const config = {
"آذربایجان شرقی.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554856,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آذرشهر",
          "name:en": "Azarshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q793612",
          "wikipedia": "en:Azarshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.4681383,
                37.6626187
              ],
              [
                45.4991906,
                37.637073
              ],
              [
                45.5086374,
                37.6259642
              ],
              [
                45.5218499,
                37.6104244
              ],
              [
                45.5223037,
                37.5924467
              ],
              [
                45.5465689,
                37.5929293
              ],
              [
                45.5744935,
                37.5903127
              ],
              [
                45.6457637,
                37.590427
              ],
              [
                45.6806133,
                37.590681
              ],
              [
                45.6980614,
                37.5908731
              ],
              [
                45.7081683,
                37.5909843
              ],
              [
                45.7101546,
                37.5908509
              ],
              [
                45.7104312,
                37.5911296
              ],
              [
                45.7140446,
                37.5911297
              ],
              [
                45.7173783,
                37.5913994
              ],
              [
                45.7184876,
                37.5911297
              ],
              [
                45.7393209,
                37.5877933
              ],
              [
                45.7407109,
                37.5877933
              ],
              [
                45.7518244,
                37.5847357
              ],
              [
                45.7696005,
                37.5822356
              ],
              [
                45.784047,
                37.5791779
              ],
              [
                45.8029372,
                37.5700137
              ],
              [
                45.8168266,
                37.5666773
              ],
              [
                45.8271035,
                37.5658499
              ],
              [
                45.8298832,
                37.5661196
              ],
              [
                45.8326599,
                37.5661197
              ],
              [
                45.8337701,
                37.5663985
              ],
              [
                45.835717,
                37.5663985
              ],
              [
                45.8368263,
                37.5666773
              ],
              [
                45.8387701,
                37.5666773
              ],
              [
                45.8398835,
                37.5669561
              ],
              [
                45.8415499,
                37.5669561
              ],
              [
                45.84266,
                37.567235
              ],
              [
                45.8451601,
                37.5672349
              ],
              [
                45.8462734,
                37.5675137
              ],
              [
                45.8501603,
                37.5675137
              ],
              [
                45.8515501,
                37.5677925
              ],
              [
                45.8534931,
                37.5675138
              ],
              [
                45.8576596,
                37.5675137
              ],
              [
                45.8596065,
                37.567235
              ],
              [
                45.8629394,
                37.567235
              ],
              [
                45.8654395,
                37.5669562
              ],
              [
                45.8690497,
                37.5669562
              ],
              [
                45.8868298,
                37.5652924
              ],
              [
                45.8893298,
                37.5652925
              ],
              [
                45.8909963,
                37.5650137
              ],
              [
                45.8921065,
                37.5650137
              ],
              [
                45.8929393,
                37.5647348
              ],
              [
                45.8959964,
                37.5647349
              ],
              [
                45.8973862,
                37.5644561
              ],
              [
                45.9048856,
                37.5644561
              ],
              [
                45.9057192,
                37.5647349
              ],
              [
                45.9071092,
                37.5647349
              ],
              [
                45.9082193,
                37.5650138
              ],
              [
                45.9093295,
                37.5650137
              ],
              [
                45.9182196,
                37.5675139
              ],
              [
                45.9190523,
                37.5680715
              ],
              [
                45.9196094,
                37.5680716
              ],
              [
                45.9201657,
                37.5683503
              ],
              [
                45.9340518,
                37.5741781
              ],
              [
                45.9354425,
                37.5747357
              ],
              [
                45.9418325,
                37.5769571
              ],
              [
                45.9851686,
                37.5858515
              ],
              [
                46.012391,
                37.5958519
              ],
              [
                46.0140583,
                37.5964005
              ],
              [
                46.0146145,
                37.5969581
              ],
              [
                46.0160012,
                37.5975157
              ],
              [
                46.0343376,
                37.613631
              ],
              [
                46.0343375,
                37.6141795
              ],
              [
                46.0529473,
                37.6105735
              ],
              [
                46.0607272,
                37.6105736
              ],
              [
                46.0660039,
                37.6116796
              ],
              [
                46.0829502,
                37.6225159
              ],
              [
                46.0943404,
                37.6286309
              ],
              [
                46.0953139,
                37.6289514
              ],
              [
                46.1010069,
                37.6311309
              ],
              [
                46.1043406,
                37.632237
              ],
              [
                46.1182299,
                37.6375156
              ],
              [
                46.1440632,
                37.6589083
              ],
              [
                46.1496195,
                37.6666865
              ],
              [
                46.1501765,
                37.6677925
              ],
              [
                46.1506663,
                37.6685278
              ],
              [
                46.165176,
                37.6830698
              ],
              [
                46.1660096,
                37.6836272
              ],
              [
                46.1654525,
                37.683906
              ],
              [
                46.1640658,
                37.6869631
              ],
              [
                46.1640659,
                37.6880692
              ],
              [
                46.1637861,
                37.6886267
              ],
              [
                46.1618423,
                37.6958559
              ],
              [
                46.1615626,
                37.6975193
              ],
              [
                46.1596195,
                37.705297
              ],
              [
                46.1590625,
                37.7058544
              ],
              [
                46.1590625,
                37.7072392
              ],
              [
                46.1587859,
                37.7075179
              ],
              [
                46.1585093,
                37.7083541
              ],
              [
                46.1579523,
                37.7094601
              ],
              [
                46.1554522,
                37.7139107
              ],
              [
                46.1551757,
                37.7141805
              ],
              [
                46.1515623,
                37.7250149
              ],
              [
                46.1432292,
                37.7350219
              ],
              [
                46.1360063,
                37.7394635
              ],
              [
                46.1193395,
                37.7461347
              ],
              [
                46.1135066,
                37.7477979
              ],
              [
                46.1021165,
                37.7491915
              ],
              [
                46.0918397,
                37.7491915
              ],
              [
                46.0907265,
                37.7489128
              ],
              [
                46.0887834,
                37.7489127
              ],
              [
                46.0843364,
                37.7480766
              ],
              [
                46.0832262,
                37.7480766
              ],
              [
                46.0740596,
                37.7480766
              ],
              [
                46.0735033,
                37.7483553
              ],
              [
                46.0726697,
                37.7483553
              ],
              [
                46.0637797,
                37.75446
              ],
              [
                46.0632266,
                37.7547387
              ],
              [
                46.0587803,
                37.7633518
              ],
              [
                46.0585038,
                37.7641878
              ],
              [
                46.0585038,
                37.7644665
              ],
              [
                46.0557271,
                37.7711285
              ],
              [
                46.0537802,
                37.7802988
              ],
              [
                46.0535036,
                37.7825194
              ],
              [
                46.0533076,
                37.7836629
              ],
              [
                46.053227,
                37.7852974
              ],
              [
                46.0496135,
                37.8105774
              ],
              [
                46.0496135,
                37.8233519
              ],
              [
                46.0493369,
                37.824188
              ],
              [
                46.0485033,
                37.8294649
              ],
              [
                46.0482235,
                37.8316853
              ],
              [
                46.0479461,
                37.8322427
              ],
              [
                46.0476696,
                37.8330787
              ],
              [
                46.0476696,
                37.8333574
              ],
              [
                46.0471133,
                37.834463
              ],
              [
                46.0465562,
                37.8364048
              ],
              [
                46.0465563,
                37.8369621
              ],
              [
                46.0462797,
                37.8372408
              ],
              [
                46.0460032,
                37.8386342
              ],
              [
                46.0457234,
                37.8397399
              ],
              [
                46.0451695,
                37.8416905
              ],
              [
                46.0440562,
                37.8447471
              ],
              [
                46.0440562,
                37.845574
              ],
              [
                46.0435031,
                37.847246
              ],
              [
                46.0432233,
                37.8480821
              ],
              [
                46.0429467,
                37.8489091
              ],
              [
                46.0412796,
                37.8533587
              ],
              [
                46.0346794,
                37.8656986
              ],
              [
                46.0210418,
                37.8770892
              ],
              [
                46.0060214,
                37.8885378
              ],
              [
                45.9961327,
                37.8934563
              ],
              [
                45.9888991,
                37.8984135
              ],
              [
                45.9857203,
                37.8953009
              ],
              [
                45.9846101,
                37.8950222
              ],
              [
                45.9832202,
                37.8950222
              ],
              [
                45.9810007,
                37.8944649
              ],
              [
                45.9798874,
                37.8944649
              ],
              [
                45.9793334,
                37.8941863
              ],
              [
                45.9724667,
                37.885548
              ],
              [
                45.9593796,
                37.8877261
              ],
              [
                45.9366961,
                37.8902123
              ],
              [
                45.9388861,
                37.8953743
              ],
              [
                45.9360211,
                37.8954928
              ],
              [
                45.9352722,
                37.8936765
              ],
              [
                45.9333085,
                37.8900382
              ],
              [
                45.9272925,
                37.8780247
              ],
              [
                45.9207173,
                37.876685
              ],
              [
                45.9198845,
                37.8761367
              ],
              [
                45.9023849,
                37.8686309
              ],
              [
                45.8834947,
                37.8594709
              ],
              [
                45.8751617,
                37.8572416
              ],
              [
                45.8721046,
                37.8572416
              ],
              [
                45.8715484,
                37.8569629
              ],
              [
                45.8665482,
                37.8566932
              ],
              [
                45.8559918,
                37.8569629
              ],
              [
                45.8554386,
                37.8572415
              ],
              [
                45.8534917,
                37.8572415
              ],
              [
                45.8526581,
                37.8575202
              ],
              [
                45.8512721,
                37.8575202
              ],
              [
                45.8504385,
                37.8577988
              ],
              [
                45.8493252,
                37.8577988
              ],
              [
                45.8484916,
                37.8580775
              ],
              [
                45.8454384,
                37.8580775
              ],
              [
                45.8354351,
                37.8600191
              ],
              [
                45.8337686,
                37.8600191
              ],
              [
                45.8318256,
                37.8605764
              ],
              [
                45.8307155,
                37.8605764
              ],
              [
                45.8301584,
                37.8608551
              ],
              [
                45.8293255,
                37.8608551
              ],
              [
                45.813769,
                37.86419
              ],
              [
                45.8121025,
                37.8641899
              ],
              [
                45.8112689,
                37.8644686
              ],
              [
                45.8065453,
                37.8644686
              ],
              [
                45.8057126,
                37.8647473
              ],
              [
                45.8032125,
                37.8647473
              ],
              [
                45.8026553,
                37.8644686
              ],
              [
                45.800989,
                37.8644686
              ],
              [
                45.7998787,
                37.8641899
              ],
              [
                45.7982124,
                37.8641899
              ],
              [
                45.7968225,
                37.8639113
              ],
              [
                45.7893223,
                37.8639112
              ],
              [
                45.7884894,
                37.8636326
              ],
              [
                45.7859894,
                37.8636326
              ],
              [
                45.7854355,
                37.8633539
              ],
              [
                45.7840456,
                37.8633539
              ],
              [
                45.7823792,
                37.8630752
              ],
              [
                45.7784892,
                37.8630752
              ],
              [
                45.7779321,
                37.8630753
              ],
              [
                45.7718227,
                37.8630752
              ],
              [
                45.7707125,
                37.8633539
              ],
              [
                45.7645991,
                37.8633538
              ],
              [
                45.7634897,
                37.8636325
              ],
              [
                45.7618224,
                37.8636326
              ],
              [
                45.7523761,
                37.8652955
              ],
              [
                45.7507096,
                37.8652954
              ],
              [
                45.7498761,
                37.8655741
              ],
              [
                45.7487659,
                37.8655741
              ],
              [
                45.7482097,
                37.8658528
              ],
              [
                45.7457096,
                37.8658527
              ],
              [
                45.7445994,
                37.8661314
              ],
              [
                45.742933,
                37.8661314
              ],
              [
                45.7382094,
                37.8669674
              ],
              [
                45.7362664,
                37.8669673
              ],
              [
                45.7282099,
                37.8683516
              ],
              [
                45.7245966,
                37.8683517
              ],
              [
                45.7187628,
                37.867246
              ],
              [
                45.7168199,
                37.867246
              ],
              [
                45.7157097,
                37.8669673
              ],
              [
                45.7123768,
                37.8669673
              ],
              [
                45.7118198,
                37.8666886
              ],
              [
                45.7095962,
                37.8666886
              ],
              [
                45.7087634,
                37.8664099
              ],
              [
                45.7073736,
                37.8664099
              ],
              [
                45.7065399,
                37.8661313
              ],
              [
                45.6951538,
                37.8661313
              ],
              [
                45.6945968,
                37.8661312
              ],
              [
                45.6890404,
                37.8661313
              ],
              [
                45.6882067,
                37.8664099
              ],
              [
                45.6870965,
                37.8664099
              ],
              [
                45.6862637,
                37.8666885
              ],
              [
                45.6851504,
                37.8666886
              ],
              [
                45.6845972,
                37.8669672
              ],
              [
                45.68293,
                37.8669672
              ],
              [
                45.6826504,
                37.8672459
              ],
              [
                45.6812636,
                37.8672459
              ],
              [
                45.6809839,
                37.8675245
              ],
              [
                45.6762635,
                37.8680729
              ],
              [
                45.6726501,
                37.8680728
              ],
              [
                45.6723736,
                37.8683515
              ],
              [
                45.6690407,
                37.8683515
              ],
              [
                45.6684837,
                37.8686302
              ],
              [
                45.6582068,
                37.8686301
              ],
              [
                45.6579272,
                37.8683515
              ],
              [
                45.5928293,
                37.8593549
              ],
              [
                45.5931059,
                37.8587976
              ],
              [
                45.5928293,
                37.8510213
              ],
              [
                45.5925489,
                37.8507425
              ],
              [
                45.5928294,
                37.8504639
              ],
              [
                45.5925489,
                37.8501853
              ],
              [
                45.5922723,
                37.8479647
              ],
              [
                45.5936622,
                37.8421301
              ],
              [
                45.5933826,
                37.8332388
              ],
              [
                45.5936623,
                37.8307395
              ],
              [
                45.5919958,
                37.8249047
              ],
              [
                45.5914396,
                37.817128
              ],
              [
                45.591996,
                37.8146287
              ],
              [
                45.5922725,
                37.81435
              ],
              [
                45.5919959,
                37.8115719
              ],
              [
                45.591996,
                37.8076789
              ],
              [
                45.5914142,
                37.8043303
              ],
              [
                45.5914142,
                37.803853
              ],
              [
                45.5914143,
                37.8032956
              ],
              [
                45.5916908,
                37.8030169
              ],
              [
                45.5916909,
                37.7980179
              ],
              [
                45.5925245,
                37.7935762
              ],
              [
                45.5928042,
                37.7932975
              ],
              [
                45.5928041,
                37.7910767
              ],
              [
                45.5933581,
                37.7888469
              ],
              [
                45.5933582,
                37.7791273
              ],
              [
                45.5936461,
                37.777851
              ],
              [
                45.595487,
                37.7695234
              ],
              [
                45.5944722,
                37.7469815
              ],
              [
                45.5854085,
                37.7092915
              ],
              [
                45.4681383,
                37.6626187
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554882,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اسکو",
          "name:en": "Osku County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291748",
          "wikipedia": "en:Osku County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.3109308,
                38.0061197
              ],
              [
                45.3126351,
                38.0037117
              ],
              [
                45.3234746,
                37.9846324
              ],
              [
                45.3354909,
                37.9727628
              ],
              [
                45.3360441,
                37.9713703
              ],
              [
                45.3357675,
                37.9710918
              ],
              [
                45.336044,
                37.9705438
              ],
              [
                45.3357675,
                37.9697083
              ],
              [
                45.3583602,
                37.9342219
              ],
              [
                45.3586406,
                37.9325593
              ],
              [
                45.3586407,
                37.9317236
              ],
              [
                45.3586407,
                37.9317235
              ],
              [
                45.3586406,
                37.9297732
              ],
              [
                45.3701016,
                37.9100756
              ],
              [
                45.3749044,
                37.8850655
              ],
              [
                45.3786811,
                37.8744895
              ],
              [
                45.3824612,
                37.8604891
              ],
              [
                45.3844338,
                37.8426114
              ],
              [
                45.3852673,
                37.8423328
              ],
              [
                45.3858944,
                37.8200907
              ],
              [
                45.3809419,
                37.8014272
              ],
              [
                45.3783413,
                37.7945931
              ],
              [
                45.3716467,
                37.7918799
              ],
              [
                45.3689036,
                37.7865582
              ],
              [
                45.3792518,
                37.7814531
              ],
              [
                45.3774764,
                37.7682854
              ],
              [
                45.3931042,
                37.7310821
              ],
              [
                45.4199217,
                37.7022675
              ],
              [
                45.4681383,
                37.6626187
              ],
              [
                45.5854085,
                37.7092915
              ],
              [
                45.5944722,
                37.7469815
              ],
              [
                45.595487,
                37.7695234
              ],
              [
                45.5936461,
                37.777851
              ],
              [
                45.5933582,
                37.7791273
              ],
              [
                45.5933581,
                37.7888469
              ],
              [
                45.5928041,
                37.7910767
              ],
              [
                45.5928042,
                37.7932975
              ],
              [
                45.5925245,
                37.7935762
              ],
              [
                45.5916909,
                37.7980179
              ],
              [
                45.5916908,
                37.8030169
              ],
              [
                45.5914143,
                37.8032956
              ],
              [
                45.5914142,
                37.803853
              ],
              [
                45.5914142,
                37.8043303
              ],
              [
                45.591996,
                37.8076789
              ],
              [
                45.5919959,
                37.8115719
              ],
              [
                45.5922725,
                37.81435
              ],
              [
                45.591996,
                37.8146287
              ],
              [
                45.5914396,
                37.817128
              ],
              [
                45.5919958,
                37.8249047
              ],
              [
                45.5936623,
                37.8307395
              ],
              [
                45.5933826,
                37.8332388
              ],
              [
                45.5936622,
                37.8421301
              ],
              [
                45.5922723,
                37.8479647
              ],
              [
                45.5925489,
                37.8501853
              ],
              [
                45.5928294,
                37.8504639
              ],
              [
                45.5925489,
                37.8507425
              ],
              [
                45.5928293,
                37.8510213
              ],
              [
                45.5931059,
                37.8587976
              ],
              [
                45.5928293,
                37.8593549
              ],
              [
                45.6579272,
                37.8683515
              ],
              [
                45.6582068,
                37.8686301
              ],
              [
                45.6684837,
                37.8686302
              ],
              [
                45.6690407,
                37.8683515
              ],
              [
                45.6723736,
                37.8683515
              ],
              [
                45.6726501,
                37.8680728
              ],
              [
                45.6762635,
                37.8680729
              ],
              [
                45.6809839,
                37.8675245
              ],
              [
                45.6812636,
                37.8672459
              ],
              [
                45.6826504,
                37.8672459
              ],
              [
                45.68293,
                37.8669672
              ],
              [
                45.6845972,
                37.8669672
              ],
              [
                45.6851504,
                37.8666886
              ],
              [
                45.6862637,
                37.8666885
              ],
              [
                45.6870965,
                37.8664099
              ],
              [
                45.6882067,
                37.8664099
              ],
              [
                45.6890404,
                37.8661313
              ],
              [
                45.6945968,
                37.8661312
              ],
              [
                45.6951538,
                37.8661313
              ],
              [
                45.7065399,
                37.8661313
              ],
              [
                45.7073736,
                37.8664099
              ],
              [
                45.7087634,
                37.8664099
              ],
              [
                45.7095962,
                37.8666886
              ],
              [
                45.7118198,
                37.8666886
              ],
              [
                45.7123768,
                37.8669673
              ],
              [
                45.7157097,
                37.8669673
              ],
              [
                45.7168199,
                37.867246
              ],
              [
                45.7187628,
                37.867246
              ],
              [
                45.7245966,
                37.8683517
              ],
              [
                45.7282099,
                37.8683516
              ],
              [
                45.7362664,
                37.8669673
              ],
              [
                45.7382094,
                37.8669674
              ],
              [
                45.742933,
                37.8661314
              ],
              [
                45.7445994,
                37.8661314
              ],
              [
                45.7457096,
                37.8658527
              ],
              [
                45.7482097,
                37.8658528
              ],
              [
                45.7487659,
                37.8655741
              ],
              [
                45.7498761,
                37.8655741
              ],
              [
                45.7507096,
                37.8652954
              ],
              [
                45.7523761,
                37.8652955
              ],
              [
                45.7618224,
                37.8636326
              ],
              [
                45.7634897,
                37.8636325
              ],
              [
                45.7645991,
                37.8633538
              ],
              [
                45.7707125,
                37.8633539
              ],
              [
                45.7718227,
                37.8630752
              ],
              [
                45.7779321,
                37.8630753
              ],
              [
                45.7784892,
                37.8630752
              ],
              [
                45.7823792,
                37.8630752
              ],
              [
                45.7840456,
                37.8633539
              ],
              [
                45.7854355,
                37.8633539
              ],
              [
                45.7859894,
                37.8636326
              ],
              [
                45.7884894,
                37.8636326
              ],
              [
                45.7893223,
                37.8639112
              ],
              [
                45.7968225,
                37.8639113
              ],
              [
                45.7982124,
                37.8641899
              ],
              [
                45.7998787,
                37.8641899
              ],
              [
                45.800989,
                37.8644686
              ],
              [
                45.8026553,
                37.8644686
              ],
              [
                45.8032125,
                37.8647473
              ],
              [
                45.8057126,
                37.8647473
              ],
              [
                45.8065453,
                37.8644686
              ],
              [
                45.8112689,
                37.8644686
              ],
              [
                45.8121025,
                37.8641899
              ],
              [
                45.813769,
                37.86419
              ],
              [
                45.8293255,
                37.8608551
              ],
              [
                45.8301584,
                37.8608551
              ],
              [
                45.8307155,
                37.8605764
              ],
              [
                45.8318256,
                37.8605764
              ],
              [
                45.8337686,
                37.8600191
              ],
              [
                45.8354351,
                37.8600191
              ],
              [
                45.8454384,
                37.8580775
              ],
              [
                45.8484916,
                37.8580775
              ],
              [
                45.8493252,
                37.8577988
              ],
              [
                45.8504385,
                37.8577988
              ],
              [
                45.8512721,
                37.8575202
              ],
              [
                45.8526581,
                37.8575202
              ],
              [
                45.8534917,
                37.8572415
              ],
              [
                45.8554386,
                37.8572415
              ],
              [
                45.8559918,
                37.8569629
              ],
              [
                45.8665482,
                37.8566932
              ],
              [
                45.8715484,
                37.8569629
              ],
              [
                45.8721046,
                37.8572416
              ],
              [
                45.8751617,
                37.8572416
              ],
              [
                45.8834947,
                37.8594709
              ],
              [
                45.9023849,
                37.8686309
              ],
              [
                45.9198845,
                37.8761367
              ],
              [
                45.9207173,
                37.876685
              ],
              [
                45.9272925,
                37.8780247
              ],
              [
                45.9333085,
                37.8900382
              ],
              [
                45.9352722,
                37.8936765
              ],
              [
                45.9360211,
                37.8954928
              ],
              [
                45.9388861,
                37.8953743
              ],
              [
                45.9366961,
                37.8902123
              ],
              [
                45.9593796,
                37.8877261
              ],
              [
                45.9724667,
                37.885548
              ],
              [
                45.9793334,
                37.8941863
              ],
              [
                45.9798874,
                37.8944649
              ],
              [
                45.9810007,
                37.8944649
              ],
              [
                45.9832202,
                37.8950222
              ],
              [
                45.9846101,
                37.8950222
              ],
              [
                45.9857203,
                37.8953009
              ],
              [
                45.9888991,
                37.8984135
              ],
              [
                45.9961327,
                37.8934563
              ],
              [
                46.0060214,
                37.8885378
              ],
              [
                46.0210418,
                37.8770892
              ],
              [
                46.0346794,
                37.8656986
              ],
              [
                46.0412796,
                37.8533587
              ],
              [
                46.0429467,
                37.8489091
              ],
              [
                46.0432233,
                37.8480821
              ],
              [
                46.0435031,
                37.847246
              ],
              [
                46.0440562,
                37.845574
              ],
              [
                46.0440562,
                37.8447471
              ],
              [
                46.0451695,
                37.8416905
              ],
              [
                46.0457234,
                37.8397399
              ],
              [
                46.0460032,
                37.8386342
              ],
              [
                46.0462797,
                37.8372408
              ],
              [
                46.0465563,
                37.8369621
              ],
              [
                46.0465562,
                37.8364048
              ],
              [
                46.0471133,
                37.834463
              ],
              [
                46.0476696,
                37.8333574
              ],
              [
                46.0476696,
                37.8330787
              ],
              [
                46.0479461,
                37.8322427
              ],
              [
                46.0482235,
                37.8316853
              ],
              [
                46.0485033,
                37.8294649
              ],
              [
                46.0493369,
                37.824188
              ],
              [
                46.0496135,
                37.8233519
              ],
              [
                46.0496135,
                37.8105774
              ],
              [
                46.053227,
                37.7852974
              ],
              [
                46.0533076,
                37.7836629
              ],
              [
                46.0535036,
                37.7825194
              ],
              [
                46.0537802,
                37.7802988
              ],
              [
                46.0557271,
                37.7711285
              ],
              [
                46.0585038,
                37.7644665
              ],
              [
                46.0585038,
                37.7641878
              ],
              [
                46.0587803,
                37.7633518
              ],
              [
                46.0632266,
                37.7547387
              ],
              [
                46.0637797,
                37.75446
              ],
              [
                46.0726697,
                37.7483553
              ],
              [
                46.0735033,
                37.7483553
              ],
              [
                46.0740596,
                37.7480766
              ],
              [
                46.0832262,
                37.7480766
              ],
              [
                46.0843364,
                37.7480766
              ],
              [
                46.0887834,
                37.7489127
              ],
              [
                46.0907265,
                37.7489128
              ],
              [
                46.0918397,
                37.7491915
              ],
              [
                46.1021165,
                37.7491915
              ],
              [
                46.1135066,
                37.7477979
              ],
              [
                46.1193395,
                37.7461347
              ],
              [
                46.1360063,
                37.7394635
              ],
              [
                46.1432292,
                37.7350219
              ],
              [
                46.1515623,
                37.7250149
              ],
              [
                46.1551757,
                37.7141805
              ],
              [
                46.1554522,
                37.7139107
              ],
              [
                46.1579523,
                37.7094601
              ],
              [
                46.1585093,
                37.7083541
              ],
              [
                46.1587859,
                37.7075179
              ],
              [
                46.1590625,
                37.7072392
              ],
              [
                46.1590625,
                37.7058544
              ],
              [
                46.1596195,
                37.705297
              ],
              [
                46.1615626,
                37.6975193
              ],
              [
                46.1618423,
                37.6958559
              ],
              [
                46.1637861,
                37.6886267
              ],
              [
                46.1640659,
                37.6880692
              ],
              [
                46.1640658,
                37.6869631
              ],
              [
                46.1654525,
                37.683906
              ],
              [
                46.1660096,
                37.6836272
              ],
              [
                46.1662862,
                37.683906
              ],
              [
                46.167119,
                37.6844635
              ],
              [
                46.167676,
                37.6847423
              ],
              [
                46.1687862,
                37.6847422
              ],
              [
                46.1690659,
                37.685021
              ],
              [
                46.1698995,
                37.685021
              ],
              [
                46.1712855,
                37.6855695
              ],
              [
                46.1773989,
                37.6864057
              ],
              [
                46.1793427,
                37.6864057
              ],
              [
                46.1798989,
                37.6866845
              ],
              [
                46.1829561,
                37.6866845
              ],
              [
                46.1854561,
                37.687242
              ],
              [
                46.1871226,
                37.687242
              ],
              [
                46.1882328,
                37.6875207
              ],
              [
                46.1968423,
                37.6875208
              ],
              [
                46.2012886,
                37.6877996
              ],
              [
                46.2054558,
                37.6880693
              ],
              [
                46.2062886,
                37.688348
              ],
              [
                46.2143451,
                37.6883481
              ],
              [
                46.2257352,
                37.6877995
              ],
              [
                46.2265687,
                37.6875209
              ],
              [
                46.2318454,
                37.6875209
              ],
              [
                46.2335119,
                37.6872421
              ],
              [
                46.2362885,
                37.6872421
              ],
              [
                46.238512,
                37.6869634
              ],
              [
                46.244345,
                37.6869635
              ],
              [
                46.2457348,
                37.6866847
              ],
              [
                46.2501787,
                37.6866847
              ],
              [
                46.251292,
                37.6869634
              ],
              [
                46.2529585,
                37.6869634
              ],
              [
                46.2543452,
                37.6872422
              ],
              [
                46.2568484,
                37.6872422
              ],
              [
                46.2982375,
                37.6947413
              ],
              [
                46.2990711,
                37.6952988
              ],
              [
                46.3097711,
                37.6982113
              ],
              [
                46.3112941,
                37.6986258
              ],
              [
                46.3118479,
                37.6986257
              ],
              [
                46.3135175,
                37.6989045
              ],
              [
                46.3174043,
                37.7000194
              ],
              [
                46.3324078,
                37.7077971
              ],
              [
                46.3331358,
                37.7079712
              ],
              [
                46.3386516,
                37.7202917
              ],
              [
                46.3401107,
                37.7259216
              ],
              [
                46.3407544,
                37.7278636
              ],
              [
                46.3427896,
                37.7306758
              ],
              [
                46.3437958,
                37.731328
              ],
              [
                46.3425868,
                37.7333726
              ],
              [
                46.3392632,
                37.7363059
              ],
              [
                46.3384008,
                37.7404151
              ],
              [
                46.338424,
                37.7444241
              ],
              [
                46.336879,
                37.7467156
              ],
              [
                46.3341093,
                37.7482203
              ],
              [
                46.3344097,
                37.7527672
              ],
              [
                46.3358259,
                37.754837
              ],
              [
                46.3424778,
                37.7585693
              ],
              [
                46.3444402,
                37.7670467
              ],
              [
                46.3460027,
                37.7726256
              ],
              [
                46.3469228,
                37.7768153
              ],
              [
                46.3484908,
                37.7790064
              ],
              [
                46.3518811,
                37.7847739
              ],
              [
                46.3511954,
                37.7880208
              ],
              [
                46.3494392,
                37.7902114
              ],
              [
                46.3487434,
                37.7948302
              ],
              [
                46.3486576,
                37.8001882
              ],
              [
                46.3473272,
                37.8009342
              ],
              [
                46.3426494,
                37.8026635
              ],
              [
                46.3353967,
                37.8048336
              ],
              [
                46.3320064,
                37.8073089
              ],
              [
                46.3320721,
                37.8150949
              ],
              [
                46.3280582,
                37.8225991
              ],
              [
                46.3248053,
                37.8259664
              ],
              [
                46.317759,
                37.8299869
              ],
              [
                46.3069221,
                37.8326971
              ],
              [
                46.3013487,
                37.8359735
              ],
              [
                46.296858,
                37.8384045
              ],
              [
                46.2804687,
                37.8541263
              ],
              [
                46.271501,
                37.8657367
              ],
              [
                46.2666831,
                37.8721468
              ],
              [
                46.257804,
                37.8854709
              ],
              [
                46.2502533,
                37.8980326
              ],
              [
                46.2348324,
                37.9124274
              ],
              [
                46.2170529,
                37.9297639
              ],
              [
                46.2096049,
                37.9366421
              ],
              [
                46.1987736,
                37.9470455
              ],
              [
                46.1887586,
                37.9582459
              ],
              [
                46.1785348,
                37.9711104
              ],
              [
                46.1694037,
                37.9765422
              ],
              [
                46.1626624,
                37.9770861
              ],
              [
                46.1590575,
                37.9787775
              ],
              [
                46.1438655,
                37.9768831
              ],
              [
                46.1356778,
                37.974174
              ],
              [
                46.1270911,
                37.9736268
              ],
              [
                46.1204767,
                37.9738046
              ],
              [
                46.1119365,
                37.9754284
              ],
              [
                46.1070325,
                37.9757133
              ],
              [
                46.0996917,
                37.9749678
              ],
              [
                46.0895045,
                37.9711392
              ],
              [
                46.0801989,
                37.9657097
              ],
              [
                46.0767574,
                37.9602454
              ],
              [
                46.0787787,
                37.9559621
              ],
              [
                46.0824486,
                37.9492365
              ],
              [
                46.0768313,
                37.9456974
              ],
              [
                46.0732868,
                37.9428471
              ],
              [
                46.0659448,
                37.9365922
              ],
              [
                46.0589904,
                37.9292701
              ],
              [
                46.0516007,
                37.9231637
              ],
              [
                46.0409706,
                37.9165503
              ],
              [
                46.033032,
                37.9116593
              ],
              [
                46.0266695,
                37.9187782
              ],
              [
                46.0237943,
                37.9240073
              ],
              [
                46.0210673,
                37.9297616
              ],
              [
                46.0136604,
                37.939087
              ],
              [
                46.0104003,
                37.9451728
              ],
              [
                46.012845,
                37.9458897
              ],
              [
                46.0125446,
                37.9473788
              ],
              [
                46.0031461,
                37.9542484
              ],
              [
                46.001927,
                37.9554423
              ],
              [
                46.0001385,
                37.9551906
              ],
              [
                45.9921511,
                37.9621924
              ],
              [
                45.9821097,
                37.96308
              ],
              [
                45.9651633,
                37.9700273
              ],
              [
                45.939054,
                37.9780799
              ],
              [
                45.9279404,
                37.9830858
              ],
              [
                45.9026609,
                37.9908596
              ],
              [
                45.9023844,
                37.9911382
              ],
              [
                45.8967729,
                37.999844
              ],
              [
                45.8698811,
                38.0250276
              ],
              [
                45.8579378,
                38.0419671
              ],
              [
                45.8573808,
                38.04336
              ],
              [
                45.8554377,
                38.0455796
              ],
              [
                45.8551573,
                38.0461366
              ],
              [
                45.8545916,
                38.0472761
              ],
              [
                45.8532143,
                38.0464153
              ],
              [
                45.8237676,
                38.0280829
              ],
              [
                45.8209909,
                38.0269686
              ],
              [
                45.8193245,
                38.0258632
              ],
              [
                45.8184917,
                38.0258632
              ],
              [
                45.7779316,
                38.0093315
              ],
              [
                45.7773784,
                38.0091927
              ],
              [
                45.7770986,
                38.0089141
              ],
              [
                45.7618218,
                38.0036388
              ],
              [
                45.7576553,
                38.0025244
              ],
              [
                45.7562654,
                38.0019672
              ],
              [
                45.7551552,
                38.0019671
              ],
              [
                45.7498754,
                38.0008618
              ],
              [
                45.7440425,
                38.0008617
              ],
              [
                45.7437659,
                38.0005832
              ],
              [
                45.7387658,
                38.0005831
              ],
              [
                45.7379322,
                38.0008618
              ],
              [
                45.7282093,
                38.0014099
              ],
              [
                45.7232093,
                38.00141
              ],
              [
                45.7220959,
                38.0011313
              ],
              [
                45.7159856,
                38.0011313
              ],
              [
                45.7148762,
                38.0014099
              ],
              [
                45.7129293,
                38.0014099
              ],
              [
                45.7115426,
                38.0016885
              ],
              [
                45.7098761,
                38.0016884
              ],
              [
                45.7084862,
                38.001967
              ],
              [
                45.706819,
                38.0019671
              ],
              [
                45.699039,
                38.0030815
              ],
              [
                45.6962625,
                38.0030814
              ],
              [
                45.6957062,
                38.0033599
              ],
              [
                45.6890396,
                38.00336
              ],
              [
                45.6873725,
                38.0036385
              ],
              [
                45.6820965,
                38.0036386
              ],
              [
                45.6815395,
                38.0039172
              ],
              [
                45.6762628,
                38.0039171
              ],
              [
                45.6745963,
                38.0036385
              ],
              [
                45.670983,
                38.0036385
              ],
              [
                45.670426,
                38.0033599
              ],
              [
                45.6684829,
                38.00336
              ],
              [
                45.6673728,
                38.0033599
              ],
              [
                45.6662594,
                38.0033599
              ],
              [
                45.6657063,
                38.0030814
              ],
              [
                45.6632064,
                38.0030814
              ],
              [
                45.6618164,
                38.0030813
              ],
              [
                45.6607062,
                38.0028027
              ],
              [
                45.6559834,
                38.0028027
              ],
              [
                45.6526498,
                38.0022455
              ],
              [
                45.650703,
                38.0022454
              ],
              [
                45.6493169,
                38.0019669
              ],
              [
                45.6476497,
                38.0019669
              ],
              [
                45.6465363,
                38.0016882
              ],
              [
                45.6359838,
                38.0016882
              ],
              [
                45.6348697,
                38.0014096
              ],
              [
                45.6282031,
                38.0014097
              ],
              [
                45.6276469,
                38.0016882
              ],
              [
                45.6262602,
                38.0016882
              ],
              [
                45.6257031,
                38.0019668
              ],
              [
                45.6179272,
                38.0019668
              ],
              [
                45.6168138,
                38.0022454
              ],
              [
                45.5923672,
                38.0022453
              ],
              [
                45.5918141,
                38.0025239
              ],
              [
                45.5873671,
                38.0025239
              ],
              [
                45.5862568,
                38.0028024
              ],
              [
                45.5832006,
                38.0028024
              ],
              [
                45.5826475,
                38.0030811
              ],
              [
                45.5795904,
                38.0030811
              ],
              [
                45.5784809,
                38.003081
              ],
              [
                45.5773676,
                38.003081
              ],
              [
                45.5770903,
                38.0033596
              ],
              [
                45.5729238,
                38.0033597
              ],
              [
                45.5726441,
                38.0036382
              ],
              [
                45.5665338,
                38.0036382
              ],
              [
                45.5654244,
                38.0039168
              ],
              [
                45.5612579,
                38.0039167
              ],
              [
                45.5601438,
                38.0041954
              ],
              [
                45.5476443,
                38.0044649
              ],
              [
                45.5340307,
                38.0044649
              ],
              [
                45.5271088,
                38.004788
              ],
              [
                45.3879284,
                38.0046256
              ],
              [
                45.3109308,
                38.0061197
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554897,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اهر",
          "name:en": "Ahar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291784",
          "wikipedia": "en:Ahar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.7588135,
                38.3935772
              ],
              [
                46.7596463,
                38.393369
              ],
              [
                46.7602003,
                38.3930905
              ],
              [
                46.7610332,
                38.3930905
              ],
              [
                46.7735365,
                38.3900372
              ],
              [
                46.7790898,
                38.3825383
              ],
              [
                46.7827032,
                38.3750392
              ],
              [
                46.7927027,
                38.3650344
              ],
              [
                46.7932597,
                38.3644866
              ],
              [
                46.7938128,
                38.3644865
              ],
              [
                46.8010364,
                38.3608761
              ],
              [
                46.8021466,
                38.3608761
              ],
              [
                46.8024264,
                38.3605887
              ],
              [
                46.8029795,
                38.3605887
              ],
              [
                46.805203,
                38.3611456
              ],
              [
                46.8063163,
                38.3617024
              ],
              [
                46.8113164,
                38.3633729
              ],
              [
                46.8207595,
                38.3683754
              ],
              [
                46.8315926,
                38.3617024
              ],
              [
                46.834649,
                38.3614241
              ],
              [
                46.8446491,
                38.3644867
              ],
              [
                46.8488156,
                38.3664266
              ],
              [
                46.8507626,
                38.3669834
              ],
              [
                46.8577056,
                38.3694801
              ],
              [
                46.8593722,
                38.3697586
              ],
              [
                46.867152,
                38.371429
              ],
              [
                46.8693723,
                38.3714291
              ],
              [
                46.8707623,
                38.3717074
              ],
              [
                46.8727052,
                38.3717075
              ],
              [
                46.878539,
                38.3719859
              ],
              [
                46.8813187,
                38.3722553
              ],
              [
                46.9307652,
                38.3658699
              ],
              [
                46.9465984,
                38.3622596
              ],
              [
                46.9479882,
                38.3622596
              ],
              [
                46.9485445,
                38.3619812
              ],
              [
                46.9513211,
                38.3614243
              ],
              [
                46.9529884,
                38.3605891
              ],
              [
                46.9568783,
                38.359206
              ],
              [
                46.9654879,
                38.3544819
              ],
              [
                46.9666012,
                38.3542035
              ],
              [
                46.9668777,
                38.3539251
              ],
              [
                46.9774342,
                38.3514283
              ],
              [
                46.9788249,
                38.3514283
              ],
              [
                46.979378,
                38.3511498
              ],
              [
                46.9854915,
                38.3503146
              ],
              [
                46.9877111,
                38.3503146
              ],
              [
                46.9941011,
                38.3494794
              ],
              [
                46.9974347,
                38.3494794
              ],
              [
                46.9982675,
                38.3492009
              ],
              [
                47.0024341,
                38.349201
              ],
              [
                47.0041014,
                38.3489225
              ],
              [
                47.0390439,
                38.344635
              ],
              [
                47.0396608,
                38.3444858
              ],
              [
                47.0413271,
                38.3444858
              ],
              [
                47.0463273,
                38.3436506
              ],
              [
                47.049104,
                38.3436506
              ],
              [
                47.0496602,
                38.3433721
              ],
              [
                47.0521602,
                38.3433721
              ],
              [
                47.0529938,
                38.3430938
              ],
              [
                47.0543837,
                38.3430937
              ],
              [
                47.0554938,
                38.3428153
              ],
              [
                47.0579939,
                38.3428153
              ],
              [
                47.0585502,
                38.3425369
              ],
              [
                47.0596604,
                38.3425369
              ],
              [
                47.0607706,
                38.3422584
              ],
              [
                47.0638269,
                38.3422585
              ],
              [
                47.066327,
                38.3417016
              ],
              [
                47.0685504,
                38.3417016
              ],
              [
                47.0696606,
                38.3414232
              ],
              [
                47.0710505,
                38.3414232
              ],
              [
                47.0721607,
                38.3411448
              ],
              [
                47.0774405,
                38.3405969
              ],
              [
                47.0804937,
                38.3397616
              ],
              [
                47.0827171,
                38.3397616
              ],
              [
                47.08355,
                38.3394832
              ],
              [
                47.0852165,
                38.3394833
              ],
              [
                47.0863266,
                38.3392048
              ],
              [
                47.0891071,
                38.3392048
              ],
              [
                47.0904971,
                38.3394832
              ],
              [
                47.0910501,
                38.3392048
              ],
              [
                47.0921634,
                38.3394833
              ],
              [
                47.0941065,
                38.3394832
              ],
              [
                47.0949401,
                38.3397617
              ],
              [
                47.0966066,
                38.3397617
              ],
              [
                47.0977167,
                38.3400401
              ],
              [
                47.0991067,
                38.3400402
              ],
              [
                47.0999402,
                38.3403186
              ],
              [
                47.1027168,
                38.3403185
              ],
              [
                47.1035497,
                38.340597
              ],
              [
                47.104663,
                38.340597
              ],
              [
                47.1049403,
                38.3408754
              ],
              [
                47.1174398,
                38.3419802
              ],
              [
                47.1246635,
                38.3419802
              ],
              [
                47.1257768,
                38.3422586
              ],
              [
                47.1299432,
                38.3422587
              ],
              [
                47.1310535,
                38.342537
              ],
              [
                47.1363293,
                38.3425371
              ],
              [
                47.1368864,
                38.3428156
              ],
              [
                47.1391098,
                38.3428155
              ],
              [
                47.1396629,
                38.3430939
              ],
              [
                47.1488328,
                38.343094
              ],
              [
                47.1491093,
                38.3428156
              ],
              [
                47.1513329,
                38.3428155
              ],
              [
                47.1524429,
                38.3425371
              ],
              [
                47.1543859,
                38.3425371
              ],
              [
                47.1599424,
                38.3417018
              ],
              [
                47.1635557,
                38.3408756
              ],
              [
                47.1660558,
                38.3400403
              ],
              [
                47.1668895,
                38.3400403
              ],
              [
                47.1758251,
                38.3368741
              ],
              [
                47.1763327,
                38.3366992
              ],
              [
                47.1974456,
                38.3311486
              ],
              [
                47.2518922,
                38.3164275
              ],
              [
                47.2552251,
                38.3147569
              ],
              [
                47.2771717,
                38.3061523
              ],
              [
                47.2782819,
                38.3061522
              ],
              [
                47.2788381,
                38.3058648
              ],
              [
                47.2843953,
                38.3050384
              ],
              [
                47.2860618,
                38.3044815
              ],
              [
                47.2871719,
                38.3044815
              ],
              [
                47.2871719,
                38.3053169
              ],
              [
                47.287172,
                38.3061522
              ],
              [
                47.2874485,
                38.3069785
              ],
              [
                47.2888384,
                38.3142001
              ],
              [
                47.2888383,
                38.3155923
              ],
              [
                47.2893945,
                38.3167061
              ],
              [
                47.2907813,
                38.3319841
              ],
              [
                47.2952282,
                38.3358732
              ],
              [
                47.2974517,
                38.3366995
              ],
              [
                47.3191178,
                38.3433728
              ],
              [
                47.3316173,
                38.3492018
              ],
              [
                47.334951,
                38.3505939
              ],
              [
                47.3402307,
                38.3533691
              ],
              [
                47.345784,
                38.3569797
              ],
              [
                47.38023,
                38.3961456
              ],
              [
                47.384677,
                38.3992079
              ],
              [
                47.3988435,
                38.4053147
              ],
              [
                47.4113431,
                38.412544
              ],
              [
                47.415233,
                38.4155972
              ],
              [
                47.4410663,
                38.4500356
              ],
              [
                47.4598739,
                38.473628
              ],
              [
                47.4684962,
                38.4805015
              ],
              [
                47.4717767,
                38.4840104
              ],
              [
                47.4737748,
                38.4860692
              ],
              [
                47.476693,
                38.4891845
              ],
              [
                47.4810218,
                38.4942088
              ],
              [
                47.4830389,
                38.4983401
              ],
              [
                47.4864292,
                38.502236
              ],
              [
                47.4972438,
                38.511337
              ],
              [
                47.5004194,
                38.5171463
              ],
              [
                47.502737,
                38.5271517
              ],
              [
                47.506652,
                38.5353744
              ],
              [
                47.5139808,
                38.5422581
              ],
              [
                47.5220489,
                38.546353
              ],
              [
                47.5361251,
                38.5480312
              ],
              [
                47.5456134,
                38.5507
              ],
              [
                47.5551435,
                38.5581357
              ],
              [
                47.5585343,
                38.5675032
              ],
              [
                47.5595749,
                38.5738529
              ],
              [
                47.5688509,
                38.6117084
              ],
              [
                47.5699607,
                38.6161609
              ],
              [
                47.567184,
                38.6286565
              ],
              [
                47.5671841,
                38.6347696
              ],
              [
                47.5666274,
                38.637274
              ],
              [
                47.565241,
                38.6406042
              ],
              [
                47.566456,
                38.6442899
              ],
              [
                47.5257943,
                38.6697677
              ],
              [
                47.5127377,
                38.6764368
              ],
              [
                47.5107912,
                38.6769933
              ],
              [
                47.5007913,
                38.682271
              ],
              [
                47.4991245,
                38.6825492
              ],
              [
                47.4969014,
                38.683384
              ],
              [
                47.4880148,
                38.6858792
              ],
              [
                47.4796779,
                38.6886616
              ],
              [
                47.4757915,
                38.6894963
              ],
              [
                47.4724582,
                38.6894963
              ],
              [
                47.4674581,
                38.6875486
              ],
              [
                47.4630115,
                38.6875486
              ],
              [
                47.4619018,
                38.6878269
              ],
              [
                47.4607885,
                38.6878269
              ],
              [
                47.4594017,
                38.6883833
              ],
              [
                47.4582883,
                38.6883833
              ],
              [
                47.4577348,
                38.6886615
              ],
              [
                47.4560685,
                38.6886615
              ],
              [
                47.4513452,
                38.6922697
              ],
              [
                47.4491218,
                38.6958779
              ],
              [
                47.4485686,
                38.6964343
              ],
              [
                47.4457884,
                38.6972691
              ],
              [
                47.4446782,
                38.6972691
              ],
              [
                47.4441215,
                38.6975473
              ],
              [
                47.4430118,
                38.6975473
              ],
              [
                47.4424552,
                38.6978255
              ],
              [
                47.4416219,
                38.6978256
              ],
              [
                47.4405117,
                38.698382
              ],
              [
                47.4396785,
                38.6983819
              ],
              [
                47.4366218,
                38.7000514
              ],
              [
                47.4360651,
                38.7000515
              ],
              [
                47.4357886,
                38.7003296
              ],
              [
                47.4357886,
                38.7008771
              ],
              [
                47.4324554,
                38.7000513
              ],
              [
                47.431065,
                38.7000514
              ],
              [
                47.4199554,
                38.6944955
              ],
              [
                47.4191219,
                38.6944956
              ],
              [
                47.4107888,
                38.6928261
              ],
              [
                47.4071754,
                38.6928261
              ],
              [
                47.4057856,
                38.6925478
              ],
              [
                47.4035652,
                38.6925479
              ],
              [
                47.3999518,
                38.6917131
              ],
              [
                47.3985659,
                38.6917131
              ],
              [
                47.3980088,
                38.6914349
              ],
              [
                47.3880094,
                38.6892089
              ],
              [
                47.3782858,
                38.6828272
              ],
              [
                47.3735623,
                38.6767147
              ],
              [
                47.3710622,
                38.6719934
              ],
              [
                47.3702294,
                38.6714369
              ],
              [
                47.3674528,
                38.6689326
              ],
              [
                47.3666192,
                38.6683761
              ],
              [
                47.3630058,
                38.665046
              ],
              [
                47.3460633,
                38.6569945
              ],
              [
                47.3452297,
                38.6569944
              ],
              [
                47.341896,
                38.6561596
              ],
              [
                47.3393967,
                38.6561596
              ],
              [
                47.3285598,
                38.653377
              ],
              [
                47.3046701,
                38.6422643
              ],
              [
                47.30356,
                38.6422643
              ],
              [
                47.3027264,
                38.641986
              ],
              [
                47.29717,
                38.6414385
              ],
              [
                47.286337,
                38.6383774
              ],
              [
                47.279947,
                38.6367078
              ],
              [
                47.256334,
                38.628934
              ],
              [
                47.2171676,
                38.6139337
              ],
              [
                47.2166112,
                38.6133772
              ],
              [
                47.1852215,
                38.5980982
              ],
              [
                47.1816081,
                38.5964285
              ],
              [
                47.178555,
                38.595046
              ],
              [
                47.1749417,
                38.5942111
              ],
              [
                47.1743885,
                38.5939328
              ],
              [
                47.1718884,
                38.5939328
              ],
              [
                47.1624414,
                38.6000462
              ],
              [
                47.1621648,
                38.6003245
              ],
              [
                47.1610514,
                38.6011594
              ],
              [
                47.1599413,
                38.601716
              ],
              [
                47.154942,
                38.6067072
              ],
              [
                47.1535521,
                38.6097683
              ],
              [
                47.1529981,
                38.6100466
              ],
              [
                47.1524418,
                38.6111598
              ],
              [
                47.1521653,
                38.6143322
              ],
              [
                47.1518848,
                38.6144902
              ],
              [
                47.151052,
                38.6144902
              ],
              [
                47.1457753,
                38.6161599
              ],
              [
                47.1443854,
                38.6164292
              ],
              [
                47.1391087,
                38.6180989
              ],
              [
                47.1379953,
                38.6180988
              ],
              [
                47.1374415,
                38.6183772
              ],
              [
                47.135775,
                38.6183771
              ],
              [
                47.1354954,
                38.6186554
              ],
              [
                47.1335515,
                38.6186554
              ],
              [
                47.133275,
                38.6183771
              ],
              [
                47.1307749,
                38.6183771
              ],
              [
                47.1302187,
                38.6180988
              ],
              [
                47.1291085,
                38.6180988
              ],
              [
                47.1271616,
                38.6175423
              ],
              [
                47.1260522,
                38.6175422
              ],
              [
                47.1182724,
                38.6158815
              ],
              [
                47.1166051,
                38.6158815
              ],
              [
                47.1163285,
                38.6156033
              ],
              [
                47.1149387,
                38.6156032
              ],
              [
                47.1143855,
                38.6153249
              ],
              [
                47.1104955,
                38.6153249
              ],
              [
                47.110219,
                38.6150466
              ],
              [
                47.1096619,
                38.6153249
              ],
              [
                47.1049392,
                38.6167074
              ],
              [
                47.1046618,
                38.6169946
              ],
              [
                47.1068853,
                38.6228205
              ],
              [
                47.1071619,
                38.624212
              ],
              [
                47.1074384,
                38.6297686
              ],
              [
                47.1068852,
                38.6319947
              ],
              [
                47.1027156,
                38.638377
              ],
              [
                47.0666023,
                38.657272
              ],
              [
                47.0591028,
                38.6583761
              ],
              [
                47.0532691,
                38.6597673
              ],
              [
                47.0513261,
                38.6597674
              ],
              [
                47.0502158,
                38.6600456
              ],
              [
                47.048826,
                38.6600455
              ],
              [
                47.0471596,
                38.6606022
              ],
              [
                47.0460462,
                38.6606021
              ],
              [
                47.0413258,
                38.6619934
              ],
              [
                47.0346593,
                38.6630974
              ],
              [
                47.0338264,
                38.6633756
              ],
              [
                47.0257692,
                38.664767
              ],
              [
                47.0135463,
                38.6697665
              ],
              [
                47.0029898,
                38.6756008
              ],
              [
                47.0021561,
                38.6756008
              ],
              [
                46.9929895,
                38.678105
              ],
              [
                46.9915997,
                38.678105
              ],
              [
                46.9904894,
                38.6783832
              ],
              [
                46.9868761,
                38.6783833
              ],
              [
                46.9857667,
                38.6786615
              ],
              [
                46.9779899,
                38.6794872
              ],
              [
                46.9763235,
                38.6800437
              ],
              [
                46.9746563,
                38.6800438
              ],
              [
                46.9738195,
                38.680322
              ],
              [
                46.9721531,
                38.6803219
              ],
              [
                46.946597,
                38.6839301
              ],
              [
                46.9379867,
                38.6864343
              ],
              [
                46.9352069,
                38.687269
              ],
              [
                46.932145,
                38.6887555
              ],
              [
                46.9315967,
                38.6889385
              ],
              [
                46.9196534,
                38.6933814
              ],
              [
                46.9185401,
                38.6933814
              ],
              [
                46.9182635,
                38.6936596
              ],
              [
                46.902707,
                38.6936595
              ],
              [
                46.9021507,
                38.6936596
              ],
              [
                46.9010405,
                38.6936595
              ],
              [
                46.900764,
                38.6939377
              ],
              [
                46.8996506,
                38.6939378
              ],
              [
                46.8918739,
                38.696433
              ],
              [
                46.890484,
                38.6989371
              ],
              [
                46.8818743,
                38.7089355
              ],
              [
                46.8790938,
                38.7125436
              ],
              [
                46.8782609,
                38.7139347
              ],
              [
                46.8638176,
                38.7261586
              ],
              [
                46.8554806,
                38.735322
              ],
              [
                46.8543705,
                38.7358784
              ],
              [
                46.8360379,
                38.7503275
              ],
              [
                46.8352044,
                38.7503275
              ],
              [
                46.8346472,
                38.7506057
              ],
              [
                46.8329808,
                38.7506057
              ],
              [
                46.8307573,
                38.7506057
              ],
              [
                46.8299245,
                38.7506057
              ],
              [
                46.8190914,
                38.7431029
              ],
              [
                46.8160344,
                38.7403208
              ],
              [
                46.8154812,
                38.7392169
              ],
              [
                46.8046482,
                38.72921
              ],
              [
                46.8035349,
                38.72921
              ],
              [
                46.7988114,
                38.7300446
              ],
              [
                46.797145,
                38.7272714
              ],
              [
                46.7913113,
                38.7236635
              ],
              [
                46.7779782,
                38.7056054
              ],
              [
                46.7777017,
                38.7039361
              ],
              [
                46.7779782,
                38.7025449
              ],
              [
                46.7782549,
                38.7014319
              ],
              [
                46.7807548,
                38.6969891
              ],
              [
                46.8040914,
                38.6872687
              ],
              [
                46.8082579,
                38.6864339
              ],
              [
                46.8090916,
                38.6861557
              ],
              [
                46.810758,
                38.6861557
              ],
              [
                46.8110346,
                38.6858775
              ],
              [
                46.8118682,
                38.6858775
              ],
              [
                46.8254818,
                38.6811563
              ],
              [
                46.8260381,
                38.6805998
              ],
              [
                46.8304811,
                38.6783828
              ],
              [
                46.8432611,
                38.6703225
              ],
              [
                46.8535379,
                38.6608799
              ],
              [
                46.8538146,
                38.6600451
              ],
              [
                46.8546481,
                38.6592103
              ],
              [
                46.8582615,
                38.6519845
              ],
              [
                46.859928,
                38.6442111
              ],
              [
                46.8604812,
                38.6419849
              ],
              [
                46.8604812,
                38.641159
              ],
              [
                46.8607609,
                38.6383764
              ],
              [
                46.8621516,
                38.6303244
              ],
              [
                46.8624281,
                38.6297679
              ],
              [
                46.8621516,
                38.6272634
              ],
              [
                46.8624281,
                38.6264285
              ],
              [
                46.8621515,
                38.6258809
              ],
              [
                46.8624281,
                38.6256027
              ],
              [
                46.8621516,
                38.6250462
              ],
              [
                46.861318,
                38.618933
              ],
              [
                46.8504811,
                38.5933754
              ],
              [
                46.849928,
                38.5930971
              ],
              [
                46.849928,
                38.5925405
              ],
              [
                46.8482615,
                38.5900448
              ],
              [
                46.8468717,
                38.5875401
              ],
              [
                46.8429817,
                38.5828181
              ],
              [
                46.8421482,
                38.5825487
              ],
              [
                46.8313151,
                38.5767043
              ],
              [
                46.8227017,
                38.5742085
              ],
              [
                46.8213149,
                38.5742085
              ],
              [
                46.8196485,
                38.5733736
              ],
              [
                46.7971457,
                38.5655989
              ],
              [
                46.7865924,
                38.558659
              ],
              [
                46.7838126,
                38.5564325
              ],
              [
                46.7735359,
                38.5425436
              ],
              [
                46.7724226,
                38.5367077
              ],
              [
                46.7724226,
                38.5267059
              ],
              [
                46.7624225,
                38.5133728
              ],
              [
                46.7621459,
                38.5130944
              ],
              [
                46.755756,
                38.5050406
              ],
              [
                46.7546466,
                38.5036488
              ],
              [
                46.7540895,
                38.5025445
              ],
              [
                46.7535325,
                38.5022661
              ],
              [
                46.7535324,
                38.5017093
              ],
              [
                46.7513129,
                38.4978216
              ],
              [
                46.7513129,
                38.4967081
              ],
              [
                46.7507566,
                38.4961515
              ],
              [
                46.7443669,
                38.4497644
              ],
              [
                46.7443669,
                38.4469807
              ],
              [
                46.7465897,
                38.4422663
              ],
              [
                46.7488131,
                38.4397609
              ],
              [
                46.7543663,
                38.4372645
              ],
              [
                46.7551999,
                38.4372645
              ],
              [
                46.7560328,
                38.4367078
              ],
              [
                46.7571461,
                38.4367078
              ],
              [
                46.7574234,
                38.4364294
              ],
              [
                46.7582563,
                38.4364294
              ],
              [
                46.7604798,
                38.4358726
              ],
              [
                46.7613134,
                38.4350375
              ],
              [
                46.7643667,
                38.4325411
              ],
              [
                46.7649229,
                38.4297573
              ],
              [
                46.7654799,
                38.4278176
              ],
              [
                46.7657564,
                38.4275392
              ],
              [
                46.7654799,
                38.4217021
              ],
              [
                46.7651995,
                38.4211453
              ],
              [
                46.7651995,
                38.4203192
              ],
              [
                46.7646463,
                38.4192056
              ],
              [
                46.7632565,
                38.4122639
              ],
              [
                46.762423,
                38.4100367
              ],
              [
                46.7596463,
                38.4025381
              ],
              [
                46.7588135,
                38.3989279
              ],
              [
                46.7588135,
                38.3935772
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554929,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بستان آباد",
          "name:en": "Bostanabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291663",
          "wikipedia": "en:Bostanabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.4892336,
                37.6435059
              ],
              [
                46.4962374,
                37.6460884
              ],
              [
                46.5003096,
                37.6464215
              ],
              [
                46.50724,
                37.6416641
              ],
              [
                46.5100032,
                37.6392241
              ],
              [
                46.5171017,
                37.6324271
              ],
              [
                46.5264993,
                37.6231754
              ],
              [
                46.5314302,
                37.619461
              ],
              [
                46.5396778,
                37.6147699
              ],
              [
                46.5472062,
                37.6124582
              ],
              [
                46.5550549,
                37.6103436
              ],
              [
                46.562878,
                37.6080252
              ],
              [
                46.5655331,
                37.6070051
              ],
              [
                46.5695226,
                37.6052441
              ],
              [
                46.5742376,
                37.6032041
              ],
              [
                46.5783757,
                37.6011369
              ],
              [
                46.5852159,
                37.5974988
              ],
              [
                46.5936403,
                37.5920241
              ],
              [
                46.6007798,
                37.5885535
              ],
              [
                46.6098112,
                37.5847468
              ],
              [
                46.6123112,
                37.5847468
              ],
              [
                46.6198329,
                37.5834181
              ],
              [
                46.6248331,
                37.5809173
              ],
              [
                46.6273332,
                37.579523
              ],
              [
                46.6303895,
                37.5775799
              ],
              [
                46.6309426,
                37.5767432
              ],
              [
                46.6460896,
                37.5758127
              ],
              [
                46.6588109,
                37.566122
              ],
              [
                46.6674213,
                37.5547362
              ],
              [
                46.6782576,
                37.5469567
              ],
              [
                46.6810342,
                37.5461293
              ],
              [
                46.6813108,
                37.5458505
              ],
              [
                46.6821444,
                37.5458505
              ],
              [
                46.6810078,
                37.5527169
              ],
              [
                46.6863401,
                37.5483324
              ],
              [
                46.6911688,
                37.5471348
              ],
              [
                46.6907578,
                37.5422351
              ],
              [
                46.6910344,
                37.5419563
              ],
              [
                46.6915907,
                37.5419563
              ],
              [
                46.7007573,
                37.5391862
              ],
              [
                46.7096474,
                37.5391862
              ],
              [
                46.7099239,
                37.539465
              ],
              [
                46.7279805,
                37.5414078
              ],
              [
                46.7290907,
                37.5419564
              ],
              [
                46.7299274,
                37.5419563
              ],
              [
                46.730204,
                37.5422351
              ],
              [
                46.7379808,
                37.5458507
              ],
              [
                46.7382604,
                37.5463993
              ],
              [
                46.739094,
                37.5466781
              ],
              [
                46.7393706,
                37.5469569
              ],
              [
                46.7396471,
                37.5475145
              ],
              [
                46.7407605,
                37.5483509
              ],
              [
                46.74298,
                37.5502936
              ],
              [
                46.7546505,
                37.5777957
              ],
              [
                46.7640936,
                37.5877962
              ],
              [
                46.765203,
                37.5883448
              ],
              [
                46.7660366,
                37.5891812
              ],
              [
                46.7682602,
                37.5916813
              ],
              [
                46.7815932,
                37.6019603
              ],
              [
                46.7840932,
                37.6030754
              ],
              [
                46.7860394,
                37.6030755
              ],
              [
                46.7865965,
                37.6033543
              ],
              [
                46.8052062,
                37.6033543
              ],
              [
                46.8063196,
                37.6030755
              ],
              [
                46.8079859,
                37.6030756
              ],
              [
                46.8090961,
                37.6027968
              ],
              [
                46.8107626,
                37.6027967
              ],
              [
                46.8118727,
                37.602518
              ],
              [
                46.8135392,
                37.602518
              ],
              [
                46.8143728,
                37.6022392
              ],
              [
                46.8165963,
                37.6022392
              ],
              [
                46.8171526,
                37.6019605
              ],
              [
                46.8199292,
                37.6019604
              ],
              [
                46.8207628,
                37.6016816
              ],
              [
                46.821873,
                37.6016816
              ],
              [
                46.8388195,
                37.5983543
              ],
              [
                46.842986,
                37.5972392
              ],
              [
                46.8435422,
                37.5972392
              ],
              [
                46.8549324,
                37.593633
              ],
              [
                46.8554855,
                37.5930755
              ],
              [
                46.8560426,
                37.5930754
              ],
              [
                46.8560425,
                37.5927967
              ],
              [
                46.859652,
                37.5914028
              ],
              [
                46.8602091,
                37.5914027
              ],
              [
                46.8607654,
                37.5911329
              ],
              [
                46.8610427,
                37.5908542
              ],
              [
                46.8857651,
                37.5814113
              ],
              [
                46.8863222,
                37.5808449
              ],
              [
                46.900489,
                37.5769597
              ],
              [
                46.9018788,
                37.5769597
              ],
              [
                46.9027117,
                37.576681
              ],
              [
                46.9038218,
                37.576681
              ],
              [
                46.9046554,
                37.5764021
              ],
              [
                46.9118782,
                37.5761323
              ],
              [
                46.9121548,
                37.5764022
              ],
              [
                46.916322,
                37.5764023
              ],
              [
                46.9177119,
                37.576681
              ],
              [
                46.9207682,
                37.5772386
              ],
              [
                46.9213254,
                37.5772386
              ],
              [
                46.9296583,
                37.5797388
              ],
              [
                46.9371585,
                37.5836329
              ],
              [
                46.9446578,
                37.5911332
              ],
              [
                46.9463249,
                37.5955758
              ],
              [
                46.9466016,
                37.5975182
              ],
              [
                46.946325,
                37.5980758
              ],
              [
                46.9466016,
                37.6005759
              ],
              [
                46.9464633,
                37.6011244
              ],
              [
                46.946325,
                37.6025183
              ],
              [
                46.9435483,
                37.6111335
              ],
              [
                46.9435483,
                37.6116821
              ],
              [
                46.9427147,
                37.6141821
              ],
              [
                46.942435,
                37.6144609
              ],
              [
                46.9443811,
                37.6250182
              ],
              [
                46.9538242,
                37.6336332
              ],
              [
                46.9629909,
                37.6375179
              ],
              [
                46.9638244,
                37.6375179
              ],
              [
                46.9649378,
                37.6380755
              ],
              [
                46.966048,
                37.6380755
              ],
              [
                46.972438,
                37.6402966
              ],
              [
                46.9735473,
                37.6402966
              ],
              [
                46.9735472,
                37.6405754
              ],
              [
                46.9746605,
                37.6405755
              ],
              [
                46.9754942,
                37.6408542
              ],
              [
                46.9782709,
                37.6414027
              ],
              [
                46.9796607,
                37.6414027
              ],
              [
                46.9804943,
                37.6416815
              ],
              [
                46.9818811,
                37.6416815
              ],
              [
                46.9827139,
                37.6419603
              ],
              [
                46.9913273,
                37.6419603
              ],
              [
                46.9918804,
                37.6416815
              ],
              [
                46.9932704,
                37.6416815
              ],
              [
                46.9935509,
                37.6414027
              ],
              [
                46.9960509,
                37.641133
              ],
              [
                47.0096606,
                37.6361333
              ],
              [
                47.0096606,
                37.6358544
              ],
              [
                47.0102169,
                37.6358545
              ],
              [
                47.0110505,
                37.6352969
              ],
              [
                47.0238274,
                37.6302972
              ],
              [
                47.0252172,
                37.6302972
              ],
              [
                47.0766098,
                37.6177975
              ],
              [
                47.0807763,
                37.6166824
              ],
              [
                47.0813294,
                37.6164037
              ],
              [
                47.0838295,
                37.6161339
              ],
              [
                47.1191093,
                37.6030763
              ],
              [
                47.1199429,
                37.60224
              ],
              [
                47.1207765,
                37.6019612
              ],
              [
                47.1388324,
                37.5883457
              ],
              [
                47.1407794,
                37.5866821
              ],
              [
                47.1526907,
                37.5820442
              ],
              [
                47.1683744,
                37.5754392
              ],
              [
                47.1811385,
                37.5699628
              ],
              [
                47.198115,
                37.5647659
              ],
              [
                47.2128424,
                37.5623404
              ],
              [
                47.2229745,
                37.5614024
              ],
              [
                47.2333911,
                37.5626545
              ],
              [
                47.2376052,
                37.5665078
              ],
              [
                47.2421715,
                37.5661236
              ],
              [
                47.2418949,
                37.5666812
              ],
              [
                47.2416184,
                37.5680752
              ],
              [
                47.2413387,
                37.5691814
              ],
              [
                47.2407847,
                37.5722391
              ],
              [
                47.2402285,
                37.5750181
              ],
              [
                47.2405051,
                37.5775182
              ],
              [
                47.2374479,
                37.5827973
              ],
              [
                47.2368948,
                37.583076
              ],
              [
                47.2368948,
                37.5833548
              ],
              [
                47.2355049,
                37.5852974
              ],
              [
                47.2143917,
                37.6330763
              ],
              [
                47.2138385,
                37.6339127
              ],
              [
                47.2135581,
                37.6347399
              ],
              [
                47.2132815,
                37.6355762
              ],
              [
                47.2127252,
                37.6380761
              ],
              [
                47.209115,
                37.6550176
              ],
              [
                47.2088384,
                37.6566901
              ],
              [
                47.2082813,
                37.6605747
              ],
              [
                47.2080047,
                37.662517
              ],
              [
                47.2077251,
                37.6658531
              ],
              [
                47.2074484,
                37.6683529
              ],
              [
                47.2068914,
                37.6733524
              ],
              [
                47.2074484,
                37.6789094
              ],
              [
                47.210225,
                37.6897444
              ],
              [
                47.2110578,
                37.6972434
              ],
              [
                47.2113383,
                37.6991857
              ],
              [
                47.2130047,
                37.7164132
              ],
              [
                47.2135578,
                37.7250178
              ],
              [
                47.2141148,
                37.7302956
              ],
              [
                47.2160578,
                37.7386302
              ],
              [
                47.2227282,
                37.7500217
              ],
              [
                47.2230048,
                37.7505792
              ],
              [
                47.2232812,
                37.7511365
              ],
              [
                47.2241142,
                37.7519638
              ],
              [
                47.2243946,
                37.7522425
              ],
              [
                47.2243947,
                37.7530785
              ],
              [
                47.2238375,
                37.7544631
              ],
              [
                47.2230047,
                37.7569625
              ],
              [
                47.221614,
                37.7577987
              ],
              [
                47.2210609,
                37.7583561
              ],
              [
                47.2166147,
                37.7600193
              ],
              [
                47.2157812,
                37.7600194
              ],
              [
                47.2152248,
                37.7602981
              ],
              [
                47.2138381,
                37.7602981
              ],
              [
                47.2135576,
                37.7605768
              ],
              [
                47.2118912,
                37.7605768
              ],
              [
                47.2110576,
                37.7608555
              ],
              [
                47.2085575,
                37.7608555
              ],
              [
                47.2080043,
                37.7611342
              ],
              [
                47.2066145,
                37.7611342
              ],
              [
                47.2057816,
                37.7614129
              ],
              [
                47.2049481,
                37.7614129
              ],
              [
                47.204391,
                37.7616916
              ],
              [
                47.203005,
                37.7616916
              ],
              [
                47.1988346,
                37.7627974
              ],
              [
                47.196058,
                37.7627974
              ],
              [
                47.1949479,
                37.7630761
              ],
              [
                47.1921681,
                37.7630761
              ],
              [
                47.1916149,
                37.7633549
              ],
              [
                47.1896681,
                37.7633548
              ],
              [
                47.1891148,
                37.7636336
              ],
              [
                47.187168,
                37.7636335
              ],
              [
                47.1863351,
                37.7639122
              ],
              [
                47.1830015,
                37.7639123
              ],
              [
                47.1702254,
                37.7666903
              ],
              [
                47.1696683,
                37.7666903
              ],
              [
                47.1693918,
                37.766969
              ],
              [
                47.1685582,
                37.766969
              ],
              [
                47.1682785,
                37.7672477
              ],
              [
                47.1678237,
                37.7674769
              ],
              [
                47.1671682,
                37.7678051
              ],
              [
                47.166612,
                37.7680748
              ],
              [
                47.1660581,
                37.7683535
              ],
              [
                47.1652253,
                37.7683535
              ],
              [
                47.1646682,
                37.7686322
              ],
              [
                47.1638354,
                37.7686322
              ],
              [
                47.163558,
                37.7689109
              ],
              [
                47.1621681,
                37.7689109
              ],
              [
                47.1618885,
                37.7691896
              ],
              [
                47.1532781,
                37.7691896
              ],
              [
                47.1530016,
                37.7689108
              ],
              [
                47.1499453,
                37.7689109
              ],
              [
                47.1493882,
                37.7686322
              ],
              [
                47.146335,
                37.7686322
              ],
              [
                47.1457787,
                37.7683534
              ],
              [
                47.1443888,
                37.7683535
              ],
              [
                47.1435552,
                37.7680748
              ],
              [
                47.1421654,
                37.7680747
              ],
              [
                47.1416122,
                37.767805
              ],
              [
                47.1371653,
                37.7680748
              ],
              [
                47.1268884,
                37.7714102
              ],
              [
                47.1263322,
                37.7719676
              ],
              [
                47.1263322,
                37.772525
              ],
              [
                47.1260556,
                37.7730734
              ],
              [
                47.1257791,
                37.7736308
              ],
              [
                47.125779,
                37.7739095
              ],
              [
                47.1243884,
                37.7758514
              ],
              [
                47.1243884,
                37.7764089
              ],
              [
                47.1238321,
                37.7766875
              ],
              [
                47.1224422,
                37.7808591
              ],
              [
                47.1227219,
                37.7839068
              ],
              [
                47.1252219,
                37.7953063
              ],
              [
                47.1227218,
                37.7986327
              ],
              [
                47.121332,
                37.7994688
              ],
              [
                47.1191085,
                37.8005835
              ],
              [
                47.1068887,
                37.8030737
              ],
              [
                47.1066089,
                37.8033524
              ],
              [
                47.1052191,
                37.8033524
              ],
              [
                47.1049425,
                37.8036311
              ],
              [
                47.0963322,
                37.8036311
              ],
              [
                47.0957759,
                37.8033525
              ],
              [
                47.0921657,
                37.8033524
              ],
              [
                47.0913321,
                37.8030737
              ],
              [
                47.0891094,
                37.8030736
              ],
              [
                47.0866093,
                37.8025253
              ],
              [
                47.0852187,
                37.8025252
              ],
              [
                47.0846624,
                37.8022466
              ],
              [
                47.0835522,
                37.8022466
              ],
              [
                47.0677191,
                37.7969693
              ],
              [
                47.0554962,
                37.7933554
              ],
              [
                47.0524391,
                37.7933554
              ],
              [
                47.0518859,
                37.7930766
              ],
              [
                47.0493827,
                37.7930767
              ],
              [
                47.0466061,
                37.7927979
              ],
              [
                47.0457725,
                37.7927979
              ],
              [
                47.045496,
                37.7930766
              ],
              [
                47.0446631,
                37.7927979
              ],
              [
                47.044106,
                37.7927979
              ],
              [
                47.0438295,
                37.7930766
              ],
              [
                47.041606,
                37.7930766
              ],
              [
                47.0385497,
                37.7939127
              ],
              [
                47.022993,
                37.801689
              ],
              [
                47.0152163,
                37.8080809
              ],
              [
                46.9966034,
                37.8239119
              ],
              [
                46.9966033,
                37.8241906
              ],
              [
                46.9959567,
                37.824655
              ],
              [
                46.9954932,
                37.825575
              ],
              [
                46.995493,
                37.8261324
              ],
              [
                46.9952165,
                37.8272471
              ],
              [
                46.9952165,
                37.8303035
              ],
              [
                46.9954931,
                37.8316879
              ],
              [
                46.9985501,
                37.8355804
              ],
              [
                47.0007697,
                37.8383582
              ],
              [
                47.0016034,
                37.8400212
              ],
              [
                47.0027166,
                37.8464126
              ],
              [
                47.0029931,
                37.8480847
              ],
              [
                47.0041034,
                37.8508623
              ],
              [
                47.0271592,
                37.8728049
              ],
              [
                47.0288257,
                37.8747465
              ],
              [
                47.0304928,
                37.8766881
              ],
              [
                47.0343828,
                37.8808589
              ],
              [
                47.0393821,
                37.8875286
              ],
              [
                47.0427157,
                37.9214152
              ],
              [
                47.042439,
                37.9216937
              ],
              [
                47.0410492,
                37.928363
              ],
              [
                47.0393819,
                37.9316975
              ],
              [
                47.0382725,
                37.9333602
              ],
              [
                47.0352154,
                37.9428067
              ],
              [
                47.0352154,
                37.9453053
              ],
              [
                47.0352154,
                37.9458625
              ],
              [
                47.0349388,
                37.9466893
              ],
              [
                47.0346622,
                37.9483611
              ],
              [
                47.0343825,
                37.9505811
              ],
              [
                47.0307722,
                37.9625257
              ],
              [
                47.0307722,
                37.9716929
              ],
              [
                47.0318824,
                37.9783615
              ],
              [
                47.0349386,
                37.9855873
              ],
              [
                47.0416051,
                37.9964168
              ],
              [
                47.0427153,
                37.9986366
              ],
              [
                47.043137,
                37.9987687
              ],
              [
                47.0471623,
                38.0000296
              ],
              [
                47.0438287,
                38.0039209
              ],
              [
                47.0427153,
                38.0050264
              ],
              [
                47.0332721,
                38.022254
              ],
              [
                47.0316056,
                38.0253094
              ],
              [
                47.0316056,
                38.0255791
              ],
              [
                47.0299384,
                38.0303059
              ],
              [
                47.0316055,
                38.0403079
              ],
              [
                47.0296586,
                38.0458614
              ],
              [
                47.014659,
                38.057804
              ],
              [
                47.0138253,
                38.0580826
              ],
              [
                47.0079924,
                38.0644716
              ],
              [
                47.0074353,
                38.0650288
              ],
              [
                47.0072898,
                38.065322
              ],
              [
                47.0068822,
                38.0653073
              ],
              [
                47.0063252,
                38.0655858
              ],
              [
                47.0057689,
                38.0653074
              ],
              [
                46.992992,
                38.0697553
              ],
              [
                46.9918788,
                38.0697553
              ],
              [
                46.9916022,
                38.0700338
              ],
              [
                46.9896592,
                38.0700339
              ],
              [
                46.9891021,
                38.0703124
              ],
              [
                46.9843793,
                38.0703124
              ],
              [
                46.9832692,
                38.0700339
              ],
              [
                46.9818793,
                38.0700338
              ],
              [
                46.9810457,
                38.0697553
              ],
              [
                46.9799355,
                38.0697552
              ],
              [
                46.9704892,
                38.0664215
              ],
              [
                46.9691025,
                38.0664215
              ],
              [
                46.9685462,
                38.0661429
              ],
              [
                46.9677126,
                38.0661429
              ],
              [
                46.9654891,
                38.0655857
              ],
              [
                46.9618789,
                38.0655858
              ],
              [
                46.9613226,
                38.0653072
              ],
              [
                46.9599359,
                38.0653073
              ],
              [
                46.9591029,
                38.0655858
              ],
              [
                46.9560459,
                38.0655858
              ],
              [
                46.9552123,
                38.0658643
              ],
              [
                46.954099,
                38.0658643
              ],
              [
                46.9504896,
                38.0667
              ],
              [
                46.9485457,
                38.0675267
              ],
              [
                46.9474324,
                38.0675267
              ],
              [
                46.9471558,
                38.0678052
              ],
              [
                46.9440995,
                38.068641
              ],
              [
                46.9404893,
                38.0691981
              ],
              [
                46.9349329,
                38.0703123
              ],
              [
                46.9127098,
                38.0703123
              ],
              [
                46.9118761,
                38.0700337
              ],
              [
                46.9104863,
                38.0703122
              ],
              [
                46.9088199,
                38.0700336
              ],
              [
                46.889653,
                38.0700336
              ],
              [
                46.8885435,
                38.0697551
              ],
              [
                46.8879866,
                38.0700336
              ],
              [
                46.8868763,
                38.0700336
              ],
              [
                46.8857631,
                38.069755
              ],
              [
                46.8840966,
                38.069755
              ],
              [
                46.8829864,
                38.0700336
              ],
              [
                46.867987,
                38.0700335
              ],
              [
                46.8668736,
                38.0703121
              ],
              [
                46.860207,
                38.0709995
              ],
              [
                46.85965,
                38.0711388
              ],
              [
                46.8579835,
                38.0711388
              ],
              [
                46.8552069,
                38.0716959
              ],
              [
                46.8535404,
                38.0716959
              ],
              [
                46.8524303,
                38.0719745
              ],
              [
                46.8504833,
                38.0719744
              ],
              [
                46.8438168,
                38.0733673
              ],
              [
                46.8393737,
                38.0744725
              ],
              [
                46.8221507,
                38.0786419
              ],
              [
                46.8207608,
                38.0786419
              ],
              [
                46.8113177,
                38.0800256
              ],
              [
                46.8090941,
                38.0800257
              ],
              [
                46.8074276,
                38.0803042
              ],
              [
                46.7988142,
                38.0803042
              ],
              [
                46.7971477,
                38.0800256
              ],
              [
                46.7840912,
                38.0794775
              ],
              [
                46.7749245,
                38.0794774
              ],
              [
                46.7735378,
                38.0797559
              ],
              [
                46.7468677,
                38.0819753
              ],
              [
                46.7435348,
                38.0819753
              ],
              [
                46.7424252,
                38.0822539
              ],
              [
                46.7399246,
                38.0822539
              ],
              [
                46.7390917,
                38.0825324
              ],
              [
                46.7377019,
                38.0825325
              ],
              [
                46.7327018,
                38.082811
              ],
              [
                46.7254782,
                38.0828109
              ],
              [
                46.7252016,
                38.0825324
              ],
              [
                46.7227015,
                38.0825324
              ],
              [
                46.7168686,
                38.0811396
              ],
              [
                46.7152022,
                38.0811396
              ],
              [
                46.7143685,
                38.0808611
              ],
              [
                46.7124217,
                38.080861
              ],
              [
                46.7115888,
                38.0805825
              ],
              [
                46.7079785,
                38.0805825
              ],
              [
                46.7068653,
                38.0803039
              ],
              [
                46.6963119,
                38.0803039
              ],
              [
                46.6957556,
                38.0805824
              ],
              [
                46.694365,
                38.0805824
              ],
              [
                46.6938118,
                38.080861
              ],
              [
                46.692979,
                38.080861
              ],
              [
                46.6926985,
                38.0811395
              ],
              [
                46.6918657,
                38.0811396
              ],
              [
                46.6670922,
                38.0828752
              ],
              [
                46.6539931,
                38.0808372
              ],
              [
                46.6540431,
                38.0735686
              ],
              [
                46.6584351,
                38.0644233
              ],
              [
                46.666465,
                38.0521975
              ],
              [
                46.6708867,
                38.0469713
              ],
              [
                46.6848562,
                38.0343013
              ],
              [
                46.693611,
                38.0172632
              ],
              [
                46.691551,
                38.0100951
              ],
              [
                46.6769722,
                37.9843043
              ],
              [
                46.6703952,
                37.9856973
              ],
              [
                46.638336,
                37.9912926
              ],
              [
                46.6041332,
                38.0015619
              ],
              [
                46.5686487,
                38.0067923
              ],
              [
                46.5590705,
                38.0074494
              ],
              [
                46.5503705,
                38.0103159
              ],
              [
                46.5384159,
                38.0140564
              ],
              [
                46.5267561,
                38.0169927
              ],
              [
                46.5191598,
                38.0167849
              ],
              [
                46.511128,
                38.0141426
              ],
              [
                46.5062247,
                38.0085025
              ],
              [
                46.5054332,
                37.9987393
              ],
              [
                46.5065928,
                37.9858077
              ],
              [
                46.5125243,
                37.9739902
              ],
              [
                46.516758,
                37.9642267
              ],
              [
                46.5244407,
                37.9571993
              ],
              [
                46.536419,
                37.9484297
              ],
              [
                46.5427705,
                37.9383996
              ],
              [
                46.544592,
                37.929386
              ],
              [
                46.5404721,
                37.9189436
              ],
              [
                46.5314243,
                37.9059853
              ],
              [
                46.5264656,
                37.8981843
              ],
              [
                46.519926,
                37.8890619
              ],
              [
                46.5160031,
                37.880759
              ],
              [
                46.5119081,
                37.8723059
              ],
              [
                46.5077116,
                37.8594727
              ],
              [
                46.5048371,
                37.8430989
              ],
              [
                46.503483,
                37.8346316
              ],
              [
                46.5032485,
                37.8208541
              ],
              [
                46.5040839,
                37.81449
              ],
              [
                46.5039791,
                37.7967348
              ],
              [
                46.505095,
                37.7863913
              ],
              [
                46.5049552,
                37.7801449
              ],
              [
                46.5013503,
                37.7673903
              ],
              [
                46.4989471,
                37.7639977
              ],
              [
                46.4896773,
                37.7497473
              ],
              [
                46.4940547,
                37.7471683
              ],
              [
                46.4985179,
                37.738345
              ],
              [
                46.499462,
                37.7299279
              ],
              [
                46.4987369,
                37.7277611
              ],
              [
                46.497488,
                37.7230373
              ],
              [
                46.4927673,
                37.7174361
              ],
              [
                46.4818668,
                37.7072512
              ],
              [
                46.4777268,
                37.7010304
              ],
              [
                46.4753044,
                37.6935179
              ],
              [
                46.4748944,
                37.6894778
              ],
              [
                46.4744203,
                37.6843339
              ],
              [
                46.4756021,
                37.6776718
              ],
              [
                46.4783944,
                37.6686977
              ],
              [
                46.4827325,
                37.659479
              ],
              [
                46.4856285,
                37.6525763
              ],
              [
                46.4892336,
                37.6435059
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554936,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بناب",
          "name:en": "Bonab County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291723",
          "wikipedia": "en:Bonab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.6421216,
                37.3036418
              ],
              [
                45.6878289,
                37.2901539
              ],
              [
                45.7611034,
                37.2065666
              ],
              [
                45.8460885,
                37.1749873
              ],
              [
                45.863285,
                37.1726281
              ],
              [
                45.8674478,
                37.1722861
              ],
              [
                45.8833265,
                37.1716364
              ],
              [
                45.908904,
                37.1725939
              ],
              [
                45.9106636,
                37.1731239
              ],
              [
                45.9118223,
                37.1762869
              ],
              [
                45.9128737,
                37.1782701
              ],
              [
                45.914526,
                37.1812107
              ],
              [
                45.9169936,
                37.1844588
              ],
              [
                45.9187531,
                37.1865444
              ],
              [
                45.923109,
                37.1900317
              ],
              [
                45.9263062,
                37.1921513
              ],
              [
                45.9297609,
                37.1942537
              ],
              [
                45.9348035,
                37.1962536
              ],
              [
                45.9399104,
                37.1978432
              ],
              [
                45.944603,
                37.1987262
              ],
              [
                45.9487101,
                37.1988482
              ],
              [
                45.9517539,
                37.1987072
              ],
              [
                45.9566772,
                37.1983775
              ],
              [
                45.9615354,
                37.1975231
              ],
              [
                45.9748422,
                37.1950413
              ],
              [
                45.9776709,
                37.1939208
              ],
              [
                45.9829231,
                37.1924798
              ],
              [
                45.9920067,
                37.1902321
              ],
              [
                45.9997426,
                37.1920154
              ],
              [
                46.0082629,
                37.1918529
              ],
              [
                46.0149621,
                37.1892891
              ],
              [
                46.0207728,
                37.1885204
              ],
              [
                46.0277458,
                37.1894226
              ],
              [
                46.0381307,
                37.1932516
              ],
              [
                46.0444236,
                37.1959823
              ],
              [
                46.0464906,
                37.204731
              ],
              [
                46.0468403,
                37.205622
              ],
              [
                46.0493218,
                37.2114883
              ],
              [
                46.0525841,
                37.2190279
              ],
              [
                46.0600226,
                37.2330495
              ],
              [
                46.0594591,
                37.2386188
              ],
              [
                46.0591769,
                37.2413976
              ],
              [
                46.0567062,
                37.2465897
              ],
              [
                46.0611956,
                37.2497751
              ],
              [
                46.0685709,
                37.2521874
              ],
              [
                46.0758715,
                37.2519081
              ],
              [
                46.0821455,
                37.2545805
              ],
              [
                46.0871361,
                37.2556004
              ],
              [
                46.0930346,
                37.2559647
              ],
              [
                46.0989384,
                37.2553989
              ],
              [
                46.1046624,
                37.254175
              ],
              [
                46.1103701,
                37.2524671
              ],
              [
                46.1131412,
                37.2514865
              ],
              [
                46.1177612,
                37.249898
              ],
              [
                46.1228804,
                37.247775
              ],
              [
                46.1289145,
                37.2467303
              ],
              [
                46.1355853,
                37.2466649
              ],
              [
                46.1423414,
                37.2467674
              ],
              [
                46.1482835,
                37.2473965
              ],
              [
                46.1516872,
                37.2483617
              ],
              [
                46.1553223,
                37.2493601
              ],
              [
                46.15883,
                37.250345
              ],
              [
                46.1624014,
                37.2511192
              ],
              [
                46.1673121,
                37.252221
              ],
              [
                46.1697669,
                37.2528273
              ],
              [
                46.1706095,
                37.2531264
              ],
              [
                46.1719488,
                37.2535988
              ],
              [
                46.1720602,
                37.253668
              ],
              [
                46.1768662,
                37.2567891
              ],
              [
                46.1818783,
                37.2669767
              ],
              [
                46.1852691,
                37.2767206
              ],
              [
                46.1779971,
                37.2989474
              ],
              [
                46.1765679,
                37.3008394
              ],
              [
                46.1765679,
                37.3013972
              ],
              [
                46.1729545,
                37.3055629
              ],
              [
                46.1615643,
                37.3105652
              ],
              [
                46.1610112,
                37.3111231
              ],
              [
                46.1601776,
                37.311393
              ],
              [
                46.153511,
                37.3177808
              ],
              [
                46.1498976,
                37.3261209
              ],
              [
                46.1479664,
                37.3278458
              ],
              [
                46.145824,
                37.3303255
              ],
              [
                46.132004,
                37.3360808
              ],
              [
                46.129561,
                37.3362843
              ],
              [
                46.1275256,
                37.3420995
              ],
              [
                46.1266716,
                37.3488515
              ],
              [
                46.1343357,
                37.3494349
              ],
              [
                46.138424,
                37.3497031
              ],
              [
                46.1451003,
                37.3502796
              ],
              [
                46.1465781,
                37.3592068
              ],
              [
                46.1524578,
                37.3659004
              ],
              [
                46.1594214,
                37.3713474
              ],
              [
                46.1624008,
                37.3786153
              ],
              [
                46.1621211,
                37.3789031
              ],
              [
                46.1607305,
                37.3794519
              ],
              [
                46.1601773,
                37.3797308
              ],
              [
                46.1510107,
                37.3869545
              ],
              [
                46.1498972,
                37.3888977
              ],
              [
                46.1496208,
                37.3897343
              ],
              [
                46.1493442,
                37.3916774
              ],
              [
                46.1501778,
                37.394736
              ],
              [
                46.1504544,
                37.3952847
              ],
              [
                46.1582774,
                37.4096314
              ],
              [
                46.1544888,
                37.4140811
              ],
              [
                46.1440814,
                37.4163711
              ],
              [
                46.1347788,
                37.4175869
              ],
              [
                46.1287239,
                37.4194655
              ],
              [
                46.1179463,
                37.4243777
              ],
              [
                46.1129466,
                37.4297752
              ],
              [
                46.1198365,
                37.4373046
              ],
              [
                46.1295409,
                37.4449642
              ],
              [
                46.1306581,
                37.4457118
              ],
              [
                46.1501775,
                37.4502921
              ],
              [
                46.1504541,
                37.4511197
              ],
              [
                46.1537869,
                37.4580639
              ],
              [
                46.1537869,
                37.4652868
              ],
              [
                46.1535103,
                37.4655657
              ],
              [
                46.1526767,
                37.4700091
              ],
              [
                46.1529541,
                37.4747314
              ],
              [
                46.1526767,
                37.4755679
              ],
              [
                46.1518439,
                37.480569
              ],
              [
                46.1518439,
                37.4841758
              ],
              [
                46.152397,
                37.488898
              ],
              [
                46.1579533,
                37.495572
              ],
              [
                46.1606624,
                37.4978211
              ],
              [
                46.161391,
                37.4983384
              ],
              [
                46.162838,
                37.4996044
              ],
              [
                46.1665268,
                37.5030218
              ],
              [
                46.1698635,
                37.5054474
              ],
              [
                46.1758782,
                37.5151806
              ],
              [
                46.1800096,
                37.5182281
              ],
              [
                46.1918865,
                37.5232092
              ],
              [
                46.192892,
                37.5233525
              ],
              [
                46.1937513,
                37.5241894
              ],
              [
                46.1743433,
                37.5316838
              ],
              [
                46.1729534,
                37.5316838
              ],
              [
                46.1718432,
                37.5319625
              ],
              [
                46.1687869,
                37.5322324
              ],
              [
                46.1582297,
                37.5305685
              ],
              [
                46.1576766,
                37.5308473
              ],
              [
                46.1571203,
                37.5305685
              ],
              [
                46.1546203,
                37.5305684
              ],
              [
                46.1535101,
                37.5300108
              ],
              [
                46.1526765,
                37.5300109
              ],
              [
                46.1479536,
                37.5286257
              ],
              [
                46.1448966,
                37.5286257
              ],
              [
                46.1426739,
                37.5283469
              ],
              [
                46.1418402,
                37.5286257
              ],
              [
                46.1396199,
                37.5286258
              ],
              [
                46.1390637,
                37.5283469
              ],
              [
                46.1385066,
                37.5283469
              ],
              [
                46.1371207,
                37.5283469
              ],
              [
                46.132397,
                37.5264042
              ],
              [
                46.1315635,
                37.5255677
              ],
              [
                46.1290635,
                37.5241826
              ],
              [
                46.128063,
                37.5231428
              ],
              [
                46.1271205,
                37.5225097
              ],
              [
                46.1040606,
                37.5050159
              ],
              [
                46.1021176,
                37.5047371
              ],
              [
                46.094894,
                37.5033429
              ],
              [
                46.0932276,
                37.5033429
              ],
              [
                46.0921175,
                37.5030641
              ],
              [
                46.0907275,
                37.5030641
              ],
              [
                46.0896174,
                37.5027853
              ],
              [
                46.0837844,
                37.5025154
              ],
              [
                46.082671,
                37.5027853
              ],
              [
                46.0762843,
                37.5019578
              ],
              [
                46.0723943,
                37.4988997
              ],
              [
                46.0718381,
                37.498351
              ],
              [
                46.0596145,
                37.4875126
              ],
              [
                46.058505,
                37.4872337
              ],
              [
                46.049615,
                37.4836269
              ],
              [
                46.0487813,
                37.4836269
              ],
              [
                46.0485048,
                37.483348
              ],
              [
                46.0476713,
                37.4833481
              ],
              [
                46.0462813,
                37.4827903
              ],
              [
                46.0454485,
                37.4827904
              ],
              [
                46.032392,
                37.4802898
              ],
              [
                46.026002,
                37.4802898
              ],
              [
                46.0251684,
                37.480011
              ],
              [
                46.0229488,
                37.480011
              ],
              [
                46.0226684,
                37.4797321
              ],
              [
                46.0215582,
                37.4797321
              ],
              [
                46.0101689,
                37.4777892
              ],
              [
                46.0068352,
                37.4766828
              ],
              [
                46.0057251,
                37.4766828
              ],
              [
                46.0026687,
                37.4752886
              ],
              [
                46.0018351,
                37.4744611
              ],
              [
                46.0010023,
                37.4739034
              ],
              [
                46.0004453,
                37.4736246
              ],
              [
                46.0001686,
                37.4733457
              ],
              [
                45.9873887,
                37.4622371
              ],
              [
                45.9790558,
                37.4397314
              ],
              [
                45.9746128,
                37.4186191
              ],
              [
                45.9740558,
                37.4172338
              ],
              [
                45.9740559,
                37.4166761
              ],
              [
                45.9696916,
                37.4085264
              ],
              [
                45.9614604,
                37.4023543
              ],
              [
                45.8384092,
                37.3762426
              ],
              [
                45.7152064,
                37.3500897
              ],
              [
                45.6984522,
                37.3421745
              ],
              [
                45.6580088,
                37.3192978
              ],
              [
                45.6421216,
                37.3036418
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554961,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تبریز",
          "name:en": "Tabriz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286247",
          "wikipedia": "en:Tabriz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.8545916,
                38.0472761
              ],
              [
                45.8551573,
                38.0461366
              ],
              [
                45.8554377,
                38.0455796
              ],
              [
                45.8573808,
                38.04336
              ],
              [
                45.8579378,
                38.0419671
              ],
              [
                45.8698811,
                38.0250276
              ],
              [
                45.8967729,
                37.999844
              ],
              [
                45.9023844,
                37.9911382
              ],
              [
                45.9026609,
                37.9908596
              ],
              [
                45.9279404,
                37.9830858
              ],
              [
                45.939054,
                37.9780799
              ],
              [
                45.9651633,
                37.9700273
              ],
              [
                45.9821097,
                37.96308
              ],
              [
                45.9921511,
                37.9621924
              ],
              [
                46.0001385,
                37.9551906
              ],
              [
                46.001927,
                37.9554423
              ],
              [
                46.0031461,
                37.9542484
              ],
              [
                46.0125446,
                37.9473788
              ],
              [
                46.012845,
                37.9458897
              ],
              [
                46.0104003,
                37.9451728
              ],
              [
                46.0136604,
                37.939087
              ],
              [
                46.0210673,
                37.9297616
              ],
              [
                46.0237943,
                37.9240073
              ],
              [
                46.0266695,
                37.9187782
              ],
              [
                46.033032,
                37.9116593
              ],
              [
                46.0409706,
                37.9165503
              ],
              [
                46.0516007,
                37.9231637
              ],
              [
                46.0589904,
                37.9292701
              ],
              [
                46.0659448,
                37.9365922
              ],
              [
                46.0732868,
                37.9428471
              ],
              [
                46.0768313,
                37.9456974
              ],
              [
                46.0824486,
                37.9492365
              ],
              [
                46.0787787,
                37.9559621
              ],
              [
                46.0767574,
                37.9602454
              ],
              [
                46.0801989,
                37.9657097
              ],
              [
                46.0895045,
                37.9711392
              ],
              [
                46.0996917,
                37.9749678
              ],
              [
                46.1070325,
                37.9757133
              ],
              [
                46.1119365,
                37.9754284
              ],
              [
                46.1204767,
                37.9738046
              ],
              [
                46.1270911,
                37.9736268
              ],
              [
                46.1356778,
                37.974174
              ],
              [
                46.1438655,
                37.9768831
              ],
              [
                46.1590575,
                37.9787775
              ],
              [
                46.1626624,
                37.9770861
              ],
              [
                46.1694037,
                37.9765422
              ],
              [
                46.1785348,
                37.9711104
              ],
              [
                46.1887586,
                37.9582459
              ],
              [
                46.1987736,
                37.9470455
              ],
              [
                46.2096049,
                37.9366421
              ],
              [
                46.2170529,
                37.9297639
              ],
              [
                46.2348324,
                37.9124274
              ],
              [
                46.2502533,
                37.8980326
              ],
              [
                46.257804,
                37.8854709
              ],
              [
                46.2666831,
                37.8721468
              ],
              [
                46.271501,
                37.8657367
              ],
              [
                46.2804687,
                37.8541263
              ],
              [
                46.296858,
                37.8384045
              ],
              [
                46.3013487,
                37.8359735
              ],
              [
                46.3069221,
                37.8326971
              ],
              [
                46.317759,
                37.8299869
              ],
              [
                46.3248053,
                37.8259664
              ],
              [
                46.3280582,
                37.8225991
              ],
              [
                46.3320721,
                37.8150949
              ],
              [
                46.3320064,
                37.8073089
              ],
              [
                46.3353967,
                37.8048336
              ],
              [
                46.3426494,
                37.8026635
              ],
              [
                46.3473272,
                37.8009342
              ],
              [
                46.3486576,
                37.8001882
              ],
              [
                46.3487434,
                37.7948302
              ],
              [
                46.3494392,
                37.7902114
              ],
              [
                46.3511954,
                37.7880208
              ],
              [
                46.3518811,
                37.7847739
              ],
              [
                46.3484908,
                37.7790064
              ],
              [
                46.3469228,
                37.7768153
              ],
              [
                46.3460027,
                37.7726256
              ],
              [
                46.3444402,
                37.7670467
              ],
              [
                46.3424778,
                37.7585693
              ],
              [
                46.3358259,
                37.754837
              ],
              [
                46.3344097,
                37.7527672
              ],
              [
                46.3341093,
                37.7482203
              ],
              [
                46.336879,
                37.7467156
              ],
              [
                46.338424,
                37.7444241
              ],
              [
                46.3384008,
                37.7404151
              ],
              [
                46.3392632,
                37.7363059
              ],
              [
                46.3425868,
                37.7333726
              ],
              [
                46.3437958,
                37.731328
              ],
              [
                46.349481,
                37.731539
              ],
              [
                46.3524595,
                37.7311657
              ],
              [
                46.3552681,
                37.7311246
              ],
              [
                46.3592154,
                37.7317766
              ],
              [
                46.3610551,
                37.7328289
              ],
              [
                46.3611824,
                37.7341258
              ],
              [
                46.3610051,
                37.7351779
              ],
              [
                46.3609367,
                37.7383074
              ],
              [
                46.3623655,
                37.7404115
              ],
              [
                46.3665319,
                37.7425355
              ],
              [
                46.3696138,
                37.7433232
              ],
              [
                46.372147,
                37.7433785
              ],
              [
                46.3743475,
                37.7420889
              ],
              [
                46.3788718,
                37.7382807
              ],
              [
                46.3809299,
                37.7368856
              ],
              [
                46.382904,
                37.7357995
              ],
              [
                46.3858652,
                37.735528
              ],
              [
                46.3886995,
                37.7355829
              ],
              [
                46.3931213,
                37.7333234
              ],
              [
                46.4028604,
                37.7305668
              ],
              [
                46.4110361,
                37.723517
              ],
              [
                46.416082,
                37.7196666
              ],
              [
                46.4206648,
                37.7177976
              ],
              [
                46.4296871,
                37.7171866
              ],
              [
                46.4353942,
                37.7180301
              ],
              [
                46.4401267,
                37.720033
              ],
              [
                46.4442657,
                37.7228576
              ],
              [
                46.4488661,
                37.7250302
              ],
              [
                46.4502742,
                37.7260145
              ],
              [
                46.45602,
                37.727976
              ],
              [
                46.4610934,
                37.7286888
              ],
              [
                46.4664782,
                37.7292732
              ],
              [
                46.4744569,
                37.729159
              ],
              [
                46.4799854,
                37.7285553
              ],
              [
                46.4833733,
                37.727971
              ],
              [
                46.4874147,
                37.7272242
              ],
              [
                46.4987369,
                37.7277611
              ],
              [
                46.499462,
                37.7299279
              ],
              [
                46.4985179,
                37.738345
              ],
              [
                46.4940547,
                37.7471683
              ],
              [
                46.4896773,
                37.7497473
              ],
              [
                46.4989471,
                37.7639977
              ],
              [
                46.5013503,
                37.7673903
              ],
              [
                46.5049552,
                37.7801449
              ],
              [
                46.505095,
                37.7863913
              ],
              [
                46.5039791,
                37.7967348
              ],
              [
                46.5040839,
                37.81449
              ],
              [
                46.5032485,
                37.8208541
              ],
              [
                46.503483,
                37.8346316
              ],
              [
                46.5048371,
                37.8430989
              ],
              [
                46.5077116,
                37.8594727
              ],
              [
                46.5119081,
                37.8723059
              ],
              [
                46.5160031,
                37.880759
              ],
              [
                46.519926,
                37.8890619
              ],
              [
                46.5264656,
                37.8981843
              ],
              [
                46.5314243,
                37.9059853
              ],
              [
                46.5404721,
                37.9189436
              ],
              [
                46.544592,
                37.929386
              ],
              [
                46.5427705,
                37.9383996
              ],
              [
                46.536419,
                37.9484297
              ],
              [
                46.5244407,
                37.9571993
              ],
              [
                46.516758,
                37.9642267
              ],
              [
                46.5125243,
                37.9739902
              ],
              [
                46.5065928,
                37.9858077
              ],
              [
                46.5054332,
                37.9987393
              ],
              [
                46.5062247,
                38.0085025
              ],
              [
                46.511128,
                38.0141426
              ],
              [
                46.5191598,
                38.0167849
              ],
              [
                46.5267561,
                38.0169927
              ],
              [
                46.5384159,
                38.0140564
              ],
              [
                46.5503705,
                38.0103159
              ],
              [
                46.5590705,
                38.0074494
              ],
              [
                46.5686487,
                38.0067923
              ],
              [
                46.6041332,
                38.0015619
              ],
              [
                46.638336,
                37.9912926
              ],
              [
                46.6703952,
                37.9856973
              ],
              [
                46.6769722,
                37.9843043
              ],
              [
                46.691551,
                38.0100951
              ],
              [
                46.693611,
                38.0172632
              ],
              [
                46.6848562,
                38.0343013
              ],
              [
                46.6708867,
                38.0469713
              ],
              [
                46.666465,
                38.0521975
              ],
              [
                46.6584351,
                38.0644233
              ],
              [
                46.6540431,
                38.0735686
              ],
              [
                46.6539931,
                38.0808372
              ],
              [
                46.6483783,
                38.0804601
              ],
              [
                46.6305376,
                38.0771227
              ],
              [
                46.6160759,
                38.0754418
              ],
              [
                46.6008181,
                38.0735047
              ],
              [
                46.5883964,
                38.0727356
              ],
              [
                46.5821508,
                38.0723302
              ],
              [
                46.5703588,
                38.0731492
              ],
              [
                46.5612504,
                38.0748541
              ],
              [
                46.544662,
                38.0808246
              ],
              [
                46.5344213,
                38.0855361
              ],
              [
                46.5194759,
                38.092189
              ],
              [
                46.5120431,
                38.0958581
              ],
              [
                46.5032389,
                38.0979753
              ],
              [
                46.4891828,
                38.0981606
              ],
              [
                46.4780044,
                38.096673
              ],
              [
                46.4690859,
                38.0959494
              ],
              [
                46.4580928,
                38.0965842
              ],
              [
                46.4370039,
                38.1017175
              ],
              [
                46.4265445,
                38.1043999
              ],
              [
                46.4056491,
                38.1089654
              ],
              [
                46.3925569,
                38.1112692
              ],
              [
                46.3885666,
                38.1128984
              ],
              [
                46.3839769,
                38.113355
              ],
              [
                46.376032,
                38.1151325
              ],
              [
                46.3734628,
                38.1210917
              ],
              [
                46.3724885,
                38.1276658
              ],
              [
                46.3744926,
                38.1366495
              ],
              [
                46.3800762,
                38.1509507
              ],
              [
                46.3852235,
                38.1583081
              ],
              [
                46.3935181,
                38.1689223
              ],
              [
                46.3949078,
                38.1792003
              ],
              [
                46.3954609,
                38.18336
              ],
              [
                46.3949078,
                38.1858665
              ],
              [
                46.3954609,
                38.1922541
              ],
              [
                46.3957413,
                38.1933682
              ],
              [
                46.4057407,
                38.2064217
              ],
              [
                46.4121307,
                38.21448
              ],
              [
                46.4124073,
                38.215028
              ],
              [
                46.414351,
                38.2172559
              ],
              [
                46.4257411,
                38.22809
              ],
              [
                46.4304638,
                38.2358696
              ],
              [
                46.4310208,
                38.2394809
              ],
              [
                46.4299075,
                38.2450324
              ],
              [
                46.4299075,
                38.2489221
              ],
              [
                46.4312974,
                38.254752
              ],
              [
                46.4354639,
                38.2633667
              ],
              [
                46.4374068,
                38.2658638
              ],
              [
                46.4443538,
                38.2778108
              ],
              [
                46.4474101,
                38.2875388
              ],
              [
                46.4471304,
                38.2880867
              ],
              [
                46.4368535,
                38.3022607
              ],
              [
                46.4329636,
                38.3103086
              ],
              [
                46.4318534,
                38.3128146
              ],
              [
                46.428797,
                38.3197576
              ],
              [
                46.4257406,
                38.3239252
              ],
              [
                46.4224069,
                38.3350356
              ],
              [
                46.422407,
                38.3416999
              ],
              [
                46.4229639,
                38.3461457
              ],
              [
                46.4236288,
                38.3491435
              ],
              [
                46.4265734,
                38.3575341
              ],
              [
                46.4471299,
                38.3800316
              ],
              [
                46.4510199,
                38.3828157
              ],
              [
                46.4576864,
                38.3880964
              ],
              [
                46.4582435,
                38.3883659
              ],
              [
                46.4587965,
                38.3894795
              ],
              [
                46.4635193,
                38.3933681
              ],
              [
                46.4649099,
                38.3947601
              ],
              [
                46.4660193,
                38.3972568
              ],
              [
                46.4657428,
                38.3975352
              ],
              [
                46.4654663,
                38.3983704
              ],
              [
                46.4654663,
                38.4011453
              ],
              [
                46.4565761,
                38.412263
              ],
              [
                46.4551862,
                38.4158731
              ],
              [
                46.4551862,
                38.4169777
              ],
              [
                46.4549097,
                38.4175345
              ],
              [
                46.4535198,
                38.4197616
              ],
              [
                46.451576,
                38.4214229
              ],
              [
                46.4468532,
                38.4242068
              ],
              [
                46.4449062,
                38.4319835
              ],
              [
                46.4449062,
                38.4464231
              ],
              [
                46.444353,
                38.4480933
              ],
              [
                46.444353,
                38.4494852
              ],
              [
                46.43602,
                38.4617064
              ],
              [
                46.4357395,
                38.4622631
              ],
              [
                46.4351863,
                38.4639333
              ],
              [
                46.434073,
                38.4647594
              ],
              [
                46.4246298,
                38.4719878
              ],
              [
                46.4160163,
                38.4772586
              ],
              [
                46.4121296,
                38.478372
              ],
              [
                46.4082395,
                38.478372
              ],
              [
                46.4004598,
                38.475319
              ],
              [
                46.3996269,
                38.4750407
              ],
              [
                46.3987933,
                38.4750407
              ],
              [
                46.3976831,
                38.4744839
              ],
              [
                46.3954596,
                38.4744839
              ],
              [
                46.3946268,
                38.4742056
              ],
              [
                46.3890696,
                38.4742056
              ],
              [
                46.3885165,
                38.4744839
              ],
              [
                46.3868501,
                38.4744839
              ],
              [
                46.386293,
                38.4747623
              ],
              [
                46.3851836,
                38.4747623
              ],
              [
                46.3810171,
                38.4764324
              ],
              [
                46.3787936,
                38.4772585
              ],
              [
                46.3782365,
                38.4775368
              ],
              [
                46.3771271,
                38.4775368
              ],
              [
                46.37546,
                38.4783719
              ],
              [
                46.3746271,
                38.4783719
              ],
              [
                46.3735169,
                38.4789286
              ],
              [
                46.3724036,
                38.4789286
              ],
              [
                46.3710168,
                38.4794853
              ],
              [
                46.3693465,
                38.4794853
              ],
              [
                46.3657371,
                38.4803203
              ],
              [
                46.3643471,
                38.4803204
              ],
              [
                46.3499038,
                38.4861478
              ],
              [
                46.3474037,
                38.4867045
              ],
              [
                46.344624,
                38.4867044
              ],
              [
                46.3440701,
                38.4864261
              ],
              [
                46.3432373,
                38.4864261
              ],
              [
                46.3426802,
                38.4861477
              ],
              [
                46.3415708,
                38.4861478
              ],
              [
                46.3410137,
                38.485591
              ],
              [
                46.3404567,
                38.4854111
              ],
              [
                46.3376802,
                38.4833732
              ],
              [
                46.3371239,
                38.480042
              ],
              [
                46.3379575,
                38.4778151
              ],
              [
                46.3385138,
                38.4772584
              ],
              [
                46.3387904,
                38.4764323
              ],
              [
                46.3393474,
                38.4758756
              ],
              [
                46.3393474,
                38.4742054
              ],
              [
                46.3396239,
                38.4733704
              ],
              [
                46.339624,
                38.4722569
              ],
              [
                46.3410139,
                38.4711524
              ],
              [
                46.3440701,
                38.4664293
              ],
              [
                46.3443475,
                38.4658726
              ],
              [
                46.3440702,
                38.4644807
              ],
              [
                46.3437905,
                38.4619845
              ],
              [
                46.3390709,
                38.4564262
              ],
              [
                46.3401803,
                38.452538
              ],
              [
                46.3382373,
                38.4461534
              ],
              [
                46.334624,
                38.4411517
              ],
              [
                46.3299004,
                38.4386463
              ],
              [
                46.3268473,
                38.4372634
              ],
              [
                46.3126774,
                38.4303128
              ],
              [
                46.2999015,
                38.4194828
              ],
              [
                46.2996249,
                38.4183692
              ],
              [
                46.2940678,
                38.4083742
              ],
              [
                46.291288,
                38.3978131
              ],
              [
                46.2896216,
                38.3953164
              ],
              [
                46.2885114,
                38.3919846
              ],
              [
                46.2854552,
                38.3853119
              ],
              [
                46.2796215,
                38.3764299
              ],
              [
                46.2787879,
                38.3725321
              ],
              [
                46.2762887,
                38.3558721
              ],
              [
                46.2740652,
                38.3530879
              ],
              [
                46.2693448,
                38.3461453
              ],
              [
                46.267955,
                38.3411426
              ],
              [
                46.267955,
                38.3380889
              ],
              [
                46.2690651,
                38.3350352
              ],
              [
                46.2698988,
                38.3341999
              ],
              [
                46.2710122,
                38.3325383
              ],
              [
                46.2735123,
                38.3258649
              ],
              [
                46.2732318,
                38.3194788
              ],
              [
                46.2723989,
                38.3167034
              ],
              [
                46.271845,
                38.3155896
              ],
              [
                46.2654551,
                38.3069759
              ],
              [
                46.2637887,
                38.3011465
              ],
              [
                46.2597369,
                38.2833344
              ],
              [
                46.2583147,
                38.2650064
              ],
              [
                46.2550162,
                38.2439777
              ],
              [
                46.252379,
                38.2219921
              ],
              [
                46.2501974,
                38.2173443
              ],
              [
                46.248163,
                38.2114752
              ],
              [
                46.2470754,
                38.2049355
              ],
              [
                46.2455953,
                38.2024716
              ],
              [
                46.2409979,
                38.1983012
              ],
              [
                46.2328941,
                38.1923815
              ],
              [
                46.222849,
                38.1882985
              ],
              [
                46.2089703,
                38.1839332
              ],
              [
                46.192692,
                38.1810658
              ],
              [
                46.188554,
                38.1804163
              ],
              [
                46.1790101,
                38.1763681
              ],
              [
                46.172021,
                38.1749502
              ],
              [
                46.1614512,
                38.1772443
              ],
              [
                46.1622732,
                38.1793177
              ],
              [
                46.1620073,
                38.1813501
              ],
              [
                46.1599197,
                38.1821427
              ],
              [
                46.150975,
                38.1805992
              ],
              [
                46.1388106,
                38.179115
              ],
              [
                46.1297746,
                38.1838219
              ],
              [
                46.1158847,
                38.1915813
              ],
              [
                46.1115608,
                38.1913629
              ],
              [
                46.104487,
                38.1835373
              ],
              [
                46.094597,
                38.1796501
              ],
              [
                46.084037,
                38.1836982
              ],
              [
                46.0760892,
                38.184743
              ],
              [
                46.0594395,
                38.1797549
              ],
              [
                46.0479227,
                38.1732678
              ],
              [
                46.0331786,
                38.1651739
              ],
              [
                46.0210355,
                38.1578756
              ],
              [
                45.9996882,
                38.148688
              ],
              [
                45.9407198,
                38.1203048
              ],
              [
                45.9401627,
                38.1200263
              ],
              [
                45.9204397,
                38.1105828
              ],
              [
                45.9171068,
                38.109199
              ],
              [
                45.9076597,
                38.1037282
              ],
              [
                45.9071066,
                38.1033585
              ],
              [
                45.889604,
                38.0794749
              ],
              [
                45.8887704,
                38.0780821
              ],
              [
                45.8684942,
                38.0569741
              ],
              [
                45.8576573,
                38.049192
              ],
              [
                45.8545916,
                38.0472761
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554977,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جلفا",
          "name:en": "Jolfa County",
          "name:ru": "Джульфа",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291807",
          "wikipedia": "en:Jolfa County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.2815158,
                38.8736622
              ],
              [
                45.2831822,
                38.8719934
              ],
              [
                45.2820427,
                38.8705241
              ],
              [
                45.2842249,
                38.8686656
              ],
              [
                45.2872218,
                38.8665623
              ],
              [
                45.29387,
                38.8631597
              ],
              [
                45.2993709,
                38.8609336
              ],
              [
                45.3082496,
                38.8598515
              ],
              [
                45.3182582,
                38.8604531
              ],
              [
                45.3211767,
                38.8610772
              ],
              [
                45.3287846,
                38.8629151
              ],
              [
                45.3387148,
                38.8646941
              ],
              [
                45.3482283,
                38.8685122
              ],
              [
                45.3534814,
                38.871085
              ],
              [
                45.361714,
                38.8745864
              ],
              [
                45.3658796,
                38.8760891
              ],
              [
                45.3706478,
                38.877058
              ],
              [
                45.3765437,
                38.8780495
              ],
              [
                45.3822641,
                38.8797098
              ],
              [
                45.3866526,
                38.8808766
              ],
              [
                45.3884651,
                38.8811633
              ],
              [
                45.392166,
                38.8817658
              ],
              [
                45.3981223,
                38.882601
              ],
              [
                45.401801,
                38.8818322
              ],
              [
                45.4043487,
                38.8783719
              ],
              [
                45.4057849,
                38.873229
              ],
              [
                45.4062409,
                38.8681548
              ],
              [
                45.4060381,
                38.8588483
              ],
              [
                45.406596,
                38.855709
              ],
              [
                45.4086624,
                38.8524836
              ],
              [
                45.413403,
                38.8494431
              ],
              [
                45.4173313,
                38.8457117
              ],
              [
                45.4199027,
                38.8427678
              ],
              [
                45.4213919,
                38.8378583
              ],
              [
                45.4221874,
                38.8330457
              ],
              [
                45.4215746,
                38.8275369
              ],
              [
                45.4217108,
                38.8235884
              ],
              [
                45.4207959,
                38.8178156
              ],
              [
                45.4241088,
                38.8147302
              ],
              [
                45.4283765,
                38.8131266
              ],
              [
                45.4298579,
                38.8125487
              ],
              [
                45.4425385,
                38.8115728
              ],
              [
                45.4641927,
                38.8081539
              ],
              [
                45.4629043,
                38.8012434
              ],
              [
                45.4566578,
                38.7909871
              ],
              [
                45.4561594,
                38.7829619
              ],
              [
                45.4677238,
                38.7726343
              ],
              [
                45.472663,
                38.7679344
              ],
              [
                45.4751521,
                38.7653405
              ],
              [
                45.4849259,
                38.7579513
              ],
              [
                45.4877589,
                38.75664
              ],
              [
                45.4901804,
                38.7558368
              ],
              [
                45.4941905,
                38.7564832
              ],
              [
                45.4986902,
                38.7595954
              ],
              [
                45.5000264,
                38.7612725
              ],
              [
                45.5089668,
                38.7629378
              ],
              [
                45.5167463,
                38.7644102
              ],
              [
                45.5346107,
                38.7673841
              ],
              [
                45.5507842,
                38.7673276
              ],
              [
                45.5628309,
                38.7658093
              ],
              [
                45.5725701,
                38.7631657
              ],
              [
                45.5794131,
                38.7594113
              ],
              [
                45.5825652,
                38.7568346
              ],
              [
                45.5872634,
                38.7553935
              ],
              [
                45.600346,
                38.7577361
              ],
              [
                45.607681,
                38.7587172
              ],
              [
                45.610707,
                38.7591417
              ],
              [
                45.6181805,
                38.7600328
              ],
              [
                45.6257138,
                38.7621292
              ],
              [
                45.6314052,
                38.7639588
              ],
              [
                45.6464148,
                38.7675201
              ],
              [
                45.6538156,
                38.7684159
              ],
              [
                45.6605152,
                38.7693068
              ],
              [
                45.6726109,
                38.7695306
              ],
              [
                45.6810975,
                38.7681482
              ],
              [
                45.6887912,
                38.7675358
              ],
              [
                45.7024488,
                38.7634947
              ],
              [
                45.719039,
                38.7558794
              ],
              [
                45.7261317,
                38.7511061
              ],
              [
                45.7359961,
                38.7437319
              ],
              [
                45.7427104,
                38.7403459
              ],
              [
                45.7491611,
                38.7370134
              ],
              [
                45.782924,
                38.7399831
              ],
              [
                45.79825,
                38.7452099
              ],
              [
                45.8049611,
                38.74826
              ],
              [
                45.8092329,
                38.7530307
              ],
              [
                45.8140411,
                38.7553443
              ],
              [
                45.8188942,
                38.7551054
              ],
              [
                45.8256218,
                38.7552606
              ],
              [
                45.8302617,
                38.7583168
              ],
              [
                45.835154,
                38.763604
              ],
              [
                45.8378396,
                38.7645046
              ],
              [
                45.8451765,
                38.765151
              ],
              [
                45.8486908,
                38.7672253
              ],
              [
                45.8525888,
                38.7723187
              ],
              [
                45.8549601,
                38.7788869
              ],
              [
                45.8571472,
                38.7813854
              ],
              [
                45.8599238,
                38.7822552
              ],
              [
                45.873004,
                38.7807198
              ],
              [
                45.8846468,
                38.7702754
              ],
              [
                45.8879309,
                38.7671828
              ],
              [
                45.8902443,
                38.7652502
              ],
              [
                45.8921792,
                38.7632526
              ],
              [
                45.8979045,
                38.7600401
              ],
              [
                45.9032174,
                38.7575427
              ],
              [
                45.9108715,
                38.7556435
              ],
              [
                45.917508,
                38.7537126
              ],
              [
                45.9203567,
                38.7527803
              ],
              [
                45.9261939,
                38.7506613
              ],
              [
                45.9275132,
                38.7503229
              ],
              [
                45.9296107,
                38.7498328
              ],
              [
                45.9339135,
                38.7482122
              ],
              [
                45.9357325,
                38.7459027
              ],
              [
                45.9406185,
                38.7396241
              ],
              [
                45.9465765,
                38.732494
              ],
              [
                45.9546683,
                38.7218881
              ],
              [
                45.9641718,
                38.7105157
              ],
              [
                45.9666034,
                38.7080066
              ],
              [
                45.970348,
                38.7042391
              ],
              [
                45.9731129,
                38.7016087
              ],
              [
                45.9753483,
                38.6995115
              ],
              [
                45.9775539,
                38.6976531
              ],
              [
                45.9831727,
                38.6926689
              ],
              [
                45.9888254,
                38.687749
              ],
              [
                45.9928894,
                38.6851413
              ],
              [
                45.9941036,
                38.6845944
              ],
              [
                45.9973097,
                38.6831145
              ],
              [
                46.0002494,
                38.6823273
              ],
              [
                46.0055467,
                38.6793448
              ],
              [
                46.0100819,
                38.6759259
              ],
              [
                46.0141479,
                38.6705315
              ],
              [
                46.0156412,
                38.6654517
              ],
              [
                46.0153811,
                38.6595712
              ],
              [
                46.0181029,
                38.6546414
              ],
              [
                46.0205489,
                38.6528492
              ],
              [
                46.0223041,
                38.6516262
              ],
              [
                46.0257351,
                38.6500332
              ],
              [
                46.0271603,
                38.6494198
              ],
              [
                46.027832,
                38.6490714
              ],
              [
                46.0328775,
                38.6480062
              ],
              [
                46.0370684,
                38.6498129
              ],
              [
                46.0413724,
                38.6530865
              ],
              [
                46.0495376,
                38.6580352
              ],
              [
                46.0563877,
                38.6643298
              ],
              [
                46.0629972,
                38.672444
              ],
              [
                46.0652683,
                38.6793443
              ],
              [
                46.0660656,
                38.6856997
              ],
              [
                46.06467,
                38.6900826
              ],
              [
                46.0637068,
                38.6933973
              ],
              [
                46.0659202,
                38.6985911
              ],
              [
                46.0672991,
                38.7023601
              ],
              [
                46.0701331,
                38.7067822
              ],
              [
                46.0718462,
                38.7093481
              ],
              [
                46.0760701,
                38.7156872
              ],
              [
                46.0780563,
                38.718487
              ],
              [
                46.0840257,
                38.7258272
              ],
              [
                46.0920269,
                38.7338725
              ],
              [
                46.10118,
                38.7394389
              ],
              [
                46.1154471,
                38.7435053
              ],
              [
                46.1303753,
                38.7504672
              ],
              [
                46.1375631,
                38.7539689
              ],
              [
                46.1519266,
                38.7609524
              ],
              [
                46.162201,
                38.7650794
              ],
              [
                46.167396,
                38.766731
              ],
              [
                46.1698842,
                38.7670849
              ],
              [
                46.173445,
                38.7657888
              ],
              [
                46.1777796,
                38.763839
              ],
              [
                46.1824187,
                38.761917
              ],
              [
                46.1983577,
                38.7562949
              ],
              [
                46.2075152,
                38.7535237
              ],
              [
                46.2196934,
                38.7519064
              ],
              [
                46.2349273,
                38.7511701
              ],
              [
                46.2448475,
                38.7516236
              ],
              [
                46.2498284,
                38.7522617
              ],
              [
                46.2679047,
                38.7518555
              ],
              [
                46.2852584,
                38.7522935
              ],
              [
                46.2999965,
                38.7534313
              ],
              [
                46.3147214,
                38.7548615
              ],
              [
                46.3333494,
                38.7586098
              ],
              [
                46.3490556,
                38.7637906
              ],
              [
                46.3541404,
                38.7667975
              ],
              [
                46.3579024,
                38.7708797
              ],
              [
                46.3587279,
                38.7762982
              ],
              [
                46.3609313,
                38.7811196
              ],
              [
                46.3642787,
                38.7843981
              ],
              [
                46.367197,
                38.7858031
              ],
              [
                46.3710593,
                38.78587
              ],
              [
                46.3775825,
                38.7843981
              ],
              [
                46.3939036,
                38.7765889
              ],
              [
                46.4017704,
                38.7722677
              ],
              [
                46.4194078,
                38.7650403
              ],
              [
                46.4288904,
                38.762173
              ],
              [
                46.4382148,
                38.7681607
              ],
              [
                46.4576593,
                38.783277
              ],
              [
                46.4704671,
                38.7927997
              ],
              [
                46.481524,
                38.7997694
              ],
              [
                46.4900851,
                38.8055502
              ],
              [
                46.5006169,
                38.8121366
              ],
              [
                46.5066861,
                38.8200478
              ],
              [
                46.5073756,
                38.828348
              ],
              [
                46.5042909,
                38.8368193
              ],
              [
                46.5028646,
                38.843498
              ],
              [
                46.4999739,
                38.8590224
              ],
              [
                46.4976594,
                38.8780847
              ],
              [
                46.5193535,
                38.8811667
              ],
              [
                46.5220017,
                38.8846994
              ],
              [
                46.5243816,
                38.8883123
              ],
              [
                46.5225997,
                38.8889067
              ],
              [
                46.5194821,
                38.8890119
              ],
              [
                46.5172934,
                38.8889034
              ],
              [
                46.5144017,
                38.8887828
              ],
              [
                46.5120488,
                38.8879839
              ],
              [
                46.5093541,
                38.8872248
              ],
              [
                46.5079759,
                38.8865829
              ],
              [
                46.5065282,
                38.8854024
              ],
              [
                46.5052613,
                38.8852319
              ],
              [
                46.5043116,
                38.8855629
              ],
              [
                46.5026036,
                38.887245
              ],
              [
                46.5007603,
                38.8888199
              ],
              [
                46.498775,
                38.8895891
              ],
              [
                46.4981425,
                38.8897886
              ],
              [
                46.491463,
                38.8892616
              ],
              [
                46.4913765,
                38.8892334
              ],
              [
                46.4907879,
                38.8890412
              ],
              [
                46.4901686,
                38.8886787
              ],
              [
                46.4894843,
                38.8877092
              ],
              [
                46.489259,
                38.887016
              ],
              [
                46.489114,
                38.8865093
              ],
              [
                46.4889739,
                38.8861054
              ],
              [
                46.4884436,
                38.8861225
              ],
              [
                46.4866412,
                38.8861642
              ],
              [
                46.485343,
                38.8856548
              ],
              [
                46.4834821,
                38.8853672
              ],
              [
                46.4821436,
                38.8859532
              ],
              [
                46.4802843,
                38.8874211
              ],
              [
                46.4782709,
                38.8887602
              ],
              [
                46.4748824,
                38.8898428
              ],
              [
                46.4738614,
                38.8900742
              ],
              [
                46.4723752,
                38.889413
              ],
              [
                46.4704127,
                38.8890707
              ],
              [
                46.4692503,
                38.889018
              ],
              [
                46.4681715,
                38.8889326
              ],
              [
                46.4665067,
                38.8884814
              ],
              [
                46.4659399,
                38.8884482
              ],
              [
                46.4652801,
                38.8885808
              ],
              [
                46.4641857,
                38.8899138
              ],
              [
                46.4635282,
                38.8914723
              ],
              [
                46.4620711,
                38.8933478
              ],
              [
                46.4618355,
                38.8935776
              ],
              [
                46.4612353,
                38.8936549
              ],
              [
                46.4607608,
                38.8940159
              ],
              [
                46.4593433,
                38.894597
              ],
              [
                46.4587247,
                38.895158
              ],
              [
                46.4584458,
                38.8959429
              ],
              [
                46.4581907,
                38.8971694
              ],
              [
                46.4566175,
                38.8981941
              ],
              [
                46.4550662,
                38.8987986
              ],
              [
                46.4534998,
                38.8990073
              ],
              [
                46.4528212,
                38.8987104
              ],
              [
                46.4514184,
                38.8977047
              ],
              [
                46.4507532,
                38.8972079
              ],
              [
                46.4499736,
                38.8970283
              ],
              [
                46.4465829,
                38.8975799
              ],
              [
                46.4455227,
                38.8972803
              ],
              [
                46.4438653,
                38.8973874
              ],
              [
                46.4430714,
                38.8973457
              ],
              [
                46.4420307,
                38.8968697
              ],
              [
                46.4415264,
                38.8961433
              ],
              [
                46.441256,
                38.8951351
              ],
              [
                46.4405328,
                38.8947248
              ],
              [
                46.4395845,
                38.8944482
              ],
              [
                46.4382457,
                38.8945469
              ],
              [
                46.4367467,
                38.8950452
              ],
              [
                46.4352822,
                38.8952248
              ],
              [
                46.4329326,
                38.894849
              ],
              [
                46.4315929,
                38.8945492
              ],
              [
                46.430937,
                38.8944649
              ],
              [
                46.4301216,
                38.8935965
              ],
              [
                46.4296281,
                38.8932458
              ],
              [
                46.4290917,
                38.8925777
              ],
              [
                46.4273,
                38.8920349
              ],
              [
                46.4268058,
                38.8914883
              ],
              [
                46.4262014,
                38.8904049
              ],
              [
                46.4263454,
                38.8883599
              ],
              [
                46.4250076,
                38.8855468
              ],
              [
                46.4238762,
                38.8844082
              ],
              [
                46.4225934,
                38.883218
              ],
              [
                46.4210438,
                38.8830219
              ],
              [
                46.4197563,
                38.8833559
              ],
              [
                46.418185,
                38.8844625
              ],
              [
                46.4167455,
                38.8866249
              ],
              [
                46.4164304,
                38.8878657
              ],
              [
                46.4163605,
                38.8882836
              ],
              [
                46.416248,
                38.8889555
              ],
              [
                46.4166541,
                38.8907556
              ],
              [
                46.4164036,
                38.8921956
              ],
              [
                46.4161322,
                38.8925719
              ],
              [
                46.4150786,
                38.8928761
              ],
              [
                46.413598,
                38.8930097
              ],
              [
                46.4103513,
                38.8932787
              ],
              [
                46.4091358,
                38.894173
              ],
              [
                46.4041903,
                38.8979772
              ],
              [
                46.4028565,
                38.8996405
              ],
              [
                46.4012043,
                38.9004693
              ],
              [
                46.3975396,
                38.9023077
              ],
              [
                46.3943455,
                38.9036707
              ],
              [
                46.3939494,
                38.904138
              ],
              [
                46.3933432,
                38.9042466
              ],
              [
                46.3918119,
                38.9041438
              ],
              [
                46.3897705,
                38.9050272
              ],
              [
                46.3889904,
                38.9054708
              ],
              [
                46.3878013,
                38.905795
              ],
              [
                46.3840948,
                38.9064098
              ],
              [
                46.3831018,
                38.9064534
              ],
              [
                46.382529,
                38.9064785
              ],
              [
                46.3818458,
                38.9064358
              ],
              [
                46.3807865,
                38.9063696
              ],
              [
                46.3774222,
                38.9069766
              ],
              [
                46.374243,
                38.9081569
              ],
              [
                46.3711901,
                38.9090107
              ],
              [
                46.369077,
                38.9097007
              ],
              [
                46.3682945,
                38.9106479
              ],
              [
                46.3682052,
                38.9120058
              ],
              [
                46.3681786,
                38.9124097
              ],
              [
                46.3657828,
                38.9142157
              ],
              [
                46.3648847,
                38.9149137
              ],
              [
                46.3632197,
                38.9163092
              ],
              [
                46.3619518,
                38.9163349
              ],
              [
                46.3595773,
                38.9151162
              ],
              [
                46.3588545,
                38.9150537
              ],
              [
                46.3568537,
                38.916409
              ],
              [
                46.3533479,
                38.9167606
              ],
              [
                46.3505824,
                38.9165906
              ],
              [
                46.3461404,
                38.9168198
              ],
              [
                46.3453843,
                38.9166828
              ],
              [
                46.3392587,
                38.9163631
              ],
              [
                46.3368347,
                38.9154026
              ],
              [
                46.3360524,
                38.9136629
              ],
              [
                46.3357656,
                38.9130251
              ],
              [
                46.3363473,
                38.9117424
              ],
              [
                46.3358569,
                38.9104609
              ],
              [
                46.3336282,
                38.9092444
              ],
              [
                46.3298321,
                38.9086945
              ],
              [
                46.3277395,
                38.9081518
              ],
              [
                46.3266091,
                38.9071172
              ],
              [
                46.321343,
                38.9035617
              ],
              [
                46.31949,
                38.9025689
              ],
              [
                46.3190224,
                38.9023183
              ],
              [
                46.3173615,
                38.901543
              ],
              [
                46.3160419,
                38.9014004
              ],
              [
                46.3156705,
                38.9014708
              ],
              [
                46.3135242,
                38.9018779
              ],
              [
                46.3094577,
                38.9035316
              ],
              [
                46.3078233,
                38.9045714
              ],
              [
                46.3057519,
                38.9058891
              ],
              [
                46.303102,
                38.9063377
              ],
              [
                46.302099,
                38.9059511
              ],
              [
                46.3016702,
                38.9055229
              ],
              [
                46.3009491,
                38.9023984
              ],
              [
                46.300241,
                38.9014733
              ],
              [
                46.2979311,
                38.9003082
              ],
              [
                46.2962161,
                38.9001765
              ],
              [
                46.293548,
                38.9010681
              ],
              [
                46.2920613,
                38.8999861
              ],
              [
                46.2912605,
                38.8998203
              ],
              [
                46.2896044,
                38.9004666
              ],
              [
                46.2883862,
                38.9008216
              ],
              [
                46.2860078,
                38.9008903
              ],
              [
                46.2858593,
                38.9008946
              ],
              [
                46.2832922,
                38.900504
              ],
              [
                46.282509,
                38.9002305
              ],
              [
                46.2787282,
                38.8979747
              ],
              [
                46.2774646,
                38.8955964
              ],
              [
                46.276353,
                38.8957128
              ],
              [
                46.271982,
                38.8953511
              ],
              [
                46.2704417,
                38.8939738
              ],
              [
                46.2691042,
                38.8938219
              ],
              [
                46.2670688,
                38.8929759
              ],
              [
                46.2666294,
                38.8918514
              ],
              [
                46.2670106,
                38.8886505
              ],
              [
                46.2670636,
                38.8882705
              ],
              [
                46.2671541,
                38.8876217
              ],
              [
                46.2670077,
                38.8872764
              ],
              [
                46.2668368,
                38.887071
              ],
              [
                46.2664811,
                38.8866402
              ],
              [
                46.262686,
                38.8848307
              ],
              [
                46.2599684,
                38.884357
              ],
              [
                46.2579588,
                38.8819884
              ],
              [
                46.2558355,
                38.8813551
              ],
              [
                46.2533191,
                38.8803027
              ],
              [
                46.2496221,
                38.8780127
              ],
              [
                46.2488752,
                38.8756364
              ],
              [
                46.2478026,
                38.8740488
              ],
              [
                46.2438071,
                38.8725932
              ],
              [
                46.2404416,
                38.8718008
              ],
              [
                46.2360896,
                38.8691662
              ],
              [
                46.2338341,
                38.8687666
              ],
              [
                46.231933,
                38.8683514
              ],
              [
                46.230772,
                38.8668896
              ],
              [
                46.2285717,
                38.8663465
              ],
              [
                46.2266131,
                38.8663651
              ],
              [
                46.2241831,
                38.8661199
              ],
              [
                46.2187294,
                38.8652316
              ],
              [
                46.2162251,
                38.8643871
              ],
              [
                46.2161933,
                38.8624375
              ],
              [
                46.2157095,
                38.8611697
              ],
              [
                46.2147846,
                38.8585362
              ],
              [
                46.2147646,
                38.8581705
              ],
              [
                46.2146201,
                38.8557027
              ],
              [
                46.2118933,
                38.8539579
              ],
              [
                46.2104637,
                38.8539939
              ],
              [
                46.2094129,
                38.8537584
              ],
              [
                46.2078078,
                38.8533086
              ],
              [
                46.2064965,
                38.8528824
              ],
              [
                46.2027699,
                38.8516713
              ],
              [
                46.2017895,
                38.8517075
              ],
              [
                46.1956887,
                38.8523923
              ],
              [
                46.1935851,
                38.8519199
              ],
              [
                46.1918934,
                38.8508804
              ],
              [
                46.1913604,
                38.848739
              ],
              [
                46.1903903,
                38.8469486
              ],
              [
                46.1869987,
                38.843148
              ],
              [
                46.1841363,
                38.8414876
              ],
              [
                46.1817758,
                38.8407564
              ],
              [
                46.1782862,
                38.8407632
              ],
              [
                46.175674,
                38.8405526
              ],
              [
                46.173374,
                38.8404775
              ],
              [
                46.1710533,
                38.8415986
              ],
              [
                46.1696737,
                38.8422269
              ],
              [
                46.1676286,
                38.8425622
              ],
              [
                46.1660426,
                38.8430156
              ],
              [
                46.1645218,
                38.8427802
              ],
              [
                46.1623533,
                38.8419916
              ],
              [
                46.161411,
                38.8411987
              ],
              [
                46.1597595,
                38.8411961
              ],
              [
                46.1586828,
                38.8414973
              ],
              [
                46.1577035,
                38.8419823
              ],
              [
                46.1559717,
                38.8428203
              ],
              [
                46.1544234,
                38.8432223
              ],
              [
                46.1528391,
                38.8423044
              ],
              [
                46.1508207,
                38.8417069
              ],
              [
                46.1476006,
                38.8418111
              ],
              [
                46.1449527,
                38.8421851
              ],
              [
                46.1406764,
                38.8445178
              ],
              [
                46.1364163,
                38.8468745
              ],
              [
                46.1354777,
                38.8467589
              ],
              [
                46.1301808,
                38.8462261
              ],
              [
                46.1291369,
                38.8464012
              ],
              [
                46.1284484,
                38.847192
              ],
              [
                46.128913,
                38.8495651
              ],
              [
                46.1281172,
                38.8511058
              ],
              [
                46.1235569,
                38.8531072
              ],
              [
                46.1216772,
                38.8547768
              ],
              [
                46.1186829,
                38.8560278
              ],
              [
                46.1172168,
                38.856445
              ],
              [
                46.1153831,
                38.8574044
              ],
              [
                46.1142623,
                38.8585939
              ],
              [
                46.1128228,
                38.858341
              ],
              [
                46.1117495,
                38.8583846
              ],
              [
                46.1114506,
                38.8589393
              ],
              [
                46.1130563,
                38.8626522
              ],
              [
                46.1131494,
                38.8637454
              ],
              [
                46.1121896,
                38.8650738
              ],
              [
                46.1104437,
                38.8658321
              ],
              [
                46.1037838,
                38.8669639
              ],
              [
                46.1018815,
                38.8666432
              ],
              [
                46.0987769,
                38.8671718
              ],
              [
                46.0971842,
                38.8671078
              ],
              [
                46.0951957,
                38.8668311
              ],
              [
                46.0930324,
                38.8672867
              ],
              [
                46.0910885,
                38.8685846
              ],
              [
                46.0863366,
                38.8698909
              ],
              [
                46.0827539,
                38.8711645
              ],
              [
                46.0804348,
                38.8714615
              ],
              [
                46.0792422,
                38.8724573
              ],
              [
                46.0778614,
                38.8741276
              ],
              [
                46.0755056,
                38.8758005
              ],
              [
                46.0724386,
                38.8773235
              ],
              [
                46.0712649,
                38.8784194
              ],
              [
                46.0690309,
                38.8824594
              ],
              [
                46.06761,
                38.885657
              ],
              [
                46.0670219,
                38.8869124
              ],
              [
                46.0654204,
                38.8874386
              ],
              [
                46.0628381,
                38.8877486
              ],
              [
                46.0606153,
                38.8875446
              ],
              [
                46.058888,
                38.8877766
              ],
              [
                46.0562041,
                38.8856649
              ],
              [
                46.0555085,
                38.8848686
              ],
              [
                46.0546186,
                38.8843128
              ],
              [
                46.0542577,
                38.8837144
              ],
              [
                46.0542839,
                38.8815938
              ],
              [
                46.0547886,
                38.8804538
              ],
              [
                46.0545168,
                38.8787658
              ],
              [
                46.0541375,
                38.8780497
              ],
              [
                46.0518492,
                38.8761008
              ],
              [
                46.0488935,
                38.8749851
              ],
              [
                46.0468369,
                38.874706
              ],
              [
                46.0446455,
                38.8738931
              ],
              [
                46.0436448,
                38.8734266
              ],
              [
                46.0415763,
                38.8719227
              ],
              [
                46.0409451,
                38.871789
              ],
              [
                46.040357,
                38.8718666
              ],
              [
                46.0379306,
                38.8726924
              ],
              [
                46.034476,
                38.8747593
              ],
              [
                46.0326504,
                38.8750095
              ],
              [
                46.0290652,
                38.8745452
              ],
              [
                46.028199,
                38.8742733
              ],
              [
                46.0278359,
                38.8739387
              ],
              [
                46.0274223,
                38.8725664
              ],
              [
                46.0245089,
                38.872378
              ],
              [
                46.0200541,
                38.8736158
              ],
              [
                46.0156497,
                38.8736581
              ],
              [
                46.0119036,
                38.8719802
              ],
              [
                46.0062956,
                38.8723619
              ],
              [
                46.0040135,
                38.8730733
              ],
              [
                45.9996589,
                38.8753441
              ],
              [
                45.9977188,
                38.8754711
              ],
              [
                45.994545,
                38.8748504
              ],
              [
                45.9877911,
                38.8759636
              ],
              [
                45.979187,
                38.8788158
              ],
              [
                45.975994,
                38.8808698
              ],
              [
                45.9729251,
                38.8839337
              ],
              [
                45.9681829,
                38.8870769
              ],
              [
                45.9677169,
                38.8878839
              ],
              [
                45.9673985,
                38.8896198
              ],
              [
                45.9667606,
                38.8901154
              ],
              [
                45.9644781,
                38.89066
              ],
              [
                45.9626366,
                38.890382
              ],
              [
                45.959927,
                38.8888703
              ],
              [
                45.9580632,
                38.8886164
              ],
              [
                45.9561369,
                38.88925
              ],
              [
                45.9472825,
                38.8950688
              ],
              [
                45.9455251,
                38.8957305
              ],
              [
                45.9445223,
                38.8965928
              ],
              [
                45.9435292,
                38.896398
              ],
              [
                45.9423372,
                38.89541
              ],
              [
                45.9417497,
                38.8940663
              ],
              [
                45.9342371,
                38.8894642
              ],
              [
                45.930471,
                38.8861348
              ],
              [
                45.9286317,
                38.8833482
              ],
              [
                45.9289272,
                38.8825187
              ],
              [
                45.9283938,
                38.8808975
              ],
              [
                45.9279565,
                38.8795686
              ],
              [
                45.9275699,
                38.8790766
              ],
              [
                45.9266648,
                38.8778907
              ],
              [
                45.9251893,
                38.8772071
              ],
              [
                45.9238704,
                38.8765574
              ],
              [
                45.9222377,
                38.8754702
              ],
              [
                45.9221466,
                38.8754162
              ],
              [
                45.9198348,
                38.8740443
              ],
              [
                45.9190602,
                38.8735846
              ],
              [
                45.9178801,
                38.8733221
              ],
              [
                45.9124279,
                38.8746039
              ],
              [
                45.9102916,
                38.8739433
              ],
              [
                45.9087076,
                38.8739169
              ],
              [
                45.9038441,
                38.8777271
              ],
              [
                45.9004192,
                38.8775724
              ],
              [
                45.898829,
                38.8770517
              ],
              [
                45.8973636,
                38.8765718
              ],
              [
                45.8953641,
                38.8764066
              ],
              [
                45.8940243,
                38.8766728
              ],
              [
                45.8939065,
                38.8767793
              ],
              [
                45.8922881,
                38.8782419
              ],
              [
                45.892105,
                38.8784074
              ],
              [
                45.8912751,
                38.8814177
              ],
              [
                45.8915728,
                38.8833575
              ],
              [
                45.8904347,
                38.8848101
              ],
              [
                45.885314,
                38.8862172
              ],
              [
                45.8823295,
                38.8865427
              ],
              [
                45.8808493,
                38.8884318
              ],
              [
                45.8795807,
                38.8892032
              ],
              [
                45.8757342,
                38.8897957
              ],
              [
                45.8735291,
                38.8891079
              ],
              [
                45.871333,
                38.8887123
              ],
              [
                45.8692518,
                38.8885515
              ],
              [
                45.8684468,
                38.889006
              ],
              [
                45.8650175,
                38.8915492
              ],
              [
                45.8608606,
                38.8930754
              ],
              [
                45.8603997,
                38.8937478
              ],
              [
                45.861601,
                38.8954243
              ],
              [
                45.862065,
                38.8971194
              ],
              [
                45.86413,
                38.8991991
              ],
              [
                45.8640587,
                38.9003033
              ],
              [
                45.8612544,
                38.9034596
              ],
              [
                45.8576532,
                38.9046213
              ],
              [
                45.8560747,
                38.9060757
              ],
              [
                45.8517853,
                38.9083948
              ],
              [
                45.8493614,
                38.9095575
              ],
              [
                45.8467457,
                38.910444
              ],
              [
                45.844416,
                38.9107035
              ],
              [
                45.8430723,
                38.9102715
              ],
              [
                45.8393831,
                38.9079954
              ],
              [
                45.8352172,
                38.9049677
              ],
              [
                45.83327,
                38.9026563
              ],
              [
                45.8321366,
                38.9023566
              ],
              [
                45.830335,
                38.9024718
              ],
              [
                45.8267452,
                38.9023752
              ],
              [
                45.82346,
                38.9039028
              ],
              [
                45.8218016,
                38.9049816
              ],
              [
                45.8200469,
                38.9054862
              ],
              [
                45.8152735,
                38.9052549
              ],
              [
                45.8137932,
                38.9060087
              ],
              [
                45.8122977,
                38.907104
              ],
              [
                45.8119384,
                38.9081011
              ],
              [
                45.8118074,
                38.9091544
              ],
              [
                45.8119303,
                38.9105338
              ],
              [
                45.8111467,
                38.9120004
              ],
              [
                45.8062037,
                38.9135085
              ],
              [
                45.805287,
                38.9140772
              ],
              [
                45.8036461,
                38.9141158
              ],
              [
                45.8024327,
                38.9134028
              ],
              [
                45.8013015,
                38.913365
              ],
              [
                45.7998297,
                38.9150389
              ],
              [
                45.7997838,
                38.9180359
              ],
              [
                45.8007719,
                38.9193387
              ],
              [
                45.8010689,
                38.9204
              ],
              [
                45.8009083,
                38.9218734
              ],
              [
                45.7987254,
                38.9245543
              ],
              [
                45.7979968,
                38.9249278
              ],
              [
                45.7941264,
                38.9244456
              ],
              [
                45.7917567,
                38.9236915
              ],
              [
                45.7901506,
                38.9222045
              ],
              [
                45.7885289,
                38.9207032
              ],
              [
                45.7864352,
                38.9195238
              ],
              [
                45.785821,
                38.9194587
              ],
              [
                45.7853007,
                38.9198983
              ],
              [
                45.7861729,
                38.9229394
              ],
              [
                45.7856739,
                38.9243673
              ],
              [
                45.7841797,
                38.9251816
              ],
              [
                45.7822494,
                38.9256294
              ],
              [
                45.7768698,
                38.9234187
              ],
              [
                45.7745216,
                38.9233469
              ],
              [
                45.7724338,
                38.9236948
              ],
              [
                45.7684929,
                38.9253917
              ],
              [
                45.766781,
                38.9271553
              ],
              [
                45.7637848,
                38.929009
              ],
              [
                45.7627509,
                38.9292503
              ],
              [
                45.7616364,
                38.9291846
              ],
              [
                45.7597116,
                38.9286727
              ],
              [
                45.758327,
                38.9284652
              ],
              [
                45.7569697,
                38.9286514
              ],
              [
                45.7535696,
                38.9289354
              ],
              [
                45.736821,
                38.9275348
              ],
              [
                45.7356,
                38.9279836
              ],
              [
                45.7321303,
                38.9307798
              ],
              [
                45.7303488,
                38.9314572
              ],
              [
                45.7255194,
                38.9321637
              ],
              [
                45.7234149,
                38.9336337
              ],
              [
                45.7216312,
                38.9354682
              ],
              [
                45.7174335,
                38.9364822
              ],
              [
                45.7132097,
                38.9394462
              ],
              [
                45.7101704,
                38.9449647
              ],
              [
                45.7093961,
                38.945086
              ],
              [
                45.7041117,
                38.9438245
              ],
              [
                45.7017946,
                38.9436372
              ],
              [
                45.6988577,
                38.9442388
              ],
              [
                45.6978175,
                38.9450685
              ],
              [
                45.6967022,
                38.9480755
              ],
              [
                45.6961922,
                38.950327
              ],
              [
                45.6924464,
                38.9514945
              ],
              [
                45.690013,
                38.9514056
              ],
              [
                45.6842876,
                38.9490936
              ],
              [
                45.6793462,
                38.9465584
              ],
              [
                45.678701,
                38.9464488
              ],
              [
                45.6780987,
                38.9465839
              ],
              [
                45.6771362,
                38.9479881
              ],
              [
                45.6759501,
                38.9490045
              ],
              [
                45.6752965,
                38.949443
              ],
              [
                45.6739215,
                38.9495647
              ],
              [
                45.6725092,
                38.9491122
              ],
              [
                45.670521,
                38.9471515
              ],
              [
                45.6700803,
                38.9470146
              ],
              [
                45.6693909,
                38.9468005
              ],
              [
                45.6686719,
                38.9469743
              ],
              [
                45.6677114,
                38.9472064
              ],
              [
                45.6634872,
                38.950588
              ],
              [
                45.660556,
                38.9517049
              ],
              [
                45.6552268,
                38.9518252
              ],
              [
                45.6501931,
                38.9513683
              ],
              [
                45.647385,
                38.9518779
              ],
              [
                45.6461949,
                38.9515358
              ],
              [
                45.6451083,
                38.9475088
              ],
              [
                45.6443865,
                38.9463939
              ],
              [
                45.6421623,
                38.9472251
              ],
              [
                45.6385911,
                38.9469864
              ],
              [
                45.6370793,
                38.9466514
              ],
              [
                45.6356111,
                38.9454555
              ],
              [
                45.6334874,
                38.9447496
              ],
              [
                45.6299422,
                38.9446953
              ],
              [
                45.6266648,
                38.9436702
              ],
              [
                45.6183144,
                38.9426502
              ],
              [
                45.6158711,
                38.9414165
              ],
              [
                45.6152749,
                38.9415467
              ],
              [
                45.6147172,
                38.941661
              ],
              [
                45.6145737,
                38.9416943
              ],
              [
                45.6140798,
                38.9425109
              ],
              [
                45.6162879,
                38.9464809
              ],
              [
                45.6163367,
                38.9481484
              ],
              [
                45.6147663,
                38.952512
              ],
              [
                45.6147743,
                38.954721
              ],
              [
                45.6144147,
                38.9563456
              ],
              [
                45.6130813,
                38.9578852
              ],
              [
                45.6124994,
                38.9581083
              ],
              [
                45.6118125,
                38.9579732
              ],
              [
                45.6110367,
                38.9568577
              ],
              [
                45.6102487,
                38.956245
              ],
              [
                45.6093557,
                38.9561696
              ],
              [
                45.6073515,
                38.9567509
              ],
              [
                45.6055737,
                38.9578489
              ],
              [
                45.603413,
                38.9592524
              ],
              [
                45.6029076,
                38.9604547
              ],
              [
                45.6007733,
                38.9617761
              ],
              [
                45.5951445,
                38.9622535
              ],
              [
                45.5928433,
                38.9632642
              ],
              [
                45.5911856,
                38.9644915
              ],
              [
                45.5853422,
                38.9672141
              ],
              [
                45.5841409,
                38.9693805
              ],
              [
                45.5838549,
                38.9717955
              ],
              [
                45.5843135,
                38.9761121
              ],
              [
                45.5835793,
                38.977269
              ],
              [
                45.5818975,
                38.978503
              ],
              [
                45.580174,
                38.9789688
              ],
              [
                45.5778086,
                38.9786447
              ],
              [
                45.5702203,
                38.9761019
              ],
              [
                45.5692938,
                38.9760695
              ],
              [
                45.5684944,
                38.9755344
              ],
              [
                45.5673363,
                38.9738216
              ],
              [
                45.5660987,
                38.9711706
              ],
              [
                45.5663613,
                38.9705931
              ],
              [
                45.5656763,
                38.9690676
              ],
              [
                45.5634456,
                38.9682605
              ],
              [
                45.5624929,
                38.9689215
              ],
              [
                45.5585236,
                38.9681513
              ],
              [
                45.5576438,
                38.9678045
              ],
              [
                45.5531415,
                38.9644899
              ],
              [
                45.5508721,
                38.9640201
              ],
              [
                45.5495158,
                38.9641164
              ],
              [
                45.5481452,
                38.965025
              ],
              [
                45.546695,
                38.9654361
              ],
              [
                45.5450956,
                38.9655026
              ],
              [
                45.5439576,
                38.9645904
              ],
              [
                45.5415028,
                38.9648285
              ],
              [
                45.5372482,
                38.9664181
              ],
              [
                45.5357426,
                38.9680809
              ],
              [
                45.5356521,
                38.9688668
              ],
              [
                45.5342739,
                38.9698785
              ],
              [
                45.5322152,
                38.9703529
              ],
              [
                45.5306669,
                38.9696847
              ],
              [
                45.5291658,
                38.9698331
              ],
              [
                45.5277553,
                38.9715283
              ],
              [
                45.5263299,
                38.9719121
              ],
              [
                45.5250186,
                38.9718084
              ],
              [
                45.5232969,
                38.9723617
              ],
              [
                45.5215983,
                38.9741336
              ],
              [
                45.5204504,
                38.974591
              ],
              [
                45.514872,
                38.9760075
              ],
              [
                45.512366,
                38.9770595
              ],
              [
                45.5092522,
                38.9785633
              ],
              [
                45.5081919,
                38.9788588
              ],
              [
                45.5067759,
                38.9793378
              ],
              [
                45.5064081,
                38.9804888
              ],
              [
                45.5050149,
                38.9806658
              ],
              [
                45.5043888,
                38.9804389
              ],
              [
                45.5036668,
                38.9802789
              ],
              [
                45.5029716,
                38.9803512
              ],
              [
                45.5019754,
                38.9807008
              ],
              [
                45.5007862,
                38.9818621
              ],
              [
                45.5008102,
                38.9830817
              ],
              [
                45.4983923,
                38.9840775
              ],
              [
                45.4973399,
                38.9841618
              ],
              [
                45.4957085,
                38.9839449
              ],
              [
                45.4939766,
                38.9832525
              ],
              [
                45.4932969,
                38.9832378
              ],
              [
                45.4907466,
                38.9841688
              ],
              [
                45.4892007,
                38.9848425
              ],
              [
                45.4868096,
                38.9866546
              ],
              [
                45.4825803,
                38.9865989
              ],
              [
                45.4802459,
                38.9861774
              ],
              [
                45.4776419,
                38.9863391
              ],
              [
                45.4724097,
                38.9897452
              ],
              [
                45.4708896,
                38.9890138
              ],
              [
                45.4685871,
                38.989138
              ],
              [
                45.4644005,
                38.9899667
              ],
              [
                45.4620447,
                38.9899853
              ],
              [
                45.4590372,
                38.990321
              ],
              [
                45.4579998,
                38.9901077
              ],
              [
                45.4549509,
                38.9905356
              ],
              [
                45.4542424,
                38.9913843
              ],
              [
                45.4535963,
                38.9926547
              ],
              [
                45.4529047,
                38.9929965
              ],
              [
                45.4501334,
                38.9906022
              ],
              [
                45.44958,
                38.9903245
              ],
              [
                45.4431901,
                38.9844938
              ],
              [
                45.4420768,
                38.9842158
              ],
              [
                45.4358284,
                38.9806241
              ],
              [
                45.4286055,
                38.9772869
              ],
              [
                45.428329,
                38.9767307
              ],
              [
                45.4234505,
                38.9752265
              ],
              [
                45.4197488,
                38.9748929
              ],
              [
                45.4194722,
                38.9746149
              ],
              [
                45.4158589,
                38.9746148
              ],
              [
                45.4114158,
                38.9740586
              ],
              [
                45.4042971,
                38.9733794
              ],
              [
                45.4037439,
                38.9731103
              ],
              [
                45.4006876,
                38.9731103
              ],
              [
                45.399854,
                38.9728322
              ],
              [
                45.398464,
                38.9728322
              ],
              [
                45.3976305,
                38.9725542
              ],
              [
                45.3962446,
                38.9725541
              ],
              [
                45.393464,
                38.9714418
              ],
              [
                45.3926311,
                38.9714417
              ],
              [
                45.391521,
                38.9708856
              ],
              [
                45.3840208,
                38.9656019
              ],
              [
                45.3779074,
                38.9625519
              ],
              [
                45.3763279,
                38.9609946
              ],
              [
                45.3754943,
                38.959335
              ],
              [
                45.3706167,
                38.947795
              ],
              [
                45.362377,
                38.9441903
              ],
              [
                45.3577421,
                38.918418
              ],
              [
                45.3493307,
                38.9146782
              ],
              [
                45.3458975,
                38.90466
              ],
              [
                45.3414343,
                38.8997172
              ],
              [
                45.3417134,
                38.8956119
              ],
              [
                45.3362203,
                38.8883082
              ],
              [
                45.3362203,
                38.8877516
              ],
              [
                45.3198117,
                38.8836864
              ],
              [
                45.3063601,
                38.8778739
              ],
              [
                45.3063601,
                38.8773172
              ],
              [
                45.2815158,
                38.8736622
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554988,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خداآفرین",
          "name:en": "Khoda Afarin County",
          "name:ru": "Ходафарин",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4808745",
          "wikipedia": "en:Khoda Afarin County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.4288904,
                38.762173
              ],
              [
                46.4390905,
                38.7597426
              ],
              [
                46.4545091,
                38.7585945
              ],
              [
                46.4627087,
                38.7580924
              ],
              [
                46.4695704,
                38.7574461
              ],
              [
                46.4725343,
                38.7566868
              ],
              [
                46.4753642,
                38.756051
              ],
              [
                46.4797639,
                38.753347
              ],
              [
                46.4823818,
                38.75077
              ],
              [
                46.4830255,
                38.748059
              ],
              [
                46.4828109,
                38.7476908
              ],
              [
                46.4867934,
                38.7481317
              ],
              [
                46.4940007,
                38.7504076
              ],
              [
                46.4983005,
                38.7532149
              ],
              [
                46.5002246,
                38.7536039
              ],
              [
                46.5047711,
                38.7559467
              ],
              [
                46.5099673,
                38.7583432
              ],
              [
                46.5127924,
                38.7593805
              ],
              [
                46.518671,
                38.7605289
              ],
              [
                46.5248124,
                38.7609974
              ],
              [
                46.5294908,
                38.7603661
              ],
              [
                46.5337147,
                38.7594312
              ],
              [
                46.5371003,
                38.7574128
              ],
              [
                46.5408324,
                38.7534809
              ],
              [
                46.5435361,
                38.7497325
              ],
              [
                46.5437432,
                38.7483792
              ],
              [
                46.5461969,
                38.7468541
              ],
              [
                46.5482255,
                38.7462832
              ],
              [
                46.5544795,
                38.7443772
              ],
              [
                46.5640919,
                38.7419685
              ],
              [
                46.5776195,
                38.7422929
              ],
              [
                46.5936504,
                38.7453841
              ],
              [
                46.6016424,
                38.748394
              ],
              [
                46.6083418,
                38.7515631
              ],
              [
                46.61454,
                38.7543926
              ],
              [
                46.6202817,
                38.7586446
              ],
              [
                46.643249,
                38.7719909
              ],
              [
                46.6463062,
                38.7744947
              ],
              [
                46.6588057,
                38.78783
              ],
              [
                46.6649158,
                38.7906029
              ],
              [
                46.6660291,
                38.7914375
              ],
              [
                46.6665824,
                38.7914375
              ],
              [
                46.6690824,
                38.7914376
              ],
              [
                46.6696395,
                38.7917157
              ],
              [
                46.6715825,
                38.7917157
              ],
              [
                46.6838053,
                38.7869955
              ],
              [
                46.6849188,
                38.7867174
              ],
              [
                46.684639,
                38.7883775
              ],
              [
                46.684639,
                38.7914376
              ],
              [
                46.684639,
                38.7917158
              ],
              [
                46.6863054,
                38.799496
              ],
              [
                46.7088089,
                38.8417151
              ],
              [
                46.709362,
                38.8419933
              ],
              [
                46.7107519,
                38.8447748
              ],
              [
                46.7246419,
                38.8656093
              ],
              [
                46.7251982,
                38.8661656
              ],
              [
                46.7276983,
                38.8689381
              ],
              [
                46.7349218,
                38.8733883
              ],
              [
                46.7390883,
                38.8747701
              ],
              [
                46.7557544,
                38.8778297
              ],
              [
                46.7568645,
                38.8778297
              ],
              [
                46.7574216,
                38.8781079
              ],
              [
                46.761031,
                38.8781079
              ],
              [
                46.7624209,
                38.878386
              ],
              [
                46.7640881,
                38.878386
              ],
              [
                46.7715874,
                38.8797767
              ],
              [
                46.7871441,
                38.8814365
              ],
              [
                46.7904777,
                38.8819929
              ],
              [
                46.7921442,
                38.8819928
              ],
              [
                46.793534,
                38.882271
              ],
              [
                46.7946443,
                38.882271
              ],
              [
                46.7952005,
                38.8825491
              ],
              [
                46.7979772,
                38.8825492
              ],
              [
                46.8038108,
                38.8833835
              ],
              [
                46.806314,
                38.8833836
              ],
              [
                46.8077007,
                38.8836617
              ],
              [
                46.8096477,
                38.8836617
              ],
              [
                46.8107571,
                38.8839399
              ],
              [
                46.8121469,
                38.8839398
              ],
              [
                46.8127009,
                38.884218
              ],
              [
                46.8165908,
                38.884218
              ],
              [
                46.8168674,
                38.8844961
              ],
              [
                46.8177002,
                38.8844962
              ],
              [
                46.8182573,
                38.8847743
              ],
              [
                46.8271473,
                38.8847744
              ],
              [
                46.8290904,
                38.8844962
              ],
              [
                46.8302037,
                38.8844962
              ],
              [
                46.8340904,
                38.8833837
              ],
              [
                46.8343702,
                38.8831055
              ],
              [
                46.8452039,
                38.8892155
              ],
              [
                46.8488135,
                38.8936656
              ],
              [
                46.852147,
                38.9078321
              ],
              [
                46.8510368,
                38.9106043
              ],
              [
                46.8507602,
                38.9139417
              ],
              [
                46.8540931,
                38.9264389
              ],
              [
                46.8629831,
                38.9375543
              ],
              [
                46.8635363,
                38.9378325
              ],
              [
                46.8671496,
                38.9411607
              ],
              [
                46.8735364,
                38.9453323
              ],
              [
                46.8738161,
                38.9458884
              ],
              [
                46.8804826,
                38.9478351
              ],
              [
                46.8813163,
                38.9478352
              ],
              [
                46.8821499,
                38.9475571
              ],
              [
                46.8835398,
                38.9475571
              ],
              [
                46.8860398,
                38.9470008
              ],
              [
                46.8879829,
                38.9470009
              ],
              [
                46.8974261,
                38.9456104
              ],
              [
                46.901873,
                38.9456104
              ],
              [
                46.9027058,
                38.9453323
              ],
              [
                46.910206,
                38.9453323
              ],
              [
                46.910763,
                38.9450543
              ],
              [
                46.9143725,
                38.9450543
              ],
              [
                46.9154826,
                38.9447762
              ],
              [
                46.9174296,
                38.9447761
              ],
              [
                46.9185391,
                38.944498
              ],
              [
                46.9193726,
                38.9447762
              ],
              [
                46.9221524,
                38.9444981
              ],
              [
                46.9243728,
                38.9447762
              ],
              [
                46.9282627,
                38.9447762
              ],
              [
                46.9415958,
                38.9475572
              ],
              [
                46.9524288,
                38.9536665
              ],
              [
                46.9527092,
                38.9539445
              ],
              [
                46.9560422,
                38.9569946
              ],
              [
                46.9624321,
                38.9617222
              ],
              [
                46.9646517,
                38.9617222
              ],
              [
                46.9657658,
                38.9620003
              ],
              [
                46.9668752,
                38.9620002
              ],
              [
                46.9677088,
                38.9617223
              ],
              [
                46.9710417,
                38.9617222
              ],
              [
                46.9724323,
                38.9614441
              ],
              [
                46.9740988,
                38.9614442
              ],
              [
                46.9749316,
                38.9611661
              ],
              [
                46.9782653,
                38.961166
              ],
              [
                46.9846554,
                38.9600537
              ],
              [
                46.986042,
                38.9600537
              ],
              [
                46.9885421,
                38.9594975
              ],
              [
                46.9907649,
                38.9594975
              ],
              [
                46.9921555,
                38.9592194
              ],
              [
                46.9971548,
                38.9592195
              ],
              [
                46.9990986,
                38.9589414
              ],
              [
                47.000765,
                38.9589414
              ],
              [
                47.0015987,
                38.9592195
              ],
              [
                47.005212,
                38.9592195
              ],
              [
                47.0074316,
                38.9597756
              ],
              [
                47.009098,
                38.9597757
              ],
              [
                47.0107653,
                38.9603319
              ],
              [
                47.0121551,
                38.9603319
              ],
              [
                47.0129879,
                38.96061
              ],
              [
                47.0160451,
                38.9606099
              ],
              [
                47.0171022,
                38.9608214
              ],
              [
                47.021878,
                38.9608881
              ],
              [
                47.0224351,
                38.9611662
              ],
              [
                47.0229882,
                38.9608881
              ],
              [
                47.0438246,
                38.9681095
              ],
              [
                47.0446859,
                38.9682822
              ],
              [
                47.0466012,
                38.9692219
              ],
              [
                47.0471583,
                38.9692218
              ],
              [
                47.0477114,
                38.9695
              ],
              [
                47.0532677,
                38.9697781
              ],
              [
                47.0541015,
                38.9700561
              ],
              [
                47.0554912,
                38.9700562
              ],
              [
                47.0577148,
                38.9706123
              ],
              [
                47.0607679,
                38.9706123
              ],
              [
                47.0613242,
                38.9708904
              ],
              [
                47.0616008,
                38.9706123
              ],
              [
                47.0624344,
                38.9706123
              ],
              [
                47.0627141,
                38.9703342
              ],
              [
                47.0635477,
                38.9706123
              ],
              [
                47.0748999,
                38.9705199
              ],
              [
                47.0751211,
                38.9730482
              ],
              [
                47.0760069,
                38.9781372
              ],
              [
                47.0802617,
                38.9851219
              ],
              [
                47.0858509,
                38.9900105
              ],
              [
                47.0900311,
                38.9923814
              ],
              [
                47.1001483,
                38.9985992
              ],
              [
                47.1016039,
                39.0128348
              ],
              [
                47.1018804,
                39.0133909
              ],
              [
                47.1021609,
                39.013669
              ],
              [
                47.1071602,
                39.0247823
              ],
              [
                47.1074367,
                39.0250514
              ],
              [
                47.1071602,
                39.0256075
              ],
              [
                47.1093837,
                39.0320028
              ],
              [
                47.1096602,
                39.0339491
              ],
              [
                47.1102172,
                39.0342272
              ],
              [
                47.1107704,
                39.0353304
              ],
              [
                47.1113267,
                39.0383889
              ],
              [
                47.1121603,
                39.0403352
              ],
              [
                47.111604,
                39.0411693
              ],
              [
                47.1027139,
                39.0447749
              ],
              [
                47.1018802,
                39.045053
              ],
              [
                47.0988271,
                39.0467212
              ],
              [
                47.0979935,
                39.0483895
              ],
              [
                47.0977138,
                39.0495016
              ],
              [
                47.0941034,
                39.0575558
              ],
              [
                47.0941035,
                39.0622823
              ],
              [
                47.0952137,
                39.0639506
              ],
              [
                47.0952136,
                39.0697803
              ],
              [
                47.0979934,
                39.0720044
              ],
              [
                47.0982699,
                39.0722825
              ],
              [
                47.0999372,
                39.0739417
              ],
              [
                47.1004935,
                39.077834
              ],
              [
                47.0991035,
                39.0803362
              ],
              [
                47.09938,
                39.0831165
              ],
              [
                47.1004934,
                39.0847757
              ],
              [
                47.1018801,
                39.0858877
              ],
              [
                47.1074366,
                39.0869999
              ],
              [
                47.1082701,
                39.0869998
              ],
              [
                47.1157703,
                39.0900581
              ],
              [
                47.1168836,
                39.0903361
              ],
              [
                47.1196602,
                39.0903361
              ],
              [
                47.12105,
                39.08978
              ],
              [
                47.1238267,
                39.08978
              ],
              [
                47.1254932,
                39.0906142
              ],
              [
                47.1271596,
                39.0922822
              ],
              [
                47.1277166,
                39.0928383
              ],
              [
                47.1304933,
                39.1028377
              ],
              [
                47.1291064,
                39.1056178
              ],
              [
                47.12994,
                39.1106129
              ],
              [
                47.1318831,
                39.112837
              ],
              [
                47.1319966,
                39.1131778
              ],
              [
                47.1329932,
                39.1161731
              ],
              [
                47.134383,
                39.118388
              ],
              [
                47.1346596,
                39.1197781
              ],
              [
                47.1343831,
                39.1200561
              ],
              [
                47.1338268,
                39.1217241
              ],
              [
                47.133273,
                39.121724
              ],
              [
                47.1329932,
                39.1220021
              ],
              [
                47.1321595,
                39.1220021
              ],
              [
                47.1313267,
                39.1225581
              ],
              [
                47.1304932,
                39.1225581
              ],
              [
                47.1302166,
                39.1228361
              ],
              [
                47.1296595,
                39.1228361
              ],
              [
                47.1293829,
                39.1231141
              ],
              [
                47.1282735,
                39.1231141
              ],
              [
                47.1279931,
                39.123392
              ],
              [
                47.1254929,
                39.1233921
              ],
              [
                47.1246602,
                39.123114
              ],
              [
                47.12355,
                39.123114
              ],
              [
                47.1232695,
                39.1228361
              ],
              [
                47.1227164,
                39.123114
              ],
              [
                47.1207702,
                39.123114
              ],
              [
                47.1203495,
                39.123114
              ],
              [
                47.1135497,
                39.12645
              ],
              [
                47.1116036,
                39.12645
              ],
              [
                47.108827,
                39.125616
              ],
              [
                47.1027135,
                39.1300549
              ],
              [
                47.102437,
                39.1308889
              ],
              [
                47.1021604,
                39.131167
              ],
              [
                47.1018799,
                39.1320009
              ],
              [
                47.1035464,
                39.1397846
              ],
              [
                47.1038269,
                39.1403406
              ],
              [
                47.1054933,
                39.1428335
              ],
              [
                47.1057698,
                39.1431115
              ],
              [
                47.1079934,
                39.1445015
              ],
              [
                47.1479965,
                39.1578357
              ],
              [
                47.1496629,
                39.1578357
              ],
              [
                47.1504958,
                39.1581137
              ],
              [
                47.1591062,
                39.1581137
              ],
              [
                47.1602164,
                39.1578357
              ],
              [
                47.1638297,
                39.1570018
              ],
              [
                47.1721628,
                39.1531191
              ],
              [
                47.1777191,
                39.1517292
              ],
              [
                47.1788293,
                39.1517292
              ],
              [
                47.1793855,
                39.1520072
              ],
              [
                47.1816059,
                39.1520072
              ],
              [
                47.2027188,
                39.1595036
              ],
              [
                47.2041088,
                39.1597816
              ],
              [
                47.2227224,
                39.1686679
              ],
              [
                47.222999,
                39.1689459
              ],
              [
                47.2263318,
                39.1714476
              ],
              [
                47.2267609,
                39.1719273
              ],
              [
                47.2267609,
                39.1719275
              ],
              [
                47.2267609,
                39.1719276
              ],
              [
                47.2277217,
                39.1747832
              ],
              [
                47.2263319,
                39.1775632
              ],
              [
                47.2263319,
                39.1783968
              ],
              [
                47.2263319,
                39.178397
              ],
              [
                47.2279984,
                39.1800559
              ],
              [
                47.2291086,
                39.1806208
              ],
              [
                47.2318882,
                39.184503
              ],
              [
                47.2318882,
                39.1845031
              ],
              [
                47.2318882,
                39.1845032
              ],
              [
                47.2318882,
                39.1861711
              ],
              [
                47.2310554,
                39.1875606
              ],
              [
                47.2310555,
                39.1875608
              ],
              [
                47.2310555,
                39.1875609
              ],
              [
                47.2354983,
                39.1997817
              ],
              [
                47.2354983,
                39.1997818
              ],
              [
                47.2354984,
                39.2000599
              ],
              [
                47.2366086,
                39.205341
              ],
              [
                47.2346647,
                39.2092321
              ],
              [
                47.2587163,
                39.2219008
              ],
              [
                47.2797001,
                39.2461028
              ],
              [
                47.2971149,
                39.2547705
              ],
              [
                47.3168493,
                39.2631479
              ],
              [
                47.3380095,
                39.2797857
              ],
              [
                47.3904062,
                39.2794366
              ],
              [
                47.4920538,
                39.2866052
              ],
              [
                47.5018987,
                39.2928425
              ],
              [
                47.5024554,
                39.2931205
              ],
              [
                47.5049349,
                39.2954356
              ],
              [
                47.5049348,
                39.2954356
              ],
              [
                47.4999372,
                39.2976911
              ],
              [
                47.4953635,
                39.3000278
              ],
              [
                47.4906687,
                39.300441
              ],
              [
                47.4867257,
                39.3017425
              ],
              [
                47.4840637,
                39.3041709
              ],
              [
                47.4791124,
                39.3043582
              ],
              [
                47.4756474,
                39.3065347
              ],
              [
                47.4700137,
                39.3083933
              ],
              [
                47.4635941,
                39.3097876
              ],
              [
                47.463594,
                39.3097876
              ],
              [
                47.4591378,
                39.3106373
              ],
              [
                47.454152,
                39.3112482
              ],
              [
                47.4508565,
                39.3113016
              ],
              [
                47.4469293,
                39.3123897
              ],
              [
                47.4412604,
                39.3146716
              ],
              [
                47.4342933,
                39.3160379
              ],
              [
                47.4307925,
                39.3186376
              ],
              [
                47.4300068,
                39.3215822
              ],
              [
                47.4300068,
                39.3215823
              ],
              [
                47.430553,
                39.3250177
              ],
              [
                47.4338318,
                39.3285858
              ],
              [
                47.4338319,
                39.3285859
              ],
              [
                47.4374014,
                39.331955
              ],
              [
                47.4387849,
                39.335218
              ],
              [
                47.439111,
                39.3372671
              ],
              [
                47.4293961,
                39.3431212
              ],
              [
                47.4049493,
                39.3683973
              ],
              [
                47.4041164,
                39.3695088
              ],
              [
                47.4032828,
                39.3703423
              ],
              [
                47.4005061,
                39.3733987
              ],
              [
                47.3796727,
                39.4058968
              ],
              [
                47.3663364,
                39.419788
              ],
              [
                47.363399,
                39.4217256
              ],
              [
                47.3608277,
                39.4200102
              ],
              [
                47.3595582,
                39.4182437
              ],
              [
                47.3555378,
                39.4185647
              ],
              [
                47.3537642,
                39.4180874
              ],
              [
                47.3499931,
                39.4126685
              ],
              [
                47.3468753,
                39.4125839
              ],
              [
                47.3451308,
                39.4141522
              ],
              [
                47.3433619,
                39.4142756
              ],
              [
                47.3415951,
                39.4134759
              ],
              [
                47.3398535,
                39.4113563
              ],
              [
                47.3412014,
                39.4061242
              ],
              [
                47.3370202,
                39.4047769
              ],
              [
                47.335519,
                39.4035682
              ],
              [
                47.3346844,
                39.3970296
              ],
              [
                47.3301002,
                39.3909623
              ],
              [
                47.3257055,
                39.3838955
              ],
              [
                47.3220476,
                39.3825008
              ],
              [
                47.3206243,
                39.3814892
              ],
              [
                47.3188852,
                39.3784046
              ],
              [
                47.3181412,
                39.3742176
              ],
              [
                47.3156299,
                39.3696027
              ],
              [
                47.3152019,
                39.3691175
              ],
              [
                47.314477,
                39.3688494
              ],
              [
                47.313612,
                39.3687565
              ],
              [
                47.3109828,
                39.3685104
              ],
              [
                47.3068533,
                39.3689826
              ],
              [
                47.3052471,
                39.3686982
              ],
              [
                47.3043519,
                39.3686449
              ],
              [
                47.3026262,
                39.3687987
              ],
              [
                47.3007045,
                39.3687456
              ],
              [
                47.298964,
                39.3683588
              ],
              [
                47.2971423,
                39.3677183
              ],
              [
                47.2960443,
                39.3670896
              ],
              [
                47.2897202,
                39.3633319
              ],
              [
                47.2795265,
                39.3611279
              ],
              [
                47.2754146,
                39.358916
              ],
              [
                47.2733101,
                39.3561652
              ],
              [
                47.2703565,
                39.3523046
              ],
              [
                47.267973,
                39.3504667
              ],
              [
                47.262051,
                39.349619
              ],
              [
                47.2591783,
                39.3474366
              ],
              [
                47.2553449,
                39.3486523
              ],
              [
                47.2518772,
                39.3482015
              ],
              [
                47.2502595,
                39.3463522
              ],
              [
                47.2488912,
                39.340561
              ],
              [
                47.2458971,
                39.3372045
              ],
              [
                47.2393843,
                39.3364805
              ],
              [
                47.2366772,
                39.3347047
              ],
              [
                47.232953,
                39.3351795
              ],
              [
                47.2264752,
                39.3334789
              ],
              [
                47.2247937,
                39.3317596
              ],
              [
                47.223787,
                39.3255172
              ],
              [
                47.2183309,
                39.322266
              ],
              [
                47.2156721,
                39.3189532
              ],
              [
                47.2082841,
                39.3188846
              ],
              [
                47.2067571,
                39.3203073
              ],
              [
                47.2061063,
                39.3209477
              ],
              [
                47.2025694,
                39.3190477
              ],
              [
                47.1992954,
                39.3187276
              ],
              [
                47.1962492,
                39.3199963
              ],
              [
                47.1949602,
                39.3199172
              ],
              [
                47.1927866,
                39.3189756
              ],
              [
                47.1887822,
                39.3157691
              ],
              [
                47.182525,
                39.3156811
              ],
              [
                47.1794498,
                39.3147999
              ],
              [
                47.1777574,
                39.3126951
              ],
              [
                47.172365,
                39.3093203
              ],
              [
                47.1668112,
                39.3075966
              ],
              [
                47.1657852,
                39.3074527
              ],
              [
                47.1650717,
                39.3079242
              ],
              [
                47.1631684,
                39.3111912
              ],
              [
                47.161355,
                39.3118332
              ],
              [
                47.1591326,
                39.3114533
              ],
              [
                47.1570534,
                39.3098883
              ],
              [
                47.1527279,
                39.3020136
              ],
              [
                47.1489089,
                39.3014158
              ],
              [
                47.1482569,
                39.3004691
              ],
              [
                47.1483552,
                39.2978786
              ],
              [
                47.1469315,
                39.2961818
              ],
              [
                47.1455362,
                39.2957852
              ],
              [
                47.1429091,
                39.2962773
              ],
              [
                47.1409673,
                39.2954642
              ],
              [
                47.1399324,
                39.293326
              ],
              [
                47.1390336,
                39.2923985
              ],
              [
                47.1344399,
                39.2923578
              ],
              [
                47.1327739,
                39.2918267
              ],
              [
                47.130708,
                39.2892217
              ],
              [
                47.1295799,
                39.285867
              ],
              [
                47.1272548,
                39.2818029
              ],
              [
                47.1265971,
                39.2798041
              ],
              [
                47.1255638,
                39.2783635
              ],
              [
                47.1243922,
                39.2780905
              ],
              [
                47.1232163,
                39.2781224
              ],
              [
                47.1200665,
                39.2803936
              ],
              [
                47.1163312,
                39.2805553
              ],
              [
                47.1134905,
                39.2792425
              ],
              [
                47.1132696,
                39.2791401
              ],
              [
                47.111281,
                39.2746271
              ],
              [
                47.1099309,
                39.2735018
              ],
              [
                47.1068048,
                39.2725983
              ],
              [
                47.1041172,
                39.2727346
              ],
              [
                47.1016583,
                39.2741979
              ],
              [
                47.1007335,
                39.2760846
              ],
              [
                47.0983303,
                39.2767338
              ],
              [
                47.0968952,
                39.2755379
              ],
              [
                47.094658,
                39.2659549
              ],
              [
                47.0924526,
                39.2648099
              ],
              [
                47.0904566,
                39.2647549
              ],
              [
                47.0882671,
                39.2663615
              ],
              [
                47.0863643,
                39.266456
              ],
              [
                47.084414,
                39.2657214
              ],
              [
                47.0814019,
                39.2636205
              ],
              [
                47.0764564,
                39.256504
              ],
              [
                47.0755366,
                39.2524189
              ],
              [
                47.0755972,
                39.2490182
              ],
              [
                47.0727628,
                39.2453158
              ],
              [
                47.0704147,
                39.2444756
              ],
              [
                47.064326,
                39.2457228
              ],
              [
                47.063112,
                39.2454184
              ],
              [
                47.0620276,
                39.2436593
              ],
              [
                47.0594628,
                39.2420049
              ],
              [
                47.0580694,
                39.2398185
              ],
              [
                47.0579494,
                39.2381368
              ],
              [
                47.0601712,
                39.2335688
              ],
              [
                47.0598289,
                39.2326175
              ],
              [
                47.0577703,
                39.2308198
              ],
              [
                47.0572275,
                39.2279736
              ],
              [
                47.057799,
                39.2241999
              ],
              [
                47.057206,
                39.2213424
              ],
              [
                47.0547813,
                39.2157349
              ],
              [
                47.054989,
                39.2137032
              ],
              [
                47.0567319,
                39.2107285
              ],
              [
                47.0606894,
                39.2064423
              ],
              [
                47.0607312,
                39.2062385
              ],
              [
                47.0609185,
                39.2052735
              ],
              [
                47.0603918,
                39.2041153
              ],
              [
                47.057593,
                39.203267
              ],
              [
                47.056313,
                39.2012657
              ],
              [
                47.055114,
                39.1955681
              ],
              [
                47.0539374,
                39.1939118
              ],
              [
                47.0488839,
                39.1906411
              ],
              [
                47.0464504,
                39.1884477
              ],
              [
                47.0445034,
                39.1870612
              ],
              [
                47.0412129,
                39.1853256
              ],
              [
                47.0406442,
                39.1849331
              ],
              [
                47.0364815,
                39.1834034
              ],
              [
                47.0345501,
                39.1799619
              ],
              [
                47.0334918,
                39.1788332
              ],
              [
                47.025578,
                39.1768502
              ],
              [
                47.0225644,
                39.1754808
              ],
              [
                47.0223098,
                39.1741689
              ],
              [
                47.0212274,
                39.1734651
              ],
              [
                47.0213572,
                39.1704574
              ],
              [
                47.0197939,
                39.1677187
              ],
              [
                47.0191103,
                39.1670014
              ],
              [
                47.0157934,
                39.166207
              ],
              [
                47.0069414,
                39.1670683
              ],
              [
                47.0036516,
                39.1666787
              ],
              [
                46.9993569,
                39.1677849
              ],
              [
                46.9976387,
                39.1672296
              ],
              [
                46.9957006,
                39.1656732
              ],
              [
                46.9932635,
                39.1645118
              ],
              [
                46.9930966,
                39.1637164
              ],
              [
                46.9919001,
                39.1624044
              ],
              [
                46.9919231,
                39.1593481
              ],
              [
                46.9939832,
                39.1557421
              ],
              [
                46.9934585,
                39.1545376
              ],
              [
                46.9889855,
                39.1528015
              ],
              [
                46.9845088,
                39.1504479
              ],
              [
                46.9820556,
                39.1498838
              ],
              [
                46.9762969,
                39.1473595
              ],
              [
                46.9681622,
                39.1445301
              ],
              [
                46.9647404,
                39.1424734
              ],
              [
                46.9637943,
                39.1415398
              ],
              [
                46.9632831,
                39.140536
              ],
              [
                46.9624954,
                39.1403575
              ],
              [
                46.9609178,
                39.1414107
              ],
              [
                46.9592159,
                39.1415467
              ],
              [
                46.9562419,
                39.1411485
              ],
              [
                46.9532832,
                39.1403351
              ],
              [
                46.9515984,
                39.1394056
              ],
              [
                46.9499057,
                39.1395053
              ],
              [
                46.9485042,
                39.1404421
              ],
              [
                46.9480611,
                39.1416702
              ],
              [
                46.9477768,
                39.1474914
              ],
              [
                46.9463776,
                39.1485484
              ],
              [
                46.9443847,
                39.1481093
              ],
              [
                46.9385584,
                39.151977
              ],
              [
                46.9382587,
                39.1546695
              ],
              [
                46.93705,
                39.1572273
              ],
              [
                46.9255441,
                39.1647287
              ],
              [
                46.9111848,
                39.158891
              ],
              [
                46.8936754,
                39.1517784
              ],
              [
                46.8664708,
                39.1407097
              ],
              [
                46.8452627,
                39.1395615
              ],
              [
                46.8390194,
                39.1374974
              ],
              [
                46.8404835,
                39.1334667
              ],
              [
                46.8414717,
                39.1304528
              ],
              [
                46.8390088,
                39.1233406
              ],
              [
                46.8366858,
                39.1218189
              ],
              [
                46.8344638,
                39.1209205
              ],
              [
                46.8338894,
                39.1202046
              ],
              [
                46.8337387,
                39.1188287
              ],
              [
                46.8344832,
                39.1155966
              ],
              [
                46.8342366,
                39.1144444
              ],
              [
                46.8331208,
                39.113403
              ],
              [
                46.8320209,
                39.112961
              ],
              [
                46.8305165,
                39.1128693
              ],
              [
                46.8269452,
                39.1147576
              ],
              [
                46.8259393,
                39.1145494
              ],
              [
                46.8241304,
                39.1131311
              ],
              [
                46.8242197,
                39.1122648
              ],
              [
                46.8227375,
                39.1108147
              ],
              [
                46.8203317,
                39.1105519
              ],
              [
                46.8185215,
                39.1100567
              ],
              [
                46.8155292,
                39.1099205
              ],
              [
                46.8147235,
                39.1090702
              ],
              [
                46.8148651,
                39.1077811
              ],
              [
                46.8157574,
                39.1068268
              ],
              [
                46.8171872,
                39.1062208
              ],
              [
                46.8199085,
                39.1066481
              ],
              [
                46.8206697,
                39.1062696
              ],
              [
                46.8211771,
                39.1055312
              ],
              [
                46.8209774,
                39.1047598
              ],
              [
                46.8203512,
                39.1041591
              ],
              [
                46.8179908,
                39.1035204
              ],
              [
                46.8130578,
                39.103531
              ],
              [
                46.8119538,
                39.1030956
              ],
              [
                46.8111034,
                39.1014421
              ],
              [
                46.8134035,
                39.0979481
              ],
              [
                46.8133781,
                39.0971634
              ],
              [
                46.8124184,
                39.0964775
              ],
              [
                46.8016959,
                39.0937324
              ],
              [
                46.7998986,
                39.0925551
              ],
              [
                46.7974082,
                39.0919786
              ],
              [
                46.7964251,
                39.0906416
              ],
              [
                46.7963536,
                39.0887062
              ],
              [
                46.7957335,
                39.0880824
              ],
              [
                46.7916138,
                39.0876571
              ],
              [
                46.790686,
                39.0871097
              ],
              [
                46.7896884,
                39.0818958
              ],
              [
                46.7885209,
                39.0804797
              ],
              [
                46.78799,
                39.0783271
              ],
              [
                46.7867182,
                39.0770149
              ],
              [
                46.7819046,
                39.0756975
              ],
              [
                46.7780202,
                39.0727645
              ],
              [
                46.7775614,
                39.0711868
              ],
              [
                46.7757076,
                39.069856
              ],
              [
                46.7746989,
                39.069685
              ],
              [
                46.773844,
                39.0698675
              ],
              [
                46.7716342,
                39.0712774
              ],
              [
                46.7704519,
                39.0715391
              ],
              [
                46.7693349,
                39.0713247
              ],
              [
                46.7683432,
                39.0704193
              ],
              [
                46.7683242,
                39.0680164
              ],
              [
                46.767482,
                39.0646965
              ],
              [
                46.7679346,
                39.0588894
              ],
              [
                46.7669087,
                39.0579532
              ],
              [
                46.761296,
                39.0584633
              ],
              [
                46.7590985,
                39.0579337
              ],
              [
                46.7584939,
                39.057075
              ],
              [
                46.7572989,
                39.0498306
              ],
              [
                46.7580788,
                39.045616
              ],
              [
                46.7586494,
                39.0435729
              ],
              [
                46.7619092,
                39.0381835
              ],
              [
                46.761784,
                39.0369011
              ],
              [
                46.7564149,
                39.0301181
              ],
              [
                46.7530928,
                39.025914
              ],
              [
                46.7519509,
                39.0257572
              ],
              [
                46.7505397,
                39.0278033
              ],
              [
                46.7493545,
                39.0284318
              ],
              [
                46.7479451,
                39.0285695
              ],
              [
                46.7437876,
                39.0263366
              ],
              [
                46.7399777,
                39.0200042
              ],
              [
                46.7385151,
                39.0187238
              ],
              [
                46.7367822,
                39.0176203
              ],
              [
                46.7346592,
                39.0168215
              ],
              [
                46.7315016,
                39.0160731
              ],
              [
                46.728139,
                39.0161088
              ],
              [
                46.7253955,
                39.0158121
              ],
              [
                46.7223576,
                39.0145849
              ],
              [
                46.720087,
                39.0144641
              ],
              [
                46.7174075,
                39.0145854
              ],
              [
                46.7155307,
                39.0138702
              ],
              [
                46.7140226,
                39.0128099
              ],
              [
                46.707876,
                39.0138459
              ],
              [
                46.7071415,
                39.0144235
              ],
              [
                46.706744,
                39.0180331
              ],
              [
                46.7060969,
                39.0184937
              ],
              [
                46.7032403,
                39.0186224
              ],
              [
                46.6993894,
                39.0194567
              ],
              [
                46.6969383,
                39.0190302
              ],
              [
                46.6957247,
                39.0180166
              ],
              [
                46.6914397,
                39.012144
              ],
              [
                46.6870776,
                39.0081386
              ],
              [
                46.6851093,
                39.0079064
              ],
              [
                46.6835639,
                39.0071507
              ],
              [
                46.6831597,
                39.0063436
              ],
              [
                46.6835176,
                39.0048994
              ],
              [
                46.6882792,
                39.002611
              ],
              [
                46.6889914,
                39.0015501
              ],
              [
                46.6888772,
                38.9964944
              ],
              [
                46.6903284,
                38.9949352
              ],
              [
                46.6892893,
                38.9935398
              ],
              [
                46.6857012,
                38.9924209
              ],
              [
                46.683769,
                38.9922933
              ],
              [
                46.681183,
                38.9900944
              ],
              [
                46.6781039,
                38.9847995
              ],
              [
                46.6751787,
                38.9838387
              ],
              [
                46.6747571,
                38.9833449
              ],
              [
                46.6748078,
                38.980007
              ],
              [
                46.6734554,
                38.9778726
              ],
              [
                46.6672622,
                38.9742393
              ],
              [
                46.6634131,
                38.9707893
              ],
              [
                46.6632108,
                38.9679396
              ],
              [
                46.6622646,
                38.966546
              ],
              [
                46.6602529,
                38.9655123
              ],
              [
                46.6577537,
                38.9635164
              ],
              [
                46.6565406,
                38.9621307
              ],
              [
                46.656832,
                38.9587237
              ],
              [
                46.656581,
                38.9571361
              ],
              [
                46.6560564,
                38.9555994
              ],
              [
                46.6549773,
                38.9540911
              ],
              [
                46.6522705,
                38.9526976
              ],
              [
                46.6483008,
                38.9516245
              ],
              [
                46.6414431,
                38.9515578
              ],
              [
                46.6404129,
                38.951116
              ],
              [
                46.6392368,
                38.9492908
              ],
              [
                46.6387397,
                38.9470519
              ],
              [
                46.6389387,
                38.9458308
              ],
              [
                46.6404154,
                38.9450297
              ],
              [
                46.6406695,
                38.9442104
              ],
              [
                46.6382403,
                38.9403444
              ],
              [
                46.6367328,
                38.9394547
              ],
              [
                46.6323061,
                38.9393082
              ],
              [
                46.6281636,
                38.9371325
              ],
              [
                46.6268552,
                38.9350177
              ],
              [
                46.6274715,
                38.930396
              ],
              [
                46.625356,
                38.9291857
              ],
              [
                46.6229779,
                38.9282119
              ],
              [
                46.621666,
                38.9270849
              ],
              [
                46.6205885,
                38.9245446
              ],
              [
                46.6191232,
                38.9234543
              ],
              [
                46.6134121,
                38.9206628
              ],
              [
                46.609647,
                38.9216355
              ],
              [
                46.607642,
                38.9213736
              ],
              [
                46.6071525,
                38.9204832
              ],
              [
                46.6078117,
                38.9177536
              ],
              [
                46.6041917,
                38.9145456
              ],
              [
                46.6034497,
                38.912529
              ],
              [
                46.6034552,
                38.9099154
              ],
              [
                46.6009537,
                38.9060612
              ],
              [
                46.5983379,
                38.9057576
              ],
              [
                46.5920823,
                38.9020786
              ],
              [
                46.5887857,
                38.8993499
              ],
              [
                46.5875463,
                38.8985874
              ],
              [
                46.5850084,
                38.8980868
              ],
              [
                46.5820807,
                38.8958925
              ],
              [
                46.5745915,
                38.8914114
              ],
              [
                46.5710988,
                38.8910552
              ],
              [
                46.5684859,
                38.8904363
              ],
              [
                46.5661959,
                38.888648
              ],
              [
                46.5663729,
                38.8863702
              ],
              [
                46.5653437,
                38.8856997
              ],
              [
                46.5569798,
                38.8853894
              ],
              [
                46.5544482,
                38.8842288
              ],
              [
                46.5521943,
                38.8826185
              ],
              [
                46.5500033,
                38.8793524
              ],
              [
                46.5462798,
                38.8784449
              ],
              [
                46.5438043,
                38.8769913
              ],
              [
                46.5409967,
                38.8718692
              ],
              [
                46.5398256,
                38.8706266
              ],
              [
                46.5339832,
                38.867172
              ],
              [
                46.5337126,
                38.8673273
              ],
              [
                46.5319385,
                38.8683425
              ],
              [
                46.5301643,
                38.8693577
              ],
              [
                46.5271301,
                38.8723603
              ],
              [
                46.5249491,
                38.8756999
              ],
              [
                46.5236921,
                38.8780122
              ],
              [
                46.523999,
                38.8811365
              ],
              [
                46.5254238,
                38.8852005
              ],
              [
                46.52578,
                38.8861726
              ],
              [
                46.525684,
                38.886675
              ],
              [
                46.5255338,
                38.8874615
              ],
              [
                46.5251148,
                38.8878846
              ],
              [
                46.5243816,
                38.8883123
              ],
              [
                46.5220017,
                38.8846994
              ],
              [
                46.5193535,
                38.8811667
              ],
              [
                46.4976594,
                38.8780847
              ],
              [
                46.4999739,
                38.8590224
              ],
              [
                46.5028646,
                38.843498
              ],
              [
                46.5042909,
                38.8368193
              ],
              [
                46.5073756,
                38.828348
              ],
              [
                46.5066861,
                38.8200478
              ],
              [
                46.5006169,
                38.8121366
              ],
              [
                46.4900851,
                38.8055502
              ],
              [
                46.481524,
                38.7997694
              ],
              [
                46.4704671,
                38.7927997
              ],
              [
                46.4576593,
                38.783277
              ],
              [
                46.4382148,
                38.7681607
              ],
              [
                46.4288904,
                38.762173
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555068,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سراب",
          "name:en": "Sarab County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291800",
          "wikipedia": "en:Sarab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.995493,
                37.8261324
              ],
              [
                46.9954932,
                37.825575
              ],
              [
                46.9959567,
                37.824655
              ],
              [
                46.9966033,
                37.8241906
              ],
              [
                46.9966034,
                37.8239119
              ],
              [
                47.0152163,
                37.8080809
              ],
              [
                47.022993,
                37.801689
              ],
              [
                47.0385497,
                37.7939127
              ],
              [
                47.041606,
                37.7930766
              ],
              [
                47.0438295,
                37.7930766
              ],
              [
                47.044106,
                37.7927979
              ],
              [
                47.0446631,
                37.7927979
              ],
              [
                47.045496,
                37.7930766
              ],
              [
                47.0457725,
                37.7927979
              ],
              [
                47.0466061,
                37.7927979
              ],
              [
                47.0493827,
                37.7930767
              ],
              [
                47.0518859,
                37.7930766
              ],
              [
                47.0524391,
                37.7933554
              ],
              [
                47.0554962,
                37.7933554
              ],
              [
                47.0677191,
                37.7969693
              ],
              [
                47.0835522,
                37.8022466
              ],
              [
                47.0846624,
                37.8022466
              ],
              [
                47.0852187,
                37.8025252
              ],
              [
                47.0866093,
                37.8025253
              ],
              [
                47.0891094,
                37.8030736
              ],
              [
                47.0913321,
                37.8030737
              ],
              [
                47.0921657,
                37.8033524
              ],
              [
                47.0957759,
                37.8033525
              ],
              [
                47.0963322,
                37.8036311
              ],
              [
                47.1049425,
                37.8036311
              ],
              [
                47.1052191,
                37.8033524
              ],
              [
                47.1066089,
                37.8033524
              ],
              [
                47.1068887,
                37.8030737
              ],
              [
                47.1191085,
                37.8005835
              ],
              [
                47.121332,
                37.7994688
              ],
              [
                47.1227218,
                37.7986327
              ],
              [
                47.1252219,
                37.7953063
              ],
              [
                47.1227219,
                37.7839068
              ],
              [
                47.1224422,
                37.7808591
              ],
              [
                47.1238321,
                37.7766875
              ],
              [
                47.1243884,
                37.7764089
              ],
              [
                47.1243884,
                37.7758514
              ],
              [
                47.125779,
                37.7739095
              ],
              [
                47.1257791,
                37.7736308
              ],
              [
                47.1260556,
                37.7730734
              ],
              [
                47.1263322,
                37.772525
              ],
              [
                47.1263322,
                37.7719676
              ],
              [
                47.1268884,
                37.7714102
              ],
              [
                47.1371653,
                37.7680748
              ],
              [
                47.1416122,
                37.767805
              ],
              [
                47.1421654,
                37.7680747
              ],
              [
                47.1435552,
                37.7680748
              ],
              [
                47.1443888,
                37.7683535
              ],
              [
                47.1457787,
                37.7683534
              ],
              [
                47.146335,
                37.7686322
              ],
              [
                47.1493882,
                37.7686322
              ],
              [
                47.1499453,
                37.7689109
              ],
              [
                47.1530016,
                37.7689108
              ],
              [
                47.1532781,
                37.7691896
              ],
              [
                47.1618885,
                37.7691896
              ],
              [
                47.1621681,
                37.7689109
              ],
              [
                47.163558,
                37.7689109
              ],
              [
                47.1638354,
                37.7686322
              ],
              [
                47.1646682,
                37.7686322
              ],
              [
                47.1652253,
                37.7683535
              ],
              [
                47.1660581,
                37.7683535
              ],
              [
                47.166612,
                37.7680748
              ],
              [
                47.1671682,
                37.7678051
              ],
              [
                47.1678237,
                37.7674769
              ],
              [
                47.1682785,
                37.7672477
              ],
              [
                47.1685582,
                37.766969
              ],
              [
                47.1693918,
                37.766969
              ],
              [
                47.1696683,
                37.7666903
              ],
              [
                47.1702254,
                37.7666903
              ],
              [
                47.1830015,
                37.7639123
              ],
              [
                47.1863351,
                37.7639122
              ],
              [
                47.187168,
                37.7636335
              ],
              [
                47.1891148,
                37.7636336
              ],
              [
                47.1896681,
                37.7633548
              ],
              [
                47.1916149,
                37.7633549
              ],
              [
                47.1921681,
                37.7630761
              ],
              [
                47.1949479,
                37.7630761
              ],
              [
                47.196058,
                37.7627974
              ],
              [
                47.1988346,
                37.7627974
              ],
              [
                47.203005,
                37.7616916
              ],
              [
                47.204391,
                37.7616916
              ],
              [
                47.2049481,
                37.7614129
              ],
              [
                47.2057816,
                37.7614129
              ],
              [
                47.2066145,
                37.7611342
              ],
              [
                47.2080043,
                37.7611342
              ],
              [
                47.2085575,
                37.7608555
              ],
              [
                47.2110576,
                37.7608555
              ],
              [
                47.2118912,
                37.7605768
              ],
              [
                47.2135576,
                37.7605768
              ],
              [
                47.2138381,
                37.7602981
              ],
              [
                47.2152248,
                37.7602981
              ],
              [
                47.2157812,
                37.7600194
              ],
              [
                47.2166147,
                37.7600193
              ],
              [
                47.2210609,
                37.7583561
              ],
              [
                47.221614,
                37.7577987
              ],
              [
                47.2230047,
                37.7569625
              ],
              [
                47.2238375,
                37.7544631
              ],
              [
                47.2243947,
                37.7530785
              ],
              [
                47.2243946,
                37.7522425
              ],
              [
                47.2255048,
                37.751694
              ],
              [
                47.2307807,
                37.7525212
              ],
              [
                47.2368941,
                37.7550206
              ],
              [
                47.2377277,
                37.7550206
              ],
              [
                47.2421708,
                37.7561354
              ],
              [
                47.2452279,
                37.7561355
              ],
              [
                47.2460607,
                37.7564142
              ],
              [
                47.2477272,
                37.7564142
              ],
              [
                47.2480045,
                37.7566929
              ],
              [
                47.2524507,
                37.7572413
              ],
              [
                47.2566172,
                37.7572414
              ],
              [
                47.2571703,
                37.7569626
              ],
              [
                47.2613407,
                37.7561355
              ],
              [
                47.2685605,
                37.7533574
              ],
              [
                47.2721738,
                37.7533574
              ],
              [
                47.2724503,
                37.7536361
              ],
              [
                47.2735605,
                37.7536362
              ],
              [
                47.2816169,
                37.7558569
              ],
              [
                47.2827303,
                37.7558568
              ],
              [
                47.2832834,
                37.7561356
              ],
              [
                47.2896733,
                37.7575202
              ],
              [
                47.2921734,
                37.7580775
              ],
              [
                47.2932836,
                37.7580776
              ],
              [
                47.2952306,
                37.758635
              ],
              [
                47.2991205,
                37.758635
              ],
              [
                47.3171772,
                37.7536362
              ],
              [
                47.3185632,
                37.7536362
              ],
              [
                47.3191201,
                37.7533575
              ],
              [
                47.3255101,
                37.7533576
              ],
              [
                47.3257867,
                37.7536363
              ],
              [
                47.3266203,
                37.7536363
              ],
              [
                47.3274532,
                37.753915
              ],
              [
                47.328843,
                37.753915
              ],
              [
                47.3293969,
                37.7541937
              ],
              [
                47.3330103,
                37.7547421
              ],
              [
                47.3341197,
                37.7547421
              ],
              [
                47.3344002,
                37.7550208
              ],
              [
                47.3346767,
                37.755857
              ],
              [
                47.3391197,
                37.7600196
              ],
              [
                47.3405097,
                37.7600197
              ],
              [
                47.3410667,
                37.759741
              ],
              [
                47.3432864,
                37.7597409
              ],
              [
                47.34912,
                37.757799
              ],
              [
                47.3502333,
                37.757799
              ],
              [
                47.3507864,
                37.7575203
              ],
              [
                47.3518998,
                37.7575203
              ],
              [
                47.3527334,
                37.7572416
              ],
              [
                47.3568999,
                37.7572416
              ],
              [
                47.3574562,
                37.7575203
              ],
              [
                47.3610664,
                37.7575203
              ],
              [
                47.3619,
                37.7577991
              ],
              [
                47.3630093,
                37.757799
              ],
              [
                47.3641227,
                37.7583565
              ],
              [
                47.3652329,
                37.7583564
              ],
              [
                47.3710658,
                37.7594624
              ],
              [
                47.372733,
                37.7594623
              ],
              [
                47.3735658,
                37.7597411
              ],
              [
                47.3766229,
                37.7597411
              ],
              [
                47.3941226,
                37.7561358
              ],
              [
                47.3952359,
                37.7555784
              ],
              [
                47.3971789,
                37.7547423
              ],
              [
                47.3988461,
                37.7539151
              ],
              [
                47.4138457,
                37.745302
              ],
              [
                47.4146794,
                37.745302
              ],
              [
                47.414959,
                37.7450232
              ],
              [
                47.4171794,
                37.7444658
              ],
              [
                47.4188458,
                37.7444659
              ],
              [
                47.4194022,
                37.7447445
              ],
              [
                47.4205123,
                37.745302
              ],
              [
                47.4210694,
                37.7453021
              ],
              [
                47.4216256,
                37.7450233
              ],
              [
                47.4238459,
                37.7450234
              ],
              [
                47.4244022,
                37.7453021
              ],
              [
                47.4260686,
                37.745302
              ],
              [
                47.4266257,
                37.7455808
              ],
              [
                47.4285692,
                37.7455808
              ],
              [
                47.4291258,
                37.7458594
              ],
              [
                47.429959,
                37.7458595
              ],
              [
                47.4307922,
                37.7464169
              ],
              [
                47.432459,
                37.7466867
              ],
              [
                47.4324591,
                37.7469654
              ],
              [
                47.4330157,
                37.7469654
              ],
              [
                47.4449588,
                37.7528005
              ],
              [
                47.4455156,
                37.7530791
              ],
              [
                47.4460722,
                37.7530791
              ],
              [
                47.4466254,
                37.7530791
              ],
              [
                47.4524587,
                37.7552998
              ],
              [
                47.458292,
                37.7552998
              ],
              [
                47.4588486,
                37.7550212
              ],
              [
                47.462182,
                37.7550211
              ],
              [
                47.4638484,
                37.7552999
              ],
              [
                47.464682,
                37.7550212
              ],
              [
                47.4663485,
                37.7550212
              ],
              [
                47.4919049,
                37.7483591
              ],
              [
                47.4924615,
                37.7478016
              ],
              [
                47.4930182,
                37.7478016
              ],
              [
                47.4941283,
                37.7466868
              ],
              [
                47.4952382,
                37.746417
              ],
              [
                47.4957948,
                37.7458596
              ],
              [
                47.4963515,
                37.7458596
              ],
              [
                47.4966284,
                37.7455809
              ],
              [
                47.4991281,
                37.7447448
              ],
              [
                47.4991281,
                37.7444661
              ],
              [
                47.5005184,
                37.7441874
              ],
              [
                47.5007949,
                37.7439086
              ],
              [
                47.5019048,
                37.7436389
              ],
              [
                47.503295,
                37.7436389
              ],
              [
                47.5066283,
                37.742524
              ],
              [
                47.5069084,
                37.7422454
              ],
              [
                47.5077398,
                37.7422454
              ],
              [
                47.5085749,
                37.7422453
              ],
              [
                47.5107948,
                37.7422453
              ],
              [
                47.5110748,
                37.7425241
              ],
              [
                47.5124612,
                37.7425241
              ],
              [
                47.5130183,
                37.7428028
              ],
              [
                47.5138514,
                37.7428028
              ],
              [
                47.5155179,
                37.7433603
              ],
              [
                47.5169082,
                37.7433602
              ],
              [
                47.5174614,
                37.7436389
              ],
              [
                47.5199614,
                37.7436389
              ],
              [
                47.520518,
                37.7433602
              ],
              [
                47.5241315,
                37.7433603
              ],
              [
                47.5363512,
                37.7408608
              ],
              [
                47.5366313,
                37.7411395
              ],
              [
                47.5371844,
                37.7408608
              ],
              [
                47.5391313,
                37.7408608
              ],
              [
                47.5399646,
                37.7405821
              ],
              [
                47.5413545,
                37.7405821
              ],
              [
                47.5474644,
                37.7391886
              ],
              [
                47.5494077,
                37.7391885
              ],
              [
                47.5499645,
                37.7389098
              ],
              [
                47.5574642,
                37.7389098
              ],
              [
                47.5580208,
                37.7391885
              ],
              [
                47.5596876,
                37.7391885
              ],
              [
                47.5602444,
                37.7394672
              ],
              [
                47.5610775,
                37.7394673
              ],
              [
                47.5666308,
                37.7414093
              ],
              [
                47.5694109,
                37.7422455
              ],
              [
                47.589134,
                37.7469657
              ],
              [
                47.5905208,
                37.7469657
              ],
              [
                47.5910774,
                37.7472444
              ],
              [
                47.5944107,
                37.7472445
              ],
              [
                47.5949673,
                37.7475231
              ],
              [
                47.5983006,
                37.7475232
              ],
              [
                47.5999671,
                37.7480806
              ],
              [
                47.6010773,
                37.7483594
              ],
              [
                47.6019105,
                37.7483594
              ],
              [
                47.6027436,
                37.748638
              ],
              [
                47.6044105,
                37.7486381
              ],
              [
                47.6049672,
                37.7489168
              ],
              [
                47.6080238,
                37.7489168
              ],
              [
                47.608577,
                37.7491955
              ],
              [
                47.6124669,
                37.749744
              ],
              [
                47.6146904,
                37.749744
              ],
              [
                47.614967,
                37.7500227
              ],
              [
                47.6160804,
                37.7500227
              ],
              [
                47.6163569,
                37.7503015
              ],
              [
                47.6171905,
                37.7503014
              ],
              [
                47.617467,
                37.7505801
              ],
              [
                47.6183002,
                37.7505801
              ],
              [
                47.6216335,
                37.7519646
              ],
              [
                47.6219136,
                37.7522434
              ],
              [
                47.6691365,
                37.7716902
              ],
              [
                47.6894162,
                37.7853016
              ],
              [
                47.6902494,
                37.7855803
              ],
              [
                47.6927494,
                37.7872436
              ],
              [
                47.6952495,
                37.7872436
              ],
              [
                47.6958062,
                37.7875222
              ],
              [
                47.6963593,
                37.7872435
              ],
              [
                47.6971925,
                37.7872436
              ],
              [
                47.6999727,
                37.7858591
              ],
              [
                47.7027493,
                37.7805818
              ],
              [
                47.7030259,
                37.7803031
              ],
              [
                47.703306,
                37.779467
              ],
              [
                47.7038592,
                37.7791883
              ],
              [
                47.7052493,
                37.7791883
              ],
              [
                47.7060826,
                37.779467
              ],
              [
                47.7071924,
                37.779467
              ],
              [
                47.7113624,
                37.7814179
              ],
              [
                47.7138625,
                37.782245
              ],
              [
                47.7149727,
                37.782245
              ],
              [
                47.7324722,
                37.7883584
              ],
              [
                47.7352523,
                37.789743
              ],
              [
                47.7360855,
                37.789743
              ],
              [
                47.7469186,
                37.7930783
              ],
              [
                47.7502523,
                37.7947505
              ],
              [
                47.7524753,
                37.7947506
              ],
              [
                47.7530285,
                37.7950292
              ],
              [
                47.7541422,
                37.7950292
              ],
              [
                47.7566419,
                37.7955776
              ],
              [
                47.7585853,
                37.7958562
              ],
              [
                47.7596954,
                37.7958563
              ],
              [
                47.7621951,
                37.7950292
              ],
              [
                47.7691418,
                37.7905791
              ],
              [
                47.772752,
                37.7889159
              ],
              [
                47.7741419,
                37.7889159
              ],
              [
                47.7746986,
                37.7886372
              ],
              [
                47.7755318,
                37.7886372
              ],
              [
                47.7783084,
                37.7891946
              ],
              [
                47.7860882,
                37.7930785
              ],
              [
                47.7869218,
                37.7930784
              ],
              [
                47.787475,
                37.7933571
              ],
              [
                47.7885882,
                37.7933571
              ],
              [
                47.789975,
                37.7939145
              ],
              [
                47.7908082,
                37.7939145
              ],
              [
                47.7910883,
                37.7941932
              ],
              [
                47.7927552,
                37.7941932
              ],
              [
                47.8038648,
                37.8005852
              ],
              [
                47.8096981,
                37.8019697
              ],
              [
                47.8180315,
                37.8019696
              ],
              [
                47.8205311,
                37.8014123
              ],
              [
                47.8235878,
                37.8005852
              ],
              [
                47.8241445,
                37.8005853
              ],
              [
                47.8294212,
                37.7983557
              ],
              [
                47.8322014,
                37.7983557
              ],
              [
                47.8330346,
                37.798077
              ],
              [
                47.8363679,
                37.798077
              ],
              [
                47.8366444,
                37.7977984
              ],
              [
                47.8413681,
                37.7977984
              ],
              [
                47.8416445,
                37.7980771
              ],
              [
                47.8438676,
                37.7980771
              ],
              [
                47.8441442,
                37.7977984
              ],
              [
                47.8491444,
                37.7977983
              ],
              [
                47.8495622,
                37.7979381
              ],
              [
                47.8499776,
                37.7980771
              ],
              [
                47.8505341,
                37.7980771
              ],
              [
                47.8510909,
                37.7983557
              ],
              [
                47.8522011,
                37.7983558
              ],
              [
                47.8552577,
                37.8011337
              ],
              [
                47.8574776,
                37.8055837
              ],
              [
                47.8619242,
                37.8189158
              ],
              [
                47.8624809,
                37.8227992
              ],
              [
                47.8635906,
                37.8333621
              ],
              [
                47.8647008,
                37.8347465
              ],
              [
                47.8658141,
                37.8355825
              ],
              [
                47.8785905,
                37.8422527
              ],
              [
                47.898037,
                37.8636381
              ],
              [
                47.8963702,
                37.8650315
              ],
              [
                47.8955368,
                37.8658585
              ],
              [
                47.8930368,
                37.8683574
              ],
              [
                47.8908137,
                37.8722497
              ],
              [
                47.8908137,
                37.8764205
              ],
              [
                47.8916469,
                37.881697
              ],
              [
                47.8919235,
                37.882524
              ],
              [
                47.8916469,
                37.8828026
              ],
              [
                47.8899805,
                37.8855801
              ],
              [
                47.8894234,
                37.8858588
              ],
              [
                47.8894234,
                37.8861374
              ],
              [
                47.8888703,
                37.8861374
              ],
              [
                47.885537,
                37.8897508
              ],
              [
                47.8847038,
                37.8919711
              ],
              [
                47.8874804,
                37.8972474
              ],
              [
                47.887757,
                37.8978047
              ],
              [
                47.8899804,
                37.8983619
              ],
              [
                47.9010935,
                37.9064157
              ],
              [
                47.9013701,
                37.9069729
              ],
              [
                47.9055366,
                37.9180826
              ],
              [
                47.9119266,
                37.928365
              ],
              [
                47.9213697,
                37.9339197
              ],
              [
                47.9219263,
                37.9339197
              ],
              [
                47.922483,
                37.9341984
              ],
              [
                47.9230365,
                37.934477
              ],
              [
                47.9238697,
                37.934477
              ],
              [
                47.924983,
                37.9350342
              ],
              [
                47.9258163,
                37.9350342
              ],
              [
                47.9352593,
                37.9403102
              ],
              [
                47.9358165,
                37.9405798
              ],
              [
                47.936093,
                37.941137
              ],
              [
                47.9366497,
                37.9414157
              ],
              [
                47.9372064,
                37.9428088
              ],
              [
                47.9377595,
                37.9466916
              ],
              [
                47.9369262,
                37.9486419
              ],
              [
                47.9366497,
                37.950026
              ],
              [
                47.9297029,
                37.9622492
              ],
              [
                47.9294264,
                37.9625278
              ],
              [
                47.9183163,
                37.9753079
              ],
              [
                47.914703,
                37.983091
              ],
              [
                47.9097032,
                37.9908649
              ],
              [
                47.9060929,
                37.9925275
              ],
              [
                47.9052597,
                37.9925275
              ],
              [
                47.9047031,
                37.9928062
              ],
              [
                47.9041465,
                37.9928061
              ],
              [
                47.9035933,
                37.9930847
              ],
              [
                47.9027596,
                37.9930847
              ],
              [
                47.9024796,
                37.9933633
              ],
              [
                47.9010932,
                37.9933633
              ],
              [
                47.9008131,
                37.9936419
              ],
              [
                47.8969232,
                37.9936419
              ],
              [
                47.8960899,
                37.9933633
              ],
              [
                47.8927563,
                37.9933633
              ],
              [
                47.8922032,
                37.9930847
              ],
              [
                47.8908132,
                37.9930847
              ],
              [
                47.8905367,
                37.9933633
              ],
              [
                47.8852566,
                37.9933633
              ],
              [
                47.8847034,
                37.9936419
              ],
              [
                47.8833132,
                37.9936419
              ],
              [
                47.8827564,
                37.9939205
              ],
              [
                47.88109,
                37.9939205
              ],
              [
                47.8805365,
                37.9941991
              ],
              [
                47.87859,
                37.994199
              ],
              [
                47.8783134,
                37.9944777
              ],
              [
                47.8766465,
                37.9944777
              ],
              [
                47.8763665,
                37.9947563
              ],
              [
                47.8752567,
                37.9947563
              ],
              [
                47.8691468,
                37.9978119
              ],
              [
                47.8685901,
                37.9986387
              ],
              [
                47.8624801,
                38.0064214
              ],
              [
                47.8622001,
                38.0066999
              ],
              [
                47.8619235,
                38.0089196
              ],
              [
                47.8585902,
                38.0311437
              ],
              [
                47.8583101,
                38.0325277
              ],
              [
                47.8580335,
                38.0344777
              ],
              [
                47.8578491,
                38.0358617
              ],
              [
                47.8538666,
                38.051417
              ],
              [
                47.8535899,
                38.0522526
              ],
              [
                47.8533099,
                38.053924
              ],
              [
                47.8530333,
                38.0561436
              ],
              [
                47.8527568,
                38.0578061
              ],
              [
                47.8524766,
                38.0594774
              ],
              [
                47.8522,
                38.0605917
              ],
              [
                47.8519235,
                38.0639166
              ],
              [
                47.8519235,
                38.0667022
              ],
              [
                47.8516434,
                38.0669718
              ],
              [
                47.8463667,
                38.0917006
              ],
              [
                47.8477564,
                38.1164192
              ],
              [
                47.850533,
                38.1289265
              ],
              [
                47.8513666,
                38.133365
              ],
              [
                47.8519232,
                38.1419814
              ],
              [
                47.8521998,
                38.1436437
              ],
              [
                47.8519232,
                38.1439222
              ],
              [
                47.8521997,
                38.1466985
              ],
              [
                47.8519232,
                38.1469769
              ],
              [
                47.8449765,
                38.1664284
              ],
              [
                47.8355332,
                38.1797611
              ],
              [
                47.834143,
                38.1814231
              ],
              [
                47.8269198,
                38.1889248
              ],
              [
                47.8266431,
                38.1892033
              ],
              [
                47.8146964,
                38.1969833
              ],
              [
                47.80942,
                38.2011429
              ],
              [
                47.8088634,
                38.2022568
              ],
              [
                47.8083099,
                38.2025353
              ],
              [
                47.8041398,
                38.2105937
              ],
              [
                47.8033066,
                38.2116987
              ],
              [
                47.7999733,
                38.2200354
              ],
              [
                47.7991401,
                38.2233683
              ],
              [
                47.79914,
                38.2239252
              ],
              [
                47.7988635,
                38.2247607
              ],
              [
                47.7985865,
                38.2264226
              ],
              [
                47.7974732,
                38.2319834
              ],
              [
                47.7874733,
                38.2514228
              ],
              [
                47.7858068,
                38.2525367
              ],
              [
                47.7852498,
                38.2525367
              ],
              [
                47.7846967,
                38.2525367
              ],
              [
                47.7844165,
                38.2528152
              ],
              [
                47.7835834,
                38.2528152
              ],
              [
                47.7805302,
                38.2505963
              ],
              [
                47.7785833,
                38.2461497
              ],
              [
                47.7777501,
                38.2436525
              ],
              [
                47.773307,
                38.236421
              ],
              [
                47.773307,
                38.235873
              ],
              [
                47.7719167,
                38.2347591
              ],
              [
                47.7710835,
                38.2347591
              ],
              [
                47.770807,
                38.2344806
              ],
              [
                47.7699738,
                38.2344806
              ],
              [
                47.7692257,
                38.2342306
              ],
              [
                47.7649737,
                38.2330882
              ],
              [
                47.7646935,
                38.2328097
              ],
              [
                47.7633068,
                38.2328097
              ],
              [
                47.7627502,
                38.2325312
              ],
              [
                47.7596938,
                38.2325313
              ],
              [
                47.7577504,
                38.2322617
              ],
              [
                47.7574739,
                38.2325312
              ],
              [
                47.7563606,
                38.2322617
              ],
              [
                47.7541406,
                38.2325312
              ],
              [
                47.7535839,
                38.2328096
              ],
              [
                47.7510839,
                38.2328097
              ],
              [
                47.7505272,
                38.2330882
              ],
              [
                47.749417,
                38.2330882
              ],
              [
                47.7488604,
                38.2333667
              ],
              [
                47.7485839,
                38.2330881
              ],
              [
                47.7483073,
                38.2333667
              ],
              [
                47.7466372,
                38.2328096
              ],
              [
                47.740804,
                38.2289288
              ],
              [
                47.738584,
                38.2264225
              ],
              [
                47.7383039,
                38.2258745
              ],
              [
                47.736084,
                38.2233682
              ],
              [
                47.7246942,
                38.2122555
              ],
              [
                47.7177476,
                38.211429
              ],
              [
                47.7166375,
                38.2116985
              ],
              [
                47.7141374,
                38.2130909
              ],
              [
                47.7044141,
                38.2161453
              ],
              [
                47.7033043,
                38.2161453
              ],
              [
                47.7013577,
                38.2167023
              ],
              [
                47.6994144,
                38.2167023
              ],
              [
                47.6985812,
                38.2169808
              ],
              [
                47.6980245,
                38.2169807
              ],
              [
                47.685966,
                38.2155306
              ],
              [
                47.6780245,
                38.2139263
              ],
              [
                47.6755248,
                38.2139263
              ],
              [
                47.6749678,
                38.2136478
              ],
              [
                47.6674681,
                38.2136478
              ],
              [
                47.6663582,
                38.2133693
              ],
              [
                47.6588581,
                38.2133693
              ],
              [
                47.6577448,
                38.2130909
              ],
              [
                47.6558014,
                38.2130908
              ],
              [
                47.6546916,
                38.2133693
              ],
              [
                47.6513548,
                38.2133693
              ],
              [
                47.6502449,
                38.2136478
              ],
              [
                47.6483016,
                38.2136477
              ],
              [
                47.6471882,
                38.2139263
              ],
              [
                47.6455214,
                38.2139263
              ],
              [
                47.6399682,
                38.2150312
              ],
              [
                47.6380216,
                38.2150312
              ],
              [
                47.6349649,
                38.2155882
              ],
              [
                47.6338552,
                38.2155882
              ],
              [
                47.6332984,
                38.2158666
              ],
              [
                47.6319117,
                38.2158666
              ],
              [
                47.6232986,
                38.2180946
              ],
              [
                47.6171887,
                38.2183641
              ],
              [
                47.6146887,
                38.2178161
              ],
              [
                47.6132984,
                38.2178161
              ],
              [
                47.6130218,
                38.2175375
              ],
              [
                47.6119085,
                38.2175376
              ],
              [
                47.611632,
                38.2172591
              ],
              [
                47.6107988,
                38.217259
              ],
              [
                47.6060752,
                38.2150311
              ],
              [
                47.6055221,
                38.2147617
              ],
              [
                47.5985754,
                38.2133692
              ],
              [
                47.5977422,
                38.2133691
              ],
              [
                47.5971856,
                38.2130906
              ],
              [
                47.5960753,
                38.2130907
              ],
              [
                47.5952422,
                38.2128122
              ],
              [
                47.5927421,
                38.2128122
              ],
              [
                47.5849658,
                38.2114287
              ],
              [
                47.5838521,
                38.2108716
              ],
              [
                47.5830188,
                38.2108717
              ],
              [
                47.581909,
                38.2103147
              ],
              [
                47.5810754,
                38.2103146
              ],
              [
                47.5807989,
                38.2100362
              ],
              [
                47.5796856,
                38.2100362
              ],
              [
                47.5757956,
                38.2089222
              ],
              [
                47.5746858,
                38.2089222
              ],
              [
                47.5738523,
                38.2086437
              ],
              [
                47.573019,
                38.2086436
              ],
              [
                47.5724624,
                38.2083652
              ],
              [
                47.5713525,
                38.2083652
              ],
              [
                47.5585726,
                38.2030917
              ],
              [
                47.5416293,
                38.1925356
              ],
              [
                47.5396828,
                38.1917001
              ],
              [
                47.5394063,
                38.1914216
              ],
              [
                47.5363495,
                38.1914216
              ],
              [
                47.5360729,
                38.1911431
              ],
              [
                47.5346827,
                38.1914216
              ],
              [
                47.5330162,
                38.1914216
              ],
              [
                47.531906,
                38.1917001
              ],
              [
                47.529963,
                38.1917001
              ],
              [
                47.5277395,
                38.1922571
              ],
              [
                47.527463,
                38.1925356
              ],
              [
                47.5266297,
                38.1925356
              ],
              [
                47.5213496,
                38.1958686
              ],
              [
                47.5207929,
                38.1964257
              ],
              [
                47.5191264,
                38.1969826
              ],
              [
                47.517183,
                38.1972611
              ],
              [
                47.5155161,
                38.1972611
              ],
              [
                47.5102399,
                38.1961471
              ],
              [
                47.5085731,
                38.1958687
              ],
              [
                47.5066265,
                38.1950331
              ],
              [
                47.5060731,
                38.1944761
              ],
              [
                47.5046832,
                38.1939191
              ],
              [
                47.4930165,
                38.1850339
              ],
              [
                47.48885,
                38.1825364
              ],
              [
                47.4880168,
                38.1825363
              ],
              [
                47.4869035,
                38.1819793
              ],
              [
                47.4827366,
                38.1819793
              ],
              [
                47.4763467,
                38.1839198
              ],
              [
                47.4760701,
                38.1841984
              ],
              [
                47.4752369,
                38.1841984
              ],
              [
                47.4744036,
                38.1861479
              ],
              [
                47.4741267,
                38.1875314
              ],
              [
                47.4741266,
                38.1925355
              ],
              [
                47.4744036,
                38.1936495
              ],
              [
                47.4746801,
                38.1947546
              ],
              [
                47.4780134,
                38.2058675
              ],
              [
                47.4807934,
                38.2300332
              ],
              [
                47.4805132,
                38.2303117
              ],
              [
                47.4802367,
                38.2322611
              ],
              [
                47.4799597,
                38.2336445
              ],
              [
                47.4799598,
                38.2342655
              ],
              [
                47.4796796,
                38.2353153
              ],
              [
                47.4794031,
                38.2378128
              ],
              [
                47.4791266,
                38.239762
              ],
              [
                47.4788465,
                38.2405885
              ],
              [
                47.4777366,
                38.2425378
              ],
              [
                47.4688466,
                38.2494817
              ],
              [
                47.4680134,
                38.2494817
              ],
              [
                47.4674598,
                38.2497602
              ],
              [
                47.4663465,
                38.2497602
              ],
              [
                47.4655133,
                38.2494817
              ],
              [
                47.4635698,
                38.2494817
              ],
              [
                47.4624566,
                38.2492033
              ],
              [
                47.4613468,
                38.2492032
              ],
              [
                47.4607902,
                38.2489248
              ],
              [
                47.4580136,
                38.2489248
              ],
              [
                47.4569034,
                38.2486463
              ],
              [
                47.4549568,
                38.2486463
              ],
              [
                47.4507899,
                38.2478109
              ],
              [
                47.4496802,
                38.2478108
              ],
              [
                47.4302336,
                38.2411454
              ],
              [
                47.4130102,
                38.2372556
              ],
              [
                47.4116242,
                38.2372555
              ],
              [
                47.4107906,
                38.2369771
              ],
              [
                47.4071772,
                38.2369771
              ],
              [
                47.4060671,
                38.2372556
              ],
              [
                47.4027341,
                38.2372556
              ],
              [
                47.3985677,
                38.2378125
              ],
              [
                47.3857877,
                38.2439211
              ],
              [
                47.379954,
                38.2486461
              ],
              [
                47.3791211,
                38.2489245
              ],
              [
                47.3777313,
                38.2503169
              ],
              [
                47.3757875,
                38.2514219
              ],
              [
                47.3749455,
                38.2519849
              ],
              [
                47.374773,
                38.2516376
              ],
              [
                47.3491182,
                38.2225318
              ],
              [
                47.348008,
                38.2219838
              ],
              [
                47.3468978,
                38.2205913
              ],
              [
                47.3332851,
                38.2105925
              ],
              [
                47.3113386,
                38.1992012
              ],
              [
                47.3077283,
                38.1978086
              ],
              [
                47.2788387,
                38.1900374
              ],
              [
                47.2774488,
                38.1900375
              ],
              [
                47.2771722,
                38.189759
              ],
              [
                47.258839,
                38.1861474
              ],
              [
                47.240226,
                38.1805861
              ],
              [
                47.2274462,
                38.1753124
              ],
              [
                47.2266125,
                38.1753124
              ],
              [
                47.2260594,
                38.1750339
              ],
              [
                47.2232797,
                38.1744769
              ],
              [
                47.2182795,
                38.1730933
              ],
              [
                47.2177224,
                38.1730932
              ],
              [
                47.2166131,
                38.1725363
              ],
              [
                47.2116129,
                38.1714222
              ],
              [
                47.2099465,
                38.1714221
              ],
              [
                47.2093895,
                38.1711437
              ],
              [
                47.2082793,
                38.1711436
              ],
              [
                47.207723,
                38.1708652
              ],
              [
                47.2063363,
                38.1708651
              ],
              [
                47.2055026,
                38.1705866
              ],
              [
                47.2038362,
                38.1705866
              ],
              [
                47.2032799,
                38.1703081
              ],
              [
                47.2007799,
                38.1703081
              ],
              [
                47.1982294,
                38.1672452
              ],
              [
                47.1585578,
                38.1578348
              ],
              [
                47.1168383,
                38.1544526
              ],
              [
                47.1052618,
                38.1440183
              ],
              [
                47.1067881,
                38.1256572
              ],
              [
                47.1175,
                38.109001
              ],
              [
                47.0975797,
                38.1055089
              ],
              [
                47.0978149,
                38.0872736
              ],
              [
                47.0963311,
                38.0830815
              ],
              [
                47.0960513,
                38.0825334
              ],
              [
                47.0954982,
                38.0805835
              ],
              [
                47.0929983,
                38.0661433
              ],
              [
                47.0916075,
                38.0633666
              ],
              [
                47.0843848,
                38.0569775
              ],
              [
                47.0824418,
                38.0564204
              ],
              [
                47.0807745,
                38.0558632
              ],
              [
                47.0774417,
                38.0558632
              ],
              [
                47.0557716,
                38.0603112
              ],
              [
                47.0332719,
                38.0686412
              ],
              [
                47.031882,
                38.0686412
              ],
              [
                47.0310484,
                38.0689198
              ],
              [
                47.0304922,
                38.0686411
              ],
              [
                47.0296585,
                38.0689197
              ],
              [
                47.0268819,
                38.0689198
              ],
              [
                47.0243818,
                38.0683626
              ],
              [
                47.0227154,
                38.0683626
              ],
              [
                47.0221583,
                38.068084
              ],
              [
                47.0213255,
                38.068084
              ],
              [
                47.0138253,
                38.0664216
              ],
              [
                47.0124386,
                38.0664216
              ],
              [
                47.0096588,
                38.0655859
              ],
              [
                47.0072898,
                38.065322
              ],
              [
                47.0074353,
                38.0650288
              ],
              [
                47.0079924,
                38.0644716
              ],
              [
                47.0138253,
                38.0580826
              ],
              [
                47.014659,
                38.057804
              ],
              [
                47.0296586,
                38.0458614
              ],
              [
                47.0316055,
                38.0403079
              ],
              [
                47.0299384,
                38.0303059
              ],
              [
                47.0316056,
                38.0255791
              ],
              [
                47.0316056,
                38.0253094
              ],
              [
                47.0332721,
                38.022254
              ],
              [
                47.0427153,
                38.0050264
              ],
              [
                47.0438287,
                38.0039209
              ],
              [
                47.0471623,
                38.0000296
              ],
              [
                47.043137,
                37.9987687
              ],
              [
                47.0427153,
                37.9986366
              ],
              [
                47.0416051,
                37.9964168
              ],
              [
                47.0349386,
                37.9855873
              ],
              [
                47.0318824,
                37.9783615
              ],
              [
                47.0307722,
                37.9716929
              ],
              [
                47.0307722,
                37.9625257
              ],
              [
                47.0343825,
                37.9505811
              ],
              [
                47.0346622,
                37.9483611
              ],
              [
                47.0349388,
                37.9466893
              ],
              [
                47.0352154,
                37.9458625
              ],
              [
                47.0352154,
                37.9453053
              ],
              [
                47.0352154,
                37.9428067
              ],
              [
                47.0382725,
                37.9333602
              ],
              [
                47.0393819,
                37.9316975
              ],
              [
                47.0410492,
                37.928363
              ],
              [
                47.042439,
                37.9216937
              ],
              [
                47.0427157,
                37.9214152
              ],
              [
                47.0393821,
                37.8875286
              ],
              [
                47.0343828,
                37.8808589
              ],
              [
                47.0304928,
                37.8766881
              ],
              [
                47.0288257,
                37.8747465
              ],
              [
                47.0271592,
                37.8728049
              ],
              [
                47.0041034,
                37.8508623
              ],
              [
                47.0029931,
                37.8480847
              ],
              [
                47.0027166,
                37.8464126
              ],
              [
                47.0016034,
                37.8400212
              ],
              [
                47.0007697,
                37.8383582
              ],
              [
                46.9985501,
                37.8355804
              ],
              [
                46.9954931,
                37.8316879
              ],
              [
                46.9952165,
                37.8303035
              ],
              [
                46.9952165,
                37.8272471
              ],
              [
                46.995493,
                37.8261324
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555102,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شبستر",
          "name:en": "Shabestar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291739",
          "wikipedia": "en:Shabestar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.0935234,
                38.3211458
              ],
              [
                45.0937309,
                38.3203105
              ],
              [
                45.0951208,
                38.3139243
              ],
              [
                45.0948443,
                38.3133675
              ],
              [
                45.0951209,
                38.3122537
              ],
              [
                45.1087871,
                38.2943077
              ],
              [
                45.1090668,
                38.2940292
              ],
              [
                45.1099005,
                38.2890257
              ],
              [
                45.1100487,
                38.2880934
              ],
              [
                45.1083189,
                38.2723535
              ],
              [
                45.1215359,
                38.252471
              ],
              [
                45.1229092,
                38.2330566
              ],
              [
                45.1256991,
                38.2308651
              ],
              [
                45.129089,
                38.2282022
              ],
              [
                45.1335685,
                38.2178206
              ],
              [
                45.133586,
                38.2177997
              ],
              [
                45.1611605,
                38.1901477
              ],
              [
                45.1611606,
                38.1901475
              ],
              [
                45.2376182,
                38.1759983
              ],
              [
                45.2438245,
                38.1232975
              ],
              [
                45.248222,
                38.0859326
              ],
              [
                45.2725979,
                38.0602567
              ],
              [
                45.3109308,
                38.0061197
              ],
              [
                45.3879284,
                38.0046256
              ],
              [
                45.5271088,
                38.004788
              ],
              [
                45.5340307,
                38.0044649
              ],
              [
                45.5476443,
                38.0044649
              ],
              [
                45.5601438,
                38.0041954
              ],
              [
                45.5612579,
                38.0039167
              ],
              [
                45.5654244,
                38.0039168
              ],
              [
                45.5665338,
                38.0036382
              ],
              [
                45.5726441,
                38.0036382
              ],
              [
                45.5729238,
                38.0033597
              ],
              [
                45.5770903,
                38.0033596
              ],
              [
                45.5773676,
                38.003081
              ],
              [
                45.5784809,
                38.003081
              ],
              [
                45.5795904,
                38.0030811
              ],
              [
                45.5826475,
                38.0030811
              ],
              [
                45.5832006,
                38.0028024
              ],
              [
                45.5862568,
                38.0028024
              ],
              [
                45.5873671,
                38.0025239
              ],
              [
                45.5918141,
                38.0025239
              ],
              [
                45.5923672,
                38.0022453
              ],
              [
                45.6168138,
                38.0022454
              ],
              [
                45.6179272,
                38.0019668
              ],
              [
                45.6257031,
                38.0019668
              ],
              [
                45.6262602,
                38.0016882
              ],
              [
                45.6276469,
                38.0016882
              ],
              [
                45.6282031,
                38.0014097
              ],
              [
                45.6348697,
                38.0014096
              ],
              [
                45.6359838,
                38.0016882
              ],
              [
                45.6465363,
                38.0016882
              ],
              [
                45.6476497,
                38.0019669
              ],
              [
                45.6493169,
                38.0019669
              ],
              [
                45.650703,
                38.0022454
              ],
              [
                45.6526498,
                38.0022455
              ],
              [
                45.6559834,
                38.0028027
              ],
              [
                45.6607062,
                38.0028027
              ],
              [
                45.6618164,
                38.0030813
              ],
              [
                45.6632064,
                38.0030814
              ],
              [
                45.6657063,
                38.0030814
              ],
              [
                45.6662594,
                38.0033599
              ],
              [
                45.6673728,
                38.0033599
              ],
              [
                45.6684829,
                38.00336
              ],
              [
                45.670426,
                38.0033599
              ],
              [
                45.670983,
                38.0036385
              ],
              [
                45.6745963,
                38.0036385
              ],
              [
                45.6762628,
                38.0039171
              ],
              [
                45.6815395,
                38.0039172
              ],
              [
                45.6820965,
                38.0036386
              ],
              [
                45.6873725,
                38.0036385
              ],
              [
                45.6890396,
                38.00336
              ],
              [
                45.6957062,
                38.0033599
              ],
              [
                45.6962625,
                38.0030814
              ],
              [
                45.699039,
                38.0030815
              ],
              [
                45.706819,
                38.0019671
              ],
              [
                45.7084862,
                38.001967
              ],
              [
                45.7098761,
                38.0016884
              ],
              [
                45.7115426,
                38.0016885
              ],
              [
                45.7129293,
                38.0014099
              ],
              [
                45.7148762,
                38.0014099
              ],
              [
                45.7159856,
                38.0011313
              ],
              [
                45.7220959,
                38.0011313
              ],
              [
                45.7232093,
                38.00141
              ],
              [
                45.7282093,
                38.0014099
              ],
              [
                45.7379322,
                38.0008618
              ],
              [
                45.7387658,
                38.0005831
              ],
              [
                45.7437659,
                38.0005832
              ],
              [
                45.7440425,
                38.0008617
              ],
              [
                45.7498754,
                38.0008618
              ],
              [
                45.7551552,
                38.0019671
              ],
              [
                45.7562654,
                38.0019672
              ],
              [
                45.7576553,
                38.0025244
              ],
              [
                45.7618218,
                38.0036388
              ],
              [
                45.7770986,
                38.0089141
              ],
              [
                45.7773784,
                38.0091927
              ],
              [
                45.7779316,
                38.0093315
              ],
              [
                45.8184917,
                38.0258632
              ],
              [
                45.8193245,
                38.0258632
              ],
              [
                45.8209909,
                38.0269686
              ],
              [
                45.8237676,
                38.0280829
              ],
              [
                45.8532143,
                38.0464153
              ],
              [
                45.8545916,
                38.0472761
              ],
              [
                45.8576573,
                38.049192
              ],
              [
                45.8684942,
                38.0569741
              ],
              [
                45.8887704,
                38.0780821
              ],
              [
                45.889604,
                38.0794749
              ],
              [
                45.9071066,
                38.1033585
              ],
              [
                45.9076597,
                38.1037282
              ],
              [
                45.9171068,
                38.109199
              ],
              [
                45.9204397,
                38.1105828
              ],
              [
                45.9401627,
                38.1200263
              ],
              [
                45.9407198,
                38.1203048
              ],
              [
                45.9996882,
                38.148688
              ],
              [
                46.0210355,
                38.1578756
              ],
              [
                46.0331786,
                38.1651739
              ],
              [
                46.0479227,
                38.1732678
              ],
              [
                46.0594395,
                38.1797549
              ],
              [
                46.0760892,
                38.184743
              ],
              [
                46.084037,
                38.1836982
              ],
              [
                46.094597,
                38.1796501
              ],
              [
                46.104487,
                38.1835373
              ],
              [
                46.1115608,
                38.1913629
              ],
              [
                46.1158847,
                38.1915813
              ],
              [
                46.1297746,
                38.1838219
              ],
              [
                46.1388106,
                38.179115
              ],
              [
                46.150975,
                38.1805992
              ],
              [
                46.1599197,
                38.1821427
              ],
              [
                46.1620073,
                38.1813501
              ],
              [
                46.1622732,
                38.1793177
              ],
              [
                46.1614512,
                38.1772443
              ],
              [
                46.172021,
                38.1749502
              ],
              [
                46.1790101,
                38.1763681
              ],
              [
                46.188554,
                38.1804163
              ],
              [
                46.192692,
                38.1810658
              ],
              [
                46.2089703,
                38.1839332
              ],
              [
                46.222849,
                38.1882985
              ],
              [
                46.2328941,
                38.1923815
              ],
              [
                46.2409979,
                38.1983012
              ],
              [
                46.2455953,
                38.2024716
              ],
              [
                46.2470754,
                38.2049355
              ],
              [
                46.248163,
                38.2114752
              ],
              [
                46.2501974,
                38.2173443
              ],
              [
                46.252379,
                38.2219921
              ],
              [
                46.2550162,
                38.2439777
              ],
              [
                46.2583147,
                38.2650064
              ],
              [
                46.2597369,
                38.2833344
              ],
              [
                46.2637887,
                38.3011465
              ],
              [
                46.2654551,
                38.3069759
              ],
              [
                46.271845,
                38.3155896
              ],
              [
                46.2723989,
                38.3167034
              ],
              [
                46.2732318,
                38.3194788
              ],
              [
                46.2735123,
                38.3258649
              ],
              [
                46.2710122,
                38.3325383
              ],
              [
                46.2698988,
                38.3341999
              ],
              [
                46.2690651,
                38.3350352
              ],
              [
                46.267955,
                38.3380889
              ],
              [
                46.267955,
                38.3411426
              ],
              [
                46.2693448,
                38.3461453
              ],
              [
                46.2740652,
                38.3530879
              ],
              [
                46.2762887,
                38.3558721
              ],
              [
                46.2787879,
                38.3725321
              ],
              [
                46.2796215,
                38.3764299
              ],
              [
                46.2854552,
                38.3853119
              ],
              [
                46.2885114,
                38.3919846
              ],
              [
                46.2896216,
                38.3953164
              ],
              [
                46.291288,
                38.3978131
              ],
              [
                46.2940678,
                38.4083742
              ],
              [
                46.2996249,
                38.4183692
              ],
              [
                46.2999015,
                38.4194828
              ],
              [
                46.3126774,
                38.4303128
              ],
              [
                46.3268473,
                38.4372634
              ],
              [
                46.3299004,
                38.4386463
              ],
              [
                46.334624,
                38.4411517
              ],
              [
                46.3382373,
                38.4461534
              ],
              [
                46.3401803,
                38.452538
              ],
              [
                46.3390709,
                38.4564262
              ],
              [
                46.3437905,
                38.4619845
              ],
              [
                46.3440702,
                38.4644807
              ],
              [
                46.3443475,
                38.4658726
              ],
              [
                46.3440701,
                38.4664293
              ],
              [
                46.3410139,
                38.4711524
              ],
              [
                46.339624,
                38.4722569
              ],
              [
                46.3360137,
                38.4728136
              ],
              [
                46.3357372,
                38.473092
              ],
              [
                46.3351809,
                38.4728136
              ],
              [
                46.3301808,
                38.4728136
              ],
              [
                46.3276807,
                38.4725442
              ],
              [
                46.3268471,
                38.4722569
              ],
              [
                46.3257338,
                38.4722569
              ],
              [
                46.3254572,
                38.4719875
              ],
              [
                46.3149007,
                38.4728135
              ],
              [
                46.3140671,
                38.4730919
              ],
              [
                46.3137906,
                38.4728136
              ],
              [
                46.3132343,
                38.473092
              ],
              [
                46.3121241,
                38.4730919
              ],
              [
                46.3115671,
                38.4736486
              ],
              [
                46.3107342,
                38.473927
              ],
              [
                46.3051779,
                38.4803202
              ],
              [
                46.300734,
                38.481703
              ],
              [
                46.3001777,
                38.4817029
              ],
              [
                46.3001777,
                38.4819813
              ],
              [
                46.2993441,
                38.4819813
              ],
              [
                46.2971246,
                38.4822597
              ],
              [
                46.2951776,
                38.4828164
              ],
              [
                46.2946245,
                38.4828164
              ],
              [
                46.294344,
                38.4830947
              ],
              [
                46.2935111,
                38.4830947
              ],
              [
                46.2929541,
                38.4833731
              ],
              [
                46.2907345,
                38.4833731
              ],
              [
                46.2901775,
                38.4830947
              ],
              [
                46.287954,
                38.4830947
              ],
              [
                46.2843445,
                38.4822596
              ],
              [
                46.2735116,
                38.4733701
              ],
              [
                46.271288,
                38.4719874
              ],
              [
                46.2640644,
                38.4697605
              ],
              [
                46.2629542,
                38.4697604
              ],
              [
                46.2621214,
                38.4694821
              ],
              [
                46.2593448,
                38.469482
              ],
              [
                46.2590644,
                38.4697605
              ],
              [
                46.2568447,
                38.4697604
              ],
              [
                46.2529548,
                38.4711522
              ],
              [
                46.2462883,
                38.4711522
              ],
              [
                46.2437882,
                38.4700388
              ],
              [
                46.2351748,
                38.4655939
              ],
              [
                46.2150861,
                38.4579501
              ],
              [
                46.2057726,
                38.4523612
              ],
              [
                46.1994002,
                38.452908
              ],
              [
                46.1946451,
                38.4463032
              ],
              [
                46.1879684,
                38.4397658
              ],
              [
                46.179714,
                38.4318892
              ],
              [
                46.1770225,
                38.4295765
              ],
              [
                46.1749064,
                38.4277824
              ],
              [
                46.1722536,
                38.4253679
              ],
              [
                46.1599077,
                38.4165383
              ],
              [
                46.1477082,
                38.4095591
              ],
              [
                46.1325672,
                38.4018702
              ],
              [
                46.1154325,
                38.3965561
              ],
              [
                46.0907401,
                38.3903867
              ],
              [
                46.0742728,
                38.3875894
              ],
              [
                46.034212,
                38.3837257
              ],
              [
                46.0287414,
                38.3831576
              ],
              [
                46.0138964,
                38.3822694
              ],
              [
                46.0002649,
                38.3821374
              ],
              [
                45.9964513,
                38.3788742
              ],
              [
                45.9932331,
                38.3753404
              ],
              [
                45.9902484,
                38.3742633
              ],
              [
                45.984132,
                38.3741134
              ],
              [
                45.976831,
                38.3755937
              ],
              [
                45.9706413,
                38.3764424
              ],
              [
                45.9630499,
                38.3770088
              ],
              [
                45.9599775,
                38.376116
              ],
              [
                45.9516906,
                38.3736258
              ],
              [
                45.9481663,
                38.3691923
              ],
              [
                45.9456204,
                38.363883
              ],
              [
                45.9441093,
                38.3566294
              ],
              [
                45.9438854,
                38.3510525
              ],
              [
                45.945603,
                38.3443426
              ],
              [
                45.9445629,
                38.3386367
              ],
              [
                45.9413235,
                38.3348241
              ],
              [
                45.9331895,
                38.3301603
              ],
              [
                45.9243106,
                38.3278208
              ],
              [
                45.9147861,
                38.3268228
              ],
              [
                45.9095371,
                38.3251378
              ],
              [
                45.8986366,
                38.3192186
              ],
              [
                45.8927836,
                38.3153385
              ],
              [
                45.8869624,
                38.3136899
              ],
              [
                45.8759565,
                38.3100091
              ],
              [
                45.8633268,
                38.3073824
              ],
              [
                45.8491579,
                38.3058644
              ],
              [
                45.8337265,
                38.3048852
              ],
              [
                45.8220785,
                38.3024273
              ],
              [
                45.809724,
                38.2954824
              ],
              [
                45.8087826,
                38.2949048
              ],
              [
                45.8051185,
                38.2919361
              ],
              [
                45.803461,
                38.2904082
              ],
              [
                45.7984399,
                38.2874103
              ],
              [
                45.7942007,
                38.2866814
              ],
              [
                45.7901675,
                38.2879861
              ],
              [
                45.7868521,
                38.2914555
              ],
              [
                45.7835912,
                38.2932376
              ],
              [
                45.7809137,
                38.2939647
              ],
              [
                45.7793366,
                38.294697
              ],
              [
                45.7763385,
                38.2984581
              ],
              [
                45.7772827,
                38.3028363
              ],
              [
                45.778736,
                38.3069883
              ],
              [
                45.7777077,
                38.3100101
              ],
              [
                45.7745886,
                38.3113234
              ],
              [
                45.7681744,
                38.3110449
              ],
              [
                45.7592896,
                38.3081826
              ],
              [
                45.7491817,
                38.3037801
              ],
              [
                45.7476746,
                38.3039924
              ],
              [
                45.7453636,
                38.3076229
              ],
              [
                45.7404769,
                38.3088106
              ],
              [
                45.7231129,
                38.3099852
              ],
              [
                45.7092538,
                38.3107731
              ],
              [
                45.6881219,
                38.3120977
              ],
              [
                45.6814313,
                38.3129052
              ],
              [
                45.6771397,
                38.313242
              ],
              [
                45.6568138,
                38.3151489
              ],
              [
                45.6427984,
                38.3163177
              ],
              [
                45.6179319,
                38.3214203
              ],
              [
                45.6121823,
                38.3232099
              ],
              [
                45.5786811,
                38.3343742
              ],
              [
                45.5613514,
                38.3435698
              ],
              [
                45.5400151,
                38.3538343
              ],
              [
                45.5230964,
                38.3587698
              ],
              [
                45.5206958,
                38.357253
              ],
              [
                45.5162527,
                38.3603155
              ],
              [
                45.5151394,
                38.360585
              ],
              [
                45.5106963,
                38.3639259
              ],
              [
                45.5093065,
                38.3653091
              ],
              [
                45.5054196,
                38.3667011
              ],
              [
                45.5026399,
                38.3667011
              ],
              [
                45.4979163,
                38.3672579
              ],
              [
                45.4959733,
                38.3680841
              ],
              [
                45.4920825,
                38.3722514
              ],
              [
                45.4895833,
                38.3753139
              ],
              [
                45.485973,
                38.3778105
              ],
              [
                45.4795831,
                38.3792025
              ],
              [
                45.4781932,
                38.3792025
              ],
              [
                45.4773595,
                38.379481
              ],
              [
                45.4756932,
                38.3794809
              ],
              [
                45.4754166,
                38.3797593
              ],
              [
                45.4698602,
                38.3780888
              ],
              [
                45.4654163,
                38.3769752
              ],
              [
                45.4640265,
                38.3769752
              ],
              [
                45.4631937,
                38.3766968
              ],
              [
                45.4615264,
                38.3766968
              ],
              [
                45.460417,
                38.3769752
              ],
              [
                45.4587499,
                38.3769752
              ],
              [
                45.4576365,
                38.3772536
              ],
              [
                45.4559701,
                38.3772536
              ],
              [
                45.4512504,
                38.3786457
              ],
              [
                45.4504168,
                38.3786456
              ],
              [
                45.4343038,
                38.3900332
              ],
              [
                45.4273599,
                38.3936434
              ],
              [
                45.4243037,
                38.3936434
              ],
              [
                45.4137471,
                38.3914252
              ],
              [
                45.4081908,
                38.3903116
              ],
              [
                45.4070806,
                38.3900331
              ],
              [
                45.4059674,
                38.3900332
              ],
              [
                45.4054141,
                38.3897547
              ],
              [
                45.4040234,
                38.3897547
              ],
              [
                45.4031907,
                38.3894763
              ],
              [
                45.4033761,
                38.3951273
              ],
              [
                45.3959487,
                38.3961865
              ],
              [
                45.3840238,
                38.3983671
              ],
              [
                45.3576341,
                38.4069793
              ],
              [
                45.3568012,
                38.4069793
              ],
              [
                45.3565207,
                38.4072577
              ],
              [
                45.3531879,
                38.4072577
              ],
              [
                45.3520777,
                38.4069793
              ],
              [
                45.3504112,
                38.4069793
              ],
              [
                45.3429111,
                38.4047521
              ],
              [
                45.3312413,
                38.3994805
              ],
              [
                45.327631,
                38.3980885
              ],
              [
                45.3267982,
                38.3975318
              ],
              [
                45.3198544,
                38.3958703
              ],
              [
                45.3192981,
                38.3955919
              ],
              [
                45.3176317,
                38.3955918
              ],
              [
                45.3173544,
                38.3953134
              ],
              [
                45.303517,
                38.3845237
              ],
              [
                45.3026842,
                38.3845237
              ],
              [
                45.3021302,
                38.3848023
              ],
              [
                45.2999075,
                38.3848022
              ],
              [
                45.2921269,
                38.3867425
              ],
              [
                45.2896276,
                38.3867425
              ],
              [
                45.2893503,
                38.3870209
              ],
              [
                45.2871276,
                38.3870209
              ],
              [
                45.286294,
                38.3867425
              ],
              [
                45.2849072,
                38.3867424
              ],
              [
                45.2846275,
                38.386464
              ],
              [
                45.2829611,
                38.3864639
              ],
              [
                45.2826837,
                38.3861855
              ],
              [
                45.2796274,
                38.3864639
              ],
              [
                45.2668506,
                38.3967491
              ],
              [
                45.2662943,
                38.397306
              ],
              [
                45.2604613,
                38.3986893
              ],
              [
                45.2585144,
                38.3986892
              ],
              [
                45.2571276,
                38.3989677
              ],
              [
                45.2540714,
                38.3989677
              ],
              [
                45.2535142,
                38.3992462
              ],
              [
                45.2518478,
                38.3992462
              ],
              [
                45.2515712,
                38.3995246
              ],
              [
                45.249904,
                38.3995246
              ],
              [
                45.2490712,
                38.3998031
              ],
              [
                45.2457375,
                38.399803
              ],
              [
                45.2451813,
                38.4000815
              ],
              [
                45.2424212,
                38.3980432
              ],
              [
                45.2435873,
                38.3934736
              ],
              [
                45.2354248,
                38.3905131
              ],
              [
                45.223868,
                38.3831248
              ],
              [
                45.2218583,
                38.3813408
              ],
              [
                45.2025603,
                38.3909172
              ],
              [
                45.1959455,
                38.3903691
              ],
              [
                45.1789992,
                38.3775968
              ],
              [
                45.1720376,
                38.368027
              ],
              [
                45.1709243,
                38.368027
              ],
              [
                45.1684243,
                38.3674701
              ],
              [
                45.1678711,
                38.3671916
              ],
              [
                45.1542576,
                38.3635805
              ],
              [
                45.1514809,
                38.3621881
              ],
              [
                45.1506481,
                38.3621882
              ],
              [
                45.1384325,
                38.3530628
              ],
              [
                45.1061399,
                38.3290841
              ],
              [
                45.0934543,
                38.3219721
              ],
              [
                45.0935234,
                38.3211458
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555122,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان عجب شیر",
          "name:en": "Ajab Shir County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1287775",
          "wikipedia": "en:Ajab Shir County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.4606918,
                37.4644556
              ],
              [
                45.4588598,
                37.4603627
              ],
              [
                45.4627587,
                37.4451104
              ],
              [
                45.4710381,
                37.4219812
              ],
              [
                45.4718856,
                37.3845861
              ],
              [
                45.4983608,
                37.3604861
              ],
              [
                45.5163567,
                37.3483266
              ],
              [
                45.5442443,
                37.3357214
              ],
              [
                45.5457115,
                37.3357075
              ],
              [
                45.547613,
                37.3348653
              ],
              [
                45.5518166,
                37.3332071
              ],
              [
                45.5551695,
                37.3319764
              ],
              [
                45.5564822,
                37.3290021
              ],
              [
                45.5582813,
                37.3271867
              ],
              [
                45.5723531,
                37.3265509
              ],
              [
                45.5857526,
                37.3244002
              ],
              [
                45.5836179,
                37.3155446
              ],
              [
                45.5868276,
                37.3059703
              ],
              [
                45.5953151,
                37.3033496
              ],
              [
                45.6291132,
                37.3035606
              ],
              [
                45.6421216,
                37.3036418
              ],
              [
                45.6580088,
                37.3192978
              ],
              [
                45.6984522,
                37.3421745
              ],
              [
                45.7152064,
                37.3500897
              ],
              [
                45.8384092,
                37.3762426
              ],
              [
                45.9614604,
                37.4023543
              ],
              [
                45.9696916,
                37.4085264
              ],
              [
                45.9740559,
                37.4166761
              ],
              [
                45.9740558,
                37.4172338
              ],
              [
                45.9746128,
                37.4186191
              ],
              [
                45.9790558,
                37.4397314
              ],
              [
                45.9873887,
                37.4622371
              ],
              [
                46.0001686,
                37.4733457
              ],
              [
                46.0004453,
                37.4736246
              ],
              [
                46.0010023,
                37.4739034
              ],
              [
                46.0018351,
                37.4744611
              ],
              [
                46.0026687,
                37.4752886
              ],
              [
                46.0057251,
                37.4766828
              ],
              [
                46.0068352,
                37.4766828
              ],
              [
                46.0101689,
                37.4777892
              ],
              [
                46.0215582,
                37.4797321
              ],
              [
                46.0226684,
                37.4797321
              ],
              [
                46.0229488,
                37.480011
              ],
              [
                46.0251684,
                37.480011
              ],
              [
                46.026002,
                37.4802898
              ],
              [
                46.032392,
                37.4802898
              ],
              [
                46.0454485,
                37.4827904
              ],
              [
                46.0462813,
                37.4827903
              ],
              [
                46.0476713,
                37.4833481
              ],
              [
                46.0485048,
                37.483348
              ],
              [
                46.0487813,
                37.4836269
              ],
              [
                46.049615,
                37.4836269
              ],
              [
                46.058505,
                37.4872337
              ],
              [
                46.0596145,
                37.4875126
              ],
              [
                46.0718381,
                37.498351
              ],
              [
                46.0723943,
                37.4988997
              ],
              [
                46.0762843,
                37.5019578
              ],
              [
                46.082671,
                37.5027853
              ],
              [
                46.0837844,
                37.5025154
              ],
              [
                46.0896174,
                37.5027853
              ],
              [
                46.0907275,
                37.5030641
              ],
              [
                46.0921175,
                37.5030641
              ],
              [
                46.0932276,
                37.5033429
              ],
              [
                46.094894,
                37.5033429
              ],
              [
                46.1021176,
                37.5047371
              ],
              [
                46.1040606,
                37.5050159
              ],
              [
                46.1271205,
                37.5225097
              ],
              [
                46.128063,
                37.5231428
              ],
              [
                46.1290635,
                37.5241826
              ],
              [
                46.1315635,
                37.5255677
              ],
              [
                46.132397,
                37.5264042
              ],
              [
                46.1371207,
                37.5283469
              ],
              [
                46.1385066,
                37.5283469
              ],
              [
                46.1390637,
                37.5283469
              ],
              [
                46.1396199,
                37.5286258
              ],
              [
                46.1418402,
                37.5286257
              ],
              [
                46.1426739,
                37.5283469
              ],
              [
                46.1448966,
                37.5286257
              ],
              [
                46.1479536,
                37.5286257
              ],
              [
                46.1526765,
                37.5300109
              ],
              [
                46.1535101,
                37.5300108
              ],
              [
                46.1546203,
                37.5305684
              ],
              [
                46.1571203,
                37.5305685
              ],
              [
                46.1576766,
                37.5308473
              ],
              [
                46.1582297,
                37.5305685
              ],
              [
                46.1687869,
                37.5322324
              ],
              [
                46.1718432,
                37.5319625
              ],
              [
                46.1729534,
                37.5316838
              ],
              [
                46.1743433,
                37.5316838
              ],
              [
                46.1937513,
                37.5241894
              ],
              [
                46.1978984,
                37.5287251
              ],
              [
                46.2001531,
                37.5304503
              ],
              [
                46.201179,
                37.5314883
              ],
              [
                46.2046743,
                37.5351702
              ],
              [
                46.2068358,
                37.5376885
              ],
              [
                46.2097943,
                37.5399202
              ],
              [
                46.2119805,
                37.5415115
              ],
              [
                46.2140125,
                37.5423009
              ],
              [
                46.2163482,
                37.543017
              ],
              [
                46.2179757,
                37.5440001
              ],
              [
                46.2191963,
                37.5454822
              ],
              [
                46.2375862,
                37.5584262
              ],
              [
                46.2564757,
                37.5892554
              ],
              [
                46.2573093,
                37.5900917
              ],
              [
                46.2592523,
                37.5928706
              ],
              [
                46.2767559,
                37.6131497
              ],
              [
                46.2889757,
                37.6225921
              ],
              [
                46.3011986,
                37.6464852
              ],
              [
                46.3014791,
                37.64787
              ],
              [
                46.3086987,
                37.6612055
              ],
              [
                46.3086988,
                37.6617628
              ],
              [
                46.3095324,
                37.6623204
              ],
              [
                46.3106458,
                37.6639839
              ],
              [
                46.3117551,
                37.6653688
              ],
              [
                46.3228686,
                37.6745406
              ],
              [
                46.3237023,
                37.6756466
              ],
              [
                46.3253686,
                37.6839819
              ],
              [
                46.3317555,
                37.6942595
              ],
              [
                46.3333352,
                37.6987698
              ],
              [
                46.3337017,
                37.6998162
              ],
              [
                46.3334251,
                37.7003737
              ],
              [
                46.3337017,
                37.7006525
              ],
              [
                46.3334251,
                37.7009312
              ],
              [
                46.3331454,
                37.7020372
              ],
              [
                46.3328688,
                37.7031521
              ],
              [
                46.3331358,
                37.7079712
              ],
              [
                46.3324078,
                37.7077971
              ],
              [
                46.3174043,
                37.7000194
              ],
              [
                46.3135175,
                37.6989045
              ],
              [
                46.3118479,
                37.6986257
              ],
              [
                46.3112941,
                37.6986258
              ],
              [
                46.3097711,
                37.6982113
              ],
              [
                46.2990711,
                37.6952988
              ],
              [
                46.2982375,
                37.6947413
              ],
              [
                46.2568484,
                37.6872422
              ],
              [
                46.2543452,
                37.6872422
              ],
              [
                46.2529585,
                37.6869634
              ],
              [
                46.251292,
                37.6869634
              ],
              [
                46.2501787,
                37.6866847
              ],
              [
                46.2457348,
                37.6866847
              ],
              [
                46.244345,
                37.6869635
              ],
              [
                46.238512,
                37.6869634
              ],
              [
                46.2362885,
                37.6872421
              ],
              [
                46.2335119,
                37.6872421
              ],
              [
                46.2318454,
                37.6875209
              ],
              [
                46.2265687,
                37.6875209
              ],
              [
                46.2257352,
                37.6877995
              ],
              [
                46.2143451,
                37.6883481
              ],
              [
                46.2062886,
                37.688348
              ],
              [
                46.2054558,
                37.6880693
              ],
              [
                46.2012886,
                37.6877996
              ],
              [
                46.1968423,
                37.6875208
              ],
              [
                46.1882328,
                37.6875207
              ],
              [
                46.1871226,
                37.687242
              ],
              [
                46.1854561,
                37.687242
              ],
              [
                46.1829561,
                37.6866845
              ],
              [
                46.1798989,
                37.6866845
              ],
              [
                46.1793427,
                37.6864057
              ],
              [
                46.1773989,
                37.6864057
              ],
              [
                46.1712855,
                37.6855695
              ],
              [
                46.1698995,
                37.685021
              ],
              [
                46.1690659,
                37.685021
              ],
              [
                46.1687862,
                37.6847422
              ],
              [
                46.167676,
                37.6847423
              ],
              [
                46.167119,
                37.6844635
              ],
              [
                46.1662862,
                37.683906
              ],
              [
                46.1660096,
                37.6836272
              ],
              [
                46.165176,
                37.6830698
              ],
              [
                46.1506663,
                37.6685278
              ],
              [
                46.1501765,
                37.6677925
              ],
              [
                46.1496195,
                37.6666865
              ],
              [
                46.1440632,
                37.6589083
              ],
              [
                46.1182299,
                37.6375156
              ],
              [
                46.1043406,
                37.632237
              ],
              [
                46.1010069,
                37.6311309
              ],
              [
                46.0953139,
                37.6289514
              ],
              [
                46.0943404,
                37.6286309
              ],
              [
                46.0829502,
                37.6225159
              ],
              [
                46.0660039,
                37.6116796
              ],
              [
                46.0607272,
                37.6105736
              ],
              [
                46.0529473,
                37.6105735
              ],
              [
                46.0343375,
                37.6141795
              ],
              [
                46.0343376,
                37.613631
              ],
              [
                46.0160012,
                37.5975157
              ],
              [
                46.0146145,
                37.5969581
              ],
              [
                46.0140583,
                37.5964005
              ],
              [
                46.012391,
                37.5958519
              ],
              [
                45.9851686,
                37.5858515
              ],
              [
                45.9418325,
                37.5769571
              ],
              [
                45.9354425,
                37.5747357
              ],
              [
                45.9340518,
                37.5741781
              ],
              [
                45.9201657,
                37.5683503
              ],
              [
                45.9196094,
                37.5680716
              ],
              [
                45.9190523,
                37.5680715
              ],
              [
                45.9182196,
                37.5675139
              ],
              [
                45.9093295,
                37.5650137
              ],
              [
                45.9082193,
                37.5650138
              ],
              [
                45.9071092,
                37.5647349
              ],
              [
                45.9057192,
                37.5647349
              ],
              [
                45.9048856,
                37.5644561
              ],
              [
                45.8973862,
                37.5644561
              ],
              [
                45.8959964,
                37.5647349
              ],
              [
                45.8929393,
                37.5647348
              ],
              [
                45.8921065,
                37.5650137
              ],
              [
                45.8909963,
                37.5650137
              ],
              [
                45.8893298,
                37.5652925
              ],
              [
                45.8868298,
                37.5652924
              ],
              [
                45.8690497,
                37.5669562
              ],
              [
                45.8654395,
                37.5669562
              ],
              [
                45.8629394,
                37.567235
              ],
              [
                45.8596065,
                37.567235
              ],
              [
                45.8576596,
                37.5675137
              ],
              [
                45.8534931,
                37.5675138
              ],
              [
                45.8515501,
                37.5677925
              ],
              [
                45.8501603,
                37.5675137
              ],
              [
                45.8462734,
                37.5675137
              ],
              [
                45.8451601,
                37.5672349
              ],
              [
                45.84266,
                37.567235
              ],
              [
                45.8415499,
                37.5669561
              ],
              [
                45.8398835,
                37.5669561
              ],
              [
                45.8387701,
                37.5666773
              ],
              [
                45.8368263,
                37.5666773
              ],
              [
                45.835717,
                37.5663985
              ],
              [
                45.8337701,
                37.5663985
              ],
              [
                45.8326599,
                37.5661197
              ],
              [
                45.8298832,
                37.5661196
              ],
              [
                45.8271035,
                37.5658499
              ],
              [
                45.8168266,
                37.5666773
              ],
              [
                45.8029372,
                37.5700137
              ],
              [
                45.784047,
                37.5791779
              ],
              [
                45.7696005,
                37.5822356
              ],
              [
                45.7518244,
                37.5847357
              ],
              [
                45.7407109,
                37.5877933
              ],
              [
                45.7393209,
                37.5877933
              ],
              [
                45.7184876,
                37.5911297
              ],
              [
                45.7173783,
                37.5913994
              ],
              [
                45.7140446,
                37.5911297
              ],
              [
                45.7104312,
                37.5911296
              ],
              [
                45.7101546,
                37.5908509
              ],
              [
                45.7081683,
                37.5909843
              ],
              [
                45.6980614,
                37.5908731
              ],
              [
                45.6806133,
                37.590681
              ],
              [
                45.6457637,
                37.590427
              ],
              [
                45.5744935,
                37.5903127
              ],
              [
                45.5465689,
                37.5929293
              ],
              [
                45.5223037,
                37.5924467
              ],
              [
                45.5225365,
                37.5832222
              ],
              [
                45.4702849,
                37.5362969
              ],
              [
                45.4722672,
                37.5292754
              ],
              [
                45.475158,
                37.498832
              ],
              [
                45.4606918,
                37.4644556
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555172,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کلیبر",
          "name:en": "Kaleybar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286210",
          "wikipedia": "en:Kaleybar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.6849188,
                38.7867174
              ],
              [
                46.6899188,
                38.7853264
              ],
              [
                46.6915853,
                38.7853264
              ],
              [
                46.6924188,
                38.7850482
              ],
              [
                46.697419,
                38.7850482
              ],
              [
                46.7110318,
                38.7828228
              ],
              [
                46.7163085,
                38.7811625
              ],
              [
                46.7221422,
                38.7792152
              ],
              [
                46.7607549,
                38.7689401
              ],
              [
                46.76107,
                38.7687828
              ],
              [
                46.7713114,
                38.7639324
              ],
              [
                46.7810351,
                38.7528223
              ],
              [
                46.7810351,
                38.7522658
              ],
              [
                46.7815882,
                38.7517184
              ],
              [
                46.7838118,
                38.7450503
              ],
              [
                46.7846447,
                38.7411554
              ],
              [
                46.7846446,
                38.7408771
              ],
              [
                46.7863119,
                38.7361565
              ],
              [
                46.7885346,
                38.7336614
              ],
              [
                46.7935347,
                38.730601
              ],
              [
                46.7963113,
                38.7303228
              ],
              [
                46.797145,
                38.7303228
              ],
              [
                46.7988114,
                38.7300446
              ],
              [
                46.8035349,
                38.72921
              ],
              [
                46.8046482,
                38.72921
              ],
              [
                46.8154812,
                38.7392169
              ],
              [
                46.8160344,
                38.7403208
              ],
              [
                46.8190914,
                38.7431029
              ],
              [
                46.8299245,
                38.7506057
              ],
              [
                46.8307573,
                38.7506057
              ],
              [
                46.8329808,
                38.7506057
              ],
              [
                46.8346472,
                38.7506057
              ],
              [
                46.8352044,
                38.7503275
              ],
              [
                46.8360379,
                38.7503275
              ],
              [
                46.8543705,
                38.7358784
              ],
              [
                46.8554806,
                38.735322
              ],
              [
                46.8638176,
                38.7261586
              ],
              [
                46.8782609,
                38.7139347
              ],
              [
                46.8790938,
                38.7125436
              ],
              [
                46.8818743,
                38.7089355
              ],
              [
                46.890484,
                38.6989371
              ],
              [
                46.8918739,
                38.696433
              ],
              [
                46.8996506,
                38.6939378
              ],
              [
                46.900764,
                38.6939377
              ],
              [
                46.9010405,
                38.6936595
              ],
              [
                46.9021507,
                38.6936596
              ],
              [
                46.902707,
                38.6936595
              ],
              [
                46.9182635,
                38.6936596
              ],
              [
                46.9185401,
                38.6933814
              ],
              [
                46.9196534,
                38.6933814
              ],
              [
                46.9315967,
                38.6889385
              ],
              [
                46.932145,
                38.6887555
              ],
              [
                46.9352069,
                38.687269
              ],
              [
                46.9379867,
                38.6864343
              ],
              [
                46.946597,
                38.6839301
              ],
              [
                46.9721531,
                38.6803219
              ],
              [
                46.9738195,
                38.680322
              ],
              [
                46.9746563,
                38.6800438
              ],
              [
                46.9763235,
                38.6800437
              ],
              [
                46.9779899,
                38.6794872
              ],
              [
                46.9857667,
                38.6786615
              ],
              [
                46.9868761,
                38.6783833
              ],
              [
                46.9904894,
                38.6783832
              ],
              [
                46.9915997,
                38.678105
              ],
              [
                46.9929895,
                38.678105
              ],
              [
                47.0021561,
                38.6756008
              ],
              [
                47.0029898,
                38.6756008
              ],
              [
                47.0135463,
                38.6697665
              ],
              [
                47.0257692,
                38.664767
              ],
              [
                47.0338264,
                38.6633756
              ],
              [
                47.0346593,
                38.6630974
              ],
              [
                47.0413258,
                38.6619934
              ],
              [
                47.0460462,
                38.6606021
              ],
              [
                47.0471596,
                38.6606022
              ],
              [
                47.048826,
                38.6600455
              ],
              [
                47.0502158,
                38.6600456
              ],
              [
                47.0513261,
                38.6597674
              ],
              [
                47.0532691,
                38.6597673
              ],
              [
                47.0591028,
                38.6583761
              ],
              [
                47.0666023,
                38.657272
              ],
              [
                47.1027156,
                38.638377
              ],
              [
                47.1068852,
                38.6319947
              ],
              [
                47.1074384,
                38.6297686
              ],
              [
                47.1071619,
                38.624212
              ],
              [
                47.1068853,
                38.6228205
              ],
              [
                47.1046618,
                38.6169946
              ],
              [
                47.1049392,
                38.6167074
              ],
              [
                47.1096619,
                38.6153249
              ],
              [
                47.110219,
                38.6150466
              ],
              [
                47.1104955,
                38.6153249
              ],
              [
                47.1143855,
                38.6153249
              ],
              [
                47.1149387,
                38.6156032
              ],
              [
                47.1163285,
                38.6156033
              ],
              [
                47.1166051,
                38.6158815
              ],
              [
                47.1182724,
                38.6158815
              ],
              [
                47.1260522,
                38.6175422
              ],
              [
                47.1271616,
                38.6175423
              ],
              [
                47.1291085,
                38.6180988
              ],
              [
                47.1302187,
                38.6180988
              ],
              [
                47.1307749,
                38.6183771
              ],
              [
                47.133275,
                38.6183771
              ],
              [
                47.1335515,
                38.6186554
              ],
              [
                47.1354954,
                38.6186554
              ],
              [
                47.135775,
                38.6183771
              ],
              [
                47.1374415,
                38.6183772
              ],
              [
                47.1379953,
                38.6180988
              ],
              [
                47.1391087,
                38.6180989
              ],
              [
                47.1443854,
                38.6164292
              ],
              [
                47.1457753,
                38.6161599
              ],
              [
                47.151052,
                38.6144902
              ],
              [
                47.1518848,
                38.6144902
              ],
              [
                47.1521653,
                38.6143322
              ],
              [
                47.1532747,
                38.6217165
              ],
              [
                47.1527184,
                38.624212
              ],
              [
                47.1527184,
                38.6308817
              ],
              [
                47.1529981,
                38.6336555
              ],
              [
                47.1541082,
                38.6383771
              ],
              [
                47.1629983,
                38.6472727
              ],
              [
                47.1641084,
                38.647542
              ],
              [
                47.1671647,
                38.6480986
              ],
              [
                47.1691077,
                38.6486551
              ],
              [
                47.1721648,
                38.6486551
              ],
              [
                47.1738312,
                38.6489334
              ],
              [
                47.1743883,
                38.6486551
              ],
              [
                47.1757742,
                38.6489334
              ],
              [
                47.1841112,
                38.6489334
              ],
              [
                47.1849448,
                38.6486552
              ],
              [
                47.1896645,
                38.6486551
              ],
              [
                47.1910543,
                38.6489334
              ],
              [
                47.1971646,
                38.6489334
              ],
              [
                47.1988311,
                38.6492117
              ],
              [
                47.2016109,
                38.6492117
              ],
              [
                47.2021678,
                38.64949
              ],
              [
                47.2068874,
                38.64949
              ],
              [
                47.2077211,
                38.6497682
              ],
              [
                47.2102211,
                38.6497683
              ],
              [
                47.2177206,
                38.6553245
              ],
              [
                47.2193877,
                38.6580982
              ],
              [
                47.2216104,
                38.6650457
              ],
              [
                47.2218909,
                38.6653239
              ],
              [
                47.2216104,
                38.6661587
              ],
              [
                47.2218909,
                38.6667152
              ],
              [
                47.2216103,
                38.6672717
              ],
              [
                47.2218909,
                38.6689323
              ],
              [
                47.2216104,
                38.669767
              ],
              [
                47.2213338,
                38.671993
              ],
              [
                47.2216104,
                38.6750448
              ],
              [
                47.2218909,
                38.6764361
              ],
              [
                47.2227244,
                38.6778273
              ],
              [
                47.2280003,
                38.6817138
              ],
              [
                47.2302238,
                38.6822704
              ],
              [
                47.2318903,
                38.6825485
              ],
              [
                47.2330004,
                38.6825486
              ],
              [
                47.2335575,
                38.6828268
              ],
              [
                47.2352239,
                38.6828269
              ],
              [
                47.2357771,
                38.6831051
              ],
              [
                47.2457804,
                38.6831052
              ],
              [
                47.2466141,
                38.6833834
              ],
              [
                47.2480008,
                38.6833834
              ],
              [
                47.2510572,
                38.6842092
              ],
              [
                47.2571665,
                38.6869916
              ],
              [
                47.2691137,
                38.6981033
              ],
              [
                47.2699466,
                38.7014332
              ],
              [
                47.2693902,
                38.7028244
              ],
              [
                47.2691137,
                38.7039373
              ],
              [
                47.2682801,
                38.7061632
              ],
              [
                47.266337,
                38.7078236
              ],
              [
                47.2193181,
                38.7351519
              ],
              [
                47.2137639,
                38.7419911
              ],
              [
                47.2088393,
                38.7479542
              ],
              [
                47.2075652,
                38.7518745
              ],
              [
                47.2077207,
                38.7561618
              ],
              [
                47.208114,
                38.7611632
              ],
              [
                47.2101741,
                38.7688074
              ],
              [
                47.212234,
                38.7740984
              ],
              [
                47.2147205,
                38.7781509
              ],
              [
                47.2196375,
                38.7858191
              ],
              [
                47.2243789,
                38.7938735
              ],
              [
                47.2221902,
                38.8016544
              ],
              [
                47.2204545,
                38.8061678
              ],
              [
                47.218951,
                38.8125954
              ],
              [
                47.219245,
                38.8151311
              ],
              [
                47.2254524,
                38.8297568
              ],
              [
                47.230525,
                38.835128
              ],
              [
                47.2378968,
                38.8390922
              ],
              [
                47.2436081,
                38.841381
              ],
              [
                47.2468195,
                38.855786
              ],
              [
                47.2474871,
                38.8634485
              ],
              [
                47.248498,
                38.8694415
              ],
              [
                47.2501372,
                38.8754655
              ],
              [
                47.2534846,
                38.8782051
              ],
              [
                47.2542571,
                38.8804768
              ],
              [
                47.2541713,
                38.8828821
              ],
              [
                47.2578725,
                38.8911294
              ],
              [
                47.2587681,
                38.8953702
              ],
              [
                47.2583746,
                38.8992421
              ],
              [
                47.2565903,
                38.9042514
              ],
              [
                47.2568462,
                38.9067436
              ],
              [
                47.2575616,
                38.9101033
              ],
              [
                47.2577227,
                38.9125522
              ],
              [
                47.2577227,
                38.9139427
              ],
              [
                47.2576377,
                38.9174826
              ],
              [
                47.2582599,
                38.922319
              ],
              [
                47.258316,
                38.9236625
              ],
              [
                47.2580502,
                38.9251132
              ],
              [
                47.2576046,
                38.9256631
              ],
              [
                47.2574329,
                38.9284341
              ],
              [
                47.2561454,
                38.9307043
              ],
              [
                47.2559523,
                38.9325904
              ],
              [
                47.2547507,
                38.934777
              ],
              [
                47.2531269,
                38.9370043
              ],
              [
                47.2519921,
                38.937774
              ],
              [
                47.2502215,
                38.9385853
              ],
              [
                47.2482046,
                38.9399426
              ],
              [
                47.2468113,
                38.9410025
              ],
              [
                47.24635,
                38.9417118
              ],
              [
                47.2446656,
                38.9443487
              ],
              [
                47.2438639,
                38.9462861
              ],
              [
                47.241638,
                38.9520709
              ],
              [
                47.2384614,
                38.9592848
              ],
              [
                47.2374696,
                38.9641587
              ],
              [
                47.2423053,
                38.9661994
              ],
              [
                47.2450089,
                38.9671671
              ],
              [
                47.2465324,
                38.9677009
              ],
              [
                47.2502016,
                38.9700199
              ],
              [
                47.2520363,
                38.9714546
              ],
              [
                47.2531098,
                38.9721056
              ],
              [
                47.2544112,
                38.9727628
              ],
              [
                47.2561454,
                38.9730227
              ],
              [
                47.2584629,
                38.9726724
              ],
              [
                47.2601366,
                38.9707539
              ],
              [
                47.2618961,
                38.9678511
              ],
              [
                47.2626042,
                38.96675
              ],
              [
                47.2641063,
                38.965482
              ],
              [
                47.265737,
                38.9650482
              ],
              [
                47.2669172,
                38.9652151
              ],
              [
                47.2693419,
                38.966483
              ],
              [
                47.2714877,
                38.9679845
              ],
              [
                47.2738051,
                38.9708707
              ],
              [
                47.2756505,
                38.9724055
              ],
              [
                47.2784185,
                38.9753915
              ],
              [
                47.2807359,
                38.9783608
              ],
              [
                47.2836116,
                38.9812306
              ],
              [
                47.2858407,
                38.9828765
              ],
              [
                47.2900845,
                38.9859345
              ],
              [
                47.2941119,
                38.987685
              ],
              [
                47.2980353,
                38.9888192
              ],
              [
                47.3013699,
                38.9892089
              ],
              [
                47.3076203,
                38.9904114
              ],
              [
                47.3107822,
                38.9911092
              ],
              [
                47.3126321,
                38.9934169
              ],
              [
                47.3152006,
                38.9954037
              ],
              [
                47.3192339,
                38.9980387
              ],
              [
                47.3258619,
                39.0064542
              ],
              [
                47.3309673,
                39.0113676
              ],
              [
                47.3380236,
                39.0165026
              ],
              [
                47.3440856,
                39.0200489
              ],
              [
                47.353582,
                39.0222226
              ],
              [
                47.3620145,
                39.0229095
              ],
              [
                47.3717546,
                39.0255495
              ],
              [
                47.3819394,
                39.0310722
              ],
              [
                47.3904275,
                39.0382197
              ],
              [
                47.3929165,
                39.0404689
              ],
              [
                47.3967278,
                39.0447819
              ],
              [
                47.404221,
                39.0519609
              ],
              [
                47.4105543,
                39.0565529
              ],
              [
                47.4147155,
                39.0598967
              ],
              [
                47.4328591,
                39.0693539
              ],
              [
                47.4386753,
                39.0737287
              ],
              [
                47.445782,
                39.0787369
              ],
              [
                47.4517706,
                39.0831725
              ],
              [
                47.461799,
                39.0846382
              ],
              [
                47.468151,
                39.0845
              ],
              [
                47.4737262,
                39.0815733
              ],
              [
                47.4823039,
                39.0785425
              ],
              [
                47.4863236,
                39.0776049
              ],
              [
                47.4980322,
                39.0748089
              ],
              [
                47.528658,
                39.0733013
              ],
              [
                47.5308433,
                39.0795299
              ],
              [
                47.5299684,
                39.0833072
              ],
              [
                47.530514,
                39.0896069
              ],
              [
                47.5355971,
                39.1074665
              ],
              [
                47.5364748,
                39.1188199
              ],
              [
                47.5310675,
                39.1309525
              ],
              [
                47.524293,
                39.1408742
              ],
              [
                47.5247105,
                39.1453012
              ],
              [
                47.5286531,
                39.1519576
              ],
              [
                47.532022,
                39.1656202
              ],
              [
                47.5301311,
                39.1780475
              ],
              [
                47.5281412,
                39.1899164
              ],
              [
                47.5258149,
                39.2052431
              ],
              [
                47.5218496,
                39.2126346
              ],
              [
                47.5188467,
                39.218199
              ],
              [
                47.517924,
                39.2199805
              ],
              [
                47.5172189,
                39.2213192
              ],
              [
                47.5144958,
                39.2258705
              ],
              [
                47.5116521,
                39.2309754
              ],
              [
                47.5099533,
                39.2343706
              ],
              [
                47.5091403,
                39.2369903
              ],
              [
                47.5088455,
                39.2389542
              ],
              [
                47.5084416,
                39.2403773
              ],
              [
                47.5077548,
                39.2431443
              ],
              [
                47.4907892,
                39.2600584
              ],
              [
                47.4905127,
                39.2608924
              ],
              [
                47.4905127,
                39.2611701
              ],
              [
                47.4893989,
                39.2636714
              ],
              [
                47.4888459,
                39.2639495
              ],
              [
                47.4882891,
                39.2650608
              ],
              [
                47.4868992,
                39.2664505
              ],
              [
                47.4866223,
                39.2672842
              ],
              [
                47.4852324,
                39.2686738
              ],
              [
                47.4821758,
                39.2706193
              ],
              [
                47.4810658,
                39.2725645
              ],
              [
                47.4813421,
                39.2753399
              ],
              [
                47.4813424,
                39.2753436
              ],
              [
                47.4813425,
                39.2753436
              ],
              [
                47.4813425,
                39.2753437
              ],
              [
                47.4813429,
                39.2753441
              ],
              [
                47.4817765,
                39.2758608
              ],
              [
                47.4817778,
                39.2758623
              ],
              [
                47.4886135,
                39.283952
              ],
              [
                47.4913457,
                39.286173
              ],
              [
                47.4920538,
                39.2866052
              ],
              [
                47.3904062,
                39.2794366
              ],
              [
                47.3380095,
                39.2797857
              ],
              [
                47.3168493,
                39.2631479
              ],
              [
                47.2971149,
                39.2547705
              ],
              [
                47.2797001,
                39.2461028
              ],
              [
                47.2587163,
                39.2219008
              ],
              [
                47.2346647,
                39.2092321
              ],
              [
                47.2366086,
                39.205341
              ],
              [
                47.2354984,
                39.2000599
              ],
              [
                47.2354983,
                39.1997818
              ],
              [
                47.2354983,
                39.1997817
              ],
              [
                47.2310555,
                39.1875609
              ],
              [
                47.2310555,
                39.1875608
              ],
              [
                47.2310554,
                39.1875606
              ],
              [
                47.2318882,
                39.1861711
              ],
              [
                47.2318882,
                39.1845032
              ],
              [
                47.2318882,
                39.1845031
              ],
              [
                47.2318882,
                39.184503
              ],
              [
                47.2291086,
                39.1806208
              ],
              [
                47.2279984,
                39.1800559
              ],
              [
                47.2263319,
                39.178397
              ],
              [
                47.2263319,
                39.1783968
              ],
              [
                47.2263319,
                39.1775632
              ],
              [
                47.2277217,
                39.1747832
              ],
              [
                47.2267609,
                39.1719276
              ],
              [
                47.2267609,
                39.1719275
              ],
              [
                47.2267609,
                39.1719273
              ],
              [
                47.2263318,
                39.1714476
              ],
              [
                47.222999,
                39.1689459
              ],
              [
                47.2227224,
                39.1686679
              ],
              [
                47.2041088,
                39.1597816
              ],
              [
                47.2027188,
                39.1595036
              ],
              [
                47.1816059,
                39.1520072
              ],
              [
                47.1793855,
                39.1520072
              ],
              [
                47.1788293,
                39.1517292
              ],
              [
                47.1777191,
                39.1517292
              ],
              [
                47.1721628,
                39.1531191
              ],
              [
                47.1638297,
                39.1570018
              ],
              [
                47.1602164,
                39.1578357
              ],
              [
                47.1591062,
                39.1581137
              ],
              [
                47.1504958,
                39.1581137
              ],
              [
                47.1496629,
                39.1578357
              ],
              [
                47.1479965,
                39.1578357
              ],
              [
                47.1079934,
                39.1445015
              ],
              [
                47.1057698,
                39.1431115
              ],
              [
                47.1054933,
                39.1428335
              ],
              [
                47.1038269,
                39.1403406
              ],
              [
                47.1035464,
                39.1397846
              ],
              [
                47.1018799,
                39.1320009
              ],
              [
                47.1021604,
                39.131167
              ],
              [
                47.102437,
                39.1308889
              ],
              [
                47.1027135,
                39.1300549
              ],
              [
                47.108827,
                39.125616
              ],
              [
                47.1116036,
                39.12645
              ],
              [
                47.1135497,
                39.12645
              ],
              [
                47.1203495,
                39.123114
              ],
              [
                47.1207702,
                39.123114
              ],
              [
                47.1227164,
                39.123114
              ],
              [
                47.1232695,
                39.1228361
              ],
              [
                47.12355,
                39.123114
              ],
              [
                47.1246602,
                39.123114
              ],
              [
                47.1254929,
                39.1233921
              ],
              [
                47.1279931,
                39.123392
              ],
              [
                47.1282735,
                39.1231141
              ],
              [
                47.1293829,
                39.1231141
              ],
              [
                47.1296595,
                39.1228361
              ],
              [
                47.1302166,
                39.1228361
              ],
              [
                47.1304932,
                39.1225581
              ],
              [
                47.1313267,
                39.1225581
              ],
              [
                47.1321595,
                39.1220021
              ],
              [
                47.1329932,
                39.1220021
              ],
              [
                47.133273,
                39.121724
              ],
              [
                47.1338268,
                39.1217241
              ],
              [
                47.1343831,
                39.1200561
              ],
              [
                47.1346596,
                39.1197781
              ],
              [
                47.134383,
                39.118388
              ],
              [
                47.1329932,
                39.1161731
              ],
              [
                47.1319966,
                39.1131778
              ],
              [
                47.1318831,
                39.112837
              ],
              [
                47.12994,
                39.1106129
              ],
              [
                47.1291064,
                39.1056178
              ],
              [
                47.1304933,
                39.1028377
              ],
              [
                47.1277166,
                39.0928383
              ],
              [
                47.1271596,
                39.0922822
              ],
              [
                47.1254932,
                39.0906142
              ],
              [
                47.1238267,
                39.08978
              ],
              [
                47.12105,
                39.08978
              ],
              [
                47.1196602,
                39.0903361
              ],
              [
                47.1168836,
                39.0903361
              ],
              [
                47.1157703,
                39.0900581
              ],
              [
                47.1082701,
                39.0869998
              ],
              [
                47.1074366,
                39.0869999
              ],
              [
                47.1018801,
                39.0858877
              ],
              [
                47.1004934,
                39.0847757
              ],
              [
                47.09938,
                39.0831165
              ],
              [
                47.0991035,
                39.0803362
              ],
              [
                47.1004935,
                39.077834
              ],
              [
                47.0999372,
                39.0739417
              ],
              [
                47.0982699,
                39.0722825
              ],
              [
                47.0979934,
                39.0720044
              ],
              [
                47.0952136,
                39.0697803
              ],
              [
                47.0952137,
                39.0639506
              ],
              [
                47.0941035,
                39.0622823
              ],
              [
                47.0941034,
                39.0575558
              ],
              [
                47.0977138,
                39.0495016
              ],
              [
                47.0979935,
                39.0483895
              ],
              [
                47.0988271,
                39.0467212
              ],
              [
                47.1018802,
                39.045053
              ],
              [
                47.1027139,
                39.0447749
              ],
              [
                47.111604,
                39.0411693
              ],
              [
                47.1121603,
                39.0403352
              ],
              [
                47.1113267,
                39.0383889
              ],
              [
                47.1107704,
                39.0353304
              ],
              [
                47.1102172,
                39.0342272
              ],
              [
                47.1096602,
                39.0339491
              ],
              [
                47.1093837,
                39.0320028
              ],
              [
                47.1071602,
                39.0256075
              ],
              [
                47.1074367,
                39.0250514
              ],
              [
                47.1071602,
                39.0247823
              ],
              [
                47.1021609,
                39.013669
              ],
              [
                47.1018804,
                39.0133909
              ],
              [
                47.1016039,
                39.0128348
              ],
              [
                47.1001483,
                38.9985992
              ],
              [
                47.0900311,
                38.9923814
              ],
              [
                47.0858509,
                38.9900105
              ],
              [
                47.0802617,
                38.9851219
              ],
              [
                47.0760069,
                38.9781372
              ],
              [
                47.0751211,
                38.9730482
              ],
              [
                47.0748999,
                38.9705199
              ],
              [
                47.0635477,
                38.9706123
              ],
              [
                47.0627141,
                38.9703342
              ],
              [
                47.0624344,
                38.9706123
              ],
              [
                47.0616008,
                38.9706123
              ],
              [
                47.0613242,
                38.9708904
              ],
              [
                47.0607679,
                38.9706123
              ],
              [
                47.0577148,
                38.9706123
              ],
              [
                47.0554912,
                38.9700562
              ],
              [
                47.0541015,
                38.9700561
              ],
              [
                47.0532677,
                38.9697781
              ],
              [
                47.0477114,
                38.9695
              ],
              [
                47.0471583,
                38.9692218
              ],
              [
                47.0466012,
                38.9692219
              ],
              [
                47.0446859,
                38.9682822
              ],
              [
                47.0438246,
                38.9681095
              ],
              [
                47.0229882,
                38.9608881
              ],
              [
                47.0224351,
                38.9611662
              ],
              [
                47.021878,
                38.9608881
              ],
              [
                47.0171022,
                38.9608214
              ],
              [
                47.0160451,
                38.9606099
              ],
              [
                47.0129879,
                38.96061
              ],
              [
                47.0121551,
                38.9603319
              ],
              [
                47.0107653,
                38.9603319
              ],
              [
                47.009098,
                38.9597757
              ],
              [
                47.0074316,
                38.9597756
              ],
              [
                47.005212,
                38.9592195
              ],
              [
                47.0015987,
                38.9592195
              ],
              [
                47.000765,
                38.9589414
              ],
              [
                46.9990986,
                38.9589414
              ],
              [
                46.9971548,
                38.9592195
              ],
              [
                46.9921555,
                38.9592194
              ],
              [
                46.9907649,
                38.9594975
              ],
              [
                46.9885421,
                38.9594975
              ],
              [
                46.986042,
                38.9600537
              ],
              [
                46.9846554,
                38.9600537
              ],
              [
                46.9782653,
                38.961166
              ],
              [
                46.9749316,
                38.9611661
              ],
              [
                46.9740988,
                38.9614442
              ],
              [
                46.9724323,
                38.9614441
              ],
              [
                46.9710417,
                38.9617222
              ],
              [
                46.9677088,
                38.9617223
              ],
              [
                46.9668752,
                38.9620002
              ],
              [
                46.9657658,
                38.9620003
              ],
              [
                46.9646517,
                38.9617222
              ],
              [
                46.9624321,
                38.9617222
              ],
              [
                46.9560422,
                38.9569946
              ],
              [
                46.9527092,
                38.9539445
              ],
              [
                46.9524288,
                38.9536665
              ],
              [
                46.9415958,
                38.9475572
              ],
              [
                46.9282627,
                38.9447762
              ],
              [
                46.9243728,
                38.9447762
              ],
              [
                46.9221524,
                38.9444981
              ],
              [
                46.9193726,
                38.9447762
              ],
              [
                46.9185391,
                38.944498
              ],
              [
                46.9174296,
                38.9447761
              ],
              [
                46.9154826,
                38.9447762
              ],
              [
                46.9143725,
                38.9450543
              ],
              [
                46.910763,
                38.9450543
              ],
              [
                46.910206,
                38.9453323
              ],
              [
                46.9027058,
                38.9453323
              ],
              [
                46.901873,
                38.9456104
              ],
              [
                46.8974261,
                38.9456104
              ],
              [
                46.8879829,
                38.9470009
              ],
              [
                46.8860398,
                38.9470008
              ],
              [
                46.8835398,
                38.9475571
              ],
              [
                46.8821499,
                38.9475571
              ],
              [
                46.8813163,
                38.9478352
              ],
              [
                46.8804826,
                38.9478351
              ],
              [
                46.8738161,
                38.9458884
              ],
              [
                46.8735364,
                38.9453323
              ],
              [
                46.8671496,
                38.9411607
              ],
              [
                46.8635363,
                38.9378325
              ],
              [
                46.8629831,
                38.9375543
              ],
              [
                46.8540931,
                38.9264389
              ],
              [
                46.8507602,
                38.9139417
              ],
              [
                46.8510368,
                38.9106043
              ],
              [
                46.852147,
                38.9078321
              ],
              [
                46.8488135,
                38.8936656
              ],
              [
                46.8452039,
                38.8892155
              ],
              [
                46.8343702,
                38.8831055
              ],
              [
                46.8340904,
                38.8833837
              ],
              [
                46.8302037,
                38.8844962
              ],
              [
                46.8290904,
                38.8844962
              ],
              [
                46.8271473,
                38.8847744
              ],
              [
                46.8182573,
                38.8847743
              ],
              [
                46.8177002,
                38.8844962
              ],
              [
                46.8168674,
                38.8844961
              ],
              [
                46.8165908,
                38.884218
              ],
              [
                46.8127009,
                38.884218
              ],
              [
                46.8121469,
                38.8839398
              ],
              [
                46.8107571,
                38.8839399
              ],
              [
                46.8096477,
                38.8836617
              ],
              [
                46.8077007,
                38.8836617
              ],
              [
                46.806314,
                38.8833836
              ],
              [
                46.8038108,
                38.8833835
              ],
              [
                46.7979772,
                38.8825492
              ],
              [
                46.7952005,
                38.8825491
              ],
              [
                46.7946443,
                38.882271
              ],
              [
                46.793534,
                38.882271
              ],
              [
                46.7921442,
                38.8819928
              ],
              [
                46.7904777,
                38.8819929
              ],
              [
                46.7871441,
                38.8814365
              ],
              [
                46.7715874,
                38.8797767
              ],
              [
                46.7640881,
                38.878386
              ],
              [
                46.7624209,
                38.878386
              ],
              [
                46.761031,
                38.8781079
              ],
              [
                46.7574216,
                38.8781079
              ],
              [
                46.7568645,
                38.8778297
              ],
              [
                46.7557544,
                38.8778297
              ],
              [
                46.7390883,
                38.8747701
              ],
              [
                46.7349218,
                38.8733883
              ],
              [
                46.7276983,
                38.8689381
              ],
              [
                46.7251982,
                38.8661656
              ],
              [
                46.7246419,
                38.8656093
              ],
              [
                46.7107519,
                38.8447748
              ],
              [
                46.709362,
                38.8419933
              ],
              [
                46.7088089,
                38.8417151
              ],
              [
                46.6863054,
                38.799496
              ],
              [
                46.684639,
                38.7917158
              ],
              [
                46.684639,
                38.7914376
              ],
              [
                46.684639,
                38.7883775
              ],
              [
                46.6849188,
                38.7867174
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555202,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ویژه مراغه",
          "name:en": "Maragheh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291861",
          "wikipedia": "en:Maragheh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.129561,
                37.3362843
              ],
              [
                46.132004,
                37.3360808
              ],
              [
                46.145824,
                37.3303255
              ],
              [
                46.1479664,
                37.3278458
              ],
              [
                46.1498976,
                37.3261209
              ],
              [
                46.153511,
                37.3177808
              ],
              [
                46.1601776,
                37.311393
              ],
              [
                46.1610112,
                37.3111231
              ],
              [
                46.1615643,
                37.3105652
              ],
              [
                46.1729545,
                37.3055629
              ],
              [
                46.1765679,
                37.3013972
              ],
              [
                46.1765679,
                37.3008394
              ],
              [
                46.1779971,
                37.2989474
              ],
              [
                46.1852691,
                37.2767206
              ],
              [
                46.1818783,
                37.2669767
              ],
              [
                46.1768662,
                37.2567891
              ],
              [
                46.1720602,
                37.253668
              ],
              [
                46.2218353,
                37.2224129
              ],
              [
                46.2418469,
                37.2361199
              ],
              [
                46.2426806,
                37.2369477
              ],
              [
                46.2515705,
                37.2477812
              ],
              [
                46.2654598,
                37.2727859
              ],
              [
                46.2726834,
                37.2811176
              ],
              [
                46.2782396,
                37.2841768
              ],
              [
                46.2787929,
                37.2844557
              ],
              [
                46.2793499,
                37.2843162
              ],
              [
                46.2851829,
                37.2744506
              ],
              [
                46.2993496,
                37.2611161
              ],
              [
                46.2996302,
                37.2608372
              ],
              [
                46.3018497,
                37.2594515
              ],
              [
                46.3104632,
                37.2544488
              ],
              [
                46.3168532,
                37.2486183
              ],
              [
                46.3179626,
                37.2461168
              ],
              [
                46.3185197,
                37.2452891
              ],
              [
                46.3185197,
                37.2450011
              ],
              [
                46.3186151,
                37.2447156
              ],
              [
                46.32213,
                37.2322239
              ],
              [
                46.3271293,
                37.2261143
              ],
              [
                46.3440758,
                37.217782
              ],
              [
                46.3446298,
                37.217224
              ],
              [
                46.3458466,
                37.2170161
              ],
              [
                46.3519543,
                37.217822
              ],
              [
                46.3665385,
                37.2119235
              ],
              [
                46.3733777,
                37.2046737
              ],
              [
                46.3736215,
                37.2019888
              ],
              [
                46.3689789,
                37.1850744
              ],
              [
                46.3604279,
                37.1679317
              ],
              [
                46.3450028,
                37.1584846
              ],
              [
                46.3625978,
                37.1375859
              ],
              [
                46.392328,
                37.1331865
              ],
              [
                46.3949125,
                37.1327791
              ],
              [
                46.3968562,
                37.1325001
              ],
              [
                46.4071322,
                37.1294493
              ],
              [
                46.4101894,
                37.1286125
              ],
              [
                46.4108539,
                37.1281672
              ],
              [
                46.4332454,
                37.1038906
              ],
              [
                46.4398715,
                37.1015445
              ],
              [
                46.4401449,
                37.1008417
              ],
              [
                46.4404392,
                37.1012347
              ],
              [
                46.4413562,
                37.1012004
              ],
              [
                46.4475137,
                37.0977485
              ],
              [
                46.4531426,
                37.0964134
              ],
              [
                46.4604757,
                37.0950568
              ],
              [
                46.4638412,
                37.095228
              ],
              [
                46.4680437,
                37.0959245
              ],
              [
                46.4704511,
                37.0962908
              ],
              [
                46.4753601,
                37.0976823
              ],
              [
                46.4796586,
                37.0989421
              ],
              [
                46.4817319,
                37.0996673
              ],
              [
                46.4829444,
                37.0998659
              ],
              [
                46.4865897,
                37.1004768
              ],
              [
                46.4914281,
                37.1003228
              ],
              [
                46.4933677,
                37.0987708
              ],
              [
                46.4954099,
                37.0948949
              ],
              [
                46.4968007,
                37.0920848
              ],
              [
                46.4978742,
                37.0868849
              ],
              [
                46.4976596,
                37.0828109
              ],
              [
                46.4963566,
                37.0768892
              ],
              [
                46.4958829,
                37.0741285
              ],
              [
                46.4953851,
                37.0719572
              ],
              [
                46.4956246,
                37.0696583
              ],
              [
                46.4967155,
                37.0668551
              ],
              [
                46.4966297,
                37.0651087
              ],
              [
                46.4937114,
                37.0605883
              ],
              [
                46.4915027,
                37.0584603
              ],
              [
                46.488959,
                37.0564537
              ],
              [
                46.4829826,
                37.051735
              ],
              [
                46.476953,
                37.0483613
              ],
              [
                46.4666107,
                37.0431049
              ],
              [
                46.4636063,
                37.0417675
              ],
              [
                46.4626622,
                37.0408598
              ],
              [
                46.462276,
                37.0401404
              ],
              [
                46.4624678,
                37.0390896
              ],
              [
                46.462269,
                37.0354984
              ],
              [
                46.461797,
                37.0329132
              ],
              [
                46.4595508,
                37.0299316
              ],
              [
                46.4570617,
                37.0288352
              ],
              [
                46.454892,
                37.0269139
              ],
              [
                46.4527702,
                37.0252378
              ],
              [
                46.4512682,
                37.0231135
              ],
              [
                46.4526844,
                37.0217772
              ],
              [
                46.4589524,
                37.0196189
              ],
              [
                46.4653015,
                37.019036
              ],
              [
                46.4744686,
                37.0172145
              ],
              [
                46.4767984,
                37.0167036
              ],
              [
                46.4776321,
                37.0164246
              ],
              [
                46.4809658,
                37.0164246
              ],
              [
                46.4812423,
                37.0161456
              ],
              [
                46.489019,
                37.0161456
              ],
              [
                46.489855,
                37.0158664
              ],
              [
                46.5040966,
                37.0176314
              ],
              [
                46.5229715,
                37.0273948
              ],
              [
                46.5232481,
                37.0276738
              ],
              [
                46.5243583,
                37.0276738
              ],
              [
                46.5249153,
                37.0279529
              ],
              [
                46.5257482,
                37.0279528
              ],
              [
                46.5263053,
                37.0282318
              ],
              [
                46.5274154,
                37.0282318
              ],
              [
                46.5507514,
                37.0272266
              ],
              [
                46.5579743,
                37.0294499
              ],
              [
                46.5590876,
                37.0294498
              ],
              [
                46.559365,
                37.0297289
              ],
              [
                46.561308,
                37.0302779
              ],
              [
                46.5626979,
                37.0302779
              ],
              [
                46.5660315,
                37.030836
              ],
              [
                46.5665878,
                37.030836
              ],
              [
                46.567698,
                37.031115
              ],
              [
                46.5690878,
                37.0311149
              ],
              [
                46.5729746,
                37.031673
              ],
              [
                46.5760309,
                37.031673
              ],
              [
                46.5768646,
                37.0319521
              ],
              [
                46.5801975,
                37.0322221
              ],
              [
                46.5871445,
                37.0322221
              ],
              [
                46.5879773,
                37.0325012
              ],
              [
                46.5907539,
                37.0325011
              ],
              [
                46.591311,
                37.0327801
              ],
              [
                46.5940875,
                37.0327802
              ],
              [
                46.5949211,
                37.0330592
              ],
              [
                46.611034,
                37.0352824
              ],
              [
                46.6165904,
                37.0363595
              ],
              [
                46.6382572,
                37.0405569
              ],
              [
                46.6407573,
                37.0411149
              ],
              [
                46.6421472,
                37.0411149
              ],
              [
                46.659243,
                37.041821
              ],
              [
                46.6603531,
                37.0418209
              ],
              [
                46.6887763,
                37.0360428
              ],
              [
                46.6904427,
                37.0382664
              ],
              [
                46.6850208,
                37.0509351
              ],
              [
                46.6833883,
                37.0635534
              ],
              [
                46.6833882,
                37.0638324
              ],
              [
                46.658813,
                37.0738943
              ],
              [
                46.6582568,
                37.0750013
              ],
              [
                46.6574232,
                37.0772244
              ],
              [
                46.6571465,
                37.0780614
              ],
              [
                46.65687,
                37.0791684
              ],
              [
                46.6565903,
                37.0819494
              ],
              [
                46.6588129,
                37.0955573
              ],
              [
                46.6585364,
                37.0958363
              ],
              [
                46.6579801,
                37.1011103
              ],
              [
                46.6568699,
                37.1041702
              ],
              [
                46.6568698,
                37.1075001
              ],
              [
                46.6593699,
                37.1158338
              ],
              [
                46.6596464,
                37.1161127
              ],
              [
                46.6604801,
                37.1186146
              ],
              [
                46.6638129,
                37.1236183
              ],
              [
                46.6682559,
                37.1327799
              ],
              [
                46.6690896,
                37.1436151
              ],
              [
                46.6657567,
                37.1519483
              ],
              [
                46.6654792,
                37.1530642
              ],
              [
                46.6568697,
                37.1636201
              ],
              [
                46.6563126,
                37.1638991
              ],
              [
                46.6552032,
                37.1661218
              ],
              [
                46.6546462,
                37.1677866
              ],
              [
                46.6540899,
                37.1691724
              ],
              [
                46.6563125,
                37.1763985
              ],
              [
                46.6571461,
                37.1766685
              ],
              [
                46.6574227,
                37.1772264
              ],
              [
                46.6627025,
                37.1797281
              ],
              [
                46.6638127,
                37.1797281
              ],
              [
                46.6643698,
                37.1800071
              ],
              [
                46.669923,
                37.180007
              ],
              [
                46.6710363,
                37.180286
              ],
              [
                46.6735363,
                37.1802861
              ],
              [
                46.6746457,
                37.1805649
              ],
              [
                46.6793693,
                37.180565
              ],
              [
                46.6824255,
                37.181393
              ],
              [
                46.6838123,
                37.1813929
              ],
              [
                46.684646,
                37.1816719
              ],
              [
                46.6857593,
                37.1816719
              ],
              [
                46.6863124,
                37.1819508
              ],
              [
                46.687146,
                37.1819509
              ],
              [
                46.6949258,
                37.1852804
              ],
              [
                46.6952023,
                37.1855594
              ],
              [
                46.7029823,
                37.1875031
              ],
              [
                46.7057589,
                37.188061
              ],
              [
                46.7104825,
                37.1900048
              ],
              [
                46.7149255,
                37.1933432
              ],
              [
                46.7199256,
                37.1961148
              ],
              [
                46.7218725,
                37.1977795
              ],
              [
                46.7218725,
                37.1997322
              ],
              [
                46.721592,
                37.2000022
              ],
              [
                46.7193724,
                37.2025038
              ],
              [
                46.7168724,
                37.2038985
              ],
              [
                46.7160387,
                37.2047264
              ],
              [
                46.7149254,
                37.2052843
              ],
              [
                46.7146489,
                37.2058421
              ],
              [
                46.7135387,
                37.2064001
              ],
              [
                46.7054822,
                37.2147325
              ],
              [
                46.7038158,
                37.2163972
              ],
              [
                46.6871457,
                37.2302814
              ],
              [
                46.6865927,
                37.2302813
              ],
              [
                46.6860357,
                37.2308393
              ],
              [
                46.6804793,
                37.232504
              ],
              [
                46.679369,
                37.2325039
              ],
              [
                46.6788128,
                37.2327828
              ],
              [
                46.664089,
                37.2327828
              ],
              [
                46.6632562,
                37.2330617
              ],
              [
                46.6610358,
                37.2330617
              ],
              [
                46.660203,
                37.2333407
              ],
              [
                46.6571459,
                37.2333407
              ],
              [
                46.6543693,
                37.2330617
              ],
              [
                46.6529794,
                37.2330617
              ],
              [
                46.6521458,
                37.2333407
              ],
              [
                46.6485325,
                37.2333407
              ],
              [
                46.6476997,
                37.2336196
              ],
              [
                46.6474231,
                37.2333407
              ],
              [
                46.6440894,
                37.2333406
              ],
              [
                46.6429792,
                37.2330617
              ],
              [
                46.6415893,
                37.2330617
              ],
              [
                46.6404799,
                37.2327827
              ],
              [
                46.6390893,
                37.2327828
              ],
              [
                46.638533,
                37.2325038
              ],
              [
                46.6324227,
                37.2325038
              ],
              [
                46.6321431,
                37.2327827
              ],
              [
                46.6313094,
                37.2327827
              ],
              [
                46.6129761,
                37.2475034
              ],
              [
                46.6101995,
                37.2511205
              ],
              [
                46.6099198,
                37.2513994
              ],
              [
                46.6096433,
                37.2519483
              ],
              [
                46.6096432,
                37.2522272
              ],
              [
                46.6093666,
                37.253064
              ],
              [
                46.6093667,
                37.2533429
              ],
              [
                46.6088096,
                37.2547286
              ],
              [
                46.608533,
                37.2550076
              ],
              [
                46.6082533,
                37.2558443
              ],
              [
                46.6079768,
                37.2575089
              ],
              [
                46.6076994,
                37.2586156
              ],
              [
                46.6068666,
                37.261117
              ],
              [
                46.6065861,
                37.2619538
              ],
              [
                46.6063095,
                37.2638973
              ],
              [
                46.606586,
                37.2666775
              ],
              [
                46.6068665,
                37.2677843
              ],
              [
                46.6138096,
                37.2755672
              ],
              [
                46.6143667,
                37.2758461
              ],
              [
                46.6149199,
                37.275846
              ],
              [
                46.6215895,
                37.2902869
              ],
              [
                46.621866,
                37.2911147
              ],
              [
                46.621866,
                37.2977906
              ],
              [
                46.6221426,
                37.2988973
              ],
              [
                46.621866,
                37.2994552
              ],
              [
                46.6221425,
                37.3005617
              ],
              [
                46.6218659,
                37.3016774
              ],
              [
                46.6226995,
                37.3066798
              ],
              [
                46.6235324,
                37.3083442
              ],
              [
                46.6238096,
                37.3089021
              ],
              [
                46.6351989,
                37.3175122
              ],
              [
                46.6388124,
                37.3186188
              ],
              [
                46.6401991,
                37.3186189
              ],
              [
                46.6404796,
                37.3188977
              ],
              [
                46.642146,
                37.3188978
              ],
              [
                46.6426991,
                37.3191767
              ],
              [
                46.6451992,
                37.3191767
              ],
              [
                46.6454788,
                37.3194556
              ],
              [
                46.6479789,
                37.3194556
              ],
              [
                46.6485321,
                37.3197346
              ],
              [
                46.6513126,
                37.3197346
              ],
              [
                46.6560354,
                37.3205623
              ],
              [
                46.6574221,
                37.3211201
              ],
              [
                46.6579791,
                37.32112
              ],
              [
                46.6627019,
                37.3283446
              ],
              [
                46.6632558,
                37.3294512
              ],
              [
                46.663812,
                37.3338956
              ],
              [
                46.6629792,
                37.3375122
              ],
              [
                46.6627018,
                37.3391766
              ],
              [
                46.6624221,
                37.3400132
              ],
              [
                46.6615885,
                37.3413988
              ],
              [
                46.6496452,
                37.3544526
              ],
              [
                46.6493656,
                37.3552893
              ],
              [
                46.6413122,
                37.3625134
              ],
              [
                46.6410325,
                37.363341
              ],
              [
                46.640756,
                37.3641777
              ],
              [
                46.6399223,
                37.3647355
              ],
              [
                46.6393653,
                37.3652842
              ],
              [
                46.6299221,
                37.372787
              ],
              [
                46.6251992,
                37.3819541
              ],
              [
                46.6115856,
                37.3980658
              ],
              [
                46.6113091,
                37.3983446
              ],
              [
                46.5701963,
                37.435847
              ],
              [
                46.5660297,
                37.4411273
              ],
              [
                46.5657532,
                37.4413972
              ],
              [
                46.5651961,
                37.441676
              ],
              [
                46.5651961,
                37.4422337
              ],
              [
                46.5646391,
                37.4425125
              ],
              [
                46.546583,
                37.4780696
              ],
              [
                46.5390829,
                37.4916785
              ],
              [
                46.5385258,
                37.4922361
              ],
              [
                46.5343593,
                37.4950154
              ],
              [
                46.5324163,
                37.4969582
              ],
              [
                46.5146361,
                37.5205681
              ],
              [
                46.5076929,
                37.529733
              ],
              [
                46.506303,
                37.5311271
              ],
              [
                46.4999797,
                37.5375015
              ],
              [
                46.4992631,
                37.544456
              ],
              [
                46.4987752,
                37.5492349
              ],
              [
                46.4958103,
                37.5562019
              ],
              [
                46.4912002,
                37.5687382
              ],
              [
                46.485525,
                37.5783284
              ],
              [
                46.4790686,
                37.5879255
              ],
              [
                46.4740357,
                37.5967564
              ],
              [
                46.4712668,
                37.6052088
              ],
              [
                46.4695529,
                37.6161274
              ],
              [
                46.4691905,
                37.6228761
              ],
              [
                46.4701155,
                37.6322095
              ],
              [
                46.4770602,
                37.6378202
              ],
              [
                46.48427,
                37.6418302
              ],
              [
                46.4892336,
                37.6435059
              ],
              [
                46.4856285,
                37.6525763
              ],
              [
                46.4827325,
                37.659479
              ],
              [
                46.4783944,
                37.6686977
              ],
              [
                46.4756021,
                37.6776718
              ],
              [
                46.4744203,
                37.6843339
              ],
              [
                46.4748944,
                37.6894778
              ],
              [
                46.4753044,
                37.6935179
              ],
              [
                46.4777268,
                37.7010304
              ],
              [
                46.4818668,
                37.7072512
              ],
              [
                46.4927673,
                37.7174361
              ],
              [
                46.497488,
                37.7230373
              ],
              [
                46.4987369,
                37.7277611
              ],
              [
                46.4874147,
                37.7272242
              ],
              [
                46.4833733,
                37.727971
              ],
              [
                46.4799854,
                37.7285553
              ],
              [
                46.4744569,
                37.729159
              ],
              [
                46.4664782,
                37.7292732
              ],
              [
                46.4610934,
                37.7286888
              ],
              [
                46.45602,
                37.727976
              ],
              [
                46.4502742,
                37.7260145
              ],
              [
                46.4488661,
                37.7250302
              ],
              [
                46.4442657,
                37.7228576
              ],
              [
                46.4401267,
                37.720033
              ],
              [
                46.4353942,
                37.7180301
              ],
              [
                46.4296871,
                37.7171866
              ],
              [
                46.4206648,
                37.7177976
              ],
              [
                46.416082,
                37.7196666
              ],
              [
                46.4110361,
                37.723517
              ],
              [
                46.4028604,
                37.7305668
              ],
              [
                46.3931213,
                37.7333234
              ],
              [
                46.3886995,
                37.7355829
              ],
              [
                46.3858652,
                37.735528
              ],
              [
                46.382904,
                37.7357995
              ],
              [
                46.3809299,
                37.7368856
              ],
              [
                46.3788718,
                37.7382807
              ],
              [
                46.3743475,
                37.7420889
              ],
              [
                46.372147,
                37.7433785
              ],
              [
                46.3696138,
                37.7433232
              ],
              [
                46.3665319,
                37.7425355
              ],
              [
                46.3623655,
                37.7404115
              ],
              [
                46.3609367,
                37.7383074
              ],
              [
                46.3610051,
                37.7351779
              ],
              [
                46.3611824,
                37.7341258
              ],
              [
                46.3610551,
                37.7328289
              ],
              [
                46.3592154,
                37.7317766
              ],
              [
                46.3552681,
                37.7311246
              ],
              [
                46.3524595,
                37.7311657
              ],
              [
                46.349481,
                37.731539
              ],
              [
                46.3437958,
                37.731328
              ],
              [
                46.3427896,
                37.7306758
              ],
              [
                46.3407544,
                37.7278636
              ],
              [
                46.3401107,
                37.7259216
              ],
              [
                46.3386516,
                37.7202917
              ],
              [
                46.3331358,
                37.7079712
              ],
              [
                46.3328688,
                37.7031521
              ],
              [
                46.3331454,
                37.7020372
              ],
              [
                46.3334251,
                37.7009312
              ],
              [
                46.3337017,
                37.7006525
              ],
              [
                46.3334251,
                37.7003737
              ],
              [
                46.3337017,
                37.6998162
              ],
              [
                46.3333352,
                37.6987698
              ],
              [
                46.3317555,
                37.6942595
              ],
              [
                46.3253686,
                37.6839819
              ],
              [
                46.3237023,
                37.6756466
              ],
              [
                46.3228686,
                37.6745406
              ],
              [
                46.3117551,
                37.6653688
              ],
              [
                46.3106458,
                37.6639839
              ],
              [
                46.3095324,
                37.6623204
              ],
              [
                46.3086988,
                37.6617628
              ],
              [
                46.3086987,
                37.6612055
              ],
              [
                46.3014791,
                37.64787
              ],
              [
                46.3011986,
                37.6464852
              ],
              [
                46.2889757,
                37.6225921
              ],
              [
                46.2767559,
                37.6131497
              ],
              [
                46.2592523,
                37.5928706
              ],
              [
                46.2573093,
                37.5900917
              ],
              [
                46.2564757,
                37.5892554
              ],
              [
                46.2375862,
                37.5584262
              ],
              [
                46.2191963,
                37.5454822
              ],
              [
                46.2179757,
                37.5440001
              ],
              [
                46.2163482,
                37.543017
              ],
              [
                46.2140125,
                37.5423009
              ],
              [
                46.2119805,
                37.5415115
              ],
              [
                46.2097943,
                37.5399202
              ],
              [
                46.2068358,
                37.5376885
              ],
              [
                46.2046743,
                37.5351702
              ],
              [
                46.201179,
                37.5314883
              ],
              [
                46.2001531,
                37.5304503
              ],
              [
                46.1978984,
                37.5287251
              ],
              [
                46.1937513,
                37.5241894
              ],
              [
                46.192892,
                37.5233525
              ],
              [
                46.1918865,
                37.5232092
              ],
              [
                46.1800096,
                37.5182281
              ],
              [
                46.1758782,
                37.5151806
              ],
              [
                46.1698635,
                37.5054474
              ],
              [
                46.1665268,
                37.5030218
              ],
              [
                46.162838,
                37.4996044
              ],
              [
                46.161391,
                37.4983384
              ],
              [
                46.1606624,
                37.4978211
              ],
              [
                46.1579533,
                37.495572
              ],
              [
                46.152397,
                37.488898
              ],
              [
                46.1518439,
                37.4841758
              ],
              [
                46.1518439,
                37.480569
              ],
              [
                46.1526767,
                37.4755679
              ],
              [
                46.1529541,
                37.4747314
              ],
              [
                46.1526767,
                37.4700091
              ],
              [
                46.1535103,
                37.4655657
              ],
              [
                46.1537869,
                37.4652868
              ],
              [
                46.1537869,
                37.4580639
              ],
              [
                46.1504541,
                37.4511197
              ],
              [
                46.1501775,
                37.4502921
              ],
              [
                46.1306581,
                37.4457118
              ],
              [
                46.1295409,
                37.4449642
              ],
              [
                46.1198365,
                37.4373046
              ],
              [
                46.1129466,
                37.4297752
              ],
              [
                46.1179463,
                37.4243777
              ],
              [
                46.1287239,
                37.4194655
              ],
              [
                46.1347788,
                37.4175869
              ],
              [
                46.1440814,
                37.4163711
              ],
              [
                46.1544888,
                37.4140811
              ],
              [
                46.1582774,
                37.4096314
              ],
              [
                46.1504544,
                37.3952847
              ],
              [
                46.1501778,
                37.394736
              ],
              [
                46.1493442,
                37.3916774
              ],
              [
                46.1496208,
                37.3897343
              ],
              [
                46.1498972,
                37.3888977
              ],
              [
                46.1510107,
                37.3869545
              ],
              [
                46.1601773,
                37.3797308
              ],
              [
                46.1607305,
                37.3794519
              ],
              [
                46.1621211,
                37.3789031
              ],
              [
                46.1624008,
                37.3786153
              ],
              [
                46.1594214,
                37.3713474
              ],
              [
                46.1524578,
                37.3659004
              ],
              [
                46.1465781,
                37.3592068
              ],
              [
                46.1451003,
                37.3502796
              ],
              [
                46.138424,
                37.3497031
              ],
              [
                46.1343357,
                37.3494349
              ],
              [
                46.1266716,
                37.3488515
              ],
              [
                46.1275256,
                37.3420995
              ],
              [
                46.129561,
                37.3362843
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555204,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مرند",
          "name:en": "Marand County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1287758",
          "wikipedia": "en:Marand County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.2424212,
                38.3980432
              ],
              [
                45.2451813,
                38.4000815
              ],
              [
                45.2457375,
                38.399803
              ],
              [
                45.2490712,
                38.3998031
              ],
              [
                45.249904,
                38.3995246
              ],
              [
                45.2515712,
                38.3995246
              ],
              [
                45.2518478,
                38.3992462
              ],
              [
                45.2535142,
                38.3992462
              ],
              [
                45.2540714,
                38.3989677
              ],
              [
                45.2571276,
                38.3989677
              ],
              [
                45.2585144,
                38.3986892
              ],
              [
                45.2604613,
                38.3986893
              ],
              [
                45.2662943,
                38.397306
              ],
              [
                45.2668506,
                38.3967491
              ],
              [
                45.2796274,
                38.3864639
              ],
              [
                45.2826837,
                38.3861855
              ],
              [
                45.2829611,
                38.3864639
              ],
              [
                45.2846275,
                38.386464
              ],
              [
                45.2849072,
                38.3867424
              ],
              [
                45.286294,
                38.3867425
              ],
              [
                45.2871276,
                38.3870209
              ],
              [
                45.2893503,
                38.3870209
              ],
              [
                45.2896276,
                38.3867425
              ],
              [
                45.2921269,
                38.3867425
              ],
              [
                45.2999075,
                38.3848022
              ],
              [
                45.3021302,
                38.3848023
              ],
              [
                45.3026842,
                38.3845237
              ],
              [
                45.303517,
                38.3845237
              ],
              [
                45.3173544,
                38.3953134
              ],
              [
                45.3176317,
                38.3955918
              ],
              [
                45.3192981,
                38.3955919
              ],
              [
                45.3198544,
                38.3958703
              ],
              [
                45.3267982,
                38.3975318
              ],
              [
                45.327631,
                38.3980885
              ],
              [
                45.3312413,
                38.3994805
              ],
              [
                45.3429111,
                38.4047521
              ],
              [
                45.3504112,
                38.4069793
              ],
              [
                45.3520777,
                38.4069793
              ],
              [
                45.3531879,
                38.4072577
              ],
              [
                45.3565207,
                38.4072577
              ],
              [
                45.3568012,
                38.4069793
              ],
              [
                45.3576341,
                38.4069793
              ],
              [
                45.3840238,
                38.3983671
              ],
              [
                45.3959487,
                38.3961865
              ],
              [
                45.4033761,
                38.3951273
              ],
              [
                45.4031907,
                38.3894763
              ],
              [
                45.4040234,
                38.3897547
              ],
              [
                45.4054141,
                38.3897547
              ],
              [
                45.4059674,
                38.3900332
              ],
              [
                45.4070806,
                38.3900331
              ],
              [
                45.4081908,
                38.3903116
              ],
              [
                45.4137471,
                38.3914252
              ],
              [
                45.4243037,
                38.3936434
              ],
              [
                45.4273599,
                38.3936434
              ],
              [
                45.4343038,
                38.3900332
              ],
              [
                45.4504168,
                38.3786456
              ],
              [
                45.4512504,
                38.3786457
              ],
              [
                45.4559701,
                38.3772536
              ],
              [
                45.4576365,
                38.3772536
              ],
              [
                45.4587499,
                38.3769752
              ],
              [
                45.460417,
                38.3769752
              ],
              [
                45.4615264,
                38.3766968
              ],
              [
                45.4631937,
                38.3766968
              ],
              [
                45.4640265,
                38.3769752
              ],
              [
                45.4654163,
                38.3769752
              ],
              [
                45.4698602,
                38.3780888
              ],
              [
                45.4754166,
                38.3797593
              ],
              [
                45.4756932,
                38.3794809
              ],
              [
                45.4773595,
                38.379481
              ],
              [
                45.4781932,
                38.3792025
              ],
              [
                45.4795831,
                38.3792025
              ],
              [
                45.485973,
                38.3778105
              ],
              [
                45.4895833,
                38.3753139
              ],
              [
                45.4920825,
                38.3722514
              ],
              [
                45.4959733,
                38.3680841
              ],
              [
                45.4979163,
                38.3672579
              ],
              [
                45.5026399,
                38.3667011
              ],
              [
                45.5054196,
                38.3667011
              ],
              [
                45.5093065,
                38.3653091
              ],
              [
                45.5106963,
                38.3639259
              ],
              [
                45.5151394,
                38.360585
              ],
              [
                45.5162527,
                38.3603155
              ],
              [
                45.5206958,
                38.357253
              ],
              [
                45.5230964,
                38.3587698
              ],
              [
                45.5400151,
                38.3538343
              ],
              [
                45.5613514,
                38.3435698
              ],
              [
                45.5786811,
                38.3343742
              ],
              [
                45.6121823,
                38.3232099
              ],
              [
                45.6179319,
                38.3214203
              ],
              [
                45.6427984,
                38.3163177
              ],
              [
                45.6568138,
                38.3151489
              ],
              [
                45.6771397,
                38.313242
              ],
              [
                45.6814313,
                38.3129052
              ],
              [
                45.6881219,
                38.3120977
              ],
              [
                45.7092538,
                38.3107731
              ],
              [
                45.7231129,
                38.3099852
              ],
              [
                45.7404769,
                38.3088106
              ],
              [
                45.7453636,
                38.3076229
              ],
              [
                45.7476746,
                38.3039924
              ],
              [
                45.7491817,
                38.3037801
              ],
              [
                45.7592896,
                38.3081826
              ],
              [
                45.7681744,
                38.3110449
              ],
              [
                45.7745886,
                38.3113234
              ],
              [
                45.7777077,
                38.3100101
              ],
              [
                45.778736,
                38.3069883
              ],
              [
                45.7772827,
                38.3028363
              ],
              [
                45.7763385,
                38.2984581
              ],
              [
                45.7793366,
                38.294697
              ],
              [
                45.7809137,
                38.2939647
              ],
              [
                45.7835912,
                38.2932376
              ],
              [
                45.7868521,
                38.2914555
              ],
              [
                45.7901675,
                38.2879861
              ],
              [
                45.7942007,
                38.2866814
              ],
              [
                45.7984399,
                38.2874103
              ],
              [
                45.803461,
                38.2904082
              ],
              [
                45.8051185,
                38.2919361
              ],
              [
                45.8087826,
                38.2949048
              ],
              [
                45.809724,
                38.2954824
              ],
              [
                45.8220785,
                38.3024273
              ],
              [
                45.8337265,
                38.3048852
              ],
              [
                45.8491579,
                38.3058644
              ],
              [
                45.8633268,
                38.3073824
              ],
              [
                45.8759565,
                38.3100091
              ],
              [
                45.8869624,
                38.3136899
              ],
              [
                45.8927836,
                38.3153385
              ],
              [
                45.8986366,
                38.3192186
              ],
              [
                45.9095371,
                38.3251378
              ],
              [
                45.9147861,
                38.3268228
              ],
              [
                45.9243106,
                38.3278208
              ],
              [
                45.9331895,
                38.3301603
              ],
              [
                45.9413235,
                38.3348241
              ],
              [
                45.9445629,
                38.3386367
              ],
              [
                45.945603,
                38.3443426
              ],
              [
                45.9438854,
                38.3510525
              ],
              [
                45.9441093,
                38.3566294
              ],
              [
                45.9456204,
                38.363883
              ],
              [
                45.9481663,
                38.3691923
              ],
              [
                45.9516906,
                38.3736258
              ],
              [
                45.9599775,
                38.376116
              ],
              [
                45.9630499,
                38.3770088
              ],
              [
                45.9706413,
                38.3764424
              ],
              [
                45.976831,
                38.3755937
              ],
              [
                45.984132,
                38.3741134
              ],
              [
                45.9902484,
                38.3742633
              ],
              [
                45.9932331,
                38.3753404
              ],
              [
                45.9964513,
                38.3788742
              ],
              [
                46.0002649,
                38.3821374
              ],
              [
                46.0138964,
                38.3822694
              ],
              [
                46.0287414,
                38.3831576
              ],
              [
                46.034212,
                38.3837257
              ],
              [
                46.0742728,
                38.3875894
              ],
              [
                46.0907401,
                38.3903867
              ],
              [
                46.1154325,
                38.3965561
              ],
              [
                46.1325672,
                38.4018702
              ],
              [
                46.1477082,
                38.4095591
              ],
              [
                46.1599077,
                38.4165383
              ],
              [
                46.1722536,
                38.4253679
              ],
              [
                46.1749064,
                38.4277824
              ],
              [
                46.1770225,
                38.4295765
              ],
              [
                46.179714,
                38.4318892
              ],
              [
                46.1879684,
                38.4397658
              ],
              [
                46.1946451,
                38.4463032
              ],
              [
                46.1994002,
                38.452908
              ],
              [
                46.1886014,
                38.4526105
              ],
              [
                46.1681574,
                38.4568827
              ],
              [
                46.1590404,
                38.4624211
              ],
              [
                46.1529789,
                38.4675404
              ],
              [
                46.1486212,
                38.470619
              ],
              [
                46.1403439,
                38.4778331
              ],
              [
                46.1347381,
                38.4846213
              ],
              [
                46.1288534,
                38.4962493
              ],
              [
                46.1253269,
                38.4988044
              ],
              [
                46.1178406,
                38.5064715
              ],
              [
                46.1109886,
                38.5139404
              ],
              [
                46.1065691,
                38.5190541
              ],
              [
                46.1011261,
                38.5264636
              ],
              [
                46.0967716,
                38.5339239
              ],
              [
                46.0947148,
                38.5407319
              ],
              [
                46.092337,
                38.5467481
              ],
              [
                46.0864559,
                38.5568591
              ],
              [
                46.0818401,
                38.5630062
              ],
              [
                46.0759862,
                38.5704843
              ],
              [
                46.0688623,
                38.5761171
              ],
              [
                46.0625965,
                38.5802979
              ],
              [
                46.0559873,
                38.5844457
              ],
              [
                46.0512722,
                38.5881339
              ],
              [
                46.0496316,
                38.5941933
              ],
              [
                46.052086,
                38.5990888
              ],
              [
                46.0587992,
                38.6045082
              ],
              [
                46.0676866,
                38.6079518
              ],
              [
                46.0662764,
                38.6090314
              ],
              [
                46.0640091,
                38.6109355
              ],
              [
                46.0610228,
                38.6132299
              ],
              [
                46.0543012,
                38.6193182
              ],
              [
                46.0493396,
                38.6252577
              ],
              [
                46.0456824,
                38.630397
              ],
              [
                46.04205,
                38.6375342
              ],
              [
                46.0377182,
                38.6443729
              ],
              [
                46.0328775,
                38.6480062
              ],
              [
                46.027832,
                38.6490714
              ],
              [
                46.0271603,
                38.6494198
              ],
              [
                46.0257351,
                38.6500332
              ],
              [
                46.0223041,
                38.6516262
              ],
              [
                46.0205489,
                38.6528492
              ],
              [
                46.0181029,
                38.6546414
              ],
              [
                46.0153811,
                38.6595712
              ],
              [
                46.0156412,
                38.6654517
              ],
              [
                46.0141479,
                38.6705315
              ],
              [
                46.0100819,
                38.6759259
              ],
              [
                46.0055467,
                38.6793448
              ],
              [
                46.0002494,
                38.6823273
              ],
              [
                45.9973097,
                38.6831145
              ],
              [
                45.9941036,
                38.6845944
              ],
              [
                45.9928894,
                38.6851413
              ],
              [
                45.9888254,
                38.687749
              ],
              [
                45.9831727,
                38.6926689
              ],
              [
                45.9775539,
                38.6976531
              ],
              [
                45.9753483,
                38.6995115
              ],
              [
                45.9731129,
                38.7016087
              ],
              [
                45.970348,
                38.7042391
              ],
              [
                45.9666034,
                38.7080066
              ],
              [
                45.9641718,
                38.7105157
              ],
              [
                45.9546683,
                38.7218881
              ],
              [
                45.9465765,
                38.732494
              ],
              [
                45.9406185,
                38.7396241
              ],
              [
                45.9357325,
                38.7459027
              ],
              [
                45.9339135,
                38.7482122
              ],
              [
                45.9296107,
                38.7498328
              ],
              [
                45.9275132,
                38.7503229
              ],
              [
                45.9261939,
                38.7506613
              ],
              [
                45.9203567,
                38.7527803
              ],
              [
                45.917508,
                38.7537126
              ],
              [
                45.9108715,
                38.7556435
              ],
              [
                45.9032174,
                38.7575427
              ],
              [
                45.8979045,
                38.7600401
              ],
              [
                45.8921792,
                38.7632526
              ],
              [
                45.8902443,
                38.7652502
              ],
              [
                45.8879309,
                38.7671828
              ],
              [
                45.8846468,
                38.7702754
              ],
              [
                45.873004,
                38.7807198
              ],
              [
                45.8599238,
                38.7822552
              ],
              [
                45.8571472,
                38.7813854
              ],
              [
                45.8549601,
                38.7788869
              ],
              [
                45.8525888,
                38.7723187
              ],
              [
                45.8486908,
                38.7672253
              ],
              [
                45.8451765,
                38.765151
              ],
              [
                45.8378396,
                38.7645046
              ],
              [
                45.835154,
                38.763604
              ],
              [
                45.8302617,
                38.7583168
              ],
              [
                45.8256218,
                38.7552606
              ],
              [
                45.8188942,
                38.7551054
              ],
              [
                45.8140411,
                38.7553443
              ],
              [
                45.8092329,
                38.7530307
              ],
              [
                45.8049611,
                38.74826
              ],
              [
                45.79825,
                38.7452099
              ],
              [
                45.782924,
                38.7399831
              ],
              [
                45.7491611,
                38.7370134
              ],
              [
                45.7427104,
                38.7403459
              ],
              [
                45.7359961,
                38.7437319
              ],
              [
                45.7261317,
                38.7511061
              ],
              [
                45.719039,
                38.7558794
              ],
              [
                45.7024488,
                38.7634947
              ],
              [
                45.6887912,
                38.7675358
              ],
              [
                45.6810975,
                38.7681482
              ],
              [
                45.6726109,
                38.7695306
              ],
              [
                45.6605152,
                38.7693068
              ],
              [
                45.6538156,
                38.7684159
              ],
              [
                45.6464148,
                38.7675201
              ],
              [
                45.6314052,
                38.7639588
              ],
              [
                45.6257138,
                38.7621292
              ],
              [
                45.6181805,
                38.7600328
              ],
              [
                45.610707,
                38.7591417
              ],
              [
                45.607681,
                38.7587172
              ],
              [
                45.600346,
                38.7577361
              ],
              [
                45.5872634,
                38.7553935
              ],
              [
                45.5825652,
                38.7568346
              ],
              [
                45.5794131,
                38.7594113
              ],
              [
                45.5725701,
                38.7631657
              ],
              [
                45.5628309,
                38.7658093
              ],
              [
                45.5507842,
                38.7673276
              ],
              [
                45.5346107,
                38.7673841
              ],
              [
                45.5167463,
                38.7644102
              ],
              [
                45.5089668,
                38.7629378
              ],
              [
                45.5000264,
                38.7612725
              ],
              [
                45.4986902,
                38.7595954
              ],
              [
                45.4941905,
                38.7564832
              ],
              [
                45.4901804,
                38.7558368
              ],
              [
                45.4877589,
                38.75664
              ],
              [
                45.4849259,
                38.7579513
              ],
              [
                45.4751521,
                38.7653405
              ],
              [
                45.472663,
                38.7679344
              ],
              [
                45.4677238,
                38.7726343
              ],
              [
                45.4561594,
                38.7829619
              ],
              [
                45.4566578,
                38.7909871
              ],
              [
                45.4629043,
                38.8012434
              ],
              [
                45.4641927,
                38.8081539
              ],
              [
                45.4425385,
                38.8115728
              ],
              [
                45.4298579,
                38.8125487
              ],
              [
                45.4283765,
                38.8131266
              ],
              [
                45.4241088,
                38.8147302
              ],
              [
                45.4207959,
                38.8178156
              ],
              [
                45.4217108,
                38.8235884
              ],
              [
                45.4215746,
                38.8275369
              ],
              [
                45.4221874,
                38.8330457
              ],
              [
                45.4213919,
                38.8378583
              ],
              [
                45.4199027,
                38.8427678
              ],
              [
                45.4173313,
                38.8457117
              ],
              [
                45.413403,
                38.8494431
              ],
              [
                45.4086624,
                38.8524836
              ],
              [
                45.406596,
                38.855709
              ],
              [
                45.4060381,
                38.8588483
              ],
              [
                45.4062409,
                38.8681548
              ],
              [
                45.4057849,
                38.873229
              ],
              [
                45.4043487,
                38.8783719
              ],
              [
                45.401801,
                38.8818322
              ],
              [
                45.3981223,
                38.882601
              ],
              [
                45.392166,
                38.8817658
              ],
              [
                45.3884651,
                38.8811633
              ],
              [
                45.3866526,
                38.8808766
              ],
              [
                45.3822641,
                38.8797098
              ],
              [
                45.3765437,
                38.8780495
              ],
              [
                45.3706478,
                38.877058
              ],
              [
                45.3658796,
                38.8760891
              ],
              [
                45.361714,
                38.8745864
              ],
              [
                45.3534814,
                38.871085
              ],
              [
                45.3482283,
                38.8685122
              ],
              [
                45.3387148,
                38.8646941
              ],
              [
                45.3287846,
                38.8629151
              ],
              [
                45.3211767,
                38.8610772
              ],
              [
                45.3182582,
                38.8604531
              ],
              [
                45.3082496,
                38.8598515
              ],
              [
                45.2993709,
                38.8609336
              ],
              [
                45.29387,
                38.8631597
              ],
              [
                45.2872218,
                38.8665623
              ],
              [
                45.2842249,
                38.8686656
              ],
              [
                45.2820427,
                38.8705241
              ],
              [
                45.2831822,
                38.8719934
              ],
              [
                45.2815158,
                38.8736622
              ],
              [
                45.2806822,
                38.873106
              ],
              [
                45.2776991,
                38.8680208
              ],
              [
                45.2774194,
                38.8677427
              ],
              [
                45.2781728,
                38.8670312
              ],
              [
                45.2755981,
                38.8630989
              ],
              [
                45.2694183,
                38.7925076
              ],
              [
                45.2657467,
                38.7852611
              ],
              [
                45.2732847,
                38.7714842
              ],
              [
                45.2691411,
                38.7650015
              ],
              [
                45.2713616,
                38.753891
              ],
              [
                45.2715163,
                38.7430984
              ],
              [
                45.2751266,
                38.7333787
              ],
              [
                45.2756836,
                38.7331006
              ],
              [
                45.2756837,
                38.7319877
              ],
              [
                45.2754071,
                38.7314312
              ],
              [
                45.2751266,
                38.7303183
              ],
              [
                45.2734602,
                38.7278233
              ],
              [
                45.2730703,
                38.7224017
              ],
              [
                45.2714032,
                38.7171244
              ],
              [
                45.2689039,
                38.7126727
              ],
              [
                45.2641914,
                38.7048074
              ],
              [
                45.2578016,
                38.6945217
              ],
              [
                45.2575219,
                38.6906351
              ],
              [
                45.2511927,
                38.6821203
              ],
              [
                45.2495263,
                38.6776679
              ],
              [
                45.2492466,
                38.6771204
              ],
              [
                45.2492466,
                38.6768331
              ],
              [
                45.2474088,
                38.6708118
              ],
              [
                45.2476853,
                38.6694205
              ],
              [
                45.2432423,
                38.6669159
              ],
              [
                45.2418524,
                38.6666466
              ],
              [
                45.240186,
                38.6666466
              ],
              [
                45.240186,
                38.6663684
              ],
              [
                45.2396289,
                38.6663684
              ],
              [
                45.2387954,
                38.6641421
              ],
              [
                45.2404626,
                38.6630291
              ],
              [
                45.2401859,
                38.6624726
              ],
              [
                45.2374054,
                38.6591422
              ],
              [
                45.2410189,
                38.6574726
              ],
              [
                45.2526274,
                38.6467107
              ],
              [
                45.2526274,
                38.6461541
              ],
              [
                45.253461,
                38.6453194
              ],
              [
                45.2579041,
                38.6353197
              ],
              [
                45.2590174,
                38.6317021
              ],
              [
                45.2581838,
                38.6289284
              ],
              [
                45.2579042,
                38.6283718
              ],
              [
                45.2616672,
                38.6178629
              ],
              [
                45.2680541,
                38.6131407
              ],
              [
                45.2691673,
                38.6070271
              ],
              [
                45.2658092,
                38.5985816
              ],
              [
                45.2617943,
                38.5939273
              ],
              [
                45.2620708,
                38.5919792
              ],
              [
                45.2623513,
                38.5900401
              ],
              [
                45.2686499,
                38.5776953
              ],
              [
                45.2594211,
                38.554295
              ],
              [
                45.2597008,
                38.5540165
              ],
              [
                45.2652541,
                38.5431761
              ],
              [
                45.2750014,
                38.5333961
              ],
              [
                45.2961157,
                38.5210412
              ],
              [
                45.3264998,
                38.4953845
              ],
              [
                45.3356041,
                38.4764312
              ],
              [
                45.3297613,
                38.4616542
              ],
              [
                45.3149985,
                38.450228
              ],
              [
                45.2762887,
                38.4367303
              ],
              [
                45.273509,
                38.4358951
              ],
              [
                45.2575484,
                38.4342346
              ],
              [
                45.2468238,
                38.4338039
              ],
              [
                45.2418197,
                38.4335346
              ],
              [
                45.2404338,
                38.4338039
              ],
              [
                45.2354337,
                38.4335345
              ],
              [
                45.2283736,
                38.4307204
              ],
              [
                45.2257345,
                38.4219909
              ],
              [
                45.2301977,
                38.4127105
              ],
              [
                45.2424212,
                38.3980432
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555212,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ملکان",
          "name:en": "Malekan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1568034",
          "wikipedia": "en:Malekan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.9106636,
                37.1731239
              ],
              [
                45.9124446,
                37.1735
              ],
              [
                45.9158563,
                37.1744575
              ],
              [
                45.9197187,
                37.1763553
              ],
              [
                45.9221434,
                37.1764408
              ],
              [
                45.9246791,
                37.1768877
              ],
              [
                45.927864,
                37.1775374
              ],
              [
                45.9297929,
                37.1777714
              ],
              [
                45.932254,
                37.1777714
              ],
              [
                45.9355991,
                37.1768598
              ],
              [
                45.9400445,
                37.1756783
              ],
              [
                45.9426652,
                37.1756838
              ],
              [
                45.9474454,
                37.1749999
              ],
              [
                45.9505956,
                37.1741055
              ],
              [
                45.9547065,
                37.1731771
              ],
              [
                45.9565502,
                37.1726876
              ],
              [
                45.9599304,
                37.1726964
              ],
              [
                45.9628989,
                37.1716223
              ],
              [
                45.9653973,
                37.1705624
              ],
              [
                45.9661531,
                37.1695162
              ],
              [
                45.9679555,
                37.1684903
              ],
              [
                45.9713459,
                37.168969
              ],
              [
                45.9749937,
                37.1680115
              ],
              [
                45.9797573,
                37.1667462
              ],
              [
                45.9832294,
                37.1656433
              ],
              [
                45.9861037,
                37.1649593
              ],
              [
                45.9888055,
                37.1632768
              ],
              [
                45.9907865,
                37.1612058
              ],
              [
                45.9931039,
                37.160214
              ],
              [
                45.9950351,
                37.1582303
              ],
              [
                45.9977312,
                37.1568034
              ],
              [
                46.0007528,
                37.1553326
              ],
              [
                46.0033984,
                37.1540275
              ],
              [
                46.0048423,
                37.153275
              ],
              [
                46.0062568,
                37.1514226
              ],
              [
                46.0093367,
                37.1472219
              ],
              [
                46.0101704,
                37.144999
              ],
              [
                46.0118869,
                37.1433106
              ],
              [
                46.0129737,
                37.1416404
              ],
              [
                46.0135327,
                37.1396334
              ],
              [
                46.0146183,
                37.1383396
              ],
              [
                46.0163111,
                37.1376159
              ],
              [
                46.0180807,
                37.1373298
              ],
              [
                46.0213422,
                37.1376719
              ],
              [
                46.0253763,
                37.1377061
              ],
              [
                46.0303115,
                37.1356192
              ],
              [
                46.0332848,
                37.1340897
              ],
              [
                46.0355901,
                37.1313083
              ],
              [
                46.0367265,
                37.1285151
              ],
              [
                46.0372638,
                37.1274762
              ],
              [
                46.0368347,
                37.1248757
              ],
              [
                46.0383796,
                37.1224805
              ],
              [
                46.0397524,
                37.1205482
              ],
              [
                46.0396671,
                37.1183057
              ],
              [
                46.0420274,
                37.1176897
              ],
              [
                46.0430574,
                37.1157734
              ],
              [
                46.0446882,
                37.114644
              ],
              [
                46.0450315,
                37.1138227
              ],
              [
                46.0445165,
                37.1130356
              ],
              [
                46.0443409,
                37.111082
              ],
              [
                46.0457562,
                37.109629
              ],
              [
                46.0482931,
                37.1093737
              ],
              [
                46.0485838,
                37.1088263
              ],
              [
                46.0475762,
                37.1080667
              ],
              [
                46.0470485,
                37.1064988
              ],
              [
                46.0495376,
                37.1042398
              ],
              [
                46.0527563,
                37.1031788
              ],
              [
                46.0531793,
                37.1024562
              ],
              [
                46.0532444,
                37.102368
              ],
              [
                46.0541296,
                37.1011251
              ],
              [
                46.0550892,
                37.1003523
              ],
              [
                46.0545158,
                37.0979076
              ],
              [
                46.0549879,
                37.0967781
              ],
              [
                46.0549449,
                37.0952035
              ],
              [
                46.0624888,
                37.0879605
              ],
              [
                46.0702387,
                37.0808077
              ],
              [
                46.0801696,
                37.0705701
              ],
              [
                46.0867881,
                37.0645265
              ],
              [
                46.0933596,
                37.0584359
              ],
              [
                46.0970275,
                37.0549483
              ],
              [
                46.1021218,
                37.0588451
              ],
              [
                46.1048675,
                37.0575729
              ],
              [
                46.1071602,
                37.0571469
              ],
              [
                46.1115932,
                37.0554511
              ],
              [
                46.1242532,
                37.0489436
              ],
              [
                46.1339199,
                37.045133
              ],
              [
                46.1347997,
                37.0447905
              ],
              [
                46.1361301,
                37.0438313
              ],
              [
                46.1375892,
                37.0420758
              ],
              [
                46.1381042,
                37.0416648
              ],
              [
                46.1404967,
                37.0407656
              ],
              [
                46.1416983,
                37.0404829
              ],
              [
                46.1434257,
                37.0402688
              ],
              [
                46.1442947,
                37.0399177
              ],
              [
                46.1450243,
                37.0392497
              ],
              [
                46.1496377,
                37.0375541
              ],
              [
                46.153135,
                37.0358072
              ],
              [
                46.154766,
                37.0344195
              ],
              [
                46.1560535,
                37.0325353
              ],
              [
                46.1553239,
                37.0302399
              ],
              [
                46.154809,
                37.0271564
              ],
              [
                46.1545515,
                37.0254776
              ],
              [
                46.1562681,
                37.01955
              ],
              [
                46.1560749,
                37.0178025
              ],
              [
                46.1548948,
                37.0164147
              ],
              [
                46.1549789,
                37.0151171
              ],
              [
                46.1556243,
                37.0139303
              ],
              [
                46.1567831,
                37.0125939
              ],
              [
                46.1585426,
                37.0109833
              ],
              [
                46.1602592,
                37.0100923
              ],
              [
                46.1657799,
                37.0084539
              ],
              [
                46.1689281,
                37.0047118
              ],
              [
                46.1699152,
                37.0010447
              ],
              [
                46.1714172,
                36.9986798
              ],
              [
                46.1724975,
                36.9980092
              ],
              [
                46.175971,
                36.9976763
              ],
              [
                46.1769564,
                36.9945469
              ],
              [
                46.1758953,
                36.9844383
              ],
              [
                46.1760241,
                36.9829693
              ],
              [
                46.1762807,
                36.9753928
              ],
              [
                46.1751038,
                36.9681942
              ],
              [
                46.1725783,
                36.9632976
              ],
              [
                46.171844,
                36.9593991
              ],
              [
                46.1755568,
                36.9528007
              ],
              [
                46.1805068,
                36.948936
              ],
              [
                46.1827338,
                36.947855
              ],
              [
                46.188397,
                36.9441509
              ],
              [
                46.1937098,
                36.9413669
              ],
              [
                46.1964579,
                36.953436
              ],
              [
                46.1995907,
                36.9540144
              ],
              [
                46.2008295,
                36.9540486
              ],
              [
                46.2061311,
                36.9549355
              ],
              [
                46.2104584,
                36.9557586
              ],
              [
                46.2141005,
                36.956591
              ],
              [
                46.2178035,
                36.9586589
              ],
              [
                46.2224864,
                36.9625118
              ],
              [
                46.2267779,
                36.9654608
              ],
              [
                46.2314557,
                36.9709812
              ],
              [
                46.2325287,
                36.9726611
              ],
              [
                46.2339877,
                36.9741698
              ],
              [
                46.2344813,
                36.9746668
              ],
              [
                46.2364983,
                36.9745126
              ],
              [
                46.2387514,
                36.9735869
              ],
              [
                46.2414336,
                36.9721297
              ],
              [
                46.2435154,
                36.9708586
              ],
              [
                46.2446287,
                36.9702757
              ],
              [
                46.245375,
                36.969989
              ],
              [
                46.2475195,
                36.9689065
              ],
              [
                46.2497082,
                36.9675304
              ],
              [
                46.2511754,
                36.9671066
              ],
              [
                46.2524199,
                36.966798
              ],
              [
                46.2562723,
                36.9665532
              ],
              [
                46.2599086,
                36.9666266
              ],
              [
                46.2623977,
                36.9685124
              ],
              [
                46.2656164,
                36.9686496
              ],
              [
                46.269298,
                36.9674842
              ],
              [
                46.2714958,
                36.9661808
              ],
              [
                46.2749273,
                36.9639567
              ],
              [
                46.2769031,
                36.9627176
              ],
              [
                46.2777969,
                36.9626878
              ],
              [
                46.2812805,
                36.9635062
              ],
              [
                46.2838182,
                36.9657498
              ],
              [
                46.286466,
                36.9676595
              ],
              [
                46.2885855,
                36.9692809
              ],
              [
                46.290121,
                36.971564
              ],
              [
                46.2907219,
                36.9729012
              ],
              [
                46.2940692,
                36.9792438
              ],
              [
                46.2994991,
                36.98751
              ],
              [
                46.3035106,
                36.9977544
              ],
              [
                46.3037631,
                37.0029108
              ],
              [
                46.3043583,
                37.0048004
              ],
              [
                46.3054847,
                37.0080361
              ],
              [
                46.3086605,
                37.0144444
              ],
              [
                46.3084796,
                37.0157685
              ],
              [
                46.3176342,
                37.0202686
              ],
              [
                46.346408,
                37.0336894
              ],
              [
                46.3545143,
                37.0386275
              ],
              [
                46.3694088,
                37.0463893
              ],
              [
                46.3763053,
                37.0488913
              ],
              [
                46.3943194,
                37.0594239
              ],
              [
                46.4103698,
                37.0667524
              ],
              [
                46.4252167,
                37.0734606
              ],
              [
                46.4282869,
                37.0743027
              ],
              [
                46.4319133,
                37.0772131
              ],
              [
                46.4325142,
                37.0796097
              ],
              [
                46.4329219,
                37.0808423
              ],
              [
                46.433351,
                37.0825541
              ],
              [
                46.4338231,
                37.0838893
              ],
              [
                46.4347886,
                37.0850705
              ],
              [
                46.4359689,
                37.087039
              ],
              [
                46.4368271,
                37.089384
              ],
              [
                46.437943,
                37.0902741
              ],
              [
                46.4397883,
                37.0913353
              ],
              [
                46.4403891,
                37.0922082
              ],
              [
                46.4398527,
                37.0928757
              ],
              [
                46.4391446,
                37.0946044
              ],
              [
                46.4391875,
                37.096333
              ],
              [
                46.4398039,
                37.098697
              ],
              [
                46.4401449,
                37.1008417
              ],
              [
                46.4398715,
                37.1015445
              ],
              [
                46.4332454,
                37.1038906
              ],
              [
                46.4108539,
                37.1281672
              ],
              [
                46.4101894,
                37.1286125
              ],
              [
                46.4071322,
                37.1294493
              ],
              [
                46.3968562,
                37.1325001
              ],
              [
                46.3949125,
                37.1327791
              ],
              [
                46.392328,
                37.1331865
              ],
              [
                46.3625978,
                37.1375859
              ],
              [
                46.3450028,
                37.1584846
              ],
              [
                46.3604279,
                37.1679317
              ],
              [
                46.3689789,
                37.1850744
              ],
              [
                46.3736215,
                37.2019888
              ],
              [
                46.3733777,
                37.2046737
              ],
              [
                46.3665385,
                37.2119235
              ],
              [
                46.3519543,
                37.217822
              ],
              [
                46.3458466,
                37.2170161
              ],
              [
                46.3446298,
                37.217224
              ],
              [
                46.3440758,
                37.217782
              ],
              [
                46.3271293,
                37.2261143
              ],
              [
                46.32213,
                37.2322239
              ],
              [
                46.3186151,
                37.2447156
              ],
              [
                46.3185197,
                37.2450011
              ],
              [
                46.3185197,
                37.2452891
              ],
              [
                46.3179626,
                37.2461168
              ],
              [
                46.3168532,
                37.2486183
              ],
              [
                46.3104632,
                37.2544488
              ],
              [
                46.3018497,
                37.2594515
              ],
              [
                46.2996302,
                37.2608372
              ],
              [
                46.2993496,
                37.2611161
              ],
              [
                46.2851829,
                37.2744506
              ],
              [
                46.2793499,
                37.2843162
              ],
              [
                46.2787929,
                37.2844557
              ],
              [
                46.2782396,
                37.2841768
              ],
              [
                46.2726834,
                37.2811176
              ],
              [
                46.2654598,
                37.2727859
              ],
              [
                46.2515705,
                37.2477812
              ],
              [
                46.2426806,
                37.2369477
              ],
              [
                46.2418469,
                37.2361199
              ],
              [
                46.2218353,
                37.2224129
              ],
              [
                46.1720602,
                37.253668
              ],
              [
                46.1719488,
                37.2535988
              ],
              [
                46.1706095,
                37.2531264
              ],
              [
                46.1697669,
                37.2528273
              ],
              [
                46.1673121,
                37.252221
              ],
              [
                46.1624014,
                37.2511192
              ],
              [
                46.15883,
                37.250345
              ],
              [
                46.1553223,
                37.2493601
              ],
              [
                46.1516872,
                37.2483617
              ],
              [
                46.1482835,
                37.2473965
              ],
              [
                46.1423414,
                37.2467674
              ],
              [
                46.1355853,
                37.2466649
              ],
              [
                46.1289145,
                37.2467303
              ],
              [
                46.1228804,
                37.247775
              ],
              [
                46.1177612,
                37.249898
              ],
              [
                46.1131412,
                37.2514865
              ],
              [
                46.1103701,
                37.2524671
              ],
              [
                46.1046624,
                37.254175
              ],
              [
                46.0989384,
                37.2553989
              ],
              [
                46.0930346,
                37.2559647
              ],
              [
                46.0871361,
                37.2556004
              ],
              [
                46.0821455,
                37.2545805
              ],
              [
                46.0758715,
                37.2519081
              ],
              [
                46.0685709,
                37.2521874
              ],
              [
                46.0611956,
                37.2497751
              ],
              [
                46.0567062,
                37.2465897
              ],
              [
                46.0591769,
                37.2413976
              ],
              [
                46.0594591,
                37.2386188
              ],
              [
                46.0600226,
                37.2330495
              ],
              [
                46.0525841,
                37.2190279
              ],
              [
                46.0493218,
                37.2114883
              ],
              [
                46.0468403,
                37.205622
              ],
              [
                46.0464906,
                37.204731
              ],
              [
                46.0444236,
                37.1959823
              ],
              [
                46.0381307,
                37.1932516
              ],
              [
                46.0277458,
                37.1894226
              ],
              [
                46.0207728,
                37.1885204
              ],
              [
                46.0149621,
                37.1892891
              ],
              [
                46.0082629,
                37.1918529
              ],
              [
                45.9997426,
                37.1920154
              ],
              [
                45.9920067,
                37.1902321
              ],
              [
                45.9829231,
                37.1924798
              ],
              [
                45.9776709,
                37.1939208
              ],
              [
                45.9748422,
                37.1950413
              ],
              [
                45.9615354,
                37.1975231
              ],
              [
                45.9566772,
                37.1983775
              ],
              [
                45.9517539,
                37.1987072
              ],
              [
                45.9487101,
                37.1988482
              ],
              [
                45.944603,
                37.1987262
              ],
              [
                45.9399104,
                37.1978432
              ],
              [
                45.9348035,
                37.1962536
              ],
              [
                45.9297609,
                37.1942537
              ],
              [
                45.9263062,
                37.1921513
              ],
              [
                45.923109,
                37.1900317
              ],
              [
                45.9187531,
                37.1865444
              ],
              [
                45.9169936,
                37.1844588
              ],
              [
                45.914526,
                37.1812107
              ],
              [
                45.9128737,
                37.1782701
              ],
              [
                45.9118223,
                37.1762869
              ],
              [
                45.9106636,
                37.1731239
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555226,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میانه",
          "name:en": "Mianeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291711",
          "wikipedia": "en:Mianeh County (Iran)"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.2229745,
                37.5614024
              ],
              [
                47.2201395,
                37.5590033
              ],
              [
                47.2277282,
                37.550016
              ],
              [
                47.2356658,
                37.5394025
              ],
              [
                47.2368785,
                37.5306945
              ],
              [
                47.2360975,
                37.5234605
              ],
              [
                47.2342029,
                37.5056934
              ],
              [
                47.2379794,
                37.4971365
              ],
              [
                47.2537421,
                37.4922941
              ],
              [
                47.2682495,
                37.4891476
              ],
              [
                47.2860456,
                37.4829272
              ],
              [
                47.2960645,
                37.4702911
              ],
              [
                47.2996748,
                37.4655688
              ],
              [
                47.2999545,
                37.4650111
              ],
              [
                47.2993982,
                37.4591824
              ],
              [
                47.2905082,
                37.4461305
              ],
              [
                47.2891184,
                37.4447362
              ],
              [
                47.2641187,
                37.4064066
              ],
              [
                47.2641188,
                37.4041756
              ],
              [
                47.2643954,
                37.4027903
              ],
              [
                47.2699517,
                37.3950089
              ],
              [
                47.2910655,
                37.3852934
              ],
              [
                47.2924514,
                37.3841779
              ],
              [
                47.292732,
                37.3833502
              ],
              [
                47.2932851,
                37.3827925
              ],
              [
                47.2935648,
                37.3819559
              ],
              [
                47.2932851,
                37.3766751
              ],
              [
                47.2924515,
                37.3750108
              ],
              [
                47.2907851,
                37.3736254
              ],
              [
                47.2885655,
                37.3719521
              ],
              [
                47.2763418,
                37.3647371
              ],
              [
                47.2668956,
                37.3530688
              ],
              [
                47.266619,
                37.3508466
              ],
              [
                47.2671753,
                37.3497311
              ],
              [
                47.2674526,
                37.3494523
              ],
              [
                47.2677292,
                37.3489034
              ],
              [
                47.285232,
                37.3405637
              ],
              [
                47.2882851,
                37.3391782
              ],
              [
                47.2888422,
                37.3391783
              ],
              [
                47.2988417,
                37.3344549
              ],
              [
                47.3016222,
                37.3322328
              ],
              [
                47.3043988,
                37.3283462
              ],
              [
                47.3052317,
                37.3266817
              ],
              [
                47.3052316,
                37.3264029
              ],
              [
                47.3052317,
                37.3255662
              ],
              [
                47.3057888,
                37.3241806
              ],
              [
                47.3057887,
                37.3200061
              ],
              [
                47.3066215,
                37.3169562
              ],
              [
                47.3055083,
                37.3122328
              ],
              [
                47.298009,
                37.3080672
              ],
              [
                47.2966222,
                37.3080671
              ],
              [
                47.2938424,
                37.3075093
              ],
              [
                47.2916189,
                37.3066815
              ],
              [
                47.2846758,
                37.3039014
              ],
              [
                47.2832852,
                37.3027858
              ],
              [
                47.2807859,
                37.2983412
              ],
              [
                47.280786,
                37.2947333
              ],
              [
                47.2818992,
                37.292511
              ],
              [
                47.2818993,
                37.2902886
              ],
              [
                47.2746756,
                37.2841795
              ],
              [
                47.274396,
                37.2833426
              ],
              [
                47.2721757,
                37.2780612
              ],
              [
                47.2724522,
                37.2766755
              ],
              [
                47.2788422,
                37.2725097
              ],
              [
                47.2810657,
                37.2722308
              ],
              [
                47.2821759,
                37.2719519
              ],
              [
                47.2830087,
                37.2722308
              ],
              [
                47.2855088,
                37.2722308
              ],
              [
                47.2863424,
                37.2725098
              ],
              [
                47.2907854,
                37.2725098
              ],
              [
                47.291066,
                37.2722308
              ],
              [
                47.293009,
                37.2722308
              ],
              [
                47.2935652,
                37.2719519
              ],
              [
                47.2943988,
                37.271952
              ],
              [
                47.2946754,
                37.271673
              ],
              [
                47.2968989,
                37.2708453
              ],
              [
                47.2985654,
                37.2689018
              ],
              [
                47.3024553,
                37.2594542
              ],
              [
                47.3174557,
                37.2452918
              ],
              [
                47.3177322,
                37.2450038
              ],
              [
                47.3230121,
                37.239731
              ],
              [
                47.3243989,
                37.2377874
              ],
              [
                47.3255122,
                37.2366806
              ],
              [
                47.3257888,
                37.2358439
              ],
              [
                47.3369023,
                37.2244523
              ],
              [
                47.3402352,
                37.2227876
              ],
              [
                47.3405117,
                37.2225086
              ],
              [
                47.3410935,
                37.2224962
              ],
              [
                47.3416219,
                37.2222297
              ],
              [
                47.342179,
                37.2219508
              ],
              [
                47.3519018,
                37.210568
              ],
              [
                47.3535683,
                37.2075085
              ],
              [
                47.3574583,
                37.2005617
              ],
              [
                47.3577349,
                37.2002827
              ],
              [
                47.3574584,
                37.1958375
              ],
              [
                47.352459,
                37.1847331
              ],
              [
                47.3521786,
                37.1841752
              ],
              [
                47.3491223,
                37.1777861
              ],
              [
                47.3491224,
                37.1732318
              ],
              [
                47.3488457,
                37.1727828
              ],
              [
                47.3491223,
                37.1725128
              ],
              [
                47.352459,
                37.170839
              ],
              [
                47.3538451,
                37.170839
              ],
              [
                47.3663453,
                37.1683374
              ],
              [
                47.3680117,
                37.1683374
              ],
              [
                47.3902381,
                37.1644498
              ],
              [
                47.3924584,
                37.1644499
              ],
              [
                47.3969046,
                37.163622
              ],
              [
                47.3996812,
                37.163622
              ],
              [
                47.4002383,
                37.163343
              ],
              [
                47.4024578,
                37.163343
              ],
              [
                47.4027384,
                37.1630641
              ],
              [
                47.4046814,
                37.1630641
              ],
              [
                47.4049579,
                37.1627851
              ],
              [
                47.4069048,
                37.1627851
              ],
              [
                47.4077384,
                37.1625061
              ],
              [
                47.4088479,
                37.1625061
              ],
              [
                47.4094049,
                37.1622272
              ],
              [
                47.4102377,
                37.1622272
              ],
              [
                47.4219044,
                37.1591765
              ],
              [
                47.4244044,
                37.1586186
              ],
              [
                47.4252381,
                37.1586186
              ],
              [
                47.4260709,
                37.1583396
              ],
              [
                47.4271811,
                37.1583397
              ],
              [
                47.4280179,
                37.1580607
              ],
              [
                47.4341277,
                37.1580607
              ],
              [
                47.4349614,
                37.1583397
              ],
              [
                47.4360711,
                37.1583397
              ],
              [
                47.4363512,
                37.1586186
              ],
              [
                47.4380176,
                37.1586186
              ],
              [
                47.4388513,
                37.1588976
              ],
              [
                47.439961,
                37.1588976
              ],
              [
                47.4405177,
                37.1591766
              ],
              [
                47.457461,
                37.1639011
              ],
              [
                47.5038538,
                37.1838966
              ],
              [
                47.507187,
                37.1850125
              ],
              [
                47.5105203,
                37.1855614
              ],
              [
                47.5132969,
                37.1855614
              ],
              [
                47.513577,
                37.1852824
              ],
              [
                47.5202436,
                37.1836178
              ],
              [
                47.5491333,
                37.1661241
              ],
              [
                47.5491333,
                37.1658361
              ],
              [
                47.5499665,
                37.1652871
              ],
              [
                47.550517,
                37.1650082
              ],
              [
                47.5510764,
                37.1647292
              ],
              [
                47.5535764,
                37.1633434
              ],
              [
                47.5563566,
                37.1608416
              ],
              [
                47.5746899,
                37.1461192
              ],
              [
                47.5899695,
                37.1258436
              ],
              [
                47.591913,
                37.1238998
              ],
              [
                47.6180262,
                37.0980617
              ],
              [
                47.6183027,
                37.0972248
              ],
              [
                47.6205263,
                37.0927879
              ],
              [
                47.6208028,
                37.0919508
              ],
              [
                47.6210829,
                37.0916718
              ],
              [
                47.6252494,
                37.0841748
              ],
              [
                47.6258025,
                37.0838959
              ],
              [
                47.6274693,
                37.0822309
              ],
              [
                47.6288592,
                37.0813939
              ],
              [
                47.6291358,
                37.0811148
              ],
              [
                47.6440371,
                37.0495936
              ],
              [
                47.6448707,
                37.0495936
              ],
              [
                47.6448708,
                37.0493145
              ],
              [
                47.6454274,
                37.0493145
              ],
              [
                47.6457039,
                37.0490355
              ],
              [
                47.6549822,
                37.0577032
              ],
              [
                47.6728854,
                37.066302
              ],
              [
                47.6899976,
                37.076313
              ],
              [
                47.6909501,
                37.0769173
              ],
              [
                47.6913137,
                37.0771896
              ],
              [
                47.6924501,
                37.07914
              ],
              [
                47.696642,
                37.0863981
              ],
              [
                47.6971951,
                37.0863981
              ],
              [
                47.7019187,
                37.0872261
              ],
              [
                47.7033085,
                37.087226
              ],
              [
                47.7038617,
                37.0875051
              ],
              [
                47.7049754,
                37.0875051
              ],
              [
                47.705252,
                37.0877841
              ],
              [
                47.7060851,
                37.087784
              ],
              [
                47.7177518,
                37.093616
              ],
              [
                47.7199749,
                37.093616
              ],
              [
                47.7216417,
                37.0930581
              ],
              [
                47.7266414,
                37.087505
              ],
              [
                47.7266414,
                37.0869471
              ],
              [
                47.729418,
                37.0841751
              ],
              [
                47.737755,
                37.0802871
              ],
              [
                47.7402547,
                37.0794501
              ],
              [
                47.7421981,
                37.0786131
              ],
              [
                47.7591445,
                37.0763991
              ],
              [
                47.759698,
                37.0761201
              ],
              [
                47.7644212,
                37.0761201
              ],
              [
                47.7649779,
                37.0763992
              ],
              [
                47.7660877,
                37.0763991
              ],
              [
                47.7683112,
                37.0772272
              ],
              [
                47.772201,
                37.0802872
              ],
              [
                47.7730343,
                37.0813942
              ],
              [
                47.7755343,
                37.0908442
              ],
              [
                47.7758108,
                37.0919512
              ],
              [
                47.7777542,
                37.1100048
              ],
              [
                47.7785874,
                37.1197244
              ],
              [
                47.7780342,
                37.1236213
              ],
              [
                47.7783108,
                37.1305598
              ],
              [
                47.7785874,
                37.1316757
              ],
              [
                47.7788675,
                37.1322247
              ],
              [
                47.7927575,
                37.1436179
              ],
              [
                47.7933107,
                37.1438968
              ],
              [
                47.7935908,
                37.1444548
              ],
              [
                47.805534,
                37.1505653
              ],
              [
                47.8072004,
                37.1513932
              ],
              [
                47.8424799,
                37.1691754
              ],
              [
                47.8433133,
                37.1691754
              ],
              [
                47.8433133,
                37.1694543
              ],
              [
                47.8441465,
                37.1694544
              ],
              [
                47.8460934,
                37.1702822
              ],
              [
                47.8472031,
                37.1702822
              ],
              [
                47.8474801,
                37.1705612
              ],
              [
                47.8477599,
                37.1708402
              ],
              [
                47.8508135,
                37.171956
              ],
              [
                47.8524798,
                37.171956
              ],
              [
                47.8538697,
                37.172514
              ],
              [
                47.8549799,
                37.172514
              ],
              [
                47.8569265,
                37.173063
              ],
              [
                47.8588698,
                37.1730629
              ],
              [
                47.8591464,
                37.1733419
              ],
              [
                47.8605367,
                37.1733419
              ],
              [
                47.8608132,
                37.1736209
              ],
              [
                47.8641496,
                37.1736208
              ],
              [
                47.8713697,
                37.1744488
              ],
              [
                47.8719263,
                37.1747277
              ],
              [
                47.8769264,
                37.1747278
              ],
              [
                47.8788695,
                37.1747278
              ],
              [
                47.8880396,
                37.1747278
              ],
              [
                47.8891493,
                37.1744488
              ],
              [
                47.8922061,
                37.1744489
              ],
              [
                47.8949827,
                37.1741789
              ],
              [
                47.8960929,
                37.1738999
              ],
              [
                47.8980394,
                37.1738999
              ],
              [
                47.9005394,
                37.173342
              ],
              [
                47.9022059,
                37.1733419
              ],
              [
                47.9044294,
                37.1727841
              ],
              [
                47.9058158,
                37.1727841
              ],
              [
                47.9272057,
                37.1677898
              ],
              [
                47.9274858,
                37.1675108
              ],
              [
                47.9285956,
                37.1675107
              ],
              [
                47.9288725,
                37.1672318
              ],
              [
                47.9299859,
                37.1672318
              ],
              [
                47.9302624,
                37.1669529
              ],
              [
                47.9322058,
                37.1669529
              ],
              [
                47.9327625,
                37.1666739
              ],
              [
                47.9380423,
                37.1666739
              ],
              [
                47.9385958,
                37.1669528
              ],
              [
                47.9469288,
                37.165567
              ],
              [
                47.9472089,
                37.1652881
              ],
              [
                47.9483186,
                37.1652881
              ],
              [
                47.9724852,
                37.1552812
              ],
              [
                47.9755419,
                37.1533464
              ],
              [
                47.9833218,
                37.1477849
              ],
              [
                48.0095666,
                37.1400672
              ],
              [
                48.0336014,
                37.1452833
              ],
              [
                48.0411012,
                37.1494499
              ],
              [
                48.044158,
                37.1505658
              ],
              [
                48.0449912,
                37.1508448
              ],
              [
                48.0472111,
                37.1511147
              ],
              [
                48.0494347,
                37.1516727
              ],
              [
                48.0508245,
                37.1516728
              ],
              [
                48.0519343,
                37.1519518
              ],
              [
                48.0530479,
                37.1519518
              ],
              [
                48.0536011,
                37.1522307
              ],
              [
                48.0555477,
                37.1522307
              ],
              [
                48.0561012,
                37.1525096
              ],
              [
                48.0644342,
                37.1525097
              ],
              [
                48.0811042,
                37.1508449
              ],
              [
                48.0824909,
                37.1511148
              ],
              [
                48.0836042,
                37.1519518
              ],
              [
                48.0894375,
                37.1536166
              ],
              [
                48.0899941,
                37.1538956
              ],
              [
                48.0933274,
                37.1538956
              ],
              [
                48.0941606,
                37.1541746
              ],
              [
                48.0947141,
                37.1538957
              ],
              [
                48.0955474,
                37.1538956
              ],
              [
                48.0955474,
                37.1541746
              ],
              [
                48.0966606,
                37.1541746
              ],
              [
                48.0997139,
                37.1558395
              ],
              [
                48.1055471,
                37.1647305
              ],
              [
                48.1058273,
                37.1650095
              ],
              [
                48.1094371,
                37.1716777
              ],
              [
                48.1163837,
                37.1872366
              ],
              [
                48.1169368,
                37.1883434
              ],
              [
                48.1313836,
                37.2044509
              ],
              [
                48.1319402,
                37.2055667
              ],
              [
                48.1402731,
                37.2133413
              ],
              [
                48.1502733,
                37.2211248
              ],
              [
                48.1594395,
                37.2236174
              ],
              [
                48.1602731,
                37.2238963
              ],
              [
                48.1613829,
                37.2238963
              ],
              [
                48.1644396,
                37.2247332
              ],
              [
                48.1658295,
                37.2250121
              ],
              [
                48.1730532,
                37.2261188
              ],
              [
                48.1736062,
                37.2263978
              ],
              [
                48.1763864,
                37.2263979
              ],
              [
                48.1774961,
                37.2266768
              ],
              [
                48.1849959,
                37.2266768
              ],
              [
                48.1858295,
                37.2269558
              ],
              [
                48.1863862,
                37.2266768
              ],
              [
                48.1872194,
                37.2269557
              ],
              [
                48.1913859,
                37.2269557
              ],
              [
                48.2013857,
                37.2286205
              ],
              [
                48.202776,
                37.2286204
              ],
              [
                48.2044424,
                37.2291784
              ],
              [
                48.2055526,
                37.2291783
              ],
              [
                48.2063858,
                37.2294573
              ],
              [
                48.2074991,
                37.2294572
              ],
              [
                48.2130524,
                37.2311219
              ],
              [
                48.219719,
                37.2327866
              ],
              [
                48.2252757,
                37.2350091
              ],
              [
                48.2336087,
                37.2372316
              ],
              [
                48.234999,
                37.2372316
              ],
              [
                48.2358322,
                37.2375106
              ],
              [
                48.236942,
                37.2375106
              ],
              [
                48.2377756,
                37.2377896
              ],
              [
                48.2399987,
                37.2377895
              ],
              [
                48.2405553,
                37.2380685
              ],
              [
                48.2416655,
                37.2380684
              ],
              [
                48.2463887,
                37.2380685
              ],
              [
                48.2472219,
                37.2377896
              ],
              [
                48.2488887,
                37.2377895
              ],
              [
                48.249722,
                37.2375106
              ],
              [
                48.2561119,
                37.2375107
              ],
              [
                48.2569451,
                37.2377896
              ],
              [
                48.2574987,
                37.2375106
              ],
              [
                48.2580553,
                37.2377896
              ],
              [
                48.2597217,
                37.2377895
              ],
              [
                48.2605554,
                37.2380685
              ],
              [
                48.260835,
                37.2377896
              ],
              [
                48.2616687,
                37.2380685
              ],
              [
                48.2644453,
                37.2380685
              ],
              [
                48.265002,
                37.2377896
              ],
              [
                48.2672219,
                37.2377896
              ],
              [
                48.2680552,
                37.2375107
              ],
              [
                48.2700017,
                37.2375107
              ],
              [
                48.2708353,
                37.2372318
              ],
              [
                48.2730548,
                37.2372317
              ],
              [
                48.273335,
                37.2375107
              ],
              [
                48.275835,
                37.2375107
              ],
              [
                48.2947248,
                37.2452939
              ],
              [
                48.3137847,
                37.2454136
              ],
              [
                48.3172246,
                37.2455298
              ],
              [
                48.3226926,
                37.2445594
              ],
              [
                48.3314906,
                37.2427598
              ],
              [
                48.332526,
                37.2424966
              ],
              [
                48.3346724,
                37.2402028
              ],
              [
                48.3365285,
                37.2397458
              ],
              [
                48.3370757,
                37.2406469
              ],
              [
                48.3382559,
                37.2422868
              ],
              [
                48.3401334,
                37.2450541
              ],
              [
                48.3420753,
                37.2479664
              ],
              [
                48.3415389,
                37.2486582
              ],
              [
                48.3407771,
                37.2497769
              ],
              [
                48.3409488,
                37.2511007
              ],
              [
                48.3416891,
                37.2515618
              ],
              [
                48.3438241,
                37.2529624
              ],
              [
                48.3458197,
                37.2550119
              ],
              [
                48.3439314,
                37.2575908
              ],
              [
                48.3402192,
                37.2571724
              ],
              [
                48.3387172,
                37.2586241
              ],
              [
                48.3379447,
                37.2600928
              ],
              [
                48.3366465,
                37.2627313
              ],
              [
                48.3354878,
                37.2637816
              ],
              [
                48.3332562,
                37.2659674
              ],
              [
                48.3287823,
                37.2701511
              ],
              [
                48.3219159,
                37.2664114
              ],
              [
                48.3201349,
                37.2684435
              ],
              [
                48.3206284,
                37.2690241
              ],
              [
                48.3215403,
                37.270578
              ],
              [
                48.3232677,
                37.2724648
              ],
              [
                48.3231068,
                37.2749151
              ],
              [
                48.3200812,
                37.276392
              ],
              [
                48.3169806,
                37.2757859
              ],
              [
                48.3150494,
                37.2753078
              ],
              [
                48.309803,
                37.2726954
              ],
              [
                48.306123,
                37.2737967
              ],
              [
                48.3047712,
                37.2750432
              ],
              [
                48.3034193,
                37.2766225
              ],
              [
                48.2986343,
                37.2776726
              ],
              [
                48.2977545,
                37.278919
              ],
              [
                48.2956087,
                37.2822056
              ],
              [
                48.2922828,
                37.2831276
              ],
              [
                48.2924437,
                37.2840666
              ],
              [
                48.2928514,
                37.2855177
              ],
              [
                48.2958555,
                37.2870798
              ],
              [
                48.2975936,
                37.2908953
              ],
              [
                48.2969123,
                37.2926515
              ],
              [
                48.2963383,
                37.2938678
              ],
              [
                48.2958046,
                37.2946871
              ],
              [
                48.2953834,
                37.2951971
              ],
              [
                48.291564,
                37.2965798
              ],
              [
                48.2906949,
                37.2964005
              ],
              [
                48.287015,
                37.2957007
              ],
              [
                48.2844829,
                37.2965542
              ],
              [
                48.2832169,
                37.2983038
              ],
              [
                48.2821441,
                37.2999254
              ],
              [
                48.2821655,
                37.3016493
              ],
              [
                48.2818544,
                37.3030063
              ],
              [
                48.2813394,
                37.3047899
              ],
              [
                48.2804811,
                37.3055323
              ],
              [
                48.2778525,
                37.3056518
              ],
              [
                48.276608,
                37.3055323
              ],
              [
                48.272177,
                37.3049094
              ],
              [
                48.2700205,
                37.3061212
              ],
              [
                48.269881,
                37.3063772
              ],
              [
                48.2705998,
                37.307589
              ],
              [
                48.2743657,
                37.3076487
              ],
              [
                48.2763076,
                37.3087922
              ],
              [
                48.276093,
                37.3108658
              ],
              [
                48.2745695,
                37.3110365
              ],
              [
                48.2725739,
                37.3113096
              ],
              [
                48.2720053,
                37.3122567
              ],
              [
                48.2716942,
                37.3133234
              ],
              [
                48.2708573,
                37.3160197
              ],
              [
                48.2691193,
                37.3152603
              ],
              [
                48.267113,
                37.3125981
              ],
              [
                48.2656538,
                37.312709
              ],
              [
                48.2638299,
                37.3129479
              ],
              [
                48.2610834,
                37.313878
              ],
              [
                48.257736,
                37.315047
              ],
              [
                48.2591092,
                37.3170095
              ],
              [
                48.2624352,
                37.3174447
              ],
              [
                48.2642376,
                37.3201068
              ],
              [
                48.2636154,
                37.3226238
              ],
              [
                48.2625747,
                37.3234599
              ],
              [
                48.2604825,
                37.3247994
              ],
              [
                48.2601821,
                37.3262497
              ],
              [
                48.2596242,
                37.3281011
              ],
              [
                48.258487,
                37.3279816
              ],
              [
                48.2572853,
                37.3278707
              ],
              [
                48.2570708,
                37.3247908
              ],
              [
                48.2568455,
                37.3231271
              ],
              [
                48.2542169,
                37.3222483
              ],
              [
                48.252908,
                37.3220862
              ],
              [
                48.250097,
                37.3216255
              ],
              [
                48.2476723,
                37.322692
              ],
              [
                48.2460415,
                37.3251748
              ],
              [
                48.2462668,
                37.3264972
              ],
              [
                48.2466745,
                37.3296026
              ],
              [
                48.2471681,
                37.3331429
              ],
              [
                48.2469749,
                37.3345931
              ],
              [
                48.246578,
                37.3377238
              ],
              [
                48.2453334,
                37.3384318
              ],
              [
                48.243649,
                37.339481
              ],
              [
                48.2394218,
                37.3423299
              ],
              [
                48.2379091,
                37.343345
              ],
              [
                48.2371044,
                37.3442662
              ],
              [
                48.2337785,
                37.3483431
              ],
              [
                48.23174,
                37.3541597
              ],
              [
                48.2319545,
                37.3580486
              ],
              [
                48.2322676,
                37.3607572
              ],
              [
                48.2329227,
                37.3638817
              ],
              [
                48.2334921,
                37.3665035
              ],
              [
                48.2341529,
                37.3686204
              ],
              [
                48.2349626,
                37.3715036
              ],
              [
                48.229624,
                37.3719288
              ],
              [
                48.2250863,
                37.3722288
              ],
              [
                48.2182313,
                37.3728496
              ],
              [
                48.2119686,
                37.3738864
              ],
              [
                48.204198,
                37.3759872
              ],
              [
                48.1982391,
                37.3776978
              ],
              [
                48.1904898,
                37.3922298
              ],
              [
                48.1818044,
                37.4042401
              ],
              [
                48.1770229,
                37.4087643
              ],
              [
                48.1720984,
                37.4126472
              ],
              [
                48.1672392,
                37.4186839
              ],
              [
                48.164432,
                37.4252284
              ],
              [
                48.1631669,
                37.4313737
              ],
              [
                48.1629861,
                37.4409848
              ],
              [
                48.1636039,
                37.4479169
              ],
              [
                48.1655468,
                37.4521246
              ],
              [
                48.1658649,
                37.4561236
              ],
              [
                48.1663799,
                37.4614379
              ],
              [
                48.1656074,
                37.4652871
              ],
              [
                48.1638694,
                37.4695448
              ],
              [
                48.160758,
                37.4734957
              ],
              [
                48.1558442,
                37.477123
              ],
              [
                48.1499004,
                37.4791493
              ],
              [
                48.1432056,
                37.4804946
              ],
              [
                48.1340217,
                37.4812779
              ],
              [
                48.1293225,
                37.4840533
              ],
              [
                48.1244302,
                37.4884462
              ],
              [
                48.1221556,
                37.4883611
              ],
              [
                48.1176495,
                37.4867776
              ],
              [
                48.1153106,
                37.4862839
              ],
              [
                48.1120276,
                37.4874757
              ],
              [
                48.1060409,
                37.4963119
              ],
              [
                48.1031871,
                37.4980824
              ],
              [
                48.1029081,
                37.5031128
              ],
              [
                48.1015456,
                37.5037001
              ],
              [
                48.0960846,
                37.5031383
              ],
              [
                48.093574,
                37.5042618
              ],
              [
                48.0917501,
                37.5063385
              ],
              [
                48.0900979,
                37.5073258
              ],
              [
                48.0882311,
                37.5069513
              ],
              [
                48.0855274,
                37.5053427
              ],
              [
                48.084079,
                37.5058023
              ],
              [
                48.0832636,
                37.5080067
              ],
              [
                48.0842507,
                37.5097259
              ],
              [
                48.0836069,
                37.5107216
              ],
              [
                48.0816114,
                37.5111641
              ],
              [
                48.078146,
                37.5133683
              ],
              [
                48.0773305,
                37.5196657
              ],
              [
                48.0782717,
                37.527789
              ],
              [
                48.0795458,
                37.5361742
              ],
              [
                48.0793109,
                37.5474403
              ],
              [
                48.0811348,
                37.557525
              ],
              [
                48.0811175,
                37.5711937
              ],
              [
                48.0785807,
                37.5830407
              ],
              [
                48.0747125,
                37.5902995
              ],
              [
                48.0716558,
                37.5930784
              ],
              [
                48.0677658,
                37.5950208
              ],
              [
                48.0669327,
                37.5952996
              ],
              [
                48.0580384,
                37.598574
              ],
              [
                48.0563797,
                37.5991846
              ],
              [
                48.055266,
                37.5991847
              ],
              [
                48.0494331,
                37.6008483
              ],
              [
                48.0491561,
                37.6011271
              ],
              [
                48.0480428,
                37.601127
              ],
              [
                48.0435997,
                37.602521
              ],
              [
                48.0427665,
                37.6025209
              ],
              [
                48.0241532,
                37.6108573
              ],
              [
                48.0236001,
                37.6111361
              ],
              [
                48.0227664,
                37.6119634
              ],
              [
                48.0216532,
                37.6122422
              ],
              [
                48.0191531,
                37.6166847
              ],
              [
                48.0188765,
                37.6180785
              ],
              [
                48.0199866,
                37.6258572
              ],
              [
                48.0224862,
                37.6414052
              ],
              [
                48.0255429,
                37.654462
              ],
              [
                48.0277664,
                37.6611342
              ],
              [
                48.028043,
                37.661413
              ],
              [
                48.0288761,
                37.6630765
              ],
              [
                48.0308195,
                37.6658551
              ],
              [
                48.031067,
                37.6662269
              ],
              [
                48.0538794,
                37.6925249
              ],
              [
                48.0630459,
                37.7064078
              ],
              [
                48.0638791,
                37.7105799
              ],
              [
                48.0633224,
                37.7147428
              ],
              [
                48.0633224,
                37.719751
              ],
              [
                48.063599,
                37.7205781
              ],
              [
                48.063599,
                37.722799
              ],
              [
                48.0641556,
                37.7247411
              ],
              [
                48.0644322,
                37.7250198
              ],
              [
                48.0652658,
                37.7266921
              ],
              [
                48.0666557,
                37.7294704
              ],
              [
                48.0708221,
                37.7322487
              ],
              [
                48.0752687,
                37.733912
              ],
              [
                48.0874886,
                37.7358541
              ],
              [
                48.0880452,
                37.7361328
              ],
              [
                48.0902687,
                37.7361329
              ],
              [
                48.0913788,
                37.7364116
              ],
              [
                48.0952688,
                37.7364115
              ],
              [
                48.0963785,
                37.7366903
              ],
              [
                48.0983255,
                37.7366903
              ],
              [
                48.0988786,
                37.736969
              ],
              [
                48.100545,
                37.736969
              ],
              [
                48.1016588,
                37.7372477
              ],
              [
                48.1030451,
                37.7372477
              ],
              [
                48.1036018,
                37.7375264
              ],
              [
                48.1052686,
                37.7375265
              ],
              [
                48.1077687,
                37.7380839
              ],
              [
                48.1091586,
                37.7380839
              ],
              [
                48.1144352,
                37.7391898
              ],
              [
                48.1152684,
                37.7391898
              ],
              [
                48.1183252,
                37.7405834
              ],
              [
                48.1191584,
                37.7405835
              ],
              [
                48.1258249,
                37.7441888
              ],
              [
                48.1266582,
                37.7447462
              ],
              [
                48.1352716,
                37.7522446
              ],
              [
                48.1474947,
                37.7805828
              ],
              [
                48.148328,
                37.7844667
              ],
              [
                48.1494377,
                37.7961359
              ],
              [
                48.1491611,
                37.7964146
              ],
              [
                48.1480479,
                37.8011343
              ],
              [
                48.1477713,
                37.8025278
              ],
              [
                48.148881,
                37.8053057
              ],
              [
                48.1494377,
                37.805863
              ],
              [
                48.1502714,
                37.8064205
              ],
              [
                48.1511045,
                37.8094681
              ],
              [
                48.1511045,
                37.8097468
              ],
              [
                48.1511045,
                37.8103041
              ],
              [
                48.146938,
                37.8169656
              ],
              [
                48.1463809,
                37.8172443
              ],
              [
                48.1461044,
                37.8178016
              ],
              [
                48.1391577,
                37.8211368
              ],
              [
                48.1386046,
                37.8216942
              ],
              [
                48.119158,
                37.8289128
              ],
              [
                48.1180482,
                37.8291915
              ],
              [
                48.114715,
                37.8303062
              ],
              [
                48.1088816,
                37.8361404
              ],
              [
                48.1086016,
                37.8364101
              ],
              [
                48.1083249,
                37.8375248
              ],
              [
                48.108048,
                37.8389181
              ],
              [
                48.1047115,
                37.849193
              ],
              [
                48.0991583,
                37.852528
              ],
              [
                48.0985513,
                37.8527311
              ],
              [
                48.0963782,
                37.8536426
              ],
              [
                48.0886018,
                37.8536427
              ],
              [
                48.0827685,
                37.850029
              ],
              [
                48.0761019,
                37.8478085
              ],
              [
                48.0755453,
                37.8478086
              ],
              [
                48.0738785,
                37.84753
              ],
              [
                48.0699886,
                37.8475299
              ],
              [
                48.0691553,
                37.8478086
              ],
              [
                48.0660985,
                37.8478086
              ],
              [
                48.0655451,
                37.8480872
              ],
              [
                48.0638786,
                37.8480872
              ],
              [
                48.0627653,
                37.8483569
              ],
              [
                48.0624887,
                37.8486355
              ],
              [
                48.0616552,
                37.8486355
              ],
              [
                48.0608219,
                37.8491928
              ],
              [
                48.0602653,
                37.8491929
              ],
              [
                48.0599887,
                37.8494715
              ],
              [
                48.059432,
                37.8494716
              ],
              [
                48.0591554,
                37.8497502
              ],
              [
                48.0585983,
                37.8497502
              ],
              [
                48.0583219,
                37.8500289
              ],
              [
                48.0572121,
                37.8500289
              ],
              [
                48.0527655,
                37.8525279
              ],
              [
                48.0497088,
                37.8583619
              ],
              [
                48.0502653,
                37.8653015
              ],
              [
                48.0466555,
                37.8711354
              ],
              [
                48.0402656,
                37.8753063
              ],
              [
                48.0399889,
                37.8755849
              ],
              [
                48.0377654,
                37.8769692
              ],
              [
                48.027209,
                37.8800253
              ],
              [
                48.0260988,
                37.8800253
              ],
              [
                48.0255422,
                37.8803039
              ],
              [
                48.0249855,
                37.880304
              ],
              [
                48.0249854,
                37.8805826
              ],
              [
                48.0244324,
                37.8805826
              ],
              [
                48.0241522,
                37.8808613
              ],
              [
                48.0235991,
                37.8808612
              ],
              [
                48.0202654,
                37.8841961
              ],
              [
                48.0124855,
                37.8886365
              ],
              [
                47.999403,
                37.8949567
              ],
              [
                47.9933191,
                37.8903084
              ],
              [
                47.9866526,
                37.8833601
              ],
              [
                47.9860959,
                37.8828028
              ],
              [
                47.9780394,
                37.876142
              ],
              [
                47.9774859,
                37.876142
              ],
              [
                47.977486,
                37.8758633
              ],
              [
                47.9766527,
                37.8758634
              ],
              [
                47.9760961,
                37.8755847
              ],
              [
                47.9752629,
                37.8755847
              ],
              [
                47.9749828,
                37.875306
              ],
              [
                47.9738726,
                37.8753061
              ],
              [
                47.9733159,
                37.8750274
              ],
              [
                47.971373,
                37.8750274
              ],
              [
                47.971096,
                37.8747487
              ],
              [
                47.9574828,
                37.8747487
              ],
              [
                47.9572062,
                37.8750274
              ],
              [
                47.9541495,
                37.8750274
              ],
              [
                47.9535929,
                37.8753061
              ],
              [
                47.9499831,
                37.875306
              ],
              [
                47.9491498,
                37.8750273
              ],
              [
                47.9480395,
                37.8750273
              ],
              [
                47.9472064,
                37.8747487
              ],
              [
                47.9444262,
                37.8747487
              ],
              [
                47.9438731,
                37.87447
              ],
              [
                47.9427598,
                37.87447
              ],
              [
                47.9419266,
                37.8741913
              ],
              [
                47.9413731,
                37.8741913
              ],
              [
                47.9313697,
                37.8719711
              ],
              [
                47.9305365,
                37.8719711
              ],
              [
                47.9299833,
                37.8716924
              ],
              [
                47.9291497,
                37.8716924
              ],
              [
                47.9285931,
                37.8714137
              ],
              [
                47.9277599,
                37.8714137
              ],
              [
                47.9272032,
                37.8711351
              ],
              [
                47.92637,
                37.8711351
              ],
              [
                47.9116466,
                37.8644742
              ],
              [
                47.9052601,
                37.8628022
              ],
              [
                47.9044269,
                37.8628022
              ],
              [
                47.9038703,
                37.8625235
              ],
              [
                47.9002604,
                37.8625235
              ],
              [
                47.8983136,
                37.8633595
              ],
              [
                47.898037,
                37.8636381
              ],
              [
                47.8785905,
                37.8422527
              ],
              [
                47.8658141,
                37.8355825
              ],
              [
                47.8647008,
                37.8347465
              ],
              [
                47.8635906,
                37.8333621
              ],
              [
                47.8624809,
                37.8227992
              ],
              [
                47.8619242,
                37.8189158
              ],
              [
                47.8574776,
                37.8055837
              ],
              [
                47.8552577,
                37.8011337
              ],
              [
                47.8522011,
                37.7983558
              ],
              [
                47.8510909,
                37.7983557
              ],
              [
                47.8505341,
                37.7980771
              ],
              [
                47.8499776,
                37.7980771
              ],
              [
                47.8495622,
                37.7979381
              ],
              [
                47.8491444,
                37.7977983
              ],
              [
                47.8441442,
                37.7977984
              ],
              [
                47.8438676,
                37.7980771
              ],
              [
                47.8416445,
                37.7980771
              ],
              [
                47.8413681,
                37.7977984
              ],
              [
                47.8366444,
                37.7977984
              ],
              [
                47.8363679,
                37.798077
              ],
              [
                47.8330346,
                37.798077
              ],
              [
                47.8322014,
                37.7983557
              ],
              [
                47.8294212,
                37.7983557
              ],
              [
                47.8241445,
                37.8005853
              ],
              [
                47.8235878,
                37.8005852
              ],
              [
                47.8205311,
                37.8014123
              ],
              [
                47.8180315,
                37.8019696
              ],
              [
                47.8096981,
                37.8019697
              ],
              [
                47.8038648,
                37.8005852
              ],
              [
                47.7927552,
                37.7941932
              ],
              [
                47.7910883,
                37.7941932
              ],
              [
                47.7908082,
                37.7939145
              ],
              [
                47.789975,
                37.7939145
              ],
              [
                47.7885882,
                37.7933571
              ],
              [
                47.787475,
                37.7933571
              ],
              [
                47.7869218,
                37.7930784
              ],
              [
                47.7860882,
                37.7930785
              ],
              [
                47.7783084,
                37.7891946
              ],
              [
                47.7755318,
                37.7886372
              ],
              [
                47.7746986,
                37.7886372
              ],
              [
                47.7741419,
                37.7889159
              ],
              [
                47.772752,
                37.7889159
              ],
              [
                47.7691418,
                37.7905791
              ],
              [
                47.7621951,
                37.7950292
              ],
              [
                47.7596954,
                37.7958563
              ],
              [
                47.7585853,
                37.7958562
              ],
              [
                47.7566419,
                37.7955776
              ],
              [
                47.7541422,
                37.7950292
              ],
              [
                47.7530285,
                37.7950292
              ],
              [
                47.7524753,
                37.7947506
              ],
              [
                47.7502523,
                37.7947505
              ],
              [
                47.7469186,
                37.7930783
              ],
              [
                47.7360855,
                37.789743
              ],
              [
                47.7352523,
                37.789743
              ],
              [
                47.7324722,
                37.7883584
              ],
              [
                47.7149727,
                37.782245
              ],
              [
                47.7138625,
                37.782245
              ],
              [
                47.7113624,
                37.7814179
              ],
              [
                47.7071924,
                37.779467
              ],
              [
                47.7060826,
                37.779467
              ],
              [
                47.7052493,
                37.7791883
              ],
              [
                47.7038592,
                37.7791883
              ],
              [
                47.703306,
                37.779467
              ],
              [
                47.7030259,
                37.7803031
              ],
              [
                47.7027493,
                37.7805818
              ],
              [
                47.6999727,
                37.7858591
              ],
              [
                47.6971925,
                37.7872436
              ],
              [
                47.6963593,
                37.7872435
              ],
              [
                47.6958062,
                37.7875222
              ],
              [
                47.6952495,
                37.7872436
              ],
              [
                47.6927494,
                37.7872436
              ],
              [
                47.6902494,
                37.7855803
              ],
              [
                47.6894162,
                37.7853016
              ],
              [
                47.6691365,
                37.7716902
              ],
              [
                47.6219136,
                37.7522434
              ],
              [
                47.6216335,
                37.7519646
              ],
              [
                47.6183002,
                37.7505801
              ],
              [
                47.617467,
                37.7505801
              ],
              [
                47.6171905,
                37.7503014
              ],
              [
                47.6163569,
                37.7503015
              ],
              [
                47.6160804,
                37.7500227
              ],
              [
                47.614967,
                37.7500227
              ],
              [
                47.6146904,
                37.749744
              ],
              [
                47.6124669,
                37.749744
              ],
              [
                47.608577,
                37.7491955
              ],
              [
                47.6080238,
                37.7489168
              ],
              [
                47.6049672,
                37.7489168
              ],
              [
                47.6044105,
                37.7486381
              ],
              [
                47.6027436,
                37.748638
              ],
              [
                47.6019105,
                37.7483594
              ],
              [
                47.6010773,
                37.7483594
              ],
              [
                47.5999671,
                37.7480806
              ],
              [
                47.5983006,
                37.7475232
              ],
              [
                47.5949673,
                37.7475231
              ],
              [
                47.5944107,
                37.7472445
              ],
              [
                47.5910774,
                37.7472444
              ],
              [
                47.5905208,
                37.7469657
              ],
              [
                47.589134,
                37.7469657
              ],
              [
                47.5694109,
                37.7422455
              ],
              [
                47.5666308,
                37.7414093
              ],
              [
                47.5610775,
                37.7394673
              ],
              [
                47.5602444,
                37.7394672
              ],
              [
                47.5596876,
                37.7391885
              ],
              [
                47.5580208,
                37.7391885
              ],
              [
                47.5574642,
                37.7389098
              ],
              [
                47.5499645,
                37.7389098
              ],
              [
                47.5494077,
                37.7391885
              ],
              [
                47.5474644,
                37.7391886
              ],
              [
                47.5413545,
                37.7405821
              ],
              [
                47.5399646,
                37.7405821
              ],
              [
                47.5391313,
                37.7408608
              ],
              [
                47.5371844,
                37.7408608
              ],
              [
                47.5366313,
                37.7411395
              ],
              [
                47.5363512,
                37.7408608
              ],
              [
                47.5241315,
                37.7433603
              ],
              [
                47.520518,
                37.7433602
              ],
              [
                47.5199614,
                37.7436389
              ],
              [
                47.5174614,
                37.7436389
              ],
              [
                47.5169082,
                37.7433602
              ],
              [
                47.5155179,
                37.7433603
              ],
              [
                47.5138514,
                37.7428028
              ],
              [
                47.5130183,
                37.7428028
              ],
              [
                47.5124612,
                37.7425241
              ],
              [
                47.5110748,
                37.7425241
              ],
              [
                47.5107948,
                37.7422453
              ],
              [
                47.5085749,
                37.7422453
              ],
              [
                47.5077398,
                37.7422454
              ],
              [
                47.5069084,
                37.7422454
              ],
              [
                47.5066283,
                37.742524
              ],
              [
                47.503295,
                37.7436389
              ],
              [
                47.5019048,
                37.7436389
              ],
              [
                47.5007949,
                37.7439086
              ],
              [
                47.5005184,
                37.7441874
              ],
              [
                47.4991281,
                37.7444661
              ],
              [
                47.4991281,
                37.7447448
              ],
              [
                47.4966284,
                37.7455809
              ],
              [
                47.4963515,
                37.7458596
              ],
              [
                47.4957948,
                37.7458596
              ],
              [
                47.4952382,
                37.746417
              ],
              [
                47.4941283,
                37.7466868
              ],
              [
                47.4930182,
                37.7478016
              ],
              [
                47.4924615,
                37.7478016
              ],
              [
                47.4919049,
                37.7483591
              ],
              [
                47.4663485,
                37.7550212
              ],
              [
                47.464682,
                37.7550212
              ],
              [
                47.4638484,
                37.7552999
              ],
              [
                47.462182,
                37.7550211
              ],
              [
                47.4588486,
                37.7550212
              ],
              [
                47.458292,
                37.7552998
              ],
              [
                47.4524587,
                37.7552998
              ],
              [
                47.4466254,
                37.7530791
              ],
              [
                47.4460722,
                37.7530791
              ],
              [
                47.4455156,
                37.7530791
              ],
              [
                47.4449588,
                37.7528005
              ],
              [
                47.4330157,
                37.7469654
              ],
              [
                47.4324591,
                37.7469654
              ],
              [
                47.432459,
                37.7466867
              ],
              [
                47.4307922,
                37.7464169
              ],
              [
                47.429959,
                37.7458595
              ],
              [
                47.4291258,
                37.7458594
              ],
              [
                47.4285692,
                37.7455808
              ],
              [
                47.4266257,
                37.7455808
              ],
              [
                47.4260686,
                37.745302
              ],
              [
                47.4244022,
                37.7453021
              ],
              [
                47.4238459,
                37.7450234
              ],
              [
                47.4216256,
                37.7450233
              ],
              [
                47.4210694,
                37.7453021
              ],
              [
                47.4205123,
                37.745302
              ],
              [
                47.4194022,
                37.7447445
              ],
              [
                47.4188458,
                37.7444659
              ],
              [
                47.4171794,
                37.7444658
              ],
              [
                47.414959,
                37.7450232
              ],
              [
                47.4146794,
                37.745302
              ],
              [
                47.4138457,
                37.745302
              ],
              [
                47.3988461,
                37.7539151
              ],
              [
                47.3971789,
                37.7547423
              ],
              [
                47.3952359,
                37.7555784
              ],
              [
                47.3941226,
                37.7561358
              ],
              [
                47.3766229,
                37.7597411
              ],
              [
                47.3735658,
                37.7597411
              ],
              [
                47.372733,
                37.7594623
              ],
              [
                47.3710658,
                37.7594624
              ],
              [
                47.3652329,
                37.7583564
              ],
              [
                47.3641227,
                37.7583565
              ],
              [
                47.3630093,
                37.757799
              ],
              [
                47.3619,
                37.7577991
              ],
              [
                47.3610664,
                37.7575203
              ],
              [
                47.3574562,
                37.7575203
              ],
              [
                47.3568999,
                37.7572416
              ],
              [
                47.3527334,
                37.7572416
              ],
              [
                47.3518998,
                37.7575203
              ],
              [
                47.3507864,
                37.7575203
              ],
              [
                47.3502333,
                37.757799
              ],
              [
                47.34912,
                37.757799
              ],
              [
                47.3432864,
                37.7597409
              ],
              [
                47.3410667,
                37.759741
              ],
              [
                47.3405097,
                37.7600197
              ],
              [
                47.3391197,
                37.7600196
              ],
              [
                47.3346767,
                37.755857
              ],
              [
                47.3344002,
                37.7550208
              ],
              [
                47.3341197,
                37.7547421
              ],
              [
                47.3330103,
                37.7547421
              ],
              [
                47.3293969,
                37.7541937
              ],
              [
                47.328843,
                37.753915
              ],
              [
                47.3274532,
                37.753915
              ],
              [
                47.3266203,
                37.7536363
              ],
              [
                47.3257867,
                37.7536363
              ],
              [
                47.3255101,
                37.7533576
              ],
              [
                47.3191201,
                37.7533575
              ],
              [
                47.3185632,
                37.7536362
              ],
              [
                47.3171772,
                37.7536362
              ],
              [
                47.2991205,
                37.758635
              ],
              [
                47.2952306,
                37.758635
              ],
              [
                47.2932836,
                37.7580776
              ],
              [
                47.2921734,
                37.7580775
              ],
              [
                47.2896733,
                37.7575202
              ],
              [
                47.2832834,
                37.7561356
              ],
              [
                47.2827303,
                37.7558568
              ],
              [
                47.2816169,
                37.7558569
              ],
              [
                47.2735605,
                37.7536362
              ],
              [
                47.2724503,
                37.7536361
              ],
              [
                47.2721738,
                37.7533574
              ],
              [
                47.2685605,
                37.7533574
              ],
              [
                47.2613407,
                37.7561355
              ],
              [
                47.2571703,
                37.7569626
              ],
              [
                47.2566172,
                37.7572414
              ],
              [
                47.2524507,
                37.7572413
              ],
              [
                47.2480045,
                37.7566929
              ],
              [
                47.2477272,
                37.7564142
              ],
              [
                47.2460607,
                37.7564142
              ],
              [
                47.2452279,
                37.7561355
              ],
              [
                47.2421708,
                37.7561354
              ],
              [
                47.2377277,
                37.7550206
              ],
              [
                47.2368941,
                37.7550206
              ],
              [
                47.2307807,
                37.7525212
              ],
              [
                47.2255048,
                37.751694
              ],
              [
                47.2243946,
                37.7522425
              ],
              [
                47.2241142,
                37.7519638
              ],
              [
                47.2232812,
                37.7511365
              ],
              [
                47.2230048,
                37.7505792
              ],
              [
                47.2227282,
                37.7500217
              ],
              [
                47.2160578,
                37.7386302
              ],
              [
                47.2141148,
                37.7302956
              ],
              [
                47.2135578,
                37.7250178
              ],
              [
                47.2130047,
                37.7164132
              ],
              [
                47.2113383,
                37.6991857
              ],
              [
                47.2110578,
                37.6972434
              ],
              [
                47.210225,
                37.6897444
              ],
              [
                47.2074484,
                37.6789094
              ],
              [
                47.2068914,
                37.6733524
              ],
              [
                47.2074484,
                37.6683529
              ],
              [
                47.2077251,
                37.6658531
              ],
              [
                47.2080047,
                37.662517
              ],
              [
                47.2082813,
                37.6605747
              ],
              [
                47.2088384,
                37.6566901
              ],
              [
                47.209115,
                37.6550176
              ],
              [
                47.2127252,
                37.6380761
              ],
              [
                47.2132815,
                37.6355762
              ],
              [
                47.2135581,
                37.6347399
              ],
              [
                47.2138385,
                37.6339127
              ],
              [
                47.2143917,
                37.6330763
              ],
              [
                47.2355049,
                37.5852974
              ],
              [
                47.2368948,
                37.5833548
              ],
              [
                47.2368948,
                37.583076
              ],
              [
                47.2374479,
                37.5827973
              ],
              [
                47.2405051,
                37.5775182
              ],
              [
                47.2402285,
                37.5750181
              ],
              [
                47.2407847,
                37.5722391
              ],
              [
                47.2413387,
                37.5691814
              ],
              [
                47.2416184,
                37.5680752
              ],
              [
                47.2418949,
                37.5666812
              ],
              [
                47.2421715,
                37.5661236
              ],
              [
                47.2376052,
                37.5665078
              ],
              [
                47.2333911,
                37.5626545
              ],
              [
                47.2229745,
                37.5614024
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555250,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هریس",
          "name:en": "Heris County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289695",
          "wikipedia": "en:Heris County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.3885666,
                38.1128984
              ],
              [
                46.3925569,
                38.1112692
              ],
              [
                46.4056491,
                38.1089654
              ],
              [
                46.4265445,
                38.1043999
              ],
              [
                46.4370039,
                38.1017175
              ],
              [
                46.4580928,
                38.0965842
              ],
              [
                46.4690859,
                38.0959494
              ],
              [
                46.4780044,
                38.096673
              ],
              [
                46.4891828,
                38.0981606
              ],
              [
                46.5032389,
                38.0979753
              ],
              [
                46.5120431,
                38.0958581
              ],
              [
                46.5194759,
                38.092189
              ],
              [
                46.5344213,
                38.0855361
              ],
              [
                46.544662,
                38.0808246
              ],
              [
                46.5612504,
                38.0748541
              ],
              [
                46.5703588,
                38.0731492
              ],
              [
                46.5821508,
                38.0723302
              ],
              [
                46.5883964,
                38.0727356
              ],
              [
                46.6008181,
                38.0735047
              ],
              [
                46.6160759,
                38.0754418
              ],
              [
                46.6305376,
                38.0771227
              ],
              [
                46.6483783,
                38.0804601
              ],
              [
                46.6539931,
                38.0808372
              ],
              [
                46.6670922,
                38.0828752
              ],
              [
                46.6918657,
                38.0811396
              ],
              [
                46.6926985,
                38.0811395
              ],
              [
                46.692979,
                38.080861
              ],
              [
                46.6938118,
                38.080861
              ],
              [
                46.694365,
                38.0805824
              ],
              [
                46.6957556,
                38.0805824
              ],
              [
                46.6963119,
                38.0803039
              ],
              [
                46.7068653,
                38.0803039
              ],
              [
                46.7079785,
                38.0805825
              ],
              [
                46.7115888,
                38.0805825
              ],
              [
                46.7124217,
                38.080861
              ],
              [
                46.7143685,
                38.0808611
              ],
              [
                46.7152022,
                38.0811396
              ],
              [
                46.7168686,
                38.0811396
              ],
              [
                46.7227015,
                38.0825324
              ],
              [
                46.7252016,
                38.0825324
              ],
              [
                46.7254782,
                38.0828109
              ],
              [
                46.7327018,
                38.082811
              ],
              [
                46.7377019,
                38.0825325
              ],
              [
                46.7390917,
                38.0825324
              ],
              [
                46.7399246,
                38.0822539
              ],
              [
                46.7424252,
                38.0822539
              ],
              [
                46.7435348,
                38.0819753
              ],
              [
                46.7468677,
                38.0819753
              ],
              [
                46.7735378,
                38.0797559
              ],
              [
                46.7749245,
                38.0794774
              ],
              [
                46.7840912,
                38.0794775
              ],
              [
                46.7971477,
                38.0800256
              ],
              [
                46.7988142,
                38.0803042
              ],
              [
                46.8074276,
                38.0803042
              ],
              [
                46.8090941,
                38.0800257
              ],
              [
                46.8113177,
                38.0800256
              ],
              [
                46.8207608,
                38.0786419
              ],
              [
                46.8221507,
                38.0786419
              ],
              [
                46.8393737,
                38.0744725
              ],
              [
                46.8438168,
                38.0733673
              ],
              [
                46.8504833,
                38.0719744
              ],
              [
                46.8524303,
                38.0719745
              ],
              [
                46.8535404,
                38.0716959
              ],
              [
                46.8552069,
                38.0716959
              ],
              [
                46.8579835,
                38.0711388
              ],
              [
                46.85965,
                38.0711388
              ],
              [
                46.860207,
                38.0709995
              ],
              [
                46.8668736,
                38.0703121
              ],
              [
                46.867987,
                38.0700335
              ],
              [
                46.8829864,
                38.0700336
              ],
              [
                46.8840966,
                38.069755
              ],
              [
                46.8857631,
                38.069755
              ],
              [
                46.8868763,
                38.0700336
              ],
              [
                46.8879866,
                38.0700336
              ],
              [
                46.8885435,
                38.0697551
              ],
              [
                46.889653,
                38.0700336
              ],
              [
                46.9088199,
                38.0700336
              ],
              [
                46.9104863,
                38.0703122
              ],
              [
                46.9118761,
                38.0700337
              ],
              [
                46.9127098,
                38.0703123
              ],
              [
                46.9349329,
                38.0703123
              ],
              [
                46.9404893,
                38.0691981
              ],
              [
                46.9440995,
                38.068641
              ],
              [
                46.9471558,
                38.0678052
              ],
              [
                46.9474324,
                38.0675267
              ],
              [
                46.9485457,
                38.0675267
              ],
              [
                46.9504896,
                38.0667
              ],
              [
                46.954099,
                38.0658643
              ],
              [
                46.9552123,
                38.0658643
              ],
              [
                46.9560459,
                38.0655858
              ],
              [
                46.9591029,
                38.0655858
              ],
              [
                46.9599359,
                38.0653073
              ],
              [
                46.9613226,
                38.0653072
              ],
              [
                46.9618789,
                38.0655858
              ],
              [
                46.9654891,
                38.0655857
              ],
              [
                46.9677126,
                38.0661429
              ],
              [
                46.9685462,
                38.0661429
              ],
              [
                46.9691025,
                38.0664215
              ],
              [
                46.9704892,
                38.0664215
              ],
              [
                46.9799355,
                38.0697552
              ],
              [
                46.9810457,
                38.0697553
              ],
              [
                46.9818793,
                38.0700338
              ],
              [
                46.9832692,
                38.0700339
              ],
              [
                46.9843793,
                38.0703124
              ],
              [
                46.9891021,
                38.0703124
              ],
              [
                46.9896592,
                38.0700339
              ],
              [
                46.9916022,
                38.0700338
              ],
              [
                46.9918788,
                38.0697553
              ],
              [
                46.992992,
                38.0697553
              ],
              [
                47.0057689,
                38.0653074
              ],
              [
                47.0063252,
                38.0655858
              ],
              [
                47.0068822,
                38.0653073
              ],
              [
                47.0072898,
                38.065322
              ],
              [
                47.0096588,
                38.0655859
              ],
              [
                47.0124386,
                38.0664216
              ],
              [
                47.0138253,
                38.0664216
              ],
              [
                47.0213255,
                38.068084
              ],
              [
                47.0221583,
                38.068084
              ],
              [
                47.0227154,
                38.0683626
              ],
              [
                47.0243818,
                38.0683626
              ],
              [
                47.0268819,
                38.0689198
              ],
              [
                47.0296585,
                38.0689197
              ],
              [
                47.0304922,
                38.0686411
              ],
              [
                47.0310484,
                38.0689198
              ],
              [
                47.031882,
                38.0686412
              ],
              [
                47.0332719,
                38.0686412
              ],
              [
                47.0557716,
                38.0603112
              ],
              [
                47.0774417,
                38.0558632
              ],
              [
                47.0807745,
                38.0558632
              ],
              [
                47.0824418,
                38.0564204
              ],
              [
                47.0843848,
                38.0569775
              ],
              [
                47.0916075,
                38.0633666
              ],
              [
                47.0929983,
                38.0661433
              ],
              [
                47.0954982,
                38.0805835
              ],
              [
                47.0960513,
                38.0825334
              ],
              [
                47.0963311,
                38.0830815
              ],
              [
                47.0978149,
                38.0872736
              ],
              [
                47.0975797,
                38.1055089
              ],
              [
                47.1175,
                38.109001
              ],
              [
                47.1067881,
                38.1256572
              ],
              [
                47.1052618,
                38.1440183
              ],
              [
                47.1168383,
                38.1544526
              ],
              [
                47.1585578,
                38.1578348
              ],
              [
                47.1982294,
                38.1672452
              ],
              [
                47.2007799,
                38.1703081
              ],
              [
                47.2032799,
                38.1703081
              ],
              [
                47.2038362,
                38.1705866
              ],
              [
                47.2055026,
                38.1705866
              ],
              [
                47.2063363,
                38.1708651
              ],
              [
                47.207723,
                38.1708652
              ],
              [
                47.2082793,
                38.1711436
              ],
              [
                47.2093895,
                38.1711437
              ],
              [
                47.2099465,
                38.1714221
              ],
              [
                47.2116129,
                38.1714222
              ],
              [
                47.2166131,
                38.1725363
              ],
              [
                47.2177224,
                38.1730932
              ],
              [
                47.2182795,
                38.1730933
              ],
              [
                47.2232797,
                38.1744769
              ],
              [
                47.2260594,
                38.1750339
              ],
              [
                47.2266125,
                38.1753124
              ],
              [
                47.2274462,
                38.1753124
              ],
              [
                47.240226,
                38.1805861
              ],
              [
                47.258839,
                38.1861474
              ],
              [
                47.2771722,
                38.189759
              ],
              [
                47.2774488,
                38.1900375
              ],
              [
                47.2788387,
                38.1900374
              ],
              [
                47.3077283,
                38.1978086
              ],
              [
                47.3113386,
                38.1992012
              ],
              [
                47.3332851,
                38.2105925
              ],
              [
                47.3468978,
                38.2205913
              ],
              [
                47.348008,
                38.2219838
              ],
              [
                47.3491182,
                38.2225318
              ],
              [
                47.374773,
                38.2516376
              ],
              [
                47.3749455,
                38.2519849
              ],
              [
                47.3605073,
                38.2630906
              ],
              [
                47.3577307,
                38.2661447
              ],
              [
                47.3580073,
                38.2691989
              ],
              [
                47.3577307,
                38.2694773
              ],
              [
                47.3538408,
                38.2739237
              ],
              [
                47.3532877,
                38.2742021
              ],
              [
                47.3532877,
                38.2744806
              ],
              [
                47.3510642,
                38.2755944
              ],
              [
                47.3249509,
                38.2903167
              ],
              [
                47.3235611,
                38.2905951
              ],
              [
                47.3218946,
                38.2914304
              ],
              [
                47.3046716,
                38.2964246
              ],
              [
                47.3035614,
                38.2964245
              ],
              [
                47.3021716,
                38.296703
              ],
              [
                47.2910619,
                38.3003138
              ],
              [
                47.2871719,
                38.302263
              ],
              [
                47.2871719,
                38.3044815
              ],
              [
                47.2860618,
                38.3044815
              ],
              [
                47.2843953,
                38.3050384
              ],
              [
                47.2788381,
                38.3058648
              ],
              [
                47.2782819,
                38.3061522
              ],
              [
                47.2771717,
                38.3061523
              ],
              [
                47.2552251,
                38.3147569
              ],
              [
                47.2518922,
                38.3164275
              ],
              [
                47.1974456,
                38.3311486
              ],
              [
                47.1763327,
                38.3366992
              ],
              [
                47.1758251,
                38.3368741
              ],
              [
                47.1668895,
                38.3400403
              ],
              [
                47.1660558,
                38.3400403
              ],
              [
                47.1635557,
                38.3408756
              ],
              [
                47.1599424,
                38.3417018
              ],
              [
                47.1543859,
                38.3425371
              ],
              [
                47.1524429,
                38.3425371
              ],
              [
                47.1513329,
                38.3428155
              ],
              [
                47.1491093,
                38.3428156
              ],
              [
                47.1488328,
                38.343094
              ],
              [
                47.1396629,
                38.3430939
              ],
              [
                47.1391098,
                38.3428155
              ],
              [
                47.1368864,
                38.3428156
              ],
              [
                47.1363293,
                38.3425371
              ],
              [
                47.1310535,
                38.342537
              ],
              [
                47.1299432,
                38.3422587
              ],
              [
                47.1257768,
                38.3422586
              ],
              [
                47.1246635,
                38.3419802
              ],
              [
                47.1174398,
                38.3419802
              ],
              [
                47.1049403,
                38.3408754
              ],
              [
                47.104663,
                38.340597
              ],
              [
                47.1035497,
                38.340597
              ],
              [
                47.1027168,
                38.3403185
              ],
              [
                47.0999402,
                38.3403186
              ],
              [
                47.0991067,
                38.3400402
              ],
              [
                47.0977167,
                38.3400401
              ],
              [
                47.0966066,
                38.3397617
              ],
              [
                47.0949401,
                38.3397617
              ],
              [
                47.0941065,
                38.3394832
              ],
              [
                47.0921634,
                38.3394833
              ],
              [
                47.0910501,
                38.3392048
              ],
              [
                47.0904971,
                38.3394832
              ],
              [
                47.0891071,
                38.3392048
              ],
              [
                47.0863266,
                38.3392048
              ],
              [
                47.0852165,
                38.3394833
              ],
              [
                47.08355,
                38.3394832
              ],
              [
                47.0827171,
                38.3397616
              ],
              [
                47.0804937,
                38.3397616
              ],
              [
                47.0774405,
                38.3405969
              ],
              [
                47.0721607,
                38.3411448
              ],
              [
                47.0710505,
                38.3414232
              ],
              [
                47.0696606,
                38.3414232
              ],
              [
                47.0685504,
                38.3417016
              ],
              [
                47.066327,
                38.3417016
              ],
              [
                47.0638269,
                38.3422585
              ],
              [
                47.0607706,
                38.3422584
              ],
              [
                47.0596604,
                38.3425369
              ],
              [
                47.0585502,
                38.3425369
              ],
              [
                47.0579939,
                38.3428153
              ],
              [
                47.0554938,
                38.3428153
              ],
              [
                47.0543837,
                38.3430937
              ],
              [
                47.0529938,
                38.3430938
              ],
              [
                47.0521602,
                38.3433721
              ],
              [
                47.0496602,
                38.3433721
              ],
              [
                47.049104,
                38.3436506
              ],
              [
                47.0463273,
                38.3436506
              ],
              [
                47.0413271,
                38.3444858
              ],
              [
                47.0396608,
                38.3444858
              ],
              [
                47.0390439,
                38.344635
              ],
              [
                47.0041014,
                38.3489225
              ],
              [
                47.0024341,
                38.349201
              ],
              [
                46.9982675,
                38.3492009
              ],
              [
                46.9974347,
                38.3494794
              ],
              [
                46.9941011,
                38.3494794
              ],
              [
                46.9877111,
                38.3503146
              ],
              [
                46.9854915,
                38.3503146
              ],
              [
                46.979378,
                38.3511498
              ],
              [
                46.9788249,
                38.3514283
              ],
              [
                46.9774342,
                38.3514283
              ],
              [
                46.9668777,
                38.3539251
              ],
              [
                46.9666012,
                38.3542035
              ],
              [
                46.9654879,
                38.3544819
              ],
              [
                46.9568783,
                38.359206
              ],
              [
                46.9529884,
                38.3605891
              ],
              [
                46.9513211,
                38.3614243
              ],
              [
                46.9485445,
                38.3619812
              ],
              [
                46.9479882,
                38.3622596
              ],
              [
                46.9465984,
                38.3622596
              ],
              [
                46.9307652,
                38.3658699
              ],
              [
                46.8813187,
                38.3722553
              ],
              [
                46.878539,
                38.3719859
              ],
              [
                46.8727052,
                38.3717075
              ],
              [
                46.8707623,
                38.3717074
              ],
              [
                46.8693723,
                38.3714291
              ],
              [
                46.867152,
                38.371429
              ],
              [
                46.8593722,
                38.3697586
              ],
              [
                46.8577056,
                38.3694801
              ],
              [
                46.8507626,
                38.3669834
              ],
              [
                46.8488156,
                38.3664266
              ],
              [
                46.8446491,
                38.3644867
              ],
              [
                46.834649,
                38.3614241
              ],
              [
                46.8315926,
                38.3617024
              ],
              [
                46.8207595,
                38.3683754
              ],
              [
                46.8113164,
                38.3633729
              ],
              [
                46.8063163,
                38.3617024
              ],
              [
                46.805203,
                38.3611456
              ],
              [
                46.8029795,
                38.3605887
              ],
              [
                46.8024264,
                38.3605887
              ],
              [
                46.8021466,
                38.3608761
              ],
              [
                46.8010364,
                38.3608761
              ],
              [
                46.7938128,
                38.3644865
              ],
              [
                46.7932597,
                38.3644866
              ],
              [
                46.7927027,
                38.3650344
              ],
              [
                46.7827032,
                38.3750392
              ],
              [
                46.7790898,
                38.3825383
              ],
              [
                46.7735365,
                38.3900372
              ],
              [
                46.7610332,
                38.3930905
              ],
              [
                46.7602003,
                38.3930905
              ],
              [
                46.7596463,
                38.393369
              ],
              [
                46.7588135,
                38.3935772
              ],
              [
                46.7577001,
                38.3939257
              ],
              [
                46.7538135,
                38.3950393
              ],
              [
                46.7454765,
                38.3992064
              ],
              [
                46.7449234,
                38.3997631
              ],
              [
                46.7338097,
                38.4036516
              ],
              [
                46.7268666,
                38.4041994
              ],
              [
                46.726587,
                38.4044868
              ],
              [
                46.7177,
                38.4047562
              ],
              [
                46.7146437,
                38.4044867
              ],
              [
                46.7029771,
                38.4022596
              ],
              [
                46.7013107,
                38.4022595
              ],
              [
                46.700477,
                38.4019811
              ],
              [
                46.6993637,
                38.4019811
              ],
              [
                46.6976973,
                38.4014243
              ],
              [
                46.696587,
                38.4014243
              ],
              [
                46.6882541,
                38.3992062
              ],
              [
                46.6871408,
                38.3992062
              ],
              [
                46.6868642,
                38.3989278
              ],
              [
                46.6854743,
                38.3989277
              ],
              [
                46.681307,
                38.3978141
              ],
              [
                46.6774211,
                38.3967006
              ],
              [
                46.674921,
                38.3955959
              ],
              [
                46.6582511,
                38.390872
              ],
              [
                46.6574174,
                38.390872
              ],
              [
                46.6571409,
                38.3905937
              ],
              [
                46.6504743,
                38.3905936
              ],
              [
                46.6493611,
                38.3903152
              ],
              [
                46.6454742,
                38.3903152
              ],
              [
                46.6443609,
                38.3905936
              ],
              [
                46.6390843,
                38.3905936
              ],
              [
                46.6388077,
                38.390872
              ],
              [
                46.6279715,
                38.3908719
              ],
              [
                46.6243612,
                38.3903151
              ],
              [
                46.6201948,
                38.3903151
              ],
              [
                46.6188049,
                38.3900367
              ],
              [
                46.6129712,
                38.3900367
              ],
              [
                46.6115813,
                38.3897583
              ],
              [
                46.6107485,
                38.3900367
              ],
              [
                46.6082484,
                38.3900367
              ],
              [
                46.6060281,
                38.3905935
              ],
              [
                46.6046381,
                38.3905935
              ],
              [
                46.6024146,
                38.3911503
              ],
              [
                46.5976951,
                38.3930901
              ],
              [
                46.5924152,
                38.3944821
              ],
              [
                46.5874151,
                38.3955957
              ],
              [
                46.5799149,
                38.3967003
              ],
              [
                46.5788055,
                38.3969787
              ],
              [
                46.5757484,
                38.3969786
              ],
              [
                46.5754687,
                38.397257
              ],
              [
                46.5746351,
                38.3969786
              ],
              [
                46.5726921,
                38.3969786
              ],
              [
                46.5638021,
                38.39309
              ],
              [
                46.5540784,
                38.3867047
              ],
              [
                46.5538018,
                38.3864263
              ],
              [
                46.5515783,
                38.3844775
              ],
              [
                46.5510252,
                38.384208
              ],
              [
                46.5510253,
                38.3836512
              ],
              [
                46.5501924,
                38.3833728
              ],
              [
                46.5496354,
                38.3825376
              ],
              [
                46.5365789,
                38.375317
              ],
              [
                46.5338023,
                38.3744817
              ],
              [
                46.5324124,
                38.3739249
              ],
              [
                46.5315788,
                38.3739249
              ],
              [
                46.5310225,
                38.3736465
              ],
              [
                46.5282459,
                38.3736464
              ],
              [
                46.5276888,
                38.3739248
              ],
              [
                46.5263021,
                38.3739248
              ],
              [
                46.5260224,
                38.3742033
              ],
              [
                46.524356,
                38.3742033
              ],
              [
                46.5238029,
                38.3744817
              ],
              [
                46.5226887,
                38.3744816
              ],
              [
                46.5215793,
                38.3750385
              ],
              [
                46.5201895,
                38.3769784
              ],
              [
                46.5199129,
                38.3778136
              ],
              [
                46.5182457,
                38.379484
              ],
              [
                46.5143557,
                38.3794841
              ],
              [
                46.5104658,
                38.3800319
              ],
              [
                46.5024124,
                38.3867046
              ],
              [
                46.5004662,
                38.3894797
              ],
              [
                46.4996327,
                38.3905932
              ],
              [
                46.4946325,
                38.3919851
              ],
              [
                46.4918559,
                38.3919852
              ],
              [
                46.4899091,
                38.3922546
              ],
              [
                46.4890761,
                38.392542
              ],
              [
                46.4857424,
                38.3925419
              ],
              [
                46.4743532,
                38.3961431
              ],
              [
                46.4671327,
                38.3983703
              ],
              [
                46.4654663,
                38.3983704
              ],
              [
                46.4657428,
                38.3975352
              ],
              [
                46.4660193,
                38.3972568
              ],
              [
                46.4649099,
                38.3947601
              ],
              [
                46.4635193,
                38.3933681
              ],
              [
                46.4587965,
                38.3894795
              ],
              [
                46.4582435,
                38.3883659
              ],
              [
                46.4576864,
                38.3880964
              ],
              [
                46.4510199,
                38.3828157
              ],
              [
                46.4471299,
                38.3800316
              ],
              [
                46.4265734,
                38.3575341
              ],
              [
                46.4236288,
                38.3491435
              ],
              [
                46.4229639,
                38.3461457
              ],
              [
                46.422407,
                38.3416999
              ],
              [
                46.4224069,
                38.3350356
              ],
              [
                46.4257406,
                38.3239252
              ],
              [
                46.428797,
                38.3197576
              ],
              [
                46.4318534,
                38.3128146
              ],
              [
                46.4329636,
                38.3103086
              ],
              [
                46.4368535,
                38.3022607
              ],
              [
                46.4471304,
                38.2880867
              ],
              [
                46.4474101,
                38.2875388
              ],
              [
                46.4443538,
                38.2778108
              ],
              [
                46.4374068,
                38.2658638
              ],
              [
                46.4354639,
                38.2633667
              ],
              [
                46.4312974,
                38.254752
              ],
              [
                46.4299075,
                38.2489221
              ],
              [
                46.4299075,
                38.2450324
              ],
              [
                46.4310208,
                38.2394809
              ],
              [
                46.4304638,
                38.2358696
              ],
              [
                46.4257411,
                38.22809
              ],
              [
                46.414351,
                38.2172559
              ],
              [
                46.4124073,
                38.215028
              ],
              [
                46.4121307,
                38.21448
              ],
              [
                46.4057407,
                38.2064217
              ],
              [
                46.3957413,
                38.1933682
              ],
              [
                46.3954609,
                38.1922541
              ],
              [
                46.3949078,
                38.1858665
              ],
              [
                46.3954609,
                38.18336
              ],
              [
                46.3949078,
                38.1792003
              ],
              [
                46.3935181,
                38.1689223
              ],
              [
                46.3852235,
                38.1583081
              ],
              [
                46.3800762,
                38.1509507
              ],
              [
                46.3744926,
                38.1366495
              ],
              [
                46.3724885,
                38.1276658
              ],
              [
                46.3734628,
                38.1210917
              ],
              [
                46.376032,
                38.1151325
              ],
              [
                46.3839769,
                38.113355
              ],
              [
                46.3885666,
                38.1128984
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555251,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هشترود",
          "name:en": "Hashtrud County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q929127",
          "wikipedia": "en:Hashtrud County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.4790686,
                37.5879255
              ],
              [
                46.485525,
                37.5783284
              ],
              [
                46.4912002,
                37.5687382
              ],
              [
                46.4958103,
                37.5562019
              ],
              [
                46.4987752,
                37.5492349
              ],
              [
                46.4992631,
                37.544456
              ],
              [
                46.4999797,
                37.5375015
              ],
              [
                46.506303,
                37.5311271
              ],
              [
                46.5076929,
                37.529733
              ],
              [
                46.5146361,
                37.5205681
              ],
              [
                46.5324163,
                37.4969582
              ],
              [
                46.5343593,
                37.4950154
              ],
              [
                46.5385258,
                37.4922361
              ],
              [
                46.5390829,
                37.4916785
              ],
              [
                46.546583,
                37.4780696
              ],
              [
                46.5646391,
                37.4425125
              ],
              [
                46.5651961,
                37.4422337
              ],
              [
                46.5651961,
                37.441676
              ],
              [
                46.5657532,
                37.4413972
              ],
              [
                46.5660297,
                37.4411273
              ],
              [
                46.5701963,
                37.435847
              ],
              [
                46.6113091,
                37.3983446
              ],
              [
                46.6115856,
                37.3980658
              ],
              [
                46.6251992,
                37.3819541
              ],
              [
                46.6299221,
                37.372787
              ],
              [
                46.6393653,
                37.3652842
              ],
              [
                46.6399223,
                37.3647355
              ],
              [
                46.640756,
                37.3641777
              ],
              [
                46.6410325,
                37.363341
              ],
              [
                46.6413122,
                37.3625134
              ],
              [
                46.6493656,
                37.3552893
              ],
              [
                46.6496452,
                37.3544526
              ],
              [
                46.6615885,
                37.3413988
              ],
              [
                46.6624221,
                37.3400132
              ],
              [
                46.6627018,
                37.3391766
              ],
              [
                46.6629792,
                37.3375122
              ],
              [
                46.663812,
                37.3338956
              ],
              [
                46.6632558,
                37.3294512
              ],
              [
                46.6627019,
                37.3283446
              ],
              [
                46.6579791,
                37.32112
              ],
              [
                46.6574221,
                37.3211201
              ],
              [
                46.6560354,
                37.3205623
              ],
              [
                46.6513126,
                37.3197346
              ],
              [
                46.6485321,
                37.3197346
              ],
              [
                46.6479789,
                37.3194556
              ],
              [
                46.6454788,
                37.3194556
              ],
              [
                46.6451992,
                37.3191767
              ],
              [
                46.6426991,
                37.3191767
              ],
              [
                46.642146,
                37.3188978
              ],
              [
                46.6404796,
                37.3188977
              ],
              [
                46.6401991,
                37.3186189
              ],
              [
                46.6388124,
                37.3186188
              ],
              [
                46.6351989,
                37.3175122
              ],
              [
                46.6238096,
                37.3089021
              ],
              [
                46.6235324,
                37.3083442
              ],
              [
                46.6226995,
                37.3066798
              ],
              [
                46.6218659,
                37.3016774
              ],
              [
                46.6221425,
                37.3005617
              ],
              [
                46.621866,
                37.2994552
              ],
              [
                46.6221426,
                37.2988973
              ],
              [
                46.621866,
                37.2977906
              ],
              [
                46.621866,
                37.2911147
              ],
              [
                46.6215895,
                37.2902869
              ],
              [
                46.6149199,
                37.275846
              ],
              [
                46.6143667,
                37.2758461
              ],
              [
                46.6138096,
                37.2755672
              ],
              [
                46.6068665,
                37.2677843
              ],
              [
                46.606586,
                37.2666775
              ],
              [
                46.6063095,
                37.2638973
              ],
              [
                46.6065861,
                37.2619538
              ],
              [
                46.6068666,
                37.261117
              ],
              [
                46.6076994,
                37.2586156
              ],
              [
                46.6079768,
                37.2575089
              ],
              [
                46.6082533,
                37.2558443
              ],
              [
                46.608533,
                37.2550076
              ],
              [
                46.6088096,
                37.2547286
              ],
              [
                46.6093667,
                37.2533429
              ],
              [
                46.6093666,
                37.253064
              ],
              [
                46.6096432,
                37.2522272
              ],
              [
                46.6096433,
                37.2519483
              ],
              [
                46.6099198,
                37.2513994
              ],
              [
                46.6101995,
                37.2511205
              ],
              [
                46.6129761,
                37.2475034
              ],
              [
                46.6313094,
                37.2327827
              ],
              [
                46.6321431,
                37.2327827
              ],
              [
                46.6324227,
                37.2325038
              ],
              [
                46.638533,
                37.2325038
              ],
              [
                46.6390893,
                37.2327828
              ],
              [
                46.6404799,
                37.2327827
              ],
              [
                46.6415893,
                37.2330617
              ],
              [
                46.6429792,
                37.2330617
              ],
              [
                46.6440894,
                37.2333406
              ],
              [
                46.6474231,
                37.2333407
              ],
              [
                46.6476997,
                37.2336196
              ],
              [
                46.6485325,
                37.2333407
              ],
              [
                46.6521458,
                37.2333407
              ],
              [
                46.6529794,
                37.2330617
              ],
              [
                46.6543693,
                37.2330617
              ],
              [
                46.6571459,
                37.2333407
              ],
              [
                46.660203,
                37.2333407
              ],
              [
                46.6610358,
                37.2330617
              ],
              [
                46.6632562,
                37.2330617
              ],
              [
                46.664089,
                37.2327828
              ],
              [
                46.6788128,
                37.2327828
              ],
              [
                46.679369,
                37.2325039
              ],
              [
                46.6804793,
                37.232504
              ],
              [
                46.6860357,
                37.2308393
              ],
              [
                46.6865927,
                37.2302813
              ],
              [
                46.6871457,
                37.2302814
              ],
              [
                46.7038158,
                37.2163972
              ],
              [
                46.7054822,
                37.2147325
              ],
              [
                46.7135387,
                37.2064001
              ],
              [
                46.7146489,
                37.2058421
              ],
              [
                46.7149254,
                37.2052843
              ],
              [
                46.7160387,
                37.2047264
              ],
              [
                46.7168724,
                37.2038985
              ],
              [
                46.7193724,
                37.2025038
              ],
              [
                46.721592,
                37.2000022
              ],
              [
                46.7218725,
                37.1997322
              ],
              [
                46.7218725,
                37.1977795
              ],
              [
                46.7199256,
                37.1961148
              ],
              [
                46.7149255,
                37.1933432
              ],
              [
                46.7104825,
                37.1900048
              ],
              [
                46.7057589,
                37.188061
              ],
              [
                46.7029823,
                37.1875031
              ],
              [
                46.6952023,
                37.1855594
              ],
              [
                46.727879,
                37.149205
              ],
              [
                46.7736476,
                37.1486818
              ],
              [
                46.8079844,
                37.1704134
              ],
              [
                46.814609,
                37.2043574
              ],
              [
                46.8366482,
                37.1994536
              ],
              [
                46.8371539,
                37.1994536
              ],
              [
                46.8410438,
                37.1997326
              ],
              [
                46.8559783,
                37.1999852
              ],
              [
                46.8589211,
                37.2048495
              ],
              [
                46.8692509,
                37.2139608
              ],
              [
                46.8750421,
                37.2262447
              ],
              [
                46.8774121,
                37.2335548
              ],
              [
                46.8783124,
                37.2380494
              ],
              [
                46.8780445,
                37.2462422
              ],
              [
                46.8791103,
                37.2538232
              ],
              [
                46.8808328,
                37.2587041
              ],
              [
                46.8817913,
                37.2625176
              ],
              [
                46.8837162,
                37.2650156
              ],
              [
                46.8897223,
                37.2697863
              ],
              [
                46.8950222,
                37.2728086
              ],
              [
                46.8964015,
                37.2734569
              ],
              [
                46.8999547,
                37.275127
              ],
              [
                46.907713,
                37.2775115
              ],
              [
                46.9085466,
                37.2838996
              ],
              [
                46.914656,
                37.2997348
              ],
              [
                46.9157693,
                37.302236
              ],
              [
                46.9582723,
                37.3586188
              ],
              [
                46.9593825,
                37.3613987
              ],
              [
                46.9593825,
                37.3616776
              ],
              [
                46.9602153,
                37.3616776
              ],
              [
                46.9604919,
                37.3619565
              ],
              [
                46.9621591,
                37.3619565
              ],
              [
                46.9632725,
                37.3625143
              ],
              [
                46.9668818,
                37.363063
              ],
              [
                46.9693819,
                37.363063
              ],
              [
                46.9746617,
                37.3638997
              ],
              [
                46.9766056,
                37.3638997
              ],
              [
                46.9791055,
                37.3644575
              ],
              [
                46.9810486,
                37.3644575
              ],
              [
                46.9827151,
                37.3647364
              ],
              [
                46.9860487,
                37.3647364
              ],
              [
                46.9877151,
                37.3650153
              ],
              [
                46.989105,
                37.3647364
              ],
              [
                46.992995,
                37.3647364
              ],
              [
                47.0060515,
                37.3625144
              ],
              [
                47.0366077,
                37.3530682
              ],
              [
                47.0379984,
                37.3530683
              ],
              [
                47.0388312,
                37.3527894
              ],
              [
                47.040775,
                37.3527894
              ],
              [
                47.0416078,
                37.3525105
              ],
              [
                47.0438313,
                37.3525105
              ],
              [
                47.0443844,
                37.3522316
              ],
              [
                47.0466079,
                37.3519527
              ],
              [
                47.0485509,
                37.3519527
              ],
              [
                47.0493845,
                37.3516738
              ],
              [
                47.0541081,
                37.3511251
              ],
              [
                47.0568878,
                37.3511251
              ],
              [
                47.057441,
                37.3508462
              ],
              [
                47.0668881,
                37.3508462
              ],
              [
                47.0677208,
                37.3511251
              ],
              [
                47.0696647,
                37.3511251
              ],
              [
                47.0702209,
                37.351404
              ],
              [
                47.0829978,
                37.3547327
              ],
              [
                47.0916104,
                37.3588981
              ],
              [
                47.0924441,
                37.358898
              ],
              [
                47.0930011,
                37.3591769
              ],
              [
                47.0935543,
                37.3588981
              ],
              [
                47.0941105,
                37.3588981
              ],
              [
                47.094387,
                37.3586191
              ],
              [
                47.0950415,
                37.3586278
              ],
              [
                47.0955011,
                37.3586192
              ],
              [
                47.1043872,
                37.3480664
              ],
              [
                47.1160573,
                37.3214002
              ],
              [
                47.1230003,
                37.3108468
              ],
              [
                47.1291138,
                37.3022366
              ],
              [
                47.129667,
                37.2994565
              ],
              [
                47.129667,
                37.2988986
              ],
              [
                47.1299475,
                37.2958396
              ],
              [
                47.130224,
                37.2955697
              ],
              [
                47.130224,
                37.2852858
              ],
              [
                47.1321672,
                37.277512
              ],
              [
                47.1330008,
                37.2766752
              ],
              [
                47.1388337,
                37.2680646
              ],
              [
                47.1491137,
                37.2563946
              ],
              [
                47.1521708,
                37.2491784
              ],
              [
                47.1524474,
                37.2488995
              ],
              [
                47.1521708,
                37.2486205
              ],
              [
                47.1521709,
                37.246677
              ],
              [
                47.1493903,
                37.2391727
              ],
              [
                47.1465111,
                37.2355127
              ],
              [
                47.16542,
                37.2261666
              ],
              [
                47.2184978,
                37.2304198
              ],
              [
                47.3174557,
                37.2452918
              ],
              [
                47.3024553,
                37.2594542
              ],
              [
                47.2985654,
                37.2689018
              ],
              [
                47.2968989,
                37.2708453
              ],
              [
                47.2946754,
                37.271673
              ],
              [
                47.2943988,
                37.271952
              ],
              [
                47.2935652,
                37.2719519
              ],
              [
                47.293009,
                37.2722308
              ],
              [
                47.291066,
                37.2722308
              ],
              [
                47.2907854,
                37.2725098
              ],
              [
                47.2863424,
                37.2725098
              ],
              [
                47.2855088,
                37.2722308
              ],
              [
                47.2830087,
                37.2722308
              ],
              [
                47.2821759,
                37.2719519
              ],
              [
                47.2810657,
                37.2722308
              ],
              [
                47.2788422,
                37.2725097
              ],
              [
                47.2724522,
                37.2766755
              ],
              [
                47.2721757,
                37.2780612
              ],
              [
                47.274396,
                37.2833426
              ],
              [
                47.2746756,
                37.2841795
              ],
              [
                47.2818993,
                37.2902886
              ],
              [
                47.2818992,
                37.292511
              ],
              [
                47.280786,
                37.2947333
              ],
              [
                47.2807859,
                37.2983412
              ],
              [
                47.2832852,
                37.3027858
              ],
              [
                47.2846758,
                37.3039014
              ],
              [
                47.2916189,
                37.3066815
              ],
              [
                47.2938424,
                37.3075093
              ],
              [
                47.2966222,
                37.3080671
              ],
              [
                47.298009,
                37.3080672
              ],
              [
                47.3055083,
                37.3122328
              ],
              [
                47.3066215,
                37.3169562
              ],
              [
                47.3057887,
                37.3200061
              ],
              [
                47.3057888,
                37.3241806
              ],
              [
                47.3052317,
                37.3255662
              ],
              [
                47.3052316,
                37.3264029
              ],
              [
                47.3052317,
                37.3266817
              ],
              [
                47.3043988,
                37.3283462
              ],
              [
                47.3016222,
                37.3322328
              ],
              [
                47.2988417,
                37.3344549
              ],
              [
                47.2888422,
                37.3391783
              ],
              [
                47.2882851,
                37.3391782
              ],
              [
                47.285232,
                37.3405637
              ],
              [
                47.2677292,
                37.3489034
              ],
              [
                47.2674526,
                37.3494523
              ],
              [
                47.2671753,
                37.3497311
              ],
              [
                47.266619,
                37.3508466
              ],
              [
                47.2668956,
                37.3530688
              ],
              [
                47.2763418,
                37.3647371
              ],
              [
                47.2885655,
                37.3719521
              ],
              [
                47.2907851,
                37.3736254
              ],
              [
                47.2924515,
                37.3750108
              ],
              [
                47.2932851,
                37.3766751
              ],
              [
                47.2935648,
                37.3819559
              ],
              [
                47.2932851,
                37.3827925
              ],
              [
                47.292732,
                37.3833502
              ],
              [
                47.2924514,
                37.3841779
              ],
              [
                47.2910655,
                37.3852934
              ],
              [
                47.2699517,
                37.3950089
              ],
              [
                47.2643954,
                37.4027903
              ],
              [
                47.2641188,
                37.4041756
              ],
              [
                47.2641187,
                37.4064066
              ],
              [
                47.2891184,
                37.4447362
              ],
              [
                47.2905082,
                37.4461305
              ],
              [
                47.2993982,
                37.4591824
              ],
              [
                47.2999545,
                37.4650111
              ],
              [
                47.2996748,
                37.4655688
              ],
              [
                47.2960645,
                37.4702911
              ],
              [
                47.2860456,
                37.4829272
              ],
              [
                47.2682495,
                37.4891476
              ],
              [
                47.2537421,
                37.4922941
              ],
              [
                47.2379794,
                37.4971365
              ],
              [
                47.2342029,
                37.5056934
              ],
              [
                47.2360975,
                37.5234605
              ],
              [
                47.2368785,
                37.5306945
              ],
              [
                47.2356658,
                37.5394025
              ],
              [
                47.2277282,
                37.550016
              ],
              [
                47.2201395,
                37.5590033
              ],
              [
                47.2229745,
                37.5614024
              ],
              [
                47.2128424,
                37.5623404
              ],
              [
                47.198115,
                37.5647659
              ],
              [
                47.1811385,
                37.5699628
              ],
              [
                47.1683744,
                37.5754392
              ],
              [
                47.1526907,
                37.5820442
              ],
              [
                47.1407794,
                37.5866821
              ],
              [
                47.1388324,
                37.5883457
              ],
              [
                47.1207765,
                37.6019612
              ],
              [
                47.1199429,
                37.60224
              ],
              [
                47.1191093,
                37.6030763
              ],
              [
                47.0838295,
                37.6161339
              ],
              [
                47.0813294,
                37.6164037
              ],
              [
                47.0807763,
                37.6166824
              ],
              [
                47.0766098,
                37.6177975
              ],
              [
                47.0252172,
                37.6302972
              ],
              [
                47.0238274,
                37.6302972
              ],
              [
                47.0110505,
                37.6352969
              ],
              [
                47.0102169,
                37.6358545
              ],
              [
                47.0096606,
                37.6358544
              ],
              [
                47.0096606,
                37.6361333
              ],
              [
                46.9960509,
                37.641133
              ],
              [
                46.9935509,
                37.6414027
              ],
              [
                46.9932704,
                37.6416815
              ],
              [
                46.9918804,
                37.6416815
              ],
              [
                46.9913273,
                37.6419603
              ],
              [
                46.9827139,
                37.6419603
              ],
              [
                46.9818811,
                37.6416815
              ],
              [
                46.9804943,
                37.6416815
              ],
              [
                46.9796607,
                37.6414027
              ],
              [
                46.9782709,
                37.6414027
              ],
              [
                46.9754942,
                37.6408542
              ],
              [
                46.9746605,
                37.6405755
              ],
              [
                46.9735472,
                37.6405754
              ],
              [
                46.9735473,
                37.6402966
              ],
              [
                46.972438,
                37.6402966
              ],
              [
                46.966048,
                37.6380755
              ],
              [
                46.9649378,
                37.6380755
              ],
              [
                46.9638244,
                37.6375179
              ],
              [
                46.9629909,
                37.6375179
              ],
              [
                46.9538242,
                37.6336332
              ],
              [
                46.9443811,
                37.6250182
              ],
              [
                46.942435,
                37.6144609
              ],
              [
                46.9427147,
                37.6141821
              ],
              [
                46.9435483,
                37.6116821
              ],
              [
                46.9435483,
                37.6111335
              ],
              [
                46.946325,
                37.6025183
              ],
              [
                46.9464633,
                37.6011244
              ],
              [
                46.9466016,
                37.6005759
              ],
              [
                46.946325,
                37.5980758
              ],
              [
                46.9466016,
                37.5975182
              ],
              [
                46.9463249,
                37.5955758
              ],
              [
                46.9446578,
                37.5911332
              ],
              [
                46.9371585,
                37.5836329
              ],
              [
                46.9296583,
                37.5797388
              ],
              [
                46.9213254,
                37.5772386
              ],
              [
                46.9207682,
                37.5772386
              ],
              [
                46.9177119,
                37.576681
              ],
              [
                46.916322,
                37.5764023
              ],
              [
                46.9121548,
                37.5764022
              ],
              [
                46.9118782,
                37.5761323
              ],
              [
                46.9046554,
                37.5764021
              ],
              [
                46.9038218,
                37.576681
              ],
              [
                46.9027117,
                37.576681
              ],
              [
                46.9018788,
                37.5769597
              ],
              [
                46.900489,
                37.5769597
              ],
              [
                46.8863222,
                37.5808449
              ],
              [
                46.8857651,
                37.5814113
              ],
              [
                46.8610427,
                37.5908542
              ],
              [
                46.8607654,
                37.5911329
              ],
              [
                46.8602091,
                37.5914027
              ],
              [
                46.859652,
                37.5914028
              ],
              [
                46.8560425,
                37.5927967
              ],
              [
                46.8560426,
                37.5930754
              ],
              [
                46.8554855,
                37.5930755
              ],
              [
                46.8549324,
                37.593633
              ],
              [
                46.8435422,
                37.5972392
              ],
              [
                46.842986,
                37.5972392
              ],
              [
                46.8388195,
                37.5983543
              ],
              [
                46.821873,
                37.6016816
              ],
              [
                46.8207628,
                37.6016816
              ],
              [
                46.8199292,
                37.6019604
              ],
              [
                46.8171526,
                37.6019605
              ],
              [
                46.8165963,
                37.6022392
              ],
              [
                46.8143728,
                37.6022392
              ],
              [
                46.8135392,
                37.602518
              ],
              [
                46.8118727,
                37.602518
              ],
              [
                46.8107626,
                37.6027967
              ],
              [
                46.8090961,
                37.6027968
              ],
              [
                46.8079859,
                37.6030756
              ],
              [
                46.8063196,
                37.6030755
              ],
              [
                46.8052062,
                37.6033543
              ],
              [
                46.7865965,
                37.6033543
              ],
              [
                46.7860394,
                37.6030755
              ],
              [
                46.7840932,
                37.6030754
              ],
              [
                46.7815932,
                37.6019603
              ],
              [
                46.7682602,
                37.5916813
              ],
              [
                46.7660366,
                37.5891812
              ],
              [
                46.765203,
                37.5883448
              ],
              [
                46.7640936,
                37.5877962
              ],
              [
                46.7546505,
                37.5777957
              ],
              [
                46.74298,
                37.5502936
              ],
              [
                46.7407605,
                37.5483509
              ],
              [
                46.7396471,
                37.5475145
              ],
              [
                46.7393706,
                37.5469569
              ],
              [
                46.739094,
                37.5466781
              ],
              [
                46.7382604,
                37.5463993
              ],
              [
                46.7379808,
                37.5458507
              ],
              [
                46.730204,
                37.5422351
              ],
              [
                46.7299274,
                37.5419563
              ],
              [
                46.7290907,
                37.5419564
              ],
              [
                46.7279805,
                37.5414078
              ],
              [
                46.7099239,
                37.539465
              ],
              [
                46.7096474,
                37.5391862
              ],
              [
                46.7007573,
                37.5391862
              ],
              [
                46.6915907,
                37.5419563
              ],
              [
                46.6910344,
                37.5419563
              ],
              [
                46.6907578,
                37.5422351
              ],
              [
                46.6911688,
                37.5471348
              ],
              [
                46.6863401,
                37.5483324
              ],
              [
                46.6810078,
                37.5527169
              ],
              [
                46.6821444,
                37.5458505
              ],
              [
                46.6813108,
                37.5458505
              ],
              [
                46.6810342,
                37.5461293
              ],
              [
                46.6782576,
                37.5469567
              ],
              [
                46.6674213,
                37.5547362
              ],
              [
                46.6588109,
                37.566122
              ],
              [
                46.6460896,
                37.5758127
              ],
              [
                46.6309426,
                37.5767432
              ],
              [
                46.6303895,
                37.5775799
              ],
              [
                46.6273332,
                37.579523
              ],
              [
                46.6248331,
                37.5809173
              ],
              [
                46.6198329,
                37.5834181
              ],
              [
                46.6123112,
                37.5847468
              ],
              [
                46.6098112,
                37.5847468
              ],
              [
                46.6007798,
                37.5885535
              ],
              [
                46.5936403,
                37.5920241
              ],
              [
                46.5852159,
                37.5974988
              ],
              [
                46.5783757,
                37.6011369
              ],
              [
                46.5742376,
                37.6032041
              ],
              [
                46.5695226,
                37.6052441
              ],
              [
                46.5655331,
                37.6070051
              ],
              [
                46.562878,
                37.6080252
              ],
              [
                46.5550549,
                37.6103436
              ],
              [
                46.5472062,
                37.6124582
              ],
              [
                46.5396778,
                37.6147699
              ],
              [
                46.5314302,
                37.619461
              ],
              [
                46.5264993,
                37.6231754
              ],
              [
                46.5171017,
                37.6324271
              ],
              [
                46.5100032,
                37.6392241
              ],
              [
                46.50724,
                37.6416641
              ],
              [
                46.5003096,
                37.6464215
              ],
              [
                46.4962374,
                37.6460884
              ],
              [
                46.4892336,
                37.6435059
              ],
              [
                46.48427,
                37.6418302
              ],
              [
                46.4770602,
                37.6378202
              ],
              [
                46.4701155,
                37.6322095
              ],
              [
                46.4691905,
                37.6228761
              ],
              [
                46.4695529,
                37.6161274
              ],
              [
                46.4712668,
                37.6052088
              ],
              [
                46.4740357,
                37.5967564
              ],
              [
                46.4790686,
                37.5879255
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555258,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ورزقان",
          "name:en": "Varzaqan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q946847",
          "wikipedia": "en:Varzaqan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.0328775,
                38.6480062
              ],
              [
                46.0377182,
                38.6443729
              ],
              [
                46.04205,
                38.6375342
              ],
              [
                46.0456824,
                38.630397
              ],
              [
                46.0493396,
                38.6252577
              ],
              [
                46.0543012,
                38.6193182
              ],
              [
                46.0610228,
                38.6132299
              ],
              [
                46.0640091,
                38.6109355
              ],
              [
                46.0662764,
                38.6090314
              ],
              [
                46.0676866,
                38.6079518
              ],
              [
                46.0587992,
                38.6045082
              ],
              [
                46.052086,
                38.5990888
              ],
              [
                46.0496316,
                38.5941933
              ],
              [
                46.0512722,
                38.5881339
              ],
              [
                46.0559873,
                38.5844457
              ],
              [
                46.0625965,
                38.5802979
              ],
              [
                46.0688623,
                38.5761171
              ],
              [
                46.0759862,
                38.5704843
              ],
              [
                46.0818401,
                38.5630062
              ],
              [
                46.0864559,
                38.5568591
              ],
              [
                46.092337,
                38.5467481
              ],
              [
                46.0947148,
                38.5407319
              ],
              [
                46.0967716,
                38.5339239
              ],
              [
                46.1011261,
                38.5264636
              ],
              [
                46.1065691,
                38.5190541
              ],
              [
                46.1109886,
                38.5139404
              ],
              [
                46.1178406,
                38.5064715
              ],
              [
                46.1253269,
                38.4988044
              ],
              [
                46.1288534,
                38.4962493
              ],
              [
                46.1347381,
                38.4846213
              ],
              [
                46.1403439,
                38.4778331
              ],
              [
                46.1486212,
                38.470619
              ],
              [
                46.1529789,
                38.4675404
              ],
              [
                46.1590404,
                38.4624211
              ],
              [
                46.1681574,
                38.4568827
              ],
              [
                46.1886014,
                38.4526105
              ],
              [
                46.1994002,
                38.452908
              ],
              [
                46.2057726,
                38.4523612
              ],
              [
                46.2150861,
                38.4579501
              ],
              [
                46.2351748,
                38.4655939
              ],
              [
                46.2437882,
                38.4700388
              ],
              [
                46.2462883,
                38.4711522
              ],
              [
                46.2529548,
                38.4711522
              ],
              [
                46.2568447,
                38.4697604
              ],
              [
                46.2590644,
                38.4697605
              ],
              [
                46.2593448,
                38.469482
              ],
              [
                46.2621214,
                38.4694821
              ],
              [
                46.2629542,
                38.4697604
              ],
              [
                46.2640644,
                38.4697605
              ],
              [
                46.271288,
                38.4719874
              ],
              [
                46.2735116,
                38.4733701
              ],
              [
                46.2843445,
                38.4822596
              ],
              [
                46.287954,
                38.4830947
              ],
              [
                46.2901775,
                38.4830947
              ],
              [
                46.2907345,
                38.4833731
              ],
              [
                46.2929541,
                38.4833731
              ],
              [
                46.2935111,
                38.4830947
              ],
              [
                46.294344,
                38.4830947
              ],
              [
                46.2946245,
                38.4828164
              ],
              [
                46.2951776,
                38.4828164
              ],
              [
                46.2971246,
                38.4822597
              ],
              [
                46.2993441,
                38.4819813
              ],
              [
                46.3001777,
                38.4819813
              ],
              [
                46.3001777,
                38.4817029
              ],
              [
                46.300734,
                38.481703
              ],
              [
                46.3051779,
                38.4803202
              ],
              [
                46.3107342,
                38.473927
              ],
              [
                46.3115671,
                38.4736486
              ],
              [
                46.3121241,
                38.4730919
              ],
              [
                46.3132343,
                38.473092
              ],
              [
                46.3137906,
                38.4728136
              ],
              [
                46.3140671,
                38.4730919
              ],
              [
                46.3149007,
                38.4728135
              ],
              [
                46.3254572,
                38.4719875
              ],
              [
                46.3257338,
                38.4722569
              ],
              [
                46.3268471,
                38.4722569
              ],
              [
                46.3276807,
                38.4725442
              ],
              [
                46.3301808,
                38.4728136
              ],
              [
                46.3351809,
                38.4728136
              ],
              [
                46.3357372,
                38.473092
              ],
              [
                46.3360137,
                38.4728136
              ],
              [
                46.339624,
                38.4722569
              ],
              [
                46.3396239,
                38.4733704
              ],
              [
                46.3393474,
                38.4742054
              ],
              [
                46.3393474,
                38.4758756
              ],
              [
                46.3387904,
                38.4764323
              ],
              [
                46.3385138,
                38.4772584
              ],
              [
                46.3379575,
                38.4778151
              ],
              [
                46.3371239,
                38.480042
              ],
              [
                46.3376802,
                38.4833732
              ],
              [
                46.3404567,
                38.4854111
              ],
              [
                46.3410137,
                38.485591
              ],
              [
                46.3415708,
                38.4861478
              ],
              [
                46.3426802,
                38.4861477
              ],
              [
                46.3432373,
                38.4864261
              ],
              [
                46.3440701,
                38.4864261
              ],
              [
                46.344624,
                38.4867044
              ],
              [
                46.3474037,
                38.4867045
              ],
              [
                46.3499038,
                38.4861478
              ],
              [
                46.3643471,
                38.4803204
              ],
              [
                46.3657371,
                38.4803203
              ],
              [
                46.3693465,
                38.4794853
              ],
              [
                46.3710168,
                38.4794853
              ],
              [
                46.3724036,
                38.4789286
              ],
              [
                46.3735169,
                38.4789286
              ],
              [
                46.3746271,
                38.4783719
              ],
              [
                46.37546,
                38.4783719
              ],
              [
                46.3771271,
                38.4775368
              ],
              [
                46.3782365,
                38.4775368
              ],
              [
                46.3787936,
                38.4772585
              ],
              [
                46.3810171,
                38.4764324
              ],
              [
                46.3851836,
                38.4747623
              ],
              [
                46.386293,
                38.4747623
              ],
              [
                46.3868501,
                38.4744839
              ],
              [
                46.3885165,
                38.4744839
              ],
              [
                46.3890696,
                38.4742056
              ],
              [
                46.3946268,
                38.4742056
              ],
              [
                46.3954596,
                38.4744839
              ],
              [
                46.3976831,
                38.4744839
              ],
              [
                46.3987933,
                38.4750407
              ],
              [
                46.3996269,
                38.4750407
              ],
              [
                46.4004598,
                38.475319
              ],
              [
                46.4082395,
                38.478372
              ],
              [
                46.4121296,
                38.478372
              ],
              [
                46.4160163,
                38.4772586
              ],
              [
                46.4246298,
                38.4719878
              ],
              [
                46.434073,
                38.4647594
              ],
              [
                46.4351863,
                38.4639333
              ],
              [
                46.4357395,
                38.4622631
              ],
              [
                46.43602,
                38.4617064
              ],
              [
                46.444353,
                38.4494852
              ],
              [
                46.444353,
                38.4480933
              ],
              [
                46.4449062,
                38.4464231
              ],
              [
                46.4449062,
                38.4319835
              ],
              [
                46.4468532,
                38.4242068
              ],
              [
                46.451576,
                38.4214229
              ],
              [
                46.4535198,
                38.4197616
              ],
              [
                46.4549097,
                38.4175345
              ],
              [
                46.4551862,
                38.4169777
              ],
              [
                46.4551862,
                38.4158731
              ],
              [
                46.4565761,
                38.412263
              ],
              [
                46.4654663,
                38.4011453
              ],
              [
                46.4654663,
                38.3983704
              ],
              [
                46.4671327,
                38.3983703
              ],
              [
                46.4743532,
                38.3961431
              ],
              [
                46.4857424,
                38.3925419
              ],
              [
                46.4890761,
                38.392542
              ],
              [
                46.4899091,
                38.3922546
              ],
              [
                46.4918559,
                38.3919852
              ],
              [
                46.4946325,
                38.3919851
              ],
              [
                46.4996327,
                38.3905932
              ],
              [
                46.5004662,
                38.3894797
              ],
              [
                46.5024124,
                38.3867046
              ],
              [
                46.5104658,
                38.3800319
              ],
              [
                46.5143557,
                38.3794841
              ],
              [
                46.5182457,
                38.379484
              ],
              [
                46.5199129,
                38.3778136
              ],
              [
                46.5201895,
                38.3769784
              ],
              [
                46.5215793,
                38.3750385
              ],
              [
                46.5226887,
                38.3744816
              ],
              [
                46.5238029,
                38.3744817
              ],
              [
                46.524356,
                38.3742033
              ],
              [
                46.5260224,
                38.3742033
              ],
              [
                46.5263021,
                38.3739248
              ],
              [
                46.5276888,
                38.3739248
              ],
              [
                46.5282459,
                38.3736464
              ],
              [
                46.5310225,
                38.3736465
              ],
              [
                46.5315788,
                38.3739249
              ],
              [
                46.5324124,
                38.3739249
              ],
              [
                46.5338023,
                38.3744817
              ],
              [
                46.5365789,
                38.375317
              ],
              [
                46.5496354,
                38.3825376
              ],
              [
                46.5501924,
                38.3833728
              ],
              [
                46.5510253,
                38.3836512
              ],
              [
                46.5510252,
                38.384208
              ],
              [
                46.5515783,
                38.3844775
              ],
              [
                46.5538018,
                38.3864263
              ],
              [
                46.5540784,
                38.3867047
              ],
              [
                46.5638021,
                38.39309
              ],
              [
                46.5726921,
                38.3969786
              ],
              [
                46.5746351,
                38.3969786
              ],
              [
                46.5754687,
                38.397257
              ],
              [
                46.5757484,
                38.3969786
              ],
              [
                46.5788055,
                38.3969787
              ],
              [
                46.5799149,
                38.3967003
              ],
              [
                46.5874151,
                38.3955957
              ],
              [
                46.5924152,
                38.3944821
              ],
              [
                46.5976951,
                38.3930901
              ],
              [
                46.6024146,
                38.3911503
              ],
              [
                46.6046381,
                38.3905935
              ],
              [
                46.6060281,
                38.3905935
              ],
              [
                46.6082484,
                38.3900367
              ],
              [
                46.6107485,
                38.3900367
              ],
              [
                46.6115813,
                38.3897583
              ],
              [
                46.6129712,
                38.3900367
              ],
              [
                46.6188049,
                38.3900367
              ],
              [
                46.6201948,
                38.3903151
              ],
              [
                46.6243612,
                38.3903151
              ],
              [
                46.6279715,
                38.3908719
              ],
              [
                46.6388077,
                38.390872
              ],
              [
                46.6390843,
                38.3905936
              ],
              [
                46.6443609,
                38.3905936
              ],
              [
                46.6454742,
                38.3903152
              ],
              [
                46.6493611,
                38.3903152
              ],
              [
                46.6504743,
                38.3905936
              ],
              [
                46.6571409,
                38.3905937
              ],
              [
                46.6574174,
                38.390872
              ],
              [
                46.6582511,
                38.390872
              ],
              [
                46.674921,
                38.3955959
              ],
              [
                46.6774211,
                38.3967006
              ],
              [
                46.681307,
                38.3978141
              ],
              [
                46.6854743,
                38.3989277
              ],
              [
                46.6868642,
                38.3989278
              ],
              [
                46.6871408,
                38.3992062
              ],
              [
                46.6882541,
                38.3992062
              ],
              [
                46.696587,
                38.4014243
              ],
              [
                46.6976973,
                38.4014243
              ],
              [
                46.6993637,
                38.4019811
              ],
              [
                46.700477,
                38.4019811
              ],
              [
                46.7013107,
                38.4022595
              ],
              [
                46.7029771,
                38.4022596
              ],
              [
                46.7146437,
                38.4044867
              ],
              [
                46.7177,
                38.4047562
              ],
              [
                46.726587,
                38.4044868
              ],
              [
                46.7268666,
                38.4041994
              ],
              [
                46.7338097,
                38.4036516
              ],
              [
                46.7449234,
                38.3997631
              ],
              [
                46.7454765,
                38.3992064
              ],
              [
                46.7538135,
                38.3950393
              ],
              [
                46.7577001,
                38.3939257
              ],
              [
                46.7588135,
                38.3935772
              ],
              [
                46.7588135,
                38.3989279
              ],
              [
                46.7596463,
                38.4025381
              ],
              [
                46.762423,
                38.4100367
              ],
              [
                46.7632565,
                38.4122639
              ],
              [
                46.7646463,
                38.4192056
              ],
              [
                46.7651995,
                38.4203192
              ],
              [
                46.7651995,
                38.4211453
              ],
              [
                46.7654799,
                38.4217021
              ],
              [
                46.7657564,
                38.4275392
              ],
              [
                46.7654799,
                38.4278176
              ],
              [
                46.7649229,
                38.4297573
              ],
              [
                46.7643667,
                38.4325411
              ],
              [
                46.7613134,
                38.4350375
              ],
              [
                46.7604798,
                38.4358726
              ],
              [
                46.7582563,
                38.4364294
              ],
              [
                46.7574234,
                38.4364294
              ],
              [
                46.7571461,
                38.4367078
              ],
              [
                46.7560328,
                38.4367078
              ],
              [
                46.7551999,
                38.4372645
              ],
              [
                46.7543663,
                38.4372645
              ],
              [
                46.7488131,
                38.4397609
              ],
              [
                46.7465897,
                38.4422663
              ],
              [
                46.7443669,
                38.4469807
              ],
              [
                46.7443669,
                38.4497644
              ],
              [
                46.7507566,
                38.4961515
              ],
              [
                46.7513129,
                38.4967081
              ],
              [
                46.7513129,
                38.4978216
              ],
              [
                46.7535324,
                38.5017093
              ],
              [
                46.7535325,
                38.5022661
              ],
              [
                46.7540895,
                38.5025445
              ],
              [
                46.7546466,
                38.5036488
              ],
              [
                46.755756,
                38.5050406
              ],
              [
                46.7621459,
                38.5130944
              ],
              [
                46.7624225,
                38.5133728
              ],
              [
                46.7724226,
                38.5267059
              ],
              [
                46.7724226,
                38.5367077
              ],
              [
                46.7735359,
                38.5425436
              ],
              [
                46.7838126,
                38.5564325
              ],
              [
                46.7865924,
                38.558659
              ],
              [
                46.7971457,
                38.5655989
              ],
              [
                46.8196485,
                38.5733736
              ],
              [
                46.8213149,
                38.5742085
              ],
              [
                46.8227017,
                38.5742085
              ],
              [
                46.8313151,
                38.5767043
              ],
              [
                46.8421482,
                38.5825487
              ],
              [
                46.8429817,
                38.5828181
              ],
              [
                46.8468717,
                38.5875401
              ],
              [
                46.8482615,
                38.5900448
              ],
              [
                46.849928,
                38.5925405
              ],
              [
                46.849928,
                38.5930971
              ],
              [
                46.8504811,
                38.5933754
              ],
              [
                46.861318,
                38.618933
              ],
              [
                46.8621516,
                38.6250462
              ],
              [
                46.8624281,
                38.6256027
              ],
              [
                46.8621515,
                38.6258809
              ],
              [
                46.8624281,
                38.6264285
              ],
              [
                46.8621516,
                38.6272634
              ],
              [
                46.8624281,
                38.6297679
              ],
              [
                46.8621516,
                38.6303244
              ],
              [
                46.8607609,
                38.6383764
              ],
              [
                46.8604812,
                38.641159
              ],
              [
                46.8604812,
                38.6419849
              ],
              [
                46.859928,
                38.6442111
              ],
              [
                46.8582615,
                38.6519845
              ],
              [
                46.8546481,
                38.6592103
              ],
              [
                46.8538146,
                38.6600451
              ],
              [
                46.8535379,
                38.6608799
              ],
              [
                46.8432611,
                38.6703225
              ],
              [
                46.8304811,
                38.6783828
              ],
              [
                46.8260381,
                38.6805998
              ],
              [
                46.8254818,
                38.6811563
              ],
              [
                46.8118682,
                38.6858775
              ],
              [
                46.8110346,
                38.6858775
              ],
              [
                46.810758,
                38.6861557
              ],
              [
                46.8090916,
                38.6861557
              ],
              [
                46.8082579,
                38.6864339
              ],
              [
                46.8040914,
                38.6872687
              ],
              [
                46.7807548,
                38.6969891
              ],
              [
                46.7782549,
                38.7014319
              ],
              [
                46.7779782,
                38.7025449
              ],
              [
                46.7777017,
                38.7039361
              ],
              [
                46.7779782,
                38.7056054
              ],
              [
                46.7913113,
                38.7236635
              ],
              [
                46.797145,
                38.7272714
              ],
              [
                46.7988114,
                38.7300446
              ],
              [
                46.797145,
                38.7303228
              ],
              [
                46.7963113,
                38.7303228
              ],
              [
                46.7935347,
                38.730601
              ],
              [
                46.7885346,
                38.7336614
              ],
              [
                46.7863119,
                38.7361565
              ],
              [
                46.7846446,
                38.7408771
              ],
              [
                46.7846447,
                38.7411554
              ],
              [
                46.7838118,
                38.7450503
              ],
              [
                46.7815882,
                38.7517184
              ],
              [
                46.7810351,
                38.7522658
              ],
              [
                46.7810351,
                38.7528223
              ],
              [
                46.7713114,
                38.7639324
              ],
              [
                46.76107,
                38.7687828
              ],
              [
                46.7607549,
                38.7689401
              ],
              [
                46.7221422,
                38.7792152
              ],
              [
                46.7163085,
                38.7811625
              ],
              [
                46.7110318,
                38.7828228
              ],
              [
                46.697419,
                38.7850482
              ],
              [
                46.6924188,
                38.7850482
              ],
              [
                46.6915853,
                38.7853264
              ],
              [
                46.6899188,
                38.7853264
              ],
              [
                46.6849188,
                38.7867174
              ],
              [
                46.6838053,
                38.7869955
              ],
              [
                46.6715825,
                38.7917157
              ],
              [
                46.6696395,
                38.7917157
              ],
              [
                46.6690824,
                38.7914376
              ],
              [
                46.6665824,
                38.7914375
              ],
              [
                46.6660291,
                38.7914375
              ],
              [
                46.6649158,
                38.7906029
              ],
              [
                46.6588057,
                38.78783
              ],
              [
                46.6463062,
                38.7744947
              ],
              [
                46.643249,
                38.7719909
              ],
              [
                46.6202817,
                38.7586446
              ],
              [
                46.61454,
                38.7543926
              ],
              [
                46.6083418,
                38.7515631
              ],
              [
                46.6016424,
                38.748394
              ],
              [
                46.5936504,
                38.7453841
              ],
              [
                46.5776195,
                38.7422929
              ],
              [
                46.5640919,
                38.7419685
              ],
              [
                46.5544795,
                38.7443772
              ],
              [
                46.5482255,
                38.7462832
              ],
              [
                46.5461969,
                38.7468541
              ],
              [
                46.5437432,
                38.7483792
              ],
              [
                46.5435361,
                38.7497325
              ],
              [
                46.5408324,
                38.7534809
              ],
              [
                46.5371003,
                38.7574128
              ],
              [
                46.5337147,
                38.7594312
              ],
              [
                46.5294908,
                38.7603661
              ],
              [
                46.5248124,
                38.7609974
              ],
              [
                46.518671,
                38.7605289
              ],
              [
                46.5127924,
                38.7593805
              ],
              [
                46.5099673,
                38.7583432
              ],
              [
                46.5047711,
                38.7559467
              ],
              [
                46.5002246,
                38.7536039
              ],
              [
                46.4983005,
                38.7532149
              ],
              [
                46.4940007,
                38.7504076
              ],
              [
                46.4867934,
                38.7481317
              ],
              [
                46.4828109,
                38.7476908
              ],
              [
                46.4830255,
                38.748059
              ],
              [
                46.4823818,
                38.75077
              ],
              [
                46.4797639,
                38.753347
              ],
              [
                46.4753642,
                38.756051
              ],
              [
                46.4725343,
                38.7566868
              ],
              [
                46.4695704,
                38.7574461
              ],
              [
                46.4627087,
                38.7580924
              ],
              [
                46.4545091,
                38.7585945
              ],
              [
                46.4390905,
                38.7597426
              ],
              [
                46.4288904,
                38.762173
              ],
              [
                46.4194078,
                38.7650403
              ],
              [
                46.4017704,
                38.7722677
              ],
              [
                46.3939036,
                38.7765889
              ],
              [
                46.3775825,
                38.7843981
              ],
              [
                46.3710593,
                38.78587
              ],
              [
                46.367197,
                38.7858031
              ],
              [
                46.3642787,
                38.7843981
              ],
              [
                46.3609313,
                38.7811196
              ],
              [
                46.3587279,
                38.7762982
              ],
              [
                46.3579024,
                38.7708797
              ],
              [
                46.3541404,
                38.7667975
              ],
              [
                46.3490556,
                38.7637906
              ],
              [
                46.3333494,
                38.7586098
              ],
              [
                46.3147214,
                38.7548615
              ],
              [
                46.2999965,
                38.7534313
              ],
              [
                46.2852584,
                38.7522935
              ],
              [
                46.2679047,
                38.7518555
              ],
              [
                46.2498284,
                38.7522617
              ],
              [
                46.2448475,
                38.7516236
              ],
              [
                46.2349273,
                38.7511701
              ],
              [
                46.2196934,
                38.7519064
              ],
              [
                46.2075152,
                38.7535237
              ],
              [
                46.1983577,
                38.7562949
              ],
              [
                46.1824187,
                38.761917
              ],
              [
                46.1777796,
                38.763839
              ],
              [
                46.173445,
                38.7657888
              ],
              [
                46.1698842,
                38.7670849
              ],
              [
                46.167396,
                38.766731
              ],
              [
                46.162201,
                38.7650794
              ],
              [
                46.1519266,
                38.7609524
              ],
              [
                46.1375631,
                38.7539689
              ],
              [
                46.1303753,
                38.7504672
              ],
              [
                46.1154471,
                38.7435053
              ],
              [
                46.10118,
                38.7394389
              ],
              [
                46.0920269,
                38.7338725
              ],
              [
                46.0840257,
                38.7258272
              ],
              [
                46.0780563,
                38.718487
              ],
              [
                46.0760701,
                38.7156872
              ],
              [
                46.0718462,
                38.7093481
              ],
              [
                46.0701331,
                38.7067822
              ],
              [
                46.0672991,
                38.7023601
              ],
              [
                46.0659202,
                38.6985911
              ],
              [
                46.0637068,
                38.6933973
              ],
              [
                46.06467,
                38.6900826
              ],
              [
                46.0660656,
                38.6856997
              ],
              [
                46.0652683,
                38.6793443
              ],
              [
                46.0629972,
                38.672444
              ],
              [
                46.0563877,
                38.6643298
              ],
              [
                46.0495376,
                38.6580352
              ],
              [
                46.0413724,
                38.6530865
              ],
              [
                46.0370684,
                38.6498129
              ],
              [
                46.0328775,
                38.6480062
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555271,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چاراویماق",
          "name:en": "Charoymagh City",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291642",
          "wikipedia": "fa:شهرستان چاراویماق"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.6833883,
                37.0635534
              ],
              [
                46.6839414,
                37.0635534
              ],
              [
                46.6847743,
                37.0641115
              ],
              [
                46.6850548,
                37.0643904
              ],
              [
                46.6861649,
                37.0646603
              ],
              [
                46.6900548,
                37.0668834
              ],
              [
                46.6908877,
                37.0668834
              ],
              [
                46.7029828,
                37.0716713
              ],
              [
                46.7040929,
                37.0716714
              ],
              [
                46.7046492,
                37.0719504
              ],
              [
                46.7054828,
                37.0719504
              ],
              [
                46.7063165,
                37.0722294
              ],
              [
                46.7093696,
                37.0724994
              ],
              [
                46.7263161,
                37.0702764
              ],
              [
                46.7304825,
                37.0688904
              ],
              [
                46.7329827,
                37.0677834
              ],
              [
                46.7602059,
                37.0577841
              ],
              [
                46.7615958,
                37.0577841
              ],
              [
                46.7621521,
                37.0575051
              ],
              [
                46.7638194,
                37.0575051
              ],
              [
                46.7643724,
                37.0572261
              ],
              [
                46.7652053,
                37.0572261
              ],
              [
                46.7654857,
                37.0569471
              ],
              [
                46.7671522,
                37.0569471
              ],
              [
                46.7674287,
                37.0566681
              ],
              [
                46.7690952,
                37.056668
              ],
              [
                46.7696522,
                37.0563891
              ],
              [
                46.7707624,
                37.0563891
              ],
              [
                46.7713187,
                37.0561101
              ],
              [
                46.774929,
                37.0555611
              ],
              [
                46.7779853,
                37.0555611
              ],
              [
                46.7782618,
                37.0552821
              ],
              [
                46.7802087,
                37.055282
              ],
              [
                46.7807619,
                37.0550031
              ],
              [
                46.7827088,
                37.055003
              ],
              [
                46.783262,
                37.054724
              ],
              [
                46.7840955,
                37.054724
              ],
              [
                46.7849323,
                37.054445
              ],
              [
                46.7865987,
                37.054445
              ],
              [
                46.7893754,
                37.0541661
              ],
              [
                46.8019014,
                37.0492971
              ],
              [
                46.8024319,
                37.0488918
              ],
              [
                46.8027085,
                37.0486128
              ],
              [
                46.8257901,
                37.0368178
              ],
              [
                46.8535992,
                37.0028271
              ],
              [
                46.8421778,
                36.9755616
              ],
              [
                46.8421779,
                36.9736173
              ],
              [
                46.8421779,
                36.971124
              ],
              [
                46.8386786,
                36.9591506
              ],
              [
                46.8389552,
                36.9583224
              ],
              [
                46.8389552,
                36.9544338
              ],
              [
                46.8436781,
                36.9385999
              ],
              [
                46.8492353,
                36.9285988
              ],
              [
                46.8622918,
                36.9194349
              ],
              [
                46.8642349,
                36.9185977
              ],
              [
                46.8917378,
                36.91082
              ],
              [
                46.892291,
                36.9102619
              ],
              [
                46.9027515,
                36.9088392
              ],
              [
                46.9074743,
                36.8991171
              ],
              [
                46.9077509,
                36.898559
              ],
              [
                46.9074744,
                36.8957864
              ],
              [
                46.9074743,
                36.8927258
              ],
              [
                46.9049731,
                36.8821088
              ],
              [
                46.9020978,
                36.8699023
              ],
              [
                46.9157878,
                36.8558929
              ],
              [
                46.9152338,
                36.8503394
              ],
              [
                46.9149542,
                36.8472791
              ],
              [
                46.9135643,
                36.8389531
              ],
              [
                46.9002911,
                36.8293483
              ],
              [
                46.8941113,
                36.815332
              ],
              [
                46.8752118,
                36.8008319
              ],
              [
                46.8721587,
                36.7930527
              ],
              [
                46.8724353,
                36.7911079
              ],
              [
                46.8727118,
                36.7904101
              ],
              [
                46.8727119,
                36.7900005
              ],
              [
                46.8729923,
                36.7894423
              ],
              [
                46.8729924,
                36.7891632
              ],
              [
                46.8729923,
                36.788884
              ],
              [
                46.8732689,
                36.7866601
              ],
              [
                46.8735455,
                36.78639
              ],
              [
                46.8779925,
                36.7799973
              ],
              [
                46.8897421,
                36.7807866
              ],
              [
                46.890575,
                36.7807866
              ],
              [
                46.8914086,
                36.7805075
              ],
              [
                46.8925219,
                36.7805075
              ],
              [
                46.893632,
                36.7802283
              ],
              [
                46.8961321,
                36.7802284
              ],
              [
                46.8972415,
                36.7799493
              ],
              [
                46.903355,
                36.7799493
              ],
              [
                46.9147451,
                36.7771763
              ],
              [
                46.9169646,
                36.7763389
              ],
              [
                46.9175217,
                36.7757807
              ],
              [
                46.9186318,
                36.7755016
              ],
              [
                46.9219647,
                36.7732868
              ],
              [
                46.9229951,
                36.7627729
              ],
              [
                46.9246615,
                36.7605579
              ],
              [
                46.9279952,
                36.7566592
              ],
              [
                46.9302147,
                36.7558307
              ],
              [
                46.9304953,
                36.7555517
              ],
              [
                46.9500729,
                36.7523645
              ],
              [
                46.9699856,
                36.7504389
              ],
              [
                46.9941076,
                36.7477723
              ],
              [
                46.9949413,
                36.7469438
              ],
              [
                46.9979975,
                36.7452781
              ],
              [
                47.0029977,
                36.7466648
              ],
              [
                47.0038305,
                36.747223
              ],
              [
                47.0116072,
                36.7544354
              ],
              [
                47.0177205,
                36.7649971
              ],
              [
                47.0179971,
                36.7661046
              ],
              [
                47.0185542,
                36.7686077
              ],
              [
                47.0204971,
                36.7891635
              ],
              [
                47.0218869,
                36.7908292
              ],
              [
                47.0363334,
                36.8008322
              ],
              [
                47.0368872,
                36.8013815
              ],
              [
                47.0407771,
                36.8033263
              ],
              [
                47.0485531,
                36.8072158
              ],
              [
                47.0493867,
                36.8072158
              ],
              [
                47.0599432,
                36.8108352
              ],
              [
                47.0696668,
                36.815274
              ],
              [
                47.0710566,
                36.8163904
              ],
              [
                47.0721669,
                36.8166694
              ],
              [
                47.0766131,
                36.8194425
              ],
              [
                47.0963361,
                36.8311108
              ],
              [
                47.0974463,
                36.8313809
              ],
              [
                47.0993892,
                36.8313809
              ],
              [
                47.1024463,
                36.8324973
              ],
              [
                47.1049464,
                36.8324973
              ],
              [
                47.1068925,
                36.8319391
              ],
              [
                47.111059,
                36.8302735
              ],
              [
                47.1182795,
                36.8269424
              ],
              [
                47.119946,
                36.8269424
              ],
              [
                47.1205022,
                36.8275006
              ],
              [
                47.1307821,
                36.8330556
              ],
              [
                47.1332822,
                36.8336047
              ],
              [
                47.1374486,
                36.8330556
              ],
              [
                47.1405026,
                36.8322183
              ],
              [
                47.1449488,
                36.8275006
              ],
              [
                47.1532819,
                36.8113847
              ],
              [
                47.1618923,
                36.8038848
              ],
              [
                47.1638392,
                36.80194
              ],
              [
                47.1643954,
                36.8016609
              ],
              [
                47.1777322,
                36.7949982
              ],
              [
                47.1782853,
                36.7938818
              ],
              [
                47.1799518,
                36.791667
              ],
              [
                47.1843987,
                36.7919371
              ],
              [
                47.1846753,
                36.7922162
              ],
              [
                47.1852316,
                36.7922161
              ],
              [
                47.1868988,
                36.7924952
              ],
              [
                47.1880082,
                36.7924952
              ],
              [
                47.1907851,
                36.7955565
              ],
              [
                47.1982853,
                36.7994371
              ],
              [
                47.2091182,
                36.811943
              ],
              [
                47.223285,
                36.8252771
              ],
              [
                47.2263413,
                36.8275008
              ],
              [
                47.2405079,
                36.8383317
              ],
              [
                47.2410643,
                36.839169
              ],
              [
                47.2432876,
                36.8461104
              ],
              [
                47.2568973,
                36.8658267
              ],
              [
                47.2577309,
                36.8663849
              ],
              [
                47.2693975,
                36.8713904
              ],
              [
                47.2910675,
                36.8780615
              ],
              [
                47.2955105,
                36.883337
              ],
              [
                47.2999567,
                36.8947162
              ],
              [
                47.3005113,
                36.8952734
              ],
              [
                47.3027333,
                36.8972278
              ],
              [
                47.3168999,
                36.9044478
              ],
              [
                47.3188468,
                36.9055551
              ],
              [
                47.3713495,
                36.9366664
              ],
              [
                47.3727362,
                36.9372245
              ],
              [
                47.3955156,
                36.9466675
              ],
              [
                47.4010728,
                36.9474957
              ],
              [
                47.4071823,
                36.9494491
              ],
              [
                47.4080159,
                36.9494491
              ],
              [
                47.4085721,
                36.9497281
              ],
              [
                47.4094057,
                36.9497282
              ],
              [
                47.4113487,
                36.9505563
              ],
              [
                47.4121824,
                36.9505563
              ],
              [
                47.4281849,
                36.9573415
              ],
              [
                47.4285721,
                36.9575056
              ],
              [
                47.4291288,
                36.9577757
              ],
              [
                47.4374617,
                36.9630597
              ],
              [
                47.4382953,
                36.9633387
              ],
              [
                47.4505182,
                36.9769489
              ],
              [
                47.4507948,
                36.977228
              ],
              [
                47.4585751,
                36.98334
              ],
              [
                47.486908,
                36.9966709
              ],
              [
                47.4874647,
                36.9966709
              ],
              [
                47.4924644,
                37.0000012
              ],
              [
                47.4935746,
                37.0016665
              ],
              [
                47.4935745,
                37.0019455
              ],
              [
                47.4941312,
                37.0025036
              ],
              [
                47.5099643,
                37.0172292
              ],
              [
                47.512744,
                37.0213966
              ],
              [
                47.515244,
                37.0366708
              ],
              [
                47.514964,
                37.039731
              ],
              [
                47.5149639,
                37.0508378
              ],
              [
                47.515244,
                37.0555629
              ],
              [
                47.5155205,
                37.056949
              ],
              [
                47.5174638,
                37.0616742
              ],
              [
                47.5241339,
                37.0672274
              ],
              [
                47.5294106,
                37.0683344
              ],
              [
                47.5369104,
                37.0622322
              ],
              [
                47.5371869,
                37.0616742
              ],
              [
                47.5388538,
                37.0608372
              ],
              [
                47.541357,
                37.0602792
              ],
              [
                47.5424672,
                37.0602792
              ],
              [
                47.5433004,
                37.0605582
              ],
              [
                47.5477436,
                37.0605582
              ],
              [
                47.5483001,
                37.0608373
              ],
              [
                47.5499669,
                37.0608372
              ],
              [
                47.5566335,
                37.0575071
              ],
              [
                47.5577433,
                37.0575071
              ],
              [
                47.5585769,
                37.0572281
              ],
              [
                47.5599668,
                37.0572281
              ],
              [
                47.5638567,
                37.0580561
              ],
              [
                47.5658001,
                37.0588932
              ],
              [
                47.56719,
                37.0588932
              ],
              [
                47.5677466,
                37.0591722
              ],
              [
                47.5696901,
                37.0591722
              ],
              [
                47.5755234,
                37.0555631
              ],
              [
                47.5793754,
                37.0544088
              ],
              [
                47.5810798,
                37.053898
              ],
              [
                47.5816369,
                37.053619
              ],
              [
                47.5821899,
                37.053619
              ],
              [
                47.5821899,
                37.05334
              ],
              [
                47.5827466,
                37.05334
              ],
              [
                47.5844135,
                37.0527819
              ],
              [
                47.5921898,
                37.0477777
              ],
              [
                47.5935796,
                37.0452846
              ],
              [
                47.5935797,
                37.0447266
              ],
              [
                47.5938566,
                37.0444476
              ],
              [
                47.5941364,
                37.0430615
              ],
              [
                47.5944133,
                37.0419544
              ],
              [
                47.5946899,
                37.0402803
              ],
              [
                47.5963563,
                37.0375081
              ],
              [
                47.59886,
                37.0375081
              ],
              [
                47.6090614,
                37.031092
              ],
              [
                47.6183279,
                37.0299309
              ],
              [
                47.6255512,
                37.0310382
              ],
              [
                47.6359776,
                37.0321709
              ],
              [
                47.6373675,
                37.0377349
              ],
              [
                47.6365342,
                37.0399498
              ],
              [
                47.6362577,
                37.0407871
              ],
              [
                47.6440371,
                37.0465325
              ],
              [
                47.6448708,
                37.0479279
              ],
              [
                47.6448708,
                37.0484772
              ],
              [
                47.6454274,
                37.0487563
              ],
              [
                47.6457039,
                37.0490355
              ],
              [
                47.6454274,
                37.0493145
              ],
              [
                47.6448708,
                37.0493145
              ],
              [
                47.6448707,
                37.0495936
              ],
              [
                47.6440371,
                37.0495936
              ],
              [
                47.6291358,
                37.0811148
              ],
              [
                47.6288592,
                37.0813939
              ],
              [
                47.6274693,
                37.0822309
              ],
              [
                47.6258025,
                37.0838959
              ],
              [
                47.6252494,
                37.0841748
              ],
              [
                47.6210829,
                37.0916718
              ],
              [
                47.6208028,
                37.0919508
              ],
              [
                47.6205263,
                37.0927879
              ],
              [
                47.6183027,
                37.0972248
              ],
              [
                47.6180262,
                37.0980617
              ],
              [
                47.591913,
                37.1238998
              ],
              [
                47.5899695,
                37.1258436
              ],
              [
                47.5746899,
                37.1461192
              ],
              [
                47.5563566,
                37.1608416
              ],
              [
                47.5535764,
                37.1633434
              ],
              [
                47.5510764,
                37.1647292
              ],
              [
                47.550517,
                37.1650082
              ],
              [
                47.5499665,
                37.1652871
              ],
              [
                47.5491333,
                37.1658361
              ],
              [
                47.5491333,
                37.1661241
              ],
              [
                47.5202436,
                37.1836178
              ],
              [
                47.513577,
                37.1852824
              ],
              [
                47.5132969,
                37.1855614
              ],
              [
                47.5105203,
                37.1855614
              ],
              [
                47.507187,
                37.1850125
              ],
              [
                47.5038538,
                37.1838966
              ],
              [
                47.457461,
                37.1639011
              ],
              [
                47.4405177,
                37.1591766
              ],
              [
                47.439961,
                37.1588976
              ],
              [
                47.4388513,
                37.1588976
              ],
              [
                47.4380176,
                37.1586186
              ],
              [
                47.4363512,
                37.1586186
              ],
              [
                47.4360711,
                37.1583397
              ],
              [
                47.4349614,
                37.1583397
              ],
              [
                47.4341277,
                37.1580607
              ],
              [
                47.4280179,
                37.1580607
              ],
              [
                47.4271811,
                37.1583397
              ],
              [
                47.4260709,
                37.1583396
              ],
              [
                47.4252381,
                37.1586186
              ],
              [
                47.4244044,
                37.1586186
              ],
              [
                47.4219044,
                37.1591765
              ],
              [
                47.4102377,
                37.1622272
              ],
              [
                47.4094049,
                37.1622272
              ],
              [
                47.4088479,
                37.1625061
              ],
              [
                47.4077384,
                37.1625061
              ],
              [
                47.4069048,
                37.1627851
              ],
              [
                47.4049579,
                37.1627851
              ],
              [
                47.4046814,
                37.1630641
              ],
              [
                47.4027384,
                37.1630641
              ],
              [
                47.4024578,
                37.163343
              ],
              [
                47.4002383,
                37.163343
              ],
              [
                47.3996812,
                37.163622
              ],
              [
                47.3969046,
                37.163622
              ],
              [
                47.3924584,
                37.1644499
              ],
              [
                47.3902381,
                37.1644498
              ],
              [
                47.3680117,
                37.1683374
              ],
              [
                47.3663453,
                37.1683374
              ],
              [
                47.3538451,
                37.170839
              ],
              [
                47.352459,
                37.170839
              ],
              [
                47.3491223,
                37.1725128
              ],
              [
                47.3488457,
                37.1727828
              ],
              [
                47.3491224,
                37.1732318
              ],
              [
                47.3491223,
                37.1777861
              ],
              [
                47.3521786,
                37.1841752
              ],
              [
                47.352459,
                37.1847331
              ],
              [
                47.3574584,
                37.1958375
              ],
              [
                47.3577349,
                37.2002827
              ],
              [
                47.3574583,
                37.2005617
              ],
              [
                47.3535683,
                37.2075085
              ],
              [
                47.3519018,
                37.210568
              ],
              [
                47.342179,
                37.2219508
              ],
              [
                47.3416219,
                37.2222297
              ],
              [
                47.3410935,
                37.2224962
              ],
              [
                47.3405117,
                37.2225086
              ],
              [
                47.3402352,
                37.2227876
              ],
              [
                47.3369023,
                37.2244523
              ],
              [
                47.3257888,
                37.2358439
              ],
              [
                47.3255122,
                37.2366806
              ],
              [
                47.3243989,
                37.2377874
              ],
              [
                47.3230121,
                37.239731
              ],
              [
                47.3177322,
                37.2450038
              ],
              [
                47.3174557,
                37.2452918
              ],
              [
                47.2184978,
                37.2304198
              ],
              [
                47.16542,
                37.2261666
              ],
              [
                47.1465111,
                37.2355127
              ],
              [
                47.1493903,
                37.2391727
              ],
              [
                47.1521709,
                37.246677
              ],
              [
                47.1521708,
                37.2486205
              ],
              [
                47.1524474,
                37.2488995
              ],
              [
                47.1521708,
                37.2491784
              ],
              [
                47.1491137,
                37.2563946
              ],
              [
                47.1388337,
                37.2680646
              ],
              [
                47.1330008,
                37.2766752
              ],
              [
                47.1321672,
                37.277512
              ],
              [
                47.130224,
                37.2852858
              ],
              [
                47.130224,
                37.2955697
              ],
              [
                47.1299475,
                37.2958396
              ],
              [
                47.129667,
                37.2988986
              ],
              [
                47.129667,
                37.2994565
              ],
              [
                47.1291138,
                37.3022366
              ],
              [
                47.1230003,
                37.3108468
              ],
              [
                47.1160573,
                37.3214002
              ],
              [
                47.1043872,
                37.3480664
              ],
              [
                47.0955011,
                37.3586192
              ],
              [
                47.0950415,
                37.3586278
              ],
              [
                47.094387,
                37.3586191
              ],
              [
                47.0941105,
                37.3588981
              ],
              [
                47.0935543,
                37.3588981
              ],
              [
                47.0930011,
                37.3591769
              ],
              [
                47.0924441,
                37.358898
              ],
              [
                47.0916104,
                37.3588981
              ],
              [
                47.0829978,
                37.3547327
              ],
              [
                47.0702209,
                37.351404
              ],
              [
                47.0696647,
                37.3511251
              ],
              [
                47.0677208,
                37.3511251
              ],
              [
                47.0668881,
                37.3508462
              ],
              [
                47.057441,
                37.3508462
              ],
              [
                47.0568878,
                37.3511251
              ],
              [
                47.0541081,
                37.3511251
              ],
              [
                47.0493845,
                37.3516738
              ],
              [
                47.0485509,
                37.3519527
              ],
              [
                47.0466079,
                37.3519527
              ],
              [
                47.0443844,
                37.3522316
              ],
              [
                47.0438313,
                37.3525105
              ],
              [
                47.0416078,
                37.3525105
              ],
              [
                47.040775,
                37.3527894
              ],
              [
                47.0388312,
                37.3527894
              ],
              [
                47.0379984,
                37.3530683
              ],
              [
                47.0366077,
                37.3530682
              ],
              [
                47.0060515,
                37.3625144
              ],
              [
                46.992995,
                37.3647364
              ],
              [
                46.989105,
                37.3647364
              ],
              [
                46.9877151,
                37.3650153
              ],
              [
                46.9860487,
                37.3647364
              ],
              [
                46.9827151,
                37.3647364
              ],
              [
                46.9810486,
                37.3644575
              ],
              [
                46.9791055,
                37.3644575
              ],
              [
                46.9766056,
                37.3638997
              ],
              [
                46.9746617,
                37.3638997
              ],
              [
                46.9693819,
                37.363063
              ],
              [
                46.9668818,
                37.363063
              ],
              [
                46.9632725,
                37.3625143
              ],
              [
                46.9621591,
                37.3619565
              ],
              [
                46.9604919,
                37.3619565
              ],
              [
                46.9602153,
                37.3616776
              ],
              [
                46.9593825,
                37.3616776
              ],
              [
                46.9593825,
                37.3613987
              ],
              [
                46.9582723,
                37.3586188
              ],
              [
                46.9157693,
                37.302236
              ],
              [
                46.914656,
                37.2997348
              ],
              [
                46.9085466,
                37.2838996
              ],
              [
                46.907713,
                37.2775115
              ],
              [
                46.8999547,
                37.275127
              ],
              [
                46.8964015,
                37.2734569
              ],
              [
                46.8950222,
                37.2728086
              ],
              [
                46.8897223,
                37.2697863
              ],
              [
                46.8837162,
                37.2650156
              ],
              [
                46.8817913,
                37.2625176
              ],
              [
                46.8808328,
                37.2587041
              ],
              [
                46.8791103,
                37.2538232
              ],
              [
                46.8780445,
                37.2462422
              ],
              [
                46.8783124,
                37.2380494
              ],
              [
                46.8774121,
                37.2335548
              ],
              [
                46.8750421,
                37.2262447
              ],
              [
                46.8692509,
                37.2139608
              ],
              [
                46.8589211,
                37.2048495
              ],
              [
                46.8559783,
                37.1999852
              ],
              [
                46.8410438,
                37.1997326
              ],
              [
                46.8371539,
                37.1994536
              ],
              [
                46.8366482,
                37.1994536
              ],
              [
                46.814609,
                37.2043574
              ],
              [
                46.8079844,
                37.1704134
              ],
              [
                46.7736476,
                37.1486818
              ],
              [
                46.727879,
                37.149205
              ],
              [
                46.6952023,
                37.1855594
              ],
              [
                46.6949258,
                37.1852804
              ],
              [
                46.687146,
                37.1819509
              ],
              [
                46.6863124,
                37.1819508
              ],
              [
                46.6857593,
                37.1816719
              ],
              [
                46.684646,
                37.1816719
              ],
              [
                46.6838123,
                37.1813929
              ],
              [
                46.6824255,
                37.181393
              ],
              [
                46.6793693,
                37.180565
              ],
              [
                46.6746457,
                37.1805649
              ],
              [
                46.6735363,
                37.1802861
              ],
              [
                46.6710363,
                37.180286
              ],
              [
                46.669923,
                37.180007
              ],
              [
                46.6643698,
                37.1800071
              ],
              [
                46.6638127,
                37.1797281
              ],
              [
                46.6627025,
                37.1797281
              ],
              [
                46.6574227,
                37.1772264
              ],
              [
                46.6571461,
                37.1766685
              ],
              [
                46.6563125,
                37.1763985
              ],
              [
                46.6540899,
                37.1691724
              ],
              [
                46.6546462,
                37.1677866
              ],
              [
                46.6552032,
                37.1661218
              ],
              [
                46.6563126,
                37.1638991
              ],
              [
                46.6568697,
                37.1636201
              ],
              [
                46.6654792,
                37.1530642
              ],
              [
                46.6657567,
                37.1519483
              ],
              [
                46.6690896,
                37.1436151
              ],
              [
                46.6682559,
                37.1327799
              ],
              [
                46.6638129,
                37.1236183
              ],
              [
                46.6604801,
                37.1186146
              ],
              [
                46.6596464,
                37.1161127
              ],
              [
                46.6593699,
                37.1158338
              ],
              [
                46.6568698,
                37.1075001
              ],
              [
                46.6568699,
                37.1041702
              ],
              [
                46.6579801,
                37.1011103
              ],
              [
                46.6585364,
                37.0958363
              ],
              [
                46.6588129,
                37.0955573
              ],
              [
                46.6565903,
                37.0819494
              ],
              [
                46.65687,
                37.0791684
              ],
              [
                46.6571465,
                37.0780614
              ],
              [
                46.6574232,
                37.0772244
              ],
              [
                46.6582568,
                37.0750013
              ],
              [
                46.658813,
                37.0738943
              ],
              [
                46.6833882,
                37.0638324
              ],
              [
                46.6833883,
                37.0635534
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6556274,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هوراند",
          "name:en": "Hurand",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q16048620",
          "wikipedia": "fa:شهرستان هوراند"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.1521653,
                38.6143322
              ],
              [
                47.1524418,
                38.6111598
              ],
              [
                47.1529981,
                38.6100466
              ],
              [
                47.1535521,
                38.6097683
              ],
              [
                47.154942,
                38.6067072
              ],
              [
                47.1599413,
                38.601716
              ],
              [
                47.1610514,
                38.6011594
              ],
              [
                47.1621648,
                38.6003245
              ],
              [
                47.1624414,
                38.6000462
              ],
              [
                47.1718884,
                38.5939328
              ],
              [
                47.1743885,
                38.5939328
              ],
              [
                47.1749417,
                38.5942111
              ],
              [
                47.178555,
                38.595046
              ],
              [
                47.1816081,
                38.5964285
              ],
              [
                47.1852215,
                38.5980982
              ],
              [
                47.2166112,
                38.6133772
              ],
              [
                47.2171676,
                38.6139337
              ],
              [
                47.256334,
                38.628934
              ],
              [
                47.279947,
                38.6367078
              ],
              [
                47.286337,
                38.6383774
              ],
              [
                47.29717,
                38.6414385
              ],
              [
                47.3027264,
                38.641986
              ],
              [
                47.30356,
                38.6422643
              ],
              [
                47.3046701,
                38.6422643
              ],
              [
                47.3285598,
                38.653377
              ],
              [
                47.3393967,
                38.6561596
              ],
              [
                47.341896,
                38.6561596
              ],
              [
                47.3452297,
                38.6569944
              ],
              [
                47.3460633,
                38.6569945
              ],
              [
                47.3630058,
                38.665046
              ],
              [
                47.3666192,
                38.6683761
              ],
              [
                47.3674528,
                38.6689326
              ],
              [
                47.3702294,
                38.6714369
              ],
              [
                47.3710622,
                38.6719934
              ],
              [
                47.3735623,
                38.6767147
              ],
              [
                47.3782858,
                38.6828272
              ],
              [
                47.3880094,
                38.6892089
              ],
              [
                47.3980088,
                38.6914349
              ],
              [
                47.3985659,
                38.6917131
              ],
              [
                47.3999518,
                38.6917131
              ],
              [
                47.4035652,
                38.6925479
              ],
              [
                47.4057856,
                38.6925478
              ],
              [
                47.4071754,
                38.6928261
              ],
              [
                47.4107888,
                38.6928261
              ],
              [
                47.4191219,
                38.6944956
              ],
              [
                47.4199554,
                38.6944955
              ],
              [
                47.431065,
                38.7000514
              ],
              [
                47.4324554,
                38.7000513
              ],
              [
                47.4357886,
                38.7008771
              ],
              [
                47.4343983,
                38.7033812
              ],
              [
                47.4330119,
                38.7069893
              ],
              [
                47.4327318,
                38.7083805
              ],
              [
                47.4332884,
                38.7181006
              ],
              [
                47.4330119,
                38.7192135
              ],
              [
                47.4545916,
                38.7652107
              ],
              [
                47.4559688,
                38.7672688
              ],
              [
                47.4590396,
                38.7710689
              ],
              [
                47.4661908,
                38.7750252
              ],
              [
                47.4723434,
                38.7782065
              ],
              [
                47.4831581,
                38.7807034
              ],
              [
                47.4894531,
                38.7822578
              ],
              [
                47.4941952,
                38.7834922
              ],
              [
                47.4972102,
                38.7847951
              ],
              [
                47.5011062,
                38.7876095
              ],
              [
                47.5075289,
                38.7935134
              ],
              [
                47.5150966,
                38.8011895
              ],
              [
                47.5283348,
                38.8097792
              ],
              [
                47.5374511,
                38.8134761
              ],
              [
                47.5427702,
                38.817288
              ],
              [
                47.5469096,
                38.8213111
              ],
              [
                47.5528556,
                38.8255908
              ],
              [
                47.5531411,
                38.8270544
              ],
              [
                47.5580978,
                38.8356963
              ],
              [
                47.5630331,
                38.8537456
              ],
              [
                47.5680466,
                38.8600485
              ],
              [
                47.5696563,
                38.8615431
              ],
              [
                47.5699395,
                38.8636577
              ],
              [
                47.5707949,
                38.86585
              ],
              [
                47.5704073,
                38.8702163
              ],
              [
                47.5657535,
                38.876982
              ],
              [
                47.5615724,
                38.8803171
              ],
              [
                47.5543351,
                38.8839918
              ],
              [
                47.533675,
                38.8915521
              ],
              [
                47.5285368,
                38.8958943
              ],
              [
                47.5223523,
                38.9036012
              ],
              [
                47.517929,
                38.9108046
              ],
              [
                47.516384,
                38.9158134
              ],
              [
                47.518444,
                38.9188854
              ],
              [
                47.5223922,
                38.9223578
              ],
              [
                47.5232505,
                38.9257633
              ],
              [
                47.5209331,
                38.9274326
              ],
              [
                47.5248718,
                38.9297448
              ],
              [
                47.5216233,
                38.9328372
              ],
              [
                47.5229238,
                38.948038
              ],
              [
                47.524027,
                38.948085
              ],
              [
                47.5240261,
                38.9502513
              ],
              [
                47.5240299,
                38.9511984
              ],
              [
                47.5246618,
                38.9537033
              ],
              [
                47.5243994,
                38.9558894
              ],
              [
                47.5267154,
                38.9579114
              ],
              [
                47.5304352,
                38.9604058
              ],
              [
                47.5316727,
                38.9601847
              ],
              [
                47.5339579,
                38.9607603
              ],
              [
                47.5380671,
                38.9613359
              ],
              [
                47.5413823,
                38.9624038
              ],
              [
                47.5469827,
                38.9633464
              ],
              [
                47.5510168,
                38.9645811
              ],
              [
                47.5559949,
                38.9652818
              ],
              [
                47.559514,
                38.9664163
              ],
              [
                47.5673935,
                38.9683035
              ],
              [
                47.5682947,
                38.9721852
              ],
              [
                47.5667554,
                38.9764004
              ],
              [
                47.5624417,
                38.978736
              ],
              [
                47.5581264,
                38.9796851
              ],
              [
                47.5500805,
                38.9814536
              ],
              [
                47.5377553,
                38.9858795
              ],
              [
                47.5332931,
                38.9875584
              ],
              [
                47.5271156,
                38.9902972
              ],
              [
                47.5073959,
                38.9943342
              ],
              [
                47.5038707,
                38.9965036
              ],
              [
                47.5019641,
                38.9975383
              ],
              [
                47.5005063,
                38.9987196
              ],
              [
                47.5038897,
                38.9998991
              ],
              [
                47.5258953,
                39.0079994
              ],
              [
                47.5261516,
                39.0092667
              ],
              [
                47.525159,
                39.0122755
              ],
              [
                47.5270719,
                39.0167763
              ],
              [
                47.528011,
                39.0196802
              ],
              [
                47.5275593,
                39.021692
              ],
              [
                47.5268274,
                39.0227733
              ],
              [
                47.5250583,
                39.0229816
              ],
              [
                47.520724,
                39.0236932
              ],
              [
                47.5169102,
                39.0245934
              ],
              [
                47.5137128,
                39.0255168
              ],
              [
                47.5087797,
                39.0268974
              ],
              [
                47.5061237,
                39.0288643
              ],
              [
                47.505214,
                39.0320349
              ],
              [
                47.5063953,
                39.0352981
              ],
              [
                47.509048,
                39.0379005
              ],
              [
                47.512285,
                39.0390813
              ],
              [
                47.5170628,
                39.0395188
              ],
              [
                47.5244406,
                39.0380581
              ],
              [
                47.5256219,
                39.0392197
              ],
              [
                47.5245275,
                39.0411904
              ],
              [
                47.5194913,
                39.043055
              ],
              [
                47.5181655,
                39.0450922
              ],
              [
                47.5190276,
                39.0467087
              ],
              [
                47.5222771,
                39.0473867
              ],
              [
                47.5236151,
                39.0476459
              ],
              [
                47.5254791,
                39.0481725
              ],
              [
                47.5263256,
                39.0515615
              ],
              [
                47.5239449,
                39.0586929
              ],
              [
                47.5241562,
                39.0626094
              ],
              [
                47.528658,
                39.0733013
              ],
              [
                47.4980322,
                39.0748089
              ],
              [
                47.4863236,
                39.0776049
              ],
              [
                47.4823039,
                39.0785425
              ],
              [
                47.4737262,
                39.0815733
              ],
              [
                47.468151,
                39.0845
              ],
              [
                47.461799,
                39.0846382
              ],
              [
                47.4517706,
                39.0831725
              ],
              [
                47.445782,
                39.0787369
              ],
              [
                47.4386753,
                39.0737287
              ],
              [
                47.4328591,
                39.0693539
              ],
              [
                47.4147155,
                39.0598967
              ],
              [
                47.4105543,
                39.0565529
              ],
              [
                47.404221,
                39.0519609
              ],
              [
                47.3967278,
                39.0447819
              ],
              [
                47.3929165,
                39.0404689
              ],
              [
                47.3904275,
                39.0382197
              ],
              [
                47.3819394,
                39.0310722
              ],
              [
                47.3717546,
                39.0255495
              ],
              [
                47.3620145,
                39.0229095
              ],
              [
                47.353582,
                39.0222226
              ],
              [
                47.3440856,
                39.0200489
              ],
              [
                47.3380236,
                39.0165026
              ],
              [
                47.3309673,
                39.0113676
              ],
              [
                47.3258619,
                39.0064542
              ],
              [
                47.3192339,
                38.9980387
              ],
              [
                47.3152006,
                38.9954037
              ],
              [
                47.3126321,
                38.9934169
              ],
              [
                47.3107822,
                38.9911092
              ],
              [
                47.3076203,
                38.9904114
              ],
              [
                47.3013699,
                38.9892089
              ],
              [
                47.2980353,
                38.9888192
              ],
              [
                47.2941119,
                38.987685
              ],
              [
                47.2900845,
                38.9859345
              ],
              [
                47.2858407,
                38.9828765
              ],
              [
                47.2836116,
                38.9812306
              ],
              [
                47.2807359,
                38.9783608
              ],
              [
                47.2784185,
                38.9753915
              ],
              [
                47.2756505,
                38.9724055
              ],
              [
                47.2738051,
                38.9708707
              ],
              [
                47.2714877,
                38.9679845
              ],
              [
                47.2693419,
                38.966483
              ],
              [
                47.2669172,
                38.9652151
              ],
              [
                47.265737,
                38.9650482
              ],
              [
                47.2641063,
                38.965482
              ],
              [
                47.2626042,
                38.96675
              ],
              [
                47.2618961,
                38.9678511
              ],
              [
                47.2601366,
                38.9707539
              ],
              [
                47.2584629,
                38.9726724
              ],
              [
                47.2561454,
                38.9730227
              ],
              [
                47.2544112,
                38.9727628
              ],
              [
                47.2531098,
                38.9721056
              ],
              [
                47.2520363,
                38.9714546
              ],
              [
                47.2502016,
                38.9700199
              ],
              [
                47.2465324,
                38.9677009
              ],
              [
                47.2450089,
                38.9671671
              ],
              [
                47.2423053,
                38.9661994
              ],
              [
                47.2374696,
                38.9641587
              ],
              [
                47.2384614,
                38.9592848
              ],
              [
                47.241638,
                38.9520709
              ],
              [
                47.2438639,
                38.9462861
              ],
              [
                47.2446656,
                38.9443487
              ],
              [
                47.24635,
                38.9417118
              ],
              [
                47.2468113,
                38.9410025
              ],
              [
                47.2482046,
                38.9399426
              ],
              [
                47.2502215,
                38.9385853
              ],
              [
                47.2519921,
                38.937774
              ],
              [
                47.2531269,
                38.9370043
              ],
              [
                47.2547507,
                38.934777
              ],
              [
                47.2559523,
                38.9325904
              ],
              [
                47.2561454,
                38.9307043
              ],
              [
                47.2574329,
                38.9284341
              ],
              [
                47.2576046,
                38.9256631
              ],
              [
                47.2580502,
                38.9251132
              ],
              [
                47.258316,
                38.9236625
              ],
              [
                47.2582599,
                38.922319
              ],
              [
                47.2576377,
                38.9174826
              ],
              [
                47.2577227,
                38.9139427
              ],
              [
                47.2577227,
                38.9125522
              ],
              [
                47.2575616,
                38.9101033
              ],
              [
                47.2568462,
                38.9067436
              ],
              [
                47.2565903,
                38.9042514
              ],
              [
                47.2583746,
                38.8992421
              ],
              [
                47.2587681,
                38.8953702
              ],
              [
                47.2578725,
                38.8911294
              ],
              [
                47.2541713,
                38.8828821
              ],
              [
                47.2542571,
                38.8804768
              ],
              [
                47.2534846,
                38.8782051
              ],
              [
                47.2501372,
                38.8754655
              ],
              [
                47.248498,
                38.8694415
              ],
              [
                47.2474871,
                38.8634485
              ],
              [
                47.2468195,
                38.855786
              ],
              [
                47.2436081,
                38.841381
              ],
              [
                47.2378968,
                38.8390922
              ],
              [
                47.230525,
                38.835128
              ],
              [
                47.2254524,
                38.8297568
              ],
              [
                47.219245,
                38.8151311
              ],
              [
                47.218951,
                38.8125954
              ],
              [
                47.2204545,
                38.8061678
              ],
              [
                47.2221902,
                38.8016544
              ],
              [
                47.2243789,
                38.7938735
              ],
              [
                47.2196375,
                38.7858191
              ],
              [
                47.2147205,
                38.7781509
              ],
              [
                47.212234,
                38.7740984
              ],
              [
                47.2101741,
                38.7688074
              ],
              [
                47.208114,
                38.7611632
              ],
              [
                47.2077207,
                38.7561618
              ],
              [
                47.2075652,
                38.7518745
              ],
              [
                47.2088393,
                38.7479542
              ],
              [
                47.2137639,
                38.7419911
              ],
              [
                47.2193181,
                38.7351519
              ],
              [
                47.266337,
                38.7078236
              ],
              [
                47.2682801,
                38.7061632
              ],
              [
                47.2691137,
                38.7039373
              ],
              [
                47.2693902,
                38.7028244
              ],
              [
                47.2699466,
                38.7014332
              ],
              [
                47.2691137,
                38.6981033
              ],
              [
                47.2571665,
                38.6869916
              ],
              [
                47.2510572,
                38.6842092
              ],
              [
                47.2480008,
                38.6833834
              ],
              [
                47.2466141,
                38.6833834
              ],
              [
                47.2457804,
                38.6831052
              ],
              [
                47.2357771,
                38.6831051
              ],
              [
                47.2352239,
                38.6828269
              ],
              [
                47.2335575,
                38.6828268
              ],
              [
                47.2330004,
                38.6825486
              ],
              [
                47.2318903,
                38.6825485
              ],
              [
                47.2302238,
                38.6822704
              ],
              [
                47.2280003,
                38.6817138
              ],
              [
                47.2227244,
                38.6778273
              ],
              [
                47.2218909,
                38.6764361
              ],
              [
                47.2216104,
                38.6750448
              ],
              [
                47.2213338,
                38.671993
              ],
              [
                47.2216104,
                38.669767
              ],
              [
                47.2218909,
                38.6689323
              ],
              [
                47.2216103,
                38.6672717
              ],
              [
                47.2218909,
                38.6667152
              ],
              [
                47.2216104,
                38.6661587
              ],
              [
                47.2218909,
                38.6653239
              ],
              [
                47.2216104,
                38.6650457
              ],
              [
                47.2193877,
                38.6580982
              ],
              [
                47.2177206,
                38.6553245
              ],
              [
                47.2102211,
                38.6497683
              ],
              [
                47.2077211,
                38.6497682
              ],
              [
                47.2068874,
                38.64949
              ],
              [
                47.2021678,
                38.64949
              ],
              [
                47.2016109,
                38.6492117
              ],
              [
                47.1988311,
                38.6492117
              ],
              [
                47.1971646,
                38.6489334
              ],
              [
                47.1910543,
                38.6489334
              ],
              [
                47.1896645,
                38.6486551
              ],
              [
                47.1849448,
                38.6486552
              ],
              [
                47.1841112,
                38.6489334
              ],
              [
                47.1757742,
                38.6489334
              ],
              [
                47.1743883,
                38.6486551
              ],
              [
                47.1738312,
                38.6489334
              ],
              [
                47.1721648,
                38.6486551
              ],
              [
                47.1691077,
                38.6486551
              ],
              [
                47.1671647,
                38.6480986
              ],
              [
                47.1641084,
                38.647542
              ],
              [
                47.1629983,
                38.6472727
              ],
              [
                47.1541082,
                38.6383771
              ],
              [
                47.1529981,
                38.6336555
              ],
              [
                47.1527184,
                38.6308817
              ],
              [
                47.1527184,
                38.624212
              ],
              [
                47.1532747,
                38.6217165
              ],
              [
                47.1521653,
                38.6143322
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 874521516
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.9745628,
          37.1283853
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32664078
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.2435751,
          37.3913128
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 1862647434
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.0662215,
          38.4774934
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 832440505
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.3683131,
          38.8604709
        ]
      }
    }
  ]
},
"آذربایجان غربی.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 2390404,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چالدران",
          "name:ckb": "شارستانی چۆڵدەران",
          "name:en": "Chaldoran County",
          "name:ku": "Şaristanya Çollderan",
          "name:ru": "Чалдоран",
          "name:tr": "Çaldıran Şehristanı",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1180764",
          "wikipedia": "fa:شهرستان چالدران"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.0377009,
                39.3612643
              ],
              [
                44.0386718,
                39.3608663
              ],
              [
                44.0408185,
                39.3599883
              ],
              [
                44.0425381,
                39.3591896
              ],
              [
                44.0435999,
                39.3586378
              ],
              [
                44.0447428,
                39.358296
              ],
              [
                44.0463806,
                39.3582838
              ],
              [
                44.0470259,
                39.3584733
              ],
              [
                44.0480958,
                39.3584331
              ],
              [
                44.0489477,
                39.3581541
              ],
              [
                44.0496959,
                39.3574698
              ],
              [
                44.0512429,
                39.3568381
              ],
              [
                44.0524451,
                39.3565558
              ],
              [
                44.0525803,
                39.3564944
              ],
              [
                44.0540547,
                39.3561944
              ],
              [
                44.0555634,
                39.3556082
              ],
              [
                44.0565238,
                39.3554892
              ],
              [
                44.0565263,
                39.3545436
              ],
              [
                44.0565564,
                39.3534506
              ],
              [
                44.0569331,
                39.3516271
              ],
              [
                44.0572372,
                39.3488081
              ],
              [
                44.0570156,
                39.3476305
              ],
              [
                44.0568634,
                39.3471799
              ],
              [
                44.0565563,
                39.3466201
              ],
              [
                44.0565319,
                39.3462819
              ],
              [
                44.0563491,
                39.3455066
              ],
              [
                44.0571398,
                39.3440014
              ],
              [
                44.0573319,
                39.3434079
              ],
              [
                44.0581369,
                39.3425351
              ],
              [
                44.0587378,
                39.3426906
              ],
              [
                44.0592545,
                39.3430609
              ],
              [
                44.059751,
                39.3432488
              ],
              [
                44.060801,
                39.3434393
              ],
              [
                44.0617201,
                39.3436291
              ],
              [
                44.0619043,
                39.3434504
              ],
              [
                44.0637756,
                39.3423429
              ],
              [
                44.06446,
                39.3418452
              ],
              [
                44.0643793,
                39.3415728
              ],
              [
                44.0644631,
                39.3405809
              ],
              [
                44.0647633,
                39.3400737
              ],
              [
                44.0649749,
                39.339729
              ],
              [
                44.065277,
                39.3394357
              ],
              [
                44.0663913,
                39.3389453
              ],
              [
                44.0681548,
                39.3378961
              ],
              [
                44.0701975,
                39.3371482
              ],
              [
                44.0714633,
                39.3367664
              ],
              [
                44.0722253,
                39.3364266
              ],
              [
                44.0734007,
                39.3354126
              ],
              [
                44.0740838,
                39.333683
              ],
              [
                44.0756455,
                39.331796
              ],
              [
                44.0758396,
                39.3313819
              ],
              [
                44.0758457,
                39.3309295
              ],
              [
                44.0757315,
                39.3302777
              ],
              [
                44.0758593,
                39.3298681
              ],
              [
                44.0762255,
                39.3296506
              ],
              [
                44.076549,
                39.3292286
              ],
              [
                44.0768659,
                39.3285943
              ],
              [
                44.0773572,
                39.328092
              ],
              [
                44.0775174,
                39.327524
              ],
              [
                44.077345,
                39.3265493
              ],
              [
                44.0774721,
                39.3261855
              ],
              [
                44.0777359,
                39.3258432
              ],
              [
                44.0779942,
                39.3256494
              ],
              [
                44.0783436,
                39.3255312
              ],
              [
                44.0790532,
                39.3254174
              ],
              [
                44.0795278,
                39.3252284
              ],
              [
                44.0797056,
                39.3249882
              ],
              [
                44.0795273,
                39.3240084
              ],
              [
                44.0790782,
                39.3221797
              ],
              [
                44.0787019,
                39.321227
              ],
              [
                44.0778636,
                39.3199415
              ],
              [
                44.0777466,
                39.3194318
              ],
              [
                44.0778083,
                39.3188725
              ],
              [
                44.078331,
                39.3181092
              ],
              [
                44.0788744,
                39.3174655
              ],
              [
                44.0790987,
                39.3169258
              ],
              [
                44.079467,
                39.3162599
              ],
              [
                44.0795865,
                39.3158467
              ],
              [
                44.0795859,
                39.3154044
              ],
              [
                44.0794402,
                39.3143543
              ],
              [
                44.0793872,
                39.3134792
              ],
              [
                44.0792932,
                39.313257
              ],
              [
                44.0786114,
                39.3126535
              ],
              [
                44.078536,
                39.3120718
              ],
              [
                44.0781849,
                39.3116563
              ],
              [
                44.0780466,
                39.3106055
              ],
              [
                44.0776572,
                39.3098
              ],
              [
                44.0775425,
                39.3095629
              ],
              [
                44.0772325,
                39.3091797
              ],
              [
                44.0770277,
                39.3087738
              ],
              [
                44.0769482,
                39.3083552
              ],
              [
                44.0767137,
                39.3079177
              ],
              [
                44.0773198,
                39.3062117
              ],
              [
                44.0776345,
                39.3055394
              ],
              [
                44.0782354,
                39.3050399
              ],
              [
                44.0787606,
                39.3043392
              ],
              [
                44.0791346,
                39.303182
              ],
              [
                44.0792553,
                39.3004868
              ],
              [
                44.0791014,
                39.2975847
              ],
              [
                44.0804721,
                39.2960014
              ],
              [
                44.0810014,
                39.295171
              ],
              [
                44.0810285,
                39.2947165
              ],
              [
                44.0812513,
                39.2941275
              ],
              [
                44.0816868,
                39.2937834
              ],
              [
                44.0821559,
                39.2935265
              ],
              [
                44.083845,
                39.2931197
              ],
              [
                44.0849708,
                39.2927348
              ],
              [
                44.0858397,
                39.2925356
              ],
              [
                44.0863608,
                39.2923291
              ],
              [
                44.0882232,
                39.2913743
              ],
              [
                44.0888332,
                39.291166
              ],
              [
                44.0893026,
                39.2908435
              ],
              [
                44.0900438,
                39.2902005
              ],
              [
                44.0905064,
                39.2900285
              ],
              [
                44.0908955,
                39.2899955
              ],
              [
                44.0912217,
                39.2900224
              ],
              [
                44.0916298,
                39.2902011
              ],
              [
                44.0921392,
                39.2904995
              ],
              [
                44.0929357,
                39.2907939
              ],
              [
                44.0936009,
                39.2909346
              ],
              [
                44.0944685,
                39.2909127
              ],
              [
                44.0955762,
                39.2907467
              ],
              [
                44.0960155,
                39.2906073
              ],
              [
                44.0976585,
                39.290317
              ],
              [
                44.0983688,
                39.2900747
              ],
              [
                44.0996892,
                39.2897789
              ],
              [
                44.1010413,
                39.2895881
              ],
              [
                44.1014094,
                39.2894732
              ],
              [
                44.1019137,
                39.2890206
              ],
              [
                44.1028782,
                39.2883663
              ],
              [
                44.1029498,
                39.2880474
              ],
              [
                44.1028891,
                39.28754
              ],
              [
                44.103067,
                39.2866872
              ],
              [
                44.1035764,
                39.2859782
              ],
              [
                44.1040044,
                39.2855295
              ],
              [
                44.1052278,
                39.2848633
              ],
              [
                44.1061212,
                39.2845504
              ],
              [
                44.1067544,
                39.2843709
              ],
              [
                44.1070871,
                39.2843553
              ],
              [
                44.1078107,
                39.2844303
              ],
              [
                44.1080596,
                39.2842966
              ],
              [
                44.1081319,
                39.283983
              ],
              [
                44.1081096,
                39.28366
              ],
              [
                44.1077983,
                39.2834656
              ],
              [
                44.105889,
                39.2827246
              ],
              [
                44.1053724,
                39.2822756
              ],
              [
                44.1039371,
                39.2805196
              ],
              [
                44.1034645,
                39.2801482
              ],
              [
                44.102524,
                39.2795518
              ],
              [
                44.1015003,
                39.2784343
              ],
              [
                44.1013953,
                39.277781
              ],
              [
                44.1012083,
                39.2773651
              ],
              [
                44.100794,
                39.2769342
              ],
              [
                44.1001975,
                39.2764647
              ],
              [
                44.0997591,
                39.2762165
              ],
              [
                44.0991869,
                39.2760987
              ],
              [
                44.0984765,
                39.276066
              ],
              [
                44.0980984,
                39.2760907
              ],
              [
                44.0944506,
                39.2759082
              ],
              [
                44.0937966,
                39.2755803
              ],
              [
                44.0934445,
                39.2751022
              ],
              [
                44.0931065,
                39.2735922
              ],
              [
                44.0925313,
                39.2730751
              ],
              [
                44.0922603,
                39.2725588
              ],
              [
                44.0912222,
                39.270144
              ],
              [
                44.091075,
                39.2696567
              ],
              [
                44.0909704,
                39.2689386
              ],
              [
                44.091113,
                39.2681992
              ],
              [
                44.0918301,
                39.2667887
              ],
              [
                44.0919474,
                39.2662578
              ],
              [
                44.0918313,
                39.2654965
              ],
              [
                44.0918351,
                39.2645959
              ],
              [
                44.0917685,
                39.2636812
              ],
              [
                44.0915587,
                39.2628142
              ],
              [
                44.0913152,
                39.2623686
              ],
              [
                44.090693,
                39.2619874
              ],
              [
                44.0898625,
                39.2616656
              ],
              [
                44.0895411,
                39.2614977
              ],
              [
                44.0867425,
                39.2579315
              ],
              [
                44.0863285,
                39.2575169
              ],
              [
                44.0846282,
                39.2564747
              ],
              [
                44.0843797,
                39.2562135
              ],
              [
                44.0843065,
                39.2560217
              ],
              [
                44.0843946,
                39.2558544
              ],
              [
                44.0850271,
                39.2555682
              ],
              [
                44.0854359,
                39.2553257
              ],
              [
                44.0858328,
                39.2550016
              ],
              [
                44.0864613,
                39.2538545
              ],
              [
                44.0866463,
                39.2534712
              ],
              [
                44.0867208,
                39.253039
              ],
              [
                44.0861728,
                39.2517667
              ],
              [
                44.0860691,
                39.2512276
              ],
              [
                44.0861311,
                39.2507621
              ],
              [
                44.0864025,
                39.2504604
              ],
              [
                44.0885676,
                39.2491066
              ],
              [
                44.0890813,
                39.2485506
              ],
              [
                44.0892651,
                39.2481721
              ],
              [
                44.0892548,
                39.2474177
              ],
              [
                44.089445,
                39.247049
              ],
              [
                44.0897917,
                39.2468437
              ],
              [
                44.0901326,
                39.2467848
              ],
              [
                44.0922555,
                39.2469285
              ],
              [
                44.0927461,
                39.2468844
              ],
              [
                44.0943376,
                39.2462673
              ],
              [
                44.095377,
                39.2458084
              ],
              [
                44.0959179,
                39.2457131
              ],
              [
                44.098093,
                39.2457286
              ],
              [
                44.0991451,
                39.2456337
              ],
              [
                44.0995261,
                39.2454006
              ],
              [
                44.1002983,
                39.2445942
              ],
              [
                44.1019922,
                39.2432411
              ],
              [
                44.1030469,
                39.2427928
              ],
              [
                44.1032307,
                39.2425733
              ],
              [
                44.1032791,
                39.2422503
              ],
              [
                44.1031323,
                39.2417395
              ],
              [
                44.1030211,
                39.2410546
              ],
              [
                44.1027102,
                39.237853
              ],
              [
                44.1027055,
                39.2375198
              ],
              [
                44.103069,
                39.2370198
              ],
              [
                44.103099,
                39.236565
              ],
              [
                44.1029539,
                39.2358296
              ],
              [
                44.1025968,
                39.2347313
              ],
              [
                44.102123,
                39.2342047
              ],
              [
                44.1022442,
                39.2335902
              ],
              [
                44.1022261,
                39.2327319
              ],
              [
                44.1023816,
                39.2313926
              ],
              [
                44.1021439,
                39.2311834
              ],
              [
                44.1019058,
                39.2310555
              ],
              [
                44.1015377,
                39.2310259
              ],
              [
                44.1013112,
                39.2308829
              ],
              [
                44.1011348,
                39.2305699
              ],
              [
                44.1007634,
                39.2303658
              ],
              [
                44.1001281,
                39.2302772
              ],
              [
                44.0998538,
                39.2299247
              ],
              [
                44.0995938,
                39.2290376
              ],
              [
                44.0993675,
                39.2286381
              ],
              [
                44.0989396,
                39.2282621
              ],
              [
                44.0987108,
                39.2278631
              ],
              [
                44.0988068,
                39.2273083
              ],
              [
                44.0991299,
                39.2269611
              ],
              [
                44.0999281,
                39.2265653
              ],
              [
                44.1004885,
                39.2261742
              ],
              [
                44.100648,
                39.2252757
              ],
              [
                44.1003124,
                39.2245045
              ],
              [
                44.1000122,
                39.2239909
              ],
              [
                44.0991704,
                39.2231462
              ],
              [
                44.098482,
                39.2220847
              ],
              [
                44.0979405,
                39.2214111
              ],
              [
                44.0967481,
                39.2208352
              ],
              [
                44.0959966,
                39.21979
              ],
              [
                44.0949837,
                39.2180435
              ],
              [
                44.09431,
                39.2171949
              ],
              [
                44.0940514,
                39.216368
              ],
              [
                44.094084,
                39.2155288
              ],
              [
                44.0945859,
                39.2144189
              ],
              [
                44.0955432,
                39.2130218
              ],
              [
                44.0956276,
                39.2122733
              ],
              [
                44.0959032,
                39.2118292
              ],
              [
                44.0966719,
                39.2111325
              ],
              [
                44.0973153,
                39.2101938
              ],
              [
                44.0974077,
                39.2097097
              ],
              [
                44.0976507,
                39.2092272
              ],
              [
                44.0974353,
                39.2086343
              ],
              [
                44.097009,
                39.2082275
              ],
              [
                44.0968119,
                39.2078741
              ],
              [
                44.096662,
                39.2075522
              ],
              [
                44.0970053,
                39.2065212
              ],
              [
                44.096993,
                39.2050193
              ],
              [
                44.0972566,
                39.2044917
              ],
              [
                44.0975845,
                39.2041397
              ],
              [
                44.0997341,
                39.2036813
              ],
              [
                44.1004988,
                39.2036234
              ],
              [
                44.1016684,
                39.2031615
              ],
              [
                44.1030103,
                39.2027324
              ],
              [
                44.1045859,
                39.2021135
              ],
              [
                44.1058659,
                39.2017167
              ],
              [
                44.1073227,
                39.2014626
              ],
              [
                44.1081411,
                39.2011741
              ],
              [
                44.1092558,
                39.1998789
              ],
              [
                44.1098982,
                39.1988918
              ],
              [
                44.1100854,
                39.1981779
              ],
              [
                44.1100537,
                39.1974887
              ],
              [
                44.1098176,
                39.1965473
              ],
              [
                44.1099816,
                39.1956513
              ],
              [
                44.1105406,
                39.1949084
              ],
              [
                44.1113231,
                39.1941423
              ],
              [
                44.111675,
                39.1936405
              ],
              [
                44.1117736,
                39.1927357
              ],
              [
                44.1122791,
                39.1918378
              ],
              [
                44.1132286,
                39.1908538
              ],
              [
                44.114932,
                39.1894902
              ],
              [
                44.1153558,
                39.1890124
              ],
              [
                44.1158881,
                39.1887227
              ],
              [
                44.1170805,
                39.1884819
              ],
              [
                44.1183961,
                39.1879572
              ],
              [
                44.1189468,
                39.1878297
              ],
              [
                44.1211904,
                39.1876915
              ],
              [
                44.1217739,
                39.1874753
              ],
              [
                44.1225379,
                39.1870526
              ],
              [
                44.1231808,
                39.1867981
              ],
              [
                44.1235049,
                39.1864492
              ],
              [
                44.1241466,
                39.1860438
              ],
              [
                44.125796,
                39.1854537
              ],
              [
                44.1277949,
                39.1852492
              ],
              [
                44.1285138,
                39.1852842
              ],
              [
                44.1295851,
                39.1851757
              ],
              [
                44.130342,
                39.1846331
              ],
              [
                44.1310808,
                39.1836802
              ],
              [
                44.131692,
                39.183097
              ],
              [
                44.1320203,
                39.1830034
              ],
              [
                44.1325457,
                39.1829793
              ],
              [
                44.1330303,
                39.1828165
              ],
              [
                44.1336574,
                39.182713
              ],
              [
                44.1345288,
                39.1826799
              ],
              [
                44.1357854,
                39.1824978
              ],
              [
                44.137134,
                39.1827011
              ],
              [
                44.1374833,
                39.1830378
              ],
              [
                44.1384242,
                39.1836999
              ],
              [
                44.1394341,
                39.1842148
              ],
              [
                44.1408196,
                39.1847539
              ],
              [
                44.1435832,
                39.1855823
              ],
              [
                44.1441674,
                39.1855906
              ],
              [
                44.144875,
                39.1854963
              ],
              [
                44.1455156,
                39.1852207
              ],
              [
                44.1470043,
                39.1843051
              ],
              [
                44.1479833,
                39.1836249
              ],
              [
                44.1494933,
                39.1823759
              ],
              [
                44.1500163,
                39.1820659
              ],
              [
                44.1508458,
                39.1817995
              ],
              [
                44.1518559,
                39.1815412
              ],
              [
                44.1526092,
                39.1812803
              ],
              [
                44.1534791,
                39.1810582
              ],
              [
                44.1554197,
                39.1804376
              ],
              [
                44.1563248,
                39.1803671
              ],
              [
                44.158451,
                39.179853
              ],
              [
                44.1600624,
                39.1793414
              ],
              [
                44.161533,
                39.1788112
              ],
              [
                44.1645706,
                39.1781192
              ],
              [
                44.1663807,
                39.1776245
              ],
              [
                44.1668342,
                39.1773325
              ],
              [
                44.1678675,
                39.1759275
              ],
              [
                44.1684463,
                39.1755654
              ],
              [
                44.1691738,
                39.1752171
              ],
              [
                44.1699343,
                39.1749825
              ],
              [
                44.1706627,
                39.1746242
              ],
              [
                44.1712073,
                39.1741833
              ],
              [
                44.1717042,
                39.1736354
              ],
              [
                44.1722608,
                39.1731199
              ],
              [
                44.1731483,
                39.1725871
              ],
              [
                44.1741073,
                39.1716756
              ],
              [
                44.1746717,
                39.1713441
              ],
              [
                44.1766354,
                39.1706247
              ],
              [
                44.1779327,
                39.1697597
              ],
              [
                44.1784838,
                39.1692391
              ],
              [
                44.1799678,
                39.1671808
              ],
              [
                44.1809399,
                39.1661018
              ],
              [
                44.181817,
                39.1654525
              ],
              [
                44.1821552,
                39.1652938
              ],
              [
                44.1825809,
                39.1652066
              ],
              [
                44.1830035,
                39.1650483
              ],
              [
                44.1832615,
                39.1647651
              ],
              [
                44.1834133,
                39.1642036
              ],
              [
                44.1834623,
                39.163279
              ],
              [
                44.1837299,
                39.162891
              ],
              [
                44.1839208,
                39.162419
              ],
              [
                44.1838165,
                39.1620412
              ],
              [
                44.1839519,
                39.1614984
              ],
              [
                44.1842524,
                39.1610696
              ],
              [
                44.1844995,
                39.1608798
              ],
              [
                44.1862379,
                39.1602898
              ],
              [
                44.1874792,
                39.1600026
              ],
              [
                44.1880781,
                39.1599144
              ],
              [
                44.1885063,
                39.1596246
              ],
              [
                44.1889114,
                39.1590828
              ],
              [
                44.1893978,
                39.1586732
              ],
              [
                44.1902139,
                39.1581882
              ],
              [
                44.1901312,
                39.1578647
              ],
              [
                44.1895092,
                39.1573338
              ],
              [
                44.1898475,
                39.1559675
              ],
              [
                44.1903645,
                39.1531692
              ],
              [
                44.1907752,
                39.1526904
              ],
              [
                44.1915157,
                39.1523274
              ],
              [
                44.1931017,
                39.1518225
              ],
              [
                44.1937754,
                39.1513674
              ],
              [
                44.1945669,
                39.1505041
              ],
              [
                44.1954479,
                39.1496653
              ],
              [
                44.1972577,
                39.1477209
              ],
              [
                44.1979321,
                39.1468296
              ],
              [
                44.1987141,
                39.1453974
              ],
              [
                44.1999753,
                39.1441872
              ],
              [
                44.2007101,
                39.1429782
              ],
              [
                44.2008534,
                39.1420917
              ],
              [
                44.2010388,
                39.1402004
              ],
              [
                44.2014439,
                39.1398101
              ],
              [
                44.2035576,
                39.1384863
              ],
              [
                44.2039268,
                39.1383489
              ],
              [
                44.2063946,
                39.1381749
              ],
              [
                44.2068714,
                39.13799
              ],
              [
                44.2075445,
                39.1373609
              ],
              [
                44.2089184,
                39.1363071
              ],
              [
                44.2093804,
                39.1358837
              ],
              [
                44.2101667,
                39.1345337
              ],
              [
                44.210815,
                39.1337228
              ],
              [
                44.2114864,
                39.132738
              ],
              [
                44.2123024,
                39.1318785
              ],
              [
                44.2135655,
                39.1303045
              ],
              [
                44.2134534,
                39.1296812
              ],
              [
                44.2131184,
                39.1287568
              ],
              [
                44.2126409,
                39.1280362
              ],
              [
                44.2114676,
                39.1268754
              ],
              [
                44.211245,
                39.1260021
              ],
              [
                44.2112988,
                39.1251787
              ],
              [
                44.2115975,
                39.1243469
              ],
              [
                44.2110744,
                39.1237057
              ],
              [
                44.2105547,
                39.1227979
              ],
              [
                44.2102214,
                39.120607
              ],
              [
                44.2098835,
                39.1194263
              ],
              [
                44.2095143,
                39.1176911
              ],
              [
                44.2093752,
                39.1174627
              ],
              [
                44.2082857,
                39.1168005
              ],
              [
                44.2080448,
                39.1165213
              ],
              [
                44.2075342,
                39.1148227
              ],
              [
                44.2075924,
                39.1140854
              ],
              [
                44.2078744,
                39.1138214
              ],
              [
                44.2085067,
                39.113065
              ],
              [
                44.2098329,
                39.1117828
              ],
              [
                44.2100207,
                39.1113207
              ],
              [
                44.2098488,
                39.1107767
              ],
              [
                44.2098131,
                39.1104689
              ],
              [
                44.21052,
                39.1101641
              ],
              [
                44.2111317,
                39.1101893
              ],
              [
                44.211544,
                39.1100803
              ],
              [
                44.2128448,
                39.1089362
              ],
              [
                44.2146638,
                39.1083422
              ],
              [
                44.2151731,
                39.1080923
              ],
              [
                44.2152753,
                39.1077074
              ],
              [
                44.2152948,
                39.107158
              ],
              [
                44.2155331,
                39.1068641
              ],
              [
                44.2158458,
                39.1067753
              ],
              [
                44.216525,
                39.1064166
              ],
              [
                44.2170612,
                39.1056918
              ],
              [
                44.217521,
                39.1046326
              ],
              [
                44.2180401,
                39.1037438
              ],
              [
                44.2190124,
                39.1034038
              ],
              [
                44.2202364,
                39.1031055
              ],
              [
                44.2209183,
                39.1032723
              ],
              [
                44.2213739,
                39.103451
              ],
              [
                44.2217707,
                39.1033373
              ],
              [
                44.2228335,
                39.102561
              ],
              [
                44.2233369,
                39.101967
              ],
              [
                44.2234949,
                39.1014324
              ],
              [
                44.2233645,
                39.1008608
              ],
              [
                44.2239769,
                39.0999006
              ],
              [
                44.224562,
                39.0988457
              ],
              [
                44.2257876,
                39.0962523
              ],
              [
                44.2260246,
                39.0954001
              ],
              [
                44.22591,
                39.0950499
              ],
              [
                44.2255758,
                39.0948545
              ],
              [
                44.2250471,
                39.094699
              ],
              [
                44.2242914,
                39.0945462
              ],
              [
                44.2237822,
                39.0945021
              ],
              [
                44.223291,
                39.0943564
              ],
              [
                44.222913,
                39.0940911
              ],
              [
                44.222601,
                39.0937091
              ],
              [
                44.2224833,
                39.0929751
              ],
              [
                44.2222315,
                39.0922599
              ],
              [
                44.2214546,
                39.0918019
              ],
              [
                44.2215691,
                39.0911812
              ],
              [
                44.2212121,
                39.0907636
              ],
              [
                44.2210071,
                39.0907036
              ],
              [
                44.219422,
                39.0911638
              ],
              [
                44.2180435,
                39.0910361
              ],
              [
                44.2168608,
                39.0908357
              ],
              [
                44.2160155,
                39.0903627
              ],
              [
                44.2156512,
                39.09029
              ],
              [
                44.2152241,
                39.0901364
              ],
              [
                44.2146416,
                39.0897352
              ],
              [
                44.2142056,
                39.0891521
              ],
              [
                44.2135178,
                39.0885881
              ],
              [
                44.2123189,
                39.0878149
              ],
              [
                44.2092274,
                39.0876745
              ],
              [
                44.2079823,
                39.0889603
              ],
              [
                44.2070564,
                39.0893604
              ],
              [
                44.2067631,
                39.0896461
              ],
              [
                44.2063251,
                39.0899074
              ],
              [
                44.2057823,
                39.0899555
              ],
              [
                44.2051695,
                39.0896727
              ],
              [
                44.2048084,
                39.089187
              ],
              [
                44.2043867,
                39.0890369
              ],
              [
                44.2041829,
                39.088561
              ],
              [
                44.2030646,
                39.0875461
              ],
              [
                44.2026104,
                39.0873465
              ],
              [
                44.2019587,
                39.0872557
              ],
              [
                44.2014128,
                39.0871142
              ],
              [
                44.2007421,
                39.0871649
              ],
              [
                44.1999436,
                39.0870868
              ],
              [
                44.199409,
                39.0867321
              ],
              [
                44.1989974,
                39.0866304
              ],
              [
                44.1982417,
                39.0868192
              ],
              [
                44.1975571,
                39.0863981
              ],
              [
                44.1972237,
                39.085835
              ],
              [
                44.1967697,
                39.0846157
              ],
              [
                44.1962169,
                39.0837218
              ],
              [
                44.1951388,
                39.08161
              ],
              [
                44.1947359,
                39.0810195
              ],
              [
                44.1939205,
                39.0805684
              ],
              [
                44.1935224,
                39.080146
              ],
              [
                44.1930366,
                39.0797564
              ],
              [
                44.1927046,
                39.0793139
              ],
              [
                44.1925661,
                39.0788125
              ],
              [
                44.1925668,
                39.0781488
              ],
              [
                44.1922512,
                39.077641
              ],
              [
                44.1917969,
                39.0771982
              ],
              [
                44.1911717,
                39.0768918
              ],
              [
                44.1909206,
                39.0766185
              ],
              [
                44.1909881,
                39.0752844
              ],
              [
                44.1908665,
                39.0745913
              ],
              [
                44.1909647,
                39.0737457
              ],
              [
                44.1919283,
                39.0725581
              ],
              [
                44.1920091,
                39.0718669
              ],
              [
                44.1921888,
                39.0710945
              ],
              [
                44.1922689,
                39.0707501
              ],
              [
                44.1928778,
                39.0698241
              ],
              [
                44.1932503,
                39.0689763
              ],
              [
                44.1936511,
                39.0679457
              ],
              [
                44.1942347,
                39.0672985
              ],
              [
                44.1944491,
                39.0668608
              ],
              [
                44.1954993,
                39.0664432
              ],
              [
                44.1956005,
                39.0662788
              ],
              [
                44.1955677,
                39.0657915
              ],
              [
                44.1964427,
                39.0651621
              ],
              [
                44.196724,
                39.0646177
              ],
              [
                44.1968694,
                39.0636482
              ],
              [
                44.1975345,
                39.0629197
              ],
              [
                44.1986733,
                39.0624737
              ],
              [
                44.2000291,
                39.0616249
              ],
              [
                44.2023568,
                39.0590709
              ],
              [
                44.2032377,
                39.0582788
              ],
              [
                44.2038752,
                39.0577003
              ],
              [
                44.2049207,
                39.056358
              ],
              [
                44.205512,
                39.0554679
              ],
              [
                44.2049836,
                39.054548
              ],
              [
                44.2043233,
                39.0540891
              ],
              [
                44.2029986,
                39.0535069
              ],
              [
                44.2019064,
                39.0528806
              ],
              [
                44.20035,
                39.0513163
              ],
              [
                44.1996037,
                39.0499924
              ],
              [
                44.1991048,
                39.0485205
              ],
              [
                44.199019,
                39.0484988
              ],
              [
                44.1979261,
                39.0474898
              ],
              [
                44.1959068,
                39.0461699
              ],
              [
                44.1951443,
                39.0449446
              ],
              [
                44.1948066,
                39.0438966
              ],
              [
                44.1946546,
                39.0420495
              ],
              [
                44.1947723,
                39.0405005
              ],
              [
                44.1954078,
                39.0392853
              ],
              [
                44.1964667,
                39.0384941
              ],
              [
                44.197931,
                39.0371182
              ],
              [
                44.1988806,
                39.0365068
              ],
              [
                44.2003062,
                39.0347941
              ],
              [
                44.2022094,
                39.0321067
              ],
              [
                44.2026223,
                39.0310124
              ],
              [
                44.2040712,
                39.0303155
              ],
              [
                44.2054827,
                39.029258
              ],
              [
                44.2071426,
                39.0276376
              ],
              [
                44.2079482,
                39.0262006
              ],
              [
                44.2084922,
                39.025445
              ],
              [
                44.20943,
                39.0243509
              ],
              [
                44.2102017,
                39.023315
              ],
              [
                44.2113866,
                39.0222157
              ],
              [
                44.2116539,
                39.0217294
              ],
              [
                44.211677,
                39.0209503
              ],
              [
                44.2114977,
                39.0204983
              ],
              [
                44.2106801,
                39.019953
              ],
              [
                44.2100115,
                39.0196929
              ],
              [
                44.208794,
                39.0193678
              ],
              [
                44.2061875,
                39.018148
              ],
              [
                44.2051481,
                39.0178843
              ],
              [
                44.203223,
                39.0172486
              ],
              [
                44.2004906,
                39.0157505
              ],
              [
                44.19943,
                39.014823
              ],
              [
                44.1985774,
                39.0137725
              ],
              [
                44.1978729,
                39.0130833
              ],
              [
                44.1970161,
                39.0126871
              ],
              [
                44.1957562,
                39.0118317
              ],
              [
                44.1947608,
                39.0115134
              ],
              [
                44.1945966,
                39.0112567
              ],
              [
                44.1944662,
                39.0107041
              ],
              [
                44.1942286,
                39.0105454
              ],
              [
                44.1937264,
                39.0104946
              ],
              [
                44.193139,
                39.0102156
              ],
              [
                44.1916459,
                39.0091419
              ],
              [
                44.1910781,
                39.0090057
              ],
              [
                44.1901913,
                39.0091987
              ],
              [
                44.1901328,
                39.0095026
              ],
              [
                44.1898226,
                39.0097556
              ],
              [
                44.1893025,
                39.0108889
              ],
              [
                44.1891191,
                39.0110355
              ],
              [
                44.1879832,
                39.0110979
              ],
              [
                44.1873039,
                39.0113926
              ],
              [
                44.186851,
                39.0114129
              ],
              [
                44.1862031,
                39.0112672
              ],
              [
                44.185072,
                39.0108599
              ],
              [
                44.1843614,
                39.0107303
              ],
              [
                44.1829909,
                39.0106658
              ],
              [
                44.1824846,
                39.010703
              ],
              [
                44.1815927,
                39.0109798
              ],
              [
                44.181272,
                39.0108658
              ],
              [
                44.1809525,
                39.0106834
              ],
              [
                44.1800391,
                39.009926
              ],
              [
                44.179665,
                39.0094084
              ],
              [
                44.1795107,
                39.0089795
              ],
              [
                44.1794396,
                39.0082723
              ],
              [
                44.1792861,
                39.0078903
              ],
              [
                44.1781035,
                39.0070263
              ],
              [
                44.1772395,
                39.0060651
              ],
              [
                44.1770053,
                39.0056597
              ],
              [
                44.1768385,
                39.0051332
              ],
              [
                44.1768717,
                39.0046545
              ],
              [
                44.1768015,
                39.003228
              ],
              [
                44.1762338,
                39.0021681
              ],
              [
                44.1761208,
                39.0018263
              ],
              [
                44.175487,
                39.0011846
              ],
              [
                44.1747694,
                39.0010575
              ],
              [
                44.1742011,
                39.0007269
              ],
              [
                44.1739031,
                39.0004969
              ],
              [
                44.1736556,
                39.0003331
              ],
              [
                44.1736207,
                39.0002011
              ],
              [
                44.1741738,
                38.9991675
              ],
              [
                44.1741362,
                38.9983623
              ],
              [
                44.1737483,
                38.9968613
              ],
              [
                44.1733294,
                38.9960073
              ],
              [
                44.1730994,
                38.9953163
              ],
              [
                44.1730024,
                38.9941503
              ],
              [
                44.1725333,
                38.9935534
              ],
              [
                44.1719972,
                38.9927191
              ],
              [
                44.1718729,
                38.9924328
              ],
              [
                44.1717941,
                38.9917907
              ],
              [
                44.1721002,
                38.9903355
              ],
              [
                44.1728348,
                38.9886241
              ],
              [
                44.1730001,
                38.9882801
              ],
              [
                44.1762161,
                38.9868205
              ],
              [
                44.176678,
                38.9865402
              ],
              [
                44.1778231,
                38.9861555
              ],
              [
                44.1782757,
                38.9859497
              ],
              [
                44.1807623,
                38.9853985
              ],
              [
                44.1817918,
                38.9844098
              ],
              [
                44.182797,
                38.9837529
              ],
              [
                44.1840404,
                38.9827779
              ],
              [
                44.1849221,
                38.9821818
              ],
              [
                44.1861884,
                38.9817765
              ],
              [
                44.1874231,
                38.9817299
              ],
              [
                44.1890422,
                38.9818656
              ],
              [
                44.1894753,
                38.9816243
              ],
              [
                44.1895388,
                38.9812786
              ],
              [
                44.1893782,
                38.9800903
              ],
              [
                44.1892145,
                38.979496
              ],
              [
                44.1889406,
                38.9792897
              ],
              [
                44.1877311,
                38.9787631
              ],
              [
                44.1873808,
                38.9785105
              ],
              [
                44.1872779,
                38.9782064
              ],
              [
                44.1873353,
                38.9778634
              ],
              [
                44.1877663,
                38.9771699
              ],
              [
                44.1882104,
                38.9766092
              ],
              [
                44.1890386,
                38.976266
              ],
              [
                44.1910991,
                38.9752114
              ],
              [
                44.1914252,
                38.9746819
              ],
              [
                44.1909814,
                38.9744678
              ],
              [
                44.1885147,
                38.9742373
              ],
              [
                44.1878474,
                38.9731248
              ],
              [
                44.1864425,
                38.971967
              ],
              [
                44.1862685,
                38.9702417
              ],
              [
                44.1865059,
                38.9698253
              ],
              [
                44.1887439,
                38.9686624
              ],
              [
                44.1889869,
                38.9676089
              ],
              [
                44.1884975,
                38.9668407
              ],
              [
                44.1872961,
                38.9665108
              ],
              [
                44.1854768,
                38.9663676
              ],
              [
                44.1849596,
                38.9659894
              ],
              [
                44.1847641,
                38.96557
              ],
              [
                44.1844486,
                38.9646308
              ],
              [
                44.182295,
                38.9616407
              ],
              [
                44.1818091,
                38.9570916
              ],
              [
                44.1841169,
                38.9555609
              ],
              [
                44.1845487,
                38.9553695
              ],
              [
                44.1853354,
                38.9548929
              ],
              [
                44.1874085,
                38.9534927
              ],
              [
                44.1895414,
                38.9521809
              ],
              [
                44.1912639,
                38.9515689
              ],
              [
                44.19191,
                38.9512949
              ],
              [
                44.1933467,
                38.9509836
              ],
              [
                44.1956739,
                38.951018
              ],
              [
                44.1968674,
                38.9506957
              ],
              [
                44.1981442,
                38.9502913
              ],
              [
                44.1996691,
                38.9496575
              ],
              [
                44.2002417,
                38.9480087
              ],
              [
                44.2002792,
                38.9473873
              ],
              [
                44.2000902,
                38.9467806
              ],
              [
                44.1993486,
                38.9453984
              ],
              [
                44.1988192,
                38.9442081
              ],
              [
                44.1984182,
                38.94356
              ],
              [
                44.1973567,
                38.9421479
              ],
              [
                44.1966548,
                38.9410995
              ],
              [
                44.1945237,
                38.938773
              ],
              [
                44.1926875,
                38.9361972
              ],
              [
                44.1924717,
                38.9324467
              ],
              [
                44.1953817,
                38.9310282
              ],
              [
                44.1957626,
                38.9307797
              ],
              [
                44.1965527,
                38.9299901
              ],
              [
                44.1967349,
                38.9289873
              ],
              [
                44.1969351,
                38.9260923
              ],
              [
                44.1977222,
                38.924276
              ],
              [
                44.1983052,
                38.9232613
              ],
              [
                44.1996955,
                38.9218636
              ],
              [
                44.2010796,
                38.9218683
              ],
              [
                44.2023022,
                38.9219937
              ],
              [
                44.20404,
                38.9219987
              ],
              [
                44.2093973,
                38.9216214
              ],
              [
                44.2099582,
                38.9214533
              ],
              [
                44.2115488,
                38.9209541
              ],
              [
                44.2127441,
                38.9208123
              ],
              [
                44.2138758,
                38.9207128
              ],
              [
                44.2148684,
                38.9203081
              ],
              [
                44.2170512,
                38.9186621
              ],
              [
                44.2180291,
                38.9173369
              ],
              [
                44.2185329,
                38.9167013
              ],
              [
                44.2192992,
                38.9150764
              ],
              [
                44.219376,
                38.9142675
              ],
              [
                44.219719,
                38.9126502
              ],
              [
                44.2196755,
                38.9107199
              ],
              [
                44.2198973,
                38.9097158
              ],
              [
                44.2200951,
                38.9091935
              ],
              [
                44.2201522,
                38.9079048
              ],
              [
                44.2197805,
                38.9061857
              ],
              [
                44.2200023,
                38.905217
              ],
              [
                44.2201401,
                38.9048181
              ],
              [
                44.2202136,
                38.9046055
              ],
              [
                44.2202203,
                38.9042982
              ],
              [
                44.2199803,
                38.9039877
              ],
              [
                44.219445,
                38.9036525
              ],
              [
                44.2189521,
                38.9035674
              ],
              [
                44.2180071,
                38.9035906
              ],
              [
                44.2173816,
                38.9036973
              ],
              [
                44.2169077,
                38.9036709
              ],
              [
                44.216515,
                38.9035116
              ],
              [
                44.2156619,
                38.902824
              ],
              [
                44.2143108,
                38.9019795
              ],
              [
                44.2134155,
                38.9013261
              ],
              [
                44.2129819,
                38.9009005
              ],
              [
                44.2119432,
                38.8988855
              ],
              [
                44.2115458,
                38.8983663
              ],
              [
                44.2101228,
                38.8979001
              ],
              [
                44.2099638,
                38.8974454
              ],
              [
                44.2104571,
                38.896205
              ],
              [
                44.2106478,
                38.894357
              ],
              [
                44.2106525,
                38.8927167
              ],
              [
                44.2113518,
                38.8905571
              ],
              [
                44.2114822,
                38.8903453
              ],
              [
                44.2116514,
                38.8902038
              ],
              [
                44.2132017,
                38.889227
              ],
              [
                44.2141446,
                38.8884546
              ],
              [
                44.2147102,
                38.8881455
              ],
              [
                44.2167112,
                38.8874562
              ],
              [
                44.2171567,
                38.8872162
              ],
              [
                44.2185623,
                38.8856917
              ],
              [
                44.2192696,
                38.8851026
              ],
              [
                44.2203916,
                38.8847901
              ],
              [
                44.2229232,
                38.8843728
              ],
              [
                44.2242734,
                38.8839488
              ],
              [
                44.2266853,
                38.8830518
              ],
              [
                44.2309135,
                38.8811148
              ],
              [
                44.2346431,
                38.8786647
              ],
              [
                44.2350453,
                38.8764147
              ],
              [
                44.2391948,
                38.873279
              ],
              [
                44.2398948,
                38.872287
              ],
              [
                44.2415177,
                38.8713756
              ],
              [
                44.2449592,
                38.8706682
              ],
              [
                44.2454553,
                38.8702175
              ],
              [
                44.2454873,
                38.8685471
              ],
              [
                44.245697,
                38.8676321
              ],
              [
                44.2456152,
                38.8666616
              ],
              [
                44.244399,
                38.8658826
              ],
              [
                44.2439535,
                38.8655447
              ],
              [
                44.2438167,
                38.8652556
              ],
              [
                44.2438606,
                38.8614481
              ],
              [
                44.2436893,
                38.8609583
              ],
              [
                44.242501,
                38.8592764
              ],
              [
                44.2410992,
                38.8584455
              ],
              [
                44.2412221,
                38.8565282
              ],
              [
                44.2422768,
                38.8560312
              ],
              [
                44.2434439,
                38.855162
              ],
              [
                44.2444919,
                38.8535087
              ],
              [
                44.2444802,
                38.85302
              ],
              [
                44.2444598,
                38.8522765
              ],
              [
                44.2446602,
                38.8520225
              ],
              [
                44.2452578,
                38.8516647
              ],
              [
                44.2454589,
                38.8509687
              ],
              [
                44.245308,
                38.8506821
              ],
              [
                44.2460033,
                38.8504524
              ],
              [
                44.2462891,
                38.85019
              ],
              [
                44.2470371,
                38.8501001
              ],
              [
                44.2487075,
                38.8498222
              ],
              [
                44.2512321,
                38.8495836
              ],
              [
                44.2532361,
                38.8491945
              ],
              [
                44.2544356,
                38.8488171
              ],
              [
                44.2565349,
                38.8475485
              ],
              [
                44.2569929,
                38.8469492
              ],
              [
                44.2577238,
                38.8475184
              ],
              [
                44.257982,
                38.8480687
              ],
              [
                44.2594964,
                38.8485236
              ],
              [
                44.2600002,
                38.8487953
              ],
              [
                44.2603554,
                38.8493759
              ],
              [
                44.2608109,
                38.8496584
              ],
              [
                44.2623943,
                38.8501374
              ],
              [
                44.2632924,
                38.850352
              ],
              [
                44.2641362,
                38.8508222
              ],
              [
                44.2649514,
                38.8511751
              ],
              [
                44.2657878,
                38.8516198
              ],
              [
                44.2660885,
                38.8518543
              ],
              [
                44.2662876,
                38.8523303
              ],
              [
                44.2666064,
                38.8527613
              ],
              [
                44.2674907,
                38.8526643
              ],
              [
                44.2686435,
                38.852958
              ],
              [
                44.2699797,
                38.8533515
              ],
              [
                44.2709943,
                38.8536574
              ],
              [
                44.2722758,
                38.8538734
              ],
              [
                44.2739658,
                38.8539331
              ],
              [
                44.2749056,
                38.8542528
              ],
              [
                44.2753975,
                38.854341
              ],
              [
                44.2765117,
                38.8541961
              ],
              [
                44.27748,
                38.8542313
              ],
              [
                44.2786628,
                38.8531549
              ],
              [
                44.281026,
                38.8512857
              ],
              [
                44.2815542,
                38.8504902
              ],
              [
                44.2816993,
                38.8498564
              ],
              [
                44.2816988,
                38.8488988
              ],
              [
                44.2820406,
                38.847847
              ],
              [
                44.2837455,
                38.8475139
              ],
              [
                44.2844038,
                38.8473369
              ],
              [
                44.2849512,
                38.8468926
              ],
              [
                44.2862926,
                38.8460529
              ],
              [
                44.2868992,
                38.8458267
              ],
              [
                44.2876054,
                38.8457421
              ],
              [
                44.2882804,
                38.8457432
              ],
              [
                44.2891474,
                38.8456123
              ],
              [
                44.289747,
                38.8454494
              ],
              [
                44.291589,
                38.843796
              ],
              [
                44.2926351,
                38.8429759
              ],
              [
                44.293602,
                38.842385
              ],
              [
                44.2948541,
                38.8417642
              ],
              [
                44.2964366,
                38.8410655
              ],
              [
                44.2978981,
                38.8408179
              ],
              [
                44.2992449,
                38.8408563
              ],
              [
                44.3009879,
                38.8408017
              ],
              [
                44.3010599,
                38.8401903
              ],
              [
                44.3006363,
                38.8385914
              ],
              [
                44.3007126,
                38.8375979
              ],
              [
                44.3006871,
                38.836599
              ],
              [
                44.3004488,
                38.835752
              ],
              [
                44.2990879,
                38.8343588
              ],
              [
                44.2985366,
                38.8336566
              ],
              [
                44.2979582,
                38.8322537
              ],
              [
                44.2975701,
                38.830688
              ],
              [
                44.2972198,
                38.8300177
              ],
              [
                44.2959282,
                38.8284072
              ],
              [
                44.2950267,
                38.8263251
              ],
              [
                44.295117,
                38.8261872
              ],
              [
                44.2956679,
                38.8257862
              ],
              [
                44.2964147,
                38.8253713
              ],
              [
                44.2978901,
                38.825054
              ],
              [
                44.2995527,
                38.8247646
              ],
              [
                44.3010449,
                38.8246096
              ],
              [
                44.3018182,
                38.8243803
              ],
              [
                44.3021981,
                38.8241669
              ],
              [
                44.3027065,
                38.8234074
              ],
              [
                44.3036475,
                38.8224003
              ],
              [
                44.3050466,
                38.8202628
              ],
              [
                44.3052164,
                38.8197308
              ],
              [
                44.3052544,
                38.8192427
              ],
              [
                44.3051065,
                38.8188621
              ],
              [
                44.3050447,
                38.8184524
              ],
              [
                44.3051497,
                38.8181016
              ],
              [
                44.3054385,
                38.8176672
              ],
              [
                44.3057132,
                38.8170975
              ],
              [
                44.305971,
                38.8162993
              ],
              [
                44.3060656,
                38.815769
              ],
              [
                44.3065703,
                38.8157095
              ],
              [
                44.3082452,
                38.8150732
              ],
              [
                44.3090701,
                38.8145472
              ],
              [
                44.3095398,
                38.8139944
              ],
              [
                44.3103935,
                38.8124312
              ],
              [
                44.3107359,
                38.8119735
              ],
              [
                44.3110665,
                38.8117128
              ],
              [
                44.3116114,
                38.8114514
              ],
              [
                44.3122944,
                38.8112215
              ],
              [
                44.3126815,
                38.810963
              ],
              [
                44.313285,
                38.8103701
              ],
              [
                44.3135464,
                38.8102486
              ],
              [
                44.3137127,
                38.8100612
              ],
              [
                44.313801,
                38.8096948
              ],
              [
                44.3140179,
                38.8093789
              ],
              [
                44.3146009,
                38.8090117
              ],
              [
                44.3148195,
                38.8087951
              ],
              [
                44.3149064,
                38.8081674
              ],
              [
                44.3148334,
                38.8078062
              ],
              [
                44.3148364,
                38.8072531
              ],
              [
                44.314744,
                38.8069272
              ],
              [
                44.3144191,
                38.8064888
              ],
              [
                44.3131811,
                38.8060413
              ],
              [
                44.3125219,
                38.8056638
              ],
              [
                44.3119992,
                38.8052876
              ],
              [
                44.3114596,
                38.8051366
              ],
              [
                44.3105604,
                38.8049888
              ],
              [
                44.309804,
                38.8047042
              ],
              [
                44.3090929,
                38.8046125
              ],
              [
                44.3080114,
                38.8046408
              ],
              [
                44.3068125,
                38.8044814
              ],
              [
                44.3060474,
                38.804479
              ],
              [
                44.305316,
                38.8042854
              ],
              [
                44.3044856,
                38.8039627
              ],
              [
                44.3038549,
                38.8035527
              ],
              [
                44.3031487,
                38.8029532
              ],
              [
                44.3028097,
                38.8025243
              ],
              [
                44.3025635,
                38.8019701
              ],
              [
                44.3023881,
                38.8010228
              ],
              [
                44.3020914,
                38.7999185
              ],
              [
                44.3017238,
                38.799185
              ],
              [
                44.3012479,
                38.7987486
              ],
              [
                44.3009266,
                38.7981471
              ],
              [
                44.3008777,
                38.797729
              ],
              [
                44.3006589,
                38.7971796
              ],
              [
                44.3005255,
                38.7964688
              ],
              [
                44.3169659,
                38.7977117
              ],
              [
                44.3180761,
                38.7977117
              ],
              [
                44.321966,
                38.7963208
              ],
              [
                44.3608255,
                38.8053324
              ],
              [
                44.3608255,
                38.8058887
              ],
              [
                44.3608254,
                38.8061669
              ],
              [
                44.3765415,
                38.8175892
              ],
              [
                44.383995,
                38.8392553
              ],
              [
                44.3914951,
                38.8492594
              ],
              [
                44.392328,
                38.85065
              ],
              [
                44.4197811,
                38.8585386
              ],
              [
                44.421171,
                38.8588167
              ],
              [
                44.4217281,
                38.8590948
              ],
              [
                44.4264477,
                38.8607637
              ],
              [
                44.4278376,
                38.8610418
              ],
              [
                44.4372609,
                38.8698846
              ],
              [
                44.445444,
                38.8816326
              ],
              [
                44.459334,
                38.8927417
              ],
              [
                44.4612771,
                38.8938543
              ],
              [
                44.4640568,
                38.8955234
              ],
              [
                44.4751672,
                38.8996869
              ],
              [
                44.4922253,
                38.9030571
              ],
              [
                44.5134266,
                38.9146797
              ],
              [
                44.5142601,
                38.9146797
              ],
              [
                44.5268282,
                38.931471
              ],
              [
                44.5277833,
                38.9363684
              ],
              [
                44.5316732,
                38.9416434
              ],
              [
                44.534425,
                38.947997
              ],
              [
                44.5349812,
                38.9532808
              ],
              [
                44.5378663,
                38.9567092
              ],
              [
                44.5433806,
                38.9668835
              ],
              [
                44.5507973,
                38.9704963
              ],
              [
                44.5589793,
                38.9703266
              ],
              [
                44.5623122,
                38.9697705
              ],
              [
                44.5659255,
                38.9697705
              ],
              [
                44.5664794,
                38.9694924
              ],
              [
                44.5687021,
                38.9694924
              ],
              [
                44.5695357,
                38.9692144
              ],
              [
                44.5714788,
                38.9692143
              ],
              [
                44.5725921,
                38.9689363
              ],
              [
                44.5742593,
                38.9689363
              ],
              [
                44.5753687,
                38.9686582
              ],
              [
                44.5773156,
                38.9686582
              ],
              [
                44.5792594,
                38.968102
              ],
              [
                44.5814822,
                38.968102
              ],
              [
                44.5875924,
                38.9672678
              ],
              [
                44.590369,
                38.9672678
              ],
              [
                44.6309621,
                38.967966
              ],
              [
                44.6326286,
                38.9679661
              ],
              [
                44.6356849,
                38.9674099
              ],
              [
                44.6376288,
                38.9674099
              ],
              [
                44.6619698,
                38.9579644
              ],
              [
                44.6636363,
                38.9574083
              ],
              [
                44.6789544,
                38.9513238
              ],
              [
                44.681178,
                38.9507676
              ],
              [
                44.6808319,
                38.9482627
              ],
              [
                44.6816647,
                38.9471504
              ],
              [
                44.6811085,
                38.9415975
              ],
              [
                44.6781347,
                38.9391167
              ],
              [
                44.6791647,
                38.9316391
              ],
              [
                44.6761419,
                38.9240725
              ],
              [
                44.675588,
                38.9229601
              ],
              [
                44.6827979,
                38.9189204
              ],
              [
                44.6830745,
                38.918373
              ],
              [
                44.682798,
                38.9167043
              ],
              [
                44.6830745,
                38.916426
              ],
              [
                44.6830745,
                38.9155917
              ],
              [
                44.6833518,
                38.9153135
              ],
              [
                44.6833518,
                38.9150354
              ],
              [
                44.6847418,
                38.9139229
              ],
              [
                44.6861316,
                38.9139228
              ],
              [
                44.6864081,
                38.9136447
              ],
              [
                44.7021673,
                38.9166817
              ],
              [
                44.7137577,
                38.9257316
              ],
              [
                44.714868,
                38.926566
              ],
              [
                44.7162578,
                38.9274003
              ],
              [
                44.7218111,
                38.9301815
              ],
              [
                44.7523962,
                38.9370036
              ],
              [
                44.7532299,
                38.9370036
              ],
              [
                44.75434,
                38.9375599
              ],
              [
                44.7548963,
                38.9375599
              ],
              [
                44.7551728,
                38.9378379
              ],
              [
                44.7543399,
                38.937838
              ],
              [
                44.7765354,
                38.9768171
              ],
              [
                44.7871395,
                38.9802293
              ],
              [
                44.7865395,
                38.9961815
              ],
              [
                44.788206,
                38.9989618
              ],
              [
                44.7909824,
                39.0022984
              ],
              [
                44.792649,
                39.0036797
              ],
              [
                44.7945959,
                39.005348
              ],
              [
                44.7949265,
                39.0245564
              ],
              [
                44.7957594,
                39.026781
              ],
              [
                44.7957593,
                39.027059
              ],
              [
                44.7954827,
                39.0278932
              ],
              [
                44.7949265,
                39.0281712
              ],
              [
                44.7946499,
                39.0287273
              ],
              [
                44.7940928,
                39.0290054
              ],
              [
                44.7935397,
                39.0292834
              ],
              [
                44.7761532,
                39.0429198
              ],
              [
                44.7545198,
                39.0511629
              ],
              [
                44.75424,
                39.0514409
              ],
              [
                44.7536869,
                39.0514409
              ],
              [
                44.7536869,
                39.051719
              ],
              [
                44.7531299,
                39.051719
              ],
              [
                44.7422967,
                39.0592169
              ],
              [
                44.7422967,
                39.0594949
              ],
              [
                44.7417397,
                39.059495
              ],
              [
                44.7128498,
                39.0861585
              ],
              [
                44.7125732,
                39.0878267
              ],
              [
                44.712017,
                39.0886607
              ],
              [
                44.7117404,
                39.0889388
              ],
              [
                44.7103498,
                39.0897728
              ],
              [
                44.6940874,
                39.0999672
              ],
              [
                44.6926968,
                39.0999673
              ],
              [
                44.6918639,
                39.1002453
              ],
              [
                44.6745297,
                39.1098172
              ],
              [
                44.6680066,
                39.1199396
              ],
              [
                44.6412977,
                39.1474682
              ],
              [
                44.6343546,
                39.1555187
              ],
              [
                44.634078,
                39.1557966
              ],
              [
                44.634078,
                39.1560745
              ],
              [
                44.633521,
                39.1566302
              ],
              [
                44.633521,
                39.1569082
              ],
              [
                44.6332444,
                39.1571861
              ],
              [
                44.6144377,
                39.1589518
              ],
              [
                44.6141612,
                39.1592297
              ],
              [
                44.6130478,
                39.1597857
              ],
              [
                44.6108275,
                39.1620095
              ],
              [
                44.6074907,
                39.1633994
              ],
              [
                44.6069375,
                39.1633993
              ],
              [
                44.604714,
                39.1642333
              ],
              [
                44.6038812,
                39.1642333
              ],
              [
                44.6036046,
                39.1645113
              ],
              [
                44.600271,
                39.1645112
              ],
              [
                44.5991577,
                39.1642333
              ],
              [
                44.5980475,
                39.1645113
              ],
              [
                44.5974912,
                39.1642332
              ],
              [
                44.5769675,
                39.1750683
              ],
              [
                44.57669,
                39.1753463
              ],
              [
                44.5756504,
                39.1756935
              ],
              [
                44.5505769,
                39.1884036
              ],
              [
                44.5500207,
                39.1886816
              ],
              [
                44.5478011,
                39.1895156
              ],
              [
                44.5466869,
                39.1895157
              ],
              [
                44.5464104,
                39.1897937
              ],
              [
                44.5439104,
                39.1897936
              ],
              [
                44.5433541,
                39.1900717
              ],
              [
                44.5416876,
                39.1900715
              ],
              [
                44.5405775,
                39.1903497
              ],
              [
                44.5191212,
                39.1940747
              ],
              [
                44.5180111,
                39.1937967
              ],
              [
                44.5049282,
                39.1947467
              ],
              [
                44.4963184,
                39.1895393
              ],
              [
                44.4954849,
                39.1892613
              ],
              [
                44.4921519,
                39.1892613
              ],
              [
                44.4913183,
                39.1889833
              ],
              [
                44.4874284,
                39.1889833
              ],
              [
                44.4802687,
                39.190834
              ],
              [
                44.478882,
                39.1911121
              ],
              [
                44.4783249,
                39.190834
              ],
              [
                44.476935,
                39.1908339
              ],
              [
                44.4758248,
                39.1911121
              ],
              [
                44.4752686,
                39.190834
              ],
              [
                44.4674919,
                39.1908339
              ],
              [
                44.4605422,
                39.1951032
              ],
              [
                44.4594321,
                39.1948253
              ],
              [
                44.4588757,
                39.1951032
              ],
              [
                44.4558226,
                39.1948253
              ],
              [
                44.4552655,
                39.1951032
              ],
              [
                44.4494325,
                39.1951032
              ],
              [
                44.4480426,
                39.1953811
              ],
              [
                44.4424855,
                39.1953811
              ],
              [
                44.4375987,
                39.1983198
              ],
              [
                44.4331556,
                39.1983197
              ],
              [
                44.4323229,
                39.1985978
              ],
              [
                44.4287094,
                39.1985977
              ],
              [
                44.4270422,
                39.1988757
              ],
              [
                44.4217656,
                39.1988757
              ],
              [
                44.4212093,
                39.1991537
              ],
              [
                44.4187092,
                39.1991536
              ],
              [
                44.4128763,
                39.2002655
              ],
              [
                44.4114855,
                39.2002655
              ],
              [
                44.4109325,
                39.2005434
              ],
              [
                44.4087089,
                39.2008215
              ],
              [
                44.4064862,
                39.2008214
              ],
              [
                44.4056526,
                39.2010993
              ],
              [
                44.4023197,
                39.2010993
              ],
              [
                44.4014861,
                39.2013773
              ],
              [
                44.3998197,
                39.2013773
              ],
              [
                44.3989862,
                39.2016553
              ],
              [
                44.390087,
                39.2011321
              ],
              [
                44.3877981,
                39.2037836
              ],
              [
                44.3872411,
                39.2040615
              ],
              [
                44.3861316,
                39.2040616
              ],
              [
                44.3758516,
                39.2087868
              ],
              [
                44.365711,
                39.2132364
              ],
              [
                44.3558923,
                39.2188111
              ],
              [
                44.3594586,
                39.2279826
              ],
              [
                44.3591821,
                39.2282606
              ],
              [
                44.3684131,
                39.2378331
              ],
              [
                44.3684132,
                39.2381111
              ],
              [
                44.3678561,
                39.2389448
              ],
              [
                44.3725524,
                39.2455695
              ],
              [
                44.3758139,
                39.2537147
              ],
              [
                44.3744239,
                39.2567717
              ],
              [
                44.3747005,
                39.2628854
              ],
              [
                44.3724809,
                39.2676007
              ],
              [
                44.367201,
                39.2728807
              ],
              [
                44.3403981,
                39.275793
              ],
              [
                44.3398411,
                39.275793
              ],
              [
                44.3253706,
                39.2890072
              ],
              [
                44.3082045,
                39.2992366
              ],
              [
                44.2978913,
                39.2938598
              ],
              [
                44.2978844,
                39.2983909
              ],
              [
                44.2959414,
                39.3003361
              ],
              [
                44.294828,
                39.3036707
              ],
              [
                44.2942749,
                39.3047733
              ],
              [
                44.2953842,
                39.3128322
              ],
              [
                44.2956616,
                39.3133878
              ],
              [
                44.2956616,
                39.3147773
              ],
              [
                44.3043826,
                39.320689
              ],
              [
                44.3118354,
                39.3230632
              ],
              [
                44.3239973,
                39.3228781
              ],
              [
                44.3300116,
                39.3341096
              ],
              [
                44.3308452,
                39.3349344
              ],
              [
                44.3313983,
                39.336324
              ],
              [
                44.3205641,
                39.3423963
              ],
              [
                44.3148993,
                39.3514232
              ],
              [
                44.3097494,
                39.3584581
              ],
              [
                44.3103525,
                39.3692216
              ],
              [
                44.3122994,
                39.3725558
              ],
              [
                44.3128555,
                39.3728336
              ],
              [
                44.3150759,
                39.3772792
              ],
              [
                44.3153555,
                39.3867259
              ],
              [
                44.3153555,
                39.3870038
              ],
              [
                44.3156308,
                39.3900051
              ],
              [
                44.3129446,
                39.3881708
              ],
              [
                44.3127723,
                39.3877563
              ],
              [
                44.311916,
                39.3860066
              ],
              [
                44.3099415,
                39.3853241
              ],
              [
                44.3083789,
                39.3846472
              ],
              [
                44.3068785,
                39.3840827
              ],
              [
                44.3062514,
                39.3832601
              ],
              [
                44.3050078,
                39.382224
              ],
              [
                44.3039667,
                39.3816178
              ],
              [
                44.3023568,
                39.3817745
              ],
              [
                44.3020494,
                39.3815177
              ],
              [
                44.3015442,
                39.3801274
              ],
              [
                44.3007509,
                39.3792134
              ],
              [
                44.299239,
                39.3786568
              ],
              [
                44.2974309,
                39.3775431
              ],
              [
                44.2969318,
                39.3768771
              ],
              [
                44.2958781,
                39.3766005
              ],
              [
                44.294908,
                39.3765039
              ],
              [
                44.2935416,
                39.3768439
              ],
              [
                44.2917045,
                39.377817
              ],
              [
                44.2901951,
                39.377941
              ],
              [
                44.289396,
                39.3781431
              ],
              [
                44.2887722,
                39.3787326
              ],
              [
                44.2877917,
                39.3796371
              ],
              [
                44.2869063,
                39.3805124
              ],
              [
                44.286442,
                39.3813968
              ],
              [
                44.2861825,
                39.3827174
              ],
              [
                44.2854784,
                39.3835083
              ],
              [
                44.2847201,
                39.3838238
              ],
              [
                44.2842575,
                39.3837618
              ],
              [
                44.2833357,
                39.3834696
              ],
              [
                44.2826216,
                39.3833596
              ],
              [
                44.2819664,
                39.3834255
              ],
              [
                44.2805537,
                39.3837857
              ],
              [
                44.2797613,
                39.3837455
              ],
              [
                44.2788497,
                39.3834172
              ],
              [
                44.2779931,
                39.3830869
              ],
              [
                44.2774326,
                39.38317
              ],
              [
                44.2769566,
                39.3834319
              ],
              [
                44.2767312,
                39.3840978
              ],
              [
                44.2760036,
                39.3849783
              ],
              [
                44.2750886,
                39.3860483
              ],
              [
                44.273542,
                39.3880107
              ],
              [
                44.2721558,
                39.3896648
              ],
              [
                44.2716955,
                39.3900125
              ],
              [
                44.2713523,
                39.3904176
              ],
              [
                44.271084,
                39.3922967
              ],
              [
                44.2707689,
                39.3943087
              ],
              [
                44.2706818,
                39.3948011
              ],
              [
                44.2705445,
                39.3951243
              ],
              [
                44.270278,
                39.3955344
              ],
              [
                44.269748,
                39.3962113
              ],
              [
                44.2692243,
                39.3968758
              ],
              [
                44.2689562,
                39.3970852
              ],
              [
                44.2687697,
                39.397159
              ],
              [
                44.2684972,
                39.3972125
              ],
              [
                44.2678562,
                39.3972927
              ],
              [
                44.2674366,
                39.397402
              ],
              [
                44.2669334,
                39.3976337
              ],
              [
                44.2662297,
                39.3981941
              ],
              [
                44.2654284,
                39.3989037
              ],
              [
                44.2649383,
                39.3991911
              ],
              [
                44.2643388,
                39.3994229
              ],
              [
                44.2639489,
                39.3994897
              ],
              [
                44.2635546,
                39.3995309
              ],
              [
                44.2630594,
                39.3995103
              ],
              [
                44.262633,
                39.3994426
              ],
              [
                44.2622088,
                39.3993299
              ],
              [
                44.2618157,
                39.3991488
              ],
              [
                44.2607473,
                39.3984675
              ],
              [
                44.2601393,
                39.3980658
              ],
              [
                44.2598819,
                39.3979821
              ],
              [
                44.2596147,
                39.397936
              ],
              [
                44.2591498,
                39.3979852
              ],
              [
                44.258777,
                39.3981465
              ],
              [
                44.2586045,
                39.3982856
              ],
              [
                44.2584683,
                39.3984449
              ],
              [
                44.2583947,
                39.3985887
              ],
              [
                44.2583702,
                39.3986976
              ],
              [
                44.258293,
                39.3988484
              ],
              [
                44.2582174,
                39.3989536
              ],
              [
                44.2580892,
                39.3990038
              ],
              [
                44.2579209,
                39.3990076
              ],
              [
                44.2577604,
                39.3989273
              ],
              [
                44.2572832,
                39.3986393
              ],
              [
                44.2559504,
                39.3983915
              ],
              [
                44.2530673,
                39.3979347
              ],
              [
                44.2527293,
                39.3978188
              ],
              [
                44.2522959,
                39.3974861
              ],
              [
                44.2518233,
                39.3972725
              ],
              [
                44.2514416,
                39.3972906
              ],
              [
                44.2510934,
                39.3973913
              ],
              [
                44.2505081,
                39.3976779
              ],
              [
                44.2502436,
                39.3977138
              ],
              [
                44.2499365,
                39.3976819
              ],
              [
                44.2484567,
                39.3973869
              ],
              [
                44.2473324,
                39.397303
              ],
              [
                44.2468265,
                39.3974079
              ],
              [
                44.2461664,
                39.3976305
              ],
              [
                44.2447707,
                39.3985392
              ],
              [
                44.2438654,
                39.3991416
              ],
              [
                44.2435908,
                39.3993545
              ],
              [
                44.2433352,
                39.3997591
              ],
              [
                44.2432923,
                39.4013406
              ],
              [
                44.2428259,
                39.404232
              ],
              [
                44.2426966,
                39.4049227
              ],
              [
                44.2406298,
                39.4073855
              ],
              [
                44.2403878,
                39.4077729
              ],
              [
                44.2403282,
                39.4080489
              ],
              [
                44.2401844,
                39.4092887
              ],
              [
                44.2399209,
                39.409658
              ],
              [
                44.2389041,
                39.4104019
              ],
              [
                44.2368286,
                39.4111548
              ],
              [
                44.2351687,
                39.4117793
              ],
              [
                44.2342906,
                39.4122337
              ],
              [
                44.2333339,
                39.4130228
              ],
              [
                44.2331218,
                39.4155361
              ],
              [
                44.2331536,
                39.4163292
              ],
              [
                44.2320266,
                39.4164237
              ],
              [
                44.2312159,
                39.4162668
              ],
              [
                44.2306563,
                39.4161582
              ],
              [
                44.2301111,
                39.4161875
              ],
              [
                44.2296341,
                39.4163256
              ],
              [
                44.2290589,
                39.4166101
              ],
              [
                44.2281011,
                39.4171621
              ],
              [
                44.2275846,
                39.4172415
              ],
              [
                44.2269144,
                39.4172566
              ],
              [
                44.2256728,
                39.41731
              ],
              [
                44.2250722,
                39.4174256
              ],
              [
                44.223605,
                39.4179243
              ],
              [
                44.2233876,
                39.4179696
              ],
              [
                44.2231786,
                39.417943
              ],
              [
                44.2229215,
                39.4178358
              ],
              [
                44.2224854,
                39.4174982
              ],
              [
                44.2221436,
                39.4172419
              ],
              [
                44.2217102,
                39.4172114
              ],
              [
                44.2211861,
                39.4173136
              ],
              [
                44.2206828,
                39.4175296
              ],
              [
                44.2202326,
                39.4179882
              ],
              [
                44.2198858,
                39.4182696
              ],
              [
                44.2196021,
                39.4183456
              ],
              [
                44.2193185,
                39.4183365
              ],
              [
                44.2182026,
                39.4181212
              ],
              [
                44.2169357,
                39.4179957
              ],
              [
                44.2165198,
                39.4177826
              ],
              [
                44.2158069,
                39.4177766
              ],
              [
                44.2145123,
                39.4179459
              ],
              [
                44.213936,
                39.4178513
              ],
              [
                44.2132655,
                39.4175307
              ],
              [
                44.2125592,
                39.4169197
              ],
              [
                44.2120223,
                39.4164969
              ],
              [
                44.2109156,
                39.4160794
              ],
              [
                44.2102463,
                39.4158833
              ],
              [
                44.2092464,
                39.4157808
              ],
              [
                44.2072899,
                39.4156236
              ],
              [
                44.2061493,
                39.415521
              ],
              [
                44.2058039,
                39.4154869
              ],
              [
                44.2054661,
                39.415407
              ],
              [
                44.203408,
                39.4143226
              ],
              [
                44.2000334,
                39.4132972
              ],
              [
                44.1979197,
                39.412669
              ],
              [
                44.1963901,
                39.412354
              ],
              [
                44.1943353,
                39.4118492
              ],
              [
                44.1939165,
                39.4116392
              ],
              [
                44.1931144,
                39.4052312
              ],
              [
                44.1909422,
                39.4042393
              ],
              [
                44.1908097,
                39.4029354
              ],
              [
                44.1908085,
                39.4024348
              ],
              [
                44.1827202,
                39.4020374
              ],
              [
                44.1802935,
                39.4015986
              ],
              [
                44.1789396,
                39.4011691
              ],
              [
                44.1778777,
                39.4010144
              ],
              [
                44.1717562,
                39.4013771
              ],
              [
                44.1662653,
                39.4015437
              ],
              [
                44.1655176,
                39.401513
              ],
              [
                44.1608676,
                39.401978
              ],
              [
                44.1576077,
                39.4013484
              ],
              [
                44.1559325,
                39.4004921
              ],
              [
                44.1546251,
                39.3995449
              ],
              [
                44.1538581,
                39.3994769
              ],
              [
                44.1494387,
                39.3999788
              ],
              [
                44.1488243,
                39.3997267
              ],
              [
                44.1482334,
                39.3997023
              ],
              [
                44.1480733,
                39.4008448
              ],
              [
                44.1448662,
                39.4005613
              ],
              [
                44.143521,
                39.3985723
              ],
              [
                44.1434437,
                39.3979413
              ],
              [
                44.14121,
                39.3963071
              ],
              [
                44.1400666,
                39.3960355
              ],
              [
                44.1389142,
                39.3958333
              ],
              [
                44.1386752,
                39.3948742
              ],
              [
                44.1371845,
                39.3935001
              ],
              [
                44.1338167,
                39.3906255
              ],
              [
                44.1321987,
                39.3905522
              ],
              [
                44.1301405,
                39.3896441
              ],
              [
                44.1293211,
                39.3898113
              ],
              [
                44.1270754,
                39.3896175
              ],
              [
                44.1262666,
                39.3896335
              ],
              [
                44.1248874,
                39.3898497
              ],
              [
                44.1246393,
                39.3906465
              ],
              [
                44.1249102,
                39.3911926
              ],
              [
                44.1270377,
                39.3931671
              ],
              [
                44.1287635,
                39.3946515
              ],
              [
                44.1296727,
                39.3952651
              ],
              [
                44.1309018,
                39.3961389
              ],
              [
                44.1323981,
                39.3980266
              ],
              [
                44.1327798,
                39.3987149
              ],
              [
                44.1321245,
                39.4004978
              ],
              [
                44.1318776,
                39.4031489
              ],
              [
                44.1311756,
                39.4042396
              ],
              [
                44.1301049,
                39.4054092
              ],
              [
                44.1285242,
                39.4052297
              ],
              [
                44.1281218,
                39.4050724
              ],
              [
                44.1274362,
                39.4043779
              ],
              [
                44.1243311,
                39.4037598
              ],
              [
                44.1228714,
                39.4036028
              ],
              [
                44.1220588,
                39.403384
              ],
              [
                44.1203013,
                39.4025929
              ],
              [
                44.1189496,
                39.402125
              ],
              [
                44.1174275,
                39.4019447
              ],
              [
                44.1136006,
                39.4025249
              ],
              [
                44.1125533,
                39.4027912
              ],
              [
                44.1114068,
                39.4034695
              ],
              [
                44.1100823,
                39.4046265
              ],
              [
                44.1085835,
                39.4058454
              ],
              [
                44.1075039,
                39.4065032
              ],
              [
                44.10673,
                39.4068119
              ],
              [
                44.1046308,
                39.4070736
              ],
              [
                44.1030185,
                39.4073304
              ],
              [
                44.1016554,
                39.4079579
              ],
              [
                44.1005197,
                39.4087667
              ],
              [
                44.0996219,
                39.4098291
              ],
              [
                44.0987838,
                39.410966
              ],
              [
                44.0981151,
                39.4117552
              ],
              [
                44.0969923,
                39.4121726
              ],
              [
                44.0935987,
                39.4119051
              ],
              [
                44.091994,
                39.4114544
              ],
              [
                44.0905388,
                39.4113021
              ],
              [
                44.0896987,
                39.4111448
              ],
              [
                44.0886988,
                39.4107483
              ],
              [
                44.0881858,
                39.410347
              ],
              [
                44.0876883,
                39.4097048
              ],
              [
                44.0869009,
                39.4092009
              ],
              [
                44.0859146,
                39.408443
              ],
              [
                44.084893,
                39.4079112
              ],
              [
                44.0843952,
                39.4077966
              ],
              [
                44.0838507,
                39.4078471
              ],
              [
                44.0830574,
                39.4081709
              ],
              [
                44.0819513,
                39.4084225
              ],
              [
                44.0758038,
                39.4100624
              ],
              [
                44.0739102,
                39.4109307
              ],
              [
                44.0723488,
                39.411939
              ],
              [
                44.0715956,
                39.4123376
              ],
              [
                44.0710893,
                39.4123425
              ],
              [
                44.0704062,
                39.4122588
              ],
              [
                44.0698358,
                39.4119182
              ],
              [
                44.0692879,
                39.4117579
              ],
              [
                44.06792,
                39.4114852
              ],
              [
                44.0668433,
                39.4111494
              ],
              [
                44.0644875,
                39.4087944
              ],
              [
                44.0624251,
                39.4071038
              ],
              [
                44.0610559,
                39.4061815
              ],
              [
                44.0595826,
                39.405398
              ],
              [
                44.0590547,
                39.4052676
              ],
              [
                44.0581981,
                39.4052909
              ],
              [
                44.0554382,
                39.4060961
              ],
              [
                44.0538207,
                39.4060362
              ],
              [
                44.0523477,
                39.4052677
              ],
              [
                44.0513157,
                39.4040585
              ],
              [
                44.0511439,
                39.4030519
              ],
              [
                44.0514161,
                39.402373
              ],
              [
                44.0517256,
                39.4010157
              ],
              [
                44.0517798,
                39.3995253
              ],
              [
                44.0514869,
                39.398249
              ],
              [
                44.0523035,
                39.396947
              ],
              [
                44.0528523,
                39.3959429
              ],
              [
                44.052997,
                39.3952493
              ],
              [
                44.0537298,
                39.3941858
              ],
              [
                44.0545327,
                39.3932451
              ],
              [
                44.0549658,
                39.392323
              ],
              [
                44.0560266,
                39.3904619
              ],
              [
                44.057068,
                39.3883787
              ],
              [
                44.0579604,
                39.3861475
              ],
              [
                44.0578682,
                39.3861109
              ],
              [
                44.0570564,
                39.3865655
              ],
              [
                44.0557251,
                39.3876695
              ],
              [
                44.0547524,
                39.3888067
              ],
              [
                44.0545768,
                39.3889121
              ],
              [
                44.0544011,
                39.3889311
              ],
              [
                44.0538417,
                39.388806
              ],
              [
                44.052965,
                39.3882865
              ],
              [
                44.0517635,
                39.3874097
              ],
              [
                44.0493931,
                39.3864031
              ],
              [
                44.0461135,
                39.3855264
              ],
              [
                44.0441327,
                39.3846821
              ],
              [
                44.0427039,
                39.3841626
              ],
              [
                44.0412102,
                39.3822792
              ],
              [
                44.0406257,
                39.3817597
              ],
              [
                44.0400088,
                39.380201
              ],
              [
                44.0396191,
                39.3798763
              ],
              [
                44.0382553,
                39.3794866
              ],
              [
                44.0377682,
                39.3791944
              ],
              [
                44.0363394,
                39.3778955
              ],
              [
                44.0348457,
                39.3777656
              ],
              [
                44.0342937,
                39.3775058
              ],
              [
                44.0340664,
                39.3769538
              ],
              [
                44.0335793,
                39.3752004
              ],
              [
                44.0327351,
                39.3727325
              ],
              [
                44.0318908,
                39.3717259
              ],
              [
                44.0320532,
                39.3710115
              ],
              [
                44.0328,
                39.3699399
              ],
              [
                44.0341963,
                39.3688034
              ],
              [
                44.0352679,
                39.3680241
              ],
              [
                44.0367616,
                39.3671473
              ],
              [
                44.0369564,
                39.3667577
              ],
              [
                44.0371837,
                39.3660433
              ],
              [
                44.0376058,
                39.3624714
              ],
              [
                44.0377009,
                39.3612643
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554877,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ارومیه",
          "name:en": "Urumia County",
          "name:ku": "Ûrmiye",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q115275",
          "wikipedia": "en:Urmia County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.4048998,
                37.8447814
              ],
              [
                44.404707,
                37.844295
              ],
              [
                44.404614,
                37.8431
              ],
              [
                44.404521,
                37.842467
              ],
              [
                44.404335,
                37.841553
              ],
              [
                44.404242,
                37.840955
              ],
              [
                44.403777,
                37.840287
              ],
              [
                44.402846,
                37.839794
              ],
              [
                44.401776,
                37.839232
              ],
              [
                44.400752,
                37.838774
              ],
              [
                44.399589,
                37.838388
              ],
              [
                44.398379,
                37.838071
              ],
              [
                44.397542,
                37.838106
              ],
              [
                44.396797,
                37.837895
              ],
              [
                44.396146,
                37.837227
              ],
              [
                44.396006,
                37.836453
              ],
              [
                44.395681,
                37.836067
              ],
              [
                44.395541,
                37.835574
              ],
              [
                44.395122,
                37.834801
              ],
              [
                44.394983,
                37.834238
              ],
              [
                44.394331,
                37.833359
              ],
              [
                44.393587,
                37.83262
              ],
              [
                44.393447,
                37.832058
              ],
              [
                44.392935,
                37.831319
              ],
              [
                44.3925478,
                37.8301485
              ],
              [
                44.3925669,
                37.8290511
              ],
              [
                44.3924171,
                37.8284697
              ],
              [
                44.3922192,
                37.8278824
              ],
              [
                44.3924159,
                37.8273688
              ],
              [
                44.3931264,
                37.8268943
              ],
              [
                44.3934248,
                37.8265106
              ],
              [
                44.3935075,
                37.8261405
              ],
              [
                44.3934205,
                37.8256028
              ],
              [
                44.3933921,
                37.8250241
              ],
              [
                44.3932684,
                37.8245706
              ],
              [
                44.3934623,
                37.8240503
              ],
              [
                44.3944467,
                37.8230608
              ],
              [
                44.3956299,
                37.8221307
              ],
              [
                44.3969467,
                37.8209544
              ],
              [
                44.3974823,
                37.8205652
              ],
              [
                44.3989227,
                37.8206035
              ],
              [
                44.4004354,
                37.8204366
              ],
              [
                44.401686,
                37.8199007
              ],
              [
                44.4025149,
                37.8197612
              ],
              [
                44.4043093,
                37.8198346
              ],
              [
                44.4056334,
                37.8195287
              ],
              [
                44.4066197,
                37.8192865
              ],
              [
                44.4078852,
                37.8185394
              ],
              [
                44.4092224,
                37.8181428
              ],
              [
                44.4107619,
                37.8172602
              ],
              [
                44.412215,
                37.8168567
              ],
              [
                44.413384,
                37.8163314
              ],
              [
                44.4141334,
                37.8160567
              ],
              [
                44.4148019,
                37.8156397
              ],
              [
                44.4152585,
                37.814641
              ],
              [
                44.415518,
                37.8131503
              ],
              [
                44.4155247,
                37.811971
              ],
              [
                44.4153661,
                37.8105631
              ],
              [
                44.4159001,
                37.8094889
              ],
              [
                44.4163517,
                37.8085692
              ],
              [
                44.4171576,
                37.8081069
              ],
              [
                44.4177543,
                37.8074854
              ],
              [
                44.4181325,
                37.8067857
              ],
              [
                44.4178785,
                37.8061472
              ],
              [
                44.4180879,
                37.8058291
              ],
              [
                44.418715,
                37.8055069
              ],
              [
                44.420041,
                37.8051422
              ],
              [
                44.4211529,
                37.8046963
              ],
              [
                44.4215712,
                37.8043708
              ],
              [
                44.422668,
                37.8030473
              ],
              [
                44.4228699,
                37.801589
              ],
              [
                44.4232134,
                37.8005091
              ],
              [
                44.4237529,
                37.799449
              ],
              [
                44.4267568,
                37.7985551
              ],
              [
                44.4297506,
                37.7987169
              ],
              [
                44.4341642,
                37.799634
              ],
              [
                44.4352886,
                37.800081
              ],
              [
                44.4360882,
                37.800841
              ],
              [
                44.4375481,
                37.80121
              ],
              [
                44.4389886,
                37.8019965
              ],
              [
                44.4403043,
                37.8026447
              ],
              [
                44.4418263,
                37.8035519
              ],
              [
                44.4430745,
                37.8041214
              ],
              [
                44.443992,
                37.8044527
              ],
              [
                44.4451202,
                37.8047179
              ],
              [
                44.446124,
                37.8051775
              ],
              [
                44.4469895,
                37.8060507
              ],
              [
                44.4476672,
                37.8064946
              ],
              [
                44.4483769,
                37.8065854
              ],
              [
                44.4485201,
                37.8059285
              ],
              [
                44.4485576,
                37.8053915
              ],
              [
                44.4484716,
                37.8046688
              ],
              [
                44.4481367,
                37.8036523
              ],
              [
                44.4475991,
                37.801504
              ],
              [
                44.447482,
                37.8001362
              ],
              [
                44.4475246,
                37.7986552
              ],
              [
                44.4478726,
                37.7971227
              ],
              [
                44.4480946,
                37.7955326
              ],
              [
                44.4481538,
                37.7930256
              ],
              [
                44.4487591,
                37.7910496
              ],
              [
                44.4494277,
                37.7891669
              ],
              [
                44.4499336,
                37.7875453
              ],
              [
                44.4499409,
                37.785845
              ],
              [
                44.4488441,
                37.7826861
              ],
              [
                44.4485122,
                37.782364
              ],
              [
                44.4476167,
                37.7820174
              ],
              [
                44.4463519,
                37.7804514
              ],
              [
                44.4456478,
                37.7797004
              ],
              [
                44.4449358,
                37.7790332
              ],
              [
                44.4439677,
                37.7777237
              ],
              [
                44.4434252,
                37.7767146
              ],
              [
                44.4431344,
                37.7746622
              ],
              [
                44.443249,
                37.7738307
              ],
              [
                44.4437504,
                37.773121
              ],
              [
                44.4445613,
                37.7713546
              ],
              [
                44.4449506,
                37.7709171
              ],
              [
                44.4464046,
                37.7703974
              ],
              [
                44.4473869,
                37.7703097
              ],
              [
                44.4491856,
                37.7697901
              ],
              [
                44.4497978,
                37.7694201
              ],
              [
                44.4501122,
                37.7690403
              ],
              [
                44.4503824,
                37.7685102
              ],
              [
                44.4508027,
                37.767866
              ],
              [
                44.4512075,
                37.767497
              ],
              [
                44.4515629,
                37.7673399
              ],
              [
                44.4524826,
                37.7666873
              ],
              [
                44.4531248,
                37.7666916
              ],
              [
                44.4535933,
                37.7665113
              ],
              [
                44.4547658,
                37.7668572
              ],
              [
                44.4559734,
                37.7669254
              ],
              [
                44.4580229,
                37.7671354
              ],
              [
                44.4595272,
                37.7665937
              ],
              [
                44.4606845,
                37.766022
              ],
              [
                44.4623158,
                37.7657452
              ],
              [
                44.4633685,
                37.7654284
              ],
              [
                44.4647051,
                37.7656321
              ],
              [
                44.4650471,
                37.7654715
              ],
              [
                44.4656627,
                37.765338
              ],
              [
                44.4664549,
                37.7654798
              ],
              [
                44.4668178,
                37.7657022
              ],
              [
                44.4681731,
                37.7649158
              ],
              [
                44.4696336,
                37.7645003
              ],
              [
                44.471106,
                37.7644259
              ],
              [
                44.4715484,
                37.7642783
              ],
              [
                44.471978,
                37.7639285
              ],
              [
                44.4723466,
                37.7638134
              ],
              [
                44.4727237,
                37.7638062
              ],
              [
                44.4736524,
                37.764568
              ],
              [
                44.4739962,
                37.7649172
              ],
              [
                44.4741947,
                37.7652609
              ],
              [
                44.4742159,
                37.7656891
              ],
              [
                44.4744698,
                37.7663803
              ],
              [
                44.4754947,
                37.7673453
              ],
              [
                44.4761814,
                37.76843
              ],
              [
                44.4766481,
                37.7694669
              ],
              [
                44.4774346,
                37.7703729
              ],
              [
                44.4778796,
                37.7708061
              ],
              [
                44.4794745,
                37.771465
              ],
              [
                44.4802692,
                37.7717443
              ],
              [
                44.4807239,
                37.7718249
              ],
              [
                44.4816381,
                37.7718236
              ],
              [
                44.4827539,
                37.7717258
              ],
              [
                44.4835725,
                37.7715757
              ],
              [
                44.4840809,
                37.7715732
              ],
              [
                44.4849525,
                37.7716553
              ],
              [
                44.4859088,
                37.7716132
              ],
              [
                44.4867754,
                37.7714167
              ],
              [
                44.4875189,
                37.771059
              ],
              [
                44.4879001,
                37.7709783
              ],
              [
                44.4884486,
                37.7710658
              ],
              [
                44.4890656,
                37.7710487
              ],
              [
                44.4909464,
                37.7707159
              ],
              [
                44.4915339,
                37.7706817
              ],
              [
                44.4919142,
                37.7705902
              ],
              [
                44.4926197,
                37.7706988
              ],
              [
                44.4939492,
                37.7704602
              ],
              [
                44.4944304,
                37.7708506
              ],
              [
                44.4951891,
                37.7720262
              ],
              [
                44.4956791,
                37.7721409
              ],
              [
                44.4961318,
                37.7728203
              ],
              [
                44.4968327,
                37.7732489
              ],
              [
                44.4979236,
                37.773743
              ],
              [
                44.4987813,
                37.7739174
              ],
              [
                44.4995607,
                37.7741348
              ],
              [
                44.501882,
                37.7745658
              ],
              [
                44.5034804,
                37.7747282
              ],
              [
                44.5061454,
                37.7751358
              ],
              [
                44.5070515,
                37.7751389
              ],
              [
                44.5077062,
                37.7752126
              ],
              [
                44.5097547,
                37.7758173
              ],
              [
                44.5108444,
                37.7757055
              ],
              [
                44.5121279,
                37.7753949
              ],
              [
                44.5125114,
                37.7753761
              ],
              [
                44.5131507,
                37.7754727
              ],
              [
                44.5177444,
                37.7767431
              ],
              [
                44.5183055,
                37.7770715
              ],
              [
                44.5186835,
                37.7775018
              ],
              [
                44.5189362,
                37.7781676
              ],
              [
                44.5189588,
                37.7793476
              ],
              [
                44.5190809,
                37.7800022
              ],
              [
                44.5193388,
                37.780246
              ],
              [
                44.5219152,
                37.7806139
              ],
              [
                44.5229768,
                37.7807237
              ],
              [
                44.5232938,
                37.7809699
              ],
              [
                44.5236644,
                37.7815943
              ],
              [
                44.5243923,
                37.7820804
              ],
              [
                44.527361,
                37.7827882
              ],
              [
                44.5290991,
                37.7829264
              ],
              [
                44.5297959,
                37.783025
              ],
              [
                44.5303121,
                37.7830167
              ],
              [
                44.5321572,
                37.7824294
              ],
              [
                44.5327203,
                37.782195
              ],
              [
                44.5331755,
                37.7817897
              ],
              [
                44.5336449,
                37.7815797
              ],
              [
                44.5346953,
                37.7814654
              ],
              [
                44.5354304,
                37.7814458
              ],
              [
                44.5376989,
                37.7819237
              ],
              [
                44.5387141,
                37.7818806
              ],
              [
                44.5396909,
                37.7819978
              ],
              [
                44.5401907,
                37.7819577
              ],
              [
                44.5423797,
                37.781155
              ],
              [
                44.5449136,
                37.7799974
              ],
              [
                44.5454574,
                37.7798477
              ],
              [
                44.5469424,
                37.7797383
              ],
              [
                44.5473163,
                37.7795998
              ],
              [
                44.5482032,
                37.7795088
              ],
              [
                44.5485862,
                37.7794856
              ],
              [
                44.5494225,
                37.7797722
              ],
              [
                44.5497219,
                37.7799648
              ],
              [
                44.550067,
                37.7803667
              ],
              [
                44.5511457,
                37.7806645
              ],
              [
                44.5516024,
                37.7807181
              ],
              [
                44.5525223,
                37.7806126
              ],
              [
                44.5545718,
                37.7806258
              ],
              [
                44.5549506,
                37.7805011
              ],
              [
                44.5552305,
                37.780316
              ],
              [
                44.5557669,
                37.7798446
              ],
              [
                44.5573149,
                37.7794383
              ],
              [
                44.5585912,
                37.7784263
              ],
              [
                44.5597469,
                37.777611
              ],
              [
                44.5601676,
                37.777149
              ],
              [
                44.5618504,
                37.7760868
              ],
              [
                44.5624795,
                37.7755104
              ],
              [
                44.5631295,
                37.7745934
              ],
              [
                44.5633371,
                37.7739951
              ],
              [
                44.5633364,
                37.7734603
              ],
              [
                44.563469,
                37.7726022
              ],
              [
                44.5636311,
                37.7720086
              ],
              [
                44.5639154,
                37.7716207
              ],
              [
                44.5645777,
                37.7712332
              ],
              [
                44.5655667,
                37.7708534
              ],
              [
                44.5665214,
                37.7705775
              ],
              [
                44.5671671,
                37.7702795
              ],
              [
                44.5677934,
                37.7697706
              ],
              [
                44.5682828,
                37.7692511
              ],
              [
                44.5685997,
                37.7688077
              ],
              [
                44.5688962,
                37.7687287
              ],
              [
                44.5697865,
                37.7687952
              ],
              [
                44.5703298,
                37.7687566
              ],
              [
                44.5713371,
                37.7684378
              ],
              [
                44.5717476,
                37.7682613
              ],
              [
                44.572178,
                37.7680009
              ],
              [
                44.5724209,
                37.7677357
              ],
              [
                44.5725075,
                37.7675559
              ],
              [
                44.5726169,
                37.7674899
              ],
              [
                44.5737363,
                37.7676022
              ],
              [
                44.5742453,
                37.7675436
              ],
              [
                44.5747994,
                37.7672928
              ],
              [
                44.5752975,
                37.7667859
              ],
              [
                44.575636,
                37.7665408
              ],
              [
                44.5765023,
                37.7663755
              ],
              [
                44.5770406,
                37.7663454
              ],
              [
                44.5773648,
                37.7662706
              ],
              [
                44.5785483,
                37.7653339
              ],
              [
                44.5787312,
                37.765327
              ],
              [
                44.579073,
                37.765615
              ],
              [
                44.5793481,
                37.7656935
              ],
              [
                44.5796846,
                37.765697
              ],
              [
                44.5806977,
                37.7655378
              ],
              [
                44.5814141,
                37.7655201
              ],
              [
                44.583,
                37.7657225
              ],
              [
                44.584134,
                37.7656567
              ],
              [
                44.5860287,
                37.7647075
              ],
              [
                44.5870796,
                37.7640076
              ],
              [
                44.5878635,
                37.7633638
              ],
              [
                44.5886025,
                37.7616143
              ],
              [
                44.5892092,
                37.7594669
              ],
              [
                44.5898972,
                37.7576961
              ],
              [
                44.5907234,
                37.7562653
              ],
              [
                44.5919432,
                37.7547516
              ],
              [
                44.5925563,
                37.7536797
              ],
              [
                44.5935879,
                37.7512214
              ],
              [
                44.5936098,
                37.75008
              ],
              [
                44.5947731,
                37.7478413
              ],
              [
                44.5967705,
                37.7463707
              ],
              [
                44.5971875,
                37.7458878
              ],
              [
                44.5992262,
                37.7453198
              ],
              [
                44.5999247,
                37.7449919
              ],
              [
                44.6005231,
                37.7446308
              ],
              [
                44.6008718,
                37.7440604
              ],
              [
                44.6012459,
                37.7437054
              ],
              [
                44.6013855,
                37.7431493
              ],
              [
                44.6019304,
                37.7425615
              ],
              [
                44.6022572,
                37.7417689
              ],
              [
                44.6023269,
                37.7409194
              ],
              [
                44.602782,
                37.7402396
              ],
              [
                44.6036635,
                37.7399393
              ],
              [
                44.6044212,
                37.7397514
              ],
              [
                44.6058759,
                37.7395669
              ],
              [
                44.606718,
                37.7392278
              ],
              [
                44.6074088,
                37.7387596
              ],
              [
                44.6083354,
                37.7365759
              ],
              [
                44.6088955,
                37.735641
              ],
              [
                44.6091983,
                37.7346289
              ],
              [
                44.6104113,
                37.7328991
              ],
              [
                44.6110145,
                37.7324384
              ],
              [
                44.6128243,
                37.7322739
              ],
              [
                44.6143049,
                37.7318023
              ],
              [
                44.615314,
                37.7314294
              ],
              [
                44.6162024,
                37.7309029
              ],
              [
                44.6164108,
                37.7307055
              ],
              [
                44.6166192,
                37.7302119
              ],
              [
                44.6193941,
                37.7282047
              ],
              [
                44.6193612,
                37.7278976
              ],
              [
                44.620469,
                37.7271957
              ],
              [
                44.6206225,
                37.7270202
              ],
              [
                44.6207103,
                37.7264718
              ],
              [
                44.6205019,
                37.7258466
              ],
              [
                44.6206225,
                37.7250021
              ],
              [
                44.6202825,
                37.7241027
              ],
              [
                44.6205787,
                37.7224246
              ],
              [
                44.6216755,
                37.7203626
              ],
              [
                44.6216316,
                37.7197264
              ],
              [
                44.6216865,
                37.7195071
              ],
              [
                44.6216316,
                37.7192438
              ],
              [
                44.6212279,
                37.7189042
              ],
              [
                44.6211367,
                37.7187112
              ],
              [
                44.6215181,
                37.7181517
              ],
              [
                44.6224109,
                37.7166994
              ],
              [
                44.6233483,
                37.7126811
              ],
              [
                44.6241474,
                37.7102333
              ],
              [
                44.6248199,
                37.7089654
              ],
              [
                44.6259479,
                37.7078567
              ],
              [
                44.6281587,
                37.7071094
              ],
              [
                44.6304124,
                37.7063482
              ],
              [
                44.6289669,
                37.7044789
              ],
              [
                44.628506,
                37.7030473
              ],
              [
                44.6281868,
                37.7028096
              ],
              [
                44.6280768,
                37.7021432
              ],
              [
                44.6274143,
                37.701583
              ],
              [
                44.6273258,
                37.7011649
              ],
              [
                44.6270174,
                37.7010779
              ],
              [
                44.6269793,
                37.7006969
              ],
              [
                44.6258221,
                37.7000856
              ],
              [
                44.6247287,
                37.6981466
              ],
              [
                44.623504,
                37.6971719
              ],
              [
                44.6233258,
                37.6966237
              ],
              [
                44.6224354,
                37.6959735
              ],
              [
                44.621591,
                37.6949664
              ],
              [
                44.6199417,
                37.6936097
              ],
              [
                44.619211,
                37.6929946
              ],
              [
                44.6183598,
                37.6919013
              ],
              [
                44.6176745,
                37.6915356
              ],
              [
                44.617318,
                37.6910153
              ],
              [
                44.6173278,
                37.6906911
              ],
              [
                44.6172028,
                37.6904321
              ],
              [
                44.6143388,
                37.688934
              ],
              [
                44.6135129,
                37.6888208
              ],
              [
                44.6124706,
                37.6882132
              ],
              [
                44.611611,
                37.6877385
              ],
              [
                44.6110747,
                37.6877401
              ],
              [
                44.6108787,
                37.6871438
              ],
              [
                44.6097391,
                37.6862204
              ],
              [
                44.6083566,
                37.6853896
              ],
              [
                44.6075937,
                37.6849271
              ],
              [
                44.6067777,
                37.6844443
              ],
              [
                44.6059677,
                37.6836953
              ],
              [
                44.6049169,
                37.6821727
              ],
              [
                44.6034059,
                37.6806131
              ],
              [
                44.6027067,
                37.6800965
              ],
              [
                44.6006822,
                37.6794074
              ],
              [
                44.5991259,
                37.6782223
              ],
              [
                44.5976419,
                37.6771439
              ],
              [
                44.5967813,
                37.6769914
              ],
              [
                44.5963192,
                37.6768663
              ],
              [
                44.5957719,
                37.6767779
              ],
              [
                44.5937478,
                37.6756226
              ],
              [
                44.591811,
                37.6758048
              ],
              [
                44.5910324,
                37.6757111
              ],
              [
                44.5907018,
                37.6750488
              ],
              [
                44.5902063,
                37.6736546
              ],
              [
                44.5900308,
                37.6726081
              ],
              [
                44.589563,
                37.671031
              ],
              [
                44.588167,
                37.670398
              ],
              [
                44.586259,
                37.670011
              ],
              [
                44.584957,
                37.669659
              ],
              [
                44.583561,
                37.669343
              ],
              [
                44.58263,
                37.669062
              ],
              [
                44.581932,
                37.668956
              ],
              [
                44.58156,
                37.668569
              ],
              [
                44.580397,
                37.668288
              ],
              [
                44.578117,
                37.667866
              ],
              [
                44.576582,
                37.667198
              ],
              [
                44.574348,
                37.665861
              ],
              [
                44.574116,
                37.665053
              ],
              [
                44.574022,
                37.663752
              ],
              [
                44.574209,
                37.663013
              ],
              [
                44.574209,
                37.66245
              ],
              [
                44.574116,
                37.661642
              ],
              [
                44.574348,
                37.660833
              ],
              [
                44.574441,
                37.660024
              ],
              [
                44.574395,
                37.658371
              ],
              [
                44.574162,
                37.657633
              ],
              [
                44.573371,
                37.656648
              ],
              [
                44.572627,
                37.65591
              ],
              [
                44.572534,
                37.655312
              ],
              [
                44.571789,
                37.654292
              ],
              [
                44.571463,
                37.652604
              ],
              [
                44.570998,
                37.651795
              ],
              [
                44.570672,
                37.650846
              ],
              [
                44.570114,
                37.650107
              ],
              [
                44.568904,
                37.647329
              ],
              [
                44.568765,
                37.646309
              ],
              [
                44.56816,
                37.644762
              ],
              [
                44.568113,
                37.642828
              ],
              [
                44.5683,
                37.641773
              ],
              [
                44.568625,
                37.640894
              ],
              [
                44.569602,
                37.639522
              ],
              [
                44.5706964,
                37.6391306
              ],
              [
                44.5715627,
                37.6383411
              ],
              [
                44.5730314,
                37.6374982
              ],
              [
                44.5737834,
                37.6372754
              ],
              [
                44.5745968,
                37.6373697
              ],
              [
                44.5765518,
                37.637922
              ],
              [
                44.5775965,
                37.6379892
              ],
              [
                44.5792172,
                37.6377769
              ],
              [
                44.5809446,
                37.6373944
              ],
              [
                44.5822722,
                37.635982
              ],
              [
                44.5827337,
                37.6349322
              ],
              [
                44.5830036,
                37.6335444
              ],
              [
                44.5831286,
                37.6319788
              ],
              [
                44.5833253,
                37.6313572
              ],
              [
                44.5838301,
                37.6306163
              ],
              [
                44.5847476,
                37.6298665
              ],
              [
                44.5855538,
                37.628977
              ],
              [
                44.5862092,
                37.6273421
              ],
              [
                44.5871749,
                37.6257762
              ],
              [
                44.5889636,
                37.6242575
              ],
              [
                44.589981,
                37.6232213
              ],
              [
                44.5911854,
                37.6220932
              ],
              [
                44.5920888,
                37.6208426
              ],
              [
                44.5928412,
                37.6191619
              ],
              [
                44.5932365,
                37.617728
              ],
              [
                44.5939256,
                37.6170041
              ],
              [
                44.5952714,
                37.6162937
              ],
              [
                44.5964007,
                37.6162403
              ],
              [
                44.5973886,
                37.6167937
              ],
              [
                44.5987162,
                37.6171827
              ],
              [
                44.6001412,
                37.6167702
              ],
              [
                44.6017983,
                37.6154614
              ],
              [
                44.6044075,
                37.613057
              ],
              [
                44.605249,
                37.6124524
              ],
              [
                44.6063954,
                37.6119351
              ],
              [
                44.606499,
                37.611671
              ],
              [
                44.606778,
                37.61139
              ],
              [
                44.607569,
                37.610862
              ],
              [
                44.607057,
                37.60942
              ],
              [
                44.607662,
                37.608928
              ],
              [
                44.607988,
                37.608084
              ],
              [
                44.608686,
                37.607627
              ],
              [
                44.610175,
                37.605974
              ],
              [
                44.610873,
                37.605447
              ],
              [
                44.611384,
                37.60513
              ],
              [
                44.612408,
                37.604743
              ],
              [
                44.612873,
                37.604321
              ],
              [
                44.613897,
                37.603161
              ],
              [
                44.614409,
                37.602176
              ],
              [
                44.614455,
                37.600629
              ],
              [
                44.614083,
                37.599855
              ],
              [
                44.613525,
                37.599011
              ],
              [
                44.613059,
                37.597499
              ],
              [
                44.612827,
                37.596972
              ],
              [
                44.612268,
                37.596057
              ],
              [
                44.611989,
                37.594897
              ],
              [
                44.611989,
                37.592787
              ],
              [
                44.612222,
                37.592365
              ],
              [
                44.612408,
                37.591873
              ],
              [
                44.612082,
                37.590958
              ],
              [
                44.6120546,
                37.5903736
              ],
              [
                44.6115803,
                37.589518
              ],
              [
                44.6107332,
                37.5882625
              ],
              [
                44.6091733,
                37.5865513
              ],
              [
                44.6074879,
                37.5855594
              ],
              [
                44.6060497,
                37.5845371
              ],
              [
                44.6038468,
                37.5835551
              ],
              [
                44.6009847,
                37.5827075
              ],
              [
                44.5989035,
                37.580766
              ],
              [
                44.5999845,
                37.5791098
              ],
              [
                44.6004876,
                37.5784965
              ],
              [
                44.6011461,
                37.5782327
              ],
              [
                44.6012878,
                37.577706
              ],
              [
                44.6018722,
                37.5769611
              ],
              [
                44.6023151,
                37.5766007
              ],
              [
                44.602757,
                37.5765437
              ],
              [
                44.6037939,
                37.5768917
              ],
              [
                44.604764,
                37.5768214
              ],
              [
                44.6051803,
                37.5768437
              ],
              [
                44.6059682,
                37.576717
              ],
              [
                44.6062889,
                37.5762491
              ],
              [
                44.6065967,
                37.5759748
              ],
              [
                44.6075562,
                37.5757073
              ],
              [
                44.6079368,
                37.575226
              ],
              [
                44.6080607,
                37.574855
              ],
              [
                44.6090059,
                37.5741582
              ],
              [
                44.6095208,
                37.5734767
              ],
              [
                44.6101261,
                37.573115
              ],
              [
                44.6109984,
                37.572296
              ],
              [
                44.6119794,
                37.5719628
              ],
              [
                44.6128461,
                37.5713523
              ],
              [
                44.6128495,
                37.5710973
              ],
              [
                44.61067,
                37.570843
              ],
              [
                44.609555,
                37.570967
              ],
              [
                44.608767,
                37.570942
              ],
              [
                44.608267,
                37.570738
              ],
              [
                44.607988,
                37.570351
              ],
              [
                44.607941,
                37.57
              ],
              [
                44.608276,
                37.569653
              ],
              [
                44.608593,
                37.569472
              ],
              [
                44.608964,
                37.569158
              ],
              [
                44.609337,
                37.568734
              ],
              [
                44.60943,
                37.568382
              ],
              [
                44.610047,
                37.56772
              ],
              [
                44.6105,
                37.567714
              ],
              [
                44.610873,
                37.567257
              ],
              [
                44.611338,
                37.56694
              ],
              [
                44.611752,
                37.56658
              ],
              [
                44.612703,
                37.566505
              ],
              [
                44.613246,
                37.566588
              ],
              [
                44.613664,
                37.566483
              ],
              [
                44.613943,
                37.56592
              ],
              [
                44.6142351,
                37.5654695
              ],
              [
                44.6143026,
                37.5649391
              ],
              [
                44.613998,
                37.5639997
              ],
              [
                44.6132202,
                37.5634829
              ],
              [
                44.6128748,
                37.5624509
              ],
              [
                44.6127572,
                37.5619157
              ],
              [
                44.6123769,
                37.5616599
              ],
              [
                44.6119371,
                37.5612944
              ],
              [
                44.6113955,
                37.5613465
              ],
              [
                44.6110825,
                37.5616228
              ],
              [
                44.610243,
                37.56182
              ],
              [
                44.609784,
                37.56182
              ],
              [
                44.6095931,
                37.5616583
              ],
              [
                44.609325,
                37.561201
              ],
              [
                44.6088784,
                37.5606555
              ],
              [
                44.6081058,
                37.5603528
              ],
              [
                44.6072489,
                37.5598485
              ],
              [
                44.606209,
                37.56006
              ],
              [
                44.6056736,
                37.5600206
              ],
              [
                44.6051854,
                37.5597716
              ],
              [
                44.6047958,
                37.5598201
              ],
              [
                44.6040823,
                37.560329
              ],
              [
                44.6036565,
                37.5602937
              ],
              [
                44.602922,
                37.5600387
              ],
              [
                44.6025968,
                37.559819
              ],
              [
                44.6026639,
                37.5589784
              ],
              [
                44.6026268,
                37.5583765
              ],
              [
                44.601782,
                37.557458
              ],
              [
                44.6015647,
                37.5571076
              ],
              [
                44.6013139,
                37.5566178
              ],
              [
                44.6012501,
                37.5560898
              ],
              [
                44.6013714,
                37.554896
              ],
              [
                44.6017877,
                37.554283
              ],
              [
                44.6017727,
                37.5538591
              ],
              [
                44.602372,
                37.553392
              ],
              [
                44.602823,
                37.553436
              ],
              [
                44.603289,
                37.553331
              ],
              [
                44.603568,
                37.552663
              ],
              [
                44.603815,
                37.552252
              ],
              [
                44.604219,
                37.55203
              ],
              [
                44.604766,
                37.55131
              ],
              [
                44.6049598,
                37.5510006
              ],
              [
                44.6058612,
                37.5503942
              ],
              [
                44.6065693,
                37.5501202
              ],
              [
                44.6071822,
                37.5497659
              ],
              [
                44.6079562,
                37.5495037
              ],
              [
                44.6085701,
                37.5495148
              ],
              [
                44.6092636,
                37.5496785
              ],
              [
                44.610161,
                37.549835
              ],
              [
                44.6107219,
                37.5498721
              ],
              [
                44.6113237,
                37.5499082
              ],
              [
                44.6120182,
                37.549867
              ],
              [
                44.612406,
                37.5496616
              ],
              [
                44.6129374,
                37.5489605
              ],
              [
                44.6132991,
                37.5485128
              ],
              [
                44.6136502,
                37.5480422
              ],
              [
                44.6137887,
                37.5476266
              ],
              [
                44.6136796,
                37.5471958
              ],
              [
                44.6134156,
                37.546853
              ],
              [
                44.6133652,
                37.5465548
              ],
              [
                44.6136062,
                37.5457821
              ],
              [
                44.613618,
                37.5454054
              ],
              [
                44.6129882,
                37.5446882
              ],
              [
                44.6124471,
                37.5442818
              ],
              [
                44.6104966,
                37.5437377
              ],
              [
                44.6102737,
                37.5435572
              ],
              [
                44.60992,
                37.543133
              ],
              [
                44.6100475,
                37.5429076
              ],
              [
                44.610407,
                37.5425
              ],
              [
                44.6105,
                37.542219
              ],
              [
                44.6107365,
                37.5420116
              ],
              [
                44.6108469,
                37.5416015
              ],
              [
                44.6104997,
                37.541187
              ],
              [
                44.6103106,
                37.5409905
              ],
              [
                44.6093188,
                37.5406102
              ],
              [
                44.608259,
                37.539821
              ],
              [
                44.607144,
                37.539474
              ],
              [
                44.607029,
                37.539114
              ],
              [
                44.606964,
                37.538315
              ],
              [
                44.607197,
                37.538104
              ],
              [
                44.607243,
                37.537612
              ],
              [
                44.607144,
                37.536648
              ],
              [
                44.606499,
                37.535396
              ],
              [
                44.606359,
                37.534834
              ],
              [
                44.606313,
                37.533603
              ],
              [
                44.606127,
                37.53304
              ],
              [
                44.606127,
                37.532091
              ],
              [
                44.605755,
                37.531704
              ],
              [
                44.605615,
                37.531458
              ],
              [
                44.605615,
                37.531247
              ],
              [
                44.605382,
                37.530825
              ],
              [
                44.605357,
                37.530314
              ],
              [
                44.60516,
                37.529818
              ],
              [
                44.604865,
                37.52957
              ],
              [
                44.604638,
                37.529278
              ],
              [
                44.604701,
                37.528405
              ],
              [
                44.604307,
                37.52791
              ],
              [
                44.603586,
                37.527662
              ],
              [
                44.602634,
                37.526645
              ],
              [
                44.60247,
                37.525852
              ],
              [
                44.602208,
                37.525282
              ],
              [
                44.601913,
                37.524786
              ],
              [
                44.601474,
                37.524249
              ],
              [
                44.601421,
                37.523621
              ],
              [
                44.601159,
                37.522927
              ],
              [
                44.601288,
                37.522174
              ],
              [
                44.601846,
                37.5214
              ],
              [
                44.601986,
                37.520767
              ],
              [
                44.602125,
                37.519677
              ],
              [
                44.602079,
                37.519115
              ],
              [
                44.6018,
                37.518482
              ],
              [
                44.601893,
                37.517919
              ],
              [
                44.601765,
                37.517512
              ],
              [
                44.601009,
                37.517286
              ],
              [
                44.601175,
                37.51667
              ],
              [
                44.601126,
                37.51616
              ],
              [
                44.600798,
                37.515491
              ],
              [
                44.601027,
                37.515119
              ],
              [
                44.601519,
                37.514722
              ],
              [
                44.601454,
                37.514202
              ],
              [
                44.600798,
                37.513755
              ],
              [
                44.600273,
                37.513483
              ],
              [
                44.599847,
                37.513458
              ],
              [
                44.599191,
                37.513532
              ],
              [
                44.598076,
                37.513309
              ],
              [
                44.597584,
                37.512665
              ],
              [
                44.597125,
                37.512367
              ],
              [
                44.596928,
                37.512045
              ],
              [
                44.59637,
                37.5115
              ],
              [
                44.595583,
                37.511425
              ],
              [
                44.594862,
                37.511227
              ],
              [
                44.594435,
                37.510979
              ],
              [
                44.594107,
                37.510706
              ],
              [
                44.593648,
                37.510459
              ],
              [
                44.592533,
                37.510459
              ],
              [
                44.591779,
                37.510582
              ],
              [
                44.590959,
                37.510285
              ],
              [
                44.590204,
                37.509938
              ],
              [
                44.589417,
                37.510112
              ],
              [
                44.5889004,
                37.5102822
              ],
              [
                44.5880259,
                37.5102875
              ],
              [
                44.5871453,
                37.5103724
              ],
              [
                44.5864993,
                37.5095869
              ],
              [
                44.5858112,
                37.5090648
              ],
              [
                44.5855668,
                37.5087047
              ],
              [
                44.5850189,
                37.5073768
              ],
              [
                44.5853583,
                37.5054303
              ],
              [
                44.5849292,
                37.5029822
              ],
              [
                44.5842451,
                37.5005089
              ],
              [
                44.5842732,
                37.4979576
              ],
              [
                44.5842201,
                37.4961326
              ],
              [
                44.5841999,
                37.4954372
              ],
              [
                44.5834458,
                37.4930948
              ],
              [
                44.5832911,
                37.4929726
              ],
              [
                44.5831367,
                37.4912132
              ],
              [
                44.583684,
                37.4878593
              ],
              [
                44.5830567,
                37.4858576
              ],
              [
                44.582373,
                37.4840103
              ],
              [
                44.5826706,
                37.4818827
              ],
              [
                44.5844259,
                37.4797683
              ],
              [
                44.5856885,
                37.4776739
              ],
              [
                44.5861583,
                37.4743386
              ],
              [
                44.586187,
                37.4732038
              ],
              [
                44.5863739,
                37.472156
              ],
              [
                44.586663,
                37.4709687
              ],
              [
                44.5864517,
                37.4700289
              ],
              [
                44.5859674,
                37.4687254
              ],
              [
                44.585706,
                37.4678047
              ],
              [
                44.5858668,
                37.4666989
              ],
              [
                44.5864544,
                37.4654318
              ],
              [
                44.5876071,
                37.4616644
              ],
              [
                44.5875512,
                37.4598877
              ],
              [
                44.5871219,
                37.4583516
              ],
              [
                44.5869082,
                37.457294
              ],
              [
                44.5866245,
                37.454062
              ],
              [
                44.5864477,
                37.452705
              ],
              [
                44.5862519,
                37.451861
              ],
              [
                44.5850992,
                37.4511321
              ],
              [
                44.584179,
                37.4504217
              ],
              [
                44.5832289,
                37.4501594
              ],
              [
                44.5806867,
                37.4487332
              ],
              [
                44.5798293,
                37.4476059
              ],
              [
                44.5804039,
                37.4469999
              ],
              [
                44.5813572,
                37.4461274
              ],
              [
                44.5826672,
                37.4447731
              ],
              [
                44.5839614,
                37.4440012
              ],
              [
                44.5854584,
                37.4418465
              ],
              [
                44.587315,
                37.439619
              ],
              [
                44.5894703,
                37.4388465
              ],
              [
                44.5910918,
                37.4384922
              ],
              [
                44.5926814,
                37.4382887
              ],
              [
                44.5945594,
                37.4382919
              ],
              [
                44.5964265,
                37.4384847
              ],
              [
                44.5985117,
                37.4384015
              ],
              [
                44.6010691,
                37.4378989
              ],
              [
                44.6056452,
                37.4364999
              ],
              [
                44.6064364,
                37.4363167
              ],
              [
                44.6074612,
                37.4363408
              ],
              [
                44.6086151,
                37.4364549
              ],
              [
                44.6134393,
                37.4365554
              ],
              [
                44.6147723,
                37.4367602
              ],
              [
                44.6167361,
                37.4371966
              ],
              [
                44.6178014,
                37.4373461
              ],
              [
                44.6190122,
                37.4371387
              ],
              [
                44.622475,
                37.435273
              ],
              [
                44.622915,
                37.434816
              ],
              [
                44.625006,
                37.433735
              ],
              [
                44.627976,
                37.432695
              ],
              [
                44.628471,
                37.432571
              ],
              [
                44.629406,
                37.432197
              ],
              [
                44.630286,
                37.431989
              ],
              [
                44.630891,
                37.431615
              ],
              [
                44.631551,
                37.431032
              ],
              [
                44.632156,
                37.430243
              ],
              [
                44.632872,
                37.429577
              ],
              [
                44.633807,
                37.428871
              ],
              [
                44.634192,
                37.428455
              ],
              [
                44.635237,
                37.426418
              ],
              [
                44.635842,
                37.425919
              ],
              [
                44.636227,
                37.425004
              ],
              [
                44.636612,
                37.424298
              ],
              [
                44.636722,
                37.423674
              ],
              [
                44.636557,
                37.423175
              ],
              [
                44.636117,
                37.422552
              ],
              [
                44.635402,
                37.422219
              ],
              [
                44.634522,
                37.420847
              ],
              [
                44.634742,
                37.419891
              ],
              [
                44.634797,
                37.419101
              ],
              [
                44.635072,
                37.418311
              ],
              [
                44.635457,
                37.417646
              ],
              [
                44.636392,
                37.41644
              ],
              [
                44.637217,
                37.415858
              ],
              [
                44.637932,
                37.414985
              ],
              [
                44.638537,
                37.414403
              ],
              [
                44.639032,
                37.413821
              ],
              [
                44.639802,
                37.412699
              ],
              [
                44.640407,
                37.412283
              ],
              [
                44.641508,
                37.411077
              ],
              [
                44.642498,
                37.410537
              ],
              [
                44.643158,
                37.409955
              ],
              [
                44.644533,
                37.408915
              ],
              [
                44.645963,
                37.408417
              ],
              [
                44.646788,
                37.407959
              ],
              [
                44.647228,
                37.407502
              ],
              [
                44.648163,
                37.407045
              ],
              [
                44.648878,
                37.406047
              ],
              [
                44.649484,
                37.405091
              ],
              [
                44.650144,
                37.4048
              ],
              [
                44.650859,
                37.403719
              ],
              [
                44.6519494,
                37.4027744
              ],
              [
                44.653236,
                37.4025707
              ],
              [
                44.6541264,
                37.4025512
              ],
              [
                44.6548084,
                37.4024333
              ],
              [
                44.6554316,
                37.4024779
              ],
              [
                44.6559968,
                37.4022666
              ],
              [
                44.656156,
                37.4016809
              ],
              [
                44.6570621,
                37.4000864
              ],
              [
                44.657252,
                37.3991879
              ],
              [
                44.6569198,
                37.3988646
              ],
              [
                44.6563025,
                37.3985075
              ],
              [
                44.6557306,
                37.3983609
              ],
              [
                44.655265,
                37.3980762
              ],
              [
                44.6547925,
                37.3970748
              ],
              [
                44.6546759,
                37.3962874
              ],
              [
                44.6541424,
                37.3950059
              ],
              [
                44.6535095,
                37.3937083
              ],
              [
                44.6533641,
                37.3928092
              ],
              [
                44.6534767,
                37.3920948
              ],
              [
                44.6544204,
                37.389706
              ],
              [
                44.6548637,
                37.3882033
              ],
              [
                44.6557959,
                37.3869335
              ],
              [
                44.6573683,
                37.3859048
              ],
              [
                44.6595444,
                37.3851743
              ],
              [
                44.6624996,
                37.3846323
              ],
              [
                44.6648184,
                37.384347
              ],
              [
                44.6685497,
                37.3833234
              ],
              [
                44.6692297,
                37.3832283
              ],
              [
                44.6710786,
                37.3834883
              ],
              [
                44.673354,
                37.3843829
              ],
              [
                44.6748582,
                37.384536
              ],
              [
                44.6782099,
                37.383566
              ],
              [
                44.6792692,
                37.3836004
              ],
              [
                44.6803792,
                37.3833915
              ],
              [
                44.681454,
                37.382526
              ],
              [
                44.6824285,
                37.3822521
              ],
              [
                44.6839768,
                37.3824953
              ],
              [
                44.6841869,
                37.3826006
              ],
              [
                44.6844329,
                37.3829135
              ],
              [
                44.6847843,
                37.3832231
              ],
              [
                44.6854734,
                37.3837022
              ],
              [
                44.6861074,
                37.3844921
              ],
              [
                44.686629,
                37.3847342
              ],
              [
                44.6870487,
                37.3847722
              ],
              [
                44.687664,
                37.384699
              ],
              [
                44.6892082,
                37.3843458
              ],
              [
                44.6893133,
                37.3843217
              ],
              [
                44.6907344,
                37.3842507
              ],
              [
                44.69267,
                37.3842643
              ],
              [
                44.6940136,
                37.3838777
              ],
              [
                44.6972014,
                37.3834742
              ],
              [
                44.6987781,
                37.3828805
              ],
              [
                44.7002688,
                37.3820093
              ],
              [
                44.7010266,
                37.3814309
              ],
              [
                44.7025156,
                37.3810977
              ],
              [
                44.7042855,
                37.3808145
              ],
              [
                44.7055509,
                37.3808381
              ],
              [
                44.7065384,
                37.381065
              ],
              [
                44.7080873,
                37.3808083
              ],
              [
                44.7110653,
                37.3801957
              ],
              [
                44.7125739,
                37.3795749
              ],
              [
                44.7138493,
                37.3783224
              ],
              [
                44.7162054,
                37.3769079
              ],
              [
                44.717517,
                37.3769021
              ],
              [
                44.7186626,
                37.3763685
              ],
              [
                44.7199387,
                37.3763896
              ],
              [
                44.7214731,
                37.3756933
              ],
              [
                44.7215132,
                37.3742369
              ],
              [
                44.7214012,
                37.3734576
              ],
              [
                44.7210002,
                37.3730451
              ],
              [
                44.720774,
                37.3726801
              ],
              [
                44.7209911,
                37.3720293
              ],
              [
                44.7217691,
                37.3706167
              ],
              [
                44.7218428,
                37.3698607
              ],
              [
                44.723871,
                37.3664334
              ],
              [
                44.7239569,
                37.3661264
              ],
              [
                44.7240212,
                37.3655977
              ],
              [
                44.7244289,
                37.3635171
              ],
              [
                44.7244504,
                37.3617093
              ],
              [
                44.7245362,
                37.3604472
              ],
              [
                44.7243216,
                37.3596797
              ],
              [
                44.7238545,
                37.3585337
              ],
              [
                44.7243044,
                37.3579976
              ],
              [
                44.7244252,
                37.3569091
              ],
              [
                44.7240689,
                37.355904
              ],
              [
                44.7244089,
                37.3548696
              ],
              [
                44.7252907,
                37.3540731
              ],
              [
                44.7261704,
                37.3536512
              ],
              [
                44.7260626,
                37.3531575
              ],
              [
                44.7266605,
                37.3525331
              ],
              [
                44.7268536,
                37.351885
              ],
              [
                44.7273043,
                37.3503668
              ],
              [
                44.7303512,
                37.3479958
              ],
              [
                44.732776,
                37.3463923
              ],
              [
                44.7334412,
                37.344857
              ],
              [
                44.7332909,
                37.3436117
              ],
              [
                44.7323468,
                37.3426223
              ],
              [
                44.732434,
                37.342232
              ],
              [
                44.733424,
                37.342024
              ],
              [
                44.734139,
                37.341775
              ],
              [
                44.735239,
                37.341525
              ],
              [
                44.736669,
                37.340777
              ],
              [
                44.737384,
                37.340527
              ],
              [
                44.738209,
                37.340029
              ],
              [
                44.738869,
                37.339738
              ],
              [
                44.739695,
                37.338573
              ],
              [
                44.74019,
                37.337991
              ],
              [
                44.741015,
                37.336536
              ],
              [
                44.741565,
                37.33583
              ],
              [
                44.74261,
                37.335164
              ],
              [
                44.743215,
                37.334624
              ],
              [
                44.744975,
                37.334458
              ],
              [
                44.7458,
                37.334084
              ],
              [
                44.7469,
                37.334042
              ],
              [
                44.747781,
                37.333793
              ],
              [
                44.748771,
                37.333418
              ],
              [
                44.749761,
                37.332629
              ],
              [
                44.750283,
                37.332064
              ],
              [
                44.750833,
                37.331856
              ],
              [
                44.751713,
                37.331357
              ],
              [
                44.754023,
                37.330817
              ],
              [
                44.755233,
                37.330276
              ],
              [
                44.756444,
                37.330235
              ],
              [
                44.757159,
                37.33011
              ],
              [
                44.758864,
                37.329985
              ],
              [
                44.761394,
                37.329486
              ],
              [
                44.762604,
                37.329486
              ],
              [
                44.763319,
                37.32957
              ],
              [
                44.76519,
                37.329985
              ],
              [
                44.765905,
                37.330069
              ],
              [
                44.76695,
                37.330069
              ],
              [
                44.770635,
                37.328406
              ],
              [
                44.77124,
                37.327948
              ],
              [
                44.772121,
                37.327366
              ],
              [
                44.772946,
                37.326909
              ],
              [
                44.774376,
                37.325911
              ],
              [
                44.774761,
                37.325329
              ],
              [
                44.775091,
                37.324581
              ],
              [
                44.775641,
                37.323708
              ],
              [
                44.776026,
                37.32325
              ],
              [
                44.776631,
                37.322793
              ],
              [
                44.778391,
                37.32192
              ],
              [
                44.779216,
                37.321297
              ],
              [
                44.779986,
                37.320839
              ],
              [
                44.781197,
                37.320424
              ],
              [
                44.784057,
                37.318677
              ],
              [
                44.784937,
                37.318303
              ],
              [
                44.785982,
                37.317513
              ],
              [
                44.786697,
                37.316807
              ],
              [
                44.787467,
                37.316225
              ],
              [
                44.787907,
                37.315809
              ],
              [
                44.788678,
                37.315227
              ],
              [
                44.790218,
                37.314229
              ],
              [
                44.790878,
                37.313897
              ],
              [
                44.791923,
                37.313689
              ],
              [
                44.793793,
                37.313023
              ],
              [
                44.795993,
                37.311319
              ],
              [
                44.797314,
                37.311111
              ],
              [
                44.798139,
                37.310903
              ],
              [
                44.798524,
                37.310654
              ],
              [
                44.799184,
                37.310113
              ],
              [
                44.799294,
                37.309947
              ],
              [
                44.799514,
                37.309282
              ],
              [
                44.799514,
                37.306995
              ],
              [
                44.799569,
                37.306538
              ],
              [
                44.8003507,
                37.3050917
              ],
              [
                44.800999,
                37.303628
              ],
              [
                44.801879,
                37.30263
              ],
              [
                44.804574,
                37.300718
              ],
              [
                44.805015,
                37.300053
              ],
              [
                44.8054,
                37.299263
              ],
              [
                44.805565,
                37.298639
              ],
              [
                44.806005,
                37.297766
              ],
              [
                44.8068075,
                37.2967427
              ],
              [
                44.8070635,
                37.2957912
              ],
              [
                44.8073334,
                37.2947856
              ],
              [
                44.8075567,
                37.2940517
              ],
              [
                44.8079333,
                37.2933238
              ],
              [
                44.80826,
                37.291987
              ],
              [
                44.808535,
                37.29153
              ],
              [
                44.808755,
                37.290906
              ],
              [
                44.80881,
                37.290408
              ],
              [
                44.809415,
                37.288869
              ],
              [
                44.8098,
                37.288204
              ],
              [
                44.810295,
                37.287622
              ],
              [
                44.812385,
                37.28546
              ],
              [
                44.813376,
                37.284504
              ],
              [
                44.813761,
                37.283631
              ],
              [
                44.814256,
                37.2828
              ],
              [
                44.814751,
                37.282218
              ],
              [
                44.815026,
                37.281345
              ],
              [
                44.815191,
                37.280472
              ],
              [
                44.815136,
                37.279599
              ],
              [
                44.814641,
                37.278642
              ],
              [
                44.814586,
                37.27806
              ],
              [
                44.814201,
                37.277561
              ],
              [
                44.813926,
                37.276813
              ],
              [
                44.813541,
                37.276314
              ],
              [
                44.812826,
                37.275649
              ],
              [
                44.81178,
                37.274859
              ],
              [
                44.810845,
                37.274527
              ],
              [
                44.809745,
                37.273986
              ],
              [
                44.80881,
                37.273612
              ],
              [
                44.807765,
                37.27303
              ],
              [
                44.80639,
                37.27249
              ],
              [
                44.805235,
                37.271783
              ],
              [
                44.804299,
                37.271325
              ],
              [
                44.803749,
                37.270785
              ],
              [
                44.803419,
                37.270286
              ],
              [
                44.802979,
                37.269829
              ],
              [
                44.802759,
                37.269081
              ],
              [
                44.802319,
                37.268166
              ],
              [
                44.801879,
                37.266004
              ],
              [
                44.801659,
                37.264216
              ],
              [
                44.801659,
                37.26351
              ],
              [
                44.801549,
                37.262678
              ],
              [
                44.801219,
                37.261847
              ],
              [
                44.801219,
                37.26168
              ],
              [
                44.8009182,
                37.26047
              ],
              [
                44.799844,
                37.259477
              ],
              [
                44.799349,
                37.259144
              ],
              [
                44.798799,
                37.258646
              ],
              [
                44.797644,
                37.258105
              ],
              [
                44.796489,
                37.257648
              ],
              [
                44.795058,
                37.257149
              ],
              [
                44.794453,
                37.256983
              ],
              [
                44.792253,
                37.256609
              ],
              [
                44.790383,
                37.256692
              ],
              [
                44.789338,
                37.256858
              ],
              [
                44.788458,
                37.256733
              ],
              [
                44.787302,
                37.256401
              ],
              [
                44.786257,
                37.255943
              ],
              [
                44.785267,
                37.255444
              ],
              [
                44.783892,
                37.254655
              ],
              [
                44.779161,
                37.251703
              ],
              [
                44.778446,
                37.251246
              ],
              [
                44.777126,
                37.250248
              ],
              [
                44.776466,
                37.249874
              ],
              [
                44.7683538,
                37.2446406
              ],
              [
                44.7676519,
                37.2437223
              ],
              [
                44.7670445,
                37.2424543
              ],
              [
                44.7668754,
                37.2404631
              ],
              [
                44.7664531,
                37.2384022
              ],
              [
                44.7652816,
                37.2373539
              ],
              [
                44.7633238,
                37.2367088
              ],
              [
                44.7616876,
                37.2358718
              ],
              [
                44.7607645,
                37.2348668
              ],
              [
                44.7600861,
                37.2340251
              ],
              [
                44.7597642,
                37.2323871
              ],
              [
                44.7589207,
                37.2302385
              ],
              [
                44.7575679,
                37.2283412
              ],
              [
                44.7587949,
                37.2261548
              ],
              [
                44.7604299,
                37.2246004
              ],
              [
                44.7617913,
                37.2241955
              ],
              [
                44.762648,
                37.2234991
              ],
              [
                44.7624122,
                37.222607
              ],
              [
                44.7615496,
                37.2218182
              ],
              [
                44.7606121,
                37.219223
              ],
              [
                44.760624,
                37.218277
              ],
              [
                44.760459,
                37.217279
              ],
              [
                44.760349,
                37.21545
              ],
              [
                44.760514,
                37.213163
              ],
              [
                44.760459,
                37.211916
              ],
              [
                44.760679,
                37.209546
              ],
              [
                44.761229,
                37.207093
              ],
              [
                44.761559,
                37.205971
              ],
              [
                44.761944,
                37.204973
              ],
              [
                44.763264,
                37.202687
              ],
              [
                44.763924,
                37.201232
              ],
              [
                44.764474,
                37.200483
              ],
              [
                44.76519,
                37.199735
              ],
              [
                44.76596,
                37.198571
              ],
              [
                44.767115,
                37.195578
              ],
              [
                44.767445,
                37.194123
              ],
              [
                44.767885,
                37.193208
              ],
              [
                44.76805,
                37.192626
              ],
              [
                44.76794,
                37.191878
              ],
              [
                44.767665,
                37.190838
              ],
              [
                44.766732,
                37.1891532
              ],
              [
                44.7665119,
                37.188229
              ],
              [
                44.7665655,
                37.1875127
              ],
              [
                44.766345,
                37.186515
              ],
              [
                44.76629,
                37.185933
              ],
              [
                44.76662,
                37.184893
              ],
              [
                44.76596,
                37.184103
              ],
              [
                44.766125,
                37.183106
              ],
              [
                44.768325,
                37.181235
              ],
              [
                44.769205,
                37.180985
              ],
              [
                44.76992,
                37.180528
              ],
              [
                44.77058,
                37.180362
              ],
              [
                44.77135,
                37.179905
              ],
              [
                44.771845,
                37.179156
              ],
              [
                44.77212,
                37.178491
              ],
              [
                44.772065,
                37.177535
              ],
              [
                44.772725,
                37.176911
              ],
              [
                44.774431,
                37.17608
              ],
              [
                44.775586,
                37.175872
              ],
              [
                44.778226,
                37.174874
              ],
              [
                44.779326,
                37.174292
              ],
              [
                44.780371,
                37.173627
              ],
              [
                44.781086,
                37.173003
              ],
              [
                44.782792,
                37.170925
              ],
              [
                44.783562,
                37.169678
              ],
              [
                44.784222,
                37.168472
              ],
              [
                44.784772,
                37.167724
              ],
              [
                44.784992,
                37.1671
              ],
              [
                44.785212,
                37.166352
              ],
              [
                44.785267,
                37.165686
              ],
              [
                44.785267,
                37.165063
              ],
              [
                44.785047,
                37.163317
              ],
              [
                44.785102,
                37.16261
              ],
              [
                44.785707,
                37.161197
              ],
              [
                44.785817,
                37.16049
              ],
              [
                44.785817,
                37.159492
              ],
              [
                44.785707,
                37.158827
              ],
              [
                44.785212,
                37.158286
              ],
              [
                44.784607,
                37.157372
              ],
              [
                44.783562,
                37.156208
              ],
              [
                44.783452,
                37.154961
              ],
              [
                44.783731,
                37.154278
              ],
              [
                44.783925,
                37.15336
              ],
              [
                44.784314,
                37.152405
              ],
              [
                44.784508,
                37.151267
              ],
              [
                44.785984,
                37.149896
              ],
              [
                44.785522,
                37.14939
              ],
              [
                44.785085,
                37.148463
              ],
              [
                44.784914,
                37.147667
              ],
              [
                44.784809,
                37.14649
              ],
              [
                44.784835,
                37.145635
              ],
              [
                44.7849294,
                37.1450862
              ],
              [
                44.7846709,
                37.1446404
              ],
              [
                44.7844154,
                37.1440877
              ],
              [
                44.7876141,
                37.1422234
              ],
              [
                44.7884468,
                37.1413864
              ],
              [
                44.7984471,
                37.1366618
              ],
              [
                44.8176669,
                37.1333096
              ],
              [
                44.8204435,
                37.1321936
              ],
              [
                44.8543365,
                37.1230324
              ],
              [
                44.860393,
                37.1191671
              ],
              [
                44.8645596,
                37.1191671
              ],
              [
                44.8651158,
                37.1188881
              ],
              [
                44.8838954,
                37.1150555
              ],
              [
                44.8855626,
                37.1153345
              ],
              [
                44.8936191,
                37.1153345
              ],
              [
                44.8941753,
                37.1156135
              ],
              [
                44.899452,
                37.1156135
              ],
              [
                44.9055623,
                37.1167205
              ],
              [
                44.9072287,
                37.1172786
              ],
              [
                44.9290922,
                37.1319851
              ],
              [
                44.9315915,
                37.133929
              ],
              [
                44.9357588,
                37.1369799
              ],
              [
                44.9626216,
                37.1655587
              ],
              [
                44.9767709,
                37.1792049
              ],
              [
                44.9814944,
                37.1853152
              ],
              [
                44.9856609,
                37.1880959
              ],
              [
                44.9859375,
                37.1886538
              ],
              [
                44.9870515,
                37.1892028
              ],
              [
                44.9898273,
                37.1925414
              ],
              [
                44.9906609,
                37.1942061
              ],
              [
                44.9945509,
                37.1983726
              ],
              [
                44.9945509,
                37.1986516
              ],
              [
                45.0009408,
                37.2053196
              ],
              [
                45.006234,
                37.2155553
              ],
              [
                45.010677,
                37.226947
              ],
              [
                45.0112341,
                37.2272259
              ],
              [
                45.0140903,
                37.2396313
              ],
              [
                45.0143676,
                37.2415752
              ],
              [
                45.0125341,
                37.2467613
              ],
              [
                45.0151751,
                37.2567866
              ],
              [
                45.0292086,
                37.2612229
              ],
              [
                45.0422284,
                37.2677693
              ],
              [
                45.0669476,
                37.2795169
              ],
              [
                45.0985333,
                37.2773314
              ],
              [
                45.1253125,
                37.2625779
              ],
              [
                45.1424786,
                37.2617582
              ],
              [
                45.1647946,
                37.2590257
              ],
              [
                45.1763032,
                37.247708
              ],
              [
                45.1776939,
                37.2468802
              ],
              [
                45.1813034,
                37.2432628
              ],
              [
                45.1824136,
                37.2415981
              ],
              [
                45.1829699,
                37.2415981
              ],
              [
                45.1838035,
                37.2410492
              ],
              [
                45.18408,
                37.2407613
              ],
              [
                45.185055,
                37.2395151
              ],
              [
                45.1851933,
                37.2391056
              ],
              [
                45.1873055,
                37.2055052
              ],
              [
                45.1875852,
                37.2035526
              ],
              [
                45.1906384,
                37.1963361
              ],
              [
                45.195362,
                37.1910542
              ],
              [
                45.1964722,
                37.1899473
              ],
              [
                45.2161652,
                37.1871197
              ],
              [
                45.2183887,
                37.1871198
              ],
              [
                45.2189418,
                37.1868409
              ],
              [
                45.2200552,
                37.1868409
              ],
              [
                45.2208888,
                37.186562
              ],
              [
                45.2225553,
                37.1865619
              ],
              [
                45.2244983,
                37.186004
              ],
              [
                45.2256116,
                37.1860041
              ],
              [
                45.227832,
                37.1854552
              ],
              [
                45.2294984,
                37.1854553
              ],
              [
                45.2297781,
                37.1851762
              ],
              [
                45.2306118,
                37.1851762
              ],
              [
                45.2311648,
                37.1848973
              ],
              [
                45.2325547,
                37.1848973
              ],
              [
                45.2331118,
                37.1846185
              ],
              [
                45.2339454,
                37.1846184
              ],
              [
                45.2344985,
                37.1843395
              ],
              [
                45.2364455,
                37.1843395
              ],
              [
                45.2503895,
                37.172811
              ],
              [
                45.2564998,
                37.1678168
              ],
              [
                45.2573335,
                37.1672588
              ],
              [
                45.2775764,
                37.1512869
              ],
              [
                45.2827017,
                37.1501099
              ],
              [
                45.2859354,
                37.1499656
              ],
              [
                45.2936091,
                37.1497065
              ],
              [
                45.3173589,
                37.1511159
              ],
              [
                45.3282041,
                37.1509453
              ],
              [
                45.3601535,
                37.1514567
              ],
              [
                45.3809164,
                37.1548443
              ],
              [
                45.3882979,
                37.1562124
              ],
              [
                45.3996275,
                37.1608639
              ],
              [
                45.4087256,
                37.1627791
              ],
              [
                45.4141696,
                37.1656526
              ],
              [
                45.4858139,
                37.2465538
              ],
              [
                45.5557824,
                37.328221
              ],
              [
                45.5564822,
                37.3290021
              ],
              [
                45.5551695,
                37.3319764
              ],
              [
                45.5518166,
                37.3332071
              ],
              [
                45.547613,
                37.3348653
              ],
              [
                45.5457115,
                37.3357075
              ],
              [
                45.5442443,
                37.3357214
              ],
              [
                45.5163567,
                37.3483266
              ],
              [
                45.4983608,
                37.3604861
              ],
              [
                45.4718856,
                37.3845861
              ],
              [
                45.4710381,
                37.4219812
              ],
              [
                45.4627587,
                37.4451104
              ],
              [
                45.4588598,
                37.4603627
              ],
              [
                45.4606918,
                37.4644556
              ],
              [
                45.475158,
                37.498832
              ],
              [
                45.4722672,
                37.5292754
              ],
              [
                45.4702849,
                37.5362969
              ],
              [
                45.5225365,
                37.5832222
              ],
              [
                45.5223037,
                37.5924467
              ],
              [
                45.5218499,
                37.6104244
              ],
              [
                45.5086374,
                37.6259642
              ],
              [
                45.4991906,
                37.637073
              ],
              [
                45.4681383,
                37.6626187
              ],
              [
                45.4199217,
                37.7022675
              ],
              [
                45.3931042,
                37.7310821
              ],
              [
                45.3774764,
                37.7682854
              ],
              [
                45.3792518,
                37.7814531
              ],
              [
                45.3689036,
                37.7865582
              ],
              [
                45.3716467,
                37.7918799
              ],
              [
                45.3783413,
                37.7945931
              ],
              [
                45.3809419,
                37.8014272
              ],
              [
                45.3858944,
                37.8200907
              ],
              [
                45.3852673,
                37.8423328
              ],
              [
                45.3844338,
                37.8426114
              ],
              [
                45.3824612,
                37.8604891
              ],
              [
                45.3786811,
                37.8744895
              ],
              [
                45.3749044,
                37.8850655
              ],
              [
                45.3701016,
                37.9100756
              ],
              [
                45.3586406,
                37.9297732
              ],
              [
                45.3586407,
                37.9317235
              ],
              [
                45.3586407,
                37.9317236
              ],
              [
                45.3586406,
                37.9325593
              ],
              [
                45.3583602,
                37.9342219
              ],
              [
                45.3357675,
                37.9697083
              ],
              [
                45.336044,
                37.9705438
              ],
              [
                45.3357675,
                37.9710918
              ],
              [
                45.3360441,
                37.9713703
              ],
              [
                45.3354909,
                37.9727628
              ],
              [
                45.3234746,
                37.9846324
              ],
              [
                45.3126351,
                38.0037117
              ],
              [
                45.3109308,
                38.0061197
              ],
              [
                45.2725979,
                38.0602567
              ],
              [
                45.248222,
                38.0859326
              ],
              [
                45.2438245,
                38.1232975
              ],
              [
                45.2376182,
                38.1759983
              ],
              [
                45.1611606,
                38.1901475
              ],
              [
                45.1611605,
                38.1901477
              ],
              [
                45.0790444,
                38.1544848
              ],
              [
                45.0293283,
                38.1328847
              ],
              [
                45.0216956,
                38.129568
              ],
              [
                45.0278187,
                38.1205636
              ],
              [
                45.0425427,
                38.0900046
              ],
              [
                45.0439286,
                38.0841731
              ],
              [
                45.0444857,
                38.0794556
              ],
              [
                45.0447623,
                38.0780628
              ],
              [
                45.0453193,
                38.0747291
              ],
              [
                45.0506821,
                38.0587403
              ],
              [
                45.0452998,
                38.0339454
              ],
              [
                45.0338767,
                38.0163212
              ],
              [
                45.0324899,
                38.0157731
              ],
              [
                45.0320331,
                38.0143474
              ],
              [
                45.0270331,
                38.0115704
              ],
              [
                45.0013435,
                37.996674
              ],
              [
                44.9982903,
                37.9961168
              ],
              [
                44.9968997,
                37.9961167
              ],
              [
                44.9963434,
                37.9958381
              ],
              [
                44.9938433,
                37.9958381
              ],
              [
                44.9932862,
                37.9955593
              ],
              [
                44.9910667,
                37.9955594
              ],
              [
                44.9905097,
                37.9952808
              ],
              [
                44.9877339,
                37.9952808
              ],
              [
                44.9871768,
                37.9950022
              ],
              [
                44.9852337,
                37.9950022
              ],
              [
                44.9849532,
                37.9947235
              ],
              [
                44.9755101,
                37.9938965
              ],
              [
                44.9649537,
                37.9938966
              ],
              [
                44.96412,
                37.9941752
              ],
              [
                44.9627301,
                37.9941753
              ],
              [
                44.9624536,
                37.9944538
              ],
              [
                44.9549533,
                37.9963953
              ],
              [
                44.9543971,
                37.9972312
              ],
              [
                44.9530072,
                37.9980581
              ],
              [
                44.9530073,
                37.9983366
              ],
              [
                44.9527307,
                37.9986153
              ],
              [
                44.9338403,
                38.0138947
              ],
              [
                44.9335637,
                38.014452
              ],
              [
                44.8928826,
                38.0270001
              ],
              [
                44.8791497,
                38.0372762
              ],
              [
                44.8720547,
                38.0561352
              ],
              [
                44.8709445,
                38.0561352
              ],
              [
                44.8703875,
                38.0564137
              ],
              [
                44.8692781,
                38.0564138
              ],
              [
                44.868721,
                38.0566923
              ],
              [
                44.8678875,
                38.0566923
              ],
              [
                44.8676108,
                38.0569709
              ],
              [
                44.8665014,
                38.0569709
              ],
              [
                44.866221,
                38.0572495
              ],
              [
                44.8653881,
                38.0572495
              ],
              [
                44.8648342,
                38.057528
              ],
              [
                44.8628882,
                38.0577976
              ],
              [
                44.8601114,
                38.0577976
              ],
              [
                44.8592778,
                38.0580761
              ],
              [
                44.8564981,
                38.0580762
              ],
              [
                44.8562215,
                38.0583547
              ],
              [
                44.8517777,
                38.0583547
              ],
              [
                44.851498,
                38.0580761
              ],
              [
                44.8506643,
                38.0583547
              ],
              [
                44.8487213,
                38.0583547
              ],
              [
                44.8484448,
                38.0580761
              ],
              [
                44.8476112,
                38.0583547
              ],
              [
                44.8445549,
                38.0583547
              ],
              [
                44.8437212,
                38.0586332
              ],
              [
                44.8277844,
                38.057265
              ],
              [
                44.825561,
                38.057265
              ],
              [
                44.8250048,
                38.0575435
              ],
              [
                44.8230609,
                38.0575435
              ],
              [
                44.8227813,
                38.0578222
              ],
              [
                44.8216711,
                38.0578222
              ],
              [
                44.8211148,
                38.0578222
              ],
              [
                44.8205609,
                38.0578222
              ],
              [
                44.8200046,
                38.0578222
              ],
              [
                44.8186148,
                38.0578222
              ],
              [
                44.8183382,
                38.0575435
              ],
              [
                44.8138944,
                38.0575435
              ],
              [
                44.813338,
                38.0572649
              ],
              [
                44.8105615,
                38.0572649
              ],
              [
                44.8100044,
                38.0569863
              ],
              [
                44.8072278,
                38.0569862
              ],
              [
                44.7869484,
                38.0530948
              ],
              [
                44.7855585,
                38.0525465
              ],
              [
                44.7847249,
                38.0525465
              ],
              [
                44.7780584,
                38.0494907
              ],
              [
                44.7772248,
                38.0494908
              ],
              [
                44.7716685,
                38.0467137
              ],
              [
                44.7711153,
                38.046435
              ],
              [
                44.7525016,
                38.0372587
              ],
              [
                44.7511118,
                38.0361533
              ],
              [
                44.7454788,
                38.0364047
              ],
              [
                44.7449218,
                38.0364047
              ],
              [
                44.7144283,
                38.0368103
              ],
              [
                44.7141477,
                38.0365317
              ],
              [
                44.7127611,
                38.0365316
              ],
              [
                44.7122048,
                38.036253
              ],
              [
                44.7077578,
                38.0362531
              ],
              [
                44.7072046,
                38.0365316
              ],
              [
                44.7055383,
                38.0365316
              ],
              [
                44.7049812,
                38.0368102
              ],
              [
                44.7033148,
                38.0368102
              ],
              [
                44.7030382,
                38.0370888
              ],
              [
                44.7024811,
                38.0368102
              ],
              [
                44.6983145,
                38.0368102
              ],
              [
                44.6845467,
                38.0372454
              ],
              [
                44.6701003,
                38.024188
              ],
              [
                44.669823,
                38.0236309
              ],
              [
                44.6637171,
                38.0121256
              ],
              [
                44.6562134,
                37.9994652
              ],
              [
                44.6562134,
                37.9991866
              ],
              [
                44.6296603,
                37.9805032
              ],
              [
                44.6185682,
                37.9780333
              ],
              [
                44.6125014,
                37.9682795
              ],
              [
                44.6114876,
                37.9683513
              ],
              [
                44.6103774,
                37.967794
              ],
              [
                44.5969389,
                37.9607114
              ],
              [
                44.5834143,
                37.9577712
              ],
              [
                44.5814713,
                37.9558299
              ],
              [
                44.5794149,
                37.9450271
              ],
              [
                44.5785711,
                37.9398655
              ],
              [
                44.571333,
                37.9319643
              ],
              [
                44.5710565,
                37.9308497
              ],
              [
                44.5705001,
                37.9305711
              ],
              [
                44.5458739,
                37.9294141
              ],
              [
                44.5124956,
                37.8987509
              ],
              [
                44.5116629,
                37.8987509
              ],
              [
                44.5108292,
                37.8981936
              ],
              [
                44.5072159,
                37.897088
              ],
              [
                44.5055495,
                37.896252
              ],
              [
                44.5049963,
                37.8938138
              ],
              [
                44.4984262,
                37.8889655
              ],
              [
                44.4968775,
                37.8828873
              ],
              [
                44.4957425,
                37.8824323
              ],
              [
                44.4580744,
                37.8644098
              ],
              [
                44.4508548,
                37.8616321
              ],
              [
                44.4502986,
                37.8610837
              ],
              [
                44.43186,
                37.8503184
              ],
              [
                44.4285264,
                37.8486553
              ],
              [
                44.4081471,
                37.8450203
              ],
              [
                44.406418,
                37.8448279
              ],
              [
                44.4048998,
                37.8447814
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554887,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اشنویه",
          "name:en": "Oshnavieh County",
          "name:ku": "Şino",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286194",
          "wikipedia": "en:Oshnavieh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.7843055,
                37.1438498
              ],
              [
                44.783599,
                37.14377
              ],
              [
                44.783271,
                37.143654
              ],
              [
                44.783001,
                37.14359
              ],
              [
                44.7825578,
                37.143604
              ],
              [
                44.7821032,
                37.14359
              ],
              [
                44.781804,
                37.143652
              ],
              [
                44.7814771,
                37.143593
              ],
              [
                44.78116,
                37.143648
              ],
              [
                44.7807031,
                37.143678
              ],
              [
                44.7804061,
                37.143901
              ],
              [
                44.7801491,
                37.14396
              ],
              [
                44.7798679,
                37.143539
              ],
              [
                44.779666,
                37.1433
              ],
              [
                44.7793841,
                37.143073
              ],
              [
                44.779167,
                37.142775
              ],
              [
                44.7790709,
                37.142426
              ],
              [
                44.7789442,
                37.142318
              ],
              [
                44.7788779,
                37.142199
              ],
              [
                44.7787951,
                37.142019
              ],
              [
                44.7787681,
                37.141955
              ],
              [
                44.7786421,
                37.141807
              ],
              [
                44.778461,
                37.141573
              ],
              [
                44.7782789,
                37.141332
              ],
              [
                44.7779009,
                37.141198
              ],
              [
                44.777677,
                37.140876
              ],
              [
                44.7775031,
                37.140573
              ],
              [
                44.7773501,
                37.140409
              ],
              [
                44.7770722,
                37.140359
              ],
              [
                44.7765739,
                37.140312
              ],
              [
                44.7761329,
                37.140106
              ],
              [
                44.7757222,
                37.13993
              ],
              [
                44.775387,
                37.139805
              ],
              [
                44.7749561,
                37.139824
              ],
              [
                44.77464,
                37.139733
              ],
              [
                44.7742699,
                37.139611
              ],
              [
                44.773898,
                37.139506
              ],
              [
                44.7733051,
                37.139497
              ],
              [
                44.7728411,
                37.139444
              ],
              [
                44.772516,
                37.139341
              ],
              [
                44.7721499,
                37.139211
              ],
              [
                44.7718208,
                37.139015
              ],
              [
                44.7713971,
                37.138908
              ],
              [
                44.7706919,
                37.138789
              ],
              [
                44.7701962,
                37.138623
              ],
              [
                44.7698149,
                37.138526
              ],
              [
                44.7694718,
                37.138473
              ],
              [
                44.7687968,
                37.138488
              ],
              [
                44.7683249,
                37.138503
              ],
              [
                44.7677269,
                37.138573
              ],
              [
                44.7676492,
                37.13841
              ],
              [
                44.7673252,
                37.138182
              ],
              [
                44.7669691,
                37.137946
              ],
              [
                44.7666019,
                37.137681
              ],
              [
                44.7664478,
                37.137487
              ],
              [
                44.766184,
                37.13732
              ],
              [
                44.7658891,
                37.137172
              ],
              [
                44.7655421,
                37.137046
              ],
              [
                44.7653819,
                37.136802
              ],
              [
                44.7650129,
                37.136784
              ],
              [
                44.764798,
                37.13663
              ],
              [
                44.7643905,
                37.1366095
              ],
              [
                44.7640284,
                37.1365222
              ],
              [
                44.763878,
                37.1364737
              ],
              [
                44.7638412,
                37.1363698
              ],
              [
                44.7638419,
                37.136169
              ],
              [
                44.763853,
                37.135993
              ],
              [
                44.7639379,
                37.13583
              ],
              [
                44.7640409,
                37.135675
              ],
              [
                44.7641971,
                37.135316
              ],
              [
                44.7643699,
                37.135031
              ],
              [
                44.7644171,
                37.134602
              ],
              [
                44.7644902,
                37.134283
              ],
              [
                44.7645679,
                37.133966
              ],
              [
                44.7646381,
                37.133712
              ],
              [
                44.764466,
                37.133517
              ],
              [
                44.764375,
                37.133322
              ],
              [
                44.7643238,
                37.133047
              ],
              [
                44.7642839,
                37.13274
              ],
              [
                44.7641269,
                37.132512
              ],
              [
                44.7641831,
                37.13225
              ],
              [
                44.7642079,
                37.132053
              ],
              [
                44.764331,
                37.131828
              ],
              [
                44.7644228,
                37.13162
              ],
              [
                44.764519,
                37.131355
              ],
              [
                44.7645881,
                37.131124
              ],
              [
                44.7645841,
                37.130774
              ],
              [
                44.764605,
                37.13046
              ],
              [
                44.7646,
                37.130461
              ],
              [
                44.7646471,
                37.130085
              ],
              [
                44.764663,
                37.12985
              ],
              [
                44.7647152,
                37.129568
              ],
              [
                44.7643861,
                37.129344
              ],
              [
                44.7641629,
                37.128999
              ],
              [
                44.7639689,
                37.128862
              ],
              [
                44.763538,
                37.12857
              ],
              [
                44.763129,
                37.128507
              ],
              [
                44.7629309,
                37.128452
              ],
              [
                44.762711,
                37.128391
              ],
              [
                44.7623359,
                37.128333
              ],
              [
                44.76199,
                37.128332
              ],
              [
                44.7613852,
                37.128319
              ],
              [
                44.761005,
                37.128241
              ],
              [
                44.7604931,
                37.128107
              ],
              [
                44.760182,
                37.127938
              ],
              [
                44.759826,
                37.1278
              ],
              [
                44.7593692,
                37.127573
              ],
              [
                44.759129,
                37.127335
              ],
              [
                44.758939,
                37.127241
              ],
              [
                44.7585329,
                37.126979
              ],
              [
                44.758229,
                37.126788
              ],
              [
                44.7579349,
                37.126614
              ],
              [
                44.757734,
                37.126466
              ],
              [
                44.757392,
                37.126081
              ],
              [
                44.756874,
                37.125872
              ],
              [
                44.756563,
                37.12576
              ],
              [
                44.756262,
                37.125053
              ],
              [
                44.7557288,
                37.12496
              ],
              [
                44.7555989,
                37.125098
              ],
              [
                44.755497,
                37.125305
              ],
              [
                44.7550931,
                37.125443
              ],
              [
                44.7545891,
                37.125338
              ],
              [
                44.75417,
                37.125626
              ],
              [
                44.7537809,
                37.125648
              ],
              [
                44.7534781,
                37.125636
              ],
              [
                44.7532268,
                37.125625
              ],
              [
                44.7528128,
                37.125385
              ],
              [
                44.752477,
                37.125189
              ],
              [
                44.752162,
                37.124838
              ],
              [
                44.7519359,
                37.124578
              ],
              [
                44.7518182,
                37.124224
              ],
              [
                44.7516472,
                37.123962
              ],
              [
                44.7514621,
                37.123777
              ],
              [
                44.7510352,
                37.123564
              ],
              [
                44.7507382,
                37.12332
              ],
              [
                44.7505402,
                37.122939
              ],
              [
                44.750227,
                37.122627
              ],
              [
                44.749926,
                37.122503
              ],
              [
                44.749643,
                37.122295
              ],
              [
                44.7493471,
                37.122
              ],
              [
                44.749152,
                37.121715
              ],
              [
                44.7489479,
                37.12142
              ],
              [
                44.748855,
                37.121118
              ],
              [
                44.7487639,
                37.120854
              ],
              [
                44.7485828,
                37.120686
              ],
              [
                44.748293,
                37.120532
              ],
              [
                44.747914,
                37.12047
              ],
              [
                44.7476029,
                37.120276
              ],
              [
                44.747699,
                37.119905
              ],
              [
                44.7477592,
                37.119709
              ],
              [
                44.7479629,
                37.119405
              ],
              [
                44.7481379,
                37.119056
              ],
              [
                44.748403,
                37.11864
              ],
              [
                44.748611,
                37.118194
              ],
              [
                44.749071,
                37.117623
              ],
              [
                44.749246,
                37.117084
              ],
              [
                44.749473,
                37.116704
              ],
              [
                44.7498,
                37.116521
              ],
              [
                44.749886,
                37.116308
              ],
              [
                44.74985,
                37.115998
              ],
              [
                44.750046,
                37.115292
              ],
              [
                44.750236,
                37.115003
              ],
              [
                44.750398,
                37.114238
              ],
              [
                44.749666,
                37.112879
              ],
              [
                44.750385,
                37.112112
              ],
              [
                44.751228,
                37.111405
              ],
              [
                44.751635,
                37.111258
              ],
              [
                44.75182,
                37.111144
              ],
              [
                44.752142,
                37.110595
              ],
              [
                44.75241,
                37.110355
              ],
              [
                44.752764,
                37.110139
              ],
              [
                44.753291,
                37.109896
              ],
              [
                44.754517,
                37.109592
              ],
              [
                44.754696,
                37.109584
              ],
              [
                44.755043,
                37.109661
              ],
              [
                44.757096,
                37.108715
              ],
              [
                44.75762,
                37.108183
              ],
              [
                44.758381,
                37.107877
              ],
              [
                44.758683,
                37.107815
              ],
              [
                44.758915,
                37.10758
              ],
              [
                44.759624,
                37.10718
              ],
              [
                44.760012,
                37.107058
              ],
              [
                44.76023,
                37.10679
              ],
              [
                44.760373,
                37.106411
              ],
              [
                44.760804,
                37.106233
              ],
              [
                44.761197,
                37.105863
              ],
              [
                44.761503,
                37.105683
              ],
              [
                44.762174,
                37.105413
              ],
              [
                44.7624753,
                37.1052457
              ],
              [
                44.7626113,
                37.105111
              ],
              [
                44.7629184,
                37.1047999
              ],
              [
                44.763273,
                37.104383
              ],
              [
                44.763705,
                37.103313
              ],
              [
                44.763747,
                37.102777
              ],
              [
                44.76441,
                37.101821
              ],
              [
                44.765402,
                37.100578
              ],
              [
                44.765629,
                37.100224
              ],
              [
                44.765721,
                37.099827
              ],
              [
                44.766149,
                37.099635
              ],
              [
                44.766923,
                37.099521
              ],
              [
                44.767386,
                37.099541
              ],
              [
                44.767813,
                37.099374
              ],
              [
                44.768187,
                37.099109
              ],
              [
                44.768575,
                37.099015
              ],
              [
                44.768807,
                37.098671
              ],
              [
                44.769089,
                37.098414
              ],
              [
                44.769465,
                37.09835
              ],
              [
                44.770415,
                37.098356
              ],
              [
                44.771516,
                37.098154
              ],
              [
                44.772204,
                37.097578
              ],
              [
                44.772555,
                37.097433
              ],
              [
                44.772904,
                37.097222
              ],
              [
                44.773686,
                37.096296
              ],
              [
                44.774439,
                37.096012
              ],
              [
                44.774992,
                37.095878
              ],
              [
                44.77527,
                37.095903
              ],
              [
                44.77589,
                37.096392
              ],
              [
                44.776218,
                37.096441
              ],
              [
                44.77743,
                37.096401
              ],
              [
                44.777736,
                37.096464
              ],
              [
                44.778074,
                37.096343
              ],
              [
                44.778291,
                37.096153
              ],
              [
                44.778758,
                37.095288
              ],
              [
                44.779128,
                37.094792
              ],
              [
                44.779947,
                37.094082
              ],
              [
                44.780343,
                37.093891
              ],
              [
                44.781339,
                37.092896
              ],
              [
                44.78231,
                37.092641
              ],
              [
                44.783485,
                37.092708
              ],
              [
                44.783908,
                37.092362
              ],
              [
                44.783981,
                37.091209
              ],
              [
                44.784089,
                37.090976
              ],
              [
                44.784185,
                37.090496
              ],
              [
                44.784423,
                37.090073
              ],
              [
                44.784561,
                37.089667
              ],
              [
                44.784067,
                37.089348
              ],
              [
                44.783499,
                37.089197
              ],
              [
                44.781574,
                37.088369
              ],
              [
                44.780812,
                37.087878
              ],
              [
                44.780061,
                37.087136
              ],
              [
                44.77977,
                37.08657
              ],
              [
                44.778992,
                37.085927
              ],
              [
                44.778578,
                37.085768
              ],
              [
                44.778369,
                37.085559
              ],
              [
                44.77829,
                37.085378
              ],
              [
                44.778217,
                37.084702
              ],
              [
                44.778129,
                37.084477
              ],
              [
                44.777906,
                37.084259
              ],
              [
                44.7775463,
                37.0840144
              ],
              [
                44.7769632,
                37.0836844
              ],
              [
                44.7769269,
                37.0836123
              ],
              [
                44.7768906,
                37.0835401
              ],
              [
                44.7768911,
                37.0833301
              ],
              [
                44.777294,
                37.082138
              ],
              [
                44.77755,
                37.081575
              ],
              [
                44.777826,
                37.081263
              ],
              [
                44.778228,
                37.080388
              ],
              [
                44.778207,
                37.079993
              ],
              [
                44.778041,
                37.079153
              ],
              [
                44.777872,
                37.078764
              ],
              [
                44.777761,
                37.078222
              ],
              [
                44.777954,
                37.077352
              ],
              [
                44.7774821,
                37.076901
              ],
              [
                44.7774808,
                37.0764026
              ],
              [
                44.777665,
                37.075947
              ],
              [
                44.777723,
                37.075656
              ],
              [
                44.778199,
                37.075593
              ],
              [
                44.778388,
                37.075637
              ],
              [
                44.779292,
                37.075519
              ],
              [
                44.780697,
                37.075617
              ],
              [
                44.781226,
                37.075736
              ],
              [
                44.781763,
                37.075752
              ],
              [
                44.782094,
                37.075709
              ],
              [
                44.782569,
                37.075288
              ],
              [
                44.782953,
                37.07518
              ],
              [
                44.783439,
                37.074862
              ],
              [
                44.784611,
                37.074507
              ],
              [
                44.78501,
                37.074327
              ],
              [
                44.78529,
                37.07406
              ],
              [
                44.785462,
                37.073641
              ],
              [
                44.785905,
                37.073626
              ],
              [
                44.786554,
                37.073701
              ],
              [
                44.786897,
                37.073653
              ],
              [
                44.787267,
                37.073153
              ],
              [
                44.787704,
                37.073058
              ],
              [
                44.788257,
                37.072873
              ],
              [
                44.7885,
                37.07263
              ],
              [
                44.789126,
                37.072332
              ],
              [
                44.789392,
                37.072137
              ],
              [
                44.789933,
                37.071627
              ],
              [
                44.790672,
                37.071057
              ],
              [
                44.791113,
                37.070845
              ],
              [
                44.791386,
                37.070653
              ],
              [
                44.792654,
                37.070178
              ],
              [
                44.793141,
                37.069838
              ],
              [
                44.794683,
                37.069012
              ],
              [
                44.795123,
                37.068846
              ],
              [
                44.795974,
                37.068279
              ],
              [
                44.797474,
                37.06765
              ],
              [
                44.798021,
                37.067632
              ],
              [
                44.798323,
                37.067675
              ],
              [
                44.798812,
                37.067646
              ],
              [
                44.799062,
                37.067521
              ],
              [
                44.799206,
                37.067089
              ],
              [
                44.799282,
                37.066576
              ],
              [
                44.799618,
                37.065979
              ],
              [
                44.799851,
                37.065399
              ],
              [
                44.799933,
                37.064833
              ],
              [
                44.799869,
                37.064223
              ],
              [
                44.799502,
                37.063507
              ],
              [
                44.799499,
                37.063331
              ],
              [
                44.800253,
                37.062886
              ],
              [
                44.800552,
                37.062566
              ],
              [
                44.801196,
                37.062177
              ],
              [
                44.801354,
                37.062028
              ],
              [
                44.801483,
                37.061479
              ],
              [
                44.801461,
                37.06089
              ],
              [
                44.801328,
                37.06082
              ],
              [
                44.801339,
                37.060544
              ],
              [
                44.801476,
                37.060356
              ],
              [
                44.801812,
                37.060252
              ],
              [
                44.802121,
                37.060002
              ],
              [
                44.802465,
                37.059471
              ],
              [
                44.802568,
                37.059077
              ],
              [
                44.802618,
                37.058533
              ],
              [
                44.802859,
                37.057737
              ],
              [
                44.802912,
                37.057397
              ],
              [
                44.803037,
                37.057021
              ],
              [
                44.803182,
                37.056843
              ],
              [
                44.802967,
                37.056412
              ],
              [
                44.803012,
                37.056095
              ],
              [
                44.802968,
                37.055954
              ],
              [
                44.802773,
                37.055834
              ],
              [
                44.802607,
                37.055593
              ],
              [
                44.802563,
                37.055374
              ],
              [
                44.802649,
                37.054741
              ],
              [
                44.802584,
                37.054508
              ],
              [
                44.802587,
                37.053841
              ],
              [
                44.802657,
                37.053552
              ],
              [
                44.803131,
                37.052936
              ],
              [
                44.803784,
                37.052588
              ],
              [
                44.803887,
                37.052444
              ],
              [
                44.803783,
                37.052204
              ],
              [
                44.803454,
                37.051929
              ],
              [
                44.803266,
                37.051618
              ],
              [
                44.803346,
                37.051179
              ],
              [
                44.8032665,
                37.0511138
              ],
              [
                44.802599,
                37.050566
              ],
              [
                44.802427,
                37.050277
              ],
              [
                44.802684,
                37.049795
              ],
              [
                44.802616,
                37.049552
              ],
              [
                44.80253,
                37.049337
              ],
              [
                44.802223,
                37.049076
              ],
              [
                44.801787,
                37.048223
              ],
              [
                44.801953,
                37.04808
              ],
              [
                44.802879,
                37.048118
              ],
              [
                44.803301,
                37.048011
              ],
              [
                44.803889,
                37.04768
              ],
              [
                44.804557,
                37.047397
              ],
              [
                44.804871,
                37.04706
              ],
              [
                44.805131,
                37.046867
              ],
              [
                44.805461,
                37.046768
              ],
              [
                44.805879,
                37.046778
              ],
              [
                44.806708,
                37.046416
              ],
              [
                44.806869,
                37.046143
              ],
              [
                44.806849,
                37.045533
              ],
              [
                44.806937,
                37.044804
              ],
              [
                44.80709,
                37.044413
              ],
              [
                44.807265,
                37.044148
              ],
              [
                44.807642,
                37.04414
              ],
              [
                44.808009,
                37.044229
              ],
              [
                44.808813,
                37.044709
              ],
              [
                44.80939,
                37.044874
              ],
              [
                44.809842,
                37.044952
              ],
              [
                44.810266,
                37.044909
              ],
              [
                44.81079,
                37.044489
              ],
              [
                44.811176,
                37.044251
              ],
              [
                44.811925,
                37.043891
              ],
              [
                44.812678,
                37.043685
              ],
              [
                44.812905,
                37.04343
              ],
              [
                44.813175,
                37.042791
              ],
              [
                44.813619,
                37.042339
              ],
              [
                44.814717,
                37.041415
              ],
              [
                44.815364,
                37.041043
              ],
              [
                44.815935,
                37.040609
              ],
              [
                44.815968,
                37.0405718
              ],
              [
                44.816285,
                37.040214
              ],
              [
                44.81666,
                37.039928
              ],
              [
                44.81708,
                37.039755
              ],
              [
                44.818206,
                37.039746
              ],
              [
                44.819011,
                37.039902
              ],
              [
                44.819207,
                37.040001
              ],
              [
                44.819828,
                37.040933
              ],
              [
                44.820429,
                37.041125
              ],
              [
                44.820513,
                37.041711
              ],
              [
                44.821615,
                37.042083
              ],
              [
                44.822231,
                37.042068
              ],
              [
                44.82307,
                37.04194
              ],
              [
                44.82419,
                37.042232
              ],
              [
                44.825289,
                37.042372
              ],
              [
                44.825913,
                37.042553
              ],
              [
                44.826318,
                37.042861
              ],
              [
                44.82694,
                37.043117
              ],
              [
                44.827293,
                37.04336
              ],
              [
                44.827631,
                37.0437
              ],
              [
                44.828244,
                37.044108
              ],
              [
                44.829226,
                37.04488
              ],
              [
                44.829644,
                37.045028
              ],
              [
                44.830295,
                37.045082
              ],
              [
                44.83063,
                37.045168
              ],
              [
                44.832261,
                37.045004
              ],
              [
                44.832549,
                37.045043
              ],
              [
                44.833491,
                37.045285
              ],
              [
                44.834313,
                37.045657
              ],
              [
                44.834538,
                37.045881
              ],
              [
                44.835297,
                37.046087
              ],
              [
                44.835592,
                37.046099
              ],
              [
                44.836004,
                37.046195
              ],
              [
                44.836883,
                37.04649
              ],
              [
                44.837364,
                37.046557
              ],
              [
                44.838025,
                37.046577
              ],
              [
                44.839229,
                37.046746
              ],
              [
                44.839499,
                37.046953
              ],
              [
                44.839724,
                37.047202
              ],
              [
                44.84032,
                37.047398
              ],
              [
                44.841218,
                37.047994
              ],
              [
                44.841984,
                37.048064
              ],
              [
                44.842311,
                37.048276
              ],
              [
                44.842857,
                37.048438
              ],
              [
                44.8431287,
                37.0484298
              ],
              [
                44.843658,
                37.048309
              ],
              [
                44.84437,
                37.048032
              ],
              [
                44.845467,
                37.047757
              ],
              [
                44.845875,
                37.04756
              ],
              [
                44.846472,
                37.047352
              ],
              [
                44.847351,
                37.047154
              ],
              [
                44.848604,
                37.046391
              ],
              [
                44.849463,
                37.046489
              ],
              [
                44.849751,
                37.046665
              ],
              [
                44.850423,
                37.046947
              ],
              [
                44.850773,
                37.047233
              ],
              [
                44.85113,
                37.047436
              ],
              [
                44.851461,
                37.047506
              ],
              [
                44.851922,
                37.04746
              ],
              [
                44.853399,
                37.047028
              ],
              [
                44.854548,
                37.04709
              ],
              [
                44.85484,
                37.046768
              ],
              [
                44.855414,
                37.046291
              ],
              [
                44.856249,
                37.046009
              ],
              [
                44.856416,
                37.045682
              ],
              [
                44.857017,
                37.044969
              ],
              [
                44.857725,
                37.044457
              ],
              [
                44.858336,
                37.044115
              ],
              [
                44.85857,
                37.043619
              ],
              [
                44.858595,
                37.043182
              ],
              [
                44.858462,
                37.042897
              ],
              [
                44.858134,
                37.041621
              ],
              [
                44.857926,
                37.041496
              ],
              [
                44.857718,
                37.04129
              ],
              [
                44.85737,
                37.040659
              ],
              [
                44.857086,
                37.04031
              ],
              [
                44.857031,
                37.039005
              ],
              [
                44.856862,
                37.03837
              ],
              [
                44.856818,
                37.037957
              ],
              [
                44.856923,
                37.03744
              ],
              [
                44.857073,
                37.037035
              ],
              [
                44.857855,
                37.036959
              ],
              [
                44.858355,
                37.037058
              ],
              [
                44.85887,
                37.037028
              ],
              [
                44.85935,
                37.036658
              ],
              [
                44.859866,
                37.036473
              ],
              [
                44.860316,
                37.036164
              ],
              [
                44.860713,
                37.035836
              ],
              [
                44.860998,
                37.035452
              ],
              [
                44.861381,
                37.035203
              ],
              [
                44.862032,
                37.034876
              ],
              [
                44.863519,
                37.034489
              ],
              [
                44.864132,
                37.034485
              ],
              [
                44.864712,
                37.034335
              ],
              [
                44.86503,
                37.034153
              ],
              [
                44.865536,
                37.033572
              ],
              [
                44.865897,
                37.033386
              ],
              [
                44.866228,
                37.033287
              ],
              [
                44.867109,
                37.032497
              ],
              [
                44.867545,
                37.032399
              ],
              [
                44.867962,
                37.03205
              ],
              [
                44.86834,
                37.031805
              ],
              [
                44.86896,
                37.031558
              ],
              [
                44.870403,
                37.031494
              ],
              [
                44.871036,
                37.031773
              ],
              [
                44.871876,
                37.031785
              ],
              [
                44.8733,
                37.03213
              ],
              [
                44.874238,
                37.032191
              ],
              [
                44.874651,
                37.032265
              ],
              [
                44.875277,
                37.032154
              ],
              [
                44.876031,
                37.031979
              ],
              [
                44.876433,
                37.031837
              ],
              [
                44.877416,
                37.031636
              ],
              [
                44.877799,
                37.031656
              ],
              [
                44.879215,
                37.031449
              ],
              [
                44.88013,
                37.031572
              ],
              [
                44.880249,
                37.031497
              ],
              [
                44.880495,
                37.031161
              ],
              [
                44.880859,
                37.030933
              ],
              [
                44.88117,
                37.030612
              ],
              [
                44.881332,
                37.030371
              ],
              [
                44.881905,
                37.030078
              ],
              [
                44.88221,
                37.030032
              ],
              [
                44.882501,
                37.030028
              ],
              [
                44.883245,
                37.030193
              ],
              [
                44.883658,
                37.030454
              ],
              [
                44.88474,
                37.030794
              ],
              [
                44.885078,
                37.030948
              ],
              [
                44.885553,
                37.03091
              ],
              [
                44.887162,
                37.031222
              ],
              [
                44.889109,
                37.030594
              ],
              [
                44.889543,
                37.030376
              ],
              [
                44.890247,
                37.029928
              ],
              [
                44.890679,
                37.029866
              ],
              [
                44.89137,
                37.029659
              ],
              [
                44.891571,
                37.029398
              ],
              [
                44.891894,
                37.029127
              ],
              [
                44.892215,
                37.029174
              ],
              [
                44.892451,
                37.029369
              ],
              [
                44.893592,
                37.02934
              ],
              [
                44.893885,
                37.029293
              ],
              [
                44.894135,
                37.028784
              ],
              [
                44.895227,
                37.028023
              ],
              [
                44.895414,
                37.027785
              ],
              [
                44.895536,
                37.027473
              ],
              [
                44.895522,
                37.027087
              ],
              [
                44.895359,
                37.02667
              ],
              [
                44.895299,
                37.026323
              ],
              [
                44.895497,
                37.025992
              ],
              [
                44.895977,
                37.025432
              ],
              [
                44.896332,
                37.025304
              ],
              [
                44.896779,
                37.02525
              ],
              [
                44.897078,
                37.025093
              ],
              [
                44.897245,
                37.024847
              ],
              [
                44.897331,
                37.024541
              ],
              [
                44.897627,
                37.024345
              ],
              [
                44.898717,
                37.02393
              ],
              [
                44.899431,
                37.023882
              ],
              [
                44.899758,
                37.023762
              ],
              [
                44.900072,
                37.023729
              ],
              [
                44.90046,
                37.022951
              ],
              [
                44.900482,
                37.022451
              ],
              [
                44.900916,
                37.021715
              ],
              [
                44.9008966,
                37.0212244
              ],
              [
                44.900542,
                37.020806
              ],
              [
                44.900496,
                37.020599
              ],
              [
                44.900538,
                37.020349
              ],
              [
                44.900461,
                37.020065
              ],
              [
                44.900866,
                37.019394
              ],
              [
                44.900794,
                37.019061
              ],
              [
                44.901092,
                37.018852
              ],
              [
                44.901165,
                37.018653
              ],
              [
                44.900882,
                37.01824
              ],
              [
                44.900783,
                37.017922
              ],
              [
                44.901054,
                37.01749
              ],
              [
                44.901375,
                37.017203
              ],
              [
                44.901636,
                37.016506
              ],
              [
                44.901617,
                37.016216
              ],
              [
                44.901448,
                37.015959
              ],
              [
                44.901398,
                37.015004
              ],
              [
                44.900834,
                37.013841
              ],
              [
                44.900983,
                37.013722
              ],
              [
                44.902099,
                37.013283
              ],
              [
                44.902699,
                37.012909
              ],
              [
                44.90298,
                37.01256
              ],
              [
                44.903481,
                37.012209
              ],
              [
                44.903595,
                37.011954
              ],
              [
                44.903621,
                37.011667
              ],
              [
                44.903533,
                37.011176
              ],
              [
                44.903617,
                37.010996
              ],
              [
                44.903802,
                37.010877
              ],
              [
                44.904173,
                37.010518
              ],
              [
                44.90475,
                37.010174
              ],
              [
                44.905143,
                37.010024
              ],
              [
                44.905552,
                37.009779
              ],
              [
                44.905102,
                37.009258
              ],
              [
                44.90468,
                37.008124
              ],
              [
                44.904464,
                37.007225
              ],
              [
                44.904553,
                37.006921
              ],
              [
                44.904532,
                37.005864
              ],
              [
                44.904662,
                37.005239
              ],
              [
                44.904546,
                37.00495
              ],
              [
                44.90447,
                37.004383
              ],
              [
                44.904334,
                37.004162
              ],
              [
                44.904065,
                37.004045
              ],
              [
                44.90316,
                37.003824
              ],
              [
                44.901579,
                37.003634
              ],
              [
                44.900572,
                37.002813
              ],
              [
                44.899686,
                37.002476
              ],
              [
                44.899497,
                37.002313
              ],
              [
                44.899389,
                37.002103
              ],
              [
                44.899157,
                37.001964
              ],
              [
                44.898518,
                37.0017
              ],
              [
                44.898279,
                37.001658
              ],
              [
                44.897796,
                36.999847
              ],
              [
                44.896284,
                36.998445
              ],
              [
                44.895916,
                36.998159
              ],
              [
                44.895569,
                36.998051
              ],
              [
                44.895437,
                36.997627
              ],
              [
                44.895454,
                36.997209
              ],
              [
                44.895723,
                36.996329
              ],
              [
                44.89589,
                36.996064
              ],
              [
                44.895741,
                36.995526
              ],
              [
                44.895836,
                36.99488
              ],
              [
                44.895986,
                36.994693
              ],
              [
                44.89578,
                36.993931
              ],
              [
                44.895628,
                36.993574
              ],
              [
                44.895197,
                36.993183
              ],
              [
                44.894839,
                36.992597
              ],
              [
                44.894665,
                36.992053
              ],
              [
                44.894595,
                36.991436
              ],
              [
                44.894745,
                36.990866
              ],
              [
                44.89501,
                36.990211
              ],
              [
                44.895078,
                36.989847
              ],
              [
                44.894884,
                36.989178
              ],
              [
                44.894624,
                36.988542
              ],
              [
                44.894318,
                36.988064
              ],
              [
                44.894169,
                36.987718
              ],
              [
                44.894062,
                36.986714
              ],
              [
                44.893962,
                36.986465
              ],
              [
                44.892925,
                36.985042
              ],
              [
                44.892777,
                36.984653
              ],
              [
                44.892493,
                36.98319
              ],
              [
                44.89207,
                36.982445
              ],
              [
                44.891919,
                36.981801
              ],
              [
                44.891859,
                36.981322
              ],
              [
                44.891893,
                36.980676
              ],
              [
                44.892069,
                36.979866
              ],
              [
                44.892235,
                36.978579
              ],
              [
                44.891691,
                36.977888
              ],
              [
                44.891604,
                36.977498
              ],
              [
                44.891399,
                36.977172
              ],
              [
                44.890793,
                36.976578
              ],
              [
                44.89026,
                36.976503
              ],
              [
                44.889772,
                36.976239
              ],
              [
                44.889488,
                36.975554
              ],
              [
                44.889745,
                36.973462
              ],
              [
                44.889697,
                36.972788
              ],
              [
                44.889826,
                36.972049
              ],
              [
                44.889543,
                36.971669
              ],
              [
                44.888937,
                36.971577
              ],
              [
                44.88877,
                36.971462
              ],
              [
                44.888387,
                36.970678
              ],
              [
                44.888351,
                36.970194
              ],
              [
                44.888421,
                36.967943
              ],
              [
                44.888299,
                36.967734
              ],
              [
                44.888232,
                36.967103
              ],
              [
                44.887394,
                36.964962
              ],
              [
                44.887371,
                36.964529
              ],
              [
                44.887081,
                36.964112
              ],
              [
                44.886669,
                36.963312
              ],
              [
                44.885191,
                36.96248
              ],
              [
                44.885026,
                36.962221
              ],
              [
                44.884902,
                36.961828
              ],
              [
                44.884586,
                36.961501
              ],
              [
                44.884329,
                36.961121
              ],
              [
                44.884214,
                36.960715
              ],
              [
                44.883978,
                36.960512
              ],
              [
                44.883691,
                36.96001
              ],
              [
                44.883637,
                36.959167
              ],
              [
                44.883931,
                36.957995
              ],
              [
                44.883904,
                36.957498
              ],
              [
                44.88329,
                36.956532
              ],
              [
                44.882852,
                36.95563
              ],
              [
                44.882736,
                36.955171
              ],
              [
                44.882758,
                36.954677
              ],
              [
                44.882687,
                36.954349
              ],
              [
                44.882725,
                36.954011
              ],
              [
                44.882994,
                36.953761
              ],
              [
                44.883405,
                36.953537
              ],
              [
                44.883811,
                36.953198
              ],
              [
                44.884212,
                36.952742
              ],
              [
                44.88473,
                36.951775
              ],
              [
                44.885432,
                36.950711
              ],
              [
                44.885559,
                36.950336
              ],
              [
                44.885025,
                36.948375
              ],
              [
                44.884389,
                36.947711
              ],
              [
                44.884551,
                36.947234
              ],
              [
                44.884828,
                36.946822
              ],
              [
                44.886599,
                36.945992
              ],
              [
                44.887849,
                36.945683
              ],
              [
                44.888732,
                36.94562
              ],
              [
                44.889774,
                36.945849
              ],
              [
                44.890273,
                36.945876
              ],
              [
                44.891142,
                36.945517
              ],
              [
                44.891721,
                36.945424
              ],
              [
                44.892394,
                36.94541
              ],
              [
                44.893125,
                36.945236
              ],
              [
                44.894169,
                36.945325
              ],
              [
                44.894453,
                36.945182
              ],
              [
                44.89458,
                36.94496
              ],
              [
                44.894973,
                36.944858
              ],
              [
                44.896185,
                36.944933
              ],
              [
                44.896642,
                36.943965
              ],
              [
                44.896769,
                36.943398
              ],
              [
                44.896998,
                36.942941
              ],
              [
                44.897767,
                36.941897
              ],
              [
                44.898134,
                36.94116
              ],
              [
                44.898296,
                36.940683
              ],
              [
                44.8983741,
                36.9400165
              ],
              [
                44.898467,
                36.939224
              ],
              [
                44.898675,
                36.938781
              ],
              [
                44.899128,
                36.938529
              ],
              [
                44.899523,
                36.938437
              ],
              [
                44.899917,
                36.938196
              ],
              [
                44.900184,
                36.937839
              ],
              [
                44.900233,
                36.937647
              ],
              [
                44.900134,
                36.936622
              ],
              [
                44.899673,
                36.935873
              ],
              [
                44.899462,
                36.935378
              ],
              [
                44.89982,
                36.934365
              ],
              [
                44.900119,
                36.933992
              ],
              [
                44.900566,
                36.933229
              ],
              [
                44.900577,
                36.932545
              ],
              [
                44.900888,
                36.931295
              ],
              [
                44.901041,
                36.930927
              ],
              [
                44.901765,
                36.930434
              ],
              [
                44.902053,
                36.929967
              ],
              [
                44.902917,
                36.929204
              ],
              [
                44.903627,
                36.927925
              ],
              [
                44.903982,
                36.926849
              ],
              [
                44.904315,
                36.926512
              ],
              [
                44.904741,
                36.925668
              ],
              [
                44.905135,
                36.925426
              ],
              [
                44.905659,
                36.924874
              ],
              [
                44.90608,
                36.924638
              ],
              [
                44.906968,
                36.924308
              ],
              [
                44.907642,
                36.923814
              ],
              [
                44.908306,
                36.923567
              ],
              [
                44.908725,
                36.923524
              ],
              [
                44.909028,
                36.923405
              ],
              [
                44.909827,
                36.922772
              ],
              [
                44.910274,
                36.922062
              ],
              [
                44.910802,
                36.920795
              ],
              [
                44.910767,
                36.919927
              ],
              [
                44.910943,
                36.918872
              ],
              [
                44.911179,
                36.918542
              ],
              [
                44.912229,
                36.917394
              ],
              [
                44.912415,
                36.917009
              ],
              [
                44.912456,
                36.916639
              ],
              [
                44.912184,
                36.91586
              ],
              [
                44.911957,
                36.915492
              ],
              [
                44.911646,
                36.915117
              ],
              [
                44.911511,
                36.91456
              ],
              [
                44.911508,
                36.91425
              ],
              [
                44.911755,
                36.913919
              ],
              [
                44.911838,
                36.913712
              ],
              [
                44.911728,
                36.912794
              ],
              [
                44.911466,
                36.912585
              ],
              [
                44.910541,
                36.912335
              ],
              [
                44.910133,
                36.912132
              ],
              [
                44.909796,
                36.911819
              ],
              [
                44.909661,
                36.911476
              ],
              [
                44.908815,
                36.910311
              ],
              [
                44.9088,
                36.910051
              ],
              [
                44.908939,
                36.909544
              ],
              [
                44.9089657,
                36.9093654
              ],
              [
                44.9142867,
                36.909437
              ],
              [
                44.915397,
                36.9091579
              ],
              [
                44.9187298,
                36.9091579
              ],
              [
                44.9220635,
                36.9097161
              ],
              [
                44.9301199,
                36.9124888
              ],
              [
                44.9433095,
                36.9517972
              ],
              [
                44.9444228,
                36.9520761
              ],
              [
                44.9469228,
                36.9531919
              ],
              [
                44.9483096,
                36.9534619
              ],
              [
                44.9510893,
                36.952913
              ],
              [
                44.9777125,
                36.9564795
              ],
              [
                44.9793789,
                36.9567585
              ],
              [
                44.9816024,
                36.9567586
              ],
              [
                44.9824352,
                36.9564796
              ],
              [
                44.9854892,
                36.9564796
              ],
              [
                44.9866025,
                36.9562007
              ],
              [
                44.9910455,
                36.9562007
              ],
              [
                45.0036921,
                36.9523324
              ],
              [
                45.0042482,
                36.9526113
              ],
              [
                45.0457743,
                36.9332802
              ],
              [
                45.0473765,
                36.9231529
              ],
              [
                45.0510406,
                36.9064704
              ],
              [
                45.0520152,
                36.9010463
              ],
              [
                45.0626251,
                36.9002732
              ],
              [
                45.0705759,
                36.8999806
              ],
              [
                45.0857371,
                36.8990792
              ],
              [
                45.1008332,
                36.8951831
              ],
              [
                45.1068746,
                36.8933595
              ],
              [
                45.1120243,
                36.8923985
              ],
              [
                45.1176865,
                36.8911675
              ],
              [
                45.1281268,
                36.889417
              ],
              [
                45.1462553,
                36.8849757
              ],
              [
                45.1785277,
                36.8808565
              ],
              [
                45.1838492,
                36.88374
              ],
              [
                45.1995139,
                36.8864101
              ],
              [
                45.2138897,
                36.8884084
              ],
              [
                45.2308842,
                36.889644
              ],
              [
                45.2475353,
                36.9025485
              ],
              [
                45.265133,
                36.9209244
              ],
              [
                45.266075,
                36.9299288
              ],
              [
                45.2659892,
                36.9381616
              ],
              [
                45.2663138,
                36.9542745
              ],
              [
                45.2644923,
                36.9575767
              ],
              [
                45.2539955,
                36.9761699
              ],
              [
                45.2525524,
                36.9802988
              ],
              [
                45.250235,
                36.9845546
              ],
              [
                45.2477931,
                36.9931615
              ],
              [
                45.2485656,
                36.9995367
              ],
              [
                45.2556037,
                37.0063226
              ],
              [
                45.2558998,
                37.0191621
              ],
              [
                45.2573342,
                37.0258277
              ],
              [
                45.2627637,
                37.0433884
              ],
              [
                45.2653025,
                37.0487382
              ],
              [
                45.2673378,
                37.0762266
              ],
              [
                45.2685247,
                37.0994477
              ],
              [
                45.2685072,
                37.1079173
              ],
              [
                45.2688594,
                37.1132704
              ],
              [
                45.2704383,
                37.1222208
              ],
              [
                45.2738381,
                37.1322513
              ],
              [
                45.2772036,
                37.140518
              ],
              [
                45.2827017,
                37.1501099
              ],
              [
                45.2775764,
                37.1512869
              ],
              [
                45.2573335,
                37.1672588
              ],
              [
                45.2564998,
                37.1678168
              ],
              [
                45.2503895,
                37.172811
              ],
              [
                45.2364455,
                37.1843395
              ],
              [
                45.2344985,
                37.1843395
              ],
              [
                45.2339454,
                37.1846184
              ],
              [
                45.2331118,
                37.1846185
              ],
              [
                45.2325547,
                37.1848973
              ],
              [
                45.2311648,
                37.1848973
              ],
              [
                45.2306118,
                37.1851762
              ],
              [
                45.2297781,
                37.1851762
              ],
              [
                45.2294984,
                37.1854553
              ],
              [
                45.227832,
                37.1854552
              ],
              [
                45.2256116,
                37.1860041
              ],
              [
                45.2244983,
                37.186004
              ],
              [
                45.2225553,
                37.1865619
              ],
              [
                45.2208888,
                37.186562
              ],
              [
                45.2200552,
                37.1868409
              ],
              [
                45.2189418,
                37.1868409
              ],
              [
                45.2183887,
                37.1871198
              ],
              [
                45.2161652,
                37.1871197
              ],
              [
                45.1964722,
                37.1899473
              ],
              [
                45.195362,
                37.1910542
              ],
              [
                45.1906384,
                37.1963361
              ],
              [
                45.1875852,
                37.2035526
              ],
              [
                45.1873055,
                37.2055052
              ],
              [
                45.1851933,
                37.2391056
              ],
              [
                45.185055,
                37.2395151
              ],
              [
                45.18408,
                37.2407613
              ],
              [
                45.1838035,
                37.2410492
              ],
              [
                45.1829699,
                37.2415981
              ],
              [
                45.1824136,
                37.2415981
              ],
              [
                45.1813034,
                37.2432628
              ],
              [
                45.1776939,
                37.2468802
              ],
              [
                45.1763032,
                37.247708
              ],
              [
                45.1647946,
                37.2590257
              ],
              [
                45.1424786,
                37.2617582
              ],
              [
                45.1253125,
                37.2625779
              ],
              [
                45.0985333,
                37.2773314
              ],
              [
                45.0669476,
                37.2795169
              ],
              [
                45.0422284,
                37.2677693
              ],
              [
                45.0292086,
                37.2612229
              ],
              [
                45.0151751,
                37.2567866
              ],
              [
                45.0125341,
                37.2467613
              ],
              [
                45.0143676,
                37.2415752
              ],
              [
                45.0140903,
                37.2396313
              ],
              [
                45.0112341,
                37.2272259
              ],
              [
                45.010677,
                37.226947
              ],
              [
                45.006234,
                37.2155553
              ],
              [
                45.0009408,
                37.2053196
              ],
              [
                44.9945509,
                37.1986516
              ],
              [
                44.9945509,
                37.1983726
              ],
              [
                44.9906609,
                37.1942061
              ],
              [
                44.9898273,
                37.1925414
              ],
              [
                44.9870515,
                37.1892028
              ],
              [
                44.9859375,
                37.1886538
              ],
              [
                44.9856609,
                37.1880959
              ],
              [
                44.9814944,
                37.1853152
              ],
              [
                44.9767709,
                37.1792049
              ],
              [
                44.9626216,
                37.1655587
              ],
              [
                44.9357588,
                37.1369799
              ],
              [
                44.9315915,
                37.133929
              ],
              [
                44.9290922,
                37.1319851
              ],
              [
                44.9072287,
                37.1172786
              ],
              [
                44.9055623,
                37.1167205
              ],
              [
                44.899452,
                37.1156135
              ],
              [
                44.8941753,
                37.1156135
              ],
              [
                44.8936191,
                37.1153345
              ],
              [
                44.8855626,
                37.1153345
              ],
              [
                44.8838954,
                37.1150555
              ],
              [
                44.8651158,
                37.1188881
              ],
              [
                44.8645596,
                37.1191671
              ],
              [
                44.860393,
                37.1191671
              ],
              [
                44.8543365,
                37.1230324
              ],
              [
                44.8204435,
                37.1321936
              ],
              [
                44.8176669,
                37.1333096
              ],
              [
                44.7984471,
                37.1366618
              ],
              [
                44.7884468,
                37.1413864
              ],
              [
                44.7876141,
                37.1422234
              ],
              [
                44.7844154,
                37.1440877
              ],
              [
                44.7843055,
                37.1438498
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554953,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بوکان",
          "name:en": "Bukan County",
          "name:ku": "Bokan",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1294493"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.6774682,
                36.2544855
              ],
              [
                45.6802939,
                36.2444118
              ],
              [
                45.7077596,
                36.2197646
              ],
              [
                45.7058714,
                36.2156098
              ],
              [
                45.6972146,
                36.2045459
              ],
              [
                45.6982112,
                36.2048322
              ],
              [
                45.6999492,
                36.2060529
              ],
              [
                45.7040262,
                36.2078535
              ],
              [
                45.7066011,
                36.2081998
              ],
              [
                45.7089219,
                36.2078557
              ],
              [
                45.7135445,
                36.2075346
              ],
              [
                45.7348414,
                36.2013748
              ],
              [
                45.7381998,
                36.2003359
              ],
              [
                45.7438775,
                36.1986664
              ],
              [
                45.7487693,
                36.1995873
              ],
              [
                45.7665739,
                36.1948144
              ],
              [
                45.7680276,
                36.1942525
              ],
              [
                45.7792843,
                36.1943675
              ],
              [
                45.7922373,
                36.1945398
              ],
              [
                45.811141,
                36.194788
              ],
              [
                45.8234167,
                36.1949617
              ],
              [
                45.8261438,
                36.1949364
              ],
              [
                45.8381156,
                36.195407
              ],
              [
                45.8501945,
                36.1958325
              ],
              [
                45.883365,
                36.2077042
              ],
              [
                45.9182165,
                36.2361046
              ],
              [
                45.9389876,
                36.2481497
              ],
              [
                45.9539221,
                36.2525796
              ],
              [
                45.9614169,
                36.2572119
              ],
              [
                45.976766,
                36.2647723
              ],
              [
                45.9796559,
                36.269017
              ],
              [
                45.9859371,
                36.2742755
              ],
              [
                45.9895849,
                36.2774931
              ],
              [
                45.988512,
                36.2871104
              ],
              [
                45.9830188,
                36.2993552
              ],
              [
                45.9810446,
                36.307379
              ],
              [
                45.9808992,
                36.3278738
              ],
              [
                45.9732338,
                36.3337964
              ],
              [
                45.9692,
                36.3449967
              ],
              [
                45.9622559,
                36.3551123
              ],
              [
                45.9601878,
                36.372576
              ],
              [
                45.9549464,
                36.380721
              ],
              [
                45.9553472,
                36.3860518
              ],
              [
                45.9602737,
                36.3912331
              ],
              [
                45.9622478,
                36.392615
              ],
              [
                45.9667968,
                36.393375
              ],
              [
                45.9716031,
                36.3914406
              ],
              [
                45.976839,
                36.3924768
              ],
              [
                45.9820747,
                36.3956549
              ],
              [
                45.9813019,
                36.3995931
              ],
              [
                45.9826755,
                36.4123725
              ],
              [
                45.9859508,
                36.4210071
              ],
              [
                45.988323,
                36.4241959
              ],
              [
                45.9916505,
                36.4285528
              ],
              [
                45.9951639,
                36.4301569
              ],
              [
                45.999349,
                36.4313014
              ],
              [
                46.0031032,
                36.4328156
              ],
              [
                46.0085455,
                36.4336523
              ],
              [
                46.0154534,
                36.4277659
              ],
              [
                46.0282295,
                36.4316484
              ],
              [
                46.0399243,
                36.4218352
              ],
              [
                46.0657873,
                36.4242993
              ],
              [
                46.0711666,
                36.4381329
              ],
              [
                46.1038682,
                36.4442091
              ],
              [
                46.1193097,
                36.4534077
              ],
              [
                46.1538272,
                36.459454
              ],
              [
                46.1608982,
                36.4550264
              ],
              [
                46.1614553,
                36.4550265
              ],
              [
                46.1757716,
                36.4486715
              ],
              [
                46.176881,
                36.4486715
              ],
              [
                46.1785482,
                36.4481131
              ],
              [
                46.1802147,
                36.4481131
              ],
              [
                46.1843843,
                36.4470049
              ],
              [
                46.1857711,
                36.447005
              ],
              [
                46.1864834,
                36.4457147
              ],
              [
                46.1918017,
                36.4397556
              ],
              [
                46.1949777,
                36.4357504
              ],
              [
                46.1972382,
                36.4312573
              ],
              [
                46.2001276,
                36.4293627
              ],
              [
                46.2036895,
                36.4283614
              ],
              [
                46.2082386,
                36.4280851
              ],
              [
                46.2157058,
                36.4249429
              ],
              [
                46.2248039,
                36.4201774
              ],
              [
                46.2337732,
                36.4158606
              ],
              [
                46.2449312,
                36.408746
              ],
              [
                46.2537717,
                36.4052231
              ],
              [
                46.260638,
                36.4028563
              ],
              [
                46.2691783,
                36.3988674
              ],
              [
                46.2750148,
                36.3965185
              ],
              [
                46.2807226,
                36.3935822
              ],
              [
                46.2896718,
                36.3887665
              ],
              [
                46.2933436,
                36.3860813
              ],
              [
                46.2968158,
                36.3827343
              ],
              [
                46.299634,
                36.3808164
              ],
              [
                46.303339,
                36.3785882
              ],
              [
                46.3090896,
                36.3763078
              ],
              [
                46.3194175,
                36.3742036
              ],
              [
                46.3262106,
                36.3732678
              ],
              [
                46.3326501,
                36.3724031
              ],
              [
                46.3480358,
                36.3725642
              ],
              [
                46.357313,
                36.3730531
              ],
              [
                46.3679424,
                36.372397
              ],
              [
                46.3737947,
                36.3715995
              ],
              [
                46.378551,
                36.3703583
              ],
              [
                46.3845563,
                36.3686997
              ],
              [
                46.3955211,
                36.3654574
              ],
              [
                46.4036747,
                36.3617944
              ],
              [
                46.4088678,
                36.359686
              ],
              [
                46.4117002,
                36.3603427
              ],
              [
                46.4173218,
                36.3653885
              ],
              [
                46.4226436,
                36.3718157
              ],
              [
                46.4275826,
                36.3799342
              ],
              [
                46.4304203,
                36.3849525
              ],
              [
                46.4344024,
                36.3934441
              ],
              [
                46.4380825,
                36.4017879
              ],
              [
                46.4399151,
                36.4052562
              ],
              [
                46.4446103,
                36.4110449
              ],
              [
                46.4515819,
                36.4159346
              ],
              [
                46.4548198,
                36.4176815
              ],
              [
                46.4583339,
                36.4187693
              ],
              [
                46.4645519,
                36.4201018
              ],
              [
                46.4724163,
                36.4208961
              ],
              [
                46.478838,
                36.4211122
              ],
              [
                46.4850494,
                36.4208014
              ],
              [
                46.4911575,
                36.4204591
              ],
              [
                46.4960501,
                36.4196476
              ],
              [
                46.4997915,
                36.4188045
              ],
              [
                46.5027143,
                36.4181368
              ],
              [
                46.5033908,
                36.4175384
              ],
              [
                46.5075573,
                36.41703
              ],
              [
                46.5094112,
                36.4166903
              ],
              [
                46.5152109,
                36.4146723
              ],
              [
                46.5173618,
                36.4135326
              ],
              [
                46.5198636,
                36.4123689
              ],
              [
                46.5221948,
                36.4112512
              ],
              [
                46.524148,
                36.4105467
              ],
              [
                46.5258168,
                36.4100229
              ],
              [
                46.5268971,
                36.4096782
              ],
              [
                46.5283012,
                36.408228
              ],
              [
                46.5288162,
                36.4069155
              ],
              [
                46.5296745,
                36.4056721
              ],
              [
                46.5306615,
                36.4041178
              ],
              [
                46.5320777,
                36.4022871
              ],
              [
                46.5334081,
                36.4014236
              ],
              [
                46.5355753,
                36.4029261
              ],
              [
                46.537013,
                36.4045841
              ],
              [
                46.5379571,
                36.4063111
              ],
              [
                46.5380001,
                36.4079862
              ],
              [
                46.5375709,
                36.4089187
              ],
              [
                46.5356397,
                36.4106802
              ],
              [
                46.5315198,
                36.4138576
              ],
              [
                46.5278291,
                36.4166204
              ],
              [
                46.523323,
                36.4190723
              ],
              [
                46.5184307,
                36.4214206
              ],
              [
                46.5133667,
                36.4229055
              ],
              [
                46.5098905,
                36.4246666
              ],
              [
                46.5068435,
                36.4270147
              ],
              [
                46.5042257,
                36.4307439
              ],
              [
                46.503067,
                36.4341967
              ],
              [
                46.5026807,
                36.439272
              ],
              [
                46.5034961,
                36.4535294
              ],
              [
                46.5046548,
                36.4577406
              ],
              [
                46.5054702,
                36.4610196
              ],
              [
                46.5068006,
                36.4638153
              ],
              [
                46.508646,
                36.4663347
              ],
              [
                46.51268,
                36.4708213
              ],
              [
                46.5165424,
                36.4746174
              ],
              [
                46.5185165,
                36.4768604
              ],
              [
                46.5213489,
                36.4814154
              ],
              [
                46.5223789,
                36.4845554
              ],
              [
                46.5223789,
                36.4860045
              ],
              [
                46.5215635,
                36.4872467
              ],
              [
                46.5200185,
                36.4882128
              ],
              [
                46.5180444,
                36.4892478
              ],
              [
                46.5160703,
                36.4903864
              ],
              [
                46.5136671,
                36.491594
              ],
              [
                46.5088176,
                36.4941816
              ],
              [
                46.5057277,
                36.4964931
              ],
              [
                46.505314,
                36.4973204
              ],
              [
                46.5040969,
                36.5005984
              ],
              [
                46.5041827,
                36.5028062
              ],
              [
                46.5049552,
                36.5054969
              ],
              [
                46.5063285,
                36.5075666
              ],
              [
                46.5068435,
                36.5089464
              ],
              [
                46.5078734,
                36.510671
              ],
              [
                46.5089892,
                36.5128785
              ],
              [
                46.5099978,
                36.5142065
              ],
              [
                46.5107702,
                36.5154309
              ],
              [
                46.5125512,
                36.5180522
              ],
              [
                46.5144395,
                36.5202939
              ],
              [
                46.5150833,
                36.5212941
              ],
              [
                46.5161776,
                36.5227599
              ],
              [
                46.5173363,
                36.5240876
              ],
              [
                46.5181303,
                36.5248636
              ],
              [
                46.5178299,
                36.5270362
              ],
              [
                46.5173578,
                36.527588
              ],
              [
                46.5174222,
                36.5295536
              ],
              [
                46.5177011,
                36.530295
              ],
              [
                46.516478,
                36.5321399
              ],
              [
                46.5157699,
                36.5332951
              ],
              [
                46.5150494,
                36.5345383
              ],
              [
                46.5133238,
                36.5372261
              ],
              [
                46.5119076,
                36.5387777
              ],
              [
                46.5105557,
                36.5406914
              ],
              [
                46.5066718,
                36.5482593
              ],
              [
                46.5052379,
                36.5534372
              ],
              [
                46.4998912,
                36.5608766
              ],
              [
                46.4920806,
                36.5679772
              ],
              [
                46.4808368,
                36.5832793
              ],
              [
                46.4775752,
                36.5882414
              ],
              [
                46.4722425,
                36.599689
              ],
              [
                46.4710521,
                36.6055376
              ],
              [
                46.4701079,
                36.6204878
              ],
              [
                46.4700534,
                36.6253817
              ],
              [
                46.467226,
                36.6386481
              ],
              [
                46.4642886,
                36.6460991
              ],
              [
                46.4595982,
                36.6531608
              ],
              [
                46.4541549,
                36.6581202
              ],
              [
                46.4495603,
                36.6616549
              ],
              [
                46.447661,
                36.6641411
              ],
              [
                46.4462711,
                36.6644202
              ],
              [
                46.4446039,
                36.6644202
              ],
              [
                46.4430204,
                36.6666331
              ],
              [
                46.4416305,
                36.666633
              ],
              [
                46.4369108,
                36.6680199
              ],
              [
                46.4360773,
                36.6680198
              ],
              [
                46.421681,
                36.6788388
              ],
              [
                46.4211239,
                36.6788387
              ],
              [
                46.4202911,
                36.6796761
              ],
              [
                46.4038507,
                36.699141
              ],
              [
                46.4041312,
                36.6994202
              ],
              [
                46.4041312,
                36.7005369
              ],
              [
                46.3986379,
                36.7021911
              ],
              [
                46.3983575,
                36.7027494
              ],
              [
                46.3982947,
                36.7069028
              ],
              [
                46.3977376,
                36.7088479
              ],
              [
                46.3957946,
                36.7119001
              ],
              [
                46.3957946,
                36.7124584
              ],
              [
                46.383247,
                36.7157701
              ],
              [
                46.3599988,
                36.7307919
              ],
              [
                46.3557216,
                36.7427491
              ],
              [
                46.3561645,
                36.7471971
              ],
              [
                46.355888,
                36.7474762
              ],
              [
                46.3579094,
                36.7556221
              ],
              [
                46.3632283,
                36.7684187
              ],
              [
                46.3629486,
                36.7689769
              ],
              [
                46.3633723,
                36.7855036
              ],
              [
                46.3630957,
                36.7863319
              ],
              [
                46.3633723,
                36.789672
              ],
              [
                46.3630957,
                36.7902213
              ],
              [
                46.3605929,
                36.7990225
              ],
              [
                46.3563014,
                36.8066647
              ],
              [
                46.3560209,
                36.8069438
              ],
              [
                46.3371094,
                36.8228596
              ],
              [
                46.3368328,
                36.8231389
              ],
              [
                46.3294675,
                36.8281494
              ],
              [
                46.3289144,
                36.8287077
              ],
              [
                46.3194681,
                36.829257
              ],
              [
                46.2969015,
                36.8298978
              ],
              [
                46.2816237,
                36.8337449
              ],
              [
                46.2444102,
                36.8405784
              ],
              [
                46.2372586,
                36.8389295
              ],
              [
                46.2358687,
                36.8389295
              ],
              [
                46.2350359,
                36.8392086
              ],
              [
                46.2254511,
                36.8360574
              ],
              [
                46.205099,
                36.8343185
              ],
              [
                46.1799445,
                36.84151
              ],
              [
                46.1755014,
                36.84151
              ],
              [
                46.1746678,
                36.841789
              ],
              [
                46.1688349,
                36.841789
              ],
              [
                46.1671676,
                36.8420592
              ],
              [
                46.1660544,
                36.841789
              ],
              [
                46.1618878,
                36.8420592
              ],
              [
                46.1599449,
                36.8423383
              ],
              [
                46.1574447,
                36.8423383
              ],
              [
                46.1560549,
                36.8426174
              ],
              [
                46.1477212,
                36.8426173
              ],
              [
                46.1466117,
                36.8428965
              ],
              [
                46.143278,
                36.8428965
              ],
              [
                46.1421647,
                36.8431756
              ],
              [
                46.140778,
                36.8428966
              ],
              [
                46.1404983,
                36.8431756
              ],
              [
                46.133454,
                36.8464993
              ],
              [
                46.1141691,
                36.8541776
              ],
              [
                46.1127785,
                36.8547358
              ],
              [
                46.1102784,
                36.8555731
              ],
              [
                46.1055588,
                36.8575178
              ],
              [
                46.1041689,
                36.8575177
              ],
              [
                46.1036119,
                36.8577968
              ],
              [
                46.102779,
                36.8577968
              ],
              [
                46.1025024,
                36.8580759
              ],
              [
                46.1011126,
                36.8580759
              ],
              [
                46.0892304,
                36.8625406
              ],
              [
                46.0886741,
                36.8628198
              ],
              [
                46.0867303,
                36.8628198
              ],
              [
                46.0853404,
                36.8630988
              ],
              [
                46.0735554,
                36.8620979
              ],
              [
                46.0529705,
                36.8540766
              ],
              [
                46.0330522,
                36.8462443
              ],
              [
                46.0309123,
                36.8309969
              ],
              [
                46.0229417,
                36.8119605
              ],
              [
                46.0107043,
                36.8018036
              ],
              [
                45.9960883,
                36.7901994
              ],
              [
                45.9961886,
                36.7860801
              ],
              [
                45.9953551,
                36.783307
              ],
              [
                45.9943919,
                36.7728093
              ],
              [
                45.9955021,
                36.7705852
              ],
              [
                46.0035056,
                36.7611046
              ],
              [
                46.0189816,
                36.7553903
              ],
              [
                46.0201716,
                36.7499935
              ],
              [
                46.023785,
                36.7469411
              ],
              [
                46.0313179,
                36.7347974
              ],
              [
                46.0324282,
                36.7339601
              ],
              [
                46.0327087,
                36.7334017
              ],
              [
                46.0338181,
                36.7328433
              ],
              [
                46.0397819,
                36.7209182
              ],
              [
                46.040335,
                36.717307
              ],
              [
                46.0452083,
                36.7117348
              ],
              [
                46.0418755,
                36.7042332
              ],
              [
                46.0186627,
                36.6942395
              ],
              [
                46.032215,
                36.6897958
              ],
              [
                46.0341589,
                36.6878505
              ],
              [
                46.0347151,
                36.6878505
              ],
              [
                46.0352721,
                36.6870129
              ],
              [
                46.0598986,
                36.6749942
              ],
              [
                46.0601752,
                36.6747151
              ],
              [
                46.0596182,
                36.6716533
              ],
              [
                46.0560581,
                36.667678
              ],
              [
                46.0535589,
                36.665454
              ],
              [
                46.0532816,
                36.6651748
              ],
              [
                46.0527253,
                36.6651748
              ],
              [
                46.0496682,
                36.663518
              ],
              [
                46.0482784,
                36.6632389
              ],
              [
                46.0261914,
                36.662636
              ],
              [
                46.004562,
                36.6565769
              ],
              [
                45.9884259,
                36.6400497
              ],
              [
                45.9735032,
                36.6436017
              ],
              [
                45.9648928,
                36.6436016
              ],
              [
                45.9352759,
                36.6384049
              ],
              [
                45.9124877,
                36.6275686
              ],
              [
                45.9093761,
                36.6270319
              ],
              [
                45.9017801,
                36.6264464
              ],
              [
                45.8932828,
                36.6270319
              ],
              [
                45.8872152,
                36.6271896
              ],
              [
                45.8783152,
                36.6280852
              ],
              [
                45.8709823,
                36.6281922
              ],
              [
                45.8687998,
                36.6276992
              ],
              [
                45.8692199,
                36.6268013
              ],
              [
                45.8691564,
                36.6245071
              ],
              [
                45.8688682,
                36.6226287
              ],
              [
                45.8673191,
                36.616561
              ],
              [
                45.8658599,
                36.606709
              ],
              [
                45.8667179,
                36.5913429
              ],
              [
                45.8684347,
                36.5805224
              ],
              [
                45.8731743,
                36.569337
              ],
              [
                45.8738608,
                36.5628297
              ],
              [
                45.8740738,
                36.5574253
              ],
              [
                45.870323,
                36.541088
              ],
              [
                45.8796474,
                36.5270109
              ],
              [
                45.8848914,
                36.5073176
              ],
              [
                45.8858878,
                36.5010642
              ],
              [
                45.8892208,
                36.4927332
              ],
              [
                45.8914444,
                36.4838436
              ],
              [
                45.8917208,
                36.4832851
              ],
              [
                45.8931116,
                36.4760707
              ],
              [
                45.8906116,
                36.4616236
              ],
              [
                45.8914374,
                36.4520798
              ],
              [
                45.8862875,
                36.4435185
              ],
              [
                45.8756445,
                36.425012
              ],
              [
                45.8628031,
                36.4085549
              ],
              [
                45.8579899,
                36.4050657
              ],
              [
                45.8439501,
                36.400606
              ],
              [
                45.8164213,
                36.3928223
              ],
              [
                45.7983969,
                36.3878476
              ],
              [
                45.7856938,
                36.3820435
              ],
              [
                45.7826629,
                36.3760944
              ],
              [
                45.7802165,
                36.3680279
              ],
              [
                45.7696265,
                36.3505254
              ],
              [
                45.7657779,
                36.3417789
              ],
              [
                45.757713,
                36.3267434
              ],
              [
                45.7459935,
                36.3160868
              ],
              [
                45.7359387,
                36.3070286
              ],
              [
                45.7264561,
                36.3006713
              ],
              [
                45.6996911,
                36.28123
              ],
              [
                45.6774682,
                36.2544855
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554967,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تکاب",
          "name:en": "Takab County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q967807",
          "wikipedia": "en:Takab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.8283939,
                36.4383638
              ],
              [
                46.8295041,
                36.4380936
              ],
              [
                46.8297806,
                36.4378144
              ],
              [
                46.8308939,
                36.4378144
              ],
              [
                46.849373,
                36.4184417
              ],
              [
                46.8659267,
                36.3941974
              ],
              [
                46.8777542,
                36.3835732
              ],
              [
                46.8868512,
                36.3778213
              ],
              [
                46.8905838,
                36.3676668
              ],
              [
                46.8896565,
                36.3592963
              ],
              [
                46.8934544,
                36.3495927
              ],
              [
                46.8975447,
                36.3452732
              ],
              [
                46.905102,
                36.3419882
              ],
              [
                46.9202883,
                36.3401852
              ],
              [
                46.942005,
                36.3386361
              ],
              [
                46.9615744,
                36.337115
              ],
              [
                46.9736602,
                36.3355973
              ],
              [
                47.0310556,
                36.3060993
              ],
              [
                47.031336,
                36.30582
              ],
              [
                47.042169,
                36.2974865
              ],
              [
                47.042169,
                36.2972073
              ],
              [
                47.0427221,
                36.2972072
              ],
              [
                47.0435558,
                36.2963694
              ],
              [
                47.0455019,
                36.2952612
              ],
              [
                47.0621741,
                36.28151
              ],
              [
                47.0656596,
                36.2765801
              ],
              [
                47.0680904,
                36.274241
              ],
              [
                47.0720386,
                36.2718191
              ],
              [
                47.0789257,
                36.2708602
              ],
              [
                47.083322,
                36.2679466
              ],
              [
                47.0892905,
                36.2606081
              ],
              [
                47.0952987,
                36.2558326
              ],
              [
                47.1038818,
                36.252095
              ],
              [
                47.1160697,
                36.2507799
              ],
              [
                47.1310618,
                36.250538
              ],
              [
                47.1503798,
                36.2513417
              ],
              [
                47.1872937,
                36.2502378
              ],
              [
                47.2112691,
                36.2503705
              ],
              [
                47.2266196,
                36.2514029
              ],
              [
                47.2486369,
                36.2520486
              ],
              [
                47.2933101,
                36.2556942
              ],
              [
                47.3117647,
                36.259455
              ],
              [
                47.3248099,
                36.2668367
              ],
              [
                47.3291015,
                36.2687051
              ],
              [
                47.3395729,
                36.278185
              ],
              [
                47.3472976,
                36.2878023
              ],
              [
                47.3549153,
                36.2963912
              ],
              [
                47.3614668,
                36.3058531
              ],
              [
                47.3658983,
                36.3120193
              ],
              [
                47.370766,
                36.3174458
              ],
              [
                47.3757934,
                36.3217643
              ],
              [
                47.3889736,
                36.3290032
              ],
              [
                47.3973741,
                36.3296076
              ],
              [
                47.4091815,
                36.3263975
              ],
              [
                47.4263476,
                36.324807
              ],
              [
                47.4302101,
                36.3235623
              ],
              [
                47.4460885,
                36.3214188
              ],
              [
                47.4568176,
                36.3196205
              ],
              [
                47.465057,
                36.3187216
              ],
              [
                47.4920079,
                36.3360089
              ],
              [
                47.5253102,
                36.3635224
              ],
              [
                47.5131549,
                36.3910319
              ],
              [
                47.5131808,
                36.3911143
              ],
              [
                47.5183364,
                36.3960848
              ],
              [
                47.5183364,
                36.3963641
              ],
              [
                47.5071679,
                36.3963705
              ],
              [
                47.5069172,
                36.397196
              ],
              [
                47.4902416,
                36.3990154
              ],
              [
                47.4914504,
                36.4032449
              ],
              [
                47.4887463,
                36.3991786
              ],
              [
                47.4879121,
                36.3992346
              ],
              [
                47.4840119,
                36.3994962
              ],
              [
                47.4640271,
                36.4008366
              ],
              [
                47.4293515,
                36.3958624
              ],
              [
                47.3881527,
                36.4171387
              ],
              [
                47.3696133,
                36.43178
              ],
              [
                47.3751061,
                36.455532
              ],
              [
                47.3950188,
                36.473203
              ],
              [
                47.4578116,
                36.5024179
              ],
              [
                47.4586445,
                36.5043631
              ],
              [
                47.4586445,
                36.5046423
              ],
              [
                47.4597546,
                36.507146
              ],
              [
                47.4603116,
                36.5110365
              ],
              [
                47.4597546,
                36.5127026
              ],
              [
                47.458921,
                36.5165842
              ],
              [
                47.4586444,
                36.5179709
              ],
              [
                47.4583646,
                36.5188085
              ],
              [
                47.4578115,
                36.5204746
              ],
              [
                47.456978,
                36.5226991
              ],
              [
                47.4533646,
                36.5288049
              ],
              [
                47.4142449,
                36.5361232
              ],
              [
                47.3943322,
                36.5504662
              ],
              [
                47.3771661,
                36.5598429
              ],
              [
                47.3702399,
                36.5726373
              ],
              [
                47.3434775,
                36.614683
              ],
              [
                47.3232004,
                36.6427341
              ],
              [
                47.3229208,
                36.6435716
              ],
              [
                47.3212543,
                36.6457958
              ],
              [
                47.2920314,
                36.6693083
              ],
              [
                47.2786983,
                36.6809813
              ],
              [
                47.2784216,
                36.6812603
              ],
              [
                47.2778646,
                36.6815396
              ],
              [
                47.2713451,
                36.7008326
              ],
              [
                47.270231,
                36.7011117
              ],
              [
                47.2615784,
                36.7185076
              ],
              [
                47.2123715,
                36.7685925
              ],
              [
                47.1813416,
                36.7886056
              ],
              [
                47.1810651,
                36.789443
              ],
              [
                47.1810651,
                36.7902714
              ],
              [
                47.1802322,
                36.7911087
              ],
              [
                47.1802322,
                36.7913878
              ],
              [
                47.1799518,
                36.791667
              ],
              [
                47.1782853,
                36.7938818
              ],
              [
                47.1777322,
                36.7949982
              ],
              [
                47.1643954,
                36.8016609
              ],
              [
                47.1638392,
                36.80194
              ],
              [
                47.1618923,
                36.8038848
              ],
              [
                47.1532819,
                36.8113847
              ],
              [
                47.1449488,
                36.8275006
              ],
              [
                47.1405026,
                36.8322183
              ],
              [
                47.1374486,
                36.8330556
              ],
              [
                47.1332822,
                36.8336047
              ],
              [
                47.1307821,
                36.8330556
              ],
              [
                47.1205022,
                36.8275006
              ],
              [
                47.119946,
                36.8269424
              ],
              [
                47.1182795,
                36.8269424
              ],
              [
                47.111059,
                36.8302735
              ],
              [
                47.1068925,
                36.8319391
              ],
              [
                47.1049464,
                36.8324973
              ],
              [
                47.1024463,
                36.8324973
              ],
              [
                47.0993892,
                36.8313809
              ],
              [
                47.0974463,
                36.8313809
              ],
              [
                47.0963361,
                36.8311108
              ],
              [
                47.0766131,
                36.8194425
              ],
              [
                47.0721669,
                36.8166694
              ],
              [
                47.0710566,
                36.8163904
              ],
              [
                47.0696668,
                36.815274
              ],
              [
                47.0599432,
                36.8108352
              ],
              [
                47.0493867,
                36.8072158
              ],
              [
                47.0485531,
                36.8072158
              ],
              [
                47.0407771,
                36.8033263
              ],
              [
                47.0368872,
                36.8013815
              ],
              [
                47.0363334,
                36.8008322
              ],
              [
                47.0218869,
                36.7908292
              ],
              [
                47.0204971,
                36.7891635
              ],
              [
                47.0185542,
                36.7686077
              ],
              [
                47.0179971,
                36.7661046
              ],
              [
                47.0177205,
                36.7649971
              ],
              [
                47.0116072,
                36.7544354
              ],
              [
                47.0038305,
                36.747223
              ],
              [
                47.0029977,
                36.7466648
              ],
              [
                46.9979975,
                36.7452781
              ],
              [
                46.9949413,
                36.7469438
              ],
              [
                46.9941076,
                36.7477723
              ],
              [
                46.9798381,
                36.6771569
              ],
              [
                46.9795615,
                36.6768778
              ],
              [
                46.9579693,
                36.6174569
              ],
              [
                46.9486996,
                36.6135989
              ],
              [
                46.9432616,
                36.602751
              ],
              [
                46.946983,
                36.586312
              ],
              [
                46.9294735,
                36.5529481
              ],
              [
                46.902351,
                36.5237085
              ],
              [
                46.8860622,
                36.5208879
              ],
              [
                46.8855059,
                36.5203293
              ],
              [
                46.8790051,
                36.5088086
              ],
              [
                46.8812423,
                36.4991791
              ],
              [
                46.8815188,
                36.4986207
              ],
              [
                46.883465,
                36.4972335
              ],
              [
                46.8776702,
                36.4840956
              ],
              [
                46.8779499,
                36.4829788
              ],
              [
                46.8682701,
                36.4727704
              ],
              [
                46.8679936,
                36.4719328
              ],
              [
                46.8679936,
                36.4694287
              ],
              [
                46.8679935,
                36.4688793
              ],
              [
                46.8674364,
                36.4677624
              ],
              [
                46.8563238,
                36.4599889
              ],
              [
                46.8557706,
                36.4591511
              ],
              [
                46.8343731,
                36.458017
              ],
              [
                46.8333778,
                36.4510764
              ],
              [
                46.8328245,
                36.4499685
              ],
              [
                46.8283939,
                36.4383638
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555007,
        "tags": {
          "admin_level": "5",
          "alt_name": "Choj",
          "boundary": "administrative",
          "name": "شهرستان خوی",
          "name:ar": "خوي",
          "name:de": "Choy",
          "name:en": "Khoy County",
          "name:fa": "خوی",
          "name:hi": "ख्वोय",
          "name:hy": "Հեր",
          "name:ku": "Xoy",
          "name:pt": "Coi",
          "name:ru": "Хой",
          "name:sh": "Hoj",
          "name:tg": "Хуй",
          "name:th": "โฆย์",
          "name:tr": "Hoy",
          "name:ur": "خوی",
          "name:zh": "霍伊",
          "name:zza": "Xoy",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282135",
          "wikipedia": "en:Khoy County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.2542973,
                38.7190364
              ],
              [
                44.2540673,
                38.718334
              ],
              [
                44.2541815,
                38.717862
              ],
              [
                44.2546244,
                38.7174384
              ],
              [
                44.2573559,
                38.7165893
              ],
              [
                44.2590046,
                38.7159239
              ],
              [
                44.2601131,
                38.7153376
              ],
              [
                44.2608988,
                38.7147018
              ],
              [
                44.2610128,
                38.7141768
              ],
              [
                44.2608694,
                38.7127633
              ],
              [
                44.2611547,
                38.7113503
              ],
              [
                44.2609856,
                38.7105746
              ],
              [
                44.2610629,
                38.7100623
              ],
              [
                44.2613509,
                38.7094249
              ],
              [
                44.2612575,
                38.7085299
              ],
              [
                44.2608713,
                38.7076127
              ],
              [
                44.2607008,
                38.7062521
              ],
              [
                44.2607687,
                38.7052874
              ],
              [
                44.2612371,
                38.7041787
              ],
              [
                44.262236,
                38.7036269
              ],
              [
                44.2628406,
                38.7036289
              ],
              [
                44.2644143,
                38.7041072
              ],
              [
                44.2649807,
                38.7046086
              ],
              [
                44.2655482,
                38.704888
              ],
              [
                44.2661524,
                38.7049733
              ],
              [
                44.2677889,
                38.7048953
              ],
              [
                44.268537,
                38.7046757
              ],
              [
                44.2691431,
                38.7044001
              ],
              [
                44.2698578,
                38.7037641
              ],
              [
                44.2714288,
                38.7026035
              ],
              [
                44.2713234,
                38.7022998
              ],
              [
                44.2710415,
                38.7017993
              ],
              [
                44.2705121,
                38.7011018
              ],
              [
                44.2694599,
                38.6991673
              ],
              [
                44.269405,
                38.6972487
              ],
              [
                44.2694747,
                38.6962886
              ],
              [
                44.2700711,
                38.6955262
              ],
              [
                44.2702772,
                38.6945932
              ],
              [
                44.2705385,
                38.6939582
              ],
              [
                44.2709855,
                38.6933987
              ],
              [
                44.2716891,
                38.6926273
              ],
              [
                44.2723856,
                38.6919685
              ],
              [
                44.2732609,
                38.6909351
              ],
              [
                44.2735923,
                38.6899112
              ],
              [
                44.2735778,
                38.6888485
              ],
              [
                44.2733774,
                38.6883203
              ],
              [
                44.2730911,
                38.6879344
              ],
              [
                44.2726047,
                38.6864975
              ],
              [
                44.2721293,
                38.6858304
              ],
              [
                44.2718749,
                38.6852133
              ],
              [
                44.2718366,
                38.684796
              ],
              [
                44.2720576,
                38.6844525
              ],
              [
                44.27344,
                38.6830338
              ],
              [
                44.27534,
                38.6809697
              ],
              [
                44.2763587,
                38.6802816
              ],
              [
                44.2769303,
                38.6799907
              ],
              [
                44.2777149,
                38.6797867
              ],
              [
                44.2780647,
                38.6795644
              ],
              [
                44.2787017,
                38.6784823
              ],
              [
                44.2796493,
                38.6777934
              ],
              [
                44.2800466,
                38.6772939
              ],
              [
                44.2804441,
                38.6770175
              ],
              [
                44.2810412,
                38.6768091
              ],
              [
                44.2818448,
                38.6763152
              ],
              [
                44.2823972,
                38.6756679
              ],
              [
                44.2826414,
                38.674969
              ],
              [
                44.2825959,
                38.6742417
              ],
              [
                44.2823208,
                38.6735542
              ],
              [
                44.2812189,
                38.6726287
              ],
              [
                44.2808055,
                38.6712907
              ],
              [
                44.280102,
                38.6696232
              ],
              [
                44.2799304,
                38.6689078
              ],
              [
                44.2798984,
                38.6680304
              ],
              [
                44.2799923,
                38.6673009
              ],
              [
                44.2802388,
                38.6667609
              ],
              [
                44.2808851,
                38.6656957
              ],
              [
                44.2813893,
                38.6644736
              ],
              [
                44.281571,
                38.6630314
              ],
              [
                44.2815212,
                38.662423
              ],
              [
                44.2809587,
                38.6614141
              ],
              [
                44.2796018,
                38.6602245
              ],
              [
                44.2794013,
                38.659589
              ],
              [
                44.2794899,
                38.6586204
              ],
              [
                44.2794604,
                38.6576283
              ],
              [
                44.2792605,
                38.6571906
              ],
              [
                44.2786284,
                38.6566781
              ],
              [
                44.2778307,
                38.6563344
              ],
              [
                44.2764993,
                38.6559867
              ],
              [
                44.2751083,
                38.6556918
              ],
              [
                44.2735252,
                38.655561
              ],
              [
                44.2728633,
                38.6554093
              ],
              [
                44.2723502,
                38.6549666
              ],
              [
                44.271532,
                38.6538061
              ],
              [
                44.2704646,
                38.6527097
              ],
              [
                44.2696033,
                38.6514239
              ],
              [
                44.2693126,
                38.6508529
              ],
              [
                44.2694442,
                38.6502709
              ],
              [
                44.2697285,
                38.6499034
              ],
              [
                44.2702803,
                38.6495536
              ],
              [
                44.2708747,
                38.6490196
              ],
              [
                44.2713017,
                38.6482502
              ],
              [
                44.271718,
                38.6470127
              ],
              [
                44.2721185,
                38.6462477
              ],
              [
                44.2726619,
                38.6456616
              ],
              [
                44.2738091,
                38.645216
              ],
              [
                44.275132,
                38.6448415
              ],
              [
                44.2762633,
                38.6442395
              ],
              [
                44.27748,
                38.6434549
              ],
              [
                44.279193,
                38.6426918
              ],
              [
                44.2814012,
                38.6415394
              ],
              [
                44.2828636,
                38.6410991
              ],
              [
                44.2837038,
                38.6411226
              ],
              [
                44.2843093,
                38.6412307
              ],
              [
                44.2848211,
                38.6412298
              ],
              [
                44.2857321,
                38.6410083
              ],
              [
                44.2866549,
                38.6405856
              ],
              [
                44.2875651,
                38.6402637
              ],
              [
                44.287971,
                38.6402135
              ],
              [
                44.2901246,
                38.6404942
              ],
              [
                44.2910979,
                38.6404941
              ],
              [
                44.2917493,
                38.6403397
              ],
              [
                44.292382,
                38.6399024
              ],
              [
                44.2933494,
                38.6389002
              ],
              [
                44.2940001,
                38.6386411
              ],
              [
                44.294876,
                38.6384774
              ],
              [
                44.2965255,
                38.6383456
              ],
              [
                44.2995814,
                38.6376557
              ],
              [
                44.3007997,
                38.6375322
              ],
              [
                44.3014567,
                38.6375176
              ],
              [
                44.3022611,
                38.6373569
              ],
              [
                44.3030827,
                38.6370591
              ],
              [
                44.3035905,
                38.6367158
              ],
              [
                44.3040796,
                38.6365562
              ],
              [
                44.3055481,
                38.6363212
              ],
              [
                44.3068138,
                38.6357953
              ],
              [
                44.3076794,
                38.6352607
              ],
              [
                44.3083244,
                38.6345882
              ],
              [
                44.3110385,
                38.6326041
              ],
              [
                44.3115894,
                38.6316952
              ],
              [
                44.3116618,
                38.6313199
              ],
              [
                44.3116631,
                38.6306852
              ],
              [
                44.3117843,
                38.6303083
              ],
              [
                44.3120286,
                38.6301056
              ],
              [
                44.3141196,
                38.6290823
              ],
              [
                44.3153059,
                38.6285718
              ],
              [
                44.3162115,
                38.6280591
              ],
              [
                44.3173382,
                38.6276469
              ],
              [
                44.3179752,
                38.6271477
              ],
              [
                44.3190295,
                38.6258675
              ],
              [
                44.3194135,
                38.6255807
              ],
              [
                44.3203711,
                38.6251457
              ],
              [
                44.3212691,
                38.6246416
              ],
              [
                44.3216199,
                38.6240924
              ],
              [
                44.3215893,
                38.6234072
              ],
              [
                44.3214592,
                38.6226609
              ],
              [
                44.320861,
                38.6203177
              ],
              [
                44.3205587,
                38.6195064
              ],
              [
                44.3205551,
                38.6189994
              ],
              [
                44.3219792,
                38.6158773
              ],
              [
                44.3219152,
                38.6150707
              ],
              [
                44.3216313,
                38.6136352
              ],
              [
                44.3216404,
                38.6130756
              ],
              [
                44.3219572,
                38.612411
              ],
              [
                44.3222211,
                38.6116448
              ],
              [
                44.3223763,
                38.6108867
              ],
              [
                44.3223866,
                38.6102648
              ],
              [
                44.3222742,
                38.6095996
              ],
              [
                44.3221658,
                38.6092261
              ],
              [
                44.3219364,
                38.609071
              ],
              [
                44.321603,
                38.6089293
              ],
              [
                44.3213481,
                38.6084581
              ],
              [
                44.3209434,
                38.608272
              ],
              [
                44.3197273,
                38.6079683
              ],
              [
                44.3186565,
                38.6078673
              ],
              [
                44.318083,
                38.6075724
              ],
              [
                44.317093,
                38.6071526
              ],
              [
                44.3167174,
                38.6068434
              ],
              [
                44.3167799,
                38.6063337
              ],
              [
                44.3170379,
                38.6060586
              ],
              [
                44.3183198,
                38.6056265
              ],
              [
                44.3190225,
                38.6051767
              ],
              [
                44.3193612,
                38.6049039
              ],
              [
                44.3195183,
                38.604604
              ],
              [
                44.3199239,
                38.6034864
              ],
              [
                44.32013,
                38.6022919
              ],
              [
                44.3203894,
                38.6017236
              ],
              [
                44.320678,
                38.6008058
              ],
              [
                44.3206728,
                38.600584
              ],
              [
                44.3201443,
                38.6000133
              ],
              [
                44.3198275,
                38.5998378
              ],
              [
                44.3180105,
                38.5991695
              ],
              [
                44.3177041,
                38.5989796
              ],
              [
                44.3176394,
                38.5986565
              ],
              [
                44.3178564,
                38.5980969
              ],
              [
                44.3183819,
                38.5976534
              ],
              [
                44.3187829,
                38.5971767
              ],
              [
                44.3190573,
                38.5965141
              ],
              [
                44.3197442,
                38.5955475
              ],
              [
                44.3204695,
                38.5946943
              ],
              [
                44.3208947,
                38.5943403
              ],
              [
                44.3216065,
                38.5940576
              ],
              [
                44.321783,
                38.5937353
              ],
              [
                44.321764,
                38.5932217
              ],
              [
                44.321545,
                38.592373
              ],
              [
                44.3216883,
                38.5918193
              ],
              [
                44.3227998,
                38.5893048
              ],
              [
                44.3228019,
                38.5887594
              ],
              [
                44.3226985,
                38.5884244
              ],
              [
                44.322334,
                38.5879951
              ],
              [
                44.3219677,
                38.5874098
              ],
              [
                44.3216019,
                38.5864779
              ],
              [
                44.3215424,
                38.5861207
              ],
              [
                44.3215816,
                38.5857076
              ],
              [
                44.3218736,
                38.5852499
              ],
              [
                44.3239682,
                38.5832001
              ],
              [
                44.324314,
                38.5827597
              ],
              [
                44.3245993,
                38.5820946
              ],
              [
                44.3247698,
                38.5806259
              ],
              [
                44.3245308,
                38.5789412
              ],
              [
                44.3246257,
                38.578436
              ],
              [
                44.3249444,
                38.5778961
              ],
              [
                44.3249447,
                38.5774874
              ],
              [
                44.3246561,
                38.5770861
              ],
              [
                44.3239031,
                38.5765993
              ],
              [
                44.3231793,
                38.5763237
              ],
              [
                44.3215978,
                38.5754546
              ],
              [
                44.3200776,
                38.5748942
              ],
              [
                44.3182921,
                38.5745842
              ],
              [
                44.3174009,
                38.5743174
              ],
              [
                44.3172026,
                38.5740492
              ],
              [
                44.3168942,
                38.5720846
              ],
              [
                44.3168503,
                38.5702327
              ],
              [
                44.3164673,
                38.5687408
              ],
              [
                44.3162482,
                38.5680649
              ],
              [
                44.3159134,
                38.567348
              ],
              [
                44.315384,
                38.5654119
              ],
              [
                44.315083,
                38.5648588
              ],
              [
                44.3143392,
                38.5643742
              ],
              [
                44.3141184,
                38.5640294
              ],
              [
                44.3138551,
                38.5634078
              ],
              [
                44.3132359,
                38.5627539
              ],
              [
                44.3127907,
                38.5617214
              ],
              [
                44.3128133,
                38.5613494
              ],
              [
                44.3130792,
                38.5600684
              ],
              [
                44.3131218,
                38.5591386
              ],
              [
                44.31337,
                38.5584966
              ],
              [
                44.3134259,
                38.5578968
              ],
              [
                44.3132484,
                38.5567123
              ],
              [
                44.3132985,
                38.5556979
              ],
              [
                44.3134431,
                38.5551454
              ],
              [
                44.3137494,
                38.5544686
              ],
              [
                44.3143035,
                38.5537369
              ],
              [
                44.3154513,
                38.5527822
              ],
              [
                44.3160884,
                38.552356
              ],
              [
                44.3164082,
                38.5520559
              ],
              [
                44.3164848,
                38.5518624
              ],
              [
                44.3162114,
                38.5508666
              ],
              [
                44.3163104,
                38.5496904
              ],
              [
                44.3163089,
                38.5490348
              ],
              [
                44.3162426,
                38.5485128
              ],
              [
                44.316112,
                38.5480827
              ],
              [
                44.315888,
                38.5478594
              ],
              [
                44.315654,
                38.547723
              ],
              [
                44.3151953,
                38.5476286
              ],
              [
                44.3145575,
                38.5470964
              ],
              [
                44.3141079,
                38.5469764
              ],
              [
                44.3136299,
                38.5467237
              ],
              [
                44.3132509,
                38.5463209
              ],
              [
                44.3130959,
                38.5458356
              ],
              [
                44.3131809,
                38.5453218
              ],
              [
                44.3133611,
                38.5449984
              ],
              [
                44.3133549,
                38.5435264
              ],
              [
                44.3134858,
                38.5422059
              ],
              [
                44.3132701,
                38.5413209
              ],
              [
                44.3130195,
                38.5390451
              ],
              [
                44.3127776,
                38.5387556
              ],
              [
                44.3124711,
                38.5385583
              ],
              [
                44.3110292,
                38.5379121
              ],
              [
                44.310719,
                38.5376653
              ],
              [
                44.3103947,
                38.537234
              ],
              [
                44.3101264,
                38.5365475
              ],
              [
                44.31014,
                38.5361234
              ],
              [
                44.3102254,
                38.5357842
              ],
              [
                44.3107101,
                38.5350089
              ],
              [
                44.3107522,
                38.5346128
              ],
              [
                44.3105618,
                38.5337761
              ],
              [
                44.3105952,
                38.533349
              ],
              [
                44.3107437,
                38.5328029
              ],
              [
                44.310551,
                38.5322573
              ],
              [
                44.3102589,
                38.5316976
              ],
              [
                44.309438,
                38.5308463
              ],
              [
                44.3093356,
                38.5302464
              ],
              [
                44.3094593,
                38.5297395
              ],
              [
                44.3098237,
                38.5291676
              ],
              [
                44.310283,
                38.52876
              ],
              [
                44.3105461,
                38.5282945
              ],
              [
                44.3105068,
                38.5279462
              ],
              [
                44.3103341,
                38.5273699
              ],
              [
                44.3103862,
                38.5269365
              ],
              [
                44.3110135,
                38.5261563
              ],
              [
                44.3114172,
                38.5254845
              ],
              [
                44.3116312,
                38.5252749
              ],
              [
                44.3117798,
                38.5249655
              ],
              [
                44.3118888,
                38.5246196
              ],
              [
                44.3117946,
                38.5241445
              ],
              [
                44.3118443,
                38.5238677
              ],
              [
                44.311993,
                38.5236519
              ],
              [
                44.312888,
                38.523301
              ],
              [
                44.3132055,
                38.522954
              ],
              [
                44.3132655,
                38.5222895
              ],
              [
                44.3130249,
                38.5219924
              ],
              [
                44.3128332,
                38.5218557
              ],
              [
                44.3127705,
                38.5216079
              ],
              [
                44.3131645,
                38.5199427
              ],
              [
                44.313692,
                38.5197384
              ],
              [
                44.3140478,
                38.5193181
              ],
              [
                44.3145727,
                38.5189344
              ],
              [
                44.3147281,
                38.5186098
              ],
              [
                44.3148075,
                38.5180804
              ],
              [
                44.3145354,
                38.5170444
              ],
              [
                44.3141987,
                38.5166823
              ],
              [
                44.3134628,
                38.5161385
              ],
              [
                44.3133273,
                38.5155001
              ],
              [
                44.3133674,
                38.5150921
              ],
              [
                44.3136685,
                38.5147926
              ],
              [
                44.3141283,
                38.5145741
              ],
              [
                44.3148592,
                38.5144737
              ],
              [
                44.3158895,
                38.5144033
              ],
              [
                44.3166672,
                38.5142737
              ],
              [
                44.3173623,
                38.5137995
              ],
              [
                44.3178233,
                38.5133099
              ],
              [
                44.3183225,
                38.5126739
              ],
              [
                44.3185551,
                38.5125185
              ],
              [
                44.319451,
                38.5125918
              ],
              [
                44.3197075,
                38.5125041
              ],
              [
                44.3198513,
                38.5123454
              ],
              [
                44.3198158,
                38.5118797
              ],
              [
                44.320259,
                38.511603
              ],
              [
                44.32073,
                38.5111917
              ],
              [
                44.3209896,
                38.5105845
              ],
              [
                44.3215039,
                38.5096297
              ],
              [
                44.3210833,
                38.5090374
              ],
              [
                44.3209848,
                38.5082294
              ],
              [
                44.3210408,
                38.5077907
              ],
              [
                44.3215096,
                38.5065831
              ],
              [
                44.3222208,
                38.5052454
              ],
              [
                44.3224173,
                38.5046696
              ],
              [
                44.3235701,
                38.5038919
              ],
              [
                44.3246682,
                38.5032881
              ],
              [
                44.3254938,
                38.5023992
              ],
              [
                44.3254601,
                38.502081
              ],
              [
                44.3238756,
                38.4993821
              ],
              [
                44.3232955,
                38.4988204
              ],
              [
                44.3220346,
                38.4983883
              ],
              [
                44.3214799,
                38.4979622
              ],
              [
                44.3210497,
                38.497534
              ],
              [
                44.3199259,
                38.4967157
              ],
              [
                44.3198756,
                38.4961887
              ],
              [
                44.3197807,
                38.4948202
              ],
              [
                44.3197839,
                38.4942379
              ],
              [
                44.3198887,
                38.4935562
              ],
              [
                44.3198002,
                38.4930906
              ],
              [
                44.319511,
                38.4925715
              ],
              [
                44.3194615,
                38.4915576
              ],
              [
                44.3202088,
                38.491232
              ],
              [
                44.3212894,
                38.4898602
              ],
              [
                44.3215533,
                38.4896245
              ],
              [
                44.3220562,
                38.489375
              ],
              [
                44.3221616,
                38.489227
              ],
              [
                44.3220706,
                38.4886145
              ],
              [
                44.3220779,
                38.4882334
              ],
              [
                44.3222347,
                38.4877558
              ],
              [
                44.3227138,
                38.487393
              ],
              [
                44.3227766,
                38.4869877
              ],
              [
                44.3227599,
                38.4862676
              ],
              [
                44.3229719,
                38.4856901
              ],
              [
                44.3228613,
                38.484784
              ],
              [
                44.3226599,
                38.4845163
              ],
              [
                44.3223752,
                38.4843696
              ],
              [
                44.3227351,
                38.4838943
              ],
              [
                44.3227118,
                38.4836828
              ],
              [
                44.3226179,
                38.4835879
              ],
              [
                44.322599,
                38.4833364
              ],
              [
                44.3226619,
                38.4831586
              ],
              [
                44.3222499,
                38.4826805
              ],
              [
                44.3221042,
                38.4826844
              ],
              [
                44.3219729,
                38.482598
              ],
              [
                44.3209257,
                38.4826581
              ],
              [
                44.3203308,
                38.4828057
              ],
              [
                44.3197483,
                38.482416
              ],
              [
                44.3193512,
                38.4823315
              ],
              [
                44.3191268,
                38.4818533
              ],
              [
                44.318979,
                38.4817191
              ],
              [
                44.3185389,
                38.4815456
              ],
              [
                44.3183569,
                38.4816177
              ],
              [
                44.3182168,
                38.4814397
              ],
              [
                44.3181927,
                38.481303
              ],
              [
                44.3180147,
                38.481001
              ],
              [
                44.3174252,
                38.4808351
              ],
              [
                44.3173837,
                38.4807535
              ],
              [
                44.317419,
                38.4805613
              ],
              [
                44.3169489,
                38.4803185
              ],
              [
                44.3167936,
                38.4801359
              ],
              [
                44.3163621,
                38.4798801
              ],
              [
                44.3155445,
                38.4796637
              ],
              [
                44.3154368,
                38.4794523
              ],
              [
                44.315025,
                38.4793717
              ],
              [
                44.3145958,
                38.4791845
              ],
              [
                44.3140558,
                38.4790272
              ],
              [
                44.3139389,
                38.4788657
              ],
              [
                44.3136743,
                38.4787262
              ],
              [
                44.3136001,
                38.4783439
              ],
              [
                44.3128928,
                38.4773845
              ],
              [
                44.3126338,
                38.477191
              ],
              [
                44.3125344,
                38.4770317
              ],
              [
                44.3118914,
                38.4764164
              ],
              [
                44.3116946,
                38.4763474
              ],
              [
                44.3116809,
                38.476249
              ],
              [
                44.3118614,
                38.4760248
              ],
              [
                44.3118935,
                38.4758915
              ],
              [
                44.3116054,
                38.4755621
              ],
              [
                44.3119001,
                38.475044
              ],
              [
                44.3120559,
                38.4743272
              ],
              [
                44.3121717,
                38.4741616
              ],
              [
                44.3129197,
                38.4735873
              ],
              [
                44.3129876,
                38.4732732
              ],
              [
                44.3132566,
                38.4728691
              ],
              [
                44.3132768,
                38.4704955
              ],
              [
                44.3137076,
                38.4661324
              ],
              [
                44.3137012,
                38.465112
              ],
              [
                44.3132591,
                38.4633165
              ],
              [
                44.312498,
                38.4617894
              ],
              [
                44.3110492,
                38.4604235
              ],
              [
                44.3098754,
                38.4589535
              ],
              [
                44.3094456,
                38.4576972
              ],
              [
                44.3093162,
                38.4568603
              ],
              [
                44.3093265,
                38.4563487
              ],
              [
                44.3096528,
                38.4555025
              ],
              [
                44.309709,
                38.4546617
              ],
              [
                44.3092785,
                38.4528362
              ],
              [
                44.3090813,
                38.4525633
              ],
              [
                44.3088446,
                38.4515677
              ],
              [
                44.3088961,
                38.4508763
              ],
              [
                44.3084394,
                38.4506894
              ],
              [
                44.3071549,
                38.4503714
              ],
              [
                44.3052173,
                38.449457
              ],
              [
                44.304007,
                38.4486066
              ],
              [
                44.3025095,
                38.4477692
              ],
              [
                44.3019383,
                38.4472285
              ],
              [
                44.3023455,
                38.4466951
              ],
              [
                44.303337,
                38.4453385
              ],
              [
                44.3040643,
                38.4442622
              ],
              [
                44.3046567,
                38.4436308
              ],
              [
                44.305058,
                38.4433225
              ],
              [
                44.305141,
                38.4430961
              ],
              [
                44.3049184,
                38.4417378
              ],
              [
                44.3050332,
                38.4412996
              ],
              [
                44.3052696,
                38.4409624
              ],
              [
                44.3057701,
                38.4407426
              ],
              [
                44.3064326,
                38.4405302
              ],
              [
                44.3072331,
                38.4400478
              ],
              [
                44.3079988,
                38.4396841
              ],
              [
                44.3086543,
                38.4392043
              ],
              [
                44.308945,
                38.4387104
              ],
              [
                44.309164,
                38.437974
              ],
              [
                44.3095437,
                38.4374529
              ],
              [
                44.3098686,
                38.4373098
              ],
              [
                44.3102483,
                38.4372982
              ],
              [
                44.3109874,
                38.4374514
              ],
              [
                44.3113087,
                38.4374294
              ],
              [
                44.3120059,
                38.4370607
              ],
              [
                44.3124972,
                38.4367389
              ],
              [
                44.3126864,
                38.4363624
              ],
              [
                44.3126338,
                38.4350199
              ],
              [
                44.3127962,
                38.4346317
              ],
              [
                44.3130602,
                38.4343058
              ],
              [
                44.3137208,
                38.4341283
              ],
              [
                44.3146401,
                38.4339716
              ],
              [
                44.3155926,
                38.4336522
              ],
              [
                44.3168777,
                38.4330659
              ],
              [
                44.3172813,
                38.4327646
              ],
              [
                44.3174565,
                38.4324044
              ],
              [
                44.3172767,
                38.4305213
              ],
              [
                44.3168629,
                38.4299484
              ],
              [
                44.3162288,
                38.4293968
              ],
              [
                44.3161017,
                38.4290724
              ],
              [
                44.3161279,
                38.4287487
              ],
              [
                44.3163619,
                38.4284548
              ],
              [
                44.3175833,
                38.4273235
              ],
              [
                44.3177325,
                38.4269515
              ],
              [
                44.3176633,
                38.426569
              ],
              [
                44.3171341,
                38.4260438
              ],
              [
                44.3164992,
                38.4252202
              ],
              [
                44.3163876,
                38.4246213
              ],
              [
                44.3167161,
                38.4239944
              ],
              [
                44.3169398,
                38.4233489
              ],
              [
                44.317044,
                38.4221359
              ],
              [
                44.3170585,
                38.4211032
              ],
              [
                44.3169949,
                38.4204855
              ],
              [
                44.3164491,
                38.4198212
              ],
              [
                44.3160531,
                38.4189069
              ],
              [
                44.3164514,
                38.4182788
              ],
              [
                44.3172717,
                38.4179198
              ],
              [
                44.3178718,
                38.4173325
              ],
              [
                44.3181184,
                38.4163786
              ],
              [
                44.3182808,
                38.4150523
              ],
              [
                44.3181121,
                38.4142863
              ],
              [
                44.3169938,
                38.4132401
              ],
              [
                44.3172296,
                38.4124235
              ],
              [
                44.3173379,
                38.411838
              ],
              [
                44.3189574,
                38.4095984
              ],
              [
                44.319729,
                38.408868
              ],
              [
                44.3198318,
                38.4086056
              ],
              [
                44.3195405,
                38.4081167
              ],
              [
                44.318074,
                38.4075837
              ],
              [
                44.3163675,
                38.4066903
              ],
              [
                44.3148521,
                38.4056896
              ],
              [
                44.3138492,
                38.4044728
              ],
              [
                44.312678,
                38.401666
              ],
              [
                44.3119707,
                38.401208
              ],
              [
                44.3115507,
                38.4006484
              ],
              [
                44.3113815,
                38.3998569
              ],
              [
                44.3114764,
                38.3990298
              ],
              [
                44.3117777,
                38.3982826
              ],
              [
                44.3118091,
                38.3978741
              ],
              [
                44.3116037,
                38.3970988
              ],
              [
                44.3112004,
                38.3962517
              ],
              [
                44.3109697,
                38.3954679
              ],
              [
                44.3107323,
                38.3952057
              ],
              [
                44.3105181,
                38.395371
              ],
              [
                44.3100476,
                38.3953451
              ],
              [
                44.3093316,
                38.3953634
              ],
              [
                44.3084127,
                38.3956361
              ],
              [
                44.307831,
                38.3952505
              ],
              [
                44.3078801,
                38.3955897
              ],
              [
                44.3077029,
                38.395807
              ],
              [
                44.3073592,
                38.3958595
              ],
              [
                44.3070599,
                38.3959144
              ],
              [
                44.3065183,
                38.3954691
              ],
              [
                44.3061045,
                38.3956096
              ],
              [
                44.3059179,
                38.3953189
              ],
              [
                44.3053774,
                38.3951788
              ],
              [
                44.3054436,
                38.3949584
              ],
              [
                44.3048252,
                38.3951856
              ],
              [
                44.3042275,
                38.3949734
              ],
              [
                44.3040432,
                38.3945681
              ],
              [
                44.303205,
                38.3947645
              ],
              [
                44.3030184,
                38.3950397
              ],
              [
                44.3024931,
                38.3950564
              ],
              [
                44.3017656,
                38.3947141
              ],
              [
                44.3009975,
                38.3945899
              ],
              [
                44.3007693,
                38.3944565
              ],
              [
                44.3001128,
                38.3945536
              ],
              [
                44.3000078,
                38.3943783
              ],
              [
                44.299987,
                38.3941676
              ],
              [
                44.300528,
                38.3938064
              ],
              [
                44.3025309,
                38.3931483
              ],
              [
                44.3036725,
                38.3925576
              ],
              [
                44.3050698,
                38.3909453
              ],
              [
                44.3057404,
                38.3902719
              ],
              [
                44.3060091,
                38.3895968
              ],
              [
                44.3066089,
                38.3888503
              ],
              [
                44.3074461,
                38.3882149
              ],
              [
                44.3082416,
                38.3872677
              ],
              [
                44.3086694,
                38.3863557
              ],
              [
                44.3090648,
                38.3847212
              ],
              [
                44.309348,
                38.383807
              ],
              [
                44.3096457,
                38.3823876
              ],
              [
                44.3115921,
                38.3814763
              ],
              [
                44.3114186,
                38.380584
              ],
              [
                44.3119831,
                38.3792991
              ],
              [
                44.3134319,
                38.376815
              ],
              [
                44.3141262,
                38.3767604
              ],
              [
                44.3148022,
                38.376633
              ],
              [
                44.3153159,
                38.3758575
              ],
              [
                44.315836,
                38.3751296
              ],
              [
                44.3163979,
                38.3742545
              ],
              [
                44.3169854,
                38.3739935
              ],
              [
                44.3183729,
                38.373522
              ],
              [
                44.3194361,
                38.3728423
              ],
              [
                44.3205622,
                38.3723863
              ],
              [
                44.3215214,
                38.3721953
              ],
              [
                44.3222422,
                38.3718894
              ],
              [
                44.3228456,
                38.3713678
              ],
              [
                44.3236591,
                38.3711874
              ],
              [
                44.324566,
                38.3710606
              ],
              [
                44.3255982,
                38.3707907
              ],
              [
                44.3274385,
                38.370465
              ],
              [
                44.3277575,
                38.3702646
              ],
              [
                44.3286416,
                38.3695409
              ],
              [
                44.3289214,
                38.3693378
              ],
              [
                44.3300158,
                38.369103
              ],
              [
                44.3305389,
                38.3691336
              ],
              [
                44.3312431,
                38.3693051
              ],
              [
                44.3322828,
                38.3693308
              ],
              [
                44.333179,
                38.3692483
              ],
              [
                44.3341914,
                38.3690659
              ],
              [
                44.3344912,
                38.3690658
              ],
              [
                44.335919,
                38.3693763
              ],
              [
                44.3363554,
                38.3698905
              ],
              [
                44.3368298,
                38.3703452
              ],
              [
                44.3373716,
                38.3704502
              ],
              [
                44.3378945,
                38.3704011
              ],
              [
                44.3381638,
                38.3704873
              ],
              [
                44.3386214,
                38.3708946
              ],
              [
                44.3392645,
                38.3712966
              ],
              [
                44.3400022,
                38.3716495
              ],
              [
                44.341003,
                38.3715599
              ],
              [
                44.3417199,
                38.3716098
              ],
              [
                44.3424523,
                38.3718987
              ],
              [
                44.3436451,
                38.371559
              ],
              [
                44.3460211,
                38.3705128
              ],
              [
                44.3471576,
                38.3702603
              ],
              [
                44.3482475,
                38.3701903
              ],
              [
                44.3490264,
                38.3699106
              ],
              [
                44.3511501,
                38.3691678
              ],
              [
                44.3513842,
                38.3696683
              ],
              [
                44.3519193,
                38.3702186
              ],
              [
                44.3525052,
                38.3705947
              ],
              [
                44.353356,
                38.3717397
              ],
              [
                44.353419,
                38.3720894
              ],
              [
                44.3535841,
                38.3722743
              ],
              [
                44.3551008,
                38.3740833
              ],
              [
                44.3556943,
                38.3747547
              ],
              [
                44.3562654,
                38.3750653
              ],
              [
                44.3577387,
                38.3753058
              ],
              [
                44.3588628,
                38.3754019
              ],
              [
                44.3601799,
                38.375426
              ],
              [
                44.3612645,
                38.375354
              ],
              [
                44.3619279,
                38.3752561
              ],
              [
                44.3625041,
                38.3750166
              ],
              [
                44.3633623,
                38.374452
              ],
              [
                44.363997,
                38.3738289
              ],
              [
                44.3642702,
                38.3731
              ],
              [
                44.3641992,
                38.3725439
              ],
              [
                44.3644014,
                38.3717399
              ],
              [
                44.3646124,
                38.3702781
              ],
              [
                44.3651695,
                38.3697709
              ],
              [
                44.3672481,
                38.3687434
              ],
              [
                44.367852,
                38.3687076
              ],
              [
                44.3685482,
                38.3688986
              ],
              [
                44.3691001,
                38.3688773
              ],
              [
                44.3698242,
                38.3680817
              ],
              [
                44.3699923,
                38.367723
              ],
              [
                44.3703066,
                38.3666814
              ],
              [
                44.3718169,
                38.3639941
              ],
              [
                44.3725372,
                38.3629998
              ],
              [
                44.373577,
                38.362004
              ],
              [
                44.3747839,
                38.3606422
              ],
              [
                44.3756333,
                38.3599942
              ],
              [
                44.3764307,
                38.3595315
              ],
              [
                44.3772491,
                38.3592803
              ],
              [
                44.3780842,
                38.3596157
              ],
              [
                44.3788945,
                38.3589078
              ],
              [
                44.3796451,
                38.3585915
              ],
              [
                44.3806525,
                38.3585695
              ],
              [
                44.3818028,
                38.358609
              ],
              [
                44.3829354,
                38.3588826
              ],
              [
                44.3836993,
                38.3591842
              ],
              [
                44.3846284,
                38.3596484
              ],
              [
                44.3855693,
                38.3603125
              ],
              [
                44.3864508,
                38.3613039
              ],
              [
                44.3877161,
                38.362447
              ],
              [
                44.389871,
                38.36365
              ],
              [
                44.3914775,
                38.3643836
              ],
              [
                44.392027,
                38.3645292
              ],
              [
                44.3934794,
                38.3644509
              ],
              [
                44.3944887,
                38.364552
              ],
              [
                44.3951669,
                38.3647206
              ],
              [
                44.3973657,
                38.3660118
              ],
              [
                44.3983357,
                38.3663569
              ],
              [
                44.399217,
                38.3668343
              ],
              [
                44.3998451,
                38.3672677
              ],
              [
                44.401588,
                38.3661616
              ],
              [
                44.4021581,
                38.3659172
              ],
              [
                44.403043,
                38.3658693
              ],
              [
                44.4042214,
                38.3659624
              ],
              [
                44.4050343,
                38.3661361
              ],
              [
                44.4063422,
                38.3664918
              ],
              [
                44.4072772,
                38.3668051
              ],
              [
                44.4090459,
                38.3668189
              ],
              [
                44.4098131,
                38.3670075
              ],
              [
                44.4104861,
                38.3674538
              ],
              [
                44.4110631,
                38.3680131
              ],
              [
                44.4125903,
                38.3688826
              ],
              [
                44.4134022,
                38.3690877
              ],
              [
                44.4153683,
                38.3691309
              ],
              [
                44.4161169,
                38.3691999
              ],
              [
                44.416887,
                38.3695706
              ],
              [
                44.4172492,
                38.3701476
              ],
              [
                44.4180799,
                38.3705365
              ],
              [
                44.4193284,
                38.3708682
              ],
              [
                44.4212709,
                38.371678
              ],
              [
                44.4227571,
                38.3727352
              ],
              [
                44.4243711,
                38.3740737
              ],
              [
                44.4253609,
                38.3745082
              ],
              [
                44.428045,
                38.3751365
              ],
              [
                44.428678,
                38.3753964
              ],
              [
                44.4294461,
                38.3759772
              ],
              [
                44.4298368,
                38.3764023
              ],
              [
                44.4305297,
                38.3770008
              ],
              [
                44.4314399,
                38.3775969
              ],
              [
                44.432663,
                38.3781967
              ],
              [
                44.4331134,
                38.3784893
              ],
              [
                44.4336603,
                38.3787294
              ],
              [
                44.4341352,
                38.3790028
              ],
              [
                44.4346808,
                38.379442
              ],
              [
                44.4365265,
                38.3811109
              ],
              [
                44.4380326,
                38.3823207
              ],
              [
                44.4395946,
                38.3834674
              ],
              [
                44.4406634,
                38.3838748
              ],
              [
                44.4420445,
                38.3842048
              ],
              [
                44.4435801,
                38.384668
              ],
              [
                44.4466329,
                38.3852781
              ],
              [
                44.4493712,
                38.3854921
              ],
              [
                44.4496203,
                38.3850122
              ],
              [
                44.4498134,
                38.3843454
              ],
              [
                44.4500018,
                38.3824915
              ],
              [
                44.4503712,
                38.3810992
              ],
              [
                44.4511302,
                38.3796988
              ],
              [
                44.4515908,
                38.3786345
              ],
              [
                44.452572,
                38.377459
              ],
              [
                44.4532344,
                38.3768331
              ],
              [
                44.4548674,
                38.3757114
              ],
              [
                44.4558757,
                38.3746692
              ],
              [
                44.4564943,
                38.3739132
              ],
              [
                44.4576932,
                38.3725927
              ],
              [
                44.4579131,
                38.3717471
              ],
              [
                44.4580669,
                38.3694104
              ],
              [
                44.4584359,
                38.3690335
              ],
              [
                44.459556,
                38.3687278
              ],
              [
                44.4603562,
                38.367436
              ],
              [
                44.4611763,
                38.3670778
              ],
              [
                44.4619035,
                38.3658759
              ],
              [
                44.4623217,
                38.365729
              ],
              [
                44.4625568,
                38.3653337
              ],
              [
                44.4626202,
                38.3631479
              ],
              [
                44.4624061,
                38.3628775
              ],
              [
                44.4623496,
                38.3597687
              ],
              [
                44.4627198,
                38.3594066
              ],
              [
                44.463526,
                38.3591656
              ],
              [
                44.4651716,
                38.3589717
              ],
              [
                44.4659713,
                38.3589483
              ],
              [
                44.4666468,
                38.3588782
              ],
              [
                44.4675444,
                38.3586655
              ],
              [
                44.4682083,
                38.3583631
              ],
              [
                44.4798876,
                38.363102
              ],
              [
                44.4812774,
                38.3631019
              ],
              [
                44.4823908,
                38.3633803
              ],
              [
                44.4848908,
                38.3633803
              ],
              [
                44.4857243,
                38.3636587
              ],
              [
                44.4929671,
                38.3662347
              ],
              [
                44.5078147,
                38.369061
              ],
              [
                44.5089281,
                38.3693485
              ],
              [
                44.5122618,
                38.3696179
              ],
              [
                44.5161516,
                38.3696179
              ],
              [
                44.5167048,
                38.3698963
              ],
              [
                44.5214276,
                38.3698962
              ],
              [
                44.5222612,
                38.3701747
              ],
              [
                44.5239276,
                38.3701747
              ],
              [
                44.5247612,
                38.370453
              ],
              [
                44.5267043,
                38.370453
              ],
              [
                44.5322614,
                38.3710099
              ],
              [
                44.5350412,
                38.3710099
              ],
              [
                44.5355943,
                38.3712882
              ],
              [
                44.5383748,
                38.3712882
              ],
              [
                44.5392076,
                38.3715667
              ],
              [
                44.5475407,
                38.3715667
              ],
              [
                44.5483743,
                38.3718451
              ],
              [
                44.554197,
                38.3722488
              ],
              [
                44.5547533,
                38.3725272
              ],
              [
                44.5564198,
                38.3725272
              ],
              [
                44.5569736,
                38.3728056
              ],
              [
                44.5683519,
                38.3723346
              ],
              [
                44.5691855,
                38.3720563
              ],
              [
                44.5747419,
                38.3720563
              ],
              [
                44.5750185,
                38.3717779
              ],
              [
                44.5794654,
                38.3717779
              ],
              [
                44.5800186,
                38.3714995
              ],
              [
                44.5897422,
                38.3714995
              ],
              [
                44.590022,
                38.3712212
              ],
              [
                44.5908556,
                38.3714995
              ],
              [
                44.5916883,
                38.3712212
              ],
              [
                44.595022,
                38.3712213
              ],
              [
                44.5955752,
                38.3709428
              ],
              [
                44.600855,
                38.3709428
              ],
              [
                44.6019651,
                38.3706644
              ],
              [
                44.6030754,
                38.3706644
              ],
              [
                44.6050223,
                38.3706644
              ],
              [
                44.6061317,
                38.3703861
              ],
              [
                44.6086317,
                38.3703862
              ],
              [
                44.6089123,
                38.3701077
              ],
              [
                44.6122452,
                38.3701077
              ],
              [
                44.6127983,
                38.3698293
              ],
              [
                44.6150217,
                38.3698293
              ],
              [
                44.6158553,
                38.3695509
              ],
              [
                44.6252495,
                38.3671283
              ],
              [
                44.6260822,
                38.3674067
              ],
              [
                44.6333059,
                38.3674068
              ],
              [
                44.633859,
                38.3676851
              ],
              [
                44.6436504,
                38.3661928
              ],
              [
                44.6442075,
                38.3664711
              ],
              [
                44.6512082,
                38.3658631
              ],
              [
                44.6512081,
                38.3661414
              ],
              [
                44.6523214,
                38.3661415
              ],
              [
                44.6528785,
                38.3664199
              ],
              [
                44.6542653,
                38.3664199
              ],
              [
                44.6566907,
                38.364141
              ],
              [
                44.6608407,
                38.3625931
              ],
              [
                44.6613978,
                38.3628715
              ],
              [
                44.6616744,
                38.3625931
              ],
              [
                44.6644509,
                38.3625932
              ],
              [
                44.6652838,
                38.3628715
              ],
              [
                44.6663971,
                38.3628715
              ],
              [
                44.666951,
                38.3631501
              ],
              [
                44.6789281,
                38.3601215
              ],
              [
                44.6794844,
                38.3603999
              ],
              [
                44.6861509,
                38.3604
              ],
              [
                44.6872643,
                38.3601215
              ],
              [
                44.6895813,
                38.3592466
              ],
              [
                44.6951376,
                38.3581329
              ],
              [
                44.6970808,
                38.3581329
              ],
              [
                44.6976378,
                38.3578544
              ],
              [
                44.6995847,
                38.3578544
              ],
              [
                44.7001378,
                38.3575759
              ],
              [
                44.7023614,
                38.357576
              ],
              [
                44.7031942,
                38.3572976
              ],
              [
                44.704584,
                38.3572975
              ],
              [
                44.7051379,
                38.3570191
              ],
              [
                44.7062513,
                38.3570191
              ],
              [
                44.7068044,
                38.3567407
              ],
              [
                44.7161586,
                38.3552257
              ],
              [
                44.7186586,
                38.3549472
              ],
              [
                44.7200485,
                38.3546778
              ],
              [
                44.7225486,
                38.3546778
              ],
              [
                44.7228251,
                38.3543904
              ],
              [
                44.7306051,
                38.353564
              ],
              [
                44.7375482,
                38.3535641
              ],
              [
                44.7381052,
                38.3532857
              ],
              [
                44.7431053,
                38.3532857
              ],
              [
                44.7433819,
                38.3530073
              ],
              [
                44.7456054,
                38.3530073
              ],
              [
                44.7458819,
                38.3527287
              ],
              [
                44.7481046,
                38.3527288
              ],
              [
                44.7486618,
                38.3524503
              ],
              [
                44.7511617,
                38.3524504
              ],
              [
                44.7514383,
                38.3521719
              ],
              [
                44.7531048,
                38.3521719
              ],
              [
                44.7536618,
                38.3518935
              ],
              [
                44.7561619,
                38.3518935
              ],
              [
                44.756715,
                38.351615
              ],
              [
                44.7592151,
                38.351615
              ],
              [
                44.7592151,
                38.3513366
              ],
              [
                44.7645697,
                38.3526155
              ],
              [
                44.7651228,
                38.3523371
              ],
              [
                44.7670697,
                38.3523371
              ],
              [
                44.7673463,
                38.3520587
              ],
              [
                44.7684596,
                38.3520587
              ],
              [
                44.7915172,
                38.3561284
              ],
              [
                44.8025211,
                38.3596459
              ],
              [
                44.8027977,
                38.3593765
              ],
              [
                44.806411,
                38.3593765
              ],
              [
                44.8069643,
                38.3590981
              ],
              [
                44.809744,
                38.3590981
              ],
              [
                44.8100213,
                38.3588198
              ],
              [
                44.8119644,
                38.3588197
              ],
              [
                44.812244,
                38.3585413
              ],
              [
                44.8133542,
                38.3585413
              ],
              [
                44.827208,
                38.3527527
              ],
              [
                44.8294315,
                38.3508128
              ],
              [
                44.8449295,
                38.3373289
              ],
              [
                44.8482632,
                38.3339968
              ],
              [
                44.8490967,
                38.3337184
              ],
              [
                44.8499296,
                38.332883
              ],
              [
                44.8504867,
                38.332883
              ],
              [
                44.8565962,
                38.3303863
              ],
              [
                44.8577095,
                38.3303863
              ],
              [
                44.857986,
                38.3301078
              ],
              [
                44.8593766,
                38.3301077
              ],
              [
                44.8596533,
                38.3298293
              ],
              [
                44.8792623,
                38.3297167
              ],
              [
                44.8892654,
                38.3299059
              ],
              [
                44.8903786,
                38.3299059
              ],
              [
                44.893999,
                38.3305849
              ],
              [
                44.9056822,
                38.3314011
              ],
              [
                44.9065158,
                38.3314011
              ],
              [
                44.9141424,
                38.3322178
              ],
              [
                44.9196957,
                38.3333227
              ],
              [
                44.9213628,
                38.3333227
              ],
              [
                44.9216426,
                38.3336011
              ],
              [
                44.9274755,
                38.3336011
              ],
              [
                44.9296991,
                38.3333227
              ],
              [
                44.9455887,
                38.3312846
              ],
              [
                44.9928117,
                38.318789
              ],
              [
                44.9933688,
                38.3187891
              ],
              [
                44.9939249,
                38.3187891
              ],
              [
                44.9944781,
                38.3185105
              ],
              [
                44.9955914,
                38.3185105
              ],
              [
                44.9961454,
                38.3182321
              ],
              [
                44.9992017,
                38.3182321
              ],
              [
                44.9997579,
                38.3179536
              ],
              [
                45.0005917,
                38.3179536
              ],
              [
                45.072011,
                38.316998
              ],
              [
                45.077844,
                38.3158932
              ],
              [
                45.0915105,
                38.3211458
              ],
              [
                45.0935234,
                38.3211458
              ],
              [
                45.0934543,
                38.3219721
              ],
              [
                45.1061399,
                38.3290841
              ],
              [
                45.1384325,
                38.3530628
              ],
              [
                45.1506481,
                38.3621882
              ],
              [
                45.1514809,
                38.3621881
              ],
              [
                45.1542576,
                38.3635805
              ],
              [
                45.1678711,
                38.3671916
              ],
              [
                45.1684243,
                38.3674701
              ],
              [
                45.1709243,
                38.368027
              ],
              [
                45.1720376,
                38.368027
              ],
              [
                45.1789992,
                38.3775968
              ],
              [
                45.1959455,
                38.3903691
              ],
              [
                45.2025603,
                38.3909172
              ],
              [
                45.2218583,
                38.3813408
              ],
              [
                45.223868,
                38.3831248
              ],
              [
                45.2354248,
                38.3905131
              ],
              [
                45.2435873,
                38.3934736
              ],
              [
                45.2424212,
                38.3980432
              ],
              [
                45.2301977,
                38.4127105
              ],
              [
                45.2257345,
                38.4219909
              ],
              [
                45.2283736,
                38.4307204
              ],
              [
                45.2354337,
                38.4335345
              ],
              [
                45.2404338,
                38.4338039
              ],
              [
                45.2418197,
                38.4335346
              ],
              [
                45.2468238,
                38.4338039
              ],
              [
                45.2575484,
                38.4342346
              ],
              [
                45.273509,
                38.4358951
              ],
              [
                45.2762887,
                38.4367303
              ],
              [
                45.3149985,
                38.450228
              ],
              [
                45.3297613,
                38.4616542
              ],
              [
                45.3356041,
                38.4764312
              ],
              [
                45.3264998,
                38.4953845
              ],
              [
                45.2961157,
                38.5210412
              ],
              [
                45.2750014,
                38.5333961
              ],
              [
                45.2652541,
                38.5431761
              ],
              [
                45.2597008,
                38.5540165
              ],
              [
                45.2594211,
                38.554295
              ],
              [
                45.2686499,
                38.5776953
              ],
              [
                45.2623513,
                38.5900401
              ],
              [
                45.2620708,
                38.5919792
              ],
              [
                45.2617943,
                38.5939273
              ],
              [
                45.2658092,
                38.5985816
              ],
              [
                45.2691673,
                38.6070271
              ],
              [
                45.2680541,
                38.6131407
              ],
              [
                45.2616672,
                38.6178629
              ],
              [
                45.2579042,
                38.6283718
              ],
              [
                45.2581838,
                38.6289284
              ],
              [
                45.2590174,
                38.6317021
              ],
              [
                45.2579041,
                38.6353197
              ],
              [
                45.253461,
                38.6453194
              ],
              [
                45.2526274,
                38.6461541
              ],
              [
                45.2526274,
                38.6467107
              ],
              [
                45.2410189,
                38.6574726
              ],
              [
                45.2374054,
                38.6591422
              ],
              [
                45.2401859,
                38.6624726
              ],
              [
                45.2404626,
                38.6630291
              ],
              [
                45.2387954,
                38.6641421
              ],
              [
                45.2396289,
                38.6663684
              ],
              [
                45.240186,
                38.6663684
              ],
              [
                45.240186,
                38.6666466
              ],
              [
                45.2418524,
                38.6666466
              ],
              [
                45.2432423,
                38.6669159
              ],
              [
                45.2476853,
                38.6694205
              ],
              [
                45.2474088,
                38.6708118
              ],
              [
                45.2492466,
                38.6768331
              ],
              [
                45.2492466,
                38.6771204
              ],
              [
                45.2495263,
                38.6776679
              ],
              [
                45.2511927,
                38.6821203
              ],
              [
                45.2575219,
                38.6906351
              ],
              [
                45.2578016,
                38.6945217
              ],
              [
                45.2641914,
                38.7048074
              ],
              [
                45.2689039,
                38.7126727
              ],
              [
                45.2714032,
                38.7171244
              ],
              [
                45.2730703,
                38.7224017
              ],
              [
                45.2734602,
                38.7278233
              ],
              [
                45.2751266,
                38.7303183
              ],
              [
                45.2754071,
                38.7314312
              ],
              [
                45.2756837,
                38.7319877
              ],
              [
                45.2756836,
                38.7331006
              ],
              [
                45.2751266,
                38.7333787
              ],
              [
                45.2715163,
                38.7430984
              ],
              [
                45.2713616,
                38.753891
              ],
              [
                45.2691411,
                38.7650015
              ],
              [
                45.2732847,
                38.7714842
              ],
              [
                45.2657467,
                38.7852611
              ],
              [
                45.2694183,
                38.7925076
              ],
              [
                45.2755981,
                38.8630989
              ],
              [
                45.2740112,
                38.8627112
              ],
              [
                45.2734581,
                38.8627113
              ],
              [
                45.2731775,
                38.8629891
              ],
              [
                45.2723447,
                38.8629891
              ],
              [
                45.2509785,
                38.8547925
              ],
              [
                45.2291678,
                38.8565529
              ],
              [
                45.2201897,
                38.851713
              ],
              [
                45.2193561,
                38.851435
              ],
              [
                45.2174091,
                38.851435
              ],
              [
                45.1951788,
                38.8426493
              ],
              [
                45.1750944,
                38.8391729
              ],
              [
                45.170642,
                38.8271532
              ],
              [
                45.1630781,
                38.819515
              ],
              [
                45.1586037,
                38.7965922
              ],
              [
                45.1385643,
                38.793851
              ],
              [
                45.1233716,
                38.7851281
              ],
              [
                45.1138984,
                38.7704736
              ],
              [
                45.1129147,
                38.7702278
              ],
              [
                45.1072947,
                38.7607934
              ],
              [
                45.1024168,
                38.7601031
              ],
              [
                45.1013027,
                38.7595464
              ],
              [
                45.0927514,
                38.7542414
              ],
              [
                45.0910849,
                38.7542414
              ],
              [
                45.0735854,
                38.7514675
              ],
              [
                45.0705282,
                38.7514674
              ],
              [
                45.0694181,
                38.7511891
              ],
              [
                45.0658047,
                38.7511891
              ],
              [
                45.0644188,
                38.7509108
              ],
              [
                45.0627515,
                38.7509109
              ],
              [
                45.0599717,
                38.7506325
              ],
              [
                45.0549717,
                38.7503542
              ],
              [
                45.0544154,
                38.7503542
              ],
              [
                45.0533052,
                38.750076
              ],
              [
                45.0421956,
                38.7500759
              ],
              [
                45.0416386,
                38.7503542
              ],
              [
                45.0391385,
                38.7503542
              ],
              [
                45.0381673,
                38.7506324
              ],
              [
                45.0377486,
                38.7506325
              ],
              [
                45.0369151,
                38.7506325
              ],
              [
                45.0363618,
                38.7509107
              ],
              [
                45.0321923,
                38.7509107
              ],
              [
                45.0316391,
                38.7506324
              ],
              [
                45.030525,
                38.7506325
              ],
              [
                45.0143575,
                38.7462237
              ],
              [
                44.9995593,
                38.7550425
              ],
              [
                44.9859892,
                38.7527993
              ],
              [
                44.984879,
                38.7527993
              ],
              [
                44.9843227,
                38.7525211
              ],
              [
                44.9818227,
                38.7525212
              ],
              [
                44.9812656,
                38.752243
              ],
              [
                44.9773796,
                38.752243
              ],
              [
                44.9759889,
                38.752243
              ],
              [
                44.9754327,
                38.7525211
              ],
              [
                44.9734889,
                38.7525211
              ],
              [
                44.9729326,
                38.7527992
              ],
              [
                44.9718224,
                38.7527993
              ],
              [
                44.9712662,
                38.7530775
              ],
              [
                44.970156,
                38.7530774
              ],
              [
                44.969599,
                38.7533556
              ],
              [
                44.9668223,
                38.7533556
              ],
              [
                44.9662661,
                38.7536338
              ],
              [
                44.9645996,
                38.7536338
              ],
              [
                44.9549427,
                38.7575905
              ],
              [
                44.9538294,
                38.7575905
              ],
              [
                44.9529957,
                38.7578686
              ],
              [
                44.9327015,
                38.7570655
              ],
              [
                44.9324218,
                38.7573436
              ],
              [
                44.9315882,
                38.7573436
              ],
              [
                44.9310351,
                38.7576218
              ],
              [
                44.9302015,
                38.7576218
              ],
              [
                44.911865,
                38.7665143
              ],
              [
                44.911865,
                38.7667835
              ],
              [
                44.9101986,
                38.7678961
              ],
              [
                44.8882483,
                38.7856694
              ],
              [
                44.8685154,
                38.7979401
              ],
              [
                44.867959,
                38.7982183
              ],
              [
                44.8530026,
                38.7989416
              ],
              [
                44.8524495,
                38.7992198
              ],
              [
                44.8516127,
                38.7992198
              ],
              [
                44.8513361,
                38.799498
              ],
              [
                44.8505025,
                38.799498
              ],
              [
                44.8499456,
                38.7997761
              ],
              [
                44.8493924,
                38.7997761
              ],
              [
                44.839769,
                38.8054409
              ],
              [
                44.8392127,
                38.8054409
              ],
              [
                44.8372689,
                38.8059972
              ],
              [
                44.8283789,
                38.8084915
              ],
              [
                44.827546,
                38.8084915
              ],
              [
                44.8264359,
                38.8090477
              ],
              [
                44.8200459,
                38.8104384
              ],
              [
                44.8189358,
                38.8104384
              ],
              [
                44.8174123,
                38.8121878
              ],
              [
                44.8165795,
                38.8121878
              ],
              [
                44.8163028,
                38.8124661
              ],
              [
                44.8140794,
                38.812466
              ],
              [
                44.811859,
                38.8130223
              ],
              [
                44.8074047,
                38.8159649
              ],
              [
                44.8065711,
                38.816243
              ],
              [
                44.8037945,
                38.816243
              ],
              [
                44.7790712,
                38.82124
              ],
              [
                44.7785149,
                38.8215182
              ],
              [
                44.7463367,
                38.8213429
              ],
              [
                44.7432796,
                38.8213428
              ],
              [
                44.743003,
                38.821621
              ],
              [
                44.7416132,
                38.8216209
              ],
              [
                44.7407795,
                38.8218992
              ],
              [
                44.7399467,
                38.8218992
              ],
              [
                44.7396702,
                38.8221683
              ],
              [
                44.7385601,
                38.8225388
              ],
              [
                44.7380029,
                38.8227247
              ],
              [
                44.7363364,
                38.8227247
              ],
              [
                44.7339879,
                38.8386583
              ],
              [
                44.7364996,
                38.8473287
              ],
              [
                44.7481747,
                38.8550951
              ],
              [
                44.748731,
                38.8556513
              ],
              [
                44.7512311,
                38.8575893
              ],
              [
                44.7520646,
                38.8617609
              ],
              [
                44.7517881,
                38.8620391
              ],
              [
                44.7451376,
                38.8733966
              ],
              [
                44.744861,
                38.8742309
              ],
              [
                44.7440274,
                38.8750653
              ],
              [
                44.7434712,
                38.8761778
              ],
              [
                44.7420813,
                38.8775595
              ],
              [
                44.740971,
                38.8789501
              ],
              [
                44.7249442,
                38.8948283
              ],
              [
                44.7154978,
                38.8995565
              ],
              [
                44.7149408,
                38.8995564
              ],
              [
                44.7146642,
                38.8998346
              ],
              [
                44.6995414,
                38.9014377
              ],
              [
                44.6987078,
                38.9017158
              ],
              [
                44.6975984,
                38.9017158
              ],
              [
                44.6970415,
                38.9019939
              ],
              [
                44.6942647,
                38.9019939
              ],
              [
                44.6934319,
                38.9022719
              ],
              [
                44.6924683,
                38.9023727
              ],
              [
                44.6899682,
                38.9023728
              ],
              [
                44.6891347,
                38.9020946
              ],
              [
                44.6877479,
                38.9020946
              ],
              [
                44.6871916,
                38.9018165
              ],
              [
                44.6852479,
                38.9018164
              ],
              [
                44.679508,
                38.9041256
              ],
              [
                44.6816846,
                38.910316
              ],
              [
                44.6819651,
                38.9105852
              ],
              [
                44.6816846,
                38.9111414
              ],
              [
                44.6830745,
                38.9153135
              ],
              [
                44.6830745,
                38.9155917
              ],
              [
                44.6830745,
                38.916426
              ],
              [
                44.682798,
                38.9167043
              ],
              [
                44.6830745,
                38.918373
              ],
              [
                44.6827979,
                38.9189204
              ],
              [
                44.675588,
                38.9229601
              ],
              [
                44.6761419,
                38.9240725
              ],
              [
                44.6791647,
                38.9316391
              ],
              [
                44.6781347,
                38.9391167
              ],
              [
                44.6811085,
                38.9415975
              ],
              [
                44.6816647,
                38.9471504
              ],
              [
                44.6808319,
                38.9482627
              ],
              [
                44.681178,
                38.9507676
              ],
              [
                44.6789544,
                38.9513238
              ],
              [
                44.6636363,
                38.9574083
              ],
              [
                44.6619698,
                38.9579644
              ],
              [
                44.6376288,
                38.9674099
              ],
              [
                44.6356849,
                38.9674099
              ],
              [
                44.6326286,
                38.9679661
              ],
              [
                44.6309621,
                38.967966
              ],
              [
                44.590369,
                38.9672678
              ],
              [
                44.5875924,
                38.9672678
              ],
              [
                44.5814822,
                38.968102
              ],
              [
                44.5792594,
                38.968102
              ],
              [
                44.5773156,
                38.9686582
              ],
              [
                44.5753687,
                38.9686582
              ],
              [
                44.5742593,
                38.9689363
              ],
              [
                44.5725921,
                38.9689363
              ],
              [
                44.5714788,
                38.9692143
              ],
              [
                44.5695357,
                38.9692144
              ],
              [
                44.5687021,
                38.9694924
              ],
              [
                44.5664794,
                38.9694924
              ],
              [
                44.5659255,
                38.9697705
              ],
              [
                44.5623122,
                38.9697705
              ],
              [
                44.5589793,
                38.9703266
              ],
              [
                44.5507973,
                38.9704963
              ],
              [
                44.5433806,
                38.9668835
              ],
              [
                44.5378663,
                38.9567092
              ],
              [
                44.5349812,
                38.9532808
              ],
              [
                44.534425,
                38.947997
              ],
              [
                44.5316732,
                38.9416434
              ],
              [
                44.5277833,
                38.9363684
              ],
              [
                44.5268282,
                38.931471
              ],
              [
                44.5142601,
                38.9146797
              ],
              [
                44.5134266,
                38.9146797
              ],
              [
                44.4922253,
                38.9030571
              ],
              [
                44.4751672,
                38.8996869
              ],
              [
                44.4640568,
                38.8955234
              ],
              [
                44.4612771,
                38.8938543
              ],
              [
                44.459334,
                38.8927417
              ],
              [
                44.445444,
                38.8816326
              ],
              [
                44.4372609,
                38.8698846
              ],
              [
                44.4278376,
                38.8610418
              ],
              [
                44.4264477,
                38.8607637
              ],
              [
                44.4217281,
                38.8590948
              ],
              [
                44.421171,
                38.8588167
              ],
              [
                44.4197811,
                38.8585386
              ],
              [
                44.392328,
                38.85065
              ],
              [
                44.3914951,
                38.8492594
              ],
              [
                44.383995,
                38.8392553
              ],
              [
                44.3765415,
                38.8175892
              ],
              [
                44.3608254,
                38.8061669
              ],
              [
                44.3608255,
                38.8058887
              ],
              [
                44.3608255,
                38.8053324
              ],
              [
                44.321966,
                38.7963208
              ],
              [
                44.3180761,
                38.7977117
              ],
              [
                44.3169659,
                38.7977117
              ],
              [
                44.3005255,
                38.7964688
              ],
              [
                44.3002836,
                38.7951806
              ],
              [
                44.3004325,
                38.7946407
              ],
              [
                44.3008292,
                38.7942099
              ],
              [
                44.300885,
                38.7938123
              ],
              [
                44.3004436,
                38.7929208
              ],
              [
                44.3003479,
                38.7918953
              ],
              [
                44.300227,
                38.7914997
              ],
              [
                44.2981214,
                38.7904293
              ],
              [
                44.2964118,
                38.7896453
              ],
              [
                44.295213,
                38.7889711
              ],
              [
                44.292061,
                38.7870484
              ],
              [
                44.2912021,
                38.7865966
              ],
              [
                44.2895815,
                38.7862416
              ],
              [
                44.2888377,
                38.7859756
              ],
              [
                44.288589,
                38.7856685
              ],
              [
                44.2883093,
                38.7844709
              ],
              [
                44.2880812,
                38.7841194
              ],
              [
                44.2875568,
                38.7837134
              ],
              [
                44.2864982,
                38.7831041
              ],
              [
                44.2863273,
                38.7826676
              ],
              [
                44.2865082,
                38.7819833
              ],
              [
                44.2870666,
                38.7813793
              ],
              [
                44.2881707,
                38.7806758
              ],
              [
                44.288723,
                38.7804832
              ],
              [
                44.2895335,
                38.7803676
              ],
              [
                44.2897906,
                38.7800851
              ],
              [
                44.2899882,
                38.779509
              ],
              [
                44.2904322,
                38.7774493
              ],
              [
                44.2905331,
                38.7770681
              ],
              [
                44.2911488,
                38.7757139
              ],
              [
                44.2912251,
                38.7752872
              ],
              [
                44.2913361,
                38.7749852
              ],
              [
                44.2910732,
                38.7740932
              ],
              [
                44.2893509,
                38.7726088
              ],
              [
                44.2890539,
                38.7721329
              ],
              [
                44.2890161,
                38.7717856
              ],
              [
                44.2893737,
                38.770405
              ],
              [
                44.2901314,
                38.7691662
              ],
              [
                44.2904137,
                38.7688526
              ],
              [
                44.2913539,
                38.7683214
              ],
              [
                44.2919855,
                38.7678146
              ],
              [
                44.2921263,
                38.7675619
              ],
              [
                44.2922324,
                38.7664823
              ],
              [
                44.292412,
                38.7657025
              ],
              [
                44.2925042,
                38.7648625
              ],
              [
                44.292505,
                38.7641949
              ],
              [
                44.2923957,
                38.763867
              ],
              [
                44.2921765,
                38.7636949
              ],
              [
                44.2916074,
                38.7633914
              ],
              [
                44.2912749,
                38.7631162
              ],
              [
                44.2909923,
                38.7627261
              ],
              [
                44.2900124,
                38.7601913
              ],
              [
                44.2876757,
                38.7575641
              ],
              [
                44.2875206,
                38.7571729
              ],
              [
                44.2875614,
                38.7568154
              ],
              [
                44.2877764,
                38.7562481
              ],
              [
                44.2877433,
                38.7557511
              ],
              [
                44.2863845,
                38.7525111
              ],
              [
                44.2861278,
                38.7522789
              ],
              [
                44.2849494,
                38.7517325
              ],
              [
                44.2835794,
                38.750906
              ],
              [
                44.2831046,
                38.7504624
              ],
              [
                44.2821654,
                38.7494343
              ],
              [
                44.2821269,
                38.7493867
              ],
              [
                44.2814337,
                38.7485297
              ],
              [
                44.2802051,
                38.7475481
              ],
              [
                44.2790188,
                38.7472522
              ],
              [
                44.278833,
                38.7472059
              ],
              [
                44.2778971,
                38.7468697
              ],
              [
                44.2773726,
                38.7464973
              ],
              [
                44.277137,
                38.7461335
              ],
              [
                44.2770461,
                38.7457035
              ],
              [
                44.2773065,
                38.744738
              ],
              [
                44.2771889,
                38.744025
              ],
              [
                44.2765516,
                38.7426255
              ],
              [
                44.2766691,
                38.7419546
              ],
              [
                44.2769369,
                38.7410518
              ],
              [
                44.2785385,
                38.7375707
              ],
              [
                44.2788969,
                38.7372276
              ],
              [
                44.2793595,
                38.736985
              ],
              [
                44.2802244,
                38.7366843
              ],
              [
                44.2808395,
                38.7364176
              ],
              [
                44.2810098,
                38.7360556
              ],
              [
                44.2810187,
                38.7356963
              ],
              [
                44.2808884,
                38.7347366
              ],
              [
                44.2806224,
                38.7337757
              ],
              [
                44.2801473,
                38.7329247
              ],
              [
                44.2796744,
                38.7324079
              ],
              [
                44.2790352,
                38.7319274
              ],
              [
                44.2781933,
                38.7310761
              ],
              [
                44.2761536,
                38.729443
              ],
              [
                44.275859,
                38.7293616
              ],
              [
                44.2755318,
                38.7293623
              ],
              [
                44.2743149,
                38.7296477
              ],
              [
                44.2738573,
                38.7295802
              ],
              [
                44.2736591,
                38.7294056
              ],
              [
                44.2736529,
                38.7291116
              ],
              [
                44.2739169,
                38.7285168
              ],
              [
                44.2743582,
                38.7270999
              ],
              [
                44.2742036,
                38.726712
              ],
              [
                44.2736689,
                38.7261773
              ],
              [
                44.2731673,
                38.7259034
              ],
              [
                44.272387,
                38.7257309
              ],
              [
                44.2713997,
                38.7256116
              ],
              [
                44.2699011,
                38.7256065
              ],
              [
                44.2694928,
                38.7254647
              ],
              [
                44.2691577,
                38.7250199
              ],
              [
                44.269088,
                38.7245264
              ],
              [
                44.2695055,
                38.7230564
              ],
              [
                44.2694443,
                38.7221868
              ],
              [
                44.2691983,
                38.7220303
              ],
              [
                44.2691063,
                38.7219717
              ],
              [
                44.2690033,
                38.7219643
              ],
              [
                44.2685734,
                38.7219336
              ],
              [
                44.2684585,
                38.7219373
              ],
              [
                44.2662909,
                38.7220067
              ],
              [
                44.2653479,
                38.72198
              ],
              [
                44.2644978,
                38.721776
              ],
              [
                44.2641643,
                38.7210598
              ],
              [
                44.2640145,
                38.7202515
              ],
              [
                44.263536,
                38.7193339
              ],
              [
                44.2633298,
                38.7191828
              ],
              [
                44.2630145,
                38.7191822
              ],
              [
                44.2602471,
                38.71945
              ],
              [
                44.2584518,
                38.7197853
              ],
              [
                44.257486,
                38.7198966
              ],
              [
                44.2571758,
                38.7199323
              ],
              [
                44.25612,
                38.7198635
              ],
              [
                44.2550123,
                38.719547
              ],
              [
                44.2542973,
                38.7190364
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555075,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سردشت",
          "name:en": "Sardasht County",
          "name:ku": "Serdeşt",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1285922",
          "wikipedia": "en:Sardasht County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.265754,
                36.253206
              ],
              [
                45.265897,
                36.253103
              ],
              [
                45.266247,
                36.253089
              ],
              [
                45.266565,
                36.252818
              ],
              [
                45.266976,
                36.252314
              ],
              [
                45.267831,
                36.251025
              ],
              [
                45.267973,
                36.250935
              ],
              [
                45.268601,
                36.250829
              ],
              [
                45.268849,
                36.250726
              ],
              [
                45.269085,
                36.250506
              ],
              [
                45.269951,
                36.250217
              ],
              [
                45.270311,
                36.250272
              ],
              [
                45.270814,
                36.250064
              ],
              [
                45.271338,
                36.250074
              ],
              [
                45.271718,
                36.249985
              ],
              [
                45.272418,
                36.249737
              ],
              [
                45.272714,
                36.249555
              ],
              [
                45.272894,
                36.249312
              ],
              [
                45.273531,
                36.248919
              ],
              [
                45.273627,
                36.24874
              ],
              [
                45.273666,
                36.248441
              ],
              [
                45.27481,
                36.247623
              ],
              [
                45.275677,
                36.246925
              ],
              [
                45.276466,
                36.246132
              ],
              [
                45.276808,
                36.245569
              ],
              [
                45.277458,
                36.245028
              ],
              [
                45.27814,
                36.244723
              ],
              [
                45.280247,
                36.244096
              ],
              [
                45.280762,
                36.243767
              ],
              [
                45.280961,
                36.243705
              ],
              [
                45.282006,
                36.243617
              ],
              [
                45.282361,
                36.243738
              ],
              [
                45.282897,
                36.243804
              ],
              [
                45.283427,
                36.243986
              ],
              [
                45.283924,
                36.244232
              ],
              [
                45.284211,
                36.244246
              ],
              [
                45.284647,
                36.244174
              ],
              [
                45.285105,
                36.244028
              ],
              [
                45.285791,
                36.243626
              ],
              [
                45.286275,
                36.243416
              ],
              [
                45.286866,
                36.24329
              ],
              [
                45.287564,
                36.243209
              ],
              [
                45.288151,
                36.243062
              ],
              [
                45.288524,
                36.243028
              ],
              [
                45.289057,
                36.243079
              ],
              [
                45.289436,
                36.242807
              ],
              [
                45.289698,
                36.24241
              ],
              [
                45.290551,
                36.241497
              ],
              [
                45.290992,
                36.241328
              ],
              [
                45.291229,
                36.241086
              ],
              [
                45.291667,
                36.240906
              ],
              [
                45.292014,
                36.240779
              ],
              [
                45.292311,
                36.240754
              ],
              [
                45.292786,
                36.240626
              ],
              [
                45.293863,
                36.240748
              ],
              [
                45.294357,
                36.241033
              ],
              [
                45.294515,
                36.241021
              ],
              [
                45.295407,
                36.240583
              ],
              [
                45.2958,
                36.240464
              ],
              [
                45.297322,
                36.240141
              ],
              [
                45.298529,
                36.239759
              ],
              [
                45.298873,
                36.239833
              ],
              [
                45.29956,
                36.239641
              ],
              [
                45.300651,
                36.239469
              ],
              [
                45.301526,
                36.239406
              ],
              [
                45.302233,
                36.239426
              ],
              [
                45.303854,
                36.239322
              ],
              [
                45.304572,
                36.239389
              ],
              [
                45.30489,
                36.239252
              ],
              [
                45.305008,
                36.239112
              ],
              [
                45.305308,
                36.238978
              ],
              [
                45.306191,
                36.238951
              ],
              [
                45.306473,
                36.239004
              ],
              [
                45.306842,
                36.239008
              ],
              [
                45.308054,
                36.238772
              ],
              [
                45.30879,
                36.238809
              ],
              [
                45.309689,
                36.238255
              ],
              [
                45.309939,
                36.23819
              ],
              [
                45.310386,
                36.238202
              ],
              [
                45.310976,
                36.238308
              ],
              [
                45.311289,
                36.238382
              ],
              [
                45.311689,
                36.238565
              ],
              [
                45.312069,
                36.238589
              ],
              [
                45.312404,
                36.238424
              ],
              [
                45.312344,
                36.23773
              ],
              [
                45.313153,
                36.236651
              ],
              [
                45.313771,
                36.236229
              ],
              [
                45.313794,
                36.236049
              ],
              [
                45.31405,
                36.235626
              ],
              [
                45.314093,
                36.235467
              ],
              [
                45.313991,
                36.234131
              ],
              [
                45.314358,
                36.233359
              ],
              [
                45.3147,
                36.232882
              ],
              [
                45.315063,
                36.232651
              ],
              [
                45.315024,
                36.232323
              ],
              [
                45.314806,
                36.232178
              ],
              [
                45.314924,
                36.231596
              ],
              [
                45.315091,
                36.231264
              ],
              [
                45.315227,
                36.230404
              ],
              [
                45.3151481,
                36.2301675
              ],
              [
                45.314955,
                36.2300117
              ],
              [
                45.3149442,
                36.2297564
              ],
              [
                45.314761,
                36.229175
              ],
              [
                45.314667,
                36.228976
              ],
              [
                45.31475,
                36.228438
              ],
              [
                45.314621,
                36.22832
              ],
              [
                45.31436,
                36.228215
              ],
              [
                45.314142,
                36.227893
              ],
              [
                45.31403,
                36.227583
              ],
              [
                45.314053,
                36.227363
              ],
              [
                45.314229,
                36.226954
              ],
              [
                45.314321,
                36.226425
              ],
              [
                45.314208,
                36.225846
              ],
              [
                45.314234,
                36.225577
              ],
              [
                45.314148,
                36.225123
              ],
              [
                45.314464,
                36.224231
              ],
              [
                45.314889,
                36.223572
              ],
              [
                45.3152,
                36.222787
              ],
              [
                45.31525,
                36.221726
              ],
              [
                45.315335,
                36.221518
              ],
              [
                45.315504,
                36.221319
              ],
              [
                45.316144,
                36.221037
              ],
              [
                45.316553,
                36.220968
              ],
              [
                45.317456,
                36.220932
              ],
              [
                45.31797,
                36.220328
              ],
              [
                45.318532,
                36.220264
              ],
              [
                45.31914,
                36.220491
              ],
              [
                45.319733,
                36.219778
              ],
              [
                45.320048,
                36.219586
              ],
              [
                45.321107,
                36.219486
              ],
              [
                45.321465,
                36.218845
              ],
              [
                45.32161,
                36.218323
              ],
              [
                45.322044,
                36.217677
              ],
              [
                45.322193,
                36.217232
              ],
              [
                45.322437,
                36.216846
              ],
              [
                45.322378,
                36.216636
              ],
              [
                45.322573,
                36.216296
              ],
              [
                45.322607,
                36.216064
              ],
              [
                45.323007,
                36.215715
              ],
              [
                45.323576,
                36.21578
              ],
              [
                45.324157,
                36.215908
              ],
              [
                45.324467,
                36.215902
              ],
              [
                45.325005,
                36.215737
              ],
              [
                45.325264,
                36.215702
              ],
              [
                45.326247,
                36.215904
              ],
              [
                45.32732,
                36.216299
              ],
              [
                45.327617,
                36.21623
              ],
              [
                45.328116,
                36.215852
              ],
              [
                45.328225,
                36.215608
              ],
              [
                45.328412,
                36.215467
              ],
              [
                45.328579,
                36.215223
              ],
              [
                45.328868,
                36.215242
              ],
              [
                45.329949,
                36.214729
              ],
              [
                45.330202,
                36.214255
              ],
              [
                45.330328,
                36.214131
              ],
              [
                45.330546,
                36.214017
              ],
              [
                45.330655,
                36.213735
              ],
              [
                45.33047,
                36.212791
              ],
              [
                45.330842,
                36.212022
              ],
              [
                45.330884,
                36.211011
              ],
              [
                45.330989,
                36.210639
              ],
              [
                45.33093,
                36.210499
              ],
              [
                45.330778,
                36.210381
              ],
              [
                45.330934,
                36.210214
              ],
              [
                45.331009,
                36.209857
              ],
              [
                45.331097,
                36.209707
              ],
              [
                45.331074,
                36.20955
              ],
              [
                45.33147,
                36.209453
              ],
              [
                45.331798,
                36.209165
              ],
              [
                45.332211,
                36.208985
              ],
              [
                45.33241,
                36.208703
              ],
              [
                45.332842,
                36.208422
              ],
              [
                45.333199,
                36.207774
              ],
              [
                45.333526,
                36.207384
              ],
              [
                45.333657,
                36.207012
              ],
              [
                45.334033,
                36.206741
              ],
              [
                45.334329,
                36.20663
              ],
              [
                45.335035,
                36.205877
              ],
              [
                45.335138,
                36.205634
              ],
              [
                45.335478,
                36.205241
              ],
              [
                45.335688,
                36.204882
              ],
              [
                45.336004,
                36.204633
              ],
              [
                45.336378,
                36.204417
              ],
              [
                45.336499,
                36.204202
              ],
              [
                45.336511,
                36.20406
              ],
              [
                45.336439,
                36.203885
              ],
              [
                45.336479,
                36.203342
              ],
              [
                45.336439,
                36.203236
              ],
              [
                45.336542,
                36.202515
              ],
              [
                45.336647,
                36.202212
              ],
              [
                45.335923,
                36.20198
              ],
              [
                45.334956,
                36.201829
              ],
              [
                45.334727,
                36.201677
              ],
              [
                45.334243,
                36.201108
              ],
              [
                45.334134,
                36.200735
              ],
              [
                45.333887,
                36.200419
              ],
              [
                45.332746,
                36.200138
              ],
              [
                45.332448,
                36.199933
              ],
              [
                45.331919,
                36.199361
              ],
              [
                45.331243,
                36.198767
              ],
              [
                45.331015,
                36.19862
              ],
              [
                45.330766,
                36.198535
              ],
              [
                45.3303,
                36.198059
              ],
              [
                45.330236,
                36.197856
              ],
              [
                45.329302,
                36.196476
              ],
              [
                45.329036,
                36.195858
              ],
              [
                45.328638,
                36.195364
              ],
              [
                45.328379,
                36.194884
              ],
              [
                45.328145,
                36.194743
              ],
              [
                45.327637,
                36.194179
              ],
              [
                45.327271,
                36.194023
              ],
              [
                45.326969,
                36.194034
              ],
              [
                45.326152,
                36.1942
              ],
              [
                45.325053,
                36.194243
              ],
              [
                45.324776,
                36.194319
              ],
              [
                45.324647,
                36.194085
              ],
              [
                45.324701,
                36.193651
              ],
              [
                45.324626,
                36.193455
              ],
              [
                45.324508,
                36.193347
              ],
              [
                45.324199,
                36.192844
              ],
              [
                45.323988,
                36.192717
              ],
              [
                45.323719,
                36.19236
              ],
              [
                45.323769,
                36.192281
              ],
              [
                45.32449,
                36.192122
              ],
              [
                45.325132,
                36.191681
              ],
              [
                45.325277,
                36.191521
              ],
              [
                45.325366,
                36.191312
              ],
              [
                45.325372,
                36.190211
              ],
              [
                45.324417,
                36.189747
              ],
              [
                45.323958,
                36.189442
              ],
              [
                45.323191,
                36.188606
              ],
              [
                45.32284,
                36.188019
              ],
              [
                45.322627,
                36.187885
              ],
              [
                45.32229,
                36.187778
              ],
              [
                45.319812,
                36.186354
              ],
              [
                45.319092,
                36.185864
              ],
              [
                45.318299,
                36.18571
              ],
              [
                45.318,
                36.185467
              ],
              [
                45.317083,
                36.184517
              ],
              [
                45.316386,
                36.183547
              ],
              [
                45.316454,
                36.183258
              ],
              [
                45.3171,
                36.182952
              ],
              [
                45.317424,
                36.182901
              ],
              [
                45.31819,
                36.182906
              ],
              [
                45.318925,
                36.182792
              ],
              [
                45.319491,
                36.182907
              ],
              [
                45.319923,
                36.18283
              ],
              [
                45.320125,
                36.182666
              ],
              [
                45.320714,
                36.182353
              ],
              [
                45.320919,
                36.181935
              ],
              [
                45.321276,
                36.181626
              ],
              [
                45.321381,
                36.181398
              ],
              [
                45.321504,
                36.18085
              ],
              [
                45.321753,
                36.180382
              ],
              [
                45.321963,
                36.180163
              ],
              [
                45.322053,
                36.179884
              ],
              [
                45.322808,
                36.179358
              ],
              [
                45.322905,
                36.179046
              ],
              [
                45.323201,
                36.178693
              ],
              [
                45.323021,
                36.178495
              ],
              [
                45.322843,
                36.177963
              ],
              [
                45.322842,
                36.177346
              ],
              [
                45.322953,
                36.177074
              ],
              [
                45.322911,
                36.176818
              ],
              [
                45.322672,
                36.176238
              ],
              [
                45.322648,
                36.175872
              ],
              [
                45.322714,
                36.175437
              ],
              [
                45.322838,
                36.1752
              ],
              [
                45.322843,
                36.174952
              ],
              [
                45.322681,
                36.174777
              ],
              [
                45.322159,
                36.174483
              ],
              [
                45.321848,
                36.174039
              ],
              [
                45.321664,
                36.17368
              ],
              [
                45.321156,
                36.173222
              ],
              [
                45.32098,
                36.172942
              ],
              [
                45.320981,
                36.172743
              ],
              [
                45.3212,
                36.172426
              ],
              [
                45.32119,
                36.171961
              ],
              [
                45.321387,
                36.171362
              ],
              [
                45.32145,
                36.170772
              ],
              [
                45.321314,
                36.170291
              ],
              [
                45.320433,
                36.168778
              ],
              [
                45.320397,
                36.168388
              ],
              [
                45.320229,
                36.167717
              ],
              [
                45.320332,
                36.167495
              ],
              [
                45.320702,
                36.167449
              ],
              [
                45.324127,
                36.167363
              ],
              [
                45.324668,
                36.167241
              ],
              [
                45.325412,
                36.166793
              ],
              [
                45.325608,
                36.166324
              ],
              [
                45.325832,
                36.166139
              ],
              [
                45.325528,
                36.165388
              ],
              [
                45.325038,
                36.164407
              ],
              [
                45.325011,
                36.16409
              ],
              [
                45.325688,
                36.163117
              ],
              [
                45.326387,
                36.16178
              ],
              [
                45.326522,
                36.160989
              ],
              [
                45.326932,
                36.160144
              ],
              [
                45.327025,
                36.159645
              ],
              [
                45.327443,
                36.159045
              ],
              [
                45.327663,
                36.15863
              ],
              [
                45.327969,
                36.157514
              ],
              [
                45.328906,
                36.156853
              ],
              [
                45.329278,
                36.156484
              ],
              [
                45.327792,
                36.154591
              ],
              [
                45.327685,
                36.154328
              ],
              [
                45.326912,
                36.153054
              ],
              [
                45.326508,
                36.151736
              ],
              [
                45.326132,
                36.151389
              ],
              [
                45.325781,
                36.151145
              ],
              [
                45.325625,
                36.150969
              ],
              [
                45.325608,
                36.150709
              ],
              [
                45.325787,
                36.150183
              ],
              [
                45.325723,
                36.149674
              ],
              [
                45.325228,
                36.148903
              ],
              [
                45.324975,
                36.148626
              ],
              [
                45.324987,
                36.148077
              ],
              [
                45.325259,
                36.147798
              ],
              [
                45.325523,
                36.147622
              ],
              [
                45.325638,
                36.147339
              ],
              [
                45.325948,
                36.147027
              ],
              [
                45.326462,
                36.146598
              ],
              [
                45.326706,
                36.146133
              ],
              [
                45.326788,
                36.145577
              ],
              [
                45.326955,
                36.144983
              ],
              [
                45.327059,
                36.143777
              ],
              [
                45.327278,
                36.143153
              ],
              [
                45.327107,
                36.141591
              ],
              [
                45.32695,
                36.140837
              ],
              [
                45.327046,
                36.139867
              ],
              [
                45.327135,
                36.139698
              ],
              [
                45.327607,
                36.139324
              ],
              [
                45.32836,
                36.13879
              ],
              [
                45.328704,
                36.138636
              ],
              [
                45.328926,
                36.138383
              ],
              [
                45.329571,
                36.136418
              ],
              [
                45.329667,
                36.136275
              ],
              [
                45.329868,
                36.136119
              ],
              [
                45.33083,
                36.135942
              ],
              [
                45.331323,
                36.135668
              ],
              [
                45.331871,
                36.135565
              ],
              [
                45.332062,
                36.13547
              ],
              [
                45.333567,
                36.135366
              ],
              [
                45.333911,
                36.13519
              ],
              [
                45.334434,
                36.134801
              ],
              [
                45.334482,
                36.134562
              ],
              [
                45.334893,
                36.134259
              ],
              [
                45.335193,
                36.134167
              ],
              [
                45.335401,
                36.134158
              ],
              [
                45.335636,
                36.134269
              ],
              [
                45.335744,
                36.134244
              ],
              [
                45.335861,
                36.134005
              ],
              [
                45.336274,
                36.133903
              ],
              [
                45.336465,
                36.133809
              ],
              [
                45.336902,
                36.133457
              ],
              [
                45.337083,
                36.133376
              ],
              [
                45.337443,
                36.13335
              ],
              [
                45.337692,
                36.133464
              ],
              [
                45.338039,
                36.133517
              ],
              [
                45.338257,
                36.133374
              ],
              [
                45.338369,
                36.133218
              ],
              [
                45.338495,
                36.132889
              ],
              [
                45.339088,
                36.132022
              ],
              [
                45.338959,
                36.131635
              ],
              [
                45.338973,
                36.13137
              ],
              [
                45.339405,
                36.130631
              ],
              [
                45.339636,
                36.130365
              ],
              [
                45.339881,
                36.130223
              ],
              [
                45.340122,
                36.129578
              ],
              [
                45.340319,
                36.129335
              ],
              [
                45.340741,
                36.129364
              ],
              [
                45.34107,
                36.129524
              ],
              [
                45.341445,
                36.12943
              ],
              [
                45.341514,
                36.129215
              ],
              [
                45.341023,
                36.128383
              ],
              [
                45.34092,
                36.127334
              ],
              [
                45.340739,
                36.126902
              ],
              [
                45.340539,
                36.126773
              ],
              [
                45.34064,
                36.126378
              ],
              [
                45.340514,
                36.126291
              ],
              [
                45.34048,
                36.125662
              ],
              [
                45.340534,
                36.125198
              ],
              [
                45.340724,
                36.124809
              ],
              [
                45.340948,
                36.124079
              ],
              [
                45.341146,
                36.123792
              ],
              [
                45.341477,
                36.123471
              ],
              [
                45.341622,
                36.122969
              ],
              [
                45.341589,
                36.122197
              ],
              [
                45.341979,
                36.122281
              ],
              [
                45.342835,
                36.12221
              ],
              [
                45.343538,
                36.121833
              ],
              [
                45.344163,
                36.121667
              ],
              [
                45.344726,
                36.121058
              ],
              [
                45.344956,
                36.120738
              ],
              [
                45.345243,
                36.120188
              ],
              [
                45.345723,
                36.119599
              ],
              [
                45.345815,
                36.118592
              ],
              [
                45.345795,
                36.117645
              ],
              [
                45.345867,
                36.117312
              ],
              [
                45.346753,
                36.116014
              ],
              [
                45.346888,
                36.115686
              ],
              [
                45.347404,
                36.115099
              ],
              [
                45.347596,
                36.114413
              ],
              [
                45.347991,
                36.114037
              ],
              [
                45.348196,
                36.113399
              ],
              [
                45.34846,
                36.112972
              ],
              [
                45.34852,
                36.112408
              ],
              [
                45.348937,
                36.111836
              ],
              [
                45.349553,
                36.110664
              ],
              [
                45.349533,
                36.110252
              ],
              [
                45.34967,
                36.109965
              ],
              [
                45.349689,
                36.109716
              ],
              [
                45.349596,
                36.109311
              ],
              [
                45.34957,
                36.108705
              ],
              [
                45.350507,
                36.108563
              ],
              [
                45.352971,
                36.108856
              ],
              [
                45.353314,
                36.108965
              ],
              [
                45.353744,
                36.108975
              ],
              [
                45.354217,
                36.109088
              ],
              [
                45.355103,
                36.109127
              ],
              [
                45.355643,
                36.10931
              ],
              [
                45.356028,
                36.109378
              ],
              [
                45.356312,
                36.109322
              ],
              [
                45.356523,
                36.109131
              ],
              [
                45.356628,
                36.108827
              ],
              [
                45.357016,
                36.108271
              ],
              [
                45.357254,
                36.108174
              ],
              [
                45.357587,
                36.108153
              ],
              [
                45.357921,
                36.10823
              ],
              [
                45.35822,
                36.108231
              ],
              [
                45.358644,
                36.107975
              ],
              [
                45.359223,
                36.107401
              ],
              [
                45.359773,
                36.107062
              ],
              [
                45.360708,
                36.106912
              ],
              [
                45.361047,
                36.106786
              ],
              [
                45.361775,
                36.106355
              ],
              [
                45.362244,
                36.106332
              ],
              [
                45.36244,
                36.106406
              ],
              [
                45.362621,
                36.106565
              ],
              [
                45.362894,
                36.10662
              ],
              [
                45.363592,
                36.106469
              ],
              [
                45.364596,
                36.106421
              ],
              [
                45.365243,
                36.106283
              ],
              [
                45.365767,
                36.106042
              ],
              [
                45.366827,
                36.105415
              ],
              [
                45.367049,
                36.105239
              ],
              [
                45.367814,
                36.104965
              ],
              [
                45.368788,
                36.10495
              ],
              [
                45.369071,
                36.104894
              ],
              [
                45.370334,
                36.104412
              ],
              [
                45.370547,
                36.104235
              ],
              [
                45.370625,
                36.104087
              ],
              [
                45.370597,
                36.103147
              ],
              [
                45.370356,
                36.102594
              ],
              [
                45.370292,
                36.10193
              ],
              [
                45.370596,
                36.101317
              ],
              [
                45.370581,
                36.101118
              ],
              [
                45.370253,
                36.100574
              ],
              [
                45.370287,
                36.100333
              ],
              [
                45.370117,
                36.099821
              ],
              [
                45.370292,
                36.099331
              ],
              [
                45.370435,
                36.09809
              ],
              [
                45.370572,
                36.098071
              ],
              [
                45.371052,
                36.097871
              ],
              [
                45.371373,
                36.09783
              ],
              [
                45.371848,
                36.097586
              ],
              [
                45.37207,
                36.097312
              ],
              [
                45.372256,
                36.096666
              ],
              [
                45.372687,
                36.096386
              ],
              [
                45.373144,
                36.096299
              ],
              [
                45.373364,
                36.096161
              ],
              [
                45.373604,
                36.095878
              ],
              [
                45.373769,
                36.095301
              ],
              [
                45.373996,
                36.095266
              ],
              [
                45.374151,
                36.095042
              ],
              [
                45.37444,
                36.095034
              ],
              [
                45.374575,
                36.094982
              ],
              [
                45.374687,
                36.094919
              ],
              [
                45.374728,
                36.094802
              ],
              [
                45.374859,
                36.094735
              ],
              [
                45.374879,
                36.09449
              ],
              [
                45.37476,
                36.094161
              ],
              [
                45.374791,
                36.093882
              ],
              [
                45.374495,
                36.093579
              ],
              [
                45.374448,
                36.093457
              ],
              [
                45.374625,
                36.093168
              ],
              [
                45.374709,
                36.092813
              ],
              [
                45.375012,
                36.092612
              ],
              [
                45.37508,
                36.092463
              ],
              [
                45.375133,
                36.092267
              ],
              [
                45.375102,
                36.092032
              ],
              [
                45.37497,
                36.091705
              ],
              [
                45.375651,
                36.091349
              ],
              [
                45.377231,
                36.090202
              ],
              [
                45.377539,
                36.089945
              ],
              [
                45.378539,
                36.088907
              ],
              [
                45.378679,
                36.08851
              ],
              [
                45.379023,
                36.088115
              ],
              [
                45.379259,
                36.087501
              ],
              [
                45.379461,
                36.087397
              ],
              [
                45.379637,
                36.087239
              ],
              [
                45.379741,
                36.087002
              ],
              [
                45.379779,
                36.086618
              ],
              [
                45.379904,
                36.086311
              ],
              [
                45.379776,
                36.085805
              ],
              [
                45.380161,
                36.085614
              ],
              [
                45.380449,
                36.085402
              ],
              [
                45.380532,
                36.085075
              ],
              [
                45.380529,
                36.084719
              ],
              [
                45.380786,
                36.084522
              ],
              [
                45.381033,
                36.084473
              ],
              [
                45.381363,
                36.08418
              ],
              [
                45.381498,
                36.08293
              ],
              [
                45.381396,
                36.081924
              ],
              [
                45.38163,
                36.081615
              ],
              [
                45.381628,
                36.081069
              ],
              [
                45.381837,
                36.080798
              ],
              [
                45.381823,
                36.080477
              ],
              [
                45.381892,
                36.080287
              ],
              [
                45.381789,
                36.079971
              ],
              [
                45.381813,
                36.079448
              ],
              [
                45.381616,
                36.079233
              ],
              [
                45.38096,
                36.078709
              ],
              [
                45.380507,
                36.077754
              ],
              [
                45.380206,
                36.077328
              ],
              [
                45.380067,
                36.077253
              ],
              [
                45.3798,
                36.077278
              ],
              [
                45.379353,
                36.077152
              ],
              [
                45.378991,
                36.077105
              ],
              [
                45.378886,
                36.076945
              ],
              [
                45.378242,
                36.076603
              ],
              [
                45.377979,
                36.076321
              ],
              [
                45.37771,
                36.076152
              ],
              [
                45.377323,
                36.075798
              ],
              [
                45.377208,
                36.0752
              ],
              [
                45.3774,
                36.074352
              ],
              [
                45.377869,
                36.073762
              ],
              [
                45.378197,
                36.073514
              ],
              [
                45.378399,
                36.073193
              ],
              [
                45.378529,
                36.072778
              ],
              [
                45.379451,
                36.071761
              ],
              [
                45.379155,
                36.07131
              ],
              [
                45.37854,
                36.070913
              ],
              [
                45.378265,
                36.0708
              ],
              [
                45.378187,
                36.070396
              ],
              [
                45.377843,
                36.069861
              ],
              [
                45.377608,
                36.069764
              ],
              [
                45.377418,
                36.069547
              ],
              [
                45.377409,
                36.069086
              ],
              [
                45.377231,
                36.068461
              ],
              [
                45.37715,
                36.067884
              ],
              [
                45.376898,
                36.067512
              ],
              [
                45.376433,
                36.066993
              ],
              [
                45.37646,
                36.06632
              ],
              [
                45.3764288,
                36.0661742
              ],
              [
                45.376366,
                36.06588
              ],
              [
                45.376208,
                36.065651
              ],
              [
                45.376058,
                36.065294
              ],
              [
                45.376063,
                36.064831
              ],
              [
                45.375756,
                36.063964
              ],
              [
                45.375505,
                36.063791
              ],
              [
                45.375358,
                36.063774
              ],
              [
                45.374975,
                36.063853
              ],
              [
                45.374854,
                36.063158
              ],
              [
                45.374602,
                36.062813
              ],
              [
                45.374249,
                36.062536
              ],
              [
                45.3737,
                36.061831
              ],
              [
                45.373653,
                36.061277
              ],
              [
                45.373941,
                36.060479
              ],
              [
                45.373977,
                36.060077
              ],
              [
                45.373872,
                36.058659
              ],
              [
                45.373506,
                36.057855
              ],
              [
                45.373444,
                36.057643
              ],
              [
                45.373433,
                36.057172
              ],
              [
                45.373302,
                36.056727
              ],
              [
                45.372749,
                36.055444
              ],
              [
                45.372627,
                36.054658
              ],
              [
                45.372695,
                36.054222
              ],
              [
                45.372656,
                36.05375
              ],
              [
                45.37243,
                36.052326
              ],
              [
                45.372537,
                36.051772
              ],
              [
                45.372477,
                36.051487
              ],
              [
                45.371312,
                36.05009
              ],
              [
                45.371,
                36.049918
              ],
              [
                45.370518,
                36.049792
              ],
              [
                45.370202,
                36.049575
              ],
              [
                45.369787,
                36.049382
              ],
              [
                45.369463,
                36.049111
              ],
              [
                45.369372,
                36.048815
              ],
              [
                45.369342,
                36.048352
              ],
              [
                45.368816,
                36.047739
              ],
              [
                45.367868,
                36.046793
              ],
              [
                45.367491,
                36.046504
              ],
              [
                45.367055,
                36.046259
              ],
              [
                45.365791,
                36.045075
              ],
              [
                45.365233,
                36.044656
              ],
              [
                45.364846,
                36.044279
              ],
              [
                45.364213,
                36.043464
              ],
              [
                45.363478,
                36.043057
              ],
              [
                45.362495,
                36.042904
              ],
              [
                45.362064,
                36.042731
              ],
              [
                45.361944,
                36.042596
              ],
              [
                45.362005,
                36.042184
              ],
              [
                45.361972,
                36.0419
              ],
              [
                45.361707,
                36.041101
              ],
              [
                45.361625,
                36.040681
              ],
              [
                45.361292,
                36.040105
              ],
              [
                45.361184,
                36.039773
              ],
              [
                45.360858,
                36.039169
              ],
              [
                45.360558,
                36.038292
              ],
              [
                45.36023,
                36.038032
              ],
              [
                45.359979,
                36.037715
              ],
              [
                45.359445,
                36.037415
              ],
              [
                45.359123,
                36.037338
              ],
              [
                45.358538,
                36.037058
              ],
              [
                45.35758,
                36.036505
              ],
              [
                45.357195,
                36.036239
              ],
              [
                45.357119,
                36.036086
              ],
              [
                45.356894,
                36.036053
              ],
              [
                45.356718,
                36.03589
              ],
              [
                45.356361,
                36.035708
              ],
              [
                45.356154,
                36.035667
              ],
              [
                45.355977,
                36.035498
              ],
              [
                45.35536,
                36.035229
              ],
              [
                45.355201,
                36.034946
              ],
              [
                45.355002,
                36.034803
              ],
              [
                45.354958,
                36.03466
              ],
              [
                45.355,
                36.034553
              ],
              [
                45.354628,
                36.034285
              ],
              [
                45.354431,
                36.03354
              ],
              [
                45.354309,
                36.033344
              ],
              [
                45.35423,
                36.03328
              ],
              [
                45.353621,
                36.033144
              ],
              [
                45.353381,
                36.033003
              ],
              [
                45.353249,
                36.032848
              ],
              [
                45.353189,
                36.032162
              ],
              [
                45.352878,
                36.031967
              ],
              [
                45.35271,
                36.031646
              ],
              [
                45.352497,
                36.031472
              ],
              [
                45.352318,
                36.031192
              ],
              [
                45.352274,
                36.031078
              ],
              [
                45.352375,
                36.030943
              ],
              [
                45.352378,
                36.030619
              ],
              [
                45.352296,
                36.030455
              ],
              [
                45.351928,
                36.030198
              ],
              [
                45.351798,
                36.029569
              ],
              [
                45.351589,
                36.029148
              ],
              [
                45.351527,
                36.028805
              ],
              [
                45.351564,
                36.028681
              ],
              [
                45.35198,
                36.028109
              ],
              [
                45.352093,
                36.027861
              ],
              [
                45.35234,
                36.027644
              ],
              [
                45.352946,
                36.027303
              ],
              [
                45.353136,
                36.027132
              ],
              [
                45.353305,
                36.026838
              ],
              [
                45.353399,
                36.026452
              ],
              [
                45.353436,
                36.026158
              ],
              [
                45.353321,
                36.025989
              ],
              [
                45.352959,
                36.025789
              ],
              [
                45.352768,
                36.025589
              ],
              [
                45.352499,
                36.025126
              ],
              [
                45.35229,
                36.025019
              ],
              [
                45.351812,
                36.02451
              ],
              [
                45.351716,
                36.024279
              ],
              [
                45.351772,
                36.024001
              ],
              [
                45.352664,
                36.022744
              ],
              [
                45.352785,
                36.022324
              ],
              [
                45.353146,
                36.021923
              ],
              [
                45.353282,
                36.020926
              ],
              [
                45.353515,
                36.020464
              ],
              [
                45.353532,
                36.019943
              ],
              [
                45.353463,
                36.019574
              ],
              [
                45.353067,
                36.019205
              ],
              [
                45.352773,
                36.019006
              ],
              [
                45.352431,
                36.018859
              ],
              [
                45.351685,
                36.018964
              ],
              [
                45.350684,
                36.018099
              ],
              [
                45.35016,
                36.017796
              ],
              [
                45.349108,
                36.016806
              ],
              [
                45.348295,
                36.016293
              ],
              [
                45.34725,
                36.01539
              ],
              [
                45.346728,
                36.015012
              ],
              [
                45.346508,
                36.014792
              ],
              [
                45.34646,
                36.014597
              ],
              [
                45.346543,
                36.014135
              ],
              [
                45.346457,
                36.013864
              ],
              [
                45.346082,
                36.013318
              ],
              [
                45.345559,
                36.01285
              ],
              [
                45.345062,
                36.011913
              ],
              [
                45.344841,
                36.01127
              ],
              [
                45.344574,
                36.01073
              ],
              [
                45.344435,
                36.010558
              ],
              [
                45.344703,
                36.009921
              ],
              [
                45.344488,
                36.009831
              ],
              [
                45.343998,
                36.009726
              ],
              [
                45.343902,
                36.009649
              ],
              [
                45.343745,
                36.00928
              ],
              [
                45.343614,
                36.009232
              ],
              [
                45.34353,
                36.009233
              ],
              [
                45.343387,
                36.00934
              ],
              [
                45.343185,
                36.009389
              ],
              [
                45.342958,
                36.009321
              ],
              [
                45.34261,
                36.008935
              ],
              [
                45.342585,
                36.008683
              ],
              [
                45.342656,
                36.008518
              ],
              [
                45.34256,
                36.008431
              ],
              [
                45.342464,
                36.008402
              ],
              [
                45.341892,
                36.008588
              ],
              [
                45.341761,
                36.008539
              ],
              [
                45.341808,
                36.008433
              ],
              [
                45.342034,
                36.008238
              ],
              [
                45.342152,
                36.008005
              ],
              [
                45.342426,
                36.007675
              ],
              [
                45.343259,
                36.007352
              ],
              [
                45.34339,
                36.007206
              ],
              [
                45.343484,
                36.006954
              ],
              [
                45.343388,
                36.00677
              ],
              [
                45.342994,
                36.006655
              ],
              [
                45.342934,
                36.006587
              ],
              [
                45.342945,
                36.006432
              ],
              [
                45.343266,
                36.006043
              ],
              [
                45.343277,
                36.005917
              ],
              [
                45.343133,
                36.005791
              ],
              [
                45.342859,
                36.00586
              ],
              [
                45.342763,
                36.005744
              ],
              [
                45.342774,
                36.005502
              ],
              [
                45.342987,
                36.005103
              ],
              [
                45.342986,
                36.004929
              ],
              [
                45.342854,
                36.004735
              ],
              [
                45.342375,
                36.004368
              ],
              [
                45.342136,
                36.004262
              ],
              [
                45.342099,
                36.00403
              ],
              [
                45.3417823,
                36.003578
              ],
              [
                45.3425984,
                36.0035214
              ],
              [
                45.3431152,
                36.003361
              ],
              [
                45.3435399,
                36.0030146
              ],
              [
                45.3438796,
                36.0027941
              ],
              [
                45.3444494,
                36.0026653
              ],
              [
                45.3448741,
                36.0024534
              ],
              [
                45.345451,
                36.0019753
              ],
              [
                45.3457236,
                36.0018092
              ],
              [
                45.3458014,
                36.0016374
              ],
              [
                45.3457943,
                36.0014227
              ],
              [
                45.3456952,
                36.0012423
              ],
              [
                45.345175,
                36.0001256
              ],
              [
                45.3443079,
                35.9994642
              ],
              [
                45.3439186,
                35.9990175
              ],
              [
                45.3436036,
                35.9981757
              ],
              [
                45.3430621,
                35.9975257
              ],
              [
                45.3426905,
                35.9973768
              ],
              [
                45.3424427,
                35.9972594
              ],
              [
                45.3423896,
                35.997079
              ],
              [
                45.3423861,
                35.9968872
              ],
              [
                45.3424923,
                35.9967641
              ],
              [
                45.3432497,
                35.9960196
              ],
              [
                45.3442937,
                35.9950202
              ],
              [
                45.3454015,
                35.9939264
              ],
              [
                45.3464066,
                35.9929127
              ],
              [
                45.3471463,
                35.9920937
              ],
              [
                45.3483886,
                35.9908481
              ],
              [
                45.3487283,
                35.9903412
              ],
              [
                45.3490008,
                35.9900033
              ],
              [
                45.3495707,
                35.9894392
              ],
              [
                45.3501865,
                35.9888607
              ],
              [
                45.3507351,
                35.9883309
              ],
              [
                45.3509014,
                35.9880818
              ],
              [
                45.3507988,
                35.9879787
              ],
              [
                45.3506784,
                35.9878384
              ],
              [
                45.3506784,
                35.9874174
              ],
              [
                45.350682,
                35.9865955
              ],
              [
                45.350367,
                35.9856562
              ],
              [
                45.3499458,
                35.9847512
              ],
              [
                45.3493831,
                35.9843417
              ],
              [
                45.3486222,
                35.9837775
              ],
              [
                45.3477727,
                35.9829842
              ],
              [
                45.3474542,
                35.9824258
              ],
              [
                45.3474117,
                35.9820363
              ],
              [
                45.3473233,
                35.9814435
              ],
              [
                45.3474436,
                35.9809795
              ],
              [
                45.3475639,
                35.9807017
              ],
              [
                45.3477197,
                35.9803952
              ],
              [
                45.3481054,
                35.9794988
              ],
              [
                45.3485974,
                35.9786511
              ],
              [
                45.3489407,
                35.9783303
              ],
              [
                45.3493335,
                35.9778033
              ],
              [
                45.3496379,
                35.9775341
              ],
              [
                45.350006,
                35.9772648
              ],
              [
                45.3505227,
                35.9769613
              ],
              [
                45.3511421,
                35.9767207
              ],
              [
                45.3517013,
                35.9764142
              ],
              [
                45.3522569,
                35.9759817
              ],
              [
                45.3526568,
                35.9754461
              ],
              [
                45.3530001,
                35.9751941
              ],
              [
                45.3535523,
                35.9747587
              ],
              [
                45.3538814,
                35.9745525
              ],
              [
                45.3541787,
                35.9744637
              ],
              [
                45.3544017,
                35.9743062
              ],
              [
                45.3546954,
                35.9742145
              ],
              [
                45.355159,
                35.9741143
              ],
              [
                45.3560686,
                35.9739367
              ],
              [
                45.3565181,
                35.9740656
              ],
              [
                45.3567305,
                35.9742059
              ],
              [
                45.3569463,
                35.9745009
              ],
              [
                45.3571162,
                35.9750165
              ],
              [
                45.358001,
                35.9758929
              ],
              [
                45.3584434,
                35.9761163
              ],
              [
                45.3592114,
                35.9762996
              ],
              [
                45.3600148,
                35.9762767
              ],
              [
                45.3608925,
                35.9761622
              ],
              [
                45.362103,
                35.9758442
              ],
              [
                45.3621808,
                35.9757927
              ],
              [
                45.3622127,
                35.9757268
              ],
              [
                45.3623905,
                35.9752601
              ],
              [
                45.3625978,
                35.974941
              ],
              [
                45.362858,
                35.9746942
              ],
              [
                45.3631345,
                35.9745857
              ],
              [
                45.3635817,
                35.9742698
              ],
              [
                45.3636508,
                35.9741349
              ],
              [
                45.3639028,
                35.9740691
              ],
              [
                45.3642525,
                35.9740823
              ],
              [
                45.364659,
                35.9741119
              ],
              [
                45.365155,
                35.974079
              ],
              [
                45.3655087,
                35.9740198
              ],
              [
                45.3658868,
                35.9739211
              ],
              [
                45.3662039,
                35.9738816
              ],
              [
                45.366456,
                35.9739211
              ],
              [
                45.3666592,
                35.9739638
              ],
              [
                45.3668097,
                35.9740395
              ],
              [
                45.3669072,
                35.9741283
              ],
              [
                45.3669194,
                35.9742632
              ],
              [
                45.3668137,
                35.9745857
              ],
              [
                45.3664234,
                35.9753556
              ],
              [
                45.3661998,
                35.9759445
              ],
              [
                45.3652526,
                35.976892
              ],
              [
                45.3649111,
                35.9772276
              ],
              [
                45.3642525,
                35.9775566
              ],
              [
                45.3639232,
                35.9777112
              ],
              [
                45.3631955,
                35.9788133
              ],
              [
                45.3627361,
                35.9797016
              ],
              [
                45.3627564,
                35.9802773
              ],
              [
                45.3630166,
                35.9808892
              ],
              [
                45.3636101,
                35.9814847
              ],
              [
                45.3637735,
                35.981894
              ],
              [
                45.3638825,
                35.9821887
              ],
              [
                45.3639801,
                35.9827973
              ],
              [
                45.3639923,
                35.982896
              ],
              [
                45.3640695,
                35.982998
              ],
              [
                45.3641305,
                35.9830506
              ],
              [
                45.3642972,
                35.9830737
              ],
              [
                45.3644436,
                35.9830737
              ],
              [
                45.3645818,
                35.9830572
              ],
              [
                45.3647566,
                35.9829684
              ],
              [
                45.3652729,
                35.9822249
              ],
              [
                45.3655372,
                35.9819321
              ],
              [
                45.3658096,
                35.9815275
              ],
              [
                45.3660169,
                35.9811886
              ],
              [
                45.3661795,
                35.9810866
              ],
              [
                45.3664844,
                35.9809978
              ],
              [
                45.3676593,
                35.9812577
              ],
              [
                45.3690091,
                35.9817216
              ],
              [
                45.3704686,
                35.9823598
              ],
              [
                45.3709605,
                35.982567
              ],
              [
                45.3719525,
                35.9827348
              ],
              [
                45.3726558,
                35.9829125
              ],
              [
                45.3730745,
                35.9829684
              ],
              [
                45.3733998,
                35.982873
              ],
              [
                45.373847,
                35.9826032
              ],
              [
                45.3745503,
                35.9819321
              ],
              [
                45.3757496,
                35.9805997
              ],
              [
                45.3761643,
                35.9792739
              ],
              [
                45.3764001,
                35.9772111
              ],
              [
                45.3764164,
                35.9765827
              ],
              [
                45.3755707,
                35.9761057
              ],
              [
                45.3740177,
                35.9745429
              ],
              [
                45.3735868,
                35.9740922
              ],
              [
                45.3733957,
                35.9726906
              ],
              [
                45.3736193,
                35.9724339
              ],
              [
                45.3742413,
                35.9717265
              ],
              [
                45.3743511,
                35.97121
              ],
              [
                45.3742047,
                35.9700847
              ],
              [
                45.3743633,
                35.969601
              ],
              [
                45.3749975,
                35.969453
              ],
              [
                45.375522,
                35.9695056
              ],
              [
                45.3761928,
                35.9697557
              ],
              [
                45.3770546,
                35.9705914
              ],
              [
                45.377449,
                35.9710784
              ],
              [
                45.3779084,
                35.9715456
              ],
              [
                45.378689,
                35.9727037
              ],
              [
                45.3792866,
                35.9733914
              ],
              [
                45.380181,
                35.9742303
              ],
              [
                45.3807623,
                35.9744804
              ],
              [
                45.3815216,
                35.9745856
              ],
              [
                45.3823763,
                35.974816
              ],
              [
                45.3828073,
                35.9747239
              ],
              [
                45.3836326,
                35.9743883
              ],
              [
                45.3841408,
                35.9739803
              ],
              [
                45.3851002,
                35.9738026
              ],
              [
                45.3873362,
                35.973523
              ],
              [
                45.3891291,
                35.9728287
              ],
              [
                45.3898975,
                35.9725392
              ],
              [
                45.3903243,
                35.9721214
              ],
              [
                45.3907024,
                35.9715028
              ],
              [
                45.3910642,
                35.9704499
              ],
              [
                45.391109,
                35.9696471
              ],
              [
                45.3913448,
                35.9691009
              ],
              [
                45.3916619,
                35.9686139
              ],
              [
                45.3919505,
                35.968252
              ],
              [
                45.3923367,
                35.9680381
              ],
              [
                45.3925685,
                35.96789
              ],
              [
                45.3929953,
                35.9677946
              ],
              [
                45.3933816,
                35.9678144
              ],
              [
                45.3939304,
                35.9680381
              ],
              [
                45.3944874,
                35.9684593
              ],
              [
                45.3953777,
                35.9689298
              ],
              [
                45.3966787,
                35.9695056
              ],
              [
                45.3980284,
                35.9698116
              ],
              [
                45.399061,
                35.9701505
              ],
              [
                45.4009515,
                35.9706243
              ],
              [
                45.4017646,
                35.9708283
              ],
              [
                45.4039802,
                35.9707362
              ],
              [
                45.4061349,
                35.9699169
              ],
              [
                45.4065415,
                35.9698741
              ],
              [
                45.4073627,
                35.9702426
              ],
              [
                45.4078018,
                35.9706177
              ],
              [
                45.4079929,
                35.971029
              ],
              [
                45.4079725,
                35.9713416
              ],
              [
                45.4077936,
                35.9715554
              ],
              [
                45.4057121,
                35.9733683
              ],
              [
                45.405334,
                35.9740724
              ],
              [
                45.405395,
                35.9746646
              ],
              [
                45.4056918,
                35.9751187
              ],
              [
                45.4060943,
                35.9755036
              ],
              [
                45.406757,
                35.9758787
              ],
              [
                45.4078018,
                35.9757273
              ],
              [
                45.4083506,
                35.9758523
              ],
              [
                45.4087694,
                35.9758885
              ],
              [
                45.4091474,
                35.9760761
              ],
              [
                45.4092775,
                35.9762208
              ],
              [
                45.4096394,
                35.9769644
              ],
              [
                45.4096434,
                35.9772243
              ],
              [
                45.4096638,
                35.9773921
              ],
              [
                45.4091759,
                35.9778592
              ],
              [
                45.4084685,
                35.9784185
              ],
              [
                45.4080538,
                35.9787377
              ],
              [
                45.4077733,
                35.9789383
              ],
              [
                45.4075172,
                35.9792509
              ],
              [
                45.4074562,
                35.9795108
              ],
              [
                45.4075213,
                35.9799549
              ],
              [
                45.4079197,
                35.9802313
              ],
              [
                45.4083222,
                35.9804056
              ],
              [
                45.4090499,
                35.9804056
              ],
              [
                45.4100378,
                35.9800503
              ],
              [
                45.4103712,
                35.979797
              ],
              [
                45.4106639,
                35.9796917
              ],
              [
                45.4108265,
                35.9799286
              ],
              [
                45.4108875,
                35.9801556
              ],
              [
                45.4109606,
                35.9809353
              ],
              [
                45.4111314,
                35.9817479
              ],
              [
                45.4115136,
                35.9823137
              ],
              [
                45.4120055,
                35.982669
              ],
              [
                45.412786,
                35.9829585
              ],
              [
                45.4136154,
                35.9832645
              ],
              [
                45.4146887,
                35.9833697
              ],
              [
                45.4153757,
                35.9831789
              ],
              [
                45.4159734,
                35.9828927
              ],
              [
                45.4183679,
                35.9822545
              ],
              [
                45.4190103,
                35.9817216
              ],
              [
                45.4194534,
                35.9815538
              ],
              [
                45.4201364,
                35.98159
              ],
              [
                45.4207137,
                35.9817216
              ],
              [
                45.4213561,
                35.981942
              ],
              [
                45.4217057,
                35.9826098
              ],
              [
                45.4224863,
                35.9830539
              ],
              [
                45.4238319,
                35.9835046
              ],
              [
                45.4254012,
                35.9846363
              ],
              [
                45.4259378,
                35.9849389
              ],
              [
                45.427003,
                35.9850014
              ],
              [
                45.4276209,
                35.9851231
              ],
              [
                45.4279624,
                35.9853929
              ],
              [
                45.4281047,
                35.9857811
              ],
              [
                45.4281373,
                35.9860903
              ],
              [
                45.4281454,
                35.9862317
              ],
              [
                45.4282023,
                35.986314
              ],
              [
                45.4283324,
                35.9863732
              ],
              [
                45.4285438,
                35.9864521
              ],
              [
                45.4285601,
                35.9870015
              ],
              [
                45.4286373,
                35.9874061
              ],
              [
                45.4289422,
                35.9880311
              ],
              [
                45.4292187,
                35.9887252
              ],
              [
                45.4295439,
                35.9894094
              ],
              [
                45.4299868,
                35.9897846
              ],
              [
                45.4303489,
                35.9902285
              ],
              [
                45.4307513,
                35.9903963
              ],
              [
                45.4311213,
                35.9905805
              ],
              [
                45.4312921,
                35.9905476
              ],
              [
                45.4317149,
                35.990541
              ],
              [
                45.4321702,
                35.9904292
              ],
              [
                45.4328166,
                35.9904357
              ],
              [
                45.433154,
                35.9907153
              ],
              [
                45.4336988,
                35.9908765
              ],
              [
                45.4336907,
                35.9911265
              ],
              [
                45.4334346,
                35.9914555
              ],
              [
                45.4326824,
                35.9926956
              ],
              [
                45.4322068,
                35.9933041
              ],
              [
                45.4319669,
                35.9937777
              ],
              [
                45.4320686,
                35.9943895
              ],
              [
                45.4322393,
                35.9947843
              ],
              [
                45.4330402,
                35.9952711
              ],
              [
                45.4339102,
                35.9959059
              ],
              [
                45.4346664,
                35.996021
              ],
              [
                45.4354307,
                35.996544
              ],
              [
                45.4366503,
                35.9971985
              ],
              [
                45.4374594,
                35.9978366
              ],
              [
                45.4387928,
                35.9984977
              ],
              [
                45.4394962,
                35.9991884
              ],
              [
                45.4396954,
                35.9993266
              ],
              [
                45.4402971,
                35.9993924
              ],
              [
                45.4414883,
                35.9992509
              ],
              [
                45.4422566,
                35.9988135
              ],
              [
                45.4429518,
                35.9985372
              ],
              [
                45.4437405,
                35.9980636
              ],
              [
                45.4447081,
                35.9976426
              ],
              [
                45.4451878,
                35.9975505
              ],
              [
                45.4456676,
                35.9975505
              ],
              [
                45.4461757,
                35.9976919
              ],
              [
                45.446688,
                35.9975307
              ],
              [
                45.4470132,
                35.9972084
              ],
              [
                45.4473669,
                35.9970308
              ],
              [
                45.4474157,
                35.9967117
              ],
              [
                45.4477166,
                35.9964223
              ],
              [
                45.4482613,
                35.9961263
              ],
              [
                45.4486191,
                35.9959782
              ],
              [
                45.4491679,
                35.9958335
              ],
              [
                45.4493712,
                35.9958039
              ],
              [
                45.4500217,
                35.9959717
              ],
              [
                45.450847,
                35.9958598
              ],
              [
                45.4523309,
                35.9949092
              ],
              [
                45.4533269,
                35.9943567
              ],
              [
                45.4535261,
                35.9941593
              ],
              [
                45.4536725,
                35.9939356
              ],
              [
                45.4539936,
                35.9931626
              ],
              [
                45.4545831,
                35.992439
              ],
              [
                45.4545884,
                35.9921273
              ],
              [
                45.4542579,
                35.991666
              ],
              [
                45.4542863,
                35.9905542
              ],
              [
                45.4543392,
                35.9903535
              ],
              [
                45.4544083,
                35.9901002
              ],
              [
                45.4546807,
                35.9899752
              ],
              [
                45.4551848,
                35.9898634
              ],
              [
                45.4556767,
                35.9898667
              ],
              [
                45.4561849,
                35.9901298
              ],
              [
                45.4569452,
                35.9907153
              ],
              [
                45.4571769,
                35.9909522
              ],
              [
                45.4580998,
                35.9911627
              ],
              [
                45.4582624,
                35.9911824
              ],
              [
                45.4583234,
                35.9912713
              ],
              [
                45.458364,
                35.9913864
              ],
              [
                45.458425,
                35.9916232
              ],
              [
                45.4588438,
                35.9933368
              ],
              [
                45.4591707,
                35.9941208
              ],
              [
                45.460114,
                35.9954376
              ],
              [
                45.46056,
                35.9957757
              ],
              [
                45.4608192,
                35.9961026
              ],
              [
                45.46148,
                35.9961592
              ],
              [
                45.4618209,
                35.9960478
              ],
              [
                45.4625284,
                35.9959288
              ],
              [
                45.4639551,
                35.9959514
              ],
              [
                45.4655499,
                35.9964124
              ],
              [
                45.4660379,
                35.9963633
              ],
              [
                45.4668038,
                35.9962461
              ],
              [
                45.4677168,
                35.9963293
              ],
              [
                45.4681021,
                35.996539
              ],
              [
                45.4683683,
                35.9967468
              ],
              [
                45.4688936,
                35.9971737
              ],
              [
                45.469391,
                35.997408
              ],
              [
                45.4702363,
                35.9978576
              ],
              [
                45.4711726,
                35.9983355
              ],
              [
                45.4727114,
                35.9986264
              ],
              [
                45.4736197,
                35.999076
              ],
              [
                45.4740703,
                35.9994198
              ],
              [
                45.4743622,
                35.999469
              ],
              [
                45.4750207,
                35.9996673
              ],
              [
                45.4756138,
                36.000047
              ],
              [
                45.4757188,
                36.0001944
              ],
              [
                45.4757866,
                36.0003417
              ],
              [
                45.475915,
                36.0004116
              ],
              [
                45.477309,
                36.0008687
              ],
              [
                45.4779254,
                36.0011445
              ],
              [
                45.4783784,
                36.0015337
              ],
              [
                45.4786096,
                36.0018265
              ],
              [
                45.4788431,
                36.0022364
              ],
              [
                45.4791069,
                36.0023252
              ],
              [
                45.4796743,
                36.0021722
              ],
              [
                45.4800946,
                36.0019908
              ],
              [
                45.4804729,
                36.0017056
              ],
              [
                45.4807788,
                36.001392
              ],
              [
                45.481045,
                36.0008461
              ],
              [
                45.4811757,
                36.0007365
              ],
              [
                45.4815703,
                36.0005438
              ],
              [
                45.4820747,
                36.000404
              ],
              [
                45.4824086,
                36.0004872
              ],
              [
                45.4831044,
                36.0009009
              ],
              [
                45.4835317,
                36.0010274
              ],
              [
                45.4842252,
                36.0009915
              ],
              [
                45.4848253,
                36.0009537
              ],
              [
                45.4851919,
                36.001052
              ],
              [
                45.485757,
                36.001358
              ],
              [
                45.4867681,
                36.0017906
              ],
              [
                45.4876133,
                36.0020739
              ],
              [
                45.4883745,
                36.0022439
              ],
              [
                45.4887995,
                36.0021325
              ],
              [
                45.4891287,
                36.0021533
              ],
              [
                45.4907259,
                36.0023119
              ],
              [
                45.4917159,
                36.00238
              ],
              [
                45.4925378,
                36.0023252
              ],
              [
                45.49318,
                36.0021155
              ],
              [
                45.493745,
                36.0018265
              ],
              [
                45.4943335,
                36.0017339
              ],
              [
                45.4958652,
                36.0016867
              ],
              [
                45.4976632,
                36.0017547
              ],
              [
                45.4987816,
                36.001919
              ],
              [
                45.5000695,
                36.0019555
              ],
              [
                45.5017579,
                36.0026441
              ],
              [
                45.5027398,
                36.0027966
              ],
              [
                45.5034007,
                36.0026932
              ],
              [
                45.5042,
                36.0022419
              ],
              [
                45.5045251,
                36.002166
              ],
              [
                45.505257,
                36.0019873
              ],
              [
                45.505724,
                36.0017847
              ],
              [
                45.5062385,
                36.0013649
              ],
              [
                45.5062767,
                36.001052
              ],
              [
                45.5062059,
                35.9995559
              ],
              [
                45.5070836,
                35.9989431
              ],
              [
                45.5077915,
                35.9986024
              ],
              [
                45.5086409,
                35.9983862
              ],
              [
                45.5094353,
                35.9982569
              ],
              [
                45.5099576,
                35.9982502
              ],
              [
                45.5104957,
                35.9980897
              ],
              [
                45.5114822,
                35.9976711
              ],
              [
                45.512398,
                35.9970118
              ],
              [
                45.5139747,
                35.9961287
              ],
              [
                45.51458,
                35.9960574
              ],
              [
                45.5154507,
                35.9962127
              ],
              [
                45.5166082,
                35.996217
              ],
              [
                45.5180432,
                35.995861
              ],
              [
                45.5183087,
                35.9959134
              ],
              [
                45.518749,
                35.9953895
              ],
              [
                45.51895,
                35.9952338
              ],
              [
                45.519296,
                35.9951954
              ],
              [
                45.5196837,
                35.9952865
              ],
              [
                45.5199726,
                35.9952429
              ],
              [
                45.5204694,
                35.9950677
              ],
              [
                45.5210454,
                35.9948014
              ],
              [
                45.521337,
                35.9946984
              ],
              [
                45.5217417,
                35.9946728
              ],
              [
                45.5224136,
                35.9947513
              ],
              [
                45.5230116,
                35.9948641
              ],
              [
                45.5235494,
                35.9949166
              ],
              [
                45.524218,
                35.9950991
              ],
              [
                45.5244769,
                35.9951356
              ],
              [
                45.5247716,
                35.9952779
              ],
              [
                45.5253484,
                35.9954448
              ],
              [
                45.5257788,
                35.9958001
              ],
              [
                45.5261916,
                35.9958899
              ],
              [
                45.5264841,
                35.9958193
              ],
              [
                45.5267243,
                35.9957416
              ],
              [
                45.5272172,
                35.9955069
              ],
              [
                45.5275085,
                35.9953563
              ],
              [
                45.5277396,
                35.9952172
              ],
              [
                45.5283077,
                35.9950948
              ],
              [
                45.5284891,
                35.995045
              ],
              [
                45.5288276,
                35.9951261
              ],
              [
                45.5291448,
                35.9951613
              ],
              [
                45.529766,
                35.9950785
              ],
              [
                45.5304579,
                35.9950987
              ],
              [
                45.5307641,
                35.9951332
              ],
              [
                45.5311366,
                35.9951348
              ],
              [
                45.5316861,
                35.9953539
              ],
              [
                45.5322304,
                35.9954999
              ],
              [
                45.5326402,
                35.9955256
              ],
              [
                45.5327354,
                35.995536
              ],
              [
                45.5330606,
                35.9955713
              ],
              [
                45.5334244,
                35.9957717
              ],
              [
                45.5334104,
                35.99601
              ],
              [
                45.5333467,
                35.9962322
              ],
              [
                45.5337927,
                35.9966263
              ],
              [
                45.5340972,
                35.9968474
              ],
              [
                45.5343334,
                35.9969827
              ],
              [
                45.5348559,
                35.9972818
              ],
              [
                45.5352284,
                35.99737
              ],
              [
                45.5356641,
                35.9974585
              ],
              [
                45.5360431,
                35.9974669
              ],
              [
                45.5366319,
                35.9973999
              ],
              [
                45.5372136,
                35.9974647
              ],
              [
                45.5378064,
                35.9975012
              ],
              [
                45.5381444,
                35.9977611
              ],
              [
                45.5384379,
                35.9980351
              ],
              [
                45.5388234,
                35.9982805
              ],
              [
                45.5395732,
                35.9986681
              ],
              [
                45.540775,
                35.9990192
              ],
              [
                45.541798,
                35.9990337
              ],
              [
                45.5429882,
                35.9992514
              ],
              [
                45.5435683,
                35.9992531
              ],
              [
                45.5441876,
                35.9992411
              ],
              [
                45.5444816,
                35.9990237
              ],
              [
                45.5449437,
                35.9988152
              ],
              [
                45.5449968,
                35.9988138
              ],
              [
                45.5456228,
                35.9987976
              ],
              [
                45.545656,
                35.998802
              ],
              [
                45.5463575,
                35.9988954
              ],
              [
                45.5470296,
                35.9992414
              ],
              [
                45.5480223,
                35.9997639
              ],
              [
                45.5484369,
                36.0004387
              ],
              [
                45.5492639,
                36.0012483
              ],
              [
                45.5496254,
                36.0015718
              ],
              [
                45.5498622,
                36.0016393
              ],
              [
                45.5501077,
                36.0016545
              ],
              [
                45.5503353,
                36.001621
              ],
              [
                45.5505154,
                36.0015283
              ],
              [
                45.5506307,
                36.001554
              ],
              [
                45.5507121,
                36.0015128
              ],
              [
                45.5506924,
                36.0012967
              ],
              [
                45.5506489,
                36.001126
              ],
              [
                45.5507392,
                36.000907
              ],
              [
                45.5507562,
                36.0006566
              ],
              [
                45.5506931,
                36.0004893
              ],
              [
                45.5505027,
                36.0000113
              ],
              [
                45.5504021,
                35.9998251
              ],
              [
                45.5504942,
                35.9995697
              ],
              [
                45.5507373,
                35.9991887
              ],
              [
                45.5513156,
                35.9988015
              ],
              [
                45.5514559,
                35.998819
              ],
              [
                45.5517461,
                35.9987877
              ],
              [
                45.5518437,
                35.9986603
              ],
              [
                45.5520665,
                35.9986132
              ],
              [
                45.5524516,
                35.9986142
              ],
              [
                45.5524711,
                35.9986187
              ],
              [
                45.5532452,
                35.998764
              ],
              [
                45.5535183,
                35.998863
              ],
              [
                45.5538246,
                35.9990401
              ],
              [
                45.5542099,
                35.9990967
              ],
              [
                45.5545279,
                35.9990705
              ],
              [
                45.5548599,
                35.9990894
              ],
              [
                45.555758,
                35.9987919
              ],
              [
                45.5558716,
                35.9985976
              ],
              [
                45.5559713,
                35.9979861
              ],
              [
                45.5560586,
                35.9977982
              ],
              [
                45.5563229,
                35.9974693
              ],
              [
                45.5565546,
                35.9970541
              ],
              [
                45.5566222,
                35.9968314
              ],
              [
                45.5567094,
                35.9966354
              ],
              [
                45.5567739,
                35.9962632
              ],
              [
                45.556936,
                35.9958797
              ],
              [
                45.5572403,
                35.9955057
              ],
              [
                45.5573646,
                35.9952605
              ],
              [
                45.55745,
                35.9951585
              ],
              [
                45.557841,
                35.9950418
              ],
              [
                45.5584872,
                35.9999714
              ],
              [
                45.5587676,
                36.0044146
              ],
              [
                45.5584871,
                36.004694
              ],
              [
                45.5582105,
                36.0069199
              ],
              [
                45.5576542,
                36.0127509
              ],
              [
                45.568199,
                36.0185593
              ],
              [
                45.572375,
                36.0235879
              ],
              [
                45.5817114,
                36.0331631
              ],
              [
                45.5861326,
                36.039145
              ],
              [
                45.5879349,
                36.0419883
              ],
              [
                45.5870575,
                36.043935
              ],
              [
                45.5836911,
                36.0459493
              ],
              [
                45.5787992,
                36.0490643
              ],
              [
                45.5745075,
                36.050244
              ],
              [
                45.5697343,
                36.0524425
              ],
              [
                45.568639,
                36.054156
              ],
              [
                45.567255,
                36.0597157
              ],
              [
                45.5671267,
                36.0638128
              ],
              [
                45.5670833,
                36.0651971
              ],
              [
                45.5675554,
                36.0688048
              ],
              [
                45.569229,
                36.0721349
              ],
              [
                45.5716753,
                36.0747017
              ],
              [
                45.5752372,
                36.0760198
              ],
              [
                45.5807304,
                36.0762972
              ],
              [
                45.5856227,
                36.077095
              ],
              [
                45.5877685,
                36.0781702
              ],
              [
                45.5888846,
                36.0796674
              ],
              [
                45.5896568,
                36.0836502
              ],
              [
                45.5895845,
                36.0876506
              ],
              [
                45.590043,
                36.0884016
              ],
              [
                45.591448,
                36.0887951
              ],
              [
                45.5967378,
                36.087812
              ],
              [
                45.6009882,
                36.0863679
              ],
              [
                45.6089294,
                36.0842202
              ],
              [
                45.6152935,
                36.0834225
              ],
              [
                45.617423,
                36.0826098
              ],
              [
                45.6191396,
                36.0827832
              ],
              [
                45.6208992,
                36.0823323
              ],
              [
                45.6259632,
                36.0826098
              ],
              [
                45.6287096,
                36.0837891
              ],
              [
                45.639739,
                36.0907251
              ],
              [
                45.6427002,
                36.0937075
              ],
              [
                45.6448972,
                36.0954111
              ],
              [
                45.6480002,
                36.09747
              ],
              [
                45.6516266,
                36.099013
              ],
              [
                45.6545877,
                36.1011282
              ],
              [
                45.6563902,
                36.1039888
              ],
              [
                45.656476,
                36.1061385
              ],
              [
                45.6560683,
                36.1084269
              ],
              [
                45.6553387,
                36.1108192
              ],
              [
                45.6542014,
                36.1132634
              ],
              [
                45.6505107,
                36.120197
              ],
              [
                45.6496095,
                36.1258127
              ],
              [
                45.6500882,
                36.1301873
              ],
              [
                45.6516695,
                36.1384986
              ],
              [
                45.6529599,
                36.1488409
              ],
              [
                45.6533923,
                36.1509283
              ],
              [
                45.6542015,
                36.1528804
              ],
              [
                45.655119,
                36.1545163
              ],
              [
                45.6581068,
                36.1582859
              ],
              [
                45.6586506,
                36.1593008
              ],
              [
                45.6639976,
                36.1652472
              ],
              [
                45.6705093,
                36.168784
              ],
              [
                45.6781709,
                36.1705366
              ],
              [
                45.6814077,
                36.17137
              ],
              [
                45.6912719,
                36.1744202
              ],
              [
                45.6977893,
                36.176442
              ],
              [
                45.7016517,
                36.1787456
              ],
              [
                45.6909798,
                36.1886157
              ],
              [
                45.6898856,
                36.1923562
              ],
              [
                45.6895852,
                36.1941399
              ],
              [
                45.6896494,
                36.195837
              ],
              [
                45.6903362,
                36.1978456
              ],
              [
                45.6914305,
                36.1995771
              ],
              [
                45.6949944,
                36.2023647
              ],
              [
                45.6972146,
                36.2045459
              ],
              [
                45.7058714,
                36.2156098
              ],
              [
                45.7077596,
                36.2197646
              ],
              [
                45.6802939,
                36.2444118
              ],
              [
                45.6774682,
                36.2544855
              ],
              [
                45.6739425,
                36.2701583
              ],
              [
                45.6739423,
                36.2817831
              ],
              [
                45.6764544,
                36.2944336
              ],
              [
                45.6754827,
                36.3103509
              ],
              [
                45.6590741,
                36.3268921
              ],
              [
                45.6538027,
                36.3322153
              ],
              [
                45.6410573,
                36.3400141
              ],
              [
                45.637021,
                36.3416746
              ],
              [
                45.6305554,
                36.34293
              ],
              [
                45.6272949,
                36.3437588
              ],
              [
                45.6236288,
                36.3442427
              ],
              [
                45.6136893,
                36.3459645
              ],
              [
                45.6006431,
                36.3449275
              ],
              [
                45.5947207,
                36.3460336
              ],
              [
                45.5880716,
                36.3488184
              ],
              [
                45.5874548,
                36.3474872
              ],
              [
                45.5870248,
                36.3464361
              ],
              [
                45.5866732,
                36.3449948
              ],
              [
                45.5862772,
                36.3438991
              ],
              [
                45.5868673,
                36.343683
              ],
              [
                45.5850219,
                36.3391891
              ],
              [
                45.580945,
                36.3334158
              ],
              [
                45.5704721,
                36.3328434
              ],
              [
                45.551593,
                36.3267458
              ],
              [
                45.5488233,
                36.3133735
              ],
              [
                45.5359107,
                36.3069743
              ],
              [
                45.5186748,
                36.2961385
              ],
              [
                45.5123079,
                36.2928019
              ],
              [
                45.5099673,
                36.2866652
              ],
              [
                45.508933,
                36.2809181
              ],
              [
                45.504341,
                36.2766628
              ],
              [
                45.5012511,
                36.2716115
              ],
              [
                45.4958438,
                36.2717499
              ],
              [
                45.48357,
                36.2720959
              ],
              [
                45.4775619,
                36.2682899
              ],
              [
                45.4772185,
                36.2630304
              ],
              [
                45.4838275,
                36.2586703
              ],
              [
                45.4862308,
                36.2530641
              ],
              [
                45.4842567,
                36.2522335
              ],
              [
                45.4799651,
                36.2455885
              ],
              [
                45.4784202,
                36.2404659
              ],
              [
                45.4732274,
                36.2272772
              ],
              [
                45.472412,
                36.222465
              ],
              [
                45.4780846,
                36.2119832
              ],
              [
                45.4662208,
                36.2125418
              ],
              [
                45.459147,
                36.2131031
              ],
              [
                45.4497639,
                36.2154696
              ],
              [
                45.4455391,
                36.2172054
              ],
              [
                45.4421174,
                36.221514
              ],
              [
                45.4392473,
                36.2239377
              ],
              [
                45.4360613,
                36.2250456
              ],
              [
                45.430355,
                36.2255809
              ],
              [
                45.4188537,
                36.225027
              ],
              [
                45.4076957,
                36.2252347
              ],
              [
                45.3995418,
                36.227935
              ],
              [
                45.3959369,
                36.2298736
              ],
              [
                45.3932012,
                36.2338647
              ],
              [
                45.3909039,
                36.2374074
              ],
              [
                45.3872156,
                36.2419072
              ],
              [
                45.3842901,
                36.2460616
              ],
              [
                45.3776213,
                36.2526094
              ],
              [
                45.3719996,
                36.2578584
              ],
              [
                45.3658076,
                36.256096
              ],
              [
                45.3622949,
                36.2542965
              ],
              [
                45.3578144,
                36.2494562
              ],
              [
                45.3508684,
                36.2468259
              ],
              [
                45.3410781,
                36.2460044
              ],
              [
                45.3347934,
                36.2478065
              ],
              [
                45.3275003,
                36.2491909
              ],
              [
                45.3181179,
                36.2515203
              ],
              [
                45.3045271,
                36.257563
              ],
              [
                45.3019556,
                36.2728275
              ],
              [
                45.301472,
                36.272674
              ],
              [
                45.301064,
                36.272401
              ],
              [
                45.3009,
                36.27209
              ],
              [
                45.300356,
                36.271598
              ],
              [
                45.30019,
                36.27125
              ],
              [
                45.300133,
                36.270925
              ],
              [
                45.30024,
                36.270113
              ],
              [
                45.300062,
                36.269735
              ],
              [
                45.299958,
                36.268927
              ],
              [
                45.299766,
                36.268756
              ],
              [
                45.299251,
                36.268702
              ],
              [
                45.298709,
                36.268814
              ],
              [
                45.298278,
                36.268998
              ],
              [
                45.297732,
                36.269095
              ],
              [
                45.297301,
                36.268983
              ],
              [
                45.296966,
                36.268772
              ],
              [
                45.296737,
                36.268759
              ],
              [
                45.296436,
                36.268915
              ],
              [
                45.295771,
                36.269028
              ],
              [
                45.29525,
                36.268974
              ],
              [
                45.294786,
                36.269003
              ],
              [
                45.294437,
                36.268881
              ],
              [
                45.29364,
                36.268952
              ],
              [
                45.293222,
                36.268897
              ],
              [
                45.292805,
                36.268728
              ],
              [
                45.292168,
                36.268555
              ],
              [
                45.29178,
                36.268516
              ],
              [
                45.291504,
                36.268376
              ],
              [
                45.291159,
                36.268118
              ],
              [
                45.290159,
                36.268026
              ],
              [
                45.289653,
                36.268072
              ],
              [
                45.289129,
                36.267674
              ],
              [
                45.288404,
                36.267452
              ],
              [
                45.287649,
                36.2673
              ],
              [
                45.287015,
                36.266991
              ],
              [
                45.28645,
                36.266913
              ],
              [
                45.286051,
                36.266946
              ],
              [
                45.285783,
                36.266837
              ],
              [
                45.285205,
                36.2664
              ],
              [
                45.284751,
                36.266179
              ],
              [
                45.28451,
                36.26593
              ],
              [
                45.28431,
                36.265571
              ],
              [
                45.283959,
                36.265348
              ],
              [
                45.283381,
                36.26518
              ],
              [
                45.282949,
                36.265003
              ],
              [
                45.282634,
                36.264768
              ],
              [
                45.281561,
                36.264337
              ],
              [
                45.280976,
                36.264435
              ],
              [
                45.280158,
                36.26417
              ],
              [
                45.279595,
                36.263563
              ],
              [
                45.279301,
                36.262801
              ],
              [
                45.27898,
                36.262566
              ],
              [
                45.278604,
                36.262169
              ],
              [
                45.277206,
                36.261429
              ],
              [
                45.277039,
                36.261162
              ],
              [
                45.276529,
                36.26095
              ],
              [
                45.276252,
                36.260773
              ],
              [
                45.275307,
                36.260843
              ],
              [
                45.274926,
                36.260781
              ],
              [
                45.274543,
                36.260649
              ],
              [
                45.274217,
                36.260453
              ],
              [
                45.273766,
                36.259951
              ],
              [
                45.273061,
                36.259342
              ],
              [
                45.273032,
                36.259088
              ],
              [
                45.272878,
                36.258764
              ],
              [
                45.272407,
                36.258195
              ],
              [
                45.271206,
                36.256999
              ],
              [
                45.270569,
                36.256556
              ],
              [
                45.270258,
                36.256131
              ],
              [
                45.269815,
                36.255724
              ],
              [
                45.269181,
                36.255383
              ],
              [
                45.268092,
                36.254583
              ],
              [
                45.267397,
                36.254337
              ],
              [
                45.265754,
                36.253206
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555083,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سلماس",
          "name:en": "Salmas County",
          "name:ku": "Selmas",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q522238",
          "wikipedia": "en:Salmas County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.2227458,
                37.8882392
              ],
              [
                44.2232921,
                37.8877416
              ],
              [
                44.2239031,
                37.8874998
              ],
              [
                44.2247364,
                37.8868794
              ],
              [
                44.2264605,
                37.886421
              ],
              [
                44.2274054,
                37.886124
              ],
              [
                44.2283905,
                37.8856345
              ],
              [
                44.2297175,
                37.8853978
              ],
              [
                44.2310991,
                37.8849757
              ],
              [
                44.2323603,
                37.8844803
              ],
              [
                44.2336278,
                37.8842345
              ],
              [
                44.2343626,
                37.8842932
              ],
              [
                44.2352428,
                37.8846458
              ],
              [
                44.236374,
                37.8848439
              ],
              [
                44.2374218,
                37.8842894
              ],
              [
                44.2385502,
                37.8841326
              ],
              [
                44.2390657,
                37.883757
              ],
              [
                44.2396537,
                37.8829938
              ],
              [
                44.2397678,
                37.8826008
              ],
              [
                44.2396513,
                37.8819718
              ],
              [
                44.2397171,
                37.880744
              ],
              [
                44.2408602,
                37.8797636
              ],
              [
                44.241947,
                37.8785924
              ],
              [
                44.2424935,
                37.8775853
              ],
              [
                44.2427933,
                37.8768844
              ],
              [
                44.243527,
                37.8763341
              ],
              [
                44.2441613,
                37.8757569
              ],
              [
                44.2461577,
                37.8750493
              ],
              [
                44.2473878,
                37.8749994
              ],
              [
                44.248023,
                37.8751982
              ],
              [
                44.2488781,
                37.8752796
              ],
              [
                44.2499232,
                37.8755999
              ],
              [
                44.2505595,
                37.8754366
              ],
              [
                44.2517196,
                37.8757813
              ],
              [
                44.2517298,
                37.8737368
              ],
              [
                44.2527994,
                37.8732856
              ],
              [
                44.2546826,
                37.8733077
              ],
              [
                44.2558141,
                37.8728159
              ],
              [
                44.2564406,
                37.8717894
              ],
              [
                44.2565204,
                37.871252
              ],
              [
                44.2578993,
                37.8700504
              ],
              [
                44.2589244,
                37.8697372
              ],
              [
                44.2607563,
                37.8688607
              ],
              [
                44.2628325,
                37.8681025
              ],
              [
                44.2634301,
                37.8681051
              ],
              [
                44.2641759,
                37.8683406
              ],
              [
                44.2661277,
                37.8679221
              ],
              [
                44.2673977,
                37.8673051
              ],
              [
                44.2680203,
                37.867248
              ],
              [
                44.2697747,
                37.8678658
              ],
              [
                44.270109,
                37.8686588
              ],
              [
                44.2706959,
                37.8692161
              ],
              [
                44.2740064,
                37.8703359
              ],
              [
                44.2754154,
                37.8705356
              ],
              [
                44.2771646,
                37.8710202
              ],
              [
                44.2797894,
                37.8714445
              ],
              [
                44.2803522,
                37.8716908
              ],
              [
                44.2807734,
                37.8724212
              ],
              [
                44.281196,
                37.8724965
              ],
              [
                44.2820586,
                37.8724624
              ],
              [
                44.2844905,
                37.8731084
              ],
              [
                44.2862449,
                37.8726964
              ],
              [
                44.2874765,
                37.8725379
              ],
              [
                44.2887948,
                37.8718914
              ],
              [
                44.2897452,
                37.8709233
              ],
              [
                44.2905766,
                37.8688371
              ],
              [
                44.2911665,
                37.8681264
              ],
              [
                44.2916147,
                37.8674038
              ],
              [
                44.2929042,
                37.866908
              ],
              [
                44.2946477,
                37.8670345
              ],
              [
                44.296402,
                37.8672446
              ],
              [
                44.2992984,
                37.8682092
              ],
              [
                44.3007422,
                37.8684867
              ],
              [
                44.3023952,
                37.8686861
              ],
              [
                44.3029692,
                37.8687298
              ],
              [
                44.3040336,
                37.8681342
              ],
              [
                44.3047168,
                37.8679322
              ],
              [
                44.3055266,
                37.8681652
              ],
              [
                44.3071801,
                37.8687872
              ],
              [
                44.3087472,
                37.8695259
              ],
              [
                44.3099329,
                37.8702521
              ],
              [
                44.3107592,
                37.8711328
              ],
              [
                44.3113869,
                37.8719339
              ],
              [
                44.3123046,
                37.87257
              ],
              [
                44.3130837,
                37.8734459
              ],
              [
                44.3143539,
                37.8742365
              ],
              [
                44.3153029,
                37.8749083
              ],
              [
                44.3164163,
                37.8760164
              ],
              [
                44.3170248,
                37.8764894
              ],
              [
                44.3182307,
                37.8768847
              ],
              [
                44.3193365,
                37.8770837
              ],
              [
                44.3207977,
                37.8770069
              ],
              [
                44.3233946,
                37.8764215
              ],
              [
                44.3267277,
                37.8757652
              ],
              [
                44.3295569,
                37.8754955
              ],
              [
                44.331565,
                37.8749123
              ],
              [
                44.3338075,
                37.8732706
              ],
              [
                44.3359579,
                37.8708996
              ],
              [
                44.3375565,
                37.8700026
              ],
              [
                44.3384335,
                37.8697664
              ],
              [
                44.3394292,
                37.8699188
              ],
              [
                44.3409654,
                37.8697964
              ],
              [
                44.3455159,
                37.8684426
              ],
              [
                44.3487652,
                37.8666793
              ],
              [
                44.3499648,
                37.8669089
              ],
              [
                44.351602,
                37.8665526
              ],
              [
                44.3532455,
                37.8656074
              ],
              [
                44.3547482,
                37.8649376
              ],
              [
                44.3561932,
                37.8637478
              ],
              [
                44.3571214,
                37.8633178
              ],
              [
                44.3585043,
                37.86331
              ],
              [
                44.3593718,
                37.8631153
              ],
              [
                44.3600472,
                37.8627719
              ],
              [
                44.3611842,
                37.8628659
              ],
              [
                44.3626576,
                37.8625134
              ],
              [
                44.365237,
                37.8624766
              ],
              [
                44.367856,
                37.862722
              ],
              [
                44.369019,
                37.863285
              ],
              [
                44.370369,
                37.863426
              ],
              [
                44.371299,
                37.863883
              ],
              [
                44.373486,
                37.863918
              ],
              [
                44.37465,
                37.864023
              ],
              [
                44.377581,
                37.864094
              ],
              [
                44.379302,
                37.863812
              ],
              [
                44.380838,
                37.863426
              ],
              [
                44.381955,
                37.86325
              ],
              [
                44.383164,
                37.862652
              ],
              [
                44.384188,
                37.862476
              ],
              [
                44.384793,
                37.862511
              ],
              [
                44.386282,
                37.862722
              ],
              [
                44.387445,
                37.862722
              ],
              [
                44.388189,
                37.862511
              ],
              [
                44.389074,
                37.862054
              ],
              [
                44.390795,
                37.860683
              ],
              [
                44.391307,
                37.860085
              ],
              [
                44.391633,
                37.859557
              ],
              [
                44.392051,
                37.85903
              ],
              [
                44.392842,
                37.858573
              ],
              [
                44.393168,
                37.85808
              ],
              [
                44.394099,
                37.857342
              ],
              [
                44.395913,
                37.856674
              ],
              [
                44.396704,
                37.856252
              ],
              [
                44.397821,
                37.855795
              ],
              [
                44.398426,
                37.855197
              ],
              [
                44.3993937,
                37.8547328
              ],
              [
                44.399775,
                37.854388
              ],
              [
                44.400101,
                37.853931
              ],
              [
                44.400892,
                37.853403
              ],
              [
                44.401543,
                37.852911
              ],
              [
                44.402288,
                37.852348
              ],
              [
                44.402986,
                37.852173
              ],
              [
                44.403172,
                37.851715
              ],
              [
                44.403451,
                37.851223
              ],
              [
                44.403637,
                37.85052
              ],
              [
                44.40373,
                37.849922
              ],
              [
                44.404009,
                37.849219
              ],
              [
                44.404335,
                37.84841
              ],
              [
                44.4048,
                37.847425
              ],
              [
                44.404986,
                37.847003
              ],
              [
                44.40508,
                37.846265
              ],
              [
                44.405033,
                37.845667
              ],
              [
                44.404986,
                37.844999
              ],
              [
                44.4048998,
                37.8447814
              ],
              [
                44.406418,
                37.8448279
              ],
              [
                44.4081471,
                37.8450203
              ],
              [
                44.4285264,
                37.8486553
              ],
              [
                44.43186,
                37.8503184
              ],
              [
                44.4502986,
                37.8610837
              ],
              [
                44.4508548,
                37.8616321
              ],
              [
                44.4580744,
                37.8644098
              ],
              [
                44.4957425,
                37.8824323
              ],
              [
                44.4968775,
                37.8828873
              ],
              [
                44.4984262,
                37.8889655
              ],
              [
                44.5049963,
                37.8938138
              ],
              [
                44.5055495,
                37.896252
              ],
              [
                44.5072159,
                37.897088
              ],
              [
                44.5108292,
                37.8981936
              ],
              [
                44.5116629,
                37.8987509
              ],
              [
                44.5124956,
                37.8987509
              ],
              [
                44.5458739,
                37.9294141
              ],
              [
                44.5705001,
                37.9305711
              ],
              [
                44.5710565,
                37.9308497
              ],
              [
                44.571333,
                37.9319643
              ],
              [
                44.5785711,
                37.9398655
              ],
              [
                44.5794149,
                37.9450271
              ],
              [
                44.5814713,
                37.9558299
              ],
              [
                44.5834143,
                37.9577712
              ],
              [
                44.5969389,
                37.9607114
              ],
              [
                44.6103774,
                37.967794
              ],
              [
                44.6114876,
                37.9683513
              ],
              [
                44.6125014,
                37.9682795
              ],
              [
                44.6185682,
                37.9780333
              ],
              [
                44.6296603,
                37.9805032
              ],
              [
                44.6562134,
                37.9991866
              ],
              [
                44.6562134,
                37.9994652
              ],
              [
                44.6637171,
                38.0121256
              ],
              [
                44.669823,
                38.0236309
              ],
              [
                44.6701003,
                38.024188
              ],
              [
                44.6845467,
                38.0372454
              ],
              [
                44.6983145,
                38.0368102
              ],
              [
                44.7024811,
                38.0368102
              ],
              [
                44.7030382,
                38.0370888
              ],
              [
                44.7033148,
                38.0368102
              ],
              [
                44.7049812,
                38.0368102
              ],
              [
                44.7055383,
                38.0365316
              ],
              [
                44.7072046,
                38.0365316
              ],
              [
                44.7077578,
                38.0362531
              ],
              [
                44.7122048,
                38.036253
              ],
              [
                44.7127611,
                38.0365316
              ],
              [
                44.7141477,
                38.0365317
              ],
              [
                44.7144283,
                38.0368103
              ],
              [
                44.7449218,
                38.0364047
              ],
              [
                44.7454788,
                38.0364047
              ],
              [
                44.7511118,
                38.0361533
              ],
              [
                44.7525016,
                38.0372587
              ],
              [
                44.7711153,
                38.046435
              ],
              [
                44.7716685,
                38.0467137
              ],
              [
                44.7772248,
                38.0494908
              ],
              [
                44.7780584,
                38.0494907
              ],
              [
                44.7847249,
                38.0525465
              ],
              [
                44.7855585,
                38.0525465
              ],
              [
                44.7869484,
                38.0530948
              ],
              [
                44.8072278,
                38.0569862
              ],
              [
                44.8100044,
                38.0569863
              ],
              [
                44.8105615,
                38.0572649
              ],
              [
                44.813338,
                38.0572649
              ],
              [
                44.8138944,
                38.0575435
              ],
              [
                44.8183382,
                38.0575435
              ],
              [
                44.8186148,
                38.0578222
              ],
              [
                44.8200046,
                38.0578222
              ],
              [
                44.8205609,
                38.0578222
              ],
              [
                44.8211148,
                38.0578222
              ],
              [
                44.8216711,
                38.0578222
              ],
              [
                44.8227813,
                38.0578222
              ],
              [
                44.8230609,
                38.0575435
              ],
              [
                44.8250048,
                38.0575435
              ],
              [
                44.825561,
                38.057265
              ],
              [
                44.8277844,
                38.057265
              ],
              [
                44.8437212,
                38.0586332
              ],
              [
                44.8445549,
                38.0583547
              ],
              [
                44.8476112,
                38.0583547
              ],
              [
                44.8484448,
                38.0580761
              ],
              [
                44.8487213,
                38.0583547
              ],
              [
                44.8506643,
                38.0583547
              ],
              [
                44.851498,
                38.0580761
              ],
              [
                44.8517777,
                38.0583547
              ],
              [
                44.8562215,
                38.0583547
              ],
              [
                44.8564981,
                38.0580762
              ],
              [
                44.8592778,
                38.0580761
              ],
              [
                44.8601114,
                38.0577976
              ],
              [
                44.8628882,
                38.0577976
              ],
              [
                44.8648342,
                38.057528
              ],
              [
                44.8653881,
                38.0572495
              ],
              [
                44.866221,
                38.0572495
              ],
              [
                44.8665014,
                38.0569709
              ],
              [
                44.8676108,
                38.0569709
              ],
              [
                44.8678875,
                38.0566923
              ],
              [
                44.868721,
                38.0566923
              ],
              [
                44.8692781,
                38.0564138
              ],
              [
                44.8703875,
                38.0564137
              ],
              [
                44.8709445,
                38.0561352
              ],
              [
                44.8720547,
                38.0561352
              ],
              [
                44.8791497,
                38.0372762
              ],
              [
                44.8928826,
                38.0270001
              ],
              [
                44.9335637,
                38.014452
              ],
              [
                44.9338403,
                38.0138947
              ],
              [
                44.9527307,
                37.9986153
              ],
              [
                44.9530073,
                37.9983366
              ],
              [
                44.9530072,
                37.9980581
              ],
              [
                44.9543971,
                37.9972312
              ],
              [
                44.9549533,
                37.9963953
              ],
              [
                44.9624536,
                37.9944538
              ],
              [
                44.9627301,
                37.9941753
              ],
              [
                44.96412,
                37.9941752
              ],
              [
                44.9649537,
                37.9938966
              ],
              [
                44.9755101,
                37.9938965
              ],
              [
                44.9849532,
                37.9947235
              ],
              [
                44.9852337,
                37.9950022
              ],
              [
                44.9871768,
                37.9950022
              ],
              [
                44.9877339,
                37.9952808
              ],
              [
                44.9905097,
                37.9952808
              ],
              [
                44.9910667,
                37.9955594
              ],
              [
                44.9932862,
                37.9955593
              ],
              [
                44.9938433,
                37.9958381
              ],
              [
                44.9963434,
                37.9958381
              ],
              [
                44.9968997,
                37.9961167
              ],
              [
                44.9982903,
                37.9961168
              ],
              [
                45.0013435,
                37.996674
              ],
              [
                45.0270331,
                38.0115704
              ],
              [
                45.0320331,
                38.0143474
              ],
              [
                45.0324899,
                38.0157731
              ],
              [
                45.0338767,
                38.0163212
              ],
              [
                45.0452998,
                38.0339454
              ],
              [
                45.0506821,
                38.0587403
              ],
              [
                45.0453193,
                38.0747291
              ],
              [
                45.0447623,
                38.0780628
              ],
              [
                45.0444857,
                38.0794556
              ],
              [
                45.0439286,
                38.0841731
              ],
              [
                45.0425427,
                38.0900046
              ],
              [
                45.0278187,
                38.1205636
              ],
              [
                45.0216956,
                38.129568
              ],
              [
                45.0293283,
                38.1328847
              ],
              [
                45.0790444,
                38.1544848
              ],
              [
                45.1611605,
                38.1901477
              ],
              [
                45.133586,
                38.2177997
              ],
              [
                45.1335685,
                38.2178206
              ],
              [
                45.129089,
                38.2282022
              ],
              [
                45.1256991,
                38.2308651
              ],
              [
                45.1229092,
                38.2330566
              ],
              [
                45.1215359,
                38.252471
              ],
              [
                45.1083189,
                38.2723535
              ],
              [
                45.1100487,
                38.2880934
              ],
              [
                45.1099005,
                38.2890257
              ],
              [
                45.1090668,
                38.2940292
              ],
              [
                45.1087871,
                38.2943077
              ],
              [
                45.0951209,
                38.3122537
              ],
              [
                45.0948443,
                38.3133675
              ],
              [
                45.0951208,
                38.3139243
              ],
              [
                45.0937309,
                38.3203105
              ],
              [
                45.0935234,
                38.3211458
              ],
              [
                45.0915105,
                38.3211458
              ],
              [
                45.077844,
                38.3158932
              ],
              [
                45.072011,
                38.316998
              ],
              [
                45.0005917,
                38.3179536
              ],
              [
                44.9997579,
                38.3179536
              ],
              [
                44.9992017,
                38.3182321
              ],
              [
                44.9961454,
                38.3182321
              ],
              [
                44.9955914,
                38.3185105
              ],
              [
                44.9944781,
                38.3185105
              ],
              [
                44.9939249,
                38.3187891
              ],
              [
                44.9933688,
                38.3187891
              ],
              [
                44.9928117,
                38.318789
              ],
              [
                44.9455887,
                38.3312846
              ],
              [
                44.9296991,
                38.3333227
              ],
              [
                44.9274755,
                38.3336011
              ],
              [
                44.9216426,
                38.3336011
              ],
              [
                44.9213628,
                38.3333227
              ],
              [
                44.9196957,
                38.3333227
              ],
              [
                44.9141424,
                38.3322178
              ],
              [
                44.9065158,
                38.3314011
              ],
              [
                44.9056822,
                38.3314011
              ],
              [
                44.893999,
                38.3305849
              ],
              [
                44.8903786,
                38.3299059
              ],
              [
                44.8892654,
                38.3299059
              ],
              [
                44.8792623,
                38.3297167
              ],
              [
                44.8596533,
                38.3298293
              ],
              [
                44.8593766,
                38.3301077
              ],
              [
                44.857986,
                38.3301078
              ],
              [
                44.8577095,
                38.3303863
              ],
              [
                44.8565962,
                38.3303863
              ],
              [
                44.8504867,
                38.332883
              ],
              [
                44.8499296,
                38.332883
              ],
              [
                44.8490967,
                38.3337184
              ],
              [
                44.8482632,
                38.3339968
              ],
              [
                44.8449295,
                38.3373289
              ],
              [
                44.8294315,
                38.3508128
              ],
              [
                44.827208,
                38.3527527
              ],
              [
                44.8133542,
                38.3585413
              ],
              [
                44.812244,
                38.3585413
              ],
              [
                44.8119644,
                38.3588197
              ],
              [
                44.8100213,
                38.3588198
              ],
              [
                44.809744,
                38.3590981
              ],
              [
                44.8069643,
                38.3590981
              ],
              [
                44.806411,
                38.3593765
              ],
              [
                44.8027977,
                38.3593765
              ],
              [
                44.8025211,
                38.3596459
              ],
              [
                44.7915172,
                38.3561284
              ],
              [
                44.7684596,
                38.3520587
              ],
              [
                44.7673463,
                38.3520587
              ],
              [
                44.7670697,
                38.3523371
              ],
              [
                44.7651228,
                38.3523371
              ],
              [
                44.7645697,
                38.3526155
              ],
              [
                44.7592151,
                38.3513366
              ],
              [
                44.7592151,
                38.351615
              ],
              [
                44.756715,
                38.351615
              ],
              [
                44.7561619,
                38.3518935
              ],
              [
                44.7536618,
                38.3518935
              ],
              [
                44.7531048,
                38.3521719
              ],
              [
                44.7514383,
                38.3521719
              ],
              [
                44.7511617,
                38.3524504
              ],
              [
                44.7486618,
                38.3524503
              ],
              [
                44.7481046,
                38.3527288
              ],
              [
                44.7458819,
                38.3527287
              ],
              [
                44.7456054,
                38.3530073
              ],
              [
                44.7433819,
                38.3530073
              ],
              [
                44.7431053,
                38.3532857
              ],
              [
                44.7381052,
                38.3532857
              ],
              [
                44.7375482,
                38.3535641
              ],
              [
                44.7306051,
                38.353564
              ],
              [
                44.7228251,
                38.3543904
              ],
              [
                44.7225486,
                38.3546778
              ],
              [
                44.7200485,
                38.3546778
              ],
              [
                44.7186586,
                38.3549472
              ],
              [
                44.7161586,
                38.3552257
              ],
              [
                44.7068044,
                38.3567407
              ],
              [
                44.7062513,
                38.3570191
              ],
              [
                44.7051379,
                38.3570191
              ],
              [
                44.704584,
                38.3572975
              ],
              [
                44.7031942,
                38.3572976
              ],
              [
                44.7023614,
                38.357576
              ],
              [
                44.7001378,
                38.3575759
              ],
              [
                44.6995847,
                38.3578544
              ],
              [
                44.6976378,
                38.3578544
              ],
              [
                44.6970808,
                38.3581329
              ],
              [
                44.6951376,
                38.3581329
              ],
              [
                44.6895813,
                38.3592466
              ],
              [
                44.6872643,
                38.3601215
              ],
              [
                44.6861509,
                38.3604
              ],
              [
                44.6794844,
                38.3603999
              ],
              [
                44.6789281,
                38.3601215
              ],
              [
                44.666951,
                38.3631501
              ],
              [
                44.6663971,
                38.3628715
              ],
              [
                44.6652838,
                38.3628715
              ],
              [
                44.6644509,
                38.3625932
              ],
              [
                44.6616744,
                38.3625931
              ],
              [
                44.6613978,
                38.3628715
              ],
              [
                44.6608407,
                38.3625931
              ],
              [
                44.6566907,
                38.364141
              ],
              [
                44.6542653,
                38.3664199
              ],
              [
                44.6528785,
                38.3664199
              ],
              [
                44.6523214,
                38.3661415
              ],
              [
                44.6512081,
                38.3661414
              ],
              [
                44.6512082,
                38.3658631
              ],
              [
                44.6442075,
                38.3664711
              ],
              [
                44.6436504,
                38.3661928
              ],
              [
                44.633859,
                38.3676851
              ],
              [
                44.6333059,
                38.3674068
              ],
              [
                44.6260822,
                38.3674067
              ],
              [
                44.6252495,
                38.3671283
              ],
              [
                44.6158553,
                38.3695509
              ],
              [
                44.6150217,
                38.3698293
              ],
              [
                44.6127983,
                38.3698293
              ],
              [
                44.6122452,
                38.3701077
              ],
              [
                44.6089123,
                38.3701077
              ],
              [
                44.6086317,
                38.3703862
              ],
              [
                44.6061317,
                38.3703861
              ],
              [
                44.6050223,
                38.3706644
              ],
              [
                44.6030754,
                38.3706644
              ],
              [
                44.6019651,
                38.3706644
              ],
              [
                44.600855,
                38.3709428
              ],
              [
                44.5955752,
                38.3709428
              ],
              [
                44.595022,
                38.3712213
              ],
              [
                44.5916883,
                38.3712212
              ],
              [
                44.5908556,
                38.3714995
              ],
              [
                44.590022,
                38.3712212
              ],
              [
                44.5897422,
                38.3714995
              ],
              [
                44.5800186,
                38.3714995
              ],
              [
                44.5794654,
                38.3717779
              ],
              [
                44.5750185,
                38.3717779
              ],
              [
                44.5747419,
                38.3720563
              ],
              [
                44.5691855,
                38.3720563
              ],
              [
                44.5683519,
                38.3723346
              ],
              [
                44.5569736,
                38.3728056
              ],
              [
                44.5564198,
                38.3725272
              ],
              [
                44.5547533,
                38.3725272
              ],
              [
                44.554197,
                38.3722488
              ],
              [
                44.5483743,
                38.3718451
              ],
              [
                44.5475407,
                38.3715667
              ],
              [
                44.5392076,
                38.3715667
              ],
              [
                44.5383748,
                38.3712882
              ],
              [
                44.5355943,
                38.3712882
              ],
              [
                44.5350412,
                38.3710099
              ],
              [
                44.5322614,
                38.3710099
              ],
              [
                44.5267043,
                38.370453
              ],
              [
                44.5247612,
                38.370453
              ],
              [
                44.5239276,
                38.3701747
              ],
              [
                44.5222612,
                38.3701747
              ],
              [
                44.5214276,
                38.3698962
              ],
              [
                44.5167048,
                38.3698963
              ],
              [
                44.5161516,
                38.3696179
              ],
              [
                44.5122618,
                38.3696179
              ],
              [
                44.5089281,
                38.3693485
              ],
              [
                44.5078147,
                38.369061
              ],
              [
                44.4929671,
                38.3662347
              ],
              [
                44.4857243,
                38.3636587
              ],
              [
                44.4848908,
                38.3633803
              ],
              [
                44.4823908,
                38.3633803
              ],
              [
                44.4812774,
                38.3631019
              ],
              [
                44.4798876,
                38.363102
              ],
              [
                44.4682083,
                38.3583631
              ],
              [
                44.4706101,
                38.3572691
              ],
              [
                44.4712641,
                38.3568848
              ],
              [
                44.4723974,
                38.3557814
              ],
              [
                44.4727777,
                38.3556011
              ],
              [
                44.4732075,
                38.3556854
              ],
              [
                44.4736656,
                38.3558762
              ],
              [
                44.4740523,
                38.3561481
              ],
              [
                44.4748652,
                38.3570114
              ],
              [
                44.4770569,
                38.3576627
              ],
              [
                44.4777718,
                38.3576967
              ],
              [
                44.4782828,
                38.357807
              ],
              [
                44.4788268,
                38.3577917
              ],
              [
                44.4794123,
                38.357665
              ],
              [
                44.4805189,
                38.3577783
              ],
              [
                44.4814701,
                38.3578036
              ],
              [
                44.4827614,
                38.3577718
              ],
              [
                44.4831453,
                38.3578586
              ],
              [
                44.4837021,
                38.3581878
              ],
              [
                44.4841463,
                38.3582818
              ],
              [
                44.4848575,
                38.3583243
              ],
              [
                44.4854955,
                38.3584457
              ],
              [
                44.4861056,
                38.3584348
              ],
              [
                44.4894193,
                38.3580442
              ],
              [
                44.4904477,
                38.3578647
              ],
              [
                44.4907507,
                38.3577049
              ],
              [
                44.4907308,
                38.3568349
              ],
              [
                44.4906406,
                38.3563327
              ],
              [
                44.490835,
                38.3561158
              ],
              [
                44.4914735,
                38.3557668
              ],
              [
                44.4921672,
                38.3551887
              ],
              [
                44.4926942,
                38.3546532
              ],
              [
                44.4935273,
                38.3542222
              ],
              [
                44.4945318,
                38.353824
              ],
              [
                44.4953573,
                38.3533457
              ],
              [
                44.4968564,
                38.3524041
              ],
              [
                44.4990194,
                38.3509064
              ],
              [
                44.499122,
                38.3505319
              ],
              [
                44.4989073,
                38.3500994
              ],
              [
                44.497546,
                38.3494186
              ],
              [
                44.4961453,
                38.3489004
              ],
              [
                44.4951711,
                38.3481536
              ],
              [
                44.4944962,
                38.347817
              ],
              [
                44.4936303,
                38.3475232
              ],
              [
                44.4933408,
                38.3473579
              ],
              [
                44.4931207,
                38.3468695
              ],
              [
                44.4929634,
                38.3463398
              ],
              [
                44.4929923,
                38.3459613
              ],
              [
                44.4931368,
                38.3457028
              ],
              [
                44.4937497,
                38.3451844
              ],
              [
                44.4946408,
                38.3445379
              ],
              [
                44.4954973,
                38.3437118
              ],
              [
                44.4958274,
                38.3435884
              ],
              [
                44.4961172,
                38.3435858
              ],
              [
                44.4965485,
                38.3437398
              ],
              [
                44.4978202,
                38.3444302
              ],
              [
                44.4980333,
                38.3446566
              ],
              [
                44.4983053,
                38.3450655
              ],
              [
                44.4985218,
                38.3455406
              ],
              [
                44.4988735,
                38.3457846
              ],
              [
                44.4995988,
                38.3459215
              ],
              [
                44.5002093,
                38.3459207
              ],
              [
                44.5010715,
                38.3457038
              ],
              [
                44.5014237,
                38.3456725
              ],
              [
                44.5016767,
                38.345703
              ],
              [
                44.502039,
                38.3458715
              ],
              [
                44.5023973,
                38.3458861
              ],
              [
                44.5034729,
                38.3457593
              ],
              [
                44.5059171,
                38.3459226
              ],
              [
                44.5069312,
                38.3460892
              ],
              [
                44.5073896,
                38.3459671
              ],
              [
                44.5082325,
                38.3452138
              ],
              [
                44.509102,
                38.3452284
              ],
              [
                44.5100577,
                38.3451748
              ],
              [
                44.510353,
                38.344748
              ],
              [
                44.5106841,
                38.3432954
              ],
              [
                44.5110469,
                38.3424693
              ],
              [
                44.5113865,
                38.3419904
              ],
              [
                44.5120597,
                38.3414889
              ],
              [
                44.5125314,
                38.3412598
              ],
              [
                44.5125473,
                38.3408754
              ],
              [
                44.5124748,
                38.3404318
              ],
              [
                44.5122201,
                38.339928
              ],
              [
                44.5117803,
                38.339374
              ],
              [
                44.5112146,
                38.3388498
              ],
              [
                44.5107595,
                38.3385951
              ],
              [
                44.5104524,
                38.3384924
              ],
              [
                44.5103779,
                38.3383642
              ],
              [
                44.5103362,
                38.3380644
              ],
              [
                44.5105855,
                38.3360965
              ],
              [
                44.5105383,
                38.3357452
              ],
              [
                44.5103614,
                38.3353408
              ],
              [
                44.5100034,
                38.335215
              ],
              [
                44.5091448,
                38.3350641
              ],
              [
                44.5082446,
                38.3350425
              ],
              [
                44.5076916,
                38.3351188
              ],
              [
                44.5068144,
                38.3349798
              ],
              [
                44.5061015,
                38.3347825
              ],
              [
                44.5048379,
                38.3346488
              ],
              [
                44.5025948,
                38.3347599
              ],
              [
                44.5020111,
                38.3347331
              ],
              [
                44.5014591,
                38.3345664
              ],
              [
                44.5009901,
                38.3343375
              ],
              [
                44.5007776,
                38.3340848
              ],
              [
                44.5003077,
                38.3338803
              ],
              [
                44.4996474,
                38.3338003
              ],
              [
                44.4975509,
                38.3337116
              ],
              [
                44.4973757,
                38.3330915
              ],
              [
                44.4975881,
                38.3321
              ],
              [
                44.4975772,
                38.3317648
              ],
              [
                44.4974266,
                38.3313902
              ],
              [
                44.4971684,
                38.3309813
              ],
              [
                44.496897,
                38.3300796
              ],
              [
                44.4969863,
                38.3295419
              ],
              [
                44.4971704,
                38.3291083
              ],
              [
                44.4976171,
                38.3284247
              ],
              [
                44.4977352,
                38.3280956
              ],
              [
                44.4977518,
                38.3276614
              ],
              [
                44.4978345,
                38.3273291
              ],
              [
                44.4980729,
                38.3270368
              ],
              [
                44.4981937,
                38.3267793
              ],
              [
                44.4981303,
                38.3259403
              ],
              [
                44.4982001,
                38.3257079
              ],
              [
                44.4990469,
                38.3249002
              ],
              [
                44.4992431,
                38.324566
              ],
              [
                44.499361,
                38.3239855
              ],
              [
                44.4994221,
                38.3232448
              ],
              [
                44.4993425,
                38.3225632
              ],
              [
                44.4991335,
                38.3218431
              ],
              [
                44.4985847,
                38.320925
              ],
              [
                44.4984425,
                38.3205971
              ],
              [
                44.4984122,
                38.3201767
              ],
              [
                44.4983317,
                38.3199394
              ],
              [
                44.4980274,
                38.3196191
              ],
              [
                44.4975725,
                38.3192934
              ],
              [
                44.4972874,
                38.3188761
              ],
              [
                44.4967286,
                38.3177447
              ],
              [
                44.4964674,
                38.3175085
              ],
              [
                44.4964051,
                38.3172983
              ],
              [
                44.497255,
                38.3155484
              ],
              [
                44.4975489,
                38.3147254
              ],
              [
                44.497556,
                38.3140911
              ],
              [
                44.4974443,
                38.3133021
              ],
              [
                44.4975829,
                38.3130753
              ],
              [
                44.4986939,
                38.3123287
              ],
              [
                44.4988858,
                38.3119674
              ],
              [
                44.4988619,
                38.3117152
              ],
              [
                44.4985507,
                38.3108585
              ],
              [
                44.4984118,
                38.3101018
              ],
              [
                44.4984495,
                38.3094363
              ],
              [
                44.4983339,
                38.308938
              ],
              [
                44.4979252,
                38.3084855
              ],
              [
                44.4960293,
                38.3068029
              ],
              [
                44.4956879,
                38.3062004
              ],
              [
                44.4949293,
                38.305357
              ],
              [
                44.4940191,
                38.3048746
              ],
              [
                44.4934891,
                38.3044105
              ],
              [
                44.492951,
                38.3036964
              ],
              [
                44.492569,
                38.3034044
              ],
              [
                44.4915494,
                38.3031748
              ],
              [
                44.4901018,
                38.302657
              ],
              [
                44.4888023,
                38.3025808
              ],
              [
                44.4875907,
                38.3026157
              ],
              [
                44.4861315,
                38.3021931
              ],
              [
                44.485015,
                38.3021203
              ],
              [
                44.4837901,
                38.3023173
              ],
              [
                44.4826478,
                38.302177
              ],
              [
                44.4815811,
                38.3022517
              ],
              [
                44.4806895,
                38.3022407
              ],
              [
                44.4801114,
                38.3023252
              ],
              [
                44.4792607,
                38.3026415
              ],
              [
                44.4788578,
                38.3027468
              ],
              [
                44.4782878,
                38.302652
              ],
              [
                44.47789,
                38.3023682
              ],
              [
                44.4763299,
                38.3007369
              ],
              [
                44.4755108,
                38.2995782
              ],
              [
                44.4752597,
                38.2991239
              ],
              [
                44.4753268,
                38.2988393
              ],
              [
                44.4757122,
                38.298455
              ],
              [
                44.4757542,
                38.2980526
              ],
              [
                44.4753275,
                38.297426
              ],
              [
                44.4741982,
                38.2960489
              ],
              [
                44.473474,
                38.2953126
              ],
              [
                44.4725984,
                38.2949136
              ],
              [
                44.4719763,
                38.2948243
              ],
              [
                44.4698572,
                38.294999
              ],
              [
                44.4692246,
                38.2949272
              ],
              [
                44.4683832,
                38.2946001
              ],
              [
                44.4672868,
                38.293558
              ],
              [
                44.4666621,
                38.2926844
              ],
              [
                44.4662382,
                38.2922797
              ],
              [
                44.4637564,
                38.2911885
              ],
              [
                44.4629423,
                38.290451
              ],
              [
                44.4593923,
                38.2884078
              ],
              [
                44.4583853,
                38.2877703
              ],
              [
                44.4578475,
                38.2871777
              ],
              [
                44.4566769,
                38.2854262
              ],
              [
                44.4558723,
                38.2843657
              ],
              [
                44.4550558,
                38.2839901
              ],
              [
                44.452255,
                38.2839798
              ],
              [
                44.4504938,
                38.2838304
              ],
              [
                44.4491621,
                38.283338
              ],
              [
                44.4475265,
                38.28181
              ],
              [
                44.4466194,
                38.281218
              ],
              [
                44.4457134,
                38.2807554
              ],
              [
                44.4444714,
                38.2800332
              ],
              [
                44.4411169,
                38.27775
              ],
              [
                44.4407868,
                38.2773681
              ],
              [
                44.4396418,
                38.275096
              ],
              [
                44.4347338,
                38.269706
              ],
              [
                44.4339559,
                38.2691525
              ],
              [
                44.4329799,
                38.2687392
              ],
              [
                44.4317883,
                38.2688305
              ],
              [
                44.4298426,
                38.2693713
              ],
              [
                44.4288809,
                38.2692528
              ],
              [
                44.4261819,
                38.2687489
              ],
              [
                44.4235044,
                38.2682338
              ],
              [
                44.4225323,
                38.2680027
              ],
              [
                44.422004,
                38.2673679
              ],
              [
                44.4208506,
                38.2664255
              ],
              [
                44.4193714,
                38.2654069
              ],
              [
                44.417674,
                38.2643263
              ],
              [
                44.4152428,
                38.2623395
              ],
              [
                44.4142948,
                38.261721
              ],
              [
                44.413471,
                38.2611
              ],
              [
                44.4134307,
                38.2594329
              ],
              [
                44.4131859,
                38.2581439
              ],
              [
                44.4127043,
                38.2573621
              ],
              [
                44.4111819,
                38.2559697
              ],
              [
                44.4086661,
                38.2542648
              ],
              [
                44.4073195,
                38.2538509
              ],
              [
                44.4056688,
                38.2536193
              ],
              [
                44.4043031,
                38.2530969
              ],
              [
                44.4030407,
                38.2524577
              ],
              [
                44.4022685,
                38.2520003
              ],
              [
                44.4017805,
                38.2510346
              ],
              [
                44.4017331,
                38.2505128
              ],
              [
                44.4018736,
                38.2489038
              ],
              [
                44.4022375,
                38.2464421
              ],
              [
                44.4020255,
                38.2459174
              ],
              [
                44.4011086,
                38.2445658
              ],
              [
                44.4005163,
                38.2441002
              ],
              [
                44.3998438,
                38.243791
              ],
              [
                44.3994221,
                38.2435229
              ],
              [
                44.3990156,
                38.2429418
              ],
              [
                44.3989075,
                38.2415149
              ],
              [
                44.3986628,
                38.2407308
              ],
              [
                44.3984516,
                38.2395958
              ],
              [
                44.3986824,
                38.2385345
              ],
              [
                44.3990623,
                38.2376664
              ],
              [
                44.3991502,
                38.2370886
              ],
              [
                44.40047,
                38.236113
              ],
              [
                44.4023619,
                38.2350354
              ],
              [
                44.405316,
                38.2336446
              ],
              [
                44.4060023,
                38.2325659
              ],
              [
                44.4067293,
                38.2310485
              ],
              [
                44.4071846,
                38.2288978
              ],
              [
                44.4081764,
                38.2267515
              ],
              [
                44.4095056,
                38.2248839
              ],
              [
                44.4102794,
                38.2229885
              ],
              [
                44.4102952,
                38.22105
              ],
              [
                44.4117396,
                38.2195101
              ],
              [
                44.4116086,
                38.2188096
              ],
              [
                44.410712,
                38.2179634
              ],
              [
                44.4080271,
                38.2159455
              ],
              [
                44.4076428,
                38.214202
              ],
              [
                44.4072118,
                38.213094
              ],
              [
                44.4072921,
                38.2125471
              ],
              [
                44.4068354,
                38.2114683
              ],
              [
                44.4066357,
                38.2106842
              ],
              [
                44.4050096,
                38.2075066
              ],
              [
                44.4023802,
                38.2019941
              ],
              [
                44.4021745,
                38.2017009
              ],
              [
                44.4019686,
                38.2016427
              ],
              [
                44.4009247,
                38.2018264
              ],
              [
                44.4000805,
                38.2018484
              ],
              [
                44.3997955,
                38.2017482
              ],
              [
                44.3993788,
                38.2013158
              ],
              [
                44.3988579,
                38.2004671
              ],
              [
                44.3984207,
                38.1995305
              ],
              [
                44.3980254,
                38.1984635
              ],
              [
                44.3982855,
                38.1977966
              ],
              [
                44.398197,
                38.1970597
              ],
              [
                44.3986479,
                38.1968199
              ],
              [
                44.3993025,
                38.1966872
              ],
              [
                44.4001464,
                38.1961309
              ],
              [
                44.4008788,
                38.194572
              ],
              [
                44.400804,
                38.1937361
              ],
              [
                44.4001449,
                38.1926649
              ],
              [
                44.3994643,
                38.1917949
              ],
              [
                44.3983978,
                38.1910398
              ],
              [
                44.3978407,
                38.1905264
              ],
              [
                44.396911,
                38.189168
              ],
              [
                44.3978132,
                38.1884709
              ],
              [
                44.3984731,
                38.1877779
              ],
              [
                44.3994262,
                38.1855976
              ],
              [
                44.3997361,
                38.1850007
              ],
              [
                44.3998556,
                38.1841941
              ],
              [
                44.4003144,
                38.1831992
              ],
              [
                44.4001279,
                38.181952
              ],
              [
                44.3999362,
                38.1809433
              ],
              [
                44.4001524,
                38.1796829
              ],
              [
                44.3996202,
                38.178285
              ],
              [
                44.3985273,
                38.1756149
              ],
              [
                44.3986432,
                38.174736
              ],
              [
                44.3983906,
                38.173487
              ],
              [
                44.3972184,
                38.1715538
              ],
              [
                44.3955562,
                38.1709934
              ],
              [
                44.3933359,
                38.1703507
              ],
              [
                44.3923264,
                38.1693433
              ],
              [
                44.3911827,
                38.1677279
              ],
              [
                44.3911685,
                38.1672241
              ],
              [
                44.391361,
                38.1664271
              ],
              [
                44.3915432,
                38.1652679
              ],
              [
                44.3919145,
                38.1646828
              ],
              [
                44.392911,
                38.164208
              ],
              [
                44.3933603,
                38.1637944
              ],
              [
                44.3931448,
                38.1628801
              ],
              [
                44.3933287,
                38.1619668
              ],
              [
                44.3940488,
                38.1616185
              ],
              [
                44.3946158,
                38.1609923
              ],
              [
                44.394711,
                38.1601149
              ],
              [
                44.3944422,
                38.1591102
              ],
              [
                44.3942722,
                38.1587137
              ],
              [
                44.3936853,
                38.1578064
              ],
              [
                44.3930447,
                38.1552409
              ],
              [
                44.3927578,
                38.1544216
              ],
              [
                44.392246,
                38.1538111
              ],
              [
                44.3918663,
                38.1532176
              ],
              [
                44.3916636,
                38.1520277
              ],
              [
                44.391846,
                38.1512944
              ],
              [
                44.3922755,
                38.15042
              ],
              [
                44.3924898,
                38.1495988
              ],
              [
                44.3922787,
                38.1484808
              ],
              [
                44.3923149,
                38.1476514
              ],
              [
                44.392385,
                38.1472316
              ],
              [
                44.3926934,
                38.1464431
              ],
              [
                44.3924193,
                38.1460966
              ],
              [
                44.3914511,
                38.1457388
              ],
              [
                44.3903023,
                38.1457629
              ],
              [
                44.3885892,
                38.1454743
              ],
              [
                44.3874077,
                38.145152
              ],
              [
                44.3862035,
                38.1446131
              ],
              [
                44.3855425,
                38.1444254
              ],
              [
                44.3850239,
                38.1441622
              ],
              [
                44.3824399,
                38.1413198
              ],
              [
                44.3811408,
                38.1394468
              ],
              [
                44.3805398,
                38.1390596
              ],
              [
                44.3799211,
                38.1389026
              ],
              [
                44.3764164,
                38.1382822
              ],
              [
                44.3748653,
                38.1381236
              ],
              [
                44.3738278,
                38.1380943
              ],
              [
                44.3728198,
                38.1382855
              ],
              [
                44.3716899,
                38.138681
              ],
              [
                44.3708835,
                38.1387481
              ],
              [
                44.3704568,
                38.1385535
              ],
              [
                44.3701895,
                38.1382142
              ],
              [
                44.370098,
                38.1375934
              ],
              [
                44.3696821,
                38.1363896
              ],
              [
                44.3691243,
                38.1358872
              ],
              [
                44.3686252,
                38.1356841
              ],
              [
                44.367845,
                38.1356878
              ],
              [
                44.366987,
                38.1357867
              ],
              [
                44.3656188,
                38.1357567
              ],
              [
                44.363607,
                38.1348687
              ],
              [
                44.3629298,
                38.134645
              ],
              [
                44.3621443,
                38.1345743
              ],
              [
                44.3612948,
                38.1346795
              ],
              [
                44.3606002,
                38.1351512
              ],
              [
                44.3593578,
                38.1356317
              ],
              [
                44.3585556,
                38.1357303
              ],
              [
                44.3577677,
                38.1355833
              ],
              [
                44.3568015,
                38.1350298
              ],
              [
                44.3560656,
                38.1347323
              ],
              [
                44.3555014,
                38.1347492
              ],
              [
                44.3534741,
                38.1352829
              ],
              [
                44.3525826,
                38.1353768
              ],
              [
                44.351587,
                38.1352746
              ],
              [
                44.3511809,
                38.1349942
              ],
              [
                44.3510621,
                38.1338811
              ],
              [
                44.3507588,
                38.1332119
              ],
              [
                44.3495126,
                38.1316841
              ],
              [
                44.3503132,
                38.1305748
              ],
              [
                44.3515832,
                38.1296394
              ],
              [
                44.353443,
                38.1278673
              ],
              [
                44.3548689,
                38.1262452
              ],
              [
                44.3581704,
                38.1244725
              ],
              [
                44.3591675,
                38.1236019
              ],
              [
                44.3596171,
                38.1228582
              ],
              [
                44.3595901,
                38.1217202
              ],
              [
                44.3588519,
                38.1196156
              ],
              [
                44.3586127,
                38.1167459
              ],
              [
                44.3587591,
                38.1143004
              ],
              [
                44.3595248,
                38.1121172
              ],
              [
                44.3601379,
                38.1111239
              ],
              [
                44.362287,
                38.1086576
              ],
              [
                44.3629363,
                38.1074197
              ],
              [
                44.3640824,
                38.1064624
              ],
              [
                44.3648052,
                38.1055825
              ],
              [
                44.364823,
                38.1046532
              ],
              [
                44.3645086,
                38.1039085
              ],
              [
                44.3638716,
                38.1036234
              ],
              [
                44.3621786,
                38.1036424
              ],
              [
                44.3602553,
                38.1037984
              ],
              [
                44.3581784,
                38.1042704
              ],
              [
                44.3562448,
                38.1048278
              ],
              [
                44.3549673,
                38.1050912
              ],
              [
                44.3537076,
                38.1051199
              ],
              [
                44.3517701,
                38.1048418
              ],
              [
                44.3508122,
                38.1044594
              ],
              [
                44.3498552,
                38.1041368
              ],
              [
                44.3484724,
                38.104041
              ],
              [
                44.3475787,
                38.1034791
              ],
              [
                44.3437959,
                38.1016944
              ],
              [
                44.3414971,
                38.1005343
              ],
              [
                44.3404569,
                38.0999325
              ],
              [
                44.3391971,
                38.0993677
              ],
              [
                44.3380382,
                38.0990466
              ],
              [
                44.33634,
                38.098743
              ],
              [
                44.3357726,
                38.0983488
              ],
              [
                44.335369,
                38.0982137
              ],
              [
                44.3347478,
                38.0981657
              ],
              [
                44.3329035,
                38.0985945
              ],
              [
                44.3322959,
                38.0988043
              ],
              [
                44.3316325,
                38.0989174
              ],
              [
                44.3311142,
                38.0989168
              ],
              [
                44.3305385,
                38.0988045
              ],
              [
                44.3298667,
                38.0985795
              ],
              [
                44.3293645,
                38.098353
              ],
              [
                44.3292737,
                38.098155
              ],
              [
                44.3289155,
                38.0976804
              ],
              [
                44.3287845,
                38.097075
              ],
              [
                44.3288108,
                38.0959569
              ],
              [
                44.3293225,
                38.0952874
              ],
              [
                44.3297621,
                38.0943523
              ],
              [
                44.331109,
                38.0920987
              ],
              [
                44.3314064,
                38.0907536
              ],
              [
                44.3313906,
                38.0897769
              ],
              [
                44.3311533,
                38.0887262
              ],
              [
                44.3308865,
                38.0882476
              ],
              [
                44.3300513,
                38.08755
              ],
              [
                44.3297491,
                38.087176
              ],
              [
                44.3295653,
                38.0864851
              ],
              [
                44.3291864,
                38.0857637
              ],
              [
                44.3288325,
                38.0841167
              ],
              [
                44.3283929,
                38.0832889
              ],
              [
                44.3282662,
                38.0828429
              ],
              [
                44.3283728,
                38.0823301
              ],
              [
                44.3289222,
                38.0807631
              ],
              [
                44.3289444,
                38.0804352
              ],
              [
                44.3287185,
                38.0797354
              ],
              [
                44.3287629,
                38.0789369
              ],
              [
                44.3285769,
                38.0786286
              ],
              [
                44.328216,
                38.0782813
              ],
              [
                44.327478,
                38.0780216
              ],
              [
                44.325845,
                38.0777763
              ],
              [
                44.3244887,
                38.0779079
              ],
              [
                44.3227947,
                38.0782377
              ],
              [
                44.3223657,
                38.0784448
              ],
              [
                44.322067,
                38.0786554
              ],
              [
                44.3218332,
                38.0787015
              ],
              [
                44.3215799,
                38.078638
              ],
              [
                44.3211567,
                38.0783055
              ],
              [
                44.320152,
                38.0772512
              ],
              [
                44.3177477,
                38.0745628
              ],
              [
                44.3172191,
                38.0741236
              ],
              [
                44.3157874,
                38.0736709
              ],
              [
                44.3142743,
                38.0733804
              ],
              [
                44.3119147,
                38.0731124
              ],
              [
                44.311362,
                38.0728943
              ],
              [
                44.3112128,
                38.0725601
              ],
              [
                44.3110731,
                38.0717852
              ],
              [
                44.3111273,
                38.0713978
              ],
              [
                44.3116452,
                38.0707346
              ],
              [
                44.3116918,
                38.0703736
              ],
              [
                44.3115052,
                38.0698978
              ],
              [
                44.3115052,
                38.0695365
              ],
              [
                44.3118796,
                38.0689438
              ],
              [
                44.3120877,
                38.0684811
              ],
              [
                44.312443,
                38.0681178
              ],
              [
                44.3127776,
                38.068069
              ],
              [
                44.3135724,
                38.0681334
              ],
              [
                44.3151551,
                38.0684392
              ],
              [
                44.315693,
                38.0687708
              ],
              [
                44.3158607,
                38.0688193
              ],
              [
                44.3164733,
                38.0687327
              ],
              [
                44.317337,
                38.0687463
              ],
              [
                44.3184555,
                38.0689414
              ],
              [
                44.3195321,
                38.0690336
              ],
              [
                44.3199941,
                38.069029
              ],
              [
                44.3200066,
                38.0688761
              ],
              [
                44.3196762,
                38.0685903
              ],
              [
                44.3194022,
                38.0681142
              ],
              [
                44.3193598,
                38.067475
              ],
              [
                44.3194039,
                38.0667544
              ],
              [
                44.3196578,
                38.0658954
              ],
              [
                44.3197835,
                38.0647133
              ],
              [
                44.3199733,
                38.0643598
              ],
              [
                44.3204552,
                38.0640708
              ],
              [
                44.321083,
                38.0639511
              ],
              [
                44.3212116,
                38.06377
              ],
              [
                44.3211099,
                38.0632898
              ],
              [
                44.3206292,
                38.0626918
              ],
              [
                44.3197274,
                38.061971
              ],
              [
                44.3191097,
                38.0618853
              ],
              [
                44.3184032,
                38.0619845
              ],
              [
                44.3177768,
                38.0618969
              ],
              [
                44.3172568,
                38.0616574
              ],
              [
                44.3167134,
                38.0611615
              ],
              [
                44.3161212,
                38.0608324
              ],
              [
                44.3154484,
                38.0606778
              ],
              [
                44.3148872,
                38.0606104
              ],
              [
                44.314524,
                38.0604418
              ],
              [
                44.3139149,
                38.0596207
              ],
              [
                44.3131608,
                38.0592128
              ],
              [
                44.3117721,
                38.0586456
              ],
              [
                44.3113682,
                38.0584212
              ],
              [
                44.3106739,
                38.0582125
              ],
              [
                44.3092023,
                38.0580556
              ],
              [
                44.3074338,
                38.0574739
              ],
              [
                44.3053112,
                38.0566039
              ],
              [
                44.3038398,
                38.0558064
              ],
              [
                44.3026244,
                38.0547443
              ],
              [
                44.3024973,
                38.0545195
              ],
              [
                44.3028293,
                38.0528706
              ],
              [
                44.3041925,
                38.0497969
              ],
              [
                44.3045953,
                38.0484248
              ],
              [
                44.3051212,
                38.0476467
              ],
              [
                44.3062778,
                38.0466958
              ],
              [
                44.3066768,
                38.0465607
              ],
              [
                44.3069369,
                38.0465366
              ],
              [
                44.3077372,
                38.04666
              ],
              [
                44.3082223,
                38.0465873
              ],
              [
                44.3087309,
                38.0464917
              ],
              [
                44.3088646,
                38.0463001
              ],
              [
                44.3085657,
                38.0454392
              ],
              [
                44.3083953,
                38.0446316
              ],
              [
                44.308014,
                38.0436809
              ],
              [
                44.3071083,
                38.0428124
              ],
              [
                44.3063601,
                38.0419865
              ],
              [
                44.3058957,
                38.0404041
              ],
              [
                44.304213,
                38.0374132
              ],
              [
                44.3038573,
                38.0366623
              ],
              [
                44.3033209,
                38.0361733
              ],
              [
                44.3028038,
                38.0355561
              ],
              [
                44.3017682,
                38.0333171
              ],
              [
                44.3013231,
                38.0325345
              ],
              [
                44.300779,
                38.0320105
              ],
              [
                44.2996512,
                38.0312943
              ],
              [
                44.2982438,
                38.030747
              ],
              [
                44.2978654,
                38.0303977
              ],
              [
                44.2965953,
                38.0292252
              ],
              [
                44.2958597,
                38.0286872
              ],
              [
                44.2950057,
                38.0281649
              ],
              [
                44.2942838,
                38.027821
              ],
              [
                44.2933034,
                38.0274883
              ],
              [
                44.2920116,
                38.0272833
              ],
              [
                44.2911689,
                38.0265781
              ],
              [
                44.290395,
                38.0258425
              ],
              [
                44.2898822,
                38.0249071
              ],
              [
                44.289042,
                38.0242941
              ],
              [
                44.2885934,
                38.0231361
              ],
              [
                44.2878292,
                38.0220197
              ],
              [
                44.2867384,
                38.0211755
              ],
              [
                44.2856269,
                38.0207307
              ],
              [
                44.282792,
                38.0209855
              ],
              [
                44.2817682,
                38.020966
              ],
              [
                44.2800746,
                38.0201246
              ],
              [
                44.2792464,
                38.019487
              ],
              [
                44.2783217,
                38.0185706
              ],
              [
                44.2775602,
                38.0181871
              ],
              [
                44.276214,
                38.0171349
              ],
              [
                44.2753471,
                38.0168353
              ],
              [
                44.2745049,
                38.0160998
              ],
              [
                44.2742495,
                38.015579
              ],
              [
                44.2743016,
                38.0147766
              ],
              [
                44.2741028,
                38.0139973
              ],
              [
                44.2737128,
                38.0130192
              ],
              [
                44.2735487,
                38.0121883
              ],
              [
                44.2726931,
                38.0118051
              ],
              [
                44.2722079,
                38.0111332
              ],
              [
                44.2708642,
                38.0104923
              ],
              [
                44.2701708,
                38.0100678
              ],
              [
                44.2698496,
                38.00931
              ],
              [
                44.2691715,
                38.0082248
              ],
              [
                44.2693027,
                38.0076409
              ],
              [
                44.2692883,
                38.0068293
              ],
              [
                44.2687544,
                38.0054218
              ],
              [
                44.2677478,
                38.0030794
              ],
              [
                44.2675115,
                38.0019547
              ],
              [
                44.2672232,
                38.0010425
              ],
              [
                44.2668324,
                38.0000401
              ],
              [
                44.2667028,
                37.9991311
              ],
              [
                44.2667647,
                37.9986283
              ],
              [
                44.2670653,
                37.9981829
              ],
              [
                44.267469,
                37.9981116
              ],
              [
                44.2675232,
                37.9976377
              ],
              [
                44.267795,
                37.9966507
              ],
              [
                44.2679557,
                37.9964613
              ],
              [
                44.2678782,
                37.9955899
              ],
              [
                44.2676985,
                37.9952691
              ],
              [
                44.2676675,
                37.995013
              ],
              [
                44.2678302,
                37.9948002
              ],
              [
                44.2684218,
                37.9943888
              ],
              [
                44.2683782,
                37.9942035
              ],
              [
                44.2680798,
                37.9937114
              ],
              [
                44.2675947,
                37.9932588
              ],
              [
                44.2671492,
                37.9927054
              ],
              [
                44.2664608,
                37.9916266
              ],
              [
                44.2655734,
                37.9911921
              ],
              [
                44.2649663,
                37.9908261
              ],
              [
                44.2644863,
                37.990415
              ],
              [
                44.2636492,
                37.9899444
              ],
              [
                44.2626368,
                37.9889584
              ],
              [
                44.2619502,
                37.988761
              ],
              [
                44.26158,
                37.9885896
              ],
              [
                44.2614253,
                37.9881932
              ],
              [
                44.2615342,
                37.9878557
              ],
              [
                44.2615357,
                37.9875026
              ],
              [
                44.2611013,
                37.986877
              ],
              [
                44.2606427,
                37.9866568
              ],
              [
                44.2604228,
                37.9859237
              ],
              [
                44.2603087,
                37.985295
              ],
              [
                44.2607657,
                37.9840162
              ],
              [
                44.2606744,
                37.9836871
              ],
              [
                44.2604607,
                37.983576
              ],
              [
                44.2597711,
                37.9835371
              ],
              [
                44.2594208,
                37.98338
              ],
              [
                44.2591366,
                37.9828236
              ],
              [
                44.2587684,
                37.9823122
              ],
              [
                44.2577215,
                37.9816279
              ],
              [
                44.256494,
                37.9810774
              ],
              [
                44.2558899,
                37.9805692
              ],
              [
                44.2549713,
                37.9796709
              ],
              [
                44.254392,
                37.9794769
              ],
              [
                44.2543876,
                37.9790808
              ],
              [
                44.2550599,
                37.9784421
              ],
              [
                44.255436,
                37.9779856
              ],
              [
                44.2560885,
                37.9776529
              ],
              [
                44.2563055,
                37.9773599
              ],
              [
                44.2565431,
                37.9769475
              ],
              [
                44.2566034,
                37.9767297
              ],
              [
                44.2563085,
                37.9762083
              ],
              [
                44.2557674,
                37.9755899
              ],
              [
                44.255336,
                37.9752222
              ],
              [
                44.2545242,
                37.9748216
              ],
              [
                44.2540115,
                37.9746205
              ],
              [
                44.2535188,
                37.9745836
              ],
              [
                44.2531953,
                37.9744927
              ],
              [
                44.2525591,
                37.9740486
              ],
              [
                44.2518329,
                37.9739514
              ],
              [
                44.250922,
                37.9736662
              ],
              [
                44.2504506,
                37.9734494
              ],
              [
                44.250041,
                37.973093
              ],
              [
                44.2487594,
                37.9712942
              ],
              [
                44.2493409,
                37.9702428
              ],
              [
                44.2490979,
                37.9696807
              ],
              [
                44.2483166,
                37.9691638
              ],
              [
                44.2466526,
                37.9688177
              ],
              [
                44.2457337,
                37.9682362
              ],
              [
                44.2449694,
                37.9666884
              ],
              [
                44.2442411,
                37.9656816
              ],
              [
                44.2435591,
                37.9651103
              ],
              [
                44.2426828,
                37.9650708
              ],
              [
                44.2415389,
                37.9654091
              ],
              [
                44.2407127,
                37.9650564
              ],
              [
                44.2405737,
                37.9643424
              ],
              [
                44.2413409,
                37.9611715
              ],
              [
                44.2413264,
                37.9607432
              ],
              [
                44.2411232,
                37.9602577
              ],
              [
                44.2406739,
                37.9565807
              ],
              [
                44.2406054,
                37.9555238
              ],
              [
                44.2408907,
                37.9549503
              ],
              [
                44.241705,
                37.9545711
              ],
              [
                44.2422879,
                37.9540808
              ],
              [
                44.2435064,
                37.95189
              ],
              [
                44.2467192,
                37.9513281
              ],
              [
                44.2477225,
                37.9513743
              ],
              [
                44.2486542,
                37.9510362
              ],
              [
                44.248783,
                37.9504074
              ],
              [
                44.2485603,
                37.9498408
              ],
              [
                44.2485998,
                37.9493273
              ],
              [
                44.2488791,
                37.9489015
              ],
              [
                44.2491973,
                37.9477876
              ],
              [
                44.2496467,
                37.9467567
              ],
              [
                44.2495321,
                37.9459261
              ],
              [
                44.2498042,
                37.9454491
              ],
              [
                44.2508686,
                37.9442114
              ],
              [
                44.251232,
                37.9433704
              ],
              [
                44.2509283,
                37.9425378
              ],
              [
                44.2502348,
                37.942231
              ],
              [
                44.249301,
                37.9420436
              ],
              [
                44.248914,
                37.941691
              ],
              [
                44.2484761,
                37.9406145
              ],
              [
                44.2479655,
                37.9398853
              ],
              [
                44.2477068,
                37.9392569
              ],
              [
                44.2476491,
                37.938576
              ],
              [
                44.2469668,
                37.9377284
              ],
              [
                44.2460126,
                37.9370968
              ],
              [
                44.2461307,
                37.9361909
              ],
              [
                44.2460146,
                37.9339933
              ],
              [
                44.246227,
                37.9332456
              ],
              [
                44.2461786,
                37.9320157
              ],
              [
                44.2459051,
                37.9313962
              ],
              [
                44.2454846,
                37.9310231
              ],
              [
                44.2446569,
                37.9307957
              ],
              [
                44.2438936,
                37.9297046
              ],
              [
                44.2433854,
                37.9290987
              ],
              [
                44.2427635,
                37.9289034
              ],
              [
                44.2424087,
                37.9290313
              ],
              [
                44.2421102,
                37.9290679
              ],
              [
                44.2416277,
                37.9289816
              ],
              [
                44.2412917,
                37.9291993
              ],
              [
                44.2410141,
                37.9292356
              ],
              [
                44.240108,
                37.9291084
              ],
              [
                44.2387664,
                37.9284783
              ],
              [
                44.2378795,
                37.928224
              ],
              [
                44.2363528,
                37.9276162
              ],
              [
                44.235119,
                37.9272619
              ],
              [
                44.234637,
                37.9269538
              ],
              [
                44.2345062,
                37.9265297
              ],
              [
                44.2344369,
                37.9252842
              ],
              [
                44.2345318,
                37.9246688
              ],
              [
                44.2345592,
                37.9234762
              ],
              [
                44.2347833,
                37.9229664
              ],
              [
                44.2347486,
                37.9222768
              ],
              [
                44.2345501,
                37.9213234
              ],
              [
                44.2344478,
                37.9203617
              ],
              [
                44.2343149,
                37.9199198
              ],
              [
                44.2338532,
                37.9194739
              ],
              [
                44.2333247,
                37.9191065
              ],
              [
                44.2323036,
                37.9188468
              ],
              [
                44.2309953,
                37.9185999
              ],
              [
                44.229828,
                37.9181523
              ],
              [
                44.2293834,
                37.9178066
              ],
              [
                44.2291728,
                37.9171852
              ],
              [
                44.2293064,
                37.9165257
              ],
              [
                44.2296031,
                37.9159454
              ],
              [
                44.2303752,
                37.9152388
              ],
              [
                44.2307576,
                37.9147167
              ],
              [
                44.230923,
                37.9137275
              ],
              [
                44.2308903,
                37.9123516
              ],
              [
                44.2305583,
                37.9115624
              ],
              [
                44.2300513,
                37.9111392
              ],
              [
                44.2292571,
                37.9109063
              ],
              [
                44.2264554,
                37.9103677
              ],
              [
                44.2259307,
                37.9089001
              ],
              [
                44.224575,
                37.9076481
              ],
              [
                44.2243172,
                37.9070057
              ],
              [
                44.2253179,
                37.9064244
              ],
              [
                44.2260039,
                37.9058727
              ],
              [
                44.2269551,
                37.9052664
              ],
              [
                44.2278282,
                37.9049288
              ],
              [
                44.2287217,
                37.9042374
              ],
              [
                44.2292699,
                37.9036326
              ],
              [
                44.2295541,
                37.9026253
              ],
              [
                44.2302922,
                37.9018239
              ],
              [
                44.2318366,
                37.9009342
              ],
              [
                44.232465,
                37.9002434
              ],
              [
                44.2321314,
                37.8996045
              ],
              [
                44.2311697,
                37.8989974
              ],
              [
                44.2305078,
                37.8981247
              ],
              [
                44.2293197,
                37.8954706
              ],
              [
                44.2273097,
                37.8936804
              ],
              [
                44.2263919,
                37.8927336
              ],
              [
                44.2260142,
                37.8920999
              ],
              [
                44.2257668,
                37.890994
              ],
              [
                44.2253808,
                37.8904109
              ],
              [
                44.2247473,
                37.8898137
              ],
              [
                44.2236123,
                37.8895223
              ],
              [
                44.2229054,
                37.8887606
              ],
              [
                44.2227458,
                37.8882392
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555101,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شاهین دژ",
          "name:en": "Shahin Dezh County",
          "name:ku": "Şahîndij",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282097",
          "wikipedia": "en:Shahin Dezh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.2469254,
                36.8836614
              ],
              [
                46.2475061,
                36.882916
              ],
              [
                46.2487292,
                36.8822982
              ],
              [
                46.2505102,
                36.880496
              ],
              [
                46.2527847,
                36.8786594
              ],
              [
                46.2551665,
                36.8777154
              ],
              [
                46.2574183,
                36.8771439
              ],
              [
                46.2603164,
                36.8764796
              ],
              [
                46.2631273,
                36.8762736
              ],
              [
                46.2649297,
                36.8761878
              ],
              [
                46.2660455,
                36.8760504
              ],
              [
                46.2669253,
                36.8758445
              ],
              [
                46.2679124,
                36.8752437
              ],
              [
                46.268585,
                36.8746345
              ],
              [
                46.2692213,
                36.8733899
              ],
              [
                46.2690711,
                36.8727032
              ],
              [
                46.2694359,
                36.8716561
              ],
              [
                46.270144,
                36.8708837
              ],
              [
                46.2709164,
                36.8702485
              ],
              [
                46.2719893,
                36.8698022
              ],
              [
                46.2733839,
                36.8698195
              ],
              [
                46.2760234,
                36.8704717
              ],
              [
                46.2778687,
                36.8714501
              ],
              [
                46.2797785,
                36.8723084
              ],
              [
                46.2808513,
                36.8727719
              ],
              [
                46.2820743,
                36.8730466
              ],
              [
                46.2972449,
                36.868635
              ],
              [
                46.3007749,
                36.8634589
              ],
              [
                46.3031612,
                36.8568403
              ],
              [
                46.3045479,
                36.8562821
              ],
              [
                46.3076051,
                36.8562821
              ],
              [
                46.3078816,
                36.8565612
              ],
              [
                46.3092714,
                36.8565611
              ],
              [
                46.310105,
                36.8568403
              ],
              [
                46.3183748,
                36.8565657
              ],
              [
                46.3192076,
                36.8562865
              ],
              [
                46.320321,
                36.8562865
              ],
              [
                46.3190745,
                36.8544446
              ],
              [
                46.319355,
                36.8536073
              ],
              [
                46.3196316,
                36.8530491
              ],
              [
                46.3169518,
                36.849611
              ],
              [
                46.3168583,
                36.8489581
              ],
              [
                46.3163947,
                36.8457216
              ],
              [
                46.3222478,
                36.8364782
              ],
              [
                46.3228009,
                36.8361991
              ],
              [
                46.3289144,
                36.8287077
              ],
              [
                46.3294675,
                36.8281494
              ],
              [
                46.3368328,
                36.8231389
              ],
              [
                46.3371094,
                36.8228596
              ],
              [
                46.3560209,
                36.8069438
              ],
              [
                46.3563014,
                36.8066647
              ],
              [
                46.3605929,
                36.7990225
              ],
              [
                46.3630957,
                36.7902213
              ],
              [
                46.3633723,
                36.789672
              ],
              [
                46.3630957,
                36.7863319
              ],
              [
                46.3633723,
                36.7855036
              ],
              [
                46.3629486,
                36.7689769
              ],
              [
                46.3632283,
                36.7684187
              ],
              [
                46.3579094,
                36.7556221
              ],
              [
                46.355888,
                36.7474762
              ],
              [
                46.3561645,
                36.7471971
              ],
              [
                46.3557216,
                36.7427491
              ],
              [
                46.3599988,
                36.7307919
              ],
              [
                46.383247,
                36.7157701
              ],
              [
                46.3957946,
                36.7124584
              ],
              [
                46.3957946,
                36.7119001
              ],
              [
                46.3977376,
                36.7088479
              ],
              [
                46.3982947,
                36.7069028
              ],
              [
                46.3983575,
                36.7027494
              ],
              [
                46.3986379,
                36.7021911
              ],
              [
                46.4041312,
                36.7005369
              ],
              [
                46.4041312,
                36.6994202
              ],
              [
                46.4038507,
                36.699141
              ],
              [
                46.4202911,
                36.6796761
              ],
              [
                46.4211239,
                36.6788387
              ],
              [
                46.421681,
                36.6788388
              ],
              [
                46.4360773,
                36.6680198
              ],
              [
                46.4369108,
                36.6680199
              ],
              [
                46.4416305,
                36.666633
              ],
              [
                46.4430204,
                36.6666331
              ],
              [
                46.4446039,
                36.6644202
              ],
              [
                46.4462711,
                36.6644202
              ],
              [
                46.447661,
                36.6641411
              ],
              [
                46.4495603,
                36.6616549
              ],
              [
                46.4541549,
                36.6581202
              ],
              [
                46.4595982,
                36.6531608
              ],
              [
                46.4642886,
                36.6460991
              ],
              [
                46.467226,
                36.6386481
              ],
              [
                46.4700534,
                36.6253817
              ],
              [
                46.4701079,
                36.6204878
              ],
              [
                46.4710521,
                36.6055376
              ],
              [
                46.4722425,
                36.599689
              ],
              [
                46.4775752,
                36.5882414
              ],
              [
                46.4808368,
                36.5832793
              ],
              [
                46.4920806,
                36.5679772
              ],
              [
                46.4998912,
                36.5608766
              ],
              [
                46.5052379,
                36.5534372
              ],
              [
                46.5066718,
                36.5482593
              ],
              [
                46.5105557,
                36.5406914
              ],
              [
                46.5119076,
                36.5387777
              ],
              [
                46.5133238,
                36.5372261
              ],
              [
                46.5150494,
                36.5345383
              ],
              [
                46.5157699,
                36.5332951
              ],
              [
                46.516478,
                36.5321399
              ],
              [
                46.5177011,
                36.530295
              ],
              [
                46.5174222,
                36.5295536
              ],
              [
                46.5173578,
                36.527588
              ],
              [
                46.5178299,
                36.5270362
              ],
              [
                46.5181303,
                36.5248636
              ],
              [
                46.5173363,
                36.5240876
              ],
              [
                46.5161776,
                36.5227599
              ],
              [
                46.5150833,
                36.5212941
              ],
              [
                46.5144395,
                36.5202939
              ],
              [
                46.5125512,
                36.5180522
              ],
              [
                46.5107702,
                36.5154309
              ],
              [
                46.5099978,
                36.5142065
              ],
              [
                46.5089892,
                36.5128785
              ],
              [
                46.5078734,
                36.510671
              ],
              [
                46.5068435,
                36.5089464
              ],
              [
                46.5063285,
                36.5075666
              ],
              [
                46.5049552,
                36.5054969
              ],
              [
                46.5041827,
                36.5028062
              ],
              [
                46.5040969,
                36.5005984
              ],
              [
                46.505314,
                36.4973204
              ],
              [
                46.5057277,
                36.4964931
              ],
              [
                46.5088176,
                36.4941816
              ],
              [
                46.5136671,
                36.491594
              ],
              [
                46.5160703,
                36.4903864
              ],
              [
                46.5180444,
                36.4892478
              ],
              [
                46.5200185,
                36.4882128
              ],
              [
                46.5215635,
                36.4872467
              ],
              [
                46.5223789,
                36.4860045
              ],
              [
                46.5223789,
                36.4845554
              ],
              [
                46.5213489,
                36.4814154
              ],
              [
                46.5185165,
                36.4768604
              ],
              [
                46.5165424,
                36.4746174
              ],
              [
                46.51268,
                36.4708213
              ],
              [
                46.508646,
                36.4663347
              ],
              [
                46.5068006,
                36.4638153
              ],
              [
                46.5054702,
                36.4610196
              ],
              [
                46.5046548,
                36.4577406
              ],
              [
                46.5034961,
                36.4535294
              ],
              [
                46.5026807,
                36.439272
              ],
              [
                46.503067,
                36.4341967
              ],
              [
                46.5042257,
                36.4307439
              ],
              [
                46.5068435,
                36.4270147
              ],
              [
                46.5098905,
                36.4246666
              ],
              [
                46.5133667,
                36.4229055
              ],
              [
                46.5184307,
                36.4214206
              ],
              [
                46.523323,
                36.4190723
              ],
              [
                46.5278291,
                36.4166204
              ],
              [
                46.5315198,
                36.4138576
              ],
              [
                46.5356397,
                36.4106802
              ],
              [
                46.5375709,
                36.4089187
              ],
              [
                46.5380001,
                36.4079862
              ],
              [
                46.5379571,
                36.4063111
              ],
              [
                46.537013,
                36.4045841
              ],
              [
                46.5355753,
                36.4029261
              ],
              [
                46.5334081,
                36.4014236
              ],
              [
                46.5356183,
                36.4006118
              ],
              [
                46.5377211,
                36.4002837
              ],
              [
                46.5397596,
                36.4003182
              ],
              [
                46.540854,
                36.4003355
              ],
              [
                46.5422916,
                36.4006291
              ],
              [
                46.5462827,
                36.402149
              ],
              [
                46.5491151,
                36.404325
              ],
              [
                46.5530204,
                36.4019762
              ],
              [
                46.5772247,
                36.3986947
              ],
              [
                46.5916013,
                36.3972094
              ],
              [
                46.6025447,
                36.3959658
              ],
              [
                46.6154193,
                36.3967948
              ],
              [
                46.6203117,
                36.3967948
              ],
              [
                46.6223287,
                36.3980902
              ],
              [
                46.6255045,
                36.3989538
              ],
              [
                46.6292166,
                36.3984184
              ],
              [
                46.6316628,
                36.3990574
              ],
              [
                46.6383361,
                36.4006982
              ],
              [
                46.6523265,
                36.4009746
              ],
              [
                46.6707801,
                36.4014581
              ],
              [
                46.6862296,
                36.4037379
              ],
              [
                46.7074298,
                36.4039451
              ],
              [
                46.7254972,
                36.4102657
              ],
              [
                46.7324066,
                36.4128905
              ],
              [
                46.7463541,
                36.4163787
              ],
              [
                46.7578125,
                36.418727
              ],
              [
                46.768198,
                36.4178291
              ],
              [
                46.7784547,
                36.4196249
              ],
              [
                46.7860078,
                36.4222149
              ],
              [
                46.7941618,
                36.4259097
              ],
              [
                46.7954921,
                36.4269111
              ],
              [
                46.8008565,
                36.4269802
              ],
              [
                46.804227,
                36.4263742
              ],
              [
                46.8065577,
                36.4284946
              ],
              [
                46.8069859,
                36.4286404
              ],
              [
                46.8080355,
                36.4290219
              ],
              [
                46.8092714,
                36.4293948
              ],
              [
                46.8124643,
                36.4318809
              ],
              [
                46.8135201,
                36.4317358
              ],
              [
                46.8151938,
                36.4326059
              ],
              [
                46.8157345,
                36.4336418
              ],
              [
                46.816919,
                36.4346569
              ],
              [
                46.8170992,
                36.4352991
              ],
              [
                46.8184124,
                36.4357962
              ],
              [
                46.8205238,
                36.4379507
              ],
              [
                46.8237425,
                36.439815
              ],
              [
                46.827004,
                36.438643
              ],
              [
                46.8275602,
                36.438643
              ],
              [
                46.8278368,
                36.4383637
              ],
              [
                46.8283939,
                36.4383638
              ],
              [
                46.8328245,
                36.4499685
              ],
              [
                46.8333778,
                36.4510764
              ],
              [
                46.8343731,
                36.458017
              ],
              [
                46.8557706,
                36.4591511
              ],
              [
                46.8563238,
                36.4599889
              ],
              [
                46.8674364,
                36.4677624
              ],
              [
                46.8679935,
                36.4688793
              ],
              [
                46.8679936,
                36.4694287
              ],
              [
                46.8679936,
                36.4719328
              ],
              [
                46.8682701,
                36.4727704
              ],
              [
                46.8779499,
                36.4829788
              ],
              [
                46.8776702,
                36.4840956
              ],
              [
                46.883465,
                36.4972335
              ],
              [
                46.8815188,
                36.4986207
              ],
              [
                46.8812423,
                36.4991791
              ],
              [
                46.8790051,
                36.5088086
              ],
              [
                46.8855059,
                36.5203293
              ],
              [
                46.8860622,
                36.5208879
              ],
              [
                46.902351,
                36.5237085
              ],
              [
                46.9294735,
                36.5529481
              ],
              [
                46.946983,
                36.586312
              ],
              [
                46.9432616,
                36.602751
              ],
              [
                46.9486996,
                36.6135989
              ],
              [
                46.9579693,
                36.6174569
              ],
              [
                46.9795615,
                36.6768778
              ],
              [
                46.9798381,
                36.6771569
              ],
              [
                46.9941076,
                36.7477723
              ],
              [
                46.9699856,
                36.7504389
              ],
              [
                46.9500729,
                36.7523645
              ],
              [
                46.9304953,
                36.7555517
              ],
              [
                46.9302147,
                36.7558307
              ],
              [
                46.9279952,
                36.7566592
              ],
              [
                46.9246615,
                36.7605579
              ],
              [
                46.9229951,
                36.7627729
              ],
              [
                46.9219647,
                36.7732868
              ],
              [
                46.9186318,
                36.7755016
              ],
              [
                46.9175217,
                36.7757807
              ],
              [
                46.9169646,
                36.7763389
              ],
              [
                46.9147451,
                36.7771763
              ],
              [
                46.903355,
                36.7799493
              ],
              [
                46.8972415,
                36.7799493
              ],
              [
                46.8961321,
                36.7802284
              ],
              [
                46.893632,
                36.7802283
              ],
              [
                46.8925219,
                36.7805075
              ],
              [
                46.8914086,
                36.7805075
              ],
              [
                46.890575,
                36.7807866
              ],
              [
                46.8897421,
                36.7807866
              ],
              [
                46.8779925,
                36.7799973
              ],
              [
                46.8735455,
                36.78639
              ],
              [
                46.8732689,
                36.7866601
              ],
              [
                46.8729923,
                36.788884
              ],
              [
                46.8729924,
                36.7891632
              ],
              [
                46.8729923,
                36.7894423
              ],
              [
                46.8727119,
                36.7900005
              ],
              [
                46.8727118,
                36.7904101
              ],
              [
                46.8415829,
                36.7556654
              ],
              [
                46.8415535,
                36.755534
              ],
              [
                46.8358188,
                36.7299048
              ],
              [
                46.8353793,
                36.7308198
              ],
              [
                46.8351027,
                36.7316487
              ],
              [
                46.7979809,
                36.7644671
              ],
              [
                46.794891,
                36.7762928
              ],
              [
                46.7815135,
                36.823119
              ],
              [
                46.7784564,
                36.8281252
              ],
              [
                46.7681795,
                36.8545152
              ],
              [
                46.7679029,
                36.8556316
              ],
              [
                46.7679029,
                36.8564599
              ],
              [
                46.7552087,
                36.8767403
              ],
              [
                46.7441256,
                36.8881099
              ],
              [
                46.7438491,
                36.888389
              ],
              [
                46.704254,
                36.9099606
              ],
              [
                46.6866159,
                36.9088659
              ],
              [
                46.685783,
                36.9083078
              ],
              [
                46.6849494,
                36.9083077
              ],
              [
                46.6785841,
                36.9009871
              ],
              [
                46.6783075,
                36.9007079
              ],
              [
                46.6748141,
                36.8968513
              ],
              [
                46.6684707,
                36.8969789
              ],
              [
                46.6645808,
                36.8967088
              ],
              [
                46.6640276,
                36.8964297
              ],
              [
                46.6620807,
                36.8964297
              ],
              [
                46.6612471,
                36.8967087
              ],
              [
                46.660694,
                36.8967087
              ],
              [
                46.6585063,
                36.8999401
              ],
              [
                46.6571473,
                36.9052743
              ],
              [
                46.657191,
                36.9236535
              ],
              [
                46.6558011,
                36.9264263
              ],
              [
                46.6549675,
                36.9275426
              ],
              [
                46.652199,
                36.9300499
              ],
              [
                46.6510888,
                36.9303199
              ],
              [
                46.6505326,
                36.930599
              ],
              [
                46.6339442,
                36.9260189
              ],
              [
                46.6336637,
                36.9257398
              ],
              [
                46.6311645,
                36.9257398
              ],
              [
                46.6267206,
                36.9249117
              ],
              [
                46.6261644,
                36.9246326
              ],
              [
                46.6250541,
                36.9246326
              ],
              [
                46.6125547,
                36.9201852
              ],
              [
                46.6108875,
                36.9199062
              ],
              [
                46.6100547,
                36.919348
              ],
              [
                46.6094976,
                36.9187899
              ],
              [
                46.6089414,
                36.9182317
              ],
              [
                46.5986646,
                36.9135143
              ],
              [
                46.5723132,
                36.9056079
              ],
              [
                46.5721008,
                36.9058223
              ],
              [
                46.5720367,
                36.905887
              ],
              [
                46.5714796,
                36.9056079
              ],
              [
                46.5698131,
                36.9056079
              ],
              [
                46.5675935,
                36.906157
              ],
              [
                46.5662037,
                36.9061571
              ],
              [
                46.564813,
                36.9067151
              ],
              [
                46.5603699,
                36.9067151
              ],
              [
                46.5589801,
                36.9064361
              ],
              [
                46.5581465,
                36.9064361
              ],
              [
                46.5416988,
                36.9010606
              ],
              [
                46.5289877,
                36.8907422
              ],
              [
                46.5152548,
                36.8793461
              ],
              [
                46.5096324,
                36.8810784
              ],
              [
                46.4943121,
                36.8731668
              ],
              [
                46.4463028,
                36.8999983
              ],
              [
                46.44547,
                36.9002774
              ],
              [
                46.4443598,
                36.9002774
              ],
              [
                46.4343595,
                36.9018962
              ],
              [
                46.4280675,
                36.9029633
              ],
              [
                46.4267194,
                36.9021416
              ],
              [
                46.426034,
                36.9017246
              ],
              [
                46.4248323,
                36.901982
              ],
              [
                46.4236092,
                36.9023938
              ],
              [
                46.421442,
                36.9027884
              ],
              [
                46.4178586,
                36.903286
              ],
              [
                46.4151764,
                36.9040582
              ],
              [
                46.4111392,
                36.9050495
              ],
              [
                46.3748358,
                36.9081762
              ],
              [
                46.3263176,
                36.9096815
              ],
              [
                46.313296,
                36.9102603
              ],
              [
                46.3084459,
                36.910235
              ],
              [
                46.3070297,
                36.9085879
              ],
              [
                46.3049268,
                36.9050191
              ],
              [
                46.3005924,
                36.8989791
              ],
              [
                46.2966871,
                36.8922523
              ],
              [
                46.2942407,
                36.8883052
              ],
              [
                46.2917518,
                36.8865202
              ],
              [
                46.286001,
                36.8841862
              ],
              [
                46.2807226,
                36.8827444
              ],
              [
                46.2734697,
                36.8817834
              ],
              [
                46.268363,
                36.8815087
              ],
              [
                46.2592864,
                36.882075
              ],
              [
                46.2548446,
                36.883122
              ],
              [
                46.249845,
                36.8834309
              ],
              [
                46.248065,
                36.8837698
              ],
              [
                46.2469254,
                36.8836614
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555112,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شوط",
          "name:en": "Showt County",
          "name:ku": "Şot",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2723709",
          "wikipedia": "en:Showt County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.634078,
                39.1557966
              ],
              [
                44.6343546,
                39.1555187
              ],
              [
                44.6412977,
                39.1474682
              ],
              [
                44.6680066,
                39.1199396
              ],
              [
                44.6745297,
                39.1098172
              ],
              [
                44.6918639,
                39.1002453
              ],
              [
                44.6926968,
                39.0999673
              ],
              [
                44.6940874,
                39.0999672
              ],
              [
                44.7103498,
                39.0897728
              ],
              [
                44.7117404,
                39.0889388
              ],
              [
                44.712017,
                39.0886607
              ],
              [
                44.7125732,
                39.0878267
              ],
              [
                44.7128498,
                39.0861585
              ],
              [
                44.7417397,
                39.059495
              ],
              [
                44.7422967,
                39.0594949
              ],
              [
                44.7422967,
                39.0592169
              ],
              [
                44.7531299,
                39.051719
              ],
              [
                44.7536869,
                39.051719
              ],
              [
                44.7536869,
                39.0514409
              ],
              [
                44.75424,
                39.0514409
              ],
              [
                44.7545198,
                39.0511629
              ],
              [
                44.7761532,
                39.0429198
              ],
              [
                44.7935397,
                39.0292834
              ],
              [
                44.7940928,
                39.0290054
              ],
              [
                44.7946499,
                39.0287273
              ],
              [
                44.7949265,
                39.0281712
              ],
              [
                44.7954827,
                39.0278932
              ],
              [
                44.7957593,
                39.027059
              ],
              [
                44.7957594,
                39.026781
              ],
              [
                44.7949265,
                39.0245564
              ],
              [
                44.7945959,
                39.005348
              ],
              [
                44.792649,
                39.0036797
              ],
              [
                44.7909824,
                39.0022984
              ],
              [
                44.788206,
                38.9989618
              ],
              [
                44.7865395,
                38.9961815
              ],
              [
                44.7871395,
                38.9802293
              ],
              [
                44.7765354,
                38.9768171
              ],
              [
                44.7543399,
                38.937838
              ],
              [
                44.7551728,
                38.9378379
              ],
              [
                44.7557299,
                38.938116
              ],
              [
                44.756167,
                38.9383347
              ],
              [
                44.75684,
                38.9383942
              ],
              [
                44.7571198,
                38.9386724
              ],
              [
                44.7585065,
                38.9386724
              ],
              [
                44.7585065,
                38.9389505
              ],
              [
                44.7596198,
                38.9389504
              ],
              [
                44.7598963,
                38.9392287
              ],
              [
                44.7752951,
                38.9420541
              ],
              [
                44.7928472,
                38.948174
              ],
              [
                44.8084038,
                38.9528926
              ],
              [
                44.8092367,
                38.9528927
              ],
              [
                44.8106234,
                38.9534488
              ],
              [
                44.8122898,
                38.9534487
              ],
              [
                44.8131234,
                38.9537269
              ],
              [
                44.815347,
                38.9537269
              ],
              [
                44.8164572,
                38.9540049
              ],
              [
                44.8212136,
                38.9522696
              ],
              [
                44.8223268,
                38.9525476
              ],
              [
                44.8356599,
                38.9525477
              ],
              [
                44.8373263,
                38.9522696
              ],
              [
                44.8398264,
                38.9522697
              ],
              [
                44.8417733,
                38.9519915
              ],
              [
                44.8442734,
                38.9519916
              ],
              [
                44.8558962,
                38.9589219
              ],
              [
                44.8581158,
                38.958922
              ],
              [
                44.8595065,
                38.9586439
              ],
              [
                44.8633964,
                38.9586439
              ],
              [
                44.863673,
                38.9583658
              ],
              [
                44.865616,
                38.9583658
              ],
              [
                44.866173,
                38.9580878
              ],
              [
                44.8756193,
                38.9580878
              ],
              [
                44.877006,
                38.9583659
              ],
              [
                44.8792296,
                38.9583658
              ],
              [
                44.8857078,
                38.9629375
              ],
              [
                44.9104099,
                38.9702056
              ],
              [
                44.913463,
                38.971318
              ],
              [
                44.9138638,
                38.9717177
              ],
              [
                44.9145763,
                38.9721522
              ],
              [
                44.9192991,
                38.9729775
              ],
              [
                44.9206859,
                38.9735337
              ],
              [
                44.9220758,
                38.9738118
              ],
              [
                44.9231859,
                38.9740898
              ],
              [
                44.9240196,
                38.9743679
              ],
              [
                44.9835203,
                39.0061124
              ],
              [
                45.0061033,
                39.0071574
              ],
              [
                45.0095666,
                39.009314
              ],
              [
                45.0104001,
                39.0098699
              ],
              [
                45.0109573,
                39.0098699
              ],
              [
                45.0120666,
                39.0102172
              ],
              [
                45.008617,
                39.0241708
              ],
              [
                45.0040241,
                39.0379176
              ],
              [
                45.0026063,
                39.0604822
              ],
              [
                45.0056647,
                39.0694463
              ],
              [
                45.0125392,
                39.0760952
              ],
              [
                45.0244909,
                39.0822418
              ],
              [
                45.0250441,
                39.0822418
              ],
              [
                45.0261574,
                39.0830759
              ],
              [
                45.0381471,
                39.0942515
              ],
              [
                45.0456473,
                39.1031387
              ],
              [
                45.0459269,
                39.1128596
              ],
              [
                45.0456472,
                39.1131376
              ],
              [
                45.0460715,
                39.1406111
              ],
              [
                45.0460715,
                39.143113
              ],
              [
                45.0424592,
                39.1546805
              ],
              [
                45.0422165,
                39.154921
              ],
              [
                45.0413837,
                39.154921
              ],
              [
                45.0377649,
                39.1625552
              ],
              [
                45.0238051,
                39.1727602
              ],
              [
                45.0235246,
                39.1730382
              ],
              [
                45.0224153,
                39.1730381
              ],
              [
                45.0218582,
                39.1733162
              ],
              [
                45.0210245,
                39.1733161
              ],
              [
                45.0168581,
                39.1752618
              ],
              [
                45.0163049,
                39.1752618
              ],
              [
                45.0160252,
                39.1755397
              ],
              [
                45.0151916,
                39.1755398
              ],
              [
                45.0149151,
                39.1758178
              ],
              [
                44.9879221,
                39.1803539
              ],
              [
                44.9507496,
                39.1971279
              ],
              [
                44.9501934,
                39.1974058
              ],
              [
                44.9465831,
                39.1974058
              ],
              [
                44.9443596,
                39.1976748
              ],
              [
                44.9438064,
                39.1976747
              ],
              [
                44.9404736,
                39.1990645
              ],
              [
                44.9354702,
                39.2065688
              ],
              [
                44.9306831,
                39.2082698
              ],
              [
                44.9309596,
                39.2091037
              ],
              [
                44.9306831,
                39.2093816
              ],
              [
                44.930683,
                39.2121613
              ],
              [
                44.9304064,
                39.2129953
              ],
              [
                44.9301268,
                39.2149409
              ],
              [
                44.9304065,
                39.2154969
              ],
              [
                44.9349113,
                39.2239357
              ],
              [
                44.9452109,
                39.2477831
              ],
              [
                44.9471578,
                39.2619479
              ],
              [
                44.9482671,
                39.2658387
              ],
              [
                44.9482671,
                39.2669503
              ],
              [
                44.9375151,
                39.2798393
              ],
              [
                44.9285887,
                39.281168
              ],
              [
                44.9217222,
                39.2782448
              ],
              [
                44.9179457,
                39.2794407
              ],
              [
                44.9186323,
                39.2815667
              ],
              [
                44.9265288,
                39.2863499
              ],
              [
                44.9268721,
                39.28914
              ],
              [
                44.9218939,
                39.2892729
              ],
              [
                44.9160574,
                39.2911329
              ],
              [
                44.8988562,
                39.2974874
              ],
              [
                44.8991327,
                39.2977653
              ],
              [
                44.8679922,
                39.3058783
              ],
              [
                44.8341749,
                39.3090661
              ],
              [
                44.8322867,
                39.3163709
              ],
              [
                44.8185418,
                39.3357193
              ],
              [
                44.8174317,
                39.3359971
              ],
              [
                44.8110416,
                39.3401651
              ],
              [
                44.7996948,
                39.3427712
              ],
              [
                44.7980276,
                39.3427711
              ],
              [
                44.797751,
                39.3427712
              ],
              [
                44.7974713,
                39.3430491
              ],
              [
                44.7966377,
                39.3430491
              ],
              [
                44.7841795,
                39.3421727
              ],
              [
                44.7772437,
                39.3450975
              ],
              [
                44.7766802,
                39.3446738
              ],
              [
                44.7612451,
                39.3373336
              ],
              [
                44.7604114,
                39.3364998
              ],
              [
                44.742852,
                39.3022039
              ],
              [
                44.7280955,
                39.2805356
              ],
              [
                44.7280955,
                39.2802577
              ],
              [
                44.7280956,
                39.2797018
              ],
              [
                44.7278189,
                39.279146
              ],
              [
                44.6653242,
                39.2411347
              ],
              [
                44.6631007,
                39.237799
              ],
              [
                44.6628241,
                39.2375211
              ],
              [
                44.6388241,
                39.2136356
              ],
              [
                44.6374508,
                39.2027285
              ],
              [
                44.6518704,
                39.1907555
              ],
              [
                44.6542736,
                39.1747882
              ],
              [
                44.641914,
                39.1678679
              ],
              [
                44.6418539,
                39.1619104
              ],
              [
                44.6415774,
                39.1616326
              ],
              [
                44.6415774,
                39.1613547
              ],
              [
                44.6410211,
                39.1613546
              ],
              [
                44.637964,
                39.1585756
              ],
              [
                44.634078,
                39.1557966
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555194,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ماکو",
          "name:en": "Maku County",
          "name:ku": "Makû",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1293986",
          "wikipedia": "en:Maku County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.2978913,
                39.2938598
              ],
              [
                44.3082045,
                39.2992366
              ],
              [
                44.3253706,
                39.2890072
              ],
              [
                44.3398411,
                39.275793
              ],
              [
                44.3403981,
                39.275793
              ],
              [
                44.367201,
                39.2728807
              ],
              [
                44.3724809,
                39.2676007
              ],
              [
                44.3747005,
                39.2628854
              ],
              [
                44.3744239,
                39.2567717
              ],
              [
                44.3758139,
                39.2537147
              ],
              [
                44.3725524,
                39.2455695
              ],
              [
                44.3678561,
                39.2389448
              ],
              [
                44.3684132,
                39.2381111
              ],
              [
                44.3684131,
                39.2378331
              ],
              [
                44.3591821,
                39.2282606
              ],
              [
                44.3594586,
                39.2279826
              ],
              [
                44.3558923,
                39.2188111
              ],
              [
                44.365711,
                39.2132364
              ],
              [
                44.3758516,
                39.2087868
              ],
              [
                44.3861316,
                39.2040616
              ],
              [
                44.3872411,
                39.2040615
              ],
              [
                44.3877981,
                39.2037836
              ],
              [
                44.390087,
                39.2011321
              ],
              [
                44.3989862,
                39.2016553
              ],
              [
                44.3998197,
                39.2013773
              ],
              [
                44.4014861,
                39.2013773
              ],
              [
                44.4023197,
                39.2010993
              ],
              [
                44.4056526,
                39.2010993
              ],
              [
                44.4064862,
                39.2008214
              ],
              [
                44.4087089,
                39.2008215
              ],
              [
                44.4109325,
                39.2005434
              ],
              [
                44.4114855,
                39.2002655
              ],
              [
                44.4128763,
                39.2002655
              ],
              [
                44.4187092,
                39.1991536
              ],
              [
                44.4212093,
                39.1991537
              ],
              [
                44.4217656,
                39.1988757
              ],
              [
                44.4270422,
                39.1988757
              ],
              [
                44.4287094,
                39.1985977
              ],
              [
                44.4323229,
                39.1985978
              ],
              [
                44.4331556,
                39.1983197
              ],
              [
                44.4375987,
                39.1983198
              ],
              [
                44.4424855,
                39.1953811
              ],
              [
                44.4480426,
                39.1953811
              ],
              [
                44.4494325,
                39.1951032
              ],
              [
                44.4552655,
                39.1951032
              ],
              [
                44.4558226,
                39.1948253
              ],
              [
                44.4588757,
                39.1951032
              ],
              [
                44.4594321,
                39.1948253
              ],
              [
                44.4605422,
                39.1951032
              ],
              [
                44.4674919,
                39.1908339
              ],
              [
                44.4752686,
                39.190834
              ],
              [
                44.4758248,
                39.1911121
              ],
              [
                44.476935,
                39.1908339
              ],
              [
                44.4783249,
                39.190834
              ],
              [
                44.478882,
                39.1911121
              ],
              [
                44.4802687,
                39.190834
              ],
              [
                44.4874284,
                39.1889833
              ],
              [
                44.4913183,
                39.1889833
              ],
              [
                44.4921519,
                39.1892613
              ],
              [
                44.4954849,
                39.1892613
              ],
              [
                44.4963184,
                39.1895393
              ],
              [
                44.5049282,
                39.1947467
              ],
              [
                44.5180111,
                39.1937967
              ],
              [
                44.5191212,
                39.1940747
              ],
              [
                44.5405775,
                39.1903497
              ],
              [
                44.5416876,
                39.1900715
              ],
              [
                44.5433541,
                39.1900717
              ],
              [
                44.5439104,
                39.1897936
              ],
              [
                44.5464104,
                39.1897937
              ],
              [
                44.5466869,
                39.1895157
              ],
              [
                44.5478011,
                39.1895156
              ],
              [
                44.5500207,
                39.1886816
              ],
              [
                44.5505769,
                39.1884036
              ],
              [
                44.5756504,
                39.1756935
              ],
              [
                44.57669,
                39.1753463
              ],
              [
                44.5769675,
                39.1750683
              ],
              [
                44.5974912,
                39.1642332
              ],
              [
                44.5980475,
                39.1645113
              ],
              [
                44.5991577,
                39.1642333
              ],
              [
                44.600271,
                39.1645112
              ],
              [
                44.6036046,
                39.1645113
              ],
              [
                44.6038812,
                39.1642333
              ],
              [
                44.604714,
                39.1642333
              ],
              [
                44.6069375,
                39.1633993
              ],
              [
                44.6074907,
                39.1633994
              ],
              [
                44.6108275,
                39.1620095
              ],
              [
                44.6130478,
                39.1597857
              ],
              [
                44.6141612,
                39.1592297
              ],
              [
                44.6144377,
                39.1589518
              ],
              [
                44.6332444,
                39.1571861
              ],
              [
                44.633521,
                39.1569082
              ],
              [
                44.633521,
                39.1566302
              ],
              [
                44.634078,
                39.1560745
              ],
              [
                44.634078,
                39.1557966
              ],
              [
                44.637964,
                39.1585756
              ],
              [
                44.6410211,
                39.1613546
              ],
              [
                44.6415774,
                39.1613547
              ],
              [
                44.6415774,
                39.1616326
              ],
              [
                44.6418539,
                39.1619104
              ],
              [
                44.641914,
                39.1678679
              ],
              [
                44.6542736,
                39.1747882
              ],
              [
                44.6518704,
                39.1907555
              ],
              [
                44.6374508,
                39.2027285
              ],
              [
                44.6388241,
                39.2136356
              ],
              [
                44.6628241,
                39.2375211
              ],
              [
                44.6631007,
                39.237799
              ],
              [
                44.6653242,
                39.2411347
              ],
              [
                44.7278189,
                39.279146
              ],
              [
                44.7280956,
                39.2797018
              ],
              [
                44.7280955,
                39.2802577
              ],
              [
                44.7280955,
                39.2805356
              ],
              [
                44.742852,
                39.3022039
              ],
              [
                44.7604114,
                39.3364998
              ],
              [
                44.7612451,
                39.3373336
              ],
              [
                44.7766802,
                39.3446738
              ],
              [
                44.7772437,
                39.3450975
              ],
              [
                44.7940062,
                39.3519542
              ],
              [
                44.8103705,
                39.3688584
              ],
              [
                44.817659,
                39.3889477
              ],
              [
                44.8182161,
                39.3895035
              ],
              [
                44.8233093,
                39.4141293
              ],
              [
                44.8267389,
                39.434183
              ],
              [
                44.8256287,
                39.4402949
              ],
              [
                44.8286773,
                39.4572085
              ],
              [
                44.8281241,
                39.4594308
              ],
              [
                44.8278436,
                39.460542
              ],
              [
                44.8281568,
                39.4714523
              ],
              [
                44.8326016,
                39.4810119
              ],
              [
                44.8450723,
                39.4910832
              ],
              [
                44.8515653,
                39.4916741
              ],
              [
                44.8515653,
                39.4919518
              ],
              [
                44.8679523,
                39.5036214
              ],
              [
                44.8759708,
                39.5178942
              ],
              [
                44.8741229,
                39.5285984
              ],
              [
                44.8738416,
                39.5346978
              ],
              [
                44.8724203,
                39.5380143
              ],
              [
                44.8713767,
                39.5437131
              ],
              [
                44.8759697,
                39.5580587
              ],
              [
                44.8792937,
                39.559884
              ],
              [
                44.8817777,
                39.5626888
              ],
              [
                44.8836368,
                39.5656399
              ],
              [
                44.8824377,
                39.5799544
              ],
              [
                44.8854394,
                39.5850225
              ],
              [
                44.8919728,
                39.5888056
              ],
              [
                44.8987787,
                39.5955845
              ],
              [
                44.8997677,
                39.59858
              ],
              [
                44.9002116,
                39.6010832
              ],
              [
                44.8989316,
                39.6032151
              ],
              [
                44.8972058,
                39.6052331
              ],
              [
                44.8954283,
                39.6057307
              ],
              [
                44.8935468,
                39.6047696
              ],
              [
                44.8919764,
                39.6019845
              ],
              [
                44.8928059,
                39.5997733
              ],
              [
                44.8925726,
                39.5977431
              ],
              [
                44.8909207,
                39.5961022
              ],
              [
                44.8760247,
                39.5930064
              ],
              [
                44.8730953,
                39.5939691
              ],
              [
                44.8729454,
                39.5965373
              ],
              [
                44.8731048,
                39.5995362
              ],
              [
                44.8735218,
                39.6007009
              ],
              [
                44.8808237,
                39.6072004
              ],
              [
                44.8810919,
                39.6083603
              ],
              [
                44.8808613,
                39.6099619
              ],
              [
                44.8755201,
                39.6152092
              ],
              [
                44.8726179,
                39.6156237
              ],
              [
                44.8689052,
                39.6150926
              ],
              [
                44.8666004,
                39.6130026
              ],
              [
                44.8666847,
                39.6070353
              ],
              [
                44.8660356,
                39.6050162
              ],
              [
                44.8645363,
                39.6035648
              ],
              [
                44.8612371,
                39.602742
              ],
              [
                44.8558229,
                39.6022547
              ],
              [
                44.8534277,
                39.6028074
              ],
              [
                44.8406864,
                39.6110638
              ],
              [
                44.8373938,
                39.6122701
              ],
              [
                44.8271203,
                39.6106534
              ],
              [
                44.8244366,
                39.6107741
              ],
              [
                44.8219144,
                39.6112697
              ],
              [
                44.8191344,
                39.6134193
              ],
              [
                44.816239,
                39.6151265
              ],
              [
                44.8120838,
                39.6197166
              ],
              [
                44.8098565,
                39.6244252
              ],
              [
                44.8093804,
                39.627336
              ],
              [
                44.8087677,
                39.6277727
              ],
              [
                44.8081264,
                39.6282297
              ],
              [
                44.807226,
                39.628764
              ],
              [
                44.80706,
                39.628865
              ],
              [
                44.8064776,
                39.6291172
              ],
              [
                44.8060172,
                39.6293233
              ],
              [
                44.8052235,
                39.6296027
              ],
              [
                44.8049608,
                39.6296309
              ],
              [
                44.8046981,
                39.6295888
              ],
              [
                44.8044856,
                39.6300241
              ],
              [
                44.8044214,
                39.6305082
              ],
              [
                44.804304,
                39.630857
              ],
              [
                44.8041029,
                39.6312109
              ],
              [
                44.8039388,
                39.6317345
              ],
              [
                44.803894,
                39.632151
              ],
              [
                44.8032842,
                39.6324758
              ],
              [
                44.8030875,
                39.6328746
              ],
              [
                44.8031025,
                39.6331702
              ],
              [
                44.8032921,
                39.6334659
              ],
              [
                44.803546,
                39.633724
              ],
              [
                44.8036366,
                39.6343007
              ],
              [
                44.8035218,
                39.634889
              ],
              [
                44.8035897,
                39.6354978
              ],
              [
                44.803582,
                39.636317
              ],
              [
                44.8034947,
                39.6372066
              ],
              [
                44.8034681,
                39.6380502
              ],
              [
                44.8031725,
                39.63855
              ],
              [
                44.8032301,
                39.6390362
              ],
              [
                44.8032251,
                39.6394068
              ],
              [
                44.803439,
                39.640205
              ],
              [
                44.803434,
                39.640586
              ],
              [
                44.803329,
                39.641145
              ],
              [
                44.8033663,
                39.641654
              ],
              [
                44.8033963,
                39.6419913
              ],
              [
                44.8033121,
                39.642378
              ],
              [
                44.8030615,
                39.6426067
              ],
              [
                44.8026532,
                39.6427306
              ],
              [
                44.802387,
                39.642893
              ],
              [
                44.802252,
                39.643146
              ],
              [
                44.802211,
                39.643858
              ],
              [
                44.801845,
                39.644135
              ],
              [
                44.801417,
                39.644133
              ],
              [
                44.801087,
                39.644207
              ],
              [
                44.801084,
                39.644487
              ],
              [
                44.800883,
                39.644765
              ],
              [
                44.800419,
                39.645016
              ],
              [
                44.799782,
                39.645928
              ],
              [
                44.799417,
                39.64618
              ],
              [
                44.799314,
                39.64656
              ],
              [
                44.799077,
                39.647118
              ],
              [
                44.798876,
                39.647422
              ],
              [
                44.798638,
                39.648081
              ],
              [
                44.79853,
                39.648869
              ],
              [
                44.798231,
                39.64907
              ],
              [
                44.79737,
                39.649446
              ],
              [
                44.796611,
                39.649594
              ],
              [
                44.796115,
                39.649769
              ],
              [
                44.795455,
                39.649867
              ],
              [
                44.794759,
                39.650218
              ],
              [
                44.793836,
                39.650264
              ],
              [
                44.792713,
                39.650511
              ],
              [
                44.792318,
                39.650458
              ],
              [
                44.791857,
                39.650455
              ],
              [
                44.789578,
                39.651026
              ],
              [
                44.789016,
                39.651124
              ],
              [
                44.7876,
                39.651141
              ],
              [
                44.787398,
                39.65147
              ],
              [
                44.7874094,
                39.652229
              ],
              [
                44.7878169,
                39.6531512
              ],
              [
                44.7876144,
                39.6534352
              ],
              [
                44.7872908,
                39.6533633
              ],
              [
                44.786992,
                39.6531689
              ],
              [
                44.7866967,
                39.6533374
              ],
              [
                44.7867399,
                39.6537636
              ],
              [
                44.7868689,
                39.6542447
              ],
              [
                44.7867588,
                39.6547429
              ],
              [
                44.786471,
                39.6550697
              ],
              [
                44.7862353,
                39.6551171
              ],
              [
                44.7853691,
                39.6548068
              ],
              [
                44.7846851,
                39.6546637
              ],
              [
                44.7842272,
                39.6548134
              ],
              [
                44.7832478,
                39.6556355
              ],
              [
                44.7829346,
                39.6564182
              ],
              [
                44.7824856,
                39.6567257
              ],
              [
                44.7801081,
                39.6574543
              ],
              [
                44.778467,
                39.6595745
              ],
              [
                44.7750854,
                39.6609508
              ],
              [
                44.7744862,
                39.6608975
              ],
              [
                44.773895,
                39.6605374
              ],
              [
                44.7703478,
                39.6610364
              ],
              [
                44.770116,
                39.6610875
              ],
              [
                44.7696293,
                39.6617204
              ],
              [
                44.7695374,
                39.6618974
              ],
              [
                44.7698865,
                39.6621588
              ],
              [
                44.770109,
                39.6625122
              ],
              [
                44.7700609,
                39.6635501
              ],
              [
                44.7691451,
                39.6646131
              ],
              [
                44.7678816,
                39.6653928
              ],
              [
                44.7673293,
                39.6654269
              ],
              [
                44.7646446,
                39.6651088
              ],
              [
                44.7640251,
                39.6652985
              ],
              [
                44.7625019,
                39.6661279
              ],
              [
                44.7606275,
                39.6678905
              ],
              [
                44.760677,
                39.6684059
              ],
              [
                44.762075,
                39.6692315
              ],
              [
                44.7616097,
                39.6700839
              ],
              [
                44.7615364,
                39.6705152
              ],
              [
                44.7611119,
                39.6706339
              ],
              [
                44.7604236,
                39.6704944
              ],
              [
                44.7595847,
                39.6704252
              ],
              [
                44.7587891,
                39.670018
              ],
              [
                44.7579519,
                39.6699795
              ],
              [
                44.756858,
                39.6704123
              ],
              [
                44.7563126,
                39.6705325
              ],
              [
                44.7555072,
                39.6707099
              ],
              [
                44.7548046,
                39.6707841
              ],
              [
                44.7545221,
                39.6711065
              ],
              [
                44.7548071,
                39.6715764
              ],
              [
                44.7544682,
                39.672053
              ],
              [
                44.7543943,
                39.6723901
              ],
              [
                44.7540827,
                39.6727111
              ],
              [
                44.7544025,
                39.6730539
              ],
              [
                44.754792,
                39.6730304
              ],
              [
                44.7557634,
                39.6723373
              ],
              [
                44.7561052,
                39.6719227
              ],
              [
                44.7568527,
                39.6715102
              ],
              [
                44.7573267,
                39.6715112
              ],
              [
                44.7578944,
                39.6716591
              ],
              [
                44.7580451,
                39.6719226
              ],
              [
                44.7580604,
                39.6723763
              ],
              [
                44.7583866,
                39.6727796
              ],
              [
                44.7585128,
                39.6731646
              ],
              [
                44.7588286,
                39.6734767
              ],
              [
                44.7586182,
                39.6740337
              ],
              [
                44.7585013,
                39.6747692
              ],
              [
                44.7587451,
                39.6753964
              ],
              [
                44.7585657,
                39.6758949
              ],
              [
                44.7581758,
                39.6766439
              ],
              [
                44.7578052,
                39.6768953
              ],
              [
                44.7571404,
                39.6771063
              ],
              [
                44.7564169,
                39.6771533
              ],
              [
                44.7558576,
                39.6774057
              ],
              [
                44.7554,
                39.6774319
              ],
              [
                44.7550827,
                39.677768
              ],
              [
                44.7546821,
                39.6779392
              ],
              [
                44.7541529,
                39.6784015
              ],
              [
                44.7541086,
                39.6789192
              ],
              [
                44.7542205,
                39.679166
              ],
              [
                44.7535948,
                39.6801445
              ],
              [
                44.7537031,
                39.681736
              ],
              [
                44.7531686,
                39.6820352
              ],
              [
                44.752818,
                39.6820823
              ],
              [
                44.7524137,
                39.6824209
              ],
              [
                44.7518857,
                39.6828632
              ],
              [
                44.7517298,
                39.6831336
              ],
              [
                44.751849,
                39.6836272
              ],
              [
                44.7515854,
                39.6838985
              ],
              [
                44.7515391,
                39.6842284
              ],
              [
                44.7513013,
                39.6844372
              ],
              [
                44.7513163,
                39.6850739
              ],
              [
                44.7509489,
                39.6855321
              ],
              [
                44.7499374,
                39.6862714
              ],
              [
                44.7500782,
                39.6867283
              ],
              [
                44.7498632,
                39.686988
              ],
              [
                44.7495165,
                39.6872204
              ],
              [
                44.7492007,
                39.6875963
              ],
              [
                44.7487221,
                39.687891
              ],
              [
                44.7483196,
                39.6879576
              ],
              [
                44.7479746,
                39.6882307
              ],
              [
                44.7475442,
                39.6882355
              ],
              [
                44.7469815,
                39.6883451
              ],
              [
                44.7458672,
                39.689102
              ],
              [
                44.7449024,
                39.6892571
              ],
              [
                44.7439447,
                39.6899503
              ],
              [
                44.7438174,
                39.6904073
              ],
              [
                44.7433932,
                39.6908473
              ],
              [
                44.7432118,
                39.6911801
              ],
              [
                44.7428971,
                39.6915763
              ],
              [
                44.7428522,
                39.691969
              ],
              [
                44.7426432,
                39.6922603
              ],
              [
                44.742734,
                39.692692
              ],
              [
                44.7426599,
                39.6929812
              ],
              [
                44.7419713,
                39.693484
              ],
              [
                44.741841,
                39.6937338
              ],
              [
                44.7414067,
                39.6936967
              ],
              [
                44.7411298,
                39.6938077
              ],
              [
                44.740531,
                39.6937821
              ],
              [
                44.7404865,
                39.6934877
              ],
              [
                44.7395274,
                39.6932305
              ],
              [
                44.7390969,
                39.6933403
              ],
              [
                44.7385976,
                39.6931468
              ],
              [
                44.7381264,
                39.6931233
              ],
              [
                44.7374675,
                39.6934246
              ],
              [
                44.7371603,
                39.6933048
              ],
              [
                44.7366956,
                39.6935138
              ],
              [
                44.7364716,
                39.693455
              ],
              [
                44.7360905,
                39.6935679
              ],
              [
                44.7358297,
                39.6935702
              ],
              [
                44.7353524,
                39.6937906
              ],
              [
                44.7342854,
                39.6938319
              ],
              [
                44.7334314,
                39.69454
              ],
              [
                44.7333563,
                39.6948199
              ],
              [
                44.7329639,
                39.695366
              ],
              [
                44.7322023,
                39.6966748
              ],
              [
                44.7315834,
                39.6973069
              ],
              [
                44.7306873,
                39.6980158
              ],
              [
                44.7305915,
                39.698233
              ],
              [
                44.7300732,
                39.698438
              ],
              [
                44.7297871,
                39.6982396
              ],
              [
                44.7293678,
                39.6983511
              ],
              [
                44.7289932,
                39.6986317
              ],
              [
                44.7289176,
                39.6988173
              ],
              [
                44.7285987,
                39.6988968
              ],
              [
                44.7281028,
                39.6992106
              ],
              [
                44.7278565,
                39.6992165
              ],
              [
                44.7277347,
                39.6993439
              ],
              [
                44.7276969,
                39.699531
              ],
              [
                44.7273882,
                39.6996802
              ],
              [
                44.7271663,
                39.7003595
              ],
              [
                44.7273999,
                39.7008052
              ],
              [
                44.7277529,
                39.700982
              ],
              [
                44.7278145,
                39.7015442
              ],
              [
                44.7280247,
                39.7016902
              ],
              [
                44.728335,
                39.702456
              ],
              [
                44.7278993,
                39.702879
              ],
              [
                44.7277422,
                39.7031293
              ],
              [
                44.7275435,
                39.7032864
              ],
              [
                44.7269833,
                39.7035411
              ],
              [
                44.7268451,
                39.7037134
              ],
              [
                44.726645,
                39.7037772
              ],
              [
                44.7263672,
                39.7039958
              ],
              [
                44.726151,
                39.7043078
              ],
              [
                44.7257145,
                39.7047458
              ],
              [
                44.7256387,
                39.7050265
              ],
              [
                44.7251596,
                39.7053269
              ],
              [
                44.7244867,
                39.7058768
              ],
              [
                44.7241477,
                39.7059729
              ],
              [
                44.7239864,
                39.705928
              ],
              [
                44.7236307,
                39.7062722
              ],
              [
                44.723289,
                39.7062912
              ],
              [
                44.7227553,
                39.7068231
              ],
              [
                44.7226148,
                39.70684
              ],
              [
                44.722359,
                39.7070898
              ],
              [
                44.7221382,
                39.7071231
              ],
              [
                44.7219561,
                39.707032
              ],
              [
                44.7215769,
                39.7072841
              ],
              [
                44.7214377,
                39.7074565
              ],
              [
                44.7207539,
                39.7075259
              ],
              [
                44.7203726,
                39.7077166
              ],
              [
                44.7194569,
                39.7076047
              ],
              [
                44.7193002,
                39.7077406
              ],
              [
                44.7189236,
                39.7079108
              ],
              [
                44.7185641,
                39.7080041
              ],
              [
                44.718127,
                39.7082996
              ],
              [
                44.7179481,
                39.7085525
              ],
              [
                44.7175849,
                39.7086827
              ],
              [
                44.7173245,
                39.7088739
              ],
              [
                44.7172655,
                39.7089841
              ],
              [
                44.7170449,
                39.7090962
              ],
              [
                44.7169893,
                39.7093932
              ],
              [
                44.7167724,
                39.7096914
              ],
              [
                44.716755,
                39.7098471
              ],
              [
                44.7164344,
                39.7099593
              ],
              [
                44.71638,
                39.7102858
              ],
              [
                44.7162006,
                39.7103962
              ],
              [
                44.7161258,
                39.7107069
              ],
              [
                44.7158661,
                39.7108181
              ],
              [
                44.7157906,
                39.711082
              ],
              [
                44.7155323,
                39.7112549
              ],
              [
                44.7154939,
                39.711348
              ],
              [
                44.7152946,
                39.7114429
              ],
              [
                44.7151584,
                39.7116761
              ],
              [
                44.7149206,
                39.7118484
              ],
              [
                44.7148842,
                39.712034
              ],
              [
                44.7151479,
                39.7121704
              ],
              [
                44.7150726,
                39.7124494
              ],
              [
                44.715096,
                39.7126347
              ],
              [
                44.714957,
                39.7127131
              ],
              [
                44.7147767,
                39.7127144
              ],
              [
                44.7146787,
                39.7128388
              ],
              [
                44.7145446,
                39.7132585
              ],
              [
                44.7147273,
                39.7134281
              ],
              [
                44.7147757,
                39.7139554
              ],
              [
                44.7149787,
                39.7140616
              ],
              [
                44.7150829,
                39.7142776
              ],
              [
                44.71454,
                39.7142989
              ],
              [
                44.7136417,
                39.7146
              ],
              [
                44.7135003,
                39.7144917
              ],
              [
                44.7132197,
                39.7144465
              ],
              [
                44.7130815,
                39.714587
              ],
              [
                44.7124167,
                39.7145957
              ],
              [
                44.712074,
                39.7143492
              ],
              [
                44.7120333,
                39.7142091
              ],
              [
                44.7118101,
                39.7140724
              ],
              [
                44.7112434,
                39.7139874
              ],
              [
                44.7110392,
                39.7138977
              ],
              [
                44.7112678,
                39.7137845
              ],
              [
                44.7112402,
                39.7133367
              ],
              [
                44.710646,
                39.7133903
              ],
              [
                44.7106283,
                39.7135143
              ],
              [
                44.7107123,
                39.7137762
              ],
              [
                44.7106554,
                39.7139316
              ],
              [
                44.7105371,
                39.7139795
              ],
              [
                44.7103578,
                39.7139509
              ],
              [
                44.7103535,
                39.7137034
              ],
              [
                44.7102716,
                39.7135651
              ],
              [
                44.7100065,
                39.7134901
              ],
              [
                44.7096763,
                39.71323
              ],
              [
                44.7094327,
                39.7132476
              ],
              [
                44.7090454,
                39.7134048
              ],
              [
                44.7087393,
                39.7132378
              ],
              [
                44.7086193,
                39.7132853
              ],
              [
                44.7086208,
                39.7134856
              ],
              [
                44.7084405,
                39.7135182
              ],
              [
                44.7082575,
                39.713212
              ],
              [
                44.7080584,
                39.713399
              ],
              [
                44.7078999,
                39.7133703
              ],
              [
                44.7078155,
                39.7131549
              ],
              [
                44.7074997,
                39.7131591
              ],
              [
                44.7073769,
                39.7130984
              ],
              [
                44.7071955,
                39.7131309
              ],
              [
                44.7070582,
                39.7133023
              ],
              [
                44.7068505,
                39.7130876
              ],
              [
                44.7067289,
                39.7130733
              ],
              [
                44.7064484,
                39.7131685
              ],
              [
                44.7062861,
                39.7131391
              ],
              [
                44.7061632,
                39.713063
              ],
              [
                44.7061804,
                39.7129393
              ],
              [
                44.7051973,
                39.7125646
              ],
              [
                44.7049197,
                39.7125988
              ],
              [
                44.7046045,
                39.7128344
              ],
              [
                44.704251,
                39.7124662
              ],
              [
                44.7038432,
                39.7122696
              ],
              [
                44.7034787,
                39.7119494
              ],
              [
                44.7031813,
                39.7120913
              ],
              [
                44.7030609,
                39.7120461
              ],
              [
                44.7028926,
                39.711584
              ],
              [
                44.7030848,
                39.7111813
              ],
              [
                44.7032649,
                39.7111329
              ],
              [
                44.7036077,
                39.7112377
              ],
              [
                44.7039277,
                39.7112348
              ],
              [
                44.704045,
                39.7110794
              ],
              [
                44.7038634,
                39.7109884
              ],
              [
                44.7036036,
                39.7110061
              ],
              [
                44.7034405,
                39.7108376
              ],
              [
                44.7036759,
                39.7105577
              ],
              [
                44.7036334,
                39.7104191
              ],
              [
                44.7033531,
                39.7104213
              ],
              [
                44.7032085,
                39.710207
              ],
              [
                44.7029862,
                39.7101482
              ],
              [
                44.7028683,
                39.7103041
              ],
              [
                44.7022622,
                39.7100961
              ],
              [
                44.7016027,
                39.7102109
              ],
              [
                44.7013266,
                39.71049
              ],
              [
                44.7008668,
                39.7106169
              ],
              [
                44.700709,
                39.7108486
              ],
              [
                44.7004882,
                39.7109271
              ],
              [
                44.6998234,
                39.710918
              ],
              [
                44.6991494,
                39.7111751
              ],
              [
                44.6989722,
                39.7113317
              ],
              [
                44.6983725,
                39.7115076
              ],
              [
                44.6978986,
                39.7121921
              ],
              [
                44.6977388,
                39.7122865
              ],
              [
                44.6969362,
                39.7122483
              ],
              [
                44.6966384,
                39.7124214
              ],
              [
                44.6964177,
                39.7126248
              ],
              [
                44.6957652,
                39.7125701
              ],
              [
                44.6955155,
                39.7127749
              ],
              [
                44.695371,
                39.7128077
              ],
              [
                44.6948692,
                39.7125953
              ],
              [
                44.6944788,
                39.7126111
              ],
              [
                44.6941604,
                39.7128313
              ],
              [
                44.6936381,
                39.7130705
              ],
              [
                44.693501,
                39.7133507
              ],
              [
                44.6933423,
                39.7135069
              ],
              [
                44.6919574,
                39.7134751
              ],
              [
                44.6917401,
                39.7136624
              ],
              [
                44.6905753,
                39.7136434
              ],
              [
                44.6901904,
                39.7135082
              ],
              [
                44.6901858,
                39.7133533
              ],
              [
                44.6904015,
                39.7131649
              ],
              [
                44.690298,
                39.7129342
              ],
              [
                44.6897902,
                39.7129222
              ],
              [
                44.6891847,
                39.7132871
              ],
              [
                44.6889682,
                39.7133208
              ],
              [
                44.6887246,
                39.7131382
              ],
              [
                44.6885267,
                39.7131868
              ],
              [
                44.6882851,
                39.7133275
              ],
              [
                44.688212,
                39.7139763
              ],
              [
                44.6894485,
                39.7154889
              ],
              [
                44.6901929,
                39.7157599
              ],
              [
                44.6908046,
                39.716355
              ],
              [
                44.6906158,
                39.7170356
              ],
              [
                44.6907189,
                39.7172044
              ],
              [
                44.6907214,
                39.7173589
              ],
              [
                44.6902388,
                39.7173187
              ],
              [
                44.6892609,
                39.7176223
              ],
              [
                44.6890592,
                39.7174841
              ],
              [
                44.6887795,
                39.7174545
              ],
              [
                44.6884567,
                39.7172093
              ],
              [
                44.6875125,
                39.7168158
              ],
              [
                44.687172,
                39.7167728
              ],
              [
                44.6866112,
                39.7162134
              ],
              [
                44.6863072,
                39.7160936
              ],
              [
                44.6862706,
                39.71586
              ],
              [
                44.6858069,
                39.7155715
              ],
              [
                44.6854806,
                39.7155609
              ],
              [
                44.6853173,
                39.715393
              ],
              [
                44.6847723,
                39.7151673
              ],
              [
                44.6844923,
                39.715201
              ],
              [
                44.6840101,
                39.7151288
              ],
              [
                44.6835092,
                39.7151339
              ],
              [
                44.6828661,
                39.7150325
              ],
              [
                44.6824264,
                39.7148207
              ],
              [
                44.681433,
                39.7151961
              ],
              [
                44.6810112,
                39.7152141
              ],
              [
                44.679708,
                39.715089
              ],
              [
                44.6791593,
                39.7146466
              ],
              [
                44.6785349,
                39.7144067
              ],
              [
                44.6780936,
                39.7143492
              ],
              [
                44.6777748,
                39.71443
              ],
              [
                44.677519,
                39.7146955
              ],
              [
                44.6773267,
                39.7151762
              ],
              [
                44.6769492,
                39.715333
              ],
              [
                44.6766079,
                39.7152265
              ],
              [
                44.6764028,
                39.7148566
              ],
              [
                44.6760603,
                39.7146117
              ],
              [
                44.6754782,
                39.7145738
              ],
              [
                44.6748972,
                39.7147528
              ],
              [
                44.6745345,
                39.7146803
              ],
              [
                44.6738098,
                39.7148151
              ],
              [
                44.6736082,
                39.714693
              ],
              [
                44.6735658,
                39.7143988
              ],
              [
                44.6734242,
                39.7142921
              ],
              [
                44.6732032,
                39.7142947
              ],
              [
                44.6725708,
                39.7146231
              ],
              [
                44.6717319,
                39.7149257
              ],
              [
                44.6714361,
                39.7148799
              ],
              [
                44.6711324,
                39.7143264
              ],
              [
                44.6705273,
                39.7146522
              ],
              [
                44.6688547,
                39.7144106
              ],
              [
                44.6684425,
                39.7144881
              ],
              [
                44.6679478,
                39.7148007
              ],
              [
                44.6673928,
                39.7149102
              ],
              [
                44.6673159,
                39.7150486
              ],
              [
                44.6672443,
                39.7157302
              ],
              [
                44.6669112,
                39.7161178
              ],
              [
                44.6666006,
                39.7166594
              ],
              [
                44.6663631,
                39.7168001
              ],
              [
                44.6656619,
                39.7167448
              ],
              [
                44.6652844,
                39.7169178
              ],
              [
                44.6646983,
                39.7178023
              ],
              [
                44.6644201,
                39.7179282
              ],
              [
                44.6636391,
                39.7179668
              ],
              [
                44.6632164,
                39.7177404
              ],
              [
                44.6629782,
                39.7177432
              ],
              [
                44.662506,
                39.718071
              ],
              [
                44.6622492,
                39.7181504
              ],
              [
                44.6617489,
                39.71814
              ],
              [
                44.6612937,
                39.7185134
              ],
              [
                44.6611201,
                39.7188377
              ],
              [
                44.6612273,
                39.7191434
              ],
              [
                44.6611512,
                39.7193283
              ],
              [
                44.6608764,
                39.7196074
              ],
              [
                44.6608992,
                39.719807
              ],
              [
                44.6613834,
                39.7202334
              ],
              [
                44.6614665,
                39.7204947
              ],
              [
                44.6613297,
                39.7207583
              ],
              [
                44.6608737,
                39.7212741
              ],
              [
                44.6605741,
                39.7213546
              ],
              [
                44.6601307,
                39.7212832
              ],
              [
                44.6596496,
                39.7213505
              ],
              [
                44.6594469,
                39.7212761
              ],
              [
                44.6592684,
                39.7213702
              ],
              [
                44.6593165,
                39.7217541
              ],
              [
                44.6591404,
                39.7219556
              ],
              [
                44.6587445,
                39.7221746
              ],
              [
                44.6585906,
                39.7224679
              ],
              [
                44.6580971,
                39.7227951
              ],
              [
                44.6579087,
                39.7233339
              ],
              [
                44.6575601,
                39.7238585
              ],
              [
                44.6570118,
                39.7243847
              ],
              [
                44.6569395,
                39.7247222
              ],
              [
                44.6561664,
                39.7252937
              ],
              [
                44.6554432,
                39.7253323
              ],
              [
                44.6551853,
                39.725473
              ],
              [
                44.6550518,
                39.7257195
              ],
              [
                44.6549246,
                39.7262269
              ],
              [
                44.6544556,
                39.7266155
              ],
              [
                44.6541184,
                39.7266805
              ],
              [
                44.6539674,
                39.7269286
              ],
              [
                44.6537709,
                39.7270845
              ],
              [
                44.6533112,
                39.7272422
              ],
              [
                44.6525808,
                39.7276503
              ],
              [
                44.6523617,
                39.7276987
              ],
              [
                44.6521542,
                39.7272546
              ],
              [
                44.6519744,
                39.7272717
              ],
              [
                44.6514373,
                39.7274463
              ],
              [
                44.6502563,
                39.7274263
              ],
              [
                44.6499997,
                39.7276137
              ],
              [
                44.6497454,
                39.7279552
              ],
              [
                44.6494273,
                39.7280655
              ],
              [
                44.6489463,
                39.7279611
              ],
              [
                44.6485398,
                39.7275033
              ],
              [
                44.6481986,
                39.7273525
              ],
              [
                44.6478404,
                39.7273554
              ],
              [
                44.6476247,
                39.7275413
              ],
              [
                44.6478356,
                39.7283231
              ],
              [
                44.6477191,
                39.7285395
              ],
              [
                44.6474434,
                39.7286633
              ],
              [
                44.6470066,
                39.7286346
              ],
              [
                44.6462444,
                39.7288011
              ],
              [
                44.6461788,
                39.7289266
              ],
              [
                44.6463858,
                39.7290491
              ],
              [
                44.6467655,
                39.7291837
              ],
              [
                44.646817,
                39.7294154
              ],
              [
                44.646649,
                39.7296347
              ],
              [
                44.6467343,
                39.7299392
              ],
              [
                44.6467301,
                39.7304639
              ],
              [
                44.6465632,
                39.7309677
              ],
              [
                44.645802,
                39.7319426
              ],
              [
                44.64573,
                39.7323849
              ],
              [
                44.6454123,
                39.7324859
              ],
              [
                44.6452713,
                39.7326588
              ],
              [
                44.6451447,
                39.7327334
              ],
              [
                44.6444712,
                39.7326962
              ],
              [
                44.6441051,
                39.7327499
              ],
              [
                44.6438848,
                39.7328989
              ],
              [
                44.6435163,
                39.7327435
              ],
              [
                44.6429982,
                39.7331646
              ],
              [
                44.6426849,
                39.7335622
              ],
              [
                44.6421469,
                39.7338543
              ],
              [
                44.6419289,
                39.7340875
              ],
              [
                44.6420142,
                39.7343771
              ],
              [
                44.6426362,
                39.73448
              ],
              [
                44.6429929,
                39.7347801
              ],
              [
                44.6430215,
                39.7355136
              ],
              [
                44.6427245,
                39.73581
              ],
              [
                44.6425867,
                39.7361172
              ],
              [
                44.6417165,
                39.7363948
              ],
              [
                44.641179,
                39.7366697
              ],
              [
                44.6410114,
                39.7371367
              ],
              [
                44.641112,
                39.7374415
              ],
              [
                44.6410403,
                39.7379192
              ],
              [
                44.6414923,
                39.7383063
              ],
              [
                44.6409328,
                39.7391051
              ],
              [
                44.6405394,
                39.7393405
              ],
              [
                44.64026,
                39.7397596
              ],
              [
                44.6396354,
                39.7403613
              ],
              [
                44.6394338,
                39.7407073
              ],
              [
                44.6389453,
                39.741007
              ],
              [
                44.638566,
                39.7407935
              ],
              [
                44.638108,
                39.7408703
              ],
              [
                44.637778,
                39.7411811
              ],
              [
                44.6376396,
                39.741451
              ],
              [
                44.6374662,
                39.7416008
              ],
              [
                44.6369943,
                39.7412953
              ],
              [
                44.6367374,
                39.7413877
              ],
              [
                44.6365458,
                39.7415398
              ],
              [
                44.6361232,
                39.7414776
              ],
              [
                44.6358573,
                39.7415998
              ],
              [
                44.6354908,
                39.7421257
              ],
              [
                44.6353991,
                39.7425191
              ],
              [
                44.6350281,
                39.7429248
              ],
              [
                44.6350111,
                39.7433019
              ],
              [
                44.6345535,
                39.7434652
              ],
              [
                44.6330688,
                39.7433448
              ],
              [
                44.6328774,
                39.7433961
              ],
              [
                44.6325605,
                39.7436328
              ],
              [
                44.6323916,
                39.7442107
              ],
              [
                44.6321398,
                39.7443721
              ],
              [
                44.6316158,
                39.7444506
              ],
              [
                44.6314714,
                39.744391
              ],
              [
                44.6314521,
                39.7441464
              ],
              [
                44.6312754,
                39.7440504
              ],
              [
                44.6307025,
                39.7440934
              ],
              [
                44.6304987,
                39.7442788
              ],
              [
                44.6305693,
                39.7447299
              ],
              [
                44.6308771,
                39.7450688
              ],
              [
                44.6308829,
                39.7454229
              ],
              [
                44.6301938,
                39.7460157
              ],
              [
                44.6296892,
                39.7462409
              ],
              [
                44.6292814,
                39.7466013
              ],
              [
                44.6291262,
                39.7468868
              ],
              [
                44.6292084,
                39.7470848
              ],
              [
                44.6297061,
                39.7472866
              ],
              [
                44.6298206,
                39.7474678
              ],
              [
                44.6298262,
                39.7478086
              ],
              [
                44.6301189,
                39.7482167
              ],
              [
                44.6301542,
                39.7484454
              ],
              [
                44.6300151,
                39.7486785
              ],
              [
                44.6300972,
                39.7488376
              ],
              [
                44.6305786,
                39.749116
              ],
              [
                44.6309686,
                39.7494548
              ],
              [
                44.630924,
                39.749651
              ],
              [
                44.6306236,
                39.7498442
              ],
              [
                44.6305418,
                39.7500772
              ],
              [
                44.6307839,
                39.7503062
              ],
              [
                44.6313412,
                39.7503324
              ],
              [
                44.6315434,
                39.7509911
              ],
              [
                44.6315159,
                39.7512615
              ],
              [
                44.6317282,
                39.7515537
              ],
              [
                44.6316522,
                39.7518013
              ],
              [
                44.6313365,
                39.7519658
              ],
              [
                44.63118,
                39.7521142
              ],
              [
                44.6311367,
                39.7523955
              ],
              [
                44.6312373,
                39.7527124
              ],
              [
                44.6315269,
                39.7529053
              ],
              [
                44.632409,
                39.7533128
              ],
              [
                44.6325399,
                39.7535317
              ],
              [
                44.6325766,
                39.7539095
              ],
              [
                44.6324239,
                39.7552903
              ],
              [
                44.6324344,
                39.7558674
              ],
              [
                44.6322932,
                39.7560367
              ],
              [
                44.6319917,
                39.7561072
              ],
              [
                44.6310834,
                39.7558898
              ],
              [
                44.6304454,
                39.7558523
              ],
              [
                44.6300177,
                39.7559789
              ],
              [
                44.629639,
                39.7562287
              ],
              [
                44.6295789,
                39.7563992
              ],
              [
                44.6296622,
                39.7566185
              ],
              [
                44.6300803,
                39.7568837
              ],
              [
                44.6307637,
                39.7577544
              ],
              [
                44.6308836,
                39.7581871
              ],
              [
                44.630849,
                39.7585192
              ],
              [
                44.6303548,
                39.7589161
              ],
              [
                44.6297732,
                39.759101
              ],
              [
                44.629225,
                39.7591011
              ],
              [
                44.628592,
                39.7589745
              ],
              [
                44.6281292,
                39.7588189
              ],
              [
                44.6278369,
                39.7586389
              ],
              [
                44.6274116,
                39.7586034
              ],
              [
                44.6272229,
                39.7587151
              ],
              [
                44.6271618,
                39.7588505
              ],
              [
                44.6272116,
                39.7590223
              ],
              [
                44.6275053,
                39.7592767
              ],
              [
                44.627555,
                39.7594608
              ],
              [
                44.6274254,
                39.7596225
              ],
              [
                44.6269086,
                39.7598374
              ],
              [
                44.6266217,
                39.759877
              ],
              [
                44.6262748,
                39.7600635
              ],
              [
                44.6259179,
                39.760555
              ],
              [
                44.6259396,
                39.7608238
              ],
              [
                44.6260857,
                39.761042
              ],
              [
                44.626533,
                39.7612933
              ],
              [
                44.6266795,
                39.7614511
              ],
              [
                44.6267314,
                39.7617432
              ],
              [
                44.6266701,
                39.7619865
              ],
              [
                44.6263857,
                39.762206
              ],
              [
                44.6259477,
                39.7623132
              ],
              [
                44.6253363,
                39.7625132
              ],
              [
                44.6250325,
                39.7628241
              ],
              [
                44.6243359,
                39.7633153
              ],
              [
                44.6240566,
                39.7636218
              ],
              [
                44.6239688,
                39.764834
              ],
              [
                44.6238136,
                39.7651651
              ],
              [
                44.6235754,
                39.7655507
              ],
              [
                44.623128,
                39.7660133
              ],
              [
                44.6229045,
                39.7660656
              ],
              [
                44.6218899,
                39.7660495
              ],
              [
                44.6216702,
                39.7661607
              ],
              [
                44.6216185,
                39.7666352
              ],
              [
                44.621611,
                39.767001
              ],
              [
                44.6216324,
                39.768714
              ],
              [
                44.6207671,
                39.7710847
              ],
              [
                44.6203215,
                39.7721691
              ],
              [
                44.6199361,
                39.7728824
              ],
              [
                44.6195401,
                39.7745115
              ],
              [
                44.6183103,
                39.7758958
              ],
              [
                44.6179085,
                39.7763933
              ],
              [
                44.6176033,
                39.7772965
              ],
              [
                44.6164358,
                39.7794687
              ],
              [
                44.6157975,
                39.7802061
              ],
              [
                44.6154058,
                39.7805716
              ],
              [
                44.6156085,
                39.7810458
              ],
              [
                44.6155444,
                39.781825
              ],
              [
                44.6151065,
                39.7821587
              ],
              [
                44.614695,
                39.7824624
              ],
              [
                44.6142661,
                39.7821524
              ],
              [
                44.6137719,
                39.7819568
              ],
              [
                44.6133379,
                39.7816502
              ],
              [
                44.6117858,
                39.7808031
              ],
              [
                44.6093367,
                39.7790538
              ],
              [
                44.6019546,
                39.7742035
              ],
              [
                44.591394,
                39.7670915
              ],
              [
                44.5850062,
                39.7655254
              ],
              [
                44.5842559,
                39.7639334
              ],
              [
                44.5811353,
                39.7621147
              ],
              [
                44.5768476,
                39.7575
              ],
              [
                44.5657783,
                39.7503595
              ],
              [
                44.550833,
                39.7395887
              ],
              [
                44.5306499,
                39.7258495
              ],
              [
                44.5198374,
                39.7191695
              ],
              [
                44.5143069,
                39.7156554
              ],
              [
                44.4933296,
                39.7018495
              ],
              [
                44.4855258,
                39.6946937
              ],
              [
                44.4671974,
                39.6841019
              ],
              [
                44.4686771,
                39.6823601
              ],
              [
                44.4690995,
                39.6818944
              ],
              [
                44.4697035,
                39.6815796
              ],
              [
                44.4701248,
                39.68115
              ],
              [
                44.4717751,
                39.6806598
              ],
              [
                44.4726076,
                39.6801849
              ],
              [
                44.4728261,
                39.6799214
              ],
              [
                44.4731914,
                39.6797715
              ],
              [
                44.4735947,
                39.6794335
              ],
              [
                44.4744315,
                39.6782942
              ],
              [
                44.4748896,
                39.6769076
              ],
              [
                44.4748029,
                39.6763211
              ],
              [
                44.4753546,
                39.6756125
              ],
              [
                44.4754925,
                39.6747302
              ],
              [
                44.475765,
                39.6741418
              ],
              [
                44.4766053,
                39.6736169
              ],
              [
                44.4771168,
                39.6726956
              ],
              [
                44.4816613,
                39.6714235
              ],
              [
                44.4822345,
                39.6707317
              ],
              [
                44.4823908,
                39.6699882
              ],
              [
                44.4825615,
                39.6686155
              ],
              [
                44.4823234,
                39.6680377
              ],
              [
                44.4823507,
                39.6675177
              ],
              [
                44.4823957,
                39.6671924
              ],
              [
                44.4825098,
                39.666986
              ],
              [
                44.4828986,
                39.6664269
              ],
              [
                44.4830713,
                39.6653842
              ],
              [
                44.4831356,
                39.6642042
              ],
              [
                44.4830555,
                39.6636997
              ],
              [
                44.4833148,
                39.6631727
              ],
              [
                44.4834071,
                39.6625401
              ],
              [
                44.4834962,
                39.6609843
              ],
              [
                44.4836474,
                39.6597056
              ],
              [
                44.4837687,
                39.6582667
              ],
              [
                44.4838831,
                39.6575206
              ],
              [
                44.4839036,
                39.6567261
              ],
              [
                44.4836668,
                39.6560286
              ],
              [
                44.4836876,
                39.6556746
              ],
              [
                44.4838938,
                39.6551593
              ],
              [
                44.4838745,
                39.6546204
              ],
              [
                44.4838866,
                39.6536394
              ],
              [
                44.4836755,
                39.6524601
              ],
              [
                44.4837006,
                39.6516801
              ],
              [
                44.4838769,
                39.6508738
              ],
              [
                44.4840141,
                39.6498267
              ],
              [
                44.4846605,
                39.6487957
              ],
              [
                44.4849283,
                39.6483304
              ],
              [
                44.4849825,
                39.6478299
              ],
              [
                44.4849871,
                39.6471987
              ],
              [
                44.4850752,
                39.6463145
              ],
              [
                44.48528,
                39.6461389
              ],
              [
                44.4854914,
                39.6458103
              ],
              [
                44.485909,
                39.645262
              ],
              [
                44.4863848,
                39.6446042
              ],
              [
                44.4869352,
                39.6440183
              ],
              [
                44.4870541,
                39.643894
              ],
              [
                44.4871135,
                39.6437168
              ],
              [
                44.4870842,
                39.6435108
              ],
              [
                44.4869905,
                39.6428619
              ],
              [
                44.4867757,
                39.6418749
              ],
              [
                44.4865331,
                39.6407679
              ],
              [
                44.4864786,
                39.6404677
              ],
              [
                44.4865082,
                39.6398222
              ],
              [
                44.4862147,
                39.6381673
              ],
              [
                44.4860762,
                39.6377639
              ],
              [
                44.4859165,
                39.6374642
              ],
              [
                44.4857716,
                39.637121
              ],
              [
                44.4855099,
                39.6361918
              ],
              [
                44.4854151,
                39.6356489
              ],
              [
                44.4855771,
                39.6349843
              ],
              [
                44.485528,
                39.6347135
              ],
              [
                44.4853076,
                39.6339558
              ],
              [
                44.4850703,
                39.632927
              ],
              [
                44.4848757,
                39.6319715
              ],
              [
                44.4845317,
                39.630775
              ],
              [
                44.4842601,
                39.6296316
              ],
              [
                44.484549,
                39.628242
              ],
              [
                44.483656,
                39.62478
              ],
              [
                44.482632,
                39.62132
              ],
              [
                44.481596,
                39.616686
              ],
              [
                44.481117,
                39.614956
              ],
              [
                44.480148,
                39.610424
              ],
              [
                44.477627,
                39.609012
              ],
              [
                44.477224,
                39.608249
              ],
              [
                44.474504,
                39.606634
              ],
              [
                44.466464,
                39.600665
              ],
              [
                44.465403,
                39.600059
              ],
              [
                44.46487,
                39.599502
              ],
              [
                44.462333,
                39.596356
              ],
              [
                44.460799,
                39.59458
              ],
              [
                44.45953,
                39.592854
              ],
              [
                44.453325,
                39.585344
              ],
              [
                44.449991,
                39.581489
              ],
              [
                44.446855,
                39.577632
              ],
              [
                44.445458,
                39.576314
              ],
              [
                44.443066,
                39.574339
              ],
              [
                44.441672,
                39.573276
              ],
              [
                44.440214,
                39.57252
              ],
              [
                44.439224,
                39.572372
              ],
              [
                44.437972,
                39.57243
              ],
              [
                44.435925,
                39.572034
              ],
              [
                44.431694,
                39.570732
              ],
              [
                44.429183,
                39.570134
              ],
              [
                44.427861,
                39.569733
              ],
              [
                44.426074,
                39.568876
              ],
              [
                44.42442,
                39.568223
              ],
              [
                44.422106,
                39.567573
              ],
              [
                44.422694,
                39.567009
              ],
              [
                44.423546,
                39.566392
              ],
              [
                44.424136,
                39.566032
              ],
              [
                44.424394,
                39.56547
              ],
              [
                44.423658,
                39.564301
              ],
              [
                44.42093,
                39.561461
              ],
              [
                44.418939,
                39.559993
              ],
              [
                44.418073,
                39.558979
              ],
              [
                44.416204,
                39.55644
              ],
              [
                44.4163109,
                39.5551168
              ],
              [
                44.417966,
                39.554493
              ],
              [
                44.419672,
                39.553668
              ],
              [
                44.420518,
                39.552491
              ],
              [
                44.420707,
                39.551572
              ],
              [
                44.420836,
                39.551265
              ],
              [
                44.421621,
                39.550649
              ],
              [
                44.422408,
                39.550186
              ],
              [
                44.423257,
                39.549417
              ],
              [
                44.423782,
                39.549108
              ],
              [
                44.423646,
                39.548701
              ],
              [
                44.423312,
                39.548193
              ],
              [
                44.423635,
                39.547528
              ],
              [
                44.424421,
                39.546963
              ],
              [
                44.424746,
                39.546452
              ],
              [
                44.425853,
                39.545069
              ],
              [
                44.426242,
                39.544404
              ],
              [
                44.426562,
                39.543383
              ],
              [
                44.426615,
                39.541955
              ],
              [
                44.426276,
                39.540886
              ],
              [
                44.426136,
                39.540071
              ],
              [
                44.42633,
                39.539662
              ],
              [
                44.427046,
                39.538639
              ],
              [
                44.427107,
                39.538129
              ],
              [
                44.426381,
                39.53798
              ],
              [
                44.425322,
                39.537527
              ],
              [
                44.425375,
                39.53615
              ],
              [
                44.425227,
                39.534315
              ],
              [
                44.425217,
                39.533296
              ],
              [
                44.425076,
                39.532328
              ],
              [
                44.425667,
                39.53207
              ],
              [
                44.426062,
                39.532017
              ],
              [
                44.426587,
                39.531861
              ],
              [
                44.427177,
                39.531501
              ],
              [
                44.4294,
                39.529704
              ],
              [
                44.429525,
                39.52899
              ],
              [
                44.429581,
                39.527868
              ],
              [
                44.429707,
                39.527255
              ],
              [
                44.430938,
                39.525056
              ],
              [
                44.432178,
                39.523775
              ],
              [
                44.432829,
                39.522955
              ],
              [
                44.433813,
                39.522542
              ],
              [
                44.434994,
                39.521975
              ],
              [
                44.435451,
                39.521564
              ],
              [
                44.435906,
                39.52095
              ],
              [
                44.435568,
                39.519983
              ],
              [
                44.435563,
                39.519473
              ],
              [
                44.434963,
                39.518763
              ],
              [
                44.434565,
                39.518408
              ],
              [
                44.433439,
                39.517752
              ],
              [
                44.43284,
                39.517041
              ],
              [
                44.432766,
                39.516277
              ],
              [
                44.43282,
                39.515002
              ],
              [
                44.432805,
                39.51332
              ],
              [
                44.432722,
                39.511485
              ],
              [
                44.43278,
                39.51072
              ],
              [
                44.432906,
                39.510107
              ],
              [
                44.433358,
                39.509085
              ],
              [
                44.43461,
                39.509129
              ],
              [
                44.43553,
                39.508971
              ],
              [
                44.437504,
                39.508756
              ],
              [
                44.438423,
                39.508394
              ],
              [
                44.438941,
                39.507525
              ],
              [
                44.439657,
                39.506552
              ],
              [
                44.440367,
                39.505069
              ],
              [
                44.440099,
                39.504561
              ],
              [
                44.439166,
                39.503445
              ],
              [
                44.437974,
                39.502687
              ],
              [
                44.437639,
                39.502128
              ],
              [
                44.438359,
                39.501614
              ],
              [
                44.439737,
                39.501147
              ],
              [
                44.438742,
                39.500337
              ],
              [
                44.4385377,
                39.4998862
              ],
              [
                44.4358338,
                39.4977231
              ],
              [
                44.4338735,
                39.4957628
              ],
              [
                44.4334003,
                39.4932618
              ],
              [
                44.4329948,
                39.4925182
              ],
              [
                44.4292094,
                39.4905579
              ],
              [
                44.4271139,
                39.488868
              ],
              [
                44.4252212,
                39.4880568
              ],
              [
                44.4243424,
                39.4880568
              ],
              [
                44.420557,
                39.4867725
              ],
              [
                44.4187995,
                39.4860965
              ],
              [
                44.4175827,
                39.4851502
              ],
              [
                44.4166364,
                39.4834602
              ],
              [
                44.4158928,
                39.4824463
              ],
              [
                44.4152169,
                39.480486
              ],
              [
                44.4144057,
                39.4790665
              ],
              [
                44.4138649,
                39.4779173
              ],
              [
                44.413189,
                39.4769034
              ],
              [
                44.4126482,
                39.4755514
              ],
              [
                44.4119722,
                39.4748755
              ],
              [
                44.4102147,
                39.4742671
              ],
              [
                44.4088515,
                39.4731494
              ],
              [
                44.4084339,
                39.4711492
              ],
              [
                44.4101492,
                39.470191
              ],
              [
                44.4119608,
                39.4690779
              ],
              [
                44.4135659,
                39.4686742
              ],
              [
                44.4145305,
                39.4677494
              ],
              [
                44.4162571,
                39.4670662
              ],
              [
                44.4165099,
                39.4668178
              ],
              [
                44.4166358,
                39.4665536
              ],
              [
                44.4174639,
                39.4665134
              ],
              [
                44.4179649,
                39.4662993
              ],
              [
                44.4188621,
                39.4655628
              ],
              [
                44.4193973,
                39.4655636
              ],
              [
                44.4197347,
                39.4653807
              ],
              [
                44.4203218,
                39.4648206
              ],
              [
                44.4203568,
                39.4642663
              ],
              [
                44.4202877,
                39.4638756
              ],
              [
                44.4202958,
                39.462911
              ],
              [
                44.4203727,
                39.4622861
              ],
              [
                44.4207484,
                39.4617226
              ],
              [
                44.4211474,
                39.4613086
              ],
              [
                44.4212721,
                39.4610456
              ],
              [
                44.4216113,
                39.4607987
              ],
              [
                44.4218229,
                39.460454
              ],
              [
                44.4219045,
                39.4600416
              ],
              [
                44.4221959,
                39.4597076
              ],
              [
                44.4222298,
                39.4593277
              ],
              [
                44.4218209,
                39.4591006
              ],
              [
                44.4217445,
                39.45833
              ],
              [
                44.4219537,
                39.4580987
              ],
              [
                44.4221162,
                39.4575063
              ],
              [
                44.4220883,
                39.4567632
              ],
              [
                44.422863,
                39.4556363
              ],
              [
                44.4228156,
                39.4553586
              ],
              [
                44.4225979,
                39.4551161
              ],
              [
                44.4226137,
                39.4547726
              ],
              [
                44.4229095,
                39.4544878
              ],
              [
                44.4229924,
                39.4542047
              ],
              [
                44.4229247,
                39.4538241
              ],
              [
                44.4229647,
                39.4535584
              ],
              [
                44.424276,
                39.4529387
              ],
              [
                44.4245273,
                39.4526644
              ],
              [
                44.4247918,
                39.4517011
              ],
              [
                44.4245311,
                39.451369
              ],
              [
                44.4245709,
                39.4511534
              ],
              [
                44.4248479,
                39.4511197
              ],
              [
                44.4251021,
                39.45097
              ],
              [
                44.4251004,
                39.450854
              ],
              [
                44.4249052,
                39.4506392
              ],
              [
                44.4247679,
                39.449948
              ],
              [
                44.4242743,
                39.4497063
              ],
              [
                44.4241649,
                39.4494931
              ],
              [
                44.4241406,
                39.4492293
              ],
              [
                44.4244577,
                39.4490626
              ],
              [
                44.4245169,
                39.4487162
              ],
              [
                44.4244905,
                39.4483373
              ],
              [
                44.4246569,
                39.4480057
              ],
              [
                44.4251639,
                39.4473297
              ],
              [
                44.425057,
                39.4467288
              ],
              [
                44.425277,
                39.4465956
              ],
              [
                44.4253774,
                39.446423
              ],
              [
                44.4250838,
                39.4462016
              ],
              [
                44.4251668,
                39.4460834
              ],
              [
                44.4254721,
                39.4459904
              ],
              [
                44.4258634,
                39.4458015
              ],
              [
                44.4259796,
                39.4455362
              ],
              [
                44.4262861,
                39.4454414
              ],
              [
                44.4265763,
                39.445412
              ],
              [
                44.426852,
                39.445581
              ],
              [
                44.4270049,
                39.4455264
              ],
              [
                44.4271877,
                39.4451808
              ],
              [
                44.4273251,
                39.4451351
              ],
              [
                44.4276003,
                39.445278
              ],
              [
                44.4279154,
                39.4452745
              ],
              [
                44.4280142,
                39.4452063
              ],
              [
                44.4279816,
                39.4449733
              ],
              [
                44.4281241,
                39.4448839
              ],
              [
                44.4284528,
                39.4449025
              ],
              [
                44.4285645,
                39.4448645
              ],
              [
                44.4286332,
                39.4447669
              ],
              [
                44.4288068,
                39.4447484
              ],
              [
                44.429679,
                39.4443467
              ],
              [
                44.430146,
                39.4443072
              ],
              [
                44.4303043,
                39.4442219
              ],
              [
                44.4303121,
                39.4440499
              ],
              [
                44.4305588,
                39.4436934
              ],
              [
                44.430704,
                39.4436242
              ],
              [
                44.4308777,
                39.4434168
              ],
              [
                44.4313248,
                39.4431449
              ],
              [
                44.4320998,
                39.4428202
              ],
              [
                44.4323825,
                39.4429127
              ],
              [
                44.4326422,
                39.442905
              ],
              [
                44.4328142,
                39.44282
              ],
              [
                44.4328572,
                39.4427251
              ],
              [
                44.4324418,
                39.4424998
              ],
              [
                44.4323896,
                39.442372
              ],
              [
                44.4322731,
                39.442295
              ],
              [
                44.4319333,
                39.4422475
              ],
              [
                44.4318956,
                39.4421308
              ],
              [
                44.4319943,
                39.4419572
              ],
              [
                44.4319601,
                39.4415618
              ],
              [
                44.4320816,
                39.4415057
              ],
              [
                44.4322671,
                39.4415005
              ],
              [
                44.4324651,
                39.4417039
              ],
              [
                44.4325291,
                39.4416927
              ],
              [
                44.4325702,
                39.4416208
              ],
              [
                44.4324818,
                39.4413041
              ],
              [
                44.432552,
                39.4412656
              ],
              [
                44.43269,
                39.4413467
              ],
              [
                44.4327319,
                39.4413025
              ],
              [
                44.4326127,
                39.441112
              ],
              [
                44.4325331,
                39.4410689
              ],
              [
                44.4322902,
                39.4410708
              ],
              [
                44.4322815,
                39.441
              ],
              [
                44.432437,
                39.4409279
              ],
              [
                44.4324085,
                39.4408943
              ],
              [
                44.4323155,
                39.4409122
              ],
              [
                44.4323825,
                39.4406931
              ],
              [
                44.432326,
                39.4406183
              ],
              [
                44.4320311,
                39.4404887
              ],
              [
                44.4319661,
                39.4404144
              ],
              [
                44.4320156,
                39.4401264
              ],
              [
                44.4318449,
                39.4398103
              ],
              [
                44.4318414,
                39.4395569
              ],
              [
                44.4320789,
                39.4394975
              ],
              [
                44.4325437,
                39.4396021
              ],
              [
                44.4326058,
                39.4395148
              ],
              [
                44.4325829,
                39.4394203
              ],
              [
                44.4324519,
                39.4393433
              ],
              [
                44.432356,
                39.439188
              ],
              [
                44.4323769,
                39.4391265
              ],
              [
                44.4325143,
                39.4390985
              ],
              [
                44.4324763,
                39.4388933
              ],
              [
                44.4326424,
                39.4387089
              ],
              [
                44.4325834,
                39.4386199
              ],
              [
                44.4322618,
                39.4384988
              ],
              [
                44.4322611,
                39.4384206
              ],
              [
                44.4326384,
                39.4381316
              ],
              [
                44.432681,
                39.4379734
              ],
              [
                44.4323448,
                39.4380386
              ],
              [
                44.4322421,
                39.4379833
              ],
              [
                44.4324083,
                39.4377728
              ],
              [
                44.4326558,
                39.4377257
              ],
              [
                44.43272,
                39.4376181
              ],
              [
                44.4325078,
                39.4375691
              ],
              [
                44.4325203,
                39.4373654
              ],
              [
                44.4324761,
                39.4373146
              ],
              [
                44.432243,
                39.4373847
              ],
              [
                44.4322554,
                39.4371571
              ],
              [
                44.4324136,
                39.4369639
              ],
              [
                44.4324098,
                39.4367691
              ],
              [
                44.4323367,
                39.4367408
              ],
              [
                44.4320615,
                39.4368027
              ],
              [
                44.4319752,
                39.4369334
              ],
              [
                44.4319018,
                39.4369268
              ],
              [
                44.4318629,
                39.4367664
              ],
              [
                44.4316687,
                39.4365579
              ],
              [
                44.4316754,
                39.4364971
              ],
              [
                44.4315334,
                39.4363177
              ],
              [
                44.4315401,
                39.4362517
              ],
              [
                44.4318371,
                39.4360026
              ],
              [
                44.4318783,
                39.4358631
              ],
              [
                44.4315286,
                39.4357144
              ],
              [
                44.4313608,
                39.4357469
              ],
              [
                44.4311927,
                39.4356863
              ],
              [
                44.431258,
                39.4354173
              ],
              [
                44.4314212,
                39.4352041
              ],
              [
                44.4312731,
                39.4350779
              ],
              [
                44.4306847,
                39.4350057
              ],
              [
                44.4306612,
                39.4349553
              ],
              [
                44.4307528,
                39.4348362
              ],
              [
                44.4310745,
                39.4346642
              ],
              [
                44.4311022,
                39.434568
              ],
              [
                44.4310347,
                39.4345174
              ],
              [
                44.430636,
                39.4345651
              ],
              [
                44.4307332,
                39.4343024
              ],
              [
                44.4306734,
                39.4342629
              ],
              [
                44.4304306,
                39.4342649
              ],
              [
                44.4302438,
                39.4344488
              ],
              [
                44.4298893,
                39.4346059
              ],
              [
                44.4297212,
                39.4343315
              ],
              [
                44.4297567,
                39.4341041
              ],
              [
                44.4296998,
                39.4340657
              ],
              [
                44.4295128,
                39.434076
              ],
              [
                44.4294562,
                39.4340266
              ],
              [
                44.4294393,
                39.4339254
              ],
              [
                44.4293037,
                39.43376
              ],
              [
                44.4292773,
                39.4335742
              ],
              [
                44.4291723,
                39.433499
              ],
              [
                44.4291357,
                39.4334212
              ],
              [
                44.4291961,
                39.4332514
              ],
              [
                44.4291044,
                39.4329757
              ],
              [
                44.4289672,
                39.4329593
              ],
              [
                44.4286821,
                39.432768
              ],
              [
                44.4288371,
                39.4326171
              ],
              [
                44.4287924,
                39.4324929
              ],
              [
                44.4282911,
                39.4324782
              ],
              [
                44.4281157,
                39.4323399
              ],
              [
                44.4279277,
                39.4323158
              ],
              [
                44.4278887,
                39.4322194
              ],
              [
                44.428087,
                39.4320644
              ],
              [
                44.4281345,
                39.431967
              ],
              [
                44.4279127,
                39.4318681
              ],
              [
                44.4277395,
                39.4319141
              ],
              [
                44.4275955,
                39.4318253
              ],
              [
                44.4276829,
                39.4316666
              ],
              [
                44.4277064,
                39.431443
              ],
              [
                44.4275789,
                39.4312544
              ],
              [
                44.4275811,
                39.4305672
              ],
              [
                44.4274664,
                39.4303178
              ],
              [
                44.4272513,
                39.430117
              ],
              [
                44.4272463,
                39.4300277
              ],
              [
                44.4274028,
                39.4298095
              ],
              [
                44.4273821,
                39.4297488
              ],
              [
                44.4271084,
                39.4292798
              ],
              [
                44.4267302,
                39.4288716
              ],
              [
                44.4267921,
                39.428345
              ],
              [
                44.4267602,
                39.4281766
              ],
              [
                44.4264328,
                39.4278523
              ],
              [
                44.4264217,
                39.4276997
              ],
              [
                44.426269,
                39.4277235
              ],
              [
                44.4261579,
                39.4276678
              ],
              [
                44.4261473,
                39.4275431
              ],
              [
                44.4260167,
                39.4273166
              ],
              [
                44.4258614,
                39.4272665
              ],
              [
                44.4258307,
                39.4269977
              ],
              [
                44.4259175,
                39.4268278
              ],
              [
                44.4258729,
                39.4266361
              ],
              [
                44.4260908,
                39.4261887
              ],
              [
                44.425969,
                39.4260336
              ],
              [
                44.4260122,
                39.4259004
              ],
              [
                44.4261175,
                39.4258102
              ],
              [
                44.4262724,
                39.4252794
              ],
              [
                44.4262451,
                39.4252146
              ],
              [
                44.4261191,
                39.4252129
              ],
              [
                44.4259559,
                39.4251231
              ],
              [
                44.426039,
                39.4249402
              ],
              [
                44.4259996,
                39.4245718
              ],
              [
                44.4258884,
                39.4244543
              ],
              [
                44.4261471,
                39.4239342
              ],
              [
                44.4261701,
                39.4237496
              ],
              [
                44.4261387,
                39.4236862
              ],
              [
                44.4257325,
                39.4236763
              ],
              [
                44.4255892,
                39.4236208
              ],
              [
                44.4254089,
                39.4234846
              ],
              [
                44.4253639,
                39.4233916
              ],
              [
                44.4252433,
                39.4233677
              ],
              [
                44.4251572,
                39.423399
              ],
              [
                44.4252029,
                39.4230282
              ],
              [
                44.4248927,
                39.4226587
              ],
              [
                44.4249323,
                39.422494
              ],
              [
                44.4247864,
                39.4220394
              ],
              [
                44.4248292,
                39.4219343
              ],
              [
                44.4251687,
                39.4216055
              ],
              [
                44.4250658,
                39.4213863
              ],
              [
                44.4252202,
                39.421189
              ],
              [
                44.4252576,
                39.4210235
              ],
              [
                44.4251676,
                39.4206013
              ],
              [
                44.4251764,
                39.4202023
              ],
              [
                44.4252599,
                39.4200254
              ],
              [
                44.4252406,
                39.419956
              ],
              [
                44.4249253,
                39.4199395
              ],
              [
                44.4248112,
                39.4198069
              ],
              [
                44.4249039,
                39.4196591
              ],
              [
                44.4249512,
                39.4190938
              ],
              [
                44.4250752,
                39.4189331
              ],
              [
                44.4250501,
                39.4188696
              ],
              [
                44.424876,
                39.4188454
              ],
              [
                44.4244311,
                39.4185384
              ],
              [
                44.4242593,
                39.4176313
              ],
              [
                44.4236815,
                39.417289
              ],
              [
                44.4235776,
                39.4170985
              ],
              [
                44.4231187,
                39.4144764
              ],
              [
                44.4219571,
                39.4116039
              ],
              [
                44.4160923,
                39.4118127
              ],
              [
                44.4144922,
                39.4117936
              ],
              [
                44.4126842,
                39.4119139
              ],
              [
                44.4116232,
                39.4120826
              ],
              [
                44.4104286,
                39.412113
              ],
              [
                44.4079896,
                39.4124349
              ],
              [
                44.3987934,
                39.4128841
              ],
              [
                44.3972092,
                39.4125599
              ],
              [
                44.3905602,
                39.4115083
              ],
              [
                44.3893429,
                39.4128236
              ],
              [
                44.3855811,
                39.4129925
              ],
              [
                44.3818202,
                39.4118035
              ],
              [
                44.379337,
                39.4117607
              ],
              [
                44.3784605,
                39.4120152
              ],
              [
                44.3781219,
                39.4119264
              ],
              [
                44.377915,
                39.4118721
              ],
              [
                44.3772132,
                39.4116879
              ],
              [
                44.3770211,
                39.4116375
              ],
              [
                44.3764159,
                39.4114146
              ],
              [
                44.3762345,
                39.4113613
              ],
              [
                44.3759,
                39.4111098
              ],
              [
                44.3756096,
                39.410674
              ],
              [
                44.3744192,
                39.4095452
              ],
              [
                44.3744499,
                39.4088993
              ],
              [
                44.3741949,
                39.4080605
              ],
              [
                44.37429,
                39.4073724
              ],
              [
                44.373457,
                39.407237
              ],
              [
                44.373267,
                39.4071504
              ],
              [
                44.3721921,
                39.4068874
              ],
              [
                44.3710963,
                39.4065759
              ],
              [
                44.3680451,
                39.4054695
              ],
              [
                44.3659548,
                39.4049552
              ],
              [
                44.3639594,
                39.4039798
              ],
              [
                44.3612814,
                39.403074
              ],
              [
                44.3607761,
                39.3980165
              ],
              [
                44.3576739,
                39.3962909
              ],
              [
                44.3545545,
                39.3953972
              ],
              [
                44.3525295,
                39.3942204
              ],
              [
                44.3513668,
                39.3933418
              ],
              [
                44.3502597,
                39.3928859
              ],
              [
                44.3488586,
                39.3926663
              ],
              [
                44.3476431,
                39.3931037
              ],
              [
                44.346413,
                39.3945122
              ],
              [
                44.3449899,
                39.3950584
              ],
              [
                44.3441692,
                39.3933371
              ],
              [
                44.3428694,
                39.3922649
              ],
              [
                44.3423082,
                39.3914676
              ],
              [
                44.3411677,
                39.3910848
              ],
              [
                44.3404978,
                39.3900422
              ],
              [
                44.3366102,
                39.3899505
              ],
              [
                44.3365156,
                39.3884135
              ],
              [
                44.3347044,
                39.3885349
              ],
              [
                44.3336473,
                39.3878721
              ],
              [
                44.3318777,
                39.3877922
              ],
              [
                44.3308806,
                39.3881933
              ],
              [
                44.3272567,
                39.389741
              ],
              [
                44.3254659,
                39.3903065
              ],
              [
                44.3227382,
                39.3906988
              ],
              [
                44.3187427,
                39.3916194
              ],
              [
                44.3161461,
                39.390357
              ],
              [
                44.3156308,
                39.3900051
              ],
              [
                44.3153555,
                39.3870038
              ],
              [
                44.3153555,
                39.3867259
              ],
              [
                44.3150759,
                39.3772792
              ],
              [
                44.3128555,
                39.3728336
              ],
              [
                44.3122994,
                39.3725558
              ],
              [
                44.3103525,
                39.3692216
              ],
              [
                44.3097494,
                39.3584581
              ],
              [
                44.3148993,
                39.3514232
              ],
              [
                44.3205641,
                39.3423963
              ],
              [
                44.3313983,
                39.336324
              ],
              [
                44.3308452,
                39.3349344
              ],
              [
                44.3300116,
                39.3341096
              ],
              [
                44.3239973,
                39.3228781
              ],
              [
                44.3118354,
                39.3230632
              ],
              [
                44.3043826,
                39.320689
              ],
              [
                44.2956616,
                39.3147773
              ],
              [
                44.2956616,
                39.3133878
              ],
              [
                44.2953842,
                39.3128322
              ],
              [
                44.2942749,
                39.3047733
              ],
              [
                44.294828,
                39.3036707
              ],
              [
                44.2959414,
                39.3003361
              ],
              [
                44.2978844,
                39.2983909
              ],
              [
                44.2978913,
                39.2938598
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555217,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مهاباد",
          "name:en": "Mahabad County",
          "name:ku": "Mehabad",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q750775"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.4743787,
                36.4344057
              ],
              [
                45.4768753,
                36.434352
              ],
              [
                45.4792353,
                36.4340933
              ],
              [
                45.4821968,
                36.4330573
              ],
              [
                45.4878187,
                36.4288793
              ],
              [
                45.4909944,
                36.4260133
              ],
              [
                45.4941832,
                36.4219976
              ],
              [
                45.4961872,
                36.4199012
              ],
              [
                45.4991542,
                36.4177416
              ],
              [
                45.5031405,
                36.4152179
              ],
              [
                45.504942,
                36.4139026
              ],
              [
                45.5114464,
                36.4065701
              ],
              [
                45.5172199,
                36.4016578
              ],
              [
                45.5250725,
                36.395918
              ],
              [
                45.5337381,
                36.3912676
              ],
              [
                45.5429219,
                36.3869147
              ],
              [
                45.5494451,
                36.3847727
              ],
              [
                45.5550344,
                36.3837284
              ],
              [
                45.5558957,
                36.3782271
              ],
              [
                45.556569,
                36.3701572
              ],
              [
                45.5585202,
                36.364855
              ],
              [
                45.5612167,
                36.3630233
              ],
              [
                45.5655025,
                36.3604978
              ],
              [
                45.5689287,
                36.3587875
              ],
              [
                45.5703677,
                36.3574218
              ],
              [
                45.5747815,
                36.3552417
              ],
              [
                45.5836808,
                36.3508503
              ],
              [
                45.5880716,
                36.3488184
              ],
              [
                45.5947207,
                36.3460336
              ],
              [
                45.6006431,
                36.3449275
              ],
              [
                45.6136893,
                36.3459645
              ],
              [
                45.6236288,
                36.3442427
              ],
              [
                45.6272949,
                36.3437588
              ],
              [
                45.6305554,
                36.34293
              ],
              [
                45.637021,
                36.3416746
              ],
              [
                45.6410573,
                36.3400141
              ],
              [
                45.6538027,
                36.3322153
              ],
              [
                45.6590741,
                36.3268921
              ],
              [
                45.6754827,
                36.3103509
              ],
              [
                45.6764544,
                36.2944336
              ],
              [
                45.6739423,
                36.2817831
              ],
              [
                45.6739425,
                36.2701583
              ],
              [
                45.6774682,
                36.2544855
              ],
              [
                45.6996911,
                36.28123
              ],
              [
                45.7264561,
                36.3006713
              ],
              [
                45.7359387,
                36.3070286
              ],
              [
                45.7459935,
                36.3160868
              ],
              [
                45.757713,
                36.3267434
              ],
              [
                45.7657779,
                36.3417789
              ],
              [
                45.7696265,
                36.3505254
              ],
              [
                45.7802165,
                36.3680279
              ],
              [
                45.7826629,
                36.3760944
              ],
              [
                45.7856938,
                36.3820435
              ],
              [
                45.7983969,
                36.3878476
              ],
              [
                45.8164213,
                36.3928223
              ],
              [
                45.8439501,
                36.400606
              ],
              [
                45.8579899,
                36.4050657
              ],
              [
                45.8628031,
                36.4085549
              ],
              [
                45.8756445,
                36.425012
              ],
              [
                45.8862875,
                36.4435185
              ],
              [
                45.8914374,
                36.4520798
              ],
              [
                45.8906116,
                36.4616236
              ],
              [
                45.8931116,
                36.4760707
              ],
              [
                45.8917208,
                36.4832851
              ],
              [
                45.8914444,
                36.4838436
              ],
              [
                45.8892208,
                36.4927332
              ],
              [
                45.8858878,
                36.5010642
              ],
              [
                45.8848914,
                36.5073176
              ],
              [
                45.8796474,
                36.5270109
              ],
              [
                45.870323,
                36.541088
              ],
              [
                45.8740738,
                36.5574253
              ],
              [
                45.8738608,
                36.5628297
              ],
              [
                45.8731743,
                36.569337
              ],
              [
                45.8684347,
                36.5805224
              ],
              [
                45.8667179,
                36.5913429
              ],
              [
                45.8658599,
                36.606709
              ],
              [
                45.8673191,
                36.616561
              ],
              [
                45.8688682,
                36.6226287
              ],
              [
                45.8691564,
                36.6245071
              ],
              [
                45.8692199,
                36.6268013
              ],
              [
                45.8687998,
                36.6276992
              ],
              [
                45.8709823,
                36.6281922
              ],
              [
                45.8783152,
                36.6280852
              ],
              [
                45.8872152,
                36.6271896
              ],
              [
                45.8932828,
                36.6270319
              ],
              [
                45.9017801,
                36.6264464
              ],
              [
                45.9093761,
                36.6270319
              ],
              [
                45.9124877,
                36.6275686
              ],
              [
                45.9352759,
                36.6384049
              ],
              [
                45.9648928,
                36.6436016
              ],
              [
                45.9735032,
                36.6436017
              ],
              [
                45.9884259,
                36.6400497
              ],
              [
                46.004562,
                36.6565769
              ],
              [
                46.0261914,
                36.662636
              ],
              [
                46.0482784,
                36.6632389
              ],
              [
                46.0496682,
                36.663518
              ],
              [
                46.0527253,
                36.6651748
              ],
              [
                46.0532816,
                36.6651748
              ],
              [
                46.0535589,
                36.665454
              ],
              [
                46.0560581,
                36.667678
              ],
              [
                46.0596182,
                36.6716533
              ],
              [
                46.0601752,
                36.6747151
              ],
              [
                46.0598986,
                36.6749942
              ],
              [
                46.0352721,
                36.6870129
              ],
              [
                46.0347151,
                36.6878505
              ],
              [
                46.0341589,
                36.6878505
              ],
              [
                46.032215,
                36.6897958
              ],
              [
                46.0186627,
                36.6942395
              ],
              [
                46.0418755,
                36.7042332
              ],
              [
                46.0452083,
                36.7117348
              ],
              [
                46.040335,
                36.717307
              ],
              [
                46.0397819,
                36.7209182
              ],
              [
                46.0338181,
                36.7328433
              ],
              [
                46.0327087,
                36.7334017
              ],
              [
                46.0324282,
                36.7339601
              ],
              [
                46.0313179,
                36.7347974
              ],
              [
                46.023785,
                36.7469411
              ],
              [
                46.0201716,
                36.7499935
              ],
              [
                46.0189816,
                36.7553903
              ],
              [
                46.0035056,
                36.7611046
              ],
              [
                45.9955021,
                36.7705852
              ],
              [
                45.9943919,
                36.7728093
              ],
              [
                45.9953551,
                36.783307
              ],
              [
                45.9961886,
                36.7860801
              ],
              [
                45.9960883,
                36.7901994
              ],
              [
                46.0107043,
                36.8018036
              ],
              [
                46.0229417,
                36.8119605
              ],
              [
                46.0309123,
                36.8309969
              ],
              [
                46.0330522,
                36.8462443
              ],
              [
                46.0529705,
                36.8540766
              ],
              [
                46.0735554,
                36.8620979
              ],
              [
                46.0608444,
                36.8679347
              ],
              [
                46.0608416,
                36.8679347
              ],
              [
                46.0602903,
                36.8679346
              ],
              [
                46.036841,
                36.8766627
              ],
              [
                46.0357277,
                36.877779
              ],
              [
                45.9982283,
                36.8969452
              ],
              [
                45.9968384,
                36.8972243
              ],
              [
                45.9851718,
                36.9030578
              ],
              [
                45.9815584,
                36.9047232
              ],
              [
                45.9471114,
                36.9197208
              ],
              [
                45.9465583,
                36.9197207
              ],
              [
                45.946002,
                36.9205489
              ],
              [
                45.9448919,
                36.920828
              ],
              [
                45.9410019,
                36.9241678
              ],
              [
                45.9404449,
                36.9244469
              ],
              [
                45.9398918,
                36.925554
              ],
              [
                45.9390589,
                36.9261032
              ],
              [
                45.9362784,
                36.9299921
              ],
              [
                45.9360018,
                36.9311083
              ],
              [
                45.9354455,
                36.9313873
              ],
              [
                45.9290555,
                36.9433328
              ],
              [
                45.9287789,
                36.94444
              ],
              [
                45.9222337,
                36.9513991
              ],
              [
                45.9219572,
                36.9525154
              ],
              [
                45.9011086,
                36.9619411
              ],
              [
                45.8902748,
                36.96611
              ],
              [
                45.8855465,
                36.9661099
              ],
              [
                45.8844418,
                36.9661099
              ],
              [
                45.8755518,
                36.9647142
              ],
              [
                45.8686585,
                36.9650862
              ],
              [
                45.8384041,
                36.9659043
              ],
              [
                45.8370181,
                36.9659043
              ],
              [
                45.8320893,
                36.9680893
              ],
              [
                45.7926432,
                36.9689758
              ],
              [
                45.7890299,
                36.9689758
              ],
              [
                45.7876439,
                36.9692548
              ],
              [
                45.7854204,
                36.9692548
              ],
              [
                45.7826438,
                36.969813
              ],
              [
                45.7820867,
                36.9700921
              ],
              [
                45.7806967,
                36.970092
              ],
              [
                45.7795866,
                36.9706501
              ],
              [
                45.75266,
                36.9830563
              ],
              [
                45.7515467,
                36.9830562
              ],
              [
                45.7496037,
                36.9836143
              ],
              [
                45.7479373,
                36.9844424
              ],
              [
                45.7454372,
                36.9850005
              ],
              [
                45.7448802,
                36.9852795
              ],
              [
                45.7436049,
                36.9855516
              ],
              [
                45.742414,
                36.9857058
              ],
              [
                45.7411802,
                36.9857915
              ],
              [
                45.737586,
                36.9857915
              ],
              [
                45.7361483,
                36.985603
              ],
              [
                45.7339588,
                36.9855918
              ],
              [
                45.7296064,
                37.0002272
              ],
              [
                45.7307142,
                37.0069452
              ],
              [
                45.7320855,
                37.0535851
              ],
              [
                45.7318089,
                37.0544131
              ],
              [
                45.7315324,
                37.054971
              ],
              [
                45.7287526,
                37.054971
              ],
              [
                45.7284753,
                37.054692
              ],
              [
                45.7276425,
                37.054692
              ],
              [
                45.6706282,
                37.0735632
              ],
              [
                45.6689609,
                37.0732843
              ],
              [
                45.6667383,
                37.0732843
              ],
              [
                45.6656242,
                37.0730054
              ],
              [
                45.6545447,
                37.0618897
              ],
              [
                45.6387518,
                37.0533963
              ],
              [
                45.6279088,
                37.049033
              ],
              [
                45.6267986,
                37.0487541
              ],
              [
                45.6248556,
                37.0487541
              ],
              [
                45.6245759,
                37.0484751
              ],
              [
                45.6192993,
                37.0484751
              ],
              [
                45.6184656,
                37.048754
              ],
              [
                45.6184657,
                37.0484751
              ],
              [
                45.6245037,
                37.0264029
              ],
              [
                45.6368634,
                37.0094072
              ],
              [
                45.690765,
                36.9924076
              ],
              [
                45.6931683,
                36.9770499
              ],
              [
                45.690765,
                36.9652553
              ],
              [
                45.6530854,
                36.9483144
              ],
              [
                45.6488799,
                36.9461192
              ],
              [
                45.6457069,
                36.9423539
              ],
              [
                45.6416701,
                36.9382988
              ],
              [
                45.6371833,
                36.9336298
              ],
              [
                45.6251916,
                36.9258676
              ],
              [
                45.6178092,
                36.9190189
              ],
              [
                45.6118011,
                36.9114017
              ],
              [
                45.6052609,
                36.9012767
              ],
              [
                45.5981929,
                36.8917297
              ],
              [
                45.5860519,
                36.874746
              ],
              [
                45.5773732,
                36.8669383
              ],
              [
                45.5800397,
                36.8615209
              ],
              [
                45.5841595,
                36.8508492
              ],
              [
                45.5818365,
                36.8443282
              ],
              [
                45.579735,
                36.8281914
              ],
              [
                45.5764387,
                36.8070858
              ],
              [
                45.5759238,
                36.7784925
              ],
              [
                45.5751179,
                36.7729301
              ],
              [
                45.5725336,
                36.7656357
              ],
              [
                45.5682846,
                36.7574189
              ],
              [
                45.5618044,
                36.7492011
              ],
              [
                45.5557966,
                36.7541523
              ],
              [
                45.5498743,
                36.7582783
              ],
              [
                45.5443041,
                36.76168
              ],
              [
                45.5440413,
                36.7572628
              ],
              [
                45.5407074,
                36.7408258
              ],
              [
                45.5401504,
                36.7405466
              ],
              [
                45.5380899,
                36.7382148
              ],
              [
                45.5376503,
                36.7377733
              ],
              [
                45.5357042,
                36.7347119
              ],
              [
                45.5290379,
                36.678871
              ],
              [
                45.5325077,
                36.6703731
              ],
              [
                45.5325572,
                36.6632004
              ],
              [
                45.5309442,
                36.6504292
              ],
              [
                45.5301106,
                36.6504292
              ],
              [
                45.5290004,
                36.6493122
              ],
              [
                45.524834,
                36.6470964
              ],
              [
                45.523444,
                36.6459795
              ],
              [
                45.5217777,
                36.6451509
              ],
              [
                45.5046841,
                36.6408762
              ],
              [
                45.4847714,
                36.6436309
              ],
              [
                45.472715,
                36.6394906
              ],
              [
                45.4713283,
                36.6383829
              ],
              [
                45.4566054,
                36.6283768
              ],
              [
                45.4496036,
                36.6194947
              ],
              [
                45.4465474,
                36.6144961
              ],
              [
                45.4468239,
                36.6075429
              ],
              [
                45.4475795,
                36.5980332
              ],
              [
                45.4531366,
                36.592485
              ],
              [
                45.4539695,
                36.591368
              ],
              [
                45.4545234,
                36.5910979
              ],
              [
                45.4556367,
                36.5894226
              ],
              [
                45.4796215,
                36.5772142
              ],
              [
                45.5020515,
                36.5551699
              ],
              [
                45.5026086,
                36.553504
              ],
              [
                45.503718,
                36.5490645
              ],
              [
                45.5053195,
                36.5328458
              ],
              [
                45.5038818,
                36.5238135
              ],
              [
                45.5060274,
                36.5153162
              ],
              [
                45.5064154,
                36.5024741
              ],
              [
                45.5072684,
                36.4938429
              ],
              [
                45.5061964,
                36.4905966
              ],
              [
                45.5021879,
                36.4849312
              ],
              [
                45.4949855,
                36.4789999
              ],
              [
                45.4822823,
                36.4691305
              ],
              [
                45.4791754,
                36.465493
              ],
              [
                45.4810809,
                36.4616754
              ],
              [
                45.4828302,
                36.4600299
              ],
              [
                45.4865788,
                36.4597538
              ],
              [
                45.4912938,
                36.4600958
              ],
              [
                45.504132,
                36.4641685
              ],
              [
                45.5090464,
                36.4644318
              ],
              [
                45.5119922,
                36.4599883
              ],
              [
                45.5111338,
                36.4553435
              ],
              [
                45.5062853,
                36.4513865
              ],
              [
                45.5019391,
                36.4474321
              ],
              [
                45.4932686,
                36.4437258
              ],
              [
                45.48563,
                36.4421375
              ],
              [
                45.4808232,
                36.4406015
              ],
              [
                45.4781627,
                36.4392547
              ],
              [
                45.4764676,
                36.4376493
              ],
              [
                45.4743787,
                36.4344057
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555224,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میاندوآب",
          "name:en": "Miandoab County",
          "name:ku": "Miyanduav",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286160",
          "wikipedia": "en:Miandoab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.6184656,
                37.048754
              ],
              [
                45.6192993,
                37.0484751
              ],
              [
                45.6245759,
                37.0484751
              ],
              [
                45.6248556,
                37.0487541
              ],
              [
                45.6267986,
                37.0487541
              ],
              [
                45.6279088,
                37.049033
              ],
              [
                45.6387518,
                37.0533963
              ],
              [
                45.6545447,
                37.0618897
              ],
              [
                45.6656242,
                37.0730054
              ],
              [
                45.6667383,
                37.0732843
              ],
              [
                45.6689609,
                37.0732843
              ],
              [
                45.6706282,
                37.0735632
              ],
              [
                45.7276425,
                37.054692
              ],
              [
                45.7284753,
                37.054692
              ],
              [
                45.7287526,
                37.054971
              ],
              [
                45.7315324,
                37.054971
              ],
              [
                45.7318089,
                37.0544131
              ],
              [
                45.7320855,
                37.0535851
              ],
              [
                45.7307142,
                37.0069452
              ],
              [
                45.7296064,
                37.0002272
              ],
              [
                45.7339588,
                36.9855918
              ],
              [
                45.7361483,
                36.985603
              ],
              [
                45.737586,
                36.9857915
              ],
              [
                45.7411802,
                36.9857915
              ],
              [
                45.742414,
                36.9857058
              ],
              [
                45.7436049,
                36.9855516
              ],
              [
                45.7448802,
                36.9852795
              ],
              [
                45.7454372,
                36.9850005
              ],
              [
                45.7479373,
                36.9844424
              ],
              [
                45.7496037,
                36.9836143
              ],
              [
                45.7515467,
                36.9830562
              ],
              [
                45.75266,
                36.9830563
              ],
              [
                45.7795866,
                36.9706501
              ],
              [
                45.7806967,
                36.970092
              ],
              [
                45.7820867,
                36.9700921
              ],
              [
                45.7826438,
                36.969813
              ],
              [
                45.7854204,
                36.9692548
              ],
              [
                45.7876439,
                36.9692548
              ],
              [
                45.7890299,
                36.9689758
              ],
              [
                45.7926432,
                36.9689758
              ],
              [
                45.8320893,
                36.9680893
              ],
              [
                45.8370181,
                36.9659043
              ],
              [
                45.8384041,
                36.9659043
              ],
              [
                45.8686585,
                36.9650862
              ],
              [
                45.8755518,
                36.9647142
              ],
              [
                45.8844418,
                36.9661099
              ],
              [
                45.8855465,
                36.9661099
              ],
              [
                45.8902748,
                36.96611
              ],
              [
                45.9011086,
                36.9619411
              ],
              [
                45.9219572,
                36.9525154
              ],
              [
                45.9222337,
                36.9513991
              ],
              [
                45.9287789,
                36.94444
              ],
              [
                45.9290555,
                36.9433328
              ],
              [
                45.9354455,
                36.9313873
              ],
              [
                45.9360018,
                36.9311083
              ],
              [
                45.9362784,
                36.9299921
              ],
              [
                45.9390589,
                36.9261032
              ],
              [
                45.9398918,
                36.925554
              ],
              [
                45.9404449,
                36.9244469
              ],
              [
                45.9410019,
                36.9241678
              ],
              [
                45.9448919,
                36.920828
              ],
              [
                45.946002,
                36.9205489
              ],
              [
                45.9465583,
                36.9197207
              ],
              [
                45.9471114,
                36.9197208
              ],
              [
                45.9815584,
                36.9047232
              ],
              [
                45.9851718,
                36.9030578
              ],
              [
                45.9968384,
                36.8972243
              ],
              [
                45.9982283,
                36.8969452
              ],
              [
                46.0357277,
                36.877779
              ],
              [
                46.036841,
                36.8766627
              ],
              [
                46.0602903,
                36.8679346
              ],
              [
                46.0608416,
                36.8679347
              ],
              [
                46.0608444,
                36.8679347
              ],
              [
                46.0735554,
                36.8620979
              ],
              [
                46.0853404,
                36.8630988
              ],
              [
                46.0867303,
                36.8628198
              ],
              [
                46.0886741,
                36.8628198
              ],
              [
                46.0892304,
                36.8625406
              ],
              [
                46.1011126,
                36.8580759
              ],
              [
                46.1025024,
                36.8580759
              ],
              [
                46.102779,
                36.8577968
              ],
              [
                46.1036119,
                36.8577968
              ],
              [
                46.1041689,
                36.8575177
              ],
              [
                46.1055588,
                36.8575178
              ],
              [
                46.1102784,
                36.8555731
              ],
              [
                46.1127785,
                36.8547358
              ],
              [
                46.1141691,
                36.8541776
              ],
              [
                46.133454,
                36.8464993
              ],
              [
                46.1404983,
                36.8431756
              ],
              [
                46.140778,
                36.8428966
              ],
              [
                46.1421647,
                36.8431756
              ],
              [
                46.143278,
                36.8428965
              ],
              [
                46.1466117,
                36.8428965
              ],
              [
                46.1477212,
                36.8426173
              ],
              [
                46.1560549,
                36.8426174
              ],
              [
                46.1574447,
                36.8423383
              ],
              [
                46.1599449,
                36.8423383
              ],
              [
                46.1618878,
                36.8420592
              ],
              [
                46.1660544,
                36.841789
              ],
              [
                46.1671676,
                36.8420592
              ],
              [
                46.1688349,
                36.841789
              ],
              [
                46.1746678,
                36.841789
              ],
              [
                46.1755014,
                36.84151
              ],
              [
                46.1799445,
                36.84151
              ],
              [
                46.205099,
                36.8343185
              ],
              [
                46.2254511,
                36.8360574
              ],
              [
                46.2350359,
                36.8392086
              ],
              [
                46.2358687,
                36.8389295
              ],
              [
                46.2372586,
                36.8389295
              ],
              [
                46.2444102,
                36.8405784
              ],
              [
                46.2816237,
                36.8337449
              ],
              [
                46.2969015,
                36.8298978
              ],
              [
                46.3194681,
                36.829257
              ],
              [
                46.3289144,
                36.8287077
              ],
              [
                46.3228009,
                36.8361991
              ],
              [
                46.3222478,
                36.8364782
              ],
              [
                46.3163947,
                36.8457216
              ],
              [
                46.3168583,
                36.8489581
              ],
              [
                46.3169518,
                36.849611
              ],
              [
                46.3196316,
                36.8530491
              ],
              [
                46.319355,
                36.8536073
              ],
              [
                46.3190745,
                36.8544446
              ],
              [
                46.320321,
                36.8562865
              ],
              [
                46.3192076,
                36.8562865
              ],
              [
                46.3183748,
                36.8565657
              ],
              [
                46.310105,
                36.8568403
              ],
              [
                46.3092714,
                36.8565611
              ],
              [
                46.3078816,
                36.8565612
              ],
              [
                46.3076051,
                36.8562821
              ],
              [
                46.3045479,
                36.8562821
              ],
              [
                46.3031612,
                36.8568403
              ],
              [
                46.3007749,
                36.8634589
              ],
              [
                46.2972449,
                36.868635
              ],
              [
                46.2820743,
                36.8730466
              ],
              [
                46.2808513,
                36.8727719
              ],
              [
                46.2797785,
                36.8723084
              ],
              [
                46.2778687,
                36.8714501
              ],
              [
                46.2760234,
                36.8704717
              ],
              [
                46.2733839,
                36.8698195
              ],
              [
                46.2719893,
                36.8698022
              ],
              [
                46.2709164,
                36.8702485
              ],
              [
                46.270144,
                36.8708837
              ],
              [
                46.2694359,
                36.8716561
              ],
              [
                46.2690711,
                36.8727032
              ],
              [
                46.2692213,
                36.8733899
              ],
              [
                46.268585,
                36.8746345
              ],
              [
                46.2679124,
                36.8752437
              ],
              [
                46.2669253,
                36.8758445
              ],
              [
                46.2660455,
                36.8760504
              ],
              [
                46.2649297,
                36.8761878
              ],
              [
                46.2631273,
                36.8762736
              ],
              [
                46.2603164,
                36.8764796
              ],
              [
                46.2574183,
                36.8771439
              ],
              [
                46.2551665,
                36.8777154
              ],
              [
                46.2527847,
                36.8786594
              ],
              [
                46.2505102,
                36.880496
              ],
              [
                46.2487292,
                36.8822982
              ],
              [
                46.2475061,
                36.882916
              ],
              [
                46.2469254,
                36.8836614
              ],
              [
                46.2450814,
                36.8837742
              ],
              [
                46.2424421,
                36.8842719
              ],
              [
                46.2377429,
                36.8855591
              ],
              [
                46.2337303,
                36.8865889
              ],
              [
                46.2260055,
                36.8891632
              ],
              [
                46.2189674,
                36.890845
              ],
              [
                46.215105,
                36.8914972
              ],
              [
                46.2128734,
                36.8925268
              ],
              [
                46.2111568,
                36.8943802
              ],
              [
                46.2084531,
                36.8974347
              ],
              [
                46.2069511,
                36.8982928
              ],
              [
                46.2048054,
                36.8981554
              ],
              [
                46.2035608,
                36.8982756
              ],
              [
                46.2013507,
                36.8995625
              ],
              [
                46.1992907,
                36.9009181
              ],
              [
                46.1981106,
                36.9015702
              ],
              [
                46.197145,
                36.9019648
              ],
              [
                46.1956858,
                36.9017074
              ],
              [
                46.1947632,
                36.9017074
              ],
              [
                46.1934757,
                36.9020506
              ],
              [
                46.1918235,
                36.9031488
              ],
              [
                46.1904716,
                36.9034748
              ],
              [
                46.1874676,
                36.9032174
              ],
              [
                46.1859441,
                36.9034576
              ],
              [
                46.1848283,
                36.9038351
              ],
              [
                46.1835407,
                36.9048475
              ],
              [
                46.1820173,
                36.9069407
              ],
              [
                46.1815882,
                36.9079874
              ],
              [
                46.1809015,
                36.909034
              ],
              [
                46.1799896,
                36.9090095
              ],
              [
                46.1821246,
                36.9100291
              ],
              [
                46.1868024,
                36.9143697
              ],
              [
                46.1893987,
                36.9198423
              ],
              [
                46.1917095,
                36.9266417
              ],
              [
                46.1921239,
                36.9339767
              ],
              [
                46.1937098,
                36.9413669
              ],
              [
                46.188397,
                36.9441509
              ],
              [
                46.1827338,
                36.947855
              ],
              [
                46.1805068,
                36.948936
              ],
              [
                46.1755568,
                36.9528007
              ],
              [
                46.171844,
                36.9593991
              ],
              [
                46.1725783,
                36.9632976
              ],
              [
                46.1751038,
                36.9681942
              ],
              [
                46.1762807,
                36.9753928
              ],
              [
                46.1760241,
                36.9829693
              ],
              [
                46.1758953,
                36.9844383
              ],
              [
                46.1769564,
                36.9945469
              ],
              [
                46.175971,
                36.9976763
              ],
              [
                46.1724975,
                36.9980092
              ],
              [
                46.1714172,
                36.9986798
              ],
              [
                46.1699152,
                37.0010447
              ],
              [
                46.1689281,
                37.0047118
              ],
              [
                46.1657799,
                37.0084539
              ],
              [
                46.1602592,
                37.0100923
              ],
              [
                46.1585426,
                37.0109833
              ],
              [
                46.1567831,
                37.0125939
              ],
              [
                46.1556243,
                37.0139303
              ],
              [
                46.1549789,
                37.0151171
              ],
              [
                46.1548948,
                37.0164147
              ],
              [
                46.1560749,
                37.0178025
              ],
              [
                46.1562681,
                37.01955
              ],
              [
                46.1545515,
                37.0254776
              ],
              [
                46.154809,
                37.0271564
              ],
              [
                46.1553239,
                37.0302399
              ],
              [
                46.1560535,
                37.0325353
              ],
              [
                46.154766,
                37.0344195
              ],
              [
                46.153135,
                37.0358072
              ],
              [
                46.1496377,
                37.0375541
              ],
              [
                46.1450243,
                37.0392497
              ],
              [
                46.1442947,
                37.0399177
              ],
              [
                46.1434257,
                37.0402688
              ],
              [
                46.1416983,
                37.0404829
              ],
              [
                46.1404967,
                37.0407656
              ],
              [
                46.1381042,
                37.0416648
              ],
              [
                46.1375892,
                37.0420758
              ],
              [
                46.1361301,
                37.0438313
              ],
              [
                46.1347997,
                37.0447905
              ],
              [
                46.1339199,
                37.045133
              ],
              [
                46.1242532,
                37.0489436
              ],
              [
                46.1115932,
                37.0554511
              ],
              [
                46.1071602,
                37.0571469
              ],
              [
                46.1048675,
                37.0575729
              ],
              [
                46.1021218,
                37.0588451
              ],
              [
                46.0970275,
                37.0549483
              ],
              [
                46.0933596,
                37.0584359
              ],
              [
                46.0867881,
                37.0645265
              ],
              [
                46.0801696,
                37.0705701
              ],
              [
                46.0702387,
                37.0808077
              ],
              [
                46.0624888,
                37.0879605
              ],
              [
                46.0549449,
                37.0952035
              ],
              [
                46.0549879,
                37.0967781
              ],
              [
                46.0545158,
                37.0979076
              ],
              [
                46.0550892,
                37.1003523
              ],
              [
                46.0541296,
                37.1011251
              ],
              [
                46.0532444,
                37.102368
              ],
              [
                46.0531793,
                37.1024562
              ],
              [
                46.0478515,
                37.1010985
              ],
              [
                46.04442,
                37.1001411
              ],
              [
                46.0433887,
                37.0997567
              ],
              [
                46.0424248,
                37.0997087
              ],
              [
                46.0398388,
                37.0990714
              ],
              [
                46.0372638,
                37.0980788
              ],
              [
                46.0339808,
                37.0967952
              ],
              [
                46.032114,
                37.0960079
              ],
              [
                46.0225009,
                37.091883
              ],
              [
                46.0031032,
                37.0816126
              ],
              [
                45.9976505,
                37.0794278
              ],
              [
                45.9950137,
                37.0781717
              ],
              [
                45.9938631,
                37.0779765
              ],
              [
                45.9919452,
                37.0778122
              ],
              [
                45.990293,
                37.0778636
              ],
              [
                45.9883189,
                37.0778122
              ],
              [
                45.9866667,
                37.0774527
              ],
              [
                45.9853363,
                37.07735
              ],
              [
                45.9839201,
                37.0775212
              ],
              [
                45.9822703,
                37.0772918
              ],
              [
                45.9796071,
                37.0764769
              ],
              [
                45.977118,
                37.0758264
              ],
              [
                45.9696292,
                37.074491
              ],
              [
                45.9620332,
                37.0730529
              ],
              [
                45.9516048,
                37.071649
              ],
              [
                45.9450037,
                37.0702823
              ],
              [
                45.9416385,
                37.0691798
              ],
              [
                45.9383755,
                37.0673828
              ],
              [
                45.9363246,
                37.0655375
              ],
              [
                45.9343116,
                37.0634728
              ],
              [
                45.932943,
                37.0614695
              ],
              [
                45.9323678,
                37.0603858
              ],
              [
                45.9320224,
                37.0591397
              ],
              [
                45.931707,
                37.0577184
              ],
              [
                45.9316943,
                37.0554902
              ],
              [
                45.9315297,
                37.054574
              ],
              [
                45.9269731,
                37.0552585
              ],
              [
                45.9230495,
                37.0573818
              ],
              [
                45.9212519,
                37.0576951
              ],
              [
                45.9193899,
                37.0575239
              ],
              [
                45.9181454,
                37.0577687
              ],
              [
                45.9170782,
                37.0588646
              ],
              [
                45.9172404,
                37.0605156
              ],
              [
                45.9189033,
                37.0634992
              ],
              [
                45.9193754,
                37.0654511
              ],
              [
                45.9192466,
                37.0669236
              ],
              [
                45.9179445,
                37.06833
              ],
              [
                45.9168351,
                37.0694461
              ],
              [
                45.9150526,
                37.0695932
              ],
              [
                45.9121116,
                37.0697251
              ],
              [
                45.9101646,
                37.0697251
              ],
              [
                45.9078331,
                37.0694624
              ],
              [
                45.9062929,
                37.0694484
              ],
              [
                45.9055832,
                37.070184
              ],
              [
                45.905385,
                37.0712039
              ],
              [
                45.9059429,
                37.0731727
              ],
              [
                45.9073022,
                37.0750848
              ],
              [
                45.9078955,
                37.0756894
              ],
              [
                45.9077239,
                37.076631
              ],
              [
                45.9057162,
                37.0779781
              ],
              [
                45.9034967,
                37.0780519
              ],
              [
                45.9010076,
                37.0787367
              ],
              [
                45.899906,
                37.0799398
              ],
              [
                45.8980035,
                37.0832217
              ],
              [
                45.8964955,
                37.0848636
              ],
              [
                45.893997,
                37.0862483
              ],
              [
                45.8921335,
                37.0864537
              ],
              [
                45.8903549,
                37.0861165
              ],
              [
                45.8883433,
                37.085603
              ],
              [
                45.8868858,
                37.0838621
              ],
              [
                45.8848406,
                37.0828349
              ],
              [
                45.8835357,
                37.0827956
              ],
              [
                45.8815434,
                37.0826929
              ],
              [
                45.8795987,
                37.083162
              ],
              [
                45.8778489,
                37.0835043
              ],
              [
                45.8751726,
                37.0850705
              ],
              [
                45.8721885,
                37.0872999
              ],
              [
                45.8697608,
                37.0901922
              ],
              [
                45.8680887,
                37.0916983
              ],
              [
                45.8671474,
                37.0922596
              ],
              [
                45.8651943,
                37.0924908
              ],
              [
                45.862464,
                37.0916692
              ],
              [
                45.8613958,
                37.0902948
              ],
              [
                45.8604764,
                37.0893706
              ],
              [
                45.8588072,
                37.0867127
              ],
              [
                45.8561182,
                37.0863372
              ],
              [
                45.8542728,
                37.0869534
              ],
              [
                45.8528873,
                37.0890914
              ],
              [
                45.8531448,
                37.0912563
              ],
              [
                45.8522865,
                37.0932966
              ],
              [
                45.8516364,
                37.0952747
              ],
              [
                45.8503326,
                37.0965018
              ],
              [
                45.8483831,
                37.097563
              ],
              [
                45.846591,
                37.0971888
              ],
              [
                45.844016,
                37.0961961
              ],
              [
                45.8425858,
                37.0934749
              ],
              [
                45.8422442,
                37.0918164
              ],
              [
                45.8416371,
                37.0892438
              ],
              [
                45.8405748,
                37.087999
              ],
              [
                45.8388233,
                37.0882201
              ],
              [
                45.836935,
                37.088939
              ],
              [
                45.8350896,
                37.0910272
              ],
              [
                45.8335697,
                37.0921795
              ],
              [
                45.8302716,
                37.0938395
              ],
              [
                45.8215961,
                37.1034044
              ],
              [
                45.8184385,
                37.1049586
              ],
              [
                45.8163026,
                37.1051538
              ],
              [
                45.8114862,
                37.1033157
              ],
              [
                45.8106708,
                37.1028023
              ],
              [
                45.8083505,
                37.1024944
              ],
              [
                45.8066149,
                37.1023522
              ],
              [
                45.8046861,
                37.1018388
              ],
              [
                45.801378,
                37.1004341
              ],
              [
                45.7981395,
                37.0997444
              ],
              [
                45.7958804,
                37.1002249
              ],
              [
                45.7927174,
                37.1021604
              ],
              [
                45.7915306,
                37.1053351
              ],
              [
                45.7955385,
                37.1075817
              ],
              [
                45.7952642,
                37.1088945
              ],
              [
                45.7948136,
                37.1095961
              ],
              [
                45.7949638,
                37.1106057
              ],
              [
                45.7959509,
                37.1106399
              ],
              [
                45.7969723,
                37.1112866
              ],
              [
                45.7977471,
                37.1118988
              ],
              [
                45.7979035,
                37.1128645
              ],
              [
                45.7975588,
                37.1139216
              ],
              [
                45.7963182,
                37.1152734
              ],
              [
                45.7952923,
                37.1160144
              ],
              [
                45.7941837,
                37.1162197
              ],
              [
                45.7916082,
                37.1157866
              ],
              [
                45.7899235,
                37.1155128
              ],
              [
                45.7889602,
                37.1154496
              ],
              [
                45.7874457,
                37.1157577
              ],
              [
                45.7871309,
                37.1166512
              ],
              [
                45.7875815,
                37.1174039
              ],
              [
                45.7888666,
                37.1180185
              ],
              [
                45.7903343,
                37.1183317
              ],
              [
                45.791791,
                37.1184857
              ],
              [
                45.7928607,
                37.1189529
              ],
              [
                45.7940494,
                37.1197191
              ],
              [
                45.7945729,
                37.1205441
              ],
              [
                45.7946634,
                37.121625
              ],
              [
                45.7948136,
                37.12272
              ],
              [
                45.7948493,
                37.1236896
              ],
              [
                45.7942104,
                37.1252876
              ],
              [
                45.7935262,
                37.1260391
              ],
              [
                45.7925391,
                37.1262786
              ],
              [
                45.791316,
                37.1263812
              ],
              [
                45.7903075,
                37.1268432
              ],
              [
                45.7898354,
                37.127767
              ],
              [
                45.7886767,
                37.1280921
              ],
              [
                45.7877326,
                37.1279894
              ],
              [
                45.7865095,
                37.1274591
              ],
              [
                45.785501,
                37.1273564
              ],
              [
                45.7846641,
                37.1274762
              ],
              [
                45.7833981,
                37.1280749
              ],
              [
                45.7814455,
                37.1295633
              ],
              [
                45.7796757,
                37.1309189
              ],
              [
                45.7779479,
                37.1319241
              ],
              [
                45.7770681,
                37.1326597
              ],
              [
                45.7772183,
                37.1336348
              ],
              [
                45.7777235,
                37.1346752
              ],
              [
                45.7780906,
                37.1353528
              ],
              [
                45.7779479,
                37.1362692
              ],
              [
                45.7771754,
                37.1369021
              ],
              [
                45.7760381,
                37.1373298
              ],
              [
                45.7748816,
                37.1374914
              ],
              [
                45.7735801,
                37.1375256
              ],
              [
                45.7725525,
                37.1373426
              ],
              [
                45.7712745,
                37.1371245
              ],
              [
                45.7691091,
                37.1361623
              ],
              [
                45.768041,
                37.1364756
              ],
              [
                45.7673692,
                37.1373298
              ],
              [
                45.7664438,
                37.1379124
              ],
              [
                45.7653951,
                37.138168
              ],
              [
                45.7623482,
                37.1378087
              ],
              [
                45.7606952,
                37.1377022
              ],
              [
                45.7582546,
                37.1377588
              ],
              [
                45.7571769,
                37.1379969
              ],
              [
                45.7545161,
                37.1386298
              ],
              [
                45.7525849,
                37.1395877
              ],
              [
                45.751748,
                37.1403404
              ],
              [
                45.7500958,
                37.142564
              ],
              [
                45.7484435,
                37.144035
              ],
              [
                45.7447528,
                37.1461559
              ],
              [
                45.742875,
                37.1504419
              ],
              [
                45.739088,
                37.1582645
              ],
              [
                45.7389163,
                37.1629843
              ],
              [
                45.7409184,
                37.1674328
              ],
              [
                45.7423172,
                37.1742199
              ],
              [
                45.7429342,
                37.1791443
              ],
              [
                45.7489677,
                37.1875268
              ],
              [
                45.7515227,
                37.1923204
              ],
              [
                45.758009,
                37.2033103
              ],
              [
                45.7611034,
                37.2065666
              ],
              [
                45.6878289,
                37.2901539
              ],
              [
                45.670509,
                37.2838876
              ],
              [
                45.6670758,
                37.2707746
              ],
              [
                45.6543728,
                37.2644905
              ],
              [
                45.6495663,
                37.2513742
              ],
              [
                45.63652,
                37.2316954
              ],
              [
                45.6344601,
                37.205996
              ],
              [
                45.6330868,
                37.182476
              ],
              [
                45.6289669,
                37.1731754
              ],
              [
                45.6306836,
                37.1600432
              ],
              [
                45.627937,
                37.1521081
              ],
              [
                45.6275937,
                37.1299399
              ],
              [
                45.6196972,
                37.1069439
              ],
              [
                45.6145474,
                37.0844887
              ],
              [
                45.5987545,
                37.0759978
              ],
              [
                45.5987547,
                37.0681907
              ],
              [
                45.6042477,
                37.0625748
              ],
              [
                45.6184656,
                37.048754
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555236,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نقده",
          "name:en": "Naqadeh County",
          "name:ku": "Nexede",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q721921",
          "wikipedia": "en:Naqadeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.250235,
                36.9845546
              ],
              [
                45.2525524,
                36.9802988
              ],
              [
                45.2539955,
                36.9761699
              ],
              [
                45.2644923,
                36.9575767
              ],
              [
                45.2663138,
                36.9542745
              ],
              [
                45.2659892,
                36.9381616
              ],
              [
                45.266075,
                36.9299288
              ],
              [
                45.265133,
                36.9209244
              ],
              [
                45.2830212,
                36.9183146
              ],
              [
                45.295831,
                36.9135019
              ],
              [
                45.3120151,
                36.8930001
              ],
              [
                45.3216268,
                36.8733118
              ],
              [
                45.3325326,
                36.8613417
              ],
              [
                45.3352152,
                36.8578773
              ],
              [
                45.3471133,
                36.8490988
              ],
              [
                45.3834691,
                36.840144
              ],
              [
                45.4001426,
                36.8363553
              ],
              [
                45.4123736,
                36.8329312
              ],
              [
                45.4197678,
                36.8300543
              ],
              [
                45.4304182,
                36.8265589
              ],
              [
                45.4389094,
                36.8237896
              ],
              [
                45.4430824,
                36.8226135
              ],
              [
                45.4541719,
                36.819128
              ],
              [
                45.4611663,
                36.8153403
              ],
              [
                45.4794632,
                36.8060478
              ],
              [
                45.5006503,
                36.7889412
              ],
              [
                45.5086675,
                36.7809119
              ],
              [
                45.5278298,
                36.7684194
              ],
              [
                45.5366992,
                36.7646044
              ],
              [
                45.5443041,
                36.76168
              ],
              [
                45.5498743,
                36.7582783
              ],
              [
                45.5557966,
                36.7541523
              ],
              [
                45.5618044,
                36.7492011
              ],
              [
                45.5682846,
                36.7574189
              ],
              [
                45.5725336,
                36.7656357
              ],
              [
                45.5751179,
                36.7729301
              ],
              [
                45.5759238,
                36.7784925
              ],
              [
                45.5764387,
                36.8070858
              ],
              [
                45.579735,
                36.8281914
              ],
              [
                45.5818365,
                36.8443282
              ],
              [
                45.5841595,
                36.8508492
              ],
              [
                45.5800397,
                36.8615209
              ],
              [
                45.5773732,
                36.8669383
              ],
              [
                45.5860519,
                36.874746
              ],
              [
                45.5981929,
                36.8917297
              ],
              [
                45.6052609,
                36.9012767
              ],
              [
                45.6118011,
                36.9114017
              ],
              [
                45.6178092,
                36.9190189
              ],
              [
                45.6251916,
                36.9258676
              ],
              [
                45.6371833,
                36.9336298
              ],
              [
                45.6416701,
                36.9382988
              ],
              [
                45.6457069,
                36.9423539
              ],
              [
                45.6488799,
                36.9461192
              ],
              [
                45.6530854,
                36.9483144
              ],
              [
                45.690765,
                36.9652553
              ],
              [
                45.6931683,
                36.9770499
              ],
              [
                45.690765,
                36.9924076
              ],
              [
                45.6368634,
                37.0094072
              ],
              [
                45.6245037,
                37.0264029
              ],
              [
                45.6184657,
                37.0484751
              ],
              [
                45.6184656,
                37.048754
              ],
              [
                45.6042477,
                37.0625748
              ],
              [
                45.5987547,
                37.0681907
              ],
              [
                45.5987545,
                37.0759978
              ],
              [
                45.6145474,
                37.0844887
              ],
              [
                45.6196972,
                37.1069439
              ],
              [
                45.6275937,
                37.1299399
              ],
              [
                45.627937,
                37.1521081
              ],
              [
                45.6306836,
                37.1600432
              ],
              [
                45.6289669,
                37.1731754
              ],
              [
                45.6330868,
                37.182476
              ],
              [
                45.6344601,
                37.205996
              ],
              [
                45.63652,
                37.2316954
              ],
              [
                45.6495663,
                37.2513742
              ],
              [
                45.6543728,
                37.2644905
              ],
              [
                45.6670758,
                37.2707746
              ],
              [
                45.670509,
                37.2838876
              ],
              [
                45.6878289,
                37.2901539
              ],
              [
                45.6421216,
                37.3036418
              ],
              [
                45.6291132,
                37.3035606
              ],
              [
                45.5953151,
                37.3033496
              ],
              [
                45.5868276,
                37.3059703
              ],
              [
                45.5836179,
                37.3155446
              ],
              [
                45.5857526,
                37.3244002
              ],
              [
                45.5723531,
                37.3265509
              ],
              [
                45.5582813,
                37.3271867
              ],
              [
                45.5564822,
                37.3290021
              ],
              [
                45.5557824,
                37.328221
              ],
              [
                45.4858139,
                37.2465538
              ],
              [
                45.4141696,
                37.1656526
              ],
              [
                45.4087256,
                37.1627791
              ],
              [
                45.3996275,
                37.1608639
              ],
              [
                45.3882979,
                37.1562124
              ],
              [
                45.3809164,
                37.1548443
              ],
              [
                45.3601535,
                37.1514567
              ],
              [
                45.3282041,
                37.1509453
              ],
              [
                45.3173589,
                37.1511159
              ],
              [
                45.2936091,
                37.1497065
              ],
              [
                45.2859354,
                37.1499656
              ],
              [
                45.2827017,
                37.1501099
              ],
              [
                45.2772036,
                37.140518
              ],
              [
                45.2738381,
                37.1322513
              ],
              [
                45.2704383,
                37.1222208
              ],
              [
                45.2688594,
                37.1132704
              ],
              [
                45.2685072,
                37.1079173
              ],
              [
                45.2685247,
                37.0994477
              ],
              [
                45.2673378,
                37.0762266
              ],
              [
                45.2653025,
                37.0487382
              ],
              [
                45.2627637,
                37.0433884
              ],
              [
                45.2573342,
                37.0258277
              ],
              [
                45.2558998,
                37.0191621
              ],
              [
                45.2556037,
                37.0063226
              ],
              [
                45.2485656,
                36.9995367
              ],
              [
                45.2477931,
                36.9931615
              ],
              [
                45.250235,
                36.9845546
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555267,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پلدشت",
          "name:en": "Poldasht County",
          "name:ku": "Puldeşt",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2725484",
          "wikipedia": "en:Poldasht County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.7772437,
                39.3450975
              ],
              [
                44.7841795,
                39.3421727
              ],
              [
                44.7966377,
                39.3430491
              ],
              [
                44.7974713,
                39.3430491
              ],
              [
                44.797751,
                39.3427712
              ],
              [
                44.7980276,
                39.3427711
              ],
              [
                44.7996948,
                39.3427712
              ],
              [
                44.8110416,
                39.3401651
              ],
              [
                44.8174317,
                39.3359971
              ],
              [
                44.8185418,
                39.3357193
              ],
              [
                44.8322867,
                39.3163709
              ],
              [
                44.8341749,
                39.3090661
              ],
              [
                44.8679922,
                39.3058783
              ],
              [
                44.8991327,
                39.2977653
              ],
              [
                44.8988562,
                39.2974874
              ],
              [
                44.9160574,
                39.2911329
              ],
              [
                44.9218939,
                39.2892729
              ],
              [
                44.9268721,
                39.28914
              ],
              [
                44.9265288,
                39.2863499
              ],
              [
                44.9186323,
                39.2815667
              ],
              [
                44.9179457,
                39.2794407
              ],
              [
                44.9217222,
                39.2782448
              ],
              [
                44.9285887,
                39.281168
              ],
              [
                44.9375151,
                39.2798393
              ],
              [
                44.9482671,
                39.2669503
              ],
              [
                44.9482671,
                39.2658387
              ],
              [
                44.9471578,
                39.2619479
              ],
              [
                44.9452109,
                39.2477831
              ],
              [
                44.9349113,
                39.2239357
              ],
              [
                44.9304065,
                39.2154969
              ],
              [
                44.9301268,
                39.2149409
              ],
              [
                44.9304064,
                39.2129953
              ],
              [
                44.930683,
                39.2121613
              ],
              [
                44.9306831,
                39.2093816
              ],
              [
                44.9309596,
                39.2091037
              ],
              [
                44.9306831,
                39.2082698
              ],
              [
                44.9354702,
                39.2065688
              ],
              [
                44.9404736,
                39.1990645
              ],
              [
                44.9438064,
                39.1976747
              ],
              [
                44.9443596,
                39.1976748
              ],
              [
                44.9465831,
                39.1974058
              ],
              [
                44.9501934,
                39.1974058
              ],
              [
                44.9507496,
                39.1971279
              ],
              [
                44.9879221,
                39.1803539
              ],
              [
                45.0149151,
                39.1758178
              ],
              [
                45.0151916,
                39.1755398
              ],
              [
                45.0160252,
                39.1755397
              ],
              [
                45.0163049,
                39.1752618
              ],
              [
                45.0168581,
                39.1752618
              ],
              [
                45.0210245,
                39.1733161
              ],
              [
                45.0218582,
                39.1733162
              ],
              [
                45.0224153,
                39.1730381
              ],
              [
                45.0235246,
                39.1730382
              ],
              [
                45.0238051,
                39.1727602
              ],
              [
                45.0377649,
                39.1625552
              ],
              [
                45.0413837,
                39.154921
              ],
              [
                45.0422165,
                39.154921
              ],
              [
                45.0424592,
                39.1546805
              ],
              [
                45.0460715,
                39.143113
              ],
              [
                45.0460715,
                39.1406111
              ],
              [
                45.0456472,
                39.1131376
              ],
              [
                45.0459269,
                39.1128596
              ],
              [
                45.0456473,
                39.1031387
              ],
              [
                45.0381471,
                39.0942515
              ],
              [
                45.0261574,
                39.0830759
              ],
              [
                45.0250441,
                39.0822418
              ],
              [
                45.0244909,
                39.0822418
              ],
              [
                45.0125392,
                39.0760952
              ],
              [
                45.0056647,
                39.0694463
              ],
              [
                45.0026063,
                39.0604822
              ],
              [
                45.0040241,
                39.0379176
              ],
              [
                45.008617,
                39.0241708
              ],
              [
                45.0120666,
                39.0102172
              ],
              [
                45.0230025,
                39.0095805
              ],
              [
                45.0321864,
                39.0078464
              ],
              [
                45.0405159,
                39.0017202
              ],
              [
                45.0451062,
                38.9948609
              ],
              [
                45.0508116,
                38.9783609
              ],
              [
                45.0611113,
                38.964748
              ],
              [
                45.081539,
                38.9664831
              ],
              [
                45.1382254,
                39.0007732
              ],
              [
                45.149817,
                38.9991205
              ],
              [
                45.1555533,
                38.9943848
              ],
              [
                45.1739158,
                38.9819016
              ],
              [
                45.1965623,
                38.966901
              ],
              [
                45.1992842,
                38.9652326
              ],
              [
                45.2027259,
                38.963867
              ],
              [
                45.2041127,
                38.9644234
              ],
              [
                45.2049455,
                38.9644233
              ],
              [
                45.2057791,
                38.9647015
              ],
              [
                45.2091159,
                38.9647016
              ],
              [
                45.2093924,
                38.9644234
              ],
              [
                45.2102261,
                38.9644234
              ],
              [
                45.2124488,
                38.9638671
              ],
              [
                45.2138355,
                38.9638671
              ],
              [
                45.2143926,
                38.9635889
              ],
              [
                45.2155027,
                38.9635889
              ],
              [
                45.2166161,
                38.9633107
              ],
              [
                45.2266155,
                38.9624852
              ],
              [
                45.2288391,
                38.9619288
              ],
              [
                45.2293922,
                38.9619289
              ],
              [
                45.2577288,
                38.9541489
              ],
              [
                45.2593952,
                38.9533144
              ],
              [
                45.261339,
                38.952758
              ],
              [
                45.2741182,
                38.9474816
              ],
              [
                45.2763386,
                38.9460906
              ],
              [
                45.3010939,
                38.9192193
              ],
              [
                45.3002356,
                38.894106
              ],
              [
                45.3063601,
                38.8778739
              ],
              [
                45.3198117,
                38.8836864
              ],
              [
                45.3362203,
                38.8877516
              ],
              [
                45.3362203,
                38.8883082
              ],
              [
                45.3417134,
                38.8956119
              ],
              [
                45.3414343,
                38.8997172
              ],
              [
                45.3458975,
                38.90466
              ],
              [
                45.3493307,
                38.9146782
              ],
              [
                45.3577421,
                38.918418
              ],
              [
                45.362377,
                38.9441903
              ],
              [
                45.3706167,
                38.947795
              ],
              [
                45.3754943,
                38.959335
              ],
              [
                45.3763279,
                38.9609946
              ],
              [
                45.3779074,
                38.9625519
              ],
              [
                45.3840208,
                38.9656019
              ],
              [
                45.391521,
                38.9708856
              ],
              [
                45.3926311,
                38.9714417
              ],
              [
                45.393464,
                38.9714418
              ],
              [
                45.3962446,
                38.9725541
              ],
              [
                45.3976305,
                38.9725542
              ],
              [
                45.398464,
                38.9728322
              ],
              [
                45.399854,
                38.9728322
              ],
              [
                45.4006876,
                38.9731103
              ],
              [
                45.4037439,
                38.9731103
              ],
              [
                45.4042971,
                38.9733794
              ],
              [
                45.4114158,
                38.9740586
              ],
              [
                45.4158589,
                38.9746148
              ],
              [
                45.4194722,
                38.9746149
              ],
              [
                45.4197488,
                38.9748929
              ],
              [
                45.4234505,
                38.9752265
              ],
              [
                45.428329,
                38.9767307
              ],
              [
                45.4286055,
                38.9772869
              ],
              [
                45.4358284,
                38.9806241
              ],
              [
                45.4420768,
                38.9842158
              ],
              [
                45.4431901,
                38.9844938
              ],
              [
                45.44958,
                38.9903245
              ],
              [
                45.4501334,
                38.9906022
              ],
              [
                45.4529047,
                38.9929965
              ],
              [
                45.4512753,
                38.9938018
              ],
              [
                45.4494691,
                38.9944591
              ],
              [
                45.4487791,
                38.9945881
              ],
              [
                45.4464142,
                38.9968426
              ],
              [
                45.4454308,
                38.9982848
              ],
              [
                45.4435936,
                38.9995619
              ],
              [
                45.4403996,
                39.0032959
              ],
              [
                45.4383272,
                39.0044242
              ],
              [
                45.4379406,
                39.0063856
              ],
              [
                45.4388517,
                39.0087063
              ],
              [
                45.4386118,
                39.0097039
              ],
              [
                45.437712,
                39.0102201
              ],
              [
                45.4371892,
                39.0108721
              ],
              [
                45.4368899,
                39.0117784
              ],
              [
                45.4370592,
                39.0127601
              ],
              [
                45.4374816,
                39.013617
              ],
              [
                45.4400106,
                39.0169683
              ],
              [
                45.4401791,
                39.0178957
              ],
              [
                45.4465145,
                39.0244808
              ],
              [
                45.4464797,
                39.0251457
              ],
              [
                45.4469407,
                39.025789
              ],
              [
                45.4480598,
                39.0262096
              ],
              [
                45.4501057,
                39.0290281
              ],
              [
                45.4505518,
                39.0306275
              ],
              [
                45.4504859,
                39.032183
              ],
              [
                45.4500732,
                39.0333884
              ],
              [
                45.4497973,
                39.0344326
              ],
              [
                45.4497695,
                39.0350944
              ],
              [
                45.4507083,
                39.0378902
              ],
              [
                45.4504282,
                39.03873
              ],
              [
                45.4503496,
                39.0395054
              ],
              [
                45.4524792,
                39.0424516
              ],
              [
                45.4543383,
                39.0439579
              ],
              [
                45.455993,
                39.0450199
              ],
              [
                45.4566119,
                39.0469824
              ],
              [
                45.4555844,
                39.049068
              ],
              [
                45.455739,
                39.0496005
              ],
              [
                45.4566746,
                39.0498014
              ],
              [
                45.4570328,
                39.0502444
              ],
              [
                45.4569034,
                39.0511283
              ],
              [
                45.4562818,
                39.0519076
              ],
              [
                45.4537021,
                39.0538212
              ],
              [
                45.4527006,
                39.055054
              ],
              [
                45.4465657,
                39.0548363
              ],
              [
                45.443887,
                39.0538674
              ],
              [
                45.4418409,
                39.0517737
              ],
              [
                45.4407091,
                39.0514081
              ],
              [
                45.4393141,
                39.0514762
              ],
              [
                45.4373305,
                39.0526839
              ],
              [
                45.4349778,
                39.0527333
              ],
              [
                45.4344127,
                39.053213
              ],
              [
                45.4332662,
                39.0533489
              ],
              [
                45.4318257,
                39.0549157
              ],
              [
                45.4320995,
                39.0561796
              ],
              [
                45.4303469,
                39.0595101
              ],
              [
                45.4303868,
                39.0606386
              ],
              [
                45.4291246,
                39.0611952
              ],
              [
                45.4277872,
                39.0611753
              ],
              [
                45.4254471,
                39.0609063
              ],
              [
                45.42238,
                39.0625038
              ],
              [
                45.4201856,
                39.0629159
              ],
              [
                45.4184397,
                39.0638454
              ],
              [
                45.4177622,
                39.0651725
              ],
              [
                45.4158259,
                39.0663867
              ],
              [
                45.4141415,
                39.0682985
              ],
              [
                45.4130527,
                39.0686128
              ],
              [
                45.4093028,
                39.0709281
              ],
              [
                45.4064895,
                39.0722315
              ],
              [
                45.4030843,
                39.0727792
              ],
              [
                45.4020553,
                39.0748882
              ],
              [
                45.4005459,
                39.0768259
              ],
              [
                45.3998628,
                39.082567
              ],
              [
                45.400663,
                39.0859288
              ],
              [
                45.4020924,
                39.088302
              ],
              [
                45.4024111,
                39.0916736
              ],
              [
                45.3987172,
                39.094991
              ],
              [
                45.3901148,
                39.1018795
              ],
              [
                45.3870491,
                39.105195
              ],
              [
                45.3840844,
                39.1069178
              ],
              [
                45.376111,
                39.1090251
              ],
              [
                45.3708976,
                39.11182
              ],
              [
                45.3691225,
                39.1133288
              ],
              [
                45.3663959,
                39.1173121
              ],
              [
                45.3652116,
                39.1198219
              ],
              [
                45.3638892,
                39.1212006
              ],
              [
                45.3637801,
                39.1212901
              ],
              [
                45.3618421,
                39.1228787
              ],
              [
                45.3601889,
                39.1235341
              ],
              [
                45.3585009,
                39.1240269
              ],
              [
                45.3546876,
                39.1263944
              ],
              [
                45.3529652,
                39.1293834
              ],
              [
                45.352587,
                39.1329547
              ],
              [
                45.3540359,
                39.1351921
              ],
              [
                45.3603949,
                39.1401906
              ],
              [
                45.3622142,
                39.1439679
              ],
              [
                45.3631991,
                39.1472832
              ],
              [
                45.3631653,
                39.1508581
              ],
              [
                45.360758,
                39.1559525
              ],
              [
                45.3497813,
                39.1705737
              ],
              [
                45.3476515,
                39.1710528
              ],
              [
                45.3449798,
                39.1709314
              ],
              [
                45.3414806,
                39.1695087
              ],
              [
                45.3347643,
                39.1690369
              ],
              [
                45.329266,
                39.1698773
              ],
              [
                45.321512,
                39.1679353
              ],
              [
                45.3134923,
                39.1661377
              ],
              [
                45.3075085,
                39.1657765
              ],
              [
                45.3042399,
                39.166023
              ],
              [
                45.3040367,
                39.1700064
              ],
              [
                45.3135905,
                39.1752936
              ],
              [
                45.3250085,
                39.1806191
              ],
              [
                45.3275812,
                39.1859033
              ],
              [
                45.3260119,
                39.1902296
              ],
              [
                45.3201164,
                39.1961805
              ],
              [
                45.316613,
                39.1984975
              ],
              [
                45.3133785,
                39.2001895
              ],
              [
                45.3084994,
                39.2016259
              ],
              [
                45.306088,
                39.2017751
              ],
              [
                45.3025922,
                39.2012281
              ],
              [
                45.3009218,
                39.2006187
              ],
              [
                45.2993434,
                39.1903979
              ],
              [
                45.2963509,
                39.1878318
              ],
              [
                45.2856562,
                39.1833438
              ],
              [
                45.2770447,
                39.1845762
              ],
              [
                45.2729092,
                39.185898
              ],
              [
                45.2476296,
                39.1856003
              ],
              [
                45.2372821,
                39.1935656
              ],
              [
                45.2311289,
                39.1940917
              ],
              [
                45.2168433,
                39.2087208
              ],
              [
                45.2036497,
                39.2036509
              ],
              [
                45.1994207,
                39.2047839
              ],
              [
                45.1979446,
                39.211562
              ],
              [
                45.1946249,
                39.2142296
              ],
              [
                45.1899503,
                39.2153513
              ],
              [
                45.1847708,
                39.2205229
              ],
              [
                45.1781489,
                39.2225268
              ],
              [
                45.1734376,
                39.223156
              ],
              [
                45.1710902,
                39.221693
              ],
              [
                45.1695536,
                39.2185696
              ],
              [
                45.1675393,
                39.2157778
              ],
              [
                45.1615157,
                39.2129691
              ],
              [
                45.1555585,
                39.2086202
              ],
              [
                45.1517015,
                39.2060229
              ],
              [
                45.1502993,
                39.2060902
              ],
              [
                45.1495258,
                39.2073141
              ],
              [
                45.1493611,
                39.2092421
              ],
              [
                45.1494355,
                39.2129614
              ],
              [
                45.1499231,
                39.2163997
              ],
              [
                45.1499504,
                39.2204266
              ],
              [
                45.1480671,
                39.229162
              ],
              [
                45.1482903,
                39.2320253
              ],
              [
                45.150881,
                39.235741
              ],
              [
                45.1522099,
                39.2399774
              ],
              [
                45.1520381,
                39.2415099
              ],
              [
                45.151415,
                39.2431485
              ],
              [
                45.148376,
                39.2462569
              ],
              [
                45.1468968,
                39.2492289
              ],
              [
                45.1462174,
                39.2538683
              ],
              [
                45.1478079,
                39.257603
              ],
              [
                45.1486946,
                39.2610799
              ],
              [
                45.148409,
                39.2634873
              ],
              [
                45.1476423,
                39.2643321
              ],
              [
                45.1369904,
                39.2680059
              ],
              [
                45.1358209,
                39.2692529
              ],
              [
                45.1346898,
                39.2713856
              ],
              [
                45.1345036,
                39.2720432
              ],
              [
                45.1347433,
                39.2727632
              ],
              [
                45.1359418,
                39.274113
              ],
              [
                45.1402596,
                39.2768268
              ],
              [
                45.1419404,
                39.2788438
              ],
              [
                45.142576,
                39.2825384
              ],
              [
                45.1419814,
                39.2844706
              ],
              [
                45.1410211,
                39.2858877
              ],
              [
                45.1389025,
                39.2870836
              ],
              [
                45.1309438,
                39.2891605
              ],
              [
                45.1266727,
                39.2882763
              ],
              [
                45.1220074,
                39.2868347
              ],
              [
                45.1206625,
                39.2855806
              ],
              [
                45.1189959,
                39.2861254
              ],
              [
                45.1178194,
                39.2868354
              ],
              [
                45.1175493,
                39.2874466
              ],
              [
                45.1179509,
                39.2886626
              ],
              [
                45.1190056,
                39.2895772
              ],
              [
                45.1245888,
                39.2914802
              ],
              [
                45.1270715,
                39.2930516
              ],
              [
                45.1288319,
                39.2946993
              ],
              [
                45.1293869,
                39.2963332
              ],
              [
                45.1286003,
                39.3012738
              ],
              [
                45.1273271,
                39.3035959
              ],
              [
                45.1267726,
                39.3041421
              ],
              [
                45.1260393,
                39.3045072
              ],
              [
                45.1196051,
                39.3058263
              ],
              [
                45.1087317,
                39.3092312
              ],
              [
                45.1078768,
                39.3102651
              ],
              [
                45.1073818,
                39.311527
              ],
              [
                45.1070452,
                39.3155736
              ],
              [
                45.1067541,
                39.3166533
              ],
              [
                45.10332,
                39.3221804
              ],
              [
                45.104092,
                39.3268721
              ],
              [
                45.103536,
                39.3291159
              ],
              [
                45.1021273,
                39.3326582
              ],
              [
                45.1013315,
                39.3333181
              ],
              [
                45.1002158,
                39.333693
              ],
              [
                45.0980664,
                39.3332672
              ],
              [
                45.0922162,
                39.3305683
              ],
              [
                45.0896154,
                39.3288583
              ],
              [
                45.0887372,
                39.3287403
              ],
              [
                45.0876976,
                39.3288577
              ],
              [
                45.0862784,
                39.3292142
              ],
              [
                45.0851717,
                39.3296664
              ],
              [
                45.0803208,
                39.3335707
              ],
              [
                45.080014,
                39.3348005
              ],
              [
                45.0812725,
                39.3367812
              ],
              [
                45.0855059,
                39.3420762
              ],
              [
                45.0863316,
                39.3438036
              ],
              [
                45.0870302,
                39.3473822
              ],
              [
                45.0867037,
                39.3512472
              ],
              [
                45.0830432,
                39.3544971
              ],
              [
                45.0792117,
                39.3564479
              ],
              [
                45.0764062,
                39.3584772
              ],
              [
                45.0733874,
                39.3598961
              ],
              [
                45.0701556,
                39.3605462
              ],
              [
                45.0681453,
                39.3605707
              ],
              [
                45.0620956,
                39.3622907
              ],
              [
                45.0571425,
                39.364346
              ],
              [
                45.0566199,
                39.3651543
              ],
              [
                45.0566314,
                39.3660599
              ],
              [
                45.0577276,
                39.3697118
              ],
              [
                45.0576315,
                39.3715865
              ],
              [
                45.0588906,
                39.379951
              ],
              [
                45.0581208,
                39.3812002
              ],
              [
                45.0563447,
                39.3821398
              ],
              [
                45.0544989,
                39.3823687
              ],
              [
                45.0524401,
                39.3821679
              ],
              [
                45.0492161,
                39.3802806
              ],
              [
                45.0467794,
                39.3795631
              ],
              [
                45.0459142,
                39.3795297
              ],
              [
                45.045259,
                39.3796865
              ],
              [
                45.04275,
                39.3822168
              ],
              [
                45.0419998,
                39.3849729
              ],
              [
                45.0416875,
                39.3861149
              ],
              [
                45.0414201,
                39.3881673
              ],
              [
                45.0415972,
                39.3901113
              ],
              [
                45.0412333,
                39.3910499
              ],
              [
                45.0406809,
                39.3912907
              ],
              [
                45.0400375,
                39.3912143
              ],
              [
                45.0367839,
                39.3903329
              ],
              [
                45.0350804,
                39.3905373
              ],
              [
                45.033612,
                39.3910222
              ],
              [
                45.0294411,
                39.3942767
              ],
              [
                45.0267108,
                39.3973923
              ],
              [
                45.0241204,
                39.3987462
              ],
              [
                45.0220252,
                39.4005384
              ],
              [
                45.0212464,
                39.402183
              ],
              [
                45.0205446,
                39.4032346
              ],
              [
                45.0195747,
                39.4042517
              ],
              [
                45.0181831,
                39.4048917
              ],
              [
                45.0171168,
                39.4057326
              ],
              [
                45.010569,
                39.4044919
              ],
              [
                45.0097002,
                39.4047211
              ],
              [
                45.0090083,
                39.4054406
              ],
              [
                45.0081162,
                39.4066349
              ],
              [
                45.0075211,
                39.4087862
              ],
              [
                45.0065811,
                39.4099323
              ],
              [
                45.0058494,
                39.4103658
              ],
              [
                45.005198,
                39.4104253
              ],
              [
                45.0024228,
                39.4097039
              ],
              [
                44.99956,
                39.4086705
              ],
              [
                44.9981639,
                39.4090545
              ],
              [
                44.9969354,
                39.4097642
              ],
              [
                44.9959467,
                39.4128968
              ],
              [
                44.9885707,
                39.4153007
              ],
              [
                44.9851965,
                39.4168493
              ],
              [
                44.9830971,
                39.4185211
              ],
              [
                44.9706206,
                39.4195778
              ],
              [
                44.966279,
                39.4205157
              ],
              [
                44.9651438,
                39.4210425
              ],
              [
                44.9645597,
                39.421841
              ],
              [
                44.9637775,
                39.4237607
              ],
              [
                44.9642264,
                39.4260323
              ],
              [
                44.9656209,
                39.429032
              ],
              [
                44.9652704,
                39.4322654
              ],
              [
                44.9619803,
                39.4360202
              ],
              [
                44.9600851,
                39.4395834
              ],
              [
                44.9608079,
                39.4421583
              ],
              [
                44.9620063,
                39.4427289
              ],
              [
                44.9648066,
                39.442277
              ],
              [
                44.9667014,
                39.4423001
              ],
              [
                44.9694826,
                39.4437195
              ],
              [
                44.9736216,
                39.4444942
              ],
              [
                44.9768556,
                39.4468659
              ],
              [
                44.9771798,
                39.4487743
              ],
              [
                44.97645,
                39.4500713
              ],
              [
                44.9756505,
                39.4507241
              ],
              [
                44.9747128,
                39.4510923
              ],
              [
                44.9700168,
                39.4515917
              ],
              [
                44.9610917,
                39.4506017
              ],
              [
                44.9508689,
                39.4522111
              ],
              [
                44.9482411,
                39.4516666
              ],
              [
                44.947164,
                39.4516525
              ],
              [
                44.9466634,
                39.4520852
              ],
              [
                44.9465007,
                39.4560927
              ],
              [
                44.9457195,
                39.4572425
              ],
              [
                44.9423852,
                39.4581819
              ],
              [
                44.9399284,
                39.459659
              ],
              [
                44.93943,
                39.4609501
              ],
              [
                44.9398938,
                39.462458
              ],
              [
                44.9422981,
                39.4643224
              ],
              [
                44.9430179,
                39.4657772
              ],
              [
                44.9438052,
                39.4672187
              ],
              [
                44.9446009,
                39.4679127
              ],
              [
                44.9475002,
                39.469735
              ],
              [
                44.9484734,
                39.4715422
              ],
              [
                44.9477582,
                39.4727013
              ],
              [
                44.9438516,
                39.4738787
              ],
              [
                44.9386333,
                39.4773109
              ],
              [
                44.9368034,
                39.4798184
              ],
              [
                44.9369091,
                39.4807141
              ],
              [
                44.9382528,
                39.4816477
              ],
              [
                44.9424811,
                39.4812672
              ],
              [
                44.9449643,
                39.4818972
              ],
              [
                44.9471586,
                39.4817492
              ],
              [
                44.9493402,
                39.4824819
              ],
              [
                44.9502924,
                39.4833062
              ],
              [
                44.9508425,
                39.4840928
              ],
              [
                44.9503456,
                39.4848242
              ],
              [
                44.948938,
                39.4851822
              ],
              [
                44.945875,
                39.4843047
              ],
              [
                44.9427063,
                39.483749
              ],
              [
                44.9409906,
                39.4841874
              ],
              [
                44.9383999,
                39.4862826
              ],
              [
                44.9378437,
                39.4874847
              ],
              [
                44.9384172,
                39.4886931
              ],
              [
                44.940054,
                39.4896523
              ],
              [
                44.9430497,
                39.4894469
              ],
              [
                44.9466623,
                39.4877763
              ],
              [
                44.9496831,
                39.4879646
              ],
              [
                44.9514032,
                39.489126
              ],
              [
                44.951985,
                39.4908229
              ],
              [
                44.9518498,
                39.4921687
              ],
              [
                44.9473649,
                39.4975582
              ],
              [
                44.9406013,
                39.502379
              ],
              [
                44.9393255,
                39.504389
              ],
              [
                44.9385323,
                39.5094695
              ],
              [
                44.9365256,
                39.5119345
              ],
              [
                44.9353655,
                39.5121697
              ],
              [
                44.9342607,
                39.5110611
              ],
              [
                44.9321974,
                39.5112316
              ],
              [
                44.9294807,
                39.5118676
              ],
              [
                44.927262,
                39.5130524
              ],
              [
                44.9259744,
                39.5146754
              ],
              [
                44.9236034,
                39.5161217
              ],
              [
                44.9181521,
                39.5177937
              ],
              [
                44.9162606,
                39.5192413
              ],
              [
                44.9147683,
                39.5206847
              ],
              [
                44.9126451,
                39.5224378
              ],
              [
                44.9097716,
                39.5250712
              ],
              [
                44.9091986,
                39.5280743
              ],
              [
                44.9149769,
                39.529961
              ],
              [
                44.917158,
                39.5311971
              ],
              [
                44.9185951,
                39.5332089
              ],
              [
                44.9181024,
                39.534502
              ],
              [
                44.9129285,
                39.5371574
              ],
              [
                44.9068803,
                39.5386501
              ],
              [
                44.9065841,
                39.5395316
              ],
              [
                44.9102146,
                39.5452039
              ],
              [
                44.9103357,
                39.5468422
              ],
              [
                44.9112731,
                39.5487564
              ],
              [
                44.908342,
                39.5561385
              ],
              [
                44.9086367,
                39.5599898
              ],
              [
                44.9107743,
                39.5619948
              ],
              [
                44.9129652,
                39.5636627
              ],
              [
                44.91544,
                39.565095
              ],
              [
                44.9157487,
                39.5659961
              ],
              [
                44.9151449,
                39.567184
              ],
              [
                44.9110488,
                39.5689584
              ],
              [
                44.9092891,
                39.5708872
              ],
              [
                44.9057982,
                39.5756271
              ],
              [
                44.9035856,
                39.576759
              ],
              [
                44.8901074,
                39.5795194
              ],
              [
                44.8883296,
                39.5817248
              ],
              [
                44.8880634,
                39.5838121
              ],
              [
                44.8919728,
                39.5888056
              ],
              [
                44.8854394,
                39.5850225
              ],
              [
                44.8824377,
                39.5799544
              ],
              [
                44.8836368,
                39.5656399
              ],
              [
                44.8817777,
                39.5626888
              ],
              [
                44.8792937,
                39.559884
              ],
              [
                44.8759697,
                39.5580587
              ],
              [
                44.8713767,
                39.5437131
              ],
              [
                44.8724203,
                39.5380143
              ],
              [
                44.8738416,
                39.5346978
              ],
              [
                44.8741229,
                39.5285984
              ],
              [
                44.8759708,
                39.5178942
              ],
              [
                44.8679523,
                39.5036214
              ],
              [
                44.8515653,
                39.4919518
              ],
              [
                44.8515653,
                39.4916741
              ],
              [
                44.8450723,
                39.4910832
              ],
              [
                44.8326016,
                39.4810119
              ],
              [
                44.8281568,
                39.4714523
              ],
              [
                44.8278436,
                39.460542
              ],
              [
                44.8281241,
                39.4594308
              ],
              [
                44.8286773,
                39.4572085
              ],
              [
                44.8256287,
                39.4402949
              ],
              [
                44.8267389,
                39.434183
              ],
              [
                44.8233093,
                39.4141293
              ],
              [
                44.8182161,
                39.3895035
              ],
              [
                44.817659,
                39.3889477
              ],
              [
                44.8103705,
                39.3688584
              ],
              [
                44.7940062,
                39.3519542
              ],
              [
                44.7772437,
                39.3450975
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555268,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پیرانشهر",
          "name:en": "Piranshahr County",
          "name:ku": "Pîranşar",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1294744",
          "wikipedia": "en:Piranshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.858667,
                36.773118
              ],
              [
                44.858981,
                36.773799
              ],
              [
                44.85903,
                36.774071
              ],
              [
                44.859681,
                36.77438
              ],
              [
                44.859786,
                36.774589
              ],
              [
                44.85971,
                36.775118
              ],
              [
                44.860254,
                36.775821
              ],
              [
                44.860535,
                36.776123
              ],
              [
                44.860949,
                36.776051
              ],
              [
                44.861356,
                36.776146
              ],
              [
                44.862115,
                36.776057
              ],
              [
                44.862267,
                36.776253
              ],
              [
                44.862418,
                36.77684
              ],
              [
                44.862932,
                36.778009
              ],
              [
                44.862943,
                36.778538
              ],
              [
                44.863266,
                36.778899
              ],
              [
                44.863796,
                36.779319
              ],
              [
                44.864767,
                36.779896
              ],
              [
                44.865419,
                36.779873
              ],
              [
                44.865894,
                36.779945
              ],
              [
                44.866848,
                36.779886
              ],
              [
                44.867729,
                36.780029
              ],
              [
                44.868037,
                36.779934
              ],
              [
                44.868462,
                36.779642
              ],
              [
                44.868853,
                36.779523
              ],
              [
                44.86924,
                36.779482
              ],
              [
                44.86977,
                36.7796
              ],
              [
                44.870215,
                36.779841
              ],
              [
                44.870833,
                36.779855
              ],
              [
                44.871128,
                36.780007
              ],
              [
                44.871448,
                36.780056
              ],
              [
                44.871769,
                36.77991
              ],
              [
                44.872094,
                36.779929
              ],
              [
                44.872385,
                36.779866
              ],
              [
                44.873059,
                36.779949
              ],
              [
                44.873406,
                36.780052
              ],
              [
                44.873609,
                36.779995
              ],
              [
                44.873957,
                36.779805
              ],
              [
                44.874496,
                36.779961
              ],
              [
                44.874843,
                36.779917
              ],
              [
                44.875814,
                36.779907
              ],
              [
                44.876778,
                36.780073
              ],
              [
                44.877499,
                36.78004
              ],
              [
                44.879434,
                36.779747
              ],
              [
                44.8799,
                36.779868
              ],
              [
                44.880164,
                36.779849
              ],
              [
                44.880598,
                36.779994
              ],
              [
                44.881273,
                36.780379
              ],
              [
                44.882225,
                36.781044
              ],
              [
                44.882733,
                36.781322
              ],
              [
                44.883088,
                36.78199
              ],
              [
                44.884399,
                36.782213
              ],
              [
                44.885286,
                36.782508
              ],
              [
                44.886811,
                36.78257
              ],
              [
                44.887598,
                36.782541
              ],
              [
                44.888663,
                36.782411
              ],
              [
                44.889895,
                36.782392
              ],
              [
                44.890965,
                36.782421
              ],
              [
                44.891235,
                36.782481
              ],
              [
                44.89147,
                36.782245
              ],
              [
                44.891647,
                36.781841
              ],
              [
                44.891977,
                36.781429
              ],
              [
                44.892852,
                36.780949
              ],
              [
                44.893223,
                36.780521
              ],
              [
                44.893678,
                36.780123
              ],
              [
                44.894389,
                36.77969
              ],
              [
                44.895203,
                36.779309
              ],
              [
                44.895587,
                36.779216
              ],
              [
                44.896137,
                36.779166
              ],
              [
                44.896743,
                36.778954
              ],
              [
                44.897477,
                36.778845
              ],
              [
                44.899519,
                36.779286
              ],
              [
                44.900557,
                36.779263
              ],
              [
                44.902425,
                36.779098
              ],
              [
                44.902825,
                36.779031
              ],
              [
                44.903673,
                36.778734
              ],
              [
                44.904309,
                36.778429
              ],
              [
                44.904893,
                36.778017
              ],
              [
                44.905748,
                36.777665
              ],
              [
                44.906185,
                36.777643
              ],
              [
                44.906613,
                36.777711
              ],
              [
                44.90729,
                36.778003
              ],
              [
                44.907811,
                36.77817
              ],
              [
                44.909023,
                36.778112
              ],
              [
                44.910018,
                36.777869
              ],
              [
                44.910364,
                36.777676
              ],
              [
                44.910721,
                36.777161
              ],
              [
                44.910847,
                36.776571
              ],
              [
                44.91098,
                36.776246
              ],
              [
                44.911496,
                36.776193
              ],
              [
                44.91221,
                36.776256
              ],
              [
                44.913151,
                36.776218
              ],
              [
                44.914293,
                36.776269
              ],
              [
                44.915624,
                36.776403
              ],
              [
                44.916615,
                36.776267
              ],
              [
                44.917995,
                36.775851
              ],
              [
                44.9185946,
                36.7756898
              ],
              [
                44.9189269,
                36.7756198
              ],
              [
                44.9190676,
                36.7756549
              ],
              [
                44.919133,
                36.775963
              ],
              [
                44.919431,
                36.776246
              ],
              [
                44.920747,
                36.77645
              ],
              [
                44.92134,
                36.776437
              ],
              [
                44.921841,
                36.776528
              ],
              [
                44.92268,
                36.776969
              ],
              [
                44.924386,
                36.77718
              ],
              [
                44.924823,
                36.777282
              ],
              [
                44.925481,
                36.777666
              ],
              [
                44.927002,
                36.778175
              ],
              [
                44.927611,
                36.778461
              ],
              [
                44.928113,
                36.77864
              ],
              [
                44.928882,
                36.779227
              ],
              [
                44.930037,
                36.779489
              ],
              [
                44.930448,
                36.779738
              ],
              [
                44.93127,
                36.781331
              ],
              [
                44.931385,
                36.781467
              ],
              [
                44.931748,
                36.781684
              ],
              [
                44.932125,
                36.78201
              ],
              [
                44.932236,
                36.782235
              ],
              [
                44.932447,
                36.783068
              ],
              [
                44.932673,
                36.783553
              ],
              [
                44.932728,
                36.783996
              ],
              [
                44.932864,
                36.784212
              ],
              [
                44.933559,
                36.784612
              ],
              [
                44.934488,
                36.784913
              ],
              [
                44.934912,
                36.784968
              ],
              [
                44.935547,
                36.784903
              ],
              [
                44.936167,
                36.784947
              ],
              [
                44.936462,
                36.785096
              ],
              [
                44.937013,
                36.785493
              ],
              [
                44.93827,
                36.786129
              ],
              [
                44.938773,
                36.786126
              ],
              [
                44.940179,
                36.785928
              ],
              [
                44.940995,
                36.78521
              ],
              [
                44.941414,
                36.784982
              ],
              [
                44.942352,
                36.784651
              ],
              [
                44.942538,
                36.784499
              ],
              [
                44.943009,
                36.783898
              ],
              [
                44.943225,
                36.783715
              ],
              [
                44.943618,
                36.783189
              ],
              [
                44.944059,
                36.782758
              ],
              [
                44.944448,
                36.782464
              ],
              [
                44.945131,
                36.781783
              ],
              [
                44.945383,
                36.781593
              ],
              [
                44.945704,
                36.781471
              ],
              [
                44.945829,
                36.781342
              ],
              [
                44.946278,
                36.781203
              ],
              [
                44.946724,
                36.780873
              ],
              [
                44.947219,
                36.780317
              ],
              [
                44.948655,
                36.77962
              ],
              [
                44.949093,
                36.77926
              ],
              [
                44.949227,
                36.779042
              ],
              [
                44.949816,
                36.778585
              ],
              [
                44.949913,
                36.778333
              ],
              [
                44.951381,
                36.777289
              ],
              [
                44.951764,
                36.77685
              ],
              [
                44.951831,
                36.776404
              ],
              [
                44.952119,
                36.775799
              ],
              [
                44.952314,
                36.775561
              ],
              [
                44.952356,
                36.77535
              ],
              [
                44.952597,
                36.774855
              ],
              [
                44.953024,
                36.774537
              ],
              [
                44.953637,
                36.774351
              ],
              [
                44.953834,
                36.7741
              ],
              [
                44.954309,
                36.773672
              ],
              [
                44.954583,
                36.773584
              ],
              [
                44.955119,
                36.773518
              ],
              [
                44.955706,
                36.773217
              ],
              [
                44.95594,
                36.773203
              ],
              [
                44.956344,
                36.773085
              ],
              [
                44.957696,
                36.772913
              ],
              [
                44.958194,
                36.772752
              ],
              [
                44.958298,
                36.772059
              ],
              [
                44.958484,
                36.771787
              ],
              [
                44.958623,
                36.771284
              ],
              [
                44.959071,
                36.770372
              ],
              [
                44.959259,
                36.770251
              ],
              [
                44.959734,
                36.769498
              ],
              [
                44.959973,
                36.769239
              ],
              [
                44.960159,
                36.768604
              ],
              [
                44.960421,
                36.768288
              ],
              [
                44.960932,
                36.767973
              ],
              [
                44.961251,
                36.76754
              ],
              [
                44.961467,
                36.766953
              ],
              [
                44.96156,
                36.766462
              ],
              [
                44.96158,
                36.76597
              ],
              [
                44.961754,
                36.765331
              ],
              [
                44.961945,
                36.765099
              ],
              [
                44.962248,
                36.764931
              ],
              [
                44.962566,
                36.764681
              ],
              [
                44.962951,
                36.764366
              ],
              [
                44.963112,
                36.764165
              ],
              [
                44.963175,
                36.76399
              ],
              [
                44.963092,
                36.763018
              ],
              [
                44.963172,
                36.762827
              ],
              [
                44.963734,
                36.762455
              ],
              [
                44.964028,
                36.762093
              ],
              [
                44.964433,
                36.761775
              ],
              [
                44.965012,
                36.761444
              ],
              [
                44.965809,
                36.760818
              ],
              [
                44.966572,
                36.759763
              ],
              [
                44.967016,
                36.75902
              ],
              [
                44.967232,
                36.758494
              ],
              [
                44.967271,
                36.75807
              ],
              [
                44.967423,
                36.757715
              ],
              [
                44.967308,
                36.757252
              ],
              [
                44.967324,
                36.756641
              ],
              [
                44.967459,
                36.756369
              ],
              [
                44.967562,
                36.755894
              ],
              [
                44.967807,
                36.755594
              ],
              [
                44.967869,
                36.755419
              ],
              [
                44.96782,
                36.755237
              ],
              [
                44.967996,
                36.754403
              ],
              [
                44.967957,
                36.753757
              ],
              [
                44.968093,
                36.753525
              ],
              [
                44.968856,
                36.752651
              ],
              [
                44.968941,
                36.752357
              ],
              [
                44.968869,
                36.751678
              ],
              [
                44.969078,
                36.751441
              ],
              [
                44.970755,
                36.750756
              ],
              [
                44.971041,
                36.750524
              ],
              [
                44.971583,
                36.750218
              ],
              [
                44.972088,
                36.750001
              ],
              [
                44.972409,
                36.749348
              ],
              [
                44.972765,
                36.749292
              ],
              [
                44.973149,
                36.749303
              ],
              [
                44.974624,
                36.749098
              ],
              [
                44.975088,
                36.748951
              ],
              [
                44.975354,
                36.74892
              ],
              [
                44.975676,
                36.748961
              ],
              [
                44.976193,
                36.74884
              ],
              [
                44.976806,
                36.748575
              ],
              [
                44.978387,
                36.748368
              ],
              [
                44.978797,
                36.748429
              ],
              [
                44.979314,
                36.748443
              ],
              [
                44.980171,
                36.748386
              ],
              [
                44.981147,
                36.74819
              ],
              [
                44.982268,
                36.748419
              ],
              [
                44.982892,
                36.748476
              ],
              [
                44.983773,
                36.74828
              ],
              [
                44.984186,
                36.748079
              ],
              [
                44.984662,
                36.747749
              ],
              [
                44.9851,
                36.747687
              ],
              [
                44.985455,
                36.747677
              ],
              [
                44.985812,
                36.747765
              ],
              [
                44.986087,
                36.747949
              ],
              [
                44.986353,
                36.748009
              ],
              [
                44.986809,
                36.747939
              ],
              [
                44.987287,
                36.747945
              ],
              [
                44.987665,
                36.747871
              ],
              [
                44.988364,
                36.747839
              ],
              [
                44.989509,
                36.747659
              ],
              [
                44.989719,
                36.747782
              ],
              [
                44.990014,
                36.748131
              ],
              [
                44.990194,
                36.748224
              ],
              [
                44.990623,
                36.748621
              ],
              [
                44.990951,
                36.749052
              ],
              [
                44.991105,
                36.749372
              ],
              [
                44.991546,
                36.750015
              ],
              [
                44.99284,
                36.750786
              ],
              [
                44.993595,
                36.750877
              ],
              [
                44.994313,
                36.750753
              ],
              [
                44.99453,
                36.750778
              ],
              [
                44.994938,
                36.751059
              ],
              [
                44.996217,
                36.752344
              ],
              [
                44.997001,
                36.75289
              ],
              [
                44.997655,
                36.753217
              ],
              [
                44.998307,
                36.753456
              ],
              [
                44.999709,
                36.753323
              ],
              [
                45.001234,
                36.752872
              ],
              [
                45.001765,
                36.752879
              ],
              [
                45.002714,
                36.753034
              ],
              [
                45.003814,
                36.753602
              ],
              [
                45.004696,
                36.753835
              ],
              [
                45.00547,
                36.753964
              ],
              [
                45.006016,
                36.754277
              ],
              [
                45.006529,
                36.754397
              ],
              [
                45.006873,
                36.754216
              ],
              [
                45.007204,
                36.754159
              ],
              [
                45.008004,
                36.75412
              ],
              [
                45.008584,
                36.753953
              ],
              [
                45.009264,
                36.753858
              ],
              [
                45.009861,
                36.753875
              ],
              [
                45.01059,
                36.753771
              ],
              [
                45.011072,
                36.753577
              ],
              [
                45.012914,
                36.753236
              ],
              [
                45.013028,
                36.752975
              ],
              [
                45.012966,
                36.752601
              ],
              [
                45.013049,
                36.751773
              ],
              [
                45.012962,
                36.750809
              ],
              [
                45.0128249,
                36.7500196
              ],
              [
                45.012669,
                36.749122
              ],
              [
                45.012085,
                36.747244
              ],
              [
                45.012046,
                36.74669
              ],
              [
                45.012099,
                36.746439
              ],
              [
                45.012568,
                36.746247
              ],
              [
                45.013726,
                36.746157
              ],
              [
                45.014138,
                36.74624
              ],
              [
                45.01478,
                36.746106
              ],
              [
                45.015938,
                36.745972
              ],
              [
                45.016461,
                36.745958
              ],
              [
                45.016951,
                36.74583
              ],
              [
                45.017474,
                36.745475
              ],
              [
                45.018017,
                36.744589
              ],
              [
                45.018305,
                36.744012
              ],
              [
                45.018518,
                36.743868
              ],
              [
                45.01885,
                36.743745
              ],
              [
                45.019564,
                36.743863
              ],
              [
                45.020274,
                36.743874
              ],
              [
                45.020724,
                36.743809
              ],
              [
                45.022137,
                36.743763
              ],
              [
                45.023246,
                36.743846
              ],
              [
                45.023968,
                36.743717
              ],
              [
                45.024669,
                36.743237
              ],
              [
                45.02513,
                36.74326
              ],
              [
                45.025403,
                36.743107
              ],
              [
                45.02569,
                36.742725
              ],
              [
                45.026078,
                36.742572
              ],
              [
                45.026739,
                36.742405
              ],
              [
                45.027064,
                36.742164
              ],
              [
                45.027419,
                36.742125
              ],
              [
                45.028387,
                36.741788
              ],
              [
                45.028625,
                36.741641
              ],
              [
                45.028783,
                36.741389
              ],
              [
                45.029128,
                36.741174
              ],
              [
                45.029591,
                36.74102
              ],
              [
                45.029953,
                36.74096
              ],
              [
                45.030589,
                36.740471
              ],
              [
                45.031236,
                36.739745
              ],
              [
                45.031804,
                36.738963
              ],
              [
                45.032064,
                36.738301
              ],
              [
                45.032184,
                36.737494
              ],
              [
                45.032327,
                36.737048
              ],
              [
                45.032761,
                36.736514
              ],
              [
                45.033142,
                36.736244
              ],
              [
                45.033416,
                36.735953
              ],
              [
                45.033133,
                36.735656
              ],
              [
                45.032727,
                36.735418
              ],
              [
                45.032115,
                36.735214
              ],
              [
                45.031437,
                36.734903
              ],
              [
                45.031789,
                36.734117
              ],
              [
                45.03162,
                36.733496
              ],
              [
                45.031639,
                36.73191
              ],
              [
                45.031704,
                36.731319
              ],
              [
                45.031584,
                36.730925
              ],
              [
                45.031749,
                36.730328
              ],
              [
                45.032014,
                36.729822
              ],
              [
                45.032898,
                36.728624
              ],
              [
                45.033873,
                36.727578
              ],
              [
                45.034613,
                36.72719
              ],
              [
                45.035123,
                36.727116
              ],
              [
                45.035668,
                36.726711
              ],
              [
                45.036136,
                36.726438
              ],
              [
                45.037254,
                36.726047
              ],
              [
                45.037536,
                36.725882
              ],
              [
                45.037828,
                36.724919
              ],
              [
                45.038124,
                36.724664
              ],
              [
                45.038658,
                36.724586
              ],
              [
                45.039171,
                36.724659
              ],
              [
                45.039611,
                36.724655
              ],
              [
                45.039994,
                36.724208
              ],
              [
                45.040521,
                36.724013
              ],
              [
                45.040694,
                36.723817
              ],
              [
                45.039883,
                36.722929
              ],
              [
                45.039623,
                36.72244
              ],
              [
                45.0397,
                36.721847
              ],
              [
                45.039934,
                36.721317
              ],
              [
                45.040711,
                36.720146
              ],
              [
                45.041022,
                36.719898
              ],
              [
                45.041475,
                36.719893
              ],
              [
                45.041899,
                36.720059
              ],
              [
                45.042477,
                36.720003
              ],
              [
                45.043665,
                36.71904
              ],
              [
                45.044708,
                36.718376
              ],
              [
                45.045167,
                36.718025
              ],
              [
                45.045602,
                36.717816
              ],
              [
                45.046043,
                36.717674
              ],
              [
                45.046535,
                36.715646
              ],
              [
                45.047019,
                36.71474
              ],
              [
                45.047448,
                36.714463
              ],
              [
                45.047731,
                36.713472
              ],
              [
                45.047821,
                36.712877
              ],
              [
                45.048126,
                36.712561
              ],
              [
                45.049039,
                36.711978
              ],
              [
                45.049423,
                36.711629
              ],
              [
                45.049781,
                36.710587
              ],
              [
                45.05028,
                36.710013
              ],
              [
                45.050411,
                36.709706
              ],
              [
                45.050905,
                36.709113
              ],
              [
                45.051379,
                36.708907
              ],
              [
                45.0519,
                36.708369
              ],
              [
                45.052308,
                36.708105
              ],
              [
                45.05257,
                36.707589
              ],
              [
                45.053349,
                36.706379
              ],
              [
                45.054516,
                36.70483
              ],
              [
                45.054912,
                36.704479
              ],
              [
                45.055245,
                36.703942
              ],
              [
                45.055651,
                36.703443
              ],
              [
                45.056105,
                36.703122
              ],
              [
                45.057093,
                36.702536
              ],
              [
                45.057272,
                36.702221
              ],
              [
                45.057627,
                36.701121
              ],
              [
                45.057934,
                36.700814
              ],
              [
                45.058168,
                36.700422
              ],
              [
                45.058639,
                36.699931
              ],
              [
                45.059185,
                36.699113
              ],
              [
                45.059171,
                36.698693
              ],
              [
                45.059046,
                36.698192
              ],
              [
                45.059136,
                36.697784
              ],
              [
                45.059404,
                36.697425
              ],
              [
                45.059778,
                36.697039
              ],
              [
                45.060067,
                36.696617
              ],
              [
                45.06025,
                36.696135
              ],
              [
                45.060582,
                36.695824
              ],
              [
                45.061085,
                36.695495
              ],
              [
                45.061518,
                36.695139
              ],
              [
                45.062158,
                36.693745
              ],
              [
                45.062925,
                36.692674
              ],
              [
                45.063907,
                36.690821
              ],
              [
                45.064451,
                36.690643
              ],
              [
                45.06481,
                36.690387
              ],
              [
                45.065172,
                36.690003
              ],
              [
                45.065388,
                36.689456
              ],
              [
                45.065317,
                36.688504
              ],
              [
                45.065681,
                36.687991
              ],
              [
                45.065878,
                36.686867
              ],
              [
                45.06581,
                36.685511
              ],
              [
                45.065473,
                36.684603
              ],
              [
                45.065455,
                36.684124
              ],
              [
                45.065577,
                36.68374
              ],
              [
                45.06553,
                36.682509
              ],
              [
                45.065861,
                36.680999
              ],
              [
                45.066033,
                36.680518
              ],
              [
                45.0662064,
                36.6802179
              ],
              [
                45.0666309,
                36.6796927
              ],
              [
                45.067143,
                36.679135
              ],
              [
                45.067445,
                36.678623
              ],
              [
                45.0676949,
                36.6784151
              ],
              [
                45.0678528,
                36.6782678
              ],
              [
                45.067862,
                36.677797
              ],
              [
                45.0679429,
                36.6774044
              ],
              [
                45.0680241,
                36.6767979
              ],
              [
                45.0680973,
                36.6763061
              ],
              [
                45.0681134,
                36.6757667
              ],
              [
                45.0681658,
                36.6754252
              ],
              [
                45.0682528,
                36.6750554
              ],
              [
                45.0686758,
                36.6744723
              ],
              [
                45.0689369,
                36.6738719
              ],
              [
                45.0692067,
                36.6732789
              ],
              [
                45.0688249,
                36.6729026
              ],
              [
                45.0679722,
                36.6707333
              ],
              [
                45.0679562,
                36.6701579
              ],
              [
                45.0679779,
                36.6695574
              ],
              [
                45.0682623,
                36.6689238
              ],
              [
                45.0683555,
                36.6678986
              ],
              [
                45.0682811,
                36.6678835
              ],
              [
                45.0681147,
                36.6668124
              ],
              [
                45.0680509,
                36.6667027
              ],
              [
                45.06798,
                36.665541
              ],
              [
                45.0679195,
                36.6646697
              ],
              [
                45.067898,
                36.663996
              ],
              [
                45.0678789,
                36.6634876
              ],
              [
                45.067841,
                36.6626041
              ],
              [
                45.0678775,
                36.6623164
              ],
              [
                45.0681273,
                36.6611734
              ],
              [
                45.0685509,
                36.6594097
              ],
              [
                45.0687661,
                36.6592488
              ],
              [
                45.0689207,
                36.6591651
              ],
              [
                45.069311,
                36.6585671
              ],
              [
                45.0696404,
                36.6574477
              ],
              [
                45.0700634,
                36.6567004
              ],
              [
                45.0706158,
                36.655322
              ],
              [
                45.0707056,
                36.6545495
              ],
              [
                45.0706937,
                36.6537803
              ],
              [
                45.0708126,
                36.6530491
              ],
              [
                45.0709073,
                36.652599
              ],
              [
                45.0716931,
                36.6520561
              ],
              [
                45.071871,
                36.6510074
              ],
              [
                45.0718,
                36.650379
              ],
              [
                45.0716882,
                36.649531
              ],
              [
                45.0715305,
                36.6488432
              ],
              [
                45.0713006,
                36.6482044
              ],
              [
                45.0711856,
                36.6463524
              ],
              [
                45.0716859,
                36.645595
              ],
              [
                45.0711927,
                36.645119
              ],
              [
                45.0709854,
                36.6444696
              ],
              [
                45.0710173,
                36.6441499
              ],
              [
                45.0708521,
                36.643751
              ],
              [
                45.0700313,
                36.6434931
              ],
              [
                45.06969,
                36.6433595
              ],
              [
                45.0694432,
                36.6432219
              ],
              [
                45.0689478,
                36.6431331
              ],
              [
                45.0685241,
                36.6430847
              ],
              [
                45.067639,
                36.64307
              ],
              [
                45.067504,
                36.642531
              ],
              [
                45.067529,
                36.642252
              ],
              [
                45.067273,
                36.6418152
              ],
              [
                45.067546,
                36.641256
              ],
              [
                45.068026,
                36.640705
              ],
              [
                45.068382,
                36.640528
              ],
              [
                45.068593,
                36.640286
              ],
              [
                45.068745,
                36.638767
              ],
              [
                45.0693136,
                36.6383298
              ],
              [
                45.069243,
                36.638006
              ],
              [
                45.06957,
                36.637677
              ],
              [
                45.069594,
                36.637397
              ],
              [
                45.069531,
                36.637122
              ],
              [
                45.069616,
                36.636833
              ],
              [
                45.069902,
                36.63654
              ],
              [
                45.070007,
                36.636277
              ],
              [
                45.069928,
                36.635897
              ],
              [
                45.069941,
                36.63553
              ],
              [
                45.070395,
                36.6345876
              ],
              [
                45.07038,
                36.634229
              ],
              [
                45.070321,
                36.633875
              ],
              [
                45.070203,
                36.633629
              ],
              [
                45.069926,
                36.633261
              ],
              [
                45.070038,
                36.632751
              ],
              [
                45.069839,
                36.631978
              ],
              [
                45.0701111,
                36.6312757
              ],
              [
                45.0703713,
                36.6308447
              ],
              [
                45.0707771,
                36.6302428
              ],
              [
                45.0700708,
                36.6292429
              ],
              [
                45.0689563,
                36.6280882
              ],
              [
                45.068508,
                36.627535
              ],
              [
                45.068085,
                36.626819
              ],
              [
                45.067758,
                36.626086
              ],
              [
                45.067065,
                36.624941
              ],
              [
                45.066988,
                36.624521
              ],
              [
                45.067067,
                36.623702
              ],
              [
                45.067004,
                36.623289
              ],
              [
                45.066869,
                36.622977
              ],
              [
                45.066393,
                36.62221
              ],
              [
                45.066162,
                36.621688
              ],
              [
                45.065621,
                36.619898
              ],
              [
                45.06534,
                36.619423
              ],
              [
                45.064497,
                36.61736
              ],
              [
                45.064097,
                36.616639
              ],
              [
                45.063834,
                36.616003
              ],
              [
                45.063721,
                36.615452
              ],
              [
                45.063446,
                36.615094
              ],
              [
                45.062974,
                36.61466
              ],
              [
                45.062701,
                36.614538
              ],
              [
                45.061512,
                36.614528
              ],
              [
                45.061122,
                36.614671
              ],
              [
                45.060173,
                36.614847
              ],
              [
                45.059587,
                36.614875
              ],
              [
                45.057632,
                36.615158
              ],
              [
                45.057249,
                36.61528
              ],
              [
                45.056964,
                36.615435
              ],
              [
                45.0565076,
                36.6155875
              ],
              [
                45.0560943,
                36.6155959
              ],
              [
                45.0549465,
                36.6156268
              ],
              [
                45.054398,
                36.615563
              ],
              [
                45.053854,
                36.615328
              ],
              [
                45.053528,
                36.615107
              ],
              [
                45.053127,
                36.615025
              ],
              [
                45.052849,
                36.614884
              ],
              [
                45.052283,
                36.614845
              ],
              [
                45.051805,
                36.614644
              ],
              [
                45.05142,
                36.614343
              ],
              [
                45.05117,
                36.614055
              ],
              [
                45.050753,
                36.613293
              ],
              [
                45.050369,
                36.612953
              ],
              [
                45.049772,
                36.612569
              ],
              [
                45.049328,
                36.612146
              ],
              [
                45.048838,
                36.611415
              ],
              [
                45.048447,
                36.611234
              ],
              [
                45.0472927,
                36.6108224
              ],
              [
                45.0463189,
                36.6104605
              ],
              [
                45.0454918,
                36.6102462
              ],
              [
                45.0443105,
                36.6096748
              ],
              [
                45.043018,
                36.608972
              ],
              [
                45.0424615,
                36.6084946
              ],
              [
                45.0415684,
                36.6081714
              ],
              [
                45.040737,
                36.608041
              ],
              [
                45.040271,
                36.607999
              ],
              [
                45.039134,
                36.607764
              ],
              [
                45.03871,
                36.607598
              ],
              [
                45.0374892,
                36.6074865
              ],
              [
                45.036637,
                36.607635
              ],
              [
                45.035869,
                36.607781
              ],
              [
                45.033824,
                36.607735
              ],
              [
                45.0331481,
                36.6075729
              ],
              [
                45.0322093,
                36.6075205
              ],
              [
                45.0315997,
                36.6074926
              ],
              [
                45.030948,
                36.607236
              ],
              [
                45.0303405,
                36.6067594
              ],
              [
                45.0304128,
                36.6063397
              ],
              [
                45.0301462,
                36.605935
              ],
              [
                45.0296993,
                36.6056101
              ],
              [
                45.0289875,
                36.6055686
              ],
              [
                45.0283799,
                36.6054459
              ],
              [
                45.028064,
                36.605184
              ],
              [
                45.0276812,
                36.6044446
              ],
              [
                45.0274422,
                36.6039342
              ],
              [
                45.0271747,
                36.6036343
              ],
              [
                45.0269863,
                36.6033748
              ],
              [
                45.0269103,
                36.6029749
              ],
              [
                45.027002,
                36.602645
              ],
              [
                45.027231,
                36.602007
              ],
              [
                45.027135,
                36.601747
              ],
              [
                45.026682,
                36.601153
              ],
              [
                45.026427,
                36.600684
              ],
              [
                45.026374,
                36.60026
              ],
              [
                45.026668,
                36.598245
              ],
              [
                45.026561,
                36.597948
              ],
              [
                45.026487,
                36.597311
              ],
              [
                45.026834,
                36.596595
              ],
              [
                45.027189,
                36.596369
              ],
              [
                45.027533,
                36.596243
              ],
              [
                45.027688,
                36.595933
              ],
              [
                45.027719,
                36.594595
              ],
              [
                45.027942,
                36.594303
              ],
              [
                45.028145,
                36.594129
              ],
              [
                45.028237,
                36.593755
              ],
              [
                45.028304,
                36.5921
              ],
              [
                45.028393,
                36.591321
              ],
              [
                45.028714,
                36.590777
              ],
              [
                45.028637,
                36.589486
              ],
              [
                45.0291683,
                36.5887843
              ],
              [
                45.029862,
                36.587868
              ],
              [
                45.030064,
                36.587297
              ],
              [
                45.030757,
                36.586957
              ],
              [
                45.03165,
                36.586385
              ],
              [
                45.032089,
                36.585274
              ],
              [
                45.032587,
                36.584701
              ],
              [
                45.033275,
                36.583653
              ],
              [
                45.03384,
                36.583249
              ],
              [
                45.034024,
                36.5827
              ],
              [
                45.034315,
                36.582236
              ],
              [
                45.035056,
                36.581746
              ],
              [
                45.035552,
                36.581703
              ],
              [
                45.035921,
                36.581945
              ],
              [
                45.036305,
                36.582051
              ],
              [
                45.037048,
                36.581221
              ],
              [
                45.037844,
                36.580703
              ],
              [
                45.039384,
                36.579903
              ],
              [
                45.039642,
                36.579058
              ],
              [
                45.039302,
                36.578538
              ],
              [
                45.039168,
                36.577955
              ],
              [
                45.0389474,
                36.5774869
              ],
              [
                45.038668,
                36.576894
              ],
              [
                45.038557,
                36.576006
              ],
              [
                45.038698,
                36.575435
              ],
              [
                45.038982,
                36.574992
              ],
              [
                45.038762,
                36.573668
              ],
              [
                45.038714,
                36.57308
              ],
              [
                45.038593,
                36.5726
              ],
              [
                45.038571,
                36.572065
              ],
              [
                45.038718,
                36.571616
              ],
              [
                45.038407,
                36.571214
              ],
              [
                45.038325,
                36.570689
              ],
              [
                45.038333,
                36.57013
              ],
              [
                45.038583,
                36.569352
              ],
              [
                45.038811,
                36.568881
              ],
              [
                45.038902,
                36.568308
              ],
              [
                45.039146,
                36.567853
              ],
              [
                45.038857,
                36.56655
              ],
              [
                45.038954,
                36.565608
              ],
              [
                45.038814,
                36.564951
              ],
              [
                45.038515,
                36.564594
              ],
              [
                45.037974,
                36.564352
              ],
              [
                45.037385,
                36.56358
              ],
              [
                45.037619,
                36.563182
              ],
              [
                45.037712,
                36.562912
              ],
              [
                45.037605,
                36.562287
              ],
              [
                45.037688,
                36.561783
              ],
              [
                45.03762,
                36.561312
              ],
              [
                45.037641,
                36.560903
              ],
              [
                45.037445,
                36.560415
              ],
              [
                45.036561,
                36.560334
              ],
              [
                45.035194,
                36.560001
              ],
              [
                45.034576,
                36.5598
              ],
              [
                45.033916,
                36.559776
              ],
              [
                45.032618,
                36.560064
              ],
              [
                45.031744,
                36.560075
              ],
              [
                45.031365,
                36.559845
              ],
              [
                45.030168,
                36.558757
              ],
              [
                45.028238,
                36.557656
              ],
              [
                45.027907,
                36.557616
              ],
              [
                45.026496,
                36.557696
              ],
              [
                45.024436,
                36.55726
              ],
              [
                45.023963,
                36.55729
              ],
              [
                45.023303,
                36.557464
              ],
              [
                45.022821,
                36.557515
              ],
              [
                45.022179,
                36.557413
              ],
              [
                45.020425,
                36.556718
              ],
              [
                45.019999,
                36.556741
              ],
              [
                45.019469,
                36.556941
              ],
              [
                45.019124,
                36.556846
              ],
              [
                45.018594,
                36.556896
              ],
              [
                45.017684,
                36.557158
              ],
              [
                45.017235,
                36.557336
              ],
              [
                45.016524,
                36.557452
              ],
              [
                45.015582,
                36.557682
              ],
              [
                45.015146,
                36.557423
              ],
              [
                45.01471,
                36.557259
              ],
              [
                45.014181,
                36.556675
              ],
              [
                45.01371,
                36.556318
              ],
              [
                45.013215,
                36.556116
              ],
              [
                45.012738,
                36.556184
              ],
              [
                45.011601,
                36.556078
              ],
              [
                45.010875,
                36.555942
              ],
              [
                45.010815,
                36.555602
              ],
              [
                45.010911,
                36.555048
              ],
              [
                45.010915,
                36.554424
              ],
              [
                45.010804,
                36.553932
              ],
              [
                45.010635,
                36.553554
              ],
              [
                45.010214,
                36.553151
              ],
              [
                45.009631,
                36.552349
              ],
              [
                45.009194,
                36.552034
              ],
              [
                45.008468,
                36.551747
              ],
              [
                45.007861,
                36.551638
              ],
              [
                45.007043,
                36.551678
              ],
              [
                45.006258,
                36.551845
              ],
              [
                45.005179,
                36.551823
              ],
              [
                45.004416,
                36.551637
              ],
              [
                45.004268,
                36.55134
              ],
              [
                45.004405,
                36.550949
              ],
              [
                45.004311,
                36.550672
              ],
              [
                45.00427,
                36.55031
              ],
              [
                45.004808,
                36.549107
              ],
              [
                45.006341,
                36.547637
              ],
              [
                45.006961,
                36.547007
              ],
              [
                45.007134,
                36.546761
              ],
              [
                45.0050955,
                36.5425773
              ],
              [
                45.004854,
                36.542139
              ],
              [
                45.00456,
                36.54146
              ],
              [
                45.003807,
                36.54062
              ],
              [
                45.003516,
                36.540195
              ],
              [
                45.003158,
                36.539999
              ],
              [
                45.002711,
                36.539544
              ],
              [
                45.002363,
                36.539336
              ],
              [
                45.002129,
                36.538798
              ],
              [
                45.001556,
                36.538382
              ],
              [
                45.001781,
                36.537307
              ],
              [
                45.002177,
                36.536571
              ],
              [
                45.002449,
                36.53544
              ],
              [
                45.003626,
                36.535162
              ],
              [
                45.004129,
                36.534853
              ],
              [
                45.004771,
                36.534559
              ],
              [
                45.005136,
                36.53414
              ],
              [
                45.00511,
                36.533644
              ],
              [
                45.004724,
                36.532838
              ],
              [
                45.004863,
                36.532164
              ],
              [
                45.004785,
                36.531704
              ],
              [
                45.004998,
                36.53132
              ],
              [
                45.006007,
                36.530965
              ],
              [
                45.006308,
                36.530586
              ],
              [
                45.006846,
                36.530223
              ],
              [
                45.007001,
                36.529509
              ],
              [
                45.006958,
                36.527315
              ],
              [
                45.007082,
                36.526331
              ],
              [
                45.007449,
                36.524987
              ],
              [
                45.007866,
                36.524238
              ],
              [
                45.00827,
                36.523926
              ],
              [
                45.008868,
                36.523309
              ],
              [
                45.009276,
                36.523213
              ],
              [
                45.009913,
                36.523194
              ],
              [
                45.010372,
                36.522958
              ],
              [
                45.01089,
                36.522609
              ],
              [
                45.01122,
                36.5223
              ],
              [
                45.011202,
                36.521934
              ],
              [
                45.011528,
                36.521116
              ],
              [
                45.01171,
                36.520906
              ],
              [
                45.0120296,
                36.5204057
              ],
              [
                45.012269,
                36.520031
              ],
              [
                45.012812,
                36.519441
              ],
              [
                45.013635,
                36.519079
              ],
              [
                45.014052,
                36.518822
              ],
              [
                45.014581,
                36.518717
              ],
              [
                45.014799,
                36.518501
              ],
              [
                45.015022,
                36.518408
              ],
              [
                45.015657,
                36.517983
              ],
              [
                45.015953,
                36.517982
              ],
              [
                45.016219,
                36.518061
              ],
              [
                45.016505,
                36.517919
              ],
              [
                45.01673,
                36.517882
              ],
              [
                45.017435,
                36.51789
              ],
              [
                45.017731,
                36.517936
              ],
              [
                45.019371,
                36.517534
              ],
              [
                45.020732,
                36.517302
              ],
              [
                45.020944,
                36.517163
              ],
              [
                45.021034,
                36.516884
              ],
              [
                45.021641,
                36.516643
              ],
              [
                45.022099,
                36.516303
              ],
              [
                45.022415,
                36.516138
              ],
              [
                45.02343,
                36.515754
              ],
              [
                45.023702,
                36.515558
              ],
              [
                45.026514,
                36.514663
              ],
              [
                45.02906,
                36.514774
              ],
              [
                45.030633,
                36.515045
              ],
              [
                45.031231,
                36.515362
              ],
              [
                45.031795,
                36.514782
              ],
              [
                45.034218,
                36.511907
              ],
              [
                45.034681,
                36.511491
              ],
              [
                45.03522,
                36.511176
              ],
              [
                45.035704,
                36.51104
              ],
              [
                45.0368,
                36.510539
              ],
              [
                45.037405,
                36.510241
              ],
              [
                45.037794,
                36.50997
              ],
              [
                45.038195,
                36.509847
              ],
              [
                45.03857,
                36.509918
              ],
              [
                45.038735,
                36.510033
              ],
              [
                45.039992,
                36.51027
              ],
              [
                45.040466,
                36.510438
              ],
              [
                45.041493,
                36.51129
              ],
              [
                45.042467,
                36.511385
              ],
              [
                45.042982,
                36.51132
              ],
              [
                45.044424,
                36.511263
              ],
              [
                45.044865,
                36.511152
              ],
              [
                45.045681,
                36.510612
              ],
              [
                45.045965,
                36.510122
              ],
              [
                45.046676,
                36.509656
              ],
              [
                45.047323,
                36.509531
              ],
              [
                45.0476,
                36.509599
              ],
              [
                45.048207,
                36.509461
              ],
              [
                45.048405,
                36.509514
              ],
              [
                45.048675,
                36.509507
              ],
              [
                45.048858,
                36.509402
              ],
              [
                45.049292,
                36.509359
              ],
              [
                45.049501,
                36.509108
              ],
              [
                45.049273,
                36.508937
              ],
              [
                45.049147,
                36.508731
              ],
              [
                45.049238,
                36.508452
              ],
              [
                45.049248,
                36.508195
              ],
              [
                45.049631,
                36.507802
              ],
              [
                45.049921,
                36.507679
              ],
              [
                45.049998,
                36.507345
              ],
              [
                45.05013,
                36.507134
              ],
              [
                45.050407,
                36.506909
              ],
              [
                45.051096,
                36.506702
              ],
              [
                45.051605,
                36.506666
              ],
              [
                45.052246,
                36.506466
              ],
              [
                45.053169,
                36.506504
              ],
              [
                45.053896,
                36.506649
              ],
              [
                45.053994,
                36.505884
              ],
              [
                45.053959,
                36.504825
              ],
              [
                45.053896,
                36.504231
              ],
              [
                45.053447,
                36.502435
              ],
              [
                45.053395,
                36.501933
              ],
              [
                45.053481,
                36.501461
              ],
              [
                45.053512,
                36.500847
              ],
              [
                45.053406,
                36.500349
              ],
              [
                45.053495,
                36.499891
              ],
              [
                45.053658,
                36.499482
              ],
              [
                45.053724,
                36.499079
              ],
              [
                45.054087,
                36.498656
              ],
              [
                45.054267,
                36.498366
              ],
              [
                45.054594,
                36.498043
              ],
              [
                45.054976,
                36.497768
              ],
              [
                45.055053,
                36.497633
              ],
              [
                45.055086,
                36.497495
              ],
              [
                45.055005,
                36.497244
              ],
              [
                45.0548,
                36.497089
              ],
              [
                45.054716,
                36.496753
              ],
              [
                45.054693,
                36.495997
              ],
              [
                45.05493,
                36.49507
              ],
              [
                45.055138,
                36.494767
              ],
              [
                45.05524,
                36.494509
              ],
              [
                45.055275,
                36.494031
              ],
              [
                45.055031,
                36.493429
              ],
              [
                45.054608,
                36.492946
              ],
              [
                45.054412,
                36.492628
              ],
              [
                45.054477,
                36.49114
              ],
              [
                45.054885,
                36.490378
              ],
              [
                45.055048,
                36.489573
              ],
              [
                45.05478,
                36.48922
              ],
              [
                45.054484,
                36.488603
              ],
              [
                45.054419,
                36.487579
              ],
              [
                45.054609,
                36.486806
              ],
              [
                45.054537,
                36.486275
              ],
              [
                45.054574,
                36.48531
              ],
              [
                45.0522806,
                36.4845929
              ],
              [
                45.0539228,
                36.4829766
              ],
              [
                45.0540398,
                36.4824476
              ],
              [
                45.054048,
                36.48227
              ],
              [
                45.054409,
                36.481914
              ],
              [
                45.054482,
                36.481689
              ],
              [
                45.054682,
                36.481501
              ],
              [
                45.054834,
                36.481244
              ],
              [
                45.054949,
                36.48089
              ],
              [
                45.055177,
                36.480546
              ],
              [
                45.055763,
                36.480025
              ],
              [
                45.056092,
                36.479588
              ],
              [
                45.05678,
                36.478937
              ],
              [
                45.056963,
                36.477915
              ],
              [
                45.057291,
                36.477351
              ],
              [
                45.057605,
                36.477078
              ],
              [
                45.057823,
                36.47674
              ],
              [
                45.057949,
                36.476431
              ],
              [
                45.05799,
                36.476151
              ],
              [
                45.058258,
                36.475965
              ],
              [
                45.058413,
                36.475595
              ],
              [
                45.059455,
                36.475027
              ],
              [
                45.059268,
                36.474746
              ],
              [
                45.059191,
                36.474414
              ],
              [
                45.058446,
                36.473705
              ],
              [
                45.057947,
                36.472994
              ],
              [
                45.058769,
                36.471447
              ],
              [
                45.05904,
                36.470557
              ],
              [
                45.059107,
                36.470206
              ],
              [
                45.059105,
                36.469805
              ],
              [
                45.059319,
                36.468759
              ],
              [
                45.059347,
                36.468353
              ],
              [
                45.059514,
                36.467839
              ],
              [
                45.059727,
                36.466848
              ],
              [
                45.060156,
                36.466041
              ],
              [
                45.060367,
                36.465801
              ],
              [
                45.060678,
                36.465597
              ],
              [
                45.06078,
                36.465408
              ],
              [
                45.060908,
                36.464767
              ],
              [
                45.061401,
                36.464099
              ],
              [
                45.061753,
                36.463253
              ],
              [
                45.062314,
                36.46285
              ],
              [
                45.062465,
                36.462791
              ],
              [
                45.062663,
                36.46258
              ],
              [
                45.063493,
                36.462252
              ],
              [
                45.063711,
                36.46208
              ],
              [
                45.064032,
                36.461965
              ],
              [
                45.064484,
                36.461911
              ],
              [
                45.065147,
                36.461756
              ],
              [
                45.065415,
                36.461624
              ],
              [
                45.065764,
                36.461652
              ],
              [
                45.066042,
                36.461603
              ],
              [
                45.066285,
                36.461704
              ],
              [
                45.066588,
                36.46172
              ],
              [
                45.066855,
                36.461614
              ],
              [
                45.067468,
                36.461223
              ],
              [
                45.067839,
                36.461077
              ],
              [
                45.068207,
                36.461007
              ],
              [
                45.068431,
                36.460871
              ],
              [
                45.068701,
                36.460813
              ],
              [
                45.06928,
                36.460508
              ],
              [
                45.069692,
                36.460445
              ],
              [
                45.069887,
                36.46032
              ],
              [
                45.070343,
                36.460287
              ],
              [
                45.070599,
                36.459826
              ],
              [
                45.07107,
                36.459311
              ],
              [
                45.071537,
                36.459036
              ],
              [
                45.072003,
                36.458863
              ],
              [
                45.072221,
                36.458697
              ],
              [
                45.07259,
                36.458301
              ],
              [
                45.072992,
                36.458182
              ],
              [
                45.07335,
                36.457926
              ],
              [
                45.073765,
                36.457714
              ],
              [
                45.074139,
                36.456747
              ],
              [
                45.074635,
                36.456099
              ],
              [
                45.074926,
                36.455925
              ],
              [
                45.075542,
                36.455779
              ],
              [
                45.076158,
                36.455339
              ],
              [
                45.076223,
                36.455056
              ],
              [
                45.076022,
                36.45475
              ],
              [
                45.075988,
                36.454005
              ],
              [
                45.075797,
                36.453052
              ],
              [
                45.075869,
                36.452874
              ],
              [
                45.076744,
                36.452053
              ],
              [
                45.076943,
                36.45165
              ],
              [
                45.0771,
                36.451489
              ],
              [
                45.077245,
                36.451229
              ],
              [
                45.077323,
                36.450948
              ],
              [
                45.077677,
                36.450342
              ],
              [
                45.077705,
                36.450124
              ],
              [
                45.078033,
                36.449213
              ],
              [
                45.078278,
                36.44886
              ],
              [
                45.078418,
                36.447774
              ],
              [
                45.078336,
                36.446941
              ],
              [
                45.078514,
                36.446627
              ],
              [
                45.078746,
                36.445573
              ],
              [
                45.078551,
                36.445197
              ],
              [
                45.078727,
                36.444937
              ],
              [
                45.07879,
                36.444606
              ],
              [
                45.078744,
                36.443798
              ],
              [
                45.078577,
                36.443508
              ],
              [
                45.078482,
                36.442405
              ],
              [
                45.078617,
                36.442259
              ],
              [
                45.078678,
                36.44179
              ],
              [
                45.078202,
                36.441016
              ],
              [
                45.078229,
                36.440691
              ],
              [
                45.078373,
                36.440495
              ],
              [
                45.078203,
                36.440056
              ],
              [
                45.078222,
                36.439861
              ],
              [
                45.077771,
                36.439317
              ],
              [
                45.077706,
                36.439168
              ],
              [
                45.077468,
                36.439003
              ],
              [
                45.076881,
                36.438797
              ],
              [
                45.077167,
                36.438592
              ],
              [
                45.07705,
                36.438405
              ],
              [
                45.076495,
                36.438103
              ],
              [
                45.076153,
                36.438009
              ],
              [
                45.076035,
                36.437518
              ],
              [
                45.076105,
                36.437389
              ],
              [
                45.076393,
                36.437295
              ],
              [
                45.076859,
                36.437021
              ],
              [
                45.076951,
                36.436812
              ],
              [
                45.076912,
                36.436606
              ],
              [
                45.077025,
                36.436506
              ],
              [
                45.077105,
                36.436236
              ],
              [
                45.077311,
                36.435341
              ],
              [
                45.077321,
                36.434929
              ],
              [
                45.077528,
                36.434605
              ],
              [
                45.077676,
                36.433997
              ],
              [
                45.077826,
                36.433635
              ],
              [
                45.077836,
                36.433356
              ],
              [
                45.077697,
                36.433082
              ],
              [
                45.077776,
                36.43277
              ],
              [
                45.078042,
                36.432589
              ],
              [
                45.078115,
                36.432416
              ],
              [
                45.077974,
                36.431961
              ],
              [
                45.078226,
                36.43181
              ],
              [
                45.078288,
                36.431511
              ],
              [
                45.078171,
                36.43069
              ],
              [
                45.078198,
                36.43053
              ],
              [
                45.078592,
                36.430503
              ],
              [
                45.078935,
                36.430368
              ],
              [
                45.080298,
                36.429657
              ],
              [
                45.081107,
                36.428981
              ],
              [
                45.081325,
                36.42858
              ],
              [
                45.081442,
                36.427872
              ],
              [
                45.081418,
                36.427545
              ],
              [
                45.081522,
                36.427239
              ],
              [
                45.081478,
                36.426469
              ],
              [
                45.081591,
                36.425878
              ],
              [
                45.081587,
                36.42549
              ],
              [
                45.082205,
                36.425327
              ],
              [
                45.084174,
                36.424978
              ],
              [
                45.084869,
                36.424695
              ],
              [
                45.085028,
                36.424577
              ],
              [
                45.085335,
                36.424218
              ],
              [
                45.085714,
                36.423581
              ],
              [
                45.085905,
                36.423531
              ],
              [
                45.086268,
                36.423536
              ],
              [
                45.086738,
                36.423282
              ],
              [
                45.086886,
                36.423144
              ],
              [
                45.086933,
                36.42296
              ],
              [
                45.086912,
                36.422782
              ],
              [
                45.087097,
                36.422408
              ],
              [
                45.087331,
                36.422324
              ],
              [
                45.087889,
                36.422236
              ],
              [
                45.088121,
                36.422078
              ],
              [
                45.088361,
                36.422025
              ],
              [
                45.089438,
                36.422047
              ],
              [
                45.089899,
                36.421976
              ],
              [
                45.090241,
                36.421873
              ],
              [
                45.090537,
                36.421853
              ],
              [
                45.090846,
                36.421968
              ],
              [
                45.09137,
                36.422302
              ],
              [
                45.09189,
                36.422348
              ],
              [
                45.092575,
                36.422206
              ],
              [
                45.092696,
                36.422057
              ],
              [
                45.092805,
                36.421771
              ],
              [
                45.093021,
                36.421594
              ],
              [
                45.093249,
                36.421479
              ],
              [
                45.093489,
                36.421426
              ],
              [
                45.094538,
                36.420899
              ],
              [
                45.094861,
                36.420692
              ],
              [
                45.09527,
                36.420279
              ],
              [
                45.095952,
                36.419859
              ],
              [
                45.096311,
                36.419711
              ],
              [
                45.096686,
                36.419644
              ],
              [
                45.096831,
                36.419555
              ],
              [
                45.09738,
                36.419489
              ],
              [
                45.09805,
                36.419072
              ],
              [
                45.099135,
                36.418933
              ],
              [
                45.100025,
                36.418456
              ],
              [
                45.100565,
                36.418243
              ],
              [
                45.100752,
                36.418109
              ],
              [
                45.101186,
                36.417925
              ],
              [
                45.101444,
                36.417741
              ],
              [
                45.101698,
                36.417632
              ],
              [
                45.10246,
                36.416708
              ],
              [
                45.103153,
                36.416345
              ],
              [
                45.103755,
                36.416095
              ],
              [
                45.103794,
                36.416003
              ],
              [
                45.104028,
                36.415823
              ],
              [
                45.10377,
                36.415277
              ],
              [
                45.103467,
                36.414957
              ],
              [
                45.10334,
                36.413983
              ],
              [
                45.103403,
                36.413822
              ],
              [
                45.10335,
                36.413341
              ],
              [
                45.103864,
                36.413085
              ],
              [
                45.104545,
                36.412895
              ],
              [
                45.104805,
                36.412849
              ],
              [
                45.10528,
                36.412952
              ],
              [
                45.106359,
                36.412787
              ],
              [
                45.106645,
                36.41271
              ],
              [
                45.106802,
                36.412586
              ],
              [
                45.107537,
                36.412312
              ],
              [
                45.108031,
                36.412219
              ],
              [
                45.108421,
                36.41207
              ],
              [
                45.108804,
                36.411784
              ],
              [
                45.108931,
                36.411564
              ],
              [
                45.10888,
                36.411125
              ],
              [
                45.109014,
                36.410414
              ],
              [
                45.109367,
                36.409866
              ],
              [
                45.109648,
                36.409571
              ],
              [
                45.109839,
                36.409287
              ],
              [
                45.110181,
                36.409216
              ],
              [
                45.111591,
                36.40855
              ],
              [
                45.112679,
                36.407899
              ],
              [
                45.112963,
                36.407486
              ],
              [
                45.112964,
                36.407262
              ],
              [
                45.113199,
                36.407018
              ],
              [
                45.113289,
                36.4064
              ],
              [
                45.1137,
                36.405762
              ],
              [
                45.114,
                36.405735
              ],
              [
                45.11445,
                36.405437
              ],
              [
                45.115119,
                36.405414
              ],
              [
                45.11573,
                36.405541
              ],
              [
                45.115912,
                36.405647
              ],
              [
                45.116141,
                36.405708
              ],
              [
                45.1168634,
                36.405694
              ],
              [
                45.117018,
                36.405691
              ],
              [
                45.117622,
                36.405819
              ],
              [
                45.117738,
                36.406236
              ],
              [
                45.118163,
                36.406272
              ],
              [
                45.118408,
                36.406218
              ],
              [
                45.118639,
                36.406252
              ],
              [
                45.11915,
                36.406476
              ],
              [
                45.119533,
                36.406525
              ],
              [
                45.119847,
                36.406768
              ],
              [
                45.120123,
                36.406911
              ],
              [
                45.120402,
                36.407363
              ],
              [
                45.121001,
                36.407828
              ],
              [
                45.121644,
                36.407863
              ],
              [
                45.121972,
                36.40805
              ],
              [
                45.12255,
                36.407974
              ],
              [
                45.123169,
                36.407678
              ],
              [
                45.123778,
                36.407634
              ],
              [
                45.124088,
                36.407457
              ],
              [
                45.124548,
                36.406917
              ],
              [
                45.125311,
                36.406329
              ],
              [
                45.125492,
                36.406062
              ],
              [
                45.125789,
                36.405951
              ],
              [
                45.126332,
                36.405887
              ],
              [
                45.126773,
                36.405574
              ],
              [
                45.127915,
                36.405047
              ],
              [
                45.128682,
                36.404879
              ],
              [
                45.12914,
                36.404888
              ],
              [
                45.129748,
                36.405005
              ],
              [
                45.130105,
                36.405011
              ],
              [
                45.13055,
                36.405156
              ],
              [
                45.131182,
                36.405566
              ],
              [
                45.131892,
                36.405723
              ],
              [
                45.133542,
                36.406305
              ],
              [
                45.134911,
                36.40698
              ],
              [
                45.135272,
                36.40691
              ],
              [
                45.135616,
                36.406983
              ],
              [
                45.136124,
                36.407197
              ],
              [
                45.136527,
                36.407216
              ],
              [
                45.136665,
                36.407085
              ],
              [
                45.137096,
                36.407254
              ],
              [
                45.137317,
                36.407401
              ],
              [
                45.137759,
                36.407145
              ],
              [
                45.138086,
                36.407045
              ],
              [
                45.1385,
                36.407023
              ],
              [
                45.139334,
                36.406634
              ],
              [
                45.139699,
                36.406579
              ],
              [
                45.139973,
                36.406468
              ],
              [
                45.140277,
                36.406231
              ],
              [
                45.140657,
                36.406079
              ],
              [
                45.140997,
                36.405961
              ],
              [
                45.141342,
                36.405983
              ],
              [
                45.141529,
                36.405814
              ],
              [
                45.142085,
                36.405642
              ],
              [
                45.142488,
                36.405193
              ],
              [
                45.142811,
                36.405183
              ],
              [
                45.143164,
                36.405089
              ],
              [
                45.14338,
                36.405097
              ],
              [
                45.143585,
                36.404987
              ],
              [
                45.144131,
                36.404806
              ],
              [
                45.144398,
                36.405067
              ],
              [
                45.14492,
                36.40524
              ],
              [
                45.145872,
                36.405467
              ],
              [
                45.146292,
                36.40547
              ],
              [
                45.147005,
                36.405609
              ],
              [
                45.14715,
                36.405531
              ],
              [
                45.147226,
                36.405387
              ],
              [
                45.147619,
                36.405197
              ],
              [
                45.147977,
                36.404846
              ],
              [
                45.148562,
                36.404731
              ],
              [
                45.148706,
                36.404627
              ],
              [
                45.148966,
                36.404575
              ],
              [
                45.149108,
                36.404341
              ],
              [
                45.149525,
                36.404413
              ],
              [
                45.14984,
                36.404419
              ],
              [
                45.150683,
                36.404619
              ],
              [
                45.150936,
                36.404793
              ],
              [
                45.151016,
                36.404914
              ],
              [
                45.151361,
                36.405062
              ],
              [
                45.151638,
                36.405273
              ],
              [
                45.151891,
                36.405301
              ],
              [
                45.152248,
                36.405572
              ],
              [
                45.152483,
                36.405686
              ],
              [
                45.152628,
                36.405854
              ],
              [
                45.152816,
                36.406624
              ],
              [
                45.152992,
                36.406875
              ],
              [
                45.153411,
                36.407119
              ],
              [
                45.153885,
                36.407259
              ],
              [
                45.153886,
                36.407656
              ],
              [
                45.1541486,
                36.4085643
              ],
              [
                45.154163,
                36.408614
              ],
              [
                45.153993,
                36.408942
              ],
              [
                45.153848,
                36.410248
              ],
              [
                45.153642,
                36.410707
              ],
              [
                45.153677,
                36.410947
              ],
              [
                45.153868,
                36.411351
              ],
              [
                45.153802,
                36.412047
              ],
              [
                45.153928,
                36.412317
              ],
              [
                45.1539,
                36.412641
              ],
              [
                45.153825,
                36.412847
              ],
              [
                45.154087,
                36.413197
              ],
              [
                45.15437,
                36.414113
              ],
              [
                45.154589,
                36.414445
              ],
              [
                45.154638,
                36.414608
              ],
              [
                45.154871,
                36.414901
              ],
              [
                45.155234,
                36.415813
              ],
              [
                45.154797,
                36.416006
              ],
              [
                45.154256,
                36.416144
              ],
              [
                45.154108,
                36.416275
              ],
              [
                45.154153,
                36.416424
              ],
              [
                45.154369,
                36.416516
              ],
              [
                45.154783,
                36.417016
              ],
              [
                45.155122,
                36.41706
              ],
              [
                45.156013,
                36.416817
              ],
              [
                45.156575,
                36.416769
              ],
              [
                45.157748,
                36.417004
              ],
              [
                45.158513,
                36.417008
              ],
              [
                45.159227,
                36.417152
              ],
              [
                45.159933,
                36.417188
              ],
              [
                45.160147,
                36.41715
              ],
              [
                45.160644,
                36.417155
              ],
              [
                45.161917,
                36.417017
              ],
              [
                45.162415,
                36.417132
              ],
              [
                45.16271,
                36.41709
              ],
              [
                45.162965,
                36.417148
              ],
              [
                45.163706,
                36.417549
              ],
              [
                45.164222,
                36.417619
              ],
              [
                45.164412,
                36.417543
              ],
              [
                45.164634,
                36.41755
              ],
              [
                45.164815,
                36.417591
              ],
              [
                45.165324,
                36.417824
              ],
              [
                45.166741,
                36.418224
              ],
              [
                45.167495,
                36.418272
              ],
              [
                45.167911,
                36.41824
              ],
              [
                45.168244,
                36.418306
              ],
              [
                45.168429,
                36.418419
              ],
              [
                45.168558,
                36.418683
              ],
              [
                45.168765,
                36.418766
              ],
              [
                45.170068,
                36.418622
              ],
              [
                45.170678,
                36.418649
              ],
              [
                45.171143,
                36.418613
              ],
              [
                45.171846,
                36.41841
              ],
              [
                45.173522,
                36.41811
              ],
              [
                45.17412,
                36.418061
              ],
              [
                45.174523,
                36.417942
              ],
              [
                45.174963,
                36.417926
              ],
              [
                45.175434,
                36.417973
              ],
              [
                45.175991,
                36.418176
              ],
              [
                45.176605,
                36.418469
              ],
              [
                45.176965,
                36.418394
              ],
              [
                45.178106,
                36.418274
              ],
              [
                45.178689,
                36.418253
              ],
              [
                45.179211,
                36.418014
              ],
              [
                45.180113,
                36.417848
              ],
              [
                45.180516,
                36.41835
              ],
              [
                45.181508,
                36.419108
              ],
              [
                45.182247,
                36.419169
              ],
              [
                45.18357,
                36.419962
              ],
              [
                45.184409,
                36.420272
              ],
              [
                45.184643,
                36.420403
              ],
              [
                45.185161,
                36.420958
              ],
              [
                45.186674,
                36.421487
              ],
              [
                45.187364,
                36.421802
              ],
              [
                45.188823,
                36.422111
              ],
              [
                45.189654,
                36.4225
              ],
              [
                45.190218,
                36.422604
              ],
              [
                45.19058,
                36.422518
              ],
              [
                45.191142,
                36.42247
              ],
              [
                45.191326,
                36.422353
              ],
              [
                45.191883,
                36.422186
              ],
              [
                45.192482,
                36.422262
              ],
              [
                45.193451,
                36.422585
              ],
              [
                45.193821,
                36.422754
              ],
              [
                45.194233,
                36.423083
              ],
              [
                45.194687,
                36.423341
              ],
              [
                45.195357,
                36.423587
              ],
              [
                45.197007,
                36.423972
              ],
              [
                45.197529,
                36.424312
              ],
              [
                45.197705,
                36.424374
              ],
              [
                45.199106,
                36.423889
              ],
              [
                45.199614,
                36.423809
              ],
              [
                45.200107,
                36.423575
              ],
              [
                45.20051,
                36.42321
              ],
              [
                45.200821,
                36.423223
              ],
              [
                45.201477,
                36.423487
              ],
              [
                45.202262,
                36.42366
              ],
              [
                45.203625,
                36.424211
              ],
              [
                45.203817,
                36.424328
              ],
              [
                45.203929,
                36.424637
              ],
              [
                45.204079,
                36.424762
              ],
              [
                45.20428,
                36.424804
              ],
              [
                45.205313,
                36.424698
              ],
              [
                45.205665,
                36.424578
              ],
              [
                45.206379,
                36.424226
              ],
              [
                45.206901,
                36.424107
              ],
              [
                45.207109,
                36.42409
              ],
              [
                45.20759,
                36.424151
              ],
              [
                45.208077,
                36.424043
              ],
              [
                45.208866,
                36.424163
              ],
              [
                45.20923,
                36.424166
              ],
              [
                45.209555,
                36.424249
              ],
              [
                45.209823,
                36.424368
              ],
              [
                45.210319,
                36.424745
              ],
              [
                45.210558,
                36.424853
              ],
              [
                45.211159,
                36.42508
              ],
              [
                45.212368,
                36.425413
              ],
              [
                45.213442,
                36.426501
              ],
              [
                45.213998,
                36.426746
              ],
              [
                45.214725,
                36.42716
              ],
              [
                45.215343,
                36.427712
              ],
              [
                45.216053,
                36.428092
              ],
              [
                45.216684,
                36.428794
              ],
              [
                45.216852,
                36.429104
              ],
              [
                45.217372,
                36.429476
              ],
              [
                45.2177577,
                36.4295693
              ],
              [
                45.2181169,
                36.4298322
              ],
              [
                45.218834,
                36.429941
              ],
              [
                45.219927,
                36.430033
              ],
              [
                45.220337,
                36.42996
              ],
              [
                45.220739,
                36.429945
              ],
              [
                45.221212,
                36.430143
              ],
              [
                45.221407,
                36.430166
              ],
              [
                45.221443,
                36.430013
              ],
              [
                45.221572,
                36.429818
              ],
              [
                45.221881,
                36.429637
              ],
              [
                45.221957,
                36.429373
              ],
              [
                45.222126,
                36.429207
              ],
              [
                45.222426,
                36.42908
              ],
              [
                45.223097,
                36.429018
              ],
              [
                45.223594,
                36.42884
              ],
              [
                45.224327,
                36.428757
              ],
              [
                45.22494,
                36.429023
              ],
              [
                45.225222,
                36.429213
              ],
              [
                45.225429,
                36.429255
              ],
              [
                45.225795,
                36.429555
              ],
              [
                45.226097,
                36.429663
              ],
              [
                45.226529,
                36.430139
              ],
              [
                45.22677,
                36.430315
              ],
              [
                45.227214,
                36.430894
              ],
              [
                45.227421,
                36.431061
              ],
              [
                45.228686,
                36.430955
              ],
              [
                45.228899,
                36.430996
              ],
              [
                45.229071,
                36.43142
              ],
              [
                45.229323,
                36.431552
              ],
              [
                45.229538,
                36.431743
              ],
              [
                45.229764,
                36.432058
              ],
              [
                45.230067,
                36.432709
              ],
              [
                45.230206,
                36.432836
              ],
              [
                45.230686,
                36.432975
              ],
              [
                45.230985,
                36.433198
              ],
              [
                45.231457,
                36.433307
              ],
              [
                45.231804,
                36.433276
              ],
              [
                45.232662,
                36.433045
              ],
              [
                45.233884,
                36.432592
              ],
              [
                45.234801,
                36.432705
              ],
              [
                45.235503,
                36.432914
              ],
              [
                45.2356331,
                36.4329258
              ],
              [
                45.2345819,
                36.4380415
              ],
              [
                45.2564879,
                36.4377776
              ],
              [
                45.2564879,
                36.4380568
              ],
              [
                45.2617408,
                36.4430719
              ],
              [
                45.2642681,
                36.4490222
              ],
              [
                45.2686584,
                36.455566
              ],
              [
                45.2727575,
                36.4598783
              ],
              [
                45.2766174,
                36.4609859
              ],
              [
                45.2837658,
                36.4616169
              ],
              [
                45.2938842,
                36.4632631
              ],
              [
                45.3025229,
                36.465463
              ],
              [
                45.3184397,
                36.4701536
              ],
              [
                45.3276402,
                36.4722273
              ],
              [
                45.3330768,
                36.4726415
              ],
              [
                45.3383099,
                36.4725694
              ],
              [
                45.3431465,
                36.471327
              ],
              [
                45.3538726,
                36.46732
              ],
              [
                45.3618232,
                36.4630735
              ],
              [
                45.3690719,
                36.4592593
              ],
              [
                45.3759384,
                36.4566015
              ],
              [
                45.3804445,
                36.4557731
              ],
              [
                45.3873849,
                36.452685
              ],
              [
                45.3955379,
                36.4500209
              ],
              [
                45.4062365,
                36.4484552
              ],
              [
                45.4138755,
                36.4480408
              ],
              [
                45.4183487,
                36.4466729
              ],
              [
                45.4217665,
                36.4458698
              ],
              [
                45.4234107,
                36.445214
              ],
              [
                45.4249271,
                36.4441031
              ],
              [
                45.4301834,
                36.4393756
              ],
              [
                45.4324794,
                36.4375457
              ],
              [
                45.4348182,
                36.4360934
              ],
              [
                45.4373255,
                36.43521
              ],
              [
                45.4563367,
                36.4343641
              ],
              [
                45.4600267,
                36.4340219
              ],
              [
                45.4632308,
                36.4340332
              ],
              [
                45.4682859,
                36.4338433
              ],
              [
                45.4718971,
                36.4338859
              ],
              [
                45.4743787,
                36.4344057
              ],
              [
                45.4764676,
                36.4376493
              ],
              [
                45.4781627,
                36.4392547
              ],
              [
                45.4808232,
                36.4406015
              ],
              [
                45.48563,
                36.4421375
              ],
              [
                45.4932686,
                36.4437258
              ],
              [
                45.5019391,
                36.4474321
              ],
              [
                45.5062853,
                36.4513865
              ],
              [
                45.5111338,
                36.4553435
              ],
              [
                45.5119922,
                36.4599883
              ],
              [
                45.5090464,
                36.4644318
              ],
              [
                45.504132,
                36.4641685
              ],
              [
                45.4912938,
                36.4600958
              ],
              [
                45.4865788,
                36.4597538
              ],
              [
                45.4828302,
                36.4600299
              ],
              [
                45.4810809,
                36.4616754
              ],
              [
                45.4791754,
                36.465493
              ],
              [
                45.4822823,
                36.4691305
              ],
              [
                45.4949855,
                36.4789999
              ],
              [
                45.5021879,
                36.4849312
              ],
              [
                45.5061964,
                36.4905966
              ],
              [
                45.5072684,
                36.4938429
              ],
              [
                45.5064154,
                36.5024741
              ],
              [
                45.5060274,
                36.5153162
              ],
              [
                45.5038818,
                36.5238135
              ],
              [
                45.5053195,
                36.5328458
              ],
              [
                45.503718,
                36.5490645
              ],
              [
                45.5026086,
                36.553504
              ],
              [
                45.5020515,
                36.5551699
              ],
              [
                45.4796215,
                36.5772142
              ],
              [
                45.4556367,
                36.5894226
              ],
              [
                45.4545234,
                36.5910979
              ],
              [
                45.4539695,
                36.591368
              ],
              [
                45.4531366,
                36.592485
              ],
              [
                45.4475795,
                36.5980332
              ],
              [
                45.4468239,
                36.6075429
              ],
              [
                45.4465474,
                36.6144961
              ],
              [
                45.4496036,
                36.6194947
              ],
              [
                45.4566054,
                36.6283768
              ],
              [
                45.4713283,
                36.6383829
              ],
              [
                45.472715,
                36.6394906
              ],
              [
                45.4847714,
                36.6436309
              ],
              [
                45.5046841,
                36.6408762
              ],
              [
                45.5217777,
                36.6451509
              ],
              [
                45.523444,
                36.6459795
              ],
              [
                45.524834,
                36.6470964
              ],
              [
                45.5290004,
                36.6493122
              ],
              [
                45.5301106,
                36.6504292
              ],
              [
                45.5309442,
                36.6504292
              ],
              [
                45.5325572,
                36.6632004
              ],
              [
                45.5325077,
                36.6703731
              ],
              [
                45.5290379,
                36.678871
              ],
              [
                45.5357042,
                36.7347119
              ],
              [
                45.5376503,
                36.7377733
              ],
              [
                45.5380899,
                36.7382148
              ],
              [
                45.5401504,
                36.7405466
              ],
              [
                45.5407074,
                36.7408258
              ],
              [
                45.5440413,
                36.7572628
              ],
              [
                45.5443041,
                36.76168
              ],
              [
                45.5366992,
                36.7646044
              ],
              [
                45.5278298,
                36.7684194
              ],
              [
                45.5086675,
                36.7809119
              ],
              [
                45.5006503,
                36.7889412
              ],
              [
                45.4794632,
                36.8060478
              ],
              [
                45.4611663,
                36.8153403
              ],
              [
                45.4541719,
                36.819128
              ],
              [
                45.4430824,
                36.8226135
              ],
              [
                45.4389094,
                36.8237896
              ],
              [
                45.4304182,
                36.8265589
              ],
              [
                45.4197678,
                36.8300543
              ],
              [
                45.4123736,
                36.8329312
              ],
              [
                45.4001426,
                36.8363553
              ],
              [
                45.3834691,
                36.840144
              ],
              [
                45.3471133,
                36.8490988
              ],
              [
                45.3352152,
                36.8578773
              ],
              [
                45.3325326,
                36.8613417
              ],
              [
                45.3216268,
                36.8733118
              ],
              [
                45.3120151,
                36.8930001
              ],
              [
                45.295831,
                36.9135019
              ],
              [
                45.2830212,
                36.9183146
              ],
              [
                45.265133,
                36.9209244
              ],
              [
                45.2475353,
                36.9025485
              ],
              [
                45.2308842,
                36.889644
              ],
              [
                45.2138897,
                36.8884084
              ],
              [
                45.1995139,
                36.8864101
              ],
              [
                45.1838492,
                36.88374
              ],
              [
                45.1785277,
                36.8808565
              ],
              [
                45.1462553,
                36.8849757
              ],
              [
                45.1281268,
                36.889417
              ],
              [
                45.1176865,
                36.8911675
              ],
              [
                45.1120243,
                36.8923985
              ],
              [
                45.1068746,
                36.8933595
              ],
              [
                45.1008332,
                36.8951831
              ],
              [
                45.0857371,
                36.8990792
              ],
              [
                45.0705759,
                36.8999806
              ],
              [
                45.0626251,
                36.9002732
              ],
              [
                45.0520152,
                36.9010463
              ],
              [
                45.0510406,
                36.9064704
              ],
              [
                45.0473765,
                36.9231529
              ],
              [
                45.0457743,
                36.9332802
              ],
              [
                45.0042482,
                36.9526113
              ],
              [
                45.0036921,
                36.9523324
              ],
              [
                44.9910455,
                36.9562007
              ],
              [
                44.9866025,
                36.9562007
              ],
              [
                44.9854892,
                36.9564796
              ],
              [
                44.9824352,
                36.9564796
              ],
              [
                44.9816024,
                36.9567586
              ],
              [
                44.9793789,
                36.9567585
              ],
              [
                44.9777125,
                36.9564795
              ],
              [
                44.9510893,
                36.952913
              ],
              [
                44.9483096,
                36.9534619
              ],
              [
                44.9469228,
                36.9531919
              ],
              [
                44.9444228,
                36.9520761
              ],
              [
                44.9433095,
                36.9517972
              ],
              [
                44.9301199,
                36.9124888
              ],
              [
                44.9220635,
                36.9097161
              ],
              [
                44.9187298,
                36.9091579
              ],
              [
                44.915397,
                36.9091579
              ],
              [
                44.9142867,
                36.909437
              ],
              [
                44.9089657,
                36.9093654
              ],
              [
                44.909048,
                36.908814
              ],
              [
                44.909203,
                36.908294
              ],
              [
                44.909433,
                36.907866
              ],
              [
                44.909962,
                36.907621
              ],
              [
                44.910435,
                36.907206
              ],
              [
                44.91084,
                36.906568
              ],
              [
                44.911283,
                36.905647
              ],
              [
                44.911417,
                36.905207
              ],
              [
                44.911445,
                36.903955
              ],
              [
                44.911554,
                36.903317
              ],
              [
                44.911701,
                36.902928
              ],
              [
                44.911981,
                36.902622
              ],
              [
                44.912286,
                36.901203
              ],
              [
                44.912191,
                36.900879
              ],
              [
                44.911651,
                36.899814
              ],
              [
                44.91178,
                36.89945
              ],
              [
                44.911768,
                36.899015
              ],
              [
                44.91201,
                36.898609
              ],
              [
                44.912361,
                36.898343
              ],
              [
                44.91258,
                36.897803
              ],
              [
                44.912388,
                36.897283
              ],
              [
                44.911709,
                36.896744
              ],
              [
                44.911068,
                36.895911
              ],
              [
                44.910964,
                36.895599
              ],
              [
                44.911044,
                36.895233
              ],
              [
                44.911338,
                36.894988
              ],
              [
                44.911156,
                36.894754
              ],
              [
                44.911092,
                36.894373
              ],
              [
                44.909592,
                36.893681
              ],
              [
                44.909009,
                36.893562
              ],
              [
                44.908402,
                36.893256
              ],
              [
                44.908021,
                36.892823
              ],
              [
                44.907524,
                36.890908
              ],
              [
                44.906674,
                36.889739
              ],
              [
                44.906465,
                36.889596
              ],
              [
                44.905614,
                36.888565
              ],
              [
                44.905985,
                36.88804
              ],
              [
                44.905565,
                36.887402
              ],
              [
                44.905498,
                36.887137
              ],
              [
                44.905205,
                36.886709
              ],
              [
                44.904971,
                36.886176
              ],
              [
                44.904883,
                36.885829
              ],
              [
                44.904534,
                36.885519
              ],
              [
                44.904442,
                36.885205
              ],
              [
                44.90406,
                36.884815
              ],
              [
                44.904188,
                36.884479
              ],
              [
                44.904378,
                36.884172
              ],
              [
                44.904698,
                36.883821
              ],
              [
                44.905467,
                36.882727
              ],
              [
                44.905704,
                36.882206
              ],
              [
                44.90581,
                36.88167
              ],
              [
                44.905711,
                36.881084
              ],
              [
                44.905033,
                36.880086
              ],
              [
                44.904496,
                36.87954
              ],
              [
                44.90415,
                36.879038
              ],
              [
                44.903669,
                36.878511
              ],
              [
                44.902968,
                36.877927
              ],
              [
                44.90273,
                36.877297
              ],
              [
                44.902036,
                36.876487
              ],
              [
                44.900535,
                36.875698
              ],
              [
                44.900578,
                36.875006
              ],
              [
                44.901266,
                36.874474
              ],
              [
                44.901958,
                36.874205
              ],
              [
                44.90268,
                36.874138
              ],
              [
                44.903046,
                36.873996
              ],
              [
                44.903265,
                36.873691
              ],
              [
                44.903246,
                36.873471
              ],
              [
                44.902832,
                36.872552
              ],
              [
                44.902857,
                36.87205
              ],
              [
                44.903374,
                36.870124
              ],
              [
                44.903627,
                36.868762
              ],
              [
                44.903681,
                36.868177
              ],
              [
                44.903601,
                36.867666
              ],
              [
                44.902669,
                36.866227
              ],
              [
                44.902617,
                36.865875
              ],
              [
                44.902656,
                36.86543
              ],
              [
                44.902829,
                36.864804
              ],
              [
                44.902835,
                36.864179
              ],
              [
                44.902767,
                36.863714
              ],
              [
                44.903091,
                36.863431
              ],
              [
                44.903349,
                36.863287
              ],
              [
                44.903702,
                36.861819
              ],
              [
                44.903699,
                36.86141
              ],
              [
                44.903508,
                36.861113
              ],
              [
                44.903126,
                36.860871
              ],
              [
                44.902813,
                36.860499
              ],
              [
                44.902139,
                36.859968
              ],
              [
                44.901938,
                36.859186
              ],
              [
                44.901879,
                36.858505
              ],
              [
                44.901359,
                36.857176
              ],
              [
                44.900128,
                36.856619
              ],
              [
                44.899596,
                36.856443
              ],
              [
                44.89911,
                36.856395
              ],
              [
                44.898732,
                36.856219
              ],
              [
                44.898104,
                36.856314
              ],
              [
                44.897179,
                36.855751
              ],
              [
                44.896598,
                36.855632
              ],
              [
                44.896204,
                36.855294
              ],
              [
                44.895999,
                36.854893
              ],
              [
                44.895101,
                36.85374
              ],
              [
                44.894719,
                36.853449
              ],
              [
                44.892883,
                36.853626
              ],
              [
                44.89164,
                36.853822
              ],
              [
                44.891079,
                36.853631
              ],
              [
                44.890608,
                36.85359
              ],
              [
                44.889062,
                36.853705
              ],
              [
                44.888514,
                36.853512
              ],
              [
                44.887946,
                36.853147
              ],
              [
                44.886959,
                36.852741
              ],
              [
                44.886549,
                36.852787
              ],
              [
                44.8845,
                36.852388
              ],
              [
                44.883943,
                36.852362
              ],
              [
                44.883327,
                36.852055
              ],
              [
                44.882932,
                36.851912
              ],
              [
                44.882533,
                36.851907
              ],
              [
                44.881297,
                36.852277
              ],
              [
                44.88087,
                36.85216
              ],
              [
                44.880232,
                36.851467
              ],
              [
                44.879935,
                36.851257
              ],
              [
                44.879653,
                36.850958
              ],
              [
                44.87975,
                36.850638
              ],
              [
                44.879756,
                36.850413
              ],
              [
                44.87967,
                36.850077
              ],
              [
                44.879213,
                36.849692
              ],
              [
                44.878962,
                36.849562
              ],
              [
                44.878204,
                36.8493
              ],
              [
                44.8772,
                36.849132
              ],
              [
                44.876621,
                36.849168
              ],
              [
                44.876133,
                36.849062
              ],
              [
                44.875658,
                36.848856
              ],
              [
                44.874989,
                36.848295
              ],
              [
                44.874714,
                36.84817
              ],
              [
                44.874576,
                36.847785
              ],
              [
                44.874278,
                36.847469
              ],
              [
                44.874174,
                36.847215
              ],
              [
                44.873343,
                36.846868
              ],
              [
                44.872628,
                36.846228
              ],
              [
                44.87088,
                36.845951
              ],
              [
                44.870045,
                36.845888
              ],
              [
                44.869552,
                36.845763
              ],
              [
                44.868674,
                36.845834
              ],
              [
                44.867641,
                36.8461
              ],
              [
                44.867145,
                36.846112
              ],
              [
                44.865807,
                36.845536
              ],
              [
                44.86539,
                36.845407
              ],
              [
                44.864969,
                36.845464
              ],
              [
                44.864491,
                36.845697
              ],
              [
                44.862625,
                36.84586
              ],
              [
                44.861645,
                36.84633
              ],
              [
                44.86133,
                36.846348
              ],
              [
                44.861483,
                36.845648
              ],
              [
                44.861449,
                36.845215
              ],
              [
                44.861495,
                36.844895
              ],
              [
                44.861244,
                36.844219
              ],
              [
                44.86112,
                36.843082
              ],
              [
                44.861198,
                36.842541
              ],
              [
                44.861635,
                36.841848
              ],
              [
                44.861417,
                36.841547
              ],
              [
                44.861112,
                36.83936
              ],
              [
                44.861091,
                36.83798
              ],
              [
                44.861241,
                36.837514
              ],
              [
                44.86144,
                36.837195
              ],
              [
                44.862181,
                36.836739
              ],
              [
                44.862778,
                36.835822
              ],
              [
                44.863149,
                36.835472
              ],
              [
                44.863746,
                36.835116
              ],
              [
                44.864153,
                36.834548
              ],
              [
                44.864482,
                36.834351
              ],
              [
                44.865264,
                36.83413
              ],
              [
                44.865657,
                36.833923
              ],
              [
                44.865928,
                36.833623
              ],
              [
                44.866017,
                36.832951
              ],
              [
                44.86626,
                36.832752
              ],
              [
                44.86684,
                36.831883
              ],
              [
                44.865898,
                36.831808
              ],
              [
                44.865453,
                36.831876
              ],
              [
                44.864994,
                36.832006
              ],
              [
                44.863734,
                36.831828
              ],
              [
                44.861878,
                36.831805
              ],
              [
                44.861299,
                36.831843
              ],
              [
                44.860042,
                36.832135
              ],
              [
                44.859934,
                36.832238
              ],
              [
                44.859696,
                36.832261
              ],
              [
                44.85946,
                36.83238
              ],
              [
                44.859183,
                36.832372
              ],
              [
                44.858041,
                36.832016
              ],
              [
                44.857685,
                36.831648
              ],
              [
                44.857119,
                36.831246
              ],
              [
                44.856508,
                36.830913
              ],
              [
                44.85527,
                36.83074
              ],
              [
                44.853844,
                36.830381
              ],
              [
                44.852992,
                36.830561
              ],
              [
                44.852471,
                36.830554
              ],
              [
                44.851798,
                36.829864
              ],
              [
                44.850881,
                36.828517
              ],
              [
                44.850492,
                36.828216
              ],
              [
                44.849642,
                36.827723
              ],
              [
                44.849324,
                36.827392
              ],
              [
                44.849104,
                36.826607
              ],
              [
                44.848771,
                36.825938
              ],
              [
                44.847837,
                36.825311
              ],
              [
                44.84708,
                36.824942
              ],
              [
                44.845995,
                36.823859
              ],
              [
                44.845335,
                36.823412
              ],
              [
                44.844629,
                36.822177
              ],
              [
                44.843999,
                36.821322
              ],
              [
                44.843699,
                36.820586
              ],
              [
                44.843089,
                36.820104
              ],
              [
                44.842602,
                36.819803
              ],
              [
                44.84147,
                36.818841
              ],
              [
                44.840937,
                36.817981
              ],
              [
                44.840109,
                36.817145
              ],
              [
                44.839278,
                36.817001
              ],
              [
                44.839326,
                36.816645
              ],
              [
                44.838666,
                36.81612
              ],
              [
                44.838355,
                36.815753
              ],
              [
                44.838514,
                36.815201
              ],
              [
                44.838489,
                36.814794
              ],
              [
                44.838664,
                36.814195
              ],
              [
                44.839157,
                36.813166
              ],
              [
                44.839164,
                36.812378
              ],
              [
                44.839055,
                36.811381
              ],
              [
                44.839065,
                36.810304
              ],
              [
                44.839256,
                36.809746
              ],
              [
                44.839191,
                36.809363
              ],
              [
                44.838978,
                36.809085
              ],
              [
                44.838647,
                36.808888
              ],
              [
                44.838204,
                36.808824
              ],
              [
                44.837244,
                36.808542
              ],
              [
                44.837166,
                36.808144
              ],
              [
                44.837272,
                36.807067
              ],
              [
                44.837035,
                36.806618
              ],
              [
                44.837085,
                36.806207
              ],
              [
                44.83767,
                36.805442
              ],
              [
                44.83778,
                36.804994
              ],
              [
                44.837672,
                36.804541
              ],
              [
                44.837733,
                36.804128
              ],
              [
                44.837485,
                36.803531
              ],
              [
                44.837594,
                36.803382
              ],
              [
                44.838193,
                36.803025
              ],
              [
                44.838292,
                36.802728
              ],
              [
                44.838057,
                36.802445
              ],
              [
                44.837951,
                36.802157
              ],
              [
                44.838027,
                36.800788
              ],
              [
                44.837996,
                36.800417
              ],
              [
                44.837835,
                36.799972
              ],
              [
                44.837737,
                36.799202
              ],
              [
                44.8373,
                36.798717
              ],
              [
                44.836876,
                36.798098
              ],
              [
                44.836814,
                36.797129
              ],
              [
                44.837491,
                36.795718
              ],
              [
                44.837941,
                36.794994
              ],
              [
                44.838493,
                36.794838
              ],
              [
                44.838764,
                36.794529
              ],
              [
                44.838921,
                36.794266
              ],
              [
                44.839084,
                36.793888
              ],
              [
                44.839176,
                36.79347
              ],
              [
                44.839171,
                36.793208
              ],
              [
                44.839511,
                36.792319
              ],
              [
                44.839589,
                36.791877
              ],
              [
                44.839533,
                36.791248
              ],
              [
                44.839859,
                36.790422
              ],
              [
                44.840143,
                36.790059
              ],
              [
                44.840463,
                36.789033
              ],
              [
                44.840769,
                36.788666
              ],
              [
                44.841333,
                36.787755
              ],
              [
                44.8416,
                36.787421
              ],
              [
                44.841908,
                36.78715
              ],
              [
                44.842241,
                36.786979
              ],
              [
                44.842459,
                36.786679
              ],
              [
                44.842672,
                36.785969
              ],
              [
                44.842846,
                36.785747
              ],
              [
                44.843458,
                36.785248
              ],
              [
                44.843713,
                36.784759
              ],
              [
                44.843981,
                36.783672
              ],
              [
                44.843928,
                36.78215
              ],
              [
                44.844057,
                36.781463
              ],
              [
                44.844303,
                36.78052
              ],
              [
                44.844998,
                36.778703
              ],
              [
                44.845333,
                36.778314
              ],
              [
                44.845624,
                36.77815
              ],
              [
                44.845955,
                36.77812
              ],
              [
                44.846643,
                36.778159
              ],
              [
                44.847162,
                36.777922
              ],
              [
                44.847675,
                36.777563
              ],
              [
                44.848234,
                36.77731
              ],
              [
                44.849294,
                36.777301
              ],
              [
                44.849679,
                36.777254
              ],
              [
                44.850065,
                36.777159
              ],
              [
                44.850659,
                36.776898
              ],
              [
                44.851076,
                36.77657
              ],
              [
                44.852595,
                36.775898
              ],
              [
                44.85345,
                36.77521
              ],
              [
                44.853807,
                36.775052
              ],
              [
                44.854467,
                36.774896
              ],
              [
                44.854747,
                36.774655
              ],
              [
                44.855016,
                36.774338
              ],
              [
                44.854948,
                36.774008
              ],
              [
                44.855001,
                36.773772
              ],
              [
                44.855241,
                36.773635
              ],
              [
                44.856111,
                36.773652
              ],
              [
                44.856738,
                36.773571
              ],
              [
                44.858223,
                36.773116
              ],
              [
                44.858667,
                36.773118
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555276,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چایپاره",
          "name:en": "Chaypareh County",
          "name:ku": "Çaypare",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2623755",
          "wikipedia": "en:Chaypareh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                44.6830745,
                38.9155917
              ],
              [
                44.6830745,
                38.9153135
              ],
              [
                44.6816846,
                38.9111414
              ],
              [
                44.6819651,
                38.9105852
              ],
              [
                44.6816846,
                38.910316
              ],
              [
                44.679508,
                38.9041256
              ],
              [
                44.6852479,
                38.9018164
              ],
              [
                44.6871916,
                38.9018165
              ],
              [
                44.6877479,
                38.9020946
              ],
              [
                44.6891347,
                38.9020946
              ],
              [
                44.6899682,
                38.9023728
              ],
              [
                44.6924683,
                38.9023727
              ],
              [
                44.6934319,
                38.9022719
              ],
              [
                44.6942647,
                38.9019939
              ],
              [
                44.6970415,
                38.9019939
              ],
              [
                44.6975984,
                38.9017158
              ],
              [
                44.6987078,
                38.9017158
              ],
              [
                44.6995414,
                38.9014377
              ],
              [
                44.7146642,
                38.8998346
              ],
              [
                44.7149408,
                38.8995564
              ],
              [
                44.7154978,
                38.8995565
              ],
              [
                44.7249442,
                38.8948283
              ],
              [
                44.740971,
                38.8789501
              ],
              [
                44.7420813,
                38.8775595
              ],
              [
                44.7434712,
                38.8761778
              ],
              [
                44.7440274,
                38.8750653
              ],
              [
                44.744861,
                38.8742309
              ],
              [
                44.7451376,
                38.8733966
              ],
              [
                44.7517881,
                38.8620391
              ],
              [
                44.7520646,
                38.8617609
              ],
              [
                44.7512311,
                38.8575893
              ],
              [
                44.748731,
                38.8556513
              ],
              [
                44.7481747,
                38.8550951
              ],
              [
                44.7364996,
                38.8473287
              ],
              [
                44.7339879,
                38.8386583
              ],
              [
                44.7363364,
                38.8227247
              ],
              [
                44.7380029,
                38.8227247
              ],
              [
                44.7385601,
                38.8225388
              ],
              [
                44.7396702,
                38.8221683
              ],
              [
                44.7399467,
                38.8218992
              ],
              [
                44.7407795,
                38.8218992
              ],
              [
                44.7416132,
                38.8216209
              ],
              [
                44.743003,
                38.821621
              ],
              [
                44.7432796,
                38.8213428
              ],
              [
                44.7463367,
                38.8213429
              ],
              [
                44.7785149,
                38.8215182
              ],
              [
                44.7790712,
                38.82124
              ],
              [
                44.8037945,
                38.816243
              ],
              [
                44.8065711,
                38.816243
              ],
              [
                44.8074047,
                38.8159649
              ],
              [
                44.811859,
                38.8130223
              ],
              [
                44.8140794,
                38.812466
              ],
              [
                44.8163028,
                38.8124661
              ],
              [
                44.8165795,
                38.8121878
              ],
              [
                44.8174123,
                38.8121878
              ],
              [
                44.8189358,
                38.8104384
              ],
              [
                44.8200459,
                38.8104384
              ],
              [
                44.8264359,
                38.8090477
              ],
              [
                44.827546,
                38.8084915
              ],
              [
                44.8283789,
                38.8084915
              ],
              [
                44.8372689,
                38.8059972
              ],
              [
                44.8392127,
                38.8054409
              ],
              [
                44.839769,
                38.8054409
              ],
              [
                44.8493924,
                38.7997761
              ],
              [
                44.8499456,
                38.7997761
              ],
              [
                44.8505025,
                38.799498
              ],
              [
                44.8513361,
                38.799498
              ],
              [
                44.8516127,
                38.7992198
              ],
              [
                44.8524495,
                38.7992198
              ],
              [
                44.8530026,
                38.7989416
              ],
              [
                44.867959,
                38.7982183
              ],
              [
                44.8685154,
                38.7979401
              ],
              [
                44.8882483,
                38.7856694
              ],
              [
                44.9101986,
                38.7678961
              ],
              [
                44.911865,
                38.7667835
              ],
              [
                44.911865,
                38.7665143
              ],
              [
                44.9302015,
                38.7576218
              ],
              [
                44.9310351,
                38.7576218
              ],
              [
                44.9315882,
                38.7573436
              ],
              [
                44.9324218,
                38.7573436
              ],
              [
                44.9327015,
                38.7570655
              ],
              [
                44.9529957,
                38.7578686
              ],
              [
                44.9538294,
                38.7575905
              ],
              [
                44.9549427,
                38.7575905
              ],
              [
                44.9645996,
                38.7536338
              ],
              [
                44.9662661,
                38.7536338
              ],
              [
                44.9668223,
                38.7533556
              ],
              [
                44.969599,
                38.7533556
              ],
              [
                44.970156,
                38.7530774
              ],
              [
                44.9712662,
                38.7530775
              ],
              [
                44.9718224,
                38.7527993
              ],
              [
                44.9729326,
                38.7527992
              ],
              [
                44.9734889,
                38.7525211
              ],
              [
                44.9754327,
                38.7525211
              ],
              [
                44.9759889,
                38.752243
              ],
              [
                44.9773796,
                38.752243
              ],
              [
                44.9812656,
                38.752243
              ],
              [
                44.9818227,
                38.7525212
              ],
              [
                44.9843227,
                38.7525211
              ],
              [
                44.984879,
                38.7527993
              ],
              [
                44.9859892,
                38.7527993
              ],
              [
                44.9995593,
                38.7550425
              ],
              [
                45.0143575,
                38.7462237
              ],
              [
                45.030525,
                38.7506325
              ],
              [
                45.0316391,
                38.7506324
              ],
              [
                45.0321923,
                38.7509107
              ],
              [
                45.0363618,
                38.7509107
              ],
              [
                45.0369151,
                38.7506325
              ],
              [
                45.0377486,
                38.7506325
              ],
              [
                45.0381673,
                38.7506324
              ],
              [
                45.0391385,
                38.7503542
              ],
              [
                45.0416386,
                38.7503542
              ],
              [
                45.0421956,
                38.7500759
              ],
              [
                45.0533052,
                38.750076
              ],
              [
                45.0544154,
                38.7503542
              ],
              [
                45.0549717,
                38.7503542
              ],
              [
                45.0599717,
                38.7506325
              ],
              [
                45.0627515,
                38.7509109
              ],
              [
                45.0644188,
                38.7509108
              ],
              [
                45.0658047,
                38.7511891
              ],
              [
                45.0694181,
                38.7511891
              ],
              [
                45.0705282,
                38.7514674
              ],
              [
                45.0735854,
                38.7514675
              ],
              [
                45.0910849,
                38.7542414
              ],
              [
                45.0927514,
                38.7542414
              ],
              [
                45.1013027,
                38.7595464
              ],
              [
                45.1024168,
                38.7601031
              ],
              [
                45.1072947,
                38.7607934
              ],
              [
                45.1129147,
                38.7702278
              ],
              [
                45.1138984,
                38.7704736
              ],
              [
                45.1233716,
                38.7851281
              ],
              [
                45.1385643,
                38.793851
              ],
              [
                45.1586037,
                38.7965922
              ],
              [
                45.1630781,
                38.819515
              ],
              [
                45.170642,
                38.8271532
              ],
              [
                45.1750944,
                38.8391729
              ],
              [
                45.1951788,
                38.8426493
              ],
              [
                45.2174091,
                38.851435
              ],
              [
                45.2193561,
                38.851435
              ],
              [
                45.2201897,
                38.851713
              ],
              [
                45.2291678,
                38.8565529
              ],
              [
                45.2509785,
                38.8547925
              ],
              [
                45.2723447,
                38.8629891
              ],
              [
                45.2731775,
                38.8629891
              ],
              [
                45.2734581,
                38.8627113
              ],
              [
                45.2740112,
                38.8627112
              ],
              [
                45.2755981,
                38.8630989
              ],
              [
                45.2781728,
                38.8670312
              ],
              [
                45.2774194,
                38.8677427
              ],
              [
                45.2776991,
                38.8680208
              ],
              [
                45.2806822,
                38.873106
              ],
              [
                45.2815158,
                38.8736622
              ],
              [
                45.3063601,
                38.8773172
              ],
              [
                45.3063601,
                38.8778739
              ],
              [
                45.3002356,
                38.894106
              ],
              [
                45.3010939,
                38.9192193
              ],
              [
                45.2763386,
                38.9460906
              ],
              [
                45.2741182,
                38.9474816
              ],
              [
                45.261339,
                38.952758
              ],
              [
                45.2593952,
                38.9533144
              ],
              [
                45.2577288,
                38.9541489
              ],
              [
                45.2293922,
                38.9619289
              ],
              [
                45.2288391,
                38.9619288
              ],
              [
                45.2266155,
                38.9624852
              ],
              [
                45.2166161,
                38.9633107
              ],
              [
                45.2155027,
                38.9635889
              ],
              [
                45.2143926,
                38.9635889
              ],
              [
                45.2138355,
                38.9638671
              ],
              [
                45.2124488,
                38.9638671
              ],
              [
                45.2102261,
                38.9644234
              ],
              [
                45.2093924,
                38.9644234
              ],
              [
                45.2091159,
                38.9647016
              ],
              [
                45.2057791,
                38.9647015
              ],
              [
                45.2049455,
                38.9644233
              ],
              [
                45.2041127,
                38.9644234
              ],
              [
                45.2027259,
                38.963867
              ],
              [
                45.1992842,
                38.9652326
              ],
              [
                45.1965623,
                38.966901
              ],
              [
                45.1739158,
                38.9819016
              ],
              [
                45.1555533,
                38.9943848
              ],
              [
                45.149817,
                38.9991205
              ],
              [
                45.1382254,
                39.0007732
              ],
              [
                45.081539,
                38.9664831
              ],
              [
                45.0611113,
                38.964748
              ],
              [
                45.0508116,
                38.9783609
              ],
              [
                45.0451062,
                38.9948609
              ],
              [
                45.0405159,
                39.0017202
              ],
              [
                45.0321864,
                39.0078464
              ],
              [
                45.0230025,
                39.0095805
              ],
              [
                45.0120666,
                39.0102172
              ],
              [
                45.0109573,
                39.0098699
              ],
              [
                45.0104001,
                39.0098699
              ],
              [
                45.0095666,
                39.009314
              ],
              [
                45.0061033,
                39.0071574
              ],
              [
                44.9835203,
                39.0061124
              ],
              [
                44.9240196,
                38.9743679
              ],
              [
                44.9231859,
                38.9740898
              ],
              [
                44.9220758,
                38.9738118
              ],
              [
                44.9206859,
                38.9735337
              ],
              [
                44.9192991,
                38.9729775
              ],
              [
                44.9145763,
                38.9721522
              ],
              [
                44.9138638,
                38.9717177
              ],
              [
                44.913463,
                38.971318
              ],
              [
                44.9104099,
                38.9702056
              ],
              [
                44.8857078,
                38.9629375
              ],
              [
                44.8792296,
                38.9583658
              ],
              [
                44.877006,
                38.9583659
              ],
              [
                44.8756193,
                38.9580878
              ],
              [
                44.866173,
                38.9580878
              ],
              [
                44.865616,
                38.9583658
              ],
              [
                44.863673,
                38.9583658
              ],
              [
                44.8633964,
                38.9586439
              ],
              [
                44.8595065,
                38.9586439
              ],
              [
                44.8581158,
                38.958922
              ],
              [
                44.8558962,
                38.9589219
              ],
              [
                44.8442734,
                38.9519916
              ],
              [
                44.8417733,
                38.9519915
              ],
              [
                44.8398264,
                38.9522697
              ],
              [
                44.8373263,
                38.9522696
              ],
              [
                44.8356599,
                38.9525477
              ],
              [
                44.8223268,
                38.9525476
              ],
              [
                44.8212136,
                38.9522696
              ],
              [
                44.8164572,
                38.9540049
              ],
              [
                44.815347,
                38.9537269
              ],
              [
                44.8131234,
                38.9537269
              ],
              [
                44.8122898,
                38.9534487
              ],
              [
                44.8106234,
                38.9534488
              ],
              [
                44.8092367,
                38.9528927
              ],
              [
                44.8084038,
                38.9528926
              ],
              [
                44.7928472,
                38.948174
              ],
              [
                44.7752951,
                38.9420541
              ],
              [
                44.7598963,
                38.9392287
              ],
              [
                44.7596198,
                38.9389504
              ],
              [
                44.7585065,
                38.9389505
              ],
              [
                44.7585065,
                38.9386724
              ],
              [
                44.7571198,
                38.9386724
              ],
              [
                44.75684,
                38.9383942
              ],
              [
                44.756167,
                38.9383347
              ],
              [
                44.7557299,
                38.938116
              ],
              [
                44.7551728,
                38.9378379
              ],
              [
                44.7548963,
                38.9375599
              ],
              [
                44.75434,
                38.9375599
              ],
              [
                44.7532299,
                38.9370036
              ],
              [
                44.7523962,
                38.9370036
              ],
              [
                44.7218111,
                38.9301815
              ],
              [
                44.7162578,
                38.9274003
              ],
              [
                44.714868,
                38.926566
              ],
              [
                44.7137577,
                38.9257316
              ],
              [
                44.7021673,
                38.9166817
              ],
              [
                44.6864081,
                38.9136447
              ],
              [
                44.6861316,
                38.9139228
              ],
              [
                44.6847418,
                38.9139229
              ],
              [
                44.6833518,
                38.9150354
              ],
              [
                44.6833518,
                38.9153135
              ],
              [
                44.6830745,
                38.9155917
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14484875,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چهار برج",
          "place": "county",
          "ref:sci": "0418",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.7611034,
                37.2065666
              ],
              [
                45.758009,
                37.2033103
              ],
              [
                45.7515227,
                37.1923204
              ],
              [
                45.7489677,
                37.1875268
              ],
              [
                45.7429342,
                37.1791443
              ],
              [
                45.7423172,
                37.1742199
              ],
              [
                45.7409184,
                37.1674328
              ],
              [
                45.7389163,
                37.1629843
              ],
              [
                45.739088,
                37.1582645
              ],
              [
                45.742875,
                37.1504419
              ],
              [
                45.7447528,
                37.1461559
              ],
              [
                45.7484435,
                37.144035
              ],
              [
                45.7500958,
                37.142564
              ],
              [
                45.751748,
                37.1403404
              ],
              [
                45.7525849,
                37.1395877
              ],
              [
                45.7545161,
                37.1386298
              ],
              [
                45.7571769,
                37.1379969
              ],
              [
                45.7582546,
                37.1377588
              ],
              [
                45.7606952,
                37.1377022
              ],
              [
                45.7623482,
                37.1378087
              ],
              [
                45.7653951,
                37.138168
              ],
              [
                45.7664438,
                37.1379124
              ],
              [
                45.7673692,
                37.1373298
              ],
              [
                45.768041,
                37.1364756
              ],
              [
                45.7691091,
                37.1361623
              ],
              [
                45.7712745,
                37.1371245
              ],
              [
                45.7725525,
                37.1373426
              ],
              [
                45.7735801,
                37.1375256
              ],
              [
                45.7748816,
                37.1374914
              ],
              [
                45.7760381,
                37.1373298
              ],
              [
                45.7771754,
                37.1369021
              ],
              [
                45.7779479,
                37.1362692
              ],
              [
                45.7780906,
                37.1353528
              ],
              [
                45.7777235,
                37.1346752
              ],
              [
                45.7772183,
                37.1336348
              ],
              [
                45.7770681,
                37.1326597
              ],
              [
                45.7779479,
                37.1319241
              ],
              [
                45.7796757,
                37.1309189
              ],
              [
                45.7814455,
                37.1295633
              ],
              [
                45.7833981,
                37.1280749
              ],
              [
                45.7846641,
                37.1274762
              ],
              [
                45.785501,
                37.1273564
              ],
              [
                45.7865095,
                37.1274591
              ],
              [
                45.7877326,
                37.1279894
              ],
              [
                45.7886767,
                37.1280921
              ],
              [
                45.7898354,
                37.127767
              ],
              [
                45.7903075,
                37.1268432
              ],
              [
                45.791316,
                37.1263812
              ],
              [
                45.7925391,
                37.1262786
              ],
              [
                45.7935262,
                37.1260391
              ],
              [
                45.7942104,
                37.1252876
              ],
              [
                45.7948493,
                37.1236896
              ],
              [
                45.7948136,
                37.12272
              ],
              [
                45.7946634,
                37.121625
              ],
              [
                45.7945729,
                37.1205441
              ],
              [
                45.7940494,
                37.1197191
              ],
              [
                45.7928607,
                37.1189529
              ],
              [
                45.791791,
                37.1184857
              ],
              [
                45.7903343,
                37.1183317
              ],
              [
                45.7888666,
                37.1180185
              ],
              [
                45.7875815,
                37.1174039
              ],
              [
                45.7871309,
                37.1166512
              ],
              [
                45.7874457,
                37.1157577
              ],
              [
                45.7889602,
                37.1154496
              ],
              [
                45.7899235,
                37.1155128
              ],
              [
                45.7916082,
                37.1157866
              ],
              [
                45.7941837,
                37.1162197
              ],
              [
                45.7952923,
                37.1160144
              ],
              [
                45.7963182,
                37.1152734
              ],
              [
                45.7975588,
                37.1139216
              ],
              [
                45.7979035,
                37.1128645
              ],
              [
                45.7977471,
                37.1118988
              ],
              [
                45.7969723,
                37.1112866
              ],
              [
                45.7959509,
                37.1106399
              ],
              [
                45.7949638,
                37.1106057
              ],
              [
                45.7948136,
                37.1095961
              ],
              [
                45.7952642,
                37.1088945
              ],
              [
                45.7955385,
                37.1075817
              ],
              [
                45.7915306,
                37.1053351
              ],
              [
                45.7927174,
                37.1021604
              ],
              [
                45.7958804,
                37.1002249
              ],
              [
                45.7981395,
                37.0997444
              ],
              [
                45.801378,
                37.1004341
              ],
              [
                45.8046861,
                37.1018388
              ],
              [
                45.8066149,
                37.1023522
              ],
              [
                45.8083505,
                37.1024944
              ],
              [
                45.8106708,
                37.1028023
              ],
              [
                45.8114862,
                37.1033157
              ],
              [
                45.8163026,
                37.1051538
              ],
              [
                45.8184385,
                37.1049586
              ],
              [
                45.8215961,
                37.1034044
              ],
              [
                45.8302716,
                37.0938395
              ],
              [
                45.8335697,
                37.0921795
              ],
              [
                45.8350896,
                37.0910272
              ],
              [
                45.836935,
                37.088939
              ],
              [
                45.8388233,
                37.0882201
              ],
              [
                45.8405748,
                37.087999
              ],
              [
                45.8416371,
                37.0892438
              ],
              [
                45.8422442,
                37.0918164
              ],
              [
                45.8425858,
                37.0934749
              ],
              [
                45.844016,
                37.0961961
              ],
              [
                45.846591,
                37.0971888
              ],
              [
                45.8483831,
                37.097563
              ],
              [
                45.8503326,
                37.0965018
              ],
              [
                45.8516364,
                37.0952747
              ],
              [
                45.8522865,
                37.0932966
              ],
              [
                45.8531448,
                37.0912563
              ],
              [
                45.8528873,
                37.0890914
              ],
              [
                45.8542728,
                37.0869534
              ],
              [
                45.8561182,
                37.0863372
              ],
              [
                45.8588072,
                37.0867127
              ],
              [
                45.8604764,
                37.0893706
              ],
              [
                45.8613958,
                37.0902948
              ],
              [
                45.862464,
                37.0916692
              ],
              [
                45.8651943,
                37.0924908
              ],
              [
                45.8671474,
                37.0922596
              ],
              [
                45.8680887,
                37.0916983
              ],
              [
                45.8697608,
                37.0901922
              ],
              [
                45.8721885,
                37.0872999
              ],
              [
                45.8751726,
                37.0850705
              ],
              [
                45.8778489,
                37.0835043
              ],
              [
                45.8795987,
                37.083162
              ],
              [
                45.8815434,
                37.0826929
              ],
              [
                45.8835357,
                37.0827956
              ],
              [
                45.8848406,
                37.0828349
              ],
              [
                45.8868858,
                37.0838621
              ],
              [
                45.8883433,
                37.085603
              ],
              [
                45.8903549,
                37.0861165
              ],
              [
                45.8921335,
                37.0864537
              ],
              [
                45.893997,
                37.0862483
              ],
              [
                45.8964955,
                37.0848636
              ],
              [
                45.8980035,
                37.0832217
              ],
              [
                45.899906,
                37.0799398
              ],
              [
                45.9010076,
                37.0787367
              ],
              [
                45.9034967,
                37.0780519
              ],
              [
                45.9057162,
                37.0779781
              ],
              [
                45.9077239,
                37.076631
              ],
              [
                45.9078955,
                37.0756894
              ],
              [
                45.9073022,
                37.0750848
              ],
              [
                45.9059429,
                37.0731727
              ],
              [
                45.905385,
                37.0712039
              ],
              [
                45.9055832,
                37.070184
              ],
              [
                45.9062929,
                37.0694484
              ],
              [
                45.9078331,
                37.0694624
              ],
              [
                45.9101646,
                37.0697251
              ],
              [
                45.9121116,
                37.0697251
              ],
              [
                45.9150526,
                37.0695932
              ],
              [
                45.9168351,
                37.0694461
              ],
              [
                45.9179445,
                37.06833
              ],
              [
                45.9192466,
                37.0669236
              ],
              [
                45.9193754,
                37.0654511
              ],
              [
                45.9189033,
                37.0634992
              ],
              [
                45.9172404,
                37.0605156
              ],
              [
                45.9170782,
                37.0588646
              ],
              [
                45.9181454,
                37.0577687
              ],
              [
                45.9193899,
                37.0575239
              ],
              [
                45.9212519,
                37.0576951
              ],
              [
                45.9230495,
                37.0573818
              ],
              [
                45.9269731,
                37.0552585
              ],
              [
                45.9315297,
                37.054574
              ],
              [
                45.9316943,
                37.0554902
              ],
              [
                45.931707,
                37.0577184
              ],
              [
                45.9320224,
                37.0591397
              ],
              [
                45.9323678,
                37.0603858
              ],
              [
                45.932943,
                37.0614695
              ],
              [
                45.9343116,
                37.0634728
              ],
              [
                45.9363246,
                37.0655375
              ],
              [
                45.9383755,
                37.0673828
              ],
              [
                45.9416385,
                37.0691798
              ],
              [
                45.9450037,
                37.0702823
              ],
              [
                45.9516048,
                37.071649
              ],
              [
                45.9620332,
                37.0730529
              ],
              [
                45.9696292,
                37.074491
              ],
              [
                45.977118,
                37.0758264
              ],
              [
                45.9796071,
                37.0764769
              ],
              [
                45.9822703,
                37.0772918
              ],
              [
                45.9839201,
                37.0775212
              ],
              [
                45.9853363,
                37.07735
              ],
              [
                45.9866667,
                37.0774527
              ],
              [
                45.9883189,
                37.0778122
              ],
              [
                45.990293,
                37.0778636
              ],
              [
                45.9919452,
                37.0778122
              ],
              [
                45.9938631,
                37.0779765
              ],
              [
                45.9950137,
                37.0781717
              ],
              [
                45.9976505,
                37.0794278
              ],
              [
                46.0031032,
                37.0816126
              ],
              [
                46.0225009,
                37.091883
              ],
              [
                46.032114,
                37.0960079
              ],
              [
                46.0339808,
                37.0967952
              ],
              [
                46.0372638,
                37.0980788
              ],
              [
                46.0398388,
                37.0990714
              ],
              [
                46.0424248,
                37.0997087
              ],
              [
                46.0433887,
                37.0997567
              ],
              [
                46.04442,
                37.1001411
              ],
              [
                46.0478515,
                37.1010985
              ],
              [
                46.0531793,
                37.1024562
              ],
              [
                46.0527563,
                37.1031788
              ],
              [
                46.0495376,
                37.1042398
              ],
              [
                46.0470485,
                37.1064988
              ],
              [
                46.0475762,
                37.1080667
              ],
              [
                46.0485838,
                37.1088263
              ],
              [
                46.0482931,
                37.1093737
              ],
              [
                46.0457562,
                37.109629
              ],
              [
                46.0443409,
                37.111082
              ],
              [
                46.0445165,
                37.1130356
              ],
              [
                46.0450315,
                37.1138227
              ],
              [
                46.0446882,
                37.114644
              ],
              [
                46.0430574,
                37.1157734
              ],
              [
                46.0420274,
                37.1176897
              ],
              [
                46.0396671,
                37.1183057
              ],
              [
                46.0397524,
                37.1205482
              ],
              [
                46.0383796,
                37.1224805
              ],
              [
                46.0368347,
                37.1248757
              ],
              [
                46.0372638,
                37.1274762
              ],
              [
                46.0367265,
                37.1285151
              ],
              [
                46.0355901,
                37.1313083
              ],
              [
                46.0332848,
                37.1340897
              ],
              [
                46.0303115,
                37.1356192
              ],
              [
                46.0253763,
                37.1377061
              ],
              [
                46.0213422,
                37.1376719
              ],
              [
                46.0180807,
                37.1373298
              ],
              [
                46.0163111,
                37.1376159
              ],
              [
                46.0146183,
                37.1383396
              ],
              [
                46.0135327,
                37.1396334
              ],
              [
                46.0129737,
                37.1416404
              ],
              [
                46.0118869,
                37.1433106
              ],
              [
                46.0101704,
                37.144999
              ],
              [
                46.0093367,
                37.1472219
              ],
              [
                46.0062568,
                37.1514226
              ],
              [
                46.0048423,
                37.153275
              ],
              [
                46.0033984,
                37.1540275
              ],
              [
                46.0007528,
                37.1553326
              ],
              [
                45.9977312,
                37.1568034
              ],
              [
                45.9950351,
                37.1582303
              ],
              [
                45.9931039,
                37.160214
              ],
              [
                45.9907865,
                37.1612058
              ],
              [
                45.9888055,
                37.1632768
              ],
              [
                45.9861037,
                37.1649593
              ],
              [
                45.9832294,
                37.1656433
              ],
              [
                45.9797573,
                37.1667462
              ],
              [
                45.9749937,
                37.1680115
              ],
              [
                45.9713459,
                37.168969
              ],
              [
                45.9679555,
                37.1684903
              ],
              [
                45.9661531,
                37.1695162
              ],
              [
                45.9653973,
                37.1705624
              ],
              [
                45.9628989,
                37.1716223
              ],
              [
                45.9599304,
                37.1726964
              ],
              [
                45.9565502,
                37.1726876
              ],
              [
                45.9547065,
                37.1731771
              ],
              [
                45.9505956,
                37.1741055
              ],
              [
                45.9474454,
                37.1749999
              ],
              [
                45.9426652,
                37.1756838
              ],
              [
                45.9400445,
                37.1756783
              ],
              [
                45.9355991,
                37.1768598
              ],
              [
                45.932254,
                37.1777714
              ],
              [
                45.9297929,
                37.1777714
              ],
              [
                45.927864,
                37.1775374
              ],
              [
                45.9246791,
                37.1768877
              ],
              [
                45.9221434,
                37.1764408
              ],
              [
                45.9197187,
                37.1763553
              ],
              [
                45.9158563,
                37.1744575
              ],
              [
                45.9124446,
                37.1735
              ],
              [
                45.9106636,
                37.1731239
              ],
              [
                45.908904,
                37.1725939
              ],
              [
                45.8833265,
                37.1716364
              ],
              [
                45.8674478,
                37.1722861
              ],
              [
                45.863285,
                37.1726281
              ],
              [
                45.8460885,
                37.1749873
              ],
              [
                45.7611034,
                37.2065666
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14484928,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان باروق",
          "place": "county",
          "ref:sci": "0419",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.1799896,
                36.9090095
              ],
              [
                46.1809015,
                36.909034
              ],
              [
                46.1815882,
                36.9079874
              ],
              [
                46.1820173,
                36.9069407
              ],
              [
                46.1835407,
                36.9048475
              ],
              [
                46.1848283,
                36.9038351
              ],
              [
                46.1859441,
                36.9034576
              ],
              [
                46.1874676,
                36.9032174
              ],
              [
                46.1904716,
                36.9034748
              ],
              [
                46.1918235,
                36.9031488
              ],
              [
                46.1934757,
                36.9020506
              ],
              [
                46.1947632,
                36.9017074
              ],
              [
                46.1956858,
                36.9017074
              ],
              [
                46.197145,
                36.9019648
              ],
              [
                46.1981106,
                36.9015702
              ],
              [
                46.1992907,
                36.9009181
              ],
              [
                46.2013507,
                36.8995625
              ],
              [
                46.2035608,
                36.8982756
              ],
              [
                46.2048054,
                36.8981554
              ],
              [
                46.2069511,
                36.8982928
              ],
              [
                46.2084531,
                36.8974347
              ],
              [
                46.2111568,
                36.8943802
              ],
              [
                46.2128734,
                36.8925268
              ],
              [
                46.215105,
                36.8914972
              ],
              [
                46.2189674,
                36.890845
              ],
              [
                46.2260055,
                36.8891632
              ],
              [
                46.2337303,
                36.8865889
              ],
              [
                46.2377429,
                36.8855591
              ],
              [
                46.2424421,
                36.8842719
              ],
              [
                46.2450814,
                36.8837742
              ],
              [
                46.2469254,
                36.8836614
              ],
              [
                46.248065,
                36.8837698
              ],
              [
                46.249845,
                36.8834309
              ],
              [
                46.2548446,
                36.883122
              ],
              [
                46.2592864,
                36.882075
              ],
              [
                46.268363,
                36.8815087
              ],
              [
                46.2734697,
                36.8817834
              ],
              [
                46.2807226,
                36.8827444
              ],
              [
                46.286001,
                36.8841862
              ],
              [
                46.2917518,
                36.8865202
              ],
              [
                46.2942407,
                36.8883052
              ],
              [
                46.2966871,
                36.8922523
              ],
              [
                46.3005924,
                36.8989791
              ],
              [
                46.3049268,
                36.9050191
              ],
              [
                46.3070297,
                36.9085879
              ],
              [
                46.3084459,
                36.910235
              ],
              [
                46.313296,
                36.9102603
              ],
              [
                46.3263176,
                36.9096815
              ],
              [
                46.3748358,
                36.9081762
              ],
              [
                46.4111392,
                36.9050495
              ],
              [
                46.4151764,
                36.9040582
              ],
              [
                46.4178586,
                36.903286
              ],
              [
                46.421442,
                36.9027884
              ],
              [
                46.4236092,
                36.9023938
              ],
              [
                46.4248323,
                36.901982
              ],
              [
                46.426034,
                36.9017246
              ],
              [
                46.4267194,
                36.9021416
              ],
              [
                46.4280675,
                36.9029633
              ],
              [
                46.4343595,
                36.9018962
              ],
              [
                46.4443598,
                36.9002774
              ],
              [
                46.44547,
                36.9002774
              ],
              [
                46.4463028,
                36.8999983
              ],
              [
                46.4943121,
                36.8731668
              ],
              [
                46.5096324,
                36.8810784
              ],
              [
                46.5152548,
                36.8793461
              ],
              [
                46.5289877,
                36.8907422
              ],
              [
                46.5416988,
                36.9010606
              ],
              [
                46.5581465,
                36.9064361
              ],
              [
                46.5589801,
                36.9064361
              ],
              [
                46.5603699,
                36.9067151
              ],
              [
                46.564813,
                36.9067151
              ],
              [
                46.5662037,
                36.9061571
              ],
              [
                46.5675935,
                36.906157
              ],
              [
                46.5698131,
                36.9056079
              ],
              [
                46.5714796,
                36.9056079
              ],
              [
                46.5720367,
                36.905887
              ],
              [
                46.5721008,
                36.9058223
              ],
              [
                46.5723132,
                36.9056079
              ],
              [
                46.5986646,
                36.9135143
              ],
              [
                46.6089414,
                36.9182317
              ],
              [
                46.6094976,
                36.9187899
              ],
              [
                46.6100547,
                36.919348
              ],
              [
                46.6108875,
                36.9199062
              ],
              [
                46.6125547,
                36.9201852
              ],
              [
                46.6250541,
                36.9246326
              ],
              [
                46.6261644,
                36.9246326
              ],
              [
                46.6267206,
                36.9249117
              ],
              [
                46.6311645,
                36.9257398
              ],
              [
                46.6336637,
                36.9257398
              ],
              [
                46.6339442,
                36.9260189
              ],
              [
                46.6505326,
                36.930599
              ],
              [
                46.6510888,
                36.9303199
              ],
              [
                46.652199,
                36.9300499
              ],
              [
                46.6549675,
                36.9275426
              ],
              [
                46.6558011,
                36.9264263
              ],
              [
                46.657191,
                36.9236535
              ],
              [
                46.6571473,
                36.9052743
              ],
              [
                46.6585063,
                36.8999401
              ],
              [
                46.660694,
                36.8967087
              ],
              [
                46.6612471,
                36.8967087
              ],
              [
                46.6620807,
                36.8964297
              ],
              [
                46.6640276,
                36.8964297
              ],
              [
                46.6645808,
                36.8967088
              ],
              [
                46.6684707,
                36.8969789
              ],
              [
                46.6748141,
                36.8968513
              ],
              [
                46.6783075,
                36.9007079
              ],
              [
                46.6785841,
                36.9009871
              ],
              [
                46.6849494,
                36.9083077
              ],
              [
                46.685783,
                36.9083078
              ],
              [
                46.6866159,
                36.9088659
              ],
              [
                46.704254,
                36.9099606
              ],
              [
                46.7438491,
                36.888389
              ],
              [
                46.7441256,
                36.8881099
              ],
              [
                46.7552087,
                36.8767403
              ],
              [
                46.7679029,
                36.8564599
              ],
              [
                46.7679029,
                36.8556316
              ],
              [
                46.7681795,
                36.8545152
              ],
              [
                46.7784564,
                36.8281252
              ],
              [
                46.7815135,
                36.823119
              ],
              [
                46.794891,
                36.7762928
              ],
              [
                46.7979809,
                36.7644671
              ],
              [
                46.8351027,
                36.7316487
              ],
              [
                46.8353793,
                36.7308198
              ],
              [
                46.8358188,
                36.7299048
              ],
              [
                46.8415535,
                36.755534
              ],
              [
                46.8415829,
                36.7556654
              ],
              [
                46.8727118,
                36.7904101
              ],
              [
                46.8724353,
                36.7911079
              ],
              [
                46.8721587,
                36.7930527
              ],
              [
                46.8752118,
                36.8008319
              ],
              [
                46.8941113,
                36.815332
              ],
              [
                46.9002911,
                36.8293483
              ],
              [
                46.9135643,
                36.8389531
              ],
              [
                46.9149542,
                36.8472791
              ],
              [
                46.9152338,
                36.8503394
              ],
              [
                46.9157878,
                36.8558929
              ],
              [
                46.9020978,
                36.8699023
              ],
              [
                46.9049731,
                36.8821088
              ],
              [
                46.9074743,
                36.8927258
              ],
              [
                46.9074744,
                36.8957864
              ],
              [
                46.9077509,
                36.898559
              ],
              [
                46.9074743,
                36.8991171
              ],
              [
                46.9027515,
                36.9088392
              ],
              [
                46.892291,
                36.9102619
              ],
              [
                46.8917378,
                36.91082
              ],
              [
                46.8642349,
                36.9185977
              ],
              [
                46.8622918,
                36.9194349
              ],
              [
                46.8492353,
                36.9285988
              ],
              [
                46.8436781,
                36.9385999
              ],
              [
                46.8389552,
                36.9544338
              ],
              [
                46.8389552,
                36.9583224
              ],
              [
                46.8386786,
                36.9591506
              ],
              [
                46.8421779,
                36.971124
              ],
              [
                46.8421779,
                36.9736173
              ],
              [
                46.8421778,
                36.9755616
              ],
              [
                46.8535992,
                37.0028271
              ],
              [
                46.8257901,
                37.0368178
              ],
              [
                46.8027085,
                37.0486128
              ],
              [
                46.8024319,
                37.0488918
              ],
              [
                46.8019014,
                37.0492971
              ],
              [
                46.7893754,
                37.0541661
              ],
              [
                46.7865987,
                37.054445
              ],
              [
                46.7849323,
                37.054445
              ],
              [
                46.7840955,
                37.054724
              ],
              [
                46.783262,
                37.054724
              ],
              [
                46.7827088,
                37.055003
              ],
              [
                46.7807619,
                37.0550031
              ],
              [
                46.7802087,
                37.055282
              ],
              [
                46.7782618,
                37.0552821
              ],
              [
                46.7779853,
                37.0555611
              ],
              [
                46.774929,
                37.0555611
              ],
              [
                46.7713187,
                37.0561101
              ],
              [
                46.7707624,
                37.0563891
              ],
              [
                46.7696522,
                37.0563891
              ],
              [
                46.7690952,
                37.056668
              ],
              [
                46.7674287,
                37.0566681
              ],
              [
                46.7671522,
                37.0569471
              ],
              [
                46.7654857,
                37.0569471
              ],
              [
                46.7652053,
                37.0572261
              ],
              [
                46.7643724,
                37.0572261
              ],
              [
                46.7638194,
                37.0575051
              ],
              [
                46.7621521,
                37.0575051
              ],
              [
                46.7615958,
                37.0577841
              ],
              [
                46.7602059,
                37.0577841
              ],
              [
                46.7329827,
                37.0677834
              ],
              [
                46.7304825,
                37.0688904
              ],
              [
                46.7263161,
                37.0702764
              ],
              [
                46.7093696,
                37.0724994
              ],
              [
                46.7063165,
                37.0722294
              ],
              [
                46.7054828,
                37.0719504
              ],
              [
                46.7046492,
                37.0719504
              ],
              [
                46.7040929,
                37.0716714
              ],
              [
                46.7029828,
                37.0716713
              ],
              [
                46.6908877,
                37.0668834
              ],
              [
                46.6900548,
                37.0668834
              ],
              [
                46.6861649,
                37.0646603
              ],
              [
                46.6850548,
                37.0643904
              ],
              [
                46.6847743,
                37.0641115
              ],
              [
                46.6839414,
                37.0635534
              ],
              [
                46.6833883,
                37.0635534
              ],
              [
                46.6850208,
                37.0509351
              ],
              [
                46.6904427,
                37.0382664
              ],
              [
                46.6887763,
                37.0360428
              ],
              [
                46.6603531,
                37.0418209
              ],
              [
                46.659243,
                37.041821
              ],
              [
                46.6421472,
                37.0411149
              ],
              [
                46.6407573,
                37.0411149
              ],
              [
                46.6382572,
                37.0405569
              ],
              [
                46.6165904,
                37.0363595
              ],
              [
                46.611034,
                37.0352824
              ],
              [
                46.5949211,
                37.0330592
              ],
              [
                46.5940875,
                37.0327802
              ],
              [
                46.591311,
                37.0327801
              ],
              [
                46.5907539,
                37.0325011
              ],
              [
                46.5879773,
                37.0325012
              ],
              [
                46.5871445,
                37.0322221
              ],
              [
                46.5801975,
                37.0322221
              ],
              [
                46.5768646,
                37.0319521
              ],
              [
                46.5760309,
                37.031673
              ],
              [
                46.5729746,
                37.031673
              ],
              [
                46.5690878,
                37.0311149
              ],
              [
                46.567698,
                37.031115
              ],
              [
                46.5665878,
                37.030836
              ],
              [
                46.5660315,
                37.030836
              ],
              [
                46.5626979,
                37.0302779
              ],
              [
                46.561308,
                37.0302779
              ],
              [
                46.559365,
                37.0297289
              ],
              [
                46.5590876,
                37.0294498
              ],
              [
                46.5579743,
                37.0294499
              ],
              [
                46.5507514,
                37.0272266
              ],
              [
                46.5274154,
                37.0282318
              ],
              [
                46.5263053,
                37.0282318
              ],
              [
                46.5257482,
                37.0279528
              ],
              [
                46.5249153,
                37.0279529
              ],
              [
                46.5243583,
                37.0276738
              ],
              [
                46.5232481,
                37.0276738
              ],
              [
                46.5229715,
                37.0273948
              ],
              [
                46.5040966,
                37.0176314
              ],
              [
                46.489855,
                37.0158664
              ],
              [
                46.489019,
                37.0161456
              ],
              [
                46.4812423,
                37.0161456
              ],
              [
                46.4809658,
                37.0164246
              ],
              [
                46.4776321,
                37.0164246
              ],
              [
                46.4767984,
                37.0167036
              ],
              [
                46.4744686,
                37.0172145
              ],
              [
                46.4653015,
                37.019036
              ],
              [
                46.4589524,
                37.0196189
              ],
              [
                46.4526844,
                37.0217772
              ],
              [
                46.4512682,
                37.0231135
              ],
              [
                46.4527702,
                37.0252378
              ],
              [
                46.454892,
                37.0269139
              ],
              [
                46.4570617,
                37.0288352
              ],
              [
                46.4595508,
                37.0299316
              ],
              [
                46.461797,
                37.0329132
              ],
              [
                46.462269,
                37.0354984
              ],
              [
                46.4624678,
                37.0390896
              ],
              [
                46.462276,
                37.0401404
              ],
              [
                46.4626622,
                37.0408598
              ],
              [
                46.4636063,
                37.0417675
              ],
              [
                46.4666107,
                37.0431049
              ],
              [
                46.476953,
                37.0483613
              ],
              [
                46.4829826,
                37.051735
              ],
              [
                46.488959,
                37.0564537
              ],
              [
                46.4915027,
                37.0584603
              ],
              [
                46.4937114,
                37.0605883
              ],
              [
                46.4966297,
                37.0651087
              ],
              [
                46.4967155,
                37.0668551
              ],
              [
                46.4956246,
                37.0696583
              ],
              [
                46.4953851,
                37.0719572
              ],
              [
                46.4958829,
                37.0741285
              ],
              [
                46.4963566,
                37.0768892
              ],
              [
                46.4976596,
                37.0828109
              ],
              [
                46.4978742,
                37.0868849
              ],
              [
                46.4968007,
                37.0920848
              ],
              [
                46.4954099,
                37.0948949
              ],
              [
                46.4933677,
                37.0987708
              ],
              [
                46.4914281,
                37.1003228
              ],
              [
                46.4865897,
                37.1004768
              ],
              [
                46.4829444,
                37.0998659
              ],
              [
                46.4817319,
                37.0996673
              ],
              [
                46.4796586,
                37.0989421
              ],
              [
                46.4753601,
                37.0976823
              ],
              [
                46.4704511,
                37.0962908
              ],
              [
                46.4680437,
                37.0959245
              ],
              [
                46.4638412,
                37.095228
              ],
              [
                46.4604757,
                37.0950568
              ],
              [
                46.4531426,
                37.0964134
              ],
              [
                46.4475137,
                37.0977485
              ],
              [
                46.4413562,
                37.1012004
              ],
              [
                46.4404392,
                37.1012347
              ],
              [
                46.4401449,
                37.1008417
              ],
              [
                46.4398039,
                37.098697
              ],
              [
                46.4391875,
                37.096333
              ],
              [
                46.4391446,
                37.0946044
              ],
              [
                46.4398527,
                37.0928757
              ],
              [
                46.4403891,
                37.0922082
              ],
              [
                46.4397883,
                37.0913353
              ],
              [
                46.437943,
                37.0902741
              ],
              [
                46.4368271,
                37.089384
              ],
              [
                46.4359689,
                37.087039
              ],
              [
                46.4347886,
                37.0850705
              ],
              [
                46.4338231,
                37.0838893
              ],
              [
                46.433351,
                37.0825541
              ],
              [
                46.4329219,
                37.0808423
              ],
              [
                46.4325142,
                37.0796097
              ],
              [
                46.4319133,
                37.0772131
              ],
              [
                46.4282869,
                37.0743027
              ],
              [
                46.4252167,
                37.0734606
              ],
              [
                46.4103698,
                37.0667524
              ],
              [
                46.3943194,
                37.0594239
              ],
              [
                46.3763053,
                37.0488913
              ],
              [
                46.3694088,
                37.0463893
              ],
              [
                46.3545143,
                37.0386275
              ],
              [
                46.346408,
                37.0336894
              ],
              [
                46.3176342,
                37.0202686
              ],
              [
                46.3084796,
                37.0157685
              ],
              [
                46.3086605,
                37.0144444
              ],
              [
                46.3054847,
                37.0080361
              ],
              [
                46.3043583,
                37.0048004
              ],
              [
                46.3037631,
                37.0029108
              ],
              [
                46.3035106,
                36.9977544
              ],
              [
                46.2994991,
                36.98751
              ],
              [
                46.2940692,
                36.9792438
              ],
              [
                46.2907219,
                36.9729012
              ],
              [
                46.290121,
                36.971564
              ],
              [
                46.2885855,
                36.9692809
              ],
              [
                46.286466,
                36.9676595
              ],
              [
                46.2838182,
                36.9657498
              ],
              [
                46.2812805,
                36.9635062
              ],
              [
                46.2777969,
                36.9626878
              ],
              [
                46.2769031,
                36.9627176
              ],
              [
                46.2749273,
                36.9639567
              ],
              [
                46.2714958,
                36.9661808
              ],
              [
                46.269298,
                36.9674842
              ],
              [
                46.2656164,
                36.9686496
              ],
              [
                46.2623977,
                36.9685124
              ],
              [
                46.2599086,
                36.9666266
              ],
              [
                46.2562723,
                36.9665532
              ],
              [
                46.2524199,
                36.966798
              ],
              [
                46.2511754,
                36.9671066
              ],
              [
                46.2497082,
                36.9675304
              ],
              [
                46.2475195,
                36.9689065
              ],
              [
                46.245375,
                36.969989
              ],
              [
                46.2446287,
                36.9702757
              ],
              [
                46.2435154,
                36.9708586
              ],
              [
                46.2414336,
                36.9721297
              ],
              [
                46.2387514,
                36.9735869
              ],
              [
                46.2364983,
                36.9745126
              ],
              [
                46.2344813,
                36.9746668
              ],
              [
                46.2339877,
                36.9741698
              ],
              [
                46.2325287,
                36.9726611
              ],
              [
                46.2314557,
                36.9709812
              ],
              [
                46.2267779,
                36.9654608
              ],
              [
                46.2224864,
                36.9625118
              ],
              [
                46.2178035,
                36.9586589
              ],
              [
                46.2141005,
                36.956591
              ],
              [
                46.2104584,
                36.9557586
              ],
              [
                46.2061311,
                36.9549355
              ],
              [
                46.2008295,
                36.9540486
              ],
              [
                46.1995907,
                36.9540144
              ],
              [
                46.1964579,
                36.953436
              ],
              [
                46.1937098,
                36.9413669
              ],
              [
                46.1921239,
                36.9339767
              ],
              [
                46.1917095,
                36.9266417
              ],
              [
                46.1893987,
                36.9198423
              ],
              [
                46.1868024,
                36.9143697
              ],
              [
                46.1821246,
                36.9100291
              ],
              [
                46.1799896,
                36.9090095
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 16505544,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میرآباد",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.2356331,
                36.4329258
              ],
              [
                45.235801,
                36.432941
              ],
              [
                45.235922,
                36.432991
              ],
              [
                45.236121,
                36.433226
              ],
              [
                45.236262,
                36.433291
              ],
              [
                45.236467,
                36.433584
              ],
              [
                45.23653,
                36.434102
              ],
              [
                45.236723,
                36.434077
              ],
              [
                45.236907,
                36.433974
              ],
              [
                45.237324,
                36.433529
              ],
              [
                45.237614,
                36.43308
              ],
              [
                45.237731,
                36.432991
              ],
              [
                45.237942,
                36.432943
              ],
              [
                45.238363,
                36.432988
              ],
              [
                45.238846,
                36.432782
              ],
              [
                45.239185,
                36.432434
              ],
              [
                45.239379,
                36.432102
              ],
              [
                45.239611,
                36.431935
              ],
              [
                45.23985,
                36.431856
              ],
              [
                45.239893,
                36.431603
              ],
              [
                45.239729,
                36.430499
              ],
              [
                45.239752,
                36.429351
              ],
              [
                45.239809,
                36.429022
              ],
              [
                45.240056,
                36.428367
              ],
              [
                45.240501,
                36.427415
              ],
              [
                45.240876,
                36.426873
              ],
              [
                45.24174,
                36.42604
              ],
              [
                45.241843,
                36.425823
              ],
              [
                45.241962,
                36.425719
              ],
              [
                45.242146,
                36.425644
              ],
              [
                45.24231,
                36.4255
              ],
              [
                45.2424,
                36.425343
              ],
              [
                45.242482,
                36.42491
              ],
              [
                45.242454,
                36.424607
              ],
              [
                45.242308,
                36.424315
              ],
              [
                45.242226,
                36.423812
              ],
              [
                45.242005,
                36.423371
              ],
              [
                45.241973,
                36.423184
              ],
              [
                45.242193,
                36.42304
              ],
              [
                45.242414,
                36.422672
              ],
              [
                45.242585,
                36.42249
              ],
              [
                45.242637,
                36.42225
              ],
              [
                45.242491,
                36.421932
              ],
              [
                45.242115,
                36.421435
              ],
              [
                45.241908,
                36.421017
              ],
              [
                45.241847,
                36.42071
              ],
              [
                45.241532,
                36.419894
              ],
              [
                45.241444,
                36.419502
              ],
              [
                45.241483,
                36.41878
              ],
              [
                45.241623,
                36.418353
              ],
              [
                45.241969,
                36.418108
              ],
              [
                45.242223,
                36.417995
              ],
              [
                45.242773,
                36.417845
              ],
              [
                45.243399,
                36.417759
              ],
              [
                45.243846,
                36.417768
              ],
              [
                45.24416,
                36.417707
              ],
              [
                45.245337,
                36.417314
              ],
              [
                45.245572,
                36.417199
              ],
              [
                45.245762,
                36.417144
              ],
              [
                45.246083,
                36.417128
              ],
              [
                45.2463,
                36.417058
              ],
              [
                45.246795,
                36.416646
              ],
              [
                45.246917,
                36.416468
              ],
              [
                45.247456,
                36.416178
              ],
              [
                45.248104,
                36.416042
              ],
              [
                45.248651,
                36.415705
              ],
              [
                45.249614,
                36.415772
              ],
              [
                45.250049,
                36.4157
              ],
              [
                45.251332,
                36.415199
              ],
              [
                45.251866,
                36.414895
              ],
              [
                45.252237,
                36.414505
              ],
              [
                45.25256,
                36.414432
              ],
              [
                45.252746,
                36.413908
              ],
              [
                45.25264,
                36.413493
              ],
              [
                45.252603,
                36.412998
              ],
              [
                45.252399,
                36.412304
              ],
              [
                45.252417,
                36.412133
              ],
              [
                45.252349,
                36.411806
              ],
              [
                45.252418,
                36.410953
              ],
              [
                45.25235,
                36.410667
              ],
              [
                45.252444,
                36.410107
              ],
              [
                45.252231,
                36.409775
              ],
              [
                45.251938,
                36.409634
              ],
              [
                45.251682,
                36.409617
              ],
              [
                45.250869,
                36.409307
              ],
              [
                45.250622,
                36.409132
              ],
              [
                45.250452,
                36.408922
              ],
              [
                45.250865,
                36.407261
              ],
              [
                45.251001,
                36.406903
              ],
              [
                45.251155,
                36.406708
              ],
              [
                45.251307,
                36.406383
              ],
              [
                45.251333,
                36.405804
              ],
              [
                45.251545,
                36.40551
              ],
              [
                45.25188,
                36.405189
              ],
              [
                45.252302,
                36.404947
              ],
              [
                45.252502,
                36.404676
              ],
              [
                45.25259,
                36.404368
              ],
              [
                45.252808,
                36.40401
              ],
              [
                45.252916,
                36.403683
              ],
              [
                45.252933,
                36.402808
              ],
              [
                45.253289,
                36.402222
              ],
              [
                45.253848,
                36.402164
              ],
              [
                45.254386,
                36.401995
              ],
              [
                45.255188,
                36.40204
              ],
              [
                45.255991,
                36.401959
              ],
              [
                45.257828,
                36.401903
              ],
              [
                45.257999,
                36.401971
              ],
              [
                45.25855,
                36.401805
              ],
              [
                45.258797,
                36.401834
              ],
              [
                45.259157,
                36.401676
              ],
              [
                45.259711,
                36.400442
              ],
              [
                45.259888,
                36.399485
              ],
              [
                45.260107,
                36.398994
              ],
              [
                45.260582,
                36.398716
              ],
              [
                45.26116,
                36.398564
              ],
              [
                45.261368,
                36.39845
              ],
              [
                45.2625307,
                36.3975965
              ],
              [
                45.263342,
                36.397001
              ],
              [
                45.263775,
                36.396819
              ],
              [
                45.263951,
                36.396656
              ],
              [
                45.264081,
                36.396439
              ],
              [
                45.264132,
                36.396193
              ],
              [
                45.264299,
                36.395916
              ],
              [
                45.264725,
                36.395382
              ],
              [
                45.265557,
                36.395201
              ],
              [
                45.266409,
                36.394884
              ],
              [
                45.267344,
                36.394717
              ],
              [
                45.267426,
                36.394522
              ],
              [
                45.267758,
                36.394247
              ],
              [
                45.268104,
                36.394234
              ],
              [
                45.268059,
                36.394673
              ],
              [
                45.268439,
                36.394803
              ],
              [
                45.268771,
                36.394877
              ],
              [
                45.269622,
                36.394824
              ],
              [
                45.271192,
                36.39423
              ],
              [
                45.271583,
                36.394012
              ],
              [
                45.27199,
                36.393884
              ],
              [
                45.272269,
                36.393713
              ],
              [
                45.272404,
                36.393518
              ],
              [
                45.272289,
                36.393021
              ],
              [
                45.27194,
                36.392774
              ],
              [
                45.271823,
                36.392619
              ],
              [
                45.271796,
                36.392403
              ],
              [
                45.271915,
                36.392222
              ],
              [
                45.272678,
                36.391733
              ],
              [
                45.27283,
                36.39094
              ],
              [
                45.272808,
                36.390613
              ],
              [
                45.272102,
                36.390298
              ],
              [
                45.271808,
                36.390218
              ],
              [
                45.271407,
                36.390213
              ],
              [
                45.27116,
                36.389981
              ],
              [
                45.270878,
                36.388675
              ],
              [
                45.270561,
                36.387817
              ],
              [
                45.271572,
                36.386523
              ],
              [
                45.27226,
                36.385117
              ],
              [
                45.272322,
                36.384571
              ],
              [
                45.272219,
                36.384099
              ],
              [
                45.27228,
                36.38384
              ],
              [
                45.272553,
                36.383648
              ],
              [
                45.272836,
                36.383548
              ],
              [
                45.272888,
                36.383335
              ],
              [
                45.273246,
                36.383194
              ],
              [
                45.273682,
                36.38278
              ],
              [
                45.273783,
                36.382657
              ],
              [
                45.273765,
                36.382269
              ],
              [
                45.273838,
                36.382113
              ],
              [
                45.274585,
                36.38193
              ],
              [
                45.275016,
                36.381523
              ],
              [
                45.275652,
                36.380816
              ],
              [
                45.275735,
                36.380664
              ],
              [
                45.276027,
                36.379728
              ],
              [
                45.276053,
                36.378532
              ],
              [
                45.276161,
                36.378276
              ],
              [
                45.276336,
                36.378058
              ],
              [
                45.276328,
                36.377442
              ],
              [
                45.276426,
                36.376961
              ],
              [
                45.276349,
                36.376841
              ],
              [
                45.276431,
                36.376469
              ],
              [
                45.276292,
                36.376313
              ],
              [
                45.275994,
                36.376217
              ],
              [
                45.275615,
                36.375981
              ],
              [
                45.275396,
                36.375756
              ],
              [
                45.275277,
                36.375408
              ],
              [
                45.274908,
                36.374944
              ],
              [
                45.274693,
                36.374735
              ],
              [
                45.274367,
                36.374583
              ],
              [
                45.273919,
                36.374492
              ],
              [
                45.272901,
                36.374558
              ],
              [
                45.272444,
                36.37438
              ],
              [
                45.271736,
                36.374242
              ],
              [
                45.270939,
                36.373904
              ],
              [
                45.268957,
                36.373673
              ],
              [
                45.268716,
                36.372801
              ],
              [
                45.269016,
                36.372317
              ],
              [
                45.268858,
                36.371943
              ],
              [
                45.268644,
                36.371204
              ],
              [
                45.268645,
                36.37105
              ],
              [
                45.269571,
                36.370874
              ],
              [
                45.271093,
                36.370327
              ],
              [
                45.271359,
                36.370131
              ],
              [
                45.27154,
                36.369856
              ],
              [
                45.272039,
                36.369304
              ],
              [
                45.273448,
                36.368541
              ],
              [
                45.273735,
                36.368346
              ],
              [
                45.273931,
                36.368107
              ],
              [
                45.274389,
                36.367893
              ],
              [
                45.274677,
                36.367655
              ],
              [
                45.27492,
                36.367259
              ],
              [
                45.275163,
                36.36705
              ],
              [
                45.275619,
                36.366771
              ],
              [
                45.275637,
                36.366607
              ],
              [
                45.27527,
                36.3661
              ],
              [
                45.275254,
                36.365662
              ],
              [
                45.275036,
                36.365309
              ],
              [
                45.274685,
                36.36503
              ],
              [
                45.274077,
                36.364846
              ],
              [
                45.274016,
                36.364438
              ],
              [
                45.274116,
                36.364233
              ],
              [
                45.274097,
                36.364049
              ],
              [
                45.273796,
                36.363865
              ],
              [
                45.273716,
                36.363725
              ],
              [
                45.273797,
                36.362989
              ],
              [
                45.273718,
                36.362645
              ],
              [
                45.273554,
                36.362349
              ],
              [
                45.273344,
                36.36211
              ],
              [
                45.27242,
                36.361492
              ],
              [
                45.27226,
                36.361163
              ],
              [
                45.272062,
                36.360972
              ],
              [
                45.271595,
                36.360857
              ],
              [
                45.271478,
                36.360674
              ],
              [
                45.271478,
                36.360409
              ],
              [
                45.271827,
                36.359752
              ],
              [
                45.271725,
                36.359097
              ],
              [
                45.271792,
                36.358545
              ],
              [
                45.271913,
                36.358116
              ],
              [
                45.272151,
                36.35793
              ],
              [
                45.271989,
                36.357512
              ],
              [
                45.272078,
                36.357287
              ],
              [
                45.271859,
                36.356902
              ],
              [
                45.271875,
                36.356464
              ],
              [
                45.272037,
                36.356192
              ],
              [
                45.272054,
                36.355594
              ],
              [
                45.271814,
                36.355019
              ],
              [
                45.271835,
                36.354784
              ],
              [
                45.272057,
                36.354623
              ],
              [
                45.272357,
                36.354487
              ],
              [
                45.272614,
                36.354281
              ],
              [
                45.272751,
                36.354092
              ],
              [
                45.272996,
                36.353916
              ],
              [
                45.273185,
                36.353436
              ],
              [
                45.273552,
                36.353117
              ],
              [
                45.273839,
                36.352978
              ],
              [
                45.274147,
                36.352476
              ],
              [
                45.274427,
                36.352256
              ],
              [
                45.274903,
                36.351531
              ],
              [
                45.274882,
                36.351392
              ],
              [
                45.275092,
                36.351101
              ],
              [
                45.275301,
                36.35054
              ],
              [
                45.275408,
                36.34922
              ],
              [
                45.275377,
                36.348856
              ],
              [
                45.275461,
                36.348505
              ],
              [
                45.275347,
                36.347164
              ],
              [
                45.275225,
                36.346778
              ],
              [
                45.27491,
                36.346586
              ],
              [
                45.274603,
                36.346216
              ],
              [
                45.274512,
                36.345847
              ],
              [
                45.274002,
                36.345083
              ],
              [
                45.274576,
                36.344325
              ],
              [
                45.274816,
                36.343892
              ],
              [
                45.274873,
                36.343689
              ],
              [
                45.275074,
                36.34339
              ],
              [
                45.275463,
                36.343332
              ],
              [
                45.275728,
                36.343178
              ],
              [
                45.275931,
                36.343115
              ],
              [
                45.276101,
                36.342902
              ],
              [
                45.276579,
                36.342759
              ],
              [
                45.276744,
                36.342611
              ],
              [
                45.27765,
                36.342445
              ],
              [
                45.278003,
                36.342452
              ],
              [
                45.279089,
                36.342602
              ],
              [
                45.279767,
                36.342584
              ],
              [
                45.280165,
                36.341939
              ],
              [
                45.280575,
                36.341631
              ],
              [
                45.280851,
                36.341582
              ],
              [
                45.281368,
                36.341586
              ],
              [
                45.281634,
                36.341518
              ],
              [
                45.281808,
                36.341412
              ],
              [
                45.281964,
                36.340966
              ],
              [
                45.282255,
                36.340587
              ],
              [
                45.28208,
                36.339889
              ],
              [
                45.282108,
                36.339557
              ],
              [
                45.282345,
                36.338877
              ],
              [
                45.282897,
                36.338264
              ],
              [
                45.283176,
                36.337801
              ],
              [
                45.283335,
                36.337114
              ],
              [
                45.283314,
                36.336817
              ],
              [
                45.283087,
                36.336262
              ],
              [
                45.282884,
                36.336009
              ],
              [
                45.282604,
                36.335839
              ],
              [
                45.282032,
                36.335677
              ],
              [
                45.281493,
                36.335006
              ],
              [
                45.281242,
                36.334799
              ],
              [
                45.280615,
                36.334873
              ],
              [
                45.280325,
                36.334833
              ],
              [
                45.279811,
                36.334672
              ],
              [
                45.279485,
                36.334757
              ],
              [
                45.279143,
                36.334909
              ],
              [
                45.278866,
                36.334899
              ],
              [
                45.278653,
                36.334685
              ],
              [
                45.278059,
                36.333857
              ],
              [
                45.277272,
                36.333557
              ],
              [
                45.276725,
                36.332968
              ],
              [
                45.276336,
                36.332796
              ],
              [
                45.275892,
                36.332666
              ],
              [
                45.275383,
                36.332102
              ],
              [
                45.275068,
                36.331863
              ],
              [
                45.274662,
                36.331812
              ],
              [
                45.274341,
                36.33189
              ],
              [
                45.273831,
                36.331691
              ],
              [
                45.273311,
                36.331419
              ],
              [
                45.2733,
                36.33023
              ],
              [
                45.272746,
                36.329149
              ],
              [
                45.272158,
                36.328202
              ],
              [
                45.271999,
                36.327834
              ],
              [
                45.272078,
                36.327386
              ],
              [
                45.272262,
                36.327037
              ],
              [
                45.272293,
                36.326581
              ],
              [
                45.272234,
                36.326259
              ],
              [
                45.271952,
                36.325853
              ],
              [
                45.271612,
                36.325672
              ],
              [
                45.271404,
                36.325425
              ],
              [
                45.271324,
                36.324983
              ],
              [
                45.270967,
                36.324183
              ],
              [
                45.270852,
                36.323673
              ],
              [
                45.270675,
                36.323361
              ],
              [
                45.270015,
                36.323237
              ],
              [
                45.269501,
                36.32342
              ],
              [
                45.269205,
                36.323408
              ],
              [
                45.267824,
                36.323508
              ],
              [
                45.267375,
                36.323894
              ],
              [
                45.267125,
                36.324034
              ],
              [
                45.266485,
                36.322851
              ],
              [
                45.266455,
                36.322518
              ],
              [
                45.26655,
                36.322115
              ],
              [
                45.266549,
                36.32174
              ],
              [
                45.266798,
                36.321428
              ],
              [
                45.267089,
                36.32136
              ],
              [
                45.267501,
                36.320836
              ],
              [
                45.267593,
                36.320616
              ],
              [
                45.267537,
                36.320337
              ],
              [
                45.267354,
                36.320122
              ],
              [
                45.267319,
                36.319705
              ],
              [
                45.267215,
                36.319439
              ],
              [
                45.265429,
                36.316244
              ],
              [
                45.264594,
                36.314564
              ],
              [
                45.264513,
                36.314144
              ],
              [
                45.264336,
                36.313752
              ],
              [
                45.264492,
                36.313108
              ],
              [
                45.26484,
                36.312182
              ],
              [
                45.265006,
                36.311156
              ],
              [
                45.264941,
                36.310776
              ],
              [
                45.264855,
                36.310507
              ],
              [
                45.264622,
                36.310237
              ],
              [
                45.264335,
                36.310122
              ],
              [
                45.26321,
                36.307769
              ],
              [
                45.262833,
                36.307343
              ],
              [
                45.262569,
                36.307127
              ],
              [
                45.262324,
                36.306774
              ],
              [
                45.26222,
                36.306422
              ],
              [
                45.261902,
                36.305744
              ],
              [
                45.261832,
                36.305285
              ],
              [
                45.262006,
                36.303897
              ],
              [
                45.262138,
                36.303461
              ],
              [
                45.262119,
                36.303202
              ],
              [
                45.261714,
                36.302673
              ],
              [
                45.261686,
                36.302463
              ],
              [
                45.261523,
                36.302278
              ],
              [
                45.26112,
                36.301985
              ],
              [
                45.260973,
                36.301614
              ],
              [
                45.260964,
                36.301289
              ],
              [
                45.261456,
                36.300778
              ],
              [
                45.261883,
                36.300637
              ],
              [
                45.262042,
                36.300518
              ],
              [
                45.261885,
                36.300187
              ],
              [
                45.261869,
                36.299943
              ],
              [
                45.26192,
                36.299773
              ],
              [
                45.262005,
                36.299699
              ],
              [
                45.262651,
                36.299418
              ],
              [
                45.262791,
                36.299045
              ],
              [
                45.263176,
                36.298944
              ],
              [
                45.263709,
                36.299042
              ],
              [
                45.264317,
                36.298913
              ],
              [
                45.264589,
                36.298757
              ],
              [
                45.264621,
                36.297787
              ],
              [
                45.264734,
                36.297552
              ],
              [
                45.264973,
                36.297306
              ],
              [
                45.265234,
                36.297163
              ],
              [
                45.265347,
                36.297014
              ],
              [
                45.266135,
                36.296997
              ],
              [
                45.266595,
                36.296889
              ],
              [
                45.267584,
                36.296317
              ],
              [
                45.268228,
                36.295719
              ],
              [
                45.268745,
                36.295435
              ],
              [
                45.269566,
                36.295396
              ],
              [
                45.270913,
                36.295457
              ],
              [
                45.271313,
                36.295595
              ],
              [
                45.271694,
                36.29593
              ],
              [
                45.271875,
                36.296509
              ],
              [
                45.272152,
                36.297151
              ],
              [
                45.272249,
                36.2973
              ],
              [
                45.272451,
                36.297404
              ],
              [
                45.27273,
                36.297483
              ],
              [
                45.273097,
                36.297525
              ],
              [
                45.273353,
                36.297501
              ],
              [
                45.273625,
                36.297576
              ],
              [
                45.274009,
                36.29761
              ],
              [
                45.27464,
                36.297836
              ],
              [
                45.275036,
                36.297867
              ],
              [
                45.275319,
                36.297962
              ],
              [
                45.275525,
                36.297973
              ],
              [
                45.275854,
                36.297845
              ],
              [
                45.275977,
                36.297255
              ],
              [
                45.276195,
                36.296943
              ],
              [
                45.27647,
                36.296663
              ],
              [
                45.276732,
                36.296579
              ],
              [
                45.277113,
                36.296313
              ],
              [
                45.277253,
                36.296085
              ],
              [
                45.277449,
                36.295905
              ],
              [
                45.277515,
                36.29569
              ],
              [
                45.277641,
                36.295539
              ],
              [
                45.277766,
                36.294642
              ],
              [
                45.27782,
                36.294483
              ],
              [
                45.277947,
                36.294337
              ],
              [
                45.278466,
                36.293864
              ],
              [
                45.278942,
                36.293511
              ],
              [
                45.279528,
                36.293252
              ],
              [
                45.279882,
                36.293178
              ],
              [
                45.280286,
                36.292929
              ],
              [
                45.280666,
                36.292519
              ],
              [
                45.280947,
                36.291895
              ],
              [
                45.281323,
                36.291608
              ],
              [
                45.281785,
                36.291162
              ],
              [
                45.281828,
                36.290983
              ],
              [
                45.282001,
                36.290786
              ],
              [
                45.282329,
                36.290486
              ],
              [
                45.282832,
                36.290139
              ],
              [
                45.283374,
                36.289426
              ],
              [
                45.283338,
                36.289036
              ],
              [
                45.283589,
                36.288477
              ],
              [
                45.283801,
                36.287737
              ],
              [
                45.283914,
                36.287561
              ],
              [
                45.284033,
                36.287465
              ],
              [
                45.284238,
                36.287412
              ],
              [
                45.284462,
                36.287415
              ],
              [
                45.284712,
                36.287451
              ],
              [
                45.285289,
                36.287633
              ],
              [
                45.285641,
                36.28764
              ],
              [
                45.28642,
                36.287443
              ],
              [
                45.287126,
                36.287318
              ],
              [
                45.287717,
                36.286966
              ],
              [
                45.287781,
                36.286681
              ],
              [
                45.287891,
                36.286603
              ],
              [
                45.288629,
                36.286536
              ],
              [
                45.289003,
                36.286411
              ],
              [
                45.28978,
                36.286037
              ],
              [
                45.29006,
                36.285832
              ],
              [
                45.290842,
                36.285537
              ],
              [
                45.291094,
                36.285353
              ],
              [
                45.291621,
                36.284825
              ],
              [
                45.291751,
                36.284668
              ],
              [
                45.29193,
                36.284271
              ],
              [
                45.292692,
                36.283627
              ],
              [
                45.293464,
                36.282771
              ],
              [
                45.294368,
                36.281632
              ],
              [
                45.294659,
                36.281399
              ],
              [
                45.295055,
                36.281186
              ],
              [
                45.296045,
                36.280803
              ],
              [
                45.297068,
                36.280022
              ],
              [
                45.297468,
                36.279827
              ],
              [
                45.297995,
                36.279701
              ],
              [
                45.298752,
                36.279448
              ],
              [
                45.299083,
                36.279249
              ],
              [
                45.299484,
                36.278795
              ],
              [
                45.299658,
                36.278362
              ],
              [
                45.2998,
                36.278189
              ],
              [
                45.300519,
                36.277845
              ],
              [
                45.300658,
                36.27767
              ],
              [
                45.300772,
                36.27745
              ],
              [
                45.300835,
                36.277177
              ],
              [
                45.300962,
                36.277019
              ],
              [
                45.301088,
                36.27693
              ],
              [
                45.301613,
                36.276826
              ],
              [
                45.301893,
                36.276633
              ],
              [
                45.302013,
                36.276426
              ],
              [
                45.302045,
                36.276228
              ],
              [
                45.3019311,
                36.2758825
              ],
              [
                45.301809,
                36.275512
              ],
              [
                45.301854,
                36.275377
              ],
              [
                45.302168,
                36.275189
              ],
              [
                45.302591,
                36.274764
              ],
              [
                45.302823,
                36.274674
              ],
              [
                45.303288,
                36.274707
              ],
              [
                45.303664,
                36.274851
              ],
              [
                45.303864,
                36.274867
              ],
              [
                45.304103,
                36.274809
              ],
              [
                45.304209,
                36.274706
              ],
              [
                45.304313,
                36.274037
              ],
              [
                45.304393,
                36.273872
              ],
              [
                45.304553,
                36.273747
              ],
              [
                45.303226,
                36.273334
              ],
              [
                45.30242,
                36.272975
              ],
              [
                45.3019556,
                36.2728275
              ],
              [
                45.3045271,
                36.257563
              ],
              [
                45.3181179,
                36.2515203
              ],
              [
                45.3275003,
                36.2491909
              ],
              [
                45.3347934,
                36.2478065
              ],
              [
                45.3410781,
                36.2460044
              ],
              [
                45.3508684,
                36.2468259
              ],
              [
                45.3578144,
                36.2494562
              ],
              [
                45.3622949,
                36.2542965
              ],
              [
                45.3658076,
                36.256096
              ],
              [
                45.3719996,
                36.2578584
              ],
              [
                45.3776213,
                36.2526094
              ],
              [
                45.3842901,
                36.2460616
              ],
              [
                45.3872156,
                36.2419072
              ],
              [
                45.3909039,
                36.2374074
              ],
              [
                45.3932012,
                36.2338647
              ],
              [
                45.3959369,
                36.2298736
              ],
              [
                45.3995418,
                36.227935
              ],
              [
                45.4076957,
                36.2252347
              ],
              [
                45.4188537,
                36.225027
              ],
              [
                45.430355,
                36.2255809
              ],
              [
                45.4360613,
                36.2250456
              ],
              [
                45.4392473,
                36.2239377
              ],
              [
                45.4421174,
                36.221514
              ],
              [
                45.4455391,
                36.2172054
              ],
              [
                45.4497639,
                36.2154696
              ],
              [
                45.459147,
                36.2131031
              ],
              [
                45.4662208,
                36.2125418
              ],
              [
                45.4780846,
                36.2119832
              ],
              [
                45.472412,
                36.222465
              ],
              [
                45.4732274,
                36.2272772
              ],
              [
                45.4784202,
                36.2404659
              ],
              [
                45.4799651,
                36.2455885
              ],
              [
                45.4842567,
                36.2522335
              ],
              [
                45.4862308,
                36.2530641
              ],
              [
                45.4838275,
                36.2586703
              ],
              [
                45.4772185,
                36.2630304
              ],
              [
                45.4775619,
                36.2682899
              ],
              [
                45.48357,
                36.2720959
              ],
              [
                45.4958438,
                36.2717499
              ],
              [
                45.5012511,
                36.2716115
              ],
              [
                45.504341,
                36.2766628
              ],
              [
                45.508933,
                36.2809181
              ],
              [
                45.5099673,
                36.2866652
              ],
              [
                45.5123079,
                36.2928019
              ],
              [
                45.5186748,
                36.2961385
              ],
              [
                45.5359107,
                36.3069743
              ],
              [
                45.5488233,
                36.3133735
              ],
              [
                45.551593,
                36.3267458
              ],
              [
                45.5704721,
                36.3328434
              ],
              [
                45.580945,
                36.3334158
              ],
              [
                45.5850219,
                36.3391891
              ],
              [
                45.5868673,
                36.343683
              ],
              [
                45.5862772,
                36.3438991
              ],
              [
                45.5866732,
                36.3449948
              ],
              [
                45.5870248,
                36.3464361
              ],
              [
                45.5874548,
                36.3474872
              ],
              [
                45.5880716,
                36.3488184
              ],
              [
                45.5836808,
                36.3508503
              ],
              [
                45.5747815,
                36.3552417
              ],
              [
                45.5703677,
                36.3574218
              ],
              [
                45.5689287,
                36.3587875
              ],
              [
                45.5655025,
                36.3604978
              ],
              [
                45.5612167,
                36.3630233
              ],
              [
                45.5585202,
                36.364855
              ],
              [
                45.556569,
                36.3701572
              ],
              [
                45.5558957,
                36.3782271
              ],
              [
                45.5550344,
                36.3837284
              ],
              [
                45.5494451,
                36.3847727
              ],
              [
                45.5429219,
                36.3869147
              ],
              [
                45.5337381,
                36.3912676
              ],
              [
                45.5250725,
                36.395918
              ],
              [
                45.5172199,
                36.4016578
              ],
              [
                45.5114464,
                36.4065701
              ],
              [
                45.504942,
                36.4139026
              ],
              [
                45.5031405,
                36.4152179
              ],
              [
                45.4991542,
                36.4177416
              ],
              [
                45.4961872,
                36.4199012
              ],
              [
                45.4941832,
                36.4219976
              ],
              [
                45.4909944,
                36.4260133
              ],
              [
                45.4878187,
                36.4288793
              ],
              [
                45.4821968,
                36.4330573
              ],
              [
                45.4792353,
                36.4340933
              ],
              [
                45.4768753,
                36.434352
              ],
              [
                45.4743787,
                36.4344057
              ],
              [
                45.4718971,
                36.4338859
              ],
              [
                45.4682859,
                36.4338433
              ],
              [
                45.4632308,
                36.4340332
              ],
              [
                45.4600267,
                36.4340219
              ],
              [
                45.4563367,
                36.4343641
              ],
              [
                45.4373255,
                36.43521
              ],
              [
                45.4348182,
                36.4360934
              ],
              [
                45.4324794,
                36.4375457
              ],
              [
                45.4301834,
                36.4393756
              ],
              [
                45.4249271,
                36.4441031
              ],
              [
                45.4234107,
                36.445214
              ],
              [
                45.4217665,
                36.4458698
              ],
              [
                45.4183487,
                36.4466729
              ],
              [
                45.4138755,
                36.4480408
              ],
              [
                45.4062365,
                36.4484552
              ],
              [
                45.3955379,
                36.4500209
              ],
              [
                45.3873849,
                36.452685
              ],
              [
                45.3804445,
                36.4557731
              ],
              [
                45.3759384,
                36.4566015
              ],
              [
                45.3690719,
                36.4592593
              ],
              [
                45.3618232,
                36.4630735
              ],
              [
                45.3538726,
                36.46732
              ],
              [
                45.3431465,
                36.471327
              ],
              [
                45.3383099,
                36.4725694
              ],
              [
                45.3330768,
                36.4726415
              ],
              [
                45.3276402,
                36.4722273
              ],
              [
                45.3184397,
                36.4701536
              ],
              [
                45.3025229,
                36.465463
              ],
              [
                45.2938842,
                36.4632631
              ],
              [
                45.2837658,
                36.4616169
              ],
              [
                45.2766174,
                36.4609859
              ],
              [
                45.2727575,
                36.4598783
              ],
              [
                45.2686584,
                36.455566
              ],
              [
                45.2642681,
                36.4490222
              ],
              [
                45.2617408,
                36.4430719
              ],
              [
                45.2564879,
                36.4380568
              ],
              [
                45.2564879,
                36.4377776
              ],
              [
                45.2345819,
                36.4380415
              ],
              [
                45.2356331,
                36.4329258
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32826994
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          44.95354,
          38.5504343
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 879415755
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          44.3844026,
          39.0651269
        ]
      }
    }
  ]
},
"اردبیل.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554871,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "int_name": "Ardabil",
          "name": "شهرستان اردبیل",
          "name:ar": "مقاطعة أردبيل",
          "name:azb": "Ərdəbil şəhəri",
          "name:ckb": "شاری ئەردەوێڵ",
          "name:cs": "Ardabíl",
          "name:de": "Ardabil",
          "name:en": "Ardabil city",
          "name:es": "ciudad de Ardebil",
          "name:et": "Ardabīl",
          "name:eu": "Ardabil",
          "name:fr": "Ardabil",
          "name:he": "ארדביל",
          "name:hi": "आर्दबील",
          "name:ja": "アルダビール",
          "name:ku": "Erdebîl",
          "name:ml": "അർദബീൽ",
          "name:pl": "Ardabil",
          "name:ru": "Ардебиль",
          "name:tr": "Ardabil  eyaleti",
          "name:tt": "Әрдәбил",
          "name:uk": "Провінція Ардебіль",
          "place": "county",
          "short_name:ar": "أردبيل",
          "type": "boundary",
          "wikidata": "Q1277868"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8385684,
                38.2666286
              ],
              [
                47.8510891,
                38.2630918
              ],
              [
                47.8555326,
                38.2617084
              ],
              [
                47.8596991,
                38.2600376
              ],
              [
                47.9141453,
                38.2436528
              ],
              [
                47.9158122,
                38.2433653
              ],
              [
                47.9163689,
                38.2436528
              ],
              [
                47.9216487,
                38.2436528
              ],
              [
                47.9255354,
                38.2467071
              ],
              [
                47.9258184,
                38.2469855
              ],
              [
                47.9310918,
                38.2519801
              ],
              [
                47.9338684,
                38.2536509
              ],
              [
                47.9352582,
                38.2547559
              ],
              [
                47.9363685,
                38.2550343
              ],
              [
                47.9369252,
                38.2555913
              ],
              [
                47.9574814,
                38.2625351
              ],
              [
                47.9588716,
                38.2625351
              ],
              [
                47.9594284,
                38.263092
              ],
              [
                47.9605381,
                38.263092
              ],
              [
                47.9610947,
                38.2633704
              ],
              [
                47.9619284,
                38.2633704
              ],
              [
                47.9622049,
                38.2636489
              ],
              [
                47.9647051,
                38.2636489
              ],
              [
                47.9660949,
                38.2639274
              ],
              [
                47.9677613,
                38.2639274
              ],
              [
                47.9683148,
                38.2642059
              ],
              [
                47.9699812,
                38.2642059
              ],
              [
                47.9702613,
                38.2644844
              ],
              [
                47.9722048,
                38.2644843
              ],
              [
                47.973038,
                38.2647628
              ],
              [
                47.9749814,
                38.2647628
              ],
              [
                47.9760947,
                38.2650413
              ],
              [
                47.9777611,
                38.2650413
              ],
              [
                47.9788714,
                38.2653198
              ],
              [
                47.9877614,
                38.2653197
              ],
              [
                47.9966511,
                38.2655893
              ],
              [
                47.9994276,
                38.2655893
              ],
              [
                48.0093039,
                38.2568286
              ],
              [
                48.0102611,
                38.25587
              ],
              [
                48.0563775,
                38.2405898
              ],
              [
                48.0577638,
                38.2403114
              ],
              [
                48.058597,
                38.2400418
              ],
              [
                48.0597107,
                38.2400419
              ],
              [
                48.060544,
                38.2397634
              ],
              [
                48.0622105,
                38.2397634
              ],
              [
                48.0624873,
                38.2394849
              ],
              [
                48.063044,
                38.2394849
              ],
              [
                48.0635971,
                38.2392064
              ],
              [
                48.0647104,
                38.2392065
              ],
              [
                48.0855438,
                38.231427
              ],
              [
                48.0894337,
                38.2314271
              ],
              [
                48.0899904,
                38.2317055
              ],
              [
                48.0913772,
                38.2317054
              ],
              [
                48.0916569,
                38.231984
              ],
              [
                48.092767,
                38.231984
              ],
              [
                48.0938767,
                38.2322625
              ],
              [
                48.1086001,
                38.2344814
              ],
              [
                48.1113803,
                38.2344814
              ],
              [
                48.1119335,
                38.2347598
              ],
              [
                48.1166566,
                38.2347599
              ],
              [
                48.1169331,
                38.2350384
              ],
              [
                48.1208235,
                38.2350384
              ],
              [
                48.1230466,
                38.2350384
              ],
              [
                48.1299897,
                38.2350384
              ],
              [
                48.1305467,
                38.2353169
              ],
              [
                48.1324897,
                38.2353169
              ],
              [
                48.1761028,
                38.2492049
              ],
              [
                48.1774927,
                38.2492049
              ],
              [
                48.1783259,
                38.2494834
              ],
              [
                48.1797161,
                38.2494834
              ],
              [
                48.1819357,
                38.2500403
              ],
              [
                48.1838827,
                38.2500403
              ],
              [
                48.1847159,
                38.2503188
              ],
              [
                48.1863827,
                38.2503188
              ],
              [
                48.1874924,
                38.2505974
              ],
              [
                48.1897159,
                38.2508668
              ],
              [
                48.1905493,
                38.2511452
              ],
              [
                48.1919391,
                38.2511453
              ],
              [
                48.1924927,
                38.2514238
              ],
              [
                48.1949923,
                38.2514238
              ],
              [
                48.1955493,
                38.2511453
              ],
              [
                48.1974923,
                38.2511453
              ],
              [
                48.1977724,
                38.2508668
              ],
              [
                48.2058292,
                38.2492049
              ],
              [
                48.2083289,
                38.249205
              ],
              [
                48.2088824,
                38.2489265
              ],
              [
                48.2111055,
                38.2489265
              ],
              [
                48.2113821,
                38.249205
              ],
              [
                48.2124958,
                38.249205
              ],
              [
                48.2127724,
                38.2494835
              ],
              [
                48.2141623,
                38.2494834
              ],
              [
                48.2144388,
                38.2497619
              ],
              [
                48.2163823,
                38.2508669
              ],
              [
                48.2197155,
                38.2558703
              ],
              [
                48.2199956,
                38.2572627
              ],
              [
                48.2199955,
                38.2578196
              ],
              [
                48.2199955,
                38.2628141
              ],
              [
                48.2205521,
                38.2628141
              ],
              [
                48.2244386,
                38.2628141
              ],
              [
                48.2372185,
                38.25976
              ],
              [
                48.2458285,
                38.25976
              ],
              [
                48.2466618,
                38.2600385
              ],
              [
                48.2477751,
                38.2600385
              ],
              [
                48.248633,
                38.2595336
              ],
              [
                48.2483286,
                38.2589245
              ],
              [
                48.2474954,
                38.2569843
              ],
              [
                48.247188,
                38.2552158
              ],
              [
                48.2470379,
                38.2543524
              ],
              [
                48.2474152,
                38.2457803
              ],
              [
                48.2432302,
                38.2381439
              ],
              [
                48.2413856,
                38.2355956
              ],
              [
                48.2361054,
                38.2292084
              ],
              [
                48.2213856,
                38.2172605
              ],
              [
                48.2211055,
                38.216982
              ],
              [
                48.1744362,
                38.1930941
              ],
              [
                48.1566596,
                38.1808668
              ],
              [
                48.1558264,
                38.1803187
              ],
              [
                48.1449934,
                38.175593
              ],
              [
                48.1441565,
                38.1755931
              ],
              [
                48.1297133,
                38.1675341
              ],
              [
                48.1294368,
                38.1669771
              ],
              [
                48.1288801,
                38.1666985
              ],
              [
                48.1288801,
                38.1653149
              ],
              [
                48.1322134,
                38.157256
              ],
              [
                48.1386035,
                38.1517035
              ],
              [
                48.1394367,
                38.1517035
              ],
              [
                48.1397132,
                38.151425
              ],
              [
                48.1402699,
                38.151425
              ],
              [
                48.1483268,
                38.1483702
              ],
              [
                48.1530468,
                38.1436443
              ],
              [
                48.1544367,
                38.1411466
              ],
              [
                48.1544367,
                38.1400324
              ],
              [
                48.1547132,
                38.1372562
              ],
              [
                48.1549933,
                38.1366991
              ],
              [
                48.1544367,
                38.1222513
              ],
              [
                48.1536035,
                38.1214247
              ],
              [
                48.1536035,
                38.1211461
              ],
              [
                48.1572134,
                38.1172556
              ],
              [
                48.1638835,
                38.1053142
              ],
              [
                48.1713832,
                38.1000308
              ],
              [
                48.1861063,
                38.0936422
              ],
              [
                48.1863832,
                38.0930851
              ],
              [
                48.191383,
                38.0880891
              ],
              [
                48.1919397,
                38.0869749
              ],
              [
                48.1927733,
                38.0847554
              ],
              [
                48.1933265,
                38.0836412
              ],
              [
                48.1938831,
                38.0828145
              ],
              [
                48.1944397,
                38.0803075
              ],
              [
                48.1919398,
                38.0719777
              ],
              [
                48.1883263,
                38.0636478
              ],
              [
                48.1880499,
                38.0586425
              ],
              [
                48.1883264,
                38.0583639
              ],
              [
                48.1883265,
                38.0578068
              ],
              [
                48.1886065,
                38.0575372
              ],
              [
                48.188883,
                38.0572587
              ],
              [
                48.18916,
                38.0569801
              ],
              [
                48.1897166,
                38.0567015
              ],
              [
                48.194993,
                38.0511391
              ],
              [
                48.197493,
                38.0503124
              ],
              [
                48.2011064,
                38.0503124
              ],
              [
                48.2013829,
                38.050591
              ],
              [
                48.2027733,
                38.050591
              ],
              [
                48.2033298,
                38.0508695
              ],
              [
                48.2044396,
                38.0508695
              ],
              [
                48.2180498,
                38.0558658
              ],
              [
                48.2230529,
                38.0591997
              ],
              [
                48.2266628,
                38.0650317
              ],
              [
                48.2277729,
                38.0744758
              ],
              [
                48.2286061,
                38.077531
              ],
              [
                48.2297194,
                38.0805862
              ],
              [
                48.2319394,
                38.0839198
              ],
              [
                48.275552,
                38.1142008
              ],
              [
                48.2763856,
                38.1142008
              ],
              [
                48.2766652,
                38.1144794
              ],
              [
                48.2774989,
                38.1144794
              ],
              [
                48.2791654,
                38.1150365
              ],
              [
                48.2811088,
                38.1150365
              ],
              [
                48.2830552,
                38.1155846
              ],
              [
                48.2841655,
                38.1155846
              ],
              [
                48.2949985,
                38.1172559
              ],
              [
                48.2969454,
                38.1180914
              ],
              [
                48.2994451,
                38.1194841
              ],
              [
                48.3124984,
                38.1414255
              ],
              [
                48.3166684,
                38.1439232
              ],
              [
                48.3172216,
                38.1442017
              ],
              [
                48.3177782,
                38.1442017
              ],
              [
                48.3177783,
                38.1444802
              ],
              [
                48.3191681,
                38.1453158
              ],
              [
                48.3200017,
                38.1455944
              ],
              [
                48.3219447,
                38.146421
              ],
              [
                48.3227783,
                38.1464209
              ],
              [
                48.323335,
                38.1466995
              ],
              [
                48.3263668,
                38.1477627
              ],
              [
                48.3268615,
                38.1422776
              ],
              [
                48.3287025,
                38.1359573
              ],
              [
                48.3361281,
                38.1256363
              ],
              [
                48.3558347,
                38.105036
              ],
              [
                48.3563913,
                38.1050361
              ],
              [
                48.3583347,
                38.1030862
              ],
              [
                48.3638912,
                38.0994741
              ],
              [
                48.3661146,
                38.0972547
              ],
              [
                48.3672244,
                38.0953138
              ],
              [
                48.3697244,
                38.0892037
              ],
              [
                48.370001,
                38.0869753
              ],
              [
                48.3702812,
                38.0864271
              ],
              [
                48.3633346,
                38.0683658
              ],
              [
                48.3547246,
                38.0569805
              ],
              [
                48.3375017,
                38.0419734
              ],
              [
                48.3352786,
                38.0403109
              ],
              [
                48.334445,
                38.0391966
              ],
              [
                48.3250019,
                38.0264178
              ],
              [
                48.3233354,
                38.0225357
              ],
              [
                48.3230554,
                38.0211427
              ],
              [
                48.3230554,
                38.0144745
              ],
              [
                48.3247218,
                38.0100351
              ],
              [
                48.3258355,
                38.0086421
              ],
              [
                48.3313884,
                38.005308
              ],
              [
                48.3330551,
                38.0047508
              ],
              [
                48.3336119,
                38.0047508
              ],
              [
                48.333892,
                38.0044722
              ],
              [
                48.3372252,
                38.0044722
              ],
              [
                48.3377783,
                38.0047508
              ],
              [
                48.3419453,
                38.0047508
              ],
              [
                48.3422253,
                38.0050294
              ],
              [
                48.3430586,
                38.0047508
              ],
              [
                48.3452785,
                38.0047509
              ],
              [
                48.3452785,
                38.0050294
              ],
              [
                48.3466684,
                38.0050294
              ],
              [
                48.3475017,
                38.0044722
              ],
              [
                48.3491685,
                38.0022525
              ],
              [
                48.3497251,
                38.0003202
              ],
              [
                48.3500017,
                37.9994755
              ],
              [
                48.349445,
                37.9950269
              ],
              [
                48.3497251,
                37.9944787
              ],
              [
                48.3500017,
                37.9853118
              ],
              [
                48.3505584,
                37.9822561
              ],
              [
                48.341718,
                37.9479947
              ],
              [
                48.3584849,
                37.9508374
              ],
              [
                48.3747059,
                37.9531515
              ],
              [
                48.3876327,
                37.949871
              ],
              [
                48.4014371,
                37.9418058
              ],
              [
                48.4074546,
                37.9357003
              ],
              [
                48.4164837,
                37.9279827
              ],
              [
                48.4219328,
                37.9237094
              ],
              [
                48.4329951,
                37.9237905
              ],
              [
                48.4478753,
                37.929879
              ],
              [
                48.461173,
                37.9347532
              ],
              [
                48.4747538,
                37.9403119
              ],
              [
                48.4832867,
                37.9407858
              ],
              [
                48.4925365,
                37.9400685
              ],
              [
                48.4988656,
                37.937214
              ],
              [
                48.5181905,
                37.9372442
              ],
              [
                48.5503519,
                37.9369498
              ],
              [
                48.567542,
                37.9371238
              ],
              [
                48.5817749,
                37.9365559
              ],
              [
                48.5861349,
                37.9383424
              ],
              [
                48.5911524,
                37.9419484
              ],
              [
                48.5913014,
                37.9456828
              ],
              [
                48.5904693,
                37.955365
              ],
              [
                48.5902977,
                37.9583427
              ],
              [
                48.5904693,
                37.9701847
              ],
              [
                48.5920572,
                37.9750563
              ],
              [
                48.5983228,
                37.9804011
              ],
              [
                48.6021943,
                37.9875002
              ],
              [
                48.6034449,
                37.9941729
              ],
              [
                48.6011123,
                37.9973126
              ],
              [
                48.5991382,
                37.9975832
              ],
              [
                48.5957789,
                37.9992892
              ],
              [
                48.5913291,
                38.0019515
              ],
              [
                48.5887527,
                38.004448
              ],
              [
                48.5872936,
                38.0064431
              ],
              [
                48.5861349,
                38.0092835
              ],
              [
                48.5859395,
                38.012795
              ],
              [
                48.586774,
                38.0166258
              ],
              [
                48.5882377,
                38.0196635
              ],
              [
                48.5918079,
                38.0244786
              ],
              [
                48.5998105,
                38.0320927
              ],
              [
                48.6030005,
                38.0375462
              ],
              [
                48.6091803,
                38.0428189
              ],
              [
                48.6175917,
                38.0445764
              ],
              [
                48.6308096,
                38.0495782
              ],
              [
                48.6385344,
                38.0533631
              ],
              [
                48.6419676,
                38.0628246
              ],
              [
                48.6490057,
                38.0752578
              ],
              [
                48.6534689,
                38.0857973
              ],
              [
                48.6548423,
                38.0945791
              ],
              [
                48.6508082,
                38.1006581
              ],
              [
                48.6499071,
                38.1035624
              ],
              [
                48.6538553,
                38.1078848
              ],
              [
                48.6575202,
                38.1144169
              ],
              [
                48.6594865,
                38.1257881
              ],
              [
                48.6681061,
                38.137865
              ],
              [
                48.6697547,
                38.140059
              ],
              [
                48.674082,
                38.1481084
              ],
              [
                48.6792442,
                38.1585642
              ],
              [
                48.6701202,
                38.1633782
              ],
              [
                48.6631679,
                38.1658076
              ],
              [
                48.6368698,
                38.171947
              ],
              [
                48.62051,
                38.1774137
              ],
              [
                48.6071204,
                38.1833509
              ],
              [
                48.6062621,
                38.1904345
              ],
              [
                48.6028662,
                38.1952844
              ],
              [
                48.5970745,
                38.2112183
              ],
              [
                48.5860378,
                38.2124158
              ],
              [
                48.5822706,
                38.2117537
              ],
              [
                48.5706228,
                38.206763
              ],
              [
                48.5609683,
                38.2036422
              ],
              [
                48.5525288,
                38.2015513
              ],
              [
                48.5452154,
                38.2012728
              ],
              [
                48.5366687,
                38.2037095
              ],
              [
                48.5282765,
                38.2061375
              ],
              [
                48.5228274,
                38.2095771
              ],
              [
                48.5164568,
                38.2118788
              ],
              [
                48.5054772,
                38.2168626
              ],
              [
                48.5004768,
                38.2227193
              ],
              [
                48.4972162,
                38.2250731
              ],
              [
                48.4912745,
                38.2254101
              ],
              [
                48.4848017,
                38.2239741
              ],
              [
                48.4759729,
                38.2213355
              ],
              [
                48.4658553,
                38.2198191
              ],
              [
                48.462367,
                38.2223358
              ],
              [
                48.4581159,
                38.2272536
              ],
              [
                48.450163,
                38.2311567
              ],
              [
                48.43834,
                38.24254
              ],
              [
                48.4358399,
                38.2461512
              ],
              [
                48.4336169,
                38.2486484
              ],
              [
                48.4286167,
                38.2569847
              ],
              [
                48.42806,
                38.2575416
              ],
              [
                48.4269502,
                38.2611527
              ],
              [
                48.4263935,
                38.2619791
              ],
              [
                48.4261166,
                38.262536
              ],
              [
                48.42556,
                38.263093
              ],
              [
                48.42556,
                38.2633714
              ],
              [
                48.4233369,
                38.2678179
              ],
              [
                48.4233368,
                38.2719858
              ],
              [
                48.4238935,
                38.2758754
              ],
              [
                48.4272268,
                38.2828189
              ],
              [
                48.4286165,
                38.2844806
              ],
              [
                48.432783,
                38.2892054
              ],
              [
                48.441393,
                38.3008734
              ],
              [
                48.4450064,
                38.3119842
              ],
              [
                48.4455598,
                38.3253223
              ],
              [
                48.4456662,
                38.3276483
              ],
              [
                48.4458395,
                38.328933
              ],
              [
                48.4461165,
                38.3292114
              ],
              [
                48.4460739,
                38.332822
              ],
              [
                48.4458422,
                38.3330876
              ],
              [
                48.4455598,
                38.3333789
              ],
              [
                48.4452829,
                38.3336483
              ],
              [
                48.4408398,
                38.3347621
              ],
              [
                48.4402832,
                38.3350405
              ],
              [
                48.4386163,
                38.3350405
              ],
              [
                48.437783,
                38.3353189
              ],
              [
                48.4300067,
                38.3353188
              ],
              [
                48.4291731,
                38.3350405
              ],
              [
                48.42695,
                38.3350404
              ],
              [
                48.4152834,
                38.3333788
              ],
              [
                48.4147267,
                38.3330915
              ],
              [
                48.4133367,
                38.3330914
              ],
              [
                48.4113934,
                38.3325436
              ],
              [
                48.40945,
                38.3325435
              ],
              [
                48.4088933,
                38.3322651
              ],
              [
                48.4072268,
                38.3322651
              ],
              [
                48.4069468,
                38.3319867
              ],
              [
                48.4036136,
                38.3319866
              ],
              [
                48.4027799,
                38.3317083
              ],
              [
                48.3991701,
                38.3317082
              ],
              [
                48.3983368,
                38.3314298
              ],
              [
                48.3905601,
                38.3314298
              ],
              [
                48.3900035,
                38.3311513
              ],
              [
                48.3875038,
                38.3311513
              ],
              [
                48.3833369,
                38.3305945
              ],
              [
                48.3827802,
                38.330316
              ],
              [
                48.379447,
                38.330316
              ],
              [
                48.3788903,
                38.3300376
              ],
              [
                48.3777805,
                38.3300375
              ],
              [
                48.3769469,
                38.3297592
              ],
              [
                48.3738902,
                38.3297591
              ],
              [
                48.373057,
                38.3294807
              ],
              [
                48.3669471,
                38.3294807
              ],
              [
                48.3663905,
                38.3297592
              ],
              [
                48.364724,
                38.3297591
              ],
              [
                48.3638903,
                38.3300376
              ],
              [
                48.3627805,
                38.3300376
              ],
              [
                48.3300009,
                38.3408783
              ],
              [
                48.3294442,
                38.3408782
              ],
              [
                48.2999979,
                38.3586523
              ],
              [
                48.2994443,
                38.3586523
              ],
              [
                48.2861075,
                38.3742075
              ],
              [
                48.2849978,
                38.3775395
              ],
              [
                48.2847211,
                38.3786531
              ],
              [
                48.2844411,
                38.380593
              ],
              [
                48.283888,
                38.3822634
              ],
              [
                48.283888,
                38.3825418
              ],
              [
                48.283888,
                38.3828203
              ],
              [
                48.2841646,
                38.3858737
              ],
              [
                48.2849977,
                38.3881009
              ],
              [
                48.2852743,
                38.3886578
              ],
              [
                48.2877744,
                38.3980964
              ],
              [
                48.2963878,
                38.4147641
              ],
              [
                48.2969444,
                38.4211491
              ],
              [
                48.2891641,
                38.4408781
              ],
              [
                48.2888876,
                38.4411565
              ],
              [
                48.2852741,
                38.4503248
              ],
              [
                48.2852741,
                38.4517077
              ],
              [
                48.284721,
                38.4536563
              ],
              [
                48.2849976,
                38.4572661
              ],
              [
                48.2883307,
                38.4669908
              ],
              [
                48.3055537,
                38.4867093
              ],
              [
                48.306944,
                38.4908755
              ],
              [
                48.3072206,
                38.4911539
              ],
              [
                48.3072205,
                38.491989
              ],
              [
                48.2997208,
                38.4969902
              ],
              [
                48.2872209,
                38.5078276
              ],
              [
                48.2869407,
                38.508097
              ],
              [
                48.2849974,
                38.5103237
              ],
              [
                48.2822207,
                38.5142114
              ],
              [
                48.282672,
                38.5145127
              ],
              [
                48.2859163,
                38.5403978
              ],
              [
                48.2967002,
                38.566603
              ],
              [
                48.3066788,
                38.58023
              ],
              [
                48.3313522,
                38.5997706
              ],
              [
                48.331831,
                38.6005651
              ],
              [
                48.3321411,
                38.6010417
              ],
              [
                48.3299424,
                38.6028884
              ],
              [
                48.3298301,
                38.6031052
              ],
              [
                48.329807,
                38.6032601
              ],
              [
                48.3298235,
                38.6038175
              ],
              [
                48.3297674,
                38.6038562
              ],
              [
                48.3296716,
                38.6038846
              ],
              [
                48.3289319,
                38.6039363
              ],
              [
                48.3287219,
                38.603958
              ],
              [
                48.3283991,
                38.604171
              ],
              [
                48.3282043,
                38.604264
              ],
              [
                48.3279269,
                38.6043052
              ],
              [
                48.3269658,
                38.6042769
              ],
              [
                48.3263879,
                38.6042098
              ],
              [
                48.3258347,
                38.6042457
              ],
              [
                48.3211746,
                38.6020176
              ],
              [
                48.3102234,
                38.6076539
              ],
              [
                48.3083656,
                38.6111998
              ],
              [
                48.307157,
                38.6130918
              ],
              [
                48.3072358,
                38.6206222
              ],
              [
                48.3042708,
                38.6219208
              ],
              [
                48.303106,
                38.6250552
              ],
              [
                48.3028275,
                38.625776
              ],
              [
                48.300278,
                38.629444
              ],
              [
                48.296569,
                38.6313734
              ],
              [
                48.296944,
                38.633611
              ],
              [
                48.293611,
                38.637778
              ],
              [
                48.2958296,
                38.642036
              ],
              [
                48.2952436,
                38.6455236
              ],
              [
                48.2920258,
                38.6438183
              ],
              [
                48.2902736,
                38.642823
              ],
              [
                48.289997,
                38.6425448
              ],
              [
                48.2533271,
                38.609771
              ],
              [
                48.2519407,
                38.608936
              ],
              [
                48.2483274,
                38.606988
              ],
              [
                48.2477739,
                38.6067097
              ],
              [
                48.2422175,
                38.6047706
              ],
              [
                48.2411074,
                38.6047707
              ],
              [
                48.2405507,
                38.6044924
              ],
              [
                48.2394408,
                38.6044923
              ],
              [
                48.2386042,
                38.6042141
              ],
              [
                48.2355509,
                38.604214
              ],
              [
                48.2347177,
                38.6039358
              ],
              [
                48.2322177,
                38.6039358
              ],
              [
                48.2302708,
                38.6033792
              ],
              [
                48.2286043,
                38.6033792
              ],
              [
                48.2283278,
                38.603101
              ],
              [
                48.2269375,
                38.6031009
              ],
              [
                48.2261043,
                38.6028227
              ],
              [
                48.223051,
                38.6028226
              ],
              [
                48.2224944,
                38.6025444
              ],
              [
                48.2197142,
                38.6025444
              ],
              [
                48.2174944,
                38.6019877
              ],
              [
                48.2152712,
                38.6017184
              ],
              [
                48.2111043,
                38.6017185
              ],
              [
                48.2099945,
                38.6014401
              ],
              [
                48.2086046,
                38.6014401
              ],
              [
                48.2074945,
                38.6017184
              ],
              [
                48.1855479,
                38.6031008
              ],
              [
                48.1799915,
                38.6039357
              ],
              [
                48.1788813,
                38.6042139
              ],
              [
                48.1783246,
                38.604214
              ],
              [
                48.1774914,
                38.6044923
              ],
              [
                48.1747148,
                38.6044922
              ],
              [
                48.1738816,
                38.6047706
              ],
              [
                48.1680483,
                38.6047705
              ],
              [
                48.1672151,
                38.6050488
              ],
              [
                48.1661017,
                38.6050488
              ],
              [
                48.1655481,
                38.6047705
              ],
              [
                48.1622114,
                38.6047706
              ],
              [
                48.1588781,
                38.6033791
              ],
              [
                48.1580449,
                38.6033791
              ],
              [
                48.1580449,
                38.6031008
              ],
              [
                48.1561015,
                38.6031008
              ],
              [
                48.1555448,
                38.6028225
              ],
              [
                48.1536018,
                38.6028225
              ],
              [
                48.1527682,
                38.6025442
              ],
              [
                48.1488783,
                38.6025442
              ],
              [
                48.148045,
                38.6022659
              ],
              [
                48.1424882,
                38.6022659
              ],
              [
                48.1419352,
                38.6025441
              ],
              [
                48.139155,
                38.6025442
              ],
              [
                48.1383218,
                38.6028225
              ],
              [
                48.137212,
                38.6028224
              ],
              [
                48.1363784,
                38.6025441
              ],
              [
                48.1338788,
                38.6025441
              ],
              [
                48.1330451,
                38.6022658
              ],
              [
                48.1319353,
                38.6022658
              ],
              [
                48.1188788,
                38.5964307
              ],
              [
                48.1166553,
                38.5953265
              ],
              [
                48.1160986,
                38.5950482
              ],
              [
                48.1002655,
                38.5867173
              ],
              [
                48.0941556,
                38.5778206
              ],
              [
                48.0933224,
                38.5730984
              ],
              [
                48.0902658,
                38.5669935
              ],
              [
                48.0897091,
                38.5667153
              ],
              [
                48.0877657,
                38.5644888
              ],
              [
                48.0844324,
                38.5614364
              ],
              [
                48.0835992,
                38.5597664
              ],
              [
                48.0833191,
                38.5575489
              ],
              [
                48.0833192,
                38.5539309
              ],
              [
                48.0833191,
                38.5533742
              ],
              [
                48.0830426,
                38.5506
              ],
              [
                48.0774859,
                38.5458775
              ],
              [
                48.0774859,
                38.545321
              ],
              [
                48.0749863,
                38.5400418
              ],
              [
                48.0749862,
                38.5381025
              ],
              [
                48.0774859,
                38.5342059
              ],
              [
                48.086376,
                38.5269874
              ],
              [
                48.0947093,
                38.5230997
              ],
              [
                48.0955426,
                38.5230998
              ],
              [
                48.1027658,
                38.5211515
              ],
              [
                48.1108222,
                38.5203254
              ],
              [
                48.1110991,
                38.5200471
              ],
              [
                48.1116559,
                38.5200471
              ],
              [
                48.1122126,
                38.5194905
              ],
              [
                48.1127657,
                38.5194904
              ],
              [
                48.1233222,
                38.5133761
              ],
              [
                48.1263789,
                38.5097667
              ],
              [
                48.1286024,
                38.5056006
              ],
              [
                48.1286025,
                38.5047655
              ],
              [
                48.1291555,
                38.5036521
              ],
              [
                48.1283224,
                38.4955981
              ],
              [
                48.1252656,
                38.4911535
              ],
              [
                48.1180459,
                38.4881006
              ],
              [
                48.1169323,
                38.4881007
              ],
              [
                48.1166557,
                38.4878223
              ],
              [
                48.1158225,
                38.4878223
              ],
              [
                48.1135989,
                38.4872656
              ],
              [
                48.1133224,
                38.4869872
              ],
              [
                48.1127658,
                38.4869872
              ],
              [
                48.1122126,
                38.4867089
              ],
              [
                48.1113795,
                38.4867088
              ],
              [
                48.1010991,
                38.4830993
              ],
              [
                48.0997093,
                38.4830993
              ],
              [
                48.0994326,
                38.4828209
              ],
              [
                48.0955427,
                38.4828209
              ],
              [
                48.0952662,
                38.4830992
              ],
              [
                48.0947094,
                38.4830993
              ],
              [
                48.0944326,
                38.4833776
              ],
              [
                48.0924896,
                38.4839343
              ],
              [
                48.0924896,
                38.4842127
              ],
              [
                48.0885996,
                38.4869872
              ],
              [
                48.0788763,
                38.490049
              ],
              [
                48.0763763,
                38.4903184
              ],
              [
                48.0658197,
                38.4894923
              ],
              [
                48.0488733,
                38.481429
              ],
              [
                48.0480397,
                38.4806029
              ],
              [
                48.0458197,
                38.4789328
              ],
              [
                48.0455396,
                38.4786544
              ],
              [
                48.0183168,
                38.4575438
              ],
              [
                48.0174836,
                38.4572655
              ],
              [
                48.017207,
                38.4569872
              ],
              [
                48.0163734,
                38.4569871
              ],
              [
                48.0163734,
                38.4567088
              ],
              [
                48.0155403,
                38.4567087
              ],
              [
                48.0152637,
                38.4564304
              ],
              [
                48.0144304,
                38.4564304
              ],
              [
                48.0141503,
                38.456152
              ],
              [
                48.0127636,
                38.456152
              ],
              [
                48.0113737,
                38.4555953
              ],
              [
                48.0105406,
                38.4555953
              ],
              [
                48.0072072,
                38.4542124
              ],
              [
                48.0060935,
                38.4542124
              ],
              [
                48.0052603,
                38.4536557
              ],
              [
                48.0044271,
                38.4536556
              ],
              [
                47.9994206,
                38.453195
              ],
              [
                47.9973494,
                38.4535375
              ],
              [
                47.9959871,
                38.4532584
              ],
              [
                47.9897037,
                38.4489323
              ],
              [
                47.9613707,
                38.428934
              ],
              [
                47.9505377,
                38.4233754
              ],
              [
                47.9488713,
                38.4222618
              ],
              [
                47.9430379,
                38.4158768
              ],
              [
                47.943038,
                38.4155985
              ],
              [
                47.9488713,
                38.4083783
              ],
              [
                47.9522046,
                38.4055944
              ],
              [
                47.9516479,
                38.4019843
              ],
              [
                47.9508144,
                38.4003228
              ],
              [
                47.9508143,
                38.3994877
              ],
              [
                47.9547043,
                38.3947638
              ],
              [
                47.9549812,
                38.3944855
              ],
              [
                47.9541476,
                38.3930935
              ],
              [
                47.9535911,
                38.3905969
              ],
              [
                47.9533145,
                38.39004
              ],
              [
                47.9527578,
                38.3864298
              ],
              [
                47.9524813,
                38.3808797
              ],
              [
                47.9547044,
                38.3739284
              ],
              [
                47.9541478,
                38.3697612
              ],
              [
                47.9541477,
                38.3694828
              ],
              [
                47.9535911,
                38.3689261
              ],
              [
                47.9519246,
                38.368926
              ],
              [
                47.9513711,
                38.3686476
              ],
              [
                47.9485914,
                38.3683781
              ],
              [
                47.9435913,
                38.3683781
              ],
              [
                47.9433147,
                38.3680907
              ],
              [
                47.9391482,
                38.3669861
              ],
              [
                47.9274816,
                38.3583731
              ],
              [
                47.9241483,
                38.3564242
              ],
              [
                47.9122015,
                38.3494816
              ],
              [
                47.8960887,
                38.3444879
              ],
              [
                47.8741456,
                38.3378146
              ],
              [
                47.873032,
                38.3378145
              ],
              [
                47.8724789,
                38.3375361
              ],
              [
                47.8713654,
                38.3375362
              ],
              [
                47.8677556,
                38.3367008
              ],
              [
                47.8630321,
                38.3358745
              ],
              [
                47.856089,
                38.333647
              ],
              [
                47.8533088,
                38.3322639
              ],
              [
                47.8494224,
                38.3311502
              ],
              [
                47.8446994,
                38.3255904
              ],
              [
                47.853589,
                38.3125398
              ],
              [
                47.8658124,
                38.3000368
              ],
              [
                47.8658124,
                38.2978182
              ],
              [
                47.8655323,
                38.2933719
              ],
              [
                47.857476,
                38.2747603
              ],
              [
                47.8444226,
                38.2678167
              ],
              [
                47.8435894,
                38.2678167
              ],
              [
                47.8385684,
                38.2666286
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554957,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بیله سوار",
          "name:en": "Bilehsavar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277796",
          "wikipedia": "en:Bileh Savar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.6012308,
                39.2083364
              ],
              [
                47.6043103,
                39.206394
              ],
              [
                47.6068387,
                39.2047527
              ],
              [
                47.6122687,
                39.2019515
              ],
              [
                47.6173296,
                39.1986591
              ],
              [
                47.6214715,
                39.1961528
              ],
              [
                47.62563,
                39.1938911
              ],
              [
                47.6304162,
                39.1917172
              ],
              [
                47.6348305,
                39.1895885
              ],
              [
                47.6410911,
                39.1886953
              ],
              [
                47.6455641,
                39.188158
              ],
              [
                47.6564196,
                39.1858249
              ],
              [
                47.6681749,
                39.1863191
              ],
              [
                47.6717608,
                39.1864875
              ],
              [
                47.6783832,
                39.1957009
              ],
              [
                47.6840258,
                39.203837
              ],
              [
                47.6952409,
                39.2026066
              ],
              [
                47.6959623,
                39.1967299
              ],
              [
                47.6952281,
                39.1846891
              ],
              [
                47.6947097,
                39.1802667
              ],
              [
                47.6919935,
                39.1694648
              ],
              [
                47.6923369,
                39.1604144
              ],
              [
                47.7020232,
                39.1607582
              ],
              [
                47.7103124,
                39.1613141
              ],
              [
                47.7213146,
                39.1616136
              ],
              [
                47.7348402,
                39.1621384
              ],
              [
                47.7451783,
                39.1660594
              ],
              [
                47.7497659,
                39.1678229
              ],
              [
                47.7540716,
                39.1682388
              ],
              [
                47.7588321,
                39.1683836
              ],
              [
                47.7616369,
                39.1686
              ],
              [
                47.7811718,
                39.1697309
              ],
              [
                47.7845441,
                39.170108
              ],
              [
                47.7895186,
                39.1707617
              ],
              [
                47.7966151,
                39.1723253
              ],
              [
                47.8030922,
                39.1732687
              ],
              [
                47.8107942,
                39.1743334
              ],
              [
                47.8156201,
                39.1755595
              ],
              [
                47.8208992,
                39.1762248
              ],
              [
                47.8239427,
                39.1759302
              ],
              [
                47.826167,
                39.1755477
              ],
              [
                47.8280027,
                39.1748232
              ],
              [
                47.8313615,
                39.1727522
              ],
              [
                47.8331854,
                39.1711601
              ],
              [
                47.8343964,
                39.1700788
              ],
              [
                47.8348926,
                39.1690536
              ],
              [
                47.8361613,
                39.1665259
              ],
              [
                47.838386,
                39.1611723
              ],
              [
                47.8388544,
                39.1580264
              ],
              [
                47.8393409,
                39.1497574
              ],
              [
                47.8387535,
                39.1475271
              ],
              [
                47.8383538,
                39.1454159
              ],
              [
                47.8388103,
                39.1426008
              ],
              [
                47.8421962,
                39.1406204
              ],
              [
                47.8424728,
                39.1403424
              ],
              [
                47.8430294,
                39.1403424
              ],
              [
                47.8435861,
                39.1406204
              ],
              [
                47.845253,
                39.1406204
              ],
              [
                47.8538625,
                39.1431134
              ],
              [
                47.8563626,
                39.1439473
              ],
              [
                47.8574728,
                39.1439473
              ],
              [
                47.8580293,
                39.1442252
              ],
              [
                47.8588627,
                39.1442252
              ],
              [
                47.8594193,
                39.1445033
              ],
              [
                47.864696,
                39.1445033
              ],
              [
                47.8646959,
                39.1442253
              ],
              [
                47.8674757,
                39.1420104
              ],
              [
                47.8730289,
                39.1425574
              ],
              [
                47.873309,
                39.1422794
              ],
              [
                47.8785857,
                39.1408984
              ],
              [
                47.8788624,
                39.1406205
              ],
              [
                47.8838659,
                39.1383966
              ],
              [
                47.8883091,
                39.1383966
              ],
              [
                47.8991421,
                39.1422795
              ],
              [
                47.8996987,
                39.1428354
              ],
              [
                47.9044222,
                39.1450593
              ],
              [
                47.9052555,
                39.1450593
              ],
              [
                47.9146986,
                39.1483951
              ],
              [
                47.9160886,
                39.1483951
              ],
              [
                47.9167209,
                39.1493073
              ],
              [
                47.9183121,
                39.149507
              ],
              [
                47.9185886,
                39.149785
              ],
              [
                47.9221987,
                39.1497851
              ],
              [
                47.923032,
                39.1495071
              ],
              [
                47.9235887,
                39.1495071
              ],
              [
                47.926922,
                39.1481172
              ],
              [
                47.9271985,
                39.1475612
              ],
              [
                47.9280318,
                39.1472832
              ],
              [
                47.9368257,
                39.1433917
              ],
              [
                47.9415892,
                39.1496322
              ],
              [
                47.9541205,
                39.1494991
              ],
              [
                47.9730032,
                39.1517622
              ],
              [
                47.9954909,
                39.1553563
              ],
              [
                48.0112837,
                39.1584178
              ],
              [
                48.0271376,
                39.1618037
              ],
              [
                48.0377859,
                39.1651588
              ],
              [
                48.0434723,
                39.1669479
              ],
              [
                48.0503105,
                39.1689838
              ],
              [
                48.0557635,
                39.1676705
              ],
              [
                48.0628104,
                39.1684231
              ],
              [
                48.097016,
                39.169285
              ],
              [
                48.1005128,
                39.1713147
              ],
              [
                48.1030056,
                39.1739545
              ],
              [
                48.1119024,
                39.1844808
              ],
              [
                48.1189399,
                39.1893094
              ],
              [
                48.1299263,
                39.1921272
              ],
              [
                48.129153,
                39.2075665
              ],
              [
                48.1322097,
                39.2086783
              ],
              [
                48.1341532,
                39.2086783
              ],
              [
                48.1349864,
                39.2089472
              ],
              [
                48.1374864,
                39.2086783
              ],
              [
                48.1383197,
                39.2084003
              ],
              [
                48.1392712,
                39.2083671
              ],
              [
                48.1403004,
                39.2083969
              ],
              [
                48.1408753,
                39.2084125
              ],
              [
                48.1412105,
                39.2111584
              ],
              [
                48.1439341,
                39.2116535
              ],
              [
                48.1445813,
                39.2130962
              ],
              [
                48.1423056,
                39.2148073
              ],
              [
                48.1370815,
                39.2155152
              ],
              [
                48.1371711,
                39.2166681
              ],
              [
                48.1357784,
                39.2179669
              ],
              [
                48.1385213,
                39.2188284
              ],
              [
                48.1387681,
                39.220549
              ],
              [
                48.1406251,
                39.2209642
              ],
              [
                48.1409432,
                39.2219906
              ],
              [
                48.1409608,
                39.2222431
              ],
              [
                48.1407362,
                39.2223933
              ],
              [
                48.1405864,
                39.2226595
              ],
              [
                48.1406657,
                39.2227482
              ],
              [
                48.1407758,
                39.2227858
              ],
              [
                48.141278,
                39.2229154
              ],
              [
                48.1415027,
                39.2230622
              ],
              [
                48.1415335,
                39.2232226
              ],
              [
                48.1415291,
                39.2235161
              ],
              [
                48.1415996,
                39.2237516
              ],
              [
                48.1418815,
                39.223929
              ],
              [
                48.1419873,
                39.2241611
              ],
              [
                48.1419872,
                39.2243641
              ],
              [
                48.1417978,
                39.2245877
              ],
              [
                48.1415379,
                39.2247515
              ],
              [
                48.1412956,
                39.2247242
              ],
              [
                48.1409697,
                39.2245365
              ],
              [
                48.1404146,
                39.2242669
              ],
              [
                48.139504,
                39.2250376
              ],
              [
                48.1376713,
                39.2281318
              ],
              [
                48.135752,
                39.227261
              ],
              [
                48.1345525,
                39.2287016
              ],
              [
                48.1356875,
                39.2298571
              ],
              [
                48.1330231,
                39.2299514
              ],
              [
                48.1336861,
                39.2333203
              ],
              [
                48.1359476,
                39.2340804
              ],
              [
                48.1348725,
                39.235012
              ],
              [
                48.1337816,
                39.2354185
              ],
              [
                48.1329867,
                39.2353848
              ],
              [
                48.132674,
                39.2354091
              ],
              [
                48.1329864,
                39.2362478
              ],
              [
                48.134424,
                39.2374409
              ],
              [
                48.1345813,
                39.2381613
              ],
              [
                48.1335795,
                39.2392267
              ],
              [
                48.1312959,
                39.2384894
              ],
              [
                48.1299803,
                39.2411355
              ],
              [
                48.1327911,
                39.2424489
              ],
              [
                48.1303421,
                39.2439384
              ],
              [
                48.1294711,
                39.2463925
              ],
              [
                48.1329808,
                39.2469974
              ],
              [
                48.1326195,
                39.2483636
              ],
              [
                48.1300603,
                39.2483437
              ],
              [
                48.1305877,
                39.2493485
              ],
              [
                48.1327053,
                39.2525378
              ],
              [
                48.1345071,
                39.2528197
              ],
              [
                48.133519,
                39.2543103
              ],
              [
                48.1349591,
                39.2565405
              ],
              [
                48.1359974,
                39.2569215
              ],
              [
                48.1366811,
                39.2602979
              ],
              [
                48.1347198,
                39.2613213
              ],
              [
                48.1315306,
                39.2620038
              ],
              [
                48.1332638,
                39.2639022
              ],
              [
                48.1335664,
                39.2643421
              ],
              [
                48.1333379,
                39.2648405
              ],
              [
                48.1328927,
                39.2649959
              ],
              [
                48.1323016,
                39.2649962
              ],
              [
                48.1317105,
                39.2647937
              ],
              [
                48.1304832,
                39.2646399
              ],
              [
                48.129801,
                39.2649784
              ],
              [
                48.1308019,
                39.2669066
              ],
              [
                48.1304583,
                39.2690036
              ],
              [
                48.1317234,
                39.2690993
              ],
              [
                48.1327705,
                39.2699265
              ],
              [
                48.1321556,
                39.2707999
              ],
              [
                48.1301963,
                39.2710262
              ],
              [
                48.1297734,
                39.2713758
              ],
              [
                48.1299685,
                39.2716202
              ],
              [
                48.1306723,
                39.271724
              ],
              [
                48.1312101,
                39.2725829
              ],
              [
                48.1308032,
                39.273709
              ],
              [
                48.1315741,
                39.2737126
              ],
              [
                48.1329187,
                39.2727464
              ],
              [
                48.1335888,
                39.2719507
              ],
              [
                48.1359403,
                39.2714675
              ],
              [
                48.1364119,
                39.271571
              ],
              [
                48.1366133,
                39.273071
              ],
              [
                48.1369394,
                39.2734971
              ],
              [
                48.1373946,
                39.2731382
              ],
              [
                48.1376896,
                39.2732322
              ],
              [
                48.1383528,
                39.2742378
              ],
              [
                48.1393242,
                39.2745406
              ],
              [
                48.1399686,
                39.2744215
              ],
              [
                48.1414754,
                39.2754491
              ],
              [
                48.1410013,
                39.276201
              ],
              [
                48.1408178,
                39.2771217
              ],
              [
                48.1415504,
                39.2776676
              ],
              [
                48.142283,
                39.2779322
              ],
              [
                48.1437136,
                39.2765639
              ],
              [
                48.1452598,
                39.2765813
              ],
              [
                48.146244,
                39.2763132
              ],
              [
                48.1469883,
                39.2767059
              ],
              [
                48.1471665,
                39.2779213
              ],
              [
                48.1463464,
                39.2787001
              ],
              [
                48.1456851,
                39.2783992
              ],
              [
                48.1450766,
                39.2787273
              ],
              [
                48.1425399,
                39.2787996
              ],
              [
                48.1426342,
                39.2800452
              ],
              [
                48.1416747,
                39.2807002
              ],
              [
                48.1420472,
                39.2815727
              ],
              [
                48.142858,
                39.2818902
              ],
              [
                48.1436062,
                39.2817664
              ],
              [
                48.1437494,
                39.2831696
              ],
              [
                48.1442481,
                39.2838501
              ],
              [
                48.1464546,
                39.2827613
              ],
              [
                48.1466337,
                39.2831624
              ],
              [
                48.1474045,
                39.2830009
              ],
              [
                48.1479172,
                39.2820132
              ],
              [
                48.148518,
                39.281959
              ],
              [
                48.1491098,
                39.2821509
              ],
              [
                48.1495331,
                39.2823509
              ],
              [
                48.1502606,
                39.2820622
              ],
              [
                48.1512913,
                39.2824056
              ],
              [
                48.1521585,
                39.2829811
              ],
              [
                48.1519663,
                39.2838405
              ],
              [
                48.1513038,
                39.2840196
              ],
              [
                48.1506533,
                39.2848537
              ],
              [
                48.1506989,
                39.2852541
              ],
              [
                48.1509261,
                39.2854295
              ],
              [
                48.1509235,
                39.2861144
              ],
              [
                48.1504635,
                39.2867282
              ],
              [
                48.1507308,
                39.2870368
              ],
              [
                48.1509039,
                39.2874654
              ],
              [
                48.1517322,
                39.2874935
              ],
              [
                48.1521626,
                39.2871559
              ],
              [
                48.1526014,
                39.2870806
              ],
              [
                48.1528584,
                39.2872866
              ],
              [
                48.153076,
                39.2876897
              ],
              [
                48.1539042,
                39.2879156
              ],
              [
                48.1539981,
                39.2881951
              ],
              [
                48.1537752,
                39.2883312
              ],
              [
                48.1537908,
                39.2886972
              ],
              [
                48.1539803,
                39.2888872
              ],
              [
                48.1542424,
                39.2889225
              ],
              [
                48.1540739,
                39.2894552
              ],
              [
                48.1540145,
                39.2897911
              ],
              [
                48.1536487,
                39.2898366
              ],
              [
                48.1533112,
                39.2897314
              ],
              [
                48.1527545,
                39.2892495
              ],
              [
                48.1521373,
                39.2895949
              ],
              [
                48.151838,
                39.2900105
              ],
              [
                48.1520748,
                39.2907017
              ],
              [
                48.1524332,
                39.2909596
              ],
              [
                48.1528644,
                39.2911612
              ],
              [
                48.1536068,
                39.2920177
              ],
              [
                48.1535435,
                39.2922402
              ],
              [
                48.1531548,
                39.2924894
              ],
              [
                48.153421,
                39.2931518
              ],
              [
                48.1539167,
                39.2934304
              ],
              [
                48.1542426,
                39.2937446
              ],
              [
                48.1546174,
                39.2946088
              ],
              [
                48.155792,
                39.2951711
              ],
              [
                48.1572427,
                39.2952712
              ],
              [
                48.1578529,
                39.2948662
              ],
              [
                48.158591,
                39.2947284
              ],
              [
                48.1592744,
                39.2949726
              ],
              [
                48.1597669,
                39.2953833
              ],
              [
                48.1590555,
                39.2961214
              ],
              [
                48.1594986,
                39.2961901
              ],
              [
                48.1597921,
                39.2961198
              ],
              [
                48.1602594,
                39.295794
              ],
              [
                48.1610187,
                39.295499
              ],
              [
                48.1614469,
                39.2953003
              ],
              [
                48.1616782,
                39.2956233
              ],
              [
                48.1615713,
                39.2960296
              ],
              [
                48.160955,
                39.2965335
              ],
              [
                48.1603036,
                39.2970027
              ],
              [
                48.160055,
                39.2975141
              ],
              [
                48.1604547,
                39.2978819
              ],
              [
                48.1609893,
                39.2979885
              ],
              [
                48.161771,
                39.2978838
              ],
              [
                48.1620235,
                39.2973833
              ],
              [
                48.1619237,
                39.2968883
              ],
              [
                48.1623407,
                39.2963267
              ],
              [
                48.1628002,
                39.296152
              ],
              [
                48.1633394,
                39.296239
              ],
              [
                48.1635974,
                39.2963019
              ],
              [
                48.1638352,
                39.296734
              ],
              [
                48.1638903,
                39.2970874
              ],
              [
                48.1631637,
                39.2976973
              ],
              [
                48.1630283,
                39.2981249
              ],
              [
                48.1632611,
                39.2986626
              ],
              [
                48.1633045,
                39.2991855
              ],
              [
                48.163136,
                39.299397
              ],
              [
                48.1626747,
                39.2996029
              ],
              [
                48.1623977,
                39.2998878
              ],
              [
                48.1625348,
                39.3001414
              ],
              [
                48.1628658,
                39.3002366
              ],
              [
                48.1635459,
                39.3002449
              ],
              [
                48.1638486,
                39.3001641
              ],
              [
                48.1641347,
                39.3002082
              ],
              [
                48.1643962,
                39.3005477
              ],
              [
                48.1647109,
                39.3007915
              ],
              [
                48.1652642,
                39.3009261
              ],
              [
                48.1669529,
                39.2997466
              ],
              [
                48.1674186,
                39.2997418
              ],
              [
                48.1681664,
                39.3004774
              ],
              [
                48.168137,
                39.3010613
              ],
              [
                48.1686692,
                39.3021522
              ],
              [
                48.1675955,
                39.3025533
              ],
              [
                48.1682997,
                39.3030509
              ],
              [
                48.1692013,
                39.3032736
              ],
              [
                48.168611,
                39.3039208
              ],
              [
                48.1678642,
                39.3041468
              ],
              [
                48.1676306,
                39.3044775
              ],
              [
                48.1687899,
                39.3047769
              ],
              [
                48.1697517,
                39.3053207
              ],
              [
                48.1701693,
                39.3052555
              ],
              [
                48.1696805,
                39.3045713
              ],
              [
                48.1704696,
                39.3041167
              ],
              [
                48.1712193,
                39.3037844
              ],
              [
                48.172108,
                39.3041699
              ],
              [
                48.1735052,
                39.304077
              ],
              [
                48.17431,
                39.3045035
              ],
              [
                48.1739432,
                39.3048153
              ],
              [
                48.1732755,
                39.3049719
              ],
              [
                48.1733778,
                39.3057636
              ],
              [
                48.1736568,
                39.306254
              ],
              [
                48.1743371,
                39.3060846
              ],
              [
                48.1759468,
                39.30555
              ],
              [
                48.1770935,
                39.3058288
              ],
              [
                48.1790704,
                39.3058456
              ],
              [
                48.1806848,
                39.3062123
              ],
              [
                48.1808161,
                39.3067303
              ],
              [
                48.180172,
                39.3067464
              ],
              [
                48.1796914,
                39.3072523
              ],
              [
                48.1795952,
                39.3078747
              ],
              [
                48.1812288,
                39.30884
              ],
              [
                48.1816667,
                39.3090177
              ],
              [
                48.1825152,
                39.3086333
              ],
              [
                48.1831692,
                39.3086299
              ],
              [
                48.1834756,
                39.3089653
              ],
              [
                48.1832981,
                39.3094365
              ],
              [
                48.1830295,
                39.3096112
              ],
              [
                48.1826907,
                39.3100955
              ],
              [
                48.1833491,
                39.3105524
              ],
              [
                48.1842416,
                39.3107995
              ],
              [
                48.1858351,
                39.3094633
              ],
              [
                48.1861753,
                39.3093491
              ],
              [
                48.1864327,
                39.3095141
              ],
              [
                48.1864789,
                39.3106668
              ],
              [
                48.1860438,
                39.3118195
              ],
              [
                48.186173,
                39.3125383
              ],
              [
                48.186997,
                39.3129134
              ],
              [
                48.188033,
                39.3128263
              ],
              [
                48.1887805,
                39.3122404
              ],
              [
                48.1888884,
                39.3114196
              ],
              [
                48.188533,
                39.3105769
              ],
              [
                48.1887333,
                39.3103523
              ],
              [
                48.1919502,
                39.3108256
              ],
              [
                48.1925494,
                39.3104198
              ],
              [
                48.1931978,
                39.3108019
              ],
              [
                48.1928807,
                39.3112666
              ],
              [
                48.1928581,
                39.3114757
              ],
              [
                48.1939628,
                39.3115766
              ],
              [
                48.1940491,
                39.3121308
              ],
              [
                48.1943073,
                39.3124778
              ],
              [
                48.1945933,
                39.3132819
              ],
              [
                48.1946218,
                39.3135909
              ],
              [
                48.1947575,
                39.3150594
              ],
              [
                48.1942724,
                39.316496
              ],
              [
                48.1944161,
                39.3172739
              ],
              [
                48.1948351,
                39.318064
              ],
              [
                48.1955981,
                39.3188784
              ],
              [
                48.197339,
                39.3197073
              ],
              [
                48.1981901,
                39.3198889
              ],
              [
                48.1995375,
                39.3198346
              ],
              [
                48.2008515,
                39.3194441
              ],
              [
                48.2012291,
                39.3199921
              ],
              [
                48.2009962,
                39.3204427
              ],
              [
                48.2012315,
                39.3210486
              ],
              [
                48.201728,
                39.3209733
              ],
              [
                48.2022209,
                39.3214342
              ],
              [
                48.2032489,
                39.3215978
              ],
              [
                48.2036557,
                39.3218566
              ],
              [
                48.2035649,
                39.3224739
              ],
              [
                48.2026565,
                39.3229723
              ],
              [
                48.2027486,
                39.32329
              ],
              [
                48.2029411,
                39.3233692
              ],
              [
                48.2030833,
                39.3234278
              ],
              [
                48.2041495,
                39.3232014
              ],
              [
                48.2049,
                39.3232952
              ],
              [
                48.2051489,
                39.3235441
              ],
              [
                48.2058847,
                39.3254714
              ],
              [
                48.211001,
                39.3291082
              ],
              [
                48.2133439,
                39.3298023
              ],
              [
                48.2160689,
                39.3296865
              ],
              [
                48.2164588,
                39.329272
              ],
              [
                48.2155985,
                39.3290625
              ],
              [
                48.2151546,
                39.3286186
              ],
              [
                48.2156865,
                39.3284385
              ],
              [
                48.217244,
                39.3288027
              ],
              [
                48.2177092,
                39.3282113
              ],
              [
                48.2180419,
                39.3279186
              ],
              [
                48.218564,
                39.3278217
              ],
              [
                48.2194269,
                39.3282388
              ],
              [
                48.2201728,
                39.3285654
              ],
              [
                48.2208206,
                39.328188
              ],
              [
                48.2211979,
                39.3279032
              ],
              [
                48.2214804,
                39.3278571
              ],
              [
                48.2220182,
                39.3283152
              ],
              [
                48.2231478,
                39.3288286
              ],
              [
                48.2238689,
                39.3285529
              ],
              [
                48.2242894,
                39.3283299
              ],
              [
                48.2246356,
                39.3278658
              ],
              [
                48.2251177,
                39.3274821
              ],
              [
                48.2257168,
                39.3274734
              ],
              [
                48.2261075,
                39.327637
              ],
              [
                48.2265007,
                39.3282654
              ],
              [
                48.2265319,
                39.3294986
              ],
              [
                48.2279515,
                39.3301186
              ],
              [
                48.2279083,
                39.3306474
              ],
              [
                48.2281058,
                39.3309053
              ],
              [
                48.2286288,
                39.3305852
              ],
              [
                48.2289293,
                39.3300919
              ],
              [
                48.2291107,
                39.3298959
              ],
              [
                48.2293351,
                39.329869
              ],
              [
                48.2294926,
                39.3299972
              ],
              [
                48.2301985,
                39.3300332
              ],
              [
                48.2303164,
                39.3312962
              ],
              [
                48.2328581,
                39.3304746
              ],
              [
                48.2339319,
                39.3313073
              ],
              [
                48.2321689,
                39.3318224
              ],
              [
                48.232094,
                39.3326663
              ],
              [
                48.2313361,
                39.3332587
              ],
              [
                48.2323437,
                39.3341869
              ],
              [
                48.2340746,
                39.3342963
              ],
              [
                48.2357829,
                39.3335987
              ],
              [
                48.2356861,
                39.3349421
              ],
              [
                48.2371769,
                39.3347066
              ],
              [
                48.2400707,
                39.3323041
              ],
              [
                48.2437186,
                39.3324452
              ],
              [
                48.2460159,
                39.3295356
              ],
              [
                48.2478115,
                39.3307088
              ],
              [
                48.2500892,
                39.3298723
              ],
              [
                48.250331,
                39.331646
              ],
              [
                48.2552065,
                39.3334862
              ],
              [
                48.2551934,
                39.3325176
              ],
              [
                48.2573683,
                39.332421
              ],
              [
                48.2584629,
                39.3321262
              ],
              [
                48.2585502,
                39.3331099
              ],
              [
                48.2578155,
                39.3336312
              ],
              [
                48.2587373,
                39.3349629
              ],
              [
                48.2632133,
                39.3354359
              ],
              [
                48.2653165,
                39.3334445
              ],
              [
                48.2667994,
                39.3341223
              ],
              [
                48.2673109,
                39.3354359
              ],
              [
                48.2650329,
                39.3373921
              ],
              [
                48.2628475,
                39.3373976
              ],
              [
                48.2614349,
                39.3384431
              ],
              [
                48.2624852,
                39.3399
              ],
              [
                48.2639923,
                39.3383763
              ],
              [
                48.2658679,
                39.3404784
              ],
              [
                48.2684237,
                39.340527
              ],
              [
                48.2687377,
                39.3391256
              ],
              [
                48.2725597,
                39.3398507
              ],
              [
                48.2732928,
                39.3412642
              ],
              [
                48.2767843,
                39.3414108
              ],
              [
                48.277541,
                39.3427113
              ],
              [
                48.2768594,
                39.3438963
              ],
              [
                48.2773891,
                39.3450171
              ],
              [
                48.2783297,
                39.3455311
              ],
              [
                48.2807678,
                39.3441005
              ],
              [
                48.282066,
                39.3459014
              ],
              [
                48.2832937,
                39.3452377
              ],
              [
                48.2842912,
                39.3467181
              ],
              [
                48.2863322,
                39.3469091
              ],
              [
                48.2876178,
                39.3480559
              ],
              [
                48.2893222,
                39.3476913
              ],
              [
                48.2925315,
                39.3500741
              ],
              [
                48.2935039,
                39.3506096
              ],
              [
                48.2935795,
                39.3524741
              ],
              [
                48.2941477,
                39.3515172
              ],
              [
                48.2944371,
                39.3510622
              ],
              [
                48.2953568,
                39.351149
              ],
              [
                48.2958315,
                39.3506344
              ],
              [
                48.2965822,
                39.3502866
              ],
              [
                48.2974003,
                39.3502528
              ],
              [
                48.298002,
                39.3503872
              ],
              [
                48.2982376,
                39.35132
              ],
              [
                48.2976886,
                39.352296
              ],
              [
                48.2976788,
                39.3528252
              ],
              [
                48.2984513,
                39.3530066
              ],
              [
                48.2990827,
                39.3518111
              ],
              [
                48.2994909,
                39.3515797
              ],
              [
                48.2997339,
                39.3516527
              ],
              [
                48.3002028,
                39.3527169
              ],
              [
                48.3006591,
                39.3523088
              ],
              [
                48.3009094,
                39.352283
              ],
              [
                48.3010429,
                39.353963
              ],
              [
                48.3014572,
                39.3540417
              ],
              [
                48.3020491,
                39.3537592
              ],
              [
                48.3023298,
                39.3536881
              ],
              [
                48.3025623,
                39.3545187
              ],
              [
                48.3031311,
                39.3552915
              ],
              [
                48.3049512,
                39.3539445
              ],
              [
                48.3067644,
                39.3563839
              ],
              [
                48.3073957,
                39.3557317
              ],
              [
                48.3076726,
                39.3557514
              ],
              [
                48.3077159,
                39.3565259
              ],
              [
                48.3094313,
                39.3580313
              ],
              [
                48.3100353,
                39.3577313
              ],
              [
                48.3104251,
                39.3579526
              ],
              [
                48.3116695,
                39.3579937
              ],
              [
                48.3120025,
                39.3585063
              ],
              [
                48.3113434,
                39.3583837
              ],
              [
                48.3110367,
                39.3592451
              ],
              [
                48.3104125,
                39.3595501
              ],
              [
                48.3104015,
                39.3602303
              ],
              [
                48.3115218,
                39.3605061
              ],
              [
                48.3150508,
                39.3622257
              ],
              [
                48.3177921,
                39.3623364
              ],
              [
                48.3187662,
                39.3625137
              ],
              [
                48.3205691,
                39.3628419
              ],
              [
                48.3261793,
                39.3632927
              ],
              [
                48.3267261,
                39.3632205
              ],
              [
                48.3270571,
                39.3634138
              ],
              [
                48.3271247,
                39.3636018
              ],
              [
                48.3273341,
                39.363654
              ],
              [
                48.3275435,
                39.3635913
              ],
              [
                48.3283811,
                39.3638577
              ],
              [
                48.3289882,
                39.3639305
              ],
              [
                48.330097,
                39.3643225
              ],
              [
                48.3298403,
                39.3651947
              ],
              [
                48.329874,
                39.3657222
              ],
              [
                48.3304009,
                39.3660512
              ],
              [
                48.3309751,
                39.3660251
              ],
              [
                48.3315291,
                39.3654193
              ],
              [
                48.3319479,
                39.3652156
              ],
              [
                48.3326707,
                39.3654715
              ],
              [
                48.3328531,
                39.3657848
              ],
              [
                48.3329556,
                39.3665056
              ],
              [
                48.3331908,
                39.3666152
              ],
              [
                48.3336097,
                39.3663698
              ],
              [
                48.3343933,
                39.3659154
              ],
              [
                48.3357511,
                39.3663698
              ],
              [
                48.3368049,
                39.366516
              ],
              [
                48.3369265,
                39.3674508
              ],
              [
                48.3368991,
                39.3681076
              ],
              [
                48.3369468,
                39.3683366
              ],
              [
                48.3371761,
                39.3684843
              ],
              [
                48.3375869,
                39.3683956
              ],
              [
                48.3384372,
                39.3682701
              ],
              [
                48.3393829,
                39.3686394
              ],
              [
                48.3400039,
                39.3691785
              ],
              [
                48.3404433,
                39.3694592
              ],
              [
                48.3406822,
                39.3694148
              ],
              [
                48.3407204,
                39.3691342
              ],
              [
                48.3407395,
                39.3685877
              ],
              [
                48.341179,
                39.3683292
              ],
              [
                48.341542,
                39.368307
              ],
              [
                48.342164,
                39.3689166
              ],
              [
                48.34263,
                39.3693942
              ],
              [
                48.3427028,
                39.3696169
              ],
              [
                48.3425213,
                39.3702262
              ],
              [
                48.3425069,
                39.3704404
              ],
              [
                48.342655,
                39.3706656
              ],
              [
                48.3428795,
                39.3706878
              ],
              [
                48.343424,
                39.370902
              ],
              [
                48.3444224,
                39.3712971
              ],
              [
                48.3451024,
                39.3713108
              ],
              [
                48.346419,
                39.3709869
              ],
              [
                48.3467486,
                39.3710977
              ],
              [
                48.3474078,
                39.3712675
              ],
              [
                48.3478138,
                39.3714928
              ],
              [
                48.3481004,
                39.3715482
              ],
              [
                48.348215,
                39.3714928
              ],
              [
                48.3479619,
                39.3707284
              ],
              [
                48.3476275,
                39.3702188
              ],
              [
                48.3477469,
                39.3700379
              ],
              [
                48.3484443,
                39.3700674
              ],
              [
                48.3489172,
                39.370012
              ],
              [
                48.3491041,
                39.3701453
              ],
              [
                48.3493566,
                39.3704367
              ],
              [
                48.349813,
                39.3705949
              ],
              [
                48.3507514,
                39.3703813
              ],
              [
                48.3522288,
                39.3702695
              ],
              [
                48.3530191,
                39.3702591
              ],
              [
                48.3537604,
                39.3704943
              ],
              [
                48.3539243,
                39.3705463
              ],
              [
                48.3541675,
                39.3705149
              ],
              [
                48.3542621,
                39.3704314
              ],
              [
                48.3545053,
                39.3701598
              ],
              [
                48.3557635,
                39.3698189
              ],
              [
                48.3566132,
                39.3699867
              ],
              [
                48.3576975,
                39.3700827
              ],
              [
                48.3587919,
                39.3701124
              ],
              [
                48.35926,
                39.3702342
              ],
              [
                48.3599138,
                39.3703596
              ],
              [
                48.360475,
                39.3705374
              ],
              [
                48.360728,
                39.3706329
              ],
              [
                48.3613014,
                39.3708217
              ],
              [
                48.3614958,
                39.3709825
              ],
              [
                48.3615244,
                39.3712225
              ],
              [
                48.3612665,
                39.3719093
              ],
              [
                48.3612139,
                39.372478
              ],
              [
                48.3613572,
                39.3729285
              ],
              [
                48.3618063,
                39.3734122
              ],
              [
                48.3623365,
                39.3737593
              ],
              [
                48.362795,
                39.3739771
              ],
              [
                48.3635545,
                39.3741618
              ],
              [
                48.3639557,
                39.3743759
              ],
              [
                48.3645961,
                39.3748631
              ],
              [
                48.3652379,
                39.3756005
              ],
              [
                48.3653595,
                39.3763733
              ],
              [
                48.3652109,
                39.3770312
              ],
              [
                48.3654609,
                39.3775795
              ],
              [
                48.3658189,
                39.3778302
              ],
              [
                48.366231,
                39.3779241
              ],
              [
                48.3668187,
                39.3779502
              ],
              [
                48.3671969,
                39.3778093
              ],
              [
                48.3674131,
                39.3775169
              ],
              [
                48.3675279,
                39.37712
              ],
              [
                48.3676428,
                39.3770678
              ],
              [
                48.3680639,
                39.3776466
              ],
              [
                48.3683866,
                39.3783511
              ],
              [
                48.3686221,
                39.3798361
              ],
              [
                48.3683809,
                39.3806818
              ],
              [
                48.3679557,
                39.381375
              ],
              [
                48.3658203,
                39.3839464
              ],
              [
                48.3641866,
                39.3861805
              ],
              [
                48.3604281,
                39.3909207
              ],
              [
                48.360179,
                39.3912349
              ],
              [
                48.3590224,
                39.3927811
              ],
              [
                48.3610586,
                39.3940615
              ],
              [
                48.3586518,
                39.3973015
              ],
              [
                48.3561952,
                39.4006082
              ],
              [
                48.3550117,
                39.4022013
              ],
              [
                48.3504217,
                39.408946
              ],
              [
                48.3444601,
                39.416345
              ],
              [
                48.3429278,
                39.4182466
              ],
              [
                48.3382318,
                39.4225349
              ],
              [
                48.3321995,
                39.4287044
              ],
              [
                48.2538929,
                39.4983066
              ],
              [
                48.1755484,
                39.5678729
              ],
              [
                48.1745922,
                39.5672513
              ],
              [
                48.1728967,
                39.5663814
              ],
              [
                48.1545666,
                39.5554913
              ],
              [
                48.1535985,
                39.5547994
              ],
              [
                48.1505418,
                39.5522908
              ],
              [
                48.1505417,
                39.5517352
              ],
              [
                48.1499883,
                39.5509021
              ],
              [
                48.1494316,
                39.5492356
              ],
              [
                48.1472085,
                39.5459027
              ],
              [
                48.1433185,
                39.5431253
              ],
              [
                48.1088756,
                39.5292378
              ],
              [
                48.0889019,
                39.5199689
              ],
              [
                48.0827246,
                39.515546
              ],
              [
                48.0780666,
                39.5139564
              ],
              [
                48.075458,
                39.5112391
              ],
              [
                48.0728235,
                39.5096286
              ],
              [
                48.0712473,
                39.5090654
              ],
              [
                48.0695798,
                39.5076028
              ],
              [
                48.0691517,
                39.5050063
              ],
              [
                48.0673098,
                39.4985604
              ],
              [
                48.067975,
                39.4941559
              ],
              [
                48.0686785,
                39.4924279
              ],
              [
                48.0691981,
                39.4872175
              ],
              [
                48.0689835,
                39.4828951
              ],
              [
                48.0698271,
                39.48077
              ],
              [
                48.0701946,
                39.4779661
              ],
              [
                48.0683374,
                39.4748033
              ],
              [
                48.0656576,
                39.4713178
              ],
              [
                48.0648207,
                39.4689656
              ],
              [
                48.0629968,
                39.4658183
              ],
              [
                48.0616049,
                39.4650936
              ],
              [
                48.0593012,
                39.4648966
              ],
              [
                48.0571505,
                39.465214
              ],
              [
                48.0542593,
                39.4676403
              ],
              [
                48.0527309,
                39.4704985
              ],
              [
                48.0499474,
                39.4746319
              ],
              [
                48.0485622,
                39.4761655
              ],
              [
                48.0465916,
                39.4774243
              ],
              [
                48.0441945,
                39.4784603
              ],
              [
                48.0413511,
                39.4792055
              ],
              [
                48.0368528,
                39.4825514
              ],
              [
                48.0342136,
                39.4815701
              ],
              [
                48.0338524,
                39.4810687
              ],
              [
                48.0328297,
                39.4804849
              ],
              [
                48.0309554,
                39.4809069
              ],
              [
                48.0279451,
                39.4800042
              ],
              [
                48.0249316,
                39.4799923
              ],
              [
                48.0200675,
                39.4793607
              ],
              [
                48.0165274,
                39.4781199
              ],
              [
                48.0131659,
                39.4778052
              ],
              [
                48.009632,
                39.4784142
              ],
              [
                48.0077261,
                39.4791761
              ],
              [
                48.0037891,
                39.4792236
              ],
              [
                47.9993093,
                39.4791905
              ],
              [
                47.9900512,
                39.4812201
              ],
              [
                47.9859166,
                39.4792989
              ],
              [
                47.9846496,
                39.4825577
              ],
              [
                47.9786793,
                39.4849426
              ],
              [
                47.9729108,
                39.4875886
              ],
              [
                47.9685808,
                39.4900228
              ],
              [
                47.9645061,
                39.4912415
              ],
              [
                47.9600462,
                39.4923646
              ],
              [
                47.9582405,
                39.4932617
              ],
              [
                47.9560518,
                39.4941228
              ],
              [
                47.9514376,
                39.4957037
              ],
              [
                47.9495072,
                39.496888
              ],
              [
                47.9484129,
                39.4971695
              ],
              [
                47.9459023,
                39.4981133
              ],
              [
                47.9398727,
                39.4998187
              ],
              [
                47.9357435,
                39.5007582
              ],
              [
                47.9304313,
                39.5028652
              ],
              [
                47.9253396,
                39.5051881
              ],
              [
                47.9223871,
                39.5069484
              ],
              [
                47.9175567,
                39.5091068
              ],
              [
                47.9126858,
                39.5117555
              ],
              [
                47.9063344,
                39.5138579
              ],
              [
                47.9017854,
                39.5150001
              ],
              [
                47.8982161,
                39.5155512
              ],
              [
                47.8882634,
                39.5155678
              ],
              [
                47.8832841,
                39.5163256
              ],
              [
                47.8796625,
                39.5165407
              ],
              [
                47.8778196,
                39.516517
              ],
              [
                47.8699605,
                39.5184413
              ],
              [
                47.8680109,
                39.5193528
              ],
              [
                47.8666223,
                39.5193776
              ],
              [
                47.863848,
                39.5183632
              ],
              [
                47.8613588,
                39.517593
              ],
              [
                47.8582082,
                39.5177331
              ],
              [
                47.8561659,
                39.5174218
              ],
              [
                47.8540453,
                39.5166396
              ],
              [
                47.8513871,
                39.5161963
              ],
              [
                47.849382,
                39.5155434
              ],
              [
                47.8486775,
                39.5147654
              ],
              [
                47.847682,
                39.513681
              ],
              [
                47.8461799,
                39.5125186
              ],
              [
                47.8435014,
                39.5126345
              ],
              [
                47.8391896,
                39.5139221
              ],
              [
                47.834816,
                39.5172492
              ],
              [
                47.8315863,
                39.5203926
              ],
              [
                47.8299631,
                39.5222797
              ],
              [
                47.827971,
                39.5245261
              ],
              [
                47.824409,
                39.5243854
              ],
              [
                47.8231832,
                39.5250056
              ],
              [
                47.8226265,
                39.5246001
              ],
              [
                47.8210815,
                39.5250708
              ],
              [
                47.8185818,
                39.5239597
              ],
              [
                47.8184484,
                39.5238259
              ],
              [
                47.8183048,
                39.523682
              ],
              [
                47.8091386,
                39.5175714
              ],
              [
                47.7985818,
                39.502572
              ],
              [
                47.7977486,
                39.5022942
              ],
              [
                47.7944152,
                39.500072
              ],
              [
                47.7838588,
                39.4956277
              ],
              [
                47.7827455,
                39.4956276
              ],
              [
                47.7785785,
                39.4942387
              ],
              [
                47.7771922,
                39.4942387
              ],
              [
                47.7613556,
                39.4906276
              ],
              [
                47.7580223,
                39.4892387
              ],
              [
                47.757189,
                39.488961
              ],
              [
                47.7474657,
                39.4842387
              ],
              [
                47.7407111,
                39.4780469
              ],
              [
                47.7374659,
                39.4750718
              ],
              [
                47.7277428,
                39.4531261
              ],
              [
                47.7274662,
                39.4525705
              ],
              [
                47.7205228,
                39.4328462
              ],
              [
                47.7180231,
                39.419511
              ],
              [
                47.7177431,
                39.4164549
              ],
              [
                47.7180231,
                39.4070178
              ],
              [
                47.7185763,
                39.4009055
              ],
              [
                47.7188564,
                39.3989607
              ],
              [
                47.7191331,
                39.3967381
              ],
              [
                47.7194097,
                39.3961824
              ],
              [
                47.719133,
                39.3953489
              ],
              [
                47.7194096,
                39.3942375
              ],
              [
                47.719133,
                39.3936819
              ],
              [
                47.7182998,
                39.388403
              ],
              [
                47.7180233,
                39.3881252
              ],
              [
                47.7169096,
                39.3839575
              ],
              [
                47.7169096,
                39.383124
              ],
              [
                47.7146897,
                39.3728437
              ],
              [
                47.7146897,
                39.3703431
              ],
              [
                47.7124665,
                39.3622852
              ],
              [
                47.7124666,
                39.360627
              ],
              [
                47.7119099,
                39.3583953
              ],
              [
                47.7096865,
                39.3534028
              ],
              [
                47.7069099,
                39.3360742
              ],
              [
                47.70691,
                39.3356193
              ],
              [
                47.7066333,
                39.3339521
              ],
              [
                47.7063533,
                39.3267363
              ],
              [
                47.7058002,
                39.3242354
              ],
              [
                47.7058002,
                39.3234017
              ],
              [
                47.6921871,
                39.2878408
              ],
              [
                47.6919106,
                39.2847839
              ],
              [
                47.6913535,
                39.2836722
              ],
              [
                47.6899637,
                39.2747882
              ],
              [
                47.688854,
                39.2722871
              ],
              [
                47.6885773,
                39.2717313
              ],
              [
                47.6813539,
                39.2592341
              ],
              [
                47.6774639,
                39.2472834
              ],
              [
                47.6757975,
                39.2453379
              ],
              [
                47.6643107,
                39.2314374
              ],
              [
                47.6637576,
                39.2311595
              ],
              [
                47.6552303,
                39.2267576
              ],
              [
                47.6543967,
                39.2267576
              ],
              [
                47.6535634,
                39.2262018
              ],
              [
                47.6527302,
                39.2262017
              ],
              [
                47.6524536,
                39.2259238
              ],
              [
                47.6498248,
                39.2248932
              ],
              [
                47.6492681,
                39.2251711
              ],
              [
                47.6473247,
                39.2251711
              ],
              [
                47.6464914,
                39.2254491
              ],
              [
                47.6454029,
                39.2248174
              ],
              [
                47.6451264,
                39.2250953
              ],
              [
                47.643183,
                39.2250953
              ],
              [
                47.6407809,
                39.2247084
              ],
              [
                47.6364273,
                39.2243095
              ],
              [
                47.6307669,
                39.223433
              ],
              [
                47.6291612,
                39.2229676
              ],
              [
                47.6213679,
                39.2210404
              ],
              [
                47.6174044,
                39.219463
              ],
              [
                47.6126217,
                39.2182963
              ],
              [
                47.610286,
                39.2166675
              ],
              [
                47.6083195,
                39.2146245
              ],
              [
                47.6066167,
                39.2123852
              ],
              [
                47.6046188,
                39.2108947
              ],
              [
                47.6034808,
                39.2093376
              ],
              [
                47.6012308,
                39.2083364
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554995,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خلخال",
          "name:en": "Kahlkhal County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q721735",
          "wikipedia": "en:Khalkhal County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.1658649,
                37.4561236
              ],
              [
                48.1655468,
                37.4521246
              ],
              [
                48.1636039,
                37.4479169
              ],
              [
                48.1629861,
                37.4409848
              ],
              [
                48.1631669,
                37.4313737
              ],
              [
                48.164432,
                37.4252284
              ],
              [
                48.1672392,
                37.4186839
              ],
              [
                48.1720984,
                37.4126472
              ],
              [
                48.1770229,
                37.4087643
              ],
              [
                48.1818044,
                37.4042401
              ],
              [
                48.1904898,
                37.3922298
              ],
              [
                48.1982391,
                37.3776978
              ],
              [
                48.204198,
                37.3759872
              ],
              [
                48.2119686,
                37.3738864
              ],
              [
                48.2182313,
                37.3728496
              ],
              [
                48.2250863,
                37.3722288
              ],
              [
                48.229624,
                37.3719288
              ],
              [
                48.2349626,
                37.3715036
              ],
              [
                48.2341529,
                37.3686204
              ],
              [
                48.2334921,
                37.3665035
              ],
              [
                48.2329227,
                37.3638817
              ],
              [
                48.2322676,
                37.3607572
              ],
              [
                48.2319545,
                37.3580486
              ],
              [
                48.23174,
                37.3541597
              ],
              [
                48.2337785,
                37.3483431
              ],
              [
                48.2371044,
                37.3442662
              ],
              [
                48.2379091,
                37.343345
              ],
              [
                48.2394218,
                37.3423299
              ],
              [
                48.243649,
                37.339481
              ],
              [
                48.2453334,
                37.3384318
              ],
              [
                48.246578,
                37.3377238
              ],
              [
                48.2469749,
                37.3345931
              ],
              [
                48.2471681,
                37.3331429
              ],
              [
                48.2466745,
                37.3296026
              ],
              [
                48.2462668,
                37.3264972
              ],
              [
                48.2460415,
                37.3251748
              ],
              [
                48.2476723,
                37.322692
              ],
              [
                48.250097,
                37.3216255
              ],
              [
                48.252908,
                37.3220862
              ],
              [
                48.2542169,
                37.3222483
              ],
              [
                48.2568455,
                37.3231271
              ],
              [
                48.2570708,
                37.3247908
              ],
              [
                48.2572853,
                37.3278707
              ],
              [
                48.258487,
                37.3279816
              ],
              [
                48.2596242,
                37.3281011
              ],
              [
                48.2601821,
                37.3262497
              ],
              [
                48.2604825,
                37.3247994
              ],
              [
                48.2625747,
                37.3234599
              ],
              [
                48.2636154,
                37.3226238
              ],
              [
                48.2642376,
                37.3201068
              ],
              [
                48.2624352,
                37.3174447
              ],
              [
                48.2591092,
                37.3170095
              ],
              [
                48.257736,
                37.315047
              ],
              [
                48.2610834,
                37.313878
              ],
              [
                48.2638299,
                37.3129479
              ],
              [
                48.2656538,
                37.312709
              ],
              [
                48.267113,
                37.3125981
              ],
              [
                48.2691193,
                37.3152603
              ],
              [
                48.2708573,
                37.3160197
              ],
              [
                48.2716942,
                37.3133234
              ],
              [
                48.2720053,
                37.3122567
              ],
              [
                48.2725739,
                37.3113096
              ],
              [
                48.2745695,
                37.3110365
              ],
              [
                48.276093,
                37.3108658
              ],
              [
                48.2763076,
                37.3087922
              ],
              [
                48.2743657,
                37.3076487
              ],
              [
                48.2705998,
                37.307589
              ],
              [
                48.269881,
                37.3063772
              ],
              [
                48.2700205,
                37.3061212
              ],
              [
                48.272177,
                37.3049094
              ],
              [
                48.276608,
                37.3055323
              ],
              [
                48.2778525,
                37.3056518
              ],
              [
                48.2804811,
                37.3055323
              ],
              [
                48.2813394,
                37.3047899
              ],
              [
                48.2818544,
                37.3030063
              ],
              [
                48.2821655,
                37.3016493
              ],
              [
                48.2821441,
                37.2999254
              ],
              [
                48.2832169,
                37.2983038
              ],
              [
                48.2844829,
                37.2965542
              ],
              [
                48.287015,
                37.2957007
              ],
              [
                48.2906949,
                37.2964005
              ],
              [
                48.291564,
                37.2965798
              ],
              [
                48.2953834,
                37.2951971
              ],
              [
                48.2958046,
                37.2946871
              ],
              [
                48.2963383,
                37.2938678
              ],
              [
                48.2969123,
                37.2926515
              ],
              [
                48.2975936,
                37.2908953
              ],
              [
                48.2958555,
                37.2870798
              ],
              [
                48.2928514,
                37.2855177
              ],
              [
                48.2924437,
                37.2840666
              ],
              [
                48.2922828,
                37.2831276
              ],
              [
                48.2956087,
                37.2822056
              ],
              [
                48.2977545,
                37.278919
              ],
              [
                48.2986343,
                37.2776726
              ],
              [
                48.3034193,
                37.2766225
              ],
              [
                48.3047712,
                37.2750432
              ],
              [
                48.306123,
                37.2737967
              ],
              [
                48.309803,
                37.2726954
              ],
              [
                48.3150494,
                37.2753078
              ],
              [
                48.3169806,
                37.2757859
              ],
              [
                48.3200812,
                37.276392
              ],
              [
                48.3231068,
                37.2749151
              ],
              [
                48.3232677,
                37.2724648
              ],
              [
                48.3215403,
                37.270578
              ],
              [
                48.3206284,
                37.2690241
              ],
              [
                48.3201349,
                37.2684435
              ],
              [
                48.3219159,
                37.2664114
              ],
              [
                48.3287823,
                37.2701511
              ],
              [
                48.3332562,
                37.2659674
              ],
              [
                48.3354878,
                37.2637816
              ],
              [
                48.3366465,
                37.2627313
              ],
              [
                48.3379447,
                37.2600928
              ],
              [
                48.3387172,
                37.2586241
              ],
              [
                48.3402192,
                37.2571724
              ],
              [
                48.3439314,
                37.2575908
              ],
              [
                48.3458197,
                37.2550119
              ],
              [
                48.3438241,
                37.2529624
              ],
              [
                48.3416891,
                37.2515618
              ],
              [
                48.3409488,
                37.2511007
              ],
              [
                48.3407771,
                37.2497769
              ],
              [
                48.3415389,
                37.2486582
              ],
              [
                48.3420753,
                37.2479664
              ],
              [
                48.3401334,
                37.2450541
              ],
              [
                48.3382559,
                37.2422868
              ],
              [
                48.3370757,
                37.2406469
              ],
              [
                48.3365285,
                37.2397458
              ],
              [
                48.3376121,
                37.2394768
              ],
              [
                48.3402622,
                37.2406725
              ],
              [
                48.342483,
                37.2416719
              ],
              [
                48.3486414,
                37.2422356
              ],
              [
                48.3529973,
                37.2461814
              ],
              [
                48.3558726,
                37.2480945
              ],
              [
                48.3623207,
                37.2468818
              ],
              [
                48.3667731,
                37.2476675
              ],
              [
                48.3691871,
                37.2486582
              ],
              [
                48.3736181,
                37.2483336
              ],
              [
                48.3761716,
                37.2471721
              ],
              [
                48.3789289,
                37.244405
              ],
              [
                48.3800554,
                37.24379
              ],
              [
                48.384304,
                37.2453616
              ],
              [
                48.3919859,
                37.2489144
              ],
              [
                48.3968782,
                37.2492219
              ],
              [
                48.4039378,
                37.2461345
              ],
              [
                48.4098709,
                37.2479749
              ],
              [
                48.4125638,
                37.2483849
              ],
              [
                48.4153533,
                37.2466426
              ],
              [
                48.4166729,
                37.2446014
              ],
              [
                48.4167695,
                37.2425174
              ],
              [
                48.4196448,
                37.2410398
              ],
              [
                48.4235608,
                37.2408348
              ],
              [
                48.4247196,
                37.2409117
              ],
              [
                48.4261894,
                37.2396476
              ],
              [
                48.4263825,
                37.2378368
              ],
              [
                48.4202456,
                37.2286712
              ],
              [
                48.4202456,
                37.2242289
              ],
              [
                48.4214902,
                37.222674
              ],
              [
                48.4265327,
                37.2213413
              ],
              [
                48.4303187,
                37.221039
              ],
              [
                48.4375191,
                37.2153265
              ],
              [
                48.442347,
                37.2118575
              ],
              [
                48.4463811,
                37.2104049
              ],
              [
                48.4509301,
                37.2082345
              ],
              [
                48.4521854,
                37.2076812
              ],
              [
                48.4537679,
                37.2082003
              ],
              [
                48.4541595,
                37.2099862
              ],
              [
                48.4560478,
                37.2104989
              ],
              [
                48.457582,
                37.210422
              ],
              [
                48.4602642,
                37.2086959
              ],
              [
                48.460586,
                37.2089865
              ],
              [
                48.4625199,
                37.2081106
              ],
              [
                48.4634507,
                37.2086724
              ],
              [
                48.4633755,
                37.2097897
              ],
              [
                48.4641051,
                37.2113619
              ],
              [
                48.4638476,
                37.212729
              ],
              [
                48.4649849,
                37.2131904
              ],
              [
                48.4680802,
                37.2127803
              ],
              [
                48.4694427,
                37.2126094
              ],
              [
                48.4720069,
                37.2116481
              ],
              [
                48.4750593,
                37.211379
              ],
              [
                48.4760034,
                37.2111824
              ],
              [
                48.4779882,
                37.2111397
              ],
              [
                48.4795868,
                37.2106997
              ],
              [
                48.480531,
                37.2106313
              ],
              [
                48.4818774,
                37.2100033
              ],
              [
                48.4826875,
                37.2084182
              ],
              [
                48.4777576,
                37.2071621
              ],
              [
                48.4764004,
                37.2071023
              ],
              [
                48.4757405,
                37.2062307
              ],
              [
                48.4761482,
                37.2053591
              ],
              [
                48.477425,
                37.2045558
              ],
              [
                48.4784335,
                37.2037697
              ],
              [
                48.4792864,
                37.2026887
              ],
              [
                48.4809279,
                37.200783
              ],
              [
                48.487376,
                37.1993729
              ],
              [
                48.4887493,
                37.198279
              ],
              [
                48.4891784,
                37.1957921
              ],
              [
                48.4872687,
                37.1925786
              ],
              [
                48.4869468,
                37.1895445
              ],
              [
                48.4868288,
                37.1858008
              ],
              [
                48.4850156,
                37.1839032
              ],
              [
                48.4808528,
                37.1819629
              ],
              [
                48.4782886,
                37.1794669
              ],
              [
                48.4790289,
                37.1787317
              ],
              [
                48.4803378,
                37.1784582
              ],
              [
                48.4830737,
                37.1791848
              ],
              [
                48.4850585,
                37.1796207
              ],
              [
                48.487494,
                37.1798772
              ],
              [
                48.4891248,
                37.1799969
              ],
              [
                48.4920645,
                37.1797917
              ],
              [
                48.4947145,
                37.1776717
              ],
              [
                48.4959376,
                37.1753807
              ],
              [
                48.4944463,
                37.1739702
              ],
              [
                48.492279,
                37.172893
              ],
              [
                48.4912491,
                37.1717988
              ],
              [
                48.4911096,
                37.1706019
              ],
              [
                48.4914207,
                37.1702428
              ],
              [
                48.4927833,
                37.169747
              ],
              [
                48.4938347,
                37.1694478
              ],
              [
                48.4957445,
                37.1673617
              ],
              [
                48.4972465,
                37.1656261
              ],
              [
                48.4966564,
                37.1639931
              ],
              [
                48.4955406,
                37.1594444
              ],
              [
                48.4981155,
                37.1550237
              ],
              [
                48.50039,
                37.1486188
              ],
              [
                48.5041451,
                37.1436929
              ],
              [
                48.5059905,
                37.1404943
              ],
              [
                48.5086298,
                37.1387325
              ],
              [
                48.5119343,
                37.1369535
              ],
              [
                48.5155177,
                37.1360982
              ],
              [
                48.5182214,
                37.135833
              ],
              [
                48.5216117,
                37.1362008
              ],
              [
                48.5251522,
                37.1362863
              ],
              [
                48.528403,
                37.1363633
              ],
              [
                48.5308814,
                37.135756
              ],
              [
                48.534497,
                37.1351744
              ],
              [
                48.5380053,
                37.1349862
              ],
              [
                48.5451937,
                37.1352599
              ],
              [
                48.5476613,
                37.1315991
              ],
              [
                48.5476827,
                37.1269458
              ],
              [
                48.5469317,
                37.1230279
              ],
              [
                48.5475111,
                37.1210261
              ],
              [
                48.5497159,
                37.1194413
              ],
              [
                48.5561263,
                37.1194606
              ],
              [
                48.5597312,
                37.1183228
              ],
              [
                48.565251,
                37.121159
              ],
              [
                48.5654497,
                37.1212614
              ],
              [
                48.5687005,
                37.1204316
              ],
              [
                48.5693872,
                37.1189345
              ],
              [
                48.5705191,
                37.1165134
              ],
              [
                48.570621,
                37.1145456
              ],
              [
                48.5708249,
                37.1113843
              ],
              [
                48.57171,
                37.1084667
              ],
              [
                48.5761249,
                37.1050014
              ],
              [
                48.5799122,
                37.1043254
              ],
              [
                48.5852766,
                37.1064645
              ],
              [
                48.5898256,
                37.1086207
              ],
              [
                48.5946321,
                37.1110506
              ],
              [
                48.6092532,
                37.1178706
              ],
              [
                48.6150598,
                37.119914
              ],
              [
                48.6230422,
                37.121853
              ],
              [
                48.630885,
                37.123635
              ],
              [
                48.6351956,
                37.1239982
              ],
              [
                48.6397556,
                37.1248841
              ],
              [
                48.6525098,
                37.1267122
              ],
              [
                48.6627641,
                37.1320892
              ],
              [
                48.6658128,
                37.1343733
              ],
              [
                48.6801978,
                37.145938
              ],
              [
                48.6947441,
                37.1594493
              ],
              [
                48.6958538,
                37.1600073
              ],
              [
                48.7262264,
                37.1796396
              ],
              [
                48.726967,
                37.1800119
              ],
              [
                48.7278003,
                37.1802908
              ],
              [
                48.7336336,
                37.1841783
              ],
              [
                48.7375235,
                37.1855641
              ],
              [
                48.7391904,
                37.1855641
              ],
              [
                48.7394669,
                37.1858431
              ],
              [
                48.7430802,
                37.1858431
              ],
              [
                48.7436334,
                37.1861221
              ],
              [
                48.744467,
                37.1861221
              ],
              [
                48.7450237,
                37.185843
              ],
              [
                48.7461334,
                37.1858431
              ],
              [
                48.7511367,
                37.1827925
              ],
              [
                48.7511367,
                37.1825136
              ],
              [
                48.7516902,
                37.1811188
              ],
              [
                48.7519703,
                37.1808398
              ],
              [
                48.7519703,
                37.1802909
              ],
              [
                48.7519703,
                37.179454
              ],
              [
                48.7522469,
                37.1694563
              ],
              [
                48.7539134,
                37.1666756
              ],
              [
                48.7553036,
                37.1666756
              ],
              [
                48.7553037,
                37.1663967
              ],
              [
                48.7572466,
                37.1658387
              ],
              [
                48.7589134,
                37.1647319
              ],
              [
                48.7647469,
                37.1566778
              ],
              [
                48.7680801,
                37.1502884
              ],
              [
                48.7764131,
                37.1469497
              ],
              [
                48.7769698,
                37.1466797
              ],
              [
                48.7833598,
                37.1436199
              ],
              [
                48.7866931,
                37.1402902
              ],
              [
                48.7872497,
                37.1402902
              ],
              [
                48.7875266,
                37.1400113
              ],
              [
                48.7883598,
                37.1400113
              ],
              [
                48.7886364,
                37.1397323
              ],
              [
                48.7900263,
                37.1391743
              ],
              [
                48.7939163,
                37.1391744
              ],
              [
                48.7941932,
                37.1394533
              ],
              [
                48.8019696,
                37.1419551
              ],
              [
                48.8101956,
                37.1485507
              ],
              [
                48.8105389,
                37.159496
              ],
              [
                48.797836,
                37.1802878
              ],
              [
                48.8028497,
                37.188092
              ],
              [
                48.8053497,
                37.1889195
              ],
              [
                48.8064599,
                37.1889195
              ],
              [
                48.8092361,
                37.1889195
              ],
              [
                48.8097931,
                37.1886405
              ],
              [
                48.8117363,
                37.1886406
              ],
              [
                48.8122928,
                37.1883618
              ],
              [
                48.8167398,
                37.1875342
              ],
              [
                48.8220162,
                37.1875342
              ],
              [
                48.8228498,
                37.1878131
              ],
              [
                48.8286826,
                37.1878131
              ],
              [
                48.8295162,
                37.1875342
              ],
              [
                48.8314593,
                37.1875342
              ],
              [
                48.8320159,
                37.1872553
              ],
              [
                48.8328495,
                37.1872554
              ],
              [
                48.8331261,
                37.1869766
              ],
              [
                48.8336827,
                37.1869766
              ],
              [
                48.8400647,
                37.1780994
              ],
              [
                48.8366314,
                37.160864
              ],
              [
                48.8434979,
                37.1518344
              ],
              [
                48.8550288,
                37.1480658
              ],
              [
                48.8561391,
                37.1480657
              ],
              [
                48.8564192,
                37.1477867
              ],
              [
                48.8580856,
                37.1477868
              ],
              [
                48.8586392,
                37.1480657
              ],
              [
                48.8589193,
                37.1477867
              ],
              [
                48.8608623,
                37.1477868
              ],
              [
                48.8608622,
                37.1475078
              ],
              [
                48.8614189,
                37.1475078
              ],
              [
                48.8622525,
                37.1475078
              ],
              [
                48.8639188,
                37.1475078
              ],
              [
                48.865372,
                37.1475733
              ],
              [
                48.8685765,
                37.1493874
              ],
              [
                48.8691956,
                37.1504033
              ],
              [
                48.8698146,
                37.1516513
              ],
              [
                48.8705793,
                37.1521302
              ],
              [
                48.8709617,
                37.1527252
              ],
              [
                48.8719189,
                37.1533031
              ],
              [
                48.8721419,
                37.1532495
              ],
              [
                48.8723631,
                37.1532721
              ],
              [
                48.8724834,
                37.1533877
              ],
              [
                48.8726144,
                37.1534484
              ],
              [
                48.8727559,
                37.153454
              ],
              [
                48.8730245,
                37.1534657
              ],
              [
                48.8732152,
                37.1535506
              ],
              [
                48.8732981,
                37.1536535
              ],
              [
                48.8735186,
                37.1538715
              ],
              [
                48.8737097,
                37.1540323
              ],
              [
                48.874322,
                37.1541
              ],
              [
                48.8747839,
                37.1541635
              ],
              [
                48.8751219,
                37.1541254
              ],
              [
                48.875536,
                37.1539956
              ],
              [
                48.8758379,
                37.1540213
              ],
              [
                48.8760626,
                37.1541287
              ],
              [
                48.8762238,
                37.154271
              ],
              [
                48.8762913,
                37.154378
              ],
              [
                48.8763783,
                37.1545118
              ],
              [
                48.876534,
                37.1545499
              ],
              [
                48.876849,
                37.154784
              ],
              [
                48.8770118,
                37.1548024
              ],
              [
                48.8770596,
                37.1548179
              ],
              [
                48.8770879,
                37.1549039
              ],
              [
                48.8771782,
                37.1549632
              ],
              [
                48.8773746,
                37.1549829
              ],
              [
                48.8775993,
                37.1550605
              ],
              [
                48.8780523,
                37.1553383
              ],
              [
                48.8782346,
                37.1553792
              ],
              [
                48.8784735,
                37.1553566
              ],
              [
                48.8790748,
                37.1554002
              ],
              [
                48.8798589,
                37.155491
              ],
              [
                48.880221,
                37.1555696
              ],
              [
                48.880489,
                37.1555094
              ],
              [
                48.880546,
                37.1554075
              ],
              [
                48.880717,
                37.1553989
              ],
              [
                48.8808541,
                37.1554358
              ],
              [
                48.8809589,
                37.15541
              ],
              [
                48.8812146,
                37.1553204
              ],
              [
                48.8815551,
                37.1552406
              ],
              [
                48.881672,
                37.1552048
              ],
              [
                48.8817923,
                37.1551681
              ],
              [
                48.8819202,
                37.15513
              ],
              [
                48.8819941,
                37.1550809
              ],
              [
                48.8820942,
                37.1550331
              ],
              [
                48.8822606,
                37.1550416
              ],
              [
                48.8824193,
                37.1550748
              ],
              [
                48.8825073,
                37.1550886
              ],
              [
                48.8827241,
                37.1550871
              ],
              [
                48.8828366,
                37.1550841
              ],
              [
                48.882942,
                37.1551459
              ],
              [
                48.8830096,
                37.1551855
              ],
              [
                48.8833551,
                37.1552287
              ],
              [
                48.883597,
                37.1552505
              ],
              [
                48.8837894,
                37.1553112
              ],
              [
                48.8840295,
                37.1554796
              ],
              [
                48.8843511,
                37.1557796
              ],
              [
                48.8846377,
                37.1558864
              ],
              [
                48.8848302,
                37.1559355
              ],
              [
                48.8850243,
                37.1560497
              ],
              [
                48.8850705,
                37.1562019
              ],
              [
                48.8850921,
                37.1563468
              ],
              [
                48.8850798,
                37.1564659
              ],
              [
                48.8850675,
                37.1566365
              ],
              [
                48.8851014,
                37.1568011
              ],
              [
                48.8851428,
                37.15701
              ],
              [
                48.8853216,
                37.1571965
              ],
              [
                48.8855411,
                37.1573545
              ],
              [
                48.8857003,
                37.1577296
              ],
              [
                48.8860259,
                37.1579186
              ],
              [
                48.8878238,
                37.1579045
              ],
              [
                48.8880008,
                37.1582345
              ],
              [
                48.8879371,
                37.1585673
              ],
              [
                48.8880149,
                37.1590243
              ],
              [
                48.8883547,
                37.1594474
              ],
              [
                48.8883936,
                37.1596843
              ],
              [
                48.8885812,
                37.1599128
              ],
              [
                48.8885918,
                37.1602343
              ],
              [
                48.8885104,
                37.1604289
              ],
              [
                48.8882592,
                37.1608971
              ],
              [
                48.8882839,
                37.1611425
              ],
              [
                48.8884927,
                37.1613456
              ],
              [
                48.8887016,
                37.1613682
              ],
              [
                48.8888821,
                37.1615205
              ],
              [
                48.8890519,
                37.1616079
              ],
              [
                48.8893917,
                37.1616079
              ],
              [
                48.889643,
                37.1615289
              ],
              [
                48.889873,
                37.1614161
              ],
              [
                48.890319,
                37.1614612
              ],
              [
                48.890595,
                37.1615966
              ],
              [
                48.890726,
                37.1617207
              ],
              [
                48.8907154,
                37.1619012
              ],
              [
                48.890641,
                37.1620394
              ],
              [
                48.890641,
                37.1622792
              ],
              [
                48.8907755,
                37.1625246
              ],
              [
                48.8912356,
                37.1628264
              ],
              [
                48.891494,
                37.16288
              ],
              [
                48.8918691,
                37.1630746
              ],
              [
                48.8920886,
                37.1632974
              ],
              [
                48.8921593,
                37.1635879
              ],
              [
                48.8921417,
                37.1638192
              ],
              [
                48.8919045,
                37.1640702
              ],
              [
                48.8918762,
                37.1642422
              ],
              [
                48.8920567,
                37.1646145
              ],
              [
                48.8922691,
                37.1648768
              ],
              [
                48.892531,
                37.1649078
              ],
              [
                48.8930654,
                37.1647302
              ],
              [
                48.8933379,
                37.1646737
              ],
              [
                48.8940917,
                37.164843
              ],
              [
                48.8942369,
                37.1649417
              ],
              [
                48.8942899,
                37.1650799
              ],
              [
                48.8943926,
                37.1651758
              ],
              [
                48.8947465,
                37.1651983
              ],
              [
                48.8950084,
                37.1653112
              ],
              [
                48.8964205,
                37.1658329
              ],
              [
                48.8968983,
                37.1661037
              ],
              [
                48.8971355,
                37.1661516
              ],
              [
                48.8973301,
                37.1662729
              ],
              [
                48.8977513,
                37.1666649
              ],
              [
                48.8983211,
                37.1668877
              ],
              [
                48.8989404,
                37.1673503
              ],
              [
                48.8992767,
                37.1677902
              ],
              [
                48.8994961,
                37.1679002
              ],
              [
                48.9000624,
                37.1683486
              ],
              [
                48.9004128,
                37.1686758
              ],
              [
                48.9005685,
                37.1689634
              ],
              [
                48.9007348,
                37.1691298
              ],
              [
                48.9009189,
                37.1693696
              ],
              [
                48.9010994,
                37.1696967
              ],
              [
                48.9013011,
                37.16999
              ],
              [
                48.9014851,
                37.1700972
              ],
              [
                48.9018143,
                37.1701818
              ],
              [
                48.9023862,
                37.1704344
              ],
              [
                48.9024655,
                37.1704694
              ],
              [
                48.9025858,
                37.1706838
              ],
              [
                48.9025858,
                37.170963
              ],
              [
                48.9026283,
                37.1711096
              ],
              [
                48.9027876,
                37.1712196
              ],
              [
                48.9029857,
                37.1712957
              ],
              [
                48.9032087,
                37.1714283
              ],
              [
                48.9033821,
                37.1716624
              ],
              [
                48.9035166,
                37.1720233
              ],
              [
                48.9035241,
                37.1722319
              ],
              [
                48.90378,
                37.1722042
              ],
              [
                48.9040965,
                37.1722961
              ],
              [
                48.90446,
                37.1723755
              ],
              [
                48.9049484,
                37.1724742
              ],
              [
                48.9050085,
                37.1725926
              ],
              [
                48.9052209,
                37.1727082
              ],
              [
                48.9059995,
                37.1728041
              ],
              [
                48.9062402,
                37.172948
              ],
              [
                48.9070259,
                37.1730269
              ],
              [
                48.9074435,
                37.1731143
              ],
              [
                48.90767,
                37.1732892
              ],
              [
                48.9084062,
                37.173402
              ],
              [
                48.9088379,
                37.1732553
              ],
              [
                48.9091565,
                37.1732835
              ],
              [
                48.9098678,
                37.173151
              ],
              [
                48.9101935,
                37.1730185
              ],
              [
                48.9105509,
                37.1732215
              ],
              [
                48.9108588,
                37.1733033
              ],
              [
                48.9112587,
                37.1733343
              ],
              [
                48.912278,
                37.1735684
              ],
              [
                48.9131495,
                37.1736115
              ],
              [
                48.9130836,
                37.1734776
              ],
              [
                48.9128132,
                37.1731801
              ],
              [
                48.9130192,
                37.1731801
              ],
              [
                48.9135728,
                37.1732827
              ],
              [
                48.9148184,
                37.173191
              ],
              [
                48.9154463,
                37.1729495
              ],
              [
                48.9142987,
                37.1723284
              ],
              [
                48.9152081,
                37.1723974
              ],
              [
                48.9159443,
                37.171759
              ],
              [
                48.9164207,
                37.1718453
              ],
              [
                48.9163124,
                37.1712932
              ],
              [
                48.9160309,
                37.1712069
              ],
              [
                48.9151865,
                37.1713277
              ],
              [
                48.9147318,
                37.1713104
              ],
              [
                48.9162691,
                37.1703787
              ],
              [
                48.9167022,
                37.1702752
              ],
              [
                48.9176765,
                37.1706893
              ],
              [
                48.9182611,
                37.1706893
              ],
              [
                48.9181312,
                37.1710344
              ],
              [
                48.9178064,
                37.1720351
              ],
              [
                48.9180229,
                37.1727769
              ],
              [
                48.9187808,
                37.1738121
              ],
              [
                48.919517,
                37.1746748
              ],
              [
                48.9201232,
                37.1750198
              ],
              [
                48.9202965,
                37.1756236
              ],
              [
                48.9207078,
                37.1766933
              ],
              [
                48.9208613,
                37.1770978
              ],
              [
                48.9214217,
                37.1800122
              ],
              [
                48.9211451,
                37.1802912
              ],
              [
                48.920865,
                37.181677
              ],
              [
                48.9205884,
                37.1833418
              ],
              [
                48.9203115,
                37.1852855
              ],
              [
                48.901422,
                37.2150075
              ],
              [
                48.8994749,
                37.2183459
              ],
              [
                48.8953085,
                37.2255624
              ],
              [
                48.8777775,
                37.2519893
              ],
              [
                48.8755566,
                37.2548425
              ],
              [
                48.8737964,
                37.261553
              ],
              [
                48.8731097,
                37.267974
              ],
              [
                48.8696765,
                37.2747359
              ],
              [
                48.8756847,
                37.2861409
              ],
              [
                48.8751944,
                37.2929557
              ],
              [
                48.8714789,
                37.2969981
              ],
              [
                48.8654707,
                37.3008216
              ],
              [
                48.8477896,
                37.3072392
              ],
              [
                48.8433264,
                37.3107892
              ],
              [
                48.8266752,
                37.3330407
              ],
              [
                48.8112257,
                37.3505096
              ],
              [
                48.8139156,
                37.3805738
              ],
              [
                48.8097487,
                37.3839023
              ],
              [
                48.8003024,
                37.3916839
              ],
              [
                48.8000253,
                37.3919627
              ],
              [
                48.7668746,
                37.4205747
              ],
              [
                48.7640189,
                37.4240256
              ],
              [
                48.7570134,
                37.429946
              ],
              [
                48.7481402,
                37.4364985
              ],
              [
                48.7414126,
                37.4450183
              ],
              [
                48.7359667,
                37.450833
              ],
              [
                48.7318804,
                37.4570545
              ],
              [
                48.7152994,
                37.4741889
              ],
              [
                48.6896893,
                37.5099985
              ],
              [
                48.6944958,
                37.5317825
              ],
              [
                48.6858466,
                37.5536964
              ],
              [
                48.6850134,
                37.5553592
              ],
              [
                48.6841799,
                37.5561951
              ],
              [
                48.6827934,
                37.5589724
              ],
              [
                48.6825133,
                37.5597993
              ],
              [
                48.6761296,
                37.5691845
              ],
              [
                48.6826028,
                37.5746668
              ],
              [
                48.682883,
                37.5752155
              ],
              [
                48.6839928,
                37.5754942
              ],
              [
                48.6839928,
                37.575773
              ],
              [
                48.6848263,
                37.575773
              ],
              [
                48.6867693,
                37.5766093
              ],
              [
                48.6884361,
                37.5863307
              ],
              [
                48.6848262,
                37.5963305
              ],
              [
                48.6848263,
                37.5966093
              ],
              [
                48.6826028,
                37.5996668
              ],
              [
                48.6809359,
                37.6010516
              ],
              [
                48.6386302,
                37.6197435
              ],
              [
                48.6377965,
                37.6205798
              ],
              [
                48.6369632,
                37.6208585
              ],
              [
                48.6252935,
                37.6330795
              ],
              [
                48.6164069,
                37.6464152
              ],
              [
                48.615017,
                37.6480788
              ],
              [
                48.6144599,
                37.6491938
              ],
              [
                48.6139032,
                37.6497423
              ],
              [
                48.6122369,
                37.6519724
              ],
              [
                48.6097368,
                37.6594719
              ],
              [
                48.6097368,
                37.662799
              ],
              [
                48.6100168,
                37.6714133
              ],
              [
                48.6097367,
                37.6716921
              ],
              [
                48.6097367,
                37.6722406
              ],
              [
                48.6097367,
                37.6725193
              ],
              [
                48.6069601,
                37.678355
              ],
              [
                48.6058502,
                37.6800275
              ],
              [
                48.5997369,
                37.6853057
              ],
              [
                48.5966801,
                37.6880751
              ],
              [
                48.5958469,
                37.6905837
              ],
              [
                48.5961269,
                37.6908535
              ],
              [
                48.5958468,
                37.691411
              ],
              [
                48.5975134,
                37.6944682
              ],
              [
                48.5991836,
                37.6983525
              ],
              [
                48.59835,
                37.6994675
              ],
              [
                48.59835,
                37.6997462
              ],
              [
                48.59807,
                37.7005825
              ],
              [
                48.59807,
                37.7014186
              ],
              [
                48.5991837,
                37.7030821
              ],
              [
                48.6047364,
                37.7055817
              ],
              [
                48.6055701,
                37.7055818
              ],
              [
                48.60696,
                37.7047455
              ],
              [
                48.6083498,
                37.7047455
              ],
              [
                48.6108499,
                37.7055818
              ],
              [
                48.6316749,
                37.7185589
              ],
              [
                48.6330412,
                37.7378699
              ],
              [
                48.6340712,
                37.7498152
              ],
              [
                48.6438559,
                37.7635228
              ],
              [
                48.6442319,
                37.7750664
              ],
              [
                48.6410506,
                37.7779619
              ],
              [
                48.6333926,
                37.7787375
              ],
              [
                48.627501,
                37.7808977
              ],
              [
                48.6228054,
                37.783965
              ],
              [
                48.618123,
                37.78936
              ],
              [
                48.6158328,
                37.7889383
              ],
              [
                48.6094397,
                37.7835795
              ],
              [
                48.601101,
                37.7789593
              ],
              [
                48.5917757,
                37.7813026
              ],
              [
                48.5788905,
                37.7900884
              ],
              [
                48.5677554,
                37.8030093
              ],
              [
                48.5623169,
                37.8128693
              ],
              [
                48.5632099,
                37.8199981
              ],
              [
                48.5661733,
                37.8258146
              ],
              [
                48.5702311,
                37.8316334
              ],
              [
                48.5722921,
                37.8353266
              ],
              [
                48.5729359,
                37.8418889
              ],
              [
                48.5695708,
                37.8478445
              ],
              [
                48.5674486,
                37.8493404
              ],
              [
                48.5290333,
                37.856771
              ],
              [
                48.5282002,
                37.8570499
              ],
              [
                48.5248669,
                37.8584433
              ],
              [
                48.5207003,
                37.8595492
              ],
              [
                48.5190336,
                37.8595493
              ],
              [
                48.5190336,
                37.8592705
              ],
              [
                48.5179238,
                37.8592704
              ],
              [
                48.5176436,
                37.8589918
              ],
              [
                48.5120905,
                37.8581646
              ],
              [
                48.4915338,
                37.8448313
              ],
              [
                48.4912541,
                37.8445524
              ],
              [
                48.4862872,
                37.8320171
              ],
              [
                48.4754542,
                37.8136753
              ],
              [
                48.4562179,
                37.8063298
              ],
              [
                48.4542744,
                37.8035607
              ],
              [
                48.4534413,
                37.8027245
              ],
              [
                48.4381613,
                37.7813348
              ],
              [
                48.4378847,
                37.7799412
              ],
              [
                48.4374428,
                37.7764113
              ],
              [
                48.4374429,
                37.7761326
              ],
              [
                48.4389601,
                37.7744445
              ],
              [
                48.4389602,
                37.773887
              ],
              [
                48.4397938,
                37.7716664
              ],
              [
                48.4400704,
                37.7713876
              ],
              [
                48.4452463,
                37.7505401
              ],
              [
                48.4455264,
                37.7485892
              ],
              [
                48.4455264,
                37.7477621
              ],
              [
                48.4458033,
                37.735256
              ],
              [
                48.444815,
                37.724176
              ],
              [
                48.4448151,
                37.7202827
              ],
              [
                48.4459249,
                37.7141772
              ],
              [
                48.4462014,
                37.7119472
              ],
              [
                48.4473746,
                37.7041329
              ],
              [
                48.4479101,
                37.6671573
              ],
              [
                48.4457435,
                37.6622462
              ],
              [
                48.4445863,
                37.6582282
              ],
              [
                48.4429419,
                37.6561742
              ],
              [
                48.4387351,
                37.655146
              ],
              [
                48.4330506,
                37.6549059
              ],
              [
                48.4287815,
                37.6546625
              ],
              [
                48.4156451,
                37.6521505
              ],
              [
                48.3998032,
                37.6503545
              ],
              [
                48.3981208,
                37.6501198
              ],
              [
                48.3975641,
                37.6501199
              ],
              [
                48.3937417,
                37.6491854
              ],
              [
                48.3928406,
                37.6490046
              ],
              [
                48.3906206,
                37.648456
              ],
              [
                48.3892307,
                37.648456
              ],
              [
                48.386174,
                37.6478984
              ],
              [
                48.3766726,
                37.6586351
              ],
              [
                48.3758393,
                37.6589139
              ],
              [
                48.3738924,
                37.6589139
              ],
              [
                48.3733393,
                37.6591926
              ],
              [
                48.3686162,
                37.6591926
              ],
              [
                48.3683361,
                37.6594714
              ],
              [
                48.3663927,
                37.6594714
              ],
              [
                48.3655595,
                37.6591926
              ],
              [
                48.3652829,
                37.6594714
              ],
              [
                48.3647263,
                37.6594714
              ],
              [
                48.3638926,
                37.6591926
              ],
              [
                48.3608359,
                37.6591926
              ],
              [
                48.3600027,
                37.6594714
              ],
              [
                48.344446,
                37.6605774
              ],
              [
                48.3444461,
                37.6608561
              ],
              [
                48.3430597,
                37.6608561
              ],
              [
                48.342503,
                37.6611349
              ],
              [
                48.3413929,
                37.6611349
              ],
              [
                48.3408362,
                37.6614136
              ],
              [
                48.3397265,
                37.6614136
              ],
              [
                48.3391697,
                37.6616924
              ],
              [
                48.3383362,
                37.6616923
              ],
              [
                48.3380597,
                37.6619711
              ],
              [
                48.3363931,
                37.6619711
              ],
              [
                48.3358365,
                37.6622499
              ],
              [
                48.3288899,
                37.6647407
              ],
              [
                48.3288898,
                37.6627983
              ],
              [
                48.3291699,
                37.6625197
              ],
              [
                48.3269465,
                37.6475207
              ],
              [
                48.31389,
                37.6216852
              ],
              [
                48.3125002,
                37.6150216
              ],
              [
                48.3125002,
                37.6144641
              ],
              [
                48.3108334,
                37.6080791
              ],
              [
                48.3108334,
                37.6039155
              ],
              [
                48.3113901,
                37.6025216
              ],
              [
                48.3075002,
                37.5755781
              ],
              [
                48.3075002,
                37.5750205
              ],
              [
                48.3066669,
                37.5736266
              ],
              [
                48.306667,
                37.5727991
              ],
              [
                48.2952771,
                37.5269583
              ],
              [
                48.2941673,
                37.5194662
              ],
              [
                48.2941673,
                37.5191874
              ],
              [
                48.2933341,
                37.516687
              ],
              [
                48.2930572,
                37.5153019
              ],
              [
                48.2922239,
                37.5036273
              ],
              [
                48.2919439,
                37.4916334
              ],
              [
                48.2919439,
                37.491125
              ],
              [
                48.2916673,
                37.4908552
              ],
              [
                48.2916912,
                37.486739
              ],
              [
                48.2902202,
                37.4872605
              ],
              [
                48.2830056,
                37.4877372
              ],
              [
                48.2742083,
                37.4869877
              ],
              [
                48.2619389,
                37.4834336
              ],
              [
                48.2498363,
                37.4760153
              ],
              [
                48.2499531,
                37.4668191
              ],
              [
                48.2502557,
                37.4595018
              ],
              [
                48.2433988,
                37.4582375
              ],
              [
                48.23717,
                37.4582968
              ],
              [
                48.2321116,
                37.4617545
              ],
              [
                48.2298631,
                37.464883
              ],
              [
                48.2244014,
                37.4645037
              ],
              [
                48.2228564,
                37.462528
              ],
              [
                48.2203673,
                37.4613016
              ],
              [
                48.2169341,
                37.4610291
              ],
              [
                48.2122134,
                37.4619148
              ],
              [
                48.2101535,
                37.4607566
              ],
              [
                48.2074069,
                37.4588489
              ],
              [
                48.2028579,
                37.4525806
              ],
              [
                48.2015704,
                37.4525806
              ],
              [
                48.1867217,
                37.452308
              ],
              [
                48.1844043,
                37.4550335
              ],
              [
                48.1795119,
                37.4574182
              ],
              [
                48.1777095,
                37.456805
              ],
              [
                48.1658649,
                37.4561236
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555076,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سرعین",
          "name:en": "Sareyn County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2403052",
          "wikipedia": "en:Sareyn County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.7852498,
                38.2525367
              ],
              [
                47.7858068,
                38.2525367
              ],
              [
                47.7874733,
                38.2514228
              ],
              [
                47.7974732,
                38.2319834
              ],
              [
                47.7985865,
                38.2264226
              ],
              [
                47.7988635,
                38.2247607
              ],
              [
                47.79914,
                38.2239252
              ],
              [
                47.7991401,
                38.2233683
              ],
              [
                47.7999733,
                38.2200354
              ],
              [
                47.8033066,
                38.2116987
              ],
              [
                47.8041398,
                38.2105937
              ],
              [
                47.8083099,
                38.2025353
              ],
              [
                47.8088634,
                38.2022568
              ],
              [
                47.80942,
                38.2011429
              ],
              [
                47.8146964,
                38.1969833
              ],
              [
                47.8266431,
                38.1892033
              ],
              [
                47.8291432,
                38.1914223
              ],
              [
                47.8333097,
                38.1936504
              ],
              [
                47.8419197,
                38.1955909
              ],
              [
                47.8471995,
                38.1955909
              ],
              [
                47.8483097,
                38.1953124
              ],
              [
                47.8502562,
                38.1953124
              ],
              [
                47.8505328,
                38.1950339
              ],
              [
                47.8513664,
                38.1950339
              ],
              [
                47.8599759,
                38.1930934
              ],
              [
                47.860533,
                38.1925364
              ],
              [
                47.8610896,
                38.1925364
              ],
              [
                47.8708129,
                38.1889249
              ],
              [
                47.8794225,
                38.1836422
              ],
              [
                47.8808128,
                38.1822587
              ],
              [
                47.8897025,
                38.1739214
              ],
              [
                47.8905361,
                38.1725379
              ],
              [
                47.8919224,
                38.1708668
              ],
              [
                47.9022024,
                38.1619813
              ],
              [
                47.9210923,
                38.1555934
              ],
              [
                47.9224821,
                38.1555933
              ],
              [
                47.9430389,
                38.1508675
              ],
              [
                47.9485922,
                38.1480913
              ],
              [
                47.9505388,
                38.1472557
              ],
              [
                47.9519254,
                38.1466987
              ],
              [
                47.9544251,
                38.1466986
              ],
              [
                47.9549821,
                38.1464201
              ],
              [
                47.9560955,
                38.1464202
              ],
              [
                47.9566485,
                38.1461417
              ],
              [
                47.962762,
                38.1453151
              ],
              [
                47.9758187,
                38.1405891
              ],
              [
                47.9992188,
                38.125888
              ],
              [
                47.9995785,
                38.1230865
              ],
              [
                47.9999848,
                38.122817
              ],
              [
                48.0033181,
                38.1219814
              ],
              [
                47.9933186,
                38.1157274
              ],
              [
                48.0007607,
                38.115221
              ],
              [
                48.0151994,
                38.1147735
              ],
              [
                48.0220407,
                38.114365
              ],
              [
                48.0330139,
                38.1126459
              ],
              [
                48.0594311,
                38.1047569
              ],
              [
                48.060821,
                38.1047569
              ],
              [
                48.0613777,
                38.1044783
              ],
              [
                48.0627644,
                38.1044784
              ],
              [
                48.0683208,
                38.1036427
              ],
              [
                48.0702677,
                38.1036427
              ],
              [
                48.0758209,
                38.1028071
              ],
              [
                48.0791542,
                38.1025375
              ],
              [
                48.0836009,
                38.1025376
              ],
              [
                48.0847106,
                38.102259
              ],
              [
                48.0863774,
                38.102259
              ],
              [
                48.095544,
                38.1008663
              ],
              [
                48.0983242,
                38.1008663
              ],
              [
                48.0991575,
                38.1005878
              ],
              [
                48.1024907,
                38.1005878
              ],
              [
                48.1030438,
                38.1008663
              ],
              [
                48.1049908,
                38.1008663
              ],
              [
                48.1055439,
                38.1011449
              ],
              [
                48.1063772,
                38.1011448
              ],
              [
                48.1116573,
                38.1022591
              ],
              [
                48.1211005,
                38.1058712
              ],
              [
                48.1236006,
                38.1072549
              ],
              [
                48.1483269,
                38.1189178
              ],
              [
                48.1491601,
                38.1189178
              ],
              [
                48.1497426,
                38.1192464
              ],
              [
                48.1536035,
                38.1214247
              ],
              [
                48.1544367,
                38.1222513
              ],
              [
                48.1549933,
                38.1366991
              ],
              [
                48.1547132,
                38.1372562
              ],
              [
                48.1544367,
                38.1400324
              ],
              [
                48.1544367,
                38.1411466
              ],
              [
                48.1530468,
                38.1436443
              ],
              [
                48.1483268,
                38.1483702
              ],
              [
                48.1402699,
                38.151425
              ],
              [
                48.1397132,
                38.151425
              ],
              [
                48.1394367,
                38.1517035
              ],
              [
                48.1386035,
                38.1517035
              ],
              [
                48.1322134,
                38.157256
              ],
              [
                48.1288801,
                38.1653149
              ],
              [
                48.1288801,
                38.1666985
              ],
              [
                48.1294368,
                38.1669771
              ],
              [
                48.1297133,
                38.1675341
              ],
              [
                48.1441565,
                38.1755931
              ],
              [
                48.1449934,
                38.175593
              ],
              [
                48.1558264,
                38.1803187
              ],
              [
                48.1566596,
                38.1808668
              ],
              [
                48.1744362,
                38.1930941
              ],
              [
                48.2211055,
                38.216982
              ],
              [
                48.2213856,
                38.2172605
              ],
              [
                48.2361054,
                38.2292084
              ],
              [
                48.2413856,
                38.2355956
              ],
              [
                48.2432302,
                38.2381439
              ],
              [
                48.2474152,
                38.2457803
              ],
              [
                48.2470379,
                38.2543524
              ],
              [
                48.247188,
                38.2552158
              ],
              [
                48.2474954,
                38.2569843
              ],
              [
                48.2483286,
                38.2589245
              ],
              [
                48.248633,
                38.2595336
              ],
              [
                48.2477751,
                38.2600385
              ],
              [
                48.2466618,
                38.2600385
              ],
              [
                48.2458285,
                38.25976
              ],
              [
                48.2372185,
                38.25976
              ],
              [
                48.2244386,
                38.2628141
              ],
              [
                48.2205521,
                38.2628141
              ],
              [
                48.2199955,
                38.2628141
              ],
              [
                48.2199955,
                38.2578196
              ],
              [
                48.2199956,
                38.2572627
              ],
              [
                48.2197155,
                38.2558703
              ],
              [
                48.2163823,
                38.2508669
              ],
              [
                48.2144388,
                38.2497619
              ],
              [
                48.2141623,
                38.2494834
              ],
              [
                48.2127724,
                38.2494835
              ],
              [
                48.2124958,
                38.249205
              ],
              [
                48.2113821,
                38.249205
              ],
              [
                48.2111055,
                38.2489265
              ],
              [
                48.2088824,
                38.2489265
              ],
              [
                48.2083289,
                38.249205
              ],
              [
                48.2058292,
                38.2492049
              ],
              [
                48.1977724,
                38.2508668
              ],
              [
                48.1974923,
                38.2511453
              ],
              [
                48.1955493,
                38.2511453
              ],
              [
                48.1949923,
                38.2514238
              ],
              [
                48.1924927,
                38.2514238
              ],
              [
                48.1919391,
                38.2511453
              ],
              [
                48.1905493,
                38.2511452
              ],
              [
                48.1897159,
                38.2508668
              ],
              [
                48.1874924,
                38.2505974
              ],
              [
                48.1863827,
                38.2503188
              ],
              [
                48.1847159,
                38.2503188
              ],
              [
                48.1838827,
                38.2500403
              ],
              [
                48.1819357,
                38.2500403
              ],
              [
                48.1797161,
                38.2494834
              ],
              [
                48.1783259,
                38.2494834
              ],
              [
                48.1774927,
                38.2492049
              ],
              [
                48.1761028,
                38.2492049
              ],
              [
                48.1324897,
                38.2353169
              ],
              [
                48.1305467,
                38.2353169
              ],
              [
                48.1299897,
                38.2350384
              ],
              [
                48.1230466,
                38.2350384
              ],
              [
                48.1208235,
                38.2350384
              ],
              [
                48.1169331,
                38.2350384
              ],
              [
                48.1166566,
                38.2347599
              ],
              [
                48.1119335,
                38.2347598
              ],
              [
                48.1113803,
                38.2344814
              ],
              [
                48.1086001,
                38.2344814
              ],
              [
                48.0938767,
                38.2322625
              ],
              [
                48.092767,
                38.231984
              ],
              [
                48.0916569,
                38.231984
              ],
              [
                48.0913772,
                38.2317054
              ],
              [
                48.0899904,
                38.2317055
              ],
              [
                48.0894337,
                38.2314271
              ],
              [
                48.0855438,
                38.231427
              ],
              [
                48.0647104,
                38.2392065
              ],
              [
                48.0635971,
                38.2392064
              ],
              [
                48.063044,
                38.2394849
              ],
              [
                48.0624873,
                38.2394849
              ],
              [
                48.0622105,
                38.2397634
              ],
              [
                48.060544,
                38.2397634
              ],
              [
                48.0597107,
                38.2400419
              ],
              [
                48.058597,
                38.2400418
              ],
              [
                48.0577638,
                38.2403114
              ],
              [
                48.0563775,
                38.2405898
              ],
              [
                48.0102611,
                38.25587
              ],
              [
                48.0093039,
                38.2568286
              ],
              [
                47.9994276,
                38.2655893
              ],
              [
                47.9966511,
                38.2655893
              ],
              [
                47.9877614,
                38.2653197
              ],
              [
                47.9788714,
                38.2653198
              ],
              [
                47.9777611,
                38.2650413
              ],
              [
                47.9760947,
                38.2650413
              ],
              [
                47.9749814,
                38.2647628
              ],
              [
                47.973038,
                38.2647628
              ],
              [
                47.9722048,
                38.2644843
              ],
              [
                47.9702613,
                38.2644844
              ],
              [
                47.9699812,
                38.2642059
              ],
              [
                47.9683148,
                38.2642059
              ],
              [
                47.9677613,
                38.2639274
              ],
              [
                47.9660949,
                38.2639274
              ],
              [
                47.9647051,
                38.2636489
              ],
              [
                47.9622049,
                38.2636489
              ],
              [
                47.9619284,
                38.2633704
              ],
              [
                47.9610947,
                38.2633704
              ],
              [
                47.9605381,
                38.263092
              ],
              [
                47.9594284,
                38.263092
              ],
              [
                47.9588716,
                38.2625351
              ],
              [
                47.9574814,
                38.2625351
              ],
              [
                47.9369252,
                38.2555913
              ],
              [
                47.9363685,
                38.2550343
              ],
              [
                47.9352582,
                38.2547559
              ],
              [
                47.9338684,
                38.2536509
              ],
              [
                47.9310918,
                38.2519801
              ],
              [
                47.9258184,
                38.2469855
              ],
              [
                47.9255354,
                38.2467071
              ],
              [
                47.9216487,
                38.2436528
              ],
              [
                47.9163689,
                38.2436528
              ],
              [
                47.9158122,
                38.2433653
              ],
              [
                47.9141453,
                38.2436528
              ],
              [
                47.8596991,
                38.2600376
              ],
              [
                47.8555326,
                38.2617084
              ],
              [
                47.8510891,
                38.2630918
              ],
              [
                47.8385684,
                38.2666286
              ],
              [
                47.8377529,
                38.2664243
              ],
              [
                47.836086,
                38.2664243
              ],
              [
                47.8319196,
                38.2655889
              ],
              [
                47.8266429,
                38.2647625
              ],
              [
                47.8246994,
                38.2647625
              ],
              [
                47.8146961,
                38.2622563
              ],
              [
                47.8133098,
                38.2622563
              ],
              [
                47.8121965,
                38.2619778
              ],
              [
                47.8099765,
                38.2617083
              ],
              [
                47.79914,
                38.2617083
              ],
              [
                47.7985864,
                38.2614298
              ],
              [
                47.79692,
                38.2614298
              ],
              [
                47.7852498,
                38.2525367
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555180,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوثر",
          "name:en": "Kosar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277783"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.031067,
                37.6662269
              ],
              [
                48.0308195,
                37.6658551
              ],
              [
                48.0288761,
                37.6630765
              ],
              [
                48.028043,
                37.661413
              ],
              [
                48.0277664,
                37.6611342
              ],
              [
                48.0255429,
                37.654462
              ],
              [
                48.0224862,
                37.6414052
              ],
              [
                48.0199866,
                37.6258572
              ],
              [
                48.0188765,
                37.6180785
              ],
              [
                48.0191531,
                37.6166847
              ],
              [
                48.0216532,
                37.6122422
              ],
              [
                48.0227664,
                37.6119634
              ],
              [
                48.0236001,
                37.6111361
              ],
              [
                48.0241532,
                37.6108573
              ],
              [
                48.0427665,
                37.6025209
              ],
              [
                48.0435997,
                37.602521
              ],
              [
                48.0480428,
                37.601127
              ],
              [
                48.0491561,
                37.6011271
              ],
              [
                48.0494331,
                37.6008483
              ],
              [
                48.055266,
                37.5991847
              ],
              [
                48.0563797,
                37.5991846
              ],
              [
                48.0580384,
                37.598574
              ],
              [
                48.0669327,
                37.5952996
              ],
              [
                48.0677658,
                37.5950208
              ],
              [
                48.0716558,
                37.5930784
              ],
              [
                48.0747125,
                37.5902995
              ],
              [
                48.0785807,
                37.5830407
              ],
              [
                48.0811175,
                37.5711937
              ],
              [
                48.0811348,
                37.557525
              ],
              [
                48.0793109,
                37.5474403
              ],
              [
                48.0795458,
                37.5361742
              ],
              [
                48.0782717,
                37.527789
              ],
              [
                48.0773305,
                37.5196657
              ],
              [
                48.078146,
                37.5133683
              ],
              [
                48.0816114,
                37.5111641
              ],
              [
                48.0836069,
                37.5107216
              ],
              [
                48.0842507,
                37.5097259
              ],
              [
                48.0832636,
                37.5080067
              ],
              [
                48.084079,
                37.5058023
              ],
              [
                48.0855274,
                37.5053427
              ],
              [
                48.0882311,
                37.5069513
              ],
              [
                48.0900979,
                37.5073258
              ],
              [
                48.0917501,
                37.5063385
              ],
              [
                48.093574,
                37.5042618
              ],
              [
                48.0960846,
                37.5031383
              ],
              [
                48.1015456,
                37.5037001
              ],
              [
                48.1029081,
                37.5031128
              ],
              [
                48.1031871,
                37.4980824
              ],
              [
                48.1060409,
                37.4963119
              ],
              [
                48.1120276,
                37.4874757
              ],
              [
                48.1153106,
                37.4862839
              ],
              [
                48.1176495,
                37.4867776
              ],
              [
                48.1221556,
                37.4883611
              ],
              [
                48.1244302,
                37.4884462
              ],
              [
                48.1293225,
                37.4840533
              ],
              [
                48.1340217,
                37.4812779
              ],
              [
                48.1432056,
                37.4804946
              ],
              [
                48.1499004,
                37.4791493
              ],
              [
                48.1558442,
                37.477123
              ],
              [
                48.160758,
                37.4734957
              ],
              [
                48.1638694,
                37.4695448
              ],
              [
                48.1656074,
                37.4652871
              ],
              [
                48.1663799,
                37.4614379
              ],
              [
                48.1658649,
                37.4561236
              ],
              [
                48.1777095,
                37.456805
              ],
              [
                48.1795119,
                37.4574182
              ],
              [
                48.1844043,
                37.4550335
              ],
              [
                48.1867217,
                37.452308
              ],
              [
                48.2015704,
                37.4525806
              ],
              [
                48.2028579,
                37.4525806
              ],
              [
                48.2074069,
                37.4588489
              ],
              [
                48.2101535,
                37.4607566
              ],
              [
                48.2122134,
                37.4619148
              ],
              [
                48.2169341,
                37.4610291
              ],
              [
                48.2203673,
                37.4613016
              ],
              [
                48.2228564,
                37.462528
              ],
              [
                48.2244014,
                37.4645037
              ],
              [
                48.2298631,
                37.464883
              ],
              [
                48.2321116,
                37.4617545
              ],
              [
                48.23717,
                37.4582968
              ],
              [
                48.2433988,
                37.4582375
              ],
              [
                48.2502557,
                37.4595018
              ],
              [
                48.2499531,
                37.4668191
              ],
              [
                48.2498363,
                37.4760153
              ],
              [
                48.2619389,
                37.4834336
              ],
              [
                48.2742083,
                37.4869877
              ],
              [
                48.2830056,
                37.4877372
              ],
              [
                48.2902202,
                37.4872605
              ],
              [
                48.2916912,
                37.486739
              ],
              [
                48.2916673,
                37.4908552
              ],
              [
                48.2919439,
                37.491125
              ],
              [
                48.2919439,
                37.4916334
              ],
              [
                48.2922239,
                37.5036273
              ],
              [
                48.2930572,
                37.5153019
              ],
              [
                48.2933341,
                37.516687
              ],
              [
                48.2941673,
                37.5191874
              ],
              [
                48.2941673,
                37.5194662
              ],
              [
                48.2952771,
                37.5269583
              ],
              [
                48.306667,
                37.5727991
              ],
              [
                48.3066669,
                37.5736266
              ],
              [
                48.3075002,
                37.5750205
              ],
              [
                48.3075002,
                37.5755781
              ],
              [
                48.3113901,
                37.6025216
              ],
              [
                48.3108334,
                37.6039155
              ],
              [
                48.3108334,
                37.6080791
              ],
              [
                48.3125002,
                37.6144641
              ],
              [
                48.3125002,
                37.6150216
              ],
              [
                48.31389,
                37.6216852
              ],
              [
                48.3269465,
                37.6475207
              ],
              [
                48.3291699,
                37.6625197
              ],
              [
                48.3288898,
                37.6627983
              ],
              [
                48.3288899,
                37.6647407
              ],
              [
                48.3358365,
                37.6622499
              ],
              [
                48.3363931,
                37.6619711
              ],
              [
                48.3380597,
                37.6619711
              ],
              [
                48.3383362,
                37.6616923
              ],
              [
                48.3391697,
                37.6616924
              ],
              [
                48.3397265,
                37.6614136
              ],
              [
                48.3408362,
                37.6614136
              ],
              [
                48.3413929,
                37.6611349
              ],
              [
                48.342503,
                37.6611349
              ],
              [
                48.3430597,
                37.6608561
              ],
              [
                48.3444461,
                37.6608561
              ],
              [
                48.344446,
                37.6605774
              ],
              [
                48.3600027,
                37.6594714
              ],
              [
                48.3608359,
                37.6591926
              ],
              [
                48.3638926,
                37.6591926
              ],
              [
                48.3647263,
                37.6594714
              ],
              [
                48.3652829,
                37.6594714
              ],
              [
                48.3655595,
                37.6591926
              ],
              [
                48.3663927,
                37.6594714
              ],
              [
                48.3683361,
                37.6594714
              ],
              [
                48.3686162,
                37.6591926
              ],
              [
                48.3733393,
                37.6591926
              ],
              [
                48.3738924,
                37.6589139
              ],
              [
                48.3758393,
                37.6589139
              ],
              [
                48.3766726,
                37.6586351
              ],
              [
                48.386174,
                37.6478984
              ],
              [
                48.3892307,
                37.648456
              ],
              [
                48.3906206,
                37.648456
              ],
              [
                48.3928406,
                37.6490046
              ],
              [
                48.3937417,
                37.6491854
              ],
              [
                48.3975641,
                37.6501199
              ],
              [
                48.3981208,
                37.6501198
              ],
              [
                48.3998032,
                37.6503545
              ],
              [
                48.4156451,
                37.6521505
              ],
              [
                48.4287815,
                37.6546625
              ],
              [
                48.4330506,
                37.6549059
              ],
              [
                48.4387351,
                37.655146
              ],
              [
                48.4429419,
                37.6561742
              ],
              [
                48.4445863,
                37.6582282
              ],
              [
                48.4457435,
                37.6622462
              ],
              [
                48.4479101,
                37.6671573
              ],
              [
                48.4473746,
                37.7041329
              ],
              [
                48.4462014,
                37.7119472
              ],
              [
                48.4459249,
                37.7141772
              ],
              [
                48.4448151,
                37.7202827
              ],
              [
                48.444815,
                37.724176
              ],
              [
                48.4458033,
                37.735256
              ],
              [
                48.4455264,
                37.7477621
              ],
              [
                48.4455264,
                37.7485892
              ],
              [
                48.4452463,
                37.7505401
              ],
              [
                48.4400704,
                37.7713876
              ],
              [
                48.4397938,
                37.7716664
              ],
              [
                48.4389602,
                37.773887
              ],
              [
                48.4389601,
                37.7744445
              ],
              [
                48.4374429,
                37.7761326
              ],
              [
                48.4374428,
                37.7764113
              ],
              [
                48.4378847,
                37.7799412
              ],
              [
                48.4381613,
                37.7813348
              ],
              [
                48.4534413,
                37.8027245
              ],
              [
                48.4542744,
                37.8035607
              ],
              [
                48.4562179,
                37.8063298
              ],
              [
                48.4754542,
                37.8136753
              ],
              [
                48.4862872,
                37.8320171
              ],
              [
                48.4912541,
                37.8445524
              ],
              [
                48.4915338,
                37.8448313
              ],
              [
                48.5120905,
                37.8581646
              ],
              [
                48.5176436,
                37.8589918
              ],
              [
                48.5179238,
                37.8592704
              ],
              [
                48.5190336,
                37.8592705
              ],
              [
                48.5190336,
                37.8595493
              ],
              [
                48.5207003,
                37.8595492
              ],
              [
                48.5248669,
                37.8584433
              ],
              [
                48.5282002,
                37.8570499
              ],
              [
                48.5290333,
                37.856771
              ],
              [
                48.5674486,
                37.8493404
              ],
              [
                48.5641569,
                37.8518474
              ],
              [
                48.5590179,
                37.8585879
              ],
              [
                48.5587222,
                37.8708663
              ],
              [
                48.5581967,
                37.8764119
              ],
              [
                48.5592594,
                37.8830233
              ],
              [
                48.5610427,
                37.8877656
              ],
              [
                48.5611475,
                37.8960446
              ],
              [
                48.5602139,
                37.8994768
              ],
              [
                48.5584868,
                37.9015366
              ],
              [
                48.5553646,
                37.902626
              ],
              [
                48.5527467,
                37.9025921
              ],
              [
                48.5464811,
                37.9000863
              ],
              [
                48.5460519,
                37.8999847
              ],
              [
                48.5414171,
                37.8973771
              ],
              [
                48.5387563,
                37.8979867
              ],
              [
                48.5361814,
                37.9033371
              ],
              [
                48.5375118,
                37.9127502
              ],
              [
                48.5428762,
                37.9187767
              ],
              [
                48.5512018,
                37.9247688
              ],
              [
                48.5532617,
                37.9300835
              ],
              [
                48.5631752,
                37.9332653
              ],
              [
                48.5778093,
                37.9349238
              ],
              [
                48.5817749,
                37.9365559
              ],
              [
                48.567542,
                37.9371238
              ],
              [
                48.5503519,
                37.9369498
              ],
              [
                48.5181905,
                37.9372442
              ],
              [
                48.4988656,
                37.937214
              ],
              [
                48.4925365,
                37.9400685
              ],
              [
                48.4832867,
                37.9407858
              ],
              [
                48.4747538,
                37.9403119
              ],
              [
                48.461173,
                37.9347532
              ],
              [
                48.4478753,
                37.929879
              ],
              [
                48.4329951,
                37.9237905
              ],
              [
                48.4219328,
                37.9237094
              ],
              [
                48.4164837,
                37.9279827
              ],
              [
                48.4074546,
                37.9357003
              ],
              [
                48.4014371,
                37.9418058
              ],
              [
                48.3876327,
                37.949871
              ],
              [
                48.3747059,
                37.9531515
              ],
              [
                48.3584849,
                37.9508374
              ],
              [
                48.341718,
                37.9479947
              ],
              [
                48.3458354,
                37.9344779
              ],
              [
                48.3425022,
                37.9291929
              ],
              [
                48.3400021,
                37.9266942
              ],
              [
                48.3397256,
                37.926137
              ],
              [
                48.335279,
                37.9205822
              ],
              [
                48.3297222,
                37.9142005
              ],
              [
                48.3294457,
                37.9136432
              ],
              [
                48.3283355,
                37.9119715
              ],
              [
                48.3244455,
                37.9041965
              ],
              [
                48.3272222,
                37.8953068
              ],
              [
                48.3269457,
                37.8933564
              ],
              [
                48.319169,
                37.8803046
              ],
              [
                48.3133326,
                37.8766911
              ],
              [
                48.3124993,
                37.8761427
              ],
              [
                48.3122223,
                37.8758641
              ],
              [
                48.2788896,
                37.8575264
              ],
              [
                48.2777764,
                37.856969
              ],
              [
                48.2580533,
                37.847809
              ],
              [
                48.256663,
                37.8475303
              ],
              [
                48.2499965,
                37.8441952
              ],
              [
                48.2422202,
                37.8380824
              ],
              [
                48.2222205,
                37.8208584
              ],
              [
                48.2213869,
                37.8203009
              ],
              [
                48.2052737,
                37.8116977
              ],
              [
                48.2008272,
                37.8083624
              ],
              [
                48.1919406,
                37.8044697
              ],
              [
                48.1897175,
                37.8039123
              ],
              [
                48.187494,
                37.8039123
              ],
              [
                48.1872174,
                37.804191
              ],
              [
                48.1724941,
                37.8097468
              ],
              [
                48.152771,
                37.8097467
              ],
              [
                48.1511045,
                37.8097468
              ],
              [
                48.1511045,
                37.8094681
              ],
              [
                48.1502714,
                37.8064205
              ],
              [
                48.1494377,
                37.805863
              ],
              [
                48.148881,
                37.8053057
              ],
              [
                48.1477713,
                37.8025278
              ],
              [
                48.1480479,
                37.8011343
              ],
              [
                48.1491611,
                37.7964146
              ],
              [
                48.1494377,
                37.7961359
              ],
              [
                48.148328,
                37.7844667
              ],
              [
                48.1474947,
                37.7805828
              ],
              [
                48.1352716,
                37.7522446
              ],
              [
                48.1266582,
                37.7447462
              ],
              [
                48.1258249,
                37.7441888
              ],
              [
                48.1191584,
                37.7405835
              ],
              [
                48.1183252,
                37.7405834
              ],
              [
                48.1152684,
                37.7391898
              ],
              [
                48.1144352,
                37.7391898
              ],
              [
                48.1091586,
                37.7380839
              ],
              [
                48.1077687,
                37.7380839
              ],
              [
                48.1052686,
                37.7375265
              ],
              [
                48.1036018,
                37.7375264
              ],
              [
                48.1030451,
                37.7372477
              ],
              [
                48.1016588,
                37.7372477
              ],
              [
                48.100545,
                37.736969
              ],
              [
                48.0988786,
                37.736969
              ],
              [
                48.0983255,
                37.7366903
              ],
              [
                48.0963785,
                37.7366903
              ],
              [
                48.0952688,
                37.7364115
              ],
              [
                48.0913788,
                37.7364116
              ],
              [
                48.0902687,
                37.7361329
              ],
              [
                48.0880452,
                37.7361328
              ],
              [
                48.0874886,
                37.7358541
              ],
              [
                48.0752687,
                37.733912
              ],
              [
                48.0708221,
                37.7322487
              ],
              [
                48.0666557,
                37.7294704
              ],
              [
                48.0652658,
                37.7266921
              ],
              [
                48.0644322,
                37.7250198
              ],
              [
                48.0641556,
                37.7247411
              ],
              [
                48.063599,
                37.722799
              ],
              [
                48.063599,
                37.7205781
              ],
              [
                48.0633224,
                37.719751
              ],
              [
                48.0633224,
                37.7147428
              ],
              [
                48.0638791,
                37.7105799
              ],
              [
                48.0630459,
                37.7064078
              ],
              [
                48.0538794,
                37.6925249
              ],
              [
                48.031067,
                37.6662269
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555209,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مشگین شهر",
          "name:en": "Meshkinshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1274515"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.2871719,
                38.3044815
              ],
              [
                47.2871719,
                38.302263
              ],
              [
                47.2910619,
                38.3003138
              ],
              [
                47.3021716,
                38.296703
              ],
              [
                47.3035614,
                38.2964245
              ],
              [
                47.3046716,
                38.2964246
              ],
              [
                47.3218946,
                38.2914304
              ],
              [
                47.3235611,
                38.2905951
              ],
              [
                47.3249509,
                38.2903167
              ],
              [
                47.3510642,
                38.2755944
              ],
              [
                47.3532877,
                38.2744806
              ],
              [
                47.3532877,
                38.2742021
              ],
              [
                47.3538408,
                38.2739237
              ],
              [
                47.3577307,
                38.2694773
              ],
              [
                47.3580073,
                38.2691989
              ],
              [
                47.3577307,
                38.2661447
              ],
              [
                47.3605073,
                38.2630906
              ],
              [
                47.3749455,
                38.2519849
              ],
              [
                47.3757875,
                38.2514219
              ],
              [
                47.3777313,
                38.2503169
              ],
              [
                47.3791211,
                38.2489245
              ],
              [
                47.379954,
                38.2486461
              ],
              [
                47.3857877,
                38.2439211
              ],
              [
                47.3985677,
                38.2378125
              ],
              [
                47.4027341,
                38.2372556
              ],
              [
                47.4060671,
                38.2372556
              ],
              [
                47.4071772,
                38.2369771
              ],
              [
                47.4107906,
                38.2369771
              ],
              [
                47.4116242,
                38.2372555
              ],
              [
                47.4130102,
                38.2372556
              ],
              [
                47.4302336,
                38.2411454
              ],
              [
                47.4496802,
                38.2478108
              ],
              [
                47.4507899,
                38.2478109
              ],
              [
                47.4549568,
                38.2486463
              ],
              [
                47.4569034,
                38.2486463
              ],
              [
                47.4580136,
                38.2489248
              ],
              [
                47.4607902,
                38.2489248
              ],
              [
                47.4613468,
                38.2492032
              ],
              [
                47.4624566,
                38.2492033
              ],
              [
                47.4635698,
                38.2494817
              ],
              [
                47.4655133,
                38.2494817
              ],
              [
                47.4663465,
                38.2497602
              ],
              [
                47.4674598,
                38.2497602
              ],
              [
                47.4680134,
                38.2494817
              ],
              [
                47.4688466,
                38.2494817
              ],
              [
                47.4777366,
                38.2425378
              ],
              [
                47.4788465,
                38.2405885
              ],
              [
                47.4791266,
                38.239762
              ],
              [
                47.4794031,
                38.2378128
              ],
              [
                47.4796796,
                38.2353153
              ],
              [
                47.4799598,
                38.2342655
              ],
              [
                47.4799597,
                38.2336445
              ],
              [
                47.4802367,
                38.2322611
              ],
              [
                47.4805132,
                38.2303117
              ],
              [
                47.4807934,
                38.2300332
              ],
              [
                47.4780134,
                38.2058675
              ],
              [
                47.4746801,
                38.1947546
              ],
              [
                47.4744036,
                38.1936495
              ],
              [
                47.4741266,
                38.1925355
              ],
              [
                47.4741267,
                38.1875314
              ],
              [
                47.4744036,
                38.1861479
              ],
              [
                47.4752369,
                38.1841984
              ],
              [
                47.4760701,
                38.1841984
              ],
              [
                47.4763467,
                38.1839198
              ],
              [
                47.4827366,
                38.1819793
              ],
              [
                47.4869035,
                38.1819793
              ],
              [
                47.4880168,
                38.1825363
              ],
              [
                47.48885,
                38.1825364
              ],
              [
                47.4930165,
                38.1850339
              ],
              [
                47.5046832,
                38.1939191
              ],
              [
                47.5060731,
                38.1944761
              ],
              [
                47.5066265,
                38.1950331
              ],
              [
                47.5085731,
                38.1958687
              ],
              [
                47.5102399,
                38.1961471
              ],
              [
                47.5155161,
                38.1972611
              ],
              [
                47.517183,
                38.1972611
              ],
              [
                47.5191264,
                38.1969826
              ],
              [
                47.5207929,
                38.1964257
              ],
              [
                47.5213496,
                38.1958686
              ],
              [
                47.5266297,
                38.1925356
              ],
              [
                47.527463,
                38.1925356
              ],
              [
                47.5277395,
                38.1922571
              ],
              [
                47.529963,
                38.1917001
              ],
              [
                47.531906,
                38.1917001
              ],
              [
                47.5330162,
                38.1914216
              ],
              [
                47.5346827,
                38.1914216
              ],
              [
                47.5360729,
                38.1911431
              ],
              [
                47.5363495,
                38.1914216
              ],
              [
                47.5394063,
                38.1914216
              ],
              [
                47.5396828,
                38.1917001
              ],
              [
                47.5416293,
                38.1925356
              ],
              [
                47.5585726,
                38.2030917
              ],
              [
                47.5713525,
                38.2083652
              ],
              [
                47.5724624,
                38.2083652
              ],
              [
                47.573019,
                38.2086436
              ],
              [
                47.5738523,
                38.2086437
              ],
              [
                47.5746858,
                38.2089222
              ],
              [
                47.5757956,
                38.2089222
              ],
              [
                47.5796856,
                38.2100362
              ],
              [
                47.5807989,
                38.2100362
              ],
              [
                47.5810754,
                38.2103146
              ],
              [
                47.581909,
                38.2103147
              ],
              [
                47.5830188,
                38.2108717
              ],
              [
                47.5838521,
                38.2108716
              ],
              [
                47.5849658,
                38.2114287
              ],
              [
                47.5927421,
                38.2128122
              ],
              [
                47.5952422,
                38.2128122
              ],
              [
                47.5960753,
                38.2130907
              ],
              [
                47.5971856,
                38.2130906
              ],
              [
                47.5977422,
                38.2133691
              ],
              [
                47.5985754,
                38.2133692
              ],
              [
                47.6055221,
                38.2147617
              ],
              [
                47.6060752,
                38.2150311
              ],
              [
                47.6107988,
                38.217259
              ],
              [
                47.611632,
                38.2172591
              ],
              [
                47.6119085,
                38.2175376
              ],
              [
                47.6130218,
                38.2175375
              ],
              [
                47.6132984,
                38.2178161
              ],
              [
                47.6146887,
                38.2178161
              ],
              [
                47.6171887,
                38.2183641
              ],
              [
                47.6232986,
                38.2180946
              ],
              [
                47.6319117,
                38.2158666
              ],
              [
                47.6332984,
                38.2158666
              ],
              [
                47.6338552,
                38.2155882
              ],
              [
                47.6349649,
                38.2155882
              ],
              [
                47.6380216,
                38.2150312
              ],
              [
                47.6399682,
                38.2150312
              ],
              [
                47.6455214,
                38.2139263
              ],
              [
                47.6471882,
                38.2139263
              ],
              [
                47.6483016,
                38.2136477
              ],
              [
                47.6502449,
                38.2136478
              ],
              [
                47.6513548,
                38.2133693
              ],
              [
                47.6546916,
                38.2133693
              ],
              [
                47.6558014,
                38.2130908
              ],
              [
                47.6577448,
                38.2130909
              ],
              [
                47.6588581,
                38.2133693
              ],
              [
                47.6663582,
                38.2133693
              ],
              [
                47.6674681,
                38.2136478
              ],
              [
                47.6749678,
                38.2136478
              ],
              [
                47.6755248,
                38.2139263
              ],
              [
                47.6780245,
                38.2139263
              ],
              [
                47.685966,
                38.2155306
              ],
              [
                47.6980245,
                38.2169807
              ],
              [
                47.6985812,
                38.2169808
              ],
              [
                47.6994144,
                38.2167023
              ],
              [
                47.7013577,
                38.2167023
              ],
              [
                47.7033043,
                38.2161453
              ],
              [
                47.7044141,
                38.2161453
              ],
              [
                47.7141374,
                38.2130909
              ],
              [
                47.7166375,
                38.2116985
              ],
              [
                47.7177476,
                38.211429
              ],
              [
                47.7246942,
                38.2122555
              ],
              [
                47.736084,
                38.2233682
              ],
              [
                47.7383039,
                38.2258745
              ],
              [
                47.738584,
                38.2264225
              ],
              [
                47.740804,
                38.2289288
              ],
              [
                47.7466372,
                38.2328096
              ],
              [
                47.7483073,
                38.2333667
              ],
              [
                47.7485839,
                38.2330881
              ],
              [
                47.7488604,
                38.2333667
              ],
              [
                47.749417,
                38.2330882
              ],
              [
                47.7505272,
                38.2330882
              ],
              [
                47.7510839,
                38.2328097
              ],
              [
                47.7535839,
                38.2328096
              ],
              [
                47.7541406,
                38.2325312
              ],
              [
                47.7563606,
                38.2322617
              ],
              [
                47.7574739,
                38.2325312
              ],
              [
                47.7577504,
                38.2322617
              ],
              [
                47.7596938,
                38.2325313
              ],
              [
                47.7627502,
                38.2325312
              ],
              [
                47.7633068,
                38.2328097
              ],
              [
                47.7646935,
                38.2328097
              ],
              [
                47.7649737,
                38.2330882
              ],
              [
                47.7692257,
                38.2342306
              ],
              [
                47.7699738,
                38.2344806
              ],
              [
                47.770807,
                38.2344806
              ],
              [
                47.7710835,
                38.2347591
              ],
              [
                47.7719167,
                38.2347591
              ],
              [
                47.773307,
                38.235873
              ],
              [
                47.773307,
                38.236421
              ],
              [
                47.7777501,
                38.2436525
              ],
              [
                47.7785833,
                38.2461497
              ],
              [
                47.7805302,
                38.2505963
              ],
              [
                47.7835834,
                38.2528152
              ],
              [
                47.7844165,
                38.2528152
              ],
              [
                47.7846967,
                38.2525367
              ],
              [
                47.7852498,
                38.2525367
              ],
              [
                47.79692,
                38.2614298
              ],
              [
                47.7985864,
                38.2614298
              ],
              [
                47.79914,
                38.2617083
              ],
              [
                47.8099765,
                38.2617083
              ],
              [
                47.8121965,
                38.2619778
              ],
              [
                47.8133098,
                38.2622563
              ],
              [
                47.8146961,
                38.2622563
              ],
              [
                47.8246994,
                38.2647625
              ],
              [
                47.8266429,
                38.2647625
              ],
              [
                47.8319196,
                38.2655889
              ],
              [
                47.836086,
                38.2664243
              ],
              [
                47.8377529,
                38.2664243
              ],
              [
                47.8385684,
                38.2666286
              ],
              [
                47.8435894,
                38.2678167
              ],
              [
                47.8444226,
                38.2678167
              ],
              [
                47.857476,
                38.2747603
              ],
              [
                47.8655323,
                38.2933719
              ],
              [
                47.8658124,
                38.2978182
              ],
              [
                47.8658124,
                38.3000368
              ],
              [
                47.853589,
                38.3125398
              ],
              [
                47.8446994,
                38.3255904
              ],
              [
                47.8494224,
                38.3311502
              ],
              [
                47.8533088,
                38.3322639
              ],
              [
                47.856089,
                38.333647
              ],
              [
                47.8630321,
                38.3358745
              ],
              [
                47.8677556,
                38.3367008
              ],
              [
                47.8713654,
                38.3375362
              ],
              [
                47.8724789,
                38.3375361
              ],
              [
                47.873032,
                38.3378145
              ],
              [
                47.8741456,
                38.3378146
              ],
              [
                47.8960887,
                38.3444879
              ],
              [
                47.9122015,
                38.3494816
              ],
              [
                47.9241483,
                38.3564242
              ],
              [
                47.9274816,
                38.3583731
              ],
              [
                47.9391482,
                38.3669861
              ],
              [
                47.9433147,
                38.3680907
              ],
              [
                47.9435913,
                38.3683781
              ],
              [
                47.9485914,
                38.3683781
              ],
              [
                47.9513711,
                38.3686476
              ],
              [
                47.9519246,
                38.368926
              ],
              [
                47.9535911,
                38.3689261
              ],
              [
                47.9541477,
                38.3694828
              ],
              [
                47.9541478,
                38.3697612
              ],
              [
                47.9547044,
                38.3739284
              ],
              [
                47.9524813,
                38.3808797
              ],
              [
                47.9527578,
                38.3864298
              ],
              [
                47.9533145,
                38.39004
              ],
              [
                47.9535911,
                38.3905969
              ],
              [
                47.9541476,
                38.3930935
              ],
              [
                47.9549812,
                38.3944855
              ],
              [
                47.9547043,
                38.3947638
              ],
              [
                47.9508143,
                38.3994877
              ],
              [
                47.9508144,
                38.4003228
              ],
              [
                47.9516479,
                38.4019843
              ],
              [
                47.9522046,
                38.4055944
              ],
              [
                47.9488713,
                38.4083783
              ],
              [
                47.943038,
                38.4155985
              ],
              [
                47.9430379,
                38.4158768
              ],
              [
                47.9488713,
                38.4222618
              ],
              [
                47.9505377,
                38.4233754
              ],
              [
                47.9613707,
                38.428934
              ],
              [
                47.9897037,
                38.4489323
              ],
              [
                47.9959871,
                38.4532584
              ],
              [
                47.9973494,
                38.4535375
              ],
              [
                47.9994206,
                38.453195
              ],
              [
                48.0044271,
                38.4536556
              ],
              [
                48.0052603,
                38.4536557
              ],
              [
                48.0060935,
                38.4542124
              ],
              [
                48.0072072,
                38.4542124
              ],
              [
                48.0105406,
                38.4555953
              ],
              [
                48.0113737,
                38.4555953
              ],
              [
                48.0127636,
                38.456152
              ],
              [
                48.0141503,
                38.456152
              ],
              [
                48.0144304,
                38.4564304
              ],
              [
                48.0152637,
                38.4564304
              ],
              [
                48.0155403,
                38.4567087
              ],
              [
                48.0163734,
                38.4567088
              ],
              [
                48.0163734,
                38.4569871
              ],
              [
                48.017207,
                38.4569872
              ],
              [
                48.0174836,
                38.4572655
              ],
              [
                48.0183168,
                38.4575438
              ],
              [
                48.0455396,
                38.4786544
              ],
              [
                48.0458197,
                38.4789328
              ],
              [
                48.0480397,
                38.4806029
              ],
              [
                48.0488733,
                38.481429
              ],
              [
                48.0658197,
                38.4894923
              ],
              [
                48.0763763,
                38.4903184
              ],
              [
                48.0788763,
                38.490049
              ],
              [
                48.0885996,
                38.4869872
              ],
              [
                48.0924896,
                38.4842127
              ],
              [
                48.0924896,
                38.4839343
              ],
              [
                48.0944326,
                38.4833776
              ],
              [
                48.0947094,
                38.4830993
              ],
              [
                48.0952662,
                38.4830992
              ],
              [
                48.0955427,
                38.4828209
              ],
              [
                48.0994326,
                38.4828209
              ],
              [
                48.0997093,
                38.4830993
              ],
              [
                48.1010991,
                38.4830993
              ],
              [
                48.1113795,
                38.4867088
              ],
              [
                48.1122126,
                38.4867089
              ],
              [
                48.1127658,
                38.4869872
              ],
              [
                48.1133224,
                38.4869872
              ],
              [
                48.1135989,
                38.4872656
              ],
              [
                48.1158225,
                38.4878223
              ],
              [
                48.1166557,
                38.4878223
              ],
              [
                48.1169323,
                38.4881007
              ],
              [
                48.1180459,
                38.4881006
              ],
              [
                48.1252656,
                38.4911535
              ],
              [
                48.1283224,
                38.4955981
              ],
              [
                48.1291555,
                38.5036521
              ],
              [
                48.1286025,
                38.5047655
              ],
              [
                48.1286024,
                38.5056006
              ],
              [
                48.1263789,
                38.5097667
              ],
              [
                48.1233222,
                38.5133761
              ],
              [
                48.1127657,
                38.5194904
              ],
              [
                48.1122126,
                38.5194905
              ],
              [
                48.1116559,
                38.5200471
              ],
              [
                48.1110991,
                38.5200471
              ],
              [
                48.1108222,
                38.5203254
              ],
              [
                48.1027658,
                38.5211515
              ],
              [
                48.0955426,
                38.5230998
              ],
              [
                48.0947093,
                38.5230997
              ],
              [
                48.086376,
                38.5269874
              ],
              [
                48.0774859,
                38.5342059
              ],
              [
                48.0749862,
                38.5381025
              ],
              [
                48.0749863,
                38.5400418
              ],
              [
                48.0774859,
                38.545321
              ],
              [
                48.0774859,
                38.5458775
              ],
              [
                48.0830426,
                38.5506
              ],
              [
                48.0833191,
                38.5533742
              ],
              [
                48.0833192,
                38.5539309
              ],
              [
                48.0833191,
                38.5575489
              ],
              [
                48.0835992,
                38.5597664
              ],
              [
                48.0844324,
                38.5614364
              ],
              [
                48.0877657,
                38.5644888
              ],
              [
                48.0897091,
                38.5667153
              ],
              [
                48.0902658,
                38.5669935
              ],
              [
                48.0933224,
                38.5730984
              ],
              [
                48.0941556,
                38.5778206
              ],
              [
                48.1002655,
                38.5867173
              ],
              [
                48.1160986,
                38.5950482
              ],
              [
                48.1166553,
                38.5953265
              ],
              [
                48.1188788,
                38.5964307
              ],
              [
                48.1319353,
                38.6022658
              ],
              [
                48.1330451,
                38.6022658
              ],
              [
                48.1338788,
                38.6025441
              ],
              [
                48.1363784,
                38.6025441
              ],
              [
                48.137212,
                38.6028224
              ],
              [
                48.1383218,
                38.6028225
              ],
              [
                48.139155,
                38.6025442
              ],
              [
                48.1419352,
                38.6025441
              ],
              [
                48.1424882,
                38.6022659
              ],
              [
                48.148045,
                38.6022659
              ],
              [
                48.1488783,
                38.6025442
              ],
              [
                48.1527682,
                38.6025442
              ],
              [
                48.1536018,
                38.6028225
              ],
              [
                48.1555448,
                38.6028225
              ],
              [
                48.1561015,
                38.6031008
              ],
              [
                48.1580449,
                38.6031008
              ],
              [
                48.1580449,
                38.6033791
              ],
              [
                48.1588781,
                38.6033791
              ],
              [
                48.1622114,
                38.6047706
              ],
              [
                48.1655481,
                38.6047705
              ],
              [
                48.1661017,
                38.6050488
              ],
              [
                48.1672151,
                38.6050488
              ],
              [
                48.1680483,
                38.6047705
              ],
              [
                48.1738816,
                38.6047706
              ],
              [
                48.1747148,
                38.6044922
              ],
              [
                48.1774914,
                38.6044923
              ],
              [
                48.1783246,
                38.604214
              ],
              [
                48.1788813,
                38.6042139
              ],
              [
                48.1799915,
                38.6039357
              ],
              [
                48.1855479,
                38.6031008
              ],
              [
                48.2074945,
                38.6017184
              ],
              [
                48.2086046,
                38.6014401
              ],
              [
                48.2099945,
                38.6014401
              ],
              [
                48.2111043,
                38.6017185
              ],
              [
                48.2152712,
                38.6017184
              ],
              [
                48.2174944,
                38.6019877
              ],
              [
                48.2197142,
                38.6025444
              ],
              [
                48.2224944,
                38.6025444
              ],
              [
                48.223051,
                38.6028226
              ],
              [
                48.2261043,
                38.6028227
              ],
              [
                48.2269375,
                38.6031009
              ],
              [
                48.2283278,
                38.603101
              ],
              [
                48.2286043,
                38.6033792
              ],
              [
                48.2302708,
                38.6033792
              ],
              [
                48.2322177,
                38.6039358
              ],
              [
                48.2347177,
                38.6039358
              ],
              [
                48.2355509,
                38.604214
              ],
              [
                48.2386042,
                38.6042141
              ],
              [
                48.2394408,
                38.6044923
              ],
              [
                48.2405507,
                38.6044924
              ],
              [
                48.2411074,
                38.6047707
              ],
              [
                48.2422175,
                38.6047706
              ],
              [
                48.2477739,
                38.6067097
              ],
              [
                48.2483274,
                38.606988
              ],
              [
                48.2519407,
                38.608936
              ],
              [
                48.2533271,
                38.609771
              ],
              [
                48.289997,
                38.6425448
              ],
              [
                48.2902736,
                38.642823
              ],
              [
                48.2920258,
                38.6438183
              ],
              [
                48.2952436,
                38.6455236
              ],
              [
                48.2949419,
                38.6473191
              ],
              [
                48.2854652,
                38.649176
              ],
              [
                48.2833771,
                38.6524101
              ],
              [
                48.2784822,
                38.6521196
              ],
              [
                48.2754678,
                38.6546514
              ],
              [
                48.2681875,
                38.657183
              ],
              [
                48.2582341,
                38.6576272
              ],
              [
                48.252657,
                38.6619076
              ],
              [
                48.2530584,
                38.6825838
              ],
              [
                48.2515016,
                38.6847685
              ],
              [
                48.2503806,
                38.685515
              ],
              [
                48.2498833,
                38.6863929
              ],
              [
                48.2479729,
                38.6891965
              ],
              [
                48.248041,
                38.6917769
              ],
              [
                48.2522601,
                38.6965666
              ],
              [
                48.2583002,
                38.6986486
              ],
              [
                48.259391,
                38.7085091
              ],
              [
                48.2539181,
                38.7135783
              ],
              [
                48.2495889,
                38.7168961
              ],
              [
                48.2468845,
                38.7217306
              ],
              [
                48.2491558,
                38.7260959
              ],
              [
                48.2431049,
                38.7288771
              ],
              [
                48.2424671,
                38.7312832
              ],
              [
                48.2357116,
                38.7320489
              ],
              [
                48.2325418,
                38.7324095
              ],
              [
                48.2237072,
                38.7346897
              ],
              [
                48.2205007,
                38.7378686
              ],
              [
                48.2173601,
                38.7364213
              ],
              [
                48.2064716,
                38.7398805
              ],
              [
                48.2023756,
                38.7437628
              ],
              [
                48.2002006,
                38.7449251
              ],
              [
                48.2000531,
                38.7462378
              ],
              [
                48.1997534,
                38.7489061
              ],
              [
                48.190467,
                38.7517875
              ],
              [
                48.1918136,
                38.7562153
              ],
              [
                48.1726754,
                38.7617366
              ],
              [
                48.1631169,
                38.7597045
              ],
              [
                48.1482129,
                38.7627958
              ],
              [
                48.1447196,
                38.7668058
              ],
              [
                48.1360452,
                38.7672396
              ],
              [
                48.1329405,
                38.7699824
              ],
              [
                48.1298333,
                38.7684374
              ],
              [
                48.1213841,
                38.7697913
              ],
              [
                48.1204203,
                38.7710563
              ],
              [
                48.1157576,
                38.7709194
              ],
              [
                48.1115885,
                38.7698762
              ],
              [
                48.1073103,
                38.7698813
              ],
              [
                48.1055997,
                38.7730359
              ],
              [
                48.1041168,
                38.7741581
              ],
              [
                48.1027746,
                38.7759556
              ],
              [
                48.1011708,
                38.7768986
              ],
              [
                48.1022216,
                38.7795217
              ],
              [
                48.1038585,
                38.7805091
              ],
              [
                48.1047297,
                38.7828996
              ],
              [
                48.1070769,
                38.7866635
              ],
              [
                48.1071082,
                38.7885576
              ],
              [
                48.0931903,
                38.7890377
              ],
              [
                48.0882912,
                38.7939844
              ],
              [
                48.0783816,
                38.7938976
              ],
              [
                48.0797177,
                38.8009266
              ],
              [
                48.068472,
                38.8031826
              ],
              [
                48.0611234,
                38.808649
              ],
              [
                48.0488756,
                38.8118591
              ],
              [
                48.0448673,
                38.8163705
              ],
              [
                48.0408589,
                38.815503
              ],
              [
                48.0359609,
                38.824387
              ],
              [
                48.034789,
                38.830722
              ],
              [
                48.0207028,
                38.8378898
              ],
              [
                48.0129562,
                38.8809304
              ],
              [
                48.0118328,
                38.8909225
              ],
              [
                48.0072057,
                38.8908871
              ],
              [
                48.0058187,
                38.8910747
              ],
              [
                48.0031753,
                38.8911896
              ],
              [
                47.9999995,
                38.890449
              ],
              [
                47.9910924,
                38.8872803
              ],
              [
                47.9877591,
                38.8872803
              ],
              [
                47.9866489,
                38.8870022
              ],
              [
                47.9847024,
                38.8870022
              ],
              [
                47.9777589,
                38.888662
              ],
              [
                47.9755357,
                38.888662
              ],
              [
                47.9749792,
                38.8889401
              ],
              [
                47.973869,
                38.8889401
              ],
              [
                47.9727591,
                38.8892182
              ],
              [
                47.9713693,
                38.8892182
              ],
              [
                47.9710923,
                38.8894964
              ],
              [
                47.9685926,
                38.8894964
              ],
              [
                47.9683126,
                38.8897745
              ],
              [
                47.9660926,
                38.8897745
              ],
              [
                47.9655359,
                38.8894964
              ],
              [
                47.9627593,
                38.8889401
              ],
              [
                47.9619261,
                38.8889401
              ],
              [
                47.9597026,
                38.8881146
              ],
              [
                47.9463695,
                38.8783889
              ],
              [
                47.9452562,
                38.8781107
              ],
              [
                47.9402561,
                38.8750512
              ],
              [
                47.9358131,
                38.8731132
              ],
              [
                47.9310896,
                38.8711662
              ],
              [
                47.9266465,
                38.868941
              ],
              [
                47.9196998,
                38.8663767
              ],
              [
                47.9188662,
                38.8661685
              ],
              [
                47.8994233,
                38.8561641
              ],
              [
                47.8891434,
                38.8475504
              ],
              [
                47.8880335,
                38.8472722
              ],
              [
                47.8816436,
                38.8450558
              ],
              [
                47.8785868,
                38.8450559
              ],
              [
                47.8783103,
                38.845334
              ],
              [
                47.8777536,
                38.8450558
              ],
              [
                47.8705304,
                38.8450559
              ],
              [
                47.8696967,
                38.845334
              ],
              [
                47.8685871,
                38.845334
              ],
              [
                47.8683104,
                38.8456122
              ],
              [
                47.8635869,
                38.8458903
              ],
              [
                47.8541406,
                38.8458903
              ],
              [
                47.8516406,
                38.845334
              ],
              [
                47.8502538,
                38.845334
              ],
              [
                47.8408071,
                38.8425524
              ],
              [
                47.8327506,
                38.8389453
              ],
              [
                47.8319174,
                38.8389453
              ],
              [
                47.8093364,
                38.8269858
              ],
              [
                47.8071942,
                38.8289403
              ],
              [
                47.8044177,
                38.8325564
              ],
              [
                47.8041376,
                38.8336602
              ],
              [
                47.8041375,
                38.8364418
              ],
              [
                47.8027511,
                38.8406052
              ],
              [
                47.8027512,
                38.8436649
              ],
              [
                47.7991377,
                38.8572765
              ],
              [
                47.7994179,
                38.8595017
              ],
              [
                47.8046941,
                38.8670027
              ],
              [
                47.8055276,
                38.8731128
              ],
              [
                47.8052507,
                38.8739473
              ],
              [
                47.8055276,
                38.8747727
              ],
              [
                47.8060843,
                38.8800574
              ],
              [
                47.8058073,
                38.8822735
              ],
              [
                47.8055277,
                38.8825516
              ],
              [
                47.8055276,
                38.8864455
              ],
              [
                47.8109584,
                38.8857869
              ],
              [
                47.811993,
                38.8885827
              ],
              [
                47.8111437,
                38.8893702
              ],
              [
                47.8104046,
                38.8896092
              ],
              [
                47.8093108,
                38.8895017
              ],
              [
                47.7997214,
                38.8902834
              ],
              [
                47.7921265,
                38.8906508
              ],
              [
                47.7766126,
                38.8907953
              ],
              [
                47.769447,
                38.8905057
              ],
              [
                47.7631704,
                38.8896802
              ],
              [
                47.7447577,
                38.880874
              ],
              [
                47.7233733,
                38.8727443
              ],
              [
                47.6548637,
                38.8685102
              ],
              [
                47.5699395,
                38.8636577
              ],
              [
                47.5696563,
                38.8615431
              ],
              [
                47.5680466,
                38.8600485
              ],
              [
                47.5630331,
                38.8537456
              ],
              [
                47.5580978,
                38.8356963
              ],
              [
                47.5531411,
                38.8270544
              ],
              [
                47.5528556,
                38.8255908
              ],
              [
                47.5469096,
                38.8213111
              ],
              [
                47.5427702,
                38.817288
              ],
              [
                47.5374511,
                38.8134761
              ],
              [
                47.5283348,
                38.8097792
              ],
              [
                47.5150966,
                38.8011895
              ],
              [
                47.5075289,
                38.7935134
              ],
              [
                47.5011062,
                38.7876095
              ],
              [
                47.4972102,
                38.7847951
              ],
              [
                47.4941952,
                38.7834922
              ],
              [
                47.4894531,
                38.7822578
              ],
              [
                47.4831581,
                38.7807034
              ],
              [
                47.4723434,
                38.7782065
              ],
              [
                47.4661908,
                38.7750252
              ],
              [
                47.4590396,
                38.7710689
              ],
              [
                47.4559688,
                38.7672688
              ],
              [
                47.4545916,
                38.7652107
              ],
              [
                47.4330119,
                38.7192135
              ],
              [
                47.4332884,
                38.7181006
              ],
              [
                47.4327318,
                38.7083805
              ],
              [
                47.4330119,
                38.7069893
              ],
              [
                47.4343983,
                38.7033812
              ],
              [
                47.4357886,
                38.7008771
              ],
              [
                47.4357886,
                38.7003296
              ],
              [
                47.4360651,
                38.7000515
              ],
              [
                47.4366218,
                38.7000514
              ],
              [
                47.4396785,
                38.6983819
              ],
              [
                47.4405117,
                38.698382
              ],
              [
                47.4416219,
                38.6978256
              ],
              [
                47.4424552,
                38.6978255
              ],
              [
                47.4430118,
                38.6975473
              ],
              [
                47.4441215,
                38.6975473
              ],
              [
                47.4446782,
                38.6972691
              ],
              [
                47.4457884,
                38.6972691
              ],
              [
                47.4485686,
                38.6964343
              ],
              [
                47.4491218,
                38.6958779
              ],
              [
                47.4513452,
                38.6922697
              ],
              [
                47.4560685,
                38.6886615
              ],
              [
                47.4577348,
                38.6886615
              ],
              [
                47.4582883,
                38.6883833
              ],
              [
                47.4594017,
                38.6883833
              ],
              [
                47.4607885,
                38.6878269
              ],
              [
                47.4619018,
                38.6878269
              ],
              [
                47.4630115,
                38.6875486
              ],
              [
                47.4674581,
                38.6875486
              ],
              [
                47.4724582,
                38.6894963
              ],
              [
                47.4757915,
                38.6894963
              ],
              [
                47.4796779,
                38.6886616
              ],
              [
                47.4880148,
                38.6858792
              ],
              [
                47.4969014,
                38.683384
              ],
              [
                47.4991245,
                38.6825492
              ],
              [
                47.5007913,
                38.682271
              ],
              [
                47.5107912,
                38.6769933
              ],
              [
                47.5127377,
                38.6764368
              ],
              [
                47.5257943,
                38.6697677
              ],
              [
                47.566456,
                38.6442899
              ],
              [
                47.565241,
                38.6406042
              ],
              [
                47.5666274,
                38.637274
              ],
              [
                47.5671841,
                38.6347696
              ],
              [
                47.567184,
                38.6286565
              ],
              [
                47.5699607,
                38.6161609
              ],
              [
                47.5688509,
                38.6117084
              ],
              [
                47.5595749,
                38.5738529
              ],
              [
                47.5585343,
                38.5675032
              ],
              [
                47.5551435,
                38.5581357
              ],
              [
                47.5456134,
                38.5507
              ],
              [
                47.5361251,
                38.5480312
              ],
              [
                47.5220489,
                38.546353
              ],
              [
                47.5139808,
                38.5422581
              ],
              [
                47.506652,
                38.5353744
              ],
              [
                47.502737,
                38.5271517
              ],
              [
                47.5004194,
                38.5171463
              ],
              [
                47.4972438,
                38.511337
              ],
              [
                47.4864292,
                38.502236
              ],
              [
                47.4830389,
                38.4983401
              ],
              [
                47.4810218,
                38.4942088
              ],
              [
                47.476693,
                38.4891845
              ],
              [
                47.4737748,
                38.4860692
              ],
              [
                47.4717767,
                38.4840104
              ],
              [
                47.4684962,
                38.4805015
              ],
              [
                47.4598739,
                38.473628
              ],
              [
                47.4410663,
                38.4500356
              ],
              [
                47.415233,
                38.4155972
              ],
              [
                47.4113431,
                38.412544
              ],
              [
                47.3988435,
                38.4053147
              ],
              [
                47.384677,
                38.3992079
              ],
              [
                47.38023,
                38.3961456
              ],
              [
                47.345784,
                38.3569797
              ],
              [
                47.3402307,
                38.3533691
              ],
              [
                47.334951,
                38.3505939
              ],
              [
                47.3316173,
                38.3492018
              ],
              [
                47.3191178,
                38.3433728
              ],
              [
                47.2974517,
                38.3366995
              ],
              [
                47.2952282,
                38.3358732
              ],
              [
                47.2907813,
                38.3319841
              ],
              [
                47.2893945,
                38.3167061
              ],
              [
                47.2888383,
                38.3155923
              ],
              [
                47.2888384,
                38.3142001
              ],
              [
                47.2874485,
                38.3069785
              ],
              [
                47.287172,
                38.3061522
              ],
              [
                47.2871719,
                38.3053169
              ],
              [
                47.2871719,
                38.3044815
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555238,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نمین",
          "name:en": "Namin County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1274531",
          "wikipedia": "en:Namin County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.283888,
                38.3828203
              ],
              [
                48.283888,
                38.3825418
              ],
              [
                48.283888,
                38.3822634
              ],
              [
                48.2844411,
                38.380593
              ],
              [
                48.2847211,
                38.3786531
              ],
              [
                48.2849978,
                38.3775395
              ],
              [
                48.2861075,
                38.3742075
              ],
              [
                48.2994443,
                38.3586523
              ],
              [
                48.2999979,
                38.3586523
              ],
              [
                48.3294442,
                38.3408782
              ],
              [
                48.3300009,
                38.3408783
              ],
              [
                48.3627805,
                38.3300376
              ],
              [
                48.3638903,
                38.3300376
              ],
              [
                48.364724,
                38.3297591
              ],
              [
                48.3663905,
                38.3297592
              ],
              [
                48.3669471,
                38.3294807
              ],
              [
                48.373057,
                38.3294807
              ],
              [
                48.3738902,
                38.3297591
              ],
              [
                48.3769469,
                38.3297592
              ],
              [
                48.3777805,
                38.3300375
              ],
              [
                48.3788903,
                38.3300376
              ],
              [
                48.379447,
                38.330316
              ],
              [
                48.3827802,
                38.330316
              ],
              [
                48.3833369,
                38.3305945
              ],
              [
                48.3875038,
                38.3311513
              ],
              [
                48.3900035,
                38.3311513
              ],
              [
                48.3905601,
                38.3314298
              ],
              [
                48.3983368,
                38.3314298
              ],
              [
                48.3991701,
                38.3317082
              ],
              [
                48.4027799,
                38.3317083
              ],
              [
                48.4036136,
                38.3319866
              ],
              [
                48.4069468,
                38.3319867
              ],
              [
                48.4072268,
                38.3322651
              ],
              [
                48.4088933,
                38.3322651
              ],
              [
                48.40945,
                38.3325435
              ],
              [
                48.4113934,
                38.3325436
              ],
              [
                48.4133367,
                38.3330914
              ],
              [
                48.4147267,
                38.3330915
              ],
              [
                48.4152834,
                38.3333788
              ],
              [
                48.42695,
                38.3350404
              ],
              [
                48.4291731,
                38.3350405
              ],
              [
                48.4300067,
                38.3353188
              ],
              [
                48.437783,
                38.3353189
              ],
              [
                48.4386163,
                38.3350405
              ],
              [
                48.4402832,
                38.3350405
              ],
              [
                48.4408398,
                38.3347621
              ],
              [
                48.4452829,
                38.3336483
              ],
              [
                48.4455598,
                38.3333789
              ],
              [
                48.4458422,
                38.3330876
              ],
              [
                48.4460739,
                38.332822
              ],
              [
                48.4461165,
                38.3292114
              ],
              [
                48.4458395,
                38.328933
              ],
              [
                48.4456662,
                38.3276483
              ],
              [
                48.4455598,
                38.3253223
              ],
              [
                48.4450064,
                38.3119842
              ],
              [
                48.441393,
                38.3008734
              ],
              [
                48.432783,
                38.2892054
              ],
              [
                48.4286165,
                38.2844806
              ],
              [
                48.4272268,
                38.2828189
              ],
              [
                48.4238935,
                38.2758754
              ],
              [
                48.4233368,
                38.2719858
              ],
              [
                48.4233369,
                38.2678179
              ],
              [
                48.42556,
                38.2633714
              ],
              [
                48.42556,
                38.263093
              ],
              [
                48.4261166,
                38.262536
              ],
              [
                48.4263935,
                38.2619791
              ],
              [
                48.4269502,
                38.2611527
              ],
              [
                48.42806,
                38.2575416
              ],
              [
                48.4286167,
                38.2569847
              ],
              [
                48.4336169,
                38.2486484
              ],
              [
                48.4358399,
                38.2461512
              ],
              [
                48.43834,
                38.24254
              ],
              [
                48.450163,
                38.2311567
              ],
              [
                48.4581159,
                38.2272536
              ],
              [
                48.462367,
                38.2223358
              ],
              [
                48.4658553,
                38.2198191
              ],
              [
                48.4759729,
                38.2213355
              ],
              [
                48.4848017,
                38.2239741
              ],
              [
                48.4912745,
                38.2254101
              ],
              [
                48.4972162,
                38.2250731
              ],
              [
                48.5004768,
                38.2227193
              ],
              [
                48.5054772,
                38.2168626
              ],
              [
                48.5164568,
                38.2118788
              ],
              [
                48.5228274,
                38.2095771
              ],
              [
                48.5282765,
                38.2061375
              ],
              [
                48.5366687,
                38.2037095
              ],
              [
                48.5452154,
                38.2012728
              ],
              [
                48.5525288,
                38.2015513
              ],
              [
                48.5609683,
                38.2036422
              ],
              [
                48.5706228,
                38.206763
              ],
              [
                48.5822706,
                38.2117537
              ],
              [
                48.5860378,
                38.2124158
              ],
              [
                48.5970745,
                38.2112183
              ],
              [
                48.6028662,
                38.1952844
              ],
              [
                48.6062621,
                38.1904345
              ],
              [
                48.6071204,
                38.1833509
              ],
              [
                48.62051,
                38.1774137
              ],
              [
                48.6368698,
                38.171947
              ],
              [
                48.6631679,
                38.1658076
              ],
              [
                48.6701202,
                38.1633782
              ],
              [
                48.6792442,
                38.1585642
              ],
              [
                48.6813726,
                38.1643156
              ],
              [
                48.6825754,
                38.1721181
              ],
              [
                48.6832691,
                38.1770876
              ],
              [
                48.6838506,
                38.1839113
              ],
              [
                48.6862899,
                38.1954056
              ],
              [
                48.6894596,
                38.2035366
              ],
              [
                48.6924328,
                38.2079654
              ],
              [
                48.70265,
                38.2087812
              ],
              [
                48.706169,
                38.2106021
              ],
              [
                48.7084865,
                38.2130974
              ],
              [
                48.7086581,
                38.2153903
              ],
              [
                48.7067699,
                38.2179528
              ],
              [
                48.7012236,
                38.2192437
              ],
              [
                48.6964497,
                38.2211365
              ],
              [
                48.693023,
                38.224132
              ],
              [
                48.6936378,
                38.2295505
              ],
              [
                48.6943521,
                38.2330105
              ],
              [
                48.692873,
                38.2358719
              ],
              [
                48.6896627,
                38.2392046
              ],
              [
                48.6893145,
                38.2427659
              ],
              [
                48.6962986,
                38.249168
              ],
              [
                48.7003437,
                38.2551276
              ],
              [
                48.6992597,
                38.2567844
              ],
              [
                48.6849354,
                38.265432
              ],
              [
                48.6790131,
                38.2679424
              ],
              [
                48.6739049,
                38.276001
              ],
              [
                48.6734444,
                38.2817164
              ],
              [
                48.675785,
                38.297313
              ],
              [
                48.675614,
                38.302908
              ],
              [
                48.6752486,
                38.306305
              ],
              [
                48.6737952,
                38.3097479
              ],
              [
                48.6693263,
                38.3099251
              ],
              [
                48.6681578,
                38.3088708
              ],
              [
                48.6646485,
                38.3058167
              ],
              [
                48.6538376,
                38.2989915
              ],
              [
                48.639782,
                38.2973434
              ],
              [
                48.6264046,
                38.3008737
              ],
              [
                48.6191813,
                38.3153169
              ],
              [
                48.6122347,
                38.3214335
              ],
              [
                48.5830684,
                38.3489262
              ],
              [
                48.5766784,
                38.3564255
              ],
              [
                48.5744548,
                38.3605929
              ],
              [
                48.5744548,
                38.3608803
              ],
              [
                48.5739016,
                38.3617065
              ],
              [
                48.5708449,
                38.3747649
              ],
              [
                48.5708448,
                38.382264
              ],
              [
                48.5739016,
                38.3917118
              ],
              [
                48.5733449,
                38.3936516
              ],
              [
                48.5705683,
                38.4058741
              ],
              [
                48.5702881,
                38.4072661
              ],
              [
                48.5694549,
                38.4125465
              ],
              [
                48.5691779,
                38.4142079
              ],
              [
                48.5700116,
                38.4194882
              ],
              [
                48.5706923,
                38.4214543
              ],
              [
                48.5725115,
                38.4267083
              ],
              [
                48.5730682,
                38.4364336
              ],
              [
                48.5736213,
                38.4383733
              ],
              [
                48.5819578,
                38.4442102
              ],
              [
                48.5822344,
                38.444767
              ],
              [
                48.5827914,
                38.4450453
              ],
              [
                48.5807243,
                38.4539868
              ],
              [
                48.5805953,
                38.4548107
              ],
              [
                48.5809063,
                38.4579987
              ],
              [
                48.5813141,
                38.4595204
              ],
              [
                48.5818264,
                38.4603383
              ],
              [
                48.5819095,
                38.4608046
              ],
              [
                48.5815206,
                38.4627736
              ],
              [
                48.5788532,
                38.4637336
              ],
              [
                48.579433,
                38.4668173
              ],
              [
                48.5737245,
                38.4687234
              ],
              [
                48.5743428,
                38.4709341
              ],
              [
                48.5663616,
                38.4800099
              ],
              [
                48.5632224,
                38.4796501
              ],
              [
                48.5571388,
                38.4811685
              ],
              [
                48.5567157,
                38.4841492
              ],
              [
                48.5529332,
                38.4859712
              ],
              [
                48.5530467,
                38.4886581
              ],
              [
                48.5496942,
                38.4907226
              ],
              [
                48.5511373,
                38.4927909
              ],
              [
                48.5507374,
                38.4940918
              ],
              [
                48.5433359,
                38.4958484
              ],
              [
                48.5376386,
                38.5034509
              ],
              [
                48.5323299,
                38.5044347
              ],
              [
                48.5310683,
                38.5059085
              ],
              [
                48.5266739,
                38.5142544
              ],
              [
                48.5219245,
                38.515759
              ],
              [
                48.5176091,
                38.5154365
              ],
              [
                48.5167375,
                38.5174825
              ],
              [
                48.5133037,
                38.518379
              ],
              [
                48.5139596,
                38.5223081
              ],
              [
                48.509365,
                38.5256711
              ],
              [
                48.508275,
                38.527929
              ],
              [
                48.5077893,
                38.5395051
              ],
              [
                48.5053279,
                38.5426712
              ],
              [
                48.5053883,
                38.5441254
              ],
              [
                48.5055078,
                38.5470001
              ],
              [
                48.4950289,
                38.5532719
              ],
              [
                48.4887298,
                38.552604
              ],
              [
                48.483957,
                38.5540011
              ],
              [
                48.4768878,
                38.5515793
              ],
              [
                48.4722042,
                38.5535327
              ],
              [
                48.4706685,
                38.5564238
              ],
              [
                48.4685627,
                38.5571989
              ],
              [
                48.4681091,
                38.5616275
              ],
              [
                48.4672182,
                38.5622126
              ],
              [
                48.464684,
                38.5613214
              ],
              [
                48.4619022,
                38.5653001
              ],
              [
                48.4621515,
                38.5700897
              ],
              [
                48.4592363,
                38.5775474
              ],
              [
                48.4545155,
                38.5811489
              ],
              [
                48.4541344,
                38.5831819
              ],
              [
                48.4567645,
                38.5859578
              ],
              [
                48.4541987,
                38.5872005
              ],
              [
                48.4535289,
                38.5897663
              ],
              [
                48.4586107,
                38.5980425
              ],
              [
                48.4584176,
                38.6005604
              ],
              [
                48.4559619,
                38.6041669
              ],
              [
                48.4592932,
                38.6076878
              ],
              [
                48.4541386,
                38.609514
              ],
              [
                48.4514814,
                38.6104553
              ],
              [
                48.4474559,
                38.6100329
              ],
              [
                48.4445053,
                38.6120433
              ],
              [
                48.4413158,
                38.6127221
              ],
              [
                48.4358582,
                38.6117569
              ],
              [
                48.4314838,
                38.613568
              ],
              [
                48.4251103,
                38.6132877
              ],
              [
                48.4214685,
                38.6101129
              ],
              [
                48.4179562,
                38.6090349
              ],
              [
                48.4161312,
                38.6059235
              ],
              [
                48.4094692,
                38.6042654
              ],
              [
                48.4079422,
                38.6023118
              ],
              [
                48.3903587,
                38.602443
              ],
              [
                48.3884074,
                38.6050457
              ],
              [
                48.3856521,
                38.6051448
              ],
              [
                48.3818225,
                38.6036449
              ],
              [
                48.3800827,
                38.6018152
              ],
              [
                48.3755371,
                38.6008763
              ],
              [
                48.3742251,
                38.6002886
              ],
              [
                48.3736743,
                38.5984105
              ],
              [
                48.3669945,
                38.5981543
              ],
              [
                48.361489,
                38.5948538
              ],
              [
                48.3563145,
                38.5977879
              ],
              [
                48.3507154,
                38.5951324
              ],
              [
                48.3440111,
                38.5990316
              ],
              [
                48.3420421,
                38.5993976
              ],
              [
                48.3415533,
                38.5995834
              ],
              [
                48.3409226,
                38.5999628
              ],
              [
                48.3399384,
                38.6005384
              ],
              [
                48.3393935,
                38.6009126
              ],
              [
                48.3390897,
                38.6011527
              ],
              [
                48.3389146,
                38.6012482
              ],
              [
                48.3387297,
                38.6012353
              ],
              [
                48.3384919,
                38.6011707
              ],
              [
                48.3382079,
                38.6009668
              ],
              [
                48.3379946,
                38.6006868
              ],
              [
                48.3376207,
                38.6003004
              ],
              [
                48.3369411,
                38.5998952
              ],
              [
                48.3356942,
                38.5996784
              ],
              [
                48.3334119,
                38.5999759
              ],
              [
                48.3321411,
                38.6010417
              ],
              [
                48.331831,
                38.6005651
              ],
              [
                48.3313522,
                38.5997706
              ],
              [
                48.3066788,
                38.58023
              ],
              [
                48.2967002,
                38.566603
              ],
              [
                48.2859163,
                38.5403978
              ],
              [
                48.282672,
                38.5145127
              ],
              [
                48.2822207,
                38.5142114
              ],
              [
                48.2849974,
                38.5103237
              ],
              [
                48.2869407,
                38.508097
              ],
              [
                48.2872209,
                38.5078276
              ],
              [
                48.2997208,
                38.4969902
              ],
              [
                48.3072205,
                38.491989
              ],
              [
                48.3072206,
                38.4911539
              ],
              [
                48.306944,
                38.4908755
              ],
              [
                48.3055537,
                38.4867093
              ],
              [
                48.2883307,
                38.4669908
              ],
              [
                48.2849976,
                38.4572661
              ],
              [
                48.284721,
                38.4536563
              ],
              [
                48.2852741,
                38.4517077
              ],
              [
                48.2852741,
                38.4503248
              ],
              [
                48.2888876,
                38.4411565
              ],
              [
                48.2891641,
                38.4408781
              ],
              [
                48.2969444,
                38.4211491
              ],
              [
                48.2963878,
                38.4147641
              ],
              [
                48.2877744,
                38.3980964
              ],
              [
                48.2852743,
                38.3886578
              ],
              [
                48.2849977,
                38.3881009
              ],
              [
                48.2841646,
                38.3858737
              ],
              [
                48.283888,
                38.3828203
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555244,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نیر",
          "name:en": "Nir County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1283166",
          "wikipedia": "en:Nir County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8266431,
                38.1892033
              ],
              [
                47.8269198,
                38.1889248
              ],
              [
                47.834143,
                38.1814231
              ],
              [
                47.8355332,
                38.1797611
              ],
              [
                47.8449765,
                38.1664284
              ],
              [
                47.8519232,
                38.1469769
              ],
              [
                47.8521997,
                38.1466985
              ],
              [
                47.8519232,
                38.1439222
              ],
              [
                47.8521998,
                38.1436437
              ],
              [
                47.8519232,
                38.1419814
              ],
              [
                47.8513666,
                38.133365
              ],
              [
                47.850533,
                38.1289265
              ],
              [
                47.8477564,
                38.1164192
              ],
              [
                47.8463667,
                38.0917006
              ],
              [
                47.8516434,
                38.0669718
              ],
              [
                47.8519235,
                38.0667022
              ],
              [
                47.8519235,
                38.0639166
              ],
              [
                47.8522,
                38.0605917
              ],
              [
                47.8524766,
                38.0594774
              ],
              [
                47.8527568,
                38.0578061
              ],
              [
                47.8530333,
                38.0561436
              ],
              [
                47.8533099,
                38.053924
              ],
              [
                47.8535899,
                38.0522526
              ],
              [
                47.8538666,
                38.051417
              ],
              [
                47.8578491,
                38.0358617
              ],
              [
                47.8580335,
                38.0344777
              ],
              [
                47.8583101,
                38.0325277
              ],
              [
                47.8585902,
                38.0311437
              ],
              [
                47.8619235,
                38.0089196
              ],
              [
                47.8622001,
                38.0066999
              ],
              [
                47.8624801,
                38.0064214
              ],
              [
                47.8685901,
                37.9986387
              ],
              [
                47.8691468,
                37.9978119
              ],
              [
                47.8752567,
                37.9947563
              ],
              [
                47.8763665,
                37.9947563
              ],
              [
                47.8766465,
                37.9944777
              ],
              [
                47.8783134,
                37.9944777
              ],
              [
                47.87859,
                37.994199
              ],
              [
                47.8805365,
                37.9941991
              ],
              [
                47.88109,
                37.9939205
              ],
              [
                47.8827564,
                37.9939205
              ],
              [
                47.8833132,
                37.9936419
              ],
              [
                47.8847034,
                37.9936419
              ],
              [
                47.8852566,
                37.9933633
              ],
              [
                47.8905367,
                37.9933633
              ],
              [
                47.8908132,
                37.9930847
              ],
              [
                47.8922032,
                37.9930847
              ],
              [
                47.8927563,
                37.9933633
              ],
              [
                47.8960899,
                37.9933633
              ],
              [
                47.8969232,
                37.9936419
              ],
              [
                47.9008131,
                37.9936419
              ],
              [
                47.9010932,
                37.9933633
              ],
              [
                47.9024796,
                37.9933633
              ],
              [
                47.9027596,
                37.9930847
              ],
              [
                47.9035933,
                37.9930847
              ],
              [
                47.9041465,
                37.9928061
              ],
              [
                47.9047031,
                37.9928062
              ],
              [
                47.9052597,
                37.9925275
              ],
              [
                47.9060929,
                37.9925275
              ],
              [
                47.9097032,
                37.9908649
              ],
              [
                47.914703,
                37.983091
              ],
              [
                47.9183163,
                37.9753079
              ],
              [
                47.9294264,
                37.9625278
              ],
              [
                47.9297029,
                37.9622492
              ],
              [
                47.9366497,
                37.950026
              ],
              [
                47.9369262,
                37.9486419
              ],
              [
                47.9377595,
                37.9466916
              ],
              [
                47.9372064,
                37.9428088
              ],
              [
                47.9366497,
                37.9414157
              ],
              [
                47.936093,
                37.941137
              ],
              [
                47.9358165,
                37.9405798
              ],
              [
                47.9352593,
                37.9403102
              ],
              [
                47.9258163,
                37.9350342
              ],
              [
                47.924983,
                37.9350342
              ],
              [
                47.9238697,
                37.934477
              ],
              [
                47.9230365,
                37.934477
              ],
              [
                47.922483,
                37.9341984
              ],
              [
                47.9219263,
                37.9339197
              ],
              [
                47.9213697,
                37.9339197
              ],
              [
                47.9119266,
                37.928365
              ],
              [
                47.9055366,
                37.9180826
              ],
              [
                47.9013701,
                37.9069729
              ],
              [
                47.9010935,
                37.9064157
              ],
              [
                47.8899804,
                37.8983619
              ],
              [
                47.887757,
                37.8978047
              ],
              [
                47.8874804,
                37.8972474
              ],
              [
                47.8847038,
                37.8919711
              ],
              [
                47.885537,
                37.8897508
              ],
              [
                47.8888703,
                37.8861374
              ],
              [
                47.8894234,
                37.8861374
              ],
              [
                47.8894234,
                37.8858588
              ],
              [
                47.8899805,
                37.8855801
              ],
              [
                47.8916469,
                37.8828026
              ],
              [
                47.8919235,
                37.882524
              ],
              [
                47.8916469,
                37.881697
              ],
              [
                47.8908137,
                37.8764205
              ],
              [
                47.8908137,
                37.8722497
              ],
              [
                47.8930368,
                37.8683574
              ],
              [
                47.8955368,
                37.8658585
              ],
              [
                47.8963702,
                37.8650315
              ],
              [
                47.898037,
                37.8636381
              ],
              [
                47.8983136,
                37.8633595
              ],
              [
                47.9002604,
                37.8625235
              ],
              [
                47.9038703,
                37.8625235
              ],
              [
                47.9044269,
                37.8628022
              ],
              [
                47.9052601,
                37.8628022
              ],
              [
                47.9116466,
                37.8644742
              ],
              [
                47.92637,
                37.8711351
              ],
              [
                47.9272032,
                37.8711351
              ],
              [
                47.9277599,
                37.8714137
              ],
              [
                47.9285931,
                37.8714137
              ],
              [
                47.9291497,
                37.8716924
              ],
              [
                47.9299833,
                37.8716924
              ],
              [
                47.9305365,
                37.8719711
              ],
              [
                47.9313697,
                37.8719711
              ],
              [
                47.9413731,
                37.8741913
              ],
              [
                47.9419266,
                37.8741913
              ],
              [
                47.9427598,
                37.87447
              ],
              [
                47.9438731,
                37.87447
              ],
              [
                47.9444262,
                37.8747487
              ],
              [
                47.9472064,
                37.8747487
              ],
              [
                47.9480395,
                37.8750273
              ],
              [
                47.9491498,
                37.8750273
              ],
              [
                47.9499831,
                37.875306
              ],
              [
                47.9535929,
                37.8753061
              ],
              [
                47.9541495,
                37.8750274
              ],
              [
                47.9572062,
                37.8750274
              ],
              [
                47.9574828,
                37.8747487
              ],
              [
                47.971096,
                37.8747487
              ],
              [
                47.971373,
                37.8750274
              ],
              [
                47.9733159,
                37.8750274
              ],
              [
                47.9738726,
                37.8753061
              ],
              [
                47.9749828,
                37.875306
              ],
              [
                47.9752629,
                37.8755847
              ],
              [
                47.9760961,
                37.8755847
              ],
              [
                47.9766527,
                37.8758634
              ],
              [
                47.977486,
                37.8758633
              ],
              [
                47.9774859,
                37.876142
              ],
              [
                47.9780394,
                37.876142
              ],
              [
                47.9860959,
                37.8828028
              ],
              [
                47.9866526,
                37.8833601
              ],
              [
                47.9933191,
                37.8903084
              ],
              [
                47.999403,
                37.8949567
              ],
              [
                48.0124855,
                37.8886365
              ],
              [
                48.0202654,
                37.8841961
              ],
              [
                48.0235991,
                37.8808612
              ],
              [
                48.0241522,
                37.8808613
              ],
              [
                48.0244324,
                37.8805826
              ],
              [
                48.0249854,
                37.8805826
              ],
              [
                48.0249855,
                37.880304
              ],
              [
                48.0255422,
                37.8803039
              ],
              [
                48.0260988,
                37.8800253
              ],
              [
                48.027209,
                37.8800253
              ],
              [
                48.0377654,
                37.8769692
              ],
              [
                48.0399889,
                37.8755849
              ],
              [
                48.0402656,
                37.8753063
              ],
              [
                48.0466555,
                37.8711354
              ],
              [
                48.0502653,
                37.8653015
              ],
              [
                48.0497088,
                37.8583619
              ],
              [
                48.0527655,
                37.8525279
              ],
              [
                48.0572121,
                37.8500289
              ],
              [
                48.0583219,
                37.8500289
              ],
              [
                48.0585983,
                37.8497502
              ],
              [
                48.0591554,
                37.8497502
              ],
              [
                48.059432,
                37.8494716
              ],
              [
                48.0599887,
                37.8494715
              ],
              [
                48.0602653,
                37.8491929
              ],
              [
                48.0608219,
                37.8491928
              ],
              [
                48.0616552,
                37.8486355
              ],
              [
                48.0624887,
                37.8486355
              ],
              [
                48.0627653,
                37.8483569
              ],
              [
                48.0638786,
                37.8480872
              ],
              [
                48.0655451,
                37.8480872
              ],
              [
                48.0660985,
                37.8478086
              ],
              [
                48.0691553,
                37.8478086
              ],
              [
                48.0699886,
                37.8475299
              ],
              [
                48.0738785,
                37.84753
              ],
              [
                48.0755453,
                37.8478086
              ],
              [
                48.0761019,
                37.8478085
              ],
              [
                48.0827685,
                37.850029
              ],
              [
                48.0886018,
                37.8536427
              ],
              [
                48.0963782,
                37.8536426
              ],
              [
                48.0985513,
                37.8527311
              ],
              [
                48.0991583,
                37.852528
              ],
              [
                48.1047115,
                37.849193
              ],
              [
                48.108048,
                37.8389181
              ],
              [
                48.1083249,
                37.8375248
              ],
              [
                48.1086016,
                37.8364101
              ],
              [
                48.1088816,
                37.8361404
              ],
              [
                48.114715,
                37.8303062
              ],
              [
                48.1180482,
                37.8291915
              ],
              [
                48.119158,
                37.8289128
              ],
              [
                48.1386046,
                37.8216942
              ],
              [
                48.1391577,
                37.8211368
              ],
              [
                48.1461044,
                37.8178016
              ],
              [
                48.1463809,
                37.8172443
              ],
              [
                48.146938,
                37.8169656
              ],
              [
                48.1511045,
                37.8103041
              ],
              [
                48.1511045,
                37.8097468
              ],
              [
                48.152771,
                37.8097467
              ],
              [
                48.1724941,
                37.8097468
              ],
              [
                48.1872174,
                37.804191
              ],
              [
                48.187494,
                37.8039123
              ],
              [
                48.1897175,
                37.8039123
              ],
              [
                48.1919406,
                37.8044697
              ],
              [
                48.2008272,
                37.8083624
              ],
              [
                48.2052737,
                37.8116977
              ],
              [
                48.2213869,
                37.8203009
              ],
              [
                48.2222205,
                37.8208584
              ],
              [
                48.2422202,
                37.8380824
              ],
              [
                48.2499965,
                37.8441952
              ],
              [
                48.256663,
                37.8475303
              ],
              [
                48.2580533,
                37.847809
              ],
              [
                48.2777764,
                37.856969
              ],
              [
                48.2788896,
                37.8575264
              ],
              [
                48.3122223,
                37.8758641
              ],
              [
                48.3124993,
                37.8761427
              ],
              [
                48.3133326,
                37.8766911
              ],
              [
                48.319169,
                37.8803046
              ],
              [
                48.3269457,
                37.8933564
              ],
              [
                48.3272222,
                37.8953068
              ],
              [
                48.3244455,
                37.9041965
              ],
              [
                48.3283355,
                37.9119715
              ],
              [
                48.3294457,
                37.9136432
              ],
              [
                48.3297222,
                37.9142005
              ],
              [
                48.335279,
                37.9205822
              ],
              [
                48.3397256,
                37.926137
              ],
              [
                48.3400021,
                37.9266942
              ],
              [
                48.3425022,
                37.9291929
              ],
              [
                48.3458354,
                37.9344779
              ],
              [
                48.341718,
                37.9479947
              ],
              [
                48.3505584,
                37.9822561
              ],
              [
                48.3500017,
                37.9853118
              ],
              [
                48.3497251,
                37.9944787
              ],
              [
                48.349445,
                37.9950269
              ],
              [
                48.3500017,
                37.9994755
              ],
              [
                48.3497251,
                38.0003202
              ],
              [
                48.3491685,
                38.0022525
              ],
              [
                48.3475017,
                38.0044722
              ],
              [
                48.3466684,
                38.0050294
              ],
              [
                48.3452785,
                38.0050294
              ],
              [
                48.3452785,
                38.0047509
              ],
              [
                48.3430586,
                38.0047508
              ],
              [
                48.3422253,
                38.0050294
              ],
              [
                48.3419453,
                38.0047508
              ],
              [
                48.3377783,
                38.0047508
              ],
              [
                48.3372252,
                38.0044722
              ],
              [
                48.333892,
                38.0044722
              ],
              [
                48.3336119,
                38.0047508
              ],
              [
                48.3330551,
                38.0047508
              ],
              [
                48.3313884,
                38.005308
              ],
              [
                48.3258355,
                38.0086421
              ],
              [
                48.3247218,
                38.0100351
              ],
              [
                48.3230554,
                38.0144745
              ],
              [
                48.3230554,
                38.0211427
              ],
              [
                48.3233354,
                38.0225357
              ],
              [
                48.3250019,
                38.0264178
              ],
              [
                48.334445,
                38.0391966
              ],
              [
                48.3352786,
                38.0403109
              ],
              [
                48.3375017,
                38.0419734
              ],
              [
                48.3547246,
                38.0569805
              ],
              [
                48.3633346,
                38.0683658
              ],
              [
                48.3702812,
                38.0864271
              ],
              [
                48.370001,
                38.0869753
              ],
              [
                48.3697244,
                38.0892037
              ],
              [
                48.3672244,
                38.0953138
              ],
              [
                48.3661146,
                38.0972547
              ],
              [
                48.3638912,
                38.0994741
              ],
              [
                48.3583347,
                38.1030862
              ],
              [
                48.3563913,
                38.1050361
              ],
              [
                48.3558347,
                38.105036
              ],
              [
                48.3361281,
                38.1256363
              ],
              [
                48.3287025,
                38.1359573
              ],
              [
                48.3268615,
                38.1422776
              ],
              [
                48.3263668,
                38.1477627
              ],
              [
                48.323335,
                38.1466995
              ],
              [
                48.3227783,
                38.1464209
              ],
              [
                48.3219447,
                38.146421
              ],
              [
                48.3200017,
                38.1455944
              ],
              [
                48.3191681,
                38.1453158
              ],
              [
                48.3177783,
                38.1444802
              ],
              [
                48.3177782,
                38.1442017
              ],
              [
                48.3172216,
                38.1442017
              ],
              [
                48.3166684,
                38.1439232
              ],
              [
                48.3124984,
                38.1414255
              ],
              [
                48.2994451,
                38.1194841
              ],
              [
                48.2969454,
                38.1180914
              ],
              [
                48.2949985,
                38.1172559
              ],
              [
                48.2841655,
                38.1155846
              ],
              [
                48.2830552,
                38.1155846
              ],
              [
                48.2811088,
                38.1150365
              ],
              [
                48.2791654,
                38.1150365
              ],
              [
                48.2774989,
                38.1144794
              ],
              [
                48.2766652,
                38.1144794
              ],
              [
                48.2763856,
                38.1142008
              ],
              [
                48.275552,
                38.1142008
              ],
              [
                48.2319394,
                38.0839198
              ],
              [
                48.2297194,
                38.0805862
              ],
              [
                48.2286061,
                38.077531
              ],
              [
                48.2277729,
                38.0744758
              ],
              [
                48.2266628,
                38.0650317
              ],
              [
                48.2230529,
                38.0591997
              ],
              [
                48.2180498,
                38.0558658
              ],
              [
                48.2044396,
                38.0508695
              ],
              [
                48.2033298,
                38.0508695
              ],
              [
                48.2027733,
                38.050591
              ],
              [
                48.2013829,
                38.050591
              ],
              [
                48.2011064,
                38.0503124
              ],
              [
                48.197493,
                38.0503124
              ],
              [
                48.194993,
                38.0511391
              ],
              [
                48.1897166,
                38.0567015
              ],
              [
                48.18916,
                38.0569801
              ],
              [
                48.188883,
                38.0572587
              ],
              [
                48.1886065,
                38.0575372
              ],
              [
                48.1883265,
                38.0578068
              ],
              [
                48.1883264,
                38.0583639
              ],
              [
                48.1880499,
                38.0586425
              ],
              [
                48.1883263,
                38.0636478
              ],
              [
                48.1919398,
                38.0719777
              ],
              [
                48.1944397,
                38.0803075
              ],
              [
                48.1938831,
                38.0828145
              ],
              [
                48.1933265,
                38.0836412
              ],
              [
                48.1927733,
                38.0847554
              ],
              [
                48.1919397,
                38.0869749
              ],
              [
                48.191383,
                38.0880891
              ],
              [
                48.1863832,
                38.0930851
              ],
              [
                48.1861063,
                38.0936422
              ],
              [
                48.1713832,
                38.1000308
              ],
              [
                48.1638835,
                38.1053142
              ],
              [
                48.1572134,
                38.1172556
              ],
              [
                48.1536035,
                38.1211461
              ],
              [
                48.1536035,
                38.1214247
              ],
              [
                48.1497426,
                38.1192464
              ],
              [
                48.1491601,
                38.1189178
              ],
              [
                48.1483269,
                38.1189178
              ],
              [
                48.1236006,
                38.1072549
              ],
              [
                48.1211005,
                38.1058712
              ],
              [
                48.1116573,
                38.1022591
              ],
              [
                48.1063772,
                38.1011448
              ],
              [
                48.1055439,
                38.1011449
              ],
              [
                48.1049908,
                38.1008663
              ],
              [
                48.1030438,
                38.1008663
              ],
              [
                48.1024907,
                38.1005878
              ],
              [
                48.0991575,
                38.1005878
              ],
              [
                48.0983242,
                38.1008663
              ],
              [
                48.095544,
                38.1008663
              ],
              [
                48.0863774,
                38.102259
              ],
              [
                48.0847106,
                38.102259
              ],
              [
                48.0836009,
                38.1025376
              ],
              [
                48.0791542,
                38.1025375
              ],
              [
                48.0758209,
                38.1028071
              ],
              [
                48.0702677,
                38.1036427
              ],
              [
                48.0683208,
                38.1036427
              ],
              [
                48.0627644,
                38.1044784
              ],
              [
                48.0613777,
                38.1044783
              ],
              [
                48.060821,
                38.1047569
              ],
              [
                48.0594311,
                38.1047569
              ],
              [
                48.0330139,
                38.1126459
              ],
              [
                48.0220407,
                38.114365
              ],
              [
                48.0151994,
                38.1147735
              ],
              [
                48.0007607,
                38.115221
              ],
              [
                47.9933186,
                38.1157274
              ],
              [
                48.0033181,
                38.1219814
              ],
              [
                47.9999848,
                38.122817
              ],
              [
                47.9995785,
                38.1230865
              ],
              [
                47.9992188,
                38.125888
              ],
              [
                47.9758187,
                38.1405891
              ],
              [
                47.962762,
                38.1453151
              ],
              [
                47.9566485,
                38.1461417
              ],
              [
                47.9560955,
                38.1464202
              ],
              [
                47.9549821,
                38.1464201
              ],
              [
                47.9544251,
                38.1466986
              ],
              [
                47.9519254,
                38.1466987
              ],
              [
                47.9505388,
                38.1472557
              ],
              [
                47.9485922,
                38.1480913
              ],
              [
                47.9430389,
                38.1508675
              ],
              [
                47.9224821,
                38.1555933
              ],
              [
                47.9210923,
                38.1555934
              ],
              [
                47.9022024,
                38.1619813
              ],
              [
                47.8919224,
                38.1708668
              ],
              [
                47.8905361,
                38.1725379
              ],
              [
                47.8897025,
                38.1739214
              ],
              [
                47.8808128,
                38.1822587
              ],
              [
                47.8794225,
                38.1836422
              ],
              [
                47.8708129,
                38.1889249
              ],
              [
                47.8610896,
                38.1925364
              ],
              [
                47.860533,
                38.1925364
              ],
              [
                47.8599759,
                38.1930934
              ],
              [
                47.8513664,
                38.1950339
              ],
              [
                47.8505328,
                38.1950339
              ],
              [
                47.8502562,
                38.1953124
              ],
              [
                47.8483097,
                38.1953124
              ],
              [
                47.8471995,
                38.1955909
              ],
              [
                47.8419197,
                38.1955909
              ],
              [
                47.8333097,
                38.1936504
              ],
              [
                47.8291432,
                38.1914223
              ],
              [
                47.8266431,
                38.1892033
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555260,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پارس آباد",
          "name:en": "Parsabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277772",
          "wikipedia": "en:Parsabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.5834326,
                39.4086755
              ],
              [
                47.5838474,
                39.4083977
              ],
              [
                47.5841275,
                39.4081199
              ],
              [
                47.5916277,
                39.4061751
              ],
              [
                47.5941273,
                39.4061752
              ],
              [
                47.594961,
                39.4058973
              ],
              [
                47.5974606,
                39.4058973
              ],
              [
                47.5982943,
                39.4056195
              ],
              [
                47.6138509,
                39.4056195
              ],
              [
                47.6141274,
                39.4053416
              ],
              [
                47.6155173,
                39.4053416
              ],
              [
                47.6230171,
                39.4017299
              ],
              [
                47.6238507,
                39.401461
              ],
              [
                47.6244073,
                39.401461
              ],
              [
                47.6255172,
                39.4011743
              ],
              [
                47.6380171,
                39.3956266
              ],
              [
                47.6402406,
                39.3956265
              ],
              [
                47.6432973,
                39.396738
              ],
              [
                47.6449637,
                39.3967379
              ],
              [
                47.6452403,
                39.3964601
              ],
              [
                47.6469071,
                39.3964601
              ],
              [
                47.6471837,
                39.3961823
              ],
              [
                47.6480169,
                39.3961822
              ],
              [
                47.6580203,
                39.3936817
              ],
              [
                47.6613536,
                39.3936817
              ],
              [
                47.6619067,
                39.3939596
              ],
              [
                47.6630204,
                39.3939596
              ],
              [
                47.663297,
                39.3942374
              ],
              [
                47.6646869,
                39.3945063
              ],
              [
                47.6682966,
                39.3942374
              ],
              [
                47.6710733,
                39.3945063
              ],
              [
                47.6721866,
                39.3945064
              ],
              [
                47.6724636,
                39.3947932
              ],
              [
                47.6738535,
                39.3947931
              ],
              [
                47.67413,
                39.395071
              ],
              [
                47.6782965,
                39.395071
              ],
              [
                47.6791302,
                39.3947932
              ],
              [
                47.6802435,
                39.3947932
              ],
              [
                47.6810767,
                39.3945063
              ],
              [
                47.68441,
                39.3939597
              ],
              [
                47.6866299,
                39.3939596
              ],
              [
                47.6871867,
                39.3936818
              ],
              [
                47.6882968,
                39.3936818
              ],
              [
                47.6888534,
                39.393404
              ],
              [
                47.6899632,
                39.393404
              ],
              [
                47.6905199,
                39.3931261
              ],
              [
                47.6913531,
                39.3931262
              ],
              [
                47.7057999,
                39.388403
              ],
              [
                47.7069098,
                39.388403
              ],
              [
                47.7088532,
                39.3872916
              ],
              [
                47.7091332,
                39.3870137
              ],
              [
                47.7163564,
                39.3842354
              ],
              [
                47.7169096,
                39.3839575
              ],
              [
                47.7180233,
                39.3881252
              ],
              [
                47.7182998,
                39.388403
              ],
              [
                47.719133,
                39.3936819
              ],
              [
                47.7194096,
                39.3942375
              ],
              [
                47.719133,
                39.3953489
              ],
              [
                47.7194097,
                39.3961824
              ],
              [
                47.7191331,
                39.3967381
              ],
              [
                47.7188564,
                39.3989607
              ],
              [
                47.7185763,
                39.4009055
              ],
              [
                47.7180231,
                39.4070178
              ],
              [
                47.7177431,
                39.4164549
              ],
              [
                47.7180231,
                39.419511
              ],
              [
                47.7205228,
                39.4328462
              ],
              [
                47.7274662,
                39.4525705
              ],
              [
                47.7277428,
                39.4531261
              ],
              [
                47.7374659,
                39.4750718
              ],
              [
                47.7407111,
                39.4780469
              ],
              [
                47.7474657,
                39.4842387
              ],
              [
                47.757189,
                39.488961
              ],
              [
                47.7580223,
                39.4892387
              ],
              [
                47.7613556,
                39.4906276
              ],
              [
                47.7771922,
                39.4942387
              ],
              [
                47.7785785,
                39.4942387
              ],
              [
                47.7827455,
                39.4956276
              ],
              [
                47.7838588,
                39.4956277
              ],
              [
                47.7944152,
                39.500072
              ],
              [
                47.7977486,
                39.5022942
              ],
              [
                47.7985818,
                39.502572
              ],
              [
                47.8091386,
                39.5175714
              ],
              [
                47.8183048,
                39.523682
              ],
              [
                47.8184484,
                39.5238259
              ],
              [
                47.8185818,
                39.5239597
              ],
              [
                47.8210815,
                39.5250708
              ],
              [
                47.8226265,
                39.5246001
              ],
              [
                47.8231832,
                39.5250056
              ],
              [
                47.824409,
                39.5243854
              ],
              [
                47.827971,
                39.5245261
              ],
              [
                47.8299631,
                39.5222797
              ],
              [
                47.8315863,
                39.5203926
              ],
              [
                47.834816,
                39.5172492
              ],
              [
                47.8391896,
                39.5139221
              ],
              [
                47.8435014,
                39.5126345
              ],
              [
                47.8461799,
                39.5125186
              ],
              [
                47.847682,
                39.513681
              ],
              [
                47.8486775,
                39.5147654
              ],
              [
                47.849382,
                39.5155434
              ],
              [
                47.8513871,
                39.5161963
              ],
              [
                47.8540453,
                39.5166396
              ],
              [
                47.8561659,
                39.5174218
              ],
              [
                47.8582082,
                39.5177331
              ],
              [
                47.8613588,
                39.517593
              ],
              [
                47.863848,
                39.5183632
              ],
              [
                47.8666223,
                39.5193776
              ],
              [
                47.8680109,
                39.5193528
              ],
              [
                47.8699605,
                39.5184413
              ],
              [
                47.8778196,
                39.516517
              ],
              [
                47.8796625,
                39.5165407
              ],
              [
                47.8832841,
                39.5163256
              ],
              [
                47.8882634,
                39.5155678
              ],
              [
                47.8982161,
                39.5155512
              ],
              [
                47.9017854,
                39.5150001
              ],
              [
                47.9063344,
                39.5138579
              ],
              [
                47.9126858,
                39.5117555
              ],
              [
                47.9175567,
                39.5091068
              ],
              [
                47.9223871,
                39.5069484
              ],
              [
                47.9253396,
                39.5051881
              ],
              [
                47.9304313,
                39.5028652
              ],
              [
                47.9357435,
                39.5007582
              ],
              [
                47.9398727,
                39.4998187
              ],
              [
                47.9459023,
                39.4981133
              ],
              [
                47.9484129,
                39.4971695
              ],
              [
                47.9495072,
                39.496888
              ],
              [
                47.9514376,
                39.4957037
              ],
              [
                47.9560518,
                39.4941228
              ],
              [
                47.9582405,
                39.4932617
              ],
              [
                47.9600462,
                39.4923646
              ],
              [
                47.9645061,
                39.4912415
              ],
              [
                47.9685808,
                39.4900228
              ],
              [
                47.9729108,
                39.4875886
              ],
              [
                47.9786793,
                39.4849426
              ],
              [
                47.9846496,
                39.4825577
              ],
              [
                47.9859166,
                39.4792989
              ],
              [
                47.9900512,
                39.4812201
              ],
              [
                47.9993093,
                39.4791905
              ],
              [
                48.0037891,
                39.4792236
              ],
              [
                48.0077261,
                39.4791761
              ],
              [
                48.009632,
                39.4784142
              ],
              [
                48.0131659,
                39.4778052
              ],
              [
                48.0165274,
                39.4781199
              ],
              [
                48.0200675,
                39.4793607
              ],
              [
                48.0249316,
                39.4799923
              ],
              [
                48.0279451,
                39.4800042
              ],
              [
                48.0309554,
                39.4809069
              ],
              [
                48.0328297,
                39.4804849
              ],
              [
                48.0338524,
                39.4810687
              ],
              [
                48.0342136,
                39.4815701
              ],
              [
                48.0368528,
                39.4825514
              ],
              [
                48.0413511,
                39.4792055
              ],
              [
                48.0441945,
                39.4784603
              ],
              [
                48.0465916,
                39.4774243
              ],
              [
                48.0485622,
                39.4761655
              ],
              [
                48.0499474,
                39.4746319
              ],
              [
                48.0527309,
                39.4704985
              ],
              [
                48.0542593,
                39.4676403
              ],
              [
                48.0571505,
                39.465214
              ],
              [
                48.0593012,
                39.4648966
              ],
              [
                48.0616049,
                39.4650936
              ],
              [
                48.0629968,
                39.4658183
              ],
              [
                48.0648207,
                39.4689656
              ],
              [
                48.0656576,
                39.4713178
              ],
              [
                48.0683374,
                39.4748033
              ],
              [
                48.0701946,
                39.4779661
              ],
              [
                48.0698271,
                39.48077
              ],
              [
                48.0689835,
                39.4828951
              ],
              [
                48.0691981,
                39.4872175
              ],
              [
                48.0686785,
                39.4924279
              ],
              [
                48.067975,
                39.4941559
              ],
              [
                48.0673098,
                39.4985604
              ],
              [
                48.0691517,
                39.5050063
              ],
              [
                48.0695798,
                39.5076028
              ],
              [
                48.0712473,
                39.5090654
              ],
              [
                48.0728235,
                39.5096286
              ],
              [
                48.075458,
                39.5112391
              ],
              [
                48.0780666,
                39.5139564
              ],
              [
                48.0827246,
                39.515546
              ],
              [
                48.0889019,
                39.5199689
              ],
              [
                48.1088756,
                39.5292378
              ],
              [
                48.1433185,
                39.5431253
              ],
              [
                48.1472085,
                39.5459027
              ],
              [
                48.1494316,
                39.5492356
              ],
              [
                48.1499883,
                39.5509021
              ],
              [
                48.1505417,
                39.5517352
              ],
              [
                48.1505418,
                39.5522908
              ],
              [
                48.1535985,
                39.5547994
              ],
              [
                48.1545666,
                39.5554913
              ],
              [
                48.1728967,
                39.5663814
              ],
              [
                48.1745922,
                39.5672513
              ],
              [
                48.1755484,
                39.5678729
              ],
              [
                48.1370862,
                39.602
              ],
              [
                48.1271866,
                39.6068288
              ],
              [
                48.1190778,
                39.6141473
              ],
              [
                48.0951619,
                39.6354594
              ],
              [
                48.0868736,
                39.6428802
              ],
              [
                48.0805903,
                39.6484605
              ],
              [
                48.068392,
                39.6594793
              ],
              [
                48.0622791,
                39.6649358
              ],
              [
                48.0488871,
                39.6768808
              ],
              [
                48.0422669,
                39.6828259
              ],
              [
                48.0316267,
                39.6922285
              ],
              [
                47.9984402,
                39.7045285
              ],
              [
                47.9897964,
                39.7076149
              ],
              [
                47.9856061,
                39.709146
              ],
              [
                47.9821222,
                39.7090003
              ],
              [
                47.9815228,
                39.7072158
              ],
              [
                47.9798896,
                39.7061476
              ],
              [
                47.9806288,
                39.7050874
              ],
              [
                47.9804798,
                39.7039093
              ],
              [
                47.9785812,
                39.7016562
              ],
              [
                47.9760733,
                39.7009088
              ],
              [
                47.974088,
                39.6993454
              ],
              [
                47.9736028,
                39.6969993
              ],
              [
                47.9737014,
                39.6939518
              ],
              [
                47.9729523,
                39.6928617
              ],
              [
                47.9716699,
                39.6920246
              ],
              [
                47.9671228,
                39.6928782
              ],
              [
                47.9635195,
                39.6922164
              ],
              [
                47.9616601,
                39.6900503
              ],
              [
                47.9608897,
                39.68593
              ],
              [
                47.9580829,
                39.6851506
              ],
              [
                47.9548022,
                39.6836879
              ],
              [
                47.9500178,
                39.6804673
              ],
              [
                47.947699,
                39.6796777
              ],
              [
                47.9464761,
                39.6801535
              ],
              [
                47.9445448,
                39.6830041
              ],
              [
                47.9427999,
                39.6834684
              ],
              [
                47.9406182,
                39.6829105
              ],
              [
                47.9389386,
                39.6813534
              ],
              [
                47.9373351,
                39.6750449
              ],
              [
                47.9353226,
                39.6720802
              ],
              [
                47.9293835,
                39.6658206
              ],
              [
                47.9280497,
                39.6658677
              ],
              [
                47.9272923,
                39.6666071
              ],
              [
                47.9276342,
                39.6682324
              ],
              [
                47.9273393,
                39.6694157
              ],
              [
                47.9261092,
                39.6702496
              ],
              [
                47.9247705,
                39.6710871
              ],
              [
                47.9234488,
                39.670712
              ],
              [
                47.9220547,
                39.6686772
              ],
              [
                47.9216075,
                39.6656374
              ],
              [
                47.9210908,
                39.6642779
              ],
              [
                47.9204016,
                39.6632005
              ],
              [
                47.9174231,
                39.6614998
              ],
              [
                47.9156627,
                39.6614079
              ],
              [
                47.9145743,
                39.6613511
              ],
              [
                47.9067093,
                39.6625873
              ],
              [
                47.9007768,
                39.6648826
              ],
              [
                47.8989861,
                39.6649341
              ],
              [
                47.8961014,
                39.6631663
              ],
              [
                47.8934783,
                39.6618461
              ],
              [
                47.892077,
                39.6619075
              ],
              [
                47.8907759,
                39.6625935
              ],
              [
                47.8904629,
                39.6636657
              ],
              [
                47.8913276,
                39.6654713
              ],
              [
                47.8905456,
                39.6662495
              ],
              [
                47.8869289,
                39.665829
              ],
              [
                47.8852772,
                39.6661445
              ],
              [
                47.8842309,
                39.6671661
              ],
              [
                47.8842256,
                39.66957
              ],
              [
                47.8836436,
                39.6702901
              ],
              [
                47.881938,
                39.6706601
              ],
              [
                47.8800024,
                39.670673
              ],
              [
                47.8705843,
                39.6673582
              ],
              [
                47.8704847,
                39.6672874
              ],
              [
                47.8670816,
                39.6648693
              ],
              [
                47.8653717,
                39.6645469
              ],
              [
                47.86378,
                39.6645415
              ],
              [
                47.8612282,
                39.6665549
              ],
              [
                47.8582512,
                39.6680456
              ],
              [
                47.8564645,
                39.6684205
              ],
              [
                47.8549642,
                39.6673588
              ],
              [
                47.8542912,
                39.6648803
              ],
              [
                47.8531618,
                39.6642648
              ],
              [
                47.8521957,
                39.6642399
              ],
              [
                47.8490975,
                39.6657234
              ],
              [
                47.8475559,
                39.6659795
              ],
              [
                47.8456992,
                39.6654813
              ],
              [
                47.8376276,
                39.66163
              ],
              [
                47.8377395,
                39.6598409
              ],
              [
                47.8369262,
                39.6588828
              ],
              [
                47.8337345,
                39.6596784
              ],
              [
                47.8309258,
                39.6611635
              ],
              [
                47.829286,
                39.6606037
              ],
              [
                47.8265281,
                39.6606127
              ],
              [
                47.8245321,
                39.661616
              ],
              [
                47.8217986,
                39.6614963
              ],
              [
                47.8213265,
                39.660229
              ],
              [
                47.8218635,
                39.658998
              ],
              [
                47.8211375,
                39.6578786
              ],
              [
                47.8200156,
                39.6570057
              ],
              [
                47.8187168,
                39.6563584
              ],
              [
                47.8166913,
                39.6560128
              ],
              [
                47.8151634,
                39.6564373
              ],
              [
                47.8126504,
                39.6589767
              ],
              [
                47.8103114,
                39.6596595
              ],
              [
                47.8073216,
                39.6591904
              ],
              [
                47.806456,
                39.6583584
              ],
              [
                47.8060431,
                39.657497
              ],
              [
                47.8066225,
                39.6560211
              ],
              [
                47.8086757,
                39.6546185
              ],
              [
                47.8091634,
                39.6532848
              ],
              [
                47.8081522,
                39.6512128
              ],
              [
                47.8064087,
                39.6505589
              ],
              [
                47.8009623,
                39.6516644
              ],
              [
                47.7977843,
                39.6498605
              ],
              [
                47.7951841,
                39.6489852
              ],
              [
                47.7939968,
                39.648295
              ],
              [
                47.7944195,
                39.645353
              ],
              [
                47.7953469,
                39.6445095
              ],
              [
                47.7952144,
                39.6436863
              ],
              [
                47.7943419,
                39.6422899
              ],
              [
                47.790225,
                39.6415683
              ],
              [
                47.7889648,
                39.6417538
              ],
              [
                47.7870726,
                39.6429023
              ],
              [
                47.7858912,
                39.6430749
              ],
              [
                47.7846002,
                39.6420958
              ],
              [
                47.7839648,
                39.6399899
              ],
              [
                47.7832698,
                39.6389851
              ],
              [
                47.7833047,
                39.6375735
              ],
              [
                47.7859763,
                39.6343092
              ],
              [
                47.7851887,
                39.6329715
              ],
              [
                47.7831718,
                39.6320441
              ],
              [
                47.7822949,
                39.6306698
              ],
              [
                47.7827554,
                39.6269438
              ],
              [
                47.7818056,
                39.6254238
              ],
              [
                47.7781398,
                39.6243867
              ],
              [
                47.7751207,
                39.624463
              ],
              [
                47.7724422,
                39.6267149
              ],
              [
                47.7703036,
                39.6265627
              ],
              [
                47.7667662,
                39.6232932
              ],
              [
                47.7638983,
                39.6226147
              ],
              [
                47.7626791,
                39.6216049
              ],
              [
                47.7622771,
                39.619715
              ],
              [
                47.7623779,
                39.6170823
              ],
              [
                47.7600698,
                39.6154731
              ],
              [
                47.757694,
                39.6123114
              ],
              [
                47.752969,
                39.606023
              ],
              [
                47.7488031,
                39.6048321
              ],
              [
                47.7438107,
                39.6019979
              ],
              [
                47.7382045,
                39.5978525
              ],
              [
                47.7267626,
                39.5965523
              ],
              [
                47.7260488,
                39.5948568
              ],
              [
                47.7158801,
                39.5894546
              ],
              [
                47.7122848,
                39.5919465
              ],
              [
                47.7110735,
                39.5919417
              ],
              [
                47.70623,
                39.5897996
              ],
              [
                47.7043418,
                39.5853129
              ],
              [
                47.7000315,
                39.5849335
              ],
              [
                47.6953864,
                39.5856956
              ],
              [
                47.690822,
                39.5875997
              ],
              [
                47.688767,
                39.5871823
              ],
              [
                47.6872097,
                39.5833106
              ],
              [
                47.683929,
                39.582163
              ],
              [
                47.6821785,
                39.579786
              ],
              [
                47.6798198,
                39.5781003
              ],
              [
                47.6764872,
                39.577494
              ],
              [
                47.6740371,
                39.5785064
              ],
              [
                47.6727821,
                39.5788537
              ],
              [
                47.6722379,
                39.578827
              ],
              [
                47.6713732,
                39.578646
              ],
              [
                47.6702124,
                39.5781315
              ],
              [
                47.6680746,
                39.5765808
              ],
              [
                47.6663986,
                39.5756181
              ],
              [
                47.6647226,
                39.5742193
              ],
              [
                47.6624943,
                39.5720186
              ],
              [
                47.6597666,
                39.5665631
              ],
              [
                47.6567379,
                39.5642199
              ],
              [
                47.6493905,
                39.5616959
              ],
              [
                47.6466707,
                39.5632393
              ],
              [
                47.6439572,
                39.5629557
              ],
              [
                47.6403072,
                39.5577743
              ],
              [
                47.6305445,
                39.5539267
              ],
              [
                47.6256768,
                39.5536143
              ],
              [
                47.6243193,
                39.5528063
              ],
              [
                47.6200787,
                39.5459405
              ],
              [
                47.6174203,
                39.5447009
              ],
              [
                47.61297,
                39.5390449
              ],
              [
                47.6120516,
                39.5388494
              ],
              [
                47.6103432,
                39.539445
              ],
              [
                47.6094999,
                39.5410385
              ],
              [
                47.6085447,
                39.5418984
              ],
              [
                47.6052974,
                39.542684
              ],
              [
                47.601585,
                39.5406725
              ],
              [
                47.5982943,
                39.538285
              ],
              [
                47.5956295,
                39.537732
              ],
              [
                47.5944747,
                39.5373435
              ],
              [
                47.5926145,
                39.5353876
              ],
              [
                47.5865502,
                39.5328854
              ],
              [
                47.586347,
                39.5267368
              ],
              [
                47.583847,
                39.5192373
              ],
              [
                47.5841271,
                39.5070158
              ],
              [
                47.5846807,
                39.5045159
              ],
              [
                47.5846807,
                39.5003493
              ],
              [
                47.5852374,
                39.499516
              ],
              [
                47.5863471,
                39.4959049
              ],
              [
                47.5866272,
                39.4953494
              ],
              [
                47.5866272,
                39.494516
              ],
              [
                47.5871804,
                39.4928494
              ],
              [
                47.5874605,
                39.4922938
              ],
              [
                47.5877375,
                39.4920161
              ],
              [
                47.6060703,
                39.4711824
              ],
              [
                47.606904,
                39.4709047
              ],
              [
                47.6082938,
                39.469238
              ],
              [
                47.6080173,
                39.467849
              ],
              [
                47.606627,
                39.4653489
              ],
              [
                47.606904,
                39.4647933
              ],
              [
                47.606627,
                39.4645155
              ],
              [
                47.6085705,
                39.4617375
              ],
              [
                47.6146838,
                39.4559038
              ],
              [
                47.6163504,
                39.4511813
              ],
              [
                47.6163504,
                39.4453473
              ],
              [
                47.6038505,
                39.4347906
              ],
              [
                47.6032938,
                39.4342349
              ],
              [
                47.5832942,
                39.4142321
              ],
              [
                47.582461,
                39.4106204
              ],
              [
                47.5834326,
                39.4086755
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555285,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گرمی",
          "name:en": "Garmi County",
          "name:ru": "Герми",
          "name:uk": "Ґермі",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1274543",
          "wikipedia": "en:Germi County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8093364,
                38.8269858
              ],
              [
                47.8319174,
                38.8389453
              ],
              [
                47.8327506,
                38.8389453
              ],
              [
                47.8408071,
                38.8425524
              ],
              [
                47.8502538,
                38.845334
              ],
              [
                47.8516406,
                38.845334
              ],
              [
                47.8541406,
                38.8458903
              ],
              [
                47.8635869,
                38.8458903
              ],
              [
                47.8683104,
                38.8456122
              ],
              [
                47.8685871,
                38.845334
              ],
              [
                47.8696967,
                38.845334
              ],
              [
                47.8705304,
                38.8450559
              ],
              [
                47.8777536,
                38.8450558
              ],
              [
                47.8783103,
                38.845334
              ],
              [
                47.8785868,
                38.8450559
              ],
              [
                47.8816436,
                38.8450558
              ],
              [
                47.8880335,
                38.8472722
              ],
              [
                47.8891434,
                38.8475504
              ],
              [
                47.8994233,
                38.8561641
              ],
              [
                47.9188662,
                38.8661685
              ],
              [
                47.9196998,
                38.8663767
              ],
              [
                47.9266465,
                38.868941
              ],
              [
                47.9310896,
                38.8711662
              ],
              [
                47.9358131,
                38.8731132
              ],
              [
                47.9402561,
                38.8750512
              ],
              [
                47.9452562,
                38.8781107
              ],
              [
                47.9463695,
                38.8783889
              ],
              [
                47.9597026,
                38.8881146
              ],
              [
                47.9619261,
                38.8889401
              ],
              [
                47.9627593,
                38.8889401
              ],
              [
                47.9655359,
                38.8894964
              ],
              [
                47.9660926,
                38.8897745
              ],
              [
                47.9683126,
                38.8897745
              ],
              [
                47.9685926,
                38.8894964
              ],
              [
                47.9710923,
                38.8894964
              ],
              [
                47.9713693,
                38.8892182
              ],
              [
                47.9727591,
                38.8892182
              ],
              [
                47.973869,
                38.8889401
              ],
              [
                47.9749792,
                38.8889401
              ],
              [
                47.9755357,
                38.888662
              ],
              [
                47.9777589,
                38.888662
              ],
              [
                47.9847024,
                38.8870022
              ],
              [
                47.9866489,
                38.8870022
              ],
              [
                47.9877591,
                38.8872803
              ],
              [
                47.9910924,
                38.8872803
              ],
              [
                47.9999995,
                38.890449
              ],
              [
                48.0031753,
                38.8911896
              ],
              [
                48.0058187,
                38.8910747
              ],
              [
                48.0072057,
                38.8908871
              ],
              [
                48.0118328,
                38.8909225
              ],
              [
                48.0107745,
                38.9004693
              ],
              [
                48.01027,
                38.907306
              ],
              [
                48.019223,
                38.9120261
              ],
              [
                48.0226406,
                38.9098258
              ],
              [
                48.0282078,
                38.8994282
              ],
              [
                48.0380272,
                38.9008003
              ],
              [
                48.0498167,
                38.9049984
              ],
              [
                48.0540902,
                38.908744
              ],
              [
                48.0629311,
                38.9105692
              ],
              [
                48.0692648,
                38.9109368
              ],
              [
                48.0795509,
                38.9172993
              ],
              [
                48.078535,
                38.9207416
              ],
              [
                48.0799833,
                38.9240089
              ],
              [
                48.0783123,
                38.9272383
              ],
              [
                48.0796942,
                38.9302334
              ],
              [
                48.0824656,
                38.9338592
              ],
              [
                48.0815724,
                38.9372849
              ],
              [
                48.0848494,
                38.9392544
              ],
              [
                48.0871923,
                38.9445813
              ],
              [
                48.0882345,
                38.9469508
              ],
              [
                48.1073052,
                38.9431561
              ],
              [
                48.1113935,
                38.9461589
              ],
              [
                48.1227535,
                38.9469538
              ],
              [
                48.1247362,
                38.9466804
              ],
              [
                48.127939,
                38.945918
              ],
              [
                48.1293556,
                38.946455
              ],
              [
                48.1313267,
                38.9469248
              ],
              [
                48.1347513,
                38.9480754
              ],
              [
                48.138089,
                38.9479156
              ],
              [
                48.1395288,
                38.9469649
              ],
              [
                48.1426918,
                38.9463385
              ],
              [
                48.1431281,
                38.9462776
              ],
              [
                48.1436752,
                38.946255
              ],
              [
                48.144194,
                38.9461934
              ],
              [
                48.1449112,
                38.9458785
              ],
              [
                48.1456799,
                38.9458717
              ],
              [
                48.1471086,
                38.9461598
              ],
              [
                48.1496539,
                38.9479364
              ],
              [
                48.1519715,
                38.9492072
              ],
              [
                48.152847,
                38.9518138
              ],
              [
                48.152481,
                38.952757
              ],
              [
                48.1548124,
                38.9530575
              ],
              [
                48.1565422,
                38.9540406
              ],
              [
                48.1587811,
                38.9538064
              ],
              [
                48.159215,
                38.9532749
              ],
              [
                48.1611304,
                38.9529714
              ],
              [
                48.1632172,
                38.9535003
              ],
              [
                48.1651341,
                38.9548658
              ],
              [
                48.1682119,
                38.9551415
              ],
              [
                48.1710632,
                38.9557254
              ],
              [
                48.1737917,
                38.955175
              ],
              [
                48.1767835,
                38.9546729
              ],
              [
                48.1781374,
                38.9552131
              ],
              [
                48.1794589,
                38.9560189
              ],
              [
                48.1825617,
                38.9557547
              ],
              [
                48.1851767,
                38.9562114
              ],
              [
                48.190793,
                38.9560432
              ],
              [
                48.2064008,
                38.9532876
              ],
              [
                48.2086872,
                38.9540167
              ],
              [
                48.2109092,
                38.9556468
              ],
              [
                48.2128179,
                38.9555788
              ],
              [
                48.2176851,
                38.9554053
              ],
              [
                48.2294145,
                38.95977
              ],
              [
                48.2327512,
                38.9597761
              ],
              [
                48.235745,
                38.9610004
              ],
              [
                48.2369545,
                38.9637748
              ],
              [
                48.2395571,
                38.9649726
              ],
              [
                48.2532906,
                38.964558
              ],
              [
                48.2585654,
                38.9667263
              ],
              [
                48.2707532,
                38.9673018
              ],
              [
                48.2772997,
                38.9725795
              ],
              [
                48.2853084,
                38.9755466
              ],
              [
                48.2888279,
                38.977536
              ],
              [
                48.2925906,
                38.9796628
              ],
              [
                48.2936239,
                38.9815289
              ],
              [
                48.2962055,
                38.983356
              ],
              [
                48.2973833,
                38.9829474
              ],
              [
                48.2984228,
                38.9836805
              ],
              [
                48.2982769,
                38.986048
              ],
              [
                48.3077952,
                38.9961588
              ],
              [
                48.3106045,
                38.9982821
              ],
              [
                48.3167221,
                39.0019411
              ],
              [
                48.3171236,
                39.0052373
              ],
              [
                48.3262227,
                39.0113991
              ],
              [
                48.3290971,
                39.015785
              ],
              [
                48.3332227,
                39.0211657
              ],
              [
                48.3352662,
                39.0249188
              ],
              [
                48.3374625,
                39.0292592
              ],
              [
                48.3370493,
                39.0319564
              ],
              [
                48.3392349,
                39.034108
              ],
              [
                48.3379248,
                39.0373704
              ],
              [
                48.3351548,
                39.0393539
              ],
              [
                48.3344401,
                39.0436525
              ],
              [
                48.332753,
                39.0465774
              ],
              [
                48.3324292,
                39.0509497
              ],
              [
                48.3311047,
                39.0514506
              ],
              [
                48.3309699,
                39.0531113
              ],
              [
                48.3279531,
                39.05243
              ],
              [
                48.326489,
                39.0526846
              ],
              [
                48.3258756,
                39.0534923
              ],
              [
                48.3266223,
                39.0557804
              ],
              [
                48.3273704,
                39.0558168
              ],
              [
                48.3276891,
                39.0566609
              ],
              [
                48.3266631,
                39.0568829
              ],
              [
                48.3267465,
                39.0572901
              ],
              [
                48.3264673,
                39.0577199
              ],
              [
                48.3252258,
                39.0571835
              ],
              [
                48.3240566,
                39.0573299
              ],
              [
                48.3229835,
                39.0601883
              ],
              [
                48.3247732,
                39.0600828
              ],
              [
                48.3225857,
                39.0674917
              ],
              [
                48.3213057,
                39.0670646
              ],
              [
                48.3194553,
                39.0681359
              ],
              [
                48.3200965,
                39.069395
              ],
              [
                48.3186515,
                39.0709973
              ],
              [
                48.3193044,
                39.0720303
              ],
              [
                48.3192445,
                39.0722247
              ],
              [
                48.3182938,
                39.0753109
              ],
              [
                48.3167804,
                39.0764186
              ],
              [
                48.3154117,
                39.0785071
              ],
              [
                48.3180867,
                39.0791354
              ],
              [
                48.3166385,
                39.0825647
              ],
              [
                48.3167452,
                39.0851316
              ],
              [
                48.3154651,
                39.086208
              ],
              [
                48.3135982,
                39.0883194
              ],
              [
                48.3109847,
                39.0873672
              ],
              [
                48.3098113,
                39.0885678
              ],
              [
                48.310878,
                39.0901409
              ],
              [
                48.3102913,
                39.0911759
              ],
              [
                48.3082908,
                39.0903041
              ],
              [
                48.3048509,
                39.0911345
              ],
              [
                48.3045889,
                39.094138
              ],
              [
                48.3033041,
                39.0958951
              ],
              [
                48.3060776,
                39.0958537
              ],
              [
                48.305971,
                39.0971783
              ],
              [
                48.3042108,
                39.0979234
              ],
              [
                48.304522,
                39.09954
              ],
              [
                48.3074111,
                39.1019799
              ],
              [
                48.3048509,
                39.1028491
              ],
              [
                48.3066764,
                39.1039847
              ],
              [
                48.3074073,
                39.104364
              ],
              [
                48.3076563,
                39.1043264
              ],
              [
                48.3078293,
                39.1043389
              ],
              [
                48.3079377,
                39.1044159
              ],
              [
                48.3079307,
                39.1046091
              ],
              [
                48.3078362,
                39.1049312
              ],
              [
                48.3077422,
                39.1049641
              ],
              [
                48.3072713,
                39.1049688
              ],
              [
                48.3067663,
                39.1051745
              ],
              [
                48.3063582,
                39.1049956
              ],
              [
                48.3061437,
                39.105001
              ],
              [
                48.3057576,
                39.1053739
              ],
              [
                48.3057062,
                39.1055798
              ],
              [
                48.3059541,
                39.1057291
              ],
              [
                48.3061497,
                39.105843
              ],
              [
                48.306091,
                39.1060429
              ],
              [
                48.3061334,
                39.1062832
              ],
              [
                48.3066817,
                39.1064958
              ],
              [
                48.3071932,
                39.1066198
              ],
              [
                48.307516,
                39.1068526
              ],
              [
                48.3080476,
                39.1067893
              ],
              [
                48.3082693,
                39.1068349
              ],
              [
                48.3083318,
                39.1069544
              ],
              [
                48.3083537,
                39.1072621
              ],
              [
                48.3082559,
                39.1074797
              ],
              [
                48.3080668,
                39.1074797
              ],
              [
                48.3078907,
                39.1076872
              ],
              [
                48.3078667,
                39.1081982
              ],
              [
                48.3077928,
                39.1085272
              ],
              [
                48.3075972,
                39.1086386
              ],
              [
                48.3073168,
                39.1086031
              ],
              [
                48.3068928,
                39.1085424
              ],
              [
                48.3066972,
                39.1082641
              ],
              [
                48.3063907,
                39.1078946
              ],
              [
                48.3061037,
                39.1077631
              ],
              [
                48.3058233,
                39.107839
              ],
              [
                48.3056407,
                39.108011
              ],
              [
                48.3057322,
                39.1084881
              ],
              [
                48.3056211,
                39.1086993
              ],
              [
                48.3051189,
                39.1089371
              ],
              [
                48.3046754,
                39.1090738
              ],
              [
                48.3028825,
                39.108973
              ],
              [
                48.3028303,
                39.1092868
              ],
              [
                48.3029738,
                39.1104051
              ],
              [
                48.3029282,
                39.1108302
              ],
              [
                48.3026738,
                39.1109922
              ],
              [
                48.3022825,
                39.1110478
              ],
              [
                48.2995663,
                39.1115028
              ],
              [
                48.2991971,
                39.1138995
              ],
              [
                48.2965442,
                39.1134519
              ],
              [
                48.2892642,
                39.1169153
              ],
              [
                48.2858627,
                39.1147686
              ],
              [
                48.2841559,
                39.1155549
              ],
              [
                48.2860227,
                39.1175413
              ],
              [
                48.2830704,
                39.1195745
              ],
              [
                48.2812756,
                39.1192379
              ],
              [
                48.2793021,
                39.1203552
              ],
              [
                48.2799955,
                39.1225897
              ],
              [
                48.2758189,
                39.1234284
              ],
              [
                48.2746084,
                39.1221345
              ],
              [
                48.2722616,
                39.1230035
              ],
              [
                48.2728991,
                39.1246744
              ],
              [
                48.2677279,
                39.124038
              ],
              [
                48.2664147,
                39.1259872
              ],
              [
                48.265061,
                39.124038
              ],
              [
                48.2606873,
                39.1232932
              ],
              [
                48.2594605,
                39.1252793
              ],
              [
                48.2587138,
                39.1238311
              ],
              [
                48.2568038,
                39.1237637
              ],
              [
                48.2565056,
                39.1256549
              ],
              [
                48.2508732,
                39.1256517
              ],
              [
                48.2472462,
                39.1285895
              ],
              [
                48.2439612,
                39.1275703
              ],
              [
                48.2424992,
                39.1299135
              ],
              [
                48.2387655,
                39.1302445
              ],
              [
                48.2349786,
                39.1296652
              ],
              [
                48.2341369,
                39.1306144
              ],
              [
                48.2358853,
                39.1315271
              ],
              [
                48.2339118,
                39.1335957
              ],
              [
                48.2306589,
                39.133771
              ],
              [
                48.2289216,
                39.1380616
              ],
              [
                48.2292181,
                39.1413734
              ],
              [
                48.2258573,
                39.1423763
              ],
              [
                48.2250044,
                39.1450137
              ],
              [
                48.2270822,
                39.14705
              ],
              [
                48.2210042,
                39.1485341
              ],
              [
                48.2209985,
                39.1512466
              ],
              [
                48.2184972,
                39.1535759
              ],
              [
                48.2164704,
                39.1601107
              ],
              [
                48.2184151,
                39.1627439
              ],
              [
                48.2138379,
                39.1632016
              ],
              [
                48.2134918,
                39.1667067
              ],
              [
                48.2100165,
                39.1672237
              ],
              [
                48.203616,
                39.1723513
              ],
              [
                48.2033849,
                39.1746353
              ],
              [
                48.1987708,
                39.1758662
              ],
              [
                48.1942819,
                39.1748323
              ],
              [
                48.1931619,
                39.1765276
              ],
              [
                48.1900683,
                39.1762381
              ],
              [
                48.1906908,
                39.1784617
              ],
              [
                48.1860679,
                39.180042
              ],
              [
                48.185491,
                39.1818007
              ],
              [
                48.1814511,
                39.1825413
              ],
              [
                48.1778698,
                39.1840991
              ],
              [
                48.1756671,
                39.1856234
              ],
              [
                48.1749157,
                39.1877112
              ],
              [
                48.172156,
                39.1881704
              ],
              [
                48.1703091,
                39.1873122
              ],
              [
                48.1699307,
                39.1885123
              ],
              [
                48.1716421,
                39.1897558
              ],
              [
                48.1689594,
                39.1920887
              ],
              [
                48.1673244,
                39.1911694
              ],
              [
                48.1665683,
                39.188941
              ],
              [
                48.1651093,
                39.1906036
              ],
              [
                48.1628377,
                39.1892835
              ],
              [
                48.1599867,
                39.1929407
              ],
              [
                48.1618712,
                39.1940283
              ],
              [
                48.1581544,
                39.1948466
              ],
              [
                48.1608555,
                39.1969394
              ],
              [
                48.1568789,
                39.1985966
              ],
              [
                48.1537987,
                39.1976943
              ],
              [
                48.1502833,
                39.1982545
              ],
              [
                48.1486109,
                39.2000646
              ],
              [
                48.1498555,
                39.2009897
              ],
              [
                48.1460902,
                39.2030557
              ],
              [
                48.1465959,
                39.204069
              ],
              [
                48.1448115,
                39.2039946
              ],
              [
                48.1434817,
                39.2052906
              ],
              [
                48.1448663,
                39.2058855
              ],
              [
                48.144455,
                39.2066397
              ],
              [
                48.1421725,
                39.2065809
              ],
              [
                48.1421519,
                39.208095
              ],
              [
                48.1408495,
                39.2082012
              ],
              [
                48.1408753,
                39.2084125
              ],
              [
                48.1403004,
                39.2083969
              ],
              [
                48.1392712,
                39.2083671
              ],
              [
                48.1383197,
                39.2084003
              ],
              [
                48.1374864,
                39.2086783
              ],
              [
                48.1349864,
                39.2089472
              ],
              [
                48.1341532,
                39.2086783
              ],
              [
                48.1322097,
                39.2086783
              ],
              [
                48.129153,
                39.2075665
              ],
              [
                48.1299263,
                39.1921272
              ],
              [
                48.1189399,
                39.1893094
              ],
              [
                48.1119024,
                39.1844808
              ],
              [
                48.1030056,
                39.1739545
              ],
              [
                48.1005128,
                39.1713147
              ],
              [
                48.097016,
                39.169285
              ],
              [
                48.0628104,
                39.1684231
              ],
              [
                48.0557635,
                39.1676705
              ],
              [
                48.0503105,
                39.1689838
              ],
              [
                48.0434723,
                39.1669479
              ],
              [
                48.0377859,
                39.1651588
              ],
              [
                48.0271376,
                39.1618037
              ],
              [
                48.0112837,
                39.1584178
              ],
              [
                47.9954909,
                39.1553563
              ],
              [
                47.9730032,
                39.1517622
              ],
              [
                47.9541205,
                39.1494991
              ],
              [
                47.9415892,
                39.1496322
              ],
              [
                47.9368257,
                39.1433917
              ],
              [
                47.9365682,
                39.1336222
              ],
              [
                47.9351949,
                39.1286621
              ],
              [
                47.9370804,
                39.1226817
              ],
              [
                47.9440517,
                39.1129143
              ],
              [
                47.9433274,
                39.1118316
              ],
              [
                47.9405165,
                39.1091843
              ],
              [
                47.9372977,
                39.1052881
              ],
              [
                47.9310437,
                39.0995223
              ],
              [
                47.9286933,
                39.0971453
              ],
              [
                47.9273477,
                39.0946808
              ],
              [
                47.9253736,
                39.0908043
              ],
              [
                47.9257636,
                39.0880357
              ],
              [
                47.926579,
                39.0865918
              ],
              [
                47.9227,
                39.0851748
              ],
              [
                47.9185437,
                39.0815066
              ],
              [
                47.9121493,
                39.072978
              ],
              [
                47.909317,
                39.070679
              ],
              [
                47.905408,
                39.063992
              ],
              [
                47.8991209,
                39.0551805
              ],
              [
                47.8955657,
                39.0473268
              ],
              [
                47.8924759,
                39.0406151
              ],
              [
                47.8879961,
                39.036199
              ],
              [
                47.8843318,
                39.0278726
              ],
              [
                47.8833139,
                39.021429
              ],
              [
                47.8811003,
                39.0124958
              ],
              [
                47.8752677,
                39.0023605
              ],
              [
                47.8717094,
                38.992269
              ],
              [
                47.8689847,
                38.9818936
              ],
              [
                47.8640066,
                38.9703587
              ],
              [
                47.8598868,
                38.9601146
              ],
              [
                47.8544412,
                38.9518715
              ],
              [
                47.8473421,
                38.9434825
              ],
              [
                47.8321525,
                38.9379859
              ],
              [
                47.8114657,
                38.9385379
              ],
              [
                47.8169631,
                38.9351777
              ],
              [
                47.820053,
                38.9319729
              ],
              [
                47.8223881,
                38.9283434
              ],
              [
                47.823778,
                38.9233911
              ],
              [
                47.8245781,
                38.9165486
              ],
              [
                47.8247009,
                38.9136006
              ],
              [
                47.82425,
                38.9108165
              ],
              [
                47.8242012,
                38.9083015
              ],
              [
                47.8244395,
                38.9048846
              ],
              [
                47.8232049,
                38.9000107
              ],
              [
                47.8208015,
                38.8964595
              ],
              [
                47.8151178,
                38.890632
              ],
              [
                47.811993,
                38.8885827
              ],
              [
                47.8109584,
                38.8857869
              ],
              [
                47.8055276,
                38.8864455
              ],
              [
                47.8055277,
                38.8825516
              ],
              [
                47.8058073,
                38.8822735
              ],
              [
                47.8060843,
                38.8800574
              ],
              [
                47.8055276,
                38.8747727
              ],
              [
                47.8052507,
                38.8739473
              ],
              [
                47.8055276,
                38.8731128
              ],
              [
                47.8046941,
                38.8670027
              ],
              [
                47.7994179,
                38.8595017
              ],
              [
                47.7991377,
                38.8572765
              ],
              [
                47.8027512,
                38.8436649
              ],
              [
                47.8027511,
                38.8406052
              ],
              [
                47.8041375,
                38.8364418
              ],
              [
                47.8041376,
                38.8336602
              ],
              [
                47.8044177,
                38.8325564
              ],
              [
                47.8071942,
                38.8289403
              ],
              [
                47.8093364,
                38.8269858
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11147752,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اصلاندوز",
          "name:en": "AslanDuz County",
          "place": "county",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.363399,
                39.4217256
              ],
              [
                47.3663364,
                39.419788
              ],
              [
                47.3796727,
                39.4058968
              ],
              [
                47.4005061,
                39.3733987
              ],
              [
                47.4032828,
                39.3703423
              ],
              [
                47.4041164,
                39.3695088
              ],
              [
                47.4049493,
                39.3683973
              ],
              [
                47.4293961,
                39.3431212
              ],
              [
                47.439111,
                39.3372671
              ],
              [
                47.4387849,
                39.335218
              ],
              [
                47.4374014,
                39.331955
              ],
              [
                47.4338319,
                39.3285859
              ],
              [
                47.4338318,
                39.3285858
              ],
              [
                47.430553,
                39.3250177
              ],
              [
                47.4300068,
                39.3215823
              ],
              [
                47.4300068,
                39.3215822
              ],
              [
                47.4307925,
                39.3186376
              ],
              [
                47.4342933,
                39.3160379
              ],
              [
                47.4412604,
                39.3146716
              ],
              [
                47.4469293,
                39.3123897
              ],
              [
                47.4508565,
                39.3113016
              ],
              [
                47.454152,
                39.3112482
              ],
              [
                47.4591378,
                39.3106373
              ],
              [
                47.463594,
                39.3097876
              ],
              [
                47.4635941,
                39.3097876
              ],
              [
                47.4700137,
                39.3083933
              ],
              [
                47.4756474,
                39.3065347
              ],
              [
                47.4791124,
                39.3043582
              ],
              [
                47.4840637,
                39.3041709
              ],
              [
                47.4867257,
                39.3017425
              ],
              [
                47.4906687,
                39.300441
              ],
              [
                47.4953635,
                39.3000278
              ],
              [
                47.4999372,
                39.2976911
              ],
              [
                47.5049348,
                39.2954356
              ],
              [
                47.5049349,
                39.2954356
              ],
              [
                47.5024554,
                39.2931205
              ],
              [
                47.5018987,
                39.2928425
              ],
              [
                47.4920538,
                39.2866052
              ],
              [
                47.4913457,
                39.286173
              ],
              [
                47.4886135,
                39.283952
              ],
              [
                47.4817778,
                39.2758623
              ],
              [
                47.4817765,
                39.2758608
              ],
              [
                47.4813429,
                39.2753441
              ],
              [
                47.4813425,
                39.2753437
              ],
              [
                47.4813425,
                39.2753436
              ],
              [
                47.4813424,
                39.2753436
              ],
              [
                47.4813421,
                39.2753399
              ],
              [
                47.4810658,
                39.2725645
              ],
              [
                47.4821758,
                39.2706193
              ],
              [
                47.4852324,
                39.2686738
              ],
              [
                47.4866223,
                39.2672842
              ],
              [
                47.4868992,
                39.2664505
              ],
              [
                47.4882891,
                39.2650608
              ],
              [
                47.4888459,
                39.2639495
              ],
              [
                47.4893989,
                39.2636714
              ],
              [
                47.4905127,
                39.2611701
              ],
              [
                47.4905127,
                39.2608924
              ],
              [
                47.4907892,
                39.2600584
              ],
              [
                47.5077548,
                39.2431443
              ],
              [
                47.5084416,
                39.2403773
              ],
              [
                47.5088455,
                39.2389542
              ],
              [
                47.5091403,
                39.2369903
              ],
              [
                47.5099533,
                39.2343706
              ],
              [
                47.5116521,
                39.2309754
              ],
              [
                47.5144958,
                39.2258705
              ],
              [
                47.5172189,
                39.2213192
              ],
              [
                47.5203445,
                39.2215048
              ],
              [
                47.5262579,
                39.2217874
              ],
              [
                47.5282729,
                39.2218825
              ],
              [
                47.5308978,
                39.2218743
              ],
              [
                47.5352789,
                39.2218373
              ],
              [
                47.53804,
                39.2218915
              ],
              [
                47.5403777,
                39.2220245
              ],
              [
                47.542777,
                39.2230113
              ],
              [
                47.5462317,
                39.222496
              ],
              [
                47.5505447,
                39.2227952
              ],
              [
                47.5556002,
                39.2239835
              ],
              [
                47.5674323,
                39.2261369
              ],
              [
                47.5704089,
                39.2254387
              ],
              [
                47.5724008,
                39.224786
              ],
              [
                47.5751847,
                39.2233231
              ],
              [
                47.5771778,
                39.2226036
              ],
              [
                47.5796933,
                39.2217392
              ],
              [
                47.5818573,
                39.2204473
              ],
              [
                47.5846659,
                39.2186519
              ],
              [
                47.5872469,
                39.2170834
              ],
              [
                47.5902791,
                39.2151949
              ],
              [
                47.5927217,
                39.2136321
              ],
              [
                47.5955957,
                39.211891
              ],
              [
                47.6012308,
                39.2083364
              ],
              [
                47.6034808,
                39.2093376
              ],
              [
                47.6046188,
                39.2108947
              ],
              [
                47.6066167,
                39.2123852
              ],
              [
                47.6083195,
                39.2146245
              ],
              [
                47.610286,
                39.2166675
              ],
              [
                47.6126217,
                39.2182963
              ],
              [
                47.6174044,
                39.219463
              ],
              [
                47.6213679,
                39.2210404
              ],
              [
                47.6291612,
                39.2229676
              ],
              [
                47.6307669,
                39.223433
              ],
              [
                47.6364273,
                39.2243095
              ],
              [
                47.6407809,
                39.2247084
              ],
              [
                47.643183,
                39.2250953
              ],
              [
                47.6451264,
                39.2250953
              ],
              [
                47.6454029,
                39.2248174
              ],
              [
                47.6464914,
                39.2254491
              ],
              [
                47.6473247,
                39.2251711
              ],
              [
                47.6492681,
                39.2251711
              ],
              [
                47.6498248,
                39.2248932
              ],
              [
                47.6524536,
                39.2259238
              ],
              [
                47.6527302,
                39.2262017
              ],
              [
                47.6535634,
                39.2262018
              ],
              [
                47.6543967,
                39.2267576
              ],
              [
                47.6552303,
                39.2267576
              ],
              [
                47.6637576,
                39.2311595
              ],
              [
                47.6643107,
                39.2314374
              ],
              [
                47.6757975,
                39.2453379
              ],
              [
                47.6774639,
                39.2472834
              ],
              [
                47.6813539,
                39.2592341
              ],
              [
                47.6885773,
                39.2717313
              ],
              [
                47.688854,
                39.2722871
              ],
              [
                47.6899637,
                39.2747882
              ],
              [
                47.6913535,
                39.2836722
              ],
              [
                47.6919106,
                39.2847839
              ],
              [
                47.6921871,
                39.2878408
              ],
              [
                47.7058002,
                39.3234017
              ],
              [
                47.7058002,
                39.3242354
              ],
              [
                47.7063533,
                39.3267363
              ],
              [
                47.7066333,
                39.3339521
              ],
              [
                47.70691,
                39.3356193
              ],
              [
                47.7069099,
                39.3360742
              ],
              [
                47.7096865,
                39.3534028
              ],
              [
                47.7119099,
                39.3583953
              ],
              [
                47.7124666,
                39.360627
              ],
              [
                47.7124665,
                39.3622852
              ],
              [
                47.7146897,
                39.3703431
              ],
              [
                47.7146897,
                39.3728437
              ],
              [
                47.7169096,
                39.383124
              ],
              [
                47.7169096,
                39.3839575
              ],
              [
                47.7163564,
                39.3842354
              ],
              [
                47.7091332,
                39.3870137
              ],
              [
                47.7088532,
                39.3872916
              ],
              [
                47.7069098,
                39.388403
              ],
              [
                47.7057999,
                39.388403
              ],
              [
                47.6913531,
                39.3931262
              ],
              [
                47.6905199,
                39.3931261
              ],
              [
                47.6899632,
                39.393404
              ],
              [
                47.6888534,
                39.393404
              ],
              [
                47.6882968,
                39.3936818
              ],
              [
                47.6871867,
                39.3936818
              ],
              [
                47.6866299,
                39.3939596
              ],
              [
                47.68441,
                39.3939597
              ],
              [
                47.6810767,
                39.3945063
              ],
              [
                47.6802435,
                39.3947932
              ],
              [
                47.6791302,
                39.3947932
              ],
              [
                47.6782965,
                39.395071
              ],
              [
                47.67413,
                39.395071
              ],
              [
                47.6738535,
                39.3947931
              ],
              [
                47.6724636,
                39.3947932
              ],
              [
                47.6721866,
                39.3945064
              ],
              [
                47.6710733,
                39.3945063
              ],
              [
                47.6682966,
                39.3942374
              ],
              [
                47.6646869,
                39.3945063
              ],
              [
                47.663297,
                39.3942374
              ],
              [
                47.6630204,
                39.3939596
              ],
              [
                47.6619067,
                39.3939596
              ],
              [
                47.6613536,
                39.3936817
              ],
              [
                47.6580203,
                39.3936817
              ],
              [
                47.6480169,
                39.3961822
              ],
              [
                47.6471837,
                39.3961823
              ],
              [
                47.6469071,
                39.3964601
              ],
              [
                47.6452403,
                39.3964601
              ],
              [
                47.6449637,
                39.3967379
              ],
              [
                47.6432973,
                39.396738
              ],
              [
                47.6402406,
                39.3956265
              ],
              [
                47.6380171,
                39.3956266
              ],
              [
                47.6255172,
                39.4011743
              ],
              [
                47.6244073,
                39.401461
              ],
              [
                47.6238507,
                39.401461
              ],
              [
                47.6230171,
                39.4017299
              ],
              [
                47.6155173,
                39.4053416
              ],
              [
                47.6141274,
                39.4053416
              ],
              [
                47.6138509,
                39.4056195
              ],
              [
                47.5982943,
                39.4056195
              ],
              [
                47.5974606,
                39.4058973
              ],
              [
                47.594961,
                39.4058973
              ],
              [
                47.5941273,
                39.4061752
              ],
              [
                47.5916277,
                39.4061751
              ],
              [
                47.5841275,
                39.4081199
              ],
              [
                47.5838474,
                39.4083977
              ],
              [
                47.5834326,
                39.4086755
              ],
              [
                47.582461,
                39.4106204
              ],
              [
                47.5832942,
                39.4142321
              ],
              [
                47.6032938,
                39.4342349
              ],
              [
                47.6038505,
                39.4347906
              ],
              [
                47.6163504,
                39.4453473
              ],
              [
                47.6163504,
                39.4511813
              ],
              [
                47.6146838,
                39.4559038
              ],
              [
                47.6085705,
                39.4617375
              ],
              [
                47.606627,
                39.4645155
              ],
              [
                47.606904,
                39.4647933
              ],
              [
                47.606627,
                39.4653489
              ],
              [
                47.6080173,
                39.467849
              ],
              [
                47.6082938,
                39.469238
              ],
              [
                47.606904,
                39.4709047
              ],
              [
                47.6060703,
                39.4711824
              ],
              [
                47.5877375,
                39.4920161
              ],
              [
                47.5874605,
                39.4922938
              ],
              [
                47.5871804,
                39.4928494
              ],
              [
                47.5866272,
                39.494516
              ],
              [
                47.5866272,
                39.4953494
              ],
              [
                47.5863471,
                39.4959049
              ],
              [
                47.5852374,
                39.499516
              ],
              [
                47.5846807,
                39.5003493
              ],
              [
                47.5846807,
                39.5045159
              ],
              [
                47.5841271,
                39.5070158
              ],
              [
                47.583847,
                39.5192373
              ],
              [
                47.586347,
                39.5267368
              ],
              [
                47.5865502,
                39.5328854
              ],
              [
                47.5842191,
                39.5320159
              ],
              [
                47.5814079,
                39.5287147
              ],
              [
                47.579766,
                39.5285769
              ],
              [
                47.5781854,
                39.5280503
              ],
              [
                47.5757939,
                39.5278994
              ],
              [
                47.573029,
                39.5256425
              ],
              [
                47.5705696,
                39.5202637
              ],
              [
                47.56666,
                39.5161755
              ],
              [
                47.5629369,
                39.5137751
              ],
              [
                47.5509836,
                39.510387
              ],
              [
                47.5489591,
                39.5087952
              ],
              [
                47.5459707,
                39.5083232
              ],
              [
                47.542588,
                39.5067958
              ],
              [
                47.5400905,
                39.5044331
              ],
              [
                47.5296314,
                39.4987857
              ],
              [
                47.5271609,
                39.4990145
              ],
              [
                47.5240186,
                39.5002583
              ],
              [
                47.5204911,
                39.4999869
              ],
              [
                47.514069,
                39.496702
              ],
              [
                47.5077122,
                39.4982146
              ],
              [
                47.5050038,
                39.4974353
              ],
              [
                47.4998212,
                39.4901826
              ],
              [
                47.4979735,
                39.4890872
              ],
              [
                47.4899105,
                39.4878796
              ],
              [
                47.4865006,
                39.4890482
              ],
              [
                47.4786454,
                39.4854826
              ],
              [
                47.4692849,
                39.4801792
              ],
              [
                47.4673152,
                39.4806193
              ],
              [
                47.458673,
                39.4804322
              ],
              [
                47.4465476,
                39.4783618
              ],
              [
                47.4426911,
                39.4791282
              ],
              [
                47.4411646,
                39.4781975
              ],
              [
                47.4403271,
                39.4756265
              ],
              [
                47.4414633,
                39.4717697
              ],
              [
                47.4394449,
                39.4706707
              ],
              [
                47.4323824,
                39.4717833
              ],
              [
                47.4300312,
                39.4711476
              ],
              [
                47.4262484,
                39.4677948
              ],
              [
                47.4230461,
                39.4665623
              ],
              [
                47.4205853,
                39.4648042
              ],
              [
                47.4131742,
                39.4639106
              ],
              [
                47.4056581,
                39.4640193
              ],
              [
                47.4036193,
                39.4650156
              ],
              [
                47.4007879,
                39.4677902
              ],
              [
                47.3967342,
                39.4696437
              ],
              [
                47.3950171,
                39.4691194
              ],
              [
                47.3942473,
                39.4669402
              ],
              [
                47.3930891,
                39.4658471
              ],
              [
                47.388474,
                39.4639535
              ],
              [
                47.3867893,
                39.4599575
              ],
              [
                47.3831047,
                39.4573544
              ],
              [
                47.3797216,
                39.4566513
              ],
              [
                47.3775701,
                39.4549047
              ],
              [
                47.3771311,
                39.4523226
              ],
              [
                47.3797286,
                39.4480915
              ],
              [
                47.380262,
                39.4461125
              ],
              [
                47.3698156,
                39.4319776
              ],
              [
                47.3652358,
                39.422963
              ],
              [
                47.363399,
                39.4217256
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 13074227,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان انگوت",
          "ref:sci": "2412",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.5005063,
                38.9987196
              ],
              [
                47.5019641,
                38.9975383
              ],
              [
                47.5038707,
                38.9965036
              ],
              [
                47.5073959,
                38.9943342
              ],
              [
                47.5271156,
                38.9902972
              ],
              [
                47.5332931,
                38.9875584
              ],
              [
                47.5377553,
                38.9858795
              ],
              [
                47.5500805,
                38.9814536
              ],
              [
                47.5581264,
                38.9796851
              ],
              [
                47.5624417,
                38.978736
              ],
              [
                47.5667554,
                38.9764004
              ],
              [
                47.5682947,
                38.9721852
              ],
              [
                47.5673935,
                38.9683035
              ],
              [
                47.559514,
                38.9664163
              ],
              [
                47.5559949,
                38.9652818
              ],
              [
                47.5510168,
                38.9645811
              ],
              [
                47.5469827,
                38.9633464
              ],
              [
                47.5413823,
                38.9624038
              ],
              [
                47.5380671,
                38.9613359
              ],
              [
                47.5339579,
                38.9607603
              ],
              [
                47.5316727,
                38.9601847
              ],
              [
                47.5304352,
                38.9604058
              ],
              [
                47.5267154,
                38.9579114
              ],
              [
                47.5243994,
                38.9558894
              ],
              [
                47.5246618,
                38.9537033
              ],
              [
                47.5240299,
                38.9511984
              ],
              [
                47.5240261,
                38.9502513
              ],
              [
                47.524027,
                38.948085
              ],
              [
                47.5229238,
                38.948038
              ],
              [
                47.5216233,
                38.9328372
              ],
              [
                47.5248718,
                38.9297448
              ],
              [
                47.5209331,
                38.9274326
              ],
              [
                47.5232505,
                38.9257633
              ],
              [
                47.5223922,
                38.9223578
              ],
              [
                47.518444,
                38.9188854
              ],
              [
                47.516384,
                38.9158134
              ],
              [
                47.517929,
                38.9108046
              ],
              [
                47.5223523,
                38.9036012
              ],
              [
                47.5285368,
                38.8958943
              ],
              [
                47.533675,
                38.8915521
              ],
              [
                47.5543351,
                38.8839918
              ],
              [
                47.5615724,
                38.8803171
              ],
              [
                47.5657535,
                38.876982
              ],
              [
                47.5704073,
                38.8702163
              ],
              [
                47.5707949,
                38.86585
              ],
              [
                47.5699395,
                38.8636577
              ],
              [
                47.6548637,
                38.8685102
              ],
              [
                47.7233733,
                38.8727443
              ],
              [
                47.7447577,
                38.880874
              ],
              [
                47.7631704,
                38.8896802
              ],
              [
                47.769447,
                38.8905057
              ],
              [
                47.7766126,
                38.8907953
              ],
              [
                47.7921265,
                38.8906508
              ],
              [
                47.7997214,
                38.8902834
              ],
              [
                47.8093108,
                38.8895017
              ],
              [
                47.8104046,
                38.8896092
              ],
              [
                47.8111437,
                38.8893702
              ],
              [
                47.811993,
                38.8885827
              ],
              [
                47.8151178,
                38.890632
              ],
              [
                47.8208015,
                38.8964595
              ],
              [
                47.8232049,
                38.9000107
              ],
              [
                47.8244395,
                38.9048846
              ],
              [
                47.8242012,
                38.9083015
              ],
              [
                47.82425,
                38.9108165
              ],
              [
                47.8247009,
                38.9136006
              ],
              [
                47.8245781,
                38.9165486
              ],
              [
                47.823778,
                38.9233911
              ],
              [
                47.8223881,
                38.9283434
              ],
              [
                47.820053,
                38.9319729
              ],
              [
                47.8169631,
                38.9351777
              ],
              [
                47.8114657,
                38.9385379
              ],
              [
                47.8321525,
                38.9379859
              ],
              [
                47.8473421,
                38.9434825
              ],
              [
                47.8544412,
                38.9518715
              ],
              [
                47.8598868,
                38.9601146
              ],
              [
                47.8640066,
                38.9703587
              ],
              [
                47.8689847,
                38.9818936
              ],
              [
                47.8717094,
                38.992269
              ],
              [
                47.8752677,
                39.0023605
              ],
              [
                47.8811003,
                39.0124958
              ],
              [
                47.8833139,
                39.021429
              ],
              [
                47.8843318,
                39.0278726
              ],
              [
                47.8879961,
                39.036199
              ],
              [
                47.8924759,
                39.0406151
              ],
              [
                47.8955657,
                39.0473268
              ],
              [
                47.8991209,
                39.0551805
              ],
              [
                47.905408,
                39.063992
              ],
              [
                47.909317,
                39.070679
              ],
              [
                47.9121493,
                39.072978
              ],
              [
                47.9185437,
                39.0815066
              ],
              [
                47.9227,
                39.0851748
              ],
              [
                47.926579,
                39.0865918
              ],
              [
                47.9257636,
                39.0880357
              ],
              [
                47.9253736,
                39.0908043
              ],
              [
                47.9273477,
                39.0946808
              ],
              [
                47.9286933,
                39.0971453
              ],
              [
                47.9310437,
                39.0995223
              ],
              [
                47.9372977,
                39.1052881
              ],
              [
                47.9405165,
                39.1091843
              ],
              [
                47.9433274,
                39.1118316
              ],
              [
                47.9440517,
                39.1129143
              ],
              [
                47.9370804,
                39.1226817
              ],
              [
                47.9351949,
                39.1286621
              ],
              [
                47.9365682,
                39.1336222
              ],
              [
                47.9368257,
                39.1433917
              ],
              [
                47.9280318,
                39.1472832
              ],
              [
                47.9271985,
                39.1475612
              ],
              [
                47.926922,
                39.1481172
              ],
              [
                47.9235887,
                39.1495071
              ],
              [
                47.923032,
                39.1495071
              ],
              [
                47.9221987,
                39.1497851
              ],
              [
                47.9185886,
                39.149785
              ],
              [
                47.9183121,
                39.149507
              ],
              [
                47.9167209,
                39.1493073
              ],
              [
                47.9160886,
                39.1483951
              ],
              [
                47.9146986,
                39.1483951
              ],
              [
                47.9052555,
                39.1450593
              ],
              [
                47.9044222,
                39.1450593
              ],
              [
                47.8996987,
                39.1428354
              ],
              [
                47.8991421,
                39.1422795
              ],
              [
                47.8883091,
                39.1383966
              ],
              [
                47.8838659,
                39.1383966
              ],
              [
                47.8788624,
                39.1406205
              ],
              [
                47.8785857,
                39.1408984
              ],
              [
                47.873309,
                39.1422794
              ],
              [
                47.8730289,
                39.1425574
              ],
              [
                47.8674757,
                39.1420104
              ],
              [
                47.8646959,
                39.1442253
              ],
              [
                47.864696,
                39.1445033
              ],
              [
                47.8594193,
                39.1445033
              ],
              [
                47.8588627,
                39.1442252
              ],
              [
                47.8580293,
                39.1442252
              ],
              [
                47.8574728,
                39.1439473
              ],
              [
                47.8563626,
                39.1439473
              ],
              [
                47.8538625,
                39.1431134
              ],
              [
                47.845253,
                39.1406204
              ],
              [
                47.8435861,
                39.1406204
              ],
              [
                47.8430294,
                39.1403424
              ],
              [
                47.8424728,
                39.1403424
              ],
              [
                47.8421962,
                39.1406204
              ],
              [
                47.8388103,
                39.1426008
              ],
              [
                47.8383538,
                39.1454159
              ],
              [
                47.8387535,
                39.1475271
              ],
              [
                47.8393409,
                39.1497574
              ],
              [
                47.8388544,
                39.1580264
              ],
              [
                47.838386,
                39.1611723
              ],
              [
                47.8361613,
                39.1665259
              ],
              [
                47.8348926,
                39.1690536
              ],
              [
                47.8343964,
                39.1700788
              ],
              [
                47.8331854,
                39.1711601
              ],
              [
                47.8313615,
                39.1727522
              ],
              [
                47.8280027,
                39.1748232
              ],
              [
                47.826167,
                39.1755477
              ],
              [
                47.8239427,
                39.1759302
              ],
              [
                47.8208992,
                39.1762248
              ],
              [
                47.8156201,
                39.1755595
              ],
              [
                47.8107942,
                39.1743334
              ],
              [
                47.8030922,
                39.1732687
              ],
              [
                47.7966151,
                39.1723253
              ],
              [
                47.7895186,
                39.1707617
              ],
              [
                47.7845441,
                39.170108
              ],
              [
                47.7811718,
                39.1697309
              ],
              [
                47.7616369,
                39.1686
              ],
              [
                47.7588321,
                39.1683836
              ],
              [
                47.7540716,
                39.1682388
              ],
              [
                47.7497659,
                39.1678229
              ],
              [
                47.7451783,
                39.1660594
              ],
              [
                47.7348402,
                39.1621384
              ],
              [
                47.7213146,
                39.1616136
              ],
              [
                47.7103124,
                39.1613141
              ],
              [
                47.7020232,
                39.1607582
              ],
              [
                47.6923369,
                39.1604144
              ],
              [
                47.6919935,
                39.1694648
              ],
              [
                47.6947097,
                39.1802667
              ],
              [
                47.6952281,
                39.1846891
              ],
              [
                47.6959623,
                39.1967299
              ],
              [
                47.6952409,
                39.2026066
              ],
              [
                47.6840258,
                39.203837
              ],
              [
                47.6783832,
                39.1957009
              ],
              [
                47.6717608,
                39.1864875
              ],
              [
                47.6681749,
                39.1863191
              ],
              [
                47.6564196,
                39.1858249
              ],
              [
                47.6455641,
                39.188158
              ],
              [
                47.6410911,
                39.1886953
              ],
              [
                47.6348305,
                39.1895885
              ],
              [
                47.6304162,
                39.1917172
              ],
              [
                47.62563,
                39.1938911
              ],
              [
                47.6214715,
                39.1961528
              ],
              [
                47.6173296,
                39.1986591
              ],
              [
                47.6122687,
                39.2019515
              ],
              [
                47.6068387,
                39.2047527
              ],
              [
                47.6043103,
                39.206394
              ],
              [
                47.6012308,
                39.2083364
              ],
              [
                47.5955957,
                39.211891
              ],
              [
                47.5927217,
                39.2136321
              ],
              [
                47.5902791,
                39.2151949
              ],
              [
                47.5872469,
                39.2170834
              ],
              [
                47.5846659,
                39.2186519
              ],
              [
                47.5818573,
                39.2204473
              ],
              [
                47.5796933,
                39.2217392
              ],
              [
                47.5771778,
                39.2226036
              ],
              [
                47.5751847,
                39.2233231
              ],
              [
                47.5724008,
                39.224786
              ],
              [
                47.5704089,
                39.2254387
              ],
              [
                47.5674323,
                39.2261369
              ],
              [
                47.5556002,
                39.2239835
              ],
              [
                47.5505447,
                39.2227952
              ],
              [
                47.5462317,
                39.222496
              ],
              [
                47.542777,
                39.2230113
              ],
              [
                47.5403777,
                39.2220245
              ],
              [
                47.53804,
                39.2218915
              ],
              [
                47.5352789,
                39.2218373
              ],
              [
                47.5308978,
                39.2218743
              ],
              [
                47.5282729,
                39.2218825
              ],
              [
                47.5262579,
                39.2217874
              ],
              [
                47.5203445,
                39.2215048
              ],
              [
                47.5172189,
                39.2213192
              ],
              [
                47.517924,
                39.2199805
              ],
              [
                47.5188467,
                39.218199
              ],
              [
                47.5218496,
                39.2126346
              ],
              [
                47.5258149,
                39.2052431
              ],
              [
                47.5281412,
                39.1899164
              ],
              [
                47.5301311,
                39.1780475
              ],
              [
                47.532022,
                39.1656202
              ],
              [
                47.5286531,
                39.1519576
              ],
              [
                47.5247105,
                39.1453012
              ],
              [
                47.524293,
                39.1408742
              ],
              [
                47.5310675,
                39.1309525
              ],
              [
                47.5364748,
                39.1188199
              ],
              [
                47.5355971,
                39.1074665
              ],
              [
                47.530514,
                39.0896069
              ],
              [
                47.5299684,
                39.0833072
              ],
              [
                47.5308433,
                39.0795299
              ],
              [
                47.528658,
                39.0733013
              ],
              [
                47.5241562,
                39.0626094
              ],
              [
                47.5239449,
                39.0586929
              ],
              [
                47.5263256,
                39.0515615
              ],
              [
                47.5254791,
                39.0481725
              ],
              [
                47.5236151,
                39.0476459
              ],
              [
                47.5222771,
                39.0473867
              ],
              [
                47.5190276,
                39.0467087
              ],
              [
                47.5181655,
                39.0450922
              ],
              [
                47.5194913,
                39.043055
              ],
              [
                47.5245275,
                39.0411904
              ],
              [
                47.5256219,
                39.0392197
              ],
              [
                47.5244406,
                39.0380581
              ],
              [
                47.5170628,
                39.0395188
              ],
              [
                47.512285,
                39.0390813
              ],
              [
                47.509048,
                39.0379005
              ],
              [
                47.5063953,
                39.0352981
              ],
              [
                47.505214,
                39.0320349
              ],
              [
                47.5061237,
                39.0288643
              ],
              [
                47.5087797,
                39.0268974
              ],
              [
                47.5137128,
                39.0255168
              ],
              [
                47.5169102,
                39.0245934
              ],
              [
                47.520724,
                39.0236932
              ],
              [
                47.5250583,
                39.0229816
              ],
              [
                47.5268274,
                39.0227733
              ],
              [
                47.5275593,
                39.021692
              ],
              [
                47.528011,
                39.0196802
              ],
              [
                47.5270719,
                39.0167763
              ],
              [
                47.525159,
                39.0122755
              ],
              [
                47.5261516,
                39.0092667
              ],
              [
                47.5258953,
                39.0079994
              ],
              [
                47.5038897,
                38.9998991
              ],
              [
                47.5005063,
                38.9987196
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 7562895082
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.4102145,
          39.4417175
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 231906831
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.918551,
          39.6461735
        ]
      }
    }
  ]
},
"اصفهان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554858,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آران و بیدگل",
          "name:en": "Aran and Bidgol County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q116115",
          "wikipedia": "fa:شهرستان آران و بیدگل"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.3625594,
                34.445794
              ],
              [
                51.3625618,
                34.4449321
              ],
              [
                51.3621498,
                34.4276453
              ],
              [
                51.3611971,
                34.4119907
              ],
              [
                51.3611971,
                34.3988828
              ],
              [
                51.3589569,
                34.3797802
              ],
              [
                51.357309,
                34.3705992
              ],
              [
                51.356176,
                34.3578673
              ],
              [
                51.3538586,
                34.3332697
              ],
              [
                51.3526999,
                34.3229353
              ],
              [
                51.3520961,
                34.3121626
              ],
              [
                51.3518195,
                34.3071628
              ],
              [
                51.3468197,
                34.2971631
              ],
              [
                51.3243199,
                34.2710538
              ],
              [
                51.31904,
                34.2654944
              ],
              [
                51.3123996,
                34.2539196
              ],
              [
                51.3078769,
                34.2414437
              ],
              [
                51.3046471,
                34.2242841
              ],
              [
                51.3023047,
                34.2194054
              ],
              [
                51.300669,
                34.2131313
              ],
              [
                51.3003792,
                34.2077631
              ],
              [
                51.2996415,
                34.2003044
              ],
              [
                51.299384,
                34.1927225
              ],
              [
                51.2988948,
                34.187845
              ],
              [
                51.3004397,
                34.1832228
              ],
              [
                51.3029632,
                34.1742546
              ],
              [
                51.3045596,
                34.167693
              ],
              [
                51.3051003,
                34.1600442
              ],
              [
                51.3063878,
                34.1540994
              ],
              [
                51.3066453,
                34.148069
              ],
              [
                51.3066453,
                34.1438282
              ],
              [
                51.3086537,
                34.1372642
              ],
              [
                51.3127736,
                34.1290372
              ],
              [
                51.3187474,
                34.123346
              ],
              [
                51.324747,
                34.1190401
              ],
              [
                51.3347634,
                34.1125808
              ],
              [
                51.3379821,
                34.1089139
              ],
              [
                51.339939,
                34.104863
              ],
              [
                51.340763,
                34.101473
              ],
              [
                51.3411235,
                34.0952255
              ],
              [
                51.3411235,
                34.0889563
              ],
              [
                51.3424367,
                34.0798289
              ],
              [
                51.3429002,
                34.0757766
              ],
              [
                51.3430289,
                34.0741344
              ],
              [
                51.3500584,
                34.0749022
              ],
              [
                51.3534316,
                34.0754354
              ],
              [
                51.3623666,
                34.0751795
              ],
              [
                51.3674649,
                34.0747102
              ],
              [
                51.3741597,
                34.0719162
              ],
              [
                51.3763374,
                34.0710842
              ],
              [
                51.3777774,
                34.0691942
              ],
              [
                51.3802508,
                34.0627072
              ],
              [
                51.379782,
                34.0529957
              ],
              [
                51.3742249,
                34.0446652
              ],
              [
                51.3733872,
                34.0412719
              ],
              [
                51.3736533,
                34.0390464
              ],
              [
                51.3712243,
                34.0358884
              ],
              [
                51.3930168,
                34.0277654
              ],
              [
                51.4076852,
                34.0386197
              ],
              [
                51.4255211,
                34.0439296
              ],
              [
                51.4345979,
                34.040605
              ],
              [
                51.4370739,
                34.0363621
              ],
              [
                51.442919,
                34.0262971
              ],
              [
                51.4476826,
                34.0196813
              ],
              [
                51.4496524,
                34.0166329
              ],
              [
                51.4555833,
                34.0175258
              ],
              [
                51.4575016,
                34.0168356
              ],
              [
                51.4616561,
                34.0169356
              ],
              [
                51.4656043,
                34.0119376
              ],
              [
                51.4661776,
                34.0090437
              ],
              [
                51.4670438,
                34.0053932
              ],
              [
                51.469894,
                34.0026798
              ],
              [
                51.4733058,
                33.9995596
              ],
              [
                51.4762241,
                33.9969837
              ],
              [
                51.4791122,
                33.9948311
              ],
              [
                51.4827128,
                33.9919597
              ],
              [
                51.4841032,
                33.9897109
              ],
              [
                51.4873691,
                33.9818396
              ],
              [
                51.4914847,
                33.9779464
              ],
              [
                51.4925455,
                33.9752987
              ],
              [
                51.4918899,
                33.9742214
              ],
              [
                51.4906025,
                33.971481
              ],
              [
                51.4942503,
                33.9689185
              ],
              [
                51.4975548,
                33.9675304
              ],
              [
                51.4992028,
                33.9662346
              ],
              [
                51.5022412,
                33.9634263
              ],
              [
                51.5099359,
                33.9622766
              ],
              [
                51.517034,
                33.961047
              ],
              [
                51.5208777,
                33.9592311
              ],
              [
                51.5267815,
                33.9489131
              ],
              [
                51.5362743,
                33.9465939
              ],
              [
                51.5365511,
                33.9463231
              ],
              [
                51.5371078,
                33.9463231
              ],
              [
                51.5546075,
                33.9399324
              ],
              [
                51.5551642,
                33.9393817
              ],
              [
                51.5557174,
                33.9393817
              ],
              [
                51.5646073,
                33.9363217
              ],
              [
                51.566554,
                33.9357711
              ],
              [
                51.5671073,
                33.9357711
              ],
              [
                51.5673872,
                33.9354823
              ],
              [
                51.572664,
                33.9335415
              ],
              [
                51.5906478,
                33.9264357
              ],
              [
                51.6020967,
                33.9213754
              ],
              [
                51.6129435,
                33.916048
              ],
              [
                51.6151668,
                33.9149377
              ],
              [
                51.6207234,
                33.9121576
              ],
              [
                51.6215568,
                33.9121576
              ],
              [
                51.6218333,
                33.9118778
              ],
              [
                51.6276666,
                33.9090975
              ],
              [
                51.6284998,
                33.908267
              ],
              [
                51.6618113,
                33.8935377
              ],
              [
                51.6775292,
                33.8860967
              ],
              [
                51.7041449,
                33.8723701
              ],
              [
                51.7124755,
                33.8684691
              ],
              [
                51.723976,
                33.8642866
              ],
              [
                51.729967,
                33.8608143
              ],
              [
                51.7335054,
                33.8582679
              ],
              [
                51.7360052,
                33.8560473
              ],
              [
                51.7452018,
                33.8462647
              ],
              [
                51.7517857,
                33.8388809
              ],
              [
                51.7552826,
                33.8341756
              ],
              [
                51.758899,
                33.8309212
              ],
              [
                51.7698096,
                33.8306047
              ],
              [
                51.7755282,
                33.8271466
              ],
              [
                51.7811934,
                33.8238154
              ],
              [
                51.7912522,
                33.8134654
              ],
              [
                51.8184443,
                33.7924909
              ],
              [
                51.8204318,
                33.79112
              ],
              [
                51.827568,
                33.797955
              ],
              [
                51.8303267,
                33.8006344
              ],
              [
                51.8357892,
                33.8035067
              ],
              [
                51.8454988,
                33.8035816
              ],
              [
                51.8514588,
                33.8029005
              ],
              [
                51.8585327,
                33.8020947
              ],
              [
                51.8669078,
                33.801856
              ],
              [
                51.8746901,
                33.8013676
              ],
              [
                51.8857335,
                33.8006531
              ],
              [
                51.8868468,
                33.8021474
              ],
              [
                51.8993325,
                33.8003286
              ],
              [
                51.9045624,
                33.800664
              ],
              [
                51.9262442,
                33.8023256
              ],
              [
                51.931356,
                33.8027571
              ],
              [
                51.9354595,
                33.8029869
              ],
              [
                51.9390335,
                33.8035574
              ],
              [
                51.9635825,
                33.8074015
              ],
              [
                51.9758023,
                33.8091388
              ],
              [
                51.9843829,
                33.8103155
              ],
              [
                51.9879571,
                33.8097965
              ],
              [
                51.9944967,
                33.8100461
              ],
              [
                51.9966784,
                33.8092508
              ],
              [
                52.0161239,
                33.8118687
              ],
              [
                52.0383485,
                33.8163336
              ],
              [
                52.0692109,
                33.8279416
              ],
              [
                52.0765675,
                33.8317918
              ],
              [
                52.0914782,
                33.8408719
              ],
              [
                52.1063144,
                33.8506711
              ],
              [
                52.1079672,
                33.8565982
              ],
              [
                52.1085206,
                33.8571488
              ],
              [
                52.1160238,
                33.8640995
              ],
              [
                52.1171339,
                33.8646591
              ],
              [
                52.1671363,
                33.9177093
              ],
              [
                52.1674131,
                33.9179891
              ],
              [
                52.1854696,
                33.9354828
              ],
              [
                52.2029692,
                33.9443738
              ],
              [
                52.2251957,
                33.9504849
              ],
              [
                52.2299155,
                33.951875
              ],
              [
                52.2371389,
                33.9532651
              ],
              [
                52.2385287,
                33.9535449
              ],
              [
                52.2732517,
                33.9657667
              ],
              [
                52.2743617,
                33.9663263
              ],
              [
                52.2813084,
                33.9679873
              ],
              [
                52.282975,
                33.9679872
              ],
              [
                52.2838081,
                33.968267
              ],
              [
                52.2896415,
                33.9682671
              ],
              [
                52.2899181,
                33.9679873
              ],
              [
                52.2921416,
                33.9679872
              ],
              [
                52.2926982,
                33.9677074
              ],
              [
                52.2954748,
                33.9677075
              ],
              [
                52.303808,
                33.9643858
              ],
              [
                52.3040881,
                33.9640968
              ],
              [
                52.3049213,
                33.9640968
              ],
              [
                52.3060313,
                33.9635462
              ],
              [
                52.306588,
                33.9632664
              ],
              [
                52.3215879,
                33.953545
              ],
              [
                52.3407543,
                33.9288213
              ],
              [
                52.3407543,
                33.9285504
              ],
              [
                52.3411726,
                33.9281307
              ],
              [
                52.3413109,
                33.9282706
              ],
              [
                52.3418676,
                33.9285505
              ],
              [
                52.3452008,
                33.9291011
              ],
              [
                52.3490874,
                33.9291011
              ],
              [
                52.3493675,
                33.9293809
              ],
              [
                52.3718671,
                33.9329915
              ],
              [
                52.3838137,
                33.9429929
              ],
              [
                52.3860336,
                33.9441032
              ],
              [
                52.3877003,
                33.9449337
              ],
              [
                52.4063134,
                33.9507738
              ],
              [
                52.4082567,
                33.9510447
              ],
              [
                52.4107566,
                33.9510447
              ],
              [
                52.4115934,
                33.9513245
              ],
              [
                52.4160366,
                33.9513245
              ],
              [
                52.4165933,
                33.9516043
              ],
              [
                52.4229798,
                33.9516043
              ],
              [
                52.4235366,
                33.9518751
              ],
              [
                52.4246464,
                33.9518751
              ],
              [
                52.4435473,
                33.9592594
              ],
              [
                52.4268698,
                33.953545
              ],
              [
                52.4271464,
                33.9543755
              ],
              [
                52.4243699,
                33.9629867
              ],
              [
                52.4238131,
                33.9635463
              ],
              [
                52.4221465,
                33.9679873
              ],
              [
                52.4185365,
                33.9754883
              ],
              [
                52.4182599,
                33.9763187
              ],
              [
                52.4179798,
                33.9765985
              ],
              [
                52.4160365,
                33.9835488
              ],
              [
                52.4157599,
                33.9849299
              ],
              [
                52.4154799,
                33.9854895
              ],
              [
                52.4154799,
                33.9868796
              ],
              [
                52.4154799,
                33.9885495
              ],
              [
                52.4174266,
                33.9985506
              ],
              [
                52.4165933,
                34.0068819
              ],
              [
                52.4168698,
                34.0229937
              ],
              [
                52.4168698,
                34.0260446
              ],
              [
                52.4168698,
                34.0313249
              ],
              [
                52.4171465,
                34.0349354
              ],
              [
                52.4168698,
                34.0352152
              ],
              [
                52.4165932,
                34.0391054
              ],
              [
                52.4163132,
                34.0441059
              ],
              [
                52.4160364,
                34.0557677
              ],
              [
                52.4182599,
                34.0777189
              ],
              [
                52.4185364,
                34.0804989
              ],
              [
                52.4165932,
                34.0918806
              ],
              [
                52.4154798,
                34.1002115
              ],
              [
                52.4152031,
                34.1018813
              ],
              [
                52.4143699,
                34.1099414
              ],
              [
                52.4143698,
                34.117162
              ],
              [
                52.4149266,
                34.1207723
              ],
              [
                52.4157598,
                34.1241028
              ],
              [
                52.417703,
                34.154384
              ],
              [
                52.4193697,
                34.168834
              ],
              [
                52.4213129,
                34.231335
              ],
              [
                52.4210363,
                34.2335551
              ],
              [
                52.4213129,
                34.2482753
              ],
              [
                52.4204796,
                34.2566055
              ],
              [
                52.4196463,
                34.2641054
              ],
              [
                52.4190929,
                34.268275
              ],
              [
                52.4202029,
                34.323273
              ],
              [
                52.4210363,
                34.3549408
              ],
              [
                52.4207596,
                34.3563306
              ],
              [
                52.4210362,
                34.36272
              ],
              [
                52.4218696,
                34.3721687
              ],
              [
                52.4232595,
                34.3821679
              ],
              [
                52.4240928,
                34.3854979
              ],
              [
                52.4257594,
                34.3896673
              ],
              [
                52.4282594,
                34.4002258
              ],
              [
                52.4279794,
                34.4007763
              ],
              [
                52.4257594,
                34.4104956
              ],
              [
                52.4252028,
                34.4113348
              ],
              [
                52.4249261,
                34.412165
              ],
              [
                52.4215928,
                34.4193935
              ],
              [
                52.4215928,
                34.4199441
              ],
              [
                52.4163128,
                34.4252232
              ],
              [
                52.4160361,
                34.4257737
              ],
              [
                52.4160362,
                34.4274432
              ],
              [
                52.4102029,
                34.4282735
              ],
              [
                52.4096462,
                34.4285532
              ],
              [
                52.4090895,
                34.4282735
              ],
              [
                52.4068696,
                34.4282734
              ],
              [
                52.4060364,
                34.4282734
              ],
              [
                52.4054797,
                34.4285532
              ],
              [
                52.4040897,
                34.4285532
              ],
              [
                52.403813,
                34.428833
              ],
              [
                52.4022866,
                34.4291127
              ],
              [
                52.399923,
                34.4291127
              ],
              [
                52.3993698,
                34.4293924
              ],
              [
                52.3954797,
                34.4293924
              ],
              [
                52.3952031,
                34.4291127
              ],
              [
                52.3943698,
                34.4293925
              ],
              [
                52.3929798,
                34.4291127
              ],
              [
                52.3885331,
                34.428833
              ],
              [
                52.3799233,
                34.4280027
              ],
              [
                52.3788133,
                34.427723
              ],
              [
                52.3768666,
                34.4277229
              ],
              [
                52.3546436,
                34.424393
              ],
              [
                52.3527004,
                34.4243929
              ],
              [
                52.3324205,
                34.4205035
              ],
              [
                52.3313105,
                34.4205035
              ],
              [
                52.3296438,
                34.4199439
              ],
              [
                52.3285306,
                34.419944
              ],
              [
                52.3129742,
                34.415504
              ],
              [
                52.3029742,
                34.4141143
              ],
              [
                52.2915843,
                34.4118943
              ],
              [
                52.2874178,
                34.4113348
              ],
              [
                52.2868645,
                34.4110549
              ],
              [
                52.2854744,
                34.4107753
              ],
              [
                52.2840846,
                34.4104954
              ],
              [
                52.2801979,
                34.4102248
              ],
              [
                52.2615848,
                34.4074453
              ],
              [
                52.2596381,
                34.4074453
              ],
              [
                52.2535283,
                34.406606
              ],
              [
                52.2474183,
                34.4055049
              ],
              [
                52.2329717,
                34.4035557
              ],
              [
                52.2307485,
                34.4035557
              ],
              [
                52.229362,
                34.403276
              ],
              [
                52.2254719,
                34.4032759
              ],
              [
                52.224082,
                34.4029962
              ],
              [
                52.2218587,
                34.4029962
              ],
              [
                52.217972,
                34.4024457
              ],
              [
                52.2146387,
                34.4024457
              ],
              [
                52.2135253,
                34.402166
              ],
              [
                52.2082488,
                34.4021659
              ],
              [
                52.2065822,
                34.4018952
              ],
              [
                52.1915822,
                34.4018952
              ],
              [
                52.1907491,
                34.4016154
              ],
              [
                52.1876924,
                34.4016155
              ],
              [
                52.1871357,
                34.4013356
              ],
              [
                52.1838024,
                34.4013358
              ],
              [
                52.182969,
                34.4010559
              ],
              [
                52.1793592,
                34.4010559
              ],
              [
                52.1782459,
                34.4013356
              ],
              [
                52.1751925,
                34.4013357
              ],
              [
                52.1738027,
                34.4016155
              ],
              [
                52.1614274,
                34.4016155
              ],
              [
                52.1607461,
                34.4016154
              ],
              [
                52.1585226,
                34.4013357
              ],
              [
                52.1551893,
                34.4013356
              ],
              [
                52.1529695,
                34.4016154
              ],
              [
                52.1493562,
                34.4016154
              ],
              [
                52.1459888,
                34.4021873
              ],
              [
                52.1440795,
                34.4024456
              ],
              [
                52.1424129,
                34.4024456
              ],
              [
                52.1412997,
                34.4027254
              ],
              [
                52.139633,
                34.4027254
              ],
              [
                52.1354663,
                34.4035556
              ],
              [
                52.1343563,
                34.4035556
              ],
              [
                52.1307464,
                34.4046656
              ],
              [
                52.129913,
                34.4046656
              ],
              [
                52.1247214,
                34.4057632
              ],
              [
                52.1215765,
                34.4071654
              ],
              [
                52.1207431,
                34.4071654
              ],
              [
                52.12019,
                34.4074451
              ],
              [
                52.1187999,
                34.4074452
              ],
              [
                52.1185232,
                34.4077249
              ],
              [
                52.1168565,
                34.4077249
              ],
              [
                52.1099099,
                34.4096742
              ],
              [
                52.1088002,
                34.4096742
              ],
              [
                52.1071334,
                34.4102246
              ],
              [
                52.1065766,
                34.4102246
              ],
              [
                52.1024101,
                34.4113346
              ],
              [
                52.0679639,
                34.4193933
              ],
              [
                52.0665738,
                34.4193933
              ],
              [
                52.0557406,
                34.4224435
              ],
              [
                52.0157411,
                34.4305022
              ],
              [
                52.0146278,
                34.4305022
              ],
              [
                51.9776816,
                34.4424411
              ],
              [
                51.9671251,
                34.4463306
              ],
              [
                51.9065692,
                34.4724462
              ],
              [
                51.8779563,
                34.4827246
              ],
              [
                51.8776761,
                34.4830043
              ],
              [
                51.8732329,
                34.4849444
              ],
              [
                51.8615663,
                34.4888337
              ],
              [
                51.8612863,
                34.4893932
              ],
              [
                51.8598996,
                34.4899527
              ],
              [
                51.8587863,
                34.4899527
              ],
              [
                51.856843,
                34.4905032
              ],
              [
                51.8346199,
                34.5055009
              ],
              [
                51.83462,
                34.5057806
              ],
              [
                51.8341678,
                34.5059559
              ],
              [
                51.8321199,
                34.5055008
              ],
              [
                51.82851,
                34.5055009
              ],
              [
                51.8098967,
                34.5094458
              ],
              [
                51.8007816,
                34.510984
              ],
              [
                51.716838,
                34.4985614
              ],
              [
                51.7143382,
                34.4980019
              ],
              [
                51.7129481,
                34.498002
              ],
              [
                51.710448,
                34.4974514
              ],
              [
                51.7076681,
                34.4971718
              ],
              [
                51.6948917,
                34.4952225
              ],
              [
                51.6837784,
                34.4941126
              ],
              [
                51.6810018,
                34.4941126
              ],
              [
                51.6790586,
                34.4938329
              ],
              [
                51.6682221,
                34.4927229
              ],
              [
                51.6337758,
                34.4880034
              ],
              [
                51.6326658,
                34.4874529
              ],
              [
                51.6318324,
                34.4874529
              ],
              [
                51.6304425,
                34.4871731
              ],
              [
                51.6293326,
                34.4866136
              ],
              [
                51.6284991,
                34.4866137
              ],
              [
                51.6062761,
                34.4821738
              ],
              [
                51.6046094,
                34.4821739
              ],
              [
                51.5832197,
                34.477725
              ],
              [
                51.5726632,
                34.4760556
              ],
              [
                51.5154373,
                34.469107
              ],
              [
                51.5062134,
                34.4683496
              ],
              [
                51.5054374,
                34.4682859
              ],
              [
                51.5018274,
                34.4682858
              ],
              [
                51.4387682,
                34.4585579
              ],
              [
                51.4321016,
                34.4571681
              ],
              [
                51.4123786,
                34.4541089
              ],
              [
                51.4054319,
                34.4527282
              ],
              [
                51.3907088,
                34.4502285
              ],
              [
                51.379599,
                34.4479996
              ],
              [
                51.3625594,
                34.445794
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554872,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اردستان",
          "name:en": "Ardestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286530",
          "wikipedia": "fa:شهرستان اردستان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8156475,
                33.2789433
              ],
              [
                51.83856,
                33.254336
              ],
              [
                51.8591178,
                33.231585
              ],
              [
                51.8649402,
                33.2236511
              ],
              [
                51.8716907,
                33.2172203
              ],
              [
                51.8941783,
                33.1882777
              ],
              [
                51.901044,
                33.1783525
              ],
              [
                51.902459,
                33.1690836
              ],
              [
                51.9053105,
                33.1596309
              ],
              [
                51.9070489,
                33.1515389
              ],
              [
                51.9092805,
                33.14283
              ],
              [
                51.912957,
                33.1340027
              ],
              [
                51.918594,
                33.1197806
              ],
              [
                51.9231121,
                33.1078049
              ],
              [
                51.9258556,
                33.096162
              ],
              [
                51.9298889,
                33.0822955
              ],
              [
                51.9322254,
                33.0708049
              ],
              [
                51.9356055,
                33.059582
              ],
              [
                51.941357,
                33.0467296
              ],
              [
                51.9524283,
                33.0350715
              ],
              [
                51.9692451,
                33.0191469
              ],
              [
                51.9859499,
                33.0062846
              ],
              [
                51.9969743,
                32.9977987
              ],
              [
                52.0134342,
                32.9917736
              ],
              [
                52.0305567,
                32.9851305
              ],
              [
                52.0456314,
                32.9797456
              ],
              [
                52.0558861,
                32.9759881
              ],
              [
                52.0607279,
                32.9741478
              ],
              [
                52.0729403,
                32.9674235
              ],
              [
                52.08352,
                32.9613776
              ],
              [
                52.0918366,
                32.9571804
              ],
              [
                52.1030995,
                32.9542193
              ],
              [
                52.1139251,
                32.9542194
              ],
              [
                52.121658,
                32.9561254
              ],
              [
                52.1312654,
                32.9601584
              ],
              [
                52.1388602,
                32.9654235
              ],
              [
                52.1470544,
                32.9744099
              ],
              [
                52.1606098,
                32.9961009
              ],
              [
                52.1631091,
                32.998033
              ],
              [
                52.1681436,
                33.0068927
              ],
              [
                52.1710118,
                33.0092519
              ],
              [
                52.1748288,
                33.0112671
              ],
              [
                52.1835029,
                33.013989
              ],
              [
                52.1947145,
                33.0169044
              ],
              [
                52.2040343,
                33.0186649
              ],
              [
                52.2121959,
                33.0216085
              ],
              [
                52.2188521,
                33.022772
              ],
              [
                52.223933,
                33.0246152
              ],
              [
                52.2331399,
                33.0251189
              ],
              [
                52.2414088,
                33.0239895
              ],
              [
                52.2478403,
                33.0221624
              ],
              [
                52.2534721,
                33.0198595
              ],
              [
                52.2586587,
                33.0199394
              ],
              [
                52.2642757,
                33.0204793
              ],
              [
                52.2726179,
                33.0201113
              ],
              [
                52.2803356,
                33.0206151
              ],
              [
                52.2921314,
                33.020901
              ],
              [
                52.2990587,
                33.0210449
              ],
              [
                52.3041646,
                33.0210009
              ],
              [
                52.3154582,
                33.0178503
              ],
              [
                52.3235991,
                33.0153314
              ],
              [
                52.3315715,
                33.0121543
              ],
              [
                52.3409271,
                33.0074399
              ],
              [
                52.34802,
                33.004018
              ],
              [
                52.3503315,
                33.0025784
              ],
              [
                52.3553217,
                32.9994992
              ],
              [
                52.3599299,
                32.9891066
              ],
              [
                52.3634599,
                32.9800447
              ],
              [
                52.3660814,
                32.9716915
              ],
              [
                52.3678698,
                32.9622556
              ],
              [
                52.3687698,
                32.9555195
              ],
              [
                52.3739996,
                32.9450931
              ],
              [
                52.3782579,
                32.9404696
              ],
              [
                52.3837703,
                32.9311934
              ],
              [
                52.3905361,
                32.9152343
              ],
              [
                52.3910071,
                32.9076047
              ],
              [
                52.3929062,
                32.901831
              ],
              [
                52.3957712,
                32.8974538
              ],
              [
                52.3992903,
                32.8944693
              ],
              [
                52.4022513,
                32.88973
              ],
              [
                52.4016506,
                32.8807057
              ],
              [
                52.4069483,
                32.8786026
              ],
              [
                52.4132678,
                32.8779229
              ],
              [
                52.4160375,
                32.8796309
              ],
              [
                52.4190941,
                32.8796309
              ],
              [
                52.4196474,
                32.8793509
              ],
              [
                52.4227042,
                32.8793509
              ],
              [
                52.4235374,
                32.879071
              ],
              [
                52.4268707,
                32.8788001
              ],
              [
                52.4315939,
                32.8788002
              ],
              [
                52.4321507,
                32.8785202
              ],
              [
                52.432984,
                32.8785202
              ],
              [
                52.4335372,
                32.8788001
              ],
              [
                52.4338173,
                32.8785202
              ],
              [
                52.4352039,
                32.8788001
              ],
              [
                52.4410372,
                32.8788001
              ],
              [
                52.4415938,
                32.879071
              ],
              [
                52.4443704,
                32.8790711
              ],
              [
                52.4449271,
                32.8793509
              ],
              [
                52.4468704,
                32.8793509
              ],
              [
                52.4477037,
                32.8796309
              ],
              [
                52.452427,
                32.8796308
              ],
              [
                52.4529837,
                32.8799107
              ],
              [
                52.4557603,
                32.8799108
              ],
              [
                52.4565936,
                32.8801906
              ],
              [
                52.4607602,
                32.8801907
              ],
              [
                52.4615935,
                32.8804705
              ],
              [
                52.4635402,
                32.8807414
              ],
              [
                52.4665934,
                32.8807414
              ],
              [
                52.4671501,
                32.8810213
              ],
              [
                52.4774301,
                32.8810213
              ],
              [
                52.4779833,
                32.8807414
              ],
              [
                52.4815967,
                32.8804705
              ],
              [
                52.4821498,
                32.8807414
              ],
              [
                52.4885398,
                32.8804706
              ],
              [
                52.4896533,
                32.8804706
              ],
              [
                52.4910398,
                32.8804706
              ],
              [
                52.4915964,
                32.8801907
              ],
              [
                52.4940964,
                32.8801907
              ],
              [
                52.4999298,
                32.8796308
              ],
              [
                52.5199295,
                32.8788002
              ],
              [
                52.5318759,
                32.8788002
              ],
              [
                52.5327093,
                32.8785203
              ],
              [
                52.5361999,
                32.8785743
              ],
              [
                52.5479633,
                32.8784729
              ],
              [
                52.5536031,
                32.8785186
              ],
              [
                52.5575445,
                32.8785006
              ],
              [
                52.5624322,
                32.8779696
              ],
              [
                52.5678601,
                32.8774829
              ],
              [
                52.5698524,
                32.8772931
              ],
              [
                52.5748559,
                32.8766708
              ],
              [
                52.5781603,
                32.8770397
              ],
              [
                52.5806591,
                32.8772116
              ],
              [
                52.5824354,
                32.8774097
              ],
              [
                52.5836979,
                32.8775094
              ],
              [
                52.5876783,
                32.877934
              ],
              [
                52.5927525,
                32.8785845
              ],
              [
                52.5942475,
                32.8790266
              ],
              [
                52.5997023,
                32.8803556
              ],
              [
                52.6064589,
                32.8823363
              ],
              [
                52.6101687,
                32.8847426
              ],
              [
                52.6150041,
                32.8884578
              ],
              [
                52.6185894,
                32.8901826
              ],
              [
                52.621293,
                32.8920925
              ],
              [
                52.6211214,
                32.898939
              ],
              [
                52.621808,
                32.9039475
              ],
              [
                52.6240396,
                32.9087755
              ],
              [
                52.6317215,
                32.9196916
              ],
              [
                52.6368979,
                32.9249672
              ],
              [
                52.6414699,
                32.9289707
              ],
              [
                52.6436574,
                32.9308437
              ],
              [
                52.6482793,
                32.9346076
              ],
              [
                52.6520239,
                32.9375507
              ],
              [
                52.6551248,
                32.9392557
              ],
              [
                52.658342,
                32.9407962
              ],
              [
                52.6628128,
                32.9432393
              ],
              [
                52.6682424,
                32.9462738
              ],
              [
                52.6951787,
                32.9544543
              ],
              [
                52.7109465,
                32.9592796
              ],
              [
                52.7225861,
                32.9645552
              ],
              [
                52.7383232,
                32.9733519
              ],
              [
                52.750082,
                32.9807682
              ],
              [
                52.7524852,
                32.9837921
              ],
              [
                52.7538699,
                32.9864483
              ],
              [
                52.7547916,
                32.9896426
              ],
              [
                52.7560159,
                32.9935969
              ],
              [
                52.7567088,
                33.0003296
              ],
              [
                52.7569592,
                33.0076814
              ],
              [
                52.7597045,
                33.0132775
              ],
              [
                52.7652323,
                33.0214112
              ],
              [
                52.7688031,
                33.0271613
              ],
              [
                52.7734715,
                33.0341852
              ],
              [
                52.7756652,
                33.0374925
              ],
              [
                52.7780863,
                33.0408775
              ],
              [
                52.7804455,
                33.0448033
              ],
              [
                52.7826475,
                33.048523
              ],
              [
                52.7860557,
                33.0529991
              ],
              [
                52.790125,
                33.0576588
              ],
              [
                52.7938053,
                33.0624566
              ],
              [
                52.7962504,
                33.0661736
              ],
              [
                52.7992103,
                33.0706163
              ],
              [
                52.8022335,
                33.0747802
              ],
              [
                52.805215,
                33.0776273
              ],
              [
                52.8080545,
                33.0804434
              ],
              [
                52.8107558,
                33.0826417
              ],
              [
                52.8135169,
                33.084949
              ],
              [
                52.8196477,
                33.0899236
              ],
              [
                52.8309585,
                33.0965939
              ],
              [
                52.8375828,
                33.0991473
              ],
              [
                52.8471504,
                33.1028258
              ],
              [
                52.856976,
                33.1050391
              ],
              [
                52.8716506,
                33.110465
              ],
              [
                52.8872691,
                33.1157747
              ],
              [
                52.8984729,
                33.1220286
              ],
              [
                52.9145765,
                33.1301841
              ],
              [
                52.9272365,
                33.1358982
              ],
              [
                52.9414415,
                33.1415759
              ],
              [
                52.942686,
                33.143157
              ],
              [
                52.9540157,
                33.1496248
              ],
              [
                52.9628992,
                33.1555891
              ],
              [
                52.9671049,
                33.1602955
              ],
              [
                52.9704951,
                33.1660077
              ],
              [
                52.9730648,
                33.1903353
              ],
              [
                52.9767608,
                33.2194462
              ],
              [
                52.9793998,
                33.2414617
              ],
              [
                52.9792222,
                33.2446939
              ],
              [
                52.9776524,
                33.2487136
              ],
              [
                52.9825114,
                33.2708428
              ],
              [
                52.9848289,
                33.2855528
              ],
              [
                52.9888796,
                33.3046118
              ],
              [
                52.9934119,
                33.3217072
              ],
              [
                52.9962017,
                33.3383289
              ],
              [
                52.9952232,
                33.3468461
              ],
              [
                52.9926511,
                33.3627827
              ],
              [
                52.9893249,
                33.3773969
              ],
              [
                52.9887482,
                33.3946375
              ],
              [
                52.98776,
                33.4082807
              ],
              [
                52.9882106,
                33.4203414
              ],
              [
                52.9896675,
                33.4244828
              ],
              [
                52.9904079,
                33.4344498
              ],
              [
                52.9918658,
                33.4439334
              ],
              [
                52.992289,
                33.4548525
              ],
              [
                52.9956331,
                33.4735434
              ],
              [
                52.9972641,
                33.4811691
              ],
              [
                52.9971058,
                33.4906375
              ],
              [
                52.99844,
                33.5069803
              ],
              [
                52.9903944,
                33.5344109
              ],
              [
                52.9884203,
                33.5478169
              ],
              [
                52.9870661,
                33.5638543
              ],
              [
                52.9864929,
                33.5835434
              ],
              [
                52.9862986,
                33.5925841
              ],
              [
                52.988082,
                33.6066088
              ],
              [
                52.9908377,
                33.6266998
              ],
              [
                52.9926279,
                33.6363648
              ],
              [
                52.9947187,
                33.6475901
              ],
              [
                52.9963877,
                33.6670695
              ],
              [
                52.9939045,
                33.6831366
              ],
              [
                52.9918278,
                33.6911355
              ],
              [
                52.9888237,
                33.7049948
              ],
              [
                52.9828163,
                33.7212377
              ],
              [
                52.9772814,
                33.7352349
              ],
              [
                52.9699057,
                33.7487416
              ],
              [
                52.9649783,
                33.7690076
              ],
              [
                52.961415,
                33.7834214
              ],
              [
                52.9584249,
                33.8068868
              ],
              [
                52.9588672,
                33.8299644
              ],
              [
                52.9612845,
                33.8518204
              ],
              [
                52.9582945,
                33.8700336
              ],
              [
                52.9565112,
                33.8824443
              ],
              [
                52.9539439,
                33.8895397
              ],
              [
                52.9520556,
                33.9127291
              ],
              [
                52.9534123,
                33.9248422
              ],
              [
                52.9515341,
                33.9420519
              ],
              [
                52.9498592,
                33.954839
              ],
              [
                52.9459828,
                33.9801348
              ],
              [
                52.9423361,
                34.004815
              ],
              [
                52.9417329,
                34.026292
              ],
              [
                52.9399624,
                34.0512472
              ],
              [
                52.9373056,
                34.0819537
              ],
              [
                52.9240915,
                34.1418522
              ],
              [
                52.9156101,
                34.1775154
              ],
              [
                52.9091095,
                34.2062769
              ],
              [
                52.9038263,
                34.227093
              ],
              [
                52.8982223,
                34.2473744
              ],
              [
                52.8943325,
                34.265161
              ],
              [
                52.8804077,
                34.2674397
              ],
              [
                52.865566,
                34.2720898
              ],
              [
                52.852427,
                34.2764549
              ],
              [
                52.8418053,
                34.2797346
              ],
              [
                52.820325,
                34.2909465
              ],
              [
                52.8017401,
                34.3005397
              ],
              [
                52.7639419,
                34.3198834
              ],
              [
                52.7416319,
                34.3327637
              ],
              [
                52.677993,
                34.3643897
              ],
              [
                52.6732697,
                34.3666098
              ],
              [
                52.6528082,
                34.3775899
              ],
              [
                52.6095714,
                34.3882974
              ],
              [
                52.6035292,
                34.390082
              ],
              [
                52.5928844,
                34.3920049
              ],
              [
                52.5804843,
                34.3960065
              ],
              [
                52.5612699,
                34.4013693
              ],
              [
                52.5264463,
                34.4102747
              ],
              [
                52.5025119,
                34.4184128
              ],
              [
                52.4999285,
                34.4191138
              ],
              [
                52.4888186,
                34.4210631
              ],
              [
                52.4829819,
                34.4218843
              ],
              [
                52.4821486,
                34.4221641
              ],
              [
                52.4796487,
                34.4221641
              ],
              [
                52.4590923,
                34.4249435
              ],
              [
                52.4563157,
                34.4255031
              ],
              [
                52.4532591,
                34.425503
              ],
              [
                52.4504824,
                34.4260535
              ],
              [
                52.4485358,
                34.4260534
              ],
              [
                52.4474257,
                34.4263332
              ],
              [
                52.4446492,
                34.4263332
              ],
              [
                52.4440925,
                34.426613
              ],
              [
                52.4368693,
                34.426613
              ],
              [
                52.4307592,
                34.4274433
              ],
              [
                52.429646,
                34.4271725
              ],
              [
                52.4174262,
                34.4271725
              ],
              [
                52.4160362,
                34.4274432
              ],
              [
                52.4160361,
                34.4257737
              ],
              [
                52.4163128,
                34.4252232
              ],
              [
                52.4215928,
                34.4199441
              ],
              [
                52.4215928,
                34.4193935
              ],
              [
                52.4249261,
                34.412165
              ],
              [
                52.4252028,
                34.4113348
              ],
              [
                52.4257594,
                34.4104956
              ],
              [
                52.4279794,
                34.4007763
              ],
              [
                52.4282594,
                34.4002258
              ],
              [
                52.4257594,
                34.3896673
              ],
              [
                52.4240928,
                34.3854979
              ],
              [
                52.4232595,
                34.3821679
              ],
              [
                52.4218696,
                34.3721687
              ],
              [
                52.4210362,
                34.36272
              ],
              [
                52.4207596,
                34.3563306
              ],
              [
                52.4210363,
                34.3549408
              ],
              [
                52.4202029,
                34.323273
              ],
              [
                52.4190929,
                34.268275
              ],
              [
                52.4196463,
                34.2641054
              ],
              [
                52.4204796,
                34.2566055
              ],
              [
                52.4213129,
                34.2482753
              ],
              [
                52.4210363,
                34.2335551
              ],
              [
                52.4213129,
                34.231335
              ],
              [
                52.4193697,
                34.168834
              ],
              [
                52.417703,
                34.154384
              ],
              [
                52.4157598,
                34.1241028
              ],
              [
                52.4149266,
                34.1207723
              ],
              [
                52.4143698,
                34.117162
              ],
              [
                52.4143699,
                34.1099414
              ],
              [
                52.4152031,
                34.1018813
              ],
              [
                52.4154798,
                34.1002115
              ],
              [
                52.4165932,
                34.0918806
              ],
              [
                52.4185364,
                34.0804989
              ],
              [
                52.4182599,
                34.0777189
              ],
              [
                52.4160364,
                34.0557677
              ],
              [
                52.4163132,
                34.0441059
              ],
              [
                52.4165932,
                34.0391054
              ],
              [
                52.4168698,
                34.0352152
              ],
              [
                52.4171465,
                34.0349354
              ],
              [
                52.4168698,
                34.0313249
              ],
              [
                52.4168698,
                34.0260446
              ],
              [
                52.4168698,
                34.0229937
              ],
              [
                52.4165933,
                34.0068819
              ],
              [
                52.4174266,
                33.9985506
              ],
              [
                52.4154799,
                33.9885495
              ],
              [
                52.4154799,
                33.9868796
              ],
              [
                52.4154799,
                33.9854895
              ],
              [
                52.4157599,
                33.9849299
              ],
              [
                52.4160365,
                33.9835488
              ],
              [
                52.4179798,
                33.9765985
              ],
              [
                52.4182599,
                33.9763187
              ],
              [
                52.4185365,
                33.9754883
              ],
              [
                52.4221465,
                33.9679873
              ],
              [
                52.4238131,
                33.9635463
              ],
              [
                52.4243699,
                33.9629867
              ],
              [
                52.4271464,
                33.9543755
              ],
              [
                52.4268698,
                33.953545
              ],
              [
                52.4435473,
                33.9592594
              ],
              [
                52.4246464,
                33.9518751
              ],
              [
                52.4235366,
                33.9518751
              ],
              [
                52.4229798,
                33.9516043
              ],
              [
                52.4165933,
                33.9516043
              ],
              [
                52.4160366,
                33.9513245
              ],
              [
                52.4115934,
                33.9513245
              ],
              [
                52.4107566,
                33.9510447
              ],
              [
                52.4082567,
                33.9510447
              ],
              [
                52.4063134,
                33.9507738
              ],
              [
                52.3877003,
                33.9449337
              ],
              [
                52.3860336,
                33.9441032
              ],
              [
                52.3838137,
                33.9429929
              ],
              [
                52.3718671,
                33.9329915
              ],
              [
                52.3493675,
                33.9293809
              ],
              [
                52.3490874,
                33.9291011
              ],
              [
                52.3452008,
                33.9291011
              ],
              [
                52.3418676,
                33.9285505
              ],
              [
                52.3413109,
                33.9282706
              ],
              [
                52.3411726,
                33.9281307
              ],
              [
                52.3393676,
                33.9152091
              ],
              [
                52.3390875,
                33.913819
              ],
              [
                52.3377009,
                33.9104881
              ],
              [
                52.3365876,
                33.9079877
              ],
              [
                52.2982549,
                33.8471562
              ],
              [
                52.2963081,
                33.8446557
              ],
              [
                52.285475,
                33.8335436
              ],
              [
                52.2849182,
                33.8335436
              ],
              [
                52.2610285,
                33.8079881
              ],
              [
                52.243529,
                33.7874334
              ],
              [
                52.2415856,
                33.7843732
              ],
              [
                52.2379723,
                33.7782618
              ],
              [
                52.2368623,
                33.7774313
              ],
              [
                52.2360291,
                33.7757613
              ],
              [
                52.2354724,
                33.7754815
              ],
              [
                52.2185259,
                33.7424237
              ],
              [
                52.2182492,
                33.7413134
              ],
              [
                52.1954696,
                33.7146466
              ],
              [
                52.1918597,
                33.7107648
              ],
              [
                52.1790798,
                33.6960411
              ],
              [
                52.1554702,
                33.6590915
              ],
              [
                52.15519,
                33.6588207
              ],
              [
                52.1540803,
                33.6563111
              ],
              [
                52.1504703,
                33.6502084
              ],
              [
                52.1404669,
                33.6382648
              ],
              [
                52.1246292,
                33.6279287
              ],
              [
                52.1230805,
                33.6270629
              ],
              [
                52.1225166,
                33.6262531
              ],
              [
                52.1219764,
                33.6247523
              ],
              [
                52.1219574,
                33.6237301
              ],
              [
                52.1210179,
                33.6241476
              ],
              [
                52.1191011,
                33.6249635
              ],
              [
                52.1172497,
                33.6257705
              ],
              [
                52.1075187,
                33.6298419
              ],
              [
                52.1038034,
                33.6268931
              ],
              [
                52.1003401,
                33.6235249
              ],
              [
                52.097411,
                33.6218706
              ],
              [
                52.0999108,
                33.6204803
              ],
              [
                52.1004675,
                33.6204804
              ],
              [
                52.1013009,
                33.6196498
              ],
              [
                52.1249107,
                33.6074263
              ],
              [
                52.1254673,
                33.6063159
              ],
              [
                52.1257439,
                33.606036
              ],
              [
                52.1213006,
                33.5971527
              ],
              [
                52.1204674,
                33.5960424
              ],
              [
                52.1151907,
                33.5904812
              ],
              [
                52.1140773,
                33.5899305
              ],
              [
                52.1121342,
                33.5879806
              ],
              [
                52.1082621,
                33.5842581
              ],
              [
                52.0989502,
                33.5746588
              ],
              [
                52.0964598,
                33.5722403
              ],
              [
                52.0886635,
                33.5633759
              ],
              [
                52.0859847,
                33.5605793
              ],
              [
                52.0855555,
                33.5556118
              ],
              [
                52.0854696,
                33.5538298
              ],
              [
                52.0851833,
                33.5513385
              ],
              [
                52.0846503,
                33.5465472
              ],
              [
                52.0830005,
                33.5347912
              ],
              [
                52.0830005,
                33.5196743
              ],
              [
                52.0813322,
                33.5083732
              ],
              [
                52.0800777,
                33.5030899
              ],
              [
                52.0809539,
                33.4973455
              ],
              [
                52.0815344,
                33.4912534
              ],
              [
                52.0817254,
                33.4863821
              ],
              [
                52.0828602,
                33.4829439
              ],
              [
                52.0847282,
                33.4768119
              ],
              [
                52.0880088,
                33.4657645
              ],
              [
                52.0909546,
                33.4551868
              ],
              [
                52.094332,
                33.4411932
              ],
              [
                52.0956318,
                33.4343584
              ],
              [
                52.0967711,
                33.4267494
              ],
              [
                52.0981696,
                33.4183317
              ],
              [
                52.0978999,
                33.4140321
              ],
              [
                52.0969763,
                33.4046756
              ],
              [
                52.0957112,
                33.3981687
              ],
              [
                52.0947876,
                33.3870565
              ],
              [
                52.0947492,
                33.3824705
              ],
              [
                52.0950687,
                33.3743873
              ],
              [
                52.0970192,
                33.3641083
              ],
              [
                52.0988204,
                33.3602314
              ],
              [
                52.1010237,
                33.3572498
              ],
              [
                52.1023971,
                33.3549922
              ],
              [
                52.1071797,
                33.3480805
              ],
              [
                52.111608,
                33.3423214
              ],
              [
                52.1203926,
                33.3322496
              ],
              [
                52.1229616,
                33.3293185
              ],
              [
                52.1243471,
                33.327532
              ],
              [
                52.1271343,
                33.3229771
              ],
              [
                52.1363008,
                33.3093621
              ],
              [
                52.1365809,
                33.3088114
              ],
              [
                52.1395541,
                33.3043737
              ],
              [
                52.1417132,
                33.2917658
              ],
              [
                52.1405116,
                33.2849641
              ],
              [
                52.1372961,
                33.2805964
              ],
              [
                52.1362209,
                33.2789515
              ],
              [
                52.1295733,
                33.2770035
              ],
              [
                52.1237773,
                33.2753918
              ],
              [
                52.1136358,
                33.2737413
              ],
              [
                52.0983113,
                33.2714378
              ],
              [
                52.0725691,
                33.2691377
              ],
              [
                52.0660658,
                33.2692669
              ],
              [
                52.05657,
                33.2695511
              ],
              [
                52.0503326,
                33.2685493
              ],
              [
                52.0403437,
                33.2673221
              ],
              [
                52.0307087,
                33.2674351
              ],
              [
                52.0256064,
                33.2675714
              ],
              [
                52.0177075,
                33.2677149
              ],
              [
                52.0002351,
                33.2675337
              ],
              [
                51.9983514,
                33.27001
              ],
              [
                51.9867066,
                33.2659375
              ],
              [
                51.9670131,
                33.2662176
              ],
              [
                51.9631862,
                33.2647429
              ],
              [
                51.9540609,
                33.2577487
              ],
              [
                51.9278216,
                33.2561626
              ],
              [
                51.916033,
                33.2624067
              ],
              [
                51.9020008,
                33.274743
              ],
              [
                51.8985401,
                33.2789765
              ],
              [
                51.8893036,
                33.2839417
              ],
              [
                51.8826852,
                33.2851378
              ],
              [
                51.8724631,
                33.2855528
              ],
              [
                51.8645667,
                33.286055
              ],
              [
                51.8535804,
                33.2854093
              ],
              [
                51.8419074,
                33.2856963
              ],
              [
                51.8335818,
                33.2858398
              ],
              [
                51.8283462,
                33.2849788
              ],
              [
                51.8156475,
                33.2789433
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554888,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اصفهان",
          "name:en": "Isfahan County",
          "name:ru": "Исфахан",
          "name:sk": "okres Isfahán",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282082",
          "wikipedia": "fa:شهرستان اصفهان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.5256383,
                32.7745093
              ],
              [
                51.5276016,
                32.7657201
              ],
              [
                51.5269636,
                32.7586587
              ],
              [
                51.5273761,
                32.7564369
              ],
              [
                51.5375151,
                32.7523813
              ],
              [
                51.539678,
                32.7492628
              ],
              [
                51.5429224,
                32.7394737
              ],
              [
                51.5493597,
                32.7352934
              ],
              [
                51.5537628,
                32.7325859
              ],
              [
                51.5565437,
                32.731048
              ],
              [
                51.5567497,
                32.7307231
              ],
              [
                51.5564324,
                32.7292467
              ],
              [
                51.5587239,
                32.7290909
              ],
              [
                51.5591011,
                32.7290541
              ],
              [
                51.5592879,
                32.7277948
              ],
              [
                51.5596771,
                32.722769
              ],
              [
                51.560477,
                32.7227629
              ],
              [
                51.561166,
                32.7227886
              ],
              [
                51.5625286,
                32.7228402
              ],
              [
                51.5647946,
                32.7227114
              ],
              [
                51.5675199,
                32.7247079
              ],
              [
                51.5695562,
                32.7233425
              ],
              [
                51.5700421,
                32.7237209
              ],
              [
                51.5704488,
                32.7235345
              ],
              [
                51.5710986,
                32.7234295
              ],
              [
                51.5716137,
                32.723455
              ],
              [
                51.5732742,
                32.7229205
              ],
              [
                51.5748155,
                32.7222618
              ],
              [
                51.5759286,
                32.7215426
              ],
              [
                51.5766091,
                32.7213721
              ],
              [
                51.5773502,
                32.7207391
              ],
              [
                51.5777499,
                32.7201748
              ],
              [
                51.5778682,
                32.7198148
              ],
              [
                51.5780411,
                32.7194566
              ],
              [
                51.5786102,
                32.7188529
              ],
              [
                51.5793272,
                32.717496
              ],
              [
                51.5801944,
                32.7163409
              ],
              [
                51.5804311,
                32.7164175
              ],
              [
                51.5815417,
                32.7147784
              ],
              [
                51.5826412,
                32.7124251
              ],
              [
                51.584352,
                32.7129889
              ],
              [
                51.5885432,
                32.7029063
              ],
              [
                51.5894772,
                32.7032137
              ],
              [
                51.5902438,
                32.7033033
              ],
              [
                51.5902646,
                32.7023746
              ],
              [
                51.5903035,
                32.7018672
              ],
              [
                51.5903619,
                32.7013708
              ],
              [
                51.5903953,
                32.7010426
              ],
              [
                51.590655,
                32.7002364
              ],
              [
                51.5894319,
                32.6997597
              ],
              [
                51.5898053,
                32.6992396
              ],
              [
                51.5894834,
                32.698929
              ],
              [
                51.5886594,
                32.6980587
              ],
              [
                51.58799,
                32.697647
              ],
              [
                51.5864836,
                32.6971703
              ],
              [
                51.5865995,
                32.6966936
              ],
              [
                51.587578,
                32.6969211
              ],
              [
                51.5877067,
                32.6966502
              ],
              [
                51.5877325,
                32.6959243
              ],
              [
                51.5872947,
                32.6951117
              ],
              [
                51.5873334,
                32.6946892
              ],
              [
                51.5872175,
                32.6940391
              ],
              [
                51.5867154,
                32.6927389
              ],
              [
                51.5867411,
                32.691547
              ],
              [
                51.58696,
                32.6889249
              ],
              [
                51.5867411,
                32.6882206
              ],
              [
                51.5863163,
                32.6875813
              ],
              [
                51.5853507,
                32.6871262
              ],
              [
                51.5853249,
                32.6863893
              ],
              [
                51.5855458,
                32.686098
              ],
              [
                51.5856682,
                32.6858367
              ],
              [
                51.5857257,
                32.685603
              ],
              [
                51.5861123,
                32.6846717
              ],
              [
                51.5873205,
                32.6850085
              ],
              [
                51.5884019,
                32.6853552
              ],
              [
                51.5897018,
                32.6855266
              ],
              [
                51.5900693,
                32.6836001
              ],
              [
                51.5919658,
                32.6839184
              ],
              [
                51.5921542,
                32.6823659
              ],
              [
                51.5921316,
                32.679202
              ],
              [
                51.5920371,
                32.677932
              ],
              [
                51.5915287,
                32.677024
              ],
              [
                51.5910203,
                32.676116
              ],
              [
                51.5901719,
                32.6743834
              ],
              [
                51.5882977,
                32.6672515
              ],
              [
                51.587606,
                32.6671009
              ],
              [
                51.5867782,
                32.6666629
              ],
              [
                51.5862256,
                32.66628
              ],
              [
                51.58656,
                32.6655416
              ],
              [
                51.5866175,
                32.6652471
              ],
              [
                51.5856894,
                32.6649318
              ],
              [
                51.585193,
                32.664598
              ],
              [
                51.5846509,
                32.663975
              ],
              [
                51.5838788,
                32.6627623
              ],
              [
                51.5837199,
                32.6623532
              ],
              [
                51.5836656,
                32.6616215
              ],
              [
                51.5812155,
                32.6618585
              ],
              [
                51.5811054,
                32.6606252
              ],
              [
                51.575639,
                32.6615924
              ],
              [
                51.5735716,
                32.657987
              ],
              [
                51.5725323,
                32.6580782
              ],
              [
                51.5716229,
                32.6583698
              ],
              [
                51.5713171,
                32.6550638
              ],
              [
                51.5707377,
                32.6551061
              ],
              [
                51.5706062,
                32.6551783
              ],
              [
                51.5703714,
                32.6551573
              ],
              [
                51.5702799,
                32.6550278
              ],
              [
                51.5702812,
                32.6545796
              ],
              [
                51.5698627,
                32.6544787
              ],
              [
                51.5698068,
                32.6541774
              ],
              [
                51.5694859,
                32.6541083
              ],
              [
                51.5685475,
                32.6542181
              ],
              [
                51.5683653,
                32.6527173
              ],
              [
                51.5684796,
                32.6522556
              ],
              [
                51.5695094,
                32.6522349
              ],
              [
                51.5699631,
                32.6508591
              ],
              [
                51.5700604,
                32.6505254
              ],
              [
                51.5685655,
                32.6497115
              ],
              [
                51.5678706,
                32.649453
              ],
              [
                51.5674539,
                32.6492916
              ],
              [
                51.5668614,
                32.6490225
              ],
              [
                51.5660968,
                32.6487288
              ],
              [
                51.565453,
                32.648512
              ],
              [
                51.5642918,
                32.6482097
              ],
              [
                51.564356,
                32.6457447
              ],
              [
                51.564369,
                32.6454345
              ],
              [
                51.5658367,
                32.6405777
              ],
              [
                51.5627983,
                32.6394069
              ],
              [
                51.5614594,
                32.6384528
              ],
              [
                51.5607899,
                32.6374771
              ],
              [
                51.561913,
                32.6365724
              ],
              [
                51.561836,
                32.636016
              ],
              [
                51.5618017,
                32.6355824
              ],
              [
                51.5621279,
                32.6349969
              ],
              [
                51.5626161,
                32.6345078
              ],
              [
                51.5628116,
                32.6342319
              ],
              [
                51.5628918,
                32.6339922
              ],
              [
                51.5627544,
                32.6336019
              ],
              [
                51.5621794,
                32.6329658
              ],
              [
                51.5618704,
                32.6325755
              ],
              [
                51.5616901,
                32.6321056
              ],
              [
                51.5616472,
                32.6311804
              ],
              [
                51.5621349,
                32.6301485
              ],
              [
                51.5621308,
                32.6294392
              ],
              [
                51.5620249,
                32.6289541
              ],
              [
                51.5619594,
                32.6286891
              ],
              [
                51.5621708,
                32.6284842
              ],
              [
                51.562557,
                32.6282529
              ],
              [
                51.5637501,
                32.6279349
              ],
              [
                51.5647972,
                32.6276602
              ],
              [
                51.5657097,
                32.6273509
              ],
              [
                51.5657856,
                32.6271922
              ],
              [
                51.565632,
                32.6269075
              ],
              [
                51.565647,
                32.6267029
              ],
              [
                51.5656471,
                32.6263354
              ],
              [
                51.5655817,
                32.626255
              ],
              [
                51.565506,
                32.6259653
              ],
              [
                51.5654336,
                32.6255984
              ],
              [
                51.5654604,
                32.6251606
              ],
              [
                51.5654776,
                32.624653
              ],
              [
                51.5656257,
                32.6243646
              ],
              [
                51.5660083,
                32.6240138
              ],
              [
                51.5663936,
                32.6236048
              ],
              [
                51.5667198,
                32.6232362
              ],
              [
                51.5667627,
                32.6222024
              ],
              [
                51.5666168,
                32.6211976
              ],
              [
                51.5703642,
                32.6232924
              ],
              [
                51.5709772,
                32.623635
              ],
              [
                51.5759345,
                32.6181061
              ],
              [
                51.5753681,
                32.6178025
              ],
              [
                51.5761405,
                32.6168048
              ],
              [
                51.5764753,
                32.6163494
              ],
              [
                51.5768615,
                32.6153083
              ],
              [
                51.57681,
                32.6147878
              ],
              [
                51.57681,
                32.6145492
              ],
              [
                51.5765525,
                32.6146143
              ],
              [
                51.576192,
                32.6117513
              ],
              [
                51.5757801,
                32.6100595
              ],
              [
                51.5758058,
                32.6098859
              ],
              [
                51.576548,
                32.6096876
              ],
              [
                51.5761239,
                32.6086696
              ],
              [
                51.5751239,
                32.6082313
              ],
              [
                51.5742141,
                32.6078878
              ],
              [
                51.5731959,
                32.6070014
              ],
              [
                51.5731456,
                32.6064021
              ],
              [
                51.5729095,
                32.6054982
              ],
              [
                51.5726698,
                32.6043447
              ],
              [
                51.5724294,
                32.603382
              ],
              [
                51.5739361,
                32.6014191
              ],
              [
                51.5719394,
                32.5968541
              ],
              [
                51.572413,
                32.596536
              ],
              [
                51.5731264,
                32.5962628
              ],
              [
                51.5766492,
                32.5995622
              ],
              [
                51.577597,
                32.5987658
              ],
              [
                51.5786073,
                32.5999469
              ],
              [
                51.5791863,
                32.599624
              ],
              [
                51.5805437,
                32.5987799
              ],
              [
                51.5808784,
                32.5987582
              ],
              [
                51.5808788,
                32.598447
              ],
              [
                51.5808994,
                32.5820251
              ],
              [
                51.5917096,
                32.5791111
              ],
              [
                51.5974363,
                32.5773971
              ],
              [
                51.6268934,
                32.5682835
              ],
              [
                51.6286489,
                32.5676956
              ],
              [
                51.6278123,
                32.5332389
              ],
              [
                51.6276244,
                32.5290375
              ],
              [
                51.6362782,
                32.5118459
              ],
              [
                51.6468348,
                32.5024011
              ],
              [
                51.6471147,
                32.5021212
              ],
              [
                51.6560012,
                32.4935071
              ],
              [
                51.656558,
                32.4932273
              ],
              [
                51.6796144,
                32.4832317
              ],
              [
                51.6804476,
                32.4832316
              ],
              [
                51.6823943,
                32.4823309
              ],
              [
                51.6876709,
                32.4810104
              ],
              [
                51.6885042,
                32.4807305
              ],
              [
                51.7187839,
                32.4643421
              ],
              [
                51.7407302,
                32.4421206
              ],
              [
                51.7418402,
                32.44129
              ],
              [
                51.7551733,
                32.435177
              ],
              [
                51.7593427,
                32.4323994
              ],
              [
                51.7596201,
                32.4321251
              ],
              [
                51.7610066,
                32.4318452
              ],
              [
                51.7612867,
                32.4315652
              ],
              [
                51.7621199,
                32.4310054
              ],
              [
                51.7654532,
                32.4298948
              ],
              [
                51.7707299,
                32.426283
              ],
              [
                51.7962863,
                32.4132356
              ],
              [
                51.8145994,
                32.3927172
              ],
              [
                51.831893,
                32.3912958
              ],
              [
                51.8544678,
                32.379959
              ],
              [
                51.8650817,
                32.3711904
              ],
              [
                51.8725346,
                32.3667729
              ],
              [
                51.8844794,
                32.3606784
              ],
              [
                51.9010591,
                32.3484366
              ],
              [
                51.9210088,
                32.3384749
              ],
              [
                51.9312611,
                32.3307151
              ],
              [
                51.9418643,
                32.3180099
              ],
              [
                51.9710173,
                32.3562871
              ],
              [
                51.9721272,
                32.3571178
              ],
              [
                51.9751839,
                32.3601698
              ],
              [
                51.9918502,
                32.3879533
              ],
              [
                51.9924069,
                32.3885041
              ],
              [
                51.9926835,
                32.3896238
              ],
              [
                52.0037967,
                32.4060121
              ],
              [
                52.0046302,
                32.4076735
              ],
              [
                52.00809,
                32.4595377
              ],
              [
                52.0097602,
                32.4810391
              ],
              [
                52.0175168,
                32.4867508
              ],
              [
                52.0308647,
                32.4910942
              ],
              [
                52.048528,
                32.4907557
              ],
              [
                52.055621,
                32.4897226
              ],
              [
                52.0633258,
                32.4876176
              ],
              [
                52.0806509,
                32.4824645
              ],
              [
                52.0855634,
                32.4813687
              ],
              [
                52.089808,
                32.4790489
              ],
              [
                52.0915885,
                32.4782719
              ],
              [
                52.1010137,
                32.4855923
              ],
              [
                52.1043777,
                32.488443
              ],
              [
                52.1064928,
                32.4919658
              ],
              [
                52.1046352,
                32.4924248
              ],
              [
                52.1025753,
                32.4940175
              ],
              [
                52.10035,
                32.4942466
              ],
              [
                52.0978419,
                32.4941362
              ],
              [
                52.093617,
                32.4974089
              ],
              [
                52.0918778,
                32.4981116
              ],
              [
                52.0961695,
                32.5058572
              ],
              [
                52.0933383,
                32.5081373
              ],
              [
                52.0913226,
                32.5094842
              ],
              [
                52.08944,
                32.5111032
              ],
              [
                52.0827477,
                32.5175884
              ],
              [
                52.0774764,
                32.5252145
              ],
              [
                52.0731596,
                32.5336475
              ],
              [
                52.0684199,
                32.5426374
              ],
              [
                52.0676213,
                32.5451789
              ],
              [
                52.0680231,
                32.5464031
              ],
              [
                52.0747146,
                32.5557071
              ],
              [
                52.0857234,
                32.5643967
              ],
              [
                52.0810063,
                32.5636976
              ],
              [
                52.075328,
                32.5633721
              ],
              [
                52.033224,
                32.5671416
              ],
              [
                52.0105688,
                32.5698847
              ],
              [
                52.0043532,
                32.5796212
              ],
              [
                51.9968534,
                32.5812917
              ],
              [
                51.9960201,
                32.5815716
              ],
              [
                51.9943501,
                32.5815715
              ],
              [
                51.9657403,
                32.5907364
              ],
              [
                51.9651623,
                32.5909306
              ],
              [
                51.9626839,
                32.591847
              ],
              [
                51.9618504,
                32.5923978
              ],
              [
                51.9618505,
                32.5926777
              ],
              [
                51.9576839,
                32.5987906
              ],
              [
                51.957127,
                32.5999013
              ],
              [
                51.9571271,
                32.600452
              ],
              [
                51.9560173,
                32.6032331
              ],
              [
                51.9576839,
                32.609346
              ],
              [
                51.9579604,
                32.6107366
              ],
              [
                51.9593506,
                32.6129579
              ],
              [
                51.9626838,
                32.6243439
              ],
              [
                51.964627,
                32.6312875
              ],
              [
                51.9668502,
                32.6357391
              ],
              [
                51.9690737,
                32.644624
              ],
              [
                51.9743502,
                32.6546286
              ],
              [
                51.9749068,
                32.65629
              ],
              [
                51.9757402,
                32.6576805
              ],
              [
                51.9774069,
                32.6626828
              ],
              [
                51.97824,
                32.6646241
              ],
              [
                51.9787967,
                32.6723985
              ],
              [
                51.9779635,
                32.6748996
              ],
              [
                51.9704602,
                32.682403
              ],
              [
                51.9667723,
                32.6843753
              ],
              [
                51.9543506,
                32.6910171
              ],
              [
                51.9529605,
                32.691017
              ],
              [
                51.9436063,
                32.6844706
              ],
              [
                51.9387638,
                32.6866378
              ],
              [
                51.9348546,
                32.688877
              ],
              [
                51.9296388,
                32.6910359
              ],
              [
                51.9255107,
                32.6927516
              ],
              [
                51.9225444,
                32.6946841
              ],
              [
                51.9197,
                32.6962012
              ],
              [
                51.9166362,
                32.698016
              ],
              [
                51.9120704,
                32.7006435
              ],
              [
                51.9074122,
                32.7032695
              ],
              [
                51.8991587,
                32.708155
              ],
              [
                51.893668,
                32.7119195
              ],
              [
                51.8904267,
                32.7145645
              ],
              [
                51.8880629,
                32.7166231
              ],
              [
                51.8852305,
                32.7202157
              ],
              [
                51.8820734,
                32.7248196
              ],
              [
                51.880125,
                32.7288648
              ],
              [
                51.8795196,
                32.7320555
              ],
              [
                51.8798792,
                32.7366808
              ],
              [
                51.8800508,
                32.7395422
              ],
              [
                51.880289,
                32.7424842
              ],
              [
                51.880499,
                32.745599
              ],
              [
                51.8806982,
                32.7488577
              ],
              [
                51.8812393,
                32.7511142
              ],
              [
                51.8821516,
                32.7549777
              ],
              [
                51.8851281,
                32.7603557
              ],
              [
                51.8892671,
                32.7636672
              ],
              [
                51.920968,
                32.7764923
              ],
              [
                51.925976,
                32.7794271
              ],
              [
                51.9321952,
                32.7827464
              ],
              [
                51.9361958,
                32.7846402
              ],
              [
                51.9315765,
                32.7879923
              ],
              [
                51.9260608,
                32.7922046
              ],
              [
                51.9124043,
                32.8001819
              ],
              [
                51.9012013,
                32.8041182
              ],
              [
                51.8926991,
                32.8041181
              ],
              [
                51.8877004,
                32.8044342
              ],
              [
                51.879756,
                32.8045424
              ],
              [
                51.8759076,
                32.8046505
              ],
              [
                51.8686583,
                32.8044255
              ],
              [
                51.8624572,
                32.8045348
              ],
              [
                51.8541207,
                32.8034887
              ],
              [
                51.8482044,
                32.8025869
              ],
              [
                51.8331659,
                32.8003952
              ],
              [
                51.8248531,
                32.7996552
              ],
              [
                51.8163856,
                32.7988079
              ],
              [
                51.8090183,
                32.797777
              ],
              [
                51.7972632,
                32.7928341
              ],
              [
                51.7908259,
                32.7883534
              ],
              [
                51.780964,
                32.7825302
              ],
              [
                51.7707415,
                32.775386
              ],
              [
                51.7573519,
                32.7700383
              ],
              [
                51.7502245,
                32.766015
              ],
              [
                51.7475072,
                32.7640766
              ],
              [
                51.7438766,
                32.7615865
              ],
              [
                51.7417091,
                32.76003
              ],
              [
                51.7380573,
                32.7574073
              ],
              [
                51.7351219,
                32.75561
              ],
              [
                51.729148,
                32.7515388
              ],
              [
                51.7284013,
                32.7507159
              ],
              [
                51.7256719,
                32.7482687
              ],
              [
                51.7253761,
                32.7477763
              ],
              [
                51.7160159,
                32.749135
              ],
              [
                51.7129811,
                32.7496187
              ],
              [
                51.7082027,
                32.749689
              ],
              [
                51.705367,
                32.7497018
              ],
              [
                51.7050316,
                32.749753
              ],
              [
                51.6912148,
                32.7531206
              ],
              [
                51.6800693,
                32.7558101
              ],
              [
                51.6751165,
                32.7570034
              ],
              [
                51.6712559,
                32.7579336
              ],
              [
                51.66257,
                32.7604509
              ],
              [
                51.6563685,
                32.7627719
              ],
              [
                51.6516505,
                32.7645475
              ],
              [
                51.6470661,
                32.7652638
              ],
              [
                51.641017,
                32.7662275
              ],
              [
                51.6407866,
                32.766229
              ],
              [
                51.6337783,
                32.7644955
              ],
              [
                51.6263169,
                32.7728857
              ],
              [
                51.6215066,
                32.7783417
              ],
              [
                51.6186436,
                32.7815888
              ],
              [
                51.6110476,
                32.7901395
              ],
              [
                51.6097344,
                32.7918495
              ],
              [
                51.6086787,
                32.7938193
              ],
              [
                51.6077774,
                32.7958972
              ],
              [
                51.607211,
                32.7979535
              ],
              [
                51.607101,
                32.799139
              ],
              [
                51.6064642,
                32.8060048
              ],
              [
                51.5754622,
                32.8201795
              ],
              [
                51.5746125,
                32.8203959
              ],
              [
                51.574003,
                32.8202961
              ],
              [
                51.572128,
                32.8193481
              ],
              [
                51.550829,
                32.8087758
              ],
              [
                51.5503404,
                32.8086376
              ],
              [
                51.5496253,
                32.8085639
              ],
              [
                51.5481214,
                32.8085506
              ],
              [
                51.5387438,
                32.8093365
              ],
              [
                51.5464858,
                32.7791316
              ],
              [
                51.546645,
                32.778467
              ],
              [
                51.5256383,
                32.7745093
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554916,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان برخوار",
          "name:en": "Borkhar County",
          "name:fa": "شهرستان برخوار",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289256",
          "wikipedia": "en:Borkhar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.508199,
                33.1682789
              ],
              [
                51.5140317,
                33.1595988
              ],
              [
                51.5181544,
                33.1531355
              ],
              [
                51.5215729,
                33.145924
              ],
              [
                51.5258716,
                33.1375426
              ],
              [
                51.5291497,
                33.127892
              ],
              [
                51.531852,
                33.1199132
              ],
              [
                51.5361636,
                33.1031488
              ],
              [
                51.5368886,
                33.0937008
              ],
              [
                51.5379272,
                33.0863064
              ],
              [
                51.5361586,
                33.0709775
              ],
              [
                51.5332603,
                33.0602557
              ],
              [
                51.5272006,
                33.0464541
              ],
              [
                51.5261471,
                33.0382275
              ],
              [
                51.5393674,
                33.0231774
              ],
              [
                51.5516685,
                33.0158114
              ],
              [
                51.5650718,
                33.0108262
              ],
              [
                51.5757784,
                33.005374
              ],
              [
                51.5835009,
                32.9992797
              ],
              [
                51.5863058,
                32.9924472
              ],
              [
                51.5896837,
                32.9811041
              ],
              [
                51.5909646,
                32.9743672
              ],
              [
                51.591473,
                32.9679497
              ],
              [
                51.5906446,
                32.9564746
              ],
              [
                51.5914654,
                32.9453177
              ],
              [
                51.592071,
                32.9355248
              ],
              [
                51.5928268,
                32.9257076
              ],
              [
                51.5943692,
                32.9160576
              ],
              [
                51.595762,
                32.9100601
              ],
              [
                51.6020259,
                32.9001876
              ],
              [
                51.607779,
                32.8930107
              ],
              [
                51.6177299,
                32.8845498
              ],
              [
                51.62696,
                32.8783876
              ],
              [
                51.6389485,
                32.8705195
              ],
              [
                51.643366,
                32.8687175
              ],
              [
                51.6475058,
                32.86367
              ],
              [
                51.6497382,
                32.8589464
              ],
              [
                51.6439446,
                32.8542527
              ],
              [
                51.6452126,
                32.8528957
              ],
              [
                51.6543283,
                32.8452558
              ],
              [
                51.6528559,
                32.844237
              ],
              [
                51.6516217,
                32.8434366
              ],
              [
                51.6541983,
                32.8405442
              ],
              [
                51.6472623,
                32.8341844
              ],
              [
                51.6448008,
                32.829597
              ],
              [
                51.64405,
                32.8223913
              ],
              [
                51.6448711,
                32.8156154
              ],
              [
                51.6455235,
                32.8010332
              ],
              [
                51.6418433,
                32.7984348
              ],
              [
                51.6380941,
                32.7964185
              ],
              [
                51.6357383,
                32.7933779
              ],
              [
                51.6320857,
                32.7907534
              ],
              [
                51.6215066,
                32.7783417
              ],
              [
                51.6263169,
                32.7728857
              ],
              [
                51.6337783,
                32.7644955
              ],
              [
                51.6407866,
                32.766229
              ],
              [
                51.641017,
                32.7662275
              ],
              [
                51.6470661,
                32.7652638
              ],
              [
                51.6516505,
                32.7645475
              ],
              [
                51.6563685,
                32.7627719
              ],
              [
                51.66257,
                32.7604509
              ],
              [
                51.6712559,
                32.7579336
              ],
              [
                51.6751165,
                32.7570034
              ],
              [
                51.6800693,
                32.7558101
              ],
              [
                51.6912148,
                32.7531206
              ],
              [
                51.7050316,
                32.749753
              ],
              [
                51.705367,
                32.7497018
              ],
              [
                51.7082027,
                32.749689
              ],
              [
                51.7129811,
                32.7496187
              ],
              [
                51.7160159,
                32.749135
              ],
              [
                51.7253761,
                32.7477763
              ],
              [
                51.7256719,
                32.7482687
              ],
              [
                51.7284013,
                32.7507159
              ],
              [
                51.729148,
                32.7515388
              ],
              [
                51.7351219,
                32.75561
              ],
              [
                51.7380573,
                32.7574073
              ],
              [
                51.7417091,
                32.76003
              ],
              [
                51.7438766,
                32.7615865
              ],
              [
                51.7475072,
                32.7640766
              ],
              [
                51.7502245,
                32.766015
              ],
              [
                51.7573519,
                32.7700383
              ],
              [
                51.7707415,
                32.775386
              ],
              [
                51.780964,
                32.7825302
              ],
              [
                51.7908259,
                32.7883534
              ],
              [
                51.7972632,
                32.7928341
              ],
              [
                51.8090183,
                32.797777
              ],
              [
                51.8163856,
                32.7988079
              ],
              [
                51.8248531,
                32.7996552
              ],
              [
                51.8331659,
                32.8003952
              ],
              [
                51.8482044,
                32.8025869
              ],
              [
                51.8541207,
                32.8034887
              ],
              [
                51.8624572,
                32.8045348
              ],
              [
                51.8686583,
                32.8044255
              ],
              [
                51.8759076,
                32.8046505
              ],
              [
                51.879756,
                32.8045424
              ],
              [
                51.8877004,
                32.8044342
              ],
              [
                51.8926991,
                32.8041181
              ],
              [
                51.9012013,
                32.8041182
              ],
              [
                51.9124043,
                32.8001819
              ],
              [
                51.9260608,
                32.7922046
              ],
              [
                51.9315765,
                32.7879923
              ],
              [
                51.9361958,
                32.7846402
              ],
              [
                51.9404606,
                32.7776808
              ],
              [
                51.9410172,
                32.7765702
              ],
              [
                51.9579602,
                32.7635138
              ],
              [
                51.9687935,
                32.757401
              ],
              [
                51.9701834,
                32.7571301
              ],
              [
                51.9824067,
                32.7507373
              ],
              [
                51.9929632,
                32.7468547
              ],
              [
                51.9937966,
                32.7465749
              ],
              [
                51.9976865,
                32.7485161
              ],
              [
                51.9990731,
                32.7515771
              ],
              [
                51.9993531,
                32.7518479
              ],
              [
                52.0001866,
                32.7532384
              ],
              [
                52.0018531,
                32.7562904
              ],
              [
                52.0057395,
                32.77741
              ],
              [
                52.0060196,
                32.7776809
              ],
              [
                52.0057396,
                32.7782407
              ],
              [
                52.0015731,
                32.7899065
              ],
              [
                51.997963,
                32.7940781
              ],
              [
                51.9918498,
                32.802963
              ],
              [
                51.9904632,
                32.8051842
              ],
              [
                51.9654602,
                32.8329673
              ],
              [
                51.9646267,
                32.8343488
              ],
              [
                51.9604602,
                32.8385203
              ],
              [
                51.9599069,
                32.8396309
              ],
              [
                51.9443504,
                32.8521274
              ],
              [
                51.9485171,
                32.8582402
              ],
              [
                51.9490703,
                32.8585201
              ],
              [
                51.9490704,
                32.8588
              ],
              [
                51.9501837,
                32.8596308
              ],
              [
                51.9879631,
                32.9007408
              ],
              [
                51.9910163,
                32.9049124
              ],
              [
                51.9921298,
                32.9062938
              ],
              [
                51.999937,
                32.9174337
              ],
              [
                52.0045245,
                32.9247711
              ],
              [
                52.0110158,
                32.9331942
              ],
              [
                52.0147915,
                32.938149
              ],
              [
                52.0193347,
                32.9438419
              ],
              [
                52.0246138,
                32.947636
              ],
              [
                52.0290372,
                32.9511814
              ],
              [
                52.0316162,
                32.95273
              ],
              [
                52.0342101,
                32.9546107
              ],
              [
                52.0377805,
                32.9567353
              ],
              [
                52.0403913,
                32.9578328
              ],
              [
                52.0429521,
                32.9578747
              ],
              [
                52.0534177,
                32.9567943
              ],
              [
                52.0615512,
                32.9557942
              ],
              [
                52.0668484,
                32.9543898
              ],
              [
                52.0690561,
                32.9527611
              ],
              [
                52.0726779,
                32.9498802
              ],
              [
                52.0765592,
                32.9456586
              ],
              [
                52.0797872,
                32.9545565
              ],
              [
                52.0807743,
                32.9579775
              ],
              [
                52.08352,
                32.9613776
              ],
              [
                52.0729403,
                32.9674235
              ],
              [
                52.0607279,
                32.9741478
              ],
              [
                52.0558861,
                32.9759881
              ],
              [
                52.0456314,
                32.9797456
              ],
              [
                52.0305567,
                32.9851305
              ],
              [
                52.0134342,
                32.9917736
              ],
              [
                51.9969743,
                32.9977987
              ],
              [
                51.9859499,
                33.0062846
              ],
              [
                51.9692451,
                33.0191469
              ],
              [
                51.9524283,
                33.0350715
              ],
              [
                51.941357,
                33.0467296
              ],
              [
                51.9356055,
                33.059582
              ],
              [
                51.9322254,
                33.0708049
              ],
              [
                51.9298889,
                33.0822955
              ],
              [
                51.9258556,
                33.096162
              ],
              [
                51.9231121,
                33.1078049
              ],
              [
                51.918594,
                33.1197806
              ],
              [
                51.912957,
                33.1340027
              ],
              [
                51.9092805,
                33.14283
              ],
              [
                51.9070489,
                33.1515389
              ],
              [
                51.9053105,
                33.1596309
              ],
              [
                51.902459,
                33.1690836
              ],
              [
                51.901044,
                33.1783525
              ],
              [
                51.8941783,
                33.1882777
              ],
              [
                51.8716907,
                33.2172203
              ],
              [
                51.8649402,
                33.2236511
              ],
              [
                51.8591178,
                33.231585
              ],
              [
                51.83856,
                33.254336
              ],
              [
                51.8156475,
                33.2789433
              ],
              [
                51.8053801,
                33.2744128
              ],
              [
                51.7826842,
                33.2647429
              ],
              [
                51.7726056,
                33.2606692
              ],
              [
                51.7635293,
                33.2580034
              ],
              [
                51.7583942,
                33.2574402
              ],
              [
                51.7537975,
                33.2562972
              ],
              [
                51.7504129,
                33.2558451
              ],
              [
                51.744147,
                33.2535358
              ],
              [
                51.738998,
                33.2528093
              ],
              [
                51.7351245,
                33.2522351
              ],
              [
                51.7285594,
                33.2523123
              ],
              [
                51.722249,
                33.2519253
              ],
              [
                51.7002173,
                33.2527252
              ],
              [
                51.6915284,
                33.2531886
              ],
              [
                51.6797102,
                33.2512866
              ],
              [
                51.6716241,
                33.2496787
              ],
              [
                51.6628751,
                33.2478124
              ],
              [
                51.6579943,
                33.2475457
              ],
              [
                51.6473905,
                33.2465859
              ],
              [
                51.6358279,
                33.2439998
              ],
              [
                51.6274548,
                33.238484
              ],
              [
                51.6201234,
                33.233186
              ],
              [
                51.6044139,
                33.2207386
              ],
              [
                51.5943965,
                33.2156884
              ],
              [
                51.5908846,
                33.2137462
              ],
              [
                51.588398,
                33.2119509
              ],
              [
                51.5861235,
                33.2105939
              ],
              [
                51.5827019,
                33.2085113
              ],
              [
                51.5780063,
                33.206867
              ],
              [
                51.5728397,
                33.2054666
              ],
              [
                51.5672846,
                33.2053874
              ],
              [
                51.5640549,
                33.2062614
              ],
              [
                51.5616215,
                33.2059469
              ],
              [
                51.5561771,
                33.2066217
              ],
              [
                51.5262324,
                33.202302
              ],
              [
                51.4854006,
                33.1966151
              ],
              [
                51.4867145,
                33.1941455
              ],
              [
                51.5007695,
                33.1768078
              ],
              [
                51.508199,
                33.1682789
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554950,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بوئین و میاندشت",
          "name:en": "Buin and Miandasht County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q15624163",
          "wikipedia": "fa:شهرستان بوئین و میاندشت"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.878977,
                33.1282436
              ],
              [
                49.8795304,
                33.1279729
              ],
              [
                49.9187001,
                33.1004708
              ],
              [
                49.9189801,
                33.0996311
              ],
              [
                49.9198134,
                33.0971302
              ],
              [
                49.9203665,
                33.0962994
              ],
              [
                49.9211998,
                33.0943582
              ],
              [
                49.9217568,
                33.0940783
              ],
              [
                49.9220333,
                33.0932386
              ],
              [
                49.9228666,
                33.092417
              ],
              [
                49.9231467,
                33.0915773
              ],
              [
                49.9239798,
                33.0901868
              ],
              [
                49.9242565,
                33.0896361
              ],
              [
                49.9220334,
                33.0732485
              ],
              [
                49.9214799,
                33.0721379
              ],
              [
                49.9148102,
                33.0657454
              ],
              [
                49.9150899,
                33.0654655
              ],
              [
                49.9273132,
                33.0596328
              ],
              [
                49.9281464,
                33.0596328
              ],
              [
                49.9284233,
                33.0593529
              ],
              [
                49.9467561,
                33.0532403
              ],
              [
                49.9584263,
                33.048798
              ],
              [
                49.9600928,
                33.0482383
              ],
              [
                49.9600928,
                33.0479674
              ],
              [
                49.9606463,
                33.0479674
              ],
              [
                49.960926,
                33.0476875
              ],
              [
                49.963426,
                33.0468568
              ],
              [
                49.9639796,
                33.046297
              ],
              [
                49.9906493,
                33.0329612
              ],
              [
                49.9906493,
                33.0326903
              ],
              [
                49.9912024,
                33.0324105
              ],
              [
                49.9912024,
                33.0321305
              ],
              [
                49.9917591,
                33.0318506
              ],
              [
                50.0298777,
                33.0123488
              ],
              [
                50.0300954,
                33.0121312
              ],
              [
                50.0312053,
                33.0118603
              ],
              [
                50.0317618,
                33.0115804
              ],
              [
                50.0325955,
                33.0110206
              ],
              [
                50.032872,
                33.0104698
              ],
              [
                50.0328721,
                33.0101899
              ],
              [
                50.0434286,
                32.9999059
              ],
              [
                50.051485,
                32.9929625
              ],
              [
                50.0550952,
                32.9874096
              ],
              [
                50.0553753,
                32.986579
              ],
              [
                50.0573183,
                32.9849086
              ],
              [
                50.062595,
                32.9826874
              ],
              [
                50.062875,
                32.9824075
              ],
              [
                50.0670415,
                32.9824075
              ],
              [
                50.0673181,
                32.9821276
              ],
              [
                50.0748183,
                32.9821276
              ],
              [
                50.0756515,
                32.9824075
              ],
              [
                50.077598,
                32.9824075
              ],
              [
                50.0784316,
                32.9821277
              ],
              [
                50.080098,
                32.9821277
              ],
              [
                50.0817648,
                32.9815769
              ],
              [
                50.0889881,
                32.9810261
              ],
              [
                50.0895412,
                32.9807462
              ],
              [
                50.0909315,
                32.9807462
              ],
              [
                50.0953745,
                32.9793557
              ],
              [
                50.0962077,
                32.9793557
              ],
              [
                50.0964879,
                32.9790758
              ],
              [
                50.0970413,
                32.9790758
              ],
              [
                50.0981547,
                32.9787959
              ],
              [
                50.1009313,
                32.9782451
              ],
              [
                50.1145444,
                32.9724123
              ],
              [
                50.1173211,
                32.9724123
              ],
              [
                50.1214875,
                32.9724123
              ],
              [
                50.123431,
                32.973243
              ],
              [
                50.1239876,
                32.9732431
              ],
              [
                50.1242641,
                32.9735229
              ],
              [
                50.1248208,
                32.9735229
              ],
              [
                50.1248208,
                32.9738029
              ],
              [
                50.125654,
                32.9738028
              ],
              [
                50.125654,
                32.9740737
              ],
              [
                50.1267673,
                32.9740737
              ],
              [
                50.1298209,
                32.9762949
              ],
              [
                50.1312108,
                32.9849087
              ],
              [
                50.1320439,
                32.9907415
              ],
              [
                50.1267673,
                33.0001588
              ],
              [
                50.1289872,
                33.0040774
              ],
              [
                50.1351006,
                33.0168536
              ],
              [
                50.1387104,
                33.0221356
              ],
              [
                50.1473238,
                33.0301895
              ],
              [
                50.1537103,
                33.0332413
              ],
              [
                50.1548236,
                33.0332413
              ],
              [
                50.1553771,
                33.0335212
              ],
              [
                50.1573237,
                33.0340811
              ],
              [
                50.1581569,
                33.0343519
              ],
              [
                50.1598238,
                33.0343519
              ],
              [
                50.1603768,
                33.0346318
              ],
              [
                50.1667668,
                33.0346318
              ],
              [
                50.1676,
                33.0343519
              ],
              [
                50.1870465,
                33.0304604
              ],
              [
                50.1876032,
                33.0304604
              ],
              [
                50.1880219,
                33.0303214
              ],
              [
                50.2053797,
                33.0485185
              ],
              [
                50.2059363,
                33.0487985
              ],
              [
                50.2062128,
                33.0490783
              ],
              [
                50.2067695,
                33.0496291
              ],
              [
                50.233436,
                33.0685178
              ],
              [
                50.2337158,
                33.0690776
              ],
              [
                50.2437159,
                33.0737998
              ],
              [
                50.2470492,
                33.0754611
              ],
              [
                50.2973282,
                33.1021326
              ],
              [
                50.2989951,
                33.1032433
              ],
              [
                50.315665,
                33.1188001
              ],
              [
                50.3184416,
                33.1235222
              ],
              [
                50.322608,
                33.1362981
              ],
              [
                50.3228846,
                33.136578
              ],
              [
                50.3228846,
                33.1382483
              ],
              [
                50.3248311,
                33.1549156
              ],
              [
                50.3251081,
                33.1576965
              ],
              [
                50.3278846,
                33.1707431
              ],
              [
                50.3287178,
                33.1721335
              ],
              [
                50.3287178,
                33.1724135
              ],
              [
                50.324831,
                33.1754652
              ],
              [
                50.3242744,
                33.1757451
              ],
              [
                50.286495,
                33.2107495
              ],
              [
                50.2856613,
                33.2115802
              ],
              [
                50.2698286,
                33.2301883
              ],
              [
                50.2698287,
                33.2307481
              ],
              [
                50.2617718,
                33.2382509
              ],
              [
                50.2545486,
                33.2421423
              ],
              [
                50.2537155,
                33.2421423
              ],
              [
                50.2506587,
                33.2435237
              ],
              [
                50.2506587,
                33.2438036
              ],
              [
                50.2501051,
                33.2438035
              ],
              [
                50.2487152,
                33.245194
              ],
              [
                50.2484388,
                33.2454739
              ],
              [
                50.2473254,
                33.2454738
              ],
              [
                50.2220491,
                33.2562991
              ],
              [
                50.2214925,
                33.2565791
              ],
              [
                50.2212159,
                33.2568589
              ],
              [
                50.2162122,
                33.2579695
              ],
              [
                50.1750997,
                33.2699142
              ],
              [
                50.1748227,
                33.2701942
              ],
              [
                50.1739895,
                33.2707449
              ],
              [
                50.1725997,
                33.2710338
              ],
              [
                50.164823,
                33.274916
              ],
              [
                50.1367668,
                33.2874206
              ],
              [
                50.1359333,
                33.2874206
              ],
              [
                50.1281534,
                33.2907521
              ],
              [
                50.1273203,
                33.2907522
              ],
              [
                50.1120437,
                33.2976952
              ],
              [
                50.1114871,
                33.297966
              ],
              [
                50.098154,
                33.3043581
              ],
              [
                50.0973204,
                33.3051887
              ],
              [
                50.0856506,
                33.3110302
              ],
              [
                50.0848174,
                33.3110302
              ],
              [
                50.0839842,
                33.311581
              ],
              [
                50.0831506,
                33.3115809
              ],
              [
                50.082874,
                33.3118609
              ],
              [
                50.0817642,
                33.3118608
              ],
              [
                50.0739839,
                33.3149125
              ],
              [
                50.0603743,
                33.3238055
              ],
              [
                50.0600942,
                33.3240854
              ],
              [
                50.0559277,
                33.3285274
              ],
              [
                50.0475943,
                33.3401922
              ],
              [
                50.0464846,
                33.3415826
              ],
              [
                50.042038,
                33.3504756
              ],
              [
                50.035928,
                33.3585289
              ],
              [
                50.0353714,
                33.3588088
              ],
              [
                50.0350944,
                33.3590887
              ],
              [
                50.0278712,
                33.3590886
              ],
              [
                50.0248145,
                33.3593595
              ],
              [
                50.0245379,
                33.3596394
              ],
              [
                50.0228715,
                33.3596394
              ],
              [
                50.0223149,
                33.3599192
              ],
              [
                50.0214812,
                33.3599192
              ],
              [
                50.0184281,
                33.3601901
              ],
              [
                50.0167617,
                33.36047
              ],
              [
                50.0162049,
                33.3601901
              ],
              [
                50.0139815,
                33.3593595
              ],
              [
                50.0137049,
                33.3588088
              ],
              [
                50.0125916,
                33.357969
              ],
              [
                50.0070384,
                33.3488052
              ],
              [
                50.0059251,
                33.3440833
              ],
              [
                49.9959249,
                33.3232456
              ],
              [
                49.9953718,
                33.3163027
              ],
              [
                49.9956485,
                33.3154721
              ],
              [
                49.9959249,
                33.3146414
              ],
              [
                49.9967586,
                33.3129712
              ],
              [
                49.9981485,
                33.31103
              ],
              [
                49.998425,
                33.3104703
              ],
              [
                50.000372,
                33.3074187
              ],
              [
                50.0000919,
                33.3068589
              ],
              [
                50.0000919,
                33.3060283
              ],
              [
                49.9987051,
                33.3035274
              ],
              [
                49.9970387,
                33.3015772
              ],
              [
                49.9709257,
                33.2807483
              ],
              [
                49.9678691,
                33.279078
              ],
              [
                49.9673123,
                33.2782473
              ],
              [
                49.9620358,
                33.2704737
              ],
              [
                49.961479,
                33.269914
              ],
              [
                49.9595356,
                33.2688034
              ],
              [
                49.958979,
                33.2685235
              ],
              [
                49.9578692,
                33.2676929
              ],
              [
                49.9570356,
                33.267413
              ],
              [
                49.9473123,
                33.2574092
              ],
              [
                49.9464792,
                33.2499155
              ],
              [
                49.9450893,
                33.2488049
              ],
              [
                49.9428693,
                33.248805
              ],
              [
                49.9423127,
                33.2490849
              ],
              [
                49.9409228,
                33.2490849
              ],
              [
                49.9375892,
                33.2471437
              ],
              [
                49.9359227,
                33.2424127
              ],
              [
                49.9361994,
                33.241582
              ],
              [
                49.9384228,
                33.239361
              ],
              [
                49.9389795,
                33.239361
              ],
              [
                49.9389794,
                33.2390811
              ],
              [
                49.9395361,
                33.2390811
              ],
              [
                49.9400893,
                33.2388012
              ],
              [
                49.9417561,
                33.2376907
              ],
              [
                49.9423128,
                33.2371399
              ],
              [
                49.9462026,
                33.2343591
              ],
              [
                49.9473125,
                33.2326888
              ],
              [
                49.9470359,
                33.2299169
              ],
              [
                49.9464793,
                33.229917
              ],
              [
                49.9442561,
                33.2288065
              ],
              [
                49.9437027,
                33.2290773
              ],
              [
                49.9392561,
                33.2290774
              ],
              [
                49.9384228,
                33.2293572
              ],
              [
                49.9328661,
                33.2293571
              ],
              [
                49.9320329,
                33.2296371
              ],
              [
                49.9298129,
                33.229637
              ],
              [
                49.9289797,
                33.229917
              ],
              [
                49.9250898,
                33.2301878
              ],
              [
                49.9206464,
                33.2301878
              ],
              [
                49.9150896,
                33.2285265
              ],
              [
                49.9050898,
                33.2240844
              ],
              [
                49.89981,
                33.2218543
              ],
              [
                49.8989768,
                33.2218543
              ],
              [
                49.8948099,
                33.2210237
              ],
              [
                49.8895336,
                33.2196333
              ],
              [
                49.8875867,
                33.2179719
              ],
              [
                49.8773103,
                33.2040768
              ],
              [
                49.8770303,
                33.2029661
              ],
              [
                49.8714771,
                33.191301
              ],
              [
                49.871197,
                33.1876895
              ],
              [
                49.8725869,
                33.1826875
              ],
              [
                49.8809202,
                33.1718531
              ],
              [
                49.8823102,
                33.1685214
              ],
              [
                49.88842,
                33.1518632
              ],
              [
                49.8887001,
                33.1507527
              ],
              [
                49.890367,
                33.144911
              ],
              [
                49.8906435,
                33.1446311
              ],
              [
                49.890367,
                33.1438005
              ],
              [
                49.8898104,
                33.1407396
              ],
              [
                49.8892537,
                33.139909
              ],
              [
                49.8887002,
                33.139909
              ],
              [
                49.8884201,
                33.1396291
              ],
              [
                49.8803637,
                33.1379678
              ],
              [
                49.8775871,
                33.134907
              ],
              [
                49.8770304,
                33.1340855
              ],
              [
                49.8767539,
                33.1321351
              ],
              [
                49.8775871,
                33.1301939
              ],
              [
                49.8778636,
                33.1296341
              ],
              [
                49.878977,
                33.1285236
              ],
              [
                49.878977,
                33.1282436
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554972,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تیران و کرون",
          "name:en": "Tiran and Karvan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286519",
          "wikipedia": "en:Tiran and Karvan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.5476808,
                32.9555896
              ],
              [
                50.5481753,
                32.9554652
              ],
              [
                50.5492854,
                32.9549145
              ],
              [
                50.5503952,
                32.9549145
              ],
              [
                50.5584517,
                32.9526843
              ],
              [
                50.5956747,
                32.9471315
              ],
              [
                50.6201209,
                32.9412986
              ],
              [
                50.6331773,
                32.9362965
              ],
              [
                50.6337344,
                32.9357367
              ],
              [
                50.6354008,
                32.9351859
              ],
              [
                50.657624,
                32.9201884
              ],
              [
                50.6595674,
                32.918798
              ],
              [
                50.6909567,
                32.8943559
              ],
              [
                50.7004034,
                32.8838007
              ],
              [
                50.7081801,
                32.8726858
              ],
              [
                50.7345731,
                32.8449027
              ],
              [
                50.7465164,
                32.8379593
              ],
              [
                50.7481829,
                32.8374085
              ],
              [
                50.7520729,
                32.8357381
              ],
              [
                50.7556827,
                32.8343476
              ],
              [
                50.7670726,
                32.8307359
              ],
              [
                50.7923524,
                32.822411
              ],
              [
                50.8042953,
                32.8146277
              ],
              [
                50.8179086,
                32.8018512
              ],
              [
                50.8179085,
                32.8015713
              ],
              [
                50.8184655,
                32.8012914
              ],
              [
                50.8192986,
                32.8004607
              ],
              [
                50.819852,
                32.7999099
              ],
              [
                50.8279086,
                32.794077
              ],
              [
                50.8506883,
                32.7749078
              ],
              [
                50.8506884,
                32.774348
              ],
              [
                50.8509649,
                32.7729574
              ],
              [
                50.851245,
                32.7724067
              ],
              [
                50.851245,
                32.7721268
              ],
              [
                50.8515216,
                32.7704654
              ],
              [
                50.8520782,
                32.7687949
              ],
              [
                50.8523551,
                32.7676843
              ],
              [
                50.8537449,
                32.7615714
              ],
              [
                50.8504117,
                32.7290747
              ],
              [
                50.8506885,
                32.725454
              ],
              [
                50.850965,
                32.7249032
              ],
              [
                50.850965,
                32.722962
              ],
              [
                50.8512452,
                32.7207407
              ],
              [
                50.8520783,
                32.7173998
              ],
              [
                50.8523551,
                32.7151786
              ],
              [
                50.8526317,
                32.7132373
              ],
              [
                50.8529118,
                32.7129574
              ],
              [
                50.8523551,
                32.7121267
              ],
              [
                50.8529117,
                32.7118467
              ],
              [
                50.8551317,
                32.711296
              ],
              [
                50.8570782,
                32.7112959
              ],
              [
                50.8576316,
                32.711016
              ],
              [
                50.8592983,
                32.7110161
              ],
              [
                50.8595783,
                32.7107361
              ],
              [
                50.8604115,
                32.7107362
              ],
              [
                50.8626351,
                32.7101853
              ],
              [
                50.8640216,
                32.7101853
              ],
              [
                50.8648548,
                32.7099055
              ],
              [
                50.8662448,
                32.7099054
              ],
              [
                50.8723547,
                32.7076842
              ],
              [
                50.8731882,
                32.7068535
              ],
              [
                50.8737448,
                32.7068535
              ],
              [
                50.8737447,
                32.7065736
              ],
              [
                50.887358,
                32.6962892
              ],
              [
                50.8873579,
                32.6957384
              ],
              [
                50.8879113,
                32.6951786
              ],
              [
                50.8895779,
                32.6915758
              ],
              [
                50.889858,
                32.6904652
              ],
              [
                50.8901346,
                32.6901853
              ],
              [
                50.8901346,
                32.6896255
              ],
              [
                50.8919712,
                32.6878871
              ],
              [
                50.8996349,
                32.6750001
              ],
              [
                50.9122744,
                32.6666371
              ],
              [
                50.9165393,
                32.6611992
              ],
              [
                50.9187833,
                32.6550611
              ],
              [
                50.920456,
                32.6500763
              ],
              [
                50.9214384,
                32.6475578
              ],
              [
                50.9218042,
                32.6440722
              ],
              [
                50.9220618,
                32.6385581
              ],
              [
                50.9215851,
                32.6279547
              ],
              [
                50.9226377,
                32.6246229
              ],
              [
                50.9229143,
                32.621291
              ],
              [
                50.9231908,
                32.6179591
              ],
              [
                50.923471,
                32.6157379
              ],
              [
                50.9261418,
                32.6000356
              ],
              [
                50.9300017,
                32.5957619
              ],
              [
                50.9412699,
                32.5870349
              ],
              [
                50.9465217,
                32.57951
              ],
              [
                50.9549892,
                32.5727917
              ],
              [
                50.9623231,
                32.5673038
              ],
              [
                50.9736529,
                32.5628285
              ],
              [
                50.9821104,
                32.5589312
              ],
              [
                50.995493,
                32.5541074
              ],
              [
                50.9977867,
                32.5505181
              ],
              [
                50.9981966,
                32.5457328
              ],
              [
                50.9981967,
                32.545182
              ],
              [
                50.9990324,
                32.5392043
              ],
              [
                50.9981967,
                32.5379584
              ],
              [
                50.9984733,
                32.5376786
              ],
              [
                51.0001401,
                32.5335069
              ],
              [
                51.0079166,
                32.5240621
              ],
              [
                51.0081965,
                32.521561
              ],
              [
                51.0087499,
                32.5182291
              ],
              [
                51.00903,
                32.5176784
              ],
              [
                51.00903,
                32.5168386
              ],
              [
                51.0148633,
                32.5190688
              ],
              [
                51.0170865,
                32.5201795
              ],
              [
                51.0243065,
                32.521561
              ],
              [
                51.0251397,
                32.5218409
              ],
              [
                51.0276397,
                32.521841
              ],
              [
                51.0279198,
                32.5221208
              ],
              [
                51.0323629,
                32.5221208
              ],
              [
                51.0331963,
                32.5224008
              ],
              [
                51.0376428,
                32.5224008
              ],
              [
                51.0379196,
                32.5221209
              ],
              [
                51.0504194,
                32.5221209
              ],
              [
                51.0509761,
                32.521841
              ],
              [
                51.0529193,
                32.5218409
              ],
              [
                51.0534759,
                32.521561
              ],
              [
                51.0543094,
                32.521561
              ],
              [
                51.0556995,
                32.5212901
              ],
              [
                51.0562526,
                32.5212902
              ],
              [
                51.0579193,
                32.5212901
              ],
              [
                51.0581992,
                32.5215611
              ],
              [
                51.0623659,
                32.5212902
              ],
              [
                51.0645857,
                32.5207304
              ],
              [
                51.0656992,
                32.5207303
              ],
              [
                51.0676424,
                32.5201795
              ],
              [
                51.0868088,
                32.5148973
              ],
              [
                51.0879221,
                32.5143465
              ],
              [
                51.1037553,
                32.5107348
              ],
              [
                51.1107019,
                32.5107348
              ],
              [
                51.1182018,
                32.5115655
              ],
              [
                51.1207019,
                32.5115655
              ],
              [
                51.1223685,
                32.5118454
              ],
              [
                51.1251451,
                32.5118454
              ],
              [
                51.1368115,
                32.5135069
              ],
              [
                51.1451447,
                32.516008
              ],
              [
                51.174871,
                32.5240623
              ],
              [
                51.1754243,
                32.5242482
              ],
              [
                51.1787577,
                32.5246223
              ],
              [
                51.1801475,
                32.5248932
              ],
              [
                51.1862609,
                32.5268434
              ],
              [
                51.1930935,
                32.540717
              ],
              [
                51.1986238,
                32.5721807
              ],
              [
                51.192817,
                32.5976932
              ],
              [
                51.1912962,
                32.6394994
              ],
              [
                51.1857649,
                32.6878283
              ],
              [
                51.1951464,
                32.6836922
              ],
              [
                51.2159924,
                32.6755824
              ],
              [
                51.224429,
                32.6721874
              ],
              [
                51.227105,
                32.6774457
              ],
              [
                51.2239251,
                32.687337
              ],
              [
                51.1986238,
                32.723402
              ],
              [
                51.2275198,
                32.7616033
              ],
              [
                51.240447,
                32.7821508
              ],
              [
                51.2415185,
                32.785202
              ],
              [
                51.2415876,
                32.785696
              ],
              [
                51.2413802,
                32.7865387
              ],
              [
                51.232117,
                32.8047272
              ],
              [
                51.2320478,
                32.8055697
              ],
              [
                51.2244436,
                32.8152725
              ],
              [
                51.2100994,
                32.8295344
              ],
              [
                51.2096155,
                32.830609
              ],
              [
                51.2087513,
                32.8315674
              ],
              [
                51.2055368,
                32.8376954
              ],
              [
                51.1834804,
                32.8629619
              ],
              [
                51.1829236,
                32.8632417
              ],
              [
                51.1784804,
                32.8632417
              ],
              [
                51.1782038,
                32.8629619
              ],
              [
                51.1765372,
                32.8629618
              ],
              [
                51.164314,
                32.8599099
              ],
              [
                51.1640341,
                32.85963
              ],
              [
                51.161534,
                32.85963
              ],
              [
                51.1579241,
                32.8590792
              ],
              [
                51.1573675,
                32.8587993
              ],
              [
                51.1557006,
                32.8585194
              ],
              [
                51.1545909,
                32.8582395
              ],
              [
                51.1540341,
                32.8582395
              ],
              [
                51.1529242,
                32.8585194
              ],
              [
                51.1515342,
                32.8585194
              ],
              [
                51.1509808,
                32.8587993
              ],
              [
                51.147091,
                32.8587993
              ],
              [
                51.1465343,
                32.8585194
              ],
              [
                51.1412576,
                32.8585193
              ],
              [
                51.140701,
                32.8587993
              ],
              [
                51.1382011,
                32.8587992
              ],
              [
                51.1373677,
                32.8585194
              ],
              [
                51.1323678,
                32.8585194
              ],
              [
                51.1318112,
                32.8582395
              ],
              [
                51.1304244,
                32.8582394
              ],
              [
                51.1293111,
                32.8579596
              ],
              [
                51.1279245,
                32.8579595
              ],
              [
                51.1276445,
                32.8582395
              ],
              [
                51.1265345,
                32.8579595
              ],
              [
                51.1257013,
                32.8582395
              ],
              [
                51.1251446,
                32.8582394
              ],
              [
                51.1243112,
                32.8585194
              ],
              [
                51.1237546,
                32.8585193
              ],
              [
                51.1140346,
                32.8615803
              ],
              [
                51.1129213,
                32.8615802
              ],
              [
                51.1115348,
                32.8621311
              ],
              [
                51.1109782,
                32.8621311
              ],
              [
                51.1107014,
                32.862411
              ],
              [
                51.1098681,
                32.862411
              ],
              [
                51.1012548,
                32.8660136
              ],
              [
                51.1004214,
                32.8665735
              ],
              [
                51.0723652,
                32.8762979
              ],
              [
                51.0506955,
                32.8854625
              ],
              [
                51.0251391,
                32.9004601
              ],
              [
                51.0231959,
                32.9012997
              ],
              [
                51.0206958,
                32.9029611
              ],
              [
                51.0190292,
                32.903521
              ],
              [
                51.0087493,
                32.9096337
              ],
              [
                51.006806,
                32.911295
              ],
              [
                50.9998628,
                32.9168571
              ],
              [
                50.9915262,
                32.9260217
              ],
              [
                50.9776397,
                32.935737
              ],
              [
                50.9770829,
                32.936017
              ],
              [
                50.9765264,
                32.9362969
              ],
              [
                50.9765263,
                32.9365767
              ],
              [
                50.9737497,
                32.9382381
              ],
              [
                50.9734696,
                32.938518
              ],
              [
                50.9629165,
                32.9435202
              ],
              [
                50.9620833,
                32.9435202
              ],
              [
                50.9565267,
                32.9460213
              ],
              [
                50.9501367,
                32.9507435
              ],
              [
                50.9490267,
                32.9513033
              ],
              [
                50.9362467,
                32.9640795
              ],
              [
                50.9354135,
                32.9643594
              ],
              [
                50.9290236,
                32.9660208
              ],
              [
                50.927637,
                32.9660207
              ],
              [
                50.9184671,
                32.9682419
              ],
              [
                50.9170804,
                32.9682419
              ],
              [
                50.9159671,
                32.9685218
              ],
              [
                50.9143004,
                32.9685218
              ],
              [
                50.869021,
                32.9779663
              ],
              [
                50.867911,
                32.9779662
              ],
              [
                50.8581878,
                32.9812979
              ],
              [
                50.8559645,
                32.9815779
              ],
              [
                50.8231849,
                32.9910223
              ],
              [
                50.790962,
                32.9990762
              ],
              [
                50.7822127,
                33.0035885
              ],
              [
                50.7645724,
                33.0126829
              ],
              [
                50.7476258,
                33.0221364
              ],
              [
                50.7356828,
                33.0299104
              ],
              [
                50.7342927,
                33.0304611
              ],
              [
                50.7279027,
                33.0321315
              ],
              [
                50.7267927,
                33.0326913
              ],
              [
                50.715683,
                33.0343527
              ],
              [
                50.7104029,
                33.0354723
              ],
              [
                50.7095697,
                33.0354722
              ],
              [
                50.7070697,
                33.0357431
              ],
              [
                50.7062365,
                33.036023
              ],
              [
                50.7020699,
                33.0351923
              ],
              [
                50.6981797,
                33.0351923
              ],
              [
                50.6909565,
                33.0340818
              ],
              [
                50.6906798,
                33.0338018
              ],
              [
                50.6890135,
                33.0338019
              ],
              [
                50.6884568,
                33.033522
              ],
              [
                50.6856802,
                33.033522
              ],
              [
                50.6792902,
                33.0326913
              ],
              [
                50.6790133,
                33.0324114
              ],
              [
                50.6776234,
                33.0324113
              ],
              [
                50.6773468,
                33.0321314
              ],
              [
                50.6754035,
                33.0321315
              ],
              [
                50.6745702,
                33.0324113
              ],
              [
                50.6737335,
                33.0324113
              ],
              [
                50.6737335,
                33.0326913
              ],
              [
                50.6726237,
                33.0326912
              ],
              [
                50.6654001,
                33.0374134
              ],
              [
                50.6651236,
                33.0379642
              ],
              [
                50.6387339,
                33.0557423
              ],
              [
                50.6326206,
                33.0588032
              ],
              [
                50.6317873,
                33.0588032
              ],
              [
                50.6310964,
                33.059083
              ],
              [
                50.6309541,
                33.0588031
              ],
              [
                50.5990113,
                33.0190754
              ],
              [
                50.5984546,
                33.0182447
              ],
              [
                50.5945647,
                33.0099109
              ],
              [
                50.5942878,
                33.0076897
              ],
              [
                50.5920648,
                32.9996267
              ],
              [
                50.5759515,
                32.9860198
              ],
              [
                50.547342,
                32.9599076
              ],
              [
                50.5473421,
                32.9596277
              ],
              [
                50.5456752,
                32.9560159
              ],
              [
                50.5467854,
                32.9557452
              ],
              [
                50.5476808,
                32.9555896
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554998,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خمینی شهر",
          "name:en": "Khomeyni Shahr County",
          "name:ru": "Хомейнишехр",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279006",
          "wikipedia": "fa:شهرستان خمینی‌شهر"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.4140476,
                32.7504569
              ],
              [
                51.4148809,
                32.747125
              ],
              [
                51.4162708,
                32.7437932
              ],
              [
                51.4165475,
                32.7429625
              ],
              [
                51.4193242,
                32.7382402
              ],
              [
                51.4198808,
                32.7379603
              ],
              [
                51.4198808,
                32.7374095
              ],
              [
                51.4246042,
                32.7326781
              ],
              [
                51.4259907,
                32.7307368
              ],
              [
                51.428214,
                32.7249038
              ],
              [
                51.4287707,
                32.7232335
              ],
              [
                51.4307141,
                32.718791
              ],
              [
                51.4312707,
                32.7176804
              ],
              [
                51.4521038,
                32.6962898
              ],
              [
                51.4608293,
                32.6799466
              ],
              [
                51.4612348,
                32.6787258
              ],
              [
                51.4615341,
                32.6775935
              ],
              [
                51.4622892,
                32.6750397
              ],
              [
                51.4651891,
                32.6648563
              ],
              [
                51.4687425,
                32.6522829
              ],
              [
                51.4693862,
                32.6500716
              ],
              [
                51.4691287,
                32.6487274
              ],
              [
                51.4685622,
                32.6477084
              ],
              [
                51.468382,
                32.6467761
              ],
              [
                51.4683047,
                32.6461473
              ],
              [
                51.468073,
                32.6448898
              ],
              [
                51.4879514,
                32.6439575
              ],
              [
                51.4880286,
                32.6444995
              ],
              [
                51.4890844,
                32.644196
              ],
              [
                51.4900113,
                32.6435672
              ],
              [
                51.4896508,
                32.6426782
              ],
              [
                51.4898311,
                32.6420928
              ],
              [
                51.4901401,
                32.6414424
              ],
              [
                51.4894191,
                32.6401197
              ],
              [
                51.4888784,
                32.6390356
              ],
              [
                51.4877454,
                32.6364119
              ],
              [
                51.4866124,
                32.6316414
              ],
              [
                51.4865609,
                32.6278681
              ],
              [
                51.4874364,
                32.6276946
              ],
              [
                51.4876166,
                32.6250272
              ],
              [
                51.4900113,
                32.6252007
              ],
              [
                51.4930238,
                32.6172184
              ],
              [
                51.494131,
                32.6169287
              ],
              [
                51.4952768,
                32.6160804
              ],
              [
                51.4986156,
                32.6185095
              ],
              [
                51.500181,
                32.6194257
              ],
              [
                51.5038942,
                32.6203746
              ],
              [
                51.5079368,
                32.6203096
              ],
              [
                51.5112842,
                32.6203096
              ],
              [
                51.5134214,
                32.6197674
              ],
              [
                51.5155071,
                32.6207216
              ],
              [
                51.5165113,
                32.6204614
              ],
              [
                51.5183137,
                32.6183143
              ],
              [
                51.5190347,
                32.6169262
              ],
              [
                51.5190862,
                32.6161238
              ],
              [
                51.5191554,
                32.6135824
              ],
              [
                51.5179452,
                32.6097651
              ],
              [
                51.5150613,
                32.604299
              ],
              [
                51.5157308,
                32.6022817
              ],
              [
                51.5186564,
                32.598967
              ],
              [
                51.5250496,
                32.5938009
              ],
              [
                51.5294135,
                32.5896871
              ],
              [
                51.530701,
                32.587626
              ],
              [
                51.5334166,
                32.5849981
              ],
              [
                51.5339239,
                32.5851749
              ],
              [
                51.5344646,
                32.5856666
              ],
              [
                51.5351341,
                32.5857752
              ],
              [
                51.5359688,
                32.5858601
              ],
              [
                51.5370867,
                32.5863194
              ],
              [
                51.5378034,
                32.5863175
              ],
              [
                51.5388849,
                32.5867225
              ],
              [
                51.5392626,
                32.5872577
              ],
              [
                51.539357,
                32.5884943
              ],
              [
                51.5395973,
                32.5893332
              ],
              [
                51.5413053,
                32.5903962
              ],
              [
                51.5417481,
                32.5905434
              ],
              [
                51.5423181,
                32.5905698
              ],
              [
                51.5429501,
                32.5905441
              ],
              [
                51.5434683,
                32.5902444
              ],
              [
                51.5443433,
                32.5898516
              ],
              [
                51.5459917,
                32.5887908
              ],
              [
                51.5465582,
                32.588704
              ],
              [
                51.5470474,
                32.5888053
              ],
              [
                51.5475881,
                32.5890439
              ],
              [
                51.5481632,
                32.5895212
              ],
              [
                51.5484416,
                32.5899683
              ],
              [
                51.5486917,
                32.5902338
              ],
              [
                51.5488863,
                32.5903914
              ],
              [
                51.5490744,
                32.5904859
              ],
              [
                51.5494449,
                32.5906175
              ],
              [
                51.5498627,
                32.5906305
              ],
              [
                51.5503004,
                32.5905264
              ],
              [
                51.5506275,
                32.5904474
              ],
              [
                51.5508695,
                32.5902824
              ],
              [
                51.5512244,
                32.5900358
              ],
              [
                51.5515964,
                32.5898466
              ],
              [
                51.5517707,
                32.5898506
              ],
              [
                51.5519054,
                32.5899406
              ],
              [
                51.5519892,
                32.5901498
              ],
              [
                51.5521586,
                32.5902759
              ],
              [
                51.5523196,
                32.5904067
              ],
              [
                51.5524363,
                32.5907418
              ],
              [
                51.5525627,
                32.590981
              ],
              [
                51.5529783,
                32.5914448
              ],
              [
                51.5533632,
                32.5918434
              ],
              [
                51.5535812,
                32.5920595
              ],
              [
                51.5537765,
                32.5921752
              ],
              [
                51.5539402,
                32.5926777
              ],
              [
                51.5541775,
                32.5932041
              ],
              [
                51.5543619,
                32.5933607
              ],
              [
                51.5545576,
                32.5934696
              ],
              [
                51.5561884,
                32.5935492
              ],
              [
                51.5573128,
                32.5935998
              ],
              [
                51.5579822,
                32.5937733
              ],
              [
                51.5590637,
                32.5941277
              ],
              [
                51.559716,
                32.5945688
              ],
              [
                51.5600078,
                32.5952774
              ],
              [
                51.5603941,
                32.5955016
              ],
              [
                51.5614326,
                32.595263
              ],
              [
                51.5622394,
                32.5952847
              ],
              [
                51.5635122,
                32.5954813
              ],
              [
                51.5646635,
                32.5930018
              ],
              [
                51.5663379,
                32.5934619
              ],
              [
                51.5683463,
                32.5935487
              ],
              [
                51.568475,
                32.5940694
              ],
              [
                51.569711,
                32.5971282
              ],
              [
                51.570638,
                32.598408
              ],
              [
                51.5704551,
                32.5993582
              ],
              [
                51.5708989,
                32.6004392
              ],
              [
                51.5714487,
                32.6012041
              ],
              [
                51.5715265,
                32.6017569
              ],
              [
                51.571664,
                32.6022507
              ],
              [
                51.5724294,
                32.603382
              ],
              [
                51.5726698,
                32.6043447
              ],
              [
                51.5729095,
                32.6054982
              ],
              [
                51.5731456,
                32.6064021
              ],
              [
                51.5731959,
                32.6070014
              ],
              [
                51.5742141,
                32.6078878
              ],
              [
                51.5751239,
                32.6082313
              ],
              [
                51.5761239,
                32.6086696
              ],
              [
                51.576548,
                32.6096876
              ],
              [
                51.5758058,
                32.6098859
              ],
              [
                51.5757801,
                32.6100595
              ],
              [
                51.576192,
                32.6117513
              ],
              [
                51.5765525,
                32.6146143
              ],
              [
                51.57681,
                32.6145492
              ],
              [
                51.57681,
                32.6147878
              ],
              [
                51.5768615,
                32.6153083
              ],
              [
                51.5764753,
                32.6163494
              ],
              [
                51.5761405,
                32.6168048
              ],
              [
                51.5753681,
                32.6178025
              ],
              [
                51.5759345,
                32.6181061
              ],
              [
                51.5709772,
                32.623635
              ],
              [
                51.5703642,
                32.6232924
              ],
              [
                51.5666168,
                32.6211976
              ],
              [
                51.5667627,
                32.6222024
              ],
              [
                51.5667198,
                32.6232362
              ],
              [
                51.5663936,
                32.6236048
              ],
              [
                51.5660083,
                32.6240138
              ],
              [
                51.5656257,
                32.6243646
              ],
              [
                51.5654776,
                32.624653
              ],
              [
                51.5654604,
                32.6251606
              ],
              [
                51.5654336,
                32.6255984
              ],
              [
                51.565506,
                32.6259653
              ],
              [
                51.5655817,
                32.626255
              ],
              [
                51.5656471,
                32.6263354
              ],
              [
                51.565647,
                32.6267029
              ],
              [
                51.565632,
                32.6269075
              ],
              [
                51.5657856,
                32.6271922
              ],
              [
                51.5657097,
                32.6273509
              ],
              [
                51.5647972,
                32.6276602
              ],
              [
                51.5637501,
                32.6279349
              ],
              [
                51.562557,
                32.6282529
              ],
              [
                51.5621708,
                32.6284842
              ],
              [
                51.5619594,
                32.6286891
              ],
              [
                51.5620249,
                32.6289541
              ],
              [
                51.5621308,
                32.6294392
              ],
              [
                51.5621349,
                32.6301485
              ],
              [
                51.5616472,
                32.6311804
              ],
              [
                51.5616901,
                32.6321056
              ],
              [
                51.5618704,
                32.6325755
              ],
              [
                51.5621794,
                32.6329658
              ],
              [
                51.5627544,
                32.6336019
              ],
              [
                51.5628918,
                32.6339922
              ],
              [
                51.5628116,
                32.6342319
              ],
              [
                51.5626161,
                32.6345078
              ],
              [
                51.5621279,
                32.6349969
              ],
              [
                51.5618017,
                32.6355824
              ],
              [
                51.561836,
                32.636016
              ],
              [
                51.561913,
                32.6365724
              ],
              [
                51.5607899,
                32.6374771
              ],
              [
                51.5614594,
                32.6384528
              ],
              [
                51.5627983,
                32.6394069
              ],
              [
                51.5658367,
                32.6405777
              ],
              [
                51.564369,
                32.6454345
              ],
              [
                51.564356,
                32.6457447
              ],
              [
                51.5642918,
                32.6482097
              ],
              [
                51.565453,
                32.648512
              ],
              [
                51.5660968,
                32.6487288
              ],
              [
                51.5668614,
                32.6490225
              ],
              [
                51.5674539,
                32.6492916
              ],
              [
                51.5678706,
                32.649453
              ],
              [
                51.5685655,
                32.6497115
              ],
              [
                51.5700604,
                32.6505254
              ],
              [
                51.5699631,
                32.6508591
              ],
              [
                51.5695094,
                32.6522349
              ],
              [
                51.5684796,
                32.6522556
              ],
              [
                51.5683653,
                32.6527173
              ],
              [
                51.5685475,
                32.6542181
              ],
              [
                51.5694859,
                32.6541083
              ],
              [
                51.5698068,
                32.6541774
              ],
              [
                51.5698627,
                32.6544787
              ],
              [
                51.5702812,
                32.6545796
              ],
              [
                51.5702799,
                32.6550278
              ],
              [
                51.5703714,
                32.6551573
              ],
              [
                51.5706062,
                32.6551783
              ],
              [
                51.5707377,
                32.6551061
              ],
              [
                51.5713171,
                32.6550638
              ],
              [
                51.5716229,
                32.6583698
              ],
              [
                51.5725323,
                32.6580782
              ],
              [
                51.5735716,
                32.657987
              ],
              [
                51.575639,
                32.6615924
              ],
              [
                51.5811054,
                32.6606252
              ],
              [
                51.5812155,
                32.6618585
              ],
              [
                51.5836656,
                32.6616215
              ],
              [
                51.5837199,
                32.6623532
              ],
              [
                51.5838788,
                32.6627623
              ],
              [
                51.5846509,
                32.663975
              ],
              [
                51.585193,
                32.664598
              ],
              [
                51.5856894,
                32.6649318
              ],
              [
                51.5866175,
                32.6652471
              ],
              [
                51.58656,
                32.6655416
              ],
              [
                51.5862256,
                32.66628
              ],
              [
                51.5867782,
                32.6666629
              ],
              [
                51.587606,
                32.6671009
              ],
              [
                51.5882977,
                32.6672515
              ],
              [
                51.5901719,
                32.6743834
              ],
              [
                51.5910203,
                32.676116
              ],
              [
                51.5915287,
                32.677024
              ],
              [
                51.5920371,
                32.677932
              ],
              [
                51.5921316,
                32.679202
              ],
              [
                51.5921542,
                32.6823659
              ],
              [
                51.5919658,
                32.6839184
              ],
              [
                51.5900693,
                32.6836001
              ],
              [
                51.5897018,
                32.6855266
              ],
              [
                51.5884019,
                32.6853552
              ],
              [
                51.5873205,
                32.6850085
              ],
              [
                51.5861123,
                32.6846717
              ],
              [
                51.5857257,
                32.685603
              ],
              [
                51.5856682,
                32.6858367
              ],
              [
                51.5855458,
                32.686098
              ],
              [
                51.5853249,
                32.6863893
              ],
              [
                51.5853507,
                32.6871262
              ],
              [
                51.5863163,
                32.6875813
              ],
              [
                51.5867411,
                32.6882206
              ],
              [
                51.58696,
                32.6889249
              ],
              [
                51.5867411,
                32.691547
              ],
              [
                51.5867154,
                32.6927389
              ],
              [
                51.5872175,
                32.6940391
              ],
              [
                51.5873334,
                32.6946892
              ],
              [
                51.5872947,
                32.6951117
              ],
              [
                51.5877325,
                32.6959243
              ],
              [
                51.5877067,
                32.6966502
              ],
              [
                51.587578,
                32.6969211
              ],
              [
                51.5865995,
                32.6966936
              ],
              [
                51.5864836,
                32.6971703
              ],
              [
                51.58799,
                32.697647
              ],
              [
                51.5886594,
                32.6980587
              ],
              [
                51.5894834,
                32.698929
              ],
              [
                51.5898053,
                32.6992396
              ],
              [
                51.5894319,
                32.6997597
              ],
              [
                51.590655,
                32.7002364
              ],
              [
                51.5903953,
                32.7010426
              ],
              [
                51.5903619,
                32.7013708
              ],
              [
                51.5903035,
                32.7018672
              ],
              [
                51.5902646,
                32.7023746
              ],
              [
                51.5902438,
                32.7033033
              ],
              [
                51.5894772,
                32.7032137
              ],
              [
                51.5885432,
                32.7029063
              ],
              [
                51.584352,
                32.7129889
              ],
              [
                51.5826412,
                32.7124251
              ],
              [
                51.5815417,
                32.7147784
              ],
              [
                51.5804311,
                32.7164175
              ],
              [
                51.5801944,
                32.7163409
              ],
              [
                51.5793272,
                32.717496
              ],
              [
                51.5786102,
                32.7188529
              ],
              [
                51.5780411,
                32.7194566
              ],
              [
                51.5778682,
                32.7198148
              ],
              [
                51.5777499,
                32.7201748
              ],
              [
                51.5773502,
                32.7207391
              ],
              [
                51.5766091,
                32.7213721
              ],
              [
                51.5759286,
                32.7215426
              ],
              [
                51.5748155,
                32.7222618
              ],
              [
                51.5732742,
                32.7229205
              ],
              [
                51.5716137,
                32.723455
              ],
              [
                51.5710986,
                32.7234295
              ],
              [
                51.5704488,
                32.7235345
              ],
              [
                51.5700421,
                32.7237209
              ],
              [
                51.5695562,
                32.7233425
              ],
              [
                51.5675199,
                32.7247079
              ],
              [
                51.5647946,
                32.7227114
              ],
              [
                51.5625286,
                32.7228402
              ],
              [
                51.561166,
                32.7227886
              ],
              [
                51.560477,
                32.7227629
              ],
              [
                51.5596771,
                32.722769
              ],
              [
                51.5592879,
                32.7277948
              ],
              [
                51.5591011,
                32.7290541
              ],
              [
                51.5587239,
                32.7290909
              ],
              [
                51.5564324,
                32.7292467
              ],
              [
                51.5567497,
                32.7307231
              ],
              [
                51.5565437,
                32.731048
              ],
              [
                51.5537628,
                32.7325859
              ],
              [
                51.5493597,
                32.7352934
              ],
              [
                51.5429224,
                32.7394737
              ],
              [
                51.5287762,
                32.7418521
              ],
              [
                51.5284961,
                32.7415721
              ],
              [
                51.5268294,
                32.7415721
              ],
              [
                51.5262761,
                32.7412923
              ],
              [
                51.5246094,
                32.7412923
              ],
              [
                51.5226628,
                32.7404615
              ],
              [
                51.5212726,
                32.7404615
              ],
              [
                51.5204394,
                32.7401816
              ],
              [
                51.5187728,
                32.7401816
              ],
              [
                51.5168294,
                32.7396309
              ],
              [
                51.5154396,
                32.7396308
              ],
              [
                51.5146061,
                32.7393509
              ],
              [
                51.5123864,
                32.7393509
              ],
              [
                51.5121062,
                32.739071
              ],
              [
                51.5048864,
                32.7379604
              ],
              [
                51.5026632,
                32.7379604
              ],
              [
                51.5021063,
                32.7382403
              ],
              [
                51.4973832,
                32.7407414
              ],
              [
                51.4971064,
                32.7412922
              ],
              [
                51.47766,
                32.7574005
              ],
              [
                51.47655,
                32.7576804
              ],
              [
                51.4512703,
                32.7710168
              ],
              [
                51.4496037,
                32.7712967
              ],
              [
                51.447937,
                32.7718474
              ],
              [
                51.4454371,
                32.7718474
              ],
              [
                51.4448804,
                32.7721274
              ],
              [
                51.4440471,
                32.7721273
              ],
              [
                51.4432137,
                32.7718475
              ],
              [
                51.4370161,
                32.7716459
              ],
              [
                51.4348806,
                32.7715765
              ],
              [
                51.4337706,
                32.7710168
              ],
              [
                51.4329373,
                32.7710167
              ],
              [
                51.4312706,
                32.770466
              ],
              [
                51.4301607,
                32.7704659
              ],
              [
                51.429604,
                32.7701861
              ],
              [
                51.4287706,
                32.770186
              ],
              [
                51.4276573,
                32.7696263
              ],
              [
                51.4273807,
                32.7690754
              ],
              [
                51.4265473,
                32.7687956
              ],
              [
                51.4262707,
                32.7682357
              ],
              [
                51.4257139,
                32.7679558
              ],
              [
                51.4140476,
                32.7504569
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555003,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خوانسار",
          "name:en": "Khansar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q936080",
          "wikipedia": "fa:شهرستان خوانسار"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.0350944,
                33.3590887
              ],
              [
                50.0353714,
                33.3588088
              ],
              [
                50.035928,
                33.3585289
              ],
              [
                50.042038,
                33.3504756
              ],
              [
                50.0464846,
                33.3415826
              ],
              [
                50.0475943,
                33.3401922
              ],
              [
                50.0559277,
                33.3285274
              ],
              [
                50.0600942,
                33.3240854
              ],
              [
                50.0603743,
                33.3238055
              ],
              [
                50.0739839,
                33.3149125
              ],
              [
                50.0817642,
                33.3118608
              ],
              [
                50.082874,
                33.3118609
              ],
              [
                50.0831506,
                33.3115809
              ],
              [
                50.0839842,
                33.311581
              ],
              [
                50.0848174,
                33.3110302
              ],
              [
                50.0856506,
                33.3110302
              ],
              [
                50.0973204,
                33.3051887
              ],
              [
                50.098154,
                33.3043581
              ],
              [
                50.1114871,
                33.297966
              ],
              [
                50.1120437,
                33.2976952
              ],
              [
                50.1273203,
                33.2907522
              ],
              [
                50.1281534,
                33.2907521
              ],
              [
                50.1359333,
                33.2874206
              ],
              [
                50.1367668,
                33.2874206
              ],
              [
                50.164823,
                33.274916
              ],
              [
                50.1725997,
                33.2710338
              ],
              [
                50.1739895,
                33.2707449
              ],
              [
                50.1748227,
                33.2701942
              ],
              [
                50.1750997,
                33.2699142
              ],
              [
                50.2162122,
                33.2579695
              ],
              [
                50.2212159,
                33.2568589
              ],
              [
                50.2214925,
                33.2565791
              ],
              [
                50.2220491,
                33.2562991
              ],
              [
                50.2473254,
                33.2454738
              ],
              [
                50.2484388,
                33.2454739
              ],
              [
                50.2487152,
                33.245194
              ],
              [
                50.2501051,
                33.2438035
              ],
              [
                50.2506587,
                33.2438036
              ],
              [
                50.2506587,
                33.2435237
              ],
              [
                50.2537155,
                33.2421423
              ],
              [
                50.2545486,
                33.2421423
              ],
              [
                50.2617718,
                33.2382509
              ],
              [
                50.2698287,
                33.2307481
              ],
              [
                50.2698286,
                33.2301883
              ],
              [
                50.2856613,
                33.2115802
              ],
              [
                50.286495,
                33.2107495
              ],
              [
                50.3242744,
                33.1757451
              ],
              [
                50.324831,
                33.1754652
              ],
              [
                50.3287178,
                33.1724135
              ],
              [
                50.3289979,
                33.1721335
              ],
              [
                50.357611,
                33.1543558
              ],
              [
                50.3617775,
                33.1526945
              ],
              [
                50.3623306,
                33.1521347
              ],
              [
                50.3853869,
                33.1399098
              ],
              [
                50.3859435,
                33.1396298
              ],
              [
                50.4231666,
                33.1140781
              ],
              [
                50.4237233,
                33.1135273
              ],
              [
                50.42428,
                33.1135274
              ],
              [
                50.4665027,
                33.0860252
              ],
              [
                50.4667828,
                33.0857454
              ],
              [
                50.4717829,
                33.0826935
              ],
              [
                50.4726161,
                33.0826936
              ],
              [
                50.4742825,
                33.0818539
              ],
              [
                50.4765026,
                33.0813032
              ],
              [
                50.4778928,
                33.0813032
              ],
              [
                50.4784495,
                33.0810233
              ],
              [
                50.4812261,
                33.0810233
              ],
              [
                50.4817827,
                33.0807433
              ],
              [
                50.4859492,
                33.0807433
              ],
              [
                50.4865059,
                33.0810232
              ],
              [
                50.493449,
                33.0810233
              ],
              [
                50.4940056,
                33.0813032
              ],
              [
                50.4956724,
                33.0813032
              ],
              [
                50.4962255,
                33.0815831
              ],
              [
                50.5098387,
                33.0849148
              ],
              [
                50.5103958,
                33.0851856
              ],
              [
                50.5181721,
                33.0910274
              ],
              [
                50.5273386,
                33.1087963
              ],
              [
                50.5276187,
                33.1110265
              ],
              [
                50.530952,
                33.1207506
              ],
              [
                50.5315051,
                33.1221321
              ],
              [
                50.5362286,
                33.1313054
              ],
              [
                50.5384517,
                33.1343572
              ],
              [
                50.5428951,
                33.1379687
              ],
              [
                50.5440085,
                33.1379687
              ],
              [
                50.5442851,
                33.1376979
              ],
              [
                50.5456749,
                33.1376979
              ],
              [
                50.5845644,
                33.1188004
              ],
              [
                50.5848413,
                33.1185205
              ],
              [
                50.5990111,
                33.1115773
              ],
              [
                50.6003975,
                33.1115773
              ],
              [
                50.6009541,
                33.1118573
              ],
              [
                50.6015112,
                33.112408
              ],
              [
                50.602621,
                33.1171391
              ],
              [
                50.6201205,
                33.1485236
              ],
              [
                50.6217874,
                33.1515843
              ],
              [
                50.6531769,
                33.201306
              ],
              [
                50.6548434,
                33.2032471
              ],
              [
                50.6745699,
                33.2235257
              ],
              [
                50.6848462,
                33.229918
              ],
              [
                50.6942929,
                33.2363103
              ],
              [
                50.6956797,
                33.2368611
              ],
              [
                50.6962363,
                33.237141
              ],
              [
                50.6609567,
                33.2482552
              ],
              [
                50.6587332,
                33.248806
              ],
              [
                50.6559566,
                33.2496366
              ],
              [
                50.6548433,
                33.2496366
              ],
              [
                50.6520667,
                33.2504673
              ],
              [
                50.6415102,
                33.2518576
              ],
              [
                50.63651,
                33.2518576
              ],
              [
                50.6356769,
                33.2521375
              ],
              [
                50.6267872,
                33.2521374
              ],
              [
                50.6254005,
                33.2524174
              ],
              [
                50.6229005,
                33.2524173
              ],
              [
                50.617064,
                33.253248
              ],
              [
                50.6151206,
                33.2538078
              ],
              [
                50.6137307,
                33.2538078
              ],
              [
                50.5820644,
                33.2654727
              ],
              [
                50.5806742,
                33.2657526
              ],
              [
                50.5756744,
                33.2682535
              ],
              [
                50.5570612,
                33.2815797
              ],
              [
                50.5556744,
                33.2829701
              ],
              [
                50.5545611,
                33.2835299
              ],
              [
                50.5531748,
                33.2849203
              ],
              [
                50.5401182,
                33.2935245
              ],
              [
                50.5390049,
                33.2946351
              ],
              [
                50.5298383,
                33.2999167
              ],
              [
                50.5273383,
                33.3015779
              ],
              [
                50.5156716,
                33.3157527
              ],
              [
                50.5109485,
                33.3193641
              ],
              [
                50.5084484,
                33.3204746
              ],
              [
                50.5023386,
                33.3232464
              ],
              [
                50.5001151,
                33.3238061
              ],
              [
                50.4870589,
                33.3257472
              ],
              [
                50.4862253,
                33.3260271
              ],
              [
                50.4837253,
                33.3260271
              ],
              [
                50.4831686,
                33.326307
              ],
              [
                50.4809487,
                33.326307
              ],
              [
                50.4803919,
                33.3265869
              ],
              [
                50.4759489,
                33.3265868
              ],
              [
                50.4734489,
                33.3268577
              ],
              [
                50.4726157,
                33.3271376
              ],
              [
                50.4701156,
                33.3271376
              ],
              [
                50.4545591,
                33.3293586
              ],
              [
                50.4540025,
                33.3296384
              ],
              [
                50.4515024,
                33.3296385
              ],
              [
                50.4512257,
                33.3299183
              ],
              [
                50.4495594,
                33.3299184
              ],
              [
                50.4487262,
                33.3301982
              ],
              [
                50.4470558,
                33.3301982
              ],
              [
                50.4453894,
                33.330749
              ],
              [
                50.4428892,
                33.3307489
              ],
              [
                50.4401127,
                33.3307489
              ],
              [
                50.4353896,
                33.330749
              ],
              [
                50.4312226,
                33.3299183
              ],
              [
                50.4303894,
                33.3299183
              ],
              [
                50.4298363,
                33.3296384
              ],
              [
                50.4290027,
                33.3296384
              ],
              [
                50.4287231,
                33.3293585
              ],
              [
                50.4278894,
                33.3293586
              ],
              [
                50.4217795,
                33.3268577
              ],
              [
                50.417613,
                33.3251964
              ],
              [
                50.402333,
                33.3160324
              ],
              [
                50.3978899,
                33.3152018
              ],
              [
                50.3970568,
                33.3149129
              ],
              [
                50.3942766,
                33.3149129
              ],
              [
                50.3923333,
                33.314642
              ],
              [
                50.3920567,
                33.3143622
              ],
              [
                50.3912235,
                33.3143621
              ],
              [
                50.3901101,
                33.3138023
              ],
              [
                50.3892766,
                33.3138024
              ],
              [
                50.3884434,
                33.3138023
              ],
              [
                50.3873335,
                33.3135315
              ],
              [
                50.3870534,
                33.3135315
              ],
              [
                50.3859433,
                33.3135316
              ],
              [
                50.3856667,
                33.3132516
              ],
              [
                50.3795533,
                33.3132516
              ],
              [
                50.3790001,
                33.3135316
              ],
              [
                50.3723337,
                33.3135315
              ],
              [
                50.3703871,
                33.3138024
              ],
              [
                50.3689968,
                33.3143621
              ],
              [
                50.3678871,
                33.3143622
              ],
              [
                50.3676104,
                33.314642
              ],
              [
                50.3667769,
                33.314642
              ],
              [
                50.3598302,
                33.3201945
              ],
              [
                50.3534437,
                33.3313086
              ],
              [
                50.3526071,
                33.3332497
              ],
              [
                50.352607,
                33.3335296
              ],
              [
                50.3503871,
                33.3371409
              ],
              [
                50.3498304,
                33.3385314
              ],
              [
                50.3392739,
                33.3496364
              ],
              [
                50.3389974,
                33.3501962
              ],
              [
                50.3378872,
                33.3507558
              ],
              [
                50.337054,
                33.3515864
              ],
              [
                50.3189977,
                33.3604704
              ],
              [
                50.3176074,
                33.3610301
              ],
              [
                50.3159409,
                33.3618608
              ],
              [
                50.3067744,
                33.3640817
              ],
              [
                50.3037178,
                33.3649213
              ],
              [
                50.2995512,
                33.3649214
              ],
              [
                50.2989946,
                33.3651922
              ],
              [
                50.2956613,
                33.3649213
              ],
              [
                50.2953843,
                33.3646415
              ],
              [
                50.2939944,
                33.3646415
              ],
              [
                50.2934378,
                33.3643615
              ],
              [
                50.2920511,
                33.3643616
              ],
              [
                50.289828,
                33.363531
              ],
              [
                50.2887178,
                33.363531
              ],
              [
                50.2881612,
                33.3632512
              ],
              [
                50.2867713,
                33.3632511
              ],
              [
                50.2864947,
                33.3629712
              ],
              [
                50.2823278,
                33.3629712
              ],
              [
                50.2814946,
                33.3626913
              ],
              [
                50.2781613,
                33.3626913
              ],
              [
                50.2776046,
                33.3629712
              ],
              [
                50.2756613,
                33.3629712
              ],
              [
                50.2751046,
                33.3632511
              ],
              [
                50.2717713,
                33.363251
              ],
              [
                50.2712147,
                33.3629712
              ],
              [
                50.2703815,
                33.3629712
              ],
              [
                50.2689948,
                33.3621405
              ],
              [
                50.2678815,
                33.3618607
              ],
              [
                50.265938,
                33.3665826
              ],
              [
                50.2656615,
                33.3674132
              ],
              [
                50.2653814,
                33.3688126
              ],
              [
                50.2651048,
                33.369914
              ],
              [
                50.2648283,
                33.3715843
              ],
              [
                50.2653814,
                33.3793667
              ],
              [
                50.2698283,
                33.3860296
              ],
              [
                50.2712147,
                33.3876999
              ],
              [
                50.2823277,
                33.3979741
              ],
              [
                50.2839945,
                33.4013056
              ],
              [
                50.2848278,
                33.4065871
              ],
              [
                50.2845513,
                33.4068671
              ],
              [
                50.2842711,
                33.4079775
              ],
              [
                50.2823277,
                33.4104693
              ],
              [
                50.281218,
                33.411029
              ],
              [
                50.2798281,
                33.4110291
              ],
              [
                50.2792714,
                33.4113089
              ],
              [
                50.2778846,
                33.411309
              ],
              [
                50.2776046,
                33.4115888
              ],
              [
                50.2726045,
                33.4115888
              ],
              [
                50.2720478,
                33.4115888
              ],
              [
                50.2712146,
                33.4115888
              ],
              [
                50.2589949,
                33.4015854
              ],
              [
                50.2548248,
                33.3990846
              ],
              [
                50.2514915,
                33.3990846
              ],
              [
                50.2506584,
                33.3993645
              ],
              [
                50.2431582,
                33.4074176
              ],
              [
                50.2414917,
                33.408808
              ],
              [
                50.2342686,
                33.4140896
              ],
              [
                50.2298251,
                33.4160306
              ],
              [
                50.225382,
                33.4168612
              ],
              [
                50.2237153,
                33.4168613
              ],
              [
                50.2228821,
                33.4171411
              ],
              [
                50.2214922,
                33.4171411
              ],
              [
                50.2206585,
                33.417421
              ],
              [
                50.218712,
                33.417421
              ],
              [
                50.2181588,
                33.4177008
              ],
              [
                50.2148256,
                33.4177009
              ],
              [
                50.2117689,
                33.4154799
              ],
              [
                50.2112122,
                33.4113088
              ],
              [
                50.2114924,
                33.4104692
              ],
              [
                50.2117689,
                33.4101983
              ],
              [
                50.2162119,
                33.4040861
              ],
              [
                50.2181589,
                33.4021361
              ],
              [
                50.2359351,
                33.3857497
              ],
              [
                50.2389918,
                33.3801973
              ],
              [
                50.2392684,
                33.3799174
              ],
              [
                50.2348252,
                33.3754754
              ],
              [
                50.2348252,
                33.3751956
              ],
              [
                50.2253822,
                33.3743649
              ],
              [
                50.2248255,
                33.3746358
              ],
              [
                50.2220489,
                33.3749157
              ],
              [
                50.1901025,
                33.3810278
              ],
              [
                50.1895459,
                33.3813077
              ],
              [
                50.1873224,
                33.3813077
              ],
              [
                50.1473231,
                33.3865802
              ],
              [
                50.142043,
                33.38686
              ],
              [
                50.1359331,
                33.3868601
              ],
              [
                50.1348197,
                33.38714
              ],
              [
                50.1328764,
                33.3871399
              ],
              [
                50.1317666,
                33.3874198
              ],
              [
                50.1284333,
                33.3874198
              ],
              [
                50.1231535,
                33.3879705
              ],
              [
                50.1225964,
                33.3882504
              ],
              [
                50.1156533,
                33.3882504
              ],
              [
                50.1150967,
                33.3885303
              ],
              [
                50.1025968,
                33.3876996
              ],
              [
                50.083707,
                33.3854787
              ],
              [
                50.0831504,
                33.3851988
              ],
              [
                50.0806507,
                33.3851988
              ],
              [
                50.0798171,
                33.3849188
              ],
              [
                50.0787073,
                33.3849189
              ],
              [
                50.076764,
                33.3843591
              ],
              [
                50.0756507,
                33.3843591
              ],
              [
                50.0748174,
                33.3840882
              ],
              [
                50.0723174,
                33.3835285
              ],
              [
                50.0559276,
                33.3796373
              ],
              [
                50.0448176,
                33.3732542
              ],
              [
                50.0353714,
                33.3593595
              ],
              [
                50.0350944,
                33.3590887
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555004,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خور و بیابانک",
          "name:en": "Khur and Biabanak County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2410156",
          "wikipedia": "en:Khur and Biabanak County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.2499703,
                34.2342332
              ],
              [
                54.2447995,
                34.2218565
              ],
              [
                54.2340547,
                34.1940971
              ],
              [
                54.2263798,
                34.1740167
              ],
              [
                54.2215375,
                34.1613122
              ],
              [
                54.2126866,
                34.1391744
              ],
              [
                54.2048575,
                34.1192364
              ],
              [
                54.1906545,
                34.081978
              ],
              [
                54.1756527,
                34.044462
              ],
              [
                54.1784442,
                34.0244311
              ],
              [
                54.183314,
                33.9978452
              ],
              [
                54.1827609,
                33.991173
              ],
              [
                54.1802786,
                33.9805206
              ],
              [
                54.179961,
                33.9658173
              ],
              [
                54.1884408,
                33.9476349
              ],
              [
                54.1910958,
                33.9428511
              ],
              [
                54.1962873,
                33.9335989
              ],
              [
                54.2106389,
                33.9129156
              ],
              [
                54.2235653,
                33.8939224
              ],
              [
                54.251165,
                33.8534386
              ],
              [
                54.2700049,
                33.8337677
              ],
              [
                54.3050755,
                33.7994898
              ],
              [
                54.3168136,
                33.7883496
              ],
              [
                54.326325,
                33.7790512
              ],
              [
                54.3372217,
                33.7684673
              ],
              [
                54.3593214,
                33.7484652
              ],
              [
                54.4030951,
                33.7207704
              ],
              [
                54.4240378,
                33.7083476
              ],
              [
                54.4639199,
                33.691017
              ],
              [
                54.4780711,
                33.6794543
              ],
              [
                54.4921857,
                33.6688881
              ],
              [
                54.508139,
                33.6566604
              ],
              [
                54.5204021,
                33.6469237
              ],
              [
                54.529842,
                33.6388234
              ],
              [
                54.5348657,
                33.6341388
              ],
              [
                54.5377173,
                33.6318488
              ],
              [
                54.5405855,
                33.6290436
              ],
              [
                54.545777,
                33.6209288
              ],
              [
                54.5516936,
                33.6142426
              ],
              [
                54.5540429,
                33.6018839
              ],
              [
                54.5562911,
                33.5938283
              ],
              [
                54.5577612,
                33.5847531
              ],
              [
                54.5585754,
                33.5749014
              ],
              [
                54.561496,
                33.5672693
              ],
              [
                54.5633651,
                33.5599365
              ],
              [
                54.5690917,
                33.5391055
              ],
              [
                54.5705358,
                33.537282
              ],
              [
                54.5747268,
                33.523987
              ],
              [
                54.5772886,
                33.5151718
              ],
              [
                54.5793475,
                33.5107911
              ],
              [
                54.5855283,
                33.5038287
              ],
              [
                54.5886793,
                33.4987241
              ],
              [
                54.5919226,
                33.4845744
              ],
              [
                54.5963858,
                33.4744086
              ],
              [
                54.6117702,
                33.4572539
              ],
              [
                54.6308586,
                33.4384124
              ],
              [
                54.6464931,
                33.4218722
              ],
              [
                54.6561249,
                33.4123933
              ],
              [
                54.6804879,
                33.3873356
              ],
              [
                54.6809291,
                33.3831138
              ],
              [
                54.6825471,
                33.3805506
              ],
              [
                54.6846039,
                33.3742252
              ],
              [
                54.6896813,
                33.3576791
              ],
              [
                54.6938037,
                33.3437225
              ],
              [
                54.6967611,
                33.3345031
              ],
              [
                54.6963952,
                33.3323888
              ],
              [
                54.6989535,
                33.3252931
              ],
              [
                54.7072624,
                33.3028733
              ],
              [
                54.7078799,
                33.297319
              ],
              [
                54.710009,
                33.2918665
              ],
              [
                54.7170081,
                33.2659466
              ],
              [
                54.7192954,
                33.2523981
              ],
              [
                54.7223802,
                33.2469037
              ],
              [
                54.7260146,
                33.2422764
              ],
              [
                54.7287687,
                33.2315687
              ],
              [
                54.7351086,
                33.2104285
              ],
              [
                54.7418976,
                33.1907128
              ],
              [
                54.7502803,
                33.1670854
              ],
              [
                54.7557233,
                33.1502095
              ],
              [
                54.7628376,
                33.1247809
              ],
              [
                54.7741602,
                33.0823169
              ],
              [
                54.7781529,
                33.0878231
              ],
              [
                54.782113,
                33.0935632
              ],
              [
                54.7908196,
                33.0959225
              ],
              [
                54.7960527,
                33.0964823
              ],
              [
                54.8000977,
                33.0953963
              ],
              [
                54.8063461,
                33.1022218
              ],
              [
                54.8086194,
                33.1139807
              ],
              [
                54.8174856,
                33.1261949
              ],
              [
                54.8277853,
                33.1348202
              ],
              [
                54.8411749,
                33.1352514
              ],
              [
                54.8550795,
                33.1376951
              ],
              [
                54.8778152,
                33.1715851
              ],
              [
                54.8786485,
                33.171856
              ],
              [
                54.8839285,
                33.174357
              ],
              [
                54.8861518,
                33.1751876
              ],
              [
                54.8883717,
                33.1765871
              ],
              [
                54.8972616,
                33.1801987
              ],
              [
                54.898095,
                33.1799188
              ],
              [
                54.8994849,
                33.1799188
              ],
              [
                54.8997616,
                33.1796389
              ],
              [
                54.9011515,
                33.1796389
              ],
              [
                54.9128181,
                33.1751877
              ],
              [
                54.9547642,
                33.1482546
              ],
              [
                54.9617108,
                33.1435235
              ],
              [
                54.9906005,
                33.1260256
              ],
              [
                54.9917104,
                33.1257457
              ],
              [
                55.01949,
                33.1504757
              ],
              [
                55.0272666,
                33.15964
              ],
              [
                55.0333799,
                33.1671339
              ],
              [
                55.0772693,
                33.2118624
              ],
              [
                55.1044923,
                33.2363121
              ],
              [
                55.1078256,
                33.238804
              ],
              [
                55.1097723,
                33.2407542
              ],
              [
                55.1372718,
                33.2610327
              ],
              [
                55.1544949,
                33.2757492
              ],
              [
                55.175608,
                33.2918652
              ],
              [
                55.1758847,
                33.2921451
              ],
              [
                55.176718,
                33.2924159
              ],
              [
                55.1833846,
                33.2985283
              ],
              [
                55.2225541,
                33.324088
              ],
              [
                55.2247774,
                33.3251985
              ],
              [
                55.2281107,
                33.3268597
              ],
              [
                55.2328341,
                33.3293606
              ],
              [
                55.2542238,
                33.3382537
              ],
              [
                55.2592238,
                33.3399239
              ],
              [
                55.260057,
                33.3404747
              ],
              [
                55.2686668,
                33.3429755
              ],
              [
                55.2697803,
                33.3435353
              ],
              [
                55.3233929,
                33.3540895
              ],
              [
                55.3247828,
                33.3546402
              ],
              [
                55.3622824,
                33.359642
              ],
              [
                55.364229,
                33.3601927
              ],
              [
                55.3670056,
                33.3604725
              ],
              [
                55.3758955,
                33.3632533
              ],
              [
                55.3772855,
                33.3632533
              ],
              [
                55.3783955,
                33.3635331
              ],
              [
                55.3803388,
                33.3635331
              ],
              [
                55.3873936,
                33.3577196
              ],
              [
                55.3955167,
                33.3680423
              ],
              [
                55.4005725,
                33.3740407
              ],
              [
                55.4049914,
                33.3824666
              ],
              [
                55.4110605,
                33.3920444
              ],
              [
                55.4184209,
                33.4035702
              ],
              [
                55.4256223,
                33.4149185
              ],
              [
                55.4324623,
                33.4254962
              ],
              [
                55.4821583,
                33.506477
              ],
              [
                55.4923724,
                33.5194296
              ],
              [
                55.4983399,
                33.5246551
              ],
              [
                55.5041847,
                33.5300843
              ],
              [
                55.5097279,
                33.5336609
              ],
              [
                55.518076,
                33.5377327
              ],
              [
                55.5287619,
                33.5423135
              ],
              [
                55.5326063,
                33.5440686
              ],
              [
                55.5354829,
                33.5526702
              ],
              [
                55.540566,
                33.5698173
              ],
              [
                55.5447942,
                33.5811191
              ],
              [
                55.5479891,
                33.5902184
              ],
              [
                55.5534157,
                33.6053637
              ],
              [
                55.557179,
                33.616369
              ],
              [
                55.559903,
                33.6318541
              ],
              [
                55.5608722,
                33.6496318
              ],
              [
                55.5612156,
                33.663732
              ],
              [
                55.5443,
                33.7797181
              ],
              [
                55.5408667,
                33.7904187
              ],
              [
                55.5379485,
                33.8006185
              ],
              [
                55.5323695,
                33.8260771
              ],
              [
                55.5275519,
                33.852175
              ],
              [
                55.5111605,
                33.9408474
              ],
              [
                55.5080896,
                33.9558693
              ],
              [
                55.503854,
                33.9809113
              ],
              [
                55.5004637,
                33.999842
              ],
              [
                55.5002932,
                34.0102337
              ],
              [
                55.5002682,
                34.0249969
              ],
              [
                55.5002874,
                34.0373987
              ],
              [
                55.5003959,
                34.0487802
              ],
              [
                55.500415,
                34.058876
              ],
              [
                55.5003352,
                34.0770147
              ],
              [
                55.5006366,
                34.0926371
              ],
              [
                55.500385,
                34.1062723
              ],
              [
                55.5007783,
                34.1387155
              ],
              [
                55.5006008,
                34.1548445
              ],
              [
                55.5004484,
                34.1746438
              ],
              [
                55.5005841,
                34.2238194
              ],
              [
                55.5005651,
                34.2445108
              ],
              [
                55.5007367,
                34.2674919
              ],
              [
                55.4016493,
                34.2393376
              ],
              [
                55.1997496,
                34.2390266
              ],
              [
                55.1818967,
                34.2384549
              ],
              [
                55.1604007,
                34.2380332
              ],
              [
                55.1337097,
                34.2403038
              ],
              [
                55.1082144,
                34.2399589
              ],
              [
                55.0405855,
                34.2397823
              ],
              [
                54.6105335,
                34.2385698
              ],
              [
                54.5677183,
                34.2389119
              ],
              [
                54.5254896,
                34.2379185
              ],
              [
                54.5054053,
                34.2390538
              ],
              [
                54.4967596,
                34.2382882
              ],
              [
                54.4302967,
                34.237015
              ],
              [
                54.3447677,
                34.237036
              ],
              [
                54.2499703,
                34.2342332
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555024,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دهاقان",
          "name:en": "Dehaqan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1119818",
          "wikipedia": "fa:شهرستان دهاقان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.3923825,
                31.8490528
              ],
              [
                51.3921024,
                31.8487729
              ],
              [
                51.4054354,
                31.8287739
              ],
              [
                51.4076588,
                31.8282233
              ],
              [
                51.4115489,
                31.8282233
              ],
              [
                51.412382,
                31.8279343
              ],
              [
                51.4215487,
                31.8279343
              ],
              [
                51.4276585,
                31.8279343
              ],
              [
                51.4293252,
                31.8276635
              ],
              [
                51.4321052,
                31.8276634
              ],
              [
                51.4368285,
                31.8271037
              ],
              [
                51.4412717,
                31.8268328
              ],
              [
                51.4465482,
                31.8268329
              ],
              [
                51.4482183,
                31.8265439
              ],
              [
                51.4584949,
                31.8265439
              ],
              [
                51.4607182,
                31.8268328
              ],
              [
                51.4729413,
                31.8268329
              ],
              [
                51.4737747,
                31.8265439
              ],
              [
                51.4873843,
                31.8251625
              ],
              [
                51.497941,
                31.8237721
              ],
              [
                51.5040509,
                31.8237721
              ],
              [
                51.5062742,
                31.8234922
              ],
              [
                51.5184974,
                31.8234922
              ],
              [
                51.5201641,
                31.8232123
              ],
              [
                51.5237739,
                31.8229415
              ],
              [
                51.5390536,
                31.8232123
              ],
              [
                51.5496103,
                31.8190501
              ],
              [
                51.5557202,
                31.8126577
              ],
              [
                51.5587767,
                31.8096059
              ],
              [
                51.5598867,
                31.8082154
              ],
              [
                51.5857232,
                31.7782129
              ],
              [
                51.6029462,
                31.7640558
              ],
              [
                51.603503,
                31.763767
              ],
              [
                51.6065562,
                31.761266
              ],
              [
                51.6068362,
                31.7609951
              ],
              [
                51.6160027,
                31.7537722
              ],
              [
                51.6179461,
                31.7551626
              ],
              [
                51.6260027,
                31.7579434
              ],
              [
                51.6407258,
                31.7604354
              ],
              [
                51.6421157,
                31.7604354
              ],
              [
                51.642669,
                31.7607153
              ],
              [
                51.6440591,
                31.7607153
              ],
              [
                51.6493355,
                31.7618258
              ],
              [
                51.650169,
                31.7618258
              ],
              [
                51.6515588,
                31.7623856
              ],
              [
                51.6629487,
                31.7640559
              ],
              [
                51.6637821,
                31.7640559
              ],
              [
                51.6701721,
                31.7651574
              ],
              [
                51.7035049,
                31.7698794
              ],
              [
                51.7054515,
                31.7701594
              ],
              [
                51.7076714,
                31.7701593
              ],
              [
                51.7085049,
                31.7704393
              ],
              [
                51.7123948,
                31.7704393
              ],
              [
                51.713228,
                31.7707191
              ],
              [
                51.7148946,
                31.7707192
              ],
              [
                51.7257278,
                31.7726604
              ],
              [
                51.7271179,
                31.7732201
              ],
              [
                51.7371177,
                31.7748814
              ],
              [
                51.7385078,
                31.7751613
              ],
              [
                51.7418409,
                31.7751614
              ],
              [
                51.742951,
                31.7754412
              ],
              [
                51.7446176,
                31.7754412
              ],
              [
                51.7529541,
                31.7776623
              ],
              [
                51.7532309,
                31.7779421
              ],
              [
                51.7543408,
                31.7779422
              ],
              [
                51.7682306,
                31.7829441
              ],
              [
                51.7696207,
                31.7832149
              ],
              [
                51.7721204,
                31.7834948
              ],
              [
                51.7805082,
                31.7861019
              ],
              [
                51.7822652,
                31.8004887
              ],
              [
                51.7836916,
                31.8136306
              ],
              [
                51.7856882,
                31.8297528
              ],
              [
                51.7869999,
                31.8418554
              ],
              [
                51.7880228,
                31.8505543
              ],
              [
                51.7907944,
                31.8736284
              ],
              [
                51.7943435,
                31.9110007
              ],
              [
                51.7946202,
                31.9121022
              ],
              [
                51.7943434,
                31.9143324
              ],
              [
                51.7937867,
                31.9232168
              ],
              [
                51.7931001,
                31.9286129
              ],
              [
                51.7869871,
                31.9374448
              ],
              [
                51.7675283,
                31.9614498
              ],
              [
                51.764218,
                31.967606
              ],
              [
                51.7605141,
                31.9808513
              ],
              [
                51.760644,
                31.992977
              ],
              [
                51.7578622,
                31.9985426
              ],
              [
                51.7718568,
                32.0050322
              ],
              [
                51.7834384,
                32.0173979
              ],
              [
                51.7865634,
                32.0237827
              ],
              [
                51.7885207,
                32.0270702
              ],
              [
                51.7890357,
                32.0322365
              ],
              [
                51.7887782,
                32.0376936
              ],
              [
                51.7891018,
                32.0458637
              ],
              [
                51.7861944,
                32.0590118
              ],
              [
                51.7846605,
                32.0642711
              ],
              [
                51.7847892,
                32.0684525
              ],
              [
                51.7845971,
                32.072938
              ],
              [
                51.7843076,
                32.0800878
              ],
              [
                51.7840801,
                32.0866372
              ],
              [
                51.783608,
                32.0928361
              ],
              [
                51.7831821,
                32.103636
              ],
              [
                51.7826909,
                32.1112008
              ],
              [
                51.7824512,
                32.1154852
              ],
              [
                51.7812879,
                32.1226706
              ],
              [
                51.7804535,
                32.1308063
              ],
              [
                51.7761483,
                32.1386947
              ],
              [
                51.7710413,
                32.1442329
              ],
              [
                51.7688655,
                32.1468754
              ],
              [
                51.7671215,
                32.1495412
              ],
              [
                51.7649834,
                32.1533395
              ],
              [
                51.7629542,
                32.1579215
              ],
              [
                51.7579275,
                32.1659399
              ],
              [
                51.7497516,
                32.171814
              ],
              [
                51.742581,
                32.1818315
              ],
              [
                51.7334662,
                32.1923246
              ],
              [
                51.7166965,
                32.2171169
              ],
              [
                51.6999435,
                32.2418441
              ],
              [
                51.6955661,
                32.2494664
              ],
              [
                51.6867255,
                32.2548379
              ],
              [
                51.6807174,
                32.2612978
              ],
              [
                51.6755675,
                32.2662331
              ],
              [
                51.6718258,
                32.2694293
              ],
              [
                51.6674136,
                32.2753047
              ],
              [
                51.6639846,
                32.2777868
              ],
              [
                51.6606502,
                32.2614804
              ],
              [
                51.6543588,
                32.2563053
              ],
              [
                51.6491403,
                32.2500555
              ],
              [
                51.6447372,
                32.2443426
              ],
              [
                51.6377591,
                32.2412718
              ],
              [
                51.6352872,
                32.2399215
              ],
              [
                51.6298284,
                32.2331914
              ],
              [
                51.6261977,
                32.2306866
              ],
              [
                51.6211766,
                32.2289223
              ],
              [
                51.6161555,
                32.2261124
              ],
              [
                51.6122674,
                32.2226925
              ],
              [
                51.609641,
                32.2177257
              ],
              [
                51.6069116,
                32.2121705
              ],
              [
                51.6026372,
                32.2095997
              ],
              [
                51.5977706,
                32.2060049
              ],
              [
                51.5920028,
                32.2008193
              ],
              [
                51.5871104,
                32.1944568
              ],
              [
                51.5839433,
                32.1931712
              ],
              [
                51.5780553,
                32.1899476
              ],
              [
                51.5722618,
                32.1829959
              ],
              [
                51.5712833,
                32.1802718
              ],
              [
                51.5682449,
                32.174954
              ],
              [
                51.5615501,
                32.1671947
              ],
              [
                51.5567092,
                32.1613312
              ],
              [
                51.5496025,
                32.1567971
              ],
              [
                51.5478773,
                32.1548788
              ],
              [
                51.5443496,
                32.1502789
              ],
              [
                51.540925,
                32.1482514
              ],
              [
                51.5372428,
                32.1456135
              ],
              [
                51.533329,
                32.1418417
              ],
              [
                51.531063,
                32.1406861
              ],
              [
                51.5254436,
                32.1393384
              ],
              [
                51.517387,
                32.1362865
              ],
              [
                51.5018304,
                32.1287831
              ],
              [
                51.4643276,
                32.109334
              ],
              [
                51.463771,
                32.1090541
              ],
              [
                51.4489692,
                32.0991304
              ],
              [
                51.4450553,
                32.0959406
              ],
              [
                51.4402402,
                32.0926466
              ],
              [
                51.4386303,
                32.0921748
              ],
              [
                51.4382147,
                32.0918354
              ],
              [
                51.429413,
                32.08529
              ],
              [
                51.4253805,
                32.0805043
              ],
              [
                51.4228615,
                32.0769537
              ],
              [
                51.4212393,
                32.071259
              ],
              [
                51.4151367,
                32.0629672
              ],
              [
                51.4110684,
                32.0556567
              ],
              [
                51.4073862,
                32.0519903
              ],
              [
                51.4029059,
                32.0483456
              ],
              [
                51.3967489,
                32.0456769
              ],
              [
                51.4029354,
                32.0435021
              ],
              [
                51.4040487,
                32.0426623
              ],
              [
                51.4143253,
                32.0323871
              ],
              [
                51.4248817,
                32.0071056
              ],
              [
                51.429325,
                31.9998914
              ],
              [
                51.4293249,
                31.9937786
              ],
              [
                51.4296051,
                31.9923881
              ],
              [
                51.4298817,
                31.9907268
              ],
              [
                51.4301617,
                31.9862755
              ],
              [
                51.4304383,
                31.9837744
              ],
              [
                51.430715,
                31.9826638
              ],
              [
                51.4312718,
                31.9818331
              ],
              [
                51.4327449,
                31.9771462
              ],
              [
                51.433888,
                31.9735093
              ],
              [
                51.4343282,
                31.9721088
              ],
              [
                51.4342279,
                31.971413
              ],
              [
                51.4340484,
                31.9701675
              ],
              [
                51.4335106,
                31.9698835
              ],
              [
                51.433323,
                31.9697844
              ],
              [
                51.4249413,
                31.9653573
              ],
              [
                51.4240483,
                31.9648856
              ],
              [
                51.4226238,
                31.964328
              ],
              [
                51.4176586,
                31.9623844
              ],
              [
                51.4161853,
                31.9603245
              ],
              [
                51.4150071,
                31.958677
              ],
              [
                51.414882,
                31.958502
              ],
              [
                51.4146052,
                31.9573914
              ],
              [
                51.4132154,
                31.9523803
              ],
              [
                51.4134919,
                31.9512787
              ],
              [
                51.4143253,
                31.9493284
              ],
              [
                51.4151585,
                31.9484978
              ],
              [
                51.4179385,
                31.9451661
              ],
              [
                51.4223817,
                31.9404439
              ],
              [
                51.4254384,
                31.9354418
              ],
              [
                51.4276585,
                31.9296091
              ],
              [
                51.4282151,
                31.9268282
              ],
              [
                51.4262719,
                31.9126617
              ],
              [
                51.417382,
                31.8940529
              ],
              [
                51.4143253,
                31.8804463
              ],
              [
                51.4140486,
                31.8668307
              ],
              [
                51.4132155,
                31.8640498
              ],
              [
                51.4121055,
                31.8618287
              ],
              [
                51.4109919,
                31.8604382
              ],
              [
                51.4096022,
                31.858497
              ],
              [
                51.4029355,
                31.8518337
              ],
              [
                51.4021022,
                31.8518337
              ],
              [
                51.3998822,
                31.8507141
              ],
              [
                51.3940491,
                31.8493327
              ],
              [
                51.3934924,
                31.8493327
              ],
              [
                51.3926591,
                31.8493326
              ],
              [
                51.3923825,
                31.8490528
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555085,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سمیرم",
          "name:en": "Semirom County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286493",
          "wikipedia": "fa:شهرستان سمیرم"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.2753,
                31.4922256
              ],
              [
                51.273004,
                31.4911377
              ],
              [
                51.2723744,
                31.4901515
              ],
              [
                51.2704061,
                31.4855638
              ],
              [
                51.2701546,
                31.4807082
              ],
              [
                51.259598,
                31.4607111
              ],
              [
                51.259598,
                31.4593207
              ],
              [
                51.283211,
                31.4495976
              ],
              [
                51.286821,
                31.4468171
              ],
              [
                51.2884877,
                31.4451559
              ],
              [
                51.2890444,
                31.4440364
              ],
              [
                51.3030725,
                31.4220986
              ],
              [
                51.3032108,
                31.4218188
              ],
              [
                51.3034874,
                31.4215389
              ],
              [
                51.3037675,
                31.4209882
              ],
              [
                51.3040443,
                31.4201486
              ],
              [
                51.3043209,
                31.4195979
              ],
              [
                51.3043209,
                31.4182076
              ],
              [
                51.3068207,
                31.4129264
              ],
              [
                51.3073775,
                31.4126555
              ],
              [
                51.3084873,
                31.4107055
              ],
              [
                51.3140441,
                31.3934804
              ],
              [
                51.3137674,
                31.388488
              ],
              [
                51.3143206,
                31.384597
              ],
              [
                51.3156149,
                31.3815458
              ],
              [
                51.3149453,
                31.3797876
              ],
              [
                51.3136924,
                31.3779972
              ],
              [
                51.3107827,
                31.3759747
              ],
              [
                51.3085718,
                31.3742308
              ],
              [
                51.305039,
                31.3751668
              ],
              [
                51.3020094,
                31.3770401
              ],
              [
                51.2981656,
                31.3780632
              ],
              [
                51.2968781,
                31.3780632
              ],
              [
                51.2910846,
                31.3768321
              ],
              [
                51.2881492,
                31.3754251
              ],
              [
                51.2859605,
                31.3733147
              ],
              [
                51.2852652,
                31.3695552
              ],
              [
                51.2852652,
                31.3672247
              ],
              [
                51.2858317,
                31.3658616
              ],
              [
                51.2912648,
                31.3553296
              ],
              [
                51.2923463,
                31.3538124
              ],
              [
                51.2942775,
                31.3521852
              ],
              [
                51.2975746,
                31.3453597
              ],
              [
                51.3037544,
                31.3384323
              ],
              [
                51.3068958,
                31.3334838
              ],
              [
                51.308003,
                31.3298327
              ],
              [
                51.3116079,
                31.3253897
              ],
              [
                51.3136421,
                31.323608
              ],
              [
                51.314981,
                31.3211664
              ],
              [
                51.3208261,
                31.3127853
              ],
              [
                51.3258472,
                31.3088035
              ],
              [
                51.3287569,
                31.3051075
              ],
              [
                51.3286539,
                31.3017634
              ],
              [
                51.3277011,
                31.2994532
              ],
              [
                51.3288599,
                31.2953828
              ],
              [
                51.333057,
                31.289992
              ],
              [
                51.3347126,
                31.2852045
              ],
              [
                51.3388324,
                31.2780085
              ],
              [
                51.3447033,
                31.2726607
              ],
              [
                51.3468404,
                31.2664323
              ],
              [
                51.3469434,
                31.2630427
              ],
              [
                51.3408666,
                31.2559332
              ],
              [
                51.3389612,
                31.2527634
              ],
              [
                51.3409954,
                31.2464676
              ],
              [
                51.3408238,
                31.2430901
              ],
              [
                51.3400256,
                31.2353405
              ],
              [
                51.3400513,
                31.226027
              ],
              [
                51.3360087,
                31.2123963
              ],
              [
                51.3346955,
                31.207265
              ],
              [
                51.3332793,
                31.2004155
              ],
              [
                51.332069,
                31.1941603
              ],
              [
                51.332481,
                31.1875301
              ],
              [
                51.3353907,
                31.1804809
              ],
              [
                51.3356224,
                31.1788507
              ],
              [
                51.3336002,
                31.1755919
              ],
              [
                51.33256,
                31.1697426
              ],
              [
                51.3332037,
                31.1658428
              ],
              [
                51.3358301,
                31.1541206
              ],
              [
                51.3380961,
                31.1463858
              ],
              [
                51.3390746,
                31.1366448
              ],
              [
                51.3391003,
                31.1312228
              ],
              [
                51.3412375,
                31.1232216
              ],
              [
                51.3425764,
                31.1190775
              ],
              [
                51.3430657,
                31.1146466
              ],
              [
                51.3435445,
                31.1128778
              ],
              [
                51.3428808,
                31.1044317
              ],
              [
                51.3413702,
                31.0978859
              ],
              [
                51.343865,
                31.0926332
              ],
              [
                51.3468404,
                31.0886152
              ],
              [
                51.3470445,
                31.0846242
              ],
              [
                51.3472047,
                31.0803314
              ],
              [
                51.3482347,
                31.0710198
              ],
              [
                51.3489671,
                31.0672753
              ],
              [
                51.3482118,
                31.0633345
              ],
              [
                51.3486128,
                31.0616629
              ],
              [
                51.3487598,
                31.0592023
              ],
              [
                51.3491461,
                31.0562907
              ],
              [
                51.3478329,
                31.0551436
              ],
              [
                51.3475239,
                31.0518127
              ],
              [
                51.3490431,
                31.0512171
              ],
              [
                51.3510515,
                31.0492097
              ],
              [
                51.3505623,
                31.0443123
              ],
              [
                51.352648,
                31.040628
              ],
              [
                51.3537294,
                31.0385762
              ],
              [
                51.3532917,
                31.0330825
              ],
              [
                51.3503048,
                31.0316042
              ],
              [
                51.3488886,
                31.0286034
              ],
              [
                51.3493521,
                31.0265955
              ],
              [
                51.3525192,
                31.0235284
              ],
              [
                51.3541414,
                31.0209025
              ],
              [
                51.3560211,
                31.0190489
              ],
              [
                51.3618919,
                31.0138851
              ],
              [
                51.3665889,
                31.0065834
              ],
              [
                51.3695758,
                31.0062082
              ],
              [
                51.3755458,
                31.0067497
              ],
              [
                51.3767817,
                30.997502
              ],
              [
                51.3790992,
                30.9944561
              ],
              [
                51.3828586,
                30.9935069
              ],
              [
                51.384455,
                30.9933745
              ],
              [
                51.3849442,
                30.9924033
              ],
              [
                51.384146,
                30.9879223
              ],
              [
                51.3867467,
                30.9855162
              ],
              [
                51.3884375,
                30.9838258
              ],
              [
                51.3901179,
                30.9810248
              ],
              [
                51.393496,
                30.9763112
              ],
              [
                51.3969979,
                30.972536
              ],
              [
                51.4020554,
                30.9690384
              ],
              [
                51.405171,
                30.9662785
              ],
              [
                51.4075399,
                30.9642031
              ],
              [
                51.4111738,
                30.9631283
              ],
              [
                51.4139289,
                30.9626867
              ],
              [
                51.4164524,
                30.9619581
              ],
              [
                51.4228382,
                30.9626646
              ],
              [
                51.4250268,
                30.9617814
              ],
              [
                51.4257736,
                30.9606995
              ],
              [
                51.4274988,
                30.9581823
              ],
              [
                51.4324426,
                30.9521098
              ],
              [
                51.4361505,
                30.9519773
              ],
              [
                51.4355325,
                30.9467878
              ],
              [
                51.437438,
                30.9451757
              ],
              [
                51.4383134,
                30.9453082
              ],
              [
                51.4407596,
                30.9445131
              ],
              [
                51.4457035,
                30.942901
              ],
              [
                51.4478149,
                30.9404275
              ],
              [
                51.451497,
                30.9359883
              ],
              [
                51.4542693,
                30.9316465
              ],
              [
                51.4591559,
                30.9275089
              ],
              [
                51.4617565,
                30.92329
              ],
              [
                51.4633994,
                30.9216305
              ],
              [
                51.4669485,
                30.9199815
              ],
              [
                51.468854,
                30.9215499
              ],
              [
                51.4706307,
                30.9221905
              ],
              [
                51.4747248,
                30.9227648
              ],
              [
                51.4772224,
                30.9219917
              ],
              [
                51.4776859,
                30.9214394
              ],
              [
                51.4811878,
                30.9219475
              ],
              [
                51.483325,
                30.9219917
              ],
              [
                51.483737,
                30.9199594
              ],
              [
                51.4824238,
                30.9184794
              ],
              [
                51.4824753,
                30.9160715
              ],
              [
                51.4803638,
                30.9118079
              ],
              [
                51.4804668,
                30.9090685
              ],
              [
                51.4826555,
                30.9055115
              ],
              [
                51.48281,
                30.9040313
              ],
              [
                51.4893246,
                30.8994357
              ],
              [
                51.4914875,
                30.8972483
              ],
              [
                51.4930067,
                30.8966517
              ],
              [
                51.4955044,
                30.8959226
              ],
              [
                51.4959164,
                30.8911278
              ],
              [
                51.4954786,
                30.8864874
              ],
              [
                51.4991865,
                30.8801452
              ],
              [
                51.5079927,
                30.8728301
              ],
              [
                51.5134773,
                30.8711504
              ],
              [
                51.5163355,
                30.8710399
              ],
              [
                51.5216913,
                30.8716145
              ],
              [
                51.523983,
                30.8705537
              ],
              [
                51.5261974,
                30.8693602
              ],
              [
                51.5280094,
                30.8685666
              ],
              [
                51.5304164,
                30.8656829
              ],
              [
                51.5333461,
                30.8635414
              ],
              [
                51.5365962,
                30.8627162
              ],
              [
                51.5430736,
                30.8610855
              ],
              [
                51.5444011,
                30.8611052
              ],
              [
                51.5455684,
                30.8613016
              ],
              [
                51.5469188,
                30.8628931
              ],
              [
                51.55097,
                30.8647988
              ],
              [
                51.5521831,
                30.8630699
              ],
              [
                51.5555705,
                30.8609676
              ],
              [
                51.5600795,
                30.858158
              ],
              [
                51.5652522,
                30.8547784
              ],
              [
                51.5688072,
                30.852263
              ],
              [
                51.5710503,
                30.849964
              ],
              [
                51.5718056,
                30.8491387
              ],
              [
                51.57398,
                30.8486475
              ],
              [
                51.5756279,
                30.8478811
              ],
              [
                51.5765892,
                30.8420252
              ],
              [
                51.5787407,
                30.840453
              ],
              [
                51.5824486,
                30.8397063
              ],
              [
                51.5859734,
                30.8388023
              ],
              [
                51.5862251,
                30.8386058
              ],
              [
                51.5861336,
                30.8378786
              ],
              [
                51.5856758,
                30.8360903
              ],
              [
                51.5863854,
                30.8344591
              ],
              [
                51.5894753,
                30.8337319
              ],
              [
                51.5955406,
                30.8321203
              ],
              [
                51.5978294,
                30.8317666
              ],
              [
                51.6020638,
                30.828622
              ],
              [
                51.6046501,
                30.8278751
              ],
              [
                51.6083809,
                30.8289757
              ],
              [
                51.6101603,
                30.8289267
              ],
              [
                51.6109238,
                30.8282711
              ],
              [
                51.6121287,
                30.8272364
              ],
              [
                51.6130213,
                30.8227354
              ],
              [
                51.6113734,
                30.8187256
              ],
              [
                51.6073679,
                30.8140277
              ],
              [
                51.6056742,
                30.812003
              ],
              [
                51.6093592,
                30.8105483
              ],
              [
                51.6143259,
                30.8077569
              ],
              [
                51.6162485,
                30.80585
              ],
              [
                51.6181025,
                30.803196
              ],
              [
                51.6251063,
                30.8028225
              ],
              [
                51.6303248,
                30.8024293
              ],
              [
                51.6331171,
                30.797239
              ],
              [
                51.6341471,
                30.794919
              ],
              [
                51.6354746,
                30.7943882
              ],
              [
                51.6371455,
                30.791498
              ],
              [
                51.6408762,
                30.7902986
              ],
              [
                51.6439432,
                30.7889419
              ],
              [
                51.6492075,
                30.7885486
              ],
              [
                51.6512904,
                30.7855599
              ],
              [
                51.6557536,
                30.7799558
              ],
              [
                51.6616587,
                30.7748823
              ],
              [
                51.6641535,
                30.7725815
              ],
              [
                51.6692118,
                30.7739581
              ],
              [
                51.6734461,
                30.7738401
              ],
              [
                51.6747965,
                30.774725
              ],
              [
                51.6810679,
                30.7753543
              ],
              [
                51.6827616,
                30.7743907
              ],
              [
                51.6829218,
                30.7713819
              ],
              [
                51.6804728,
                30.7700249
              ],
              [
                51.6808619,
                30.7655802
              ],
              [
                51.6934046,
                30.7618041
              ],
              [
                51.6942286,
                30.7558446
              ],
              [
                51.6948958,
                30.7527767
              ],
              [
                51.6959487,
                30.7495508
              ],
              [
                51.6955367,
                30.747092
              ],
              [
                51.6971388,
                30.7447315
              ],
              [
                51.6978026,
                30.7424889
              ],
              [
                51.6970473,
                30.7408955
              ],
              [
                51.6978713,
                30.739066
              ],
              [
                51.7011672,
                30.73702
              ],
              [
                51.7035018,
                30.7367643
              ],
              [
                51.7067519,
                30.7372954
              ],
              [
                51.7108489,
                30.7366265
              ],
              [
                51.7149916,
                30.7343248
              ],
              [
                51.7157927,
                30.7321016
              ],
              [
                51.7171202,
                30.7310786
              ],
              [
                51.7210799,
                30.7289341
              ],
              [
                51.7252913,
                30.7282652
              ],
              [
                51.7300749,
                30.7237596
              ],
              [
                51.7335768,
                30.7213394
              ],
              [
                51.7395278,
                30.7187421
              ],
              [
                51.7424117,
                30.7194308
              ],
              [
                51.7448415,
                30.7202932
              ],
              [
                51.7505865,
                30.7170072
              ],
              [
                51.7566747,
                30.7171252
              ],
              [
                51.7593298,
                30.7155904
              ],
              [
                51.763278,
                30.7151329
              ],
              [
                51.7669973,
                30.7123239
              ],
              [
                51.7732458,
                30.71134
              ],
              [
                51.7842493,
                30.7099724
              ],
              [
                51.801856,
                30.7131455
              ],
              [
                51.8067598,
                30.7129585
              ],
              [
                51.8112459,
                30.7142277
              ],
              [
                51.8164769,
                30.7162497
              ],
              [
                51.827401,
                30.7334731
              ],
              [
                51.8326809,
                30.7404135
              ],
              [
                51.8335142,
                30.7420832
              ],
              [
                51.8465706,
                30.7690329
              ],
              [
                51.8549038,
                30.7951345
              ],
              [
                51.8574039,
                30.799584
              ],
              [
                51.8576804,
                30.7998548
              ],
              [
                51.8579571,
                30.8004144
              ],
              [
                51.8585137,
                30.8004145
              ],
              [
                51.8585138,
                30.8026347
              ],
              [
                51.8562905,
                30.8131946
              ],
              [
                51.8426807,
                30.8423565
              ],
              [
                51.8424005,
                30.8440353
              ],
              [
                51.8415674,
                30.8459668
              ],
              [
                51.8324007,
                30.8759777
              ],
              [
                51.8326808,
                30.8826388
              ],
              [
                51.8354575,
                30.8934789
              ],
              [
                51.8371241,
                30.8984793
              ],
              [
                51.8412905,
                30.905971
              ],
              [
                51.8415673,
                30.9065305
              ],
              [
                51.8499038,
                30.9195822
              ],
              [
                51.8560136,
                30.9265323
              ],
              [
                51.8715702,
                30.9426439
              ],
              [
                51.8724034,
                30.9443138
              ],
              [
                51.87296,
                30.9445846
              ],
              [
                51.894903,
                30.9840294
              ],
              [
                51.8954596,
                30.9854194
              ],
              [
                51.8976831,
                30.9893098
              ],
              [
                51.8976831,
                30.9895896
              ],
              [
                51.8976831,
                30.9901493
              ],
              [
                51.8976831,
                30.9906999
              ],
              [
                51.8979597,
                30.9909706
              ],
              [
                51.8979597,
                30.9918101
              ],
              [
                51.8965697,
                31.0001234
              ],
              [
                51.897403,
                31.0123632
              ],
              [
                51.8976831,
                31.0212543
              ],
              [
                51.8985163,
                31.0273653
              ],
              [
                51.9010164,
                31.0329256
              ],
              [
                51.9012929,
                31.0332055
              ],
              [
                51.9021263,
                31.0343067
              ],
              [
                51.9024062,
                31.0345865
              ],
              [
                51.9218493,
                31.0770929
              ],
              [
                51.9249058,
                31.0829242
              ],
              [
                51.9401857,
                31.11181
              ],
              [
                51.9410189,
                31.1129202
              ],
              [
                51.956852,
                31.1509777
              ],
              [
                51.9679618,
                31.1943167
              ],
              [
                51.9685184,
                31.2109809
              ],
              [
                51.9682418,
                31.2112607
              ],
              [
                51.9685184,
                31.2129218
              ],
              [
                51.9685184,
                31.2132016
              ],
              [
                51.9685184,
                31.2134814
              ],
              [
                51.9682418,
                31.2140321
              ],
              [
                51.9665752,
                31.2204234
              ],
              [
                51.966295,
                31.2220934
              ],
              [
                51.9660186,
                31.2245939
              ],
              [
                51.9657418,
                31.2259842
              ],
              [
                51.9654619,
                31.2284847
              ],
              [
                51.9651851,
                31.2309762
              ],
              [
                51.9646285,
                31.2343163
              ],
              [
                51.9640751,
                31.2379273
              ],
              [
                51.9635185,
                31.241818
              ],
              [
                51.9635184,
                31.2437588
              ],
              [
                51.9546286,
                31.2882097
              ],
              [
                51.9546286,
                31.2904215
              ],
              [
                51.954352,
                31.2909812
              ],
              [
                51.9546286,
                31.2929311
              ],
              [
                51.9546286,
                31.294872
              ],
              [
                51.9562952,
                31.3009836
              ],
              [
                51.9557386,
                31.3023738
              ],
              [
                51.9554618,
                31.3040439
              ],
              [
                51.9551852,
                31.3062557
              ],
              [
                51.9535186,
                31.314868
              ],
              [
                51.9535186,
                31.316538
              ],
              [
                51.9487952,
                31.3359835
              ],
              [
                51.947962,
                31.3409848
              ],
              [
                51.9454619,
                31.3501479
              ],
              [
                51.9451854,
                31.3523777
              ],
              [
                51.9443519,
                31.3548783
              ],
              [
                51.9418521,
                31.3765358
              ],
              [
                51.9382387,
                31.3948713
              ],
              [
                51.9374053,
                31.3970921
              ],
              [
                51.9365721,
                31.4029331
              ],
              [
                51.9362954,
                31.4040434
              ],
              [
                51.9365721,
                31.4120964
              ],
              [
                51.9365721,
                31.4123762
              ],
              [
                51.9346286,
                31.4123762
              ],
              [
                51.9249054,
                31.4090449
              ],
              [
                51.9218489,
                31.4076546
              ],
              [
                51.9210155,
                31.4076546
              ],
              [
                51.9168491,
                31.4059845
              ],
              [
                51.9115723,
                31.4037636
              ],
              [
                51.8968493,
                31.3973719
              ],
              [
                51.8754596,
                31.3912601
              ],
              [
                51.8693464,
                31.3893191
              ],
              [
                51.8582364,
                31.3868184
              ],
              [
                51.8435133,
                31.3862677
              ],
              [
                51.84018,
                31.3865385
              ],
              [
                51.8390667,
                31.3868184
              ],
              [
                51.8360135,
                31.3868184
              ],
              [
                51.8312902,
                31.3873691
              ],
              [
                51.8129571,
                31.3915399
              ],
              [
                51.8085105,
                31.3929302
              ],
              [
                51.8026771,
                31.3954309
              ],
              [
                51.7762876,
                31.4173684
              ],
              [
                51.7523978,
                31.4526496
              ],
              [
                51.7412847,
                31.4765467
              ],
              [
                51.7412847,
                31.4770974
              ],
              [
                51.7410079,
                31.4773772
              ],
              [
                51.7410079,
                31.4776571
              ],
              [
                51.7410079,
                31.477937
              ],
              [
                51.7407313,
                31.4784877
              ],
              [
                51.730728,
                31.5043171
              ],
              [
                51.7298948,
                31.5054365
              ],
              [
                51.7246181,
                31.5196017
              ],
              [
                51.7237848,
                31.5212629
              ],
              [
                51.719895,
                31.5384886
              ],
              [
                51.7201749,
                31.5457112
              ],
              [
                51.7204516,
                31.5462619
              ],
              [
                51.7215615,
                31.5507128
              ],
              [
                51.7226749,
                31.5537643
              ],
              [
                51.7229515,
                31.5551547
              ],
              [
                51.7265614,
                31.5623773
              ],
              [
                51.7283511,
                31.5676204
              ],
              [
                51.7482577,
                31.6163358
              ],
              [
                51.7337845,
                31.6279321
              ],
              [
                51.7293413,
                31.6315525
              ],
              [
                51.7226748,
                31.6382155
              ],
              [
                51.7176749,
                31.6423866
              ],
              [
                51.7171182,
                31.6426575
              ],
              [
                51.7163472,
                31.6432406
              ],
              [
                51.7146738,
                31.6443757
              ],
              [
                51.7134893,
                31.6449675
              ],
              [
                51.7065616,
                31.6479391
              ],
              [
                51.7060049,
                31.6484899
              ],
              [
                51.7046184,
                31.6493204
              ],
              [
                51.6971184,
                31.6557127
              ],
              [
                51.6890618,
                31.6695984
              ],
              [
                51.6773954,
                31.6862742
              ],
              [
                51.6176693,
                31.7515511
              ],
              [
                51.6162795,
                31.7532124
              ],
              [
                51.6160027,
                31.7537722
              ],
              [
                51.6068362,
                31.7609951
              ],
              [
                51.6065562,
                31.761266
              ],
              [
                51.603503,
                31.763767
              ],
              [
                51.6029462,
                31.7640558
              ],
              [
                51.5857232,
                31.7782129
              ],
              [
                51.5598867,
                31.8082154
              ],
              [
                51.5587767,
                31.8096059
              ],
              [
                51.5557202,
                31.8126577
              ],
              [
                51.5496103,
                31.8190501
              ],
              [
                51.5390536,
                31.8232123
              ],
              [
                51.5237739,
                31.8229415
              ],
              [
                51.5201641,
                31.8232123
              ],
              [
                51.5184974,
                31.8234922
              ],
              [
                51.5062742,
                31.8234922
              ],
              [
                51.5040509,
                31.8237721
              ],
              [
                51.497941,
                31.8237721
              ],
              [
                51.4873843,
                31.8251625
              ],
              [
                51.4737747,
                31.8265439
              ],
              [
                51.4729413,
                31.8268329
              ],
              [
                51.4607182,
                31.8268328
              ],
              [
                51.4584949,
                31.8265439
              ],
              [
                51.4482183,
                31.8265439
              ],
              [
                51.4465482,
                31.8268329
              ],
              [
                51.4412717,
                31.8268328
              ],
              [
                51.4368285,
                31.8271037
              ],
              [
                51.4321052,
                31.8276634
              ],
              [
                51.4293252,
                31.8276635
              ],
              [
                51.4276585,
                31.8279343
              ],
              [
                51.4215487,
                31.8279343
              ],
              [
                51.412382,
                31.8279343
              ],
              [
                51.4115489,
                31.8282233
              ],
              [
                51.4076588,
                31.8282233
              ],
              [
                51.4054354,
                31.8287739
              ],
              [
                51.3921024,
                31.8487729
              ],
              [
                51.3923825,
                31.8490528
              ],
              [
                51.3915457,
                31.8490527
              ],
              [
                51.387521,
                31.8489872
              ],
              [
                51.3837852,
                31.8496615
              ],
              [
                51.3811588,
                31.8516737
              ],
              [
                51.3776826,
                31.8533141
              ],
              [
                51.3697776,
                31.8562448
              ],
              [
                51.36625,
                31.8563979
              ],
              [
                51.3653745,
                31.8555012
              ],
              [
                51.3597612,
                31.8492459
              ],
              [
                51.348483,
                31.839709
              ],
              [
                51.3456249,
                31.8399715
              ],
              [
                51.3389558,
                31.8407371
              ],
              [
                51.3338832,
                31.8402559
              ],
              [
                51.3246908,
                31.8371497
              ],
              [
                51.3189946,
                31.835389
              ],
              [
                51.3095704,
                31.8304012
              ],
              [
                51.2991162,
                31.822919
              ],
              [
                51.2986787,
                31.8222844
              ],
              [
                51.2959805,
                31.8183708
              ],
              [
                51.2931358,
                31.810817
              ],
              [
                51.2938132,
                31.8055718
              ],
              [
                51.2995206,
                31.7955587
              ],
              [
                51.3047655,
                31.7878865
              ],
              [
                51.3059757,
                31.784297
              ],
              [
                51.3088854,
                31.7794159
              ],
              [
                51.3094776,
                31.7760011
              ],
              [
                51.3094518,
                31.7730241
              ],
              [
                51.3120268,
                31.7670478
              ],
              [
                51.312619,
                31.7629101
              ],
              [
                51.3137005,
                31.7605238
              ],
              [
                51.3176401,
                31.757174
              ],
              [
                51.3222749,
                31.7534519
              ],
              [
                51.3246181,
                31.7501238
              ],
              [
                51.328532,
                31.7446497
              ],
              [
                51.3301542,
                31.7416935
              ],
              [
                51.3370807,
                31.7347297
              ],
              [
                51.3418186,
                31.7324084
              ],
              [
                51.3472002,
                31.7289043
              ],
              [
                51.3574226,
                31.725422
              ],
              [
                51.3603838,
                31.7230347
              ],
              [
                51.3621605,
                31.7217205
              ],
              [
                51.3634737,
                31.7197712
              ],
              [
                51.3633964,
                31.7172304
              ],
              [
                51.3630102,
                31.7158285
              ],
              [
                51.3616455,
                31.7144486
              ],
              [
                51.3567016,
                31.712981
              ],
              [
                51.3505218,
                31.7101333
              ],
              [
                51.3447282,
                31.7101771
              ],
              [
                51.3332698,
                31.7082933
              ],
              [
                51.326678,
                31.7082933
              ],
              [
                51.3206527,
                31.7081837
              ],
              [
                51.3162754,
                31.7045692
              ],
              [
                51.3143957,
                31.6952146
              ],
              [
                51.3117693,
                31.6848731
              ],
              [
                51.3117178,
                31.6832735
              ],
              [
                51.3107153,
                31.6816296
              ],
              [
                51.3046868,
                31.6768578
              ],
              [
                51.3001509,
                31.6673709
              ],
              [
                51.2987276,
                31.6469639
              ],
              [
                51.3001656,
                31.6407525
              ],
              [
                51.3042286,
                31.6225604
              ],
              [
                51.3033854,
                31.6159561
              ],
              [
                51.303194,
                31.6131465
              ],
              [
                51.3023142,
                31.6062341
              ],
              [
                51.3016533,
                31.5967894
              ],
              [
                51.2971884,
                31.5694447
              ],
              [
                51.2926175,
                31.5514879
              ],
              [
                51.2917313,
                31.5468213
              ],
              [
                51.2910349,
                31.535373
              ],
              [
                51.2941387,
                31.5239195
              ],
              [
                51.2922434,
                31.5127273
              ],
              [
                51.289119,
                31.5105139
              ],
              [
                51.2798546,
                31.5080603
              ],
              [
                51.2722357,
                31.5042154
              ],
              [
                51.2729115,
                31.5026075
              ],
              [
                51.2735988,
                31.4996013
              ],
              [
                51.2745663,
                31.4951612
              ],
              [
                51.2749822,
                31.4936781
              ],
              [
                51.2753,
                31.4922256
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555100,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شاهین شهر و میمه",
          "name:en": "Shahin Shahr and Meymeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q8546986",
          "wikipedia": "fa:شهرستان شاهین شهر و میمه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.5873409,
                33.6543677
              ],
              [
                50.5876201,
                33.6540887
              ],
              [
                50.5881736,
                33.6515971
              ],
              [
                50.5884537,
                33.6502069
              ],
              [
                50.5887303,
                33.649927
              ],
              [
                50.5884537,
                33.646316
              ],
              [
                50.5878968,
                33.6346522
              ],
              [
                50.5887303,
                33.6282607
              ],
              [
                50.5887303,
                33.618258
              ],
              [
                50.5895635,
                33.6124261
              ],
              [
                50.5898402,
                33.6121463
              ],
              [
                50.5898402,
                33.6115956
              ],
              [
                50.5898401,
                33.6099254
              ],
              [
                50.5901202,
                33.6071449
              ],
              [
                50.5903969,
                33.6057546
              ],
              [
                50.5906734,
                33.6010332
              ],
              [
                50.5909535,
                33.5988124
              ],
              [
                50.5912304,
                33.5960408
              ],
              [
                50.591507,
                33.5940908
              ],
              [
                50.591787,
                33.5927006
              ],
              [
                50.5956736,
                33.5846478
              ],
              [
                50.5967868,
                33.5832575
              ],
              [
                50.5992869,
                33.5807568
              ],
              [
                50.6134532,
                33.568813
              ],
              [
                50.6162298,
                33.5657616
              ],
              [
                50.6167864,
                33.5652019
              ],
              [
                50.6167865,
                33.5646421
              ],
              [
                50.6206769,
                33.5596407
              ],
              [
                50.6228999,
                33.5543684
              ],
              [
                50.6242866,
                33.5452051
              ],
              [
                50.6245668,
                33.5446454
              ],
              [
                50.6223432,
                33.5321417
              ],
              [
                50.6215101,
                33.531591
              ],
              [
                50.6215101,
                33.5310403
              ],
              [
                50.6134533,
                33.5238179
              ],
              [
                50.6117868,
                33.5221387
              ],
              [
                50.6065102,
                33.5132552
              ],
              [
                50.605677,
                33.5085335
              ],
              [
                50.6020636,
                33.5021417
              ],
              [
                50.599287,
                33.4990901
              ],
              [
                50.5934537,
                33.4938087
              ],
              [
                50.5895639,
                33.4840855
              ],
              [
                50.5892873,
                33.4821445
              ],
              [
                50.5892873,
                33.4788041
              ],
              [
                50.5895638,
                33.4752019
              ],
              [
                50.5898403,
                33.4732517
              ],
              [
                50.6078971,
                33.43964
              ],
              [
                50.6087303,
                33.4382496
              ],
              [
                50.6106768,
                33.4338077
              ],
              [
                50.6109538,
                33.4335279
              ],
              [
                50.6109538,
                33.433257
              ],
              [
                50.6109538,
                33.4329772
              ],
              [
                50.6109538,
                33.4326973
              ],
              [
                50.6112303,
                33.4318667
              ],
              [
                50.6115105,
                33.4310361
              ],
              [
                50.6117871,
                33.4307472
              ],
              [
                50.611787,
                33.4301965
              ],
              [
                50.6115104,
                33.4282554
              ],
              [
                50.611787,
                33.4240844
              ],
              [
                50.6115104,
                33.4232537
              ],
              [
                50.6106769,
                33.4163111
              ],
              [
                50.6117871,
                33.4068675
              ],
              [
                50.6120636,
                33.4060278
              ],
              [
                50.6142871,
                33.3974148
              ],
              [
                50.6145637,
                33.3940833
              ],
              [
                50.6148438,
                33.3918624
              ],
              [
                50.6151204,
                33.3902012
              ],
              [
                50.615397,
                33.3885309
              ],
              [
                50.6156771,
                33.3877003
              ],
              [
                50.6167868,
                33.3857502
              ],
              [
                50.6179005,
                33.384089
              ],
              [
                50.6312335,
                33.3774171
              ],
              [
                50.6323433,
                33.3774171
              ],
              [
                50.63512,
                33.3765865
              ],
              [
                50.6362334,
                33.3765865
              ],
              [
                50.6370669,
                33.3763066
              ],
              [
                50.6490097,
                33.3738057
              ],
              [
                50.6576232,
                33.3721445
              ],
              [
                50.6592896,
                33.3721445
              ],
              [
                50.6598463,
                33.3718647
              ],
              [
                50.6606799,
                33.3718647
              ],
              [
                50.6609565,
                33.3715848
              ],
              [
                50.6623463,
                33.3715848
              ],
              [
                50.6628998,
                33.3713049
              ],
              [
                50.6653995,
                33.3707542
              ],
              [
                50.6667898,
                33.3707541
              ],
              [
                50.6670664,
                33.3704743
              ],
              [
                50.667623,
                33.3704743
              ],
              [
                50.6692899,
                33.3699145
              ],
              [
                50.6701231,
                33.3699146
              ],
              [
                50.6706797,
                33.3696437
              ],
              [
                50.6715129,
                33.3696436
              ],
              [
                50.6728996,
                33.3690839
              ],
              [
                50.6862363,
                33.3651927
              ],
              [
                50.6956794,
                33.3613105
              ],
              [
                50.6965127,
                33.3613106
              ],
              [
                50.6973459,
                33.3607507
              ],
              [
                50.7012358,
                33.3593604
              ],
              [
                50.7017924,
                33.3588097
              ],
              [
                50.7145691,
                33.3524176
              ],
              [
                50.7154025,
                33.3515869
              ],
              [
                50.727349,
                33.3446351
              ],
              [
                50.7287356,
                33.3440844
              ],
              [
                50.7290156,
                33.3438045
              ],
              [
                50.749572,
                33.3310292
              ],
              [
                50.7634619,
                33.3188046
              ],
              [
                50.7637384,
                33.3185338
              ],
              [
                50.753459,
                33.3119311
              ],
              [
                50.756759,
                33.3097145
              ],
              [
                50.7598071,
                33.3072469
              ],
              [
                50.764404,
                33.3045812
              ],
              [
                50.7685847,
                33.3026802
              ],
              [
                50.7706851,
                33.3018065
              ],
              [
                50.7752307,
                33.3007126
              ],
              [
                50.7796262,
                33.300405
              ],
              [
                50.7864212,
                33.3005665
              ],
              [
                50.7905888,
                33.3004575
              ],
              [
                50.8009822,
                33.2988603
              ],
              [
                50.8097291,
                33.2965477
              ],
              [
                50.8195138,
                33.2946107
              ],
              [
                50.8278533,
                33.292837
              ],
              [
                50.8329103,
                33.2912728
              ],
              [
                50.8371576,
                33.29034
              ],
              [
                50.8409788,
                33.2894985
              ],
              [
                50.8464467,
                33.2881585
              ],
              [
                50.8607985,
                33.2849299
              ],
              [
                50.8799606,
                33.2788941
              ],
              [
                50.8930953,
                33.2733149
              ],
              [
                50.8971762,
                33.2704445
              ],
              [
                50.9068726,
                33.2633614
              ],
              [
                50.9122752,
                33.2585707
              ],
              [
                50.9165668,
                33.2498859
              ],
              [
                50.9221458,
                33.2407694
              ],
              [
                50.9262965,
                33.2363694
              ],
              [
                50.9325436,
                33.2224606
              ],
              [
                50.9355656,
                33.2185977
              ],
              [
                50.9391658,
                33.2145072
              ],
              [
                50.942938,
                33.2104677
              ],
              [
                50.947803,
                33.2049024
              ],
              [
                50.9547083,
                33.197123
              ],
              [
                50.96004,
                33.1912226
              ],
              [
                50.9625721,
                33.1872002
              ],
              [
                50.9735162,
                33.1748378
              ],
              [
                50.97859,
                33.1699256
              ],
              [
                50.9826037,
                33.1657555
              ],
              [
                50.9881209,
                33.160156
              ],
              [
                50.9907429,
                33.1587603
              ],
              [
                50.9971189,
                33.1554094
              ],
              [
                50.998342,
                33.1545651
              ],
              [
                50.9996652,
                33.1539504
              ],
              [
                51.0105388,
                33.1495905
              ],
              [
                51.0238765,
                33.1420888
              ],
              [
                51.041728,
                33.1242638
              ],
              [
                51.0568727,
                33.1103419
              ],
              [
                51.0753237,
                33.0986375
              ],
              [
                51.0874168,
                33.0948088
              ],
              [
                51.1022346,
                33.0955522
              ],
              [
                51.1242409,
                33.0936501
              ],
              [
                51.1537775,
                33.0927549
              ],
              [
                51.1618205,
                33.0937616
              ],
              [
                51.1667736,
                33.0961587
              ],
              [
                51.1738728,
                33.1009762
              ],
              [
                51.1897705,
                33.1084613
              ],
              [
                51.201056,
                33.1080299
              ],
              [
                51.216259,
                33.1124306
              ],
              [
                51.2266597,
                33.1125961
              ],
              [
                51.2398695,
                33.1149113
              ],
              [
                51.2479566,
                33.1161884
              ],
              [
                51.2489234,
                33.1130006
              ],
              [
                51.2482165,
                33.1002422
              ],
              [
                51.2482058,
                33.0946308
              ],
              [
                51.2484826,
                33.0860262
              ],
              [
                51.248474,
                33.0726275
              ],
              [
                51.2483368,
                33.0553947
              ],
              [
                51.2467693,
                33.0396327
              ],
              [
                51.2451195,
                33.0314787
              ],
              [
                51.2389455,
                33.0286342
              ],
              [
                51.2278149,
                33.0225576
              ],
              [
                51.2069579,
                33.0118193
              ],
              [
                51.1855694,
                33.0010203
              ],
              [
                51.1855195,
                32.9976937
              ],
              [
                51.1900494,
                32.9918241
              ],
              [
                51.1943646,
                32.9881551
              ],
              [
                51.2032256,
                32.9737573
              ],
              [
                51.2135253,
                32.9574098
              ],
              [
                51.2170969,
                32.9526342
              ],
              [
                51.2222038,
                32.9468616
              ],
              [
                51.2418161,
                32.9432406
              ],
              [
                51.2418161,
                32.9429697
              ],
              [
                51.242373,
                32.9418501
              ],
              [
                51.2426496,
                32.9407486
              ],
              [
                51.2429296,
                32.9396289
              ],
              [
                51.2432062,
                32.936577
              ],
              [
                51.2434827,
                32.9351866
              ],
              [
                51.2443161,
                32.9296336
              ],
              [
                51.2445963,
                32.9243516
              ],
              [
                51.2448729,
                32.9240807
              ],
              [
                51.2448728,
                32.9143562
              ],
              [
                51.2462629,
                32.9087943
              ],
              [
                51.2465031,
                32.9073335
              ],
              [
                51.2467858,
                32.9070829
              ],
              [
                51.2465031,
                32.9055927
              ],
              [
                51.2463678,
                32.905331
              ],
              [
                51.2476495,
                32.9001894
              ],
              [
                51.248483,
                32.8993497
              ],
              [
                51.2493162,
                32.8960179
              ],
              [
                51.2495962,
                32.8946274
              ],
              [
                51.264596,
                32.8618513
              ],
              [
                51.2648728,
                32.8604608
              ],
              [
                51.2651527,
                32.8596301
              ],
              [
                51.2654294,
                32.8585195
              ],
              [
                51.265706,
                32.8582396
              ],
              [
                51.2740392,
                32.8332466
              ],
              [
                51.2795959,
                32.8210119
              ],
              [
                51.2798758,
                32.820741
              ],
              [
                51.2801526,
                32.8199103
              ],
              [
                51.2804292,
                32.8187997
              ],
              [
                51.2807093,
                32.8185198
              ],
              [
                51.2901524,
                32.7904658
              ],
              [
                51.2909858,
                32.7896261
              ],
              [
                51.2912625,
                32.7887953
              ],
              [
                51.3023755,
                32.7757389
              ],
              [
                51.3034855,
                32.7743485
              ],
              [
                51.3037656,
                32.7737886
              ],
              [
                51.3315419,
                32.7582402
              ],
              [
                51.3326553,
                32.7582402
              ],
              [
                51.3329318,
                32.7579602
              ],
              [
                51.3337653,
                32.7579602
              ],
              [
                51.3357119,
                32.7574004
              ],
              [
                51.3495984,
                32.7551792
              ],
              [
                51.351265,
                32.7549083
              ],
              [
                51.3529316,
                32.7549083
              ],
              [
                51.3534883,
                32.7546285
              ],
              [
                51.3551549,
                32.7546284
              ],
              [
                51.3557116,
                32.7543485
              ],
              [
                51.3571017,
                32.7543485
              ],
              [
                51.3576549,
                32.7540686
              ],
              [
                51.3718215,
                32.7518474
              ],
              [
                51.3757114,
                32.7512966
              ],
              [
                51.3782113,
                32.7512966
              ],
              [
                51.3793248,
                32.7510167
              ],
              [
                51.3807113,
                32.7510167
              ],
              [
                51.3818246,
                32.7507368
              ],
              [
                51.3957145,
                32.7507368
              ],
              [
                51.3965477,
                32.7510167
              ],
              [
                51.3996012,
                32.7510167
              ],
              [
                51.4001578,
                32.7512966
              ],
              [
                51.4046011,
                32.7512966
              ],
              [
                51.4051577,
                32.7510167
              ],
              [
                51.4065476,
                32.7510168
              ],
              [
                51.4065475,
                32.7507369
              ],
              [
                51.4076575,
                32.7504569
              ],
              [
                51.4090477,
                32.7504569
              ],
              [
                51.4093242,
                32.750177
              ],
              [
                51.4101576,
                32.750177
              ],
              [
                51.4104377,
                32.7504569
              ],
              [
                51.4112709,
                32.7504569
              ],
              [
                51.4118242,
                32.750177
              ],
              [
                51.413771,
                32.750177
              ],
              [
                51.4140476,
                32.7504569
              ],
              [
                51.4257139,
                32.7679558
              ],
              [
                51.4262707,
                32.7682357
              ],
              [
                51.4265473,
                32.7687956
              ],
              [
                51.4273807,
                32.7690754
              ],
              [
                51.4276573,
                32.7696263
              ],
              [
                51.4287706,
                32.770186
              ],
              [
                51.429604,
                32.7701861
              ],
              [
                51.4301607,
                32.7704659
              ],
              [
                51.4312706,
                32.770466
              ],
              [
                51.4329373,
                32.7710167
              ],
              [
                51.4337706,
                32.7710168
              ],
              [
                51.4348806,
                32.7715765
              ],
              [
                51.4370161,
                32.7716459
              ],
              [
                51.4432137,
                32.7718475
              ],
              [
                51.4440471,
                32.7721273
              ],
              [
                51.4448804,
                32.7721274
              ],
              [
                51.4454371,
                32.7718474
              ],
              [
                51.447937,
                32.7718474
              ],
              [
                51.4496037,
                32.7712967
              ],
              [
                51.4512703,
                32.7710168
              ],
              [
                51.47655,
                32.7576804
              ],
              [
                51.47766,
                32.7574005
              ],
              [
                51.4971064,
                32.7412922
              ],
              [
                51.4973832,
                32.7407414
              ],
              [
                51.5021063,
                32.7382403
              ],
              [
                51.5026632,
                32.7379604
              ],
              [
                51.5048864,
                32.7379604
              ],
              [
                51.5121062,
                32.739071
              ],
              [
                51.5123864,
                32.7393509
              ],
              [
                51.5146061,
                32.7393509
              ],
              [
                51.5154396,
                32.7396308
              ],
              [
                51.5168294,
                32.7396309
              ],
              [
                51.5187728,
                32.7401816
              ],
              [
                51.5204394,
                32.7401816
              ],
              [
                51.5212726,
                32.7404615
              ],
              [
                51.5226628,
                32.7404615
              ],
              [
                51.5246094,
                32.7412923
              ],
              [
                51.5262761,
                32.7412923
              ],
              [
                51.5268294,
                32.7415721
              ],
              [
                51.5284961,
                32.7415721
              ],
              [
                51.5287762,
                32.7418521
              ],
              [
                51.5429224,
                32.7394737
              ],
              [
                51.539678,
                32.7492628
              ],
              [
                51.5375151,
                32.7523813
              ],
              [
                51.5273761,
                32.7564369
              ],
              [
                51.5269636,
                32.7586587
              ],
              [
                51.5276016,
                32.7657201
              ],
              [
                51.5256383,
                32.7745093
              ],
              [
                51.546645,
                32.778467
              ],
              [
                51.5464858,
                32.7791316
              ],
              [
                51.5387438,
                32.8093365
              ],
              [
                51.5481214,
                32.8085506
              ],
              [
                51.5496253,
                32.8085639
              ],
              [
                51.5503404,
                32.8086376
              ],
              [
                51.550829,
                32.8087758
              ],
              [
                51.572128,
                32.8193481
              ],
              [
                51.574003,
                32.8202961
              ],
              [
                51.5746125,
                32.8203959
              ],
              [
                51.5754622,
                32.8201795
              ],
              [
                51.6064642,
                32.8060048
              ],
              [
                51.607101,
                32.799139
              ],
              [
                51.607211,
                32.7979535
              ],
              [
                51.6077774,
                32.7958972
              ],
              [
                51.6086787,
                32.7938193
              ],
              [
                51.6097344,
                32.7918495
              ],
              [
                51.6110476,
                32.7901395
              ],
              [
                51.6186436,
                32.7815888
              ],
              [
                51.6215066,
                32.7783417
              ],
              [
                51.6320857,
                32.7907534
              ],
              [
                51.6357383,
                32.7933779
              ],
              [
                51.6380941,
                32.7964185
              ],
              [
                51.6418433,
                32.7984348
              ],
              [
                51.6455235,
                32.8010332
              ],
              [
                51.6448711,
                32.8156154
              ],
              [
                51.64405,
                32.8223913
              ],
              [
                51.6448008,
                32.829597
              ],
              [
                51.6472623,
                32.8341844
              ],
              [
                51.6541983,
                32.8405442
              ],
              [
                51.6516217,
                32.8434366
              ],
              [
                51.6528559,
                32.844237
              ],
              [
                51.6543283,
                32.8452558
              ],
              [
                51.6452126,
                32.8528957
              ],
              [
                51.6439446,
                32.8542527
              ],
              [
                51.6497382,
                32.8589464
              ],
              [
                51.6475058,
                32.86367
              ],
              [
                51.643366,
                32.8687175
              ],
              [
                51.6389485,
                32.8705195
              ],
              [
                51.62696,
                32.8783876
              ],
              [
                51.6177299,
                32.8845498
              ],
              [
                51.607779,
                32.8930107
              ],
              [
                51.6020259,
                32.9001876
              ],
              [
                51.595762,
                32.9100601
              ],
              [
                51.5943692,
                32.9160576
              ],
              [
                51.5928268,
                32.9257076
              ],
              [
                51.592071,
                32.9355248
              ],
              [
                51.5914654,
                32.9453177
              ],
              [
                51.5906446,
                32.9564746
              ],
              [
                51.591473,
                32.9679497
              ],
              [
                51.5909646,
                32.9743672
              ],
              [
                51.5896837,
                32.9811041
              ],
              [
                51.5863058,
                32.9924472
              ],
              [
                51.5835009,
                32.9992797
              ],
              [
                51.5757784,
                33.005374
              ],
              [
                51.5650718,
                33.0108262
              ],
              [
                51.5516685,
                33.0158114
              ],
              [
                51.5393674,
                33.0231774
              ],
              [
                51.5261471,
                33.0382275
              ],
              [
                51.5272006,
                33.0464541
              ],
              [
                51.5332603,
                33.0602557
              ],
              [
                51.5361586,
                33.0709775
              ],
              [
                51.5379272,
                33.0863064
              ],
              [
                51.5368886,
                33.0937008
              ],
              [
                51.5361636,
                33.1031488
              ],
              [
                51.531852,
                33.1199132
              ],
              [
                51.5291497,
                33.127892
              ],
              [
                51.5258716,
                33.1375426
              ],
              [
                51.5215729,
                33.145924
              ],
              [
                51.5181544,
                33.1531355
              ],
              [
                51.5140317,
                33.1595988
              ],
              [
                51.508199,
                33.1682789
              ],
              [
                51.5007695,
                33.1768078
              ],
              [
                51.4867145,
                33.1941455
              ],
              [
                51.4854006,
                33.1966151
              ],
              [
                51.5262324,
                33.202302
              ],
              [
                51.5561771,
                33.2066217
              ],
              [
                51.5616215,
                33.2059469
              ],
              [
                51.5640549,
                33.2062614
              ],
              [
                51.5672846,
                33.2053874
              ],
              [
                51.5728397,
                33.2054666
              ],
              [
                51.5780063,
                33.206867
              ],
              [
                51.5827019,
                33.2085113
              ],
              [
                51.5861235,
                33.2105939
              ],
              [
                51.588398,
                33.2119509
              ],
              [
                51.5908846,
                33.2137462
              ],
              [
                51.5943965,
                33.2156884
              ],
              [
                51.6044139,
                33.2207386
              ],
              [
                51.6201234,
                33.233186
              ],
              [
                51.6274548,
                33.238484
              ],
              [
                51.6358279,
                33.2439998
              ],
              [
                51.6473905,
                33.2465859
              ],
              [
                51.6579943,
                33.2475457
              ],
              [
                51.6628751,
                33.2478124
              ],
              [
                51.6716241,
                33.2496787
              ],
              [
                51.6797102,
                33.2512866
              ],
              [
                51.6915284,
                33.2531886
              ],
              [
                51.7002173,
                33.2527252
              ],
              [
                51.722249,
                33.2519253
              ],
              [
                51.7204141,
                33.2586424
              ],
              [
                51.7198613,
                33.2656417
              ],
              [
                51.7166189,
                33.2940483
              ],
              [
                51.710849,
                33.3103832
              ],
              [
                51.7058041,
                33.330405
              ],
              [
                51.7015794,
                33.3460161
              ],
              [
                51.6945232,
                33.3629807
              ],
              [
                51.6817286,
                33.3829418
              ],
              [
                51.6689125,
                33.3961202
              ],
              [
                51.6490731,
                33.4066039
              ],
              [
                51.6309956,
                33.4161917
              ],
              [
                51.6117393,
                33.4311963
              ],
              [
                51.6047704,
                33.4388261
              ],
              [
                51.5959009,
                33.4493314
              ],
              [
                51.5994357,
                33.4517102
              ],
              [
                51.6079049,
                33.4569862
              ],
              [
                51.6133313,
                33.4617058
              ],
              [
                51.6139931,
                33.4644267
              ],
              [
                51.6159589,
                33.4676698
              ],
              [
                51.6172214,
                33.4747579
              ],
              [
                51.6203306,
                33.4789704
              ],
              [
                51.6230373,
                33.4831861
              ],
              [
                51.6251582,
                33.4869259
              ],
              [
                51.6091148,
                33.4959051
              ],
              [
                51.5997406,
                33.5005617
              ],
              [
                51.5950283,
                33.5030972
              ],
              [
                51.5731237,
                33.514226
              ],
              [
                51.5658759,
                33.5179268
              ],
              [
                51.5569133,
                33.5224207
              ],
              [
                51.5458641,
                33.5291859
              ],
              [
                51.5345012,
                33.5359932
              ],
              [
                51.5286338,
                33.5390784
              ],
              [
                51.5227762,
                33.5428096
              ],
              [
                51.5122088,
                33.5475018
              ],
              [
                51.4981556,
                33.5546641
              ],
              [
                51.4962266,
                33.5568007
              ],
              [
                51.4898604,
                33.5595245
              ],
              [
                51.4737146,
                33.5633886
              ],
              [
                51.468472,
                33.5648402
              ],
              [
                51.4618976,
                33.5667353
              ],
              [
                51.4533157,
                33.5688299
              ],
              [
                51.4462795,
                33.5705917
              ],
              [
                51.4381746,
                33.5722902
              ],
              [
                51.4323359,
                33.5734041
              ],
              [
                51.4274925,
                33.5744093
              ],
              [
                51.4249544,
                33.5757583
              ],
              [
                51.4182609,
                33.5775549
              ],
              [
                51.4134173,
                33.5752021
              ],
              [
                51.4082991,
                33.5725867
              ],
              [
                51.3876485,
                33.5619596
              ],
              [
                51.3815975,
                33.5601001
              ],
              [
                51.3766347,
                33.557021
              ],
              [
                51.3675642,
                33.5536627
              ],
              [
                51.3638958,
                33.5516847
              ],
              [
                51.3586505,
                33.5502166
              ],
              [
                51.3534528,
                33.5477953
              ],
              [
                51.3501494,
                33.5469727
              ],
              [
                51.3366651,
                33.5426824
              ],
              [
                51.3320732,
                33.537925
              ],
              [
                51.3283986,
                33.5309122
              ],
              [
                51.3225404,
                33.5196936
              ],
              [
                51.3191641,
                33.5152326
              ],
              [
                51.3062756,
                33.5083822
              ],
              [
                51.295482,
                33.5033366
              ],
              [
                51.2867855,
                33.5007601
              ],
              [
                51.2763161,
                33.5015329
              ],
              [
                51.2682346,
                33.5018487
              ],
              [
                51.264271,
                33.5021349
              ],
              [
                51.2611174,
                33.5025653
              ],
              [
                51.2580572,
                33.5026012
              ],
              [
                51.2551283,
                33.5026958
              ],
              [
                51.250747,
                33.5035546
              ],
              [
                51.2449719,
                33.5057491
              ],
              [
                51.2387249,
                33.5080457
              ],
              [
                51.2286144,
                33.5111598
              ],
              [
                51.2148837,
                33.5142371
              ],
              [
                51.2027208,
                33.5134434
              ],
              [
                51.1902202,
                33.5115112
              ],
              [
                51.1799811,
                33.5095541
              ],
              [
                51.1727897,
                33.5100653
              ],
              [
                51.1675107,
                33.5118463
              ],
              [
                51.1634714,
                33.5154179
              ],
              [
                51.1529445,
                33.5226496
              ],
              [
                51.145563,
                33.5260841
              ],
              [
                51.1266866,
                33.5338775
              ],
              [
                51.1148445,
                33.5392153
              ],
              [
                51.1062671,
                33.5437875
              ],
              [
                51.0992145,
                33.5484053
              ],
              [
                51.0882748,
                33.5562671
              ],
              [
                51.0813975,
                33.5622073
              ],
              [
                51.0724353,
                33.5719364
              ],
              [
                51.0646559,
                33.5820005
              ],
              [
                51.050925,
                33.5957727
              ],
              [
                51.0469148,
                33.6001633
              ],
              [
                51.0438023,
                33.602594
              ],
              [
                51.0389299,
                33.6054189
              ],
              [
                51.0299844,
                33.6123824
              ],
              [
                51.0231179,
                33.6201226
              ],
              [
                51.0120372,
                33.6311631
              ],
              [
                51.0086481,
                33.635936
              ],
              [
                51.0016992,
                33.6421996
              ],
              [
                50.9996899,
                33.6487694
              ],
              [
                50.9779614,
                33.6732504
              ],
              [
                50.9571301,
                33.6970013
              ],
              [
                50.9474958,
                33.7080097
              ],
              [
                50.9478588,
                33.7121344
              ],
              [
                50.9495537,
                33.7182472
              ],
              [
                50.9507274,
                33.7229834
              ],
              [
                50.9518321,
                33.7313269
              ],
              [
                50.9526157,
                33.7433979
              ],
              [
                50.9543213,
                33.7484194
              ],
              [
                50.9482521,
                33.7492101
              ],
              [
                50.9338727,
                33.7476744
              ],
              [
                50.9214387,
                33.7466678
              ],
              [
                50.9124469,
                33.7453249
              ],
              [
                50.9015785,
                33.7446867
              ],
              [
                50.8959802,
                33.7439878
              ],
              [
                50.8825913,
                33.7441027
              ],
              [
                50.8778516,
                33.743252
              ],
              [
                50.8716359,
                33.7431807
              ],
              [
                50.8536554,
                33.7448993
              ],
              [
                50.8420302,
                33.7452383
              ],
              [
                50.8265743,
                33.7448106
              ],
              [
                50.8163634,
                33.7452782
              ],
              [
                50.8052503,
                33.744247
              ],
              [
                50.7971713,
                33.7431051
              ],
              [
                50.7831042,
                33.7399867
              ],
              [
                50.7743551,
                33.7363822
              ],
              [
                50.7693353,
                33.7340924
              ],
              [
                50.7633949,
                33.7312016
              ],
              [
                50.7592516,
                33.7290434
              ],
              [
                50.7571071,
                33.727937
              ],
              [
                50.7584613,
                33.7240969
              ],
              [
                50.7548479,
                33.7232574
              ],
              [
                50.7540145,
                33.7235373
              ],
              [
                50.752628,
                33.7235372
              ],
              [
                50.7520714,
                33.7238171
              ],
              [
                50.7445714,
                33.7238171
              ],
              [
                50.7442913,
                33.7240969
              ],
              [
                50.7420715,
                33.7243677
              ],
              [
                50.7381815,
                33.7243677
              ],
              [
                50.7379048,
                33.7246476
              ],
              [
                50.7370715,
                33.7246476
              ],
              [
                50.7351249,
                33.7252073
              ],
              [
                50.7337381,
                33.7252073
              ],
              [
                50.7304016,
                33.7263176
              ],
              [
                50.7292916,
                33.7263176
              ],
              [
                50.7242917,
                33.7277079
              ],
              [
                50.7187351,
                33.7277078
              ],
              [
                50.7156818,
                33.7265975
              ],
              [
                50.7040117,
                33.7271481
              ],
              [
                50.7006785,
                33.7263176
              ],
              [
                50.6904021,
                33.7207657
              ],
              [
                50.6595661,
                33.6965903
              ],
              [
                50.6556757,
                33.6957598
              ],
              [
                50.6465095,
                33.691869
              ],
              [
                50.6426227,
                33.6896482
              ],
              [
                50.6290095,
                33.6796457
              ],
              [
                50.6128964,
                33.671873
              ],
              [
                50.61151,
                33.6707627
              ],
              [
                50.6095631,
                33.6699231
              ],
              [
                50.6084534,
                33.6690925
              ],
              [
                50.6070631,
                33.6685419
              ],
              [
                50.5956733,
                33.6621504
              ],
              [
                50.5934535,
                33.6604803
              ],
              [
                50.5881736,
                33.6549283
              ],
              [
                50.5876201,
                33.6546484
              ],
              [
                50.5873409,
                33.6543677
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555106,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شهرضا",
          "name:en": "Shahreza County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277880",
          "wikipedia": "fa:شهرستان شهرضا"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.6160027,
                31.7537722
              ],
              [
                51.6162795,
                31.7532124
              ],
              [
                51.6176693,
                31.7515511
              ],
              [
                51.6773954,
                31.6862742
              ],
              [
                51.6890618,
                31.6695984
              ],
              [
                51.6971184,
                31.6557127
              ],
              [
                51.7046184,
                31.6493204
              ],
              [
                51.7060049,
                31.6484899
              ],
              [
                51.7065616,
                31.6479391
              ],
              [
                51.7134893,
                31.6449675
              ],
              [
                51.7146738,
                31.6443757
              ],
              [
                51.7163472,
                31.6432406
              ],
              [
                51.7171182,
                31.6426575
              ],
              [
                51.7176749,
                31.6423866
              ],
              [
                51.7226748,
                31.6382155
              ],
              [
                51.7293413,
                31.6315525
              ],
              [
                51.7337845,
                31.6279321
              ],
              [
                51.7482577,
                31.6163358
              ],
              [
                51.7283511,
                31.5676204
              ],
              [
                51.7265614,
                31.5623773
              ],
              [
                51.7229515,
                31.5551547
              ],
              [
                51.7226749,
                31.5537643
              ],
              [
                51.7215615,
                31.5507128
              ],
              [
                51.7204516,
                31.5462619
              ],
              [
                51.7201749,
                31.5457112
              ],
              [
                51.719895,
                31.5384886
              ],
              [
                51.7237848,
                31.5212629
              ],
              [
                51.7246181,
                31.5196017
              ],
              [
                51.7298948,
                31.5054365
              ],
              [
                51.730728,
                31.5043171
              ],
              [
                51.7407313,
                31.4784877
              ],
              [
                51.7410079,
                31.477937
              ],
              [
                51.7410079,
                31.4776571
              ],
              [
                51.7410079,
                31.4773772
              ],
              [
                51.7412847,
                31.4770974
              ],
              [
                51.7412847,
                31.4765467
              ],
              [
                51.7523978,
                31.4526496
              ],
              [
                51.7762876,
                31.4173684
              ],
              [
                51.8026771,
                31.3954309
              ],
              [
                51.8085105,
                31.3929302
              ],
              [
                51.8129571,
                31.3915399
              ],
              [
                51.8312902,
                31.3873691
              ],
              [
                51.8360135,
                31.3868184
              ],
              [
                51.8390667,
                31.3868184
              ],
              [
                51.84018,
                31.3865385
              ],
              [
                51.8435133,
                31.3862677
              ],
              [
                51.8582364,
                31.3868184
              ],
              [
                51.8693464,
                31.3893191
              ],
              [
                51.8754596,
                31.3912601
              ],
              [
                51.8968493,
                31.3973719
              ],
              [
                51.9115723,
                31.4037636
              ],
              [
                51.9168491,
                31.4059845
              ],
              [
                51.9210155,
                31.4076546
              ],
              [
                51.9218489,
                31.4076546
              ],
              [
                51.9249054,
                31.4090449
              ],
              [
                51.9346286,
                31.4123762
              ],
              [
                51.9365721,
                31.4123762
              ],
              [
                51.936572,
                31.412656
              ],
              [
                51.9365721,
                31.4134866
              ],
              [
                51.937682,
                31.414597
              ],
              [
                51.9379619,
                31.4154276
              ],
              [
                51.9387953,
                31.4159873
              ],
              [
                51.9804646,
                31.4890417
              ],
              [
                51.9837981,
                31.4943231
              ],
              [
                51.9882412,
                31.5023762
              ],
              [
                51.9987977,
                31.525434
              ],
              [
                52.0029644,
                31.5362679
              ],
              [
                52.0079642,
                31.5459912
              ],
              [
                52.0096309,
                31.5484921
              ],
              [
                52.0104641,
                31.5504331
              ],
              [
                52.0463004,
                31.59571
              ],
              [
                52.0726898,
                31.6171074
              ],
              [
                52.0782466,
                31.6207096
              ],
              [
                52.1304691,
                31.6565526
              ],
              [
                52.1340824,
                31.6579341
              ],
              [
                52.1426924,
                31.6604349
              ],
              [
                52.1440822,
                31.6609947
              ],
              [
                52.1449156,
                31.6609947
              ],
              [
                52.1463021,
                31.6615454
              ],
              [
                52.1863049,
                31.6673778
              ],
              [
                52.1904715,
                31.6679376
              ],
              [
                52.1918616,
                31.6679376
              ],
              [
                52.1926948,
                31.6682175
              ],
              [
                52.1943615,
                31.6682175
              ],
              [
                52.2007514,
                31.669328
              ],
              [
                52.2013047,
                31.669328
              ],
              [
                52.2020993,
                31.6696399
              ],
              [
                52.2032233,
                31.6692013
              ],
              [
                52.2043615,
                31.6743298
              ],
              [
                52.2090846,
                31.6832139
              ],
              [
                52.2093613,
                31.6865455
              ],
              [
                52.2096415,
                31.6879358
              ],
              [
                52.208808,
                31.6904368
              ],
              [
                52.208808,
                31.6909965
              ],
              [
                52.2068613,
                31.6926578
              ],
              [
                52.2068613,
                31.6929377
              ],
              [
                52.2060281,
                31.6934884
              ],
              [
                52.195195,
                31.7023815
              ],
              [
                52.1832483,
                31.7101551
              ],
              [
                52.1824149,
                31.7109948
              ],
              [
                52.1796384,
                31.7134957
              ],
              [
                52.1740817,
                31.7193282
              ],
              [
                52.1554721,
                31.7426582
              ],
              [
                52.1535253,
                31.7446084
              ],
              [
                52.1337477,
                31.7835198
              ],
              [
                52.1328894,
                31.7876167
              ],
              [
                52.0876562,
                31.808597
              ],
              [
                52.065222,
                31.819312
              ],
              [
                52.0551687,
                31.8241303
              ],
              [
                52.043935,
                31.830016
              ],
              [
                52.0361918,
                31.8345431
              ],
              [
                52.0218018,
                31.8469963
              ],
              [
                51.9961271,
                31.870134
              ],
              [
                51.9787975,
                31.8863549
              ],
              [
                51.9490696,
                31.9135998
              ],
              [
                51.9334925,
                31.9270453
              ],
              [
                51.921745,
                31.9378051
              ],
              [
                51.9098853,
                31.9504145
              ],
              [
                51.9071387,
                31.9550753
              ],
              [
                51.9060179,
                31.9612551
              ],
              [
                51.9060487,
                31.9666928
              ],
              [
                51.9104089,
                31.9801844
              ],
              [
                51.9140053,
                31.9919925
              ],
              [
                51.9166203,
                31.9992778
              ],
              [
                51.9273601,
                32.0075055
              ],
              [
                51.9409046,
                32.0164608
              ],
              [
                51.9537944,
                32.0240537
              ],
              [
                51.9614802,
                32.028477
              ],
              [
                51.9706492,
                32.0350049
              ],
              [
                51.987894,
                32.0424115
              ],
              [
                52.0051903,
                32.0512648
              ],
              [
                52.0012972,
                32.0882242
              ],
              [
                52.0010204,
                32.088784
              ],
              [
                51.9965738,
                32.1104451
              ],
              [
                51.9951837,
                32.1146166
              ],
              [
                51.9940738,
                32.1173886
              ],
              [
                51.9868506,
                32.1460023
              ],
              [
                51.9862972,
                32.1510046
              ],
              [
                51.9860172,
                32.1546163
              ],
              [
                51.9882406,
                32.1751669
              ],
              [
                51.9887973,
                32.1771173
              ],
              [
                51.9893505,
                32.1871127
              ],
              [
                51.9882406,
                32.1943362
              ],
              [
                51.9851839,
                32.2046116
              ],
              [
                51.9824073,
                32.2110043
              ],
              [
                51.9757407,
                32.2182278
              ],
              [
                51.9646274,
                32.2346161
              ],
              [
                51.9624075,
                32.237677
              ],
              [
                51.9601842,
                32.2426703
              ],
              [
                51.9590741,
                32.2504445
              ],
              [
                51.9590741,
                32.269334
              ],
              [
                51.958794,
                32.2707245
              ],
              [
                51.9585175,
                32.2754469
              ],
              [
                51.9582409,
                32.2793385
              ],
              [
                51.953445,
                32.2990725
              ],
              [
                51.9486308,
                32.3082176
              ],
              [
                51.9418643,
                32.3180099
              ],
              [
                51.9312611,
                32.3307151
              ],
              [
                51.9210088,
                32.3384749
              ],
              [
                51.9010591,
                32.3484366
              ],
              [
                51.8844794,
                32.3606784
              ],
              [
                51.8725346,
                32.3667729
              ],
              [
                51.8650817,
                32.3711904
              ],
              [
                51.8544678,
                32.379959
              ],
              [
                51.831893,
                32.3912958
              ],
              [
                51.8145994,
                32.3927172
              ],
              [
                51.8037567,
                32.3902831
              ],
              [
                51.7889138,
                32.38879
              ],
              [
                51.7830088,
                32.3880819
              ],
              [
                51.7707375,
                32.387502
              ],
              [
                51.7613704,
                32.3871681
              ],
              [
                51.7532961,
                32.3864199
              ],
              [
                51.741743,
                32.3844658
              ],
              [
                51.7344571,
                32.3833856
              ],
              [
                51.7263337,
                32.3840018
              ],
              [
                51.7098179,
                32.3860446
              ],
              [
                51.70372,
                32.3860501
              ],
              [
                51.6893005,
                32.3846004
              ],
              [
                51.6816432,
                32.3830155
              ],
              [
                51.6786032,
                32.3816122
              ],
              [
                51.672,
                32.3762611
              ],
              [
                51.6682234,
                32.3725742
              ],
              [
                51.665794,
                32.368432
              ],
              [
                51.6642573,
                32.3649813
              ],
              [
                51.6624607,
                32.3577482
              ],
              [
                51.661562,
                32.352178
              ],
              [
                51.6720882,
                32.3484094
              ],
              [
                51.6759674,
                32.3461196
              ],
              [
                51.6843539,
                32.3421505
              ],
              [
                51.6885978,
                32.3390526
              ],
              [
                51.6954203,
                32.3325257
              ],
              [
                51.7055143,
                32.3222533
              ],
              [
                51.6921113,
                32.3190957
              ],
              [
                51.6883027,
                32.3177402
              ],
              [
                51.6806611,
                32.311505
              ],
              [
                51.6756031,
                32.307358
              ],
              [
                51.6707962,
                32.2968351
              ],
              [
                51.6675157,
                32.2872193
              ],
              [
                51.6639846,
                32.2777868
              ],
              [
                51.6674136,
                32.2753047
              ],
              [
                51.6718258,
                32.2694293
              ],
              [
                51.6755675,
                32.2662331
              ],
              [
                51.6807174,
                32.2612978
              ],
              [
                51.6867255,
                32.2548379
              ],
              [
                51.6955661,
                32.2494664
              ],
              [
                51.6999435,
                32.2418441
              ],
              [
                51.7166965,
                32.2171169
              ],
              [
                51.7334662,
                32.1923246
              ],
              [
                51.742581,
                32.1818315
              ],
              [
                51.7497516,
                32.171814
              ],
              [
                51.7579275,
                32.1659399
              ],
              [
                51.7629542,
                32.1579215
              ],
              [
                51.7649834,
                32.1533395
              ],
              [
                51.7671215,
                32.1495412
              ],
              [
                51.7688655,
                32.1468754
              ],
              [
                51.7710413,
                32.1442329
              ],
              [
                51.7761483,
                32.1386947
              ],
              [
                51.7804535,
                32.1308063
              ],
              [
                51.7812879,
                32.1226706
              ],
              [
                51.7824512,
                32.1154852
              ],
              [
                51.7826909,
                32.1112008
              ],
              [
                51.7831821,
                32.103636
              ],
              [
                51.783608,
                32.0928361
              ],
              [
                51.7840801,
                32.0866372
              ],
              [
                51.7843076,
                32.0800878
              ],
              [
                51.7845971,
                32.072938
              ],
              [
                51.7847892,
                32.0684525
              ],
              [
                51.7846605,
                32.0642711
              ],
              [
                51.7861944,
                32.0590118
              ],
              [
                51.7891018,
                32.0458637
              ],
              [
                51.7887782,
                32.0376936
              ],
              [
                51.7890357,
                32.0322365
              ],
              [
                51.7885207,
                32.0270702
              ],
              [
                51.7865634,
                32.0237827
              ],
              [
                51.7834384,
                32.0173979
              ],
              [
                51.7718568,
                32.0050322
              ],
              [
                51.7578622,
                31.9985426
              ],
              [
                51.760644,
                31.992977
              ],
              [
                51.7605141,
                31.9808513
              ],
              [
                51.764218,
                31.967606
              ],
              [
                51.7675283,
                31.9614498
              ],
              [
                51.7869871,
                31.9374448
              ],
              [
                51.7931001,
                31.9286129
              ],
              [
                51.7937867,
                31.9232168
              ],
              [
                51.7943434,
                31.9143324
              ],
              [
                51.7946202,
                31.9121022
              ],
              [
                51.7943435,
                31.9110007
              ],
              [
                51.7907944,
                31.8736284
              ],
              [
                51.7880228,
                31.8505543
              ],
              [
                51.7869999,
                31.8418554
              ],
              [
                51.7856882,
                31.8297528
              ],
              [
                51.7836916,
                31.8136306
              ],
              [
                51.7822652,
                31.8004887
              ],
              [
                51.7805082,
                31.7861019
              ],
              [
                51.7721204,
                31.7834948
              ],
              [
                51.7696207,
                31.7832149
              ],
              [
                51.7682306,
                31.7829441
              ],
              [
                51.7543408,
                31.7779422
              ],
              [
                51.7532309,
                31.7779421
              ],
              [
                51.7529541,
                31.7776623
              ],
              [
                51.7446176,
                31.7754412
              ],
              [
                51.742951,
                31.7754412
              ],
              [
                51.7418409,
                31.7751614
              ],
              [
                51.7385078,
                31.7751613
              ],
              [
                51.7371177,
                31.7748814
              ],
              [
                51.7271179,
                31.7732201
              ],
              [
                51.7257278,
                31.7726604
              ],
              [
                51.7148946,
                31.7707192
              ],
              [
                51.713228,
                31.7707191
              ],
              [
                51.7123948,
                31.7704393
              ],
              [
                51.7085049,
                31.7704393
              ],
              [
                51.7076714,
                31.7701593
              ],
              [
                51.7054515,
                31.7701594
              ],
              [
                51.7035049,
                31.7698794
              ],
              [
                51.6701721,
                31.7651574
              ],
              [
                51.6637821,
                31.7640559
              ],
              [
                51.6629487,
                31.7640559
              ],
              [
                51.6515588,
                31.7623856
              ],
              [
                51.650169,
                31.7618258
              ],
              [
                51.6493355,
                31.7618258
              ],
              [
                51.6440591,
                31.7607153
              ],
              [
                51.642669,
                31.7607153
              ],
              [
                51.6421157,
                31.7604354
              ],
              [
                51.6407258,
                31.7604354
              ],
              [
                51.6260027,
                31.7579434
              ],
              [
                51.6179461,
                31.7551626
              ],
              [
                51.6160027,
                31.7537722
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555134,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فریدن",
          "name:en": "Fereydan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1285314",
          "wikipedia": "fa:شهرستان فریدن"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.1880219,
                33.0303214
              ],
              [
                50.1887134,
                33.0299097
              ],
              [
                50.1898231,
                33.0299097
              ],
              [
                50.1901032,
                33.0296297
              ],
              [
                50.2014897,
                33.0265779
              ],
              [
                50.2253828,
                33.013522
              ],
              [
                50.225936,
                33.0126823
              ],
              [
                50.2303825,
                33.005468
              ],
              [
                50.2342694,
                33.0002131
              ],
              [
                50.2337159,
                32.9935226
              ],
              [
                50.2339928,
                32.9910215
              ],
              [
                50.2342694,
                32.9888003
              ],
              [
                50.234826,
                32.98713
              ],
              [
                50.2398259,
                32.9707421
              ],
              [
                50.2403829,
                32.9679611
              ],
              [
                50.2406594,
                32.9674104
              ],
              [
                50.2423259,
                32.9579659
              ],
              [
                50.242606,
                32.955185
              ],
              [
                50.2428826,
                32.9518532
              ],
              [
                50.2431591,
                32.9510225
              ],
              [
                50.2428825,
                32.949632
              ],
              [
                50.2431591,
                32.9490813
              ],
              [
                50.2431591,
                32.9460203
              ],
              [
                50.2431591,
                32.9454605
              ],
              [
                50.2428826,
                32.9362959
              ],
              [
                50.2437162,
                32.9290726
              ],
              [
                50.2439927,
                32.9274022
              ],
              [
                50.2476062,
                32.9229598
              ],
              [
                50.2517726,
                32.9146349
              ],
              [
                50.2526059,
                32.9137953
              ],
              [
                50.2545493,
                32.9099036
              ],
              [
                50.255106,
                32.9093528
              ],
              [
                50.2562157,
                32.9074116
              ],
              [
                50.2706626,
                32.8910236
              ],
              [
                50.2803858,
                32.8826806
              ],
              [
                50.2887188,
                32.8799086
              ],
              [
                50.2892723,
                32.8793488
              ],
              [
                50.289829,
                32.8793488
              ],
              [
                50.2948286,
                32.8768477
              ],
              [
                50.2953852,
                32.8768477
              ],
              [
                50.2953853,
                32.8765678
              ],
              [
                50.2967755,
                32.8760171
              ],
              [
                50.2970521,
                32.8757372
              ],
              [
                50.2976088,
                32.8757371
              ],
              [
                50.3020523,
                32.873516
              ],
              [
                50.3037186,
                32.8721254
              ],
              [
                50.3078852,
                32.8679629
              ],
              [
                50.3081621,
                32.8671323
              ],
              [
                50.3087188,
                32.8665724
              ],
              [
                50.3087187,
                32.8660126
              ],
              [
                50.3098286,
                32.8638005
              ],
              [
                50.3106617,
                32.8629608
              ],
              [
                50.315942,
                32.8515749
              ],
              [
                50.3167752,
                32.8499045
              ],
              [
                50.3206651,
                32.8368482
              ],
              [
                50.3206651,
                32.8354576
              ],
              [
                50.3212187,
                32.8321258
              ],
              [
                50.3214984,
                32.8299046
              ],
              [
                50.3217754,
                32.8274035
              ],
              [
                50.3220519,
                32.8265728
              ],
              [
                50.3206652,
                32.7896249
              ],
              [
                50.3203852,
                32.7887942
              ],
              [
                50.3187188,
                32.7840718
              ],
              [
                50.3206653,
                32.7832322
              ],
              [
                50.352055,
                32.7593496
              ],
              [
                50.3576117,
                32.7485144
              ],
              [
                50.3578883,
                32.7487943
              ],
              [
                50.369278,
                32.7546272
              ],
              [
                50.3706647,
                32.7546272
              ],
              [
                50.3712214,
                32.7549072
              ],
              [
                50.3728878,
                32.7549072
              ],
              [
                50.3734445,
                32.755178
              ],
              [
                50.3826111,
                32.7549072
              ],
              [
                50.3831677,
                32.7549072
              ],
              [
                50.3840013,
                32.7551781
              ],
              [
                50.3920578,
                32.7549071
              ],
              [
                50.3951109,
                32.7551781
              ],
              [
                50.3956676,
                32.755458
              ],
              [
                50.402611,
                32.755458
              ],
              [
                50.4317803,
                32.7601804
              ],
              [
                50.432614,
                32.7604603
              ],
              [
                50.4365039,
                32.7604603
              ],
              [
                50.4417805,
                32.7599095
              ],
              [
                50.4426138,
                32.7596296
              ],
              [
                50.4448369,
                32.7596297
              ],
              [
                50.4451138,
                32.7593497
              ],
              [
                50.4481702,
                32.7593498
              ],
              [
                50.4484471,
                32.7596296
              ],
              [
                50.4515034,
                32.7596296
              ],
              [
                50.4517804,
                32.7599096
              ],
              [
                50.4526136,
                32.7599096
              ],
              [
                50.4553937,
                32.7632324
              ],
              [
                50.4556703,
                32.7649028
              ],
              [
                50.4556703,
                32.7654626
              ],
              [
                50.4556703,
                32.7765687
              ],
              [
                50.4553937,
                32.7771285
              ],
              [
                50.4551136,
                32.7793498
              ],
              [
                50.454837,
                32.7851826
              ],
              [
                50.454837,
                32.7868531
              ],
              [
                50.4642802,
                32.8012909
              ],
              [
                50.4648368,
                32.8018508
              ],
              [
                50.4681701,
                32.8071329
              ],
              [
                50.4751167,
                32.8229613
              ],
              [
                50.4762265,
                32.8335165
              ],
              [
                50.4759499,
                32.8343472
              ],
              [
                50.4756698,
                32.837959
              ],
              [
                50.4753932,
                32.8382389
              ],
              [
                50.4751166,
                32.8401892
              ],
              [
                50.4748365,
                32.8449025
              ],
              [
                50.47456,
                32.8482343
              ],
              [
                50.4737263,
                32.8526857
              ],
              [
                50.4726165,
                32.8582386
              ],
              [
                50.4723365,
                32.8593492
              ],
              [
                50.4723365,
                32.8599091
              ],
              [
                50.4659465,
                32.8779676
              ],
              [
                50.4673364,
                32.8896243
              ],
              [
                50.4676164,
                32.890744
              ],
              [
                50.4673363,
                32.8912947
              ],
              [
                50.4670598,
                32.8946265
              ],
              [
                50.4667832,
                32.896297
              ],
              [
                50.4651131,
                32.9024097
              ],
              [
                50.46206,
                32.9060214
              ],
              [
                50.4548368,
                32.9076827
              ],
              [
                50.4915063,
                32.937127
              ],
              [
                50.492616,
                32.9379576
              ],
              [
                50.4940059,
                32.9393572
              ],
              [
                50.4970595,
                32.9424091
              ],
              [
                50.501506,
                32.9482419
              ],
              [
                50.5112293,
                32.9637991
              ],
              [
                50.5115058,
                32.9635192
              ],
              [
                50.5165059,
                32.9635192
              ],
              [
                50.5345622,
                32.9576864
              ],
              [
                50.5370621,
                32.9571356
              ],
              [
                50.547062,
                32.9543547
              ],
              [
                50.5476808,
                32.9555896
              ],
              [
                50.5467854,
                32.9557452
              ],
              [
                50.5456752,
                32.9560159
              ],
              [
                50.5473421,
                32.9596277
              ],
              [
                50.547342,
                32.9599076
              ],
              [
                50.5759515,
                32.9860198
              ],
              [
                50.5920648,
                32.9996267
              ],
              [
                50.5942878,
                33.0076897
              ],
              [
                50.5945647,
                33.0099109
              ],
              [
                50.5984546,
                33.0182447
              ],
              [
                50.5990113,
                33.0190754
              ],
              [
                50.6309541,
                33.0588031
              ],
              [
                50.6310964,
                33.059083
              ],
              [
                50.6312341,
                33.0593539
              ],
              [
                50.6315107,
                33.0596337
              ],
              [
                50.6320673,
                33.0657464
              ],
              [
                50.6317873,
                33.0660263
              ],
              [
                50.628734,
                33.0738003
              ],
              [
                50.6281774,
                33.0743511
              ],
              [
                50.6281774,
                33.0746309
              ],
              [
                50.6267876,
                33.0765812
              ],
              [
                50.6028975,
                33.1065844
              ],
              [
                50.6017878,
                33.1082457
              ],
              [
                50.6012311,
                33.1093562
              ],
              [
                50.6012312,
                33.1101869
              ],
              [
                50.6009542,
                33.1104667
              ],
              [
                50.6009541,
                33.1118573
              ],
              [
                50.6003975,
                33.1115773
              ],
              [
                50.5990111,
                33.1115773
              ],
              [
                50.5848413,
                33.1185205
              ],
              [
                50.5845644,
                33.1188004
              ],
              [
                50.5456749,
                33.1376979
              ],
              [
                50.5442851,
                33.1376979
              ],
              [
                50.5440085,
                33.1379687
              ],
              [
                50.5428951,
                33.1379687
              ],
              [
                50.5384517,
                33.1343572
              ],
              [
                50.5362286,
                33.1313054
              ],
              [
                50.5315051,
                33.1221321
              ],
              [
                50.530952,
                33.1207506
              ],
              [
                50.5276187,
                33.1110265
              ],
              [
                50.5273386,
                33.1087963
              ],
              [
                50.5181721,
                33.0910274
              ],
              [
                50.5103958,
                33.0851856
              ],
              [
                50.5098387,
                33.0849148
              ],
              [
                50.4962255,
                33.0815831
              ],
              [
                50.4956724,
                33.0813032
              ],
              [
                50.4940056,
                33.0813032
              ],
              [
                50.493449,
                33.0810233
              ],
              [
                50.4865059,
                33.0810232
              ],
              [
                50.4859492,
                33.0807433
              ],
              [
                50.4817827,
                33.0807433
              ],
              [
                50.4812261,
                33.0810233
              ],
              [
                50.4784495,
                33.0810233
              ],
              [
                50.4778928,
                33.0813032
              ],
              [
                50.4765026,
                33.0813032
              ],
              [
                50.4742825,
                33.0818539
              ],
              [
                50.4726161,
                33.0826936
              ],
              [
                50.4717829,
                33.0826935
              ],
              [
                50.4667828,
                33.0857454
              ],
              [
                50.4665027,
                33.0860252
              ],
              [
                50.42428,
                33.1135274
              ],
              [
                50.4237233,
                33.1135273
              ],
              [
                50.4231666,
                33.1140781
              ],
              [
                50.3859435,
                33.1396298
              ],
              [
                50.3853869,
                33.1399098
              ],
              [
                50.3623306,
                33.1521347
              ],
              [
                50.3617775,
                33.1526945
              ],
              [
                50.357611,
                33.1543558
              ],
              [
                50.3289979,
                33.1721335
              ],
              [
                50.3287178,
                33.1724135
              ],
              [
                50.3287178,
                33.1721335
              ],
              [
                50.3278846,
                33.1707431
              ],
              [
                50.3251081,
                33.1576965
              ],
              [
                50.3248311,
                33.1549156
              ],
              [
                50.3228846,
                33.1382483
              ],
              [
                50.3228846,
                33.136578
              ],
              [
                50.322608,
                33.1362981
              ],
              [
                50.3184416,
                33.1235222
              ],
              [
                50.315665,
                33.1188001
              ],
              [
                50.2989951,
                33.1032433
              ],
              [
                50.2973282,
                33.1021326
              ],
              [
                50.2470492,
                33.0754611
              ],
              [
                50.2437159,
                33.0737998
              ],
              [
                50.2337158,
                33.0690776
              ],
              [
                50.233436,
                33.0685178
              ],
              [
                50.2067695,
                33.0496291
              ],
              [
                50.2062128,
                33.0490783
              ],
              [
                50.2059363,
                33.0487985
              ],
              [
                50.2053797,
                33.0485185
              ],
              [
                50.1880219,
                33.0303214
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555135,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فریدون شهر",
          "name:en": "Fereydunshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q946746",
          "wikipedia": "fa:شهرستان فریدون‌شهر"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.6498081,
                32.9717615
              ],
              [
                49.6500226,
                32.9700494
              ],
              [
                49.6498319,
                32.9688363
              ],
              [
                49.6498418,
                32.9672634
              ],
              [
                49.6518802,
                32.965626
              ],
              [
                49.6533512,
                32.9636742
              ],
              [
                49.6550773,
                32.9443491
              ],
              [
                49.6559105,
                32.9432385
              ],
              [
                49.6581336,
                32.9385162
              ],
              [
                49.6584106,
                32.9374057
              ],
              [
                49.6586902,
                32.936575
              ],
              [
                49.6589672,
                32.9326834
              ],
              [
                49.6614668,
                32.9299115
              ],
              [
                49.662577,
                32.9299114
              ],
              [
                49.662577,
                32.9296316
              ],
              [
                49.6634102,
                32.9296315
              ],
              [
                49.6636903,
                32.9293516
              ],
              [
                49.6642435,
                32.9293517
              ],
              [
                49.6650771,
                32.9279612
              ],
              [
                49.6659103,
                32.9254601
              ],
              [
                49.6667435,
                32.9240786
              ],
              [
                49.6673002,
                32.9232389
              ],
              [
                49.6706335,
                32.9210177
              ],
              [
                49.6714671,
                32.9210177
              ],
              [
                49.6761902,
                32.9162955
              ],
              [
                49.6775801,
                32.9137944
              ],
              [
                49.6781336,
                32.9135145
              ],
              [
                49.6785358,
                32.9127921
              ],
              [
                49.6809134,
                32.9085214
              ],
              [
                49.6803568,
                32.9024085
              ],
              [
                49.6809134,
                32.9015689
              ],
              [
                49.6809133,
                32.9007381
              ],
              [
                49.6814669,
                32.9001873
              ],
              [
                49.6823002,
                32.8990767
              ],
              [
                49.6867467,
                32.8971265
              ],
              [
                49.6881335,
                32.8971264
              ],
              [
                49.6881335,
                32.8968466
              ],
              [
                49.7000799,
                32.8937947
              ],
              [
                49.7028564,
                32.8932439
              ],
              [
                49.7031365,
                32.892964
              ],
              [
                49.7036901,
                32.892964
              ],
              [
                49.70369,
                32.8926841
              ],
              [
                49.7042467,
                32.8926841
              ],
              [
                49.7061896,
                32.8912936
              ],
              [
                49.7128598,
                32.8846301
              ],
              [
                49.71397,
                32.8840702
              ],
              [
                49.7189696,
                32.8804676
              ],
              [
                49.7195264,
                32.8799078
              ],
              [
                49.7200798,
                32.8799078
              ],
              [
                49.7203596,
                32.8796279
              ],
              [
                49.7217462,
                32.8796279
              ],
              [
                49.7284128,
                32.8760162
              ],
              [
                49.7295261,
                32.8760162
              ],
              [
                49.7323028,
                32.8749056
              ],
              [
                49.740083,
                32.8646303
              ],
              [
                49.7461929,
                32.8590773
              ],
              [
                49.7473027,
                32.8579577
              ],
              [
                49.7486925,
                32.8557365
              ],
              [
                49.7489726,
                32.8549058
              ],
              [
                49.7495262,
                32.8535154
              ],
              [
                49.7492492,
                32.8524048
              ],
              [
                49.7448026,
                32.8435199
              ],
              [
                49.7439695,
                32.8407389
              ],
              [
                49.743693,
                32.8340753
              ],
              [
                49.7439695,
                32.8332446
              ],
              [
                49.7442495,
                32.8329647
              ],
              [
                49.7453593,
                32.8299038
              ],
              [
                49.7453594,
                32.8257412
              ],
              [
                49.7453594,
                32.8251815
              ],
              [
                49.7439694,
                32.8210099
              ],
              [
                49.7370264,
                32.8143463
              ],
              [
                49.7359162,
                32.8118542
              ],
              [
                49.7359162,
                32.8115743
              ],
              [
                49.7352067,
                32.8098742
              ],
              [
                49.7350831,
                32.809344
              ],
              [
                49.7331365,
                32.8082425
              ],
              [
                49.7317497,
                32.8082425
              ],
              [
                49.7317497,
                32.8079626
              ],
              [
                49.7314696,
                32.8076826
              ],
              [
                49.7317497,
                32.8071318
              ],
              [
                49.7317497,
                32.8068519
              ],
              [
                49.7317498,
                32.806572
              ],
              [
                49.7323028,
                32.8057323
              ],
              [
                49.7528597,
                32.7762968
              ],
              [
                49.7528596,
                32.7760168
              ],
              [
                49.7531397,
                32.775737
              ],
              [
                49.767306,
                32.7640711
              ],
              [
                49.7764726,
                32.7596287
              ],
              [
                49.7773058,
                32.7596287
              ],
              [
                49.7775824,
                32.7593487
              ],
              [
                49.7831391,
                32.7593487
              ],
              [
                49.7834157,
                32.7596287
              ],
              [
                49.7850826,
                32.7596287
              ],
              [
                49.7856392,
                32.7599086
              ],
              [
                49.7906389,
                32.7604594
              ],
              [
                49.7911956,
                32.7601794
              ],
              [
                49.7942522,
                32.7599086
              ],
              [
                49.7945289,
                32.7596287
              ],
              [
                49.7950854,
                32.7596286
              ],
              [
                49.7953624,
                32.7593488
              ],
              [
                49.8011954,
                32.7557371
              ],
              [
                49.8125855,
                32.7446219
              ],
              [
                49.8267517,
                32.7396287
              ],
              [
                49.853975,
                32.7187889
              ],
              [
                49.8553648,
                32.7182382
              ],
              [
                49.8556414,
                32.7179583
              ],
              [
                49.8875878,
                32.7021208
              ],
              [
                49.8962012,
                32.6979583
              ],
              [
                49.8995345,
                32.6918454
              ],
              [
                49.8995346,
                32.6910147
              ],
              [
                49.9006444,
                32.6885136
              ],
              [
                49.9009244,
                32.6879628
              ],
              [
                49.9009244,
                32.687403
              ],
              [
                49.9028678,
                32.6837912
              ],
              [
                49.9037011,
                32.6829605
              ],
              [
                49.9039777,
                32.6821207
              ],
              [
                49.9120345,
                32.6765677
              ],
              [
                49.9350907,
                32.6676738
              ],
              [
                49.9503704,
                32.6579581
              ],
              [
                49.9662036,
                32.6443508
              ],
              [
                49.96648,
                32.6440709
              ],
              [
                49.9800229,
                32.6359868
              ],
              [
                49.9823168,
                32.6346172
              ],
              [
                49.9853699,
                32.6337864
              ],
              [
                49.9859266,
                32.6332357
              ],
              [
                49.9864833,
                32.6332357
              ],
              [
                50.00065,
                32.6285134
              ],
              [
                50.0017597,
                32.6285133
              ],
              [
                50.0023164,
                32.6282334
              ],
              [
                50.00315,
                32.6282334
              ],
              [
                50.0034265,
                32.6279535
              ],
              [
                50.0175964,
                32.6276826
              ],
              [
                50.0181495,
                32.6279535
              ],
              [
                50.0198163,
                32.6279535
              ],
              [
                50.0200964,
                32.6282334
              ],
              [
                50.0212062,
                32.6282334
              ],
              [
                50.0242628,
                32.6287933
              ],
              [
                50.024816,
                32.6287933
              ],
              [
                50.0289829,
                32.6290642
              ],
              [
                50.0348194,
                32.6287932
              ],
              [
                50.0353728,
                32.6285133
              ],
              [
                50.0370394,
                32.6285133
              ],
              [
                50.0392628,
                32.6279536
              ],
              [
                50.0420394,
                32.6274028
              ],
              [
                50.0445391,
                32.6274027
              ],
              [
                50.0448191,
                32.6276826
              ],
              [
                50.0589858,
                32.6304547
              ],
              [
                50.0744293,
                32.6390062
              ],
              [
                50.0745424,
                32.6390688
              ],
              [
                50.0837085,
                32.6415699
              ],
              [
                50.0848187,
                32.64157
              ],
              [
                50.0870418,
                32.6421207
              ],
              [
                50.0892654,
                32.6421207
              ],
              [
                50.0895419,
                32.6424007
              ],
              [
                50.0909322,
                32.6424007
              ],
              [
                50.092322,
                32.6429605
              ],
              [
                50.0928752,
                32.6429605
              ],
              [
                50.0939885,
                32.6435113
              ],
              [
                50.0948221,
                32.6435113
              ],
              [
                50.096765,
                32.644351
              ],
              [
                50.0992651,
                32.6449019
              ],
              [
                50.1034316,
                32.6462924
              ],
              [
                50.1153782,
                32.6529561
              ],
              [
                50.1253781,
                32.6604505
              ],
              [
                50.131768,
                32.6632316
              ],
              [
                50.1326013,
                32.6632316
              ],
              [
                50.1339881,
                32.6637914
              ],
              [
                50.1420444,
                32.664902
              ],
              [
                50.1456578,
                32.6651729
              ],
              [
                50.1464914,
                32.664902
              ],
              [
                50.1484344,
                32.664902
              ],
              [
                50.148991,
                32.6646222
              ],
              [
                50.1501012,
                32.6646221
              ],
              [
                50.1506579,
                32.6643422
              ],
              [
                50.151491,
                32.6643422
              ],
              [
                50.1523243,
                32.6640623
              ],
              [
                50.1537111,
                32.6637915
              ],
              [
                50.1659343,
                32.6579585
              ],
              [
                50.1859421,
                32.6424801
              ],
              [
                50.1951801,
                32.6332621
              ],
              [
                50.2093361,
                32.6209472
              ],
              [
                50.2170825,
                32.6148066
              ],
              [
                50.2209371,
                32.615457
              ],
              [
                50.2359366,
                32.6182291
              ],
              [
                50.2537166,
                32.6235113
              ],
              [
                50.2545499,
                32.6235113
              ],
              [
                50.2628832,
                32.6268523
              ],
              [
                50.2634398,
                32.6271231
              ],
              [
                50.2662164,
                32.6282338
              ],
              [
                50.2764964,
                32.6365679
              ],
              [
                50.2803863,
                32.6418502
              ],
              [
                50.2811017,
                32.6453652
              ],
              [
                50.2834394,
                32.656848
              ],
              [
                50.2845527,
                32.6615704
              ],
              [
                50.2842726,
                32.6621212
              ],
              [
                50.2842725,
                32.6624011
              ],
              [
                50.2842726,
                32.6629519
              ],
              [
                50.283996,
                32.6635117
              ],
              [
                50.2845527,
                32.6674033
              ],
              [
                50.2839961,
                32.6704553
              ],
              [
                50.2848292,
                32.6818414
              ],
              [
                50.2851058,
                32.6821213
              ],
              [
                50.2848292,
                32.682961
              ],
              [
                50.2851058,
                32.6849023
              ],
              [
                50.2848291,
                32.685733
              ],
              [
                50.2845526,
                32.6896247
              ],
              [
                50.2848292,
                32.6899046
              ],
              [
                50.2845526,
                32.6907353
              ],
              [
                50.2842726,
                32.6929565
              ],
              [
                50.283996,
                32.6960175
              ],
              [
                50.2837194,
                32.6985096
              ],
              [
                50.283996,
                32.7010108
              ],
              [
                50.2837195,
                32.7015706
              ],
              [
                50.2839959,
                32.7043426
              ],
              [
                50.2837193,
                32.7049024
              ],
              [
                50.2839959,
                32.7054622
              ],
              [
                50.2839959,
                32.7057332
              ],
              [
                50.2837194,
                32.7062929
              ],
              [
                50.2837193,
                32.7143471
              ],
              [
                50.2967758,
                32.746293
              ],
              [
                50.299829,
                32.7515752
              ],
              [
                50.300109,
                32.752126
              ],
              [
                50.3017755,
                32.7551779
              ],
              [
                50.3120522,
                32.7704646
              ],
              [
                50.3126089,
                32.7707356
              ],
              [
                50.3176085,
                32.7812999
              ],
              [
                50.3181652,
                32.7824014
              ],
              [
                50.3181652,
                32.7826813
              ],
              [
                50.3181652,
                32.7829612
              ],
              [
                50.3184421,
                32.7829613
              ],
              [
                50.3184421,
                32.7832322
              ],
              [
                50.3184421,
                32.783792
              ],
              [
                50.3187188,
                32.7840718
              ],
              [
                50.3203852,
                32.7887942
              ],
              [
                50.3206652,
                32.7896249
              ],
              [
                50.3220519,
                32.8265728
              ],
              [
                50.3217754,
                32.8274035
              ],
              [
                50.3214984,
                32.8299046
              ],
              [
                50.3212187,
                32.8321258
              ],
              [
                50.3206651,
                32.8354576
              ],
              [
                50.3206651,
                32.8368482
              ],
              [
                50.3167752,
                32.8499045
              ],
              [
                50.315942,
                32.8515749
              ],
              [
                50.3106617,
                32.8629608
              ],
              [
                50.3098286,
                32.8638005
              ],
              [
                50.3087187,
                32.8660126
              ],
              [
                50.3087188,
                32.8665724
              ],
              [
                50.3081621,
                32.8671323
              ],
              [
                50.3078852,
                32.8679629
              ],
              [
                50.3037186,
                32.8721254
              ],
              [
                50.3020523,
                32.873516
              ],
              [
                50.2976088,
                32.8757371
              ],
              [
                50.2970521,
                32.8757372
              ],
              [
                50.2967755,
                32.8760171
              ],
              [
                50.2953853,
                32.8765678
              ],
              [
                50.2953852,
                32.8768477
              ],
              [
                50.2948286,
                32.8768477
              ],
              [
                50.289829,
                32.8793488
              ],
              [
                50.2892723,
                32.8793488
              ],
              [
                50.2887188,
                32.8799086
              ],
              [
                50.2803858,
                32.8826806
              ],
              [
                50.2706626,
                32.8910236
              ],
              [
                50.2562157,
                32.9074116
              ],
              [
                50.255106,
                32.9093528
              ],
              [
                50.2545493,
                32.9099036
              ],
              [
                50.2526059,
                32.9137953
              ],
              [
                50.2517726,
                32.9146349
              ],
              [
                50.2476062,
                32.9229598
              ],
              [
                50.2439927,
                32.9274022
              ],
              [
                50.2437162,
                32.9290726
              ],
              [
                50.2428826,
                32.9362959
              ],
              [
                50.2431591,
                32.9454605
              ],
              [
                50.2431591,
                32.9460203
              ],
              [
                50.2431591,
                32.9490813
              ],
              [
                50.2428825,
                32.949632
              ],
              [
                50.2431591,
                32.9510225
              ],
              [
                50.2428826,
                32.9518532
              ],
              [
                50.242606,
                32.955185
              ],
              [
                50.2423259,
                32.9579659
              ],
              [
                50.2406594,
                32.9674104
              ],
              [
                50.2403829,
                32.9679611
              ],
              [
                50.2398259,
                32.9707421
              ],
              [
                50.234826,
                32.98713
              ],
              [
                50.2342694,
                32.9888003
              ],
              [
                50.2339928,
                32.9910215
              ],
              [
                50.2337159,
                32.9935226
              ],
              [
                50.2342694,
                33.0002131
              ],
              [
                50.2303825,
                33.005468
              ],
              [
                50.225936,
                33.0126823
              ],
              [
                50.2253828,
                33.013522
              ],
              [
                50.2014897,
                33.0265779
              ],
              [
                50.1901032,
                33.0296297
              ],
              [
                50.1898231,
                33.0299097
              ],
              [
                50.1887134,
                33.0299097
              ],
              [
                50.1880219,
                33.0303214
              ],
              [
                50.1876032,
                33.0304604
              ],
              [
                50.1870465,
                33.0304604
              ],
              [
                50.1676,
                33.0343519
              ],
              [
                50.1667668,
                33.0346318
              ],
              [
                50.1603768,
                33.0346318
              ],
              [
                50.1598238,
                33.0343519
              ],
              [
                50.1581569,
                33.0343519
              ],
              [
                50.1573237,
                33.0340811
              ],
              [
                50.1553771,
                33.0335212
              ],
              [
                50.1548236,
                33.0332413
              ],
              [
                50.1537103,
                33.0332413
              ],
              [
                50.1473238,
                33.0301895
              ],
              [
                50.1387104,
                33.0221356
              ],
              [
                50.1351006,
                33.0168536
              ],
              [
                50.1289872,
                33.0040774
              ],
              [
                50.1267673,
                33.0001588
              ],
              [
                50.1320439,
                32.9907415
              ],
              [
                50.1312108,
                32.9849087
              ],
              [
                50.1298209,
                32.9762949
              ],
              [
                50.1267673,
                32.9740737
              ],
              [
                50.125654,
                32.9740737
              ],
              [
                50.125654,
                32.9738028
              ],
              [
                50.1248208,
                32.9738029
              ],
              [
                50.1248208,
                32.9735229
              ],
              [
                50.1242641,
                32.9735229
              ],
              [
                50.1239876,
                32.9732431
              ],
              [
                50.123431,
                32.973243
              ],
              [
                50.1214875,
                32.9724123
              ],
              [
                50.1173211,
                32.9724123
              ],
              [
                50.1145444,
                32.9724123
              ],
              [
                50.1009313,
                32.9782451
              ],
              [
                50.0981547,
                32.9787959
              ],
              [
                50.0970413,
                32.9790758
              ],
              [
                50.0964879,
                32.9790758
              ],
              [
                50.0962077,
                32.9793557
              ],
              [
                50.0953745,
                32.9793557
              ],
              [
                50.0909315,
                32.9807462
              ],
              [
                50.0895412,
                32.9807462
              ],
              [
                50.0889881,
                32.9810261
              ],
              [
                50.0817648,
                32.9815769
              ],
              [
                50.080098,
                32.9821277
              ],
              [
                50.0784316,
                32.9821277
              ],
              [
                50.077598,
                32.9824075
              ],
              [
                50.0756515,
                32.9824075
              ],
              [
                50.0748183,
                32.9821276
              ],
              [
                50.0673181,
                32.9821276
              ],
              [
                50.0670415,
                32.9824075
              ],
              [
                50.062875,
                32.9824075
              ],
              [
                50.062595,
                32.9826874
              ],
              [
                50.0573183,
                32.9849086
              ],
              [
                50.0553753,
                32.986579
              ],
              [
                50.0550952,
                32.9874096
              ],
              [
                50.051485,
                32.9929625
              ],
              [
                50.0434286,
                32.9999059
              ],
              [
                50.0328721,
                33.0101899
              ],
              [
                50.032872,
                33.0104698
              ],
              [
                50.0325955,
                33.0110206
              ],
              [
                50.0317618,
                33.0115804
              ],
              [
                50.0312053,
                33.0118603
              ],
              [
                50.0300954,
                33.0121312
              ],
              [
                50.0298777,
                33.0123488
              ],
              [
                49.9917591,
                33.0318506
              ],
              [
                49.9912024,
                33.0321305
              ],
              [
                49.9912024,
                33.0324105
              ],
              [
                49.9906493,
                33.0326903
              ],
              [
                49.9906493,
                33.0329612
              ],
              [
                49.9639796,
                33.046297
              ],
              [
                49.963426,
                33.0468568
              ],
              [
                49.960926,
                33.0476875
              ],
              [
                49.9606463,
                33.0479674
              ],
              [
                49.9600928,
                33.0479674
              ],
              [
                49.9600928,
                33.0482383
              ],
              [
                49.9584263,
                33.048798
              ],
              [
                49.9467561,
                33.0532403
              ],
              [
                49.9284233,
                33.0593529
              ],
              [
                49.9281464,
                33.0596328
              ],
              [
                49.9273132,
                33.0596328
              ],
              [
                49.9150899,
                33.0654655
              ],
              [
                49.9148102,
                33.0657454
              ],
              [
                49.9142567,
                33.0657455
              ],
              [
                49.9103668,
                33.064075
              ],
              [
                49.9095336,
                33.0638042
              ],
              [
                49.9084234,
                33.0638042
              ],
              [
                49.9070335,
                33.0632444
              ],
              [
                49.9053667,
                33.0632444
              ],
              [
                49.90481,
                33.0629645
              ],
              [
                49.9037002,
                33.0629645
              ],
              [
                49.9014767,
                33.0624138
              ],
              [
                49.9000869,
                33.0624138
              ],
              [
                49.8989771,
                33.0621339
              ],
              [
                49.8975868,
                33.0621338
              ],
              [
                49.8967536,
                33.0618539
              ],
              [
                49.8956439,
                33.0618538
              ],
              [
                49.8948102,
                33.0621338
              ],
              [
                49.8928672,
                33.0621339
              ],
              [
                49.8925872,
                33.0624137
              ],
              [
                49.8714773,
                33.069077
              ],
              [
                49.8698105,
                33.069077
              ],
              [
                49.8689773,
                33.0693569
              ],
              [
                49.8653639,
                33.069357
              ],
              [
                49.8648108,
                33.069077
              ],
              [
                49.8636975,
                33.0690771
              ],
              [
                49.8598076,
                33.0668559
              ],
              [
                49.858974,
                33.0657453
              ],
              [
                49.8570309,
                33.0629645
              ],
              [
                49.8564743,
                33.0624137
              ],
              [
                49.8542543,
                33.0571317
              ],
              [
                49.8498075,
                33.0535201
              ],
              [
                49.8489742,
                33.0535201
              ],
              [
                49.8411979,
                33.0501884
              ],
              [
                49.8398075,
                33.0501883
              ],
              [
                49.8389743,
                33.0499084
              ],
              [
                49.837308,
                33.0499084
              ],
              [
                49.8364743,
                33.0501884
              ],
              [
                49.8345314,
                33.0501883
              ],
              [
                49.8098081,
                33.0565808
              ],
              [
                49.7856386,
                33.0610231
              ],
              [
                49.7828619,
                33.0615738
              ],
              [
                49.7809149,
                33.0615738
              ],
              [
                49.7803619,
                33.0618537
              ],
              [
                49.7795286,
                33.0618537
              ],
              [
                49.7661921,
                33.0643547
              ],
              [
                49.7620255,
                33.0660251
              ],
              [
                49.7548055,
                33.0679663
              ],
              [
                49.7456354,
                33.0715779
              ],
              [
                49.7445256,
                33.0715779
              ],
              [
                49.7425822,
                33.0721377
              ],
              [
                49.7373024,
                33.073799
              ],
              [
                49.7281358,
                33.0826925
              ],
              [
                49.7261924,
                33.0835232
              ],
              [
                49.7248024,
                33.0840739
              ],
              [
                49.724246,
                33.0843539
              ],
              [
                49.722026,
                33.0843538
              ],
              [
                49.7188335,
                33.0822699
              ],
              [
                49.7178594,
                33.0815819
              ],
              [
                49.7125794,
                33.0751895
              ],
              [
                49.7036896,
                33.0715778
              ],
              [
                49.7017462,
                33.0715778
              ],
              [
                49.7011895,
                33.0718577
              ],
              [
                49.6989696,
                33.0718578
              ],
              [
                49.698413,
                33.0715778
              ],
              [
                49.6967461,
                33.0715778
              ],
              [
                49.6964695,
                33.0712979
              ],
              [
                49.6956364,
                33.0712979
              ],
              [
                49.6909129,
                33.0699075
              ],
              [
                49.685633,
                33.0663048
              ],
              [
                49.6797998,
                33.0568515
              ],
              [
                49.6717433,
                33.0512987
              ],
              [
                49.6689667,
                33.0501881
              ],
              [
                49.66591,
                33.0432448
              ],
              [
                49.6656335,
                33.040193
              ],
              [
                49.6659101,
                33.037132
              ],
              [
                49.6686902,
                33.0274078
              ],
              [
                49.6678567,
                33.0221349
              ],
              [
                49.6556337,
                33.0140719
              ],
              [
                49.6539669,
                33.0115799
              ],
              [
                49.6539669,
                33.0104693
              ],
              [
                49.6536869,
                33.0101894
              ],
              [
                49.6550771,
                33.0074084
              ],
              [
                49.6645233,
                33.0018555
              ],
              [
                49.6706333,
                32.9987947
              ],
              [
                49.6834133,
                32.9940725
              ],
              [
                49.6861899,
                32.9935218
              ],
              [
                49.6917466,
                32.9935217
              ],
              [
                49.6920232,
                32.9938017
              ],
              [
                49.6989698,
                32.9938017
              ],
              [
                49.6992463,
                32.9935218
              ],
              [
                49.699803,
                32.9935217
              ],
              [
                49.7003565,
                32.9929619
              ],
              [
                49.7009132,
                32.992962
              ],
              [
                49.7048032,
                32.9901901
              ],
              [
                49.7059128,
                32.9887995
              ],
              [
                49.7059129,
                32.9885197
              ],
              [
                49.7064696,
                32.9874091
              ],
              [
                49.7075798,
                32.9846372
              ],
              [
                49.7075797,
                32.9843572
              ],
              [
                49.7075797,
                32.9837974
              ],
              [
                49.7075797,
                32.9835176
              ],
              [
                49.7078563,
                32.9832467
              ],
              [
                49.7078563,
                32.982407
              ],
              [
                49.7050797,
                32.9801858
              ],
              [
                49.6998031,
                32.9779646
              ],
              [
                49.6959131,
                32.9779646
              ],
              [
                49.6953565,
                32.9776847
              ],
              [
                49.6948033,
                32.9779646
              ],
              [
                49.6936896,
                32.9776847
              ],
              [
                49.6864665,
                32.9757435
              ],
              [
                49.6853567,
                32.9749037
              ],
              [
                49.6842464,
                32.9735222
              ],
              [
                49.6803566,
                32.9712921
              ],
              [
                49.6786902,
                32.9710212
              ],
              [
                49.6784136,
                32.9707413
              ],
              [
                49.6772999,
                32.9707413
              ],
              [
                49.6764667,
                32.9704614
              ],
              [
                49.6725767,
                32.9704614
              ],
              [
                49.6720236,
                32.9707413
              ],
              [
                49.6703568,
                32.9707413
              ],
              [
                49.6509102,
                32.9782444
              ],
              [
                49.6453539,
                32.9787952
              ],
              [
                49.6417437,
                32.9787952
              ],
              [
                49.6409105,
                32.9785153
              ],
              [
                49.6406339,
                32.9782445
              ],
              [
                49.6531235,
                32.9764083
              ],
              [
                49.6506785,
                32.9755246
              ],
              [
                49.6500063,
                32.97382
              ],
              [
                49.6498081,
                32.9717615
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555139,
        "tags": {
          "admin_level": "5",
          "alt_name:en": "Falaverjan County",
          "boundary": "administrative",
          "name": "شهرستان فلاورجان",
          "name:en": "Falaverjan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277889",
          "wikipedia": "fa:شهرستان فلاورجان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.4181184,
                32.4971031
              ],
              [
                51.4190222,
                32.4963023
              ],
              [
                51.4203316,
                32.4953622
              ],
              [
                51.4223491,
                32.494218
              ],
              [
                51.4248421,
                32.4933345
              ],
              [
                51.4319081,
                32.4920709
              ],
              [
                51.4330728,
                32.4918378
              ],
              [
                51.4347806,
                32.4914553
              ],
              [
                51.4418963,
                32.4882574
              ],
              [
                51.4418061,
                32.4852239
              ],
              [
                51.4329376,
                32.4779492
              ],
              [
                51.4332143,
                32.4776784
              ],
              [
                51.4337709,
                32.4768476
              ],
              [
                51.4340476,
                32.4762878
              ],
              [
                51.4451608,
                32.4646217
              ],
              [
                51.4648839,
                32.4515652
              ],
              [
                51.4651606,
                32.4512853
              ],
              [
                51.4665505,
                32.4504546
              ],
              [
                51.4668273,
                32.4498947
              ],
              [
                51.4696072,
                32.4487932
              ],
              [
                51.4698839,
                32.4485133
              ],
              [
                51.4709937,
                32.4485133
              ],
              [
                51.4712738,
                32.4482333
              ],
              [
                51.4723838,
                32.4482334
              ],
              [
                51.4729405,
                32.4479535
              ],
              [
                51.4746071,
                32.4479535
              ],
              [
                51.4748839,
                32.4476735
              ],
              [
                51.4754405,
                32.4479535
              ],
              [
                51.4798837,
                32.4479534
              ],
              [
                51.4801604,
                32.4476735
              ],
              [
                51.4815504,
                32.4476735
              ],
              [
                51.4821071,
                32.4479534
              ],
              [
                51.4851602,
                32.4479534
              ],
              [
                51.4859936,
                32.4482334
              ],
              [
                51.488497,
                32.4482333
              ],
              [
                51.4887735,
                32.4485133
              ],
              [
                51.4893302,
                32.4482334
              ],
              [
                51.4912737,
                32.4482334
              ],
              [
                51.4915502,
                32.4479535
              ],
              [
                51.4929402,
                32.4479535
              ],
              [
                51.5034968,
                32.4421205
              ],
              [
                51.5040501,
                32.4418405
              ],
              [
                51.5046067,
                32.4415696
              ],
              [
                51.5046066,
                32.4412897
              ],
              [
                51.5087734,
                32.4387886
              ],
              [
                51.5101633,
                32.4379488
              ],
              [
                51.5129399,
                32.4368473
              ],
              [
                51.5134965,
                32.4362875
              ],
              [
                51.5146065,
                32.4360075
              ],
              [
                51.5151631,
                32.4354567
              ],
              [
                51.5309963,
                32.4293438
              ],
              [
                51.5354431,
                32.4276734
              ],
              [
                51.5362763,
                32.4276734
              ],
              [
                51.5373862,
                32.4271226
              ],
              [
                51.5384962,
                32.4271226
              ],
              [
                51.5415529,
                32.4262829
              ],
              [
                51.5465014,
                32.425609
              ],
              [
                51.5517951,
                32.4246337
              ],
              [
                51.5538293,
                32.4239816
              ],
              [
                51.5550395,
                32.4246337
              ],
              [
                51.561348,
                32.4278504
              ],
              [
                51.5631235,
                32.4291097
              ],
              [
                51.5664497,
                32.4323718
              ],
              [
                51.5689348,
                32.4348047
              ],
              [
                51.5728435,
                32.4371582
              ],
              [
                51.5734832,
                32.4387152
              ],
              [
                51.574183,
                32.4417552
              ],
              [
                51.574609,
                32.4448926
              ],
              [
                51.5754424,
                32.4451725
              ],
              [
                51.5757226,
                32.4457323
              ],
              [
                51.5762757,
                32.4457323
              ],
              [
                51.5771091,
                32.4460122
              ],
              [
                51.580999,
                32.4460122
              ],
              [
                51.5876656,
                32.443791
              ],
              [
                51.588779,
                32.443791
              ],
              [
                51.5896123,
                32.4432312
              ],
              [
                51.5907222,
                32.4432312
              ],
              [
                51.5909988,
                32.4429512
              ],
              [
                51.5921123,
                32.4429513
              ],
              [
                51.5926655,
                32.4426713
              ],
              [
                51.5982222,
                32.4426714
              ],
              [
                51.5990555,
                32.4429513
              ],
              [
                51.600722,
                32.4429513
              ],
              [
                51.6012787,
                32.4432312
              ],
              [
                51.6029454,
                32.4432312
              ],
              [
                51.6035022,
                32.4435111
              ],
              [
                51.604612,
                32.4435111
              ],
              [
                51.6207252,
                32.4565676
              ],
              [
                51.6212785,
                32.4568476
              ],
              [
                51.6226686,
                32.4573984
              ],
              [
                51.6404482,
                32.4637822
              ],
              [
                51.6457249,
                32.4649019
              ],
              [
                51.6526679,
                32.4660034
              ],
              [
                51.6540581,
                32.4665633
              ],
              [
                51.655168,
                32.4665633
              ],
              [
                51.659058,
                32.4682338
              ],
              [
                51.6629478,
                32.4693443
              ],
              [
                51.6821142,
                32.4815702
              ],
              [
                51.6821142,
                32.482121
              ],
              [
                51.6823943,
                32.4823309
              ],
              [
                51.6804476,
                32.4832316
              ],
              [
                51.6796144,
                32.4832317
              ],
              [
                51.656558,
                32.4932273
              ],
              [
                51.6560012,
                32.4935071
              ],
              [
                51.6471147,
                32.5021212
              ],
              [
                51.6468348,
                32.5024011
              ],
              [
                51.6362782,
                32.5118459
              ],
              [
                51.6276244,
                32.5290375
              ],
              [
                51.6278123,
                32.5332389
              ],
              [
                51.6286489,
                32.5676956
              ],
              [
                51.6268934,
                32.5682835
              ],
              [
                51.5974363,
                32.5773971
              ],
              [
                51.5917096,
                32.5791111
              ],
              [
                51.5808994,
                32.5820251
              ],
              [
                51.5808788,
                32.598447
              ],
              [
                51.5808784,
                32.5987582
              ],
              [
                51.5805437,
                32.5987799
              ],
              [
                51.5791863,
                32.599624
              ],
              [
                51.5786073,
                32.5999469
              ],
              [
                51.577597,
                32.5987658
              ],
              [
                51.5766492,
                32.5995622
              ],
              [
                51.5731264,
                32.5962628
              ],
              [
                51.572413,
                32.596536
              ],
              [
                51.5719394,
                32.5968541
              ],
              [
                51.5739361,
                32.6014191
              ],
              [
                51.5724294,
                32.603382
              ],
              [
                51.571664,
                32.6022507
              ],
              [
                51.5715265,
                32.6017569
              ],
              [
                51.5714487,
                32.6012041
              ],
              [
                51.5708989,
                32.6004392
              ],
              [
                51.5704551,
                32.5993582
              ],
              [
                51.570638,
                32.598408
              ],
              [
                51.569711,
                32.5971282
              ],
              [
                51.568475,
                32.5940694
              ],
              [
                51.5683463,
                32.5935487
              ],
              [
                51.5663379,
                32.5934619
              ],
              [
                51.5646635,
                32.5930018
              ],
              [
                51.5635122,
                32.5954813
              ],
              [
                51.5622394,
                32.5952847
              ],
              [
                51.5614326,
                32.595263
              ],
              [
                51.5603941,
                32.5955016
              ],
              [
                51.5600078,
                32.5952774
              ],
              [
                51.559716,
                32.5945688
              ],
              [
                51.5590637,
                32.5941277
              ],
              [
                51.5579822,
                32.5937733
              ],
              [
                51.5573128,
                32.5935998
              ],
              [
                51.5561884,
                32.5935492
              ],
              [
                51.5545576,
                32.5934696
              ],
              [
                51.5543619,
                32.5933607
              ],
              [
                51.5541775,
                32.5932041
              ],
              [
                51.5539402,
                32.5926777
              ],
              [
                51.5537765,
                32.5921752
              ],
              [
                51.5535812,
                32.5920595
              ],
              [
                51.5533632,
                32.5918434
              ],
              [
                51.5529783,
                32.5914448
              ],
              [
                51.5525627,
                32.590981
              ],
              [
                51.5524363,
                32.5907418
              ],
              [
                51.5523196,
                32.5904067
              ],
              [
                51.5521586,
                32.5902759
              ],
              [
                51.5519892,
                32.5901498
              ],
              [
                51.5519054,
                32.5899406
              ],
              [
                51.5517707,
                32.5898506
              ],
              [
                51.5515964,
                32.5898466
              ],
              [
                51.5512244,
                32.5900358
              ],
              [
                51.5508695,
                32.5902824
              ],
              [
                51.5506275,
                32.5904474
              ],
              [
                51.5503004,
                32.5905264
              ],
              [
                51.5498627,
                32.5906305
              ],
              [
                51.5494449,
                32.5906175
              ],
              [
                51.5490744,
                32.5904859
              ],
              [
                51.5488863,
                32.5903914
              ],
              [
                51.5486917,
                32.5902338
              ],
              [
                51.5484416,
                32.5899683
              ],
              [
                51.5481632,
                32.5895212
              ],
              [
                51.5475881,
                32.5890439
              ],
              [
                51.5470474,
                32.5888053
              ],
              [
                51.5465582,
                32.588704
              ],
              [
                51.5459917,
                32.5887908
              ],
              [
                51.5443433,
                32.5898516
              ],
              [
                51.5434683,
                32.5902444
              ],
              [
                51.5429501,
                32.5905441
              ],
              [
                51.5423181,
                32.5905698
              ],
              [
                51.5417481,
                32.5905434
              ],
              [
                51.5413053,
                32.5903962
              ],
              [
                51.5395973,
                32.5893332
              ],
              [
                51.539357,
                32.5884943
              ],
              [
                51.5392626,
                32.5872577
              ],
              [
                51.5388849,
                32.5867225
              ],
              [
                51.5378034,
                32.5863175
              ],
              [
                51.5370867,
                32.5863194
              ],
              [
                51.5359688,
                32.5858601
              ],
              [
                51.5351341,
                32.5857752
              ],
              [
                51.5344646,
                32.5856666
              ],
              [
                51.5339239,
                32.5851749
              ],
              [
                51.5334166,
                32.5849981
              ],
              [
                51.530701,
                32.587626
              ],
              [
                51.5294135,
                32.5896871
              ],
              [
                51.5250496,
                32.5938009
              ],
              [
                51.5186564,
                32.598967
              ],
              [
                51.5157308,
                32.6022817
              ],
              [
                51.5150613,
                32.604299
              ],
              [
                51.5179452,
                32.6097651
              ],
              [
                51.5191554,
                32.6135824
              ],
              [
                51.5190862,
                32.6161238
              ],
              [
                51.5190347,
                32.6169262
              ],
              [
                51.5183137,
                32.6183143
              ],
              [
                51.5165113,
                32.6204614
              ],
              [
                51.5155071,
                32.6207216
              ],
              [
                51.5134214,
                32.6197674
              ],
              [
                51.5112842,
                32.6203096
              ],
              [
                51.5079368,
                32.6203096
              ],
              [
                51.5038942,
                32.6203746
              ],
              [
                51.500181,
                32.6194257
              ],
              [
                51.4986156,
                32.6185095
              ],
              [
                51.4952768,
                32.6160804
              ],
              [
                51.494131,
                32.6169287
              ],
              [
                51.4930238,
                32.6172184
              ],
              [
                51.4879162,
                32.6172158
              ],
              [
                51.463524,
                32.6176956
              ],
              [
                51.462803,
                32.6090199
              ],
              [
                51.4627047,
                32.6079968
              ],
              [
                51.4620821,
                32.6015148
              ],
              [
                51.4616201,
                32.6006828
              ],
              [
                51.4613353,
                32.6001698
              ],
              [
                51.4601357,
                32.5990931
              ],
              [
                51.455825,
                32.5952238
              ],
              [
                51.4539076,
                32.5944876
              ],
              [
                51.4518476,
                32.5940538
              ],
              [
                51.4457193,
                32.5914721
              ],
              [
                51.4417024,
                32.588565
              ],
              [
                51.4409942,
                32.5879549
              ],
              [
                51.4382193,
                32.585121
              ],
              [
                51.4352839,
                32.5811505
              ],
              [
                51.4320653,
                32.5760299
              ],
              [
                51.4312671,
                32.5718637
              ],
              [
                51.4312425,
                32.5671797
              ],
              [
                51.4313253,
                32.5654214
              ],
              [
                51.4315827,
                32.5647097
              ],
              [
                51.4319689,
                32.5632301
              ],
              [
                51.4325063,
                32.5609459
              ],
              [
                51.4359943,
                32.5526769
              ],
              [
                51.4373809,
                32.5432321
              ],
              [
                51.437661,
                32.5412907
              ],
              [
                51.4382141,
                32.5379589
              ],
              [
                51.4384941,
                32.5371192
              ],
              [
                51.4387707,
                32.5335073
              ],
              [
                51.4390475,
                32.5298956
              ],
              [
                51.4393276,
                32.5265637
              ],
              [
                51.4371246,
                32.5180945
              ],
              [
                51.4353221,
                32.5129268
              ],
              [
                51.4326185,
                32.5070423
              ],
              [
                51.430278,
                32.500764
              ],
              [
                51.4299433,
                32.5002645
              ],
              [
                51.4291451,
                32.5001993
              ],
              [
                51.4252827,
                32.5018932
              ],
              [
                51.4236347,
                32.502371
              ],
              [
                51.4227078,
                32.5022841
              ],
              [
                51.4217808,
                32.5016109
              ],
              [
                51.4213031,
                32.5005926
              ],
              [
                51.4209592,
                32.5005925
              ],
              [
                51.4181184,
                32.4971031
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555161,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کاشان",
          "name:ar": "مقاطعة كاشان",
          "name:en": "Kashan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279103",
          "wikipedia": "fa:شهرستان کاشان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.9282821,
                34.1593659
              ],
              [
                50.9299439,
                34.1563956
              ],
              [
                50.9315006,
                34.1486309
              ],
              [
                50.931924,
                34.1407814
              ],
              [
                50.9343024,
                34.1371138
              ],
              [
                50.9406423,
                34.1327301
              ],
              [
                50.9518015,
                34.1149403
              ],
              [
                50.9518014,
                34.1146606
              ],
              [
                50.9526347,
                34.1124312
              ],
              [
                50.9529114,
                34.1116009
              ],
              [
                50.961248,
                34.1052195
              ],
              [
                50.968748,
                34.0974393
              ],
              [
                50.9693013,
                34.0974393
              ],
              [
                50.9806912,
                34.0915996
              ],
              [
                50.9815244,
                34.0907692
              ],
              [
                50.9837477,
                34.088269
              ],
              [
                50.9837477,
                34.0879892
              ],
              [
                50.9859712,
                34.0849384
              ],
              [
                50.993191,
                34.081328
              ],
              [
                50.9940242,
                34.0813281
              ],
              [
                50.9943044,
                34.0810482
              ],
              [
                50.9998609,
                34.0796583
              ],
              [
                51.0000233,
                34.0788906
              ],
              [
                51.0004142,
                34.0771581
              ],
              [
                51.0018043,
                34.0766075
              ],
              [
                51.0209649,
                34.0654905
              ],
              [
                51.0236357,
                34.064549
              ],
              [
                51.0276011,
                34.0625439
              ],
              [
                51.0290688,
                34.0616053
              ],
              [
                51.0296353,
                34.060816
              ],
              [
                51.0298413,
                34.0594934
              ],
              [
                51.029352,
                34.0564216
              ],
              [
                51.0285538,
                34.0494241
              ],
              [
                51.0277813,
                34.0461172
              ],
              [
                51.0279873,
                34.0443463
              ],
              [
                51.0281418,
                34.0432582
              ],
              [
                51.0280646,
                34.0411672
              ],
              [
                51.0274981,
                34.0388628
              ],
              [
                51.0270346,
                34.0375825
              ],
              [
                51.0268029,
                34.0354914
              ],
              [
                51.0275753,
                34.0336563
              ],
              [
                51.0292748,
                34.0327814
              ],
              [
                51.0318497,
                34.0314157
              ],
              [
                51.0344246,
                34.0306902
              ],
              [
                51.0401667,
                34.0292818
              ],
              [
                51.0462435,
                34.0286203
              ],
              [
                51.0537108,
                34.0280654
              ],
              [
                51.0538653,
                34.0266356
              ],
              [
                51.0539425,
                34.0240534
              ],
              [
                51.054097,
                34.0145775
              ],
              [
                51.0553587,
                34.0103941
              ],
              [
                51.0523203,
                34.0045241
              ],
              [
                51.0453938,
                33.9975864
              ],
              [
                51.0441836,
                33.995537
              ],
              [
                51.0403727,
                33.989538
              ],
              [
                51.0384158,
                33.9866984
              ],
              [
                51.0356091,
                33.9830047
              ],
              [
                51.0348109,
                33.9784568
              ],
              [
                51.0348109,
                33.9763429
              ],
              [
                51.0340384,
                33.975019
              ],
              [
                51.030485,
                33.9719654
              ],
              [
                51.0293263,
                33.970556
              ],
              [
                51.0289915,
                33.9681856
              ],
              [
                51.0281418,
                33.9663277
              ],
              [
                51.0263651,
                33.9620992
              ],
              [
                51.0262364,
                33.9600062
              ],
              [
                51.0270604,
                33.9577851
              ],
              [
                51.0282877,
                33.9548253
              ],
              [
                51.0351408,
                33.9493826
              ],
              [
                51.0354173,
                33.9491028
              ],
              [
                51.0387506,
                33.9463226
              ],
              [
                51.0390273,
                33.9460428
              ],
              [
                51.0484739,
                33.9368718
              ],
              [
                51.0487506,
                33.9366011
              ],
              [
                51.0487506,
                33.9349311
              ],
              [
                51.0487507,
                33.9347913
              ],
              [
                51.0484071,
                33.9330564
              ],
              [
                51.0481938,
                33.9288202
              ],
              [
                51.0451406,
                33.9232688
              ],
              [
                51.0449459,
                33.9197933
              ],
              [
                51.0448605,
                33.918268
              ],
              [
                51.0454172,
                33.9160475
              ],
              [
                51.0460226,
                33.914733
              ],
              [
                51.0470841,
                33.9124278
              ],
              [
                51.0476407,
                33.912157
              ],
              [
                51.0476407,
                33.9115973
              ],
              [
                51.0481535,
                33.9107632
              ],
              [
                51.0498605,
                33.9079867
              ],
              [
                51.0495839,
                33.9077159
              ],
              [
                51.0481938,
                33.9027151
              ],
              [
                51.0473606,
                33.9024353
              ],
              [
                51.0468073,
                33.9024353
              ],
              [
                51.043474,
                33.8988156
              ],
              [
                51.0426408,
                33.8963242
              ],
              [
                51.0390274,
                33.8882633
              ],
              [
                51.0393073,
                33.8868732
              ],
              [
                51.0401407,
                33.8827118
              ],
              [
                51.0415273,
                33.8763209
              ],
              [
                51.0418074,
                33.8754904
              ],
              [
                51.0379175,
                33.8627085
              ],
              [
                51.0373609,
                33.8621578
              ],
              [
                51.0359741,
                33.860208
              ],
              [
                51.0320842,
                33.8529864
              ],
              [
                51.0326375,
                33.8496556
              ],
              [
                51.0351408,
                33.8465955
              ],
              [
                51.0362508,
                33.8460448
              ],
              [
                51.0484739,
                33.8338224
              ],
              [
                51.0484739,
                33.8332627
              ],
              [
                51.0504174,
                33.8296519
              ],
              [
                51.050694,
                33.8279819
              ],
              [
                51.050974,
                33.8274312
              ],
              [
                51.049584,
                33.8202096
              ],
              [
                51.0487508,
                33.8188195
              ],
              [
                51.0468074,
                33.8157683
              ],
              [
                51.0237511,
                33.7860422
              ],
              [
                51.0093045,
                33.7729798
              ],
              [
                50.9998615,
                33.7677079
              ],
              [
                50.9912482,
                33.7640971
              ],
              [
                50.989305,
                33.7635374
              ],
              [
                50.979025,
                33.7579856
              ],
              [
                50.9750468,
                33.7550939
              ],
              [
                50.9746741,
                33.7485365
              ],
              [
                50.9737235,
                33.7477378
              ],
              [
                50.9677219,
                33.7472519
              ],
              [
                50.9653653,
                33.7483407
              ],
              [
                50.960647,
                33.7481525
              ],
              [
                50.9543213,
                33.7484194
              ],
              [
                50.9526157,
                33.7433979
              ],
              [
                50.9518321,
                33.7313269
              ],
              [
                50.9507274,
                33.7229834
              ],
              [
                50.9495537,
                33.7182472
              ],
              [
                50.9478588,
                33.7121344
              ],
              [
                50.9474958,
                33.7080097
              ],
              [
                50.9571301,
                33.6970013
              ],
              [
                50.9779614,
                33.6732504
              ],
              [
                50.9996899,
                33.6487694
              ],
              [
                51.0016992,
                33.6421996
              ],
              [
                51.0086481,
                33.635936
              ],
              [
                51.0120372,
                33.6311631
              ],
              [
                51.0231179,
                33.6201226
              ],
              [
                51.0299844,
                33.6123824
              ],
              [
                51.0389299,
                33.6054189
              ],
              [
                51.0438023,
                33.602594
              ],
              [
                51.0469148,
                33.6001633
              ],
              [
                51.050925,
                33.5957727
              ],
              [
                51.0646559,
                33.5820005
              ],
              [
                51.0724353,
                33.5719364
              ],
              [
                51.0813975,
                33.5622073
              ],
              [
                51.0882748,
                33.5562671
              ],
              [
                51.0992145,
                33.5484053
              ],
              [
                51.1062671,
                33.5437875
              ],
              [
                51.1148445,
                33.5392153
              ],
              [
                51.1266866,
                33.5338775
              ],
              [
                51.145563,
                33.5260841
              ],
              [
                51.1529445,
                33.5226496
              ],
              [
                51.1634714,
                33.5154179
              ],
              [
                51.1675107,
                33.5118463
              ],
              [
                51.1727897,
                33.5100653
              ],
              [
                51.1799811,
                33.5095541
              ],
              [
                51.1902202,
                33.5115112
              ],
              [
                51.2027208,
                33.5134434
              ],
              [
                51.2148837,
                33.5142371
              ],
              [
                51.2286144,
                33.5111598
              ],
              [
                51.2387249,
                33.5080457
              ],
              [
                51.2449719,
                33.5057491
              ],
              [
                51.250747,
                33.5035546
              ],
              [
                51.2551283,
                33.5026958
              ],
              [
                51.2580572,
                33.5026012
              ],
              [
                51.2611174,
                33.5025653
              ],
              [
                51.264271,
                33.5021349
              ],
              [
                51.2682346,
                33.5018487
              ],
              [
                51.2763161,
                33.5015329
              ],
              [
                51.2867855,
                33.5007601
              ],
              [
                51.295482,
                33.5033366
              ],
              [
                51.3062756,
                33.5083822
              ],
              [
                51.3191641,
                33.5152326
              ],
              [
                51.3225404,
                33.5196936
              ],
              [
                51.3283986,
                33.5309122
              ],
              [
                51.3320732,
                33.537925
              ],
              [
                51.3366651,
                33.5426824
              ],
              [
                51.3501494,
                33.5469727
              ],
              [
                51.3534528,
                33.5477953
              ],
              [
                51.3586505,
                33.5502166
              ],
              [
                51.3638958,
                33.5516847
              ],
              [
                51.3675642,
                33.5536627
              ],
              [
                51.3766347,
                33.557021
              ],
              [
                51.3815975,
                33.5601001
              ],
              [
                51.3876485,
                33.5619596
              ],
              [
                51.4082991,
                33.5725867
              ],
              [
                51.4134173,
                33.5752021
              ],
              [
                51.4182609,
                33.5775549
              ],
              [
                51.4193094,
                33.5796952
              ],
              [
                51.4204788,
                33.5830917
              ],
              [
                51.4231824,
                33.5884544
              ],
              [
                51.4322637,
                33.6018893
              ],
              [
                51.4338028,
                33.6099597
              ],
              [
                51.4342729,
                33.6183325
              ],
              [
                51.437238,
                33.6245621
              ],
              [
                51.4408371,
                33.6267776
              ],
              [
                51.4483458,
                33.6288442
              ],
              [
                51.4582214,
                33.6324889
              ],
              [
                51.462661,
                33.6332492
              ],
              [
                51.471609,
                33.6343926
              ],
              [
                51.483877,
                33.635539
              ],
              [
                51.4894324,
                33.6371615
              ],
              [
                51.4989838,
                33.6386682
              ],
              [
                51.5282202,
                33.6366106
              ],
              [
                51.5421082,
                33.6347395
              ],
              [
                51.5483665,
                33.6348095
              ],
              [
                51.5546321,
                33.6342021
              ],
              [
                51.5624261,
                33.6351981
              ],
              [
                51.5653554,
                33.635314
              ],
              [
                51.5717554,
                33.6383825
              ],
              [
                51.5800593,
                33.640244
              ],
              [
                51.5866861,
                33.6423161
              ],
              [
                51.592698,
                33.645201
              ],
              [
                51.6017154,
                33.650113
              ],
              [
                51.6079078,
                33.653164
              ],
              [
                51.6146207,
                33.6556111
              ],
              [
                51.6230679,
                33.6603353
              ],
              [
                51.6258504,
                33.6616329
              ],
              [
                51.6373729,
                33.6706042
              ],
              [
                51.6435098,
                33.6767828
              ],
              [
                51.6516898,
                33.6856904
              ],
              [
                51.6558265,
                33.6902457
              ],
              [
                51.668082,
                33.6973345
              ],
              [
                51.6729924,
                33.6994295
              ],
              [
                51.6790352,
                33.7029414
              ],
              [
                51.6895652,
                33.706284
              ],
              [
                51.6972754,
                33.7079762
              ],
              [
                51.702148,
                33.7086188
              ],
              [
                51.7054742,
                33.7090945
              ],
              [
                51.7104148,
                33.7098469
              ],
              [
                51.7180586,
                33.7099156
              ],
              [
                51.7230527,
                33.7103119
              ],
              [
                51.7264777,
                33.7109488
              ],
              [
                51.7295356,
                33.7116155
              ],
              [
                51.7415713,
                33.7132026
              ],
              [
                51.751356,
                33.7154873
              ],
              [
                51.7632226,
                33.7199031
              ],
              [
                51.7694663,
                33.7224123
              ],
              [
                51.7807525,
                33.7302643
              ],
              [
                51.7840974,
                33.7333734
              ],
              [
                51.7886924,
                33.7399007
              ],
              [
                51.7925548,
                33.7490361
              ],
              [
                51.797398,
                33.7563164
              ],
              [
                51.7985079,
                33.7585371
              ],
              [
                51.8121211,
                33.7818724
              ],
              [
                51.8129543,
                33.7835424
              ],
              [
                51.8204318,
                33.79112
              ],
              [
                51.8184443,
                33.7924909
              ],
              [
                51.7912522,
                33.8134654
              ],
              [
                51.7811934,
                33.8238154
              ],
              [
                51.7755282,
                33.8271466
              ],
              [
                51.7698096,
                33.8306047
              ],
              [
                51.758899,
                33.8309212
              ],
              [
                51.7552826,
                33.8341756
              ],
              [
                51.7517857,
                33.8388809
              ],
              [
                51.7452018,
                33.8462647
              ],
              [
                51.7360052,
                33.8560473
              ],
              [
                51.7335054,
                33.8582679
              ],
              [
                51.729967,
                33.8608143
              ],
              [
                51.723976,
                33.8642866
              ],
              [
                51.7124755,
                33.8684691
              ],
              [
                51.7041449,
                33.8723701
              ],
              [
                51.6775292,
                33.8860967
              ],
              [
                51.6618113,
                33.8935377
              ],
              [
                51.6284998,
                33.908267
              ],
              [
                51.6276666,
                33.9090975
              ],
              [
                51.6218333,
                33.9118778
              ],
              [
                51.6215568,
                33.9121576
              ],
              [
                51.6207234,
                33.9121576
              ],
              [
                51.6151668,
                33.9149377
              ],
              [
                51.6129435,
                33.916048
              ],
              [
                51.6020967,
                33.9213754
              ],
              [
                51.5906478,
                33.9264357
              ],
              [
                51.572664,
                33.9335415
              ],
              [
                51.5673872,
                33.9354823
              ],
              [
                51.5671073,
                33.9357711
              ],
              [
                51.566554,
                33.9357711
              ],
              [
                51.5646073,
                33.9363217
              ],
              [
                51.5557174,
                33.9393817
              ],
              [
                51.5551642,
                33.9393817
              ],
              [
                51.5546075,
                33.9399324
              ],
              [
                51.5371078,
                33.9463231
              ],
              [
                51.5365511,
                33.9463231
              ],
              [
                51.5362743,
                33.9465939
              ],
              [
                51.5267815,
                33.9489131
              ],
              [
                51.5208777,
                33.9592311
              ],
              [
                51.517034,
                33.961047
              ],
              [
                51.5099359,
                33.9622766
              ],
              [
                51.5022412,
                33.9634263
              ],
              [
                51.4992028,
                33.9662346
              ],
              [
                51.4975548,
                33.9675304
              ],
              [
                51.4942503,
                33.9689185
              ],
              [
                51.4906025,
                33.971481
              ],
              [
                51.4918899,
                33.9742214
              ],
              [
                51.4925455,
                33.9752987
              ],
              [
                51.4914847,
                33.9779464
              ],
              [
                51.4873691,
                33.9818396
              ],
              [
                51.4841032,
                33.9897109
              ],
              [
                51.4827128,
                33.9919597
              ],
              [
                51.4791122,
                33.9948311
              ],
              [
                51.4762241,
                33.9969837
              ],
              [
                51.4733058,
                33.9995596
              ],
              [
                51.469894,
                34.0026798
              ],
              [
                51.4670438,
                34.0053932
              ],
              [
                51.4661776,
                34.0090437
              ],
              [
                51.4656043,
                34.0119376
              ],
              [
                51.4616561,
                34.0169356
              ],
              [
                51.4575016,
                34.0168356
              ],
              [
                51.4555833,
                34.0175258
              ],
              [
                51.4496524,
                34.0166329
              ],
              [
                51.4476826,
                34.0196813
              ],
              [
                51.442919,
                34.0262971
              ],
              [
                51.4370739,
                34.0363621
              ],
              [
                51.4345979,
                34.040605
              ],
              [
                51.4255211,
                34.0439296
              ],
              [
                51.4076852,
                34.0386197
              ],
              [
                51.3930168,
                34.0277654
              ],
              [
                51.3712243,
                34.0358884
              ],
              [
                51.3736533,
                34.0390464
              ],
              [
                51.3733872,
                34.0412719
              ],
              [
                51.3742249,
                34.0446652
              ],
              [
                51.379782,
                34.0529957
              ],
              [
                51.3802508,
                34.0627072
              ],
              [
                51.3777774,
                34.0691942
              ],
              [
                51.3763374,
                34.0710842
              ],
              [
                51.3741597,
                34.0719162
              ],
              [
                51.3674649,
                34.0747102
              ],
              [
                51.3623666,
                34.0751795
              ],
              [
                51.3534316,
                34.0754354
              ],
              [
                51.3500584,
                34.0749022
              ],
              [
                51.3430289,
                34.0741344
              ],
              [
                51.3429002,
                34.0757766
              ],
              [
                51.3424367,
                34.0798289
              ],
              [
                51.3411235,
                34.0889563
              ],
              [
                51.3411235,
                34.0952255
              ],
              [
                51.340763,
                34.101473
              ],
              [
                51.339939,
                34.104863
              ],
              [
                51.3379821,
                34.1089139
              ],
              [
                51.3347634,
                34.1125808
              ],
              [
                51.324747,
                34.1190401
              ],
              [
                51.3187474,
                34.123346
              ],
              [
                51.3127736,
                34.1290372
              ],
              [
                51.3086537,
                34.1372642
              ],
              [
                51.3066453,
                34.1438282
              ],
              [
                51.3066453,
                34.148069
              ],
              [
                51.3063878,
                34.1540994
              ],
              [
                51.3051003,
                34.1600442
              ],
              [
                51.3045596,
                34.167693
              ],
              [
                51.3029632,
                34.1742546
              ],
              [
                51.3004397,
                34.1832228
              ],
              [
                51.2988948,
                34.187845
              ],
              [
                51.299384,
                34.1927225
              ],
              [
                51.2996415,
                34.2003044
              ],
              [
                51.3003792,
                34.2077631
              ],
              [
                51.300669,
                34.2131313
              ],
              [
                51.3023047,
                34.2194054
              ],
              [
                51.3046471,
                34.2242841
              ],
              [
                51.3078769,
                34.2414437
              ],
              [
                51.3123996,
                34.2539196
              ],
              [
                51.31904,
                34.2654944
              ],
              [
                51.3243199,
                34.2710538
              ],
              [
                51.3468197,
                34.2971631
              ],
              [
                51.3518195,
                34.3071628
              ],
              [
                51.3520961,
                34.3121626
              ],
              [
                51.3526999,
                34.3229353
              ],
              [
                51.3538586,
                34.3332697
              ],
              [
                51.356176,
                34.3578673
              ],
              [
                51.357309,
                34.3705992
              ],
              [
                51.3589569,
                34.3797802
              ],
              [
                51.3611971,
                34.3988828
              ],
              [
                51.3611971,
                34.4119907
              ],
              [
                51.3621498,
                34.4276453
              ],
              [
                51.3625618,
                34.4449321
              ],
              [
                51.3625594,
                34.445794
              ],
              [
                51.3259785,
                34.4410284
              ],
              [
                51.3235613,
                34.4410598
              ],
              [
                51.3220964,
                34.4416104
              ],
              [
                51.3120964,
                34.4413397
              ],
              [
                51.3115398,
                34.4416104
              ],
              [
                51.3110491,
                34.4416104
              ],
              [
                51.3101499,
                34.4416104
              ],
              [
                51.3068164,
                34.4421699
              ],
              [
                51.3001499,
                34.4427203
              ],
              [
                51.29626,
                34.4427203
              ],
              [
                51.2945933,
                34.443
              ],
              [
                51.2920933,
                34.4430001
              ],
              [
                51.2865402,
                34.4438393
              ],
              [
                51.2568138,
                34.4460592
              ],
              [
                51.2315375,
                34.4466097
              ],
              [
                51.2309809,
                34.4463299
              ],
              [
                51.209591,
                34.4454997
              ],
              [
                51.2020912,
                34.44522
              ],
              [
                51.1973679,
                34.4452199
              ],
              [
                51.1959778,
                34.4449402
              ],
              [
                51.188758,
                34.4446694
              ],
              [
                51.1807015,
                34.4446694
              ],
              [
                51.1793115,
                34.4443896
              ],
              [
                51.1773681,
                34.4443897
              ],
              [
                51.1473651,
                34.4391105
              ],
              [
                51.1459752,
                34.438551
              ],
              [
                51.1431986,
                34.4377208
              ],
              [
                51.1273654,
                34.4327213
              ],
              [
                51.1229187,
                34.4302216
              ],
              [
                51.1201422,
                34.4285521
              ],
              [
                51.115727,
                34.4170262
              ],
              [
                51.1062723,
                34.4166048
              ],
              [
                51.0900306,
                34.417602
              ],
              [
                51.086769,
                34.4159026
              ],
              [
                51.0847949,
                34.4119374
              ],
              [
                51.0778578,
                34.4052138
              ],
              [
                51.0690321,
                34.3987266
              ],
              [
                51.0599847,
                34.3958991
              ],
              [
                51.0467418,
                34.3913004
              ],
              [
                51.0397978,
                34.3874424
              ],
              [
                51.0306581,
                34.3800919
              ],
              [
                51.0221892,
                34.369401
              ],
              [
                51.0184792,
                34.3610443
              ],
              [
                51.0147809,
                34.3540495
              ],
              [
                51.012336,
                34.3438541
              ],
              [
                51.0115962,
                34.3383592
              ],
              [
                51.0123538,
                34.3325927
              ],
              [
                51.0134177,
                34.3283861
              ],
              [
                51.0190486,
                34.3228819
              ],
              [
                51.029005,
                34.3160767
              ],
              [
                51.0331248,
                34.312532
              ],
              [
                51.0360248,
                34.3047654
              ],
              [
                51.0363014,
                34.2999669
              ],
              [
                51.0351831,
                34.2941833
              ],
              [
                51.0314507,
                34.2870175
              ],
              [
                51.0274739,
                34.2801981
              ],
              [
                51.0202293,
                34.2694202
              ],
              [
                51.0094788,
                34.2579192
              ],
              [
                51.0044814,
                34.253266
              ],
              [
                50.9982299,
                34.2456367
              ],
              [
                50.9979,
                34.2355141
              ],
              [
                50.9979731,
                34.2280736
              ],
              [
                50.9946889,
                34.2204261
              ],
              [
                50.9892958,
                34.212482
              ],
              [
                50.9811114,
                34.2010837
              ],
              [
                50.9777382,
                34.1892289
              ],
              [
                50.9794215,
                34.1831032
              ],
              [
                50.9756183,
                34.1747431
              ],
              [
                50.9695243,
                34.1692041
              ],
              [
                50.9642886,
                34.164517
              ],
              [
                50.9587955,
                34.1618893
              ],
              [
                50.9532061,
                34.1599682
              ],
              [
                50.9466677,
                34.1590376
              ],
              [
                50.9380035,
                34.1581799
              ],
              [
                50.9342602,
                34.1582668
              ],
              [
                50.9282821,
                34.1593659
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555190,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لنجان",
          "name:en": "Lenjan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278617",
          "wikipedia": "fa:شهرستان لنجان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.9710357,
                32.3904972
              ],
              [
                50.973194,
                32.3882322
              ],
              [
                50.9854172,
                32.3760064
              ],
              [
                50.9998944,
                32.3679522
              ],
              [
                51.0162533,
                32.3610086
              ],
              [
                51.0220868,
                32.356837
              ],
              [
                51.02264,
                32.3562862
              ],
              [
                51.0318064,
                32.351004
              ],
              [
                51.0418099,
                32.3443403
              ],
              [
                51.0465296,
                32.3426698
              ],
              [
                51.0743093,
                32.333505
              ],
              [
                51.0784759,
                32.330724
              ],
              [
                51.0795892,
                32.3298933
              ],
              [
                51.1326452,
                32.2948954
              ],
              [
                51.1337587,
                32.2946154
              ],
              [
                51.1365351,
                32.293225
              ],
              [
                51.1373686,
                32.2923943
              ],
              [
                51.138202,
                32.2921234
              ],
              [
                51.1443119,
                32.2876719
              ],
              [
                51.1457017,
                32.2862814
              ],
              [
                51.1462584,
                32.2860105
              ],
              [
                51.1657049,
                32.2665613
              ],
              [
                51.1684814,
                32.2626696
              ],
              [
                51.1812579,
                32.2451706
              ],
              [
                51.1843146,
                32.2387869
              ],
              [
                51.185148,
                32.2373964
              ],
              [
                51.1907047,
                32.2265612
              ],
              [
                51.1915378,
                32.2257215
              ],
              [
                51.1915378,
                32.2254415
              ],
              [
                51.1918146,
                32.2251706
              ],
              [
                51.1918146,
                32.2246199
              ],
              [
                51.1923713,
                32.22434
              ],
              [
                51.1937613,
                32.2232294
              ],
              [
                51.194038,
                32.2226696
              ],
              [
                51.1970946,
                32.2182271
              ],
              [
                51.2087611,
                32.2062813
              ],
              [
                51.2093177,
                32.2051707
              ],
              [
                51.2212629,
                32.190165
              ],
              [
                51.2273741,
                32.1943355
              ],
              [
                51.2284841,
                32.1948863
              ],
              [
                51.2565403,
                32.2179473
              ],
              [
                51.2801534,
                32.2296132
              ],
              [
                51.2837633,
                32.2307238
              ],
              [
                51.2854299,
                32.2310037
              ],
              [
                51.2909867,
                32.232945
              ],
              [
                51.3387658,
                32.2723944
              ],
              [
                51.3398792,
                32.2737849
              ],
              [
                51.3751587,
                32.3129454
              ],
              [
                51.3829351,
                32.3257311
              ],
              [
                51.3831982,
                32.326167
              ],
              [
                51.3866184,
                32.3298954
              ],
              [
                51.3975876,
                32.335472
              ],
              [
                51.4030344,
                32.3387972
              ],
              [
                51.4080505,
                32.3418593
              ],
              [
                51.4180669,
                32.3470028
              ],
              [
                51.4208794,
                32.349848
              ],
              [
                51.4251223,
                32.3541399
              ],
              [
                51.4261335,
                32.3567445
              ],
              [
                51.4273756,
                32.3599434
              ],
              [
                51.4302138,
                32.3658418
              ],
              [
                51.4305733,
                32.3665888
              ],
              [
                51.4332144,
                32.3693432
              ],
              [
                51.4334945,
                32.369894
              ],
              [
                51.4337711,
                32.3701739
              ],
              [
                51.437035,
                32.3730104
              ],
              [
                51.440161,
                32.375727
              ],
              [
                51.4479068,
                32.3853159
              ],
              [
                51.4682172,
                32.4104542
              ],
              [
                51.468774,
                32.411014
              ],
              [
                51.4696072,
                32.4129554
              ],
              [
                51.4709937,
                32.4229509
              ],
              [
                51.4707171,
                32.4232308
              ],
              [
                51.4704406,
                32.4249013
              ],
              [
                51.4679406,
                32.4332265
              ],
              [
                51.4676605,
                32.4346169
              ],
              [
                51.4662706,
                32.4412897
              ],
              [
                51.4659938,
                32.443511
              ],
              [
                51.4657172,
                32.446563
              ],
              [
                51.4654371,
                32.4490641
              ],
              [
                51.4651606,
                32.4507345
              ],
              [
                51.4651606,
                32.4512853
              ],
              [
                51.4648839,
                32.4515652
              ],
              [
                51.4451608,
                32.4646217
              ],
              [
                51.4340476,
                32.4762878
              ],
              [
                51.4337709,
                32.4768476
              ],
              [
                51.4332143,
                32.4776784
              ],
              [
                51.4329376,
                32.4779492
              ],
              [
                51.4418061,
                32.4852239
              ],
              [
                51.4418963,
                32.4882574
              ],
              [
                51.4347806,
                32.4914553
              ],
              [
                51.4330728,
                32.4918378
              ],
              [
                51.4319081,
                32.4920709
              ],
              [
                51.4248421,
                32.4933345
              ],
              [
                51.4223491,
                32.494218
              ],
              [
                51.4203316,
                32.4953622
              ],
              [
                51.4190222,
                32.4963023
              ],
              [
                51.4181184,
                32.4971031
              ],
              [
                51.4137889,
                32.5000521
              ],
              [
                51.406934,
                32.505694
              ],
              [
                51.4062933,
                32.5064911
              ],
              [
                51.3993444,
                32.5119027
              ],
              [
                51.3879683,
                32.5109838
              ],
              [
                51.3765449,
                32.5321258
              ],
              [
                51.3663185,
                32.5479996
              ],
              [
                51.3459657,
                32.5618166
              ],
              [
                51.3308354,
                32.5467112
              ],
              [
                51.3202959,
                32.538947
              ],
              [
                51.3168161,
                32.5363833
              ],
              [
                51.3163524,
                32.5310953
              ],
              [
                51.2997172,
                32.5249286
              ],
              [
                51.2861692,
                32.4992983
              ],
              [
                51.2756367,
                32.497484
              ],
              [
                51.2622747,
                32.5066904
              ],
              [
                51.2466644,
                32.5079284
              ],
              [
                51.2127382,
                32.5171993
              ],
              [
                51.1966065,
                32.5307977
              ],
              [
                51.1884809,
                32.5274033
              ],
              [
                51.1876475,
                32.5274034
              ],
              [
                51.1873709,
                32.5271234
              ],
              [
                51.1862609,
                32.5268434
              ],
              [
                51.1801475,
                32.5248932
              ],
              [
                51.1787577,
                32.5246223
              ],
              [
                51.1754243,
                32.5242482
              ],
              [
                51.174871,
                32.5240623
              ],
              [
                51.1451447,
                32.516008
              ],
              [
                51.1368115,
                32.5135069
              ],
              [
                51.1251451,
                32.5118454
              ],
              [
                51.1223685,
                32.5118454
              ],
              [
                51.1207019,
                32.5115655
              ],
              [
                51.1182018,
                32.5115655
              ],
              [
                51.1107019,
                32.5107348
              ],
              [
                51.1037553,
                32.5107348
              ],
              [
                51.0879221,
                32.5143465
              ],
              [
                51.0868088,
                32.5148973
              ],
              [
                51.0676424,
                32.5201795
              ],
              [
                51.0656992,
                32.5207303
              ],
              [
                51.0645857,
                32.5207304
              ],
              [
                51.0623659,
                32.5212902
              ],
              [
                51.0581992,
                32.5215611
              ],
              [
                51.0579193,
                32.5212901
              ],
              [
                51.0562526,
                32.5212902
              ],
              [
                51.0556995,
                32.5212901
              ],
              [
                51.0543094,
                32.521561
              ],
              [
                51.0534759,
                32.521561
              ],
              [
                51.0529193,
                32.5218409
              ],
              [
                51.0509761,
                32.521841
              ],
              [
                51.0504194,
                32.5221209
              ],
              [
                51.0379196,
                32.5221209
              ],
              [
                51.0376428,
                32.5224008
              ],
              [
                51.0331963,
                32.5224008
              ],
              [
                51.0323629,
                32.5221208
              ],
              [
                51.0279198,
                32.5221208
              ],
              [
                51.0276397,
                32.521841
              ],
              [
                51.0251397,
                32.5218409
              ],
              [
                51.0243065,
                32.521561
              ],
              [
                51.0170865,
                32.5201795
              ],
              [
                51.0148633,
                32.5190688
              ],
              [
                51.00903,
                32.5168386
              ],
              [
                51.0090299,
                32.5165677
              ],
              [
                51.0090299,
                32.5151772
              ],
              [
                51.0090299,
                32.5148973
              ],
              [
                51.0051401,
                32.5012899
              ],
              [
                50.9998634,
                32.4846216
              ],
              [
                50.9997917,
                32.4840617
              ],
              [
                50.9993068,
                32.4835109
              ],
              [
                50.9943069,
                32.4740661
              ],
              [
                50.9845837,
                32.4604497
              ],
              [
                50.9731939,
                32.4457317
              ],
              [
                50.9704172,
                32.4401696
              ],
              [
                50.9701371,
                32.4396187
              ],
              [
                50.9698606,
                32.4379482
              ],
              [
                50.9684705,
                32.4335058
              ],
              [
                50.9679174,
                32.4293432
              ],
              [
                50.9676373,
                32.4254516
              ],
              [
                50.9673605,
                32.4146162
              ],
              [
                50.9695841,
                32.3996184
              ],
              [
                50.9698606,
                32.3971172
              ],
              [
                50.9701373,
                32.3954468
              ],
              [
                50.9704173,
                32.3951758
              ],
              [
                50.9704173,
                32.3937854
              ],
              [
                50.9706939,
                32.392124
              ],
              [
                50.9709707,
                32.3912842
              ],
              [
                50.9710357,
                32.3904972
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555197,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مبارکه",
          "name:en": "Mobarakeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q81443",
          "wikipedia": "fa:شهرستان مبارکه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.2212629,
                32.190165
              ],
              [
                51.2218176,
                32.1896132
              ],
              [
                51.2218176,
                32.1893332
              ],
              [
                51.2309842,
                32.1782272
              ],
              [
                51.2315408,
                32.1768367
              ],
              [
                51.232094,
                32.1765568
              ],
              [
                51.2337608,
                32.1743356
              ],
              [
                51.2423741,
                32.1687826
              ],
              [
                51.2434838,
                32.1685027
              ],
              [
                51.2565403,
                32.1635004
              ],
              [
                51.258207,
                32.1632295
              ],
              [
                51.2593169,
                32.1626698
              ],
              [
                51.2684869,
                32.1587782
              ],
              [
                51.2779302,
                32.1565569
              ],
              [
                51.2820967,
                32.1565569
              ],
              [
                51.2826534,
                32.1562771
              ],
              [
                51.2843201,
                32.1562771
              ],
              [
                51.2845968,
                32.1559972
              ],
              [
                51.2876533,
                32.1559972
              ],
              [
                51.2890433,
                32.1562771
              ],
              [
                51.2926534,
                32.1562771
              ],
              [
                51.2934865,
                32.1559972
              ],
              [
                51.2998766,
                32.1554463
              ],
              [
                51.3020999,
                32.1548866
              ],
              [
                51.3268228,
                32.1476721
              ],
              [
                51.3309895,
                32.1460017
              ],
              [
                51.3320995,
                32.1451711
              ],
              [
                51.3326561,
                32.1451711
              ],
              [
                51.340156,
                32.1415594
              ],
              [
                51.3409893,
                32.1415593
              ],
              [
                51.3409892,
                32.1412794
              ],
              [
                51.3418227,
                32.1412795
              ],
              [
                51.3423794,
                32.1409995
              ],
              [
                51.3434894,
                32.1407287
              ],
              [
                51.3437659,
                32.1409995
              ],
              [
                51.3442305,
                32.1406355
              ],
              [
                51.3445994,
                32.1404488
              ],
              [
                51.3457126,
                32.1396181
              ],
              [
                51.3543226,
                32.1307242
              ],
              [
                51.3573791,
                32.12295
              ],
              [
                51.3676557,
                32.1101647
              ],
              [
                51.3818255,
                32.0959978
              ],
              [
                51.3823789,
                32.0948871
              ],
              [
                51.3851588,
                32.0912755
              ],
              [
                51.3857121,
                32.0915555
              ],
              [
                51.3862688,
                32.0865532
              ],
              [
                51.3865455,
                32.0860024
              ],
              [
                51.3862687,
                32.0835014
              ],
              [
                51.3859922,
                32.0723864
              ],
              [
                51.3854355,
                32.070725
              ],
              [
                51.3843256,
                32.0701652
              ],
              [
                51.3837799,
                32.0698692
              ],
              [
                51.3821577,
                32.0674471
              ],
              [
                51.3760294,
                32.0583257
              ],
              [
                51.3768792,
                32.0556197
              ],
              [
                51.3785014,
                32.0527171
              ],
              [
                51.381823,
                32.0510585
              ],
              [
                51.3842949,
                32.0496399
              ],
              [
                51.3851961,
                32.0497054
              ],
              [
                51.3855051,
                32.0492252
              ],
              [
                51.3868698,
                32.0493125
              ],
              [
                51.3869213,
                32.0489852
              ],
              [
                51.3875908,
                32.0489633
              ],
              [
                51.3967489,
                32.0456769
              ],
              [
                51.4029059,
                32.0483456
              ],
              [
                51.4073862,
                32.0519903
              ],
              [
                51.4110684,
                32.0556567
              ],
              [
                51.4151367,
                32.0629672
              ],
              [
                51.4212393,
                32.071259
              ],
              [
                51.4228615,
                32.0769537
              ],
              [
                51.4253805,
                32.0805043
              ],
              [
                51.429413,
                32.08529
              ],
              [
                51.4382147,
                32.0918354
              ],
              [
                51.4386303,
                32.0921748
              ],
              [
                51.4402402,
                32.0926466
              ],
              [
                51.4450553,
                32.0959406
              ],
              [
                51.4489692,
                32.0991304
              ],
              [
                51.463771,
                32.1090541
              ],
              [
                51.4643276,
                32.109334
              ],
              [
                51.5018304,
                32.1287831
              ],
              [
                51.517387,
                32.1362865
              ],
              [
                51.5254436,
                32.1393384
              ],
              [
                51.531063,
                32.1406861
              ],
              [
                51.533329,
                32.1418417
              ],
              [
                51.5372428,
                32.1456135
              ],
              [
                51.540925,
                32.1482514
              ],
              [
                51.5443496,
                32.1502789
              ],
              [
                51.5478773,
                32.1548788
              ],
              [
                51.5496025,
                32.1567971
              ],
              [
                51.5567092,
                32.1613312
              ],
              [
                51.5615501,
                32.1671947
              ],
              [
                51.5682449,
                32.174954
              ],
              [
                51.5712833,
                32.1802718
              ],
              [
                51.5722618,
                32.1829959
              ],
              [
                51.5780553,
                32.1899476
              ],
              [
                51.5839433,
                32.1931712
              ],
              [
                51.5871104,
                32.1944568
              ],
              [
                51.5920028,
                32.2008193
              ],
              [
                51.5977706,
                32.2060049
              ],
              [
                51.6026372,
                32.2095997
              ],
              [
                51.6069116,
                32.2121705
              ],
              [
                51.609641,
                32.2177257
              ],
              [
                51.6122674,
                32.2226925
              ],
              [
                51.6161555,
                32.2261124
              ],
              [
                51.6211766,
                32.2289223
              ],
              [
                51.6261977,
                32.2306866
              ],
              [
                51.6298284,
                32.2331914
              ],
              [
                51.6352872,
                32.2399215
              ],
              [
                51.6377591,
                32.2412718
              ],
              [
                51.6447372,
                32.2443426
              ],
              [
                51.6491403,
                32.2500555
              ],
              [
                51.6543588,
                32.2563053
              ],
              [
                51.6606502,
                32.2614804
              ],
              [
                51.6639846,
                32.2777868
              ],
              [
                51.6675157,
                32.2872193
              ],
              [
                51.6707962,
                32.2968351
              ],
              [
                51.6756031,
                32.307358
              ],
              [
                51.6806611,
                32.311505
              ],
              [
                51.6883027,
                32.3177402
              ],
              [
                51.6921113,
                32.3190957
              ],
              [
                51.7055143,
                32.3222533
              ],
              [
                51.6954203,
                32.3325257
              ],
              [
                51.6885978,
                32.3390526
              ],
              [
                51.6843539,
                32.3421505
              ],
              [
                51.6759674,
                32.3461196
              ],
              [
                51.6720882,
                32.3484094
              ],
              [
                51.661562,
                32.352178
              ],
              [
                51.6624607,
                32.3577482
              ],
              [
                51.6642573,
                32.3649813
              ],
              [
                51.665794,
                32.368432
              ],
              [
                51.6682234,
                32.3725742
              ],
              [
                51.672,
                32.3762611
              ],
              [
                51.6786032,
                32.3816122
              ],
              [
                51.6816432,
                32.3830155
              ],
              [
                51.6893005,
                32.3846004
              ],
              [
                51.70372,
                32.3860501
              ],
              [
                51.7098179,
                32.3860446
              ],
              [
                51.7263337,
                32.3840018
              ],
              [
                51.7344571,
                32.3833856
              ],
              [
                51.741743,
                32.3844658
              ],
              [
                51.7532961,
                32.3864199
              ],
              [
                51.7613704,
                32.3871681
              ],
              [
                51.7707375,
                32.387502
              ],
              [
                51.7830088,
                32.3880819
              ],
              [
                51.7889138,
                32.38879
              ],
              [
                51.8037567,
                32.3902831
              ],
              [
                51.8145994,
                32.3927172
              ],
              [
                51.7962863,
                32.4132356
              ],
              [
                51.7707299,
                32.426283
              ],
              [
                51.7654532,
                32.4298948
              ],
              [
                51.7621199,
                32.4310054
              ],
              [
                51.7612867,
                32.4315652
              ],
              [
                51.7610066,
                32.4318452
              ],
              [
                51.7596201,
                32.4321251
              ],
              [
                51.7593427,
                32.4323994
              ],
              [
                51.7551733,
                32.435177
              ],
              [
                51.7418402,
                32.44129
              ],
              [
                51.7407302,
                32.4421206
              ],
              [
                51.7187839,
                32.4643421
              ],
              [
                51.6885042,
                32.4807305
              ],
              [
                51.6876709,
                32.4810104
              ],
              [
                51.6823943,
                32.4823309
              ],
              [
                51.6821142,
                32.482121
              ],
              [
                51.6821142,
                32.4815702
              ],
              [
                51.6629478,
                32.4693443
              ],
              [
                51.659058,
                32.4682338
              ],
              [
                51.655168,
                32.4665633
              ],
              [
                51.6540581,
                32.4665633
              ],
              [
                51.6526679,
                32.4660034
              ],
              [
                51.6457249,
                32.4649019
              ],
              [
                51.6404482,
                32.4637822
              ],
              [
                51.6226686,
                32.4573984
              ],
              [
                51.6212785,
                32.4568476
              ],
              [
                51.6207252,
                32.4565676
              ],
              [
                51.604612,
                32.4435111
              ],
              [
                51.6035022,
                32.4435111
              ],
              [
                51.6029454,
                32.4432312
              ],
              [
                51.6012787,
                32.4432312
              ],
              [
                51.600722,
                32.4429513
              ],
              [
                51.5990555,
                32.4429513
              ],
              [
                51.5982222,
                32.4426714
              ],
              [
                51.5926655,
                32.4426713
              ],
              [
                51.5921123,
                32.4429513
              ],
              [
                51.5909988,
                32.4429512
              ],
              [
                51.5907222,
                32.4432312
              ],
              [
                51.5896123,
                32.4432312
              ],
              [
                51.588779,
                32.443791
              ],
              [
                51.5876656,
                32.443791
              ],
              [
                51.580999,
                32.4460122
              ],
              [
                51.5771091,
                32.4460122
              ],
              [
                51.5762757,
                32.4457323
              ],
              [
                51.5757226,
                32.4457323
              ],
              [
                51.5754424,
                32.4451725
              ],
              [
                51.574609,
                32.4448926
              ],
              [
                51.574183,
                32.4417552
              ],
              [
                51.5734832,
                32.4387152
              ],
              [
                51.5728435,
                32.4371582
              ],
              [
                51.5689348,
                32.4348047
              ],
              [
                51.5664497,
                32.4323718
              ],
              [
                51.5631235,
                32.4291097
              ],
              [
                51.561348,
                32.4278504
              ],
              [
                51.5550395,
                32.4246337
              ],
              [
                51.5538293,
                32.4239816
              ],
              [
                51.5517951,
                32.4246337
              ],
              [
                51.5465014,
                32.425609
              ],
              [
                51.5415529,
                32.4262829
              ],
              [
                51.5384962,
                32.4271226
              ],
              [
                51.5373862,
                32.4271226
              ],
              [
                51.5362763,
                32.4276734
              ],
              [
                51.5354431,
                32.4276734
              ],
              [
                51.5309963,
                32.4293438
              ],
              [
                51.5151631,
                32.4354567
              ],
              [
                51.5146065,
                32.4360075
              ],
              [
                51.5134965,
                32.4362875
              ],
              [
                51.5129399,
                32.4368473
              ],
              [
                51.5101633,
                32.4379488
              ],
              [
                51.5087734,
                32.4387886
              ],
              [
                51.5046066,
                32.4412897
              ],
              [
                51.5046067,
                32.4415696
              ],
              [
                51.5040501,
                32.4418405
              ],
              [
                51.5034968,
                32.4421205
              ],
              [
                51.4929402,
                32.4479535
              ],
              [
                51.4915502,
                32.4479535
              ],
              [
                51.4912737,
                32.4482334
              ],
              [
                51.4893302,
                32.4482334
              ],
              [
                51.4887735,
                32.4485133
              ],
              [
                51.488497,
                32.4482333
              ],
              [
                51.4859936,
                32.4482334
              ],
              [
                51.4851602,
                32.4479534
              ],
              [
                51.4821071,
                32.4479534
              ],
              [
                51.4815504,
                32.4476735
              ],
              [
                51.4801604,
                32.4476735
              ],
              [
                51.4798837,
                32.4479534
              ],
              [
                51.4754405,
                32.4479535
              ],
              [
                51.4748839,
                32.4476735
              ],
              [
                51.4746071,
                32.4479535
              ],
              [
                51.4729405,
                32.4479535
              ],
              [
                51.4723838,
                32.4482334
              ],
              [
                51.4712738,
                32.4482333
              ],
              [
                51.4709937,
                32.4485133
              ],
              [
                51.4698839,
                32.4485133
              ],
              [
                51.4696072,
                32.4487932
              ],
              [
                51.4668273,
                32.4498947
              ],
              [
                51.4665505,
                32.4504546
              ],
              [
                51.4651606,
                32.4512853
              ],
              [
                51.4651606,
                32.4507345
              ],
              [
                51.4654371,
                32.4490641
              ],
              [
                51.4657172,
                32.446563
              ],
              [
                51.4659938,
                32.443511
              ],
              [
                51.4662706,
                32.4412897
              ],
              [
                51.4676605,
                32.4346169
              ],
              [
                51.4679406,
                32.4332265
              ],
              [
                51.4704406,
                32.4249013
              ],
              [
                51.4707171,
                32.4232308
              ],
              [
                51.4709937,
                32.4229509
              ],
              [
                51.4696072,
                32.4129554
              ],
              [
                51.468774,
                32.411014
              ],
              [
                51.4682172,
                32.4104542
              ],
              [
                51.4479068,
                32.3853159
              ],
              [
                51.440161,
                32.375727
              ],
              [
                51.437035,
                32.3730104
              ],
              [
                51.4337711,
                32.3701739
              ],
              [
                51.4334945,
                32.369894
              ],
              [
                51.4332144,
                32.3693432
              ],
              [
                51.4305733,
                32.3665888
              ],
              [
                51.4302138,
                32.3658418
              ],
              [
                51.4273756,
                32.3599434
              ],
              [
                51.4261335,
                32.3567445
              ],
              [
                51.4251223,
                32.3541399
              ],
              [
                51.4208794,
                32.349848
              ],
              [
                51.4180669,
                32.3470028
              ],
              [
                51.4080505,
                32.3418593
              ],
              [
                51.4030344,
                32.3387972
              ],
              [
                51.3975876,
                32.335472
              ],
              [
                51.3866184,
                32.3298954
              ],
              [
                51.3831982,
                32.326167
              ],
              [
                51.3829351,
                32.3257311
              ],
              [
                51.3751587,
                32.3129454
              ],
              [
                51.3398792,
                32.2737849
              ],
              [
                51.3387658,
                32.2723944
              ],
              [
                51.2909867,
                32.232945
              ],
              [
                51.2854299,
                32.2310037
              ],
              [
                51.2837633,
                32.2307238
              ],
              [
                51.2801534,
                32.2296132
              ],
              [
                51.2565403,
                32.2179473
              ],
              [
                51.2284841,
                32.1948863
              ],
              [
                51.2273741,
                32.1943355
              ],
              [
                51.2212629,
                32.190165
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555231,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نائین",
          "name:en": "Nain County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286366",
          "wikipedia": "fa:شهرستان نائین"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.5997023,
                32.8803556
              ],
              [
                52.6008075,
                32.8780405
              ],
              [
                52.6016635,
                32.8761735
              ],
              [
                52.6020485,
                32.8748743
              ],
              [
                52.6026458,
                32.8722464
              ],
              [
                52.6031382,
                32.870063
              ],
              [
                52.6041062,
                32.866336
              ],
              [
                52.6054103,
                32.862225
              ],
              [
                52.6073094,
                32.8582134
              ],
              [
                52.608082,
                32.85677
              ],
              [
                52.6088475,
                32.8533903
              ],
              [
                52.6104784,
                32.851543
              ],
              [
                52.6116586,
                32.8470363
              ],
              [
                52.6129889,
                32.8436111
              ],
              [
                52.6140189,
                32.838473
              ],
              [
                52.6163617,
                32.8346222
              ],
              [
                52.6230311,
                32.827042
              ],
              [
                52.6257992,
                32.8254373
              ],
              [
                52.6278591,
                32.8247521
              ],
              [
                52.6309705,
                32.8240849
              ],
              [
                52.6344251,
                32.824139
              ],
              [
                52.6355824,
                32.824351
              ],
              [
                52.6397922,
                32.8250924
              ],
              [
                52.6434083,
                32.8257537
              ],
              [
                52.6480384,
                32.8262765
              ],
              [
                52.6504556,
                32.8265944
              ],
              [
                52.6534787,
                32.8272161
              ],
              [
                52.6562685,
                32.8275766
              ],
              [
                52.6573784,
                32.8278738
              ],
              [
                52.6643488,
                32.8300193
              ],
              [
                52.6695595,
                32.8315795
              ],
              [
                52.6739467,
                32.8322285
              ],
              [
                52.6800348,
                32.8304169
              ],
              [
                52.682492,
                32.8292634
              ],
              [
                52.6882268,
                32.8261797
              ],
              [
                52.6906503,
                32.824917
              ],
              [
                52.6934646,
                32.8235005
              ],
              [
                52.6963748,
                32.8221578
              ],
              [
                52.7026346,
                32.8192536
              ],
              [
                52.7090898,
                32.8161158
              ],
              [
                52.7124498,
                32.8142537
              ],
              [
                52.7159618,
                32.8123317
              ],
              [
                52.7193772,
                32.8107783
              ],
              [
                52.7210816,
                32.8098671
              ],
              [
                52.7258343,
                32.8075091
              ],
              [
                52.7372074,
                32.802318
              ],
              [
                52.7407264,
                32.8009472
              ],
              [
                52.7432584,
                32.797917
              ],
              [
                52.7471208,
                32.791676
              ],
              [
                52.7490426,
                32.790177
              ],
              [
                52.7542275,
                32.7890372
              ],
              [
                52.7656602,
                32.7848573
              ],
              [
                52.7725696,
                32.7827647
              ],
              [
                52.7805948,
                32.7796978
              ],
              [
                52.7863986,
                32.776715
              ],
              [
                52.7904255,
                32.7744772
              ],
              [
                52.7983117,
                32.7687692
              ],
              [
                52.8064432,
                32.7586661
              ],
              [
                52.807374,
                32.7549786
              ],
              [
                52.8135818,
                32.7476576
              ],
              [
                52.8148842,
                32.7463884
              ],
              [
                52.8174921,
                32.7444335
              ],
              [
                52.8203627,
                32.7422492
              ],
              [
                52.8239085,
                32.7394786
              ],
              [
                52.8267582,
                32.7372491
              ],
              [
                52.8305492,
                32.7343598
              ],
              [
                52.8380213,
                32.7286179
              ],
              [
                52.8368017,
                32.7273901
              ],
              [
                52.8232097,
                32.7190604
              ],
              [
                52.8197911,
                32.7159011
              ],
              [
                52.8190898,
                32.7136804
              ],
              [
                52.8152242,
                32.7100504
              ],
              [
                52.8112556,
                32.7041281
              ],
              [
                52.8126538,
                32.6956388
              ],
              [
                52.8143828,
                32.6946022
              ],
              [
                52.8153258,
                32.6919565
              ],
              [
                52.8168457,
                32.6891485
              ],
              [
                52.8193044,
                32.6858005
              ],
              [
                52.8211927,
                32.6819356
              ],
              [
                52.8240611,
                32.6771935
              ],
              [
                52.8267781,
                32.6724164
              ],
              [
                52.8291397,
                32.6680103
              ],
              [
                52.8349371,
                32.6610223
              ],
              [
                52.8345855,
                32.6525741
              ],
              [
                52.8340243,
                32.643061
              ],
              [
                52.8340296,
                32.634621
              ],
              [
                52.833877,
                32.6295979
              ],
              [
                52.8334146,
                32.6226737
              ],
              [
                52.8326531,
                32.6158365
              ],
              [
                52.8318223,
                32.6068497
              ],
              [
                52.8300999,
                32.5964837
              ],
              [
                52.8396212,
                32.5924358
              ],
              [
                52.846277,
                32.5900821
              ],
              [
                52.8494706,
                32.5887732
              ],
              [
                52.8573004,
                32.5865138
              ],
              [
                52.87283,
                32.5821393
              ],
              [
                52.8816628,
                32.5822179
              ],
              [
                52.89746,
                32.5832819
              ],
              [
                52.9053867,
                32.5839172
              ],
              [
                52.9156494,
                32.5850788
              ],
              [
                52.9293687,
                32.58312
              ],
              [
                52.9348644,
                32.5794513
              ],
              [
                52.9384135,
                32.5771369
              ],
              [
                52.9414905,
                32.5749949
              ],
              [
                52.9438227,
                32.5735995
              ],
              [
                52.9450343,
                32.5729407
              ],
              [
                52.945784,
                32.5723982
              ],
              [
                52.9483102,
                32.5707263
              ],
              [
                52.9519941,
                32.5685137
              ],
              [
                52.9557752,
                32.5662736
              ],
              [
                52.9891848,
                32.541331
              ],
              [
                52.9973589,
                32.5411763
              ],
              [
                53.0003857,
                32.5408621
              ],
              [
                53.0089675,
                32.5395205
              ],
              [
                53.0250357,
                32.5370603
              ],
              [
                53.0335999,
                32.5356451
              ],
              [
                53.0337632,
                32.5358151
              ],
              [
                53.0452482,
                32.5375855
              ],
              [
                53.0571411,
                32.5396141
              ],
              [
                53.0685137,
                32.5408802
              ],
              [
                53.0832767,
                32.5283618
              ],
              [
                53.1062633,
                32.5325674
              ],
              [
                53.1307096,
                32.53187
              ],
              [
                53.1506558,
                32.527841
              ],
              [
                53.1697869,
                32.5242318
              ],
              [
                53.1913374,
                32.5222106
              ],
              [
                53.2096097,
                32.528934
              ],
              [
                53.2119365,
                32.5581462
              ],
              [
                53.2170115,
                32.6003287
              ],
              [
                53.2347649,
                32.6220997
              ],
              [
                53.2499055,
                32.6418765
              ],
              [
                53.278858,
                32.6512261
              ],
              [
                53.3031672,
                32.6543251
              ],
              [
                53.3282276,
                32.6491388
              ],
              [
                53.3595666,
                32.6375572
              ],
              [
                53.4146493,
                32.6162236
              ],
              [
                53.4356975,
                32.6090137
              ],
              [
                53.4499578,
                32.6024235
              ],
              [
                53.5222356,
                32.6306184
              ],
              [
                53.5694176,
                32.6525809
              ],
              [
                53.6016339,
                32.6666989
              ],
              [
                53.6351481,
                32.6817172
              ],
              [
                53.6605212,
                32.6925532
              ],
              [
                53.6781414,
                32.7007846
              ],
              [
                53.6858148,
                32.7043691
              ],
              [
                53.7178873,
                32.7171997
              ],
              [
                53.7542296,
                32.727309
              ],
              [
                53.7899485,
                32.7391591
              ],
              [
                53.8265207,
                32.7515759
              ],
              [
                53.863918,
                32.7650104
              ],
              [
                53.8934273,
                32.774879
              ],
              [
                53.9120142,
                32.7814909
              ],
              [
                53.9240985,
                32.7858955
              ],
              [
                53.9455039,
                32.7923077
              ],
              [
                53.9560573,
                32.7970349
              ],
              [
                53.9711135,
                32.8049274
              ],
              [
                53.9853235,
                32.8105343
              ],
              [
                53.9957834,
                32.8144697
              ],
              [
                54.0169048,
                32.8241738
              ],
              [
                54.0199997,
                32.8257447
              ],
              [
                54.0342008,
                32.8306916
              ],
              [
                54.0617025,
                32.8407625
              ],
              [
                54.1246602,
                32.8611662
              ],
              [
                54.1402981,
                32.867061
              ],
              [
                54.1496147,
                32.8703771
              ],
              [
                54.1587543,
                32.873099
              ],
              [
                54.1712774,
                32.8775683
              ],
              [
                54.2042706,
                32.8874055
              ],
              [
                54.2224605,
                32.8924583
              ],
              [
                54.2346355,
                32.8962496
              ],
              [
                54.2492537,
                32.8990505
              ],
              [
                54.2550669,
                32.9021926
              ],
              [
                54.2721217,
                32.9080346
              ],
              [
                54.2882295,
                32.9134001
              ],
              [
                54.3145738,
                32.920106
              ],
              [
                54.3327468,
                32.9234845
              ],
              [
                54.3626304,
                32.928984
              ],
              [
                54.3850765,
                32.9328258
              ],
              [
                54.4087926,
                32.9364832
              ],
              [
                54.4406894,
                32.9425643
              ],
              [
                54.4735352,
                32.9484705
              ],
              [
                54.5165123,
                32.9558958
              ],
              [
                54.5480564,
                32.9599288
              ],
              [
                54.579193,
                32.9656023
              ],
              [
                54.6057953,
                32.9684359
              ],
              [
                54.6572322,
                32.9657644
              ],
              [
                54.6940695,
                32.9610429
              ],
              [
                54.7361835,
                32.9572269
              ],
              [
                54.7365568,
                32.9848776
              ],
              [
                54.7383736,
                32.9981768
              ],
              [
                54.7422767,
                33.0021719
              ],
              [
                54.7496749,
                33.0123759
              ],
              [
                54.7548798,
                33.0214609
              ],
              [
                54.7612721,
                33.032471
              ],
              [
                54.7691723,
                33.0460375
              ],
              [
                54.7739064,
                33.0534423
              ],
              [
                54.7795701,
                33.0622749
              ],
              [
                54.7774661,
                33.0679934
              ],
              [
                54.7753331,
                33.0770338
              ],
              [
                54.7741602,
                33.0823169
              ],
              [
                54.7628376,
                33.1247809
              ],
              [
                54.7557233,
                33.1502095
              ],
              [
                54.7502803,
                33.1670854
              ],
              [
                54.7418976,
                33.1907128
              ],
              [
                54.7351086,
                33.2104285
              ],
              [
                54.7287687,
                33.2315687
              ],
              [
                54.7260146,
                33.2422764
              ],
              [
                54.7223802,
                33.2469037
              ],
              [
                54.7192954,
                33.2523981
              ],
              [
                54.7170081,
                33.2659466
              ],
              [
                54.710009,
                33.2918665
              ],
              [
                54.7078799,
                33.297319
              ],
              [
                54.7072624,
                33.3028733
              ],
              [
                54.6989535,
                33.3252931
              ],
              [
                54.6963952,
                33.3323888
              ],
              [
                54.6967611,
                33.3345031
              ],
              [
                54.6938037,
                33.3437225
              ],
              [
                54.6896813,
                33.3576791
              ],
              [
                54.6846039,
                33.3742252
              ],
              [
                54.6825471,
                33.3805506
              ],
              [
                54.6809291,
                33.3831138
              ],
              [
                54.6804879,
                33.3873356
              ],
              [
                54.6561249,
                33.4123933
              ],
              [
                54.6464931,
                33.4218722
              ],
              [
                54.6308586,
                33.4384124
              ],
              [
                54.6117702,
                33.4572539
              ],
              [
                54.5963858,
                33.4744086
              ],
              [
                54.5919226,
                33.4845744
              ],
              [
                54.5886793,
                33.4987241
              ],
              [
                54.5855283,
                33.5038287
              ],
              [
                54.5793475,
                33.5107911
              ],
              [
                54.5772886,
                33.5151718
              ],
              [
                54.5747268,
                33.523987
              ],
              [
                54.5705358,
                33.537282
              ],
              [
                54.5690917,
                33.5391055
              ],
              [
                54.5633651,
                33.5599365
              ],
              [
                54.561496,
                33.5672693
              ],
              [
                54.5585754,
                33.5749014
              ],
              [
                54.5577612,
                33.5847531
              ],
              [
                54.5562911,
                33.5938283
              ],
              [
                54.5540429,
                33.6018839
              ],
              [
                54.5516936,
                33.6142426
              ],
              [
                54.545777,
                33.6209288
              ],
              [
                54.5405855,
                33.6290436
              ],
              [
                54.5377173,
                33.6318488
              ],
              [
                54.5348657,
                33.6341388
              ],
              [
                54.529842,
                33.6388234
              ],
              [
                54.5204021,
                33.6469237
              ],
              [
                54.508139,
                33.6566604
              ],
              [
                54.4921857,
                33.6688881
              ],
              [
                54.4780711,
                33.6794543
              ],
              [
                54.4639199,
                33.691017
              ],
              [
                54.4240378,
                33.7083476
              ],
              [
                54.4030951,
                33.7207704
              ],
              [
                54.3593214,
                33.7484652
              ],
              [
                54.3372217,
                33.7684673
              ],
              [
                54.326325,
                33.7790512
              ],
              [
                54.3168136,
                33.7883496
              ],
              [
                54.3050755,
                33.7994898
              ],
              [
                54.2700049,
                33.8337677
              ],
              [
                54.251165,
                33.8534386
              ],
              [
                54.2235653,
                33.8939224
              ],
              [
                54.2106389,
                33.9129156
              ],
              [
                54.1962873,
                33.9335989
              ],
              [
                54.1910958,
                33.9428511
              ],
              [
                54.1884408,
                33.9476349
              ],
              [
                54.179961,
                33.9658173
              ],
              [
                54.1802786,
                33.9805206
              ],
              [
                54.1827609,
                33.991173
              ],
              [
                54.183314,
                33.9978452
              ],
              [
                54.1784442,
                34.0244311
              ],
              [
                54.1756527,
                34.044462
              ],
              [
                54.1906545,
                34.081978
              ],
              [
                54.2048575,
                34.1192364
              ],
              [
                54.2126866,
                34.1391744
              ],
              [
                54.2215375,
                34.1613122
              ],
              [
                54.2263798,
                34.1740167
              ],
              [
                54.2340547,
                34.1940971
              ],
              [
                54.2447995,
                34.2218565
              ],
              [
                54.2499703,
                34.2342332
              ],
              [
                54.2339897,
                34.2355854
              ],
              [
                54.2222209,
                34.2366143
              ],
              [
                54.197569,
                34.2385802
              ],
              [
                54.1807712,
                34.2392897
              ],
              [
                54.1546961,
                34.2397033
              ],
              [
                54.0271567,
                34.2465748
              ],
              [
                53.9991759,
                34.2479938
              ],
              [
                53.9072441,
                34.2465018
              ],
              [
                53.8732993,
                34.2468984
              ],
              [
                53.8446401,
                34.2457763
              ],
              [
                53.5343699,
                34.2450538
              ],
              [
                53.5190209,
                34.2458592
              ],
              [
                53.5166735,
                34.2458552
              ],
              [
                53.5121409,
                34.2459223
              ],
              [
                53.4983972,
                34.2458472
              ],
              [
                53.3660885,
                34.2461493
              ],
              [
                53.285751,
                34.2470006
              ],
              [
                53.2078925,
                34.2510909
              ],
              [
                53.194365,
                34.2519147
              ],
              [
                53.1735702,
                34.2532756
              ],
              [
                53.1697219,
                34.2534174
              ],
              [
                53.1351516,
                34.2554909
              ],
              [
                53.1004753,
                34.2578449
              ],
              [
                53.0810578,
                34.2585583
              ],
              [
                53.0697114,
                34.2595554
              ],
              [
                53.0413023,
                34.2611081
              ],
              [
                53.0256643,
                34.2620971
              ],
              [
                53.0033984,
                34.2640873
              ],
              [
                52.9816033,
                34.2642252
              ],
              [
                52.9678454,
                34.2644171
              ],
              [
                52.9502034,
                34.2647483
              ],
              [
                52.9205728,
                34.2654891
              ],
              [
                52.8943325,
                34.265161
              ],
              [
                52.8982223,
                34.2473744
              ],
              [
                52.9038263,
                34.227093
              ],
              [
                52.9091095,
                34.2062769
              ],
              [
                52.9156101,
                34.1775154
              ],
              [
                52.9240915,
                34.1418522
              ],
              [
                52.9373056,
                34.0819537
              ],
              [
                52.9399624,
                34.0512472
              ],
              [
                52.9417329,
                34.026292
              ],
              [
                52.9423361,
                34.004815
              ],
              [
                52.9459828,
                33.9801348
              ],
              [
                52.9498592,
                33.954839
              ],
              [
                52.9515341,
                33.9420519
              ],
              [
                52.9534123,
                33.9248422
              ],
              [
                52.9520556,
                33.9127291
              ],
              [
                52.9539439,
                33.8895397
              ],
              [
                52.9565112,
                33.8824443
              ],
              [
                52.9582945,
                33.8700336
              ],
              [
                52.9612845,
                33.8518204
              ],
              [
                52.9588672,
                33.8299644
              ],
              [
                52.9584249,
                33.8068868
              ],
              [
                52.961415,
                33.7834214
              ],
              [
                52.9649783,
                33.7690076
              ],
              [
                52.9699057,
                33.7487416
              ],
              [
                52.9772814,
                33.7352349
              ],
              [
                52.9828163,
                33.7212377
              ],
              [
                52.9888237,
                33.7049948
              ],
              [
                52.9918278,
                33.6911355
              ],
              [
                52.9939045,
                33.6831366
              ],
              [
                52.9963877,
                33.6670695
              ],
              [
                52.9947187,
                33.6475901
              ],
              [
                52.9926279,
                33.6363648
              ],
              [
                52.9908377,
                33.6266998
              ],
              [
                52.988082,
                33.6066088
              ],
              [
                52.9862986,
                33.5925841
              ],
              [
                52.9864929,
                33.5835434
              ],
              [
                52.9870661,
                33.5638543
              ],
              [
                52.9884203,
                33.5478169
              ],
              [
                52.9903944,
                33.5344109
              ],
              [
                52.99844,
                33.5069803
              ],
              [
                52.9971058,
                33.4906375
              ],
              [
                52.9972641,
                33.4811691
              ],
              [
                52.9956331,
                33.4735434
              ],
              [
                52.992289,
                33.4548525
              ],
              [
                52.9918658,
                33.4439334
              ],
              [
                52.9904079,
                33.4344498
              ],
              [
                52.9896675,
                33.4244828
              ],
              [
                52.9882106,
                33.4203414
              ],
              [
                52.98776,
                33.4082807
              ],
              [
                52.9887482,
                33.3946375
              ],
              [
                52.9893249,
                33.3773969
              ],
              [
                52.9926511,
                33.3627827
              ],
              [
                52.9952232,
                33.3468461
              ],
              [
                52.9962017,
                33.3383289
              ],
              [
                52.9934119,
                33.3217072
              ],
              [
                52.9888796,
                33.3046118
              ],
              [
                52.9848289,
                33.2855528
              ],
              [
                52.9825114,
                33.2708428
              ],
              [
                52.9776524,
                33.2487136
              ],
              [
                52.9792222,
                33.2446939
              ],
              [
                52.9793998,
                33.2414617
              ],
              [
                52.9767608,
                33.2194462
              ],
              [
                52.9730648,
                33.1903353
              ],
              [
                52.9704951,
                33.1660077
              ],
              [
                52.9671049,
                33.1602955
              ],
              [
                52.9628992,
                33.1555891
              ],
              [
                52.9540157,
                33.1496248
              ],
              [
                52.942686,
                33.143157
              ],
              [
                52.9414415,
                33.1415759
              ],
              [
                52.9272365,
                33.1358982
              ],
              [
                52.9145765,
                33.1301841
              ],
              [
                52.8984729,
                33.1220286
              ],
              [
                52.8872691,
                33.1157747
              ],
              [
                52.8716506,
                33.110465
              ],
              [
                52.856976,
                33.1050391
              ],
              [
                52.8471504,
                33.1028258
              ],
              [
                52.8375828,
                33.0991473
              ],
              [
                52.8309585,
                33.0965939
              ],
              [
                52.8196477,
                33.0899236
              ],
              [
                52.8135169,
                33.084949
              ],
              [
                52.8107558,
                33.0826417
              ],
              [
                52.8080545,
                33.0804434
              ],
              [
                52.805215,
                33.0776273
              ],
              [
                52.8022335,
                33.0747802
              ],
              [
                52.7992103,
                33.0706163
              ],
              [
                52.7962504,
                33.0661736
              ],
              [
                52.7938053,
                33.0624566
              ],
              [
                52.790125,
                33.0576588
              ],
              [
                52.7860557,
                33.0529991
              ],
              [
                52.7826475,
                33.048523
              ],
              [
                52.7804455,
                33.0448033
              ],
              [
                52.7780863,
                33.0408775
              ],
              [
                52.7756652,
                33.0374925
              ],
              [
                52.7734715,
                33.0341852
              ],
              [
                52.7688031,
                33.0271613
              ],
              [
                52.7652323,
                33.0214112
              ],
              [
                52.7597045,
                33.0132775
              ],
              [
                52.7569592,
                33.0076814
              ],
              [
                52.7567088,
                33.0003296
              ],
              [
                52.7560159,
                32.9935969
              ],
              [
                52.7547916,
                32.9896426
              ],
              [
                52.7538699,
                32.9864483
              ],
              [
                52.7524852,
                32.9837921
              ],
              [
                52.750082,
                32.9807682
              ],
              [
                52.7383232,
                32.9733519
              ],
              [
                52.7225861,
                32.9645552
              ],
              [
                52.7109465,
                32.9592796
              ],
              [
                52.6951787,
                32.9544543
              ],
              [
                52.6682424,
                32.9462738
              ],
              [
                52.6628128,
                32.9432393
              ],
              [
                52.658342,
                32.9407962
              ],
              [
                52.6551248,
                32.9392557
              ],
              [
                52.6520239,
                32.9375507
              ],
              [
                52.6482793,
                32.9346076
              ],
              [
                52.6436574,
                32.9308437
              ],
              [
                52.6414699,
                32.9289707
              ],
              [
                52.6368979,
                32.9249672
              ],
              [
                52.6317215,
                32.9196916
              ],
              [
                52.6240396,
                32.9087755
              ],
              [
                52.621808,
                32.9039475
              ],
              [
                52.6211214,
                32.898939
              ],
              [
                52.621293,
                32.8920925
              ],
              [
                52.6185894,
                32.8901826
              ],
              [
                52.6150041,
                32.8884578
              ],
              [
                52.6101687,
                32.8847426
              ],
              [
                52.6064589,
                32.8823363
              ],
              [
                52.5997023,
                32.8803556
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555232,
        "tags": {
          "admin_level": "5",
          "alt_name:ar": "مقاطعة نجفآباد",
          "boundary": "administrative",
          "name": "شهرستان نجف آباد",
          "name:ar": "مقاطعة نجف آباد",
          "name:en": "Najafabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279095",
          "wikipedia": "fa:شهرستان نجف‌آباد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.6009541,
                33.1118573
              ],
              [
                50.6009542,
                33.1104667
              ],
              [
                50.6012312,
                33.1101869
              ],
              [
                50.6012311,
                33.1093562
              ],
              [
                50.6017878,
                33.1082457
              ],
              [
                50.6028975,
                33.1065844
              ],
              [
                50.6267876,
                33.0765812
              ],
              [
                50.6281774,
                33.0746309
              ],
              [
                50.6281774,
                33.0743511
              ],
              [
                50.628734,
                33.0738003
              ],
              [
                50.6317873,
                33.0660263
              ],
              [
                50.6320673,
                33.0657464
              ],
              [
                50.6315107,
                33.0596337
              ],
              [
                50.6312341,
                33.0593539
              ],
              [
                50.6310964,
                33.059083
              ],
              [
                50.6317873,
                33.0588032
              ],
              [
                50.6326206,
                33.0588032
              ],
              [
                50.6387339,
                33.0557423
              ],
              [
                50.6651236,
                33.0379642
              ],
              [
                50.6654001,
                33.0374134
              ],
              [
                50.6726237,
                33.0326912
              ],
              [
                50.6737335,
                33.0326913
              ],
              [
                50.6737335,
                33.0324113
              ],
              [
                50.6745702,
                33.0324113
              ],
              [
                50.6754035,
                33.0321315
              ],
              [
                50.6773468,
                33.0321314
              ],
              [
                50.6776234,
                33.0324113
              ],
              [
                50.6790133,
                33.0324114
              ],
              [
                50.6792902,
                33.0326913
              ],
              [
                50.6856802,
                33.033522
              ],
              [
                50.6884568,
                33.033522
              ],
              [
                50.6890135,
                33.0338019
              ],
              [
                50.6906798,
                33.0338018
              ],
              [
                50.6909565,
                33.0340818
              ],
              [
                50.6981797,
                33.0351923
              ],
              [
                50.7020699,
                33.0351923
              ],
              [
                50.7062365,
                33.036023
              ],
              [
                50.7070697,
                33.0357431
              ],
              [
                50.7095697,
                33.0354722
              ],
              [
                50.7104029,
                33.0354723
              ],
              [
                50.715683,
                33.0343527
              ],
              [
                50.7267927,
                33.0326913
              ],
              [
                50.7279027,
                33.0321315
              ],
              [
                50.7342927,
                33.0304611
              ],
              [
                50.7356828,
                33.0299104
              ],
              [
                50.7476258,
                33.0221364
              ],
              [
                50.7645724,
                33.0126829
              ],
              [
                50.7822127,
                33.0035885
              ],
              [
                50.790962,
                32.9990762
              ],
              [
                50.8231849,
                32.9910223
              ],
              [
                50.8559645,
                32.9815779
              ],
              [
                50.8581878,
                32.9812979
              ],
              [
                50.867911,
                32.9779662
              ],
              [
                50.869021,
                32.9779663
              ],
              [
                50.9143004,
                32.9685218
              ],
              [
                50.9159671,
                32.9685218
              ],
              [
                50.9170804,
                32.9682419
              ],
              [
                50.9184671,
                32.9682419
              ],
              [
                50.927637,
                32.9660207
              ],
              [
                50.9290236,
                32.9660208
              ],
              [
                50.9354135,
                32.9643594
              ],
              [
                50.9362467,
                32.9640795
              ],
              [
                50.9490267,
                32.9513033
              ],
              [
                50.9501367,
                32.9507435
              ],
              [
                50.9565267,
                32.9460213
              ],
              [
                50.9620833,
                32.9435202
              ],
              [
                50.9629165,
                32.9435202
              ],
              [
                50.9734696,
                32.938518
              ],
              [
                50.9737497,
                32.9382381
              ],
              [
                50.9765263,
                32.9365767
              ],
              [
                50.9765264,
                32.9362969
              ],
              [
                50.9770829,
                32.936017
              ],
              [
                50.9776397,
                32.935737
              ],
              [
                50.9915262,
                32.9260217
              ],
              [
                50.9998628,
                32.9168571
              ],
              [
                51.006806,
                32.911295
              ],
              [
                51.0087493,
                32.9096337
              ],
              [
                51.0190292,
                32.903521
              ],
              [
                51.0206958,
                32.9029611
              ],
              [
                51.0231959,
                32.9012997
              ],
              [
                51.0251391,
                32.9004601
              ],
              [
                51.0506955,
                32.8854625
              ],
              [
                51.0723652,
                32.8762979
              ],
              [
                51.1004214,
                32.8665735
              ],
              [
                51.1012548,
                32.8660136
              ],
              [
                51.1098681,
                32.862411
              ],
              [
                51.1107014,
                32.862411
              ],
              [
                51.1109782,
                32.8621311
              ],
              [
                51.1115348,
                32.8621311
              ],
              [
                51.1129213,
                32.8615802
              ],
              [
                51.1140346,
                32.8615803
              ],
              [
                51.1237546,
                32.8585193
              ],
              [
                51.1243112,
                32.8585194
              ],
              [
                51.1251446,
                32.8582394
              ],
              [
                51.1257013,
                32.8582395
              ],
              [
                51.1265345,
                32.8579595
              ],
              [
                51.1276445,
                32.8582395
              ],
              [
                51.1279245,
                32.8579595
              ],
              [
                51.1293111,
                32.8579596
              ],
              [
                51.1304244,
                32.8582394
              ],
              [
                51.1318112,
                32.8582395
              ],
              [
                51.1323678,
                32.8585194
              ],
              [
                51.1373677,
                32.8585194
              ],
              [
                51.1382011,
                32.8587992
              ],
              [
                51.140701,
                32.8587993
              ],
              [
                51.1412576,
                32.8585193
              ],
              [
                51.1465343,
                32.8585194
              ],
              [
                51.147091,
                32.8587993
              ],
              [
                51.1509808,
                32.8587993
              ],
              [
                51.1515342,
                32.8585194
              ],
              [
                51.1529242,
                32.8585194
              ],
              [
                51.1540341,
                32.8582395
              ],
              [
                51.1545909,
                32.8582395
              ],
              [
                51.1557006,
                32.8585194
              ],
              [
                51.1573675,
                32.8587993
              ],
              [
                51.1579241,
                32.8590792
              ],
              [
                51.161534,
                32.85963
              ],
              [
                51.1640341,
                32.85963
              ],
              [
                51.164314,
                32.8599099
              ],
              [
                51.1765372,
                32.8629618
              ],
              [
                51.1782038,
                32.8629619
              ],
              [
                51.1784804,
                32.8632417
              ],
              [
                51.1829236,
                32.8632417
              ],
              [
                51.1834804,
                32.8629619
              ],
              [
                51.2055368,
                32.8376954
              ],
              [
                51.2087513,
                32.8315674
              ],
              [
                51.2096155,
                32.830609
              ],
              [
                51.2100994,
                32.8295344
              ],
              [
                51.2244436,
                32.8152725
              ],
              [
                51.2320478,
                32.8055697
              ],
              [
                51.232117,
                32.8047272
              ],
              [
                51.2413802,
                32.7865387
              ],
              [
                51.2415876,
                32.785696
              ],
              [
                51.2415185,
                32.785202
              ],
              [
                51.240447,
                32.7821508
              ],
              [
                51.2275198,
                32.7616033
              ],
              [
                51.1986238,
                32.723402
              ],
              [
                51.2239251,
                32.687337
              ],
              [
                51.227105,
                32.6774457
              ],
              [
                51.224429,
                32.6721874
              ],
              [
                51.2159924,
                32.6755824
              ],
              [
                51.1951464,
                32.6836922
              ],
              [
                51.1857649,
                32.6878283
              ],
              [
                51.1912962,
                32.6394994
              ],
              [
                51.192817,
                32.5976932
              ],
              [
                51.1986238,
                32.5721807
              ],
              [
                51.1930935,
                32.540717
              ],
              [
                51.1862609,
                32.5268434
              ],
              [
                51.1873709,
                32.5271234
              ],
              [
                51.1876475,
                32.5274034
              ],
              [
                51.1884809,
                32.5274033
              ],
              [
                51.1966065,
                32.5307977
              ],
              [
                51.2127382,
                32.5171993
              ],
              [
                51.2466644,
                32.5079284
              ],
              [
                51.2622747,
                32.5066904
              ],
              [
                51.2756367,
                32.497484
              ],
              [
                51.2861692,
                32.4992983
              ],
              [
                51.2997172,
                32.5249286
              ],
              [
                51.3163524,
                32.5310953
              ],
              [
                51.3168161,
                32.5363833
              ],
              [
                51.3202959,
                32.538947
              ],
              [
                51.3308354,
                32.5467112
              ],
              [
                51.3459657,
                32.5618166
              ],
              [
                51.3663185,
                32.5479996
              ],
              [
                51.3765449,
                32.5321258
              ],
              [
                51.3879683,
                32.5109838
              ],
              [
                51.3993444,
                32.5119027
              ],
              [
                51.4062933,
                32.5064911
              ],
              [
                51.406934,
                32.505694
              ],
              [
                51.4137889,
                32.5000521
              ],
              [
                51.4181184,
                32.4971031
              ],
              [
                51.4209592,
                32.5005925
              ],
              [
                51.4213031,
                32.5005926
              ],
              [
                51.4217808,
                32.5016109
              ],
              [
                51.4227078,
                32.5022841
              ],
              [
                51.4236347,
                32.502371
              ],
              [
                51.4252827,
                32.5018932
              ],
              [
                51.4291451,
                32.5001993
              ],
              [
                51.4299433,
                32.5002645
              ],
              [
                51.430278,
                32.500764
              ],
              [
                51.4326185,
                32.5070423
              ],
              [
                51.4353221,
                32.5129268
              ],
              [
                51.4371246,
                32.5180945
              ],
              [
                51.4393276,
                32.5265637
              ],
              [
                51.4390475,
                32.5298956
              ],
              [
                51.4387707,
                32.5335073
              ],
              [
                51.4384941,
                32.5371192
              ],
              [
                51.4382141,
                32.5379589
              ],
              [
                51.437661,
                32.5412907
              ],
              [
                51.4373809,
                32.5432321
              ],
              [
                51.4359943,
                32.5526769
              ],
              [
                51.4325063,
                32.5609459
              ],
              [
                51.4319689,
                32.5632301
              ],
              [
                51.4315827,
                32.5647097
              ],
              [
                51.4313253,
                32.5654214
              ],
              [
                51.4312425,
                32.5671797
              ],
              [
                51.4312671,
                32.5718637
              ],
              [
                51.4320653,
                32.5760299
              ],
              [
                51.4352839,
                32.5811505
              ],
              [
                51.4382193,
                32.585121
              ],
              [
                51.4409942,
                32.5879549
              ],
              [
                51.4417024,
                32.588565
              ],
              [
                51.4457193,
                32.5914721
              ],
              [
                51.4518476,
                32.5940538
              ],
              [
                51.4539076,
                32.5944876
              ],
              [
                51.455825,
                32.5952238
              ],
              [
                51.4601357,
                32.5990931
              ],
              [
                51.4613353,
                32.6001698
              ],
              [
                51.4616201,
                32.6006828
              ],
              [
                51.4620821,
                32.6015148
              ],
              [
                51.4627047,
                32.6079968
              ],
              [
                51.462803,
                32.6090199
              ],
              [
                51.463524,
                32.6176956
              ],
              [
                51.4879162,
                32.6172158
              ],
              [
                51.4930238,
                32.6172184
              ],
              [
                51.4900113,
                32.6252007
              ],
              [
                51.4876166,
                32.6250272
              ],
              [
                51.4874364,
                32.6276946
              ],
              [
                51.4865609,
                32.6278681
              ],
              [
                51.4866124,
                32.6316414
              ],
              [
                51.4877454,
                32.6364119
              ],
              [
                51.4888784,
                32.6390356
              ],
              [
                51.4894191,
                32.6401197
              ],
              [
                51.4901401,
                32.6414424
              ],
              [
                51.4898311,
                32.6420928
              ],
              [
                51.4896508,
                32.6426782
              ],
              [
                51.4900113,
                32.6435672
              ],
              [
                51.4890844,
                32.644196
              ],
              [
                51.4880286,
                32.6444995
              ],
              [
                51.4879514,
                32.6439575
              ],
              [
                51.468073,
                32.6448898
              ],
              [
                51.4683047,
                32.6461473
              ],
              [
                51.468382,
                32.6467761
              ],
              [
                51.4685622,
                32.6477084
              ],
              [
                51.4691287,
                32.6487274
              ],
              [
                51.4693862,
                32.6500716
              ],
              [
                51.4687425,
                32.6522829
              ],
              [
                51.4651891,
                32.6648563
              ],
              [
                51.4622892,
                32.6750397
              ],
              [
                51.4615341,
                32.6775935
              ],
              [
                51.4612348,
                32.6787258
              ],
              [
                51.4608293,
                32.6799466
              ],
              [
                51.4521038,
                32.6962898
              ],
              [
                51.4312707,
                32.7176804
              ],
              [
                51.4307141,
                32.718791
              ],
              [
                51.4287707,
                32.7232335
              ],
              [
                51.428214,
                32.7249038
              ],
              [
                51.4259907,
                32.7307368
              ],
              [
                51.4246042,
                32.7326781
              ],
              [
                51.4198808,
                32.7374095
              ],
              [
                51.4198808,
                32.7379603
              ],
              [
                51.4193242,
                32.7382402
              ],
              [
                51.4165475,
                32.7429625
              ],
              [
                51.4162708,
                32.7437932
              ],
              [
                51.4148809,
                32.747125
              ],
              [
                51.4140476,
                32.7504569
              ],
              [
                51.413771,
                32.750177
              ],
              [
                51.4118242,
                32.750177
              ],
              [
                51.4112709,
                32.7504569
              ],
              [
                51.4104377,
                32.7504569
              ],
              [
                51.4101576,
                32.750177
              ],
              [
                51.4093242,
                32.750177
              ],
              [
                51.4090477,
                32.7504569
              ],
              [
                51.4076575,
                32.7504569
              ],
              [
                51.4065475,
                32.7507369
              ],
              [
                51.4065476,
                32.7510168
              ],
              [
                51.4051577,
                32.7510167
              ],
              [
                51.4046011,
                32.7512966
              ],
              [
                51.4001578,
                32.7512966
              ],
              [
                51.3996012,
                32.7510167
              ],
              [
                51.3965477,
                32.7510167
              ],
              [
                51.3957145,
                32.7507368
              ],
              [
                51.3818246,
                32.7507368
              ],
              [
                51.3807113,
                32.7510167
              ],
              [
                51.3793248,
                32.7510167
              ],
              [
                51.3782113,
                32.7512966
              ],
              [
                51.3757114,
                32.7512966
              ],
              [
                51.3718215,
                32.7518474
              ],
              [
                51.3576549,
                32.7540686
              ],
              [
                51.3571017,
                32.7543485
              ],
              [
                51.3557116,
                32.7543485
              ],
              [
                51.3551549,
                32.7546284
              ],
              [
                51.3534883,
                32.7546285
              ],
              [
                51.3529316,
                32.7549083
              ],
              [
                51.351265,
                32.7549083
              ],
              [
                51.3495984,
                32.7551792
              ],
              [
                51.3357119,
                32.7574004
              ],
              [
                51.3337653,
                32.7579602
              ],
              [
                51.3329318,
                32.7579602
              ],
              [
                51.3326553,
                32.7582402
              ],
              [
                51.3315419,
                32.7582402
              ],
              [
                51.3037656,
                32.7737886
              ],
              [
                51.3034855,
                32.7743485
              ],
              [
                51.3023755,
                32.7757389
              ],
              [
                51.2912625,
                32.7887953
              ],
              [
                51.2909858,
                32.7896261
              ],
              [
                51.2901524,
                32.7904658
              ],
              [
                51.2807093,
                32.8185198
              ],
              [
                51.2804292,
                32.8187997
              ],
              [
                51.2801526,
                32.8199103
              ],
              [
                51.2798758,
                32.820741
              ],
              [
                51.2795959,
                32.8210119
              ],
              [
                51.2740392,
                32.8332466
              ],
              [
                51.265706,
                32.8582396
              ],
              [
                51.2654294,
                32.8585195
              ],
              [
                51.2651527,
                32.8596301
              ],
              [
                51.2648728,
                32.8604608
              ],
              [
                51.264596,
                32.8618513
              ],
              [
                51.2495962,
                32.8946274
              ],
              [
                51.2493162,
                32.8960179
              ],
              [
                51.248483,
                32.8993497
              ],
              [
                51.2476495,
                32.9001894
              ],
              [
                51.2463678,
                32.905331
              ],
              [
                51.2465031,
                32.9055927
              ],
              [
                51.2467858,
                32.9070829
              ],
              [
                51.2465031,
                32.9073335
              ],
              [
                51.2462629,
                32.9087943
              ],
              [
                51.2448728,
                32.9143562
              ],
              [
                51.2448729,
                32.9240807
              ],
              [
                51.2445963,
                32.9243516
              ],
              [
                51.2443161,
                32.9296336
              ],
              [
                51.2434827,
                32.9351866
              ],
              [
                51.2432062,
                32.936577
              ],
              [
                51.2429296,
                32.9396289
              ],
              [
                51.2426496,
                32.9407486
              ],
              [
                51.242373,
                32.9418501
              ],
              [
                51.2418161,
                32.9429697
              ],
              [
                51.2418161,
                32.9432406
              ],
              [
                51.2222038,
                32.9468616
              ],
              [
                51.2170969,
                32.9526342
              ],
              [
                51.2135253,
                32.9574098
              ],
              [
                51.2032256,
                32.9737573
              ],
              [
                51.1943646,
                32.9881551
              ],
              [
                51.1900494,
                32.9918241
              ],
              [
                51.1855195,
                32.9976937
              ],
              [
                51.1855694,
                33.0010203
              ],
              [
                51.2069579,
                33.0118193
              ],
              [
                51.2278149,
                33.0225576
              ],
              [
                51.2389455,
                33.0286342
              ],
              [
                51.2451195,
                33.0314787
              ],
              [
                51.2467693,
                33.0396327
              ],
              [
                51.2483368,
                33.0553947
              ],
              [
                51.248474,
                33.0726275
              ],
              [
                51.2484826,
                33.0860262
              ],
              [
                51.2482058,
                33.0946308
              ],
              [
                51.2482165,
                33.1002422
              ],
              [
                51.2489234,
                33.1130006
              ],
              [
                51.2479566,
                33.1161884
              ],
              [
                51.2398695,
                33.1149113
              ],
              [
                51.2266597,
                33.1125961
              ],
              [
                51.216259,
                33.1124306
              ],
              [
                51.201056,
                33.1080299
              ],
              [
                51.1897705,
                33.1084613
              ],
              [
                51.1738728,
                33.1009762
              ],
              [
                51.1667736,
                33.0961587
              ],
              [
                51.1618205,
                33.0937616
              ],
              [
                51.1537775,
                33.0927549
              ],
              [
                51.1242409,
                33.0936501
              ],
              [
                51.1022346,
                33.0955522
              ],
              [
                51.0874168,
                33.0948088
              ],
              [
                51.0753237,
                33.0986375
              ],
              [
                51.0568727,
                33.1103419
              ],
              [
                51.041728,
                33.1242638
              ],
              [
                51.0238765,
                33.1420888
              ],
              [
                51.0105388,
                33.1495905
              ],
              [
                50.9996652,
                33.1539504
              ],
              [
                50.998342,
                33.1545651
              ],
              [
                50.9971189,
                33.1554094
              ],
              [
                50.9907429,
                33.1587603
              ],
              [
                50.9881209,
                33.160156
              ],
              [
                50.9826037,
                33.1657555
              ],
              [
                50.97859,
                33.1699256
              ],
              [
                50.9735162,
                33.1748378
              ],
              [
                50.9625721,
                33.1872002
              ],
              [
                50.96004,
                33.1912226
              ],
              [
                50.9547083,
                33.197123
              ],
              [
                50.947803,
                33.2049024
              ],
              [
                50.942938,
                33.2104677
              ],
              [
                50.9391658,
                33.2145072
              ],
              [
                50.9355656,
                33.2185977
              ],
              [
                50.9325436,
                33.2224606
              ],
              [
                50.9262965,
                33.2363694
              ],
              [
                50.9221458,
                33.2407694
              ],
              [
                50.9165668,
                33.2498859
              ],
              [
                50.9122752,
                33.2585707
              ],
              [
                50.9068726,
                33.2633614
              ],
              [
                50.8971762,
                33.2704445
              ],
              [
                50.8930953,
                33.2733149
              ],
              [
                50.8799606,
                33.2788941
              ],
              [
                50.8607985,
                33.2849299
              ],
              [
                50.8464467,
                33.2881585
              ],
              [
                50.8409788,
                33.2894985
              ],
              [
                50.8371576,
                33.29034
              ],
              [
                50.8329103,
                33.2912728
              ],
              [
                50.8278533,
                33.292837
              ],
              [
                50.8195138,
                33.2946107
              ],
              [
                50.8097291,
                33.2965477
              ],
              [
                50.8009822,
                33.2988603
              ],
              [
                50.7905888,
                33.3004575
              ],
              [
                50.7864212,
                33.3005665
              ],
              [
                50.7796262,
                33.300405
              ],
              [
                50.7752307,
                33.3007126
              ],
              [
                50.7706851,
                33.3018065
              ],
              [
                50.7685847,
                33.3026802
              ],
              [
                50.764404,
                33.3045812
              ],
              [
                50.7598071,
                33.3072469
              ],
              [
                50.756759,
                33.3097145
              ],
              [
                50.753459,
                33.3119311
              ],
              [
                50.7448489,
                33.3026978
              ],
              [
                50.7448489,
                33.3021381
              ],
              [
                50.7420723,
                33.2960257
              ],
              [
                50.7404057,
                33.2893625
              ],
              [
                50.7404057,
                33.2888028
              ],
              [
                50.7337389,
                33.2751967
              ],
              [
                50.7276257,
                33.2665834
              ],
              [
                50.7231824,
                33.2610308
              ],
              [
                50.7209592,
                33.2571395
              ],
              [
                50.7073459,
                33.2446348
              ],
              [
                50.7070693,
                33.2443639
              ],
              [
                50.6970695,
                33.2376918
              ],
              [
                50.6962363,
                33.237141
              ],
              [
                50.6956797,
                33.2368611
              ],
              [
                50.6942929,
                33.2363103
              ],
              [
                50.6848462,
                33.229918
              ],
              [
                50.6745699,
                33.2235257
              ],
              [
                50.6548434,
                33.2032471
              ],
              [
                50.6531769,
                33.201306
              ],
              [
                50.6217874,
                33.1515843
              ],
              [
                50.6201205,
                33.1485236
              ],
              [
                50.602621,
                33.1171391
              ],
              [
                50.6015112,
                33.112408
              ],
              [
                50.6009541,
                33.1118573
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555234,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نطنز",
          "name:en": "Natanz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286468",
          "wikipedia": "fa:شهرستان نطنز"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.4182609,
                33.5775549
              ],
              [
                51.4249544,
                33.5757583
              ],
              [
                51.4274925,
                33.5744093
              ],
              [
                51.4323359,
                33.5734041
              ],
              [
                51.4381746,
                33.5722902
              ],
              [
                51.4462795,
                33.5705917
              ],
              [
                51.4533157,
                33.5688299
              ],
              [
                51.4618976,
                33.5667353
              ],
              [
                51.468472,
                33.5648402
              ],
              [
                51.4737146,
                33.5633886
              ],
              [
                51.4898604,
                33.5595245
              ],
              [
                51.4962266,
                33.5568007
              ],
              [
                51.4981556,
                33.5546641
              ],
              [
                51.5122088,
                33.5475018
              ],
              [
                51.5227762,
                33.5428096
              ],
              [
                51.5286338,
                33.5390784
              ],
              [
                51.5345012,
                33.5359932
              ],
              [
                51.5458641,
                33.5291859
              ],
              [
                51.5569133,
                33.5224207
              ],
              [
                51.5658759,
                33.5179268
              ],
              [
                51.5731237,
                33.514226
              ],
              [
                51.5950283,
                33.5030972
              ],
              [
                51.5997406,
                33.5005617
              ],
              [
                51.6091148,
                33.4959051
              ],
              [
                51.6251582,
                33.4869259
              ],
              [
                51.6230373,
                33.4831861
              ],
              [
                51.6203306,
                33.4789704
              ],
              [
                51.6172214,
                33.4747579
              ],
              [
                51.6159589,
                33.4676698
              ],
              [
                51.6139931,
                33.4644267
              ],
              [
                51.6133313,
                33.4617058
              ],
              [
                51.6079049,
                33.4569862
              ],
              [
                51.5994357,
                33.4517102
              ],
              [
                51.5959009,
                33.4493314
              ],
              [
                51.6047704,
                33.4388261
              ],
              [
                51.6117393,
                33.4311963
              ],
              [
                51.6309956,
                33.4161917
              ],
              [
                51.6490731,
                33.4066039
              ],
              [
                51.6689125,
                33.3961202
              ],
              [
                51.6817286,
                33.3829418
              ],
              [
                51.6945232,
                33.3629807
              ],
              [
                51.7015794,
                33.3460161
              ],
              [
                51.7058041,
                33.330405
              ],
              [
                51.710849,
                33.3103832
              ],
              [
                51.7166189,
                33.2940483
              ],
              [
                51.7198613,
                33.2656417
              ],
              [
                51.7204141,
                33.2586424
              ],
              [
                51.722249,
                33.2519253
              ],
              [
                51.7285594,
                33.2523123
              ],
              [
                51.7351245,
                33.2522351
              ],
              [
                51.738998,
                33.2528093
              ],
              [
                51.744147,
                33.2535358
              ],
              [
                51.7504129,
                33.2558451
              ],
              [
                51.7537975,
                33.2562972
              ],
              [
                51.7583942,
                33.2574402
              ],
              [
                51.7635293,
                33.2580034
              ],
              [
                51.7726056,
                33.2606692
              ],
              [
                51.7826842,
                33.2647429
              ],
              [
                51.8053801,
                33.2744128
              ],
              [
                51.8156475,
                33.2789433
              ],
              [
                51.8283462,
                33.2849788
              ],
              [
                51.8335818,
                33.2858398
              ],
              [
                51.8419074,
                33.2856963
              ],
              [
                51.8535804,
                33.2854093
              ],
              [
                51.8645667,
                33.286055
              ],
              [
                51.8724631,
                33.2855528
              ],
              [
                51.8826852,
                33.2851378
              ],
              [
                51.8893036,
                33.2839417
              ],
              [
                51.8985401,
                33.2789765
              ],
              [
                51.9020008,
                33.274743
              ],
              [
                51.916033,
                33.2624067
              ],
              [
                51.9278216,
                33.2561626
              ],
              [
                51.9540609,
                33.2577487
              ],
              [
                51.9631862,
                33.2647429
              ],
              [
                51.9670131,
                33.2662176
              ],
              [
                51.9867066,
                33.2659375
              ],
              [
                51.9983514,
                33.27001
              ],
              [
                52.0002351,
                33.2675337
              ],
              [
                52.0177075,
                33.2677149
              ],
              [
                52.0256064,
                33.2675714
              ],
              [
                52.0307087,
                33.2674351
              ],
              [
                52.0403437,
                33.2673221
              ],
              [
                52.0503326,
                33.2685493
              ],
              [
                52.05657,
                33.2695511
              ],
              [
                52.0660658,
                33.2692669
              ],
              [
                52.0725691,
                33.2691377
              ],
              [
                52.0983113,
                33.2714378
              ],
              [
                52.1136358,
                33.2737413
              ],
              [
                52.1237773,
                33.2753918
              ],
              [
                52.1295733,
                33.2770035
              ],
              [
                52.1362209,
                33.2789515
              ],
              [
                52.1372961,
                33.2805964
              ],
              [
                52.1405116,
                33.2849641
              ],
              [
                52.1417132,
                33.2917658
              ],
              [
                52.1395541,
                33.3043737
              ],
              [
                52.1365809,
                33.3088114
              ],
              [
                52.1363008,
                33.3093621
              ],
              [
                52.1271343,
                33.3229771
              ],
              [
                52.1243471,
                33.327532
              ],
              [
                52.1229616,
                33.3293185
              ],
              [
                52.1203926,
                33.3322496
              ],
              [
                52.111608,
                33.3423214
              ],
              [
                52.1071797,
                33.3480805
              ],
              [
                52.1023971,
                33.3549922
              ],
              [
                52.1010237,
                33.3572498
              ],
              [
                52.0988204,
                33.3602314
              ],
              [
                52.0970192,
                33.3641083
              ],
              [
                52.0950687,
                33.3743873
              ],
              [
                52.0947492,
                33.3824705
              ],
              [
                52.0947876,
                33.3870565
              ],
              [
                52.0957112,
                33.3981687
              ],
              [
                52.0969763,
                33.4046756
              ],
              [
                52.0978999,
                33.4140321
              ],
              [
                52.0981696,
                33.4183317
              ],
              [
                52.0967711,
                33.4267494
              ],
              [
                52.0956318,
                33.4343584
              ],
              [
                52.094332,
                33.4411932
              ],
              [
                52.0909546,
                33.4551868
              ],
              [
                52.0880088,
                33.4657645
              ],
              [
                52.0847282,
                33.4768119
              ],
              [
                52.0828602,
                33.4829439
              ],
              [
                52.0817254,
                33.4863821
              ],
              [
                52.0815344,
                33.4912534
              ],
              [
                52.0809539,
                33.4973455
              ],
              [
                52.0800777,
                33.5030899
              ],
              [
                52.0813322,
                33.5083732
              ],
              [
                52.0830005,
                33.5196743
              ],
              [
                52.0830005,
                33.5347912
              ],
              [
                52.0846503,
                33.5465472
              ],
              [
                52.0851833,
                33.5513385
              ],
              [
                52.0854696,
                33.5538298
              ],
              [
                52.0855555,
                33.5556118
              ],
              [
                52.0859847,
                33.5605793
              ],
              [
                52.0886635,
                33.5633759
              ],
              [
                52.0964598,
                33.5722403
              ],
              [
                52.0989502,
                33.5746588
              ],
              [
                52.1082621,
                33.5842581
              ],
              [
                52.1121342,
                33.5879806
              ],
              [
                52.1140773,
                33.5899305
              ],
              [
                52.1151907,
                33.5904812
              ],
              [
                52.1204674,
                33.5960424
              ],
              [
                52.1213006,
                33.5971527
              ],
              [
                52.1257439,
                33.606036
              ],
              [
                52.1254673,
                33.6063159
              ],
              [
                52.1249107,
                33.6074263
              ],
              [
                52.1013009,
                33.6196498
              ],
              [
                52.1004675,
                33.6204804
              ],
              [
                52.0999108,
                33.6204803
              ],
              [
                52.097411,
                33.6218706
              ],
              [
                52.1003401,
                33.6235249
              ],
              [
                52.1038034,
                33.6268931
              ],
              [
                52.1075187,
                33.6298419
              ],
              [
                52.1172497,
                33.6257705
              ],
              [
                52.1191011,
                33.6249635
              ],
              [
                52.1210179,
                33.6241476
              ],
              [
                52.1219574,
                33.6237301
              ],
              [
                52.1219764,
                33.6247523
              ],
              [
                52.1225166,
                33.6262531
              ],
              [
                52.1230805,
                33.6270629
              ],
              [
                52.1246292,
                33.6279287
              ],
              [
                52.1404669,
                33.6382648
              ],
              [
                52.1504703,
                33.6502084
              ],
              [
                52.1540803,
                33.6563111
              ],
              [
                52.15519,
                33.6588207
              ],
              [
                52.1554702,
                33.6590915
              ],
              [
                52.1790798,
                33.6960411
              ],
              [
                52.1918597,
                33.7107648
              ],
              [
                52.1954696,
                33.7146466
              ],
              [
                52.2182492,
                33.7413134
              ],
              [
                52.2185259,
                33.7424237
              ],
              [
                52.2354724,
                33.7754815
              ],
              [
                52.2360291,
                33.7757613
              ],
              [
                52.2368623,
                33.7774313
              ],
              [
                52.2379723,
                33.7782618
              ],
              [
                52.2415856,
                33.7843732
              ],
              [
                52.243529,
                33.7874334
              ],
              [
                52.2610285,
                33.8079881
              ],
              [
                52.2849182,
                33.8335436
              ],
              [
                52.285475,
                33.8335436
              ],
              [
                52.2963081,
                33.8446557
              ],
              [
                52.2982549,
                33.8471562
              ],
              [
                52.3365876,
                33.9079877
              ],
              [
                52.3377009,
                33.9104881
              ],
              [
                52.3390875,
                33.913819
              ],
              [
                52.3393676,
                33.9152091
              ],
              [
                52.3411726,
                33.9281307
              ],
              [
                52.3407543,
                33.9285504
              ],
              [
                52.3407543,
                33.9288213
              ],
              [
                52.3215879,
                33.953545
              ],
              [
                52.306588,
                33.9632664
              ],
              [
                52.3060313,
                33.9635462
              ],
              [
                52.3049213,
                33.9640968
              ],
              [
                52.3040881,
                33.9640968
              ],
              [
                52.303808,
                33.9643858
              ],
              [
                52.2954748,
                33.9677075
              ],
              [
                52.2926982,
                33.9677074
              ],
              [
                52.2921416,
                33.9679872
              ],
              [
                52.2899181,
                33.9679873
              ],
              [
                52.2896415,
                33.9682671
              ],
              [
                52.2838081,
                33.968267
              ],
              [
                52.282975,
                33.9679872
              ],
              [
                52.2813084,
                33.9679873
              ],
              [
                52.2743617,
                33.9663263
              ],
              [
                52.2732517,
                33.9657667
              ],
              [
                52.2385287,
                33.9535449
              ],
              [
                52.2371389,
                33.9532651
              ],
              [
                52.2299155,
                33.951875
              ],
              [
                52.2251957,
                33.9504849
              ],
              [
                52.2029692,
                33.9443738
              ],
              [
                52.1854696,
                33.9354828
              ],
              [
                52.1674131,
                33.9179891
              ],
              [
                52.1671363,
                33.9177093
              ],
              [
                52.1171339,
                33.8646591
              ],
              [
                52.1160238,
                33.8640995
              ],
              [
                52.1085206,
                33.8571488
              ],
              [
                52.1079672,
                33.8565982
              ],
              [
                52.1063144,
                33.8506711
              ],
              [
                52.0914782,
                33.8408719
              ],
              [
                52.0765675,
                33.8317918
              ],
              [
                52.0692109,
                33.8279416
              ],
              [
                52.0383485,
                33.8163336
              ],
              [
                52.0161239,
                33.8118687
              ],
              [
                51.9966784,
                33.8092508
              ],
              [
                51.9944967,
                33.8100461
              ],
              [
                51.9879571,
                33.8097965
              ],
              [
                51.9843829,
                33.8103155
              ],
              [
                51.9758023,
                33.8091388
              ],
              [
                51.9635825,
                33.8074015
              ],
              [
                51.9390335,
                33.8035574
              ],
              [
                51.9354595,
                33.8029869
              ],
              [
                51.931356,
                33.8027571
              ],
              [
                51.9262442,
                33.8023256
              ],
              [
                51.9045624,
                33.800664
              ],
              [
                51.8993325,
                33.8003286
              ],
              [
                51.8868468,
                33.8021474
              ],
              [
                51.8857335,
                33.8006531
              ],
              [
                51.8746901,
                33.8013676
              ],
              [
                51.8669078,
                33.801856
              ],
              [
                51.8585327,
                33.8020947
              ],
              [
                51.8514588,
                33.8029005
              ],
              [
                51.8454988,
                33.8035816
              ],
              [
                51.8357892,
                33.8035067
              ],
              [
                51.8303267,
                33.8006344
              ],
              [
                51.827568,
                33.797955
              ],
              [
                51.8204318,
                33.79112
              ],
              [
                51.8129543,
                33.7835424
              ],
              [
                51.8121211,
                33.7818724
              ],
              [
                51.7985079,
                33.7585371
              ],
              [
                51.797398,
                33.7563164
              ],
              [
                51.7925548,
                33.7490361
              ],
              [
                51.7886924,
                33.7399007
              ],
              [
                51.7840974,
                33.7333734
              ],
              [
                51.7807525,
                33.7302643
              ],
              [
                51.7694663,
                33.7224123
              ],
              [
                51.7632226,
                33.7199031
              ],
              [
                51.751356,
                33.7154873
              ],
              [
                51.7415713,
                33.7132026
              ],
              [
                51.7295356,
                33.7116155
              ],
              [
                51.7264777,
                33.7109488
              ],
              [
                51.7230527,
                33.7103119
              ],
              [
                51.7180586,
                33.7099156
              ],
              [
                51.7104148,
                33.7098469
              ],
              [
                51.7054742,
                33.7090945
              ],
              [
                51.702148,
                33.7086188
              ],
              [
                51.6972754,
                33.7079762
              ],
              [
                51.6895652,
                33.706284
              ],
              [
                51.6790352,
                33.7029414
              ],
              [
                51.6729924,
                33.6994295
              ],
              [
                51.668082,
                33.6973345
              ],
              [
                51.6558265,
                33.6902457
              ],
              [
                51.6516898,
                33.6856904
              ],
              [
                51.6435098,
                33.6767828
              ],
              [
                51.6373729,
                33.6706042
              ],
              [
                51.6258504,
                33.6616329
              ],
              [
                51.6230679,
                33.6603353
              ],
              [
                51.6146207,
                33.6556111
              ],
              [
                51.6079078,
                33.653164
              ],
              [
                51.6017154,
                33.650113
              ],
              [
                51.592698,
                33.645201
              ],
              [
                51.5866861,
                33.6423161
              ],
              [
                51.5800593,
                33.640244
              ],
              [
                51.5717554,
                33.6383825
              ],
              [
                51.5653554,
                33.635314
              ],
              [
                51.5624261,
                33.6351981
              ],
              [
                51.5546321,
                33.6342021
              ],
              [
                51.5483665,
                33.6348095
              ],
              [
                51.5421082,
                33.6347395
              ],
              [
                51.5282202,
                33.6366106
              ],
              [
                51.4989838,
                33.6386682
              ],
              [
                51.4894324,
                33.6371615
              ],
              [
                51.483877,
                33.635539
              ],
              [
                51.471609,
                33.6343926
              ],
              [
                51.462661,
                33.6332492
              ],
              [
                51.4582214,
                33.6324889
              ],
              [
                51.4483458,
                33.6288442
              ],
              [
                51.4408371,
                33.6267776
              ],
              [
                51.437238,
                33.6245621
              ],
              [
                51.4342729,
                33.6183325
              ],
              [
                51.4338028,
                33.6099597
              ],
              [
                51.4322637,
                33.6018893
              ],
              [
                51.4231824,
                33.5884544
              ],
              [
                51.4204788,
                33.5830917
              ],
              [
                51.4193094,
                33.5796952
              ],
              [
                51.4182609,
                33.5775549
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555270,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چادگان",
          "name:en": "Chadegan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286589",
          "wikipedia": "fa:شهرستان چادگان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.2170825,
                32.6148066
              ],
              [
                50.2260489,
                32.6057079
              ],
              [
                50.2351236,
                32.5960466
              ],
              [
                50.2410617,
                32.5874328
              ],
              [
                50.241432,
                32.5837648
              ],
              [
                50.2497005,
                32.5739057
              ],
              [
                50.2546094,
                32.5642059
              ],
              [
                50.2585887,
                32.5641035
              ],
              [
                50.2641548,
                32.562877
              ],
              [
                50.2698578,
                32.5623535
              ],
              [
                50.2870232,
                32.5501633
              ],
              [
                50.2895633,
                32.5486018
              ],
              [
                50.3040388,
                32.5407153
              ],
              [
                50.313585,
                32.5379933
              ],
              [
                50.3153859,
                32.5371178
              ],
              [
                50.3218149,
                32.533818
              ],
              [
                50.3249725,
                32.5312445
              ],
              [
                50.3264907,
                32.5277062
              ],
              [
                50.3314292,
                32.5342874
              ],
              [
                50.3349928,
                32.5344126
              ],
              [
                50.3453697,
                32.5396833
              ],
              [
                50.3508231,
                32.543843
              ],
              [
                50.3549229,
                32.5473146
              ],
              [
                50.3599306,
                32.5482704
              ],
              [
                50.3657366,
                32.5488688
              ],
              [
                50.3645037,
                32.5520928
              ],
              [
                50.3666567,
                32.5550965
              ],
              [
                50.3728188,
                32.5609784
              ],
              [
                50.3725218,
                32.5644198
              ],
              [
                50.3756399,
                32.564983
              ],
              [
                50.3767535,
                32.5681114
              ],
              [
                50.3810596,
                32.5696755
              ],
              [
                50.3832868,
                32.5731166
              ],
              [
                50.3892261,
                32.5739299
              ],
              [
                50.3952527,
                32.573377
              ],
              [
                50.4029608,
                32.572491
              ],
              [
                50.4109071,
                32.5685561
              ],
              [
                50.4125261,
                32.5664544
              ],
              [
                50.4141883,
                32.5652963
              ],
              [
                50.4219774,
                32.5681998
              ],
              [
                50.4311348,
                32.5731291
              ],
              [
                50.4342776,
                32.5741551
              ],
              [
                50.4357862,
                32.5758937
              ],
              [
                50.4490742,
                32.581136
              ],
              [
                50.4588322,
                32.5848802
              ],
              [
                50.4630538,
                32.5877533
              ],
              [
                50.4712272,
                32.5890734
              ],
              [
                50.4766204,
                32.589905
              ],
              [
                50.4828217,
                32.5903938
              ],
              [
                50.4892956,
                32.5907794
              ],
              [
                50.4943811,
                32.5929429
              ],
              [
                50.4987431,
                32.5995428
              ],
              [
                50.4994448,
                32.6085367
              ],
              [
                50.5017168,
                32.6168224
              ],
              [
                50.5036752,
                32.6241214
              ],
              [
                50.504146,
                32.6257208
              ],
              [
                50.504708,
                32.6277127
              ],
              [
                50.5048772,
                32.6307843
              ],
              [
                50.5043624,
                32.6323653
              ],
              [
                50.5042696,
                32.6357422
              ],
              [
                50.5047512,
                32.638363
              ],
              [
                50.5009486,
                32.6437099
              ],
              [
                50.4956077,
                32.6448924
              ],
              [
                50.4829785,
                32.6457596
              ],
              [
                50.4842836,
                32.6474035
              ],
              [
                50.4826167,
                32.6471236
              ],
              [
                50.4787268,
                32.6471235
              ],
              [
                50.4784503,
                32.6468437
              ],
              [
                50.4709501,
                32.6465728
              ],
              [
                50.4703934,
                32.6468436
              ],
              [
                50.4678938,
                32.6468437
              ],
              [
                50.4676168,
                32.6471236
              ],
              [
                50.4670602,
                32.6471236
              ],
              [
                50.4667837,
                32.6471236
              ],
              [
                50.466227,
                32.6471236
              ],
              [
                50.4654338,
                32.6475224
              ],
              [
                50.4651137,
                32.6476835
              ],
              [
                50.4601135,
                32.6504555
              ],
              [
                50.4600501,
                32.6505929
              ],
              [
                50.458447,
                32.6540672
              ],
              [
                50.4581706,
                32.6546271
              ],
              [
                50.4584471,
                32.6599002
              ],
              [
                50.4581705,
                32.6607308
              ],
              [
                50.458447,
                32.6612907
              ],
              [
                50.4620605,
                32.6712863
              ],
              [
                50.4695602,
                32.6818417
              ],
              [
                50.4767833,
                32.6887942
              ],
              [
                50.4784502,
                32.6907356
              ],
              [
                50.4940063,
                32.7035121
              ],
              [
                50.4973628,
                32.705088
              ],
              [
                50.5087926,
                32.710453
              ],
              [
                50.5095529,
                32.7108099
              ],
              [
                50.5159457,
                32.7138098
              ],
              [
                50.5200427,
                32.7157321
              ],
              [
                50.5212295,
                32.7162888
              ],
              [
                50.5220627,
                32.7162888
              ],
              [
                50.5266062,
                32.7178068
              ],
              [
                50.5270627,
                32.7179593
              ],
              [
                50.5280973,
                32.7179592
              ],
              [
                50.5281726,
                32.7179592
              ],
              [
                50.528708,
                32.7180491
              ],
              [
                50.5288346,
                32.7180704
              ],
              [
                50.5298394,
                32.7182392
              ],
              [
                50.529994,
                32.7182703
              ],
              [
                50.5302404,
                32.7183199
              ],
              [
                50.5312292,
                32.7185191
              ],
              [
                50.5317835,
                32.7186544
              ],
              [
                50.5323391,
                32.71879
              ],
              [
                50.5330615,
                32.71879
              ],
              [
                50.5334832,
                32.71879
              ],
              [
                50.5342859,
                32.71879
              ],
              [
                50.5342859,
                32.7190698
              ],
              [
                50.5373392,
                32.7190699
              ],
              [
                50.5373391,
                32.7193498
              ],
              [
                50.5381724,
                32.7193498
              ],
              [
                50.5384525,
                32.7190699
              ],
              [
                50.5409526,
                32.7190698
              ],
              [
                50.5423806,
                32.7182429
              ],
              [
                50.5451313,
                32.7166501
              ],
              [
                50.5498848,
                32.7138973
              ],
              [
                50.5526263,
                32.7096555
              ],
              [
                50.550751,
                32.7015785
              ],
              [
                50.5539533,
                32.6942549
              ],
              [
                50.5504524,
                32.6904529
              ],
              [
                50.548673,
                32.6799061
              ],
              [
                50.5554232,
                32.6751534
              ],
              [
                50.5622097,
                32.6883087
              ],
              [
                50.5613247,
                32.6734644
              ],
              [
                50.5626951,
                32.6730437
              ],
              [
                50.565016,
                32.6723313
              ],
              [
                50.5717563,
                32.6867198
              ],
              [
                50.5788785,
                32.6912385
              ],
              [
                50.5871804,
                32.6840568
              ],
              [
                50.6023914,
                32.6869434
              ],
              [
                50.6058001,
                32.6932115
              ],
              [
                50.6147584,
                32.6878983
              ],
              [
                50.6181914,
                32.6935492
              ],
              [
                50.628897,
                32.6978593
              ],
              [
                50.6346592,
                32.7015252
              ],
              [
                50.6428126,
                32.7053236
              ],
              [
                50.664701,
                32.707094
              ],
              [
                50.6725323,
                32.7078661
              ],
              [
                50.6878443,
                32.7044672
              ],
              [
                50.6947619,
                32.706669
              ],
              [
                50.703063,
                32.7051584
              ],
              [
                50.7116515,
                32.7005607
              ],
              [
                50.7155032,
                32.7060378
              ],
              [
                50.7301267,
                32.7068534
              ],
              [
                50.7351266,
                32.7087947
              ],
              [
                50.7365165,
                32.7087947
              ],
              [
                50.7370732,
                32.7090746
              ],
              [
                50.7412398,
                32.7093455
              ],
              [
                50.7417932,
                32.7090746
              ],
              [
                50.7440165,
                32.7090746
              ],
              [
                50.7445732,
                32.7087947
              ],
              [
                50.7459597,
                32.7087947
              ],
              [
                50.7462397,
                32.7085148
              ],
              [
                50.7467931,
                32.7085147
              ],
              [
                50.7523497,
                32.7065735
              ],
              [
                50.7529063,
                32.7062935
              ],
              [
                50.7565163,
                32.704903
              ],
              [
                50.7567964,
                32.7043433
              ],
              [
                50.7573495,
                32.7043432
              ],
              [
                50.7598496,
                32.7029618
              ],
              [
                50.7606828,
                32.7029617
              ],
              [
                50.7606827,
                32.7026818
              ],
              [
                50.7670728,
                32.7004606
              ],
              [
                50.7684628,
                32.7004606
              ],
              [
                50.7690195,
                32.7001807
              ],
              [
                50.7701294,
                32.7001806
              ],
              [
                50.7758574,
                32.7034038
              ],
              [
                50.7757181,
                32.6982757
              ],
              [
                50.7763381,
                32.6966415
              ],
              [
                50.7778747,
                32.6968401
              ],
              [
                50.7798194,
                32.6972012
              ],
              [
                50.7899403,
                32.7007764
              ],
              [
                50.7945759,
                32.7040724
              ],
              [
                50.8123522,
                32.7079641
              ],
              [
                50.8290221,
                32.711296
              ],
              [
                50.8317987,
                32.7112959
              ],
              [
                50.8345753,
                32.7112959
              ],
              [
                50.8354085,
                32.711016
              ],
              [
                50.8429085,
                32.711016
              ],
              [
                50.8431885,
                32.7112959
              ],
              [
                50.8459652,
                32.7115668
              ],
              [
                50.8512451,
                32.7115669
              ],
              [
                50.8523551,
                32.7121267
              ],
              [
                50.8529118,
                32.7129574
              ],
              [
                50.8526317,
                32.7132373
              ],
              [
                50.8523551,
                32.7151786
              ],
              [
                50.8520783,
                32.7173998
              ],
              [
                50.8512452,
                32.7207407
              ],
              [
                50.850965,
                32.722962
              ],
              [
                50.850965,
                32.7249032
              ],
              [
                50.8506885,
                32.725454
              ],
              [
                50.8504117,
                32.7290747
              ],
              [
                50.8537449,
                32.7615714
              ],
              [
                50.8523551,
                32.7676843
              ],
              [
                50.8520782,
                32.7687949
              ],
              [
                50.8515216,
                32.7704654
              ],
              [
                50.851245,
                32.7721268
              ],
              [
                50.851245,
                32.7724067
              ],
              [
                50.8509649,
                32.7729574
              ],
              [
                50.8506884,
                32.774348
              ],
              [
                50.8506883,
                32.7749078
              ],
              [
                50.8279086,
                32.794077
              ],
              [
                50.819852,
                32.7999099
              ],
              [
                50.8192986,
                32.8004607
              ],
              [
                50.8184655,
                32.8012914
              ],
              [
                50.8179085,
                32.8015713
              ],
              [
                50.8179086,
                32.8018512
              ],
              [
                50.8042953,
                32.8146277
              ],
              [
                50.7923524,
                32.822411
              ],
              [
                50.7670726,
                32.8307359
              ],
              [
                50.7556827,
                32.8343476
              ],
              [
                50.7520729,
                32.8357381
              ],
              [
                50.7481829,
                32.8374085
              ],
              [
                50.7465164,
                32.8379593
              ],
              [
                50.7345731,
                32.8449027
              ],
              [
                50.7081801,
                32.8726858
              ],
              [
                50.7004034,
                32.8838007
              ],
              [
                50.6909567,
                32.8943559
              ],
              [
                50.6595674,
                32.918798
              ],
              [
                50.657624,
                32.9201884
              ],
              [
                50.6354008,
                32.9351859
              ],
              [
                50.6337344,
                32.9357367
              ],
              [
                50.6331773,
                32.9362965
              ],
              [
                50.6201209,
                32.9412986
              ],
              [
                50.5956747,
                32.9471315
              ],
              [
                50.5584517,
                32.9526843
              ],
              [
                50.5503952,
                32.9549145
              ],
              [
                50.5492854,
                32.9549145
              ],
              [
                50.5481753,
                32.9554652
              ],
              [
                50.5476808,
                32.9555896
              ],
              [
                50.547062,
                32.9543547
              ],
              [
                50.5370621,
                32.9571356
              ],
              [
                50.5345622,
                32.9576864
              ],
              [
                50.5165059,
                32.9635192
              ],
              [
                50.5115058,
                32.9635192
              ],
              [
                50.5112293,
                32.9637991
              ],
              [
                50.501506,
                32.9482419
              ],
              [
                50.4970595,
                32.9424091
              ],
              [
                50.4940059,
                32.9393572
              ],
              [
                50.492616,
                32.9379576
              ],
              [
                50.4915063,
                32.937127
              ],
              [
                50.4548368,
                32.9076827
              ],
              [
                50.46206,
                32.9060214
              ],
              [
                50.4651131,
                32.9024097
              ],
              [
                50.4667832,
                32.896297
              ],
              [
                50.4670598,
                32.8946265
              ],
              [
                50.4673363,
                32.8912947
              ],
              [
                50.4676164,
                32.890744
              ],
              [
                50.4673364,
                32.8896243
              ],
              [
                50.4659465,
                32.8779676
              ],
              [
                50.4723365,
                32.8599091
              ],
              [
                50.4723365,
                32.8593492
              ],
              [
                50.4726165,
                32.8582386
              ],
              [
                50.4737263,
                32.8526857
              ],
              [
                50.47456,
                32.8482343
              ],
              [
                50.4748365,
                32.8449025
              ],
              [
                50.4751166,
                32.8401892
              ],
              [
                50.4753932,
                32.8382389
              ],
              [
                50.4756698,
                32.837959
              ],
              [
                50.4759499,
                32.8343472
              ],
              [
                50.4762265,
                32.8335165
              ],
              [
                50.4751167,
                32.8229613
              ],
              [
                50.4681701,
                32.8071329
              ],
              [
                50.4648368,
                32.8018508
              ],
              [
                50.4642802,
                32.8012909
              ],
              [
                50.454837,
                32.7868531
              ],
              [
                50.454837,
                32.7851826
              ],
              [
                50.4551136,
                32.7793498
              ],
              [
                50.4553937,
                32.7771285
              ],
              [
                50.4556703,
                32.7765687
              ],
              [
                50.4556703,
                32.7654626
              ],
              [
                50.4556703,
                32.7649028
              ],
              [
                50.4553937,
                32.7632324
              ],
              [
                50.4526136,
                32.7599096
              ],
              [
                50.4517804,
                32.7599096
              ],
              [
                50.4515034,
                32.7596296
              ],
              [
                50.4484471,
                32.7596296
              ],
              [
                50.4481702,
                32.7593498
              ],
              [
                50.4451138,
                32.7593497
              ],
              [
                50.4448369,
                32.7596297
              ],
              [
                50.4426138,
                32.7596296
              ],
              [
                50.4417805,
                32.7599095
              ],
              [
                50.4365039,
                32.7604603
              ],
              [
                50.432614,
                32.7604603
              ],
              [
                50.4317803,
                32.7601804
              ],
              [
                50.402611,
                32.755458
              ],
              [
                50.3956676,
                32.755458
              ],
              [
                50.3951109,
                32.7551781
              ],
              [
                50.3920578,
                32.7549071
              ],
              [
                50.3840013,
                32.7551781
              ],
              [
                50.3831677,
                32.7549072
              ],
              [
                50.3826111,
                32.7549072
              ],
              [
                50.3734445,
                32.755178
              ],
              [
                50.3728878,
                32.7549072
              ],
              [
                50.3712214,
                32.7549072
              ],
              [
                50.3706647,
                32.7546272
              ],
              [
                50.369278,
                32.7546272
              ],
              [
                50.3578883,
                32.7487943
              ],
              [
                50.3576117,
                32.7485144
              ],
              [
                50.352055,
                32.7593496
              ],
              [
                50.3206653,
                32.7832322
              ],
              [
                50.3187188,
                32.7840718
              ],
              [
                50.3184421,
                32.783792
              ],
              [
                50.3184421,
                32.7832322
              ],
              [
                50.3184421,
                32.7829613
              ],
              [
                50.3181652,
                32.7829612
              ],
              [
                50.3181652,
                32.7826813
              ],
              [
                50.3181652,
                32.7824014
              ],
              [
                50.3176085,
                32.7812999
              ],
              [
                50.3126089,
                32.7707356
              ],
              [
                50.3120522,
                32.7704646
              ],
              [
                50.3017755,
                32.7551779
              ],
              [
                50.300109,
                32.752126
              ],
              [
                50.299829,
                32.7515752
              ],
              [
                50.2967758,
                32.746293
              ],
              [
                50.2837193,
                32.7143471
              ],
              [
                50.2837194,
                32.7062929
              ],
              [
                50.2839959,
                32.7057332
              ],
              [
                50.2839959,
                32.7054622
              ],
              [
                50.2837193,
                32.7049024
              ],
              [
                50.2839959,
                32.7043426
              ],
              [
                50.2837195,
                32.7015706
              ],
              [
                50.283996,
                32.7010108
              ],
              [
                50.2837194,
                32.6985096
              ],
              [
                50.283996,
                32.6960175
              ],
              [
                50.2842726,
                32.6929565
              ],
              [
                50.2845526,
                32.6907353
              ],
              [
                50.2848292,
                32.6899046
              ],
              [
                50.2845526,
                32.6896247
              ],
              [
                50.2848291,
                32.685733
              ],
              [
                50.2851058,
                32.6849023
              ],
              [
                50.2848292,
                32.682961
              ],
              [
                50.2851058,
                32.6821213
              ],
              [
                50.2848292,
                32.6818414
              ],
              [
                50.2839961,
                32.6704553
              ],
              [
                50.2845527,
                32.6674033
              ],
              [
                50.283996,
                32.6635117
              ],
              [
                50.2842726,
                32.6629519
              ],
              [
                50.2842725,
                32.6624011
              ],
              [
                50.2842726,
                32.6621212
              ],
              [
                50.2845527,
                32.6615704
              ],
              [
                50.2834394,
                32.656848
              ],
              [
                50.2811017,
                32.6453652
              ],
              [
                50.2803863,
                32.6418502
              ],
              [
                50.2764964,
                32.6365679
              ],
              [
                50.2662164,
                32.6282338
              ],
              [
                50.2634398,
                32.6271231
              ],
              [
                50.2628832,
                32.6268523
              ],
              [
                50.2545499,
                32.6235113
              ],
              [
                50.2537166,
                32.6235113
              ],
              [
                50.2359366,
                32.6182291
              ],
              [
                50.2209371,
                32.615457
              ],
              [
                50.2170825,
                32.6148066
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555288,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گلپایگان",
          "name:ar": "مقاطعة كلبايكان",
          "name:en": "Golpayegan County",
          "name:uk": "Ґольпаєґан",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282230",
          "wikipedia": "fa:شهرستان گلپایگان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.9478688,
                33.3874196
              ],
              [
                49.9484224,
                33.3871397
              ],
              [
                49.9487024,
                33.3865799
              ],
              [
                49.951479,
                33.3835283
              ],
              [
                49.951479,
                33.3829776
              ],
              [
                49.9520357,
                33.3826978
              ],
              [
                49.9620355,
                33.3763057
              ],
              [
                49.9767584,
                33.3721436
              ],
              [
                49.9903685,
                33.373534
              ],
              [
                49.9959249,
                33.3749153
              ],
              [
                49.9975917,
                33.3749153
              ],
              [
                49.998705,
                33.3751952
              ],
              [
                50.0023148,
                33.3754751
              ],
              [
                50.0028714,
                33.3754751
              ],
              [
                50.0034249,
                33.375755
              ],
              [
                50.0064817,
                33.375755
              ],
              [
                50.0100916,
                33.3743646
              ],
              [
                50.0106482,
                33.3738049
              ],
              [
                50.0153713,
                33.3715839
              ],
              [
                50.018148,
                33.3685323
              ],
              [
                50.0198148,
                33.3640813
              ],
              [
                50.0195382,
                33.3615895
              ],
              [
                50.0184281,
                33.3601901
              ],
              [
                50.0214812,
                33.3599192
              ],
              [
                50.0223149,
                33.3599192
              ],
              [
                50.0228715,
                33.3596394
              ],
              [
                50.0245379,
                33.3596394
              ],
              [
                50.0248145,
                33.3593595
              ],
              [
                50.0278712,
                33.3590886
              ],
              [
                50.0350944,
                33.3590887
              ],
              [
                50.0353714,
                33.3593595
              ],
              [
                50.0448176,
                33.3732542
              ],
              [
                50.0559276,
                33.3796373
              ],
              [
                50.0723174,
                33.3835285
              ],
              [
                50.0748174,
                33.3840882
              ],
              [
                50.0756507,
                33.3843591
              ],
              [
                50.076764,
                33.3843591
              ],
              [
                50.0787073,
                33.3849189
              ],
              [
                50.0798171,
                33.3849188
              ],
              [
                50.0806507,
                33.3851988
              ],
              [
                50.0831504,
                33.3851988
              ],
              [
                50.083707,
                33.3854787
              ],
              [
                50.1025968,
                33.3876996
              ],
              [
                50.1150967,
                33.3885303
              ],
              [
                50.1156533,
                33.3882504
              ],
              [
                50.1225964,
                33.3882504
              ],
              [
                50.1231535,
                33.3879705
              ],
              [
                50.1284333,
                33.3874198
              ],
              [
                50.1317666,
                33.3874198
              ],
              [
                50.1328764,
                33.3871399
              ],
              [
                50.1348197,
                33.38714
              ],
              [
                50.1359331,
                33.3868601
              ],
              [
                50.142043,
                33.38686
              ],
              [
                50.1473231,
                33.3865802
              ],
              [
                50.1873224,
                33.3813077
              ],
              [
                50.1895459,
                33.3813077
              ],
              [
                50.1901025,
                33.3810278
              ],
              [
                50.2220489,
                33.3749157
              ],
              [
                50.2248255,
                33.3746358
              ],
              [
                50.2253822,
                33.3743649
              ],
              [
                50.2348252,
                33.3751956
              ],
              [
                50.2348252,
                33.3754754
              ],
              [
                50.2392684,
                33.3799174
              ],
              [
                50.2389918,
                33.3801973
              ],
              [
                50.2359351,
                33.3857497
              ],
              [
                50.2181589,
                33.4021361
              ],
              [
                50.2162119,
                33.4040861
              ],
              [
                50.2117689,
                33.4101983
              ],
              [
                50.2114924,
                33.4104692
              ],
              [
                50.2112122,
                33.4113088
              ],
              [
                50.2117689,
                33.4154799
              ],
              [
                50.2148256,
                33.4177009
              ],
              [
                50.2181588,
                33.4177008
              ],
              [
                50.218712,
                33.417421
              ],
              [
                50.2206585,
                33.417421
              ],
              [
                50.2214922,
                33.4171411
              ],
              [
                50.2228821,
                33.4171411
              ],
              [
                50.2237153,
                33.4168613
              ],
              [
                50.225382,
                33.4168612
              ],
              [
                50.2298251,
                33.4160306
              ],
              [
                50.2342686,
                33.4140896
              ],
              [
                50.2414917,
                33.408808
              ],
              [
                50.2431582,
                33.4074176
              ],
              [
                50.2506584,
                33.3993645
              ],
              [
                50.2514915,
                33.3990846
              ],
              [
                50.2548248,
                33.3990846
              ],
              [
                50.2589949,
                33.4015854
              ],
              [
                50.2712146,
                33.4115888
              ],
              [
                50.2720478,
                33.4115888
              ],
              [
                50.2726045,
                33.4115888
              ],
              [
                50.2776046,
                33.4115888
              ],
              [
                50.2778846,
                33.411309
              ],
              [
                50.2792714,
                33.4113089
              ],
              [
                50.2798281,
                33.4110291
              ],
              [
                50.281218,
                33.411029
              ],
              [
                50.2823277,
                33.4104693
              ],
              [
                50.2842711,
                33.4079775
              ],
              [
                50.2845513,
                33.4068671
              ],
              [
                50.2848278,
                33.4065871
              ],
              [
                50.2839945,
                33.4013056
              ],
              [
                50.2823277,
                33.3979741
              ],
              [
                50.2712147,
                33.3876999
              ],
              [
                50.2698283,
                33.3860296
              ],
              [
                50.2653814,
                33.3793667
              ],
              [
                50.2648283,
                33.3715843
              ],
              [
                50.2651048,
                33.369914
              ],
              [
                50.2653814,
                33.3688126
              ],
              [
                50.2656615,
                33.3674132
              ],
              [
                50.265938,
                33.3665826
              ],
              [
                50.2678815,
                33.3618607
              ],
              [
                50.2689948,
                33.3621405
              ],
              [
                50.2703815,
                33.3629712
              ],
              [
                50.2712147,
                33.3629712
              ],
              [
                50.2717713,
                33.363251
              ],
              [
                50.2751046,
                33.3632511
              ],
              [
                50.2756613,
                33.3629712
              ],
              [
                50.2776046,
                33.3629712
              ],
              [
                50.2781613,
                33.3626913
              ],
              [
                50.2814946,
                33.3626913
              ],
              [
                50.2823278,
                33.3629712
              ],
              [
                50.2864947,
                33.3629712
              ],
              [
                50.2867713,
                33.3632511
              ],
              [
                50.2881612,
                33.3632512
              ],
              [
                50.2887178,
                33.363531
              ],
              [
                50.289828,
                33.363531
              ],
              [
                50.2920511,
                33.3643616
              ],
              [
                50.2934378,
                33.3643615
              ],
              [
                50.2939944,
                33.3646415
              ],
              [
                50.2953843,
                33.3646415
              ],
              [
                50.2956613,
                33.3649213
              ],
              [
                50.2989946,
                33.3651922
              ],
              [
                50.2995512,
                33.3649214
              ],
              [
                50.3037178,
                33.3649213
              ],
              [
                50.3067744,
                33.3640817
              ],
              [
                50.3159409,
                33.3618608
              ],
              [
                50.3176074,
                33.3610301
              ],
              [
                50.3189977,
                33.3604704
              ],
              [
                50.337054,
                33.3515864
              ],
              [
                50.3378872,
                33.3507558
              ],
              [
                50.3389974,
                33.3501962
              ],
              [
                50.3392739,
                33.3496364
              ],
              [
                50.3498304,
                33.3385314
              ],
              [
                50.3503871,
                33.3371409
              ],
              [
                50.352607,
                33.3335296
              ],
              [
                50.3526071,
                33.3332497
              ],
              [
                50.3534437,
                33.3313086
              ],
              [
                50.3598302,
                33.3201945
              ],
              [
                50.3667769,
                33.314642
              ],
              [
                50.3676104,
                33.314642
              ],
              [
                50.3678871,
                33.3143622
              ],
              [
                50.3689968,
                33.3143621
              ],
              [
                50.3703871,
                33.3138024
              ],
              [
                50.3723337,
                33.3135315
              ],
              [
                50.3790001,
                33.3135316
              ],
              [
                50.3795533,
                33.3132516
              ],
              [
                50.3856667,
                33.3132516
              ],
              [
                50.3859433,
                33.3135316
              ],
              [
                50.3870534,
                33.3135315
              ],
              [
                50.3873335,
                33.3135315
              ],
              [
                50.3884434,
                33.3138023
              ],
              [
                50.3892766,
                33.3138024
              ],
              [
                50.3901101,
                33.3138023
              ],
              [
                50.3912235,
                33.3143621
              ],
              [
                50.3920567,
                33.3143622
              ],
              [
                50.3923333,
                33.314642
              ],
              [
                50.3942766,
                33.3149129
              ],
              [
                50.3970568,
                33.3149129
              ],
              [
                50.3978899,
                33.3152018
              ],
              [
                50.402333,
                33.3160324
              ],
              [
                50.417613,
                33.3251964
              ],
              [
                50.4217795,
                33.3268577
              ],
              [
                50.4278894,
                33.3293586
              ],
              [
                50.4287231,
                33.3293585
              ],
              [
                50.4290027,
                33.3296384
              ],
              [
                50.4298363,
                33.3296384
              ],
              [
                50.4303894,
                33.3299183
              ],
              [
                50.4312226,
                33.3299183
              ],
              [
                50.4353896,
                33.330749
              ],
              [
                50.4401127,
                33.3307489
              ],
              [
                50.4428892,
                33.3307489
              ],
              [
                50.4453894,
                33.330749
              ],
              [
                50.4470558,
                33.3301982
              ],
              [
                50.4487262,
                33.3301982
              ],
              [
                50.4495594,
                33.3299184
              ],
              [
                50.4512257,
                33.3299183
              ],
              [
                50.4515024,
                33.3296385
              ],
              [
                50.4540025,
                33.3296384
              ],
              [
                50.4545591,
                33.3293586
              ],
              [
                50.4701156,
                33.3271376
              ],
              [
                50.4726157,
                33.3271376
              ],
              [
                50.4734489,
                33.3268577
              ],
              [
                50.4759489,
                33.3265868
              ],
              [
                50.4803919,
                33.3265869
              ],
              [
                50.4809487,
                33.326307
              ],
              [
                50.4831686,
                33.326307
              ],
              [
                50.4837253,
                33.3260271
              ],
              [
                50.4862253,
                33.3260271
              ],
              [
                50.4870589,
                33.3257472
              ],
              [
                50.5001151,
                33.3238061
              ],
              [
                50.5023386,
                33.3232464
              ],
              [
                50.5084484,
                33.3204746
              ],
              [
                50.5109485,
                33.3193641
              ],
              [
                50.5156716,
                33.3157527
              ],
              [
                50.5273383,
                33.3015779
              ],
              [
                50.5298383,
                33.2999167
              ],
              [
                50.5390049,
                33.2946351
              ],
              [
                50.5401182,
                33.2935245
              ],
              [
                50.5531748,
                33.2849203
              ],
              [
                50.5545611,
                33.2835299
              ],
              [
                50.5556744,
                33.2829701
              ],
              [
                50.5570612,
                33.2815797
              ],
              [
                50.5756744,
                33.2682535
              ],
              [
                50.5806742,
                33.2657526
              ],
              [
                50.5820644,
                33.2654727
              ],
              [
                50.6137307,
                33.2538078
              ],
              [
                50.6151206,
                33.2538078
              ],
              [
                50.617064,
                33.253248
              ],
              [
                50.6229005,
                33.2524173
              ],
              [
                50.6254005,
                33.2524174
              ],
              [
                50.6267872,
                33.2521374
              ],
              [
                50.6356769,
                33.2521375
              ],
              [
                50.63651,
                33.2518576
              ],
              [
                50.6415102,
                33.2518576
              ],
              [
                50.6520667,
                33.2504673
              ],
              [
                50.6548433,
                33.2496366
              ],
              [
                50.6559566,
                33.2496366
              ],
              [
                50.6587332,
                33.248806
              ],
              [
                50.6609567,
                33.2482552
              ],
              [
                50.6962363,
                33.237141
              ],
              [
                50.6970695,
                33.2376918
              ],
              [
                50.7070693,
                33.2443639
              ],
              [
                50.7073459,
                33.2446348
              ],
              [
                50.7209592,
                33.2571395
              ],
              [
                50.7231824,
                33.2610308
              ],
              [
                50.7276257,
                33.2665834
              ],
              [
                50.7337389,
                33.2751967
              ],
              [
                50.7404057,
                33.2888028
              ],
              [
                50.7404057,
                33.2893625
              ],
              [
                50.7420723,
                33.2960257
              ],
              [
                50.7448489,
                33.3021381
              ],
              [
                50.7448489,
                33.3026978
              ],
              [
                50.753459,
                33.3119311
              ],
              [
                50.7637384,
                33.3185338
              ],
              [
                50.7634619,
                33.3188046
              ],
              [
                50.749572,
                33.3310292
              ],
              [
                50.7290156,
                33.3438045
              ],
              [
                50.7287356,
                33.3440844
              ],
              [
                50.727349,
                33.3446351
              ],
              [
                50.7154025,
                33.3515869
              ],
              [
                50.7145691,
                33.3524176
              ],
              [
                50.7017924,
                33.3588097
              ],
              [
                50.7012358,
                33.3593604
              ],
              [
                50.6973459,
                33.3607507
              ],
              [
                50.6965127,
                33.3613106
              ],
              [
                50.6956794,
                33.3613105
              ],
              [
                50.6862363,
                33.3651927
              ],
              [
                50.6728996,
                33.3690839
              ],
              [
                50.6715129,
                33.3696436
              ],
              [
                50.6706797,
                33.3696437
              ],
              [
                50.6701231,
                33.3699146
              ],
              [
                50.6692899,
                33.3699145
              ],
              [
                50.667623,
                33.3704743
              ],
              [
                50.6670664,
                33.3704743
              ],
              [
                50.6667898,
                33.3707541
              ],
              [
                50.6653995,
                33.3707542
              ],
              [
                50.6628998,
                33.3713049
              ],
              [
                50.6623463,
                33.3715848
              ],
              [
                50.6609565,
                33.3715848
              ],
              [
                50.6606799,
                33.3718647
              ],
              [
                50.6598463,
                33.3718647
              ],
              [
                50.6592896,
                33.3721445
              ],
              [
                50.6576232,
                33.3721445
              ],
              [
                50.6490097,
                33.3738057
              ],
              [
                50.6370669,
                33.3763066
              ],
              [
                50.6362334,
                33.3765865
              ],
              [
                50.63512,
                33.3765865
              ],
              [
                50.6323433,
                33.3774171
              ],
              [
                50.6312335,
                33.3774171
              ],
              [
                50.6179005,
                33.384089
              ],
              [
                50.6167868,
                33.3857502
              ],
              [
                50.6156771,
                33.3877003
              ],
              [
                50.615397,
                33.3885309
              ],
              [
                50.6151204,
                33.3902012
              ],
              [
                50.6148438,
                33.3918624
              ],
              [
                50.6145637,
                33.3940833
              ],
              [
                50.6142871,
                33.3974148
              ],
              [
                50.6120636,
                33.4060278
              ],
              [
                50.6117871,
                33.4068675
              ],
              [
                50.6106769,
                33.4163111
              ],
              [
                50.6115104,
                33.4232537
              ],
              [
                50.611787,
                33.4240844
              ],
              [
                50.6115104,
                33.4282554
              ],
              [
                50.611787,
                33.4301965
              ],
              [
                50.6117871,
                33.4307472
              ],
              [
                50.6115105,
                33.4310361
              ],
              [
                50.6112303,
                33.4318667
              ],
              [
                50.6109538,
                33.4326973
              ],
              [
                50.6109538,
                33.4329772
              ],
              [
                50.6109538,
                33.433257
              ],
              [
                50.6109538,
                33.4335279
              ],
              [
                50.6106768,
                33.4338077
              ],
              [
                50.6087303,
                33.4382496
              ],
              [
                50.6078971,
                33.43964
              ],
              [
                50.5898403,
                33.4732517
              ],
              [
                50.5895638,
                33.4752019
              ],
              [
                50.5892873,
                33.4788041
              ],
              [
                50.5892873,
                33.4821445
              ],
              [
                50.5895639,
                33.4840855
              ],
              [
                50.5934537,
                33.4938087
              ],
              [
                50.599287,
                33.4990901
              ],
              [
                50.6020636,
                33.5021417
              ],
              [
                50.605677,
                33.5085335
              ],
              [
                50.6065102,
                33.5132552
              ],
              [
                50.6117868,
                33.5221387
              ],
              [
                50.6134533,
                33.5238179
              ],
              [
                50.6215101,
                33.5310403
              ],
              [
                50.6215101,
                33.531591
              ],
              [
                50.6223432,
                33.5321417
              ],
              [
                50.6245668,
                33.5446454
              ],
              [
                50.6242866,
                33.5452051
              ],
              [
                50.6228999,
                33.5543684
              ],
              [
                50.6206769,
                33.5596407
              ],
              [
                50.6167865,
                33.5646421
              ],
              [
                50.6167864,
                33.5652019
              ],
              [
                50.6162298,
                33.5657616
              ],
              [
                50.6134532,
                33.568813
              ],
              [
                50.5992869,
                33.5807568
              ],
              [
                50.5967868,
                33.5832575
              ],
              [
                50.5956736,
                33.5846478
              ],
              [
                50.591787,
                33.5927006
              ],
              [
                50.591507,
                33.5940908
              ],
              [
                50.5912304,
                33.5960408
              ],
              [
                50.5909535,
                33.5988124
              ],
              [
                50.5906734,
                33.6010332
              ],
              [
                50.5903969,
                33.6057546
              ],
              [
                50.5901202,
                33.6071449
              ],
              [
                50.5898401,
                33.6099254
              ],
              [
                50.5898402,
                33.6115956
              ],
              [
                50.5898402,
                33.6121463
              ],
              [
                50.5895635,
                33.6124261
              ],
              [
                50.5887303,
                33.618258
              ],
              [
                50.5887303,
                33.6282607
              ],
              [
                50.5878968,
                33.6346522
              ],
              [
                50.5884537,
                33.646316
              ],
              [
                50.5887303,
                33.649927
              ],
              [
                50.5884537,
                33.6502069
              ],
              [
                50.5881736,
                33.6515971
              ],
              [
                50.5876201,
                33.6540887
              ],
              [
                50.5873409,
                33.6543677
              ],
              [
                50.5870635,
                33.6540887
              ],
              [
                50.586787,
                33.6538179
              ],
              [
                50.5867868,
                33.6535381
              ],
              [
                50.5831736,
                33.6460362
              ],
              [
                50.5798402,
                33.6435355
              ],
              [
                50.5776168,
                33.6365932
              ],
              [
                50.5778969,
                33.6363134
              ],
              [
                50.5776168,
                33.6340925
              ],
              [
                50.5756738,
                33.6315919
              ],
              [
                50.5748403,
                33.631312
              ],
              [
                50.5742836,
                33.6307614
              ],
              [
                50.5631739,
                33.6282607
              ],
              [
                50.5612306,
                33.6282607
              ],
              [
                50.5601172,
                33.6279807
              ],
              [
                50.5587274,
                33.6282606
              ],
              [
                50.5428943,
                33.6299308
              ],
              [
                50.5376175,
                33.6304815
              ],
              [
                50.5292842,
                33.6332529
              ],
              [
                50.528171,
                33.633253
              ],
              [
                50.5267846,
                33.6338126
              ],
              [
                50.5256709,
                33.6338126
              ],
              [
                50.5251177,
                33.6340925
              ],
              [
                50.5126144,
                33.6360335
              ],
              [
                50.4837246,
                33.6343632
              ],
              [
                50.4737248,
                33.6313119
              ],
              [
                50.4695584,
                33.6313119
              ],
              [
                50.4687252,
                33.631032
              ],
              [
                50.4673349,
                33.631032
              ],
              [
                50.4667817,
                33.6313119
              ],
              [
                50.4656685,
                33.6313119
              ],
              [
                50.4642786,
                33.6318717
              ],
              [
                50.4598352,
                33.6327021
              ],
              [
                50.4573351,
                33.6332528
              ],
              [
                50.4559452,
                33.6332528
              ],
              [
                50.4556687,
                33.6335417
              ],
              [
                50.455112,
                33.6335417
              ],
              [
                50.4540018,
                33.6343633
              ],
              [
                50.4537253,
                33.6346521
              ],
              [
                50.4523354,
                33.6338125
              ],
              [
                50.4495588,
                33.6332528
              ],
              [
                50.4448352,
                33.6315918
              ],
              [
                50.4320557,
                33.6246495
              ],
              [
                50.4253892,
                33.6226995
              ],
              [
                50.4220556,
                33.6224286
              ],
              [
                50.4214988,
                33.6226995
              ],
              [
                50.4206656,
                33.6224286
              ],
              [
                50.4192793,
                33.6224286
              ],
              [
                50.4181656,
                33.6221487
              ],
              [
                50.4164991,
                33.6221488
              ],
              [
                50.4156659,
                33.6218689
              ],
              [
                50.4142792,
                33.6218689
              ],
              [
                50.4134459,
                33.621589
              ],
              [
                50.4117791,
                33.621589
              ],
              [
                50.4112225,
                33.6213092
              ],
              [
                50.4067759,
                33.6210383
              ],
              [
                50.400666,
                33.6210383
              ],
              [
                50.4001094,
                33.6207585
              ],
              [
                50.3992762,
                33.6210383
              ],
              [
                50.3987226,
                33.6207585
              ],
              [
                50.3934428,
                33.6207584
              ],
              [
                50.3928893,
                33.6204786
              ],
              [
                50.3909428,
                33.6204786
              ],
              [
                50.3884427,
                33.6204786
              ],
              [
                50.3884428,
                33.6201987
              ],
              [
                50.3864993,
                33.6199279
              ],
              [
                50.384274,
                33.6199256
              ],
              [
                50.3839997,
                33.619648
              ],
              [
                50.3831661,
                33.6199279
              ],
              [
                50.3823329,
                33.6199279
              ],
              [
                50.3820528,
                33.619648
              ],
              [
                50.380943,
                33.6196481
              ],
              [
                50.3801098,
                33.6193682
              ],
              [
                50.3787194,
                33.6193682
              ],
              [
                50.3781663,
                33.619648
              ],
              [
                50.3770531,
                33.6196481
              ],
              [
                50.3681631,
                33.6177071
              ],
              [
                50.3667763,
                33.6177071
              ],
              [
                50.3659431,
                33.6174272
              ],
              [
                50.3609433,
                33.6174272
              ],
              [
                50.3598297,
                33.6171474
              ],
              [
                50.3578867,
                33.6171473
              ],
              [
                50.3570531,
                33.6168675
              ],
              [
                50.3534432,
                33.6168675
              ],
              [
                50.3526065,
                33.6165876
              ],
              [
                50.3481635,
                33.6163168
              ],
              [
                50.3476068,
                33.6165876
              ],
              [
                50.3370535,
                33.615757
              ],
              [
                50.3370534,
                33.6154772
              ],
              [
                50.331217,
                33.6135363
              ],
              [
                50.3281634,
                33.6099252
              ],
              [
                50.3267736,
                33.6071446
              ],
              [
                50.3259403,
                33.6049238
              ],
              [
                50.3184406,
                33.5957606
              ],
              [
                50.3164972,
                33.5946502
              ],
              [
                50.2951043,
                33.5849272
              ],
              [
                50.2942706,
                33.5849273
              ],
              [
                50.2937175,
                33.5846473
              ],
              [
                50.2928842,
                33.5846474
              ],
              [
                50.2923276,
                33.5843675
              ],
              [
                50.2895509,
                33.5843675
              ],
              [
                50.2889943,
                33.5840876
              ],
              [
                50.2787175,
                33.5829772
              ],
              [
                50.2751043,
                33.5826973
              ],
              [
                50.2731613,
                33.5824265
              ],
              [
                50.2614946,
                33.5835369
              ],
              [
                50.2589945,
                33.5843674
              ],
              [
                50.2562144,
                33.5865883
              ],
              [
                50.2487146,
                33.600482
              ],
              [
                50.243438,
                33.6043729
              ],
              [
                50.2409383,
                33.6046438
              ],
              [
                50.2403816,
                33.604373
              ],
              [
                50.2389913,
                33.6043729
              ],
              [
                50.2381581,
                33.604093
              ],
              [
                50.2353814,
                33.6035334
              ],
              [
                50.2328815,
                33.6027028
              ],
              [
                50.2306583,
                33.6002021
              ],
              [
                50.228715,
                33.5932507
              ],
              [
                50.2259348,
                33.5888091
              ],
              [
                50.2153784,
                33.5799258
              ],
              [
                50.211212,
                33.5777048
              ],
              [
                50.2101018,
                33.5757548
              ],
              [
                50.2098252,
                33.5743736
              ],
              [
                50.2098253,
                33.5707534
              ],
              [
                50.2095452,
                33.5685326
              ],
              [
                50.2048251,
                33.5596401
              ],
              [
                50.2037118,
                33.556038
              ],
              [
                50.2034352,
                33.5524269
              ],
              [
                50.203992,
                33.5507567
              ],
              [
                50.2046897,
                33.5495951
              ],
              [
                50.206492,
                33.5465949
              ],
              [
                50.206492,
                33.5446448
              ],
              [
                50.2064921,
                33.5440941
              ],
              [
                50.2056588,
                33.542424
              ],
              [
                50.1917691,
                33.5310397
              ],
              [
                50.1906553,
                33.5310397
              ],
              [
                50.1884353,
                33.53048
              ],
              [
                50.1867689,
                33.5304799
              ],
              [
                50.1859358,
                33.5302001
              ],
              [
                50.1839888,
                33.5302001
              ],
              [
                50.1831556,
                33.5299202
              ],
              [
                50.1762125,
                33.5285299
              ],
              [
                50.1492663,
                33.5229777
              ],
              [
                50.1431528,
                33.5204769
              ],
              [
                50.1387094,
                33.5190867
              ],
              [
                50.09732,
                33.5068626
              ],
              [
                50.0845404,
                33.5049215
              ],
              [
                50.0798169,
                33.5043708
              ],
              [
                50.0789836,
                33.504082
              ],
              [
                50.0764836,
                33.5038111
              ],
              [
                50.073707,
                33.5038111
              ],
              [
                50.0725972,
                33.5035312
              ],
              [
                50.071207,
                33.5035313
              ],
              [
                50.0545406,
                33.5010304
              ],
              [
                50.052594,
                33.5010304
              ],
              [
                50.0514839,
                33.5007506
              ],
              [
                50.0342609,
                33.4996491
              ],
              [
                50.0284275,
                33.4996491
              ],
              [
                50.0270377,
                33.4993603
              ],
              [
                49.987315,
                33.4940878
              ],
              [
                49.9853682,
                33.4929773
              ],
              [
                49.9837016,
                33.4924176
              ],
              [
                49.9745351,
                33.4801935
              ],
              [
                49.973425,
                33.4771421
              ],
              [
                49.973425,
                33.4765823
              ],
              [
                49.9731449,
                33.4757517
              ],
              [
                49.9720351,
                33.4676986
              ],
              [
                49.9723117,
                33.4663083
              ],
              [
                49.9903683,
                33.4401989
              ],
              [
                49.990925,
                33.4351972
              ],
              [
                49.9912016,
                33.4332562
              ],
              [
                49.9914817,
                33.4326964
              ],
              [
                49.9903684,
                33.4199214
              ],
              [
                49.9898148,
                33.4196415
              ],
              [
                49.9856483,
                33.4171408
              ],
              [
                49.9825917,
                33.4171408
              ],
              [
                49.9823151,
                33.4168608
              ],
              [
                49.9812019,
                33.4168608
              ],
              [
                49.9809252,
                33.416581
              ],
              [
                49.9784252,
                33.4163102
              ],
              [
                49.9748118,
                33.4163102
              ],
              [
                49.9745352,
                33.4160303
              ],
              [
                49.9687019,
                33.4160302
              ],
              [
                49.9656453,
                33.4171407
              ],
              [
                49.9637018,
                33.4171407
              ],
              [
                49.9625921,
                33.4168608
              ],
              [
                49.9606455,
                33.4163101
              ],
              [
                49.959812,
                33.4157504
              ],
              [
                49.9592588,
                33.4135294
              ],
              [
                49.9578689,
                33.407977
              ],
              [
                49.9500887,
                33.3951929
              ],
              [
                49.9478688,
                33.3874196
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14474249,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هرند",
          "ref:sci": "1028",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.0857234,
                32.5643967
              ],
              [
                52.0747146,
                32.5557071
              ],
              [
                52.0680231,
                32.5464031
              ],
              [
                52.0676213,
                32.5451789
              ],
              [
                52.0684199,
                32.5426374
              ],
              [
                52.0731596,
                32.5336475
              ],
              [
                52.0774764,
                32.5252145
              ],
              [
                52.0827477,
                32.5175884
              ],
              [
                52.08944,
                32.5111032
              ],
              [
                52.0913226,
                32.5094842
              ],
              [
                52.0933383,
                32.5081373
              ],
              [
                52.0961695,
                32.5058572
              ],
              [
                52.0918778,
                32.4981116
              ],
              [
                52.093617,
                32.4974089
              ],
              [
                52.0978419,
                32.4941362
              ],
              [
                52.10035,
                32.4942466
              ],
              [
                52.1025753,
                32.4940175
              ],
              [
                52.1046352,
                32.4924248
              ],
              [
                52.1064928,
                32.4919658
              ],
              [
                52.1043777,
                32.488443
              ],
              [
                52.1010137,
                32.4855923
              ],
              [
                52.0915885,
                32.4782719
              ],
              [
                52.1060925,
                32.4721729
              ],
              [
                52.1246949,
                32.4639989
              ],
              [
                52.1380344,
                32.4581809
              ],
              [
                52.1482846,
                32.4537868
              ],
              [
                52.1596244,
                32.4487607
              ],
              [
                52.1663712,
                32.4461346
              ],
              [
                52.1719026,
                32.444314
              ],
              [
                52.189881,
                32.4416383
              ],
              [
                52.1980433,
                32.4412233
              ],
              [
                52.2052287,
                32.4392351
              ],
              [
                52.2091258,
                32.4385863
              ],
              [
                52.2166647,
                32.4373506
              ],
              [
                52.2278456,
                32.4357979
              ],
              [
                52.2135241,
                32.4208463
              ],
              [
                52.2058001,
                32.4134519
              ],
              [
                52.1784495,
                32.3857602
              ],
              [
                52.1696948,
                32.3723503
              ],
              [
                52.167775,
                32.3681142
              ],
              [
                52.2003402,
                32.3693848
              ],
              [
                52.2304788,
                32.3603728
              ],
              [
                52.2500155,
                32.3545611
              ],
              [
                52.2810611,
                32.3431337
              ],
              [
                52.3226308,
                32.3269813
              ],
              [
                52.3807884,
                32.3066247
              ],
              [
                52.40317,
                32.298391
              ],
              [
                52.4164562,
                32.2934879
              ],
              [
                52.4396714,
                32.2853169
              ],
              [
                52.4525485,
                32.2799153
              ],
              [
                52.4681448,
                32.2720779
              ],
              [
                52.4858541,
                32.2626268
              ],
              [
                52.5007438,
                32.2549105
              ],
              [
                52.514305,
                32.2480872
              ],
              [
                52.5296141,
                32.2418437
              ],
              [
                52.5469755,
                32.2347679
              ],
              [
                52.5715541,
                32.2247099
              ],
              [
                52.5921601,
                32.2162596
              ],
              [
                52.6190185,
                32.2053937
              ],
              [
                52.6466484,
                32.1944953
              ],
              [
                52.665184,
                32.1864627
              ],
              [
                52.6857001,
                32.1779121
              ],
              [
                52.7021975,
                32.1708939
              ],
              [
                52.7306227,
                32.1588424
              ],
              [
                52.7723841,
                32.1422
              ],
              [
                52.8115999,
                32.1263135
              ],
              [
                52.8371241,
                32.1163642
              ],
              [
                52.9127503,
                32.0854944
              ],
              [
                52.9658737,
                32.0645592
              ],
              [
                53.0014798,
                32.0505712
              ],
              [
                53.0404469,
                32.0344196
              ],
              [
                53.0440518,
                32.0488252
              ],
              [
                53.0419918,
                32.0645378
              ],
              [
                53.0354687,
                32.1067157
              ],
              [
                53.0340954,
                32.1311409
              ],
              [
                53.0323885,
                32.1557259
              ],
              [
                53.0312917,
                32.1768898
              ],
              [
                53.0298018,
                32.2029296
              ],
              [
                53.029182,
                32.2250781
              ],
              [
                53.0249294,
                32.2749347
              ],
              [
                53.0262539,
                32.2890363
              ],
              [
                52.9844411,
                32.2925836
              ],
              [
                52.9295143,
                32.2974323
              ],
              [
                52.8753713,
                32.3017573
              ],
              [
                52.8423764,
                32.3043689
              ],
              [
                52.8079743,
                32.3074772
              ],
              [
                52.7720222,
                32.3099511
              ],
              [
                52.7577385,
                32.3107492
              ],
              [
                52.7506827,
                32.3109292
              ],
              [
                52.655998,
                32.3218313
              ],
              [
                52.5757594,
                32.3311855
              ],
              [
                52.5476718,
                32.3457474
              ],
              [
                52.5182599,
                32.3617982
              ],
              [
                52.4989289,
                32.372435
              ],
              [
                52.4652072,
                32.386563
              ],
              [
                52.4428643,
                32.3989306
              ],
              [
                52.4358806,
                32.4055857
              ],
              [
                52.4309634,
                32.4122842
              ],
              [
                52.4279594,
                32.4222106
              ],
              [
                52.4278735,
                32.4302523
              ],
              [
                52.4296477,
                32.436848
              ],
              [
                52.4327769,
                32.4440143
              ],
              [
                52.4353709,
                32.4478334
              ],
              [
                52.4431755,
                32.4525074
              ],
              [
                52.4515596,
                32.4568969
              ],
              [
                52.4604095,
                32.460878
              ],
              [
                52.4689006,
                32.4659606
              ],
              [
                52.4805736,
                32.4757001
              ],
              [
                52.4883842,
                32.4831216
              ],
              [
                52.4955648,
                32.4910162
              ],
              [
                52.5001901,
                32.488851
              ],
              [
                52.5039625,
                32.4873209
              ],
              [
                52.5068807,
                32.4858005
              ],
              [
                52.509857,
                32.4833648
              ],
              [
                52.5110574,
                32.4813208
              ],
              [
                52.5140307,
                32.4759588
              ],
              [
                52.5168371,
                32.4693641
              ],
              [
                52.5366817,
                32.4757112
              ],
              [
                52.5687216,
                32.4823977
              ],
              [
                52.5968741,
                32.4903617
              ],
              [
                52.6094053,
                32.5096171
              ],
              [
                52.6263998,
                32.5316183
              ],
              [
                52.6421927,
                32.5443533
              ],
              [
                52.6501268,
                32.5567141
              ],
              [
                52.6308707,
                32.5627533
              ],
              [
                52.6194135,
                32.5673639
              ],
              [
                52.5986908,
                32.5752956
              ],
              [
                52.5763485,
                32.5855876
              ],
              [
                52.561805,
                32.5911377
              ],
              [
                52.5472718,
                32.5970651
              ],
              [
                52.5323295,
                32.6042417
              ],
              [
                52.5241379,
                32.6070818
              ],
              [
                52.5065374,
                32.6147975
              ],
              [
                52.5029754,
                32.6155566
              ],
              [
                52.4997685,
                32.61739
              ],
              [
                52.4805969,
                32.6209002
              ],
              [
                52.4797788,
                32.6244012
              ],
              [
                52.4768248,
                32.6302202
              ],
              [
                52.4722137,
                32.63715
              ],
              [
                52.467413,
                32.6427514
              ],
              [
                52.465875,
                32.6442384
              ],
              [
                52.463281,
                32.6462529
              ],
              [
                52.4591861,
                32.6493604
              ],
              [
                52.4544237,
                32.6521697
              ],
              [
                52.4506959,
                32.6540485
              ],
              [
                52.4445398,
                32.654509
              ],
              [
                52.4406429,
                32.6522144
              ],
              [
                52.4369579,
                32.6473902
              ],
              [
                52.4362534,
                32.6452945
              ],
              [
                52.4338333,
                32.6389431
              ],
              [
                52.4319809,
                32.6360878
              ],
              [
                52.4226184,
                32.6380534
              ],
              [
                52.4122523,
                32.6396641
              ],
              [
                52.4085616,
                32.6411096
              ],
              [
                52.396202,
                32.662934
              ],
              [
                52.3963737,
                32.6731939
              ],
              [
                52.3955227,
                32.6811297
              ],
              [
                52.3931446,
                32.6850848
              ],
              [
                52.3890843,
                32.6865769
              ],
              [
                52.381674,
                32.6882723
              ],
              [
                52.3691439,
                32.6904236
              ],
              [
                52.3649834,
                32.6903402
              ],
              [
                52.3580439,
                32.6889225
              ],
              [
                52.3561354,
                32.6886606
              ],
              [
                52.349918,
                32.6877667
              ],
              [
                52.3451174,
                32.6870985
              ],
              [
                52.3406126,
                32.6864755
              ],
              [
                52.3352701,
                32.6850487
              ],
              [
                52.3311572,
                32.6840104
              ],
              [
                52.3312431,
                32.6827915
              ],
              [
                52.3310941,
                32.6811572
              ],
              [
                52.3312611,
                32.6773734
              ],
              [
                52.3317861,
                32.6718212
              ],
              [
                52.3322089,
                32.6647604
              ],
              [
                52.3325714,
                32.6602536
              ],
              [
                52.3322043,
                32.6570205
              ],
              [
                52.3316662,
                32.6532244
              ],
              [
                52.3313331,
                32.6528253
              ],
              [
                52.3305201,
                32.6524379
              ],
              [
                52.325816,
                32.6514343
              ],
              [
                52.3207973,
                32.650505
              ],
              [
                52.3173868,
                32.6501618
              ],
              [
                52.3110875,
                32.6499922
              ],
              [
                52.3052332,
                32.6498573
              ],
              [
                52.2948208,
                32.6498392
              ],
              [
                52.2816707,
                32.6501191
              ],
              [
                52.2690235,
                32.6504443
              ],
              [
                52.2612541,
                32.6497901
              ],
              [
                52.2574567,
                32.6499989
              ],
              [
                52.252268,
                32.6509644
              ],
              [
                52.2501377,
                32.6509368
              ],
              [
                52.2357239,
                32.6530686
              ],
              [
                52.2332584,
                32.6536015
              ],
              [
                52.2280401,
                32.6546486
              ],
              [
                52.224956,
                32.6556058
              ],
              [
                52.2221498,
                32.6560574
              ],
              [
                52.2183024,
                32.6564088
              ],
              [
                52.2154091,
                32.6569325
              ],
              [
                52.2127315,
                32.6572215
              ],
              [
                52.2092182,
                32.6574291
              ],
              [
                52.2072275,
                32.657393
              ],
              [
                52.2038126,
                32.6578396
              ],
              [
                52.2011089,
                32.6570448
              ],
              [
                52.2002556,
                32.6564468
              ],
              [
                52.1952131,
                32.6533464
              ],
              [
                52.1917104,
                32.6511552
              ],
              [
                52.1872043,
                32.6484813
              ],
              [
                52.1821375,
                32.6451931
              ],
              [
                52.1775055,
                32.6426634
              ],
              [
                52.1714791,
                32.638904
              ],
              [
                52.1641669,
                32.6342695
              ],
              [
                52.1580648,
                32.6294002
              ],
              [
                52.1505546,
                32.6235811
              ],
              [
                52.1415206,
                32.6152268
              ],
              [
                52.1365277,
                32.6106871
              ],
              [
                52.1336107,
                32.6077772
              ],
              [
                52.1313791,
                32.605509
              ],
              [
                52.1238613,
                32.5979871
              ],
              [
                52.1192693,
                32.5938653
              ],
              [
                52.1053218,
                32.5811734
              ],
              [
                52.1025753,
                32.5792207
              ],
              [
                52.0997358,
                32.5751469
              ],
              [
                52.0857234,
                32.5643967
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14474257,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ورزنه",
          "ref:sci": "1027",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.4296477,
                32.436848
              ],
              [
                52.4278735,
                32.4302523
              ],
              [
                52.4279594,
                32.4222106
              ],
              [
                52.4309634,
                32.4122842
              ],
              [
                52.4358806,
                32.4055857
              ],
              [
                52.4428643,
                32.3989306
              ],
              [
                52.4652072,
                32.386563
              ],
              [
                52.4989289,
                32.372435
              ],
              [
                52.5182599,
                32.3617982
              ],
              [
                52.5476718,
                32.3457474
              ],
              [
                52.5757594,
                32.3311855
              ],
              [
                52.655998,
                32.3218313
              ],
              [
                52.7506827,
                32.3109292
              ],
              [
                52.7577385,
                32.3107492
              ],
              [
                52.7720222,
                32.3099511
              ],
              [
                52.8079743,
                32.3074772
              ],
              [
                52.8423764,
                32.3043689
              ],
              [
                52.8753713,
                32.3017573
              ],
              [
                52.9295143,
                32.2974323
              ],
              [
                52.9844411,
                32.2925836
              ],
              [
                53.0262539,
                32.2890363
              ],
              [
                53.0276669,
                32.3022519
              ],
              [
                53.0286336,
                32.3099209
              ],
              [
                53.0294693,
                32.3212061
              ],
              [
                53.0289769,
                32.3300608
              ],
              [
                53.0288684,
                32.3390763
              ],
              [
                53.0278086,
                32.350659
              ],
              [
                53.0276177,
                32.3645667
              ],
              [
                53.0270802,
                32.3801167
              ],
              [
                53.0257736,
                32.3968515
              ],
              [
                53.0250414,
                32.4101267
              ],
              [
                53.0245534,
                32.4225924
              ],
              [
                53.0233668,
                32.4336572
              ],
              [
                53.0228869,
                32.4430735
              ],
              [
                53.0218638,
                32.4453502
              ],
              [
                53.0220287,
                32.4497819
              ],
              [
                52.9716171,
                32.4596205
              ],
              [
                52.9582839,
                32.4621216
              ],
              [
                52.9350141,
                32.4668538
              ],
              [
                52.9112385,
                32.4722523
              ],
              [
                52.8793344,
                32.486299
              ],
              [
                52.8439007,
                32.5017507
              ],
              [
                52.8171717,
                32.5133358
              ],
              [
                52.7970263,
                32.5216493
              ],
              [
                52.7685596,
                32.5324736
              ],
              [
                52.7651161,
                32.5341469
              ],
              [
                52.746325,
                32.536887
              ],
              [
                52.7391814,
                32.5377689
              ],
              [
                52.7268357,
                32.5400991
              ],
              [
                52.716531,
                32.5430472
              ],
              [
                52.6919115,
                32.5471871
              ],
              [
                52.6809727,
                32.5492756
              ],
              [
                52.6648917,
                32.5531333
              ],
              [
                52.6501268,
                32.5567141
              ],
              [
                52.6421927,
                32.5443533
              ],
              [
                52.6263998,
                32.5316183
              ],
              [
                52.6094053,
                32.5096171
              ],
              [
                52.5968741,
                32.4903617
              ],
              [
                52.5687216,
                32.4823977
              ],
              [
                52.5366817,
                32.4757112
              ],
              [
                52.5168371,
                32.4693641
              ],
              [
                52.5140307,
                32.4759588
              ],
              [
                52.5110574,
                32.4813208
              ],
              [
                52.509857,
                32.4833648
              ],
              [
                52.5068807,
                32.4858005
              ],
              [
                52.5039625,
                32.4873209
              ],
              [
                52.5001901,
                32.488851
              ],
              [
                52.4955648,
                32.4910162
              ],
              [
                52.4883842,
                32.4831216
              ],
              [
                52.4805736,
                32.4757001
              ],
              [
                52.4689006,
                32.4659606
              ],
              [
                52.4604095,
                32.460878
              ],
              [
                52.4515596,
                32.4568969
              ],
              [
                52.4431755,
                32.4525074
              ],
              [
                52.4353709,
                32.4478334
              ],
              [
                52.4327769,
                32.4440143
              ],
              [
                52.4296477,
                32.436848
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14474282,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جرقویه",
          "ref:sci": "1026",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.9060179,
                31.9612551
              ],
              [
                51.9071387,
                31.9550753
              ],
              [
                51.9098853,
                31.9504145
              ],
              [
                51.921745,
                31.9378051
              ],
              [
                51.9334925,
                31.9270453
              ],
              [
                51.9490696,
                31.9135998
              ],
              [
                51.9787975,
                31.8863549
              ],
              [
                51.9961271,
                31.870134
              ],
              [
                52.0218018,
                31.8469963
              ],
              [
                52.0361918,
                31.8345431
              ],
              [
                52.043935,
                31.830016
              ],
              [
                52.0551687,
                31.8241303
              ],
              [
                52.065222,
                31.819312
              ],
              [
                52.0876562,
                31.808597
              ],
              [
                52.1328894,
                31.7876167
              ],
              [
                52.1337477,
                31.7835198
              ],
              [
                52.1535253,
                31.7446084
              ],
              [
                52.1554721,
                31.7426582
              ],
              [
                52.1740817,
                31.7193282
              ],
              [
                52.1796384,
                31.7134957
              ],
              [
                52.1824149,
                31.7109948
              ],
              [
                52.1832483,
                31.7101551
              ],
              [
                52.195195,
                31.7023815
              ],
              [
                52.2060281,
                31.6934884
              ],
              [
                52.2068613,
                31.6929377
              ],
              [
                52.2068613,
                31.6926578
              ],
              [
                52.208808,
                31.6909965
              ],
              [
                52.208808,
                31.6904368
              ],
              [
                52.2096415,
                31.6879358
              ],
              [
                52.2093613,
                31.6865455
              ],
              [
                52.2090846,
                31.6832139
              ],
              [
                52.2043615,
                31.6743298
              ],
              [
                52.2032233,
                31.6692013
              ],
              [
                52.2046413,
                31.6690481
              ],
              [
                52.2051947,
                31.6687683
              ],
              [
                52.2065848,
                31.6687682
              ],
              [
                52.2071414,
                31.6684884
              ],
              [
                52.2088081,
                31.6684884
              ],
              [
                52.211028,
                31.6679377
              ],
              [
                52.2121413,
                31.6679376
              ],
              [
                52.2126946,
                31.6676578
              ],
              [
                52.213808,
                31.6676578
              ],
              [
                52.2140845,
                31.6673779
              ],
              [
                52.2149179,
                31.6673779
              ],
              [
                52.2154746,
                31.667107
              ],
              [
                52.2176945,
                31.667107
              ],
              [
                52.2188079,
                31.6668272
              ],
              [
                52.2199178,
                31.6668272
              ],
              [
                52.2207512,
                31.6665472
              ],
              [
                52.2226977,
                31.6665473
              ],
              [
                52.2374175,
                31.6643262
              ],
              [
                52.2393643,
                31.6637665
              ],
              [
                52.2407508,
                31.6637665
              ],
              [
                52.2446408,
                31.662656
              ],
              [
                52.2474209,
                31.6615455
              ],
              [
                52.3446462,
                31.5723811
              ],
              [
                52.3449228,
                31.5721012
              ],
              [
                52.345203,
                31.5718213
              ],
              [
                52.3729792,
                31.5546045
              ],
              [
                52.3810357,
                31.5515438
              ],
              [
                52.3935389,
                31.5482125
              ],
              [
                52.3977055,
                31.5473728
              ],
              [
                52.3999255,
                31.5468221
              ],
              [
                52.4077054,
                31.5459915
              ],
              [
                52.4107585,
                31.5454318
              ],
              [
                52.4129819,
                31.5454318
              ],
              [
                52.4302051,
                31.542931
              ],
              [
                52.4329851,
                31.5426601
              ],
              [
                52.4965975,
                31.5234933
              ],
              [
                52.4971541,
                31.5234933
              ],
              [
                52.4996541,
                31.5229336
              ],
              [
                52.5596566,
                31.5123797
              ],
              [
                52.5738231,
                31.5112692
              ],
              [
                52.574933,
                31.5109894
              ],
              [
                52.5785464,
                31.5109894
              ],
              [
                52.5796563,
                31.5107095
              ],
              [
                52.5824364,
                31.5107095
              ],
              [
                52.5846562,
                31.5104296
              ],
              [
                52.5866029,
                31.5104297
              ],
              [
                52.5963228,
                31.509879
              ],
              [
                52.6107693,
                31.5087685
              ],
              [
                52.6138259,
                31.5087685
              ],
              [
                52.6154926,
                31.5084886
              ],
              [
                52.6185491,
                31.5084886
              ],
              [
                52.6232691,
                31.5079379
              ],
              [
                52.6260491,
                31.5079379
              ],
              [
                52.6563253,
                31.5048773
              ],
              [
                52.6602152,
                31.5048773
              ],
              [
                52.6866048,
                31.5029364
              ],
              [
                52.6907715,
                31.5029364
              ],
              [
                52.7291076,
                31.4990453
              ],
              [
                52.7304976,
                31.4990452
              ],
              [
                52.7329975,
                31.4984855
              ],
              [
                52.754944,
                31.4962646
              ],
              [
                52.7610538,
                31.4959938
              ],
              [
                52.7621638,
                31.4957049
              ],
              [
                52.7774436,
                31.4957049
              ],
              [
                52.7793869,
                31.495434
              ],
              [
                52.7824435,
                31.4954341
              ],
              [
                52.7843868,
                31.4951542
              ],
              [
                52.7863335,
                31.4951542
              ],
              [
                52.7871668,
                31.4948743
              ],
              [
                52.793,
                31.4948743
              ],
              [
                52.7946667,
                31.4946035
              ],
              [
                52.79661,
                31.4946035
              ],
              [
                52.7977234,
                31.4948743
              ],
              [
                52.7991099,
                31.4948743
              ],
              [
                52.7993899,
                31.4951542
              ],
              [
                52.8005,
                31.4948743
              ],
              [
                52.8010566,
                31.4948743
              ],
              [
                52.8057765,
                31.4946034
              ],
              [
                52.8060565,
                31.4943236
              ],
              [
                52.8077232,
                31.4943236
              ],
              [
                52.8132799,
                31.4932132
              ],
              [
                52.829113,
                31.4921027
              ],
              [
                52.8307796,
                31.4918228
              ],
              [
                52.8321695,
                31.4918229
              ],
              [
                52.8330028,
                31.491543
              ],
              [
                52.8360562,
                31.491543
              ],
              [
                52.8368894,
                31.4912631
              ],
              [
                52.8418894,
                31.4912631
              ],
              [
                52.8491126,
                31.4907124
              ],
              [
                52.849946,
                31.4904325
              ],
              [
                52.8535592,
                31.4904326
              ],
              [
                52.8577259,
                31.4898728
              ],
              [
                52.8585591,
                31.4901526
              ],
              [
                52.8716156,
                31.4901527
              ],
              [
                52.8727256,
                31.4898728
              ],
              [
                52.8807822,
                31.4898728
              ],
              [
                52.8832821,
                31.489602
              ],
              [
                52.8868921,
                31.4896019
              ],
              [
                52.888282,
                31.4893221
              ],
              [
                52.8927253,
                31.4893221
              ],
              [
                52.9016152,
                31.4890422
              ],
              [
                52.9213382,
                31.4898729
              ],
              [
                52.9227283,
                31.4901527
              ],
              [
                52.9360614,
                31.4901527
              ],
              [
                52.9385615,
                31.4898728
              ],
              [
                52.9410613,
                31.4901527
              ],
              [
                52.9460613,
                31.4901527
              ],
              [
                52.9774508,
                31.4934932
              ],
              [
                52.9793974,
                31.4934931
              ],
              [
                52.9824541,
                31.4940439
              ],
              [
                52.9843974,
                31.4940438
              ],
              [
                52.9852307,
                31.4943237
              ],
              [
                52.987174,
                31.4943237
              ],
              [
                52.9938406,
                31.4954342
              ],
              [
                52.9966206,
                31.4962647
              ],
              [
                52.9977306,
                31.4962647
              ],
              [
                53.0063438,
                31.4987655
              ],
              [
                53.0071771,
                31.4993252
              ],
              [
                53.009397,
                31.4995961
              ],
              [
                53.0113437,
                31.5004267
              ],
              [
                53.0524565,
                31.5098792
              ],
              [
                53.0574564,
                31.5112694
              ],
              [
                53.0596797,
                31.5115403
              ],
              [
                53.0832893,
                31.5201532
              ],
              [
                53.0913459,
                31.5234936
              ],
              [
                53.1291253,
                31.5398798
              ],
              [
                53.130792,
                31.5407103
              ],
              [
                53.1327387,
                31.5412701
              ],
              [
                53.133572,
                31.5418208
              ],
              [
                53.1355152,
                31.5423805
              ],
              [
                53.1832945,
                31.56682
              ],
              [
                53.1849612,
                31.5676597
              ],
              [
                53.1860746,
                31.5679305
              ],
              [
                53.1944078,
                31.573212
              ],
              [
                53.2029075,
                31.5889258
              ],
              [
                53.2035743,
                31.5901582
              ],
              [
                53.2035744,
                31.5904381
              ],
              [
                53.2032943,
                31.590718
              ],
              [
                53.203419,
                31.5918284
              ],
              [
                53.2035743,
                31.5932098
              ],
              [
                53.203851,
                31.5968212
              ],
              [
                53.1980177,
                31.6134876
              ],
              [
                53.186908,
                31.6279329
              ],
              [
                53.1802379,
                31.6376566
              ],
              [
                53.1771847,
                31.641268
              ],
              [
                53.1402385,
                31.6804336
              ],
              [
                53.102459,
                31.7046031
              ],
              [
                53.0819026,
                31.716268
              ],
              [
                53.0810692,
                31.7171077
              ],
              [
                53.0794026,
                31.7179383
              ],
              [
                53.0757894,
                31.72099
              ],
              [
                53.0612546,
                31.7300913
              ],
              [
                53.0474699,
                31.7396576
              ],
              [
                53.0409968,
                31.7473041
              ],
              [
                53.0364983,
                31.759848
              ],
              [
                53.0283699,
                31.7797787
              ],
              [
                53.0233334,
                31.7921091
              ],
              [
                53.0155486,
                31.8121175
              ],
              [
                53.0089671,
                31.827318
              ],
              [
                53.0063296,
                31.8375455
              ],
              [
                53.0030453,
                31.8541591
              ],
              [
                53.0003655,
                31.8667867
              ],
              [
                53.0045904,
                31.8813453
              ],
              [
                53.0112986,
                31.9072903
              ],
              [
                53.0159251,
                31.9253995
              ],
              [
                53.0224835,
                31.9479982
              ],
              [
                53.0251385,
                31.9586496
              ],
              [
                53.0341949,
                31.9934593
              ],
              [
                53.0349539,
                31.9961391
              ],
              [
                53.0452537,
                32.0019621
              ],
              [
                53.0473351,
                32.0034361
              ],
              [
                53.0511759,
                32.0051102
              ],
              [
                53.0522917,
                32.0294716
              ],
              [
                53.0404469,
                32.0344196
              ],
              [
                53.0014798,
                32.0505712
              ],
              [
                52.9658737,
                32.0645592
              ],
              [
                52.9127503,
                32.0854944
              ],
              [
                52.8371241,
                32.1163642
              ],
              [
                52.8115999,
                32.1263135
              ],
              [
                52.7723841,
                32.1422
              ],
              [
                52.7306227,
                32.1588424
              ],
              [
                52.7021975,
                32.1708939
              ],
              [
                52.6857001,
                32.1779121
              ],
              [
                52.665184,
                32.1864627
              ],
              [
                52.6466484,
                32.1944953
              ],
              [
                52.6190185,
                32.2053937
              ],
              [
                52.5921601,
                32.2162596
              ],
              [
                52.5715541,
                32.2247099
              ],
              [
                52.5469755,
                32.2347679
              ],
              [
                52.5296141,
                32.2418437
              ],
              [
                52.514305,
                32.2480872
              ],
              [
                52.5007438,
                32.2549105
              ],
              [
                52.4858541,
                32.2626268
              ],
              [
                52.4681448,
                32.2720779
              ],
              [
                52.4525485,
                32.2799153
              ],
              [
                52.4396714,
                32.2853169
              ],
              [
                52.4164562,
                32.2934879
              ],
              [
                52.40317,
                32.298391
              ],
              [
                52.3807884,
                32.3066247
              ],
              [
                52.3226308,
                32.3269813
              ],
              [
                52.2810611,
                32.3431337
              ],
              [
                52.2500155,
                32.3545611
              ],
              [
                52.2304788,
                32.3603728
              ],
              [
                52.2003402,
                32.3693848
              ],
              [
                52.167775,
                32.3681142
              ],
              [
                52.1696948,
                32.3723503
              ],
              [
                52.1784495,
                32.3857602
              ],
              [
                52.2058001,
                32.4134519
              ],
              [
                52.2135241,
                32.4208463
              ],
              [
                52.2278456,
                32.4357979
              ],
              [
                52.2166647,
                32.4373506
              ],
              [
                52.2091258,
                32.4385863
              ],
              [
                52.2052287,
                32.4392351
              ],
              [
                52.1980433,
                32.4412233
              ],
              [
                52.189881,
                32.4416383
              ],
              [
                52.1719026,
                32.444314
              ],
              [
                52.1663712,
                32.4461346
              ],
              [
                52.1596244,
                32.4487607
              ],
              [
                52.1482846,
                32.4537868
              ],
              [
                52.1380344,
                32.4581809
              ],
              [
                52.1246949,
                32.4639989
              ],
              [
                52.1060925,
                32.4721729
              ],
              [
                52.0915885,
                32.4782719
              ],
              [
                52.089808,
                32.4790489
              ],
              [
                52.0855634,
                32.4813687
              ],
              [
                52.0806509,
                32.4824645
              ],
              [
                52.0633258,
                32.4876176
              ],
              [
                52.055621,
                32.4897226
              ],
              [
                52.048528,
                32.4907557
              ],
              [
                52.0308647,
                32.4910942
              ],
              [
                52.0175168,
                32.4867508
              ],
              [
                52.0097602,
                32.4810391
              ],
              [
                52.00809,
                32.4595377
              ],
              [
                52.0046302,
                32.4076735
              ],
              [
                52.0037967,
                32.4060121
              ],
              [
                51.9926835,
                32.3896238
              ],
              [
                51.9924069,
                32.3885041
              ],
              [
                51.9918502,
                32.3879533
              ],
              [
                51.9751839,
                32.3601698
              ],
              [
                51.9721272,
                32.3571178
              ],
              [
                51.9710173,
                32.3562871
              ],
              [
                51.9418643,
                32.3180099
              ],
              [
                51.9486308,
                32.3082176
              ],
              [
                51.953445,
                32.2990725
              ],
              [
                51.9582409,
                32.2793385
              ],
              [
                51.9585175,
                32.2754469
              ],
              [
                51.958794,
                32.2707245
              ],
              [
                51.9590741,
                32.269334
              ],
              [
                51.9590741,
                32.2504445
              ],
              [
                51.9601842,
                32.2426703
              ],
              [
                51.9624075,
                32.237677
              ],
              [
                51.9646274,
                32.2346161
              ],
              [
                51.9757407,
                32.2182278
              ],
              [
                51.9824073,
                32.2110043
              ],
              [
                51.9851839,
                32.2046116
              ],
              [
                51.9882406,
                32.1943362
              ],
              [
                51.9893505,
                32.1871127
              ],
              [
                51.9887973,
                32.1771173
              ],
              [
                51.9882406,
                32.1751669
              ],
              [
                51.9860172,
                32.1546163
              ],
              [
                51.9862972,
                32.1510046
              ],
              [
                51.9868506,
                32.1460023
              ],
              [
                51.9940738,
                32.1173886
              ],
              [
                51.9951837,
                32.1146166
              ],
              [
                51.9965738,
                32.1104451
              ],
              [
                52.0010204,
                32.088784
              ],
              [
                52.0012972,
                32.0882242
              ],
              [
                52.0051903,
                32.0512648
              ],
              [
                51.987894,
                32.0424115
              ],
              [
                51.9706492,
                32.0350049
              ],
              [
                51.9614802,
                32.028477
              ],
              [
                51.9537944,
                32.0240537
              ],
              [
                51.9409046,
                32.0164608
              ],
              [
                51.9273601,
                32.0075055
              ],
              [
                51.9166203,
                31.9992778
              ],
              [
                51.9140053,
                31.9919925
              ],
              [
                51.9104089,
                31.9801844
              ],
              [
                51.9060487,
                31.9666928
              ],
              [
                51.9060179,
                31.9612551
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14474306,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوهپایه",
          "ref:sci": "1025",
          "type": "boundary",
          "wikidata": "Q110646328"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.9074122,
                32.7032695
              ],
              [
                51.9120704,
                32.7006435
              ],
              [
                51.9166362,
                32.698016
              ],
              [
                51.9197,
                32.6962012
              ],
              [
                51.9225444,
                32.6946841
              ],
              [
                51.9255107,
                32.6927516
              ],
              [
                51.9296388,
                32.6910359
              ],
              [
                51.9348546,
                32.688877
              ],
              [
                51.9387638,
                32.6866378
              ],
              [
                51.9436063,
                32.6844706
              ],
              [
                51.9529605,
                32.691017
              ],
              [
                51.9543506,
                32.6910171
              ],
              [
                51.9667723,
                32.6843753
              ],
              [
                51.9704602,
                32.682403
              ],
              [
                51.9779635,
                32.6748996
              ],
              [
                51.9787967,
                32.6723985
              ],
              [
                51.97824,
                32.6646241
              ],
              [
                51.9774069,
                32.6626828
              ],
              [
                51.9757402,
                32.6576805
              ],
              [
                51.9749068,
                32.65629
              ],
              [
                51.9743502,
                32.6546286
              ],
              [
                51.9690737,
                32.644624
              ],
              [
                51.9668502,
                32.6357391
              ],
              [
                51.964627,
                32.6312875
              ],
              [
                51.9626838,
                32.6243439
              ],
              [
                51.9593506,
                32.6129579
              ],
              [
                51.9579604,
                32.6107366
              ],
              [
                51.9576839,
                32.609346
              ],
              [
                51.9560173,
                32.6032331
              ],
              [
                51.9571271,
                32.600452
              ],
              [
                51.957127,
                32.5999013
              ],
              [
                51.9576839,
                32.5987906
              ],
              [
                51.9618505,
                32.5926777
              ],
              [
                51.9618504,
                32.5923978
              ],
              [
                51.9626839,
                32.591847
              ],
              [
                51.9651623,
                32.5909306
              ],
              [
                51.9657403,
                32.5907364
              ],
              [
                51.9943501,
                32.5815715
              ],
              [
                51.9960201,
                32.5815716
              ],
              [
                51.9968534,
                32.5812917
              ],
              [
                52.0043532,
                32.5796212
              ],
              [
                52.0105688,
                32.5698847
              ],
              [
                52.033224,
                32.5671416
              ],
              [
                52.075328,
                32.5633721
              ],
              [
                52.0810063,
                32.5636976
              ],
              [
                52.0857234,
                32.5643967
              ],
              [
                52.0997358,
                32.5751469
              ],
              [
                52.1025753,
                32.5792207
              ],
              [
                52.1053218,
                32.5811734
              ],
              [
                52.1192693,
                32.5938653
              ],
              [
                52.1238613,
                32.5979871
              ],
              [
                52.1313791,
                32.605509
              ],
              [
                52.1336107,
                32.6077772
              ],
              [
                52.1365277,
                32.6106871
              ],
              [
                52.1415206,
                32.6152268
              ],
              [
                52.1505546,
                32.6235811
              ],
              [
                52.1580648,
                32.6294002
              ],
              [
                52.1641669,
                32.6342695
              ],
              [
                52.1714791,
                32.638904
              ],
              [
                52.1775055,
                32.6426634
              ],
              [
                52.1821375,
                32.6451931
              ],
              [
                52.1872043,
                32.6484813
              ],
              [
                52.1917104,
                32.6511552
              ],
              [
                52.1952131,
                32.6533464
              ],
              [
                52.2002556,
                32.6564468
              ],
              [
                52.2011089,
                32.6570448
              ],
              [
                52.2038126,
                32.6578396
              ],
              [
                52.2072275,
                32.657393
              ],
              [
                52.2092182,
                32.6574291
              ],
              [
                52.2127315,
                32.6572215
              ],
              [
                52.2154091,
                32.6569325
              ],
              [
                52.2183024,
                32.6564088
              ],
              [
                52.2221498,
                32.6560574
              ],
              [
                52.224956,
                32.6556058
              ],
              [
                52.2280401,
                32.6546486
              ],
              [
                52.2332584,
                32.6536015
              ],
              [
                52.2357239,
                32.6530686
              ],
              [
                52.2501377,
                32.6509368
              ],
              [
                52.252268,
                32.6509644
              ],
              [
                52.2574567,
                32.6499989
              ],
              [
                52.2612541,
                32.6497901
              ],
              [
                52.2690235,
                32.6504443
              ],
              [
                52.2816707,
                32.6501191
              ],
              [
                52.2948208,
                32.6498392
              ],
              [
                52.3052332,
                32.6498573
              ],
              [
                52.3110875,
                32.6499922
              ],
              [
                52.3173868,
                32.6501618
              ],
              [
                52.3207973,
                32.650505
              ],
              [
                52.325816,
                32.6514343
              ],
              [
                52.3305201,
                32.6524379
              ],
              [
                52.3313331,
                32.6528253
              ],
              [
                52.3316662,
                32.6532244
              ],
              [
                52.3322043,
                32.6570205
              ],
              [
                52.3325714,
                32.6602536
              ],
              [
                52.3322089,
                32.6647604
              ],
              [
                52.3317861,
                32.6718212
              ],
              [
                52.3312611,
                32.6773734
              ],
              [
                52.3310941,
                32.6811572
              ],
              [
                52.3312431,
                32.6827915
              ],
              [
                52.3311572,
                32.6840104
              ],
              [
                52.3352701,
                32.6850487
              ],
              [
                52.3406126,
                32.6864755
              ],
              [
                52.3451174,
                32.6870985
              ],
              [
                52.349918,
                32.6877667
              ],
              [
                52.3561354,
                32.6886606
              ],
              [
                52.3580439,
                32.6889225
              ],
              [
                52.3649834,
                32.6903402
              ],
              [
                52.3691439,
                32.6904236
              ],
              [
                52.381674,
                32.6882723
              ],
              [
                52.3890843,
                32.6865769
              ],
              [
                52.3931446,
                32.6850848
              ],
              [
                52.3955227,
                32.6811297
              ],
              [
                52.3963737,
                32.6731939
              ],
              [
                52.396202,
                32.662934
              ],
              [
                52.4085616,
                32.6411096
              ],
              [
                52.4122523,
                32.6396641
              ],
              [
                52.4226184,
                32.6380534
              ],
              [
                52.4319809,
                32.6360878
              ],
              [
                52.4338333,
                32.6389431
              ],
              [
                52.4362534,
                32.6452945
              ],
              [
                52.4369579,
                32.6473902
              ],
              [
                52.4406429,
                32.6522144
              ],
              [
                52.4445398,
                32.654509
              ],
              [
                52.4506959,
                32.6540485
              ],
              [
                52.4544237,
                32.6521697
              ],
              [
                52.4591861,
                32.6493604
              ],
              [
                52.463281,
                32.6462529
              ],
              [
                52.465875,
                32.6442384
              ],
              [
                52.467413,
                32.6427514
              ],
              [
                52.4722137,
                32.63715
              ],
              [
                52.4768248,
                32.6302202
              ],
              [
                52.4797788,
                32.6244012
              ],
              [
                52.4805969,
                32.6209002
              ],
              [
                52.4997685,
                32.61739
              ],
              [
                52.5029754,
                32.6155566
              ],
              [
                52.5065374,
                32.6147975
              ],
              [
                52.5241379,
                32.6070818
              ],
              [
                52.5323295,
                32.6042417
              ],
              [
                52.5472718,
                32.5970651
              ],
              [
                52.561805,
                32.5911377
              ],
              [
                52.5763485,
                32.5855876
              ],
              [
                52.5986908,
                32.5752956
              ],
              [
                52.6194135,
                32.5673639
              ],
              [
                52.6308707,
                32.5627533
              ],
              [
                52.6501268,
                32.5567141
              ],
              [
                52.6648917,
                32.5531333
              ],
              [
                52.6809727,
                32.5492756
              ],
              [
                52.6919115,
                32.5471871
              ],
              [
                52.716531,
                32.5430472
              ],
              [
                52.7268357,
                32.5400991
              ],
              [
                52.7391814,
                32.5377689
              ],
              [
                52.746325,
                32.536887
              ],
              [
                52.7651161,
                32.5341469
              ],
              [
                52.7685596,
                32.5324736
              ],
              [
                52.7970263,
                32.5216493
              ],
              [
                52.8171717,
                32.5133358
              ],
              [
                52.8439007,
                32.5017507
              ],
              [
                52.8793344,
                32.486299
              ],
              [
                52.9112385,
                32.4722523
              ],
              [
                52.9350141,
                32.4668538
              ],
              [
                52.9582839,
                32.4621216
              ],
              [
                52.9716171,
                32.4596205
              ],
              [
                53.0220287,
                32.4497819
              ],
              [
                53.0224441,
                32.465347
              ],
              [
                53.0234098,
                32.4823614
              ],
              [
                53.0175159,
                32.4993752
              ],
              [
                53.0134234,
                32.5072386
              ],
              [
                53.0115161,
                32.5143132
              ],
              [
                53.0136286,
                32.5177438
              ],
              [
                53.0239032,
                32.5273026
              ],
              [
                53.0254268,
                32.5286874
              ],
              [
                53.0288172,
                32.5310573
              ],
              [
                53.0301046,
                32.5325046
              ],
              [
                53.0335999,
                32.5356451
              ],
              [
                53.0250357,
                32.5370603
              ],
              [
                53.0089675,
                32.5395205
              ],
              [
                53.0003857,
                32.5408621
              ],
              [
                52.9973589,
                32.5411763
              ],
              [
                52.9891848,
                32.541331
              ],
              [
                52.9557752,
                32.5662736
              ],
              [
                52.9519941,
                32.5685137
              ],
              [
                52.9483102,
                32.5707263
              ],
              [
                52.945784,
                32.5723982
              ],
              [
                52.9450343,
                32.5729407
              ],
              [
                52.9438227,
                32.5735995
              ],
              [
                52.9414905,
                32.5749949
              ],
              [
                52.9384135,
                32.5771369
              ],
              [
                52.9348644,
                32.5794513
              ],
              [
                52.9293687,
                32.58312
              ],
              [
                52.9156494,
                32.5850788
              ],
              [
                52.9053867,
                32.5839172
              ],
              [
                52.89746,
                32.5832819
              ],
              [
                52.8816628,
                32.5822179
              ],
              [
                52.87283,
                32.5821393
              ],
              [
                52.8573004,
                32.5865138
              ],
              [
                52.8494706,
                32.5887732
              ],
              [
                52.846277,
                32.5900821
              ],
              [
                52.8396212,
                32.5924358
              ],
              [
                52.8300999,
                32.5964837
              ],
              [
                52.8318223,
                32.6068497
              ],
              [
                52.8326531,
                32.6158365
              ],
              [
                52.8334146,
                32.6226737
              ],
              [
                52.833877,
                32.6295979
              ],
              [
                52.8340296,
                32.634621
              ],
              [
                52.8340243,
                32.643061
              ],
              [
                52.8345855,
                32.6525741
              ],
              [
                52.8349371,
                32.6610223
              ],
              [
                52.8291397,
                32.6680103
              ],
              [
                52.8267781,
                32.6724164
              ],
              [
                52.8240611,
                32.6771935
              ],
              [
                52.8211927,
                32.6819356
              ],
              [
                52.8193044,
                32.6858005
              ],
              [
                52.8168457,
                32.6891485
              ],
              [
                52.8153258,
                32.6919565
              ],
              [
                52.8143828,
                32.6946022
              ],
              [
                52.8126538,
                32.6956388
              ],
              [
                52.8112556,
                32.7041281
              ],
              [
                52.8152242,
                32.7100504
              ],
              [
                52.8190898,
                32.7136804
              ],
              [
                52.8197911,
                32.7159011
              ],
              [
                52.8232097,
                32.7190604
              ],
              [
                52.8368017,
                32.7273901
              ],
              [
                52.8380213,
                32.7286179
              ],
              [
                52.8305492,
                32.7343598
              ],
              [
                52.8267582,
                32.7372491
              ],
              [
                52.8239085,
                32.7394786
              ],
              [
                52.8203627,
                32.7422492
              ],
              [
                52.8174921,
                32.7444335
              ],
              [
                52.8148842,
                32.7463884
              ],
              [
                52.8135818,
                32.7476576
              ],
              [
                52.807374,
                32.7549786
              ],
              [
                52.8064432,
                32.7586661
              ],
              [
                52.7983117,
                32.7687692
              ],
              [
                52.7904255,
                32.7744772
              ],
              [
                52.7863986,
                32.776715
              ],
              [
                52.7805948,
                32.7796978
              ],
              [
                52.7725696,
                32.7827647
              ],
              [
                52.7656602,
                32.7848573
              ],
              [
                52.7542275,
                32.7890372
              ],
              [
                52.7490426,
                32.790177
              ],
              [
                52.7471208,
                32.791676
              ],
              [
                52.7432584,
                32.797917
              ],
              [
                52.7407264,
                32.8009472
              ],
              [
                52.7372074,
                32.802318
              ],
              [
                52.7258343,
                32.8075091
              ],
              [
                52.7210816,
                32.8098671
              ],
              [
                52.7193772,
                32.8107783
              ],
              [
                52.7159618,
                32.8123317
              ],
              [
                52.7124498,
                32.8142537
              ],
              [
                52.7090898,
                32.8161158
              ],
              [
                52.7026346,
                32.8192536
              ],
              [
                52.6963748,
                32.8221578
              ],
              [
                52.6934646,
                32.8235005
              ],
              [
                52.6906503,
                32.824917
              ],
              [
                52.6882268,
                32.8261797
              ],
              [
                52.682492,
                32.8292634
              ],
              [
                52.6800348,
                32.8304169
              ],
              [
                52.6739467,
                32.8322285
              ],
              [
                52.6695595,
                32.8315795
              ],
              [
                52.6643488,
                32.8300193
              ],
              [
                52.6573784,
                32.8278738
              ],
              [
                52.6562685,
                32.8275766
              ],
              [
                52.6534787,
                32.8272161
              ],
              [
                52.6504556,
                32.8265944
              ],
              [
                52.6480384,
                32.8262765
              ],
              [
                52.6434083,
                32.8257537
              ],
              [
                52.6397922,
                32.8250924
              ],
              [
                52.6355824,
                32.824351
              ],
              [
                52.6344251,
                32.824139
              ],
              [
                52.6309705,
                32.8240849
              ],
              [
                52.6278591,
                32.8247521
              ],
              [
                52.6257992,
                32.8254373
              ],
              [
                52.6230311,
                32.827042
              ],
              [
                52.6163617,
                32.8346222
              ],
              [
                52.6140189,
                32.838473
              ],
              [
                52.6129889,
                32.8436111
              ],
              [
                52.6116586,
                32.8470363
              ],
              [
                52.6104784,
                32.851543
              ],
              [
                52.6088475,
                32.8533903
              ],
              [
                52.608082,
                32.85677
              ],
              [
                52.6073094,
                32.8582134
              ],
              [
                52.6054103,
                32.862225
              ],
              [
                52.6041062,
                32.866336
              ],
              [
                52.6031382,
                32.870063
              ],
              [
                52.6026458,
                32.8722464
              ],
              [
                52.6020485,
                32.8748743
              ],
              [
                52.6016635,
                32.8761735
              ],
              [
                52.6008075,
                32.8780405
              ],
              [
                52.5997023,
                32.8803556
              ],
              [
                52.5942475,
                32.8790266
              ],
              [
                52.5927525,
                32.8785845
              ],
              [
                52.5876783,
                32.877934
              ],
              [
                52.5836979,
                32.8775094
              ],
              [
                52.5824354,
                32.8774097
              ],
              [
                52.5806591,
                32.8772116
              ],
              [
                52.5781603,
                32.8770397
              ],
              [
                52.5748559,
                32.8766708
              ],
              [
                52.5698524,
                32.8772931
              ],
              [
                52.5678601,
                32.8774829
              ],
              [
                52.5624322,
                32.8779696
              ],
              [
                52.5575445,
                32.8785006
              ],
              [
                52.5536031,
                32.8785186
              ],
              [
                52.5479633,
                32.8784729
              ],
              [
                52.5361999,
                32.8785743
              ],
              [
                52.5327093,
                32.8785203
              ],
              [
                52.5318759,
                32.8788002
              ],
              [
                52.5199295,
                32.8788002
              ],
              [
                52.4999298,
                32.8796308
              ],
              [
                52.4940964,
                32.8801907
              ],
              [
                52.4915964,
                32.8801907
              ],
              [
                52.4910398,
                32.8804706
              ],
              [
                52.4896533,
                32.8804706
              ],
              [
                52.4885398,
                32.8804706
              ],
              [
                52.4821498,
                32.8807414
              ],
              [
                52.4815967,
                32.8804705
              ],
              [
                52.4779833,
                32.8807414
              ],
              [
                52.4774301,
                32.8810213
              ],
              [
                52.4671501,
                32.8810213
              ],
              [
                52.4665934,
                32.8807414
              ],
              [
                52.4635402,
                32.8807414
              ],
              [
                52.4615935,
                32.8804705
              ],
              [
                52.4607602,
                32.8801907
              ],
              [
                52.4565936,
                32.8801906
              ],
              [
                52.4557603,
                32.8799108
              ],
              [
                52.4529837,
                32.8799107
              ],
              [
                52.452427,
                32.8796308
              ],
              [
                52.4477037,
                32.8796309
              ],
              [
                52.4468704,
                32.8793509
              ],
              [
                52.4449271,
                32.8793509
              ],
              [
                52.4443704,
                32.8790711
              ],
              [
                52.4415938,
                32.879071
              ],
              [
                52.4410372,
                32.8788001
              ],
              [
                52.4352039,
                32.8788001
              ],
              [
                52.4338173,
                32.8785202
              ],
              [
                52.4335372,
                32.8788001
              ],
              [
                52.432984,
                32.8785202
              ],
              [
                52.4321507,
                32.8785202
              ],
              [
                52.4315939,
                32.8788002
              ],
              [
                52.4268707,
                32.8788001
              ],
              [
                52.4235374,
                32.879071
              ],
              [
                52.4227042,
                32.8793509
              ],
              [
                52.4196474,
                32.8793509
              ],
              [
                52.4190941,
                32.8796309
              ],
              [
                52.4160375,
                32.8796309
              ],
              [
                52.4132678,
                32.8779229
              ],
              [
                52.4069483,
                32.8786026
              ],
              [
                52.4016506,
                32.8807057
              ],
              [
                52.4022513,
                32.88973
              ],
              [
                52.3992903,
                32.8944693
              ],
              [
                52.3957712,
                32.8974538
              ],
              [
                52.3929062,
                32.901831
              ],
              [
                52.3910071,
                32.9076047
              ],
              [
                52.3905361,
                32.9152343
              ],
              [
                52.3837703,
                32.9311934
              ],
              [
                52.3782579,
                32.9404696
              ],
              [
                52.3739996,
                32.9450931
              ],
              [
                52.3687698,
                32.9555195
              ],
              [
                52.3678698,
                32.9622556
              ],
              [
                52.3660814,
                32.9716915
              ],
              [
                52.3634599,
                32.9800447
              ],
              [
                52.3599299,
                32.9891066
              ],
              [
                52.3553217,
                32.9994992
              ],
              [
                52.3503315,
                33.0025784
              ],
              [
                52.34802,
                33.004018
              ],
              [
                52.3409271,
                33.0074399
              ],
              [
                52.3315715,
                33.0121543
              ],
              [
                52.3235991,
                33.0153314
              ],
              [
                52.3154582,
                33.0178503
              ],
              [
                52.3041646,
                33.0210009
              ],
              [
                52.2990587,
                33.0210449
              ],
              [
                52.2921314,
                33.020901
              ],
              [
                52.2803356,
                33.0206151
              ],
              [
                52.2726179,
                33.0201113
              ],
              [
                52.2642757,
                33.0204793
              ],
              [
                52.2586587,
                33.0199394
              ],
              [
                52.2534721,
                33.0198595
              ],
              [
                52.2478403,
                33.0221624
              ],
              [
                52.2414088,
                33.0239895
              ],
              [
                52.2331399,
                33.0251189
              ],
              [
                52.223933,
                33.0246152
              ],
              [
                52.2188521,
                33.022772
              ],
              [
                52.2121959,
                33.0216085
              ],
              [
                52.2040343,
                33.0186649
              ],
              [
                52.1947145,
                33.0169044
              ],
              [
                52.1835029,
                33.013989
              ],
              [
                52.1748288,
                33.0112671
              ],
              [
                52.1710118,
                33.0092519
              ],
              [
                52.1681436,
                33.0068927
              ],
              [
                52.1631091,
                32.998033
              ],
              [
                52.1606098,
                32.9961009
              ],
              [
                52.1470544,
                32.9744099
              ],
              [
                52.1388602,
                32.9654235
              ],
              [
                52.1312654,
                32.9601584
              ],
              [
                52.121658,
                32.9561254
              ],
              [
                52.1139251,
                32.9542194
              ],
              [
                52.1030995,
                32.9542193
              ],
              [
                52.0918366,
                32.9571804
              ],
              [
                52.08352,
                32.9613776
              ],
              [
                52.0807743,
                32.9579775
              ],
              [
                52.0797872,
                32.9545565
              ],
              [
                52.0765592,
                32.9456586
              ],
              [
                52.0726779,
                32.9498802
              ],
              [
                52.0690561,
                32.9527611
              ],
              [
                52.0668484,
                32.9543898
              ],
              [
                52.0615512,
                32.9557942
              ],
              [
                52.0534177,
                32.9567943
              ],
              [
                52.0429521,
                32.9578747
              ],
              [
                52.0403913,
                32.9578328
              ],
              [
                52.0377805,
                32.9567353
              ],
              [
                52.0342101,
                32.9546107
              ],
              [
                52.0316162,
                32.95273
              ],
              [
                52.0290372,
                32.9511814
              ],
              [
                52.0246138,
                32.947636
              ],
              [
                52.0193347,
                32.9438419
              ],
              [
                52.0147915,
                32.938149
              ],
              [
                52.0110158,
                32.9331942
              ],
              [
                52.0045245,
                32.9247711
              ],
              [
                51.999937,
                32.9174337
              ],
              [
                51.9921298,
                32.9062938
              ],
              [
                51.9910163,
                32.9049124
              ],
              [
                51.9879631,
                32.9007408
              ],
              [
                51.9501837,
                32.8596308
              ],
              [
                51.9490704,
                32.8588
              ],
              [
                51.9490703,
                32.8585201
              ],
              [
                51.9485171,
                32.8582402
              ],
              [
                51.9443504,
                32.8521274
              ],
              [
                51.9599069,
                32.8396309
              ],
              [
                51.9604602,
                32.8385203
              ],
              [
                51.9646267,
                32.8343488
              ],
              [
                51.9654602,
                32.8329673
              ],
              [
                51.9904632,
                32.8051842
              ],
              [
                51.9918498,
                32.802963
              ],
              [
                51.997963,
                32.7940781
              ],
              [
                52.0015731,
                32.7899065
              ],
              [
                52.0057396,
                32.7782407
              ],
              [
                52.0060196,
                32.7776809
              ],
              [
                52.0057395,
                32.77741
              ],
              [
                52.0018531,
                32.7562904
              ],
              [
                52.0001866,
                32.7532384
              ],
              [
                51.9993531,
                32.7518479
              ],
              [
                51.9990731,
                32.7515771
              ],
              [
                51.9976865,
                32.7485161
              ],
              [
                51.9937966,
                32.7465749
              ],
              [
                51.9929632,
                32.7468547
              ],
              [
                51.9824067,
                32.7507373
              ],
              [
                51.9701834,
                32.7571301
              ],
              [
                51.9687935,
                32.757401
              ],
              [
                51.9579602,
                32.7635138
              ],
              [
                51.9410172,
                32.7765702
              ],
              [
                51.9404606,
                32.7776808
              ],
              [
                51.9361958,
                32.7846402
              ],
              [
                51.9321952,
                32.7827464
              ],
              [
                51.925976,
                32.7794271
              ],
              [
                51.920968,
                32.7764923
              ],
              [
                51.8892671,
                32.7636672
              ],
              [
                51.8851281,
                32.7603557
              ],
              [
                51.8821516,
                32.7549777
              ],
              [
                51.8812393,
                32.7511142
              ],
              [
                51.8806982,
                32.7488577
              ],
              [
                51.880499,
                32.745599
              ],
              [
                51.880289,
                32.7424842
              ],
              [
                51.8800508,
                32.7395422
              ],
              [
                51.8798792,
                32.7366808
              ],
              [
                51.8795196,
                32.7320555
              ],
              [
                51.880125,
                32.7288648
              ],
              [
                51.8820734,
                32.7248196
              ],
              [
                51.8852305,
                32.7202157
              ],
              [
                51.8880629,
                32.7166231
              ],
              [
                51.8904267,
                32.7145645
              ],
              [
                51.893668,
                32.7119195
              ],
              [
                51.8991587,
                32.708155
              ],
              [
                51.9074122,
                32.7032695
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 16692177,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "نجف آباد",
          "name:en": "Najaf Abad",
          "place": "city",
          "population": "280281",
          "type": "multipolygon",
          "wikidata": "Q721198",
          "wikipedia": "en:Najafabad",
          "wikipedia:fa": "نجف آباد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.329489,
                32.5967189
              ],
              [
                51.3299498,
                32.5955338
              ],
              [
                51.3340797,
                32.5942306
              ],
              [
                51.3604023,
                32.5859244
              ],
              [
                51.3778135,
                32.5862086
              ],
              [
                51.3917999,
                32.5862108
              ],
              [
                51.3948534,
                32.5908122
              ],
              [
                51.3958335,
                32.5971614
              ],
              [
                51.3961836,
                32.5994289
              ],
              [
                51.4013413,
                32.6099303
              ],
              [
                51.4012845,
                32.6176253
              ],
              [
                51.4019748,
                32.6183062
              ],
              [
                51.4113527,
                32.6271307
              ],
              [
                51.4136715,
                32.6514688
              ],
              [
                51.4272816,
                32.6620536
              ],
              [
                51.4418441,
                32.6709216
              ],
              [
                51.4426728,
                32.6834821
              ],
              [
                51.4455654,
                32.6898076
              ],
              [
                51.4364296,
                32.6962513
              ],
              [
                51.4345741,
                32.697599
              ],
              [
                51.4254247,
                32.6949519
              ],
              [
                51.4245211,
                32.6896001
              ],
              [
                51.4181909,
                32.6768522
              ],
              [
                51.4054829,
                32.6774912
              ],
              [
                51.4078927,
                32.6925505
              ],
              [
                51.3780902,
                32.7026756
              ],
              [
                51.3682454,
                32.7032734
              ],
              [
                51.3451402,
                32.7040336
              ],
              [
                51.3419034,
                32.6976448
              ],
              [
                51.3595654,
                32.6825834
              ],
              [
                51.3804968,
                32.6779621
              ],
              [
                51.3819012,
                32.6745212
              ],
              [
                51.3864288,
                32.6587337
              ],
              [
                51.3621602,
                32.6691205
              ],
              [
                51.3138803,
                32.6726789
              ],
              [
                51.3111484,
                32.6665962
              ],
              [
                51.3037247,
                32.6640231
              ],
              [
                51.2898478,
                32.659384
              ],
              [
                51.2861455,
                32.6584968
              ],
              [
                51.2743318,
                32.6486724
              ],
              [
                51.2687271,
                32.6407788
              ],
              [
                51.2624678,
                32.6262646
              ],
              [
                51.2787327,
                32.6233912
              ],
              [
                51.2949118,
                32.6211501
              ],
              [
                51.3195523,
                32.6189076
              ],
              [
                51.3211373,
                32.6181971
              ],
              [
                51.329489,
                32.5967189
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4514974317
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.1203257,
          32.942017
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3342978613
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.1598427,
          33.0805194
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 891686054
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5708254,
          31.4136588
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820885106
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.6471146,
          31.9367339
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 1487544742
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.8651719,
          32.0116032
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820885075
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.1530853,
          32.7039199
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4514974318
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.6290648,
          32.7679417
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 10694777568
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.4137004,
          32.986101
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820417174
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5046633,
          32.3424135
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820885051
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5079153,
          32.5576772
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5436844169
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5254892,
          32.6938201
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 26038567
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.6650002,
          32.6707877
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2817866841
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.558376,
          32.8556169
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820885088
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.69628,
          32.803716
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 27403186
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.085985,
          32.8610688
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821009117
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.3146044,
          33.22692
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821009063
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.2883303,
          33.456488
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 314358720
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.9140078,
          33.5136336
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 1909925519
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.4428856,
          33.9876533
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 312441256
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.4835403,
          34.0584233
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2433865131
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.3724967,
          33.3797762
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2450628401
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.0828304,
          33.7761331
        ]
      }
    }
  ]
},
"البرز.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554885,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اشتهارد",
          "name:en": "Eshtehard County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4808763"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.2019068,
                35.5271473
              ],
              [
                50.2200507,
                35.5311786
              ],
              [
                50.2280472,
                35.5320984
              ],
              [
                50.2850243,
                35.5366967
              ],
              [
                50.3223609,
                35.5432615
              ],
              [
                50.3289699,
                35.5472422
              ],
              [
                50.3329055,
                35.5507027
              ],
              [
                50.3359547,
                35.5722262
              ],
              [
                50.3363967,
                35.5796417
              ],
              [
                50.3327898,
                35.5909379
              ],
              [
                50.3348166,
                35.6108344
              ],
              [
                50.3390627,
                35.617093
              ],
              [
                50.3390459,
                35.6171459
              ],
              [
                50.3443563,
                35.6265629
              ],
              [
                50.3497457,
                35.6342697
              ],
              [
                50.3504345,
                35.6366497
              ],
              [
                50.3554448,
                35.6429279
              ],
              [
                50.3684747,
                35.6549579
              ],
              [
                50.3735038,
                35.6584407
              ],
              [
                50.3899732,
                35.6601183
              ],
              [
                50.4010756,
                35.6624981
              ],
              [
                50.4320327,
                35.6659741
              ],
              [
                50.4449465,
                35.668183
              ],
              [
                50.4784791,
                35.6746135
              ],
              [
                50.5017886,
                35.6768269
              ],
              [
                50.5550048,
                35.6780321
              ],
              [
                50.5603199,
                35.678499
              ],
              [
                50.6022051,
                35.6853998
              ],
              [
                50.6473003,
                35.6843362
              ],
              [
                50.6622927,
                35.6843348
              ],
              [
                50.7091523,
                35.68334
              ],
              [
                50.7140921,
                35.6832351
              ],
              [
                50.7365797,
                35.6821196
              ],
              [
                50.7455233,
                35.6887396
              ],
              [
                50.759426,
                35.6987318
              ],
              [
                50.7609338,
                35.6995273
              ],
              [
                50.7494129,
                35.7102981
              ],
              [
                50.7445185,
                35.7110837
              ],
              [
                50.7430765,
                35.7111256
              ],
              [
                50.7337296,
                35.7117528
              ],
              [
                50.7294552,
                35.7120037
              ],
              [
                50.7292235,
                35.7181711
              ],
              [
                50.7296695,
                35.7197154
              ],
              [
                50.7309744,
                35.7242335
              ],
              [
                50.7323944,
                35.7384956
              ],
              [
                50.7413717,
                35.7592219
              ],
              [
                50.7233991,
                35.7653746
              ],
              [
                50.7085418,
                35.772102
              ],
              [
                50.6953345,
                35.7811772
              ],
              [
                50.6826186,
                35.7855366
              ],
              [
                50.6573423,
                35.7913689
              ],
              [
                50.6534523,
                35.7919278
              ],
              [
                50.649839,
                35.7919277
              ],
              [
                50.6467853,
                35.7924776
              ],
              [
                50.6456721,
                35.792757
              ],
              [
                50.6442857,
                35.7927571
              ],
              [
                50.643452,
                35.7930365
              ],
              [
                50.6423388,
                35.7930365
              ],
              [
                50.6417856,
                35.792757
              ],
              [
                50.6406723,
                35.792757
              ],
              [
                50.6403958,
                35.7924776
              ],
              [
                50.6387289,
                35.7924776
              ],
              [
                50.6381723,
                35.7921981
              ],
              [
                50.6365055,
                35.7919278
              ],
              [
                50.6337292,
                35.7919277
              ],
              [
                50.6331722,
                35.7916392
              ],
              [
                50.6295623,
                35.7910893
              ],
              [
                50.6270623,
                35.7899806
              ],
              [
                50.626229,
                35.7899807
              ],
              [
                50.6245627,
                35.7891423
              ],
              [
                50.6223392,
                35.7885924
              ],
              [
                50.6203957,
                35.7885924
              ],
              [
                50.6201156,
                35.7883129
              ],
              [
                50.6190059,
                35.7880335
              ],
              [
                50.6178961,
                35.7880335
              ],
              [
                50.6173391,
                35.787754
              ],
              [
                50.6153926,
                35.787754
              ],
              [
                50.6142827,
                35.7872042
              ],
              [
                50.6134491,
                35.7872042
              ],
              [
                50.611506,
                35.7863659
              ],
              [
                50.5973363,
                35.7824806
              ],
              [
                50.591783,
                35.7802541
              ],
              [
                50.5909495,
                35.7802541
              ],
              [
                50.5878927,
                35.7794248
              ],
              [
                50.586783,
                35.7794247
              ],
              [
                50.5865028,
                35.7791453
              ],
              [
                50.5842828,
                35.7791453
              ],
              [
                50.5837262,
                35.7788659
              ],
              [
                50.5826164,
                35.7788659
              ],
              [
                50.5812261,
                35.7791452
              ],
              [
                50.5776128,
                35.7794247
              ],
              [
                50.5714539,
                35.7794247
              ],
              [
                50.5651133,
                35.7794247
              ],
              [
                50.5513768,
                35.7760819
              ],
              [
                50.5445566,
                35.7744216
              ],
              [
                50.5437234,
                35.7738627
              ],
              [
                50.5345568,
                35.7713657
              ],
              [
                50.5334471,
                35.7713658
              ],
              [
                50.504834,
                35.764145
              ],
              [
                50.5023339,
                35.7635861
              ],
              [
                50.4965006,
                35.7624773
              ],
              [
                50.494554,
                35.7624774
              ],
              [
                50.4937209,
                35.7621979
              ],
              [
                50.4895539,
                35.7621978
              ],
              [
                50.4892774,
                35.7624773
              ],
              [
                50.487611,
                35.7624773
              ],
              [
                50.4870543,
                35.7627568
              ],
              [
                50.4603877,
                35.7727538
              ],
              [
                50.4501304,
                35.7770596
              ],
              [
                50.4122475,
                35.8044303
              ],
              [
                50.3714919,
                35.834429
              ],
              [
                50.3706586,
                35.8349788
              ],
              [
                50.3353826,
                35.8541422
              ],
              [
                50.3313526,
                35.8573375
              ],
              [
                50.3309356,
                35.8569274
              ],
              [
                50.3281589,
                35.8533129
              ],
              [
                50.3151028,
                35.8424783
              ],
              [
                50.3151029,
                35.8421989
              ],
              [
                50.2970462,
                35.8224764
              ],
              [
                50.2918249,
                35.819517
              ],
              [
                50.2847668,
                35.8013865
              ],
              [
                50.2857968,
                35.7841206
              ],
              [
                50.2761837,
                35.7791072
              ],
              [
                50.2627943,
                35.7837027
              ],
              [
                50.2531496,
                35.7793684
              ],
              [
                50.252063,
                35.7535238
              ],
              [
                50.2459336,
                35.7277522
              ],
              [
                50.2437105,
                35.7163664
              ],
              [
                50.2434336,
                35.6985886
              ],
              [
                50.2434347,
                35.689158
              ],
              [
                50.2434336,
                35.6891406
              ],
              [
                50.2437106,
                35.6855345
              ],
              [
                50.2439795,
                35.6847194
              ],
              [
                50.2439872,
                35.6846961
              ],
              [
                50.243712,
                35.6816555
              ],
              [
                50.2437106,
                35.6816399
              ],
              [
                50.2442673,
                35.6746981
              ],
              [
                50.2445387,
                35.6741496
              ],
              [
                50.2445439,
                35.6741391
              ],
              [
                50.2437107,
                35.6477508
              ],
              [
                50.2417673,
                35.644424
              ],
              [
                50.2403774,
                35.6427562
              ],
              [
                50.2384305,
                35.6410792
              ],
              [
                50.2273209,
                35.6363639
              ],
              [
                50.2264873,
                35.6363639
              ],
              [
                50.2139875,
                35.6330282
              ],
              [
                50.2128741,
                35.6330281
              ],
              [
                50.212321,
                35.6327487
              ],
              [
                50.2106542,
                35.6327486
              ],
              [
                50.2098209,
                35.632469
              ],
              [
                50.2078744,
                35.6321986
              ],
              [
                50.2056544,
                35.6321987
              ],
              [
                50.2053744,
                35.6319192
              ],
              [
                50.2045412,
                35.6319191
              ],
              [
                50.2034309,
                35.6316396
              ],
              [
                50.2000977,
                35.6313692
              ],
              [
                50.1939843,
                35.6313692
              ],
              [
                50.1937077,
                35.6310807
              ],
              [
                50.1834313,
                35.6294218
              ],
              [
                50.1792614,
                35.6285833
              ],
              [
                50.168708,
                35.6241385
              ],
              [
                50.1650946,
                35.6191346
              ],
              [
                50.1634282,
                35.6141399
              ],
              [
                50.1631547,
                35.6105736
              ],
              [
                50.1631517,
                35.6105336
              ],
              [
                50.1645415,
                35.6033117
              ],
              [
                50.1648181,
                35.6027528
              ],
              [
                50.1678749,
                35.5963603
              ],
              [
                50.2059774,
                35.5732452
              ],
              [
                50.2090306,
                35.5707473
              ],
              [
                50.2032222,
                35.535874
              ],
              [
                50.2027175,
                35.5340377
              ],
              [
                50.2019068,
                35.5271473
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555065,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ساوجبلاغ",
          "name:en": "Savojbolagh County",
          "place": "county",
          "source": "type=boundary admin_level=5 boundary=administrative name=شهرستان ساوجبلاغ name:en=Savojbolagh County place=county wikidata=Q1274555 wikipedia=en:Savojbolagh County",
          "type": "boundary",
          "wikidata": "Q1274555",
          "wikipedia": "en:Savojbolagh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.5604279,
                36.0420636
              ],
              [
                50.5770822,
                36.0325107
              ],
              [
                50.5808901,
                36.0303075
              ],
              [
                50.5838534,
                36.0286022
              ],
              [
                50.5895845,
                36.0250881
              ],
              [
                50.5925971,
                36.0227557
              ],
              [
                50.5961763,
                36.0191736
              ],
              [
                50.6006566,
                36.0148833
              ],
              [
                50.6022889,
                36.0133177
              ],
              [
                50.6071712,
                36.0086347
              ],
              [
                50.6101581,
                36.0063851
              ],
              [
                50.6119863,
                36.005177
              ],
              [
                50.6136085,
                36.0042605
              ],
              [
                50.6174267,
                36.002291
              ],
              [
                50.6206949,
                36.0010532
              ],
              [
                50.6296556,
                35.9983451
              ],
              [
                50.63444,
                35.9967641
              ],
              [
                50.6309381,
                35.9902849
              ],
              [
                50.6288266,
                35.9912641
              ],
              [
                50.6273074,
                35.9875556
              ],
              [
                50.6258419,
                35.9863689
              ],
              [
                50.6297536,
                35.9841803
              ],
              [
                50.6400171,
                35.9790041
              ],
              [
                50.641047,
                35.9785666
              ],
              [
                50.6414848,
                35.979025
              ],
              [
                50.6413303,
                35.9798585
              ],
              [
                50.6404033,
                35.9805461
              ],
              [
                50.6420255,
                35.9829422
              ],
              [
                50.6428752,
                35.9841299
              ],
              [
                50.6427465,
                35.9849633
              ],
              [
                50.6434417,
                35.9857551
              ],
              [
                50.6436734,
                35.9867343
              ],
              [
                50.6440854,
                35.9878177
              ],
              [
                50.644808,
                35.9898955
              ],
              [
                50.645014,
                35.9934789
              ],
              [
                50.6561891,
                35.9898747
              ],
              [
                50.6554939,
                35.9887288
              ],
              [
                50.6554681,
                35.9875829
              ],
              [
                50.6553909,
                35.9866662
              ],
              [
                50.6555196,
                35.9856452
              ],
              [
                50.6551076,
                35.9853744
              ],
              [
                50.6539747,
                35.9837492
              ],
              [
                50.6537944,
                35.9817906
              ],
              [
                50.6522495,
                35.9817698
              ],
              [
                50.6521898,
                35.980663
              ],
              [
                50.6494088,
                35.9771832
              ],
              [
                50.6487733,
                35.9759771
              ],
              [
                50.6454029,
                35.9721094
              ],
              [
                50.6410771,
                35.9698588
              ],
              [
                50.6383497,
                35.9676377
              ],
              [
                50.6364994,
                35.9664477
              ],
              [
                50.663223,
                35.9523473
              ],
              [
                50.6644302,
                35.9517103
              ],
              [
                50.6728352,
                35.947524
              ],
              [
                50.6792875,
                35.9443102
              ],
              [
                50.6818367,
                35.9427467
              ],
              [
                50.6821457,
                35.941621
              ],
              [
                50.6818624,
                35.939703
              ],
              [
                50.6776911,
                35.9341366
              ],
              [
                50.6756826,
                35.9317389
              ],
              [
                50.6778713,
                35.9274646
              ],
              [
                50.6782318,
                35.9259634
              ],
              [
                50.6772018,
                35.9244204
              ],
              [
                50.6777168,
                35.9230233
              ],
              [
                50.6777941,
                35.921522
              ],
              [
                50.678618,
                35.9205628
              ],
              [
                50.6809612,
                35.9191031
              ],
              [
                50.6822229,
                35.9184566
              ],
              [
                50.6840254,
                35.9172888
              ],
              [
                50.6861883,
                35.9159125
              ],
              [
                50.688377,
                35.9136811
              ],
              [
                50.6884285,
                35.9121587
              ],
              [
                50.687038,
                35.9098021
              ],
              [
                50.6863943,
                35.9083005
              ],
              [
                50.6846434,
                35.9065903
              ],
              [
                50.6824547,
                35.9053598
              ],
              [
                50.6817594,
                35.9037747
              ],
              [
                50.680987,
                35.9028987
              ],
              [
                50.6796995,
                35.9015847
              ],
              [
                50.6773306,
                35.9005418
              ],
              [
                50.6741119,
                35.89904
              ],
              [
                50.6712023,
                35.8980806
              ],
              [
                50.6700436,
                35.8977885
              ],
              [
                50.6679836,
                35.8969542
              ],
              [
                50.6650997,
                35.8965162
              ],
              [
                50.6634003,
                35.8957861
              ],
              [
                50.6605936,
                35.8957027
              ],
              [
                50.6603854,
                35.8915228
              ],
              [
                50.6613037,
                35.887586
              ],
              [
                50.6610768,
                35.8864638
              ],
              [
                50.6604445,
                35.8856699
              ],
              [
                50.6577421,
                35.8840743
              ],
              [
                50.6547958,
                35.8815631
              ],
              [
                50.650614,
                35.8773719
              ],
              [
                50.6491663,
                35.8777876
              ],
              [
                50.6470178,
                35.8781422
              ],
              [
                50.6457514,
                35.8788639
              ],
              [
                50.6425611,
                35.8790997
              ],
              [
                50.6404793,
                35.8792473
              ],
              [
                50.6403681,
                35.8777097
              ],
              [
                50.6403681,
                35.8768334
              ],
              [
                50.6405998,
                35.8745383
              ],
              [
                50.6400693,
                35.8699244
              ],
              [
                50.6393226,
                35.8655007
              ],
              [
                50.6385244,
                35.8621202
              ],
              [
                50.6390909,
                35.8572995
              ],
              [
                50.6389364,
                35.8535639
              ],
              [
                50.6375717,
                35.8468642
              ],
              [
                50.6367734,
                35.8443178
              ],
              [
                50.6376212,
                35.8386499
              ],
              [
                50.6380422,
                35.837685
              ],
              [
                50.6560729,
                35.8414328
              ],
              [
                50.6660881,
                35.8444578
              ],
              [
                50.6664783,
                35.8445331
              ],
              [
                50.6668079,
                35.84458
              ],
              [
                50.6669793,
                35.8445595
              ],
              [
                50.6672899,
                35.8445837
              ],
              [
                50.6675678,
                35.8446626
              ],
              [
                50.6680698,
                35.8449594
              ],
              [
                50.6691491,
                35.8456661
              ],
              [
                50.6699972,
                35.8460552
              ],
              [
                50.6701478,
                35.8464189
              ],
              [
                50.6704852,
                35.846926
              ],
              [
                50.6707189,
                35.8469834
              ],
              [
                50.6709416,
                35.846995
              ],
              [
                50.6716705,
                35.8468157
              ],
              [
                50.6725469,
                35.8468045
              ],
              [
                50.6740547,
                35.8465974
              ],
              [
                50.6746704,
                35.8467038
              ],
              [
                50.6757492,
                35.8467835
              ],
              [
                50.6764953,
                35.8467086
              ],
              [
                50.6774244,
                35.8464573
              ],
              [
                50.6778304,
                35.8464247
              ],
              [
                50.6780272,
                35.8464634
              ],
              [
                50.6782634,
                35.8464338
              ],
              [
                50.6786834,
                35.8462531
              ],
              [
                50.6790609,
                35.8460946
              ],
              [
                50.6794383,
                35.8458631
              ],
              [
                50.6801073,
                35.8456784
              ],
              [
                50.680813,
                35.8455246
              ],
              [
                50.6810211,
                35.8455339
              ],
              [
                50.6811527,
                35.8455529
              ],
              [
                50.6813512,
                35.8459051
              ],
              [
                50.6815388,
                35.8462566
              ],
              [
                50.6818229,
                35.8466168
              ],
              [
                50.6825522,
                35.8470677
              ],
              [
                50.6831019,
                35.8474843
              ],
              [
                50.6833146,
                35.8478183
              ],
              [
                50.6838429,
                35.8485662
              ],
              [
                50.6842962,
                35.8488271
              ],
              [
                50.6845497,
                35.8489494
              ],
              [
                50.6847992,
                35.8489554
              ],
              [
                50.6850096,
                35.8488955
              ],
              [
                50.6852914,
                35.8488122
              ],
              [
                50.685536,
                35.8487506
              ],
              [
                50.6858769,
                35.848686
              ],
              [
                50.6863464,
                35.8486581
              ],
              [
                50.6865216,
                35.8486173
              ],
              [
                50.686735,
                35.8484887
              ],
              [
                50.6868989,
                35.848359
              ],
              [
                50.6870355,
                35.8482239
              ],
              [
                50.687132,
                35.8481664
              ],
              [
                50.6872671,
                35.8481658
              ],
              [
                50.6876546,
                35.8483735
              ],
              [
                50.6879816,
                35.8486013
              ],
              [
                50.6880874,
                35.8486556
              ],
              [
                50.6881863,
                35.848653
              ],
              [
                50.6882863,
                35.8486058
              ],
              [
                50.6883892,
                35.8485177
              ],
              [
                50.688468,
                35.8483604
              ],
              [
                50.6885288,
                35.8482031
              ],
              [
                50.6885717,
                35.8476487
              ],
              [
                50.6889687,
                35.847427
              ],
              [
                50.6893871,
                35.8473574
              ],
              [
                50.6903098,
                35.847053
              ],
              [
                50.6914182,
                35.8473704
              ],
              [
                50.6923979,
                35.8478792
              ],
              [
                50.6931663,
                35.8479748
              ],
              [
                50.6934909,
                35.8481922
              ],
              [
                50.6940112,
                35.8487901
              ],
              [
                50.6943867,
                35.8495532
              ],
              [
                50.6957439,
                35.8503555
              ],
              [
                50.6960201,
                35.8506305
              ],
              [
                50.6961462,
                35.8508968
              ],
              [
                50.6964929,
                35.8511463
              ],
              [
                50.6967967,
                35.8513262
              ],
              [
                50.6972111,
                35.8514686
              ],
              [
                50.6983618,
                35.851936
              ],
              [
                50.6987855,
                35.8522534
              ],
              [
                50.6993246,
                35.8524295
              ],
              [
                50.6998423,
                35.8524491
              ],
              [
                50.7007677,
                35.8520425
              ],
              [
                50.7015965,
                35.8518447
              ],
              [
                50.702161,
                35.8518468
              ],
              [
                50.7053581,
                35.8522126
              ],
              [
                50.7163525,
                35.8507238
              ],
              [
                50.7185595,
                35.8527309
              ],
              [
                50.7206967,
                35.8528979
              ],
              [
                50.7225763,
                35.8529605
              ],
              [
                50.7249195,
                35.8554857
              ],
              [
                50.726104,
                35.8570092
              ],
              [
                50.7279322,
                35.8593465
              ],
              [
                50.7291166,
                35.8596596
              ],
              [
                50.7297861,
                35.8604943
              ],
              [
                50.7318976,
                35.8603691
              ],
              [
                50.734009,
                35.8631654
              ],
              [
                50.7407295,
                35.8651478
              ],
              [
                50.7471819,
                35.8751112
              ],
              [
                50.757778,
                35.8709854
              ],
              [
                50.7619555,
                35.8764118
              ],
              [
                50.7724418,
                35.8847848
              ],
              [
                50.773329,
                35.88642
              ],
              [
                50.7803876,
                35.8923694
              ],
              [
                50.7846641,
                35.8972645
              ],
              [
                50.7869494,
                35.8999952
              ],
              [
                50.7939746,
                35.9097074
              ],
              [
                50.7973309,
                35.9131008
              ],
              [
                50.7976739,
                35.9157875
              ],
              [
                50.8008225,
                35.9155279
              ],
              [
                50.8103585,
                35.9149406
              ],
              [
                50.8174658,
                35.9144025
              ],
              [
                50.8208281,
                35.9139296
              ],
              [
                50.8253582,
                35.9130165
              ],
              [
                50.8298884,
                35.9116956
              ],
              [
                50.8335125,
                35.910228
              ],
              [
                50.8383647,
                35.9083853
              ],
              [
                50.8523452,
                35.9029764
              ],
              [
                50.8562076,
                35.9013078
              ],
              [
                50.858937,
                35.8996392
              ],
              [
                50.8635204,
                35.8965104
              ],
              [
                50.8671318,
                35.8941507
              ],
              [
                50.8735176,
                35.8891443
              ],
              [
                50.8738009,
                35.889937
              ],
              [
                50.8774058,
                35.9063317
              ],
              [
                50.8781268,
                35.9059354
              ],
              [
                50.8833796,
                35.9118793
              ],
              [
                50.8847614,
                35.9224607
              ],
              [
                50.8868533,
                35.9252571
              ],
              [
                50.8931814,
                35.9288829
              ],
              [
                50.9027086,
                35.9296544
              ],
              [
                50.905438,
                35.9269855
              ],
              [
                50.9166904,
                35.9208134
              ],
              [
                50.9281402,
                35.9198839
              ],
              [
                50.9335197,
                35.9217726
              ],
              [
                50.9369186,
                35.923128
              ],
              [
                50.942635,
                35.9272982
              ],
              [
                50.9503597,
                35.9314266
              ],
              [
                50.9535784,
                35.9330528
              ],
              [
                50.9551233,
                35.935096
              ],
              [
                50.9660291,
                35.9442605
              ],
              [
                50.9708819,
                35.9482505
              ],
              [
                50.9729933,
                35.9509186
              ],
              [
                50.9750275,
                35.9541077
              ],
              [
                50.9774221,
                35.9566715
              ],
              [
                50.9808176,
                35.9607356
              ],
              [
                50.9850919,
                35.9631741
              ],
              [
                50.9942586,
                35.9664669
              ],
              [
                50.9962156,
                35.9668004
              ],
              [
                50.9984043,
                35.9670713
              ],
              [
                51.0005414,
                35.9678841
              ],
              [
                51.0012109,
                35.9684884
              ],
              [
                51.0033996,
                35.969322
              ],
              [
                51.0080345,
                35.9704265
              ],
              [
                51.0101974,
                35.9712601
              ],
              [
                51.0165317,
                35.9747193
              ],
              [
                51.0182224,
                35.9777845
              ],
              [
                51.0190722,
                35.9820769
              ],
              [
                51.0198704,
                35.9844314
              ],
              [
                51.022574,
                35.994411
              ],
              [
                51.023707,
                35.9998691
              ],
              [
                51.0244774,
                36.0038973
              ],
              [
                51.0268978,
                36.0072717
              ],
              [
                51.0308374,
                36.0090006
              ],
              [
                51.0382017,
                36.012229
              ],
              [
                51.0416778,
                36.0134787
              ],
              [
                51.0462354,
                36.0143743
              ],
              [
                51.0548357,
                36.0170611
              ],
              [
                51.0602688,
                36.0177484
              ],
              [
                51.0703625,
                36.0194353
              ],
              [
                51.0800442,
                36.0204766
              ],
              [
                51.0806934,
                36.0238745
              ],
              [
                51.0851366,
                36.034707
              ],
              [
                51.0856933,
                36.042205
              ],
              [
                51.0854167,
                36.0472066
              ],
              [
                51.0915107,
                36.0583144
              ],
              [
                51.0923356,
                36.0688011
              ],
              [
                51.091043,
                36.0759588
              ],
              [
                51.0897535,
                36.0846486
              ],
              [
                51.0902167,
                36.0866719
              ],
              [
                51.0873652,
                36.1093894
              ],
              [
                51.0853529,
                36.1199543
              ],
              [
                51.0836363,
                36.1240101
              ],
              [
                51.0837593,
                36.1271462
              ],
              [
                51.0687446,
                36.1251194
              ],
              [
                51.0552459,
                36.1228114
              ],
              [
                51.0446144,
                36.1226034
              ],
              [
                51.0370229,
                36.1232243
              ],
              [
                51.0251931,
                36.123858
              ],
              [
                51.0179973,
                36.1229517
              ],
              [
                51.0102431,
                36.1210086
              ],
              [
                51.0064114,
                36.1206638
              ],
              [
                51.0003675,
                36.1195546
              ],
              [
                50.993396,
                36.1174073
              ],
              [
                50.9864943,
                36.1153964
              ],
              [
                50.9810259,
                36.1138691
              ],
              [
                50.9746528,
                36.1119988
              ],
              [
                50.9700511,
                36.1115135
              ],
              [
                50.9591975,
                36.1088872
              ],
              [
                50.9526993,
                36.1078491
              ],
              [
                50.9458163,
                36.1065316
              ],
              [
                50.9332489,
                36.1046632
              ],
              [
                50.9228253,
                36.1028602
              ],
              [
                50.9109287,
                36.1011254
              ],
              [
                50.9053457,
                36.1002863
              ],
              [
                50.8908176,
                36.0979381
              ],
              [
                50.8670425,
                36.0950253
              ],
              [
                50.8476447,
                36.0954414
              ],
              [
                50.8333968,
                36.0945398
              ],
              [
                50.8178227,
                36.0938604
              ],
              [
                50.8030343,
                36.0943114
              ],
              [
                50.7944297,
                36.0946785
              ],
              [
                50.7880783,
                36.0957534
              ],
              [
                50.7798814,
                36.0959268
              ],
              [
                50.7678448,
                36.1039024
              ],
              [
                50.7582722,
                36.1037546
              ],
              [
                50.7524453,
                36.0993873
              ],
              [
                50.7381335,
                36.095635
              ],
              [
                50.719285,
                36.1007121
              ],
              [
                50.6980507,
                36.1009621
              ],
              [
                50.6806182,
                36.102862
              ],
              [
                50.6736287,
                36.1053388
              ],
              [
                50.6620785,
                36.0990479
              ],
              [
                50.6026155,
                36.0974818
              ],
              [
                50.5604279,
                36.0420636
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555118,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان طالقان",
          "name:en": "Taleghan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2438558"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.4332141,
                36.2393804
              ],
              [
                50.4345845,
                36.238666
              ],
              [
                50.4439864,
                36.2364441
              ],
              [
                50.4506349,
                36.2348237
              ],
              [
                50.4546298,
                36.2337188
              ],
              [
                50.459926,
                36.2322276
              ],
              [
                50.4634451,
                36.2311718
              ],
              [
                50.4676844,
                36.2299937
              ],
              [
                50.4722214,
                36.2287311
              ],
              [
                50.4777353,
                36.2271836
              ],
              [
                50.4811048,
                36.2262387
              ],
              [
                50.4887008,
                36.2225343
              ],
              [
                50.4914903,
                36.221184
              ],
              [
                50.496683,
                36.2184143
              ],
              [
                50.5003737,
                36.2166485
              ],
              [
                50.504322,
                36.2131168
              ],
              [
                50.5110644,
                36.2076359
              ],
              [
                50.5171966,
                36.202313
              ],
              [
                50.5206728,
                36.2012394
              ],
              [
                50.523076,
                36.2008931
              ],
              [
                50.5265521,
                36.1984689
              ],
              [
                50.5305862,
                36.1937243
              ],
              [
                50.5378597,
                36.1870277
              ],
              [
                50.5408833,
                36.1845985
              ],
              [
                50.5465912,
                36.1813861
              ],
              [
                50.5513366,
                36.1786013
              ],
              [
                50.5576509,
                36.1750412
              ],
              [
                50.561434,
                36.17264
              ],
              [
                50.5661725,
                36.1702798
              ],
              [
                50.5703684,
                36.1677103
              ],
              [
                50.5797243,
                36.1623744
              ],
              [
                50.6052589,
                36.1511478
              ],
              [
                50.6125784,
                36.1469832
              ],
              [
                50.6178974,
                36.1439311
              ],
              [
                50.6462184,
                36.1304475
              ],
              [
                50.6687736,
                36.118429
              ],
              [
                50.673666,
                36.112362
              ],
              [
                50.675683,
                36.1074734
              ],
              [
                50.6748139,
                36.1061732
              ],
              [
                50.6736287,
                36.1053388
              ],
              [
                50.6806182,
                36.102862
              ],
              [
                50.6980507,
                36.1009621
              ],
              [
                50.719285,
                36.1007121
              ],
              [
                50.7381335,
                36.095635
              ],
              [
                50.7524453,
                36.0993873
              ],
              [
                50.7582722,
                36.1037546
              ],
              [
                50.7678448,
                36.1039024
              ],
              [
                50.7798814,
                36.0959268
              ],
              [
                50.7880783,
                36.0957534
              ],
              [
                50.7944297,
                36.0946785
              ],
              [
                50.8030343,
                36.0943114
              ],
              [
                50.8178227,
                36.0938604
              ],
              [
                50.8333968,
                36.0945398
              ],
              [
                50.8476447,
                36.0954414
              ],
              [
                50.8670425,
                36.0950253
              ],
              [
                50.8908176,
                36.0979381
              ],
              [
                50.9053457,
                36.1002863
              ],
              [
                50.9109287,
                36.1011254
              ],
              [
                50.9228253,
                36.1028602
              ],
              [
                50.9332489,
                36.1046632
              ],
              [
                50.9458163,
                36.1065316
              ],
              [
                50.9526993,
                36.1078491
              ],
              [
                50.9591975,
                36.1088872
              ],
              [
                50.9700511,
                36.1115135
              ],
              [
                50.9746528,
                36.1119988
              ],
              [
                50.9810259,
                36.1138691
              ],
              [
                50.9864943,
                36.1153964
              ],
              [
                50.993396,
                36.1174073
              ],
              [
                51.0003675,
                36.1195546
              ],
              [
                51.0064114,
                36.1206638
              ],
              [
                51.0102431,
                36.1210086
              ],
              [
                51.0179973,
                36.1229517
              ],
              [
                51.0251931,
                36.123858
              ],
              [
                51.0370229,
                36.1232243
              ],
              [
                51.0446144,
                36.1226034
              ],
              [
                51.0552459,
                36.1228114
              ],
              [
                51.0687446,
                36.1251194
              ],
              [
                51.0837593,
                36.1271462
              ],
              [
                51.0872934,
                36.1294918
              ],
              [
                51.0969172,
                36.1339977
              ],
              [
                51.1045421,
                36.1371211
              ],
              [
                51.1134653,
                36.1405799
              ],
              [
                51.1241692,
                36.1428693
              ],
              [
                51.1292515,
                36.1438397
              ],
              [
                51.1325489,
                36.1441191
              ],
              [
                51.1405793,
                36.1444656
              ],
              [
                51.1493507,
                36.1436319
              ],
              [
                51.1555489,
                36.1443942
              ],
              [
                51.1623656,
                36.1448815
              ],
              [
                51.1681265,
                36.1462636
              ],
              [
                51.1785094,
                36.1496314
              ],
              [
                51.1923416,
                36.1574914
              ],
              [
                51.223583,
                36.1808396
              ],
              [
                51.2408941,
                36.1986662
              ],
              [
                51.2433763,
                36.2024141
              ],
              [
                51.2494899,
                36.2096164
              ],
              [
                51.239461,
                36.2105845
              ],
              [
                51.2204855,
                36.2105949
              ],
              [
                51.2098019,
                36.2090136
              ],
              [
                51.2011319,
                36.2085395
              ],
              [
                51.1933831,
                36.2080661
              ],
              [
                51.1854099,
                36.2087599
              ],
              [
                51.1791362,
                36.2085041
              ],
              [
                51.1712837,
                36.2086446
              ],
              [
                51.157123,
                36.2090527
              ],
              [
                51.144385,
                36.2099152
              ],
              [
                51.1346527,
                36.2103084
              ],
              [
                51.1250198,
                36.2123269
              ],
              [
                51.1044501,
                36.2168909
              ],
              [
                51.063938,
                36.2301506
              ],
              [
                51.0410168,
                36.2372096
              ],
              [
                51.0246514,
                36.2409887
              ],
              [
                51.0098114,
                36.2447504
              ],
              [
                51.0042285,
                36.246513
              ],
              [
                50.9989763,
                36.2485704
              ],
              [
                51.0001284,
                36.2485033
              ],
              [
                50.9946189,
                36.2523003
              ],
              [
                50.9845088,
                36.2619347
              ],
              [
                50.9756049,
                36.267309
              ],
              [
                50.964117,
                36.2729608
              ],
              [
                50.9517574,
                36.2780466
              ],
              [
                50.9412963,
                36.2805097
              ],
              [
                50.9273386,
                36.2838932
              ],
              [
                50.9186055,
                36.2865326
              ],
              [
                50.9149297,
                36.2929376
              ],
              [
                50.9140298,
                36.2939145
              ],
              [
                50.9076038,
                36.3011458
              ],
              [
                50.9024911,
                36.3091185
              ],
              [
                50.9017914,
                36.3116473
              ],
              [
                50.9030485,
                36.3159897
              ],
              [
                50.905838,
                36.3229744
              ],
              [
                50.9061246,
                36.3300928
              ],
              [
                50.9049797,
                36.3332948
              ],
              [
                50.9029717,
                36.3376248
              ],
              [
                50.9002477,
                36.3409258
              ],
              [
                50.8954771,
                36.3448186
              ],
              [
                50.890485,
                36.3469668
              ],
              [
                50.8837366,
                36.3493864
              ],
              [
                50.8817933,
                36.3504978
              ],
              [
                50.881445,
                36.3508941
              ],
              [
                50.8820468,
                36.3495938
              ],
              [
                50.8820575,
                36.3491747
              ],
              [
                50.8817839,
                36.3481248
              ],
              [
                50.8804536,
                36.3468113
              ],
              [
                50.8791446,
                36.3449101
              ],
              [
                50.878458,
                36.3432423
              ],
              [
                50.8756578,
                36.3406324
              ],
              [
                50.8750892,
                36.3395607
              ],
              [
                50.8740699,
                36.338515
              ],
              [
                50.8720958,
                36.3362247
              ],
              [
                50.8715164,
                36.3358617
              ],
              [
                50.8706528,
                36.3356154
              ],
              [
                50.8690381,
                36.3350061
              ],
              [
                50.8654654,
                36.3343752
              ],
              [
                50.8646607,
                36.3343147
              ],
              [
                50.8637273,
                36.3339258
              ],
              [
                50.8634376,
                36.3335368
              ],
              [
                50.8626008,
                36.3321194
              ],
              [
                50.861839,
                36.3319206
              ],
              [
                50.8568394,
                36.3317131
              ],
              [
                50.8558953,
                36.3317564
              ],
              [
                50.8538782,
                36.3315057
              ],
              [
                50.8533579,
                36.3315122
              ],
              [
                50.8527866,
                36.3316958
              ],
              [
                50.8523172,
                36.3317628
              ],
              [
                50.8513221,
                36.3318363
              ],
              [
                50.8507937,
                36.3317002
              ],
              [
                50.8501768,
                36.3311945
              ],
              [
                50.8496028,
                36.330516
              ],
              [
                50.8489215,
                36.329911
              ],
              [
                50.8481491,
                36.3287053
              ],
              [
                50.8475697,
                36.3283595
              ],
              [
                50.8470547,
                36.3280786
              ],
              [
                50.8464807,
                36.3276248
              ],
              [
                50.8462285,
                36.3273115
              ],
              [
                50.846647,
                36.326661
              ],
              [
                50.8472264,
                36.3259047
              ],
              [
                50.8491146,
                36.3242278
              ],
              [
                50.8512068,
                36.3232424
              ],
              [
                50.8519256,
                36.3225422
              ],
              [
                50.8524835,
                36.3221359
              ],
              [
                50.8529019,
                36.3213493
              ],
              [
                50.8531057,
                36.3205454
              ],
              [
                50.8528268,
                36.3192314
              ],
              [
                50.8520973,
                36.3178742
              ],
              [
                50.8516252,
                36.3165948
              ],
              [
                50.8506811,
                36.3154537
              ],
              [
                50.849533,
                36.3142953
              ],
              [
                50.8485782,
                36.314131
              ],
              [
                50.8469045,
                36.3141656
              ],
              [
                50.845617,
                36.3142174
              ],
              [
                50.8440614,
                36.3142088
              ],
              [
                50.842334,
                36.3134739
              ],
              [
                50.8405745,
                36.313059
              ],
              [
                50.8391368,
                36.3131887
              ],
              [
                50.8366477,
                36.312255
              ],
              [
                50.8320451,
                36.3098169
              ],
              [
                50.8303499,
                36.3081656
              ],
              [
                50.8289552,
                36.3070503
              ],
              [
                50.8276033,
                36.3065488
              ],
              [
                50.8257472,
                36.3061771
              ],
              [
                50.8236766,
                36.3062895
              ],
              [
                50.8213055,
                36.305788
              ],
              [
                50.8186769,
                36.3050185
              ],
              [
                50.8169549,
                36.303981
              ],
              [
                50.8162469,
                36.3030255
              ],
              [
                50.8159561,
                36.3025563
              ],
              [
                50.8075568,
                36.3024958
              ],
              [
                50.7964305,
                36.3028244
              ],
              [
                50.7945682,
                36.3028732
              ],
              [
                50.7824992,
                36.3047505
              ],
              [
                50.7621574,
                36.3062031
              ],
              [
                50.7592641,
                36.3074533
              ],
              [
                50.7586383,
                36.3127737
              ],
              [
                50.7531451,
                36.3161626
              ],
              [
                50.7503584,
                36.3161852
              ],
              [
                50.74512,
                36.3186021
              ],
              [
                50.7423435,
                36.3186021
              ],
              [
                50.7377715,
                36.3191497
              ],
              [
                50.7300996,
                36.3192747
              ],
              [
                50.7273101,
                36.3173728
              ],
              [
                50.7271814,
                36.3144682
              ],
              [
                50.7261085,
                36.3134999
              ],
              [
                50.7218599,
                36.3135345
              ],
              [
                50.7192359,
                36.3147004
              ],
              [
                50.7141351,
                36.3155401
              ],
              [
                50.7084103,
                36.3160146
              ],
              [
                50.7074403,
                36.3186868
              ],
              [
                50.7048124,
                36.3203741
              ],
              [
                50.7027626,
                36.3217643
              ],
              [
                50.6995868,
                36.3221446
              ],
              [
                50.697484,
                36.3201045
              ],
              [
                50.6956385,
                36.3180645
              ],
              [
                50.6923341,
                36.3170617
              ],
              [
                50.6897163,
                36.3064797
              ],
              [
                50.6824206,
                36.3017762
              ],
              [
                50.67667,
                36.2967265
              ],
              [
                50.6723785,
                36.2967957
              ],
              [
                50.6685161,
                36.2939594
              ],
              [
                50.6647395,
                36.2932676
              ],
              [
                50.6606074,
                36.2885485
              ],
              [
                50.6592464,
                36.2859342
              ],
              [
                50.6567144,
                36.2877676
              ],
              [
                50.6537532,
                36.2887708
              ],
              [
                50.6487643,
                36.2907875
              ],
              [
                50.6414365,
                36.2907425
              ],
              [
                50.6379603,
                36.2876639
              ],
              [
                50.6281719,
                36.2870544
              ],
              [
                50.6253432,
                36.2893935
              ],
              [
                50.6210517,
                36.2931984
              ],
              [
                50.6121253,
                36.296519
              ],
              [
                50.6076621,
                36.2970032
              ],
              [
                50.5993365,
                36.3017762
              ],
              [
                50.5976199,
                36.3010845
              ],
              [
                50.5910968,
                36.3011537
              ],
              [
                50.5790805,
                36.3047505
              ],
              [
                50.571848,
                36.3061936
              ],
              [
                50.5646734,
                36.3075771
              ],
              [
                50.5604124,
                36.3093501
              ],
              [
                50.5565071,
                36.3105605
              ],
              [
                50.5529451,
                36.3100763
              ],
              [
                50.5515047,
                36.3092496
              ],
              [
                50.549941,
                36.3058918
              ],
              [
                50.5456924,
                36.3029867
              ],
              [
                50.5408001,
                36.3018108
              ],
              [
                50.5333328,
                36.300289
              ],
              [
                50.5326032,
                36.2976257
              ],
              [
                50.5310583,
                36.294582
              ],
              [
                50.5298043,
                36.2949701
              ],
              [
                50.5280971,
                36.2962076
              ],
              [
                50.5237197,
                36.3000469
              ],
              [
                50.5223035,
                36.3019491
              ],
              [
                50.5179745,
                36.3047488
              ],
              [
                50.5157068,
                36.3069268
              ],
              [
                50.5061674,
                36.3108717
              ],
              [
                50.504837,
                36.3134999
              ],
              [
                50.5040352,
                36.3163166
              ],
              [
                50.5022401,
                36.3190137
              ],
              [
                50.5001262,
                36.3199527
              ],
              [
                50.4967689,
                36.3196205
              ],
              [
                50.4926383,
                36.3185316
              ],
              [
                50.4894019,
                36.3193932
              ],
              [
                50.4842588,
                36.3205371
              ],
              [
                50.4806536,
                36.3209392
              ],
              [
                50.47544,
                36.3208998
              ],
              [
                50.4713629,
                36.320243
              ],
              [
                50.4629515,
                36.3170617
              ],
              [
                50.4588316,
                36.308624
              ],
              [
                50.4578015,
                36.302399
              ],
              [
                50.4471586,
                36.2981101
              ],
              [
                50.4411505,
                36.2985251
              ],
              [
                50.4322241,
                36.2938211
              ],
              [
                50.4239844,
                36.293406
              ],
              [
                50.419006,
                36.2903623
              ],
              [
                50.4213353,
                36.2742717
              ],
              [
                50.4267659,
                36.2717426
              ],
              [
                50.429372,
                36.2689705
              ],
              [
                50.4305739,
                36.2688319
              ],
              [
                50.4322241,
                36.2637917
              ],
              [
                50.4314447,
                36.254092
              ],
              [
                50.4287909,
                36.2503647
              ],
              [
                50.4308939,
                36.248115
              ],
              [
                50.4342093,
                36.2460411
              ],
              [
                50.4383182,
                36.2436502
              ],
              [
                50.434606,
                36.2410716
              ],
              [
                50.4332141,
                36.2393804
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555133,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فردیس",
          "name:en": "Fardis County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q16053063",
          "wikipedia": "fa:شهرستان فردیس"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.8983277,
                35.7218767
              ],
              [
                50.8991517,
                35.7218139
              ],
              [
                50.9027308,
                35.7194308
              ],
              [
                50.9001031,
                35.7072262
              ],
              [
                50.9000716,
                35.7065461
              ],
              [
                50.9038824,
                35.6966323
              ],
              [
                50.9042187,
                35.6959901
              ],
              [
                50.9047107,
                35.695483
              ],
              [
                50.9059632,
                35.69503
              ],
              [
                50.9108997,
                35.6938743
              ],
              [
                50.9188778,
                35.6917598
              ],
              [
                50.9192383,
                35.6928054
              ],
              [
                50.9160969,
                35.6943111
              ],
              [
                50.9161226,
                35.6948757
              ],
              [
                50.9165818,
                35.6991531
              ],
              [
                50.9171172,
                35.702172
              ],
              [
                50.9167578,
                35.7052135
              ],
              [
                50.9171622,
                35.7062572
              ],
              [
                50.9179298,
                35.7082547
              ],
              [
                50.9187834,
                35.7098239
              ],
              [
                50.9216179,
                35.71419
              ],
              [
                50.9226629,
                35.7153764
              ],
              [
                50.9249557,
                35.7173982
              ],
              [
                50.9266487,
                35.7187188
              ],
              [
                50.9284382,
                35.720095
              ],
              [
                50.9323866,
                35.7221269
              ],
              [
                50.9370855,
                35.7213377
              ],
              [
                50.9404877,
                35.7205201
              ],
              [
                50.9422206,
                35.7199756
              ],
              [
                50.9385389,
                35.7106328
              ],
              [
                50.9508618,
                35.7077805
              ],
              [
                50.9555426,
                35.7069001
              ],
              [
                50.9562672,
                35.7072722
              ],
              [
                50.9640026,
                35.7060231
              ],
              [
                50.969009,
                35.7051183
              ],
              [
                50.9691294,
                35.7050923
              ],
              [
                50.9691545,
                35.7050869
              ],
              [
                50.9712783,
                35.7046287
              ],
              [
                50.9730415,
                35.7043025
              ],
              [
                50.9745443,
                35.7040653
              ],
              [
                50.975248,
                35.7039554
              ],
              [
                50.9762069,
                35.7037615
              ],
              [
                50.9788688,
                35.7032691
              ],
              [
                50.9830709,
                35.7025309
              ],
              [
                50.9863934,
                35.7019323
              ],
              [
                50.987997,
                35.7016476
              ],
              [
                50.9898436,
                35.701309
              ],
              [
                50.9899005,
                35.7014788
              ],
              [
                50.9900359,
                35.7018829
              ],
              [
                50.9910821,
                35.7016929
              ],
              [
                50.9915648,
                35.701597
              ],
              [
                50.9921349,
                35.7014783
              ],
              [
                50.9932375,
                35.70122
              ],
              [
                50.9935205,
                35.7011163
              ],
              [
                50.9938969,
                35.7022083
              ],
              [
                50.9976089,
                35.7004433
              ],
              [
                51.0023672,
                35.7071764
              ],
              [
                51.0044854,
                35.7065077
              ],
              [
                51.0050844,
                35.7117561
              ],
              [
                51.0055029,
                35.7125872
              ],
              [
                51.0056015,
                35.7127928
              ],
              [
                51.0056264,
                35.7128329
              ],
              [
                51.0056812,
                35.7128579
              ],
              [
                51.0057399,
                35.7128644
              ],
              [
                51.00582,
                35.7128616
              ],
              [
                51.0059234,
                35.7128439
              ],
              [
                51.0060191,
                35.7128156
              ],
              [
                51.0060756,
                35.7128182
              ],
              [
                51.0061786,
                35.7128664
              ],
              [
                51.0062255,
                35.7129183
              ],
              [
                51.0062688,
                35.7129664
              ],
              [
                51.0063014,
                35.7130463
              ],
              [
                51.0067856,
                35.7138288
              ],
              [
                51.0071644,
                35.7144409
              ],
              [
                51.0066424,
                35.7150205
              ],
              [
                51.0085794,
                35.7195565
              ],
              [
                51.0095132,
                35.7205797
              ],
              [
                51.010918,
                35.7222987
              ],
              [
                51.0128492,
                35.7240356
              ],
              [
                51.0170337,
                35.7278236
              ],
              [
                51.0171804,
                35.7279563
              ],
              [
                51.0182893,
                35.7289665
              ],
              [
                51.0183954,
                35.7290645
              ],
              [
                51.0188357,
                35.7294448
              ],
              [
                51.0196918,
                35.7305882
              ],
              [
                51.0202111,
                35.7313073
              ],
              [
                51.0208281,
                35.7319956
              ],
              [
                51.0215354,
                35.7333765
              ],
              [
                51.0220463,
                35.7340461
              ],
              [
                51.0248221,
                35.7378989
              ],
              [
                51.0254871,
                35.7387642
              ],
              [
                51.0257243,
                35.7389339
              ],
              [
                51.0268377,
                35.7376632
              ],
              [
                51.0289344,
                35.7391777
              ],
              [
                51.0305823,
                35.7394912
              ],
              [
                51.0349597,
                35.7391359
              ],
              [
                51.0378951,
                35.7385925
              ],
              [
                51.0425815,
                35.73807
              ],
              [
                51.0475253,
                35.7382372
              ],
              [
                51.0495595,
                35.7385089
              ],
              [
                51.0511817,
                35.739324
              ],
              [
                51.0483493,
                35.7410796
              ],
              [
                51.0447444,
                35.7429397
              ],
              [
                51.0432252,
                35.7444862
              ],
              [
                51.0414485,
                35.7456565
              ],
              [
                51.0411395,
                35.7473075
              ],
              [
                51.040367,
                35.7476628
              ],
              [
                51.0393371,
                35.7493764
              ],
              [
                51.0385646,
                35.7498361
              ],
              [
                51.0369939,
                35.7499615
              ],
              [
                51.0357579,
                35.749857
              ],
              [
                51.0347001,
                35.7502634
              ],
              [
                51.0334804,
                35.7506538
              ],
              [
                51.0327971,
                35.751671
              ],
              [
                51.0321467,
                35.753521
              ],
              [
                51.0320423,
                35.7537637
              ],
              [
                51.0318562,
                35.753904
              ],
              [
                51.0316976,
                35.7541027
              ],
              [
                51.0316997,
                35.7543564
              ],
              [
                51.0315718,
                35.7545641
              ],
              [
                51.0306763,
                35.7545057
              ],
              [
                51.0302375,
                35.7558081
              ],
              [
                51.0310499,
                35.7562932
              ],
              [
                51.0307543,
                35.7567959
              ],
              [
                51.0302591,
                35.7578947
              ],
              [
                51.0301881,
                35.758129
              ],
              [
                51.0299113,
                35.7590433
              ],
              [
                51.0298056,
                35.7593922
              ],
              [
                51.0294992,
                35.760404
              ],
              [
                51.029499,
                35.7619279
              ],
              [
                51.0291735,
                35.7639004
              ],
              [
                51.0276649,
                35.7651208
              ],
              [
                51.0269045,
                35.7663279
              ],
              [
                51.025731,
                35.7669776
              ],
              [
                51.0246392,
                35.7677901
              ],
              [
                51.0236415,
                35.7679
              ],
              [
                51.0231203,
                35.7680068
              ],
              [
                51.0224799,
                35.7681957
              ],
              [
                51.0220578,
                35.76855
              ],
              [
                51.0217667,
                35.7690578
              ],
              [
                51.0214901,
                35.769483
              ],
              [
                51.0207915,
                35.7697782
              ],
              [
                51.0201365,
                35.7701089
              ],
              [
                51.0195543,
                35.7704868
              ],
              [
                51.0191323,
                35.77103
              ],
              [
                51.0184191,
                35.7713134
              ],
              [
                51.0182299,
                35.7715496
              ],
              [
                51.0181862,
                35.7718684
              ],
              [
                51.0179679,
                35.7719747
              ],
              [
                51.0175021,
                35.7719865
              ],
              [
                51.0171819,
                35.7721873
              ],
              [
                51.016949,
                35.7725179
              ],
              [
                51.016265,
                35.7734154
              ],
              [
                51.0160903,
                35.7739704
              ],
              [
                51.0157817,
                35.7746334
              ],
              [
                51.0129811,
                35.7732355
              ],
              [
                51.0104577,
                35.7722745
              ],
              [
                51.0083463,
                35.7716896
              ],
              [
                51.0064666,
                35.7717522
              ],
              [
                51.0044066,
                35.7720656
              ],
              [
                51.0012652,
                35.77334
              ],
              [
                50.9942748,
                35.7768675
              ],
              [
                50.9916608,
                35.7781866
              ],
              [
                50.9852492,
                35.7810903
              ],
              [
                50.9817216,
                35.7829912
              ],
              [
                50.9706265,
                35.7889106
              ],
              [
                50.9655954,
                35.7915925
              ],
              [
                50.9625487,
                35.7877302
              ],
              [
                50.9664048,
                35.7856069
              ],
              [
                50.9642705,
                35.7841974
              ],
              [
                50.9594841,
                35.7815446
              ],
              [
                50.9565556,
                35.7800279
              ],
              [
                50.9514944,
                35.7770438
              ],
              [
                50.9523261,
                35.776253
              ],
              [
                50.9479584,
                35.773909
              ],
              [
                50.9497868,
                35.7719248
              ],
              [
                50.9411447,
                35.7674834
              ],
              [
                50.9387443,
                35.7640248
              ],
              [
                50.937095,
                35.7631228
              ],
              [
                50.9361475,
                35.7624562
              ],
              [
                50.9339092,
                35.76109
              ],
              [
                50.9328597,
                35.7605922
              ],
              [
                50.9318255,
                35.759933
              ],
              [
                50.9315812,
                35.7598472
              ],
              [
                50.9295283,
                35.7586641
              ],
              [
                50.9267484,
                35.7571402
              ],
              [
                50.9237401,
                35.7574186
              ],
              [
                50.9218973,
                35.7557214
              ],
              [
                50.9211515,
                35.7549983
              ],
              [
                50.9195321,
                35.7534279
              ],
              [
                50.9188406,
                35.7526116
              ],
              [
                50.9216627,
                35.7492721
              ],
              [
                50.920716,
                35.7486072
              ],
              [
                50.920441,
                35.7475754
              ],
              [
                50.9155943,
                35.7456514
              ],
              [
                50.9149506,
                35.7453797
              ],
              [
                50.9141008,
                35.7446483
              ],
              [
                50.9116804,
                35.7445647
              ],
              [
                50.9109594,
                35.7439795
              ],
              [
                50.9100582,
                35.7437914
              ],
              [
                50.9092085,
                35.7439168
              ],
              [
                50.907818,
                35.7435824
              ],
              [
                50.9088995,
                35.7425584
              ],
              [
                50.9049341,
                35.7385038
              ],
              [
                50.907612,
                35.735097
              ],
              [
                50.9046917,
                35.7344639
              ],
              [
                50.9039807,
                35.7259526
              ],
              [
                50.9006952,
                35.7238452
              ],
              [
                50.8997947,
                35.7228923
              ],
              [
                50.8989692,
                35.7224677
              ],
              [
                50.8983277,
                35.7218767
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555165,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کرج",
          "name:en": "Karaj County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q36529",
          "wikipedia": "fa:کرج"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.7413717,
                35.7592219
              ],
              [
                50.7323944,
                35.7384956
              ],
              [
                50.7309744,
                35.7242335
              ],
              [
                50.7296695,
                35.7197154
              ],
              [
                50.7292235,
                35.7181711
              ],
              [
                50.7294552,
                35.7120037
              ],
              [
                50.7337296,
                35.7117528
              ],
              [
                50.7430765,
                35.7111256
              ],
              [
                50.7445185,
                35.7110837
              ],
              [
                50.7494129,
                35.7102981
              ],
              [
                50.7609338,
                35.6995273
              ],
              [
                50.7683124,
                35.7034198
              ],
              [
                50.7696551,
                35.7041298
              ],
              [
                50.7849981,
                35.7020961
              ],
              [
                50.7999945,
                35.6989663
              ],
              [
                50.8007775,
                35.6987567
              ],
              [
                50.801957,
                35.6983999
              ],
              [
                50.802819,
                35.6979606
              ],
              [
                50.803404,
                35.6976624
              ],
              [
                50.8068811,
                35.6958905
              ],
              [
                50.8104966,
                35.6941038
              ],
              [
                50.8110548,
                35.6938755
              ],
              [
                50.8118316,
                35.7048444
              ],
              [
                50.8139752,
                35.7042993
              ],
              [
                50.8153744,
                35.7037954
              ],
              [
                50.8163487,
                35.7043405
              ],
              [
                50.8220651,
                35.7046541
              ],
              [
                50.8266484,
                35.7049469
              ],
              [
                50.8286054,
                35.7048632
              ],
              [
                50.8297126,
                35.7052814
              ],
              [
                50.8320043,
                35.7064941
              ],
              [
                50.8370207,
                35.7080116
              ],
              [
                50.8442526,
                35.7088027
              ],
              [
                50.8507917,
                35.7101038
              ],
              [
                50.8538014,
                35.712108
              ],
              [
                50.8732782,
                35.719615
              ],
              [
                50.8769816,
                35.7123853
              ],
              [
                50.8950576,
                35.7189499
              ],
              [
                50.8983277,
                35.7218767
              ],
              [
                50.8989692,
                35.7224677
              ],
              [
                50.8997947,
                35.7228923
              ],
              [
                50.9006952,
                35.7238452
              ],
              [
                50.9039807,
                35.7259526
              ],
              [
                50.9046917,
                35.7344639
              ],
              [
                50.907612,
                35.735097
              ],
              [
                50.9049341,
                35.7385038
              ],
              [
                50.9088995,
                35.7425584
              ],
              [
                50.907818,
                35.7435824
              ],
              [
                50.9092085,
                35.7439168
              ],
              [
                50.9100582,
                35.7437914
              ],
              [
                50.9109594,
                35.7439795
              ],
              [
                50.9116804,
                35.7445647
              ],
              [
                50.9141008,
                35.7446483
              ],
              [
                50.9149506,
                35.7453797
              ],
              [
                50.9155943,
                35.7456514
              ],
              [
                50.920441,
                35.7475754
              ],
              [
                50.920716,
                35.7486072
              ],
              [
                50.9216627,
                35.7492721
              ],
              [
                50.9188406,
                35.7526116
              ],
              [
                50.9195321,
                35.7534279
              ],
              [
                50.9211515,
                35.7549983
              ],
              [
                50.9218973,
                35.7557214
              ],
              [
                50.9237401,
                35.7574186
              ],
              [
                50.9267484,
                35.7571402
              ],
              [
                50.9295283,
                35.7586641
              ],
              [
                50.9315812,
                35.7598472
              ],
              [
                50.9318255,
                35.759933
              ],
              [
                50.9328597,
                35.7605922
              ],
              [
                50.9339092,
                35.76109
              ],
              [
                50.9361475,
                35.7624562
              ],
              [
                50.937095,
                35.7631228
              ],
              [
                50.9387443,
                35.7640248
              ],
              [
                50.9411447,
                35.7674834
              ],
              [
                50.9497868,
                35.7719248
              ],
              [
                50.9479584,
                35.773909
              ],
              [
                50.9523261,
                35.776253
              ],
              [
                50.9514944,
                35.7770438
              ],
              [
                50.9565556,
                35.7800279
              ],
              [
                50.9594841,
                35.7815446
              ],
              [
                50.9642705,
                35.7841974
              ],
              [
                50.9664048,
                35.7856069
              ],
              [
                50.9625487,
                35.7877302
              ],
              [
                50.9655954,
                35.7915925
              ],
              [
                50.9706265,
                35.7889106
              ],
              [
                50.9817216,
                35.7829912
              ],
              [
                50.9852492,
                35.7810903
              ],
              [
                50.9916608,
                35.7781866
              ],
              [
                50.9942748,
                35.7768675
              ],
              [
                51.0012652,
                35.77334
              ],
              [
                51.0044066,
                35.7720656
              ],
              [
                51.0064666,
                35.7717522
              ],
              [
                51.0083463,
                35.7716896
              ],
              [
                51.0104577,
                35.7722745
              ],
              [
                51.0129811,
                35.7732355
              ],
              [
                51.0157817,
                35.7746334
              ],
              [
                51.0160903,
                35.7739704
              ],
              [
                51.016265,
                35.7734154
              ],
              [
                51.016949,
                35.7725179
              ],
              [
                51.0171819,
                35.7721873
              ],
              [
                51.0175021,
                35.7719865
              ],
              [
                51.0179679,
                35.7719747
              ],
              [
                51.0181862,
                35.7718684
              ],
              [
                51.0182299,
                35.7715496
              ],
              [
                51.0184191,
                35.7713134
              ],
              [
                51.0191323,
                35.77103
              ],
              [
                51.0195543,
                35.7704868
              ],
              [
                51.0201365,
                35.7701089
              ],
              [
                51.0207915,
                35.7697782
              ],
              [
                51.0214901,
                35.769483
              ],
              [
                51.0217667,
                35.7690578
              ],
              [
                51.0220578,
                35.76855
              ],
              [
                51.0224799,
                35.7681957
              ],
              [
                51.0231203,
                35.7680068
              ],
              [
                51.0236415,
                35.7679
              ],
              [
                51.0246392,
                35.7677901
              ],
              [
                51.025731,
                35.7669776
              ],
              [
                51.0269045,
                35.7663279
              ],
              [
                51.0276649,
                35.7651208
              ],
              [
                51.0291735,
                35.7639004
              ],
              [
                51.029499,
                35.7619279
              ],
              [
                51.0294992,
                35.760404
              ],
              [
                51.0298056,
                35.7593922
              ],
              [
                51.0299113,
                35.7590433
              ],
              [
                51.0301881,
                35.758129
              ],
              [
                51.0302591,
                35.7578947
              ],
              [
                51.0307543,
                35.7567959
              ],
              [
                51.0310499,
                35.7562932
              ],
              [
                51.0302375,
                35.7558081
              ],
              [
                51.0306763,
                35.7545057
              ],
              [
                51.0315718,
                35.7545641
              ],
              [
                51.0316997,
                35.7543564
              ],
              [
                51.0316976,
                35.7541027
              ],
              [
                51.0318562,
                35.753904
              ],
              [
                51.0320423,
                35.7537637
              ],
              [
                51.0321467,
                35.753521
              ],
              [
                51.0327971,
                35.751671
              ],
              [
                51.0334804,
                35.7506538
              ],
              [
                51.0347001,
                35.7502634
              ],
              [
                51.0357579,
                35.749857
              ],
              [
                51.0369939,
                35.7499615
              ],
              [
                51.0385646,
                35.7498361
              ],
              [
                51.0393371,
                35.7493764
              ],
              [
                51.040367,
                35.7476628
              ],
              [
                51.0411395,
                35.7473075
              ],
              [
                51.0414485,
                35.7456565
              ],
              [
                51.0432252,
                35.7444862
              ],
              [
                51.0447444,
                35.7429397
              ],
              [
                51.0483493,
                35.7410796
              ],
              [
                51.0511817,
                35.739324
              ],
              [
                51.0516776,
                35.7389746
              ],
              [
                51.0529472,
                35.7379626
              ],
              [
                51.0539369,
                35.7363232
              ],
              [
                51.0540791,
                35.736051
              ],
              [
                51.0543849,
                35.7356809
              ],
              [
                51.056651,
                35.7351495
              ],
              [
                51.0587088,
                35.735499
              ],
              [
                51.0613638,
                35.7348334
              ],
              [
                51.0631733,
                35.7342617
              ],
              [
                51.0642388,
                35.7344717
              ],
              [
                51.0663245,
                35.7343463
              ],
              [
                51.0681269,
                35.7341791
              ],
              [
                51.0701611,
                35.7343254
              ],
              [
                51.072942,
                35.7339492
              ],
              [
                51.0756199,
                35.733991
              ],
              [
                51.0776284,
                35.7341791
              ],
              [
                51.0804608,
                35.7336147
              ],
              [
                51.0829842,
                35.7336849
              ],
              [
                51.0855591,
                35.7336983
              ],
              [
                51.088855,
                35.7344508
              ],
              [
                51.090606,
                35.7349942
              ],
              [
                51.0903742,
                35.7360393
              ],
              [
                51.090503,
                35.7373142
              ],
              [
                51.0913784,
                35.7403866
              ],
              [
                51.0925702,
                35.7401965
              ],
              [
                51.0933876,
                35.7421762
              ],
              [
                51.0890493,
                35.7429636
              ],
              [
                51.0901497,
                35.7456386
              ],
              [
                51.0920291,
                35.7487229
              ],
              [
                51.0920783,
                35.7488362
              ],
              [
                51.0921226,
                35.7489801
              ],
              [
                51.0934702,
                35.7559179
              ],
              [
                51.093584,
                35.7562732
              ],
              [
                51.0936705,
                35.7565435
              ],
              [
                51.0940866,
                35.7574188
              ],
              [
                51.0940979,
                35.7574547
              ],
              [
                51.0941068,
                35.7574954
              ],
              [
                51.0941102,
                35.7575368
              ],
              [
                51.0941073,
                35.7575551
              ],
              [
                51.0941116,
                35.7575654
              ],
              [
                51.0941235,
                35.7575703
              ],
              [
                51.0941734,
                35.7575792
              ],
              [
                51.0941883,
                35.7575946
              ],
              [
                51.0941966,
                35.7576132
              ],
              [
                51.094197,
                35.7576935
              ],
              [
                51.0941943,
                35.7577126
              ],
              [
                51.0941876,
                35.7577586
              ],
              [
                51.0941942,
                35.7577691
              ],
              [
                51.095373,
                35.7605029
              ],
              [
                51.0956954,
                35.7621845
              ],
              [
                51.0988756,
                35.7647237
              ],
              [
                51.1015078,
                35.7659094
              ],
              [
                51.1057053,
                35.7671917
              ],
              [
                51.1098306,
                35.7684567
              ],
              [
                51.1124564,
                35.7724766
              ],
              [
                51.1149537,
                35.7781703
              ],
              [
                51.1185605,
                35.7838232
              ],
              [
                51.1187901,
                35.7915401
              ],
              [
                51.1167779,
                35.8005118
              ],
              [
                51.1147097,
                35.81241
              ],
              [
                51.1127952,
                35.8172794
              ],
              [
                51.1107225,
                35.8217835
              ],
              [
                51.1099432,
                35.8281132
              ],
              [
                51.1079443,
                35.8425779
              ],
              [
                51.1121943,
                35.8439591
              ],
              [
                51.1165998,
                35.8459713
              ],
              [
                51.1189556,
                35.8470736
              ],
              [
                51.1224424,
                35.8472999
              ],
              [
                51.1247061,
                35.8494221
              ],
              [
                51.1274527,
                35.8642915
              ],
              [
                51.1429022,
                35.8794537
              ],
              [
                51.1802406,
                35.918515
              ],
              [
                51.1828911,
                35.9231683
              ],
              [
                51.1826037,
                35.9264506
              ],
              [
                51.1826618,
                35.9265048
              ],
              [
                51.182008,
                35.9296332
              ],
              [
                51.1820081,
                35.9296333
              ],
              [
                51.1820654,
                35.9296816
              ],
              [
                51.1786078,
                35.9357647
              ],
              [
                51.1647525,
                35.9633304
              ],
              [
                51.1535452,
                35.9821737
              ],
              [
                51.1520964,
                35.9983533
              ],
              [
                51.1542253,
                35.998958
              ],
              [
                51.1781926,
                35.9926449
              ],
              [
                51.2096296,
                35.9847279
              ],
              [
                51.2096837,
                35.9847159
              ],
              [
                51.2525322,
                35.9694481
              ],
              [
                51.2688181,
                35.9673484
              ],
              [
                51.2781918,
                35.9626491
              ],
              [
                51.3231104,
                35.9373673
              ],
              [
                51.3359596,
                35.9303989
              ],
              [
                51.3423232,
                35.9269476
              ],
              [
                51.3529149,
                35.9220974
              ],
              [
                51.3667596,
                35.9212172
              ],
              [
                51.3770218,
                35.9211929
              ],
              [
                51.387189,
                35.9263349
              ],
              [
                51.3925405,
                35.9315233
              ],
              [
                51.3954812,
                35.9363812
              ],
              [
                51.3988614,
                35.9427845
              ],
              [
                51.4026685,
                35.9504887
              ],
              [
                51.4026685,
                35.9505595
              ],
              [
                51.4050718,
                35.955836
              ],
              [
                51.407046,
                35.9587478
              ],
              [
                51.4075587,
                35.9597271
              ],
              [
                51.4122623,
                35.9677832
              ],
              [
                51.4281661,
                35.9902778
              ],
              [
                51.4324276,
                35.9953988
              ],
              [
                51.4334394,
                35.9971348
              ],
              [
                51.437264,
                35.9993626
              ],
              [
                51.4449159,
                36.0053379
              ],
              [
                51.4508193,
                36.0128169
              ],
              [
                51.4508104,
                36.0128413
              ],
              [
                51.4558891,
                36.0194846
              ],
              [
                51.459389,
                36.0233755
              ],
              [
                51.459391,
                36.0233815
              ],
              [
                51.464424,
                36.0243905
              ],
              [
                51.4682487,
                36.0286479
              ],
              [
                51.4682373,
                36.0286934
              ],
              [
                51.4859965,
                36.0486349
              ],
              [
                51.4918105,
                36.0535754
              ],
              [
                51.4917255,
                36.054211
              ],
              [
                51.4972339,
                36.0583245
              ],
              [
                51.4997068,
                36.0599459
              ],
              [
                51.5019194,
                36.0602148
              ],
              [
                51.5074585,
                36.0639025
              ],
              [
                51.5242488,
                36.0792001
              ],
              [
                51.525278,
                36.081708
              ],
              [
                51.5168666,
                36.0948865
              ],
              [
                51.5113735,
                36.107092
              ],
              [
                51.5087985,
                36.11153
              ],
              [
                51.5007304,
                36.1173543
              ],
              [
                51.4967822,
                36.1192957
              ],
              [
                51.4926623,
                36.1217223
              ],
              [
                51.4903449,
                36.1238715
              ],
              [
                51.4866542,
                36.1261594
              ],
              [
                51.4824485,
                36.1269913
              ],
              [
                51.4736938,
                36.1298336
              ],
              [
                51.4696597,
                36.1340623
              ],
              [
                51.4559429,
                36.1461336
              ],
              [
                51.4464438,
                36.1517204
              ],
              [
                51.4382541,
                36.1551856
              ],
              [
                51.4317368,
                36.1603158
              ],
              [
                51.4286109,
                36.1602465
              ],
              [
                51.4239594,
                36.1590013
              ],
              [
                51.4142812,
                36.1574073
              ],
              [
                51.407888,
                36.1565044
              ],
              [
                51.4004212,
                36.1560885
              ],
              [
                51.3850217,
                36.1585119
              ],
              [
                51.3811708,
                36.1600365
              ],
              [
                51.3720743,
                36.1611451
              ],
              [
                51.3693968,
                36.1610087
              ],
              [
                51.360781,
                36.1589991
              ],
              [
                51.3563012,
                36.1576846
              ],
              [
                51.3536246,
                36.158031
              ],
              [
                51.3507201,
                36.159828
              ],
              [
                51.346786,
                36.1603174
              ],
              [
                51.3444697,
                36.1598446
              ],
              [
                51.3388324,
                36.1540239
              ],
              [
                51.3376912,
                36.1535621
              ],
              [
                51.3346052,
                36.1539026
              ],
              [
                51.3312653,
                36.1535463
              ],
              [
                51.3275479,
                36.1543661
              ],
              [
                51.3197565,
                36.1580434
              ],
              [
                51.3125896,
                36.1622012
              ],
              [
                51.3068389,
                36.1650423
              ],
              [
                51.3001314,
                36.1666993
              ],
              [
                51.2973159,
                36.1665777
              ],
              [
                51.2928339,
                36.1676867
              ],
              [
                51.2886791,
                36.1678267
              ],
              [
                51.2821287,
                36.1667527
              ],
              [
                51.2730428,
                36.1672499
              ],
              [
                51.2644413,
                36.1685286
              ],
              [
                51.2494351,
                36.1733257
              ],
              [
                51.2476134,
                36.1785692
              ],
              [
                51.2464072,
                36.1856445
              ],
              [
                51.2453628,
                36.1938543
              ],
              [
                51.2428373,
                36.1973065
              ],
              [
                51.2408941,
                36.1986662
              ],
              [
                51.223583,
                36.1808396
              ],
              [
                51.1923416,
                36.1574914
              ],
              [
                51.1785094,
                36.1496314
              ],
              [
                51.1681265,
                36.1462636
              ],
              [
                51.1623656,
                36.1448815
              ],
              [
                51.1555489,
                36.1443942
              ],
              [
                51.1493507,
                36.1436319
              ],
              [
                51.1405793,
                36.1444656
              ],
              [
                51.1325489,
                36.1441191
              ],
              [
                51.1292515,
                36.1438397
              ],
              [
                51.1241692,
                36.1428693
              ],
              [
                51.1134653,
                36.1405799
              ],
              [
                51.1045421,
                36.1371211
              ],
              [
                51.0969172,
                36.1339977
              ],
              [
                51.0872934,
                36.1294918
              ],
              [
                51.0837593,
                36.1271462
              ],
              [
                51.0836363,
                36.1240101
              ],
              [
                51.0853529,
                36.1199543
              ],
              [
                51.0873652,
                36.1093894
              ],
              [
                51.0902167,
                36.0866719
              ],
              [
                51.0897535,
                36.0846486
              ],
              [
                51.091043,
                36.0759588
              ],
              [
                51.0923356,
                36.0688011
              ],
              [
                51.0915107,
                36.0583144
              ],
              [
                51.0854167,
                36.0472066
              ],
              [
                51.0856933,
                36.042205
              ],
              [
                51.0851366,
                36.034707
              ],
              [
                51.0806934,
                36.0238745
              ],
              [
                51.0800442,
                36.0204766
              ],
              [
                51.0703625,
                36.0194353
              ],
              [
                51.0602688,
                36.0177484
              ],
              [
                51.0548357,
                36.0170611
              ],
              [
                51.0462354,
                36.0143743
              ],
              [
                51.0416778,
                36.0134787
              ],
              [
                51.0382017,
                36.012229
              ],
              [
                51.0308374,
                36.0090006
              ],
              [
                51.0268978,
                36.0072717
              ],
              [
                51.0244774,
                36.0038973
              ],
              [
                51.023707,
                35.9998691
              ],
              [
                51.022574,
                35.994411
              ],
              [
                51.0198704,
                35.9844314
              ],
              [
                51.0190722,
                35.9820769
              ],
              [
                51.0182224,
                35.9777845
              ],
              [
                51.0165317,
                35.9747193
              ],
              [
                51.0101974,
                35.9712601
              ],
              [
                51.0080345,
                35.9704265
              ],
              [
                51.0033996,
                35.969322
              ],
              [
                51.0012109,
                35.9684884
              ],
              [
                51.0005414,
                35.9678841
              ],
              [
                50.9984043,
                35.9670713
              ],
              [
                50.9962156,
                35.9668004
              ],
              [
                50.9942586,
                35.9664669
              ],
              [
                50.9850919,
                35.9631741
              ],
              [
                50.9808176,
                35.9607356
              ],
              [
                50.9774221,
                35.9566715
              ],
              [
                50.9750275,
                35.9541077
              ],
              [
                50.9729933,
                35.9509186
              ],
              [
                50.9708819,
                35.9482505
              ],
              [
                50.9660291,
                35.9442605
              ],
              [
                50.9551233,
                35.935096
              ],
              [
                50.9535784,
                35.9330528
              ],
              [
                50.9503597,
                35.9314266
              ],
              [
                50.942635,
                35.9272982
              ],
              [
                50.9369186,
                35.923128
              ],
              [
                50.9335197,
                35.9217726
              ],
              [
                50.9281402,
                35.9198839
              ],
              [
                50.9166904,
                35.9208134
              ],
              [
                50.905438,
                35.9269855
              ],
              [
                50.9027086,
                35.9296544
              ],
              [
                50.8931814,
                35.9288829
              ],
              [
                50.8868533,
                35.9252571
              ],
              [
                50.8847614,
                35.9224607
              ],
              [
                50.8833796,
                35.9118793
              ],
              [
                50.8781268,
                35.9059354
              ],
              [
                50.8774058,
                35.9063317
              ],
              [
                50.8738009,
                35.889937
              ],
              [
                50.8735176,
                35.8891443
              ],
              [
                50.8671318,
                35.8941507
              ],
              [
                50.8665062,
                35.8916671
              ],
              [
                50.8606011,
                35.8702806
              ],
              [
                50.8599248,
                35.8705712
              ],
              [
                50.8532879,
                35.8596524
              ],
              [
                50.8548468,
                35.8588854
              ],
              [
                50.8532424,
                35.85638
              ],
              [
                50.8805216,
                35.8406177
              ],
              [
                50.8858038,
                35.8377513
              ],
              [
                50.8789833,
                35.8328806
              ],
              [
                50.8746888,
                35.8301648
              ],
              [
                50.8738905,
                35.8291627
              ],
              [
                50.8731695,
                35.8270959
              ],
              [
                50.8718746,
                35.8231312
              ],
              [
                50.8714444,
                35.8218138
              ],
              [
                50.8705946,
                35.8201018
              ],
              [
                50.8698046,
                35.819561
              ],
              [
                50.8686119,
                35.8187446
              ],
              [
                50.8595997,
                35.8142346
              ],
              [
                50.858235,
                35.8133158
              ],
              [
                50.8573853,
                35.8122091
              ],
              [
                50.8569962,
                35.8113891
              ],
              [
                50.8520728,
                35.8010113
              ],
              [
                50.8519265,
                35.8007028
              ],
              [
                50.8514372,
                35.7934766
              ],
              [
                50.8508618,
                35.7905364
              ],
              [
                50.8500434,
                35.7872853
              ],
              [
                50.8465996,
                35.7736037
              ],
              [
                50.846407,
                35.7729347
              ],
              [
                50.8448398,
                35.7673619
              ],
              [
                50.8474711,
                35.765635
              ],
              [
                50.8466198,
                35.7631232
              ],
              [
                50.8443175,
                35.7637355
              ],
              [
                50.843737,
                35.7610351
              ],
              [
                50.8379521,
                35.7621812
              ],
              [
                50.8368687,
                35.7610822
              ],
              [
                50.8338247,
                35.7607979
              ],
              [
                50.8305288,
                35.7619471
              ],
              [
                50.8111397,
                35.7616128
              ],
              [
                50.7994495,
                35.7640783
              ],
              [
                50.7853132,
                35.771349
              ],
              [
                50.7792879,
                35.7655826
              ],
              [
                50.7734686,
                35.7626784
              ],
              [
                50.7619711,
                35.7574876
              ],
              [
                50.7530876,
                35.7557742
              ],
              [
                50.7413717,
                35.7592219
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555235,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نظرآباد",
          "name:en": "Nazarabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1274523",
          "wikipedia": "en:Nazarabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.3313526,
                35.8573375
              ],
              [
                50.3353826,
                35.8541422
              ],
              [
                50.3706586,
                35.8349788
              ],
              [
                50.3714919,
                35.834429
              ],
              [
                50.4122475,
                35.8044303
              ],
              [
                50.4501304,
                35.7770596
              ],
              [
                50.4603877,
                35.7727538
              ],
              [
                50.4870543,
                35.7627568
              ],
              [
                50.487611,
                35.7624773
              ],
              [
                50.4892774,
                35.7624773
              ],
              [
                50.4895539,
                35.7621978
              ],
              [
                50.4937209,
                35.7621979
              ],
              [
                50.494554,
                35.7624774
              ],
              [
                50.4965006,
                35.7624773
              ],
              [
                50.5023339,
                35.7635861
              ],
              [
                50.504834,
                35.764145
              ],
              [
                50.5334471,
                35.7713658
              ],
              [
                50.5345568,
                35.7713657
              ],
              [
                50.5437234,
                35.7738627
              ],
              [
                50.5445566,
                35.7744216
              ],
              [
                50.5513768,
                35.7760819
              ],
              [
                50.5651133,
                35.7794247
              ],
              [
                50.5714539,
                35.7794247
              ],
              [
                50.5776128,
                35.7794247
              ],
              [
                50.5812261,
                35.7791452
              ],
              [
                50.5826164,
                35.7788659
              ],
              [
                50.5837262,
                35.7788659
              ],
              [
                50.5842828,
                35.7791453
              ],
              [
                50.5865028,
                35.7791453
              ],
              [
                50.586783,
                35.7794247
              ],
              [
                50.5878927,
                35.7794248
              ],
              [
                50.5909495,
                35.7802541
              ],
              [
                50.591783,
                35.7802541
              ],
              [
                50.5973363,
                35.7824806
              ],
              [
                50.611506,
                35.7863659
              ],
              [
                50.6134491,
                35.7872042
              ],
              [
                50.6142827,
                35.7872042
              ],
              [
                50.6153926,
                35.787754
              ],
              [
                50.6173391,
                35.787754
              ],
              [
                50.6178961,
                35.7880335
              ],
              [
                50.6190059,
                35.7880335
              ],
              [
                50.6190059,
                35.7885924
              ],
              [
                50.6184492,
                35.7899806
              ],
              [
                50.6187293,
                35.7902601
              ],
              [
                50.6181726,
                35.7916393
              ],
              [
                50.6198391,
                35.7983098
              ],
              [
                50.6231962,
                35.8047826
              ],
              [
                50.6289701,
                35.8099641
              ],
              [
                50.6312288,
                35.8133623
              ],
              [
                50.6325814,
                35.8156508
              ],
              [
                50.6342551,
                35.8168618
              ],
              [
                50.6358773,
                35.8178431
              ],
              [
                50.6388384,
                35.818741
              ],
              [
                50.6401774,
                35.8200772
              ],
              [
                50.6410013,
                35.8226035
              ],
              [
                50.6405894,
                35.8254638
              ],
              [
                50.6394821,
                35.8294931
              ],
              [
                50.6397459,
                35.8319887
              ],
              [
                50.6380422,
                35.837685
              ],
              [
                50.6376212,
                35.8386499
              ],
              [
                50.6367734,
                35.8443178
              ],
              [
                50.6375717,
                35.8468642
              ],
              [
                50.6389364,
                35.8535639
              ],
              [
                50.6390909,
                35.8572995
              ],
              [
                50.6385244,
                35.8621202
              ],
              [
                50.6393226,
                35.8655007
              ],
              [
                50.6400693,
                35.8699244
              ],
              [
                50.6405998,
                35.8745383
              ],
              [
                50.6403681,
                35.8768334
              ],
              [
                50.6403681,
                35.8777097
              ],
              [
                50.6404793,
                35.8792473
              ],
              [
                50.6425611,
                35.8790997
              ],
              [
                50.6457514,
                35.8788639
              ],
              [
                50.6470178,
                35.8781422
              ],
              [
                50.6491663,
                35.8777876
              ],
              [
                50.650614,
                35.8773719
              ],
              [
                50.6547958,
                35.8815631
              ],
              [
                50.6577421,
                35.8840743
              ],
              [
                50.6604445,
                35.8856699
              ],
              [
                50.6610768,
                35.8864638
              ],
              [
                50.6613037,
                35.887586
              ],
              [
                50.6603854,
                35.8915228
              ],
              [
                50.6605936,
                35.8957027
              ],
              [
                50.6634003,
                35.8957861
              ],
              [
                50.6650997,
                35.8965162
              ],
              [
                50.6679836,
                35.8969542
              ],
              [
                50.6700436,
                35.8977885
              ],
              [
                50.6712023,
                35.8980806
              ],
              [
                50.6741119,
                35.89904
              ],
              [
                50.6773306,
                35.9005418
              ],
              [
                50.6796995,
                35.9015847
              ],
              [
                50.680987,
                35.9028987
              ],
              [
                50.6817594,
                35.9037747
              ],
              [
                50.6824547,
                35.9053598
              ],
              [
                50.6846434,
                35.9065903
              ],
              [
                50.6863943,
                35.9083005
              ],
              [
                50.687038,
                35.9098021
              ],
              [
                50.6884285,
                35.9121587
              ],
              [
                50.688377,
                35.9136811
              ],
              [
                50.6861883,
                35.9159125
              ],
              [
                50.6840254,
                35.9172888
              ],
              [
                50.6822229,
                35.9184566
              ],
              [
                50.6809612,
                35.9191031
              ],
              [
                50.678618,
                35.9205628
              ],
              [
                50.6777941,
                35.921522
              ],
              [
                50.6777168,
                35.9230233
              ],
              [
                50.6772018,
                35.9244204
              ],
              [
                50.6782318,
                35.9259634
              ],
              [
                50.6778713,
                35.9274646
              ],
              [
                50.6756826,
                35.9317389
              ],
              [
                50.6776911,
                35.9341366
              ],
              [
                50.6818624,
                35.939703
              ],
              [
                50.6821457,
                35.941621
              ],
              [
                50.6818367,
                35.9427467
              ],
              [
                50.6792875,
                35.9443102
              ],
              [
                50.6728352,
                35.947524
              ],
              [
                50.6644302,
                35.9517103
              ],
              [
                50.663223,
                35.9523473
              ],
              [
                50.6364994,
                35.9664477
              ],
              [
                50.6383497,
                35.9676377
              ],
              [
                50.6410771,
                35.9698588
              ],
              [
                50.6454029,
                35.9721094
              ],
              [
                50.6487733,
                35.9759771
              ],
              [
                50.6494088,
                35.9771832
              ],
              [
                50.6521898,
                35.980663
              ],
              [
                50.6522495,
                35.9817698
              ],
              [
                50.6537944,
                35.9817906
              ],
              [
                50.6539747,
                35.9837492
              ],
              [
                50.6551076,
                35.9853744
              ],
              [
                50.6555196,
                35.9856452
              ],
              [
                50.6553909,
                35.9866662
              ],
              [
                50.6554681,
                35.9875829
              ],
              [
                50.6554939,
                35.9887288
              ],
              [
                50.6561891,
                35.9898747
              ],
              [
                50.645014,
                35.9934789
              ],
              [
                50.644808,
                35.9898955
              ],
              [
                50.6440854,
                35.9878177
              ],
              [
                50.6436734,
                35.9867343
              ],
              [
                50.6434417,
                35.9857551
              ],
              [
                50.6427465,
                35.9849633
              ],
              [
                50.6428752,
                35.9841299
              ],
              [
                50.6420255,
                35.9829422
              ],
              [
                50.6404033,
                35.9805461
              ],
              [
                50.6413303,
                35.9798585
              ],
              [
                50.6414848,
                35.979025
              ],
              [
                50.641047,
                35.9785666
              ],
              [
                50.6400171,
                35.9790041
              ],
              [
                50.6297536,
                35.9841803
              ],
              [
                50.6258419,
                35.9863689
              ],
              [
                50.6273074,
                35.9875556
              ],
              [
                50.6288266,
                35.9912641
              ],
              [
                50.6309381,
                35.9902849
              ],
              [
                50.63444,
                35.9967641
              ],
              [
                50.6296556,
                35.9983451
              ],
              [
                50.6206949,
                36.0010532
              ],
              [
                50.6174267,
                36.002291
              ],
              [
                50.6136085,
                36.0042605
              ],
              [
                50.6119863,
                36.005177
              ],
              [
                50.6101581,
                36.0063851
              ],
              [
                50.6071712,
                36.0086347
              ],
              [
                50.6022889,
                36.0133177
              ],
              [
                50.6006566,
                36.0148833
              ],
              [
                50.5961763,
                36.0191736
              ],
              [
                50.5925971,
                36.0227557
              ],
              [
                50.5895845,
                36.0250881
              ],
              [
                50.5838534,
                36.0286022
              ],
              [
                50.5808901,
                36.0303075
              ],
              [
                50.5770822,
                36.0325107
              ],
              [
                50.5604279,
                36.0420636
              ],
              [
                50.5570961,
                36.037591
              ],
              [
                50.5526672,
                36.0346759
              ],
              [
                50.5531307,
                36.029137
              ],
              [
                50.551251,
                36.0258468
              ],
              [
                50.5469766,
                36.0195366
              ],
              [
                50.5451999,
                36.0199115
              ],
              [
                50.534308,
                36.0215151
              ],
              [
                50.5282312,
                36.0222024
              ],
              [
                50.5235191,
                36.020807
              ],
              [
                50.5146614,
                36.0167667
              ],
              [
                50.5108763,
                36.0146423
              ],
              [
                50.5080953,
                36.0120596
              ],
              [
                50.50413,
                36.008477
              ],
              [
                50.5007053,
                36.0046443
              ],
              [
                50.4983879,
                36.0021863
              ],
              [
                50.4973064,
                36.0009156
              ],
              [
                50.4953495,
                35.9998116
              ],
              [
                50.4930321,
                35.9996449
              ],
              [
                50.4891182,
                36.0001032
              ],
              [
                50.4837881,
                36.0016447
              ],
              [
                50.4781233,
                36.0039153
              ],
              [
                50.4683901,
                36.0082687
              ],
              [
                50.4643217,
                36.0092894
              ],
              [
                50.4576445,
                36.00964
              ],
              [
                50.4539915,
                36.0099335
              ],
              [
                50.4510046,
                36.0100168
              ],
              [
                50.44655,
                36.0107458
              ],
              [
                50.4429193,
                36.0095586
              ],
              [
                50.4387737,
                36.0074756
              ],
              [
                50.4362503,
                36.007059
              ],
              [
                50.4337526,
                36.0052677
              ],
              [
                50.4324137,
                36.0045595
              ],
              [
                50.431358,
                36.0044553
              ],
              [
                50.4294268,
                36.0044553
              ],
              [
                50.4280878,
                36.0044553
              ],
              [
                50.4254614,
                36.0048094
              ],
              [
                50.4232985,
                36.0044761
              ],
              [
                50.4220882,
                36.0036846
              ],
              [
                50.4193073,
                36.0034763
              ],
              [
                50.4156767,
                36.0029763
              ],
              [
                50.4141129,
                36.0016466
              ],
              [
                50.4115895,
                35.9976261
              ],
              [
                50.4096583,
                35.9952512
              ],
              [
                50.4088858,
                35.9916262
              ],
              [
                50.4084996,
                35.9865218
              ],
              [
                50.4072636,
                35.981417
              ],
              [
                50.4067713,
                35.9777576
              ],
              [
                50.4059381,
                35.9749817
              ],
              [
                50.4045337,
                35.9708545
              ],
              [
                50.4014946,
                35.9619224
              ],
              [
                50.3989946,
                35.9522066
              ],
              [
                50.3342688,
                35.8613712
              ],
              [
                50.3339922,
                35.8610917
              ],
              [
                50.3320457,
                35.8583155
              ],
              [
                50.3317692,
                35.8577567
              ],
              [
                50.3313526,
                35.8573375
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6556321,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چهارباغ",
          "name:en": "Chaharbagh County",
          "place": "district",
          "source": "https://rc.majlis.ir/fa/law/show/1632957",
          "type": "boundary",
          "wikidata": "Q107333581"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.6190059,
                35.7880335
              ],
              [
                50.6201156,
                35.7883129
              ],
              [
                50.6203957,
                35.7885924
              ],
              [
                50.6223392,
                35.7885924
              ],
              [
                50.6245627,
                35.7891423
              ],
              [
                50.626229,
                35.7899807
              ],
              [
                50.6270623,
                35.7899806
              ],
              [
                50.6295623,
                35.7910893
              ],
              [
                50.6331722,
                35.7916392
              ],
              [
                50.6337292,
                35.7919277
              ],
              [
                50.6365055,
                35.7919278
              ],
              [
                50.6381723,
                35.7921981
              ],
              [
                50.6387289,
                35.7924776
              ],
              [
                50.6403958,
                35.7924776
              ],
              [
                50.6406723,
                35.792757
              ],
              [
                50.6417856,
                35.792757
              ],
              [
                50.6423388,
                35.7930365
              ],
              [
                50.643452,
                35.7930365
              ],
              [
                50.6442857,
                35.7927571
              ],
              [
                50.6456721,
                35.792757
              ],
              [
                50.6467853,
                35.7924776
              ],
              [
                50.649839,
                35.7919277
              ],
              [
                50.6534523,
                35.7919278
              ],
              [
                50.6573423,
                35.7913689
              ],
              [
                50.6826186,
                35.7855366
              ],
              [
                50.6953345,
                35.7811772
              ],
              [
                50.7085418,
                35.772102
              ],
              [
                50.7233991,
                35.7653746
              ],
              [
                50.7413717,
                35.7592219
              ],
              [
                50.7530876,
                35.7557742
              ],
              [
                50.7619711,
                35.7574876
              ],
              [
                50.7734686,
                35.7626784
              ],
              [
                50.7792879,
                35.7655826
              ],
              [
                50.7853132,
                35.771349
              ],
              [
                50.7994495,
                35.7640783
              ],
              [
                50.8111397,
                35.7616128
              ],
              [
                50.8305288,
                35.7619471
              ],
              [
                50.8338247,
                35.7607979
              ],
              [
                50.8368687,
                35.7610822
              ],
              [
                50.8379521,
                35.7621812
              ],
              [
                50.843737,
                35.7610351
              ],
              [
                50.8443175,
                35.7637355
              ],
              [
                50.8466198,
                35.7631232
              ],
              [
                50.8474711,
                35.765635
              ],
              [
                50.8448398,
                35.7673619
              ],
              [
                50.846407,
                35.7729347
              ],
              [
                50.8465996,
                35.7736037
              ],
              [
                50.8500434,
                35.7872853
              ],
              [
                50.8508618,
                35.7905364
              ],
              [
                50.8514372,
                35.7934766
              ],
              [
                50.8519265,
                35.8007028
              ],
              [
                50.8520728,
                35.8010113
              ],
              [
                50.8569962,
                35.8113891
              ],
              [
                50.8573853,
                35.8122091
              ],
              [
                50.858235,
                35.8133158
              ],
              [
                50.8595997,
                35.8142346
              ],
              [
                50.8686119,
                35.8187446
              ],
              [
                50.8698046,
                35.819561
              ],
              [
                50.8705946,
                35.8201018
              ],
              [
                50.8714444,
                35.8218138
              ],
              [
                50.8718746,
                35.8231312
              ],
              [
                50.8731695,
                35.8270959
              ],
              [
                50.8738905,
                35.8291627
              ],
              [
                50.8746888,
                35.8301648
              ],
              [
                50.8789833,
                35.8328806
              ],
              [
                50.8858038,
                35.8377513
              ],
              [
                50.8805216,
                35.8406177
              ],
              [
                50.8532424,
                35.85638
              ],
              [
                50.8548468,
                35.8588854
              ],
              [
                50.8532879,
                35.8596524
              ],
              [
                50.8599248,
                35.8705712
              ],
              [
                50.8606011,
                35.8702806
              ],
              [
                50.8665062,
                35.8916671
              ],
              [
                50.8671318,
                35.8941507
              ],
              [
                50.8635204,
                35.8965104
              ],
              [
                50.858937,
                35.8996392
              ],
              [
                50.8562076,
                35.9013078
              ],
              [
                50.8523452,
                35.9029764
              ],
              [
                50.8383647,
                35.9083853
              ],
              [
                50.8335125,
                35.910228
              ],
              [
                50.8298884,
                35.9116956
              ],
              [
                50.8253582,
                35.9130165
              ],
              [
                50.8208281,
                35.9139296
              ],
              [
                50.8174658,
                35.9144025
              ],
              [
                50.8103585,
                35.9149406
              ],
              [
                50.8008225,
                35.9155279
              ],
              [
                50.7976739,
                35.9157875
              ],
              [
                50.7973309,
                35.9131008
              ],
              [
                50.7939746,
                35.9097074
              ],
              [
                50.7869494,
                35.8999952
              ],
              [
                50.7846641,
                35.8972645
              ],
              [
                50.7803876,
                35.8923694
              ],
              [
                50.773329,
                35.88642
              ],
              [
                50.7724418,
                35.8847848
              ],
              [
                50.7619555,
                35.8764118
              ],
              [
                50.757778,
                35.8709854
              ],
              [
                50.7471819,
                35.8751112
              ],
              [
                50.7407295,
                35.8651478
              ],
              [
                50.734009,
                35.8631654
              ],
              [
                50.7318976,
                35.8603691
              ],
              [
                50.7297861,
                35.8604943
              ],
              [
                50.7291166,
                35.8596596
              ],
              [
                50.7279322,
                35.8593465
              ],
              [
                50.726104,
                35.8570092
              ],
              [
                50.7249195,
                35.8554857
              ],
              [
                50.7225763,
                35.8529605
              ],
              [
                50.7206967,
                35.8528979
              ],
              [
                50.7185595,
                35.8527309
              ],
              [
                50.7163525,
                35.8507238
              ],
              [
                50.7053581,
                35.8522126
              ],
              [
                50.702161,
                35.8518468
              ],
              [
                50.7015965,
                35.8518447
              ],
              [
                50.7007677,
                35.8520425
              ],
              [
                50.6998423,
                35.8524491
              ],
              [
                50.6993246,
                35.8524295
              ],
              [
                50.6987855,
                35.8522534
              ],
              [
                50.6983618,
                35.851936
              ],
              [
                50.6972111,
                35.8514686
              ],
              [
                50.6967967,
                35.8513262
              ],
              [
                50.6964929,
                35.8511463
              ],
              [
                50.6961462,
                35.8508968
              ],
              [
                50.6960201,
                35.8506305
              ],
              [
                50.6957439,
                35.8503555
              ],
              [
                50.6943867,
                35.8495532
              ],
              [
                50.6940112,
                35.8487901
              ],
              [
                50.6934909,
                35.8481922
              ],
              [
                50.6931663,
                35.8479748
              ],
              [
                50.6923979,
                35.8478792
              ],
              [
                50.6914182,
                35.8473704
              ],
              [
                50.6903098,
                35.847053
              ],
              [
                50.6893871,
                35.8473574
              ],
              [
                50.6889687,
                35.847427
              ],
              [
                50.6885717,
                35.8476487
              ],
              [
                50.6885288,
                35.8482031
              ],
              [
                50.688468,
                35.8483604
              ],
              [
                50.6883892,
                35.8485177
              ],
              [
                50.6882863,
                35.8486058
              ],
              [
                50.6881863,
                35.848653
              ],
              [
                50.6880874,
                35.8486556
              ],
              [
                50.6879816,
                35.8486013
              ],
              [
                50.6876546,
                35.8483735
              ],
              [
                50.6872671,
                35.8481658
              ],
              [
                50.687132,
                35.8481664
              ],
              [
                50.6870355,
                35.8482239
              ],
              [
                50.6868989,
                35.848359
              ],
              [
                50.686735,
                35.8484887
              ],
              [
                50.6865216,
                35.8486173
              ],
              [
                50.6863464,
                35.8486581
              ],
              [
                50.6858769,
                35.848686
              ],
              [
                50.685536,
                35.8487506
              ],
              [
                50.6852914,
                35.8488122
              ],
              [
                50.6850096,
                35.8488955
              ],
              [
                50.6847992,
                35.8489554
              ],
              [
                50.6845497,
                35.8489494
              ],
              [
                50.6842962,
                35.8488271
              ],
              [
                50.6838429,
                35.8485662
              ],
              [
                50.6833146,
                35.8478183
              ],
              [
                50.6831019,
                35.8474843
              ],
              [
                50.6825522,
                35.8470677
              ],
              [
                50.6818229,
                35.8466168
              ],
              [
                50.6815388,
                35.8462566
              ],
              [
                50.6813512,
                35.8459051
              ],
              [
                50.6811527,
                35.8455529
              ],
              [
                50.6810211,
                35.8455339
              ],
              [
                50.680813,
                35.8455246
              ],
              [
                50.6801073,
                35.8456784
              ],
              [
                50.6794383,
                35.8458631
              ],
              [
                50.6790609,
                35.8460946
              ],
              [
                50.6786834,
                35.8462531
              ],
              [
                50.6782634,
                35.8464338
              ],
              [
                50.6780272,
                35.8464634
              ],
              [
                50.6778304,
                35.8464247
              ],
              [
                50.6774244,
                35.8464573
              ],
              [
                50.6764953,
                35.8467086
              ],
              [
                50.6757492,
                35.8467835
              ],
              [
                50.6746704,
                35.8467038
              ],
              [
                50.6740547,
                35.8465974
              ],
              [
                50.6725469,
                35.8468045
              ],
              [
                50.6716705,
                35.8468157
              ],
              [
                50.6709416,
                35.846995
              ],
              [
                50.6707189,
                35.8469834
              ],
              [
                50.6704852,
                35.846926
              ],
              [
                50.6701478,
                35.8464189
              ],
              [
                50.6699972,
                35.8460552
              ],
              [
                50.6691491,
                35.8456661
              ],
              [
                50.6680698,
                35.8449594
              ],
              [
                50.6675678,
                35.8446626
              ],
              [
                50.6672899,
                35.8445837
              ],
              [
                50.6669793,
                35.8445595
              ],
              [
                50.6668079,
                35.84458
              ],
              [
                50.6664783,
                35.8445331
              ],
              [
                50.6660881,
                35.8444578
              ],
              [
                50.6560729,
                35.8414328
              ],
              [
                50.6380422,
                35.837685
              ],
              [
                50.6397459,
                35.8319887
              ],
              [
                50.6394821,
                35.8294931
              ],
              [
                50.6405894,
                35.8254638
              ],
              [
                50.6410013,
                35.8226035
              ],
              [
                50.6401774,
                35.8200772
              ],
              [
                50.6388384,
                35.818741
              ],
              [
                50.6358773,
                35.8178431
              ],
              [
                50.6342551,
                35.8168618
              ],
              [
                50.6325814,
                35.8156508
              ],
              [
                50.6312288,
                35.8133623
              ],
              [
                50.6289701,
                35.8099641
              ],
              [
                50.6231962,
                35.8047826
              ],
              [
                50.6198391,
                35.7983098
              ],
              [
                50.6181726,
                35.7916393
              ],
              [
                50.6187293,
                35.7902601
              ],
              [
                50.6184492,
                35.7899806
              ],
              [
                50.6190059,
                35.7885924
              ],
              [
                50.6190059,
                35.7880335
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 29070193
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.6097443,
          35.9558897
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 8921249855
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.8508914,
          35.8368603
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2717318938
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.9891563,
          35.7316704
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 234526006
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.9904681,
          35.8224892
        ]
      }
    }
  ]
},
"ایلام.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 903703,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ایوان",
          "name:de": "Eyvan",
          "name:en": "Eyvan County",
          "name:ku": "Eywan",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291755",
          "wikipedia": "en:Eyvan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.9058668,
                33.8987048
              ],
              [
                45.9126162,
                33.8968866
              ],
              [
                45.9174656,
                33.8990594
              ],
              [
                45.9224224,
                33.8997006
              ],
              [
                45.925126,
                33.8985963
              ],
              [
                45.929718,
                33.8985963
              ],
              [
                45.932722,
                33.8964947
              ],
              [
                45.9468841,
                33.8890851
              ],
              [
                45.953426,
                33.8838985
              ],
              [
                45.9575205,
                33.8802073
              ],
              [
                45.9615284,
                33.8776178
              ],
              [
                45.9649561,
                33.8752661
              ],
              [
                45.9707185,
                33.8729836
              ],
              [
                45.9714885,
                33.8720217
              ],
              [
                45.9708717,
                33.8709412
              ],
              [
                45.9692236,
                33.8665182
              ],
              [
                45.9687856,
                33.8654918
              ],
              [
                45.9662504,
                33.8623696
              ],
              [
                45.9640502,
                33.8609648
              ],
              [
                45.9601583,
                33.8595429
              ],
              [
                45.9557296,
                33.8571071
              ],
              [
                45.9508668,
                33.852874
              ],
              [
                45.9611153,
                33.8502295
              ],
              [
                45.9747384,
                33.8481699
              ],
              [
                45.9892416,
                33.8443285
              ],
              [
                45.9984254,
                33.841976
              ],
              [
                46.0008023,
                33.8408607
              ],
              [
                46.0044016,
                33.8398271
              ],
              [
                46.0070935,
                33.8404883
              ],
              [
                46.0125174,
                33.8476171
              ],
              [
                46.015369,
                33.8515945
              ],
              [
                46.0194193,
                33.8550463
              ],
              [
                46.0225209,
                33.8553165
              ],
              [
                46.0254191,
                33.8534528
              ],
              [
                46.0303973,
                33.8482493
              ],
              [
                46.0338306,
                33.8443998
              ],
              [
                46.0397529,
                33.8414057
              ],
              [
                46.0504817,
                33.8395522
              ],
              [
                46.0583781,
                33.8391245
              ],
              [
                46.0658454,
                33.8374134
              ],
              [
                46.0696055,
                33.8363538
              ],
              [
                46.0753792,
                33.8357173
              ],
              [
                46.0809024,
                33.8341488
              ],
              [
                46.0913458,
                33.830461
              ],
              [
                46.1048156,
                33.8260404
              ],
              [
                46.1113387,
                33.8216248
              ],
              [
                46.1147711,
                33.8203056
              ],
              [
                46.1237618,
                33.8200029
              ],
              [
                46.1260128,
                33.8180909
              ],
              [
                46.1302364,
                33.8171506
              ],
              [
                46.1419902,
                33.8216265
              ],
              [
                46.1493353,
                33.8196998
              ],
              [
                46.1545653,
                33.8162164
              ],
              [
                46.1640816,
                33.8074364
              ],
              [
                46.1656988,
                33.8063538
              ],
              [
                46.1872958,
                33.7983361
              ],
              [
                46.1974238,
                33.7964103
              ],
              [
                46.2088393,
                33.7932718
              ],
              [
                46.2179267,
                33.7919698
              ],
              [
                46.225134,
                33.7899926
              ],
              [
                46.234871,
                33.78529
              ],
              [
                46.2365851,
                33.7843626
              ],
              [
                46.2403671,
                33.7826047
              ],
              [
                46.2428718,
                33.7814276
              ],
              [
                46.2471157,
                33.7793285
              ],
              [
                46.2501458,
                33.7768948
              ],
              [
                46.2570552,
                33.775081
              ],
              [
                46.2677192,
                33.7712281
              ],
              [
                46.2717533,
                33.7689271
              ],
              [
                46.2743031,
                33.7679786
              ],
              [
                46.2866878,
                33.762666
              ],
              [
                46.3213377,
                33.749279
              ],
              [
                46.3350965,
                33.7444144
              ],
              [
                46.3463504,
                33.7397355
              ],
              [
                46.3551807,
                33.7359036
              ],
              [
                46.3615321,
                33.7317637
              ],
              [
                46.3668536,
                33.7274807
              ],
              [
                46.3927062,
                33.7141538
              ],
              [
                46.4007267,
                33.7091561
              ],
              [
                46.4099629,
                33.7029616
              ],
              [
                46.4145922,
                33.699974
              ],
              [
                46.4194678,
                33.699065
              ],
              [
                46.4215931,
                33.6964273
              ],
              [
                46.4251151,
                33.6919583
              ],
              [
                46.4283718,
                33.6906453
              ],
              [
                46.4343601,
                33.6896869
              ],
              [
                46.4409864,
                33.6897042
              ],
              [
                46.4477671,
                33.6906292
              ],
              [
                46.4526844,
                33.6917097
              ],
              [
                46.45794,
                33.6920023
              ],
              [
                46.4558419,
                33.6953434
              ],
              [
                46.4527719,
                33.6996109
              ],
              [
                46.4504462,
                33.7015814
              ],
              [
                46.4464551,
                33.7052025
              ],
              [
                46.4461612,
                33.7079548
              ],
              [
                46.4470195,
                33.7139166
              ],
              [
                46.4465967,
                33.7185275
              ],
              [
                46.4450614,
                33.7218607
              ],
              [
                46.4431142,
                33.7244468
              ],
              [
                46.4397239,
                33.7254462
              ],
              [
                46.4358615,
                33.7265884
              ],
              [
                46.4316129,
                33.727909
              ],
              [
                46.430483,
                33.7296401
              ],
              [
                46.4289522,
                33.7292653
              ],
              [
                46.4248752,
                33.7314067
              ],
              [
                46.4210987,
                33.7336909
              ],
              [
                46.4201545,
                33.7345117
              ],
              [
                46.4200258,
                33.7392226
              ],
              [
                46.4190387,
                33.7466809
              ],
              [
                46.4188671,
                33.750499
              ],
              [
                46.4186954,
                33.7591338
              ],
              [
                46.4185237,
                33.76288
              ],
              [
                46.4184379,
                33.7714065
              ],
              [
                46.4180088,
                33.7760083
              ],
              [
                46.4179229,
                33.7803245
              ],
              [
                46.4177513,
                33.7846405
              ],
              [
                46.4177084,
                33.7862812
              ],
              [
                46.4179658,
                33.7885639
              ],
              [
                46.4135091,
                33.7921803
              ],
              [
                46.4041862,
                33.8052775
              ],
              [
                46.3857109,
                33.8223834
              ],
              [
                46.3736869,
                33.8395908
              ],
              [
                46.3709913,
                33.8437846
              ],
              [
                46.3604217,
                33.8558292
              ],
              [
                46.363599,
                33.8884432
              ],
              [
                46.3599647,
                33.8926911
              ],
              [
                46.3492127,
                33.8995182
              ],
              [
                46.3424235,
                33.9057568
              ],
              [
                46.3160338,
                33.9207591
              ],
              [
                46.3121439,
                33.9274207
              ],
              [
                46.3115868,
                33.9282602
              ],
              [
                46.3115869,
                33.92854
              ],
              [
                46.3032538,
                33.9471436
              ],
              [
                46.2980531,
                33.9534491
              ],
              [
                46.2930547,
                33.9571933
              ],
              [
                46.2913074,
                33.9589556
              ],
              [
                46.2910309,
                33.9574248
              ],
              [
                46.2913074,
                33.957145
              ],
              [
                46.2904738,
                33.9543648
              ],
              [
                46.2815877,
                33.9502036
              ],
              [
                46.2799213,
                33.9507633
              ],
              [
                46.2788072,
                33.9507632
              ],
              [
                46.2782541,
                33.9507633
              ],
              [
                46.2463081,
                33.9588147
              ],
              [
                46.2451947,
                33.9593654
              ],
              [
                46.2338047,
                33.9618656
              ],
              [
                46.232418,
                33.9618657
              ],
              [
                46.2304718,
                33.9624253
              ],
              [
                46.2290851,
                33.9624253
              ],
              [
                46.2251952,
                33.9638154
              ],
              [
                46.2151949,
                33.9654762
              ],
              [
                46.2146386,
                33.965756
              ],
              [
                46.213248,
                33.965756
              ],
              [
                46.2024149,
                33.9696464
              ],
              [
                46.2001954,
                33.970197
              ],
              [
                46.1954719,
                33.9721467
              ],
              [
                46.1949156,
                33.9724175
              ],
              [
                46.1796355,
                33.9801982
              ],
              [
                46.1682485,
                33.9879789
              ],
              [
                46.1651923,
                33.9888093
              ],
              [
                46.1646353,
                33.9890892
              ],
              [
                46.1574124,
                33.9890891
              ],
              [
                46.1565787,
                33.9888093
              ],
              [
                46.1538022,
                33.9888093
              ],
              [
                46.1493591,
                33.9899285
              ],
              [
                46.1485255,
                33.9899285
              ],
              [
                46.1415791,
                33.9951998
              ],
              [
                46.1401894,
                33.9957595
              ],
              [
                46.1401894,
                33.9960303
              ],
              [
                46.1273844,
                33.9999291
              ],
              [
                46.1110231,
                34.0149222
              ],
              [
                46.1007432,
                34.0202025
              ],
              [
                46.0993564,
                34.0202025
              ],
              [
                46.0965758,
                34.0210329
              ],
              [
                46.0946329,
                34.0210329
              ],
              [
                46.0935227,
                34.0215925
              ],
              [
                46.0865765,
                34.0243636
              ],
              [
                46.0846334,
                34.0263132
              ],
              [
                46.0840763,
                34.0274234
              ],
              [
                46.0821334,
                34.0296438
              ],
              [
                46.0812997,
                34.0299237
              ],
              [
                46.0804662,
                34.0307631
              ],
              [
                46.0776864,
                34.0321441
              ],
              [
                46.0746332,
                34.0343646
              ],
              [
                46.0707433,
                34.0363141
              ],
              [
                46.0693534,
                34.0363141
              ],
              [
                46.0690769,
                34.036594
              ],
              [
                46.0587969,
                34.0377041
              ],
              [
                46.0549102,
                34.0377041
              ],
              [
                46.0549102,
                34.0374244
              ],
              [
                46.0385201,
                34.0160322
              ],
              [
                46.0229643,
                33.9999202
              ],
              [
                46.0137978,
                33.9846477
              ],
              [
                46.0132408,
                33.9846477
              ],
              [
                45.9832378,
                33.9724168
              ],
              [
                45.9824043,
                33.9724168
              ],
              [
                45.9810183,
                33.9718663
              ],
              [
                45.979905,
                33.9718662
              ],
              [
                45.9793511,
                33.9715864
              ],
              [
                45.9699048,
                33.9696457
              ],
              [
                45.9682384,
                33.9696456
              ],
              [
                45.9676812,
                33.9693659
              ],
              [
                45.9643485,
                33.9688153
              ],
              [
                45.9615718,
                33.9688153
              ],
              [
                45.9607382,
                33.9685354
              ],
              [
                45.9543482,
                33.9685354
              ],
              [
                45.9529584,
                33.9682556
              ],
              [
                45.9474051,
                33.9682556
              ],
              [
                45.9462919,
                33.9679757
              ],
              [
                45.9446253,
                33.9679757
              ],
              [
                45.9435153,
                33.9676959
              ],
              [
                45.9379589,
                33.9674252
              ],
              [
                45.937405,
                33.9674251
              ],
              [
                45.9354588,
                33.9676959
              ],
              [
                45.9349018,
                33.967425
              ],
              [
                45.9337916,
                33.9676959
              ],
              [
                45.9326822,
                33.967425
              ],
              [
                45.9321252,
                33.9676959
              ],
              [
                45.9279587,
                33.9676958
              ],
              [
                45.9274017,
                33.9679757
              ],
              [
                45.9260156,
                33.9679757
              ],
              [
                45.9257352,
                33.9682555
              ],
              [
                45.9243484,
                33.9682555
              ],
              [
                45.9235156,
                33.9685353
              ],
              [
                45.9215687,
                33.9685353
              ],
              [
                45.9212921,
                33.9688151
              ],
              [
                45.9193491,
                33.9688151
              ],
              [
                45.9185154,
                33.9690949
              ],
              [
                45.9124021,
                33.9707558
              ],
              [
                45.8762896,
                33.9885377
              ],
              [
                45.8757325,
                33.9888084
              ],
              [
                45.8737895,
                33.9893681
              ],
              [
                45.8679558,
                33.989368
              ],
              [
                45.8679558,
                33.9890882
              ],
              [
                45.8673995,
                33.9890883
              ],
              [
                45.8576811,
                33.9790946
              ],
              [
                45.8573993,
                33.9788162
              ],
              [
                45.851843,
                33.9693655
              ],
              [
                45.8498993,
                33.9635345
              ],
              [
                45.8498993,
                33.9629748
              ],
              [
                45.8460094,
                33.955203
              ],
              [
                45.8446235,
                33.9490921
              ],
              [
                45.8537902,
                33.9265889
              ],
              [
                45.8576761,
                33.9226984
              ],
              [
                45.8587895,
                33.9221478
              ],
              [
                45.8593426,
                33.9215881
              ],
              [
                45.8885128,
                33.9063151
              ],
              [
                45.8893464,
                33.9054757
              ],
              [
                45.9058668,
                33.8987048
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 903762,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آبدانان",
          "name:en": "Abdanan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286856",
          "wikipedia": "en:Abdanan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.0374576,
                33.0979639
              ],
              [
                47.0377342,
                33.0943523
              ],
              [
                47.0377342,
                33.0904609
              ],
              [
                47.0399578,
                33.0854589
              ],
              [
                47.0407914,
                33.0851789
              ],
              [
                47.0494009,
                33.0807367
              ],
              [
                47.0527378,
                33.0735135
              ],
              [
                47.0530142,
                33.0729628
              ],
              [
                47.0513479,
                33.0637983
              ],
              [
                47.0463479,
                33.0443498
              ],
              [
                47.044958,
                33.0349055
              ],
              [
                47.0455142,
                33.0335149
              ],
              [
                47.0460682,
                33.0326843
              ],
              [
                47.0480142,
                33.0318446
              ],
              [
                47.0544043,
                33.0310139
              ],
              [
                47.0577379,
                33.031014
              ],
              [
                47.0585708,
                33.0307341
              ],
              [
                47.0613474,
                33.0307341
              ],
              [
                47.0624576,
                33.0304542
              ],
              [
                47.0696812,
                33.0287929
              ],
              [
                47.0746805,
                33.0262919
              ],
              [
                47.0805143,
                33.0204591
              ],
              [
                47.0805143,
                33.0199083
              ],
              [
                47.0810705,
                33.0193485
              ],
              [
                47.0827378,
                33.0160168
              ],
              [
                47.0891277,
                33.0118544
              ],
              [
                47.0994037,
                33.0090734
              ],
              [
                47.1371834,
                33.000171
              ],
              [
                47.1766296,
                32.9765689
              ],
              [
                47.1774632,
                32.9754584
              ],
              [
                47.182186,
                32.9707361
              ],
              [
                47.1832992,
                32.9701854
              ],
              [
                47.1846861,
                32.9687948
              ],
              [
                47.1860759,
                32.9674044
              ],
              [
                47.1913526,
                32.9624023
              ],
              [
                47.1927433,
                32.9618425
              ],
              [
                47.194966,
                32.9618424
              ],
              [
                47.2207992,
                32.9687949
              ],
              [
                47.2230227,
                32.9690658
              ],
              [
                47.2271892,
                32.9690659
              ],
              [
                47.228022,
                32.9693458
              ],
              [
                47.2307986,
                32.9693458
              ],
              [
                47.2321894,
                32.9696256
              ],
              [
                47.2366323,
                32.9696256
              ],
              [
                47.2369121,
                32.9693458
              ],
              [
                47.2427458,
                32.9668447
              ],
              [
                47.2441356,
                32.966294
              ],
              [
                47.2624688,
                32.952678
              ],
              [
                47.2630251,
                32.9515675
              ],
              [
                47.2635783,
                32.9512966
              ],
              [
                47.2846921,
                32.923234
              ],
              [
                47.2846921,
                32.9226742
              ],
              [
                47.2849686,
                32.9224033
              ],
              [
                47.2849686,
                32.9218525
              ],
              [
                47.2849686,
                32.9215726
              ],
              [
                47.2867749,
                32.9193469
              ],
              [
                47.2869148,
                32.9190715
              ],
              [
                47.2874687,
                32.9179609
              ],
              [
                47.2877483,
                32.9171303
              ],
              [
                47.2894148,
                32.9126789
              ],
              [
                47.2913586,
                32.906846
              ],
              [
                47.2916352,
                32.9049048
              ],
              [
                47.2919149,
                32.9021238
              ],
              [
                47.2921915,
                32.901564
              ],
              [
                47.2921915,
                32.8982322
              ],
              [
                47.2949682,
                32.8826748
              ],
              [
                47.2949682,
                32.871289
              ],
              [
                47.2946916,
                32.8682371
              ],
              [
                47.2944151,
                32.8676772
              ],
              [
                47.287469,
                32.8315601
              ],
              [
                47.2871924,
                32.8285082
              ],
              [
                47.2871925,
                32.8232351
              ],
              [
                47.2885824,
                32.8146212
              ],
              [
                47.2991389,
                32.798233
              ],
              [
                47.3049718,
                32.7937906
              ],
              [
                47.3069156,
                32.792671
              ],
              [
                47.3110821,
                32.7904588
              ],
              [
                47.3160822,
                32.7832264
              ],
              [
                47.3199722,
                32.7760119
              ],
              [
                47.3205284,
                32.775732
              ],
              [
                47.3205284,
                32.7751812
              ],
              [
                47.3235816,
                32.7718404
              ],
              [
                47.3288614,
                32.7698991
              ],
              [
                47.3308052,
                32.7698991
              ],
              [
                47.331638,
                32.7696192
              ],
              [
                47.334138,
                32.7696191
              ],
              [
                47.3352514,
                32.7693393
              ],
              [
                47.3449711,
                32.7693393
              ],
              [
                47.346918,
                32.7696193
              ],
              [
                47.3521946,
                32.7696192
              ],
              [
                47.3541416,
                32.7698991
              ],
              [
                47.3549744,
                32.7696192
              ],
              [
                47.3563612,
                32.7698991
              ],
              [
                47.3585847,
                32.7698991
              ],
              [
                47.3594183,
                32.7696192
              ],
              [
                47.3621948,
                32.7696192
              ],
              [
                47.3649746,
                32.7687886
              ],
              [
                47.3660848,
                32.7687886
              ],
              [
                47.3708076,
                32.7673981
              ],
              [
                47.3727513,
                32.7665673
              ],
              [
                47.3749748,
                32.7651769
              ],
              [
                47.3816414,
                32.7585132
              ],
              [
                47.3824742,
                32.7582333
              ],
              [
                47.3830574,
                32.7576453
              ],
              [
                47.3833078,
                32.7573935
              ],
              [
                47.3999738,
                32.7460076
              ],
              [
                47.4044208,
                32.7454569
              ],
              [
                47.4085872,
                32.7454568
              ],
              [
                47.4091443,
                32.7457368
              ],
              [
                47.4158109,
                32.7462876
              ],
              [
                47.4166437,
                32.7462876
              ],
              [
                47.4171976,
                32.7465675
              ],
              [
                47.4208109,
                32.7465675
              ],
              [
                47.4210875,
                32.7468473
              ],
              [
                47.4219203,
                32.7465675
              ],
              [
                47.4224774,
                32.7468474
              ],
              [
                47.4244204,
                32.7471183
              ],
              [
                47.4249774,
                32.7473982
              ],
              [
                47.425254,
                32.7476781
              ],
              [
                47.4260868,
                32.747958
              ],
              [
                47.4266439,
                32.7482289
              ],
              [
                47.4374769,
                32.7526804
              ],
              [
                47.45581,
                32.7610055
              ],
              [
                47.4666466,
                32.7610055
              ],
              [
                47.4685899,
                32.7612854
              ],
              [
                47.4735897,
                32.7612854
              ],
              [
                47.4746998,
                32.7615654
              ],
              [
                47.4841465,
                32.7615654
              ],
              [
                47.4908131,
                32.7593442
              ],
              [
                47.5027594,
                32.7526806
              ],
              [
                47.5038696,
                32.75157
              ],
              [
                47.5180359,
                32.7415655
              ],
              [
                47.5183124,
                32.7412855
              ],
              [
                47.5219258,
                32.7393442
              ],
              [
                47.5274826,
                32.7376738
              ],
              [
                47.5288693,
                32.7374029
              ],
              [
                47.5310925,
                32.7374029
              ],
              [
                47.5322026,
                32.7371231
              ],
              [
                47.5338691,
                32.7371231
              ],
              [
                47.5349823,
                32.737403
              ],
              [
                47.5352589,
                32.737123
              ],
              [
                47.5363691,
                32.7374029
              ],
              [
                47.5397023,
                32.7374029
              ],
              [
                47.5410922,
                32.737123
              ],
              [
                47.548872,
                32.7371231
              ],
              [
                47.549149,
                32.737403
              ],
              [
                47.559982,
                32.7398951
              ],
              [
                47.5613719,
                32.7398951
              ],
              [
                47.5613719,
                32.740175
              ],
              [
                47.5627622,
                32.740175
              ],
              [
                47.5633153,
                32.7404549
              ],
              [
                47.5649821,
                32.7404549
              ],
              [
                47.5655388,
                32.740455
              ],
              [
                47.566372,
                32.7407349
              ],
              [
                47.5672052,
                32.7407349
              ],
              [
                47.5672053,
                32.740455
              ],
              [
                47.5708151,
                32.7382338
              ],
              [
                47.5758152,
                32.7301796
              ],
              [
                47.5760953,
                32.7293489
              ],
              [
                47.5808184,
                32.711561
              ],
              [
                47.5810951,
                32.7104504
              ],
              [
                47.5810951,
                32.7068477
              ],
              [
                47.5827619,
                32.7040666
              ],
              [
                47.5833186,
                32.7040666
              ],
              [
                47.5858186,
                32.7032269
              ],
              [
                47.5924851,
                32.7026761
              ],
              [
                47.5997084,
                32.7026761
              ],
              [
                47.6002614,
                32.7023962
              ],
              [
                47.6013752,
                32.7023963
              ],
              [
                47.6022084,
                32.7021163
              ],
              [
                47.6044283,
                32.7012856
              ],
              [
                47.6133179,
                32.6965633
              ],
              [
                47.6172083,
                32.6926806
              ],
              [
                47.6177649,
                32.6915701
              ],
              [
                47.6183181,
                32.6912902
              ],
              [
                47.6191513,
                32.6901796
              ],
              [
                47.637208,
                32.6651681
              ],
              [
                47.6502646,
                32.6396149
              ],
              [
                47.6599879,
                32.6251769
              ],
              [
                47.6608211,
                32.6246171
              ],
              [
                47.6608211,
                32.6243372
              ],
              [
                47.6616544,
                32.6240664
              ],
              [
                47.6652642,
                32.621836
              ],
              [
                47.666931,
                32.6212853
              ],
              [
                47.6680444,
                32.6212853
              ],
              [
                47.6683208,
                32.6210054
              ],
              [
                47.6694311,
                32.6210053
              ],
              [
                47.6697112,
                32.6207255
              ],
              [
                47.6702642,
                32.6207254
              ],
              [
                47.6705444,
                32.6204455
              ],
              [
                47.6744343,
                32.6198947
              ],
              [
                47.6752674,
                32.6198948
              ],
              [
                47.6769343,
                32.6196149
              ],
              [
                47.6783207,
                32.6193349
              ],
              [
                47.6899873,
                32.6168428
              ],
              [
                47.7061005,
                32.6096193
              ],
              [
                47.723047,
                32.5976734
              ],
              [
                47.7530465,
                32.5679486
              ],
              [
                47.7549934,
                32.5660073
              ],
              [
                47.7566599,
                32.5646168
              ],
              [
                47.7761033,
                32.5471178
              ],
              [
                47.7790498,
                32.5451763
              ],
              [
                47.8136061,
                32.5223953
              ],
              [
                47.8144392,
                32.5223952
              ],
              [
                47.8149959,
                32.5218355
              ],
              [
                47.8155494,
                32.5218355
              ],
              [
                47.8202726,
                32.5204449
              ],
              [
                47.8230491,
                32.5204449
              ],
              [
                47.824439,
                32.520174
              ],
              [
                47.8272193,
                32.520174
              ],
              [
                47.8280524,
                32.5198941
              ],
              [
                47.8297193,
                32.5198942
              ],
              [
                47.8305525,
                32.5196143
              ],
              [
                47.8355526,
                32.5196143
              ],
              [
                47.8358292,
                32.5198941
              ],
              [
                47.8374957,
                32.5198942
              ],
              [
                47.8383292,
                32.5201741
              ],
              [
                47.8413859,
                32.520445
              ],
              [
                47.8413859,
                32.5207248
              ],
              [
                47.8422191,
                32.5207249
              ],
              [
                47.8424956,
                32.5210049
              ],
              [
                47.8433289,
                32.5210048
              ],
              [
                47.8444422,
                32.5215556
              ],
              [
                47.8452759,
                32.5215557
              ],
              [
                47.8455524,
                32.5218355
              ],
              [
                47.8463856,
                32.5218356
              ],
              [
                47.8469423,
                32.5221155
              ],
              [
                47.8508291,
                32.5221155
              ],
              [
                47.8511087,
                32.5218356
              ],
              [
                47.8519424,
                32.5218356
              ],
              [
                47.8558288,
                32.520445
              ],
              [
                47.8563855,
                32.5198942
              ],
              [
                47.8597187,
                32.5182238
              ],
              [
                47.8694419,
                32.5151718
              ],
              [
                47.878332,
                32.5148919
              ],
              [
                47.8786085,
                32.5151719
              ],
              [
                47.8794417,
                32.5151718
              ],
              [
                47.8811086,
                32.5151719
              ],
              [
                47.8908318,
                32.5179529
              ],
              [
                47.8922217,
                32.5187837
              ],
              [
                47.9130548,
                32.5251676
              ],
              [
                47.9141646,
                32.5251675
              ],
              [
                47.9147213,
                32.5254474
              ],
              [
                47.9155545,
                32.5254475
              ],
              [
                47.9161112,
                32.5257274
              ],
              [
                47.917778,
                32.5257274
              ],
              [
                47.9180545,
                32.5260073
              ],
              [
                47.9197213,
                32.5260072
              ],
              [
                47.9200015,
                32.5262872
              ],
              [
                47.9219445,
                32.5265581
              ],
              [
                47.9244445,
                32.5265581
              ],
              [
                47.9247211,
                32.526838
              ],
              [
                47.9252777,
                32.5265581
              ],
              [
                47.9258344,
                32.526838
              ],
              [
                47.9294446,
                32.526838
              ],
              [
                47.9297212,
                32.5265581
              ],
              [
                47.930414,
                32.5265582
              ],
              [
                47.9383342,
                32.5265582
              ],
              [
                47.9386112,
                32.526838
              ],
              [
                47.9397245,
                32.526838
              ],
              [
                47.9402777,
                32.527118
              ],
              [
                47.941391,
                32.5271179
              ],
              [
                47.9452777,
                32.5285085
              ],
              [
                47.9544439,
                32.5326711
              ],
              [
                47.9550247,
                32.5329165
              ],
              [
                47.9554099,
                32.5341114
              ],
              [
                47.9553095,
                32.5349405
              ],
              [
                47.9554319,
                32.5351251
              ],
              [
                47.9558342,
                32.5357321
              ],
              [
                47.9552775,
                32.5385041
              ],
              [
                47.9550816,
                32.5387652
              ],
              [
                47.9544439,
                32.5396147
              ],
              [
                47.954444,
                32.5398947
              ],
              [
                47.9525009,
                32.5398947
              ],
              [
                47.9513907,
                32.5398946
              ],
              [
                47.951098,
                32.5397963
              ],
              [
                47.9506988,
                32.5399091
              ],
              [
                47.9493903,
                32.5400013
              ],
              [
                47.9481925,
                32.5400917
              ],
              [
                47.9476471,
                32.5400018
              ],
              [
                47.9472122,
                32.5399101
              ],
              [
                47.9468841,
                32.5397263
              ],
              [
                47.9466096,
                32.5394515
              ],
              [
                47.9465485,
                32.5381157
              ],
              [
                47.9464341,
                32.5371054
              ],
              [
                47.9463805,
                32.5369218
              ],
              [
                47.9460449,
                32.5357706
              ],
              [
                47.9457131,
                32.5345297
              ],
              [
                47.9448357,
                32.5332462
              ],
              [
                47.944397,
                32.5325548
              ],
              [
                47.9438477,
                32.532138
              ],
              [
                47.9433022,
                32.5317731
              ],
              [
                47.9424821,
                32.5314985
              ],
              [
                47.9413413,
                32.5314978
              ],
              [
                47.9397397,
                32.5315727
              ],
              [
                47.9393768,
                32.5315897
              ],
              [
                47.9377441,
                32.5320052
              ],
              [
                47.9371889,
                32.5321876
              ],
              [
                47.936058,
                32.5325591
              ],
              [
                47.9344825,
                32.5332036
              ],
              [
                47.9337768,
                32.5339392
              ],
              [
                47.9328002,
                32.5349499
              ],
              [
                47.9324226,
                32.5358287
              ],
              [
                47.9323197,
                32.5365136
              ],
              [
                47.9323197,
                32.5371582
              ],
              [
                47.9325408,
                32.5375738
              ],
              [
                47.933033,
                32.5380321
              ],
              [
                47.9336891,
                32.5387694
              ],
              [
                47.9339254,
                32.539005
              ],
              [
                47.9342385,
                32.539317
              ],
              [
                47.9346772,
                32.5402382
              ],
              [
                47.9346806,
                32.5407961
              ],
              [
                47.9346848,
                32.5414803
              ],
              [
                47.934486,
                32.5420723
              ],
              [
                47.9343604,
                32.5424461
              ],
              [
                47.9336053,
                32.5438724
              ],
              [
                47.9328728,
                32.5448256
              ],
              [
                47.9327926,
                32.5449299
              ],
              [
                47.9321441,
                32.545757
              ],
              [
                47.9318161,
                32.5462178
              ],
              [
                47.9317131,
                32.5468644
              ],
              [
                47.9318238,
                32.5474126
              ],
              [
                47.9323159,
                32.547828
              ],
              [
                47.9335136,
                32.5480579
              ],
              [
                47.9346047,
                32.54824
              ],
              [
                47.9357528,
                32.5483785
              ],
              [
                47.9368973,
                32.5483771
              ],
              [
                47.9376029,
                32.5483785
              ],
              [
                47.9380951,
                32.5486069
              ],
              [
                47.9383163,
                32.549018
              ],
              [
                47.9385911,
                32.5495724
              ],
              [
                47.938816,
                32.5506755
              ],
              [
                47.9389305,
                32.5518729
              ],
              [
                47.9387169,
                32.5528842
              ],
              [
                47.9391021,
                32.5535742
              ],
              [
                47.9393234,
                32.5541679
              ],
              [
                47.9395981,
                32.5549499
              ],
              [
                47.9397659,
                32.5559164
              ],
              [
                47.9398804,
                32.5566517
              ],
              [
                47.9398842,
                32.5573888
              ],
              [
                47.9398842,
                32.557941
              ],
              [
                47.9399413,
                32.5584
              ],
              [
                47.9401092,
                32.5590442
              ],
              [
                47.940384,
                32.5593642
              ],
              [
                47.9407653,
                32.559689
              ],
              [
                47.9420737,
                32.5596893
              ],
              [
                47.9430007,
                32.5598719
              ],
              [
                47.9430292,
                32.5598838
              ],
              [
                47.9436569,
                32.5601471
              ],
              [
                47.9442063,
                32.5606044
              ],
              [
                47.9442595,
                32.5610205
              ],
              [
                47.944046,
                32.561572
              ],
              [
                47.9433936,
                32.5622638
              ],
              [
                47.942524,
                32.5626303
              ],
              [
                47.9413652,
                32.5628336
              ],
              [
                47.9409448,
                32.5629074
              ],
              [
                47.9409098,
                32.5629074
              ],
              [
                47.93898,
                32.5629091
              ],
              [
                47.9350548,
                32.562908
              ],
              [
                47.9333114,
                32.5628159
              ],
              [
                47.9315644,
                32.5623585
              ],
              [
                47.9300347,
                32.56153
              ],
              [
                47.928997,
                32.5610268
              ],
              [
                47.9280128,
                32.5605204
              ],
              [
                47.9267578,
                32.5600164
              ],
              [
                47.925663,
                32.5593721
              ],
              [
                47.9248962,
                32.5588236
              ],
              [
                47.9241868,
                32.5581774
              ],
              [
                47.923748,
                32.5575333
              ],
              [
                47.9234161,
                32.5568919
              ],
              [
                47.9229239,
                32.5562487
              ],
              [
                47.9222642,
                32.5554189
              ],
              [
                47.9218826,
                32.5548213
              ],
              [
                47.9210624,
                32.5543639
              ],
              [
                47.9202956,
                32.5539056
              ],
              [
                47.9192048,
                32.5537189
              ],
              [
                47.9182243,
                32.5538143
              ],
              [
                47.9175187,
                32.5540877
              ],
              [
                47.9169731,
                32.5544597
              ],
              [
                47.916388,
                32.5550781
              ],
              [
                47.9163208,
                32.5551492
              ],
              [
                47.9162178,
                32.5559738
              ],
              [
                47.9159618,
                32.5581211
              ],
              [
                47.9159547,
                32.5581806
              ],
              [
                47.915474,
                32.5602537
              ],
              [
                47.9147721,
                32.5619088
              ],
              [
                47.9142303,
                32.5628737
              ],
              [
                47.9135208,
                32.5632867
              ],
              [
                47.912922,
                32.5633802
              ],
              [
                47.9116707,
                32.5635635
              ],
              [
                47.9111241,
                32.5634937
              ],
              [
                47.9102515,
                32.5633821
              ],
              [
                47.9094354,
                32.5633801
              ],
              [
                47.9092063,
                32.5633867
              ],
              [
                47.9077987,
                32.5634277
              ],
              [
                47.9067078,
                32.5634729
              ],
              [
                47.9049644,
                32.5636599
              ],
              [
                47.9034385,
                32.5642579
              ],
              [
                47.9025689,
                32.5647616
              ],
              [
                47.9019203,
                32.5655434
              ],
              [
                47.9011575,
                32.5661422
              ],
              [
                47.9007263,
                32.5669249
              ],
              [
                47.9007103,
                32.5669758
              ],
              [
                47.9005089,
                32.5676159
              ],
              [
                47.9006195,
                32.5683061
              ],
              [
                47.9012794,
                32.5690391
              ],
              [
                47.9025917,
                32.5698671
              ],
              [
                47.9035525,
                32.5702541
              ],
              [
                47.9037362,
                32.5703281
              ],
              [
                47.9051552,
                32.5708319
              ],
              [
                47.9059219,
                32.5711528
              ],
              [
                47.90625,
                32.571659
              ],
              [
                47.9064178,
                32.5722581
              ],
              [
                47.9062576,
                32.5733157
              ],
              [
                47.9062081,
                32.5743716
              ],
              [
                47.9063226,
                32.5753819
              ],
              [
                47.9065972,
                32.5761189
              ],
              [
                47.9067146,
                32.5763164
              ],
              [
                47.9070891,
                32.5769469
              ],
              [
                47.9073677,
                32.5776817
              ],
              [
                47.9078064,
                32.5783687
              ],
              [
                47.9082985,
                32.5786468
              ],
              [
                47.9095001,
                32.5792894
              ],
              [
                47.9101259,
                32.5794954
              ],
              [
                47.9104842,
                32.5796134
              ],
              [
                47.9116288,
                32.5797948
              ],
              [
                47.9122848,
                32.5797952
              ],
              [
                47.9128266,
                32.5795178
              ],
              [
                47.913536,
                32.5791971
              ],
              [
                47.9145165,
                32.5791964
              ],
              [
                47.9162063,
                32.5791974
              ],
              [
                47.9170047,
                32.5793351
              ],
              [
                47.9180641,
                32.579518
              ],
              [
                47.9192124,
                32.5799744
              ],
              [
                47.9200162,
                32.5802791
              ],
              [
                47.9207954,
                32.5805744
              ],
              [
                47.9221611,
                32.5809392
              ],
              [
                47.9228133,
                32.5809868
              ],
              [
                47.9232647,
                32.580911
              ],
              [
                47.9238007,
                32.5806698
              ],
              [
                47.9240647,
                32.5803864
              ],
              [
                47.9244995,
                32.5797434
              ],
              [
                47.9247704,
                32.5791482
              ],
              [
                47.9251481,
                32.5785489
              ],
              [
                47.9257469,
                32.5784103
              ],
              [
                47.9265099,
                32.5781315
              ],
              [
                47.9274902,
                32.578133
              ],
              [
                47.928421,
                32.5781332
              ],
              [
                47.9296188,
                32.5783158
              ],
              [
                47.9300575,
                32.5784978
              ],
              [
                47.930142,
                32.5785614
              ],
              [
                47.9305497,
                32.5788682
              ],
              [
                47.9311524,
                32.5795095
              ],
              [
                47.9320832,
                32.5807065
              ],
              [
                47.9324847,
                32.5815836
              ],
              [
                47.9325256,
                32.581673
              ],
              [
                47.9328576,
                32.5824091
              ],
              [
                47.9328575,
                32.5828666
              ],
              [
                47.9326973,
                32.5835569
              ],
              [
                47.9323197,
                32.5840638
              ],
              [
                47.93161,
                32.584522
              ],
              [
                47.9305763,
                32.5850287
              ],
              [
                47.928997,
                32.5856752
              ],
              [
                47.9280561,
                32.5860883
              ],
              [
                47.9275283,
                32.58632
              ],
              [
                47.9266052,
                32.5869172
              ],
              [
                47.9247055,
                32.5888022
              ],
              [
                47.9230765,
                32.5905046
              ],
              [
                47.9207917,
                32.5926213
              ],
              [
                47.9180222,
                32.5948297
              ],
              [
                47.9166068,
                32.5959331
              ],
              [
                47.9159012,
                32.5969435
              ],
              [
                47.9151993,
                32.5986911
              ],
              [
                47.9148217,
                32.5999327
              ],
              [
                47.9146117,
                32.6011739
              ],
              [
                47.9145584,
                32.6018172
              ],
              [
                47.9147264,
                32.6024163
              ],
              [
                47.9152184,
                32.6027823
              ],
              [
                47.9159812,
                32.6028754
              ],
              [
                47.9164832,
                32.6029102
              ],
              [
                47.9166373,
                32.6029208
              ],
              [
                47.9176177,
                32.6026925
              ],
              [
                47.9188727,
                32.6023221
              ],
              [
                47.920723,
                32.6015404
              ],
              [
                47.9230652,
                32.600667
              ],
              [
                47.924862,
                32.6002535
              ],
              [
                47.926609,
                32.5998838
              ],
              [
                47.9289513,
                32.5994678
              ],
              [
                47.9304809,
                32.5993768
              ],
              [
                47.9315719,
                32.5994215
              ],
              [
                47.9323882,
                32.599606
              ],
              [
                47.932991,
                32.5998348
              ],
              [
                47.9335938,
                32.6003409
              ],
              [
                47.9341431,
                32.6009854
              ],
              [
                47.934475,
                32.601859
              ],
              [
                47.9349709,
                32.6030544
              ],
              [
                47.9352649,
                32.6044632
              ],
              [
                47.9353065,
                32.6046628
              ],
              [
                47.9359665,
                32.6058577
              ],
              [
                47.9366265,
                32.6070549
              ],
              [
                47.9375573,
                32.6082045
              ],
              [
                47.9380447,
                32.6087568
              ],
              [
                47.9380707,
                32.6087862
              ],
              [
                47.9383277,
                32.6090775
              ],
              [
                47.9393121,
                32.6099513
              ],
              [
                47.9403534,
                32.6103621
              ],
              [
                47.9413376,
                32.6108256
              ],
              [
                47.9424287,
                32.6109153
              ],
              [
                47.9433556,
                32.6109153
              ],
              [
                47.9445,
                32.6107336
              ],
              [
                47.9457398,
                32.6104506
              ],
              [
                47.9459191,
                32.6104097
              ],
              [
                47.9475517,
                32.6099964
              ],
              [
                47.9485893,
                32.6097647
              ],
              [
                47.9493523,
                32.6095804
              ],
              [
                47.9501152,
                32.6097184
              ],
              [
                47.9507905,
                32.6098908
              ],
              [
                47.951374,
                32.6100398
              ],
              [
                47.9545441,
                32.611282
              ],
              [
                47.9560203,
                32.6116942
              ],
              [
                47.95755,
                32.6123399
              ],
              [
                47.9588623,
                32.6127052
              ],
              [
                47.9600639,
                32.6129349
              ],
              [
                47.961483,
                32.6129333
              ],
              [
                47.963829,
                32.612706
              ],
              [
                47.9652482,
                32.6124722
              ],
              [
                47.9674836,
                32.6125172
              ],
              [
                47.9702149,
                32.6126553
              ],
              [
                47.9725609,
                32.6128381
              ],
              [
                47.9745788,
                32.6126546
              ],
              [
                47.9756164,
                32.6124272
              ],
              [
                47.9770851,
                32.611827
              ],
              [
                47.9785538,
                32.6107219
              ],
              [
                47.9793716,
                32.6101549
              ],
              [
                47.9797477,
                32.6098941
              ],
              [
                47.9807281,
                32.6093452
              ],
              [
                47.9818192,
                32.609065
              ],
              [
                47.9829636,
                32.6088829
              ],
              [
                47.9845467,
                32.6090201
              ],
              [
                47.9847862,
                32.6090954
              ],
              [
                47.9858589,
                32.6094325
              ],
              [
                47.9870071,
                32.6100303
              ],
              [
                47.9876671,
                32.6107223
              ],
              [
                47.9883271,
                32.6114121
              ],
              [
                47.9887123,
                32.6121494
              ],
              [
                47.9892081,
                32.6128352
              ],
              [
                47.9893189,
                32.6134802
              ],
              [
                47.9892159,
                32.6143523
              ],
              [
                47.9889985,
                32.614906
              ],
              [
                47.9882964,
                32.6157344
              ],
              [
                47.9864998,
                32.6168408
              ],
              [
                47.9851417,
                32.6176218
              ],
              [
                47.9835626,
                32.6183119
              ],
              [
                47.9821434,
                32.6188164
              ],
              [
                47.9809493,
                32.6195991
              ],
              [
                47.9794808,
                32.6207493
              ],
              [
                47.9785081,
                32.622085
              ],
              [
                47.977581,
                32.6228177
              ],
              [
                47.9762229,
                32.6235085
              ],
              [
                47.9748039,
                32.6238778
              ],
              [
                47.9733315,
                32.6243404
              ],
              [
                47.9713173,
                32.6252136
              ],
              [
                47.9693031,
                32.6262243
              ],
              [
                47.9639664,
                32.6288495
              ],
              [
                47.9626046,
                32.6293981
              ],
              [
                47.9611358,
                32.6303181
              ],
              [
                47.9596672,
                32.6311503
              ],
              [
                47.9583626,
                32.6322051
              ],
              [
                47.9569511,
                32.6334465
              ],
              [
                47.9554824,
                32.6345514
              ],
              [
                47.9546661,
                32.6353339
              ],
              [
                47.9545594,
                32.6359782
              ],
              [
                47.9548378,
                32.6372178
              ],
              [
                47.9553872,
                32.6379547
              ],
              [
                47.9564858,
                32.6385989
              ],
              [
                47.9569065,
                32.6387883
              ],
              [
                47.9579087,
                32.6392397
              ],
              [
                47.9592781,
                32.6402083
              ],
              [
                47.9606476,
                32.6409875
              ],
              [
                47.9611931,
                32.6414042
              ],
              [
                47.9620704,
                32.6422774
              ],
              [
                47.9624595,
                32.6429675
              ],
              [
                47.9624062,
                32.6437956
              ],
              [
                47.9621925,
                32.6443472
              ],
              [
                47.9617428,
                32.6447949
              ],
              [
                47.9615936,
                32.6449435
              ],
              [
                47.9612694,
                32.6454495
              ],
              [
                47.9609451,
                32.6460502
              ],
              [
                47.960949,
                32.6469225
              ],
              [
                47.9610634,
                32.6478877
              ],
              [
                47.961506,
                32.6489442
              ],
              [
                47.9621123,
                32.6502346
              ],
              [
                47.962883,
                32.6512901
              ],
              [
                47.9639816,
                32.6523467
              ],
              [
                47.9648349,
                32.6530119
              ],
              [
                47.9654617,
                32.6535005
              ],
              [
                47.9665603,
                32.6544196
              ],
              [
                47.9672737,
                32.655246
              ],
              [
                47.9677696,
                32.6558913
              ],
              [
                47.9679909,
                32.6565323
              ],
              [
                47.968212,
                32.6571777
              ],
              [
                47.9686507,
                32.6577766
              ],
              [
                47.9691466,
                32.6582799
              ],
              [
                47.9693907,
                32.6587288
              ],
              [
                47.9588904,
                32.6668393
              ],
              [
                47.9586139,
                32.6671192
              ],
              [
                47.9525004,
                32.6748936
              ],
              [
                47.950557,
                32.6790651
              ],
              [
                47.9519438,
                32.6860087
              ],
              [
                47.9516672,
                32.6862887
              ],
              [
                47.9502769,
                32.6901803
              ],
              [
                47.9411104,
                32.6987853
              ],
              [
                47.9288874,
                32.7071194
              ],
              [
                47.9286104,
                32.7073992
              ],
              [
                47.918054,
                32.7126725
              ],
              [
                47.9172207,
                32.7135122
              ],
              [
                47.9161106,
                32.7140629
              ],
              [
                47.9102776,
                32.7212864
              ],
              [
                47.9105541,
                32.7235076
              ],
              [
                47.9161105,
                32.7276792
              ],
              [
                47.9172207,
                32.7276793
              ],
              [
                47.9222208,
                32.7296206
              ],
              [
                47.9227774,
                32.7299004
              ],
              [
                47.9238873,
                32.7310111
              ],
              [
                47.9247205,
                32.737124
              ],
              [
                47.9244438,
                32.7374039
              ],
              [
                47.9275005,
                32.7462887
              ],
              [
                47.9305537,
                32.7471195
              ],
              [
                47.9308338,
                32.7473994
              ],
              [
                47.931667,
                32.7473994
              ],
              [
                47.9350003,
                32.7499005
              ],
              [
                47.9352768,
                32.7551737
              ],
              [
                47.9350002,
                32.7560044
              ],
              [
                47.9394436,
                32.7623972
              ],
              [
                47.9400004,
                32.7623972
              ],
              [
                47.9400003,
                32.7626771
              ],
              [
                47.9408335,
                32.7626771
              ],
              [
                47.9419438,
                32.7632278
              ],
              [
                47.9433336,
                32.7637876
              ],
              [
                47.9486102,
                32.7651782
              ],
              [
                47.9580566,
                32.7660089
              ],
              [
                47.9586136,
                32.7662888
              ],
              [
                47.9630567,
                32.7662889
              ],
              [
                47.9636133,
                32.7665688
              ],
              [
                47.9825031,
                32.7668397
              ],
              [
                47.9830563,
                32.7671196
              ],
              [
                47.990836,
                32.7671196
              ],
              [
                47.991113,
                32.7673995
              ],
              [
                47.9916697,
                32.7671196
              ],
              [
                47.9952795,
                32.7676794
              ],
              [
                47.996946,
                32.7676794
              ],
              [
                47.9988928,
                32.7685101
              ],
              [
                48.0063926,
                32.7743431
              ],
              [
                48.0066692,
                32.7746231
              ],
              [
                48.0100024,
                32.7793454
              ],
              [
                48.0125025,
                32.7904605
              ],
              [
                48.0116692,
                32.7937923
              ],
              [
                48.0113927,
                32.7940722
              ],
              [
                48.0094457,
                32.8007358
              ],
              [
                48.0030593,
                32.8110111
              ],
              [
                48.0027791,
                32.8112911
              ],
              [
                48.0000026,
                32.8101804
              ],
              [
                47.9991694,
                32.8101804
              ],
              [
                47.9988927,
                32.8099005
              ],
              [
                47.9975029,
                32.8090698
              ],
              [
                47.9944462,
                32.8085101
              ],
              [
                47.9936125,
                32.80851
              ],
              [
                47.9922227,
                32.8079592
              ],
              [
                47.9913895,
                32.8079592
              ],
              [
                47.9913895,
                32.8076793
              ],
              [
                47.9905563,
                32.8076793
              ],
              [
                47.9900027,
                32.8076793
              ],
              [
                47.9900027,
                32.8073994
              ],
              [
                47.9855561,
                32.8071286
              ],
              [
                47.984723,
                32.8068486
              ],
              [
                47.9797229,
                32.8068486
              ],
              [
                47.95,
                32.8107312
              ],
              [
                47.9491667,
                32.8110111
              ],
              [
                47.9477765,
                32.8110111
              ],
              [
                47.9427768,
                32.8121216
              ],
              [
                47.9336102,
                32.8185144
              ],
              [
                47.9313867,
                32.8196249
              ],
              [
                47.9308336,
                32.8199048
              ],
              [
                47.9294437,
                32.8204556
              ],
              [
                47.9250003,
                32.8204557
              ],
              [
                47.9225002,
                32.819345
              ],
              [
                47.9161103,
                32.8140629
              ],
              [
                47.9141637,
                32.811011
              ],
              [
                47.9136106,
                32.8062886
              ],
              [
                47.9138872,
                32.805458
              ],
              [
                47.9141637,
                32.8040674
              ],
              [
                47.9133305,
                32.7979546
              ],
              [
                47.910554,
                32.7954534
              ],
              [
                47.9102774,
                32.7957334
              ],
              [
                47.9099973,
                32.7960132
              ],
              [
                47.9072207,
                32.7982345
              ],
              [
                47.9063875,
                32.7982345
              ],
              [
                47.9030542,
                32.7999049
              ],
              [
                47.8855542,
                32.8037875
              ],
              [
                47.8658312,
                32.8085097
              ],
              [
                47.8641643,
                32.8087896
              ],
              [
                47.8491612,
                32.8146226
              ],
              [
                47.8469413,
                32.8151823
              ],
              [
                47.8466612,
                32.8154623
              ],
              [
                47.845828,
                32.8157331
              ],
              [
                47.845828,
                32.816013
              ],
              [
                47.8449948,
                32.816293
              ],
              [
                47.8444413,
                32.8168437
              ],
              [
                47.8438846,
                32.8168438
              ],
              [
                47.8416615,
                32.819074
              ],
              [
                47.8411049,
                32.8196248
              ],
              [
                47.826385,
                32.8273989
              ],
              [
                47.7958254,
                32.8404552
              ],
              [
                47.7947152,
                32.8415658
              ],
              [
                47.7880486,
                32.8460172
              ],
              [
                47.7863822,
                32.846568
              ],
              [
                47.7852685,
                32.8468479
              ],
              [
                47.7824919,
                32.8473987
              ],
              [
                47.7822153,
                32.8476786
              ],
              [
                47.7808255,
                32.8476786
              ],
              [
                47.7805489,
                32.8479585
              ],
              [
                47.7788821,
                32.8479585
              ],
              [
                47.7774921,
                32.8482294
              ],
              [
                47.7769355,
                32.8485092
              ],
              [
                47.7763819,
                32.8485092
              ],
              [
                47.7761023,
                32.8487892
              ],
              [
                47.7752687,
                32.8487892
              ],
              [
                47.7427692,
                32.8646264
              ],
              [
                47.740546,
                32.8662878
              ],
              [
                47.7377695,
                32.8685089
              ],
              [
                47.7319361,
                32.8749017
              ],
              [
                47.7297126,
                32.8812943
              ],
              [
                47.7294325,
                32.8826758
              ],
              [
                47.729156,
                32.8835156
              ],
              [
                47.7299891,
                32.8887887
              ],
              [
                47.7324892,
                32.8957411
              ],
              [
                47.7274894,
                32.9007343
              ],
              [
                47.7263793,
                32.901565
              ],
              [
                47.7199894,
                32.9057365
              ],
              [
                47.7197128,
                32.9062872
              ],
              [
                47.719156,
                32.9062873
              ],
              [
                47.7091562,
                32.9162916
              ],
              [
                47.7058229,
                32.9224043
              ],
              [
                47.7047097,
                32.9262959
              ],
              [
                47.7044327,
                32.9271266
              ],
              [
                47.7033229,
                32.9315689
              ],
              [
                47.7030427,
                32.9324087
              ],
              [
                47.7027663,
                32.9332393
              ],
              [
                47.6997095,
                32.936851
              ],
              [
                47.6955431,
                32.9379525
              ],
              [
                47.6947098,
                32.9385124
              ],
              [
                47.6941562,
                32.9385124
              ],
              [
                47.6933231,
                32.9387923
              ],
              [
                47.6858198,
                32.9404626
              ],
              [
                47.6855432,
                32.9407425
              ],
              [
                47.6847096,
                32.9407425
              ],
              [
                47.6577633,
                32.952679
              ],
              [
                47.6563769,
                32.9529589
              ],
              [
                47.6530402,
                32.9546293
              ],
              [
                47.6505402,
                32.95546
              ],
              [
                47.6252638,
                32.9676764
              ],
              [
                47.6219306,
                32.968796
              ],
              [
                47.6205406,
                32.9696266
              ],
              [
                47.6197071,
                32.9699066
              ],
              [
                47.6185973,
                32.9704573
              ],
              [
                47.6180406,
                32.9710172
              ],
              [
                47.6177641,
                32.971288
              ],
              [
                47.6135941,
                32.9726784
              ],
              [
                47.6133171,
                32.9729583
              ],
              [
                47.6122073,
                32.9729583
              ],
              [
                47.6119272,
                32.9732382
              ],
              [
                47.6108174,
                32.9732382
              ],
              [
                47.6105405,
                32.9735182
              ],
              [
                47.6088739,
                32.9735182
              ],
              [
                47.608594,
                32.9737981
              ],
              [
                47.6069276,
                32.9737981
              ],
              [
                47.6060938,
                32.9740689
              ],
              [
                47.6052606,
                32.9740689
              ],
              [
                47.6044274,
                32.974069
              ],
              [
                47.6041509,
                32.9743488
              ],
              [
                47.6030407,
                32.9743488
              ],
              [
                47.6027606,
                32.9746287
              ],
              [
                47.6016508,
                32.9746287
              ],
              [
                47.5991507,
                32.9754594
              ],
              [
                47.5980409,
                32.9754594
              ],
              [
                47.5969272,
                32.9760192
              ],
              [
                47.5958176,
                32.9760192
              ],
              [
                47.5902608,
                32.9776805
              ],
              [
                47.5849886,
                32.9800922
              ],
              [
                47.5708142,
                32.9865742
              ],
              [
                47.5449812,
                32.999901
              ],
              [
                47.5405382,
                33.0029619
              ],
              [
                47.5402581,
                33.0035217
              ],
              [
                47.5397015,
                33.0037925
              ],
              [
                47.5399815,
                33.0040725
              ],
              [
                47.5374814,
                33.0054629
              ],
              [
                47.5277582,
                33.0087947
              ],
              [
                47.5252582,
                33.0096254
              ],
              [
                47.5230351,
                33.0107359
              ],
              [
                47.5016452,
                33.0162887
              ],
              [
                47.500812,
                33.0165686
              ],
              [
                47.4994217,
                33.0165686
              ],
              [
                47.448866,
                33.0315747
              ],
              [
                47.4391427,
                33.0362879
              ],
              [
                47.4208099,
                33.0432402
              ],
              [
                47.4183099,
                33.0443508
              ],
              [
                47.4127527,
                33.046292
              ],
              [
                47.4119199,
                33.0468518
              ],
              [
                47.4119199,
                33.0471226
              ],
              [
                47.3771965,
                33.0579664
              ],
              [
                47.3635837,
                33.0607383
              ],
              [
                47.3560836,
                33.0632393
              ],
              [
                47.3544172,
                33.0635192
              ],
              [
                47.353307,
                33.0637991
              ],
              [
                47.3530273,
                33.0640699
              ],
              [
                47.3521936,
                33.06407
              ],
              [
                47.3516374,
                33.0640699
              ],
              [
                47.3513601,
                33.0643499
              ],
              [
                47.3471936,
                33.0643498
              ],
              [
                47.3466372,
                33.0646297
              ],
              [
                47.3455271,
                33.0646298
              ],
              [
                47.3449701,
                33.0649096
              ],
              [
                47.3433037,
                33.0649096
              ],
              [
                47.3310808,
                33.0676815
              ],
              [
                47.329694,
                33.0676815
              ],
              [
                47.2916346,
                33.0793469
              ],
              [
                47.2869142,
                33.0807373
              ],
              [
                47.2680247,
                33.0896307
              ],
              [
                47.2566346,
                33.0971248
              ],
              [
                47.2185751,
                33.1360122
              ],
              [
                47.2107984,
                33.1418538
              ],
              [
                47.209689,
                33.1429643
              ],
              [
                47.2083005,
                33.1437564
              ],
              [
                47.2077421,
                33.1440749
              ],
              [
                47.2060756,
                33.1457362
              ],
              [
                47.205799,
                33.1460251
              ],
              [
                47.2057991,
                33.146296
              ],
              [
                47.1991317,
                33.151018
              ],
              [
                47.1980184,
                33.1521286
              ],
              [
                47.1935754,
                33.1557402
              ],
              [
                47.1363491,
                33.1901849
              ],
              [
                47.1363491,
                33.1904647
              ],
              [
                47.135796,
                33.1904648
              ],
              [
                47.135796,
                33.1907447
              ],
              [
                47.1349632,
                33.1907447
              ],
              [
                47.1346826,
                33.1904648
              ],
              [
                47.1346827,
                33.1901849
              ],
              [
                47.1338499,
                33.1888035
              ],
              [
                47.124406,
                33.1790794
              ],
              [
                47.1221832,
                33.1774091
              ],
              [
                47.109683,
                33.1724071
              ],
              [
                47.0867846,
                33.1643201
              ],
              [
                47.0753901,
                33.1578949
              ],
              [
                47.0638032,
                33.1512824
              ],
              [
                47.0601021,
                33.1479164
              ],
              [
                47.05845,
                33.142382
              ],
              [
                47.0556889,
                33.1350301
              ],
              [
                47.0509362,
                33.1317809
              ],
              [
                47.0407912,
                33.1260167
              ],
              [
                47.0382911,
                33.1207438
              ],
              [
                47.0382912,
                33.1199042
              ],
              [
                47.0377341,
                33.1187936
              ],
              [
                47.0374576,
                33.0979639
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 903763,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دهلران",
          "name:en": "Dehloran County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286862"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.5142611,
                32.8993366
              ],
              [
                46.518693,
                32.898156
              ],
              [
                46.527683,
                32.89241
              ],
              [
                46.555702,
                32.874702
              ],
              [
                46.5654107,
                32.8676237
              ],
              [
                46.573649,
                32.861617
              ],
              [
                46.585221,
                32.851784
              ],
              [
                46.588738,
                32.851383
              ],
              [
                46.592412,
                32.850565
              ],
              [
                46.592096,
                32.847863
              ],
              [
                46.601585,
                32.840752
              ],
              [
                46.613722,
                32.832479
              ],
              [
                46.622615,
                32.822218
              ],
              [
                46.632469,
                32.817805
              ],
              [
                46.647307,
                32.814454
              ],
              [
                46.655987,
                32.80735
              ],
              [
                46.688649,
                32.797894
              ],
              [
                46.691232,
                32.79335
              ],
              [
                46.698361,
                32.789195
              ],
              [
                46.707899,
                32.785457
              ],
              [
                46.720615,
                32.78596
              ],
              [
                46.734397,
                32.775398
              ],
              [
                46.74046,
                32.768775
              ],
              [
                46.751356,
                32.760343
              ],
              [
                46.758459,
                32.751283
              ],
              [
                46.758474,
                32.751162
              ],
              [
                46.766326,
                32.742083
              ],
              [
                46.766299,
                32.742033
              ],
              [
                46.78366,
                32.730313
              ],
              [
                46.783801,
                32.730157
              ],
              [
                46.787791,
                32.722788
              ],
              [
                46.791315,
                32.711954
              ],
              [
                46.804238,
                32.705439
              ],
              [
                46.811891,
                32.701022
              ],
              [
                46.825896,
                32.694731
              ],
              [
                46.830258,
                32.686325
              ],
              [
                46.836375,
                32.672572
              ],
              [
                46.842392,
                32.666982
              ],
              [
                46.857348,
                32.655488
              ],
              [
                46.872086,
                32.646476
              ],
              [
                46.887238,
                32.631954
              ],
              [
                46.914126,
                32.618334
              ],
              [
                46.922161,
                32.615281
              ],
              [
                46.939698,
                32.605766
              ],
              [
                46.95577,
                32.597626
              ],
              [
                46.973419,
                32.581341
              ],
              [
                47.017411,
                32.555623
              ],
              [
                47.022638,
                32.550797
              ],
              [
                47.033145,
                32.54454
              ],
              [
                47.0480301,
                32.531239
              ],
              [
                47.0521313,
                32.5271588
              ],
              [
                47.055363,
                32.526151
              ],
              [
                47.0795711,
                32.5117172
              ],
              [
                47.0854976,
                32.5085116
              ],
              [
                47.0904973,
                32.5052312
              ],
              [
                47.0950364,
                32.5020581
              ],
              [
                47.1034009,
                32.4977322
              ],
              [
                47.1073234,
                32.4939495
              ],
              [
                47.110917,
                32.489598
              ],
              [
                47.135073,
                32.476113
              ],
              [
                47.149805,
                32.469279
              ],
              [
                47.168401,
                32.457281
              ],
              [
                47.180773,
                32.455747
              ],
              [
                47.180318,
                32.45638
              ],
              [
                47.180128,
                32.456956
              ],
              [
                47.180155,
                32.458067
              ],
              [
                47.180347,
                32.459176
              ],
              [
                47.180466,
                32.459368
              ],
              [
                47.180712,
                32.459505
              ],
              [
                47.182457,
                32.459528
              ],
              [
                47.18284,
                32.459586
              ],
              [
                47.182998,
                32.460307
              ],
              [
                47.183001,
                32.460977
              ],
              [
                47.18328,
                32.461468
              ],
              [
                47.18354,
                32.46168
              ],
              [
                47.183951,
                32.461824
              ],
              [
                47.184437,
                32.461891
              ],
              [
                47.185716,
                32.461599
              ],
              [
                47.187808,
                32.461217
              ],
              [
                47.188571,
                32.461171
              ],
              [
                47.189159,
                32.461248
              ],
              [
                47.189736,
                32.461399
              ],
              [
                47.190226,
                32.461639
              ],
              [
                47.190396,
                32.461831
              ],
              [
                47.190475,
                32.462995
              ],
              [
                47.1921202,
                32.4629319
              ],
              [
                47.194748,
                32.462831
              ],
              [
                47.194912,
                32.4625
              ],
              [
                47.195005,
                32.462125
              ],
              [
                47.195167,
                32.462039
              ],
              [
                47.195531,
                32.46201
              ],
              [
                47.195944,
                32.461908
              ],
              [
                47.196138,
                32.461924
              ],
              [
                47.196277,
                32.461866
              ],
              [
                47.197523,
                32.462079
              ],
              [
                47.197653,
                32.46195
              ],
              [
                47.198556,
                32.461823
              ],
              [
                47.198721,
                32.461874
              ],
              [
                47.198921,
                32.46204
              ],
              [
                47.1993,
                32.461888
              ],
              [
                47.20016,
                32.461396
              ],
              [
                47.200323,
                32.461346
              ],
              [
                47.200567,
                32.46139
              ],
              [
                47.200811,
                32.461621
              ],
              [
                47.201089,
                32.461654
              ],
              [
                47.201226,
                32.46174
              ],
              [
                47.201591,
                32.461651
              ],
              [
                47.201781,
                32.461716
              ],
              [
                47.202074,
                32.461567
              ],
              [
                47.202453,
                32.461692
              ],
              [
                47.202646,
                32.461613
              ],
              [
                47.202674,
                32.461488
              ],
              [
                47.202842,
                32.461365
              ],
              [
                47.203046,
                32.461302
              ],
              [
                47.203452,
                32.461477
              ],
              [
                47.203637,
                32.461489
              ],
              [
                47.203777,
                32.461556
              ],
              [
                47.203945,
                32.461649
              ],
              [
                47.204045,
                32.461795
              ],
              [
                47.204203,
                32.461878
              ],
              [
                47.204298,
                32.461784
              ],
              [
                47.204295,
                32.461377
              ],
              [
                47.204542,
                32.461247
              ],
              [
                47.204753,
                32.461219
              ],
              [
                47.204947,
                32.461422
              ],
              [
                47.205137,
                32.461481
              ],
              [
                47.20543,
                32.461488
              ],
              [
                47.205575,
                32.461638
              ],
              [
                47.205867,
                32.461423
              ],
              [
                47.206059,
                32.461374
              ],
              [
                47.206214,
                32.461229
              ],
              [
                47.206363,
                32.461241
              ],
              [
                47.206729,
                32.461128
              ],
              [
                47.2071,
                32.461153
              ],
              [
                47.207449,
                32.461336
              ],
              [
                47.207557,
                32.461301
              ],
              [
                47.207727,
                32.461124
              ],
              [
                47.207913,
                32.461051
              ],
              [
                47.207838,
                32.460824
              ],
              [
                47.207885,
                32.46075
              ],
              [
                47.208173,
                32.460674
              ],
              [
                47.208449,
                32.460821
              ],
              [
                47.208676,
                32.46052
              ],
              [
                47.208843,
                32.460518
              ],
              [
                47.2091,
                32.46074
              ],
              [
                47.209245,
                32.460705
              ],
              [
                47.209413,
                32.460582
              ],
              [
                47.209524,
                32.460378
              ],
              [
                47.2098,
                32.460309
              ],
              [
                47.21022,
                32.460452
              ],
              [
                47.21034,
                32.460372
              ],
              [
                47.210526,
                32.46033
              ],
              [
                47.210583,
                32.460201
              ],
              [
                47.211138,
                32.460268
              ],
              [
                47.211263,
                32.460406
              ],
              [
                47.211458,
                32.460432
              ],
              [
                47.21161,
                32.460596
              ],
              [
                47.212359,
                32.460389
              ],
              [
                47.21269,
                32.460722
              ],
              [
                47.212801,
                32.460914
              ],
              [
                47.212798,
                32.461023
              ],
              [
                47.21261,
                32.461185
              ],
              [
                47.212476,
                32.461674
              ],
              [
                47.2126,
                32.461861
              ],
              [
                47.212698,
                32.462223
              ],
              [
                47.212977,
                32.462661
              ],
              [
                47.213088,
                32.462931
              ],
              [
                47.212958,
                32.463102
              ],
              [
                47.213011,
                32.463234
              ],
              [
                47.213621,
                32.4631
              ],
              [
                47.214032,
                32.46319
              ],
              [
                47.214223,
                32.463075
              ],
              [
                47.21459,
                32.462947
              ],
              [
                47.215062,
                32.462802
              ],
              [
                47.215345,
                32.462795
              ],
              [
                47.215641,
                32.462708
              ],
              [
                47.2166,
                32.462341
              ],
              [
                47.216809,
                32.462547
              ],
              [
                47.217131,
                32.462645
              ],
              [
                47.218307,
                32.462698
              ],
              [
                47.218643,
                32.462686
              ],
              [
                47.219575,
                32.462416
              ],
              [
                47.21999,
                32.462384
              ],
              [
                47.220165,
                32.462445
              ],
              [
                47.220524,
                32.462258
              ],
              [
                47.220881,
                32.462166
              ],
              [
                47.221157,
                32.462148
              ],
              [
                47.221316,
                32.462218
              ],
              [
                47.222361,
                32.462365
              ],
              [
                47.222671,
                32.462335
              ],
              [
                47.222714,
                32.462061
              ],
              [
                47.222931,
                32.461888
              ],
              [
                47.223141,
                32.461797
              ],
              [
                47.223432,
                32.461749
              ],
              [
                47.223463,
                32.461876
              ],
              [
                47.223917,
                32.462095
              ],
              [
                47.224148,
                32.462058
              ],
              [
                47.22448,
                32.462165
              ],
              [
                47.224529,
                32.462457
              ],
              [
                47.224434,
                32.46279
              ],
              [
                47.224693,
                32.462868
              ],
              [
                47.224759,
                32.462929
              ],
              [
                47.224774,
                32.463052
              ],
              [
                47.225063,
                32.463221
              ],
              [
                47.225336,
                32.463206
              ],
              [
                47.225781,
                32.463265
              ],
              [
                47.226605,
                32.463148
              ],
              [
                47.227301,
                32.463106
              ],
              [
                47.227773,
                32.462915
              ],
              [
                47.228019,
                32.462881
              ],
              [
                47.228259,
                32.462908
              ],
              [
                47.228501,
                32.463066
              ],
              [
                47.228675,
                32.463122
              ],
              [
                47.228969,
                32.463073
              ],
              [
                47.229266,
                32.463127
              ],
              [
                47.229386,
                32.463203
              ],
              [
                47.229355,
                32.463406
              ],
              [
                47.229435,
                32.463555
              ],
              [
                47.229594,
                32.463612
              ],
              [
                47.22985,
                32.464068
              ],
              [
                47.230132,
                32.464088
              ],
              [
                47.230245,
                32.464195
              ],
              [
                47.230974,
                32.464526
              ],
              [
                47.231321,
                32.464757
              ],
              [
                47.23161,
                32.465351
              ],
              [
                47.231606,
                32.465544
              ],
              [
                47.232075,
                32.465647
              ],
              [
                47.232773,
                32.466725
              ],
              [
                47.233422,
                32.466817
              ],
              [
                47.233689,
                32.466779
              ],
              [
                47.234292,
                32.466531
              ],
              [
                47.234619,
                32.466465
              ],
              [
                47.235139,
                32.466476
              ],
              [
                47.235485,
                32.466402
              ],
              [
                47.23578,
                32.466234
              ],
              [
                47.235884,
                32.465941
              ],
              [
                47.236105,
                32.465773
              ],
              [
                47.237224,
                32.465368
              ],
              [
                47.237816,
                32.465223
              ],
              [
                47.238389,
                32.465183
              ],
              [
                47.239383,
                32.465314
              ],
              [
                47.24006,
                32.465342
              ],
              [
                47.240341,
                32.465241
              ],
              [
                47.240675,
                32.465235
              ],
              [
                47.240905,
                32.465101
              ],
              [
                47.241953,
                32.464978
              ],
              [
                47.24213,
                32.464865
              ],
              [
                47.242309,
                32.464854
              ],
              [
                47.242542,
                32.464941
              ],
              [
                47.242915,
                32.464916
              ],
              [
                47.243997,
                32.464691
              ],
              [
                47.2443,
                32.464468
              ],
              [
                47.244413,
                32.46394
              ],
              [
                47.244645,
                32.463392
              ],
              [
                47.244942,
                32.463356
              ],
              [
                47.245207,
                32.463426
              ],
              [
                47.245398,
                32.463587
              ],
              [
                47.246859,
                32.46363
              ],
              [
                47.247204,
                32.463729
              ],
              [
                47.24736,
                32.463925
              ],
              [
                47.247368,
                32.46414
              ],
              [
                47.247459,
                32.464335
              ],
              [
                47.247618,
                32.464327
              ],
              [
                47.247915,
                32.4642
              ],
              [
                47.248188,
                32.464185
              ],
              [
                47.248355,
                32.464212
              ],
              [
                47.248465,
                32.464278
              ],
              [
                47.248382,
                32.464507
              ],
              [
                47.248449,
                32.464784
              ],
              [
                47.248642,
                32.464921
              ],
              [
                47.248837,
                32.465272
              ],
              [
                47.248982,
                32.465333
              ],
              [
                47.249651,
                32.465175
              ],
              [
                47.249995,
                32.465149
              ],
              [
                47.250381,
                32.465212
              ],
              [
                47.250744,
                32.465206
              ],
              [
                47.25096,
                32.465105
              ],
              [
                47.251122,
                32.465114
              ],
              [
                47.251385,
                32.465233
              ],
              [
                47.251429,
                32.465388
              ],
              [
                47.251568,
                32.465569
              ],
              [
                47.252047,
                32.465473
              ],
              [
                47.252245,
                32.465506
              ],
              [
                47.252449,
                32.465719
              ],
              [
                47.25267,
                32.46579
              ],
              [
                47.252749,
                32.465903
              ],
              [
                47.252952,
                32.46599
              ],
              [
                47.253155,
                32.466197
              ],
              [
                47.25348,
                32.466305
              ],
              [
                47.253583,
                32.466462
              ],
              [
                47.254059,
                32.466594
              ],
              [
                47.254044,
                32.466771
              ],
              [
                47.253955,
                32.466917
              ],
              [
                47.254056,
                32.467092
              ],
              [
                47.25455,
                32.467569
              ],
              [
                47.254618,
                32.467852
              ],
              [
                47.254894,
                32.468028
              ],
              [
                47.25516,
                32.468075
              ],
              [
                47.255472,
                32.467976
              ],
              [
                47.255907,
                32.46809
              ],
              [
                47.256373,
                32.467936
              ],
              [
                47.256668,
                32.468074
              ],
              [
                47.256868,
                32.468299
              ],
              [
                47.257116,
                32.46845
              ],
              [
                47.257822,
                32.468718
              ],
              [
                47.258085,
                32.468873
              ],
              [
                47.258374,
                32.468952
              ],
              [
                47.258662,
                32.46942
              ],
              [
                47.258809,
                32.469756
              ],
              [
                47.258869,
                32.470094
              ],
              [
                47.259074,
                32.470402
              ],
              [
                47.259233,
                32.471209
              ],
              [
                47.259419,
                32.471527
              ],
              [
                47.259652,
                32.47174
              ],
              [
                47.259916,
                32.471865
              ],
              [
                47.260048,
                32.472173
              ],
              [
                47.260774,
                32.472402
              ],
              [
                47.261239,
                32.472638
              ],
              [
                47.261229,
                32.472807
              ],
              [
                47.261115,
                32.47309
              ],
              [
                47.261112,
                32.473348
              ],
              [
                47.261449,
                32.473508
              ],
              [
                47.262066,
                32.473617
              ],
              [
                47.262366,
                32.473652
              ],
              [
                47.262688,
                32.4736
              ],
              [
                47.26294,
                32.473648
              ],
              [
                47.263076,
                32.473758
              ],
              [
                47.263401,
                32.473867
              ],
              [
                47.263831,
                32.474198
              ],
              [
                47.26467,
                32.474444
              ],
              [
                47.264928,
                32.475122
              ],
              [
                47.265457,
                32.475197
              ],
              [
                47.265671,
                32.47542
              ],
              [
                47.265837,
                32.475716
              ],
              [
                47.265979,
                32.475759
              ],
              [
                47.266384,
                32.475687
              ],
              [
                47.266717,
                32.4758
              ],
              [
                47.266937,
                32.476016
              ],
              [
                47.267843,
                32.476149
              ],
              [
                47.26816,
                32.476014
              ],
              [
                47.268523,
                32.475948
              ],
              [
                47.26885,
                32.476033
              ],
              [
                47.269211,
                32.476261
              ],
              [
                47.269313,
                32.476473
              ],
              [
                47.269175,
                32.476747
              ],
              [
                47.268286,
                32.477198
              ],
              [
                47.267559,
                32.477779
              ],
              [
                47.267154,
                32.478031
              ],
              [
                47.267211,
                32.478177
              ],
              [
                47.267627,
                32.478211
              ],
              [
                47.268298,
                32.478425
              ],
              [
                47.268468,
                32.478583
              ],
              [
                47.268717,
                32.47859
              ],
              [
                47.268886,
                32.478868
              ],
              [
                47.269515,
                32.479299
              ],
              [
                47.270298,
                32.478949
              ],
              [
                47.270958,
                32.478907
              ],
              [
                47.271126,
                32.47903
              ],
              [
                47.271188,
                32.479409
              ],
              [
                47.271443,
                32.479679
              ],
              [
                47.271635,
                32.47999
              ],
              [
                47.271651,
                32.480239
              ],
              [
                47.271893,
                32.480427
              ],
              [
                47.272325,
                32.480494
              ],
              [
                47.272643,
                32.480634
              ],
              [
                47.272826,
                32.48088
              ],
              [
                47.272764,
                32.481406
              ],
              [
                47.273286,
                32.481488
              ],
              [
                47.273611,
                32.481357
              ],
              [
                47.273911,
                32.481452
              ],
              [
                47.274439,
                32.481467
              ],
              [
                47.274814,
                32.481328
              ],
              [
                47.27524,
                32.481342
              ],
              [
                47.275605,
                32.481498
              ],
              [
                47.275914,
                32.481418
              ],
              [
                47.27619,
                32.481414
              ],
              [
                47.27635,
                32.481172
              ],
              [
                47.276617,
                32.481069
              ],
              [
                47.277261,
                32.481173
              ],
              [
                47.277367,
                32.481432
              ],
              [
                47.277294,
                32.481851
              ],
              [
                47.277495,
                32.482082
              ],
              [
                47.277793,
                32.482291
              ],
              [
                47.277894,
                32.482497
              ],
              [
                47.277641,
                32.482928
              ],
              [
                47.277828,
                32.483221
              ],
              [
                47.277929,
                32.483486
              ],
              [
                47.27772,
                32.483766
              ],
              [
                47.277731,
                32.483962
              ],
              [
                47.278353,
                32.484334
              ],
              [
                47.278463,
                32.48452
              ],
              [
                47.278311,
                32.484796
              ],
              [
                47.278445,
                32.48499
              ],
              [
                47.278512,
                32.485237
              ],
              [
                47.278839,
                32.485352
              ],
              [
                47.279731,
                32.485487
              ],
              [
                47.280054,
                32.485644
              ],
              [
                47.280273,
                32.48595
              ],
              [
                47.280333,
                32.486319
              ],
              [
                47.281976,
                32.488519
              ],
              [
                47.282013,
                32.489114
              ],
              [
                47.281902,
                32.489487
              ],
              [
                47.281492,
                32.490231
              ],
              [
                47.28138,
                32.49079
              ],
              [
                47.281435,
                32.49112
              ],
              [
                47.281797,
                32.491744
              ],
              [
                47.281832,
                32.492008
              ],
              [
                47.281865,
                32.492356
              ],
              [
                47.281824,
                32.492549
              ],
              [
                47.281633,
                32.492754
              ],
              [
                47.281658,
                32.492978
              ],
              [
                47.281822,
                32.493053
              ],
              [
                47.281969,
                32.493059
              ],
              [
                47.28213,
                32.493182
              ],
              [
                47.282348,
                32.493602
              ],
              [
                47.282315,
                32.493859
              ],
              [
                47.282409,
                32.493976
              ],
              [
                47.282605,
                32.494094
              ],
              [
                47.282671,
                32.494245
              ],
              [
                47.282381,
                32.494886
              ],
              [
                47.28253,
                32.495017
              ],
              [
                47.282896,
                32.495149
              ],
              [
                47.282985,
                32.495273
              ],
              [
                47.282871,
                32.495735
              ],
              [
                47.283269,
                32.496269
              ],
              [
                47.283461,
                32.49637
              ],
              [
                47.28368,
                32.49628
              ],
              [
                47.2842,
                32.496171
              ],
              [
                47.284497,
                32.496194
              ],
              [
                47.284863,
                32.49614
              ],
              [
                47.284995,
                32.495933
              ],
              [
                47.285304,
                32.495948
              ],
              [
                47.285872,
                32.496125
              ],
              [
                47.286909,
                32.495656
              ],
              [
                47.28727,
                32.495579
              ],
              [
                47.287534,
                32.495314
              ],
              [
                47.287827,
                32.49514
              ],
              [
                47.2887,
                32.495045
              ],
              [
                47.289123,
                32.495048
              ],
              [
                47.289462,
                32.494399
              ],
              [
                47.289761,
                32.494248
              ],
              [
                47.29051,
                32.494065
              ],
              [
                47.290636,
                32.493799
              ],
              [
                47.290776,
                32.493656
              ],
              [
                47.291417,
                32.493563
              ],
              [
                47.291625,
                32.493463
              ],
              [
                47.292737,
                32.493209
              ],
              [
                47.292969,
                32.493202
              ],
              [
                47.293174,
                32.49309
              ],
              [
                47.293687,
                32.493072
              ],
              [
                47.294049,
                32.493121
              ],
              [
                47.294445,
                32.493314
              ],
              [
                47.294703,
                32.493235
              ],
              [
                47.294928,
                32.492989
              ],
              [
                47.295654,
                32.492618
              ],
              [
                47.295834,
                32.492457
              ],
              [
                47.295895,
                32.492255
              ],
              [
                47.296083,
                32.491979
              ],
              [
                47.296811,
                32.491404
              ],
              [
                47.297069,
                32.491386
              ],
              [
                47.297245,
                32.491303
              ],
              [
                47.297361,
                32.491056
              ],
              [
                47.297368,
                32.490875
              ],
              [
                47.297798,
                32.490787
              ],
              [
                47.298085,
                32.49095
              ],
              [
                47.298906,
                32.491031
              ],
              [
                47.299424,
                32.49094
              ],
              [
                47.299672,
                32.490672
              ],
              [
                47.300027,
                32.490512
              ],
              [
                47.300163,
                32.490292
              ],
              [
                47.30054,
                32.490044
              ],
              [
                47.300684,
                32.489853
              ],
              [
                47.300933,
                32.48974
              ],
              [
                47.301652,
                32.49003
              ],
              [
                47.301961,
                32.490016
              ],
              [
                47.302382,
                32.490097
              ],
              [
                47.302816,
                32.489966
              ],
              [
                47.303072,
                32.489336
              ],
              [
                47.303715,
                32.489159
              ],
              [
                47.303691,
                32.488911
              ],
              [
                47.303868,
                32.488679
              ],
              [
                47.304175,
                32.488532
              ],
              [
                47.305129,
                32.488442
              ],
              [
                47.305525,
                32.488569
              ],
              [
                47.305903,
                32.488567
              ],
              [
                47.306115,
                32.488479
              ],
              [
                47.306643,
                32.488015
              ],
              [
                47.306704,
                32.487663
              ],
              [
                47.306899,
                32.487505
              ],
              [
                47.307505,
                32.487658
              ],
              [
                47.307821,
                32.487552
              ],
              [
                47.308089,
                32.487334
              ],
              [
                47.30821,
                32.487171
              ],
              [
                47.308629,
                32.487186
              ],
              [
                47.309243,
                32.486834
              ],
              [
                47.309507,
                32.486839
              ],
              [
                47.309749,
                32.486997
              ],
              [
                47.310412,
                32.487026
              ],
              [
                47.310532,
                32.487163
              ],
              [
                47.310857,
                32.487391
              ],
              [
                47.311388,
                32.487538
              ],
              [
                47.311582,
                32.487375
              ],
              [
                47.31171,
                32.48697
              ],
              [
                47.311948,
                32.486811
              ],
              [
                47.312295,
                32.486467
              ],
              [
                47.312381,
                32.486129
              ],
              [
                47.312754,
                32.486014
              ],
              [
                47.313379,
                32.485618
              ],
              [
                47.313576,
                32.485316
              ],
              [
                47.313966,
                32.48518
              ],
              [
                47.314428,
                32.485134
              ],
              [
                47.315601,
                32.485494
              ],
              [
                47.315804,
                32.485341
              ],
              [
                47.315942,
                32.484947
              ],
              [
                47.316386,
                32.484886
              ],
              [
                47.316635,
                32.484288
              ],
              [
                47.316876,
                32.48402
              ],
              [
                47.317938,
                32.483889
              ],
              [
                47.318571,
                32.483587
              ],
              [
                47.318907,
                32.483376
              ],
              [
                47.319348,
                32.483424
              ],
              [
                47.320285,
                32.482839
              ],
              [
                47.321043,
                32.483051
              ],
              [
                47.321413,
                32.482805
              ],
              [
                47.321641,
                32.482539
              ],
              [
                47.321743,
                32.482211
              ],
              [
                47.322104,
                32.482044
              ],
              [
                47.322446,
                32.482012
              ],
              [
                47.322563,
                32.481681
              ],
              [
                47.322428,
                32.481337
              ],
              [
                47.323344,
                32.4803
              ],
              [
                47.323606,
                32.48027
              ],
              [
                47.323865,
                32.480047
              ],
              [
                47.3243,
                32.479796
              ],
              [
                47.324614,
                32.479739
              ],
              [
                47.324961,
                32.479454
              ],
              [
                47.325816,
                32.479225
              ],
              [
                47.326351,
                32.478663
              ],
              [
                47.326614,
                32.478548
              ],
              [
                47.326707,
                32.478299
              ],
              [
                47.32699,
                32.478205
              ],
              [
                47.327193,
                32.478322
              ],
              [
                47.327625,
                32.478329
              ],
              [
                47.328036,
                32.47828
              ],
              [
                47.328207,
                32.478054
              ],
              [
                47.328592,
                32.477931
              ],
              [
                47.329388,
                32.476943
              ],
              [
                47.329861,
                32.476758
              ],
              [
                47.330262,
                32.476729
              ],
              [
                47.331674,
                32.476815
              ],
              [
                47.331872,
                32.476759
              ],
              [
                47.33234,
                32.476976
              ],
              [
                47.333016,
                32.477093
              ],
              [
                47.333319,
                32.47684
              ],
              [
                47.333873,
                32.476659
              ],
              [
                47.334105,
                32.476412
              ],
              [
                47.334589,
                32.476063
              ],
              [
                47.334762,
                32.475783
              ],
              [
                47.335137,
                32.475589
              ],
              [
                47.335624,
                32.475229
              ],
              [
                47.33607,
                32.475414
              ],
              [
                47.336554,
                32.475712
              ],
              [
                47.33715,
                32.476494
              ],
              [
                47.337596,
                32.476903
              ],
              [
                47.338192,
                32.477015
              ],
              [
                47.338899,
                32.477052
              ],
              [
                47.339793,
                32.477276
              ],
              [
                47.340091,
                32.476978
              ],
              [
                47.340426,
                32.476829
              ],
              [
                47.340649,
                32.476345
              ],
              [
                47.340947,
                32.476159
              ],
              [
                47.341654,
                32.475973
              ],
              [
                47.342101,
                32.476084
              ],
              [
                47.342585,
                32.476047
              ],
              [
                47.343032,
                32.475786
              ],
              [
                47.343702,
                32.475675
              ],
              [
                47.344186,
                32.475786
              ],
              [
                47.34467,
                32.475824
              ],
              [
                47.345228,
                32.475935
              ],
              [
                47.345787,
                32.4756
              ],
              [
                47.346308,
                32.475451
              ],
              [
                47.346866,
                32.475451
              ],
              [
                47.348169,
                32.475153
              ],
              [
                47.349063,
                32.475079
              ],
              [
                47.351483,
                32.475042
              ],
              [
                47.352525,
                32.474967
              ],
              [
                47.354349,
                32.474707
              ],
              [
                47.354684,
                32.474521
              ],
              [
                47.354871,
                32.474334
              ],
              [
                47.355641,
                32.473242
              ],
              [
                47.355758,
                32.472941
              ],
              [
                47.356071,
                32.472794
              ],
              [
                47.3563,
                32.472744
              ],
              [
                47.35702,
                32.472075
              ],
              [
                47.357598,
                32.471723
              ],
              [
                47.357633,
                32.471357
              ],
              [
                47.358006,
                32.470942
              ],
              [
                47.358629,
                32.470834
              ],
              [
                47.358825,
                32.470653
              ],
              [
                47.358865,
                32.470484
              ],
              [
                47.35911,
                32.470504
              ],
              [
                47.359509,
                32.470828
              ],
              [
                47.359754,
                32.470848
              ],
              [
                47.3601,
                32.471073
              ],
              [
                47.360452,
                32.470932
              ],
              [
                47.360736,
                32.470718
              ],
              [
                47.360791,
                32.470253
              ],
              [
                47.360994,
                32.47016
              ],
              [
                47.36118,
                32.470387
              ],
              [
                47.361594,
                32.470529
              ],
              [
                47.361947,
                32.470424
              ],
              [
                47.362347,
                32.470454
              ],
              [
                47.362509,
                32.470518
              ],
              [
                47.363042,
                32.470101
              ],
              [
                47.363264,
                32.470148
              ],
              [
                47.36348,
                32.470377
              ],
              [
                47.363969,
                32.470261
              ],
              [
                47.364326,
                32.470412
              ],
              [
                47.364942,
                32.470245
              ],
              [
                47.365274,
                32.470383
              ],
              [
                47.365571,
                32.470406
              ],
              [
                47.366285,
                32.470649
              ],
              [
                47.366661,
                32.470606
              ],
              [
                47.367003,
                32.470694
              ],
              [
                47.36746,
                32.470655
              ],
              [
                47.367823,
                32.470739
              ],
              [
                47.367756,
                32.471008
              ],
              [
                47.367863,
                32.471206
              ],
              [
                47.368329,
                32.471568
              ],
              [
                47.368713,
                32.471439
              ],
              [
                47.36891,
                32.471563
              ],
              [
                47.369417,
                32.472211
              ],
              [
                47.369761,
                32.472251
              ],
              [
                47.369936,
                32.472672
              ],
              [
                47.370133,
                32.472825
              ],
              [
                47.370123,
                32.473265
              ],
              [
                47.370389,
                32.473461
              ],
              [
                47.371163,
                32.473802
              ],
              [
                47.371213,
                32.474009
              ],
              [
                47.371095,
                32.474424
              ],
              [
                47.370719,
                32.474738
              ],
              [
                47.370613,
                32.474989
              ],
              [
                47.37065,
                32.475175
              ],
              [
                47.370812,
                32.475334
              ],
              [
                47.371146,
                32.475297
              ],
              [
                47.371572,
                32.475162
              ],
              [
                47.372005,
                32.474965
              ],
              [
                47.372778,
                32.474755
              ],
              [
                47.373092,
                32.474727
              ],
              [
                47.373494,
                32.474524
              ],
              [
                47.374483,
                32.474362
              ],
              [
                47.374767,
                32.474213
              ],
              [
                47.375399,
                32.47351
              ],
              [
                47.375706,
                32.473394
              ],
              [
                47.376101,
                32.473342
              ],
              [
                47.376529,
                32.473362
              ],
              [
                47.376807,
                32.47355
              ],
              [
                47.37746,
                32.473689
              ],
              [
                47.37777,
                32.473854
              ],
              [
                47.378021,
                32.473867
              ],
              [
                47.378,
                32.473481
              ],
              [
                47.378522,
                32.473197
              ],
              [
                47.378916,
                32.473199
              ],
              [
                47.379353,
                32.473139
              ],
              [
                47.379567,
                32.473212
              ],
              [
                47.379738,
                32.473076
              ],
              [
                47.379768,
                32.472808
              ],
              [
                47.37988,
                32.472609
              ],
              [
                47.379818,
                32.4722
              ],
              [
                47.379953,
                32.472064
              ],
              [
                47.379866,
                32.471826
              ],
              [
                47.380081,
                32.471509
              ],
              [
                47.380377,
                32.471557
              ],
              [
                47.380623,
                32.471493
              ],
              [
                47.380884,
                32.471216
              ],
              [
                47.381149,
                32.471227
              ],
              [
                47.381687,
                32.471343
              ],
              [
                47.382233,
                32.470948
              ],
              [
                47.382428,
                32.471
              ],
              [
                47.382955,
                32.470919
              ],
              [
                47.383116,
                32.470743
              ],
              [
                47.383315,
                32.470633
              ],
              [
                47.383858,
                32.470526
              ],
              [
                47.383977,
                32.470326
              ],
              [
                47.384162,
                32.469763
              ],
              [
                47.384001,
                32.469369
              ],
              [
                47.38429,
                32.469148
              ],
              [
                47.384615,
                32.469077
              ],
              [
                47.384709,
                32.468894
              ],
              [
                47.384632,
                32.468666
              ],
              [
                47.384735,
                32.468398
              ],
              [
                47.384932,
                32.468156
              ],
              [
                47.385517,
                32.467772
              ],
              [
                47.386,
                32.467088
              ],
              [
                47.38626,
                32.466991
              ],
              [
                47.386499,
                32.467012
              ],
              [
                47.386796,
                32.466766
              ],
              [
                47.387062,
                32.466722
              ],
              [
                47.38738,
                32.466802
              ],
              [
                47.387523,
                32.466911
              ],
              [
                47.387593,
                32.467049
              ],
              [
                47.387746,
                32.467138
              ],
              [
                47.387946,
                32.467153
              ],
              [
                47.388438,
                32.466929
              ],
              [
                47.388797,
                32.466966
              ],
              [
                47.389094,
                32.466869
              ],
              [
                47.38975,
                32.46678
              ],
              [
                47.391033,
                32.465845
              ],
              [
                47.391536,
                32.465697
              ],
              [
                47.39207,
                32.465105
              ],
              [
                47.392309,
                32.464977
              ],
              [
                47.392622,
                32.464883
              ],
              [
                47.393188,
                32.464545
              ],
              [
                47.393437,
                32.464007
              ],
              [
                47.3944,
                32.463068
              ],
              [
                47.394682,
                32.462353
              ],
              [
                47.394536,
                32.461971
              ],
              [
                47.394477,
                32.461502
              ],
              [
                47.394183,
                32.460504
              ],
              [
                47.394213,
                32.460284
              ],
              [
                47.394345,
                32.460093
              ],
              [
                47.394624,
                32.459858
              ],
              [
                47.394609,
                32.459345
              ],
              [
                47.394785,
                32.459286
              ],
              [
                47.394888,
                32.459184
              ],
              [
                47.395152,
                32.458494
              ],
              [
                47.395299,
                32.458406
              ],
              [
                47.39615,
                32.458288
              ],
              [
                47.396678,
                32.457907
              ],
              [
                47.397221,
                32.45776
              ],
              [
                47.397676,
                32.457482
              ],
              [
                47.397969,
                32.457232
              ],
              [
                47.398277,
                32.456836
              ],
              [
                47.398864,
                32.456234
              ],
              [
                47.400214,
                32.454415
              ],
              [
                47.400493,
                32.45421
              ],
              [
                47.401124,
                32.454107
              ],
              [
                47.40152,
                32.453813
              ],
              [
                47.402146,
                32.453755
              ],
              [
                47.402442,
                32.453211
              ],
              [
                47.402631,
                32.453
              ],
              [
                47.402952,
                32.452456
              ],
              [
                47.403493,
                32.451924
              ],
              [
                47.405102,
                32.449928
              ],
              [
                47.4058,
                32.448927
              ],
              [
                47.406047,
                32.448712
              ],
              [
                47.407331,
                32.447243
              ],
              [
                47.40763,
                32.446797
              ],
              [
                47.408062,
                32.446304
              ],
              [
                47.408783,
                32.445297
              ],
              [
                47.40866,
                32.444909
              ],
              [
                47.408957,
                32.444428
              ],
              [
                47.40924,
                32.444264
              ],
              [
                47.409575,
                32.444353
              ],
              [
                47.410094,
                32.443873
              ],
              [
                47.410901,
                32.44288
              ],
              [
                47.411182,
                32.442419
              ],
              [
                47.41105,
                32.44226
              ],
              [
                47.411021,
                32.442094
              ],
              [
                47.411178,
                32.441901
              ],
              [
                47.411897,
                32.441602
              ],
              [
                47.412551,
                32.440899
              ],
              [
                47.412634,
                32.440684
              ],
              [
                47.412574,
                32.440484
              ],
              [
                47.412605,
                32.440205
              ],
              [
                47.412822,
                32.440081
              ],
              [
                47.413162,
                32.440083
              ],
              [
                47.413797,
                32.439332
              ],
              [
                47.414152,
                32.439046
              ],
              [
                47.414463,
                32.43862
              ],
              [
                47.414556,
                32.438153
              ],
              [
                47.415065,
                32.437903
              ],
              [
                47.415435,
                32.437541
              ],
              [
                47.415816,
                32.437251
              ],
              [
                47.415958,
                32.436998
              ],
              [
                47.415738,
                32.43666
              ],
              [
                47.41584,
                32.436443
              ],
              [
                47.416698,
                32.436091
              ],
              [
                47.416977,
                32.435887
              ],
              [
                47.417887,
                32.434836
              ],
              [
                47.418065,
                32.434725
              ],
              [
                47.418109,
                32.434546
              ],
              [
                47.418417,
                32.434371
              ],
              [
                47.418558,
                32.434118
              ],
              [
                47.418958,
                32.433899
              ],
              [
                47.41901,
                32.433701
              ],
              [
                47.418989,
                32.433437
              ],
              [
                47.419559,
                32.432543
              ],
              [
                47.420241,
                32.431812
              ],
              [
                47.420493,
                32.431265
              ],
              [
                47.420623,
                32.430837
              ],
              [
                47.421076,
                32.430477
              ],
              [
                47.421454,
                32.42988
              ],
              [
                47.421646,
                32.429053
              ],
              [
                47.42198,
                32.428555
              ],
              [
                47.422107,
                32.428196
              ],
              [
                47.422552,
                32.427643
              ],
              [
                47.422907,
                32.427016
              ],
              [
                47.423182,
                32.426688
              ],
              [
                47.423466,
                32.426238
              ],
              [
                47.423694,
                32.426129
              ],
              [
                47.423913,
                32.425828
              ],
              [
                47.423802,
                32.4253
              ],
              [
                47.423925,
                32.425107
              ],
              [
                47.424122,
                32.424855
              ],
              [
                47.424519,
                32.424705
              ],
              [
                47.425032,
                32.423964
              ],
              [
                47.425283,
                32.423891
              ],
              [
                47.425905,
                32.423461
              ],
              [
                47.42614,
                32.423088
              ],
              [
                47.426584,
                32.42269
              ],
              [
                47.42666,
                32.422557
              ],
              [
                47.426652,
                32.42237
              ],
              [
                47.426776,
                32.422234
              ],
              [
                47.427012,
                32.422129
              ],
              [
                47.427095,
                32.421995
              ],
              [
                47.427108,
                32.421833
              ],
              [
                47.427329,
                32.421594
              ],
              [
                47.427446,
                32.42114
              ],
              [
                47.427729,
                32.420924
              ],
              [
                47.42801,
                32.420595
              ],
              [
                47.428689,
                32.420115
              ],
              [
                47.428973,
                32.419745
              ],
              [
                47.42952,
                32.419295
              ],
              [
                47.429845,
                32.418764
              ],
              [
                47.430189,
                32.418332
              ],
              [
                47.430383,
                32.418144
              ],
              [
                47.430597,
                32.41806
              ],
              [
                47.430863,
                32.418047
              ],
              [
                47.431762,
                32.418144
              ],
              [
                47.431761,
                32.417825
              ],
              [
                47.432104,
                32.41757
              ],
              [
                47.432207,
                32.417329
              ],
              [
                47.432466,
                32.417152
              ],
              [
                47.432753,
                32.417084
              ],
              [
                47.433006,
                32.416965
              ],
              [
                47.433356,
                32.416954
              ],
              [
                47.433549,
                32.416817
              ],
              [
                47.433661,
                32.416609
              ],
              [
                47.434293,
                32.416189
              ],
              [
                47.434598,
                32.41561
              ],
              [
                47.434751,
                32.415424
              ],
              [
                47.435052,
                32.41533
              ],
              [
                47.43516,
                32.415163
              ],
              [
                47.435365,
                32.415046
              ],
              [
                47.435342,
                32.414823
              ],
              [
                47.435428,
                32.414704
              ],
              [
                47.435908,
                32.414471
              ],
              [
                47.436033,
                32.414312
              ],
              [
                47.436282,
                32.414154
              ],
              [
                47.436455,
                32.413809
              ],
              [
                47.436465,
                32.413608
              ],
              [
                47.436902,
                32.413479
              ],
              [
                47.436945,
                32.413272
              ],
              [
                47.437059,
                32.413069
              ],
              [
                47.437268,
                32.412969
              ],
              [
                47.437473,
                32.412665
              ],
              [
                47.437696,
                32.412488
              ],
              [
                47.43775,
                32.412376
              ],
              [
                47.438432,
                32.411645
              ],
              [
                47.438684,
                32.41152
              ],
              [
                47.439024,
                32.411209
              ],
              [
                47.439142,
                32.410892
              ],
              [
                47.439378,
                32.410787
              ],
              [
                47.439607,
                32.410575
              ],
              [
                47.439829,
                32.410125
              ],
              [
                47.440862,
                32.409811
              ],
              [
                47.441316,
                32.409188
              ],
              [
                47.44162,
                32.408866
              ],
              [
                47.441866,
                32.40872
              ],
              [
                47.442267,
                32.408637
              ],
              [
                47.442943,
                32.407833
              ],
              [
                47.443207,
                32.407729
              ],
              [
                47.443607,
                32.407721
              ],
              [
                47.443818,
                32.407655
              ],
              [
                47.443904,
                32.407189
              ],
              [
                47.444154,
                32.407059
              ],
              [
                47.444351,
                32.406779
              ],
              [
                47.444676,
                32.406619
              ],
              [
                47.444856,
                32.406404
              ],
              [
                47.44503,
                32.406299
              ],
              [
                47.445446,
                32.406169
              ],
              [
                47.445714,
                32.40595
              ],
              [
                47.445802,
                32.405729
              ],
              [
                47.44567,
                32.405518
              ],
              [
                47.445434,
                32.405355
              ],
              [
                47.445579,
                32.405118
              ],
              [
                47.446068,
                32.404627
              ],
              [
                47.44682,
                32.404271
              ],
              [
                47.447138,
                32.403844
              ],
              [
                47.447464,
                32.403689
              ],
              [
                47.447617,
                32.403399
              ],
              [
                47.447904,
                32.403223
              ],
              [
                47.448485,
                32.403034
              ],
              [
                47.448777,
                32.402771
              ],
              [
                47.44954,
                32.40251
              ],
              [
                47.450001,
                32.402075
              ],
              [
                47.45014,
                32.401731
              ],
              [
                47.450364,
                32.401634
              ],
              [
                47.451067,
                32.401566
              ],
              [
                47.451222,
                32.401339
              ],
              [
                47.451605,
                32.400975
              ],
              [
                47.451788,
                32.400457
              ],
              [
                47.452047,
                32.40036
              ],
              [
                47.452326,
                32.400316
              ],
              [
                47.452391,
                32.400031
              ],
              [
                47.4525,
                32.399921
              ],
              [
                47.453267,
                32.399619
              ],
              [
                47.453503,
                32.399332
              ],
              [
                47.453777,
                32.399238
              ],
              [
                47.453991,
                32.399234
              ],
              [
                47.454142,
                32.398859
              ],
              [
                47.454345,
                32.398681
              ],
              [
                47.454304,
                32.39834
              ],
              [
                47.454502,
                32.397854
              ],
              [
                47.454682,
                32.39772
              ],
              [
                47.455631,
                32.397426
              ],
              [
                47.455851,
                32.397261
              ],
              [
                47.456058,
                32.397019
              ],
              [
                47.456249,
                32.396957
              ],
              [
                47.456713,
                32.397006
              ],
              [
                47.456907,
                32.396846
              ],
              [
                47.457238,
                32.396365
              ],
              [
                47.457543,
                32.39602
              ],
              [
                47.458011,
                32.395794
              ],
              [
                47.458712,
                32.395641
              ],
              [
                47.459187,
                32.395392
              ],
              [
                47.459508,
                32.394844
              ],
              [
                47.459788,
                32.394749
              ],
              [
                47.460698,
                32.39473
              ],
              [
                47.460948,
                32.394863
              ],
              [
                47.461339,
                32.394691
              ],
              [
                47.461635,
                32.394444
              ],
              [
                47.461395,
                32.394002
              ],
              [
                47.461571,
                32.393725
              ],
              [
                47.461963,
                32.393553
              ],
              [
                47.462241,
                32.393293
              ],
              [
                47.462647,
                32.393044
              ],
              [
                47.462851,
                32.392842
              ],
              [
                47.462984,
                32.392608
              ],
              [
                47.463535,
                32.392356
              ],
              [
                47.463909,
                32.392119
              ],
              [
                47.464202,
                32.392021
              ],
              [
                47.464448,
                32.391795
              ],
              [
                47.464584,
                32.39152
              ],
              [
                47.465348,
                32.391316
              ],
              [
                47.464667,
                32.38988
              ],
              [
                47.464456,
                32.389632
              ],
              [
                47.464157,
                32.389468
              ],
              [
                47.464039,
                32.388964
              ],
              [
                47.464194,
                32.388578
              ],
              [
                47.464115,
                32.387668
              ],
              [
                47.463868,
                32.387415
              ],
              [
                47.463467,
                32.387338
              ],
              [
                47.463175,
                32.38715
              ],
              [
                47.463081,
                32.386659
              ],
              [
                47.463173,
                32.386215
              ],
              [
                47.463084,
                32.385746
              ],
              [
                47.462936,
                32.38531
              ],
              [
                47.46297,
                32.384831
              ],
              [
                47.462633,
                32.384315
              ],
              [
                47.462327,
                32.384152
              ],
              [
                47.462187,
                32.383909
              ],
              [
                47.462455,
                32.38324
              ],
              [
                47.462517,
                32.382892
              ],
              [
                47.462404,
                32.382542
              ],
              [
                47.46257,
                32.38209
              ],
              [
                47.462972,
                32.382116
              ],
              [
                47.463315,
                32.381679
              ],
              [
                47.463787,
                32.381418
              ],
              [
                47.463845,
                32.380951
              ],
              [
                47.463996,
                32.380656
              ],
              [
                47.464249,
                32.380429
              ],
              [
                47.464275,
                32.380105
              ],
              [
                47.464113,
                32.379832
              ],
              [
                47.464174,
                32.379747
              ],
              [
                47.464617,
                32.379822
              ],
              [
                47.464842,
                32.379942
              ],
              [
                47.465016,
                32.379973
              ],
              [
                47.465165,
                32.379879
              ],
              [
                47.465122,
                32.379715
              ],
              [
                47.465008,
                32.37957
              ],
              [
                47.465055,
                32.379459
              ],
              [
                47.465418,
                32.379309
              ],
              [
                47.465866,
                32.379247
              ],
              [
                47.466219,
                32.378505
              ],
              [
                47.466076,
                32.37812
              ],
              [
                47.466023,
                32.377571
              ],
              [
                47.465712,
                32.377101
              ],
              [
                47.46537,
                32.376774
              ],
              [
                47.464671,
                32.376407
              ],
              [
                47.464356,
                32.375944
              ],
              [
                47.464032,
                32.375289
              ],
              [
                47.463648,
                32.374832
              ],
              [
                47.463082,
                32.374602
              ],
              [
                47.462451,
                32.374628
              ],
              [
                47.461803,
                32.37488
              ],
              [
                47.461342,
                32.375156
              ],
              [
                47.46089,
                32.375202
              ],
              [
                47.460614,
                32.374812
              ],
              [
                47.460307,
                32.37311
              ],
              [
                47.460191,
                32.37272
              ],
              [
                47.460029,
                32.372526
              ],
              [
                47.459273,
                32.37205
              ],
              [
                47.458351,
                32.371306
              ],
              [
                47.457992,
                32.370942
              ],
              [
                47.457559,
                32.370375
              ],
              [
                47.455816,
                32.368694
              ],
              [
                47.454348,
                32.367192
              ],
              [
                47.453962,
                32.366935
              ],
              [
                47.453523,
                32.366876
              ],
              [
                47.45293,
                32.366651
              ],
              [
                47.452815,
                32.366369
              ],
              [
                47.452919,
                32.365945
              ],
              [
                47.452933,
                32.36539
              ],
              [
                47.452673,
                32.364979
              ],
              [
                47.452015,
                32.36448
              ],
              [
                47.452059,
                32.364119
              ],
              [
                47.451935,
                32.363382
              ],
              [
                47.451624,
                32.362884
              ],
              [
                47.451261,
                32.362475
              ],
              [
                47.450715,
                32.361027
              ],
              [
                47.450737,
                32.360344
              ],
              [
                47.451042,
                32.359497
              ],
              [
                47.451204,
                32.358185
              ],
              [
                47.449528,
                32.35753
              ],
              [
                47.448624,
                32.357228
              ],
              [
                47.447463,
                32.356921
              ],
              [
                47.442853,
                32.356102
              ],
              [
                47.442002,
                32.355843
              ],
              [
                47.44079,
                32.355579
              ],
              [
                47.439885,
                32.355038
              ],
              [
                47.439498,
                32.354245
              ],
              [
                47.438947,
                32.353413
              ],
              [
                47.4382,
                32.352628
              ],
              [
                47.437619,
                32.352343
              ],
              [
                47.436768,
                32.352374
              ],
              [
                47.435855,
                32.352302
              ],
              [
                47.435418,
                32.352089
              ],
              [
                47.435256,
                32.351867
              ],
              [
                47.435689,
                32.351379
              ],
              [
                47.436411,
                32.350772
              ],
              [
                47.437408,
                32.350584
              ],
              [
                47.438893,
                32.350406
              ],
              [
                47.439692,
                32.350201
              ],
              [
                47.440243,
                32.349949
              ],
              [
                47.440903,
                32.349268
              ],
              [
                47.441884,
                32.34862
              ],
              [
                47.442563,
                32.348249
              ],
              [
                47.443023,
                32.348179
              ],
              [
                47.44341,
                32.348201
              ],
              [
                47.444334,
                32.348476
              ],
              [
                47.444787,
                32.34851
              ],
              [
                47.445238,
                32.348247
              ],
              [
                47.445553,
                32.347969
              ],
              [
                47.445726,
                32.347437
              ],
              [
                47.446504,
                32.346757
              ],
              [
                47.446813,
                32.346616
              ],
              [
                47.44717,
                32.346576
              ],
              [
                47.447361,
                32.346776
              ],
              [
                47.447656,
                32.346895
              ],
              [
                47.448143,
                32.346877
              ],
              [
                47.448801,
                32.346503
              ],
              [
                47.449432,
                32.346294
              ],
              [
                47.450394,
                32.346181
              ],
              [
                47.450991,
                32.345812
              ],
              [
                47.451647,
                32.345593
              ],
              [
                47.452382,
                32.345092
              ],
              [
                47.453067,
                32.344771
              ],
              [
                47.453456,
                32.344325
              ],
              [
                47.453734,
                32.344088
              ],
              [
                47.454261,
                32.342979
              ],
              [
                47.454962,
                32.341897
              ],
              [
                47.455094,
                32.341291
              ],
              [
                47.455274,
                32.340815
              ],
              [
                47.455777,
                32.340246
              ],
              [
                47.456201,
                32.339589
              ],
              [
                47.456577,
                32.338382
              ],
              [
                47.4571482,
                32.3373821
              ],
              [
                47.457174,
                32.337337
              ],
              [
                47.457481,
                32.336672
              ],
              [
                47.457958,
                32.33468
              ],
              [
                47.45795,
                32.33407
              ],
              [
                47.457678,
                32.333036
              ],
              [
                47.457371,
                32.332745
              ],
              [
                47.456467,
                32.332623
              ],
              [
                47.456096,
                32.332494
              ],
              [
                47.455812,
                32.332198
              ],
              [
                47.455833,
                32.331754
              ],
              [
                47.456207,
                32.331435
              ],
              [
                47.456999,
                32.330985
              ],
              [
                47.45764,
                32.330311
              ],
              [
                47.458179,
                32.329629
              ],
              [
                47.458932,
                32.328393
              ],
              [
                47.459159,
                32.327887
              ],
              [
                47.459225,
                32.327384
              ],
              [
                47.459856,
                32.32673
              ],
              [
                47.460068,
                32.326113
              ],
              [
                47.460472,
                32.325701
              ],
              [
                47.461685,
                32.325226
              ],
              [
                47.462086,
                32.324859
              ],
              [
                47.461425,
                32.324121
              ],
              [
                47.461363,
                32.323653
              ],
              [
                47.461707,
                32.322811
              ],
              [
                47.462449,
                32.321678
              ],
              [
                47.462703,
                32.321047
              ],
              [
                47.461949,
                32.319551
              ],
              [
                47.461788,
                32.318359
              ],
              [
                47.461743,
                32.316214
              ],
              [
                47.46314,
                32.314316
              ],
              [
                47.463502,
                32.31427
              ],
              [
                47.46397,
                32.314331
              ],
              [
                47.46411,
                32.314747
              ],
              [
                47.464127,
                32.315247
              ],
              [
                47.464451,
                32.315693
              ],
              [
                47.46509,
                32.316114
              ],
              [
                47.465718,
                32.316436
              ],
              [
                47.46654,
                32.316768
              ],
              [
                47.468638,
                32.317212
              ],
              [
                47.470145,
                32.317296
              ],
              [
                47.470707,
                32.31705
              ],
              [
                47.471757,
                32.316038
              ],
              [
                47.472066,
                32.315587
              ],
              [
                47.472551,
                32.315104
              ],
              [
                47.473119,
                32.314675
              ],
              [
                47.473713,
                32.313971
              ],
              [
                47.474256,
                32.313823
              ],
              [
                47.475003,
                32.313696
              ],
              [
                47.475283,
                32.313395
              ],
              [
                47.475548,
                32.313007
              ],
              [
                47.476829,
                32.312294
              ],
              [
                47.477303,
                32.311656
              ],
              [
                47.477676,
                32.310953
              ],
              [
                47.478003,
                32.310567
              ],
              [
                47.478385,
                32.310392
              ],
              [
                47.478857,
                32.310295
              ],
              [
                47.479053,
                32.310399
              ],
              [
                47.479108,
                32.310609
              ],
              [
                47.479294,
                32.310822
              ],
              [
                47.479183,
                32.31098
              ],
              [
                47.479292,
                32.311017
              ],
              [
                47.479524,
                32.310969
              ],
              [
                47.479962,
                32.311206
              ],
              [
                47.480154,
                32.31121
              ],
              [
                47.480298,
                32.311379
              ],
              [
                47.48033,
                32.311732
              ],
              [
                47.480496,
                32.311841
              ],
              [
                47.480773,
                32.311848
              ],
              [
                47.481362,
                32.31202
              ],
              [
                47.481721,
                32.311786
              ],
              [
                47.482416,
                32.311782
              ],
              [
                47.482646,
                32.312307
              ],
              [
                47.48303,
                32.312371
              ],
              [
                47.483434,
                32.313004
              ],
              [
                47.483578,
                32.313173
              ],
              [
                47.483751,
                32.313275
              ],
              [
                47.484251,
                32.313865
              ],
              [
                47.484433,
                32.314034
              ],
              [
                47.484981,
                32.314314
              ],
              [
                47.485191,
                32.314358
              ],
              [
                47.485912,
                32.314249
              ],
              [
                47.486542,
                32.31391
              ],
              [
                47.487402,
                32.313718
              ],
              [
                47.488851,
                32.313586
              ],
              [
                47.489288,
                32.313589
              ],
              [
                47.489372,
                32.313732
              ],
              [
                47.489618,
                32.313883
              ],
              [
                47.489892,
                32.31391
              ],
              [
                47.490107,
                32.313909
              ],
              [
                47.490456,
                32.313696
              ],
              [
                47.490704,
                32.313677
              ],
              [
                47.49118,
                32.313976
              ],
              [
                47.491421,
                32.314021
              ],
              [
                47.491618,
                32.313866
              ],
              [
                47.491603,
                32.313636
              ],
              [
                47.491453,
                32.313386
              ],
              [
                47.49153,
                32.313214
              ],
              [
                47.492215,
                32.31262
              ],
              [
                47.49228,
                32.312256
              ],
              [
                47.492257,
                32.311996
              ],
              [
                47.492379,
                32.311848
              ],
              [
                47.492626,
                32.311741
              ],
              [
                47.49285,
                32.31172
              ],
              [
                47.493038,
                32.311649
              ],
              [
                47.493012,
                32.311464
              ],
              [
                47.492843,
                32.311199
              ],
              [
                47.492691,
                32.311087
              ],
              [
                47.492473,
                32.311044
              ],
              [
                47.492704,
                32.310644
              ],
              [
                47.493903,
                32.310462
              ],
              [
                47.494041,
                32.310349
              ],
              [
                47.494719,
                32.310134
              ],
              [
                47.495026,
                32.309758
              ],
              [
                47.495489,
                32.309367
              ],
              [
                47.49583,
                32.308745
              ],
              [
                47.495997,
                32.308596
              ],
              [
                47.496775,
                32.308413
              ],
              [
                47.49714,
                32.308058
              ],
              [
                47.497241,
                32.307656
              ],
              [
                47.497411,
                32.307374
              ],
              [
                47.49776,
                32.307186
              ],
              [
                47.498208,
                32.306741
              ],
              [
                47.498594,
                32.305709
              ],
              [
                47.498589,
                32.304992
              ],
              [
                47.498746,
                32.304687
              ],
              [
                47.499053,
                32.304431
              ],
              [
                47.499328,
                32.304369
              ],
              [
                47.500547,
                32.304322
              ],
              [
                47.501576,
                32.30451
              ],
              [
                47.502388,
                32.304572
              ],
              [
                47.502872,
                32.304813
              ],
              [
                47.503212,
                32.305086
              ],
              [
                47.503251,
                32.305495
              ],
              [
                47.503502,
                32.305664
              ],
              [
                47.503962,
                32.305758
              ],
              [
                47.504392,
                32.305442
              ],
              [
                47.505379,
                32.305153
              ],
              [
                47.50629,
                32.30533
              ],
              [
                47.506693,
                32.305176
              ],
              [
                47.507228,
                32.304942
              ],
              [
                47.507696,
                32.304481
              ],
              [
                47.508077,
                32.303866
              ],
              [
                47.508427,
                32.303772
              ],
              [
                47.509183,
                32.303681
              ],
              [
                47.509893,
                32.303963
              ],
              [
                47.510735,
                32.304228
              ],
              [
                47.511411,
                32.304353
              ],
              [
                47.511985,
                32.304528
              ],
              [
                47.513467,
                32.304666
              ],
              [
                47.515225,
                32.304661
              ],
              [
                47.51617,
                32.304706
              ],
              [
                47.516875,
                32.304593
              ],
              [
                47.517342,
                32.304566
              ],
              [
                47.517911,
                32.304603
              ],
              [
                47.51833,
                32.304887
              ],
              [
                47.518891,
                32.305014
              ],
              [
                47.519494,
                32.304516
              ],
              [
                47.520189,
                32.303611
              ],
              [
                47.520613,
                32.302755
              ],
              [
                47.521044,
                32.302212
              ],
              [
                47.521542,
                32.30172
              ],
              [
                47.521772,
                32.301056
              ],
              [
                47.521833,
                32.300038
              ],
              [
                47.521498,
                32.29894
              ],
              [
                47.521711,
                32.297749
              ],
              [
                47.521613,
                32.2972
              ],
              [
                47.520965,
                32.296397
              ],
              [
                47.521262,
                32.295985
              ],
              [
                47.52145,
                32.295624
              ],
              [
                47.521196,
                32.29504
              ],
              [
                47.520761,
                32.29452
              ],
              [
                47.52057,
                32.293855
              ],
              [
                47.52137,
                32.292768
              ],
              [
                47.521431,
                32.291372
              ],
              [
                47.521616,
                32.290798
              ],
              [
                47.52166,
                32.290066
              ],
              [
                47.521643,
                32.289565
              ],
              [
                47.521554,
                32.289286
              ],
              [
                47.520525,
                32.289475
              ],
              [
                47.519884,
                32.28925
              ],
              [
                47.519237,
                32.289202
              ],
              [
                47.517334,
                32.28895
              ],
              [
                47.516831,
                32.289071
              ],
              [
                47.516478,
                32.289216
              ],
              [
                47.515333,
                32.288904
              ],
              [
                47.514356,
                32.288707
              ],
              [
                47.513762,
                32.28875
              ],
              [
                47.512889,
                32.288717
              ],
              [
                47.512149,
                32.288578
              ],
              [
                47.511377,
                32.288609
              ],
              [
                47.510749,
                32.288696
              ],
              [
                47.510166,
                32.288661
              ],
              [
                47.509742,
                32.288271
              ],
              [
                47.509416,
                32.287731
              ],
              [
                47.509297,
                32.286815
              ],
              [
                47.509108,
                32.286213
              ],
              [
                47.509249,
                32.285791
              ],
              [
                47.509533,
                32.2853
              ],
              [
                47.509321,
                32.284758
              ],
              [
                47.509157,
                32.284076
              ],
              [
                47.509136,
                32.283331
              ],
              [
                47.509038,
                32.282524
              ],
              [
                47.508382,
                32.281312
              ],
              [
                47.507767,
                32.280982
              ],
              [
                47.507293,
                32.280953
              ],
              [
                47.506767,
                32.280757
              ],
              [
                47.506108,
                32.280869
              ],
              [
                47.505744,
                32.280883
              ],
              [
                47.505479,
                32.280716
              ],
              [
                47.505525,
                32.280368
              ],
              [
                47.505306,
                32.280118
              ],
              [
                47.504867,
                32.280051
              ],
              [
                47.504204,
                32.280233
              ],
              [
                47.503689,
                32.280255
              ],
              [
                47.503344,
                32.280455
              ],
              [
                47.502999,
                32.280567
              ],
              [
                47.502687,
                32.28034
              ],
              [
                47.502216,
                32.27963
              ],
              [
                47.502683,
                32.279018
              ],
              [
                47.502731,
                32.278708
              ],
              [
                47.502511,
                32.278571
              ],
              [
                47.502111,
                32.278415
              ],
              [
                47.501645,
                32.27848
              ],
              [
                47.501086,
                32.278794
              ],
              [
                47.500588,
                32.278794
              ],
              [
                47.499889,
                32.278113
              ],
              [
                47.499849,
                32.277875
              ],
              [
                47.500087,
                32.277763
              ],
              [
                47.500522,
                32.277786
              ],
              [
                47.500968,
                32.277505
              ],
              [
                47.501187,
                32.277233
              ],
              [
                47.50153,
                32.277027
              ],
              [
                47.501953,
                32.277034
              ],
              [
                47.502089,
                32.276739
              ],
              [
                47.502122,
                32.276544
              ],
              [
                47.502681,
                32.275764
              ],
              [
                47.503194,
                32.275415
              ],
              [
                47.504141,
                32.274597
              ],
              [
                47.504154,
                32.274123
              ],
              [
                47.504899,
                32.273234
              ],
              [
                47.505387,
                32.272795
              ],
              [
                47.505953,
                32.272473
              ],
              [
                47.506332,
                32.272198
              ],
              [
                47.506567,
                32.271785
              ],
              [
                47.507065,
                32.271293
              ],
              [
                47.507422,
                32.27082
              ],
              [
                47.507797,
                32.270734
              ],
              [
                47.50849,
                32.270346
              ],
              [
                47.508879,
                32.269962
              ],
              [
                47.509227,
                32.269484
              ],
              [
                47.509778,
                32.268989
              ],
              [
                47.510623,
                32.268045
              ],
              [
                47.511616,
                32.267402
              ],
              [
                47.511871,
                32.266948
              ],
              [
                47.512883,
                32.265968
              ],
              [
                47.512968,
                32.265537
              ],
              [
                47.513166,
                32.265099
              ],
              [
                47.513258,
                32.264692
              ],
              [
                47.513709,
                32.264341
              ],
              [
                47.514286,
                32.263747
              ],
              [
                47.514906,
                32.26334
              ],
              [
                47.515291,
                32.262913
              ],
              [
                47.515836,
                32.262545
              ],
              [
                47.515865,
                32.262275
              ],
              [
                47.515954,
                32.262033
              ],
              [
                47.516304,
                32.261851
              ],
              [
                47.516541,
                32.261909
              ],
              [
                47.516777,
                32.262106
              ],
              [
                47.517168,
                32.262225
              ],
              [
                47.51752,
                32.262257
              ],
              [
                47.517775,
                32.262381
              ],
              [
                47.518181,
                32.262328
              ],
              [
                47.518489,
                32.26187
              ],
              [
                47.518887,
                32.261434
              ],
              [
                47.519178,
                32.260973
              ],
              [
                47.519265,
                32.260605
              ],
              [
                47.519946,
                32.260143
              ],
              [
                47.520108,
                32.259799
              ],
              [
                47.520104,
                32.259492
              ],
              [
                47.519728,
                32.259112
              ],
              [
                47.519877,
                32.258865
              ],
              [
                47.520391,
                32.258465
              ],
              [
                47.520621,
                32.258002
              ],
              [
                47.520969,
                32.25755
              ],
              [
                47.522094,
                32.256537
              ],
              [
                47.522631,
                32.255931
              ],
              [
                47.523497,
                32.254807
              ],
              [
                47.523563,
                32.254506
              ],
              [
                47.523515,
                32.253947
              ],
              [
                47.52377,
                32.253638
              ],
              [
                47.523772,
                32.253297
              ],
              [
                47.524011,
                32.252927
              ],
              [
                47.524906,
                32.252346
              ],
              [
                47.525025,
                32.251865
              ],
              [
                47.525273,
                32.2515
              ],
              [
                47.525527,
                32.251247
              ],
              [
                47.52659,
                32.250868
              ],
              [
                47.526682,
                32.25026
              ],
              [
                47.526983,
                32.249892
              ],
              [
                47.52748,
                32.249545
              ],
              [
                47.52782,
                32.248917
              ],
              [
                47.528171,
                32.248622
              ],
              [
                47.528696,
                32.248409
              ],
              [
                47.529161,
                32.248112
              ],
              [
                47.529369,
                32.247684
              ],
              [
                47.529729,
                32.247192
              ],
              [
                47.530526,
                32.246647
              ],
              [
                47.530754,
                32.24626
              ],
              [
                47.530851,
                32.245846
              ],
              [
                47.531741,
                32.24507
              ],
              [
                47.532525,
                32.244099
              ],
              [
                47.533046,
                32.243843
              ],
              [
                47.533447,
                32.243362
              ],
              [
                47.533581,
                32.242822
              ],
              [
                47.53382,
                32.242395
              ],
              [
                47.533917,
                32.24195
              ],
              [
                47.533907,
                32.241536
              ],
              [
                47.534187,
                32.24097
              ],
              [
                47.535254,
                32.239999
              ],
              [
                47.537019,
                32.237871
              ],
              [
                47.537776,
                32.237232
              ],
              [
                47.538391,
                32.236109
              ],
              [
                47.538623,
                32.23586
              ],
              [
                47.539488,
                32.23563
              ],
              [
                47.539938,
                32.235247
              ],
              [
                47.539912,
                32.234887
              ],
              [
                47.539954,
                32.234464
              ],
              [
                47.540156,
                32.234302
              ],
              [
                47.540597,
                32.234179
              ],
              [
                47.54096,
                32.233988
              ],
              [
                47.541314,
                32.23356
              ],
              [
                47.541433,
                32.233168
              ],
              [
                47.541208,
                32.23278
              ],
              [
                47.541108,
                32.23237
              ],
              [
                47.541377,
                32.231969
              ],
              [
                47.541681,
                32.231644
              ],
              [
                47.541915,
                32.231574
              ],
              [
                47.542209,
                32.231644
              ],
              [
                47.542511,
                32.232091
              ],
              [
                47.542491,
                32.232274
              ],
              [
                47.54309,
                32.232629
              ],
              [
                47.543449,
                32.232688
              ],
              [
                47.544042,
                32.232629
              ],
              [
                47.544179,
                32.232755
              ],
              [
                47.544416,
                32.232826
              ],
              [
                47.545122,
                32.232804
              ],
              [
                47.545392,
                32.233001
              ],
              [
                47.546335,
                32.23305
              ],
              [
                47.54656,
                32.232905
              ],
              [
                47.54672,
                32.232858
              ],
              [
                47.546959,
                32.232891
              ],
              [
                47.54717,
                32.232995
              ],
              [
                47.54739,
                32.233003
              ],
              [
                47.548712,
                32.232662
              ],
              [
                47.549344,
                32.23271
              ],
              [
                47.550074,
                32.232995
              ],
              [
                47.551132,
                32.233306
              ],
              [
                47.552055,
                32.233367
              ],
              [
                47.552543,
                32.233261
              ],
              [
                47.553477,
                32.233189
              ],
              [
                47.553944,
                32.233086
              ],
              [
                47.554523,
                32.23302
              ],
              [
                47.556252,
                32.231917
              ],
              [
                47.556837,
                32.231699
              ],
              [
                47.557252,
                32.231748
              ],
              [
                47.557755,
                32.231696
              ],
              [
                47.558137,
                32.231448
              ],
              [
                47.558474,
                32.231161
              ],
              [
                47.560095,
                32.230823
              ],
              [
                47.560549,
                32.230412
              ],
              [
                47.560774,
                32.230088
              ],
              [
                47.561168,
                32.2298
              ],
              [
                47.561713,
                32.229561
              ],
              [
                47.562925,
                32.229193
              ],
              [
                47.563337,
                32.229015
              ],
              [
                47.56371,
                32.228646
              ],
              [
                47.564563,
                32.227119
              ],
              [
                47.565223,
                32.226075
              ],
              [
                47.565506,
                32.225864
              ],
              [
                47.565986,
                32.225769
              ],
              [
                47.566522,
                32.225541
              ],
              [
                47.56696,
                32.225089
              ],
              [
                47.567118,
                32.224669
              ],
              [
                47.566886,
                32.223095
              ],
              [
                47.56713,
                32.222324
              ],
              [
                47.567456,
                32.221496
              ],
              [
                47.567692,
                32.220717
              ],
              [
                47.567893,
                32.220454
              ],
              [
                47.568747,
                32.218866
              ],
              [
                47.569285,
                32.217754
              ],
              [
                47.569513,
                32.217052
              ],
              [
                47.570273,
                32.21515
              ],
              [
                47.570527,
                32.214263
              ],
              [
                47.570578,
                32.213414
              ],
              [
                47.570558,
                32.212534
              ],
              [
                47.570467,
                32.212168
              ],
              [
                47.570489,
                32.211838
              ],
              [
                47.570415,
                32.211516
              ],
              [
                47.570488,
                32.210988
              ],
              [
                47.57042,
                32.210797
              ],
              [
                47.570176,
                32.210482
              ],
              [
                47.569369,
                32.209601
              ],
              [
                47.56916,
                32.20894
              ],
              [
                47.569242,
                32.208448
              ],
              [
                47.569504,
                32.208005
              ],
              [
                47.569456,
                32.207735
              ],
              [
                47.569261,
                32.207604
              ],
              [
                47.568913,
                32.207548
              ],
              [
                47.568537,
                32.207384
              ],
              [
                47.568372,
                32.206979
              ],
              [
                47.568424,
                32.206743
              ],
              [
                47.568662,
                32.206493
              ],
              [
                47.568626,
                32.206353
              ],
              [
                47.568375,
                32.206166
              ],
              [
                47.568029,
                32.206006
              ],
              [
                47.56774,
                32.205954
              ],
              [
                47.567408,
                32.205829
              ],
              [
                47.566567,
                32.205295
              ],
              [
                47.566257,
                32.205166
              ],
              [
                47.565611,
                32.204479
              ],
              [
                47.565043,
                32.20357
              ],
              [
                47.564889,
                32.203163
              ],
              [
                47.564807,
                32.201439
              ],
              [
                47.564859,
                32.200613
              ],
              [
                47.564776,
                32.199282
              ],
              [
                47.564876,
                32.198116
              ],
              [
                47.564893,
                32.197249
              ],
              [
                47.56477,
                32.196326
              ],
              [
                47.564619,
                32.195645
              ],
              [
                47.564687,
                32.195057
              ],
              [
                47.565245,
                32.194475
              ],
              [
                47.565381,
                32.193709
              ],
              [
                47.565278,
                32.193232
              ],
              [
                47.564708,
                32.192942
              ],
              [
                47.564148,
                32.192367
              ],
              [
                47.563446,
                32.191817
              ],
              [
                47.562793,
                32.191126
              ],
              [
                47.562157,
                32.190782
              ],
              [
                47.560477,
                32.19018
              ],
              [
                47.560079,
                32.189978
              ],
              [
                47.559733,
                32.189865
              ],
              [
                47.559361,
                32.189823
              ],
              [
                47.558821,
                32.189541
              ],
              [
                47.558538,
                32.189469
              ],
              [
                47.557933,
                32.188071
              ],
              [
                47.557814,
                32.187903
              ],
              [
                47.557431,
                32.187929
              ],
              [
                47.557123,
                32.188155
              ],
              [
                47.556817,
                32.188124
              ],
              [
                47.556594,
                32.187975
              ],
              [
                47.556201,
                32.188098
              ],
              [
                47.555927,
                32.188057
              ],
              [
                47.555392,
                32.187794
              ],
              [
                47.555002,
                32.187708
              ],
              [
                47.554783,
                32.187553
              ],
              [
                47.554586,
                32.187503
              ],
              [
                47.55408,
                32.187566
              ],
              [
                47.553696,
                32.187521
              ],
              [
                47.553271,
                32.187347
              ],
              [
                47.553145,
                32.187025
              ],
              [
                47.552922,
                32.186658
              ],
              [
                47.55295,
                32.186394
              ],
              [
                47.553245,
                32.185774
              ],
              [
                47.553078,
                32.185771
              ],
              [
                47.551857,
                32.186169
              ],
              [
                47.550783,
                32.185884
              ],
              [
                47.550202,
                32.185856
              ],
              [
                47.549793,
                32.18574
              ],
              [
                47.549172,
                32.184935
              ],
              [
                47.549097,
                32.184627
              ],
              [
                47.549158,
                32.184404
              ],
              [
                47.549541,
                32.183811
              ],
              [
                47.548646,
                32.183508
              ],
              [
                47.5484,
                32.183359
              ],
              [
                47.548254,
                32.183177
              ],
              [
                47.547908,
                32.182497
              ],
              [
                47.547207,
                32.182387
              ],
              [
                47.546881,
                32.182152
              ],
              [
                47.546338,
                32.181985
              ],
              [
                47.5462,
                32.181835
              ],
              [
                47.546203,
                32.18156
              ],
              [
                47.546331,
                32.181353
              ],
              [
                47.545712,
                32.180595
              ],
              [
                47.544929,
                32.180131
              ],
              [
                47.544503,
                32.180126
              ],
              [
                47.544176,
                32.180039
              ],
              [
                47.543865,
                32.180142
              ],
              [
                47.542733,
                32.180051
              ],
              [
                47.541924,
                32.179705
              ],
              [
                47.541509,
                32.179675
              ],
              [
                47.541174,
                32.179452
              ],
              [
                47.540849,
                32.17909
              ],
              [
                47.5406,
                32.178671
              ],
              [
                47.54024,
                32.178372
              ],
              [
                47.540138,
                32.177984
              ],
              [
                47.539982,
                32.177809
              ],
              [
                47.539182,
                32.177711
              ],
              [
                47.538822,
                32.177587
              ],
              [
                47.538581,
                32.177436
              ],
              [
                47.53833,
                32.176924
              ],
              [
                47.538121,
                32.176805
              ],
              [
                47.537649,
                32.176649
              ],
              [
                47.537421,
                32.176458
              ],
              [
                47.53707,
                32.176087
              ],
              [
                47.536329,
                32.175128
              ],
              [
                47.536359,
                32.174873
              ],
              [
                47.536699,
                32.174552
              ],
              [
                47.537228,
                32.174141
              ],
              [
                47.537456,
                32.174029
              ],
              [
                47.537727,
                32.17399
              ],
              [
                47.537663,
                32.173789
              ],
              [
                47.537448,
                32.173478
              ],
              [
                47.536981,
                32.173141
              ],
              [
                47.536462,
                32.172918
              ],
              [
                47.536033,
                32.172858
              ],
              [
                47.534687,
                32.173278
              ],
              [
                47.534291,
                32.173453
              ],
              [
                47.534108,
                32.173325
              ],
              [
                47.534026,
                32.173103
              ],
              [
                47.533787,
                32.172981
              ],
              [
                47.533331,
                32.173034
              ],
              [
                47.532894,
                32.172947
              ],
              [
                47.53263,
                32.172683
              ],
              [
                47.532226,
                32.172613
              ],
              [
                47.531649,
                32.172665
              ],
              [
                47.531084,
                32.172657
              ],
              [
                47.530628,
                32.172517
              ],
              [
                47.530374,
                32.172359
              ],
              [
                47.530215,
                32.17217
              ],
              [
                47.530152,
                32.171974
              ],
              [
                47.529662,
                32.171358
              ],
              [
                47.529199,
                32.170911
              ],
              [
                47.528784,
                32.170707
              ],
              [
                47.528653,
                32.17058
              ],
              [
                47.528443,
                32.17057
              ],
              [
                47.528032,
                32.170686
              ],
              [
                47.527892,
                32.170546
              ],
              [
                47.527865,
                32.170399
              ],
              [
                47.52796,
                32.17026
              ],
              [
                47.528294,
                32.169982
              ],
              [
                47.528611,
                32.169879
              ],
              [
                47.528922,
                32.169426
              ],
              [
                47.528851,
                32.169203
              ],
              [
                47.529068,
                32.168635
              ],
              [
                47.529038,
                32.16839
              ],
              [
                47.529218,
                32.168136
              ],
              [
                47.529581,
                32.167121
              ],
              [
                47.529321,
                32.166549
              ],
              [
                47.52968,
                32.165909
              ],
              [
                47.529735,
                32.165361
              ],
              [
                47.529856,
                32.165207
              ],
              [
                47.53027,
                32.164972
              ],
              [
                47.530649,
                32.164885
              ],
              [
                47.530829,
                32.164655
              ],
              [
                47.531046,
                32.16454
              ],
              [
                47.531074,
                32.164365
              ],
              [
                47.531168,
                32.164287
              ],
              [
                47.531376,
                32.164226
              ],
              [
                47.531521,
                32.16404
              ],
              [
                47.531835,
                32.16388
              ],
              [
                47.531936,
                32.163696
              ],
              [
                47.531773,
                32.163211
              ],
              [
                47.531719,
                32.162682
              ],
              [
                47.532002,
                32.162381
              ],
              [
                47.532371,
                32.161866
              ],
              [
                47.532417,
                32.161608
              ],
              [
                47.532329,
                32.16125
              ],
              [
                47.532328,
                32.160575
              ],
              [
                47.532496,
                32.159147
              ],
              [
                47.532596,
                32.15894
              ],
              [
                47.532955,
                32.158758
              ],
              [
                47.533311,
                32.158713
              ],
              [
                47.533583,
                32.158527
              ],
              [
                47.533803,
                32.158186
              ],
              [
                47.53374,
                32.157342
              ],
              [
                47.533896,
                32.15628
              ],
              [
                47.534111,
                32.156029
              ],
              [
                47.534489,
                32.15581
              ],
              [
                47.534852,
                32.155684
              ],
              [
                47.535067,
                32.155499
              ],
              [
                47.535217,
                32.155198
              ],
              [
                47.535171,
                32.154961
              ],
              [
                47.535049,
                32.154737
              ],
              [
                47.534715,
                32.154362
              ],
              [
                47.534377,
                32.153516
              ],
              [
                47.53421,
                32.153253
              ],
              [
                47.534159,
                32.152932
              ],
              [
                47.533785,
                32.152559
              ],
              [
                47.533438,
                32.152291
              ],
              [
                47.533311,
                32.151893
              ],
              [
                47.533211,
                32.151104
              ],
              [
                47.532828,
                32.150001
              ],
              [
                47.532492,
                32.14973
              ],
              [
                47.532076,
                32.149502
              ],
              [
                47.531769,
                32.14858
              ],
              [
                47.531247,
                32.148319
              ],
              [
                47.530558,
                32.147691
              ],
              [
                47.530093,
                32.147387
              ],
              [
                47.529527,
                32.146827
              ],
              [
                47.529113,
                32.146306
              ],
              [
                47.528995,
                32.145968
              ],
              [
                47.529037,
                32.145626
              ],
              [
                47.529587,
                32.145253
              ],
              [
                47.529625,
                32.144505
              ],
              [
                47.529792,
                32.143965
              ],
              [
                47.529785,
                32.143702
              ],
              [
                47.529683,
                32.143446
              ],
              [
                47.529479,
                32.143261
              ],
              [
                47.529208,
                32.142908
              ],
              [
                47.529117,
                32.142584
              ],
              [
                47.529067,
                32.142201
              ],
              [
                47.529201,
                32.141752
              ],
              [
                47.529706,
                32.141383
              ],
              [
                47.529855,
                32.141163
              ],
              [
                47.530375,
                32.141046
              ],
              [
                47.530507,
                32.14098
              ],
              [
                47.530707,
                32.141001
              ],
              [
                47.530963,
                32.141144
              ],
              [
                47.531249,
                32.141182
              ],
              [
                47.531659,
                32.141085
              ],
              [
                47.531934,
                32.141126
              ],
              [
                47.53238,
                32.141098
              ],
              [
                47.532944,
                32.140822
              ],
              [
                47.533072,
                32.140634
              ],
              [
                47.533478,
                32.140585
              ],
              [
                47.533874,
                32.140259
              ],
              [
                47.534312,
                32.140067
              ],
              [
                47.534651,
                32.140158
              ],
              [
                47.535318,
                32.140119
              ],
              [
                47.535876,
                32.140189
              ],
              [
                47.536073,
                32.140064
              ],
              [
                47.536111,
                32.139816
              ],
              [
                47.536295,
                32.139339
              ],
              [
                47.536584,
                32.139174
              ],
              [
                47.536886,
                32.139101
              ],
              [
                47.537129,
                32.138912
              ],
              [
                47.537353,
                32.138829
              ],
              [
                47.537479,
                32.138651
              ],
              [
                47.537873,
                32.138448
              ],
              [
                47.538579,
                32.13834
              ],
              [
                47.538906,
                32.138405
              ],
              [
                47.539108,
                32.138387
              ],
              [
                47.539664,
                32.138274
              ],
              [
                47.540836,
                32.137866
              ],
              [
                47.541253,
                32.137881
              ],
              [
                47.541706,
                32.137596
              ],
              [
                47.542553,
                32.137327
              ],
              [
                47.543242,
                32.13735
              ],
              [
                47.543528,
                32.137086
              ],
              [
                47.543711,
                32.137039
              ],
              [
                47.543925,
                32.136916
              ],
              [
                47.544534,
                32.136788
              ],
              [
                47.544915,
                32.136753
              ],
              [
                47.545016,
                32.136678
              ],
              [
                47.545428,
                32.136543
              ],
              [
                47.546297,
                32.136355
              ],
              [
                47.546483,
                32.136236
              ],
              [
                47.546805,
                32.136174
              ],
              [
                47.546928,
                32.136095
              ],
              [
                47.547756,
                32.135838
              ],
              [
                47.54895,
                32.135559
              ],
              [
                47.550073,
                32.135074
              ],
              [
                47.550635,
                32.134638
              ],
              [
                47.551281,
                32.134343
              ],
              [
                47.551301,
                32.134094
              ],
              [
                47.551452,
                32.133666
              ],
              [
                47.551587,
                32.133528
              ],
              [
                47.551878,
                32.133433
              ],
              [
                47.552284,
                32.132756
              ],
              [
                47.552622,
                32.131926
              ],
              [
                47.552779,
                32.131695
              ],
              [
                47.552693,
                32.131587
              ],
              [
                47.552426,
                32.131555
              ],
              [
                47.552276,
                32.131398
              ],
              [
                47.552238,
                32.131192
              ],
              [
                47.552409,
                32.130793
              ],
              [
                47.552548,
                32.130669
              ],
              [
                47.552844,
                32.130616
              ],
              [
                47.553332,
                32.130358
              ],
              [
                47.553786,
                32.130272
              ],
              [
                47.554368,
                32.12989
              ],
              [
                47.554372,
                32.129535
              ],
              [
                47.554161,
                32.128869
              ],
              [
                47.554159,
                32.1286
              ],
              [
                47.554245,
                32.128405
              ],
              [
                47.554576,
                32.128332
              ],
              [
                47.554734,
                32.128214
              ],
              [
                47.554835,
                32.127964
              ],
              [
                47.554554,
                32.127835
              ],
              [
                47.55442,
                32.127675
              ],
              [
                47.554436,
                32.127497
              ],
              [
                47.554815,
                32.12717
              ],
              [
                47.555249,
                32.126492
              ],
              [
                47.555254,
                32.126076
              ],
              [
                47.555433,
                32.125907
              ],
              [
                47.555737,
                32.125819
              ],
              [
                47.556116,
                32.125515
              ],
              [
                47.556433,
                32.125043
              ],
              [
                47.55666,
                32.124596
              ],
              [
                47.557143,
                32.124231
              ],
              [
                47.55728,
                32.123795
              ],
              [
                47.557244,
                32.123528
              ],
              [
                47.557449,
                32.123217
              ],
              [
                47.557424,
                32.122863
              ],
              [
                47.557657,
                32.122613
              ],
              [
                47.558766,
                32.122032
              ],
              [
                47.55906,
                32.122018
              ],
              [
                47.559349,
                32.121937
              ],
              [
                47.559415,
                32.121623
              ],
              [
                47.559573,
                32.121524
              ],
              [
                47.560002,
                32.12141
              ],
              [
                47.560038,
                32.121285
              ],
              [
                47.559745,
                32.120983
              ],
              [
                47.559696,
                32.120624
              ],
              [
                47.559808,
                32.119395
              ],
              [
                47.559745,
                32.118919
              ],
              [
                47.559194,
                32.118853
              ],
              [
                47.559147,
                32.118479
              ],
              [
                47.559037,
                32.11813
              ],
              [
                47.559226,
                32.117803
              ],
              [
                47.559169,
                32.117455
              ],
              [
                47.559214,
                32.117083
              ],
              [
                47.559422,
                32.116696
              ],
              [
                47.559353,
                32.116501
              ],
              [
                47.559077,
                32.116347
              ],
              [
                47.558674,
                32.115994
              ],
              [
                47.558833,
                32.115271
              ],
              [
                47.558923,
                32.11518
              ],
              [
                47.559259,
                32.115148
              ],
              [
                47.560071,
                32.115177
              ],
              [
                47.560396,
                32.115062
              ],
              [
                47.560709,
                32.11503
              ],
              [
                47.561026,
                32.115077
              ],
              [
                47.561406,
                32.115061
              ],
              [
                47.562212,
                32.114832
              ],
              [
                47.562436,
                32.114636
              ],
              [
                47.56265,
                32.114295
              ],
              [
                47.56298,
                32.114241
              ],
              [
                47.56332,
                32.114114
              ],
              [
                47.563592,
                32.113952
              ],
              [
                47.56438,
                32.113197
              ],
              [
                47.564552,
                32.11311
              ],
              [
                47.564995,
                32.112657
              ],
              [
                47.565404,
                32.112532
              ],
              [
                47.565708,
                32.112076
              ],
              [
                47.565933,
                32.112017
              ],
              [
                47.566477,
                32.112161
              ],
              [
                47.566739,
                32.112133
              ],
              [
                47.567336,
                32.111936
              ],
              [
                47.567557,
                32.112014
              ],
              [
                47.567571,
                32.112196
              ],
              [
                47.567977,
                32.112431
              ],
              [
                47.568347,
                32.112416
              ],
              [
                47.568535,
                32.112501
              ],
              [
                47.56937,
                32.112446
              ],
              [
                47.569644,
                32.112354
              ],
              [
                47.570011,
                32.112331
              ],
              [
                47.570603,
                32.112202
              ],
              [
                47.570854,
                32.112261
              ],
              [
                47.570996,
                32.112386
              ],
              [
                47.571361,
                32.112444
              ],
              [
                47.571701,
                32.112468
              ],
              [
                47.572654,
                32.112425
              ],
              [
                47.572982,
                32.112257
              ],
              [
                47.57347,
                32.111802
              ],
              [
                47.574501,
                32.111575
              ],
              [
                47.574991,
                32.111279
              ],
              [
                47.575216,
                32.11122
              ],
              [
                47.575469,
                32.111241
              ],
              [
                47.575729,
                32.111379
              ],
              [
                47.578357,
                32.111659
              ],
              [
                47.57847,
                32.111828
              ],
              [
                47.578208,
                32.112267
              ],
              [
                47.577928,
                32.112317
              ],
              [
                47.577867,
                32.112521
              ],
              [
                47.577928,
                32.112751
              ],
              [
                47.577738,
                32.11305
              ],
              [
                47.577834,
                32.113283
              ],
              [
                47.577981,
                32.113408
              ],
              [
                47.578029,
                32.113522
              ],
              [
                47.577992,
                32.113949
              ],
              [
                47.578051,
                32.114194
              ],
              [
                47.578416,
                32.114379
              ],
              [
                47.578779,
                32.11447
              ],
              [
                47.57894,
                32.114667
              ],
              [
                47.578978,
                32.114963
              ],
              [
                47.578922,
                32.115209
              ],
              [
                47.578753,
                32.115414
              ],
              [
                47.578675,
                32.116009
              ],
              [
                47.579268,
                32.116885
              ],
              [
                47.57961,
                32.116942
              ],
              [
                47.580013,
                32.116903
              ],
              [
                47.580581,
                32.116598
              ],
              [
                47.580927,
                32.116475
              ],
              [
                47.581251,
                32.116464
              ],
              [
                47.581524,
                32.116321
              ],
              [
                47.582277,
                32.116219
              ],
              [
                47.582583,
                32.116075
              ],
              [
                47.582924,
                32.115995
              ],
              [
                47.583064,
                32.115828
              ],
              [
                47.583567,
                32.11578
              ],
              [
                47.583687,
                32.115603
              ],
              [
                47.583666,
                32.115437
              ],
              [
                47.583524,
                32.115203
              ],
              [
                47.584773,
                32.115021
              ],
              [
                47.585669,
                32.115088
              ],
              [
                47.585957,
                32.115027
              ],
              [
                47.586439,
                32.114681
              ],
              [
                47.586773,
                32.114682
              ],
              [
                47.586938,
                32.114591
              ],
              [
                47.587141,
                32.11438
              ],
              [
                47.587143,
                32.11413
              ],
              [
                47.587083,
                32.113923
              ],
              [
                47.587648,
                32.113737
              ],
              [
                47.587859,
                32.113709
              ],
              [
                47.588242,
                32.114075
              ],
              [
                47.588496,
                32.11419
              ],
              [
                47.588955,
                32.115071
              ],
              [
                47.589111,
                32.115227
              ],
              [
                47.589476,
                32.115393
              ],
              [
                47.589564,
                32.115571
              ],
              [
                47.589183,
                32.115908
              ],
              [
                47.589353,
                32.116416
              ],
              [
                47.589674,
                32.116439
              ],
              [
                47.590173,
                32.116717
              ],
              [
                47.590571,
                32.116466
              ],
              [
                47.590891,
                32.116352
              ],
              [
                47.591198,
                32.11632
              ],
              [
                47.591341,
                32.116578
              ],
              [
                47.591255,
                32.116773
              ],
              [
                47.591278,
                32.116944
              ],
              [
                47.591472,
                32.117027
              ],
              [
                47.592287,
                32.11696
              ],
              [
                47.592809,
                32.117155
              ],
              [
                47.593055,
                32.117087
              ],
              [
                47.593257,
                32.117154
              ],
              [
                47.593411,
                32.117131
              ],
              [
                47.593621,
                32.117188
              ],
              [
                47.594348,
                32.117199
              ],
              [
                47.594533,
                32.117227
              ],
              [
                47.594782,
                32.117343
              ],
              [
                47.595189,
                32.117317
              ],
              [
                47.595493,
                32.11747
              ],
              [
                47.595626,
                32.117408
              ],
              [
                47.595749,
                32.117268
              ],
              [
                47.5959,
                32.117231
              ],
              [
                47.596232,
                32.117247
              ],
              [
                47.596547,
                32.117181
              ],
              [
                47.596834,
                32.117224
              ],
              [
                47.59704,
                32.117309
              ],
              [
                47.597505,
                32.117155
              ],
              [
                47.597654,
                32.117005
              ],
              [
                47.597946,
                32.116896
              ],
              [
                47.598503,
                32.117046
              ],
              [
                47.598743,
                32.116956
              ],
              [
                47.598766,
                32.116503
              ],
              [
                47.599258,
                32.116277
              ],
              [
                47.599665,
                32.116322
              ],
              [
                47.599878,
                32.116128
              ],
              [
                47.599931,
                32.115854
              ],
              [
                47.600197,
                32.115579
              ],
              [
                47.600744,
                32.115457
              ],
              [
                47.600947,
                32.115312
              ],
              [
                47.601261,
                32.114788
              ],
              [
                47.601858,
                32.114421
              ],
              [
                47.602111,
                32.114314
              ],
              [
                47.602345,
                32.114375
              ],
              [
                47.602515,
                32.114345
              ],
              [
                47.60288,
                32.11384
              ],
              [
                47.60356,
                32.113481
              ],
              [
                47.604056,
                32.113147
              ],
              [
                47.604287,
                32.113086
              ],
              [
                47.604641,
                32.112862
              ],
              [
                47.604747,
                32.11272
              ],
              [
                47.604907,
                32.112611
              ],
              [
                47.605206,
                32.112505
              ],
              [
                47.606277,
                32.111609
              ],
              [
                47.606844,
                32.111455
              ],
              [
                47.607013,
                32.111571
              ],
              [
                47.60717,
                32.111537
              ],
              [
                47.607622,
                32.111617
              ],
              [
                47.607899,
                32.111732
              ],
              [
                47.608033,
                32.111869
              ],
              [
                47.608164,
                32.111907
              ],
              [
                47.608371,
                32.111798
              ],
              [
                47.608488,
                32.111636
              ],
              [
                47.608441,
                32.11146
              ],
              [
                47.608482,
                32.111226
              ],
              [
                47.608731,
                32.111082
              ],
              [
                47.609327,
                32.11097
              ],
              [
                47.609651,
                32.110784
              ],
              [
                47.610009,
                32.110729
              ],
              [
                47.61006,
                32.110512
              ],
              [
                47.610252,
                32.110326
              ],
              [
                47.610776,
                32.110095
              ],
              [
                47.610947,
                32.10996
              ],
              [
                47.611278,
                32.109868
              ],
              [
                47.611724,
                32.109924
              ],
              [
                47.611965,
                32.109881
              ],
              [
                47.612246,
                32.109901
              ],
              [
                47.612522,
                32.109837
              ],
              [
                47.612658,
                32.109747
              ],
              [
                47.612706,
                32.109493
              ],
              [
                47.613109,
                32.109217
              ],
              [
                47.613738,
                32.109142
              ],
              [
                47.613864,
                32.108968
              ],
              [
                47.613952,
                32.108697
              ],
              [
                47.614509,
                32.108091
              ],
              [
                47.61496,
                32.107717
              ],
              [
                47.615345,
                32.107586
              ],
              [
                47.615554,
                32.107402
              ],
              [
                47.616126,
                32.107049
              ],
              [
                47.616556,
                32.106896
              ],
              [
                47.617118,
                32.106417
              ],
              [
                47.617339,
                32.106344
              ],
              [
                47.617477,
                32.106107
              ],
              [
                47.617598,
                32.106043
              ],
              [
                47.617712,
                32.10589
              ],
              [
                47.618756,
                32.10539
              ],
              [
                47.619572,
                32.104832
              ],
              [
                47.62147,
                32.103803
              ],
              [
                47.621454,
                32.103507
              ],
              [
                47.621848,
                32.10292
              ],
              [
                47.622215,
                32.10258
              ],
              [
                47.622541,
                32.102372
              ],
              [
                47.622673,
                32.102394
              ],
              [
                47.622745,
                32.1025
              ],
              [
                47.623193,
                32.1023
              ],
              [
                47.623378,
                32.101983
              ],
              [
                47.623951,
                32.101621
              ],
              [
                47.624115,
                32.101437
              ],
              [
                47.624028,
                32.101344
              ],
              [
                47.624032,
                32.101101
              ],
              [
                47.624237,
                32.100744
              ],
              [
                47.624284,
                32.100406
              ],
              [
                47.625351,
                32.099217
              ],
              [
                47.62579,
                32.098911
              ],
              [
                47.626123,
                32.098562
              ],
              [
                47.627187,
                32.097925
              ],
              [
                47.627653,
                32.097325
              ],
              [
                47.628403,
                32.096849
              ],
              [
                47.628581,
                32.096389
              ],
              [
                47.62881,
                32.096002
              ],
              [
                47.629037,
                32.095868
              ],
              [
                47.629439,
                32.095728
              ],
              [
                47.630388,
                32.095107
              ],
              [
                47.630702,
                32.094829
              ],
              [
                47.630908,
                32.094616
              ],
              [
                47.631015,
                32.094287
              ],
              [
                47.631393,
                32.094013
              ],
              [
                47.63168,
                32.093398
              ],
              [
                47.6316,
                32.093217
              ],
              [
                47.631684,
                32.093062
              ],
              [
                47.632448,
                32.092733
              ],
              [
                47.633123,
                32.092374
              ],
              [
                47.633434,
                32.092085
              ],
              [
                47.633598,
                32.091762
              ],
              [
                47.633474,
                32.091413
              ],
              [
                47.633368,
                32.091277
              ],
              [
                47.633574,
                32.091178
              ],
              [
                47.633626,
                32.090952
              ],
              [
                47.634094,
                32.090872
              ],
              [
                47.634238,
                32.090965
              ],
              [
                47.634547,
                32.090785
              ],
              [
                47.634452,
                32.090617
              ],
              [
                47.634786,
                32.090206
              ],
              [
                47.635153,
                32.090077
              ],
              [
                47.635222,
                32.089864
              ],
              [
                47.635372,
                32.089816
              ],
              [
                47.635508,
                32.089621
              ],
              [
                47.635825,
                32.089682
              ],
              [
                47.63631,
                32.089388
              ],
              [
                47.636406,
                32.089206
              ],
              [
                47.636576,
                32.089304
              ],
              [
                47.63676,
                32.089312
              ],
              [
                47.637005,
                32.089175
              ],
              [
                47.637217,
                32.088961
              ],
              [
                47.637419,
                32.088873
              ],
              [
                47.637593,
                32.088583
              ],
              [
                47.637744,
                32.088611
              ],
              [
                47.638134,
                32.088418
              ],
              [
                47.639074,
                32.088109
              ],
              [
                47.639746,
                32.087827
              ],
              [
                47.640243,
                32.087505
              ],
              [
                47.640619,
                32.087182
              ],
              [
                47.641479,
                32.086981
              ],
              [
                47.641939,
                32.086776
              ],
              [
                47.642036,
                32.086535
              ],
              [
                47.642084,
                32.086173
              ],
              [
                47.642325,
                32.085883
              ],
              [
                47.642711,
                32.085642
              ],
              [
                47.643267,
                32.085473
              ],
              [
                47.644256,
                32.085062
              ],
              [
                47.644497,
                32.084869
              ],
              [
                47.645414,
                32.084459
              ],
              [
                47.645511,
                32.084314
              ],
              [
                47.646235,
                32.084194
              ],
              [
                47.64679,
                32.083639
              ],
              [
                47.647104,
                32.083542
              ],
              [
                47.647683,
                32.082987
              ],
              [
                47.64831,
                32.08289
              ],
              [
                47.648576,
                32.082963
              ],
              [
                47.64901,
                32.08318
              ],
              [
                47.649252,
                32.083156
              ],
              [
                47.649541,
                32.082987
              ],
              [
                47.650072,
                32.082529
              ],
              [
                47.650386,
                32.082384
              ],
              [
                47.650555,
                32.082094
              ],
              [
                47.650965,
                32.083276
              ],
              [
                47.651042,
                32.082347
              ],
              [
                47.65071,
                32.081339
              ],
              [
                47.650692,
                32.079986
              ],
              [
                47.650982,
                32.077695
              ],
              [
                47.651158,
                32.076972
              ],
              [
                47.651213,
                32.076333
              ],
              [
                47.651296,
                32.076009
              ],
              [
                47.651611,
                32.075292
              ],
              [
                47.652696,
                32.07363
              ],
              [
                47.653355,
                32.072836
              ],
              [
                47.653669,
                32.072299
              ],
              [
                47.653816,
                32.071958
              ],
              [
                47.65414,
                32.070687
              ],
              [
                47.65409,
                32.070521
              ],
              [
                47.653978,
                32.070407
              ],
              [
                47.653459,
                32.070249
              ],
              [
                47.653337,
                32.070121
              ],
              [
                47.65315,
                32.069727
              ],
              [
                47.652719,
                32.069217
              ],
              [
                47.652698,
                32.068741
              ],
              [
                47.652526,
                32.067911
              ],
              [
                47.652245,
                32.067163
              ],
              [
                47.65195,
                32.066649
              ],
              [
                47.651526,
                32.066138
              ],
              [
                47.650133,
                32.064961
              ],
              [
                47.649937,
                32.064698
              ],
              [
                47.649216,
                32.063219
              ],
              [
                47.648629,
                32.062196
              ],
              [
                47.648467,
                32.062133
              ],
              [
                47.647993,
                32.062141
              ],
              [
                47.647789,
                32.062034
              ],
              [
                47.647548,
                32.061974
              ],
              [
                47.647319,
                32.061541
              ],
              [
                47.647088,
                32.061356
              ],
              [
                47.646836,
                32.060767
              ],
              [
                47.64657,
                32.060475
              ],
              [
                47.646016,
                32.060091
              ],
              [
                47.646058,
                32.059732
              ],
              [
                47.646158,
                32.059498
              ],
              [
                47.646696,
                32.058885
              ],
              [
                47.647166,
                32.058624
              ],
              [
                47.647668,
                32.058255
              ],
              [
                47.648035,
                32.057796
              ],
              [
                47.648316,
                32.057302
              ],
              [
                47.649011,
                32.056433
              ],
              [
                47.650231,
                32.055418
              ],
              [
                47.650855,
                32.055078
              ],
              [
                47.65209,
                32.053885
              ],
              [
                47.652556,
                32.053564
              ],
              [
                47.653248,
                32.053294
              ],
              [
                47.653458,
                32.053142
              ],
              [
                47.653578,
                32.052419
              ],
              [
                47.653915,
                32.052131
              ],
              [
                47.65425,
                32.051978
              ],
              [
                47.654606,
                32.051903
              ],
              [
                47.655172,
                32.051584
              ],
              [
                47.655544,
                32.051475
              ],
              [
                47.656158,
                32.051426
              ],
              [
                47.657255,
                32.051124
              ],
              [
                47.658461,
                32.050431
              ],
              [
                47.658726,
                32.050342
              ],
              [
                47.659045,
                32.050408
              ],
              [
                47.65938,
                32.050306
              ],
              [
                47.660582,
                32.049408
              ],
              [
                47.661217,
                32.049251
              ],
              [
                47.661912,
                32.048806
              ],
              [
                47.662449,
                32.048564
              ],
              [
                47.6627,
                32.048518
              ],
              [
                47.663834,
                32.048633
              ],
              [
                47.664111,
                32.048542
              ],
              [
                47.6644396,
                32.0488708
              ],
              [
                47.6646987,
                32.0491255
              ],
              [
                47.6651397,
                32.0493721
              ],
              [
                47.6656316,
                32.0496671
              ],
              [
                47.7001868,
                32.0648534
              ],
              [
                47.7326755,
                32.0791152
              ],
              [
                47.7500797,
                32.0867543
              ],
              [
                47.7558687,
                32.0888433
              ],
              [
                47.7605285,
                32.0907703
              ],
              [
                47.7670287,
                32.0933459
              ],
              [
                47.7724457,
                32.0959656
              ],
              [
                47.7782975,
                32.0987743
              ],
              [
                47.7818756,
                32.1004295
              ],
              [
                47.7839936,
                32.1014906
              ],
              [
                47.7851791,
                32.1020845
              ],
              [
                47.7884331,
                32.1034653
              ],
              [
                47.7930374,
                32.1058585
              ],
              [
                47.7981873,
                32.1086192
              ],
              [
                47.8020364,
                32.111011
              ],
              [
                47.8050728,
                32.1130373
              ],
              [
                47.8100625,
                32.116073
              ],
              [
                47.8107982,
                32.1166055
              ],
              [
                47.8143997,
                32.1192025
              ],
              [
                47.8186303,
                32.1218717
              ],
              [
                47.8213958,
                32.1241275
              ],
              [
                47.8265496,
                32.1279443
              ],
              [
                47.8309441,
                32.1310724
              ],
              [
                47.8388139,
                32.1374699
              ],
              [
                47.8463593,
                32.1446499
              ],
              [
                47.8503762,
                32.1480092
              ],
              [
                47.8576547,
                32.1550512
              ],
              [
                47.8650436,
                32.162738
              ],
              [
                47.8685798,
                32.1673402
              ],
              [
                47.8729857,
                32.1731878
              ],
              [
                47.8782616,
                32.1800913
              ],
              [
                47.8802185,
                32.1823011
              ],
              [
                47.8816871,
                32.1840977
              ],
              [
                47.8835907,
                32.1858441
              ],
              [
                47.8860893,
                32.1876864
              ],
              [
                47.8900528,
                32.1902205
              ],
              [
                47.8904231,
                32.19042
              ],
              [
                47.8954316,
                32.1931183
              ],
              [
                47.9031983,
                32.1975396
              ],
              [
                47.9075966,
                32.1999329
              ],
              [
                47.9118881,
                32.2025104
              ],
              [
                47.9158553,
                32.2051814
              ],
              [
                47.9182472,
                32.2069775
              ],
              [
                47.9212913,
                32.2094658
              ],
              [
                47.925045,
                32.2125978
              ],
              [
                47.9283103,
                32.2156795
              ],
              [
                47.9316292,
                32.2190443
              ],
              [
                47.9352799,
                32.2231405
              ],
              [
                47.9385491,
                32.2282484
              ],
              [
                47.9417152,
                32.2335431
              ],
              [
                47.942245,
                32.2343375
              ],
              [
                47.9434051,
                32.2360769
              ],
              [
                47.9453125,
                32.2384717
              ],
              [
                47.9485816,
                32.24165
              ],
              [
                47.9517365,
                32.2440906
              ],
              [
                47.9552192,
                32.2467622
              ],
              [
                47.9564797,
                32.2476356
              ],
              [
                47.9598738,
                32.2499872
              ],
              [
                47.9620591,
                32.2520436
              ],
              [
                47.9643631,
                32.2537309
              ],
              [
                47.9681892,
                32.2555922
              ],
              [
                47.9727859,
                32.2581369
              ],
              [
                47.9751319,
                32.259133
              ],
              [
                47.9759483,
                32.2594028
              ],
              [
                47.9770354,
                32.25967
              ],
              [
                47.9781799,
                32.2598913
              ],
              [
                47.9795952,
                32.2603421
              ],
              [
                47.9813995,
                32.2612486
              ],
              [
                47.9830932,
                32.2620667
              ],
              [
                47.9840813,
                32.2627485
              ],
              [
                47.9850235,
                32.2638935
              ],
              [
                47.9856416,
                32.2651818
              ],
              [
                47.9860992,
                32.2667007
              ],
              [
                47.9866752,
                32.2686393
              ],
              [
                47.9869232,
                32.2703899
              ],
              [
                47.9870606,
                32.2720025
              ],
              [
                47.987194,
                32.2732972
              ],
              [
                47.9870987,
                32.274174
              ],
              [
                47.9870034,
                32.2749133
              ],
              [
                47.9866448,
                32.2760746
              ],
              [
                47.9861221,
                32.2770922
              ],
              [
                47.9858627,
                32.2777396
              ],
              [
                47.9849549,
                32.2785339
              ],
              [
                47.9836159,
                32.2795139
              ],
              [
                47.9810371,
                32.2807844
              ],
              [
                47.9806177,
                32.2810063
              ],
              [
                47.9772225,
                32.2828028
              ],
              [
                47.9723396,
                32.2856181
              ],
              [
                47.9681548,
                32.288148
              ],
              [
                47.9656447,
                32.2901546
              ],
              [
                47.9630279,
                32.292438
              ],
              [
                47.9624443,
                32.2933661
              ],
              [
                47.9619751,
                32.2943871
              ],
              [
                47.9617768,
                32.2954034
              ],
              [
                47.9618987,
                32.2962809
              ],
              [
                47.9621429,
                32.2977113
              ],
              [
                47.9625512,
                32.2995063
              ],
              [
                47.9627876,
                32.3005668
              ],
              [
                47.9633637,
                32.3026386
              ],
              [
                47.9638901,
                32.3048962
              ],
              [
                47.9643098,
                32.3070634
              ],
              [
                47.9647218,
                32.3090929
              ],
              [
                47.9655799,
                32.311532
              ],
              [
                47.9670754,
                32.3166462
              ],
              [
                47.969574,
                32.3230445
              ],
              [
                47.9717102,
                32.3274573
              ],
              [
                47.9746055,
                32.3317259
              ],
              [
                47.9760476,
                32.3335637
              ],
              [
                47.9778594,
                32.3347477
              ],
              [
                47.9812584,
                32.3367991
              ],
              [
                47.9848061,
                32.3380155
              ],
              [
                47.9890137,
                32.3395992
              ],
              [
                47.9963929,
                32.3424035
              ],
              [
                48.0000037,
                32.3437787
              ],
              [
                48.0008122,
                32.3442443
              ],
              [
                48.0046012,
                32.3461353
              ],
              [
                48.0085144,
                32.3473665
              ],
              [
                48.0135651,
                32.347714
              ],
              [
                48.0175934,
                32.3482016
              ],
              [
                48.020977,
                32.3483695
              ],
              [
                48.0260811,
                32.3491279
              ],
              [
                48.0290909,
                32.3495303
              ],
              [
                48.0312957,
                32.3501164
              ],
              [
                48.0322647,
                32.3503421
              ],
              [
                48.0335046,
                32.3511647
              ],
              [
                48.0342637,
                32.3521766
              ],
              [
                48.0348587,
                32.3530043
              ],
              [
                48.0354539,
                32.3539695
              ],
              [
                48.0356255,
                32.3553508
              ],
              [
                48.0356369,
                32.357285
              ],
              [
                48.0354385,
                32.3597755
              ],
              [
                48.0345955,
                32.3621292
              ],
              [
                48.0332718,
                32.3654092
              ],
              [
                48.0324859,
                32.3682713
              ],
              [
                48.0316505,
                32.3723292
              ],
              [
                48.0311241,
                32.3742665
              ],
              [
                48.030491,
                32.3763005
              ],
              [
                48.0292741,
                32.379486
              ],
              [
                48.0271415,
                32.3826296
              ],
              [
                48.0257073,
                32.3852645
              ],
              [
                48.0243263,
                32.3881756
              ],
              [
                48.0233115,
                32.3897024
              ],
              [
                48.022892,
                32.3915476
              ],
              [
                48.0221062,
                32.395194
              ],
              [
                48.0214232,
                32.3980111
              ],
              [
                48.0200082,
                32.4050214
              ],
              [
                48.0195504,
                32.4096786
              ],
              [
                48.0194015,
                32.4119832
              ],
              [
                48.0187225,
                32.4155397
              ],
              [
                48.0182038,
                32.4189061
              ],
              [
                48.0188942,
                32.4270594
              ],
              [
                48.019291,
                32.4306076
              ],
              [
                48.0193673,
                32.4344795
              ],
              [
                48.0197144,
                32.4382091
              ],
              [
                48.0201607,
                32.4412039
              ],
              [
                48.0212592,
                32.4446109
              ],
              [
                48.0220871,
                32.4481084
              ],
              [
                48.0225334,
                32.4506412
              ],
              [
                48.0229226,
                32.4528052
              ],
              [
                48.0228843,
                32.4549253
              ],
              [
                48.022892,
                32.4566769
              ],
              [
                48.0224724,
                32.4588443
              ],
              [
                48.0223846,
                32.4620248
              ],
              [
                48.022129,
                32.4649309
              ],
              [
                48.0218849,
                32.4691739
              ],
              [
                48.0216904,
                32.4725841
              ],
              [
                48.0217094,
                32.4758573
              ],
              [
                48.0215072,
                32.4786272
              ],
              [
                48.0213547,
                32.4805147
              ],
              [
                48.020939,
                32.4828219
              ],
              [
                48.0208398,
                32.4848978
              ],
              [
                48.020588,
                32.4877093
              ],
              [
                48.0203819,
                32.4896022
              ],
              [
                48.0201188,
                32.4912144
              ],
              [
                48.0202407,
                32.4935186
              ],
              [
                48.0204696,
                32.4957306
              ],
              [
                48.0206565,
                32.5000604
              ],
              [
                48.0206565,
                32.5016022
              ],
              [
                48.0206794,
                32.5030295
              ],
              [
                48.0205917,
                32.5044136
              ],
              [
                48.0205039,
                32.5057075
              ],
              [
                48.0203553,
                32.5066755
              ],
              [
                48.0200997,
                32.5075981
              ],
              [
                48.0198975,
                32.5085264
              ],
              [
                48.0198957,
                32.5085354
              ],
              [
                48.0197983,
                32.5090335
              ],
              [
                48.0191041,
                32.5097766
              ],
              [
                48.0182458,
                32.5103333
              ],
              [
                48.0175552,
                32.5112613
              ],
              [
                48.0168113,
                32.5124202
              ],
              [
                48.0163384,
                32.513439
              ],
              [
                48.015976,
                32.5144582
              ],
              [
                48.0159301,
                32.5150116
              ],
              [
                48.0157204,
                32.5154259
              ],
              [
                48.0153961,
                32.5156143
              ],
              [
                48.0149651,
                32.5158001
              ],
              [
                48.0147018,
                32.516265
              ],
              [
                48.0145493,
                32.5169601
              ],
              [
                48.0145607,
                32.5176501
              ],
              [
                48.0148392,
                32.5181075
              ],
              [
                48.0152321,
                32.5187524
              ],
              [
                48.0154489,
                32.5191301
              ],
              [
                48.0157318,
                32.5196231
              ],
              [
                48.016182,
                32.520497
              ],
              [
                48.0163041,
                32.5214646
              ],
              [
                48.0162659,
                32.5223878
              ],
              [
                48.0160638,
                32.5233567
              ],
              [
                48.0156975,
                32.5242384
              ],
              [
                48.0146828,
                32.5251654
              ],
              [
                48.0129776,
                32.5271197
              ],
              [
                48.0119158,
                32.5279594
              ],
              [
                48.0111542,
                32.5285617
              ],
              [
                48.0098152,
                32.529632
              ],
              [
                48.0091745,
                32.5302205
              ],
              [
                48.0079422,
                32.5313523
              ],
              [
                48.0064964,
                32.5326116
              ],
              [
                48.0057411,
                32.5330309
              ],
              [
                48.0043374,
                32.5334122
              ],
              [
                48.0029297,
                32.5336986
              ],
              [
                48.001091,
                32.5340379
              ],
              [
                47.9999885,
                32.5342753
              ],
              [
                47.9975361,
                32.5349377
              ],
              [
                47.9969368,
                32.5350995
              ],
              [
                47.9935607,
                32.5354696
              ],
              [
                47.9898032,
                32.5357019
              ],
              [
                47.986805,
                32.5357923
              ],
              [
                47.9846267,
                32.5359339
              ],
              [
                47.9842686,
                32.5359781
              ],
              [
                47.9823951,
                32.5362094
              ],
              [
                47.9813614,
                32.536304
              ],
              [
                47.9805985,
                32.5363511
              ],
              [
                47.9799423,
                32.5361663
              ],
              [
                47.9793968,
                32.535939
              ],
              [
                47.9789581,
                32.5354777
              ],
              [
                47.9786835,
                32.5349234
              ],
              [
                47.978569,
                32.5343278
              ],
              [
                47.9785651,
                32.5337305
              ],
              [
                47.9785614,
                32.5330384
              ],
              [
                47.9787751,
                32.5321194
              ],
              [
                47.9792061,
                32.5312463
              ],
              [
                47.9798584,
                32.5305091
              ],
              [
                47.9803749,
                32.5296238
              ],
              [
                47.9804497,
                32.5294955
              ],
              [
                47.9808274,
                32.5285309
              ],
              [
                47.981041,
                32.5280717
              ],
              [
                47.9810372,
                32.5275194
              ],
              [
                47.9809838,
                32.5270583
              ],
              [
                47.9806519,
                32.5263674
              ],
              [
                47.9802132,
                32.5258633
              ],
              [
                47.9794502,
                32.5256804
              ],
              [
                47.9791428,
                32.5256299
              ],
              [
                47.9772149,
                32.5253134
              ],
              [
                47.9716529,
                32.5249946
              ],
              [
                47.9687119,
                32.5247659
              ],
              [
                47.9659843,
                32.5244477
              ],
              [
                47.9637489,
                32.5242201
              ],
              [
                47.9622765,
                32.5238487
              ],
              [
                47.9606399,
                32.5232998
              ],
              [
                47.9588929,
                32.5222883
              ],
              [
                47.9573632,
                32.5214151
              ],
              [
                47.9565964,
                32.5209119
              ],
              [
                47.9555054,
                32.5201755
              ],
              [
                47.9549561,
                32.5196235
              ],
              [
                47.9546814,
                32.5191661
              ],
              [
                47.9546776,
                32.5183365
              ],
              [
                47.9547806,
                32.5169101
              ],
              [
                47.9548835,
                32.5160831
              ],
              [
                47.9548798,
                32.5155781
              ],
              [
                47.954609,
                32.5153462
              ],
              [
                47.9541702,
                32.5151643
              ],
              [
                47.9538422,
                32.515118
              ],
              [
                47.9526481,
                32.5153054
              ],
              [
                47.9509049,
                32.5156711
              ],
              [
                47.9491653,
                32.515994
              ],
              [
                47.9465523,
                32.5162281
              ],
              [
                47.9447129,
                32.5164253
              ],
              [
                47.9444276,
                32.5164559
              ],
              [
                47.9425773,
                32.5170105
              ],
              [
                47.9405671,
                32.5178406
              ],
              [
                47.939373,
                32.5188055
              ],
              [
                47.9388313,
                32.5194977
              ],
              [
                47.9388351,
                32.5200951
              ],
              [
                47.9389992,
                32.5208316
              ],
              [
                47.9393311,
                32.5216105
              ],
              [
                47.9399338,
                32.5223465
              ],
              [
                47.9407005,
                32.5232667
              ],
              [
                47.9414674,
                32.5237271
              ],
              [
                47.9424477,
                32.5240012
              ],
              [
                47.9438096,
                32.5240929
              ],
              [
                47.9464264,
                32.5244135
              ],
              [
                47.9476815,
                32.5245048
              ],
              [
                47.9484978,
                32.5247793
              ],
              [
                47.9491006,
                32.5252831
              ],
              [
                47.9498139,
                32.5259292
              ],
              [
                47.95047,
                32.526849
              ],
              [
                47.9509125,
                32.5278131
              ],
              [
                47.9509697,
                32.5286867
              ],
              [
                47.9510841,
                32.5296519
              ],
              [
                47.9513588,
                32.530434
              ],
              [
                47.9513055,
                32.5304327
              ],
              [
                47.951416,
                32.5307081
              ],
              [
                47.9517975,
                32.5309405
              ],
              [
                47.9521828,
                32.5311707
              ],
              [
                47.9531632,
                32.5313522
              ],
              [
                47.953598,
                32.5314913
              ],
              [
                47.9540841,
                32.5318702
              ],
              [
                47.9543647,
                32.5320891
              ],
              [
                47.9550247,
                32.5329165
              ],
              [
                47.9544439,
                32.5326711
              ],
              [
                47.9452777,
                32.5285085
              ],
              [
                47.941391,
                32.5271179
              ],
              [
                47.9402777,
                32.527118
              ],
              [
                47.9397245,
                32.526838
              ],
              [
                47.9386112,
                32.526838
              ],
              [
                47.9383342,
                32.5265582
              ],
              [
                47.930414,
                32.5265582
              ],
              [
                47.9297212,
                32.5265581
              ],
              [
                47.9294446,
                32.526838
              ],
              [
                47.9258344,
                32.526838
              ],
              [
                47.9252777,
                32.5265581
              ],
              [
                47.9247211,
                32.526838
              ],
              [
                47.9244445,
                32.5265581
              ],
              [
                47.9219445,
                32.5265581
              ],
              [
                47.9200015,
                32.5262872
              ],
              [
                47.9197213,
                32.5260072
              ],
              [
                47.9180545,
                32.5260073
              ],
              [
                47.917778,
                32.5257274
              ],
              [
                47.9161112,
                32.5257274
              ],
              [
                47.9155545,
                32.5254475
              ],
              [
                47.9147213,
                32.5254474
              ],
              [
                47.9141646,
                32.5251675
              ],
              [
                47.9130548,
                32.5251676
              ],
              [
                47.8922217,
                32.5187837
              ],
              [
                47.8908318,
                32.5179529
              ],
              [
                47.8811086,
                32.5151719
              ],
              [
                47.8794417,
                32.5151718
              ],
              [
                47.8786085,
                32.5151719
              ],
              [
                47.878332,
                32.5148919
              ],
              [
                47.8694419,
                32.5151718
              ],
              [
                47.8597187,
                32.5182238
              ],
              [
                47.8563855,
                32.5198942
              ],
              [
                47.8558288,
                32.520445
              ],
              [
                47.8519424,
                32.5218356
              ],
              [
                47.8511087,
                32.5218356
              ],
              [
                47.8508291,
                32.5221155
              ],
              [
                47.8469423,
                32.5221155
              ],
              [
                47.8463856,
                32.5218356
              ],
              [
                47.8455524,
                32.5218355
              ],
              [
                47.8452759,
                32.5215557
              ],
              [
                47.8444422,
                32.5215556
              ],
              [
                47.8433289,
                32.5210048
              ],
              [
                47.8424956,
                32.5210049
              ],
              [
                47.8422191,
                32.5207249
              ],
              [
                47.8413859,
                32.5207248
              ],
              [
                47.8413859,
                32.520445
              ],
              [
                47.8383292,
                32.5201741
              ],
              [
                47.8374957,
                32.5198942
              ],
              [
                47.8358292,
                32.5198941
              ],
              [
                47.8355526,
                32.5196143
              ],
              [
                47.8305525,
                32.5196143
              ],
              [
                47.8297193,
                32.5198942
              ],
              [
                47.8280524,
                32.5198941
              ],
              [
                47.8272193,
                32.520174
              ],
              [
                47.824439,
                32.520174
              ],
              [
                47.8230491,
                32.5204449
              ],
              [
                47.8202726,
                32.5204449
              ],
              [
                47.8155494,
                32.5218355
              ],
              [
                47.8149959,
                32.5218355
              ],
              [
                47.8144392,
                32.5223952
              ],
              [
                47.8136061,
                32.5223953
              ],
              [
                47.7790498,
                32.5451763
              ],
              [
                47.7761033,
                32.5471178
              ],
              [
                47.7566599,
                32.5646168
              ],
              [
                47.7549934,
                32.5660073
              ],
              [
                47.7530465,
                32.5679486
              ],
              [
                47.723047,
                32.5976734
              ],
              [
                47.7061005,
                32.6096193
              ],
              [
                47.6899873,
                32.6168428
              ],
              [
                47.6783207,
                32.6193349
              ],
              [
                47.6769343,
                32.6196149
              ],
              [
                47.6752674,
                32.6198948
              ],
              [
                47.6744343,
                32.6198947
              ],
              [
                47.6705444,
                32.6204455
              ],
              [
                47.6702642,
                32.6207254
              ],
              [
                47.6697112,
                32.6207255
              ],
              [
                47.6694311,
                32.6210053
              ],
              [
                47.6683208,
                32.6210054
              ],
              [
                47.6680444,
                32.6212853
              ],
              [
                47.666931,
                32.6212853
              ],
              [
                47.6652642,
                32.621836
              ],
              [
                47.6616544,
                32.6240664
              ],
              [
                47.6608211,
                32.6243372
              ],
              [
                47.6608211,
                32.6246171
              ],
              [
                47.6599879,
                32.6251769
              ],
              [
                47.6502646,
                32.6396149
              ],
              [
                47.637208,
                32.6651681
              ],
              [
                47.6191513,
                32.6901796
              ],
              [
                47.6183181,
                32.6912902
              ],
              [
                47.6177649,
                32.6915701
              ],
              [
                47.6172083,
                32.6926806
              ],
              [
                47.6133179,
                32.6965633
              ],
              [
                47.6044283,
                32.7012856
              ],
              [
                47.6022084,
                32.7021163
              ],
              [
                47.6013752,
                32.7023963
              ],
              [
                47.6002614,
                32.7023962
              ],
              [
                47.5997084,
                32.7026761
              ],
              [
                47.5924851,
                32.7026761
              ],
              [
                47.5858186,
                32.7032269
              ],
              [
                47.5833186,
                32.7040666
              ],
              [
                47.5827619,
                32.7040666
              ],
              [
                47.5810951,
                32.7068477
              ],
              [
                47.5810951,
                32.7104504
              ],
              [
                47.5808184,
                32.711561
              ],
              [
                47.5760953,
                32.7293489
              ],
              [
                47.5758152,
                32.7301796
              ],
              [
                47.5708151,
                32.7382338
              ],
              [
                47.5672053,
                32.740455
              ],
              [
                47.5672052,
                32.7407349
              ],
              [
                47.566372,
                32.7407349
              ],
              [
                47.5655388,
                32.740455
              ],
              [
                47.5649821,
                32.7404549
              ],
              [
                47.5633153,
                32.7404549
              ],
              [
                47.5627622,
                32.740175
              ],
              [
                47.5613719,
                32.740175
              ],
              [
                47.5613719,
                32.7398951
              ],
              [
                47.559982,
                32.7398951
              ],
              [
                47.549149,
                32.737403
              ],
              [
                47.548872,
                32.7371231
              ],
              [
                47.5410922,
                32.737123
              ],
              [
                47.5397023,
                32.7374029
              ],
              [
                47.5363691,
                32.7374029
              ],
              [
                47.5352589,
                32.737123
              ],
              [
                47.5349823,
                32.737403
              ],
              [
                47.5338691,
                32.7371231
              ],
              [
                47.5322026,
                32.7371231
              ],
              [
                47.5310925,
                32.7374029
              ],
              [
                47.5288693,
                32.7374029
              ],
              [
                47.5274826,
                32.7376738
              ],
              [
                47.5219258,
                32.7393442
              ],
              [
                47.5183124,
                32.7412855
              ],
              [
                47.5180359,
                32.7415655
              ],
              [
                47.5038696,
                32.75157
              ],
              [
                47.5027594,
                32.7526806
              ],
              [
                47.4908131,
                32.7593442
              ],
              [
                47.4841465,
                32.7615654
              ],
              [
                47.4746998,
                32.7615654
              ],
              [
                47.4735897,
                32.7612854
              ],
              [
                47.4685899,
                32.7612854
              ],
              [
                47.4666466,
                32.7610055
              ],
              [
                47.45581,
                32.7610055
              ],
              [
                47.4374769,
                32.7526804
              ],
              [
                47.4266439,
                32.7482289
              ],
              [
                47.4260868,
                32.747958
              ],
              [
                47.425254,
                32.7476781
              ],
              [
                47.4249774,
                32.7473982
              ],
              [
                47.4244204,
                32.7471183
              ],
              [
                47.4224774,
                32.7468474
              ],
              [
                47.4219203,
                32.7465675
              ],
              [
                47.4210875,
                32.7468473
              ],
              [
                47.4208109,
                32.7465675
              ],
              [
                47.4171976,
                32.7465675
              ],
              [
                47.4166437,
                32.7462876
              ],
              [
                47.4158109,
                32.7462876
              ],
              [
                47.4091443,
                32.7457368
              ],
              [
                47.4085872,
                32.7454568
              ],
              [
                47.4044208,
                32.7454569
              ],
              [
                47.3999738,
                32.7460076
              ],
              [
                47.3833078,
                32.7573935
              ],
              [
                47.3830574,
                32.7576453
              ],
              [
                47.3824742,
                32.7582333
              ],
              [
                47.3816414,
                32.7585132
              ],
              [
                47.3749748,
                32.7651769
              ],
              [
                47.3727513,
                32.7665673
              ],
              [
                47.3708076,
                32.7673981
              ],
              [
                47.3660848,
                32.7687886
              ],
              [
                47.3649746,
                32.7687886
              ],
              [
                47.3621948,
                32.7696192
              ],
              [
                47.3594183,
                32.7696192
              ],
              [
                47.3585847,
                32.7698991
              ],
              [
                47.3563612,
                32.7698991
              ],
              [
                47.3549744,
                32.7696192
              ],
              [
                47.3541416,
                32.7698991
              ],
              [
                47.3521946,
                32.7696192
              ],
              [
                47.346918,
                32.7696193
              ],
              [
                47.3449711,
                32.7693393
              ],
              [
                47.3352514,
                32.7693393
              ],
              [
                47.334138,
                32.7696191
              ],
              [
                47.331638,
                32.7696192
              ],
              [
                47.3308052,
                32.7698991
              ],
              [
                47.3288614,
                32.7698991
              ],
              [
                47.3235816,
                32.7718404
              ],
              [
                47.3205284,
                32.7751812
              ],
              [
                47.3205284,
                32.775732
              ],
              [
                47.3199722,
                32.7760119
              ],
              [
                47.3160822,
                32.7832264
              ],
              [
                47.3110821,
                32.7904588
              ],
              [
                47.3069156,
                32.792671
              ],
              [
                47.3049718,
                32.7937906
              ],
              [
                47.2991389,
                32.798233
              ],
              [
                47.2885824,
                32.8146212
              ],
              [
                47.2871925,
                32.8232351
              ],
              [
                47.2871924,
                32.8285082
              ],
              [
                47.287469,
                32.8315601
              ],
              [
                47.2944151,
                32.8676772
              ],
              [
                47.2946916,
                32.8682371
              ],
              [
                47.2949682,
                32.871289
              ],
              [
                47.2949682,
                32.8826748
              ],
              [
                47.2921915,
                32.8982322
              ],
              [
                47.2921915,
                32.901564
              ],
              [
                47.2919149,
                32.9021238
              ],
              [
                47.2916352,
                32.9049048
              ],
              [
                47.2913586,
                32.906846
              ],
              [
                47.2894148,
                32.9126789
              ],
              [
                47.2877483,
                32.9171303
              ],
              [
                47.2874687,
                32.9179609
              ],
              [
                47.2869148,
                32.9190715
              ],
              [
                47.2867749,
                32.9193469
              ],
              [
                47.2849686,
                32.9215726
              ],
              [
                47.2849686,
                32.9218525
              ],
              [
                47.2849686,
                32.9224033
              ],
              [
                47.2846921,
                32.9226742
              ],
              [
                47.2846921,
                32.923234
              ],
              [
                47.2635783,
                32.9512966
              ],
              [
                47.2630251,
                32.9515675
              ],
              [
                47.2624688,
                32.952678
              ],
              [
                47.2441356,
                32.966294
              ],
              [
                47.2427458,
                32.9668447
              ],
              [
                47.2369121,
                32.9693458
              ],
              [
                47.2366323,
                32.9696256
              ],
              [
                47.2321894,
                32.9696256
              ],
              [
                47.2307986,
                32.9693458
              ],
              [
                47.228022,
                32.9693458
              ],
              [
                47.2271892,
                32.9690659
              ],
              [
                47.2230227,
                32.9690658
              ],
              [
                47.2207992,
                32.9687949
              ],
              [
                47.194966,
                32.9618424
              ],
              [
                47.1927433,
                32.9618425
              ],
              [
                47.1913526,
                32.9624023
              ],
              [
                47.1860759,
                32.9674044
              ],
              [
                47.1846861,
                32.9687948
              ],
              [
                47.1832992,
                32.9701854
              ],
              [
                47.182186,
                32.9707361
              ],
              [
                47.1774632,
                32.9754584
              ],
              [
                47.1766296,
                32.9765689
              ],
              [
                47.1371834,
                33.000171
              ],
              [
                47.0994037,
                33.0090734
              ],
              [
                47.0891277,
                33.0118544
              ],
              [
                47.0827378,
                33.0160168
              ],
              [
                47.0810705,
                33.0193485
              ],
              [
                47.0805143,
                33.0199083
              ],
              [
                47.0805143,
                33.0204591
              ],
              [
                47.0746805,
                33.0262919
              ],
              [
                47.0696812,
                33.0287929
              ],
              [
                47.0624576,
                33.0304542
              ],
              [
                47.0613474,
                33.0307341
              ],
              [
                47.0585708,
                33.0307341
              ],
              [
                47.0577379,
                33.031014
              ],
              [
                47.0544043,
                33.0310139
              ],
              [
                47.0480142,
                33.0318446
              ],
              [
                47.0460682,
                33.0326843
              ],
              [
                47.0455142,
                33.0335149
              ],
              [
                47.044958,
                33.0349055
              ],
              [
                47.0463479,
                33.0443498
              ],
              [
                47.0513479,
                33.0637983
              ],
              [
                47.0530142,
                33.0729628
              ],
              [
                47.0527378,
                33.0735135
              ],
              [
                47.0494009,
                33.0807367
              ],
              [
                47.0407914,
                33.0851789
              ],
              [
                47.0399578,
                33.0854589
              ],
              [
                47.0377342,
                33.0904609
              ],
              [
                47.0377342,
                33.0943523
              ],
              [
                47.0374576,
                33.0979639
              ],
              [
                47.0377341,
                33.1187936
              ],
              [
                47.0382912,
                33.1199042
              ],
              [
                47.0382911,
                33.1207438
              ],
              [
                47.0407912,
                33.1260167
              ],
              [
                47.0509362,
                33.1317809
              ],
              [
                47.0556889,
                33.1350301
              ],
              [
                47.05845,
                33.142382
              ],
              [
                47.0601021,
                33.1479164
              ],
              [
                47.0638032,
                33.1512824
              ],
              [
                47.0753901,
                33.1578949
              ],
              [
                47.0867846,
                33.1643201
              ],
              [
                47.109683,
                33.1724071
              ],
              [
                47.1221832,
                33.1774091
              ],
              [
                47.124406,
                33.1790794
              ],
              [
                47.1338499,
                33.1888035
              ],
              [
                47.1346827,
                33.1901849
              ],
              [
                47.1346826,
                33.1904648
              ],
              [
                47.1349632,
                33.1907447
              ],
              [
                47.1352397,
                33.1915753
              ],
              [
                47.1352397,
                33.1918552
              ],
              [
                47.1349632,
                33.1921351
              ],
              [
                47.1344061,
                33.1921351
              ],
              [
                47.1341295,
                33.192406
              ],
              [
                47.1335725,
                33.1926859
              ],
              [
                47.1095542,
                33.2014894
              ],
              [
                47.0971834,
                33.2060213
              ],
              [
                47.0952366,
                33.206292
              ],
              [
                47.0807933,
                33.2118537
              ],
              [
                47.0794033,
                33.2126843
              ],
              [
                47.0752368,
                33.2140748
              ],
              [
                47.0666234,
                33.2179661
              ],
              [
                47.0619038,
                33.2193566
              ],
              [
                47.0602373,
                33.2201872
              ],
              [
                47.0580139,
                33.220738
              ],
              [
                47.0524567,
                33.2232389
              ],
              [
                47.0524567,
                33.2235188
              ],
              [
                47.0509193,
                33.223749
              ],
              [
                47.0365512,
                33.2285093
              ],
              [
                47.0300109,
                33.2309216
              ],
              [
                47.0290582,
                33.2313955
              ],
              [
                47.0217969,
                33.232257
              ],
              [
                47.0185268,
                33.2331831
              ],
              [
                47.0156429,
                33.2341308
              ],
              [
                47.0052951,
                33.2382278
              ],
              [
                46.995346,
                33.241901
              ],
              [
                46.953285,
                33.2618542
              ],
              [
                46.922175,
                33.2838026
              ],
              [
                46.9102286,
                33.2949078
              ],
              [
                46.897172,
                33.3065816
              ],
              [
                46.8932821,
                33.3115744
              ],
              [
                46.89146,
                33.3142402
              ],
              [
                46.8896719,
                33.3168561
              ],
              [
                46.8893954,
                33.3176867
              ],
              [
                46.8885625,
                33.3185264
              ],
              [
                46.888282,
                33.3190771
              ],
              [
                46.8880055,
                33.319357
              ],
              [
                46.8863391,
                33.3204675
              ],
              [
                46.8810624,
                33.3032411
              ],
              [
                46.8807828,
                33.2871342
              ],
              [
                46.8802288,
                33.2854639
              ],
              [
                46.8796726,
                33.282683
              ],
              [
                46.878839,
                33.2810217
              ],
              [
                46.8713397,
                33.2626846
              ],
              [
                46.8546699,
                33.2346326
              ],
              [
                46.8549497,
                33.2343527
              ],
              [
                46.8557833,
                33.2321316
              ],
              [
                46.8577263,
                33.2293507
              ],
              [
                46.8646725,
                33.2224077
              ],
              [
                46.8671725,
                33.2196269
              ],
              [
                46.8702257,
                33.2157355
              ],
              [
                46.8724492,
                33.209912
              ],
              [
                46.8732829,
                33.2049101
              ],
              [
                46.8716165,
                33.1968475
              ],
              [
                46.8691165,
                33.1918545
              ],
              [
                46.8657828,
                33.188243
              ],
              [
                46.8632828,
                33.1865726
              ],
              [
                46.8585601,
                33.1846315
              ],
              [
                46.838837,
                33.1776883
              ],
              [
                46.8346698,
                33.1754581
              ],
              [
                46.8327267,
                33.1749074
              ],
              [
                46.8266134,
                33.1721265
              ],
              [
                46.8196703,
                33.1696255
              ],
              [
                46.8124474,
                33.1679642
              ],
              [
                46.8071709,
                33.1660139
              ],
              [
                46.7935573,
                33.1593506
              ],
              [
                46.773278,
                33.1515767
              ],
              [
                46.7666107,
                33.1482451
              ],
              [
                46.7599442,
                33.1429632
              ],
              [
                46.7596676,
                33.1418526
              ],
              [
                46.7616114,
                33.1374014
              ],
              [
                46.761888,
                33.1371215
              ],
              [
                46.7613349,
                33.1340787
              ],
              [
                46.7582778,
                33.1293477
              ],
              [
                46.7577216,
                33.1293476
              ],
              [
                46.757445,
                33.1287969
              ],
              [
                46.7560543,
                33.1282371
              ],
              [
                46.751055,
                33.1254652
              ],
              [
                46.7410548,
                33.1124003
              ],
              [
                46.7404986,
                33.1076782
              ],
              [
                46.7407784,
                33.1068476
              ],
              [
                46.7435549,
                33.1012948
              ],
              [
                46.743555,
                33.0996245
              ],
              [
                46.742998,
                33.0960128
              ],
              [
                46.7299454,
                33.085458
              ],
              [
                46.7235554,
                33.0824062
              ],
              [
                46.7121654,
                33.0771241
              ],
              [
                46.7027191,
                33.0707407
              ],
              [
                46.6999425,
                33.0693502
              ],
              [
                46.6891095,
                33.0640683
              ],
              [
                46.6782757,
                33.0618471
              ],
              [
                46.6785523,
                33.0615672
              ],
              [
                46.6771624,
                33.0607365
              ],
              [
                46.6768858,
                33.0601767
              ],
              [
                46.6752194,
                33.0593461
              ],
              [
                46.6727194,
                33.0546239
              ],
              [
                46.6721623,
                33.0510123
              ],
              [
                46.6702194,
                33.0496218
              ],
              [
                46.6668865,
                33.0487911
              ],
              [
                46.6660529,
                33.0482313
              ],
              [
                46.6643865,
                33.0479605
              ],
              [
                46.6552199,
                33.0443488
              ],
              [
                46.6466064,
                33.0389033
              ],
              [
                46.6466064,
                33.038516
              ],
              [
                46.646883,
                33.0374055
              ],
              [
                46.6466065,
                33.0343446
              ],
              [
                46.64494,
                33.0343446
              ],
              [
                46.6443829,
                33.0346245
              ],
              [
                46.6416063,
                33.0346245
              ],
              [
                46.6416064,
                33.0349044
              ],
              [
                46.6399399,
                33.0354642
              ],
              [
                46.63605,
                33.0318436
              ],
              [
                46.6346633,
                33.0237896
              ],
              [
                46.6329929,
                33.0204579
              ],
              [
                46.6327164,
                33.0201779
              ],
              [
                46.6318835,
                33.0193473
              ],
              [
                46.631607,
                33.0190674
              ],
              [
                46.631607,
                33.0187875
              ],
              [
                46.6146606,
                33.0029595
              ],
              [
                46.6110503,
                32.9985172
              ],
              [
                46.604937,
                32.9940658
              ],
              [
                46.594104,
                32.9915737
              ],
              [
                46.5918805,
                32.9915738
              ],
              [
                46.5907703,
                32.9912939
              ],
              [
                46.5802139,
                32.9912938
              ],
              [
                46.5799374,
                32.9910139
              ],
              [
                46.5782709,
                32.9910139
              ],
              [
                46.5732708,
                32.9887927
              ],
              [
                46.5702145,
                32.9865715
              ],
              [
                46.5582675,
                32.9715652
              ],
              [
                46.556601,
                32.969064
              ],
              [
                46.5188216,
                32.9065641
              ],
              [
                46.5182684,
                32.9057334
              ],
              [
                46.515756,
                32.901963
              ],
              [
                46.5142611,
                32.8993366
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 903764,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دره‌شهر",
          "name:en": "Darreh Shahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q741497",
          "wikipedia": "en:Darreh Shahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.2083005,
                33.1437564
              ],
              [
                47.209689,
                33.1429643
              ],
              [
                47.2107984,
                33.1418538
              ],
              [
                47.2185751,
                33.1360122
              ],
              [
                47.2566346,
                33.0971248
              ],
              [
                47.2680247,
                33.0896307
              ],
              [
                47.2869142,
                33.0807373
              ],
              [
                47.2916346,
                33.0793469
              ],
              [
                47.329694,
                33.0676815
              ],
              [
                47.3310808,
                33.0676815
              ],
              [
                47.3433037,
                33.0649096
              ],
              [
                47.3449701,
                33.0649096
              ],
              [
                47.3455271,
                33.0646298
              ],
              [
                47.3466372,
                33.0646297
              ],
              [
                47.3471936,
                33.0643498
              ],
              [
                47.3513601,
                33.0643499
              ],
              [
                47.3516374,
                33.0640699
              ],
              [
                47.3521936,
                33.06407
              ],
              [
                47.3530273,
                33.0640699
              ],
              [
                47.353307,
                33.0637991
              ],
              [
                47.3544172,
                33.0635192
              ],
              [
                47.3560836,
                33.0632393
              ],
              [
                47.3635837,
                33.0607383
              ],
              [
                47.3771965,
                33.0579664
              ],
              [
                47.4119199,
                33.0471226
              ],
              [
                47.4119199,
                33.0468518
              ],
              [
                47.4127527,
                33.046292
              ],
              [
                47.4183099,
                33.0443508
              ],
              [
                47.4208099,
                33.0432402
              ],
              [
                47.4391427,
                33.0362879
              ],
              [
                47.448866,
                33.0315747
              ],
              [
                47.4994217,
                33.0165686
              ],
              [
                47.500812,
                33.0165686
              ],
              [
                47.5016452,
                33.0162887
              ],
              [
                47.5230351,
                33.0107359
              ],
              [
                47.5252582,
                33.0096254
              ],
              [
                47.5277582,
                33.0087947
              ],
              [
                47.5374814,
                33.0054629
              ],
              [
                47.5399815,
                33.0040725
              ],
              [
                47.5397015,
                33.0037925
              ],
              [
                47.5402581,
                33.0035217
              ],
              [
                47.5405382,
                33.0029619
              ],
              [
                47.5449812,
                32.999901
              ],
              [
                47.5708142,
                32.9865742
              ],
              [
                47.5849886,
                32.9800922
              ],
              [
                47.5902608,
                32.9776805
              ],
              [
                47.5958176,
                32.9760192
              ],
              [
                47.5969272,
                32.9760192
              ],
              [
                47.5980409,
                32.9754594
              ],
              [
                47.5991507,
                32.9754594
              ],
              [
                47.6016508,
                32.9746287
              ],
              [
                47.6027606,
                32.9746287
              ],
              [
                47.6030407,
                32.9743488
              ],
              [
                47.6041509,
                32.9743488
              ],
              [
                47.6044274,
                32.974069
              ],
              [
                47.6052606,
                32.9740689
              ],
              [
                47.6060938,
                32.9740689
              ],
              [
                47.6069276,
                32.9737981
              ],
              [
                47.608594,
                32.9737981
              ],
              [
                47.6088739,
                32.9735182
              ],
              [
                47.6105405,
                32.9735182
              ],
              [
                47.6108174,
                32.9732382
              ],
              [
                47.6119272,
                32.9732382
              ],
              [
                47.6122073,
                32.9729583
              ],
              [
                47.6133171,
                32.9729583
              ],
              [
                47.6135941,
                32.9726784
              ],
              [
                47.6177641,
                32.971288
              ],
              [
                47.6180406,
                32.9710172
              ],
              [
                47.6185973,
                32.9704573
              ],
              [
                47.6197071,
                32.9699066
              ],
              [
                47.6205406,
                32.9696266
              ],
              [
                47.6219306,
                32.968796
              ],
              [
                47.6252638,
                32.9676764
              ],
              [
                47.6505402,
                32.95546
              ],
              [
                47.6530402,
                32.9546293
              ],
              [
                47.6563769,
                32.9529589
              ],
              [
                47.6577633,
                32.952679
              ],
              [
                47.6847096,
                32.9407425
              ],
              [
                47.6855432,
                32.9407425
              ],
              [
                47.6858198,
                32.9404626
              ],
              [
                47.6933231,
                32.9387923
              ],
              [
                47.6941562,
                32.9385124
              ],
              [
                47.6947098,
                32.9385124
              ],
              [
                47.6955431,
                32.9379525
              ],
              [
                47.6997095,
                32.936851
              ],
              [
                47.7027663,
                32.9332393
              ],
              [
                47.7030427,
                32.9324087
              ],
              [
                47.7033229,
                32.9315689
              ],
              [
                47.7044327,
                32.9271266
              ],
              [
                47.7047097,
                32.9262959
              ],
              [
                47.7058229,
                32.9224043
              ],
              [
                47.7091562,
                32.9162916
              ],
              [
                47.719156,
                32.9062873
              ],
              [
                47.7197128,
                32.9062872
              ],
              [
                47.7199894,
                32.9057365
              ],
              [
                47.7263793,
                32.901565
              ],
              [
                47.7274894,
                32.9007343
              ],
              [
                47.7324892,
                32.8957411
              ],
              [
                47.7299891,
                32.8887887
              ],
              [
                47.729156,
                32.8835156
              ],
              [
                47.7294325,
                32.8826758
              ],
              [
                47.7297126,
                32.8812943
              ],
              [
                47.7319361,
                32.8749017
              ],
              [
                47.7377695,
                32.8685089
              ],
              [
                47.740546,
                32.8662878
              ],
              [
                47.7427692,
                32.8646264
              ],
              [
                47.7752687,
                32.8487892
              ],
              [
                47.7761023,
                32.8487892
              ],
              [
                47.7763819,
                32.8485092
              ],
              [
                47.7769355,
                32.8485092
              ],
              [
                47.7774921,
                32.8482294
              ],
              [
                47.7788821,
                32.8479585
              ],
              [
                47.7805489,
                32.8479585
              ],
              [
                47.7808255,
                32.8476786
              ],
              [
                47.7822153,
                32.8476786
              ],
              [
                47.7824919,
                32.8473987
              ],
              [
                47.7852685,
                32.8468479
              ],
              [
                47.7863822,
                32.846568
              ],
              [
                47.7880486,
                32.8460172
              ],
              [
                47.7947152,
                32.8415658
              ],
              [
                47.7958254,
                32.8404552
              ],
              [
                47.826385,
                32.8273989
              ],
              [
                47.8411049,
                32.8196248
              ],
              [
                47.8416615,
                32.819074
              ],
              [
                47.8438846,
                32.8168438
              ],
              [
                47.8444413,
                32.8168437
              ],
              [
                47.8449948,
                32.816293
              ],
              [
                47.845828,
                32.816013
              ],
              [
                47.845828,
                32.8157331
              ],
              [
                47.8466612,
                32.8154623
              ],
              [
                47.8469413,
                32.8151823
              ],
              [
                47.8491612,
                32.8146226
              ],
              [
                47.8641643,
                32.8087896
              ],
              [
                47.8658312,
                32.8085097
              ],
              [
                47.8855542,
                32.8037875
              ],
              [
                47.9030542,
                32.7999049
              ],
              [
                47.9063875,
                32.7982345
              ],
              [
                47.9072207,
                32.7982345
              ],
              [
                47.9099973,
                32.7960132
              ],
              [
                47.9102774,
                32.7957334
              ],
              [
                47.910554,
                32.7954534
              ],
              [
                47.9133305,
                32.7979546
              ],
              [
                47.9141637,
                32.8040674
              ],
              [
                47.9138872,
                32.805458
              ],
              [
                47.9136106,
                32.8062886
              ],
              [
                47.9141637,
                32.811011
              ],
              [
                47.9161103,
                32.8140629
              ],
              [
                47.9225002,
                32.819345
              ],
              [
                47.9250003,
                32.8204557
              ],
              [
                47.9294437,
                32.8204556
              ],
              [
                47.9308336,
                32.8199048
              ],
              [
                47.9313867,
                32.8196249
              ],
              [
                47.9336102,
                32.8185144
              ],
              [
                47.9427768,
                32.8121216
              ],
              [
                47.9477765,
                32.8110111
              ],
              [
                47.9491667,
                32.8110111
              ],
              [
                47.95,
                32.8107312
              ],
              [
                47.9797229,
                32.8068486
              ],
              [
                47.984723,
                32.8068486
              ],
              [
                47.9855561,
                32.8071286
              ],
              [
                47.9900027,
                32.8073994
              ],
              [
                47.9900027,
                32.8076793
              ],
              [
                47.9905563,
                32.8076793
              ],
              [
                47.9913895,
                32.8076793
              ],
              [
                47.9913895,
                32.8079592
              ],
              [
                47.9922227,
                32.8079592
              ],
              [
                47.9936125,
                32.80851
              ],
              [
                47.9944462,
                32.8085101
              ],
              [
                47.9975029,
                32.8090698
              ],
              [
                47.9988927,
                32.8099005
              ],
              [
                47.9991694,
                32.8101804
              ],
              [
                48.0000026,
                32.8101804
              ],
              [
                48.0027791,
                32.8112911
              ],
              [
                48.0033358,
                32.8118509
              ],
              [
                48.0033357,
                32.8129525
              ],
              [
                48.0033358,
                32.8132324
              ],
              [
                48.0033358,
                32.8135123
              ],
              [
                48.0033357,
                32.8137922
              ],
              [
                48.0027792,
                32.8151827
              ],
              [
                48.0025026,
                32.8165642
              ],
              [
                48.0025025,
                32.8168441
              ],
              [
                48.0025026,
                32.817124
              ],
              [
                48.0013928,
                32.8193452
              ],
              [
                48.0011126,
                32.8204558
              ],
              [
                48.0008361,
                32.8212865
              ],
              [
                48.0005591,
                32.8224062
              ],
              [
                48.0002794,
                32.8232368
              ],
              [
                47.9952793,
                32.8390652
              ],
              [
                47.9952793,
                32.8412864
              ],
              [
                47.9952793,
                32.8418461
              ],
              [
                47.9941696,
                32.8435165
              ],
              [
                47.9913893,
                32.8462976
              ],
              [
                47.9897225,
                32.8462976
              ],
              [
                47.9897226,
                32.8460177
              ],
              [
                47.9886127,
                32.8460177
              ],
              [
                47.9883362,
                32.8457378
              ],
              [
                47.9875026,
                32.8457377
              ],
              [
                47.9863893,
                32.844898
              ],
              [
                47.9852795,
                32.844898
              ],
              [
                47.9850029,
                32.8446181
              ],
              [
                47.9847228,
                32.8446181
              ],
              [
                47.9833361,
                32.8446181
              ],
              [
                47.9825029,
                32.844898
              ],
              [
                47.9813896,
                32.8460177
              ],
              [
                47.9813896,
                32.8465685
              ],
              [
                47.981113,
                32.8468483
              ],
              [
                47.9822228,
                32.8501802
              ],
              [
                47.9827794,
                32.85046
              ],
              [
                47.9833361,
                32.8518505
              ],
              [
                47.983336,
                32.8526813
              ],
              [
                47.9833361,
                32.8529612
              ],
              [
                47.9811129,
                32.8551823
              ],
              [
                47.9800028,
                32.8551823
              ],
              [
                47.9797227,
                32.8554623
              ],
              [
                47.9780563,
                32.8554622
              ],
              [
                47.9772226,
                32.8557331
              ],
              [
                47.9769461,
                32.856013
              ],
              [
                47.974723,
                32.856013
              ],
              [
                47.9733327,
                32.8565638
              ],
              [
                47.9658329,
                32.8649069
              ],
              [
                47.9652798,
                32.8660084
              ],
              [
                47.9649998,
                32.867408
              ],
              [
                47.9647232,
                32.8682387
              ],
              [
                47.9644461,
                32.8707398
              ],
              [
                47.9641661,
                32.872681
              ],
              [
                47.9638895,
                32.8737916
              ],
              [
                47.9630563,
                32.8749022
              ],
              [
                47.9591663,
                32.878234
              ],
              [
                47.9580562,
                32.8779631
              ],
              [
                47.9547229,
                32.878234
              ],
              [
                47.9438898,
                32.8832361
              ],
              [
                47.9366666,
                32.8893489
              ],
              [
                47.93611,
                32.8896198
              ],
              [
                47.9344432,
                32.8924008
              ],
              [
                47.9347197,
                32.8940712
              ],
              [
                47.9349998,
                32.8949019
              ],
              [
                47.9355534,
                32.8987935
              ],
              [
                47.9344431,
                32.8999041
              ],
              [
                47.9313864,
                32.9015654
              ],
              [
                47.9263868,
                32.9001839
              ],
              [
                47.9236101,
                32.9015654
              ],
              [
                47.9230534,
                32.9015654
              ],
              [
                47.9194436,
                32.905457
              ],
              [
                47.9147201,
                32.9079581
              ],
              [
                47.912497,
                32.9079581
              ],
              [
                47.9105536,
                32.9074073
              ],
              [
                47.910277,
                32.9071274
              ],
              [
                47.9061101,
                32.9071274
              ],
              [
                47.9049969,
                32.9076782
              ],
              [
                47.9044438,
                32.9087887
              ],
              [
                47.9047202,
                32.9115697
              ],
              [
                47.9027768,
                32.913791
              ],
              [
                47.9016636,
                32.9137909
              ],
              [
                47.8997202,
                32.9121296
              ],
              [
                47.8966639,
                32.9112898
              ],
              [
                47.8941638,
                32.9112898
              ],
              [
                47.8936071,
                32.9115697
              ],
              [
                47.892497,
                32.9115697
              ],
              [
                47.8894402,
                32.9140708
              ],
              [
                47.8891636,
                32.9149015
              ],
              [
                47.8888872,
                32.9157321
              ],
              [
                47.8877738,
                32.9187931
              ],
              [
                47.8874973,
                32.919073
              ],
              [
                47.886107,
                32.9201836
              ],
              [
                47.8794404,
                32.9229555
              ],
              [
                47.8774974,
                32.9268471
              ],
              [
                47.8774974,
                32.9324091
              ],
              [
                47.8741641,
                32.9365715
              ],
              [
                47.8719406,
                32.9382329
              ],
              [
                47.8702739,
                32.9387927
              ],
              [
                47.8694405,
                32.9387926
              ],
              [
                47.8691641,
                32.9390726
              ],
              [
                47.8677742,
                32.9390726
              ],
              [
                47.8633307,
                32.9349011
              ],
              [
                47.862774,
                32.9349011
              ],
              [
                47.8613842,
                32.9346301
              ],
              [
                47.8605509,
                32.9346302
              ],
              [
                47.860274,
                32.9343503
              ],
              [
                47.8577743,
                32.9343503
              ],
              [
                47.8572173,
                32.9340704
              ],
              [
                47.8563841,
                32.9343502
              ],
              [
                47.8561076,
                32.9340704
              ],
              [
                47.8555509,
                32.9343503
              ],
              [
                47.8533274,
                32.9343503
              ],
              [
                47.8491608,
                32.9362915
              ],
              [
                47.8486078,
                32.9368513
              ],
              [
                47.8477741,
                32.9371222
              ],
              [
                47.8374942,
                32.9482371
              ],
              [
                47.8333277,
                32.951018
              ],
              [
                47.8322179,
                32.9518487
              ],
              [
                47.8299944,
                32.9532393
              ],
              [
                47.825828,
                32.9582414
              ],
              [
                47.8258279,
                32.959072
              ],
              [
                47.8211044,
                32.9654556
              ],
              [
                47.8111046,
                32.9710176
              ],
              [
                47.8097147,
                32.9718482
              ],
              [
                47.7999915,
                32.9740693
              ],
              [
                47.798048,
                32.9746293
              ],
              [
                47.7969382,
                32.9746291
              ],
              [
                47.7911049,
                32.9765704
              ],
              [
                47.7905483,
                32.9765703
              ],
              [
                47.7902718,
                32.9768503
              ],
              [
                47.7888814,
                32.9774101
              ],
              [
                47.7849915,
                32.9785117
              ],
              [
                47.784715,
                32.9787916
              ],
              [
                47.7808251,
                32.9787915
              ],
              [
                47.7802685,
                32.9790714
              ],
              [
                47.7780484,
                32.9790714
              ],
              [
                47.7763816,
                32.9796312
              ],
              [
                47.7760044,
                32.9799021
              ],
              [
                47.7722151,
                32.9832429
              ],
              [
                47.7713818,
                32.9846333
              ],
              [
                47.7616586,
                32.9937979
              ],
              [
                47.7533252,
                32.9982401
              ],
              [
                47.7519353,
                32.9982401
              ],
              [
                47.7505454,
                32.9982402
              ],
              [
                47.7499919,
                32.9979603
              ],
              [
                47.7491587,
                32.9979603
              ],
              [
                47.7444356,
                32.9951883
              ],
              [
                47.7441555,
                32.9949084
              ],
              [
                47.7422121,
                32.9949085
              ],
              [
                47.7308224,
                32.9993507
              ],
              [
                47.7302689,
                33.0007412
              ],
              [
                47.728599,
                33.0026824
              ],
              [
                47.7280458,
                33.0026824
              ],
              [
                47.7274892,
                33.0032423
              ],
              [
                47.7269321,
                33.0032422
              ],
              [
                47.7266555,
                33.0035221
              ],
              [
                47.7235988,
                33.0035221
              ],
              [
                47.7230457,
                33.0032422
              ],
              [
                47.7216558,
                33.0032422
              ],
              [
                47.7210992,
                33.0029623
              ],
              [
                47.7180459,
                33.0029623
              ],
              [
                47.717489,
                33.0032422
              ],
              [
                47.7122127,
                33.0049036
              ],
              [
                47.7116561,
                33.0049035
              ],
              [
                47.7113791,
                33.0051834
              ],
              [
                47.7083227,
                33.0051834
              ],
              [
                47.7080427,
                33.0049035
              ],
              [
                47.7063759,
                33.0049034
              ],
              [
                47.691656,
                33.0021316
              ],
              [
                47.6905427,
                33.0024024
              ],
              [
                47.6872094,
                33.0051834
              ],
              [
                47.6799862,
                33.008795
              ],
              [
                47.6797096,
                33.0090749
              ],
              [
                47.6785995,
                33.0093457
              ],
              [
                47.6783194,
                33.0096257
              ],
              [
                47.6772095,
                33.0096257
              ],
              [
                47.6769331,
                33.0099056
              ],
              [
                47.6760999,
                33.0099056
              ],
              [
                47.6758198,
                33.0101854
              ],
              [
                47.6749861,
                33.0101855
              ],
              [
                47.661653,
                33.0176795
              ],
              [
                47.6605432,
                33.01907
              ],
              [
                47.65721,
                33.0201806
              ],
              [
                47.6538732,
                33.0235123
              ],
              [
                47.6505399,
                33.0257334
              ],
              [
                47.6502634,
                33.0260134
              ],
              [
                47.648873,
                33.0260133
              ],
              [
                47.6485965,
                33.0262933
              ],
              [
                47.6466535,
                33.0262933
              ],
              [
                47.6458199,
                33.026853
              ],
              [
                47.6416534,
                33.0326858
              ],
              [
                47.6408201,
                33.0332366
              ],
              [
                47.6405401,
                33.0337964
              ],
              [
                47.6372067,
                33.0343471
              ],
              [
                47.6366533,
                33.034627
              ],
              [
                47.6341501,
                33.0346271
              ],
              [
                47.6335969,
                33.0349069
              ],
              [
                47.6322067,
                33.0349069
              ],
              [
                47.6308168,
                33.0343471
              ],
              [
                47.6288734,
                33.0326857
              ],
              [
                47.6280402,
                33.0324059
              ],
              [
                47.6255401,
                33.0318461
              ],
              [
                47.6247069,
                33.0318461
              ],
              [
                47.6244304,
                33.032126
              ],
              [
                47.6238737,
                33.0321259
              ],
              [
                47.6197069,
                33.0362883
              ],
              [
                47.6124836,
                33.0387984
              ],
              [
                47.6113738,
                33.0387983
              ],
              [
                47.6019272,
                33.0465724
              ],
              [
                47.6002604,
                33.0471231
              ],
              [
                47.5999837,
                33.047403
              ],
              [
                47.5977607,
                33.047403
              ],
              [
                47.5933172,
                33.0451819
              ],
              [
                47.5922039,
                33.0451818
              ],
              [
                47.5874839,
                33.0490733
              ],
              [
                47.5872038,
                33.0493533
              ],
              [
                47.5799841,
                33.060179
              ],
              [
                47.5797039,
                33.0607388
              ],
              [
                47.5788708,
                33.0610187
              ],
              [
                47.5785942,
                33.0615695
              ],
              [
                47.5755375,
                33.06268
              ],
              [
                47.5669275,
                33.0715736
              ],
              [
                47.5644275,
                33.0740746
              ],
              [
                47.5622043,
                33.0762957
              ],
              [
                47.556091,
                33.0790766
              ],
              [
                47.5522045,
                33.0860199
              ],
              [
                47.5499811,
                33.0871304
              ],
              [
                47.5491478,
                33.0871304
              ],
              [
                47.5469244,
                33.08546
              ],
              [
                47.5458403,
                33.0818492
              ],
              [
                47.5440654,
                33.0815966
              ],
              [
                47.5432435,
                33.081301
              ],
              [
                47.541999,
                33.0808941
              ],
              [
                47.5403342,
                33.0814237
              ],
              [
                47.539566,
                33.0828297
              ],
              [
                47.5376454,
                33.0844568
              ],
              [
                47.5328328,
                33.0835832
              ],
              [
                47.5291479,
                33.0857399
              ],
              [
                47.5305451,
                33.088101
              ],
              [
                47.527758,
                33.0904621
              ],
              [
                47.5256132,
                33.0922632
              ],
              [
                47.5255392,
                33.0934766
              ],
              [
                47.5259884,
                33.0958458
              ],
              [
                47.5254563,
                33.0990389
              ],
              [
                47.5226399,
                33.1013522
              ],
              [
                47.5236166,
                33.1042694
              ],
              [
                47.5233055,
                33.1053696
              ],
              [
                47.5222314,
                33.1062316
              ],
              [
                47.5191274,
                33.1069899
              ],
              [
                47.5146359,
                33.1041982
              ],
              [
                47.5133302,
                33.1022425
              ],
              [
                47.5116447,
                33.1015767
              ],
              [
                47.5107208,
                33.1017614
              ],
              [
                47.5101803,
                33.1018585
              ],
              [
                47.5092308,
                33.1019952
              ],
              [
                47.5086514,
                33.1021194
              ],
              [
                47.5083352,
                33.1023843
              ],
              [
                47.508061,
                33.102614
              ],
              [
                47.5057499,
                33.103622
              ],
              [
                47.5013386,
                33.1049149
              ],
              [
                47.499645,
                33.1073299
              ],
              [
                47.4955276,
                33.1128952
              ],
              [
                47.4922255,
                33.1134397
              ],
              [
                47.4896619,
                33.1149593
              ],
              [
                47.4914894,
                33.1170929
              ],
              [
                47.4919216,
                33.1182439
              ],
              [
                47.4866449,
                33.1207449
              ],
              [
                47.4844218,
                33.123246
              ],
              [
                47.4827441,
                33.1239906
              ],
              [
                47.4814727,
                33.1255496
              ],
              [
                47.4818534,
                33.1278483
              ],
              [
                47.4847745,
                33.1292705
              ],
              [
                47.487262,
                33.1299219
              ],
              [
                47.4886482,
                33.129211
              ],
              [
                47.4894187,
                33.1294441
              ],
              [
                47.4898592,
                33.1297199
              ],
              [
                47.4901227,
                33.1314066
              ],
              [
                47.4880533,
                33.1327125
              ],
              [
                47.4794217,
                33.1349022
              ],
              [
                47.4769216,
                33.1376922
              ],
              [
                47.4766451,
                33.1385138
              ],
              [
                47.4763649,
                33.1401841
              ],
              [
                47.4758119,
                33.1424142
              ],
              [
                47.4758119,
                33.142965
              ],
              [
                47.474145,
                33.1446263
              ],
              [
                47.474145,
                33.1449062
              ],
              [
                47.4733118,
                33.1449062
              ],
              [
                47.4730317,
                33.1451861
              ],
              [
                47.4727551,
                33.145457
              ],
              [
                47.4719219,
                33.1454569
              ],
              [
                47.4719219,
                33.1457368
              ],
              [
                47.4710887,
                33.1457368
              ],
              [
                47.4710887,
                33.1460258
              ],
              [
                47.4705321,
                33.1460258
              ],
              [
                47.4699785,
                33.1462966
              ],
              [
                47.4671398,
                33.1478451
              ],
              [
                47.4608087,
                33.1512986
              ],
              [
                47.4563654,
                33.1512986
              ],
              [
                47.4560888,
                33.1515785
              ],
              [
                47.4538652,
                33.1515785
              ],
              [
                47.4505321,
                33.1521292
              ],
              [
                47.4499753,
                33.1524092
              ],
              [
                47.4494222,
                33.1524091
              ],
              [
                47.4491421,
                33.152689
              ],
              [
                47.448589,
                33.1526891
              ],
              [
                47.448589,
                33.152969
              ],
              [
                47.4474753,
                33.1529689
              ],
              [
                47.4458089,
                33.1535197
              ],
              [
                47.444419,
                33.1535196
              ],
              [
                47.444142,
                33.1537996
              ],
              [
                47.4413655,
                33.1537995
              ],
              [
                47.4408087,
                33.1535196
              ],
              [
                47.4402521,
                33.1535197
              ],
              [
                47.4391423,
                33.1532397
              ],
              [
                47.4374755,
                33.1532398
              ],
              [
                47.4358091,
                33.1551899
              ],
              [
                47.435809,
                33.1590724
              ],
              [
                47.4371989,
                33.169907
              ],
              [
                47.4369188,
                33.1704668
              ],
              [
                47.4333089,
                33.1724079
              ],
              [
                47.4327522,
                33.1724079
              ],
              [
                47.4313656,
                33.1740692
              ],
              [
                47.4308088,
                33.1743491
              ],
              [
                47.4308088,
                33.1749089
              ],
              [
                47.4302523,
                33.1754597
              ],
              [
                47.4302522,
                33.1760195
              ],
              [
                47.4299756,
                33.1762994
              ],
              [
                47.4299757,
                33.1765791
              ],
              [
                47.429419,
                33.1768591
              ],
              [
                47.4255291,
                33.1768591
              ],
              [
                47.4252526,
                33.1765792
              ],
              [
                47.4241424,
                33.1765792
              ],
              [
                47.4238627,
                33.1762993
              ],
              [
                47.4224759,
                33.1762993
              ],
              [
                47.4221954,
                33.1760194
              ],
              [
                47.4188625,
                33.1760194
              ],
              [
                47.4158093,
                33.17713
              ],
              [
                47.4149757,
                33.1779696
              ],
              [
                47.4152524,
                33.1788003
              ],
              [
                47.4188625,
                33.1804616
              ],
              [
                47.4199759,
                33.1813013
              ],
              [
                47.4196953,
                33.1815721
              ],
              [
                47.4194188,
                33.1821319
              ],
              [
                47.4194188,
                33.1824118
              ],
              [
                47.4158094,
                33.1857434
              ],
              [
                47.4069193,
                33.1888041
              ],
              [
                47.4060857,
                33.1888042
              ],
              [
                47.4030294,
                33.1907454
              ],
              [
                47.3996957,
                33.1976884
              ],
              [
                47.3952526,
                33.1990699
              ],
              [
                47.3919197,
                33.1968488
              ],
              [
                47.3905292,
                33.1965779
              ],
              [
                47.3894157,
                33.1965779
              ],
              [
                47.3877493,
                33.1974085
              ],
              [
                47.3871962,
                33.1979593
              ],
              [
                47.3863626,
                33.1982391
              ],
              [
                47.3808062,
                33.2046315
              ],
              [
                47.3749733,
                33.2093536
              ],
              [
                47.3719162,
                33.2104641
              ],
              [
                47.3680262,
                33.210464
              ],
              [
                47.3602496,
                33.2035209
              ],
              [
                47.3583066,
                33.2024104
              ],
              [
                47.3571933,
                33.2024104
              ],
              [
                47.3566401,
                33.2021305
              ],
              [
                47.3538596,
                33.2060219
              ],
              [
                47.3535831,
                33.2062927
              ],
              [
                47.3533065,
                33.2088028
              ],
              [
                47.3530268,
                33.210464
              ],
              [
                47.3527502,
                33.2132449
              ],
              [
                47.3527501,
                33.2146262
              ],
              [
                47.3524735,
                33.215186
              ],
              [
                47.3510829,
                33.2174071
              ],
              [
                47.3508032,
                33.2179669
              ],
              [
                47.3469164,
                33.2190774
              ],
              [
                47.3444164,
                33.2190774
              ],
              [
                47.338303,
                33.2162965
              ],
              [
                47.3360834,
                33.2162965
              ],
              [
                47.3330271,
                33.2174071
              ],
              [
                47.3313599,
                33.2193572
              ],
              [
                47.3310802,
                33.2218491
              ],
              [
                47.3283036,
                33.2249099
              ],
              [
                47.3263606,
                33.2249099
              ],
              [
                47.3258035,
                33.22463
              ],
              [
                47.3246933,
                33.2246299
              ],
              [
                47.3199706,
                33.2224089
              ],
              [
                47.3169135,
                33.2212984
              ],
              [
                47.3119134,
                33.2204677
              ],
              [
                47.3099704,
                33.2226888
              ],
              [
                47.3105235,
                33.2265801
              ],
              [
                47.310804,
                33.2271309
              ],
              [
                47.3105235,
                33.2276906
              ],
              [
                47.3094133,
                33.2299118
              ],
              [
                47.3085805,
                33.2301826
              ],
              [
                47.308304,
                33.2304715
              ],
              [
                47.3074704,
                33.2304715
              ],
              [
                47.3033038,
                33.2274107
              ],
              [
                47.3021906,
                33.2274107
              ],
              [
                47.301914,
                33.2271309
              ],
              [
                47.3013569,
                33.2271309
              ],
              [
                47.2991373,
                33.2274107
              ],
              [
                47.2971904,
                33.2296319
              ],
              [
                47.2974709,
                33.2321327
              ],
              [
                47.2971904,
                33.2324126
              ],
              [
                47.2883004,
                33.2379652
              ],
              [
                47.2860808,
                33.2379652
              ],
              [
                47.2808011,
                33.233794
              ],
              [
                47.2771908,
                33.2310222
              ],
              [
                47.2749674,
                33.2310222
              ],
              [
                47.2733009,
                33.2315729
              ],
              [
                47.2713579,
                33.2329634
              ],
              [
                47.2702438,
                33.2346336
              ],
              [
                47.2694109,
                33.2368547
              ],
              [
                47.2660772,
                33.2451881
              ],
              [
                47.2594107,
                33.2496303
              ],
              [
                47.2588576,
                33.2501901
              ],
              [
                47.2552443,
                33.2515713
              ],
              [
                47.2552442,
                33.2518513
              ],
              [
                47.2546879,
                33.2518512
              ],
              [
                47.2544114,
                33.2521312
              ],
              [
                47.2524676,
                33.2521311
              ],
              [
                47.2505206,
                33.2510206
              ],
              [
                47.2474675,
                33.2462986
              ],
              [
                47.2474675,
                33.2460187
              ],
              [
                47.2480215,
                33.245468
              ],
              [
                47.2458011,
                33.2357441
              ],
              [
                47.2444113,
                33.2332432
              ],
              [
                47.2199647,
                33.2110235
              ],
              [
                47.2155217,
                33.2004688
              ],
              [
                47.2146881,
                33.197688
              ],
              [
                47.2121881,
                33.17824
              ],
              [
                47.2116319,
                33.1712968
              ],
              [
                47.2083005,
                33.1437564
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 903794,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مهران",
          "name:en": "Mehran County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291671",
          "wikipedia": "en:Mehran County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.8747964,
                33.4930667
              ],
              [
                45.878907,
                33.490602
              ],
              [
                45.879607,
                33.490745
              ],
              [
                45.881584,
                33.4916
              ],
              [
                45.882042,
                33.491907
              ],
              [
                45.883615,
                33.492517
              ],
              [
                45.884497,
                33.492391
              ],
              [
                45.887514,
                33.493785
              ],
              [
                45.889325,
                33.493625
              ],
              [
                45.889806,
                33.49369
              ],
              [
                45.890318,
                33.493937
              ],
              [
                45.890894,
                33.493964
              ],
              [
                45.891338,
                33.493717
              ],
              [
                45.891806,
                33.493543
              ],
              [
                45.892872,
                33.492893
              ],
              [
                45.893313,
                33.492701
              ],
              [
                45.893984,
                33.49273
              ],
              [
                45.89424,
                33.492424
              ],
              [
                45.895132,
                33.492255
              ],
              [
                45.895935,
                33.492184
              ],
              [
                45.896647,
                33.492059
              ],
              [
                45.898635,
                33.492469
              ],
              [
                45.899222,
                33.492834
              ],
              [
                45.899415,
                33.492778
              ],
              [
                45.899724,
                33.492537
              ],
              [
                45.900151,
                33.492436
              ],
              [
                45.900376,
                33.491631
              ],
              [
                45.900737,
                33.491508
              ],
              [
                45.901454,
                33.491905
              ],
              [
                45.902635,
                33.492027
              ],
              [
                45.904154,
                33.490995
              ],
              [
                45.905,
                33.490055
              ],
              [
                45.905232,
                33.489955
              ],
              [
                45.90554,
                33.489638
              ],
              [
                45.906038,
                33.488907
              ],
              [
                45.906681,
                33.489031
              ],
              [
                45.90769,
                33.489724
              ],
              [
                45.907991,
                33.489829
              ],
              [
                45.909336,
                33.489833
              ],
              [
                45.90978,
                33.489764
              ],
              [
                45.910271,
                33.489792
              ],
              [
                45.910761,
                33.489642
              ],
              [
                45.911697,
                33.489582
              ],
              [
                45.912217,
                33.489633
              ],
              [
                45.912669,
                33.48974
              ],
              [
                45.912964,
                33.48994
              ],
              [
                45.913385,
                33.49048
              ],
              [
                45.915795,
                33.490662
              ],
              [
                45.916186,
                33.490847
              ],
              [
                45.916687,
                33.490908
              ],
              [
                45.917105,
                33.490845
              ],
              [
                45.917815,
                33.49051
              ],
              [
                45.91795,
                33.490285
              ],
              [
                45.918214,
                33.490038
              ],
              [
                45.918573,
                33.490082
              ],
              [
                45.918827,
                33.489979
              ],
              [
                45.919311,
                33.490096
              ],
              [
                45.920044,
                33.489987
              ],
              [
                45.920341,
                33.490105
              ],
              [
                45.920773,
                33.490062
              ],
              [
                45.921179,
                33.490227
              ],
              [
                45.921675,
                33.490271
              ],
              [
                45.922366,
                33.490472
              ],
              [
                45.923107,
                33.490385
              ],
              [
                45.923405,
                33.490639
              ],
              [
                45.923737,
                33.490796
              ],
              [
                45.924123,
                33.490746
              ],
              [
                45.925132,
                33.490469
              ],
              [
                45.925462,
                33.490556
              ],
              [
                45.925937,
                33.490492
              ],
              [
                45.926891,
                33.490683
              ],
              [
                45.927204,
                33.490673
              ],
              [
                45.927653,
                33.490727
              ],
              [
                45.92858,
                33.490705
              ],
              [
                45.928815,
                33.490984
              ],
              [
                45.928789,
                33.491256
              ],
              [
                45.929463,
                33.491142
              ],
              [
                45.9299,
                33.49127
              ],
              [
                45.930286,
                33.491504
              ],
              [
                45.930861,
                33.49133
              ],
              [
                45.931301,
                33.491445
              ],
              [
                45.931667,
                33.491311
              ],
              [
                45.931968,
                33.491286
              ],
              [
                45.932308,
                33.491358
              ],
              [
                45.932519,
                33.491566
              ],
              [
                45.932987,
                33.491756
              ],
              [
                45.933292,
                33.49182
              ],
              [
                45.933395,
                33.49193
              ],
              [
                45.934085,
                33.492095
              ],
              [
                45.93453,
                33.491411
              ],
              [
                45.934957,
                33.491139
              ],
              [
                45.936015,
                33.490699
              ],
              [
                45.936239,
                33.490429
              ],
              [
                45.936603,
                33.490119
              ],
              [
                45.936945,
                33.48992
              ],
              [
                45.937166,
                33.489434
              ],
              [
                45.936938,
                33.488571
              ],
              [
                45.936998,
                33.488368
              ],
              [
                45.937522,
                33.487637
              ],
              [
                45.937558,
                33.487414
              ],
              [
                45.937712,
                33.487177
              ],
              [
                45.938264,
                33.486983
              ],
              [
                45.938909,
                33.486631
              ],
              [
                45.939226,
                33.486269
              ],
              [
                45.939231,
                33.486
              ],
              [
                45.939117,
                33.485582
              ],
              [
                45.9387,
                33.48535
              ],
              [
                45.938439,
                33.485064
              ],
              [
                45.938161,
                33.484621
              ],
              [
                45.938124,
                33.48413
              ],
              [
                45.938164,
                33.483468
              ],
              [
                45.938028,
                33.483149
              ],
              [
                45.938178,
                33.482565
              ],
              [
                45.938315,
                33.482223
              ],
              [
                45.938446,
                33.482046
              ],
              [
                45.939108,
                33.48189
              ],
              [
                45.939491,
                33.481894
              ],
              [
                45.940014,
                33.482557
              ],
              [
                45.94068,
                33.482716
              ],
              [
                45.942956,
                33.483493
              ],
              [
                45.943443,
                33.484224
              ],
              [
                45.943609,
                33.484853
              ],
              [
                45.944044,
                33.485079
              ],
              [
                45.944151,
                33.485441
              ],
              [
                45.944382,
                33.485783
              ],
              [
                45.944739,
                33.486085
              ],
              [
                45.945332,
                33.486148
              ],
              [
                45.945678,
                33.486517
              ],
              [
                45.945898,
                33.486917
              ],
              [
                45.946525,
                33.486893
              ],
              [
                45.946857,
                33.487033
              ],
              [
                45.94721,
                33.487059
              ],
              [
                45.947408,
                33.48744
              ],
              [
                45.947978,
                33.487502
              ],
              [
                45.948219,
                33.487634
              ],
              [
                45.94859,
                33.488223
              ],
              [
                45.949094,
                33.488505
              ],
              [
                45.949397,
                33.489123
              ],
              [
                45.950297,
                33.489183
              ],
              [
                45.95112,
                33.48934
              ],
              [
                45.951592,
                33.489644
              ],
              [
                45.952281,
                33.489809
              ],
              [
                45.952798,
                33.48969
              ],
              [
                45.953442,
                33.489683
              ],
              [
                45.953712,
                33.489517
              ],
              [
                45.953933,
                33.489491
              ],
              [
                45.954158,
                33.489519
              ],
              [
                45.954473,
                33.489472
              ],
              [
                45.954751,
                33.48973
              ],
              [
                45.954431,
                33.490189
              ],
              [
                45.954049,
                33.490495
              ],
              [
                45.953896,
                33.490674
              ],
              [
                45.953899,
                33.490838
              ],
              [
                45.954005,
                33.49104
              ],
              [
                45.953951,
                33.49125
              ],
              [
                45.953978,
                33.492001
              ],
              [
                45.954053,
                33.49233
              ],
              [
                45.954039,
                33.492661
              ],
              [
                45.95413,
                33.492896
              ],
              [
                45.954347,
                33.492978
              ],
              [
                45.9544,
                33.493128
              ],
              [
                45.954945,
                33.493487
              ],
              [
                45.955065,
                33.493644
              ],
              [
                45.955243,
                33.494243
              ],
              [
                45.955136,
                33.494565
              ],
              [
                45.955143,
                33.49475
              ],
              [
                45.95541,
                33.494919
              ],
              [
                45.955603,
                33.495124
              ],
              [
                45.9559,
                33.495298
              ],
              [
                45.956579,
                33.49544
              ],
              [
                45.956826,
                33.495371
              ],
              [
                45.956929,
                33.495445
              ],
              [
                45.957024,
                33.496119
              ],
              [
                45.957214,
                33.496349
              ],
              [
                45.957381,
                33.497267
              ],
              [
                45.957528,
                33.497637
              ],
              [
                45.957626,
                33.497796
              ],
              [
                45.957927,
                33.497903
              ],
              [
                45.958071,
                33.498099
              ],
              [
                45.958239,
                33.498671
              ],
              [
                45.958411,
                33.498855
              ],
              [
                45.958673,
                33.498921
              ],
              [
                45.959023,
                33.498935
              ],
              [
                45.959599,
                33.498654
              ],
              [
                45.959773,
                33.498491
              ],
              [
                45.959888,
                33.498294
              ],
              [
                45.960035,
                33.498241
              ],
              [
                45.960197,
                33.498252
              ],
              [
                45.960606,
                33.498866
              ],
              [
                45.960625,
                33.499009
              ],
              [
                45.960559,
                33.49916
              ],
              [
                45.960725,
                33.499845
              ],
              [
                45.961395,
                33.500707
              ],
              [
                45.961596,
                33.500817
              ],
              [
                45.961975,
                33.50081
              ],
              [
                45.962228,
                33.501209
              ],
              [
                45.962932,
                33.501449
              ],
              [
                45.963219,
                33.501339
              ],
              [
                45.963427,
                33.501337
              ],
              [
                45.963859,
                33.501132
              ],
              [
                45.964139,
                33.501185
              ],
              [
                45.964285,
                33.501345
              ],
              [
                45.96456,
                33.501944
              ],
              [
                45.964851,
                33.502077
              ],
              [
                45.96504,
                33.502085
              ],
              [
                45.965682,
                33.501739
              ],
              [
                45.965899,
                33.5017
              ],
              [
                45.966139,
                33.501499
              ],
              [
                45.966613,
                33.501598
              ],
              [
                45.967248,
                33.501452
              ],
              [
                45.967481,
                33.501459
              ],
              [
                45.968076,
                33.501127
              ],
              [
                45.968148,
                33.500951
              ],
              [
                45.968133,
                33.500818
              ],
              [
                45.968334,
                33.50075
              ],
              [
                45.968889,
                33.501041
              ],
              [
                45.969594,
                33.500779
              ],
              [
                45.970085,
                33.500918
              ],
              [
                45.970553,
                33.501163
              ],
              [
                45.971199,
                33.501293
              ],
              [
                45.97163,
                33.501511
              ],
              [
                45.972029,
                33.501984
              ],
              [
                45.972208,
                33.502092
              ],
              [
                45.972913,
                33.502356
              ],
              [
                45.973242,
                33.502265
              ],
              [
                45.973461,
                33.502122
              ],
              [
                45.973807,
                33.5023
              ],
              [
                45.973902,
                33.502415
              ],
              [
                45.974175,
                33.502437
              ],
              [
                45.974547,
                33.502739
              ],
              [
                45.975594,
                33.503016
              ],
              [
                45.975759,
                33.503104
              ],
              [
                45.976143,
                33.503445
              ],
              [
                45.976924,
                33.503307
              ],
              [
                45.977288,
                33.503386
              ],
              [
                45.977611,
                33.503581
              ],
              [
                45.977889,
                33.503661
              ],
              [
                45.977988,
                33.503965
              ],
              [
                45.978328,
                33.504238
              ],
              [
                45.978366,
                33.504419
              ],
              [
                45.978661,
                33.504442
              ],
              [
                45.978794,
                33.504496
              ],
              [
                45.978915,
                33.505169
              ],
              [
                45.979124,
                33.505352
              ],
              [
                45.979334,
                33.50567
              ],
              [
                45.979588,
                33.505589
              ],
              [
                45.979779,
                33.505388
              ],
              [
                45.980025,
                33.505221
              ],
              [
                45.980115,
                33.505773
              ],
              [
                45.980286,
                33.505788
              ],
              [
                45.980563,
                33.505707
              ],
              [
                45.981406,
                33.505869
              ],
              [
                45.981512,
                33.506194
              ],
              [
                45.982228,
                33.506734
              ],
              [
                45.982635,
                33.506945
              ],
              [
                45.982828,
                33.507097
              ],
              [
                45.983053,
                33.507125
              ],
              [
                45.983539,
                33.50746
              ],
              [
                45.984002,
                33.507691
              ],
              [
                45.984343,
                33.507616
              ],
              [
                45.984796,
                33.507389
              ],
              [
                45.985212,
                33.50754
              ],
              [
                45.985628,
                33.507616
              ],
              [
                45.986195,
                33.507502
              ],
              [
                45.987291,
                33.506935
              ],
              [
                45.988463,
                33.506708
              ],
              [
                45.98937,
                33.507767
              ],
              [
                45.98971,
                33.507994
              ],
              [
                45.98997,
                33.508059
              ],
              [
                45.990527,
                33.507871
              ],
              [
                45.990733,
                33.507689
              ],
              [
                45.990933,
                33.507597
              ],
              [
                45.991057,
                33.507623
              ],
              [
                45.991301,
                33.507581
              ],
              [
                45.991857,
                33.507257
              ],
              [
                45.992001,
                33.507391
              ],
              [
                45.992267,
                33.507521
              ],
              [
                45.992758,
                33.507572
              ],
              [
                45.99301,
                33.50764
              ],
              [
                45.99318,
                33.507851
              ],
              [
                45.993486,
                33.507866
              ],
              [
                45.993694,
                33.507974
              ],
              [
                45.994008,
                33.508011
              ],
              [
                45.994597,
                33.50801
              ],
              [
                45.994703,
                33.508182
              ],
              [
                45.99485,
                33.508256
              ],
              [
                45.995164,
                33.508316
              ],
              [
                45.995697,
                33.50834
              ],
              [
                45.996189,
                33.508285
              ],
              [
                45.997384,
                33.510413
              ],
              [
                45.998291,
                33.511585
              ],
              [
                45.998782,
                33.511471
              ],
              [
                45.998971,
                33.511282
              ],
              [
                45.999047,
                33.510866
              ],
              [
                45.999236,
                33.510791
              ],
              [
                45.999916,
                33.511093
              ],
              [
                46.000294,
                33.511207
              ],
              [
                46.000634,
                33.511093
              ],
              [
                46.000861,
                33.510942
              ],
              [
                46.00105,
                33.510299
              ],
              [
                46.001579,
                33.509921
              ],
              [
                46.002897,
                33.509754
              ],
              [
                46.003502,
                33.509551
              ],
              [
                46.003843,
                33.509298
              ],
              [
                46.004047,
                33.509064
              ],
              [
                46.003988,
                33.508882
              ],
              [
                46.00405,
                33.508655
              ],
              [
                46.004318,
                33.508484
              ],
              [
                46.004858,
                33.5084
              ],
              [
                46.005128,
                33.508192
              ],
              [
                46.005461,
                33.508136
              ],
              [
                46.005839,
                33.507993
              ],
              [
                46.006174,
                33.507919
              ],
              [
                46.00658,
                33.50793
              ],
              [
                46.007252,
                33.50781
              ],
              [
                46.007403,
                33.507546
              ],
              [
                46.007762,
                33.507171
              ],
              [
                46.00786,
                33.506724
              ],
              [
                46.00772,
                33.506341
              ],
              [
                46.007692,
                33.50575
              ],
              [
                46.007938,
                33.505447
              ],
              [
                46.00795,
                33.505066
              ],
              [
                46.008194,
                33.504491
              ],
              [
                46.008136,
                33.504096
              ],
              [
                46.007669,
                33.503833
              ],
              [
                46.007604,
                33.503611
              ],
              [
                46.007628,
                33.503333
              ],
              [
                46.00754,
                33.503063
              ],
              [
                46.007576,
                33.502647
              ],
              [
                46.007364,
                33.502085
              ],
              [
                46.007346,
                33.501746
              ],
              [
                46.007235,
                33.501493
              ],
              [
                46.007317,
                33.501043
              ],
              [
                46.007486,
                33.500615
              ],
              [
                46.007502,
                33.500245
              ],
              [
                46.007424,
                33.500138
              ],
              [
                46.007465,
                33.49923
              ],
              [
                46.007382,
                33.498911
              ],
              [
                46.007472,
                33.498637
              ],
              [
                46.007438,
                33.498313
              ],
              [
                46.007536,
                33.497647
              ],
              [
                46.00742,
                33.497312
              ],
              [
                46.007407,
                33.497054
              ],
              [
                46.007184,
                33.496678
              ],
              [
                46.006889,
                33.496306
              ],
              [
                46.006996,
                33.495797
              ],
              [
                46.006849,
                33.495546
              ],
              [
                46.006935,
                33.495083
              ],
              [
                46.00684,
                33.494749
              ],
              [
                46.007012,
                33.493647
              ],
              [
                46.006858,
                33.493527
              ],
              [
                46.006424,
                33.491826
              ],
              [
                46.005809,
                33.490826
              ],
              [
                46.00503,
                33.490136
              ],
              [
                46.004847,
                33.489685
              ],
              [
                46.004806,
                33.489428
              ],
              [
                46.004651,
                33.489131
              ],
              [
                46.004954,
                33.488585
              ],
              [
                46.005751,
                33.488385
              ],
              [
                46.006678,
                33.488298
              ],
              [
                46.007078,
                33.488115
              ],
              [
                46.007801,
                33.487488
              ],
              [
                46.007865,
                33.486829
              ],
              [
                46.008076,
                33.486593
              ],
              [
                46.008315,
                33.486469
              ],
              [
                46.008852,
                33.486374
              ],
              [
                46.009176,
                33.486201
              ],
              [
                46.009418,
                33.485929
              ],
              [
                46.009564,
                33.485672
              ],
              [
                46.009573,
                33.485457
              ],
              [
                46.009682,
                33.485262
              ],
              [
                46.009869,
                33.485066
              ],
              [
                46.010519,
                33.484657
              ],
              [
                46.011309,
                33.484239
              ],
              [
                46.012103,
                33.484205
              ],
              [
                46.01238,
                33.484108
              ],
              [
                46.012564,
                33.483813
              ],
              [
                46.013218,
                33.483065
              ],
              [
                46.013343,
                33.482635
              ],
              [
                46.013525,
                33.482335
              ],
              [
                46.013855,
                33.482025
              ],
              [
                46.014513,
                33.481643
              ],
              [
                46.014791,
                33.48157
              ],
              [
                46.015173,
                33.481639
              ],
              [
                46.015953,
                33.481957
              ],
              [
                46.016406,
                33.481981
              ],
              [
                46.016677,
                33.482063
              ],
              [
                46.016812,
                33.482542
              ],
              [
                46.016924,
                33.482665
              ],
              [
                46.017845,
                33.482668
              ],
              [
                46.018047,
                33.482404
              ],
              [
                46.018392,
                33.482251
              ],
              [
                46.018816,
                33.482405
              ],
              [
                46.019184,
                33.482785
              ],
              [
                46.019354,
                33.483126
              ],
              [
                46.019331,
                33.483847
              ],
              [
                46.01886,
                33.484584
              ],
              [
                46.018373,
                33.485005
              ],
              [
                46.018446,
                33.485757
              ],
              [
                46.018636,
                33.486053
              ],
              [
                46.018929,
                33.486112
              ],
              [
                46.019278,
                33.486058
              ],
              [
                46.019647,
                33.485693
              ],
              [
                46.020892,
                33.485258
              ],
              [
                46.021492,
                33.485249
              ],
              [
                46.023258,
                33.484242
              ],
              [
                46.023926,
                33.483583
              ],
              [
                46.024556,
                33.482844
              ],
              [
                46.025194,
                33.481926
              ],
              [
                46.025945,
                33.481181
              ],
              [
                46.026532,
                33.480308
              ],
              [
                46.026474,
                33.480057
              ],
              [
                46.026046,
                33.479944
              ],
              [
                46.026031,
                33.479553
              ],
              [
                46.026139,
                33.479195
              ],
              [
                46.026457,
                33.478686
              ],
              [
                46.026812,
                33.47747
              ],
              [
                46.027269,
                33.47724
              ],
              [
                46.02732,
                33.476454
              ],
              [
                46.028064,
                33.474977
              ],
              [
                46.028118,
                33.474707
              ],
              [
                46.027987,
                33.474379
              ],
              [
                46.027891,
                33.47377
              ],
              [
                46.027983,
                33.473141
              ],
              [
                46.0281847,
                33.4729167
              ],
              [
                46.02859,
                33.472466
              ],
              [
                46.029636,
                33.471775
              ],
              [
                46.030447,
                33.471572
              ],
              [
                46.031259,
                33.471154
              ],
              [
                46.031401,
                33.469921
              ],
              [
                46.031754,
                33.469346
              ],
              [
                46.032391,
                33.468926
              ],
              [
                46.03194,
                33.468471
              ],
              [
                46.031986,
                33.46825
              ],
              [
                46.032787,
                33.467805
              ],
              [
                46.033497,
                33.467562
              ],
              [
                46.033436,
                33.467015
              ],
              [
                46.03347,
                33.466355
              ],
              [
                46.033976,
                33.465291
              ],
              [
                46.034102,
                33.464845
              ],
              [
                46.034419,
                33.464456
              ],
              [
                46.034521,
                33.463941
              ],
              [
                46.034236,
                33.46347
              ],
              [
                46.03445,
                33.463184
              ],
              [
                46.03505,
                33.463032
              ],
              [
                46.035679,
                33.462761
              ],
              [
                46.035649,
                33.462378
              ],
              [
                46.035528,
                33.461977
              ],
              [
                46.035927,
                33.461372
              ],
              [
                46.036502,
                33.461247
              ],
              [
                46.036768,
                33.460955
              ],
              [
                46.036788,
                33.460469
              ],
              [
                46.036564,
                33.460143
              ],
              [
                46.036518,
                33.45946
              ],
              [
                46.036196,
                33.458726
              ],
              [
                46.036701,
                33.458442
              ],
              [
                46.037314,
                33.458174
              ],
              [
                46.037668,
                33.457698
              ],
              [
                46.037844,
                33.45671
              ],
              [
                46.03783,
                33.456071
              ],
              [
                46.038414,
                33.455586
              ],
              [
                46.039054,
                33.4554
              ],
              [
                46.03938,
                33.455158
              ],
              [
                46.039666,
                33.454442
              ],
              [
                46.039599,
                33.45402
              ],
              [
                46.038285,
                33.453707
              ],
              [
                46.038264,
                33.453346
              ],
              [
                46.038659,
                33.45278
              ],
              [
                46.039436,
                33.452079
              ],
              [
                46.040408,
                33.451306
              ],
              [
                46.041133,
                33.450268
              ],
              [
                46.041438,
                33.449655
              ],
              [
                46.042188,
                33.449312
              ],
              [
                46.042784,
                33.449266
              ],
              [
                46.042987,
                33.448542
              ],
              [
                46.043553,
                33.447772
              ],
              [
                46.044604,
                33.447238
              ],
              [
                46.043648,
                33.445598
              ],
              [
                46.042767,
                33.445049
              ],
              [
                46.042053,
                33.444899
              ],
              [
                46.041533,
                33.444544
              ],
              [
                46.041076,
                33.44396
              ],
              [
                46.040413,
                33.443336
              ],
              [
                46.039677,
                33.443065
              ],
              [
                46.038447,
                33.443077
              ],
              [
                46.037858,
                33.442978
              ],
              [
                46.037337,
                33.442738
              ],
              [
                46.036655,
                33.442824
              ],
              [
                46.036092,
                33.442732
              ],
              [
                46.035966,
                33.442624
              ],
              [
                46.036425,
                33.441774
              ],
              [
                46.036809,
                33.441584
              ],
              [
                46.037302,
                33.441435
              ],
              [
                46.038067,
                33.441031
              ],
              [
                46.038429,
                33.440507
              ],
              [
                46.038647,
                33.439927
              ],
              [
                46.039176,
                33.439581
              ],
              [
                46.039758,
                33.438914
              ],
              [
                46.040152,
                33.437954
              ],
              [
                46.040039,
                33.437701
              ],
              [
                46.040189,
                33.437424
              ],
              [
                46.040777,
                33.437093
              ],
              [
                46.040822,
                33.436544
              ],
              [
                46.041212,
                33.436293
              ],
              [
                46.041427,
                33.435944
              ],
              [
                46.041303,
                33.435453
              ],
              [
                46.041012,
                33.435149
              ],
              [
                46.040845,
                33.434847
              ],
              [
                46.040419,
                33.434781
              ],
              [
                46.040338,
                33.434524
              ],
              [
                46.040304,
                33.434095
              ],
              [
                46.040416,
                33.433308
              ],
              [
                46.040424,
                33.432865
              ],
              [
                46.0406,
                33.432364
              ],
              [
                46.040676,
                33.431378
              ],
              [
                46.041144,
                33.431062
              ],
              [
                46.041683,
                33.430829
              ],
              [
                46.043303,
                33.430333
              ],
              [
                46.044274,
                33.429954
              ],
              [
                46.044981,
                33.429295
              ],
              [
                46.045323,
                33.429087
              ],
              [
                46.045131,
                33.428411
              ],
              [
                46.045409,
                33.427971
              ],
              [
                46.045491,
                33.427141
              ],
              [
                46.045431,
                33.426449
              ],
              [
                46.045757,
                33.424272
              ],
              [
                46.04554,
                33.423277
              ],
              [
                46.045487,
                33.422501
              ],
              [
                46.045058,
                33.421754
              ],
              [
                46.045281,
                33.421136
              ],
              [
                46.045827,
                33.419973
              ],
              [
                46.046454,
                33.419305
              ],
              [
                46.047332,
                33.41903
              ],
              [
                46.047725,
                33.418732
              ],
              [
                46.048613,
                33.417784
              ],
              [
                46.048839,
                33.417737
              ],
              [
                46.049162,
                33.417575
              ],
              [
                46.049494,
                33.417193
              ],
              [
                46.049911,
                33.416478
              ],
              [
                46.049888,
                33.416048
              ],
              [
                46.050031,
                33.415791
              ],
              [
                46.049992,
                33.415096
              ],
              [
                46.05031,
                33.414817
              ],
              [
                46.051493,
                33.415167
              ],
              [
                46.051879,
                33.415192
              ],
              [
                46.052275,
                33.415113
              ],
              [
                46.053261,
                33.415225
              ],
              [
                46.053499,
                33.415119
              ],
              [
                46.053942,
                33.415082
              ],
              [
                46.054165,
                33.414689
              ],
              [
                46.054562,
                33.414453
              ],
              [
                46.054652,
                33.414211
              ],
              [
                46.054706,
                33.413836
              ],
              [
                46.055416,
                33.412772
              ],
              [
                46.05605,
                33.412444
              ],
              [
                46.056299,
                33.412155
              ],
              [
                46.0567,
                33.411415
              ],
              [
                46.057057,
                33.411352
              ],
              [
                46.057353,
                33.411195
              ],
              [
                46.057466,
                33.410896
              ],
              [
                46.057421,
                33.410533
              ],
              [
                46.057333,
                33.410295
              ],
              [
                46.058076,
                33.410018
              ],
              [
                46.058343,
                33.409764
              ],
              [
                46.059003,
                33.409461
              ],
              [
                46.059452,
                33.409101
              ],
              [
                46.05996,
                33.408338
              ],
              [
                46.060688,
                33.40822
              ],
              [
                46.061372,
                33.407619
              ],
              [
                46.061755,
                33.406659
              ],
              [
                46.062216,
                33.406123
              ],
              [
                46.063104,
                33.405478
              ],
              [
                46.064145,
                33.40463
              ],
              [
                46.064958,
                33.403516
              ],
              [
                46.065228,
                33.403041
              ],
              [
                46.065488,
                33.401958
              ],
              [
                46.065905,
                33.401667
              ],
              [
                46.066803,
                33.401868
              ],
              [
                46.067948,
                33.401947
              ],
              [
                46.068862,
                33.402293
              ],
              [
                46.069427,
                33.40214
              ],
              [
                46.070142,
                33.40159
              ],
              [
                46.070805,
                33.40124
              ],
              [
                46.070969,
                33.399701
              ],
              [
                46.070538,
                33.399119
              ],
              [
                46.069986,
                33.398672
              ],
              [
                46.069956,
                33.397967
              ],
              [
                46.070438,
                33.397603
              ],
              [
                46.072092,
                33.397286
              ],
              [
                46.072502,
                33.39672
              ],
              [
                46.072254,
                33.396042
              ],
              [
                46.072136,
                33.395522
              ],
              [
                46.072123,
                33.394843
              ],
              [
                46.072694,
                33.393022
              ],
              [
                46.073369,
                33.392008
              ],
              [
                46.073676,
                33.391307
              ],
              [
                46.074288,
                33.390982
              ],
              [
                46.075112,
                33.390842
              ],
              [
                46.075698,
                33.391229
              ],
              [
                46.076484,
                33.391058
              ],
              [
                46.076901,
                33.390591
              ],
              [
                46.077601,
                33.389648
              ],
              [
                46.077612,
                33.389223
              ],
              [
                46.077443,
                33.388913
              ],
              [
                46.077697,
                33.388411
              ],
              [
                46.078016,
                33.387948
              ],
              [
                46.07792,
                33.362124
              ],
              [
                46.078909,
                33.361528
              ],
              [
                46.079442,
                33.361033
              ],
              [
                46.079953,
                33.360017
              ],
              [
                46.079544,
                33.359114
              ],
              [
                46.078998,
                33.358689
              ],
              [
                46.078626,
                33.358478
              ],
              [
                46.077845,
                33.357458
              ],
              [
                46.079286,
                33.356635
              ],
              [
                46.08005,
                33.356541
              ],
              [
                46.081045,
                33.356309
              ],
              [
                46.082003,
                33.355585
              ],
              [
                46.08256,
                33.354697
              ],
              [
                46.082519,
                33.353647
              ],
              [
                46.0824,
                33.353219
              ],
              [
                46.081569,
                33.352677
              ],
              [
                46.080962,
                33.351755
              ],
              [
                46.08644,
                33.34745
              ],
              [
                46.087919,
                33.346863
              ],
              [
                46.088937,
                33.34638
              ],
              [
                46.089465,
                33.345927
              ],
              [
                46.089888,
                33.345251
              ],
              [
                46.089317,
                33.34472
              ],
              [
                46.08897,
                33.3443
              ],
              [
                46.088909,
                33.344138
              ],
              [
                46.089499,
                33.343834
              ],
              [
                46.090194,
                33.343616
              ],
              [
                46.090858,
                33.343299
              ],
              [
                46.091809,
                33.342244
              ],
              [
                46.092581,
                33.34225
              ],
              [
                46.094525,
                33.339891
              ],
              [
                46.094598,
                33.339729
              ],
              [
                46.095318,
                33.339174
              ],
              [
                46.095636,
                33.339127
              ],
              [
                46.095922,
                33.339291
              ],
              [
                46.096583,
                33.33915
              ],
              [
                46.097124,
                33.339185
              ],
              [
                46.098095,
                33.338795
              ],
              [
                46.098514,
                33.338171
              ],
              [
                46.098993,
                33.337856
              ],
              [
                46.099475,
                33.337741
              ],
              [
                46.099863,
                33.337753
              ],
              [
                46.100023,
                33.337656
              ],
              [
                46.100159,
                33.337146
              ],
              [
                46.1003,
                33.336931
              ],
              [
                46.102099,
                33.335443
              ],
              [
                46.102266,
                33.334678
              ],
              [
                46.102113,
                33.334281
              ],
              [
                46.102689,
                33.334051
              ],
              [
                46.103147,
                33.333948
              ],
              [
                46.103496,
                33.333396
              ],
              [
                46.104218,
                33.332929
              ],
              [
                46.104423,
                33.332716
              ],
              [
                46.10496,
                33.33291
              ],
              [
                46.105672,
                33.332941
              ],
              [
                46.107069,
                33.332493
              ],
              [
                46.10736,
                33.332204
              ],
              [
                46.107801,
                33.33214
              ],
              [
                46.108578,
                33.3317
              ],
              [
                46.10887,
                33.33158
              ],
              [
                46.108952,
                33.331389
              ],
              [
                46.109034,
                33.330909
              ],
              [
                46.109252,
                33.330916
              ],
              [
                46.109529,
                33.330995
              ],
              [
                46.109746,
                33.331142
              ],
              [
                46.110039,
                33.331167
              ],
              [
                46.110383,
                33.331064
              ],
              [
                46.110568,
                33.330911
              ],
              [
                46.111204,
                33.330662
              ],
              [
                46.111444,
                33.330732
              ],
              [
                46.111839,
                33.330723
              ],
              [
                46.112101,
                33.330572
              ],
              [
                46.11238,
                33.330155
              ],
              [
                46.112485,
                33.329913
              ],
              [
                46.112275,
                33.329392
              ],
              [
                46.112344,
                33.328909
              ],
              [
                46.112497,
                33.328767
              ],
              [
                46.113081,
                33.328522
              ],
              [
                46.113671,
                33.328302
              ],
              [
                46.114276,
                33.328188
              ],
              [
                46.114547,
                33.32803
              ],
              [
                46.114647,
                33.327598
              ],
              [
                46.114791,
                33.327277
              ],
              [
                46.114821,
                33.326899
              ],
              [
                46.114932,
                33.326848
              ],
              [
                46.11515,
                33.326902
              ],
              [
                46.115447,
                33.326874
              ],
              [
                46.115737,
                33.326718
              ],
              [
                46.116011,
                33.326472
              ],
              [
                46.116114,
                33.326319
              ],
              [
                46.115936,
                33.325952
              ],
              [
                46.115744,
                33.325739
              ],
              [
                46.115469,
                33.32524
              ],
              [
                46.115402,
                33.324895
              ],
              [
                46.115608,
                33.324563
              ],
              [
                46.115733,
                33.324235
              ],
              [
                46.116015,
                33.32393
              ],
              [
                46.116151,
                33.323647
              ],
              [
                46.116442,
                33.323496
              ],
              [
                46.116702,
                33.323051
              ],
              [
                46.116782,
                33.322731
              ],
              [
                46.116701,
                33.322207
              ],
              [
                46.116717,
                33.321915
              ],
              [
                46.116899,
                33.321054
              ],
              [
                46.116838,
                33.320832
              ],
              [
                46.116541,
                33.320575
              ],
              [
                46.116224,
                33.320451
              ],
              [
                46.11601,
                33.319817
              ],
              [
                46.115776,
                33.319626
              ],
              [
                46.115319,
                33.319383
              ],
              [
                46.114737,
                33.319281
              ],
              [
                46.114502,
                33.319106
              ],
              [
                46.114284,
                33.31886
              ],
              [
                46.114147,
                33.318445
              ],
              [
                46.114232,
                33.31829
              ],
              [
                46.114749,
                33.318036
              ],
              [
                46.114939,
                33.317878
              ],
              [
                46.115231,
                33.317779
              ],
              [
                46.115491,
                33.317623
              ],
              [
                46.115801,
                33.317262
              ],
              [
                46.115876,
                33.316969
              ],
              [
                46.116136,
                33.316622
              ],
              [
                46.116973,
                33.316046
              ],
              [
                46.117126,
                33.315879
              ],
              [
                46.117149,
                33.315663
              ],
              [
                46.117226,
                33.315545
              ],
              [
                46.117115,
                33.315234
              ],
              [
                46.116991,
                33.315137
              ],
              [
                46.116625,
                33.315074
              ],
              [
                46.116129,
                33.314796
              ],
              [
                46.115974,
                33.314664
              ],
              [
                46.11584,
                33.314357
              ],
              [
                46.11584,
                33.314212
              ],
              [
                46.11599,
                33.313797
              ],
              [
                46.116286,
                33.313546
              ],
              [
                46.116319,
                33.313323
              ],
              [
                46.116703,
                33.312405
              ],
              [
                46.116842,
                33.312183
              ],
              [
                46.11701,
                33.312101
              ],
              [
                46.117085,
                33.311907
              ],
              [
                46.117046,
                33.311795
              ],
              [
                46.116589,
                33.311577
              ],
              [
                46.1164,
                33.311187
              ],
              [
                46.116075,
                33.311152
              ],
              [
                46.115357,
                33.311303
              ],
              [
                46.115101,
                33.311095
              ],
              [
                46.115037,
                33.310713
              ],
              [
                46.11516,
                33.310044
              ],
              [
                46.115088,
                33.309296
              ],
              [
                46.115349,
                33.308996
              ],
              [
                46.115778,
                33.308742
              ],
              [
                46.116498,
                33.308478
              ],
              [
                46.116743,
                33.308449
              ],
              [
                46.116925,
                33.308354
              ],
              [
                46.117048,
                33.308234
              ],
              [
                46.117115,
                33.307745
              ],
              [
                46.117503,
                33.307417
              ],
              [
                46.117581,
                33.307087
              ],
              [
                46.11781,
                33.306901
              ],
              [
                46.117989,
                33.306672
              ],
              [
                46.118272,
                33.30661
              ],
              [
                46.118698,
                33.306699
              ],
              [
                46.118959,
                33.306688
              ],
              [
                46.119891,
                33.306525
              ],
              [
                46.120295,
                33.306287
              ],
              [
                46.121013,
                33.306328
              ],
              [
                46.121184,
                33.306282
              ],
              [
                46.121389,
                33.306141
              ],
              [
                46.121738,
                33.305793
              ],
              [
                46.122138,
                33.305612
              ],
              [
                46.122371,
                33.305369
              ],
              [
                46.12277,
                33.305131
              ],
              [
                46.123237,
                33.304576
              ],
              [
                46.123358,
                33.304497
              ],
              [
                46.123721,
                33.304447
              ],
              [
                46.123919,
                33.304298
              ],
              [
                46.124025,
                33.304159
              ],
              [
                46.123978,
                33.30394
              ],
              [
                46.124065,
                33.303412
              ],
              [
                46.124289,
                33.302699
              ],
              [
                46.124498,
                33.302501
              ],
              [
                46.125038,
                33.30215
              ],
              [
                46.125024,
                33.302018
              ],
              [
                46.124784,
                33.301637
              ],
              [
                46.125087,
                33.300987
              ],
              [
                46.125191,
                33.300833
              ],
              [
                46.125381,
                33.300748
              ],
              [
                46.125519,
                33.300407
              ],
              [
                46.125638,
                33.30022
              ],
              [
                46.125816,
                33.300063
              ],
              [
                46.125967,
                33.299721
              ],
              [
                46.126085,
                33.299632
              ],
              [
                46.126636,
                33.299491
              ],
              [
                46.126965,
                33.299183
              ],
              [
                46.127136,
                33.299116
              ],
              [
                46.127391,
                33.299081
              ],
              [
                46.127587,
                33.299118
              ],
              [
                46.127993,
                33.299101
              ],
              [
                46.128306,
                33.299014
              ],
              [
                46.128372,
                33.298857
              ],
              [
                46.128556,
                33.298699
              ],
              [
                46.128556,
                33.29841
              ],
              [
                46.128997,
                33.298227
              ],
              [
                46.129223,
                33.298217
              ],
              [
                46.129772,
                33.298045
              ],
              [
                46.129752,
                33.297412
              ],
              [
                46.129869,
                33.296863
              ],
              [
                46.129931,
                33.296107
              ],
              [
                46.130985,
                33.296206
              ],
              [
                46.131259,
                33.296033
              ],
              [
                46.131517,
                33.295795
              ],
              [
                46.131629,
                33.29563
              ],
              [
                46.13166,
                33.295469
              ],
              [
                46.131933,
                33.295244
              ],
              [
                46.132281,
                33.294492
              ],
              [
                46.132303,
                33.293981
              ],
              [
                46.132168,
                33.293669
              ],
              [
                46.132587,
                33.29347
              ],
              [
                46.132823,
                33.293499
              ],
              [
                46.133243,
                33.293398
              ],
              [
                46.133477,
                33.293061
              ],
              [
                46.133966,
                33.292641
              ],
              [
                46.134031,
                33.292479
              ],
              [
                46.13397,
                33.292325
              ],
              [
                46.134,
                33.292185
              ],
              [
                46.134161,
                33.292099
              ],
              [
                46.134336,
                33.292072
              ],
              [
                46.134525,
                33.292126
              ],
              [
                46.134977,
                33.292034
              ],
              [
                46.135467,
                33.29162
              ],
              [
                46.135842,
                33.291071
              ],
              [
                46.136089,
                33.290933
              ],
              [
                46.136164,
                33.290785
              ],
              [
                46.13615,
                33.290632
              ],
              [
                46.136513,
                33.290536
              ],
              [
                46.136845,
                33.290336
              ],
              [
                46.137292,
                33.29025
              ],
              [
                46.137487,
                33.290163
              ],
              [
                46.138589,
                33.289519
              ],
              [
                46.138805,
                33.289444
              ],
              [
                46.13947,
                33.28934
              ],
              [
                46.139517,
                33.289197
              ],
              [
                46.139795,
                33.288924
              ],
              [
                46.139859,
                33.288705
              ],
              [
                46.139997,
                33.288551
              ],
              [
                46.140034,
                33.288198
              ],
              [
                46.140327,
                33.288031
              ],
              [
                46.140447,
                33.287875
              ],
              [
                46.140603,
                33.287893
              ],
              [
                46.141055,
                33.287656
              ],
              [
                46.141313,
                33.287589
              ],
              [
                46.14189,
                33.28705
              ],
              [
                46.14215,
                33.286895
              ],
              [
                46.142435,
                33.286647
              ],
              [
                46.142812,
                33.286465
              ],
              [
                46.142883,
                33.286369
              ],
              [
                46.143026,
                33.286359
              ],
              [
                46.143804,
                33.286498
              ],
              [
                46.14388,
                33.286137
              ],
              [
                46.144082,
                33.285744
              ],
              [
                46.144287,
                33.285552
              ],
              [
                46.145378,
                33.284697
              ],
              [
                46.145565,
                33.284576
              ],
              [
                46.145936,
                33.284442
              ],
              [
                46.146308,
                33.284074
              ],
              [
                46.146711,
                33.283805
              ],
              [
                46.146974,
                33.283706
              ],
              [
                46.147104,
                33.283522
              ],
              [
                46.14747,
                33.283197
              ],
              [
                46.147657,
                33.283127
              ],
              [
                46.148095,
                33.283146
              ],
              [
                46.148547,
                33.282797
              ],
              [
                46.148862,
                33.282667
              ],
              [
                46.149218,
                33.282642
              ],
              [
                46.149545,
                33.282441
              ],
              [
                46.150742,
                33.282533
              ],
              [
                46.150838,
                33.282351
              ],
              [
                46.150941,
                33.281866
              ],
              [
                46.151069,
                33.281752
              ],
              [
                46.151268,
                33.281665
              ],
              [
                46.152002,
                33.281555
              ],
              [
                46.152101,
                33.281452
              ],
              [
                46.152625,
                33.28125
              ],
              [
                46.153019,
                33.280968
              ],
              [
                46.153357,
                33.280856
              ],
              [
                46.154,
                33.280786
              ],
              [
                46.154519,
                33.280636
              ],
              [
                46.155449,
                33.28015
              ],
              [
                46.156329,
                33.2792
              ],
              [
                46.157104,
                33.278731
              ],
              [
                46.157413,
                33.278578
              ],
              [
                46.157913,
                33.278477
              ],
              [
                46.158094,
                33.278302
              ],
              [
                46.159194,
                33.277689
              ],
              [
                46.159624,
                33.277725
              ],
              [
                46.159977,
                33.27769
              ],
              [
                46.160314,
                33.277527
              ],
              [
                46.160294,
                33.277269
              ],
              [
                46.160387,
                33.277047
              ],
              [
                46.160658,
                33.276645
              ],
              [
                46.160911,
                33.276452
              ],
              [
                46.161709,
                33.276018
              ],
              [
                46.162632,
                33.275716
              ],
              [
                46.163271,
                33.275191
              ],
              [
                46.163826,
                33.274869
              ],
              [
                46.164242,
                33.274504
              ],
              [
                46.164935,
                33.274362
              ],
              [
                46.165519,
                33.274029
              ],
              [
                46.165746,
                33.273812
              ],
              [
                46.16596,
                33.273756
              ],
              [
                46.16624,
                33.273456
              ],
              [
                46.166412,
                33.273362
              ],
              [
                46.166594,
                33.273073
              ],
              [
                46.16712,
                33.272904
              ],
              [
                46.167318,
                33.272766
              ],
              [
                46.167513,
                33.272481
              ],
              [
                46.167481,
                33.272128
              ],
              [
                46.167813,
                33.271784
              ],
              [
                46.168369,
                33.271513
              ],
              [
                46.168597,
                33.271369
              ],
              [
                46.168944,
                33.271056
              ],
              [
                46.16971,
                33.2706
              ],
              [
                46.170386,
                33.27037
              ],
              [
                46.170937,
                33.270265
              ],
              [
                46.171403,
                33.270455
              ],
              [
                46.171661,
                33.270494
              ],
              [
                46.171972,
                33.270466
              ],
              [
                46.172085,
                33.270366
              ],
              [
                46.172863,
                33.2703
              ],
              [
                46.173011,
                33.270006
              ],
              [
                46.173583,
                33.269721
              ],
              [
                46.173948,
                33.269593
              ],
              [
                46.174693,
                33.269613
              ],
              [
                46.174879,
                33.269551
              ],
              [
                46.175024,
                33.269451
              ],
              [
                46.175185,
                33.269086
              ],
              [
                46.175356,
                33.268896
              ],
              [
                46.176022,
                33.268468
              ],
              [
                46.176398,
                33.268287
              ],
              [
                46.176694,
                33.268205
              ],
              [
                46.176822,
                33.268091
              ],
              [
                46.177115,
                33.268044
              ],
              [
                46.177465,
                33.268067
              ],
              [
                46.177668,
                33.268019
              ],
              [
                46.178046,
                33.2677
              ],
              [
                46.178256,
                33.267628
              ],
              [
                46.178729,
                33.267219
              ],
              [
                46.178962,
                33.266909
              ],
              [
                46.179322,
                33.266201
              ],
              [
                46.179662,
                33.265838
              ],
              [
                46.180034,
                33.265663
              ],
              [
                46.180208,
                33.265461
              ],
              [
                46.180461,
                33.265268
              ],
              [
                46.180662,
                33.26526
              ],
              [
                46.181257,
                33.265409
              ],
              [
                46.181481,
                33.265551
              ],
              [
                46.182566,
                33.26605
              ],
              [
                46.182769,
                33.266071
              ],
              [
                46.182927,
                33.26602
              ],
              [
                46.183117,
                33.265877
              ],
              [
                46.183263,
                33.265851
              ],
              [
                46.183659,
                33.266019
              ],
              [
                46.184276,
                33.26597
              ],
              [
                46.185126,
                33.265681
              ],
              [
                46.185306,
                33.265432
              ],
              [
                46.185636,
                33.26531
              ],
              [
                46.185836,
                33.265297
              ],
              [
                46.186449,
                33.265073
              ],
              [
                46.18676,
                33.265159
              ],
              [
                46.187213,
                33.265118
              ],
              [
                46.187426,
                33.264943
              ],
              [
                46.187869,
                33.26484
              ],
              [
                46.188028,
                33.26463
              ],
              [
                46.188247,
                33.264522
              ],
              [
                46.188496,
                33.264477
              ],
              [
                46.188962,
                33.26453
              ],
              [
                46.189199,
                33.264465
              ],
              [
                46.189827,
                33.26397
              ],
              [
                46.189986,
                33.262541
              ],
              [
                46.189894,
                33.262191
              ],
              [
                46.190014,
                33.261685
              ],
              [
                46.190529,
                33.261373
              ],
              [
                46.190639,
                33.261216
              ],
              [
                46.19086,
                33.260766
              ],
              [
                46.191531,
                33.259828
              ],
              [
                46.191642,
                33.259515
              ],
              [
                46.191669,
                33.25923
              ],
              [
                46.191586,
                33.258927
              ],
              [
                46.191596,
                33.258789
              ],
              [
                46.191162,
                33.258317
              ],
              [
                46.190696,
                33.258338
              ],
              [
                46.190376,
                33.258213
              ],
              [
                46.189845,
                33.257739
              ],
              [
                46.189334,
                33.257734
              ],
              [
                46.189229,
                33.257605
              ],
              [
                46.188976,
                33.257611
              ],
              [
                46.188887,
                33.257519
              ],
              [
                46.18883,
                33.257358
              ],
              [
                46.188652,
                33.25722
              ],
              [
                46.188603,
                33.257063
              ],
              [
                46.188629,
                33.256928
              ],
              [
                46.188562,
                33.256684
              ],
              [
                46.188676,
                33.256521
              ],
              [
                46.188813,
                33.256462
              ],
              [
                46.188972,
                33.256462
              ],
              [
                46.189103,
                33.256381
              ],
              [
                46.189245,
                33.255992
              ],
              [
                46.189345,
                33.255939
              ],
              [
                46.189484,
                33.255983
              ],
              [
                46.189566,
                33.255956
              ],
              [
                46.189866,
                33.255493
              ],
              [
                46.190007,
                33.255405
              ],
              [
                46.190342,
                33.25535
              ],
              [
                46.190663,
                33.25515
              ],
              [
                46.190896,
                33.254909
              ],
              [
                46.190931,
                33.254806
              ],
              [
                46.190855,
                33.254666
              ],
              [
                46.190719,
                33.254519
              ],
              [
                46.190173,
                33.25443
              ],
              [
                46.190004,
                33.254466
              ],
              [
                46.189854,
                33.254823
              ],
              [
                46.189446,
                33.254936
              ],
              [
                46.189232,
                33.254901
              ],
              [
                46.189119,
                33.254745
              ],
              [
                46.189039,
                33.254474
              ],
              [
                46.189067,
                33.254344
              ],
              [
                46.189372,
                33.254227
              ],
              [
                46.189414,
                33.2541
              ],
              [
                46.189372,
                33.253925
              ],
              [
                46.188979,
                33.253142
              ],
              [
                46.188843,
                33.253109
              ],
              [
                46.188685,
                33.25316
              ],
              [
                46.188522,
                33.253332
              ],
              [
                46.18828,
                33.253472
              ],
              [
                46.188159,
                33.253471
              ],
              [
                46.188046,
                33.253406
              ],
              [
                46.188002,
                33.253295
              ],
              [
                46.18815,
                33.252858
              ],
              [
                46.188125,
                33.252766
              ],
              [
                46.187827,
                33.252655
              ],
              [
                46.187794,
                33.252581
              ],
              [
                46.187964,
                33.252294
              ],
              [
                46.187964,
                33.252134
              ],
              [
                46.187883,
                33.252024
              ],
              [
                46.187748,
                33.251974
              ],
              [
                46.187377,
                33.252058
              ],
              [
                46.187243,
                33.252036
              ],
              [
                46.187204,
                33.251987
              ],
              [
                46.187223,
                33.251869
              ],
              [
                46.187322,
                33.251743
              ],
              [
                46.187841,
                33.251383
              ],
              [
                46.18792,
                33.251232
              ],
              [
                46.187916,
                33.250914
              ],
              [
                46.187983,
                33.25081
              ],
              [
                46.188618,
                33.250525
              ],
              [
                46.188621,
                33.250394
              ],
              [
                46.18849,
                33.25015
              ],
              [
                46.188549,
                33.250065
              ],
              [
                46.188666,
                33.250027
              ],
              [
                46.189027,
                33.250065
              ],
              [
                46.189109,
                33.250016
              ],
              [
                46.189008,
                33.249624
              ],
              [
                46.189057,
                33.249433
              ],
              [
                46.189017,
                33.249287
              ],
              [
                46.18864,
                33.249002
              ],
              [
                46.188618,
                33.248852
              ],
              [
                46.188754,
                33.248674
              ],
              [
                46.18878,
                33.248515
              ],
              [
                46.188678,
                33.248329
              ],
              [
                46.188699,
                33.248194
              ],
              [
                46.188881,
                33.248093
              ],
              [
                46.188928,
                33.247868
              ],
              [
                46.188688,
                33.247434
              ],
              [
                46.188745,
                33.247332
              ],
              [
                46.187525,
                33.243189
              ],
              [
                46.187508,
                33.242966
              ],
              [
                46.187604,
                33.242852
              ],
              [
                46.188098,
                33.24282
              ],
              [
                46.188121,
                33.242742
              ],
              [
                46.188066,
                33.242633
              ],
              [
                46.187717,
                33.242547
              ],
              [
                46.187615,
                33.242452
              ],
              [
                46.187632,
                33.242375
              ],
              [
                46.187741,
                33.242309
              ],
              [
                46.188099,
                33.242222
              ],
              [
                46.188119,
                33.241968
              ],
              [
                46.188188,
                33.241893
              ],
              [
                46.187981,
                33.241743
              ],
              [
                46.187969,
                33.241631
              ],
              [
                46.188049,
                33.24148
              ],
              [
                46.188199,
                33.241356
              ],
              [
                46.188243,
                33.241212
              ],
              [
                46.188387,
                33.241089
              ],
              [
                46.18853,
                33.241052
              ],
              [
                46.18873,
                33.241107
              ],
              [
                46.188905,
                33.241075
              ],
              [
                46.189088,
                33.240974
              ],
              [
                46.189171,
                33.240675
              ],
              [
                46.189185,
                33.240376
              ],
              [
                46.189407,
                33.240348
              ],
              [
                46.189584,
                33.240253
              ],
              [
                46.189679,
                33.240111
              ],
              [
                46.189719,
                33.239887
              ],
              [
                46.190419,
                33.239744
              ],
              [
                46.190786,
                33.239713
              ],
              [
                46.190883,
                33.239741
              ],
              [
                46.190881,
                33.240105
              ],
              [
                46.190984,
                33.240155
              ],
              [
                46.191075,
                33.240139
              ],
              [
                46.191237,
                33.240013
              ],
              [
                46.191577,
                33.239906
              ],
              [
                46.191469,
                33.239601
              ],
              [
                46.191571,
                33.239395
              ],
              [
                46.191711,
                33.239279
              ],
              [
                46.191803,
                33.23929
              ],
              [
                46.191932,
                33.239666
              ],
              [
                46.192001,
                33.239687
              ],
              [
                46.19226,
                33.239561
              ],
              [
                46.192494,
                33.239508
              ],
              [
                46.192553,
                33.239469
              ],
              [
                46.192433,
                33.239171
              ],
              [
                46.192485,
                33.239105
              ],
              [
                46.192766,
                33.238992
              ],
              [
                46.192827,
                33.238611
              ],
              [
                46.193356,
                33.238567
              ],
              [
                46.193522,
                33.238383
              ],
              [
                46.193588,
                33.23795
              ],
              [
                46.193407,
                33.237499
              ],
              [
                46.193258,
                33.237349
              ],
              [
                46.193021,
                33.237227
              ],
              [
                46.192859,
                33.236801
              ],
              [
                46.192856,
                33.236579
              ],
              [
                46.192355,
                33.235889
              ],
              [
                46.192295,
                33.235462
              ],
              [
                46.192332,
                33.235296
              ],
              [
                46.192159,
                33.234991
              ],
              [
                46.192126,
                33.234798
              ],
              [
                46.192158,
                33.23457
              ],
              [
                46.192279,
                33.234383
              ],
              [
                46.192413,
                33.234012
              ],
              [
                46.192171,
                33.233293
              ],
              [
                46.192255,
                33.233181
              ],
              [
                46.192161,
                33.232907
              ],
              [
                46.192178,
                33.232807
              ],
              [
                46.192297,
                33.232706
              ],
              [
                46.192319,
                33.232554
              ],
              [
                46.192137,
                33.231938
              ],
              [
                46.191937,
                33.231695
              ],
              [
                46.191999,
                33.231456
              ],
              [
                46.191755,
                33.231102
              ],
              [
                46.191856,
                33.230867
              ],
              [
                46.191856,
                33.230565
              ],
              [
                46.192163,
                33.230499
              ],
              [
                46.192235,
                33.230435
              ],
              [
                46.192236,
                33.230349
              ],
              [
                46.192181,
                33.230262
              ],
              [
                46.191863,
                33.230149
              ],
              [
                46.191723,
                33.229895
              ],
              [
                46.19152,
                33.229732
              ],
              [
                46.191516,
                33.229511
              ],
              [
                46.191288,
                33.229233
              ],
              [
                46.191059,
                33.228654
              ],
              [
                46.190696,
                33.228121
              ],
              [
                46.19033,
                33.227948
              ],
              [
                46.189727,
                33.227931
              ],
              [
                46.189576,
                33.22789
              ],
              [
                46.189462,
                33.227638
              ],
              [
                46.189341,
                33.227591
              ],
              [
                46.189155,
                33.227585
              ],
              [
                46.188909,
                33.227709
              ],
              [
                46.188566,
                33.227759
              ],
              [
                46.188457,
                33.227665
              ],
              [
                46.188018,
                33.22755
              ],
              [
                46.187754,
                33.227421
              ],
              [
                46.187573,
                33.227368
              ],
              [
                46.187308,
                33.227376
              ],
              [
                46.187147,
                33.227206
              ],
              [
                46.186776,
                33.227153
              ],
              [
                46.186487,
                33.227028
              ],
              [
                46.186006,
                33.226944
              ],
              [
                46.185676,
                33.226742
              ],
              [
                46.185587,
                33.226348
              ],
              [
                46.185331,
                33.225899
              ],
              [
                46.185354,
                33.225473
              ],
              [
                46.185028,
                33.225168
              ],
              [
                46.184871,
                33.224735
              ],
              [
                46.184923,
                33.224412
              ],
              [
                46.184748,
                33.223726
              ],
              [
                46.18467,
                33.223604
              ],
              [
                46.184325,
                33.223461
              ],
              [
                46.184009,
                33.222749
              ],
              [
                46.183633,
                33.222379
              ],
              [
                46.18331,
                33.221708
              ],
              [
                46.182929,
                33.221202
              ],
              [
                46.182785,
                33.220818
              ],
              [
                46.182744,
                33.220204
              ],
              [
                46.182696,
                33.220099
              ],
              [
                46.182562,
                33.220004
              ],
              [
                46.182387,
                33.219688
              ],
              [
                46.182397,
                33.219333
              ],
              [
                46.182791,
                33.21854
              ],
              [
                46.183078,
                33.218154
              ],
              [
                46.183657,
                33.217732
              ],
              [
                46.184062,
                33.217294
              ],
              [
                46.184194,
                33.216776
              ],
              [
                46.184414,
                33.216348
              ],
              [
                46.18507,
                33.215638
              ],
              [
                46.185245,
                33.215066
              ],
              [
                46.185357,
                33.214808
              ],
              [
                46.185552,
                33.214599
              ],
              [
                46.185724,
                33.214086
              ],
              [
                46.186071,
                33.213623
              ],
              [
                46.186304,
                33.213146
              ],
              [
                46.186616,
                33.212742
              ],
              [
                46.186981,
                33.212131
              ],
              [
                46.186872,
                33.211801
              ],
              [
                46.186274,
                33.210931
              ],
              [
                46.186249,
                33.210767
              ],
              [
                46.186331,
                33.210497
              ],
              [
                46.186312,
                33.210186
              ],
              [
                46.186239,
                33.209967
              ],
              [
                46.186122,
                33.209842
              ],
              [
                46.185476,
                33.209538
              ],
              [
                46.18451,
                33.209175
              ],
              [
                46.184139,
                33.209142
              ],
              [
                46.18385,
                33.209176
              ],
              [
                46.183666,
                33.209308
              ],
              [
                46.18343,
                33.209751
              ],
              [
                46.183284,
                33.209881
              ],
              [
                46.183061,
                33.209944
              ],
              [
                46.182637,
                33.209979
              ],
              [
                46.182352,
                33.20993
              ],
              [
                46.182079,
                33.209781
              ],
              [
                46.181918,
                33.209641
              ],
              [
                46.181853,
                33.209473
              ],
              [
                46.181917,
                33.208467
              ],
              [
                46.181835,
                33.208308
              ],
              [
                46.181594,
                33.208135
              ],
              [
                46.181222,
                33.207957
              ],
              [
                46.180927,
                33.20773
              ],
              [
                46.180599,
                33.207306
              ],
              [
                46.180548,
                33.207071
              ],
              [
                46.180584,
                33.206344
              ],
              [
                46.180683,
                33.206065
              ],
              [
                46.180822,
                33.205907
              ],
              [
                46.181573,
                33.2055
              ],
              [
                46.181738,
                33.205203
              ],
              [
                46.182103,
                33.2049
              ],
              [
                46.183233,
                33.20422
              ],
              [
                46.197343,
                33.201279
              ],
              [
                46.205533,
                33.202433
              ],
              [
                46.214986,
                33.203587
              ],
              [
                46.215438,
                33.203438
              ],
              [
                46.215605,
                33.203216
              ],
              [
                46.21552,
                33.203069
              ],
              [
                46.214884,
                33.202682
              ],
              [
                46.214819,
                33.202513
              ],
              [
                46.214041,
                33.201576
              ],
              [
                46.213915,
                33.201017
              ],
              [
                46.213797,
                33.200794
              ],
              [
                46.213622,
                33.200604
              ],
              [
                46.213472,
                33.200503
              ],
              [
                46.213145,
                33.200445
              ],
              [
                46.212649,
                33.200236
              ],
              [
                46.212484,
                33.200248
              ],
              [
                46.212286,
                33.200353
              ],
              [
                46.211769,
                33.200404
              ],
              [
                46.211559,
                33.200395
              ],
              [
                46.211492,
                33.200267
              ],
              [
                46.211529,
                33.200069
              ],
              [
                46.211447,
                33.199694
              ],
              [
                46.211475,
                33.199608
              ],
              [
                46.211614,
                33.199595
              ],
              [
                46.212062,
                33.199312
              ],
              [
                46.212461,
                33.19866
              ],
              [
                46.212366,
                33.19802
              ],
              [
                46.212346,
                33.197072
              ],
              [
                46.211971,
                33.197043
              ],
              [
                46.210848,
                33.197103
              ],
              [
                46.209393,
                33.197275
              ],
              [
                46.208911,
                33.197238
              ],
              [
                46.208547,
                33.197117
              ],
              [
                46.208216,
                33.196873
              ],
              [
                46.207907,
                33.19676
              ],
              [
                46.207416,
                33.196789
              ],
              [
                46.206804,
                33.196653
              ],
              [
                46.206275,
                33.196422
              ],
              [
                46.205739,
                33.196116
              ],
              [
                46.205312,
                33.195785
              ],
              [
                46.205022,
                33.195453
              ],
              [
                46.204883,
                33.195036
              ],
              [
                46.204759,
                33.194842
              ],
              [
                46.204015,
                33.194626
              ],
              [
                46.203057,
                33.194029
              ],
              [
                46.202108,
                33.193633
              ],
              [
                46.199953,
                33.192441
              ],
              [
                46.198729,
                33.192007
              ],
              [
                46.198319,
                33.191737
              ],
              [
                46.198122,
                33.191371
              ],
              [
                46.19806,
                33.191045
              ],
              [
                46.198132,
                33.190282
              ],
              [
                46.198115,
                33.189693
              ],
              [
                46.198182,
                33.189274
              ],
              [
                46.198333,
                33.188875
              ],
              [
                46.199255,
                33.187787
              ],
              [
                46.19934,
                33.187406
              ],
              [
                46.199361,
                33.186861
              ],
              [
                46.199276,
                33.186429
              ],
              [
                46.19901,
                33.185686
              ],
              [
                46.198294,
                33.183953
              ],
              [
                46.198186,
                33.183577
              ],
              [
                46.198193,
                33.182982
              ],
              [
                46.198079,
                33.182538
              ],
              [
                46.197528,
                33.181554
              ],
              [
                46.196846,
                33.18078
              ],
              [
                46.196626,
                33.180616
              ],
              [
                46.196337,
                33.180551
              ],
              [
                46.195158,
                33.180429
              ],
              [
                46.194346,
                33.180393
              ],
              [
                46.193847,
                33.180319
              ],
              [
                46.193436,
                33.180142
              ],
              [
                46.19182,
                33.179889
              ],
              [
                46.191203,
                33.179737
              ],
              [
                46.189447,
                33.179014
              ],
              [
                46.188777,
                33.178691
              ],
              [
                46.188271,
                33.178519
              ],
              [
                46.186831,
                33.177601
              ],
              [
                46.186203,
                33.17698
              ],
              [
                46.184972,
                33.175373
              ],
              [
                46.184332,
                33.173348
              ],
              [
                46.18377,
                33.172466
              ],
              [
                46.18335,
                33.171918
              ],
              [
                46.183143,
                33.171467
              ],
              [
                46.182367,
                33.170611
              ],
              [
                46.182039,
                33.170378
              ],
              [
                46.181568,
                33.170241
              ],
              [
                46.181215,
                33.170013
              ],
              [
                46.180844,
                33.16955
              ],
              [
                46.180607,
                33.169156
              ],
              [
                46.180273,
                33.16878
              ],
              [
                46.179987,
                33.168325
              ],
              [
                46.179969,
                33.168089
              ],
              [
                46.180028,
                33.167806
              ],
              [
                46.18057,
                33.167012
              ],
              [
                46.180611,
                33.166348
              ],
              [
                46.180485,
                33.166074
              ],
              [
                46.179324,
                33.165088
              ],
              [
                46.178338,
                33.164578
              ],
              [
                46.177856,
                33.16421
              ],
              [
                46.176863,
                33.163171
              ],
              [
                46.176611,
                33.162623
              ],
              [
                46.176363,
                33.161447
              ],
              [
                46.176149,
                33.161037
              ],
              [
                46.175782,
                33.160783
              ],
              [
                46.174883,
                33.160378
              ],
              [
                46.17363,
                33.159671
              ],
              [
                46.172986,
                33.15928
              ],
              [
                46.172557,
                33.15896
              ],
              [
                46.171865,
                33.15863
              ],
              [
                46.171016,
                33.15767
              ],
              [
                46.170327,
                33.157444
              ],
              [
                46.169729,
                33.157103
              ],
              [
                46.169254,
                33.157094
              ],
              [
                46.168924,
                33.157019
              ],
              [
                46.168739,
                33.156912
              ],
              [
                46.167859,
                33.155505
              ],
              [
                46.167468,
                33.155185
              ],
              [
                46.16714,
                33.154546
              ],
              [
                46.166877,
                33.15422
              ],
              [
                46.166601,
                33.15399
              ],
              [
                46.166451,
                33.153674
              ],
              [
                46.166058,
                33.153325
              ],
              [
                46.165645,
                33.153091
              ],
              [
                46.165102,
                33.152902
              ],
              [
                46.164662,
                33.152829
              ],
              [
                46.164397,
                33.15283
              ],
              [
                46.163148,
                33.153191
              ],
              [
                46.162348,
                33.153107
              ],
              [
                46.161463,
                33.152636
              ],
              [
                46.161286,
                33.152604
              ],
              [
                46.160924,
                33.152435
              ],
              [
                46.160677,
                33.152218
              ],
              [
                46.159978,
                33.151406
              ],
              [
                46.15977,
                33.150804
              ],
              [
                46.159742,
                33.150344
              ],
              [
                46.159731,
                33.149991
              ],
              [
                46.159944,
                33.14925
              ],
              [
                46.159903,
                33.148263
              ],
              [
                46.159841,
                33.147914
              ],
              [
                46.159589,
                33.147252
              ],
              [
                46.159262,
                33.146944
              ],
              [
                46.159031,
                33.146614
              ],
              [
                46.158892,
                33.146252
              ],
              [
                46.158854,
                33.145889
              ],
              [
                46.158859,
                33.145618
              ],
              [
                46.159211,
                33.144786
              ],
              [
                46.159477,
                33.143749
              ],
              [
                46.159525,
                33.143377
              ],
              [
                46.159462,
                33.143062
              ],
              [
                46.159296,
                33.142694
              ],
              [
                46.158474,
                33.142277
              ],
              [
                46.158096,
                33.141967
              ],
              [
                46.15741,
                33.141544
              ],
              [
                46.155484,
                33.140682
              ],
              [
                46.154868,
                33.140379
              ],
              [
                46.154548,
                33.140147
              ],
              [
                46.154415,
                33.139756
              ],
              [
                46.154124,
                33.13937
              ],
              [
                46.153567,
                33.138908
              ],
              [
                46.153338,
                33.13854
              ],
              [
                46.153116,
                33.137905
              ],
              [
                46.152926,
                33.137662
              ],
              [
                46.151543,
                33.136988
              ],
              [
                46.151213,
                33.13667
              ],
              [
                46.151126,
                33.136458
              ],
              [
                46.151179,
                33.136152
              ],
              [
                46.151072,
                33.13574
              ],
              [
                46.15023,
                33.135178
              ],
              [
                46.150064,
                33.134909
              ],
              [
                46.150079,
                33.134625
              ],
              [
                46.150014,
                33.134399
              ],
              [
                46.149808,
                33.13412
              ],
              [
                46.149506,
                33.133835
              ],
              [
                46.149088,
                33.133565
              ],
              [
                46.148394,
                33.132917
              ],
              [
                46.146658,
                33.132028
              ],
              [
                46.146284,
                33.131905
              ],
              [
                46.145962,
                33.131496
              ],
              [
                46.145651,
                33.131395
              ],
              [
                46.145394,
                33.131378
              ],
              [
                46.144558,
                33.131516
              ],
              [
                46.144079,
                33.131547
              ],
              [
                46.143475,
                33.131485
              ],
              [
                46.142814,
                33.13135
              ],
              [
                46.142373,
                33.13121
              ],
              [
                46.141871,
                33.130932
              ],
              [
                46.141572,
                33.130707
              ],
              [
                46.141375,
                33.130388
              ],
              [
                46.141111,
                33.130202
              ],
              [
                46.140076,
                33.129965
              ],
              [
                46.139795,
                33.129809
              ],
              [
                46.139355,
                33.129504
              ],
              [
                46.138669,
                33.12891
              ],
              [
                46.138087,
                33.128254
              ],
              [
                46.137781,
                33.128174
              ],
              [
                46.137507,
                33.128187
              ],
              [
                46.137202,
                33.128134
              ],
              [
                46.137001,
                33.12797
              ],
              [
                46.136675,
                33.126791
              ],
              [
                46.136691,
                33.126006
              ],
              [
                46.136643,
                33.125264
              ],
              [
                46.136515,
                33.124922
              ],
              [
                46.136116,
                33.124505
              ],
              [
                46.135115,
                33.123915
              ],
              [
                46.134744,
                33.123802
              ],
              [
                46.134363,
                33.123746
              ],
              [
                46.133939,
                33.123504
              ],
              [
                46.133792,
                33.123353
              ],
              [
                46.133143,
                33.123022
              ],
              [
                46.132979,
                33.122852
              ],
              [
                46.13259,
                33.122814
              ],
              [
                46.131108,
                33.123072
              ],
              [
                46.130685,
                33.123073
              ],
              [
                46.130212,
                33.122982
              ],
              [
                46.129979,
                33.122862
              ],
              [
                46.129314,
                33.122204
              ],
              [
                46.128854,
                33.121483
              ],
              [
                46.12859,
                33.121297
              ],
              [
                46.128093,
                33.120698
              ],
              [
                46.127855,
                33.120127
              ],
              [
                46.12766,
                33.120011
              ],
              [
                46.127131,
                33.119848
              ],
              [
                46.126926,
                33.119596
              ],
              [
                46.126569,
                33.119001
              ],
              [
                46.126539,
                33.118742
              ],
              [
                46.126743,
                33.118238
              ],
              [
                46.125454,
                33.11708
              ],
              [
                46.124974,
                33.116986
              ],
              [
                46.124116,
                33.116895
              ],
              [
                46.123875,
                33.116672
              ],
              [
                46.123716,
                33.116428
              ],
              [
                46.123581,
                33.116005
              ],
              [
                46.123463,
                33.115893
              ],
              [
                46.123236,
                33.115821
              ],
              [
                46.122731,
                33.115996
              ],
              [
                46.122681,
                33.116192
              ],
              [
                46.122794,
                33.116696
              ],
              [
                46.122741,
                33.116904
              ],
              [
                46.12255,
                33.117168
              ],
              [
                46.122304,
                33.117364
              ],
              [
                46.121957,
                33.117484
              ],
              [
                46.121696,
                33.117528
              ],
              [
                46.121359,
                33.11747
              ],
              [
                46.120803,
                33.117278
              ],
              [
                46.120356,
                33.117189
              ],
              [
                46.119847,
                33.116934
              ],
              [
                46.119545,
                33.116721
              ],
              [
                46.119352,
                33.11649
              ],
              [
                46.119253,
                33.116231
              ],
              [
                46.119269,
                33.11593
              ],
              [
                46.119196,
                33.115579
              ],
              [
                46.1191,
                33.11538
              ],
              [
                46.118899,
                33.115145
              ],
              [
                46.118584,
                33.114928
              ],
              [
                46.118323,
                33.114824
              ],
              [
                46.118063,
                33.114797
              ],
              [
                46.117769,
                33.11488
              ],
              [
                46.11753,
                33.114888
              ],
              [
                46.115952,
                33.114776
              ],
              [
                46.115363,
                33.114915
              ],
              [
                46.11428,
                33.114929
              ],
              [
                46.113899,
                33.115022
              ],
              [
                46.113201,
                33.1154
              ],
              [
                46.11272,
                33.116
              ],
              [
                46.1125,
                33.116126
              ],
              [
                46.111529,
                33.116887
              ],
              [
                46.109862,
                33.118031
              ],
              [
                46.109047,
                33.118446
              ],
              [
                46.108693,
                33.118931
              ],
              [
                46.108699,
                33.119266
              ],
              [
                46.108827,
                33.119636
              ],
              [
                46.108802,
                33.120048
              ],
              [
                46.108695,
                33.120413
              ],
              [
                46.108137,
                33.120916
              ],
              [
                46.107854,
                33.121307
              ],
              [
                46.107716,
                33.121942
              ],
              [
                46.107742,
                33.122379
              ],
              [
                46.107698,
                33.122601
              ],
              [
                46.107488,
                33.122786
              ],
              [
                46.106891,
                33.123163
              ],
              [
                46.106685,
                33.123248
              ],
              [
                46.1065,
                33.123241
              ],
              [
                46.105944,
                33.123071
              ],
              [
                46.10528,
                33.122997
              ],
              [
                46.10512,
                33.12287
              ],
              [
                46.104845,
                33.122421
              ],
              [
                46.104169,
                33.122034
              ],
              [
                46.103763,
                33.121883
              ],
              [
                46.10134,
                33.121657
              ],
              [
                46.101038,
                33.121687
              ],
              [
                46.100738,
                33.121798
              ],
              [
                46.100516,
                33.121941
              ],
              [
                46.100402,
                33.122131
              ],
              [
                46.10002,
                33.122439
              ],
              [
                46.099535,
                33.122202
              ],
              [
                46.098619,
                33.12189
              ],
              [
                46.098055,
                33.12181
              ],
              [
                46.096854,
                33.121425
              ],
              [
                46.096391,
                33.121322
              ],
              [
                46.0954,
                33.121204
              ],
              [
                46.094771,
                33.120975
              ],
              [
                46.094336,
                33.120735
              ],
              [
                46.093556,
                33.120146
              ],
              [
                46.092916,
                33.119583
              ],
              [
                46.092668,
                33.119482
              ],
              [
                46.092267,
                33.119424
              ],
              [
                46.091605,
                33.119454
              ],
              [
                46.089846,
                33.119059
              ],
              [
                46.089646,
                33.119116
              ],
              [
                46.089435,
                33.119251
              ],
              [
                46.089299,
                33.119506
              ],
              [
                46.089305,
                33.120183
              ],
              [
                46.089071,
                33.120471
              ],
              [
                46.088767,
                33.12076
              ],
              [
                46.0879,
                33.121337
              ],
              [
                46.087633,
                33.121454
              ],
              [
                46.086626,
                33.121544
              ],
              [
                46.085983,
                33.121791
              ],
              [
                46.085721,
                33.121974
              ],
              [
                46.085432,
                33.122321
              ],
              [
                46.084599,
                33.122711
              ],
              [
                46.084131,
                33.122835
              ],
              [
                46.083685,
                33.123038
              ],
              [
                46.083187,
                33.123189
              ],
              [
                46.082481,
                33.123221
              ],
              [
                46.082132,
                33.123143
              ],
              [
                46.081772,
                33.123143
              ],
              [
                46.081209,
                33.123284
              ],
              [
                46.080975,
                33.123456
              ],
              [
                46.080266,
                33.124227
              ],
              [
                46.080015,
                33.124402
              ],
              [
                46.079666,
                33.124517
              ],
              [
                46.078178,
                33.124848
              ],
              [
                46.077295,
                33.124806
              ],
              [
                46.076973,
                33.124662
              ],
              [
                46.076752,
                33.124204
              ],
              [
                46.075791,
                33.123839
              ],
              [
                46.075158,
                33.123666
              ],
              [
                46.074561,
                33.123585
              ],
              [
                46.074087,
                33.123606
              ],
              [
                46.073807,
                33.123698
              ],
              [
                46.073637,
                33.12382
              ],
              [
                46.073541,
                33.123986
              ],
              [
                46.07351,
                33.124184
              ],
              [
                46.07357,
                33.124581
              ],
              [
                46.073467,
                33.124742
              ],
              [
                46.07252,
                33.125521
              ],
              [
                46.072348,
                33.12581
              ],
              [
                46.072116,
                33.126059
              ],
              [
                46.07176,
                33.12629
              ],
              [
                46.070415,
                33.126806
              ],
              [
                46.069898,
                33.126933
              ],
              [
                46.067836,
                33.12712
              ],
              [
                46.067099,
                33.126959
              ],
              [
                46.066592,
                33.126665
              ],
              [
                46.066366,
                33.126114
              ],
              [
                46.065926,
                33.125445
              ],
              [
                46.06575,
                33.125039
              ],
              [
                46.065671,
                33.12476
              ],
              [
                46.065694,
                33.124558
              ],
              [
                46.065642,
                33.124335
              ],
              [
                46.065542,
                33.124171
              ],
              [
                46.065402,
                33.124068
              ],
              [
                46.065207,
                33.124024
              ],
              [
                46.064716,
                33.124129
              ],
              [
                46.063284,
                33.124214
              ],
              [
                46.062633,
                33.124165
              ],
              [
                46.062092,
                33.124054
              ],
              [
                46.061519,
                33.124063
              ],
              [
                46.059988,
                33.124396
              ],
              [
                46.059222,
                33.124703
              ],
              [
                46.058826,
                33.12498
              ],
              [
                46.058553,
                33.125098
              ],
              [
                46.057315,
                33.125293
              ],
              [
                46.055127,
                33.125992
              ],
              [
                46.054541,
                33.12624
              ],
              [
                46.054174,
                33.126507
              ],
              [
                46.05386,
                33.126853
              ],
              [
                46.053639,
                33.127304
              ],
              [
                46.0531735,
                33.1282554
              ],
              [
                46.0513656,
                33.1232271
              ],
              [
                46.0504823,
                33.1207269
              ],
              [
                46.0491399,
                33.1169659
              ],
              [
                46.046832,
                33.11135
              ],
              [
                46.04037,
                33.094539
              ],
              [
                46.04071,
                33.094524
              ],
              [
                46.040996,
                33.094288
              ],
              [
                46.041245,
                33.094538
              ],
              [
                46.041634,
                33.094334
              ],
              [
                46.041757,
                33.094346
              ],
              [
                46.041841,
                33.094475
              ],
              [
                46.041971,
                33.094535
              ],
              [
                46.042122,
                33.094532
              ],
              [
                46.042239,
                33.094473
              ],
              [
                46.042301,
                33.094347
              ],
              [
                46.042471,
                33.094296
              ],
              [
                46.042541,
                33.094102
              ],
              [
                46.042634,
                33.094047
              ],
              [
                46.04284,
                33.094062
              ],
              [
                46.043047,
                33.09401
              ],
              [
                46.043214,
                33.093899
              ],
              [
                46.043577,
                33.093837
              ],
              [
                46.04369,
                33.093591
              ],
              [
                46.04399,
                33.093529
              ],
              [
                46.044161,
                33.093528
              ],
              [
                46.044197,
                33.093692
              ],
              [
                46.044063,
                33.093809
              ],
              [
                46.044013,
                33.093955
              ],
              [
                46.044354,
                33.094316
              ],
              [
                46.044634,
                33.094274
              ],
              [
                46.044988,
                33.094302
              ],
              [
                46.045823,
                33.09406
              ],
              [
                46.04595,
                33.093895
              ],
              [
                46.045971,
                33.093781
              ],
              [
                46.046537,
                33.093525
              ],
              [
                46.046744,
                33.093522
              ],
              [
                46.047461,
                33.093362
              ],
              [
                46.04758,
                33.093479
              ],
              [
                46.047836,
                33.093441
              ],
              [
                46.048062,
                33.093507
              ],
              [
                46.048116,
                33.093619
              ],
              [
                46.04821,
                33.093664
              ],
              [
                46.048353,
                33.093678
              ],
              [
                46.048537,
                33.093608
              ],
              [
                46.048702,
                33.093613
              ],
              [
                46.048853,
                33.093923
              ],
              [
                46.04895,
                33.094006
              ],
              [
                46.049193,
                33.093871
              ],
              [
                46.049388,
                33.093843
              ],
              [
                46.050059,
                33.094087
              ],
              [
                46.05022,
                33.094269
              ],
              [
                46.051022,
                33.094364
              ],
              [
                46.051585,
                33.094146
              ],
              [
                46.051761,
                33.093973
              ],
              [
                46.051864,
                33.093763
              ],
              [
                46.051863,
                33.093592
              ],
              [
                46.051767,
                33.093366
              ],
              [
                46.051817,
                33.093219
              ],
              [
                46.052221,
                33.092974
              ],
              [
                46.052295,
                33.092631
              ],
              [
                46.052493,
                33.092564
              ],
              [
                46.052671,
                33.092423
              ],
              [
                46.052799,
                33.092115
              ],
              [
                46.053117,
                33.092049
              ],
              [
                46.053416,
                33.091888
              ],
              [
                46.053464,
                33.091759
              ],
              [
                46.053966,
                33.091524
              ],
              [
                46.054159,
                33.091442
              ],
              [
                46.054594,
                33.091533
              ],
              [
                46.054904,
                33.091656
              ],
              [
                46.055082,
                33.091538
              ],
              [
                46.055316,
                33.091564
              ],
              [
                46.055866,
                33.091272
              ],
              [
                46.0561,
                33.091078
              ],
              [
                46.056289,
                33.091029
              ],
              [
                46.056331,
                33.090851
              ],
              [
                46.056471,
                33.090661
              ],
              [
                46.056693,
                33.090469
              ],
              [
                46.056945,
                33.090393
              ],
              [
                46.057076,
                33.090288
              ],
              [
                46.057509,
                33.090352
              ],
              [
                46.058233,
                33.090289
              ],
              [
                46.058455,
                33.090417
              ],
              [
                46.058615,
                33.090445
              ],
              [
                46.059279,
                33.090232
              ],
              [
                46.059654,
                33.090212
              ],
              [
                46.059813,
                33.09029
              ],
              [
                46.059972,
                33.090268
              ],
              [
                46.060142,
                33.090074
              ],
              [
                46.060208,
                33.089914
              ],
              [
                46.060317,
                33.089823
              ],
              [
                46.060471,
                33.089786
              ],
              [
                46.060541,
                33.089592
              ],
              [
                46.060837,
                33.089564
              ],
              [
                46.061056,
                33.089603
              ],
              [
                46.061449,
                33.089558
              ],
              [
                46.061573,
                33.089455
              ],
              [
                46.061691,
                33.089446
              ],
              [
                46.061801,
                33.089647
              ],
              [
                46.061931,
                33.089735
              ],
              [
                46.062318,
                33.089835
              ],
              [
                46.062523,
                33.089993
              ],
              [
                46.062913,
                33.090081
              ],
              [
                46.06365,
                33.089806
              ],
              [
                46.064043,
                33.089833
              ],
              [
                46.064104,
                33.089971
              ],
              [
                46.064267,
                33.090015
              ],
              [
                46.064449,
                33.089984
              ],
              [
                46.06478,
                33.089701
              ],
              [
                46.065061,
                33.089907
              ],
              [
                46.065128,
                33.090359
              ],
              [
                46.065419,
                33.090458
              ],
              [
                46.065151,
                33.091005
              ],
              [
                46.065189,
                33.091175
              ],
              [
                46.065578,
                33.091428
              ],
              [
                46.065735,
                33.091594
              ],
              [
                46.066276,
                33.091657
              ],
              [
                46.066659,
                33.091624
              ],
              [
                46.066838,
                33.091704
              ],
              [
                46.067382,
                33.091584
              ],
              [
                46.067502,
                33.091414
              ],
              [
                46.067661,
                33.091371
              ],
              [
                46.06824,
                33.091382
              ],
              [
                46.068461,
                33.091262
              ],
              [
                46.068552,
                33.090982
              ],
              [
                46.068766,
                33.090879
              ],
              [
                46.069168,
                33.090921
              ],
              [
                46.069592,
                33.090606
              ],
              [
                46.069817,
                33.090573
              ],
              [
                46.070018,
                33.090445
              ],
              [
                46.070102,
                33.090331
              ],
              [
                46.070443,
                33.090185
              ],
              [
                46.070517,
                33.089985
              ],
              [
                46.070767,
                33.089854
              ],
              [
                46.070772,
                33.089655
              ],
              [
                46.070868,
                33.089489
              ],
              [
                46.070899,
                33.089269
              ],
              [
                46.071251,
                33.089093
              ],
              [
                46.07185,
                33.089206
              ],
              [
                46.072025,
                33.089127
              ],
              [
                46.072188,
                33.089121
              ],
              [
                46.072365,
                33.089317
              ],
              [
                46.072573,
                33.089336
              ],
              [
                46.072741,
                33.089423
              ],
              [
                46.073253,
                33.089424
              ],
              [
                46.073401,
                33.089531
              ],
              [
                46.073442,
                33.08964
              ],
              [
                46.073624,
                33.089802
              ],
              [
                46.07348,
                33.089953
              ],
              [
                46.073451,
                33.090085
              ],
              [
                46.073484,
                33.090333
              ],
              [
                46.073582,
                33.090465
              ],
              [
                46.074049,
                33.090656
              ],
              [
                46.074163,
                33.090802
              ],
              [
                46.074511,
                33.090924
              ],
              [
                46.074741,
                33.090885
              ],
              [
                46.074826,
                33.09092
              ],
              [
                46.07482,
                33.091042
              ],
              [
                46.074898,
                33.091172
              ],
              [
                46.075011,
                33.091219
              ],
              [
                46.075469,
                33.09118
              ],
              [
                46.075625,
                33.091269
              ],
              [
                46.075694,
                33.091439
              ],
              [
                46.07582,
                33.091483
              ],
              [
                46.076521,
                33.091022
              ],
              [
                46.076695,
                33.091108
              ],
              [
                46.076884,
                33.091104
              ],
              [
                46.077075,
                33.090966
              ],
              [
                46.077379,
                33.09087
              ],
              [
                46.077742,
                33.09083
              ],
              [
                46.07798,
                33.090729
              ],
              [
                46.078208,
                33.090365
              ],
              [
                46.078493,
                33.090101
              ],
              [
                46.078969,
                33.090059
              ],
              [
                46.079259,
                33.089838
              ],
              [
                46.079337,
                33.089704
              ],
              [
                46.07969,
                33.089627
              ],
              [
                46.079793,
                33.089659
              ],
              [
                46.079911,
                33.089892
              ],
              [
                46.080026,
                33.089945
              ],
              [
                46.080262,
                33.089904
              ],
              [
                46.080507,
                33.090044
              ],
              [
                46.080662,
                33.090079
              ],
              [
                46.080788,
                33.09003
              ],
              [
                46.080873,
                33.089872
              ],
              [
                46.081025,
                33.089802
              ],
              [
                46.081135,
                33.08981
              ],
              [
                46.081265,
                33.089992
              ],
              [
                46.081371,
                33.090349
              ],
              [
                46.081836,
                33.090556
              ],
              [
                46.082013,
                33.090559
              ],
              [
                46.082226,
                33.090815
              ],
              [
                46.082451,
                33.090975
              ],
              [
                46.082939,
                33.09103
              ],
              [
                46.083214,
                33.090994
              ],
              [
                46.083338,
                33.091177
              ],
              [
                46.083619,
                33.091261
              ],
              [
                46.083756,
                33.091397
              ],
              [
                46.084369,
                33.091497
              ],
              [
                46.084754,
                33.091227
              ],
              [
                46.084971,
                33.091212
              ],
              [
                46.086144,
                33.090742
              ],
              [
                46.086347,
                33.090768
              ],
              [
                46.086453,
                33.090667
              ],
              [
                46.086487,
                33.090457
              ],
              [
                46.086834,
                33.090283
              ],
              [
                46.08717,
                33.089586
              ],
              [
                46.087295,
                33.089437
              ],
              [
                46.087516,
                33.08929
              ],
              [
                46.087727,
                33.088961
              ],
              [
                46.087948,
                33.088885
              ],
              [
                46.088148,
                33.088879
              ],
              [
                46.088489,
                33.08849
              ],
              [
                46.088445,
                33.088222
              ],
              [
                46.088907,
                33.088032
              ],
              [
                46.089013,
                33.087904
              ],
              [
                46.08905,
                33.087732
              ],
              [
                46.08868,
                33.087333
              ],
              [
                46.088812,
                33.087255
              ],
              [
                46.088844,
                33.086897
              ],
              [
                46.08893,
                33.08686
              ],
              [
                46.089536,
                33.08669
              ],
              [
                46.089785,
                33.086868
              ],
              [
                46.089766,
                33.086987
              ],
              [
                46.09002,
                33.087258
              ],
              [
                46.090252,
                33.087324
              ],
              [
                46.090502,
                33.087336
              ],
              [
                46.091145,
                33.087574
              ],
              [
                46.091085,
                33.087804
              ],
              [
                46.091126,
                33.087913
              ],
              [
                46.091488,
                33.087967
              ],
              [
                46.09169,
                33.087916
              ],
              [
                46.091908,
                33.087928
              ],
              [
                46.09244,
                33.088152
              ],
              [
                46.092664,
                33.088136
              ],
              [
                46.092771,
                33.088377
              ],
              [
                46.093167,
                33.08837
              ],
              [
                46.09348,
                33.08809
              ],
              [
                46.093769,
                33.088135
              ],
              [
                46.093938,
                33.088078
              ],
              [
                46.094334,
                33.087878
              ],
              [
                46.094458,
                33.08772
              ],
              [
                46.094617,
                33.087654
              ],
              [
                46.094935,
                33.087611
              ],
              [
                46.095252,
                33.087446
              ],
              [
                46.09544,
                33.087172
              ],
              [
                46.09565,
                33.087058
              ],
              [
                46.095798,
                33.086631
              ],
              [
                46.096085,
                33.086472
              ],
              [
                46.096182,
                33.086334
              ],
              [
                46.09637,
                33.086329
              ],
              [
                46.096632,
                33.086411
              ],
              [
                46.096909,
                33.086116
              ],
              [
                46.097054,
                33.085827
              ],
              [
                46.09722,
                33.085782
              ],
              [
                46.097223,
                33.0856
              ],
              [
                46.097331,
                33.08546
              ],
              [
                46.097546,
                33.085385
              ],
              [
                46.09761,
                33.085026
              ],
              [
                46.098044,
                33.084991
              ],
              [
                46.098202,
                33.085184
              ],
              [
                46.098324,
                33.085241
              ],
              [
                46.098528,
                33.08525
              ],
              [
                46.099139,
                33.084997
              ],
              [
                46.099372,
                33.084775
              ],
              [
                46.099376,
                33.084648
              ],
              [
                46.09981,
                33.08464
              ],
              [
                46.09985,
                33.084743
              ],
              [
                46.1001,
                33.084998
              ],
              [
                46.100254,
                33.085033
              ],
              [
                46.100403,
                33.085024
              ],
              [
                46.100496,
                33.084942
              ],
              [
                46.100695,
                33.084979
              ],
              [
                46.100865,
                33.084951
              ],
              [
                46.101108,
                33.0846
              ],
              [
                46.10127,
                33.08454
              ],
              [
                46.101559,
                33.084535
              ],
              [
                46.101715,
                33.084695
              ],
              [
                46.101903,
                33.084641
              ],
              [
                46.101999,
                33.084548
              ],
              [
                46.102223,
                33.084559
              ],
              [
                46.102406,
                33.084412
              ],
              [
                46.102402,
                33.084253
              ],
              [
                46.102568,
                33.084092
              ],
              [
                46.102803,
                33.083997
              ],
              [
                46.103189,
                33.083926
              ],
              [
                46.103516,
                33.083776
              ],
              [
                46.103607,
                33.08381
              ],
              [
                46.103793,
                33.084423
              ],
              [
                46.10392,
                33.084523
              ],
              [
                46.104152,
                33.084539
              ],
              [
                46.104535,
                33.084435
              ],
              [
                46.105142,
                33.08453
              ],
              [
                46.105332,
                33.084459
              ],
              [
                46.105465,
                33.084243
              ],
              [
                46.105678,
                33.084113
              ],
              [
                46.106312,
                33.084098
              ],
              [
                46.106496,
                33.084028
              ],
              [
                46.10669,
                33.083609
              ],
              [
                46.106647,
                33.083468
              ],
              [
                46.106851,
                33.082992
              ],
              [
                46.106786,
                33.082838
              ],
              [
                46.106609,
                33.082791
              ],
              [
                46.106496,
                33.082695
              ],
              [
                46.106599,
                33.082484
              ],
              [
                46.106601,
                33.082032
              ],
              [
                46.106651,
                33.081885
              ],
              [
                46.107008,
                33.081753
              ],
              [
                46.10718,
                33.081586
              ],
              [
                46.10729,
                33.081016
              ],
              [
                46.107465,
                33.080914
              ],
              [
                46.107654,
                33.080887
              ],
              [
                46.107834,
                33.081066
              ],
              [
                46.108284,
                33.080901
              ],
              [
                46.108689,
                33.080832
              ],
              [
                46.108784,
                33.080733
              ],
              [
                46.109135,
                33.080602
              ],
              [
                46.109814,
                33.080127
              ],
              [
                46.109868,
                33.079633
              ],
              [
                46.109978,
                33.079471
              ],
              [
                46.110158,
                33.079484
              ],
              [
                46.110254,
                33.079584
              ],
              [
                46.111022,
                33.079767
              ],
              [
                46.111508,
                33.079717
              ],
              [
                46.111993,
                33.079563
              ],
              [
                46.112135,
                33.079428
              ],
              [
                46.112304,
                33.07935
              ],
              [
                46.112413,
                33.079381
              ],
              [
                46.112589,
                33.079621
              ],
              [
                46.112732,
                33.079635
              ],
              [
                46.112908,
                33.079511
              ],
              [
                46.113032,
                33.07933
              ],
              [
                46.113129,
                33.078977
              ],
              [
                46.113492,
                33.07843
              ],
              [
                46.113742,
                33.078178
              ],
              [
                46.113761,
                33.077982
              ],
              [
                46.113719,
                33.077824
              ],
              [
                46.113646,
                33.077759
              ],
              [
                46.113746,
                33.077516
              ],
              [
                46.113668,
                33.077359
              ],
              [
                46.113774,
                33.077208
              ],
              [
                46.113994,
                33.077083
              ],
              [
                46.11419,
                33.077011
              ],
              [
                46.114356,
                33.077015
              ],
              [
                46.114707,
                33.076862
              ],
              [
                46.114968,
                33.076624
              ],
              [
                46.115087,
                33.076428
              ],
              [
                46.115118,
                33.075943
              ],
              [
                46.115015,
                33.075839
              ],
              [
                46.114816,
                33.075779
              ],
              [
                46.114858,
                33.075381
              ],
              [
                46.115145,
                33.074726
              ],
              [
                46.115549,
                33.074518
              ],
              [
                46.115754,
                33.07446
              ],
              [
                46.115682,
                33.074179
              ],
              [
                46.115838,
                33.074113
              ],
              [
                46.116232,
                33.074151
              ],
              [
                46.116455,
                33.074101
              ],
              [
                46.116518,
                33.073951
              ],
              [
                46.116439,
                33.073765
              ],
              [
                46.116507,
                33.07354
              ],
              [
                46.117045,
                33.073243
              ],
              [
                46.117229,
                33.073246
              ],
              [
                46.117825,
                33.073483
              ],
              [
                46.117946,
                33.073486
              ],
              [
                46.118013,
                33.073334
              ],
              [
                46.1181,
                33.073264
              ],
              [
                46.118301,
                33.07329
              ],
              [
                46.118438,
                33.073186
              ],
              [
                46.118709,
                33.073144
              ],
              [
                46.118998,
                33.073177
              ],
              [
                46.119192,
                33.073027
              ],
              [
                46.11964,
                33.073026
              ],
              [
                46.119804,
                33.072871
              ],
              [
                46.119872,
                33.072526
              ],
              [
                46.119977,
                33.072484
              ],
              [
                46.120088,
                33.072519
              ],
              [
                46.120378,
                33.072506
              ],
              [
                46.120666,
                33.072242
              ],
              [
                46.12108,
                33.072126
              ],
              [
                46.121729,
                33.072151
              ],
              [
                46.121939,
                33.072041
              ],
              [
                46.122207,
                33.07201
              ],
              [
                46.122415,
                33.071921
              ],
              [
                46.122792,
                33.072009
              ],
              [
                46.122958,
                33.072421
              ],
              [
                46.123206,
                33.072717
              ],
              [
                46.123341,
                33.072754
              ],
              [
                46.123501,
                33.07263
              ],
              [
                46.123628,
                33.07261
              ],
              [
                46.124291,
                33.072863
              ],
              [
                46.124813,
                33.072887
              ],
              [
                46.124947,
                33.073018
              ],
              [
                46.125126,
                33.073095
              ],
              [
                46.125204,
                33.073229
              ],
              [
                46.12569,
                33.073269
              ],
              [
                46.126144,
                33.073465
              ],
              [
                46.12672,
                33.073475
              ],
              [
                46.126958,
                33.073533
              ],
              [
                46.127064,
                33.073668
              ],
              [
                46.127433,
                33.0737
              ],
              [
                46.127697,
                33.073941
              ],
              [
                46.127999,
                33.07403
              ],
              [
                46.128239,
                33.073998
              ],
              [
                46.128394,
                33.073854
              ],
              [
                46.128947,
                33.073717
              ],
              [
                46.129284,
                33.073733
              ],
              [
                46.129422,
                33.073858
              ],
              [
                46.129619,
                33.073864
              ],
              [
                46.129751,
                33.073959
              ],
              [
                46.130314,
                33.074034
              ],
              [
                46.130354,
                33.074106
              ],
              [
                46.131133,
                33.074075
              ],
              [
                46.131318,
                33.074036
              ],
              [
                46.131521,
                33.073895
              ],
              [
                46.131881,
                33.073839
              ],
              [
                46.132034,
                33.073758
              ],
              [
                46.132158,
                33.073604
              ],
              [
                46.13234,
                33.073184
              ],
              [
                46.132167,
                33.073059
              ],
              [
                46.132205,
                33.073001
              ],
              [
                46.132555,
                33.072906
              ],
              [
                46.13275,
                33.072735
              ],
              [
                46.132789,
                33.072583
              ],
              [
                46.13305,
                33.072569
              ],
              [
                46.133287,
                33.072454
              ],
              [
                46.133567,
                33.072447
              ],
              [
                46.133801,
                33.072348
              ],
              [
                46.134319,
                33.072378
              ],
              [
                46.134524,
                33.072347
              ],
              [
                46.134648,
                33.072265
              ],
              [
                46.134716,
                33.072114
              ],
              [
                46.135067,
                33.071898
              ],
              [
                46.135207,
                33.071981
              ],
              [
                46.135569,
                33.072029
              ],
              [
                46.135777,
                33.07182
              ],
              [
                46.13597,
                33.071811
              ],
              [
                46.136168,
                33.071916
              ],
              [
                46.136269,
                33.071859
              ],
              [
                46.136342,
                33.071733
              ],
              [
                46.136361,
                33.071568
              ],
              [
                46.136751,
                33.071618
              ],
              [
                46.136898,
                33.071532
              ],
              [
                46.13716,
                33.071596
              ],
              [
                46.137313,
                33.071515
              ],
              [
                46.137598,
                33.071727
              ],
              [
                46.138031,
                33.071812
              ],
              [
                46.138872,
                33.071578
              ],
              [
                46.13939,
                33.07166
              ],
              [
                46.139546,
                33.071589
              ],
              [
                46.139916,
                33.0716
              ],
              [
                46.140173,
                33.071545
              ],
              [
                46.140601,
                33.071583
              ],
              [
                46.141056,
                33.071325
              ],
              [
                46.141114,
                33.071107
              ],
              [
                46.141216,
                33.070956
              ],
              [
                46.141351,
                33.07092
              ],
              [
                46.141508,
                33.070953
              ],
              [
                46.141571,
                33.071074
              ],
              [
                46.141774,
                33.071157
              ],
              [
                46.141994,
                33.071165
              ],
              [
                46.142443,
                33.07095
              ],
              [
                46.143761,
                33.071425
              ],
              [
                46.143972,
                33.071398
              ],
              [
                46.144157,
                33.071427
              ],
              [
                46.144241,
                33.071294
              ],
              [
                46.144417,
                33.071215
              ],
              [
                46.145557,
                33.070987
              ],
              [
                46.145956,
                33.070951
              ],
              [
                46.146221,
                33.070686
              ],
              [
                46.146408,
                33.070605
              ],
              [
                46.147037,
                33.070571
              ],
              [
                46.147089,
                33.070474
              ],
              [
                46.147573,
                33.070384
              ],
              [
                46.147877,
                33.070431
              ],
              [
                46.148127,
                33.07081
              ],
              [
                46.148362,
                33.070931
              ],
              [
                46.148436,
                33.071269
              ],
              [
                46.148631,
                33.071317
              ],
              [
                46.148679,
                33.071398
              ],
              [
                46.148853,
                33.071429
              ],
              [
                46.149031,
                33.071527
              ],
              [
                46.149619,
                33.071368
              ],
              [
                46.149963,
                33.071462
              ],
              [
                46.150411,
                33.071487
              ],
              [
                46.150541,
                33.07155
              ],
              [
                46.150986,
                33.071612
              ],
              [
                46.15123,
                33.071334
              ],
              [
                46.151265,
                33.071188
              ],
              [
                46.151939,
                33.071225
              ],
              [
                46.152175,
                33.071178
              ],
              [
                46.152761,
                33.071255
              ],
              [
                46.152921,
                33.071178
              ],
              [
                46.153151,
                33.071206
              ],
              [
                46.153669,
                33.071063
              ],
              [
                46.153794,
                33.071133
              ],
              [
                46.153847,
                33.07126
              ],
              [
                46.154024,
                33.071327
              ],
              [
                46.154433,
                33.071311
              ],
              [
                46.15527,
                33.071646
              ],
              [
                46.155286,
                33.072004
              ],
              [
                46.155067,
                33.072121
              ],
              [
                46.155052,
                33.072228
              ],
              [
                46.155266,
                33.072404
              ],
              [
                46.155614,
                33.072543
              ],
              [
                46.156604,
                33.072531
              ],
              [
                46.15683,
                33.072466
              ],
              [
                46.157215,
                33.07225
              ],
              [
                46.157395,
                33.072013
              ],
              [
                46.157733,
                33.07194
              ],
              [
                46.157989,
                33.07176
              ],
              [
                46.158782,
                33.071789
              ],
              [
                46.158971,
                33.071666
              ],
              [
                46.159114,
                33.071467
              ],
              [
                46.159574,
                33.071229
              ],
              [
                46.159859,
                33.070976
              ],
              [
                46.160672,
                33.070846
              ],
              [
                46.160806,
                33.07107
              ],
              [
                46.161201,
                33.071067
              ],
              [
                46.161332,
                33.071135
              ],
              [
                46.161471,
                33.071286
              ],
              [
                46.161667,
                33.071293
              ],
              [
                46.162873,
                33.071076
              ],
              [
                46.163232,
                33.070577
              ],
              [
                46.16363,
                33.070463
              ],
              [
                46.163654,
                33.070298
              ],
              [
                46.163853,
                33.069949
              ],
              [
                46.164199,
                33.069765
              ],
              [
                46.164373,
                33.069576
              ],
              [
                46.164625,
                33.069428
              ],
              [
                46.164311,
                33.069069
              ],
              [
                46.164144,
                33.06897
              ],
              [
                46.164059,
                33.068831
              ],
              [
                46.16369,
                33.068701
              ],
              [
                46.163598,
                33.068558
              ],
              [
                46.16342,
                33.068481
              ],
              [
                46.163179,
                33.068461
              ],
              [
                46.162653,
                33.06803
              ],
              [
                46.16256,
                33.067805
              ],
              [
                46.162103,
                33.067379
              ],
              [
                46.161857,
                33.067261
              ],
              [
                46.161496,
                33.066899
              ],
              [
                46.160933,
                33.066557
              ],
              [
                46.160838,
                33.066348
              ],
              [
                46.16087,
                33.066097
              ],
              [
                46.160521,
                33.065447
              ],
              [
                46.159614,
                33.065252
              ],
              [
                46.159404,
                33.065139
              ],
              [
                46.159101,
                33.06517
              ],
              [
                46.158861,
                33.065076
              ],
              [
                46.158734,
                33.065122
              ],
              [
                46.158673,
                33.065277
              ],
              [
                46.158513,
                33.065401
              ],
              [
                46.158269,
                33.065387
              ],
              [
                46.158098,
                33.065345
              ],
              [
                46.157899,
                33.06511
              ],
              [
                46.157346,
                33.065007
              ],
              [
                46.15643,
                33.065284
              ],
              [
                46.156434,
                33.064886
              ],
              [
                46.156133,
                33.064755
              ],
              [
                46.155702,
                33.064702
              ],
              [
                46.155647,
                33.064642
              ],
              [
                46.155729,
                33.064332
              ],
              [
                46.155333,
                33.063678
              ],
              [
                46.155222,
                33.06357
              ],
              [
                46.154516,
                33.063449
              ],
              [
                46.154294,
                33.063457
              ],
              [
                46.153853,
                33.063583
              ],
              [
                46.153431,
                33.063548
              ],
              [
                46.152999,
                33.063296
              ],
              [
                46.152787,
                33.063105
              ],
              [
                46.152467,
                33.062575
              ],
              [
                46.151663,
                33.061968
              ],
              [
                46.151472,
                33.061669
              ],
              [
                46.151389,
                33.061389
              ],
              [
                46.151399,
                33.061116
              ],
              [
                46.151471,
                33.060886
              ],
              [
                46.151911,
                33.060322
              ],
              [
                46.152069,
                33.060042
              ],
              [
                46.152267,
                33.05986
              ],
              [
                46.152306,
                33.059682
              ],
              [
                46.152273,
                33.05867
              ],
              [
                46.152199,
                33.058405
              ],
              [
                46.152024,
                33.058202
              ],
              [
                46.151866,
                33.058111
              ],
              [
                46.151483,
                33.058045
              ],
              [
                46.150889,
                33.057573
              ],
              [
                46.149996,
                33.057173
              ],
              [
                46.149819,
                33.056981
              ],
              [
                46.149673,
                33.056701
              ],
              [
                46.149548,
                33.05637
              ],
              [
                46.14945,
                33.055081
              ],
              [
                46.149854,
                33.053897
              ],
              [
                46.14986,
                33.053656
              ],
              [
                46.149643,
                33.053345
              ],
              [
                46.148889,
                33.05285
              ],
              [
                46.148747,
                33.052689
              ],
              [
                46.14866,
                33.052489
              ],
              [
                46.148558,
                33.051837
              ],
              [
                46.148581,
                33.051546
              ],
              [
                46.148357,
                33.051012
              ],
              [
                46.14791,
                33.050527
              ],
              [
                46.147694,
                33.050441
              ],
              [
                46.147593,
                33.050451
              ],
              [
                46.147554,
                33.050603
              ],
              [
                46.147261,
                33.05094
              ],
              [
                46.146586,
                33.051243
              ],
              [
                46.146289,
                33.051299
              ],
              [
                46.146015,
                33.051278
              ],
              [
                46.14509,
                33.050935
              ],
              [
                46.144924,
                33.050768
              ],
              [
                46.144544,
                33.050132
              ],
              [
                46.14398,
                33.049541
              ],
              [
                46.143591,
                33.049256
              ],
              [
                46.14341,
                33.049049
              ],
              [
                46.143361,
                33.048916
              ],
              [
                46.143413,
                33.048162
              ],
              [
                46.143239,
                33.047766
              ],
              [
                46.142995,
                33.04773
              ],
              [
                46.142824,
                33.047809
              ],
              [
                46.142149,
                33.048544
              ],
              [
                46.141976,
                33.048639
              ],
              [
                46.141867,
                33.04864
              ],
              [
                46.14171,
                33.048439
              ],
              [
                46.141704,
                33.048268
              ],
              [
                46.141812,
                33.047944
              ],
              [
                46.141686,
                33.047389
              ],
              [
                46.141683,
                33.047108
              ],
              [
                46.141542,
                33.046754
              ],
              [
                46.141222,
                33.046688
              ],
              [
                46.139982,
                33.046884
              ],
              [
                46.139826,
                33.046877
              ],
              [
                46.139719,
                33.046789
              ],
              [
                46.139517,
                33.046372
              ],
              [
                46.139373,
                33.04547
              ],
              [
                46.138908,
                33.043647
              ],
              [
                46.138979,
                33.043
              ],
              [
                46.139192,
                33.042127
              ],
              [
                46.13919,
                33.041855
              ],
              [
                46.138983,
                33.041292
              ],
              [
                46.138476,
                33.040363
              ],
              [
                46.137662,
                33.039372
              ],
              [
                46.136929,
                33.038796
              ],
              [
                46.136012,
                33.038217
              ],
              [
                46.135728,
                33.037916
              ],
              [
                46.134531,
                33.036979
              ],
              [
                46.133808,
                33.036594
              ],
              [
                46.13182,
                33.03583
              ],
              [
                46.131667,
                33.035692
              ],
              [
                46.13143,
                33.035275
              ],
              [
                46.131322,
                33.034963
              ],
              [
                46.131304,
                33.034569
              ],
              [
                46.131387,
                33.03417
              ],
              [
                46.131564,
                33.033824
              ],
              [
                46.131962,
                33.033518
              ],
              [
                46.132476,
                33.033261
              ],
              [
                46.133059,
                33.033103
              ],
              [
                46.133492,
                33.033068
              ],
              [
                46.134634,
                33.032558
              ],
              [
                46.134874,
                33.032333
              ],
              [
                46.135108,
                33.031963
              ],
              [
                46.135291,
                33.031549
              ],
              [
                46.135376,
                33.031228
              ],
              [
                46.13536,
                33.031037
              ],
              [
                46.135287,
                33.030897
              ],
              [
                46.135103,
                33.030727
              ],
              [
                46.134298,
                33.030209
              ],
              [
                46.133923,
                33.030006
              ],
              [
                46.132879,
                33.029624
              ],
              [
                46.132753,
                33.029529
              ],
              [
                46.1323,
                33.028195
              ],
              [
                46.132169,
                33.027954
              ],
              [
                46.131454,
                33.027307
              ],
              [
                46.131383,
                33.02713
              ],
              [
                46.131363,
                33.026753
              ],
              [
                46.131561,
                33.026425
              ],
              [
                46.131818,
                33.026275
              ],
              [
                46.133032,
                33.025848
              ],
              [
                46.133265,
                33.025718
              ],
              [
                46.133512,
                33.025451
              ],
              [
                46.133729,
                33.025057
              ],
              [
                46.133815,
                33.024715
              ],
              [
                46.133727,
                33.024176
              ],
              [
                46.133592,
                33.02392
              ],
              [
                46.133351,
                33.023701
              ],
              [
                46.133038,
                33.023541
              ],
              [
                46.132628,
                33.023458
              ],
              [
                46.132115,
                33.023474
              ],
              [
                46.131191,
                33.023643
              ],
              [
                46.130259,
                33.024
              ],
              [
                46.128791,
                33.023861
              ],
              [
                46.128511,
                33.023768
              ],
              [
                46.12833,
                33.023587
              ],
              [
                46.128187,
                33.023223
              ],
              [
                46.128212,
                33.023063
              ],
              [
                46.128474,
                33.022788
              ],
              [
                46.128721,
                33.02264
              ],
              [
                46.130097,
                33.022073
              ],
              [
                46.130344,
                33.021811
              ],
              [
                46.130313,
                33.021508
              ],
              [
                46.130071,
                33.021117
              ],
              [
                46.129911,
                33.020975
              ],
              [
                46.129293,
                33.020788
              ],
              [
                46.128807,
                33.020748
              ],
              [
                46.125558,
                33.020695
              ],
              [
                46.125216,
                33.020659
              ],
              [
                46.125033,
                33.020515
              ],
              [
                46.124853,
                33.020094
              ],
              [
                46.125013,
                33.018707
              ],
              [
                46.124425,
                33.018161
              ],
              [
                46.123662,
                33.017872
              ],
              [
                46.123389,
                33.017835
              ],
              [
                46.12328,
                33.017857
              ],
              [
                46.123173,
                33.017942
              ],
              [
                46.122516,
                33.018899
              ],
              [
                46.122417,
                33.019431
              ],
              [
                46.122437,
                33.020122
              ],
              [
                46.122315,
                33.02048
              ],
              [
                46.121812,
                33.020635
              ],
              [
                46.121651,
                33.020728
              ],
              [
                46.12135,
                33.021035
              ],
              [
                46.120736,
                33.02184
              ],
              [
                46.120427,
                33.022132
              ],
              [
                46.11945,
                33.022737
              ],
              [
                46.11909,
                33.022886
              ],
              [
                46.118796,
                33.022932
              ],
              [
                46.118652,
                33.022881
              ],
              [
                46.118589,
                33.022786
              ],
              [
                46.118478,
                33.021879
              ],
              [
                46.118243,
                33.021441
              ],
              [
                46.117994,
                33.020754
              ],
              [
                46.11776,
                33.020466
              ],
              [
                46.117738,
                33.020083
              ],
              [
                46.117952,
                33.019748
              ],
              [
                46.117963,
                33.019553
              ],
              [
                46.117883,
                33.019237
              ],
              [
                46.117794,
                33.019151
              ],
              [
                46.117486,
                33.019016
              ],
              [
                46.116973,
                33.018886
              ],
              [
                46.11552,
                33.018593
              ],
              [
                46.114889,
                33.018544
              ],
              [
                46.114381,
                33.01868
              ],
              [
                46.113771,
                33.018988
              ],
              [
                46.113255,
                33.019401
              ],
              [
                46.112972,
                33.019539
              ],
              [
                46.112334,
                33.019684
              ],
              [
                46.111627,
                33.019631
              ],
              [
                46.111515,
                33.019596
              ],
              [
                46.111079,
                33.01923
              ],
              [
                46.111029,
                33.019092
              ],
              [
                46.111191,
                33.018247
              ],
              [
                46.111144,
                33.018046
              ],
              [
                46.109822,
                33.017362
              ],
              [
                46.109592,
                33.017262
              ],
              [
                46.109423,
                33.017252
              ],
              [
                46.108814,
                33.017444
              ],
              [
                46.108587,
                33.01772
              ],
              [
                46.108373,
                33.019125
              ],
              [
                46.108378,
                33.020189
              ],
              [
                46.108299,
                33.020655
              ],
              [
                46.108228,
                33.020864
              ],
              [
                46.108119,
                33.020965
              ],
              [
                46.107598,
                33.021238
              ],
              [
                46.106679,
                33.021233
              ],
              [
                46.106062,
                33.021125
              ],
              [
                46.105899,
                33.02104
              ],
              [
                46.105511,
                33.020662
              ],
              [
                46.105137,
                33.019905
              ],
              [
                46.10494,
                33.019147
              ],
              [
                46.104701,
                33.018767
              ],
              [
                46.104381,
                33.018555
              ],
              [
                46.104043,
                33.018435
              ],
              [
                46.10312,
                33.018342
              ],
              [
                46.102916,
                33.018379
              ],
              [
                46.102742,
                33.018468
              ],
              [
                46.102421,
                33.018737
              ],
              [
                46.101299,
                33.019259
              ],
              [
                46.100726,
                33.019629
              ],
              [
                46.100479,
                33.020111
              ],
              [
                46.100301,
                33.020259
              ],
              [
                46.099948,
                33.020318
              ],
              [
                46.099603,
                33.020027
              ],
              [
                46.099162,
                33.019813
              ],
              [
                46.098959,
                33.019437
              ],
              [
                46.098868,
                33.019083
              ],
              [
                46.099053,
                33.018853
              ],
              [
                46.099161,
                33.018535
              ],
              [
                46.099338,
                33.018293
              ],
              [
                46.099563,
                33.018088
              ],
              [
                46.100124,
                33.017774
              ],
              [
                46.100196,
                33.017595
              ],
              [
                46.100227,
                33.017357
              ],
              [
                46.100026,
                33.016643
              ],
              [
                46.099915,
                33.015699
              ],
              [
                46.099778,
                33.015317
              ],
              [
                46.099379,
                33.014623
              ],
              [
                46.098585,
                33.01371
              ],
              [
                46.097849,
                33.013198
              ],
              [
                46.097163,
                33.012982
              ],
              [
                46.096495,
                33.01285
              ],
              [
                46.096429,
                33.012756
              ],
              [
                46.096445,
                33.012351
              ],
              [
                46.09632,
                33.011847
              ],
              [
                46.096701,
                33.010288
              ],
              [
                46.097017,
                33.009486
              ],
              [
                46.096942,
                33.009056
              ],
              [
                46.096821,
                33.008892
              ],
              [
                46.096607,
                33.008772
              ],
              [
                46.095898,
                33.008529
              ],
              [
                46.095238,
                33.008507
              ],
              [
                46.094435,
                33.008624
              ],
              [
                46.093717,
                33.008645
              ],
              [
                46.093604,
                33.008567
              ],
              [
                46.093591,
                33.008486
              ],
              [
                46.094025,
                33.007806
              ],
              [
                46.094825,
                33.007128
              ],
              [
                46.095652,
                33.006568
              ],
              [
                46.09581,
                33.006415
              ],
              [
                46.095818,
                33.006276
              ],
              [
                46.095786,
                33.006185
              ],
              [
                46.095452,
                33.005832
              ],
              [
                46.095063,
                33.005231
              ],
              [
                46.094855,
                33.005063
              ],
              [
                46.09397,
                33.00459
              ],
              [
                46.093688,
                33.004363
              ],
              [
                46.09353,
                33.004114
              ],
              [
                46.093482,
                33.003904
              ],
              [
                46.093566,
                33.003797
              ],
              [
                46.093754,
                33.003684
              ],
              [
                46.094599,
                33.003354
              ],
              [
                46.095612,
                33.003117
              ],
              [
                46.098003,
                33.00278
              ],
              [
                46.098343,
                33.00264
              ],
              [
                46.098742,
                33.002405
              ],
              [
                46.099084,
                33.002096
              ],
              [
                46.099364,
                33.00171
              ],
              [
                46.099575,
                33.001273
              ],
              [
                46.099781,
                33.000358
              ],
              [
                46.099575,
                32.999358
              ],
              [
                46.099088,
                32.99843
              ],
              [
                46.098561,
                32.99788
              ],
              [
                46.097888,
                32.99747
              ],
              [
                46.097484,
                32.997276
              ],
              [
                46.09723,
                32.996901
              ],
              [
                46.097136,
                32.996596
              ],
              [
                46.097143,
                32.996456
              ],
              [
                46.097333,
                32.996226
              ],
              [
                46.097546,
                32.995662
              ],
              [
                46.097987,
                32.995079
              ],
              [
                46.098157,
                32.994946
              ],
              [
                46.098242,
                32.994697
              ],
              [
                46.098159,
                32.994425
              ],
              [
                46.097921,
                32.994127
              ],
              [
                46.096693,
                32.993214
              ],
              [
                46.096202,
                32.992778
              ],
              [
                46.096086,
                32.992605
              ],
              [
                46.096033,
                32.992408
              ],
              [
                46.09608,
                32.992011
              ],
              [
                46.095987,
                32.991637
              ],
              [
                46.096097,
                32.9911
              ],
              [
                46.096,
                32.99053
              ],
              [
                46.095939,
                32.990398
              ],
              [
                46.095618,
                32.990106
              ],
              [
                46.095442,
                32.98983
              ],
              [
                46.095278,
                32.989431
              ],
              [
                46.095135,
                32.989032
              ],
              [
                46.095103,
                32.988767
              ],
              [
                46.095147,
                32.988406
              ],
              [
                46.095099,
                32.988063
              ],
              [
                46.094033,
                32.985127
              ],
              [
                46.094107,
                32.984979
              ],
              [
                46.095709,
                32.984173
              ],
              [
                46.095919,
                32.984124
              ],
              [
                46.096286,
                32.984175
              ],
              [
                46.09639,
                32.984125
              ],
              [
                46.09647,
                32.983975
              ],
              [
                46.09669,
                32.983774
              ],
              [
                46.097443,
                32.983341
              ],
              [
                46.097641,
                32.983161
              ],
              [
                46.097772,
                32.982926
              ],
              [
                46.097817,
                32.982679
              ],
              [
                46.097787,
                32.982466
              ],
              [
                46.097583,
                32.982075
              ],
              [
                46.09743,
                32.981967
              ],
              [
                46.096988,
                32.982059
              ],
              [
                46.096756,
                32.981984
              ],
              [
                46.096602,
                32.98185
              ],
              [
                46.096511,
                32.98168
              ],
              [
                46.10218,
                32.977612
              ],
              [
                46.109093,
                32.974259
              ],
              [
                46.119994,
                32.968885
              ],
              [
                46.133748,
                32.960869
              ],
              [
                46.137802,
                32.95993
              ],
              [
                46.159405,
                32.955131
              ],
              [
                46.173556,
                32.953285
              ],
              [
                46.199846,
                32.959124
              ],
              [
                46.207354,
                32.960539
              ],
              [
                46.2098762,
                32.9610943
              ],
              [
                46.2205,
                32.963433
              ],
              [
                46.244134,
                32.97019
              ],
              [
                46.253742,
                32.968606
              ],
              [
                46.266369,
                32.972447
              ],
              [
                46.282369,
                32.968902
              ],
              [
                46.298142,
                32.968288
              ],
              [
                46.312327,
                32.968816
              ],
              [
                46.322019,
                32.965782
              ],
              [
                46.331533,
                32.96523
              ],
              [
                46.344807,
                32.958594
              ],
              [
                46.347508,
                32.960324
              ],
              [
                46.359192,
                32.954786
              ],
              [
                46.387556,
                32.948836
              ],
              [
                46.410102,
                32.947231
              ],
              [
                46.415413,
                32.941534
              ],
              [
                46.422569,
                32.937529
              ],
              [
                46.427617,
                32.935532
              ],
              [
                46.431613,
                32.934585
              ],
              [
                46.436942,
                32.933396
              ],
              [
                46.441183,
                32.931093
              ],
              [
                46.444382,
                32.930514
              ],
              [
                46.447421,
                32.933275
              ],
              [
                46.451022,
                32.931069
              ],
              [
                46.449409,
                32.927365
              ],
              [
                46.461767,
                32.921565
              ],
              [
                46.462092,
                32.921379
              ],
              [
                46.471655,
                32.917659
              ],
              [
                46.480506,
                32.916202
              ],
              [
                46.491513,
                32.902993
              ],
              [
                46.504161,
                32.902106
              ],
              [
                46.510712,
                32.900282
              ],
              [
                46.5142611,
                32.8993366
              ],
              [
                46.515756,
                32.901963
              ],
              [
                46.5182684,
                32.9057334
              ],
              [
                46.5188216,
                32.9065641
              ],
              [
                46.556601,
                32.969064
              ],
              [
                46.5582675,
                32.9715652
              ],
              [
                46.5702145,
                32.9865715
              ],
              [
                46.5732708,
                32.9887927
              ],
              [
                46.5782709,
                32.9910139
              ],
              [
                46.5799374,
                32.9910139
              ],
              [
                46.5802139,
                32.9912938
              ],
              [
                46.5907703,
                32.9912939
              ],
              [
                46.5918805,
                32.9915738
              ],
              [
                46.594104,
                32.9915737
              ],
              [
                46.604937,
                32.9940658
              ],
              [
                46.6110503,
                32.9985172
              ],
              [
                46.6146606,
                33.0029595
              ],
              [
                46.631607,
                33.0187875
              ],
              [
                46.631607,
                33.0190674
              ],
              [
                46.6318835,
                33.0193473
              ],
              [
                46.6327164,
                33.0201779
              ],
              [
                46.6329929,
                33.0204579
              ],
              [
                46.6346633,
                33.0237896
              ],
              [
                46.63605,
                33.0318436
              ],
              [
                46.6399399,
                33.0354642
              ],
              [
                46.6416064,
                33.0349044
              ],
              [
                46.6416063,
                33.0346245
              ],
              [
                46.6443829,
                33.0346245
              ],
              [
                46.64494,
                33.0343446
              ],
              [
                46.6466065,
                33.0343446
              ],
              [
                46.646883,
                33.0374055
              ],
              [
                46.6466064,
                33.038516
              ],
              [
                46.6466064,
                33.0389033
              ],
              [
                46.6552199,
                33.0443488
              ],
              [
                46.6643865,
                33.0479605
              ],
              [
                46.6660529,
                33.0482313
              ],
              [
                46.6668865,
                33.0487911
              ],
              [
                46.6702194,
                33.0496218
              ],
              [
                46.6721623,
                33.0510123
              ],
              [
                46.6727194,
                33.0546239
              ],
              [
                46.6752194,
                33.0593461
              ],
              [
                46.6768858,
                33.0601767
              ],
              [
                46.6771624,
                33.0607365
              ],
              [
                46.6785523,
                33.0615672
              ],
              [
                46.6782757,
                33.0618471
              ],
              [
                46.6771624,
                33.0635174
              ],
              [
                46.6768858,
                33.0637974
              ],
              [
                46.6766093,
                33.0654587
              ],
              [
                46.6788296,
                33.0726819
              ],
              [
                46.6788296,
                33.0729618
              ],
              [
                46.6788296,
                33.0743431
              ],
              [
                46.6785522,
                33.0746231
              ],
              [
                46.6766092,
                33.077404
              ],
              [
                46.6757755,
                33.0787945
              ],
              [
                46.6757756,
                33.0793452
              ],
              [
                46.6649395,
                33.0912905
              ],
              [
                46.6607729,
                33.0974031
              ],
              [
                46.6577197,
                33.105466
              ],
              [
                46.6566064,
                33.1090685
              ],
              [
                46.6541063,
                33.1174021
              ],
              [
                46.6518828,
                33.1212935
              ],
              [
                46.6502164,
                33.1224041
              ],
              [
                46.6257728,
                33.1310176
              ],
              [
                46.6088264,
                33.137401
              ],
              [
                46.6074365,
                33.1376899
              ],
              [
                46.5871604,
                33.1482446
              ],
              [
                46.5854939,
                33.1501767
              ],
              [
                46.5852133,
                33.1510164
              ],
              [
                46.5852133,
                33.1565782
              ],
              [
                46.5849368,
                33.1574089
              ],
              [
                46.5829938,
                33.164352
              ],
              [
                46.5807703,
                33.1674038
              ],
              [
                46.5774365,
                33.1687942
              ],
              [
                46.5763233,
                33.1687942
              ],
              [
                46.5757701,
                33.169074
              ],
              [
                46.5721568,
                33.169074
              ],
              [
                46.5713232,
                33.169354
              ],
              [
                46.5674372,
                33.1693539
              ],
              [
                46.5602136,
                33.1707353
              ],
              [
                46.5585471,
                33.171575
              ],
              [
                46.5571573,
                33.1718458
              ],
              [
                46.5560471,
                33.1724056
              ],
              [
                46.5557674,
                33.1729564
              ],
              [
                46.5549337,
                33.1732363
              ],
              [
                46.5513236,
                33.1774076
              ],
              [
                46.5452141,
                33.1799086
              ],
              [
                46.5446572,
                33.1799085
              ],
              [
                46.5435476,
                33.1801884
              ],
              [
                46.5421569,
                33.1801885
              ],
              [
                46.5404905,
                33.1790779
              ],
              [
                46.5391006,
                33.1785181
              ],
              [
                46.5377108,
                33.1785181
              ],
              [
                46.5368771,
                33.1782382
              ],
              [
                46.5352108,
                33.1782382
              ],
              [
                46.5349341,
                33.1779673
              ],
              [
                46.5266012,
                33.1793487
              ],
              [
                46.5260442,
                33.1796286
              ],
              [
                46.5246574,
                33.1796286
              ],
              [
                46.522991,
                33.1801884
              ],
              [
                46.5199346,
                33.1801884
              ],
              [
                46.5193776,
                33.1799085
              ],
              [
                46.5177112,
                33.1799085
              ],
              [
                46.5088212,
                33.1771276
              ],
              [
                46.5046546,
                33.1771276
              ],
              [
                46.4996546,
                33.1771276
              ],
              [
                46.4946545,
                33.176017
              ],
              [
                46.4857644,
                33.1732361
              ],
              [
                46.4846551,
                33.1729562
              ],
              [
                46.470765,
                33.1682431
              ],
              [
                46.4582655,
                33.1632412
              ],
              [
                46.4535419,
                33.1618506
              ],
              [
                46.4527084,
                33.1618507
              ],
              [
                46.4524318,
                33.1615708
              ],
              [
                46.4515982,
                33.1615708
              ],
              [
                46.4510419,
                33.1612909
              ],
              [
                46.4463184,
                33.1612909
              ],
              [
                46.4454856,
                33.1615707
              ],
              [
                46.4429855,
                33.1615707
              ],
              [
                46.4418754,
                33.1618507
              ],
              [
                46.4404855,
                33.1618506
              ],
              [
                46.4302087,
                33.1643516
              ],
              [
                46.4293758,
                33.1643516
              ],
              [
                46.426872,
                33.1654621
              ],
              [
                46.424929,
                33.1662927
              ],
              [
                46.4163193,
                33.1704641
              ],
              [
                46.4013158,
                33.1843503
              ],
              [
                46.3846491,
                33.2099107
              ],
              [
                46.3838162,
                33.211572
              ],
              [
                46.3838162,
                33.2118519
              ],
              [
                46.3835396,
                33.2124026
              ],
              [
                46.3832592,
                33.2132423
              ],
              [
                46.3835397,
                33.2176844
              ],
              [
                46.390206,
                33.2363016
              ],
              [
                46.3904826,
                33.2418452
              ],
              [
                46.3902061,
                33.2421341
              ],
              [
                46.388259,
                33.2482465
              ],
              [
                46.3874254,
                33.2493481
              ],
              [
                46.3871489,
                33.2496279
              ],
              [
                46.3871489,
                33.2499078
              ],
              [
                46.3868723,
                33.2501877
              ],
              [
                46.3863153,
                33.2512982
              ],
              [
                46.3860388,
                33.2521288
              ],
              [
                46.385759,
                33.2532394
              ],
              [
                46.3854825,
                33.2543499
              ],
              [
                46.3852059,
                33.2546298
              ],
              [
                46.3846488,
                33.2565709
              ],
              [
                46.3843722,
                33.2574015
              ],
              [
                46.3840925,
                33.2582412
              ],
              [
                46.3838159,
                33.2590718
              ],
              [
                46.3835395,
                33.2604622
              ],
              [
                46.383259,
                33.2612929
              ],
              [
                46.3829824,
                33.2624125
              ],
              [
                46.3793721,
                33.2707368
              ],
              [
                46.3790925,
                33.2715765
              ],
              [
                46.3785392,
                33.272687
              ],
              [
                46.377426,
                33.2760185
              ],
              [
                46.3771494,
                33.2776888
              ],
              [
                46.376872,
                33.2799098
              ],
              [
                46.3765923,
                33.281851
              ],
              [
                46.3763158,
                33.2843519
              ],
              [
                46.3763158,
                33.2860222
              ],
              [
                46.3763157,
                33.2865729
              ],
              [
                46.3757587,
                33.2879633
              ],
              [
                46.3743727,
                33.2951862
              ],
              [
                46.362149,
                33.3082414
              ],
              [
                46.3549261,
                33.3104624
              ],
              [
                46.353816,
                33.3104624
              ],
              [
                46.3502026,
                33.3115729
              ],
              [
                46.3490924,
                33.3115729
              ],
              [
                46.3482596,
                33.3118528
              ],
              [
                46.3460361,
                33.3121327
              ],
              [
                46.340479,
                33.3126834
              ],
              [
                46.3390931,
                33.3129632
              ],
              [
                46.3374258,
                33.3129632
              ],
              [
                46.336593,
                33.3132432
              ],
              [
                46.3335359,
                33.3132431
              ],
              [
                46.3279795,
                33.3137938
              ],
              [
                46.3271459,
                33.3140737
              ],
              [
                46.3165895,
                33.3140737
              ],
              [
                46.3154801,
                33.3137938
              ],
              [
                46.3096463,
                33.3137938
              ],
              [
                46.2876998,
                33.3124124
              ],
              [
                46.2846435,
                33.3126833
              ],
              [
                46.2840904,
                33.3129632
              ],
              [
                46.2815903,
                33.3129631
              ],
              [
                46.2813098,
                33.313243
              ],
              [
                46.2790903,
                33.313243
              ],
              [
                46.2785333,
                33.3137938
              ],
              [
                46.2790902,
                33.3146334
              ],
              [
                46.2793668,
                33.3149042
              ],
              [
                46.2799239,
                33.315464
              ],
              [
                46.2799239,
                33.3157439
              ],
              [
                46.2813098,
                33.3171342
              ],
              [
                46.2854771,
                33.3229667
              ],
              [
                46.2874231,
                33.3382429
              ],
              [
                46.2871435,
                33.3387936
              ],
              [
                46.2868669,
                33.340184
              ],
              [
                46.2865904,
                33.3421251
              ],
              [
                46.2840902,
                33.3524085
              ],
              [
                46.2835331,
                33.3532482
              ],
              [
                46.2799237,
                33.3551893
              ],
              [
                46.2788096,
                33.3560199
              ],
              [
                46.2771432,
                33.3576901
              ],
              [
                46.27659,
                33.3596312
              ],
              [
                46.2768666,
                33.3638023
              ],
              [
                46.2771431,
                33.364353
              ],
              [
                46.2768666,
                33.3663032
              ],
              [
                46.2771431,
                33.3726863
              ],
              [
                46.2774236,
                33.3760268
              ],
              [
                46.278533,
                33.38185
              ],
              [
                46.2793666,
                33.3838002
              ],
              [
                46.2796432,
                33.3854705
              ],
              [
                46.2824228,
                33.3904632
              ],
              [
                46.2827002,
                33.3910228
              ],
              [
                46.2838096,
                33.3921333
              ],
              [
                46.286033,
                33.3943543
              ],
              [
                46.327422,
                33.4218546
              ],
              [
                46.3296456,
                33.422965
              ],
              [
                46.3460357,
                33.4343587
              ],
              [
                46.3602023,
                33.4557466
              ],
              [
                46.3613156,
                33.457137
              ],
              [
                46.3657586,
                33.4596377
              ],
              [
                46.3671484,
                33.4604683
              ],
              [
                46.3899278,
                33.4743536
              ],
              [
                46.3938145,
                33.4754641
              ],
              [
                46.3940951,
                33.475744
              ],
              [
                46.3957615,
                33.475744
              ],
              [
                46.4044683,
                33.4815491
              ],
              [
                46.4065945,
                33.4829665
              ],
              [
                46.406871,
                33.4835262
              ],
              [
                46.4077046,
                33.4843568
              ],
              [
                46.4091434,
                33.4865111
              ],
              [
                46.4099808,
                33.4877648
              ],
              [
                46.4103402,
                33.4883028
              ],
              [
                46.4104844,
                33.4885188
              ],
              [
                46.4110375,
                33.4890785
              ],
              [
                46.4135375,
                33.4979712
              ],
              [
                46.4152039,
                33.5015824
              ],
              [
                46.4160375,
                33.5051936
              ],
              [
                46.4177039,
                33.5096354
              ],
              [
                46.4177039,
                33.5101861
              ],
              [
                46.4174274,
                33.5101861
              ],
              [
                46.411871,
                33.5176883
              ],
              [
                46.411871,
                33.5182481
              ],
              [
                46.4004809,
                33.5265809
              ],
              [
                46.3921479,
                33.5285219
              ],
              [
                46.3902049,
                33.5290816
              ],
              [
                46.3863142,
                33.5299121
              ],
              [
                46.3857579,
                33.530192
              ],
              [
                46.3843712,
                33.530192
              ],
              [
                46.3802046,
                33.5313024
              ],
              [
                46.3629816,
                33.5443568
              ],
              [
                46.3518628,
                33.5510789
              ],
              [
                46.3518128,
                33.5511091
              ],
              [
                46.3510353,
                33.551579
              ],
              [
                46.3293684,
                33.5704653
              ],
              [
                46.3265886,
                33.5724153
              ],
              [
                46.3013647,
                33.597606
              ],
              [
                46.2838342,
                33.6099522
              ],
              [
                46.279279,
                33.614097
              ],
              [
                46.2718554,
                33.6215807
              ],
              [
                46.26363,
                33.6272441
              ],
              [
                46.2608645,
                33.6298375
              ],
              [
                46.2583605,
                33.6286463
              ],
              [
                46.254921,
                33.6273241
              ],
              [
                46.2508257,
                33.6260081
              ],
              [
                46.247376,
                33.6242928
              ],
              [
                46.2433471,
                33.6229366
              ],
              [
                46.2384438,
                33.6199976
              ],
              [
                46.2333031,
                33.6175563
              ],
              [
                46.2276411,
                33.6163805
              ],
              [
                46.2232528,
                33.6152491
              ],
              [
                46.2167132,
                33.6138969
              ],
              [
                46.2101734,
                33.6127533
              ],
              [
                46.2047668,
                33.6139253
              ],
              [
                46.2004533,
                33.6119633
              ],
              [
                46.1975467,
                33.608556
              ],
              [
                46.1930216,
                33.6032638
              ],
              [
                46.1902942,
                33.599443
              ],
              [
                46.1874839,
                33.5942281
              ],
              [
                46.1891147,
                33.587894
              ],
              [
                46.1877696,
                33.5824046
              ],
              [
                46.184687,
                33.580001
              ],
              [
                46.1798336,
                33.5780558
              ],
              [
                46.1757149,
                33.5766614
              ],
              [
                46.1721362,
                33.5755592
              ],
              [
                46.1677353,
                33.5752374
              ],
              [
                46.1608566,
                33.5749835
              ],
              [
                46.1557379,
                33.5769796
              ],
              [
                46.1525714,
                33.5779106
              ],
              [
                46.1442571,
                33.5804518
              ],
              [
                46.1384555,
                33.5829641
              ],
              [
                46.1280501,
                33.5894647
              ],
              [
                46.1234406,
                33.5896791
              ],
              [
                46.1149148,
                33.5921405
              ],
              [
                46.1046029,
                33.595426
              ],
              [
                46.1021439,
                33.5971677
              ],
              [
                46.0950877,
                33.6010639
              ],
              [
                46.0915337,
                33.6045795
              ],
              [
                46.0893678,
                33.607276
              ],
              [
                46.0853154,
                33.6063824
              ],
              [
                46.0751881,
                33.5996424
              ],
              [
                46.074078,
                33.598523
              ],
              [
                46.0710217,
                33.5951917
              ],
              [
                46.0662982,
                33.5804673
              ],
              [
                46.0593551,
                33.5690742
              ],
              [
                46.058245,
                33.5679728
              ],
              [
                46.0551888,
                33.5649124
              ],
              [
                46.0529652,
                33.5643617
              ],
              [
                46.0521324,
                33.5632513
              ],
              [
                46.0515785,
                33.5588005
              ],
              [
                46.047409,
                33.5524178
              ],
              [
                46.032132,
                33.5474162
              ],
              [
                46.0299093,
                33.5471364
              ],
              [
                46.0221327,
                33.5465857
              ],
              [
                46.0199092,
                33.5468565
              ],
              [
                46.0193529,
                33.5471364
              ],
              [
                46.0171326,
                33.5471364
              ],
              [
                46.0165762,
                33.5474162
              ],
              [
                46.0154661,
                33.5474162
              ],
              [
                45.9985196,
                33.5526885
              ],
              [
                45.995743,
                33.5540788
              ],
              [
                45.9887959,
                33.5551892
              ],
              [
                45.9871296,
                33.5549183
              ],
              [
                45.9846295,
                33.5540787
              ],
              [
                45.9837967,
                33.5540788
              ],
              [
                45.9687964,
                33.5426945
              ],
              [
                45.9682402,
                33.5424147
              ],
              [
                45.9682403,
                33.5421349
              ],
              [
                45.967683,
                33.5415841
              ],
              [
                45.96713,
                33.5393542
              ],
              [
                45.9687965,
                33.5368624
              ],
              [
                45.969073,
                33.5354721
              ],
              [
                45.9699067,
                33.531861
              ],
              [
                45.9693496,
                33.5285206
              ],
              [
                45.9685168,
                33.5268595
              ],
              [
                45.9671301,
                33.5257491
              ],
              [
                45.9668503,
                33.5251893
              ],
              [
                45.9662965,
                33.5251893
              ],
              [
                45.9576839,
                33.5151953
              ],
              [
                45.9557401,
                33.5140758
              ],
              [
                45.9346271,
                33.5007414
              ],
              [
                45.9337936,
                33.5007413
              ],
              [
                45.9265708,
                33.4968593
              ],
              [
                45.9257372,
                33.4968593
              ],
              [
                45.9257373,
                33.4971392
              ],
              [
                45.9229606,
                33.49741
              ],
              [
                45.9210176,
                33.4979698
              ],
              [
                45.9201841,
                33.4979697
              ],
              [
                45.9196277,
                33.4982496
              ],
              [
                45.916294,
                33.4982496
              ],
              [
                45.9121275,
                33.4962996
              ],
              [
                45.9093478,
                33.4957488
              ],
              [
                45.9079611,
                33.4960196
              ],
              [
                45.9060142,
                33.4968593
              ],
              [
                45.9007375,
                33.499351
              ],
              [
                45.8993476,
                33.5001905
              ],
              [
                45.8968475,
                33.5001905
              ],
              [
                45.893238,
                33.4976898
              ],
              [
                45.8899044,
                33.4976898
              ],
              [
                45.884348,
                33.4985204
              ],
              [
                45.8829582,
                33.4982495
              ],
              [
                45.8760066,
                33.4939496
              ],
              [
                45.8747964,
                33.4930667
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554902,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ایلام",
          "name:en": "Ilam County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291845",
          "wikipedia": "en:Ilam County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.1021439,
                33.5971677
              ],
              [
                46.1046029,
                33.595426
              ],
              [
                46.1149148,
                33.5921405
              ],
              [
                46.1234406,
                33.5896791
              ],
              [
                46.1280501,
                33.5894647
              ],
              [
                46.1384555,
                33.5829641
              ],
              [
                46.1442571,
                33.5804518
              ],
              [
                46.1525714,
                33.5779106
              ],
              [
                46.1557379,
                33.5769796
              ],
              [
                46.1608566,
                33.5749835
              ],
              [
                46.1677353,
                33.5752374
              ],
              [
                46.1721362,
                33.5755592
              ],
              [
                46.1757149,
                33.5766614
              ],
              [
                46.1798336,
                33.5780558
              ],
              [
                46.184687,
                33.580001
              ],
              [
                46.1877696,
                33.5824046
              ],
              [
                46.1891147,
                33.587894
              ],
              [
                46.1874839,
                33.5942281
              ],
              [
                46.1902942,
                33.599443
              ],
              [
                46.1930216,
                33.6032638
              ],
              [
                46.1975467,
                33.608556
              ],
              [
                46.2004533,
                33.6119633
              ],
              [
                46.2047668,
                33.6139253
              ],
              [
                46.2101734,
                33.6127533
              ],
              [
                46.2167132,
                33.6138969
              ],
              [
                46.2232528,
                33.6152491
              ],
              [
                46.2276411,
                33.6163805
              ],
              [
                46.2333031,
                33.6175563
              ],
              [
                46.2384438,
                33.6199976
              ],
              [
                46.2433471,
                33.6229366
              ],
              [
                46.247376,
                33.6242928
              ],
              [
                46.2508257,
                33.6260081
              ],
              [
                46.254921,
                33.6273241
              ],
              [
                46.2583605,
                33.6286463
              ],
              [
                46.2608645,
                33.6298375
              ],
              [
                46.26363,
                33.6272441
              ],
              [
                46.2718554,
                33.6215807
              ],
              [
                46.279279,
                33.614097
              ],
              [
                46.2838342,
                33.6099522
              ],
              [
                46.3013647,
                33.597606
              ],
              [
                46.3265886,
                33.5724153
              ],
              [
                46.3293684,
                33.5704653
              ],
              [
                46.3510353,
                33.551579
              ],
              [
                46.3518128,
                33.5511091
              ],
              [
                46.3518628,
                33.5510789
              ],
              [
                46.3629816,
                33.5443568
              ],
              [
                46.3802046,
                33.5313024
              ],
              [
                46.3843712,
                33.530192
              ],
              [
                46.3857579,
                33.530192
              ],
              [
                46.3863142,
                33.5299121
              ],
              [
                46.3902049,
                33.5290816
              ],
              [
                46.3921479,
                33.5285219
              ],
              [
                46.4004809,
                33.5265809
              ],
              [
                46.411871,
                33.5182481
              ],
              [
                46.411871,
                33.5176883
              ],
              [
                46.4174274,
                33.5101861
              ],
              [
                46.4177039,
                33.5101861
              ],
              [
                46.418261,
                33.5099153
              ],
              [
                46.4299276,
                33.5126959
              ],
              [
                46.4332605,
                33.5129668
              ],
              [
                46.4338175,
                33.5132466
              ],
              [
                46.4343738,
                33.5129668
              ],
              [
                46.4371505,
                33.5121362
              ],
              [
                46.446874,
                33.5068548
              ],
              [
                46.4493742,
                33.506584
              ],
              [
                46.4518742,
                33.5054646
              ],
              [
                46.4568735,
                33.5043631
              ],
              [
                46.4585408,
                33.5043632
              ],
              [
                46.4768732,
                33.5007429
              ],
              [
                46.4843765,
                33.4996416
              ],
              [
                46.4863202,
                33.4996416
              ],
              [
                46.4865968,
                33.4993527
              ],
              [
                46.4879866,
                33.4990819
              ],
              [
                46.4902102,
                33.4990818
              ],
              [
                46.4907632,
                33.498802
              ],
              [
                46.4943943,
                33.4985909
              ],
              [
                46.4952101,
                33.4985221
              ],
              [
                46.4996532,
                33.4974117
              ],
              [
                46.5035433,
                33.4954707
              ],
              [
                46.5038198,
                33.4951908
              ],
              [
                46.5082668,
                33.4938004
              ],
              [
                46.5382659,
                33.4732436
              ],
              [
                46.5557663,
                33.4596383
              ],
              [
                46.5596561,
                33.4607487
              ],
              [
                46.5621563,
                33.4610196
              ],
              [
                46.5627125,
                33.4607488
              ],
              [
                46.5638226,
                33.4607487
              ],
              [
                46.569379,
                33.4585278
              ],
              [
                46.5785457,
                33.4526866
              ],
              [
                46.5802121,
                33.4521359
              ],
              [
                46.5807691,
                33.4515852
              ],
              [
                46.5891022,
                33.4488046
              ],
              [
                46.5924357,
                33.447974
              ],
              [
                46.6270433,
                33.4388846
              ],
              [
                46.6421618,
                33.4349103
              ],
              [
                46.6568848,
                33.4315789
              ],
              [
                46.6585512,
                33.431579
              ],
              [
                46.6654943,
                33.4296378
              ],
              [
                46.6691046,
                33.4301886
              ],
              [
                46.6729945,
                33.4301887
              ],
              [
                46.6732749,
                33.4304685
              ],
              [
                46.6760516,
                33.4304685
              ],
              [
                46.677718,
                33.4304685
              ],
              [
                46.6782743,
                33.4304685
              ],
              [
                46.6793844,
                33.4301886
              ],
              [
                46.7029975,
                33.4229661
              ],
              [
                46.733277,
                33.4113017
              ],
              [
                46.7580003,
                33.4012984
              ],
              [
                46.7677239,
                33.3987976
              ],
              [
                46.7682769,
                33.3982469
              ],
              [
                46.7891134,
                33.3896339
              ],
              [
                46.8041128,
                33.3843524
              ],
              [
                46.8188359,
                33.3729676
              ],
              [
                46.8357792,
                33.3615829
              ],
              [
                46.8357792,
                33.361303
              ],
              [
                46.8374456,
                33.3604634
              ],
              [
                46.8488357,
                33.3688056
              ],
              [
                46.8499491,
                33.3699071
              ],
              [
                46.8538358,
                33.3740782
              ],
              [
                46.8543921,
                33.3751887
              ],
              [
                46.8552256,
                33.3782494
              ],
              [
                46.8563357,
                33.3943559
              ],
              [
                46.8560592,
                33.3946358
              ],
              [
                46.8510591,
                33.402689
              ],
              [
                46.8507826,
                33.4032488
              ],
              [
                46.8380026,
                33.4093609
              ],
              [
                46.8157794,
                33.4246367
              ],
              [
                46.8141129,
                33.4260269
              ],
              [
                46.8105027,
                33.4296382
              ],
              [
                46.8007798,
                33.4393617
              ],
              [
                46.7999462,
                33.4404721
              ],
              [
                46.7938328,
                33.4557478
              ],
              [
                46.7932796,
                33.4565783
              ],
              [
                46.7910562,
                33.4657509
              ],
              [
                46.7910561,
                33.4682427
              ],
              [
                46.7907796,
                33.4688025
              ],
              [
                46.7913327,
                33.4713032
              ],
              [
                46.8024461,
                33.4860281
              ],
              [
                46.8041125,
                33.488249
              ],
              [
                46.8041125,
                33.4888087
              ],
              [
                46.8043891,
                33.4893594
              ],
              [
                46.8035563,
                33.4896394
              ],
              [
                46.799946,
                33.4910296
              ],
              [
                46.7646663,
                33.5093565
              ],
              [
                46.7628101,
                33.5105497
              ],
              [
                46.7601837,
                33.5114729
              ],
              [
                46.7573513,
                33.5117305
              ],
              [
                46.7537979,
                33.5111079
              ],
              [
                46.7512488,
                33.5100345
              ],
              [
                46.7488404,
                33.508657
              ],
              [
                46.7458929,
                33.5055043
              ],
              [
                46.7434725,
                33.5040228
              ],
              [
                46.7404971,
                33.5026937
              ],
              [
                46.7371634,
                33.5018632
              ],
              [
                46.7360533,
                33.5018632
              ],
              [
                46.7352205,
                33.5015833
              ],
              [
                46.7335142,
                33.5015833
              ],
              [
                46.7318868,
                33.5015833
              ],
              [
                46.7316103,
                33.5013034
              ],
              [
                46.7296633,
                33.5013034
              ],
              [
                46.729107,
                33.5015833
              ],
              [
                46.7204968,
                33.5015832
              ],
              [
                46.7193873,
                33.5018631
              ],
              [
                46.7104973,
                33.5026936
              ],
              [
                46.7038308,
                33.5026936
              ],
              [
                46.7035503,
                33.5029735
              ],
              [
                46.6849405,
                33.5057541
              ],
              [
                46.6782741,
                33.507966
              ],
              [
                46.6757739,
                33.5088055
              ],
              [
                46.6632713,
                33.5151973
              ],
              [
                46.6627174,
                33.5154682
              ],
              [
                46.6621611,
                33.515748
              ],
              [
                46.6543845,
                33.5201897
              ],
              [
                46.6357715,
                33.537695
              ],
              [
                46.6349379,
                33.5390762
              ],
              [
                46.6318815,
                33.5424166
              ],
              [
                46.6185484,
                33.5576917
              ],
              [
                46.6163248,
                33.5613028
              ],
              [
                46.6049348,
                33.5749168
              ],
              [
                46.593268,
                33.5913023
              ],
              [
                46.5685456,
                33.6151986
              ],
              [
                46.5666018,
                33.6174194
              ],
              [
                46.5365988,
                33.6401961
              ],
              [
                46.5363222,
                33.6401961
              ],
              [
                46.5357651,
                33.6404759
              ],
              [
                46.5327089,
                33.6404759
              ],
              [
                46.5321557,
                33.6401961
              ],
              [
                46.5315987,
                33.6401961
              ],
              [
                46.5307658,
                33.6399162
              ],
              [
                46.5288221,
                33.6399163
              ],
              [
                46.5238227,
                33.6368648
              ],
              [
                46.5213187,
                33.6346441
              ],
              [
                46.5177094,
                33.6351947
              ],
              [
                46.5154859,
                33.6357545
              ],
              [
                46.4996527,
                33.6463076
              ],
              [
                46.4940964,
                33.6474181
              ],
              [
                46.4890962,
                33.6496388
              ],
              [
                46.4888197,
                33.6499187
              ],
              [
                46.4882627,
                33.6499187
              ],
              [
                46.4846532,
                33.6510291
              ],
              [
                46.4840961,
                33.6510291
              ],
              [
                46.4838196,
                33.651309
              ],
              [
                46.482986,
                33.6513089
              ],
              [
                46.4824296,
                33.6515888
              ],
              [
                46.4813195,
                33.6518596
              ],
              [
                46.4768725,
                33.65297
              ],
              [
                46.4720419,
                33.6582876
              ],
              [
                46.4631385,
                33.6616835
              ],
              [
                46.4557772,
                33.6647674
              ],
              [
                46.4467191,
                33.670025
              ],
              [
                46.4406339,
                33.6733055
              ],
              [
                46.4372246,
                33.6749872
              ],
              [
                46.4313117,
                33.67799
              ],
              [
                46.4266332,
                33.6782281
              ],
              [
                46.4212141,
                33.6803707
              ],
              [
                46.4141338,
                33.6824835
              ],
              [
                46.4094205,
                33.6835906
              ],
              [
                46.4026847,
                33.683623
              ],
              [
                46.3949004,
                33.6851586
              ],
              [
                46.3919401,
                33.6854144
              ],
              [
                46.3871591,
                33.6834503
              ],
              [
                46.3818844,
                33.6768139
              ],
              [
                46.3790399,
                33.6747957
              ],
              [
                46.3726321,
                33.67151
              ],
              [
                46.3703543,
                33.6702801
              ],
              [
                46.365923,
                33.6659909
              ],
              [
                46.36288,
                33.6615976
              ],
              [
                46.3599112,
                33.6573517
              ],
              [
                46.3570013,
                33.6545597
              ],
              [
                46.3528803,
                33.6473767
              ],
              [
                46.3448579,
                33.6417736
              ],
              [
                46.3420922,
                33.6402671
              ],
              [
                46.3399481,
                33.6408386
              ],
              [
                46.3376283,
                33.6449207
              ],
              [
                46.3359132,
                33.6488019
              ],
              [
                46.3342904,
                33.652788
              ],
              [
                46.3266752,
                33.6509454
              ],
              [
                46.3190182,
                33.6489091
              ],
              [
                46.3139676,
                33.648424
              ],
              [
                46.3087334,
                33.6468897
              ],
              [
                46.2972667,
                33.6434513
              ],
              [
                46.271324,
                33.6466357
              ],
              [
                46.2280653,
                33.6349168
              ],
              [
                46.1863516,
                33.6203375
              ],
              [
                46.152706,
                33.6119032
              ],
              [
                46.1300467,
                33.6070424
              ],
              [
                46.1021439,
                33.5971677
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554915,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بدره",
          "name:en": "Badreh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q26878146",
          "wikipedia": "en:Badreh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.8043891,
                33.4893594
              ],
              [
                46.8041125,
                33.4888087
              ],
              [
                46.8041125,
                33.488249
              ],
              [
                46.8024461,
                33.4860281
              ],
              [
                46.7913327,
                33.4713032
              ],
              [
                46.7907796,
                33.4688025
              ],
              [
                46.7910561,
                33.4682427
              ],
              [
                46.7910562,
                33.4657509
              ],
              [
                46.7932796,
                33.4565783
              ],
              [
                46.7938328,
                33.4557478
              ],
              [
                46.7999462,
                33.4404721
              ],
              [
                46.8007798,
                33.4393617
              ],
              [
                46.8105027,
                33.4296382
              ],
              [
                46.8141129,
                33.4260269
              ],
              [
                46.8157794,
                33.4246367
              ],
              [
                46.8380026,
                33.4093609
              ],
              [
                46.8507826,
                33.4032488
              ],
              [
                46.8510591,
                33.402689
              ],
              [
                46.8560592,
                33.3946358
              ],
              [
                46.8563357,
                33.3943559
              ],
              [
                46.8552256,
                33.3782494
              ],
              [
                46.8543921,
                33.3751887
              ],
              [
                46.8538358,
                33.3740782
              ],
              [
                46.8499491,
                33.3699071
              ],
              [
                46.8488357,
                33.3688056
              ],
              [
                46.8374456,
                33.3604634
              ],
              [
                46.8377261,
                33.3601835
              ],
              [
                46.8777254,
                33.3313016
              ],
              [
                46.8821725,
                33.3265797
              ],
              [
                46.8832819,
                33.32602
              ],
              [
                46.8880054,
                33.3196368
              ],
              [
                46.8880055,
                33.319357
              ],
              [
                46.888282,
                33.3190771
              ],
              [
                46.8885625,
                33.3185264
              ],
              [
                46.8893954,
                33.3176867
              ],
              [
                46.8896719,
                33.3168561
              ],
              [
                46.89146,
                33.3142402
              ],
              [
                46.8932821,
                33.3115744
              ],
              [
                46.897172,
                33.3065816
              ],
              [
                46.9102286,
                33.2949078
              ],
              [
                46.922175,
                33.2838026
              ],
              [
                46.953285,
                33.2618542
              ],
              [
                46.995346,
                33.241901
              ],
              [
                47.0052951,
                33.2382278
              ],
              [
                47.0156429,
                33.2341308
              ],
              [
                47.0185268,
                33.2331831
              ],
              [
                47.0217969,
                33.232257
              ],
              [
                47.0290582,
                33.2313955
              ],
              [
                47.0300109,
                33.2309216
              ],
              [
                47.0365512,
                33.2285093
              ],
              [
                47.0509193,
                33.223749
              ],
              [
                47.0524567,
                33.2235188
              ],
              [
                47.0524567,
                33.2232389
              ],
              [
                47.0580139,
                33.220738
              ],
              [
                47.0602373,
                33.2201872
              ],
              [
                47.0619038,
                33.2193566
              ],
              [
                47.0666234,
                33.2179661
              ],
              [
                47.0752368,
                33.2140748
              ],
              [
                47.0794033,
                33.2126843
              ],
              [
                47.0807933,
                33.2118537
              ],
              [
                47.0952366,
                33.206292
              ],
              [
                47.0971834,
                33.2060213
              ],
              [
                47.1095542,
                33.2014894
              ],
              [
                47.1335725,
                33.1926859
              ],
              [
                47.1341295,
                33.192406
              ],
              [
                47.1344061,
                33.1921351
              ],
              [
                47.1349632,
                33.1921351
              ],
              [
                47.1352397,
                33.1918552
              ],
              [
                47.1352397,
                33.1915753
              ],
              [
                47.1349632,
                33.1907447
              ],
              [
                47.135796,
                33.1907447
              ],
              [
                47.135796,
                33.1904648
              ],
              [
                47.1363491,
                33.1904647
              ],
              [
                47.1363491,
                33.1901849
              ],
              [
                47.1935754,
                33.1557402
              ],
              [
                47.1980184,
                33.1521286
              ],
              [
                47.1991317,
                33.151018
              ],
              [
                47.2057991,
                33.146296
              ],
              [
                47.205799,
                33.1460251
              ],
              [
                47.2060756,
                33.1457362
              ],
              [
                47.2077421,
                33.1440749
              ],
              [
                47.2083005,
                33.1437564
              ],
              [
                47.2116319,
                33.1712968
              ],
              [
                47.2121881,
                33.17824
              ],
              [
                47.2146881,
                33.197688
              ],
              [
                47.2155217,
                33.2004688
              ],
              [
                47.2199647,
                33.2110235
              ],
              [
                47.2444113,
                33.2332432
              ],
              [
                47.2458011,
                33.2357441
              ],
              [
                47.2480215,
                33.245468
              ],
              [
                47.2474675,
                33.2460187
              ],
              [
                47.2463542,
                33.2451881
              ],
              [
                47.2463542,
                33.2443575
              ],
              [
                47.2455214,
                33.2440776
              ],
              [
                47.2427447,
                33.2440776
              ],
              [
                47.2396877,
                33.2446283
              ],
              [
                47.2324649,
                33.2479689
              ],
              [
                47.2319109,
                33.2487995
              ],
              [
                47.2305211,
                33.2504608
              ],
              [
                47.230521,
                33.2513004
              ],
              [
                47.2302445,
                33.2515714
              ],
              [
                47.2330212,
                33.2599137
              ],
              [
                47.2327445,
                33.2601847
              ],
              [
                47.2324648,
                33.2629654
              ],
              [
                47.2288546,
                33.2682472
              ],
              [
                47.2288546,
                33.2687979
              ],
              [
                47.2282983,
                33.2690778
              ],
              [
                47.2282983,
                33.2696285
              ],
              [
                47.2252443,
                33.27324
              ],
              [
                47.222188,
                33.2746304
              ],
              [
                47.2196879,
                33.2751902
              ],
              [
                47.2177411,
                33.2751901
              ],
              [
                47.2174645,
                33.2754701
              ],
              [
                47.2141316,
                33.2751901
              ],
              [
                47.213855,
                33.2749103
              ],
              [
                47.2121878,
                33.2749103
              ],
              [
                47.2116316,
                33.2746303
              ],
              [
                47.2044079,
                33.2746303
              ],
              [
                47.2013548,
                33.2757408
              ],
              [
                47.1955179,
                33.2826838
              ],
              [
                47.2007985,
                33.2907463
              ],
              [
                47.2030219,
                33.2932473
              ],
              [
                47.2038548,
                33.2943577
              ],
              [
                47.2044079,
                33.29852
              ],
              [
                47.2041313,
                33.2990797
              ],
              [
                47.2019079,
                33.3024113
              ],
              [
                47.201075,
                33.3024112
              ],
              [
                47.2007984,
                33.3026911
              ],
              [
                47.1996851,
                33.3026911
              ],
              [
                47.1991312,
                33.3024113
              ],
              [
                47.1977413,
                33.3024112
              ],
              [
                47.1910748,
                33.2990796
              ],
              [
                47.1894084,
                33.2990796
              ],
              [
                47.1891318,
                33.2987997
              ],
              [
                47.1880185,
                33.2987998
              ],
              [
                47.1805183,
                33.3015716
              ],
              [
                47.1795837,
                33.3062327
              ],
              [
                47.177808,
                33.3084196
              ],
              [
                47.1760399,
                33.313121
              ],
              [
                47.1742718,
                33.3160089
              ],
              [
                47.1708965,
                33.3193668
              ],
              [
                47.1659137,
                33.3219186
              ],
              [
                47.1628598,
                33.3248062
              ],
              [
                47.1575556,
                33.3287681
              ],
              [
                47.1539391,
                33.3324612
              ],
              [
                47.150403,
                33.3352813
              ],
              [
                47.1469473,
                33.3376313
              ],
              [
                47.1440318,
                33.3394405
              ],
              [
                47.1417815,
                33.3397762
              ],
              [
                47.1376828,
                33.3403133
              ],
              [
                47.1347093,
                33.3403804
              ],
              [
                47.1318965,
                33.3403804
              ],
              [
                47.1295658,
                33.340649
              ],
              [
                47.1272352,
                33.3403804
              ],
              [
                47.1254671,
                33.3395076
              ],
              [
                47.1240205,
                33.3378962
              ],
              [
                47.1232972,
                33.3364191
              ],
              [
                47.1206452,
                33.3356134
              ],
              [
                47.1173501,
                33.3351434
              ],
              [
                47.1125281,
                33.3338005
              ],
              [
                47.1111183,
                33.3337774
              ],
              [
                47.1084295,
                33.3337333
              ],
              [
                47.1054559,
                33.3349419
              ],
              [
                47.1034467,
                33.3364191
              ],
              [
                47.1022412,
                33.3378962
              ],
              [
                47.1019198,
                33.3399776
              ],
              [
                47.1013572,
                33.3417232
              ],
              [
                47.1023216,
                33.3437373
              ],
              [
                47.1038486,
                33.3458186
              ],
              [
                47.1050541,
                33.3472284
              ],
              [
                47.1056166,
                33.3489739
              ],
              [
                47.1038486,
                33.3496452
              ],
              [
                47.1017813,
                33.349842
              ],
              [
                47.0988494,
                33.3494569
              ],
              [
                47.097012,
                33.3500698
              ],
              [
                47.0947672,
                33.3506522
              ],
              [
                47.0931598,
                33.3511221
              ],
              [
                47.0905881,
                33.3523976
              ],
              [
                47.0885789,
                33.3526661
              ],
              [
                47.0876094,
                33.3524296
              ],
              [
                47.0860876,
                33.3517934
              ],
              [
                47.0845606,
                33.3519948
              ],
              [
                47.0808638,
                33.3521291
              ],
              [
                47.0786135,
                33.3524647
              ],
              [
                47.0767651,
                33.3540758
              ],
              [
                47.0778075,
                33.3560575
              ],
              [
                47.0761198,
                33.3583398
              ],
              [
                47.0739499,
                33.3597494
              ],
              [
                47.0712174,
                33.3598837
              ],
              [
                47.0675206,
                33.3599508
              ],
              [
                47.0613324,
                33.360622
              ],
              [
                47.0586803,
                33.3618974
              ],
              [
                47.0565907,
                33.3650521
              ],
              [
                47.0558674,
                33.3686094
              ],
              [
                47.0542601,
                33.3713612
              ],
              [
                47.0505632,
                33.3728378
              ],
              [
                47.0462235,
                33.3737774
              ],
              [
                47.0430088,
                33.3747841
              ],
              [
                47.0397941,
                33.377133
              ],
              [
                47.033847,
                33.3782739
              ],
              [
                47.0310342,
                33.3799516
              ],
              [
                47.0307931,
                33.383911
              ],
              [
                47.0297112,
                33.385074
              ],
              [
                47.0268698,
                33.3861653
              ],
              [
                47.0250514,
                33.3873041
              ],
              [
                47.0224373,
                33.3877311
              ],
              [
                47.0204483,
                33.3865924
              ],
              [
                47.0167927,
                33.3855445
              ],
              [
                47.0166409,
                33.385501
              ],
              [
                47.0136858,
                33.3853587
              ],
              [
                47.0130223,
                33.3847253
              ],
              [
                47.0111683,
                33.3826613
              ],
              [
                47.0102671,
                33.3814787
              ],
              [
                47.0077694,
                33.3804466
              ],
              [
                47.0063532,
                33.3803176
              ],
              [
                47.0033406,
                33.3805541
              ],
              [
                46.9961823,
                33.3818872
              ],
              [
                46.98923,
                33.3841663
              ],
              [
                46.9833077,
                33.3882083
              ],
              [
                46.9812735,
                33.3904443
              ],
              [
                46.972174,
                33.3985273
              ],
              [
                46.9363411,
                33.4274177
              ],
              [
                46.9021717,
                33.4463046
              ],
              [
                46.9016185,
                33.4465845
              ],
              [
                46.8168893,
                33.484078
              ],
              [
                46.8160557,
                33.4840781
              ],
              [
                46.8127229,
                33.4854684
              ],
              [
                46.8124463,
                33.4857483
              ],
              [
                46.8068891,
                33.4885199
              ],
              [
                46.8068891,
                33.4888087
              ],
              [
                46.8063359,
                33.4888087
              ],
              [
                46.8043891,
                33.4893594
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555093,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سیروان",
          "name:en": "Sirvan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q6501364",
          "wikipedia": "en:Sirvan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.4135091,
                33.7921803
              ],
              [
                46.4179658,
                33.7885639
              ],
              [
                46.4177084,
                33.7862812
              ],
              [
                46.4177513,
                33.7846405
              ],
              [
                46.4179229,
                33.7803245
              ],
              [
                46.4180088,
                33.7760083
              ],
              [
                46.4184379,
                33.7714065
              ],
              [
                46.4185237,
                33.76288
              ],
              [
                46.4186954,
                33.7591338
              ],
              [
                46.4188671,
                33.750499
              ],
              [
                46.4190387,
                33.7466809
              ],
              [
                46.4200258,
                33.7392226
              ],
              [
                46.4201545,
                33.7345117
              ],
              [
                46.4210987,
                33.7336909
              ],
              [
                46.4248752,
                33.7314067
              ],
              [
                46.4289522,
                33.7292653
              ],
              [
                46.430483,
                33.7296401
              ],
              [
                46.4316129,
                33.727909
              ],
              [
                46.4358615,
                33.7265884
              ],
              [
                46.4397239,
                33.7254462
              ],
              [
                46.4431142,
                33.7244468
              ],
              [
                46.4450614,
                33.7218607
              ],
              [
                46.4465967,
                33.7185275
              ],
              [
                46.4470195,
                33.7139166
              ],
              [
                46.4461612,
                33.7079548
              ],
              [
                46.4464551,
                33.7052025
              ],
              [
                46.4504462,
                33.7015814
              ],
              [
                46.4527719,
                33.6996109
              ],
              [
                46.4558419,
                33.6953434
              ],
              [
                46.45794,
                33.6920023
              ],
              [
                46.4528277,
                33.689421
              ],
              [
                46.4470581,
                33.6857845
              ],
              [
                46.4382765,
                33.6805625
              ],
              [
                46.4342235,
                33.6786697
              ],
              [
                46.4313117,
                33.67799
              ],
              [
                46.4372246,
                33.6749872
              ],
              [
                46.4406339,
                33.6733055
              ],
              [
                46.4467191,
                33.670025
              ],
              [
                46.4557772,
                33.6647674
              ],
              [
                46.4631385,
                33.6616835
              ],
              [
                46.4720419,
                33.6582876
              ],
              [
                46.4768725,
                33.65297
              ],
              [
                46.4813195,
                33.6518596
              ],
              [
                46.4824296,
                33.6515888
              ],
              [
                46.482986,
                33.6513089
              ],
              [
                46.4838196,
                33.651309
              ],
              [
                46.4840961,
                33.6510291
              ],
              [
                46.4846532,
                33.6510291
              ],
              [
                46.4882627,
                33.6499187
              ],
              [
                46.4888197,
                33.6499187
              ],
              [
                46.4890962,
                33.6496388
              ],
              [
                46.4940964,
                33.6474181
              ],
              [
                46.4996527,
                33.6463076
              ],
              [
                46.5154859,
                33.6357545
              ],
              [
                46.5177094,
                33.6351947
              ],
              [
                46.5213187,
                33.6346441
              ],
              [
                46.5238227,
                33.6368648
              ],
              [
                46.5288221,
                33.6399163
              ],
              [
                46.5307658,
                33.6399162
              ],
              [
                46.5315987,
                33.6401961
              ],
              [
                46.5321557,
                33.6401961
              ],
              [
                46.5327089,
                33.6404759
              ],
              [
                46.5357651,
                33.6404759
              ],
              [
                46.5363222,
                33.6401961
              ],
              [
                46.5365988,
                33.6401961
              ],
              [
                46.5666018,
                33.6174194
              ],
              [
                46.5685456,
                33.6151986
              ],
              [
                46.593268,
                33.5913023
              ],
              [
                46.6049348,
                33.5749168
              ],
              [
                46.6163248,
                33.5613028
              ],
              [
                46.6185484,
                33.5576917
              ],
              [
                46.6318815,
                33.5424166
              ],
              [
                46.6349379,
                33.5390762
              ],
              [
                46.6357715,
                33.537695
              ],
              [
                46.6543845,
                33.5201897
              ],
              [
                46.6621611,
                33.515748
              ],
              [
                46.6627174,
                33.5154682
              ],
              [
                46.6632713,
                33.5151973
              ],
              [
                46.6757739,
                33.5088055
              ],
              [
                46.6782741,
                33.507966
              ],
              [
                46.6849405,
                33.5057541
              ],
              [
                46.7035503,
                33.5029735
              ],
              [
                46.7038308,
                33.5026936
              ],
              [
                46.7104973,
                33.5026936
              ],
              [
                46.7193873,
                33.5018631
              ],
              [
                46.7204968,
                33.5015832
              ],
              [
                46.729107,
                33.5015833
              ],
              [
                46.7296633,
                33.5013034
              ],
              [
                46.7316103,
                33.5013034
              ],
              [
                46.7318868,
                33.5015833
              ],
              [
                46.7335142,
                33.5015833
              ],
              [
                46.7352205,
                33.5015833
              ],
              [
                46.7360533,
                33.5018632
              ],
              [
                46.7371634,
                33.5018632
              ],
              [
                46.7404971,
                33.5026937
              ],
              [
                46.7434725,
                33.5040228
              ],
              [
                46.7458929,
                33.5055043
              ],
              [
                46.7488404,
                33.508657
              ],
              [
                46.7512488,
                33.5100345
              ],
              [
                46.7537979,
                33.5111079
              ],
              [
                46.7573513,
                33.5117305
              ],
              [
                46.7601837,
                33.5114729
              ],
              [
                46.7628101,
                33.5105497
              ],
              [
                46.7646663,
                33.5093565
              ],
              [
                46.799946,
                33.4910296
              ],
              [
                46.8035563,
                33.4896394
              ],
              [
                46.8043891,
                33.4893594
              ],
              [
                46.8063359,
                33.4888087
              ],
              [
                46.8068891,
                33.4888087
              ],
              [
                46.8068891,
                33.4885199
              ],
              [
                46.8124463,
                33.4857483
              ],
              [
                46.8127229,
                33.4854684
              ],
              [
                46.8160557,
                33.4840781
              ],
              [
                46.8168893,
                33.484078
              ],
              [
                46.9016185,
                33.4465845
              ],
              [
                46.9021717,
                33.4463046
              ],
              [
                46.9363411,
                33.4274177
              ],
              [
                46.972174,
                33.3985273
              ],
              [
                46.9812735,
                33.3904443
              ],
              [
                46.9833077,
                33.3882083
              ],
              [
                46.98923,
                33.3841663
              ],
              [
                46.9961823,
                33.3818872
              ],
              [
                47.0033406,
                33.3805541
              ],
              [
                47.0063532,
                33.3803176
              ],
              [
                47.0077694,
                33.3804466
              ],
              [
                47.0102671,
                33.3814787
              ],
              [
                47.0111683,
                33.3826613
              ],
              [
                47.0130223,
                33.3847253
              ],
              [
                47.0136858,
                33.3853587
              ],
              [
                47.0110718,
                33.3857383
              ],
              [
                47.0088555,
                33.3869245
              ],
              [
                47.0074348,
                33.3884429
              ],
              [
                47.0073211,
                33.3911474
              ],
              [
                47.0064119,
                33.3929978
              ],
              [
                47.0062414,
                33.3952752
              ],
              [
                47.0062414,
                33.3973628
              ],
              [
                47.0064687,
                33.3994503
              ],
              [
                47.007378,
                33.4010633
              ],
              [
                47.0088555,
                33.4028661
              ],
              [
                47.0114696,
                33.4047163
              ],
              [
                47.0148224,
                33.4055702
              ],
              [
                47.0181752,
                33.406851
              ],
              [
                47.021528,
                33.4079421
              ],
              [
                47.0221377,
                33.4096712
              ],
              [
                47.0228764,
                33.4116161
              ],
              [
                47.0228764,
                33.4137507
              ],
              [
                47.0228764,
                33.4155532
              ],
              [
                47.0231606,
                33.4171185
              ],
              [
                47.0237857,
                33.4188735
              ],
              [
                47.0239562,
                33.4198221
              ],
              [
                47.0254337,
                33.4198696
              ],
              [
                47.0261156,
                33.420249
              ],
              [
                47.0257747,
                33.4213874
              ],
              [
                47.0245245,
                33.4219565
              ],
              [
                47.0234447,
                33.4229526
              ],
              [
                47.0204329,
                33.423332
              ],
              [
                47.0180461,
                33.4237114
              ],
              [
                47.0147501,
                33.4245177
              ],
              [
                47.0139545,
                33.4258457
              ],
              [
                47.014466,
                33.4281697
              ],
              [
                47.0149206,
                33.4299245
              ],
              [
                47.0145796,
                33.4319638
              ],
              [
                47.0128748,
                33.4340979
              ],
              [
                47.0112268,
                33.4361845
              ],
              [
                47.0100902,
                33.4374649
              ],
              [
                47.0074193,
                33.438034
              ],
              [
                47.0043506,
                33.4376072
              ],
              [
                47.0012251,
                33.4372278
              ],
              [
                46.9984406,
                33.4367061
              ],
              [
                46.9960538,
                33.4360897
              ],
              [
                46.9937239,
                33.4363742
              ],
              [
                46.9926441,
                33.4376072
              ],
              [
                46.9913939,
                33.4396463
              ],
              [
                46.9913939,
                33.4416854
              ],
              [
                46.992019,
                33.4431554
              ],
              [
                46.9930419,
                33.4446253
              ],
              [
                46.9946899,
                33.4458582
              ],
              [
                46.9944058,
                33.4469488
              ],
              [
                46.9924168,
                33.4478971
              ],
              [
                46.991053,
                33.4468539
              ],
              [
                46.9901437,
                33.4455737
              ],
              [
                46.9901437,
                33.444246
              ],
              [
                46.9891776,
                33.4441511
              ],
              [
                46.9867909,
                33.4445305
              ],
              [
                46.9845746,
                33.4460953
              ],
              [
                46.982813,
                33.4463798
              ],
              [
                46.9802557,
                33.4456685
              ],
              [
                46.9778689,
                33.4469014
              ],
              [
                46.9756527,
                33.4485609
              ],
              [
                46.9734364,
                33.4505998
              ],
              [
                46.970254,
                33.4511214
              ],
              [
                46.9679809,
                33.4524015
              ],
              [
                46.9664299,
                33.453804
              ],
              [
                46.9648955,
                33.4546574
              ],
              [
                46.9640431,
                33.4557953
              ],
              [
                46.9640999,
                33.4573599
              ],
              [
                46.9651796,
                33.45864
              ],
              [
                46.9648387,
                33.4598252
              ],
              [
                46.9638726,
                33.4604889
              ],
              [
                46.9626224,
                33.4621009
              ],
              [
                46.9606334,
                33.4627172
              ],
              [
                46.9588718,
                33.4627646
              ],
              [
                46.9573943,
                33.4634283
              ],
              [
                46.9554621,
                33.4635705
              ],
              [
                46.9544392,
                33.4629068
              ],
              [
                46.9529049,
                33.4621009
              ],
              [
                46.9505749,
                33.4619586
              ],
              [
                46.9478472,
                33.4636179
              ],
              [
                46.9454036,
                33.4652772
              ],
              [
                46.9431873,
                33.4669364
              ],
              [
                46.9410279,
                33.4674578
              ],
              [
                46.9384138,
                33.4674578
              ],
              [
                46.9351178,
                33.4692592
              ],
              [
                46.9317275,
                33.4715915
              ],
              [
                46.9319548,
                33.4725395
              ],
              [
                46.9317275,
                33.4739142
              ],
              [
                46.9308182,
                33.4753836
              ],
              [
                46.9298522,
                33.4767109
              ],
              [
                46.9287725,
                33.4778485
              ],
              [
                46.9267835,
                33.4780381
              ],
              [
                46.9249082,
                33.4774219
              ],
              [
                46.9230329,
                33.4771375
              ],
              [
                46.9210439,
                33.4770901
              ],
              [
                46.9186571,
                33.4774219
              ],
              [
                46.9168386,
                33.4782277
              ],
              [
                46.9160431,
                33.4796023
              ],
              [
                46.9151338,
                33.480882
              ],
              [
                46.9139404,
                33.482304
              ],
              [
                46.9132017,
                33.4837259
              ],
              [
                46.9120083,
                33.4852425
              ],
              [
                46.9104739,
                33.4859061
              ],
              [
                46.9083145,
                33.4864274
              ],
              [
                46.906496,
                33.4876597
              ],
              [
                46.9054731,
                33.4896503
              ],
              [
                46.9052458,
                33.4917355
              ],
              [
                46.9062687,
                33.4936312
              ],
              [
                46.9072916,
                33.4953847
              ],
              [
                46.9076326,
                33.4971381
              ],
              [
                46.9068938,
                33.4980385
              ],
              [
                46.9054163,
                33.4985598
              ],
              [
                46.9041092,
                33.4979437
              ],
              [
                46.9025181,
                33.4975172
              ],
              [
                46.9009269,
                33.4978489
              ],
              [
                46.8984833,
                33.4985124
              ],
              [
                46.8967217,
                33.4985124
              ],
              [
                46.8948463,
                33.4979911
              ],
              [
                46.8930279,
                33.4980385
              ],
              [
                46.8911525,
                33.4980859
              ],
              [
                46.8905843,
                33.4994127
              ],
              [
                46.891664,
                33.5012135
              ],
              [
                46.8908116,
                33.5026825
              ],
              [
                46.8907547,
                33.5048622
              ],
              [
                46.8902141,
                33.5058985
              ],
              [
                46.888888,
                33.505999
              ],
              [
                46.8867985,
                33.5074062
              ],
              [
                46.8855126,
                33.5083779
              ],
              [
                46.8843473,
                33.5092155
              ],
              [
                46.8829811,
                33.5100866
              ],
              [
                46.8817354,
                33.5112593
              ],
              [
                46.8798066,
                33.5120299
              ],
              [
                46.8779984,
                33.5121974
              ],
              [
                46.8764714,
                33.513169
              ],
              [
                46.8744623,
                33.5144086
              ],
              [
                46.8733773,
                33.5159832
              ],
              [
                46.8728148,
                33.5175913
              ],
              [
                46.8714887,
                33.5183953
              ],
              [
                46.8703636,
                33.5194673
              ],
              [
                46.8689572,
                33.5202713
              ],
              [
                46.8671087,
                33.5199028
              ],
              [
                46.8655014,
                33.5188978
              ],
              [
                46.8631708,
                33.5181608
              ],
              [
                46.8628091,
                33.5168877
              ],
              [
                46.8629297,
                33.5163182
              ],
              [
                46.8612822,
                33.5164522
              ],
              [
                46.8598758,
                33.5177923
              ],
              [
                46.8597552,
                33.5191323
              ],
              [
                46.8599963,
                33.5207068
              ],
              [
                46.860358,
                33.5218793
              ],
              [
                46.8609205,
                33.5231188
              ],
              [
                46.8617242,
                33.5246598
              ],
              [
                46.8624475,
                33.5260667
              ],
              [
                46.862568,
                33.5276076
              ],
              [
                46.8619251,
                33.5288135
              ],
              [
                46.8609607,
                33.5304214
              ],
              [
                46.8595945,
                33.5312588
              ],
              [
                46.8587506,
                33.5325651
              ],
              [
                46.8579068,
                33.5342064
              ],
              [
                46.8565004,
                33.5353787
              ],
              [
                46.8554154,
                33.5370199
              ],
              [
                46.8549886,
                33.5375902
              ],
              [
                46.8541362,
                33.5381112
              ],
              [
                46.8528292,
                33.5383244
              ],
              [
                46.8518915,
                33.5377086
              ],
              [
                46.8509255,
                33.5379454
              ],
              [
                46.8493059,
                33.5381349
              ],
              [
                46.8489649,
                33.5394849
              ],
              [
                46.8489365,
                33.5404795
              ],
              [
                46.8490786,
                33.5415926
              ],
              [
                46.8488797,
                33.5427294
              ],
              [
                46.848766,
                33.5436293
              ],
              [
                46.8480841,
                33.5442924
              ],
              [
                46.8462088,
                33.5444582
              ],
              [
                46.8447597,
                33.5443871
              ],
              [
                46.8432253,
                33.5446476
              ],
              [
                46.841833,
                33.5456896
              ],
              [
                46.8407533,
                33.5466368
              ],
              [
                46.8400714,
                33.5476551
              ],
              [
                46.8395599,
                33.5489339
              ],
              [
                46.8392474,
                33.5504494
              ],
              [
                46.8386223,
                33.5514913
              ],
              [
                46.8385176,
                33.5519856
              ],
              [
                46.8383665,
                33.552699
              ],
              [
                46.8386223,
                33.5537646
              ],
              [
                46.8394747,
                33.5546407
              ],
              [
                46.8400714,
                33.5555168
              ],
              [
                46.8404692,
                33.5567954
              ],
              [
                46.8404976,
                33.5576479
              ],
              [
                46.8406002,
                33.5590221
              ],
              [
                46.8406854,
                33.5600876
              ],
              [
                46.8405149,
                33.5614609
              ],
              [
                46.8402308,
                33.5629999
              ],
              [
                46.8398046,
                33.5643494
              ],
              [
                46.8388669,
                33.5657227
              ],
              [
                46.8380429,
                33.5667881
              ],
              [
                46.8375315,
                33.5680665
              ],
              [
                46.8379861,
                33.569345
              ],
              [
                46.8390942,
                33.5708128
              ],
              [
                46.839492,
                33.5719729
              ],
              [
                46.8406286,
                33.5727304
              ],
              [
                46.8415846,
                33.5732736
              ],
              [
                46.8420668,
                33.5737423
              ],
              [
                46.8431919,
                33.5745123
              ],
              [
                46.8441965,
                33.5747467
              ],
              [
                46.8458038,
                33.5746463
              ],
              [
                46.847813,
                33.5750145
              ],
              [
                46.8494605,
                33.5756171
              ],
              [
                46.8515099,
                33.5756506
              ],
              [
                46.853961,
                33.5752489
              ],
              [
                46.8554076,
                33.5739767
              ],
              [
                46.8572159,
                33.5737423
              ],
              [
                46.8597072,
                33.5739432
              ],
              [
                46.8616762,
                33.5746463
              ],
              [
                46.8632434,
                33.5757845
              ],
              [
                46.86469,
                33.5768893
              ],
              [
                46.8549719,
                33.5811397
              ],
              [
                46.8387499,
                33.5872533
              ],
              [
                46.8309994,
                33.5899774
              ],
              [
                46.8032792,
                33.6029666
              ],
              [
                46.8021659,
                33.6038062
              ],
              [
                46.7996658,
                33.6046368
              ],
              [
                46.7991119,
                33.6051965
              ],
              [
                46.7954986,
                33.6063069
              ],
              [
                46.7835562,
                33.6118589
              ],
              [
                46.7829991,
                33.611859
              ],
              [
                46.7824421,
                33.6124186
              ],
              [
                46.7807756,
                33.6129693
              ],
              [
                46.780499,
                33.6132492
              ],
              [
                46.7796655,
                33.6132492
              ],
              [
                46.7599424,
                33.6243622
              ],
              [
                46.7595259,
                33.6246375
              ],
              [
                46.7591095,
                33.6249129
              ],
              [
                46.758833,
                33.6251928
              ],
              [
                46.756886,
                33.6263031
              ],
              [
                46.7560524,
                33.626583
              ],
              [
                46.7535524,
                33.6274136
              ],
              [
                46.7027169,
                33.6490888
              ],
              [
                46.7018833,
                33.6490887
              ],
              [
                46.7016067,
                33.6493596
              ],
              [
                46.6991067,
                33.6501991
              ],
              [
                46.698273,
                33.6504699
              ],
              [
                46.6974402,
                33.6507498
              ],
              [
                46.6941066,
                33.6507498
              ],
              [
                46.6941066,
                33.6510296
              ],
              [
                46.6927167,
                33.6510296
              ],
              [
                46.6838267,
                33.6540809
              ],
              [
                46.6832735,
                33.6546406
              ],
              [
                46.6807735,
                33.6554802
              ],
              [
                46.6779937,
                33.6568614
              ],
              [
                46.6185478,
                33.6896402
              ],
              [
                46.6117205,
                33.6938193
              ],
              [
                46.6049343,
                33.6979724
              ],
              [
                46.6046577,
                33.6982524
              ],
              [
                46.6046577,
                33.6985322
              ],
              [
                46.5963248,
                33.7029737
              ],
              [
                46.5941012,
                33.704084
              ],
              [
                46.567435,
                33.7265892
              ],
              [
                46.556598,
                33.7357519
              ],
              [
                46.5552113,
                33.7363116
              ],
              [
                46.5532651,
                33.7376927
              ],
              [
                46.5415985,
                33.7474241
              ],
              [
                46.5407648,
                33.7479748
              ],
              [
                46.5335419,
                33.7713101
              ],
              [
                46.513778,
                33.7985929
              ],
              [
                46.5100882,
                33.7990667
              ],
              [
                46.4996521,
                33.8001969
              ],
              [
                46.495209,
                33.8001968
              ],
              [
                46.4931935,
                33.8001996
              ],
              [
                46.4891866,
                33.8007598
              ],
              [
                46.4700433,
                33.7994199
              ],
              [
                46.4527362,
                33.7960318
              ],
              [
                46.4135091,
                33.7921803
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555213,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ملکشاهی",
          "name:en": "Malekshahi County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2413541",
          "wikipedia": "en:Malekshahi County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.2785333,
                33.3137938
              ],
              [
                46.2790903,
                33.313243
              ],
              [
                46.2813098,
                33.313243
              ],
              [
                46.2815903,
                33.3129631
              ],
              [
                46.2840904,
                33.3129632
              ],
              [
                46.2846435,
                33.3126833
              ],
              [
                46.2876998,
                33.3124124
              ],
              [
                46.3096463,
                33.3137938
              ],
              [
                46.3154801,
                33.3137938
              ],
              [
                46.3165895,
                33.3140737
              ],
              [
                46.3271459,
                33.3140737
              ],
              [
                46.3279795,
                33.3137938
              ],
              [
                46.3335359,
                33.3132431
              ],
              [
                46.336593,
                33.3132432
              ],
              [
                46.3374258,
                33.3129632
              ],
              [
                46.3390931,
                33.3129632
              ],
              [
                46.340479,
                33.3126834
              ],
              [
                46.3460361,
                33.3121327
              ],
              [
                46.3482596,
                33.3118528
              ],
              [
                46.3490924,
                33.3115729
              ],
              [
                46.3502026,
                33.3115729
              ],
              [
                46.353816,
                33.3104624
              ],
              [
                46.3549261,
                33.3104624
              ],
              [
                46.362149,
                33.3082414
              ],
              [
                46.3743727,
                33.2951862
              ],
              [
                46.3757587,
                33.2879633
              ],
              [
                46.3763157,
                33.2865729
              ],
              [
                46.3763158,
                33.2860222
              ],
              [
                46.3763158,
                33.2843519
              ],
              [
                46.3765923,
                33.281851
              ],
              [
                46.376872,
                33.2799098
              ],
              [
                46.3771494,
                33.2776888
              ],
              [
                46.377426,
                33.2760185
              ],
              [
                46.3785392,
                33.272687
              ],
              [
                46.3790925,
                33.2715765
              ],
              [
                46.3793721,
                33.2707368
              ],
              [
                46.3829824,
                33.2624125
              ],
              [
                46.383259,
                33.2612929
              ],
              [
                46.3835395,
                33.2604622
              ],
              [
                46.3838159,
                33.2590718
              ],
              [
                46.3840925,
                33.2582412
              ],
              [
                46.3843722,
                33.2574015
              ],
              [
                46.3846488,
                33.2565709
              ],
              [
                46.3852059,
                33.2546298
              ],
              [
                46.3854825,
                33.2543499
              ],
              [
                46.385759,
                33.2532394
              ],
              [
                46.3860388,
                33.2521288
              ],
              [
                46.3863153,
                33.2512982
              ],
              [
                46.3868723,
                33.2501877
              ],
              [
                46.3871489,
                33.2499078
              ],
              [
                46.3871489,
                33.2496279
              ],
              [
                46.3874254,
                33.2493481
              ],
              [
                46.388259,
                33.2482465
              ],
              [
                46.3902061,
                33.2421341
              ],
              [
                46.3904826,
                33.2418452
              ],
              [
                46.390206,
                33.2363016
              ],
              [
                46.3835397,
                33.2176844
              ],
              [
                46.3832592,
                33.2132423
              ],
              [
                46.3835396,
                33.2124026
              ],
              [
                46.3838162,
                33.2118519
              ],
              [
                46.3838162,
                33.211572
              ],
              [
                46.3846491,
                33.2099107
              ],
              [
                46.4013158,
                33.1843503
              ],
              [
                46.4163193,
                33.1704641
              ],
              [
                46.424929,
                33.1662927
              ],
              [
                46.426872,
                33.1654621
              ],
              [
                46.4293758,
                33.1643516
              ],
              [
                46.4302087,
                33.1643516
              ],
              [
                46.4404855,
                33.1618506
              ],
              [
                46.4418754,
                33.1618507
              ],
              [
                46.4429855,
                33.1615707
              ],
              [
                46.4454856,
                33.1615707
              ],
              [
                46.4463184,
                33.1612909
              ],
              [
                46.4510419,
                33.1612909
              ],
              [
                46.4515982,
                33.1615708
              ],
              [
                46.4524318,
                33.1615708
              ],
              [
                46.4527084,
                33.1618507
              ],
              [
                46.4535419,
                33.1618506
              ],
              [
                46.4582655,
                33.1632412
              ],
              [
                46.470765,
                33.1682431
              ],
              [
                46.4846551,
                33.1729562
              ],
              [
                46.4857644,
                33.1732361
              ],
              [
                46.4946545,
                33.176017
              ],
              [
                46.4996546,
                33.1771276
              ],
              [
                46.5046546,
                33.1771276
              ],
              [
                46.5088212,
                33.1771276
              ],
              [
                46.5177112,
                33.1799085
              ],
              [
                46.5193776,
                33.1799085
              ],
              [
                46.5199346,
                33.1801884
              ],
              [
                46.522991,
                33.1801884
              ],
              [
                46.5246574,
                33.1796286
              ],
              [
                46.5260442,
                33.1796286
              ],
              [
                46.5266012,
                33.1793487
              ],
              [
                46.5349341,
                33.1779673
              ],
              [
                46.5352108,
                33.1782382
              ],
              [
                46.5368771,
                33.1782382
              ],
              [
                46.5377108,
                33.1785181
              ],
              [
                46.5391006,
                33.1785181
              ],
              [
                46.5404905,
                33.1790779
              ],
              [
                46.5421569,
                33.1801885
              ],
              [
                46.5435476,
                33.1801884
              ],
              [
                46.5446572,
                33.1799085
              ],
              [
                46.5452141,
                33.1799086
              ],
              [
                46.5513236,
                33.1774076
              ],
              [
                46.5549337,
                33.1732363
              ],
              [
                46.5557674,
                33.1729564
              ],
              [
                46.5560471,
                33.1724056
              ],
              [
                46.5571573,
                33.1718458
              ],
              [
                46.5585471,
                33.171575
              ],
              [
                46.5602136,
                33.1707353
              ],
              [
                46.5674372,
                33.1693539
              ],
              [
                46.5713232,
                33.169354
              ],
              [
                46.5721568,
                33.169074
              ],
              [
                46.5757701,
                33.169074
              ],
              [
                46.5763233,
                33.1687942
              ],
              [
                46.5774365,
                33.1687942
              ],
              [
                46.5807703,
                33.1674038
              ],
              [
                46.5829938,
                33.164352
              ],
              [
                46.5849368,
                33.1574089
              ],
              [
                46.5852133,
                33.1565782
              ],
              [
                46.5852133,
                33.1510164
              ],
              [
                46.5854939,
                33.1501767
              ],
              [
                46.5871604,
                33.1482446
              ],
              [
                46.6074365,
                33.1376899
              ],
              [
                46.6088264,
                33.137401
              ],
              [
                46.6257728,
                33.1310176
              ],
              [
                46.6502164,
                33.1224041
              ],
              [
                46.6518828,
                33.1212935
              ],
              [
                46.6541063,
                33.1174021
              ],
              [
                46.6566064,
                33.1090685
              ],
              [
                46.6577197,
                33.105466
              ],
              [
                46.6607729,
                33.0974031
              ],
              [
                46.6649395,
                33.0912905
              ],
              [
                46.6757756,
                33.0793452
              ],
              [
                46.6757755,
                33.0787945
              ],
              [
                46.6766092,
                33.077404
              ],
              [
                46.6785522,
                33.0746231
              ],
              [
                46.6788296,
                33.0743431
              ],
              [
                46.6788296,
                33.0729618
              ],
              [
                46.6788296,
                33.0726819
              ],
              [
                46.6766093,
                33.0654587
              ],
              [
                46.6768858,
                33.0637974
              ],
              [
                46.6771624,
                33.0635174
              ],
              [
                46.6782757,
                33.0618471
              ],
              [
                46.6891095,
                33.0640683
              ],
              [
                46.6999425,
                33.0693502
              ],
              [
                46.7027191,
                33.0707407
              ],
              [
                46.7121654,
                33.0771241
              ],
              [
                46.7235554,
                33.0824062
              ],
              [
                46.7299454,
                33.085458
              ],
              [
                46.742998,
                33.0960128
              ],
              [
                46.743555,
                33.0996245
              ],
              [
                46.7435549,
                33.1012948
              ],
              [
                46.7407784,
                33.1068476
              ],
              [
                46.7404986,
                33.1076782
              ],
              [
                46.7410548,
                33.1124003
              ],
              [
                46.751055,
                33.1254652
              ],
              [
                46.7560543,
                33.1282371
              ],
              [
                46.757445,
                33.1287969
              ],
              [
                46.7577216,
                33.1293476
              ],
              [
                46.7582778,
                33.1293477
              ],
              [
                46.7613349,
                33.1340787
              ],
              [
                46.761888,
                33.1371215
              ],
              [
                46.7616114,
                33.1374014
              ],
              [
                46.7596676,
                33.1418526
              ],
              [
                46.7599442,
                33.1429632
              ],
              [
                46.7666107,
                33.1482451
              ],
              [
                46.773278,
                33.1515767
              ],
              [
                46.7935573,
                33.1593506
              ],
              [
                46.8071709,
                33.1660139
              ],
              [
                46.8124474,
                33.1679642
              ],
              [
                46.8196703,
                33.1696255
              ],
              [
                46.8266134,
                33.1721265
              ],
              [
                46.8327267,
                33.1749074
              ],
              [
                46.8346698,
                33.1754581
              ],
              [
                46.838837,
                33.1776883
              ],
              [
                46.8585601,
                33.1846315
              ],
              [
                46.8632828,
                33.1865726
              ],
              [
                46.8657828,
                33.188243
              ],
              [
                46.8691165,
                33.1918545
              ],
              [
                46.8716165,
                33.1968475
              ],
              [
                46.8732829,
                33.2049101
              ],
              [
                46.8724492,
                33.209912
              ],
              [
                46.8702257,
                33.2157355
              ],
              [
                46.8671725,
                33.2196269
              ],
              [
                46.8646725,
                33.2224077
              ],
              [
                46.8577263,
                33.2293507
              ],
              [
                46.8557833,
                33.2321316
              ],
              [
                46.8549497,
                33.2343527
              ],
              [
                46.8546699,
                33.2346326
              ],
              [
                46.8713397,
                33.2626846
              ],
              [
                46.878839,
                33.2810217
              ],
              [
                46.8796726,
                33.282683
              ],
              [
                46.8802288,
                33.2854639
              ],
              [
                46.8807828,
                33.2871342
              ],
              [
                46.8810624,
                33.3032411
              ],
              [
                46.8863391,
                33.3204675
              ],
              [
                46.8880055,
                33.319357
              ],
              [
                46.8880054,
                33.3196368
              ],
              [
                46.8832819,
                33.32602
              ],
              [
                46.8821725,
                33.3265797
              ],
              [
                46.8777254,
                33.3313016
              ],
              [
                46.8377261,
                33.3601835
              ],
              [
                46.8374456,
                33.3604634
              ],
              [
                46.8357792,
                33.361303
              ],
              [
                46.8357792,
                33.3615829
              ],
              [
                46.8188359,
                33.3729676
              ],
              [
                46.8041128,
                33.3843524
              ],
              [
                46.7891134,
                33.3896339
              ],
              [
                46.7682769,
                33.3982469
              ],
              [
                46.7677239,
                33.3987976
              ],
              [
                46.7580003,
                33.4012984
              ],
              [
                46.733277,
                33.4113017
              ],
              [
                46.7029975,
                33.4229661
              ],
              [
                46.6793844,
                33.4301886
              ],
              [
                46.6782743,
                33.4304685
              ],
              [
                46.677718,
                33.4304685
              ],
              [
                46.6760516,
                33.4304685
              ],
              [
                46.6732749,
                33.4304685
              ],
              [
                46.6729945,
                33.4301887
              ],
              [
                46.6691046,
                33.4301886
              ],
              [
                46.6654943,
                33.4296378
              ],
              [
                46.6585512,
                33.431579
              ],
              [
                46.6568848,
                33.4315789
              ],
              [
                46.6421618,
                33.4349103
              ],
              [
                46.6270433,
                33.4388846
              ],
              [
                46.5924357,
                33.447974
              ],
              [
                46.5891022,
                33.4488046
              ],
              [
                46.5807691,
                33.4515852
              ],
              [
                46.5802121,
                33.4521359
              ],
              [
                46.5785457,
                33.4526866
              ],
              [
                46.569379,
                33.4585278
              ],
              [
                46.5638226,
                33.4607487
              ],
              [
                46.5627125,
                33.4607488
              ],
              [
                46.5621563,
                33.4610196
              ],
              [
                46.5596561,
                33.4607487
              ],
              [
                46.5557663,
                33.4596383
              ],
              [
                46.5382659,
                33.4732436
              ],
              [
                46.5082668,
                33.4938004
              ],
              [
                46.5038198,
                33.4951908
              ],
              [
                46.5035433,
                33.4954707
              ],
              [
                46.4996532,
                33.4974117
              ],
              [
                46.4952101,
                33.4985221
              ],
              [
                46.4943943,
                33.4985909
              ],
              [
                46.4907632,
                33.498802
              ],
              [
                46.4902102,
                33.4990818
              ],
              [
                46.4879866,
                33.4990819
              ],
              [
                46.4865968,
                33.4993527
              ],
              [
                46.4863202,
                33.4996416
              ],
              [
                46.4843765,
                33.4996416
              ],
              [
                46.4768732,
                33.5007429
              ],
              [
                46.4585408,
                33.5043632
              ],
              [
                46.4568735,
                33.5043631
              ],
              [
                46.4518742,
                33.5054646
              ],
              [
                46.4493742,
                33.506584
              ],
              [
                46.446874,
                33.5068548
              ],
              [
                46.4371505,
                33.5121362
              ],
              [
                46.4343738,
                33.5129668
              ],
              [
                46.4338175,
                33.5132466
              ],
              [
                46.4332605,
                33.5129668
              ],
              [
                46.4299276,
                33.5126959
              ],
              [
                46.418261,
                33.5099153
              ],
              [
                46.4177039,
                33.5101861
              ],
              [
                46.4177039,
                33.5096354
              ],
              [
                46.4160375,
                33.5051936
              ],
              [
                46.4152039,
                33.5015824
              ],
              [
                46.4135375,
                33.4979712
              ],
              [
                46.4110375,
                33.4890785
              ],
              [
                46.4104844,
                33.4885188
              ],
              [
                46.4103402,
                33.4883028
              ],
              [
                46.4099808,
                33.4877648
              ],
              [
                46.4091434,
                33.4865111
              ],
              [
                46.4077046,
                33.4843568
              ],
              [
                46.406871,
                33.4835262
              ],
              [
                46.4065945,
                33.4829665
              ],
              [
                46.4044683,
                33.4815491
              ],
              [
                46.3957615,
                33.475744
              ],
              [
                46.3940951,
                33.475744
              ],
              [
                46.3938145,
                33.4754641
              ],
              [
                46.3899278,
                33.4743536
              ],
              [
                46.3671484,
                33.4604683
              ],
              [
                46.3657586,
                33.4596377
              ],
              [
                46.3613156,
                33.457137
              ],
              [
                46.3602023,
                33.4557466
              ],
              [
                46.3460357,
                33.4343587
              ],
              [
                46.3296456,
                33.422965
              ],
              [
                46.327422,
                33.4218546
              ],
              [
                46.286033,
                33.3943543
              ],
              [
                46.2838096,
                33.3921333
              ],
              [
                46.2827002,
                33.3910228
              ],
              [
                46.2824228,
                33.3904632
              ],
              [
                46.2796432,
                33.3854705
              ],
              [
                46.2793666,
                33.3838002
              ],
              [
                46.278533,
                33.38185
              ],
              [
                46.2774236,
                33.3760268
              ],
              [
                46.2771431,
                33.3726863
              ],
              [
                46.2768666,
                33.3663032
              ],
              [
                46.2771431,
                33.364353
              ],
              [
                46.2768666,
                33.3638023
              ],
              [
                46.27659,
                33.3596312
              ],
              [
                46.2771432,
                33.3576901
              ],
              [
                46.2788096,
                33.3560199
              ],
              [
                46.2799237,
                33.3551893
              ],
              [
                46.2835331,
                33.3532482
              ],
              [
                46.2840902,
                33.3524085
              ],
              [
                46.2865904,
                33.3421251
              ],
              [
                46.2868669,
                33.340184
              ],
              [
                46.2871435,
                33.3387936
              ],
              [
                46.2874231,
                33.3382429
              ],
              [
                46.2854771,
                33.3229667
              ],
              [
                46.2813098,
                33.3171342
              ],
              [
                46.2799239,
                33.3157439
              ],
              [
                46.2799239,
                33.315464
              ],
              [
                46.2793668,
                33.3149042
              ],
              [
                46.2790902,
                33.3146334
              ],
              [
                46.2785333,
                33.3137938
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555278,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چرداول",
          "name:en": "Chardavol County",
          "name:ku": "Çirdawil",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291855",
          "wikipedia": "en:Chardavol County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.2913074,
                33.9589556
              ],
              [
                46.2930547,
                33.9571933
              ],
              [
                46.2980531,
                33.9534491
              ],
              [
                46.3032538,
                33.9471436
              ],
              [
                46.3115869,
                33.92854
              ],
              [
                46.3115868,
                33.9282602
              ],
              [
                46.3121439,
                33.9274207
              ],
              [
                46.3160338,
                33.9207591
              ],
              [
                46.3424235,
                33.9057568
              ],
              [
                46.3492127,
                33.8995182
              ],
              [
                46.3599647,
                33.8926911
              ],
              [
                46.363599,
                33.8884432
              ],
              [
                46.3604217,
                33.8558292
              ],
              [
                46.3709913,
                33.8437846
              ],
              [
                46.3736869,
                33.8395908
              ],
              [
                46.3857109,
                33.8223834
              ],
              [
                46.4041862,
                33.8052775
              ],
              [
                46.4135091,
                33.7921803
              ],
              [
                46.4527362,
                33.7960318
              ],
              [
                46.4700433,
                33.7994199
              ],
              [
                46.4891866,
                33.8007598
              ],
              [
                46.4931935,
                33.8001996
              ],
              [
                46.495209,
                33.8001968
              ],
              [
                46.4996521,
                33.8001969
              ],
              [
                46.5100882,
                33.7990667
              ],
              [
                46.513778,
                33.7985929
              ],
              [
                46.5335419,
                33.7713101
              ],
              [
                46.5407648,
                33.7479748
              ],
              [
                46.5415985,
                33.7474241
              ],
              [
                46.5532651,
                33.7376927
              ],
              [
                46.5552113,
                33.7363116
              ],
              [
                46.556598,
                33.7357519
              ],
              [
                46.567435,
                33.7265892
              ],
              [
                46.5941012,
                33.704084
              ],
              [
                46.5963248,
                33.7029737
              ],
              [
                46.6046577,
                33.6985322
              ],
              [
                46.6046577,
                33.6982524
              ],
              [
                46.6049343,
                33.6979724
              ],
              [
                46.6117205,
                33.6938193
              ],
              [
                46.6185478,
                33.6896402
              ],
              [
                46.6779937,
                33.6568614
              ],
              [
                46.6807735,
                33.6554802
              ],
              [
                46.6832735,
                33.6546406
              ],
              [
                46.6838267,
                33.6540809
              ],
              [
                46.6927167,
                33.6510296
              ],
              [
                46.6941066,
                33.6510296
              ],
              [
                46.6941066,
                33.6507498
              ],
              [
                46.6974402,
                33.6507498
              ],
              [
                46.698273,
                33.6504699
              ],
              [
                46.6991067,
                33.6501991
              ],
              [
                46.7016067,
                33.6493596
              ],
              [
                46.7018833,
                33.6490887
              ],
              [
                46.7027169,
                33.6490888
              ],
              [
                46.7535524,
                33.6274136
              ],
              [
                46.7560524,
                33.626583
              ],
              [
                46.756886,
                33.6263031
              ],
              [
                46.758833,
                33.6251928
              ],
              [
                46.7591095,
                33.6249129
              ],
              [
                46.7595259,
                33.6246375
              ],
              [
                46.7599424,
                33.6243622
              ],
              [
                46.7796655,
                33.6132492
              ],
              [
                46.780499,
                33.6132492
              ],
              [
                46.7807756,
                33.6129693
              ],
              [
                46.7824421,
                33.6124186
              ],
              [
                46.7829991,
                33.611859
              ],
              [
                46.7835562,
                33.6118589
              ],
              [
                46.7954986,
                33.6063069
              ],
              [
                46.7991119,
                33.6051965
              ],
              [
                46.7996658,
                33.6046368
              ],
              [
                46.8021659,
                33.6038062
              ],
              [
                46.8032792,
                33.6029666
              ],
              [
                46.8309994,
                33.5899774
              ],
              [
                46.8387499,
                33.5872533
              ],
              [
                46.8549719,
                33.5811397
              ],
              [
                46.86469,
                33.5768893
              ],
              [
                46.8650114,
                33.5785967
              ],
              [
                46.86469,
                33.579668
              ],
              [
                46.8646096,
                33.5812414
              ],
              [
                46.8650114,
                33.5822792
              ],
              [
                46.8647301,
                33.5829822
              ],
              [
                46.8636854,
                33.5839865
              ],
              [
                46.8627612,
                33.5845556
              ],
              [
                46.8615959,
                33.585359
              ],
              [
                46.8610735,
                33.5864971
              ],
              [
                46.8604797,
                33.5872663
              ],
              [
                46.8596273,
                33.5886865
              ],
              [
                46.8593431,
                33.5896806
              ],
              [
                46.8604797,
                33.590722
              ],
              [
                46.8608775,
                33.5915268
              ],
              [
                46.8615026,
                33.5913847
              ],
              [
                46.862696,
                33.5920001
              ],
              [
                46.8625823,
                33.5933256
              ],
              [
                46.8612185,
                33.5949823
              ],
              [
                46.8592295,
                33.5967337
              ],
              [
                46.8572973,
                33.5993371
              ],
              [
                46.8553652,
                33.6020351
              ],
              [
                46.853774,
                33.604023
              ],
              [
                46.8512168,
                33.6061055
              ],
              [
                46.8487164,
                33.6082353
              ],
              [
                46.8466501,
                33.6098086
              ],
              [
                46.8460074,
                33.6103239
              ],
              [
                46.8457917,
                33.61145
              ],
              [
                46.8468428,
                33.6116825
              ],
              [
                46.8472957,
                33.6115482
              ],
              [
                46.8508758,
                33.6120688
              ],
              [
                46.8534899,
                33.6129207
              ],
              [
                46.8562176,
                33.6130154
              ],
              [
                46.8589453,
                33.6134886
              ],
              [
                46.8618436,
                33.6140565
              ],
              [
                46.8648554,
                33.6152396
              ],
              [
                46.8671285,
                33.6160915
              ],
              [
                46.8696289,
                33.6168013
              ],
              [
                46.8713906,
                33.6179844
              ],
              [
                46.8731523,
                33.6189309
              ],
              [
                46.8761641,
                33.6194514
              ],
              [
                46.8788919,
                33.6199247
              ],
              [
                46.8815628,
                33.6208711
              ],
              [
                46.8849156,
                33.6207764
              ],
              [
                46.8869428,
                33.6203596
              ],
              [
                46.8912129,
                33.6195913
              ],
              [
                46.8932728,
                33.6190552
              ],
              [
                46.8946139,
                33.6184298
              ],
              [
                46.8961696,
                33.6177151
              ],
              [
                46.8975536,
                33.6171879
              ],
              [
                46.8987875,
                33.6167948
              ],
              [
                46.9000105,
                33.6164106
              ],
              [
                46.9014267,
                33.6157852
              ],
              [
                46.9022958,
                33.6153385
              ],
              [
                46.9035081,
                33.6149275
              ],
              [
                46.9048063,
                33.6148739
              ],
              [
                46.9057612,
                33.6147845
              ],
              [
                46.9068985,
                33.6149364
              ],
              [
                46.9081323,
                33.6151687
              ],
              [
                46.9093661,
                33.6157227
              ],
              [
                46.9106321,
                33.6168841
              ],
              [
                46.912853,
                33.61868
              ],
              [
                46.913722,
                33.6193947
              ],
              [
                46.9146232,
                33.6201184
              ],
              [
                46.9151811,
                33.62044
              ],
              [
                46.9158785,
                33.6211458
              ],
              [
                46.9163613,
                33.6213156
              ],
              [
                46.9173376,
                33.621253
              ],
              [
                46.9178419,
                33.6213424
              ],
              [
                46.9194083,
                33.6210207
              ],
              [
                46.9211785,
                33.6208421
              ],
              [
                46.9220261,
                33.6203596
              ],
              [
                46.9228522,
                33.6203328
              ],
              [
                46.9234316,
                33.6204489
              ],
              [
                46.9246225,
                33.6204758
              ],
              [
                46.9265537,
                33.620172
              ],
              [
                46.9276909,
                33.6203328
              ],
              [
                46.9294505,
                33.6207348
              ],
              [
                46.930813,
                33.6211726
              ],
              [
                46.9324653,
                33.6218963
              ],
              [
                46.9340639,
                33.6228075
              ],
              [
                46.9362525,
                33.6235044
              ],
              [
                46.9377546,
                33.6233078
              ],
              [
                46.9390528,
                33.6228165
              ],
              [
                46.9410162,
                33.6220928
              ],
              [
                46.942722,
                33.6212352
              ],
              [
                46.9440202,
                33.6203953
              ],
              [
                46.9449322,
                33.6199308
              ],
              [
                46.9453506,
                33.6196359
              ],
              [
                46.9468634,
                33.6191267
              ],
              [
                46.9485049,
                33.6187872
              ],
              [
                46.94961,
                33.618805
              ],
              [
                46.9511549,
                33.6184209
              ],
              [
                46.9520669,
                33.6182332
              ],
              [
                46.9529573,
                33.6177329
              ],
              [
                46.9534616,
                33.617045
              ],
              [
                46.9535903,
                33.6162587
              ],
              [
                46.9536762,
                33.6152938
              ],
              [
                46.9536655,
                33.6144361
              ],
              [
                46.9537513,
                33.6135962
              ],
              [
                46.9537513,
                33.6129261
              ],
              [
                46.9542341,
                33.6121487
              ],
              [
                46.9552748,
                33.6115858
              ],
              [
                46.9562511,
                33.6109246
              ],
              [
                46.9576566,
                33.6102634
              ],
              [
                46.9590406,
                33.6099685
              ],
              [
                46.9602637,
                33.6099149
              ],
              [
                46.9614868,
                33.6098256
              ],
              [
                46.9627313,
                33.6096022
              ],
              [
                46.9638793,
                33.6093341
              ],
              [
                46.9648878,
                33.6091822
              ],
              [
                46.9661216,
                33.6088695
              ],
              [
                46.9671731,
                33.6089052
              ],
              [
                46.9680314,
                33.6086819
              ],
              [
                46.9692759,
                33.6083602
              ],
              [
                46.9700269,
                33.6078866
              ],
              [
                46.9714109,
                33.6071092
              ],
              [
                46.9733207,
                33.6063944
              ],
              [
                46.9740181,
                33.6059476
              ],
              [
                46.9746403,
                33.6055455
              ],
              [
                46.9757454,
                33.6049915
              ],
              [
                46.9769685,
                33.6041604
              ],
              [
                46.9779233,
                33.6034366
              ],
              [
                46.979125,
                33.6014171
              ],
              [
                46.9786958,
                33.6008452
              ],
              [
                46.9775908,
                33.6001303
              ],
              [
                46.9767324,
                33.5988613
              ],
              [
                46.9766359,
                33.5972885
              ],
              [
                46.9777624,
                33.5952956
              ],
              [
                46.9788353,
                33.5938969
              ],
              [
                46.979811,
                33.5928267
              ],
              [
                46.9820226,
                33.5908761
              ],
              [
                46.9857303,
                33.5885055
              ],
              [
                46.9873403,
                33.587503
              ],
              [
                46.9897145,
                33.5862296
              ],
              [
                46.9921375,
                33.5854845
              ],
              [
                46.9939914,
                33.5847801
              ],
              [
                46.9957314,
                33.5845227
              ],
              [
                46.9963299,
                33.5847906
              ],
              [
                46.9968209,
                33.5850104
              ],
              [
                46.9974064,
                33.5862296
              ],
              [
                46.998317,
                33.587801
              ],
              [
                46.9985935,
                33.5884919
              ],
              [
                46.9988049,
                33.5904291
              ],
              [
                46.9992765,
                33.5918921
              ],
              [
                47.0006262,
                33.5930435
              ],
              [
                47.0018621,
                33.5938427
              ],
              [
                47.0074887,
                33.5947232
              ],
              [
                47.0091637,
                33.5945877
              ],
              [
                47.0113265,
                33.5939375
              ],
              [
                47.0142211,
                33.5932331
              ],
              [
                47.0157172,
                33.5933144
              ],
              [
                47.0171645,
                33.5933821
              ],
              [
                47.018498,
                33.5938021
              ],
              [
                47.0197339,
                33.5944116
              ],
              [
                47.0205795,
                33.5947367
              ],
              [
                47.0219259,
                33.5945335
              ],
              [
                47.0245008,
                33.5928355
              ],
              [
                47.0266037,
                33.5911553
              ],
              [
                47.0284061,
                33.5901186
              ],
              [
                47.0298652,
                33.5893679
              ],
              [
                47.031775,
                33.5881345
              ],
              [
                47.0348626,
                33.5857417
              ],
              [
                47.0360021,
                33.5854353
              ],
              [
                47.0364084,
                33.586384
              ],
              [
                47.0369463,
                33.5872765
              ],
              [
                47.0373983,
                33.5879007
              ],
              [
                47.037203,
                33.5886828
              ],
              [
                47.0361738,
                33.589636
              ],
              [
                47.0348207,
                33.5904124
              ],
              [
                47.0338134,
                33.5906727
              ],
              [
                47.0312171,
                33.5928534
              ],
              [
                47.030466,
                33.5941761
              ],
              [
                47.0293502,
                33.5971967
              ],
              [
                47.028213,
                33.6013253
              ],
              [
                47.0269899,
                33.6035235
              ],
              [
                47.0264964,
                33.6049533
              ],
              [
                47.0246081,
                33.6068476
              ],
              [
                47.0248871,
                33.607902
              ],
              [
                47.026947,
                33.6105647
              ],
              [
                47.0275263,
                33.6120301
              ],
              [
                47.0284276,
                33.6136384
              ],
              [
                47.0291571,
                33.6154075
              ],
              [
                47.0281272,
                33.6169442
              ],
              [
                47.0265178,
                33.6179091
              ],
              [
                47.0235996,
                33.6195531
              ],
              [
                47.0220976,
                33.620911
              ],
              [
                47.0215826,
                33.6242702
              ],
              [
                47.0206384,
                33.625378
              ],
              [
                47.0200805,
                33.6283082
              ],
              [
                47.020617,
                33.6305057
              ],
              [
                47.0214538,
                33.6317564
              ],
              [
                47.0234279,
                33.6318814
              ],
              [
                47.0243721,
                33.633936
              ],
              [
                47.0260458,
                33.6397957
              ],
              [
                47.0269899,
                33.6439758
              ],
              [
                47.0277624,
                33.645655
              ],
              [
                47.0281057,
                33.6461909
              ],
              [
                47.0302086,
                33.6473698
              ],
              [
                47.0311098,
                33.6480665
              ],
              [
                47.0319681,
                33.6493526
              ],
              [
                47.0348863,
                33.6506386
              ],
              [
                47.0367531,
                33.6513888
              ],
              [
                47.0377831,
                33.6526034
              ],
              [
                47.0375256,
                33.6541038
              ],
              [
                47.0379237,
                33.6546522
              ],
              [
                47.023397,
                33.6671151
              ],
              [
                47.0175005,
                33.6718511
              ],
              [
                46.9967209,
                33.6832935
              ],
              [
                46.9787737,
                33.6856504
              ],
              [
                46.960981,
                33.6881358
              ],
              [
                46.9513397,
                33.6929722
              ],
              [
                46.9363401,
                33.7035343
              ],
              [
                46.8985603,
                33.7332523
              ],
              [
                46.8911072,
                33.7394695
              ],
              [
                46.8893569,
                33.7407478
              ],
              [
                46.8826572,
                33.741441
              ],
              [
                46.8738372,
                33.7338119
              ],
              [
                46.8727239,
                33.7338119
              ],
              [
                46.8718911,
                33.7335321
              ],
              [
                46.8696707,
                33.7335321
              ],
              [
                46.8688378,
                33.7332522
              ],
              [
                46.8630042,
                33.7332522
              ],
              [
                46.8627245,
                33.733532
              ],
              [
                46.8596674,
                33.733532
              ],
              [
                46.8591143,
                33.7338119
              ],
              [
                46.8582814,
                33.7338119
              ],
              [
                46.8427248,
                33.7413045
              ],
              [
                46.8388349,
                33.7432543
              ],
              [
                46.8338347,
                33.7460257
              ],
              [
                46.8307776,
                33.7482554
              ],
              [
                46.8299449,
                33.7485353
              ],
              [
                46.8293918,
                33.7490859
              ],
              [
                46.7799422,
                33.7671403
              ],
              [
                46.7791086,
                33.7671403
              ],
              [
                46.7771656,
                33.7676999
              ],
              [
                46.770499,
                33.7693609
              ],
              [
                46.7688319,
                33.7702005
              ],
              [
                46.7666083,
                33.7704713
              ],
              [
                46.7663317,
                33.7707511
              ],
              [
                46.7652184,
                33.770751
              ],
              [
                46.7646653,
                33.771031
              ],
              [
                46.763552,
                33.7710309
              ],
              [
                46.7627183,
                33.7713108
              ],
              [
                46.7604988,
                33.7713107
              ],
              [
                46.7599418,
                33.7710309
              ],
              [
                46.7588324,
                33.7710309
              ],
              [
                46.7554988,
                33.7676999
              ],
              [
                46.7524425,
                33.7574179
              ],
              [
                46.7513324,
                33.7543666
              ],
              [
                46.7504988,
                33.7529764
              ],
              [
                46.739386,
                33.7426944
              ],
              [
                46.7363289,
                33.7421437
              ],
              [
                46.7360524,
                33.7418638
              ],
              [
                46.7341093,
                33.7418639
              ],
              [
                46.7335524,
                33.741584
              ],
              [
                46.7324429,
                33.741584
              ],
              [
                46.7318858,
                33.7418639
              ],
              [
                46.7313296,
                33.7418638
              ],
              [
                46.7299429,
                33.7418639
              ],
              [
                46.7296624,
                33.7421437
              ],
              [
                46.7288296,
                33.7421437
              ],
              [
                46.7279674,
                33.7421437
              ],
              [
                46.7268858,
                33.7421437
              ],
              [
                46.7268858,
                33.7418638
              ],
              [
                46.7252193,
                33.7418638
              ],
              [
                46.7252193,
                33.7421437
              ],
              [
                46.724106,
                33.7421437
              ],
              [
                46.7143863,
                33.7485349
              ],
              [
                46.7135527,
                33.7488058
              ],
              [
                46.7129964,
                33.7493655
              ],
              [
                46.7052166,
                33.7521458
              ],
              [
                46.7027166,
                33.7529764
              ],
              [
                46.6952163,
                33.7571469
              ],
              [
                46.6932733,
                33.7593676
              ],
              [
                46.6713267,
                33.7893649
              ],
              [
                46.6707696,
                33.7904752
              ],
              [
                46.667993,
                33.7932555
              ],
              [
                46.6657702,
                33.7949255
              ],
              [
                46.6607701,
                33.7982565
              ],
              [
                46.6411214,
                33.8144911
              ],
              [
                46.6352134,
                33.8193707
              ],
              [
                46.6216036,
                33.830203
              ],
              [
                46.621324,
                33.830825
              ],
              [
                46.6210473,
                33.8310336
              ],
              [
                46.62077,
                33.8313134
              ],
              [
                46.6168801,
                33.8332542
              ],
              [
                46.6168801,
                33.833534
              ],
              [
                46.6163238,
                33.833534
              ],
              [
                46.6160473,
                33.8338138
              ],
              [
                46.6154902,
                33.8340847
              ],
              [
                46.5907671,
                33.8449259
              ],
              [
                46.5899342,
                33.8451967
              ],
              [
                46.5835442,
                33.8488164
              ],
              [
                46.582434,
                33.8490873
              ],
              [
                46.5816005,
                33.849647
              ],
              [
                46.5602108,
                33.8610298
              ],
              [
                46.5599343,
                33.8613096
              ],
              [
                46.5593781,
                33.8613096
              ],
              [
                46.5591007,
                33.8615894
              ],
              [
                46.558264,
                33.8615895
              ],
              [
                46.5418777,
                33.8696414
              ],
              [
                46.5415979,
                33.8699212
              ],
              [
                46.5013182,
                33.8979763
              ],
              [
                46.4849288,
                33.9057572
              ],
              [
                46.472705,
                33.9107579
              ],
              [
                46.4718722,
                33.910758
              ],
              [
                46.4710386,
                33.9113176
              ],
              [
                46.4696519,
                33.9118682
              ],
              [
                46.4682619,
                33.9129785
              ],
              [
                46.3929798,
                33.9518647
              ],
              [
                46.3921463,
                33.9524244
              ],
              [
                46.3557564,
                33.9704863
              ],
              [
                46.3490897,
                33.9727067
              ],
              [
                46.3074201,
                33.9910392
              ],
              [
                46.3068639,
                33.99131
              ],
              [
                46.2985308,
                33.9954801
              ],
              [
                46.2982535,
                33.9952004
              ],
              [
                46.2976972,
                33.9949296
              ],
              [
                46.2951972,
                33.9927
              ],
              [
                46.2918636,
                33.982419
              ],
              [
                46.289087,
                33.9657563
              ],
              [
                46.2910309,
                33.9604847
              ],
              [
                46.2913074,
                33.9596453
              ],
              [
                46.2913074,
                33.9589556
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11155682,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هلیلان",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.8893569,
                33.7407478
              ],
              [
                46.8911072,
                33.7394695
              ],
              [
                46.8985603,
                33.7332523
              ],
              [
                46.9363401,
                33.7035343
              ],
              [
                46.9513397,
                33.6929722
              ],
              [
                46.960981,
                33.6881358
              ],
              [
                46.9787737,
                33.6856504
              ],
              [
                46.9967209,
                33.6832935
              ],
              [
                47.0175005,
                33.6718511
              ],
              [
                47.023397,
                33.6671151
              ],
              [
                47.0379237,
                33.6546522
              ],
              [
                47.0381479,
                33.6549611
              ],
              [
                47.0402078,
                33.6552826
              ],
              [
                47.0419459,
                33.6550504
              ],
              [
                47.0432334,
                33.6551755
              ],
              [
                47.0443706,
                33.6556756
              ],
              [
                47.0443706,
                33.6568723
              ],
              [
                47.0439844,
                33.6585512
              ],
              [
                47.0432334,
                33.6603193
              ],
              [
                47.0439629,
                33.6618374
              ],
              [
                47.04392,
                33.6626589
              ],
              [
                47.044199,
                33.6634448
              ],
              [
                47.0447998,
                33.6644449
              ],
              [
                47.0441131,
                33.6663558
              ],
              [
                47.0444779,
                33.6672309
              ],
              [
                47.0472889,
                33.6679988
              ],
              [
                47.0495634,
                33.6685345
              ],
              [
                47.0536832,
                33.6682131
              ],
              [
                47.0582537,
                33.6678023
              ],
              [
                47.0602278,
                33.6683738
              ],
              [
                47.0609359,
                33.6705168
              ],
              [
                47.0606785,
                33.6718383
              ],
              [
                47.0589189,
                33.6715704
              ],
              [
                47.0551424,
                33.671749
              ],
              [
                47.0541768,
                33.6728026
              ],
              [
                47.0549278,
                33.6760347
              ],
              [
                47.0561509,
                33.6782132
              ],
              [
                47.0559792,
                33.6798917
              ],
              [
                47.056108,
                33.6808336
              ],
              [
                47.0563449,
                33.6814654
              ],
              [
                47.0571728,
                33.6817108
              ],
              [
                47.0583713,
                33.6820961
              ],
              [
                47.0601849,
                33.6826058
              ],
              [
                47.0626526,
                33.684677
              ],
              [
                47.0631246,
                33.6870695
              ],
              [
                47.0641975,
                33.6883729
              ],
              [
                47.0656137,
                33.6891406
              ],
              [
                47.067502,
                33.6888549
              ],
              [
                47.0701627,
                33.6895155
              ],
              [
                47.0714717,
                33.6912831
              ],
              [
                47.0712571,
                33.6924971
              ],
              [
                47.0692401,
                33.6938004
              ],
              [
                47.0638756,
                33.6956214
              ],
              [
                47.0601849,
                33.6982814
              ],
              [
                47.0595737,
                33.6993101
              ],
              [
                47.0595491,
                33.7004072
              ],
              [
                47.0599188,
                33.7019247
              ],
              [
                47.0615579,
                33.7035959
              ],
              [
                47.0629136,
                33.7047852
              ],
              [
                47.0643185,
                33.7058822
              ],
              [
                47.065514,
                33.7073483
              ],
              [
                47.0656988,
                33.7084556
              ],
              [
                47.0652305,
                33.7090092
              ],
              [
                47.0672886,
                33.7108033
              ],
              [
                47.0686073,
                33.7116337
              ],
              [
                47.0700493,
                33.7112543
              ],
              [
                47.0719965,
                33.7094705
              ],
              [
                47.0739314,
                33.7077071
              ],
              [
                47.0752378,
                33.7061898
              ],
              [
                47.0773205,
                33.7046519
              ],
              [
                47.0787333,
                33.7034711
              ],
              [
                47.0799022,
                33.7033309
              ],
              [
                47.0807874,
                33.7029999
              ],
              [
                47.0821853,
                33.7024496
              ],
              [
                47.0849779,
                33.7009888
              ],
              [
                47.0872383,
                33.70061
              ],
              [
                47.0889946,
                33.7012188
              ],
              [
                47.0906208,
                33.7020441
              ],
              [
                47.0916128,
                33.7036134
              ],
              [
                47.0927836,
                33.7040598
              ],
              [
                47.0935642,
                33.7051962
              ],
              [
                47.0934178,
                33.7067249
              ],
              [
                47.0937593,
                33.7082265
              ],
              [
                47.0943773,
                33.7097957
              ],
              [
                47.0956578,
                33.7099568
              ],
              [
                47.0963124,
                33.7100392
              ],
              [
                47.0981012,
                33.7086729
              ],
              [
                47.0997762,
                33.7075095
              ],
              [
                47.1029473,
                33.7065626
              ],
              [
                47.1040368,
                33.706062
              ],
              [
                47.1059557,
                33.7064814
              ],
              [
                47.1074518,
                33.706292
              ],
              [
                47.1092244,
                33.705805
              ],
              [
                47.1096583,
                33.7045747
              ],
              [
                47.1104511,
                33.7033735
              ],
              [
                47.1116402,
                33.7025844
              ],
              [
                47.1144008,
                33.7031026
              ],
              [
                47.1167225,
                33.7033146
              ],
              [
                47.1174162,
                33.7034677
              ],
              [
                47.1190442,
                33.7035737
              ],
              [
                47.1218897,
                33.7034677
              ],
              [
                47.1232346,
                33.7035266
              ],
              [
                47.1243813,
                33.703715
              ],
              [
                47.1262642,
                33.7042097
              ],
              [
                47.1273967,
                33.7053167
              ],
              [
                47.1276091,
                33.7061647
              ],
              [
                47.1286425,
                33.7068595
              ],
              [
                47.1298175,
                33.7071775
              ],
              [
                47.1307094,
                33.7070244
              ],
              [
                47.1311341,
                33.7066004
              ],
              [
                47.13221,
                33.705882
              ],
              [
                47.1329037,
                33.7059291
              ],
              [
                47.1344043,
                33.7062942
              ],
              [
                47.1361456,
                33.7065768
              ],
              [
                47.1370233,
                33.7066475
              ],
              [
                47.1378727,
                33.7069773
              ],
              [
                47.1384673,
                33.7076132
              ],
              [
                47.1391327,
                33.7084022
              ],
              [
                47.1405342,
                33.7093326
              ],
              [
                47.1419357,
                33.7095799
              ],
              [
                47.1429833,
                33.7096152
              ],
              [
                47.1440451,
                33.7096859
              ],
              [
                47.1461262,
                33.708838
              ],
              [
                47.1472445,
                33.7082138
              ],
              [
                47.1487168,
                33.7082138
              ],
              [
                47.1498352,
                33.7076485
              ],
              [
                47.1509395,
                33.707201
              ],
              [
                47.1522844,
                33.7075072
              ],
              [
                47.153785,
                33.7077545
              ],
              [
                47.1545494,
                33.7070008
              ],
              [
                47.1555121,
                33.7062
              ],
              [
                47.156319,
                33.7063766
              ],
              [
                47.1571118,
                33.7068006
              ],
              [
                47.157494,
                33.7073306
              ],
              [
                47.1583576,
                33.707731
              ],
              [
                47.1587257,
                33.708414
              ],
              [
                47.1589664,
                33.7091324
              ],
              [
                47.1601414,
                33.709521
              ],
              [
                47.1618119,
                33.7098743
              ],
              [
                47.1635248,
                33.7103218
              ],
              [
                47.1650962,
                33.7105573
              ],
              [
                47.165889,
                33.7105927
              ],
              [
                47.1675737,
                33.7106398
              ],
              [
                47.1688903,
                33.7116408
              ],
              [
                47.1708439,
                33.7129832
              ],
              [
                47.1723587,
                33.7133247
              ],
              [
                47.1734346,
                33.7135956
              ],
              [
                47.1739725,
                33.7143728
              ],
              [
                47.1736611,
                33.7160685
              ],
              [
                47.1734629,
                33.7163511
              ],
              [
                47.1730948,
                33.7172578
              ],
              [
                47.1737036,
                33.7187886
              ],
              [
                47.1746662,
                33.720025
              ],
              [
                47.1761102,
                33.7215204
              ],
              [
                47.1766057,
                33.7217677
              ],
              [
                47.1775967,
                33.7221327
              ],
              [
                47.1787717,
                33.7225919
              ],
              [
                47.1801449,
                33.7232513
              ],
              [
                47.1807395,
                33.7236163
              ],
              [
                47.1812916,
                33.7239225
              ],
              [
                47.1814049,
                33.7254178
              ],
              [
                47.182594,
                33.7259476
              ],
              [
                47.1841796,
                33.7255591
              ],
              [
                47.1865155,
                33.7255473
              ],
              [
                47.1882426,
                33.7254531
              ],
              [
                47.1899839,
                33.7248526
              ],
              [
                47.1919233,
                33.72384
              ],
              [
                47.1940469,
                33.7228274
              ],
              [
                47.1950803,
                33.7219443
              ],
              [
                47.1965526,
                33.7211319
              ],
              [
                47.1980815,
                33.7203312
              ],
              [
                47.198931,
                33.7198484
              ],
              [
                47.2002617,
                33.7197424
              ],
              [
                47.2015075,
                33.719919
              ],
              [
                47.203447,
                33.720131
              ],
              [
                47.2049051,
                33.7203312
              ],
              [
                47.206519,
                33.7201545
              ],
              [
                47.2075949,
                33.7199426
              ],
              [
                47.2086991,
                33.7195069
              ],
              [
                47.2095061,
                33.7199073
              ],
              [
                47.2102847,
                33.7201663
              ],
              [
                47.2120826,
                33.7209435
              ],
              [
                47.2135832,
                33.7218266
              ],
              [
                47.2141353,
                33.7225095
              ],
              [
                47.21456,
                33.7233808
              ],
              [
                47.2146875,
                33.72384
              ],
              [
                47.2151122,
                33.7250293
              ],
              [
                47.2168534,
                33.7274783
              ],
              [
                47.2185947,
                33.7286204
              ],
              [
                47.2200246,
                33.7288794
              ],
              [
                47.2217517,
                33.729315
              ],
              [
                47.2240168,
                33.7303393
              ],
              [
                47.2254891,
                33.7309986
              ],
              [
                47.226565,
                33.7315167
              ],
              [
                47.2268481,
                33.732329
              ],
              [
                47.2272021,
                33.7328118
              ],
              [
                47.2282497,
                33.7327411
              ],
              [
                47.2305572,
                33.7320465
              ],
              [
                47.2331196,
                33.7311399
              ],
              [
                47.2358094,
                33.7303511
              ],
              [
                47.2377772,
                33.7302451
              ],
              [
                47.2388814,
                33.7303511
              ],
              [
                47.2408067,
                33.7306454
              ],
              [
                47.2420101,
                33.730669
              ],
              [
                47.2428311,
                33.7306925
              ],
              [
                47.2435956,
                33.7314931
              ],
              [
                47.2434399,
                33.7330825
              ],
              [
                47.2431284,
                33.7348367
              ],
              [
                47.2429302,
                33.7358728
              ],
              [
                47.2428878,
                33.7381684
              ],
              [
                47.2427604,
                33.7400638
              ],
              [
                47.2426613,
                33.7417708
              ],
              [
                47.2440345,
                33.7443959
              ],
              [
                47.245252,
                33.7449138
              ],
              [
                47.2471206,
                33.7460439
              ],
              [
                47.2477719,
                33.7463617
              ],
              [
                47.249315,
                33.7468444
              ],
              [
                47.2525427,
                33.7481039
              ],
              [
                47.2554165,
                33.7489161
              ],
              [
                47.2574268,
                33.7488102
              ],
              [
                47.2593521,
                33.7485394
              ],
              [
                47.2608952,
                33.7480568
              ],
              [
                47.2617305,
                33.747327
              ],
              [
                47.2620419,
                33.7466913
              ],
              [
                47.2623109,
                33.7458438
              ],
              [
                47.263132,
                33.7449727
              ],
              [
                47.2644627,
                33.7441487
              ],
              [
                47.2655386,
                33.7436778
              ],
              [
                47.2665721,
                33.7435248
              ],
              [
                47.2670959,
                33.7428302
              ],
              [
                47.267917,
                33.7419238
              ],
              [
                47.2683557,
                33.7414119
              ],
              [
                47.2687947,
                33.7408996
              ],
              [
                47.2695981,
                33.7403705
              ],
              [
                47.270525,
                33.7401271
              ],
              [
                47.2718422,
                33.7401406
              ],
              [
                47.2724602,
                33.7407221
              ],
              [
                47.2733871,
                33.7409114
              ],
              [
                47.2743303,
                33.7402894
              ],
              [
                47.2754198,
                33.7392616
              ],
              [
                47.2761679,
                33.7376659
              ],
              [
                47.2764118,
                33.7367463
              ],
              [
                47.276298,
                33.7357997
              ],
              [
                47.2758751,
                33.7354346
              ],
              [
                47.2753873,
                33.7350153
              ],
              [
                47.2750458,
                33.7347043
              ],
              [
                47.2750783,
                33.7336359
              ],
              [
                47.2754361,
                33.7327569
              ],
              [
                47.2761841,
                33.7321212
              ],
              [
                47.2771924,
                33.7317155
              ],
              [
                47.2789974,
                33.7319995
              ],
              [
                47.2815018,
                33.7328245
              ],
              [
                47.2834694,
                33.7331355
              ],
              [
                47.2860226,
                33.7330138
              ],
              [
                47.2891286,
                33.7326487
              ],
              [
                47.291828,
                33.7330814
              ],
              [
                47.293503,
                33.7329327
              ],
              [
                47.2947714,
                33.732581
              ],
              [
                47.2999265,
                33.7306877
              ],
              [
                47.3014876,
                33.7301873
              ],
              [
                47.302382,
                33.7290647
              ],
              [
                47.3028536,
                33.7279692
              ],
              [
                47.3041708,
                33.7266303
              ],
              [
                47.3053904,
                33.7259135
              ],
              [
                47.3060734,
                33.725697
              ],
              [
                47.3071467,
                33.7258864
              ],
              [
                47.3080737,
                33.7262245
              ],
              [
                47.3088217,
                33.726779
              ],
              [
                47.3091607,
                33.7270931
              ],
              [
                47.3095372,
                33.7274418
              ],
              [
                47.3107731,
                33.7284155
              ],
              [
                47.3124644,
                33.7297815
              ],
              [
                47.3138466,
                33.7307012
              ],
              [
                47.314985,
                33.7312422
              ],
              [
                47.3160745,
                33.731702
              ],
              [
                47.3166924,
                33.7317155
              ],
              [
                47.3177169,
                33.732013
              ],
              [
                47.3184813,
                33.7323376
              ],
              [
                47.3192781,
                33.7330003
              ],
              [
                47.3199611,
                33.7337982
              ],
              [
                47.3207742,
                33.7341498
              ],
              [
                47.3223353,
                33.7345285
              ],
              [
                47.3235062,
                33.734231
              ],
              [
                47.3243681,
                33.7338658
              ],
              [
                47.3250023,
                33.7330273
              ],
              [
                47.3257178,
                33.73227
              ],
              [
                47.326287,
                33.7315532
              ],
              [
                47.3275066,
                33.7309176
              ],
              [
                47.3294743,
                33.7306877
              ],
              [
                47.3309704,
                33.7313503
              ],
              [
                47.3324014,
                33.7317425
              ],
              [
                47.3343041,
                33.7319319
              ],
              [
                47.3362067,
                33.733095
              ],
              [
                47.3372149,
                33.7340281
              ],
              [
                47.3384996,
                33.734231
              ],
              [
                47.3402722,
                33.734285
              ],
              [
                47.3425326,
                33.7344068
              ],
              [
                47.3434595,
                33.7348666
              ],
              [
                47.3452971,
                33.7367193
              ],
              [
                47.346842,
                33.7378958
              ],
              [
                47.3476225,
                33.7388019
              ],
              [
                47.3490536,
                33.7382068
              ],
              [
                47.3500456,
                33.7367869
              ],
              [
                47.3511126,
                33.7354766
              ],
              [
                47.3512815,
                33.7344879
              ],
              [
                47.3521433,
                33.7330679
              ],
              [
                47.3550542,
                33.7321077
              ],
              [
                47.3574772,
                33.7323106
              ],
              [
                47.3588432,
                33.7325675
              ],
              [
                47.360632,
                33.732838
              ],
              [
                47.3619005,
                33.733406
              ],
              [
                47.3635104,
                33.7341228
              ],
              [
                47.3650553,
                33.7353669
              ],
              [
                47.3666652,
                33.7358808
              ],
              [
                47.3680312,
                33.7359485
              ],
              [
                47.3693972,
                33.7358944
              ],
              [
                47.3706006,
                33.735989
              ],
              [
                47.3722105,
                33.7353805
              ],
              [
                47.3728284,
                33.7352858
              ],
              [
                47.3729748,
                33.7358944
              ],
              [
                47.3732675,
                33.7369898
              ],
              [
                47.3734952,
                33.7375577
              ],
              [
                47.3742757,
                33.738031
              ],
              [
                47.3753816,
                33.7383556
              ],
              [
                47.3778859,
                33.7387748
              ],
              [
                47.3802113,
                33.7386531
              ],
              [
                47.3825368,
                33.7381257
              ],
              [
                47.3870413,
                33.7370438
              ],
              [
                47.3882447,
                33.7367193
              ],
              [
                47.3907002,
                33.7367058
              ],
              [
                47.3929281,
                33.7365435
              ],
              [
                47.3938713,
                33.7363406
              ],
              [
                47.3974814,
                33.7363271
              ],
              [
                47.4000183,
                33.7368951
              ],
              [
                47.4033195,
                33.7385855
              ],
              [
                47.4039211,
                33.739167
              ],
              [
                47.4048318,
                33.7397079
              ],
              [
                47.4063442,
                33.739451
              ],
              [
                47.4076939,
                33.7392887
              ],
              [
                47.4097429,
                33.7406274
              ],
              [
                47.4107837,
                33.7437376
              ],
              [
                47.4120683,
                33.7465908
              ],
              [
                47.4118732,
                33.7480241
              ],
              [
                47.4123285,
                33.749552
              ],
              [
                47.4128652,
                33.7502145
              ],
              [
                47.4134018,
                33.7507959
              ],
              [
                47.4143938,
                33.7511069
              ],
              [
                47.4178088,
                33.7542708
              ],
              [
                47.4196139,
                33.7548657
              ],
              [
                47.4206546,
                33.7549468
              ],
              [
                47.4220857,
                33.755055
              ],
              [
                47.4232565,
                33.7551632
              ],
              [
                47.4236468,
                33.7581376
              ],
              [
                47.4238094,
                33.7593409
              ],
              [
                47.4243623,
                33.7608551
              ],
              [
                47.425273,
                33.7617068
              ],
              [
                47.4253868,
                33.7624233
              ],
              [
                47.4228988,
                33.7647351
              ],
              [
                47.4226386,
                33.7658166
              ],
              [
                47.4232403,
                33.766817
              ],
              [
                47.4246062,
                33.7676551
              ],
              [
                47.4255657,
                33.768669
              ],
              [
                47.4259072,
                33.7695612
              ],
              [
                47.42633,
                33.7699127
              ],
              [
                47.426704,
                33.7701966
              ],
              [
                47.4282814,
                33.7703993
              ],
              [
                47.4292734,
                33.7704264
              ],
              [
                47.430363,
                33.7703858
              ],
              [
                47.4311273,
                33.7700479
              ],
              [
                47.4322331,
                33.7696018
              ],
              [
                47.4362498,
                33.7678444
              ],
              [
                47.4373393,
                33.7681688
              ],
              [
                47.4392907,
                33.7692638
              ],
              [
                47.4407055,
                33.7698316
              ],
              [
                47.4418601,
                33.7700208
              ],
              [
                47.4435676,
                33.7705886
              ],
              [
                47.4440229,
                33.771251
              ],
              [
                47.4444457,
                33.7717782
              ],
              [
                47.4452588,
                33.7726839
              ],
              [
                47.4455028,
                33.7741437
              ],
              [
                47.446511,
                33.7757523
              ],
              [
                47.4471127,
                33.7761308
              ],
              [
                47.4483323,
                33.7768202
              ],
              [
                47.4483811,
                33.7774825
              ],
              [
                47.4477144,
                33.7784963
              ],
              [
                47.4436001,
                33.7826728
              ],
              [
                47.4427708,
                33.7833081
              ],
              [
                47.4417951,
                33.784511
              ],
              [
                47.4416812,
                33.7859572
              ],
              [
                47.4414048,
                33.7869438
              ],
              [
                47.4411446,
                33.7874844
              ],
              [
                47.4403477,
                33.788025
              ],
              [
                47.4407706,
                33.7886738
              ],
              [
                47.4414048,
                33.7888495
              ],
              [
                47.4421203,
                33.7886738
              ],
              [
                47.4433237,
                33.7881061
              ],
              [
                47.4453401,
                33.7867681
              ],
              [
                47.4471289,
                33.7856598
              ],
              [
                47.4485112,
                33.7854571
              ],
              [
                47.4497634,
                33.7861599
              ],
              [
                47.4507553,
                33.7872952
              ],
              [
                47.4514871,
                33.7884575
              ],
              [
                47.4515522,
                33.7892819
              ],
              [
                47.4513408,
                33.7906064
              ],
              [
                47.4515522,
                33.7917822
              ],
              [
                47.4515684,
                33.7927012
              ],
              [
                47.4519912,
                33.7935661
              ],
              [
                47.4536825,
                33.7954446
              ],
              [
                47.4549997,
                33.7967419
              ],
              [
                47.4562031,
                33.7974447
              ],
              [
                47.4573577,
                33.7991203
              ],
              [
                47.4579431,
                33.8009582
              ],
              [
                47.4575691,
                33.801796
              ],
              [
                47.4562031,
                33.8046607
              ],
              [
                47.4556176,
                33.8061336
              ],
              [
                47.4550485,
                33.8064173
              ],
              [
                47.4545606,
                33.8073497
              ],
              [
                47.455081,
                33.8083901
              ],
              [
                47.4552761,
                33.8086468
              ],
              [
                47.4569023,
                33.8101196
              ],
              [
                47.4585448,
                33.8103628
              ],
              [
                47.459179,
                33.810498
              ],
              [
                47.46061,
                33.8107412
              ],
              [
                47.4631306,
                33.8114303
              ],
              [
                47.4640738,
                33.8115654
              ],
              [
                47.4649845,
                33.8118897
              ],
              [
                47.4658138,
                33.8125382
              ],
              [
                47.4661879,
                33.8129976
              ],
              [
                47.466692,
                33.8136596
              ],
              [
                47.4668383,
                33.8145244
              ],
              [
                47.4672286,
                33.8159565
              ],
              [
                47.468741,
                33.8171184
              ],
              [
                47.4706761,
                33.8179831
              ],
              [
                47.4713429,
                33.8193612
              ],
              [
                47.4719446,
                33.8201448
              ],
              [
                47.4728227,
                33.8209013
              ],
              [
                47.4743513,
                33.8214823
              ],
              [
                47.4750994,
                33.8221578
              ],
              [
                47.4752945,
                33.8227252
              ],
              [
                47.4763027,
                33.8238735
              ],
              [
                47.4768069,
                33.8242653
              ],
              [
                47.4782216,
                33.8252245
              ],
              [
                47.4793437,
                33.8258729
              ],
              [
                47.4798966,
                33.8264403
              ],
              [
                47.4799617,
                33.82744
              ],
              [
                47.4800267,
                33.8283991
              ],
              [
                47.4802869,
                33.8295744
              ],
              [
                47.4811712,
                33.8298749
              ],
              [
                47.4819212,
                33.8300414
              ],
              [
                47.4823957,
                33.8300793
              ],
              [
                47.4829864,
                33.8300201
              ],
              [
                47.4834048,
                33.8299104
              ],
              [
                47.4840071,
                33.8297313
              ],
              [
                47.4846614,
                33.8294123
              ],
              [
                47.4901579,
                33.8292502
              ],
              [
                47.4915048,
                33.8290254
              ],
              [
                47.4936216,
                33.8292502
              ],
              [
                47.4963802,
                33.8285861
              ],
              [
                47.4989777,
                33.8263445
              ],
              [
                47.4993133,
                33.8253325
              ],
              [
                47.5052668,
                33.8262366
              ],
              [
                47.5101274,
                33.8327624
              ],
              [
                47.5112007,
                33.8345859
              ],
              [
                47.5116786,
                33.8377159
              ],
              [
                47.5110219,
                33.8404092
              ],
              [
                47.5092005,
                33.8412991
              ],
              [
                47.5085477,
                33.8422826
              ],
              [
                47.5067578,
                33.8437197
              ],
              [
                47.5054115,
                33.8452835
              ],
              [
                47.5052326,
                33.8460534
              ],
              [
                47.5051838,
                33.8467152
              ],
              [
                47.5051838,
                33.8467422
              ],
              [
                47.5055579,
                33.8480658
              ],
              [
                47.5058181,
                33.8482684
              ],
              [
                47.5059319,
                33.8493758
              ],
              [
                47.5057855,
                33.8501861
              ],
              [
                47.5043618,
                33.8533165
              ],
              [
                47.50407,
                33.8554834
              ],
              [
                47.5063016,
                33.8576217
              ],
              [
                47.504585,
                33.8601876
              ],
              [
                47.5008084,
                33.8627534
              ],
              [
                47.4996325,
                33.8714766
              ],
              [
                47.5000703,
                33.8751253
              ],
              [
                47.5029885,
                33.8785458
              ],
              [
                47.5006368,
                33.8856998
              ],
              [
                47.5051857,
                33.8884519
              ],
              [
                47.5036065,
                33.8907443
              ],
              [
                47.5021817,
                33.8941072
              ],
              [
                47.5011517,
                33.8970994
              ],
              [
                47.4958302,
                33.8990942
              ],
              [
                47.4957787,
                33.9010605
              ],
              [
                47.4990403,
                33.9034826
              ],
              [
                47.5026452,
                33.9046224
              ],
              [
                47.5050484,
                33.9071868
              ],
              [
                47.4983537,
                33.9150223
              ],
              [
                47.4894788,
                33.9203215
              ],
              [
                47.4870755,
                33.9234553
              ],
              [
                47.4815823,
                33.9250221
              ],
              [
                47.4801576,
                33.9282697
              ],
              [
                47.4817025,
                33.929694
              ],
              [
                47.479222,
                33.9325924
              ],
              [
                47.4842774,
                33.9376698
              ],
              [
                47.4836423,
                33.9425403
              ],
              [
                47.4790056,
                33.9440778
              ],
              [
                47.4658092,
                33.9435362
              ],
              [
                47.4652526,
                33.943816
              ],
              [
                47.4630291,
                33.943816
              ],
              [
                47.4624725,
                33.9440957
              ],
              [
                47.4605291,
                33.9440957
              ],
              [
                47.455806,
                33.945206
              ],
              [
                47.4549728,
                33.945206
              ],
              [
                47.4544192,
                33.9454858
              ],
              [
                47.4524727,
                33.9460364
              ],
              [
                47.4383064,
                33.9504774
              ],
              [
                47.4371962,
                33.9510371
              ],
              [
                47.4308062,
                33.9518675
              ],
              [
                47.429973,
                33.9521474
              ],
              [
                47.4274733,
                33.9521473
              ],
              [
                47.4269163,
                33.9524271
              ],
              [
                47.4244163,
                33.9524271
              ],
              [
                47.4235834,
                33.9521473
              ],
              [
                47.4221927,
                33.9521474
              ],
              [
                47.4213599,
                33.9524271
              ],
              [
                47.4185833,
                33.9513169
              ],
              [
                47.4171934,
                33.9510371
              ],
              [
                47.4103898,
                33.9517217
              ],
              [
                47.4052584,
                33.9522074
              ],
              [
                47.4020165,
                33.9507483
              ],
              [
                47.3976269,
                33.9505547
              ],
              [
                47.3941737,
                33.9484303
              ],
              [
                47.3909445,
                33.9474609
              ],
              [
                47.3885393,
                33.9460523
              ],
              [
                47.3902911,
                33.9423288
              ],
              [
                47.3890235,
                33.9411189
              ],
              [
                47.3853922,
                33.9408508
              ],
              [
                47.3824711,
                33.9391127
              ],
              [
                47.3795043,
                33.9395527
              ],
              [
                47.3765331,
                33.9426555
              ],
              [
                47.3731877,
                33.946201
              ],
              [
                47.3715305,
                33.9487664
              ],
              [
                47.3691423,
                33.9505315
              ],
              [
                47.3581098,
                33.9547631
              ],
              [
                47.3526571,
                33.9572044
              ],
              [
                47.348001,
                33.96045
              ],
              [
                47.3465939,
                33.9619152
              ],
              [
                47.343142,
                33.9627689
              ],
              [
                47.3410643,
                33.9629317
              ],
              [
                47.3386381,
                33.9624189
              ],
              [
                47.3336814,
                33.9636933
              ],
              [
                47.3304791,
                33.9640947
              ],
              [
                47.3285205,
                33.9637552
              ],
              [
                47.3274673,
                33.9621485
              ],
              [
                47.326911,
                33.9621484
              ],
              [
                47.3266345,
                33.9624283
              ],
              [
                47.3255244,
                33.9624282
              ],
              [
                47.3248942,
                33.9623565
              ],
              [
                47.3235059,
                33.9633256
              ],
              [
                47.3221906,
                33.9632761
              ],
              [
                47.3210631,
                33.9633115
              ],
              [
                47.3196033,
                33.9629962
              ],
              [
                47.3190028,
                33.9626023
              ],
              [
                47.3184165,
                33.9617283
              ],
              [
                47.3162408,
                33.9610453
              ],
              [
                47.3149679,
                33.9571477
              ],
              [
                47.3144108,
                33.9560375
              ],
              [
                47.3133014,
                33.9527067
              ],
              [
                47.3196907,
                33.9390947
              ],
              [
                47.3505243,
                33.90965
              ],
              [
                47.3535805,
                33.9071497
              ],
              [
                47.3591377,
                33.9027085
              ],
              [
                47.3596909,
                33.9027085
              ],
              [
                47.3774702,
                33.8849259
              ],
              [
                47.379414,
                33.8818748
              ],
              [
                47.3819141,
                33.8777045
              ],
              [
                47.3821938,
                33.8765852
              ],
              [
                47.3830273,
                33.8752041
              ],
              [
                47.3830274,
                33.8740938
              ],
              [
                47.383304,
                33.873534
              ],
              [
                47.3835806,
                33.870474
              ],
              [
                47.3866369,
                33.8613118
              ],
              [
                47.3830275,
                33.8538105
              ],
              [
                47.380804,
                33.8527001
              ],
              [
                47.378861,
                33.85131
              ],
              [
                47.3724709,
                33.85131
              ],
              [
                47.3713608,
                33.8510302
              ],
              [
                47.3605239,
                33.8426982
              ],
              [
                47.3602473,
                33.8421476
              ],
              [
                47.3588574,
                33.839927
              ],
              [
                47.3441346,
                33.8168721
              ],
              [
                47.3435814,
                33.8165832
              ],
              [
                47.343301,
                33.8160326
              ],
              [
                47.3413579,
                33.8149222
              ],
              [
                47.3371915,
                33.8138118
              ],
              [
                47.3355243,
                33.8138119
              ],
              [
                47.3188583,
                33.8210335
              ],
              [
                47.3158012,
                33.8196433
              ],
              [
                47.3116348,
                33.8163123
              ],
              [
                47.3091347,
                33.8121418
              ],
              [
                47.308855,
                33.8018691
              ],
              [
                47.3077448,
                33.7963083
              ],
              [
                47.304412,
                33.791867
              ],
              [
                47.2952454,
                33.788536
              ],
              [
                47.2935782,
                33.7885359
              ],
              [
                47.2932985,
                33.7882561
              ],
              [
                47.2882985,
                33.7882561
              ],
              [
                47.2874656,
                33.788536
              ],
              [
                47.2852452,
                33.7885359
              ],
              [
                47.284132,
                33.7888157
              ],
              [
                47.2807991,
                33.7896462
              ],
              [
                47.2516328,
                33.8029792
              ],
              [
                47.2499656,
                33.80325
              ],
              [
                47.2491327,
                33.8038097
              ],
              [
                47.2460756,
                33.8038097
              ],
              [
                47.2452428,
                33.8040896
              ],
              [
                47.2444092,
                33.8040895
              ],
              [
                47.2438522,
                33.8043694
              ],
              [
                47.2391325,
                33.8043693
              ],
              [
                47.2380192,
                33.8040895
              ],
              [
                47.2360763,
                33.8040895
              ],
              [
                47.2346855,
                33.8038096
              ],
              [
                47.2341293,
                33.8038097
              ],
              [
                47.2335762,
                33.8038097
              ],
              [
                47.2310762,
                33.8035388
              ],
              [
                47.2307956,
                33.80325
              ],
              [
                47.2199626,
                33.8029792
              ],
              [
                47.2138531,
                33.8024284
              ],
              [
                47.2116296,
                33.8026992
              ],
              [
                47.2069061,
                33.8038096
              ],
              [
                47.1949628,
                33.8099208
              ],
              [
                47.1921831,
                33.8121416
              ],
              [
                47.1907964,
                33.8132609
              ],
              [
                47.1902401,
                33.8132609
              ],
              [
                47.189683,
                33.8138115
              ],
              [
                47.1832963,
                33.8157613
              ],
              [
                47.1777399,
                33.8165828
              ],
              [
                47.1771836,
                33.8168716
              ],
              [
                47.1677404,
                33.8168716
              ],
              [
                47.1602371,
                33.8163119
              ],
              [
                47.1546839,
                33.8154814
              ],
              [
                47.1532933,
                33.8154815
              ],
              [
                47.1521838,
                33.8152016
              ],
              [
                47.1499604,
                33.8152016
              ],
              [
                47.1471838,
                33.8146419
              ],
              [
                47.1402367,
                33.8146418
              ],
              [
                47.1396805,
                33.8143711
              ],
              [
                47.1374601,
                33.8146418
              ],
              [
                47.1299607,
                33.8199226
              ],
              [
                47.1296803,
                33.8202025
              ],
              [
                47.1269036,
                33.8232536
              ],
              [
                47.1269036,
                33.8238133
              ],
              [
                47.1127377,
                33.8385362
              ],
              [
                47.1094041,
                33.8402062
              ],
              [
                47.1063476,
                33.8404771
              ],
              [
                47.1024578,
                33.8368662
              ],
              [
                47.0996812,
                33.8304842
              ],
              [
                47.0994007,
                33.8299245
              ],
              [
                47.0960679,
                33.8254742
              ],
              [
                47.0946811,
                33.8249235
              ],
              [
                47.0938475,
                33.8249236
              ],
              [
                47.0927342,
                33.8243639
              ],
              [
                47.0905147,
                33.8243638
              ],
              [
                47.0521778,
                33.8332553
              ],
              [
                47.0471786,
                33.8318651
              ],
              [
                47.0466215,
                33.8318651
              ],
              [
                47.0443981,
                33.8302042
              ],
              [
                47.0399551,
                33.8238131
              ],
              [
                47.0307885,
                33.8143708
              ],
              [
                47.020789,
                33.8113106
              ],
              [
                47.0193984,
                33.8113106
              ],
              [
                47.0185656,
                33.8110307
              ],
              [
                47.0099521,
                33.8110307
              ],
              [
                47.004952,
                33.8099204
              ],
              [
                47.0043989,
                33.8102002
              ],
              [
                47.002452,
                33.8102002
              ],
              [
                46.9996072,
                33.8107508
              ],
              [
                46.9982855,
                33.8113105
              ],
              [
                46.9977324,
                33.8113105
              ],
              [
                46.9971753,
                33.8115904
              ],
              [
                46.9968988,
                33.805479
              ],
              [
                46.9977324,
                33.8007489
              ],
              [
                46.9977324,
                33.795477
              ],
              [
                46.998009,
                33.7951972
              ],
              [
                46.9995462,
                33.7865854
              ],
              [
                46.9991192,
                33.7835341
              ],
              [
                46.9988426,
                33.7818642
              ],
              [
                46.993566,
                33.7729724
              ],
              [
                46.9882862,
                33.7624196
              ],
              [
                46.9874527,
                33.7585289
              ],
              [
                46.9793962,
                33.7454754
              ],
              [
                46.9785626,
                33.7443651
              ],
              [
                46.9779031,
                33.7444803
              ],
              [
                46.9768178,
                33.7442498
              ],
              [
                46.9751694,
                33.7438986
              ],
              [
                46.9735402,
                33.7438572
              ],
              [
                46.971503,
                33.743197
              ],
              [
                46.9706703,
                33.7432359
              ],
              [
                46.969943,
                33.7433909
              ],
              [
                46.9686405,
                33.743944
              ],
              [
                46.9680749,
                33.7479871
              ],
              [
                46.9645137,
                33.7513768
              ],
              [
                46.9474686,
                33.7631416
              ],
              [
                46.9449834,
                33.7630144
              ],
              [
                46.943332,
                33.7636485
              ],
              [
                46.9428607,
                33.7637171
              ],
              [
                46.9413166,
                33.7639284
              ],
              [
                46.9405506,
                33.7639328
              ],
              [
                46.9393299,
                33.7641177
              ],
              [
                46.9376489,
                33.7646622
              ],
              [
                46.9363111,
                33.7650639
              ],
              [
                46.9352661,
                33.7655277
              ],
              [
                46.9341941,
                33.7662534
              ],
              [
                46.9329313,
                33.7667351
              ],
              [
                46.9293276,
                33.7682216
              ],
              [
                46.9247797,
                33.7698329
              ],
              [
                46.9206563,
                33.7712064
              ],
              [
                46.9189626,
                33.7715498
              ],
              [
                46.9172096,
                33.769461
              ],
              [
                46.9161996,
                33.767937
              ],
              [
                46.9149504,
                33.7651998
              ],
              [
                46.9146699,
                33.7649199
              ],
              [
                46.91467,
                33.7643693
              ],
              [
                46.9138371,
                33.7632499
              ],
              [
                46.9141168,
                33.7626992
              ],
              [
                46.9141168,
                33.761309
              ],
              [
                46.9132832,
                33.7576981
              ],
              [
                46.9005041,
                33.744085
              ],
              [
                46.9002275,
                33.7435343
              ],
              [
                46.8968939,
                33.7424149
              ],
              [
                46.8949469,
                33.7418643
              ],
              [
                46.8905891,
                33.7403185
              ],
              [
                46.8893569,
                33.7407478
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 13074214,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چوار",
          "ref:sci": "1612",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.69252,
                33.69097
              ],
              [
                45.694369,
                33.690172
              ],
              [
                45.69493,
                33.688975
              ],
              [
                45.694325,
                33.688311
              ],
              [
                45.694263,
                33.687667
              ],
              [
                45.694686,
                33.687044
              ],
              [
                45.694639,
                33.686327
              ],
              [
                45.694914,
                33.686336
              ],
              [
                45.695133,
                33.686247
              ],
              [
                45.695323,
                33.686109
              ],
              [
                45.695577,
                33.686046
              ],
              [
                45.695776,
                33.685917
              ],
              [
                45.695939,
                33.685643
              ],
              [
                45.696703,
                33.685207
              ],
              [
                45.696887,
                33.685071
              ],
              [
                45.697035,
                33.684881
              ],
              [
                45.697937,
                33.685029
              ],
              [
                45.698284,
                33.685209
              ],
              [
                45.698547,
                33.685198
              ],
              [
                45.698746,
                33.685157
              ],
              [
                45.698921,
                33.684837
              ],
              [
                45.699148,
                33.684686
              ],
              [
                45.699902,
                33.684328
              ],
              [
                45.699977,
                33.684181
              ],
              [
                45.699871,
                33.683985
              ],
              [
                45.699475,
                33.68358
              ],
              [
                45.69942,
                33.6834
              ],
              [
                45.699925,
                33.683094
              ],
              [
                45.700097,
                33.682637
              ],
              [
                45.700265,
                33.68251
              ],
              [
                45.70093,
                33.681793
              ],
              [
                45.701151,
                33.681627
              ],
              [
                45.701257,
                33.68119
              ],
              [
                45.701446,
                33.681025
              ],
              [
                45.701569,
                33.680819
              ],
              [
                45.70163,
                33.680473
              ],
              [
                45.701802,
                33.680318
              ],
              [
                45.702275,
                33.680061
              ],
              [
                45.702442,
                33.679825
              ],
              [
                45.702504,
                33.679484
              ],
              [
                45.702999,
                33.678797
              ],
              [
                45.70303,
                33.678244
              ],
              [
                45.702747,
                33.677685
              ],
              [
                45.705467,
                33.675232
              ],
              [
                45.705804,
                33.675031
              ],
              [
                45.706406,
                33.674978
              ],
              [
                45.706685,
                33.674828
              ],
              [
                45.706923,
                33.674866
              ],
              [
                45.707139,
                33.674811
              ],
              [
                45.708426,
                33.674939
              ],
              [
                45.708938,
                33.675068
              ],
              [
                45.709055,
                33.674973
              ],
              [
                45.70922,
                33.674753
              ],
              [
                45.709221,
                33.674365
              ],
              [
                45.70936,
                33.674101
              ],
              [
                45.70956,
                33.673797
              ],
              [
                45.70986,
                33.673604
              ],
              [
                45.71002,
                33.673281
              ],
              [
                45.710451,
                33.672799
              ],
              [
                45.710643,
                33.672492
              ],
              [
                45.710922,
                33.672423
              ],
              [
                45.711181,
                33.672206
              ],
              [
                45.711332,
                33.671983
              ],
              [
                45.711444,
                33.671676
              ],
              [
                45.712823,
                33.67108
              ],
              [
                45.713036,
                33.670905
              ],
              [
                45.713325,
                33.670435
              ],
              [
                45.714065,
                33.669747
              ],
              [
                45.714033,
                33.669229
              ],
              [
                45.714117,
                33.669003
              ],
              [
                45.714546,
                33.668516
              ],
              [
                45.714695,
                33.668239
              ],
              [
                45.714756,
                33.667937
              ],
              [
                45.714686,
                33.667754
              ],
              [
                45.714492,
                33.66751
              ],
              [
                45.714649,
                33.667281
              ],
              [
                45.714622,
                33.667151
              ],
              [
                45.714678,
                33.666969
              ],
              [
                45.714897,
                33.66671
              ],
              [
                45.715488,
                33.666712
              ],
              [
                45.715646,
                33.666663
              ],
              [
                45.716091,
                33.666406
              ],
              [
                45.716279,
                33.666263
              ],
              [
                45.716389,
                33.666103
              ],
              [
                45.716817,
                33.665812
              ],
              [
                45.717566,
                33.665573
              ],
              [
                45.717883,
                33.665567
              ],
              [
                45.718012,
                33.665491
              ],
              [
                45.718177,
                33.665292
              ],
              [
                45.71834,
                33.66492
              ],
              [
                45.718236,
                33.664433
              ],
              [
                45.718208,
                33.663911
              ],
              [
                45.718505,
                33.663474
              ],
              [
                45.718753,
                33.662361
              ],
              [
                45.719064,
                33.661992
              ],
              [
                45.719501,
                33.661837
              ],
              [
                45.719863,
                33.661609
              ],
              [
                45.72003,
                33.661283
              ],
              [
                45.721333,
                33.660389
              ],
              [
                45.721749,
                33.660393
              ],
              [
                45.734555,
                33.65563
              ],
              [
                45.7472521,
                33.6492352
              ],
              [
                45.77167,
                33.636936
              ],
              [
                45.772226,
                33.63028
              ],
              [
                45.772251,
                33.629472
              ],
              [
                45.771101,
                33.62401
              ],
              [
                45.770547,
                33.623853
              ],
              [
                45.769849,
                33.623542
              ],
              [
                45.76961,
                33.623303
              ],
              [
                45.769303,
                33.62285
              ],
              [
                45.768673,
                33.622459
              ],
              [
                45.767852,
                33.622121
              ],
              [
                45.767712,
                33.621968
              ],
              [
                45.767559,
                33.621547
              ],
              [
                45.767065,
                33.620633
              ],
              [
                45.767037,
                33.620474
              ],
              [
                45.767114,
                33.619733
              ],
              [
                45.766732,
                33.618901
              ],
              [
                45.766675,
                33.61856
              ],
              [
                45.766473,
                33.618049
              ],
              [
                45.766259,
                33.61773
              ],
              [
                45.766095,
                33.617322
              ],
              [
                45.766057,
                33.617107
              ],
              [
                45.766278,
                33.616577
              ],
              [
                45.766269,
                33.616297
              ],
              [
                45.765976,
                33.615587
              ],
              [
                45.765584,
                33.615087
              ],
              [
                45.764573,
                33.614418
              ],
              [
                45.763776,
                33.614133
              ],
              [
                45.762984,
                33.613959
              ],
              [
                45.76269,
                33.613956
              ],
              [
                45.761887,
                33.614067
              ],
              [
                45.761058,
                33.613978
              ],
              [
                45.760785,
                33.61377
              ],
              [
                45.759837,
                33.6133
              ],
              [
                45.759548,
                33.613314
              ],
              [
                45.759273,
                33.613236
              ],
              [
                45.759001,
                33.612958
              ],
              [
                45.758801,
                33.612641
              ],
              [
                45.758587,
                33.611633
              ],
              [
                45.758589,
                33.610725
              ],
              [
                45.758442,
                33.610162
              ],
              [
                45.757747,
                33.609108
              ],
              [
                45.757579,
                33.608613
              ],
              [
                45.757544,
                33.608226
              ],
              [
                45.757619,
                33.607686
              ],
              [
                45.757573,
                33.607243
              ],
              [
                45.757289,
                33.60599
              ],
              [
                45.757107,
                33.60465
              ],
              [
                45.756904,
                33.604093
              ],
              [
                45.756141,
                33.602752
              ],
              [
                45.75565,
                33.602185
              ],
              [
                45.755184,
                33.601542
              ],
              [
                45.754731,
                33.600642
              ],
              [
                45.754585,
                33.600243
              ],
              [
                45.754724,
                33.598259
              ],
              [
                45.754488,
                33.598009
              ],
              [
                45.754262,
                33.597444
              ],
              [
                45.754068,
                33.596502
              ],
              [
                45.753842,
                33.596261
              ],
              [
                45.7537,
                33.595991
              ],
              [
                45.753268,
                33.593209
              ],
              [
                45.753165,
                33.592917
              ],
              [
                45.757549,
                33.594418
              ],
              [
                45.774864,
                33.602428
              ],
              [
                45.788923,
                33.607525
              ],
              [
                45.80002,
                33.612864
              ],
              [
                45.801702,
                33.612672
              ],
              [
                45.801872,
                33.612719
              ],
              [
                45.802312,
                33.61315
              ],
              [
                45.803229,
                33.613909
              ],
              [
                45.803491,
                33.61406
              ],
              [
                45.803911,
                33.614077
              ],
              [
                45.804493,
                33.61459
              ],
              [
                45.804728,
                33.614699
              ],
              [
                45.805057,
                33.615089
              ],
              [
                45.805854,
                33.615256
              ],
              [
                45.80651,
                33.615318
              ],
              [
                45.806765,
                33.615517
              ],
              [
                45.807687,
                33.615946
              ],
              [
                45.808073,
                33.616176
              ],
              [
                45.80909,
                33.617027
              ],
              [
                45.809169,
                33.617187
              ],
              [
                45.809443,
                33.617471
              ],
              [
                45.809709,
                33.617632
              ],
              [
                45.81012,
                33.617987
              ],
              [
                45.810409,
                33.618109
              ],
              [
                45.810648,
                33.618394
              ],
              [
                45.811218,
                33.618844
              ],
              [
                45.811611,
                33.619256
              ],
              [
                45.811883,
                33.619416
              ],
              [
                45.812288,
                33.619819
              ],
              [
                45.812669,
                33.619962
              ],
              [
                45.812874,
                33.62009
              ],
              [
                45.812792,
                33.620584
              ],
              [
                45.812716,
                33.620753
              ],
              [
                45.812734,
                33.620949
              ],
              [
                45.81256,
                33.621398
              ],
              [
                45.812446,
                33.621446
              ],
              [
                45.812412,
                33.621589
              ],
              [
                45.812501,
                33.622288
              ],
              [
                45.812309,
                33.622564
              ],
              [
                45.812309,
                33.622682
              ],
              [
                45.8124,
                33.623269
              ],
              [
                45.81249,
                33.623374
              ],
              [
                45.812409,
                33.623756
              ],
              [
                45.812571,
                33.62391
              ],
              [
                45.812849,
                33.623928
              ],
              [
                45.812862,
                33.624243
              ],
              [
                45.812796,
                33.624469
              ],
              [
                45.812784,
                33.624796
              ],
              [
                45.812962,
                33.625094
              ],
              [
                45.812987,
                33.625353
              ],
              [
                45.812855,
                33.625688
              ],
              [
                45.81293,
                33.625789
              ],
              [
                45.812906,
                33.626218
              ],
              [
                45.81325,
                33.627412
              ],
              [
                45.813437,
                33.627619
              ],
              [
                45.813807,
                33.627729
              ],
              [
                45.814225,
                33.627965
              ],
              [
                45.814546,
                33.628215
              ],
              [
                45.814716,
                33.628415
              ],
              [
                45.81507,
                33.628428
              ],
              [
                45.815253,
                33.628372
              ],
              [
                45.815835,
                33.628425
              ],
              [
                45.816703,
                33.628248
              ],
              [
                45.817151,
                33.627941
              ],
              [
                45.817389,
                33.62772
              ],
              [
                45.817901,
                33.627411
              ],
              [
                45.818396,
                33.627436
              ],
              [
                45.819125,
                33.627341
              ],
              [
                45.819567,
                33.627453
              ],
              [
                45.819843,
                33.627466
              ],
              [
                45.820297,
                33.627658
              ],
              [
                45.820979,
                33.62762
              ],
              [
                45.821154,
                33.627653
              ],
              [
                45.821562,
                33.627585
              ],
              [
                45.82203,
                33.62771
              ],
              [
                45.822481,
                33.627732
              ],
              [
                45.822711,
                33.627872
              ],
              [
                45.822883,
                33.627894
              ],
              [
                45.823089,
                33.628004
              ],
              [
                45.82328,
                33.628046
              ],
              [
                45.823371,
                33.628291
              ],
              [
                45.823526,
                33.628441
              ],
              [
                45.824531,
                33.628818
              ],
              [
                45.824676,
                33.628781
              ],
              [
                45.825296,
                33.628291
              ],
              [
                45.825292,
                33.628139
              ],
              [
                45.825421,
                33.627752
              ],
              [
                45.82541,
                33.627578
              ],
              [
                45.825804,
                33.627259
              ],
              [
                45.826848,
                33.627097
              ],
              [
                45.827193,
                33.627101
              ],
              [
                45.827644,
                33.627193
              ],
              [
                45.827922,
                33.627188
              ],
              [
                45.828189,
                33.626878
              ],
              [
                45.828873,
                33.626386
              ],
              [
                45.828922,
                33.626152
              ],
              [
                45.829062,
                33.626005
              ],
              [
                45.829256,
                33.625916
              ],
              [
                45.829981,
                33.625834
              ],
              [
                45.830198,
                33.62577
              ],
              [
                45.830751,
                33.625871
              ],
              [
                45.831344,
                33.625775
              ],
              [
                45.832055,
                33.625348
              ],
              [
                45.832861,
                33.625637
              ],
              [
                45.833419,
                33.625613
              ],
              [
                45.833938,
                33.62512
              ],
              [
                45.834519,
                33.625009
              ],
              [
                45.834953,
                33.625071
              ],
              [
                45.835224,
                33.624954
              ],
              [
                45.835546,
                33.62491
              ],
              [
                45.835806,
                33.625031
              ],
              [
                45.836619,
                33.624907
              ],
              [
                45.836952,
                33.625148
              ],
              [
                45.837372,
                33.625277
              ],
              [
                45.838378,
                33.625406
              ],
              [
                45.838755,
                33.625332
              ],
              [
                45.839055,
                33.625169
              ],
              [
                45.839352,
                33.625112
              ],
              [
                45.839705,
                33.625279
              ],
              [
                45.840028,
                33.625304
              ],
              [
                45.840599,
                33.625554
              ],
              [
                45.841412,
                33.625636
              ],
              [
                45.841781,
                33.625717
              ],
              [
                45.842323,
                33.626056
              ],
              [
                45.843346,
                33.626351
              ],
              [
                45.843394,
                33.626506
              ],
              [
                45.843604,
                33.62665
              ],
              [
                45.84415,
                33.626888
              ],
              [
                45.844252,
                33.627031
              ],
              [
                45.844244,
                33.62721
              ],
              [
                45.844349,
                33.627317
              ],
              [
                45.845389,
                33.627786
              ],
              [
                45.845691,
                33.628063
              ],
              [
                45.84663,
                33.62846
              ],
              [
                45.847074,
                33.628436
              ],
              [
                45.847427,
                33.628262
              ],
              [
                45.848054,
                33.628182
              ],
              [
                45.848389,
                33.628294
              ],
              [
                45.848535,
                33.628463
              ],
              [
                45.848732,
                33.628545
              ],
              [
                45.848912,
                33.628548
              ],
              [
                45.849322,
                33.628349
              ],
              [
                45.849477,
                33.628776
              ],
              [
                45.849764,
                33.628868
              ],
              [
                45.850063,
                33.628864
              ],
              [
                45.85038,
                33.628803
              ],
              [
                45.850638,
                33.628689
              ],
              [
                45.850752,
                33.628506
              ],
              [
                45.851241,
                33.628444
              ],
              [
                45.851408,
                33.628474
              ],
              [
                45.851628,
                33.628445
              ],
              [
                45.851837,
                33.628336
              ],
              [
                45.852303,
                33.628314
              ],
              [
                45.8527,
                33.628189
              ],
              [
                45.852999,
                33.628184
              ],
              [
                45.85351,
                33.628447
              ],
              [
                45.85368,
                33.628623
              ],
              [
                45.853824,
                33.628899
              ],
              [
                45.854018,
                33.629087
              ],
              [
                45.854043,
                33.629306
              ],
              [
                45.854137,
                33.629492
              ],
              [
                45.854374,
                33.629701
              ],
              [
                45.85491,
                33.629882
              ],
              [
                45.855205,
                33.630114
              ],
              [
                45.8555,
                33.630211
              ],
              [
                45.855851,
                33.630143
              ],
              [
                45.856197,
                33.629922
              ],
              [
                45.85654,
                33.629808
              ],
              [
                45.856757,
                33.629815
              ],
              [
                45.856876,
                33.629943
              ],
              [
                45.85685,
                33.63009
              ],
              [
                45.857324,
                33.630508
              ],
              [
                45.857445,
                33.630871
              ],
              [
                45.857641,
                33.631065
              ],
              [
                45.857738,
                33.631327
              ],
              [
                45.857739,
                33.631651
              ],
              [
                45.857842,
                33.631776
              ],
              [
                45.857829,
                33.631962
              ],
              [
                45.858349,
                33.632458
              ],
              [
                45.858485,
                33.632529
              ],
              [
                45.858673,
                33.63249
              ],
              [
                45.858946,
                33.632538
              ],
              [
                45.860205,
                33.63249
              ],
              [
                45.861069,
                33.632371
              ],
              [
                45.861565,
                33.632514
              ],
              [
                45.862465,
                33.632165
              ],
              [
                45.862826,
                33.631947
              ],
              [
                45.863067,
                33.631872
              ],
              [
                45.86379,
                33.632079
              ],
              [
                45.864452,
                33.63241
              ],
              [
                45.865108,
                33.632907
              ],
              [
                45.866123,
                33.633888
              ],
              [
                45.867173,
                33.633907
              ],
              [
                45.86815,
                33.633965
              ],
              [
                45.868645,
                33.634037
              ],
              [
                45.869143,
                33.634003
              ],
              [
                45.869387,
                33.634075
              ],
              [
                45.869972,
                33.634139
              ],
              [
                45.870093,
                33.634043
              ],
              [
                45.870301,
                33.633976
              ],
              [
                45.870654,
                33.634077
              ],
              [
                45.870817,
                33.634025
              ],
              [
                45.87142,
                33.634169
              ],
              [
                45.871543,
                33.634266
              ],
              [
                45.871693,
                33.634517
              ],
              [
                45.872187,
                33.634631
              ],
              [
                45.872516,
                33.634608
              ],
              [
                45.872757,
                33.634463
              ],
              [
                45.873023,
                33.634466
              ],
              [
                45.873219,
                33.634589
              ],
              [
                45.873757,
                33.634434
              ],
              [
                45.873984,
                33.634451
              ],
              [
                45.874215,
                33.634572
              ],
              [
                45.874679,
                33.634409
              ],
              [
                45.875384,
                33.63426
              ],
              [
                45.875643,
                33.634288
              ],
              [
                45.875826,
                33.634414
              ],
              [
                45.875983,
                33.634434
              ],
              [
                45.876204,
                33.634181
              ],
              [
                45.87631,
                33.634153
              ],
              [
                45.877274,
                33.634102
              ],
              [
                45.877739,
                33.633986
              ],
              [
                45.877939,
                33.633962
              ],
              [
                45.878232,
                33.634006
              ],
              [
                45.878866,
                33.633907
              ],
              [
                45.879828,
                33.633527
              ],
              [
                45.879941,
                33.633615
              ],
              [
                45.880137,
                33.633667
              ],
              [
                45.880315,
                33.633665
              ],
              [
                45.880494,
                33.633598
              ],
              [
                45.880607,
                33.633662
              ],
              [
                45.881195,
                33.633573
              ],
              [
                45.881634,
                33.633604
              ],
              [
                45.881829,
                33.633474
              ],
              [
                45.882577,
                33.633416
              ],
              [
                45.882827,
                33.633299
              ],
              [
                45.883197,
                33.633385
              ],
              [
                45.883351,
                33.633282
              ],
              [
                45.88357,
                33.633342
              ],
              [
                45.883985,
                33.633366
              ],
              [
                45.884099,
                33.633477
              ],
              [
                45.884247,
                33.63354
              ],
              [
                45.884381,
                33.633441
              ],
              [
                45.884602,
                33.633394
              ],
              [
                45.884775,
                33.633464
              ],
              [
                45.884836,
                33.633616
              ],
              [
                45.885405,
                33.633873
              ],
              [
                45.885679,
                33.634086
              ],
              [
                45.886046,
                33.634072
              ],
              [
                45.886243,
                33.633901
              ],
              [
                45.886443,
                33.633877
              ],
              [
                45.88664,
                33.633982
              ],
              [
                45.887057,
                33.634422
              ],
              [
                45.887268,
                33.634819
              ],
              [
                45.887519,
                33.634913
              ],
              [
                45.887768,
                33.635113
              ],
              [
                45.887884,
                33.635324
              ],
              [
                45.887911,
                33.635571
              ],
              [
                45.887769,
                33.635848
              ],
              [
                45.887528,
                33.636058
              ],
              [
                45.887559,
                33.636681
              ],
              [
                45.887776,
                33.636735
              ],
              [
                45.888438,
                33.636565
              ],
              [
                45.889425,
                33.636385
              ],
              [
                45.889976,
                33.636362
              ],
              [
                45.890782,
                33.636402
              ],
              [
                45.891207,
                33.636365
              ],
              [
                45.89169,
                33.636286
              ],
              [
                45.892075,
                33.636168
              ],
              [
                45.892318,
                33.63617
              ],
              [
                45.892655,
                33.636057
              ],
              [
                45.893848,
                33.636009
              ],
              [
                45.89413,
                33.635949
              ],
              [
                45.894707,
                33.636033
              ],
              [
                45.894936,
                33.635983
              ],
              [
                45.895269,
                33.635834
              ],
              [
                45.895991,
                33.635679
              ],
              [
                45.896226,
                33.635736
              ],
              [
                45.896491,
                33.635994
              ],
              [
                45.897035,
                33.635797
              ],
              [
                45.89747,
                33.635769
              ],
              [
                45.898402,
                33.6358
              ],
              [
                45.898884,
                33.635651
              ],
              [
                45.899732,
                33.635618
              ],
              [
                45.899951,
                33.635701
              ],
              [
                45.900958,
                33.635539
              ],
              [
                45.901177,
                33.635599
              ],
              [
                45.901793,
                33.636033
              ],
              [
                45.901998,
                33.636389
              ],
              [
                45.901966,
                33.636631
              ],
              [
                45.902214,
                33.636849
              ],
              [
                45.903085,
                33.637188
              ],
              [
                45.903483,
                33.637409
              ],
              [
                45.903662,
                33.637683
              ],
              [
                45.903833,
                33.637841
              ],
              [
                45.904543,
                33.637984
              ],
              [
                45.904782,
                33.638128
              ],
              [
                45.905417,
                33.63801
              ],
              [
                45.906055,
                33.638175
              ],
              [
                45.906321,
                33.638089
              ],
              [
                45.907062,
                33.638097
              ],
              [
                45.916596,
                33.627614
              ],
              [
                45.905254,
                33.606284
              ],
              [
                45.906479,
                33.606088
              ],
              [
                45.906845,
                33.606163
              ],
              [
                45.907174,
                33.606163
              ],
              [
                45.908308,
                33.605811
              ],
              [
                45.909013,
                33.605755
              ],
              [
                45.909345,
                33.605673
              ],
              [
                45.910524,
                33.605081
              ],
              [
                45.910914,
                33.605115
              ],
              [
                45.911654,
                33.605011
              ],
              [
                45.912097,
                33.604852
              ],
              [
                45.912321,
                33.604675
              ],
              [
                45.913501,
                33.604313
              ],
              [
                45.913988,
                33.604109
              ],
              [
                45.914486,
                33.604056
              ],
              [
                45.915294,
                33.603508
              ],
              [
                45.915568,
                33.603267
              ],
              [
                45.915806,
                33.603205
              ],
              [
                45.916092,
                33.603203
              ],
              [
                45.91657,
                33.602972
              ],
              [
                45.916996,
                33.60294
              ],
              [
                45.91719,
                33.602875
              ],
              [
                45.917874,
                33.602436
              ],
              [
                45.918404,
                33.602164
              ],
              [
                45.918586,
                33.601766
              ],
              [
                45.919277,
                33.601643
              ],
              [
                45.919604,
                33.601362
              ],
              [
                45.91994,
                33.601273
              ],
              [
                45.920157,
                33.601121
              ],
              [
                45.920352,
                33.600785
              ],
              [
                45.920567,
                33.600557
              ],
              [
                45.920946,
                33.600329
              ],
              [
                45.92134,
                33.599945
              ],
              [
                45.921562,
                33.599651
              ],
              [
                45.9229,
                33.599061
              ],
              [
                45.923206,
                33.599149
              ],
              [
                45.923596,
                33.599001
              ],
              [
                45.923748,
                33.598733
              ],
              [
                45.924083,
                33.598456
              ],
              [
                45.924131,
                33.598175
              ],
              [
                45.924479,
                33.597825
              ],
              [
                45.925022,
                33.597757
              ],
              [
                45.925865,
                33.597436
              ],
              [
                45.926463,
                33.59688
              ],
              [
                45.926459,
                33.596686
              ],
              [
                45.926591,
                33.596423
              ],
              [
                45.926862,
                33.596353
              ],
              [
                45.927091,
                33.596399
              ],
              [
                45.927635,
                33.596377
              ],
              [
                45.927906,
                33.596284
              ],
              [
                45.928571,
                33.596261
              ],
              [
                45.928673,
                33.596086
              ],
              [
                45.929142,
                33.595621
              ],
              [
                45.929461,
                33.595566
              ],
              [
                45.929688,
                33.595264
              ],
              [
                45.929857,
                33.59514
              ],
              [
                45.930083,
                33.595063
              ],
              [
                45.930244,
                33.594917
              ],
              [
                45.930423,
                33.594596
              ],
              [
                45.930744,
                33.594481
              ],
              [
                45.930794,
                33.594253
              ],
              [
                45.93075,
                33.594068
              ],
              [
                45.931202,
                33.593801
              ],
              [
                45.931677,
                33.593765
              ],
              [
                45.931915,
                33.593655
              ],
              [
                45.932707,
                33.593446
              ],
              [
                45.933136,
                33.593149
              ],
              [
                45.93334,
                33.59307
              ],
              [
                45.933858,
                33.592601
              ],
              [
                45.934068,
                33.592268
              ],
              [
                45.934375,
                33.592038
              ],
              [
                45.934514,
                33.591844
              ],
              [
                45.934672,
                33.591481
              ],
              [
                45.935084,
                33.591087
              ],
              [
                45.935241,
                33.590789
              ],
              [
                45.93565,
                33.590337
              ],
              [
                45.935964,
                33.590064
              ],
              [
                45.936098,
                33.589807
              ],
              [
                45.936543,
                33.589494
              ],
              [
                45.937169,
                33.588843
              ],
              [
                45.937479,
                33.588625
              ],
              [
                45.937826,
                33.588251
              ],
              [
                45.937975,
                33.587678
              ],
              [
                45.938115,
                33.587395
              ],
              [
                45.938313,
                33.587206
              ],
              [
                45.938617,
                33.587035
              ],
              [
                45.938768,
                33.586673
              ],
              [
                45.939044,
                33.586527
              ],
              [
                45.939224,
                33.586371
              ],
              [
                45.939424,
                33.586075
              ],
              [
                45.939866,
                33.585752
              ],
              [
                45.940121,
                33.585333
              ],
              [
                45.940136,
                33.585153
              ],
              [
                45.940303,
                33.584935
              ],
              [
                45.940352,
                33.584748
              ],
              [
                45.940666,
                33.584587
              ],
              [
                45.940916,
                33.584358
              ],
              [
                45.941036,
                33.584309
              ],
              [
                45.941405,
                33.583912
              ],
              [
                45.941536,
                33.58369
              ],
              [
                45.941714,
                33.583553
              ],
              [
                45.942032,
                33.583403
              ],
              [
                45.942112,
                33.583227
              ],
              [
                45.942178,
                33.582819
              ],
              [
                45.942448,
                33.582473
              ],
              [
                45.942621,
                33.582342
              ],
              [
                45.943165,
                33.582091
              ],
              [
                45.94343,
                33.581705
              ],
              [
                45.943878,
                33.581333
              ],
              [
                45.944126,
                33.581234
              ],
              [
                45.944675,
                33.580705
              ],
              [
                45.94478,
                33.580471
              ],
              [
                45.944998,
                33.580324
              ],
              [
                45.945333,
                33.58023
              ],
              [
                45.945547,
                33.579543
              ],
              [
                45.94554,
                33.579409
              ],
              [
                45.945368,
                33.579246
              ],
              [
                45.945159,
                33.578854
              ],
              [
                45.944947,
                33.578682
              ],
              [
                45.945111,
                33.578335
              ],
              [
                45.945389,
                33.578129
              ],
              [
                45.945529,
                33.57787
              ],
              [
                45.945598,
                33.577543
              ],
              [
                45.945841,
                33.57688
              ],
              [
                45.946882,
                33.575711
              ],
              [
                45.947137,
                33.575269
              ],
              [
                45.947444,
                33.575109
              ],
              [
                45.948065,
                33.575036
              ],
              [
                45.94837,
                33.574871
              ],
              [
                45.948458,
                33.574717
              ],
              [
                45.948291,
                33.574346
              ],
              [
                45.948579,
                33.574168
              ],
              [
                45.948745,
                33.573968
              ],
              [
                45.949288,
                33.573923
              ],
              [
                45.949439,
                33.573696
              ],
              [
                45.949389,
                33.57356
              ],
              [
                45.949436,
                33.573415
              ],
              [
                45.949719,
                33.572972
              ],
              [
                45.949708,
                33.572733
              ],
              [
                45.950003,
                33.572417
              ],
              [
                45.949852,
                33.572073
              ],
              [
                45.949912,
                33.571901
              ],
              [
                45.950032,
                33.571758
              ],
              [
                45.950685,
                33.57129
              ],
              [
                45.951051,
                33.570677
              ],
              [
                45.951469,
                33.570164
              ],
              [
                45.951802,
                33.569334
              ],
              [
                45.951761,
                33.568884
              ],
              [
                45.952155,
                33.568683
              ],
              [
                45.953049,
                33.568022
              ],
              [
                45.953392,
                33.56802
              ],
              [
                45.95367,
                33.568108
              ],
              [
                45.953925,
                33.568283
              ],
              [
                45.954149,
                33.568541
              ],
              [
                45.9546,
                33.568681
              ],
              [
                45.955558,
                33.569113
              ],
              [
                45.955898,
                33.569146
              ],
              [
                45.956361,
                33.569071
              ],
              [
                45.957062,
                33.569076
              ],
              [
                45.957254,
                33.569029
              ],
              [
                45.957684,
                33.568779
              ],
              [
                45.957902,
                33.568744
              ],
              [
                45.958089,
                33.568522
              ],
              [
                45.958333,
                33.568388
              ],
              [
                45.958467,
                33.56813
              ],
              [
                45.958698,
                33.568069
              ],
              [
                45.958845,
                33.567761
              ],
              [
                45.958906,
                33.567413
              ],
              [
                45.959034,
                33.56725
              ],
              [
                45.959275,
                33.567105
              ],
              [
                45.959241,
                33.566541
              ],
              [
                45.959383,
                33.566446
              ],
              [
                45.959189,
                33.56574
              ],
              [
                45.959382,
                33.565441
              ],
              [
                45.959841,
                33.565219
              ],
              [
                45.959866,
                33.565026
              ],
              [
                45.959753,
                33.564756
              ],
              [
                45.959534,
                33.564467
              ],
              [
                45.959487,
                33.564206
              ],
              [
                45.959576,
                33.564034
              ],
              [
                45.960394,
                33.56379
              ],
              [
                45.960682,
                33.563252
              ],
              [
                45.961139,
                33.563272
              ],
              [
                45.961238,
                33.562904
              ],
              [
                45.961223,
                33.562719
              ],
              [
                45.961136,
                33.562443
              ],
              [
                45.960737,
                33.561787
              ],
              [
                45.961002,
                33.56133
              ],
              [
                45.96053,
                33.56106
              ],
              [
                45.96024,
                33.560751
              ],
              [
                45.959577,
                33.560392
              ],
              [
                45.959321,
                33.560146
              ],
              [
                45.959091,
                33.559824
              ],
              [
                45.959068,
                33.559635
              ],
              [
                45.959172,
                33.559513
              ],
              [
                45.959113,
                33.559325
              ],
              [
                45.958877,
                33.559052
              ],
              [
                45.958642,
                33.558643
              ],
              [
                45.958257,
                33.558307
              ],
              [
                45.95773,
                33.557583
              ],
              [
                45.957236,
                33.557147
              ],
              [
                45.957082,
                33.557045
              ],
              [
                45.956922,
                33.557014
              ],
              [
                45.95679,
                33.556889
              ],
              [
                45.95676,
                33.556748
              ],
              [
                45.956804,
                33.556592
              ],
              [
                45.957048,
                33.556346
              ],
              [
                45.957217,
                33.556292
              ],
              [
                45.956975,
                33.555543
              ],
              [
                45.957087,
                33.555355
              ],
              [
                45.956772,
                33.555169
              ],
              [
                45.956664,
                33.555009
              ],
              [
                45.95641,
                33.554904
              ],
              [
                45.956143,
                33.554626
              ],
              [
                45.955591,
                33.55462
              ],
              [
                45.955496,
                33.554522
              ],
              [
                45.955464,
                33.554329
              ],
              [
                45.955715,
                33.553828
              ],
              [
                45.95553,
                33.553515
              ],
              [
                45.955096,
                33.553089
              ],
              [
                45.954618,
                33.552385
              ],
              [
                45.953779,
                33.551898
              ],
              [
                45.953524,
                33.551587
              ],
              [
                45.953352,
                33.551018
              ],
              [
                45.953637,
                33.550581
              ],
              [
                45.953392,
                33.550303
              ],
              [
                45.953244,
                33.550035
              ],
              [
                45.953109,
                33.549516
              ],
              [
                45.952797,
                33.549318
              ],
              [
                45.952416,
                33.548834
              ],
              [
                45.952385,
                33.548529
              ],
              [
                45.952233,
                33.548296
              ],
              [
                45.951983,
                33.548114
              ],
              [
                45.951524,
                33.547223
              ],
              [
                45.950886,
                33.546464
              ],
              [
                45.950846,
                33.546314
              ],
              [
                45.950739,
                33.546225
              ],
              [
                45.950585,
                33.546122
              ],
              [
                45.950295,
                33.546019
              ],
              [
                45.950038,
                33.545791
              ],
              [
                45.949648,
                33.545757
              ],
              [
                45.949422,
                33.545628
              ],
              [
                45.949298,
                33.54546
              ],
              [
                45.948653,
                33.545068
              ],
              [
                45.94839,
                33.544712
              ],
              [
                45.94811,
                33.544912
              ],
              [
                45.947683,
                33.545095
              ],
              [
                45.947603,
                33.545262
              ],
              [
                45.947277,
                33.545378
              ],
              [
                45.946961,
                33.545312
              ],
              [
                45.924458,
                33.530826
              ],
              [
                45.895249,
                33.512558
              ],
              [
                45.863003,
                33.493148
              ],
              [
                45.873505,
                33.493841
              ],
              [
                45.8747964,
                33.4930667
              ],
              [
                45.8760066,
                33.4939496
              ],
              [
                45.8829582,
                33.4982495
              ],
              [
                45.884348,
                33.4985204
              ],
              [
                45.8899044,
                33.4976898
              ],
              [
                45.893238,
                33.4976898
              ],
              [
                45.8968475,
                33.5001905
              ],
              [
                45.8993476,
                33.5001905
              ],
              [
                45.9007375,
                33.499351
              ],
              [
                45.9060142,
                33.4968593
              ],
              [
                45.9079611,
                33.4960196
              ],
              [
                45.9093478,
                33.4957488
              ],
              [
                45.9121275,
                33.4962996
              ],
              [
                45.916294,
                33.4982496
              ],
              [
                45.9196277,
                33.4982496
              ],
              [
                45.9201841,
                33.4979697
              ],
              [
                45.9210176,
                33.4979698
              ],
              [
                45.9229606,
                33.49741
              ],
              [
                45.9257373,
                33.4971392
              ],
              [
                45.9257372,
                33.4968593
              ],
              [
                45.9265708,
                33.4968593
              ],
              [
                45.9337936,
                33.5007413
              ],
              [
                45.9346271,
                33.5007414
              ],
              [
                45.9557401,
                33.5140758
              ],
              [
                45.9576839,
                33.5151953
              ],
              [
                45.9662965,
                33.5251893
              ],
              [
                45.9668503,
                33.5251893
              ],
              [
                45.9671301,
                33.5257491
              ],
              [
                45.9685168,
                33.5268595
              ],
              [
                45.9693496,
                33.5285206
              ],
              [
                45.9699067,
                33.531861
              ],
              [
                45.969073,
                33.5354721
              ],
              [
                45.9687965,
                33.5368624
              ],
              [
                45.96713,
                33.5393542
              ],
              [
                45.967683,
                33.5415841
              ],
              [
                45.9682403,
                33.5421349
              ],
              [
                45.9682402,
                33.5424147
              ],
              [
                45.9687964,
                33.5426945
              ],
              [
                45.9837967,
                33.5540788
              ],
              [
                45.9846295,
                33.5540787
              ],
              [
                45.9871296,
                33.5549183
              ],
              [
                45.9887959,
                33.5551892
              ],
              [
                45.995743,
                33.5540788
              ],
              [
                45.9985196,
                33.5526885
              ],
              [
                46.0154661,
                33.5474162
              ],
              [
                46.0165762,
                33.5474162
              ],
              [
                46.0171326,
                33.5471364
              ],
              [
                46.0193529,
                33.5471364
              ],
              [
                46.0199092,
                33.5468565
              ],
              [
                46.0221327,
                33.5465857
              ],
              [
                46.0299093,
                33.5471364
              ],
              [
                46.032132,
                33.5474162
              ],
              [
                46.047409,
                33.5524178
              ],
              [
                46.0515785,
                33.5588005
              ],
              [
                46.0521324,
                33.5632513
              ],
              [
                46.0529652,
                33.5643617
              ],
              [
                46.0551888,
                33.5649124
              ],
              [
                46.058245,
                33.5679728
              ],
              [
                46.0593551,
                33.5690742
              ],
              [
                46.0662982,
                33.5804673
              ],
              [
                46.0710217,
                33.5951917
              ],
              [
                46.074078,
                33.598523
              ],
              [
                46.0751881,
                33.5996424
              ],
              [
                46.0853154,
                33.6063824
              ],
              [
                46.0893678,
                33.607276
              ],
              [
                46.0915337,
                33.6045795
              ],
              [
                46.0950877,
                33.6010639
              ],
              [
                46.1021439,
                33.5971677
              ],
              [
                46.1300467,
                33.6070424
              ],
              [
                46.152706,
                33.6119032
              ],
              [
                46.1863516,
                33.6203375
              ],
              [
                46.2280653,
                33.6349168
              ],
              [
                46.271324,
                33.6466357
              ],
              [
                46.2972667,
                33.6434513
              ],
              [
                46.3087334,
                33.6468897
              ],
              [
                46.3139676,
                33.648424
              ],
              [
                46.3190182,
                33.6489091
              ],
              [
                46.3266752,
                33.6509454
              ],
              [
                46.3342904,
                33.652788
              ],
              [
                46.3359132,
                33.6488019
              ],
              [
                46.3376283,
                33.6449207
              ],
              [
                46.3399481,
                33.6408386
              ],
              [
                46.3420922,
                33.6402671
              ],
              [
                46.3448579,
                33.6417736
              ],
              [
                46.3528803,
                33.6473767
              ],
              [
                46.3570013,
                33.6545597
              ],
              [
                46.3599112,
                33.6573517
              ],
              [
                46.36288,
                33.6615976
              ],
              [
                46.365923,
                33.6659909
              ],
              [
                46.3703543,
                33.6702801
              ],
              [
                46.3726321,
                33.67151
              ],
              [
                46.3790399,
                33.6747957
              ],
              [
                46.3818844,
                33.6768139
              ],
              [
                46.3871591,
                33.6834503
              ],
              [
                46.3919401,
                33.6854144
              ],
              [
                46.3949004,
                33.6851586
              ],
              [
                46.4026847,
                33.683623
              ],
              [
                46.4094205,
                33.6835906
              ],
              [
                46.4141338,
                33.6824835
              ],
              [
                46.4212141,
                33.6803707
              ],
              [
                46.4266332,
                33.6782281
              ],
              [
                46.4313117,
                33.67799
              ],
              [
                46.4342235,
                33.6786697
              ],
              [
                46.4382765,
                33.6805625
              ],
              [
                46.4470581,
                33.6857845
              ],
              [
                46.4528277,
                33.689421
              ],
              [
                46.45794,
                33.6920023
              ],
              [
                46.4526844,
                33.6917097
              ],
              [
                46.4477671,
                33.6906292
              ],
              [
                46.4409864,
                33.6897042
              ],
              [
                46.4343601,
                33.6896869
              ],
              [
                46.4283718,
                33.6906453
              ],
              [
                46.4251151,
                33.6919583
              ],
              [
                46.4215931,
                33.6964273
              ],
              [
                46.4194678,
                33.699065
              ],
              [
                46.4145922,
                33.699974
              ],
              [
                46.4099629,
                33.7029616
              ],
              [
                46.4007267,
                33.7091561
              ],
              [
                46.3927062,
                33.7141538
              ],
              [
                46.3668536,
                33.7274807
              ],
              [
                46.3615321,
                33.7317637
              ],
              [
                46.3551807,
                33.7359036
              ],
              [
                46.3463504,
                33.7397355
              ],
              [
                46.3350965,
                33.7444144
              ],
              [
                46.3213377,
                33.749279
              ],
              [
                46.2866878,
                33.762666
              ],
              [
                46.2743031,
                33.7679786
              ],
              [
                46.2717533,
                33.7689271
              ],
              [
                46.2677192,
                33.7712281
              ],
              [
                46.2570552,
                33.775081
              ],
              [
                46.2501458,
                33.7768948
              ],
              [
                46.2471157,
                33.7793285
              ],
              [
                46.2428718,
                33.7814276
              ],
              [
                46.2403671,
                33.7826047
              ],
              [
                46.2365851,
                33.7843626
              ],
              [
                46.234871,
                33.78529
              ],
              [
                46.225134,
                33.7899926
              ],
              [
                46.2179267,
                33.7919698
              ],
              [
                46.2088393,
                33.7932718
              ],
              [
                46.1974238,
                33.7964103
              ],
              [
                46.1872958,
                33.7983361
              ],
              [
                46.1656988,
                33.8063538
              ],
              [
                46.1640816,
                33.8074364
              ],
              [
                46.1545653,
                33.8162164
              ],
              [
                46.1493353,
                33.8196998
              ],
              [
                46.1419902,
                33.8216265
              ],
              [
                46.1302364,
                33.8171506
              ],
              [
                46.1260128,
                33.8180909
              ],
              [
                46.1237618,
                33.8200029
              ],
              [
                46.1147711,
                33.8203056
              ],
              [
                46.1113387,
                33.8216248
              ],
              [
                46.1048156,
                33.8260404
              ],
              [
                46.0913458,
                33.830461
              ],
              [
                46.0809024,
                33.8341488
              ],
              [
                46.0753792,
                33.8357173
              ],
              [
                46.0696055,
                33.8363538
              ],
              [
                46.0658454,
                33.8374134
              ],
              [
                46.0583781,
                33.8391245
              ],
              [
                46.0504817,
                33.8395522
              ],
              [
                46.0397529,
                33.8414057
              ],
              [
                46.0338306,
                33.8443998
              ],
              [
                46.0303973,
                33.8482493
              ],
              [
                46.0254191,
                33.8534528
              ],
              [
                46.0225209,
                33.8553165
              ],
              [
                46.0194193,
                33.8550463
              ],
              [
                46.015369,
                33.8515945
              ],
              [
                46.0125174,
                33.8476171
              ],
              [
                46.0070935,
                33.8404883
              ],
              [
                46.0044016,
                33.8398271
              ],
              [
                46.0008023,
                33.8408607
              ],
              [
                45.9984254,
                33.841976
              ],
              [
                45.9892416,
                33.8443285
              ],
              [
                45.9747384,
                33.8481699
              ],
              [
                45.9611153,
                33.8502295
              ],
              [
                45.9508668,
                33.852874
              ],
              [
                45.9557296,
                33.8571071
              ],
              [
                45.9601583,
                33.8595429
              ],
              [
                45.9640502,
                33.8609648
              ],
              [
                45.9662504,
                33.8623696
              ],
              [
                45.9687856,
                33.8654918
              ],
              [
                45.9692236,
                33.8665182
              ],
              [
                45.9708717,
                33.8709412
              ],
              [
                45.9714885,
                33.8720217
              ],
              [
                45.9707185,
                33.8729836
              ],
              [
                45.9649561,
                33.8752661
              ],
              [
                45.9615284,
                33.8776178
              ],
              [
                45.9575205,
                33.8802073
              ],
              [
                45.953426,
                33.8838985
              ],
              [
                45.9468841,
                33.8890851
              ],
              [
                45.932722,
                33.8964947
              ],
              [
                45.929718,
                33.8985963
              ],
              [
                45.925126,
                33.8985963
              ],
              [
                45.9224224,
                33.8997006
              ],
              [
                45.9174656,
                33.8990594
              ],
              [
                45.9126162,
                33.8968866
              ],
              [
                45.9058668,
                33.8987048
              ],
              [
                45.9056854,
                33.8978483
              ],
              [
                45.8986473,
                33.893538
              ],
              [
                45.8933687,
                33.8877669
              ],
              [
                45.8917379,
                33.885095
              ],
              [
                45.8898496,
                33.8810334
              ],
              [
                45.8885622,
                33.8783257
              ],
              [
                45.8880043,
                33.8759741
              ],
              [
                45.8882618,
                33.8725179
              ],
              [
                45.8890342,
                33.8679213
              ],
              [
                45.8884334,
                33.8652131
              ],
              [
                45.8863735,
                33.860224
              ],
              [
                45.8814325,
                33.8547885
              ],
              [
                45.8777982,
                33.8539323
              ],
              [
                45.8673178,
                33.8492573
              ],
              [
                45.8665252,
                33.8484452
              ],
              [
                45.8665225,
                33.8470544
              ],
              [
                45.8667237,
                33.8459048
              ],
              [
                45.868269,
                33.8439311
              ],
              [
                45.8688768,
                33.8420836
              ],
              [
                45.8693141,
                33.8394571
              ],
              [
                45.8694481,
                33.8365031
              ],
              [
                45.8683274,
                33.8335958
              ],
              [
                45.8672691,
                33.8304224
              ],
              [
                45.8651421,
                33.8268776
              ],
              [
                45.8617202,
                33.8224671
              ],
              [
                45.8592506,
                33.8185397
              ],
              [
                45.8557687,
                33.813984
              ],
              [
                45.8516627,
                33.8078833
              ],
              [
                45.8475468,
                33.8021779
              ],
              [
                45.8452161,
                33.8002227
              ],
              [
                45.8441642,
                33.7981091
              ],
              [
                45.8438873,
                33.7964102
              ],
              [
                45.84473,
                33.7947438
              ],
              [
                45.8479955,
                33.7926428
              ],
              [
                45.8527083,
                33.7882754
              ],
              [
                45.8545303,
                33.7857818
              ],
              [
                45.8554101,
                33.7825717
              ],
              [
                45.8542084,
                33.7810023
              ],
              [
                45.8507108,
                33.780164
              ],
              [
                45.8437898,
                33.7775293
              ],
              [
                45.8424164,
                33.7742954
              ],
              [
                45.846391,
                33.7710462
              ],
              [
                45.8522129,
                33.7645568
              ],
              [
                45.8534574,
                33.7640217
              ],
              [
                45.8547878,
                33.7632903
              ],
              [
                45.8554423,
                33.7612745
              ],
              [
                45.85482,
                33.7608285
              ],
              [
                45.8474063,
                33.757778
              ],
              [
                45.8458614,
                33.7576709
              ],
              [
                45.8435654,
                33.75638
              ],
              [
                45.8376646,
                33.7502493
              ],
              [
                45.835431,
                33.7485598
              ],
              [
                45.832768,
                33.7477489
              ],
              [
                45.829103,
                33.744522
              ],
              [
                45.8277863,
                33.7428998
              ],
              [
                45.8255302,
                33.7426931
              ],
              [
                45.8253908,
                33.7406054
              ],
              [
                45.821979,
                33.7367869
              ],
              [
                45.8179235,
                33.7327629
              ],
              [
                45.8172369,
                33.7337979
              ],
              [
                45.8165414,
                33.7331621
              ],
              [
                45.8140075,
                33.7353772
              ],
              [
                45.8111244,
                33.7323509
              ],
              [
                45.8097267,
                33.7304966
              ],
              [
                45.8078833,
                33.7303757
              ],
              [
                45.8076792,
                33.7313493
              ],
              [
                45.8064524,
                33.7312129
              ],
              [
                45.805485,
                33.7315064
              ],
              [
                45.8007715,
                33.7300516
              ],
              [
                45.7993865,
                33.7305383
              ],
              [
                45.7982546,
                33.7300351
              ],
              [
                45.7963664,
                33.7291497
              ],
              [
                45.7949168,
                33.7291577
              ],
              [
                45.7906216,
                33.7283316
              ],
              [
                45.7877794,
                33.7264415
              ],
              [
                45.786488,
                33.7266954
              ],
              [
                45.7854659,
                33.7270061
              ],
              [
                45.7842106,
                33.7259628
              ],
              [
                45.7839453,
                33.7242549
              ],
              [
                45.7835752,
                33.72384
              ],
              [
                45.7829905,
                33.7237061
              ],
              [
                45.782572,
                33.7239284
              ],
              [
                45.7816279,
                33.7251606
              ],
              [
                45.7810749,
                33.7250341
              ],
              [
                45.7804116,
                33.7234847
              ],
              [
                45.7797074,
                33.7232332
              ],
              [
                45.7789993,
                33.7235723
              ],
              [
                45.7780659,
                33.723135
              ],
              [
                45.7770467,
                33.7229208
              ],
              [
                45.7762635,
                33.7231261
              ],
              [
                45.7764029,
                33.7226978
              ],
              [
                45.7763493,
                33.7219839
              ],
              [
                45.7761454,
                33.721618
              ],
              [
                45.7768321,
                33.7207345
              ],
              [
                45.7761601,
                33.71937
              ],
              [
                45.7757324,
                33.7196101
              ],
              [
                45.7749438,
                33.7207301
              ],
              [
                45.7745308,
                33.720739
              ],
              [
                45.7743859,
                33.7204401
              ],
              [
                45.7743967,
                33.7191327
              ],
              [
                45.7738495,
                33.7182448
              ],
              [
                45.7731306,
                33.7176737
              ],
              [
                45.7734686,
                33.7175175
              ],
              [
                45.7733184,
                33.7169553
              ],
              [
                45.7725084,
                33.7167054
              ],
              [
                45.7717116,
                33.7163821
              ],
              [
                45.772843,
                33.7162045
              ],
              [
                45.7733131,
                33.7158247
              ],
              [
                45.7735754,
                33.7152669
              ],
              [
                45.772326,
                33.7144877
              ],
              [
                45.7711857,
                33.7135604
              ],
              [
                45.7690652,
                33.7118632
              ],
              [
                45.7686756,
                33.7115999
              ],
              [
                45.76825,
                33.7112919
              ],
              [
                45.7669401,
                33.7120156
              ],
              [
                45.7651162,
                33.7112927
              ],
              [
                45.7649982,
                33.7103824
              ],
              [
                45.7650578,
                33.7094624
              ],
              [
                45.767617,
                33.7081886
              ],
              [
                45.768641,
                33.7067791
              ],
              [
                45.7688674,
                33.7063044
              ],
              [
                45.7682914,
                33.7058513
              ],
              [
                45.7672083,
                33.7059823
              ],
              [
                45.7669352,
                33.7051547
              ],
              [
                45.7670581,
                33.7044382
              ],
              [
                45.7676151,
                33.7038118
              ],
              [
                45.7672083,
                33.7031262
              ],
              [
                45.7666261,
                33.7031229
              ],
              [
                45.7656956,
                33.703992
              ],
              [
                45.7645047,
                33.7033404
              ],
              [
                45.762831,
                33.7038224
              ],
              [
                45.7611787,
                33.7027781
              ],
              [
                45.7605994,
                33.7025193
              ],
              [
                45.7594192,
                33.7028674
              ],
              [
                45.7591402,
                33.7020194
              ],
              [
                45.7582712,
                33.7005824
              ],
              [
                45.7576479,
                33.7000119
              ],
              [
                45.7565976,
                33.7004744
              ],
              [
                45.755626,
                33.701161
              ],
              [
                45.7536724,
                33.6999299
              ],
              [
                45.7492661,
                33.6962515
              ],
              [
                45.7415812,
                33.6921776
              ],
              [
                45.7328276,
                33.6889436
              ],
              [
                45.7230872,
                33.6894406
              ],
              [
                45.7107663,
                33.6900307
              ],
              [
                45.69252,
                33.69097
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 724197171
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.1667015,
          33.1236709
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 409193566
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.3096374,
          33.8282411
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2904946669
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.5654912,
          33.7675797
        ]
      }
    }
  ]
},
"بوشهر.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554952,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بوشهر",
          "name:ar": "مقاطعة بوشهر",
          "name:en": "Bushehr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1568659",
          "wikipedia": "en:Bushehr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.0519489,
                29.1684767
              ],
              [
                50.1313982,
                29.0842133
              ],
              [
                50.2857055,
                28.9015164
              ],
              [
                50.3840847,
                28.7848692
              ],
              [
                50.5881313,
                28.542517
              ],
              [
                50.9781926,
                28.8048394
              ],
              [
                50.9880317,
                28.8519668
              ],
              [
                50.9912099,
                28.8861735
              ],
              [
                50.9949006,
                28.9097638
              ],
              [
                50.9951941,
                28.9232254
              ],
              [
                51.0021574,
                28.9291399
              ],
              [
                51.0053022,
                28.9433294
              ],
              [
                51.0134585,
                28.9490781
              ],
              [
                51.0221859,
                28.9547506
              ],
              [
                51.0277749,
                28.9579282
              ],
              [
                51.0305751,
                28.9607619
              ],
              [
                51.0395627,
                28.9660728
              ],
              [
                51.0423681,
                28.9662063
              ],
              [
                51.0429247,
                28.965927
              ],
              [
                51.0437579,
                28.9659269
              ],
              [
                51.0440347,
                28.9662063
              ],
              [
                51.0518145,
                28.9662063
              ],
              [
                51.0526479,
                28.9664857
              ],
              [
                51.0528955,
                28.9664857
              ],
              [
                51.059591,
                28.9664858
              ],
              [
                51.0604245,
                28.9662064
              ],
              [
                51.066553,
                28.966319
              ],
              [
                51.0658382,
                28.9575881
              ],
              [
                51.0632515,
                28.9484854
              ],
              [
                51.0554514,
                28.9402385
              ],
              [
                51.0564754,
                28.915298
              ],
              [
                51.0612344,
                28.9126158
              ],
              [
                51.0706353,
                28.9138541
              ],
              [
                51.0772418,
                28.9224577
              ],
              [
                51.0852505,
                28.9378559
              ],
              [
                51.0877372,
                28.9399591
              ],
              [
                51.0895148,
                28.9477026
              ],
              [
                51.0974481,
                28.9512678
              ],
              [
                51.1044404,
                28.9565468
              ],
              [
                51.1119604,
                28.9613278
              ],
              [
                51.1130333,
                28.9653455
              ],
              [
                51.1114024,
                28.9696258
              ],
              [
                51.1132049,
                28.9712402
              ],
              [
                51.1198997,
                28.9747694
              ],
              [
                51.1265945,
                28.9797626
              ],
              [
                51.1347913,
                28.9891852
              ],
              [
                51.1408424,
                28.9958293
              ],
              [
                51.1456489,
                28.9970304
              ],
              [
                51.1568927,
                29.0091162
              ],
              [
                51.1719999,
                29.0192243
              ],
              [
                51.1709879,
                29.0230969
              ],
              [
                51.1650037,
                29.0322704
              ],
              [
                51.1599825,
                29.0414632
              ],
              [
                51.1573219,
                29.0443146
              ],
              [
                51.1646175,
                29.0501298
              ],
              [
                51.1670208,
                29.0523245
              ],
              [
                51.1689949,
                29.0546692
              ],
              [
                51.1714196,
                29.0584768
              ],
              [
                51.1664146,
                29.0676998
              ],
              [
                51.165858,
                29.0682586
              ],
              [
                51.1678045,
                29.0795681
              ],
              [
                51.168561,
                29.0880797
              ],
              [
                51.1681485,
                29.0914897
              ],
              [
                51.1679293,
                29.094266
              ],
              [
                51.1621498,
                29.1096204
              ],
              [
                51.1546775,
                29.1188249
              ],
              [
                51.1508314,
                29.1224465
              ],
              [
                51.1410408,
                29.1235625
              ],
              [
                51.137051,
                29.1265786
              ],
              [
                51.1350171,
                29.1311896
              ],
              [
                51.1317366,
                29.1342089
              ],
              [
                51.1293032,
                29.1333093
              ],
              [
                51.1250559,
                29.1275942
              ],
              [
                51.1213112,
                29.1250825
              ],
              [
                51.1185659,
                29.1236784
              ],
              [
                51.115763,
                29.1216683
              ],
              [
                51.1083591,
                29.1207282
              ],
              [
                51.1055518,
                29.1207397
              ],
              [
                51.1030211,
                29.1211218
              ],
              [
                51.100372,
                29.1217592
              ],
              [
                51.0898501,
                29.1234
              ],
              [
                51.0809755,
                29.1256601
              ],
              [
                51.0737608,
                29.1348198
              ],
              [
                51.0737608,
                29.1350992
              ],
              [
                51.0734807,
                29.1359375
              ],
              [
                51.0734807,
                29.136217
              ],
              [
                51.0716799,
                29.1370338
              ],
              [
                51.0724687,
                29.1375595
              ],
              [
                51.0726473,
                29.1401021
              ],
              [
                51.0723707,
                29.1417697
              ],
              [
                51.0723707,
                29.1437169
              ],
              [
                51.0720941,
                29.1448256
              ],
              [
                51.0720941,
                29.1531548
              ],
              [
                51.071814,
                29.1537137
              ],
              [
                51.0720941,
                29.1581578
              ],
              [
                51.0773705,
                29.19427
              ],
              [
                51.077094,
                29.1945495
              ],
              [
                51.0768138,
                29.1989937
              ],
              [
                51.0765373,
                29.2012114
              ],
              [
                51.0765374,
                29.2017702
              ],
              [
                51.0698706,
                29.2201065
              ],
              [
                51.0612573,
                29.2292656
              ],
              [
                51.0451477,
                29.2392723
              ],
              [
                51.0434809,
                29.2401017
              ],
              [
                51.0218112,
                29.2556619
              ],
              [
                51.0212579,
                29.2556619
              ],
              [
                51.0132016,
                29.2656598
              ],
              [
                51.0129214,
                29.2659393
              ],
              [
                51.0126446,
                29.2667687
              ],
              [
                51.0123681,
                29.2676071
              ],
              [
                51.0118114,
                29.2701044
              ],
              [
                51.0118115,
                29.2709338
              ],
              [
                51.0115347,
                29.2714927
              ],
              [
                51.0112548,
                29.2726016
              ],
              [
                51.010978,
                29.27399
              ],
              [
                51.0107015,
                29.2764963
              ],
              [
                51.0104214,
                29.2784346
              ],
              [
                51.0101448,
                29.2803819
              ],
              [
                51.0098681,
                29.2826087
              ],
              [
                51.0095881,
                29.2848265
              ],
              [
                51.0093113,
                29.2862149
              ],
              [
                51.0090348,
                29.2876034
              ],
              [
                51.0087548,
                29.2889918
              ],
              [
                51.0084781,
                29.2909391
              ],
              [
                51.0082014,
                29.2923275
              ],
              [
                51.0079215,
                29.2939954
              ],
              [
                51.0065347,
                29.3012168
              ],
              [
                51.0062548,
                29.3026052
              ],
              [
                51.0057015,
                29.3048231
              ],
              [
                51.0054214,
                29.305941
              ],
              [
                51.0051449,
                29.307609
              ],
              [
                51.004588,
                29.3081679
              ],
              [
                51.0037548,
                29.3087178
              ],
              [
                51.000038,
                29.3064655
              ],
              [
                50.9997987,
                29.3035216
              ],
              [
                50.9999468,
                29.2989716
              ],
              [
                51.001755,
                29.2949038
              ],
              [
                50.993365,
                29.2932513
              ],
              [
                50.9863251,
                29.2893353
              ],
              [
                50.9830194,
                29.28614
              ],
              [
                50.9733289,
                29.2842839
              ],
              [
                50.9662016,
                29.2825475
              ],
              [
                50.9589682,
                29.2803851
              ],
              [
                50.9523372,
                29.2761187
              ],
              [
                50.9437355,
                29.2735608
              ],
              [
                50.9363752,
                29.2743646
              ],
              [
                50.9323307,
                29.2710283
              ],
              [
                50.9276421,
                29.2690142
              ],
              [
                50.922645,
                29.2724649
              ],
              [
                50.9147608,
                29.2769413
              ],
              [
                50.9081963,
                29.278714
              ],
              [
                50.905973,
                29.278714
              ],
              [
                50.9054196,
                29.2784345
              ],
              [
                50.9037531,
                29.278164
              ],
              [
                50.9019468,
                29.2783138
              ],
              [
                50.8926398,
                29.2798318
              ],
              [
                50.8931966,
                29.2853854
              ],
              [
                50.8926398,
                29.2856649
              ],
              [
                50.8912499,
                29.2856648
              ],
              [
                50.88903,
                29.2853854
              ],
              [
                50.8890299,
                29.2848265
              ],
              [
                50.8870831,
                29.2814907
              ],
              [
                50.8865299,
                29.2812203
              ],
              [
                50.88403,
                29.2812202
              ],
              [
                50.8834734,
                29.2809407
              ],
              [
                50.8828248,
                29.2811739
              ],
              [
                50.8807289,
                29.2810933
              ],
              [
                50.8770459,
                29.2809974
              ],
              [
                50.8774187,
                29.2874363
              ],
              [
                50.8708449,
                29.2878512
              ],
              [
                50.8673295,
                29.2838776
              ],
              [
                50.8671027,
                29.2820429
              ],
              [
                50.8645963,
                29.2812569
              ],
              [
                50.8622291,
                29.2829561
              ],
              [
                50.860188,
                29.2873167
              ],
              [
                50.8569182,
                29.2878688
              ],
              [
                50.8539247,
                29.289098
              ],
              [
                50.8528381,
                29.2891876
              ],
              [
                50.8513974,
                29.288959
              ],
              [
                50.8509482,
                29.2884753
              ],
              [
                50.8505272,
                29.2874603
              ],
              [
                50.8504603,
                29.2865388
              ],
              [
                50.8507024,
                29.2851766
              ],
              [
                50.8520837,
                29.2823291
              ],
              [
                50.85296,
                29.2805195
              ],
              [
                50.8529706,
                29.2784118
              ],
              [
                50.853125,
                29.2769734
              ],
              [
                50.8524771,
                29.2764692
              ],
              [
                50.8489187,
                29.2763501
              ],
              [
                50.8473512,
                29.2764618
              ],
              [
                50.8477016,
                29.2738155
              ],
              [
                50.8459706,
                29.2731604
              ],
              [
                50.8441888,
                29.2729991
              ],
              [
                50.8434997,
                29.2745895
              ],
              [
                50.8434509,
                29.2746642
              ],
              [
                50.8425201,
                29.2760902
              ],
              [
                50.84016,
                29.280056
              ],
              [
                50.8344131,
                29.2834211
              ],
              [
                50.8284669,
                29.2855469
              ],
              [
                50.824501,
                29.2862206
              ],
              [
                50.8207326,
                29.2844124
              ],
              [
                50.8188276,
                29.2845247
              ],
              [
                50.8145809,
                29.2848263
              ],
              [
                50.8129143,
                29.2864942
              ],
              [
                50.8104144,
                29.2853852
              ],
              [
                50.8104144,
                29.2853029
              ],
              [
                50.8133426,
                29.2837162
              ],
              [
                50.8170425,
                29.278439
              ],
              [
                50.8195701,
                29.2756826
              ],
              [
                50.8213788,
                29.2739925
              ],
              [
                50.8213702,
                29.2734753
              ],
              [
                50.8213648,
                29.2730518
              ],
              [
                50.8186986,
                29.2714919
              ],
              [
                50.8127274,
                29.2629242
              ],
              [
                50.8107974,
                29.2641511
              ],
              [
                50.810135,
                29.265785
              ],
              [
                50.8102311,
                29.2666176
              ],
              [
                50.8111101,
                29.2675404
              ],
              [
                50.8115245,
                29.2681568
              ],
              [
                50.8120881,
                29.2723684
              ],
              [
                50.8071635,
                29.2712962
              ],
              [
                50.8043537,
                29.2717907
              ],
              [
                50.8042537,
                29.2736851
              ],
              [
                50.8064969,
                29.2755885
              ],
              [
                50.80814,
                29.2769828
              ],
              [
                50.8093558,
                29.2781438
              ],
              [
                50.8107385,
                29.2794805
              ],
              [
                50.8116103,
                29.2807715
              ],
              [
                50.810149,
                29.2814396
              ],
              [
                50.8088313,
                29.2810346
              ],
              [
                50.8071254,
                29.2799232
              ],
              [
                50.8052122,
                29.27951
              ],
              [
                50.8020193,
                29.2780133
              ],
              [
                50.8011633,
                29.2777409
              ],
              [
                50.7996296,
                29.2781958
              ],
              [
                50.799177,
                29.2789933
              ],
              [
                50.7981733,
                29.2816918
              ],
              [
                50.7979386,
                29.2831329
              ],
              [
                50.7964817,
                29.283375
              ],
              [
                50.7945711,
                29.2814895
              ],
              [
                50.7932224,
                29.2805314
              ],
              [
                50.7913803,
                29.280486
              ],
              [
                50.7903039,
                29.2810669
              ],
              [
                50.7867146,
                29.2815528
              ],
              [
                50.7853793,
                29.2815975
              ],
              [
                50.7835773,
                29.281339
              ],
              [
                50.7829789,
                29.2811337
              ],
              [
                50.7821281,
                29.280722
              ],
              [
                50.7808845,
                29.2806896
              ],
              [
                50.7789659,
                29.2813745
              ],
              [
                50.7779511,
                29.2821256
              ],
              [
                50.7768017,
                29.2806612
              ],
              [
                50.7743017,
                29.2773255
              ],
              [
                50.7731918,
                29.2703836
              ],
              [
                50.7745783,
                29.2681568
              ],
              [
                50.7743018,
                29.2667685
              ],
              [
                50.770296,
                29.263161
              ],
              [
                50.7656633,
                29.2576333
              ],
              [
                50.7650841,
                29.2568988
              ],
              [
                50.7643438,
                29.255829
              ],
              [
                50.764687,
                29.2544274
              ],
              [
                50.7685246,
                29.2521732
              ],
              [
                50.7694544,
                29.2502727
              ],
              [
                50.7664012,
                29.2493885
              ],
              [
                50.7581886,
                29.2437165
              ],
              [
                50.7559686,
                29.2406603
              ],
              [
                50.7581886,
                29.2359364
              ],
              [
                50.7576352,
                29.2328803
              ],
              [
                50.7556886,
                29.2306627
              ],
              [
                50.7548554,
                29.2303831
              ],
              [
                50.7506886,
                29.2303832
              ],
              [
                50.7467988,
                29.2312125
              ],
              [
                50.7462454,
                29.2306626
              ],
              [
                50.7456887,
                29.2287154
              ],
              [
                50.7459653,
                29.2281564
              ],
              [
                50.7479121,
                29.2262092
              ],
              [
                50.7490221,
                29.2251004
              ],
              [
                50.7484654,
                29.2234416
              ],
              [
                50.7470788,
                29.2226032
              ],
              [
                50.7462454,
                29.2226032
              ],
              [
                50.7426321,
                29.2234416
              ],
              [
                50.7412455,
                29.2234416
              ],
              [
                50.7390223,
                29.2245504
              ],
              [
                50.7387457,
                29.2251003
              ],
              [
                50.7381889,
                29.2253798
              ],
              [
                50.7365276,
                29.2253623
              ],
              [
                50.7334657,
                29.2234416
              ],
              [
                50.7337456,
                29.2223327
              ],
              [
                50.7373556,
                29.220106
              ],
              [
                50.7387457,
                29.2184383
              ],
              [
                50.7384656,
                29.2173295
              ],
              [
                50.7373557,
                29.2153822
              ],
              [
                50.7266336,
                29.2090827
              ],
              [
                50.7227898,
                29.2071762
              ],
              [
                50.7200181,
                29.2063033
              ],
              [
                50.7172965,
                29.2050582
              ],
              [
                50.7170306,
                29.2037577
              ],
              [
                50.7176327,
                29.2020493
              ],
              [
                50.7188964,
                29.2003299
              ],
              [
                50.7206892,
                29.1978755
              ],
              [
                50.7234264,
                29.1949173
              ],
              [
                50.7221924,
                29.1935883
              ],
              [
                50.7218479,
                29.1931925
              ],
              [
                50.7190572,
                29.1914343
              ],
              [
                50.7170902,
                29.1915093
              ],
              [
                50.7150147,
                29.1918715
              ],
              [
                50.7123563,
                29.1898254
              ],
              [
                50.7092995,
                29.1870488
              ],
              [
                50.7092995,
                29.1864899
              ],
              [
                50.7148561,
                29.1809369
              ],
              [
                50.7148207,
                29.1807955
              ],
              [
                50.7137426,
                29.1764927
              ],
              [
                50.7133649,
                29.1761128
              ],
              [
                50.7129094,
                29.1756544
              ],
              [
                50.7115688,
                29.1754913
              ],
              [
                50.7106859,
                29.1753839
              ],
              [
                50.7067995,
                29.1767722
              ],
              [
                50.7059663,
                29.1767722
              ],
              [
                50.6995358,
                29.1775291
              ],
              [
                50.69574,
                29.1781118
              ],
              [
                50.6859632,
                29.1781604
              ],
              [
                50.6840198,
                29.1776015
              ],
              [
                50.6792967,
                29.1728869
              ],
              [
                50.678463,
                29.1687132
              ],
              [
                50.6787431,
                29.1684337
              ],
              [
                50.6801299,
                29.1628809
              ],
              [
                50.68041,
                29.162322
              ],
              [
                50.6801299,
                29.1620515
              ],
              [
                50.6801299,
                29.1609337
              ],
              [
                50.6787432,
                29.1587162
              ],
              [
                50.6773533,
                29.1578778
              ],
              [
                50.6765201,
                29.1575984
              ],
              [
                50.6734634,
                29.1562102
              ],
              [
                50.6729068,
                29.1564897
              ],
              [
                50.6673535,
                29.1564897
              ],
              [
                50.6604069,
                29.1520455
              ],
              [
                50.6545077,
                29.1479119
              ],
              [
                50.6540281,
                29.1476313
              ],
              [
                50.6529117,
                29.1472447
              ],
              [
                50.6520776,
                29.1469844
              ],
              [
                50.6510519,
                29.1468285
              ],
              [
                50.6499914,
                29.1467722
              ],
              [
                50.648479,
                29.1466233
              ],
              [
                50.6475398,
                29.1465704
              ],
              [
                50.6467485,
                29.1465249
              ],
              [
                50.6450478,
                29.1458717
              ],
              [
                50.6428551,
                29.1443193
              ],
              [
                50.6427226,
                29.1442256
              ],
              [
                50.6423495,
                29.1439614
              ],
              [
                50.6423144,
                29.1439462
              ],
              [
                50.3779951,
                29.3963488
              ],
              [
                50.0519489,
                29.1684767
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554969,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تنگستان",
          "name:en": "Tangestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277789",
          "wikipedia": "en:Tangestan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.5881313,
                28.542517
              ],
              [
                50.7017919,
                28.4072764
              ],
              [
                50.9440729,
                28.0718545
              ],
              [
                51.2516202,
                28.26835
              ],
              [
                51.2532293,
                28.270056
              ],
              [
                51.2857153,
                28.3084206
              ],
              [
                51.2859918,
                28.30897
              ],
              [
                51.2896672,
                28.3127767
              ],
              [
                51.2898819,
                28.3134189
              ],
              [
                51.2898819,
                28.3139682
              ],
              [
                51.2782153,
                28.3278644
              ],
              [
                51.2390457,
                28.3834243
              ],
              [
                51.2373791,
                28.3867567
              ],
              [
                51.232656,
                28.3931424
              ],
              [
                51.2323792,
                28.3937009
              ],
              [
                51.2320991,
                28.3942593
              ],
              [
                51.2318225,
                28.3948086
              ],
              [
                51.2318226,
                28.3956463
              ],
              [
                51.2257127,
                28.4095348
              ],
              [
                51.2201561,
                28.4200909
              ],
              [
                51.219876,
                28.4211989
              ],
              [
                51.2190428,
                28.4220275
              ],
              [
                51.2134896,
                28.432863
              ],
              [
                51.2129328,
                28.4345294
              ],
              [
                51.2040429,
                28.4484185
              ],
              [
                51.196543,
                28.4698111
              ],
              [
                51.1959863,
                28.4703607
              ],
              [
                51.1943196,
                28.4737025
              ],
              [
                51.1848765,
                28.4903667
              ],
              [
                51.1804299,
                28.5006446
              ],
              [
                51.1737633,
                28.5231466
              ],
              [
                51.1673767,
                28.5431449
              ],
              [
                51.1595969,
                28.5625941
              ],
              [
                51.1593201,
                28.5681434
              ],
              [
                51.1582068,
                28.578143
              ],
              [
                51.1576534,
                28.5809267
              ],
              [
                51.1570969,
                28.5834222
              ],
              [
                51.1570968,
                28.5934219
              ],
              [
                51.1568203,
                28.5948184
              ],
              [
                51.1554302,
                28.6053678
              ],
              [
                51.1551536,
                28.6067552
              ],
              [
                51.1548735,
                28.6089804
              ],
              [
                51.1551536,
                28.6098182
              ],
              [
                51.1548735,
                28.6109264
              ],
              [
                51.1551535,
                28.6114759
              ],
              [
                51.1548734,
                28.612593
              ],
              [
                51.1509869,
                28.6353683
              ],
              [
                51.1507068,
                28.6375936
              ],
              [
                51.1509868,
                28.6514771
              ],
              [
                51.1507067,
                28.6528646
              ],
              [
                51.1495968,
                28.6606488
              ],
              [
                51.1498735,
                28.6698116
              ],
              [
                51.1495968,
                28.6706495
              ],
              [
                51.1493202,
                28.6709288
              ],
              [
                51.1493202,
                28.6711991
              ],
              [
                51.1493202,
                28.6728749
              ],
              [
                51.1490401,
                28.6731451
              ],
              [
                51.1487635,
                28.6745417
              ],
              [
                51.1484869,
                28.6756499
              ],
              [
                51.1482068,
                28.676758
              ],
              [
                51.1479301,
                28.6778753
              ],
              [
                51.1473735,
                28.6789835
              ],
              [
                51.1473734,
                28.6800916
              ],
              [
                51.1429302,
                28.6945345
              ],
              [
                51.1426501,
                28.6989763
              ],
              [
                51.1434835,
                28.706761
              ],
              [
                51.1434835,
                28.7081485
              ],
              [
                51.1443169,
                28.7106533
              ],
              [
                51.1443169,
                28.7109327
              ],
              [
                51.1443169,
                28.7114823
              ],
              [
                51.1445969,
                28.7117616
              ],
              [
                51.1515401,
                28.7184291
              ],
              [
                51.1598732,
                28.7217628
              ],
              [
                51.1679298,
                28.7228711
              ],
              [
                51.1698765,
                28.7228712
              ],
              [
                51.1712631,
                28.7231505
              ],
              [
                51.1729297,
                28.7231504
              ],
              [
                51.1743198,
                28.7234298
              ],
              [
                51.1748764,
                28.7234298
              ],
              [
                51.1782096,
                28.7234298
              ],
              [
                51.1845997,
                28.7234298
              ],
              [
                51.1854328,
                28.7237091
              ],
              [
                51.1868196,
                28.7237091
              ],
              [
                51.2515451,
                28.7434238
              ],
              [
                51.2526551,
                28.7437031
              ],
              [
                51.2534885,
                28.7442617
              ],
              [
                51.2584884,
                28.74537
              ],
              [
                51.2598783,
                28.7459286
              ],
              [
                51.2604352,
                28.7462079
              ],
              [
                51.2782146,
                28.7498122
              ],
              [
                51.2832146,
                28.7512088
              ],
              [
                51.284048,
                28.7514791
              ],
              [
                51.3021044,
                28.7584263
              ],
              [
                51.303771,
                28.758985
              ],
              [
                51.3046044,
                28.758985
              ],
              [
                51.3498838,
                28.7770423
              ],
              [
                51.3516795,
                28.7776405
              ],
              [
                51.3623834,
                28.7812053
              ],
              [
                51.3632168,
                28.7814847
              ],
              [
                51.3663453,
                28.7779651
              ],
              [
                51.3721065,
                28.7714828
              ],
              [
                51.3829399,
                28.7634272
              ],
              [
                51.3843298,
                28.7620396
              ],
              [
                51.3909964,
                28.7575973
              ],
              [
                51.4137761,
                28.7445412
              ],
              [
                51.4251625,
                28.7384321
              ],
              [
                51.4323858,
                28.7350984
              ],
              [
                51.4576654,
                28.7214839
              ],
              [
                51.4601655,
                28.719817
              ],
              [
                51.4818316,
                28.7092662
              ],
              [
                51.4896117,
                28.7059234
              ],
              [
                51.5326675,
                28.689264
              ],
              [
                51.5560038,
                28.6814796
              ],
              [
                51.5607239,
                28.6795334
              ],
              [
                51.5640604,
                28.6787045
              ],
              [
                51.5829503,
                28.6714788
              ],
              [
                51.5868369,
                28.6700913
              ],
              [
                51.6240629,
                28.6598113
              ],
              [
                51.6285061,
                28.6598114
              ],
              [
                51.6290628,
                28.6598114
              ],
              [
                51.6293396,
                28.6600907
              ],
              [
                51.6298962,
                28.6600907
              ],
              [
                51.6307294,
                28.6603699
              ],
              [
                51.6298962,
                28.6617574
              ],
              [
                51.6298963,
                28.6645414
              ],
              [
                51.6296162,
                28.6653703
              ],
              [
                51.6293396,
                28.6656496
              ],
              [
                51.6246162,
                28.6764882
              ],
              [
                51.6176729,
                28.6842637
              ],
              [
                51.6110065,
                28.693706
              ],
              [
                51.6076731,
                28.6992561
              ],
              [
                51.6092547,
                28.7111705
              ],
              [
                51.6001815,
                28.7095251
              ],
              [
                51.5833171,
                28.718279
              ],
              [
                51.570329,
                28.728894
              ],
              [
                51.5603657,
                28.7395346
              ],
              [
                51.549546,
                28.7503956
              ],
              [
                51.5599205,
                28.7626184
              ],
              [
                51.5382242,
                28.7789889
              ],
              [
                51.5356313,
                28.7815813
              ],
              [
                51.5337809,
                28.7834312
              ],
              [
                51.5326674,
                28.7848188
              ],
              [
                51.5307242,
                28.7873239
              ],
              [
                51.5170364,
                28.7949806
              ],
              [
                51.4949085,
                28.8140689
              ],
              [
                51.5052998,
                28.8230284
              ],
              [
                51.4867399,
                28.8461775
              ],
              [
                51.4537202,
                28.8959526
              ],
              [
                51.4505336,
                28.908003
              ],
              [
                51.4428005,
                28.9198646
              ],
              [
                51.4362715,
                28.9226832
              ],
              [
                51.4307573,
                28.9319622
              ],
              [
                51.4297055,
                28.9480977
              ],
              [
                51.4265522,
                28.9645484
              ],
              [
                51.4236705,
                28.9712087
              ],
              [
                51.4119841,
                28.9776712
              ],
              [
                51.4067261,
                28.9848963
              ],
              [
                51.403016,
                28.9924406
              ],
              [
                51.3971496,
                29.0025268
              ],
              [
                51.3850364,
                29.02587
              ],
              [
                51.3754911,
                29.0530559
              ],
              [
                51.3687972,
                29.0603639
              ],
              [
                51.3598375,
                29.0717635
              ],
              [
                51.3518001,
                29.0808986
              ],
              [
                51.3448787,
                29.090879
              ],
              [
                51.3394876,
                29.100019
              ],
              [
                51.3348109,
                29.1078726
              ],
              [
                51.3343626,
                29.1121718
              ],
              [
                51.3299674,
                29.1187875
              ],
              [
                51.3300025,
                29.1204021
              ],
              [
                51.3291706,
                29.1206154
              ],
              [
                51.3215985,
                29.1234628
              ],
              [
                51.2890474,
                29.1425993
              ],
              [
                51.2871007,
                29.1448258
              ],
              [
                51.2871007,
                29.1451052
              ],
              [
                51.2834909,
                29.1487109
              ],
              [
                51.2818242,
                29.1500992
              ],
              [
                51.2768244,
                29.1514874
              ],
              [
                51.2762677,
                29.1517667
              ],
              [
                51.2743243,
                29.1517668
              ],
              [
                51.2432115,
                29.1420494
              ],
              [
                51.2421014,
                29.1420494
              ],
              [
                51.2379315,
                29.1406612
              ],
              [
                51.2376549,
                29.1403818
              ],
              [
                51.2365449,
                29.1403818
              ],
              [
                51.233765,
                29.1395524
              ],
              [
                51.2334883,
                29.139273
              ],
              [
                51.2326551,
                29.139273
              ],
              [
                51.2323782,
                29.1389936
              ],
              [
                51.2295983,
                29.1381552
              ],
              [
                51.2248785,
                29.136767
              ],
              [
                51.2240452,
                29.1367671
              ],
              [
                51.222655,
                29.1359377
              ],
              [
                51.2090419,
                29.1320437
              ],
              [
                51.2079319,
                29.1320436
              ],
              [
                51.2012654,
                29.1301055
              ],
              [
                51.2004322,
                29.1301055
              ],
              [
                51.2001521,
                29.1298261
              ],
              [
                51.1984855,
                29.1298261
              ],
              [
                51.1982087,
                29.1295466
              ],
              [
                51.1951522,
                29.1295467
              ],
              [
                51.1943188,
                29.1292672
              ],
              [
                51.1920989,
                29.1292672
              ],
              [
                51.1857091,
                29.1284379
              ],
              [
                51.1843189,
                29.1281585
              ],
              [
                51.1826523,
                29.1281585
              ],
              [
                51.1815424,
                29.127879
              ],
              [
                51.1790423,
                29.1278791
              ],
              [
                51.1734858,
                29.1270498
              ],
              [
                51.1729292,
                29.1267703
              ],
              [
                51.1676528,
                29.1267703
              ],
              [
                51.1618194,
                29.1251027
              ],
              [
                51.1546775,
                29.1188249
              ],
              [
                51.1621498,
                29.1096204
              ],
              [
                51.1679293,
                29.094266
              ],
              [
                51.1681485,
                29.0914897
              ],
              [
                51.168561,
                29.0880797
              ],
              [
                51.1678045,
                29.0795681
              ],
              [
                51.165858,
                29.0682586
              ],
              [
                51.1664146,
                29.0676998
              ],
              [
                51.1714196,
                29.0584768
              ],
              [
                51.1689949,
                29.0546692
              ],
              [
                51.1670208,
                29.0523245
              ],
              [
                51.1646175,
                29.0501298
              ],
              [
                51.1573219,
                29.0443146
              ],
              [
                51.1599825,
                29.0414632
              ],
              [
                51.1650037,
                29.0322704
              ],
              [
                51.1709879,
                29.0230969
              ],
              [
                51.1719999,
                29.0192243
              ],
              [
                51.1568927,
                29.0091162
              ],
              [
                51.1456489,
                28.9970304
              ],
              [
                51.1408424,
                28.9958293
              ],
              [
                51.1347913,
                28.9891852
              ],
              [
                51.1265945,
                28.9797626
              ],
              [
                51.1198997,
                28.9747694
              ],
              [
                51.1132049,
                28.9712402
              ],
              [
                51.1114024,
                28.9696258
              ],
              [
                51.1130333,
                28.9653455
              ],
              [
                51.1119604,
                28.9613278
              ],
              [
                51.1044404,
                28.9565468
              ],
              [
                51.0974481,
                28.9512678
              ],
              [
                51.0895148,
                28.9477026
              ],
              [
                51.0877372,
                28.9399591
              ],
              [
                51.0852505,
                28.9378559
              ],
              [
                51.0772418,
                28.9224577
              ],
              [
                51.0706353,
                28.9138541
              ],
              [
                51.0612344,
                28.9126158
              ],
              [
                51.0564754,
                28.915298
              ],
              [
                51.0554514,
                28.9402385
              ],
              [
                51.0632515,
                28.9484854
              ],
              [
                51.0658382,
                28.9575881
              ],
              [
                51.066553,
                28.966319
              ],
              [
                51.0604245,
                28.9662064
              ],
              [
                51.059591,
                28.9664858
              ],
              [
                51.0528955,
                28.9664857
              ],
              [
                51.0526479,
                28.9664857
              ],
              [
                51.0518145,
                28.9662063
              ],
              [
                51.0440347,
                28.9662063
              ],
              [
                51.0437579,
                28.9659269
              ],
              [
                51.0429247,
                28.965927
              ],
              [
                51.0423681,
                28.9662063
              ],
              [
                51.0395627,
                28.9660728
              ],
              [
                51.0305751,
                28.9607619
              ],
              [
                51.0277749,
                28.9579282
              ],
              [
                51.0221859,
                28.9547506
              ],
              [
                51.0134585,
                28.9490781
              ],
              [
                51.0053022,
                28.9433294
              ],
              [
                51.0021574,
                28.9291399
              ],
              [
                50.9951941,
                28.9232254
              ],
              [
                50.9949006,
                28.9097638
              ],
              [
                50.9912099,
                28.8861735
              ],
              [
                50.9880317,
                28.8519668
              ],
              [
                50.9781926,
                28.8048394
              ],
              [
                50.5881313,
                28.542517
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554978,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جم",
          "name:en": "Jam County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1272877",
          "wikipedia": "en:Jam County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8632398,
                28.1395268
              ],
              [
                51.8643497,
                28.1384103
              ],
              [
                51.8651831,
                28.137582
              ],
              [
                51.8654632,
                28.1373028
              ],
              [
                51.8687964,
                28.1331341
              ],
              [
                51.8823925,
                28.1211423
              ],
              [
                51.9279655,
                28.080914
              ],
              [
                51.9376854,
                28.0748009
              ],
              [
                51.9382421,
                28.0739726
              ],
              [
                51.9387987,
                28.0739726
              ],
              [
                51.9393554,
                28.0734144
              ],
              [
                51.9529651,
                28.0650776
              ],
              [
                51.955465,
                28.0639703
              ],
              [
                51.9637984,
                28.0598019
              ],
              [
                51.9646316,
                28.0598019
              ],
              [
                51.9649116,
                28.0595228
              ],
              [
                51.9701882,
                28.0575782
              ],
              [
                51.9776881,
                28.0525817
              ],
              [
                51.9779682,
                28.0523026
              ],
              [
                51.9935211,
                28.0400768
              ],
              [
                52.0010245,
                28.0359176
              ],
              [
                52.0013012,
                28.0353595
              ],
              [
                52.0188007,
                28.0203523
              ],
              [
                52.0335238,
                28.003968
              ],
              [
                52.036304,
                27.9998
              ],
              [
                52.0490804,
                27.9820209
              ],
              [
                52.0596369,
                27.9720197
              ],
              [
                52.0643602,
                27.9650794
              ],
              [
                52.0815833,
                27.9439705
              ],
              [
                52.0818599,
                27.9436915
              ],
              [
                52.08325,
                27.9414682
              ],
              [
                52.0840832,
                27.9395238
              ],
              [
                52.08436,
                27.9392447
              ],
              [
                52.0839985,
                27.9380402
              ],
              [
                52.0854699,
                27.9373005
              ],
              [
                52.0890831,
                27.9350771
              ],
              [
                52.1063063,
                27.9214671
              ],
              [
                52.1065828,
                27.9211881
              ],
              [
                52.1082494,
                27.9198019
              ],
              [
                52.1082494,
                27.9195229
              ],
              [
                52.1082495,
                27.9192439
              ],
              [
                52.1174161,
                27.9098016
              ],
              [
                52.1199161,
                27.9034109
              ],
              [
                52.1201961,
                27.9009086
              ],
              [
                52.1210293,
                27.8981273
              ],
              [
                52.121306,
                27.8967412
              ],
              [
                52.1215827,
                27.895913
              ],
              [
                52.1260293,
                27.8842479
              ],
              [
                52.127696,
                27.8822948
              ],
              [
                52.1321391,
                27.8781365
              ],
              [
                52.1326958,
                27.8778574
              ],
              [
                52.143529,
                27.8686858
              ],
              [
                52.1726987,
                27.8317483
              ],
              [
                52.1799186,
                27.8275813
              ],
              [
                52.1826985,
                27.8261863
              ],
              [
                52.1865239,
                27.8246355
              ],
              [
                52.1868651,
                27.8245212
              ],
              [
                52.1879751,
                27.8236843
              ],
              [
                52.1890884,
                27.8234143
              ],
              [
                52.1968649,
                27.8186893
              ],
              [
                52.2096448,
                27.8053605
              ],
              [
                52.2096448,
                27.8048024
              ],
              [
                52.2103902,
                27.8033909
              ],
              [
                52.210478,
                27.8031285
              ],
              [
                52.2107547,
                27.8028495
              ],
              [
                52.2110313,
                27.8020215
              ],
              [
                52.211588,
                27.8014636
              ],
              [
                52.2132547,
                27.7986827
              ],
              [
                52.2238111,
                27.7934088
              ],
              [
                52.2249211,
                27.7934089
              ],
              [
                52.2254778,
                27.7931298
              ],
              [
                52.2263111,
                27.7931299
              ],
              [
                52.2299209,
                27.7917439
              ],
              [
                52.2343677,
                27.789242
              ],
              [
                52.2399209,
                27.7839593
              ],
              [
                52.2485342,
                27.7747978
              ],
              [
                52.2652005,
                27.7636837
              ],
              [
                52.2671472,
                27.7617398
              ],
              [
                52.2904801,
                27.7475751
              ],
              [
                52.2952033,
                27.7450734
              ],
              [
                52.2971468,
                27.7442365
              ],
              [
                52.3021466,
                27.7431297
              ],
              [
                52.3054799,
                27.7417438
              ],
              [
                52.3063131,
                27.7417438
              ],
              [
                52.3088132,
                27.7411859
              ],
              [
                52.3102033,
                27.7411859
              ],
              [
                52.31076,
                27.7409069
              ],
              [
                52.3354828,
                27.7356335
              ],
              [
                52.3368728,
                27.7356335
              ],
              [
                52.3393727,
                27.7350756
              ],
              [
                52.3407595,
                27.7350756
              ],
              [
                52.3415926,
                27.7347966
              ],
              [
                52.3429827,
                27.7347966
              ],
              [
                52.3435394,
                27.7345177
              ],
              [
                52.3554825,
                27.732016
              ],
              [
                52.362149,
                27.7303511
              ],
              [
                52.3640957,
                27.7303512
              ],
              [
                52.3652057,
                27.7300722
              ],
              [
                52.3671489,
                27.7300722
              ],
              [
                52.3693722,
                27.7295233
              ],
              [
                52.3707622,
                27.7295233
              ],
              [
                52.3827053,
                27.7275706
              ],
              [
                52.3915953,
                27.7264637
              ],
              [
                52.3935419,
                27.7259058
              ],
              [
                52.4007617,
                27.7253478
              ],
              [
                52.4021517,
                27.7256358
              ],
              [
                52.406595,
                27.7256358
              ],
              [
                52.4074282,
                27.7253479
              ],
              [
                52.4099282,
                27.7247989
              ],
              [
                52.4113182,
                27.724799
              ],
              [
                52.4374313,
                27.7150713
              ],
              [
                52.4385412,
                27.7150713
              ],
              [
                52.452711,
                27.7103561
              ],
              [
                52.4693774,
                27.7025724
              ],
              [
                52.4720261,
                27.7014778
              ],
              [
                52.4774339,
                27.6992429
              ],
              [
                52.5091,
                27.6831269
              ],
              [
                52.5099334,
                27.6822901
              ],
              [
                52.51549,
                27.6789607
              ],
              [
                52.5165999,
                27.6778539
              ],
              [
                52.5332697,
                27.6684059
              ],
              [
                52.5341031,
                27.6684059
              ],
              [
                52.5343797,
                27.668127
              ],
              [
                52.5349363,
                27.6681269
              ],
              [
                52.5371563,
                27.6675691
              ],
              [
                52.541603,
                27.6659045
              ],
              [
                52.541603,
                27.6661834
              ],
              [
                52.5410462,
                27.6670202
              ],
              [
                52.5407696,
                27.667848
              ],
              [
                52.5407697,
                27.6689638
              ],
              [
                52.5277132,
                27.704795
              ],
              [
                52.5277132,
                27.7053529
              ],
              [
                52.5271564,
                27.7059019
              ],
              [
                52.5271564,
                27.7064597
              ],
              [
                52.5266032,
                27.7072966
              ],
              [
                52.5135467,
                27.732574
              ],
              [
                52.51049,
                27.7420138
              ],
              [
                52.5099334,
                27.7439667
              ],
              [
                52.5096273,
                27.7465781
              ],
              [
                52.5093801,
                27.7475752
              ],
              [
                52.5088233,
                27.7520208
              ],
              [
                52.5085467,
                27.7572943
              ],
              [
                52.5082667,
                27.7625769
              ],
              [
                52.5066001,
                27.7756349
              ],
              [
                52.5016002,
                27.7861823
              ],
              [
                52.5016001,
                27.7864703
              ],
              [
                52.5010434,
                27.7872983
              ],
              [
                52.486877,
                27.8095185
              ],
              [
                52.4640974,
                27.8373016
              ],
              [
                52.4585441,
                27.8461849
              ],
              [
                52.4582641,
                27.8464638
              ],
              [
                52.4579875,
                27.8470219
              ],
              [
                52.4552108,
                27.8550773
              ],
              [
                52.4552109,
                27.8561842
              ],
              [
                52.4499309,
                27.8717462
              ],
              [
                52.4496543,
                27.8720252
              ],
              [
                52.4429876,
                27.8839692
              ],
              [
                52.442431,
                27.8850763
              ],
              [
                52.4415976,
                27.8859133
              ],
              [
                52.4365978,
                27.8950762
              ],
              [
                52.4363211,
                27.8956342
              ],
              [
                52.4271512,
                27.9122951
              ],
              [
                52.4071515,
                27.9403521
              ],
              [
                52.4067187,
                27.940786
              ],
              [
                52.4029849,
                27.9470223
              ],
              [
                52.4027083,
                27.9473013
              ],
              [
                52.4015949,
                27.9484086
              ],
              [
                52.3932617,
                27.9684102
              ],
              [
                52.3918717,
                27.9753597
              ],
              [
                52.391595,
                27.9775832
              ],
              [
                52.3913184,
                27.9792485
              ],
              [
                52.3910383,
                27.9809139
              ],
              [
                52.3904851,
                27.9839746
              ],
              [
                52.390205,
                27.9856309
              ],
              [
                52.3899284,
                27.9873053
              ],
              [
                52.3896518,
                27.9881334
              ],
              [
                52.3893717,
                27.9892497
              ],
              [
                52.3879852,
                27.9931387
              ],
              [
                52.3875574,
                27.993546
              ],
              [
                52.3821519,
                27.998693
              ],
              [
                52.3802053,
                28.0014746
              ],
              [
                52.3782619,
                28.0036892
              ],
              [
                52.3774286,
                28.0042473
              ],
              [
                52.3760385,
                28.0059127
              ],
              [
                52.3685388,
                28.0123043
              ],
              [
                52.3646488,
                28.014807
              ],
              [
                52.3640954,
                28.014807
              ],
              [
                52.3632622,
                28.0150771
              ],
              [
                52.3393726,
                28.022306
              ],
              [
                52.3352024,
                28.0231343
              ],
              [
                52.3332592,
                28.0231342
              ],
              [
                52.3107597,
                28.0270233
              ],
              [
                52.3093696,
                28.0270233
              ],
              [
                52.3054797,
                28.0278606
              ],
              [
                52.3043697,
                28.0278605
              ],
              [
                52.3027031,
                28.0284187
              ],
              [
                52.3015932,
                28.0284187
              ],
              [
                52.2954799,
                28.0300841
              ],
              [
                52.2940899,
                28.0303542
              ],
              [
                52.2835367,
                28.0350806
              ],
              [
                52.2785369,
                28.0373042
              ],
              [
                52.2652003,
                28.0442452
              ],
              [
                52.2340874,
                28.0725865
              ],
              [
                52.233254,
                28.0734146
              ],
              [
                52.2299207,
                28.0798068
              ],
              [
                52.2207542,
                28.0911869
              ],
              [
                52.2204775,
                28.0917541
              ],
              [
                52.2174211,
                28.0953554
              ],
              [
                52.199088,
                28.1114715
              ],
              [
                52.1790848,
                28.1234193
              ],
              [
                52.1707517,
                28.130082
              ],
              [
                52.1601953,
                28.1436958
              ],
              [
                52.1590853,
                28.1448032
              ],
              [
                52.1582518,
                28.1456406
              ],
              [
                52.1435287,
                28.1700776
              ],
              [
                52.1414772,
                28.1741821
              ],
              [
                52.1401955,
                28.1734182
              ],
              [
                52.1163058,
                28.1548067
              ],
              [
                52.0999161,
                28.1459197
              ],
              [
                52.0957496,
                28.1450824
              ],
              [
                52.0938062,
                28.1450823
              ],
              [
                52.0910262,
                28.1445241
              ],
              [
                52.0790831,
                28.1431375
              ],
              [
                52.0746366,
                28.1409135
              ],
              [
                52.0721365,
                28.1381403
              ],
              [
                52.0710266,
                28.1359164
              ],
              [
                52.0710265,
                28.1353581
              ],
              [
                52.0704699,
                28.1345298
              ],
              [
                52.0699132,
                28.1320268
              ],
              [
                52.0693599,
                28.1311894
              ],
              [
                52.0646368,
                28.1225818
              ],
              [
                52.0582468,
                28.1173057
              ],
              [
                52.05686,
                28.1167476
              ],
              [
                52.0563034,
                28.1161893
              ],
              [
                52.0488036,
                28.1134162
              ],
              [
                52.0440804,
                28.1125789
              ],
              [
                52.0365804,
                28.1120297
              ],
              [
                52.0276906,
                28.1120296
              ],
              [
                52.0271339,
                28.1123087
              ],
              [
                52.0168574,
                28.1142445
              ],
              [
                52.0151908,
                28.1148027
              ],
              [
                51.9913012,
                28.1267504
              ],
              [
                51.9885212,
                28.1281371
              ],
              [
                51.9874112,
                28.1284162
              ],
              [
                51.9868546,
                28.1289744
              ],
              [
                51.9846346,
                28.1300819
              ],
              [
                51.9835213,
                28.1311893
              ],
              [
                51.9799113,
                28.1331342
              ],
              [
                51.9796347,
                28.1336924
              ],
              [
                51.9762979,
                28.1347998
              ],
              [
                51.9735215,
                28.1361955
              ],
              [
                51.960465,
                28.1409134
              ],
              [
                51.9443552,
                28.1453613
              ],
              [
                51.9327053,
                28.1475763
              ],
              [
                51.9301854,
                28.1481436
              ],
              [
                51.9282422,
                28.1481435
              ],
              [
                51.9271322,
                28.1484137
              ],
              [
                51.9229655,
                28.1484136
              ],
              [
                51.9215754,
                28.1486928
              ],
              [
                51.9068524,
                28.1486928
              ],
              [
                51.9054625,
                28.1484137
              ],
              [
                51.8846295,
                28.1467479
              ],
              [
                51.8818494,
                28.1461986
              ],
              [
                51.8810162,
                28.1459195
              ],
              [
                51.8799062,
                28.1459196
              ],
              [
                51.8793496,
                28.1456405
              ],
              [
                51.8782395,
                28.1456404
              ],
              [
                51.8765729,
                28.1450821
              ],
              [
                51.875463,
                28.1450822
              ],
              [
                51.8637966,
                28.1406432
              ],
              [
                51.8632398,
                28.1395268
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555017,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دشتستان",
          "name:ar": "مقاطعة دشتستان",
          "name:en": "Dashtestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270938",
          "wikipedia": "en:Dashtestan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.7887478,
                29.4459364
              ],
              [
                50.7887477,
                29.4445478
              ],
              [
                50.7870812,
                29.4415001
              ],
              [
                50.7864946,
                29.4410583
              ],
              [
                50.7859679,
                29.4406616
              ],
              [
                50.7851345,
                29.4406615
              ],
              [
                50.7790246,
                29.4437182
              ],
              [
                50.7765247,
                29.4431592
              ],
              [
                50.7743015,
                29.4420501
              ],
              [
                50.772078,
                29.4395524
              ],
              [
                50.772358,
                29.4390025
              ],
              [
                50.7787448,
                29.4356662
              ],
              [
                50.7801346,
                29.4337186
              ],
              [
                50.7795779,
                29.4315005
              ],
              [
                50.7776348,
                29.4295529
              ],
              [
                50.7772514,
                29.4295529
              ],
              [
                50.7768013,
                29.4295529
              ],
              [
                50.7765247,
                29.4298324
              ],
              [
                50.7754113,
                29.4298324
              ],
              [
                50.7748582,
                29.4295528
              ],
              [
                50.7737446,
                29.4295529
              ],
              [
                50.7735695,
                29.4293759
              ],
              [
                50.773468,
                29.4292733
              ],
              [
                50.7726348,
                29.4289939
              ],
              [
                50.7718014,
                29.4276143
              ],
              [
                50.7681881,
                29.4287143
              ],
              [
                50.7679115,
                29.4289939
              ],
              [
                50.7668015,
                29.43233
              ],
              [
                50.7662449,
                29.4326095
              ],
              [
                50.7648549,
                29.4326095
              ],
              [
                50.7631882,
                29.4328891
              ],
              [
                50.7604116,
                29.4309415
              ],
              [
                50.7579117,
                29.4281643
              ],
              [
                50.7662449,
                29.4192738
              ],
              [
                50.7666074,
                29.4191522
              ],
              [
                50.7670781,
                29.4189944
              ],
              [
                50.7679115,
                29.4181648
              ],
              [
                50.7693014,
                29.4159378
              ],
              [
                50.7698583,
                29.4139992
              ],
              [
                50.7693015,
                29.4092744
              ],
              [
                50.7654115,
                29.4070474
              ],
              [
                50.7643277,
                29.4066185
              ],
              [
                50.7640217,
                29.4064974
              ],
              [
                50.7618017,
                29.4028908
              ],
              [
                50.7618017,
                29.3978866
              ],
              [
                50.7570784,
                29.3787178
              ],
              [
                50.7568018,
                29.3751024
              ],
              [
                50.7593017,
                29.3673303
              ],
              [
                50.7637449,
                29.3628853
              ],
              [
                50.7856915,
                29.3453851
              ],
              [
                50.7920812,
                29.3378839
              ],
              [
                50.8084711,
                29.320943
              ],
              [
                50.8129143,
                29.3167687
              ],
              [
                50.8173576,
                29.312324
              ],
              [
                50.8190242,
                29.3112151
              ],
              [
                50.8498941,
                29.2871212
              ],
              [
                50.8504603,
                29.2865388
              ],
              [
                50.8505272,
                29.2874603
              ],
              [
                50.8509482,
                29.2884753
              ],
              [
                50.8513974,
                29.288959
              ],
              [
                50.8528381,
                29.2891876
              ],
              [
                50.8539247,
                29.289098
              ],
              [
                50.8569182,
                29.2878688
              ],
              [
                50.860188,
                29.2873167
              ],
              [
                50.8622291,
                29.2829561
              ],
              [
                50.8645963,
                29.2812569
              ],
              [
                50.8671027,
                29.2820429
              ],
              [
                50.8673295,
                29.2838776
              ],
              [
                50.8708449,
                29.2878512
              ],
              [
                50.8774187,
                29.2874363
              ],
              [
                50.8770459,
                29.2809974
              ],
              [
                50.8807289,
                29.2810933
              ],
              [
                50.8828248,
                29.2811739
              ],
              [
                50.8834734,
                29.2809407
              ],
              [
                50.88403,
                29.2812202
              ],
              [
                50.8865299,
                29.2812203
              ],
              [
                50.8870831,
                29.2814907
              ],
              [
                50.8890299,
                29.2848265
              ],
              [
                50.88903,
                29.2853854
              ],
              [
                50.8912499,
                29.2856648
              ],
              [
                50.8926398,
                29.2856649
              ],
              [
                50.8931966,
                29.2853854
              ],
              [
                50.8926398,
                29.2798318
              ],
              [
                50.9019468,
                29.2783138
              ],
              [
                50.9037531,
                29.278164
              ],
              [
                50.9054196,
                29.2784345
              ],
              [
                50.905973,
                29.278714
              ],
              [
                50.9081963,
                29.278714
              ],
              [
                50.9147608,
                29.2769413
              ],
              [
                50.922645,
                29.2724649
              ],
              [
                50.9276421,
                29.2690142
              ],
              [
                50.9323307,
                29.2710283
              ],
              [
                50.9363752,
                29.2743646
              ],
              [
                50.9437355,
                29.2735608
              ],
              [
                50.9523372,
                29.2761187
              ],
              [
                50.9589682,
                29.2803851
              ],
              [
                50.9662016,
                29.2825475
              ],
              [
                50.9733289,
                29.2842839
              ],
              [
                50.9830194,
                29.28614
              ],
              [
                50.9863251,
                29.2893353
              ],
              [
                50.993365,
                29.2932513
              ],
              [
                51.001755,
                29.2949038
              ],
              [
                50.9999468,
                29.2989716
              ],
              [
                50.9997987,
                29.3035216
              ],
              [
                51.000038,
                29.3064655
              ],
              [
                51.0037548,
                29.3087178
              ],
              [
                51.004588,
                29.3081679
              ],
              [
                51.0051449,
                29.307609
              ],
              [
                51.0054214,
                29.305941
              ],
              [
                51.0057015,
                29.3048231
              ],
              [
                51.0062548,
                29.3026052
              ],
              [
                51.0065347,
                29.3012168
              ],
              [
                51.0079215,
                29.2939954
              ],
              [
                51.0082014,
                29.2923275
              ],
              [
                51.0084781,
                29.2909391
              ],
              [
                51.0087548,
                29.2889918
              ],
              [
                51.0090348,
                29.2876034
              ],
              [
                51.0093113,
                29.2862149
              ],
              [
                51.0095881,
                29.2848265
              ],
              [
                51.0098681,
                29.2826087
              ],
              [
                51.0101448,
                29.2803819
              ],
              [
                51.0104214,
                29.2784346
              ],
              [
                51.0107015,
                29.2764963
              ],
              [
                51.010978,
                29.27399
              ],
              [
                51.0112548,
                29.2726016
              ],
              [
                51.0115347,
                29.2714927
              ],
              [
                51.0118115,
                29.2709338
              ],
              [
                51.0118114,
                29.2701044
              ],
              [
                51.0123681,
                29.2676071
              ],
              [
                51.0126446,
                29.2667687
              ],
              [
                51.0129214,
                29.2659393
              ],
              [
                51.0132016,
                29.2656598
              ],
              [
                51.0212579,
                29.2556619
              ],
              [
                51.0218112,
                29.2556619
              ],
              [
                51.0434809,
                29.2401017
              ],
              [
                51.0451477,
                29.2392723
              ],
              [
                51.0612573,
                29.2292656
              ],
              [
                51.0698706,
                29.2201065
              ],
              [
                51.0765374,
                29.2017702
              ],
              [
                51.0765373,
                29.2012114
              ],
              [
                51.0768138,
                29.1989937
              ],
              [
                51.077094,
                29.1945495
              ],
              [
                51.0773705,
                29.19427
              ],
              [
                51.0720941,
                29.1581578
              ],
              [
                51.071814,
                29.1537137
              ],
              [
                51.0720941,
                29.1531548
              ],
              [
                51.0720941,
                29.1448256
              ],
              [
                51.0723707,
                29.1437169
              ],
              [
                51.0723707,
                29.1417697
              ],
              [
                51.0726473,
                29.1401021
              ],
              [
                51.0724687,
                29.1375595
              ],
              [
                51.0716799,
                29.1370338
              ],
              [
                51.0734807,
                29.136217
              ],
              [
                51.0734807,
                29.1359375
              ],
              [
                51.0737608,
                29.1350992
              ],
              [
                51.0737608,
                29.1348198
              ],
              [
                51.0809755,
                29.1256601
              ],
              [
                51.0898501,
                29.1234
              ],
              [
                51.100372,
                29.1217592
              ],
              [
                51.1030211,
                29.1211218
              ],
              [
                51.1055518,
                29.1207397
              ],
              [
                51.1083591,
                29.1207282
              ],
              [
                51.115763,
                29.1216683
              ],
              [
                51.1185659,
                29.1236784
              ],
              [
                51.1213112,
                29.1250825
              ],
              [
                51.1250559,
                29.1275942
              ],
              [
                51.1293032,
                29.1333093
              ],
              [
                51.1317366,
                29.1342089
              ],
              [
                51.1350171,
                29.1311896
              ],
              [
                51.137051,
                29.1265786
              ],
              [
                51.1410408,
                29.1235625
              ],
              [
                51.1508314,
                29.1224465
              ],
              [
                51.1546775,
                29.1188249
              ],
              [
                51.1618194,
                29.1251027
              ],
              [
                51.1676528,
                29.1267703
              ],
              [
                51.1729292,
                29.1267703
              ],
              [
                51.1734858,
                29.1270498
              ],
              [
                51.1790423,
                29.1278791
              ],
              [
                51.1815424,
                29.127879
              ],
              [
                51.1826523,
                29.1281585
              ],
              [
                51.1843189,
                29.1281585
              ],
              [
                51.1857091,
                29.1284379
              ],
              [
                51.1920989,
                29.1292672
              ],
              [
                51.1943188,
                29.1292672
              ],
              [
                51.1951522,
                29.1295467
              ],
              [
                51.1982087,
                29.1295466
              ],
              [
                51.1984855,
                29.1298261
              ],
              [
                51.2001521,
                29.1298261
              ],
              [
                51.2004322,
                29.1301055
              ],
              [
                51.2012654,
                29.1301055
              ],
              [
                51.2079319,
                29.1320436
              ],
              [
                51.2090419,
                29.1320437
              ],
              [
                51.222655,
                29.1359377
              ],
              [
                51.2240452,
                29.1367671
              ],
              [
                51.2248785,
                29.136767
              ],
              [
                51.2295983,
                29.1381552
              ],
              [
                51.2323782,
                29.1389936
              ],
              [
                51.2326551,
                29.139273
              ],
              [
                51.2334883,
                29.139273
              ],
              [
                51.233765,
                29.1395524
              ],
              [
                51.2365449,
                29.1403818
              ],
              [
                51.2376549,
                29.1403818
              ],
              [
                51.2379315,
                29.1406612
              ],
              [
                51.2421014,
                29.1420494
              ],
              [
                51.2432115,
                29.1420494
              ],
              [
                51.2743243,
                29.1517668
              ],
              [
                51.2762677,
                29.1517667
              ],
              [
                51.2768244,
                29.1514874
              ],
              [
                51.2818242,
                29.1500992
              ],
              [
                51.2834909,
                29.1487109
              ],
              [
                51.2871007,
                29.1451052
              ],
              [
                51.2871007,
                29.1448258
              ],
              [
                51.2890474,
                29.1425993
              ],
              [
                51.3215985,
                29.1234628
              ],
              [
                51.3291706,
                29.1206154
              ],
              [
                51.3300025,
                29.1204021
              ],
              [
                51.3299674,
                29.1187875
              ],
              [
                51.3343626,
                29.1121718
              ],
              [
                51.3348109,
                29.1078726
              ],
              [
                51.3394876,
                29.100019
              ],
              [
                51.3448787,
                29.090879
              ],
              [
                51.3518001,
                29.0808986
              ],
              [
                51.3598375,
                29.0717635
              ],
              [
                51.3687972,
                29.0603639
              ],
              [
                51.3754911,
                29.0530559
              ],
              [
                51.3850364,
                29.02587
              ],
              [
                51.3971496,
                29.0025268
              ],
              [
                51.403016,
                28.9924406
              ],
              [
                51.4067261,
                28.9848963
              ],
              [
                51.4119841,
                28.9776712
              ],
              [
                51.4236705,
                28.9712087
              ],
              [
                51.4265522,
                28.9645484
              ],
              [
                51.4297055,
                28.9480977
              ],
              [
                51.4307573,
                28.9319622
              ],
              [
                51.4362715,
                28.9226832
              ],
              [
                51.4428005,
                28.9198646
              ],
              [
                51.4505336,
                28.908003
              ],
              [
                51.4537202,
                28.8959526
              ],
              [
                51.4867399,
                28.8461775
              ],
              [
                51.5052998,
                28.8230284
              ],
              [
                51.4949085,
                28.8140689
              ],
              [
                51.5170364,
                28.7949806
              ],
              [
                51.5307242,
                28.7873239
              ],
              [
                51.5326674,
                28.7848188
              ],
              [
                51.5337809,
                28.7834312
              ],
              [
                51.5356313,
                28.7815813
              ],
              [
                51.5382242,
                28.7789889
              ],
              [
                51.5599205,
                28.7626184
              ],
              [
                51.549546,
                28.7503956
              ],
              [
                51.5603657,
                28.7395346
              ],
              [
                51.570329,
                28.728894
              ],
              [
                51.5833171,
                28.718279
              ],
              [
                51.6001815,
                28.7095251
              ],
              [
                51.6092547,
                28.7111705
              ],
              [
                51.6076731,
                28.6992561
              ],
              [
                51.6110065,
                28.693706
              ],
              [
                51.6176729,
                28.6842637
              ],
              [
                51.6246162,
                28.6764882
              ],
              [
                51.6293396,
                28.6656496
              ],
              [
                51.6296162,
                28.6653703
              ],
              [
                51.6298963,
                28.6645414
              ],
              [
                51.6298962,
                28.6617574
              ],
              [
                51.6307294,
                28.6603699
              ],
              [
                51.677074,
                28.6633688
              ],
              [
                51.6794729,
                28.6653239
              ],
              [
                51.682949,
                28.6666042
              ],
              [
                51.6860541,
                28.6674136
              ],
              [
                51.6884483,
                28.6685056
              ],
              [
                51.6891638,
                28.6693686
              ],
              [
                51.689837,
                28.6702755
              ],
              [
                51.6914159,
                28.6739059
              ],
              [
                51.6940212,
                28.6741537
              ],
              [
                51.6954373,
                28.6730242
              ],
              [
                51.697788,
                28.6700999
              ],
              [
                51.7496209,
                28.6667578
              ],
              [
                51.7599008,
                28.6667579
              ],
              [
                51.7637908,
                28.6664876
              ],
              [
                51.7740673,
                28.6664876
              ],
              [
                51.7762905,
                28.6662083
              ],
              [
                51.7901805,
                28.6656497
              ],
              [
                51.7940704,
                28.6653704
              ],
              [
                51.8001803,
                28.6653705
              ],
              [
                51.8021235,
                28.6651001
              ],
              [
                51.8179601,
                28.6651002
              ],
              [
                51.8232365,
                28.6653704
              ],
              [
                51.8737958,
                28.6720376
              ],
              [
                51.8751823,
                28.6720376
              ],
              [
                51.9235183,
                28.6820385
              ],
              [
                51.9262983,
                28.6825881
              ],
              [
                51.9299083,
                28.6837053
              ],
              [
                51.9460213,
                28.6867596
              ],
              [
                51.9732442,
                28.6889851
              ],
              [
                51.9793541,
                28.6889851
              ],
              [
                51.9810208,
                28.6892645
              ],
              [
                51.9829674,
                28.6892644
              ],
              [
                51.9840774,
                28.6895437
              ],
              [
                51.9865773,
                28.6895437
              ],
              [
                51.9885207,
                28.689814
              ],
              [
                51.9907439,
                28.6903726
              ],
              [
                51.9918539,
                28.6903726
              ],
              [
                51.9926872,
                28.6906519
              ],
              [
                51.9932439,
                28.6909312
              ],
              [
                51.993244,
                28.6912015
              ],
              [
                51.9929672,
                28.6917601
              ],
              [
                51.9929672,
                28.6920395
              ],
              [
                51.9929672,
                28.69704
              ],
              [
                51.9926871,
                28.6975896
              ],
              [
                51.9810206,
                28.7439831
              ],
              [
                51.9807441,
                28.7445416
              ],
              [
                51.9807442,
                28.7456499
              ],
              [
                51.9788007,
                28.7570392
              ],
              [
                51.9743541,
                28.7795388
              ],
              [
                51.9709425,
                28.7897765
              ],
              [
                51.9604644,
                28.8212057
              ],
              [
                51.9590776,
                28.8234315
              ],
              [
                51.9443545,
                28.8381469
              ],
              [
                51.9432412,
                28.8392643
              ],
              [
                51.9321314,
                28.8520425
              ],
              [
                51.9235182,
                28.8645415
              ],
              [
                51.906575,
                28.8959295
              ],
              [
                51.8962952,
                28.9223168
              ],
              [
                51.8962952,
                28.9225961
              ],
              [
                51.8960186,
                28.923155
              ],
              [
                51.8951852,
                28.9253719
              ],
              [
                51.8951852,
                28.9264894
              ],
              [
                51.8887952,
                28.9450998
              ],
              [
                51.8882386,
                28.945929
              ],
              [
                51.887962,
                28.9473169
              ],
              [
                51.8768487,
                28.9617639
              ],
              [
                51.8648306,
                28.9759208
              ],
              [
                51.8146704,
                29.0238477
              ],
              [
                51.79304,
                29.0421466
              ],
              [
                51.7946233,
                29.046765
              ],
              [
                51.7949032,
                29.0473239
              ],
              [
                51.7987117,
                29.0606513
              ],
              [
                51.8013607,
                29.0653872
              ],
              [
                51.80462,
                29.0720075
              ],
              [
                51.8093656,
                29.0797703
              ],
              [
                51.8140504,
                29.0874596
              ],
              [
                51.817156,
                29.0906805
              ],
              [
                51.8117356,
                29.0962112
              ],
              [
                51.8078013,
                29.1003362
              ],
              [
                51.8016333,
                29.1065415
              ],
              [
                51.7908628,
                29.1178485
              ],
              [
                51.7806936,
                29.1272821
              ],
              [
                51.7677718,
                29.1417916
              ],
              [
                51.7559354,
                29.1532336
              ],
              [
                51.7425094,
                29.1675985
              ],
              [
                51.7365288,
                29.1730751
              ],
              [
                51.7267236,
                29.1820903
              ],
              [
                51.7216608,
                29.1865195
              ],
              [
                51.718923,
                29.1890381
              ],
              [
                51.7117194,
                29.1962733
              ],
              [
                51.7052436,
                29.2034832
              ],
              [
                51.7045783,
                29.2076905
              ],
              [
                51.6812797,
                29.2302746
              ],
              [
                51.677118,
                29.230943
              ],
              [
                51.6765648,
                29.2312135
              ],
              [
                51.6760081,
                29.2323223
              ],
              [
                51.6740614,
                29.2342696
              ],
              [
                51.6668417,
                29.2451057
              ],
              [
                51.6660082,
                29.2459351
              ],
              [
                51.6654517,
                29.247044
              ],
              [
                51.6629516,
                29.250659
              ],
              [
                51.635172,
                29.2887219
              ],
              [
                51.6348954,
                29.2895514
              ],
              [
                51.6337821,
                29.2906602
              ],
              [
                51.6335053,
                29.2914987
              ],
              [
                51.6326721,
                29.2923281
              ],
              [
                51.6221155,
                29.3126042
              ],
              [
                51.6218389,
                29.3137222
              ],
              [
                51.6207289,
                29.3173286
              ],
              [
                51.5926692,
                29.3826047
              ],
              [
                51.5926692,
                29.3828842
              ],
              [
                51.5921288,
                29.3834844
              ],
              [
                51.5901693,
                29.3856613
              ],
              [
                51.5885026,
                29.3889973
              ],
              [
                51.5871159,
                29.3912154
              ],
              [
                51.587116,
                29.3914949
              ],
              [
                51.5865592,
                29.3914949
              ],
              [
                51.5860026,
                29.3920538
              ],
              [
                51.5826694,
                29.3931629
              ],
              [
                51.5810026,
                29.3931629
              ],
              [
                51.5810028,
                29.3934424
              ],
              [
                51.5796126,
                29.3934424
              ],
              [
                51.5793361,
                29.3937219
              ],
              [
                51.5776694,
                29.3937219
              ],
              [
                51.5771129,
                29.3934424
              ],
              [
                51.5746128,
                29.3951104
              ],
              [
                51.5746128,
                29.3956694
              ],
              [
                51.5743362,
                29.3959399
              ],
              [
                51.5718361,
                29.400385
              ],
              [
                51.5698929,
                29.400385
              ],
              [
                51.5696128,
                29.4006645
              ],
              [
                51.5687796,
                29.4006645
              ],
              [
                51.567113,
                29.4042711
              ],
              [
                51.5665597,
                29.4045506
              ],
              [
                51.5662796,
                29.4051097
              ],
              [
                51.5601697,
                29.4084458
              ],
              [
                51.559613,
                29.4089957
              ],
              [
                51.557113,
                29.4098343
              ],
              [
                51.5557232,
                29.4101048
              ],
              [
                51.5546131,
                29.4109433
              ],
              [
                51.5535031,
                29.4117729
              ],
              [
                51.5518365,
                29.4142705
              ],
              [
                51.5529465,
                29.4212223
              ],
              [
                51.5526697,
                29.4217723
              ],
              [
                51.5523899,
                29.4242699
              ],
              [
                51.5515564,
                29.425388
              ],
              [
                51.53989,
                29.4339989
              ],
              [
                51.5315568,
                29.4381647
              ],
              [
                51.5304468,
                29.4381647
              ],
              [
                51.52989,
                29.4384442
              ],
              [
                51.5240569,
                29.4384442
              ],
              [
                51.5237768,
                29.4387237
              ],
              [
                51.5226669,
                29.4387237
              ],
              [
                51.5221101,
                29.4390032
              ],
              [
                51.5210002,
                29.4390032
              ],
              [
                51.5193335,
                29.4398328
              ],
              [
                51.5179435,
                29.4409418
              ],
              [
                51.5179435,
                29.4420509
              ],
              [
                51.5176669,
                29.4423304
              ],
              [
                51.5173904,
                29.4451076
              ],
              [
                51.5171103,
                29.4462258
              ],
              [
                51.5118337,
                29.4512211
              ],
              [
                51.5085004,
                29.4528891
              ],
              [
                51.5076671,
                29.4528892
              ],
              [
                51.5073904,
                29.4531687
              ],
              [
                51.5054438,
                29.4531687
              ],
              [
                51.5051671,
                29.4528891
              ],
              [
                51.5043339,
                29.4528891
              ],
              [
                51.5037772,
                29.4526096
              ],
              [
                51.5023871,
                29.4526097
              ],
              [
                51.490444,
                29.4487233
              ],
              [
                51.4898873,
                29.4484439
              ],
              [
                51.4896108,
                29.4487234
              ],
              [
                51.4885008,
                29.4487233
              ],
              [
                51.4846109,
                29.4506619
              ],
              [
                51.4834974,
                29.4537187
              ],
              [
                51.4832209,
                29.4545573
              ],
              [
                51.4832208,
                29.4548278
              ],
              [
                51.4832208,
                29.4559458
              ],
              [
                51.4857206,
                29.4601117
              ],
              [
                51.4859974,
                29.4612208
              ],
              [
                51.4846109,
                29.4623299
              ],
              [
                51.484054,
                29.4626094
              ],
              [
                51.4823873,
                29.4626094
              ],
              [
                51.4812775,
                29.4617798
              ],
              [
                51.4793309,
                29.4617798
              ],
              [
                51.4787775,
                29.4615004
              ],
              [
                51.4776642,
                29.4615003
              ],
              [
                51.4746108,
                29.462889
              ],
              [
                51.4746109,
                29.4626094
              ],
              [
                51.4698878,
                29.4626094
              ],
              [
                51.4662745,
                29.4617798
              ],
              [
                51.4657211,
                29.4617799
              ],
              [
                51.464331,
                29.4617798
              ],
              [
                51.4598878,
                29.4617798
              ],
              [
                51.4593311,
                29.4615003
              ],
              [
                51.4584979,
                29.4615003
              ],
              [
                51.4573879,
                29.4620503
              ],
              [
                51.4543313,
                29.4656662
              ],
              [
                51.4529411,
                29.4662252
              ],
              [
                51.4521079,
                29.4662252
              ],
              [
                51.4515546,
                29.4664957
              ],
              [
                51.4498879,
                29.4662252
              ],
              [
                51.4482214,
                29.4656662
              ],
              [
                51.4471081,
                29.4656661
              ],
              [
                51.4459981,
                29.4664957
              ],
              [
                51.4443315,
                29.4690025
              ],
              [
                51.4440514,
                29.4695525
              ],
              [
                51.4443314,
                29.4706616
              ],
              [
                51.4421081,
                29.4739979
              ],
              [
                51.4379415,
                29.4739979
              ],
              [
                51.4373848,
                29.4737184
              ],
              [
                51.4362748,
                29.4739979
              ],
              [
                51.4359983,
                29.4737184
              ],
              [
                51.4334982,
                29.4737183
              ],
              [
                51.4276615,
                29.475107
              ],
              [
                51.4226617,
                29.4734388
              ],
              [
                51.4123851,
                29.4626093
              ],
              [
                51.4087719,
                29.4617798
              ],
              [
                51.4079385,
                29.4620503
              ],
              [
                51.4068286,
                29.4628889
              ],
              [
                51.4040519,
                29.463998
              ],
              [
                51.4018287,
                29.463998
              ],
              [
                51.4012721,
                29.4642775
              ],
              [
                51.4009953,
                29.4639979
              ],
              [
                51.4004387,
                29.4642775
              ],
              [
                51.3979386,
                29.4642775
              ],
              [
                51.3973855,
                29.463998
              ],
              [
                51.396272,
                29.4639979
              ],
              [
                51.3959954,
                29.4637184
              ],
              [
                51.3948854,
                29.4637185
              ],
              [
                51.3915489,
                29.4615003
              ],
              [
                51.3898822,
                29.4615002
              ],
              [
                51.3851622,
                29.4642775
              ],
              [
                51.3826624,
                29.4690024
              ],
              [
                51.3815488,
                29.470941
              ],
              [
                51.379329,
                29.4717796
              ],
              [
                51.3768291,
                29.4717796
              ],
              [
                51.3759958,
                29.4715001
              ],
              [
                51.375439,
                29.4715001
              ],
              [
                51.3687724,
                29.464557
              ],
              [
                51.3676592,
                29.4639979
              ],
              [
                51.3668258,
                29.463998
              ],
              [
                51.365716,
                29.4634388
              ],
              [
                51.364606,
                29.4634389
              ],
              [
                51.3519992,
                29.4734668
              ],
              [
                51.3307129,
                29.490391
              ],
              [
                51.3304364,
                29.490941
              ],
              [
                51.3298797,
                29.490941
              ],
              [
                51.329603,
                29.4915
              ],
              [
                51.3276597,
                29.4926092
              ],
              [
                51.3273797,
                29.4928887
              ],
              [
                51.3265465,
                29.4931682
              ],
              [
                51.3209933,
                29.4976138
              ],
              [
                51.3043233,
                29.5178848
              ],
              [
                51.3029369,
                29.5198325
              ],
              [
                51.2979369,
                29.5301125
              ],
              [
                51.2973801,
                29.5306625
              ],
              [
                51.2784904,
                29.5826138
              ],
              [
                51.2782137,
                29.5840025
              ],
              [
                51.277657,
                29.5873392
              ],
              [
                51.277657,
                29.5876097
              ],
              [
                51.2773769,
                29.5881688
              ],
              [
                51.273085,
                29.5994327
              ],
              [
                51.2724124,
                29.6011977
              ],
              [
                51.2707103,
                29.6056639
              ],
              [
                51.2704337,
                29.6073322
              ],
              [
                51.2701572,
                29.6081709
              ],
              [
                51.2698771,
                29.6098303
              ],
              [
                51.2704338,
                29.6148353
              ],
              [
                51.2740436,
                29.6259458
              ],
              [
                51.2848803,
                29.641782
              ],
              [
                51.2873802,
                29.6448303
              ],
              [
                51.2965467,
                29.6584482
              ],
              [
                51.2996034,
                29.6784425
              ],
              [
                51.2993233,
                29.6790017
              ],
              [
                51.2979367,
                29.6845571
              ],
              [
                51.2979367,
                29.6851163
              ],
              [
                51.2973798,
                29.6856665
              ],
              [
                51.2970999,
                29.6865052
              ],
              [
                51.2880716,
                29.6941233
              ],
              [
                51.2873801,
                29.6948386
              ],
              [
                51.2868234,
                29.6951092
              ],
              [
                51.2865468,
                29.6953978
              ],
              [
                51.2782135,
                29.7006648
              ],
              [
                51.262377,
                29.7073387
              ],
              [
                51.2507107,
                29.7092777
              ],
              [
                51.2504339,
                29.7095573
              ],
              [
                51.2490441,
                29.7095574
              ],
              [
                51.2487673,
                29.7098369
              ],
              [
                51.2473773,
                29.7098369
              ],
              [
                51.2468206,
                29.7101165
              ],
              [
                51.2451538,
                29.7101165
              ],
              [
                51.2446008,
                29.7103961
              ],
              [
                51.2437673,
                29.7103961
              ],
              [
                51.2409874,
                29.7106757
              ],
              [
                51.2345975,
                29.7109463
              ],
              [
                51.2340441,
                29.7112259
              ],
              [
                51.2279309,
                29.7112258
              ],
              [
                51.2268209,
                29.7109462
              ],
              [
                51.2240444,
                29.7109462
              ],
              [
                51.2234876,
                29.7112258
              ],
              [
                51.2168212,
                29.7112258
              ],
              [
                51.2159877,
                29.7115054
              ],
              [
                51.2120978,
                29.7115053
              ],
              [
                51.2051545,
                29.7120555
              ],
              [
                51.2037647,
                29.7123352
              ],
              [
                51.1998748,
                29.7123351
              ],
              [
                51.1984847,
                29.7126147
              ],
              [
                51.1895982,
                29.7126147
              ],
              [
                51.1773749,
                29.713724
              ],
              [
                51.1743184,
                29.7142832
              ],
              [
                51.1726518,
                29.7142832
              ],
              [
                51.1654284,
                29.7165018
              ],
              [
                51.1623719,
                29.7176111
              ],
              [
                51.1137592,
                29.7409435
              ],
              [
                51.0937595,
                29.7498364
              ],
              [
                51.0901496,
                29.7509457
              ],
              [
                51.0512567,
                29.7709506
              ],
              [
                51.0398668,
                29.7742787
              ],
              [
                51.0395904,
                29.7745583
              ],
              [
                51.0387569,
                29.7745583
              ],
              [
                51.0382003,
                29.7745583
              ],
              [
                51.0376469,
                29.7748379
              ],
              [
                51.034867,
                29.7756676
              ],
              [
                51.0345904,
                29.7759472
              ],
              [
                51.033757,
                29.7759473
              ],
              [
                51.0332004,
                29.7762268
              ],
              [
                51.0318103,
                29.7762269
              ],
              [
                51.0315337,
                29.7765065
              ],
              [
                51.0257004,
                29.7765065
              ],
              [
                51.0226439,
                29.776777
              ],
              [
                51.0195905,
                29.7773362
              ],
              [
                51.0190339,
                29.7776159
              ],
              [
                51.0182006,
                29.7776158
              ],
              [
                51.0179239,
                29.7778954
              ],
              [
                51.0173673,
                29.7778954
              ],
              [
                50.9998675,
                29.7828922
              ],
              [
                50.9712547,
                29.7820624
              ],
              [
                50.9684745,
                29.7820623
              ],
              [
                50.9673646,
                29.7817827
              ],
              [
                50.9618081,
                29.7817827
              ],
              [
                50.9476415,
                29.780953
              ],
              [
                50.9451417,
                29.7806734
              ],
              [
                50.9362517,
                29.7806733
              ],
              [
                50.9345851,
                29.7803937
              ],
              [
                50.9318085,
                29.7803937
              ],
              [
                50.9301418,
                29.7801141
              ],
              [
                50.9273619,
                29.7801141
              ],
              [
                50.872916,
                29.7745581
              ],
              [
                50.8590263,
                29.7745581
              ],
              [
                50.8579163,
                29.7742785
              ],
              [
                50.852083,
                29.7742785
              ],
              [
                50.8476364,
                29.7740079
              ],
              [
                50.8443032,
                29.7734487
              ],
              [
                50.8373599,
                29.7734487
              ],
              [
                50.8365267,
                29.7737283
              ],
              [
                50.83458,
                29.7737282
              ],
              [
                50.8276367,
                29.7751173
              ],
              [
                50.8268299,
                29.7754366
              ],
              [
                50.8262469,
                29.774558
              ],
              [
                50.8262468,
                29.7715005
              ],
              [
                50.8229136,
                29.7651147
              ],
              [
                50.8234703,
                29.7640053
              ],
              [
                50.8254134,
                29.761507
              ],
              [
                50.8254134,
                29.7578903
              ],
              [
                50.8195804,
                29.7542826
              ],
              [
                50.8159703,
                29.7487267
              ],
              [
                50.8145802,
                29.7392836
              ],
              [
                50.8070805,
                29.7317797
              ],
              [
                50.8059671,
                29.7287223
              ],
              [
                50.8040238,
                29.7267831
              ],
              [
                50.7948573,
                29.7234461
              ],
              [
                50.7934674,
                29.7223367
              ],
              [
                50.792634,
                29.7198384
              ],
              [
                50.7937473,
                29.7165014
              ],
              [
                50.8001339,
                29.7126142
              ],
              [
                50.8040238,
                29.7126143
              ],
              [
                50.8043004,
                29.7123347
              ],
              [
                50.8048571,
                29.7123347
              ],
              [
                50.8056905,
                29.7117845
              ],
              [
                50.8065238,
                29.7117845
              ],
              [
                50.8084704,
                29.710116
              ],
              [
                50.8118037,
                29.7098364
              ],
              [
                50.8137471,
                29.7081679
              ],
              [
                50.8148571,
                29.7053901
              ],
              [
                50.8115238,
                29.7006642
              ],
              [
                50.8120804,
                29.6992844
              ],
              [
                50.8126371,
                29.6978864
              ],
              [
                50.8131904,
                29.6973363
              ],
              [
                50.813747,
                29.6973363
              ],
              [
                50.8140236,
                29.6967771
              ],
              [
                50.8148571,
                29.6962269
              ],
              [
                50.8165237,
                29.6926194
              ],
              [
                50.8143037,
                29.689553
              ],
              [
                50.8140237,
                29.6851158
              ],
              [
                50.8145804,
                29.6823381
              ],
              [
                50.8148571,
                29.6801104
              ],
              [
                50.8151372,
                29.6790012
              ],
              [
                50.8137471,
                29.673166
              ],
              [
                50.8131904,
                29.6728865
              ],
              [
                50.8084705,
                29.6728865
              ],
              [
                50.8079138,
                29.6734456
              ],
              [
                50.8070806,
                29.6737252
              ],
              [
                50.8056905,
                29.6737251
              ],
              [
                50.8043005,
                29.673166
              ],
              [
                50.8034672,
                29.6684493
              ],
              [
                50.8040239,
                29.6670604
              ],
              [
                50.8051339,
                29.6656715
              ],
              [
                50.805414,
                29.6634529
              ],
              [
                50.8031906,
                29.6587273
              ],
              [
                50.8026338,
                29.6573384
              ],
              [
                50.8012473,
                29.6548403
              ],
              [
                50.7968008,
                29.6523331
              ],
              [
                50.7962474,
                29.6490053
              ],
              [
                50.796524,
                29.6476075
              ],
              [
                50.7970806,
                29.6467777
              ],
              [
                50.796524,
                29.6423317
              ],
              [
                50.7954141,
                29.6403926
              ],
              [
                50.7951341,
                29.6390038
              ],
              [
                50.7951341,
                29.6387555
              ],
              [
                50.7951341,
                29.6384447
              ],
              [
                50.7951341,
                29.637615
              ],
              [
                50.7956908,
                29.637615
              ],
              [
                50.796524,
                29.6373354
              ],
              [
                50.7979141,
                29.6373354
              ],
              [
                50.7995808,
                29.6370558
              ],
              [
                50.7998573,
                29.6373354
              ],
              [
                50.8006907,
                29.6373355
              ],
              [
                50.8012473,
                29.637615
              ],
              [
                50.8026338,
                29.637615
              ],
              [
                50.8034673,
                29.6378946
              ],
              [
                50.8048572,
                29.6378946
              ],
              [
                50.8062472,
                29.6370559
              ],
              [
                50.8062472,
                29.6364967
              ],
              [
                50.8043006,
                29.6337191
              ],
              [
                50.8026339,
                29.6326099
              ],
              [
                50.8026339,
                29.6320597
              ],
              [
                50.8018006,
                29.6309504
              ],
              [
                50.8012474,
                29.6278932
              ],
              [
                50.7984674,
                29.6123368
              ],
              [
                50.7981907,
                29.6076113
              ],
              [
                50.7973574,
                29.6026152
              ],
              [
                50.797634,
                29.602056
              ],
              [
                50.8018007,
                29.5998376
              ],
              [
                50.8027901,
                29.5997133
              ],
              [
                50.8040241,
                29.5995581
              ],
              [
                50.805134,
                29.598999
              ],
              [
                50.8070807,
                29.5959418
              ],
              [
                50.8070807,
                29.5951122
              ],
              [
                50.8073573,
                29.5937234
              ],
              [
                50.8073573,
                29.5934439
              ],
              [
                50.8065241,
                29.5906663
              ],
              [
                50.8068039,
                29.5903867
              ],
              [
                50.8068039,
                29.5896069
              ],
              [
                50.8068039,
                29.5884478
              ],
              [
                50.8073573,
                29.5884478
              ],
              [
                50.8076374,
                29.5881683
              ],
              [
                50.8081907,
                29.5881682
              ],
              [
                50.8112472,
                29.5867795
              ],
              [
                50.8112472,
                29.5862204
              ],
              [
                50.8084706,
                29.5845521
              ],
              [
                50.8062473,
                29.5842815
              ],
              [
                50.8048572,
                29.5831633
              ],
              [
                50.8059672,
                29.5820541
              ],
              [
                50.8090239,
                29.5812245
              ],
              [
                50.8101372,
                29.5803858
              ],
              [
                50.8145805,
                29.5731715
              ],
              [
                50.8148572,
                29.5717827
              ],
              [
                50.8151374,
                29.5709441
              ],
              [
                50.8159706,
                29.5687257
              ],
              [
                50.8159705,
                29.5684461
              ],
              [
                50.8159706,
                29.5676074
              ],
              [
                50.8156905,
                29.5667778
              ],
              [
                50.8123572,
                29.5634503
              ],
              [
                50.8137473,
                29.5603932
              ],
              [
                50.8134707,
                29.559275
              ],
              [
                50.8112472,
                29.559275
              ],
              [
                50.8109707,
                29.5595546
              ],
              [
                50.8081908,
                29.5581658
              ],
              [
                50.811524,
                29.5526109
              ],
              [
                50.8106907,
                29.5464969
              ],
              [
                50.8054142,
                29.5417807
              ],
              [
                50.8051341,
                29.5387237
              ],
              [
                50.8054142,
                29.5378851
              ],
              [
                50.8054142,
                29.5356667
              ],
              [
                50.8051341,
                29.5342781
              ],
              [
                50.8046092,
                29.5333613
              ],
              [
                50.8040241,
                29.5323393
              ],
              [
                50.8037476,
                29.5292733
              ],
              [
                50.8038723,
                29.5290252
              ],
              [
                50.8040242,
                29.5287232
              ],
              [
                50.8037476,
                29.5245571
              ],
              [
                50.802634,
                29.5228889
              ],
              [
                50.8018008,
                29.5223389
              ],
              [
                50.8018009,
                29.5215002
              ],
              [
                50.8012475,
                29.5203911
              ],
              [
                50.7993008,
                29.5087225
              ],
              [
                50.7906911,
                29.5042769
              ],
              [
                50.7901343,
                29.5039975
              ],
              [
                50.7865245,
                29.4995519
              ],
              [
                50.7859678,
                29.495945
              ],
              [
                50.7879145,
                29.4931677
              ],
              [
                50.7940244,
                29.487054
              ],
              [
                50.794301,
                29.4862244
              ],
              [
                50.7934677,
                29.4839972
              ],
              [
                50.7904144,
                29.4817789
              ],
              [
                50.786801,
                29.4834381
              ],
              [
                50.7806912,
                29.4812199
              ],
              [
                50.7765247,
                29.4739972
              ],
              [
                50.7765247,
                29.4734381
              ],
              [
                50.7790245,
                29.4690018
              ],
              [
                50.7795778,
                29.4687222
              ],
              [
                50.7826345,
                29.4628882
              ],
              [
                50.782078,
                29.4612201
              ],
              [
                50.7787446,
                29.4587223
              ],
              [
                50.7784679,
                29.4553861
              ],
              [
                50.7787446,
                29.4551066
              ],
              [
                50.7787447,
                29.4539975
              ],
              [
                50.779528,
                29.4536616
              ],
              [
                50.7826346,
                29.4523294
              ],
              [
                50.7834678,
                29.4523293
              ],
              [
                50.7850721,
                29.4516176
              ],
              [
                50.7859679,
                29.4512202
              ],
              [
                50.7890245,
                29.4487226
              ],
              [
                50.7893011,
                29.448443
              ],
              [
                50.7890245,
                29.4481636
              ],
              [
                50.7887478,
                29.4459364
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555018,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دشتی",
          "name:en": "Dashti County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270888",
          "wikipedia": "en:Dashti County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.9440729,
                28.0718545
              ],
              [
                50.991349,
                28.0120123
              ],
              [
                51.2555121,
                28.1784087
              ],
              [
                51.2756211,
                28.1699475
              ],
              [
                51.2787687,
                28.1686993
              ],
              [
                51.2790489,
                28.1684111
              ],
              [
                51.2796022,
                28.1684111
              ],
              [
                51.2798821,
                28.168141
              ],
              [
                51.2804354,
                28.1681409
              ],
              [
                51.2954626,
                28.1603717
              ],
              [
                51.2956782,
                28.1602602
              ],
              [
                51.2971019,
                28.159524
              ],
              [
                51.3034917,
                28.1586957
              ],
              [
                51.3090484,
                28.1556433
              ],
              [
                51.3096051,
                28.1542477
              ],
              [
                51.3093251,
                28.1534193
              ],
              [
                51.3084916,
                28.1489714
              ],
              [
                51.3118251,
                28.1461981
              ],
              [
                51.3129384,
                28.1428577
              ],
              [
                51.3129383,
                28.1392471
              ],
              [
                51.313215,
                28.1373023
              ],
              [
                51.3137716,
                28.1359157
              ],
              [
                51.315715,
                28.1347992
              ],
              [
                51.3176617,
                28.1347992
              ],
              [
                51.3237715,
                28.1445234
              ],
              [
                51.3246048,
                28.1486922
              ],
              [
                51.3265482,
                28.1492505
              ],
              [
                51.3268281,
                28.1489714
              ],
              [
                51.3282148,
                28.1489714
              ],
              [
                51.3284947,
                28.1486923
              ],
              [
                51.3296047,
                28.148143
              ],
              [
                51.334328,
                28.1453609
              ],
              [
                51.335438,
                28.1453608
              ],
              [
                51.3373847,
                28.1473056
              ],
              [
                51.3390514,
                28.1475758
              ],
              [
                51.3418279,
                28.1461982
              ],
              [
                51.3426611,
                28.1453608
              ],
              [
                51.3426612,
                28.1423085
              ],
              [
                51.3429379,
                28.1420204
              ],
              [
                51.3429379,
                28.1414711
              ],
              [
                51.3448845,
                28.1375814
              ],
              [
                51.3457178,
                28.1367441
              ],
              [
                51.3465512,
                28.136474
              ],
              [
                51.3482179,
                28.136474
              ],
              [
                51.3496045,
                28.1361949
              ],
              [
                51.3509943,
                28.1367441
              ],
              [
                51.3526611,
                28.1386979
              ],
              [
                51.355441,
                28.1423085
              ],
              [
                51.3565511,
                28.1420204
              ],
              [
                51.3571077,
                28.1414711
              ],
              [
                51.3587743,
                28.1375815
              ],
              [
                51.3590509,
                28.1353575
              ],
              [
                51.3593277,
                28.1342501
              ],
              [
                51.361551,
                28.1320262
              ],
              [
                51.3623842,
                28.131747
              ],
              [
                51.3634942,
                28.131747
              ],
              [
                51.3732174,
                28.1356367
              ],
              [
                51.374884,
                28.1370323
              ],
              [
                51.377384,
                28.1378607
              ],
              [
                51.3801639,
                28.1378607
              ],
              [
                51.3809974,
                28.1375815
              ],
              [
                51.3843307,
                28.1375815
              ],
              [
                51.3843307,
                28.1373024
              ],
              [
                51.384884,
                28.1373024
              ],
              [
                51.3854406,
                28.1367442
              ],
              [
                51.3862738,
                28.1347993
              ],
              [
                51.3890504,
                28.1278574
              ],
              [
                51.3893306,
                28.1248052
              ],
              [
                51.3901637,
                28.121753
              ],
              [
                51.3951638,
                28.1164678
              ],
              [
                51.3962736,
                28.1159186
              ],
              [
                51.3971071,
                28.1159186
              ],
              [
                51.3976637,
                28.1156396
              ],
              [
                51.402387,
                28.1156396
              ],
              [
                51.4059968,
                28.1167469
              ],
              [
                51.4076635,
                28.1178544
              ],
              [
                51.4123868,
                28.1236978
              ],
              [
                51.4129435,
                28.1264709
              ],
              [
                51.4129435,
                28.1289739
              ],
              [
                51.4112768,
                28.1334218
              ],
              [
                51.4115536,
                28.1364741
              ],
              [
                51.4123868,
                28.1370323
              ],
              [
                51.4165534,
                28.1381398
              ],
              [
                51.4198867,
                28.138698
              ],
              [
                51.4215534,
                28.138698
              ],
              [
                51.42322,
                28.1384099
              ],
              [
                51.4234966,
                28.1381398
              ],
              [
                51.4282199,
                28.1381398
              ],
              [
                51.4284965,
                28.1378607
              ],
              [
                51.4296099,
                28.1378607
              ],
              [
                51.4298865,
                28.1375815
              ],
              [
                51.4332198,
                28.1367443
              ],
              [
                51.4351665,
                28.1364741
              ],
              [
                51.4376665,
                28.1364741
              ],
              [
                51.4379431,
                28.136195
              ],
              [
                51.4384998,
                28.136195
              ],
              [
                51.4393331,
                28.1356367
              ],
              [
                51.4412764,
                28.1339711
              ],
              [
                51.440443,
                28.1300814
              ],
              [
                51.4387763,
                28.1295232
              ],
              [
                51.4362765,
                28.1267501
              ],
              [
                51.4359999,
                28.1239679
              ],
              [
                51.4376665,
                28.1223023
              ],
              [
                51.4396097,
                28.1214649
              ],
              [
                51.4409998,
                28.1211947
              ],
              [
                51.4432195,
                28.1211948
              ],
              [
                51.444333,
                28.121753
              ],
              [
                51.4490562,
                28.1289739
              ],
              [
                51.4498896,
                28.131468
              ],
              [
                51.4582227,
                28.1525821
              ],
              [
                51.4618327,
                28.1556434
              ],
              [
                51.4654426,
                28.1570301
              ],
              [
                51.466276,
                28.1570301
              ],
              [
                51.4687794,
                28.1561928
              ],
              [
                51.4690559,
                28.1556435
              ],
              [
                51.4721126,
                28.1539688
              ],
              [
                51.4732226,
                28.1536986
              ],
              [
                51.4746124,
                28.1536986
              ],
              [
                51.4754459,
                28.1542479
              ],
              [
                51.4776658,
                28.1570301
              ],
              [
                51.4812789,
                28.1581376
              ],
              [
                51.4871123,
                28.1600825
              ],
              [
                51.490169,
                28.1600825
              ],
              [
                51.4907223,
                28.1598034
              ],
              [
                51.4987786,
                28.1598034
              ],
              [
                51.4996121,
                28.1600825
              ],
              [
                51.5010021,
                28.1600825
              ],
              [
                51.5060021,
                28.1617482
              ],
              [
                51.507112,
                28.1625766
              ],
              [
                51.5079452,
                28.1650799
              ],
              [
                51.5085019,
                28.165638
              ],
              [
                51.5104453,
                28.1711936
              ],
              [
                51.517945,
                28.1753626
              ],
              [
                51.5187785,
                28.1753626
              ],
              [
                51.5212783,
                28.1764701
              ],
              [
                51.5240583,
                28.178136
              ],
              [
                51.5287817,
                28.1825841
              ],
              [
                51.5301683,
                28.186474
              ],
              [
                51.5298915,
                28.1889683
              ],
              [
                51.5296149,
                28.1898056
              ],
              [
                51.5293348,
                28.1900848
              ],
              [
                51.5285016,
                28.1934164
              ],
              [
                51.5248915,
                28.1971667
              ],
              [
                51.5248916,
                28.1973063
              ],
              [
                51.5254485,
                28.1975855
              ],
              [
                51.526835,
                28.1978556
              ],
              [
                51.5273917,
                28.1978556
              ],
              [
                51.5304484,
                28.198693
              ],
              [
                51.5385014,
                28.2017455
              ],
              [
                51.539058,
                28.2023038
              ],
              [
                51.5423913,
                28.2036905
              ],
              [
                51.5435048,
                28.204528
              ],
              [
                51.5448914,
                28.2050863
              ],
              [
                51.5665611,
                28.2164682
              ],
              [
                51.5760042,
                28.2195298
              ],
              [
                51.5771141,
                28.2195298
              ],
              [
                51.581004,
                28.2209166
              ],
              [
                51.6221167,
                28.2303626
              ],
              [
                51.6271167,
                28.2311911
              ],
              [
                51.6287834,
                28.2317495
              ],
              [
                51.6382299,
                28.2336945
              ],
              [
                51.6407299,
                28.2345229
              ],
              [
                51.6660094,
                28.2406464
              ],
              [
                51.6707292,
                28.241754
              ],
              [
                51.7110086,
                28.2506421
              ],
              [
                51.7129553,
                28.250642
              ],
              [
                51.7148986,
                28.2511913
              ],
              [
                51.7162886,
                28.2511914
              ],
              [
                51.7167072,
                28.2514706
              ],
              [
                51.7176787,
                28.2514705
              ],
              [
                51.7182319,
                28.2511914
              ],
              [
                51.7187887,
                28.2511914
              ],
              [
                51.7254552,
                28.248697
              ],
              [
                51.7465682,
                28.230642
              ],
              [
                51.8354603,
                28.1639725
              ],
              [
                51.8543499,
                28.1473061
              ],
              [
                51.8601833,
                28.142309
              ],
              [
                51.8632398,
                28.1395268
              ],
              [
                51.8637966,
                28.1406432
              ],
              [
                51.875463,
                28.1450822
              ],
              [
                51.8765729,
                28.1450821
              ],
              [
                51.8782395,
                28.1456404
              ],
              [
                51.8793496,
                28.1456405
              ],
              [
                51.8799062,
                28.1459196
              ],
              [
                51.8810162,
                28.1459195
              ],
              [
                51.8818494,
                28.1461986
              ],
              [
                51.8846295,
                28.1467479
              ],
              [
                51.9054625,
                28.1484137
              ],
              [
                51.9068524,
                28.1486928
              ],
              [
                51.9215754,
                28.1486928
              ],
              [
                51.9229655,
                28.1484136
              ],
              [
                51.9271322,
                28.1484137
              ],
              [
                51.9282422,
                28.1481435
              ],
              [
                51.9301854,
                28.1481436
              ],
              [
                51.9327053,
                28.1475763
              ],
              [
                51.9443552,
                28.1453613
              ],
              [
                51.960465,
                28.1409134
              ],
              [
                51.9735215,
                28.1361955
              ],
              [
                51.9762979,
                28.1347998
              ],
              [
                51.9796347,
                28.1336924
              ],
              [
                51.9799113,
                28.1331342
              ],
              [
                51.9835213,
                28.1311893
              ],
              [
                51.9846346,
                28.1300819
              ],
              [
                51.9868546,
                28.1289744
              ],
              [
                51.9874112,
                28.1284162
              ],
              [
                51.9885212,
                28.1281371
              ],
              [
                51.9913012,
                28.1267504
              ],
              [
                52.0151908,
                28.1148027
              ],
              [
                52.0168574,
                28.1142445
              ],
              [
                52.0271339,
                28.1123087
              ],
              [
                52.0276906,
                28.1120296
              ],
              [
                52.0365804,
                28.1120297
              ],
              [
                52.0440804,
                28.1125789
              ],
              [
                52.0488036,
                28.1134162
              ],
              [
                52.0563034,
                28.1161893
              ],
              [
                52.05686,
                28.1167476
              ],
              [
                52.0582468,
                28.1173057
              ],
              [
                52.0646368,
                28.1225818
              ],
              [
                52.0693599,
                28.1311894
              ],
              [
                52.0699132,
                28.1320268
              ],
              [
                52.0704699,
                28.1345298
              ],
              [
                52.0710265,
                28.1353581
              ],
              [
                52.0710266,
                28.1359164
              ],
              [
                52.0721365,
                28.1381403
              ],
              [
                52.0746366,
                28.1409135
              ],
              [
                52.0790831,
                28.1431375
              ],
              [
                52.0910262,
                28.1445241
              ],
              [
                52.0938062,
                28.1450823
              ],
              [
                52.0957496,
                28.1450824
              ],
              [
                52.0999161,
                28.1459197
              ],
              [
                52.1163058,
                28.1548067
              ],
              [
                52.1401955,
                28.1734182
              ],
              [
                52.1414772,
                28.1741821
              ],
              [
                52.1413055,
                28.1745258
              ],
              [
                52.1413055,
                28.1748048
              ],
              [
                52.1254724,
                28.1995309
              ],
              [
                52.1218624,
                28.2111919
              ],
              [
                52.1215824,
                28.2134161
              ],
              [
                52.1213057,
                28.2203587
              ],
              [
                52.1215824,
                28.2239696
              ],
              [
                52.1218625,
                28.2289763
              ],
              [
                52.1235291,
                28.258702
              ],
              [
                52.1232489,
                28.2598096
              ],
              [
                52.1229722,
                28.2623041
              ],
              [
                52.1126959,
                28.2945346
              ],
              [
                52.1121392,
                28.2950839
              ],
              [
                52.1113058,
                28.2973083
              ],
              [
                52.1060258,
                28.3064761
              ],
              [
                52.1040826,
                28.3106458
              ],
              [
                52.0971393,
                28.324812
              ],
              [
                52.0808427,
                28.3638461
              ],
              [
                52.0590798,
                28.4159215
              ],
              [
                52.0560266,
                28.4225867
              ],
              [
                52.0558232,
                28.4230686
              ],
              [
                52.0540799,
                28.4284232
              ],
              [
                52.0540799,
                28.4295311
              ],
              [
                52.0540799,
                28.4298104
              ],
              [
                52.0513032,
                28.4409252
              ],
              [
                52.0510231,
                28.4417539
              ],
              [
                52.0501899,
                28.4464737
              ],
              [
                52.0496366,
                28.4500856
              ],
              [
                52.04908,
                28.4539769
              ],
              [
                52.0485233,
                28.4575888
              ],
              [
                52.04797,
                28.4609215
              ],
              [
                52.0438035,
                28.4867553
              ],
              [
                52.03797,
                28.5173101
              ],
              [
                52.0374134,
                28.5214809
              ],
              [
                52.03658,
                28.528147
              ],
              [
                52.0363035,
                28.5292549
              ],
              [
                52.0360234,
                28.5312007
              ],
              [
                52.0354701,
                28.5411999
              ],
              [
                52.0210236,
                28.5989812
              ],
              [
                52.0207469,
                28.6014767
              ],
              [
                52.0201902,
                28.6031524
              ],
              [
                52.0199137,
                28.6056479
              ],
              [
                52.0135237,
                28.6309275
              ],
              [
                52.0113004,
                28.6348195
              ],
              [
                52.0107438,
                28.6350987
              ],
              [
                52.010467,
                28.6362069
              ],
              [
                52.0101904,
                28.6370358
              ],
              [
                52.0096338,
                28.6381439
              ],
              [
                52.009357,
                28.6389818
              ],
              [
                52.009357,
                28.6392611
              ],
              [
                52.0074105,
                28.6459281
              ],
              [
                52.0071337,
                28.6464776
              ],
              [
                52.0010239,
                28.6651003
              ],
              [
                52.0010239,
                28.6659291
              ],
              [
                51.9993572,
                28.6698123
              ],
              [
                51.9990771,
                28.6714792
              ],
              [
                51.9974104,
                28.6759299
              ],
              [
                51.9935205,
                28.6889851
              ],
              [
                51.993244,
                28.6903727
              ],
              [
                51.9932439,
                28.6909312
              ],
              [
                51.9926872,
                28.6906519
              ],
              [
                51.9918539,
                28.6903726
              ],
              [
                51.9907439,
                28.6903726
              ],
              [
                51.9885207,
                28.689814
              ],
              [
                51.9865773,
                28.6895437
              ],
              [
                51.9840774,
                28.6895437
              ],
              [
                51.9829674,
                28.6892644
              ],
              [
                51.9810208,
                28.6892645
              ],
              [
                51.9793541,
                28.6889851
              ],
              [
                51.9732442,
                28.6889851
              ],
              [
                51.9460213,
                28.6867596
              ],
              [
                51.9299083,
                28.6837053
              ],
              [
                51.9262983,
                28.6825881
              ],
              [
                51.9235183,
                28.6820385
              ],
              [
                51.8751823,
                28.6720376
              ],
              [
                51.8737958,
                28.6720376
              ],
              [
                51.8232365,
                28.6653704
              ],
              [
                51.8179601,
                28.6651002
              ],
              [
                51.8021235,
                28.6651001
              ],
              [
                51.8001803,
                28.6653705
              ],
              [
                51.7940704,
                28.6653704
              ],
              [
                51.7901805,
                28.6656497
              ],
              [
                51.7762905,
                28.6662083
              ],
              [
                51.7740673,
                28.6664876
              ],
              [
                51.7637908,
                28.6664876
              ],
              [
                51.7599008,
                28.6667579
              ],
              [
                51.7496209,
                28.6667578
              ],
              [
                51.697788,
                28.6700999
              ],
              [
                51.6954373,
                28.6730242
              ],
              [
                51.6940212,
                28.6741537
              ],
              [
                51.6914159,
                28.6739059
              ],
              [
                51.689837,
                28.6702755
              ],
              [
                51.6891638,
                28.6693686
              ],
              [
                51.6884483,
                28.6685056
              ],
              [
                51.6860541,
                28.6674136
              ],
              [
                51.682949,
                28.6666042
              ],
              [
                51.6794729,
                28.6653239
              ],
              [
                51.677074,
                28.6633688
              ],
              [
                51.6307294,
                28.6603699
              ],
              [
                51.6298962,
                28.6600907
              ],
              [
                51.6293396,
                28.6600907
              ],
              [
                51.6290628,
                28.6598114
              ],
              [
                51.6285061,
                28.6598114
              ],
              [
                51.6240629,
                28.6598113
              ],
              [
                51.5868369,
                28.6700913
              ],
              [
                51.5829503,
                28.6714788
              ],
              [
                51.5640604,
                28.6787045
              ],
              [
                51.5607239,
                28.6795334
              ],
              [
                51.5560038,
                28.6814796
              ],
              [
                51.5326675,
                28.689264
              ],
              [
                51.4896117,
                28.7059234
              ],
              [
                51.4818316,
                28.7092662
              ],
              [
                51.4601655,
                28.719817
              ],
              [
                51.4576654,
                28.7214839
              ],
              [
                51.4323858,
                28.7350984
              ],
              [
                51.4251625,
                28.7384321
              ],
              [
                51.4137761,
                28.7445412
              ],
              [
                51.3909964,
                28.7575973
              ],
              [
                51.3843298,
                28.7620396
              ],
              [
                51.3829399,
                28.7634272
              ],
              [
                51.3721065,
                28.7714828
              ],
              [
                51.3663453,
                28.7779651
              ],
              [
                51.3632168,
                28.7814847
              ],
              [
                51.3623834,
                28.7812053
              ],
              [
                51.3516795,
                28.7776405
              ],
              [
                51.3498838,
                28.7770423
              ],
              [
                51.3046044,
                28.758985
              ],
              [
                51.303771,
                28.758985
              ],
              [
                51.3021044,
                28.7584263
              ],
              [
                51.284048,
                28.7514791
              ],
              [
                51.2832146,
                28.7512088
              ],
              [
                51.2782146,
                28.7498122
              ],
              [
                51.2604352,
                28.7462079
              ],
              [
                51.2598783,
                28.7459286
              ],
              [
                51.2584884,
                28.74537
              ],
              [
                51.2534885,
                28.7442617
              ],
              [
                51.2526551,
                28.7437031
              ],
              [
                51.2515451,
                28.7434238
              ],
              [
                51.1868196,
                28.7237091
              ],
              [
                51.1854328,
                28.7237091
              ],
              [
                51.1845997,
                28.7234298
              ],
              [
                51.1782096,
                28.7234298
              ],
              [
                51.1748764,
                28.7234298
              ],
              [
                51.1743198,
                28.7234298
              ],
              [
                51.1729297,
                28.7231504
              ],
              [
                51.1712631,
                28.7231505
              ],
              [
                51.1698765,
                28.7228712
              ],
              [
                51.1679298,
                28.7228711
              ],
              [
                51.1598732,
                28.7217628
              ],
              [
                51.1515401,
                28.7184291
              ],
              [
                51.1445969,
                28.7117616
              ],
              [
                51.1443169,
                28.7114823
              ],
              [
                51.1443169,
                28.7109327
              ],
              [
                51.1443169,
                28.7106533
              ],
              [
                51.1434835,
                28.7081485
              ],
              [
                51.1434835,
                28.706761
              ],
              [
                51.1426501,
                28.6989763
              ],
              [
                51.1429302,
                28.6945345
              ],
              [
                51.1473734,
                28.6800916
              ],
              [
                51.1473735,
                28.6789835
              ],
              [
                51.1479301,
                28.6778753
              ],
              [
                51.1482068,
                28.676758
              ],
              [
                51.1484869,
                28.6756499
              ],
              [
                51.1487635,
                28.6745417
              ],
              [
                51.1490401,
                28.6731451
              ],
              [
                51.1493202,
                28.6728749
              ],
              [
                51.1493202,
                28.6711991
              ],
              [
                51.1493202,
                28.6709288
              ],
              [
                51.1495968,
                28.6706495
              ],
              [
                51.1498735,
                28.6698116
              ],
              [
                51.1495968,
                28.6606488
              ],
              [
                51.1507067,
                28.6528646
              ],
              [
                51.1509868,
                28.6514771
              ],
              [
                51.1507068,
                28.6375936
              ],
              [
                51.1509869,
                28.6353683
              ],
              [
                51.1548734,
                28.612593
              ],
              [
                51.1551535,
                28.6114759
              ],
              [
                51.1548735,
                28.6109264
              ],
              [
                51.1551536,
                28.6098182
              ],
              [
                51.1548735,
                28.6089804
              ],
              [
                51.1551536,
                28.6067552
              ],
              [
                51.1554302,
                28.6053678
              ],
              [
                51.1568203,
                28.5948184
              ],
              [
                51.1570968,
                28.5934219
              ],
              [
                51.1570969,
                28.5834222
              ],
              [
                51.1576534,
                28.5809267
              ],
              [
                51.1582068,
                28.578143
              ],
              [
                51.1593201,
                28.5681434
              ],
              [
                51.1595969,
                28.5625941
              ],
              [
                51.1673767,
                28.5431449
              ],
              [
                51.1737633,
                28.5231466
              ],
              [
                51.1804299,
                28.5006446
              ],
              [
                51.1848765,
                28.4903667
              ],
              [
                51.1943196,
                28.4737025
              ],
              [
                51.1959863,
                28.4703607
              ],
              [
                51.196543,
                28.4698111
              ],
              [
                51.2040429,
                28.4484185
              ],
              [
                51.2129328,
                28.4345294
              ],
              [
                51.2134896,
                28.432863
              ],
              [
                51.2190428,
                28.4220275
              ],
              [
                51.219876,
                28.4211989
              ],
              [
                51.2201561,
                28.4200909
              ],
              [
                51.2257127,
                28.4095348
              ],
              [
                51.2318226,
                28.3956463
              ],
              [
                51.2318225,
                28.3948086
              ],
              [
                51.2320991,
                28.3942593
              ],
              [
                51.2323792,
                28.3937009
              ],
              [
                51.232656,
                28.3931424
              ],
              [
                51.2373791,
                28.3867567
              ],
              [
                51.2390457,
                28.3834243
              ],
              [
                51.2782153,
                28.3278644
              ],
              [
                51.2898819,
                28.3139682
              ],
              [
                51.2898819,
                28.3134189
              ],
              [
                51.2896672,
                28.3127767
              ],
              [
                51.2859918,
                28.30897
              ],
              [
                51.2857153,
                28.3084206
              ],
              [
                51.2532293,
                28.270056
              ],
              [
                51.2516202,
                28.26835
              ],
              [
                50.9440729,
                28.0718545
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555029,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دیلم",
          "name:en": "Deylam County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270911",
          "wikipedia": "en:Deylam County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.5801433,
                29.6674426
              ],
              [
                49.7102571,
                29.5300835
              ],
              [
                49.8426242,
                29.3901539
              ],
              [
                50.3193867,
                29.746732
              ],
              [
                50.3342805,
                29.7553913
              ],
              [
                50.3659502,
                29.7770649
              ],
              [
                50.3690034,
                29.779004
              ],
              [
                50.3967831,
                29.7953924
              ],
              [
                50.4162296,
                29.8056749
              ],
              [
                50.4173394,
                29.8065047
              ],
              [
                50.4237293,
                29.8092828
              ],
              [
                50.4317857,
                29.8109514
              ],
              [
                50.4328958,
                29.8109514
              ],
              [
                50.4345623,
                29.8115015
              ],
              [
                50.4406757,
                29.8123314
              ],
              [
                50.4531755,
                29.816228
              ],
              [
                50.4615089,
                29.8203951
              ],
              [
                50.4678988,
                29.8251124
              ],
              [
                50.4678989,
                29.8256717
              ],
              [
                50.4870651,
                29.8384528
              ],
              [
                50.4906781,
                29.8445591
              ],
              [
                50.4962313,
                29.8615078
              ],
              [
                50.5037314,
                29.8765082
              ],
              [
                50.5129011,
                29.8867822
              ],
              [
                50.5137347,
                29.8870618
              ],
              [
                50.5142878,
                29.8873415
              ],
              [
                50.5159542,
                29.8884509
              ],
              [
                50.5287342,
                29.8909496
              ],
              [
                50.5292908,
                29.8912292
              ],
              [
                50.5415106,
                29.8901197
              ],
              [
                50.5426238,
                29.8898401
              ],
              [
                50.5431809,
                29.8901198
              ],
              [
                50.5498475,
                29.8901198
              ],
              [
                50.5556804,
                29.8903904
              ],
              [
                50.5570672,
                29.8901197
              ],
              [
                50.5581805,
                29.8895605
              ],
              [
                50.5620703,
                29.8895605
              ],
              [
                50.5795702,
                29.8909497
              ],
              [
                50.5912368,
                29.8923388
              ],
              [
                50.5926268,
                29.8926184
              ],
              [
                50.59568,
                29.8926184
              ],
              [
                50.6115165,
                29.8956763
              ],
              [
                50.6120697,
                29.8959469
              ],
              [
                50.6140162,
                29.8965063
              ],
              [
                50.6212397,
                29.8973361
              ],
              [
                50.6234593,
                29.8973361
              ],
              [
                50.6270727,
                29.8965062
              ],
              [
                50.6290161,
                29.8965062
              ],
              [
                50.6340161,
                29.8948375
              ],
              [
                50.6362393,
                29.8948375
              ],
              [
                50.6373494,
                29.8951171
              ],
              [
                50.6390159,
                29.8951171
              ],
              [
                50.6398495,
                29.8953967
              ],
              [
                50.6415159,
                29.8953968
              ],
              [
                50.6492957,
                29.9028926
              ],
              [
                50.6498493,
                29.9031722
              ],
              [
                50.6509625,
                29.9054003
              ],
              [
                50.6509626,
                29.9081695
              ],
              [
                50.6506824,
                29.9087288
              ],
              [
                50.6504059,
                29.9101179
              ],
              [
                50.6587388,
                29.9145649
              ],
              [
                50.6601292,
                29.9151152
              ],
              [
                50.6581858,
                29.9173433
              ],
              [
                50.6573525,
                29.9190031
              ],
              [
                50.6548489,
                29.9237298
              ],
              [
                50.6481823,
                29.9328946
              ],
              [
                50.6456824,
                29.9354023
              ],
              [
                50.642349,
                29.9373417
              ],
              [
                50.6342927,
                29.9392902
              ],
              [
                50.6306829,
                29.9392902
              ],
              [
                50.6287395,
                29.9395608
              ],
              [
                50.6279063,
                29.9398404
              ],
              [
                50.6267929,
                29.9398404
              ],
              [
                50.6259593,
                29.94012
              ],
              [
                50.6248495,
                29.94012
              ],
              [
                50.6142931,
                29.9434486
              ],
              [
                50.611793,
                29.9434486
              ],
              [
                50.6112364,
                29.9437283
              ],
              [
                50.6090164,
                29.9437282
              ],
              [
                50.6084598,
                29.9440079
              ],
              [
                50.605403,
                29.9440079
              ],
              [
                50.6045699,
                29.9437282
              ],
              [
                50.6031831,
                29.9437282
              ],
              [
                50.602903,
                29.9434486
              ],
              [
                50.6026265,
                29.9420685
              ],
              [
                50.5851269,
                29.9292863
              ],
              [
                50.5792901,
                29.9262284
              ],
              [
                50.5781803,
                29.9253984
              ],
              [
                50.5762369,
                29.9248392
              ],
              [
                50.5754037,
                29.9248392
              ],
              [
                50.5748467,
                29.9245596
              ],
              [
                50.5737369,
                29.9245595
              ],
              [
                50.569847,
                29.9270582
              ],
              [
                50.5687368,
                29.9281767
              ],
              [
                50.5629039,
                29.934013
              ],
              [
                50.5556802,
                29.9478957
              ],
              [
                50.5554006,
                29.9490142
              ],
              [
                50.539844,
                29.9659551
              ],
              [
                50.5392905,
                29.966785
              ],
              [
                50.5387338,
                29.9670647
              ],
              [
                50.5356775,
                29.9726215
              ],
              [
                50.5342908,
                29.9762298
              ],
              [
                50.5340107,
                29.9790083
              ],
              [
                50.535124,
                29.9917909
              ],
              [
                50.5348204,
                29.992891
              ],
              [
                50.5326239,
                30.0017862
              ],
              [
                50.5323438,
                30.0031753
              ],
              [
                50.5320673,
                30.0040143
              ],
              [
                50.5298441,
                30.0098419
              ],
              [
                50.5290105,
                30.0120611
              ],
              [
                50.5284574,
                30.01456
              ],
              [
                50.5284574,
                30.0153989
              ],
              [
                50.5281773,
                30.0173475
              ],
              [
                50.5279008,
                30.0181774
              ],
              [
                50.5276242,
                30.0203966
              ],
              [
                50.5392903,
                30.0731804
              ],
              [
                50.5426235,
                30.0823462
              ],
              [
                50.5448471,
                30.0856752
              ],
              [
                50.5476236,
                30.0890131
              ],
              [
                50.5481803,
                30.0898431
              ],
              [
                50.5573468,
                30.0959598
              ],
              [
                50.5587336,
                30.0970694
              ],
              [
                50.5595668,
                30.0973401
              ],
              [
                50.5604001,
                30.0981791
              ],
              [
                50.5626235,
                30.0992888
              ],
              [
                50.5748464,
                30.1126229
              ],
              [
                50.5754034,
                30.1137325
              ],
              [
                50.5767897,
                30.1245677
              ],
              [
                50.5770698,
                30.1253977
              ],
              [
                50.5767897,
                30.1259571
              ],
              [
                50.5765131,
                30.1273465
              ],
              [
                50.5762366,
                30.1281765
              ],
              [
                50.5754033,
                30.1306755
              ],
              [
                50.5745697,
                30.1328949
              ],
              [
                50.5717901,
                30.137902
              ],
              [
                50.5654032,
                30.1440098
              ],
              [
                50.5612367,
                30.1462292
              ],
              [
                50.560476,
                30.1467128
              ],
              [
                50.5353206,
                30.1531104
              ],
              [
                50.5148699,
                30.1616618
              ],
              [
                50.5138933,
                30.1660606
              ],
              [
                50.5090712,
                30.166158
              ],
              [
                50.5044213,
                30.1661179
              ],
              [
                50.5030833,
                30.1660572
              ],
              [
                50.5003508,
                30.1659333
              ],
              [
                50.4836769,
                30.1662094
              ],
              [
                50.4768295,
                30.1670373
              ],
              [
                50.4731942,
                30.1675214
              ],
              [
                50.4693565,
                30.1684692
              ],
              [
                50.4628793,
                30.1695686
              ],
              [
                50.4561959,
                30.1711339
              ],
              [
                50.4483032,
                30.1731223
              ],
              [
                50.4422037,
                30.1747299
              ],
              [
                50.4367293,
                30.1760579
              ],
              [
                50.4302521,
                30.1775753
              ],
              [
                50.4229433,
                30.1800701
              ],
              [
                50.4165763,
                30.1821897
              ],
              [
                50.406063,
                30.1867854
              ],
              [
                50.3987811,
                30.1902193
              ],
              [
                50.3970222,
                30.1910487
              ],
              [
                50.3882902,
                30.1950804
              ],
              [
                50.3799286,
                30.1990636
              ],
              [
                50.3698731,
                30.2035705
              ],
              [
                50.3648186,
                30.2059172
              ],
              [
                50.3578606,
                30.2086492
              ],
              [
                50.3511657,
                30.2113776
              ],
              [
                50.3482169,
                30.2126466
              ],
              [
                50.3400917,
                30.2156177
              ],
              [
                50.330967,
                30.2190615
              ],
              [
                50.3239478,
                30.2217507
              ],
              [
                50.3186148,
                30.2236858
              ],
              [
                50.3110696,
                30.2277207
              ],
              [
                50.291855,
                30.2374928
              ],
              [
                50.2835046,
                30.2417247
              ],
              [
                50.2758979,
                30.2460888
              ],
              [
                50.2695071,
                30.2499607
              ],
              [
                50.2641181,
                30.253707
              ],
              [
                50.2602425,
                30.2566292
              ],
              [
                50.2564697,
                30.2593669
              ],
              [
                50.252697,
                30.262664
              ],
              [
                50.2500241,
                30.2642369
              ],
              [
                50.2473028,
                30.26495
              ],
              [
                50.2429276,
                30.2664701
              ],
              [
                50.2393989,
                30.2679544
              ],
              [
                50.2354966,
                30.269662
              ],
              [
                50.231804,
                30.2714226
              ],
              [
                50.2270583,
                30.2740025
              ],
              [
                50.2215194,
                30.2773581
              ],
              [
                50.2162398,
                30.2809046
              ],
              [
                50.2117995,
                30.2839979
              ],
              [
                50.2074127,
                30.2876035
              ],
              [
                50.2033959,
                30.2912112
              ],
              [
                50.2024806,
                30.2921888
              ],
              [
                50.2006949,
                30.2940959
              ],
              [
                50.2000071,
                30.2949624
              ],
              [
                50.1992722,
                30.2931058
              ],
              [
                50.1988062,
                30.292025
              ],
              [
                50.1978716,
                30.2898572
              ],
              [
                50.1975481,
                30.2891068
              ],
              [
                50.1951446,
                30.283477
              ],
              [
                50.1934164,
                30.2796154
              ],
              [
                50.1890869,
                30.2689158
              ],
              [
                50.1864356,
                30.2609674
              ],
              [
                50.1846658,
                30.2561332
              ],
              [
                50.1828957,
                30.2512019
              ],
              [
                50.1825508,
                30.2501372
              ],
              [
                50.1814574,
                30.2464171
              ],
              [
                50.1805687,
                30.2431427
              ],
              [
                50.1793595,
                30.2397782
              ],
              [
                50.177616,
                30.2357698
              ],
              [
                50.1759261,
                30.2318992
              ],
              [
                50.1743433,
                30.2281669
              ],
              [
                50.1732026,
                30.2258158
              ],
              [
                50.1718979,
                30.2229109
              ],
              [
                50.1701622,
                30.2193174
              ],
              [
                50.1688117,
                30.2169221
              ],
              [
                50.1659927,
                30.2113026
              ],
              [
                50.1634027,
                30.2066952
              ],
              [
                50.1605453,
                30.2019507
              ],
              [
                50.1580161,
                30.1980362
              ],
              [
                50.1552275,
                30.1943072
              ],
              [
                50.1495512,
                30.1872635
              ],
              [
                50.1439932,
                30.1810483
              ],
              [
                50.1390342,
                30.1759444
              ],
              [
                50.1324843,
                30.1699162
              ],
              [
                50.1292915,
                30.1671112
              ],
              [
                50.1259385,
                30.1637049
              ],
              [
                50.1234323,
                30.1608028
              ],
              [
                50.1208266,
                30.1585497
              ],
              [
                50.1189118,
                30.1565697
              ],
              [
                50.1168438,
                30.1547139
              ],
              [
                50.1161772,
                30.1541459
              ],
              [
                49.5801433,
                29.6674426
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555031,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دیر",
          "name:en": "Deyr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270657",
          "wikipedia": "en:Deyr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.991349,
                28.0120123
              ],
              [
                51.2423375,
                27.7184419
              ],
              [
                51.2785047,
                27.6908719
              ],
              [
                51.3144248,
                27.6622615
              ],
              [
                51.5230274,
                27.523409
              ],
              [
                51.7123616,
                27.431492
              ],
              [
                51.9701161,
                27.7958682
              ],
              [
                52.0007397,
                27.8394498
              ],
              [
                52.0006494,
                27.8492522
              ],
              [
                52.0009458,
                27.857106
              ],
              [
                52.0053508,
                27.8802078
              ],
              [
                52.0156739,
                27.8884722
              ],
              [
                52.0168576,
                27.8886853
              ],
              [
                52.0182477,
                27.8895223
              ],
              [
                52.019081,
                27.8895223
              ],
              [
                52.0274141,
                27.8931317
              ],
              [
                52.0279675,
                27.8934107
              ],
              [
                52.062137,
                27.9178576
              ],
              [
                52.0654701,
                27.9220251
              ],
              [
                52.0657467,
                27.9222952
              ],
              [
                52.0826932,
                27.9336908
              ],
              [
                52.0839985,
                27.9380402
              ],
              [
                52.08436,
                27.9392447
              ],
              [
                52.0840832,
                27.9395238
              ],
              [
                52.08325,
                27.9414682
              ],
              [
                52.0818599,
                27.9436915
              ],
              [
                52.0815833,
                27.9439705
              ],
              [
                52.0643602,
                27.9650794
              ],
              [
                52.0596369,
                27.9720197
              ],
              [
                52.0490804,
                27.9820209
              ],
              [
                52.036304,
                27.9998
              ],
              [
                52.0335238,
                28.003968
              ],
              [
                52.0188007,
                28.0203523
              ],
              [
                52.0013012,
                28.0353595
              ],
              [
                52.0010245,
                28.0359176
              ],
              [
                51.9935211,
                28.0400768
              ],
              [
                51.9779682,
                28.0523026
              ],
              [
                51.9776881,
                28.0525817
              ],
              [
                51.9701882,
                28.0575782
              ],
              [
                51.9649116,
                28.0595228
              ],
              [
                51.9646316,
                28.0598019
              ],
              [
                51.9637984,
                28.0598019
              ],
              [
                51.955465,
                28.0639703
              ],
              [
                51.9529651,
                28.0650776
              ],
              [
                51.9393554,
                28.0734144
              ],
              [
                51.9387987,
                28.0739726
              ],
              [
                51.9382421,
                28.0739726
              ],
              [
                51.9376854,
                28.0748009
              ],
              [
                51.9279655,
                28.080914
              ],
              [
                51.8823925,
                28.1211423
              ],
              [
                51.8687964,
                28.1331341
              ],
              [
                51.8654632,
                28.1373028
              ],
              [
                51.8651831,
                28.137582
              ],
              [
                51.8643497,
                28.1384103
              ],
              [
                51.8632398,
                28.1395268
              ],
              [
                51.8601833,
                28.142309
              ],
              [
                51.8543499,
                28.1473061
              ],
              [
                51.8354603,
                28.1639725
              ],
              [
                51.7465682,
                28.230642
              ],
              [
                51.7254552,
                28.248697
              ],
              [
                51.7187887,
                28.2511914
              ],
              [
                51.7182319,
                28.2511914
              ],
              [
                51.7176787,
                28.2514705
              ],
              [
                51.7167072,
                28.2514706
              ],
              [
                51.7162886,
                28.2511914
              ],
              [
                51.7148986,
                28.2511913
              ],
              [
                51.7129553,
                28.250642
              ],
              [
                51.7110086,
                28.2506421
              ],
              [
                51.6707292,
                28.241754
              ],
              [
                51.6660094,
                28.2406464
              ],
              [
                51.6407299,
                28.2345229
              ],
              [
                51.6382299,
                28.2336945
              ],
              [
                51.6287834,
                28.2317495
              ],
              [
                51.6271167,
                28.2311911
              ],
              [
                51.6221167,
                28.2303626
              ],
              [
                51.581004,
                28.2209166
              ],
              [
                51.5771141,
                28.2195298
              ],
              [
                51.5760042,
                28.2195298
              ],
              [
                51.5665611,
                28.2164682
              ],
              [
                51.5448914,
                28.2050863
              ],
              [
                51.5435048,
                28.204528
              ],
              [
                51.5423913,
                28.2036905
              ],
              [
                51.539058,
                28.2023038
              ],
              [
                51.5385014,
                28.2017455
              ],
              [
                51.5304484,
                28.198693
              ],
              [
                51.5273917,
                28.1978556
              ],
              [
                51.526835,
                28.1978556
              ],
              [
                51.5254485,
                28.1975855
              ],
              [
                51.5248916,
                28.1973063
              ],
              [
                51.5248915,
                28.1971667
              ],
              [
                51.5285016,
                28.1934164
              ],
              [
                51.5293348,
                28.1900848
              ],
              [
                51.5296149,
                28.1898056
              ],
              [
                51.5298915,
                28.1889683
              ],
              [
                51.5301683,
                28.186474
              ],
              [
                51.5287817,
                28.1825841
              ],
              [
                51.5240583,
                28.178136
              ],
              [
                51.5212783,
                28.1764701
              ],
              [
                51.5187785,
                28.1753626
              ],
              [
                51.517945,
                28.1753626
              ],
              [
                51.5104453,
                28.1711936
              ],
              [
                51.5085019,
                28.165638
              ],
              [
                51.5079452,
                28.1650799
              ],
              [
                51.507112,
                28.1625766
              ],
              [
                51.5060021,
                28.1617482
              ],
              [
                51.5010021,
                28.1600825
              ],
              [
                51.4996121,
                28.1600825
              ],
              [
                51.4987786,
                28.1598034
              ],
              [
                51.4907223,
                28.1598034
              ],
              [
                51.490169,
                28.1600825
              ],
              [
                51.4871123,
                28.1600825
              ],
              [
                51.4812789,
                28.1581376
              ],
              [
                51.4776658,
                28.1570301
              ],
              [
                51.4754459,
                28.1542479
              ],
              [
                51.4746124,
                28.1536986
              ],
              [
                51.4732226,
                28.1536986
              ],
              [
                51.4721126,
                28.1539688
              ],
              [
                51.4690559,
                28.1556435
              ],
              [
                51.4687794,
                28.1561928
              ],
              [
                51.466276,
                28.1570301
              ],
              [
                51.4654426,
                28.1570301
              ],
              [
                51.4618327,
                28.1556434
              ],
              [
                51.4582227,
                28.1525821
              ],
              [
                51.4498896,
                28.131468
              ],
              [
                51.4490562,
                28.1289739
              ],
              [
                51.444333,
                28.121753
              ],
              [
                51.4432195,
                28.1211948
              ],
              [
                51.4409998,
                28.1211947
              ],
              [
                51.4396097,
                28.1214649
              ],
              [
                51.4376665,
                28.1223023
              ],
              [
                51.4359999,
                28.1239679
              ],
              [
                51.4362765,
                28.1267501
              ],
              [
                51.4387763,
                28.1295232
              ],
              [
                51.440443,
                28.1300814
              ],
              [
                51.4412764,
                28.1339711
              ],
              [
                51.4393331,
                28.1356367
              ],
              [
                51.4384998,
                28.136195
              ],
              [
                51.4379431,
                28.136195
              ],
              [
                51.4376665,
                28.1364741
              ],
              [
                51.4351665,
                28.1364741
              ],
              [
                51.4332198,
                28.1367443
              ],
              [
                51.4298865,
                28.1375815
              ],
              [
                51.4296099,
                28.1378607
              ],
              [
                51.4284965,
                28.1378607
              ],
              [
                51.4282199,
                28.1381398
              ],
              [
                51.4234966,
                28.1381398
              ],
              [
                51.42322,
                28.1384099
              ],
              [
                51.4215534,
                28.138698
              ],
              [
                51.4198867,
                28.138698
              ],
              [
                51.4165534,
                28.1381398
              ],
              [
                51.4123868,
                28.1370323
              ],
              [
                51.4115536,
                28.1364741
              ],
              [
                51.4112768,
                28.1334218
              ],
              [
                51.4129435,
                28.1289739
              ],
              [
                51.4129435,
                28.1264709
              ],
              [
                51.4123868,
                28.1236978
              ],
              [
                51.4076635,
                28.1178544
              ],
              [
                51.4059968,
                28.1167469
              ],
              [
                51.402387,
                28.1156396
              ],
              [
                51.3976637,
                28.1156396
              ],
              [
                51.3971071,
                28.1159186
              ],
              [
                51.3962736,
                28.1159186
              ],
              [
                51.3951638,
                28.1164678
              ],
              [
                51.3901637,
                28.121753
              ],
              [
                51.3893306,
                28.1248052
              ],
              [
                51.3890504,
                28.1278574
              ],
              [
                51.3862738,
                28.1347993
              ],
              [
                51.3854406,
                28.1367442
              ],
              [
                51.384884,
                28.1373024
              ],
              [
                51.3843307,
                28.1373024
              ],
              [
                51.3843307,
                28.1375815
              ],
              [
                51.3809974,
                28.1375815
              ],
              [
                51.3801639,
                28.1378607
              ],
              [
                51.377384,
                28.1378607
              ],
              [
                51.374884,
                28.1370323
              ],
              [
                51.3732174,
                28.1356367
              ],
              [
                51.3634942,
                28.131747
              ],
              [
                51.3623842,
                28.131747
              ],
              [
                51.361551,
                28.1320262
              ],
              [
                51.3593277,
                28.1342501
              ],
              [
                51.3590509,
                28.1353575
              ],
              [
                51.3587743,
                28.1375815
              ],
              [
                51.3571077,
                28.1414711
              ],
              [
                51.3565511,
                28.1420204
              ],
              [
                51.355441,
                28.1423085
              ],
              [
                51.3526611,
                28.1386979
              ],
              [
                51.3509943,
                28.1367441
              ],
              [
                51.3496045,
                28.1361949
              ],
              [
                51.3482179,
                28.136474
              ],
              [
                51.3465512,
                28.136474
              ],
              [
                51.3457178,
                28.1367441
              ],
              [
                51.3448845,
                28.1375814
              ],
              [
                51.3429379,
                28.1414711
              ],
              [
                51.3429379,
                28.1420204
              ],
              [
                51.3426612,
                28.1423085
              ],
              [
                51.3426611,
                28.1453608
              ],
              [
                51.3418279,
                28.1461982
              ],
              [
                51.3390514,
                28.1475758
              ],
              [
                51.3373847,
                28.1473056
              ],
              [
                51.335438,
                28.1453608
              ],
              [
                51.334328,
                28.1453609
              ],
              [
                51.3296047,
                28.148143
              ],
              [
                51.3284947,
                28.1486923
              ],
              [
                51.3282148,
                28.1489714
              ],
              [
                51.3268281,
                28.1489714
              ],
              [
                51.3265482,
                28.1492505
              ],
              [
                51.3246048,
                28.1486922
              ],
              [
                51.3237715,
                28.1445234
              ],
              [
                51.3176617,
                28.1347992
              ],
              [
                51.315715,
                28.1347992
              ],
              [
                51.3137716,
                28.1359157
              ],
              [
                51.313215,
                28.1373023
              ],
              [
                51.3129383,
                28.1392471
              ],
              [
                51.3129384,
                28.1428577
              ],
              [
                51.3118251,
                28.1461981
              ],
              [
                51.3084916,
                28.1489714
              ],
              [
                51.3093251,
                28.1534193
              ],
              [
                51.3096051,
                28.1542477
              ],
              [
                51.3090484,
                28.1556433
              ],
              [
                51.3034917,
                28.1586957
              ],
              [
                51.2971019,
                28.159524
              ],
              [
                51.2956782,
                28.1602602
              ],
              [
                51.2954626,
                28.1603717
              ],
              [
                51.2804354,
                28.1681409
              ],
              [
                51.2798821,
                28.168141
              ],
              [
                51.2796022,
                28.1684111
              ],
              [
                51.2790489,
                28.1684111
              ],
              [
                51.2787687,
                28.1686993
              ],
              [
                51.2756211,
                28.1699475
              ],
              [
                51.2555121,
                28.1784087
              ],
              [
                50.991349,
                28.0120123
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555123,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان عسلویه",
          "name:en": "Asaluyeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2902500",
          "wikipedia": "en:Asaluyeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.1150457,
                27.2090607
              ],
              [
                52.242959,
                27.1326254
              ],
              [
                52.482398,
                26.989407
              ],
              [
                52.7379214,
                27.2743065
              ],
              [
                52.7899507,
                27.311903
              ],
              [
                52.7921389,
                27.3117624
              ],
              [
                52.8067069,
                27.326112
              ],
              [
                52.8108037,
                27.327995
              ],
              [
                52.8325609,
                27.3224233
              ],
              [
                52.8387145,
                27.3217517
              ],
              [
                52.8420457,
                27.3173905
              ],
              [
                52.8676735,
                27.3060588
              ],
              [
                52.8679501,
                27.3066163
              ],
              [
                52.9006112,
                27.3183472
              ],
              [
                52.9120874,
                27.3412746
              ],
              [
                52.91316,
                27.3669656
              ],
              [
                52.9134056,
                27.3734652
              ],
              [
                52.9126668,
                27.374435
              ],
              [
                52.9054355,
                27.382133
              ],
              [
                52.8981399,
                27.3910497
              ],
              [
                52.889471,
                27.4008801
              ],
              [
                52.8823067,
                27.4071859
              ],
              [
                52.8701614,
                27.419808
              ],
              [
                52.828282,
                27.4420163
              ],
              [
                52.8173123,
                27.4485982
              ],
              [
                52.8088355,
                27.453683
              ],
              [
                52.8088355,
                27.4539619
              ],
              [
                52.8007789,
                27.4600696
              ],
              [
                52.7988356,
                27.4614549
              ],
              [
                52.7888358,
                27.4678506
              ],
              [
                52.7757793,
                27.4809031
              ],
              [
                52.7746694,
                27.483125
              ],
              [
                52.768556,
                27.4895119
              ],
              [
                52.7680169,
                27.4903309
              ],
              [
                52.7579997,
                27.500064
              ],
              [
                52.7549464,
                27.502295
              ],
              [
                52.7546663,
                27.5028527
              ],
              [
                52.7460565,
                27.5072967
              ],
              [
                52.7452231,
                27.5072966
              ],
              [
                52.7423467,
                27.5084734
              ],
              [
                52.7391098,
                27.5097975
              ],
              [
                52.73689,
                27.5106251
              ],
              [
                52.7368899,
                27.510904
              ],
              [
                52.6879974,
                27.536741
              ],
              [
                52.6877207,
                27.5370109
              ],
              [
                52.6874407,
                27.5372898
              ],
              [
                52.687164,
                27.5372898
              ],
              [
                52.6854974,
                27.5386842
              ],
              [
                52.6668843,
                27.5484093
              ],
              [
                52.6602178,
                27.551738
              ],
              [
                52.647718,
                27.5575678
              ],
              [
                52.6407748,
                27.5595111
              ],
              [
                52.6404947,
                27.55979
              ],
              [
                52.6371615,
                27.55979
              ],
              [
                52.6366048,
                27.5600688
              ],
              [
                52.6354949,
                27.5600689
              ],
              [
                52.6346616,
                27.5603478
              ],
              [
                52.6335516,
                27.5603478
              ],
              [
                52.6329949,
                27.5606266
              ],
              [
                52.6318849,
                27.5606266
              ],
              [
                52.6299382,
                27.5611845
              ],
              [
                52.6291049,
                27.5611844
              ],
              [
                52.6238284,
                27.5634067
              ],
              [
                52.613358,
                27.5719474
              ],
              [
                52.6027152,
                27.5806265
              ],
              [
                52.601882,
                27.5817421
              ],
              [
                52.5974387,
                27.5864565
              ],
              [
                52.5635492,
                27.6242449
              ],
              [
                52.5632693,
                27.6245148
              ],
              [
                52.5510461,
                27.6486824
              ],
              [
                52.5510461,
                27.6489614
              ],
              [
                52.5507695,
                27.6492403
              ],
              [
                52.5507694,
                27.6495192
              ],
              [
                52.5485461,
                27.6536852
              ],
              [
                52.5427129,
                27.6631241
              ],
              [
                52.5418795,
                27.6650767
              ],
              [
                52.5418795,
                27.6653555
              ],
              [
                52.541603,
                27.6656255
              ],
              [
                52.541603,
                27.6659045
              ],
              [
                52.5371563,
                27.6675691
              ],
              [
                52.5349363,
                27.6681269
              ],
              [
                52.5343797,
                27.668127
              ],
              [
                52.5341031,
                27.6684059
              ],
              [
                52.5332697,
                27.6684059
              ],
              [
                52.5165999,
                27.6778539
              ],
              [
                52.51549,
                27.6789607
              ],
              [
                52.5099334,
                27.6822901
              ],
              [
                52.5091,
                27.6831269
              ],
              [
                52.4774339,
                27.6992429
              ],
              [
                52.4720261,
                27.7014778
              ],
              [
                52.4733679,
                27.679571
              ],
              [
                52.4876755,
                27.6541629
              ],
              [
                52.5187296,
                27.6263956
              ],
              [
                52.5253773,
                27.6125472
              ],
              [
                52.5543183,
                27.5669763
              ],
              [
                52.1150457,
                27.2090607
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555175,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کنگان",
          "name:en": "Kangan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1272916",
          "wikipedia": "en:Kangan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.7123616,
                27.431492
              ],
              [
                51.8420008,
                27.3720446
              ],
              [
                51.8705058,
                27.3550408
              ],
              [
                52.0618571,
                27.2408284
              ],
              [
                52.1150457,
                27.2090607
              ],
              [
                52.5543183,
                27.5669763
              ],
              [
                52.5253773,
                27.6125472
              ],
              [
                52.5187296,
                27.6263956
              ],
              [
                52.4876755,
                27.6541629
              ],
              [
                52.4733679,
                27.679571
              ],
              [
                52.4720261,
                27.7014778
              ],
              [
                52.4693774,
                27.7025724
              ],
              [
                52.452711,
                27.7103561
              ],
              [
                52.4385412,
                27.7150713
              ],
              [
                52.4374313,
                27.7150713
              ],
              [
                52.4113182,
                27.724799
              ],
              [
                52.4099282,
                27.7247989
              ],
              [
                52.4074282,
                27.7253479
              ],
              [
                52.406595,
                27.7256358
              ],
              [
                52.4021517,
                27.7256358
              ],
              [
                52.4007617,
                27.7253478
              ],
              [
                52.3935419,
                27.7259058
              ],
              [
                52.3915953,
                27.7264637
              ],
              [
                52.3827053,
                27.7275706
              ],
              [
                52.3707622,
                27.7295233
              ],
              [
                52.3693722,
                27.7295233
              ],
              [
                52.3671489,
                27.7300722
              ],
              [
                52.3652057,
                27.7300722
              ],
              [
                52.3640957,
                27.7303512
              ],
              [
                52.362149,
                27.7303511
              ],
              [
                52.3554825,
                27.732016
              ],
              [
                52.3435394,
                27.7345177
              ],
              [
                52.3429827,
                27.7347966
              ],
              [
                52.3415926,
                27.7347966
              ],
              [
                52.3407595,
                27.7350756
              ],
              [
                52.3393727,
                27.7350756
              ],
              [
                52.3368728,
                27.7356335
              ],
              [
                52.3354828,
                27.7356335
              ],
              [
                52.31076,
                27.7409069
              ],
              [
                52.3102033,
                27.7411859
              ],
              [
                52.3088132,
                27.7411859
              ],
              [
                52.3063131,
                27.7417438
              ],
              [
                52.3054799,
                27.7417438
              ],
              [
                52.3021466,
                27.7431297
              ],
              [
                52.2971468,
                27.7442365
              ],
              [
                52.2952033,
                27.7450734
              ],
              [
                52.2904801,
                27.7475751
              ],
              [
                52.2671472,
                27.7617398
              ],
              [
                52.2652005,
                27.7636837
              ],
              [
                52.2485342,
                27.7747978
              ],
              [
                52.2399209,
                27.7839593
              ],
              [
                52.2343677,
                27.789242
              ],
              [
                52.2299209,
                27.7917439
              ],
              [
                52.2263111,
                27.7931299
              ],
              [
                52.2254778,
                27.7931298
              ],
              [
                52.2249211,
                27.7934089
              ],
              [
                52.2238111,
                27.7934088
              ],
              [
                52.2132547,
                27.7986827
              ],
              [
                52.211588,
                27.8014636
              ],
              [
                52.2110313,
                27.8020215
              ],
              [
                52.2107547,
                27.8028495
              ],
              [
                52.210478,
                27.8031285
              ],
              [
                52.2103902,
                27.8033909
              ],
              [
                52.2096448,
                27.8048024
              ],
              [
                52.2096448,
                27.8053605
              ],
              [
                52.1968649,
                27.8186893
              ],
              [
                52.1890884,
                27.8234143
              ],
              [
                52.1879751,
                27.8236843
              ],
              [
                52.1868651,
                27.8245212
              ],
              [
                52.1865239,
                27.8246355
              ],
              [
                52.1826985,
                27.8261863
              ],
              [
                52.1799186,
                27.8275813
              ],
              [
                52.1726987,
                27.8317483
              ],
              [
                52.143529,
                27.8686858
              ],
              [
                52.1326958,
                27.8778574
              ],
              [
                52.1321391,
                27.8781365
              ],
              [
                52.127696,
                27.8822948
              ],
              [
                52.1260293,
                27.8842479
              ],
              [
                52.1215827,
                27.895913
              ],
              [
                52.121306,
                27.8967412
              ],
              [
                52.1210293,
                27.8981273
              ],
              [
                52.1201961,
                27.9009086
              ],
              [
                52.1199161,
                27.9034109
              ],
              [
                52.1174161,
                27.9098016
              ],
              [
                52.1082495,
                27.9192439
              ],
              [
                52.1082494,
                27.9195229
              ],
              [
                52.1082494,
                27.9198019
              ],
              [
                52.1065828,
                27.9211881
              ],
              [
                52.1063063,
                27.9214671
              ],
              [
                52.0890831,
                27.9350771
              ],
              [
                52.0854699,
                27.9373005
              ],
              [
                52.0839985,
                27.9380402
              ],
              [
                52.0826932,
                27.9336908
              ],
              [
                52.0657467,
                27.9222952
              ],
              [
                52.0654701,
                27.9220251
              ],
              [
                52.062137,
                27.9178576
              ],
              [
                52.0279675,
                27.8934107
              ],
              [
                52.0274141,
                27.8931317
              ],
              [
                52.019081,
                27.8895223
              ],
              [
                52.0182477,
                27.8895223
              ],
              [
                52.0168576,
                27.8886853
              ],
              [
                52.0156739,
                27.8884722
              ],
              [
                52.0053508,
                27.8802078
              ],
              [
                52.0009458,
                27.857106
              ],
              [
                52.0006494,
                27.8492522
              ],
              [
                52.0007397,
                27.8394498
              ],
              [
                51.9701161,
                27.7958682
              ],
              [
                51.7123616,
                27.431492
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555291,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گناوه",
          "name:ar": "مقاطعة غناوه",
          "name:en": "Ganaveh County",
          "name:uk": "Ґенаве",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270875",
          "wikipedia": "en:Ganaveh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.8426242,
                29.3901539
              ],
              [
                50.0519489,
                29.1684767
              ],
              [
                50.3779951,
                29.3963488
              ],
              [
                50.6423144,
                29.1439462
              ],
              [
                50.6423495,
                29.1439614
              ],
              [
                50.6427226,
                29.1442256
              ],
              [
                50.6428551,
                29.1443193
              ],
              [
                50.6450478,
                29.1458717
              ],
              [
                50.6467485,
                29.1465249
              ],
              [
                50.6475398,
                29.1465704
              ],
              [
                50.648479,
                29.1466233
              ],
              [
                50.6499914,
                29.1467722
              ],
              [
                50.6510519,
                29.1468285
              ],
              [
                50.6520776,
                29.1469844
              ],
              [
                50.6529117,
                29.1472447
              ],
              [
                50.6540281,
                29.1476313
              ],
              [
                50.6545077,
                29.1479119
              ],
              [
                50.6604069,
                29.1520455
              ],
              [
                50.6673535,
                29.1564897
              ],
              [
                50.6729068,
                29.1564897
              ],
              [
                50.6734634,
                29.1562102
              ],
              [
                50.6765201,
                29.1575984
              ],
              [
                50.6773533,
                29.1578778
              ],
              [
                50.6787432,
                29.1587162
              ],
              [
                50.6801299,
                29.1609337
              ],
              [
                50.6801299,
                29.1620515
              ],
              [
                50.68041,
                29.162322
              ],
              [
                50.6801299,
                29.1628809
              ],
              [
                50.6787431,
                29.1684337
              ],
              [
                50.678463,
                29.1687132
              ],
              [
                50.6792967,
                29.1728869
              ],
              [
                50.6840198,
                29.1776015
              ],
              [
                50.6859632,
                29.1781604
              ],
              [
                50.69574,
                29.1781118
              ],
              [
                50.6995358,
                29.1775291
              ],
              [
                50.7059663,
                29.1767722
              ],
              [
                50.7067995,
                29.1767722
              ],
              [
                50.7106859,
                29.1753839
              ],
              [
                50.7115688,
                29.1754913
              ],
              [
                50.7129094,
                29.1756544
              ],
              [
                50.7133649,
                29.1761128
              ],
              [
                50.7137426,
                29.1764927
              ],
              [
                50.7148207,
                29.1807955
              ],
              [
                50.7148561,
                29.1809369
              ],
              [
                50.7092995,
                29.1864899
              ],
              [
                50.7092995,
                29.1870488
              ],
              [
                50.7123563,
                29.1898254
              ],
              [
                50.7150147,
                29.1918715
              ],
              [
                50.7170902,
                29.1915093
              ],
              [
                50.7190572,
                29.1914343
              ],
              [
                50.7218479,
                29.1931925
              ],
              [
                50.7221924,
                29.1935883
              ],
              [
                50.7234264,
                29.1949173
              ],
              [
                50.7206892,
                29.1978755
              ],
              [
                50.7188964,
                29.2003299
              ],
              [
                50.7176327,
                29.2020493
              ],
              [
                50.7170306,
                29.2037577
              ],
              [
                50.7172965,
                29.2050582
              ],
              [
                50.7200181,
                29.2063033
              ],
              [
                50.7227898,
                29.2071762
              ],
              [
                50.7266336,
                29.2090827
              ],
              [
                50.7373557,
                29.2153822
              ],
              [
                50.7384656,
                29.2173295
              ],
              [
                50.7387457,
                29.2184383
              ],
              [
                50.7373556,
                29.220106
              ],
              [
                50.7337456,
                29.2223327
              ],
              [
                50.7334657,
                29.2234416
              ],
              [
                50.7365276,
                29.2253623
              ],
              [
                50.7381889,
                29.2253798
              ],
              [
                50.7387457,
                29.2251003
              ],
              [
                50.7390223,
                29.2245504
              ],
              [
                50.7412455,
                29.2234416
              ],
              [
                50.7426321,
                29.2234416
              ],
              [
                50.7462454,
                29.2226032
              ],
              [
                50.7470788,
                29.2226032
              ],
              [
                50.7484654,
                29.2234416
              ],
              [
                50.7490221,
                29.2251004
              ],
              [
                50.7479121,
                29.2262092
              ],
              [
                50.7459653,
                29.2281564
              ],
              [
                50.7456887,
                29.2287154
              ],
              [
                50.7462454,
                29.2306626
              ],
              [
                50.7467988,
                29.2312125
              ],
              [
                50.7506886,
                29.2303832
              ],
              [
                50.7548554,
                29.2303831
              ],
              [
                50.7556886,
                29.2306627
              ],
              [
                50.7576352,
                29.2328803
              ],
              [
                50.7581886,
                29.2359364
              ],
              [
                50.7559686,
                29.2406603
              ],
              [
                50.7581886,
                29.2437165
              ],
              [
                50.7664012,
                29.2493885
              ],
              [
                50.7694544,
                29.2502727
              ],
              [
                50.7685246,
                29.2521732
              ],
              [
                50.764687,
                29.2544274
              ],
              [
                50.7643438,
                29.255829
              ],
              [
                50.7650841,
                29.2568988
              ],
              [
                50.7656633,
                29.2576333
              ],
              [
                50.770296,
                29.263161
              ],
              [
                50.7743018,
                29.2667685
              ],
              [
                50.7745783,
                29.2681568
              ],
              [
                50.7731918,
                29.2703836
              ],
              [
                50.7743017,
                29.2773255
              ],
              [
                50.7768017,
                29.2806612
              ],
              [
                50.7779511,
                29.2821256
              ],
              [
                50.7789659,
                29.2813745
              ],
              [
                50.7808845,
                29.2806896
              ],
              [
                50.7821281,
                29.280722
              ],
              [
                50.7829789,
                29.2811337
              ],
              [
                50.7835773,
                29.281339
              ],
              [
                50.7853793,
                29.2815975
              ],
              [
                50.7867146,
                29.2815528
              ],
              [
                50.7903039,
                29.2810669
              ],
              [
                50.7913803,
                29.280486
              ],
              [
                50.7932224,
                29.2805314
              ],
              [
                50.7945711,
                29.2814895
              ],
              [
                50.7964817,
                29.283375
              ],
              [
                50.7979386,
                29.2831329
              ],
              [
                50.7981733,
                29.2816918
              ],
              [
                50.799177,
                29.2789933
              ],
              [
                50.7996296,
                29.2781958
              ],
              [
                50.8011633,
                29.2777409
              ],
              [
                50.8020193,
                29.2780133
              ],
              [
                50.8052122,
                29.27951
              ],
              [
                50.8071254,
                29.2799232
              ],
              [
                50.8088313,
                29.2810346
              ],
              [
                50.810149,
                29.2814396
              ],
              [
                50.8116103,
                29.2807715
              ],
              [
                50.8107385,
                29.2794805
              ],
              [
                50.8093558,
                29.2781438
              ],
              [
                50.80814,
                29.2769828
              ],
              [
                50.8064969,
                29.2755885
              ],
              [
                50.8042537,
                29.2736851
              ],
              [
                50.8043537,
                29.2717907
              ],
              [
                50.8071635,
                29.2712962
              ],
              [
                50.8120881,
                29.2723684
              ],
              [
                50.8115245,
                29.2681568
              ],
              [
                50.8111101,
                29.2675404
              ],
              [
                50.8102311,
                29.2666176
              ],
              [
                50.810135,
                29.265785
              ],
              [
                50.8107974,
                29.2641511
              ],
              [
                50.8127274,
                29.2629242
              ],
              [
                50.8186986,
                29.2714919
              ],
              [
                50.8213648,
                29.2730518
              ],
              [
                50.8213702,
                29.2734753
              ],
              [
                50.8213788,
                29.2739925
              ],
              [
                50.8195701,
                29.2756826
              ],
              [
                50.8170425,
                29.278439
              ],
              [
                50.8133426,
                29.2837162
              ],
              [
                50.8104144,
                29.2853029
              ],
              [
                50.8104144,
                29.2853852
              ],
              [
                50.8129143,
                29.2864942
              ],
              [
                50.8145809,
                29.2848263
              ],
              [
                50.8188276,
                29.2845247
              ],
              [
                50.8207326,
                29.2844124
              ],
              [
                50.824501,
                29.2862206
              ],
              [
                50.8284669,
                29.2855469
              ],
              [
                50.8344131,
                29.2834211
              ],
              [
                50.84016,
                29.280056
              ],
              [
                50.8425201,
                29.2760902
              ],
              [
                50.8434509,
                29.2746642
              ],
              [
                50.8434997,
                29.2745895
              ],
              [
                50.8441888,
                29.2729991
              ],
              [
                50.8459706,
                29.2731604
              ],
              [
                50.8477016,
                29.2738155
              ],
              [
                50.8473512,
                29.2764618
              ],
              [
                50.8489187,
                29.2763501
              ],
              [
                50.8524771,
                29.2764692
              ],
              [
                50.853125,
                29.2769734
              ],
              [
                50.8529706,
                29.2784118
              ],
              [
                50.85296,
                29.2805195
              ],
              [
                50.8520837,
                29.2823291
              ],
              [
                50.8507024,
                29.2851766
              ],
              [
                50.8504603,
                29.2865388
              ],
              [
                50.8498941,
                29.2871212
              ],
              [
                50.8190242,
                29.3112151
              ],
              [
                50.8173576,
                29.312324
              ],
              [
                50.8129143,
                29.3167687
              ],
              [
                50.8084711,
                29.320943
              ],
              [
                50.7920812,
                29.3378839
              ],
              [
                50.7856915,
                29.3453851
              ],
              [
                50.7637449,
                29.3628853
              ],
              [
                50.7593017,
                29.3673303
              ],
              [
                50.7568018,
                29.3751024
              ],
              [
                50.7570784,
                29.3787178
              ],
              [
                50.7618017,
                29.3978866
              ],
              [
                50.7618017,
                29.4028908
              ],
              [
                50.7640217,
                29.4064974
              ],
              [
                50.7643277,
                29.4066185
              ],
              [
                50.7654115,
                29.4070474
              ],
              [
                50.7693015,
                29.4092744
              ],
              [
                50.7698583,
                29.4139992
              ],
              [
                50.7693014,
                29.4159378
              ],
              [
                50.7679115,
                29.4181648
              ],
              [
                50.7670781,
                29.4189944
              ],
              [
                50.7666074,
                29.4191522
              ],
              [
                50.7662449,
                29.4192738
              ],
              [
                50.7579117,
                29.4281643
              ],
              [
                50.7604116,
                29.4309415
              ],
              [
                50.7631882,
                29.4328891
              ],
              [
                50.7648549,
                29.4326095
              ],
              [
                50.7662449,
                29.4326095
              ],
              [
                50.7668015,
                29.43233
              ],
              [
                50.7679115,
                29.4289939
              ],
              [
                50.7681881,
                29.4287143
              ],
              [
                50.7718014,
                29.4276143
              ],
              [
                50.7726348,
                29.4289939
              ],
              [
                50.773468,
                29.4292733
              ],
              [
                50.7735695,
                29.4293759
              ],
              [
                50.7737446,
                29.4295529
              ],
              [
                50.7748582,
                29.4295528
              ],
              [
                50.7754113,
                29.4298324
              ],
              [
                50.7765247,
                29.4298324
              ],
              [
                50.7768013,
                29.4295529
              ],
              [
                50.7772514,
                29.4295529
              ],
              [
                50.7776348,
                29.4295529
              ],
              [
                50.7795779,
                29.4315005
              ],
              [
                50.7801346,
                29.4337186
              ],
              [
                50.7787448,
                29.4356662
              ],
              [
                50.772358,
                29.4390025
              ],
              [
                50.772078,
                29.4395524
              ],
              [
                50.7743015,
                29.4420501
              ],
              [
                50.7765247,
                29.4431592
              ],
              [
                50.7790246,
                29.4437182
              ],
              [
                50.7851345,
                29.4406615
              ],
              [
                50.7859679,
                29.4406616
              ],
              [
                50.7864946,
                29.4410583
              ],
              [
                50.7870812,
                29.4415001
              ],
              [
                50.7887477,
                29.4445478
              ],
              [
                50.7887478,
                29.4459364
              ],
              [
                50.7890245,
                29.4481636
              ],
              [
                50.7893011,
                29.448443
              ],
              [
                50.7890245,
                29.4487226
              ],
              [
                50.7859679,
                29.4512202
              ],
              [
                50.7850721,
                29.4516176
              ],
              [
                50.7834678,
                29.4523293
              ],
              [
                50.7826346,
                29.4523294
              ],
              [
                50.779528,
                29.4536616
              ],
              [
                50.7787447,
                29.4539975
              ],
              [
                50.7787446,
                29.4551066
              ],
              [
                50.7784679,
                29.4553861
              ],
              [
                50.7787446,
                29.4587223
              ],
              [
                50.782078,
                29.4612201
              ],
              [
                50.7826345,
                29.4628882
              ],
              [
                50.7795778,
                29.4687222
              ],
              [
                50.7790245,
                29.4690018
              ],
              [
                50.7765247,
                29.4734381
              ],
              [
                50.7765247,
                29.4739972
              ],
              [
                50.7806912,
                29.4812199
              ],
              [
                50.786801,
                29.4834381
              ],
              [
                50.7904144,
                29.4817789
              ],
              [
                50.7934677,
                29.4839972
              ],
              [
                50.794301,
                29.4862244
              ],
              [
                50.7940244,
                29.487054
              ],
              [
                50.7879145,
                29.4931677
              ],
              [
                50.7859678,
                29.495945
              ],
              [
                50.7865245,
                29.4995519
              ],
              [
                50.7901343,
                29.5039975
              ],
              [
                50.7906911,
                29.5042769
              ],
              [
                50.7993008,
                29.5087225
              ],
              [
                50.8012475,
                29.5203911
              ],
              [
                50.8018009,
                29.5215002
              ],
              [
                50.8018008,
                29.5223389
              ],
              [
                50.802634,
                29.5228889
              ],
              [
                50.8037476,
                29.5245571
              ],
              [
                50.8040242,
                29.5287232
              ],
              [
                50.8038723,
                29.5290252
              ],
              [
                50.8037476,
                29.5292733
              ],
              [
                50.8040241,
                29.5323393
              ],
              [
                50.8046092,
                29.5333613
              ],
              [
                50.8051341,
                29.5342781
              ],
              [
                50.8054142,
                29.5356667
              ],
              [
                50.8054142,
                29.5378851
              ],
              [
                50.8051341,
                29.5387237
              ],
              [
                50.8054142,
                29.5417807
              ],
              [
                50.8106907,
                29.5464969
              ],
              [
                50.811524,
                29.5526109
              ],
              [
                50.8081908,
                29.5581658
              ],
              [
                50.8109707,
                29.5595546
              ],
              [
                50.8112472,
                29.559275
              ],
              [
                50.8134707,
                29.559275
              ],
              [
                50.8137473,
                29.5603932
              ],
              [
                50.8123572,
                29.5634503
              ],
              [
                50.8156905,
                29.5667778
              ],
              [
                50.8159706,
                29.5676074
              ],
              [
                50.8159705,
                29.5684461
              ],
              [
                50.8159706,
                29.5687257
              ],
              [
                50.8151374,
                29.5709441
              ],
              [
                50.8148572,
                29.5717827
              ],
              [
                50.8145805,
                29.5731715
              ],
              [
                50.8101372,
                29.5803858
              ],
              [
                50.8090239,
                29.5812245
              ],
              [
                50.8059672,
                29.5820541
              ],
              [
                50.8048572,
                29.5831633
              ],
              [
                50.8062473,
                29.5842815
              ],
              [
                50.8084706,
                29.5845521
              ],
              [
                50.8112472,
                29.5862204
              ],
              [
                50.8112472,
                29.5867795
              ],
              [
                50.8081907,
                29.5881682
              ],
              [
                50.8076374,
                29.5881683
              ],
              [
                50.8073573,
                29.5884478
              ],
              [
                50.8068039,
                29.5884478
              ],
              [
                50.8068039,
                29.5896069
              ],
              [
                50.8068039,
                29.5903867
              ],
              [
                50.8065241,
                29.5906663
              ],
              [
                50.8073573,
                29.5934439
              ],
              [
                50.8073573,
                29.5937234
              ],
              [
                50.8070807,
                29.5951122
              ],
              [
                50.8070807,
                29.5959418
              ],
              [
                50.805134,
                29.598999
              ],
              [
                50.8040241,
                29.5995581
              ],
              [
                50.8027901,
                29.5997133
              ],
              [
                50.8018007,
                29.5998376
              ],
              [
                50.797634,
                29.602056
              ],
              [
                50.7973574,
                29.6026152
              ],
              [
                50.7981907,
                29.6076113
              ],
              [
                50.7984674,
                29.6123368
              ],
              [
                50.8012474,
                29.6278932
              ],
              [
                50.8018006,
                29.6309504
              ],
              [
                50.8026339,
                29.6320597
              ],
              [
                50.8026339,
                29.6326099
              ],
              [
                50.8043006,
                29.6337191
              ],
              [
                50.8062472,
                29.6364967
              ],
              [
                50.8062472,
                29.6370559
              ],
              [
                50.8048572,
                29.6378946
              ],
              [
                50.8034673,
                29.6378946
              ],
              [
                50.8026338,
                29.637615
              ],
              [
                50.8012473,
                29.637615
              ],
              [
                50.8006907,
                29.6373355
              ],
              [
                50.7998573,
                29.6373354
              ],
              [
                50.7995808,
                29.6370558
              ],
              [
                50.7979141,
                29.6373354
              ],
              [
                50.796524,
                29.6373354
              ],
              [
                50.7956908,
                29.637615
              ],
              [
                50.7951341,
                29.637615
              ],
              [
                50.7951341,
                29.6384447
              ],
              [
                50.7951341,
                29.6387555
              ],
              [
                50.7951341,
                29.6390038
              ],
              [
                50.7954141,
                29.6403926
              ],
              [
                50.796524,
                29.6423317
              ],
              [
                50.7970806,
                29.6467777
              ],
              [
                50.796524,
                29.6476075
              ],
              [
                50.7962474,
                29.6490053
              ],
              [
                50.7968008,
                29.6523331
              ],
              [
                50.8012473,
                29.6548403
              ],
              [
                50.8026338,
                29.6573384
              ],
              [
                50.8031906,
                29.6587273
              ],
              [
                50.805414,
                29.6634529
              ],
              [
                50.8051339,
                29.6656715
              ],
              [
                50.8040239,
                29.6670604
              ],
              [
                50.8034672,
                29.6684493
              ],
              [
                50.8043005,
                29.673166
              ],
              [
                50.8056905,
                29.6737251
              ],
              [
                50.8070806,
                29.6737252
              ],
              [
                50.8079138,
                29.6734456
              ],
              [
                50.8084705,
                29.6728865
              ],
              [
                50.8131904,
                29.6728865
              ],
              [
                50.8137471,
                29.673166
              ],
              [
                50.8151372,
                29.6790012
              ],
              [
                50.8148571,
                29.6801104
              ],
              [
                50.8145804,
                29.6823381
              ],
              [
                50.8140237,
                29.6851158
              ],
              [
                50.8143037,
                29.689553
              ],
              [
                50.8165237,
                29.6926194
              ],
              [
                50.8148571,
                29.6962269
              ],
              [
                50.8140236,
                29.6967771
              ],
              [
                50.813747,
                29.6973363
              ],
              [
                50.8131904,
                29.6973363
              ],
              [
                50.8126371,
                29.6978864
              ],
              [
                50.8120804,
                29.6992844
              ],
              [
                50.8115238,
                29.7006642
              ],
              [
                50.8148571,
                29.7053901
              ],
              [
                50.8137471,
                29.7081679
              ],
              [
                50.8118037,
                29.7098364
              ],
              [
                50.8084704,
                29.710116
              ],
              [
                50.8065238,
                29.7117845
              ],
              [
                50.8056905,
                29.7117845
              ],
              [
                50.8048571,
                29.7123347
              ],
              [
                50.8043004,
                29.7123347
              ],
              [
                50.8040238,
                29.7126143
              ],
              [
                50.8001339,
                29.7126142
              ],
              [
                50.7937473,
                29.7165014
              ],
              [
                50.792634,
                29.7198384
              ],
              [
                50.7934674,
                29.7223367
              ],
              [
                50.7948573,
                29.7234461
              ],
              [
                50.8040238,
                29.7267831
              ],
              [
                50.8059671,
                29.7287223
              ],
              [
                50.8070805,
                29.7317797
              ],
              [
                50.8145802,
                29.7392836
              ],
              [
                50.8159703,
                29.7487267
              ],
              [
                50.8195804,
                29.7542826
              ],
              [
                50.8254134,
                29.7578903
              ],
              [
                50.8254134,
                29.761507
              ],
              [
                50.8234703,
                29.7640053
              ],
              [
                50.8229136,
                29.7651147
              ],
              [
                50.8262468,
                29.7715005
              ],
              [
                50.8262469,
                29.774558
              ],
              [
                50.8268299,
                29.7754366
              ],
              [
                50.8262468,
                29.7756675
              ],
              [
                50.8256935,
                29.7759471
              ],
              [
                50.8226368,
                29.775947
              ],
              [
                50.82069,
                29.7753968
              ],
              [
                50.8201369,
                29.7756675
              ],
              [
                50.8195803,
                29.7753969
              ],
              [
                50.8184704,
                29.7756674
              ],
              [
                50.8154136,
                29.7753968
              ],
              [
                50.8018005,
                29.780114
              ],
              [
                50.8006905,
                29.780114
              ],
              [
                50.8001338,
                29.7803936
              ],
              [
                50.7987471,
                29.7803936
              ],
              [
                50.7981904,
                29.7806732
              ],
              [
                50.7912473,
                29.7806732
              ],
              [
                50.787914,
                29.7812234
              ],
              [
                50.7829107,
                29.7817826
              ],
              [
                50.7804109,
                29.7817826
              ],
              [
                50.7790241,
                29.7820621
              ],
              [
                50.7751342,
                29.7820621
              ],
              [
                50.7737441,
                29.7817825
              ],
              [
                50.7654109,
                29.7817825
              ],
              [
                50.7526345,
                29.7828919
              ],
              [
                50.7512444,
                29.7831715
              ],
              [
                50.7484645,
                29.7831715
              ],
              [
                50.7456879,
                29.7834511
              ],
              [
                50.7323549,
                29.7865087
              ],
              [
                50.7304081,
                29.7873385
              ],
              [
                50.7037418,
                29.7915055
              ],
              [
                50.6684622,
                29.8048364
              ],
              [
                50.6656856,
                29.8056752
              ],
              [
                50.6476295,
                29.817058
              ],
              [
                50.6448493,
                29.822064
              ],
              [
                50.6440161,
                29.8253923
              ],
              [
                50.644016,
                29.827061
              ],
              [
                50.6445727,
                29.8287296
              ],
              [
                50.6515158,
                29.8345655
              ],
              [
                50.654296,
                29.8353953
              ],
              [
                50.6559624,
                29.8353952
              ],
              [
                50.6565191,
                29.8356749
              ],
              [
                50.6601292,
                29.8356749
              ],
              [
                50.6606859,
                29.8362251
              ],
              [
                50.6606859,
                29.8370639
              ],
              [
                50.6604059,
                29.8373435
              ],
              [
                50.661239,
                29.8390032
              ],
              [
                50.6620722,
                29.8390032
              ],
              [
                50.6626289,
                29.8387236
              ],
              [
                50.6634624,
                29.8387235
              ],
              [
                50.6642957,
                29.8381734
              ],
              [
                50.6656856,
                29.8381734
              ],
              [
                50.6665192,
                29.8387236
              ],
              [
                50.6659622,
                29.8392828
              ],
              [
                50.6651289,
                29.8392828
              ],
              [
                50.6645723,
                29.8398421
              ],
              [
                50.6648523,
                29.8415017
              ],
              [
                50.6670723,
                29.8412311
              ],
              [
                50.667629,
                29.8415017
              ],
              [
                50.6681856,
                29.8440093
              ],
              [
                50.6670723,
                29.8445595
              ],
              [
                50.6659622,
                29.8456779
              ],
              [
                50.6654055,
                29.8459485
              ],
              [
                50.6656856,
                29.847067
              ],
              [
                50.6681856,
                29.8473376
              ],
              [
                50.6690189,
                29.8470671
              ],
              [
                50.6706857,
                29.8484561
              ],
              [
                50.6709623,
                29.8503953
              ],
              [
                50.6704055,
                29.8523437
              ],
              [
                50.6690188,
                29.8542829
              ],
              [
                50.6695723,
                29.8548422
              ],
              [
                50.6715189,
                29.8548422
              ],
              [
                50.672072,
                29.8545626
              ],
              [
                50.6729056,
                29.8545626
              ],
              [
                50.6731857,
                29.8548422
              ],
              [
                50.6740189,
                29.8548422
              ],
              [
                50.6754088,
                29.8562313
              ],
              [
                50.6751287,
                29.8565109
              ],
              [
                50.6748521,
                29.8573408
              ],
              [
                50.6745756,
                29.8584502
              ],
              [
                50.6742955,
                29.8606691
              ],
              [
                50.6751287,
                29.8628971
              ],
              [
                50.6759623,
                29.8631767
              ],
              [
                50.6790186,
                29.8617876
              ],
              [
                50.6798522,
                29.8609488
              ],
              [
                50.6804088,
                29.8606692
              ],
              [
                50.680962,
                29.8617877
              ],
              [
                50.6815187,
                29.8640066
              ],
              [
                50.682909,
                29.8656753
              ],
              [
                50.6837421,
                29.865116
              ],
              [
                50.6842952,
                29.8651161
              ],
              [
                50.6848518,
                29.8645658
              ],
              [
                50.6837422,
                29.8606692
              ],
              [
                50.6851284,
                29.8592801
              ],
              [
                50.6873519,
                29.8592801
              ],
              [
                50.689852,
                29.8623379
              ],
              [
                50.6940185,
                29.8612284
              ],
              [
                50.6945752,
                29.8615081
              ],
              [
                50.6954087,
                29.8615081
              ],
              [
                50.700685,
                29.8667848
              ],
              [
                50.7034651,
                29.8667848
              ],
              [
                50.7034651,
                29.8665051
              ],
              [
                50.7045749,
                29.8659549
              ],
              [
                50.7056851,
                29.8653957
              ],
              [
                50.7062417,
                29.8648365
              ],
              [
                50.7087418,
                29.8648364
              ],
              [
                50.7126317,
                29.8662255
              ],
              [
                50.7137415,
                29.873171
              ],
              [
                50.7134649,
                29.8734507
              ],
              [
                50.696242,
                29.8876123
              ],
              [
                50.6801288,
                29.8976157
              ],
              [
                50.6604057,
                29.9148446
              ],
              [
                50.6601292,
                29.9151152
              ],
              [
                50.6587388,
                29.9145649
              ],
              [
                50.6504059,
                29.9101179
              ],
              [
                50.6506824,
                29.9087288
              ],
              [
                50.6509626,
                29.9081695
              ],
              [
                50.6509625,
                29.9054003
              ],
              [
                50.6498493,
                29.9031722
              ],
              [
                50.6492957,
                29.9028926
              ],
              [
                50.6415159,
                29.8953968
              ],
              [
                50.6398495,
                29.8953967
              ],
              [
                50.6390159,
                29.8951171
              ],
              [
                50.6373494,
                29.8951171
              ],
              [
                50.6362393,
                29.8948375
              ],
              [
                50.6340161,
                29.8948375
              ],
              [
                50.6290161,
                29.8965062
              ],
              [
                50.6270727,
                29.8965062
              ],
              [
                50.6234593,
                29.8973361
              ],
              [
                50.6212397,
                29.8973361
              ],
              [
                50.6140162,
                29.8965063
              ],
              [
                50.6120697,
                29.8959469
              ],
              [
                50.6115165,
                29.8956763
              ],
              [
                50.59568,
                29.8926184
              ],
              [
                50.5926268,
                29.8926184
              ],
              [
                50.5912368,
                29.8923388
              ],
              [
                50.5795702,
                29.8909497
              ],
              [
                50.5620703,
                29.8895605
              ],
              [
                50.5581805,
                29.8895605
              ],
              [
                50.5570672,
                29.8901197
              ],
              [
                50.5556804,
                29.8903904
              ],
              [
                50.5498475,
                29.8901198
              ],
              [
                50.5431809,
                29.8901198
              ],
              [
                50.5426238,
                29.8898401
              ],
              [
                50.5415106,
                29.8901197
              ],
              [
                50.5292908,
                29.8912292
              ],
              [
                50.5287342,
                29.8909496
              ],
              [
                50.5159542,
                29.8884509
              ],
              [
                50.5142878,
                29.8873415
              ],
              [
                50.5137347,
                29.8870618
              ],
              [
                50.5129011,
                29.8867822
              ],
              [
                50.5037314,
                29.8765082
              ],
              [
                50.4962313,
                29.8615078
              ],
              [
                50.4906781,
                29.8445591
              ],
              [
                50.4870651,
                29.8384528
              ],
              [
                50.4678989,
                29.8256717
              ],
              [
                50.4678988,
                29.8251124
              ],
              [
                50.4615089,
                29.8203951
              ],
              [
                50.4531755,
                29.816228
              ],
              [
                50.4406757,
                29.8123314
              ],
              [
                50.4345623,
                29.8115015
              ],
              [
                50.4328958,
                29.8109514
              ],
              [
                50.4317857,
                29.8109514
              ],
              [
                50.4237293,
                29.8092828
              ],
              [
                50.4173394,
                29.8065047
              ],
              [
                50.4162296,
                29.8056749
              ],
              [
                50.3967831,
                29.7953924
              ],
              [
                50.3690034,
                29.779004
              ],
              [
                50.3659502,
                29.7770649
              ],
              [
                50.3342805,
                29.7553913
              ],
              [
                50.3193867,
                29.746732
              ],
              [
                49.8426242,
                29.3901539
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836764246
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.2742019,
          28.8830282
        ]
      }
    }
  ]
},
"تهران.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554884,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اسلامشهر",
          "name:ar": "مقاطعة إسلام شهر",
          "name:azb": "ایسلامشهر بؤلگه‌سی",
          "name:de": "Schahrestan Eslamschahr",
          "name:en": "Eslamshahr County",
          "name:es": "Condado de Islamshahr",
          "name:ur": "شہرستان اسلامشہر",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282239",
          "wikipedia": "fa:شهرستان اسلامشهر"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.1658813,
                35.6462888
              ],
              [
                51.1740304,
                35.6394396
              ],
              [
                51.1780142,
                35.6365225
              ],
              [
                51.1762127,
                35.6331386
              ],
              [
                51.1759764,
                35.6324703
              ],
              [
                51.1756996,
                35.6274756
              ],
              [
                51.1758334,
                35.6272096
              ],
              [
                51.1759763,
                35.6258076
              ],
              [
                51.176533,
                35.6230308
              ],
              [
                51.1768096,
                35.6213629
              ],
              [
                51.1770863,
                35.6183065
              ],
              [
                51.1783619,
                35.6114884
              ],
              [
                51.1797406,
                35.6041181
              ],
              [
                51.1804765,
                35.5985047
              ],
              [
                51.181533,
                35.5944141
              ],
              [
                51.1818095,
                35.5921962
              ],
              [
                51.1820862,
                35.5888602
              ],
              [
                51.1823663,
                35.5877512
              ],
              [
                51.1823663,
                35.5871923
              ],
              [
                51.182643,
                35.5858038
              ],
              [
                51.181648,
                35.5797282
              ],
              [
                51.1815386,
                35.5773219
              ],
              [
                51.1817929,
                35.5708442
              ],
              [
                51.1906996,
                35.5530295
              ],
              [
                51.1921934,
                35.5488659
              ],
              [
                51.1929874,
                35.5466628
              ],
              [
                51.1893847,
                35.5459848
              ],
              [
                51.1896394,
                35.5452603
              ],
              [
                51.1903755,
                35.5443794
              ],
              [
                51.1914365,
                35.5438333
              ],
              [
                51.1927356,
                35.5434809
              ],
              [
                51.19371,
                35.54334
              ],
              [
                51.1937966,
                35.5425648
              ],
              [
                51.1941696,
                35.5417447
              ],
              [
                51.1944067,
                35.5412235
              ],
              [
                51.1948662,
                35.5408031
              ],
              [
                51.1957244,
                35.5400697
              ],
              [
                51.1967201,
                35.5395719
              ],
              [
                51.1979034,
                35.5389887
              ],
              [
                51.1989076,
                35.5381506
              ],
              [
                51.1991921,
                35.5375986
              ],
              [
                51.199173,
                35.5373339
              ],
              [
                51.2000663,
                35.5289727
              ],
              [
                51.2006328,
                35.5267304
              ],
              [
                51.1993453,
                35.520171
              ],
              [
                51.202461,
                35.5129613
              ],
              [
                51.2038257,
                35.5081614
              ],
              [
                51.204994,
                35.5016854
              ],
              [
                51.2041443,
                35.4937193
              ],
              [
                51.2106594,
                35.4845073
              ],
              [
                51.2113634,
                35.4847491
              ],
              [
                51.2133158,
                35.4846649
              ],
              [
                51.2138307,
                35.4842875
              ],
              [
                51.2154014,
                35.4850004
              ],
              [
                51.2267187,
                35.4899411
              ],
              [
                51.2312248,
                35.4907588
              ],
              [
                51.2362946,
                35.492796
              ],
              [
                51.2494327,
                35.5009786
              ],
              [
                51.2576568,
                35.5052516
              ],
              [
                51.2624586,
                35.5110715
              ],
              [
                51.2714165,
                35.5214287
              ],
              [
                51.2743621,
                35.5247434
              ],
              [
                51.2792052,
                35.5286922
              ],
              [
                51.2840203,
                35.5324222
              ],
              [
                51.2859,
                35.5328413
              ],
              [
                51.2922085,
                35.5330508
              ],
              [
                51.2960396,
                35.5334682
              ],
              [
                51.3111115,
                35.5406202
              ],
              [
                51.315609,
                35.5429948
              ],
              [
                51.3173599,
                35.5438328
              ],
              [
                51.3190422,
                35.5448664
              ],
              [
                51.3195229,
                35.5457324
              ],
              [
                51.3189392,
                35.5465425
              ],
              [
                51.3185272,
                35.5470453
              ],
              [
                51.3185616,
                35.5477995
              ],
              [
                51.3183212,
                35.5486934
              ],
              [
                51.3180466,
                35.5498107
              ],
              [
                51.3180809,
                35.5507604
              ],
              [
                51.3178406,
                35.5525691
              ],
              [
                51.3178343,
                35.554249
              ],
              [
                51.3180918,
                35.5548146
              ],
              [
                51.3184008,
                35.555443
              ],
              [
                51.3182978,
                35.5562391
              ],
              [
                51.3180403,
                35.5566161
              ],
              [
                51.3177055,
                35.557873
              ],
              [
                51.3163923,
                35.5592555
              ],
              [
                51.3149246,
                35.559884
              ],
              [
                51.3131619,
                35.5606773
              ],
              [
                51.3146925,
                35.5637292
              ],
              [
                51.318698,
                35.5717156
              ],
              [
                51.3202172,
                35.5739565
              ],
              [
                51.3228436,
                35.5755901
              ],
              [
                51.3244658,
                35.5769095
              ],
              [
                51.3302594,
                35.5812446
              ],
              [
                51.3379327,
                35.5882806
              ],
              [
                51.3403804,
                35.5902656
              ],
              [
                51.3451797,
                35.5941575
              ],
              [
                51.3448198,
                35.5968159
              ],
              [
                51.3413431,
                35.600062
              ],
              [
                51.3437893,
                35.6035792
              ],
              [
                51.3430426,
                35.6058403
              ],
              [
                51.3434509,
                35.6078458
              ],
              [
                51.3405812,
                35.6081217
              ],
              [
                51.3376302,
                35.6092481
              ],
              [
                51.3343813,
                35.6104882
              ],
              [
                51.330589,
                35.6138458
              ],
              [
                51.3299043,
                35.6145909
              ],
              [
                51.3248439,
                35.6200969
              ],
              [
                51.3246313,
                35.6203321
              ],
              [
                51.3240165,
                35.6210814
              ],
              [
                51.3231014,
                35.6221968
              ],
              [
                51.3230067,
                35.6222917
              ],
              [
                51.3213909,
                35.6242637
              ],
              [
                51.3209276,
                35.6247797
              ],
              [
                51.319542,
                35.6262263
              ],
              [
                51.3188817,
                35.6268575
              ],
              [
                51.3172576,
                35.6282217
              ],
              [
                51.3164181,
                35.6288655
              ],
              [
                51.3155899,
                35.6294183
              ],
              [
                51.3138066,
                35.630538
              ],
              [
                51.3114948,
                35.6317621
              ],
              [
                51.3106771,
                35.6321951
              ],
              [
                51.3056536,
                35.6347184
              ],
              [
                51.3038112,
                35.6356438
              ],
              [
                51.301173,
                35.6369689
              ],
              [
                51.2990177,
                35.6380512
              ],
              [
                51.2915857,
                35.6417245
              ],
              [
                51.2873203,
                35.6437041
              ],
              [
                51.2857974,
                35.6443967
              ],
              [
                51.2850981,
                35.6447149
              ],
              [
                51.2825714,
                35.6458492
              ],
              [
                51.2821948,
                35.6460183
              ],
              [
                51.2804473,
                35.6467733
              ],
              [
                51.2793907,
                35.6472297
              ],
              [
                51.2746857,
                35.6490051
              ],
              [
                51.2709796,
                35.6505013
              ],
              [
                51.258661,
                35.6552857
              ],
              [
                51.2516963,
                35.6578264
              ],
              [
                51.249246,
                35.6459202
              ],
              [
                51.238972,
                35.6446228
              ],
              [
                51.2337192,
                35.642614
              ],
              [
                51.2314018,
                35.6401447
              ],
              [
                51.2276166,
                35.640082
              ],
              [
                51.2216647,
                35.6489912
              ],
              [
                51.2190006,
                35.6494153
              ],
              [
                51.2143519,
                35.6500793
              ],
              [
                51.213528,
                35.6474847
              ],
              [
                51.2126653,
                35.6449458
              ],
              [
                51.2094619,
                35.6469237
              ],
              [
                51.2056444,
                35.6492807
              ],
              [
                51.1902747,
                35.658467
              ],
              [
                51.1784499,
                35.6468982
              ],
              [
                51.174573,
                35.648848
              ],
              [
                51.1707703,
                35.6510381
              ],
              [
                51.1658813,
                35.6462888
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554945,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بهارستان",
          "name:en": "Baharestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4811776",
          "wikipedia": "fa:شهرستان بهارستان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.1181869,
                35.5492009
              ],
              [
                51.1196803,
                35.5446127
              ],
              [
                51.1205558,
                35.5422871
              ],
              [
                51.1214568,
                35.5401678
              ],
              [
                51.1233107,
                35.5383449
              ],
              [
                51.1413355,
                35.5254353
              ],
              [
                51.1444752,
                35.523493
              ],
              [
                51.1456017,
                35.5245056
              ],
              [
                51.1470396,
                35.5235815
              ],
              [
                51.1452669,
                35.5221485
              ],
              [
                51.1381906,
                35.5170577
              ],
              [
                51.1357989,
                35.5154597
              ],
              [
                51.1339179,
                35.5139552
              ],
              [
                51.1299067,
                35.5108952
              ],
              [
                51.1271432,
                35.5087682
              ],
              [
                51.1217581,
                35.504856
              ],
              [
                51.1223888,
                35.5043608
              ],
              [
                51.1226194,
                35.5042291
              ],
              [
                51.1230004,
                35.5040114
              ],
              [
                51.123687,
                35.5037494
              ],
              [
                51.1245024,
                35.5031467
              ],
              [
                51.1229896,
                35.4992163
              ],
              [
                51.1222815,
                35.4968928
              ],
              [
                51.128244,
                35.5008415
              ],
              [
                51.1345164,
                35.5051114
              ],
              [
                51.1390538,
                35.5006594
              ],
              [
                51.1428475,
                35.4968158
              ],
              [
                51.1447906,
                35.497941
              ],
              [
                51.1473441,
                35.4988669
              ],
              [
                51.1492703,
                35.4953677
              ],
              [
                51.1501775,
                35.4946124
              ],
              [
                51.1539533,
                35.4908274
              ],
              [
                51.1518827,
                35.4887763
              ],
              [
                51.1506271,
                35.4874761
              ],
              [
                51.1496079,
                35.4867685
              ],
              [
                51.149473,
                35.4852906
              ],
              [
                51.1504257,
                35.4839802
              ],
              [
                51.1502047,
                35.4838195
              ],
              [
                51.1489963,
                35.4827761
              ],
              [
                51.1505735,
                35.4815093
              ],
              [
                51.1483623,
                35.4793882
              ],
              [
                51.1468931,
                35.4779341
              ],
              [
                51.1478871,
                35.4775498
              ],
              [
                51.1477187,
                35.4759405
              ],
              [
                51.1479459,
                35.47479
              ],
              [
                51.1493167,
                35.4761388
              ],
              [
                51.1523907,
                35.4746918
              ],
              [
                51.1559358,
                35.4744888
              ],
              [
                51.1567446,
                35.4744425
              ],
              [
                51.1720006,
                35.4728252
              ],
              [
                51.1781083,
                35.4745095
              ],
              [
                51.1803528,
                35.4753104
              ],
              [
                51.1828558,
                35.4774004
              ],
              [
                51.1854927,
                35.4786278
              ],
              [
                51.1895481,
                35.480386
              ],
              [
                51.1945724,
                35.4840516
              ],
              [
                51.2100428,
                35.4808944
              ],
              [
                51.2096909,
                35.4823415
              ],
              [
                51.2106594,
                35.4845073
              ],
              [
                51.2041443,
                35.4937193
              ],
              [
                51.204994,
                35.5016854
              ],
              [
                51.2038257,
                35.5081614
              ],
              [
                51.202461,
                35.5129613
              ],
              [
                51.1993453,
                35.520171
              ],
              [
                51.2006328,
                35.5267304
              ],
              [
                51.2000663,
                35.5289727
              ],
              [
                51.199173,
                35.5373339
              ],
              [
                51.1991921,
                35.5375986
              ],
              [
                51.1989076,
                35.5381506
              ],
              [
                51.1979034,
                35.5389887
              ],
              [
                51.1967201,
                35.5395719
              ],
              [
                51.1957244,
                35.5400697
              ],
              [
                51.1948662,
                35.5408031
              ],
              [
                51.1944067,
                35.5412235
              ],
              [
                51.1941696,
                35.5417447
              ],
              [
                51.1937966,
                35.5425648
              ],
              [
                51.19371,
                35.54334
              ],
              [
                51.1927356,
                35.5434809
              ],
              [
                51.1914365,
                35.5438333
              ],
              [
                51.1903755,
                35.5443794
              ],
              [
                51.1896394,
                35.5452603
              ],
              [
                51.1893847,
                35.5459848
              ],
              [
                51.1929874,
                35.5466628
              ],
              [
                51.1921934,
                35.5488659
              ],
              [
                51.1906996,
                35.5530295
              ],
              [
                51.1817929,
                35.5708442
              ],
              [
                51.1815386,
                35.5773219
              ],
              [
                51.181648,
                35.5797282
              ],
              [
                51.182643,
                35.5858038
              ],
              [
                51.1823663,
                35.5871923
              ],
              [
                51.1823663,
                35.5877512
              ],
              [
                51.1820862,
                35.5888602
              ],
              [
                51.1818095,
                35.5921962
              ],
              [
                51.181533,
                35.5944141
              ],
              [
                51.1804765,
                35.5985047
              ],
              [
                51.1745408,
                35.595284
              ],
              [
                51.1699227,
                35.593496
              ],
              [
                51.1670675,
                35.5914155
              ],
              [
                51.164676,
                35.5904305
              ],
              [
                51.1656453,
                35.5880415
              ],
              [
                51.1600505,
                35.5853473
              ],
              [
                51.1595167,
                35.58475
              ],
              [
                51.1577614,
                35.5814858
              ],
              [
                51.1552693,
                35.5799973
              ],
              [
                51.147285,
                35.5763654
              ],
              [
                51.1457486,
                35.5757304
              ],
              [
                51.141547,
                35.5733438
              ],
              [
                51.1385324,
                35.5713662
              ],
              [
                51.1375282,
                35.5704028
              ],
              [
                51.1322238,
                35.5703818
              ],
              [
                51.1296232,
                35.5662976
              ],
              [
                51.1285059,
                35.5636452
              ],
              [
                51.1251328,
                35.5569212
              ],
              [
                51.1251327,
                35.5539256
              ],
              [
                51.1234333,
                35.5516631
              ],
              [
                51.1209053,
                35.5505595
              ],
              [
                51.1181869,
                35.5492009
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554970,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تهران",
          "name:ar": "مقاطعة طهران",
          "name:en": "Tehran County",
          "name:sk": "okres Teherán",
          "place": "county",
          "short_name:ar": "طهران",
          "type": "boundary",
          "website": "https://tehran.ostan-th.ir/",
          "wikidata": "Q643031",
          "wikipedia": "fa:شهرستان تهران"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.0901497,
                35.7456386
              ],
              [
                51.0890493,
                35.7429636
              ],
              [
                51.0933876,
                35.7421762
              ],
              [
                51.0989731,
                35.7409334
              ],
              [
                51.1026979,
                35.7402594
              ],
              [
                51.104756,
                35.7399383
              ],
              [
                51.1136635,
                35.7375146
              ],
              [
                51.1137546,
                35.7374884
              ],
              [
                51.1164378,
                35.7364194
              ],
              [
                51.1236697,
                35.7329578
              ],
              [
                51.125218,
                35.7310599
              ],
              [
                51.1257776,
                35.730269
              ],
              [
                51.1273957,
                35.7280037
              ],
              [
                51.1283693,
                35.726792
              ],
              [
                51.1316791,
                35.7235613
              ],
              [
                51.1321352,
                35.723096
              ],
              [
                51.1325589,
                35.7227039
              ],
              [
                51.1339672,
                35.7215959
              ],
              [
                51.1349819,
                35.72082
              ],
              [
                51.1355659,
                35.720359
              ],
              [
                51.1360812,
                35.7199603
              ],
              [
                51.1391449,
                35.7176549
              ],
              [
                51.1413307,
                35.7163899
              ],
              [
                51.142546,
                35.7157795
              ],
              [
                51.1434179,
                35.7153904
              ],
              [
                51.1471906,
                35.7138823
              ],
              [
                51.152046,
                35.712236
              ],
              [
                51.1621145,
                35.7085122
              ],
              [
                51.1628079,
                35.7082557
              ],
              [
                51.165784,
                35.7076823
              ],
              [
                51.1722416,
                35.7061907
              ],
              [
                51.1764115,
                35.7051047
              ],
              [
                51.1794338,
                35.7043488
              ],
              [
                51.1807935,
                35.7039797
              ],
              [
                51.1824842,
                35.703401
              ],
              [
                51.1834181,
                35.7031228
              ],
              [
                51.1857416,
                35.7021978
              ],
              [
                51.1901569,
                35.7004326
              ],
              [
                51.1966753,
                35.6978452
              ],
              [
                51.2020826,
                35.6956827
              ],
              [
                51.206433,
                35.6939424
              ],
              [
                51.2102014,
                35.6923785
              ],
              [
                51.2127514,
                35.6913353
              ],
              [
                51.2164431,
                35.6899889
              ],
              [
                51.2175907,
                35.6895566
              ],
              [
                51.220004,
                35.6885288
              ],
              [
                51.2201504,
                35.6883711
              ],
              [
                51.2214286,
                35.6869942
              ],
              [
                51.2235382,
                35.6871052
              ],
              [
                51.2245961,
                35.6866969
              ],
              [
                51.2256686,
                35.6862743
              ],
              [
                51.2262811,
                35.6860687
              ],
              [
                51.2276385,
                35.6855387
              ],
              [
                51.2277997,
                35.6845832
              ],
              [
                51.2306453,
                35.6840225
              ],
              [
                51.2333501,
                35.683573
              ],
              [
                51.2325182,
                35.6820743
              ],
              [
                51.2316008,
                35.6807271
              ],
              [
                51.2308185,
                35.6793187
              ],
              [
                51.2304643,
                35.6775739
              ],
              [
                51.2304534,
                35.6768611
              ],
              [
                51.2305214,
                35.675191
              ],
              [
                51.2305865,
                35.6743931
              ],
              [
                51.2308018,
                35.6731431
              ],
              [
                51.2309855,
                35.6723432
              ],
              [
                51.23142,
                35.6711332
              ],
              [
                51.2317087,
                35.670428
              ],
              [
                51.2320761,
                35.6696861
              ],
              [
                51.2326998,
                35.6686264
              ],
              [
                51.2331313,
                35.6680032
              ],
              [
                51.2334019,
                35.6676585
              ],
              [
                51.2335058,
                35.6675157
              ],
              [
                51.2341972,
                35.6666741
              ],
              [
                51.2350687,
                35.6657662
              ],
              [
                51.2358832,
                35.6649989
              ],
              [
                51.236646,
                35.6643844
              ],
              [
                51.2372897,
                35.6638721
              ],
              [
                51.2383636,
                35.6631916
              ],
              [
                51.2392877,
                35.6626345
              ],
              [
                51.2395868,
                35.6624667
              ],
              [
                51.2402994,
                35.6621211
              ],
              [
                51.2412419,
                35.6616891
              ],
              [
                51.242308,
                35.6612621
              ],
              [
                51.2447822,
                35.6603235
              ],
              [
                51.2508769,
                35.6581253
              ],
              [
                51.2516963,
                35.6578264
              ],
              [
                51.258661,
                35.6552857
              ],
              [
                51.2709796,
                35.6505013
              ],
              [
                51.2746857,
                35.6490051
              ],
              [
                51.2793907,
                35.6472297
              ],
              [
                51.2804473,
                35.6467733
              ],
              [
                51.2821948,
                35.6460183
              ],
              [
                51.2825714,
                35.6458492
              ],
              [
                51.2850981,
                35.6447149
              ],
              [
                51.2857974,
                35.6443967
              ],
              [
                51.2873203,
                35.6437041
              ],
              [
                51.2915857,
                35.6417245
              ],
              [
                51.2990177,
                35.6380512
              ],
              [
                51.301173,
                35.6369689
              ],
              [
                51.3038112,
                35.6356438
              ],
              [
                51.3056536,
                35.6347184
              ],
              [
                51.3106771,
                35.6321951
              ],
              [
                51.3114948,
                35.6317621
              ],
              [
                51.3138066,
                35.630538
              ],
              [
                51.3155899,
                35.6294183
              ],
              [
                51.3164181,
                35.6288655
              ],
              [
                51.3172576,
                35.6282217
              ],
              [
                51.3188817,
                35.6268575
              ],
              [
                51.319542,
                35.6262263
              ],
              [
                51.3209276,
                35.6247797
              ],
              [
                51.3213909,
                35.6242637
              ],
              [
                51.3230067,
                35.6222917
              ],
              [
                51.3231014,
                35.6221968
              ],
              [
                51.3240165,
                35.6210814
              ],
              [
                51.3246313,
                35.6203321
              ],
              [
                51.3248439,
                35.6200969
              ],
              [
                51.3299043,
                35.6145909
              ],
              [
                51.330589,
                35.6138458
              ],
              [
                51.3343813,
                35.6104882
              ],
              [
                51.3376302,
                35.6092481
              ],
              [
                51.3405812,
                35.6081217
              ],
              [
                51.3434509,
                35.6078458
              ],
              [
                51.3430426,
                35.6058403
              ],
              [
                51.3437893,
                35.6035792
              ],
              [
                51.3413431,
                35.600062
              ],
              [
                51.3448198,
                35.5968159
              ],
              [
                51.3451797,
                35.5941575
              ],
              [
                51.3403804,
                35.5902656
              ],
              [
                51.3379327,
                35.5882806
              ],
              [
                51.3302594,
                35.5812446
              ],
              [
                51.3244658,
                35.5769095
              ],
              [
                51.3228436,
                35.5755901
              ],
              [
                51.3202172,
                35.5739565
              ],
              [
                51.318698,
                35.5717156
              ],
              [
                51.3146925,
                35.5637292
              ],
              [
                51.3131619,
                35.5606773
              ],
              [
                51.3149246,
                35.559884
              ],
              [
                51.3163923,
                35.5592555
              ],
              [
                51.3177055,
                35.557873
              ],
              [
                51.3180403,
                35.5566161
              ],
              [
                51.3182978,
                35.5562391
              ],
              [
                51.3184008,
                35.555443
              ],
              [
                51.3180918,
                35.5548146
              ],
              [
                51.3178343,
                35.554249
              ],
              [
                51.3178406,
                35.5525691
              ],
              [
                51.3180809,
                35.5507604
              ],
              [
                51.3180466,
                35.5498107
              ],
              [
                51.3183212,
                35.5486934
              ],
              [
                51.3185616,
                35.5477995
              ],
              [
                51.3185272,
                35.5470453
              ],
              [
                51.3189392,
                35.5465425
              ],
              [
                51.3195229,
                35.5457324
              ],
              [
                51.3190422,
                35.5448664
              ],
              [
                51.3173599,
                35.5438328
              ],
              [
                51.315609,
                35.5429948
              ],
              [
                51.3111115,
                35.5406202
              ],
              [
                51.2960396,
                35.5334682
              ],
              [
                51.2922085,
                35.5330508
              ],
              [
                51.2859,
                35.5328413
              ],
              [
                51.2840203,
                35.5324222
              ],
              [
                51.2792052,
                35.5286922
              ],
              [
                51.3019128,
                35.5152797
              ],
              [
                51.3025652,
                35.5151032
              ],
              [
                51.3135858,
                35.5224385
              ],
              [
                51.318488,
                35.5248079
              ],
              [
                51.324967,
                35.5272584
              ],
              [
                51.3398758,
                35.533042
              ],
              [
                51.3458753,
                35.5361012
              ],
              [
                51.3491871,
                35.5386386
              ],
              [
                51.3498407,
                35.5391394
              ],
              [
                51.3553768,
                35.5435813
              ],
              [
                51.358132,
                35.5465144
              ],
              [
                51.3615309,
                35.550893
              ],
              [
                51.3649044,
                35.5561363
              ],
              [
                51.3676595,
                35.555047
              ],
              [
                51.3701315,
                35.5532873
              ],
              [
                51.3765945,
                35.5484689
              ],
              [
                51.3824396,
                35.5430845
              ],
              [
                51.3865199,
                35.5380602
              ],
              [
                51.3874908,
                35.5396571
              ],
              [
                51.3897643,
                35.5441363
              ],
              [
                51.390408,
                35.5449115
              ],
              [
                51.3914122,
                35.5460638
              ],
              [
                51.3923392,
                35.5473209
              ],
              [
                51.3967445,
                35.5547053
              ],
              [
                51.3981328,
                35.5572508
              ],
              [
                51.3983349,
                35.5577418
              ],
              [
                51.3976041,
                35.5590466
              ],
              [
                51.3976122,
                35.5604271
              ],
              [
                51.3979525,
                35.5612517
              ],
              [
                51.3984933,
                35.5624457
              ],
              [
                51.3975663,
                35.5636815
              ],
              [
                51.3957381,
                35.5662997
              ],
              [
                51.3948111,
                35.5683105
              ],
              [
                51.3949399,
                35.5694206
              ],
              [
                51.3943476,
                35.5697347
              ],
              [
                51.3944249,
                35.570007
              ],
              [
                51.3922203,
                35.5700739
              ],
              [
                51.3921946,
                35.5717285
              ],
              [
                51.3916796,
                35.5766502
              ],
              [
                51.390951,
                35.5841254
              ],
              [
                51.3908558,
                35.5850196
              ],
              [
                51.3905081,
                35.5883893
              ],
              [
                51.3903692,
                35.5901004
              ],
              [
                51.3900317,
                35.5917067
              ],
              [
                51.3902683,
                35.596986
              ],
              [
                51.3902227,
                35.598523
              ],
              [
                51.3902318,
                35.5992744
              ],
              [
                51.3904054,
                35.610135
              ],
              [
                51.3904081,
                35.6136005
              ],
              [
                51.4002501,
                35.6141058
              ],
              [
                51.4032567,
                35.6144292
              ],
              [
                51.4082734,
                35.6144584
              ],
              [
                51.4118783,
                35.614877
              ],
              [
                51.4144729,
                35.6152331
              ],
              [
                51.4167142,
                35.6158778
              ],
              [
                51.4185624,
                35.6167304
              ],
              [
                51.4203997,
                35.617764
              ],
              [
                51.4210251,
                35.6182618
              ],
              [
                51.4245035,
                35.6210301
              ],
              [
                51.4259491,
                35.622201
              ],
              [
                51.4281137,
                35.6236095
              ],
              [
                51.4299188,
                35.6246777
              ],
              [
                51.432888,
                35.6261386
              ],
              [
                51.4349507,
                35.6269779
              ],
              [
                51.4363541,
                35.6274749
              ],
              [
                51.4398678,
                35.6284778
              ],
              [
                51.4423461,
                35.6289618
              ],
              [
                51.4443041,
                35.6292932
              ],
              [
                51.4462465,
                35.6294438
              ],
              [
                51.447957,
                35.6295124
              ],
              [
                51.4502891,
                35.6295415
              ],
              [
                51.4524662,
                35.6295107
              ],
              [
                51.4527825,
                35.6289613
              ],
              [
                51.4531065,
                35.6286098
              ],
              [
                51.4537723,
                35.6283273
              ],
              [
                51.4544701,
                35.6280392
              ],
              [
                51.4553253,
                35.627703
              ],
              [
                51.4563255,
                35.6272794
              ],
              [
                51.457329,
                35.6268689
              ],
              [
                51.4602717,
                35.6251127
              ],
              [
                51.4712177,
                35.6173572
              ],
              [
                51.4715273,
                35.6179472
              ],
              [
                51.4721709,
                35.6179709
              ],
              [
                51.4723006,
                35.6178946
              ],
              [
                51.4728655,
                35.6179938
              ],
              [
                51.4777203,
                35.6125442
              ],
              [
                51.4800416,
                35.6139826
              ],
              [
                51.480217,
                35.6139649
              ],
              [
                51.4802611,
                35.6139427
              ],
              [
                51.480648,
                35.6137424
              ],
              [
                51.4807736,
                35.6136848
              ],
              [
                51.4838155,
                35.6124535
              ],
              [
                51.4858752,
                35.6114429
              ],
              [
                51.4872025,
                35.6107823
              ],
              [
                51.4893248,
                35.6097897
              ],
              [
                51.4903261,
                35.6092745
              ],
              [
                51.4929794,
                35.6079794
              ],
              [
                51.4939157,
                35.6086254
              ],
              [
                51.4954732,
                35.6075155
              ],
              [
                51.4984125,
                35.6057444
              ],
              [
                51.5005204,
                35.606345
              ],
              [
                51.502225,
                35.6075565
              ],
              [
                51.5028428,
                35.6086617
              ],
              [
                51.5000972,
                35.6111117
              ],
              [
                51.49886,
                35.6121789
              ],
              [
                51.4987465,
                35.6125334
              ],
              [
                51.4996168,
                35.612931
              ],
              [
                51.4984954,
                35.6140213
              ],
              [
                51.4992214,
                35.6144668
              ],
              [
                51.5003813,
                35.614934
              ],
              [
                51.5013509,
                35.6157401
              ],
              [
                51.5026671,
                35.6145065
              ],
              [
                51.5035607,
                35.6131553
              ],
              [
                51.5043676,
                35.6142601
              ],
              [
                51.5045839,
                35.6153834
              ],
              [
                51.5042725,
                35.6164074
              ],
              [
                51.504024,
                35.6169178
              ],
              [
                51.5037755,
                35.6175797
              ],
              [
                51.5032302,
                35.6196689
              ],
              [
                51.504185,
                35.6221757
              ],
              [
                51.5050408,
                35.6237615
              ],
              [
                51.5142059,
                35.6230471
              ],
              [
                51.51824,
                35.6263523
              ],
              [
                51.5302563,
                35.6271895
              ],
              [
                51.5302455,
                35.6297882
              ],
              [
                51.5220916,
                35.630294
              ],
              [
                51.530995,
                35.6321957
              ],
              [
                51.5385138,
                35.6306051
              ],
              [
                51.5404471,
                35.6298006
              ],
              [
                51.5417324,
                35.6292657
              ],
              [
                51.5532681,
                35.6238867
              ],
              [
                51.5667864,
                35.6214378
              ],
              [
                51.580691,
                35.6196587
              ],
              [
                51.5911709,
                35.616791
              ],
              [
                51.5998741,
                35.6142581
              ],
              [
                51.6090222,
                35.6118315
              ],
              [
                51.6109463,
                35.6112453
              ],
              [
                51.6118313,
                35.6110852
              ],
              [
                51.6177421,
                35.6103874
              ],
              [
                51.6182953,
                35.6101079
              ],
              [
                51.6272449,
                35.6095108
              ],
              [
                51.6354486,
                35.6098201
              ],
              [
                51.6359138,
                35.6187911
              ],
              [
                51.6338538,
                35.6281401
              ],
              [
                51.6350555,
                35.6362324
              ],
              [
                51.6393219,
                35.6424559
              ],
              [
                51.6423787,
                35.6441228
              ],
              [
                51.6468219,
                35.6441228
              ],
              [
                51.6473786,
                35.6438435
              ],
              [
                51.6487651,
                35.6438435
              ],
              [
                51.6490452,
                35.6435642
              ],
              [
                51.6504318,
                35.6435642
              ],
              [
                51.6607041,
                35.6452466
              ],
              [
                51.6612575,
                35.6449674
              ],
              [
                51.6620907,
                35.6449673
              ],
              [
                51.663204,
                35.6444087
              ],
              [
                51.6645906,
                35.6441294
              ],
              [
                51.665704,
                35.6441294
              ],
              [
                51.6723764,
                35.6433086
              ],
              [
                51.6737632,
                35.6430293
              ],
              [
                51.6823764,
                35.6394165
              ],
              [
                51.6907862,
                35.6382766
              ],
              [
                51.6999419,
                35.6353072
              ],
              [
                51.7072557,
                35.6323661
              ],
              [
                51.7110878,
                35.6302273
              ],
              [
                51.7118023,
                35.639969
              ],
              [
                51.7125161,
                35.6474737
              ],
              [
                51.7132764,
                35.6542447
              ],
              [
                51.7150397,
                35.6710745
              ],
              [
                51.7065673,
                35.6793571
              ],
              [
                51.7040221,
                35.6844451
              ],
              [
                51.7016349,
                35.6889348
              ],
              [
                51.694498,
                35.6987236
              ],
              [
                51.6903305,
                35.7045653
              ],
              [
                51.6878309,
                35.7102955
              ],
              [
                51.6964249,
                35.7249569
              ],
              [
                51.6953402,
                35.7298431
              ],
              [
                51.6942572,
                35.7324047
              ],
              [
                51.6930424,
                35.7354642
              ],
              [
                51.6930342,
                35.737212
              ],
              [
                51.6936026,
                35.7415155
              ],
              [
                51.6905021,
                35.7411482
              ],
              [
                51.6846871,
                35.7405387
              ],
              [
                51.683674,
                35.743465
              ],
              [
                51.6888713,
                35.7449449
              ],
              [
                51.6909098,
                35.7494032
              ],
              [
                51.6916608,
                35.7556374
              ],
              [
                51.6928624,
                35.7569608
              ],
              [
                51.6918753,
                35.7646569
              ],
              [
                51.6901617,
                35.7667041
              ],
              [
                51.6922966,
                35.7680542
              ],
              [
                51.6933185,
                35.7684829
              ],
              [
                51.6948876,
                35.7687006
              ],
              [
                51.6952282,
                35.7688921
              ],
              [
                51.6961294,
                35.7692272
              ],
              [
                51.6968429,
                35.7693796
              ],
              [
                51.6979694,
                35.7703937
              ],
              [
                51.6981518,
                35.7712424
              ],
              [
                51.6976422,
                35.7718953
              ],
              [
                51.6970521,
                35.7723567
              ],
              [
                51.696977,
                35.7723697
              ],
              [
                51.6965613,
                35.7730313
              ],
              [
                51.6971272,
                35.7733664
              ],
              [
                51.6976556,
                35.7731727
              ],
              [
                51.6978782,
                35.7732489
              ],
              [
                51.6983315,
                35.77346
              ],
              [
                51.6989189,
                35.7735731
              ],
              [
                51.699222,
                35.7736972
              ],
              [
                51.699246,
                35.773939
              ],
              [
                51.6993103,
                35.7750682
              ],
              [
                51.6988921,
                35.7751639
              ],
              [
                51.6976797,
                35.777192
              ],
              [
                51.6970682,
                35.7790721
              ],
              [
                51.6968751,
                35.7811263
              ],
              [
                51.6965101,
                35.7828845
              ],
              [
                51.6932701,
                35.7855478
              ],
              [
                51.6906521,
                35.7855478
              ],
              [
                51.6888928,
                35.7849036
              ],
              [
                51.6881847,
                35.7843292
              ],
              [
                51.6876483,
                35.7832674
              ],
              [
                51.6871118,
                35.7829715
              ],
              [
                51.6865325,
                35.7812307
              ],
              [
                51.6877983,
                35.7800645
              ],
              [
                51.6880773,
                35.7790375
              ],
              [
                51.687691,
                35.7770703
              ],
              [
                51.6867685,
                35.7766001
              ],
              [
                51.6846442,
                35.7764783
              ],
              [
                51.6843866,
                35.7773488
              ],
              [
                51.6837644,
                35.7783758
              ],
              [
                51.6820264,
                35.7780973
              ],
              [
                51.6812968,
                35.7784106
              ],
              [
                51.6794727,
                35.7828498
              ],
              [
                51.6782282,
                35.7856349
              ],
              [
                51.6776007,
                35.7863179
              ],
              [
                51.6777992,
                35.7869924
              ],
              [
                51.6769409,
                35.7875494
              ],
              [
                51.6765547,
                35.7883849
              ],
              [
                51.6755461,
                35.7891856
              ],
              [
                51.6681217,
                35.7897253
              ],
              [
                51.6659544,
                35.7910829
              ],
              [
                51.659045,
                35.7884024
              ],
              [
                51.6549681,
                35.7850256
              ],
              [
                51.6504191,
                35.780604
              ],
              [
                51.6461705,
                35.7787241
              ],
              [
                51.6345404,
                35.7844686
              ],
              [
                51.6222806,
                35.790284
              ],
              [
                51.6154001,
                35.7919184
              ],
              [
                51.6081047,
                35.7917094
              ],
              [
                51.6008947,
                35.7890987
              ],
              [
                51.5938136,
                35.7815094
              ],
              [
                51.5892218,
                35.7784804
              ],
              [
                51.5811497,
                35.7753036
              ],
              [
                51.5762823,
                35.7748038
              ],
              [
                51.5721877,
                35.7736796
              ],
              [
                51.5696524,
                35.7796293
              ],
              [
                51.5673351,
                35.7841203
              ],
              [
                51.5657682,
                35.7855899
              ],
              [
                51.5641491,
                35.7819999
              ],
              [
                51.5630005,
                35.780639
              ],
              [
                51.5600394,
                35.7752424
              ],
              [
                51.5572543,
                35.7701237
              ],
              [
                51.5562193,
                35.7704852
              ],
              [
                51.5541673,
                35.7712032
              ],
              [
                51.5510466,
                35.7723006
              ],
              [
                51.5476847,
                35.7734719
              ],
              [
                51.5442078,
                35.7746896
              ],
              [
                51.5440098,
                35.774759
              ],
              [
                51.5423923,
                35.7753249
              ],
              [
                51.5420491,
                35.7754283
              ],
              [
                51.5402378,
                35.7759741
              ],
              [
                51.5375469,
                35.7765465
              ],
              [
                51.5348971,
                35.7769599
              ],
              [
                51.533931,
                35.7771111
              ],
              [
                51.5272703,
                35.7773022
              ],
              [
                51.5265064,
                35.7773496
              ],
              [
                51.5226612,
                35.7775977
              ],
              [
                51.5217224,
                35.7775934
              ],
              [
                51.5205047,
                35.7780678
              ],
              [
                51.5193996,
                35.7785204
              ],
              [
                51.5189437,
                35.7787815
              ],
              [
                51.5161917,
                35.780766
              ],
              [
                51.5148881,
                35.7816755
              ],
              [
                51.5134827,
                35.7824284
              ],
              [
                51.5095828,
                35.7836643
              ],
              [
                51.5028128,
                35.7855181
              ],
              [
                51.5002486,
                35.7861578
              ],
              [
                51.4991329,
                35.7862797
              ],
              [
                51.4966921,
                35.7860708
              ],
              [
                51.4950184,
                35.7858359
              ],
              [
                51.4937407,
                35.7856652
              ],
              [
                51.4926463,
                35.7855955
              ],
              [
                51.4917461,
                35.7856792
              ],
              [
                51.4906155,
                35.7859349
              ],
              [
                51.487472,
                35.7872523
              ],
              [
                51.4847481,
                35.7883969
              ],
              [
                51.4844386,
                35.7885291
              ],
              [
                51.4837638,
                35.7888472
              ],
              [
                51.4806069,
                35.7902026
              ],
              [
                51.4794749,
                35.7904484
              ],
              [
                51.478909,
                35.790468
              ],
              [
                51.4767304,
                35.7902548
              ],
              [
                51.4764252,
                35.7902115
              ],
              [
                51.4756153,
                35.7901797
              ],
              [
                51.4741018,
                35.7902847
              ],
              [
                51.4733908,
                35.7904073
              ],
              [
                51.4725763,
                35.7906171
              ],
              [
                51.469823,
                35.791445
              ],
              [
                51.4662155,
                35.7920595
              ],
              [
                51.4653884,
                35.7922838
              ],
              [
                51.4630022,
                35.7930016
              ],
              [
                51.4618371,
                35.7931791
              ],
              [
                51.460796,
                35.7932007
              ],
              [
                51.4594124,
                35.7929648
              ],
              [
                51.4584894,
                35.7926024
              ],
              [
                51.4574759,
                35.792088
              ],
              [
                51.4560538,
                35.7911965
              ],
              [
                51.4541464,
                35.7900212
              ],
              [
                51.451681,
                35.7886351
              ],
              [
                51.4493484,
                35.7875613
              ],
              [
                51.4481874,
                35.787099
              ],
              [
                51.4459407,
                35.7863069
              ],
              [
                51.4428815,
                35.7854692
              ],
              [
                51.4405507,
                35.7849862
              ],
              [
                51.4390045,
                35.784686
              ],
              [
                51.43735,
                35.784333
              ],
              [
                51.4369016,
                35.7842246
              ],
              [
                51.4364175,
                35.7840506
              ],
              [
                51.4360861,
                35.7838755
              ],
              [
                51.4350737,
                35.783203
              ],
              [
                51.4344863,
                35.7826395
              ],
              [
                51.4336038,
                35.7816386
              ],
              [
                51.4329462,
                35.7809758
              ],
              [
                51.4325032,
                35.7805757
              ],
              [
                51.4316432,
                35.7799883
              ],
              [
                51.4310065,
                35.7796858
              ],
              [
                51.4303663,
                35.7794561
              ],
              [
                51.428414,
                35.7788078
              ],
              [
                51.4278159,
                35.7785087
              ],
              [
                51.4272282,
                35.779641
              ],
              [
                51.426209,
                35.7810533
              ],
              [
                51.4247284,
                35.7827179
              ],
              [
                51.4230161,
                35.7844137
              ],
              [
                51.4222366,
                35.7852397
              ],
              [
                51.421727,
                35.7860643
              ],
              [
                51.4208231,
                35.7880443
              ],
              [
                51.4200882,
                35.7889755
              ],
              [
                51.4191225,
                35.7897914
              ],
              [
                51.418393,
                35.7901874
              ],
              [
                51.4177171,
                35.7904811
              ],
              [
                51.4169232,
                35.7907531
              ],
              [
                51.4162755,
                35.7909102
              ],
              [
                51.4162543,
                35.7909153
              ],
              [
                51.4128515,
                35.7915538
              ],
              [
                51.4104992,
                35.7919475
              ],
              [
                51.4082542,
                35.7918932
              ],
              [
                51.407286,
                35.7918822
              ],
              [
                51.4068058,
                35.7919388
              ],
              [
                51.4060334,
                35.7922195
              ],
              [
                51.4055804,
                35.7925124
              ],
              [
                51.4042604,
                35.793366
              ],
              [
                51.4037187,
                35.7936337
              ],
              [
                51.4030374,
                35.7937903
              ],
              [
                51.4023775,
                35.7938099
              ],
              [
                51.4016104,
                35.7936315
              ],
              [
                51.4004704,
                35.7931115
              ],
              [
                51.3997688,
                35.7928107
              ],
              [
                51.3993042,
                35.7926066
              ],
              [
                51.3989738,
                35.7924675
              ],
              [
                51.3968763,
                35.7918496
              ],
              [
                51.3948191,
                35.7912687
              ],
              [
                51.3942692,
                35.791099
              ],
              [
                51.3936738,
                35.7908662
              ],
              [
                51.3932164,
                35.7906204
              ],
              [
                51.3925566,
                35.7901135
              ],
              [
                51.3922542,
                35.7897669
              ],
              [
                51.3920061,
                35.7904261
              ],
              [
                51.3915596,
                35.7911071
              ],
              [
                51.3910835,
                35.791588
              ],
              [
                51.3906235,
                35.7919383
              ],
              [
                51.3899105,
                35.7923524
              ],
              [
                51.3893846,
                35.7925525
              ],
              [
                51.3888841,
                35.7926976
              ],
              [
                51.3883449,
                35.7927889
              ],
              [
                51.387787,
                35.7928651
              ],
              [
                51.3874719,
                35.7928847
              ],
              [
                51.3870562,
                35.7928903
              ],
              [
                51.3863261,
                35.7928332
              ],
              [
                51.3856946,
                35.7927564
              ],
              [
                51.3851115,
                35.7926388
              ],
              [
                51.3846096,
                35.7924927
              ],
              [
                51.3820884,
                35.7916942
              ],
              [
                51.3806561,
                35.7913504
              ],
              [
                51.3779551,
                35.7909392
              ],
              [
                51.3770083,
                35.7907695
              ],
              [
                51.3761473,
                35.7904889
              ],
              [
                51.3751924,
                35.790008
              ],
              [
                51.3725156,
                35.7887091
              ],
              [
                51.3709679,
                35.7881304
              ],
              [
                51.3698012,
                35.787817
              ],
              [
                51.3683474,
                35.787371
              ],
              [
                51.3666844,
                35.7866269
              ],
              [
                51.3645843,
                35.7854215
              ],
              [
                51.364021,
                35.7851473
              ],
              [
                51.3626021,
                35.7846425
              ],
              [
                51.3610689,
                35.7842631
              ],
              [
                51.3602525,
                35.7841377
              ],
              [
                51.3589328,
                35.783968
              ],
              [
                51.3576937,
                35.7838853
              ],
              [
                51.3567012,
                35.7838984
              ],
              [
                51.3545501,
                35.7840463
              ],
              [
                51.3533056,
                35.7842509
              ],
              [
                51.3505644,
                35.7846251
              ],
              [
                51.3490945,
                35.7847687
              ],
              [
                51.34844,
                35.7847861
              ],
              [
                51.3477641,
                35.7847209
              ],
              [
                51.347056,
                35.7845903
              ],
              [
                51.3463855,
                35.7843901
              ],
              [
                51.3458008,
                35.7841203
              ],
              [
                51.345098,
                35.7836634
              ],
              [
                51.3445187,
                35.7831716
              ],
              [
                51.3437784,
                35.7822969
              ],
              [
                51.3434458,
                35.7816702
              ],
              [
                51.343317,
                35.7811828
              ],
              [
                51.3432044,
                35.7804299
              ],
              [
                51.3422522,
                35.7806018
              ],
              [
                51.3419169,
                35.7807433
              ],
              [
                51.3416085,
                35.7809391
              ],
              [
                51.3414207,
                35.7811741
              ],
              [
                51.3411679,
                35.7819923
              ],
              [
                51.3408418,
                35.7813911
              ],
              [
                51.3404325,
                35.780417
              ],
              [
                51.3402096,
                35.7801142
              ],
              [
                51.3390256,
                35.7796324
              ],
              [
                51.338562,
                35.7794455
              ],
              [
                51.3382698,
                35.7793517
              ],
              [
                51.3380805,
                35.7791913
              ],
              [
                51.3377665,
                35.7790688
              ],
              [
                51.3374012,
                35.7790008
              ],
              [
                51.3369625,
                35.7789354
              ],
              [
                51.3365717,
                35.7787604
              ],
              [
                51.3361234,
                35.7785036
              ],
              [
                51.3358869,
                35.7783696
              ],
              [
                51.335776,
                35.7789421
              ],
              [
                51.3333369,
                35.7861787
              ],
              [
                51.3328175,
                35.7877126
              ],
              [
                51.330981,
                35.792723
              ],
              [
                51.3313518,
                35.7927613
              ],
              [
                51.331444,
                35.7925933
              ],
              [
                51.3316725,
                35.7924974
              ],
              [
                51.3318478,
                35.7922171
              ],
              [
                51.3322938,
                35.7920999
              ],
              [
                51.3326829,
                35.7918993
              ],
              [
                51.3331385,
                35.7920733
              ],
              [
                51.3332624,
                35.7922079
              ],
              [
                51.3334739,
                35.7923166
              ],
              [
                51.3340194,
                35.7924398
              ],
              [
                51.3340554,
                35.7928896
              ],
              [
                51.334094,
                35.7929584
              ],
              [
                51.3343531,
                35.7930652
              ],
              [
                51.334423,
                35.7934471
              ],
              [
                51.3345463,
                35.79352
              ],
              [
                51.3352211,
                35.7937391
              ],
              [
                51.3357093,
                35.7935051
              ],
              [
                51.3358633,
                35.7935404
              ],
              [
                51.3360084,
                35.7942
              ],
              [
                51.3360087,
                35.7944346
              ],
              [
                51.3361271,
                35.7947658
              ],
              [
                51.335919,
                35.7956627
              ],
              [
                51.3359827,
                35.7958889
              ],
              [
                51.3361829,
                35.7960428
              ],
              [
                51.3362804,
                35.7961887
              ],
              [
                51.3363018,
                35.7964548
              ],
              [
                51.3365972,
                35.7969291
              ],
              [
                51.3367653,
                35.7974635
              ],
              [
                51.3371385,
                35.7980793
              ],
              [
                51.3367844,
                35.7981718
              ],
              [
                51.3360285,
                35.7982237
              ],
              [
                51.3357239,
                35.7980719
              ],
              [
                51.3354787,
                35.7980602
              ],
              [
                51.3356216,
                35.7981929
              ],
              [
                51.3356239,
                35.7985683
              ],
              [
                51.3356916,
                35.7985973
              ],
              [
                51.3360001,
                35.7991279
              ],
              [
                51.3362226,
                35.7992913
              ],
              [
                51.3365022,
                35.7996537
              ],
              [
                51.3365152,
                35.7998884
              ],
              [
                51.3366643,
                35.8001616
              ],
              [
                51.3366649,
                35.8002751
              ],
              [
                51.3372759,
                35.8006218
              ],
              [
                51.3373612,
                35.8007144
              ],
              [
                51.3376848,
                35.801721
              ],
              [
                51.3382975,
                35.8022525
              ],
              [
                51.3384066,
                35.8024308
              ],
              [
                51.3384029,
                35.8025441
              ],
              [
                51.3382434,
                35.8026885
              ],
              [
                51.3378683,
                35.8028808
              ],
              [
                51.3375022,
                35.8029947
              ],
              [
                51.3372597,
                35.803468
              ],
              [
                51.3371256,
                35.803864
              ],
              [
                51.3372174,
                35.8042397
              ],
              [
                51.3372458,
                35.8042831
              ],
              [
                51.3374263,
                35.8045587
              ],
              [
                51.3375218,
                35.8047045
              ],
              [
                51.3377469,
                35.804895
              ],
              [
                51.3379372,
                35.8049108
              ],
              [
                51.3378655,
                35.8068544
              ],
              [
                51.3376686,
                35.807232
              ],
              [
                51.337657,
                35.8076056
              ],
              [
                51.3375911,
                35.8076776
              ],
              [
                51.3374722,
                35.8076995
              ],
              [
                51.3372723,
                35.8080055
              ],
              [
                51.3371841,
                35.8082684
              ],
              [
                51.3371967,
                35.8084962
              ],
              [
                51.3373959,
                35.8087425
              ],
              [
                51.3377946,
                35.8089719
              ],
              [
                51.3379518,
                35.809996
              ],
              [
                51.3382757,
                35.8100343
              ],
              [
                51.3385339,
                35.8092092
              ],
              [
                51.3385325,
                35.8089244
              ],
              [
                51.3388522,
                35.8087154
              ],
              [
                51.3389761,
                35.8085424
              ],
              [
                51.3395338,
                35.8081713
              ],
              [
                51.3395898,
                35.808116
              ],
              [
                51.3396662,
                35.8083484
              ],
              [
                51.339714,
                35.8084326
              ],
              [
                51.3397198,
                35.8084458
              ],
              [
                51.3491549,
                35.813096
              ],
              [
                51.3523292,
                35.8212234
              ],
              [
                51.3527154,
                35.8232417
              ],
              [
                51.3516426,
                35.8239724
              ],
              [
                51.3510847,
                35.8251207
              ],
              [
                51.3552149,
                35.8324304
              ],
              [
                51.3552212,
                35.8324419
              ],
              [
                51.3578918,
                35.841458
              ],
              [
                51.3584451,
                35.8428461
              ],
              [
                51.3604782,
                35.8545108
              ],
              [
                51.3611619,
                35.8601886
              ],
              [
                51.362074,
                35.8680054
              ],
              [
                51.3660535,
                35.881783
              ],
              [
                51.3660263,
                35.8923483
              ],
              [
                51.3660877,
                35.8924053
              ],
              [
                51.3663045,
                35.8926172
              ],
              [
                51.3718985,
                35.9146353
              ],
              [
                51.3770218,
                35.9211929
              ],
              [
                51.3667596,
                35.9212172
              ],
              [
                51.3529149,
                35.9220974
              ],
              [
                51.3423232,
                35.9269476
              ],
              [
                51.3359596,
                35.9303989
              ],
              [
                51.3231104,
                35.9373673
              ],
              [
                51.2781918,
                35.9626491
              ],
              [
                51.2688181,
                35.9673484
              ],
              [
                51.2525322,
                35.9694481
              ],
              [
                51.2096837,
                35.9847159
              ],
              [
                51.2096296,
                35.9847279
              ],
              [
                51.1781926,
                35.9926449
              ],
              [
                51.1542253,
                35.998958
              ],
              [
                51.1520964,
                35.9983533
              ],
              [
                51.1535452,
                35.9821737
              ],
              [
                51.1647525,
                35.9633304
              ],
              [
                51.1786078,
                35.9357647
              ],
              [
                51.1820654,
                35.9296816
              ],
              [
                51.1820081,
                35.9296333
              ],
              [
                51.182008,
                35.9296332
              ],
              [
                51.1826618,
                35.9265048
              ],
              [
                51.1826037,
                35.9264506
              ],
              [
                51.1828911,
                35.9231683
              ],
              [
                51.1802406,
                35.918515
              ],
              [
                51.1429022,
                35.8794537
              ],
              [
                51.1274527,
                35.8642915
              ],
              [
                51.1247061,
                35.8494221
              ],
              [
                51.1224424,
                35.8472999
              ],
              [
                51.1189556,
                35.8470736
              ],
              [
                51.1165998,
                35.8459713
              ],
              [
                51.1121943,
                35.8439591
              ],
              [
                51.1079443,
                35.8425779
              ],
              [
                51.1099432,
                35.8281132
              ],
              [
                51.1107225,
                35.8217835
              ],
              [
                51.1127952,
                35.8172794
              ],
              [
                51.1147097,
                35.81241
              ],
              [
                51.1167779,
                35.8005118
              ],
              [
                51.1187901,
                35.7915401
              ],
              [
                51.1185605,
                35.7838232
              ],
              [
                51.1149537,
                35.7781703
              ],
              [
                51.1124564,
                35.7724766
              ],
              [
                51.1098306,
                35.7684567
              ],
              [
                51.1057053,
                35.7671917
              ],
              [
                51.1015078,
                35.7659094
              ],
              [
                51.0988756,
                35.7647237
              ],
              [
                51.0956954,
                35.7621845
              ],
              [
                51.095373,
                35.7605029
              ],
              [
                51.0941942,
                35.7577691
              ],
              [
                51.0941876,
                35.7577586
              ],
              [
                51.0941943,
                35.7577126
              ],
              [
                51.094197,
                35.7576935
              ],
              [
                51.0941966,
                35.7576132
              ],
              [
                51.0941883,
                35.7575946
              ],
              [
                51.0941734,
                35.7575792
              ],
              [
                51.0941235,
                35.7575703
              ],
              [
                51.0941116,
                35.7575654
              ],
              [
                51.0941073,
                35.7575551
              ],
              [
                51.0941102,
                35.7575368
              ],
              [
                51.0941068,
                35.7574954
              ],
              [
                51.0940979,
                35.7574547
              ],
              [
                51.0940866,
                35.7574188
              ],
              [
                51.0936705,
                35.7565435
              ],
              [
                51.093584,
                35.7562732
              ],
              [
                51.0934702,
                35.7559179
              ],
              [
                51.0921226,
                35.7489801
              ],
              [
                51.0920783,
                35.7488362
              ],
              [
                51.0920291,
                35.7487229
              ],
              [
                51.0901497,
                35.7456386
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555022,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دماوند",
          "name:en": "Damavand County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282194",
          "wikipedia": "fa:شهرستان دماوند"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8132268,
                35.5748769
              ],
              [
                51.8147528,
                35.5748833
              ],
              [
                51.8175745,
                35.575084
              ],
              [
                51.8238658,
                35.5749818
              ],
              [
                51.8296559,
                35.5748593
              ],
              [
                51.8382485,
                35.5745453
              ],
              [
                51.8457863,
                35.5738557
              ],
              [
                51.85256,
                35.5730175
              ],
              [
                51.8442714,
                35.5707487
              ],
              [
                51.8462147,
                35.5701897
              ],
              [
                51.8476047,
                35.5699194
              ],
              [
                51.8670261,
                35.5669492
              ],
              [
                51.8686928,
                35.5666698
              ],
              [
                51.8709162,
                35.5658404
              ],
              [
                51.8734931,
                35.5637914
              ],
              [
                51.8742656,
                35.5581357
              ],
              [
                51.8862819,
                35.5458455
              ],
              [
                51.8891143,
                35.5440297
              ],
              [
                51.8916034,
                35.5390013
              ],
              [
                51.8929612,
                35.5345318
              ],
              [
                51.8936562,
                35.5341171
              ],
              [
                51.9036197,
                35.5142035
              ],
              [
                51.9165801,
                35.4958272
              ],
              [
                51.9286453,
                35.4883852
              ],
              [
                51.929202,
                35.4880967
              ],
              [
                51.929202,
                35.4883853
              ],
              [
                51.9289218,
                35.4889353
              ],
              [
                51.9286453,
                35.490324
              ],
              [
                51.9215677,
                35.5035829
              ],
              [
                51.9212911,
                35.5055305
              ],
              [
                51.921011,
                35.5080282
              ],
              [
                51.9212911,
                35.5085782
              ],
              [
                51.921011,
                35.5099668
              ],
              [
                51.9229577,
                35.5355292
              ],
              [
                51.9229577,
                35.5374767
              ],
              [
                51.923511,
                35.5458079
              ],
              [
                51.9243442,
                35.548585
              ],
              [
                51.9296242,
                35.5585843
              ],
              [
                51.9357341,
                35.5616408
              ],
              [
                51.9365676,
                35.5616408
              ],
              [
                51.9579572,
                35.5780235
              ],
              [
                51.9604572,
                35.5785825
              ],
              [
                51.9629571,
                35.5785825
              ],
              [
                51.9657371,
                35.5785825
              ],
              [
                51.9662904,
                35.578312
              ],
              [
                51.9693471,
                35.578312
              ],
              [
                51.9696237,
                35.5785825
              ],
              [
                51.9704571,
                35.5785825
              ],
              [
                51.972957,
                35.5785825
              ],
              [
                51.979347,
                35.577194
              ],
              [
                51.9804602,
                35.577194
              ],
              [
                51.9857369,
                35.575526
              ],
              [
                51.9935134,
                35.5685834
              ],
              [
                52.0096267,
                35.5488646
              ],
              [
                52.0117525,
                35.5392061
              ],
              [
                52.0096592,
                35.5282986
              ],
              [
                52.0056003,
                35.5183514
              ],
              [
                52.0056003,
                35.5169627
              ],
              [
                52.003967,
                35.5060285
              ],
              [
                52.017115,
                35.4868295
              ],
              [
                52.027115,
                35.4787669
              ],
              [
                52.0296149,
                35.4776577
              ],
              [
                52.0500402,
                35.4589783
              ],
              [
                52.0511501,
                35.4589783
              ],
              [
                52.0689299,
                35.4537018
              ],
              [
                52.0764298,
                35.4509236
              ],
              [
                52.1177488,
                35.4555851
              ],
              [
                52.1264953,
                35.4585216
              ],
              [
                52.1299753,
                35.4611969
              ],
              [
                52.1496353,
                35.4602472
              ],
              [
                52.169601,
                35.4561513
              ],
              [
                52.1968579,
                35.4505266
              ],
              [
                52.2021344,
                35.4499675
              ],
              [
                52.2029677,
                35.449697
              ],
              [
                52.2060245,
                35.449697
              ],
              [
                52.2121377,
                35.4488584
              ],
              [
                52.2143577,
                35.4488584
              ],
              [
                52.2374141,
                35.445531
              ],
              [
                52.2515839,
                35.4421946
              ],
              [
                52.2521372,
                35.4421946
              ],
              [
                52.254084,
                35.4416356
              ],
              [
                52.2568606,
                35.4405265
              ],
              [
                52.2576937,
                35.4405264
              ],
              [
                52.27692,
                35.4282479
              ],
              [
                52.2807503,
                35.4258009
              ],
              [
                52.2810271,
                35.4255273
              ],
              [
                52.324363,
                35.3860782
              ],
              [
                52.3326963,
                35.3755273
              ],
              [
                52.3331994,
                35.3749235
              ],
              [
                52.3365863,
                35.3777456
              ],
              [
                52.3421429,
                35.3833007
              ],
              [
                52.3443662,
                35.3858075
              ],
              [
                52.3565894,
                35.4041317
              ],
              [
                52.3574228,
                35.4049703
              ],
              [
                52.3601993,
                35.4096866
              ],
              [
                52.4150842,
                35.4601112
              ],
              [
                52.4282584,
                35.5130238
              ],
              [
                52.4427015,
                35.5349704
              ],
              [
                52.4529814,
                35.5552485
              ],
              [
                52.4621479,
                35.5719198
              ],
              [
                52.4732612,
                35.5846958
              ],
              [
                52.4805547,
                35.590169
              ],
              [
                52.4942577,
                35.6004511
              ],
              [
                52.4948108,
                35.6012897
              ],
              [
                52.4953677,
                35.6015603
              ],
              [
                52.5081672,
                35.6107581
              ],
              [
                52.5131672,
                35.6157627
              ],
              [
                52.517057,
                35.6204784
              ],
              [
                52.5448602,
                35.6589705
              ],
              [
                52.5571599,
                35.7017141
              ],
              [
                52.5596599,
                35.7053194
              ],
              [
                52.5643397,
                35.7125896
              ],
              [
                52.5564508,
                35.710995
              ],
              [
                52.5535383,
                35.7081388
              ],
              [
                52.5529817,
                35.7081388
              ],
              [
                52.5527051,
                35.7084182
              ],
              [
                52.5521483,
                35.7084183
              ],
              [
                52.5518717,
                35.7086888
              ],
              [
                52.5510384,
                35.7086887
              ],
              [
                52.5205958,
                35.7079938
              ],
              [
                52.5203192,
                35.7077143
              ],
              [
                52.5068417,
                35.7092974
              ],
              [
                52.4999275,
                35.713033
              ],
              [
                52.4963175,
                35.7141418
              ],
              [
                52.4815944,
                35.7188656
              ],
              [
                52.4796476,
                35.7191451
              ],
              [
                52.477981,
                35.7196951
              ],
              [
                52.476871,
                35.719695
              ],
              [
                52.4402014,
                35.7252573
              ],
              [
                52.3507525,
                35.7474788
              ],
              [
                52.332976,
                35.7524728
              ],
              [
                52.3307526,
                35.7527613
              ],
              [
                52.3288095,
                35.7533112
              ],
              [
                52.3276961,
                35.7533112
              ],
              [
                52.3135296,
                35.7552583
              ],
              [
                52.3101963,
                35.7560877
              ],
              [
                52.2963064,
                35.7577554
              ],
              [
                52.2753165,
                35.7603944
              ],
              [
                52.2502181,
                35.7624838
              ],
              [
                52.2274139,
                35.7674821
              ],
              [
                52.2260273,
                35.7669232
              ],
              [
                52.2201905,
                35.7658144
              ],
              [
                52.2182473,
                35.7658144
              ],
              [
                52.2179707,
                35.7655349
              ],
              [
                52.217414,
                35.765535
              ],
              [
                52.2171373,
                35.7658144
              ],
              [
                52.2165806,
                35.7655351
              ],
              [
                52.2154707,
                35.765535
              ],
              [
                52.2146375,
                35.7658144
              ],
              [
                52.2135239,
                35.765535
              ],
              [
                52.2113042,
                35.765535
              ],
              [
                52.2107473,
                35.7652555
              ],
              [
                52.2090807,
                35.7652555
              ],
              [
                52.2046374,
                35.7646966
              ],
              [
                52.2024141,
                35.7646966
              ],
              [
                52.201024,
                35.7644261
              ],
              [
                52.1990809,
                35.7644262
              ],
              [
                52.1979676,
                35.7641467
              ],
              [
                52.1954675,
                35.7641467
              ],
              [
                52.1946343,
                35.7638673
              ],
              [
                52.1918577,
                35.7638672
              ],
              [
                52.1907477,
                35.7635878
              ],
              [
                52.1840776,
                35.7633174
              ],
              [
                52.1771345,
                35.7633173
              ],
              [
                52.1751912,
                35.7630289
              ],
              [
                52.1585212,
                35.7630289
              ],
              [
                52.1560213,
                35.7633173
              ],
              [
                52.1551879,
                35.7630289
              ],
              [
                52.1374115,
                35.7621995
              ],
              [
                52.1293549,
                35.7621995
              ],
              [
                52.1226884,
                35.76192
              ],
              [
                52.1185218,
                35.7616496
              ],
              [
                52.1121319,
                35.7616496
              ],
              [
                52.1101886,
                35.7613611
              ],
              [
                52.0965753,
                35.7613611
              ],
              [
                52.0957422,
                35.7616496
              ],
              [
                52.0726856,
                35.7633173
              ],
              [
                52.0601859,
                35.7660937
              ],
              [
                52.0587959,
                35.7666436
              ],
              [
                52.0515726,
                35.7685908
              ],
              [
                52.0376827,
                35.7738642
              ],
              [
                52.0268495,
                35.7785878
              ],
              [
                52.0104597,
                35.7846996
              ],
              [
                52.0062932,
                35.7866467
              ],
              [
                51.9929599,
                35.7933082
              ],
              [
                51.9843466,
                35.7985906
              ],
              [
                51.9340671,
                35.828869
              ],
              [
                51.8821211,
                35.8571995
              ],
              [
                51.8782311,
                35.8599847
              ],
              [
                51.8776744,
                35.8605858
              ],
              [
                51.8776745,
                35.8599847
              ],
              [
                51.8776745,
                35.858876
              ],
              [
                51.873788,
                35.8466443
              ],
              [
                51.8718412,
                35.8427594
              ],
              [
                51.8701745,
                35.8377567
              ],
              [
                51.8679547,
                35.8324835
              ],
              [
                51.8551749,
                35.8030346
              ],
              [
                51.8529515,
                35.8002582
              ],
              [
                51.8471183,
                35.7891436
              ],
              [
                51.8443417,
                35.7858083
              ],
              [
                51.8416398,
                35.7823038
              ],
              [
                51.8460009,
                35.7793467
              ],
              [
                51.8541866,
                35.7743088
              ],
              [
                51.8620133,
                35.7669552
              ],
              [
                51.8736054,
                35.7587968
              ],
              [
                51.8869361,
                35.7607037
              ],
              [
                51.8892655,
                35.7584515
              ],
              [
                51.8915184,
                35.7550021
              ],
              [
                51.8965218,
                35.7525251
              ],
              [
                51.8989247,
                35.7508521
              ],
              [
                51.8961782,
                35.7466854
              ],
              [
                51.8922472,
                35.741223
              ],
              [
                51.8914232,
                35.7375654
              ],
              [
                51.8905993,
                35.7361442
              ],
              [
                51.8918352,
                35.7357889
              ],
              [
                51.890213,
                35.7326745
              ],
              [
                51.8898268,
                35.7321729
              ],
              [
                51.8892603,
                35.7322565
              ],
              [
                51.8882303,
                35.7312323
              ],
              [
                51.8869686,
                35.7296019
              ],
              [
                51.8868914,
                35.7282641
              ],
              [
                51.8902388,
                35.7277833
              ],
              [
                51.890316,
                35.7265918
              ],
              [
                51.8894663,
                35.7256094
              ],
              [
                51.8890286,
                35.7246269
              ],
              [
                51.8896093,
                35.7240055
              ],
              [
                51.8904075,
                35.7236083
              ],
              [
                51.8908453,
                35.7232529
              ],
              [
                51.8915148,
                35.7226676
              ],
              [
                51.8922357,
                35.7222077
              ],
              [
                51.893034,
                35.7218941
              ],
              [
                51.893363,
                35.7206987
              ],
              [
                51.8881296,
                35.7149782
              ],
              [
                51.8850374,
                35.7127544
              ],
              [
                51.8828916,
                35.7059244
              ],
              [
                51.887627,
                35.7053374
              ],
              [
                51.8894362,
                35.7053058
              ],
              [
                51.8904447,
                35.7048267
              ],
              [
                51.8911314,
                35.7047483
              ],
              [
                51.8910241,
                35.7036505
              ],
              [
                51.890552,
                35.7030581
              ],
              [
                51.8903859,
                35.7020719
              ],
              [
                51.8895113,
                35.7022653
              ],
              [
                51.8886959,
                35.7019865
              ],
              [
                51.8885243,
                35.7015465
              ],
              [
                51.8881488,
                35.7011152
              ],
              [
                51.8872475,
                35.7009628
              ],
              [
                51.886239,
                35.7011065
              ],
              [
                51.8852681,
                35.7013548
              ],
              [
                51.8848711,
                35.7013025
              ],
              [
                51.8848175,
                35.7009148
              ],
              [
                51.8850374,
                35.7004704
              ],
              [
                51.8849033,
                35.7002439
              ],
              [
                51.8850428,
                35.6998606
              ],
              [
                51.8853271,
                35.6994816
              ],
              [
                51.8851232,
                35.699377
              ],
              [
                51.8848389,
                35.6994598
              ],
              [
                51.8836695,
                35.6993857
              ],
              [
                51.8835729,
                35.6992289
              ],
              [
                51.8834871,
                35.698815
              ],
              [
                51.8831545,
                35.6986364
              ],
              [
                51.8837231,
                35.6977783
              ],
              [
                51.8830419,
                35.6977521
              ],
              [
                51.8831491,
                35.6972467
              ],
              [
                51.8829614,
                35.6970855
              ],
              [
                51.8828057,
                35.6968372
              ],
              [
                51.882838,
                35.6965322
              ],
              [
                51.8835246,
                35.6960094
              ],
              [
                51.8840825,
                35.6959223
              ],
              [
                51.8842005,
                35.6957482
              ],
              [
                51.8848228,
                35.6947286
              ],
              [
                51.8847477,
                35.6945021
              ],
              [
                51.8830097,
                35.6945195
              ],
              [
                51.8821192,
                35.6945021
              ],
              [
                51.8819904,
                35.6941535
              ],
              [
                51.8821192,
                35.6938486
              ],
              [
                51.8817544,
                35.6930818
              ],
              [
                51.8813145,
                35.6926635
              ],
              [
                51.8806171,
                35.6915569
              ],
              [
                51.8805313,
                35.6911648
              ],
              [
                51.8807351,
                35.6899797
              ],
              [
                51.8805635,
                35.6886552
              ],
              [
                51.8802094,
                35.6875311
              ],
              [
                51.8798983,
                35.6871041
              ],
              [
                51.8788468,
                35.6868689
              ],
              [
                51.8769907,
                35.6869909
              ],
              [
                51.8728494,
                35.6748686
              ],
              [
                51.8723344,
                35.6722539
              ],
              [
                51.8710041,
                35.6672335
              ],
              [
                51.869974,
                35.6656646
              ],
              [
                51.8695557,
                35.6644529
              ],
              [
                51.8687295,
                35.663067
              ],
              [
                51.8678712,
                35.6619164
              ],
              [
                51.8654036,
                35.6566512
              ],
              [
                51.8637317,
                35.6527326
              ],
              [
                51.8620562,
                35.6488051
              ],
              [
                51.8604034,
                35.6429291
              ],
              [
                51.8576793,
                35.6349751
              ],
              [
                51.8566576,
                35.6262876
              ],
              [
                51.8497851,
                35.6105976
              ],
              [
                51.8485295,
                35.6079772
              ],
              [
                51.8449494,
                35.6005049
              ],
              [
                51.8300952,
                35.5858526
              ],
              [
                51.8226736,
                35.5808841
              ],
              [
                51.8198919,
                35.5795344
              ],
              [
                51.8132268,
                35.5748769
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555039,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رباط کریم",
          "name:en": "Robat Karim County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282254",
          "wikipedia": "fa:شهرستان رباط‌کریم"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.8844644,
                35.4911489
              ],
              [
                50.8879956,
                35.4873396
              ],
              [
                50.8915269,
                35.4851248
              ],
              [
                50.8948336,
                35.4828955
              ],
              [
                50.8975415,
                35.4816335
              ],
              [
                50.899977,
                35.4799
              ],
              [
                50.9036046,
                35.4760444
              ],
              [
                50.9065339,
                35.4746713
              ],
              [
                50.9096846,
                35.4734231
              ],
              [
                50.91212,
                35.4704133
              ],
              [
                50.915952,
                35.4684298
              ],
              [
                50.9218277,
                35.4656001
              ],
              [
                50.934107,
                35.4603151
              ],
              [
                50.9418391,
                35.4569857
              ],
              [
                50.9458257,
                35.4557088
              ],
              [
                50.9462147,
                35.455684
              ],
              [
                50.9469356,
                35.4555791
              ],
              [
                50.9473734,
                35.4557259
              ],
              [
                50.9487381,
                35.4554533
              ],
              [
                50.9493046,
                35.4550548
              ],
              [
                50.9492788,
                35.4543626
              ],
              [
                50.9488411,
                35.4541738
              ],
              [
                50.9485063,
                35.4537124
              ],
              [
                50.9493818,
                35.45323
              ],
              [
                50.9496908,
                35.4527895
              ],
              [
                50.950695,
                35.4527056
              ],
              [
                50.9515705,
                35.4529363
              ],
              [
                50.9527292,
                35.453188
              ],
              [
                50.9531412,
                35.4528314
              ],
              [
                50.9542484,
                35.4525168
              ],
              [
                50.9552526,
                35.4522231
              ],
              [
                50.9567461,
                35.4516988
              ],
              [
                50.9574671,
                35.4509017
              ],
              [
                50.9578533,
                35.4501675
              ],
              [
                50.9582395,
                35.4493705
              ],
              [
                50.9592438,
                35.4489509
              ],
              [
                50.960763,
                35.4488461
              ],
              [
                50.9611749,
                35.4487202
              ],
              [
                50.9621534,
                35.4476504
              ],
              [
                50.9633121,
                35.4467904
              ],
              [
                50.9634924,
                35.4464128
              ],
              [
                50.9632864,
                35.4457835
              ],
              [
                50.9634403,
                35.4448193
              ],
              [
                50.9643651,
                35.443781
              ],
              [
                50.9650196,
                35.4432565
              ],
              [
                50.9654058,
                35.442531
              ],
              [
                50.96591,
                35.4418755
              ],
              [
                50.9660495,
                35.4413773
              ],
              [
                50.966307,
                35.4407129
              ],
              [
                50.9665109,
                35.4399787
              ],
              [
                50.9667254,
                35.4395242
              ],
              [
                50.9670258,
                35.4392095
              ],
              [
                50.9672941,
                35.4390434
              ],
              [
                50.9674765,
                35.43898
              ],
              [
                50.9677018,
                35.4389363
              ],
              [
                50.9678654,
                35.4389735
              ],
              [
                50.9679485,
                35.4390543
              ],
              [
                50.9680478,
                35.4391286
              ],
              [
                50.9682462,
                35.439098
              ],
              [
                50.9685198,
                35.4390216
              ],
              [
                50.9687773,
                35.438921
              ],
              [
                50.9689973,
                35.4388161
              ],
              [
                50.9692548,
                35.438626
              ],
              [
                50.9695337,
                35.4383922
              ],
              [
                50.9697241,
                35.4381715
              ],
              [
                50.9698663,
                35.4380316
              ],
              [
                50.9701667,
                35.437918
              ],
              [
                50.9706066,
                35.4378568
              ],
              [
                50.9712208,
                35.4377978
              ],
              [
                50.9716285,
                35.4377716
              ],
              [
                50.9721462,
                35.437612
              ],
              [
                50.9728543,
                35.4373301
              ],
              [
                50.9732217,
                35.437057
              ],
              [
                50.9737528,
                35.4366155
              ],
              [
                50.9745253,
                35.436279
              ],
              [
                50.9755875,
                35.43589
              ],
              [
                50.9758986,
                35.4357807
              ],
              [
                50.9761024,
                35.4356758
              ],
              [
                50.9766013,
                35.4352213
              ],
              [
                50.9770358,
                35.4350246
              ],
              [
                50.9777815,
                35.4350901
              ],
              [
                50.9782375,
                35.4353305
              ],
              [
                50.9785218,
                35.4355185
              ],
              [
                50.9789241,
                35.4354966
              ],
              [
                50.9795893,
                35.4354048
              ],
              [
                50.9800882,
                35.4350901
              ],
              [
                50.9808285,
                35.4346443
              ],
              [
                50.9815366,
                35.434417
              ],
              [
                50.9829743,
                35.4341679
              ],
              [
                50.9833176,
                35.4339756
              ],
              [
                50.9838326,
                35.4335997
              ],
              [
                50.9847928,
                35.4329528
              ],
              [
                50.9853453,
                35.4324021
              ],
              [
                50.9857369,
                35.4319256
              ],
              [
                50.9861017,
                35.4317377
              ],
              [
                50.9864933,
                35.4315891
              ],
              [
                50.9870673,
                35.4313181
              ],
              [
                50.9874535,
                35.431082
              ],
              [
                50.9879351,
                35.4300871
              ],
              [
                50.9886485,
                35.428955
              ],
              [
                50.9906763,
                35.4283911
              ],
              [
                50.9911269,
                35.4276437
              ],
              [
                50.9922212,
                35.427294
              ],
              [
                50.9936535,
                35.4264897
              ],
              [
                50.9946513,
                35.4259433
              ],
              [
                50.9953594,
                35.4258908
              ],
              [
                50.9964484,
                35.425222
              ],
              [
                50.9969419,
                35.4249379
              ],
              [
                50.9977734,
                35.4247892
              ],
              [
                50.998165,
                35.4245313
              ],
              [
                50.9985352,
                35.4244264
              ],
              [
                50.9987444,
                35.4241292
              ],
              [
                50.9986317,
                35.4237926
              ],
              [
                50.9986693,
                35.4235084
              ],
              [
                50.9988999,
                35.4232418
              ],
              [
                50.9990877,
                35.4230451
              ],
              [
                50.9991038,
                35.4227653
              ],
              [
                50.9989268,
                35.4224986
              ],
              [
                50.9995329,
                35.421974
              ],
              [
                51.0001552,
                35.4220003
              ],
              [
                51.0004288,
                35.4217249
              ],
              [
                51.0004771,
                35.421467
              ],
              [
                51.0004234,
                35.4212221
              ],
              [
                51.0007721,
                35.4209861
              ],
              [
                51.0013568,
                35.4208243
              ],
              [
                51.0016572,
                35.4208549
              ],
              [
                51.0019898,
                35.4209948
              ],
              [
                51.0023439,
                35.4210167
              ],
              [
                51.0028535,
                35.4208418
              ],
              [
                51.0030627,
                35.4207937
              ],
              [
                51.0032451,
                35.4208812
              ],
              [
                51.0033363,
                35.421126
              ],
              [
                51.0035777,
                35.4213183
              ],
              [
                51.003862,
                35.4212877
              ],
              [
                51.0042643,
                35.4211522
              ],
              [
                51.004656,
                35.4209467
              ],
              [
                51.0053962,
                35.4207325
              ],
              [
                51.0061473,
                35.4206014
              ],
              [
                51.0069466,
                35.420785
              ],
              [
                51.0081804,
                35.4210167
              ],
              [
                51.0092747,
                35.4210079
              ],
              [
                51.0104442,
                35.4210823
              ],
              [
                51.0111415,
                35.4209205
              ],
              [
                51.0116726,
                35.4206058
              ],
              [
                51.0125631,
                35.4203435
              ],
              [
                51.0133141,
                35.4199325
              ],
              [
                51.0141241,
                35.4194167
              ],
              [
                51.015299,
                35.4193555
              ],
              [
                51.0159266,
                35.4194167
              ],
              [
                51.016522,
                35.4193948
              ],
              [
                51.0176754,
                35.4192812
              ],
              [
                51.0185659,
                35.4188527
              ],
              [
                51.0193759,
                35.4184418
              ],
              [
                51.0202289,
                35.4185074
              ],
              [
                51.0210872,
                35.418385
              ],
              [
                51.0217363,
                35.418538
              ],
              [
                51.0225463,
                35.4185598
              ],
              [
                51.0236138,
                35.4183806
              ],
              [
                51.0241449,
                35.4182014
              ],
              [
                51.0267162,
                35.4183106
              ],
              [
                51.0296773,
                35.4185414
              ],
              [
                51.030939,
                35.4189191
              ],
              [
                51.0336942,
                35.4205978
              ],
              [
                51.041419,
                35.4248364
              ],
              [
                51.0654172,
                35.4391871
              ],
              [
                51.0686874,
                35.4427534
              ],
              [
                51.086827,
                35.4561317
              ],
              [
                51.1008184,
                35.4510182
              ],
              [
                51.1174266,
                35.4449979
              ],
              [
                51.1306617,
                35.4399003
              ],
              [
                51.1468322,
                35.4338373
              ],
              [
                51.178066,
                35.4218778
              ],
              [
                51.186383,
                35.4186883
              ],
              [
                51.1882627,
                35.4176181
              ],
              [
                51.190253,
                35.4158135
              ],
              [
                51.1914633,
                35.4136311
              ],
              [
                51.1915148,
                35.4121621
              ],
              [
                51.1914375,
                35.4056143
              ],
              [
                51.191798,
                35.4052994
              ],
              [
                51.1939867,
                35.4023192
              ],
              [
                51.1971796,
                35.4030118
              ],
              [
                51.198776,
                35.4038933
              ],
              [
                51.200012,
                35.4049007
              ],
              [
                51.2010935,
                35.4062649
              ],
              [
                51.2020462,
                35.4085734
              ],
              [
                51.2020977,
                35.4111128
              ],
              [
                51.2016599,
                35.4175132
              ],
              [
                51.2009647,
                35.4238293
              ],
              [
                51.2009647,
                35.4281096
              ],
              [
                51.2019689,
                35.4335856
              ],
              [
                51.2035911,
                35.4396067
              ],
              [
                51.2055223,
                35.4429842
              ],
              [
                51.208947,
                35.4492353
              ],
              [
                51.2116249,
                35.4528641
              ],
              [
                51.2146375,
                35.456241
              ],
              [
                51.2173927,
                35.4587998
              ],
              [
                51.223006,
                35.4631412
              ],
              [
                51.223006,
                35.4636865
              ],
              [
                51.223109,
                35.4643367
              ],
              [
                51.2241647,
                35.4652804
              ],
              [
                51.2242935,
                35.4665807
              ],
              [
                51.2233923,
                35.4674824
              ],
              [
                51.2217701,
                35.4683632
              ],
              [
                51.2216413,
                35.4689085
              ],
              [
                51.2214096,
                35.4698521
              ],
              [
                51.2204311,
                35.470649
              ],
              [
                51.2195814,
                35.4712572
              ],
              [
                51.2197359,
                35.4718443
              ],
              [
                51.2192724,
                35.4731864
              ],
              [
                51.2172897,
                35.4745075
              ],
              [
                51.216543,
                35.4754511
              ],
              [
                51.2161052,
                35.4768141
              ],
              [
                51.2145345,
                35.4780722
              ],
              [
                51.2132986,
                35.4784916
              ],
              [
                51.2119596,
                35.478911
              ],
              [
                51.210921,
                35.4802006
              ],
              [
                51.2100428,
                35.4808944
              ],
              [
                51.1945724,
                35.4840516
              ],
              [
                51.1895481,
                35.480386
              ],
              [
                51.1854927,
                35.4786278
              ],
              [
                51.1828558,
                35.4774004
              ],
              [
                51.1803528,
                35.4753104
              ],
              [
                51.1781083,
                35.4745095
              ],
              [
                51.1720006,
                35.4728252
              ],
              [
                51.1567446,
                35.4744425
              ],
              [
                51.1559358,
                35.4744888
              ],
              [
                51.1523907,
                35.4746918
              ],
              [
                51.1493167,
                35.4761388
              ],
              [
                51.1479459,
                35.47479
              ],
              [
                51.1477187,
                35.4759405
              ],
              [
                51.1478871,
                35.4775498
              ],
              [
                51.1468931,
                35.4779341
              ],
              [
                51.1483623,
                35.4793882
              ],
              [
                51.1505735,
                35.4815093
              ],
              [
                51.1489963,
                35.4827761
              ],
              [
                51.1502047,
                35.4838195
              ],
              [
                51.1504257,
                35.4839802
              ],
              [
                51.149473,
                35.4852906
              ],
              [
                51.1496079,
                35.4867685
              ],
              [
                51.1506271,
                35.4874761
              ],
              [
                51.1518827,
                35.4887763
              ],
              [
                51.1539533,
                35.4908274
              ],
              [
                51.1501775,
                35.4946124
              ],
              [
                51.1492703,
                35.4953677
              ],
              [
                51.1473441,
                35.4988669
              ],
              [
                51.1447906,
                35.497941
              ],
              [
                51.1428475,
                35.4968158
              ],
              [
                51.1390538,
                35.5006594
              ],
              [
                51.1345164,
                35.5051114
              ],
              [
                51.128244,
                35.5008415
              ],
              [
                51.1222815,
                35.4968928
              ],
              [
                51.1229896,
                35.4992163
              ],
              [
                51.1245024,
                35.5031467
              ],
              [
                51.123687,
                35.5037494
              ],
              [
                51.1230004,
                35.5040114
              ],
              [
                51.1226194,
                35.5042291
              ],
              [
                51.1223888,
                35.5043608
              ],
              [
                51.1217581,
                35.504856
              ],
              [
                51.1271432,
                35.5087682
              ],
              [
                51.1299067,
                35.5108952
              ],
              [
                51.1339179,
                35.5139552
              ],
              [
                51.1357989,
                35.5154597
              ],
              [
                51.1381906,
                35.5170577
              ],
              [
                51.1452669,
                35.5221485
              ],
              [
                51.1470396,
                35.5235815
              ],
              [
                51.1456017,
                35.5245056
              ],
              [
                51.1444752,
                35.523493
              ],
              [
                51.1413355,
                35.5254353
              ],
              [
                51.1233107,
                35.5383449
              ],
              [
                51.1214568,
                35.5401678
              ],
              [
                51.1205558,
                35.5422871
              ],
              [
                51.1196803,
                35.5446127
              ],
              [
                51.1181869,
                35.5492009
              ],
              [
                51.1136592,
                35.5464567
              ],
              [
                51.1123203,
                35.5462053
              ],
              [
                51.1109813,
                35.5469176
              ],
              [
                51.1092089,
                35.5487508
              ],
              [
                51.1086529,
                35.549087
              ],
              [
                51.1057714,
                35.5498576
              ],
              [
                51.1042779,
                35.5511495
              ],
              [
                51.1032003,
                35.5517071
              ],
              [
                51.102739,
                35.5517333
              ],
              [
                51.1014086,
                35.5532914
              ],
              [
                51.1009633,
                35.5529684
              ],
              [
                51.1012101,
                35.5526847
              ],
              [
                51.1003089,
                35.5521828
              ],
              [
                51.1000246,
                35.5523705
              ],
              [
                51.0995471,
                35.5521043
              ],
              [
                51.0999145,
                35.5516322
              ],
              [
                51.0977018,
                35.5500966
              ],
              [
                51.0974872,
                35.5502625
              ],
              [
                51.0960925,
                35.5493285
              ],
              [
                51.0963607,
                35.5489531
              ],
              [
                51.0955667,
                35.5484206
              ],
              [
                51.0945046,
                35.5477397
              ],
              [
                51.0946875,
                35.5475049
              ],
              [
                51.0906535,
                35.5447953
              ],
              [
                51.0901379,
                35.5457931
              ],
              [
                51.0899448,
                35.5468581
              ],
              [
                51.0897302,
                35.5486389
              ],
              [
                51.0869836,
                35.5520607
              ],
              [
                51.0833578,
                35.5569586
              ],
              [
                51.0823478,
                35.556184
              ],
              [
                51.0753536,
                35.5532827
              ],
              [
                51.0711479,
                35.5501054
              ],
              [
                51.0707187,
                35.5533874
              ],
              [
                51.0699892,
                35.556006
              ],
              [
                51.0695171,
                35.5590434
              ],
              [
                51.067028,
                35.5617665
              ],
              [
                51.0634993,
                35.5657846
              ],
              [
                51.0584612,
                35.5634736
              ],
              [
                51.0563325,
                35.563355
              ],
              [
                51.0499316,
                35.5611573
              ],
              [
                51.0475981,
                35.5608676
              ],
              [
                51.0457217,
                35.5632973
              ],
              [
                51.0456133,
                35.5637041
              ],
              [
                51.0444975,
                35.5645768
              ],
              [
                51.0454201,
                35.5653274
              ],
              [
                51.0453772,
                35.5660779
              ],
              [
                51.0455704,
                35.5663223
              ],
              [
                51.045506,
                35.5684866
              ],
              [
                51.0460424,
                35.5702495
              ],
              [
                51.0454105,
                35.5703367
              ],
              [
                51.0446038,
                35.5709965
              ],
              [
                51.0405868,
                35.5736747
              ],
              [
                51.0404488,
                35.5734807
              ],
              [
                51.0403749,
                35.573234
              ],
              [
                51.0401121,
                35.57297
              ],
              [
                51.0396051,
                35.572429
              ],
              [
                51.0394549,
                35.5723723
              ],
              [
                51.0389614,
                35.572261
              ],
              [
                51.0386825,
                35.5726177
              ],
              [
                51.0385618,
                35.572693
              ],
              [
                51.0382828,
                35.5730148
              ],
              [
                51.0381903,
                35.5730813
              ],
              [
                51.0380709,
                35.5730682
              ],
              [
                51.0379797,
                35.5730071
              ],
              [
                51.0376914,
                35.573054
              ],
              [
                51.0374325,
                35.5731707
              ],
              [
                51.0372018,
                35.5733082
              ],
              [
                51.0358071,
                35.5754942
              ],
              [
                51.0328082,
                35.5735904
              ],
              [
                51.0278892,
                35.5707731
              ],
              [
                51.0287475,
                35.5691325
              ],
              [
                51.0268592,
                35.5678758
              ],
              [
                51.0279408,
                35.5651086
              ],
              [
                51.0289299,
                35.5607279
              ],
              [
                51.0251748,
                35.5582404
              ],
              [
                51.0243916,
                35.5588776
              ],
              [
                51.0237425,
                35.5589387
              ],
              [
                51.021527,
                35.5599773
              ],
              [
                51.0204434,
                35.559122
              ],
              [
                51.018523,
                35.5578651
              ],
              [
                51.0179651,
                35.5584673
              ],
              [
                51.0166991,
                35.5596107
              ],
              [
                51.0160017,
                35.560405
              ],
              [
                51.0157227,
                35.5613039
              ],
              [
                51.0158085,
                35.5615745
              ],
              [
                51.012899,
                35.5656287
              ],
              [
                51.0085989,
                35.563206
              ],
              [
                50.9947586,
                35.560789
              ],
              [
                50.9855318,
                35.5588689
              ],
              [
                50.9836006,
                35.558799
              ],
              [
                50.9816265,
                35.5572978
              ],
              [
                50.9829613,
                35.5558256
              ],
              [
                50.9781503,
                35.5539112
              ],
              [
                50.975746,
                35.5557717
              ],
              [
                50.9660987,
                35.5521685
              ],
              [
                50.9522084,
                35.5451329
              ],
              [
                50.9430519,
                35.5392397
              ],
              [
                50.9405677,
                35.5371792
              ],
              [
                50.9349346,
                35.5326104
              ],
              [
                50.9291266,
                35.529275
              ],
              [
                50.9229161,
                35.5245343
              ],
              [
                50.9194214,
                35.5218108
              ],
              [
                50.9131121,
                35.5169106
              ],
              [
                50.9063744,
                35.5116883
              ],
              [
                50.8957682,
                35.5048323
              ],
              [
                50.8944225,
                35.5040027
              ],
              [
                50.8926201,
                35.5018541
              ],
              [
                50.8924269,
                35.5008409
              ],
              [
                50.8898306,
                35.4976964
              ],
              [
                50.8844644,
                35.4911489
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555053,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ری",
          "name:en": "Rey County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1264560",
          "wikipedia": "fa:شهرستان ری"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.8431728,
                35.2145523
              ],
              [
                50.8712169,
                35.2137184
              ],
              [
                50.9077495,
                35.2186113
              ],
              [
                50.9110829,
                35.2174937
              ],
              [
                50.9498385,
                35.2181248
              ],
              [
                50.983541,
                35.2184467
              ],
              [
                50.992711,
                35.2151123
              ],
              [
                50.993821,
                35.2151123
              ],
              [
                51.0134203,
                35.2142742
              ],
              [
                51.0145337,
                35.2142741
              ],
              [
                51.0181436,
                35.2131658
              ],
              [
                51.0195337,
                35.2131658
              ],
              [
                51.0273102,
                35.2114985
              ],
              [
                51.0320335,
                35.2112281
              ],
              [
                51.0331435,
                35.2109489
              ],
              [
                51.0364768,
                35.2109488
              ],
              [
                51.0375902,
                35.2106694
              ],
              [
                51.0489966,
                35.2061812
              ],
              [
                51.0520531,
                35.2061812
              ],
              [
                51.0590081,
                35.2037967
              ],
              [
                51.0592847,
                35.2040762
              ],
              [
                51.0603947,
                35.2037967
              ],
              [
                51.0680331,
                35.2008512
              ],
              [
                51.0691464,
                35.2005717
              ],
              [
                51.0708131,
                35.2005717
              ],
              [
                51.0710896,
                35.2008511
              ],
              [
                51.0719231,
                35.2008512
              ],
              [
                51.0721996,
                35.2005718
              ],
              [
                51.082003,
                35.1966542
              ],
              [
                51.0828364,
                35.1963747
              ],
              [
                51.0872797,
                35.1963748
              ],
              [
                51.0878363,
                35.1960953
              ],
              [
                51.0903361,
                35.1960954
              ],
              [
                51.096211,
                35.1927298
              ],
              [
                51.0981577,
                35.1927298
              ],
              [
                51.1037144,
                35.1927298
              ],
              [
                51.1117675,
                35.1913417
              ],
              [
                51.1174221,
                35.187487
              ],
              [
                51.1227321,
                35.1845114
              ],
              [
                51.1320876,
                35.1802358
              ],
              [
                51.1398642,
                35.1802358
              ],
              [
                51.1406974,
                35.1805155
              ],
              [
                51.1451407,
                35.1805155
              ],
              [
                51.146254,
                35.1802358
              ],
              [
                51.158404,
                35.173526
              ],
              [
                51.1776174,
                35.1668309
              ],
              [
                51.1837272,
                35.1662716
              ],
              [
                51.2190068,
                35.1590464
              ],
              [
                51.2209536,
                35.1590464
              ],
              [
                51.2217869,
                35.1587667
              ],
              [
                51.2459973,
                35.1505134
              ],
              [
                51.2687771,
                35.1449482
              ],
              [
                51.3107592,
                35.1267086
              ],
              [
                51.3196491,
                35.1247599
              ],
              [
                51.328259,
                35.1222607
              ],
              [
                51.3620884,
                35.1057775
              ],
              [
                51.398988,
                35.1047632
              ],
              [
                51.4404723,
                35.0937979
              ],
              [
                51.4405978,
                35.0938196
              ],
              [
                51.4442626,
                35.0934499
              ],
              [
                51.4464176,
                35.0932326
              ],
              [
                51.4567195,
                35.1051183
              ],
              [
                51.4602472,
                35.1084466
              ],
              [
                51.4620754,
                35.1097736
              ],
              [
                51.4644186,
                35.1113534
              ],
              [
                51.4758141,
                35.115998
              ],
              [
                51.4866545,
                35.1202104
              ],
              [
                51.4927828,
                35.1226535
              ],
              [
                51.4982159,
                35.1251386
              ],
              [
                51.5070736,
                35.1299191
              ],
              [
                51.5141547,
                35.1340255
              ],
              [
                51.5215447,
                35.1381317
              ],
              [
                51.5250466,
                35.1398373
              ],
              [
                51.5334408,
                35.1426588
              ],
              [
                51.5492766,
                35.1478173
              ],
              [
                51.5567438,
                35.1502806
              ],
              [
                51.5567438,
                35.1513333
              ],
              [
                51.5576193,
                35.1533123
              ],
              [
                51.5576193,
                35.1541755
              ],
              [
                51.5575678,
                35.155607
              ],
              [
                51.5571816,
                35.1573122
              ],
              [
                51.5573361,
                35.1579859
              ],
              [
                51.5581858,
                35.1586175
              ],
              [
                51.5587265,
                35.1595437
              ],
              [
                51.558778,
                35.160491
              ],
              [
                51.5584175,
                35.1615436
              ],
              [
                51.5572073,
                35.1620488
              ],
              [
                51.5567438,
                35.1631855
              ],
              [
                51.5576708,
                35.1647643
              ],
              [
                51.5576708,
                35.1657747
              ],
              [
                51.5568468,
                35.1671639
              ],
              [
                51.5560744,
                35.1676481
              ],
              [
                51.5543749,
                35.1679007
              ],
              [
                51.5533707,
                35.1685111
              ],
              [
                51.5531647,
                35.1691004
              ],
              [
                51.5514652,
                35.1704897
              ],
              [
                51.5514652,
                35.1714158
              ],
              [
                51.5520317,
                35.1722577
              ],
              [
                51.552727,
                35.1722577
              ],
              [
                51.5534222,
                35.1726787
              ],
              [
                51.5536797,
                35.1736679
              ],
              [
                51.5531389,
                35.1749729
              ],
              [
                51.552212,
                35.1761094
              ],
              [
                51.5510275,
                35.176804
              ],
              [
                51.5502808,
                35.1770355
              ],
              [
                51.549534,
                35.1771197
              ],
              [
                51.5485298,
                35.1782562
              ],
              [
                51.5479633,
                35.1795821
              ],
              [
                51.5474999,
                35.1806554
              ],
              [
                51.5476544,
                35.180929
              ],
              [
                51.5478861,
                35.1812868
              ],
              [
                51.5472939,
                35.1820024
              ],
              [
                51.5463411,
                35.1826548
              ],
              [
                51.5455429,
                35.1836649
              ],
              [
                51.5451309,
                35.1845909
              ],
              [
                51.5451309,
                35.18558
              ],
              [
                51.5454142,
                35.1865901
              ],
              [
                51.5450537,
                35.1873056
              ],
              [
                51.5450537,
                35.187937
              ],
              [
                51.5452854,
                35.1886525
              ],
              [
                51.5455429,
                35.1889681
              ],
              [
                51.5463411,
                35.1893469
              ],
              [
                51.5470879,
                35.1901886
              ],
              [
                51.5465986,
                35.1915354
              ],
              [
                51.5461352,
                35.1922088
              ],
              [
                51.5451567,
                35.1930505
              ],
              [
                51.543998,
                35.1941026
              ],
              [
                51.543071,
                35.1957018
              ],
              [
                51.5426075,
                35.1965435
              ],
              [
                51.5417578,
                35.1969433
              ],
              [
                51.5413201,
                35.1980374
              ],
              [
                51.5415003,
                35.1986056
              ],
              [
                51.5420668,
                35.1996787
              ],
              [
                51.541732,
                35.201404
              ],
              [
                51.5411398,
                35.2024139
              ],
              [
                51.5410626,
                35.2042865
              ],
              [
                51.5411656,
                35.2051701
              ],
              [
                51.5414488,
                35.2059276
              ],
              [
                51.5413458,
                35.206706
              ],
              [
                51.5406248,
                35.207758
              ],
              [
                51.5390284,
                35.207779
              ],
              [
                51.5379727,
                35.2084733
              ],
              [
                51.5382301,
                35.2092727
              ],
              [
                51.5391314,
                35.2100932
              ],
              [
                51.5408308,
                35.2114397
              ],
              [
                51.5408823,
                35.2128913
              ],
              [
                51.5410111,
                35.2150791
              ],
              [
                51.5407021,
                35.2174142
              ],
              [
                51.5411656,
                35.2177929
              ],
              [
                51.5412428,
                35.2187184
              ],
              [
                51.5398266,
                35.2199806
              ],
              [
                51.5390541,
                35.2210113
              ],
              [
                51.5377409,
                35.2234514
              ],
              [
                51.5367624,
                35.2261017
              ],
              [
                51.5362732,
                35.2278686
              ],
              [
                51.5360157,
                35.2291516
              ],
              [
                51.536299,
                35.2296985
              ],
              [
                51.5368139,
                35.2305608
              ],
              [
                51.5359127,
                35.2311918
              ],
              [
                51.5345738,
                35.2324117
              ],
              [
                51.5337755,
                35.2330006
              ],
              [
                51.5335695,
                35.2337998
              ],
              [
                51.5341103,
                35.2340733
              ],
              [
                51.534754,
                35.2343256
              ],
              [
                51.5347025,
                35.2347883
              ],
              [
                51.5340073,
                35.2353562
              ],
              [
                51.5325653,
                35.235882
              ],
              [
                51.5309689,
                35.2369125
              ],
              [
                51.5309689,
                35.2376066
              ],
              [
                51.5310976,
                35.2384268
              ],
              [
                51.5309689,
                35.2389946
              ],
              [
                51.5302736,
                35.2393101
              ],
              [
                51.5293724,
                35.239268
              ],
              [
                51.5288059,
                35.2397096
              ],
              [
                51.5287029,
                35.2409925
              ],
              [
                51.5286772,
                35.2425067
              ],
              [
                51.5290892,
                35.2439998
              ],
              [
                51.5289604,
                35.2460186
              ],
              [
                51.5295012,
                35.2481214
              ],
              [
                51.5283939,
                35.2498668
              ],
              [
                51.52757,
                35.2508971
              ],
              [
                51.5266688,
                35.2516541
              ],
              [
                51.52654,
                35.2522429
              ],
              [
                51.5266173,
                35.2530419
              ],
              [
                51.52757,
                35.2548082
              ],
              [
                51.5272867,
                35.2550605
              ],
              [
                51.525819,
                35.254661
              ],
              [
                51.5251238,
                35.254682
              ],
              [
                51.5240681,
                35.255502
              ],
              [
                51.5238878,
                35.2563221
              ],
              [
                51.5235531,
                35.2572893
              ],
              [
                51.5223136,
                35.2572691
              ],
              [
                51.5217164,
                35.2575568
              ],
              [
                51.5208752,
                35.2579621
              ],
              [
                51.5211069,
                35.2593918
              ],
              [
                51.5206434,
                35.2601908
              ],
              [
                51.5204632,
                35.2614313
              ],
              [
                51.5205147,
                35.2622512
              ],
              [
                51.5205147,
                35.2630081
              ],
              [
                51.5198967,
                35.2636389
              ],
              [
                51.5199482,
                35.2649213
              ],
              [
                51.5202829,
                35.2654049
              ],
              [
                51.5207464,
                35.2657623
              ],
              [
                51.5207464,
                35.2668135
              ],
              [
                51.5198452,
                35.2676334
              ],
              [
                51.5174763,
                35.2692311
              ],
              [
                51.5163948,
                35.2701982
              ],
              [
                51.5151413,
                35.2708397
              ],
              [
                51.5106351,
                35.2722062
              ],
              [
                51.5095022,
                35.2717857
              ],
              [
                51.5072105,
                35.272059
              ],
              [
                51.5026529,
                35.2734465
              ],
              [
                51.4847314,
                35.2793324
              ],
              [
                51.4857614,
                35.2820229
              ],
              [
                51.4648015,
                35.2886832
              ],
              [
                51.4665267,
                35.2914155
              ],
              [
                51.4719598,
                35.2951354
              ],
              [
                51.4653938,
                35.2955768
              ],
              [
                51.4582355,
                35.2941687
              ],
              [
                51.4902476,
                35.3151478
              ],
              [
                51.4893234,
                35.3162451
              ],
              [
                51.4877785,
                35.3210143
              ],
              [
                51.4862335,
                35.3222749
              ],
              [
                51.4860018,
                35.3234304
              ],
              [
                51.4866455,
                35.3273589
              ],
              [
                51.4865323,
                35.3282262
              ],
              [
                51.4858473,
                35.333472
              ],
              [
                51.4873455,
                35.3346492
              ],
              [
                51.4868821,
                35.3357835
              ],
              [
                51.4862126,
                35.3376319
              ],
              [
                51.4862126,
                35.3389342
              ],
              [
                51.4874485,
                35.3415598
              ],
              [
                51.4877575,
                35.3429461
              ],
              [
                51.487603,
                35.3439122
              ],
              [
                51.4899977,
                35.3459075
              ],
              [
                51.4913109,
                35.3468947
              ],
              [
                51.4918001,
                35.3480708
              ],
              [
                51.4905384,
                35.3491839
              ],
              [
                51.4918516,
                35.3507381
              ],
              [
                51.4902552,
                35.3512421
              ],
              [
                51.4912852,
                35.3527122
              ],
              [
                51.4922379,
                35.3527542
              ],
              [
                51.4929589,
                35.3535943
              ],
              [
                51.4916972,
                35.3537413
              ],
              [
                51.4913624,
                35.3545813
              ],
              [
                51.4912594,
                35.3557783
              ],
              [
                51.4930619,
                35.3580463
              ],
              [
                51.4934224,
                35.3595373
              ],
              [
                51.4922894,
                35.3609443
              ],
              [
                51.4918517,
                35.3618262
              ],
              [
                51.4917997,
                35.36283
              ],
              [
                51.4921083,
                35.3635733
              ],
              [
                51.4929323,
                35.3640143
              ],
              [
                51.4934988,
                35.3644763
              ],
              [
                51.4934215,
                35.3654422
              ],
              [
                51.4931898,
                35.3661981
              ],
              [
                51.4937048,
                35.36666
              ],
              [
                51.494297,
                35.367101
              ],
              [
                51.4948377,
                35.3677939
              ],
              [
                51.4952497,
                35.3689277
              ],
              [
                51.4949922,
                35.3706915
              ],
              [
                51.4951982,
                35.3726651
              ],
              [
                51.4945545,
                35.3736519
              ],
              [
                51.4945287,
                35.3747857
              ],
              [
                51.4956102,
                35.3758774
              ],
              [
                51.495018,
                35.3772001
              ],
              [
                51.494915,
                35.3779979
              ],
              [
                51.4944515,
                35.3781659
              ],
              [
                51.4939365,
                35.3785018
              ],
              [
                51.4939622,
                35.3793416
              ],
              [
                51.4925718,
                35.3820708
              ],
              [
                51.4926748,
                35.3833094
              ],
              [
                51.4931898,
                35.3847159
              ],
              [
                51.4930868,
                35.3860595
              ],
              [
                51.4934215,
                35.3871511
              ],
              [
                51.493061,
                35.3880327
              ],
              [
                51.4935503,
                35.3893132
              ],
              [
                51.4925975,
                35.3904258
              ],
              [
                51.4931434,
                35.3916724
              ],
              [
                51.4937614,
                35.3927009
              ],
              [
                51.4947398,
                35.3937295
              ],
              [
                51.4959397,
                35.3957256
              ],
              [
                51.4963517,
                35.3975307
              ],
              [
                51.4987721,
                35.4011409
              ],
              [
                51.4994931,
                35.4018965
              ],
              [
                51.5007291,
                35.402715
              ],
              [
                51.502068,
                35.4034496
              ],
              [
                51.503613,
                35.4041422
              ],
              [
                51.5056987,
                35.4047298
              ],
              [
                51.5076813,
                35.4058212
              ],
              [
                51.5093035,
                35.4080878
              ],
              [
                51.5113635,
                35.4113826
              ],
              [
                51.5113635,
                35.4139429
              ],
              [
                51.5109,
                35.4175523
              ],
              [
                51.5112605,
                35.4206999
              ],
              [
                51.5133462,
                35.4233857
              ],
              [
                51.518393,
                35.4275822
              ],
              [
                51.5204529,
                35.4294285
              ],
              [
                51.5225644,
                35.4305825
              ],
              [
                51.5249076,
                35.4315896
              ],
              [
                51.5273795,
                35.4321351
              ],
              [
                51.5307784,
                35.4334358
              ],
              [
                51.5327611,
                35.434338
              ],
              [
                51.5346408,
                35.4355758
              ],
              [
                51.5355935,
                35.4366038
              ],
              [
                51.5375247,
                35.4396038
              ],
              [
                51.5380397,
                35.4424778
              ],
              [
                51.5380912,
                35.4427295
              ],
              [
                51.5383229,
                35.4433589
              ],
              [
                51.5387349,
                35.4437994
              ],
              [
                51.5392756,
                35.4443868
              ],
              [
                51.5399193,
                35.4447224
              ],
              [
                51.5407948,
                35.4447853
              ],
              [
                51.5419793,
                35.4447853
              ],
              [
                51.5432146,
                35.4452836
              ],
              [
                51.5493817,
                35.450439
              ],
              [
                51.5477413,
                35.4521363
              ],
              [
                51.5423524,
                35.4577119
              ],
              [
                51.5467298,
                35.4558872
              ],
              [
                51.5526778,
                35.4633537
              ],
              [
                51.5533988,
                35.4638151
              ],
              [
                51.5553471,
                35.4638278
              ],
              [
                51.5839897,
                35.4653324
              ],
              [
                51.5854342,
                35.467498
              ],
              [
                51.5867636,
                35.4689002
              ],
              [
                51.5879223,
                35.4706198
              ],
              [
                51.5890037,
                35.4720458
              ],
              [
                51.5916044,
                35.474646
              ],
              [
                51.5925056,
                35.47603
              ],
              [
                51.5932781,
                35.4795946
              ],
              [
                51.5933296,
                35.4835575
              ],
              [
                51.5954925,
                35.4875621
              ],
              [
                51.596986,
                35.4922584
              ],
              [
                51.5968315,
                35.494858
              ],
              [
                51.596059,
                35.4987363
              ],
              [
                51.5949261,
                35.5045848
              ],
              [
                51.5941793,
                35.5101604
              ],
              [
                51.5921194,
                35.5183344
              ],
              [
                51.5919405,
                35.5214519
              ],
              [
                51.5960397,
                35.5294994
              ],
              [
                51.600111,
                35.5405042
              ],
              [
                51.6035599,
                35.5384341
              ],
              [
                51.6159852,
                35.529882
              ],
              [
                51.6188368,
                35.5279416
              ],
              [
                51.6258783,
                35.5231502
              ],
              [
                51.6266599,
                35.5226183
              ],
              [
                51.6379921,
                35.5149066
              ],
              [
                51.6387131,
                35.5156192
              ],
              [
                51.6403095,
                35.5158078
              ],
              [
                51.6445839,
                35.5161012
              ],
              [
                51.6534416,
                35.5163527
              ],
              [
                51.6546003,
                35.521194
              ],
              [
                51.6541883,
                35.5229335
              ],
              [
                51.6568148,
                35.5240022
              ],
              [
                51.6593382,
                35.5249872
              ],
              [
                51.6639988,
                35.5256159
              ],
              [
                51.6647455,
                35.5300794
              ],
              [
                51.6655695,
                35.5361561
              ],
              [
                51.6547291,
                35.5368685
              ],
              [
                51.6477253,
                35.5393619
              ],
              [
                51.6456911,
                35.5401581
              ],
              [
                51.6463863,
                35.5412895
              ],
              [
                51.6472875,
                35.5410381
              ],
              [
                51.6497852,
                35.5452703
              ],
              [
                51.649708,
                35.5464017
              ],
              [
                51.6501972,
                35.5485805
              ],
              [
                51.6512272,
                35.549209
              ],
              [
                51.6518709,
                35.5497747
              ],
              [
                51.6515104,
                35.5504451
              ],
              [
                51.6509439,
                35.5518277
              ],
              [
                51.6508409,
                35.5527704
              ],
              [
                51.6507122,
                35.5542788
              ],
              [
                51.6499397,
                35.5552843
              ],
              [
                51.648369,
                35.5553052
              ],
              [
                51.6471588,
                35.5562898
              ],
              [
                51.6465666,
                35.5571487
              ],
              [
                51.6455881,
                35.5584265
              ],
              [
                51.6460516,
                35.5614219
              ],
              [
                51.6451504,
                35.5623855
              ],
              [
                51.6458456,
                35.5630348
              ],
              [
                51.6465151,
                35.5636423
              ],
              [
                51.648575,
                35.564124
              ],
              [
                51.6491415,
                35.56492
              ],
              [
                51.650017,
                35.5661558
              ],
              [
                51.650017,
                35.5676638
              ],
              [
                51.6499397,
                35.5693394
              ],
              [
                51.649502,
                35.5723345
              ],
              [
                51.648987,
                35.5736539
              ],
              [
                51.6483175,
                35.5749524
              ],
              [
                51.6470558,
                35.5778006
              ],
              [
                51.6441976,
                35.5801043
              ],
              [
                51.640773,
                35.584502
              ],
              [
                51.6397173,
                35.5905117
              ],
              [
                51.6386616,
                35.5976726
              ],
              [
                51.6376058,
                35.6007085
              ],
              [
                51.6360094,
                35.6047491
              ],
              [
                51.6356983,
                35.607402
              ],
              [
                51.6354486,
                35.6098201
              ],
              [
                51.6272449,
                35.6095108
              ],
              [
                51.6182953,
                35.6101079
              ],
              [
                51.6177421,
                35.6103874
              ],
              [
                51.6118313,
                35.6110852
              ],
              [
                51.6109463,
                35.6112453
              ],
              [
                51.6090222,
                35.6118315
              ],
              [
                51.5998741,
                35.6142581
              ],
              [
                51.5911709,
                35.616791
              ],
              [
                51.580691,
                35.6196587
              ],
              [
                51.5667864,
                35.6214378
              ],
              [
                51.5532681,
                35.6238867
              ],
              [
                51.5417324,
                35.6292657
              ],
              [
                51.5404471,
                35.6298006
              ],
              [
                51.5385138,
                35.6306051
              ],
              [
                51.530995,
                35.6321957
              ],
              [
                51.5220916,
                35.630294
              ],
              [
                51.5302455,
                35.6297882
              ],
              [
                51.5302563,
                35.6271895
              ],
              [
                51.51824,
                35.6263523
              ],
              [
                51.5142059,
                35.6230471
              ],
              [
                51.5050408,
                35.6237615
              ],
              [
                51.504185,
                35.6221757
              ],
              [
                51.5032302,
                35.6196689
              ],
              [
                51.5037755,
                35.6175797
              ],
              [
                51.504024,
                35.6169178
              ],
              [
                51.5042725,
                35.6164074
              ],
              [
                51.5045839,
                35.6153834
              ],
              [
                51.5043676,
                35.6142601
              ],
              [
                51.5035607,
                35.6131553
              ],
              [
                51.5026671,
                35.6145065
              ],
              [
                51.5013509,
                35.6157401
              ],
              [
                51.5003813,
                35.614934
              ],
              [
                51.4992214,
                35.6144668
              ],
              [
                51.4984954,
                35.6140213
              ],
              [
                51.4996168,
                35.612931
              ],
              [
                51.4987465,
                35.6125334
              ],
              [
                51.49886,
                35.6121789
              ],
              [
                51.5000972,
                35.6111117
              ],
              [
                51.5028428,
                35.6086617
              ],
              [
                51.502225,
                35.6075565
              ],
              [
                51.5005204,
                35.606345
              ],
              [
                51.4984125,
                35.6057444
              ],
              [
                51.4954732,
                35.6075155
              ],
              [
                51.4939157,
                35.6086254
              ],
              [
                51.4929794,
                35.6079794
              ],
              [
                51.4903261,
                35.6092745
              ],
              [
                51.4893248,
                35.6097897
              ],
              [
                51.4872025,
                35.6107823
              ],
              [
                51.4858752,
                35.6114429
              ],
              [
                51.4838155,
                35.6124535
              ],
              [
                51.4807736,
                35.6136848
              ],
              [
                51.480648,
                35.6137424
              ],
              [
                51.4802611,
                35.6139427
              ],
              [
                51.480217,
                35.6139649
              ],
              [
                51.4800416,
                35.6139826
              ],
              [
                51.4777203,
                35.6125442
              ],
              [
                51.4728655,
                35.6179938
              ],
              [
                51.4723006,
                35.6178946
              ],
              [
                51.4721709,
                35.6179709
              ],
              [
                51.4715273,
                35.6179472
              ],
              [
                51.4712177,
                35.6173572
              ],
              [
                51.4602717,
                35.6251127
              ],
              [
                51.457329,
                35.6268689
              ],
              [
                51.4563255,
                35.6272794
              ],
              [
                51.4553253,
                35.627703
              ],
              [
                51.4544701,
                35.6280392
              ],
              [
                51.4537723,
                35.6283273
              ],
              [
                51.4531065,
                35.6286098
              ],
              [
                51.4527825,
                35.6289613
              ],
              [
                51.4524662,
                35.6295107
              ],
              [
                51.4502891,
                35.6295415
              ],
              [
                51.447957,
                35.6295124
              ],
              [
                51.4462465,
                35.6294438
              ],
              [
                51.4443041,
                35.6292932
              ],
              [
                51.4423461,
                35.6289618
              ],
              [
                51.4398678,
                35.6284778
              ],
              [
                51.4363541,
                35.6274749
              ],
              [
                51.4349507,
                35.6269779
              ],
              [
                51.432888,
                35.6261386
              ],
              [
                51.4299188,
                35.6246777
              ],
              [
                51.4281137,
                35.6236095
              ],
              [
                51.4259491,
                35.622201
              ],
              [
                51.4245035,
                35.6210301
              ],
              [
                51.4210251,
                35.6182618
              ],
              [
                51.4203997,
                35.617764
              ],
              [
                51.4185624,
                35.6167304
              ],
              [
                51.4167142,
                35.6158778
              ],
              [
                51.4144729,
                35.6152331
              ],
              [
                51.4118783,
                35.614877
              ],
              [
                51.4082734,
                35.6144584
              ],
              [
                51.4032567,
                35.6144292
              ],
              [
                51.4002501,
                35.6141058
              ],
              [
                51.3904081,
                35.6136005
              ],
              [
                51.3904054,
                35.610135
              ],
              [
                51.3902318,
                35.5992744
              ],
              [
                51.3902227,
                35.598523
              ],
              [
                51.3902683,
                35.596986
              ],
              [
                51.3900317,
                35.5917067
              ],
              [
                51.3903692,
                35.5901004
              ],
              [
                51.3905081,
                35.5883893
              ],
              [
                51.3908558,
                35.5850196
              ],
              [
                51.390951,
                35.5841254
              ],
              [
                51.3916796,
                35.5766502
              ],
              [
                51.3921946,
                35.5717285
              ],
              [
                51.3922203,
                35.5700739
              ],
              [
                51.3944249,
                35.570007
              ],
              [
                51.3943476,
                35.5697347
              ],
              [
                51.3949399,
                35.5694206
              ],
              [
                51.3948111,
                35.5683105
              ],
              [
                51.3957381,
                35.5662997
              ],
              [
                51.3975663,
                35.5636815
              ],
              [
                51.3984933,
                35.5624457
              ],
              [
                51.3979525,
                35.5612517
              ],
              [
                51.3976122,
                35.5604271
              ],
              [
                51.3976041,
                35.5590466
              ],
              [
                51.3983349,
                35.5577418
              ],
              [
                51.3981328,
                35.5572508
              ],
              [
                51.3967445,
                35.5547053
              ],
              [
                51.3923392,
                35.5473209
              ],
              [
                51.3914122,
                35.5460638
              ],
              [
                51.390408,
                35.5449115
              ],
              [
                51.3897643,
                35.5441363
              ],
              [
                51.3874908,
                35.5396571
              ],
              [
                51.3865199,
                35.5380602
              ],
              [
                51.3824396,
                35.5430845
              ],
              [
                51.3765945,
                35.5484689
              ],
              [
                51.3701315,
                35.5532873
              ],
              [
                51.3676595,
                35.555047
              ],
              [
                51.3649044,
                35.5561363
              ],
              [
                51.3615309,
                35.550893
              ],
              [
                51.358132,
                35.5465144
              ],
              [
                51.3553768,
                35.5435813
              ],
              [
                51.3498407,
                35.5391394
              ],
              [
                51.3491871,
                35.5386386
              ],
              [
                51.3458753,
                35.5361012
              ],
              [
                51.3398758,
                35.533042
              ],
              [
                51.324967,
                35.5272584
              ],
              [
                51.318488,
                35.5248079
              ],
              [
                51.3135858,
                35.5224385
              ],
              [
                51.3025652,
                35.5151032
              ],
              [
                51.3019128,
                35.5152797
              ],
              [
                51.2792052,
                35.5286922
              ],
              [
                51.2743621,
                35.5247434
              ],
              [
                51.2714165,
                35.5214287
              ],
              [
                51.2624586,
                35.5110715
              ],
              [
                51.2576568,
                35.5052516
              ],
              [
                51.2494327,
                35.5009786
              ],
              [
                51.2362946,
                35.492796
              ],
              [
                51.2312248,
                35.4907588
              ],
              [
                51.2267187,
                35.4899411
              ],
              [
                51.2154014,
                35.4850004
              ],
              [
                51.2138307,
                35.4842875
              ],
              [
                51.2133158,
                35.4846649
              ],
              [
                51.2113634,
                35.4847491
              ],
              [
                51.2106594,
                35.4845073
              ],
              [
                51.2096909,
                35.4823415
              ],
              [
                51.2100428,
                35.4808944
              ],
              [
                51.210921,
                35.4802006
              ],
              [
                51.2119596,
                35.478911
              ],
              [
                51.2132986,
                35.4784916
              ],
              [
                51.2145345,
                35.4780722
              ],
              [
                51.2161052,
                35.4768141
              ],
              [
                51.216543,
                35.4754511
              ],
              [
                51.2172897,
                35.4745075
              ],
              [
                51.2192724,
                35.4731864
              ],
              [
                51.2197359,
                35.4718443
              ],
              [
                51.2195814,
                35.4712572
              ],
              [
                51.2204311,
                35.470649
              ],
              [
                51.2214096,
                35.4698521
              ],
              [
                51.2216413,
                35.4689085
              ],
              [
                51.2217701,
                35.4683632
              ],
              [
                51.2233923,
                35.4674824
              ],
              [
                51.2242935,
                35.4665807
              ],
              [
                51.2241647,
                35.4652804
              ],
              [
                51.223109,
                35.4643367
              ],
              [
                51.223006,
                35.4636865
              ],
              [
                51.223006,
                35.4631412
              ],
              [
                51.2173927,
                35.4587998
              ],
              [
                51.2146375,
                35.456241
              ],
              [
                51.2116249,
                35.4528641
              ],
              [
                51.208947,
                35.4492353
              ],
              [
                51.2055223,
                35.4429842
              ],
              [
                51.2035911,
                35.4396067
              ],
              [
                51.2019689,
                35.4335856
              ],
              [
                51.2009647,
                35.4281096
              ],
              [
                51.2009647,
                35.4238293
              ],
              [
                51.2016599,
                35.4175132
              ],
              [
                51.2020977,
                35.4111128
              ],
              [
                51.2020462,
                35.4085734
              ],
              [
                51.2010935,
                35.4062649
              ],
              [
                51.200012,
                35.4049007
              ],
              [
                51.198776,
                35.4038933
              ],
              [
                51.1971796,
                35.4030118
              ],
              [
                51.1939867,
                35.4023192
              ],
              [
                51.191798,
                35.4052994
              ],
              [
                51.1914375,
                35.4056143
              ],
              [
                51.1915148,
                35.4121621
              ],
              [
                51.1914633,
                35.4136311
              ],
              [
                51.190253,
                35.4158135
              ],
              [
                51.1882627,
                35.4176181
              ],
              [
                51.186383,
                35.4186883
              ],
              [
                51.178066,
                35.4218778
              ],
              [
                51.1468322,
                35.4338373
              ],
              [
                51.1306617,
                35.4399003
              ],
              [
                51.1174266,
                35.4449979
              ],
              [
                51.1008184,
                35.4510182
              ],
              [
                51.086827,
                35.4561317
              ],
              [
                51.0686874,
                35.4427534
              ],
              [
                51.0654172,
                35.4391871
              ],
              [
                51.041419,
                35.4248364
              ],
              [
                51.0336942,
                35.4205978
              ],
              [
                51.030939,
                35.4189191
              ],
              [
                51.0296773,
                35.4185414
              ],
              [
                51.0267162,
                35.4183106
              ],
              [
                51.0241449,
                35.4182014
              ],
              [
                51.0236138,
                35.4183806
              ],
              [
                51.0225463,
                35.4185598
              ],
              [
                51.0217363,
                35.418538
              ],
              [
                51.0210872,
                35.418385
              ],
              [
                51.0202289,
                35.4185074
              ],
              [
                51.0193759,
                35.4184418
              ],
              [
                51.0185659,
                35.4188527
              ],
              [
                51.0176754,
                35.4192812
              ],
              [
                51.016522,
                35.4193948
              ],
              [
                51.0159266,
                35.4194167
              ],
              [
                51.015299,
                35.4193555
              ],
              [
                51.0141241,
                35.4194167
              ],
              [
                51.0133141,
                35.4199325
              ],
              [
                51.0125631,
                35.4203435
              ],
              [
                51.0116726,
                35.4206058
              ],
              [
                51.0111415,
                35.4209205
              ],
              [
                51.0104442,
                35.4210823
              ],
              [
                51.0092747,
                35.4210079
              ],
              [
                51.0081804,
                35.4210167
              ],
              [
                51.0069466,
                35.420785
              ],
              [
                51.0061473,
                35.4206014
              ],
              [
                51.0053962,
                35.4207325
              ],
              [
                51.004656,
                35.4209467
              ],
              [
                51.0042643,
                35.4211522
              ],
              [
                51.003862,
                35.4212877
              ],
              [
                51.0035777,
                35.4213183
              ],
              [
                51.0033363,
                35.421126
              ],
              [
                51.0032451,
                35.4208812
              ],
              [
                51.0030627,
                35.4207937
              ],
              [
                51.0028535,
                35.4208418
              ],
              [
                51.0023439,
                35.4210167
              ],
              [
                51.0019898,
                35.4209948
              ],
              [
                51.0016572,
                35.4208549
              ],
              [
                51.0013568,
                35.4208243
              ],
              [
                51.0007721,
                35.4209861
              ],
              [
                51.0004234,
                35.4212221
              ],
              [
                51.0004771,
                35.421467
              ],
              [
                51.0004288,
                35.4217249
              ],
              [
                51.0001552,
                35.4220003
              ],
              [
                50.9995329,
                35.421974
              ],
              [
                50.9989268,
                35.4224986
              ],
              [
                50.9991038,
                35.4227653
              ],
              [
                50.9990877,
                35.4230451
              ],
              [
                50.9988999,
                35.4232418
              ],
              [
                50.9986693,
                35.4235084
              ],
              [
                50.9986317,
                35.4237926
              ],
              [
                50.9987444,
                35.4241292
              ],
              [
                50.9985352,
                35.4244264
              ],
              [
                50.998165,
                35.4245313
              ],
              [
                50.9977734,
                35.4247892
              ],
              [
                50.9969419,
                35.4249379
              ],
              [
                50.9964484,
                35.425222
              ],
              [
                50.9953594,
                35.4258908
              ],
              [
                50.9946513,
                35.4259433
              ],
              [
                50.9936535,
                35.4264897
              ],
              [
                50.9922212,
                35.427294
              ],
              [
                50.9911269,
                35.4276437
              ],
              [
                50.9906763,
                35.4283911
              ],
              [
                50.9886485,
                35.428955
              ],
              [
                50.9879351,
                35.4300871
              ],
              [
                50.9874535,
                35.431082
              ],
              [
                50.9870673,
                35.4313181
              ],
              [
                50.9864933,
                35.4315891
              ],
              [
                50.9861017,
                35.4317377
              ],
              [
                50.9857369,
                35.4319256
              ],
              [
                50.9853453,
                35.4324021
              ],
              [
                50.9847928,
                35.4329528
              ],
              [
                50.9838326,
                35.4335997
              ],
              [
                50.9833176,
                35.4339756
              ],
              [
                50.9829743,
                35.4341679
              ],
              [
                50.9815366,
                35.434417
              ],
              [
                50.9808285,
                35.4346443
              ],
              [
                50.9800882,
                35.4350901
              ],
              [
                50.9795893,
                35.4354048
              ],
              [
                50.9789241,
                35.4354966
              ],
              [
                50.9785218,
                35.4355185
              ],
              [
                50.9782375,
                35.4353305
              ],
              [
                50.9777815,
                35.4350901
              ],
              [
                50.9770358,
                35.4350246
              ],
              [
                50.9766013,
                35.4352213
              ],
              [
                50.9761024,
                35.4356758
              ],
              [
                50.9758986,
                35.4357807
              ],
              [
                50.9755875,
                35.43589
              ],
              [
                50.9745253,
                35.436279
              ],
              [
                50.9737528,
                35.4366155
              ],
              [
                50.9732217,
                35.437057
              ],
              [
                50.9728543,
                35.4373301
              ],
              [
                50.9721462,
                35.437612
              ],
              [
                50.9716285,
                35.4377716
              ],
              [
                50.9712208,
                35.4377978
              ],
              [
                50.9706066,
                35.4378568
              ],
              [
                50.9701667,
                35.437918
              ],
              [
                50.9698663,
                35.4380316
              ],
              [
                50.9697241,
                35.4381715
              ],
              [
                50.9695337,
                35.4383922
              ],
              [
                50.9692548,
                35.438626
              ],
              [
                50.9689973,
                35.4388161
              ],
              [
                50.9687773,
                35.438921
              ],
              [
                50.9685198,
                35.4390216
              ],
              [
                50.9682462,
                35.439098
              ],
              [
                50.9680478,
                35.4391286
              ],
              [
                50.9679485,
                35.4390543
              ],
              [
                50.9678654,
                35.4389735
              ],
              [
                50.9677018,
                35.4389363
              ],
              [
                50.9674765,
                35.43898
              ],
              [
                50.9672941,
                35.4390434
              ],
              [
                50.9670258,
                35.4392095
              ],
              [
                50.9622033,
                35.436015
              ],
              [
                50.9615226,
                35.417188
              ],
              [
                50.9648257,
                35.3958463
              ],
              [
                50.9645489,
                35.3958463
              ],
              [
                50.9645489,
                35.3955667
              ],
              [
                50.9651057,
                35.3944576
              ],
              [
                50.9653824,
                35.394178
              ],
              [
                50.9583663,
                35.3861111
              ],
              [
                50.9484661,
                35.3819107
              ],
              [
                50.9473561,
                35.3794128
              ],
              [
                50.9067737,
                35.3247975
              ],
              [
                50.9048304,
                35.3211906
              ],
              [
                50.8933937,
                35.2998653
              ],
              [
                50.8844623,
                35.289215
              ],
              [
                50.8765358,
                35.2812332
              ],
              [
                50.8745891,
                35.2762396
              ],
              [
                50.8743124,
                35.2759602
              ],
              [
                50.8740358,
                35.2748425
              ],
              [
                50.8683626,
                35.2702844
              ],
              [
                50.8675294,
                35.2694552
              ],
              [
                50.8666959,
                35.2677876
              ],
              [
                50.8555604,
                35.2527998
              ],
              [
                50.8488812,
                35.2360305
              ],
              [
                50.8466885,
                35.2245462
              ],
              [
                50.8450219,
                35.2226081
              ],
              [
                50.8431728,
                35.2145523
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555104,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شمیرانات",
          "name:en": "Shemiranat County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1294509",
          "wikipedia": "fa:شهرستان شمیرانات"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.330981,
                35.792723
              ],
              [
                51.3328175,
                35.7877126
              ],
              [
                51.3333369,
                35.7861787
              ],
              [
                51.335776,
                35.7789421
              ],
              [
                51.3358869,
                35.7783696
              ],
              [
                51.3361234,
                35.7785036
              ],
              [
                51.3365717,
                35.7787604
              ],
              [
                51.3369625,
                35.7789354
              ],
              [
                51.3374012,
                35.7790008
              ],
              [
                51.3377665,
                35.7790688
              ],
              [
                51.3380805,
                35.7791913
              ],
              [
                51.3382698,
                35.7793517
              ],
              [
                51.338562,
                35.7794455
              ],
              [
                51.3390256,
                35.7796324
              ],
              [
                51.3402096,
                35.7801142
              ],
              [
                51.3404325,
                35.780417
              ],
              [
                51.3408418,
                35.7813911
              ],
              [
                51.3411679,
                35.7819923
              ],
              [
                51.3414207,
                35.7811741
              ],
              [
                51.3416085,
                35.7809391
              ],
              [
                51.3419169,
                35.7807433
              ],
              [
                51.3422522,
                35.7806018
              ],
              [
                51.3432044,
                35.7804299
              ],
              [
                51.343317,
                35.7811828
              ],
              [
                51.3434458,
                35.7816702
              ],
              [
                51.3437784,
                35.7822969
              ],
              [
                51.3445187,
                35.7831716
              ],
              [
                51.345098,
                35.7836634
              ],
              [
                51.3458008,
                35.7841203
              ],
              [
                51.3463855,
                35.7843901
              ],
              [
                51.347056,
                35.7845903
              ],
              [
                51.3477641,
                35.7847209
              ],
              [
                51.34844,
                35.7847861
              ],
              [
                51.3490945,
                35.7847687
              ],
              [
                51.3505644,
                35.7846251
              ],
              [
                51.3533056,
                35.7842509
              ],
              [
                51.3545501,
                35.7840463
              ],
              [
                51.3567012,
                35.7838984
              ],
              [
                51.3576937,
                35.7838853
              ],
              [
                51.3589328,
                35.783968
              ],
              [
                51.3602525,
                35.7841377
              ],
              [
                51.3610689,
                35.7842631
              ],
              [
                51.3626021,
                35.7846425
              ],
              [
                51.364021,
                35.7851473
              ],
              [
                51.3645843,
                35.7854215
              ],
              [
                51.3666844,
                35.7866269
              ],
              [
                51.3683474,
                35.787371
              ],
              [
                51.3698012,
                35.787817
              ],
              [
                51.3709679,
                35.7881304
              ],
              [
                51.3725156,
                35.7887091
              ],
              [
                51.3751924,
                35.790008
              ],
              [
                51.3761473,
                35.7904889
              ],
              [
                51.3770083,
                35.7907695
              ],
              [
                51.3779551,
                35.7909392
              ],
              [
                51.3806561,
                35.7913504
              ],
              [
                51.3820884,
                35.7916942
              ],
              [
                51.3846096,
                35.7924927
              ],
              [
                51.3851115,
                35.7926388
              ],
              [
                51.3856946,
                35.7927564
              ],
              [
                51.3863261,
                35.7928332
              ],
              [
                51.3870562,
                35.7928903
              ],
              [
                51.3874719,
                35.7928847
              ],
              [
                51.387787,
                35.7928651
              ],
              [
                51.3883449,
                35.7927889
              ],
              [
                51.3888841,
                35.7926976
              ],
              [
                51.3893846,
                35.7925525
              ],
              [
                51.3899105,
                35.7923524
              ],
              [
                51.3906235,
                35.7919383
              ],
              [
                51.3910835,
                35.791588
              ],
              [
                51.3915596,
                35.7911071
              ],
              [
                51.3920061,
                35.7904261
              ],
              [
                51.3922542,
                35.7897669
              ],
              [
                51.3925566,
                35.7901135
              ],
              [
                51.3932164,
                35.7906204
              ],
              [
                51.3936738,
                35.7908662
              ],
              [
                51.3942692,
                35.791099
              ],
              [
                51.3948191,
                35.7912687
              ],
              [
                51.3968763,
                35.7918496
              ],
              [
                51.3989738,
                35.7924675
              ],
              [
                51.3993042,
                35.7926066
              ],
              [
                51.3997688,
                35.7928107
              ],
              [
                51.4004704,
                35.7931115
              ],
              [
                51.4016104,
                35.7936315
              ],
              [
                51.4023775,
                35.7938099
              ],
              [
                51.4030374,
                35.7937903
              ],
              [
                51.4037187,
                35.7936337
              ],
              [
                51.4042604,
                35.793366
              ],
              [
                51.4055804,
                35.7925124
              ],
              [
                51.4060334,
                35.7922195
              ],
              [
                51.4068058,
                35.7919388
              ],
              [
                51.407286,
                35.7918822
              ],
              [
                51.4082542,
                35.7918932
              ],
              [
                51.4104992,
                35.7919475
              ],
              [
                51.4128515,
                35.7915538
              ],
              [
                51.4162543,
                35.7909153
              ],
              [
                51.4162755,
                35.7909102
              ],
              [
                51.4169232,
                35.7907531
              ],
              [
                51.4177171,
                35.7904811
              ],
              [
                51.418393,
                35.7901874
              ],
              [
                51.4191225,
                35.7897914
              ],
              [
                51.4200882,
                35.7889755
              ],
              [
                51.4208231,
                35.7880443
              ],
              [
                51.421727,
                35.7860643
              ],
              [
                51.4222366,
                35.7852397
              ],
              [
                51.4230161,
                35.7844137
              ],
              [
                51.4247284,
                35.7827179
              ],
              [
                51.426209,
                35.7810533
              ],
              [
                51.4272282,
                35.779641
              ],
              [
                51.4278159,
                35.7785087
              ],
              [
                51.428414,
                35.7788078
              ],
              [
                51.4303663,
                35.7794561
              ],
              [
                51.4310065,
                35.7796858
              ],
              [
                51.4316432,
                35.7799883
              ],
              [
                51.4325032,
                35.7805757
              ],
              [
                51.4329462,
                35.7809758
              ],
              [
                51.4336038,
                35.7816386
              ],
              [
                51.4344863,
                35.7826395
              ],
              [
                51.4350737,
                35.783203
              ],
              [
                51.4360861,
                35.7838755
              ],
              [
                51.4364175,
                35.7840506
              ],
              [
                51.4369016,
                35.7842246
              ],
              [
                51.43735,
                35.784333
              ],
              [
                51.4390045,
                35.784686
              ],
              [
                51.4405507,
                35.7849862
              ],
              [
                51.4428815,
                35.7854692
              ],
              [
                51.4459407,
                35.7863069
              ],
              [
                51.4481874,
                35.787099
              ],
              [
                51.4493484,
                35.7875613
              ],
              [
                51.451681,
                35.7886351
              ],
              [
                51.4541464,
                35.7900212
              ],
              [
                51.4560538,
                35.7911965
              ],
              [
                51.4574759,
                35.792088
              ],
              [
                51.4584894,
                35.7926024
              ],
              [
                51.4594124,
                35.7929648
              ],
              [
                51.460796,
                35.7932007
              ],
              [
                51.4618371,
                35.7931791
              ],
              [
                51.4630022,
                35.7930016
              ],
              [
                51.4653884,
                35.7922838
              ],
              [
                51.4662155,
                35.7920595
              ],
              [
                51.469823,
                35.791445
              ],
              [
                51.4725763,
                35.7906171
              ],
              [
                51.4733908,
                35.7904073
              ],
              [
                51.4741018,
                35.7902847
              ],
              [
                51.4756153,
                35.7901797
              ],
              [
                51.4764252,
                35.7902115
              ],
              [
                51.4767304,
                35.7902548
              ],
              [
                51.478909,
                35.790468
              ],
              [
                51.4794749,
                35.7904484
              ],
              [
                51.4806069,
                35.7902026
              ],
              [
                51.4837638,
                35.7888472
              ],
              [
                51.4844386,
                35.7885291
              ],
              [
                51.4847481,
                35.7883969
              ],
              [
                51.487472,
                35.7872523
              ],
              [
                51.4906155,
                35.7859349
              ],
              [
                51.4917461,
                35.7856792
              ],
              [
                51.4926463,
                35.7855955
              ],
              [
                51.4937407,
                35.7856652
              ],
              [
                51.4950184,
                35.7858359
              ],
              [
                51.4966921,
                35.7860708
              ],
              [
                51.4991329,
                35.7862797
              ],
              [
                51.5002486,
                35.7861578
              ],
              [
                51.5028128,
                35.7855181
              ],
              [
                51.5095828,
                35.7836643
              ],
              [
                51.5134827,
                35.7824284
              ],
              [
                51.5148881,
                35.7816755
              ],
              [
                51.5161917,
                35.780766
              ],
              [
                51.5189437,
                35.7787815
              ],
              [
                51.5193996,
                35.7785204
              ],
              [
                51.5205047,
                35.7780678
              ],
              [
                51.5217224,
                35.7775934
              ],
              [
                51.5226612,
                35.7775977
              ],
              [
                51.5265064,
                35.7773496
              ],
              [
                51.5272703,
                35.7773022
              ],
              [
                51.533931,
                35.7771111
              ],
              [
                51.5348971,
                35.7769599
              ],
              [
                51.5375469,
                35.7765465
              ],
              [
                51.5402378,
                35.7759741
              ],
              [
                51.5420491,
                35.7754283
              ],
              [
                51.5423923,
                35.7753249
              ],
              [
                51.5440098,
                35.774759
              ],
              [
                51.5442078,
                35.7746896
              ],
              [
                51.5476847,
                35.7734719
              ],
              [
                51.5510466,
                35.7723006
              ],
              [
                51.5541673,
                35.7712032
              ],
              [
                51.5562193,
                35.7704852
              ],
              [
                51.5572543,
                35.7701237
              ],
              [
                51.5600394,
                35.7752424
              ],
              [
                51.5630005,
                35.780639
              ],
              [
                51.5641491,
                35.7819999
              ],
              [
                51.5657682,
                35.7855899
              ],
              [
                51.5673351,
                35.7841203
              ],
              [
                51.5696524,
                35.7796293
              ],
              [
                51.5721877,
                35.7736796
              ],
              [
                51.5762823,
                35.7748038
              ],
              [
                51.5811497,
                35.7753036
              ],
              [
                51.5892218,
                35.7784804
              ],
              [
                51.5938136,
                35.7815094
              ],
              [
                51.6008947,
                35.7890987
              ],
              [
                51.6081047,
                35.7917094
              ],
              [
                51.6154001,
                35.7919184
              ],
              [
                51.6222806,
                35.790284
              ],
              [
                51.6345404,
                35.7844686
              ],
              [
                51.6461705,
                35.7787241
              ],
              [
                51.6504191,
                35.780604
              ],
              [
                51.6549681,
                35.7850256
              ],
              [
                51.659045,
                35.7884024
              ],
              [
                51.6659544,
                35.7910829
              ],
              [
                51.6681217,
                35.7897253
              ],
              [
                51.6755461,
                35.7891856
              ],
              [
                51.6765547,
                35.7883849
              ],
              [
                51.6769409,
                35.7875494
              ],
              [
                51.6777992,
                35.7869924
              ],
              [
                51.6776007,
                35.7863179
              ],
              [
                51.6782282,
                35.7856349
              ],
              [
                51.6794727,
                35.7828498
              ],
              [
                51.6812968,
                35.7784106
              ],
              [
                51.6820264,
                35.7780973
              ],
              [
                51.6837644,
                35.7783758
              ],
              [
                51.6843866,
                35.7773488
              ],
              [
                51.6846442,
                35.7764783
              ],
              [
                51.6867685,
                35.7766001
              ],
              [
                51.687691,
                35.7770703
              ],
              [
                51.6880773,
                35.7790375
              ],
              [
                51.6877983,
                35.7800645
              ],
              [
                51.6865325,
                35.7812307
              ],
              [
                51.6871118,
                35.7829715
              ],
              [
                51.6876483,
                35.7832674
              ],
              [
                51.6881847,
                35.7843292
              ],
              [
                51.6888928,
                35.7849036
              ],
              [
                51.6906521,
                35.7855478
              ],
              [
                51.6932701,
                35.7855478
              ],
              [
                51.6965101,
                35.7828845
              ],
              [
                51.6968751,
                35.7811263
              ],
              [
                51.6970682,
                35.7790721
              ],
              [
                51.6976797,
                35.777192
              ],
              [
                51.6988921,
                35.7751639
              ],
              [
                51.6993103,
                35.7750682
              ],
              [
                51.699246,
                35.773939
              ],
              [
                51.7025346,
                35.7759434
              ],
              [
                51.7044498,
                35.776489
              ],
              [
                51.706205,
                35.776472
              ],
              [
                51.7097528,
                35.7765918
              ],
              [
                51.7150804,
                35.7765622
              ],
              [
                51.7179564,
                35.7768226
              ],
              [
                51.7201873,
                35.7779375
              ],
              [
                51.7216683,
                35.7778619
              ],
              [
                51.7245938,
                35.7776896
              ],
              [
                51.7311289,
                35.7773352
              ],
              [
                51.7421722,
                35.7757645
              ],
              [
                51.7500686,
                35.7741977
              ],
              [
                51.7538023,
                35.7741281
              ],
              [
                51.7560387,
                35.7741903
              ],
              [
                51.7522144,
                35.7767568
              ],
              [
                51.7518282,
                35.7821881
              ],
              [
                51.7533302,
                35.7843814
              ],
              [
                51.7543816,
                35.7848689
              ],
              [
                51.7559051,
                35.7843466
              ],
              [
                51.7561841,
                35.7829018
              ],
              [
                51.761055,
                35.7800296
              ],
              [
                51.7629861,
                35.7793855
              ],
              [
                51.7687583,
                35.780134
              ],
              [
                51.7788219,
                35.778341
              ],
              [
                51.7831349,
                35.7795074
              ],
              [
                51.7895078,
                35.7776447
              ],
              [
                51.7904305,
                35.7752858
              ],
              [
                51.7906129,
                35.7724829
              ],
              [
                51.7923403,
                35.7715341
              ],
              [
                51.7928552,
                35.767582
              ],
              [
                51.7962884,
                35.7654578
              ],
              [
                51.7966317,
                35.7630899
              ],
              [
                51.7995071,
                35.760304
              ],
              [
                51.8001166,
                35.7606505
              ],
              [
                51.8002453,
                35.7610475
              ],
              [
                51.8004771,
                35.7615072
              ],
              [
                51.8007346,
                35.7615072
              ],
              [
                51.8010436,
                35.7611519
              ],
              [
                51.8024083,
                35.7606714
              ],
              [
                51.8068886,
                35.7614863
              ],
              [
                51.8082791,
                35.761925
              ],
              [
                51.8118325,
                35.7628862
              ],
              [
                51.8127595,
                35.7632414
              ],
              [
                51.8135319,
                35.7633458
              ],
              [
                51.8141757,
                35.7634921
              ],
              [
                51.8151026,
                35.7639518
              ],
              [
                51.8148709,
                35.7643487
              ],
              [
                51.8143559,
                35.7645577
              ],
              [
                51.8147679,
                35.764892
              ],
              [
                51.8152056,
                35.7651636
              ],
              [
                51.8160554,
                35.7656859
              ],
              [
                51.8167763,
                35.7661665
              ],
              [
                51.8173428,
                35.7663963
              ],
              [
                51.8181925,
                35.7668141
              ],
              [
                51.818244,
                35.7672529
              ],
              [
                51.8188363,
                35.7677125
              ],
              [
                51.8192225,
                35.7678379
              ],
              [
                51.8199692,
                35.7678588
              ],
              [
                51.8203812,
                35.7682766
              ],
              [
                51.8201495,
                35.7693839
              ],
              [
                51.8201998,
                35.7725357
              ],
              [
                51.8207753,
                35.775422
              ],
              [
                51.8255568,
                35.7780625
              ],
              [
                51.8281214,
                35.7821808
              ],
              [
                51.8309277,
                35.7862622
              ],
              [
                51.833094,
                35.7890893
              ],
              [
                51.8349123,
                35.7886982
              ],
              [
                51.8401694,
                35.7830585
              ],
              [
                51.8416398,
                35.7823038
              ],
              [
                51.8443417,
                35.7858083
              ],
              [
                51.8471183,
                35.7891436
              ],
              [
                51.8529515,
                35.8002582
              ],
              [
                51.8551749,
                35.8030346
              ],
              [
                51.8679547,
                35.8324835
              ],
              [
                51.8701745,
                35.8377567
              ],
              [
                51.8718412,
                35.8427594
              ],
              [
                51.873788,
                35.8466443
              ],
              [
                51.8776745,
                35.858876
              ],
              [
                51.8776745,
                35.8599847
              ],
              [
                51.8776744,
                35.8605858
              ],
              [
                51.8607314,
                35.8788772
              ],
              [
                51.8573981,
                35.8855381
              ],
              [
                51.8573981,
                35.886088
              ],
              [
                51.8507316,
                35.9005364
              ],
              [
                51.8473982,
                35.9049799
              ],
              [
                51.8291354,
                35.9346017
              ],
              [
                51.8246184,
                35.9419245
              ],
              [
                51.8143384,
                35.9524786
              ],
              [
                51.7798922,
                35.9808143
              ],
              [
                51.7698922,
                36.0002271
              ],
              [
                51.760449,
                36.0066529
              ],
              [
                51.7285028,
                36.0261011
              ],
              [
                51.7274191,
                36.0266362
              ],
              [
                51.7154463,
                36.0330404
              ],
              [
                51.7145335,
                36.0334998
              ],
              [
                51.7071128,
                36.0369336
              ],
              [
                51.699613,
                36.0397092
              ],
              [
                51.6934997,
                36.0427643
              ],
              [
                51.6548867,
                36.0597065
              ],
              [
                51.653777,
                36.0602653
              ],
              [
                51.5990507,
                36.0835963
              ],
              [
                51.598494,
                36.084155
              ],
              [
                51.5979408,
                36.084155
              ],
              [
                51.5943274,
                36.0860924
              ],
              [
                51.5865508,
                36.0902648
              ],
              [
                51.5729376,
                36.0949868
              ],
              [
                51.5581069,
                36.1003115
              ],
              [
                51.5527438,
                36.1016137
              ],
              [
                51.5380668,
                36.0907945
              ],
              [
                51.5242488,
                36.0792001
              ],
              [
                51.5074585,
                36.0639025
              ],
              [
                51.5019194,
                36.0602148
              ],
              [
                51.4997068,
                36.0599459
              ],
              [
                51.4972339,
                36.0583245
              ],
              [
                51.4917255,
                36.054211
              ],
              [
                51.4918105,
                36.0535754
              ],
              [
                51.4859965,
                36.0486349
              ],
              [
                51.4682373,
                36.0286934
              ],
              [
                51.4682487,
                36.0286479
              ],
              [
                51.464424,
                36.0243905
              ],
              [
                51.459391,
                36.0233815
              ],
              [
                51.459389,
                36.0233755
              ],
              [
                51.4558891,
                36.0194846
              ],
              [
                51.4508104,
                36.0128413
              ],
              [
                51.4508193,
                36.0128169
              ],
              [
                51.4449159,
                36.0053379
              ],
              [
                51.437264,
                35.9993626
              ],
              [
                51.4334394,
                35.9971348
              ],
              [
                51.4324276,
                35.9953988
              ],
              [
                51.4281661,
                35.9902778
              ],
              [
                51.4122623,
                35.9677832
              ],
              [
                51.4075587,
                35.9597271
              ],
              [
                51.407046,
                35.9587478
              ],
              [
                51.4050718,
                35.955836
              ],
              [
                51.4026685,
                35.9505595
              ],
              [
                51.4026685,
                35.9504887
              ],
              [
                51.3988614,
                35.9427845
              ],
              [
                51.3954812,
                35.9363812
              ],
              [
                51.3925405,
                35.9315233
              ],
              [
                51.387189,
                35.9263349
              ],
              [
                51.3770218,
                35.9211929
              ],
              [
                51.3718985,
                35.9146353
              ],
              [
                51.3663045,
                35.8926172
              ],
              [
                51.3660877,
                35.8924053
              ],
              [
                51.3660263,
                35.8923483
              ],
              [
                51.3660535,
                35.881783
              ],
              [
                51.362074,
                35.8680054
              ],
              [
                51.3611619,
                35.8601886
              ],
              [
                51.3604782,
                35.8545108
              ],
              [
                51.3584451,
                35.8428461
              ],
              [
                51.3578918,
                35.841458
              ],
              [
                51.3552212,
                35.8324419
              ],
              [
                51.3552149,
                35.8324304
              ],
              [
                51.3510847,
                35.8251207
              ],
              [
                51.3516426,
                35.8239724
              ],
              [
                51.3527154,
                35.8232417
              ],
              [
                51.3523292,
                35.8212234
              ],
              [
                51.3491549,
                35.813096
              ],
              [
                51.3397198,
                35.8084458
              ],
              [
                51.339714,
                35.8084326
              ],
              [
                51.3396662,
                35.8083484
              ],
              [
                51.3395898,
                35.808116
              ],
              [
                51.3395338,
                35.8081713
              ],
              [
                51.3389761,
                35.8085424
              ],
              [
                51.3388522,
                35.8087154
              ],
              [
                51.3385325,
                35.8089244
              ],
              [
                51.3385339,
                35.8092092
              ],
              [
                51.3382757,
                35.8100343
              ],
              [
                51.3379518,
                35.809996
              ],
              [
                51.3377946,
                35.8089719
              ],
              [
                51.3373959,
                35.8087425
              ],
              [
                51.3371967,
                35.8084962
              ],
              [
                51.3371841,
                35.8082684
              ],
              [
                51.3372723,
                35.8080055
              ],
              [
                51.3374722,
                35.8076995
              ],
              [
                51.3375911,
                35.8076776
              ],
              [
                51.337657,
                35.8076056
              ],
              [
                51.3376686,
                35.807232
              ],
              [
                51.3378655,
                35.8068544
              ],
              [
                51.3379372,
                35.8049108
              ],
              [
                51.3377469,
                35.804895
              ],
              [
                51.3375218,
                35.8047045
              ],
              [
                51.3374263,
                35.8045587
              ],
              [
                51.3372458,
                35.8042831
              ],
              [
                51.3372174,
                35.8042397
              ],
              [
                51.3371256,
                35.803864
              ],
              [
                51.3372597,
                35.803468
              ],
              [
                51.3375022,
                35.8029947
              ],
              [
                51.3378683,
                35.8028808
              ],
              [
                51.3382434,
                35.8026885
              ],
              [
                51.3384029,
                35.8025441
              ],
              [
                51.3384066,
                35.8024308
              ],
              [
                51.3382975,
                35.8022525
              ],
              [
                51.3376848,
                35.801721
              ],
              [
                51.3373612,
                35.8007144
              ],
              [
                51.3372759,
                35.8006218
              ],
              [
                51.3366649,
                35.8002751
              ],
              [
                51.3366643,
                35.8001616
              ],
              [
                51.3365152,
                35.7998884
              ],
              [
                51.3365022,
                35.7996537
              ],
              [
                51.3362226,
                35.7992913
              ],
              [
                51.3360001,
                35.7991279
              ],
              [
                51.3356916,
                35.7985973
              ],
              [
                51.3356239,
                35.7985683
              ],
              [
                51.3356216,
                35.7981929
              ],
              [
                51.3354787,
                35.7980602
              ],
              [
                51.3357239,
                35.7980719
              ],
              [
                51.3360285,
                35.7982237
              ],
              [
                51.3367844,
                35.7981718
              ],
              [
                51.3371385,
                35.7980793
              ],
              [
                51.3367653,
                35.7974635
              ],
              [
                51.3365972,
                35.7969291
              ],
              [
                51.3363018,
                35.7964548
              ],
              [
                51.3362804,
                35.7961887
              ],
              [
                51.3361829,
                35.7960428
              ],
              [
                51.3359827,
                35.7958889
              ],
              [
                51.335919,
                35.7956627
              ],
              [
                51.3361271,
                35.7947658
              ],
              [
                51.3360087,
                35.7944346
              ],
              [
                51.3360084,
                35.7942
              ],
              [
                51.3358633,
                35.7935404
              ],
              [
                51.3357093,
                35.7935051
              ],
              [
                51.3352211,
                35.7937391
              ],
              [
                51.3345463,
                35.79352
              ],
              [
                51.334423,
                35.7934471
              ],
              [
                51.3343531,
                35.7930652
              ],
              [
                51.334094,
                35.7929584
              ],
              [
                51.3340554,
                35.7928896
              ],
              [
                51.3340194,
                35.7924398
              ],
              [
                51.3334739,
                35.7923166
              ],
              [
                51.3332624,
                35.7922079
              ],
              [
                51.3331385,
                35.7920733
              ],
              [
                51.3326829,
                35.7918993
              ],
              [
                51.3322938,
                35.7920999
              ],
              [
                51.3318478,
                35.7922171
              ],
              [
                51.3316725,
                35.7924974
              ],
              [
                51.331444,
                35.7925933
              ],
              [
                51.3313518,
                35.7927613
              ],
              [
                51.330981,
                35.792723
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555108,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شهریار",
          "name:en": "Shahriar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282170",
          "wikipedia": "fa:شهرستان شهریار"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.8401239,
                35.573138
              ],
              [
                50.8401239,
                35.5729024
              ],
              [
                50.8399737,
                35.5727191
              ],
              [
                50.839684,
                35.5724923
              ],
              [
                50.8383965,
                35.5723352
              ],
              [
                50.8374524,
                35.5716283
              ],
              [
                50.8367336,
                35.5710436
              ],
              [
                50.8363902,
                35.5703804
              ],
              [
                50.8362937,
                35.5697608
              ],
              [
                50.8365351,
                35.5694597
              ],
              [
                50.8368248,
                35.569259
              ],
              [
                50.8374792,
                35.5691455
              ],
              [
                50.8378601,
                35.5689317
              ],
              [
                50.8382249,
                35.5685826
              ],
              [
                50.8384073,
                35.5682248
              ],
              [
                50.8381069,
                35.5676663
              ],
              [
                50.8386218,
                35.5665579
              ],
              [
                50.8387935,
                35.5661128
              ],
              [
                50.8385789,
                35.5653361
              ],
              [
                50.838359,
                35.5644546
              ],
              [
                50.8383322,
                35.5636299
              ],
              [
                50.8383322,
                35.5632851
              ],
              [
                50.8381712,
                35.5630364
              ],
              [
                50.8379245,
                35.5628837
              ],
              [
                50.8372861,
                35.5627615
              ],
              [
                50.8369911,
                35.5626393
              ],
              [
                50.8367979,
                35.5624647
              ],
              [
                50.8366853,
                35.5621593
              ],
              [
                50.8368945,
                35.5618276
              ],
              [
                50.8371627,
                35.5609854
              ],
              [
                50.8374578,
                35.5601737
              ],
              [
                50.8374739,
                35.5597111
              ],
              [
                50.8373666,
                35.5594187
              ],
              [
                50.8371627,
                35.5592354
              ],
              [
                50.8367497,
                35.5591481
              ],
              [
                50.8358699,
                35.5591132
              ],
              [
                50.8351672,
                35.5589648
              ],
              [
                50.8349526,
                35.5587816
              ],
              [
                50.8348829,
                35.5584499
              ],
              [
                50.8349848,
                35.5579262
              ],
              [
                50.8350384,
                35.5571057
              ],
              [
                50.8349633,
                35.556713
              ],
              [
                50.8345771,
                35.5562329
              ],
              [
                50.8341265,
                35.5555172
              ],
              [
                50.834046,
                35.5552291
              ],
              [
                50.8339387,
                35.5547883
              ],
              [
                50.8339816,
                35.5545658
              ],
              [
                50.8342767,
                35.5543519
              ],
              [
                50.8346683,
                35.5542734
              ],
              [
                50.8351242,
                35.5543476
              ],
              [
                50.835591,
                35.5545614
              ],
              [
                50.8359396,
                35.5546225
              ],
              [
                50.8365673,
                35.5545941
              ],
              [
                50.8372271,
                35.5544436
              ],
              [
                50.8375329,
                35.5542559
              ],
              [
                50.8377582,
                35.553994
              ],
              [
                50.8378118,
                35.5536362
              ],
              [
                50.8377796,
                35.5532914
              ],
              [
                50.8379406,
                35.5530077
              ],
              [
                50.8382571,
                35.5528375
              ],
              [
                50.8390725,
                35.5526498
              ],
              [
                50.8399039,
                35.5524185
              ],
              [
                50.8401507,
                35.5522177
              ],
              [
                50.8402151,
                35.551921
              ],
              [
                50.8401453,
                35.5517595
              ],
              [
                50.8399254,
                35.551694
              ],
              [
                50.8397001,
                35.5517202
              ],
              [
                50.8395177,
                35.5516329
              ],
              [
                50.8393568,
                35.5513841
              ],
              [
                50.8390725,
                35.5506204
              ],
              [
                50.8391476,
                35.5501926
              ],
              [
                50.8394694,
                35.5499133
              ],
              [
                50.8400059,
                35.5495903
              ],
              [
                50.8402204,
                35.5493197
              ],
              [
                50.8403345,
                35.5490331
              ],
              [
                50.8392441,
                35.5470152
              ],
              [
                50.8388699,
                35.5467052
              ],
              [
                50.8386058,
                35.5466791
              ],
              [
                50.8370233,
                35.5470676
              ],
              [
                50.8360952,
                35.5471854
              ],
              [
                50.835452,
                35.5470854
              ],
              [
                50.8351672,
                35.5467009
              ],
              [
                50.8351457,
                35.546247
              ],
              [
                50.8354032,
                35.5450598
              ],
              [
                50.8352423,
                35.5443356
              ],
              [
                50.8342715,
                35.5422015
              ],
              [
                50.8344248,
                35.540691
              ],
              [
                50.8332326,
                35.5390695
              ],
              [
                50.8332662,
                35.5385628
              ],
              [
                50.8338153,
                35.5374036
              ],
              [
                50.8343296,
                35.5364683
              ],
              [
                50.8355641,
                35.5360852
              ],
              [
                50.8386314,
                35.534801
              ],
              [
                50.8393568,
                35.5349197
              ],
              [
                50.8397494,
                35.5348077
              ],
              [
                50.8400807,
                35.5343768
              ],
              [
                50.8402466,
                35.5335053
              ],
              [
                50.8427189,
                35.5278573
              ],
              [
                50.843366,
                35.5246832
              ],
              [
                50.842804,
                35.5218694
              ],
              [
                50.842804,
                35.5198456
              ],
              [
                50.8442005,
                35.5187644
              ],
              [
                50.8484924,
                35.5173643
              ],
              [
                50.8516771,
                35.5124431
              ],
              [
                50.8564458,
                35.5036812
              ],
              [
                50.8663749,
                35.4978717
              ],
              [
                50.8709221,
                35.4974558
              ],
              [
                50.877139,
                35.4942422
              ],
              [
                50.8818732,
                35.4926956
              ],
              [
                50.8844644,
                35.4911489
              ],
              [
                50.8898306,
                35.4976964
              ],
              [
                50.8924269,
                35.5008409
              ],
              [
                50.8926201,
                35.5018541
              ],
              [
                50.8944225,
                35.5040027
              ],
              [
                50.8957682,
                35.5048323
              ],
              [
                50.9063744,
                35.5116883
              ],
              [
                50.9131121,
                35.5169106
              ],
              [
                50.9194214,
                35.5218108
              ],
              [
                50.9229161,
                35.5245343
              ],
              [
                50.9291266,
                35.529275
              ],
              [
                50.9349346,
                35.5326104
              ],
              [
                50.9405677,
                35.5371792
              ],
              [
                50.9430519,
                35.5392397
              ],
              [
                50.9522084,
                35.5451329
              ],
              [
                50.9660987,
                35.5521685
              ],
              [
                50.975746,
                35.5557717
              ],
              [
                50.9781503,
                35.5539112
              ],
              [
                50.9829613,
                35.5558256
              ],
              [
                50.9816265,
                35.5572978
              ],
              [
                50.9836006,
                35.558799
              ],
              [
                50.9855318,
                35.5588689
              ],
              [
                50.9947586,
                35.560789
              ],
              [
                51.0085989,
                35.563206
              ],
              [
                51.012899,
                35.5656287
              ],
              [
                51.0158085,
                35.5615745
              ],
              [
                51.0157227,
                35.5613039
              ],
              [
                51.0160017,
                35.560405
              ],
              [
                51.0166991,
                35.5596107
              ],
              [
                51.0179651,
                35.5584673
              ],
              [
                51.018523,
                35.5578651
              ],
              [
                51.0204434,
                35.559122
              ],
              [
                51.021527,
                35.5599773
              ],
              [
                51.0237425,
                35.5589387
              ],
              [
                51.0243916,
                35.5588776
              ],
              [
                51.0251748,
                35.5582404
              ],
              [
                51.0289299,
                35.5607279
              ],
              [
                51.0279408,
                35.5651086
              ],
              [
                51.0268592,
                35.5678758
              ],
              [
                51.0287475,
                35.5691325
              ],
              [
                51.0278892,
                35.5707731
              ],
              [
                51.0328082,
                35.5735904
              ],
              [
                51.0358071,
                35.5754942
              ],
              [
                51.0372018,
                35.5733082
              ],
              [
                51.0374325,
                35.5731707
              ],
              [
                51.0376914,
                35.573054
              ],
              [
                51.0379797,
                35.5730071
              ],
              [
                51.0380709,
                35.5730682
              ],
              [
                51.0381903,
                35.5730813
              ],
              [
                51.0382828,
                35.5730148
              ],
              [
                51.0385618,
                35.572693
              ],
              [
                51.0386825,
                35.5726177
              ],
              [
                51.0389614,
                35.572261
              ],
              [
                51.0394549,
                35.5723723
              ],
              [
                51.0396051,
                35.572429
              ],
              [
                51.0401121,
                35.57297
              ],
              [
                51.0403749,
                35.573234
              ],
              [
                51.0404488,
                35.5734807
              ],
              [
                51.0405868,
                35.5736747
              ],
              [
                51.0446038,
                35.5709965
              ],
              [
                51.0454105,
                35.5703367
              ],
              [
                51.0460424,
                35.5702495
              ],
              [
                51.045506,
                35.5684866
              ],
              [
                51.0455704,
                35.5663223
              ],
              [
                51.0453772,
                35.5660779
              ],
              [
                51.0454201,
                35.5653274
              ],
              [
                51.0444975,
                35.5645768
              ],
              [
                51.0456133,
                35.5637041
              ],
              [
                51.0457217,
                35.5632973
              ],
              [
                51.0475981,
                35.5608676
              ],
              [
                51.0499316,
                35.5611573
              ],
              [
                51.0563325,
                35.563355
              ],
              [
                51.0584612,
                35.5634736
              ],
              [
                51.0634993,
                35.5657846
              ],
              [
                51.067028,
                35.5617665
              ],
              [
                51.0695171,
                35.5590434
              ],
              [
                51.0699892,
                35.556006
              ],
              [
                51.0707187,
                35.5533874
              ],
              [
                51.0711479,
                35.5501054
              ],
              [
                51.0753536,
                35.5532827
              ],
              [
                51.0823478,
                35.556184
              ],
              [
                51.0833578,
                35.5569586
              ],
              [
                51.0869836,
                35.5520607
              ],
              [
                51.0897302,
                35.5486389
              ],
              [
                51.0899448,
                35.5468581
              ],
              [
                51.0901379,
                35.5457931
              ],
              [
                51.0906535,
                35.5447953
              ],
              [
                51.0946875,
                35.5475049
              ],
              [
                51.0945046,
                35.5477397
              ],
              [
                51.0955667,
                35.5484206
              ],
              [
                51.0963607,
                35.5489531
              ],
              [
                51.0960925,
                35.5493285
              ],
              [
                51.0974872,
                35.5502625
              ],
              [
                51.0977018,
                35.5500966
              ],
              [
                51.0999145,
                35.5516322
              ],
              [
                51.0995471,
                35.5521043
              ],
              [
                51.1000246,
                35.5523705
              ],
              [
                51.1003089,
                35.5521828
              ],
              [
                51.1012101,
                35.5526847
              ],
              [
                51.1009633,
                35.5529684
              ],
              [
                51.1014086,
                35.5532914
              ],
              [
                51.102739,
                35.5517333
              ],
              [
                51.1032003,
                35.5517071
              ],
              [
                51.1042779,
                35.5511495
              ],
              [
                51.1057714,
                35.5498576
              ],
              [
                51.1086529,
                35.549087
              ],
              [
                51.1092089,
                35.5487508
              ],
              [
                51.1109813,
                35.5469176
              ],
              [
                51.1123203,
                35.5462053
              ],
              [
                51.1136592,
                35.5464567
              ],
              [
                51.1181869,
                35.5492009
              ],
              [
                51.1209053,
                35.5505595
              ],
              [
                51.1234333,
                35.5516631
              ],
              [
                51.1251327,
                35.5539256
              ],
              [
                51.1251328,
                35.5569212
              ],
              [
                51.1285059,
                35.5636452
              ],
              [
                51.1296232,
                35.5662976
              ],
              [
                51.1322238,
                35.5703818
              ],
              [
                51.1375282,
                35.5704028
              ],
              [
                51.1385324,
                35.5713662
              ],
              [
                51.141547,
                35.5733438
              ],
              [
                51.1457486,
                35.5757304
              ],
              [
                51.147285,
                35.5763654
              ],
              [
                51.1552693,
                35.5799973
              ],
              [
                51.1577614,
                35.5814858
              ],
              [
                51.1595167,
                35.58475
              ],
              [
                51.1600505,
                35.5853473
              ],
              [
                51.1656453,
                35.5880415
              ],
              [
                51.164676,
                35.5904305
              ],
              [
                51.1670675,
                35.5914155
              ],
              [
                51.1699227,
                35.593496
              ],
              [
                51.1745408,
                35.595284
              ],
              [
                51.1804765,
                35.5985047
              ],
              [
                51.1797406,
                35.6041181
              ],
              [
                51.1783619,
                35.6114884
              ],
              [
                51.1770863,
                35.6183065
              ],
              [
                51.1768096,
                35.6213629
              ],
              [
                51.176533,
                35.6230308
              ],
              [
                51.1759763,
                35.6258076
              ],
              [
                51.1758334,
                35.6272096
              ],
              [
                51.1756996,
                35.6274756
              ],
              [
                51.1759764,
                35.6324703
              ],
              [
                51.1762127,
                35.6331386
              ],
              [
                51.1780142,
                35.6365225
              ],
              [
                51.1740304,
                35.6394396
              ],
              [
                51.1658813,
                35.6462888
              ],
              [
                51.1707703,
                35.6510381
              ],
              [
                51.174573,
                35.648848
              ],
              [
                51.1784499,
                35.6468982
              ],
              [
                51.1902747,
                35.658467
              ],
              [
                51.2056444,
                35.6492807
              ],
              [
                51.2094619,
                35.6469237
              ],
              [
                51.2126653,
                35.6449458
              ],
              [
                51.213528,
                35.6474847
              ],
              [
                51.2143519,
                35.6500793
              ],
              [
                51.2190006,
                35.6494153
              ],
              [
                51.2216647,
                35.6489912
              ],
              [
                51.2276166,
                35.640082
              ],
              [
                51.2314018,
                35.6401447
              ],
              [
                51.2337192,
                35.642614
              ],
              [
                51.238972,
                35.6446228
              ],
              [
                51.249246,
                35.6459202
              ],
              [
                51.2516963,
                35.6578264
              ],
              [
                51.2508769,
                35.6581253
              ],
              [
                51.2447822,
                35.6603235
              ],
              [
                51.242308,
                35.6612621
              ],
              [
                51.2412419,
                35.6616891
              ],
              [
                51.2402994,
                35.6621211
              ],
              [
                51.2395868,
                35.6624667
              ],
              [
                51.2392877,
                35.6626345
              ],
              [
                51.2383636,
                35.6631916
              ],
              [
                51.2372897,
                35.6638721
              ],
              [
                51.236646,
                35.6643844
              ],
              [
                51.2358832,
                35.6649989
              ],
              [
                51.2350687,
                35.6657662
              ],
              [
                51.2341972,
                35.6666741
              ],
              [
                51.2335058,
                35.6675157
              ],
              [
                51.2334019,
                35.6676585
              ],
              [
                51.2331313,
                35.6680032
              ],
              [
                51.2326998,
                35.6686264
              ],
              [
                51.2320761,
                35.6696861
              ],
              [
                51.2317087,
                35.670428
              ],
              [
                51.23142,
                35.6711332
              ],
              [
                51.2309855,
                35.6723432
              ],
              [
                51.2308018,
                35.6731431
              ],
              [
                51.2305865,
                35.6743931
              ],
              [
                51.2305214,
                35.675191
              ],
              [
                51.2304534,
                35.6768611
              ],
              [
                51.2304643,
                35.6775739
              ],
              [
                51.2308185,
                35.6793187
              ],
              [
                51.2316008,
                35.6807271
              ],
              [
                51.2325182,
                35.6820743
              ],
              [
                51.2333501,
                35.683573
              ],
              [
                51.2306453,
                35.6840225
              ],
              [
                51.2277997,
                35.6845832
              ],
              [
                51.2276385,
                35.6855387
              ],
              [
                51.2262811,
                35.6860687
              ],
              [
                51.2256686,
                35.6862743
              ],
              [
                51.2245961,
                35.6866969
              ],
              [
                51.2235382,
                35.6871052
              ],
              [
                51.2214286,
                35.6869942
              ],
              [
                51.2201504,
                35.6883711
              ],
              [
                51.220004,
                35.6885288
              ],
              [
                51.2175907,
                35.6895566
              ],
              [
                51.2164431,
                35.6899889
              ],
              [
                51.2127514,
                35.6913353
              ],
              [
                51.2102014,
                35.6923785
              ],
              [
                51.206433,
                35.6939424
              ],
              [
                51.2020826,
                35.6956827
              ],
              [
                51.1966753,
                35.6978452
              ],
              [
                51.184414,
                35.6844569
              ],
              [
                51.179552,
                35.6797142
              ],
              [
                51.1653578,
                35.6884984
              ],
              [
                51.163727,
                35.685797
              ],
              [
                51.1613774,
                35.685187
              ],
              [
                51.1591154,
                35.6815724
              ],
              [
                51.1717414,
                35.6729163
              ],
              [
                51.1677028,
                35.6681418
              ],
              [
                51.1670076,
                35.6664265
              ],
              [
                51.1668531,
                35.6658407
              ],
              [
                51.1647931,
                35.6632467
              ],
              [
                51.1641237,
                35.6623471
              ],
              [
                51.1627589,
                35.6616149
              ],
              [
                51.1504426,
                35.6651427
              ],
              [
                51.1447797,
                35.6672074
              ],
              [
                51.1411081,
                35.6682179
              ],
              [
                51.122417,
                35.6743642
              ],
              [
                51.1209236,
                35.6749499
              ],
              [
                51.1203828,
                35.675682
              ],
              [
                51.1192241,
                35.6768115
              ],
              [
                51.1195331,
                35.6774181
              ],
              [
                51.1201253,
                35.6778573
              ],
              [
                51.1203056,
                35.6787358
              ],
              [
                51.1201192,
                35.6800999
              ],
              [
                51.1195295,
                35.6799293
              ],
              [
                51.1189458,
                35.6798214
              ],
              [
                51.117918,
                35.6797817
              ],
              [
                51.1169374,
                35.6798633
              ],
              [
                51.1148517,
                35.6803025
              ],
              [
                51.1119152,
                35.6810742
              ],
              [
                51.1105929,
                35.6814367
              ],
              [
                51.1100269,
                35.6816641
              ],
              [
                51.1077964,
                35.6827496
              ],
              [
                51.1031101,
                35.6854058
              ],
              [
                51.0922697,
                35.691638
              ],
              [
                51.0903182,
                35.6925735
              ],
              [
                51.0886595,
                35.6932662
              ],
              [
                51.0864808,
                35.6935731
              ],
              [
                51.0863914,
                35.6970409
              ],
              [
                51.0837711,
                35.6970476
              ],
              [
                51.0788971,
                35.6965735
              ],
              [
                51.0756238,
                35.696255
              ],
              [
                51.0679834,
                35.6945694
              ],
              [
                51.0644354,
                35.6939249
              ],
              [
                51.0613062,
                35.6949324
              ],
              [
                51.0484089,
                35.6992934
              ],
              [
                51.0444071,
                35.6997614
              ],
              [
                51.043007,
                35.7071091
              ],
              [
                51.0426047,
                35.7099011
              ],
              [
                51.0418069,
                35.7118966
              ],
              [
                51.0386497,
                35.7176816
              ],
              [
                51.0385627,
                35.717841
              ],
              [
                51.0364339,
                35.7222354
              ],
              [
                51.0360363,
                35.7221136
              ],
              [
                51.0352785,
                35.722553
              ],
              [
                51.0320089,
                35.7219026
              ],
              [
                51.0303634,
                35.723889
              ],
              [
                51.0274403,
                35.7252249
              ],
              [
                51.0276785,
                35.7255765
              ],
              [
                51.0285662,
                35.7268597
              ],
              [
                51.023695,
                35.7293656
              ],
              [
                51.0225861,
                35.7282484
              ],
              [
                51.0210091,
                35.7291419
              ],
              [
                51.0206983,
                35.7287516
              ],
              [
                51.0191458,
                35.7267403
              ],
              [
                51.0173717,
                35.726835
              ],
              [
                51.0136401,
                35.7245211
              ],
              [
                51.0111688,
                35.7222437
              ],
              [
                51.0089576,
                35.7193997
              ],
              [
                51.0069106,
                35.7151076
              ],
              [
                51.0075238,
                35.7144104
              ],
              [
                51.0063014,
                35.7130463
              ],
              [
                51.0062688,
                35.7129664
              ],
              [
                51.0062255,
                35.7129183
              ],
              [
                51.0061786,
                35.7128664
              ],
              [
                51.0060756,
                35.7128182
              ],
              [
                51.0060191,
                35.7128156
              ],
              [
                51.0059234,
                35.7128439
              ],
              [
                51.00582,
                35.7128616
              ],
              [
                51.0057399,
                35.7128644
              ],
              [
                51.0056812,
                35.7128579
              ],
              [
                51.0056264,
                35.7128329
              ],
              [
                51.0056015,
                35.7127928
              ],
              [
                51.0055029,
                35.7125872
              ],
              [
                51.0050844,
                35.7117561
              ],
              [
                51.0044854,
                35.7065077
              ],
              [
                51.0023672,
                35.7071764
              ],
              [
                50.9976089,
                35.7004433
              ],
              [
                50.9938969,
                35.7022083
              ],
              [
                50.9935205,
                35.7011163
              ],
              [
                50.993395,
                35.7007743
              ],
              [
                50.9933515,
                35.700453
              ],
              [
                50.9933606,
                35.7003267
              ],
              [
                50.9933757,
                35.7001169
              ],
              [
                50.9933072,
                35.6997737
              ],
              [
                50.9932966,
                35.6997429
              ],
              [
                50.9931828,
                35.6994108
              ],
              [
                50.9928767,
                35.6985634
              ],
              [
                50.9927879,
                35.6983421
              ],
              [
                50.9929407,
                35.698294
              ],
              [
                50.9978278,
                35.6967548
              ],
              [
                51.0006318,
                35.6959095
              ],
              [
                51.0014209,
                35.6957364
              ],
              [
                51.0030448,
                35.6953143
              ],
              [
                51.0058173,
                35.6937471
              ],
              [
                51.0039875,
                35.6873915
              ],
              [
                51.0029015,
                35.6835534
              ],
              [
                51.0013773,
                35.6817801
              ],
              [
                50.9997184,
                35.6780012
              ],
              [
                50.9995941,
                35.6777181
              ],
              [
                50.9985487,
                35.6743485
              ],
              [
                50.9984342,
                35.673627
              ],
              [
                50.9983274,
                35.672977
              ],
              [
                50.9982699,
                35.672438
              ],
              [
                50.9980951,
                35.6708631
              ],
              [
                50.997987,
                35.6699924
              ],
              [
                50.9979028,
                35.6692854
              ],
              [
                50.9978483,
                35.6688137
              ],
              [
                50.9978091,
                35.6684738
              ],
              [
                50.9976074,
                35.6684912
              ],
              [
                50.9967817,
                35.6685604
              ],
              [
                50.9967056,
                35.6685657
              ],
              [
                50.9962542,
                35.6686173
              ],
              [
                50.9959268,
                35.6686377
              ],
              [
                50.9946037,
                35.6687202
              ],
              [
                50.9938472,
                35.6687674
              ],
              [
                50.9927944,
                35.6688402
              ],
              [
                50.9888661,
                35.6692434
              ],
              [
                50.9888567,
                35.6691569
              ],
              [
                50.9888081,
                35.668707
              ],
              [
                50.9887494,
                35.6681697
              ],
              [
                50.9886884,
                35.6676466
              ],
              [
                50.9885753,
                35.6666761
              ],
              [
                50.9884709,
                35.6657812
              ],
              [
                50.9883887,
                35.6650752
              ],
              [
                50.98822,
                35.6634582
              ],
              [
                50.988172,
                35.6629672
              ],
              [
                50.9881331,
                35.66273
              ],
              [
                50.9880176,
                35.6620259
              ],
              [
                50.9879024,
                35.6616827
              ],
              [
                50.9875227,
                35.660836
              ],
              [
                50.9866574,
                35.659026
              ],
              [
                50.9860878,
                35.6578447
              ],
              [
                50.9857006,
                35.6570092
              ],
              [
                50.9853903,
                35.6562632
              ],
              [
                50.9849294,
                35.6554318
              ],
              [
                50.9849158,
                35.6553613
              ],
              [
                50.9857807,
                35.6552719
              ],
              [
                50.988161,
                35.6550763
              ],
              [
                50.9913702,
                35.6548159
              ],
              [
                50.992903,
                35.6547357
              ],
              [
                50.9938971,
                35.6546291
              ],
              [
                50.9948237,
                35.6545778
              ],
              [
                50.9946529,
                35.6534138
              ],
              [
                50.9945242,
                35.6512378
              ],
              [
                50.9947302,
                35.6501498
              ],
              [
                50.9951409,
                35.6493651
              ],
              [
                50.995515,
                35.6487898
              ],
              [
                50.9958374,
                35.6479947
              ],
              [
                50.9957087,
                35.6474506
              ],
              [
                50.9943697,
                35.6448769
              ],
              [
                50.9944727,
                35.6438725
              ],
              [
                50.9950392,
                35.6427425
              ],
              [
                50.9956856,
                35.6410595
              ],
              [
                50.9968331,
                35.6407604
              ],
              [
                50.9980424,
                35.6395647
              ],
              [
                50.9967556,
                35.6342328
              ],
              [
                50.996525,
                35.6333087
              ],
              [
                50.9959684,
                35.6296933
              ],
              [
                50.9953297,
                35.628781
              ],
              [
                50.9948584,
                35.6283048
              ],
              [
                50.9898551,
                35.6246985
              ],
              [
                50.9887452,
                35.624419
              ],
              [
                50.9635683,
                35.6112978
              ],
              [
                50.9575424,
                35.6041552
              ],
              [
                50.9234659,
                35.5996973
              ],
              [
                50.9223526,
                35.5991382
              ],
              [
                50.9020763,
                35.5927549
              ],
              [
                50.9004061,
                35.5919164
              ],
              [
                50.8990196,
                35.5916458
              ],
              [
                50.8970729,
                35.5908074
              ],
              [
                50.8824923,
                35.5863904
              ],
              [
                50.8787399,
                35.5852534
              ],
              [
                50.8773497,
                35.5852534
              ],
              [
                50.8752644,
                35.5846402
              ],
              [
                50.8527622,
                35.5780224
              ],
              [
                50.8520735,
                35.5774724
              ],
              [
                50.8515169,
                35.5774725
              ],
              [
                50.8509602,
                35.5774724
              ],
              [
                50.8501267,
                35.5769224
              ],
              [
                50.8401239,
                35.573138
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555144,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فیروزکوه",
          "name:en": "Firuzkuh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1294072",
          "wikipedia": "fa:شهرستان فیروزکوه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.2274139,
                35.7674821
              ],
              [
                52.2502181,
                35.7624838
              ],
              [
                52.2753165,
                35.7603944
              ],
              [
                52.2963064,
                35.7577554
              ],
              [
                52.3101963,
                35.7560877
              ],
              [
                52.3135296,
                35.7552583
              ],
              [
                52.3276961,
                35.7533112
              ],
              [
                52.3288095,
                35.7533112
              ],
              [
                52.3307526,
                35.7527613
              ],
              [
                52.332976,
                35.7524728
              ],
              [
                52.3507525,
                35.7474788
              ],
              [
                52.4402014,
                35.7252573
              ],
              [
                52.476871,
                35.719695
              ],
              [
                52.477981,
                35.7196951
              ],
              [
                52.4796476,
                35.7191451
              ],
              [
                52.4815944,
                35.7188656
              ],
              [
                52.4963175,
                35.7141418
              ],
              [
                52.4999275,
                35.713033
              ],
              [
                52.5068417,
                35.7092974
              ],
              [
                52.5203192,
                35.7077143
              ],
              [
                52.5205958,
                35.7079938
              ],
              [
                52.5510384,
                35.7086887
              ],
              [
                52.5518717,
                35.7086888
              ],
              [
                52.5521483,
                35.7084183
              ],
              [
                52.5527051,
                35.7084182
              ],
              [
                52.5529817,
                35.7081388
              ],
              [
                52.5535383,
                35.7081388
              ],
              [
                52.5564508,
                35.710995
              ],
              [
                52.5643397,
                35.7125896
              ],
              [
                52.5596599,
                35.7053194
              ],
              [
                52.5571599,
                35.7017141
              ],
              [
                52.5448602,
                35.6589705
              ],
              [
                52.517057,
                35.6204784
              ],
              [
                52.5131672,
                35.6157627
              ],
              [
                52.5081672,
                35.6107581
              ],
              [
                52.4953677,
                35.6015603
              ],
              [
                52.4948108,
                35.6012897
              ],
              [
                52.4942577,
                35.6004511
              ],
              [
                52.4805547,
                35.590169
              ],
              [
                52.4732612,
                35.5846958
              ],
              [
                52.4621479,
                35.5719198
              ],
              [
                52.4529814,
                35.5552485
              ],
              [
                52.4427015,
                35.5349704
              ],
              [
                52.4282584,
                35.5130238
              ],
              [
                52.4150842,
                35.4601112
              ],
              [
                52.3601993,
                35.4096866
              ],
              [
                52.3574228,
                35.4049703
              ],
              [
                52.3565894,
                35.4041317
              ],
              [
                52.3443662,
                35.3858075
              ],
              [
                52.3421429,
                35.3833007
              ],
              [
                52.3365863,
                35.3777456
              ],
              [
                52.3331994,
                35.3749235
              ],
              [
                52.3401997,
                35.3660764
              ],
              [
                52.3451995,
                35.3610805
              ],
              [
                52.3601994,
                35.3474632
              ],
              [
                52.3688092,
                35.3410783
              ],
              [
                52.3785325,
                35.3377506
              ],
              [
                52.3790892,
                35.3374621
              ],
              [
                52.3801991,
                35.337462
              ],
              [
                52.3829791,
                35.3380212
              ],
              [
                52.4001154,
                35.3507378
              ],
              [
                52.4085355,
                35.3569142
              ],
              [
                52.4104788,
                35.3585825
              ],
              [
                52.4218687,
                35.3660765
              ],
              [
                52.4935377,
                35.3860782
              ],
              [
                52.4949278,
                35.3860782
              ],
              [
                52.4957611,
                35.3863578
              ],
              [
                52.499651,
                35.3869169
              ],
              [
                52.5171509,
                35.3957995
              ],
              [
                52.5188174,
                35.396079
              ],
              [
                52.5210407,
                35.3969177
              ],
              [
                52.5227074,
                35.3971882
              ],
              [
                52.5232607,
                35.3974677
              ],
              [
                52.5246748,
                35.397823
              ],
              [
                52.5302073,
                35.3994155
              ],
              [
                52.5310407,
                35.3999656
              ],
              [
                52.5318739,
                35.3999656
              ],
              [
                52.5327073,
                35.4005247
              ],
              [
                52.5340973,
                35.4008043
              ],
              [
                52.5349306,
                35.4013544
              ],
              [
                52.5363172,
                35.4016339
              ],
              [
                52.5502071,
                35.4091366
              ],
              [
                52.5513204,
                35.4099663
              ],
              [
                52.555207,
                35.4119141
              ],
              [
                52.5629869,
                35.4174689
              ],
              [
                52.6063231,
                35.4619156
              ],
              [
                52.6071564,
                35.4624657
              ],
              [
                52.6082664,
                35.4641428
              ],
              [
                52.6115996,
                35.4674702
              ],
              [
                52.6152095,
                35.4724748
              ],
              [
                52.6338227,
                35.5027448
              ],
              [
                52.634656,
                35.5038628
              ],
              [
                52.6377126,
                35.5083082
              ],
              [
                52.6591023,
                35.5283073
              ],
              [
                52.6596591,
                35.5285868
              ],
              [
                52.6599357,
                35.5294163
              ],
              [
                52.6671589,
                35.5352501
              ],
              [
                52.6674356,
                35.5358092
              ],
              [
                52.6696589,
                35.5369182
              ],
              [
                52.6727122,
                35.5391362
              ],
              [
                52.6977153,
                35.5519216
              ],
              [
                52.7077151,
                35.5544192
              ],
              [
                52.7085484,
                35.5544192
              ],
              [
                52.7121583,
                35.5549692
              ],
              [
                52.7132718,
                35.5552487
              ],
              [
                52.715215,
                35.5552487
              ],
              [
                52.7163284,
                35.5555282
              ],
              [
                52.725495,
                35.5555282
              ],
              [
                52.7260482,
                35.5552487
              ],
              [
                52.7266049,
                35.5555282
              ],
              [
                52.7277148,
                35.5555282
              ],
              [
                52.7343849,
                35.5533102
              ],
              [
                52.7660511,
                35.5469175
              ],
              [
                52.7668843,
                35.5469175
              ],
              [
                52.7768843,
                35.5416429
              ],
              [
                52.7788309,
                35.5410839
              ],
              [
                52.7821642,
                35.5410839
              ],
              [
                52.7929974,
                35.5452495
              ],
              [
                52.7932741,
                35.545529
              ],
              [
                52.7943875,
                35.5459445
              ],
              [
                52.801054,
                35.5494151
              ],
              [
                52.8021641,
                35.5505331
              ],
              [
                52.8024406,
                35.5508037
              ],
              [
                52.8227204,
                35.572479
              ],
              [
                52.8291104,
                35.579701
              ],
              [
                52.8299438,
                35.5810896
              ],
              [
                52.8771663,
                35.6260885
              ],
              [
                52.8846697,
                35.6313716
              ],
              [
                52.8857797,
                35.6322011
              ],
              [
                52.8991128,
                35.6419201
              ],
              [
                52.9143926,
                35.6497006
              ],
              [
                52.9263359,
                35.6541452
              ],
              [
                52.9291158,
                35.6549747
              ],
              [
                52.9296691,
                35.6555337
              ],
              [
                52.9743952,
                35.6694265
              ],
              [
                52.9752286,
                35.6699764
              ],
              [
                52.9846717,
                35.6727532
              ],
              [
                52.9952283,
                35.6785861
              ],
              [
                52.995785,
                35.6788656
              ],
              [
                52.999675,
                35.6813629
              ],
              [
                53.0010616,
                35.6827602
              ],
              [
                53.001895,
                35.6833102
              ],
              [
                53.0124514,
                35.7008087
              ],
              [
                53.0236118,
                35.7059191
              ],
              [
                53.0260515,
                35.7086249
              ],
              [
                53.0294194,
                35.7107269
              ],
              [
                53.0345465,
                35.7157818
              ],
              [
                53.0396417,
                35.7173855
              ],
              [
                53.0450542,
                35.7186159
              ],
              [
                53.0482405,
                35.720593
              ],
              [
                53.0501364,
                35.7226807
              ],
              [
                53.0528843,
                35.7236171
              ],
              [
                53.0537982,
                35.7249015
              ],
              [
                53.0555043,
                35.7262102
              ],
              [
                53.0626664,
                35.7333319
              ],
              [
                53.0649541,
                35.7347051
              ],
              [
                53.0655109,
                35.7349755
              ],
              [
                53.0880105,
                35.744982
              ],
              [
                53.0932904,
                35.7488673
              ],
              [
                53.0938438,
                35.7496967
              ],
              [
                53.0944005,
                35.7499851
              ],
              [
                53.0969005,
                35.7555382
              ],
              [
                53.1099569,
                35.772756
              ],
              [
                53.13329,
                35.7847001
              ],
              [
                53.1469033,
                35.7888739
              ],
              [
                53.1482932,
                35.7894237
              ],
              [
                53.1527365,
                35.7919297
              ],
              [
                53.1546798,
                35.7941472
              ],
              [
                53.1560698,
                35.7960943
              ],
              [
                53.1569031,
                35.8038645
              ],
              [
                53.1563464,
                35.8052618
              ],
              [
                53.1566264,
                35.8055322
              ],
              [
                53.1560697,
                35.8077587
              ],
              [
                53.1532932,
                35.8113644
              ],
              [
                53.1410699,
                35.8177554
              ],
              [
                53.1399566,
                35.8183142
              ],
              [
                53.1394032,
                35.8180348
              ],
              [
                53.1285701,
                35.8205406
              ],
              [
                53.1199568,
                35.8205407
              ],
              [
                53.1180136,
                35.8202523
              ],
              [
                53.107457,
                35.8202523
              ],
              [
                53.1052337,
                35.8199818
              ],
              [
                53.0980104,
                35.8199818
              ],
              [
                53.0971771,
                35.8197024
              ],
              [
                53.0938437,
                35.8197024
              ],
              [
                53.0913438,
                35.8191435
              ],
              [
                53.0891205,
                35.8191436
              ],
              [
                53.0855106,
                35.8185937
              ],
              [
                53.0846771,
                35.8185937
              ],
              [
                53.0830106,
                35.8183142
              ],
              [
                53.0816206,
                35.8180348
              ],
              [
                53.0807873,
                35.8183142
              ],
              [
                53.0766207,
                35.8183142
              ],
              [
                53.0657875,
                35.8191435
              ],
              [
                53.0652308,
                35.819432
              ],
              [
                53.0602307,
                35.8194319
              ],
              [
                53.0585641,
                35.8191435
              ],
              [
                53.0580109,
                35.819432
              ],
              [
                53.0566209,
                35.8191436
              ],
              [
                53.0499543,
                35.8197024
              ],
              [
                53.0485643,
                35.8199818
              ],
              [
                53.0471743,
                35.8199818
              ],
              [
                53.0410644,
                35.8221993
              ],
              [
                53.0330078,
                35.8263727
              ],
              [
                53.0318978,
                35.8266521
              ],
              [
                53.0205078,
                35.8355399
              ],
              [
                53.0216179,
                35.8449774
              ],
              [
                53.0221745,
                35.8480331
              ],
              [
                53.0221746,
                35.8483126
              ],
              [
                53.0221746,
                35.8491508
              ],
              [
                53.021898,
                35.8499801
              ],
              [
                53.0202313,
                35.8516477
              ],
              [
                53.018008,
                35.8530357
              ],
              [
                53.0174514,
                35.8535946
              ],
              [
                53.0110614,
                35.8485919
              ],
              [
                53.0107847,
                35.8483126
              ],
              [
                53.0071748,
                35.8460951
              ],
              [
                53.0068947,
                35.8455364
              ],
              [
                53.0046748,
                35.8444276
              ],
              [
                53.0038415,
                35.8435893
              ],
              [
                52.9874517,
                35.83554
              ],
              [
                52.9707818,
                35.8324842
              ],
              [
                52.9674485,
                35.8324842
              ],
              [
                52.9663387,
                35.8322048
              ],
              [
                52.9643953,
                35.8322048
              ],
              [
                52.9632819,
                35.8319254
              ],
              [
                52.9627287,
                35.8322048
              ],
              [
                52.9613387,
                35.8319253
              ],
              [
                52.9516155,
                35.8319253
              ],
              [
                52.9507821,
                35.8322048
              ],
              [
                52.9480055,
                35.8322047
              ],
              [
                52.9468922,
                35.8324842
              ],
              [
                52.9455055,
                35.8324842
              ],
              [
                52.9449488,
                35.8327546
              ],
              [
                52.9430055,
                35.8327546
              ],
              [
                52.937449,
                35.8338723
              ],
              [
                52.9368923,
                35.8338723
              ],
              [
                52.9357823,
                35.8341427
              ],
              [
                52.9216158,
                35.8377573
              ],
              [
                52.9207825,
                35.8377573
              ],
              [
                52.9180024,
                35.8391455
              ],
              [
                52.9171691,
                35.8391455
              ],
              [
                52.8774463,
                35.8566503
              ],
              [
                52.8718897,
                35.8585882
              ],
              [
                52.8704997,
                35.8594264
              ],
              [
                52.8291102,
                35.8738753
              ],
              [
                52.8281778,
                35.8741024
              ],
              [
                52.8229968,
                35.8760926
              ],
              [
                52.8218869,
                35.876372
              ],
              [
                52.815777,
                35.8791482
              ],
              [
                52.8146636,
                35.8794276
              ],
              [
                52.8038129,
                35.8854164
              ],
              [
                52.7966072,
                35.8894235
              ],
              [
                52.7881052,
                35.8929868
              ],
              [
                52.7057716,
                35.9274863
              ],
              [
                52.7049383,
                35.9280361
              ],
              [
                52.7016049,
                35.928595
              ],
              [
                52.6993816,
                35.9294241
              ],
              [
                52.6949384,
                35.9302623
              ],
              [
                52.6935484,
                35.9308211
              ],
              [
                52.692435,
                35.9308211
              ],
              [
                52.6841018,
                35.9333177
              ],
              [
                52.6832685,
                35.9333177
              ],
              [
                52.6616785,
                35.9390399
              ],
              [
                52.660212,
                35.9394284
              ],
              [
                52.6591021,
                35.9394285
              ],
              [
                52.6585453,
                35.9397079
              ],
              [
                52.6571589,
                35.9397079
              ],
              [
                52.6560454,
                35.9399783
              ],
              [
                52.6538222,
                35.9399783
              ],
              [
                52.6524355,
                35.9402577
              ],
              [
                52.6502122,
                35.9402576
              ],
              [
                52.6488221,
                35.9405371
              ],
              [
                52.6477122,
                35.9402576
              ],
              [
                52.6443789,
                35.9408165
              ],
              [
                52.6435456,
                35.9405371
              ],
              [
                52.6227125,
                35.941925
              ],
              [
                52.6196559,
                35.9424839
              ],
              [
                52.6149325,
                35.9424838
              ],
              [
                52.6129892,
                35.9427632
              ],
              [
                52.6077093,
                35.9427633
              ],
              [
                52.6065993,
                35.9430426
              ],
              [
                52.6024192,
                35.943043
              ],
              [
                52.5832664,
                35.9430426
              ],
              [
                52.581043,
                35.943313
              ],
              [
                52.5799296,
                35.9430426
              ],
              [
                52.5777097,
                35.9433131
              ],
              [
                52.5757629,
                35.943313
              ],
              [
                52.5749297,
                35.9430426
              ],
              [
                52.5685432,
                35.9430426
              ],
              [
                52.5679864,
                35.943313
              ],
              [
                52.5482634,
                35.9410958
              ],
              [
                52.54604,
                35.940537
              ],
              [
                52.5435401,
                35.940537
              ],
              [
                52.5418733,
                35.9402576
              ],
              [
                52.54104,
                35.940537
              ],
              [
                52.4999272,
                35.9338674
              ],
              [
                52.4957606,
                35.933597
              ],
              [
                52.4949272,
                35.933597
              ],
              [
                52.4943706,
                35.9333176
              ],
              [
                52.4935373,
                35.9333176
              ],
              [
                52.4805157,
                35.9304368
              ],
              [
                52.4796475,
                35.9302622
              ],
              [
                52.4790942,
                35.9302622
              ],
              [
                52.4752041,
                35.929424
              ],
              [
                52.4740942,
                35.9288742
              ],
              [
                52.4702042,
                35.9277655
              ],
              [
                52.4685377,
                35.9269273
              ],
              [
                52.4663143,
                35.9263775
              ],
              [
                52.4635377,
                35.9252599
              ],
              [
                52.4627044,
                35.92526
              ],
              [
                52.4357581,
                35.9122089
              ],
              [
                52.4176557,
                35.8941065
              ],
              [
                52.4157583,
                35.8922085
              ],
              [
                52.4152015,
                35.8910908
              ],
              [
                52.412425,
                35.8874763
              ],
              [
                52.4090882,
                35.8830327
              ],
              [
                52.3943686,
                35.8616436
              ],
              [
                52.3793654,
                35.8494299
              ],
              [
                52.3785321,
                35.8488711
              ],
              [
                52.3782555,
                35.8485917
              ],
              [
                52.326586,
                35.8283195
              ],
              [
                52.3196427,
                35.8263724
              ],
              [
                52.3003625,
                35.818777
              ],
              [
                52.2921399,
                35.8155375
              ],
              [
                52.2665834,
                35.7985908
              ],
              [
                52.2657501,
                35.7974821
              ],
              [
                52.2446369,
                35.7730351
              ],
              [
                52.240747,
                35.771088
              ],
              [
                52.2374138,
                35.7696997
              ],
              [
                52.2274139,
                35.7674821
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555148,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قدس",
          "name:en": "Qods County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q8217067",
          "wikipedia": "en:Qods County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.0063014,
                35.7130463
              ],
              [
                51.0075238,
                35.7144104
              ],
              [
                51.0069106,
                35.7151076
              ],
              [
                51.0089576,
                35.7193997
              ],
              [
                51.0111688,
                35.7222437
              ],
              [
                51.0136401,
                35.7245211
              ],
              [
                51.0173717,
                35.726835
              ],
              [
                51.0191458,
                35.7267403
              ],
              [
                51.0206983,
                35.7287516
              ],
              [
                51.0210091,
                35.7291419
              ],
              [
                51.0225861,
                35.7282484
              ],
              [
                51.023695,
                35.7293656
              ],
              [
                51.0285662,
                35.7268597
              ],
              [
                51.0276785,
                35.7255765
              ],
              [
                51.0274403,
                35.7252249
              ],
              [
                51.0303634,
                35.723889
              ],
              [
                51.0320089,
                35.7219026
              ],
              [
                51.0352785,
                35.722553
              ],
              [
                51.0360363,
                35.7221136
              ],
              [
                51.0364339,
                35.7222354
              ],
              [
                51.0385627,
                35.717841
              ],
              [
                51.0386497,
                35.7176816
              ],
              [
                51.0418069,
                35.7118966
              ],
              [
                51.0426047,
                35.7099011
              ],
              [
                51.043007,
                35.7071091
              ],
              [
                51.0444071,
                35.6997614
              ],
              [
                51.0484089,
                35.6992934
              ],
              [
                51.0613062,
                35.6949324
              ],
              [
                51.0644354,
                35.6939249
              ],
              [
                51.0679834,
                35.6945694
              ],
              [
                51.0756238,
                35.696255
              ],
              [
                51.0788971,
                35.6965735
              ],
              [
                51.0837711,
                35.6970476
              ],
              [
                51.0863914,
                35.6970409
              ],
              [
                51.0864808,
                35.6935731
              ],
              [
                51.0886595,
                35.6932662
              ],
              [
                51.0903182,
                35.6925735
              ],
              [
                51.0922697,
                35.691638
              ],
              [
                51.1031101,
                35.6854058
              ],
              [
                51.1077964,
                35.6827496
              ],
              [
                51.1100269,
                35.6816641
              ],
              [
                51.1105929,
                35.6814367
              ],
              [
                51.1119152,
                35.6810742
              ],
              [
                51.1148517,
                35.6803025
              ],
              [
                51.1169374,
                35.6798633
              ],
              [
                51.117918,
                35.6797817
              ],
              [
                51.1189458,
                35.6798214
              ],
              [
                51.1195295,
                35.6799293
              ],
              [
                51.1201192,
                35.6800999
              ],
              [
                51.1203056,
                35.6787358
              ],
              [
                51.1201253,
                35.6778573
              ],
              [
                51.1195331,
                35.6774181
              ],
              [
                51.1192241,
                35.6768115
              ],
              [
                51.1203828,
                35.675682
              ],
              [
                51.1209236,
                35.6749499
              ],
              [
                51.122417,
                35.6743642
              ],
              [
                51.1411081,
                35.6682179
              ],
              [
                51.1447797,
                35.6672074
              ],
              [
                51.1504426,
                35.6651427
              ],
              [
                51.1627589,
                35.6616149
              ],
              [
                51.1641237,
                35.6623471
              ],
              [
                51.1647931,
                35.6632467
              ],
              [
                51.1668531,
                35.6658407
              ],
              [
                51.1670076,
                35.6664265
              ],
              [
                51.1677028,
                35.6681418
              ],
              [
                51.1717414,
                35.6729163
              ],
              [
                51.1591154,
                35.6815724
              ],
              [
                51.1613774,
                35.685187
              ],
              [
                51.163727,
                35.685797
              ],
              [
                51.1653578,
                35.6884984
              ],
              [
                51.179552,
                35.6797142
              ],
              [
                51.184414,
                35.6844569
              ],
              [
                51.1966753,
                35.6978452
              ],
              [
                51.1901569,
                35.7004326
              ],
              [
                51.1857416,
                35.7021978
              ],
              [
                51.1834181,
                35.7031228
              ],
              [
                51.1824842,
                35.703401
              ],
              [
                51.1807935,
                35.7039797
              ],
              [
                51.1794338,
                35.7043488
              ],
              [
                51.1764115,
                35.7051047
              ],
              [
                51.1722416,
                35.7061907
              ],
              [
                51.165784,
                35.7076823
              ],
              [
                51.1628079,
                35.7082557
              ],
              [
                51.1621145,
                35.7085122
              ],
              [
                51.152046,
                35.712236
              ],
              [
                51.1471906,
                35.7138823
              ],
              [
                51.1434179,
                35.7153904
              ],
              [
                51.142546,
                35.7157795
              ],
              [
                51.1413307,
                35.7163899
              ],
              [
                51.1391449,
                35.7176549
              ],
              [
                51.1360812,
                35.7199603
              ],
              [
                51.1355659,
                35.720359
              ],
              [
                51.1349819,
                35.72082
              ],
              [
                51.1339672,
                35.7215959
              ],
              [
                51.1325589,
                35.7227039
              ],
              [
                51.1321352,
                35.723096
              ],
              [
                51.1316791,
                35.7235613
              ],
              [
                51.1283693,
                35.726792
              ],
              [
                51.1273957,
                35.7280037
              ],
              [
                51.1257776,
                35.730269
              ],
              [
                51.125218,
                35.7310599
              ],
              [
                51.1236697,
                35.7329578
              ],
              [
                51.1164378,
                35.7364194
              ],
              [
                51.1137546,
                35.7374884
              ],
              [
                51.1136635,
                35.7375146
              ],
              [
                51.104756,
                35.7399383
              ],
              [
                51.1026979,
                35.7402594
              ],
              [
                51.0989731,
                35.7409334
              ],
              [
                51.0933876,
                35.7421762
              ],
              [
                51.0925702,
                35.7401965
              ],
              [
                51.0913784,
                35.7403866
              ],
              [
                51.090503,
                35.7373142
              ],
              [
                51.0903742,
                35.7360393
              ],
              [
                51.090606,
                35.7349942
              ],
              [
                51.088855,
                35.7344508
              ],
              [
                51.0855591,
                35.7336983
              ],
              [
                51.0829842,
                35.7336849
              ],
              [
                51.0804608,
                35.7336147
              ],
              [
                51.0776284,
                35.7341791
              ],
              [
                51.0756199,
                35.733991
              ],
              [
                51.072942,
                35.7339492
              ],
              [
                51.0701611,
                35.7343254
              ],
              [
                51.0681269,
                35.7341791
              ],
              [
                51.0663245,
                35.7343463
              ],
              [
                51.0642388,
                35.7344717
              ],
              [
                51.0631733,
                35.7342617
              ],
              [
                51.0613638,
                35.7348334
              ],
              [
                51.0587088,
                35.735499
              ],
              [
                51.056651,
                35.7351495
              ],
              [
                51.0543849,
                35.7356809
              ],
              [
                51.0540791,
                35.736051
              ],
              [
                51.0539369,
                35.7363232
              ],
              [
                51.0529472,
                35.7379626
              ],
              [
                51.0516776,
                35.7389746
              ],
              [
                51.0511817,
                35.739324
              ],
              [
                51.0495595,
                35.7385089
              ],
              [
                51.0475253,
                35.7382372
              ],
              [
                51.0425815,
                35.73807
              ],
              [
                51.0378951,
                35.7385925
              ],
              [
                51.0349597,
                35.7391359
              ],
              [
                51.0305823,
                35.7394912
              ],
              [
                51.0289344,
                35.7391777
              ],
              [
                51.0268377,
                35.7376632
              ],
              [
                51.0257243,
                35.7389339
              ],
              [
                51.0254871,
                35.7387642
              ],
              [
                51.0248221,
                35.7378989
              ],
              [
                51.0220463,
                35.7340461
              ],
              [
                51.0215354,
                35.7333765
              ],
              [
                51.0208281,
                35.7319956
              ],
              [
                51.0202111,
                35.7313073
              ],
              [
                51.0196918,
                35.7305882
              ],
              [
                51.0188357,
                35.7294448
              ],
              [
                51.0183954,
                35.7290645
              ],
              [
                51.0182893,
                35.7289665
              ],
              [
                51.0171804,
                35.7279563
              ],
              [
                51.0170337,
                35.7278236
              ],
              [
                51.0128492,
                35.7240356
              ],
              [
                51.010918,
                35.7222987
              ],
              [
                51.0095132,
                35.7205797
              ],
              [
                51.0085794,
                35.7195565
              ],
              [
                51.0066424,
                35.7150205
              ],
              [
                51.0071644,
                35.7144409
              ],
              [
                51.0067856,
                35.7138288
              ],
              [
                51.0063014,
                35.7130463
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555150,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قرچک",
          "name:en": "Qarchak County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5704075",
          "wikipedia": "fa:شهرستان قرچک"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.4917997,
                35.36283
              ],
              [
                51.4949986,
                35.3619225
              ],
              [
                51.4978567,
                35.3632454
              ],
              [
                51.5040623,
                35.3609145
              ],
              [
                51.5074869,
                35.3596125
              ],
              [
                51.5119153,
                35.3575464
              ],
              [
                51.5206957,
                35.3577144
              ],
              [
                51.5233994,
                35.3580924
              ],
              [
                51.5260258,
                35.3582184
              ],
              [
                51.5367922,
                35.3590051
              ],
              [
                51.5475296,
                35.3599291
              ],
              [
                51.5501303,
                35.362428
              ],
              [
                51.551701,
                35.3639609
              ],
              [
                51.5616466,
                35.3674387
              ],
              [
                51.5622645,
                35.3705462
              ],
              [
                51.5633975,
                35.3715751
              ],
              [
                51.5637838,
                35.372226
              ],
              [
                51.5638353,
                35.3729608
              ],
              [
                51.564067,
                35.3737377
              ],
              [
                51.564891,
                35.3745565
              ],
              [
                51.5665647,
                35.376656
              ],
              [
                51.5690623,
                35.3794903
              ],
              [
                51.5699893,
                35.3812328
              ],
              [
                51.571148,
                35.3826184
              ],
              [
                51.571457,
                35.3833531
              ],
              [
                51.571972,
                35.3844238
              ],
              [
                51.5736972,
                35.3868589
              ],
              [
                51.5751134,
                35.3891051
              ],
              [
                51.5891729,
                35.3961162
              ],
              [
                51.5937116,
                35.389417
              ],
              [
                51.6000137,
                35.3926964
              ],
              [
                51.6013526,
                35.3927804
              ],
              [
                51.605273,
                35.3949796
              ],
              [
                51.6061162,
                35.3949214
              ],
              [
                51.6110858,
                35.3931792
              ],
              [
                51.6133517,
                35.3904714
              ],
              [
                51.620304,
                35.3941238
              ],
              [
                51.6172514,
                35.3981998
              ],
              [
                51.6231994,
                35.401684
              ],
              [
                51.620985,
                35.4047273
              ],
              [
                51.6217317,
                35.4050841
              ],
              [
                51.6280222,
                35.4060235
              ],
              [
                51.6305841,
                35.4076494
              ],
              [
                51.626326,
                35.4101488
              ],
              [
                51.6233133,
                35.4118697
              ],
              [
                51.6162838,
                35.4178714
              ],
              [
                51.6154225,
                35.4181606
              ],
              [
                51.616898,
                35.4208838
              ],
              [
                51.6183657,
                35.4220799
              ],
              [
                51.6186747,
                35.4224576
              ],
              [
                51.6202454,
                35.423192
              ],
              [
                51.6226143,
                35.4251643
              ],
              [
                51.6241077,
                35.425563
              ],
              [
                51.6253437,
                35.426738
              ],
              [
                51.6269144,
                35.427913
              ],
              [
                51.6278929,
                35.4288991
              ],
              [
                51.6296696,
                35.4314588
              ],
              [
                51.630339,
                35.4326337
              ],
              [
                51.6306223,
                35.4345219
              ],
              [
                51.6311115,
                35.4359066
              ],
              [
                51.6309313,
                35.4363052
              ],
              [
                51.6306223,
                35.4369346
              ],
              [
                51.6297468,
                35.4366619
              ],
              [
                51.6298201,
                35.4368326
              ],
              [
                51.6291764,
                35.4371893
              ],
              [
                51.6288931,
                35.4382802
              ],
              [
                51.6263182,
                35.4364969
              ],
              [
                51.6255457,
                35.4362871
              ],
              [
                51.624696,
                35.4365389
              ],
              [
                51.6212971,
                35.4365389
              ],
              [
                51.6204731,
                35.4362871
              ],
              [
                51.6169197,
                35.4353221
              ],
              [
                51.6155293,
                35.4350703
              ],
              [
                51.6129029,
                35.4337276
              ],
              [
                51.6121561,
                35.4329933
              ],
              [
                51.6109459,
                35.4325947
              ],
              [
                51.609813,
                35.4340004
              ],
              [
                51.6055128,
                35.4392452
              ],
              [
                51.6083195,
                35.4425598
              ],
              [
                51.6114609,
                35.4439233
              ],
              [
                51.6143706,
                35.4455176
              ],
              [
                51.6156323,
                35.4462098
              ],
              [
                51.617924,
                35.4496919
              ],
              [
                51.6198037,
                35.4511812
              ],
              [
                51.6208594,
                35.4518104
              ],
              [
                51.6211034,
                35.4524657
              ],
              [
                51.6166995,
                35.4623794
              ],
              [
                51.6147654,
                35.4618248
              ],
              [
                51.6111635,
                35.4613969
              ],
              [
                51.6095224,
                35.4608743
              ],
              [
                51.6083894,
                35.4602242
              ],
              [
                51.5890775,
                35.4638944
              ],
              [
                51.5869146,
                35.4643558
              ],
              [
                51.5863739,
                35.4647333
              ],
              [
                51.5859669,
                35.4652522
              ],
              [
                51.5839897,
                35.4653324
              ],
              [
                51.5553471,
                35.4638278
              ],
              [
                51.5533988,
                35.4638151
              ],
              [
                51.5526778,
                35.4633537
              ],
              [
                51.5467298,
                35.4558872
              ],
              [
                51.5423524,
                35.4577119
              ],
              [
                51.5477413,
                35.4521363
              ],
              [
                51.5493817,
                35.450439
              ],
              [
                51.5432146,
                35.4452836
              ],
              [
                51.5419793,
                35.4447853
              ],
              [
                51.5407948,
                35.4447853
              ],
              [
                51.5399193,
                35.4447224
              ],
              [
                51.5392756,
                35.4443868
              ],
              [
                51.5387349,
                35.4437994
              ],
              [
                51.5383229,
                35.4433589
              ],
              [
                51.5380912,
                35.4427295
              ],
              [
                51.5380397,
                35.4424778
              ],
              [
                51.5375247,
                35.4396038
              ],
              [
                51.5355935,
                35.4366038
              ],
              [
                51.5346408,
                35.4355758
              ],
              [
                51.5327611,
                35.434338
              ],
              [
                51.5307784,
                35.4334358
              ],
              [
                51.5273795,
                35.4321351
              ],
              [
                51.5249076,
                35.4315896
              ],
              [
                51.5225644,
                35.4305825
              ],
              [
                51.5204529,
                35.4294285
              ],
              [
                51.518393,
                35.4275822
              ],
              [
                51.5133462,
                35.4233857
              ],
              [
                51.5112605,
                35.4206999
              ],
              [
                51.5109,
                35.4175523
              ],
              [
                51.5113635,
                35.4139429
              ],
              [
                51.5113635,
                35.4113826
              ],
              [
                51.5093035,
                35.4080878
              ],
              [
                51.5076813,
                35.4058212
              ],
              [
                51.5056987,
                35.4047298
              ],
              [
                51.503613,
                35.4041422
              ],
              [
                51.502068,
                35.4034496
              ],
              [
                51.5007291,
                35.402715
              ],
              [
                51.4994931,
                35.4018965
              ],
              [
                51.4987721,
                35.4011409
              ],
              [
                51.4963517,
                35.3975307
              ],
              [
                51.4959397,
                35.3957256
              ],
              [
                51.4947398,
                35.3937295
              ],
              [
                51.4937614,
                35.3927009
              ],
              [
                51.4931434,
                35.3916724
              ],
              [
                51.4925975,
                35.3904258
              ],
              [
                51.4935503,
                35.3893132
              ],
              [
                51.493061,
                35.3880327
              ],
              [
                51.4934215,
                35.3871511
              ],
              [
                51.4930868,
                35.3860595
              ],
              [
                51.4931898,
                35.3847159
              ],
              [
                51.4926748,
                35.3833094
              ],
              [
                51.4925718,
                35.3820708
              ],
              [
                51.4939622,
                35.3793416
              ],
              [
                51.4939365,
                35.3785018
              ],
              [
                51.4944515,
                35.3781659
              ],
              [
                51.494915,
                35.3779979
              ],
              [
                51.495018,
                35.3772001
              ],
              [
                51.4956102,
                35.3758774
              ],
              [
                51.4945287,
                35.3747857
              ],
              [
                51.4945545,
                35.3736519
              ],
              [
                51.4951982,
                35.3726651
              ],
              [
                51.4949922,
                35.3706915
              ],
              [
                51.4952497,
                35.3689277
              ],
              [
                51.4948377,
                35.3677939
              ],
              [
                51.494297,
                35.367101
              ],
              [
                51.4937048,
                35.36666
              ],
              [
                51.4931898,
                35.3661981
              ],
              [
                51.4934215,
                35.3654422
              ],
              [
                51.4934988,
                35.3644763
              ],
              [
                51.4929323,
                35.3640143
              ],
              [
                51.4921083,
                35.3635733
              ],
              [
                51.4917997,
                35.36283
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555210,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ملارد",
          "name:en": "Malard County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2413553",
          "wikipedia": "fa:شهرستان ملارد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.3329055,
                35.5507027
              ],
              [
                50.3351497,
                35.5508736
              ],
              [
                50.3573286,
                35.5637571
              ],
              [
                50.3738139,
                35.5638952
              ],
              [
                50.3884791,
                35.564339
              ],
              [
                50.4027049,
                35.5606034
              ],
              [
                50.4055309,
                35.5598813
              ],
              [
                50.4157664,
                35.5589101
              ],
              [
                50.4228684,
                35.5582374
              ],
              [
                50.4417564,
                35.5585589
              ],
              [
                50.4523712,
                35.5590905
              ],
              [
                50.456632,
                35.5601728
              ],
              [
                50.4929353,
                35.56849
              ],
              [
                50.531693,
                35.5706074
              ],
              [
                50.5418645,
                35.5651006
              ],
              [
                50.5536786,
                35.5581875
              ],
              [
                50.5587537,
                35.5546785
              ],
              [
                50.5669582,
                35.5542342
              ],
              [
                50.5709466,
                35.5538583
              ],
              [
                50.5762269,
                35.5535788
              ],
              [
                50.5883665,
                35.5527493
              ],
              [
                50.5911172,
                35.5527142
              ],
              [
                50.5969082,
                35.552784
              ],
              [
                50.6063747,
                35.5532827
              ],
              [
                50.6181764,
                35.5524796
              ],
              [
                50.6259494,
                35.5474747
              ],
              [
                50.6270627,
                35.5469157
              ],
              [
                50.6328629,
                35.540979
              ],
              [
                50.6414739,
                35.5323054
              ],
              [
                50.6497631,
                35.5251971
              ],
              [
                50.6526361,
                35.5241491
              ],
              [
                50.6558252,
                35.5207698
              ],
              [
                50.6767683,
                35.5129611
              ],
              [
                50.6885559,
                35.5115726
              ],
              [
                50.7075471,
                35.5040966
              ],
              [
                50.7410345,
                35.4928463
              ],
              [
                50.7560459,
                35.48778
              ],
              [
                50.7676246,
                35.4869185
              ],
              [
                50.7684581,
                35.4869184
              ],
              [
                50.7712347,
                35.4863594
              ],
              [
                50.7715148,
                35.4860799
              ],
              [
                50.7726247,
                35.4860799
              ],
              [
                50.7745679,
                35.4855298
              ],
              [
                50.775958,
                35.4855299
              ],
              [
                50.7776246,
                35.4849708
              ],
              [
                50.7787346,
                35.4849708
              ],
              [
                50.7823478,
                35.4841413
              ],
              [
                50.7842912,
                35.4841413
              ],
              [
                50.7848478,
                35.4838617
              ],
              [
                50.786791,
                35.4838617
              ],
              [
                50.7876245,
                35.4835822
              ],
              [
                50.7895712,
                35.4835822
              ],
              [
                50.7904044,
                35.4833026
              ],
              [
                50.7987376,
                35.4833027
              ],
              [
                50.799571,
                35.4835822
              ],
              [
                50.8004044,
                35.4833027
              ],
              [
                50.8009575,
                35.4835822
              ],
              [
                50.8017909,
                35.4835822
              ],
              [
                50.8084608,
                35.4841413
              ],
              [
                50.8092942,
                35.4844118
              ],
              [
                50.8104042,
                35.4844117
              ],
              [
                50.8112375,
                35.4846913
              ],
              [
                50.8217941,
                35.4846913
              ],
              [
                50.8223473,
                35.4844118
              ],
              [
                50.845127,
                35.4813551
              ],
              [
                50.851517,
                35.480805
              ],
              [
                50.8576269,
                35.480805
              ],
              [
                50.8615168,
                35.4819141
              ],
              [
                50.8623502,
                35.4819141
              ],
              [
                50.8626303,
                35.4821936
              ],
              [
                50.8634635,
                35.4821936
              ],
              [
                50.8637403,
                35.4824732
              ],
              [
                50.8673502,
                35.4835823
              ],
              [
                50.8731835,
                35.4849709
              ],
              [
                50.8751302,
                35.484971
              ],
              [
                50.8756834,
                35.484971
              ],
              [
                50.8765168,
                35.4849709
              ],
              [
                50.8779066,
                35.4846914
              ],
              [
                50.8915269,
                35.4851248
              ],
              [
                50.8879956,
                35.4873396
              ],
              [
                50.8844644,
                35.4911489
              ],
              [
                50.8818732,
                35.4926956
              ],
              [
                50.877139,
                35.4942422
              ],
              [
                50.8709221,
                35.4974558
              ],
              [
                50.8663749,
                35.4978717
              ],
              [
                50.8564458,
                35.5036812
              ],
              [
                50.8516771,
                35.5124431
              ],
              [
                50.8484924,
                35.5173643
              ],
              [
                50.8442005,
                35.5187644
              ],
              [
                50.842804,
                35.5198456
              ],
              [
                50.842804,
                35.5218694
              ],
              [
                50.843366,
                35.5246832
              ],
              [
                50.8427189,
                35.5278573
              ],
              [
                50.8402466,
                35.5335053
              ],
              [
                50.8400807,
                35.5343768
              ],
              [
                50.8397494,
                35.5348077
              ],
              [
                50.8393568,
                35.5349197
              ],
              [
                50.8386314,
                35.534801
              ],
              [
                50.8355641,
                35.5360852
              ],
              [
                50.8343296,
                35.5364683
              ],
              [
                50.8338153,
                35.5374036
              ],
              [
                50.8332662,
                35.5385628
              ],
              [
                50.8332326,
                35.5390695
              ],
              [
                50.8344248,
                35.540691
              ],
              [
                50.8342715,
                35.5422015
              ],
              [
                50.8352423,
                35.5443356
              ],
              [
                50.8354032,
                35.5450598
              ],
              [
                50.8351457,
                35.546247
              ],
              [
                50.8351672,
                35.5467009
              ],
              [
                50.835452,
                35.5470854
              ],
              [
                50.8360952,
                35.5471854
              ],
              [
                50.8370233,
                35.5470676
              ],
              [
                50.8386058,
                35.5466791
              ],
              [
                50.8388699,
                35.5467052
              ],
              [
                50.8392441,
                35.5470152
              ],
              [
                50.8403345,
                35.5490331
              ],
              [
                50.8402204,
                35.5493197
              ],
              [
                50.8400059,
                35.5495903
              ],
              [
                50.8394694,
                35.5499133
              ],
              [
                50.8391476,
                35.5501926
              ],
              [
                50.8390725,
                35.5506204
              ],
              [
                50.8393568,
                35.5513841
              ],
              [
                50.8395177,
                35.5516329
              ],
              [
                50.8397001,
                35.5517202
              ],
              [
                50.8399254,
                35.551694
              ],
              [
                50.8401453,
                35.5517595
              ],
              [
                50.8402151,
                35.551921
              ],
              [
                50.8401507,
                35.5522177
              ],
              [
                50.8399039,
                35.5524185
              ],
              [
                50.8390725,
                35.5526498
              ],
              [
                50.8382571,
                35.5528375
              ],
              [
                50.8379406,
                35.5530077
              ],
              [
                50.8377796,
                35.5532914
              ],
              [
                50.8378118,
                35.5536362
              ],
              [
                50.8377582,
                35.553994
              ],
              [
                50.8375329,
                35.5542559
              ],
              [
                50.8372271,
                35.5544436
              ],
              [
                50.8365673,
                35.5545941
              ],
              [
                50.8359396,
                35.5546225
              ],
              [
                50.835591,
                35.5545614
              ],
              [
                50.8351242,
                35.5543476
              ],
              [
                50.8346683,
                35.5542734
              ],
              [
                50.8342767,
                35.5543519
              ],
              [
                50.8339816,
                35.5545658
              ],
              [
                50.8339387,
                35.5547883
              ],
              [
                50.834046,
                35.5552291
              ],
              [
                50.8341265,
                35.5555172
              ],
              [
                50.8345771,
                35.5562329
              ],
              [
                50.8349633,
                35.556713
              ],
              [
                50.8350384,
                35.5571057
              ],
              [
                50.8349848,
                35.5579262
              ],
              [
                50.8348829,
                35.5584499
              ],
              [
                50.8349526,
                35.5587816
              ],
              [
                50.8351672,
                35.5589648
              ],
              [
                50.8358699,
                35.5591132
              ],
              [
                50.8367497,
                35.5591481
              ],
              [
                50.8371627,
                35.5592354
              ],
              [
                50.8373666,
                35.5594187
              ],
              [
                50.8374739,
                35.5597111
              ],
              [
                50.8374578,
                35.5601737
              ],
              [
                50.8371627,
                35.5609854
              ],
              [
                50.8368945,
                35.5618276
              ],
              [
                50.8366853,
                35.5621593
              ],
              [
                50.8367979,
                35.5624647
              ],
              [
                50.8369911,
                35.5626393
              ],
              [
                50.8372861,
                35.5627615
              ],
              [
                50.8379245,
                35.5628837
              ],
              [
                50.8381712,
                35.5630364
              ],
              [
                50.8383322,
                35.5632851
              ],
              [
                50.8383322,
                35.5636299
              ],
              [
                50.838359,
                35.5644546
              ],
              [
                50.8385789,
                35.5653361
              ],
              [
                50.8387935,
                35.5661128
              ],
              [
                50.8386218,
                35.5665579
              ],
              [
                50.8381069,
                35.5676663
              ],
              [
                50.8384073,
                35.5682248
              ],
              [
                50.8382249,
                35.5685826
              ],
              [
                50.8378601,
                35.5689317
              ],
              [
                50.8374792,
                35.5691455
              ],
              [
                50.8368248,
                35.569259
              ],
              [
                50.8365351,
                35.5694597
              ],
              [
                50.8362937,
                35.5697608
              ],
              [
                50.8363902,
                35.5703804
              ],
              [
                50.8367336,
                35.5710436
              ],
              [
                50.8374524,
                35.5716283
              ],
              [
                50.8383965,
                35.5723352
              ],
              [
                50.839684,
                35.5724923
              ],
              [
                50.8399737,
                35.5727191
              ],
              [
                50.8401239,
                35.5729024
              ],
              [
                50.8401239,
                35.573138
              ],
              [
                50.8501267,
                35.5769224
              ],
              [
                50.8509602,
                35.5774724
              ],
              [
                50.8515169,
                35.5774725
              ],
              [
                50.8520735,
                35.5774724
              ],
              [
                50.8527622,
                35.5780224
              ],
              [
                50.8752644,
                35.5846402
              ],
              [
                50.8773497,
                35.5852534
              ],
              [
                50.8787399,
                35.5852534
              ],
              [
                50.8824923,
                35.5863904
              ],
              [
                50.8970729,
                35.5908074
              ],
              [
                50.8990196,
                35.5916458
              ],
              [
                50.9004061,
                35.5919164
              ],
              [
                50.9020763,
                35.5927549
              ],
              [
                50.9223526,
                35.5991382
              ],
              [
                50.9234659,
                35.5996973
              ],
              [
                50.9575424,
                35.6041552
              ],
              [
                50.9635683,
                35.6112978
              ],
              [
                50.9887452,
                35.624419
              ],
              [
                50.9898551,
                35.6246985
              ],
              [
                50.9948584,
                35.6283048
              ],
              [
                50.9953297,
                35.628781
              ],
              [
                50.9959684,
                35.6296933
              ],
              [
                50.996525,
                35.6333087
              ],
              [
                50.9967556,
                35.6342328
              ],
              [
                50.9980424,
                35.6395647
              ],
              [
                50.9968331,
                35.6407604
              ],
              [
                50.9956856,
                35.6410595
              ],
              [
                50.9950392,
                35.6427425
              ],
              [
                50.9944727,
                35.6438725
              ],
              [
                50.9943697,
                35.6448769
              ],
              [
                50.9957087,
                35.6474506
              ],
              [
                50.9958374,
                35.6479947
              ],
              [
                50.995515,
                35.6487898
              ],
              [
                50.9951409,
                35.6493651
              ],
              [
                50.9947302,
                35.6501498
              ],
              [
                50.9945242,
                35.6512378
              ],
              [
                50.9946529,
                35.6534138
              ],
              [
                50.9948237,
                35.6545778
              ],
              [
                50.9938971,
                35.6546291
              ],
              [
                50.992903,
                35.6547357
              ],
              [
                50.9913702,
                35.6548159
              ],
              [
                50.988161,
                35.6550763
              ],
              [
                50.9857807,
                35.6552719
              ],
              [
                50.9849158,
                35.6553613
              ],
              [
                50.9849294,
                35.6554318
              ],
              [
                50.9853903,
                35.6562632
              ],
              [
                50.9857006,
                35.6570092
              ],
              [
                50.9860878,
                35.6578447
              ],
              [
                50.9866574,
                35.659026
              ],
              [
                50.9875227,
                35.660836
              ],
              [
                50.9879024,
                35.6616827
              ],
              [
                50.9880176,
                35.6620259
              ],
              [
                50.9881331,
                35.66273
              ],
              [
                50.988172,
                35.6629672
              ],
              [
                50.98822,
                35.6634582
              ],
              [
                50.9883887,
                35.6650752
              ],
              [
                50.9884709,
                35.6657812
              ],
              [
                50.9885753,
                35.6666761
              ],
              [
                50.9886884,
                35.6676466
              ],
              [
                50.9887494,
                35.6681697
              ],
              [
                50.9888081,
                35.668707
              ],
              [
                50.9888567,
                35.6691569
              ],
              [
                50.9888661,
                35.6692434
              ],
              [
                50.9927944,
                35.6688402
              ],
              [
                50.9938472,
                35.6687674
              ],
              [
                50.9946037,
                35.6687202
              ],
              [
                50.9959268,
                35.6686377
              ],
              [
                50.9962542,
                35.6686173
              ],
              [
                50.9967056,
                35.6685657
              ],
              [
                50.9967817,
                35.6685604
              ],
              [
                50.9976074,
                35.6684912
              ],
              [
                50.9978091,
                35.6684738
              ],
              [
                50.9978483,
                35.6688137
              ],
              [
                50.9979028,
                35.6692854
              ],
              [
                50.997987,
                35.6699924
              ],
              [
                50.9980951,
                35.6708631
              ],
              [
                50.9982699,
                35.672438
              ],
              [
                50.9983274,
                35.672977
              ],
              [
                50.9984342,
                35.673627
              ],
              [
                50.9985487,
                35.6743485
              ],
              [
                50.9995941,
                35.6777181
              ],
              [
                50.9997184,
                35.6780012
              ],
              [
                51.0013773,
                35.6817801
              ],
              [
                51.0029015,
                35.6835534
              ],
              [
                51.0039875,
                35.6873915
              ],
              [
                51.0058173,
                35.6937471
              ],
              [
                51.0030448,
                35.6953143
              ],
              [
                51.0014209,
                35.6957364
              ],
              [
                51.0006318,
                35.6959095
              ],
              [
                50.9978278,
                35.6967548
              ],
              [
                50.9929407,
                35.698294
              ],
              [
                50.9927879,
                35.6983421
              ],
              [
                50.9928767,
                35.6985634
              ],
              [
                50.9931828,
                35.6994108
              ],
              [
                50.9932966,
                35.6997429
              ],
              [
                50.9933072,
                35.6997737
              ],
              [
                50.9933757,
                35.7001169
              ],
              [
                50.9933606,
                35.7003267
              ],
              [
                50.9933515,
                35.700453
              ],
              [
                50.993395,
                35.7007743
              ],
              [
                50.9935205,
                35.7011163
              ],
              [
                50.9932375,
                35.70122
              ],
              [
                50.9921349,
                35.7014783
              ],
              [
                50.9915648,
                35.701597
              ],
              [
                50.9910821,
                35.7016929
              ],
              [
                50.9900359,
                35.7018829
              ],
              [
                50.9899005,
                35.7014788
              ],
              [
                50.9898436,
                35.701309
              ],
              [
                50.987997,
                35.7016476
              ],
              [
                50.9863934,
                35.7019323
              ],
              [
                50.9830709,
                35.7025309
              ],
              [
                50.9788688,
                35.7032691
              ],
              [
                50.9762069,
                35.7037615
              ],
              [
                50.975248,
                35.7039554
              ],
              [
                50.9745443,
                35.7040653
              ],
              [
                50.9730415,
                35.7043025
              ],
              [
                50.9712783,
                35.7046287
              ],
              [
                50.9691545,
                35.7050869
              ],
              [
                50.9691294,
                35.7050923
              ],
              [
                50.969009,
                35.7051183
              ],
              [
                50.9640026,
                35.7060231
              ],
              [
                50.9562672,
                35.7072722
              ],
              [
                50.9555426,
                35.7069001
              ],
              [
                50.9508618,
                35.7077805
              ],
              [
                50.9385389,
                35.7106328
              ],
              [
                50.9422206,
                35.7199756
              ],
              [
                50.9404877,
                35.7205201
              ],
              [
                50.9370855,
                35.7213377
              ],
              [
                50.9323866,
                35.7221269
              ],
              [
                50.9284382,
                35.720095
              ],
              [
                50.9266487,
                35.7187188
              ],
              [
                50.9249557,
                35.7173982
              ],
              [
                50.9226629,
                35.7153764
              ],
              [
                50.9216179,
                35.71419
              ],
              [
                50.9187834,
                35.7098239
              ],
              [
                50.9179298,
                35.7082547
              ],
              [
                50.9171622,
                35.7062572
              ],
              [
                50.9167578,
                35.7052135
              ],
              [
                50.9171172,
                35.702172
              ],
              [
                50.9165818,
                35.6991531
              ],
              [
                50.9161226,
                35.6948757
              ],
              [
                50.9160969,
                35.6943111
              ],
              [
                50.9192383,
                35.6928054
              ],
              [
                50.9188778,
                35.6917598
              ],
              [
                50.9108997,
                35.6938743
              ],
              [
                50.9059632,
                35.69503
              ],
              [
                50.9047107,
                35.695483
              ],
              [
                50.9042187,
                35.6959901
              ],
              [
                50.9038824,
                35.6966323
              ],
              [
                50.9000716,
                35.7065461
              ],
              [
                50.9001031,
                35.7072262
              ],
              [
                50.9027308,
                35.7194308
              ],
              [
                50.8991517,
                35.7218139
              ],
              [
                50.8983277,
                35.7218767
              ],
              [
                50.8950576,
                35.7189499
              ],
              [
                50.8769816,
                35.7123853
              ],
              [
                50.8732782,
                35.719615
              ],
              [
                50.8538014,
                35.712108
              ],
              [
                50.8507917,
                35.7101038
              ],
              [
                50.8442526,
                35.7088027
              ],
              [
                50.8370207,
                35.7080116
              ],
              [
                50.8320043,
                35.7064941
              ],
              [
                50.8297126,
                35.7052814
              ],
              [
                50.8286054,
                35.7048632
              ],
              [
                50.8266484,
                35.7049469
              ],
              [
                50.8220651,
                35.7046541
              ],
              [
                50.8163487,
                35.7043405
              ],
              [
                50.8153744,
                35.7037954
              ],
              [
                50.8139752,
                35.7042993
              ],
              [
                50.8118316,
                35.7048444
              ],
              [
                50.8110548,
                35.6938755
              ],
              [
                50.8104966,
                35.6941038
              ],
              [
                50.8068811,
                35.6958905
              ],
              [
                50.803404,
                35.6976624
              ],
              [
                50.802819,
                35.6979606
              ],
              [
                50.801957,
                35.6983999
              ],
              [
                50.8007775,
                35.6987567
              ],
              [
                50.7999945,
                35.6989663
              ],
              [
                50.7849981,
                35.7020961
              ],
              [
                50.7696551,
                35.7041298
              ],
              [
                50.7683124,
                35.7034198
              ],
              [
                50.7609338,
                35.6995273
              ],
              [
                50.759426,
                35.6987318
              ],
              [
                50.7455233,
                35.6887396
              ],
              [
                50.7365797,
                35.6821196
              ],
              [
                50.7140921,
                35.6832351
              ],
              [
                50.7091523,
                35.68334
              ],
              [
                50.6622927,
                35.6843348
              ],
              [
                50.6473003,
                35.6843362
              ],
              [
                50.6022051,
                35.6853998
              ],
              [
                50.5603199,
                35.678499
              ],
              [
                50.5550048,
                35.6780321
              ],
              [
                50.5017886,
                35.6768269
              ],
              [
                50.4784791,
                35.6746135
              ],
              [
                50.4449465,
                35.668183
              ],
              [
                50.4320327,
                35.6659741
              ],
              [
                50.4010756,
                35.6624981
              ],
              [
                50.3899732,
                35.6601183
              ],
              [
                50.3735038,
                35.6584407
              ],
              [
                50.3684747,
                35.6549579
              ],
              [
                50.3554448,
                35.6429279
              ],
              [
                50.3504345,
                35.6366497
              ],
              [
                50.3497457,
                35.6342697
              ],
              [
                50.3443563,
                35.6265629
              ],
              [
                50.3390459,
                35.6171459
              ],
              [
                50.3390627,
                35.617093
              ],
              [
                50.3348166,
                35.6108344
              ],
              [
                50.3327898,
                35.5909379
              ],
              [
                50.3363967,
                35.5796417
              ],
              [
                50.3359547,
                35.5722262
              ],
              [
                50.3329055,
                35.5507027
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555257,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ورامین",
          "name:en": "Varamin County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q569086",
          "wikipedia": "fa:شهرستان ورامین"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.4464176,
                35.0932326
              ],
              [
                51.4480369,
                35.0929204
              ],
              [
                51.4754534,
                35.0876352
              ],
              [
                51.5157356,
                35.080332
              ],
              [
                51.5229589,
                35.0792221
              ],
              [
                51.5297971,
                35.0775504
              ],
              [
                51.5359071,
                35.0750509
              ],
              [
                51.5408083,
                35.070961
              ],
              [
                51.5473918,
                35.0641688
              ],
              [
                51.5874823,
                35.0254863
              ],
              [
                51.5993289,
                35.0177316
              ],
              [
                51.614332,
                35.0110744
              ],
              [
                51.6193319,
                35.0099559
              ],
              [
                51.6321085,
                35.0080164
              ],
              [
                51.6365551,
                35.0077368
              ],
              [
                51.6384983,
                35.0077368
              ],
              [
                51.6421116,
                35.0077368
              ],
              [
                51.6459982,
                35.0080164
              ],
              [
                51.650445,
                35.008287
              ],
              [
                51.674988,
                35.0026244
              ],
              [
                51.6794313,
                35.0029041
              ],
              [
                51.6833688,
                35.0031775
              ],
              [
                51.6863744,
                35.0031838
              ],
              [
                51.6894311,
                35.0029041
              ],
              [
                51.6922112,
                35.0026244
              ],
              [
                51.7069308,
                34.9998458
              ],
              [
                51.7183207,
                34.9970671
              ],
              [
                51.7219341,
                34.9959575
              ],
              [
                51.7308239,
                34.9923488
              ],
              [
                51.7327673,
                34.9909414
              ],
              [
                51.7747135,
                34.9631722
              ],
              [
                51.7758234,
                34.9626219
              ],
              [
                51.8098465,
                34.946282
              ],
              [
                51.8290129,
                34.9348878
              ],
              [
                51.8487359,
                34.9251713
              ],
              [
                51.9073521,
                34.8951647
              ],
              [
                51.9351782,
                34.8832909
              ],
              [
                51.9354584,
                34.8830113
              ],
              [
                51.9521246,
                34.8743957
              ],
              [
                51.9524014,
                34.8738453
              ],
              [
                51.962958,
                34.8677287
              ],
              [
                51.9649046,
                34.8652387
              ],
              [
                51.9654579,
                34.8657891
              ],
              [
                51.9696244,
                34.871617
              ],
              [
                51.9699045,
                34.8718967
              ],
              [
                51.9768479,
                34.8810717
              ],
              [
                51.9774045,
                34.8824519
              ],
              [
                51.9785145,
                34.8838502
              ],
              [
                51.985181,
                34.896345
              ],
              [
                51.9985176,
                34.9146855
              ],
              [
                51.9987942,
                34.9149561
              ],
              [
                52.0015707,
                34.9185647
              ],
              [
                52.0212938,
                34.9671794
              ],
              [
                52.0215739,
                34.9677388
              ],
              [
                52.0309338,
                34.9965863
              ],
              [
                52.0320438,
                34.9996445
              ],
              [
                52.035657,
                35.0118681
              ],
              [
                52.0398237,
                35.0463098
              ],
              [
                52.0395435,
                35.0482492
              ],
              [
                52.039267,
                35.0524257
              ],
              [
                52.0389904,
                35.0607609
              ],
              [
                52.0387103,
                35.065199
              ],
              [
                52.0381569,
                35.0688163
              ],
              [
                52.0378768,
                35.0693666
              ],
              [
                52.0323237,
                35.0826989
              ],
              [
                52.0320438,
                35.0829785
              ],
              [
                52.0309338,
                35.0854772
              ],
              [
                52.0298238,
                35.087146
              ],
              [
                52.0025974,
                35.1132599
              ],
              [
                51.9645411,
                35.1360359
              ],
              [
                51.9637077,
                35.1365951
              ],
              [
                51.9500945,
                35.1474282
              ],
              [
                51.9478745,
                35.150486
              ],
              [
                51.9467612,
                35.1515954
              ],
              [
                51.9464847,
                35.1521547
              ],
              [
                51.9431513,
                35.1579815
              ],
              [
                51.9417613,
                35.1613189
              ],
              [
                51.9334282,
                35.176319
              ],
              [
                51.9328714,
                35.1779876
              ],
              [
                51.8953718,
                35.2307702
              ],
              [
                51.8792587,
                35.2485472
              ],
              [
                51.8789819,
                35.2490975
              ],
              [
                51.8770353,
                35.2516048
              ],
              [
                51.8695355,
                35.2699317
              ],
              [
                51.8692586,
                35.2702112
              ],
              [
                51.869169,
                35.2709737
              ],
              [
                51.826274,
                35.270946
              ],
              [
                51.7918389,
                35.2831842
              ],
              [
                51.7630122,
                35.2830557
              ],
              [
                51.7553042,
                35.2668827
              ],
              [
                51.7487014,
                35.2657298
              ],
              [
                51.7481617,
                35.2657218
              ],
              [
                51.7463221,
                35.2652716
              ],
              [
                51.7460838,
                35.2651598
              ],
              [
                51.7444506,
                35.2641617
              ],
              [
                51.7324497,
                35.2772498
              ],
              [
                51.7270022,
                35.2770203
              ],
              [
                51.7145268,
                35.2765294
              ],
              [
                51.7078349,
                35.2762787
              ],
              [
                51.7074146,
                35.2745359
              ],
              [
                51.7072568,
                35.2719746
              ],
              [
                51.6947782,
                35.2804366
              ],
              [
                51.6872184,
                35.2730616
              ],
              [
                51.686231,
                35.274167
              ],
              [
                51.6855626,
                35.2748976
              ],
              [
                51.68499,
                35.2754049
              ],
              [
                51.6825855,
                35.2753073
              ],
              [
                51.681656,
                35.2735865
              ],
              [
                51.6808534,
                35.2735727
              ],
              [
                51.6791948,
                35.2706017
              ],
              [
                51.6772337,
                35.2713176
              ],
              [
                51.6772622,
                35.2728541
              ],
              [
                51.6771385,
                35.2750628
              ],
              [
                51.6733097,
                35.2749201
              ],
              [
                51.6690651,
                35.2747385
              ],
              [
                51.6591399,
                35.2743886
              ],
              [
                51.6591759,
                35.2751629
              ],
              [
                51.6591438,
                35.2759783
              ],
              [
                51.6585051,
                35.279773
              ],
              [
                51.658334,
                35.2859147
              ],
              [
                51.6580891,
                35.2944808
              ],
              [
                51.6583001,
                35.3010458
              ],
              [
                51.6585287,
                35.3029801
              ],
              [
                51.6586154,
                35.3034527
              ],
              [
                51.6587011,
                35.304631
              ],
              [
                51.6581752,
                35.3083743
              ],
              [
                51.6601112,
                35.3084288
              ],
              [
                51.6608976,
                35.308724
              ],
              [
                51.6635498,
                35.3108252
              ],
              [
                51.6644768,
                35.3110984
              ],
              [
                51.6662277,
                35.3106781
              ],
              [
                51.6715695,
                35.3092271
              ],
              [
                51.6727522,
                35.3121272
              ],
              [
                51.6744615,
                35.3114629
              ],
              [
                51.6777585,
                35.3143484
              ],
              [
                51.6727395,
                35.3160831
              ],
              [
                51.6739651,
                35.3182202
              ],
              [
                51.6780948,
                35.3225246
              ],
              [
                51.6754411,
                35.3241239
              ],
              [
                51.6740835,
                35.3250306
              ],
              [
                51.6734346,
                35.3255093
              ],
              [
                51.6729335,
                35.3261189
              ],
              [
                51.6720307,
                35.3273419
              ],
              [
                51.6710077,
                35.3288791
              ],
              [
                51.6699957,
                35.3304972
              ],
              [
                51.6695613,
                35.3312337
              ],
              [
                51.6691796,
                35.3318591
              ],
              [
                51.6685026,
                35.3329391
              ],
              [
                51.6680935,
                35.3335904
              ],
              [
                51.6672687,
                35.3349371
              ],
              [
                51.6658341,
                35.3372943
              ],
              [
                51.6652103,
                35.3382981
              ],
              [
                51.6646404,
                35.339235
              ],
              [
                51.6639849,
                35.3402933
              ],
              [
                51.6630904,
                35.3417314
              ],
              [
                51.6618402,
                35.3437626
              ],
              [
                51.6607654,
                35.3455303
              ],
              [
                51.6585617,
                35.3491257
              ],
              [
                51.6568329,
                35.351936
              ],
              [
                51.656168,
                35.3529965
              ],
              [
                51.6559201,
                35.3534088
              ],
              [
                51.6556337,
                35.3538767
              ],
              [
                51.6553838,
                35.35429
              ],
              [
                51.6549836,
                35.3549435
              ],
              [
                51.6544847,
                35.3557557
              ],
              [
                51.6539276,
                35.356663
              ],
              [
                51.6533963,
                35.3575258
              ],
              [
                51.6529147,
                35.3583129
              ],
              [
                51.6523986,
                35.3591409
              ],
              [
                51.6521122,
                35.359577
              ],
              [
                51.6517976,
                35.3600297
              ],
              [
                51.6515134,
                35.3603942
              ],
              [
                51.6512415,
                35.3607206
              ],
              [
                51.6509872,
                35.3609961
              ],
              [
                51.650676,
                35.3612896
              ],
              [
                51.6502382,
                35.3616859
              ],
              [
                51.6497887,
                35.3620355
              ],
              [
                51.6492924,
                35.3623865
              ],
              [
                51.6488021,
                35.3626907
              ],
              [
                51.6482855,
                35.3629784
              ],
              [
                51.6476536,
                35.3632698
              ],
              [
                51.6489035,
                35.3662593
              ],
              [
                51.6550874,
                35.3741032
              ],
              [
                51.6504884,
                35.3776977
              ],
              [
                51.6545416,
                35.3811447
              ],
              [
                51.6583112,
                35.3800363
              ],
              [
                51.6588184,
                35.3799504
              ],
              [
                51.659206,
                35.3800149
              ],
              [
                51.6594255,
                35.3801178
              ],
              [
                51.6598274,
                35.3803985
              ],
              [
                51.6743334,
                35.391695
              ],
              [
                51.6758134,
                35.3949818
              ],
              [
                51.6808286,
                35.3982
              ],
              [
                51.6785475,
                35.4005615
              ],
              [
                51.6700593,
                35.4031353
              ],
              [
                51.6629526,
                35.4073328
              ],
              [
                51.6617939,
                35.4082142
              ],
              [
                51.6609184,
                35.408613
              ],
              [
                51.6591417,
                35.4090747
              ],
              [
                51.6577255,
                35.4093475
              ],
              [
                51.6568243,
                35.4097463
              ],
              [
                51.6585237,
                35.4110894
              ],
              [
                51.6583692,
                35.4117819
              ],
              [
                51.6584207,
                35.4119708
              ],
              [
                51.6588069,
                35.4124954
              ],
              [
                51.6589872,
                35.4127472
              ],
              [
                51.6592962,
                35.4129151
              ],
              [
                51.6593734,
                35.4132929
              ],
              [
                51.6592962,
                35.4138175
              ],
              [
                51.6588327,
                35.4144471
              ],
              [
                51.6582662,
                35.4149507
              ],
              [
                51.6576997,
                35.4155173
              ],
              [
                51.656438,
                35.4156012
              ],
              [
                51.6561548,
                35.4158321
              ],
              [
                51.6558458,
                35.415979
              ],
              [
                51.655408,
                35.415937
              ],
              [
                51.6536313,
                35.4150346
              ],
              [
                51.6532194,
                35.4153914
              ],
              [
                51.6524211,
                35.4151815
              ],
              [
                51.6512109,
                35.4170282
              ],
              [
                51.6504384,
                35.4164406
              ],
              [
                51.6494857,
                35.4163567
              ],
              [
                51.648636,
                35.4171541
              ],
              [
                51.6480695,
                35.4168183
              ],
              [
                51.6471168,
                35.4165455
              ],
              [
                51.6465503,
                35.4161678
              ],
              [
                51.6457006,
                35.4164616
              ],
              [
                51.6443616,
                35.4150137
              ],
              [
                51.6425592,
                35.4156642
              ],
              [
                51.6412975,
                35.4156222
              ],
              [
                51.639907,
                35.4151815
              ],
              [
                51.6395723,
                35.4154963
              ],
              [
                51.6386196,
                35.4155802
              ],
              [
                51.6377183,
                35.4151815
              ],
              [
                51.6370489,
                35.4153284
              ],
              [
                51.6363794,
                35.4149297
              ],
              [
                51.6351177,
                35.4142162
              ],
              [
                51.633753,
                35.4136706
              ],
              [
                51.6319763,
                35.4133978
              ],
              [
                51.6307918,
                35.4125794
              ],
              [
                51.6304313,
                35.4120127
              ],
              [
                51.6298391,
                35.4119288
              ],
              [
                51.6296588,
                35.4114461
              ],
              [
                51.6284486,
                35.4110474
              ],
              [
                51.6278626,
                35.4108339
              ],
              [
                51.626326,
                35.4101488
              ],
              [
                51.6305841,
                35.4076494
              ],
              [
                51.6280222,
                35.4060235
              ],
              [
                51.6217317,
                35.4050841
              ],
              [
                51.620985,
                35.4047273
              ],
              [
                51.6231994,
                35.401684
              ],
              [
                51.6172514,
                35.3981998
              ],
              [
                51.620304,
                35.3941238
              ],
              [
                51.6133517,
                35.3904714
              ],
              [
                51.6110858,
                35.3931792
              ],
              [
                51.6061162,
                35.3949214
              ],
              [
                51.605273,
                35.3949796
              ],
              [
                51.6013526,
                35.3927804
              ],
              [
                51.6000137,
                35.3926964
              ],
              [
                51.5937116,
                35.389417
              ],
              [
                51.5891729,
                35.3961162
              ],
              [
                51.5751134,
                35.3891051
              ],
              [
                51.5736972,
                35.3868589
              ],
              [
                51.571972,
                35.3844238
              ],
              [
                51.571457,
                35.3833531
              ],
              [
                51.571148,
                35.3826184
              ],
              [
                51.5699893,
                35.3812328
              ],
              [
                51.5690623,
                35.3794903
              ],
              [
                51.5665647,
                35.376656
              ],
              [
                51.564891,
                35.3745565
              ],
              [
                51.564067,
                35.3737377
              ],
              [
                51.5638353,
                35.3729608
              ],
              [
                51.5637838,
                35.372226
              ],
              [
                51.5633975,
                35.3715751
              ],
              [
                51.5622645,
                35.3705462
              ],
              [
                51.5616466,
                35.3674387
              ],
              [
                51.551701,
                35.3639609
              ],
              [
                51.5501303,
                35.362428
              ],
              [
                51.5475296,
                35.3599291
              ],
              [
                51.5367922,
                35.3590051
              ],
              [
                51.5260258,
                35.3582184
              ],
              [
                51.5233994,
                35.3580924
              ],
              [
                51.5206957,
                35.3577144
              ],
              [
                51.5119153,
                35.3575464
              ],
              [
                51.5074869,
                35.3596125
              ],
              [
                51.5040623,
                35.3609145
              ],
              [
                51.4978567,
                35.3632454
              ],
              [
                51.4949986,
                35.3619225
              ],
              [
                51.4917997,
                35.36283
              ],
              [
                51.4918517,
                35.3618262
              ],
              [
                51.4922894,
                35.3609443
              ],
              [
                51.4934224,
                35.3595373
              ],
              [
                51.4930619,
                35.3580463
              ],
              [
                51.4912594,
                35.3557783
              ],
              [
                51.4913624,
                35.3545813
              ],
              [
                51.4916972,
                35.3537413
              ],
              [
                51.4929589,
                35.3535943
              ],
              [
                51.4922379,
                35.3527542
              ],
              [
                51.4912852,
                35.3527122
              ],
              [
                51.4902552,
                35.3512421
              ],
              [
                51.4918516,
                35.3507381
              ],
              [
                51.4905384,
                35.3491839
              ],
              [
                51.4918001,
                35.3480708
              ],
              [
                51.4913109,
                35.3468947
              ],
              [
                51.4899977,
                35.3459075
              ],
              [
                51.487603,
                35.3439122
              ],
              [
                51.4877575,
                35.3429461
              ],
              [
                51.4874485,
                35.3415598
              ],
              [
                51.4862126,
                35.3389342
              ],
              [
                51.4862126,
                35.3376319
              ],
              [
                51.4868821,
                35.3357835
              ],
              [
                51.4873455,
                35.3346492
              ],
              [
                51.4858473,
                35.333472
              ],
              [
                51.4865323,
                35.3282262
              ],
              [
                51.4866455,
                35.3273589
              ],
              [
                51.4860018,
                35.3234304
              ],
              [
                51.4862335,
                35.3222749
              ],
              [
                51.4877785,
                35.3210143
              ],
              [
                51.4893234,
                35.3162451
              ],
              [
                51.4902476,
                35.3151478
              ],
              [
                51.4582355,
                35.2941687
              ],
              [
                51.4653938,
                35.2955768
              ],
              [
                51.4719598,
                35.2951354
              ],
              [
                51.4665267,
                35.2914155
              ],
              [
                51.4648015,
                35.2886832
              ],
              [
                51.4857614,
                35.2820229
              ],
              [
                51.4847314,
                35.2793324
              ],
              [
                51.5026529,
                35.2734465
              ],
              [
                51.5072105,
                35.272059
              ],
              [
                51.5095022,
                35.2717857
              ],
              [
                51.5106351,
                35.2722062
              ],
              [
                51.5151413,
                35.2708397
              ],
              [
                51.5163948,
                35.2701982
              ],
              [
                51.5174763,
                35.2692311
              ],
              [
                51.5198452,
                35.2676334
              ],
              [
                51.5207464,
                35.2668135
              ],
              [
                51.5207464,
                35.2657623
              ],
              [
                51.5202829,
                35.2654049
              ],
              [
                51.5199482,
                35.2649213
              ],
              [
                51.5198967,
                35.2636389
              ],
              [
                51.5205147,
                35.2630081
              ],
              [
                51.5205147,
                35.2622512
              ],
              [
                51.5204632,
                35.2614313
              ],
              [
                51.5206434,
                35.2601908
              ],
              [
                51.5211069,
                35.2593918
              ],
              [
                51.5208752,
                35.2579621
              ],
              [
                51.5217164,
                35.2575568
              ],
              [
                51.5223136,
                35.2572691
              ],
              [
                51.5235531,
                35.2572893
              ],
              [
                51.5238878,
                35.2563221
              ],
              [
                51.5240681,
                35.255502
              ],
              [
                51.5251238,
                35.254682
              ],
              [
                51.525819,
                35.254661
              ],
              [
                51.5272867,
                35.2550605
              ],
              [
                51.52757,
                35.2548082
              ],
              [
                51.5266173,
                35.2530419
              ],
              [
                51.52654,
                35.2522429
              ],
              [
                51.5266688,
                35.2516541
              ],
              [
                51.52757,
                35.2508971
              ],
              [
                51.5283939,
                35.2498668
              ],
              [
                51.5295012,
                35.2481214
              ],
              [
                51.5289604,
                35.2460186
              ],
              [
                51.5290892,
                35.2439998
              ],
              [
                51.5286772,
                35.2425067
              ],
              [
                51.5287029,
                35.2409925
              ],
              [
                51.5288059,
                35.2397096
              ],
              [
                51.5293724,
                35.239268
              ],
              [
                51.5302736,
                35.2393101
              ],
              [
                51.5309689,
                35.2389946
              ],
              [
                51.5310976,
                35.2384268
              ],
              [
                51.5309689,
                35.2376066
              ],
              [
                51.5309689,
                35.2369125
              ],
              [
                51.5325653,
                35.235882
              ],
              [
                51.5340073,
                35.2353562
              ],
              [
                51.5347025,
                35.2347883
              ],
              [
                51.534754,
                35.2343256
              ],
              [
                51.5341103,
                35.2340733
              ],
              [
                51.5335695,
                35.2337998
              ],
              [
                51.5337755,
                35.2330006
              ],
              [
                51.5345738,
                35.2324117
              ],
              [
                51.5359127,
                35.2311918
              ],
              [
                51.5368139,
                35.2305608
              ],
              [
                51.536299,
                35.2296985
              ],
              [
                51.5360157,
                35.2291516
              ],
              [
                51.5362732,
                35.2278686
              ],
              [
                51.5367624,
                35.2261017
              ],
              [
                51.5377409,
                35.2234514
              ],
              [
                51.5390541,
                35.2210113
              ],
              [
                51.5398266,
                35.2199806
              ],
              [
                51.5412428,
                35.2187184
              ],
              [
                51.5411656,
                35.2177929
              ],
              [
                51.5407021,
                35.2174142
              ],
              [
                51.5410111,
                35.2150791
              ],
              [
                51.5408823,
                35.2128913
              ],
              [
                51.5408308,
                35.2114397
              ],
              [
                51.5391314,
                35.2100932
              ],
              [
                51.5382301,
                35.2092727
              ],
              [
                51.5379727,
                35.2084733
              ],
              [
                51.5390284,
                35.207779
              ],
              [
                51.5406248,
                35.207758
              ],
              [
                51.5413458,
                35.206706
              ],
              [
                51.5414488,
                35.2059276
              ],
              [
                51.5411656,
                35.2051701
              ],
              [
                51.5410626,
                35.2042865
              ],
              [
                51.5411398,
                35.2024139
              ],
              [
                51.541732,
                35.201404
              ],
              [
                51.5420668,
                35.1996787
              ],
              [
                51.5415003,
                35.1986056
              ],
              [
                51.5413201,
                35.1980374
              ],
              [
                51.5417578,
                35.1969433
              ],
              [
                51.5426075,
                35.1965435
              ],
              [
                51.543071,
                35.1957018
              ],
              [
                51.543998,
                35.1941026
              ],
              [
                51.5451567,
                35.1930505
              ],
              [
                51.5461352,
                35.1922088
              ],
              [
                51.5465986,
                35.1915354
              ],
              [
                51.5470879,
                35.1901886
              ],
              [
                51.5463411,
                35.1893469
              ],
              [
                51.5455429,
                35.1889681
              ],
              [
                51.5452854,
                35.1886525
              ],
              [
                51.5450537,
                35.187937
              ],
              [
                51.5450537,
                35.1873056
              ],
              [
                51.5454142,
                35.1865901
              ],
              [
                51.5451309,
                35.18558
              ],
              [
                51.5451309,
                35.1845909
              ],
              [
                51.5455429,
                35.1836649
              ],
              [
                51.5463411,
                35.1826548
              ],
              [
                51.5472939,
                35.1820024
              ],
              [
                51.5478861,
                35.1812868
              ],
              [
                51.5476544,
                35.180929
              ],
              [
                51.5474999,
                35.1806554
              ],
              [
                51.5479633,
                35.1795821
              ],
              [
                51.5485298,
                35.1782562
              ],
              [
                51.549534,
                35.1771197
              ],
              [
                51.5502808,
                35.1770355
              ],
              [
                51.5510275,
                35.176804
              ],
              [
                51.552212,
                35.1761094
              ],
              [
                51.5531389,
                35.1749729
              ],
              [
                51.5536797,
                35.1736679
              ],
              [
                51.5534222,
                35.1726787
              ],
              [
                51.552727,
                35.1722577
              ],
              [
                51.5520317,
                35.1722577
              ],
              [
                51.5514652,
                35.1714158
              ],
              [
                51.5514652,
                35.1704897
              ],
              [
                51.5531647,
                35.1691004
              ],
              [
                51.5533707,
                35.1685111
              ],
              [
                51.5543749,
                35.1679007
              ],
              [
                51.5560744,
                35.1676481
              ],
              [
                51.5568468,
                35.1671639
              ],
              [
                51.5576708,
                35.1657747
              ],
              [
                51.5576708,
                35.1647643
              ],
              [
                51.5567438,
                35.1631855
              ],
              [
                51.5572073,
                35.1620488
              ],
              [
                51.5584175,
                35.1615436
              ],
              [
                51.558778,
                35.160491
              ],
              [
                51.5587265,
                35.1595437
              ],
              [
                51.5581858,
                35.1586175
              ],
              [
                51.5573361,
                35.1579859
              ],
              [
                51.5571816,
                35.1573122
              ],
              [
                51.5575678,
                35.155607
              ],
              [
                51.5576193,
                35.1541755
              ],
              [
                51.5576193,
                35.1533123
              ],
              [
                51.5567438,
                35.1513333
              ],
              [
                51.5567438,
                35.1502806
              ],
              [
                51.5492766,
                35.1478173
              ],
              [
                51.5334408,
                35.1426588
              ],
              [
                51.5250466,
                35.1398373
              ],
              [
                51.5215447,
                35.1381317
              ],
              [
                51.5141547,
                35.1340255
              ],
              [
                51.5070736,
                35.1299191
              ],
              [
                51.4982159,
                35.1251386
              ],
              [
                51.4927828,
                35.1226535
              ],
              [
                51.4866545,
                35.1202104
              ],
              [
                51.4758141,
                35.115998
              ],
              [
                51.4644186,
                35.1113534
              ],
              [
                51.4620754,
                35.1097736
              ],
              [
                51.4602472,
                35.1084466
              ],
              [
                51.4567195,
                35.1051183
              ],
              [
                51.4464176,
                35.0932326
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555263,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پاکدشت",
          "name:en": "Pakdasht County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282185",
          "wikipedia": "fa:شهرستان پاکدشت"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.5839897,
                35.4653324
              ],
              [
                51.5859669,
                35.4652522
              ],
              [
                51.5863739,
                35.4647333
              ],
              [
                51.5869146,
                35.4643558
              ],
              [
                51.5890775,
                35.4638944
              ],
              [
                51.6083894,
                35.4602242
              ],
              [
                51.6095224,
                35.4608743
              ],
              [
                51.6111635,
                35.4613969
              ],
              [
                51.6147654,
                35.4618248
              ],
              [
                51.6166995,
                35.4623794
              ],
              [
                51.6211034,
                35.4524657
              ],
              [
                51.6208594,
                35.4518104
              ],
              [
                51.6198037,
                35.4511812
              ],
              [
                51.617924,
                35.4496919
              ],
              [
                51.6156323,
                35.4462098
              ],
              [
                51.6143706,
                35.4455176
              ],
              [
                51.6114609,
                35.4439233
              ],
              [
                51.6083195,
                35.4425598
              ],
              [
                51.6055128,
                35.4392452
              ],
              [
                51.609813,
                35.4340004
              ],
              [
                51.6109459,
                35.4325947
              ],
              [
                51.6121561,
                35.4329933
              ],
              [
                51.6129029,
                35.4337276
              ],
              [
                51.6155293,
                35.4350703
              ],
              [
                51.6169197,
                35.4353221
              ],
              [
                51.6204731,
                35.4362871
              ],
              [
                51.6212971,
                35.4365389
              ],
              [
                51.624696,
                35.4365389
              ],
              [
                51.6255457,
                35.4362871
              ],
              [
                51.6263182,
                35.4364969
              ],
              [
                51.6288931,
                35.4382802
              ],
              [
                51.6291764,
                35.4371893
              ],
              [
                51.6298201,
                35.4368326
              ],
              [
                51.6297468,
                35.4366619
              ],
              [
                51.6306223,
                35.4369346
              ],
              [
                51.6309313,
                35.4363052
              ],
              [
                51.6311115,
                35.4359066
              ],
              [
                51.6306223,
                35.4345219
              ],
              [
                51.630339,
                35.4326337
              ],
              [
                51.6296696,
                35.4314588
              ],
              [
                51.6278929,
                35.4288991
              ],
              [
                51.6269144,
                35.427913
              ],
              [
                51.6253437,
                35.426738
              ],
              [
                51.6241077,
                35.425563
              ],
              [
                51.6226143,
                35.4251643
              ],
              [
                51.6202454,
                35.423192
              ],
              [
                51.6186747,
                35.4224576
              ],
              [
                51.6183657,
                35.4220799
              ],
              [
                51.616898,
                35.4208838
              ],
              [
                51.6154225,
                35.4181606
              ],
              [
                51.6162838,
                35.4178714
              ],
              [
                51.6233133,
                35.4118697
              ],
              [
                51.626326,
                35.4101488
              ],
              [
                51.6278626,
                35.4108339
              ],
              [
                51.6284486,
                35.4110474
              ],
              [
                51.6296588,
                35.4114461
              ],
              [
                51.6298391,
                35.4119288
              ],
              [
                51.6304313,
                35.4120127
              ],
              [
                51.6307918,
                35.4125794
              ],
              [
                51.6319763,
                35.4133978
              ],
              [
                51.633753,
                35.4136706
              ],
              [
                51.6351177,
                35.4142162
              ],
              [
                51.6363794,
                35.4149297
              ],
              [
                51.6370489,
                35.4153284
              ],
              [
                51.6377183,
                35.4151815
              ],
              [
                51.6386196,
                35.4155802
              ],
              [
                51.6395723,
                35.4154963
              ],
              [
                51.639907,
                35.4151815
              ],
              [
                51.6412975,
                35.4156222
              ],
              [
                51.6425592,
                35.4156642
              ],
              [
                51.6443616,
                35.4150137
              ],
              [
                51.6457006,
                35.4164616
              ],
              [
                51.6465503,
                35.4161678
              ],
              [
                51.6471168,
                35.4165455
              ],
              [
                51.6480695,
                35.4168183
              ],
              [
                51.648636,
                35.4171541
              ],
              [
                51.6494857,
                35.4163567
              ],
              [
                51.6504384,
                35.4164406
              ],
              [
                51.6512109,
                35.4170282
              ],
              [
                51.6524211,
                35.4151815
              ],
              [
                51.6532194,
                35.4153914
              ],
              [
                51.6536313,
                35.4150346
              ],
              [
                51.655408,
                35.415937
              ],
              [
                51.6558458,
                35.415979
              ],
              [
                51.6561548,
                35.4158321
              ],
              [
                51.656438,
                35.4156012
              ],
              [
                51.6576997,
                35.4155173
              ],
              [
                51.6582662,
                35.4149507
              ],
              [
                51.6588327,
                35.4144471
              ],
              [
                51.6592962,
                35.4138175
              ],
              [
                51.6593734,
                35.4132929
              ],
              [
                51.6592962,
                35.4129151
              ],
              [
                51.6589872,
                35.4127472
              ],
              [
                51.6588069,
                35.4124954
              ],
              [
                51.6584207,
                35.4119708
              ],
              [
                51.6583692,
                35.4117819
              ],
              [
                51.6585237,
                35.4110894
              ],
              [
                51.6568243,
                35.4097463
              ],
              [
                51.6577255,
                35.4093475
              ],
              [
                51.6591417,
                35.4090747
              ],
              [
                51.6609184,
                35.408613
              ],
              [
                51.6617939,
                35.4082142
              ],
              [
                51.6629526,
                35.4073328
              ],
              [
                51.6700593,
                35.4031353
              ],
              [
                51.6785475,
                35.4005615
              ],
              [
                51.6808286,
                35.3982
              ],
              [
                51.6963192,
                35.3905036
              ],
              [
                51.709707,
                35.3825168
              ],
              [
                51.7226104,
                35.4076763
              ],
              [
                51.7327299,
                35.404147
              ],
              [
                51.7373483,
                35.4031105
              ],
              [
                51.7429359,
                35.4001301
              ],
              [
                51.7472292,
                35.3994673
              ],
              [
                51.7506909,
                35.3988893
              ],
              [
                51.7518582,
                35.3984397
              ],
              [
                51.7542014,
                35.3976211
              ],
              [
                51.7638316,
                35.3966766
              ],
              [
                51.7655053,
                35.3966556
              ],
              [
                51.7682369,
                35.3973567
              ],
              [
                51.772491,
                35.3877623
              ],
              [
                51.782002,
                35.3863061
              ],
              [
                51.7824573,
                35.3857983
              ],
              [
                51.7839641,
                35.3831364
              ],
              [
                51.7856669,
                35.3768808
              ],
              [
                51.7883132,
                35.3770661
              ],
              [
                51.7890529,
                35.3711549
              ],
              [
                51.7908936,
                35.3721816
              ],
              [
                51.7942925,
                35.3721396
              ],
              [
                51.7955798,
                35.3716974
              ],
              [
                51.8007307,
                35.3681175
              ],
              [
                51.8035119,
                35.3661927
              ],
              [
                51.7995799,
                35.3590235
              ],
              [
                51.8046588,
                35.3568345
              ],
              [
                51.8148813,
                35.3528444
              ],
              [
                51.8130804,
                35.3472905
              ],
              [
                51.8175306,
                35.3463302
              ],
              [
                51.8159112,
                35.341734
              ],
              [
                51.8268972,
                35.3382975
              ],
              [
                51.8617842,
                35.3124876
              ],
              [
                51.8846339,
                35.2955786
              ],
              [
                51.8976783,
                35.3094148
              ],
              [
                51.9024015,
                35.3152496
              ],
              [
                51.9043448,
                35.3180273
              ],
              [
                51.932262,
                35.3128064
              ],
              [
                51.9359957,
                35.3126593
              ],
              [
                51.9413686,
                35.3121009
              ],
              [
                51.9436603,
                35.3134876
              ],
              [
                51.9443555,
                35.3156938
              ],
              [
                51.9452825,
                35.3162401
              ],
              [
                51.946261,
                35.3176268
              ],
              [
                51.9471364,
                35.318215
              ],
              [
                51.9476772,
                35.3190344
              ],
              [
                51.9491706,
                35.320337
              ],
              [
                51.9494281,
                35.3209043
              ],
              [
                51.9498144,
                35.3215346
              ],
              [
                51.9535222,
                35.3235094
              ],
              [
                51.9543977,
                35.3244758
              ],
              [
                51.9550929,
                35.3253792
              ],
              [
                51.9555307,
                35.3261355
              ],
              [
                51.9555307,
                35.3267237
              ],
              [
                51.9554019,
                35.3271859
              ],
              [
                51.9554019,
                35.3279422
              ],
              [
                51.9558654,
                35.3287825
              ],
              [
                51.9567409,
                35.3295387
              ],
              [
                51.9579769,
                35.3307151
              ],
              [
                51.9586978,
                35.3311563
              ],
              [
                51.9593673,
                35.3315134
              ],
              [
                51.9593673,
                35.3323536
              ],
              [
                51.960217,
                35.333572
              ],
              [
                51.9607578,
                35.3345593
              ],
              [
                51.9616332,
                35.3355046
              ],
              [
                51.9625345,
                35.3377311
              ],
              [
                51.9628177,
                35.3395375
              ],
              [
                51.9632297,
                35.3401677
              ],
              [
                51.9629722,
                35.34168
              ],
              [
                51.9629722,
                35.3424361
              ],
              [
                51.962998,
                35.3433813
              ],
              [
                51.962998,
                35.3446835
              ],
              [
                51.9641567,
                35.3463217
              ],
              [
                51.9655214,
                35.3478129
              ],
              [
                51.9661394,
                35.348569
              ],
              [
                51.9664998,
                35.3500392
              ],
              [
                51.9671178,
                35.3516353
              ],
              [
                51.9676071,
                35.3526014
              ],
              [
                51.9694095,
                35.3537774
              ],
              [
                51.9706455,
                35.3549955
              ],
              [
                51.9718557,
                35.3560875
              ],
              [
                51.9646716,
                35.3576205
              ],
              [
                51.9593158,
                35.3584395
              ],
              [
                51.952724,
                35.3603924
              ],
              [
                51.9392057,
                35.3649071
              ],
              [
                51.9297557,
                35.3679098
              ],
              [
                51.9243566,
                35.3698347
              ],
              [
                51.9253093,
                35.38176
              ],
              [
                51.9242793,
                35.3949219
              ],
              [
                51.9231206,
                35.4000854
              ],
              [
                51.9209319,
                35.4047028
              ],
              [
                51.9119893,
                35.4143066
              ],
              [
                51.9129545,
                35.4224732
              ],
              [
                51.9135114,
                35.4241415
              ],
              [
                51.9135113,
                35.4255302
              ],
              [
                51.9176778,
                35.4413558
              ],
              [
                51.9190678,
                35.4471991
              ],
              [
                51.9196211,
                35.4480285
              ],
              [
                51.9251778,
                35.4702471
              ],
              [
                51.9254578,
                35.4708061
              ],
              [
                51.9257344,
                35.4763606
              ],
              [
                51.9257344,
                35.4794175
              ],
              [
                51.9260109,
                35.4799675
              ],
              [
                51.9257344,
                35.4810856
              ],
              [
                51.929202,
                35.4880967
              ],
              [
                51.9286453,
                35.4883852
              ],
              [
                51.9165801,
                35.4958272
              ],
              [
                51.9036197,
                35.5142035
              ],
              [
                51.8936562,
                35.5341171
              ],
              [
                51.8929612,
                35.5345318
              ],
              [
                51.8916034,
                35.5390013
              ],
              [
                51.8891143,
                35.5440297
              ],
              [
                51.8862819,
                35.5458455
              ],
              [
                51.8742656,
                35.5581357
              ],
              [
                51.8734931,
                35.5637914
              ],
              [
                51.8709162,
                35.5658404
              ],
              [
                51.8686928,
                35.5666698
              ],
              [
                51.8670261,
                35.5669492
              ],
              [
                51.8476047,
                35.5699194
              ],
              [
                51.8462147,
                35.5701897
              ],
              [
                51.8442714,
                35.5707487
              ],
              [
                51.85256,
                35.5730175
              ],
              [
                51.8457863,
                35.5738557
              ],
              [
                51.8382485,
                35.5745453
              ],
              [
                51.8296559,
                35.5748593
              ],
              [
                51.8238658,
                35.5749818
              ],
              [
                51.8175745,
                35.575084
              ],
              [
                51.8147528,
                35.5748833
              ],
              [
                51.8132268,
                35.5748769
              ],
              [
                51.8070442,
                35.5717262
              ],
              [
                51.8045836,
                35.5712029
              ],
              [
                51.7980866,
                35.5696493
              ],
              [
                51.7944064,
                35.5701903
              ],
              [
                51.7888954,
                35.57225
              ],
              [
                51.7810964,
                35.5766373
              ],
              [
                51.7690801,
                35.5850838
              ],
              [
                51.7659498,
                35.5882705
              ],
              [
                51.7551326,
                35.5983451
              ],
              [
                51.7505836,
                35.6019741
              ],
              [
                51.7495106,
                35.6045563
              ],
              [
                51.7466783,
                35.6060915
              ],
              [
                51.7410135,
                35.6103133
              ],
              [
                51.7326879,
                35.6181981
              ],
              [
                51.7246198,
                35.6241285
              ],
              [
                51.7186975,
                35.6271285
              ],
              [
                51.7110878,
                35.6302273
              ],
              [
                51.7072557,
                35.6323661
              ],
              [
                51.6999419,
                35.6353072
              ],
              [
                51.6907862,
                35.6382766
              ],
              [
                51.6823764,
                35.6394165
              ],
              [
                51.6737632,
                35.6430293
              ],
              [
                51.6723764,
                35.6433086
              ],
              [
                51.665704,
                35.6441294
              ],
              [
                51.6645906,
                35.6441294
              ],
              [
                51.663204,
                35.6444087
              ],
              [
                51.6620907,
                35.6449673
              ],
              [
                51.6612575,
                35.6449674
              ],
              [
                51.6607041,
                35.6452466
              ],
              [
                51.6504318,
                35.6435642
              ],
              [
                51.6490452,
                35.6435642
              ],
              [
                51.6487651,
                35.6438435
              ],
              [
                51.6473786,
                35.6438435
              ],
              [
                51.6468219,
                35.6441228
              ],
              [
                51.6423787,
                35.6441228
              ],
              [
                51.6393219,
                35.6424559
              ],
              [
                51.6350555,
                35.6362324
              ],
              [
                51.6338538,
                35.6281401
              ],
              [
                51.6359138,
                35.6187911
              ],
              [
                51.6354486,
                35.6098201
              ],
              [
                51.6356983,
                35.607402
              ],
              [
                51.6360094,
                35.6047491
              ],
              [
                51.6376058,
                35.6007085
              ],
              [
                51.6386616,
                35.5976726
              ],
              [
                51.6397173,
                35.5905117
              ],
              [
                51.640773,
                35.584502
              ],
              [
                51.6441976,
                35.5801043
              ],
              [
                51.6470558,
                35.5778006
              ],
              [
                51.6483175,
                35.5749524
              ],
              [
                51.648987,
                35.5736539
              ],
              [
                51.649502,
                35.5723345
              ],
              [
                51.6499397,
                35.5693394
              ],
              [
                51.650017,
                35.5676638
              ],
              [
                51.650017,
                35.5661558
              ],
              [
                51.6491415,
                35.56492
              ],
              [
                51.648575,
                35.564124
              ],
              [
                51.6465151,
                35.5636423
              ],
              [
                51.6458456,
                35.5630348
              ],
              [
                51.6451504,
                35.5623855
              ],
              [
                51.6460516,
                35.5614219
              ],
              [
                51.6455881,
                35.5584265
              ],
              [
                51.6465666,
                35.5571487
              ],
              [
                51.6471588,
                35.5562898
              ],
              [
                51.648369,
                35.5553052
              ],
              [
                51.6499397,
                35.5552843
              ],
              [
                51.6507122,
                35.5542788
              ],
              [
                51.6508409,
                35.5527704
              ],
              [
                51.6509439,
                35.5518277
              ],
              [
                51.6515104,
                35.5504451
              ],
              [
                51.6518709,
                35.5497747
              ],
              [
                51.6512272,
                35.549209
              ],
              [
                51.6501972,
                35.5485805
              ],
              [
                51.649708,
                35.5464017
              ],
              [
                51.6497852,
                35.5452703
              ],
              [
                51.6472875,
                35.5410381
              ],
              [
                51.6463863,
                35.5412895
              ],
              [
                51.6456911,
                35.5401581
              ],
              [
                51.6477253,
                35.5393619
              ],
              [
                51.6547291,
                35.5368685
              ],
              [
                51.6655695,
                35.5361561
              ],
              [
                51.6647455,
                35.5300794
              ],
              [
                51.6639988,
                35.5256159
              ],
              [
                51.6593382,
                35.5249872
              ],
              [
                51.6568148,
                35.5240022
              ],
              [
                51.6541883,
                35.5229335
              ],
              [
                51.6546003,
                35.521194
              ],
              [
                51.6534416,
                35.5163527
              ],
              [
                51.6445839,
                35.5161012
              ],
              [
                51.6403095,
                35.5158078
              ],
              [
                51.6387131,
                35.5156192
              ],
              [
                51.6379921,
                35.5149066
              ],
              [
                51.6266599,
                35.5226183
              ],
              [
                51.6258783,
                35.5231502
              ],
              [
                51.6188368,
                35.5279416
              ],
              [
                51.6159852,
                35.529882
              ],
              [
                51.6035599,
                35.5384341
              ],
              [
                51.600111,
                35.5405042
              ],
              [
                51.5960397,
                35.5294994
              ],
              [
                51.5919405,
                35.5214519
              ],
              [
                51.5921194,
                35.5183344
              ],
              [
                51.5941793,
                35.5101604
              ],
              [
                51.5949261,
                35.5045848
              ],
              [
                51.596059,
                35.4987363
              ],
              [
                51.5968315,
                35.494858
              ],
              [
                51.596986,
                35.4922584
              ],
              [
                51.5954925,
                35.4875621
              ],
              [
                51.5933296,
                35.4835575
              ],
              [
                51.5932781,
                35.4795946
              ],
              [
                51.5925056,
                35.47603
              ],
              [
                51.5916044,
                35.474646
              ],
              [
                51.5890037,
                35.4720458
              ],
              [
                51.5879223,
                35.4706198
              ],
              [
                51.5867636,
                35.4689002
              ],
              [
                51.5854342,
                35.467498
              ],
              [
                51.5839897,
                35.4653324
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555265,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پردیس",
          "name:en": "Pardis County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5711257",
          "wikipedia": "fa:شهرستان پردیس"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.6936026,
                35.7415155
              ],
              [
                51.6930342,
                35.737212
              ],
              [
                51.6930424,
                35.7354642
              ],
              [
                51.6942572,
                35.7324047
              ],
              [
                51.6953402,
                35.7298431
              ],
              [
                51.6964249,
                35.7249569
              ],
              [
                51.6878309,
                35.7102955
              ],
              [
                51.6903305,
                35.7045653
              ],
              [
                51.694498,
                35.6987236
              ],
              [
                51.7016349,
                35.6889348
              ],
              [
                51.7040221,
                35.6844451
              ],
              [
                51.7065673,
                35.6793571
              ],
              [
                51.7150397,
                35.6710745
              ],
              [
                51.7132764,
                35.6542447
              ],
              [
                51.7125161,
                35.6474737
              ],
              [
                51.7118023,
                35.639969
              ],
              [
                51.7110878,
                35.6302273
              ],
              [
                51.7186975,
                35.6271285
              ],
              [
                51.7246198,
                35.6241285
              ],
              [
                51.7326879,
                35.6181981
              ],
              [
                51.7410135,
                35.6103133
              ],
              [
                51.7466783,
                35.6060915
              ],
              [
                51.7495106,
                35.6045563
              ],
              [
                51.7505836,
                35.6019741
              ],
              [
                51.7551326,
                35.5983451
              ],
              [
                51.7659498,
                35.5882705
              ],
              [
                51.7690801,
                35.5850838
              ],
              [
                51.7810964,
                35.5766373
              ],
              [
                51.7888954,
                35.57225
              ],
              [
                51.7944064,
                35.5701903
              ],
              [
                51.7980866,
                35.5696493
              ],
              [
                51.8045836,
                35.5712029
              ],
              [
                51.8070442,
                35.5717262
              ],
              [
                51.8132268,
                35.5748769
              ],
              [
                51.8198919,
                35.5795344
              ],
              [
                51.8226736,
                35.5808841
              ],
              [
                51.8300952,
                35.5858526
              ],
              [
                51.8449494,
                35.6005049
              ],
              [
                51.8485295,
                35.6079772
              ],
              [
                51.8497851,
                35.6105976
              ],
              [
                51.8566576,
                35.6262876
              ],
              [
                51.8576793,
                35.6349751
              ],
              [
                51.8604034,
                35.6429291
              ],
              [
                51.8620562,
                35.6488051
              ],
              [
                51.8637317,
                35.6527326
              ],
              [
                51.8654036,
                35.6566512
              ],
              [
                51.8678712,
                35.6619164
              ],
              [
                51.8687295,
                35.663067
              ],
              [
                51.8695557,
                35.6644529
              ],
              [
                51.869974,
                35.6656646
              ],
              [
                51.8710041,
                35.6672335
              ],
              [
                51.8723344,
                35.6722539
              ],
              [
                51.8728494,
                35.6748686
              ],
              [
                51.8769907,
                35.6869909
              ],
              [
                51.8788468,
                35.6868689
              ],
              [
                51.8798983,
                35.6871041
              ],
              [
                51.8802094,
                35.6875311
              ],
              [
                51.8805635,
                35.6886552
              ],
              [
                51.8807351,
                35.6899797
              ],
              [
                51.8805313,
                35.6911648
              ],
              [
                51.8806171,
                35.6915569
              ],
              [
                51.8813145,
                35.6926635
              ],
              [
                51.8817544,
                35.6930818
              ],
              [
                51.8821192,
                35.6938486
              ],
              [
                51.8819904,
                35.6941535
              ],
              [
                51.8821192,
                35.6945021
              ],
              [
                51.8830097,
                35.6945195
              ],
              [
                51.8847477,
                35.6945021
              ],
              [
                51.8848228,
                35.6947286
              ],
              [
                51.8842005,
                35.6957482
              ],
              [
                51.8840825,
                35.6959223
              ],
              [
                51.8835246,
                35.6960094
              ],
              [
                51.882838,
                35.6965322
              ],
              [
                51.8828057,
                35.6968372
              ],
              [
                51.8829614,
                35.6970855
              ],
              [
                51.8831491,
                35.6972467
              ],
              [
                51.8830419,
                35.6977521
              ],
              [
                51.8837231,
                35.6977783
              ],
              [
                51.8831545,
                35.6986364
              ],
              [
                51.8834871,
                35.698815
              ],
              [
                51.8835729,
                35.6992289
              ],
              [
                51.8836695,
                35.6993857
              ],
              [
                51.8848389,
                35.6994598
              ],
              [
                51.8851232,
                35.699377
              ],
              [
                51.8853271,
                35.6994816
              ],
              [
                51.8850428,
                35.6998606
              ],
              [
                51.8849033,
                35.7002439
              ],
              [
                51.8850374,
                35.7004704
              ],
              [
                51.8848175,
                35.7009148
              ],
              [
                51.8848711,
                35.7013025
              ],
              [
                51.8852681,
                35.7013548
              ],
              [
                51.886239,
                35.7011065
              ],
              [
                51.8872475,
                35.7009628
              ],
              [
                51.8881488,
                35.7011152
              ],
              [
                51.8885243,
                35.7015465
              ],
              [
                51.8886959,
                35.7019865
              ],
              [
                51.8895113,
                35.7022653
              ],
              [
                51.8903859,
                35.7020719
              ],
              [
                51.890552,
                35.7030581
              ],
              [
                51.8910241,
                35.7036505
              ],
              [
                51.8911314,
                35.7047483
              ],
              [
                51.8904447,
                35.7048267
              ],
              [
                51.8894362,
                35.7053058
              ],
              [
                51.887627,
                35.7053374
              ],
              [
                51.8828916,
                35.7059244
              ],
              [
                51.8850374,
                35.7127544
              ],
              [
                51.8881296,
                35.7149782
              ],
              [
                51.893363,
                35.7206987
              ],
              [
                51.893034,
                35.7218941
              ],
              [
                51.8922357,
                35.7222077
              ],
              [
                51.8915148,
                35.7226676
              ],
              [
                51.8908453,
                35.7232529
              ],
              [
                51.8904075,
                35.7236083
              ],
              [
                51.8896093,
                35.7240055
              ],
              [
                51.8890286,
                35.7246269
              ],
              [
                51.8894663,
                35.7256094
              ],
              [
                51.890316,
                35.7265918
              ],
              [
                51.8902388,
                35.7277833
              ],
              [
                51.8868914,
                35.7282641
              ],
              [
                51.8869686,
                35.7296019
              ],
              [
                51.8882303,
                35.7312323
              ],
              [
                51.8892603,
                35.7322565
              ],
              [
                51.8898268,
                35.7321729
              ],
              [
                51.890213,
                35.7326745
              ],
              [
                51.8918352,
                35.7357889
              ],
              [
                51.8905993,
                35.7361442
              ],
              [
                51.8914232,
                35.7375654
              ],
              [
                51.8922472,
                35.741223
              ],
              [
                51.8961782,
                35.7466854
              ],
              [
                51.8989247,
                35.7508521
              ],
              [
                51.8965218,
                35.7525251
              ],
              [
                51.8915184,
                35.7550021
              ],
              [
                51.8892655,
                35.7584515
              ],
              [
                51.8869361,
                35.7607037
              ],
              [
                51.8736054,
                35.7587968
              ],
              [
                51.8620133,
                35.7669552
              ],
              [
                51.8541866,
                35.7743088
              ],
              [
                51.8460009,
                35.7793467
              ],
              [
                51.8416398,
                35.7823038
              ],
              [
                51.8401694,
                35.7830585
              ],
              [
                51.8349123,
                35.7886982
              ],
              [
                51.833094,
                35.7890893
              ],
              [
                51.8309277,
                35.7862622
              ],
              [
                51.8281214,
                35.7821808
              ],
              [
                51.8255568,
                35.7780625
              ],
              [
                51.8207753,
                35.775422
              ],
              [
                51.8201998,
                35.7725357
              ],
              [
                51.8201495,
                35.7693839
              ],
              [
                51.8203812,
                35.7682766
              ],
              [
                51.8199692,
                35.7678588
              ],
              [
                51.8192225,
                35.7678379
              ],
              [
                51.8188363,
                35.7677125
              ],
              [
                51.818244,
                35.7672529
              ],
              [
                51.8181925,
                35.7668141
              ],
              [
                51.8173428,
                35.7663963
              ],
              [
                51.8167763,
                35.7661665
              ],
              [
                51.8160554,
                35.7656859
              ],
              [
                51.8152056,
                35.7651636
              ],
              [
                51.8147679,
                35.764892
              ],
              [
                51.8143559,
                35.7645577
              ],
              [
                51.8148709,
                35.7643487
              ],
              [
                51.8151026,
                35.7639518
              ],
              [
                51.8141757,
                35.7634921
              ],
              [
                51.8135319,
                35.7633458
              ],
              [
                51.8127595,
                35.7632414
              ],
              [
                51.8118325,
                35.7628862
              ],
              [
                51.8082791,
                35.761925
              ],
              [
                51.8068886,
                35.7614863
              ],
              [
                51.8024083,
                35.7606714
              ],
              [
                51.8010436,
                35.7611519
              ],
              [
                51.8007346,
                35.7615072
              ],
              [
                51.8004771,
                35.7615072
              ],
              [
                51.8002453,
                35.7610475
              ],
              [
                51.8001166,
                35.7606505
              ],
              [
                51.7995071,
                35.760304
              ],
              [
                51.7966317,
                35.7630899
              ],
              [
                51.7962884,
                35.7654578
              ],
              [
                51.7928552,
                35.767582
              ],
              [
                51.7923403,
                35.7715341
              ],
              [
                51.7906129,
                35.7724829
              ],
              [
                51.7904305,
                35.7752858
              ],
              [
                51.7895078,
                35.7776447
              ],
              [
                51.7831349,
                35.7795074
              ],
              [
                51.7788219,
                35.778341
              ],
              [
                51.7687583,
                35.780134
              ],
              [
                51.7629861,
                35.7793855
              ],
              [
                51.761055,
                35.7800296
              ],
              [
                51.7561841,
                35.7829018
              ],
              [
                51.7559051,
                35.7843466
              ],
              [
                51.7543816,
                35.7848689
              ],
              [
                51.7533302,
                35.7843814
              ],
              [
                51.7518282,
                35.7821881
              ],
              [
                51.7522144,
                35.7767568
              ],
              [
                51.7560387,
                35.7741903
              ],
              [
                51.7538023,
                35.7741281
              ],
              [
                51.7500686,
                35.7741977
              ],
              [
                51.7421722,
                35.7757645
              ],
              [
                51.7311289,
                35.7773352
              ],
              [
                51.7245938,
                35.7776896
              ],
              [
                51.7216683,
                35.7778619
              ],
              [
                51.7201873,
                35.7779375
              ],
              [
                51.7179564,
                35.7768226
              ],
              [
                51.7150804,
                35.7765622
              ],
              [
                51.7097528,
                35.7765918
              ],
              [
                51.706205,
                35.776472
              ],
              [
                51.7044498,
                35.776489
              ],
              [
                51.7025346,
                35.7759434
              ],
              [
                51.699246,
                35.773939
              ],
              [
                51.699222,
                35.7736972
              ],
              [
                51.6989189,
                35.7735731
              ],
              [
                51.6983315,
                35.77346
              ],
              [
                51.6978782,
                35.7732489
              ],
              [
                51.6976556,
                35.7731727
              ],
              [
                51.6971272,
                35.7733664
              ],
              [
                51.6965613,
                35.7730313
              ],
              [
                51.696977,
                35.7723697
              ],
              [
                51.6970521,
                35.7723567
              ],
              [
                51.6976422,
                35.7718953
              ],
              [
                51.6981518,
                35.7712424
              ],
              [
                51.6979694,
                35.7703937
              ],
              [
                51.6968429,
                35.7693796
              ],
              [
                51.6961294,
                35.7692272
              ],
              [
                51.6952282,
                35.7688921
              ],
              [
                51.6948876,
                35.7687006
              ],
              [
                51.6933185,
                35.7684829
              ],
              [
                51.6922966,
                35.7680542
              ],
              [
                51.6901617,
                35.7667041
              ],
              [
                51.6918753,
                35.7646569
              ],
              [
                51.6928624,
                35.7569608
              ],
              [
                51.6916608,
                35.7556374
              ],
              [
                51.6909098,
                35.7494032
              ],
              [
                51.6888713,
                35.7449449
              ],
              [
                51.683674,
                35.743465
              ],
              [
                51.6846871,
                35.7405387
              ],
              [
                51.6905021,
                35.7411482
              ],
              [
                51.6936026,
                35.7415155
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555269,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پیشوا",
          "name:en": "Pishva County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4811773",
          "wikipedia": "fa:شهرستان پیشوا"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.6476536,
                35.3632698
              ],
              [
                51.6482855,
                35.3629784
              ],
              [
                51.6488021,
                35.3626907
              ],
              [
                51.6492924,
                35.3623865
              ],
              [
                51.6497887,
                35.3620355
              ],
              [
                51.6502382,
                35.3616859
              ],
              [
                51.650676,
                35.3612896
              ],
              [
                51.6509872,
                35.3609961
              ],
              [
                51.6512415,
                35.3607206
              ],
              [
                51.6515134,
                35.3603942
              ],
              [
                51.6517976,
                35.3600297
              ],
              [
                51.6521122,
                35.359577
              ],
              [
                51.6523986,
                35.3591409
              ],
              [
                51.6529147,
                35.3583129
              ],
              [
                51.6533963,
                35.3575258
              ],
              [
                51.6539276,
                35.356663
              ],
              [
                51.6544847,
                35.3557557
              ],
              [
                51.6549836,
                35.3549435
              ],
              [
                51.6553838,
                35.35429
              ],
              [
                51.6556337,
                35.3538767
              ],
              [
                51.6559201,
                35.3534088
              ],
              [
                51.656168,
                35.3529965
              ],
              [
                51.6568329,
                35.351936
              ],
              [
                51.6585617,
                35.3491257
              ],
              [
                51.6607654,
                35.3455303
              ],
              [
                51.6618402,
                35.3437626
              ],
              [
                51.6630904,
                35.3417314
              ],
              [
                51.6639849,
                35.3402933
              ],
              [
                51.6646404,
                35.339235
              ],
              [
                51.6652103,
                35.3382981
              ],
              [
                51.6658341,
                35.3372943
              ],
              [
                51.6672687,
                35.3349371
              ],
              [
                51.6680935,
                35.3335904
              ],
              [
                51.6685026,
                35.3329391
              ],
              [
                51.6691796,
                35.3318591
              ],
              [
                51.6695613,
                35.3312337
              ],
              [
                51.6699957,
                35.3304972
              ],
              [
                51.6710077,
                35.3288791
              ],
              [
                51.6720307,
                35.3273419
              ],
              [
                51.6729335,
                35.3261189
              ],
              [
                51.6734346,
                35.3255093
              ],
              [
                51.6740835,
                35.3250306
              ],
              [
                51.6754411,
                35.3241239
              ],
              [
                51.6780948,
                35.3225246
              ],
              [
                51.6739651,
                35.3182202
              ],
              [
                51.6727395,
                35.3160831
              ],
              [
                51.6777585,
                35.3143484
              ],
              [
                51.6744615,
                35.3114629
              ],
              [
                51.6727522,
                35.3121272
              ],
              [
                51.6715695,
                35.3092271
              ],
              [
                51.6662277,
                35.3106781
              ],
              [
                51.6644768,
                35.3110984
              ],
              [
                51.6635498,
                35.3108252
              ],
              [
                51.6608976,
                35.308724
              ],
              [
                51.6601112,
                35.3084288
              ],
              [
                51.6581752,
                35.3083743
              ],
              [
                51.6587011,
                35.304631
              ],
              [
                51.6586154,
                35.3034527
              ],
              [
                51.6585287,
                35.3029801
              ],
              [
                51.6583001,
                35.3010458
              ],
              [
                51.6580891,
                35.2944808
              ],
              [
                51.658334,
                35.2859147
              ],
              [
                51.6585051,
                35.279773
              ],
              [
                51.6591438,
                35.2759783
              ],
              [
                51.6591759,
                35.2751629
              ],
              [
                51.6591399,
                35.2743886
              ],
              [
                51.6690651,
                35.2747385
              ],
              [
                51.6733097,
                35.2749201
              ],
              [
                51.6771385,
                35.2750628
              ],
              [
                51.6772622,
                35.2728541
              ],
              [
                51.6772337,
                35.2713176
              ],
              [
                51.6791948,
                35.2706017
              ],
              [
                51.6808534,
                35.2735727
              ],
              [
                51.681656,
                35.2735865
              ],
              [
                51.6825855,
                35.2753073
              ],
              [
                51.68499,
                35.2754049
              ],
              [
                51.6855626,
                35.2748976
              ],
              [
                51.686231,
                35.274167
              ],
              [
                51.6872184,
                35.2730616
              ],
              [
                51.6947782,
                35.2804366
              ],
              [
                51.7072568,
                35.2719746
              ],
              [
                51.7074146,
                35.2745359
              ],
              [
                51.7078349,
                35.2762787
              ],
              [
                51.7145268,
                35.2765294
              ],
              [
                51.7270022,
                35.2770203
              ],
              [
                51.7324497,
                35.2772498
              ],
              [
                51.7444506,
                35.2641617
              ],
              [
                51.7460838,
                35.2651598
              ],
              [
                51.7463221,
                35.2652716
              ],
              [
                51.7481617,
                35.2657218
              ],
              [
                51.7487014,
                35.2657298
              ],
              [
                51.7553042,
                35.2668827
              ],
              [
                51.7630122,
                35.2830557
              ],
              [
                51.7918389,
                35.2831842
              ],
              [
                51.826274,
                35.270946
              ],
              [
                51.869169,
                35.2709737
              ],
              [
                51.8689821,
                35.2721594
              ],
              [
                51.868702,
                35.2727096
              ],
              [
                51.8681487,
                35.2749373
              ],
              [
                51.8678688,
                35.2763263
              ],
              [
                51.867592,
                35.2777152
              ],
              [
                51.8846339,
                35.2955786
              ],
              [
                51.8617842,
                35.3124876
              ],
              [
                51.8268972,
                35.3382975
              ],
              [
                51.8159112,
                35.341734
              ],
              [
                51.8175306,
                35.3463302
              ],
              [
                51.8130804,
                35.3472905
              ],
              [
                51.8148813,
                35.3528444
              ],
              [
                51.8046588,
                35.3568345
              ],
              [
                51.7995799,
                35.3590235
              ],
              [
                51.8035119,
                35.3661927
              ],
              [
                51.8007307,
                35.3681175
              ],
              [
                51.7955798,
                35.3716974
              ],
              [
                51.7942925,
                35.3721396
              ],
              [
                51.7908936,
                35.3721816
              ],
              [
                51.7890529,
                35.3711549
              ],
              [
                51.7883132,
                35.3770661
              ],
              [
                51.7856669,
                35.3768808
              ],
              [
                51.7839641,
                35.3831364
              ],
              [
                51.7824573,
                35.3857983
              ],
              [
                51.782002,
                35.3863061
              ],
              [
                51.772491,
                35.3877623
              ],
              [
                51.7682369,
                35.3973567
              ],
              [
                51.7655053,
                35.3966556
              ],
              [
                51.7638316,
                35.3966766
              ],
              [
                51.7542014,
                35.3976211
              ],
              [
                51.7518582,
                35.3984397
              ],
              [
                51.7506909,
                35.3988893
              ],
              [
                51.7472292,
                35.3994673
              ],
              [
                51.7429359,
                35.4001301
              ],
              [
                51.7373483,
                35.4031105
              ],
              [
                51.7327299,
                35.404147
              ],
              [
                51.7226104,
                35.4076763
              ],
              [
                51.709707,
                35.3825168
              ],
              [
                51.6963192,
                35.3905036
              ],
              [
                51.6808286,
                35.3982
              ],
              [
                51.6758134,
                35.3949818
              ],
              [
                51.6743334,
                35.391695
              ],
              [
                51.6598274,
                35.3803985
              ],
              [
                51.6594255,
                35.3801178
              ],
              [
                51.659206,
                35.3800149
              ],
              [
                51.6588184,
                35.3799504
              ],
              [
                51.6583112,
                35.3800363
              ],
              [
                51.6545416,
                35.3811447
              ],
              [
                51.6504884,
                35.3776977
              ],
              [
                51.6550874,
                35.3741032
              ],
              [
                51.6489035,
                35.3662593
              ],
              [
                51.6476536,
                35.3632698
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821096755
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.0781534,
          35.480576
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2702220719
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.9790423,
          35.666763
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4327958633
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.0586022,
          35.6589015
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5382787195
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.1591692,
          35.5683375
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3290916467
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5697005,
          35.4421824
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 6149532933
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.2318676,
          35.5478513
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821096690
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.4357865,
          35.5989911
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3248971788
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.6460307,
          35.3283255
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3311719071
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.7227122,
          35.3064185
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2758633613
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.6824624,
          35.4784573
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5731891666
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.1100769,
          35.7204271
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 25960293
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.3896004,
          35.6892523
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 8919837928
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.4409634,
          35.804937
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4516472058
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.4334159,
          35.8076264
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821096717
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.815509,
          35.7411286
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2326794015
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.0681882,
          35.7179802
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2319420949
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.7730592,
          35.7556732
        ]
      }
    }
  ]
},
"چهارمحال بختیاری.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554874,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اردل",
          "name:en": "Ardal County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279017",
          "wikipedia": "en:Ardal County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.1694679,
                31.988155
              ],
              [
                50.1792568,
                31.9802829
              ],
              [
                50.1847512,
                31.9798737
              ],
              [
                50.1883103,
                31.9769883
              ],
              [
                50.1923634,
                31.9720886
              ],
              [
                50.2004484,
                31.969383
              ],
              [
                50.2038212,
                31.9668946
              ],
              [
                50.2051625,
                31.9653588
              ],
              [
                50.2088598,
                31.9618277
              ],
              [
                50.2134921,
                31.9572585
              ],
              [
                50.2207655,
                31.9545741
              ],
              [
                50.2246314,
                31.9512991
              ],
              [
                50.2264832,
                31.9496986
              ],
              [
                50.2309664,
                31.9477381
              ],
              [
                50.2345071,
                31.9461685
              ],
              [
                50.236076,
                31.9434398
              ],
              [
                50.2371643,
                31.9415882
              ],
              [
                50.2375261,
                31.9409835
              ],
              [
                50.2385688,
                31.9391792
              ],
              [
                50.240243,
                31.9363772
              ],
              [
                50.2399325,
                31.9345101
              ],
              [
                50.2397404,
                31.9318632
              ],
              [
                50.2418073,
                31.930283
              ],
              [
                50.2420449,
                31.9252258
              ],
              [
                50.2417223,
                31.9251826
              ],
              [
                50.2426374,
                31.9214044
              ],
              [
                50.2468437,
                31.9175632
              ],
              [
                50.2526574,
                31.9130624
              ],
              [
                50.2526596,
                31.9057781
              ],
              [
                50.2563841,
                31.901378
              ],
              [
                50.2597861,
                31.8972734
              ],
              [
                50.2674633,
                31.8918215
              ],
              [
                50.2741246,
                31.8871328
              ],
              [
                50.281511,
                31.8803941
              ],
              [
                50.2825244,
                31.8761586
              ],
              [
                50.2835757,
                31.8721109
              ],
              [
                50.2862618,
                31.8683982
              ],
              [
                50.2881296,
                31.8661445
              ],
              [
                50.2891691,
                31.86344
              ],
              [
                50.2848089,
                31.8608721
              ],
              [
                50.2815276,
                31.8588175
              ],
              [
                50.2782641,
                31.8577355
              ],
              [
                50.2790087,
                31.8526348
              ],
              [
                50.2792148,
                31.8509172
              ],
              [
                50.2841049,
                31.8524667
              ],
              [
                50.2850119,
                31.8484667
              ],
              [
                50.2859096,
                31.8445838
              ],
              [
                50.2923275,
                31.8439207
              ],
              [
                50.2967343,
                31.8391379
              ],
              [
                50.3014001,
                31.8343512
              ],
              [
                50.3081556,
                31.826769
              ],
              [
                50.3126157,
                31.8222215
              ],
              [
                50.3118202,
                31.8196353
              ],
              [
                50.3077107,
                31.8060296
              ],
              [
                50.3214341,
                31.7917363
              ],
              [
                50.3232211,
                31.77797
              ],
              [
                50.3512564,
                31.7570168
              ],
              [
                50.3868137,
                31.7301895
              ],
              [
                50.3858906,
                31.7159837
              ],
              [
                50.3832816,
                31.7030614
              ],
              [
                50.3835957,
                31.6939611
              ],
              [
                50.387064,
                31.686168
              ],
              [
                50.3944141,
                31.676361
              ],
              [
                50.4056337,
                31.6650457
              ],
              [
                50.4096387,
                31.6550502
              ],
              [
                50.441513,
                31.6189189
              ],
              [
                50.4279251,
                31.6109122
              ],
              [
                50.4168909,
                31.6043103
              ],
              [
                50.4106532,
                31.6005631
              ],
              [
                50.4141652,
                31.5998181
              ],
              [
                50.4567922,
                31.6016628
              ],
              [
                50.4647793,
                31.6177062
              ],
              [
                50.4672294,
                31.622553
              ],
              [
                50.469212,
                31.6267668
              ],
              [
                50.4695743,
                31.6313308
              ],
              [
                50.4729204,
                31.6336482
              ],
              [
                50.4792364,
                31.636322
              ],
              [
                50.4864405,
                31.6388458
              ],
              [
                50.4907,
                31.6407151
              ],
              [
                50.4951381,
                31.6422022
              ],
              [
                50.4963475,
                31.6432552
              ],
              [
                50.4996153,
                31.6414485
              ],
              [
                50.5008506,
                31.6409102
              ],
              [
                50.5065319,
                31.6429927
              ],
              [
                50.5093985,
                31.6445446
              ],
              [
                50.5154686,
                31.6501095
              ],
              [
                50.5181844,
                31.6521709
              ],
              [
                50.5215342,
                31.65319
              ],
              [
                50.5278874,
                31.6551659
              ],
              [
                50.5352986,
                31.6561243
              ],
              [
                50.5433538,
                31.6562473
              ],
              [
                50.5472283,
                31.6565181
              ],
              [
                50.554413,
                31.6568404
              ],
              [
                50.5664711,
                31.6559819
              ],
              [
                50.5736974,
                31.6536074
              ],
              [
                50.5743808,
                31.6533882
              ],
              [
                50.5803841,
                31.648919
              ],
              [
                50.5820098,
                31.6466813
              ],
              [
                50.5835252,
                31.6449869
              ],
              [
                50.5853204,
                31.6429813
              ],
              [
                50.5900262,
                31.6381857
              ],
              [
                50.6072776,
                31.6271102
              ],
              [
                50.6223364,
                31.6246442
              ],
              [
                50.6287771,
                31.6258483
              ],
              [
                50.6366144,
                31.6338648
              ],
              [
                50.6450198,
                31.6388964
              ],
              [
                50.6558422,
                31.6461812
              ],
              [
                50.6654048,
                31.6505035
              ],
              [
                50.677185,
                31.6549888
              ],
              [
                50.6874418,
                31.6580573
              ],
              [
                50.694952,
                31.6588244
              ],
              [
                50.7004248,
                31.6587728
              ],
              [
                50.7069276,
                31.6574571
              ],
              [
                50.7177136,
                31.6533346
              ],
              [
                50.7158517,
                31.6573633
              ],
              [
                50.7122898,
                31.6655186
              ],
              [
                50.7085788,
                31.67466
              ],
              [
                50.7055625,
                31.6851993
              ],
              [
                50.7019568,
                31.6965829
              ],
              [
                50.7021273,
                31.702854
              ],
              [
                50.7013928,
                31.7090243
              ],
              [
                50.7025968,
                31.71477
              ],
              [
                50.7033265,
                31.7214782
              ],
              [
                50.7050286,
                31.7272147
              ],
              [
                50.7134287,
                31.7373262
              ],
              [
                50.6876999,
                31.7492195
              ],
              [
                50.6798281,
                31.7529422
              ],
              [
                50.6638581,
                31.7597189
              ],
              [
                50.6510724,
                31.7655
              ],
              [
                50.642181,
                31.7704007
              ],
              [
                50.6253622,
                31.7791616
              ],
              [
                50.6105362,
                31.7871252
              ],
              [
                50.5518328,
                31.8281079
              ],
              [
                50.5340069,
                31.8407518
              ],
              [
                50.525774,
                31.8464389
              ],
              [
                50.5040672,
                31.8613178
              ],
              [
                50.4913537,
                31.8702605
              ],
              [
                50.485125,
                31.8777412
              ],
              [
                50.4756432,
                31.8821208
              ],
              [
                50.4667286,
                31.8838405
              ],
              [
                50.4588712,
                31.8854548
              ],
              [
                50.4638336,
                31.886883
              ],
              [
                50.4839786,
                31.9066308
              ],
              [
                50.4943227,
                31.9150395
              ],
              [
                50.5011807,
                31.9205521
              ],
              [
                50.5146194,
                31.9246005
              ],
              [
                50.5231233,
                31.9271662
              ],
              [
                50.5326425,
                31.9266681
              ],
              [
                50.541337,
                31.9242119
              ],
              [
                50.5557553,
                31.9261946
              ],
              [
                50.5741365,
                31.9373965
              ],
              [
                50.5812758,
                31.9395301
              ],
              [
                50.5886572,
                31.9417665
              ],
              [
                50.6033925,
                31.9430965
              ],
              [
                50.6037279,
                31.9435028
              ],
              [
                50.6058475,
                31.9459431
              ],
              [
                50.6149612,
                31.9480534
              ],
              [
                50.6226743,
                31.9500628
              ],
              [
                50.6245542,
                31.9505284
              ],
              [
                50.629479,
                31.9485383
              ],
              [
                50.6410819,
                31.9523192
              ],
              [
                50.6461204,
                31.9516175
              ],
              [
                50.6517285,
                31.9554309
              ],
              [
                50.6744274,
                31.972534
              ],
              [
                50.6811084,
                31.9776553
              ],
              [
                50.6862387,
                31.9812725
              ],
              [
                50.6877315,
                31.9821852
              ],
              [
                50.689765,
                31.9830911
              ],
              [
                50.6917648,
                31.9841848
              ],
              [
                50.6960155,
                31.9862262
              ],
              [
                50.7013114,
                31.9891282
              ],
              [
                50.719583,
                31.9915738
              ],
              [
                50.7211559,
                31.9985734
              ],
              [
                50.7117748,
                32.0099319
              ],
              [
                50.7066313,
                32.0153547
              ],
              [
                50.7042155,
                32.0186405
              ],
              [
                50.6973086,
                32.0234938
              ],
              [
                50.6910685,
                32.0292034
              ],
              [
                50.6830356,
                32.0401397
              ],
              [
                50.6810882,
                32.0433125
              ],
              [
                50.6596449,
                32.0488781
              ],
              [
                50.6546759,
                32.051553
              ],
              [
                50.6511143,
                32.058426
              ],
              [
                50.634652,
                32.0690541
              ],
              [
                50.6224225,
                32.079798
              ],
              [
                50.6055987,
                32.0918028
              ],
              [
                50.5939514,
                32.1173129
              ],
              [
                50.5867945,
                32.127941
              ],
              [
                50.5783641,
                32.1396321
              ],
              [
                50.5656715,
                32.1531974
              ],
              [
                50.5605411,
                32.1569035
              ],
              [
                50.5551767,
                32.1591924
              ],
              [
                50.5423879,
                32.1703453
              ],
              [
                50.5268526,
                32.180153
              ],
              [
                50.5242319,
                32.1822117
              ],
              [
                50.5224946,
                32.1823214
              ],
              [
                50.5205885,
                32.1815736
              ],
              [
                50.517491,
                32.1827243
              ],
              [
                50.5153513,
                32.1833129
              ],
              [
                50.5129909,
                32.1847658
              ],
              [
                50.4902859,
                32.203053
              ],
              [
                50.4674357,
                32.2197452
              ],
              [
                50.4626941,
                32.2213698
              ],
              [
                50.4501524,
                32.2272955
              ],
              [
                50.4463863,
                32.2292166
              ],
              [
                50.4433339,
                32.2302426
              ],
              [
                50.4401636,
                32.228667
              ],
              [
                50.4353141,
                32.2245646
              ],
              [
                50.4344377,
                32.2229716
              ],
              [
                50.4334281,
                32.2203514
              ],
              [
                50.4260943,
                32.2100501
              ],
              [
                50.4164652,
                32.1929618
              ],
              [
                50.4164223,
                32.1911564
              ],
              [
                50.417397,
                32.1885067
              ],
              [
                50.4186551,
                32.1869541
              ],
              [
                50.4204278,
                32.1739107
              ],
              [
                50.4253973,
                32.1614117
              ],
              [
                50.4262188,
                32.1603955
              ],
              [
                50.4293695,
                32.1546128
              ],
              [
                50.4311168,
                32.1461874
              ],
              [
                50.4339302,
                32.1417667
              ],
              [
                50.4340548,
                32.1292063
              ],
              [
                50.4320092,
                32.1185728
              ],
              [
                50.4329589,
                32.1123007
              ],
              [
                50.4348227,
                32.1082458
              ],
              [
                50.4146119,
                32.1090746
              ],
              [
                50.4087066,
                32.1084603
              ],
              [
                50.3962651,
                32.1083966
              ],
              [
                50.3904236,
                32.108176
              ],
              [
                50.3731777,
                32.1040846
              ],
              [
                50.3446709,
                32.1035757
              ],
              [
                50.3330421,
                32.1016017
              ],
              [
                50.3281141,
                32.1016015
              ],
              [
                50.3213776,
                32.0998456
              ],
              [
                50.302262,
                32.1007181
              ],
              [
                50.2854643,
                32.0980169
              ],
              [
                50.2764677,
                32.0943063
              ],
              [
                50.2729827,
                32.0919569
              ],
              [
                50.24483,
                32.0742495
              ],
              [
                50.2189948,
                32.0604484
              ],
              [
                50.2059744,
                32.0533354
              ],
              [
                50.1877783,
                32.0366023
              ],
              [
                50.1738737,
                32.0185561
              ],
              [
                50.1690672,
                32.0086584
              ],
              [
                50.1734446,
                31.9989051
              ],
              [
                50.1694679,
                31.988155
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554925,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بروجن",
          "name:en": "Borujen County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278749",
          "wikipedia": "en:Borujen County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.780856,
                31.9047111
              ],
              [
                50.7793734,
                31.8975952
              ],
              [
                50.7846291,
                31.8924365
              ],
              [
                50.788378,
                31.8907124
              ],
              [
                50.7925998,
                31.8875384
              ],
              [
                50.7976216,
                31.883605
              ],
              [
                50.8105415,
                31.8746164
              ],
              [
                50.8317824,
                31.8640116
              ],
              [
                50.8417834,
                31.859392
              ],
              [
                50.8517534,
                31.8556857
              ],
              [
                50.8645256,
                31.8508793
              ],
              [
                50.8638018,
                31.85191
              ],
              [
                50.8873086,
                31.8422397
              ],
              [
                50.9231427,
                31.8306373
              ],
              [
                50.9469147,
                31.8201915
              ],
              [
                50.9546018,
                31.8152627
              ],
              [
                50.9632458,
                31.8102666
              ],
              [
                50.9747035,
                31.802079
              ],
              [
                50.9868589,
                31.7938738
              ],
              [
                51.0009728,
                31.7846147
              ],
              [
                51.005314,
                31.7804852
              ],
              [
                51.0091427,
                31.7757368
              ],
              [
                51.0262963,
                31.7548252
              ],
              [
                51.0352218,
                31.7357506
              ],
              [
                51.0367447,
                31.7046131
              ],
              [
                51.0305864,
                31.6875313
              ],
              [
                51.0290286,
                31.6799981
              ],
              [
                51.0137984,
                31.6563664
              ],
              [
                51.0097743,
                31.6530532
              ],
              [
                51.0281569,
                31.6478023
              ],
              [
                51.0424177,
                31.643295
              ],
              [
                51.0535316,
                31.6410001
              ],
              [
                51.0589586,
                31.6401468
              ],
              [
                51.0693888,
                31.6414347
              ],
              [
                51.0811422,
                31.6396838
              ],
              [
                51.0908974,
                31.6382108
              ],
              [
                51.096789,
                31.6389148
              ],
              [
                51.1019571,
                31.6410267
              ],
              [
                51.1099602,
                31.6412301
              ],
              [
                51.1202757,
                31.6392963
              ],
              [
                51.1304972,
                31.6387683
              ],
              [
                51.1371162,
                31.6398116
              ],
              [
                51.1444222,
                31.6383593
              ],
              [
                51.1478796,
                31.6359219
              ],
              [
                51.1512253,
                31.6312499
              ],
              [
                51.1544153,
                31.62488
              ],
              [
                51.1568381,
                31.6205742
              ],
              [
                51.1620864,
                31.6146151
              ],
              [
                51.1643621,
                31.6132252
              ],
              [
                51.167116,
                31.6065449
              ],
              [
                51.1706594,
                31.6011423
              ],
              [
                51.1744054,
                31.5933828
              ],
              [
                51.1792377,
                31.5855592
              ],
              [
                51.1845394,
                31.5796914
              ],
              [
                51.1894082,
                31.5737372
              ],
              [
                51.1930794,
                31.5711806
              ],
              [
                51.1960137,
                31.5693176
              ],
              [
                51.2015006,
                31.5667402
              ],
              [
                51.2084685,
                31.5602804
              ],
              [
                51.2093746,
                31.5574853
              ],
              [
                51.2093186,
                31.5557139
              ],
              [
                51.2093503,
                31.5540749
              ],
              [
                51.2095401,
                31.549444
              ],
              [
                51.2090587,
                31.5448809
              ],
              [
                51.2093943,
                31.53879
              ],
              [
                51.2105605,
                31.5341304
              ],
              [
                51.2131571,
                31.5303415
              ],
              [
                51.2194535,
                31.5222008
              ],
              [
                51.2267734,
                31.5146066
              ],
              [
                51.2283262,
                31.4981141
              ],
              [
                51.2362919,
                31.4942971
              ],
              [
                51.237506,
                31.4941981
              ],
              [
                51.242829,
                31.4911152
              ],
              [
                51.2474991,
                31.4899964
              ],
              [
                51.2508755,
                31.4905866
              ],
              [
                51.2534699,
                31.4909992
              ],
              [
                51.2572454,
                31.4915275
              ],
              [
                51.2613592,
                31.4911463
              ],
              [
                51.2638012,
                31.4918525
              ],
              [
                51.268405,
                31.4913242
              ],
              [
                51.2707078,
                31.4915419
              ],
              [
                51.2753,
                31.4922256
              ],
              [
                51.2749822,
                31.4936781
              ],
              [
                51.2745663,
                31.4951612
              ],
              [
                51.2735988,
                31.4996013
              ],
              [
                51.2729115,
                31.5026075
              ],
              [
                51.2722357,
                31.5042154
              ],
              [
                51.2798546,
                31.5080603
              ],
              [
                51.289119,
                31.5105139
              ],
              [
                51.2922434,
                31.5127273
              ],
              [
                51.2941387,
                31.5239195
              ],
              [
                51.2910349,
                31.535373
              ],
              [
                51.2917313,
                31.5468213
              ],
              [
                51.2926175,
                31.5514879
              ],
              [
                51.2971884,
                31.5694447
              ],
              [
                51.3016533,
                31.5967894
              ],
              [
                51.3023142,
                31.6062341
              ],
              [
                51.303194,
                31.6131465
              ],
              [
                51.3033854,
                31.6159561
              ],
              [
                51.3042286,
                31.6225604
              ],
              [
                51.3001656,
                31.6407525
              ],
              [
                51.2987276,
                31.6469639
              ],
              [
                51.3001509,
                31.6673709
              ],
              [
                51.3046868,
                31.6768578
              ],
              [
                51.3107153,
                31.6816296
              ],
              [
                51.3117178,
                31.6832735
              ],
              [
                51.3117693,
                31.6848731
              ],
              [
                51.3143957,
                31.6952146
              ],
              [
                51.3162754,
                31.7045692
              ],
              [
                51.3206527,
                31.7081837
              ],
              [
                51.326678,
                31.7082933
              ],
              [
                51.3332698,
                31.7082933
              ],
              [
                51.3447282,
                31.7101771
              ],
              [
                51.3505218,
                31.7101333
              ],
              [
                51.3567016,
                31.712981
              ],
              [
                51.3616455,
                31.7144486
              ],
              [
                51.3630102,
                31.7158285
              ],
              [
                51.3633964,
                31.7172304
              ],
              [
                51.3634737,
                31.7197712
              ],
              [
                51.3621605,
                31.7217205
              ],
              [
                51.3603838,
                31.7230347
              ],
              [
                51.3574226,
                31.725422
              ],
              [
                51.3472002,
                31.7289043
              ],
              [
                51.3418186,
                31.7324084
              ],
              [
                51.3370807,
                31.7347297
              ],
              [
                51.3301542,
                31.7416935
              ],
              [
                51.328532,
                31.7446497
              ],
              [
                51.3246181,
                31.7501238
              ],
              [
                51.3222749,
                31.7534519
              ],
              [
                51.3176401,
                31.757174
              ],
              [
                51.3137005,
                31.7605238
              ],
              [
                51.312619,
                31.7629101
              ],
              [
                51.3120268,
                31.7670478
              ],
              [
                51.3094518,
                31.7730241
              ],
              [
                51.3094776,
                31.7760011
              ],
              [
                51.3088854,
                31.7794159
              ],
              [
                51.3059757,
                31.784297
              ],
              [
                51.3047655,
                31.7878865
              ],
              [
                51.2995206,
                31.7955587
              ],
              [
                51.2938132,
                31.8055718
              ],
              [
                51.2931358,
                31.810817
              ],
              [
                51.2959805,
                31.8183708
              ],
              [
                51.2986787,
                31.8222844
              ],
              [
                51.2991162,
                31.822919
              ],
              [
                51.3095704,
                31.8304012
              ],
              [
                51.3189946,
                31.835389
              ],
              [
                51.3246908,
                31.8371497
              ],
              [
                51.3338832,
                31.8402559
              ],
              [
                51.3389558,
                31.8407371
              ],
              [
                51.3456249,
                31.8399715
              ],
              [
                51.348483,
                31.839709
              ],
              [
                51.3597612,
                31.8492459
              ],
              [
                51.3653745,
                31.8555012
              ],
              [
                51.36625,
                31.8563979
              ],
              [
                51.3697776,
                31.8562448
              ],
              [
                51.3776826,
                31.8533141
              ],
              [
                51.3811588,
                31.8516737
              ],
              [
                51.3837852,
                31.8496615
              ],
              [
                51.387521,
                31.8489872
              ],
              [
                51.3915457,
                31.8490527
              ],
              [
                51.3923825,
                31.8490528
              ],
              [
                51.3926591,
                31.8493326
              ],
              [
                51.3934924,
                31.8493327
              ],
              [
                51.3940491,
                31.8493327
              ],
              [
                51.3998822,
                31.8507141
              ],
              [
                51.4021022,
                31.8518337
              ],
              [
                51.4029355,
                31.8518337
              ],
              [
                51.4096022,
                31.858497
              ],
              [
                51.4109919,
                31.8604382
              ],
              [
                51.4121055,
                31.8618287
              ],
              [
                51.4132155,
                31.8640498
              ],
              [
                51.4140486,
                31.8668307
              ],
              [
                51.4143253,
                31.8804463
              ],
              [
                51.417382,
                31.8940529
              ],
              [
                51.4262719,
                31.9126617
              ],
              [
                51.4282151,
                31.9268282
              ],
              [
                51.4276585,
                31.9296091
              ],
              [
                51.4254384,
                31.9354418
              ],
              [
                51.4223817,
                31.9404439
              ],
              [
                51.4179385,
                31.9451661
              ],
              [
                51.4151585,
                31.9484978
              ],
              [
                51.4143253,
                31.9493284
              ],
              [
                51.4134919,
                31.9512787
              ],
              [
                51.4132154,
                31.9523803
              ],
              [
                51.4146052,
                31.9573914
              ],
              [
                51.414882,
                31.958502
              ],
              [
                51.4150071,
                31.958677
              ],
              [
                51.4161853,
                31.9603245
              ],
              [
                51.4176586,
                31.9623844
              ],
              [
                51.4226238,
                31.964328
              ],
              [
                51.4240483,
                31.9648856
              ],
              [
                51.4249413,
                31.9653573
              ],
              [
                51.433323,
                31.9697844
              ],
              [
                51.4335106,
                31.9698835
              ],
              [
                51.4340484,
                31.9701675
              ],
              [
                51.4342279,
                31.971413
              ],
              [
                51.4343282,
                31.9721088
              ],
              [
                51.433888,
                31.9735093
              ],
              [
                51.4327449,
                31.9771462
              ],
              [
                51.4312718,
                31.9818331
              ],
              [
                51.430715,
                31.9826638
              ],
              [
                51.4304383,
                31.9837744
              ],
              [
                51.4301617,
                31.9862755
              ],
              [
                51.4298817,
                31.9907268
              ],
              [
                51.4296051,
                31.9923881
              ],
              [
                51.4293249,
                31.9937786
              ],
              [
                51.429325,
                31.9998914
              ],
              [
                51.4248817,
                32.0071056
              ],
              [
                51.4143253,
                32.0323871
              ],
              [
                51.4040487,
                32.0426623
              ],
              [
                51.4029354,
                32.0435021
              ],
              [
                51.3967489,
                32.0456769
              ],
              [
                51.3875908,
                32.0489633
              ],
              [
                51.3869213,
                32.0489852
              ],
              [
                51.3868698,
                32.0493125
              ],
              [
                51.3855051,
                32.0492252
              ],
              [
                51.3851961,
                32.0497054
              ],
              [
                51.3842949,
                32.0496399
              ],
              [
                51.381823,
                32.0510585
              ],
              [
                51.3785014,
                32.0527171
              ],
              [
                51.3768792,
                32.0556197
              ],
              [
                51.3760294,
                32.0583257
              ],
              [
                51.3821577,
                32.0674471
              ],
              [
                51.3837799,
                32.0698692
              ],
              [
                51.3843256,
                32.0701652
              ],
              [
                51.3854355,
                32.070725
              ],
              [
                51.3859922,
                32.0723864
              ],
              [
                51.3862687,
                32.0835014
              ],
              [
                51.3865455,
                32.0860024
              ],
              [
                51.3862688,
                32.0865532
              ],
              [
                51.3857121,
                32.0915555
              ],
              [
                51.3851588,
                32.0912755
              ],
              [
                51.3823789,
                32.0948871
              ],
              [
                51.3818255,
                32.0959978
              ],
              [
                51.3676557,
                32.1101647
              ],
              [
                51.3573791,
                32.12295
              ],
              [
                51.3543226,
                32.1307242
              ],
              [
                51.3457126,
                32.1396181
              ],
              [
                51.3445994,
                32.1404488
              ],
              [
                51.3442305,
                32.1406355
              ],
              [
                51.3437659,
                32.1409995
              ],
              [
                51.3434894,
                32.1407287
              ],
              [
                51.3423794,
                32.1409995
              ],
              [
                51.3418227,
                32.1412795
              ],
              [
                51.3409892,
                32.1412794
              ],
              [
                51.3409893,
                32.1415593
              ],
              [
                51.340156,
                32.1415594
              ],
              [
                51.3326561,
                32.1451711
              ],
              [
                51.3320995,
                32.1451711
              ],
              [
                51.3309895,
                32.1460017
              ],
              [
                51.3268228,
                32.1476721
              ],
              [
                51.3020999,
                32.1548866
              ],
              [
                51.2998766,
                32.1554463
              ],
              [
                51.2934865,
                32.1559972
              ],
              [
                51.2926534,
                32.1562771
              ],
              [
                51.2890433,
                32.1562771
              ],
              [
                51.2876533,
                32.1559972
              ],
              [
                51.2845968,
                32.1559972
              ],
              [
                51.2843201,
                32.1562771
              ],
              [
                51.2826534,
                32.1562771
              ],
              [
                51.2820967,
                32.1565569
              ],
              [
                51.2779302,
                32.1565569
              ],
              [
                51.2684869,
                32.1587782
              ],
              [
                51.2593169,
                32.1626698
              ],
              [
                51.258207,
                32.1632295
              ],
              [
                51.2565403,
                32.1635004
              ],
              [
                51.2434838,
                32.1685027
              ],
              [
                51.2423741,
                32.1687826
              ],
              [
                51.2337608,
                32.1743356
              ],
              [
                51.232094,
                32.1765568
              ],
              [
                51.2315408,
                32.1768367
              ],
              [
                51.2309842,
                32.1782272
              ],
              [
                51.2218176,
                32.1893332
              ],
              [
                51.2218176,
                32.1896132
              ],
              [
                51.2212629,
                32.190165
              ],
              [
                51.2093177,
                32.2051707
              ],
              [
                51.2087611,
                32.2062813
              ],
              [
                51.1970946,
                32.2182271
              ],
              [
                51.194038,
                32.2226696
              ],
              [
                51.1937613,
                32.2232294
              ],
              [
                51.1923713,
                32.22434
              ],
              [
                51.1918146,
                32.2246199
              ],
              [
                51.1915378,
                32.2243399
              ],
              [
                51.1915379,
                32.22406
              ],
              [
                51.1645918,
                32.192945
              ],
              [
                51.1545919,
                32.1862813
              ],
              [
                51.1540351,
                32.1860014
              ],
              [
                51.1534819,
                32.1860014
              ],
              [
                51.1495919,
                32.18406
              ],
              [
                51.1487586,
                32.1832203
              ],
              [
                51.1137558,
                32.1601685
              ],
              [
                51.1129224,
                32.158778
              ],
              [
                51.1018127,
                32.136286
              ],
              [
                51.1015326,
                32.1354463
              ],
              [
                51.1015325,
                32.1343357
              ],
              [
                51.1009792,
                32.1321145
              ],
              [
                51.100146,
                32.1273922
              ],
              [
                51.099866,
                32.1246112
              ],
              [
                51.0984793,
                32.1096136
              ],
              [
                51.0954227,
                32.086553
              ],
              [
                51.0948661,
                32.0854423
              ],
              [
                51.0945895,
                32.0840609
              ],
              [
                51.0943127,
                32.0798894
              ],
              [
                51.0943127,
                32.0751671
              ],
              [
                51.0945895,
                32.0735058
              ],
              [
                51.0948661,
                32.0715554
              ],
              [
                51.0951462,
                32.0685036
              ],
              [
                51.0954227,
                32.0651718
              ],
              [
                51.0956995,
                32.0635014
              ],
              [
                51.0959794,
                32.0629415
              ],
              [
                51.0970894,
                32.0559981
              ],
              [
                51.0976461,
                32.0526664
              ],
              [
                51.0979228,
                32.0521156
              ],
              [
                51.0965327,
                32.0404499
              ],
              [
                51.0912563,
                32.034608
              ],
              [
                51.0898663,
                32.0340572
              ],
              [
                51.0879229,
                32.0326668
              ],
              [
                51.0873661,
                32.0321069
              ],
              [
                51.0837563,
                32.0293259
              ],
              [
                51.0759764,
                32.0259942
              ],
              [
                51.0643099,
                32.0240529
              ],
              [
                51.0612532,
                32.023782
              ],
              [
                51.05292,
                32.023782
              ],
              [
                51.0501434,
                32.0243328
              ],
              [
                51.0493102,
                32.0243328
              ],
              [
                51.0451436,
                32.0243328
              ],
              [
                51.0445869,
                32.0246127
              ],
              [
                51.0404202,
                32.0248836
              ],
              [
                51.039587,
                32.0246127
              ],
              [
                51.038477,
                32.0246127
              ],
              [
                51.0381969,
                32.0243328
              ],
              [
                51.0373637,
                32.0243328
              ],
              [
                51.0359769,
                32.023782
              ],
              [
                51.0351438,
                32.023782
              ],
              [
                51.0281971,
                32.0221116
              ],
              [
                51.0243071,
                32.0204412
              ],
              [
                51.0240305,
                32.0207211
              ],
              [
                51.0220873,
                32.0207211
              ],
              [
                51.0220872,
                32.0204412
              ],
              [
                51.0095841,
                32.0118364
              ],
              [
                51.0079174,
                32.010166
              ],
              [
                50.9988407,
                31.999343
              ],
              [
                50.9914384,
                31.9939075
              ],
              [
                50.9864106,
                31.9880111
              ],
              [
                50.9779956,
                31.9802546
              ],
              [
                50.9691456,
                31.9739955
              ],
              [
                50.9642426,
                31.9713192
              ],
              [
                50.9605151,
                31.9679871
              ],
              [
                50.9561911,
                31.9672442
              ],
              [
                50.9358414,
                31.9597155
              ],
              [
                50.9313904,
                31.9585755
              ],
              [
                50.9156134,
                31.9505303
              ],
              [
                50.9043067,
                31.9460908
              ],
              [
                50.9017169,
                31.9449594
              ],
              [
                50.8979593,
                31.9435831
              ],
              [
                50.8908728,
                31.9432761
              ],
              [
                50.885263,
                31.9424183
              ],
              [
                50.8786749,
                31.940401
              ],
              [
                50.8655163,
                31.9403685
              ],
              [
                50.8574336,
                31.9413966
              ],
              [
                50.8511664,
                31.9438063
              ],
              [
                50.8469957,
                31.9453994
              ],
              [
                50.8416715,
                31.9496817
              ],
              [
                50.8363936,
                31.9564412
              ],
              [
                50.8358251,
                31.9592992
              ],
              [
                50.8337686,
                31.9621071
              ],
              [
                50.8307464,
                31.9642891
              ],
              [
                50.8263983,
                31.9716011
              ],
              [
                50.8194183,
                31.9751637
              ],
              [
                50.8084088,
                31.9831064
              ],
              [
                50.8047216,
                31.9842938
              ],
              [
                50.8033353,
                31.9832479
              ],
              [
                50.8004514,
                31.9795914
              ],
              [
                50.7972425,
                31.9728016
              ],
              [
                50.788354,
                31.9516507
              ],
              [
                50.7871137,
                31.9474075
              ],
              [
                50.7852416,
                31.9350887
              ],
              [
                50.785849,
                31.9328936
              ],
              [
                50.7859125,
                31.9262862
              ],
              [
                50.780856,
                31.9047111
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554935,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بن",
          "name:en": "Ben County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4815442",
          "wikipedia": "en:Ben County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.3952527,
                32.573377
              ],
              [
                50.3989636,
                32.5559727
              ],
              [
                50.4193121,
                32.5457492
              ],
              [
                50.4231218,
                32.5384634
              ],
              [
                50.4353682,
                32.5276385
              ],
              [
                50.4479479,
                32.5121582
              ],
              [
                50.4513799,
                32.5111269
              ],
              [
                50.4558707,
                32.5096319
              ],
              [
                50.4696962,
                32.5079414
              ],
              [
                50.4842261,
                32.5067908
              ],
              [
                50.5018904,
                32.5047862
              ],
              [
                50.5311014,
                32.5030806
              ],
              [
                50.5558611,
                32.5015778
              ],
              [
                50.5655867,
                32.5011083
              ],
              [
                50.5716333,
                32.4967714
              ],
              [
                50.5735024,
                32.4930934
              ],
              [
                50.5804523,
                32.4823951
              ],
              [
                50.5847953,
                32.4754561
              ],
              [
                50.5897522,
                32.4749632
              ],
              [
                50.5967309,
                32.4757774
              ],
              [
                50.6082215,
                32.4794699
              ],
              [
                50.6292173,
                32.4782133
              ],
              [
                50.6351717,
                32.4834589
              ],
              [
                50.6535387,
                32.4981676
              ],
              [
                50.676994,
                32.4932176
              ],
              [
                50.7057314,
                32.4688464
              ],
              [
                50.7217229,
                32.4653216
              ],
              [
                50.7343347,
                32.4565452
              ],
              [
                50.7568864,
                32.4538918
              ],
              [
                50.7673815,
                32.4528343
              ],
              [
                50.7831994,
                32.4507
              ],
              [
                50.8051048,
                32.460646
              ],
              [
                50.8134081,
                32.4637514
              ],
              [
                50.8179345,
                32.4658001
              ],
              [
                50.8244527,
                32.4767902
              ],
              [
                50.8275573,
                32.4824662
              ],
              [
                50.8287017,
                32.4845642
              ],
              [
                50.8317151,
                32.489778
              ],
              [
                50.8333818,
                32.5064793
              ],
              [
                50.8418744,
                32.5163317
              ],
              [
                50.841338,
                32.5181725
              ],
              [
                50.8207603,
                32.5226367
              ],
              [
                50.8104809,
                32.5326679
              ],
              [
                50.8046156,
                32.5356004
              ],
              [
                50.79757,
                32.5442689
              ],
              [
                50.7944382,
                32.5521994
              ],
              [
                50.7939373,
                32.5625978
              ],
              [
                50.7944105,
                32.567682
              ],
              [
                50.7863855,
                32.5762355
              ],
              [
                50.7765149,
                32.5871334
              ],
              [
                50.7641362,
                32.6004297
              ],
              [
                50.7612428,
                32.6124922
              ],
              [
                50.760009,
                32.6315311
              ],
              [
                50.7613752,
                32.6316972
              ],
              [
                50.7872553,
                32.6278428
              ],
              [
                50.7956918,
                32.6303345
              ],
              [
                50.7966992,
                32.6336944
              ],
              [
                50.7953219,
                32.6360905
              ],
              [
                50.7923341,
                32.6413518
              ],
              [
                50.7813713,
                32.6515741
              ],
              [
                50.7759461,
                32.6644995
              ],
              [
                50.7775795,
                32.6925599
              ],
              [
                50.7778747,
                32.6968401
              ],
              [
                50.7763381,
                32.6966415
              ],
              [
                50.7757181,
                32.6982757
              ],
              [
                50.7758574,
                32.7034038
              ],
              [
                50.7701294,
                32.7001806
              ],
              [
                50.7690195,
                32.7001807
              ],
              [
                50.7684628,
                32.7004606
              ],
              [
                50.7670728,
                32.7004606
              ],
              [
                50.7606827,
                32.7026818
              ],
              [
                50.7606828,
                32.7029617
              ],
              [
                50.7598496,
                32.7029618
              ],
              [
                50.7573495,
                32.7043432
              ],
              [
                50.7567964,
                32.7043433
              ],
              [
                50.7565163,
                32.704903
              ],
              [
                50.7529063,
                32.7062935
              ],
              [
                50.7523497,
                32.7065735
              ],
              [
                50.7467931,
                32.7085147
              ],
              [
                50.7462397,
                32.7085148
              ],
              [
                50.7459597,
                32.7087947
              ],
              [
                50.7445732,
                32.7087947
              ],
              [
                50.7440165,
                32.7090746
              ],
              [
                50.7417932,
                32.7090746
              ],
              [
                50.7412398,
                32.7093455
              ],
              [
                50.7370732,
                32.7090746
              ],
              [
                50.7365165,
                32.7087947
              ],
              [
                50.7351266,
                32.7087947
              ],
              [
                50.7301267,
                32.7068534
              ],
              [
                50.7155032,
                32.7060378
              ],
              [
                50.7116515,
                32.7005607
              ],
              [
                50.703063,
                32.7051584
              ],
              [
                50.6947619,
                32.706669
              ],
              [
                50.6878443,
                32.7044672
              ],
              [
                50.6725323,
                32.7078661
              ],
              [
                50.664701,
                32.707094
              ],
              [
                50.6428126,
                32.7053236
              ],
              [
                50.6346592,
                32.7015252
              ],
              [
                50.628897,
                32.6978593
              ],
              [
                50.6181914,
                32.6935492
              ],
              [
                50.6147584,
                32.6878983
              ],
              [
                50.6058001,
                32.6932115
              ],
              [
                50.6023914,
                32.6869434
              ],
              [
                50.5871804,
                32.6840568
              ],
              [
                50.5788785,
                32.6912385
              ],
              [
                50.5717563,
                32.6867198
              ],
              [
                50.565016,
                32.6723313
              ],
              [
                50.5626951,
                32.6730437
              ],
              [
                50.5613247,
                32.6734644
              ],
              [
                50.5622097,
                32.6883087
              ],
              [
                50.5554232,
                32.6751534
              ],
              [
                50.548673,
                32.6799061
              ],
              [
                50.5504524,
                32.6904529
              ],
              [
                50.5539533,
                32.6942549
              ],
              [
                50.550751,
                32.7015785
              ],
              [
                50.5526263,
                32.7096555
              ],
              [
                50.5498848,
                32.7138973
              ],
              [
                50.5451313,
                32.7166501
              ],
              [
                50.5423806,
                32.7182429
              ],
              [
                50.5409526,
                32.7190698
              ],
              [
                50.5384525,
                32.7190699
              ],
              [
                50.5381724,
                32.7193498
              ],
              [
                50.5373391,
                32.7193498
              ],
              [
                50.5373392,
                32.7190699
              ],
              [
                50.5342859,
                32.7190698
              ],
              [
                50.5342859,
                32.71879
              ],
              [
                50.5334832,
                32.71879
              ],
              [
                50.5330615,
                32.71879
              ],
              [
                50.5323391,
                32.71879
              ],
              [
                50.5317835,
                32.7186544
              ],
              [
                50.5312292,
                32.7185191
              ],
              [
                50.5302404,
                32.7183199
              ],
              [
                50.529994,
                32.7182703
              ],
              [
                50.5298394,
                32.7182392
              ],
              [
                50.5288346,
                32.7180704
              ],
              [
                50.528708,
                32.7180491
              ],
              [
                50.5281726,
                32.7179592
              ],
              [
                50.5280973,
                32.7179592
              ],
              [
                50.5270627,
                32.7179593
              ],
              [
                50.5266062,
                32.7178068
              ],
              [
                50.5220627,
                32.7162888
              ],
              [
                50.5212295,
                32.7162888
              ],
              [
                50.5200427,
                32.7157321
              ],
              [
                50.5159457,
                32.7138098
              ],
              [
                50.5095529,
                32.7108099
              ],
              [
                50.5087926,
                32.710453
              ],
              [
                50.4973628,
                32.705088
              ],
              [
                50.4940063,
                32.7035121
              ],
              [
                50.4784502,
                32.6907356
              ],
              [
                50.4767833,
                32.6887942
              ],
              [
                50.4695602,
                32.6818417
              ],
              [
                50.4620605,
                32.6712863
              ],
              [
                50.458447,
                32.6612907
              ],
              [
                50.4581705,
                32.6607308
              ],
              [
                50.4584471,
                32.6599002
              ],
              [
                50.4581706,
                32.6546271
              ],
              [
                50.458447,
                32.6540672
              ],
              [
                50.4600501,
                32.6505929
              ],
              [
                50.4601135,
                32.6504555
              ],
              [
                50.4651137,
                32.6476835
              ],
              [
                50.4654338,
                32.6475224
              ],
              [
                50.466227,
                32.6471236
              ],
              [
                50.4667837,
                32.6471236
              ],
              [
                50.4670602,
                32.6471236
              ],
              [
                50.4676168,
                32.6471236
              ],
              [
                50.4678938,
                32.6468437
              ],
              [
                50.4703934,
                32.6468436
              ],
              [
                50.4709501,
                32.6465728
              ],
              [
                50.4784503,
                32.6468437
              ],
              [
                50.4787268,
                32.6471235
              ],
              [
                50.4826167,
                32.6471236
              ],
              [
                50.4842836,
                32.6474035
              ],
              [
                50.4829785,
                32.6457596
              ],
              [
                50.4956077,
                32.6448924
              ],
              [
                50.5009486,
                32.6437099
              ],
              [
                50.5047512,
                32.638363
              ],
              [
                50.5042696,
                32.6357422
              ],
              [
                50.5043624,
                32.6323653
              ],
              [
                50.5048772,
                32.6307843
              ],
              [
                50.504708,
                32.6277127
              ],
              [
                50.504146,
                32.6257208
              ],
              [
                50.5036752,
                32.6241214
              ],
              [
                50.5017168,
                32.6168224
              ],
              [
                50.4994448,
                32.6085367
              ],
              [
                50.4987431,
                32.5995428
              ],
              [
                50.4943811,
                32.5929429
              ],
              [
                50.4892956,
                32.5907794
              ],
              [
                50.4828217,
                32.5903938
              ],
              [
                50.4766204,
                32.589905
              ],
              [
                50.4712272,
                32.5890734
              ],
              [
                50.4630538,
                32.5877533
              ],
              [
                50.4588322,
                32.5848802
              ],
              [
                50.4490742,
                32.581136
              ],
              [
                50.4357862,
                32.5758937
              ],
              [
                50.4342776,
                32.5741551
              ],
              [
                50.4311348,
                32.5731291
              ],
              [
                50.4219774,
                32.5681998
              ],
              [
                50.4141883,
                32.5652963
              ],
              [
                50.4125261,
                32.5664544
              ],
              [
                50.4109071,
                32.5685561
              ],
              [
                50.4029608,
                32.572491
              ],
              [
                50.3952527,
                32.573377
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555064,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سامان",
          "name:en": "Saman County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5682862",
          "wikipedia": "en:Saman County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.760009,
                32.6315311
              ],
              [
                50.7612428,
                32.6124922
              ],
              [
                50.7641362,
                32.6004297
              ],
              [
                50.7765149,
                32.5871334
              ],
              [
                50.7863855,
                32.5762355
              ],
              [
                50.7944105,
                32.567682
              ],
              [
                50.7939373,
                32.5625978
              ],
              [
                50.7944382,
                32.5521994
              ],
              [
                50.79757,
                32.5442689
              ],
              [
                50.8046156,
                32.5356004
              ],
              [
                50.8104809,
                32.5326679
              ],
              [
                50.8207603,
                32.5226367
              ],
              [
                50.841338,
                32.5181725
              ],
              [
                50.8418744,
                32.5163317
              ],
              [
                50.8333818,
                32.5064793
              ],
              [
                50.8317151,
                32.489778
              ],
              [
                50.8287017,
                32.4845642
              ],
              [
                50.8275573,
                32.4824662
              ],
              [
                50.8244527,
                32.4767902
              ],
              [
                50.8179345,
                32.4658001
              ],
              [
                50.8201756,
                32.4629876
              ],
              [
                50.8289105,
                32.4495983
              ],
              [
                50.8353639,
                32.4403852
              ],
              [
                50.840577,
                32.4288496
              ],
              [
                50.8546197,
                32.4194906
              ],
              [
                50.8656258,
                32.4146641
              ],
              [
                50.8775174,
                32.4147675
              ],
              [
                50.8980281,
                32.4066439
              ],
              [
                50.9126093,
                32.40362
              ],
              [
                50.9281695,
                32.4003093
              ],
              [
                50.9386008,
                32.3994123
              ],
              [
                50.9509643,
                32.3980848
              ],
              [
                50.9710357,
                32.3904972
              ],
              [
                50.9709707,
                32.3912842
              ],
              [
                50.9706939,
                32.392124
              ],
              [
                50.9704173,
                32.3937854
              ],
              [
                50.9704173,
                32.3951758
              ],
              [
                50.9701373,
                32.3954468
              ],
              [
                50.9698606,
                32.3971172
              ],
              [
                50.9695841,
                32.3996184
              ],
              [
                50.9673605,
                32.4146162
              ],
              [
                50.9676373,
                32.4254516
              ],
              [
                50.9679174,
                32.4293432
              ],
              [
                50.9684705,
                32.4335058
              ],
              [
                50.9698606,
                32.4379482
              ],
              [
                50.9701371,
                32.4396187
              ],
              [
                50.9704172,
                32.4401696
              ],
              [
                50.9731939,
                32.4457317
              ],
              [
                50.9845837,
                32.4604497
              ],
              [
                50.9943069,
                32.4740661
              ],
              [
                50.9993068,
                32.4835109
              ],
              [
                50.9997917,
                32.4840617
              ],
              [
                50.9998634,
                32.4846216
              ],
              [
                51.0051401,
                32.5012899
              ],
              [
                51.0090299,
                32.5148973
              ],
              [
                51.0090299,
                32.5151772
              ],
              [
                51.0090299,
                32.5165677
              ],
              [
                51.00903,
                32.5168386
              ],
              [
                51.00903,
                32.5176784
              ],
              [
                51.0087499,
                32.5182291
              ],
              [
                51.0081965,
                32.521561
              ],
              [
                51.0079166,
                32.5240621
              ],
              [
                51.0001401,
                32.5335069
              ],
              [
                50.9984733,
                32.5376786
              ],
              [
                50.9981967,
                32.5379584
              ],
              [
                50.9990324,
                32.5392043
              ],
              [
                50.9981967,
                32.545182
              ],
              [
                50.9981966,
                32.5457328
              ],
              [
                50.9977867,
                32.5505181
              ],
              [
                50.995493,
                32.5541074
              ],
              [
                50.9821104,
                32.5589312
              ],
              [
                50.9736529,
                32.5628285
              ],
              [
                50.9623231,
                32.5673038
              ],
              [
                50.9549892,
                32.5727917
              ],
              [
                50.9465217,
                32.57951
              ],
              [
                50.9412699,
                32.5870349
              ],
              [
                50.9300017,
                32.5957619
              ],
              [
                50.9261418,
                32.6000356
              ],
              [
                50.923471,
                32.6157379
              ],
              [
                50.9231908,
                32.6179591
              ],
              [
                50.9229143,
                32.621291
              ],
              [
                50.9226377,
                32.6246229
              ],
              [
                50.9215851,
                32.6279547
              ],
              [
                50.9220618,
                32.6385581
              ],
              [
                50.9218042,
                32.6440722
              ],
              [
                50.9214384,
                32.6475578
              ],
              [
                50.920456,
                32.6500763
              ],
              [
                50.9187833,
                32.6550611
              ],
              [
                50.9165393,
                32.6611992
              ],
              [
                50.9122744,
                32.6666371
              ],
              [
                50.8996349,
                32.6750001
              ],
              [
                50.8919712,
                32.6878871
              ],
              [
                50.8901346,
                32.6896255
              ],
              [
                50.8901346,
                32.6901853
              ],
              [
                50.889858,
                32.6904652
              ],
              [
                50.8895779,
                32.6915758
              ],
              [
                50.8879113,
                32.6951786
              ],
              [
                50.8873579,
                32.6957384
              ],
              [
                50.887358,
                32.6962892
              ],
              [
                50.8737447,
                32.7065736
              ],
              [
                50.8737448,
                32.7068535
              ],
              [
                50.8731882,
                32.7068535
              ],
              [
                50.8723547,
                32.7076842
              ],
              [
                50.8662448,
                32.7099054
              ],
              [
                50.8648548,
                32.7099055
              ],
              [
                50.8640216,
                32.7101853
              ],
              [
                50.8626351,
                32.7101853
              ],
              [
                50.8604115,
                32.7107362
              ],
              [
                50.8595783,
                32.7107361
              ],
              [
                50.8592983,
                32.7110161
              ],
              [
                50.8576316,
                32.711016
              ],
              [
                50.8570782,
                32.7112959
              ],
              [
                50.8551317,
                32.711296
              ],
              [
                50.8529117,
                32.7118467
              ],
              [
                50.8523551,
                32.7121267
              ],
              [
                50.8512451,
                32.7115669
              ],
              [
                50.8459652,
                32.7115668
              ],
              [
                50.8431885,
                32.7112959
              ],
              [
                50.8429085,
                32.711016
              ],
              [
                50.8354085,
                32.711016
              ],
              [
                50.8345753,
                32.7112959
              ],
              [
                50.8317987,
                32.7112959
              ],
              [
                50.8290221,
                32.711296
              ],
              [
                50.8123522,
                32.7079641
              ],
              [
                50.7945759,
                32.7040724
              ],
              [
                50.7899403,
                32.7007764
              ],
              [
                50.7798194,
                32.6972012
              ],
              [
                50.7778747,
                32.6968401
              ],
              [
                50.7775795,
                32.6925599
              ],
              [
                50.7759461,
                32.6644995
              ],
              [
                50.7813713,
                32.6515741
              ],
              [
                50.7923341,
                32.6413518
              ],
              [
                50.7953219,
                32.6360905
              ],
              [
                50.7966992,
                32.6336944
              ],
              [
                50.7956918,
                32.6303345
              ],
              [
                50.7872553,
                32.6278428
              ],
              [
                50.7613752,
                32.6316972
              ],
              [
                50.760009,
                32.6315311
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555107,
        "tags": {
          "admin_level": "5",
          "alt_name:ar": "مقاطعة شهر كورد",
          "boundary": "administrative",
          "name": "شهرستان شهرکرد",
          "name:ar": "مقاطعة شهركرد",
          "name:en": "Sharekurd County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279085",
          "wikipedia": "en:Shahrekord County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.3453697,
                32.5396833
              ],
              [
                50.3507152,
                32.5358774
              ],
              [
                50.3624671,
                32.5264239
              ],
              [
                50.3675339,
                32.5223581
              ],
              [
                50.372893,
                32.516103
              ],
              [
                50.3778666,
                32.5080158
              ],
              [
                50.3808937,
                32.4988245
              ],
              [
                50.3781778,
                32.4904831
              ],
              [
                50.3742766,
                32.4858058
              ],
              [
                50.370559,
                32.4801243
              ],
              [
                50.3685748,
                32.4754733
              ],
              [
                50.3662847,
                32.4677648
              ],
              [
                50.3647053,
                32.4632394
              ],
              [
                50.3643915,
                32.458207
              ],
              [
                50.3632575,
                32.4486188
              ],
              [
                50.3677657,
                32.4382557
              ],
              [
                50.3715279,
                32.4347834
              ],
              [
                50.3761102,
                32.4322065
              ],
              [
                50.3901118,
                32.4179564
              ],
              [
                50.4215458,
                32.3940311
              ],
              [
                50.4279451,
                32.3887441
              ],
              [
                50.4315215,
                32.3874633
              ],
              [
                50.4338061,
                32.3831375
              ],
              [
                50.4390421,
                32.3777685
              ],
              [
                50.4467632,
                32.3723135
              ],
              [
                50.4636903,
                32.3662938
              ],
              [
                50.4653924,
                32.3641523
              ],
              [
                50.4707622,
                32.3600621
              ],
              [
                50.4834652,
                32.3544974
              ],
              [
                50.4876065,
                32.3546787
              ],
              [
                50.4889431,
                32.3539374
              ],
              [
                50.4980135,
                32.3491137
              ],
              [
                50.5005025,
                32.3481711
              ],
              [
                50.5119649,
                32.3394161
              ],
              [
                50.5432346,
                32.3152123
              ],
              [
                50.5790992,
                32.2932734
              ],
              [
                50.5960875,
                32.2864097
              ],
              [
                50.6057862,
                32.2853963
              ],
              [
                50.60788,
                32.285665
              ],
              [
                50.6095525,
                32.2859021
              ],
              [
                50.6154449,
                32.2847631
              ],
              [
                50.6201953,
                32.2832567
              ],
              [
                50.6232833,
                32.282779
              ],
              [
                50.631523,
                32.2722567
              ],
              [
                50.6352138,
                32.2630215
              ],
              [
                50.639197,
                32.2547311
              ],
              [
                50.6527332,
                32.2436465
              ],
              [
                50.6606898,
                32.2372039
              ],
              [
                50.6686681,
                32.2308366
              ],
              [
                50.6833411,
                32.2150353
              ],
              [
                50.6854357,
                32.2140225
              ],
              [
                50.6914089,
                32.2092823
              ],
              [
                50.7023229,
                32.2032908
              ],
              [
                50.713367,
                32.1982114
              ],
              [
                50.7195709,
                32.1976668
              ],
              [
                50.7248412,
                32.1970071
              ],
              [
                50.7313913,
                32.1927372
              ],
              [
                50.7452075,
                32.182318
              ],
              [
                50.7500999,
                32.1756684
              ],
              [
                50.7566398,
                32.1672199
              ],
              [
                50.7622378,
                32.1633797
              ],
              [
                50.7600414,
                32.1613567
              ],
              [
                50.7659472,
                32.1571462
              ],
              [
                50.7701504,
                32.1542141
              ],
              [
                50.773176,
                32.1534617
              ],
              [
                50.7788948,
                32.1518852
              ],
              [
                50.7838475,
                32.1506219
              ],
              [
                50.7867609,
                32.1498457
              ],
              [
                50.8209964,
                32.1352898
              ],
              [
                50.8455176,
                32.127163
              ],
              [
                50.8517577,
                32.1249848
              ],
              [
                50.8656892,
                32.1173875
              ],
              [
                50.8662458,
                32.1173876
              ],
              [
                50.8662458,
                32.1171076
              ],
              [
                50.8701357,
                32.1171076
              ],
              [
                50.870689,
                32.1173875
              ],
              [
                50.8765223,
                32.1285026
              ],
              [
                50.877079,
                32.1315544
              ],
              [
                50.8801356,
                32.140999
              ],
              [
                50.8804122,
                32.1415589
              ],
              [
                50.8806888,
                32.1429494
              ],
              [
                50.8962453,
                32.1690621
              ],
              [
                50.8965254,
                32.1701727
              ],
              [
                50.9129151,
                32.1896129
              ],
              [
                50.9148584,
                32.1901636
              ],
              [
                50.9156917,
                32.1904435
              ],
              [
                50.9168017,
                32.1904436
              ],
              [
                50.921805,
                32.192114
              ],
              [
                50.9226384,
                32.192114
              ],
              [
                50.9231915,
                32.1923938
              ],
              [
                50.925415,
                32.1923939
              ],
              [
                50.9270816,
                32.1926648
              ],
              [
                50.9279148,
                32.1929447
              ],
              [
                50.9301381,
                32.1929447
              ],
              [
                50.9309715,
                32.1932245
              ],
              [
                50.941528,
                32.1932246
              ],
              [
                50.9418048,
                32.1929447
              ],
              [
                50.9443046,
                32.1929447
              ],
              [
                50.9451469,
                32.1929447
              ],
              [
                50.9370039,
                32.1803373
              ],
              [
                50.9310184,
                32.1651569
              ],
              [
                50.9251437,
                32.1468143
              ],
              [
                50.9235317,
                32.1396538
              ],
              [
                50.9247861,
                32.1301911
              ],
              [
                50.9351589,
                32.125702
              ],
              [
                50.9381343,
                32.123594
              ],
              [
                50.9513417,
                32.1142353
              ],
              [
                50.9599896,
                32.1057458
              ],
              [
                50.963149,
                32.0947475
              ],
              [
                50.9736496,
                32.0863028
              ],
              [
                50.9842278,
                32.0754857
              ],
              [
                50.9948566,
                32.0630867
              ],
              [
                51.0033366,
                32.0593372
              ],
              [
                51.0092449,
                32.0491958
              ],
              [
                51.0219472,
                32.0233621
              ],
              [
                51.0220873,
                32.0207211
              ],
              [
                51.0240305,
                32.0207211
              ],
              [
                51.0243071,
                32.0204412
              ],
              [
                51.0281971,
                32.0221116
              ],
              [
                51.0351438,
                32.023782
              ],
              [
                51.0359769,
                32.023782
              ],
              [
                51.0373637,
                32.0243328
              ],
              [
                51.0381969,
                32.0243328
              ],
              [
                51.038477,
                32.0246127
              ],
              [
                51.039587,
                32.0246127
              ],
              [
                51.0404202,
                32.0248836
              ],
              [
                51.0445869,
                32.0246127
              ],
              [
                51.0451436,
                32.0243328
              ],
              [
                51.0493102,
                32.0243328
              ],
              [
                51.0501434,
                32.0243328
              ],
              [
                51.05292,
                32.023782
              ],
              [
                51.0612532,
                32.023782
              ],
              [
                51.0643099,
                32.0240529
              ],
              [
                51.0759764,
                32.0259942
              ],
              [
                51.0837563,
                32.0293259
              ],
              [
                51.0873661,
                32.0321069
              ],
              [
                51.0879229,
                32.0326668
              ],
              [
                51.0898663,
                32.0340572
              ],
              [
                51.0912563,
                32.034608
              ],
              [
                51.0965327,
                32.0404499
              ],
              [
                51.0979228,
                32.0521156
              ],
              [
                51.0976461,
                32.0526664
              ],
              [
                51.0970894,
                32.0559981
              ],
              [
                51.0959794,
                32.0629415
              ],
              [
                51.0956995,
                32.0635014
              ],
              [
                51.0954227,
                32.0651718
              ],
              [
                51.0951462,
                32.0685036
              ],
              [
                51.0948661,
                32.0715554
              ],
              [
                51.0945895,
                32.0735058
              ],
              [
                51.0943127,
                32.0751671
              ],
              [
                51.0943127,
                32.0798894
              ],
              [
                51.0945895,
                32.0840609
              ],
              [
                51.0948661,
                32.0854423
              ],
              [
                51.0954227,
                32.086553
              ],
              [
                51.0984793,
                32.1096136
              ],
              [
                51.099866,
                32.1246112
              ],
              [
                51.100146,
                32.1273922
              ],
              [
                51.1009792,
                32.1321145
              ],
              [
                51.1015325,
                32.1343357
              ],
              [
                51.1015326,
                32.1354463
              ],
              [
                51.1018127,
                32.136286
              ],
              [
                51.1129224,
                32.158778
              ],
              [
                51.1137558,
                32.1601685
              ],
              [
                51.1487586,
                32.1832203
              ],
              [
                51.1495919,
                32.18406
              ],
              [
                51.1534819,
                32.1860014
              ],
              [
                51.1540351,
                32.1860014
              ],
              [
                51.1545919,
                32.1862813
              ],
              [
                51.1645918,
                32.192945
              ],
              [
                51.1915379,
                32.22406
              ],
              [
                51.1915378,
                32.2243399
              ],
              [
                51.1918146,
                32.2246199
              ],
              [
                51.1918146,
                32.2251706
              ],
              [
                51.1915378,
                32.2254415
              ],
              [
                51.1915378,
                32.2257215
              ],
              [
                51.1907047,
                32.2265612
              ],
              [
                51.185148,
                32.2373964
              ],
              [
                51.1843146,
                32.2387869
              ],
              [
                51.1812579,
                32.2451706
              ],
              [
                51.1684814,
                32.2626696
              ],
              [
                51.1657049,
                32.2665613
              ],
              [
                51.1462584,
                32.2860105
              ],
              [
                51.1457017,
                32.2862814
              ],
              [
                51.1443119,
                32.2876719
              ],
              [
                51.138202,
                32.2921234
              ],
              [
                51.1373686,
                32.2923943
              ],
              [
                51.1365351,
                32.293225
              ],
              [
                51.1337587,
                32.2946154
              ],
              [
                51.1326452,
                32.2948954
              ],
              [
                51.0795892,
                32.3298933
              ],
              [
                51.0784759,
                32.330724
              ],
              [
                51.0743093,
                32.333505
              ],
              [
                51.0465296,
                32.3426698
              ],
              [
                51.0418099,
                32.3443403
              ],
              [
                51.0318064,
                32.351004
              ],
              [
                51.02264,
                32.3562862
              ],
              [
                51.0220868,
                32.356837
              ],
              [
                51.0162533,
                32.3610086
              ],
              [
                50.9998944,
                32.3679522
              ],
              [
                50.9854172,
                32.3760064
              ],
              [
                50.973194,
                32.3882322
              ],
              [
                50.9710357,
                32.3904972
              ],
              [
                50.9509643,
                32.3980848
              ],
              [
                50.9386008,
                32.3994123
              ],
              [
                50.9281695,
                32.4003093
              ],
              [
                50.9126093,
                32.40362
              ],
              [
                50.8980281,
                32.4066439
              ],
              [
                50.8775174,
                32.4147675
              ],
              [
                50.8656258,
                32.4146641
              ],
              [
                50.8546197,
                32.4194906
              ],
              [
                50.840577,
                32.4288496
              ],
              [
                50.8353639,
                32.4403852
              ],
              [
                50.8289105,
                32.4495983
              ],
              [
                50.8201756,
                32.4629876
              ],
              [
                50.8179345,
                32.4658001
              ],
              [
                50.8134081,
                32.4637514
              ],
              [
                50.8051048,
                32.460646
              ],
              [
                50.7831994,
                32.4507
              ],
              [
                50.7673815,
                32.4528343
              ],
              [
                50.7568864,
                32.4538918
              ],
              [
                50.7343347,
                32.4565452
              ],
              [
                50.7217229,
                32.4653216
              ],
              [
                50.7057314,
                32.4688464
              ],
              [
                50.676994,
                32.4932176
              ],
              [
                50.6535387,
                32.4981676
              ],
              [
                50.6351717,
                32.4834589
              ],
              [
                50.6292173,
                32.4782133
              ],
              [
                50.6082215,
                32.4794699
              ],
              [
                50.5967309,
                32.4757774
              ],
              [
                50.5897522,
                32.4749632
              ],
              [
                50.5847953,
                32.4754561
              ],
              [
                50.5804523,
                32.4823951
              ],
              [
                50.5735024,
                32.4930934
              ],
              [
                50.5716333,
                32.4967714
              ],
              [
                50.5655867,
                32.5011083
              ],
              [
                50.5558611,
                32.5015778
              ],
              [
                50.5311014,
                32.5030806
              ],
              [
                50.5018904,
                32.5047862
              ],
              [
                50.4842261,
                32.5067908
              ],
              [
                50.4696962,
                32.5079414
              ],
              [
                50.4558707,
                32.5096319
              ],
              [
                50.4513799,
                32.5111269
              ],
              [
                50.4479479,
                32.5121582
              ],
              [
                50.4353682,
                32.5276385
              ],
              [
                50.4231218,
                32.5384634
              ],
              [
                50.4193121,
                32.5457492
              ],
              [
                50.3989636,
                32.5559727
              ],
              [
                50.3952527,
                32.573377
              ],
              [
                50.3892261,
                32.5739299
              ],
              [
                50.3832868,
                32.5731166
              ],
              [
                50.3810596,
                32.5696755
              ],
              [
                50.3767535,
                32.5681114
              ],
              [
                50.3756399,
                32.564983
              ],
              [
                50.3725218,
                32.5644198
              ],
              [
                50.3728188,
                32.5609784
              ],
              [
                50.3666567,
                32.5550965
              ],
              [
                50.3645037,
                32.5520928
              ],
              [
                50.3657366,
                32.5488688
              ],
              [
                50.3599306,
                32.5482704
              ],
              [
                50.3549229,
                32.5473146
              ],
              [
                50.3508231,
                32.543843
              ],
              [
                50.3453697,
                32.5396833
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555126,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فارسان",
          "name:en": "Farsan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278699",
          "wikipedia": "en:Farsan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.3436041,
                32.3263274
              ],
              [
                50.3523384,
                32.316565
              ],
              [
                50.3794454,
                32.2859605
              ],
              [
                50.390682,
                32.2732002
              ],
              [
                50.3974434,
                32.2670672
              ],
              [
                50.414351,
                32.2514498
              ],
              [
                50.4211521,
                32.2452561
              ],
              [
                50.4243894,
                32.2431439
              ],
              [
                50.4302975,
                32.2389676
              ],
              [
                50.433062,
                32.2370541
              ],
              [
                50.4433339,
                32.2302426
              ],
              [
                50.4463863,
                32.2292166
              ],
              [
                50.4501524,
                32.2272955
              ],
              [
                50.4626941,
                32.2213698
              ],
              [
                50.4674357,
                32.2197452
              ],
              [
                50.4902859,
                32.203053
              ],
              [
                50.5129909,
                32.1847658
              ],
              [
                50.5153513,
                32.1833129
              ],
              [
                50.517491,
                32.1827243
              ],
              [
                50.5205885,
                32.1815736
              ],
              [
                50.5224946,
                32.1823214
              ],
              [
                50.5242319,
                32.1822117
              ],
              [
                50.5268526,
                32.180153
              ],
              [
                50.5423879,
                32.1703453
              ],
              [
                50.5551767,
                32.1591924
              ],
              [
                50.5605411,
                32.1569035
              ],
              [
                50.5656715,
                32.1531974
              ],
              [
                50.5783641,
                32.1396321
              ],
              [
                50.5867945,
                32.127941
              ],
              [
                50.5939514,
                32.1173129
              ],
              [
                50.6055987,
                32.0918028
              ],
              [
                50.6224225,
                32.079798
              ],
              [
                50.634652,
                32.0690541
              ],
              [
                50.6511143,
                32.058426
              ],
              [
                50.6546759,
                32.051553
              ],
              [
                50.6596449,
                32.0488781
              ],
              [
                50.6810882,
                32.0433125
              ],
              [
                50.6836867,
                32.04757
              ],
              [
                50.68506,
                32.0480247
              ],
              [
                50.6864333,
                32.0505891
              ],
              [
                50.6870985,
                32.05399
              ],
              [
                50.6870126,
                32.0613007
              ],
              [
                50.6876342,
                32.079524
              ],
              [
                50.6896372,
                32.0826485
              ],
              [
                50.6911489,
                32.089031
              ],
              [
                50.694166,
                32.0945151
              ],
              [
                50.7132131,
                32.1123419
              ],
              [
                50.7314813,
                32.1327935
              ],
              [
                50.742115,
                32.1420864
              ],
              [
                50.7531698,
                32.1551768
              ],
              [
                50.7600414,
                32.1613567
              ],
              [
                50.7622378,
                32.1633797
              ],
              [
                50.7566398,
                32.1672199
              ],
              [
                50.7500999,
                32.1756684
              ],
              [
                50.7452075,
                32.182318
              ],
              [
                50.7313913,
                32.1927372
              ],
              [
                50.7248412,
                32.1970071
              ],
              [
                50.7195709,
                32.1976668
              ],
              [
                50.713367,
                32.1982114
              ],
              [
                50.7023229,
                32.2032908
              ],
              [
                50.6914089,
                32.2092823
              ],
              [
                50.6854357,
                32.2140225
              ],
              [
                50.6833411,
                32.2150353
              ],
              [
                50.6686681,
                32.2308366
              ],
              [
                50.6606898,
                32.2372039
              ],
              [
                50.6527332,
                32.2436465
              ],
              [
                50.639197,
                32.2547311
              ],
              [
                50.6352138,
                32.2630215
              ],
              [
                50.631523,
                32.2722567
              ],
              [
                50.6232833,
                32.282779
              ],
              [
                50.6201953,
                32.2832567
              ],
              [
                50.6154449,
                32.2847631
              ],
              [
                50.6095525,
                32.2859021
              ],
              [
                50.60788,
                32.285665
              ],
              [
                50.6057862,
                32.2853963
              ],
              [
                50.5960875,
                32.2864097
              ],
              [
                50.5790992,
                32.2932734
              ],
              [
                50.5432346,
                32.3152123
              ],
              [
                50.5119649,
                32.3394161
              ],
              [
                50.5005025,
                32.3481711
              ],
              [
                50.4980135,
                32.3491137
              ],
              [
                50.4889431,
                32.3539374
              ],
              [
                50.4876065,
                32.3546787
              ],
              [
                50.4834652,
                32.3544974
              ],
              [
                50.4707622,
                32.3600621
              ],
              [
                50.4653924,
                32.3641523
              ],
              [
                50.4636903,
                32.3662938
              ],
              [
                50.4467632,
                32.3723135
              ],
              [
                50.4390421,
                32.3777685
              ],
              [
                50.4338061,
                32.3831375
              ],
              [
                50.4241049,
                32.377741
              ],
              [
                50.4109949,
                32.3713485
              ],
              [
                50.3827133,
                32.3560792
              ],
              [
                50.3768649,
                32.3472801
              ],
              [
                50.3622913,
                32.3385621
              ],
              [
                50.3436041,
                32.3263274
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555183,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوهرنگ",
          "name:en": "Kuhrang County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279066",
          "wikipedia": "en:Kuhrang County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.5008323,
                32.7160473
              ],
              [
                49.5008256,
                32.7156708
              ],
              [
                49.5004487,
                32.7147847
              ],
              [
                49.500289,
                32.7138876
              ],
              [
                49.5002391,
                32.7113466
              ],
              [
                49.5002055,
                32.7096321
              ],
              [
                49.5000772,
                32.7030932
              ],
              [
                49.5005647,
                32.7029502
              ],
              [
                49.5019189,
                32.7017893
              ],
              [
                49.5033838,
                32.7005418
              ],
              [
                49.5050086,
                32.6987415
              ],
              [
                49.5067979,
                32.6968462
              ],
              [
                49.5086364,
                32.6948139
              ],
              [
                49.5102616,
                32.6930992
              ],
              [
                49.5124283,
                32.6904213
              ],
              [
                49.5143737,
                32.6875581
              ],
              [
                49.5160483,
                32.6849713
              ],
              [
                49.5166427,
                32.6844458
              ],
              [
                49.5207596,
                32.6808058
              ],
              [
                49.5259551,
                32.676179
              ],
              [
                49.5337981,
                32.6690056
              ],
              [
                49.5370444,
                32.6660918
              ],
              [
                49.5419617,
                32.6611409
              ],
              [
                49.5424463,
                32.6599424
              ],
              [
                49.5437966,
                32.6589659
              ],
              [
                49.5458526,
                32.6576233
              ],
              [
                49.547474,
                32.6562801
              ],
              [
                49.5504495,
                32.6539198
              ],
              [
                49.5522843,
                32.6520649
              ],
              [
                49.5540123,
                32.6502155
              ],
              [
                49.5556298,
                32.6482272
              ],
              [
                49.5570297,
                32.6460538
              ],
              [
                49.5578346,
                32.6450393
              ],
              [
                49.5591317,
                32.6437418
              ],
              [
                49.5600471,
                32.6425392
              ],
              [
                49.5615042,
                32.6411511
              ],
              [
                49.5632821,
                32.638885
              ],
              [
                49.5649528,
                32.63671
              ],
              [
                49.5804386,
                32.6324168
              ],
              [
                49.5850411,
                32.6271839
              ],
              [
                49.5937501,
                32.6180594
              ],
              [
                49.5981825,
                32.6136233
              ],
              [
                49.6044446,
                32.6053229
              ],
              [
                49.6096134,
                32.5985551
              ],
              [
                49.615553,
                32.5897906
              ],
              [
                49.6214599,
                32.5804755
              ],
              [
                49.625492,
                32.573668
              ],
              [
                49.6339988,
                32.5683713
              ],
              [
                49.6429138,
                32.5618039
              ],
              [
                49.6424369,
                32.5590087
              ],
              [
                49.646515,
                32.555253
              ],
              [
                49.6504287,
                32.551633
              ],
              [
                49.6538046,
                32.5483859
              ],
              [
                49.6579895,
                32.5447663
              ],
              [
                49.6613617,
                32.5413318
              ],
              [
                49.6629104,
                32.5392917
              ],
              [
                49.6644555,
                32.5369765
              ],
              [
                49.6659052,
                32.5358621
              ],
              [
                49.6684798,
                32.534047
              ],
              [
                49.6706276,
                32.5326987
              ],
              [
                49.6729394,
                32.5313499
              ],
              [
                49.6746065,
                32.5306007
              ],
              [
                49.6762163,
                32.5296706
              ],
              [
                49.6781998,
                32.5283655
              ],
              [
                49.6799164,
                32.5270193
              ],
              [
                49.6822244,
                32.5254356
              ],
              [
                49.6841545,
                32.5242269
              ],
              [
                49.6864089,
                32.5230147
              ],
              [
                49.6895295,
                32.521798
              ],
              [
                49.691677,
                32.5205372
              ],
              [
                49.6943625,
                32.5190926
              ],
              [
                49.6978455,
                32.5168602
              ],
              [
                49.7018739,
                32.5147595
              ],
              [
                49.7031022,
                32.5137822
              ],
              [
                49.7043381,
                32.5129922
              ],
              [
                49.7055131,
                32.5118339
              ],
              [
                49.7072716,
                32.510066
              ],
              [
                49.7090254,
                32.5080787
              ],
              [
                49.7111625,
                32.5056568
              ],
              [
                49.7152214,
                32.5018039
              ],
              [
                49.7174808,
                32.499608
              ],
              [
                49.7177055,
                32.4994095
              ],
              [
                49.7233847,
                32.4944183
              ],
              [
                49.7273407,
                32.4906428
              ],
              [
                49.7292441,
                32.4886122
              ],
              [
                49.7312048,
                32.486634
              ],
              [
                49.7325097,
                32.4846041
              ],
              [
                49.7360458,
                32.4805941
              ],
              [
                49.7381668,
                32.4785701
              ],
              [
                49.7404517,
                32.476356
              ],
              [
                49.7425242,
                32.4744554
              ],
              [
                49.7462014,
                32.4717702
              ],
              [
                49.749868,
                32.4698087
              ],
              [
                49.7540742,
                32.4673315
              ],
              [
                49.7575284,
                32.4655334
              ],
              [
                49.7616233,
                32.4610782
              ],
              [
                49.7640036,
                32.4577814
              ],
              [
                49.7714177,
                32.4524451
              ],
              [
                49.778963,
                32.4456327
              ],
              [
                49.7857571,
                32.4389686
              ],
              [
                49.7904243,
                32.4342615
              ],
              [
                49.7982388,
                32.4275802
              ],
              [
                49.8010942,
                32.4196634
              ],
              [
                49.8045235,
                32.4100631
              ],
              [
                49.8102129,
                32.3930142
              ],
              [
                49.8167877,
                32.386262
              ],
              [
                49.8289508,
                32.377623
              ],
              [
                49.8530845,
                32.3596866
              ],
              [
                49.8671969,
                32.3496697
              ],
              [
                49.874349,
                32.3450448
              ],
              [
                49.8791293,
                32.3419225
              ],
              [
                49.9051973,
                32.325037
              ],
              [
                49.9115182,
                32.3160824
              ],
              [
                49.9214428,
                32.3037715
              ],
              [
                49.9217128,
                32.2908507
              ],
              [
                49.9221257,
                32.2853031
              ],
              [
                49.9225233,
                32.2791611
              ],
              [
                49.9232014,
                32.2669626
              ],
              [
                49.9195109,
                32.2670891
              ],
              [
                49.922121,
                32.2576828
              ],
              [
                49.9235078,
                32.2528076
              ],
              [
                49.924183,
                32.2453158
              ],
              [
                49.9264878,
                32.2372759
              ],
              [
                49.9276542,
                32.2314887
              ],
              [
                49.9293527,
                32.2261526
              ],
              [
                49.9305791,
                32.2178471
              ],
              [
                49.9313677,
                32.2130224
              ],
              [
                49.9350575,
                32.2060517
              ],
              [
                49.9380597,
                32.1992988
              ],
              [
                49.9422491,
                32.1893702
              ],
              [
                49.947463,
                32.1775298
              ],
              [
                49.9612093,
                32.1633836
              ],
              [
                49.967267,
                32.156911
              ],
              [
                49.9726179,
                32.1512555
              ],
              [
                49.9864806,
                32.1369787
              ],
              [
                49.9961013,
                32.1268392
              ],
              [
                50.0067901,
                32.1159335
              ],
              [
                50.0124581,
                32.1100709
              ],
              [
                50.0159342,
                32.1063199
              ],
              [
                50.0225048,
                32.1009987
              ],
              [
                50.0420244,
                32.0845968
              ],
              [
                50.0569324,
                32.0723358
              ],
              [
                50.0775086,
                32.0559369
              ],
              [
                50.0963785,
                32.0426499
              ],
              [
                50.1098917,
                32.0313638
              ],
              [
                50.1195602,
                32.0228919
              ],
              [
                50.1238784,
                32.0190257
              ],
              [
                50.132555,
                32.0115769
              ],
              [
                50.1436824,
                32.0019204
              ],
              [
                50.1561069,
                31.9944648
              ],
              [
                50.1694679,
                31.988155
              ],
              [
                50.1734446,
                31.9989051
              ],
              [
                50.1690672,
                32.0086584
              ],
              [
                50.1738737,
                32.0185561
              ],
              [
                50.1877783,
                32.0366023
              ],
              [
                50.2059744,
                32.0533354
              ],
              [
                50.2189948,
                32.0604484
              ],
              [
                50.24483,
                32.0742495
              ],
              [
                50.2729827,
                32.0919569
              ],
              [
                50.2764677,
                32.0943063
              ],
              [
                50.2854643,
                32.0980169
              ],
              [
                50.302262,
                32.1007181
              ],
              [
                50.3213776,
                32.0998456
              ],
              [
                50.3281141,
                32.1016015
              ],
              [
                50.3330421,
                32.1016017
              ],
              [
                50.3446709,
                32.1035757
              ],
              [
                50.3731777,
                32.1040846
              ],
              [
                50.3904236,
                32.108176
              ],
              [
                50.3962651,
                32.1083966
              ],
              [
                50.4087066,
                32.1084603
              ],
              [
                50.4146119,
                32.1090746
              ],
              [
                50.4348227,
                32.1082458
              ],
              [
                50.4329589,
                32.1123007
              ],
              [
                50.4320092,
                32.1185728
              ],
              [
                50.4340548,
                32.1292063
              ],
              [
                50.4339302,
                32.1417667
              ],
              [
                50.4311168,
                32.1461874
              ],
              [
                50.4293695,
                32.1546128
              ],
              [
                50.4262188,
                32.1603955
              ],
              [
                50.4253973,
                32.1614117
              ],
              [
                50.4204278,
                32.1739107
              ],
              [
                50.4186551,
                32.1869541
              ],
              [
                50.417397,
                32.1885067
              ],
              [
                50.4164223,
                32.1911564
              ],
              [
                50.4164652,
                32.1929618
              ],
              [
                50.4260943,
                32.2100501
              ],
              [
                50.4334281,
                32.2203514
              ],
              [
                50.4344377,
                32.2229716
              ],
              [
                50.4353141,
                32.2245646
              ],
              [
                50.4401636,
                32.228667
              ],
              [
                50.4433339,
                32.2302426
              ],
              [
                50.433062,
                32.2370541
              ],
              [
                50.4302975,
                32.2389676
              ],
              [
                50.4243894,
                32.2431439
              ],
              [
                50.4211521,
                32.2452561
              ],
              [
                50.414351,
                32.2514498
              ],
              [
                50.3974434,
                32.2670672
              ],
              [
                50.390682,
                32.2732002
              ],
              [
                50.3794454,
                32.2859605
              ],
              [
                50.3523384,
                32.316565
              ],
              [
                50.3436041,
                32.3263274
              ],
              [
                50.3622913,
                32.3385621
              ],
              [
                50.3768649,
                32.3472801
              ],
              [
                50.3827133,
                32.3560792
              ],
              [
                50.4109949,
                32.3713485
              ],
              [
                50.4241049,
                32.377741
              ],
              [
                50.4338061,
                32.3831375
              ],
              [
                50.4315215,
                32.3874633
              ],
              [
                50.4279451,
                32.3887441
              ],
              [
                50.4215458,
                32.3940311
              ],
              [
                50.3901118,
                32.4179564
              ],
              [
                50.3761102,
                32.4322065
              ],
              [
                50.3715279,
                32.4347834
              ],
              [
                50.3677657,
                32.4382557
              ],
              [
                50.3632575,
                32.4486188
              ],
              [
                50.3643915,
                32.458207
              ],
              [
                50.3647053,
                32.4632394
              ],
              [
                50.3662847,
                32.4677648
              ],
              [
                50.3685748,
                32.4754733
              ],
              [
                50.370559,
                32.4801243
              ],
              [
                50.3742766,
                32.4858058
              ],
              [
                50.3781778,
                32.4904831
              ],
              [
                50.3808937,
                32.4988245
              ],
              [
                50.3778666,
                32.5080158
              ],
              [
                50.372893,
                32.516103
              ],
              [
                50.3675339,
                32.5223581
              ],
              [
                50.3624671,
                32.5264239
              ],
              [
                50.3507152,
                32.5358774
              ],
              [
                50.3453697,
                32.5396833
              ],
              [
                50.3349928,
                32.5344126
              ],
              [
                50.3314292,
                32.5342874
              ],
              [
                50.3264907,
                32.5277062
              ],
              [
                50.3249725,
                32.5312445
              ],
              [
                50.3218149,
                32.533818
              ],
              [
                50.3153859,
                32.5371178
              ],
              [
                50.313585,
                32.5379933
              ],
              [
                50.3040388,
                32.5407153
              ],
              [
                50.2895633,
                32.5486018
              ],
              [
                50.2870232,
                32.5501633
              ],
              [
                50.2698578,
                32.5623535
              ],
              [
                50.2641548,
                32.562877
              ],
              [
                50.2585887,
                32.5641035
              ],
              [
                50.2546094,
                32.5642059
              ],
              [
                50.2497005,
                32.5739057
              ],
              [
                50.241432,
                32.5837648
              ],
              [
                50.2410617,
                32.5874328
              ],
              [
                50.2351236,
                32.5960466
              ],
              [
                50.2260489,
                32.6057079
              ],
              [
                50.2170825,
                32.6148066
              ],
              [
                50.2093361,
                32.6209472
              ],
              [
                50.1951801,
                32.6332621
              ],
              [
                50.1859421,
                32.6424801
              ],
              [
                50.1659343,
                32.6579585
              ],
              [
                50.1537111,
                32.6637915
              ],
              [
                50.1523243,
                32.6640623
              ],
              [
                50.151491,
                32.6643422
              ],
              [
                50.1506579,
                32.6643422
              ],
              [
                50.1501012,
                32.6646221
              ],
              [
                50.148991,
                32.6646222
              ],
              [
                50.1484344,
                32.664902
              ],
              [
                50.1464914,
                32.664902
              ],
              [
                50.1456578,
                32.6651729
              ],
              [
                50.1420444,
                32.664902
              ],
              [
                50.1339881,
                32.6637914
              ],
              [
                50.1326013,
                32.6632316
              ],
              [
                50.131768,
                32.6632316
              ],
              [
                50.1253781,
                32.6604505
              ],
              [
                50.1153782,
                32.6529561
              ],
              [
                50.1034316,
                32.6462924
              ],
              [
                50.0992651,
                32.6449019
              ],
              [
                50.096765,
                32.644351
              ],
              [
                50.0948221,
                32.6435113
              ],
              [
                50.0939885,
                32.6435113
              ],
              [
                50.0928752,
                32.6429605
              ],
              [
                50.092322,
                32.6429605
              ],
              [
                50.0909322,
                32.6424007
              ],
              [
                50.0895419,
                32.6424007
              ],
              [
                50.0892654,
                32.6421207
              ],
              [
                50.0870418,
                32.6421207
              ],
              [
                50.0848187,
                32.64157
              ],
              [
                50.0837085,
                32.6415699
              ],
              [
                50.0745424,
                32.6390688
              ],
              [
                50.0744293,
                32.6390062
              ],
              [
                50.0589858,
                32.6304547
              ],
              [
                50.0448191,
                32.6276826
              ],
              [
                50.0445391,
                32.6274027
              ],
              [
                50.0420394,
                32.6274028
              ],
              [
                50.0392628,
                32.6279536
              ],
              [
                50.0370394,
                32.6285133
              ],
              [
                50.0353728,
                32.6285133
              ],
              [
                50.0348194,
                32.6287932
              ],
              [
                50.0289829,
                32.6290642
              ],
              [
                50.024816,
                32.6287933
              ],
              [
                50.0242628,
                32.6287933
              ],
              [
                50.0212062,
                32.6282334
              ],
              [
                50.0200964,
                32.6282334
              ],
              [
                50.0198163,
                32.6279535
              ],
              [
                50.0181495,
                32.6279535
              ],
              [
                50.0175964,
                32.6276826
              ],
              [
                50.0034265,
                32.6279535
              ],
              [
                50.00315,
                32.6282334
              ],
              [
                50.0023164,
                32.6282334
              ],
              [
                50.0017597,
                32.6285133
              ],
              [
                50.00065,
                32.6285134
              ],
              [
                49.9864833,
                32.6332357
              ],
              [
                49.9859266,
                32.6332357
              ],
              [
                49.9853699,
                32.6337864
              ],
              [
                49.9823168,
                32.6346172
              ],
              [
                49.9800229,
                32.6359868
              ],
              [
                49.96648,
                32.6440709
              ],
              [
                49.9662036,
                32.6443508
              ],
              [
                49.9503704,
                32.6579581
              ],
              [
                49.9350907,
                32.6676738
              ],
              [
                49.9120345,
                32.6765677
              ],
              [
                49.9039777,
                32.6821207
              ],
              [
                49.9037011,
                32.6829605
              ],
              [
                49.9028678,
                32.6837912
              ],
              [
                49.9009244,
                32.687403
              ],
              [
                49.9009244,
                32.6879628
              ],
              [
                49.9006444,
                32.6885136
              ],
              [
                49.8995346,
                32.6910147
              ],
              [
                49.8995345,
                32.6918454
              ],
              [
                49.8962012,
                32.6979583
              ],
              [
                49.8875878,
                32.7021208
              ],
              [
                49.8556414,
                32.7179583
              ],
              [
                49.8553648,
                32.7182382
              ],
              [
                49.853975,
                32.7187889
              ],
              [
                49.8267517,
                32.7396287
              ],
              [
                49.8125855,
                32.7446219
              ],
              [
                49.8011954,
                32.7557371
              ],
              [
                49.7953624,
                32.7593488
              ],
              [
                49.7950854,
                32.7596286
              ],
              [
                49.7945289,
                32.7596287
              ],
              [
                49.7942522,
                32.7599086
              ],
              [
                49.7911956,
                32.7601794
              ],
              [
                49.7906389,
                32.7604594
              ],
              [
                49.7856392,
                32.7599086
              ],
              [
                49.7850826,
                32.7596287
              ],
              [
                49.7834157,
                32.7596287
              ],
              [
                49.7831391,
                32.7593487
              ],
              [
                49.7775824,
                32.7593487
              ],
              [
                49.7773058,
                32.7596287
              ],
              [
                49.7764726,
                32.7596287
              ],
              [
                49.767306,
                32.7640711
              ],
              [
                49.7531397,
                32.775737
              ],
              [
                49.7528596,
                32.7760168
              ],
              [
                49.7528597,
                32.7762968
              ],
              [
                49.7323028,
                32.8057323
              ],
              [
                49.7317498,
                32.806572
              ],
              [
                49.7317497,
                32.8068519
              ],
              [
                49.7317497,
                32.8071318
              ],
              [
                49.7314696,
                32.8076826
              ],
              [
                49.7317497,
                32.8079626
              ],
              [
                49.7317497,
                32.8082425
              ],
              [
                49.7311931,
                32.8085133
              ],
              [
                49.7298032,
                32.8090731
              ],
              [
                49.7281364,
                32.8090731
              ],
              [
                49.7273032,
                32.8087932
              ],
              [
                49.7256364,
                32.8087933
              ],
              [
                49.7256363,
                32.8085133
              ],
              [
                49.7248032,
                32.8085133
              ],
              [
                49.7192463,
                32.8057323
              ],
              [
                49.6959135,
                32.7910145
              ],
              [
                49.69369,
                32.7901838
              ],
              [
                49.6925803,
                32.789624
              ],
              [
                49.6600773,
                32.7793485
              ],
              [
                49.6556343,
                32.7793485
              ],
              [
                49.6550777,
                32.7790687
              ],
              [
                49.6442442,
                32.7790686
              ],
              [
                49.6439676,
                32.7793485
              ],
              [
                49.6411875,
                32.7793485
              ],
              [
                49.6406344,
                32.7796285
              ],
              [
                49.6386878,
                32.7798993
              ],
              [
                49.6364679,
                32.7798993
              ],
              [
                49.6356311,
                32.7801792
              ],
              [
                49.6345209,
                32.7801792
              ],
              [
                49.6336877,
                32.7804591
              ],
              [
                49.6331311,
                32.7804591
              ],
              [
                49.6325779,
                32.780739
              ],
              [
                49.6314643,
                32.780739
              ],
              [
                49.6286876,
                32.7815697
              ],
              [
                49.6275779,
                32.7815697
              ],
              [
                49.6272977,
                32.7818496
              ],
              [
                49.6189644,
                32.7846216
              ],
              [
                49.6184675,
                32.7847885
              ],
              [
                49.6181311,
                32.7849015
              ],
              [
                49.6042415,
                32.7896238
              ],
              [
                49.6025746,
                32.7896238
              ],
              [
                49.602298,
                32.7899037
              ],
              [
                49.600355,
                32.7899037
              ],
              [
                49.6004846,
                32.7860347
              ],
              [
                49.5999494,
                32.7853852
              ],
              [
                49.5994357,
                32.7824354
              ],
              [
                49.5975292,
                32.7792963
              ],
              [
                49.5953096,
                32.7768058
              ],
              [
                49.5946893,
                32.7756977
              ],
              [
                49.5943946,
                32.7740623
              ],
              [
                49.5945307,
                32.7716487
              ],
              [
                49.5951327,
                32.7685225
              ],
              [
                49.5956929,
                32.7665284
              ],
              [
                49.5958249,
                32.7633387
              ],
              [
                49.595527,
                32.7610452
              ],
              [
                49.5948923,
                32.7602297
              ],
              [
                49.5944357,
                32.7592446
              ],
              [
                49.5943689,
                32.7585182
              ],
              [
                49.5948703,
                32.7571073
              ],
              [
                49.5946472,
                32.7557072
              ],
              [
                49.5926978,
                32.754444
              ],
              [
                49.5916118,
                32.7533789
              ],
              [
                49.5912517,
                32.7520796
              ],
              [
                49.591018,
                32.7499952
              ],
              [
                49.5775021,
                32.7499591
              ],
              [
                49.5772268,
                32.7441927
              ],
              [
                49.578136,
                32.7386062
              ],
              [
                49.5775028,
                32.7369457
              ],
              [
                49.5770546,
                32.7318828
              ],
              [
                49.5767125,
                32.7306281
              ],
              [
                49.5777898,
                32.7300056
              ],
              [
                49.5775574,
                32.7254294
              ],
              [
                49.5767623,
                32.7197521
              ],
              [
                49.5745853,
                32.7166108
              ],
              [
                49.5701837,
                32.7153413
              ],
              [
                49.563686,
                32.7140384
              ],
              [
                49.5621585,
                32.713211
              ],
              [
                49.5566968,
                32.7127023
              ],
              [
                49.5476429,
                32.7129462
              ],
              [
                49.5448794,
                32.7139754
              ],
              [
                49.5430611,
                32.7148688
              ],
              [
                49.5411515,
                32.7143664
              ],
              [
                49.5382877,
                32.7128012
              ],
              [
                49.5325127,
                32.7101449
              ],
              [
                49.5295337,
                32.7093867
              ],
              [
                49.5262813,
                32.7092751
              ],
              [
                49.5226861,
                32.7086458
              ],
              [
                49.5174089,
                32.7059375
              ],
              [
                49.5151662,
                32.7044723
              ],
              [
                49.5122602,
                32.7033102
              ],
              [
                49.5104825,
                32.7024073
              ],
              [
                49.510678,
                32.7044025
              ],
              [
                49.5117177,
                32.7062982
              ],
              [
                49.5157088,
                32.7109292
              ],
              [
                49.5194671,
                32.7137457
              ],
              [
                49.520093,
                32.7156323
              ],
              [
                49.512915,
                32.7204423
              ],
              [
                49.5124159,
                32.7199787
              ],
              [
                49.5037787,
                32.7161871
              ],
              [
                49.5008323,
                32.7160473
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555184,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کیار",
          "name:en": "Kiar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610763",
          "wikipedia": "en:Kiar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.4588712,
                31.8854548
              ],
              [
                50.4667286,
                31.8838405
              ],
              [
                50.4756432,
                31.8821208
              ],
              [
                50.485125,
                31.8777412
              ],
              [
                50.4913537,
                31.8702605
              ],
              [
                50.5040672,
                31.8613178
              ],
              [
                50.525774,
                31.8464389
              ],
              [
                50.5340069,
                31.8407518
              ],
              [
                50.5518328,
                31.8281079
              ],
              [
                50.6105362,
                31.7871252
              ],
              [
                50.6253622,
                31.7791616
              ],
              [
                50.642181,
                31.7704007
              ],
              [
                50.6510724,
                31.7655
              ],
              [
                50.6638581,
                31.7597189
              ],
              [
                50.6798281,
                31.7529422
              ],
              [
                50.6876999,
                31.7492195
              ],
              [
                50.7134287,
                31.7373262
              ],
              [
                50.7172782,
                31.739588
              ],
              [
                50.7394774,
                31.740391
              ],
              [
                50.7683965,
                31.7413106
              ],
              [
                50.7848529,
                31.7391865
              ],
              [
                50.799837,
                31.7374382
              ],
              [
                50.8129609,
                31.7335054
              ],
              [
                50.8284237,
                31.727424
              ],
              [
                50.8384744,
                31.7217111
              ],
              [
                50.8442115,
                31.7172891
              ],
              [
                50.8538741,
                31.7054003
              ],
              [
                50.8615568,
                31.6962903
              ],
              [
                50.8701595,
                31.6921132
              ],
              [
                50.8781206,
                31.6885728
              ],
              [
                50.9055218,
                31.6796275
              ],
              [
                50.9296138,
                31.6737517
              ],
              [
                50.9416293,
                31.6726679
              ],
              [
                50.9532774,
                31.6700183
              ],
              [
                50.9617279,
                31.6684626
              ],
              [
                50.9697415,
                31.6663725
              ],
              [
                50.979694,
                31.6641723
              ],
              [
                50.9858982,
                31.661972
              ],
              [
                50.9962384,
                31.6580114
              ],
              [
                51.0025718,
                31.6553709
              ],
              [
                51.0097743,
                31.6530532
              ],
              [
                51.0137984,
                31.6563664
              ],
              [
                51.0290286,
                31.6799981
              ],
              [
                51.0305864,
                31.6875313
              ],
              [
                51.0367447,
                31.7046131
              ],
              [
                51.0352218,
                31.7357506
              ],
              [
                51.0262963,
                31.7548252
              ],
              [
                51.0091427,
                31.7757368
              ],
              [
                51.005314,
                31.7804852
              ],
              [
                51.0009728,
                31.7846147
              ],
              [
                50.9868589,
                31.7938738
              ],
              [
                50.9747035,
                31.802079
              ],
              [
                50.9632458,
                31.8102666
              ],
              [
                50.9546018,
                31.8152627
              ],
              [
                50.9469147,
                31.8201915
              ],
              [
                50.9231427,
                31.8306373
              ],
              [
                50.8873086,
                31.8422397
              ],
              [
                50.8638018,
                31.85191
              ],
              [
                50.8645256,
                31.8508793
              ],
              [
                50.8517534,
                31.8556857
              ],
              [
                50.8417834,
                31.859392
              ],
              [
                50.8317824,
                31.8640116
              ],
              [
                50.8105415,
                31.8746164
              ],
              [
                50.7976216,
                31.883605
              ],
              [
                50.7925998,
                31.8875384
              ],
              [
                50.788378,
                31.8907124
              ],
              [
                50.7846291,
                31.8924365
              ],
              [
                50.7793734,
                31.8975952
              ],
              [
                50.780856,
                31.9047111
              ],
              [
                50.7859125,
                31.9262862
              ],
              [
                50.785849,
                31.9328936
              ],
              [
                50.7852416,
                31.9350887
              ],
              [
                50.7871137,
                31.9474075
              ],
              [
                50.788354,
                31.9516507
              ],
              [
                50.7972425,
                31.9728016
              ],
              [
                50.8004514,
                31.9795914
              ],
              [
                50.8033353,
                31.9832479
              ],
              [
                50.8047216,
                31.9842938
              ],
              [
                50.8084088,
                31.9831064
              ],
              [
                50.8194183,
                31.9751637
              ],
              [
                50.8263983,
                31.9716011
              ],
              [
                50.8307464,
                31.9642891
              ],
              [
                50.8337686,
                31.9621071
              ],
              [
                50.8358251,
                31.9592992
              ],
              [
                50.8363936,
                31.9564412
              ],
              [
                50.8416715,
                31.9496817
              ],
              [
                50.8469957,
                31.9453994
              ],
              [
                50.8511664,
                31.9438063
              ],
              [
                50.8574336,
                31.9413966
              ],
              [
                50.8655163,
                31.9403685
              ],
              [
                50.8786749,
                31.940401
              ],
              [
                50.885263,
                31.9424183
              ],
              [
                50.8908728,
                31.9432761
              ],
              [
                50.8979593,
                31.9435831
              ],
              [
                50.9017169,
                31.9449594
              ],
              [
                50.9043067,
                31.9460908
              ],
              [
                50.9156134,
                31.9505303
              ],
              [
                50.9313904,
                31.9585755
              ],
              [
                50.9358414,
                31.9597155
              ],
              [
                50.9561911,
                31.9672442
              ],
              [
                50.9605151,
                31.9679871
              ],
              [
                50.9642426,
                31.9713192
              ],
              [
                50.9691456,
                31.9739955
              ],
              [
                50.9779956,
                31.9802546
              ],
              [
                50.9864106,
                31.9880111
              ],
              [
                50.9914384,
                31.9939075
              ],
              [
                50.9988407,
                31.999343
              ],
              [
                51.0079174,
                32.010166
              ],
              [
                51.0095841,
                32.0118364
              ],
              [
                51.0220872,
                32.0204412
              ],
              [
                51.0220873,
                32.0207211
              ],
              [
                51.0219472,
                32.0233621
              ],
              [
                51.0092449,
                32.0491958
              ],
              [
                51.0033366,
                32.0593372
              ],
              [
                50.9948566,
                32.0630867
              ],
              [
                50.9842278,
                32.0754857
              ],
              [
                50.9736496,
                32.0863028
              ],
              [
                50.963149,
                32.0947475
              ],
              [
                50.9599896,
                32.1057458
              ],
              [
                50.9513417,
                32.1142353
              ],
              [
                50.9381343,
                32.123594
              ],
              [
                50.9351589,
                32.125702
              ],
              [
                50.9247861,
                32.1301911
              ],
              [
                50.9235317,
                32.1396538
              ],
              [
                50.9251437,
                32.1468143
              ],
              [
                50.9310184,
                32.1651569
              ],
              [
                50.9370039,
                32.1803373
              ],
              [
                50.9451469,
                32.1929447
              ],
              [
                50.9443046,
                32.1929447
              ],
              [
                50.9418048,
                32.1929447
              ],
              [
                50.941528,
                32.1932246
              ],
              [
                50.9309715,
                32.1932245
              ],
              [
                50.9301381,
                32.1929447
              ],
              [
                50.9279148,
                32.1929447
              ],
              [
                50.9270816,
                32.1926648
              ],
              [
                50.925415,
                32.1923939
              ],
              [
                50.9231915,
                32.1923938
              ],
              [
                50.9226384,
                32.192114
              ],
              [
                50.921805,
                32.192114
              ],
              [
                50.9168017,
                32.1904436
              ],
              [
                50.9156917,
                32.1904435
              ],
              [
                50.9148584,
                32.1901636
              ],
              [
                50.9129151,
                32.1896129
              ],
              [
                50.8965254,
                32.1701727
              ],
              [
                50.8962453,
                32.1690621
              ],
              [
                50.8806888,
                32.1429494
              ],
              [
                50.8804122,
                32.1415589
              ],
              [
                50.8801356,
                32.140999
              ],
              [
                50.877079,
                32.1315544
              ],
              [
                50.8765223,
                32.1285026
              ],
              [
                50.870689,
                32.1173875
              ],
              [
                50.8701357,
                32.1171076
              ],
              [
                50.8662458,
                32.1171076
              ],
              [
                50.8662458,
                32.1173876
              ],
              [
                50.8656892,
                32.1173875
              ],
              [
                50.8517577,
                32.1249848
              ],
              [
                50.8455176,
                32.127163
              ],
              [
                50.8209964,
                32.1352898
              ],
              [
                50.7867609,
                32.1498457
              ],
              [
                50.7838475,
                32.1506219
              ],
              [
                50.7788948,
                32.1518852
              ],
              [
                50.773176,
                32.1534617
              ],
              [
                50.7701504,
                32.1542141
              ],
              [
                50.7659472,
                32.1571462
              ],
              [
                50.7600414,
                32.1613567
              ],
              [
                50.7531698,
                32.1551768
              ],
              [
                50.742115,
                32.1420864
              ],
              [
                50.7314813,
                32.1327935
              ],
              [
                50.7132131,
                32.1123419
              ],
              [
                50.694166,
                32.0945151
              ],
              [
                50.6911489,
                32.089031
              ],
              [
                50.6896372,
                32.0826485
              ],
              [
                50.6876342,
                32.079524
              ],
              [
                50.6870126,
                32.0613007
              ],
              [
                50.6870985,
                32.05399
              ],
              [
                50.6864333,
                32.0505891
              ],
              [
                50.68506,
                32.0480247
              ],
              [
                50.6836867,
                32.04757
              ],
              [
                50.6810882,
                32.0433125
              ],
              [
                50.6830356,
                32.0401397
              ],
              [
                50.6910685,
                32.0292034
              ],
              [
                50.6973086,
                32.0234938
              ],
              [
                50.7042155,
                32.0186405
              ],
              [
                50.7066313,
                32.0153547
              ],
              [
                50.7117748,
                32.0099319
              ],
              [
                50.7211559,
                31.9985734
              ],
              [
                50.719583,
                31.9915738
              ],
              [
                50.7013114,
                31.9891282
              ],
              [
                50.6960155,
                31.9862262
              ],
              [
                50.6917648,
                31.9841848
              ],
              [
                50.689765,
                31.9830911
              ],
              [
                50.6877315,
                31.9821852
              ],
              [
                50.6862387,
                31.9812725
              ],
              [
                50.6811084,
                31.9776553
              ],
              [
                50.6744274,
                31.972534
              ],
              [
                50.6517285,
                31.9554309
              ],
              [
                50.6461204,
                31.9516175
              ],
              [
                50.6410819,
                31.9523192
              ],
              [
                50.629479,
                31.9485383
              ],
              [
                50.6245542,
                31.9505284
              ],
              [
                50.6226743,
                31.9500628
              ],
              [
                50.6149612,
                31.9480534
              ],
              [
                50.6058475,
                31.9459431
              ],
              [
                50.6037279,
                31.9435028
              ],
              [
                50.6033925,
                31.9430965
              ],
              [
                50.5886572,
                31.9417665
              ],
              [
                50.5812758,
                31.9395301
              ],
              [
                50.5741365,
                31.9373965
              ],
              [
                50.5557553,
                31.9261946
              ],
              [
                50.541337,
                31.9242119
              ],
              [
                50.5326425,
                31.9266681
              ],
              [
                50.5231233,
                31.9271662
              ],
              [
                50.5146194,
                31.9246005
              ],
              [
                50.5011807,
                31.9205521
              ],
              [
                50.4943227,
                31.9150395
              ],
              [
                50.4839786,
                31.9066308
              ],
              [
                50.4638336,
                31.886883
              ],
              [
                50.4588712,
                31.8854548
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555189,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لردگان",
          "name:en": "Lordegan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279074",
          "wikipedia": "en:Lordegan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.3189523,
                31.4572918
              ],
              [
                50.3262017,
                31.4507304
              ],
              [
                50.3322286,
                31.4455016
              ],
              [
                50.3424963,
                31.4344152
              ],
              [
                50.3529031,
                31.4296486
              ],
              [
                50.3637067,
                31.4248693
              ],
              [
                50.3748315,
                31.4219734
              ],
              [
                50.3841116,
                31.4194267
              ],
              [
                50.4014976,
                31.4195344
              ],
              [
                50.4094106,
                31.4197303
              ],
              [
                50.4146058,
                31.4197359
              ],
              [
                50.4191291,
                31.423027
              ],
              [
                50.4199624,
                31.4281257
              ],
              [
                50.4196494,
                31.4322
              ],
              [
                50.421767,
                31.4352611
              ],
              [
                50.4296708,
                31.4356921
              ],
              [
                50.4410377,
                31.4334915
              ],
              [
                50.4499874,
                31.4313345
              ],
              [
                50.4601692,
                31.4289306
              ],
              [
                50.476229,
                31.4276498
              ],
              [
                50.4773392,
                31.4282096
              ],
              [
                50.4781513,
                31.4289187
              ],
              [
                50.4795622,
                31.4301506
              ],
              [
                50.4803955,
                31.431261
              ],
              [
                50.492062,
                31.4498766
              ],
              [
                50.4956754,
                31.4518177
              ],
              [
                50.4965086,
                31.4518176
              ],
              [
                50.4976188,
                31.4523773
              ],
              [
                50.5003954,
                31.4526482
              ],
              [
                50.5081752,
                31.4518177
              ],
              [
                50.509285,
                31.4512579
              ],
              [
                50.5123417,
                31.4504274
              ],
              [
                50.5226184,
                31.4448752
              ],
              [
                50.5295651,
                31.4401535
              ],
              [
                50.5303983,
                31.4401535
              ],
              [
                50.530955,
                31.4398737
              ],
              [
                50.5315082,
                31.4398737
              ],
              [
                50.5342882,
                31.4398737
              ],
              [
                50.537898,
                31.441264
              ],
              [
                50.5390083,
                31.4412641
              ],
              [
                50.5423447,
                31.4401536
              ],
              [
                50.5426212,
                31.4395938
              ],
              [
                50.5437314,
                31.4384834
              ],
              [
                50.5440115,
                31.4368223
              ],
              [
                50.5442881,
                31.4365424
              ],
              [
                50.5440115,
                31.4351521
              ],
              [
                50.5442881,
                31.4337618
              ],
              [
                50.5445646,
                31.4329312
              ],
              [
                50.5448447,
                31.4326514
              ],
              [
                50.5470646,
                31.4304306
              ],
              [
                50.5476214,
                31.4304305
              ],
              [
                50.5606778,
                31.4234881
              ],
              [
                50.5681776,
                31.4134852
              ],
              [
                50.5681776,
                31.4132054
              ],
              [
                50.5687342,
                31.4123748
              ],
              [
                50.5737344,
                31.4090435
              ],
              [
                50.5767875,
                31.4087636
              ],
              [
                50.5804009,
                31.410154
              ],
              [
                50.5951242,
                31.4195972
              ],
              [
                50.5967906,
                31.4195971
              ],
              [
                50.5981774,
                31.4201478
              ],
              [
                50.6045673,
                31.4201479
              ],
              [
                50.6048474,
                31.4204277
              ],
              [
                50.6054005,
                31.4204277
              ],
              [
                50.6059572,
                31.4207075
              ],
              [
                50.6062338,
                31.4207075
              ],
              [
                50.6070671,
                31.4204278
              ],
              [
                50.6084573,
                31.4204277
              ],
              [
                50.609014,
                31.4201478
              ],
              [
                50.611514,
                31.4195972
              ],
              [
                50.6129004,
                31.4195971
              ],
              [
                50.6131804,
                31.4193172
              ],
              [
                50.6181805,
                31.4193173
              ],
              [
                50.6187371,
                31.4190374
              ],
              [
                50.619847,
                31.4190375
              ],
              [
                50.6204036,
                31.4187576
              ],
              [
                50.6217904,
                31.4184868
              ],
              [
                50.6301237,
                31.4187577
              ],
              [
                50.6301238,
                31.4187577
              ],
              [
                50.6301238,
                31.4187579
              ],
              [
                50.6301237,
                31.4190374
              ],
              [
                50.6301238,
                31.4190375
              ],
              [
                50.6315136,
                31.419877
              ],
              [
                50.6315137,
                31.4198771
              ],
              [
                50.6379034,
                31.4273792
              ],
              [
                50.6395699,
                31.42765
              ],
              [
                50.6412367,
                31.4268195
              ],
              [
                50.6417934,
                31.4259889
              ],
              [
                50.6473467,
                31.4182069
              ],
              [
                50.6490131,
                31.4173673
              ],
              [
                50.6515132,
                31.4170965
              ],
              [
                50.6520698,
                31.4173673
              ],
              [
                50.6545698,
                31.4170965
              ],
              [
                50.6545698,
                31.4170964
              ],
              [
                50.6545698,
                31.4170956
              ],
              [
                50.6545699,
                31.4168167
              ],
              [
                50.6545699,
                31.4168166
              ],
              [
                50.6556797,
                31.4168166
              ],
              [
                50.6559597,
                31.4165368
              ],
              [
                50.6601266,
                31.4154263
              ],
              [
                50.6617931,
                31.4154264
              ],
              [
                50.6623499,
                31.4151466
              ],
              [
                50.6690162,
                31.4129256
              ],
              [
                50.6709597,
                31.4126548
              ],
              [
                50.6740164,
                31.4126548
              ],
              [
                50.6742929,
                31.4123749
              ],
              [
                50.6751261,
                31.4123749
              ],
              [
                50.6756829,
                31.4120952
              ],
              [
                50.679016,
                31.4107048
              ],
              [
                50.6822057,
                31.402467
              ],
              [
                50.6992962,
                31.3940394
              ],
              [
                50.7009626,
                31.3909881
              ],
              [
                50.7165191,
                31.3845965
              ],
              [
                50.7176291,
                31.3840366
              ],
              [
                50.7198524,
                31.3832062
              ],
              [
                50.7242957,
                31.3793152
              ],
              [
                50.7245793,
                31.3784822
              ],
              [
                50.7240191,
                31.3709825
              ],
              [
                50.7245722,
                31.370152
              ],
              [
                50.749852,
                31.3487564
              ],
              [
                50.7506864,
                31.3473736
              ],
              [
                50.7554087,
                31.3407038
              ],
              [
                50.7787455,
                31.3223659
              ],
              [
                50.7892982,
                31.3143162
              ],
              [
                50.7901314,
                31.3143161
              ],
              [
                50.7906944,
                31.3140365
              ],
              [
                50.7915276,
                31.3140364
              ],
              [
                50.7917982,
                31.3137564
              ],
              [
                50.7962447,
                31.312926
              ],
              [
                50.7987446,
                31.3120954
              ],
              [
                50.8006942,
                31.311256
              ],
              [
                50.8062507,
                31.3082047
              ],
              [
                50.8079112,
                31.3082045
              ],
              [
                50.8079113,
                31.3082047
              ],
              [
                50.8081879,
                31.3084844
              ],
              [
                50.8140211,
                31.3095948
              ],
              [
                50.8140263,
                31.3095948
              ],
              [
                50.8140264,
                31.3095948
              ],
              [
                50.8140495,
                31.3095948
              ],
              [
                50.8168013,
                31.3095948
              ],
              [
                50.8170778,
                31.3093149
              ],
              [
                50.8179172,
                31.309315
              ],
              [
                50.8204172,
                31.3079248
              ],
              [
                50.8265304,
                31.3009827
              ],
              [
                50.8304108,
                31.3009825
              ],
              [
                50.8312442,
                31.3007027
              ],
              [
                50.8359676,
                31.3004319
              ],
              [
                50.8362442,
                31.300143
              ],
              [
                50.8376343,
                31.2995923
              ],
              [
                50.8393049,
                31.2990402
              ],
              [
                50.8431909,
                31.2976514
              ],
              [
                50.8437441,
                31.2970917
              ],
              [
                50.8556906,
                31.2907093
              ],
              [
                50.8568068,
                31.2907094
              ],
              [
                50.8570867,
                31.2904206
              ],
              [
                50.8598571,
                31.2904204
              ],
              [
                50.86014,
                31.2907095
              ],
              [
                50.8637472,
                31.2926502
              ],
              [
                50.8718037,
                31.2995923
              ],
              [
                50.8781903,
                31.3034832
              ],
              [
                50.8801431,
                31.3045937
              ],
              [
                50.8890326,
                31.3082046
              ],
              [
                50.889033,
                31.3082047
              ],
              [
                50.8906938,
                31.3082047
              ],
              [
                50.890694,
                31.3082047
              ],
              [
                50.8912529,
                31.3084847
              ],
              [
                50.8923632,
                31.3087547
              ],
              [
                50.8923633,
                31.3087547
              ],
              [
                50.8923662,
                31.3087554
              ],
              [
                50.9118091,
                31.3051445
              ],
              [
                50.9198925,
                31.3009305
              ],
              [
                50.9245891,
                31.2984821
              ],
              [
                50.9254225,
                31.2976517
              ],
              [
                50.9273657,
                31.2965323
              ],
              [
                50.9370889,
                31.2865388
              ],
              [
                50.9390357,
                31.2843181
              ],
              [
                50.959592,
                31.2629232
              ],
              [
                50.9604254,
                31.2626523
              ],
              [
                50.963202,
                31.2604226
              ],
              [
                50.9613761,
                31.2398818
              ],
              [
                50.9694423,
                31.2265568
              ],
              [
                50.9791626,
                31.2195027
              ],
              [
                50.9791627,
                31.2195027
              ],
              [
                50.998246,
                31.2056484
              ],
              [
                51.0195945,
                31.1901454
              ],
              [
                51.0204234,
                31.189033
              ],
              [
                51.0206999,
                31.1887622
              ],
              [
                51.0309765,
                31.1818113
              ],
              [
                51.0406997,
                31.1787511
              ],
              [
                51.0457019,
                31.1787534
              ],
              [
                51.0459828,
                31.1790405
              ],
              [
                51.0459843,
                31.1790421
              ],
              [
                51.0537608,
                31.1804232
              ],
              [
                51.0634031,
                31.1849473
              ],
              [
                51.0695198,
                31.1878166
              ],
              [
                51.06952,
                31.1878167
              ],
              [
                51.0662543,
                31.1951464
              ],
              [
                51.0659777,
                31.1954262
              ],
              [
                51.0654211,
                31.1968164
              ],
              [
                51.0582014,
                31.2173713
              ],
              [
                51.0576448,
                31.2187615
              ],
              [
                51.0543655,
                31.2400745
              ],
              [
                51.0543113,
                31.2404269
              ],
              [
                51.0543113,
                31.240427
              ],
              [
                51.0514257,
                31.255404
              ],
              [
                51.0512605,
                31.256261
              ],
              [
                51.0512605,
                31.2562611
              ],
              [
                51.0504215,
                31.2595919
              ],
              [
                51.0498704,
                31.2634829
              ],
              [
                51.0479213,
                31.270154
              ],
              [
                51.0459781,
                31.2840382
              ],
              [
                51.0462606,
                31.2926506
              ],
              [
                51.0465371,
                31.2934811
              ],
              [
                51.0465373,
                31.2937609
              ],
              [
                51.0470881,
                31.2940407
              ],
              [
                51.0470908,
                31.2940434
              ],
              [
                51.0551444,
                31.3020932
              ],
              [
                51.0807008,
                31.318758
              ],
              [
                51.1187569,
                31.3382035
              ],
              [
                51.1194503,
                31.3386217
              ],
              [
                51.1201467,
                31.3393229
              ],
              [
                51.1254234,
                31.3407041
              ],
              [
                51.1276467,
                31.3418236
              ],
              [
                51.1370934,
                31.3440354
              ],
              [
                51.1640362,
                31.3545978
              ],
              [
                51.170426,
                31.3598699
              ],
              [
                51.1729261,
                31.3645914
              ],
              [
                51.1729261,
                31.3682116
              ],
              [
                51.1720928,
                31.3712629
              ],
              [
                51.1709828,
                31.3740435
              ],
              [
                51.1673728,
                31.3873685
              ],
              [
                51.1662594,
                31.3951504
              ],
              [
                51.1659829,
                31.4001518
              ],
              [
                51.1684828,
                31.4098748
              ],
              [
                51.1684827,
                31.4101546
              ],
              [
                51.1609828,
                31.4148762
              ],
              [
                51.1604261,
                31.4151471
              ],
              [
                51.1462596,
                31.4218186
              ],
              [
                51.1070901,
                31.430711
              ],
              [
                51.1062569,
                31.4307111
              ],
              [
                51.1057003,
                31.4309909
              ],
              [
                51.1034803,
                31.4309909
              ],
              [
                51.0812572,
                31.4348729
              ],
              [
                51.0807006,
                31.4348729
              ],
              [
                51.0757006,
                31.4357034
              ],
              [
                51.0748672,
                31.4359833
              ],
              [
                51.072924,
                31.4359833
              ],
              [
                51.061811,
                31.4393146
              ],
              [
                51.0615342,
                31.4395945
              ],
              [
                51.0609775,
                31.4395945
              ],
              [
                51.060701,
                31.4398743
              ],
              [
                51.0598676,
                31.4398744
              ],
              [
                51.0598675,
                31.4401542
              ],
              [
                51.0573677,
                31.4401542
              ],
              [
                51.0493111,
                31.4429348
              ],
              [
                51.0485653,
                31.4431162
              ],
              [
                51.0295879,
                31.4520981
              ],
              [
                51.0098648,
                31.4648727
              ],
              [
                50.9998957,
                31.4707048
              ],
              [
                50.9976417,
                31.4715444
              ],
              [
                50.997085,
                31.4718243
              ],
              [
                50.9893086,
                31.4759862
              ],
              [
                50.9881951,
                31.4770966
              ],
              [
                50.9873618,
                31.4773766
              ],
              [
                50.9870852,
                31.4779362
              ],
              [
                50.9581956,
                31.4921013
              ],
              [
                50.9576389,
                31.4923721
              ],
              [
                50.9576388,
                31.4923721
              ],
              [
                50.9570821,
                31.4926519
              ],
              [
                50.9568055,
                31.4929319
              ],
              [
                50.9531957,
                31.4954326
              ],
              [
                50.9523623,
                31.4962631
              ],
              [
                50.9468057,
                31.4990438
              ],
              [
                50.9462492,
                31.4990439
              ],
              [
                50.9456957,
                31.4995945
              ],
              [
                50.9431959,
                31.5004253
              ],
              [
                50.942639,
                31.5009849
              ],
              [
                50.9184696,
                31.5107083
              ],
              [
                50.9173595,
                31.5115388
              ],
              [
                50.9020832,
                31.517371
              ],
              [
                50.8957864,
                31.5197269
              ],
              [
                50.8937462,
                31.5245934
              ],
              [
                50.8912464,
                31.5265434
              ],
              [
                50.8901365,
                31.5270943
              ],
              [
                50.8406904,
                31.5579345
              ],
              [
                50.8390236,
                31.5593158
              ],
              [
                50.8134676,
                31.5709894
              ],
              [
                50.8120777,
                31.5709894
              ],
              [
                50.7954109,
                31.5768216
              ],
              [
                50.787631,
                31.5834935
              ],
              [
                50.787631,
                31.5834936
              ],
              [
                50.786241,
                31.584604
              ],
              [
                50.7748548,
                31.5970994
              ],
              [
                50.7652191,
                31.5996843
              ],
              [
                50.7621323,
                31.6035629
              ],
              [
                50.74409,
                31.6157467
              ],
              [
                50.7271455,
                31.6323348
              ],
              [
                50.7216024,
                31.6440655
              ],
              [
                50.7177136,
                31.6533346
              ],
              [
                50.7069276,
                31.6574571
              ],
              [
                50.7004248,
                31.6587728
              ],
              [
                50.694952,
                31.6588244
              ],
              [
                50.6874418,
                31.6580573
              ],
              [
                50.677185,
                31.6549888
              ],
              [
                50.6654048,
                31.6505035
              ],
              [
                50.6558422,
                31.6461812
              ],
              [
                50.6450198,
                31.6388964
              ],
              [
                50.6366144,
                31.6338648
              ],
              [
                50.6287771,
                31.6258483
              ],
              [
                50.6223364,
                31.6246442
              ],
              [
                50.6072776,
                31.6271102
              ],
              [
                50.5900262,
                31.6381857
              ],
              [
                50.5853204,
                31.6429813
              ],
              [
                50.5835252,
                31.6449869
              ],
              [
                50.5820098,
                31.6466813
              ],
              [
                50.5803841,
                31.648919
              ],
              [
                50.5743808,
                31.6533882
              ],
              [
                50.5736974,
                31.6536074
              ],
              [
                50.5664711,
                31.6559819
              ],
              [
                50.554413,
                31.6568404
              ],
              [
                50.5472283,
                31.6565181
              ],
              [
                50.5433538,
                31.6562473
              ],
              [
                50.5352986,
                31.6561243
              ],
              [
                50.5278874,
                31.6551659
              ],
              [
                50.5215342,
                31.65319
              ],
              [
                50.5181844,
                31.6521709
              ],
              [
                50.5154686,
                31.6501095
              ],
              [
                50.5093985,
                31.6445446
              ],
              [
                50.5065319,
                31.6429927
              ],
              [
                50.5008506,
                31.6409102
              ],
              [
                50.4996153,
                31.6414485
              ],
              [
                50.4963475,
                31.6432552
              ],
              [
                50.4951381,
                31.6422022
              ],
              [
                50.4907,
                31.6407151
              ],
              [
                50.4864405,
                31.6388458
              ],
              [
                50.4792364,
                31.636322
              ],
              [
                50.4729204,
                31.6336482
              ],
              [
                50.4695743,
                31.6313308
              ],
              [
                50.469212,
                31.6267668
              ],
              [
                50.4672294,
                31.622553
              ],
              [
                50.4647793,
                31.6177062
              ],
              [
                50.4567922,
                31.6016628
              ],
              [
                50.4141652,
                31.5998181
              ],
              [
                50.4106532,
                31.6005631
              ],
              [
                50.4056058,
                31.5956991
              ],
              [
                50.4007967,
                31.5982059
              ],
              [
                50.396157,
                31.5971395
              ],
              [
                50.3934777,
                31.5960909
              ],
              [
                50.3938986,
                31.5949796
              ],
              [
                50.3948177,
                31.5928883
              ],
              [
                50.3916923,
                31.5885383
              ],
              [
                50.3873748,
                31.5836988
              ],
              [
                50.3843071,
                31.5795029
              ],
              [
                50.3831806,
                31.5740522
              ],
              [
                50.3808016,
                31.5688514
              ],
              [
                50.3781561,
                31.5684996
              ],
              [
                50.3749127,
                31.5681997
              ],
              [
                50.3702234,
                31.5696634
              ],
              [
                50.3649115,
                31.5618989
              ],
              [
                50.3631932,
                31.5581894
              ],
              [
                50.3632014,
                31.5576644
              ],
              [
                50.363045,
                31.5571383
              ],
              [
                50.3612668,
                31.5520873
              ],
              [
                50.3622079,
                31.5498707
              ],
              [
                50.3692391,
                31.5500495
              ],
              [
                50.3694927,
                31.5468553
              ],
              [
                50.3662024,
                31.5403525
              ],
              [
                50.3637172,
                31.5350593
              ],
              [
                50.3613097,
                31.5302529
              ],
              [
                50.3519581,
                31.5125104
              ],
              [
                50.3490391,
                31.5029313
              ],
              [
                50.3495668,
                31.4989908
              ],
              [
                50.3478221,
                31.4920615
              ],
              [
                50.3350126,
                31.4733068
              ],
              [
                50.3233738,
                31.4601098
              ],
              [
                50.3189523,
                31.4572918
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11144781,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خانمیرزا",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.7134287,
                31.7373262
              ],
              [
                50.7050286,
                31.7272147
              ],
              [
                50.7033265,
                31.7214782
              ],
              [
                50.7025968,
                31.71477
              ],
              [
                50.7013928,
                31.7090243
              ],
              [
                50.7021273,
                31.702854
              ],
              [
                50.7019568,
                31.6965829
              ],
              [
                50.7055625,
                31.6851993
              ],
              [
                50.7085788,
                31.67466
              ],
              [
                50.7122898,
                31.6655186
              ],
              [
                50.7158517,
                31.6573633
              ],
              [
                50.7177136,
                31.6533346
              ],
              [
                50.7216024,
                31.6440655
              ],
              [
                50.7271455,
                31.6323348
              ],
              [
                50.74409,
                31.6157467
              ],
              [
                50.7621323,
                31.6035629
              ],
              [
                50.7652191,
                31.5996843
              ],
              [
                50.7748548,
                31.5970994
              ],
              [
                50.786241,
                31.584604
              ],
              [
                50.787631,
                31.5834936
              ],
              [
                50.787631,
                31.5834935
              ],
              [
                50.7954109,
                31.5768216
              ],
              [
                50.8120777,
                31.5709894
              ],
              [
                50.8134676,
                31.5709894
              ],
              [
                50.8390236,
                31.5593158
              ],
              [
                50.8406904,
                31.5579345
              ],
              [
                50.8901365,
                31.5270943
              ],
              [
                50.8912464,
                31.5265434
              ],
              [
                50.8937462,
                31.5245934
              ],
              [
                50.8957864,
                31.5197269
              ],
              [
                50.9020832,
                31.517371
              ],
              [
                50.9173595,
                31.5115388
              ],
              [
                50.9184696,
                31.5107083
              ],
              [
                50.942639,
                31.5009849
              ],
              [
                50.9431959,
                31.5004253
              ],
              [
                50.9456957,
                31.4995945
              ],
              [
                50.9462492,
                31.4990439
              ],
              [
                50.9468057,
                31.4990438
              ],
              [
                50.9523623,
                31.4962631
              ],
              [
                50.9531957,
                31.4954326
              ],
              [
                50.9568055,
                31.4929319
              ],
              [
                50.9570821,
                31.4926519
              ],
              [
                50.9576388,
                31.4923721
              ],
              [
                50.9576389,
                31.4923721
              ],
              [
                50.9581956,
                31.4921013
              ],
              [
                50.9870852,
                31.4779362
              ],
              [
                50.9873618,
                31.4773766
              ],
              [
                50.9881951,
                31.4770966
              ],
              [
                50.9893086,
                31.4759862
              ],
              [
                50.997085,
                31.4718243
              ],
              [
                50.9976417,
                31.4715444
              ],
              [
                50.9998957,
                31.4707048
              ],
              [
                51.0098648,
                31.4648727
              ],
              [
                51.0295879,
                31.4520981
              ],
              [
                51.0485653,
                31.4431162
              ],
              [
                51.0493111,
                31.4429348
              ],
              [
                51.0573677,
                31.4401542
              ],
              [
                51.0598675,
                31.4401542
              ],
              [
                51.0598676,
                31.4398744
              ],
              [
                51.060701,
                31.4398743
              ],
              [
                51.0609775,
                31.4395945
              ],
              [
                51.0615342,
                31.4395945
              ],
              [
                51.061811,
                31.4393146
              ],
              [
                51.072924,
                31.4359833
              ],
              [
                51.0748672,
                31.4359833
              ],
              [
                51.0757006,
                31.4357034
              ],
              [
                51.0807006,
                31.4348729
              ],
              [
                51.0812572,
                31.4348729
              ],
              [
                51.1034803,
                31.4309909
              ],
              [
                51.1057003,
                31.4309909
              ],
              [
                51.1062569,
                31.4307111
              ],
              [
                51.1070901,
                31.430711
              ],
              [
                51.1462596,
                31.4218186
              ],
              [
                51.1604261,
                31.4151471
              ],
              [
                51.1609828,
                31.4148762
              ],
              [
                51.1684827,
                31.4101546
              ],
              [
                51.1720927,
                31.4120956
              ],
              [
                51.1740393,
                31.413206
              ],
              [
                51.1929291,
                31.4184874
              ],
              [
                51.238485,
                31.4226493
              ],
              [
                51.2393184,
                31.4229291
              ],
              [
                51.2509849,
                31.4229291
              ],
              [
                51.2651547,
                31.4218187
              ],
              [
                51.268208,
                31.4218188
              ],
              [
                51.2723745,
                31.421268
              ],
              [
                51.285431,
                31.421268
              ],
              [
                51.2898778,
                31.4215389
              ],
              [
                51.291821,
                31.4218188
              ],
              [
                51.2987675,
                31.4218188
              ],
              [
                51.3004342,
                31.4220986
              ],
              [
                51.3026542,
                31.4220986
              ],
              [
                51.3030725,
                31.4220986
              ],
              [
                51.2890444,
                31.4440364
              ],
              [
                51.2884877,
                31.4451559
              ],
              [
                51.286821,
                31.4468171
              ],
              [
                51.283211,
                31.4495976
              ],
              [
                51.259598,
                31.4593207
              ],
              [
                51.259598,
                31.4607111
              ],
              [
                51.2701546,
                31.4807082
              ],
              [
                51.2704061,
                31.4855638
              ],
              [
                51.2723744,
                31.4901515
              ],
              [
                51.273004,
                31.4911377
              ],
              [
                51.2753,
                31.4922256
              ],
              [
                51.2707078,
                31.4915419
              ],
              [
                51.268405,
                31.4913242
              ],
              [
                51.2638012,
                31.4918525
              ],
              [
                51.2613592,
                31.4911463
              ],
              [
                51.2572454,
                31.4915275
              ],
              [
                51.2534699,
                31.4909992
              ],
              [
                51.2508755,
                31.4905866
              ],
              [
                51.2474991,
                31.4899964
              ],
              [
                51.242829,
                31.4911152
              ],
              [
                51.237506,
                31.4941981
              ],
              [
                51.2362919,
                31.4942971
              ],
              [
                51.2283262,
                31.4981141
              ],
              [
                51.2267734,
                31.5146066
              ],
              [
                51.2194535,
                31.5222008
              ],
              [
                51.2131571,
                31.5303415
              ],
              [
                51.2105605,
                31.5341304
              ],
              [
                51.2093943,
                31.53879
              ],
              [
                51.2090587,
                31.5448809
              ],
              [
                51.2095401,
                31.549444
              ],
              [
                51.2093503,
                31.5540749
              ],
              [
                51.2093186,
                31.5557139
              ],
              [
                51.2093746,
                31.5574853
              ],
              [
                51.2084685,
                31.5602804
              ],
              [
                51.2015006,
                31.5667402
              ],
              [
                51.1960137,
                31.5693176
              ],
              [
                51.1930794,
                31.5711806
              ],
              [
                51.1894082,
                31.5737372
              ],
              [
                51.1845394,
                31.5796914
              ],
              [
                51.1792377,
                31.5855592
              ],
              [
                51.1744054,
                31.5933828
              ],
              [
                51.1706594,
                31.6011423
              ],
              [
                51.167116,
                31.6065449
              ],
              [
                51.1643621,
                31.6132252
              ],
              [
                51.1620864,
                31.6146151
              ],
              [
                51.1568381,
                31.6205742
              ],
              [
                51.1544153,
                31.62488
              ],
              [
                51.1512253,
                31.6312499
              ],
              [
                51.1478796,
                31.6359219
              ],
              [
                51.1444222,
                31.6383593
              ],
              [
                51.1371162,
                31.6398116
              ],
              [
                51.1304972,
                31.6387683
              ],
              [
                51.1202757,
                31.6392963
              ],
              [
                51.1099602,
                31.6412301
              ],
              [
                51.1019571,
                31.6410267
              ],
              [
                51.096789,
                31.6389148
              ],
              [
                51.0908974,
                31.6382108
              ],
              [
                51.0811422,
                31.6396838
              ],
              [
                51.0693888,
                31.6414347
              ],
              [
                51.0589586,
                31.6401468
              ],
              [
                51.0535316,
                31.6410001
              ],
              [
                51.0424177,
                31.643295
              ],
              [
                51.0281569,
                31.6478023
              ],
              [
                51.0097743,
                31.6530532
              ],
              [
                51.0025718,
                31.6553709
              ],
              [
                50.9962384,
                31.6580114
              ],
              [
                50.9858982,
                31.661972
              ],
              [
                50.979694,
                31.6641723
              ],
              [
                50.9697415,
                31.6663725
              ],
              [
                50.9617279,
                31.6684626
              ],
              [
                50.9532774,
                31.6700183
              ],
              [
                50.9416293,
                31.6726679
              ],
              [
                50.9296138,
                31.6737517
              ],
              [
                50.9055218,
                31.6796275
              ],
              [
                50.8781206,
                31.6885728
              ],
              [
                50.8701595,
                31.6921132
              ],
              [
                50.8615568,
                31.6962903
              ],
              [
                50.8538741,
                31.7054003
              ],
              [
                50.8442115,
                31.7172891
              ],
              [
                50.8384744,
                31.7217111
              ],
              [
                50.8284237,
                31.727424
              ],
              [
                50.8129609,
                31.7335054
              ],
              [
                50.799837,
                31.7374382
              ],
              [
                50.7848529,
                31.7391865
              ],
              [
                50.7683965,
                31.7413106
              ],
              [
                50.7394774,
                31.740391
              ],
              [
                50.7172782,
                31.739588
              ],
              [
                50.7134287,
                31.7373262
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 16545694,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فلارد",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.0470881,
                31.2940407
              ],
              [
                51.0465373,
                31.2937609
              ],
              [
                51.0465371,
                31.2934811
              ],
              [
                51.0462606,
                31.2926506
              ],
              [
                51.0459781,
                31.2840382
              ],
              [
                51.0479213,
                31.270154
              ],
              [
                51.0498704,
                31.2634829
              ],
              [
                51.0504215,
                31.2595919
              ],
              [
                51.0512605,
                31.2562611
              ],
              [
                51.0512605,
                31.256261
              ],
              [
                51.0514257,
                31.255404
              ],
              [
                51.0543113,
                31.240427
              ],
              [
                51.0543113,
                31.2404269
              ],
              [
                51.0543655,
                31.2400745
              ],
              [
                51.0576448,
                31.2187615
              ],
              [
                51.0582014,
                31.2173713
              ],
              [
                51.0654211,
                31.1968164
              ],
              [
                51.0659777,
                31.1954262
              ],
              [
                51.0662543,
                31.1951464
              ],
              [
                51.06952,
                31.1878167
              ],
              [
                51.0695203,
                31.1878169
              ],
              [
                51.0695204,
                31.1878169
              ],
              [
                51.0715036,
                31.1887497
              ],
              [
                51.071533,
                31.1887635
              ],
              [
                51.071534,
                31.188764
              ],
              [
                51.0715343,
                31.1887642
              ],
              [
                51.0715344,
                31.1887642
              ],
              [
                51.07154,
                31.1887642
              ],
              [
                51.0784776,
                31.1887642
              ],
              [
                51.0887576,
                31.1854241
              ],
              [
                51.0957008,
                31.1818133
              ],
              [
                51.1290385,
                31.1573662
              ],
              [
                51.1487601,
                31.1501465
              ],
              [
                51.1504267,
                31.1501465
              ],
              [
                51.1509834,
                31.1498667
              ],
              [
                51.1529212,
                31.1498667
              ],
              [
                51.1529267,
                31.1498667
              ],
              [
                51.1529271,
                31.1498668
              ],
              [
                51.1537596,
                31.1501464
              ],
              [
                51.15376,
                31.1501465
              ],
              [
                51.1537655,
                31.1501465
              ],
              [
                51.1548662,
                31.1501446
              ],
              [
                51.1548714,
                31.1501446
              ],
              [
                51.1548722,
                31.1501447
              ],
              [
                51.1579281,
                31.1506951
              ],
              [
                51.1579281,
                31.1506952
              ],
              [
                51.1601504,
                31.1515344
              ],
              [
                51.1601514,
                31.1515347
              ],
              [
                51.1601514,
                31.1515348
              ],
              [
                51.1601517,
                31.1515349
              ],
              [
                51.1601518,
                31.151535
              ],
              [
                51.1615379,
                31.1523652
              ],
              [
                51.161538,
                31.1523652
              ],
              [
                51.1645946,
                31.157646
              ],
              [
                51.164318,
                31.1584765
              ],
              [
                51.1643175,
                31.158477
              ],
              [
                51.1643167,
                31.1584778
              ],
              [
                51.1643162,
                31.1584782
              ],
              [
                51.164038,
                31.1587563
              ],
              [
                51.1640381,
                31.1587567
              ],
              [
                51.1640382,
                31.1587573
              ],
              [
                51.1645946,
                31.1634774
              ],
              [
                51.1645947,
                31.1634774
              ],
              [
                51.1707078,
                31.1665286
              ],
              [
                51.1707079,
                31.1665286
              ],
              [
                51.1709846,
                31.1670883
              ],
              [
                51.179041,
                31.1748696
              ],
              [
                51.1801494,
                31.1818134
              ],
              [
                51.1848728,
                31.1898746
              ],
              [
                51.1848742,
                31.190983
              ],
              [
                51.1845963,
                31.1923661
              ],
              [
                51.1843176,
                31.1932037
              ],
              [
                51.1843167,
                31.1932056
              ],
              [
                51.1829276,
                31.195984
              ],
              [
                51.179041,
                31.2012559
              ],
              [
                51.1790408,
                31.201257
              ],
              [
                51.1787611,
                31.202646
              ],
              [
                51.1804257,
                31.209869
              ],
              [
                51.1804258,
                31.2098692
              ],
              [
                51.1804259,
                31.2098696
              ],
              [
                51.182926,
                31.2098698
              ],
              [
                51.1840395,
                31.20959
              ],
              [
                51.1873622,
                31.20959
              ],
              [
                51.1873673,
                31.20959
              ],
              [
                51.1873729,
                31.20959
              ],
              [
                51.1873732,
                31.2095902
              ],
              [
                51.1873739,
                31.2095904
              ],
              [
                51.2237627,
                31.2237604
              ],
              [
                51.2237634,
                31.2237607
              ],
              [
                51.2237637,
                31.2237608
              ],
              [
                51.2237693,
                31.2237608
              ],
              [
                51.2237744,
                31.2237608
              ],
              [
                51.2268188,
                31.2237628
              ],
              [
                51.2326911,
                31.220402
              ],
              [
                51.236542,
                31.218202
              ],
              [
                51.2454319,
                31.2093192
              ],
              [
                51.2520999,
                31.2068077
              ],
              [
                51.2570765,
                31.2063379
              ],
              [
                51.2579332,
                31.206257
              ],
              [
                51.2598265,
                31.2078841
              ],
              [
                51.260496,
                31.2097561
              ],
              [
                51.2622727,
                31.2115399
              ],
              [
                51.2656716,
                31.214645
              ],
              [
                51.2673196,
                31.215658
              ],
              [
                51.2710789,
                31.2157681
              ],
              [
                51.2729329,
                31.2157901
              ],
              [
                51.2759713,
                31.215724
              ],
              [
                51.2784432,
                31.2149973
              ],
              [
                51.2814559,
                31.2139183
              ],
              [
                51.284417,
                31.2125089
              ],
              [
                51.2869662,
                31.2102846
              ],
              [
                51.2901849,
                31.2076639
              ],
              [
                51.2913411,
                31.2075568
              ],
              [
                51.2948026,
                31.2072362
              ],
              [
                51.2961158,
                31.2083153
              ],
              [
                51.2985105,
                31.2085135
              ],
              [
                51.3022699,
                31.2086016
              ],
              [
                51.3043041,
                31.2073023
              ],
              [
                51.3060293,
                31.2056064
              ],
              [
                51.3121318,
                31.2004748
              ],
              [
                51.3156337,
                31.197986
              ],
              [
                51.3216333,
                31.1941535
              ],
              [
                51.3264484,
                31.1892415
              ],
              [
                51.3276843,
                31.1871488
              ],
              [
                51.3316497,
                31.1832057
              ],
              [
                51.3326024,
                31.1814434
              ],
              [
                51.3356224,
                31.1788507
              ],
              [
                51.3353907,
                31.1804809
              ],
              [
                51.332481,
                31.1875301
              ],
              [
                51.332069,
                31.1941603
              ],
              [
                51.3332793,
                31.2004155
              ],
              [
                51.3346955,
                31.207265
              ],
              [
                51.3360087,
                31.2123963
              ],
              [
                51.3400513,
                31.226027
              ],
              [
                51.3400256,
                31.2353405
              ],
              [
                51.3408238,
                31.2430901
              ],
              [
                51.3409954,
                31.2464676
              ],
              [
                51.3389612,
                31.2527634
              ],
              [
                51.3408666,
                31.2559332
              ],
              [
                51.3469434,
                31.2630427
              ],
              [
                51.3468404,
                31.2664323
              ],
              [
                51.3447033,
                31.2726607
              ],
              [
                51.3388324,
                31.2780085
              ],
              [
                51.3347126,
                31.2852045
              ],
              [
                51.333057,
                31.289992
              ],
              [
                51.3288599,
                31.2953828
              ],
              [
                51.3277011,
                31.2994532
              ],
              [
                51.3286539,
                31.3017634
              ],
              [
                51.3287569,
                31.3051075
              ],
              [
                51.3258472,
                31.3088035
              ],
              [
                51.3208261,
                31.3127853
              ],
              [
                51.314981,
                31.3211664
              ],
              [
                51.3136421,
                31.323608
              ],
              [
                51.3116079,
                31.3253897
              ],
              [
                51.308003,
                31.3298327
              ],
              [
                51.3068958,
                31.3334838
              ],
              [
                51.3037544,
                31.3384323
              ],
              [
                51.2975746,
                31.3453597
              ],
              [
                51.2942775,
                31.3521852
              ],
              [
                51.2923463,
                31.3538124
              ],
              [
                51.2912648,
                31.3553296
              ],
              [
                51.2858317,
                31.3658616
              ],
              [
                51.2852652,
                31.3672247
              ],
              [
                51.2852652,
                31.3695552
              ],
              [
                51.2859605,
                31.3733147
              ],
              [
                51.2881492,
                31.3754251
              ],
              [
                51.2910846,
                31.3768321
              ],
              [
                51.2968781,
                31.3780632
              ],
              [
                51.2981656,
                31.3780632
              ],
              [
                51.3020094,
                31.3770401
              ],
              [
                51.305039,
                31.3751668
              ],
              [
                51.3085718,
                31.3742308
              ],
              [
                51.3107827,
                31.3759747
              ],
              [
                51.3136924,
                31.3779972
              ],
              [
                51.3149453,
                31.3797876
              ],
              [
                51.3156149,
                31.3815458
              ],
              [
                51.3143206,
                31.384597
              ],
              [
                51.3137674,
                31.388488
              ],
              [
                51.3140441,
                31.3934804
              ],
              [
                51.3084873,
                31.4107055
              ],
              [
                51.3073775,
                31.4126555
              ],
              [
                51.3068207,
                31.4129264
              ],
              [
                51.3043209,
                31.4182076
              ],
              [
                51.3043209,
                31.4195979
              ],
              [
                51.3040443,
                31.4201486
              ],
              [
                51.3037675,
                31.4209882
              ],
              [
                51.3034874,
                31.4215389
              ],
              [
                51.3032108,
                31.4218188
              ],
              [
                51.3030725,
                31.4220986
              ],
              [
                51.3026542,
                31.4220986
              ],
              [
                51.3004342,
                31.4220986
              ],
              [
                51.2987675,
                31.4218188
              ],
              [
                51.291821,
                31.4218188
              ],
              [
                51.2898778,
                31.4215389
              ],
              [
                51.285431,
                31.421268
              ],
              [
                51.2723745,
                31.421268
              ],
              [
                51.268208,
                31.4218188
              ],
              [
                51.2651547,
                31.4218187
              ],
              [
                51.2509849,
                31.4229291
              ],
              [
                51.2393184,
                31.4229291
              ],
              [
                51.238485,
                31.4226493
              ],
              [
                51.1929291,
                31.4184874
              ],
              [
                51.1740393,
                31.413206
              ],
              [
                51.1720927,
                31.4120956
              ],
              [
                51.1684827,
                31.4101546
              ],
              [
                51.1684828,
                31.4098748
              ],
              [
                51.1659829,
                31.4001518
              ],
              [
                51.1662594,
                31.3951504
              ],
              [
                51.1673728,
                31.3873685
              ],
              [
                51.1709828,
                31.3740435
              ],
              [
                51.1720928,
                31.3712629
              ],
              [
                51.1729261,
                31.3682116
              ],
              [
                51.1729261,
                31.3645914
              ],
              [
                51.170426,
                31.3598699
              ],
              [
                51.1640362,
                31.3545978
              ],
              [
                51.1370934,
                31.3440354
              ],
              [
                51.1276467,
                31.3418236
              ],
              [
                51.1254234,
                31.3407041
              ],
              [
                51.1201467,
                31.3393229
              ],
              [
                51.1194503,
                31.3386217
              ],
              [
                51.1187569,
                31.3382035
              ],
              [
                51.0807008,
                31.318758
              ],
              [
                51.0551444,
                31.3020932
              ],
              [
                51.0470908,
                31.2940434
              ],
              [
                51.0470881,
                31.2940407
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820417173
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.8303948,
          31.5126237
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3067853248
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.0576007,
          31.5528467
        ]
      }
    }
  ]
},
"خراسان جنوبی.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554933,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بشرویه",
          "name:ar": "مقاطعة بشرويه",
          "name:en": "Boshruyeh County",
          "name:uk": "Бошрує шагрестан",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q80860"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.0168052,
                33.9374314
              ],
              [
                57.017082,
                33.9371516
              ],
              [
                57.0187486,
                33.9338208
              ],
              [
                57.0479181,
                33.8960442
              ],
              [
                57.0484714,
                33.8943743
              ],
              [
                57.0562514,
                33.8849323
              ],
              [
                57.0765311,
                33.8749306
              ],
              [
                57.0765311,
                33.8746507
              ],
              [
                57.086531,
                33.8652087
              ],
              [
                57.1004208,
                33.8382634
              ],
              [
                57.1054207,
                33.829101
              ],
              [
                57.1062539,
                33.8277109
              ],
              [
                57.122087,
                33.8013159
              ],
              [
                57.1287535,
                33.787703
              ],
              [
                57.1301436,
                33.7832616
              ],
              [
                57.1307003,
                33.7818714
              ],
              [
                57.1312535,
                33.7807611
              ],
              [
                57.1415334,
                33.755485
              ],
              [
                57.1468099,
                33.7490936
              ],
              [
                57.1590331,
                33.7393712
              ],
              [
                57.1604232,
                33.7379811
              ],
              [
                57.1859793,
                33.7196465
              ],
              [
                57.1934794,
                33.7124246
              ],
              [
                57.1935566,
                33.7121926
              ],
              [
                57.1937558,
                33.7115941
              ],
              [
                57.2068124,
                33.6902081
              ],
              [
                57.2082024,
                33.6854868
              ],
              [
                57.208479,
                33.6735344
              ],
              [
                57.2070924,
                33.6685421
              ],
              [
                57.2068124,
                33.6674317
              ],
              [
                57.2051457,
                33.6574292
              ],
              [
                57.2048691,
                33.6571494
              ],
              [
                57.2051457,
                33.6554882
              ],
              [
                57.2070924,
                33.6418656
              ],
              [
                57.2076457,
                33.6407552
              ],
              [
                57.2095924,
                33.6343636
              ],
              [
                57.2095924,
                33.633813
              ],
              [
                57.2101455,
                33.6304818
              ],
              [
                57.212369,
                33.6263109
              ],
              [
                57.2298687,
                33.5977022
              ],
              [
                57.230982,
                33.5927008
              ],
              [
                57.2312586,
                33.5907598
              ],
              [
                57.2312585,
                33.5896493
              ],
              [
                57.2315353,
                33.5876993
              ],
              [
                57.2304254,
                33.5849279
              ],
              [
                57.2295919,
                33.5840883
              ],
              [
                57.2273687,
                33.5799265
              ],
              [
                57.2179255,
                33.5685333
              ],
              [
                57.2176454,
                33.5671431
              ],
              [
                57.2173688,
                33.5657618
              ],
              [
                57.217092,
                33.5652021
              ],
              [
                57.2176453,
                33.5610312
              ],
              [
                57.2195921,
                33.5568694
              ],
              [
                57.2198686,
                33.5554791
              ],
              [
                57.2198686,
                33.5551992
              ],
              [
                57.2201454,
                33.5543686
              ],
              [
                57.2201454,
                33.5540887
              ],
              [
                57.220702,
                33.5529783
              ],
              [
                57.2215352,
                33.5499269
              ],
              [
                57.2348685,
                33.5268695
              ],
              [
                57.2582048,
                33.5090934
              ],
              [
                57.2595914,
                33.5082538
              ],
              [
                57.2732045,
                33.5013112
              ],
              [
                57.2734811,
                33.5010313
              ],
              [
                57.3276505,
                33.4738117
              ],
              [
                57.3343171,
                33.4724212
              ],
              [
                57.3362636,
                33.4721414
              ],
              [
                57.35793,
                33.4665891
              ],
              [
                57.3620965,
                33.4649189
              ],
              [
                57.3629301,
                33.4649189
              ],
              [
                57.3643165,
                33.4643681
              ],
              [
                57.3651501,
                33.4643682
              ],
              [
                57.3654301,
                33.4640883
              ],
              [
                57.3662633,
                33.4640883
              ],
              [
                57.3679298,
                33.4635286
              ],
              [
                57.3690431,
                33.4635286
              ],
              [
                57.3701569,
                33.4629778
              ],
              [
                57.3720967,
                33.4629779
              ],
              [
                57.37293,
                33.4626979
              ],
              [
                57.3748765,
                33.462698
              ],
              [
                57.37571,
                33.4624181
              ],
              [
                57.3818231,
                33.4621473
              ],
              [
                57.396823,
                33.4638084
              ],
              [
                57.399323,
                33.4640882
              ],
              [
                57.399596,
                33.4643681
              ],
              [
                57.4146027,
                33.4674197
              ],
              [
                57.4162694,
                33.4674196
              ],
              [
                57.4193226,
                33.4685301
              ],
              [
                57.4207094,
                33.46853
              ],
              [
                57.422656,
                33.4690898
              ],
              [
                57.4234891,
                33.4696405
              ],
              [
                57.4334889,
                33.472701
              ],
              [
                57.4387692,
                33.472701
              ],
              [
                57.4398758,
                33.4729809
              ],
              [
                57.4573825,
                33.4774227
              ],
              [
                57.4648822,
                33.4804833
              ],
              [
                57.4665486,
                33.4813138
              ],
              [
                57.4668221,
                33.4815846
              ],
              [
                57.4915484,
                33.4940885
              ],
              [
                57.4940485,
                33.4965892
              ],
              [
                57.5259948,
                33.5246483
              ],
              [
                57.5279414,
                33.5260296
              ],
              [
                57.5409943,
                33.5324214
              ],
              [
                57.5432143,
                33.5360325
              ],
              [
                57.5932205,
                33.5910392
              ],
              [
                57.5951675,
                33.5935399
              ],
              [
                57.599887,
                33.6010329
              ],
              [
                57.6054403,
                33.6099252
              ],
              [
                57.606554,
                33.6110357
              ],
              [
                57.6071072,
                33.612146
              ],
              [
                57.6273869,
                33.6349228
              ],
              [
                57.6335004,
                33.6374235
              ],
              [
                57.6348866,
                33.6374235
              ],
              [
                57.6354468,
                33.6371436
              ],
              [
                57.6410001,
                33.6360332
              ],
              [
                57.6440532,
                33.634652
              ],
              [
                57.6454466,
                33.6340923
              ],
              [
                57.6928019,
                33.626589
              ],
              [
                57.7055166,
                33.6107595
              ],
              [
                57.7093139,
                33.6009995
              ],
              [
                57.7094219,
                33.5948
              ],
              [
                57.7108107,
                33.5911006
              ],
              [
                57.7127823,
                33.5887689
              ],
              [
                57.7155674,
                33.5736372
              ],
              [
                57.7303357,
                33.5668588
              ],
              [
                57.7344435,
                33.5602565
              ],
              [
                57.738552,
                33.5583984
              ],
              [
                57.7592125,
                33.5633335
              ],
              [
                57.7668952,
                33.5510253
              ],
              [
                57.7753169,
                33.555254
              ],
              [
                57.7807217,
                33.5577297
              ],
              [
                57.8001304,
                33.5612162
              ],
              [
                57.8049137,
                33.5678466
              ],
              [
                57.8054513,
                33.5732541
              ],
              [
                57.8093362,
                33.579265
              ],
              [
                57.8107251,
                33.5851792
              ],
              [
                57.8042723,
                33.5949534
              ],
              [
                57.8040805,
                33.6080687
              ],
              [
                57.7992024,
                33.6129162
              ],
              [
                57.7974697,
                33.6243037
              ],
              [
                57.8016946,
                33.6317337
              ],
              [
                57.8020748,
                33.6397537
              ],
              [
                57.7897017,
                33.6433606
              ],
              [
                57.7952581,
                33.6541287
              ],
              [
                57.7991431,
                33.6574807
              ],
              [
                57.8007739,
                33.661806
              ],
              [
                57.7967398,
                33.6707803
              ],
              [
                57.7921682,
                33.6736316
              ],
              [
                57.7860968,
                33.679099
              ],
              [
                57.7823584,
                33.6887621
              ],
              [
                57.7770994,
                33.6959231
              ],
              [
                57.7712622,
                33.7041713
              ],
              [
                57.7776685,
                33.7165707
              ],
              [
                57.7721372,
                33.7235611
              ],
              [
                57.7515178,
                33.7150726
              ],
              [
                57.747116,
                33.7150814
              ],
              [
                57.7429276,
                33.7246037
              ],
              [
                57.7375525,
                33.7288232
              ],
              [
                57.7243206,
                33.7383817
              ],
              [
                57.7230261,
                33.741471
              ],
              [
                57.7232075,
                33.7493266
              ],
              [
                57.7211378,
                33.7608821
              ],
              [
                57.7068899,
                33.7694445
              ],
              [
                57.6989935,
                33.7765791
              ],
              [
                57.6900671,
                33.7912746
              ],
              [
                57.6818558,
                33.8018453
              ],
              [
                57.6759123,
                33.8075233
              ],
              [
                57.671879,
                33.8121615
              ],
              [
                57.6677859,
                33.8159209
              ],
              [
                57.6608848,
                33.8195884
              ],
              [
                57.6497268,
                33.8280736
              ],
              [
                57.6401996,
                33.8365579
              ],
              [
                57.6421,
                33.8409926
              ],
              [
                57.6440108,
                33.844261
              ],
              [
                57.6469395,
                33.8473792
              ],
              [
                57.6334425,
                33.8569182
              ],
              [
                57.641342,
                33.8683089
              ],
              [
                57.6514166,
                33.8793943
              ],
              [
                57.6455062,
                33.885144
              ],
              [
                57.641081,
                33.8915807
              ],
              [
                57.6340166,
                33.8987926
              ],
              [
                57.6338243,
                33.9018257
              ],
              [
                57.6556646,
                33.9243668
              ],
              [
                57.6494232,
                33.9286294
              ],
              [
                57.6422494,
                33.931741
              ],
              [
                57.641285,
                33.939576
              ],
              [
                57.6317325,
                33.9434124
              ],
              [
                57.6242762,
                33.9511463
              ],
              [
                57.609436,
                33.9510336
              ],
              [
                57.6251062,
                33.9739302
              ],
              [
                57.6002776,
                33.9897267
              ],
              [
                57.5809117,
                34.0000043
              ],
              [
                57.5754768,
                34.0066592
              ],
              [
                57.5660984,
                34.0281572
              ],
              [
                57.5580787,
                34.0486722
              ],
              [
                57.5524008,
                34.0763611
              ],
              [
                57.5544299,
                34.0901139
              ],
              [
                57.5540044,
                34.1005879
              ],
              [
                57.5531902,
                34.1058694
              ],
              [
                57.5660991,
                34.1244899
              ],
              [
                57.5710034,
                34.127522
              ],
              [
                57.5701617,
                34.136673
              ],
              [
                57.5689179,
                34.1417092
              ],
              [
                57.5663784,
                34.1506016
              ],
              [
                57.567501,
                34.1613921
              ],
              [
                57.5711747,
                34.172253
              ],
              [
                57.5627099,
                34.1799866
              ],
              [
                57.5613623,
                34.1918327
              ],
              [
                57.560913,
                34.1989865
              ],
              [
                57.5601595,
                34.2062856
              ],
              [
                57.5595177,
                34.211216
              ],
              [
                57.5798628,
                34.2296721
              ],
              [
                57.5811654,
                34.2414378
              ],
              [
                57.5841939,
                34.2521286
              ],
              [
                57.5864808,
                34.2643158
              ],
              [
                57.5925706,
                34.2687276
              ],
              [
                57.6200898,
                34.2759029
              ],
              [
                57.6304549,
                34.2725348
              ],
              [
                57.6402754,
                34.2734991
              ],
              [
                57.6428376,
                34.2741361
              ],
              [
                57.6611333,
                34.2749681
              ],
              [
                57.6616185,
                34.2770833
              ],
              [
                57.6671797,
                34.2821698
              ],
              [
                57.6720046,
                34.2836513
              ],
              [
                57.6809552,
                34.2811294
              ],
              [
                57.6851199,
                34.2817025
              ],
              [
                57.6979297,
                34.2905896
              ],
              [
                57.7131781,
                34.3012731
              ],
              [
                57.7200393,
                34.3085461
              ],
              [
                57.7291693,
                34.3143843
              ],
              [
                57.738857,
                34.3232273
              ],
              [
                57.7499984,
                34.3303493
              ],
              [
                57.76695,
                34.3546226
              ],
              [
                57.7677707,
                34.3549214
              ],
              [
                57.7697996,
                34.3567577
              ],
              [
                57.7695898,
                34.3594136
              ],
              [
                57.7742173,
                34.3662291
              ],
              [
                57.7749028,
                34.3666507
              ],
              [
                57.7925687,
                34.3850123
              ],
              [
                57.7920156,
                34.3858517
              ],
              [
                57.7953019,
                34.3988677
              ],
              [
                57.8011319,
                34.4083262
              ],
              [
                57.8014752,
                34.4256028
              ],
              [
                57.8063908,
                34.4348469
              ],
              [
                57.8055571,
                34.4359662
              ],
              [
                57.820243,
                34.4497466
              ],
              [
                57.8230931,
                34.4892684
              ],
              [
                57.8186463,
                34.4962094
              ],
              [
                57.8183665,
                34.4970399
              ],
              [
                57.8125421,
                34.498293
              ],
              [
                57.812269,
                34.4991238
              ],
              [
                57.7852534,
                34.511154
              ],
              [
                57.7878225,
                34.5205293
              ],
              [
                57.7874076,
                34.5205282
              ],
              [
                57.7897694,
                34.5244219
              ],
              [
                57.7897694,
                34.5247018
              ],
              [
                57.7958758,
                34.5308163
              ],
              [
                57.807976,
                34.5408506
              ],
              [
                57.8079759,
                34.5414108
              ],
              [
                57.8290889,
                34.565055
              ],
              [
                57.8360356,
                34.573394
              ],
              [
                57.8382556,
                34.5775681
              ],
              [
                57.8385357,
                34.5778481
              ],
              [
                57.8388157,
                34.5783992
              ],
              [
                57.8393692,
                34.5797905
              ],
              [
                57.8413158,
                34.5822932
              ],
              [
                57.8413158,
                34.5828533
              ],
              [
                57.8450224,
                34.6188228
              ],
              [
                57.8462171,
                34.6549216
              ],
              [
                57.8506495,
                34.6608072
              ],
              [
                57.8551194,
                34.6729775
              ],
              [
                57.8562327,
                34.6743682
              ],
              [
                57.8574368,
                34.7057759
              ],
              [
                57.8701397,
                34.7249661
              ],
              [
                57.8751495,
                34.7416757
              ],
              [
                57.8820961,
                34.7475154
              ],
              [
                57.8870964,
                34.750846
              ],
              [
                57.8879296,
                34.7516854
              ],
              [
                57.9004295,
                34.7583554
              ],
              [
                57.902376,
                34.7591858
              ],
              [
                57.9178616,
                34.7873034
              ],
              [
                57.9285046,
                34.8205682
              ],
              [
                57.9273031,
                34.8433947
              ],
              [
                57.9300495,
                34.8521997
              ],
              [
                57.9548547,
                34.8853768
              ],
              [
                57.9535142,
                34.8854034
              ],
              [
                57.9346418,
                34.8854733
              ],
              [
                57.8653332,
                34.8659334
              ],
              [
                57.8244778,
                34.8624121
              ],
              [
                57.7968403,
                34.8557918
              ],
              [
                57.7681731,
                34.8532561
              ],
              [
                57.7604483,
                34.8541013
              ],
              [
                57.7550444,
                34.8542178
              ],
              [
                57.7156627,
                34.8198338
              ],
              [
                57.7192454,
                34.8109783
              ],
              [
                57.6716359,
                34.7704005
              ],
              [
                57.6801682,
                34.7486169
              ],
              [
                57.6042462,
                34.7115087
              ],
              [
                57.6001531,
                34.7079128
              ],
              [
                57.6012249,
                34.7023665
              ],
              [
                57.601985,
                34.683443
              ],
              [
                57.4629374,
                34.5988392
              ],
              [
                57.4418244,
                34.5930012
              ],
              [
                57.4404376,
                34.5930012
              ],
              [
                57.4396045,
                34.5927215
              ],
              [
                57.4371043,
                34.5924509
              ],
              [
                57.4209916,
                34.5938405
              ],
              [
                57.4193247,
                34.5941201
              ],
              [
                57.4173782,
                34.5949503
              ],
              [
                57.4076582,
                34.6096763
              ],
              [
                57.4007115,
                34.6174452
              ],
              [
                57.4001583,
                34.6180047
              ],
              [
                57.4001583,
                34.6182754
              ],
              [
                57.3962649,
                34.6213434
              ],
              [
                57.3934918,
                34.6221735
              ],
              [
                57.391825,
                34.6221735
              ],
              [
                57.3915449,
                34.6218938
              ],
              [
                57.3904316,
                34.6218937
              ],
              [
                57.3901585,
                34.621614
              ],
              [
                57.370712,
                34.6096764
              ],
              [
                57.3690452,
                34.6082777
              ],
              [
                57.3309858,
                34.5785549
              ],
              [
                57.3243193,
                34.5724551
              ],
              [
                57.3237657,
                34.5713362
              ],
              [
                57.3118193,
                34.5557797
              ],
              [
                57.3095993,
                34.5530005
              ],
              [
                57.3087661,
                34.551331
              ],
              [
                57.3076529,
                34.5502302
              ],
              [
                57.3073727,
                34.549391
              ],
              [
                57.3065391,
                34.5485608
              ],
              [
                57.3009862,
                34.5391132
              ],
              [
                57.2940397,
                34.5243955
              ],
              [
                57.293486,
                34.5241158
              ],
              [
                57.2893196,
                34.5160575
              ],
              [
                57.2893196,
                34.5157778
              ],
              [
                57.2890395,
                34.5152274
              ],
              [
                57.2873727,
                34.5116178
              ],
              [
                57.2868195,
                34.5113381
              ],
              [
                57.2851529,
                34.5096687
              ],
              [
                57.2851529,
                34.5091182
              ],
              [
                57.2845963,
                34.5085588
              ],
              [
                57.2845962,
                34.5079993
              ],
              [
                57.2840396,
                34.5071691
              ],
              [
                57.283763,
                34.5063389
              ],
              [
                57.2834862,
                34.5054998
              ],
              [
                57.2832061,
                34.5046696
              ],
              [
                57.2829296,
                34.5041101
              ],
              [
                57.2829296,
                34.5032798
              ],
              [
                57.2823729,
                34.5013397
              ],
              [
                57.2820961,
                34.5007803
              ],
              [
                57.2718162,
                34.4771646
              ],
              [
                57.2712631,
                34.4760547
              ],
              [
                57.2526497,
                34.4368901
              ],
              [
                57.2518165,
                34.4360509
              ],
              [
                57.2437598,
                34.4210615
              ],
              [
                57.2429266,
                34.419392
              ],
              [
                57.2423698,
                34.4188326
              ],
              [
                57.2423698,
                34.4182731
              ],
              [
                57.2243133,
                34.3810564
              ],
              [
                57.2240367,
                34.3799374
              ],
              [
                57.21987,
                34.362168
              ],
              [
                57.2193134,
                34.3599389
              ],
              [
                57.2112603,
                34.3427199
              ],
              [
                57.1912571,
                34.3127216
              ],
              [
                57.1882039,
                34.3060521
              ],
              [
                57.1868138,
                34.303832
              ],
              [
                57.1865336,
                34.3035523
              ],
              [
                57.1707005,
                34.2743835
              ],
              [
                57.1662572,
                34.2566041
              ],
              [
                57.1659771,
                34.2563243
              ],
              [
                57.1593105,
                34.2302234
              ],
              [
                57.1587572,
                34.228274
              ],
              [
                57.146534,
                34.1932737
              ],
              [
                57.1418107,
                34.1841038
              ],
              [
                57.1390341,
                34.1777138
              ],
              [
                57.1384773,
                34.1774429
              ],
              [
                57.1354206,
                34.1713237
              ],
              [
                57.1345875,
                34.1685528
              ],
              [
                57.1329208,
                34.1632728
              ],
              [
                57.1323675,
                34.1627223
              ],
              [
                57.1243108,
                34.1449418
              ],
              [
                57.1234776,
                34.1443823
              ],
              [
                57.1220876,
                34.140772
              ],
              [
                57.1212543,
                34.1391023
              ],
              [
                57.1073643,
                34.1118806
              ],
              [
                57.1070878,
                34.1104906
              ],
              [
                57.1065312,
                34.1096602
              ],
              [
                57.1062543,
                34.1082702
              ],
              [
                57.1056977,
                34.10716
              ],
              [
                57.1054212,
                34.1057701
              ],
              [
                57.1048645,
                34.1046599
              ],
              [
                57.1045877,
                34.1029901
              ],
              [
                57.104031,
                34.1018799
              ],
              [
                57.1020878,
                34.0927097
              ],
              [
                57.1012544,
                34.0857687
              ],
              [
                57.1009743,
                34.0849384
              ],
              [
                57.1012544,
                34.0838281
              ],
              [
                57.1009744,
                34.0829977
              ],
              [
                57.1009744,
                34.0815988
              ],
              [
                57.0951412,
                34.0732678
              ],
              [
                57.0843079,
                34.057716
              ],
              [
                57.0695848,
                34.0399346
              ],
              [
                57.0684747,
                34.0388243
              ],
              [
                57.0684747,
                34.0385445
              ],
              [
                57.0679181,
                34.0382737
              ],
              [
                57.0676414,
                34.0377141
              ],
              [
                57.0656948,
                34.0360442
              ],
              [
                57.0640282,
                34.0352138
              ],
              [
                57.0637515,
                34.0346543
              ],
              [
                57.0265286,
                34.013542
              ],
              [
                57.0256954,
                34.0129914
              ],
              [
                57.0251385,
                34.0124318
              ],
              [
                57.0140254,
                34.0038208
              ],
              [
                57.0129154,
                34.0027106
              ],
              [
                57.0073588,
                33.9979898
              ],
              [
                57.007082,
                33.9871582
              ],
              [
                57.0065253,
                33.9857681
              ],
              [
                57.0079154,
                33.9710461
              ],
              [
                57.0076389,
                33.9685458
              ],
              [
                57.0073588,
                33.9679861
              ],
              [
                57.0073587,
                33.9624349
              ],
              [
                57.0101387,
                33.953264
              ],
              [
                57.0104152,
                33.9507726
              ],
              [
                57.0120819,
                33.9463226
              ],
              [
                57.0120819,
                33.9460427
              ],
              [
                57.0156919,
                33.9391014
              ],
              [
                57.0168052,
                33.9379911
              ],
              [
                57.0168052,
                33.9374314
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554956,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بیرجند",
          "name:en": "Birjand County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286327",
          "wikipedia": "en:Birjand County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.6597905,
                33.2217889
              ],
              [
                58.6599327,
                33.2143595
              ],
              [
                58.6599327,
                33.2137998
              ],
              [
                58.665766,
                33.203805
              ],
              [
                58.6685458,
                33.1851876
              ],
              [
                58.6704926,
                33.1796349
              ],
              [
                58.6707656,
                33.1788043
              ],
              [
                58.6821588,
                33.1493613
              ],
              [
                58.6888254,
                33.1382468
              ],
              [
                58.6960454,
                33.1304729
              ],
              [
                58.6971586,
                33.1299131
              ],
              [
                58.6974388,
                33.1293533
              ],
              [
                58.6985454,
                33.1288025
              ],
              [
                58.7127116,
                33.1179678
              ],
              [
                58.7168781,
                33.1132457
              ],
              [
                58.7210449,
                33.1063024
              ],
              [
                58.7213251,
                33.1060226
              ],
              [
                58.7193456,
                33.0931287
              ],
              [
                58.7326981,
                33.0762923
              ],
              [
                58.7324382,
                33.0687962
              ],
              [
                58.7352183,
                33.0660243
              ],
              [
                58.7429911,
                33.0618529
              ],
              [
                58.7649375,
                33.058801
              ],
              [
                58.7693841,
                33.058801
              ],
              [
                58.7710509,
                33.0585211
              ],
              [
                58.7749374,
                33.0585211
              ],
              [
                58.7757706,
                33.0582412
              ],
              [
                58.7793839,
                33.0579703
              ],
              [
                58.786604,
                33.0565799
              ],
              [
                58.7888306,
                33.0562999
              ],
              [
                58.7943838,
                33.0551894
              ],
              [
                58.7960506,
                33.0551894
              ],
              [
                58.7985503,
                33.0546296
              ],
              [
                58.8002171,
                33.0546296
              ],
              [
                58.8010504,
                33.0543497
              ],
              [
                58.8141103,
                33.0512978
              ],
              [
                58.8268832,
                33.0454651
              ],
              [
                58.8296634,
                33.0446344
              ],
              [
                58.8307767,
                33.0446344
              ],
              [
                58.8402234,
                33.0421333
              ],
              [
                58.8427235,
                33.0421333
              ],
              [
                58.8435567,
                33.0418534
              ],
              [
                58.8488298,
                33.0418534
              ],
              [
                58.8499431,
                33.0421334
              ],
              [
                58.8546631,
                33.0426841
              ],
              [
                58.8635563,
                33.0451851
              ],
              [
                58.8646629,
                33.0451851
              ],
              [
                58.8877227,
                33.052959
              ],
              [
                58.8905026,
                33.0537986
              ],
              [
                58.8913361,
                33.0540786
              ],
              [
                58.9096689,
                33.0576902
              ],
              [
                58.9118889,
                33.0576902
              ],
              [
                58.9130022,
                33.0579701
              ],
              [
                58.9135557,
                33.0576902
              ],
              [
                58.9166155,
                33.0576901
              ],
              [
                58.9168889,
                33.0574103
              ],
              [
                58.9180023,
                33.0574103
              ],
              [
                58.9182824,
                33.0571304
              ],
              [
                58.9193891,
                33.0571304
              ],
              [
                58.9196688,
                33.0568505
              ],
              [
                58.9216156,
                33.0557399
              ],
              [
                58.9227223,
                33.0537987
              ],
              [
                58.9235555,
                33.0499071
              ],
              [
                58.9291154,
                33.0454649
              ],
              [
                58.9374487,
                33.0412935
              ],
              [
                58.9396687,
                33.0404628
              ],
              [
                58.9441152,
                33.0393522
              ],
              [
                58.9468884,
                33.0382416
              ],
              [
                58.9477216,
                33.0382416
              ],
              [
                58.9577285,
                33.0335194
              ],
              [
                58.9641148,
                33.0321289
              ],
              [
                58.9702283,
                33.0321289
              ],
              [
                58.9760616,
                33.0337992
              ],
              [
                58.9885615,
                33.0399119
              ],
              [
                58.9891146,
                33.0401918
              ],
              [
                58.9985612,
                33.0454648
              ],
              [
                58.9988413,
                33.0454648
              ],
              [
                58.9989783,
                33.0450489
              ],
              [
                58.9996747,
                33.0446341
              ],
              [
                59.0021746,
                33.0410135
              ],
              [
                59.0032809,
                33.0340791
              ],
              [
                59.0038411,
                33.0329596
              ],
              [
                59.0043946,
                33.0299077
              ],
              [
                59.0049476,
                33.0287971
              ],
              [
                59.0049477,
                33.0279665
              ],
              [
                59.0146743,
                32.9999041
              ],
              [
                59.0241139,
                32.9687988
              ],
              [
                59.0357871,
                32.9410161
              ],
              [
                59.0363402,
                32.9379552
              ],
              [
                59.0368938,
                32.92796
              ],
              [
                59.0366202,
                32.92768
              ],
              [
                59.0368937,
                32.9271292
              ],
              [
                59.0366203,
                32.9265694
              ],
              [
                59.0366203,
                32.924908
              ],
              [
                59.0366203,
                32.9243482
              ],
              [
                59.0371738,
                32.9193551
              ],
              [
                59.0391202,
                32.8771254
              ],
              [
                59.03856,
                32.8737936
              ],
              [
                59.0385601,
                32.8715725
              ],
              [
                59.03856,
                32.8685116
              ],
              [
                59.038287,
                32.8649089
              ],
              [
                59.0380068,
                32.8632385
              ],
              [
                59.0377268,
                32.8596268
              ],
              [
                59.0374538,
                32.8546246
              ],
              [
                59.0371737,
                32.8510128
              ],
              [
                59.0368935,
                32.8487916
              ],
              [
                59.030507,
                32.8279611
              ],
              [
                59.0299536,
                32.8274013
              ],
              [
                59.0288402,
                32.8243494
              ],
              [
                59.0282871,
                32.8237896
              ],
              [
                59.0282871,
                32.8232388
              ],
              [
                59.0218936,
                32.8137942
              ],
              [
                59.0188404,
                32.8107333
              ],
              [
                59.0185602,
                32.8104624
              ],
              [
                59.0182801,
                32.8099025
              ],
              [
                59.0099471,
                32.8012886
              ],
              [
                59.0085605,
                32.7982368
              ],
              [
                59.0130069,
                32.7810178
              ],
              [
                59.0302268,
                32.7554558
              ],
              [
                59.0305068,
                32.7551758
              ],
              [
                59.0305069,
                32.7549049
              ],
              [
                59.03356,
                32.7510133
              ],
              [
                59.0341202,
                32.7510133
              ],
              [
                59.0343932,
                32.7507334
              ],
              [
                59.0482865,
                32.7507333
              ],
              [
                59.0491197,
                32.7510132
              ],
              [
                59.0693994,
                32.7510132
              ],
              [
                59.0696728,
                32.7512931
              ],
              [
                59.0768996,
                32.7512931
              ],
              [
                59.0771726,
                32.751573
              ],
              [
                59.0813391,
                32.7526836
              ],
              [
                59.0830059,
                32.754345
              ],
              [
                59.0841192,
                32.7554555
              ],
              [
                59.0971723,
                32.7737851
              ],
              [
                59.0988391,
                32.7754555
              ],
              [
                59.0999524,
                32.7760154
              ],
              [
                59.1135656,
                32.7829589
              ],
              [
                59.1163458,
                32.7832298
              ],
              [
                59.1216188,
                32.7832298
              ],
              [
                59.1257853,
                32.7832297
              ],
              [
                59.1318987,
                32.782679
              ],
              [
                59.1349519,
                32.782679
              ],
              [
                59.1357851,
                32.7823991
              ],
              [
                59.1585648,
                32.7796269
              ],
              [
                59.1610649,
                32.779627
              ],
              [
                59.1621783,
                32.779347
              ],
              [
                59.1680116,
                32.7793471
              ],
              [
                59.1691249,
                32.7790671
              ],
              [
                59.1716249,
                32.7790672
              ],
              [
                59.1727315,
                32.7787873
              ],
              [
                59.1780113,
                32.7787872
              ],
              [
                59.1791246,
                32.7785074
              ],
              [
                59.1857912,
                32.7779565
              ],
              [
                59.1894045,
                32.7779565
              ],
              [
                59.189678,
                32.7776766
              ],
              [
                59.1955113,
                32.7776766
              ],
              [
                59.1988445,
                32.7774057
              ],
              [
                59.1996777,
                32.7774057
              ],
              [
                59.2007911,
                32.7771258
              ],
              [
                59.2021779,
                32.7771257
              ],
              [
                59.2032911,
                32.7768458
              ],
              [
                59.2046775,
                32.7768459
              ],
              [
                59.205511,
                32.776566
              ],
              [
                59.2294041,
                32.770733
              ],
              [
                59.2302373,
                32.7701822
              ],
              [
                59.2435704,
                32.7637894
              ],
              [
                59.2516237,
                32.7585162
              ],
              [
                59.2616305,
                32.7487916
              ],
              [
                59.26357,
                32.7468503
              ],
              [
                59.2646837,
                32.7454598
              ],
              [
                59.2813499,
                32.7315726
              ],
              [
                59.3035761,
                32.7076808
              ],
              [
                59.3055159,
                32.7060103
              ],
              [
                59.3094095,
                32.7026786
              ],
              [
                59.3733203,
                32.6509919
              ],
              [
                59.3863329,
                32.6540641
              ],
              [
                59.3943714,
                32.6559611
              ],
              [
                59.41199,
                32.6809424
              ],
              [
                59.4579899,
                32.7016489
              ],
              [
                59.471021,
                32.7253052
              ],
              [
                59.4923399,
                32.7302526
              ],
              [
                59.4935232,
                32.7458187
              ],
              [
                59.494213,
                32.7554807
              ],
              [
                59.4962881,
                32.7664911
              ],
              [
                59.4870638,
                32.7781522
              ],
              [
                59.4767187,
                32.7905938
              ],
              [
                59.4854735,
                32.8081977
              ],
              [
                59.4894721,
                32.8227827
              ],
              [
                59.489729,
                32.8458023
              ],
              [
                59.4898191,
                32.8697005
              ],
              [
                59.4958101,
                32.868888
              ],
              [
                59.5116137,
                32.8653884
              ],
              [
                59.5264362,
                32.8587351
              ],
              [
                59.5292472,
                32.8617993
              ],
              [
                59.5340537,
                32.8617092
              ],
              [
                59.5416926,
                32.8625022
              ],
              [
                59.578514,
                32.8874438
              ],
              [
                59.6249674,
                32.9071962
              ],
              [
                59.6427422,
                32.9093322
              ],
              [
                59.6657088,
                32.9180637
              ],
              [
                59.6682032,
                32.9354266
              ],
              [
                59.6677351,
                32.9359552
              ],
              [
                59.6600103,
                32.9365855
              ],
              [
                59.6504401,
                32.9368737
              ],
              [
                59.6431445,
                32.9505593
              ],
              [
                59.6425734,
                32.9554477
              ],
              [
                59.6345994,
                32.9631142
              ],
              [
                59.6155436,
                32.9725037
              ],
              [
                59.6100139,
                32.9774202
              ],
              [
                59.6022033,
                32.985988
              ],
              [
                59.5792223,
                32.9893208
              ],
              [
                59.5791461,
                32.9912839
              ],
              [
                59.5767429,
                33.0018248
              ],
              [
                59.5810977,
                33.0071291
              ],
              [
                59.5900153,
                33.0125502
              ],
              [
                59.597478,
                33.0309876
              ],
              [
                59.6027183,
                33.0432775
              ],
              [
                59.605894,
                33.0446265
              ],
              [
                59.6023004,
                33.0453453
              ],
              [
                59.6015764,
                33.0468418
              ],
              [
                59.5964312,
                33.0463892
              ],
              [
                59.58619,
                33.0479989
              ],
              [
                59.5816897,
                33.0506879
              ],
              [
                59.5743603,
                33.0574958
              ],
              [
                59.5712955,
                33.0612432
              ],
              [
                59.5696735,
                33.0675208
              ],
              [
                59.5646279,
                33.0678208
              ],
              [
                59.5618629,
                33.0714768
              ],
              [
                59.5644378,
                33.0797478
              ],
              [
                59.5705318,
                33.094346
              ],
              [
                59.5574855,
                33.1105235
              ],
              [
                59.5518207,
                33.1116019
              ],
              [
                59.5401477,
                33.1041967
              ],
              [
                59.5292876,
                33.0989414
              ],
              [
                59.5203208,
                33.0934831
              ],
              [
                59.5179538,
                33.0931407
              ],
              [
                59.5117377,
                33.0913978
              ],
              [
                59.5071887,
                33.0901034
              ],
              [
                59.5063304,
                33.0984446
              ],
              [
                59.5078754,
                33.1075758
              ],
              [
                59.5065879,
                33.1103078
              ],
              [
                59.502968,
                33.1110461
              ],
              [
                59.4991837,
                33.1115815
              ],
              [
                59.4883333,
                33.1103273
              ],
              [
                59.4819843,
                33.1086659
              ],
              [
                59.4705462,
                33.1037694
              ],
              [
                59.4624623,
                33.124538
              ],
              [
                59.5004791,
                33.1263391
              ],
              [
                59.501953,
                33.1323045
              ],
              [
                59.503944,
                33.1365853
              ],
              [
                59.5109674,
                33.1396232
              ],
              [
                59.5210322,
                33.1449741
              ],
              [
                59.525518,
                33.1525535
              ],
              [
                59.5181365,
                33.1645133
              ],
              [
                59.5180281,
                33.1721304
              ],
              [
                59.5185598,
                33.1808009
              ],
              [
                59.5181119,
                33.1887181
              ],
              [
                59.5021364,
                33.1960928
              ],
              [
                59.50683,
                33.204483
              ],
              [
                59.5109879,
                33.2114896
              ],
              [
                59.5022308,
                33.2136201
              ],
              [
                59.5093908,
                33.2236913
              ],
              [
                59.5278973,
                33.2247074
              ],
              [
                59.5473311,
                33.2238457
              ],
              [
                59.5755581,
                33.2320968
              ],
              [
                59.5785934,
                33.2326378
              ],
              [
                59.5855255,
                33.2346407
              ],
              [
                59.5899862,
                33.2360047
              ],
              [
                59.5990951,
                33.2393655
              ],
              [
                59.6079111,
                33.2425999
              ],
              [
                59.647073,
                33.2441452
              ],
              [
                59.6475649,
                33.2454354
              ],
              [
                59.6487838,
                33.2467221
              ],
              [
                59.6495604,
                33.249186
              ],
              [
                59.6502226,
                33.2512907
              ],
              [
                59.6519208,
                33.2540848
              ],
              [
                59.6535223,
                33.2589883
              ],
              [
                59.6572559,
                33.2690394
              ],
              [
                59.6580521,
                33.2700745
              ],
              [
                59.6589963,
                33.2750671
              ],
              [
                59.6595841,
                33.2784444
              ],
              [
                59.6475218,
                33.2909339
              ],
              [
                59.6358488,
                33.3008342
              ],
              [
                59.6313856,
                33.3147501
              ],
              [
                59.6221159,
                33.3300981
              ],
              [
                59.6187716,
                33.3365584
              ],
              [
                59.6155959,
                33.3434282
              ],
              [
                59.6116403,
                33.3559862
              ],
              [
                59.609971,
                33.3630535
              ],
              [
                59.6241098,
                33.3864725
              ],
              [
                59.6146529,
                33.3914753
              ],
              [
                59.6058562,
                33.3945129
              ],
              [
                59.598519,
                33.3998701
              ],
              [
                59.5658729,
                33.4201382
              ],
              [
                59.5612608,
                33.4204538
              ],
              [
                59.5500035,
                33.4229362
              ],
              [
                59.5368139,
                33.4248493
              ],
              [
                59.5356845,
                33.4262839
              ],
              [
                59.5289437,
                33.4304144
              ],
              [
                59.5343542,
                33.433447
              ],
              [
                59.5373823,
                33.4348309
              ],
              [
                59.5520782,
                33.4438682
              ],
              [
                59.5456497,
                33.4492166
              ],
              [
                59.5378732,
                33.454145
              ],
              [
                59.5382051,
                33.4623227
              ],
              [
                59.5391444,
                33.4715694
              ],
              [
                59.5395282,
                33.4742455
              ],
              [
                59.5368853,
                33.4820936
              ],
              [
                59.5355774,
                33.4855526
              ],
              [
                59.5300197,
                33.4953473
              ],
              [
                59.5282641,
                33.4990573
              ],
              [
                59.5254707,
                33.5023257
              ],
              [
                59.5218229,
                33.5086953
              ],
              [
                59.5088625,
                33.5107349
              ],
              [
                59.499979,
                33.5144919
              ],
              [
                59.4980907,
                33.5145277
              ],
              [
                59.4968032,
                33.5158874
              ],
              [
                59.4945716,
                33.5061905
              ],
              [
                59.4910955,
                33.4929494
              ],
              [
                59.4870615,
                33.4803506
              ],
              [
                59.4867181,
                33.4783819
              ],
              [
                59.4840574,
                33.4738357
              ],
              [
                59.4828987,
                33.4667834
              ],
              [
                59.4709682,
                33.469182
              ],
              [
                59.449768,
                33.468287
              ],
              [
                59.4445967,
                33.4678574
              ],
              [
                59.4389534,
                33.4669266
              ],
              [
                59.4361638,
                33.4665328
              ],
              [
                59.4215297,
                33.465423
              ],
              [
                59.4211194,
                33.4626248
              ],
              [
                59.4200714,
                33.4550344
              ],
              [
                59.4180974,
                33.4460892
              ],
              [
                59.4241033,
                33.4444061
              ],
              [
                59.4304561,
                33.4420419
              ],
              [
                59.4398116,
                33.4202665
              ],
              [
                59.4293403,
                33.4131739
              ],
              [
                59.4013033,
                33.3936388
              ],
              [
                59.3877138,
                33.3836823
              ],
              [
                59.3728186,
                33.3725122
              ],
              [
                59.3661689,
                33.3670942
              ],
              [
                59.3586158,
                33.3594238
              ],
              [
                59.3391524,
                33.3464078
              ],
              [
                59.3253814,
                33.3405422
              ],
              [
                59.3163473,
                33.3391731
              ],
              [
                59.3173164,
                33.3020008
              ],
              [
                59.3176285,
                33.2874422
              ],
              [
                59.3183389,
                33.2796247
              ],
              [
                59.3146841,
                33.2751934
              ],
              [
                59.3085778,
                33.2710313
              ],
              [
                59.3077446,
                33.2701916
              ],
              [
                59.2991311,
                33.2665802
              ],
              [
                59.2977447,
                33.2663003
              ],
              [
                59.2971846,
                33.2660205
              ],
              [
                59.2941313,
                33.2660205
              ],
              [
                59.2932978,
                33.2660204
              ],
              [
                59.2932978,
                33.2663003
              ],
              [
                59.2927447,
                33.2663003
              ],
              [
                59.2910711,
                33.2663003
              ],
              [
                59.2732982,
                33.2618583
              ],
              [
                59.2716317,
                33.2615784
              ],
              [
                59.2691317,
                33.2615784
              ],
              [
                59.2674649,
                33.2612985
              ],
              [
                59.2666316,
                33.2615784
              ],
              [
                59.2649652,
                33.2615784
              ],
              [
                59.2635714,
                33.2612985
              ],
              [
                59.257465,
                33.2612985
              ],
              [
                59.2560716,
                33.2615785
              ],
              [
                59.251625,
                33.2615784
              ],
              [
                59.2502383,
                33.2618583
              ],
              [
                59.2432917,
                33.2618584
              ],
              [
                59.2416253,
                33.2621292
              ],
              [
                59.2285723,
                33.2618584
              ],
              [
                59.2202389,
                33.2621292
              ],
              [
                59.2119055,
                33.2626891
              ],
              [
                59.2105121,
                33.262969
              ],
              [
                59.2096789,
                33.262969
              ],
              [
                59.2080121,
                33.2632488
              ],
              [
                59.2060726,
                33.2632489
              ],
              [
                59.2049589,
                33.2635287
              ],
              [
                59.202739,
                33.2635287
              ],
              [
                59.1899594,
                33.26519
              ],
              [
                59.1824593,
                33.2668513
              ],
              [
                59.1463464,
                33.2718622
              ],
              [
                59.1416268,
                33.2721331
              ],
              [
                59.1388467,
                33.2726929
              ],
              [
                59.1330134,
                33.2732436
              ],
              [
                59.1230135,
                33.2751938
              ],
              [
                59.1130137,
                33.276855
              ],
              [
                59.112244,
                33.2771772
              ],
              [
                59.1002339,
                33.2790762
              ],
              [
                59.0994006,
                33.279365
              ],
              [
                59.0944005,
                33.2793651
              ],
              [
                59.0877339,
                33.2779657
              ],
              [
                59.0863405,
                33.2776949
              ],
              [
                59.0785674,
                33.2740834
              ],
              [
                59.0621741,
                33.2618587
              ],
              [
                59.0616209,
                33.2612989
              ],
              [
                59.0374547,
                33.2376891
              ],
              [
                59.0310612,
                33.2315766
              ],
              [
                58.9924483,
                33.1990734
              ],
              [
                58.9721686,
                33.1876881
              ],
              [
                58.934949,
                33.1738019
              ],
              [
                58.9205026,
                33.1693598
              ],
              [
                58.9171694,
                33.1688
              ],
              [
                58.9152224,
                33.1687999
              ],
              [
                58.9143892,
                33.1685201
              ],
              [
                58.9138361,
                33.1688
              ],
              [
                58.911336,
                33.1687999
              ],
              [
                58.9021695,
                33.1715808
              ],
              [
                58.9016093,
                33.1718518
              ],
              [
                58.900776,
                33.1724115
              ],
              [
                58.898276,
                33.1765828
              ],
              [
                58.8935564,
                33.1810249
              ],
              [
                58.8918896,
                33.1815757
              ],
              [
                58.8663297,
                33.1665789
              ],
              [
                58.8629964,
                33.1654684
              ],
              [
                58.86161,
                33.1654683
              ],
              [
                58.8577233,
                33.1643579
              ],
              [
                58.8557768,
                33.1643579
              ],
              [
                58.8554966,
                33.1646378
              ],
              [
                58.8546634,
                33.1646378
              ],
              [
                58.8424436,
                33.1724116
              ],
              [
                58.8418901,
                33.1729624
              ],
              [
                58.7854978,
                33.2271349
              ],
              [
                58.764665,
                33.2560267
              ],
              [
                58.7643849,
                33.2562976
              ],
              [
                58.7638314,
                33.2571372
              ],
              [
                58.7629916,
                33.2565774
              ],
              [
                58.7568847,
                33.2538057
              ],
              [
                58.7007723,
                33.2243633
              ],
              [
                58.6782659,
                33.2190816
              ],
              [
                58.6768792,
                33.2190816
              ],
              [
                58.6760459,
                33.2188017
              ],
              [
                58.6743791,
                33.2188016
              ],
              [
                58.674099,
                33.2185218
              ],
              [
                58.6597905,
                33.2217889
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555005,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خوسف",
          "name:en": "Khusf County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q6034225",
          "wikipedia": "en:Khusf County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.9200156,
                31.6931694
              ],
              [
                57.9205686,
                31.6928896
              ],
              [
                57.959747,
                31.6782196
              ],
              [
                57.9937359,
                31.6761744
              ],
              [
                58.0212781,
                31.6688824
              ],
              [
                58.0712434,
                31.6529389
              ],
              [
                58.0723572,
                31.6521082
              ],
              [
                58.1385158,
                31.627659
              ],
              [
                58.1415761,
                31.6259887
              ],
              [
                58.2238615,
                31.5943506
              ],
              [
                58.2288615,
                31.5915793
              ],
              [
                58.2793405,
                31.5689739
              ],
              [
                58.2804538,
                31.5687031
              ],
              [
                58.3043401,
                31.553141
              ],
              [
                58.3090669,
                31.54981
              ],
              [
                58.3353417,
                31.5352382
              ],
              [
                58.3734397,
                31.4800577
              ],
              [
                58.3764929,
                31.4778278
              ],
              [
                58.3834395,
                31.4728265
              ],
              [
                58.4527574,
                31.4063972
              ],
              [
                58.573467,
                31.3369975
              ],
              [
                58.5737405,
                31.3367174
              ],
              [
                58.5880535,
                31.3353187
              ],
              [
                58.6235612,
                31.3545171
              ],
              [
                58.6375522,
                31.3638247
              ],
              [
                58.6585807,
                31.372619
              ],
              [
                58.6737727,
                31.3819254
              ],
              [
                58.6941998,
                31.3895462
              ],
              [
                58.7134259,
                31.4004626
              ],
              [
                58.730592,
                31.4055175
              ],
              [
                58.7436389,
                31.4131353
              ],
              [
                58.7789147,
                31.4359873
              ],
              [
                58.7884425,
                31.4336433
              ],
              [
                58.7997722,
                31.4330574
              ],
              [
                58.8195991,
                31.4583201
              ],
              [
                58.8208865,
                31.4624933
              ],
              [
                58.8286106,
                31.4724501
              ],
              [
                58.8555621,
                31.4780861
              ],
              [
                58.8731574,
                31.482112
              ],
              [
                58.8826846,
                31.4830636
              ],
              [
                58.9007091,
                31.485479
              ],
              [
                58.9422511,
                31.4968234
              ],
              [
                58.9428519,
                31.517752
              ],
              [
                58.9452552,
                31.5366277
              ],
              [
                58.9558982,
                31.5500139
              ],
              [
                58.9814757,
                31.5647877
              ],
              [
                58.9919471,
                31.57349
              ],
              [
                58.9982986,
                31.5772193
              ],
              [
                59.0216445,
                31.5777312
              ],
              [
                59.0317725,
                31.5889181
              ],
              [
                59.0217301,
                31.5982033
              ],
              [
                59.026966,
                31.6077794
              ],
              [
                59.0309998,
                31.6185244
              ],
              [
                59.0515994,
                31.6304371
              ],
              [
                59.0854161,
                31.6736911
              ],
              [
                59.1189759,
                31.692097
              ],
              [
                59.1270439,
                31.7034892
              ],
              [
                59.1218944,
                31.716048
              ],
              [
                59.1158863,
                31.7353215
              ],
              [
                59.1321942,
                31.754299
              ],
              [
                59.1416357,
                31.757802
              ],
              [
                59.1488453,
                31.7826121
              ],
              [
                59.1399189,
                31.7951604
              ],
              [
                59.1478154,
                31.8030388
              ],
              [
                59.1521071,
                31.8136879
              ],
              [
                59.1699599,
                31.818064
              ],
              [
                59.1929623,
                31.8263052
              ],
              [
                59.2079401,
                31.8235154
              ],
              [
                59.2110944,
                31.8244088
              ],
              [
                59.2168879,
                31.828128
              ],
              [
                59.2153641,
                31.8301701
              ],
              [
                59.2102143,
                31.8356392
              ],
              [
                59.2126175,
                31.846066
              ],
              [
                59.2356201,
                31.868957
              ],
              [
                59.2374229,
                31.8889272
              ],
              [
                59.2371652,
                31.9028457
              ],
              [
                59.2371271,
                31.9206385
              ],
              [
                59.2276048,
                31.9247431
              ],
              [
                59.210809,
                31.9323484
              ],
              [
                59.1985137,
                31.93593
              ],
              [
                59.1914531,
                31.9651725
              ],
              [
                59.187944,
                31.9898106
              ],
              [
                59.2060088,
                31.9949743
              ],
              [
                59.2159652,
                31.9985411
              ],
              [
                59.2399119,
                32.0072754
              ],
              [
                59.2387961,
                32.0117151
              ],
              [
                59.2351052,
                32.0184107
              ],
              [
                59.2310711,
                32.0532629
              ],
              [
                59.2293579,
                32.0627784
              ],
              [
                59.2289732,
                32.0688245
              ],
              [
                59.2371628,
                32.0925326
              ],
              [
                59.2699727,
                32.091431
              ],
              [
                59.2799692,
                32.0882533
              ],
              [
                59.2982768,
                32.0851199
              ],
              [
                59.3046274,
                32.0849331
              ],
              [
                59.3217944,
                32.0865016
              ],
              [
                59.346342,
                32.0865743
              ],
              [
                59.3508052,
                32.0871561
              ],
              [
                59.3562984,
                32.0958092
              ],
              [
                59.3558692,
                32.0995175
              ],
              [
                59.3545817,
                32.1007536
              ],
              [
                59.3513202,
                32.1027167
              ],
              [
                59.3490886,
                32.1053341
              ],
              [
                59.3512344,
                32.1074425
              ],
              [
                59.3568133,
                32.1109322
              ],
              [
                59.3613624,
                32.1132586
              ],
              [
                59.3641948,
                32.1155122
              ],
              [
                59.3676279,
                32.1202374
              ],
              [
                59.3621348,
                32.1232904
              ],
              [
                59.3556116,
                32.1260526
              ],
              [
                59.3011237,
                32.1358091
              ],
              [
                59.3091772,
                32.1695099
              ],
              [
                59.2955451,
                32.2031727
              ],
              [
                59.2930451,
                32.2056737
              ],
              [
                59.2821817,
                32.2185033
              ],
              [
                59.2758749,
                32.2341487
              ],
              [
                59.2660687,
                32.242106
              ],
              [
                59.2652354,
                32.2440564
              ],
              [
                59.2635686,
                32.2465575
              ],
              [
                59.251894,
                32.2618724
              ],
              [
                59.2503554,
                32.2640419
              ],
              [
                59.2500823,
                32.2646019
              ],
              [
                59.2327361,
                32.2943321
              ],
              [
                59.2299559,
                32.3021154
              ],
              [
                59.2294028,
                32.3040567
              ],
              [
                59.2238497,
                32.3465581
              ],
              [
                59.2235697,
                32.3535017
              ],
              [
                59.2232896,
                32.3540616
              ],
              [
                59.2232896,
                32.3579441
              ],
              [
                59.2243063,
                32.3588556
              ],
              [
                59.2313495,
                32.3651677
              ],
              [
                59.2330164,
                32.3665582
              ],
              [
                59.2371829,
                32.3704499
              ],
              [
                59.2535691,
                32.3829466
              ],
              [
                59.2546829,
                32.3860076
              ],
              [
                59.2546829,
                32.3910008
              ],
              [
                59.2541294,
                32.3943417
              ],
              [
                59.2469027,
                32.4126715
              ],
              [
                59.2457894,
                32.4151726
              ],
              [
                59.2427363,
                32.4329516
              ],
              [
                59.2441231,
                32.4393355
              ],
              [
                59.2460696,
                32.4440669
              ],
              [
                59.249683,
                32.4485094
              ],
              [
                59.2652361,
                32.4596155
              ],
              [
                59.2655161,
                32.4598954
              ],
              [
                59.2680162,
                32.4618368
              ],
              [
                59.2969089,
                32.4854487
              ],
              [
                59.2977426,
                32.4868392
              ],
              [
                59.2982957,
                32.4871191
              ],
              [
                59.3007958,
                32.4926722
              ],
              [
                59.3010759,
                32.493503
              ],
              [
                59.3013489,
                32.4971147
              ],
              [
                59.301629,
                32.4990651
              ],
              [
                59.3019092,
                32.5012863
              ],
              [
                59.3021821,
                32.5043383
              ],
              [
                59.3024623,
                32.5068395
              ],
              [
                59.3021822,
                32.5093406
              ],
              [
                59.301629,
                32.522957
              ],
              [
                59.3002424,
                32.5512823
              ],
              [
                59.2999623,
                32.5521221
              ],
              [
                59.3002425,
                32.5571154
              ],
              [
                59.2999624,
                32.5660093
              ],
              [
                59.298576,
                32.5776754
              ],
              [
                59.2988491,
                32.5785061
              ],
              [
                59.2988492,
                32.578786
              ],
              [
                59.2988491,
                32.5804564
              ],
              [
                59.2988491,
                32.5829576
              ],
              [
                59.2994093,
                32.5851698
              ],
              [
                59.2994093,
                32.5879679
              ],
              [
                59.2994093,
                32.5910119
              ],
              [
                59.2996828,
                32.5918426
              ],
              [
                59.2999624,
                32.5946236
              ],
              [
                59.3002426,
                32.5976756
              ],
              [
                59.3010762,
                32.6021181
              ],
              [
                59.3013492,
                32.6032287
              ],
              [
                59.3019094,
                32.605179
              ],
              [
                59.3035758,
                32.6098924
              ],
              [
                59.3130158,
                32.6243394
              ],
              [
                59.3141292,
                32.6257299
              ],
              [
                59.3230157,
                32.6318428
              ],
              [
                59.3232958,
                32.6321228
              ],
              [
                59.324129,
                32.6321228
              ],
              [
                59.3249623,
                32.6326736
              ],
              [
                59.3257959,
                32.6326736
              ],
              [
                59.3613552,
                32.6482312
              ],
              [
                59.3705218,
                32.6510122
              ],
              [
                59.3733203,
                32.6509919
              ],
              [
                59.3094095,
                32.7026786
              ],
              [
                59.3055159,
                32.7060103
              ],
              [
                59.3035761,
                32.7076808
              ],
              [
                59.2813499,
                32.7315726
              ],
              [
                59.2646837,
                32.7454598
              ],
              [
                59.26357,
                32.7468503
              ],
              [
                59.2616305,
                32.7487916
              ],
              [
                59.2516237,
                32.7585162
              ],
              [
                59.2435704,
                32.7637894
              ],
              [
                59.2302373,
                32.7701822
              ],
              [
                59.2294041,
                32.770733
              ],
              [
                59.205511,
                32.776566
              ],
              [
                59.2046775,
                32.7768459
              ],
              [
                59.2032911,
                32.7768458
              ],
              [
                59.2021779,
                32.7771257
              ],
              [
                59.2007911,
                32.7771258
              ],
              [
                59.1996777,
                32.7774057
              ],
              [
                59.1988445,
                32.7774057
              ],
              [
                59.1955113,
                32.7776766
              ],
              [
                59.189678,
                32.7776766
              ],
              [
                59.1894045,
                32.7779565
              ],
              [
                59.1857912,
                32.7779565
              ],
              [
                59.1791246,
                32.7785074
              ],
              [
                59.1780113,
                32.7787872
              ],
              [
                59.1727315,
                32.7787873
              ],
              [
                59.1716249,
                32.7790672
              ],
              [
                59.1691249,
                32.7790671
              ],
              [
                59.1680116,
                32.7793471
              ],
              [
                59.1621783,
                32.779347
              ],
              [
                59.1610649,
                32.779627
              ],
              [
                59.1585648,
                32.7796269
              ],
              [
                59.1357851,
                32.7823991
              ],
              [
                59.1349519,
                32.782679
              ],
              [
                59.1318987,
                32.782679
              ],
              [
                59.1257853,
                32.7832297
              ],
              [
                59.1216188,
                32.7832298
              ],
              [
                59.1163458,
                32.7832298
              ],
              [
                59.1135656,
                32.7829589
              ],
              [
                59.0999524,
                32.7760154
              ],
              [
                59.0988391,
                32.7754555
              ],
              [
                59.0971723,
                32.7737851
              ],
              [
                59.0841192,
                32.7554555
              ],
              [
                59.0830059,
                32.754345
              ],
              [
                59.0813391,
                32.7526836
              ],
              [
                59.0771726,
                32.751573
              ],
              [
                59.0768996,
                32.7512931
              ],
              [
                59.0696728,
                32.7512931
              ],
              [
                59.0693994,
                32.7510132
              ],
              [
                59.0491197,
                32.7510132
              ],
              [
                59.0482865,
                32.7507333
              ],
              [
                59.0343932,
                32.7507334
              ],
              [
                59.0341202,
                32.7510133
              ],
              [
                59.03356,
                32.7510133
              ],
              [
                59.0305069,
                32.7549049
              ],
              [
                59.0305068,
                32.7551758
              ],
              [
                59.0302268,
                32.7554558
              ],
              [
                59.0130069,
                32.7810178
              ],
              [
                59.0085605,
                32.7982368
              ],
              [
                59.0099471,
                32.8012886
              ],
              [
                59.0182801,
                32.8099025
              ],
              [
                59.0185602,
                32.8104624
              ],
              [
                59.0188404,
                32.8107333
              ],
              [
                59.0218936,
                32.8137942
              ],
              [
                59.0282871,
                32.8232388
              ],
              [
                59.0282871,
                32.8237896
              ],
              [
                59.0288402,
                32.8243494
              ],
              [
                59.0299536,
                32.8274013
              ],
              [
                59.030507,
                32.8279611
              ],
              [
                59.0368935,
                32.8487916
              ],
              [
                59.0371737,
                32.8510128
              ],
              [
                59.0374538,
                32.8546246
              ],
              [
                59.0377268,
                32.8596268
              ],
              [
                59.0380068,
                32.8632385
              ],
              [
                59.038287,
                32.8649089
              ],
              [
                59.03856,
                32.8685116
              ],
              [
                59.0385601,
                32.8715725
              ],
              [
                59.03856,
                32.8737936
              ],
              [
                59.0391202,
                32.8771254
              ],
              [
                59.0371738,
                32.9193551
              ],
              [
                59.0366203,
                32.9243482
              ],
              [
                59.0366203,
                32.924908
              ],
              [
                59.0366203,
                32.9265694
              ],
              [
                59.0368937,
                32.9271292
              ],
              [
                59.0366202,
                32.92768
              ],
              [
                59.0368938,
                32.92796
              ],
              [
                59.0363402,
                32.9379552
              ],
              [
                59.0357871,
                32.9410161
              ],
              [
                59.0241139,
                32.9687988
              ],
              [
                59.0146743,
                32.9999041
              ],
              [
                59.0049477,
                33.0279665
              ],
              [
                59.0049476,
                33.0287971
              ],
              [
                59.0043946,
                33.0299077
              ],
              [
                59.0038411,
                33.0329596
              ],
              [
                59.0032809,
                33.0340791
              ],
              [
                59.0021746,
                33.0410135
              ],
              [
                58.9996747,
                33.0446341
              ],
              [
                58.9989783,
                33.0450489
              ],
              [
                58.9988413,
                33.0454648
              ],
              [
                58.9985612,
                33.0454648
              ],
              [
                58.9891146,
                33.0401918
              ],
              [
                58.9885615,
                33.0399119
              ],
              [
                58.9760616,
                33.0337992
              ],
              [
                58.9702283,
                33.0321289
              ],
              [
                58.9641148,
                33.0321289
              ],
              [
                58.9577285,
                33.0335194
              ],
              [
                58.9477216,
                33.0382416
              ],
              [
                58.9468884,
                33.0382416
              ],
              [
                58.9441152,
                33.0393522
              ],
              [
                58.9396687,
                33.0404628
              ],
              [
                58.9374487,
                33.0412935
              ],
              [
                58.9291154,
                33.0454649
              ],
              [
                58.9235555,
                33.0499071
              ],
              [
                58.9227223,
                33.0537987
              ],
              [
                58.9216156,
                33.0557399
              ],
              [
                58.9196688,
                33.0568505
              ],
              [
                58.9193891,
                33.0571304
              ],
              [
                58.9182824,
                33.0571304
              ],
              [
                58.9180023,
                33.0574103
              ],
              [
                58.9168889,
                33.0574103
              ],
              [
                58.9166155,
                33.0576901
              ],
              [
                58.9135557,
                33.0576902
              ],
              [
                58.9130022,
                33.0579701
              ],
              [
                58.9118889,
                33.0576902
              ],
              [
                58.9096689,
                33.0576902
              ],
              [
                58.8913361,
                33.0540786
              ],
              [
                58.8905026,
                33.0537986
              ],
              [
                58.8877227,
                33.052959
              ],
              [
                58.8646629,
                33.0451851
              ],
              [
                58.8635563,
                33.0451851
              ],
              [
                58.8546631,
                33.0426841
              ],
              [
                58.8499431,
                33.0421334
              ],
              [
                58.8488298,
                33.0418534
              ],
              [
                58.8435567,
                33.0418534
              ],
              [
                58.8427235,
                33.0421333
              ],
              [
                58.8402234,
                33.0421333
              ],
              [
                58.8307767,
                33.0446344
              ],
              [
                58.8296634,
                33.0446344
              ],
              [
                58.8268832,
                33.0454651
              ],
              [
                58.8141103,
                33.0512978
              ],
              [
                58.8010504,
                33.0543497
              ],
              [
                58.8002171,
                33.0546296
              ],
              [
                58.7985503,
                33.0546296
              ],
              [
                58.7960506,
                33.0551894
              ],
              [
                58.7943838,
                33.0551894
              ],
              [
                58.7888306,
                33.0562999
              ],
              [
                58.786604,
                33.0565799
              ],
              [
                58.7793839,
                33.0579703
              ],
              [
                58.7757706,
                33.0582412
              ],
              [
                58.7749374,
                33.0585211
              ],
              [
                58.7710509,
                33.0585211
              ],
              [
                58.7693841,
                33.058801
              ],
              [
                58.7649375,
                33.058801
              ],
              [
                58.7429911,
                33.0618529
              ],
              [
                58.7352183,
                33.0660243
              ],
              [
                58.7324382,
                33.0687962
              ],
              [
                58.7326981,
                33.0762923
              ],
              [
                58.7193456,
                33.0931287
              ],
              [
                58.7213251,
                33.1060226
              ],
              [
                58.7210449,
                33.1063024
              ],
              [
                58.7168781,
                33.1132457
              ],
              [
                58.7127116,
                33.1179678
              ],
              [
                58.6985454,
                33.1288025
              ],
              [
                58.6974388,
                33.1293533
              ],
              [
                58.6971586,
                33.1299131
              ],
              [
                58.6960454,
                33.1304729
              ],
              [
                58.6888254,
                33.1382468
              ],
              [
                58.6821588,
                33.1493613
              ],
              [
                58.6707656,
                33.1788043
              ],
              [
                58.6704926,
                33.1796349
              ],
              [
                58.6685458,
                33.1851876
              ],
              [
                58.665766,
                33.203805
              ],
              [
                58.6599327,
                33.2137998
              ],
              [
                58.6599327,
                33.2143595
              ],
              [
                58.6597905,
                33.2217889
              ],
              [
                58.647065,
                33.2185651
              ],
              [
                58.6365984,
                33.2148671
              ],
              [
                58.6269425,
                33.210889
              ],
              [
                58.6121702,
                33.2087032
              ],
              [
                58.6051939,
                33.209824
              ],
              [
                58.5964886,
                33.2088025
              ],
              [
                58.5787581,
                33.2049407
              ],
              [
                58.5708616,
                33.2043661
              ],
              [
                58.5607336,
                33.2017807
              ],
              [
                58.547344,
                33.196466
              ],
              [
                58.4942857,
                33.2259255
              ],
              [
                58.4736277,
                33.2262275
              ],
              [
                58.432867,
                33.221675
              ],
              [
                58.4085408,
                33.2204603
              ],
              [
                58.3948746,
                33.2251485
              ],
              [
                58.3823773,
                33.237252
              ],
              [
                58.3734509,
                33.2628054
              ],
              [
                58.3535382,
                33.2897861
              ],
              [
                58.3440882,
                33.2957945
              ],
              [
                58.2883732,
                33.3053274
              ],
              [
                58.2493908,
                33.3069321
              ],
              [
                58.1909024,
                33.3143013
              ],
              [
                58.1695172,
                33.3176193
              ],
              [
                58.1434246,
                33.3199144
              ],
              [
                58.1142724,
                33.3254793
              ],
              [
                58.0948796,
                33.3279654
              ],
              [
                58.0814551,
                33.3289507
              ],
              [
                58.0697821,
                33.3222093
              ],
              [
                58.0489256,
                33.2987606
              ],
              [
                58.0328593,
                33.2775468
              ],
              [
                58.0206261,
                33.2616232
              ],
              [
                58.0160866,
                33.248625
              ],
              [
                58.0104384,
                33.2327541
              ],
              [
                58.0110739,
                33.2102549
              ],
              [
                58.0212945,
                33.1764875
              ],
              [
                58.0276077,
                33.1616952
              ],
              [
                58.0496436,
                33.1129992
              ],
              [
                58.0548474,
                33.0636368
              ],
              [
                58.0572506,
                33.0198914
              ],
              [
                58.0610272,
                32.9813084
              ],
              [
                58.0654904,
                32.922826
              ],
              [
                58.067207,
                32.8839123
              ],
              [
                58.061159,
                32.8587543
              ],
              [
                58.0627148,
                32.8531868
              ],
              [
                58.0631732,
                32.8486588
              ],
              [
                58.063259,
                32.8428179
              ],
              [
                58.0652331,
                32.8395728
              ],
              [
                58.0725288,
                32.8360392
              ],
              [
                58.084545,
                32.8363998
              ],
              [
                58.0929659,
                32.8386537
              ],
              [
                58.1070169,
                32.8393525
              ],
              [
                58.12128,
                32.8266639
              ],
              [
                58.1375882,
                32.8040136
              ],
              [
                58.1471154,
                32.7961497
              ],
              [
                58.1496905,
                32.7910988
              ],
              [
                58.1520077,
                32.7786156
              ],
              [
                58.155784,
                32.7722652
              ],
              [
                58.1629082,
                32.7677904
              ],
              [
                58.1719206,
                32.7573968
              ],
              [
                58.1628221,
                32.7384838
              ],
              [
                58.149433,
                32.7347291
              ],
              [
                58.1401627,
                32.7173999
              ],
              [
                58.1401632,
                32.7096002
              ],
              [
                58.1387895,
                32.7049785
              ],
              [
                58.144369,
                32.6926991
              ],
              [
                58.1513212,
                32.68562
              ],
              [
                58.1587028,
                32.6834527
              ],
              [
                58.173465,
                32.6766624
              ],
              [
                58.1875633,
                32.6631507
              ],
              [
                58.1805038,
                32.6571893
              ],
              [
                58.1774996,
                32.6560693
              ],
              [
                58.1475442,
                32.5980238
              ],
              [
                58.1307214,
                32.5514441
              ],
              [
                58.1062394,
                32.525819
              ],
              [
                58.126542,
                32.5060658
              ],
              [
                58.138677,
                32.4944577
              ],
              [
                58.141177,
                32.4905664
              ],
              [
                58.1569648,
                32.4691855
              ],
              [
                58.157245,
                32.4675245
              ],
              [
                58.1583583,
                32.4636335
              ],
              [
                58.1591914,
                32.4561314
              ],
              [
                58.1591914,
                32.4450183
              ],
              [
                58.1586312,
                32.4405766
              ],
              [
                58.1658996,
                32.3973549
              ],
              [
                58.1658996,
                32.3887404
              ],
              [
                58.1658996,
                32.3851375
              ],
              [
                58.1884001,
                32.3737277
              ],
              [
                58.1949232,
                32.3606785
              ],
              [
                58.20206,
                32.3581562
              ],
              [
                58.2017799,
                32.3575964
              ],
              [
                58.2350189,
                32.329887
              ],
              [
                58.2297988,
                32.3216481
              ],
              [
                58.2302019,
                32.255339
              ],
              [
                58.2299218,
                32.2547882
              ],
              [
                58.1597457,
                32.2018472
              ],
              [
                58.156966,
                32.1985173
              ],
              [
                58.1529724,
                32.1760481
              ],
              [
                58.1479657,
                32.1677188
              ],
              [
                58.1299126,
                32.1321817
              ],
              [
                58.1296324,
                32.1319019
              ],
              [
                58.1153863,
                32.1142288
              ],
              [
                58.1134398,
                32.1111696
              ],
              [
                58.1163459,
                32.085372
              ],
              [
                58.1157858,
                32.0850922
              ],
              [
                58.1155123,
                32.0845419
              ],
              [
                58.1107856,
                32.079823
              ],
              [
                58.1096789,
                32.0792636
              ],
              [
                58.0988459,
                32.0709358
              ],
              [
                58.0971795,
                32.0692666
              ],
              [
                58.0957858,
                32.0678861
              ],
              [
                58.0952326,
                32.0678862
              ],
              [
                58.0943994,
                32.0667673
              ],
              [
                58.0924524,
                32.0651072
              ],
              [
                58.0784395,
                32.0446976
              ],
              [
                58.0726258,
                32.0207895
              ],
              [
                58.0511225,
                31.9902322
              ],
              [
                58.0715046,
                31.9258013
              ],
              [
                58.0712315,
                31.9246823
              ],
              [
                58.0592848,
                31.9058025
              ],
              [
                58.0587317,
                31.9047016
              ],
              [
                58.0366509,
                31.8933002
              ],
              [
                58.0393914,
                31.8680499
              ],
              [
                57.9706,
                31.8093865
              ],
              [
                57.9419868,
                31.7663345
              ],
              [
                57.9417068,
                31.7652242
              ],
              [
                57.9389336,
                31.7580022
              ],
              [
                57.9389336,
                31.7568919
              ],
              [
                57.9386536,
                31.7563321
              ],
              [
                57.9364007,
                31.7299198
              ],
              [
                57.9211289,
                31.6951105
              ],
              [
                57.9200875,
                31.6932948
              ],
              [
                57.9200156,
                31.6931694
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555012,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان درمیان",
          "name:en": "Darmian County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286121",
          "wikipedia": "en:Darmian County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.4624623,
                33.124538
              ],
              [
                59.4705462,
                33.1037694
              ],
              [
                59.4819843,
                33.1086659
              ],
              [
                59.4883333,
                33.1103273
              ],
              [
                59.4991837,
                33.1115815
              ],
              [
                59.502968,
                33.1110461
              ],
              [
                59.5065879,
                33.1103078
              ],
              [
                59.5078754,
                33.1075758
              ],
              [
                59.5063304,
                33.0984446
              ],
              [
                59.5071887,
                33.0901034
              ],
              [
                59.5117377,
                33.0913978
              ],
              [
                59.5179538,
                33.0931407
              ],
              [
                59.5203208,
                33.0934831
              ],
              [
                59.5292876,
                33.0989414
              ],
              [
                59.5401477,
                33.1041967
              ],
              [
                59.5518207,
                33.1116019
              ],
              [
                59.5574855,
                33.1105235
              ],
              [
                59.5705318,
                33.094346
              ],
              [
                59.5644378,
                33.0797478
              ],
              [
                59.5618629,
                33.0714768
              ],
              [
                59.5646279,
                33.0678208
              ],
              [
                59.5696735,
                33.0675208
              ],
              [
                59.5712955,
                33.0612432
              ],
              [
                59.5743603,
                33.0574958
              ],
              [
                59.5816897,
                33.0506879
              ],
              [
                59.58619,
                33.0479989
              ],
              [
                59.5964312,
                33.0463892
              ],
              [
                59.6015764,
                33.0468418
              ],
              [
                59.6023004,
                33.0453453
              ],
              [
                59.605894,
                33.0446265
              ],
              [
                59.6027183,
                33.0432775
              ],
              [
                59.597478,
                33.0309876
              ],
              [
                59.5900153,
                33.0125502
              ],
              [
                59.5810977,
                33.0071291
              ],
              [
                59.5767429,
                33.0018248
              ],
              [
                59.5791461,
                32.9912839
              ],
              [
                59.5792223,
                32.9893208
              ],
              [
                59.6022033,
                32.985988
              ],
              [
                59.6100139,
                32.9774202
              ],
              [
                59.6155436,
                32.9725037
              ],
              [
                59.6345994,
                32.9631142
              ],
              [
                59.6425734,
                32.9554477
              ],
              [
                59.6431445,
                32.9505593
              ],
              [
                59.6504401,
                32.9368737
              ],
              [
                59.6600103,
                32.9365855
              ],
              [
                59.6677351,
                32.9359552
              ],
              [
                59.6682032,
                32.9354266
              ],
              [
                59.6805374,
                32.9212791
              ],
              [
                59.6843446,
                32.9150565
              ],
              [
                59.6908583,
                32.9066599
              ],
              [
                59.7034557,
                32.9006264
              ],
              [
                59.7309676,
                32.8869959
              ],
              [
                59.7249126,
                32.8758154
              ],
              [
                59.7396751,
                32.8568973
              ],
              [
                59.7491668,
                32.8436544
              ],
              [
                59.7577633,
                32.8342674
              ],
              [
                59.7601408,
                32.8316038
              ],
              [
                59.7652372,
                32.8281815
              ],
              [
                59.7759263,
                32.8217145
              ],
              [
                59.7928576,
                32.8219571
              ],
              [
                59.8068236,
                32.801344
              ],
              [
                59.8277662,
                32.7898723
              ],
              [
                59.8472092,
                32.7715714
              ],
              [
                59.8485959,
                32.7704609
              ],
              [
                59.8662184,
                32.7560975
              ],
              [
                59.8794363,
                32.7420931
              ],
              [
                59.8884739,
                32.73168
              ],
              [
                59.9020707,
                32.7232133
              ],
              [
                59.9100054,
                32.7111626
              ],
              [
                59.9323158,
                32.7068175
              ],
              [
                59.9438398,
                32.7041669
              ],
              [
                59.962897,
                32.7001939
              ],
              [
                59.9686226,
                32.6985507
              ],
              [
                59.9822107,
                32.6957607
              ],
              [
                59.9877547,
                32.6957328
              ],
              [
                59.9953091,
                32.6942934
              ],
              [
                60.0026936,
                32.6937724
              ],
              [
                60.0113724,
                32.6918328
              ],
              [
                60.0208778,
                32.6902256
              ],
              [
                60.0255105,
                32.6895483
              ],
              [
                60.0305913,
                32.6885099
              ],
              [
                60.0374556,
                32.6862435
              ],
              [
                60.0409899,
                32.6854487
              ],
              [
                60.0495253,
                32.684284
              ],
              [
                60.0538933,
                32.6835976
              ],
              [
                60.0689428,
                32.6818374
              ],
              [
                60.0762992,
                32.6788034
              ],
              [
                60.0702461,
                32.6621315
              ],
              [
                60.083766,
                32.6632154
              ],
              [
                60.1006379,
                32.6642812
              ],
              [
                60.1111528,
                32.6631243
              ],
              [
                60.1140078,
                32.6683086
              ],
              [
                60.118333,
                32.6693291
              ],
              [
                60.1327789,
                32.6564581
              ],
              [
                60.1257404,
                32.6821733
              ],
              [
                60.1327401,
                32.6806806
              ],
              [
                60.13903,
                32.6762015
              ],
              [
                60.1462374,
                32.6688952
              ],
              [
                60.1441648,
                32.6912907
              ],
              [
                60.1455582,
                32.6915706
              ],
              [
                60.1536114,
                32.6915706
              ],
              [
                60.1691715,
                32.687399
              ],
              [
                60.1752778,
                32.684618
              ],
              [
                60.1833377,
                32.6773943
              ],
              [
                60.1836111,
                32.6765637
              ],
              [
                60.1869444,
                32.6712814
              ],
              [
                60.188891,
                32.666839
              ],
              [
                60.2252836,
                32.6012854
              ],
              [
                60.2366701,
                32.5860075
              ],
              [
                60.2508363,
                32.5707297
              ],
              [
                60.2530634,
                32.5685085
              ],
              [
                60.2533364,
                32.5679486
              ],
              [
                60.2544498,
                32.5671179
              ],
              [
                60.2658362,
                32.558233
              ],
              [
                60.2719497,
                32.5568423
              ],
              [
                60.2741762,
                32.5568424
              ],
              [
                60.2750094,
                32.5565625
              ],
              [
                60.2786161,
                32.5565625
              ],
              [
                60.2813959,
                32.5562826
              ],
              [
                60.2822295,
                32.5565624
              ],
              [
                60.288896,
                32.557673
              ],
              [
                60.2925094,
                32.5576731
              ],
              [
                60.3016759,
                32.5601742
              ],
              [
                60.3205622,
                32.5673977
              ],
              [
                60.3530685,
                32.5790636
              ],
              [
                60.3808983,
                32.5918584
              ],
              [
                60.435433,
                32.6169019
              ],
              [
                60.4486275,
                32.6229554
              ],
              [
                60.4514006,
                32.6248968
              ],
              [
                60.4572339,
                32.6285085
              ],
              [
                60.4733472,
                32.6354521
              ],
              [
                60.4986265,
                32.6396146
              ],
              [
                60.5008536,
                32.6396146
              ],
              [
                60.5022399,
                32.6398945
              ],
              [
                60.5041868,
                32.6398945
              ],
              [
                60.5055732,
                32.6401744
              ],
              [
                60.5136265,
                32.6401744
              ],
              [
                60.5150198,
                32.6398945
              ],
              [
                60.5241865,
                32.6398945
              ],
              [
                60.5255733,
                32.6396146
              ],
              [
                60.535573,
                32.638233
              ],
              [
                60.5386328,
                32.638233
              ],
              [
                60.5394664,
                32.637953
              ],
              [
                60.546406,
                32.6379531
              ],
              [
                60.5525194,
                32.6393436
              ],
              [
                60.5544659,
                32.6401743
              ],
              [
                60.5664056,
                32.6451766
              ],
              [
                60.6114121,
                32.6707297
              ],
              [
                60.6130785,
                32.6707297
              ],
              [
                60.613359,
                32.6704498
              ],
              [
                60.6144652,
                32.6704497
              ],
              [
                60.6239115,
                32.666558
              ],
              [
                60.6364117,
                32.6562826
              ],
              [
                60.6391914,
                32.6537814
              ],
              [
                60.6464111,
                32.6473976
              ],
              [
                60.6536378,
                32.6429551
              ],
              [
                60.6853039,
                32.6207246
              ],
              [
                60.7347501,
                32.5798934
              ],
              [
                60.7369696,
                32.578223
              ],
              [
                60.7375298,
                32.5779521
              ],
              [
                60.7397502,
                32.5760107
              ],
              [
                60.7411369,
                32.5754509
              ],
              [
                60.7422502,
                32.5746202
              ],
              [
                60.7764187,
                32.5593351
              ],
              [
                60.7478436,
                32.6185296
              ],
              [
                60.7095814,
                32.6958555
              ],
              [
                60.6886991,
                32.7817361
              ],
              [
                60.6649261,
                32.8776041
              ],
              [
                60.6541746,
                32.9214314
              ],
              [
                60.6337405,
                33.0039088
              ],
              [
                60.6294139,
                33.0212334
              ],
              [
                60.5978837,
                33.095297
              ],
              [
                60.5758543,
                33.0929629
              ],
              [
                60.5347462,
                33.0984439
              ],
              [
                60.5180556,
                33.0989776
              ],
              [
                60.5162143,
                33.0996309
              ],
              [
                60.487461,
                33.1006017
              ],
              [
                60.4590245,
                33.1023436
              ],
              [
                60.4450616,
                33.1019199
              ],
              [
                60.4281685,
                33.101201
              ],
              [
                60.4219435,
                33.100953
              ],
              [
                60.3930624,
                33.1042279
              ],
              [
                60.3835506,
                33.1034451
              ],
              [
                60.3759648,
                33.103157
              ],
              [
                60.3634377,
                33.1018228
              ],
              [
                60.3541051,
                33.1012644
              ],
              [
                60.3339805,
                33.0989317
              ],
              [
                60.3176879,
                33.0881618
              ],
              [
                60.3010042,
                33.0851096
              ],
              [
                60.2694251,
                33.0794839
              ],
              [
                60.2612204,
                33.0942425
              ],
              [
                60.2558222,
                33.1028783
              ],
              [
                60.2654167,
                33.1151967
              ],
              [
                60.2749436,
                33.1259078
              ],
              [
                60.2711656,
                33.1339503
              ],
              [
                60.2619401,
                33.151044
              ],
              [
                60.2619292,
                33.1543118
              ],
              [
                60.2606963,
                33.1614811
              ],
              [
                60.2593041,
                33.1693138
              ],
              [
                60.2578858,
                33.1787246
              ],
              [
                60.284454,
                33.1961867
              ],
              [
                60.2761888,
                33.199626
              ],
              [
                60.270009,
                33.2031451
              ],
              [
                60.263915,
                33.2068796
              ],
              [
                60.2604818,
                33.2098957
              ],
              [
                60.2559424,
                33.2129364
              ],
              [
                60.2510296,
                33.2162012
              ],
              [
                60.2427856,
                33.2206343
              ],
              [
                60.2285758,
                33.2278455
              ],
              [
                60.2149915,
                33.2338776
              ],
              [
                60.1959017,
                33.2418819
              ],
              [
                60.1947223,
                33.2429606
              ],
              [
                60.1938994,
                33.2471665
              ],
              [
                60.1928469,
                33.2547669
              ],
              [
                60.1907203,
                33.2711768
              ],
              [
                60.1852366,
                33.2705793
              ],
              [
                60.1759109,
                33.2692375
              ],
              [
                60.169015,
                33.2683922
              ],
              [
                60.1489445,
                33.2652455
              ],
              [
                60.0786442,
                33.2810325
              ],
              [
                60.0474255,
                33.2941554
              ],
              [
                60.0395965,
                33.2990407
              ],
              [
                60.0351333,
                33.3100878
              ],
              [
                60.0123881,
                33.3278032
              ],
              [
                59.9851798,
                33.3118093
              ],
              [
                59.9553082,
                33.3106441
              ],
              [
                59.9486159,
                33.3051383
              ],
              [
                59.9466418,
                33.3026993
              ],
              [
                59.9438455,
                33.2950591
              ],
              [
                59.9392991,
                33.2836745
              ],
              [
                59.9390886,
                33.2731393
              ],
              [
                59.9209174,
                33.2741609
              ],
              [
                59.9147493,
                33.2728655
              ],
              [
                59.9093649,
                33.2708991
              ],
              [
                59.9054664,
                33.2695016
              ],
              [
                59.8984908,
                33.2656758
              ],
              [
                59.8878878,
                33.2591637
              ],
              [
                59.8799069,
                33.2626758
              ],
              [
                59.8687284,
                33.2666198
              ],
              [
                59.8586371,
                33.271428
              ],
              [
                59.8519448,
                33.2736454
              ],
              [
                59.8479605,
                33.2760134
              ],
              [
                59.8379873,
                33.2798086
              ],
              [
                59.8291742,
                33.2805117
              ],
              [
                59.8139469,
                33.2798816
              ],
              [
                59.7995365,
                33.2760552
              ],
              [
                59.7945499,
                33.2689053
              ],
              [
                59.7908164,
                33.2613401
              ],
              [
                59.7861384,
                33.2571352
              ],
              [
                59.7784995,
                33.2525416
              ],
              [
                59.7701739,
                33.2495987
              ],
              [
                59.761752,
                33.2478862
              ],
              [
                59.7533677,
                33.2524083
              ],
              [
                59.7440804,
                33.2708122
              ],
              [
                59.7363638,
                33.285833
              ],
              [
                59.7312926,
                33.2972473
              ],
              [
                59.7203062,
                33.3062861
              ],
              [
                59.7204779,
                33.3111638
              ],
              [
                59.7160147,
                33.3257952
              ],
              [
                59.6974753,
                33.3280901
              ],
              [
                59.6890639,
                33.3342574
              ],
              [
                59.6784208,
                33.3372691
              ],
              [
                59.6751966,
                33.3403286
              ],
              [
                59.6670912,
                33.3420017
              ],
              [
                59.6475218,
                33.3376994
              ],
              [
                59.6351622,
                33.3401374
              ],
              [
                59.6155959,
                33.3434282
              ],
              [
                59.6187716,
                33.3365584
              ],
              [
                59.6221159,
                33.3300981
              ],
              [
                59.6313856,
                33.3147501
              ],
              [
                59.6358488,
                33.3008342
              ],
              [
                59.6475218,
                33.2909339
              ],
              [
                59.6595841,
                33.2784444
              ],
              [
                59.6589963,
                33.2750671
              ],
              [
                59.6580521,
                33.2700745
              ],
              [
                59.6572559,
                33.2690394
              ],
              [
                59.6535223,
                33.2589883
              ],
              [
                59.6519208,
                33.2540848
              ],
              [
                59.6502226,
                33.2512907
              ],
              [
                59.6495604,
                33.249186
              ],
              [
                59.6487838,
                33.2467221
              ],
              [
                59.6475649,
                33.2454354
              ],
              [
                59.647073,
                33.2441452
              ],
              [
                59.6079111,
                33.2425999
              ],
              [
                59.5990951,
                33.2393655
              ],
              [
                59.5899862,
                33.2360047
              ],
              [
                59.5855255,
                33.2346407
              ],
              [
                59.5785934,
                33.2326378
              ],
              [
                59.5755581,
                33.2320968
              ],
              [
                59.5473311,
                33.2238457
              ],
              [
                59.5278973,
                33.2247074
              ],
              [
                59.5093908,
                33.2236913
              ],
              [
                59.5022308,
                33.2136201
              ],
              [
                59.5109879,
                33.2114896
              ],
              [
                59.50683,
                33.204483
              ],
              [
                59.5021364,
                33.1960928
              ],
              [
                59.5181119,
                33.1887181
              ],
              [
                59.5185598,
                33.1808009
              ],
              [
                59.5180281,
                33.1721304
              ],
              [
                59.5181365,
                33.1645133
              ],
              [
                59.525518,
                33.1525535
              ],
              [
                59.5210322,
                33.1449741
              ],
              [
                59.5109674,
                33.1396232
              ],
              [
                59.503944,
                33.1365853
              ],
              [
                59.501953,
                33.1323045
              ],
              [
                59.5004791,
                33.1263391
              ],
              [
                59.4624623,
                33.124538
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555062,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زیرکوه",
          "name:en": "Zirkuh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q6407760",
          "wikipedia": "en:Zirkuh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.4361638,
                33.4665328
              ],
              [
                59.4389534,
                33.4669266
              ],
              [
                59.4445967,
                33.4678574
              ],
              [
                59.449768,
                33.468287
              ],
              [
                59.4709682,
                33.469182
              ],
              [
                59.4828987,
                33.4667834
              ],
              [
                59.4840574,
                33.4738357
              ],
              [
                59.4867181,
                33.4783819
              ],
              [
                59.4870615,
                33.4803506
              ],
              [
                59.4910955,
                33.4929494
              ],
              [
                59.4945716,
                33.5061905
              ],
              [
                59.4968032,
                33.5158874
              ],
              [
                59.4980907,
                33.5145277
              ],
              [
                59.499979,
                33.5144919
              ],
              [
                59.5088625,
                33.5107349
              ],
              [
                59.5218229,
                33.5086953
              ],
              [
                59.5254707,
                33.5023257
              ],
              [
                59.5282641,
                33.4990573
              ],
              [
                59.5300197,
                33.4953473
              ],
              [
                59.5355774,
                33.4855526
              ],
              [
                59.5368853,
                33.4820936
              ],
              [
                59.5395282,
                33.4742455
              ],
              [
                59.5391444,
                33.4715694
              ],
              [
                59.5382051,
                33.4623227
              ],
              [
                59.5378732,
                33.454145
              ],
              [
                59.5456497,
                33.4492166
              ],
              [
                59.5520782,
                33.4438682
              ],
              [
                59.5373823,
                33.4348309
              ],
              [
                59.5343542,
                33.433447
              ],
              [
                59.5289437,
                33.4304144
              ],
              [
                59.5356845,
                33.4262839
              ],
              [
                59.5368139,
                33.4248493
              ],
              [
                59.5500035,
                33.4229362
              ],
              [
                59.5612608,
                33.4204538
              ],
              [
                59.5658729,
                33.4201382
              ],
              [
                59.598519,
                33.3998701
              ],
              [
                59.6058562,
                33.3945129
              ],
              [
                59.6146529,
                33.3914753
              ],
              [
                59.6241098,
                33.3864725
              ],
              [
                59.609971,
                33.3630535
              ],
              [
                59.6116403,
                33.3559862
              ],
              [
                59.6155959,
                33.3434282
              ],
              [
                59.6351622,
                33.3401374
              ],
              [
                59.6475218,
                33.3376994
              ],
              [
                59.6670912,
                33.3420017
              ],
              [
                59.6751966,
                33.3403286
              ],
              [
                59.6784208,
                33.3372691
              ],
              [
                59.6890639,
                33.3342574
              ],
              [
                59.6974753,
                33.3280901
              ],
              [
                59.7160147,
                33.3257952
              ],
              [
                59.7204779,
                33.3111638
              ],
              [
                59.7203062,
                33.3062861
              ],
              [
                59.7312926,
                33.2972473
              ],
              [
                59.7363638,
                33.285833
              ],
              [
                59.7440804,
                33.2708122
              ],
              [
                59.7533677,
                33.2524083
              ],
              [
                59.761752,
                33.2478862
              ],
              [
                59.7701739,
                33.2495987
              ],
              [
                59.7784995,
                33.2525416
              ],
              [
                59.7861384,
                33.2571352
              ],
              [
                59.7908164,
                33.2613401
              ],
              [
                59.7945499,
                33.2689053
              ],
              [
                59.7995365,
                33.2760552
              ],
              [
                59.8139469,
                33.2798816
              ],
              [
                59.8291742,
                33.2805117
              ],
              [
                59.8379873,
                33.2798086
              ],
              [
                59.8479605,
                33.2760134
              ],
              [
                59.8519448,
                33.2736454
              ],
              [
                59.8586371,
                33.271428
              ],
              [
                59.8687284,
                33.2666198
              ],
              [
                59.8799069,
                33.2626758
              ],
              [
                59.8878878,
                33.2591637
              ],
              [
                59.8984908,
                33.2656758
              ],
              [
                59.9054664,
                33.2695016
              ],
              [
                59.9093649,
                33.2708991
              ],
              [
                59.9147493,
                33.2728655
              ],
              [
                59.9209174,
                33.2741609
              ],
              [
                59.9390886,
                33.2731393
              ],
              [
                59.9392991,
                33.2836745
              ],
              [
                59.9438455,
                33.2950591
              ],
              [
                59.9466418,
                33.3026993
              ],
              [
                59.9486159,
                33.3051383
              ],
              [
                59.9553082,
                33.3106441
              ],
              [
                59.9851798,
                33.3118093
              ],
              [
                60.0123881,
                33.3278032
              ],
              [
                60.0351333,
                33.3100878
              ],
              [
                60.0395965,
                33.2990407
              ],
              [
                60.0474255,
                33.2941554
              ],
              [
                60.0786442,
                33.2810325
              ],
              [
                60.1489445,
                33.2652455
              ],
              [
                60.169015,
                33.2683922
              ],
              [
                60.1759109,
                33.2692375
              ],
              [
                60.1852366,
                33.2705793
              ],
              [
                60.1907203,
                33.2711768
              ],
              [
                60.1928469,
                33.2547669
              ],
              [
                60.1938994,
                33.2471665
              ],
              [
                60.1947223,
                33.2429606
              ],
              [
                60.1959017,
                33.2418819
              ],
              [
                60.2149915,
                33.2338776
              ],
              [
                60.2285758,
                33.2278455
              ],
              [
                60.2427856,
                33.2206343
              ],
              [
                60.2510296,
                33.2162012
              ],
              [
                60.2559424,
                33.2129364
              ],
              [
                60.2604818,
                33.2098957
              ],
              [
                60.263915,
                33.2068796
              ],
              [
                60.270009,
                33.2031451
              ],
              [
                60.2761888,
                33.199626
              ],
              [
                60.284454,
                33.1961867
              ],
              [
                60.2578858,
                33.1787246
              ],
              [
                60.2593041,
                33.1693138
              ],
              [
                60.2606963,
                33.1614811
              ],
              [
                60.2619292,
                33.1543118
              ],
              [
                60.2619401,
                33.151044
              ],
              [
                60.2711656,
                33.1339503
              ],
              [
                60.2749436,
                33.1259078
              ],
              [
                60.2654167,
                33.1151967
              ],
              [
                60.2558222,
                33.1028783
              ],
              [
                60.2612204,
                33.0942425
              ],
              [
                60.2694251,
                33.0794839
              ],
              [
                60.3010042,
                33.0851096
              ],
              [
                60.3176879,
                33.0881618
              ],
              [
                60.3339805,
                33.0989317
              ],
              [
                60.3541051,
                33.1012644
              ],
              [
                60.3634377,
                33.1018228
              ],
              [
                60.3759648,
                33.103157
              ],
              [
                60.3835506,
                33.1034451
              ],
              [
                60.3930624,
                33.1042279
              ],
              [
                60.4219435,
                33.100953
              ],
              [
                60.4281685,
                33.101201
              ],
              [
                60.4450616,
                33.1019199
              ],
              [
                60.4590245,
                33.1023436
              ],
              [
                60.487461,
                33.1006017
              ],
              [
                60.5162143,
                33.0996309
              ],
              [
                60.5180556,
                33.0989776
              ],
              [
                60.5347462,
                33.0984439
              ],
              [
                60.5758543,
                33.0929629
              ],
              [
                60.5978837,
                33.095297
              ],
              [
                60.5833775,
                33.1299045
              ],
              [
                60.6058475,
                33.1731321
              ],
              [
                60.612902,
                33.1868775
              ],
              [
                60.6340548,
                33.2281412
              ],
              [
                60.7038369,
                33.2923734
              ],
              [
                60.7592717,
                33.3436359
              ],
              [
                60.8243549,
                33.399798
              ],
              [
                60.8664836,
                33.421487
              ],
              [
                60.8634248,
                33.4616233
              ],
              [
                60.8509231,
                33.4820012
              ],
              [
                60.8824864,
                33.5052436
              ],
              [
                60.8832913,
                33.5052232
              ],
              [
                60.8858606,
                33.5045986
              ],
              [
                60.8864684,
                33.5043222
              ],
              [
                60.8870209,
                33.5035917
              ],
              [
                60.8877562,
                33.5032519
              ],
              [
                60.8883706,
                33.5031968
              ],
              [
                60.8899409,
                33.5035153
              ],
              [
                60.8909279,
                33.5033811
              ],
              [
                60.8914883,
                33.5029993
              ],
              [
                60.8917724,
                33.5030586
              ],
              [
                60.8922933,
                33.5029599
              ],
              [
                60.8927432,
                33.5026045
              ],
              [
                60.893201,
                33.5024465
              ],
              [
                60.8941618,
                33.5027736
              ],
              [
                60.8949769,
                33.502486
              ],
              [
                60.8959714,
                33.5025452
              ],
              [
                60.8984498,
                33.501841
              ],
              [
                60.9016125,
                33.5020372
              ],
              [
                60.903217,
                33.5007583
              ],
              [
                60.9082182,
                33.4994855
              ],
              [
                60.9194759,
                33.4982316
              ],
              [
                60.9215677,
                33.4974539
              ],
              [
                60.9235211,
                33.4976029
              ],
              [
                60.9253405,
                33.4972305
              ],
              [
                60.9258874,
                33.4977518
              ],
              [
                60.9287078,
                33.4972033
              ],
              [
                60.9459035,
                33.5134944
              ],
              [
                60.9439574,
                33.5150844
              ],
              [
                60.9027952,
                33.5399665
              ],
              [
                60.8742226,
                33.5405285
              ],
              [
                60.8262277,
                33.5413576
              ],
              [
                60.7986618,
                33.5418599
              ],
              [
                60.7811881,
                33.5423074
              ],
              [
                60.7529151,
                33.5429181
              ],
              [
                60.7034182,
                33.54552
              ],
              [
                60.6741973,
                33.5527693
              ],
              [
                60.6550163,
                33.5574733
              ],
              [
                60.6262032,
                33.5821543
              ],
              [
                60.6168541,
                33.5998234
              ],
              [
                60.5963244,
                33.6513191
              ],
              [
                60.5468937,
                33.7314095
              ],
              [
                60.5552661,
                33.7489647
              ],
              [
                60.5822135,
                33.8054437
              ],
              [
                60.576597,
                33.8271947
              ],
              [
                60.5713561,
                33.8480329
              ],
              [
                60.5420008,
                33.9647513
              ],
              [
                60.533076,
                34.0002495
              ],
              [
                60.4149977,
                33.9409948
              ],
              [
                60.4005513,
                33.9373823
              ],
              [
                60.396945,
                33.9365513
              ],
              [
                60.3852783,
                33.931828
              ],
              [
                60.3334801,
                33.9524742
              ],
              [
                60.2812951,
                33.9331065
              ],
              [
                60.2625075,
                33.9360357
              ],
              [
                60.2605676,
                33.9340951
              ],
              [
                60.2183077,
                33.9277889
              ],
              [
                60.1863617,
                33.9039053
              ],
              [
                60.1858081,
                33.9033549
              ],
              [
                60.1841417,
                33.9027955
              ],
              [
                60.1710819,
                33.8917063
              ],
              [
                60.1571887,
                33.8875372
              ],
              [
                60.1544156,
                33.8864273
              ],
              [
                60.1535823,
                33.8858678
              ],
              [
                60.147742,
                33.8842074
              ],
              [
                60.1460756,
                33.8842074
              ],
              [
                60.145522,
                33.8839276
              ],
              [
                60.1438556,
                33.8839276
              ],
              [
                60.1374691,
                33.8828176
              ],
              [
                60.136909,
                33.8828177
              ],
              [
                60.1352422,
                33.8825379
              ],
              [
                60.1336731,
                33.8841068
              ],
              [
                60.119409,
                33.8983661
              ],
              [
                60.1163559,
                33.9022556
              ],
              [
                60.1158028,
                33.9033655
              ],
              [
                60.1152426,
                33.9036452
              ],
              [
                60.1146895,
                33.9047552
              ],
              [
                60.0921432,
                33.9089644
              ],
              [
                60.0880562,
                33.9277046
              ],
              [
                60.1199334,
                33.9570306
              ],
              [
                60.0924676,
                33.9729763
              ],
              [
                60.0088541,
                33.9730135
              ],
              [
                59.9583621,
                33.9747657
              ],
              [
                59.8742118,
                33.9777986
              ],
              [
                59.8456676,
                33.9491535
              ],
              [
                59.8508374,
                33.9216426
              ],
              [
                59.7751863,
                33.9131416
              ],
              [
                59.7751864,
                33.9092503
              ],
              [
                59.7762995,
                33.8906339
              ],
              [
                59.7793527,
                33.8575718
              ],
              [
                59.782966,
                33.8436768
              ],
              [
                59.7865793,
                33.8375736
              ],
              [
                59.7871324,
                33.836734
              ],
              [
                59.7901926,
                33.8325717
              ],
              [
                59.7904657,
                33.8322919
              ],
              [
                59.7738734,
                33.8257566
              ],
              [
                59.8166527,
                33.7965902
              ],
              [
                59.8410989,
                33.7710343
              ],
              [
                59.841379,
                33.7704746
              ],
              [
                59.8579786,
                33.7407572
              ],
              [
                59.8820973,
                33.7306494
              ],
              [
                59.885091,
                33.7235352
              ],
              [
                59.8880703,
                33.7107459
              ],
              [
                59.8813755,
                33.7005019
              ],
              [
                59.8719232,
                33.6834824
              ],
              [
                59.8660408,
                33.6672121
              ],
              [
                59.8827981,
                33.6603779
              ],
              [
                59.8877021,
                33.6583534
              ],
              [
                59.880149,
                33.653001
              ],
              [
                59.8728423,
                33.6482862
              ],
              [
                59.8665044,
                33.6446641
              ],
              [
                59.8710127,
                33.6370361
              ],
              [
                59.8792648,
                33.6243904
              ],
              [
                59.8847579,
                33.6108123
              ],
              [
                59.8758793,
                33.5987337
              ],
              [
                59.8602103,
                33.5821622
              ],
              [
                59.854288,
                33.5799455
              ],
              [
                59.8491859,
                33.5789495
              ],
              [
                59.8292603,
                33.5821677
              ],
              [
                59.8170717,
                33.5786424
              ],
              [
                59.7871123,
                33.5942246
              ],
              [
                59.743772,
                33.5847327
              ],
              [
                59.7169844,
                33.5795454
              ],
              [
                59.7030282,
                33.5839398
              ],
              [
                59.6886719,
                33.5833617
              ],
              [
                59.6675007,
                33.5914076
              ],
              [
                59.6374255,
                33.6182822
              ],
              [
                59.6120446,
                33.6431256
              ],
              [
                59.5998141,
                33.6616021
              ],
              [
                59.594689,
                33.6914438
              ],
              [
                59.5895056,
                33.7225429
              ],
              [
                59.5625824,
                33.743478
              ],
              [
                59.5440044,
                33.7441917
              ],
              [
                59.514746,
                33.7447381
              ],
              [
                59.4873685,
                33.7454463
              ],
              [
                59.4533329,
                33.7465153
              ],
              [
                59.4328334,
                33.7443798
              ],
              [
                59.425737,
                33.7384424
              ],
              [
                59.4297484,
                33.712087
              ],
              [
                59.4152336,
                33.6946785
              ],
              [
                59.4201866,
                33.6727134
              ],
              [
                59.4181268,
                33.657575
              ],
              [
                59.4162101,
                33.645405
              ],
              [
                59.4069157,
                33.6250124
              ],
              [
                59.409454,
                33.6131317
              ],
              [
                59.40682,
                33.5985931
              ],
              [
                59.413982,
                33.5770928
              ],
              [
                59.4340282,
                33.5625398
              ],
              [
                59.4549232,
                33.5505359
              ],
              [
                59.4749164,
                33.538247
              ],
              [
                59.4731139,
                33.5174975
              ],
              [
                59.4426428,
                33.4852511
              ],
              [
                59.4365287,
                33.4805296
              ],
              [
                59.4287824,
                33.473263
              ],
              [
                59.4361638,
                33.4665328
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555070,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سرایان",
          "name:en": "Sarayan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286233",
          "wikipedia": "en:Sarayan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.7938534,
                33.1269252
              ],
              [
                57.8062817,
                33.074282
              ],
              [
                57.798042,
                33.0587453
              ],
              [
                57.8070092,
                33.040668
              ],
              [
                57.8075623,
                33.0395575
              ],
              [
                57.7855103,
                33.0198328
              ],
              [
                57.7857833,
                33.0178824
              ],
              [
                57.7863435,
                33.0167718
              ],
              [
                57.7877298,
                33.0101082
              ],
              [
                57.7877298,
                33.0076072
              ],
              [
                57.7880099,
                33.0056568
              ],
              [
                57.7877298,
                33.005106
              ],
              [
                57.7880099,
                33.0034355
              ],
              [
                57.7893966,
                32.9979096
              ],
              [
                57.8121178,
                32.9389632
              ],
              [
                57.8649895,
                32.9251317
              ],
              [
                57.8746026,
                32.9089922
              ],
              [
                57.9082482,
                32.9020744
              ],
              [
                58.0001729,
                32.8565186
              ],
              [
                58.006696,
                32.8616376
              ],
              [
                58.0378532,
                32.8642325
              ],
              [
                58.0472945,
                32.8643046
              ],
              [
                58.0487139,
                32.8631607
              ],
              [
                58.061159,
                32.8587543
              ],
              [
                58.067207,
                32.8839123
              ],
              [
                58.0654904,
                32.922826
              ],
              [
                58.0610272,
                32.9813084
              ],
              [
                58.0572506,
                33.0198914
              ],
              [
                58.0548474,
                33.0636368
              ],
              [
                58.0496436,
                33.1129992
              ],
              [
                58.0276077,
                33.1616952
              ],
              [
                58.0212945,
                33.1764875
              ],
              [
                58.0110739,
                33.2102549
              ],
              [
                58.0104384,
                33.2327541
              ],
              [
                58.0160866,
                33.248625
              ],
              [
                58.0206261,
                33.2616232
              ],
              [
                58.0328593,
                33.2775468
              ],
              [
                58.0489256,
                33.2987606
              ],
              [
                58.0697821,
                33.3222093
              ],
              [
                58.0814551,
                33.3289507
              ],
              [
                58.0948796,
                33.3279654
              ],
              [
                58.1142724,
                33.3254793
              ],
              [
                58.1434246,
                33.3199144
              ],
              [
                58.1695172,
                33.3176193
              ],
              [
                58.1909024,
                33.3143013
              ],
              [
                58.2493908,
                33.3069321
              ],
              [
                58.2883732,
                33.3053274
              ],
              [
                58.3440882,
                33.2957945
              ],
              [
                58.3535382,
                33.2897861
              ],
              [
                58.3734509,
                33.2628054
              ],
              [
                58.3823773,
                33.237252
              ],
              [
                58.3948746,
                33.2251485
              ],
              [
                58.4085408,
                33.2204603
              ],
              [
                58.432867,
                33.221675
              ],
              [
                58.4736277,
                33.2262275
              ],
              [
                58.4942857,
                33.2259255
              ],
              [
                58.547344,
                33.196466
              ],
              [
                58.5607336,
                33.2017807
              ],
              [
                58.5708616,
                33.2043661
              ],
              [
                58.5787581,
                33.2049407
              ],
              [
                58.5964886,
                33.2088025
              ],
              [
                58.6051939,
                33.209824
              ],
              [
                58.6121702,
                33.2087032
              ],
              [
                58.6269425,
                33.210889
              ],
              [
                58.6365984,
                33.2148671
              ],
              [
                58.647065,
                33.2185651
              ],
              [
                58.6597905,
                33.2217889
              ],
              [
                58.674099,
                33.2185218
              ],
              [
                58.6743791,
                33.2188016
              ],
              [
                58.6760459,
                33.2188017
              ],
              [
                58.6768792,
                33.2190816
              ],
              [
                58.6782659,
                33.2190816
              ],
              [
                58.7007723,
                33.2243633
              ],
              [
                58.7568847,
                33.2538057
              ],
              [
                58.7629916,
                33.2565774
              ],
              [
                58.7638314,
                33.2571372
              ],
              [
                58.7646651,
                33.2574081
              ],
              [
                58.7785512,
                33.2635295
              ],
              [
                58.7791043,
                33.2640802
              ],
              [
                58.7893847,
                33.2676916
              ],
              [
                58.7924379,
                33.2688022
              ],
              [
                58.8116109,
                33.2768557
              ],
              [
                58.8235506,
                33.2846383
              ],
              [
                58.848557,
                33.3060269
              ],
              [
                58.850777,
                33.3088077
              ],
              [
                58.8591104,
                33.3226935
              ],
              [
                58.8624437,
                33.3354688
              ],
              [
                58.8629968,
                33.3410303
              ],
              [
                58.8632769,
                33.3515846
              ],
              [
                58.863557,
                33.3529659
              ],
              [
                58.8638304,
                33.357137
              ],
              [
                58.8638305,
                33.3718623
              ],
              [
                58.8641103,
                33.372693
              ],
              [
                58.8638306,
                33.3738035
              ],
              [
                58.8641102,
                33.374914
              ],
              [
                58.8643903,
                33.3763043
              ],
              [
                58.8643903,
                33.3765842
              ],
              [
                58.8063604,
                33.4136567
              ],
              [
                58.7854813,
                33.426164
              ],
              [
                58.7712207,
                33.443679
              ],
              [
                58.7645383,
                33.4579611
              ],
              [
                58.7615775,
                33.466318
              ],
              [
                58.7591481,
                33.4716942
              ],
              [
                58.742523,
                33.4845744
              ],
              [
                58.7260435,
                33.4838585
              ],
              [
                58.7212226,
                33.4857312
              ],
              [
                58.7176929,
                33.4900591
              ],
              [
                58.7184477,
                33.4988277
              ],
              [
                58.7198868,
                33.5086148
              ],
              [
                58.701046,
                33.5357509
              ],
              [
                58.6996597,
                33.5365815
              ],
              [
                58.67938,
                33.5604783
              ],
              [
                58.67438,
                33.5679805
              ],
              [
                58.6732667,
                33.5699215
              ],
              [
                58.6727136,
                33.5713118
              ],
              [
                58.6718799,
                33.5724222
              ],
              [
                58.6663268,
                33.5888077
              ],
              [
                58.6663268,
                33.5896473
              ],
              [
                58.6499339,
                33.6251985
              ],
              [
                58.6416006,
                33.652146
              ],
              [
                58.6416006,
                33.6635388
              ],
              [
                58.6413206,
                33.6746517
              ],
              [
                58.642434,
                33.6763127
              ],
              [
                58.6432676,
                33.6768724
              ],
              [
                58.6443808,
                33.6779828
              ],
              [
                58.6452141,
                33.6782536
              ],
              [
                58.6457672,
                33.6785335
              ],
              [
                58.6460473,
                33.6782536
              ],
              [
                58.6468808,
                33.6782536
              ],
              [
                58.6527138,
                33.6738121
              ],
              [
                58.6593804,
                33.6688108
              ],
              [
                58.6696602,
                33.6649199
              ],
              [
                58.6727138,
                33.6646491
              ],
              [
                58.686327,
                33.6718711
              ],
              [
                58.6941068,
                33.6749224
              ],
              [
                58.6952135,
                33.675482
              ],
              [
                58.7127131,
                33.6904767
              ],
              [
                58.7291064,
                33.7004791
              ],
              [
                58.7766059,
                33.7396487
              ],
              [
                58.7777192,
                33.7401994
              ],
              [
                58.7802193,
                33.7426999
              ],
              [
                58.7804533,
                33.7433057
              ],
              [
                58.7718859,
                33.7477011
              ],
              [
                58.7588259,
                33.7554826
              ],
              [
                58.7582727,
                33.7557624
              ],
              [
                58.7577197,
                33.7563131
              ],
              [
                58.7566059,
                33.7563131
              ],
              [
                58.748273,
                33.7585338
              ],
              [
                58.7474398,
                33.7590935
              ],
              [
                58.7466062,
                33.7590935
              ],
              [
                58.7463261,
                33.7593733
              ],
              [
                58.7452198,
                33.7593733
              ],
              [
                58.7232733,
                33.7715963
              ],
              [
                58.7177134,
                33.7743676
              ],
              [
                58.7166068,
                33.7749272
              ],
              [
                58.6774337,
                33.7996526
              ],
              [
                58.6760474,
                33.8004832
              ],
              [
                58.6613276,
                33.8154861
              ],
              [
                58.6532677,
                33.8318701
              ],
              [
                58.6529943,
                33.8332602
              ],
              [
                58.6527142,
                33.83354
              ],
              [
                58.6527142,
                33.8338199
              ],
              [
                58.6527142,
                33.8340907
              ],
              [
                58.6527142,
                33.8354808
              ],
              [
                58.6524341,
                33.8360406
              ],
              [
                58.6527142,
                33.8365912
              ],
              [
                58.652161,
                33.8429823
              ],
              [
                58.6496544,
                33.854654
              ],
              [
                58.649381,
                33.8554845
              ],
              [
                58.6491009,
                33.8571455
              ],
              [
                58.6446544,
                33.8713176
              ],
              [
                58.6429879,
                33.8846503
              ],
              [
                58.6424344,
                33.8857605
              ],
              [
                58.6416012,
                33.8904815
              ],
              [
                58.6413212,
                33.914655
              ],
              [
                58.6410482,
                33.9221561
              ],
              [
                58.638268,
                33.9402093
              ],
              [
                58.6388212,
                33.9415993
              ],
              [
                58.6389975,
                33.9426505
              ],
              [
                58.6391013,
                33.9432692
              ],
              [
                58.6393814,
                33.9440997
              ],
              [
                58.6393814,
                33.9449112
              ],
              [
                58.6393814,
                33.9454898
              ],
              [
                58.6385482,
                33.9471507
              ],
              [
                58.6382681,
                33.9477103
              ],
              [
                58.6354879,
                33.952711
              ],
              [
                58.6313216,
                33.9710438
              ],
              [
                58.6327149,
                33.9788245
              ],
              [
                58.6329884,
                33.9791043
              ],
              [
                58.637435,
                33.9932667
              ],
              [
                58.6379881,
                33.9940971
              ],
              [
                58.6382682,
                33.9946567
              ],
              [
                58.6385483,
                33.9949365
              ],
              [
                58.6385483,
                33.9963266
              ],
              [
                58.6388214,
                33.9965974
              ],
              [
                58.6388213,
                33.9988269
              ],
              [
                58.6391014,
                34.0104889
              ],
              [
                58.6462278,
                34.0719979
              ],
              [
                58.646508,
                34.0725482
              ],
              [
                58.6462279,
                34.074208
              ],
              [
                58.6445614,
                34.0736577
              ],
              [
                58.6347347,
                34.0637928
              ],
              [
                58.6239816,
                34.0579138
              ],
              [
                58.6007306,
                34.0569264
              ],
              [
                58.5736728,
                34.0513003
              ],
              [
                58.5560986,
                34.058633
              ],
              [
                58.542709,
                34.0762658
              ],
              [
                58.5245129,
                34.0811
              ],
              [
                58.5124966,
                34.0901989
              ],
              [
                58.4988066,
                34.0799981
              ],
              [
                58.4963607,
                34.0777585
              ],
              [
                58.4950733,
                34.0774742
              ],
              [
                58.4939575,
                34.0764433
              ],
              [
                58.4912967,
                34.0756613
              ],
              [
                58.4860611,
                34.0780074
              ],
              [
                58.4774351,
                34.0796336
              ],
              [
                58.4739053,
                34.0807888
              ],
              [
                58.4694314,
                34.0815352
              ],
              [
                58.4654059,
                34.0815654
              ],
              [
                58.4604091,
                34.0772379
              ],
              [
                58.4441946,
                34.0621835
              ],
              [
                58.4440906,
                34.0588243
              ],
              [
                58.4435375,
                34.0585445
              ],
              [
                58.4429843,
                34.0582646
              ],
              [
                58.4427042,
                34.0579939
              ],
              [
                58.4424242,
                34.057714
              ],
              [
                58.4421508,
                34.057714
              ],
              [
                58.4418711,
                34.0571544
              ],
              [
                58.4415909,
                34.0571545
              ],
              [
                58.4407573,
                34.0566038
              ],
              [
                58.4402041,
                34.0560443
              ],
              [
                58.4396511,
                34.0557644
              ],
              [
                58.4390909,
                34.0554937
              ],
              [
                58.4382578,
                34.054934
              ],
              [
                58.4377042,
                34.0543744
              ],
              [
                58.4365909,
                34.0538239
              ],
              [
                58.4357577,
                34.0529934
              ],
              [
                58.4352041,
                34.0527136
              ],
              [
                58.4340908,
                34.0518832
              ],
              [
                58.4332575,
                34.0513236
              ],
              [
                58.4329845,
                34.0510438
              ],
              [
                58.4324244,
                34.050764
              ],
              [
                58.4318708,
                34.0504931
              ],
              [
                58.4315912,
                34.0502134
              ],
              [
                58.4313177,
                34.0499336
              ],
              [
                58.4304845,
                34.049383
              ],
              [
                58.4302044,
                34.0491032
              ],
              [
                58.4296512,
                34.0485435
              ],
              [
                58.4293711,
                34.0482637
              ],
              [
                58.4288177,
                34.0477132
              ],
              [
                58.4279844,
                34.0474334
              ],
              [
                58.4277043,
                34.0471535
              ],
              [
                58.426591,
                34.0463231
              ],
              [
                58.4257578,
                34.0457635
              ],
              [
                58.4254844,
                34.0454837
              ],
              [
                58.4246511,
                34.0449331
              ],
              [
                58.4238179,
                34.0441027
              ],
              [
                58.4232577,
                34.0438229
              ],
              [
                58.4224246,
                34.0429835
              ],
              [
                58.4215909,
                34.0424329
              ],
              [
                58.4213112,
                34.0421531
              ],
              [
                58.4207576,
                34.0418823
              ],
              [
                58.4202046,
                34.0413227
              ],
              [
                58.4196443,
                34.0410429
              ],
              [
                58.4188112,
                34.0402125
              ],
              [
                58.4182577,
                34.0396529
              ],
              [
                58.4177045,
                34.0393821
              ],
              [
                58.4171443,
                34.0388224
              ],
              [
                58.4163111,
                34.0382719
              ],
              [
                58.4160376,
                34.0382719
              ],
              [
                58.4154778,
                34.0377123
              ],
              [
                58.4149243,
                34.0371526
              ],
              [
                58.4146442,
                34.0371526
              ],
              [
                58.413811,
                34.036602
              ],
              [
                58.4132579,
                34.0360424
              ],
              [
                58.4129778,
                34.0357716
              ],
              [
                58.4121446,
                34.035212
              ],
              [
                58.4113109,
                34.0346524
              ],
              [
                58.4107579,
                34.0343726
              ],
              [
                58.4102047,
                34.0341017
              ],
              [
                58.4093711,
                34.0335421
              ],
              [
                58.4090914,
                34.0332714
              ],
              [
                58.4082578,
                34.0329915
              ],
              [
                58.4074246,
                34.0321522
              ],
              [
                58.4068714,
                34.0318723
              ],
              [
                58.4058026,
                34.0309253
              ],
              [
                58.4050102,
                34.030695
              ],
              [
                58.4043714,
                34.0302116
              ],
              [
                58.4034823,
                34.0295404
              ],
              [
                58.4029971,
                34.0290765
              ],
              [
                58.4025483,
                34.0286232
              ],
              [
                58.4023227,
                34.0282729
              ],
              [
                58.4019937,
                34.0278702
              ],
              [
                58.4016391,
                34.0274178
              ],
              [
                58.4013189,
                34.026994
              ],
              [
                58.4007899,
                34.0265732
              ],
              [
                58.4002403,
                34.026062
              ],
              [
                58.3996079,
                34.025429
              ],
              [
                58.3987859,
                34.0248866
              ],
              [
                58.3980641,
                34.0246648
              ],
              [
                58.397366,
                34.0243789
              ],
              [
                58.3960951,
                34.0238284
              ],
              [
                58.3946935,
                34.0234245
              ],
              [
                58.3940831,
                34.0233469
              ],
              [
                58.3933604,
                34.0231528
              ],
              [
                58.3923863,
                34.0229722
              ],
              [
                58.3917587,
                34.0227009
              ],
              [
                58.3909474,
                34.0225707
              ],
              [
                58.3903161,
                34.0223199
              ],
              [
                58.3896743,
                34.0222169
              ],
              [
                58.3891196,
                34.0220257
              ],
              [
                58.3885383,
                34.0219528
              ],
              [
                58.3882581,
                34.0218713
              ],
              [
                58.387425,
                34.0216006
              ],
              [
                58.3865758,
                34.0212083
              ],
              [
                58.3857432,
                34.0208088
              ],
              [
                58.3849249,
                34.0204903
              ],
              [
                58.3835315,
                34.0199398
              ],
              [
                58.3829783,
                34.0196509
              ],
              [
                58.3821448,
                34.0193801
              ],
              [
                58.3815915,
                34.0191003
              ],
              [
                58.3807584,
                34.0188205
              ],
              [
                58.3801981,
                34.0185407
              ],
              [
                58.3799248,
                34.0185407
              ],
              [
                58.379365,
                34.0182699
              ],
              [
                58.3785314,
                34.0179901
              ],
              [
                58.3782583,
                34.0179901
              ],
              [
                58.377145,
                34.0177103
              ],
              [
                58.3763113,
                34.0171507
              ],
              [
                58.3757583,
                34.0171507
              ],
              [
                58.374925,
                34.0166001
              ],
              [
                58.3740919,
                34.0166001
              ],
              [
                58.3738117,
                34.0163203
              ],
              [
                58.3729781,
                34.0160405
              ],
              [
                58.3721449,
                34.0157697
              ],
              [
                58.3715918,
                34.0157697
              ],
              [
                58.3707586,
                34.0152101
              ],
              [
                58.369925,
                34.0149302
              ],
              [
                58.3693648,
                34.0146504
              ],
              [
                58.3685315,
                34.0143796
              ],
              [
                58.3676983,
                34.0140998
              ],
              [
                58.3674249,
                34.01382
              ],
              [
                58.3665917,
                34.0135402
              ],
              [
                58.3657584,
                34.0129896
              ],
              [
                58.3654784,
                34.0129896
              ],
              [
                58.3646451,
                34.0124299
              ],
              [
                58.3638119,
                34.0121501
              ],
              [
                58.3635318,
                34.0121502
              ],
              [
                58.3632584,
                34.0118794
              ],
              [
                58.3626982,
                34.0115996
              ],
              [
                58.3621451,
                34.0113198
              ],
              [
                58.362145,
                34.0110489
              ],
              [
                58.361592,
                34.011049
              ],
              [
                58.3613118,
                34.0107691
              ],
              [
                58.3610318,
                34.0104893
              ],
              [
                58.3604782,
                34.0104894
              ],
              [
                58.3599251,
                34.0102095
              ],
              [
                58.3590919,
                34.0096499
              ],
              [
                58.3579786,
                34.0090993
              ],
              [
                58.3574251,
                34.0088195
              ],
              [
                58.3563118,
                34.0082688
              ],
              [
                58.3554785,
                34.0079891
              ],
              [
                58.3551984,
                34.0079891
              ],
              [
                58.3546453,
                34.0077092
              ],
              [
                58.3540918,
                34.0074294
              ],
              [
                58.353532,
                34.0068788
              ],
              [
                58.3529785,
                34.006599
              ],
              [
                58.3524253,
                34.0063192
              ],
              [
                58.3518652,
                34.0060484
              ],
              [
                58.3513121,
                34.0057686
              ],
              [
                58.351032,
                34.0057686
              ],
              [
                58.3507585,
                34.0057686
              ],
              [
                58.3504784,
                34.0054887
              ],
              [
                58.3501983,
                34.005209
              ],
              [
                58.3496452,
                34.005209
              ],
              [
                58.3496453,
                34.0049292
              ],
              [
                58.349092,
                34.0046583
              ],
              [
                58.3482585,
                34.0043786
              ],
              [
                58.3466782,
                34.003959
              ],
              [
                58.3452217,
                34.0032163
              ],
              [
                58.3395691,
                33.9976313
              ],
              [
                58.3432739,
                33.995172
              ],
              [
                58.3541269,
                33.9884577
              ],
              [
                58.3677006,
                33.9829808
              ],
              [
                58.390196,
                33.9837595
              ],
              [
                58.414756,
                33.9883605
              ],
              [
                58.4310159,
                33.9929998
              ],
              [
                58.4440289,
                33.9935708
              ],
              [
                58.4558376,
                33.9904822
              ],
              [
                58.4418703,
                33.9694744
              ],
              [
                58.4407452,
                33.9684222
              ],
              [
                58.4208681,
                33.9557678
              ],
              [
                58.4024867,
                33.949083
              ],
              [
                58.3830211,
                33.9440791
              ],
              [
                58.3313219,
                33.9344256
              ],
              [
                58.3150694,
                33.930199
              ],
              [
                58.2973091,
                33.9255236
              ],
              [
                58.2821741,
                33.9222296
              ],
              [
                58.2674383,
                33.927116
              ],
              [
                58.252581,
                33.931574
              ],
              [
                58.245247,
                33.9338016
              ],
              [
                58.2393587,
                33.9359524
              ],
              [
                58.229828,
                33.9397668
              ],
              [
                58.2207803,
                33.9434411
              ],
              [
                58.2175303,
                33.9450753
              ],
              [
                58.2114954,
                33.9501472
              ],
              [
                58.2023344,
                33.9458145
              ],
              [
                58.1978011,
                33.9434933
              ],
              [
                58.191363,
                33.9400759
              ],
              [
                58.1944789,
                33.9290924
              ],
              [
                58.1997195,
                33.9129124
              ],
              [
                58.2019533,
                33.9017193
              ],
              [
                58.2061768,
                33.892815
              ],
              [
                58.200035,
                33.8824332
              ],
              [
                58.1834066,
                33.8755565
              ],
              [
                58.1827859,
                33.8696195
              ],
              [
                58.1756779,
                33.8609656
              ],
              [
                58.1774398,
                33.8575641
              ],
              [
                58.1823476,
                33.8546062
              ],
              [
                58.1773444,
                33.8469436
              ],
              [
                58.1800909,
                33.840116
              ],
              [
                58.1792662,
                33.8291821
              ],
              [
                58.1702016,
                33.8224899
              ],
              [
                58.1583571,
                33.8149564
              ],
              [
                58.1614493,
                33.8088203
              ],
              [
                58.1758688,
                33.7917026
              ],
              [
                58.1794215,
                33.7827489
              ],
              [
                58.1794667,
                33.7766447
              ],
              [
                58.1745899,
                33.7678234
              ],
              [
                58.1831064,
                33.7520323
              ],
              [
                58.1741522,
                33.7390443
              ],
              [
                58.1710623,
                33.7311927
              ],
              [
                58.1713712,
                33.719803
              ],
              [
                58.1759636,
                33.7094573
              ],
              [
                58.1761309,
                33.7022382
              ],
              [
                58.1824779,
                33.6952446
              ],
              [
                58.1705405,
                33.6897712
              ],
              [
                58.1599427,
                33.6848843
              ],
              [
                58.1589899,
                33.6525209
              ],
              [
                58.1446974,
                33.6478075
              ],
              [
                58.1311864,
                33.6421246
              ],
              [
                58.1225649,
                33.6378373
              ],
              [
                58.1194947,
                33.6327069
              ],
              [
                58.1194767,
                33.6265029
              ],
              [
                58.1014469,
                33.6084839
              ],
              [
                58.0920934,
                33.6017765
              ],
              [
                58.0966677,
                33.5955567
              ],
              [
                58.1011785,
                33.5784742
              ],
              [
                58.1006522,
                33.571199
              ],
              [
                58.0943415,
                33.5682272
              ],
              [
                58.0864071,
                33.5658672
              ],
              [
                58.0753418,
                33.5651939
              ],
              [
                58.0656477,
                33.5626131
              ],
              [
                58.057462,
                33.5593733
              ],
              [
                58.0595516,
                33.5551052
              ],
              [
                58.0596613,
                33.5496314
              ],
              [
                58.0488964,
                33.5493475
              ],
              [
                58.0418145,
                33.5480444
              ],
              [
                58.0494356,
                33.5350585
              ],
              [
                58.0521871,
                33.5285416
              ],
              [
                58.0625048,
                33.524644
              ],
              [
                58.0601522,
                33.5149656
              ],
              [
                58.0564782,
                33.5053319
              ],
              [
                58.0529378,
                33.4974243
              ],
              [
                58.0533842,
                33.4913072
              ],
              [
                58.0455626,
                33.4874865
              ],
              [
                58.0453691,
                33.4827232
              ],
              [
                58.0458075,
                33.4780489
              ],
              [
                58.0519264,
                33.4742545
              ],
              [
                58.052568,
                33.4730125
              ],
              [
                58.0489931,
                33.4689614
              ],
              [
                58.0475113,
                33.4653397
              ],
              [
                58.0469988,
                33.4611152
              ],
              [
                58.0411893,
                33.4565264
              ],
              [
                58.037467,
                33.4520324
              ],
              [
                58.0053234,
                33.438425
              ],
              [
                57.9998302,
                33.4385682
              ],
              [
                57.9950237,
                33.4350944
              ],
              [
                57.9866552,
                33.431513
              ],
              [
                57.9596614,
                33.4309758
              ],
              [
                57.9536533,
                33.4186904
              ],
              [
                57.9377317,
                33.4042895
              ],
              [
                57.8993225,
                33.4080511
              ],
              [
                57.8919839,
                33.4049702
              ],
              [
                57.8832721,
                33.3998111
              ],
              [
                57.8790664,
                33.3931111
              ],
              [
                57.8745174,
                33.3828271
              ],
              [
                57.8737449,
                33.3759823
              ],
              [
                57.8670501,
                33.3762691
              ],
              [
                57.8522014,
                33.3753373
              ],
              [
                57.8466224,
                33.3716817
              ],
              [
                57.8419017,
                33.3694597
              ],
              [
                57.8334045,
                33.3676676
              ],
              [
                57.8222464,
                33.3619329
              ],
              [
                57.8126333,
                33.3576316
              ],
              [
                57.8031918,
                33.3546207
              ],
              [
                57.7692028,
                33.3265125
              ],
              [
                57.7740094,
                33.3118812
              ],
              [
                57.7711174,
                33.3034674
              ],
              [
                57.7716705,
                33.2993051
              ],
              [
                57.7722307,
                33.2976439
              ],
              [
                57.7730639,
                33.2937525
              ],
              [
                57.7738976,
                33.2920822
              ],
              [
                57.7738976,
                33.2915314
              ],
              [
                57.7755639,
                33.2873601
              ],
              [
                57.7747439,
                33.2871855
              ],
              [
                57.7750238,
                33.283854
              ],
              [
                57.7851675,
                33.2801715
              ],
              [
                57.781906,
                33.2669677
              ],
              [
                57.7748489,
                33.2559916
              ],
              [
                57.7748488,
                33.2537708
              ],
              [
                57.7745688,
                33.2512701
              ],
              [
                57.7880332,
                33.2443736
              ],
              [
                57.7976986,
                33.2085315
              ],
              [
                57.8170825,
                33.1888698
              ],
              [
                57.8138908,
                33.1524658
              ],
              [
                57.8136107,
                33.150795
              ],
              [
                57.8133311,
                33.1502441
              ],
              [
                57.8136107,
                33.1491332
              ],
              [
                57.7959822,
                33.13942
              ],
              [
                57.7938534,
                33.1269252
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555072,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سربیشه",
          "name:en": "Sarbisheh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286335",
          "wikipedia": "en:Sarbisheh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.2243063,
                32.3588556
              ],
              [
                59.2232896,
                32.3579441
              ],
              [
                59.2232896,
                32.3540616
              ],
              [
                59.2235697,
                32.3535017
              ],
              [
                59.2238497,
                32.3465581
              ],
              [
                59.2294028,
                32.3040567
              ],
              [
                59.2299559,
                32.3021154
              ],
              [
                59.2327361,
                32.2943321
              ],
              [
                59.2500823,
                32.2646019
              ],
              [
                59.2525824,
                32.2646018
              ],
              [
                59.2551206,
                32.2670294
              ],
              [
                59.2899153,
                32.2985585
              ],
              [
                59.3082484,
                32.3010596
              ],
              [
                59.3088015,
                32.3013396
              ],
              [
                59.3115818,
                32.3013396
              ],
              [
                59.3157482,
                32.3016105
              ],
              [
                59.3415811,
                32.3030009
              ],
              [
                59.349408,
                32.3051671
              ],
              [
                59.3623142,
                32.3160778
              ],
              [
                59.365094,
                32.3163486
              ],
              [
                59.369821,
                32.3171883
              ],
              [
                59.3948363,
                32.3174577
              ],
              [
                59.4090841,
                32.312235
              ],
              [
                59.4341467,
                32.2949689
              ],
              [
                59.4925116,
                32.2819083
              ],
              [
                59.5332433,
                32.249296
              ],
              [
                59.6091508,
                32.2496731
              ],
              [
                59.6347336,
                32.255871
              ],
              [
                59.6505536,
                32.2593223
              ],
              [
                59.6669825,
                32.2626772
              ],
              [
                59.6885578,
                32.2678219
              ],
              [
                59.684505,
                32.3015316
              ],
              [
                59.6968744,
                32.3004103
              ],
              [
                59.7296924,
                32.296433
              ],
              [
                59.730816,
                32.3123897
              ],
              [
                59.7310891,
                32.3132205
              ],
              [
                59.7313693,
                32.3135003
              ],
              [
                59.7322029,
                32.3157216
              ],
              [
                59.7383159,
                32.323225
              ],
              [
                59.7519206,
                32.3353052
              ],
              [
                59.7681997,
                32.3174577
              ],
              [
                59.7917174,
                32.3062865
              ],
              [
                59.793434,
                32.2906156
              ],
              [
                59.8075102,
                32.2853913
              ],
              [
                59.8406409,
                32.2881486
              ],
              [
                59.8877021,
                32.2877834
              ],
              [
                59.8929822,
                32.2844522
              ],
              [
                59.8963155,
                32.2833417
              ],
              [
                59.9177584,
                32.2711064
              ],
              [
                59.9188717,
                32.2711064
              ],
              [
                59.932308,
                32.2601366
              ],
              [
                59.9547957,
                32.2565074
              ],
              [
                59.9670458,
                32.2459729
              ],
              [
                59.9688211,
                32.2452778
              ],
              [
                59.970761,
                32.2438872
              ],
              [
                59.9863789,
                32.2240549
              ],
              [
                60.004506,
                32.2065214
              ],
              [
                60.01757,
                32.1909165
              ],
              [
                60.028605,
                32.183495
              ],
              [
                60.0444027,
                32.1849113
              ],
              [
                60.0548489,
                32.1913185
              ],
              [
                60.1239616,
                32.1906227
              ],
              [
                60.1438429,
                32.1912411
              ],
              [
                60.1717755,
                32.2037961
              ],
              [
                60.1676556,
                32.2186107
              ],
              [
                60.2266761,
                32.224363
              ],
              [
                60.2291762,
                32.2249226
              ],
              [
                60.2305625,
                32.2249226
              ],
              [
                60.2313961,
                32.2252024
              ],
              [
                60.2383427,
                32.2260326
              ],
              [
                60.2447291,
                32.2260328
              ],
              [
                60.2450092,
                32.2257528
              ],
              [
                60.2458425,
                32.2257529
              ],
              [
                60.2463956,
                32.2254732
              ],
              [
                60.2472292,
                32.2254732
              ],
              [
                60.2475093,
                32.2254732
              ],
              [
                60.2475093,
                32.2246428
              ],
              [
                60.2480624,
                32.221872
              ],
              [
                60.2621587,
                32.184458
              ],
              [
                60.2618785,
                32.1830677
              ],
              [
                60.2516623,
                32.1263808
              ],
              [
                60.2552689,
                32.1191557
              ],
              [
                60.2558291,
                32.1188757
              ],
              [
                60.2561022,
                32.1183156
              ],
              [
                60.2706526,
                32.1048252
              ],
              [
                60.2895354,
                32.0925372
              ],
              [
                60.2662637,
                32.0728772
              ],
              [
                60.2952748,
                32.0714373
              ],
              [
                60.297294,
                32.0712112
              ],
              [
                60.3027812,
                32.070597
              ],
              [
                60.3078287,
                32.070597
              ],
              [
                60.3116581,
                32.070597
              ],
              [
                60.3154835,
                32.0705969
              ],
              [
                60.3179296,
                32.0705969
              ],
              [
                60.3312491,
                32.0723929
              ],
              [
                60.3415487,
                32.0795203
              ],
              [
                60.4009253,
                32.0737971
              ],
              [
                60.4020386,
                32.073517
              ],
              [
                60.4039785,
                32.073517
              ],
              [
                60.4237163,
                32.0812567
              ],
              [
                60.4269966,
                32.0813808
              ],
              [
                60.4310945,
                32.0815359
              ],
              [
                60.4359638,
                32.0817201
              ],
              [
                60.5536067,
                32.0867092
              ],
              [
                60.5547956,
                32.0862888
              ],
              [
                60.5583334,
                32.0850379
              ],
              [
                60.5605391,
                32.0838468
              ],
              [
                60.5638497,
                32.0795207
              ],
              [
                60.571575,
                32.0753021
              ],
              [
                60.6704777,
                32.0754713
              ],
              [
                60.6725394,
                32.0751709
              ],
              [
                60.6740368,
                32.0749528
              ],
              [
                60.6836699,
                32.0578456
              ],
              [
                60.6910513,
                32.0527534
              ],
              [
                60.7365411,
                32.0546453
              ],
              [
                60.7824276,
                32.039359
              ],
              [
                60.797247,
                32.0312692
              ],
              [
                60.8029939,
                32.0298172
              ],
              [
                60.8088103,
                32.0283476
              ],
              [
                60.8136144,
                32.0271337
              ],
              [
                60.8159668,
                32.0265393
              ],
              [
                60.8225204,
                32.0328611
              ],
              [
                60.8316968,
                32.0492082
              ],
              [
                60.8427148,
                32.0688322
              ],
              [
                60.8639632,
                32.1373621
              ],
              [
                60.882921,
                32.197736
              ],
              [
                60.8791967,
                32.2088094
              ],
              [
                60.8590962,
                32.2664924
              ],
              [
                60.8474185,
                32.340298
              ],
              [
                60.8339864,
                32.3998876
              ],
              [
                60.8149811,
                32.4804051
              ],
              [
                60.814771,
                32.4812948
              ],
              [
                60.7816089,
                32.5494463
              ],
              [
                60.7778957,
                32.5570741
              ],
              [
                60.7764187,
                32.5593351
              ],
              [
                60.7422502,
                32.5746202
              ],
              [
                60.7411369,
                32.5754509
              ],
              [
                60.7397502,
                32.5760107
              ],
              [
                60.7375298,
                32.5779521
              ],
              [
                60.7369696,
                32.578223
              ],
              [
                60.7347501,
                32.5798934
              ],
              [
                60.6853039,
                32.6207246
              ],
              [
                60.6536378,
                32.6429551
              ],
              [
                60.6464111,
                32.6473976
              ],
              [
                60.6391914,
                32.6537814
              ],
              [
                60.6364117,
                32.6562826
              ],
              [
                60.6239115,
                32.666558
              ],
              [
                60.6144652,
                32.6704497
              ],
              [
                60.613359,
                32.6704498
              ],
              [
                60.6130785,
                32.6707297
              ],
              [
                60.6114121,
                32.6707297
              ],
              [
                60.5664056,
                32.6451766
              ],
              [
                60.5544659,
                32.6401743
              ],
              [
                60.5525194,
                32.6393436
              ],
              [
                60.546406,
                32.6379531
              ],
              [
                60.5394664,
                32.637953
              ],
              [
                60.5386328,
                32.638233
              ],
              [
                60.535573,
                32.638233
              ],
              [
                60.5255733,
                32.6396146
              ],
              [
                60.5241865,
                32.6398945
              ],
              [
                60.5150198,
                32.6398945
              ],
              [
                60.5136265,
                32.6401744
              ],
              [
                60.5055732,
                32.6401744
              ],
              [
                60.5041868,
                32.6398945
              ],
              [
                60.5022399,
                32.6398945
              ],
              [
                60.5008536,
                32.6396146
              ],
              [
                60.4986265,
                32.6396146
              ],
              [
                60.4733472,
                32.6354521
              ],
              [
                60.4572339,
                32.6285085
              ],
              [
                60.4514006,
                32.6248968
              ],
              [
                60.4486275,
                32.6229554
              ],
              [
                60.435433,
                32.6169019
              ],
              [
                60.3808983,
                32.5918584
              ],
              [
                60.3530685,
                32.5790636
              ],
              [
                60.3205622,
                32.5673977
              ],
              [
                60.3016759,
                32.5601742
              ],
              [
                60.2925094,
                32.5576731
              ],
              [
                60.288896,
                32.557673
              ],
              [
                60.2822295,
                32.5565624
              ],
              [
                60.2813959,
                32.5562826
              ],
              [
                60.2786161,
                32.5565625
              ],
              [
                60.2750094,
                32.5565625
              ],
              [
                60.2741762,
                32.5568424
              ],
              [
                60.2719497,
                32.5568423
              ],
              [
                60.2658362,
                32.558233
              ],
              [
                60.2544498,
                32.5671179
              ],
              [
                60.2533364,
                32.5679486
              ],
              [
                60.2530634,
                32.5685085
              ],
              [
                60.2508363,
                32.5707297
              ],
              [
                60.2366701,
                32.5860075
              ],
              [
                60.2252836,
                32.6012854
              ],
              [
                60.188891,
                32.666839
              ],
              [
                60.1869444,
                32.6712814
              ],
              [
                60.1836111,
                32.6765637
              ],
              [
                60.1833377,
                32.6773943
              ],
              [
                60.1752778,
                32.684618
              ],
              [
                60.1691715,
                32.687399
              ],
              [
                60.1536114,
                32.6915706
              ],
              [
                60.1455582,
                32.6915706
              ],
              [
                60.1441648,
                32.6912907
              ],
              [
                60.1462374,
                32.6688952
              ],
              [
                60.13903,
                32.6762015
              ],
              [
                60.1327401,
                32.6806806
              ],
              [
                60.1257404,
                32.6821733
              ],
              [
                60.1327789,
                32.6564581
              ],
              [
                60.118333,
                32.6693291
              ],
              [
                60.1140078,
                32.6683086
              ],
              [
                60.1111528,
                32.6631243
              ],
              [
                60.1006379,
                32.6642812
              ],
              [
                60.083766,
                32.6632154
              ],
              [
                60.0702461,
                32.6621315
              ],
              [
                60.0762992,
                32.6788034
              ],
              [
                60.0689428,
                32.6818374
              ],
              [
                60.0538933,
                32.6835976
              ],
              [
                60.0495253,
                32.684284
              ],
              [
                60.0409899,
                32.6854487
              ],
              [
                60.0374556,
                32.6862435
              ],
              [
                60.0305913,
                32.6885099
              ],
              [
                60.0255105,
                32.6895483
              ],
              [
                60.0208778,
                32.6902256
              ],
              [
                60.0113724,
                32.6918328
              ],
              [
                60.0026936,
                32.6937724
              ],
              [
                59.9953091,
                32.6942934
              ],
              [
                59.9877547,
                32.6957328
              ],
              [
                59.9822107,
                32.6957607
              ],
              [
                59.9686226,
                32.6985507
              ],
              [
                59.962897,
                32.7001939
              ],
              [
                59.9438398,
                32.7041669
              ],
              [
                59.9323158,
                32.7068175
              ],
              [
                59.9100054,
                32.7111626
              ],
              [
                59.9020707,
                32.7232133
              ],
              [
                59.8884739,
                32.73168
              ],
              [
                59.8794363,
                32.7420931
              ],
              [
                59.8662184,
                32.7560975
              ],
              [
                59.8485959,
                32.7704609
              ],
              [
                59.8472092,
                32.7715714
              ],
              [
                59.8277662,
                32.7898723
              ],
              [
                59.8068236,
                32.801344
              ],
              [
                59.7928576,
                32.8219571
              ],
              [
                59.7759263,
                32.8217145
              ],
              [
                59.7652372,
                32.8281815
              ],
              [
                59.7601408,
                32.8316038
              ],
              [
                59.7577633,
                32.8342674
              ],
              [
                59.7491668,
                32.8436544
              ],
              [
                59.7396751,
                32.8568973
              ],
              [
                59.7249126,
                32.8758154
              ],
              [
                59.7309676,
                32.8869959
              ],
              [
                59.7034557,
                32.9006264
              ],
              [
                59.6908583,
                32.9066599
              ],
              [
                59.6843446,
                32.9150565
              ],
              [
                59.6805374,
                32.9212791
              ],
              [
                59.6682032,
                32.9354266
              ],
              [
                59.6657088,
                32.9180637
              ],
              [
                59.6427422,
                32.9093322
              ],
              [
                59.6249674,
                32.9071962
              ],
              [
                59.578514,
                32.8874438
              ],
              [
                59.5416926,
                32.8625022
              ],
              [
                59.5340537,
                32.8617092
              ],
              [
                59.5292472,
                32.8617993
              ],
              [
                59.5264362,
                32.8587351
              ],
              [
                59.5116137,
                32.8653884
              ],
              [
                59.4958101,
                32.868888
              ],
              [
                59.4898191,
                32.8697005
              ],
              [
                59.489729,
                32.8458023
              ],
              [
                59.4894721,
                32.8227827
              ],
              [
                59.4854735,
                32.8081977
              ],
              [
                59.4767187,
                32.7905938
              ],
              [
                59.4870638,
                32.7781522
              ],
              [
                59.4962881,
                32.7664911
              ],
              [
                59.494213,
                32.7554807
              ],
              [
                59.4935232,
                32.7458187
              ],
              [
                59.4923399,
                32.7302526
              ],
              [
                59.471021,
                32.7253052
              ],
              [
                59.4579899,
                32.7016489
              ],
              [
                59.41199,
                32.6809424
              ],
              [
                59.3943714,
                32.6559611
              ],
              [
                59.3863329,
                32.6540641
              ],
              [
                59.3733203,
                32.6509919
              ],
              [
                59.3705218,
                32.6510122
              ],
              [
                59.3613552,
                32.6482312
              ],
              [
                59.3257959,
                32.6326736
              ],
              [
                59.3249623,
                32.6326736
              ],
              [
                59.324129,
                32.6321228
              ],
              [
                59.3232958,
                32.6321228
              ],
              [
                59.3230157,
                32.6318428
              ],
              [
                59.3141292,
                32.6257299
              ],
              [
                59.3130158,
                32.6243394
              ],
              [
                59.3035758,
                32.6098924
              ],
              [
                59.3019094,
                32.605179
              ],
              [
                59.3013492,
                32.6032287
              ],
              [
                59.3010762,
                32.6021181
              ],
              [
                59.3002426,
                32.5976756
              ],
              [
                59.2999624,
                32.5946236
              ],
              [
                59.2996828,
                32.5918426
              ],
              [
                59.2994093,
                32.5910119
              ],
              [
                59.2994093,
                32.5879679
              ],
              [
                59.2994093,
                32.5851698
              ],
              [
                59.2988491,
                32.5829576
              ],
              [
                59.2988491,
                32.5804564
              ],
              [
                59.2988492,
                32.578786
              ],
              [
                59.2988491,
                32.5785061
              ],
              [
                59.298576,
                32.5776754
              ],
              [
                59.2999624,
                32.5660093
              ],
              [
                59.3002425,
                32.5571154
              ],
              [
                59.2999623,
                32.5521221
              ],
              [
                59.3002424,
                32.5512823
              ],
              [
                59.301629,
                32.522957
              ],
              [
                59.3021822,
                32.5093406
              ],
              [
                59.3024623,
                32.5068395
              ],
              [
                59.3021821,
                32.5043383
              ],
              [
                59.3019092,
                32.5012863
              ],
              [
                59.301629,
                32.4990651
              ],
              [
                59.3013489,
                32.4971147
              ],
              [
                59.3010759,
                32.493503
              ],
              [
                59.3007958,
                32.4926722
              ],
              [
                59.2982957,
                32.4871191
              ],
              [
                59.2977426,
                32.4868392
              ],
              [
                59.2969089,
                32.4854487
              ],
              [
                59.2680162,
                32.4618368
              ],
              [
                59.2655161,
                32.4598954
              ],
              [
                59.2652361,
                32.4596155
              ],
              [
                59.249683,
                32.4485094
              ],
              [
                59.2460696,
                32.4440669
              ],
              [
                59.2441231,
                32.4393355
              ],
              [
                59.2427363,
                32.4329516
              ],
              [
                59.2457894,
                32.4151726
              ],
              [
                59.2469027,
                32.4126715
              ],
              [
                59.2541294,
                32.3943417
              ],
              [
                59.2546829,
                32.3910008
              ],
              [
                59.2546829,
                32.3860076
              ],
              [
                59.2535691,
                32.3829466
              ],
              [
                59.2371829,
                32.3704499
              ],
              [
                59.2330164,
                32.3665582
              ],
              [
                59.2313495,
                32.3651677
              ],
              [
                59.2243063,
                32.3588556
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555119,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان طبس",
          "name:ar": "مقاطعة طبس",
          "name:en": "Tabas County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286560",
          "wikipedia": "en:Tabas County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.4049914,
                33.3824666
              ],
              [
                55.416872,
                33.3758326
              ],
              [
                55.4342527,
                33.3521776
              ],
              [
                55.4455764,
                33.3370295
              ],
              [
                55.467747,
                33.306446
              ],
              [
                55.4849609,
                33.2787612
              ],
              [
                55.5046955,
                33.2426785
              ],
              [
                55.5168404,
                33.2234986
              ],
              [
                55.5260851,
                33.2082013
              ],
              [
                55.5619681,
                33.150082
              ],
              [
                55.5824758,
                33.1159329
              ],
              [
                55.6060428,
                33.0782032
              ],
              [
                55.6062022,
                33.0779479
              ],
              [
                55.6266717,
                33.0440673
              ],
              [
                55.6370818,
                33.0273727
              ],
              [
                55.6455683,
                33.0132702
              ],
              [
                55.6510998,
                33.0038021
              ],
              [
                55.6574364,
                32.9939165
              ],
              [
                55.6692694,
                32.9741081
              ],
              [
                55.6847125,
                32.9535863
              ],
              [
                55.701419,
                32.9313493
              ],
              [
                55.7151986,
                32.9141661
              ],
              [
                55.7274084,
                32.8981241
              ],
              [
                55.7392913,
                32.8823339
              ],
              [
                55.7489844,
                32.8697151
              ],
              [
                55.7823031,
                32.8151888
              ],
              [
                55.806746,
                32.7885162
              ],
              [
                55.8075795,
                32.7874056
              ],
              [
                55.8228593,
                32.7740693
              ],
              [
                55.8278591,
                32.771848
              ],
              [
                55.8298058,
                32.7704666
              ],
              [
                55.8314725,
                32.7699067
              ],
              [
                55.8359157,
                32.7671257
              ],
              [
                55.8492488,
                32.7629632
              ],
              [
                55.8503621,
                32.7629632
              ],
              [
                55.8506389,
                32.7626833
              ],
              [
                55.8511955,
                32.7626833
              ],
              [
                55.8517488,
                32.7624033
              ],
              [
                55.852582,
                32.7624034
              ],
              [
                55.8528621,
                32.7621234
              ],
              [
                55.8542487,
                32.7618525
              ],
              [
                55.8550821,
                32.7615726
              ],
              [
                55.8559154,
                32.7612928
              ],
              [
                55.857582,
                32.760742
              ],
              [
                55.8600821,
                32.7593514
              ],
              [
                55.8764718,
                32.7532385
              ],
              [
                55.879805,
                32.7526877
              ],
              [
                55.8814717,
                32.7521279
              ],
              [
                55.885085,
                32.7515771
              ],
              [
                55.8984181,
                32.7504575
              ],
              [
                55.9070314,
                32.7504575
              ],
              [
                55.9081413,
                32.7501776
              ],
              [
                55.9373075,
                32.7482363
              ],
              [
                55.9634205,
                32.7424032
              ],
              [
                55.9656441,
                32.7415726
              ],
              [
                55.9720338,
                32.7396312
              ],
              [
                55.9862003,
                32.7318479
              ],
              [
                55.9925902,
                32.7276854
              ],
              [
                56.0028669,
                32.7221323
              ],
              [
                56.0306465,
                32.7087959
              ],
              [
                56.037593,
                32.7051841
              ],
              [
                56.0384263,
                32.7046244
              ],
              [
                56.0512027,
                32.6985114
              ],
              [
                56.0531461,
                32.6979606
              ],
              [
                56.0821777,
                32.6835651
              ],
              [
                56.0856488,
                32.6818432
              ],
              [
                56.1117619,
                32.6612922
              ],
              [
                56.1131519,
                32.6607324
              ],
              [
                56.1350948,
                32.6468451
              ],
              [
                56.1684311,
                32.6282355
              ],
              [
                56.1803743,
                32.621012
              ],
              [
                56.1814876,
                32.6201812
              ],
              [
                56.1842642,
                32.6187907
              ],
              [
                56.1998208,
                32.6093459
              ],
              [
                56.2009307,
                32.6082353
              ],
              [
                56.221487,
                32.5937882
              ],
              [
                56.2403767,
                32.5765691
              ],
              [
                56.2487134,
                32.5632326
              ],
              [
                56.2612131,
                32.53851
              ],
              [
                56.2620465,
                32.5376793
              ],
              [
                56.2734363,
                32.5190695
              ],
              [
                56.2778796,
                32.5124058
              ],
              [
                56.2995458,
                32.4837825
              ],
              [
                56.3048258,
                32.4782293
              ],
              [
                56.3053824,
                32.4771188
              ],
              [
                56.3114923,
                32.4668432
              ],
              [
                56.3209389,
                32.4551771
              ],
              [
                56.3623284,
                32.4057319
              ],
              [
                56.3739947,
                32.3954474
              ],
              [
                56.3742714,
                32.3951765
              ],
              [
                56.374828,
                32.3948966
              ],
              [
                56.3756614,
                32.3940659
              ],
              [
                56.3820514,
                32.3887837
              ],
              [
                56.4006644,
                32.3693433
              ],
              [
                56.4098309,
                32.3629505
              ],
              [
                56.4164975,
                32.3548962
              ],
              [
                56.4795566,
                32.291284
              ],
              [
                56.4801098,
                32.2907332
              ],
              [
                56.4809432,
                32.2904533
              ],
              [
                56.4812232,
                32.2898935
              ],
              [
                56.4892799,
                32.2848913
              ],
              [
                56.4934463,
                32.2818393
              ],
              [
                56.4935382,
                32.2817463
              ],
              [
                56.4942798,
                32.2809995
              ],
              [
                56.4945564,
                32.2801778
              ],
              [
                56.498723,
                32.2757264
              ],
              [
                56.5262225,
                32.2473922
              ],
              [
                56.5273358,
                32.2468414
              ],
              [
                56.5276123,
                32.2462816
              ],
              [
                56.542059,
                32.2329451
              ],
              [
                56.5426123,
                32.2326743
              ],
              [
                56.543169,
                32.2318346
              ],
              [
                56.5437256,
                32.2315637
              ],
              [
                56.544559,
                32.2301732
              ],
              [
                56.5615019,
                32.2093334
              ],
              [
                56.5756719,
                32.1915547
              ],
              [
                56.584005,
                32.1835005
              ],
              [
                56.5912282,
                32.1740559
              ],
              [
                56.6334509,
                32.1129457
              ],
              [
                56.6373409,
                32.1076725
              ],
              [
                56.6534506,
                32.0873839
              ],
              [
                56.6545639,
                32.0812801
              ],
              [
                56.6528972,
                32.075998
              ],
              [
                56.6359507,
                32.0576688
              ],
              [
                56.6312274,
                32.0523868
              ],
              [
                56.6309509,
                32.0518359
              ],
              [
                56.6162278,
                32.0329379
              ],
              [
                56.5967812,
                31.9996114
              ],
              [
                56.6031712,
                31.9904469
              ],
              [
                56.6028946,
                31.9893272
              ],
              [
                56.6026178,
                31.9887764
              ],
              [
                56.6026178,
                31.9879458
              ],
              [
                56.6023377,
                31.9857246
              ],
              [
                56.6020611,
                31.9834944
              ],
              [
                56.6015045,
                31.9810024
              ],
              [
                56.6009479,
                31.9762712
              ],
              [
                56.600671,
                31.9754405
              ],
              [
                56.6003946,
                31.9746098
              ],
              [
                56.5990044,
                31.9615538
              ],
              [
                56.5987278,
                31.9562718
              ],
              [
                56.5984477,
                31.9546105
              ],
              [
                56.5981712,
                31.9540507
              ],
              [
                56.5992812,
                31.9434957
              ],
              [
                56.5998378,
                31.9423851
              ],
              [
                56.6001143,
                31.9407148
              ],
              [
                56.6012279,
                31.9379428
              ],
              [
                56.6026178,
                31.932381
              ],
              [
                56.6028945,
                31.9312794
              ],
              [
                56.6023487,
                31.92502
              ],
              [
                56.6097769,
                31.92725
              ],
              [
                56.6228941,
                31.9293726
              ],
              [
                56.6280467,
                31.9304423
              ],
              [
                56.6374646,
                31.9327657
              ],
              [
                56.6501171,
                31.9354418
              ],
              [
                56.6698401,
                31.9384935
              ],
              [
                56.6728968,
                31.9390534
              ],
              [
                56.67484,
                31.9390533
              ],
              [
                56.7225426,
                31.9439345
              ],
              [
                56.7744887,
                31.9481468
              ],
              [
                56.8146451,
                31.9514446
              ],
              [
                56.8336015,
                31.9528808
              ],
              [
                56.8482444,
                31.9546717
              ],
              [
                56.8632976,
                31.9552316
              ],
              [
                56.8724277,
                31.9569589
              ],
              [
                56.8968802,
                31.9543386
              ],
              [
                56.9339453,
                31.9489167
              ],
              [
                56.9742794,
                31.9410983
              ],
              [
                57.0059688,
                31.9384932
              ],
              [
                57.0168021,
                31.9360011
              ],
              [
                57.0350552,
                31.9346053
              ],
              [
                57.0599447,
                31.9269099
              ],
              [
                57.0756343,
                31.9245975
              ],
              [
                57.1129371,
                31.9127206
              ],
              [
                57.1521367,
                31.9016862
              ],
              [
                57.2380825,
                31.8746425
              ],
              [
                57.254562,
                31.867645
              ],
              [
                57.3300447,
                31.8464389
              ],
              [
                57.3555895,
                31.8394364
              ],
              [
                57.3874964,
                31.8306892
              ],
              [
                57.4359985,
                31.8175948
              ],
              [
                57.4866482,
                31.8058106
              ],
              [
                57.5031277,
                31.7964736
              ],
              [
                57.5231893,
                31.7982451
              ],
              [
                57.5295636,
                31.7988079
              ],
              [
                57.5454345,
                31.7969758
              ],
              [
                57.5546011,
                31.7947542
              ],
              [
                57.5865273,
                31.7897211
              ],
              [
                57.5965006,
                31.7857487
              ],
              [
                57.6227433,
                31.7815856
              ],
              [
                57.6590665,
                31.7681263
              ],
              [
                57.6808293,
                31.7597914
              ],
              [
                57.6941118,
                31.7543683
              ],
              [
                57.7260756,
                31.7388418
              ],
              [
                57.7378368,
                31.720644
              ],
              [
                57.7458216,
                31.707815
              ],
              [
                57.7506402,
                31.7005402
              ],
              [
                57.7578321,
                31.7006882
              ],
              [
                57.7706312,
                31.7438322
              ],
              [
                57.7720245,
                31.7432724
              ],
              [
                57.8005542,
                31.7363406
              ],
              [
                57.9200156,
                31.6931694
              ],
              [
                57.9200875,
                31.6932948
              ],
              [
                57.9211289,
                31.6951105
              ],
              [
                57.9364007,
                31.7299198
              ],
              [
                57.9386536,
                31.7563321
              ],
              [
                57.9389336,
                31.7568919
              ],
              [
                57.9389336,
                31.7580022
              ],
              [
                57.9417068,
                31.7652242
              ],
              [
                57.9419868,
                31.7663345
              ],
              [
                57.9706,
                31.8093865
              ],
              [
                58.0393914,
                31.8680499
              ],
              [
                58.0366509,
                31.8933002
              ],
              [
                58.0587317,
                31.9047016
              ],
              [
                58.0592848,
                31.9058025
              ],
              [
                58.0712315,
                31.9246823
              ],
              [
                58.0715046,
                31.9258013
              ],
              [
                58.0511225,
                31.9902322
              ],
              [
                58.0726258,
                32.0207895
              ],
              [
                58.0784395,
                32.0446976
              ],
              [
                58.0924524,
                32.0651072
              ],
              [
                58.0943994,
                32.0667673
              ],
              [
                58.0952326,
                32.0678862
              ],
              [
                58.0957858,
                32.0678861
              ],
              [
                58.0971795,
                32.0692666
              ],
              [
                58.0988459,
                32.0709358
              ],
              [
                58.1096789,
                32.0792636
              ],
              [
                58.1107856,
                32.079823
              ],
              [
                58.1155123,
                32.0845419
              ],
              [
                58.1157858,
                32.0850922
              ],
              [
                58.1163459,
                32.085372
              ],
              [
                58.1134398,
                32.1111696
              ],
              [
                58.1153863,
                32.1142288
              ],
              [
                58.1296324,
                32.1319019
              ],
              [
                58.1299126,
                32.1321817
              ],
              [
                58.1479657,
                32.1677188
              ],
              [
                58.1529724,
                32.1760481
              ],
              [
                58.156966,
                32.1985173
              ],
              [
                58.1597457,
                32.2018472
              ],
              [
                58.2299218,
                32.2547882
              ],
              [
                58.2302019,
                32.255339
              ],
              [
                58.2297988,
                32.3216481
              ],
              [
                58.2350189,
                32.329887
              ],
              [
                58.2017799,
                32.3575964
              ],
              [
                58.20206,
                32.3581562
              ],
              [
                58.1949232,
                32.3606785
              ],
              [
                58.1884001,
                32.3737277
              ],
              [
                58.1658996,
                32.3851375
              ],
              [
                58.1658996,
                32.3887404
              ],
              [
                58.1658996,
                32.3973549
              ],
              [
                58.1586312,
                32.4405766
              ],
              [
                58.1591914,
                32.4450183
              ],
              [
                58.1591914,
                32.4561314
              ],
              [
                58.1583583,
                32.4636335
              ],
              [
                58.157245,
                32.4675245
              ],
              [
                58.1569648,
                32.4691855
              ],
              [
                58.141177,
                32.4905664
              ],
              [
                58.138677,
                32.4944577
              ],
              [
                58.126542,
                32.5060658
              ],
              [
                58.1062394,
                32.525819
              ],
              [
                58.1307214,
                32.5514441
              ],
              [
                58.1475442,
                32.5980238
              ],
              [
                58.1774996,
                32.6560693
              ],
              [
                58.1805038,
                32.6571893
              ],
              [
                58.1875633,
                32.6631507
              ],
              [
                58.173465,
                32.6766624
              ],
              [
                58.1587028,
                32.6834527
              ],
              [
                58.1513212,
                32.68562
              ],
              [
                58.144369,
                32.6926991
              ],
              [
                58.1387895,
                32.7049785
              ],
              [
                58.1401632,
                32.7096002
              ],
              [
                58.1401627,
                32.7173999
              ],
              [
                58.149433,
                32.7347291
              ],
              [
                58.1628221,
                32.7384838
              ],
              [
                58.1719206,
                32.7573968
              ],
              [
                58.1629082,
                32.7677904
              ],
              [
                58.155784,
                32.7722652
              ],
              [
                58.1520077,
                32.7786156
              ],
              [
                58.1496905,
                32.7910988
              ],
              [
                58.1471154,
                32.7961497
              ],
              [
                58.1375882,
                32.8040136
              ],
              [
                58.12128,
                32.8266639
              ],
              [
                58.1070169,
                32.8393525
              ],
              [
                58.0929659,
                32.8386537
              ],
              [
                58.084545,
                32.8363998
              ],
              [
                58.0725288,
                32.8360392
              ],
              [
                58.0652331,
                32.8395728
              ],
              [
                58.063259,
                32.8428179
              ],
              [
                58.0631732,
                32.8486588
              ],
              [
                58.0627148,
                32.8531868
              ],
              [
                58.061159,
                32.8587543
              ],
              [
                58.0487139,
                32.8631607
              ],
              [
                58.0472945,
                32.8643046
              ],
              [
                58.0378532,
                32.8642325
              ],
              [
                58.006696,
                32.8616376
              ],
              [
                58.0001729,
                32.8565186
              ],
              [
                57.9082482,
                32.9020744
              ],
              [
                57.8746026,
                32.9089922
              ],
              [
                57.8649895,
                32.9251317
              ],
              [
                57.8121178,
                32.9389632
              ],
              [
                57.7893966,
                32.9979096
              ],
              [
                57.7880099,
                33.0034355
              ],
              [
                57.7877298,
                33.005106
              ],
              [
                57.7880099,
                33.0056568
              ],
              [
                57.7877298,
                33.0076072
              ],
              [
                57.7877298,
                33.0101082
              ],
              [
                57.7863435,
                33.0167718
              ],
              [
                57.7857833,
                33.0178824
              ],
              [
                57.7855103,
                33.0198328
              ],
              [
                57.8075623,
                33.0395575
              ],
              [
                57.8070092,
                33.040668
              ],
              [
                57.798042,
                33.0587453
              ],
              [
                57.8062817,
                33.074282
              ],
              [
                57.7938534,
                33.1269252
              ],
              [
                57.7959822,
                33.13942
              ],
              [
                57.8136107,
                33.1491332
              ],
              [
                57.8133311,
                33.1502441
              ],
              [
                57.8136107,
                33.150795
              ],
              [
                57.8138908,
                33.1524658
              ],
              [
                57.8170825,
                33.1888698
              ],
              [
                57.7976986,
                33.2085315
              ],
              [
                57.7880332,
                33.2443736
              ],
              [
                57.7745688,
                33.2512701
              ],
              [
                57.7748488,
                33.2537708
              ],
              [
                57.7748489,
                33.2559916
              ],
              [
                57.781906,
                33.2669677
              ],
              [
                57.7851675,
                33.2801715
              ],
              [
                57.7750238,
                33.283854
              ],
              [
                57.7747439,
                33.2871855
              ],
              [
                57.7755639,
                33.2873601
              ],
              [
                57.7738976,
                33.2915314
              ],
              [
                57.7738976,
                33.2920822
              ],
              [
                57.7730639,
                33.2937525
              ],
              [
                57.7722307,
                33.2976439
              ],
              [
                57.7716705,
                33.2993051
              ],
              [
                57.7711174,
                33.3034674
              ],
              [
                57.7740094,
                33.3118812
              ],
              [
                57.7692028,
                33.3265125
              ],
              [
                57.8031918,
                33.3546207
              ],
              [
                57.8178688,
                33.3684563
              ],
              [
                57.8163241,
                33.3777743
              ],
              [
                57.8225897,
                33.383293
              ],
              [
                57.8272246,
                33.389743
              ],
              [
                57.8303145,
                33.4055435
              ],
              [
                57.8256367,
                33.4144636
              ],
              [
                57.8213881,
                33.4229888
              ],
              [
                57.8231047,
                33.4343066
              ],
              [
                57.8272244,
                33.449562
              ],
              [
                57.8094577,
                33.4522831
              ],
              [
                57.798128,
                33.4547895
              ],
              [
                57.7985572,
                33.4675352
              ],
              [
                57.7830218,
                33.4696116
              ],
              [
                57.7803611,
                33.485147
              ],
              [
                57.7841376,
                33.4915894
              ],
              [
                57.789127,
                33.4971859
              ],
              [
                57.7895084,
                33.4998292
              ],
              [
                57.7909424,
                33.5018715
              ],
              [
                57.7868446,
                33.5059713
              ],
              [
                57.7849945,
                33.5096799
              ],
              [
                57.7818414,
                33.5151619
              ],
              [
                57.7811617,
                33.5197334
              ],
              [
                57.7805264,
                33.5329898
              ],
              [
                57.778681,
                33.544144
              ],
              [
                57.7726459,
                33.5473568
              ],
              [
                57.7668952,
                33.5510253
              ],
              [
                57.7592125,
                33.5633335
              ],
              [
                57.738552,
                33.5583984
              ],
              [
                57.7344435,
                33.5602565
              ],
              [
                57.7303357,
                33.5668588
              ],
              [
                57.7155674,
                33.5736372
              ],
              [
                57.7127823,
                33.5887689
              ],
              [
                57.7108107,
                33.5911006
              ],
              [
                57.7094219,
                33.5948
              ],
              [
                57.7093139,
                33.6009995
              ],
              [
                57.7055166,
                33.6107595
              ],
              [
                57.6928019,
                33.626589
              ],
              [
                57.6454466,
                33.6340923
              ],
              [
                57.6440532,
                33.634652
              ],
              [
                57.6410001,
                33.6360332
              ],
              [
                57.6354468,
                33.6371436
              ],
              [
                57.6348866,
                33.6374235
              ],
              [
                57.6335004,
                33.6374235
              ],
              [
                57.6273869,
                33.6349228
              ],
              [
                57.6071072,
                33.612146
              ],
              [
                57.606554,
                33.6110357
              ],
              [
                57.6054403,
                33.6099252
              ],
              [
                57.599887,
                33.6010329
              ],
              [
                57.5951675,
                33.5935399
              ],
              [
                57.5932205,
                33.5910392
              ],
              [
                57.5432143,
                33.5360325
              ],
              [
                57.5409943,
                33.5324214
              ],
              [
                57.5279414,
                33.5260296
              ],
              [
                57.5259948,
                33.5246483
              ],
              [
                57.4940485,
                33.4965892
              ],
              [
                57.4915484,
                33.4940885
              ],
              [
                57.4668221,
                33.4815846
              ],
              [
                57.4665486,
                33.4813138
              ],
              [
                57.4648822,
                33.4804833
              ],
              [
                57.4573825,
                33.4774227
              ],
              [
                57.4398758,
                33.4729809
              ],
              [
                57.4387692,
                33.472701
              ],
              [
                57.4334889,
                33.472701
              ],
              [
                57.4234891,
                33.4696405
              ],
              [
                57.422656,
                33.4690898
              ],
              [
                57.4207094,
                33.46853
              ],
              [
                57.4193226,
                33.4685301
              ],
              [
                57.4162694,
                33.4674196
              ],
              [
                57.4146027,
                33.4674197
              ],
              [
                57.399596,
                33.4643681
              ],
              [
                57.399323,
                33.4640882
              ],
              [
                57.396823,
                33.4638084
              ],
              [
                57.3818231,
                33.4621473
              ],
              [
                57.37571,
                33.4624181
              ],
              [
                57.3748765,
                33.462698
              ],
              [
                57.37293,
                33.4626979
              ],
              [
                57.3720967,
                33.4629779
              ],
              [
                57.3701569,
                33.4629778
              ],
              [
                57.3690431,
                33.4635286
              ],
              [
                57.3679298,
                33.4635286
              ],
              [
                57.3662633,
                33.4640883
              ],
              [
                57.3654301,
                33.4640883
              ],
              [
                57.3651501,
                33.4643682
              ],
              [
                57.3643165,
                33.4643681
              ],
              [
                57.3629301,
                33.4649189
              ],
              [
                57.3620965,
                33.4649189
              ],
              [
                57.35793,
                33.4665891
              ],
              [
                57.3362636,
                33.4721414
              ],
              [
                57.3343171,
                33.4724212
              ],
              [
                57.3276505,
                33.4738117
              ],
              [
                57.2734811,
                33.5010313
              ],
              [
                57.2732045,
                33.5013112
              ],
              [
                57.2595914,
                33.5082538
              ],
              [
                57.2582048,
                33.5090934
              ],
              [
                57.2348685,
                33.5268695
              ],
              [
                57.2215352,
                33.5499269
              ],
              [
                57.220702,
                33.5529783
              ],
              [
                57.2201454,
                33.5540887
              ],
              [
                57.2201454,
                33.5543686
              ],
              [
                57.2198686,
                33.5551992
              ],
              [
                57.2198686,
                33.5554791
              ],
              [
                57.2195921,
                33.5568694
              ],
              [
                57.2176453,
                33.5610312
              ],
              [
                57.217092,
                33.5652021
              ],
              [
                57.2173688,
                33.5657618
              ],
              [
                57.2176454,
                33.5671431
              ],
              [
                57.2179255,
                33.5685333
              ],
              [
                57.2273687,
                33.5799265
              ],
              [
                57.2295919,
                33.5840883
              ],
              [
                57.2304254,
                33.5849279
              ],
              [
                57.2315353,
                33.5876993
              ],
              [
                57.2312585,
                33.5896493
              ],
              [
                57.2312586,
                33.5907598
              ],
              [
                57.230982,
                33.5927008
              ],
              [
                57.2298687,
                33.5977022
              ],
              [
                57.212369,
                33.6263109
              ],
              [
                57.2101455,
                33.6304818
              ],
              [
                57.2095924,
                33.633813
              ],
              [
                57.2095924,
                33.6343636
              ],
              [
                57.2076457,
                33.6407552
              ],
              [
                57.2070924,
                33.6418656
              ],
              [
                57.2051457,
                33.6554882
              ],
              [
                57.2048691,
                33.6571494
              ],
              [
                57.2051457,
                33.6574292
              ],
              [
                57.2068124,
                33.6674317
              ],
              [
                57.2070924,
                33.6685421
              ],
              [
                57.208479,
                33.6735344
              ],
              [
                57.2082024,
                33.6854868
              ],
              [
                57.2068124,
                33.6902081
              ],
              [
                57.1937558,
                33.7115941
              ],
              [
                57.1935566,
                33.7121926
              ],
              [
                57.1934794,
                33.7124246
              ],
              [
                57.1859793,
                33.7196465
              ],
              [
                57.1604232,
                33.7379811
              ],
              [
                57.1590331,
                33.7393712
              ],
              [
                57.1468099,
                33.7490936
              ],
              [
                57.1415334,
                33.755485
              ],
              [
                57.1312535,
                33.7807611
              ],
              [
                57.1307003,
                33.7818714
              ],
              [
                57.1301436,
                33.7832616
              ],
              [
                57.1287535,
                33.787703
              ],
              [
                57.122087,
                33.8013159
              ],
              [
                57.1062539,
                33.8277109
              ],
              [
                57.1054207,
                33.829101
              ],
              [
                57.1004208,
                33.8382634
              ],
              [
                57.086531,
                33.8652087
              ],
              [
                57.0765311,
                33.8746507
              ],
              [
                57.0765311,
                33.8749306
              ],
              [
                57.0562514,
                33.8849323
              ],
              [
                57.0484714,
                33.8943743
              ],
              [
                57.0479181,
                33.8960442
              ],
              [
                57.0187486,
                33.9338208
              ],
              [
                57.017082,
                33.9371516
              ],
              [
                57.0168052,
                33.9374314
              ],
              [
                57.0168052,
                33.9379911
              ],
              [
                57.0156919,
                33.9391014
              ],
              [
                57.0120819,
                33.9460427
              ],
              [
                57.0120819,
                33.9463226
              ],
              [
                57.0104152,
                33.9507726
              ],
              [
                57.0101387,
                33.953264
              ],
              [
                57.0073587,
                33.9624349
              ],
              [
                57.0073588,
                33.9679861
              ],
              [
                57.0076389,
                33.9685458
              ],
              [
                57.0079154,
                33.9710461
              ],
              [
                57.0065253,
                33.9857681
              ],
              [
                57.007082,
                33.9871582
              ],
              [
                57.0073588,
                33.9979898
              ],
              [
                57.0129154,
                34.0027106
              ],
              [
                57.0140254,
                34.0038208
              ],
              [
                57.0251385,
                34.0124318
              ],
              [
                57.0256954,
                34.0129914
              ],
              [
                57.0265286,
                34.013542
              ],
              [
                57.0637515,
                34.0346543
              ],
              [
                57.0640282,
                34.0352138
              ],
              [
                57.0656948,
                34.0360442
              ],
              [
                57.0676414,
                34.0377141
              ],
              [
                57.0679181,
                34.0382737
              ],
              [
                57.0684747,
                34.0385445
              ],
              [
                57.0684747,
                34.0388243
              ],
              [
                57.0695848,
                34.0399346
              ],
              [
                57.0843079,
                34.057716
              ],
              [
                57.0951412,
                34.0732678
              ],
              [
                57.1009744,
                34.0815988
              ],
              [
                57.1009744,
                34.0829977
              ],
              [
                57.1012544,
                34.0838281
              ],
              [
                57.1009743,
                34.0849384
              ],
              [
                57.1012544,
                34.0857687
              ],
              [
                57.1020878,
                34.0927097
              ],
              [
                57.104031,
                34.1018799
              ],
              [
                57.1045877,
                34.1029901
              ],
              [
                57.1048645,
                34.1046599
              ],
              [
                57.1054212,
                34.1057701
              ],
              [
                57.1056977,
                34.10716
              ],
              [
                57.1062543,
                34.1082702
              ],
              [
                57.1065312,
                34.1096602
              ],
              [
                57.1070878,
                34.1104906
              ],
              [
                57.1073643,
                34.1118806
              ],
              [
                57.1212543,
                34.1391023
              ],
              [
                57.1220876,
                34.140772
              ],
              [
                57.1234776,
                34.1443823
              ],
              [
                57.1243108,
                34.1449418
              ],
              [
                57.1323675,
                34.1627223
              ],
              [
                57.1329208,
                34.1632728
              ],
              [
                57.1345875,
                34.1685528
              ],
              [
                57.1354206,
                34.1713237
              ],
              [
                57.1384773,
                34.1774429
              ],
              [
                57.1390341,
                34.1777138
              ],
              [
                57.1418107,
                34.1841038
              ],
              [
                57.146534,
                34.1932737
              ],
              [
                57.1587572,
                34.228274
              ],
              [
                57.1593105,
                34.2302234
              ],
              [
                57.1659771,
                34.2563243
              ],
              [
                57.1662572,
                34.2566041
              ],
              [
                57.1707005,
                34.2743835
              ],
              [
                57.1865336,
                34.3035523
              ],
              [
                57.1868138,
                34.303832
              ],
              [
                57.1882039,
                34.3060521
              ],
              [
                57.1912571,
                34.3127216
              ],
              [
                57.2112603,
                34.3427199
              ],
              [
                57.2193134,
                34.3599389
              ],
              [
                57.21987,
                34.362168
              ],
              [
                57.2240367,
                34.3799374
              ],
              [
                57.2243133,
                34.3810564
              ],
              [
                57.2423698,
                34.4182731
              ],
              [
                57.2423698,
                34.4188326
              ],
              [
                57.2429266,
                34.419392
              ],
              [
                57.2437598,
                34.4210615
              ],
              [
                57.2518165,
                34.4360509
              ],
              [
                57.2526497,
                34.4368901
              ],
              [
                57.2712631,
                34.4760547
              ],
              [
                57.2718162,
                34.4771646
              ],
              [
                57.2820961,
                34.5007803
              ],
              [
                57.2823729,
                34.5013397
              ],
              [
                57.2829296,
                34.5032798
              ],
              [
                57.2829296,
                34.5041101
              ],
              [
                57.2832061,
                34.5046696
              ],
              [
                57.2834862,
                34.5054998
              ],
              [
                57.283763,
                34.5063389
              ],
              [
                57.2840396,
                34.5071691
              ],
              [
                57.2845962,
                34.5079993
              ],
              [
                57.2845963,
                34.5085588
              ],
              [
                57.2851529,
                34.5091182
              ],
              [
                57.2851529,
                34.5096687
              ],
              [
                57.2868195,
                34.5113381
              ],
              [
                57.2873727,
                34.5116178
              ],
              [
                57.2890395,
                34.5152274
              ],
              [
                57.2893196,
                34.5157778
              ],
              [
                57.2893196,
                34.5160575
              ],
              [
                57.293486,
                34.5241158
              ],
              [
                57.2940397,
                34.5243955
              ],
              [
                57.3009862,
                34.5391132
              ],
              [
                57.3065391,
                34.5485608
              ],
              [
                57.3073727,
                34.549391
              ],
              [
                57.3076529,
                34.5502302
              ],
              [
                57.3087661,
                34.551331
              ],
              [
                57.3095993,
                34.5530005
              ],
              [
                57.3118193,
                34.5557797
              ],
              [
                57.3237657,
                34.5713362
              ],
              [
                57.3243193,
                34.5724551
              ],
              [
                57.3309858,
                34.5785549
              ],
              [
                57.3690452,
                34.6082777
              ],
              [
                57.370712,
                34.6096764
              ],
              [
                57.3901585,
                34.621614
              ],
              [
                57.3904316,
                34.6218937
              ],
              [
                57.3915449,
                34.6218938
              ],
              [
                57.391825,
                34.6221735
              ],
              [
                57.3934918,
                34.6221735
              ],
              [
                57.3962649,
                34.6213434
              ],
              [
                57.4001583,
                34.6182754
              ],
              [
                57.4001583,
                34.6180047
              ],
              [
                57.4007115,
                34.6174452
              ],
              [
                57.4076582,
                34.6096763
              ],
              [
                57.4173782,
                34.5949503
              ],
              [
                57.4193247,
                34.5941201
              ],
              [
                57.4209916,
                34.5938405
              ],
              [
                57.4371043,
                34.5924509
              ],
              [
                57.4396045,
                34.5927215
              ],
              [
                57.4404376,
                34.5930012
              ],
              [
                57.4418244,
                34.5930012
              ],
              [
                57.4629374,
                34.5988392
              ],
              [
                57.601985,
                34.683443
              ],
              [
                57.6012249,
                34.7023665
              ],
              [
                57.6001531,
                34.7079128
              ],
              [
                57.6042462,
                34.7115087
              ],
              [
                57.6801682,
                34.7486169
              ],
              [
                57.6716359,
                34.7704005
              ],
              [
                57.7192454,
                34.8109783
              ],
              [
                57.7156627,
                34.8198338
              ],
              [
                57.7550444,
                34.8542178
              ],
              [
                57.753955,
                34.8608591
              ],
              [
                57.7565979,
                34.8810716
              ],
              [
                57.7624299,
                34.8926181
              ],
              [
                57.7615385,
                34.9135434
              ],
              [
                57.761481,
                34.9140592
              ],
              [
                57.757101,
                34.9157778
              ],
              [
                57.7507495,
                34.917467
              ],
              [
                57.7427259,
                34.9206582
              ],
              [
                57.7319526,
                34.9214081
              ],
              [
                57.7224253,
                34.9209859
              ],
              [
                57.7117824,
                34.9229564
              ],
              [
                57.7063951,
                34.9268426
              ],
              [
                57.7018725,
                34.9328255
              ],
              [
                57.6966934,
                34.9386079
              ],
              [
                57.6908651,
                34.9477076
              ],
              [
                57.6795256,
                34.9557837
              ],
              [
                57.6761452,
                34.9582612
              ],
              [
                57.6736452,
                34.9596593
              ],
              [
                57.6728119,
                34.9604891
              ],
              [
                57.6700322,
                34.9618782
              ],
              [
                57.6613998,
                34.968265
              ],
              [
                57.6556938,
                34.9713098
              ],
              [
                57.6497268,
                34.9745247
              ],
              [
                57.6428422,
                34.9782526
              ],
              [
                57.6181608,
                34.9930692
              ],
              [
                57.6015758,
                34.995832
              ],
              [
                57.5917053,
                34.9983983
              ],
              [
                57.5885295,
                34.9999803
              ],
              [
                57.5722217,
                35.009401
              ],
              [
                57.5673293,
                35.0130566
              ],
              [
                57.5645595,
                35.0139566
              ],
              [
                57.536371,
                35.0125375
              ],
              [
                57.5341444,
                35.0125375
              ],
              [
                57.5333111,
                35.0122577
              ],
              [
                57.5327576,
                35.0125375
              ],
              [
                57.5319243,
                35.0122577
              ],
              [
                57.530811,
                35.0122577
              ],
              [
                57.5305381,
                35.0125376
              ],
              [
                57.5288712,
                35.0125376
              ],
              [
                57.5280379,
                35.0128173
              ],
              [
                57.5269246,
                35.0128173
              ],
              [
                57.5094712,
                35.0372281
              ],
              [
                57.5033582,
                35.0391682
              ],
              [
                57.500023,
                35.0503605
              ],
              [
                57.4918315,
                35.0671804
              ],
              [
                57.4862193,
                35.0774234
              ],
              [
                57.4842483,
                35.0933066
              ],
              [
                57.4667346,
                35.115716
              ],
              [
                57.4642349,
                35.116266
              ],
              [
                57.460899,
                35.1229978
              ],
              [
                57.4520949,
                35.1269001
              ],
              [
                57.4040452,
                35.1116458
              ],
              [
                57.3920988,
                35.113873
              ],
              [
                57.3898722,
                35.1141435
              ],
              [
                57.3815389,
                35.1163708
              ],
              [
                57.3695752,
                35.1067092
              ],
              [
                57.3530957,
                35.1106412
              ],
              [
                57.3398467,
                35.1053709
              ],
              [
                57.3121604,
                35.1022517
              ],
              [
                57.3015404,
                35.1011282
              ],
              [
                57.2987673,
                35.1008487
              ],
              [
                57.2945972,
                35.1008487
              ],
              [
                57.2918207,
                35.1005781
              ],
              [
                57.2876538,
                35.1005781
              ],
              [
                57.2848739,
                35.1002985
              ],
              [
                57.2782073,
                35.1002984
              ],
              [
                57.2754307,
                35.100019
              ],
              [
                57.2715408,
                35.1000189
              ],
              [
                57.2633504,
                35.1000667
              ],
              [
                57.2391807,
                35.0975684
              ],
              [
                57.2375141,
                35.0975685
              ],
              [
                57.2255709,
                35.0961795
              ],
              [
                57.2225142,
                35.0958999
              ],
              [
                57.1725383,
                35.0738009
              ],
              [
                57.1686484,
                35.0732506
              ],
              [
                57.1661484,
                35.0724116
              ],
              [
                57.1622585,
                35.0715818
              ],
              [
                57.1321089,
                35.0610131
              ],
              [
                57.0559631,
                35.019022
              ],
              [
                57.053183,
                35.018192
              ],
              [
                57.0517965,
                35.0173622
              ],
              [
                57.0484632,
                35.0162525
              ],
              [
                57.0401266,
                35.0123643
              ],
              [
                57.0098603,
                35.0052373
              ],
              [
                57.0010372,
                35.0064486
              ],
              [
                56.9824274,
                35.0022814
              ],
              [
                56.9699475,
                34.9970978
              ],
              [
                56.9562445,
                34.9815628
              ],
              [
                56.9551345,
                34.9815627
              ],
              [
                56.9545778,
                34.9812832
              ],
              [
                56.9537445,
                34.9812831
              ],
              [
                56.9448546,
                34.9793346
              ],
              [
                56.9331913,
                34.9821804
              ],
              [
                56.9312481,
                34.9821804
              ],
              [
                56.9298581,
                34.9819007
              ],
              [
                56.9259682,
                34.9819007
              ],
              [
                56.9245813,
                34.9816211
              ],
              [
                56.9198582,
                34.9813505
              ],
              [
                56.9162449,
                34.9813505
              ],
              [
                56.9104115,
                34.9819007
              ],
              [
                56.9062449,
                34.9819008
              ],
              [
                56.9051351,
                34.9821804
              ],
              [
                56.9026351,
                34.9821804
              ],
              [
                56.9012449,
                34.9824601
              ],
              [
                56.8959685,
                34.9824601
              ],
              [
                56.8798552,
                34.9799613
              ],
              [
                56.8645754,
                34.9744045
              ],
              [
                56.8640221,
                34.9738452
              ],
              [
                56.8337425,
                34.954405
              ],
              [
                56.8273525,
                34.948848
              ],
              [
                56.8240192,
                34.9466289
              ],
              [
                56.8217959,
                34.9444006
              ],
              [
                56.8209625,
                34.9419018
              ],
              [
                56.8198526,
                34.9391233
              ],
              [
                56.820686,
                34.9374544
              ],
              [
                56.821796,
                34.9369041
              ],
              [
                56.8248525,
                34.9371747
              ],
              [
                56.8298524,
                34.9388436
              ],
              [
                56.8395756,
                34.9371747
              ],
              [
                56.8442988,
                34.9352351
              ],
              [
                56.8520755,
                34.9219018
              ],
              [
                56.8517989,
                34.9205124
              ],
              [
                56.8515221,
                34.9191232
              ],
              [
                56.8509655,
                34.9180136
              ],
              [
                56.8495757,
                34.9149554
              ],
              [
                56.835409,
                34.8946753
              ],
              [
                56.8298523,
                34.8902367
              ],
              [
                56.8179093,
                34.876903
              ],
              [
                56.8092959,
                34.8646787
              ],
              [
                56.8087393,
                34.8632893
              ],
              [
                56.8015194,
                34.853573
              ],
              [
                56.7984627,
                34.8482862
              ],
              [
                56.7976293,
                34.847727
              ],
              [
                56.795406,
                34.8452369
              ],
              [
                56.7901295,
                34.8374511
              ],
              [
                56.7837396,
                34.8305133
              ],
              [
                56.7826295,
                34.8299539
              ],
              [
                56.7823494,
                34.8293946
              ],
              [
                56.7534598,
                34.8074533
              ],
              [
                56.7531832,
                34.8066233
              ],
              [
                56.7517931,
                34.8052338
              ],
              [
                56.7490165,
                34.7971771
              ],
              [
                56.7490165,
                34.7968974
              ],
              [
                56.7479031,
                34.7932887
              ],
              [
                56.7456832,
                34.7896798
              ],
              [
                56.7398501,
                34.7827327
              ],
              [
                56.6723442,
                34.7543938
              ],
              [
                56.6665108,
                34.7521744
              ],
              [
                56.6492876,
                34.7477353
              ],
              [
                56.6462345,
                34.7477354
              ],
              [
                56.6456778,
                34.7474557
              ],
              [
                56.6445678,
                34.7474556
              ],
              [
                56.6378977,
                34.7455068
              ],
              [
                56.6373446,
                34.7449475
              ],
              [
                56.6356779,
                34.7446767
              ],
              [
                56.6256779,
                34.7405084
              ],
              [
                56.6115081,
                34.7324514
              ],
              [
                56.5662286,
                34.7177266
              ],
              [
                56.5603955,
                34.7157868
              ],
              [
                56.487893,
                34.6902256
              ],
              [
                56.4851128,
                34.6896752
              ],
              [
                56.4823365,
                34.6888451
              ],
              [
                56.4809464,
                34.6888451
              ],
              [
                56.4801129,
                34.6885654
              ],
              [
                56.479003,
                34.6885654
              ],
              [
                56.4773363,
                34.6880061
              ],
              [
                56.4734464,
                34.6868962
              ],
              [
                56.472893,
                34.6868963
              ],
              [
                56.4698366,
                34.6860662
              ],
              [
                56.4673365,
                34.6860661
              ],
              [
                56.4662232,
                34.6857864
              ],
              [
                56.4648366,
                34.6857865
              ],
              [
                56.4637232,
                34.6855067
              ],
              [
                56.4623365,
                34.6855067
              ],
              [
                56.4615034,
                34.685227
              ],
              [
                56.4584466,
                34.685227
              ],
              [
                56.45789,
                34.6849474
              ],
              [
                56.4548367,
                34.6846766
              ],
              [
                56.4512233,
                34.6846767
              ],
              [
                56.4462234,
                34.6835578
              ],
              [
                56.4384468,
                34.682448
              ],
              [
                56.4362236,
                34.6824481
              ],
              [
                56.4323336,
                34.6818977
              ],
              [
                56.4253904,
                34.682448
              ],
              [
                56.421777,
                34.6824481
              ],
              [
                56.4209437,
                34.6827278
              ],
              [
                56.4198338,
                34.6827277
              ],
              [
                56.419277,
                34.6830075
              ],
              [
                56.4184436,
                34.6830075
              ],
              [
                56.4159438,
                34.6835579
              ],
              [
                56.4126106,
                34.6835578
              ],
              [
                56.4117772,
                34.6838376
              ],
              [
                56.4109439,
                34.6835579
              ],
              [
                56.4106671,
                34.6838376
              ],
              [
                56.4078872,
                34.6838376
              ],
              [
                56.4070538,
                34.6841173
              ],
              [
                56.4028873,
                34.6841173
              ],
              [
                56.3998342,
                34.6846767
              ],
              [
                56.395944,
                34.6849474
              ],
              [
                56.3889973,
                34.6852271
              ],
              [
                56.3839975,
                34.6852271
              ],
              [
                56.3770544,
                34.6860662
              ],
              [
                56.318995,
                34.6924544
              ],
              [
                56.3131616,
                34.6924544
              ],
              [
                56.3123284,
                34.6927341
              ],
              [
                56.3098284,
                34.6930048
              ],
              [
                56.3064951,
                34.6930048
              ],
              [
                56.3051053,
                34.6932845
              ],
              [
                56.3012187,
                34.6932845
              ],
              [
                56.2998285,
                34.6935642
              ],
              [
                56.2976053,
                34.6935642
              ],
              [
                56.2962152,
                34.6938439
              ],
              [
                56.2926054,
                34.6938439
              ],
              [
                56.2912153,
                34.6941236
              ],
              [
                56.2820487,
                34.6952334
              ],
              [
                56.2787154,
                34.6957838
              ],
              [
                56.2773255,
                34.6957838
              ],
              [
                56.275659,
                34.6963432
              ],
              [
                56.2745489,
                34.6963433
              ],
              [
                56.2723257,
                34.6971733
              ],
              [
                56.2712156,
                34.6971733
              ],
              [
                56.2653824,
                34.6988425
              ],
              [
                56.2642724,
                34.6988425
              ],
              [
                56.2439926,
                34.7035614
              ],
              [
                56.2428791,
                34.7041208
              ],
              [
                56.2420459,
                34.7041208
              ],
              [
                56.2417693,
                34.7044005
              ],
              [
                56.2412125,
                34.7044005
              ],
              [
                56.2279736,
                34.7104172
              ],
              [
                56.2276029,
                34.7091193
              ],
              [
                56.2273261,
                34.7088397
              ],
              [
                56.2270463,
                34.7080096
              ],
              [
                56.2256594,
                34.7060607
              ],
              [
                56.0168348,
                34.3866309
              ],
              [
                56.0132214,
                34.3813517
              ],
              [
                56.0107213,
                34.3766319
              ],
              [
                56.0098882,
                34.3758018
              ],
              [
                55.9436991,
                34.282272
              ],
              [
                55.9108997,
                34.2474447
              ],
              [
                55.9103431,
                34.247165
              ],
              [
                55.9100664,
                34.2468852
              ],
              [
                55.9100665,
                34.2466054
              ],
              [
                55.9095096,
                34.2460549
              ],
              [
                55.909233,
                34.2457751
              ],
              [
                55.9058998,
                34.2443852
              ],
              [
                55.9050666,
                34.2443853
              ],
              [
                55.9047864,
                34.2441054
              ],
              [
                55.9042331,
                34.2441054
              ],
              [
                55.9036764,
                34.2438257
              ],
              [
                55.9014532,
                34.2432751
              ],
              [
                55.8936766,
                34.2432751
              ],
              [
                55.8931198,
                34.2435549
              ],
              [
                55.8908965,
                34.2438257
              ],
              [
                55.8900633,
                34.2435549
              ],
              [
                55.88951,
                34.2438257
              ],
              [
                55.88701,
                34.2438257
              ],
              [
                55.8864532,
                34.2441054
              ],
              [
                55.8678673,
                34.2378615
              ],
              [
                55.8670338,
                34.2381413
              ],
              [
                55.8564774,
                34.2381412
              ],
              [
                55.8553674,
                34.2384211
              ],
              [
                55.8525872,
                34.2384211
              ],
              [
                55.8514775,
                34.2387009
              ],
              [
                55.8445342,
                34.2387008
              ],
              [
                55.8434209,
                34.2384211
              ],
              [
                55.8417543,
                34.2384212
              ],
              [
                55.8106373,
                34.2429954
              ],
              [
                55.8100842,
                34.2427157
              ],
              [
                55.8075809,
                34.2424449
              ],
              [
                55.7998043,
                34.2424449
              ],
              [
                55.7986944,
                34.242165
              ],
              [
                55.7978609,
                34.2424449
              ],
              [
                55.7973043,
                34.2421651
              ],
              [
                55.7945276,
                34.2421651
              ],
              [
                55.7936944,
                34.2424449
              ],
              [
                55.7914709,
                34.2424449
              ],
              [
                55.7911944,
                34.2427157
              ],
              [
                55.7892477,
                34.2427157
              ],
              [
                55.788691,
                34.2429954
              ],
              [
                55.7867478,
                34.2429954
              ],
              [
                55.7861909,
                34.2432753
              ],
              [
                55.7828577,
                34.2432752
              ],
              [
                55.7823046,
                34.243555
              ],
              [
                55.7775812,
                34.243555
              ],
              [
                55.773138,
                34.2432752
              ],
              [
                55.7631346,
                34.2432752
              ],
              [
                55.7623014,
                34.243555
              ],
              [
                55.7531348,
                34.2441056
              ],
              [
                55.7525815,
                34.2438258
              ],
              [
                55.7520248,
                34.2441055
              ],
              [
                55.7498016,
                34.2441056
              ],
              [
                55.7492449,
                34.2438258
              ],
              [
                55.7489681,
                34.243555
              ],
              [
                55.7464682,
                34.2427157
              ],
              [
                55.7267452,
                34.2424449
              ],
              [
                55.7259118,
                34.2427157
              ],
              [
                55.7236884,
                34.2427157
              ],
              [
                55.7228551,
                34.2429955
              ],
              [
                55.710912,
                34.2429954
              ],
              [
                55.7095219,
                34.2427157
              ],
              [
                55.6786891,
                34.2421652
              ],
              [
                55.6775756,
                34.242445
              ],
              [
                55.6697991,
                34.2424449
              ],
              [
                55.6689659,
                34.2427157
              ],
              [
                55.6597993,
                34.242445
              ],
              [
                55.6584094,
                34.2421652
              ],
              [
                55.6547961,
                34.2421651
              ],
              [
                55.6534093,
                34.242445
              ],
              [
                55.5957227,
                34.2647793
              ],
              [
                55.5524977,
                34.2622428
              ],
              [
                55.5338286,
                34.2684953
              ],
              [
                55.5209677,
                34.2718896
              ],
              [
                55.5007367,
                34.2674919
              ],
              [
                55.5005651,
                34.2445108
              ],
              [
                55.5005841,
                34.2238194
              ],
              [
                55.5004484,
                34.1746438
              ],
              [
                55.5006008,
                34.1548445
              ],
              [
                55.5007783,
                34.1387155
              ],
              [
                55.500385,
                34.1062723
              ],
              [
                55.5006366,
                34.0926371
              ],
              [
                55.5003352,
                34.0770147
              ],
              [
                55.500415,
                34.058876
              ],
              [
                55.5003959,
                34.0487802
              ],
              [
                55.5002874,
                34.0373987
              ],
              [
                55.5002682,
                34.0249969
              ],
              [
                55.5002932,
                34.0102337
              ],
              [
                55.5004637,
                33.999842
              ],
              [
                55.503854,
                33.9809113
              ],
              [
                55.5080896,
                33.9558693
              ],
              [
                55.5111605,
                33.9408474
              ],
              [
                55.5275519,
                33.852175
              ],
              [
                55.5323695,
                33.8260771
              ],
              [
                55.5379485,
                33.8006185
              ],
              [
                55.5408667,
                33.7904187
              ],
              [
                55.5443,
                33.7797181
              ],
              [
                55.5612156,
                33.663732
              ],
              [
                55.5608722,
                33.6496318
              ],
              [
                55.559903,
                33.6318541
              ],
              [
                55.557179,
                33.616369
              ],
              [
                55.5534157,
                33.6053637
              ],
              [
                55.5479891,
                33.5902184
              ],
              [
                55.5447942,
                33.5811191
              ],
              [
                55.540566,
                33.5698173
              ],
              [
                55.5354829,
                33.5526702
              ],
              [
                55.5326063,
                33.5440686
              ],
              [
                55.5287619,
                33.5423135
              ],
              [
                55.518076,
                33.5377327
              ],
              [
                55.5097279,
                33.5336609
              ],
              [
                55.5041847,
                33.5300843
              ],
              [
                55.4983399,
                33.5246551
              ],
              [
                55.4923724,
                33.5194296
              ],
              [
                55.4821583,
                33.506477
              ],
              [
                55.4324623,
                33.4254962
              ],
              [
                55.4256223,
                33.4149185
              ],
              [
                55.4184209,
                33.4035702
              ],
              [
                55.4110605,
                33.3920444
              ],
              [
                55.4049914,
                33.3824666
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555132,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فردوس",
          "name:ar": "مقاطعة فردوس",
          "name:az": "Firdovs şəhristanı",
          "name:ceb": "Ferdows (munisipyo)",
          "name:de": "Ferdows (Verwaltungsbezirk)",
          "name:en": "Ferdows County",
          "name:it": "Shahrestān di Ferdows",
          "name:ku": "Ferdovs (navçe)",
          "name:nan": "Ferdows Kūn",
          "name:nn": "Ferdows fylke",
          "name:ps": "فردوس ولسوالي",
          "name:sh": "Firduški okrug",
          "name:sv": "Ferdows (shahrestan)",
          "name:tg": "Шаҳристони Фирдавс",
          "name:tr": "Firdevs şehristanı",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286278",
          "wikipedia": "en:Ferdows County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.671879,
                33.8121615
              ],
              [
                57.6759123,
                33.8075233
              ],
              [
                57.6818558,
                33.8018453
              ],
              [
                57.6900671,
                33.7912746
              ],
              [
                57.6989935,
                33.7765791
              ],
              [
                57.7068899,
                33.7694445
              ],
              [
                57.7211378,
                33.7608821
              ],
              [
                57.7232075,
                33.7493266
              ],
              [
                57.7230261,
                33.741471
              ],
              [
                57.7243206,
                33.7383817
              ],
              [
                57.7375525,
                33.7288232
              ],
              [
                57.7429276,
                33.7246037
              ],
              [
                57.747116,
                33.7150814
              ],
              [
                57.7515178,
                33.7150726
              ],
              [
                57.7721372,
                33.7235611
              ],
              [
                57.7776685,
                33.7165707
              ],
              [
                57.7712622,
                33.7041713
              ],
              [
                57.7770994,
                33.6959231
              ],
              [
                57.7823584,
                33.6887621
              ],
              [
                57.7860968,
                33.679099
              ],
              [
                57.7921682,
                33.6736316
              ],
              [
                57.7967398,
                33.6707803
              ],
              [
                57.8007739,
                33.661806
              ],
              [
                57.7991431,
                33.6574807
              ],
              [
                57.7952581,
                33.6541287
              ],
              [
                57.7897017,
                33.6433606
              ],
              [
                57.8020748,
                33.6397537
              ],
              [
                57.8016946,
                33.6317337
              ],
              [
                57.7974697,
                33.6243037
              ],
              [
                57.7992024,
                33.6129162
              ],
              [
                57.8040805,
                33.6080687
              ],
              [
                57.8042723,
                33.5949534
              ],
              [
                57.8107251,
                33.5851792
              ],
              [
                57.8093362,
                33.579265
              ],
              [
                57.8054513,
                33.5732541
              ],
              [
                57.8049137,
                33.5678466
              ],
              [
                57.8001304,
                33.5612162
              ],
              [
                57.7807217,
                33.5577297
              ],
              [
                57.7753169,
                33.555254
              ],
              [
                57.7668952,
                33.5510253
              ],
              [
                57.7726459,
                33.5473568
              ],
              [
                57.778681,
                33.544144
              ],
              [
                57.7805264,
                33.5329898
              ],
              [
                57.7811617,
                33.5197334
              ],
              [
                57.7818414,
                33.5151619
              ],
              [
                57.7849945,
                33.5096799
              ],
              [
                57.7868446,
                33.5059713
              ],
              [
                57.7909424,
                33.5018715
              ],
              [
                57.7895084,
                33.4998292
              ],
              [
                57.789127,
                33.4971859
              ],
              [
                57.7841376,
                33.4915894
              ],
              [
                57.7803611,
                33.485147
              ],
              [
                57.7830218,
                33.4696116
              ],
              [
                57.7985572,
                33.4675352
              ],
              [
                57.798128,
                33.4547895
              ],
              [
                57.8094577,
                33.4522831
              ],
              [
                57.8272244,
                33.449562
              ],
              [
                57.8231047,
                33.4343066
              ],
              [
                57.8213881,
                33.4229888
              ],
              [
                57.8256367,
                33.4144636
              ],
              [
                57.8303145,
                33.4055435
              ],
              [
                57.8272246,
                33.389743
              ],
              [
                57.8225897,
                33.383293
              ],
              [
                57.8163241,
                33.3777743
              ],
              [
                57.8178688,
                33.3684563
              ],
              [
                57.8031918,
                33.3546207
              ],
              [
                57.8126333,
                33.3576316
              ],
              [
                57.8222464,
                33.3619329
              ],
              [
                57.8334045,
                33.3676676
              ],
              [
                57.8419017,
                33.3694597
              ],
              [
                57.8466224,
                33.3716817
              ],
              [
                57.8522014,
                33.3753373
              ],
              [
                57.8670501,
                33.3762691
              ],
              [
                57.8737449,
                33.3759823
              ],
              [
                57.8745174,
                33.3828271
              ],
              [
                57.8790664,
                33.3931111
              ],
              [
                57.8832721,
                33.3998111
              ],
              [
                57.8919839,
                33.4049702
              ],
              [
                57.8993225,
                33.4080511
              ],
              [
                57.9377317,
                33.4042895
              ],
              [
                57.9536533,
                33.4186904
              ],
              [
                57.9596614,
                33.4309758
              ],
              [
                57.9866552,
                33.431513
              ],
              [
                57.9950237,
                33.4350944
              ],
              [
                57.9998302,
                33.4385682
              ],
              [
                58.0053234,
                33.438425
              ],
              [
                58.037467,
                33.4520324
              ],
              [
                58.0411893,
                33.4565264
              ],
              [
                58.0469988,
                33.4611152
              ],
              [
                58.0475113,
                33.4653397
              ],
              [
                58.0489931,
                33.4689614
              ],
              [
                58.052568,
                33.4730125
              ],
              [
                58.0519264,
                33.4742545
              ],
              [
                58.0458075,
                33.4780489
              ],
              [
                58.0453691,
                33.4827232
              ],
              [
                58.0455626,
                33.4874865
              ],
              [
                58.0533842,
                33.4913072
              ],
              [
                58.0529378,
                33.4974243
              ],
              [
                58.0564782,
                33.5053319
              ],
              [
                58.0601522,
                33.5149656
              ],
              [
                58.0625048,
                33.524644
              ],
              [
                58.0521871,
                33.5285416
              ],
              [
                58.0494356,
                33.5350585
              ],
              [
                58.0418145,
                33.5480444
              ],
              [
                58.0488964,
                33.5493475
              ],
              [
                58.0596613,
                33.5496314
              ],
              [
                58.0595516,
                33.5551052
              ],
              [
                58.057462,
                33.5593733
              ],
              [
                58.0656477,
                33.5626131
              ],
              [
                58.0753418,
                33.5651939
              ],
              [
                58.0864071,
                33.5658672
              ],
              [
                58.0943415,
                33.5682272
              ],
              [
                58.1006522,
                33.571199
              ],
              [
                58.1011785,
                33.5784742
              ],
              [
                58.0966677,
                33.5955567
              ],
              [
                58.0920934,
                33.6017765
              ],
              [
                58.1014469,
                33.6084839
              ],
              [
                58.1194767,
                33.6265029
              ],
              [
                58.1194947,
                33.6327069
              ],
              [
                58.1225649,
                33.6378373
              ],
              [
                58.1311864,
                33.6421246
              ],
              [
                58.1446974,
                33.6478075
              ],
              [
                58.1589899,
                33.6525209
              ],
              [
                58.1599427,
                33.6848843
              ],
              [
                58.1705405,
                33.6897712
              ],
              [
                58.1824779,
                33.6952446
              ],
              [
                58.1761309,
                33.7022382
              ],
              [
                58.1759636,
                33.7094573
              ],
              [
                58.1713712,
                33.719803
              ],
              [
                58.1710623,
                33.7311927
              ],
              [
                58.1741522,
                33.7390443
              ],
              [
                58.1831064,
                33.7520323
              ],
              [
                58.1745899,
                33.7678234
              ],
              [
                58.1794667,
                33.7766447
              ],
              [
                58.1794215,
                33.7827489
              ],
              [
                58.1758688,
                33.7917026
              ],
              [
                58.1614493,
                33.8088203
              ],
              [
                58.1583571,
                33.8149564
              ],
              [
                58.1702016,
                33.8224899
              ],
              [
                58.1792662,
                33.8291821
              ],
              [
                58.1800909,
                33.840116
              ],
              [
                58.1773444,
                33.8469436
              ],
              [
                58.1823476,
                33.8546062
              ],
              [
                58.1774398,
                33.8575641
              ],
              [
                58.1756779,
                33.8609656
              ],
              [
                58.1827859,
                33.8696195
              ],
              [
                58.1834066,
                33.8755565
              ],
              [
                58.200035,
                33.8824332
              ],
              [
                58.2061768,
                33.892815
              ],
              [
                58.2019533,
                33.9017193
              ],
              [
                58.1997195,
                33.9129124
              ],
              [
                58.1944789,
                33.9290924
              ],
              [
                58.191363,
                33.9400759
              ],
              [
                58.1978011,
                33.9434933
              ],
              [
                58.2023344,
                33.9458145
              ],
              [
                58.2114954,
                33.9501472
              ],
              [
                58.2175303,
                33.9450753
              ],
              [
                58.2207803,
                33.9434411
              ],
              [
                58.229828,
                33.9397668
              ],
              [
                58.2393587,
                33.9359524
              ],
              [
                58.245247,
                33.9338016
              ],
              [
                58.252581,
                33.931574
              ],
              [
                58.2674383,
                33.927116
              ],
              [
                58.2821741,
                33.9222296
              ],
              [
                58.2973091,
                33.9255236
              ],
              [
                58.3150694,
                33.930199
              ],
              [
                58.3313219,
                33.9344256
              ],
              [
                58.3830211,
                33.9440791
              ],
              [
                58.4024867,
                33.949083
              ],
              [
                58.4208681,
                33.9557678
              ],
              [
                58.4407452,
                33.9684222
              ],
              [
                58.4418703,
                33.9694744
              ],
              [
                58.4558376,
                33.9904822
              ],
              [
                58.4440289,
                33.9935708
              ],
              [
                58.4310159,
                33.9929998
              ],
              [
                58.414756,
                33.9883605
              ],
              [
                58.390196,
                33.9837595
              ],
              [
                58.3677006,
                33.9829808
              ],
              [
                58.3541269,
                33.9884577
              ],
              [
                58.3432739,
                33.995172
              ],
              [
                58.3395691,
                33.9976313
              ],
              [
                58.3452217,
                34.0032163
              ],
              [
                58.3466782,
                34.003959
              ],
              [
                58.3482585,
                34.0043786
              ],
              [
                58.349092,
                34.0046583
              ],
              [
                58.3496453,
                34.0049292
              ],
              [
                58.3496452,
                34.005209
              ],
              [
                58.3501983,
                34.005209
              ],
              [
                58.3504784,
                34.0054887
              ],
              [
                58.3507585,
                34.0057686
              ],
              [
                58.351032,
                34.0057686
              ],
              [
                58.3513121,
                34.0057686
              ],
              [
                58.3518652,
                34.0060484
              ],
              [
                58.3524253,
                34.0063192
              ],
              [
                58.3529785,
                34.006599
              ],
              [
                58.353532,
                34.0068788
              ],
              [
                58.3540918,
                34.0074294
              ],
              [
                58.3546453,
                34.0077092
              ],
              [
                58.3551984,
                34.0079891
              ],
              [
                58.3554785,
                34.0079891
              ],
              [
                58.3563118,
                34.0082688
              ],
              [
                58.3574251,
                34.0088195
              ],
              [
                58.3579786,
                34.0090993
              ],
              [
                58.3590919,
                34.0096499
              ],
              [
                58.3599251,
                34.0102095
              ],
              [
                58.3604782,
                34.0104894
              ],
              [
                58.3610318,
                34.0104893
              ],
              [
                58.3613118,
                34.0107691
              ],
              [
                58.361592,
                34.011049
              ],
              [
                58.362145,
                34.0110489
              ],
              [
                58.3621451,
                34.0113198
              ],
              [
                58.3626982,
                34.0115996
              ],
              [
                58.3632584,
                34.0118794
              ],
              [
                58.3635318,
                34.0121502
              ],
              [
                58.3638119,
                34.0121501
              ],
              [
                58.3646451,
                34.0124299
              ],
              [
                58.3654784,
                34.0129896
              ],
              [
                58.3657584,
                34.0129896
              ],
              [
                58.3665917,
                34.0135402
              ],
              [
                58.3674249,
                34.01382
              ],
              [
                58.3676983,
                34.0140998
              ],
              [
                58.3685315,
                34.0143796
              ],
              [
                58.3693648,
                34.0146504
              ],
              [
                58.369925,
                34.0149302
              ],
              [
                58.3707586,
                34.0152101
              ],
              [
                58.3715918,
                34.0157697
              ],
              [
                58.3721449,
                34.0157697
              ],
              [
                58.3729781,
                34.0160405
              ],
              [
                58.3738117,
                34.0163203
              ],
              [
                58.3740919,
                34.0166001
              ],
              [
                58.374925,
                34.0166001
              ],
              [
                58.3757583,
                34.0171507
              ],
              [
                58.3763113,
                34.0171507
              ],
              [
                58.377145,
                34.0177103
              ],
              [
                58.3782583,
                34.0179901
              ],
              [
                58.3785314,
                34.0179901
              ],
              [
                58.379365,
                34.0182699
              ],
              [
                58.3799248,
                34.0185407
              ],
              [
                58.3801981,
                34.0185407
              ],
              [
                58.3807584,
                34.0188205
              ],
              [
                58.3815915,
                34.0191003
              ],
              [
                58.3821448,
                34.0193801
              ],
              [
                58.3829783,
                34.0196509
              ],
              [
                58.3835315,
                34.0199398
              ],
              [
                58.3849249,
                34.0204903
              ],
              [
                58.3857432,
                34.0208088
              ],
              [
                58.3865758,
                34.0212083
              ],
              [
                58.387425,
                34.0216006
              ],
              [
                58.3882581,
                34.0218713
              ],
              [
                58.3885383,
                34.0219528
              ],
              [
                58.3891196,
                34.0220257
              ],
              [
                58.3896743,
                34.0222169
              ],
              [
                58.3903161,
                34.0223199
              ],
              [
                58.3909474,
                34.0225707
              ],
              [
                58.3917587,
                34.0227009
              ],
              [
                58.3923863,
                34.0229722
              ],
              [
                58.3933604,
                34.0231528
              ],
              [
                58.3940831,
                34.0233469
              ],
              [
                58.3946935,
                34.0234245
              ],
              [
                58.3960951,
                34.0238284
              ],
              [
                58.397366,
                34.0243789
              ],
              [
                58.3980641,
                34.0246648
              ],
              [
                58.3987859,
                34.0248866
              ],
              [
                58.3996079,
                34.025429
              ],
              [
                58.4002403,
                34.026062
              ],
              [
                58.4007899,
                34.0265732
              ],
              [
                58.4013189,
                34.026994
              ],
              [
                58.4016391,
                34.0274178
              ],
              [
                58.4019937,
                34.0278702
              ],
              [
                58.4023227,
                34.0282729
              ],
              [
                58.4025483,
                34.0286232
              ],
              [
                58.4029971,
                34.0290765
              ],
              [
                58.4034823,
                34.0295404
              ],
              [
                58.4043714,
                34.0302116
              ],
              [
                58.4050102,
                34.030695
              ],
              [
                58.4058026,
                34.0309253
              ],
              [
                58.4068714,
                34.0318723
              ],
              [
                58.4074246,
                34.0321522
              ],
              [
                58.4082578,
                34.0329915
              ],
              [
                58.4090914,
                34.0332714
              ],
              [
                58.4093711,
                34.0335421
              ],
              [
                58.4102047,
                34.0341017
              ],
              [
                58.4107579,
                34.0343726
              ],
              [
                58.4113109,
                34.0346524
              ],
              [
                58.4121446,
                34.035212
              ],
              [
                58.4129778,
                34.0357716
              ],
              [
                58.4132579,
                34.0360424
              ],
              [
                58.413811,
                34.036602
              ],
              [
                58.4146442,
                34.0371526
              ],
              [
                58.4149243,
                34.0371526
              ],
              [
                58.4154778,
                34.0377123
              ],
              [
                58.4160376,
                34.0382719
              ],
              [
                58.4163111,
                34.0382719
              ],
              [
                58.4171443,
                34.0388224
              ],
              [
                58.4177045,
                34.0393821
              ],
              [
                58.4182577,
                34.0396529
              ],
              [
                58.4188112,
                34.0402125
              ],
              [
                58.4196443,
                34.0410429
              ],
              [
                58.4202046,
                34.0413227
              ],
              [
                58.4207576,
                34.0418823
              ],
              [
                58.4213112,
                34.0421531
              ],
              [
                58.4215909,
                34.0424329
              ],
              [
                58.4224246,
                34.0429835
              ],
              [
                58.4232577,
                34.0438229
              ],
              [
                58.4238179,
                34.0441027
              ],
              [
                58.4246511,
                34.0449331
              ],
              [
                58.4254844,
                34.0454837
              ],
              [
                58.4257578,
                34.0457635
              ],
              [
                58.426591,
                34.0463231
              ],
              [
                58.4277043,
                34.0471535
              ],
              [
                58.4279844,
                34.0474334
              ],
              [
                58.4288177,
                34.0477132
              ],
              [
                58.4293711,
                34.0482637
              ],
              [
                58.4296512,
                34.0485435
              ],
              [
                58.4302044,
                34.0491032
              ],
              [
                58.4304845,
                34.049383
              ],
              [
                58.4313177,
                34.0499336
              ],
              [
                58.4315912,
                34.0502134
              ],
              [
                58.4318708,
                34.0504931
              ],
              [
                58.4324244,
                34.050764
              ],
              [
                58.4329845,
                34.0510438
              ],
              [
                58.4332575,
                34.0513236
              ],
              [
                58.4340908,
                34.0518832
              ],
              [
                58.4352041,
                34.0527136
              ],
              [
                58.4357577,
                34.0529934
              ],
              [
                58.4365909,
                34.0538239
              ],
              [
                58.4377042,
                34.0543744
              ],
              [
                58.4382578,
                34.054934
              ],
              [
                58.4390909,
                34.0554937
              ],
              [
                58.4396511,
                34.0557644
              ],
              [
                58.4402041,
                34.0560443
              ],
              [
                58.4407573,
                34.0566038
              ],
              [
                58.4415909,
                34.0571545
              ],
              [
                58.4418711,
                34.0571544
              ],
              [
                58.4421508,
                34.057714
              ],
              [
                58.4424242,
                34.057714
              ],
              [
                58.4427042,
                34.0579939
              ],
              [
                58.4429843,
                34.0582646
              ],
              [
                58.4435375,
                34.0585445
              ],
              [
                58.4440906,
                34.0588243
              ],
              [
                58.4441946,
                34.0621835
              ],
              [
                58.4604091,
                34.0772379
              ],
              [
                58.4654059,
                34.0815654
              ],
              [
                58.46632,
                34.0836945
              ],
              [
                58.4659338,
                34.0849296
              ],
              [
                58.4662771,
                34.0854716
              ],
              [
                58.4651613,
                34.0902697
              ],
              [
                58.4636163,
                34.1003627
              ],
              [
                58.4579085,
                34.1137233
              ],
              [
                58.4582519,
                34.1201897
              ],
              [
                58.4608268,
                34.1236003
              ],
              [
                58.4671783,
                34.138307
              ],
              [
                58.4469222,
                34.1577167
              ],
              [
                58.4452056,
                34.1616052
              ],
              [
                58.4450984,
                34.1645347
              ],
              [
                58.4447336,
                34.1653159
              ],
              [
                58.4435963,
                34.1683874
              ],
              [
                58.4435534,
                34.1707486
              ],
              [
                58.4432316,
                34.1721334
              ],
              [
                58.4424162,
                34.1727547
              ],
              [
                58.4431379,
                34.1738136
              ],
              [
                58.4384621,
                34.1783383
              ],
              [
                58.4359778,
                34.1815256
              ],
              [
                58.4316444,
                34.1863524
              ],
              [
                58.4324169,
                34.1902573
              ],
              [
                58.4331464,
                34.1925647
              ],
              [
                58.4343051,
                34.1948365
              ],
              [
                58.4330177,
                34.1959369
              ],
              [
                58.4306144,
                34.2002673
              ],
              [
                58.4237816,
                34.2127084
              ],
              [
                58.4216022,
                34.2149962
              ],
              [
                58.4195725,
                34.2158732
              ],
              [
                58.418355,
                34.2165393
              ],
              [
                58.4172214,
                34.2191257
              ],
              [
                58.4191131,
                34.2232468
              ],
              [
                58.4188342,
                34.2245952
              ],
              [
                58.4191346,
                34.2251806
              ],
              [
                58.4178256,
                34.2313192
              ],
              [
                58.4149074,
                34.2418919
              ],
              [
                58.4148982,
                34.2467382
              ],
              [
                58.4146198,
                34.2533691
              ],
              [
                58.4038992,
                34.2552993
              ],
              [
                58.3986895,
                34.2590667
              ],
              [
                58.3941755,
                34.2631686
              ],
              [
                58.3853816,
                34.2716162
              ],
              [
                58.3838352,
                34.275102
              ],
              [
                58.3786422,
                34.2818634
              ],
              [
                58.3718204,
                34.288141
              ],
              [
                58.3658978,
                34.2916868
              ],
              [
                58.3650814,
                34.2986035
              ],
              [
                58.3632444,
                34.305363
              ],
              [
                58.3613631,
                34.3105302
              ],
              [
                58.3458369,
                34.3074126
              ],
              [
                58.3413405,
                34.3069474
              ],
              [
                58.3381567,
                34.3066744
              ],
              [
                58.3348046,
                34.3065924
              ],
              [
                58.3323063,
                34.3065599
              ],
              [
                58.3270347,
                34.3064324
              ],
              [
                58.3218615,
                34.3063884
              ],
              [
                58.3178452,
                34.3062566
              ],
              [
                58.3141344,
                34.3061921
              ],
              [
                58.3090988,
                34.3059065
              ],
              [
                58.302484,
                34.3058445
              ],
              [
                58.29648,
                34.3058053
              ],
              [
                58.2910081,
                34.3066148
              ],
              [
                58.2857094,
                34.3088056
              ],
              [
                58.282168,
                34.3106676
              ],
              [
                58.2783749,
                34.3121136
              ],
              [
                58.2732168,
                34.3143966
              ],
              [
                58.2699022,
                34.3154378
              ],
              [
                58.2674035,
                34.3159404
              ],
              [
                58.2593839,
                34.312246
              ],
              [
                58.2729005,
                34.2956576
              ],
              [
                58.2760201,
                34.2909321
              ],
              [
                58.2729123,
                34.2840504
              ],
              [
                58.270925,
                34.2817319
              ],
              [
                58.2637261,
                34.2747201
              ],
              [
                58.262176,
                34.2727155
              ],
              [
                58.260728,
                34.2705236
              ],
              [
                58.2592885,
                34.2684303
              ],
              [
                58.2559627,
                34.2638607
              ],
              [
                58.2552695,
                34.2629602
              ],
              [
                58.250273,
                34.2644759
              ],
              [
                58.247253,
                34.26385
              ],
              [
                58.2449205,
                34.2629363
              ],
              [
                58.2429828,
                34.2616149
              ],
              [
                58.2389451,
                34.2582268
              ],
              [
                58.2367276,
                34.2531717
              ],
              [
                58.2372831,
                34.2482048
              ],
              [
                58.2382413,
                34.2441694
              ],
              [
                58.2392156,
                34.2419976
              ],
              [
                58.2358646,
                34.2365702
              ],
              [
                58.2201094,
                34.2229363
              ],
              [
                58.2120036,
                34.2228742
              ],
              [
                58.206253,
                34.2245775
              ],
              [
                58.1996326,
                34.2287508
              ],
              [
                58.1851862,
                34.2351881
              ],
              [
                58.1733678,
                34.2365279
              ],
              [
                58.1672,
                34.2345834
              ],
              [
                58.1578355,
                34.2317067
              ],
              [
                58.1401148,
                34.2316277
              ],
              [
                58.1248855,
                34.2347253
              ],
              [
                58.1206798,
                34.2371379
              ],
              [
                58.1132125,
                34.2404728
              ],
              [
                58.1052726,
                34.2442376
              ],
              [
                58.0966472,
                34.2486323
              ],
              [
                58.0920123,
                34.2495546
              ],
              [
                58.082375,
                34.2542869
              ],
              [
                58.0705546,
                34.2611891
              ],
              [
                58.0626582,
                34.2668639
              ],
              [
                58.05768,
                34.2717581
              ],
              [
                58.0502128,
                34.2760137
              ],
              [
                58.044033,
                34.2795599
              ],
              [
                58.0392264,
                34.2799854
              ],
              [
                58.0251502,
                34.2778577
              ],
              [
                58.0147808,
                34.2741276
              ],
              [
                57.9987905,
                34.2820302
              ],
              [
                57.9803466,
                34.2856589
              ],
              [
                57.975406,
                34.2879701
              ],
              [
                57.964351,
                34.2922367
              ],
              [
                57.9593275,
                34.2957784
              ],
              [
                57.9539265,
                34.3013511
              ],
              [
                57.9515173,
                34.3048063
              ],
              [
                57.9419722,
                34.307855
              ],
              [
                57.9383516,
                34.3087917
              ],
              [
                57.9351151,
                34.3098197
              ],
              [
                57.9316415,
                34.3102729
              ],
              [
                57.9290691,
                34.3119035
              ],
              [
                57.9271876,
                34.3137037
              ],
              [
                57.925067,
                34.3165749
              ],
              [
                57.9206943,
                34.3175653
              ],
              [
                57.9150898,
                34.3155527
              ],
              [
                57.9109044,
                34.3147337
              ],
              [
                57.9099615,
                34.3201858
              ],
              [
                57.9071814,
                34.321305
              ],
              [
                57.9046813,
                34.3218556
              ],
              [
                57.9032879,
                34.3218556
              ],
              [
                57.9027347,
                34.3221354
              ],
              [
                57.8945645,
                34.3373036
              ],
              [
                57.8940115,
                34.3375834
              ],
              [
                57.8832398,
                34.3443868
              ],
              [
                57.8824066,
                34.3441071
              ],
              [
                57.8818464,
                34.3443869
              ],
              [
                57.8810132,
                34.3441071
              ],
              [
                57.8762932,
                34.3441072
              ],
              [
                57.8757329,
                34.3438275
              ],
              [
                57.8751798,
                34.3438275
              ],
              [
                57.873513,
                34.3438274
              ],
              [
                57.8676797,
                34.3432771
              ],
              [
                57.8671266,
                34.3429973
              ],
              [
                57.8657332,
                34.3429973
              ],
              [
                57.8651801,
                34.3427176
              ],
              [
                57.8643464,
                34.3427177
              ],
              [
                57.8640668,
                34.3424379
              ],
              [
                57.8623999,
                34.3424379
              ],
              [
                57.8465386,
                34.3444666
              ],
              [
                57.8457053,
                34.3441868
              ],
              [
                57.7721865,
                34.3488601
              ],
              [
                57.7719065,
                34.3491397
              ],
              [
                57.7713529,
                34.3496993
              ],
              [
                57.76695,
                34.3546226
              ],
              [
                57.7499984,
                34.3303493
              ],
              [
                57.738857,
                34.3232273
              ],
              [
                57.7291693,
                34.3143843
              ],
              [
                57.7200393,
                34.3085461
              ],
              [
                57.7131781,
                34.3012731
              ],
              [
                57.6979297,
                34.2905896
              ],
              [
                57.6851199,
                34.2817025
              ],
              [
                57.6809552,
                34.2811294
              ],
              [
                57.6720046,
                34.2836513
              ],
              [
                57.6671797,
                34.2821698
              ],
              [
                57.6616185,
                34.2770833
              ],
              [
                57.6611333,
                34.2749681
              ],
              [
                57.6428376,
                34.2741361
              ],
              [
                57.6402754,
                34.2734991
              ],
              [
                57.6304549,
                34.2725348
              ],
              [
                57.6200898,
                34.2759029
              ],
              [
                57.5925706,
                34.2687276
              ],
              [
                57.5864808,
                34.2643158
              ],
              [
                57.5841939,
                34.2521286
              ],
              [
                57.5811654,
                34.2414378
              ],
              [
                57.5798628,
                34.2296721
              ],
              [
                57.5595177,
                34.211216
              ],
              [
                57.5601595,
                34.2062856
              ],
              [
                57.560913,
                34.1989865
              ],
              [
                57.5613623,
                34.1918327
              ],
              [
                57.5627099,
                34.1799866
              ],
              [
                57.5711747,
                34.172253
              ],
              [
                57.567501,
                34.1613921
              ],
              [
                57.5663784,
                34.1506016
              ],
              [
                57.5689179,
                34.1417092
              ],
              [
                57.5701617,
                34.136673
              ],
              [
                57.5710034,
                34.127522
              ],
              [
                57.5660991,
                34.1244899
              ],
              [
                57.5531902,
                34.1058694
              ],
              [
                57.5540044,
                34.1005879
              ],
              [
                57.5544299,
                34.0901139
              ],
              [
                57.5524008,
                34.0763611
              ],
              [
                57.5580787,
                34.0486722
              ],
              [
                57.5660984,
                34.0281572
              ],
              [
                57.5754768,
                34.0066592
              ],
              [
                57.5809117,
                34.0000043
              ],
              [
                57.6002776,
                33.9897267
              ],
              [
                57.6251062,
                33.9739302
              ],
              [
                57.609436,
                33.9510336
              ],
              [
                57.6242762,
                33.9511463
              ],
              [
                57.6317325,
                33.9434124
              ],
              [
                57.641285,
                33.939576
              ],
              [
                57.6422494,
                33.931741
              ],
              [
                57.6494232,
                33.9286294
              ],
              [
                57.6556646,
                33.9243668
              ],
              [
                57.6338243,
                33.9018257
              ],
              [
                57.6340166,
                33.8987926
              ],
              [
                57.641081,
                33.8915807
              ],
              [
                57.6455062,
                33.885144
              ],
              [
                57.6514166,
                33.8793943
              ],
              [
                57.641342,
                33.8683089
              ],
              [
                57.6334425,
                33.8569182
              ],
              [
                57.6469395,
                33.8473792
              ],
              [
                57.6440108,
                33.844261
              ],
              [
                57.6421,
                33.8409926
              ],
              [
                57.6401996,
                33.8365579
              ],
              [
                57.6497268,
                33.8280736
              ],
              [
                57.6608848,
                33.8195884
              ],
              [
                57.6677859,
                33.8159209
              ],
              [
                57.671879,
                33.8121615
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555147,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قائنات",
          "name:en": "Qaenat County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286169"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.6385483,
                33.9963266
              ],
              [
                58.6385483,
                33.9949365
              ],
              [
                58.6382682,
                33.9946567
              ],
              [
                58.6379881,
                33.9940971
              ],
              [
                58.637435,
                33.9932667
              ],
              [
                58.6329884,
                33.9791043
              ],
              [
                58.6327149,
                33.9788245
              ],
              [
                58.6313216,
                33.9710438
              ],
              [
                58.6354879,
                33.952711
              ],
              [
                58.6382681,
                33.9477103
              ],
              [
                58.6385482,
                33.9471507
              ],
              [
                58.6393814,
                33.9454898
              ],
              [
                58.6393814,
                33.9449112
              ],
              [
                58.6393814,
                33.9440997
              ],
              [
                58.6391013,
                33.9432692
              ],
              [
                58.6389975,
                33.9426505
              ],
              [
                58.6388212,
                33.9415993
              ],
              [
                58.638268,
                33.9402093
              ],
              [
                58.6410482,
                33.9221561
              ],
              [
                58.6413212,
                33.914655
              ],
              [
                58.6416012,
                33.8904815
              ],
              [
                58.6424344,
                33.8857605
              ],
              [
                58.6429879,
                33.8846503
              ],
              [
                58.6446544,
                33.8713176
              ],
              [
                58.6491009,
                33.8571455
              ],
              [
                58.649381,
                33.8554845
              ],
              [
                58.6496544,
                33.854654
              ],
              [
                58.652161,
                33.8429823
              ],
              [
                58.6527142,
                33.8365912
              ],
              [
                58.6524341,
                33.8360406
              ],
              [
                58.6527142,
                33.8354808
              ],
              [
                58.6527142,
                33.8340907
              ],
              [
                58.6527142,
                33.8338199
              ],
              [
                58.6527142,
                33.83354
              ],
              [
                58.6529943,
                33.8332602
              ],
              [
                58.6532677,
                33.8318701
              ],
              [
                58.6613276,
                33.8154861
              ],
              [
                58.6760474,
                33.8004832
              ],
              [
                58.6774337,
                33.7996526
              ],
              [
                58.7166068,
                33.7749272
              ],
              [
                58.7177134,
                33.7743676
              ],
              [
                58.7232733,
                33.7715963
              ],
              [
                58.7452198,
                33.7593733
              ],
              [
                58.7463261,
                33.7593733
              ],
              [
                58.7466062,
                33.7590935
              ],
              [
                58.7474398,
                33.7590935
              ],
              [
                58.748273,
                33.7585338
              ],
              [
                58.7566059,
                33.7563131
              ],
              [
                58.7577197,
                33.7563131
              ],
              [
                58.7582727,
                33.7557624
              ],
              [
                58.7588259,
                33.7554826
              ],
              [
                58.7718859,
                33.7477011
              ],
              [
                58.7804533,
                33.7433057
              ],
              [
                58.7802193,
                33.7426999
              ],
              [
                58.7777192,
                33.7401994
              ],
              [
                58.7766059,
                33.7396487
              ],
              [
                58.7291064,
                33.7004791
              ],
              [
                58.7127131,
                33.6904767
              ],
              [
                58.6952135,
                33.675482
              ],
              [
                58.6941068,
                33.6749224
              ],
              [
                58.686327,
                33.6718711
              ],
              [
                58.6727138,
                33.6646491
              ],
              [
                58.6696602,
                33.6649199
              ],
              [
                58.6593804,
                33.6688108
              ],
              [
                58.6527138,
                33.6738121
              ],
              [
                58.6468808,
                33.6782536
              ],
              [
                58.6460473,
                33.6782536
              ],
              [
                58.6457672,
                33.6785335
              ],
              [
                58.6452141,
                33.6782536
              ],
              [
                58.6443808,
                33.6779828
              ],
              [
                58.6432676,
                33.6768724
              ],
              [
                58.642434,
                33.6763127
              ],
              [
                58.6413206,
                33.6746517
              ],
              [
                58.6416006,
                33.6635388
              ],
              [
                58.6416006,
                33.652146
              ],
              [
                58.6499339,
                33.6251985
              ],
              [
                58.6663268,
                33.5896473
              ],
              [
                58.6663268,
                33.5888077
              ],
              [
                58.6718799,
                33.5724222
              ],
              [
                58.6727136,
                33.5713118
              ],
              [
                58.6732667,
                33.5699215
              ],
              [
                58.67438,
                33.5679805
              ],
              [
                58.67938,
                33.5604783
              ],
              [
                58.6996597,
                33.5365815
              ],
              [
                58.701046,
                33.5357509
              ],
              [
                58.7198868,
                33.5086148
              ],
              [
                58.7184477,
                33.4988277
              ],
              [
                58.7176929,
                33.4900591
              ],
              [
                58.7212226,
                33.4857312
              ],
              [
                58.7260435,
                33.4838585
              ],
              [
                58.742523,
                33.4845744
              ],
              [
                58.7591481,
                33.4716942
              ],
              [
                58.7615775,
                33.466318
              ],
              [
                58.7645383,
                33.4579611
              ],
              [
                58.7712207,
                33.443679
              ],
              [
                58.7854813,
                33.426164
              ],
              [
                58.8063604,
                33.4136567
              ],
              [
                58.8643903,
                33.3765842
              ],
              [
                58.8643903,
                33.3763043
              ],
              [
                58.8641102,
                33.374914
              ],
              [
                58.8638306,
                33.3738035
              ],
              [
                58.8641103,
                33.372693
              ],
              [
                58.8638305,
                33.3718623
              ],
              [
                58.8638304,
                33.357137
              ],
              [
                58.863557,
                33.3529659
              ],
              [
                58.8632769,
                33.3515846
              ],
              [
                58.8629968,
                33.3410303
              ],
              [
                58.8624437,
                33.3354688
              ],
              [
                58.8591104,
                33.3226935
              ],
              [
                58.850777,
                33.3088077
              ],
              [
                58.848557,
                33.3060269
              ],
              [
                58.8235506,
                33.2846383
              ],
              [
                58.8116109,
                33.2768557
              ],
              [
                58.7924379,
                33.2688022
              ],
              [
                58.7893847,
                33.2676916
              ],
              [
                58.7791043,
                33.2640802
              ],
              [
                58.7785512,
                33.2635295
              ],
              [
                58.7646651,
                33.2574081
              ],
              [
                58.7638314,
                33.2571372
              ],
              [
                58.7643849,
                33.2562976
              ],
              [
                58.764665,
                33.2560267
              ],
              [
                58.7854978,
                33.2271349
              ],
              [
                58.8418901,
                33.1729624
              ],
              [
                58.8424436,
                33.1724116
              ],
              [
                58.8546634,
                33.1646378
              ],
              [
                58.8554966,
                33.1646378
              ],
              [
                58.8557768,
                33.1643579
              ],
              [
                58.8577233,
                33.1643579
              ],
              [
                58.86161,
                33.1654683
              ],
              [
                58.8629964,
                33.1654684
              ],
              [
                58.8663297,
                33.1665789
              ],
              [
                58.8918896,
                33.1815757
              ],
              [
                58.8935564,
                33.1810249
              ],
              [
                58.898276,
                33.1765828
              ],
              [
                58.900776,
                33.1724115
              ],
              [
                58.9016093,
                33.1718518
              ],
              [
                58.9021695,
                33.1715808
              ],
              [
                58.911336,
                33.1687999
              ],
              [
                58.9138361,
                33.1688
              ],
              [
                58.9143892,
                33.1685201
              ],
              [
                58.9152224,
                33.1687999
              ],
              [
                58.9171694,
                33.1688
              ],
              [
                58.9205026,
                33.1693598
              ],
              [
                58.934949,
                33.1738019
              ],
              [
                58.9721686,
                33.1876881
              ],
              [
                58.9924483,
                33.1990734
              ],
              [
                59.0310612,
                33.2315766
              ],
              [
                59.0374547,
                33.2376891
              ],
              [
                59.0616209,
                33.2612989
              ],
              [
                59.0621741,
                33.2618587
              ],
              [
                59.0785674,
                33.2740834
              ],
              [
                59.0863405,
                33.2776949
              ],
              [
                59.0877339,
                33.2779657
              ],
              [
                59.0944005,
                33.2793651
              ],
              [
                59.0994006,
                33.279365
              ],
              [
                59.1002339,
                33.2790762
              ],
              [
                59.112244,
                33.2771772
              ],
              [
                59.1130137,
                33.276855
              ],
              [
                59.1230135,
                33.2751938
              ],
              [
                59.1330134,
                33.2732436
              ],
              [
                59.1388467,
                33.2726929
              ],
              [
                59.1416268,
                33.2721331
              ],
              [
                59.1463464,
                33.2718622
              ],
              [
                59.1824593,
                33.2668513
              ],
              [
                59.1899594,
                33.26519
              ],
              [
                59.202739,
                33.2635287
              ],
              [
                59.2049589,
                33.2635287
              ],
              [
                59.2060726,
                33.2632489
              ],
              [
                59.2080121,
                33.2632488
              ],
              [
                59.2096789,
                33.262969
              ],
              [
                59.2105121,
                33.262969
              ],
              [
                59.2119055,
                33.2626891
              ],
              [
                59.2202389,
                33.2621292
              ],
              [
                59.2285723,
                33.2618584
              ],
              [
                59.2416253,
                33.2621292
              ],
              [
                59.2432917,
                33.2618584
              ],
              [
                59.2502383,
                33.2618583
              ],
              [
                59.251625,
                33.2615784
              ],
              [
                59.2560716,
                33.2615785
              ],
              [
                59.257465,
                33.2612985
              ],
              [
                59.2635714,
                33.2612985
              ],
              [
                59.2649652,
                33.2615784
              ],
              [
                59.2666316,
                33.2615784
              ],
              [
                59.2674649,
                33.2612985
              ],
              [
                59.2691317,
                33.2615784
              ],
              [
                59.2716317,
                33.2615784
              ],
              [
                59.2732982,
                33.2618583
              ],
              [
                59.2910711,
                33.2663003
              ],
              [
                59.2927447,
                33.2663003
              ],
              [
                59.2932978,
                33.2663003
              ],
              [
                59.2932978,
                33.2660204
              ],
              [
                59.2941313,
                33.2660205
              ],
              [
                59.2971846,
                33.2660205
              ],
              [
                59.2977447,
                33.2663003
              ],
              [
                59.2991311,
                33.2665802
              ],
              [
                59.3077446,
                33.2701916
              ],
              [
                59.3085778,
                33.2710313
              ],
              [
                59.3146841,
                33.2751934
              ],
              [
                59.3183389,
                33.2796247
              ],
              [
                59.3176285,
                33.2874422
              ],
              [
                59.3173164,
                33.3020008
              ],
              [
                59.3163473,
                33.3391731
              ],
              [
                59.3253814,
                33.3405422
              ],
              [
                59.3391524,
                33.3464078
              ],
              [
                59.3586158,
                33.3594238
              ],
              [
                59.3661689,
                33.3670942
              ],
              [
                59.3728186,
                33.3725122
              ],
              [
                59.3877138,
                33.3836823
              ],
              [
                59.4013033,
                33.3936388
              ],
              [
                59.4293403,
                33.4131739
              ],
              [
                59.4398116,
                33.4202665
              ],
              [
                59.4304561,
                33.4420419
              ],
              [
                59.4241033,
                33.4444061
              ],
              [
                59.4180974,
                33.4460892
              ],
              [
                59.4200714,
                33.4550344
              ],
              [
                59.4211194,
                33.4626248
              ],
              [
                59.4215297,
                33.465423
              ],
              [
                59.4361638,
                33.4665328
              ],
              [
                59.4287824,
                33.473263
              ],
              [
                59.4365287,
                33.4805296
              ],
              [
                59.4426428,
                33.4852511
              ],
              [
                59.4731139,
                33.5174975
              ],
              [
                59.4749164,
                33.538247
              ],
              [
                59.4549232,
                33.5505359
              ],
              [
                59.4340282,
                33.5625398
              ],
              [
                59.413982,
                33.5770928
              ],
              [
                59.40682,
                33.5985931
              ],
              [
                59.409454,
                33.6131317
              ],
              [
                59.4069157,
                33.6250124
              ],
              [
                59.4162101,
                33.645405
              ],
              [
                59.4181268,
                33.657575
              ],
              [
                59.4201866,
                33.6727134
              ],
              [
                59.4152336,
                33.6946785
              ],
              [
                59.4297484,
                33.712087
              ],
              [
                59.425737,
                33.7384424
              ],
              [
                59.4328334,
                33.7443798
              ],
              [
                59.4533329,
                33.7465153
              ],
              [
                59.4873685,
                33.7454463
              ],
              [
                59.514746,
                33.7447381
              ],
              [
                59.5440044,
                33.7441917
              ],
              [
                59.5625824,
                33.743478
              ],
              [
                59.5895056,
                33.7225429
              ],
              [
                59.594689,
                33.6914438
              ],
              [
                59.5998141,
                33.6616021
              ],
              [
                59.6120446,
                33.6431256
              ],
              [
                59.6374255,
                33.6182822
              ],
              [
                59.6675007,
                33.5914076
              ],
              [
                59.6886719,
                33.5833617
              ],
              [
                59.7030282,
                33.5839398
              ],
              [
                59.7169844,
                33.5795454
              ],
              [
                59.743772,
                33.5847327
              ],
              [
                59.7871123,
                33.5942246
              ],
              [
                59.8170717,
                33.5786424
              ],
              [
                59.8292603,
                33.5821677
              ],
              [
                59.8491859,
                33.5789495
              ],
              [
                59.854288,
                33.5799455
              ],
              [
                59.8602103,
                33.5821622
              ],
              [
                59.8758793,
                33.5987337
              ],
              [
                59.8847579,
                33.6108123
              ],
              [
                59.8792648,
                33.6243904
              ],
              [
                59.8710127,
                33.6370361
              ],
              [
                59.8665044,
                33.6446641
              ],
              [
                59.8728423,
                33.6482862
              ],
              [
                59.880149,
                33.653001
              ],
              [
                59.8877021,
                33.6583534
              ],
              [
                59.8827981,
                33.6603779
              ],
              [
                59.8660408,
                33.6672121
              ],
              [
                59.8719232,
                33.6834824
              ],
              [
                59.8813755,
                33.7005019
              ],
              [
                59.8880703,
                33.7107459
              ],
              [
                59.885091,
                33.7235352
              ],
              [
                59.8820973,
                33.7306494
              ],
              [
                59.8579786,
                33.7407572
              ],
              [
                59.841379,
                33.7704746
              ],
              [
                59.8410989,
                33.7710343
              ],
              [
                59.8166527,
                33.7965902
              ],
              [
                59.7738734,
                33.8257566
              ],
              [
                59.7904657,
                33.8322919
              ],
              [
                59.7901926,
                33.8325717
              ],
              [
                59.7871324,
                33.836734
              ],
              [
                59.7865793,
                33.8375736
              ],
              [
                59.782966,
                33.8436768
              ],
              [
                59.7793527,
                33.8575718
              ],
              [
                59.7762995,
                33.8906339
              ],
              [
                59.7751864,
                33.9092503
              ],
              [
                59.7751863,
                33.9131416
              ],
              [
                59.8508374,
                33.9216426
              ],
              [
                59.8456676,
                33.9491535
              ],
              [
                59.8742118,
                33.9777986
              ],
              [
                59.8250197,
                33.9966042
              ],
              [
                59.8148916,
                34.0075621
              ],
              [
                59.7712897,
                34.0183763
              ],
              [
                59.7498247,
                34.0179848
              ],
              [
                59.7225379,
                34.0272684
              ],
              [
                59.7041652,
                34.0322782
              ],
              [
                59.6734306,
                34.028219
              ],
              [
                59.6692114,
                34.0304952
              ],
              [
                59.6608505,
                34.03144
              ],
              [
                59.6484806,
                34.0431196
              ],
              [
                59.6407757,
                34.0497767
              ],
              [
                59.633274,
                34.0495305
              ],
              [
                59.6222608,
                34.0478125
              ],
              [
                59.563237,
                34.0500944
              ],
              [
                59.5632369,
                34.0503742
              ],
              [
                59.4916531,
                34.0523753
              ],
              [
                59.4672772,
                34.0617616
              ],
              [
                59.4573208,
                34.0805313
              ],
              [
                59.4236752,
                34.0867869
              ],
              [
                59.4044491,
                34.108678
              ],
              [
                59.3781124,
                34.1152319
              ],
              [
                59.3781124,
                34.1155116
              ],
              [
                59.3772788,
                34.1163419
              ],
              [
                59.3769986,
                34.1166217
              ],
              [
                59.3767185,
                34.1168924
              ],
              [
                59.3764455,
                34.1171722
              ],
              [
                59.3758853,
                34.1171722
              ],
              [
                59.3753322,
                34.1168924
              ],
              [
                59.3499661,
                34.1077071
              ],
              [
                59.349413,
                34.1079869
              ],
              [
                59.347193,
                34.1079869
              ],
              [
                59.3466329,
                34.1082668
              ],
              [
                59.3030136,
                34.0805411
              ],
              [
                59.291907,
                34.0855393
              ],
              [
                59.2907938,
                34.0860941
              ],
              [
                59.259028,
                34.088631
              ],
              [
                59.2576417,
                34.0891818
              ],
              [
                59.2504149,
                34.0933535
              ],
              [
                59.2501415,
                34.0939042
              ],
              [
                59.2490283,
                34.094464
              ],
              [
                59.2248622,
                34.1150236
              ],
              [
                59.2223621,
                34.1161341
              ],
              [
                59.2215289,
                34.1161341
              ],
              [
                59.219582,
                34.1169649
              ],
              [
                59.2148623,
                34.1164141
              ],
              [
                59.2145822,
                34.1161343
              ],
              [
                59.2140287,
                34.1161341
              ],
              [
                59.2134686,
                34.1158542
              ],
              [
                59.1904652,
                34.1175212
              ],
              [
                59.1899116,
                34.1175212
              ],
              [
                59.179916,
                34.1245952
              ],
              [
                59.1657953,
                34.1196577
              ],
              [
                59.1644019,
                34.1196576
              ],
              [
                59.1641288,
                34.1193778
              ],
              [
                59.1627355,
                34.1193778
              ],
              [
                59.162462,
                34.1190981
              ],
              [
                59.1552352,
                34.1185475
              ],
              [
                59.1342541,
                34.1137946
              ],
              [
                59.1199556,
                34.120488
              ],
              [
                59.1155161,
                34.1210477
              ],
              [
                59.1132891,
                34.1210477
              ],
              [
                59.1113493,
                34.1216073
              ],
              [
                59.1032893,
                34.1221579
              ],
              [
                59.101903,
                34.1218781
              ],
              [
                59.0767499,
                34.1332461
              ],
              [
                59.0759168,
                34.1335258
              ],
              [
                59.0678568,
                34.1335258
              ],
              [
                59.0667502,
                34.1332461
              ],
              [
                59.0545238,
                34.1332462
              ],
              [
                59.0536901,
                34.1335258
              ],
              [
                59.053137,
                34.1332462
              ],
              [
                59.0525768,
                34.1335259
              ],
              [
                59.0489705,
                34.1335259
              ],
              [
                59.0481369,
                34.1338057
              ],
              [
                59.0331373,
                34.1351864
              ],
              [
                59.0328573,
                34.1349157
              ],
              [
                59.0323037,
                34.1349156
              ],
              [
                59.0323037,
                34.134636
              ],
              [
                59.0317439,
                34.1343562
              ],
              [
                59.0314705,
                34.1340765
              ],
              [
                59.0311905,
                34.1338057
              ],
              [
                58.999231,
                34.1222937
              ],
              [
                58.997284,
                34.1217432
              ],
              [
                58.9964509,
                34.1211839
              ],
              [
                58.9894575,
                34.0988308
              ],
              [
                58.9741776,
                34.0949408
              ],
              [
                58.9581295,
                34.0793939
              ],
              [
                58.8949254,
                34.0849009
              ],
              [
                58.8938121,
                34.0849009
              ],
              [
                58.8893722,
                34.0860115
              ],
              [
                58.8877057,
                34.0860115
              ],
              [
                58.8810392,
                34.0874019
              ],
              [
                58.8796458,
                34.0874019
              ],
              [
                58.8790923,
                34.0876818
              ],
              [
                58.8777059,
                34.0876818
              ],
              [
                58.8763125,
                34.0879617
              ],
              [
                58.8477259,
                34.113268
              ],
              [
                58.8468926,
                34.1129882
              ],
              [
                58.8249462,
                34.1082677
              ],
              [
                58.8213328,
                34.1063272
              ],
              [
                58.8113329,
                34.0985469
              ],
              [
                58.8079997,
                34.0946568
              ],
              [
                58.748827,
                34.0893767
              ],
              [
                58.7185475,
                34.0982672
              ],
              [
                58.7163274,
                34.0988268
              ],
              [
                58.7152142,
                34.0993774
              ],
              [
                58.7143809,
                34.0993774
              ],
              [
                58.7138275,
                34.0996572
              ],
              [
                58.7127141,
                34.0996573
              ],
              [
                58.7118809,
                34.099937
              ],
              [
                58.7085476,
                34.1002078
              ],
              [
                58.7077145,
                34.099937
              ],
              [
                58.7057745,
                34.099937
              ],
              [
                58.6940776,
                34.1064393
              ],
              [
                58.6861909,
                34.1082827
              ],
              [
                58.6847031,
                34.105881
              ],
              [
                58.6725409,
                34.09703
              ],
              [
                58.6692076,
                34.0878731
              ],
              [
                58.6578946,
                34.0875405
              ],
              [
                58.6562277,
                34.0839233
              ],
              [
                58.6559547,
                34.0836526
              ],
              [
                58.6509545,
                34.0761566
              ],
              [
                58.6481748,
                34.0744967
              ],
              [
                58.6473412,
                34.0744967
              ],
              [
                58.6462279,
                34.074208
              ],
              [
                58.646508,
                34.0725482
              ],
              [
                58.6462278,
                34.0719979
              ],
              [
                58.6391014,
                34.0104889
              ],
              [
                58.6388213,
                33.9988269
              ],
              [
                58.6388214,
                33.9965974
              ],
              [
                58.6385483,
                33.9963266
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555240,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نهبندان",
          "name:en": "Nehbandan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q3924635",
          "wikipedia": "en:Nehbandan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.5880535,
                31.3353187
              ],
              [
                58.6053895,
                31.3194036
              ],
              [
                58.6391827,
                31.2808985
              ],
              [
                58.6661335,
                31.2475901
              ],
              [
                58.6920544,
                31.226014
              ],
              [
                58.7239834,
                31.2081036
              ],
              [
                58.7449261,
                31.1943015
              ],
              [
                58.7708471,
                31.1903365
              ],
              [
                58.7796014,
                31.1857846
              ],
              [
                58.8015744,
                31.1743289
              ],
              [
                58.8389965,
                31.1517078
              ],
              [
                58.8719555,
                31.1287874
              ],
              [
                58.964309,
                31.0570522
              ],
              [
                59.0195843,
                31.0182216
              ],
              [
                59.0439602,
                30.9855566
              ],
              [
                59.0834423,
                30.95818
              ],
              [
                59.1434672,
                30.90644
              ],
              [
                59.1608189,
                30.8911404
              ],
              [
                59.1885723,
                30.8645116
              ],
              [
                59.2329541,
                30.8176491
              ],
              [
                59.2412655,
                30.8108148
              ],
              [
                59.263448,
                30.7938734
              ],
              [
                59.2678069,
                30.7885207
              ],
              [
                59.2742169,
                30.7778027
              ],
              [
                59.2819522,
                30.763829
              ],
              [
                59.2903345,
                30.7481443
              ],
              [
                59.2981334,
                30.7303009
              ],
              [
                59.3036492,
                30.7214042
              ],
              [
                59.3094605,
                30.7118515
              ],
              [
                59.3141562,
                30.7069197
              ],
              [
                59.3536918,
                30.6646169
              ],
              [
                59.3697661,
                30.6489304
              ],
              [
                59.3818185,
                30.6373168
              ],
              [
                59.4029492,
                30.6145196
              ],
              [
                59.4165464,
                30.6010153
              ],
              [
                59.4348258,
                30.5827064
              ],
              [
                59.4582706,
                30.5535857
              ],
              [
                59.468116,
                30.5427928
              ],
              [
                59.4830583,
                30.5275894
              ],
              [
                59.4881025,
                30.52283
              ],
              [
                59.5029529,
                30.5332544
              ],
              [
                59.5083903,
                30.5361684
              ],
              [
                59.519861,
                30.5484436
              ],
              [
                59.6416851,
                30.5764503
              ],
              [
                59.6701809,
                30.5900462
              ],
              [
                59.6976468,
                30.5876819
              ],
              [
                59.7051988,
                30.6024591
              ],
              [
                59.7388455,
                30.6219596
              ],
              [
                59.776611,
                30.6423432
              ],
              [
                59.8030468,
                30.6379123
              ],
              [
                59.8583218,
                30.6822117
              ],
              [
                59.8576352,
                30.7002209
              ],
              [
                59.865123,
                30.7119149
              ],
              [
                59.8656764,
                30.7124744
              ],
              [
                59.8673429,
                30.7135844
              ],
              [
                59.8789208,
                30.7214737
              ],
              [
                59.9193923,
                30.7487619
              ],
              [
                59.9243924,
                30.7559825
              ],
              [
                59.9243924,
                30.7562623
              ],
              [
                59.9249455,
                30.7568219
              ],
              [
                59.9274457,
                30.7612625
              ],
              [
                59.9277257,
                30.7623728
              ],
              [
                59.9279987,
                30.7646021
              ],
              [
                59.9285589,
                30.7662627
              ],
              [
                59.9288324,
                30.7673731
              ],
              [
                59.9291124,
                30.7690428
              ],
              [
                59.9293922,
                30.7707125
              ],
              [
                59.9296656,
                30.7726531
              ],
              [
                59.9299457,
                30.7751534
              ],
              [
                59.9302258,
                30.7770938
              ],
              [
                59.9304988,
                30.7793233
              ],
              [
                59.9306454,
                30.7939884
              ],
              [
                59.9312057,
                30.8067686
              ],
              [
                59.9309257,
                30.810379
              ],
              [
                59.9312056,
                30.8112093
              ],
              [
                59.9314791,
                30.8148195
              ],
              [
                59.9314792,
                30.8187096
              ],
              [
                59.9314792,
                30.8198197
              ],
              [
                59.9320393,
                30.8245402
              ],
              [
                59.9320394,
                30.8326002
              ],
              [
                59.9334258,
                30.8439907
              ],
              [
                59.9334258,
                30.8551014
              ],
              [
                59.9339794,
                30.8592714
              ],
              [
                59.9339794,
                30.8648223
              ],
              [
                59.936479,
                30.881764
              ],
              [
                59.9370392,
                30.8828832
              ],
              [
                59.9370393,
                30.8837136
              ],
              [
                59.9378724,
                30.8856632
              ],
              [
                59.9409257,
                30.8937144
              ],
              [
                59.9414792,
                30.894265
              ],
              [
                59.9414792,
                30.8945448
              ],
              [
                59.9428725,
                30.8967652
              ],
              [
                59.9556455,
                30.9134363
              ],
              [
                59.9562057,
                30.9145465
              ],
              [
                59.962039,
                30.9192671
              ],
              [
                59.9839779,
                30.973194
              ],
              [
                60.0121411,
                31.0086067
              ],
              [
                60.0190807,
                31.0099956
              ],
              [
                60.035474,
                31.0099955
              ],
              [
                60.0357541,
                31.0097161
              ],
              [
                60.0396405,
                31.009716
              ],
              [
                60.040194,
                31.0094364
              ],
              [
                60.0418604,
                31.0094364
              ],
              [
                60.0449206,
                31.0091659
              ],
              [
                60.0588673,
                31.0070235
              ],
              [
                60.0599739,
                31.006744
              ],
              [
                60.0616407,
                31.0070236
              ],
              [
                60.0697007,
                31.0070236
              ],
              [
                60.0699737,
                31.0067439
              ],
              [
                60.076087,
                31.0067439
              ],
              [
                60.0772004,
                31.0070235
              ],
              [
                60.0855338,
                31.0070235
              ],
              [
                60.0866471,
                31.007303
              ],
              [
                60.0922003,
                31.007303
              ],
              [
                60.0947004,
                31.0075736
              ],
              [
                60.1022001,
                31.0073029
              ],
              [
                60.1076901,
                31.003748
              ],
              [
                60.1082432,
                31.0040277
              ],
              [
                60.1238033,
                31.0040277
              ],
              [
                60.1246365,
                31.003748
              ],
              [
                60.1249166,
                31.0040277
              ],
              [
                60.1257498,
                31.003748
              ],
              [
                60.1282498,
                31.003748
              ],
              [
                60.128803,
                31.0040277
              ],
              [
                60.1329694,
                31.0040276
              ],
              [
                60.1380328,
                31.0084032
              ],
              [
                60.138866,
                31.0086828
              ],
              [
                60.1402594,
                31.0086828
              ],
              [
                60.1408129,
                31.0089624
              ],
              [
                60.1502596,
                31.0089624
              ],
              [
                60.1510928,
                31.009242
              ],
              [
                60.154146,
                31.009242
              ],
              [
                60.154699,
                31.0095215
              ],
              [
                60.1563659,
                31.0092419
              ],
              [
                60.1588659,
                31.009242
              ],
              [
                60.1622059,
                31.009242
              ],
              [
                60.1669259,
                31.0092419
              ],
              [
                60.1694259,
                31.0100717
              ],
              [
                60.1708122,
                31.0100716
              ],
              [
                60.2063254,
                31.0246128
              ],
              [
                60.2276287,
                31.023433
              ],
              [
                60.2348555,
                31.0281526
              ],
              [
                60.2543019,
                31.0348124
              ],
              [
                60.2556887,
                31.0356517
              ],
              [
                60.2584685,
                31.0375919
              ],
              [
                60.2693019,
                31.0467605
              ],
              [
                60.2701614,
                31.0534359
              ],
              [
                60.265995,
                31.0664983
              ],
              [
                60.2511718,
                31.0892741
              ],
              [
                60.2481186,
                31.0937156
              ],
              [
                60.2431185,
                31.1042775
              ],
              [
                60.2313623,
                31.1227381
              ],
              [
                60.2324756,
                31.1260691
              ],
              [
                60.2630993,
                31.1493572
              ],
              [
                60.282425,
                31.1460551
              ],
              [
                60.282425,
                31.146335
              ],
              [
                60.282978,
                31.1466149
              ],
              [
                60.2849246,
                31.1482848
              ],
              [
                60.2926251,
                31.1628721
              ],
              [
                60.3252407,
                31.1672787
              ],
              [
                60.3415877,
                31.196654
              ],
              [
                60.3457543,
                31.1988749
              ],
              [
                60.3581709,
                31.2119562
              ],
              [
                60.3706173,
                31.2154854
              ],
              [
                60.3910005,
                31.2104505
              ],
              [
                60.4218406,
                31.2160037
              ],
              [
                60.4240601,
                31.2162835
              ],
              [
                60.4293403,
                31.2173942
              ],
              [
                60.5118152,
                31.1987011
              ],
              [
                60.5123683,
                31.1989812
              ],
              [
                60.5137617,
                31.1989811
              ],
              [
                60.5358548,
                31.211877
              ],
              [
                60.536688,
                31.211877
              ],
              [
                60.5383549,
                31.212708
              ],
              [
                60.5731742,
                31.2236819
              ],
              [
                60.5745676,
                31.2236819
              ],
              [
                60.5773407,
                31.2245128
              ],
              [
                60.5798408,
                31.2247837
              ],
              [
                60.5801208,
                31.2250636
              ],
              [
                60.5804009,
                31.2250636
              ],
              [
                60.5815072,
                31.2250636
              ],
              [
                60.5820674,
                31.2253437
              ],
              [
                60.6507107,
                31.2227845
              ],
              [
                60.6658663,
                31.2253458
              ],
              [
                60.6664625,
                31.2260158
              ],
              [
                60.6673588,
                31.2270231
              ],
              [
                60.668093,
                31.2278481
              ],
              [
                60.6683665,
                31.2283991
              ],
              [
                60.6686469,
                31.2286792
              ],
              [
                60.670199,
                31.2294182
              ],
              [
                60.6674774,
                31.2399715
              ],
              [
                60.6527707,
                31.2662266
              ],
              [
                60.6678272,
                31.2932275
              ],
              [
                60.6730741,
                31.295724
              ],
              [
                60.6782323,
                31.2981783
              ],
              [
                60.7214869,
                31.3021398
              ],
              [
                60.7859795,
                31.323141
              ],
              [
                60.7942193,
                31.355983
              ],
              [
                60.809875,
                31.3886187
              ],
              [
                60.8187669,
                31.3968452
              ],
              [
                60.8282086,
                31.4028799
              ],
              [
                60.835075,
                31.4151866
              ],
              [
                60.833302,
                31.4241783
              ],
              [
                60.8344247,
                31.4264036
              ],
              [
                60.8376092,
                31.4327152
              ],
              [
                60.8428745,
                31.4431502
              ],
              [
                60.8448447,
                31.4470544
              ],
              [
                60.8473216,
                31.4569733
              ],
              [
                60.8487315,
                31.4626188
              ],
              [
                60.8487315,
                31.4640001
              ],
              [
                60.8492917,
                31.4659502
              ],
              [
                60.8490729,
                31.4752663
              ],
              [
                60.8572509,
                31.4784799
              ],
              [
                60.8575314,
                31.4787598
              ],
              [
                60.857251,
                31.482371
              ],
              [
                60.8569713,
                31.4832016
              ],
              [
                60.8569713,
                31.4834814
              ],
              [
                60.856057,
                31.4865192
              ],
              [
                60.8549929,
                31.491869
              ],
              [
                60.853881,
                31.4974591
              ],
              [
                60.8514942,
                31.5094568
              ],
              [
                60.8493717,
                31.5201248
              ],
              [
                60.8486974,
                31.5235139
              ],
              [
                60.8496221,
                31.5371797
              ],
              [
                60.8500977,
                31.5443054
              ],
              [
                60.8419141,
                31.5575988
              ],
              [
                60.8409225,
                31.5625803
              ],
              [
                60.839722,
                31.568611
              ],
              [
                60.8380867,
                31.5773484
              ],
              [
                60.8369229,
                31.5835658
              ],
              [
                60.8353337,
                31.5920555
              ],
              [
                60.8343276,
                31.5974293
              ],
              [
                60.8322799,
                31.6083664
              ],
              [
                60.8316128,
                31.6119296
              ],
              [
                60.8304571,
                31.6181013
              ],
              [
                60.829752,
                31.6218671
              ],
              [
                60.8283486,
                31.6293607
              ],
              [
                60.827581,
                31.6334597
              ],
              [
                60.825736,
                31.6433102
              ],
              [
                60.8243906,
                31.6504928
              ],
              [
                60.8225452,
                31.6603436
              ],
              [
                60.821868,
                31.6639582
              ],
              [
                60.8202504,
                31.6725924
              ],
              [
                60.8189515,
                31.6795243
              ],
              [
                60.8168151,
                31.6909252
              ],
              [
                60.8162475,
                31.6939539
              ],
              [
                60.814987,
                31.7006798
              ],
              [
                60.8134835,
                31.7087013
              ],
              [
                60.8136337,
                31.7148763
              ],
              [
                60.8138785,
                31.724937
              ],
              [
                60.8141316,
                31.7353365
              ],
              [
                60.8142403,
                31.7398067
              ],
              [
                60.8143812,
                31.7455926
              ],
              [
                60.8145082,
                31.7508117
              ],
              [
                60.8146658,
                31.7572892
              ],
              [
                60.814807,
                31.7630907
              ],
              [
                60.8150179,
                31.7717544
              ],
              [
                60.815165,
                31.7777947
              ],
              [
                60.815336,
                31.7848184
              ],
              [
                60.8154892,
                31.7911094
              ],
              [
                60.8156224,
                31.7965818
              ],
              [
                60.8157769,
                31.802927
              ],
              [
                60.8160141,
                31.8126657
              ],
              [
                60.816134,
                31.8175886
              ],
              [
                60.8162761,
                31.8234224
              ],
              [
                60.8163534,
                31.8265956
              ],
              [
                60.8165425,
                31.8343586
              ],
              [
                60.8166793,
                31.8399742
              ],
              [
                60.8168245,
                31.8459334
              ],
              [
                60.8169635,
                31.8516402
              ],
              [
                60.8171279,
                31.8583847
              ],
              [
                60.8172442,
                31.8631594
              ],
              [
                60.8174286,
                31.8707234
              ],
              [
                60.8175444,
                31.8754785
              ],
              [
                60.8178255,
                31.8870107
              ],
              [
                60.8178956,
                31.8898861
              ],
              [
                60.8191276,
                31.894975
              ],
              [
                60.8213053,
                31.9039692
              ],
              [
                60.823033,
                31.911104
              ],
              [
                60.8250453,
                31.9194136
              ],
              [
                60.8258401,
                31.9226955
              ],
              [
                60.8274737,
                31.9294407
              ],
              [
                60.8268781,
                31.9326332
              ],
              [
                60.8258138,
                31.9383379
              ],
              [
                60.8249639,
                31.9428932
              ],
              [
                60.8233174,
                31.9517177
              ],
              [
                60.8227018,
                31.961064
              ],
              [
                60.8224952,
                31.9642008
              ],
              [
                60.825404,
                31.9687449
              ],
              [
                60.832519,
                31.979859
              ],
              [
                60.8310091,
                31.9833543
              ],
              [
                60.8277299,
                31.9909452
              ],
              [
                60.8250445,
                31.9971609
              ],
              [
                60.8201424,
                32.0085064
              ],
              [
                60.8187522,
                32.0117237
              ],
              [
                60.8173419,
                32.0192252
              ],
              [
                60.8159668,
                32.0265393
              ],
              [
                60.8136144,
                32.0271337
              ],
              [
                60.8088103,
                32.0283476
              ],
              [
                60.8029939,
                32.0298172
              ],
              [
                60.797247,
                32.0312692
              ],
              [
                60.7824276,
                32.039359
              ],
              [
                60.7365411,
                32.0546453
              ],
              [
                60.6910513,
                32.0527534
              ],
              [
                60.6836699,
                32.0578456
              ],
              [
                60.6740368,
                32.0749528
              ],
              [
                60.6725394,
                32.0751709
              ],
              [
                60.6704777,
                32.0754713
              ],
              [
                60.571575,
                32.0753021
              ],
              [
                60.5638497,
                32.0795207
              ],
              [
                60.5605391,
                32.0838468
              ],
              [
                60.5583334,
                32.0850379
              ],
              [
                60.5547956,
                32.0862888
              ],
              [
                60.5536067,
                32.0867092
              ],
              [
                60.4359638,
                32.0817201
              ],
              [
                60.4310945,
                32.0815359
              ],
              [
                60.4269966,
                32.0813808
              ],
              [
                60.4237163,
                32.0812567
              ],
              [
                60.4039785,
                32.073517
              ],
              [
                60.4020386,
                32.073517
              ],
              [
                60.4009253,
                32.0737971
              ],
              [
                60.3415487,
                32.0795203
              ],
              [
                60.3312491,
                32.0723929
              ],
              [
                60.3179296,
                32.0705969
              ],
              [
                60.3154835,
                32.0705969
              ],
              [
                60.3116581,
                32.070597
              ],
              [
                60.3078287,
                32.070597
              ],
              [
                60.3027812,
                32.070597
              ],
              [
                60.297294,
                32.0712112
              ],
              [
                60.2952748,
                32.0714373
              ],
              [
                60.2662637,
                32.0728772
              ],
              [
                60.2895354,
                32.0925372
              ],
              [
                60.2706526,
                32.1048252
              ],
              [
                60.2561022,
                32.1183156
              ],
              [
                60.2558291,
                32.1188757
              ],
              [
                60.2552689,
                32.1191557
              ],
              [
                60.2516623,
                32.1263808
              ],
              [
                60.2618785,
                32.1830677
              ],
              [
                60.2621587,
                32.184458
              ],
              [
                60.2480624,
                32.221872
              ],
              [
                60.2475093,
                32.2246428
              ],
              [
                60.2475093,
                32.2254732
              ],
              [
                60.2472292,
                32.2254732
              ],
              [
                60.2463956,
                32.2254732
              ],
              [
                60.2458425,
                32.2257529
              ],
              [
                60.2450092,
                32.2257528
              ],
              [
                60.2447291,
                32.2260328
              ],
              [
                60.2383427,
                32.2260326
              ],
              [
                60.2313961,
                32.2252024
              ],
              [
                60.2305625,
                32.2249226
              ],
              [
                60.2291762,
                32.2249226
              ],
              [
                60.2266761,
                32.224363
              ],
              [
                60.1676556,
                32.2186107
              ],
              [
                60.1717755,
                32.2037961
              ],
              [
                60.1438429,
                32.1912411
              ],
              [
                60.1239616,
                32.1906227
              ],
              [
                60.0548489,
                32.1913185
              ],
              [
                60.0444027,
                32.1849113
              ],
              [
                60.028605,
                32.183495
              ],
              [
                60.01757,
                32.1909165
              ],
              [
                60.004506,
                32.2065214
              ],
              [
                59.9863789,
                32.2240549
              ],
              [
                59.970761,
                32.2438872
              ],
              [
                59.9688211,
                32.2452778
              ],
              [
                59.9670458,
                32.2459729
              ],
              [
                59.9547957,
                32.2565074
              ],
              [
                59.932308,
                32.2601366
              ],
              [
                59.9188717,
                32.2711064
              ],
              [
                59.9177584,
                32.2711064
              ],
              [
                59.8963155,
                32.2833417
              ],
              [
                59.8929822,
                32.2844522
              ],
              [
                59.8877021,
                32.2877834
              ],
              [
                59.8406409,
                32.2881486
              ],
              [
                59.8075102,
                32.2853913
              ],
              [
                59.793434,
                32.2906156
              ],
              [
                59.7917174,
                32.3062865
              ],
              [
                59.7681997,
                32.3174577
              ],
              [
                59.7519206,
                32.3353052
              ],
              [
                59.7383159,
                32.323225
              ],
              [
                59.7322029,
                32.3157216
              ],
              [
                59.7313693,
                32.3135003
              ],
              [
                59.7310891,
                32.3132205
              ],
              [
                59.730816,
                32.3123897
              ],
              [
                59.7296924,
                32.296433
              ],
              [
                59.6968744,
                32.3004103
              ],
              [
                59.684505,
                32.3015316
              ],
              [
                59.6885578,
                32.2678219
              ],
              [
                59.6669825,
                32.2626772
              ],
              [
                59.6505536,
                32.2593223
              ],
              [
                59.6347336,
                32.255871
              ],
              [
                59.6091508,
                32.2496731
              ],
              [
                59.5332433,
                32.249296
              ],
              [
                59.4925116,
                32.2819083
              ],
              [
                59.4341467,
                32.2949689
              ],
              [
                59.4090841,
                32.312235
              ],
              [
                59.3948363,
                32.3174577
              ],
              [
                59.369821,
                32.3171883
              ],
              [
                59.365094,
                32.3163486
              ],
              [
                59.3623142,
                32.3160778
              ],
              [
                59.349408,
                32.3051671
              ],
              [
                59.3415811,
                32.3030009
              ],
              [
                59.3157482,
                32.3016105
              ],
              [
                59.3115818,
                32.3013396
              ],
              [
                59.3088015,
                32.3013396
              ],
              [
                59.3082484,
                32.3010596
              ],
              [
                59.2899153,
                32.2985585
              ],
              [
                59.2551206,
                32.2670294
              ],
              [
                59.2525824,
                32.2646018
              ],
              [
                59.2500823,
                32.2646019
              ],
              [
                59.2503554,
                32.2640419
              ],
              [
                59.251894,
                32.2618724
              ],
              [
                59.2635686,
                32.2465575
              ],
              [
                59.2652354,
                32.2440564
              ],
              [
                59.2660687,
                32.242106
              ],
              [
                59.2758749,
                32.2341487
              ],
              [
                59.2821817,
                32.2185033
              ],
              [
                59.2930451,
                32.2056737
              ],
              [
                59.2955451,
                32.2031727
              ],
              [
                59.3091772,
                32.1695099
              ],
              [
                59.3011237,
                32.1358091
              ],
              [
                59.3556116,
                32.1260526
              ],
              [
                59.3621348,
                32.1232904
              ],
              [
                59.3676279,
                32.1202374
              ],
              [
                59.3641948,
                32.1155122
              ],
              [
                59.3613624,
                32.1132586
              ],
              [
                59.3568133,
                32.1109322
              ],
              [
                59.3512344,
                32.1074425
              ],
              [
                59.3490886,
                32.1053341
              ],
              [
                59.3513202,
                32.1027167
              ],
              [
                59.3545817,
                32.1007536
              ],
              [
                59.3558692,
                32.0995175
              ],
              [
                59.3562984,
                32.0958092
              ],
              [
                59.3508052,
                32.0871561
              ],
              [
                59.346342,
                32.0865743
              ],
              [
                59.3217944,
                32.0865016
              ],
              [
                59.3046274,
                32.0849331
              ],
              [
                59.2982768,
                32.0851199
              ],
              [
                59.2799692,
                32.0882533
              ],
              [
                59.2699727,
                32.091431
              ],
              [
                59.2371628,
                32.0925326
              ],
              [
                59.2289732,
                32.0688245
              ],
              [
                59.2293579,
                32.0627784
              ],
              [
                59.2310711,
                32.0532629
              ],
              [
                59.2351052,
                32.0184107
              ],
              [
                59.2387961,
                32.0117151
              ],
              [
                59.2399119,
                32.0072754
              ],
              [
                59.2159652,
                31.9985411
              ],
              [
                59.2060088,
                31.9949743
              ],
              [
                59.187944,
                31.9898106
              ],
              [
                59.1914531,
                31.9651725
              ],
              [
                59.1985137,
                31.93593
              ],
              [
                59.210809,
                31.9323484
              ],
              [
                59.2276048,
                31.9247431
              ],
              [
                59.2371271,
                31.9206385
              ],
              [
                59.2371652,
                31.9028457
              ],
              [
                59.2374229,
                31.8889272
              ],
              [
                59.2356201,
                31.868957
              ],
              [
                59.2126175,
                31.846066
              ],
              [
                59.2102143,
                31.8356392
              ],
              [
                59.2153641,
                31.8301701
              ],
              [
                59.2168879,
                31.828128
              ],
              [
                59.2110944,
                31.8244088
              ],
              [
                59.2079401,
                31.8235154
              ],
              [
                59.1929623,
                31.8263052
              ],
              [
                59.1699599,
                31.818064
              ],
              [
                59.1521071,
                31.8136879
              ],
              [
                59.1478154,
                31.8030388
              ],
              [
                59.1399189,
                31.7951604
              ],
              [
                59.1488453,
                31.7826121
              ],
              [
                59.1416357,
                31.757802
              ],
              [
                59.1321942,
                31.754299
              ],
              [
                59.1158863,
                31.7353215
              ],
              [
                59.1218944,
                31.716048
              ],
              [
                59.1270439,
                31.7034892
              ],
              [
                59.1189759,
                31.692097
              ],
              [
                59.0854161,
                31.6736911
              ],
              [
                59.0515994,
                31.6304371
              ],
              [
                59.0309998,
                31.6185244
              ],
              [
                59.026966,
                31.6077794
              ],
              [
                59.0217301,
                31.5982033
              ],
              [
                59.0317725,
                31.5889181
              ],
              [
                59.0216445,
                31.5777312
              ],
              [
                58.9982986,
                31.5772193
              ],
              [
                58.9919471,
                31.57349
              ],
              [
                58.9814757,
                31.5647877
              ],
              [
                58.9558982,
                31.5500139
              ],
              [
                58.9452552,
                31.5366277
              ],
              [
                58.9428519,
                31.517752
              ],
              [
                58.9422511,
                31.4968234
              ],
              [
                58.9007091,
                31.485479
              ],
              [
                58.8826846,
                31.4830636
              ],
              [
                58.8731574,
                31.482112
              ],
              [
                58.8555621,
                31.4780861
              ],
              [
                58.8286106,
                31.4724501
              ],
              [
                58.8208865,
                31.4624933
              ],
              [
                58.8195991,
                31.4583201
              ],
              [
                58.7997722,
                31.4330574
              ],
              [
                58.7884425,
                31.4336433
              ],
              [
                58.7789147,
                31.4359873
              ],
              [
                58.7436389,
                31.4131353
              ],
              [
                58.730592,
                31.4055175
              ],
              [
                58.7134259,
                31.4004626
              ],
              [
                58.6941998,
                31.3895462
              ],
              [
                58.6737727,
                31.3819254
              ],
              [
                58.6585807,
                31.372619
              ],
              [
                58.6375522,
                31.3638247
              ],
              [
                58.6235612,
                31.3545171
              ],
              [
                58.5880535,
                31.3353187
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 10586791016
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.1713038,
          34.0183198
        ]
      }
    }
  ]
},
"خراسان رضوی.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554906,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان باخرز",
          "name:en": "Bakharz County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q4849379",
          "wikipedia": "fa:شهرستان باخرز"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.013686,
                34.9882786
              ],
              [
                60.036163,
                35.00216
              ],
              [
                60.0512692,
                34.9906289
              ],
              [
                60.08011,
                34.9741157
              ],
              [
                60.0965059,
                34.9653273
              ],
              [
                60.1080939,
                34.957852
              ],
              [
                60.1147903,
                34.9558112
              ],
              [
                60.1192474,
                34.9543901
              ],
              [
                60.1284953,
                34.9543903
              ],
              [
                60.1424064,
                34.9529434
              ],
              [
                60.157028,
                34.947349
              ],
              [
                60.1686667,
                34.9399794
              ],
              [
                60.1770114,
                34.9337933
              ],
              [
                60.1805302,
                34.9282345
              ],
              [
                60.1758956,
                34.9236601
              ],
              [
                60.1738357,
                34.9176781
              ],
              [
                60.1709174,
                34.8967025
              ],
              [
                60.1723625,
                34.8851241
              ],
              [
                60.1750373,
                34.8811432
              ],
              [
                60.1840925,
                34.8797702
              ],
              [
                60.1946312,
                34.8808439
              ],
              [
                60.2024417,
                34.879684
              ],
              [
                60.2084254,
                34.8695951
              ],
              [
                60.2186393,
                34.8529038
              ],
              [
                60.2436374,
                34.8208506
              ],
              [
                60.2433585,
                34.8106323
              ],
              [
                60.2395817,
                34.800625
              ],
              [
                60.2455043,
                34.7951977
              ],
              [
                60.2530574,
                34.7911801
              ],
              [
                60.2562331,
                34.7879376
              ],
              [
                60.2641871,
                34.7871297
              ],
              [
                60.2963209,
                34.8007472
              ],
              [
                60.3048132,
                34.8377591
              ],
              [
                60.3391455,
                34.8269094
              ],
              [
                60.3869575,
                34.8556495
              ],
              [
                60.4225051,
                34.8587055
              ],
              [
                60.4601757,
                34.8601488
              ],
              [
                60.4550169,
                34.8622712
              ],
              [
                60.5367278,
                34.8898738
              ],
              [
                60.5683133,
                34.9062057
              ],
              [
                60.6050488,
                34.8924083
              ],
              [
                60.6031607,
                34.8286004
              ],
              [
                60.6445309,
                34.8305733
              ],
              [
                60.6469343,
                34.8377591
              ],
              [
                60.6616971,
                34.850157
              ],
              [
                60.6765908,
                34.8574736
              ],
              [
                60.6644438,
                34.8659333
              ],
              [
                60.6441878,
                34.878186
              ],
              [
                60.6623837,
                34.9095843
              ],
              [
                60.6699368,
                34.9219713
              ],
              [
                60.67234,
                34.9329491
              ],
              [
                60.6675159,
                34.943001
              ],
              [
                60.667516,
                34.9432807
              ],
              [
                60.6658495,
                34.9513276
              ],
              [
                60.6623839,
                34.9646076
              ],
              [
                60.6497422,
                34.9724854
              ],
              [
                60.6405937,
                34.9796666
              ],
              [
                60.6333006,
                34.9887318
              ],
              [
                60.6352551,
                34.9908097
              ],
              [
                60.6457464,
                34.9941224
              ],
              [
                60.6514404,
                34.9999803
              ],
              [
                60.643587,
                35.007503
              ],
              [
                60.6381367,
                35.0113695
              ],
              [
                60.6328252,
                35.0128599
              ],
              [
                60.6378718,
                35.0196248
              ],
              [
                60.6411194,
                35.0257716
              ],
              [
                60.6363772,
                35.0314724
              ],
              [
                60.6299397,
                35.0411708
              ],
              [
                60.6267642,
                35.0435599
              ],
              [
                60.624361,
                35.0479868
              ],
              [
                60.6081387,
                35.0492518
              ],
              [
                60.5995556,
                35.0583156
              ],
              [
                60.5974099,
                35.0663247
              ],
              [
                60.5977532,
                35.0786178
              ],
              [
                60.5977532,
                35.080444
              ],
              [
                60.5913218,
                35.082902
              ],
              [
                60.5884838,
                35.0848862
              ],
              [
                60.5820387,
                35.0854833
              ],
              [
                60.5769824,
                35.0778449
              ],
              [
                60.5608462,
                35.066184
              ],
              [
                60.5289172,
                35.0363216
              ],
              [
                60.5226328,
                35.0355052
              ],
              [
                60.5111502,
                35.0388516
              ],
              [
                60.5037687,
                35.0458788
              ],
              [
                60.4869254,
                35.0559536
              ],
              [
                60.4704664,
                35.0637252
              ],
              [
                60.4503594,
                35.0739382
              ],
              [
                60.4380899,
                35.078292
              ],
              [
                60.4227731,
                35.0854435
              ],
              [
                60.3985087,
                35.0958225
              ],
              [
                60.3943872,
                35.108214
              ],
              [
                60.388069,
                35.1156963
              ],
              [
                60.3814102,
                35.1310639
              ],
              [
                60.3784736,
                35.1406751
              ],
              [
                60.3664396,
                35.1552844
              ],
              [
                60.3617568,
                35.1691391
              ],
              [
                60.3597449,
                35.1823674
              ],
              [
                60.35408,
                35.1868569
              ],
              [
                60.3421382,
                35.1884983
              ],
              [
                60.3150181,
                35.2174616
              ],
              [
                60.2948684,
                35.2371633
              ],
              [
                60.2766815,
                35.2510882
              ],
              [
                60.2644291,
                35.264381
              ],
              [
                60.2585935,
                35.2658745
              ],
              [
                60.2509975,
                35.2682922
              ],
              [
                60.238878,
                35.2680306
              ],
              [
                60.2342605,
                35.2688178
              ],
              [
                60.2242609,
                35.2730225
              ],
              [
                60.2201843,
                35.2810102
              ],
              [
                60.2157,
                35.2835878
              ],
              [
                60.2012566,
                35.2856579
              ],
              [
                60.1962069,
                35.2867756
              ],
              [
                60.1898198,
                35.2880368
              ],
              [
                60.1835431,
                35.2917396
              ],
              [
                60.1764965,
                35.2975441
              ],
              [
                60.1769048,
                35.3005053
              ],
              [
                60.173192,
                35.3072808
              ],
              [
                60.1708742,
                35.3099426
              ],
              [
                60.1599308,
                35.3142851
              ],
              [
                60.1443957,
                35.3177866
              ],
              [
                60.134523,
                35.319049
              ],
              [
                60.1216151,
                35.3209062
              ],
              [
                60.1193835,
                35.3171453
              ],
              [
                60.0980929,
                35.3016231
              ],
              [
                60.0946897,
                35.2978094
              ],
              [
                60.083078,
                35.2828781
              ],
              [
                60.0873183,
                35.2754749
              ],
              [
                60.0926175,
                35.2687958
              ],
              [
                60.0898074,
                35.2509463
              ],
              [
                60.0831985,
                35.2342627
              ],
              [
                60.0771045,
                35.2280931
              ],
              [
                60.0747012,
                35.2201701
              ],
              [
                60.0691222,
                35.2108438
              ],
              [
                60.0687787,
                35.2060752
              ],
              [
                60.0547397,
                35.1933453
              ],
              [
                60.0590798,
                35.1810346
              ],
              [
                60.0478362,
                35.1660906
              ],
              [
                60.0292393,
                35.1379983
              ],
              [
                60.0303642,
                35.1252541
              ],
              [
                60.0312704,
                35.0713617
              ],
              [
                60.0287818,
                35.0548024
              ],
              [
                60.0340174,
                35.0434545
              ],
              [
                60.0316568,
                35.0395546
              ],
              [
                60.0308844,
                35.0332296
              ],
              [
                60.0352621,
                35.0278176
              ],
              [
                60.0405833,
                35.0224058
              ],
              [
                60.0324297,
                35.0195588
              ],
              [
                60.0220868,
                35.0145681
              ],
              [
                60.0092765,
                35.0055346
              ],
              [
                60.0086546,
                35.003144
              ],
              [
                60.0084185,
                35.0001736
              ],
              [
                60.0083329,
                34.9975229
              ],
              [
                60.011208,
                34.9920174
              ],
              [
                60.013686,
                34.9882786
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554913,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بجستان",
          "name:en": "Bajestan County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2725436",
          "wikipedia": "fa:شهرستان بجستان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.76695,
                34.3546226
              ],
              [
                57.7713529,
                34.3496993
              ],
              [
                57.7719065,
                34.3491397
              ],
              [
                57.7721865,
                34.3488601
              ],
              [
                57.8457053,
                34.3441868
              ],
              [
                57.8465386,
                34.3444666
              ],
              [
                57.8623999,
                34.3424379
              ],
              [
                57.8640668,
                34.3424379
              ],
              [
                57.8643464,
                34.3427177
              ],
              [
                57.8651801,
                34.3427176
              ],
              [
                57.8657332,
                34.3429973
              ],
              [
                57.8671266,
                34.3429973
              ],
              [
                57.8676797,
                34.3432771
              ],
              [
                57.873513,
                34.3438274
              ],
              [
                57.8751798,
                34.3438275
              ],
              [
                57.8757329,
                34.3438275
              ],
              [
                57.8762932,
                34.3441072
              ],
              [
                57.8810132,
                34.3441071
              ],
              [
                57.8818464,
                34.3443869
              ],
              [
                57.8824066,
                34.3441071
              ],
              [
                57.8832398,
                34.3443868
              ],
              [
                57.8940115,
                34.3375834
              ],
              [
                57.8945645,
                34.3373036
              ],
              [
                57.9027347,
                34.3221354
              ],
              [
                57.9032879,
                34.3218556
              ],
              [
                57.9046813,
                34.3218556
              ],
              [
                57.9071814,
                34.321305
              ],
              [
                57.9099615,
                34.3201858
              ],
              [
                57.9109044,
                34.3147337
              ],
              [
                57.9150898,
                34.3155527
              ],
              [
                57.9206943,
                34.3175653
              ],
              [
                57.925067,
                34.3165749
              ],
              [
                57.9271876,
                34.3137037
              ],
              [
                57.9290691,
                34.3119035
              ],
              [
                57.9316415,
                34.3102729
              ],
              [
                57.9351151,
                34.3098197
              ],
              [
                57.9383516,
                34.3087917
              ],
              [
                57.9419722,
                34.307855
              ],
              [
                57.9515173,
                34.3048063
              ],
              [
                57.9539265,
                34.3013511
              ],
              [
                57.9593275,
                34.2957784
              ],
              [
                57.964351,
                34.2922367
              ],
              [
                57.975406,
                34.2879701
              ],
              [
                57.9803466,
                34.2856589
              ],
              [
                57.9987905,
                34.2820302
              ],
              [
                58.0147808,
                34.2741276
              ],
              [
                58.0251502,
                34.2778577
              ],
              [
                58.0392264,
                34.2799854
              ],
              [
                58.044033,
                34.2795599
              ],
              [
                58.0502128,
                34.2760137
              ],
              [
                58.05768,
                34.2717581
              ],
              [
                58.0626582,
                34.2668639
              ],
              [
                58.0705546,
                34.2611891
              ],
              [
                58.082375,
                34.2542869
              ],
              [
                58.0920123,
                34.2495546
              ],
              [
                58.0966472,
                34.2486323
              ],
              [
                58.1052726,
                34.2442376
              ],
              [
                58.1132125,
                34.2404728
              ],
              [
                58.1206798,
                34.2371379
              ],
              [
                58.1248855,
                34.2347253
              ],
              [
                58.1401148,
                34.2316277
              ],
              [
                58.1578355,
                34.2317067
              ],
              [
                58.1672,
                34.2345834
              ],
              [
                58.1733678,
                34.2365279
              ],
              [
                58.1851862,
                34.2351881
              ],
              [
                58.1996326,
                34.2287508
              ],
              [
                58.206253,
                34.2245775
              ],
              [
                58.2120036,
                34.2228742
              ],
              [
                58.2201094,
                34.2229363
              ],
              [
                58.2358646,
                34.2365702
              ],
              [
                58.2392156,
                34.2419976
              ],
              [
                58.2382413,
                34.2441694
              ],
              [
                58.2372831,
                34.2482048
              ],
              [
                58.2367276,
                34.2531717
              ],
              [
                58.2389451,
                34.2582268
              ],
              [
                58.2429828,
                34.2616149
              ],
              [
                58.2449205,
                34.2629363
              ],
              [
                58.247253,
                34.26385
              ],
              [
                58.250273,
                34.2644759
              ],
              [
                58.2552695,
                34.2629602
              ],
              [
                58.2559627,
                34.2638607
              ],
              [
                58.2592885,
                34.2684303
              ],
              [
                58.260728,
                34.2705236
              ],
              [
                58.262176,
                34.2727155
              ],
              [
                58.2637261,
                34.2747201
              ],
              [
                58.270925,
                34.2817319
              ],
              [
                58.2729123,
                34.2840504
              ],
              [
                58.2760201,
                34.2909321
              ],
              [
                58.2729005,
                34.2956576
              ],
              [
                58.2593839,
                34.312246
              ],
              [
                58.2674035,
                34.3159404
              ],
              [
                58.2699022,
                34.3154378
              ],
              [
                58.2732168,
                34.3143966
              ],
              [
                58.2783749,
                34.3121136
              ],
              [
                58.282168,
                34.3106676
              ],
              [
                58.2857094,
                34.3088056
              ],
              [
                58.2910081,
                34.3066148
              ],
              [
                58.29648,
                34.3058053
              ],
              [
                58.302484,
                34.3058445
              ],
              [
                58.3090988,
                34.3059065
              ],
              [
                58.3141344,
                34.3061921
              ],
              [
                58.3178452,
                34.3062566
              ],
              [
                58.3218615,
                34.3063884
              ],
              [
                58.3187845,
                34.3162463
              ],
              [
                58.3176735,
                34.3222322
              ],
              [
                58.3166313,
                34.328836
              ],
              [
                58.3039712,
                34.3317066
              ],
              [
                58.3039712,
                34.3351442
              ],
              [
                58.3078333,
                34.3378376
              ],
              [
                58.3060309,
                34.3396449
              ],
              [
                58.3032843,
                34.3441096
              ],
              [
                58.3005308,
                34.3488516
              ],
              [
                58.2936261,
                34.3504778
              ],
              [
                58.2881355,
                34.3532153
              ],
              [
                58.2800251,
                34.3552595
              ],
              [
                58.2735872,
                34.3592027
              ],
              [
                58.274892,
                34.3643139
              ],
              [
                58.2777929,
                34.3683425
              ],
              [
                58.278737,
                34.3708221
              ],
              [
                58.2810971,
                34.3757459
              ],
              [
                58.282814,
                34.3811293
              ],
              [
                58.2835271,
                34.3847305
              ],
              [
                58.2856502,
                34.3910591
              ],
              [
                58.2865741,
                34.3935927
              ],
              [
                58.2917833,
                34.4006424
              ],
              [
                58.294744,
                34.4054215
              ],
              [
                58.3003561,
                34.4118222
              ],
              [
                58.2972266,
                34.4154173
              ],
              [
                58.3356095,
                34.4258743
              ],
              [
                58.3428363,
                34.4314338
              ],
              [
                58.3428362,
                34.4317135
              ],
              [
                58.3431092,
                34.4314338
              ],
              [
                58.3461696,
                34.4314338
              ],
              [
                58.3470027,
                34.4314338
              ],
              [
                58.3492227,
                34.4314338
              ],
              [
                58.3497758,
                34.4317135
              ],
              [
                58.350056,
                34.4314338
              ],
              [
                58.3765926,
                34.4413374
              ],
              [
                58.3782593,
                34.4418879
              ],
              [
                58.3813125,
                34.4418879
              ],
              [
                58.3815926,
                34.4421676
              ],
              [
                58.3838126,
                34.4421677
              ],
              [
                58.3965498,
                34.439494
              ],
              [
                58.4024904,
                34.4435415
              ],
              [
                58.4068788,
                34.4467784
              ],
              [
                58.4104013,
                34.4497059
              ],
              [
                58.4131049,
                34.4525725
              ],
              [
                58.4308644,
                34.4607753
              ],
              [
                58.4429377,
                34.4818958
              ],
              [
                58.4463677,
                34.4873691
              ],
              [
                58.4468576,
                34.5031341
              ],
              [
                58.448408,
                34.5206299
              ],
              [
                58.4501956,
                34.5316065
              ],
              [
                58.4537838,
                34.5372198
              ],
              [
                58.4651183,
                34.5493372
              ],
              [
                58.4775637,
                34.5630507
              ],
              [
                58.4752463,
                34.5735816
              ],
              [
                58.4985506,
                34.5816186
              ],
              [
                58.5072611,
                34.5834045
              ],
              [
                58.5137843,
                34.5818498
              ],
              [
                58.5179042,
                34.5848177
              ],
              [
                58.523811,
                34.5929574
              ],
              [
                58.5258864,
                34.6009981
              ],
              [
                58.5270022,
                34.6029056
              ],
              [
                58.5294055,
                34.6041772
              ],
              [
                58.5351912,
                34.6053165
              ],
              [
                58.5350355,
                34.6237529
              ],
              [
                58.5492344,
                34.6339625
              ],
              [
                58.550949,
                34.6360328
              ],
              [
                58.5548914,
                34.6380629
              ],
              [
                58.5677717,
                34.6481786
              ],
              [
                58.5768698,
                34.6546744
              ],
              [
                58.5892055,
                34.6605926
              ],
              [
                58.5972703,
                34.6768623
              ],
              [
                58.6032736,
                34.6801398
              ],
              [
                58.6157705,
                34.6935134
              ],
              [
                58.6160506,
                34.6951752
              ],
              [
                58.6188353,
                34.6999053
              ],
              [
                58.6193889,
                34.7012871
              ],
              [
                58.6239604,
                34.7093061
              ],
              [
                58.6239604,
                34.7114661
              ],
              [
                58.6231268,
                34.7115366
              ],
              [
                58.6228469,
                34.7118075
              ],
              [
                58.6222937,
                34.7118075
              ],
              [
                58.6217405,
                34.7120875
              ],
              [
                58.5983273,
                34.7125494
              ],
              [
                58.5688015,
                34.7424591
              ],
              [
                58.553352,
                34.7641792
              ],
              [
                58.5314628,
                34.785714
              ],
              [
                58.530903,
                34.7859936
              ],
              [
                58.5264631,
                34.7859937
              ],
              [
                58.5261831,
                34.7862734
              ],
              [
                58.5245162,
                34.7862734
              ],
              [
                58.523683,
                34.786553
              ],
              [
                58.5228497,
                34.786553
              ],
              [
                58.5214631,
                34.7871034
              ],
              [
                58.5203496,
                34.7871035
              ],
              [
                58.5197966,
                34.7873832
              ],
              [
                58.5178497,
                34.7873832
              ],
              [
                58.509646,
                34.7953822
              ],
              [
                58.4987637,
                34.8087297
              ],
              [
                58.5002119,
                34.8160669
              ],
              [
                58.4904856,
                34.8207854
              ],
              [
                58.4836049,
                34.8289666
              ],
              [
                58.4824916,
                34.8295171
              ],
              [
                58.4571787,
                34.8248308
              ],
              [
                58.4387124,
                34.8209464
              ],
              [
                58.437046,
                34.8223365
              ],
              [
                58.4256192,
                34.8294466
              ],
              [
                58.424786,
                34.8294466
              ],
              [
                58.4231191,
                34.8302862
              ],
              [
                58.414226,
                34.8330667
              ],
              [
                58.4017261,
                34.8350076
              ],
              [
                58.3662671,
                34.8637422
              ],
              [
                58.3654339,
                34.864013
              ],
              [
                58.3643205,
                34.864013
              ],
              [
                58.3601536,
                34.865132
              ],
              [
                58.3537672,
                34.8676319
              ],
              [
                58.352934,
                34.8676318
              ],
              [
                58.3526539,
                34.8679116
              ],
              [
                58.3518207,
                34.8679116
              ],
              [
                58.3456417,
                34.8741021
              ],
              [
                58.3274456,
                34.8757921
              ],
              [
                58.3109879,
                34.8826306
              ],
              [
                58.309321,
                34.8829103
              ],
              [
                58.3087612,
                34.8831901
              ],
              [
                58.3079276,
                34.8831901
              ],
              [
                58.3076546,
                34.8834698
              ],
              [
                58.3068214,
                34.8834699
              ],
              [
                58.3054279,
                34.8840292
              ],
              [
                58.3040412,
                34.8840292
              ],
              [
                58.3034881,
                34.884309
              ],
              [
                58.2973747,
                34.8856898
              ],
              [
                58.2802512,
                34.8968242
              ],
              [
                58.2785844,
                34.8968242
              ],
              [
                58.2780313,
                34.8971039
              ],
              [
                58.274698,
                34.8971039
              ],
              [
                58.2744179,
                34.8968242
              ],
              [
                58.272478,
                34.8968242
              ],
              [
                58.2719179,
                34.8965444
              ],
              [
                58.2685846,
                34.895994
              ],
              [
                58.2685846,
                34.8957143
              ],
              [
                58.2680315,
                34.8957143
              ],
              [
                58.2515713,
                34.8971955
              ],
              [
                58.2451655,
                34.9047466
              ],
              [
                58.2418323,
                34.9047466
              ],
              [
                58.2412721,
                34.9050264
              ],
              [
                58.2401654,
                34.9050263
              ],
              [
                58.238219,
                34.9055768
              ],
              [
                58.2368322,
                34.9055767
              ],
              [
                58.2242631,
                34.911514
              ],
              [
                58.223703,
                34.9117937
              ],
              [
                58.221763,
                34.9117937
              ],
              [
                58.2217631,
                34.911514
              ],
              [
                58.2108455,
                34.9138459
              ],
              [
                58.1595206,
                34.9344295
              ],
              [
                58.1570206,
                34.9344295
              ],
              [
                58.1564608,
                34.9344295
              ],
              [
                58.1553468,
                34.9341741
              ],
              [
                58.1522964,
                34.935909
              ],
              [
                58.1520233,
                34.9361887
              ],
              [
                58.1514632,
                34.935909
              ],
              [
                58.1487962,
                34.9363304
              ],
              [
                58.1482361,
                34.9360507
              ],
              [
                58.132683,
                34.9357802
              ],
              [
                58.1324029,
                34.9355006
              ],
              [
                58.1307365,
                34.9355006
              ],
              [
                58.1301834,
                34.935221
              ],
              [
                58.1196234,
                34.9321726
              ],
              [
                58.1179564,
                34.9313338
              ],
              [
                58.11379,
                34.9291151
              ],
              [
                58.1035992,
                34.9321047
              ],
              [
                58.0898663,
                34.9337935
              ],
              [
                58.0785366,
                34.9366081
              ],
              [
                58.0705744,
                34.9293381
              ],
              [
                58.069461,
                34.9293381
              ],
              [
                58.0689075,
                34.9290585
              ],
              [
                58.0677943,
                34.9290585
              ],
              [
                58.0669611,
                34.928779
              ],
              [
                58.0641808,
                34.9285084
              ],
              [
                58.0586276,
                34.9285084
              ],
              [
                58.058348,
                34.9282289
              ],
              [
                58.056408,
                34.9282289
              ],
              [
                58.0552943,
                34.9279494
              ],
              [
                58.0408479,
                34.9271198
              ],
              [
                58.0339084,
                34.9271198
              ],
              [
                58.0330747,
                34.9268402
              ],
              [
                58.0311282,
                34.9268403
              ],
              [
                58.030295,
                34.9265607
              ],
              [
                58.0283481,
                34.9265607
              ],
              [
                58.0272347,
                34.9262812
              ],
              [
                58.0008603,
                34.9124028
              ],
              [
                57.9723326,
                34.9051899
              ],
              [
                57.9647284,
                34.8977551
              ],
              [
                57.9548549,
                34.8872863
              ],
              [
                57.9535142,
                34.8854034
              ],
              [
                57.9548547,
                34.8853768
              ],
              [
                57.9300495,
                34.8521997
              ],
              [
                57.9273031,
                34.8433947
              ],
              [
                57.9285046,
                34.8205682
              ],
              [
                57.9178616,
                34.7873034
              ],
              [
                57.902376,
                34.7591858
              ],
              [
                57.9004295,
                34.7583554
              ],
              [
                57.8879296,
                34.7516854
              ],
              [
                57.8870964,
                34.750846
              ],
              [
                57.8820961,
                34.7475154
              ],
              [
                57.8751495,
                34.7416757
              ],
              [
                57.8701397,
                34.7249661
              ],
              [
                57.8574368,
                34.7057759
              ],
              [
                57.8562327,
                34.6743682
              ],
              [
                57.8551194,
                34.6729775
              ],
              [
                57.8506495,
                34.6608072
              ],
              [
                57.8462171,
                34.6549216
              ],
              [
                57.8450224,
                34.6188228
              ],
              [
                57.8413158,
                34.5828533
              ],
              [
                57.8413158,
                34.5822932
              ],
              [
                57.8393692,
                34.5797905
              ],
              [
                57.8388157,
                34.5783992
              ],
              [
                57.8385357,
                34.5778481
              ],
              [
                57.8382556,
                34.5775681
              ],
              [
                57.8360356,
                34.573394
              ],
              [
                57.8290889,
                34.565055
              ],
              [
                57.8079759,
                34.5414108
              ],
              [
                57.807976,
                34.5408506
              ],
              [
                57.7958758,
                34.5308163
              ],
              [
                57.7897694,
                34.5247018
              ],
              [
                57.7897694,
                34.5244219
              ],
              [
                57.7874076,
                34.5205282
              ],
              [
                57.7878225,
                34.5205293
              ],
              [
                57.7852534,
                34.511154
              ],
              [
                57.812269,
                34.4991238
              ],
              [
                57.8125421,
                34.498293
              ],
              [
                57.8183665,
                34.4970399
              ],
              [
                57.8186463,
                34.4962094
              ],
              [
                57.8230931,
                34.4892684
              ],
              [
                57.820243,
                34.4497466
              ],
              [
                57.8055571,
                34.4359662
              ],
              [
                57.8063908,
                34.4348469
              ],
              [
                57.8014752,
                34.4256028
              ],
              [
                57.8011319,
                34.4083262
              ],
              [
                57.7953019,
                34.3988677
              ],
              [
                57.7920156,
                34.3858517
              ],
              [
                57.7925687,
                34.3850123
              ],
              [
                57.7749028,
                34.3666507
              ],
              [
                57.7742173,
                34.3662291
              ],
              [
                57.7695898,
                34.3594136
              ],
              [
                57.7697996,
                34.3567577
              ],
              [
                57.7677707,
                34.3549214
              ],
              [
                57.76695,
                34.3546226
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554917,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بردسکن",
          "name:ar": "مقاطعة بردسكن",
          "name:en": "Bardaskan County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q32084",
          "wikipedia": "fa:شهرستان بردسکن"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.2279736,
                34.7104172
              ],
              [
                56.2412125,
                34.7044005
              ],
              [
                56.2417693,
                34.7044005
              ],
              [
                56.2420459,
                34.7041208
              ],
              [
                56.2428791,
                34.7041208
              ],
              [
                56.2439926,
                34.7035614
              ],
              [
                56.2642724,
                34.6988425
              ],
              [
                56.2653824,
                34.6988425
              ],
              [
                56.2712156,
                34.6971733
              ],
              [
                56.2723257,
                34.6971733
              ],
              [
                56.2745489,
                34.6963433
              ],
              [
                56.275659,
                34.6963432
              ],
              [
                56.2773255,
                34.6957838
              ],
              [
                56.2787154,
                34.6957838
              ],
              [
                56.2820487,
                34.6952334
              ],
              [
                56.2912153,
                34.6941236
              ],
              [
                56.2926054,
                34.6938439
              ],
              [
                56.2962152,
                34.6938439
              ],
              [
                56.2976053,
                34.6935642
              ],
              [
                56.2998285,
                34.6935642
              ],
              [
                56.3012187,
                34.6932845
              ],
              [
                56.3051053,
                34.6932845
              ],
              [
                56.3064951,
                34.6930048
              ],
              [
                56.3098284,
                34.6930048
              ],
              [
                56.3123284,
                34.6927341
              ],
              [
                56.3131616,
                34.6924544
              ],
              [
                56.318995,
                34.6924544
              ],
              [
                56.3770544,
                34.6860662
              ],
              [
                56.3839975,
                34.6852271
              ],
              [
                56.3889973,
                34.6852271
              ],
              [
                56.395944,
                34.6849474
              ],
              [
                56.3998342,
                34.6846767
              ],
              [
                56.4028873,
                34.6841173
              ],
              [
                56.4070538,
                34.6841173
              ],
              [
                56.4078872,
                34.6838376
              ],
              [
                56.4106671,
                34.6838376
              ],
              [
                56.4109439,
                34.6835579
              ],
              [
                56.4117772,
                34.6838376
              ],
              [
                56.4126106,
                34.6835578
              ],
              [
                56.4159438,
                34.6835579
              ],
              [
                56.4184436,
                34.6830075
              ],
              [
                56.419277,
                34.6830075
              ],
              [
                56.4198338,
                34.6827277
              ],
              [
                56.4209437,
                34.6827278
              ],
              [
                56.421777,
                34.6824481
              ],
              [
                56.4253904,
                34.682448
              ],
              [
                56.4323336,
                34.6818977
              ],
              [
                56.4362236,
                34.6824481
              ],
              [
                56.4384468,
                34.682448
              ],
              [
                56.4462234,
                34.6835578
              ],
              [
                56.4512233,
                34.6846767
              ],
              [
                56.4548367,
                34.6846766
              ],
              [
                56.45789,
                34.6849474
              ],
              [
                56.4584466,
                34.685227
              ],
              [
                56.4615034,
                34.685227
              ],
              [
                56.4623365,
                34.6855067
              ],
              [
                56.4637232,
                34.6855067
              ],
              [
                56.4648366,
                34.6857865
              ],
              [
                56.4662232,
                34.6857864
              ],
              [
                56.4673365,
                34.6860661
              ],
              [
                56.4698366,
                34.6860662
              ],
              [
                56.472893,
                34.6868963
              ],
              [
                56.4734464,
                34.6868962
              ],
              [
                56.4773363,
                34.6880061
              ],
              [
                56.479003,
                34.6885654
              ],
              [
                56.4801129,
                34.6885654
              ],
              [
                56.4809464,
                34.6888451
              ],
              [
                56.4823365,
                34.6888451
              ],
              [
                56.4851128,
                34.6896752
              ],
              [
                56.487893,
                34.6902256
              ],
              [
                56.5603955,
                34.7157868
              ],
              [
                56.5662286,
                34.7177266
              ],
              [
                56.6115081,
                34.7324514
              ],
              [
                56.6256779,
                34.7405084
              ],
              [
                56.6356779,
                34.7446767
              ],
              [
                56.6373446,
                34.7449475
              ],
              [
                56.6378977,
                34.7455068
              ],
              [
                56.6445678,
                34.7474556
              ],
              [
                56.6456778,
                34.7474557
              ],
              [
                56.6462345,
                34.7477354
              ],
              [
                56.6492876,
                34.7477353
              ],
              [
                56.6665108,
                34.7521744
              ],
              [
                56.6723442,
                34.7543938
              ],
              [
                56.7398501,
                34.7827327
              ],
              [
                56.7456832,
                34.7896798
              ],
              [
                56.7479031,
                34.7932887
              ],
              [
                56.7490165,
                34.7968974
              ],
              [
                56.7490165,
                34.7971771
              ],
              [
                56.7517931,
                34.8052338
              ],
              [
                56.7531832,
                34.8066233
              ],
              [
                56.7534598,
                34.8074533
              ],
              [
                56.7823494,
                34.8293946
              ],
              [
                56.7826295,
                34.8299539
              ],
              [
                56.7837396,
                34.8305133
              ],
              [
                56.7901295,
                34.8374511
              ],
              [
                56.795406,
                34.8452369
              ],
              [
                56.7976293,
                34.847727
              ],
              [
                56.7984627,
                34.8482862
              ],
              [
                56.8015194,
                34.853573
              ],
              [
                56.8087393,
                34.8632893
              ],
              [
                56.8092959,
                34.8646787
              ],
              [
                56.8179093,
                34.876903
              ],
              [
                56.8298523,
                34.8902367
              ],
              [
                56.835409,
                34.8946753
              ],
              [
                56.8495757,
                34.9149554
              ],
              [
                56.8509655,
                34.9180136
              ],
              [
                56.8515221,
                34.9191232
              ],
              [
                56.8517989,
                34.9205124
              ],
              [
                56.8520755,
                34.9219018
              ],
              [
                56.8442988,
                34.9352351
              ],
              [
                56.8395756,
                34.9371747
              ],
              [
                56.8298524,
                34.9388436
              ],
              [
                56.8248525,
                34.9371747
              ],
              [
                56.821796,
                34.9369041
              ],
              [
                56.820686,
                34.9374544
              ],
              [
                56.8198526,
                34.9391233
              ],
              [
                56.8209625,
                34.9419018
              ],
              [
                56.8217959,
                34.9444006
              ],
              [
                56.8240192,
                34.9466289
              ],
              [
                56.8273525,
                34.948848
              ],
              [
                56.8337425,
                34.954405
              ],
              [
                56.8640221,
                34.9738452
              ],
              [
                56.8645754,
                34.9744045
              ],
              [
                56.8798552,
                34.9799613
              ],
              [
                56.8959685,
                34.9824601
              ],
              [
                56.9012449,
                34.9824601
              ],
              [
                56.9026351,
                34.9821804
              ],
              [
                56.9051351,
                34.9821804
              ],
              [
                56.9062449,
                34.9819008
              ],
              [
                56.9104115,
                34.9819007
              ],
              [
                56.9162449,
                34.9813505
              ],
              [
                56.9198582,
                34.9813505
              ],
              [
                56.9245813,
                34.9816211
              ],
              [
                56.9259682,
                34.9819007
              ],
              [
                56.9298581,
                34.9819007
              ],
              [
                56.9312481,
                34.9821804
              ],
              [
                56.9331913,
                34.9821804
              ],
              [
                56.9448546,
                34.9793346
              ],
              [
                56.9537445,
                34.9812831
              ],
              [
                56.9545778,
                34.9812832
              ],
              [
                56.9551345,
                34.9815627
              ],
              [
                56.9562445,
                34.9815628
              ],
              [
                56.9699475,
                34.9970978
              ],
              [
                56.9824274,
                35.0022814
              ],
              [
                57.0010372,
                35.0064486
              ],
              [
                57.0098603,
                35.0052373
              ],
              [
                57.0401266,
                35.0123643
              ],
              [
                57.0484632,
                35.0162525
              ],
              [
                57.0517965,
                35.0173622
              ],
              [
                57.053183,
                35.018192
              ],
              [
                57.0559631,
                35.019022
              ],
              [
                57.1321089,
                35.0610131
              ],
              [
                57.1622585,
                35.0715818
              ],
              [
                57.1661484,
                35.0724116
              ],
              [
                57.1686484,
                35.0732506
              ],
              [
                57.1725383,
                35.0738009
              ],
              [
                57.2225142,
                35.0958999
              ],
              [
                57.2255709,
                35.0961795
              ],
              [
                57.2375141,
                35.0975685
              ],
              [
                57.2391807,
                35.0975684
              ],
              [
                57.2633504,
                35.1000667
              ],
              [
                57.2715408,
                35.1000189
              ],
              [
                57.2754307,
                35.100019
              ],
              [
                57.2782073,
                35.1002984
              ],
              [
                57.2848739,
                35.1002985
              ],
              [
                57.2876538,
                35.1005781
              ],
              [
                57.2918207,
                35.1005781
              ],
              [
                57.2945972,
                35.1008487
              ],
              [
                57.2987673,
                35.1008487
              ],
              [
                57.3015404,
                35.1011282
              ],
              [
                57.3121604,
                35.1022517
              ],
              [
                57.3398467,
                35.1053709
              ],
              [
                57.3530957,
                35.1106412
              ],
              [
                57.3695752,
                35.1067092
              ],
              [
                57.3815389,
                35.1163708
              ],
              [
                57.3898722,
                35.1141435
              ],
              [
                57.3920988,
                35.113873
              ],
              [
                57.4040452,
                35.1116458
              ],
              [
                57.4520949,
                35.1269001
              ],
              [
                57.460899,
                35.1229978
              ],
              [
                57.4642349,
                35.116266
              ],
              [
                57.4667346,
                35.115716
              ],
              [
                57.4842483,
                35.0933066
              ],
              [
                57.4862193,
                35.0774234
              ],
              [
                57.4918315,
                35.0671804
              ],
              [
                57.500023,
                35.0503605
              ],
              [
                57.5033582,
                35.0391682
              ],
              [
                57.5094712,
                35.0372281
              ],
              [
                57.5269246,
                35.0128173
              ],
              [
                57.5280379,
                35.0128173
              ],
              [
                57.5288712,
                35.0125376
              ],
              [
                57.5305381,
                35.0125376
              ],
              [
                57.530811,
                35.0122577
              ],
              [
                57.5319243,
                35.0122577
              ],
              [
                57.5327576,
                35.0125375
              ],
              [
                57.5333111,
                35.0122577
              ],
              [
                57.5341444,
                35.0125375
              ],
              [
                57.536371,
                35.0125375
              ],
              [
                57.5645595,
                35.0139566
              ],
              [
                57.5673293,
                35.0130566
              ],
              [
                57.5722217,
                35.009401
              ],
              [
                57.5885295,
                34.9999803
              ],
              [
                57.5917053,
                34.9983983
              ],
              [
                57.6015758,
                34.995832
              ],
              [
                57.6181608,
                34.9930692
              ],
              [
                57.6428422,
                34.9782526
              ],
              [
                57.6497268,
                34.9745247
              ],
              [
                57.6556938,
                34.9713098
              ],
              [
                57.6613998,
                34.968265
              ],
              [
                57.6700322,
                34.9618782
              ],
              [
                57.6728119,
                34.9604891
              ],
              [
                57.6736452,
                34.9596593
              ],
              [
                57.6761452,
                34.9582612
              ],
              [
                57.6795256,
                34.9557837
              ],
              [
                57.6908651,
                34.9477076
              ],
              [
                57.6966934,
                34.9386079
              ],
              [
                57.7018725,
                34.9328255
              ],
              [
                57.7063951,
                34.9268426
              ],
              [
                57.7117824,
                34.9229564
              ],
              [
                57.7224253,
                34.9209859
              ],
              [
                57.7319526,
                34.9214081
              ],
              [
                57.7427259,
                34.9206582
              ],
              [
                57.7507495,
                34.917467
              ],
              [
                57.757101,
                34.9157778
              ],
              [
                57.761481,
                34.9140592
              ],
              [
                57.7615385,
                34.9135434
              ],
              [
                57.7624299,
                34.8926181
              ],
              [
                57.7565979,
                34.8810716
              ],
              [
                57.753955,
                34.8608591
              ],
              [
                57.7550444,
                34.8542178
              ],
              [
                57.7604483,
                34.8541013
              ],
              [
                57.7681731,
                34.8532561
              ],
              [
                57.7968403,
                34.8557918
              ],
              [
                57.8244778,
                34.8624121
              ],
              [
                57.8653332,
                34.8659334
              ],
              [
                57.9346418,
                34.8854733
              ],
              [
                57.9535142,
                34.8854034
              ],
              [
                57.9548549,
                34.8872863
              ],
              [
                57.9647284,
                34.8977551
              ],
              [
                57.9723326,
                34.9051899
              ],
              [
                57.9757976,
                34.9227452
              ],
              [
                57.9737376,
                34.932386
              ],
              [
                57.9727934,
                34.9442068
              ],
              [
                57.975025,
                34.9695312
              ],
              [
                57.9775999,
                34.9774082
              ],
              [
                57.9800032,
                34.9892928
              ],
              [
                57.9815482,
                34.9943554
              ],
              [
                57.9819204,
                35.0003067
              ],
              [
                57.9745941,
                35.0101882
              ],
              [
                57.9854882,
                35.0204133
              ],
              [
                58.0146003,
                35.048039
              ],
              [
                58.0560822,
                35.0624734
              ],
              [
                58.0547741,
                35.0695893
              ],
              [
                58.0545464,
                35.0746594
              ],
              [
                58.0786231,
                35.1111807
              ],
              [
                58.0916663,
                35.1247617
              ],
              [
                58.0961322,
                35.1351066
              ],
              [
                58.1021369,
                35.1450319
              ],
              [
                58.1073298,
                35.1523391
              ],
              [
                58.1069469,
                35.1554598
              ],
              [
                58.1076548,
                35.1617704
              ],
              [
                58.1068182,
                35.1676692
              ],
              [
                58.1053657,
                35.1742285
              ],
              [
                58.1051169,
                35.1771666
              ],
              [
                58.0981546,
                35.1783004
              ],
              [
                58.0872917,
                35.1793507
              ],
              [
                58.0815839,
                35.1786492
              ],
              [
                58.0773353,
                35.1786842
              ],
              [
                58.0719508,
                35.1805169
              ],
              [
                58.0648106,
                35.1863246
              ],
              [
                58.0656623,
                35.1982901
              ],
              [
                58.0664655,
                35.2123822
              ],
              [
                58.0639457,
                35.2151915
              ],
              [
                58.0599975,
                35.2177158
              ],
              [
                58.05871,
                35.2203453
              ],
              [
                58.0572508,
                35.2280932
              ],
              [
                58.0582809,
                35.2313532
              ],
              [
                58.0624639,
                35.2369671
              ],
              [
                58.0707263,
                35.2387495
              ],
              [
                58.0799101,
                35.2406772
              ],
              [
                58.0802106,
                35.2494043
              ],
              [
                58.0809093,
                35.2518809
              ],
              [
                58.0875242,
                35.2516337
              ],
              [
                58.1028441,
                35.2516712
              ],
              [
                58.1104551,
                35.2516821
              ],
              [
                58.1105305,
                35.2493206
              ],
              [
                58.1323527,
                35.2498249
              ],
              [
                58.1427775,
                35.249102
              ],
              [
                58.1478593,
                35.249163
              ],
              [
                58.1570545,
                35.2489352
              ],
              [
                58.1586169,
                35.2501753
              ],
              [
                58.1657409,
                35.2516473
              ],
              [
                58.1659638,
                35.2577223
              ],
              [
                58.1643607,
                35.2677294
              ],
              [
                58.1651172,
                35.2730321
              ],
              [
                58.1650705,
                35.2796617
              ],
              [
                58.1657823,
                35.2862126
              ],
              [
                58.1662559,
                35.2992254
              ],
              [
                58.1685289,
                35.3031364
              ],
              [
                58.1727361,
                35.312884
              ],
              [
                58.1749248,
                35.3221636
              ],
              [
                58.1726172,
                35.3272299
              ],
              [
                58.1763057,
                35.34108
              ],
              [
                58.1815394,
                35.3530454
              ],
              [
                58.1914901,
                35.3558412
              ],
              [
                58.2090273,
                35.3758575
              ],
              [
                58.2154728,
                35.3907071
              ],
              [
                58.2282042,
                35.3979885
              ],
              [
                58.2388986,
                35.4053358
              ],
              [
                58.2313641,
                35.4055675
              ],
              [
                58.2238564,
                35.40566
              ],
              [
                58.2248781,
                35.4062965
              ],
              [
                58.2293415,
                35.4138165
              ],
              [
                58.2319163,
                35.4174539
              ],
              [
                58.2332468,
                35.4237139
              ],
              [
                58.2333753,
                35.4294841
              ],
              [
                58.2060305,
                35.4560786
              ],
              [
                58.1938933,
                35.472554
              ],
              [
                58.1810187,
                35.4742315
              ],
              [
                58.1892584,
                35.4875112
              ],
              [
                58.1885718,
                35.4957574
              ],
              [
                58.1755075,
                35.504202
              ],
              [
                58.1644846,
                35.5067505
              ],
              [
                58.1586683,
                35.5159468
              ],
              [
                58.1699707,
                35.5302385
              ],
              [
                58.160076,
                35.5320867
              ],
              [
                58.1568576,
                35.528584
              ],
              [
                58.1529712,
                35.5277454
              ],
              [
                58.1501812,
                35.5308278
              ],
              [
                58.144628,
                35.5310983
              ],
              [
                58.142401,
                35.5313777
              ],
              [
                58.1253384,
                35.5210395
              ],
              [
                58.1245048,
                35.52076
              ],
              [
                58.1231185,
                35.5207599
              ],
              [
                58.1206184,
                35.5202099
              ],
              [
                58.1153381,
                35.5202099
              ],
              [
                58.1139518,
                35.5199303
              ],
              [
                58.1073758,
                35.5224472
              ],
              [
                58.0664745,
                35.5307441
              ],
              [
                58.0606412,
                35.5307441
              ],
              [
                58.0348081,
                35.5213025
              ],
              [
                58.0256415,
                35.5160182
              ],
              [
                58.0198016,
                35.5110222
              ],
              [
                58.0064685,
                35.4976848
              ],
              [
                57.9994008,
                35.4791244
              ],
              [
                57.9955383,
                35.480033
              ],
              [
                57.985067,
                35.4934515
              ],
              [
                57.9635235,
                35.4940804
              ],
              [
                57.9488468,
                35.4865657
              ],
              [
                57.93587,
                35.4896051
              ],
              [
                57.9238699,
                35.4849952
              ],
              [
                57.9014956,
                35.4940749
              ],
              [
                57.8909109,
                35.5002296
              ],
              [
                57.8907391,
                35.5054004
              ],
              [
                57.9103085,
                35.5199323
              ],
              [
                57.9123686,
                35.5251015
              ],
              [
                57.9072186,
                35.5308295
              ],
              [
                57.8941724,
                35.5341822
              ],
              [
                57.893829,
                35.5528989
              ],
              [
                57.8773495,
                35.5598816
              ],
              [
                57.8659341,
                35.5749272
              ],
              [
                57.8596713,
                35.5763136
              ],
              [
                57.862544,
                35.5794645
              ],
              [
                57.8678655,
                35.5838448
              ],
              [
                57.873659,
                35.5875269
              ],
              [
                57.8732728,
                35.5885564
              ],
              [
                57.8571796,
                35.5909644
              ],
              [
                57.8491189,
                35.5903836
              ],
              [
                57.8375887,
                35.5930932
              ],
              [
                57.825379,
                35.5926572
              ],
              [
                57.8004455,
                35.5893765
              ],
              [
                57.7980981,
                35.5893487
              ],
              [
                57.7887756,
                35.5872982
              ],
              [
                57.7833321,
                35.5849945
              ],
              [
                57.7758447,
                35.581609
              ],
              [
                57.7728939,
                35.5745779
              ],
              [
                57.7725076,
                35.5717156
              ],
              [
                57.7779642,
                35.5660748
              ],
              [
                57.7779697,
                35.5632293
              ],
              [
                57.7750766,
                35.5612918
              ],
              [
                57.7682734,
                35.5561768
              ],
              [
                57.7586459,
                35.5494769
              ],
              [
                57.7530669,
                35.5468232
              ],
              [
                57.7492043,
                35.5455315
              ],
              [
                57.7323409,
                35.5449336
              ],
              [
                57.731502,
                35.5448503
              ],
              [
                57.7140998,
                35.5512925
              ],
              [
                57.7049589,
                35.5409568
              ],
              [
                57.6849603,
                35.5301657
              ],
              [
                57.6594913,
                35.5225694
              ],
              [
                57.6516473,
                35.5332628
              ],
              [
                57.6304862,
                35.5299876
              ],
              [
                57.6197465,
                35.5320132
              ],
              [
                57.6106218,
                35.5244698
              ],
              [
                57.5988225,
                35.5172989
              ],
              [
                57.5863336,
                35.5171589
              ],
              [
                57.5702631,
                35.5168718
              ],
              [
                57.5519228,
                35.5167408
              ],
              [
                57.5428822,
                35.5212207
              ],
              [
                57.5292016,
                35.5181465
              ],
              [
                57.5178125,
                35.5274913
              ],
              [
                57.4992686,
                35.5304084
              ],
              [
                57.4906554,
                35.5304084
              ],
              [
                57.4788592,
                35.5404747
              ],
              [
                57.4757989,
                35.5396361
              ],
              [
                57.4640528,
                35.5463656
              ],
              [
                57.4348795,
                35.5241398
              ],
              [
                57.4271063,
                35.520524
              ],
              [
                57.4165463,
                35.5180264
              ],
              [
                57.38488,
                35.518856
              ],
              [
                57.3776604,
                35.5185855
              ],
              [
                57.3768271,
                35.518306
              ],
              [
                57.3729336,
                35.518306
              ],
              [
                57.3721005,
                35.518306
              ],
              [
                57.3710282,
                35.5181262
              ],
              [
                57.3704336,
                35.5180265
              ],
              [
                57.3687672,
                35.518306
              ],
              [
                57.3618206,
                35.5171879
              ],
              [
                57.3609869,
                35.5171879
              ],
              [
                57.3440475,
                35.5083065
              ],
              [
                57.3412674,
                35.5074769
              ],
              [
                57.3373809,
                35.5055293
              ],
              [
                57.3287675,
                35.5035816
              ],
              [
                57.3243209,
                35.5030316
              ],
              [
                57.2224221,
                35.487614
              ],
              [
                57.2095012,
                35.4822344
              ],
              [
                57.1646116,
                35.4654239
              ],
              [
                57.1552133,
                35.4577337
              ],
              [
                57.1445703,
                35.4523502
              ],
              [
                57.1407535,
                35.4484897
              ],
              [
                57.1368455,
                35.446442
              ],
              [
                57.1322965,
                35.4453232
              ],
              [
                57.1270179,
                35.4448337
              ],
              [
                57.1236328,
                35.4436928
              ],
              [
                57.119471,
                35.4438067
              ],
              [
                57.1152997,
                35.4442264
              ],
              [
                57.1098947,
                35.4461273
              ],
              [
                57.1065044,
                35.4465119
              ],
              [
                57.1019125,
                35.4469314
              ],
              [
                57.0996809,
                35.4474559
              ],
              [
                57.0959603,
                35.4486596
              ],
              [
                57.0822382,
                35.4563597
              ],
              [
                57.0775342,
                35.4583873
              ],
              [
                57.0680522,
                35.4613341
              ],
              [
                57.064564,
                35.4633859
              ],
              [
                57.0577526,
                35.4653538
              ],
              [
                57.0511436,
                35.4687093
              ],
              [
                57.0481824,
                35.4709112
              ],
              [
                57.040331,
                35.4758635
              ],
              [
                57.0317512,
                35.4779512
              ],
              [
                57.0294284,
                35.4796484
              ],
              [
                57.0273685,
                35.4842612
              ],
              [
                57.0235732,
                35.4957848
              ],
              [
                57.0024312,
                35.4747289
              ],
              [
                57.0018744,
                35.4727813
              ],
              [
                56.995418,
                35.4663598
              ],
              [
                56.9945848,
                35.4605257
              ],
              [
                56.9943047,
                35.4583075
              ],
              [
                56.9940279,
                35.4558096
              ],
              [
                56.9841383,
                35.4415465
              ],
              [
                56.9813585,
                35.437939
              ],
              [
                56.9813584,
                35.4376594
              ],
              [
                56.9816383,
                35.4290465
              ],
              [
                56.9869149,
                35.4193241
              ],
              [
                56.9906272,
                35.4168259
              ],
              [
                57.009391,
                35.3953914
              ],
              [
                57.0096676,
                35.3940024
              ],
              [
                57.0102242,
                35.3856591
              ],
              [
                57.0195842,
                35.3641364
              ],
              [
                57.0343073,
                35.3394088
              ],
              [
                57.0354173,
                35.3382996
              ],
              [
                57.0359739,
                35.3380199
              ],
              [
                57.036254,
                35.3374608
              ],
              [
                57.0523637,
                35.3210836
              ],
              [
                57.0520871,
                35.3149691
              ],
              [
                57.0501403,
                35.3071863
              ],
              [
                57.0393071,
                35.2810776
              ],
              [
                57.0318073,
                35.2688572
              ],
              [
                57.0315306,
                35.2677479
              ],
              [
                57.0312505,
                35.2674683
              ],
              [
                57.010694,
                35.2235732
              ],
              [
                57.0002296,
                35.2152486
              ],
              [
                56.9906943,
                35.2119116
              ],
              [
                56.9868043,
                35.2108022
              ],
              [
                56.9837511,
                35.2108022
              ],
              [
                56.9831945,
                35.2105226
              ],
              [
                56.980971,
                35.2105226
              ],
              [
                56.9806945,
                35.2108021
              ],
              [
                56.9751379,
                35.2116319
              ],
              [
                56.967638,
                35.2141303
              ],
              [
                56.966528,
                35.2141303
              ],
              [
                56.9656947,
                35.2144099
              ],
              [
                56.9523581,
                35.217747
              ],
              [
                56.9515247,
                35.2180175
              ],
              [
                56.9473582,
                35.219686
              ],
              [
                56.9465248,
                35.2196861
              ],
              [
                56.9426381,
                35.2207954
              ],
              [
                56.9415249,
                35.2207954
              ],
              [
                56.9409682,
                35.221075
              ],
              [
                56.9370816,
                35.221075
              ],
              [
                56.9368015,
                35.2207954
              ],
              [
                56.9354149,
                35.2207954
              ],
              [
                56.9348583,
                35.2205158
              ],
              [
                56.9165251,
                35.2133005
              ],
              [
                56.9109685,
                35.2091336
              ],
              [
                56.9098586,
                35.2088541
              ],
              [
                56.9093019,
                35.2083039
              ],
              [
                56.9081919,
                35.2080153
              ],
              [
                56.9076353,
                35.2074651
              ],
              [
                56.8951354,
                35.2038574
              ],
              [
                56.8940221,
                35.2038575
              ],
              [
                56.8934688,
                35.2035778
              ],
              [
                56.8918022,
                35.2035778
              ],
              [
                56.8912455,
                35.2032983
              ],
              [
                56.8904122,
                35.2032982
              ],
              [
                56.8898554,
                35.2030186
              ],
              [
                56.8876357,
                35.2030187
              ],
              [
                56.8870788,
                35.2027391
              ],
              [
                56.8837455,
                35.2027391
              ],
              [
                56.8826322,
                35.2030186
              ],
              [
                56.8765224,
                35.2030187
              ],
              [
                56.8751322,
                35.202739
              ],
              [
                56.8740223,
                35.2030187
              ],
              [
                56.8695792,
                35.2030187
              ],
              [
                56.8684657,
                35.2032983
              ],
              [
                56.8662458,
                35.2032983
              ],
              [
                56.865409,
                35.2035779
              ],
              [
                56.8629091,
                35.2035779
              ],
              [
                56.8623558,
                35.2032983
              ],
              [
                56.8612425,
                35.2032983
              ],
              [
                56.8573559,
                35.2024685
              ],
              [
                56.8556893,
                35.2024685
              ],
              [
                56.8437427,
                35.1977425
              ],
              [
                56.8429093,
                35.1969036
              ],
              [
                56.8306861,
                35.1882992
              ],
              [
                56.828743,
                35.1863511
              ],
              [
                56.828743,
                35.1860714
              ],
              [
                56.8270763,
                35.1846825
              ],
              [
                56.8112432,
                35.1674643
              ],
              [
                56.7823499,
                35.1535742
              ],
              [
                56.77513,
                35.1482977
              ],
              [
                56.7737402,
                35.1469087
              ],
              [
                56.7608636,
                35.126087
              ],
              [
                56.7133647,
                35.1092306
              ],
              [
                56.6986415,
                35.0953413
              ],
              [
                56.6972514,
                35.0942319
              ],
              [
                56.6969749,
                35.0936727
              ],
              [
                56.6944748,
                35.0920132
              ],
              [
                56.6908783,
                35.0872661
              ],
              [
                56.6869549,
                35.0822105
              ],
              [
                56.6772248,
                35.0610587
              ],
              [
                56.6758348,
                35.0610586
              ],
              [
                56.6750014,
                35.060779
              ],
              [
                56.6733348,
                35.060779
              ],
              [
                56.6725014,
                35.0604994
              ],
              [
                56.6705582,
                35.0604994
              ],
              [
                56.6700016,
                35.0602197
              ],
              [
                56.6672249,
                35.0602197
              ],
              [
                56.6666683,
                35.0604993
              ],
              [
                56.6647249,
                35.0604994
              ],
              [
                56.6615556,
                35.0628548
              ],
              [
                56.6598891,
                35.0631254
              ],
              [
                56.6582224,
                35.0636936
              ],
              [
                56.6579014,
                35.0666221
              ],
              [
                56.6531782,
                35.0666221
              ],
              [
                56.6520682,
                35.0669018
              ],
              [
                56.641235,
                35.0669017
              ],
              [
                56.6401217,
                35.0666221
              ],
              [
                56.6265119,
                35.0649624
              ],
              [
                56.6253985,
                35.0644031
              ],
              [
                56.6240117,
                35.0641325
              ],
              [
                56.5948422,
                35.0555182
              ],
              [
                56.5937322,
                35.0555181
              ],
              [
                56.5915089,
                35.0549589
              ],
              [
                56.5895655,
                35.0549589
              ],
              [
                56.5870657,
                35.0544087
              ],
              [
                56.585119,
                35.0544087
              ],
              [
                56.5840089,
                35.0541291
              ],
              [
                56.5820622,
                35.0541291
              ],
              [
                56.5815089,
                35.0538494
              ],
              [
                56.580119,
                35.0538494
              ],
              [
                56.5723425,
                35.0530195
              ],
              [
                56.5717858,
                35.0530195
              ],
              [
                56.5703958,
                35.0530195
              ],
              [
                56.5687292,
                35.0527399
              ],
              [
                56.5645624,
                35.0527399
              ],
              [
                56.5637292,
                35.0524603
              ],
              [
                56.5620626,
                35.0524603
              ],
              [
                56.5367828,
                35.0477427
              ],
              [
                56.5345628,
                35.0469038
              ],
              [
                56.5328961,
                35.0466241
              ],
              [
                56.5190065,
                35.0421861
              ],
              [
                56.5178931,
                35.0413472
              ],
              [
                56.5170597,
                35.0413472
              ],
              [
                56.4884468,
                35.0285743
              ],
              [
                56.4815034,
                35.0221877
              ],
              [
                56.4537237,
                34.9999609
              ],
              [
                56.4428905,
                34.9796821
              ],
              [
                56.3944879,
                34.9442453
              ],
              [
                56.3944879,
                34.943695
              ],
              [
                56.3939312,
                34.9431357
              ],
              [
                56.3903212,
                34.9375884
              ],
              [
                56.3900413,
                34.9367495
              ],
              [
                56.3883746,
                34.9345305
              ],
              [
                56.3490919,
                34.901935
              ],
              [
                56.3490918,
                34.9016555
              ],
              [
                56.3488151,
                34.9013759
              ],
              [
                56.348535,
                34.9005461
              ],
              [
                56.3413118,
                34.8899939
              ],
              [
                56.3338118,
                34.8836082
              ],
              [
                56.3335353,
                34.8833287
              ],
              [
                56.3324253,
                34.8816692
              ],
              [
                56.3279786,
                34.8775023
              ],
              [
                56.3125957,
                34.8659688
              ],
              [
                56.2579799,
                34.8230391
              ],
              [
                56.2554798,
                34.8199904
              ],
              [
                56.23159,
                34.7858323
              ],
              [
                56.2307568,
                34.7852731
              ],
              [
                56.2237801,
                34.7482579
              ],
              [
                56.2235036,
                34.7471391
              ],
              [
                56.221837,
                34.7446398
              ],
              [
                56.226223,
                34.7260448
              ],
              [
                56.2237229,
                34.7229952
              ],
              [
                56.2284362,
                34.7118984
              ],
              [
                56.2279736,
                34.7104172
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554958,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان طرقبه شاندیز",
          "name:en": "torghabeh shandiz County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2577815",
          "wikipedia": "fa:شهرستان طرقبه شاندیز"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.0667757,
                36.3207154
              ],
              [
                59.0897508,
                36.3051227
              ],
              [
                59.1080909,
                36.2899734
              ],
              [
                59.138575,
                36.2591552
              ],
              [
                59.1396883,
                36.2588758
              ],
              [
                59.1424684,
                36.258038
              ],
              [
                59.149135,
                36.2549837
              ],
              [
                59.1508014,
                36.2538755
              ],
              [
                59.1533583,
                36.2511089
              ],
              [
                59.1744076,
                36.2283234
              ],
              [
                59.1749678,
                36.2277648
              ],
              [
                59.1929623,
                36.2091004
              ],
              [
                59.2189167,
                36.1883662
              ],
              [
                59.2225301,
                36.185311
              ],
              [
                59.2423195,
                36.1705681
              ],
              [
                59.2669134,
                36.1513742
              ],
              [
                59.26914,
                36.1505361
              ],
              [
                59.2708065,
                36.1497071
              ],
              [
                59.2719131,
                36.1497072
              ],
              [
                59.2724733,
                36.1494279
              ],
              [
                59.2897161,
                36.1516456
              ],
              [
                59.2902759,
                36.1513662
              ],
              [
                59.2961092,
                36.1499786
              ],
              [
                59.3008292,
                36.1463653
              ],
              [
                59.3094423,
                36.1338675
              ],
              [
                59.3089124,
                36.1183187
              ],
              [
                59.3128058,
                36.1130383
              ],
              [
                59.3139124,
                36.1108126
              ],
              [
                59.3141926,
                36.1105423
              ],
              [
                59.3144367,
                36.1100534
              ],
              [
                59.3250257,
                36.116922
              ],
              [
                59.323859,
                36.1188714
              ],
              [
                59.3266392,
                36.1188714
              ],
              [
                59.3288591,
                36.1183217
              ],
              [
                59.3455321,
                36.1127618
              ],
              [
                59.3521986,
                36.1110947
              ],
              [
                59.3546988,
                36.110536
              ],
              [
                59.3569187,
                36.110536
              ],
              [
                59.3583054,
                36.1102567
              ],
              [
                59.3646984,
                36.1103269
              ],
              [
                59.426851,
                36.1036269
              ],
              [
                59.4546306,
                36.1116849
              ],
              [
                59.461017,
                36.113073
              ],
              [
                59.467684,
                36.1183548
              ],
              [
                59.4695472,
                36.1202954
              ],
              [
                59.4667706,
                36.1246073
              ],
              [
                59.4658123,
                36.1355623
              ],
              [
                59.466919,
                36.139735
              ],
              [
                59.4681555,
                36.1412047
              ],
              [
                59.4907436,
                36.1503067
              ],
              [
                59.4937972,
                36.1553089
              ],
              [
                59.4940768,
                36.1561381
              ],
              [
                59.4984185,
                36.1666926
              ],
              [
                59.4975854,
                36.1730826
              ],
              [
                59.4978584,
                36.1736413
              ],
              [
                59.5025852,
                36.1814191
              ],
              [
                59.5029634,
                36.1808697
              ],
              [
                59.5060237,
                36.1803198
              ],
              [
                59.5068569,
                36.1803198
              ],
              [
                59.5138802,
                36.1837721
              ],
              [
                59.5147135,
                36.1837722
              ],
              [
                59.5266266,
                36.1871136
              ],
              [
                59.5294067,
                36.1882222
              ],
              [
                59.5341264,
                36.1876724
              ],
              [
                59.53496,
                36.1871136
              ],
              [
                59.5357932,
                36.1871136
              ],
              [
                59.5357932,
                36.1868343
              ],
              [
                59.5380132,
                36.1865638
              ],
              [
                59.5382932,
                36.1862756
              ],
              [
                59.5405199,
                36.1862755
              ],
              [
                59.540793,
                36.1865639
              ],
              [
                59.5416266,
                36.1865639
              ],
              [
                59.5860694,
                36.190285
              ],
              [
                59.5866296,
                36.1905643
              ],
              [
                59.5877362,
                36.1905643
              ],
              [
                59.5880163,
                36.1908438
              ],
              [
                59.5894027,
                36.1908439
              ],
              [
                59.5956801,
                36.1989885
              ],
              [
                59.5920752,
                36.2067456
              ],
              [
                59.5864104,
                36.2099313
              ],
              [
                59.5871298,
                36.2201447
              ],
              [
                59.588737,
                36.2217417
              ],
              [
                59.5878412,
                36.2375106
              ],
              [
                59.5869225,
                36.2379307
              ],
              [
                59.5841514,
                36.2386731
              ],
              [
                59.5843284,
                36.2409058
              ],
              [
                59.5845076,
                36.2417077
              ],
              [
                59.5847953,
                36.2437602
              ],
              [
                59.5853269,
                36.2459691
              ],
              [
                59.5852411,
                36.2482274
              ],
              [
                59.5816067,
                36.2526622
              ],
              [
                59.580108,
                36.2535433
              ],
              [
                59.5784046,
                36.2545074
              ],
              [
                59.5736268,
                36.2551612
              ],
              [
                59.5693397,
                36.2551784
              ],
              [
                59.5625097,
                36.2557712
              ],
              [
                59.5542039,
                36.2570924
              ],
              [
                59.546186,
                36.2586502
              ],
              [
                59.5436814,
                36.25936
              ],
              [
                59.5396146,
                36.2611751
              ],
              [
                59.5357562,
                36.2637697
              ],
              [
                59.5327936,
                36.2654801
              ],
              [
                59.5290535,
                36.2671583
              ],
              [
                59.5274363,
                36.2677017
              ],
              [
                59.5259547,
                36.2685522
              ],
              [
                59.5244638,
                36.2696379
              ],
              [
                59.5228751,
                36.2704337
              ],
              [
                59.5215561,
                36.270997
              ],
              [
                59.5202492,
                36.2717199
              ],
              [
                59.5185895,
                36.2724763
              ],
              [
                59.5165297,
                36.2727972
              ],
              [
                59.5142901,
                36.2732474
              ],
              [
                59.5119305,
                36.2739395
              ],
              [
                59.5094312,
                36.2743585
              ],
              [
                59.5072916,
                36.2748084
              ],
              [
                59.5055517,
                36.2758073
              ],
              [
                59.5036119,
                36.2768062
              ],
              [
                59.5016722,
                36.2778697
              ],
              [
                59.4992125,
                36.2797388
              ],
              [
                59.4966298,
                36.2815187
              ],
              [
                59.4943888,
                36.2832081
              ],
              [
                59.492149,
                36.2845131
              ],
              [
                59.4897295,
                36.2854471
              ],
              [
                59.4869501,
                36.2865753
              ],
              [
                59.4847106,
                36.2876224
              ],
              [
                59.4818708,
                36.2891362
              ],
              [
                59.4797712,
                36.2897151
              ],
              [
                59.4768316,
                36.2906006
              ],
              [
                59.4739525,
                36.2911807
              ],
              [
                59.471573,
                36.2920832
              ],
              [
                59.4692116,
                36.2934305
              ],
              [
                59.4677318,
                36.2951224
              ],
              [
                59.466332,
                36.2970891
              ],
              [
                59.4658121,
                36.2987492
              ],
              [
                59.4653322,
                36.3005711
              ],
              [
                59.4649718,
                36.3035849
              ],
              [
                59.4646318,
                36.3064071
              ],
              [
                59.4650515,
                36.3082125
              ],
              [
                59.4646116,
                36.310372
              ],
              [
                59.4637602,
                36.3131871
              ],
              [
                59.4637455,
                36.3132358
              ],
              [
                59.4630856,
                36.3157989
              ],
              [
                59.4630854,
                36.3178785
              ],
              [
                59.4633925,
                36.3196546
              ],
              [
                59.4629327,
                36.3199126
              ],
              [
                59.4615131,
                36.3203157
              ],
              [
                59.4598937,
                36.3214606
              ],
              [
                59.4584339,
                36.3225556
              ],
              [
                59.4578141,
                36.3243616
              ],
              [
                59.4575936,
                36.3264392
              ],
              [
                59.4558584,
                36.3267605
              ],
              [
                59.44608,
                36.3278996
              ],
              [
                59.4400482,
                36.3285716
              ],
              [
                59.4374288,
                36.3285865
              ],
              [
                59.4379648,
                36.3295381
              ],
              [
                59.4361146,
                36.3296378
              ],
              [
                59.436769,
                36.3307793
              ],
              [
                59.4380086,
                36.3307148
              ],
              [
                59.4390682,
                36.3316016
              ],
              [
                59.4401276,
                36.331633
              ],
              [
                59.4429266,
                36.3333421
              ],
              [
                59.4415866,
                36.3342277
              ],
              [
                59.4411464,
                36.3348711
              ],
              [
                59.442506,
                36.3355482
              ],
              [
                59.4420661,
                36.3363866
              ],
              [
                59.4397469,
                36.337628
              ],
              [
                59.4412049,
                36.3387855
              ],
              [
                59.4419647,
                36.339785
              ],
              [
                59.4421631,
                36.3406843
              ],
              [
                59.4420432,
                36.3419257
              ],
              [
                59.4423828,
                36.3432464
              ],
              [
                59.4416831,
                36.3439879
              ],
              [
                59.4405635,
                36.3445844
              ],
              [
                59.4409717,
                36.3454049
              ],
              [
                59.4414609,
                36.3463165
              ],
              [
                59.4419314,
                36.3471293
              ],
              [
                59.442069,
                36.3472392
              ],
              [
                59.4422488,
                36.3473063
              ],
              [
                59.4424436,
                36.347341
              ],
              [
                59.4422256,
                36.3476696
              ],
              [
                59.4410107,
                36.3493868
              ],
              [
                59.437405,
                36.3543667
              ],
              [
                59.4371409,
                36.354712
              ],
              [
                59.436911,
                36.3549701
              ],
              [
                59.4366025,
                36.3551991
              ],
              [
                59.4315068,
                36.3573993
              ],
              [
                59.4290421,
                36.3583813
              ],
              [
                59.4202603,
                36.361849
              ],
              [
                59.4201994,
                36.362589
              ],
              [
                59.4233966,
                36.3663558
              ],
              [
                59.4243622,
                36.3693277
              ],
              [
                59.4266152,
                36.3718675
              ],
              [
                59.4267225,
                36.3725932
              ],
              [
                59.4269579,
                36.3745715
              ],
              [
                59.4279027,
                36.3764114
              ],
              [
                59.4291043,
                36.3781217
              ],
              [
                59.430778,
                36.3798493
              ],
              [
                59.4331086,
                36.3815747
              ],
              [
                59.4349886,
                36.3822635
              ],
              [
                59.4354343,
                36.3825615
              ],
              [
                59.4369454,
                36.3835386
              ],
              [
                59.4390738,
                36.3856256
              ],
              [
                59.4429016,
                36.3881239
              ],
              [
                59.4469215,
                36.389946
              ],
              [
                59.4484914,
                36.3881988
              ],
              [
                59.4495163,
                36.3882833
              ],
              [
                59.4500814,
                36.3882886
              ],
              [
                59.4514974,
                36.3890535
              ],
              [
                59.4521877,
                36.3897931
              ],
              [
                59.455654,
                36.3914124
              ],
              [
                59.4608132,
                36.393794
              ],
              [
                59.4694998,
                36.3904709
              ],
              [
                59.4613934,
                36.3944739
              ],
              [
                59.4591451,
                36.3955504
              ],
              [
                59.4583115,
                36.3986042
              ],
              [
                59.4577585,
                36.399433
              ],
              [
                59.4580385,
                36.3997122
              ],
              [
                59.4583054,
                36.4035346
              ],
              [
                59.4600649,
                36.4061882
              ],
              [
                59.4638869,
                36.4089255
              ],
              [
                59.4670904,
                36.4107404
              ],
              [
                59.4683165,
                36.4133277
              ],
              [
                59.464821,
                36.4164535
              ],
              [
                59.4603729,
                36.419992
              ],
              [
                59.4589733,
                36.4221849
              ],
              [
                59.4529821,
                36.4282024
              ],
              [
                59.4487057,
                36.4308592
              ],
              [
                59.4443546,
                36.4351181
              ],
              [
                59.444396,
                36.438197
              ],
              [
                59.4419868,
                36.4405112
              ],
              [
                59.4354793,
                36.4423461
              ],
              [
                59.4260787,
                36.4502847
              ],
              [
                59.4135887,
                36.4601539
              ],
              [
                59.4028661,
                36.463723
              ],
              [
                59.3916926,
                36.4702455
              ],
              [
                59.3822957,
                36.4709943
              ],
              [
                59.3732197,
                36.4734139
              ],
              [
                59.3606349,
                36.4781003
              ],
              [
                59.3589868,
                36.4794066
              ],
              [
                59.3569801,
                36.4801328
              ],
              [
                59.3538488,
                36.4817269
              ],
              [
                59.3523143,
                36.4833589
              ],
              [
                59.3501132,
                36.484481
              ],
              [
                59.3443679,
                36.4875227
              ],
              [
                59.3378795,
                36.4911974
              ],
              [
                59.3321639,
                36.4900469
              ],
              [
                59.3272601,
                36.490445
              ],
              [
                59.3242553,
                36.4921433
              ],
              [
                59.3212023,
                36.4976403
              ],
              [
                59.3179252,
                36.5003912
              ],
              [
                59.3115221,
                36.5030948
              ],
              [
                59.3073693,
                36.504025
              ],
              [
                59.3044005,
                36.5082682
              ],
              [
                59.2997359,
                36.4990805
              ],
              [
                59.2960452,
                36.4932846
              ],
              [
                59.2933845,
                36.4912145
              ],
              [
                59.2907237,
                36.4825196
              ],
              [
                59.2850589,
                36.46844
              ],
              [
                59.2791125,
                36.4556091
              ],
              [
                59.2781066,
                36.4497324
              ],
              [
                59.2680473,
                36.4416566
              ],
              [
                59.2566489,
                36.4415852
              ],
              [
                59.2496108,
                36.4437947
              ],
              [
                59.2435809,
                36.4408249
              ],
              [
                59.233451,
                36.4365438
              ],
              [
                59.2275927,
                36.4344661
              ],
              [
                59.2193126,
                36.4310201
              ],
              [
                59.2183683,
                36.4230783
              ],
              [
                59.2070586,
                36.4224131
              ],
              [
                59.187415,
                36.4268332
              ],
              [
                59.1803701,
                36.4274035
              ],
              [
                59.1656536,
                36.4220649
              ],
              [
                59.1565173,
                36.4200935
              ],
              [
                59.1498756,
                36.4134431
              ],
              [
                59.1437387,
                36.4132704
              ],
              [
                59.1360688,
                36.4118678
              ],
              [
                59.1254997,
                36.4095059
              ],
              [
                59.1151044,
                36.4061316
              ],
              [
                59.1101378,
                36.4031588
              ],
              [
                59.1029262,
                36.3953786
              ],
              [
                59.0927066,
                36.3864194
              ],
              [
                59.0874766,
                36.3781736
              ],
              [
                59.0845333,
                36.3702331
              ],
              [
                59.0809341,
                36.3484953
              ],
              [
                59.0765818,
                36.3430293
              ],
              [
                59.0774823,
                36.3392564
              ],
              [
                59.0796282,
                36.3331693
              ],
              [
                59.0742822,
                36.3271931
              ],
              [
                59.0667757,
                36.3207154
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554960,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تایباد",
          "name:ar": "مقاطعة تايباد",
          "name:en": "Taybad County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1278169",
          "wikipedia": "fa:شهرستان تایباد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.2641871,
                34.7871297
              ],
              [
                60.2715968,
                34.7765174
              ],
              [
                60.2752017,
                34.7738383
              ],
              [
                60.2840423,
                34.7713002
              ],
              [
                60.2857589,
                34.7665058
              ],
              [
                60.2849006,
                34.7648841
              ],
              [
                60.2883338,
                34.7552237
              ],
              [
                60.2929233,
                34.7493079
              ],
              [
                60.3022365,
                34.7416121
              ],
              [
                60.3050211,
                34.7397807
              ],
              [
                60.3016376,
                34.7337834
              ],
              [
                60.3012084,
                34.7275054
              ],
              [
                60.3129672,
                34.7226379
              ],
              [
                60.3225768,
                34.7146543
              ],
              [
                60.3288459,
                34.7083159
              ],
              [
                60.3375982,
                34.7005758
              ],
              [
                60.3382383,
                34.6978667
              ],
              [
                60.3411092,
                34.6891627
              ],
              [
                60.3430937,
                34.684605
              ],
              [
                60.3528784,
                34.6748646
              ],
              [
                60.3576849,
                34.6656879
              ],
              [
                60.367717,
                34.6394308
              ],
              [
                60.4096984,
                34.6435181
              ],
              [
                60.4028812,
                34.6305707
              ],
              [
                60.4004287,
                34.6248388
              ],
              [
                60.4217902,
                34.6133933
              ],
              [
                60.439825,
                34.5932969
              ],
              [
                60.4521976,
                34.5856474
              ],
              [
                60.4707817,
                34.578582
              ],
              [
                60.4955082,
                34.5663462
              ],
              [
                60.5164715,
                34.5417729
              ],
              [
                60.5233869,
                34.5339695
              ],
              [
                60.521989,
                34.5192981
              ],
              [
                60.5363845,
                34.5009689
              ],
              [
                60.5433733,
                34.4851179
              ],
              [
                60.5490868,
                34.4737321
              ],
              [
                60.5524234,
                34.4693433
              ],
              [
                60.5555352,
                34.4659455
              ],
              [
                60.569112,
                34.4660229
              ],
              [
                60.5761476,
                34.4653926
              ],
              [
                60.593853,
                34.4480124
              ],
              [
                60.6092324,
                34.4528183
              ],
              [
                60.6254899,
                34.4614591
              ],
              [
                60.6308835,
                34.4548377
              ],
              [
                60.6368916,
                34.4483263
              ],
              [
                60.6655591,
                34.4554039
              ],
              [
                60.6798934,
                34.4461316
              ],
              [
                60.6825536,
                34.4231959
              ],
              [
                60.6845283,
                34.4187349
              ],
              [
                60.6901073,
                34.413212
              ],
              [
                60.7008361,
                34.4163275
              ],
              [
                60.7083886,
                34.419939
              ],
              [
                60.7300185,
                34.4182392
              ],
              [
                60.7551234,
                34.4179211
              ],
              [
                60.7631921,
                34.4250008
              ],
              [
                60.7901859,
                34.4178852
              ],
              [
                60.7970094,
                34.4205757
              ],
              [
                60.8057212,
                34.4206111
              ],
              [
                60.8135318,
                34.4193013
              ],
              [
                60.8291161,
                34.4126009
              ],
              [
                60.8415126,
                34.4083614
              ],
              [
                60.843599,
                34.407853
              ],
              [
                60.842749,
                34.408339
              ],
              [
                60.84244,
                34.40872
              ],
              [
                60.842043,
                34.40956
              ],
              [
                60.841881,
                34.410356
              ],
              [
                60.841701,
                34.410641
              ],
              [
                60.840972,
                34.41105
              ],
              [
                60.840119,
                34.411228
              ],
              [
                60.839814,
                34.411398
              ],
              [
                60.839603,
                34.411719
              ],
              [
                60.839172,
                34.411708
              ],
              [
                60.838599,
                34.412024
              ],
              [
                60.838305,
                34.41229
              ],
              [
                60.83806,
                34.412382
              ],
              [
                60.837562,
                34.41247
              ],
              [
                60.836761,
                34.412391
              ],
              [
                60.835723,
                34.412655
              ],
              [
                60.835501,
                34.412824
              ],
              [
                60.835383,
                34.412998
              ],
              [
                60.835229,
                34.413402
              ],
              [
                60.834877,
                34.413748
              ],
              [
                60.83468,
                34.414022
              ],
              [
                60.834591,
                34.41434
              ],
              [
                60.834475,
                34.414447
              ],
              [
                60.834007,
                34.414478
              ],
              [
                60.833654,
                34.414649
              ],
              [
                60.832984,
                34.414749
              ],
              [
                60.832599,
                34.415013
              ],
              [
                60.8322,
                34.415195
              ],
              [
                60.831626,
                34.415245
              ],
              [
                60.830901,
                34.415409
              ],
              [
                60.829791,
                34.415857
              ],
              [
                60.829733,
                34.416101
              ],
              [
                60.829851,
                34.416517
              ],
              [
                60.830164,
                34.417291
              ],
              [
                60.830508,
                34.417778
              ],
              [
                60.830551,
                34.417967
              ],
              [
                60.830447,
                34.418532
              ],
              [
                60.830404,
                34.419169
              ],
              [
                60.830454,
                34.420072
              ],
              [
                60.830015,
                34.42013
              ],
              [
                60.829861,
                34.420206
              ],
              [
                60.829554,
                34.420394
              ],
              [
                60.828952,
                34.420916
              ],
              [
                60.829082,
                34.421378
              ],
              [
                60.829062,
                34.421507
              ],
              [
                60.828956,
                34.421659
              ],
              [
                60.828844,
                34.422315
              ],
              [
                60.828682,
                34.422409
              ],
              [
                60.828492,
                34.4224
              ],
              [
                60.828159,
                34.422283
              ],
              [
                60.827622,
                34.42264
              ],
              [
                60.827637,
                34.422933
              ],
              [
                60.826762,
                34.423126
              ],
              [
                60.826635,
                34.423236
              ],
              [
                60.826603,
                34.423353
              ],
              [
                60.82694,
                34.423776
              ],
              [
                60.827261,
                34.424585
              ],
              [
                60.827308,
                34.424977
              ],
              [
                60.827278,
                34.425283
              ],
              [
                60.827495,
                34.425669
              ],
              [
                60.827512,
                34.426035
              ],
              [
                60.828181,
                34.426566
              ],
              [
                60.828257,
                34.426675
              ],
              [
                60.828034,
                34.426775
              ],
              [
                60.827902,
                34.42698
              ],
              [
                60.827874,
                34.427412
              ],
              [
                60.827808,
                34.427541
              ],
              [
                60.827239,
                34.427921
              ],
              [
                60.82722,
                34.428035
              ],
              [
                60.827295,
                34.428341
              ],
              [
                60.82725,
                34.42847
              ],
              [
                60.827433,
                34.428762
              ],
              [
                60.827414,
                34.428826
              ],
              [
                60.826937,
                34.429053
              ],
              [
                60.826113,
                34.429053
              ],
              [
                60.825609,
                34.428624
              ],
              [
                60.825455,
                34.428592
              ],
              [
                60.825221,
                34.428785
              ],
              [
                60.82507,
                34.428826
              ],
              [
                60.824572,
                34.429102
              ],
              [
                60.824004,
                34.429203
              ],
              [
                60.823391,
                34.429142
              ],
              [
                60.822808,
                34.429275
              ],
              [
                60.822457,
                34.429279
              ],
              [
                60.822148,
                34.429559
              ],
              [
                60.822255,
                34.42993
              ],
              [
                60.822086,
                34.43051
              ],
              [
                60.822112,
                34.430822
              ],
              [
                60.822228,
                34.430921
              ],
              [
                60.822227,
                34.431235
              ],
              [
                60.822103,
                34.431407
              ],
              [
                60.821739,
                34.431678
              ],
              [
                60.821348,
                34.43186
              ],
              [
                60.821064,
                34.432256
              ],
              [
                60.821183,
                34.432484
              ],
              [
                60.82115,
                34.43298
              ],
              [
                60.821272,
                34.433268
              ],
              [
                60.821364,
                34.433692
              ],
              [
                60.821234,
                34.433979
              ],
              [
                60.821223,
                34.434147
              ],
              [
                60.821279,
                34.434291
              ],
              [
                60.821612,
                34.434472
              ],
              [
                60.821876,
                34.434683
              ],
              [
                60.821739,
                34.434984
              ],
              [
                60.821682,
                34.435326
              ],
              [
                60.821721,
                34.435837
              ],
              [
                60.821196,
                34.436185
              ],
              [
                60.821331,
                34.436605
              ],
              [
                60.821487,
                34.436784
              ],
              [
                60.821506,
                34.436876
              ],
              [
                60.821305,
                34.437213
              ],
              [
                60.821189,
                34.437762
              ],
              [
                60.821248,
                34.438108
              ],
              [
                60.821666,
                34.438339
              ],
              [
                60.82173,
                34.43852
              ],
              [
                60.82189,
                34.438719
              ],
              [
                60.821506,
                34.439513
              ],
              [
                60.821365,
                34.4396
              ],
              [
                60.821249,
                34.43991
              ],
              [
                60.82128,
                34.439998
              ],
              [
                60.821222,
                34.440224
              ],
              [
                60.821156,
                34.440333
              ],
              [
                60.820998,
                34.440408
              ],
              [
                60.82103,
                34.440689
              ],
              [
                60.821201,
                34.441111
              ],
              [
                60.821367,
                34.44124
              ],
              [
                60.821625,
                34.441661
              ],
              [
                60.82169,
                34.441862
              ],
              [
                60.821639,
                34.442314
              ],
              [
                60.82124,
                34.442531
              ],
              [
                60.820816,
                34.442897
              ],
              [
                60.820647,
                34.442868
              ],
              [
                60.820458,
                34.442899
              ],
              [
                60.820113,
                34.443038
              ],
              [
                60.819761,
                34.443688
              ],
              [
                60.819719,
                34.444321
              ],
              [
                60.819147,
                34.444483
              ],
              [
                60.818896,
                34.44434
              ],
              [
                60.818304,
                34.444488
              ],
              [
                60.817877,
                34.444739
              ],
              [
                60.817099,
                34.444959
              ],
              [
                60.817045,
                34.445051
              ],
              [
                60.816607,
                34.445279
              ],
              [
                60.816527,
                34.44538
              ],
              [
                60.816367,
                34.446284
              ],
              [
                60.816142,
                34.44676
              ],
              [
                60.815622,
                34.447592
              ],
              [
                60.815685,
                34.44785
              ],
              [
                60.815656,
                34.448253
              ],
              [
                60.815405,
                34.448366
              ],
              [
                60.815302,
                34.448524
              ],
              [
                60.815099,
                34.449242
              ],
              [
                60.814725,
                34.44995
              ],
              [
                60.814567,
                34.450472
              ],
              [
                60.814585,
                34.45089
              ],
              [
                60.814508,
                34.450817
              ],
              [
                60.814489,
                34.45054
              ],
              [
                60.814361,
                34.450349
              ],
              [
                60.814062,
                34.45022
              ],
              [
                60.813668,
                34.450693
              ],
              [
                60.81313,
                34.45157
              ],
              [
                60.812992,
                34.45174
              ],
              [
                60.81285,
                34.451831
              ],
              [
                60.812205,
                34.453348
              ],
              [
                60.811957,
                34.453599
              ],
              [
                60.811729,
                34.453968
              ],
              [
                60.811601,
                34.453962
              ],
              [
                60.811348,
                34.454217
              ],
              [
                60.811215,
                34.454785
              ],
              [
                60.811396,
                34.455261
              ],
              [
                60.811088,
                34.455565
              ],
              [
                60.810792,
                34.455751
              ],
              [
                60.810696,
                34.455924
              ],
              [
                60.810424,
                34.456093
              ],
              [
                60.810188,
                34.456533
              ],
              [
                60.809671,
                34.456823
              ],
              [
                60.809584,
                34.45702
              ],
              [
                60.809553,
                34.457356
              ],
              [
                60.809583,
                34.457805
              ],
              [
                60.809144,
                34.458333
              ],
              [
                60.80894,
                34.458685
              ],
              [
                60.809045,
                34.459171
              ],
              [
                60.808932,
                34.459256
              ],
              [
                60.808811,
                34.459557
              ],
              [
                60.808812,
                34.459693
              ],
              [
                60.809023,
                34.460319
              ],
              [
                60.808642,
                34.460408
              ],
              [
                60.808555,
                34.460519
              ],
              [
                60.808474,
                34.460911
              ],
              [
                60.808374,
                34.461131
              ],
              [
                60.807977,
                34.461219
              ],
              [
                60.807639,
                34.46145
              ],
              [
                60.807459,
                34.461703
              ],
              [
                60.80739,
                34.461911
              ],
              [
                60.807362,
                34.462389
              ],
              [
                60.807435,
                34.462496
              ],
              [
                60.80747,
                34.46273
              ],
              [
                60.807454,
                34.463055
              ],
              [
                60.807608,
                34.463268
              ],
              [
                60.807727,
                34.463348
              ],
              [
                60.807854,
                34.46373
              ],
              [
                60.807655,
                34.464124
              ],
              [
                60.807563,
                34.464505
              ],
              [
                60.807415,
                34.464736
              ],
              [
                60.80739,
                34.46495
              ],
              [
                60.807601,
                34.466344
              ],
              [
                60.807704,
                34.466704
              ],
              [
                60.808064,
                34.467548
              ],
              [
                60.808645,
                34.468636
              ],
              [
                60.808756,
                34.469008
              ],
              [
                60.808711,
                34.469515
              ],
              [
                60.808613,
                34.469721
              ],
              [
                60.808642,
                34.470057
              ],
              [
                60.808858,
                34.470381
              ],
              [
                60.809271,
                34.471493
              ],
              [
                60.809274,
                34.471653
              ],
              [
                60.808798,
                34.471701
              ],
              [
                60.808545,
                34.471846
              ],
              [
                60.807819,
                34.471973
              ],
              [
                60.807416,
                34.471888
              ],
              [
                60.806705,
                34.471912
              ],
              [
                60.806441,
                34.47201
              ],
              [
                60.806357,
                34.472122
              ],
              [
                60.806073,
                34.472262
              ],
              [
                60.805708,
                34.472162
              ],
              [
                60.803932,
                34.472194
              ],
              [
                60.803754,
                34.472311
              ],
              [
                60.803585,
                34.472892
              ],
              [
                60.803372,
                34.47305
              ],
              [
                60.802743,
                34.473018
              ],
              [
                60.802393,
                34.473087
              ],
              [
                60.802088,
                34.473226
              ],
              [
                60.801661,
                34.473509
              ],
              [
                60.801542,
                34.47396
              ],
              [
                60.801142,
                34.474348
              ],
              [
                60.801075,
                34.474626
              ],
              [
                60.800906,
                34.475008
              ],
              [
                60.800831,
                34.475064
              ],
              [
                60.800364,
                34.474966
              ],
              [
                60.80024,
                34.474866
              ],
              [
                60.799737,
                34.474766
              ],
              [
                60.79923,
                34.474186
              ],
              [
                60.798949,
                34.473942
              ],
              [
                60.797746,
                34.473151
              ],
              [
                60.797528,
                34.473042
              ],
              [
                60.797128,
                34.472947
              ],
              [
                60.796075,
                34.473385
              ],
              [
                60.795587,
                34.473502
              ],
              [
                60.795337,
                34.473683
              ],
              [
                60.794946,
                34.473812
              ],
              [
                60.794446,
                34.473779
              ],
              [
                60.794209,
                34.473806
              ],
              [
                60.793964,
                34.47392
              ],
              [
                60.793602,
                34.474238
              ],
              [
                60.793479,
                34.474412
              ],
              [
                60.79338,
                34.474864
              ],
              [
                60.792778,
                34.475289
              ],
              [
                60.792452,
                34.47541
              ],
              [
                60.791904,
                34.475395
              ],
              [
                60.791716,
                34.475431
              ],
              [
                60.791046,
                34.475696
              ],
              [
                60.790596,
                34.475822
              ],
              [
                60.790455,
                34.476061
              ],
              [
                60.790219,
                34.476202
              ],
              [
                60.790074,
                34.476355
              ],
              [
                60.789936,
                34.476961
              ],
              [
                60.789762,
                34.477471
              ],
              [
                60.789617,
                34.477702
              ],
              [
                60.788204,
                34.479516
              ],
              [
                60.787299,
                34.481016
              ],
              [
                60.787096,
                34.48147
              ],
              [
                60.786463,
                34.482361
              ],
              [
                60.786546,
                34.482717
              ],
              [
                60.787014,
                34.483541
              ],
              [
                60.787014,
                34.483671
              ],
              [
                60.786485,
                34.483774
              ],
              [
                60.784613,
                34.48375
              ],
              [
                60.784307,
                34.483781
              ],
              [
                60.783791,
                34.483919
              ],
              [
                60.783585,
                34.484065
              ],
              [
                60.783185,
                34.484485
              ],
              [
                60.782969,
                34.485179
              ],
              [
                60.782883,
                34.485362
              ],
              [
                60.782734,
                34.485498
              ],
              [
                60.78253,
                34.485536
              ],
              [
                60.78177,
                34.485479
              ],
              [
                60.78114,
                34.485161
              ],
              [
                60.780835,
                34.485257
              ],
              [
                60.780411,
                34.485484
              ],
              [
                60.780206,
                34.485523
              ],
              [
                60.779687,
                34.485479
              ],
              [
                60.7794243,
                34.4858567
              ],
              [
                60.779077,
                34.486356
              ],
              [
                60.77898,
                34.486566
              ],
              [
                60.77849,
                34.486623
              ],
              [
                60.778181,
                34.486705
              ],
              [
                60.777797,
                34.486709
              ],
              [
                60.777212,
                34.486396
              ],
              [
                60.777104,
                34.486392
              ],
              [
                60.777055,
                34.486326
              ],
              [
                60.77663,
                34.48631
              ],
              [
                60.776112,
                34.486475
              ],
              [
                60.775715,
                34.486686
              ],
              [
                60.774981,
                34.486922
              ],
              [
                60.774813,
                34.487152
              ],
              [
                60.774483,
                34.48742
              ],
              [
                60.774236,
                34.487789
              ],
              [
                60.774182,
                34.488012
              ],
              [
                60.773695,
                34.488553
              ],
              [
                60.773602,
                34.488718
              ],
              [
                60.751371,
                34.507627
              ],
              [
                60.741861,
                34.510827
              ],
              [
                60.739083,
                34.518086
              ],
              [
                60.742346,
                34.526945
              ],
              [
                60.790337,
                34.537761
              ],
              [
                60.822836,
                34.544868
              ],
              [
                60.825974,
                34.539144
              ],
              [
                60.83095,
                34.544876
              ],
              [
                60.84865,
                34.542077
              ],
              [
                60.897272,
                34.56726
              ],
              [
                60.903606,
                34.580335
              ],
              [
                60.910524,
                34.596911
              ],
              [
                60.915095,
                34.607009
              ],
              [
                60.918034,
                34.613896
              ],
              [
                60.9214342,
                34.6213163
              ],
              [
                60.922214,
                34.623018
              ],
              [
                60.922306,
                34.622878
              ],
              [
                60.922848,
                34.622432
              ],
              [
                60.923185,
                34.622264
              ],
              [
                60.923434,
                34.622231
              ],
              [
                60.924173,
                34.622262
              ],
              [
                60.924961,
                34.622179
              ],
              [
                60.925485,
                34.621959
              ],
              [
                60.926355,
                34.621497
              ],
              [
                60.926526,
                34.621535
              ],
              [
                60.926876,
                34.621424
              ],
              [
                60.927289,
                34.621367
              ],
              [
                60.927646,
                34.621383
              ],
              [
                60.927917,
                34.621346
              ],
              [
                60.928187,
                34.621188
              ],
              [
                60.92871,
                34.621089
              ],
              [
                60.929401,
                34.621432
              ],
              [
                60.929556,
                34.621436
              ],
              [
                60.929666,
                34.621401
              ],
              [
                60.929897,
                34.621185
              ],
              [
                60.93003,
                34.621131
              ],
              [
                60.930266,
                34.621157
              ],
              [
                60.930645,
                34.621086
              ],
              [
                60.930703,
                34.621182
              ],
              [
                60.930654,
                34.621366
              ],
              [
                60.93069,
                34.621484
              ],
              [
                60.930936,
                34.621898
              ],
              [
                60.931029,
                34.622002
              ],
              [
                60.931343,
                34.622142
              ],
              [
                60.9318,
                34.622076
              ],
              [
                60.932474,
                34.621876
              ],
              [
                60.932662,
                34.621742
              ],
              [
                60.932814,
                34.621511
              ],
              [
                60.93298,
                34.621451
              ],
              [
                60.933582,
                34.621527
              ],
              [
                60.933941,
                34.621717
              ],
              [
                60.935302,
                34.62154
              ],
              [
                60.935707,
                34.621819
              ],
              [
                60.935923,
                34.621876
              ],
              [
                60.936511,
                34.622236
              ],
              [
                60.936791,
                34.622464
              ],
              [
                60.937039,
                34.622843
              ],
              [
                60.937444,
                34.623014
              ],
              [
                60.93777,
                34.623044
              ],
              [
                60.938147,
                34.623152
              ],
              [
                60.938299,
                34.623837
              ],
              [
                60.938541,
                34.624089
              ],
              [
                60.938789,
                34.624207
              ],
              [
                60.938931,
                34.624383
              ],
              [
                60.939049,
                34.624383
              ],
              [
                60.939032,
                34.624099
              ],
              [
                60.939072,
                34.624012
              ],
              [
                60.93949,
                34.623577
              ],
              [
                60.940163,
                34.623183
              ],
              [
                60.940386,
                34.622839
              ],
              [
                60.940398,
                34.622315
              ],
              [
                60.940298,
                34.621995
              ],
              [
                60.940346,
                34.621878
              ],
              [
                60.940757,
                34.621773
              ],
              [
                60.941412,
                34.621826
              ],
              [
                60.941822,
                34.621916
              ],
              [
                60.942267,
                34.621834
              ],
              [
                60.942633,
                34.621849
              ],
              [
                60.942793,
                34.62187
              ],
              [
                60.942914,
                34.62196
              ],
              [
                60.943369,
                34.621985
              ],
              [
                60.943873,
                34.621837
              ],
              [
                60.944075,
                34.621484
              ],
              [
                60.944429,
                34.62124
              ],
              [
                60.945096,
                34.6212
              ],
              [
                60.945882,
                34.620945
              ],
              [
                60.946214,
                34.621024
              ],
              [
                60.946565,
                34.621028
              ],
              [
                60.9469,
                34.621197
              ],
              [
                60.946951,
                34.621022
              ],
              [
                60.947158,
                34.620737
              ],
              [
                60.94727,
                34.620618
              ],
              [
                60.94748,
                34.620555
              ],
              [
                60.94883,
                34.620614
              ],
              [
                60.948997,
                34.620667
              ],
              [
                60.949146,
                34.620833
              ],
              [
                60.949385,
                34.620972
              ],
              [
                60.949605,
                34.620903
              ],
              [
                60.949819,
                34.620678
              ],
              [
                60.950001,
                34.620596
              ],
              [
                60.950325,
                34.620562
              ],
              [
                60.950508,
                34.62046
              ],
              [
                60.950953,
                34.620386
              ],
              [
                60.951072,
                34.620289
              ],
              [
                60.951362,
                34.620165
              ],
              [
                60.951981,
                34.619996
              ],
              [
                60.952342,
                34.620035
              ],
              [
                60.952679,
                34.620139
              ],
              [
                60.953089,
                34.620332
              ],
              [
                60.953292,
                34.620384
              ],
              [
                60.953364,
                34.620358
              ],
              [
                60.953354,
                34.620161
              ],
              [
                60.953154,
                34.619941
              ],
              [
                60.95288,
                34.619446
              ],
              [
                60.952891,
                34.619073
              ],
              [
                60.952943,
                34.619012
              ],
              [
                60.954024,
                34.618622
              ],
              [
                60.954812,
                34.618612
              ],
              [
                60.955276,
                34.618522
              ],
              [
                60.955564,
                34.618309
              ],
              [
                60.955808,
                34.618019
              ],
              [
                60.956509,
                34.617403
              ],
              [
                60.956933,
                34.616827
              ],
              [
                60.957133,
                34.616715
              ],
              [
                60.957415,
                34.61667
              ],
              [
                60.957575,
                34.616675
              ],
              [
                60.958055,
                34.616942
              ],
              [
                60.958322,
                34.617251
              ],
              [
                60.958705,
                34.617572
              ],
              [
                60.959121,
                34.617739
              ],
              [
                60.95957,
                34.617833
              ],
              [
                60.9597,
                34.617921
              ],
              [
                60.960223,
                34.61845
              ],
              [
                60.960387,
                34.61926
              ],
              [
                60.960543,
                34.619409
              ],
              [
                60.960805,
                34.619422
              ],
              [
                60.961321,
                34.619161
              ],
              [
                60.96148,
                34.619132
              ],
              [
                60.961952,
                34.619168
              ],
              [
                60.962251,
                34.619296
              ],
              [
                60.962458,
                34.619316
              ],
              [
                60.962544,
                34.619307
              ],
              [
                60.962825,
                34.6191
              ],
              [
                60.963561,
                34.619094
              ],
              [
                60.963936,
                34.619185
              ],
              [
                60.964095,
                34.619293
              ],
              [
                60.964375,
                34.619894
              ],
              [
                60.965126,
                34.619756
              ],
              [
                60.966728,
                34.619935
              ],
              [
                60.967264,
                34.619857
              ],
              [
                60.968087,
                34.619934
              ],
              [
                60.968591,
                34.620076
              ],
              [
                60.969367,
                34.620446
              ],
              [
                60.969912,
                34.620869
              ],
              [
                60.970249,
                34.621026
              ],
              [
                60.971409,
                34.62063
              ],
              [
                60.971811,
                34.620115
              ],
              [
                60.972235,
                34.620006
              ],
              [
                60.972886,
                34.619926
              ],
              [
                60.973992,
                34.620225
              ],
              [
                60.97487,
                34.62079
              ],
              [
                60.975053,
                34.62108
              ],
              [
                60.975293,
                34.621261
              ],
              [
                60.975501,
                34.621327
              ],
              [
                60.976534,
                34.621476
              ],
              [
                60.976804,
                34.621576
              ],
              [
                60.977235,
                34.621617
              ],
              [
                60.977416,
                34.621549
              ],
              [
                60.978275,
                34.620797
              ],
              [
                60.978453,
                34.620718
              ],
              [
                60.978626,
                34.620715
              ],
              [
                60.978845,
                34.620807
              ],
              [
                60.979089,
                34.620947
              ],
              [
                60.979262,
                34.62113
              ],
              [
                60.979441,
                34.621181
              ],
              [
                60.98008,
                34.62114
              ],
              [
                60.980409,
                34.621176
              ],
              [
                60.981149,
                34.620871
              ],
              [
                60.981239,
                34.62073
              ],
              [
                60.981229,
                34.620477
              ],
              [
                60.981543,
                34.619407
              ],
              [
                60.982116,
                34.6193
              ],
              [
                60.982285,
                34.61933
              ],
              [
                60.982592,
                34.619759
              ],
              [
                60.982858,
                34.620036
              ],
              [
                60.98306,
                34.620144
              ],
              [
                60.983204,
                34.620135
              ],
              [
                60.983717,
                34.61994
              ],
              [
                60.984492,
                34.619758
              ],
              [
                60.984687,
                34.619816
              ],
              [
                60.984934,
                34.62
              ],
              [
                60.984991,
                34.620268
              ],
              [
                60.98514,
                34.620386
              ],
              [
                60.985177,
                34.620492
              ],
              [
                60.985246,
                34.620975
              ],
              [
                60.985913,
                34.621712
              ],
              [
                61.000798,
                34.642976
              ],
              [
                61.000713,
                34.643149
              ],
              [
                61.000292,
                34.643673
              ],
              [
                61.000316,
                34.64378
              ],
              [
                61.000387,
                34.643843
              ],
              [
                61.000653,
                34.643922
              ],
              [
                61.000802,
                34.644127
              ],
              [
                61.000921,
                34.64558
              ],
              [
                61.001124,
                34.646033
              ],
              [
                61.001539,
                34.646377
              ],
              [
                61.00145,
                34.646606
              ],
              [
                61.001534,
                34.646926
              ],
              [
                61.001444,
                34.647031
              ],
              [
                61.001419,
                34.647395
              ],
              [
                61.001919,
                34.648622
              ],
              [
                61.00184,
                34.648728
              ],
              [
                61.001708,
                34.648731
              ],
              [
                61.001676,
                34.648767
              ],
              [
                61.00133,
                34.649554
              ],
              [
                61.000742,
                34.650024
              ],
              [
                61.000491,
                34.650325
              ],
              [
                61.000326,
                34.650445
              ],
              [
                60.999829,
                34.650619
              ],
              [
                60.999644,
                34.6508
              ],
              [
                60.999608,
                34.651185
              ],
              [
                60.999742,
                34.652063
              ],
              [
                60.9997,
                34.652424
              ],
              [
                60.999483,
                34.65325
              ],
              [
                60.999146,
                34.65373
              ],
              [
                60.999251,
                34.654057
              ],
              [
                60.999277,
                34.654428
              ],
              [
                60.99925,
                34.655814
              ],
              [
                61.000064,
                34.684581
              ],
              [
                61.0007206,
                34.6955096
              ],
              [
                61.0023943,
                34.7062354
              ],
              [
                61.0027725,
                34.7086939
              ],
              [
                61.0028093,
                34.7090451
              ],
              [
                61.002802,
                34.7092165
              ],
              [
                61.0034564,
                34.709975
              ],
              [
                61.003844,
                34.711239
              ],
              [
                61.003819,
                34.711317
              ],
              [
                61.004046,
                34.711486
              ],
              [
                61.00435,
                34.711859
              ],
              [
                61.004814,
                34.712127
              ],
              [
                61.005063,
                34.712411
              ],
              [
                61.005866,
                34.712623
              ],
              [
                61.006146,
                34.712796
              ],
              [
                61.006263,
                34.713143
              ],
              [
                61.006246,
                34.713282
              ],
              [
                61.006449,
                34.713481
              ],
              [
                61.006588,
                34.713557
              ],
              [
                61.00678,
                34.713584
              ],
              [
                61.007471,
                34.714004
              ],
              [
                61.007551,
                34.714223
              ],
              [
                61.007521,
                34.715361
              ],
              [
                61.007598,
                34.715508
              ],
              [
                61.008088,
                34.71575
              ],
              [
                61.008301,
                34.716067
              ],
              [
                61.008454,
                34.716195
              ],
              [
                61.008869,
                34.71641
              ],
              [
                61.0093,
                34.717081
              ],
              [
                61.009983,
                34.717495
              ],
              [
                61.010126,
                34.717649
              ],
              [
                61.010276,
                34.718033
              ],
              [
                61.010604,
                34.718298
              ],
              [
                61.010771,
                34.718941
              ],
              [
                61.01075,
                34.719596
              ],
              [
                61.010968,
                34.72001
              ],
              [
                61.010977,
                34.720125
              ],
              [
                61.010885,
                34.720345
              ],
              [
                61.01103,
                34.720961
              ],
              [
                61.01137,
                34.721306
              ],
              [
                61.011651,
                34.721733
              ],
              [
                61.011962,
                34.722057
              ],
              [
                61.012034,
                34.722263
              ],
              [
                61.012331,
                34.722735
              ],
              [
                61.012466,
                34.722857
              ],
              [
                61.01303,
                34.723013
              ],
              [
                61.013323,
                34.723202
              ],
              [
                61.013299,
                34.723674
              ],
              [
                61.012963,
                34.724349
              ],
              [
                61.012945,
                34.725395
              ],
              [
                61.013082,
                34.726783
              ],
              [
                61.013318,
                34.727629
              ],
              [
                61.013514,
                34.728068
              ],
              [
                61.013534,
                34.728291
              ],
              [
                61.01421,
                34.729024
              ],
              [
                61.014356,
                34.72933
              ],
              [
                61.014298,
                34.729606
              ],
              [
                61.014338,
                34.730123
              ],
              [
                61.014421,
                34.730576
              ],
              [
                61.014513,
                34.730718
              ],
              [
                61.01453,
                34.731051
              ],
              [
                61.014416,
                34.73125
              ],
              [
                61.014272,
                34.731752
              ],
              [
                61.014593,
                34.732442
              ],
              [
                61.014867,
                34.732687
              ],
              [
                61.015217,
                34.732879
              ],
              [
                61.016372,
                34.733215
              ],
              [
                61.016828,
                34.733608
              ],
              [
                61.017145,
                34.733767
              ],
              [
                61.017399,
                34.733868
              ],
              [
                61.018262,
                34.734064
              ],
              [
                61.01855,
                34.734266
              ],
              [
                61.01883,
                34.734675
              ],
              [
                61.018971,
                34.735403
              ],
              [
                61.019051,
                34.735526
              ],
              [
                61.019529,
                34.735892
              ],
              [
                61.019695,
                34.736232
              ],
              [
                61.019595,
                34.73689
              ],
              [
                61.01959,
                34.737235
              ],
              [
                61.019665,
                34.737733
              ],
              [
                61.019933,
                34.738123
              ],
              [
                61.020191,
                34.73835
              ],
              [
                61.020612,
                34.738588
              ],
              [
                61.02106,
                34.738697
              ],
              [
                61.022327,
                34.738593
              ],
              [
                61.022884,
                34.738672
              ],
              [
                61.023219,
                34.738777
              ],
              [
                61.023803,
                34.739134
              ],
              [
                61.023988,
                34.739408
              ],
              [
                61.024592,
                34.740031
              ],
              [
                61.024859,
                34.740685
              ],
              [
                61.025098,
                34.740871
              ],
              [
                61.025696,
                34.741173
              ],
              [
                61.02596,
                34.741456
              ],
              [
                61.026006,
                34.74173
              ],
              [
                61.025553,
                34.742311
              ],
              [
                61.025526,
                34.742472
              ],
              [
                61.025676,
                34.743044
              ],
              [
                61.025948,
                34.743564
              ],
              [
                61.026136,
                34.744174
              ],
              [
                61.02627,
                34.744372
              ],
              [
                61.02661,
                34.744621
              ],
              [
                61.026969,
                34.744786
              ],
              [
                61.027573,
                34.74491
              ],
              [
                61.028258,
                34.744878
              ],
              [
                61.028546,
                34.744939
              ],
              [
                61.028936,
                34.745119
              ],
              [
                61.029153,
                34.745328
              ],
              [
                61.029192,
                34.745464
              ],
              [
                61.029156,
                34.745623
              ],
              [
                61.029036,
                34.745813
              ],
              [
                61.028968,
                34.746284
              ],
              [
                61.029271,
                34.746669
              ],
              [
                61.029525,
                34.746864
              ],
              [
                61.030244,
                34.747283
              ],
              [
                61.030838,
                34.74754
              ],
              [
                61.031538,
                34.74777
              ],
              [
                61.032785,
                34.748047
              ],
              [
                61.033749,
                34.748577
              ],
              [
                61.034179,
                34.748928
              ],
              [
                61.034237,
                34.749124
              ],
              [
                61.034182,
                34.749268
              ],
              [
                61.034113,
                34.749346
              ],
              [
                61.033885,
                34.74944
              ],
              [
                61.033596,
                34.749768
              ],
              [
                61.033615,
                34.749998
              ],
              [
                61.033819,
                34.750452
              ],
              [
                61.03378,
                34.750519
              ],
              [
                61.0338,
                34.750694
              ],
              [
                61.034008,
                34.751164
              ],
              [
                61.034396,
                34.751447
              ],
              [
                61.035009,
                34.751696
              ],
              [
                61.035204,
                34.751818
              ],
              [
                61.03531,
                34.75197
              ],
              [
                61.035408,
                34.752383
              ],
              [
                61.035393,
                34.752653
              ],
              [
                61.035368,
                34.752889
              ],
              [
                61.035039,
                34.753467
              ],
              [
                61.035032,
                34.753612
              ],
              [
                61.035119,
                34.753781
              ],
              [
                61.035805,
                34.753878
              ],
              [
                61.036404,
                34.754298
              ],
              [
                61.036938,
                34.754475
              ],
              [
                61.03713,
                34.754614
              ],
              [
                61.037259,
                34.754715
              ],
              [
                61.037308,
                34.754825
              ],
              [
                61.037394,
                34.755338
              ],
              [
                61.037504,
                34.755534
              ],
              [
                61.037916,
                34.755877
              ],
              [
                61.038136,
                34.756316
              ],
              [
                61.038311,
                34.75653
              ],
              [
                61.03899,
                34.757091
              ],
              [
                61.039542,
                34.757356
              ],
              [
                61.039755,
                34.75769
              ],
              [
                61.04006,
                34.757927
              ],
              [
                61.041361,
                34.758441
              ],
              [
                61.041437,
                34.758505
              ],
              [
                61.041542,
                34.758745
              ],
              [
                61.041589,
                34.759024
              ],
              [
                61.041566,
                34.759372
              ],
              [
                61.041506,
                34.759515
              ],
              [
                61.04115,
                34.759658
              ],
              [
                61.041054,
                34.759784
              ],
              [
                61.041276,
                34.760528
              ],
              [
                61.041284,
                34.760734
              ],
              [
                61.041014,
                34.76131
              ],
              [
                61.040724,
                34.761633
              ],
              [
                61.040717,
                34.761747
              ],
              [
                61.040805,
                34.761904
              ],
              [
                61.041116,
                34.76218
              ],
              [
                61.041738,
                34.763157
              ],
              [
                61.04181,
                34.763613
              ],
              [
                61.04168,
                34.763936
              ],
              [
                61.041696,
                34.76405
              ],
              [
                61.042027,
                34.764294
              ],
              [
                61.042196,
                34.764314
              ],
              [
                61.043165,
                34.764799
              ],
              [
                61.04377,
                34.766295
              ],
              [
                61.044145,
                34.766745
              ],
              [
                61.04429,
                34.767153
              ],
              [
                61.044233,
                34.767264
              ],
              [
                61.044424,
                34.767728
              ],
              [
                61.044435,
                34.768055
              ],
              [
                61.044619,
                34.768337
              ],
              [
                61.044651,
                34.768574
              ],
              [
                61.044633,
                34.769129
              ],
              [
                61.044439,
                34.769343
              ],
              [
                61.044339,
                34.769596
              ],
              [
                61.044349,
                34.76976
              ],
              [
                61.044471,
                34.76994
              ],
              [
                61.044588,
                34.769991
              ],
              [
                61.045495,
                34.770093
              ],
              [
                61.04612,
                34.770268
              ],
              [
                61.046548,
                34.770596
              ],
              [
                61.046679,
                34.770778
              ],
              [
                61.04668,
                34.770875
              ],
              [
                61.046417,
                34.771229
              ],
              [
                61.046184,
                34.771916
              ],
              [
                61.046128,
                34.772265
              ],
              [
                61.046201,
                34.773257
              ],
              [
                61.046457,
                34.773949
              ],
              [
                61.047015,
                34.774629
              ],
              [
                61.047415,
                34.775649
              ],
              [
                61.047879,
                34.776165
              ],
              [
                61.048043,
                34.776212
              ],
              [
                61.048217,
                34.776376
              ],
              [
                61.048455,
                34.776459
              ],
              [
                61.048777,
                34.776765
              ],
              [
                61.048787,
                34.777104
              ],
              [
                61.048669,
                34.777238
              ],
              [
                61.04864,
                34.777533
              ],
              [
                61.048728,
                34.777816
              ],
              [
                61.049062,
                34.778057
              ],
              [
                61.049536,
                34.778566
              ],
              [
                61.049611,
                34.778717
              ],
              [
                61.049592,
                34.779035
              ],
              [
                61.049655,
                34.779283
              ],
              [
                61.049899,
                34.77966
              ],
              [
                61.050061,
                34.77976
              ],
              [
                61.050086,
                34.779891
              ],
              [
                61.050253,
                34.780059
              ],
              [
                61.050549,
                34.780153
              ],
              [
                61.05081,
                34.780107
              ],
              [
                61.051145,
                34.780228
              ],
              [
                61.051557,
                34.78024
              ],
              [
                61.05198,
                34.780473
              ],
              [
                61.052247,
                34.780529
              ],
              [
                61.052392,
                34.78061
              ],
              [
                61.052484,
                34.780879
              ],
              [
                61.052701,
                34.780865
              ],
              [
                61.053049,
                34.781006
              ],
              [
                61.053111,
                34.781218
              ],
              [
                61.053357,
                34.781381
              ],
              [
                61.053457,
                34.781504
              ],
              [
                61.053606,
                34.781983
              ],
              [
                61.053854,
                34.782246
              ],
              [
                61.054885,
                34.782398
              ],
              [
                61.054975,
                34.782428
              ],
              [
                61.055241,
                34.782684
              ],
              [
                61.055385,
                34.783595
              ],
              [
                61.054768,
                34.783832
              ],
              [
                61.054835,
                34.784179
              ],
              [
                61.054689,
                34.785226
              ],
              [
                61.054803,
                34.785412
              ],
              [
                61.055029,
                34.785397
              ],
              [
                61.055158,
                34.785469
              ],
              [
                61.055252,
                34.785651
              ],
              [
                61.055717,
                34.786084
              ],
              [
                61.055816,
                34.786331
              ],
              [
                61.055888,
                34.786598
              ],
              [
                61.055831,
                34.78672
              ],
              [
                61.055846,
                34.787268
              ],
              [
                61.055931,
                34.78785
              ],
              [
                61.055865,
                34.787987
              ],
              [
                61.055861,
                34.78819
              ],
              [
                61.055923,
                34.788341
              ],
              [
                61.05669,
                34.788662
              ],
              [
                61.057085,
                34.789001
              ],
              [
                61.057156,
                34.789312
              ],
              [
                61.057688,
                34.789529
              ],
              [
                61.057976,
                34.789561
              ],
              [
                61.05809,
                34.789661
              ],
              [
                61.058202,
                34.790276
              ],
              [
                61.058074,
                34.790935
              ],
              [
                61.058112,
                34.791021
              ],
              [
                61.058517,
                34.791229
              ],
              [
                61.058617,
                34.791322
              ],
              [
                61.059308,
                34.792586
              ],
              [
                61.059339,
                34.7929
              ],
              [
                61.059145,
                34.79308
              ],
              [
                61.05919,
                34.7942
              ],
              [
                61.059581,
                34.794697
              ],
              [
                61.059717,
                34.794792
              ],
              [
                61.060057,
                34.794915
              ],
              [
                61.060149,
                34.795054
              ],
              [
                61.060095,
                34.795222
              ],
              [
                61.059939,
                34.795424
              ],
              [
                61.059911,
                34.795615
              ],
              [
                61.060437,
                34.795965
              ],
              [
                61.060585,
                34.796151
              ],
              [
                61.060701,
                34.796577
              ],
              [
                61.060671,
                34.796695
              ],
              [
                61.060404,
                34.796982
              ],
              [
                61.060482,
                34.797146
              ],
              [
                61.060779,
                34.797404
              ],
              [
                61.060787,
                34.797543
              ],
              [
                61.060706,
                34.797666
              ],
              [
                61.060401,
                34.797884
              ],
              [
                61.060554,
                34.798358
              ],
              [
                61.061117,
                34.798571
              ],
              [
                61.061295,
                34.798733
              ],
              [
                61.061393,
                34.7989
              ],
              [
                61.061391,
                34.799191
              ],
              [
                61.061995,
                34.7998
              ],
              [
                61.062158,
                34.800064
              ],
              [
                61.062251,
                34.800866
              ],
              [
                61.0618,
                34.801108
              ],
              [
                61.061746,
                34.801226
              ],
              [
                61.061917,
                34.801381
              ],
              [
                61.061856,
                34.801505
              ],
              [
                61.06149,
                34.80181
              ],
              [
                61.061247,
                34.802238
              ],
              [
                61.061202,
                34.802755
              ],
              [
                61.061323,
                34.803182
              ],
              [
                61.062014,
                34.804227
              ],
              [
                61.062566,
                34.804664
              ],
              [
                61.062538,
                34.804887
              ],
              [
                61.062579,
                34.804955
              ],
              [
                61.062933,
                34.805211
              ],
              [
                61.063205,
                34.80529
              ],
              [
                61.06347,
                34.805792
              ],
              [
                61.063723,
                34.806003
              ],
              [
                61.064488,
                34.806223
              ],
              [
                61.064979,
                34.806075
              ],
              [
                61.065212,
                34.806169
              ],
              [
                61.065604,
                34.806926
              ],
              [
                61.065832,
                34.807189
              ],
              [
                61.06609,
                34.807687
              ],
              [
                61.066034,
                34.808499
              ],
              [
                61.066128,
                34.808933
              ],
              [
                61.066297,
                34.809182
              ],
              [
                61.066367,
                34.809455
              ],
              [
                61.06628,
                34.809815
              ],
              [
                61.06634,
                34.810271
              ],
              [
                61.066805,
                34.810842
              ],
              [
                61.066955,
                34.811335
              ],
              [
                61.067674,
                34.811676
              ],
              [
                61.068078,
                34.81229
              ],
              [
                61.068151,
                34.812705
              ],
              [
                61.068056,
                34.813192
              ],
              [
                61.068268,
                34.814087
              ],
              [
                61.068116,
                34.814507
              ],
              [
                61.067565,
                34.814981
              ],
              [
                61.067505,
                34.815225
              ],
              [
                61.067607,
                34.815734
              ],
              [
                61.067535,
                34.815993
              ],
              [
                61.067586,
                34.816161
              ],
              [
                61.067759,
                34.816284
              ],
              [
                61.068308,
                34.816434
              ],
              [
                61.068367,
                34.816621
              ],
              [
                61.068199,
                34.817151
              ],
              [
                61.068055,
                34.817383
              ],
              [
                61.067568,
                34.818095
              ],
              [
                61.067131,
                34.818493
              ],
              [
                61.067168,
                34.818779
              ],
              [
                61.067021,
                34.819284
              ],
              [
                61.066967,
                34.819708
              ],
              [
                61.067084,
                34.820088
              ],
              [
                61.067158,
                34.820632
              ],
              [
                61.066945,
                34.821132
              ],
              [
                61.067172,
                34.821958
              ],
              [
                61.067555,
                34.82257
              ],
              [
                61.067932,
                34.823542
              ],
              [
                61.067941,
                34.824022
              ],
              [
                61.06785,
                34.824589
              ],
              [
                61.06787,
                34.825255
              ],
              [
                61.068012,
                34.825559
              ],
              [
                61.068318,
                34.825868
              ],
              [
                61.068766,
                34.827769
              ],
              [
                61.068636,
                34.828276
              ],
              [
                61.068393,
                34.828532
              ],
              [
                61.067112,
                34.829243
              ],
              [
                61.066892,
                34.829474
              ],
              [
                61.066794,
                34.829677
              ],
              [
                61.067169,
                34.83099
              ],
              [
                61.067481,
                34.831373
              ],
              [
                61.067791,
                34.832683
              ],
              [
                61.067651,
                34.833071
              ],
              [
                61.067395,
                34.833354
              ],
              [
                61.065878,
                34.833984
              ],
              [
                61.064997,
                34.834454
              ],
              [
                61.064644,
                34.834909
              ],
              [
                61.064356,
                34.835451
              ],
              [
                61.064226,
                34.836321
              ],
              [
                61.063971,
                34.836865
              ],
              [
                61.063633,
                34.837081
              ],
              [
                61.06258,
                34.837494
              ],
              [
                61.062474,
                34.837682
              ],
              [
                61.062515,
                34.837904
              ],
              [
                61.063134,
                34.839029
              ],
              [
                61.063761,
                34.839741
              ],
              [
                61.065014,
                34.84078
              ],
              [
                61.065314,
                34.841226
              ],
              [
                61.0657,
                34.841533
              ],
              [
                61.066463,
                34.841778
              ],
              [
                61.06749,
                34.841929
              ],
              [
                61.068177,
                34.841905
              ],
              [
                61.069823,
                34.841532
              ],
              [
                61.070346,
                34.841515
              ],
              [
                61.071,
                34.84165
              ],
              [
                61.073156,
                34.842323
              ],
              [
                61.074026,
                34.842763
              ],
              [
                61.074625,
                34.843494
              ],
              [
                61.075061,
                34.844264
              ],
              [
                61.075205,
                34.844972
              ],
              [
                61.075097,
                34.845454
              ],
              [
                61.074815,
                34.845972
              ],
              [
                61.074058,
                34.846671
              ],
              [
                61.073122,
                34.847386
              ],
              [
                61.072336,
                34.848212
              ],
              [
                61.071507,
                34.848995
              ],
              [
                61.070576,
                34.849509
              ],
              [
                61.069707,
                34.850184
              ],
              [
                61.06895,
                34.850819
              ],
              [
                61.068582,
                34.851283
              ],
              [
                61.068522,
                34.851713
              ],
              [
                61.068579,
                34.852179
              ],
              [
                61.068573,
                34.852855
              ],
              [
                61.068719,
                34.854221
              ],
              [
                61.069047,
                34.855602
              ],
              [
                61.069363,
                34.856509
              ],
              [
                61.069481,
                34.85724
              ],
              [
                61.069431,
                34.857904
              ],
              [
                61.069538,
                34.85869
              ],
              [
                61.069666,
                34.859033
              ],
              [
                61.069719,
                34.859636
              ],
              [
                61.06965,
                34.860081
              ],
              [
                61.069081,
                34.860886
              ],
              [
                61.068882,
                34.861281
              ],
              [
                61.069083,
                34.862167
              ],
              [
                61.068522,
                34.8633
              ],
              [
                61.068423,
                34.863866
              ],
              [
                61.068561,
                34.864505
              ],
              [
                61.068876,
                34.865026
              ],
              [
                61.069926,
                34.865854
              ],
              [
                61.070641,
                34.866242
              ],
              [
                61.070883,
                34.866686
              ],
              [
                61.070779,
                34.867215
              ],
              [
                61.070569,
                34.867694
              ],
              [
                61.069815,
                34.868356
              ],
              [
                61.069949,
                34.869343
              ],
              [
                61.070114,
                34.869786
              ],
              [
                61.070489,
                34.870174
              ],
              [
                61.071095,
                34.87033
              ],
              [
                61.0731,
                34.870519
              ],
              [
                61.073858,
                34.870678
              ],
              [
                61.074825,
                34.870739
              ],
              [
                61.075633,
                34.870889
              ],
              [
                61.076308,
                34.871154
              ],
              [
                61.076852,
                34.871603
              ],
              [
                61.077454,
                34.872218
              ],
              [
                61.078009,
                34.873203
              ],
              [
                61.078892,
                34.875047
              ],
              [
                61.080628,
                34.875928
              ],
              [
                61.080891,
                34.876279
              ],
              [
                61.080661,
                34.876776
              ],
              [
                61.080534,
                34.877275
              ],
              [
                61.080132,
                34.878005
              ],
              [
                61.079815,
                34.878237
              ],
              [
                61.079166,
                34.878585
              ],
              [
                61.07871,
                34.878955
              ],
              [
                61.078384,
                34.879347
              ],
              [
                61.077791,
                34.880421
              ],
              [
                61.077291,
                34.880985
              ],
              [
                61.076679,
                34.881479
              ],
              [
                61.075842,
                34.881879
              ],
              [
                61.075155,
                34.881998
              ],
              [
                61.073965,
                34.881795
              ],
              [
                61.072925,
                34.881753
              ],
              [
                61.072245,
                34.881787
              ],
              [
                61.069945,
                34.882107
              ],
              [
                61.068946,
                34.88208
              ],
              [
                61.068318,
                34.882159
              ],
              [
                61.067635,
                34.8825
              ],
              [
                61.067509,
                34.88291
              ],
              [
                61.067432,
                34.883452
              ],
              [
                61.066912,
                34.88443
              ],
              [
                61.066461,
                34.884935
              ],
              [
                61.066326,
                34.885356
              ],
              [
                61.066255,
                34.885856
              ],
              [
                61.065471,
                34.887341
              ],
              [
                61.065348,
                34.888083
              ],
              [
                61.065382,
                34.888853
              ],
              [
                61.065737,
                34.88977
              ],
              [
                61.065978,
                34.890126
              ],
              [
                61.067264,
                34.8936
              ],
              [
                61.067346,
                34.89427
              ],
              [
                61.067265,
                34.894868
              ],
              [
                61.067017,
                34.895174
              ],
              [
                61.066305,
                34.895595
              ],
              [
                61.064268,
                34.897043
              ],
              [
                61.063434,
                34.897782
              ],
              [
                61.062821,
                34.898138
              ],
              [
                61.061859,
                34.898582
              ],
              [
                61.06102,
                34.898909
              ],
              [
                61.05996,
                34.899485
              ],
              [
                61.05896,
                34.899779
              ],
              [
                61.058108,
                34.900429
              ],
              [
                61.057264,
                34.901209
              ],
              [
                61.056726,
                34.901914
              ],
              [
                61.056299,
                34.9027327
              ],
              [
                61.0558807,
                34.9027327
              ],
              [
                61.0544947,
                34.903283
              ],
              [
                61.0536611,
                34.903283
              ],
              [
                61.0533815,
                34.9035627
              ],
              [
                61.0519948,
                34.9035627
              ],
              [
                61.0508814,
                34.9038333
              ],
              [
                61.050608,
                34.904113
              ],
              [
                61.0483814,
                34.904113
              ],
              [
                61.0475477,
                34.9043926
              ],
              [
                61.0439414,
                34.9043927
              ],
              [
                61.0433813,
                34.9046724
              ],
              [
                61.0414414,
                34.9046723
              ],
              [
                61.0333811,
                34.907451
              ],
              [
                61.0297747,
                34.9093906
              ],
              [
                61.0144947,
                34.9160574
              ],
              [
                60.9997687,
                34.9185563
              ],
              [
                60.9989351,
                34.9188359
              ],
              [
                60.9953288,
                34.918836
              ],
              [
                60.9825487,
                34.9213349
              ],
              [
                60.9808823,
                34.9213349
              ],
              [
                60.9708822,
                34.9238338
              ],
              [
                60.9706024,
                34.9241134
              ],
              [
                60.9697688,
                34.9241134
              ],
              [
                60.9655377,
                34.9405483
              ],
              [
                60.9502722,
                34.9524343
              ],
              [
                60.9469393,
                34.9543824
              ],
              [
                60.9353391,
                34.9668827
              ],
              [
                60.9336727,
                34.9677124
              ],
              [
                60.9154229,
                34.9728648
              ],
              [
                60.89035,
                34.9799401
              ],
              [
                60.880397,
                34.993803
              ],
              [
                60.8790103,
                34.9960312
              ],
              [
                60.877897,
                34.9973302
              ],
              [
                60.8748502,
                35.0335273
              ],
              [
                60.8728603,
                35.0398129
              ],
              [
                60.8725798,
                35.040363
              ],
              [
                60.869247,
                35.0448095
              ],
              [
                60.8252982,
                35.0465155
              ],
              [
                60.7765546,
                35.0763439
              ],
              [
                60.7697347,
                35.0817471
              ],
              [
                60.7463124,
                35.0710703
              ],
              [
                60.7205434,
                35.0615876
              ],
              [
                60.6825258,
                35.039948
              ],
              [
                60.6411194,
                35.0257716
              ],
              [
                60.6378718,
                35.0196248
              ],
              [
                60.6328252,
                35.0128599
              ],
              [
                60.6381367,
                35.0113695
              ],
              [
                60.643587,
                35.007503
              ],
              [
                60.6514404,
                34.9999803
              ],
              [
                60.6457464,
                34.9941224
              ],
              [
                60.6352551,
                34.9908097
              ],
              [
                60.6333006,
                34.9887318
              ],
              [
                60.6405937,
                34.9796666
              ],
              [
                60.6497422,
                34.9724854
              ],
              [
                60.6623839,
                34.9646076
              ],
              [
                60.6658495,
                34.9513276
              ],
              [
                60.667516,
                34.9432807
              ],
              [
                60.6675159,
                34.943001
              ],
              [
                60.67234,
                34.9329491
              ],
              [
                60.6699368,
                34.9219713
              ],
              [
                60.6623837,
                34.9095843
              ],
              [
                60.6441878,
                34.878186
              ],
              [
                60.6644438,
                34.8659333
              ],
              [
                60.6765908,
                34.8574736
              ],
              [
                60.6616971,
                34.850157
              ],
              [
                60.6469343,
                34.8377591
              ],
              [
                60.6445309,
                34.8305733
              ],
              [
                60.6031607,
                34.8286004
              ],
              [
                60.6050488,
                34.8924083
              ],
              [
                60.5683133,
                34.9062057
              ],
              [
                60.5367278,
                34.8898738
              ],
              [
                60.4550169,
                34.8622712
              ],
              [
                60.4601757,
                34.8601488
              ],
              [
                60.4225051,
                34.8587055
              ],
              [
                60.3869575,
                34.8556495
              ],
              [
                60.3391455,
                34.8269094
              ],
              [
                60.3048132,
                34.8377591
              ],
              [
                60.2963209,
                34.8007472
              ],
              [
                60.2641871,
                34.7871297
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554962,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تربت جام",
          "name:ar": "مقاطعة تربت جام",
          "name:en": "Torbat-e-jam County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1278088",
          "wikipedia": "fa:شهرستان تربت جام"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.0200301,
                35.4665719
              ],
              [
                60.0200236,
                35.4578642
              ],
              [
                60.021425,
                35.4513737
              ],
              [
                60.0231866,
                35.4437416
              ],
              [
                60.0189113,
                35.4402886
              ],
              [
                60.0172643,
                35.4380279
              ],
              [
                60.023117,
                35.4265116
              ],
              [
                60.0292355,
                35.4186265
              ],
              [
                60.0351762,
                35.4117529
              ],
              [
                60.0403768,
                35.4044615
              ],
              [
                60.0422379,
                35.4007884
              ],
              [
                60.0460912,
                35.392953
              ],
              [
                60.0482538,
                35.3888334
              ],
              [
                60.0500342,
                35.3864551
              ],
              [
                60.056306,
                35.3782431
              ],
              [
                60.0597819,
                35.3777881
              ],
              [
                60.0714408,
                35.3776832
              ],
              [
                60.0848284,
                35.3776389
              ],
              [
                60.089731,
                35.3740937
              ],
              [
                60.1026669,
                35.3672082
              ],
              [
                60.1074008,
                35.3652416
              ],
              [
                60.113368,
                35.3608812
              ],
              [
                60.1189041,
                35.3580462
              ],
              [
                60.1225948,
                35.3553162
              ],
              [
                60.1237045,
                35.3514471
              ],
              [
                60.1305771,
                35.34706
              ],
              [
                60.1297187,
                35.3433451
              ],
              [
                60.1278645,
                35.3365663
              ],
              [
                60.1256847,
                35.3304618
              ],
              [
                60.1230239,
                35.3263303
              ],
              [
                60.1216151,
                35.3209062
              ],
              [
                60.134523,
                35.319049
              ],
              [
                60.1443957,
                35.3177866
              ],
              [
                60.1599308,
                35.3142851
              ],
              [
                60.1708742,
                35.3099426
              ],
              [
                60.173192,
                35.3072808
              ],
              [
                60.1769048,
                35.3005053
              ],
              [
                60.1764965,
                35.2975441
              ],
              [
                60.1835431,
                35.2917396
              ],
              [
                60.1898198,
                35.2880368
              ],
              [
                60.1962069,
                35.2867756
              ],
              [
                60.2012566,
                35.2856579
              ],
              [
                60.2157,
                35.2835878
              ],
              [
                60.2201843,
                35.2810102
              ],
              [
                60.2242609,
                35.2730225
              ],
              [
                60.2342605,
                35.2688178
              ],
              [
                60.238878,
                35.2680306
              ],
              [
                60.2509975,
                35.2682922
              ],
              [
                60.2585935,
                35.2658745
              ],
              [
                60.2644291,
                35.264381
              ],
              [
                60.2766815,
                35.2510882
              ],
              [
                60.2948684,
                35.2371633
              ],
              [
                60.3150181,
                35.2174616
              ],
              [
                60.3421382,
                35.1884983
              ],
              [
                60.35408,
                35.1868569
              ],
              [
                60.3597449,
                35.1823674
              ],
              [
                60.3617568,
                35.1691391
              ],
              [
                60.3664396,
                35.1552844
              ],
              [
                60.3784736,
                35.1406751
              ],
              [
                60.3814102,
                35.1310639
              ],
              [
                60.388069,
                35.1156963
              ],
              [
                60.3943872,
                35.108214
              ],
              [
                60.3985087,
                35.0958225
              ],
              [
                60.4227731,
                35.0854435
              ],
              [
                60.4380899,
                35.078292
              ],
              [
                60.4503594,
                35.0739382
              ],
              [
                60.4704664,
                35.0637252
              ],
              [
                60.4869254,
                35.0559536
              ],
              [
                60.5037687,
                35.0458788
              ],
              [
                60.5111502,
                35.0388516
              ],
              [
                60.5226328,
                35.0355052
              ],
              [
                60.5289172,
                35.0363216
              ],
              [
                60.5608462,
                35.066184
              ],
              [
                60.5769824,
                35.0778449
              ],
              [
                60.5820387,
                35.0854833
              ],
              [
                60.5884838,
                35.0848862
              ],
              [
                60.5913218,
                35.082902
              ],
              [
                60.5977532,
                35.080444
              ],
              [
                60.5977532,
                35.0786178
              ],
              [
                60.5974099,
                35.0663247
              ],
              [
                60.5995556,
                35.0583156
              ],
              [
                60.6081387,
                35.0492518
              ],
              [
                60.624361,
                35.0479868
              ],
              [
                60.6267642,
                35.0435599
              ],
              [
                60.6299397,
                35.0411708
              ],
              [
                60.6363772,
                35.0314724
              ],
              [
                60.6411194,
                35.0257716
              ],
              [
                60.6825258,
                35.039948
              ],
              [
                60.7205434,
                35.0615876
              ],
              [
                60.7463124,
                35.0710703
              ],
              [
                60.7697347,
                35.0817471
              ],
              [
                60.7765546,
                35.0763439
              ],
              [
                60.8252982,
                35.0465155
              ],
              [
                60.869247,
                35.0448095
              ],
              [
                60.8725798,
                35.040363
              ],
              [
                60.8728603,
                35.0398129
              ],
              [
                60.8748502,
                35.0335273
              ],
              [
                60.877897,
                34.9973302
              ],
              [
                60.8790103,
                34.9960312
              ],
              [
                60.880397,
                34.993803
              ],
              [
                60.89035,
                34.9799401
              ],
              [
                60.9154229,
                34.9728648
              ],
              [
                60.9336727,
                34.9677124
              ],
              [
                60.9353391,
                34.9668827
              ],
              [
                60.9469393,
                34.9543824
              ],
              [
                60.9502722,
                34.9524343
              ],
              [
                60.9655377,
                34.9405483
              ],
              [
                60.9697688,
                34.9241134
              ],
              [
                60.9706024,
                34.9241134
              ],
              [
                60.9708822,
                34.9238338
              ],
              [
                60.9808823,
                34.9213349
              ],
              [
                60.9825487,
                34.9213349
              ],
              [
                60.9953288,
                34.918836
              ],
              [
                60.9989351,
                34.9188359
              ],
              [
                60.9997687,
                34.9185563
              ],
              [
                61.0144947,
                34.9160574
              ],
              [
                61.0297747,
                34.9093906
              ],
              [
                61.0333811,
                34.907451
              ],
              [
                61.0414414,
                34.9046723
              ],
              [
                61.0433813,
                34.9046724
              ],
              [
                61.0439414,
                34.9043927
              ],
              [
                61.0475477,
                34.9043926
              ],
              [
                61.0483814,
                34.904113
              ],
              [
                61.050608,
                34.904113
              ],
              [
                61.0508814,
                34.9038333
              ],
              [
                61.0519948,
                34.9035627
              ],
              [
                61.0533815,
                34.9035627
              ],
              [
                61.0536611,
                34.903283
              ],
              [
                61.0544947,
                34.903283
              ],
              [
                61.0558807,
                34.9027327
              ],
              [
                61.056299,
                34.9027327
              ],
              [
                61.055835,
                34.904285
              ],
              [
                61.055943,
                34.904862
              ],
              [
                61.056459,
                34.90588
              ],
              [
                61.056967,
                34.906687
              ],
              [
                61.057683,
                34.907504
              ],
              [
                61.059004,
                34.908482
              ],
              [
                61.060468,
                34.909426
              ],
              [
                61.061085,
                34.909771
              ],
              [
                61.062307,
                34.909902
              ],
              [
                61.063063,
                34.909898
              ],
              [
                61.064037,
                34.909618
              ],
              [
                61.06486,
                34.909321
              ],
              [
                61.065664,
                34.90889
              ],
              [
                61.066851,
                34.908021
              ],
              [
                61.067395,
                34.907565
              ],
              [
                61.068328,
                34.90704
              ],
              [
                61.068821,
                34.906891
              ],
              [
                61.069619,
                34.907038
              ],
              [
                61.070365,
                34.907437
              ],
              [
                61.071108,
                34.907595
              ],
              [
                61.072229,
                34.907732
              ],
              [
                61.073211,
                34.908002
              ],
              [
                61.073857,
                34.908623
              ],
              [
                61.074152,
                34.909435
              ],
              [
                61.073938,
                34.909892
              ],
              [
                61.073422,
                34.910586
              ],
              [
                61.073163,
                34.91106
              ],
              [
                61.072521,
                34.911988
              ],
              [
                61.071751,
                34.912945
              ],
              [
                61.070548,
                34.913624
              ],
              [
                61.069371,
                34.913999
              ],
              [
                61.066566,
                34.914179
              ],
              [
                61.065434,
                34.91411
              ],
              [
                61.064665,
                34.914323
              ],
              [
                61.06398,
                34.914673
              ],
              [
                61.062989,
                34.915313
              ],
              [
                61.062477,
                34.915891
              ],
              [
                61.062268,
                34.916383
              ],
              [
                61.062174,
                34.916794
              ],
              [
                61.062264,
                34.917265
              ],
              [
                61.062533,
                34.917793
              ],
              [
                61.062937,
                34.918336
              ],
              [
                61.063579,
                34.918876
              ],
              [
                61.064456,
                34.919317
              ],
              [
                61.065765,
                34.919859
              ],
              [
                61.066486,
                34.920027
              ],
              [
                61.067387,
                34.920108
              ],
              [
                61.06846,
                34.920121
              ],
              [
                61.069157,
                34.920212
              ],
              [
                61.070088,
                34.920544
              ],
              [
                61.071057,
                34.921251
              ],
              [
                61.071645,
                34.922115
              ],
              [
                61.071934,
                34.922723
              ],
              [
                61.072084,
                34.923728
              ],
              [
                61.072026,
                34.925064
              ],
              [
                61.071827,
                34.926475
              ],
              [
                61.071991,
                34.927729
              ],
              [
                61.071868,
                34.929477
              ],
              [
                61.072033,
                34.930112
              ],
              [
                61.072492,
                34.930725
              ],
              [
                61.07312,
                34.931193
              ],
              [
                61.07394,
                34.931543
              ],
              [
                61.075141,
                34.931671
              ],
              [
                61.075811,
                34.931802
              ],
              [
                61.076483,
                34.932068
              ],
              [
                61.077034,
                34.932703
              ],
              [
                61.077587,
                34.93364
              ],
              [
                61.078286,
                34.934453
              ],
              [
                61.079105,
                34.935173
              ],
              [
                61.079553,
                34.935903
              ],
              [
                61.079774,
                34.936471
              ],
              [
                61.079892,
                34.937053
              ],
              [
                61.079863,
                34.937524
              ],
              [
                61.079941,
                34.937787
              ],
              [
                61.081844,
                34.939069
              ],
              [
                61.082684,
                34.939721
              ],
              [
                61.083066,
                34.940061
              ],
              [
                61.083638,
                34.940825
              ],
              [
                61.083992,
                34.941145
              ],
              [
                61.084818,
                34.941669
              ],
              [
                61.085111,
                34.941957
              ],
              [
                61.085295,
                34.942353
              ],
              [
                61.08549,
                34.943138
              ],
              [
                61.085398,
                34.943804
              ],
              [
                61.085458,
                34.944957
              ],
              [
                61.085309,
                34.945542
              ],
              [
                61.085001,
                34.945987
              ],
              [
                61.08474,
                34.946611
              ],
              [
                61.083719,
                34.948674
              ],
              [
                61.083496,
                34.949558
              ],
              [
                61.083462,
                34.950015
              ],
              [
                61.083507,
                34.950546
              ],
              [
                61.083628,
                34.951059
              ],
              [
                61.08406,
                34.951611
              ],
              [
                61.084939,
                34.952367
              ],
              [
                61.085432,
                34.952681
              ],
              [
                61.087278,
                34.95338
              ],
              [
                61.087863,
                34.953547
              ],
              [
                61.08863,
                34.953617
              ],
              [
                61.089203,
                34.953555
              ],
              [
                61.090567,
                34.953098
              ],
              [
                61.09108,
                34.952701
              ],
              [
                61.091472,
                34.952471
              ],
              [
                61.092313,
                34.951544
              ],
              [
                61.092941,
                34.9512
              ],
              [
                61.093339,
                34.951107
              ],
              [
                61.094993,
                34.951132
              ],
              [
                61.096086,
                34.950895
              ],
              [
                61.096432,
                34.950934
              ],
              [
                61.096816,
                34.95112
              ],
              [
                61.097467,
                34.951861
              ],
              [
                61.097682,
                34.952707
              ],
              [
                61.0982,
                34.953575
              ],
              [
                61.098405,
                34.954121
              ],
              [
                61.098517,
                34.954796
              ],
              [
                61.098408,
                34.95538
              ],
              [
                61.097578,
                34.956337
              ],
              [
                61.097394,
                34.956881
              ],
              [
                61.096969,
                34.957294
              ],
              [
                61.096696,
                34.95775
              ],
              [
                61.096521,
                34.959224
              ],
              [
                61.097063,
                34.960706
              ],
              [
                61.097179,
                34.961345
              ],
              [
                61.097189,
                34.96233
              ],
              [
                61.09691,
                34.963417
              ],
              [
                61.096856,
                34.963935
              ],
              [
                61.097113,
                34.964293
              ],
              [
                61.097365,
                34.964431
              ],
              [
                61.098258,
                34.964763
              ],
              [
                61.099458,
                34.965379
              ],
              [
                61.100443,
                34.965995
              ],
              [
                61.100829,
                34.966507
              ],
              [
                61.101017,
                34.967227
              ],
              [
                61.101068,
                34.967626
              ],
              [
                61.101228,
                34.968143
              ],
              [
                61.101594,
                34.968812
              ],
              [
                61.101819,
                34.96988
              ],
              [
                61.10171,
                34.970194
              ],
              [
                61.101522,
                34.970497
              ],
              [
                61.100746,
                34.971234
              ],
              [
                61.100487,
                34.971759
              ],
              [
                61.100269,
                34.972027
              ],
              [
                61.099845,
                34.972216
              ],
              [
                61.099272,
                34.972032
              ],
              [
                61.099092,
                34.972085
              ],
              [
                61.097787,
                34.972974
              ],
              [
                61.095761,
                34.974158
              ],
              [
                61.095639,
                34.974839
              ],
              [
                61.095691,
                34.975292
              ],
              [
                61.096651,
                34.976574
              ],
              [
                61.096752,
                34.97718
              ],
              [
                61.096692,
                34.97765
              ],
              [
                61.09594,
                34.978345
              ],
              [
                61.095612,
                34.979175
              ],
              [
                61.095682,
                34.979497
              ],
              [
                61.096069,
                34.979591
              ],
              [
                61.096788,
                34.979727
              ],
              [
                61.097184,
                34.979748
              ],
              [
                61.097971,
                34.979641
              ],
              [
                61.098277,
                34.979507
              ],
              [
                61.098641,
                34.979197
              ],
              [
                61.098841,
                34.978744
              ],
              [
                61.099426,
                34.978466
              ],
              [
                61.100095,
                34.97834
              ],
              [
                61.100596,
                34.978321
              ],
              [
                61.103186,
                34.978843
              ],
              [
                61.103744,
                34.978915
              ],
              [
                61.105675,
                34.979397
              ],
              [
                61.106245,
                34.979678
              ],
              [
                61.10703,
                34.980284
              ],
              [
                61.107438,
                34.980743
              ],
              [
                61.10788,
                34.982106
              ],
              [
                61.10763,
                34.98318
              ],
              [
                61.107252,
                34.983935
              ],
              [
                61.106774,
                34.98449
              ],
              [
                61.106292,
                34.984935
              ],
              [
                61.105591,
                34.985825
              ],
              [
                61.105004,
                34.986158
              ],
              [
                61.104459,
                34.98638
              ],
              [
                61.103687,
                34.986583
              ],
              [
                61.10313,
                34.98698
              ],
              [
                61.102756,
                34.987471
              ],
              [
                61.10264,
                34.987771
              ],
              [
                61.102616,
                34.988324
              ],
              [
                61.102736,
                34.988958
              ],
              [
                61.102749,
                34.989481
              ],
              [
                61.102611,
                34.990054
              ],
              [
                61.102188,
                34.990947
              ],
              [
                61.101999,
                34.99199
              ],
              [
                61.102301,
                34.993064
              ],
              [
                61.103031,
                34.994767
              ],
              [
                61.104199,
                34.996717
              ],
              [
                61.104357,
                34.997247
              ],
              [
                61.104544,
                34.997465
              ],
              [
                61.105014,
                34.99777
              ],
              [
                61.105631,
                34.998301
              ],
              [
                61.106453,
                34.99875
              ],
              [
                61.107415,
                34.999552
              ],
              [
                61.107741,
                35.00008
              ],
              [
                61.108024,
                35.000422
              ],
              [
                61.108897,
                35.000931
              ],
              [
                61.109751,
                35.001319
              ],
              [
                61.110793,
                35.001624
              ],
              [
                61.11172,
                35.001743
              ],
              [
                61.112581,
                35.001681
              ],
              [
                61.113761,
                35.001687
              ],
              [
                61.115223,
                35.001221
              ],
              [
                61.116405,
                35.000975
              ],
              [
                61.117775,
                35.001112
              ],
              [
                61.118333,
                35.001263
              ],
              [
                61.120314,
                35.00204
              ],
              [
                61.12101,
                35.002528
              ],
              [
                61.121411,
                35.003062
              ],
              [
                61.121625,
                35.003515
              ],
              [
                61.121788,
                35.004703
              ],
              [
                61.12175,
                35.00503
              ],
              [
                61.121491,
                35.00556
              ],
              [
                61.121087,
                35.005951
              ],
              [
                61.119844,
                35.006179
              ],
              [
                61.11565,
                35.006273
              ],
              [
                61.113961,
                35.007413
              ],
              [
                61.112881,
                35.008306
              ],
              [
                61.112691,
                35.010369
              ],
              [
                61.112567,
                35.011003
              ],
              [
                61.112524,
                35.012824
              ],
              [
                61.112141,
                35.014094
              ],
              [
                61.11153,
                35.015271
              ],
              [
                61.111125,
                35.015918
              ],
              [
                61.110078,
                35.017235
              ],
              [
                61.109328,
                35.0184
              ],
              [
                61.108478,
                35.019049
              ],
              [
                61.105294,
                35.020691
              ],
              [
                61.102814,
                35.021779
              ],
              [
                61.10052,
                35.023246
              ],
              [
                61.099881,
                35.023816
              ],
              [
                61.099702,
                35.024205
              ],
              [
                61.099759,
                35.024785
              ],
              [
                61.100206,
                35.025682
              ],
              [
                61.100693,
                35.026379
              ],
              [
                61.10098,
                35.027278
              ],
              [
                61.101031,
                35.027684
              ],
              [
                61.101416,
                35.028071
              ],
              [
                61.101807,
                35.02809
              ],
              [
                61.102058,
                35.027988
              ],
              [
                61.103221,
                35.028379
              ],
              [
                61.103713,
                35.028768
              ],
              [
                61.104268,
                35.02902
              ],
              [
                61.105038,
                35.029211
              ],
              [
                61.105972,
                35.029263
              ],
              [
                61.107539,
                35.029655
              ],
              [
                61.108665,
                35.030129
              ],
              [
                61.109483,
                35.031078
              ],
              [
                61.110361,
                35.032276
              ],
              [
                61.110732,
                35.033199
              ],
              [
                61.110743,
                35.034869
              ],
              [
                61.11044,
                35.036956
              ],
              [
                61.110878,
                35.037628
              ],
              [
                61.111338,
                35.037833
              ],
              [
                61.11219,
                35.037952
              ],
              [
                61.11302,
                35.037885
              ],
              [
                61.114271,
                35.037489
              ],
              [
                61.115275,
                35.037386
              ],
              [
                61.116185,
                35.03796
              ],
              [
                61.116746,
                35.038556
              ],
              [
                61.116705,
                35.042758
              ],
              [
                61.116809,
                35.04368
              ],
              [
                61.116287,
                35.044572
              ],
              [
                61.115135,
                35.045681
              ],
              [
                61.114496,
                35.046602
              ],
              [
                61.113656,
                35.04761
              ],
              [
                61.113039,
                35.048829
              ],
              [
                61.111713,
                35.050731
              ],
              [
                61.110934,
                35.052576
              ],
              [
                61.11037,
                35.054139
              ],
              [
                61.110326,
                35.055369
              ],
              [
                61.110572,
                35.057271
              ],
              [
                61.111194,
                35.059421
              ],
              [
                61.1117,
                35.060622
              ],
              [
                61.11231,
                35.061334
              ],
              [
                61.113033,
                35.06168
              ],
              [
                61.114581,
                35.06185
              ],
              [
                61.11619,
                35.061506
              ],
              [
                61.117647,
                35.060364
              ],
              [
                61.11826,
                35.059282
              ],
              [
                61.118978,
                35.058781
              ],
              [
                61.12089,
                35.058961
              ],
              [
                61.12559,
                35.058395
              ],
              [
                61.125863,
                35.058524
              ],
              [
                61.125996,
                35.058858
              ],
              [
                61.126387,
                35.060489
              ],
              [
                61.126598,
                35.062675
              ],
              [
                61.126221,
                35.065033
              ],
              [
                61.125425,
                35.066554
              ],
              [
                61.124127,
                35.067799
              ],
              [
                61.12309,
                35.068281
              ],
              [
                61.120462,
                35.069069
              ],
              [
                61.119808,
                35.069456
              ],
              [
                61.119108,
                35.069958
              ],
              [
                61.117761,
                35.070695
              ],
              [
                61.117325,
                35.071142
              ],
              [
                61.117081,
                35.071946
              ],
              [
                61.117072,
                35.072717
              ],
              [
                61.117244,
                35.073585
              ],
              [
                61.117421,
                35.073975
              ],
              [
                61.118131,
                35.07464
              ],
              [
                61.118772,
                35.07514
              ],
              [
                61.119393,
                35.075327
              ],
              [
                61.121833,
                35.075723
              ],
              [
                61.123332,
                35.075607
              ],
              [
                61.124499,
                35.075425
              ],
              [
                61.127063,
                35.075489
              ],
              [
                61.12873,
                35.075273
              ],
              [
                61.130176,
                35.075002
              ],
              [
                61.131712,
                35.074542
              ],
              [
                61.133063,
                35.074211
              ],
              [
                61.135061,
                35.073529
              ],
              [
                61.137309,
                35.073001
              ],
              [
                61.138139,
                35.072758
              ],
              [
                61.13948,
                35.072695
              ],
              [
                61.140979,
                35.073357
              ],
              [
                61.141944,
                35.074176
              ],
              [
                61.142664,
                35.075226
              ],
              [
                61.14285,
                35.075976
              ],
              [
                61.142871,
                35.076594
              ],
              [
                61.143378,
                35.077192
              ],
              [
                61.144047,
                35.07773
              ],
              [
                61.144474,
                35.07836
              ],
              [
                61.145245,
                35.079184
              ],
              [
                61.145623,
                35.079698
              ],
              [
                61.145771,
                35.080611
              ],
              [
                61.145566,
                35.082557
              ],
              [
                61.145356,
                35.083504
              ],
              [
                61.144381,
                35.085194
              ],
              [
                61.143586,
                35.086042
              ],
              [
                61.14242,
                35.086968
              ],
              [
                61.141201,
                35.087784
              ],
              [
                61.137328,
                35.089664
              ],
              [
                61.136248,
                35.090336
              ],
              [
                61.134825,
                35.091495
              ],
              [
                61.133743,
                35.091967
              ],
              [
                61.132712,
                35.092101
              ],
              [
                61.131844,
                35.091945
              ],
              [
                61.131237,
                35.092111
              ],
              [
                61.12995,
                35.092831
              ],
              [
                61.128493,
                35.093496
              ],
              [
                61.127747,
                35.093782
              ],
              [
                61.126247,
                35.094962
              ],
              [
                61.126077,
                35.095384
              ],
              [
                61.126057,
                35.09568
              ],
              [
                61.126248,
                35.096077
              ],
              [
                61.126467,
                35.096313
              ],
              [
                61.126795,
                35.09647
              ],
              [
                61.127213,
                35.096981
              ],
              [
                61.127562,
                35.097541
              ],
              [
                61.127948,
                35.097868
              ],
              [
                61.128594,
                35.09817
              ],
              [
                61.129075,
                35.098452
              ],
              [
                61.129872,
                35.098788
              ],
              [
                61.132096,
                35.099239
              ],
              [
                61.132798,
                35.09955
              ],
              [
                61.133328,
                35.099947
              ],
              [
                61.133753,
                35.100135
              ],
              [
                61.13436,
                35.100315
              ],
              [
                61.135544,
                35.100521
              ],
              [
                61.136036,
                35.100433
              ],
              [
                61.136883,
                35.100493
              ],
              [
                61.137267,
                35.100745
              ],
              [
                61.138123,
                35.101013
              ],
              [
                61.139069,
                35.101389
              ],
              [
                61.139845,
                35.10182
              ],
              [
                61.140424,
                35.102418
              ],
              [
                61.141005,
                35.103246
              ],
              [
                61.141347,
                35.104039
              ],
              [
                61.141486,
                35.104899
              ],
              [
                61.141374,
                35.10566
              ],
              [
                61.141248,
                35.106133
              ],
              [
                61.140463,
                35.107281
              ],
              [
                61.139885,
                35.107818
              ],
              [
                61.138931,
                35.108388
              ],
              [
                61.138169,
                35.108576
              ],
              [
                61.137503,
                35.108569
              ],
              [
                61.136252,
                35.108226
              ],
              [
                61.135466,
                35.10787
              ],
              [
                61.134856,
                35.107482
              ],
              [
                61.134805,
                35.107264
              ],
              [
                61.134723,
                35.107179
              ],
              [
                61.134365,
                35.107009
              ],
              [
                61.133949,
                35.10691
              ],
              [
                61.133348,
                35.106666
              ],
              [
                61.132034,
                35.106307
              ],
              [
                61.13149,
                35.106422
              ],
              [
                61.131031,
                35.106666
              ],
              [
                61.130521,
                35.107322
              ],
              [
                61.1304,
                35.107791
              ],
              [
                61.130459,
                35.108038
              ],
              [
                61.130451,
                35.109574
              ],
              [
                61.130112,
                35.11028
              ],
              [
                61.130119,
                35.110554
              ],
              [
                61.130254,
                35.111624
              ],
              [
                61.130462,
                35.11215
              ],
              [
                61.130776,
                35.112808
              ],
              [
                61.13112,
                35.113374
              ],
              [
                61.131452,
                35.113722
              ],
              [
                61.13176,
                35.115599
              ],
              [
                61.131861,
                35.116753
              ],
              [
                61.131575,
                35.117576
              ],
              [
                61.131543,
                35.118783
              ],
              [
                61.131799,
                35.121657
              ],
              [
                61.131974,
                35.122213
              ],
              [
                61.132424,
                35.122817
              ],
              [
                61.133188,
                35.123487
              ],
              [
                61.133295,
                35.123942
              ],
              [
                61.133225,
                35.124273
              ],
              [
                61.132905,
                35.124538
              ],
              [
                61.13255,
                35.125224
              ],
              [
                61.13231,
                35.126083
              ],
              [
                61.131921,
                35.126563
              ],
              [
                61.131313,
                35.127749
              ],
              [
                61.130796,
                35.128382
              ],
              [
                61.130611,
                35.129029
              ],
              [
                61.130705,
                35.130806
              ],
              [
                61.130864,
                35.131885
              ],
              [
                61.131176,
                35.132613
              ],
              [
                61.131758,
                35.133082
              ],
              [
                61.132655,
                35.1336
              ],
              [
                61.133109,
                35.133988
              ],
              [
                61.133297,
                35.134476
              ],
              [
                61.133175,
                35.134714
              ],
              [
                61.132679,
                35.135392
              ],
              [
                61.13257,
                35.135873
              ],
              [
                61.131827,
                35.136785
              ],
              [
                61.131046,
                35.137043
              ],
              [
                61.130404,
                35.137075
              ],
              [
                61.129965,
                35.137002
              ],
              [
                61.129563,
                35.136715
              ],
              [
                61.129047,
                35.135893
              ],
              [
                61.128684,
                35.135587
              ],
              [
                61.127726,
                35.135031
              ],
              [
                61.126929,
                35.13482
              ],
              [
                61.12507,
                35.134661
              ],
              [
                61.124396,
                35.134778
              ],
              [
                61.124237,
                35.135018
              ],
              [
                61.124121,
                35.135367
              ],
              [
                61.121931,
                35.138475
              ],
              [
                61.121189,
                35.139171
              ],
              [
                61.120285,
                35.140488
              ],
              [
                61.11973,
                35.141498
              ],
              [
                61.119484,
                35.142081
              ],
              [
                61.11949,
                35.143872
              ],
              [
                61.119413,
                35.144598
              ],
              [
                61.11907,
                35.145119
              ],
              [
                61.118254,
                35.14558
              ],
              [
                61.117376,
                35.145931
              ],
              [
                61.116076,
                35.146308
              ],
              [
                61.114777,
                35.14654
              ],
              [
                61.114128,
                35.146893
              ],
              [
                61.1138069,
                35.1472497
              ],
              [
                61.113208,
                35.147915
              ],
              [
                61.11227,
                35.149178
              ],
              [
                61.111148,
                35.151072
              ],
              [
                61.110727,
                35.151924
              ],
              [
                61.110771,
                35.152834
              ],
              [
                61.110961,
                35.15346
              ],
              [
                61.111561,
                35.154685
              ],
              [
                61.112308,
                35.155929
              ],
              [
                61.112524,
                35.156621
              ],
              [
                61.1124,
                35.157331
              ],
              [
                61.112086,
                35.158001
              ],
              [
                61.111567,
                35.158617
              ],
              [
                61.111116,
                35.15904
              ],
              [
                61.110536,
                35.159295
              ],
              [
                61.108683,
                35.15935
              ],
              [
                61.107841,
                35.159693
              ],
              [
                61.107329,
                35.160098
              ],
              [
                61.106976,
                35.16091
              ],
              [
                61.10695,
                35.16149
              ],
              [
                61.107251,
                35.163263
              ],
              [
                61.107074,
                35.163698
              ],
              [
                61.106646,
                35.163899
              ],
              [
                61.106169,
                35.164275
              ],
              [
                61.104788,
                35.164952
              ],
              [
                61.104042,
                35.165269
              ],
              [
                61.102201,
                35.165584
              ],
              [
                61.101702,
                35.165883
              ],
              [
                61.099838,
                35.166049
              ],
              [
                61.098543,
                35.165972
              ],
              [
                61.097327,
                35.165391
              ],
              [
                61.096679,
                35.164973
              ],
              [
                61.095884,
                35.163929
              ],
              [
                61.095362,
                35.162739
              ],
              [
                61.095285,
                35.16178
              ],
              [
                61.095349,
                35.160251
              ],
              [
                61.095124,
                35.159873
              ],
              [
                61.094547,
                35.159399
              ],
              [
                61.093875,
                35.159089
              ],
              [
                61.093155,
                35.15902
              ],
              [
                61.092805,
                35.159261
              ],
              [
                61.092621,
                35.159481
              ],
              [
                61.092408,
                35.159897
              ],
              [
                61.091981,
                35.160232
              ],
              [
                61.0919,
                35.160532
              ],
              [
                61.091245,
                35.160993
              ],
              [
                61.08838,
                35.162616
              ],
              [
                61.087926,
                35.163115
              ],
              [
                61.087453,
                35.163958
              ],
              [
                61.087117,
                35.164807
              ],
              [
                61.086733,
                35.166334
              ],
              [
                61.086745,
                35.16683
              ],
              [
                61.087116,
                35.167422
              ],
              [
                61.087836,
                35.168091
              ],
              [
                61.089166,
                35.16873
              ],
              [
                61.090201,
                35.168802
              ],
              [
                61.090913,
                35.169057
              ],
              [
                61.092027,
                35.169666
              ],
              [
                61.093251,
                35.170405
              ],
              [
                61.094096,
                35.170827
              ],
              [
                61.094973,
                35.171144
              ],
              [
                61.09608,
                35.171749
              ],
              [
                61.098099,
                35.172885
              ],
              [
                61.098976,
                35.173504
              ],
              [
                61.099101,
                35.174027
              ],
              [
                61.0989,
                35.174661
              ],
              [
                61.09738,
                35.176688
              ],
              [
                61.0967,
                35.177474
              ],
              [
                61.096494,
                35.178068
              ],
              [
                61.095008,
                35.179328
              ],
              [
                61.094002,
                35.180503
              ],
              [
                61.093135,
                35.182166
              ],
              [
                61.092787,
                35.183125
              ],
              [
                61.092985,
                35.18393
              ],
              [
                61.093458,
                35.184751
              ],
              [
                61.094231,
                35.185501
              ],
              [
                61.09513,
                35.185916
              ],
              [
                61.098282,
                35.186819
              ],
              [
                61.099279,
                35.187408
              ],
              [
                61.101538,
                35.188973
              ],
              [
                61.104071,
                35.190187
              ],
              [
                61.105658,
                35.190795
              ],
              [
                61.106329,
                35.191167
              ],
              [
                61.1071,
                35.192817
              ],
              [
                61.107689,
                35.193484
              ],
              [
                61.108151,
                35.19422
              ],
              [
                61.10851,
                35.195051
              ],
              [
                61.109266,
                35.195743
              ],
              [
                61.109693,
                35.196595
              ],
              [
                61.109851,
                35.197064
              ],
              [
                61.109957,
                35.199773
              ],
              [
                61.109806,
                35.201814
              ],
              [
                61.109833,
                35.202794
              ],
              [
                61.110141,
                35.203554
              ],
              [
                61.110612,
                35.204021
              ],
              [
                61.111437,
                35.204611
              ],
              [
                61.11226,
                35.204929
              ],
              [
                61.112915,
                35.20492
              ],
              [
                61.113543,
                35.204711
              ],
              [
                61.11377,
                35.204425
              ],
              [
                61.114606,
                35.203821
              ],
              [
                61.115108,
                35.203814
              ],
              [
                61.115627,
                35.204255
              ],
              [
                61.116699,
                35.20569
              ],
              [
                61.117029,
                35.206763
              ],
              [
                61.117303,
                35.207207
              ],
              [
                61.117521,
                35.20776
              ],
              [
                61.117573,
                35.208329
              ],
              [
                61.117794,
                35.208871
              ],
              [
                61.117854,
                35.209644
              ],
              [
                61.117812,
                35.210814
              ],
              [
                61.117684,
                35.211099
              ],
              [
                61.117097,
                35.211391
              ],
              [
                61.116637,
                35.212
              ],
              [
                61.11611,
                35.21248
              ],
              [
                61.115427,
                35.212824
              ],
              [
                61.115104,
                35.212792
              ],
              [
                61.114456,
                35.212502
              ],
              [
                61.113448,
                35.212199
              ],
              [
                61.112853,
                35.212139
              ],
              [
                61.112119,
                35.212171
              ],
              [
                61.111652,
                35.212561
              ],
              [
                61.110706,
                35.213039
              ],
              [
                61.109014,
                35.213209
              ],
              [
                61.107782,
                35.213565
              ],
              [
                61.105926,
                35.214325
              ],
              [
                61.103887,
                35.214329
              ],
              [
                61.103437,
                35.214392
              ],
              [
                61.103318,
                35.214664
              ],
              [
                61.102139,
                35.215836
              ],
              [
                61.101027,
                35.216639
              ],
              [
                61.100552,
                35.217107
              ],
              [
                61.100173,
                35.217395
              ],
              [
                61.099292,
                35.217798
              ],
              [
                61.098697,
                35.218
              ],
              [
                61.09836,
                35.2185
              ],
              [
                61.098543,
                35.218948
              ],
              [
                61.099028,
                35.219659
              ],
              [
                61.099493,
                35.221077
              ],
              [
                61.099343,
                35.221459
              ],
              [
                61.099399,
                35.221699
              ],
              [
                61.100019,
                35.222971
              ],
              [
                61.100033,
                35.22382
              ],
              [
                61.099817,
                35.224335
              ],
              [
                61.099427,
                35.224954
              ],
              [
                61.099119,
                35.226033
              ],
              [
                61.098725,
                35.227932
              ],
              [
                61.098999,
                35.228334
              ],
              [
                61.099428,
                35.228759
              ],
              [
                61.099857,
                35.229446
              ],
              [
                61.1009,
                35.230456
              ],
              [
                61.101633,
                35.231585
              ],
              [
                61.102326,
                35.232358
              ],
              [
                61.102524,
                35.233162
              ],
              [
                61.102585,
                35.233852
              ],
              [
                61.102344,
                35.234429
              ],
              [
                61.102053,
                35.234467
              ],
              [
                61.101494,
                35.234296
              ],
              [
                61.100681,
                35.234443
              ],
              [
                61.100235,
                35.234885
              ],
              [
                61.099992,
                35.235241
              ],
              [
                61.099071,
                35.235699
              ],
              [
                61.097957,
                35.236384
              ],
              [
                61.097411,
                35.237078
              ],
              [
                61.096282,
                35.238902
              ],
              [
                61.096081,
                35.239557
              ],
              [
                61.096334,
                35.240447
              ],
              [
                61.096664,
                35.241109
              ],
              [
                61.097291,
                35.241475
              ],
              [
                61.097854,
                35.241578
              ],
              [
                61.098856,
                35.241642
              ],
              [
                61.099195,
                35.241989
              ],
              [
                61.099426,
                35.242457
              ],
              [
                61.09926,
                35.242955
              ],
              [
                61.099148,
                35.243791
              ],
              [
                61.098894,
                35.244129
              ],
              [
                61.098695,
                35.244599
              ],
              [
                61.098411,
                35.245611
              ],
              [
                61.097821,
                35.246043
              ],
              [
                61.097704,
                35.246387
              ],
              [
                61.097838,
                35.247246
              ],
              [
                61.097564,
                35.247948
              ],
              [
                61.097825,
                35.248651
              ],
              [
                61.097661,
                35.249607
              ],
              [
                61.097363,
                35.250334
              ],
              [
                61.097458,
                35.251032
              ],
              [
                61.097229,
                35.251396
              ],
              [
                61.097172,
                35.252081
              ],
              [
                61.097231,
                35.252505
              ],
              [
                61.097433,
                35.253066
              ],
              [
                61.097341,
                35.253302
              ],
              [
                61.097459,
                35.253934
              ],
              [
                61.097328,
                35.254404
              ],
              [
                61.097131,
                35.257991
              ],
              [
                61.096817,
                35.258419
              ],
              [
                61.096324,
                35.258501
              ],
              [
                61.094706,
                35.259342
              ],
              [
                61.092795,
                35.260078
              ],
              [
                61.092337,
                35.260476
              ],
              [
                61.092063,
                35.260875
              ],
              [
                61.091916,
                35.261224
              ],
              [
                61.091731,
                35.26203
              ],
              [
                61.091693,
                35.263115
              ],
              [
                61.091775,
                35.263737
              ],
              [
                61.092187,
                35.264389
              ],
              [
                61.092973,
                35.265128
              ],
              [
                61.093787,
                35.265753
              ],
              [
                61.09447,
                35.266514
              ],
              [
                61.095031,
                35.267452
              ],
              [
                61.095503,
                35.268826
              ],
              [
                61.096494,
                35.270702
              ],
              [
                61.09658,
                35.27134
              ],
              [
                61.096947,
                35.272146
              ],
              [
                61.097688,
                35.273022
              ],
              [
                61.099247,
                35.274456
              ],
              [
                61.099545,
                35.275091
              ],
              [
                61.100263,
                35.276026
              ],
              [
                61.101093,
                35.277287
              ],
              [
                61.1016304,
                35.2778731
              ],
              [
                61.102125,
                35.278209
              ],
              [
                61.10417,
                35.279121
              ],
              [
                61.104894,
                35.279572
              ],
              [
                61.105324,
                35.28003
              ],
              [
                61.105561,
                35.280579
              ],
              [
                61.106446,
                35.281462
              ],
              [
                61.107142,
                35.281773
              ],
              [
                61.107967,
                35.282413
              ],
              [
                61.108955,
                35.282812
              ],
              [
                61.109716,
                35.282921
              ],
              [
                61.110355,
                35.28258
              ],
              [
                61.111029,
                35.281321
              ],
              [
                61.111461,
                35.281082
              ],
              [
                61.113192,
                35.281502
              ],
              [
                61.114047,
                35.281632
              ],
              [
                61.115045,
                35.281906
              ],
              [
                61.115594,
                35.282219
              ],
              [
                61.116036,
                35.282316
              ],
              [
                61.116569,
                35.282217
              ],
              [
                61.116925,
                35.28195
              ],
              [
                61.117334,
                35.281768
              ],
              [
                61.117687,
                35.280918
              ],
              [
                61.117678,
                35.280202
              ],
              [
                61.117784,
                35.279765
              ],
              [
                61.117771,
                35.279248
              ],
              [
                61.118479,
                35.278707
              ],
              [
                61.118849,
                35.278541
              ],
              [
                61.119579,
                35.278371
              ],
              [
                61.119975,
                35.277952
              ],
              [
                61.120575,
                35.277789
              ],
              [
                61.12123,
                35.277707
              ],
              [
                61.121616,
                35.277708
              ],
              [
                61.122856,
                35.277958
              ],
              [
                61.123522,
                35.278218
              ],
              [
                61.124426,
                35.278852
              ],
              [
                61.124858,
                35.279235
              ],
              [
                61.125545,
                35.280185
              ],
              [
                61.125909,
                35.280467
              ],
              [
                61.126431,
                35.280638
              ],
              [
                61.126784,
                35.280651
              ],
              [
                61.127106,
                35.280579
              ],
              [
                61.128535,
                35.279918
              ],
              [
                61.128898,
                35.279598
              ],
              [
                61.129427,
                35.27886
              ],
              [
                61.129662,
                35.278623
              ],
              [
                61.12993,
                35.27853
              ],
              [
                61.13124,
                35.278457
              ],
              [
                61.13193,
                35.278465
              ],
              [
                61.132931,
                35.278358
              ],
              [
                61.133271,
                35.278425
              ],
              [
                61.135024,
                35.279064
              ],
              [
                61.136387,
                35.279324
              ],
              [
                61.136894,
                35.279552
              ],
              [
                61.137458,
                35.279729
              ],
              [
                61.138054,
                35.279872
              ],
              [
                61.138507,
                35.279931
              ],
              [
                61.139347,
                35.279945
              ],
              [
                61.140009,
                35.280258
              ],
              [
                61.140492,
                35.280429
              ],
              [
                61.140979,
                35.280754
              ],
              [
                61.141102,
                35.281056
              ],
              [
                61.141166,
                35.281822
              ],
              [
                61.14127,
                35.282135
              ],
              [
                61.141782,
                35.282691
              ],
              [
                61.142211,
                35.282993
              ],
              [
                61.142871,
                35.28329
              ],
              [
                61.143317,
                35.283223
              ],
              [
                61.144064,
                35.282908
              ],
              [
                61.144432,
                35.282894
              ],
              [
                61.14517,
                35.283167
              ],
              [
                61.146243,
                35.283397
              ],
              [
                61.146719,
                35.283541
              ],
              [
                61.147477,
                35.283617
              ],
              [
                61.148052,
                35.283812
              ],
              [
                61.149263,
                35.283935
              ],
              [
                61.149983,
                35.284073
              ],
              [
                61.151017,
                35.284388
              ],
              [
                61.151692,
                35.284461
              ],
              [
                61.152161,
                35.284437
              ],
              [
                61.153828,
                35.284702
              ],
              [
                61.154804,
                35.284697
              ],
              [
                61.155421,
                35.284545
              ],
              [
                61.155767,
                35.284299
              ],
              [
                61.155778,
                35.283989
              ],
              [
                61.155578,
                35.283616
              ],
              [
                61.155603,
                35.283316
              ],
              [
                61.155877,
                35.282516
              ],
              [
                61.156302,
                35.280094
              ],
              [
                61.156232,
                35.27893
              ],
              [
                61.155991,
                35.278275
              ],
              [
                61.155693,
                35.27669
              ],
              [
                61.155796,
                35.276266
              ],
              [
                61.155996,
                35.275844
              ],
              [
                61.156348,
                35.275572
              ],
              [
                61.156678,
                35.275472
              ],
              [
                61.157048,
                35.275465
              ],
              [
                61.157867,
                35.275352
              ],
              [
                61.15837,
                35.275484
              ],
              [
                61.158588,
                35.275593
              ],
              [
                61.159366,
                35.276587
              ],
              [
                61.159747,
                35.277244
              ],
              [
                61.160083,
                35.278227
              ],
              [
                61.160168,
                35.278952
              ],
              [
                61.160342,
                35.279402
              ],
              [
                61.160786,
                35.28038
              ],
              [
                61.161102,
                35.280799
              ],
              [
                61.161543,
                35.281073
              ],
              [
                61.161952,
                35.281225
              ],
              [
                61.162608,
                35.281434
              ],
              [
                61.163113,
                35.281464
              ],
              [
                61.163507,
                35.281567
              ],
              [
                61.16391,
                35.281926
              ],
              [
                61.164156,
                35.282237
              ],
              [
                61.164516,
                35.282966
              ],
              [
                61.164887,
                35.283088
              ],
              [
                61.165851,
                35.283299
              ],
              [
                61.166135,
                35.283456
              ],
              [
                61.166683,
                35.283986
              ],
              [
                61.167062,
                35.284505
              ],
              [
                61.167127,
                35.284873
              ],
              [
                61.167029,
                35.284995
              ],
              [
                61.166033,
                35.285379
              ],
              [
                61.164838,
                35.285636
              ],
              [
                61.164665,
                35.285823
              ],
              [
                61.16471,
                35.28609
              ],
              [
                61.164891,
                35.286423
              ],
              [
                61.165167,
                35.287238
              ],
              [
                61.165319,
                35.287516
              ],
              [
                61.165904,
                35.287997
              ],
              [
                61.166541,
                35.288423
              ],
              [
                61.167302,
                35.288859
              ],
              [
                61.1681878,
                35.2892966
              ],
              [
                61.168302,
                35.289353
              ],
              [
                61.16857,
                35.289969
              ],
              [
                61.168976,
                35.290183
              ],
              [
                61.169188,
                35.290211
              ],
              [
                61.169559,
                35.290079
              ],
              [
                61.170313,
                35.289929
              ],
              [
                61.170796,
                35.289997
              ],
              [
                61.171372,
                35.29027
              ],
              [
                61.172501,
                35.290081
              ],
              [
                61.17285,
                35.289908
              ],
              [
                61.174398,
                35.289926
              ],
              [
                61.174634,
                35.290021
              ],
              [
                61.175551,
                35.290631
              ],
              [
                61.176024,
                35.291052
              ],
              [
                61.176878,
                35.292075
              ],
              [
                61.177799,
                35.292548
              ],
              [
                61.178602,
                35.292817
              ],
              [
                61.179184,
                35.29279
              ],
              [
                61.179527,
                35.292594
              ],
              [
                61.179749,
                35.292335
              ],
              [
                61.180337,
                35.291838
              ],
              [
                61.181358,
                35.291275
              ],
              [
                61.181721,
                35.29111
              ],
              [
                61.182634,
                35.290954
              ],
              [
                61.183149,
                35.291101
              ],
              [
                61.183673,
                35.291179
              ],
              [
                61.184511,
                35.29156
              ],
              [
                61.184673,
                35.29172
              ],
              [
                61.184906,
                35.291776
              ],
              [
                61.185629,
                35.291864
              ],
              [
                61.186297,
                35.291678
              ],
              [
                61.186928,
                35.291697
              ],
              [
                61.187299,
                35.291908
              ],
              [
                61.187543,
                35.291962
              ],
              [
                61.188425,
                35.291919
              ],
              [
                61.189265,
                35.292017
              ],
              [
                61.189539,
                35.292131
              ],
              [
                61.189836,
                35.292359
              ],
              [
                61.190296,
                35.292865
              ],
              [
                61.190254,
                35.293594
              ],
              [
                61.189979,
                35.294469
              ],
              [
                61.189705,
                35.296375
              ],
              [
                61.189712,
                35.297624
              ],
              [
                61.189489,
                35.298351
              ],
              [
                61.189408,
                35.298958
              ],
              [
                61.189518,
                35.299339
              ],
              [
                61.190127,
                35.299793
              ],
              [
                61.190512,
                35.300002
              ],
              [
                61.191,
                35.30013
              ],
              [
                61.191679,
                35.300557
              ],
              [
                61.191882,
                35.301104
              ],
              [
                61.19132,
                35.301647
              ],
              [
                61.190622,
                35.301773
              ],
              [
                61.190261,
                35.301548
              ],
              [
                61.189869,
                35.301535
              ],
              [
                61.189501,
                35.301707
              ],
              [
                61.18839,
                35.301619
              ],
              [
                61.187884,
                35.301807
              ],
              [
                61.187616,
                35.302169
              ],
              [
                61.187427,
                35.302737
              ],
              [
                61.187322,
                35.303254
              ],
              [
                61.187862,
                35.304519
              ],
              [
                61.18812,
                35.305368
              ],
              [
                61.188345,
                35.305874
              ],
              [
                61.189362,
                35.307542
              ],
              [
                61.189484,
                35.308052
              ],
              [
                61.189523,
                35.308473
              ],
              [
                61.189246,
                35.308841
              ],
              [
                61.189325,
                35.309295
              ],
              [
                61.189258,
                35.309631
              ],
              [
                61.188859,
                35.310049
              ],
              [
                61.188834,
                35.310561
              ],
              [
                61.188547,
                35.311212
              ],
              [
                61.188007,
                35.31196
              ],
              [
                61.187529,
                35.312812
              ],
              [
                61.187313,
                35.313645
              ],
              [
                61.186979,
                35.314445
              ],
              [
                61.186497,
                35.315145
              ],
              [
                61.186242,
                35.315751
              ],
              [
                61.185968,
                35.31611
              ],
              [
                61.186126,
                35.316489
              ],
              [
                61.186919,
                35.317396
              ],
              [
                61.187776,
                35.317575
              ],
              [
                61.18849,
                35.317227
              ],
              [
                61.189995,
                35.317018
              ],
              [
                61.190415,
                35.317116
              ],
              [
                61.191093,
                35.317939
              ],
              [
                61.191312,
                35.318504
              ],
              [
                61.191225,
                35.31891
              ],
              [
                61.191343,
                35.319504
              ],
              [
                61.191225,
                35.31969
              ],
              [
                61.190712,
                35.319814
              ],
              [
                61.190365,
                35.320666
              ],
              [
                61.189933,
                35.321108
              ],
              [
                61.187412,
                35.322182
              ],
              [
                61.18671,
                35.322531
              ],
              [
                61.185993,
                35.323111
              ],
              [
                61.185257,
                35.324177
              ],
              [
                61.185078,
                35.324846
              ],
              [
                61.185159,
                35.325246
              ],
              [
                61.185675,
                35.326519
              ],
              [
                61.186088,
                35.327072
              ],
              [
                61.186416,
                35.327635
              ],
              [
                61.186415,
                35.328134
              ],
              [
                61.186048,
                35.328653
              ],
              [
                61.185474,
                35.328893
              ],
              [
                61.185058,
                35.32929
              ],
              [
                61.18443,
                35.329694
              ],
              [
                61.183671,
                35.330315
              ],
              [
                61.183065,
                35.330657
              ],
              [
                61.182642,
                35.331191
              ],
              [
                61.182278,
                35.331862
              ],
              [
                61.182201,
                35.333209
              ],
              [
                61.1823,
                35.333937
              ],
              [
                61.182268,
                35.334402
              ],
              [
                61.18217,
                35.334744
              ],
              [
                61.181936,
                35.335219
              ],
              [
                61.181326,
                35.335848
              ],
              [
                61.181007,
                35.336305
              ],
              [
                61.18072,
                35.336623
              ],
              [
                61.179995,
                35.337031
              ],
              [
                61.179495,
                35.337501
              ],
              [
                61.179112,
                35.337781
              ],
              [
                61.178348,
                35.337944
              ],
              [
                61.178152,
                35.337917
              ],
              [
                61.177916,
                35.338053
              ],
              [
                61.177751,
                35.33836
              ],
              [
                61.177557,
                35.338481
              ],
              [
                61.177273,
                35.338559
              ],
              [
                61.177049,
                35.339042
              ],
              [
                61.176743,
                35.339331
              ],
              [
                61.176522,
                35.339664
              ],
              [
                61.176557,
                35.339754
              ],
              [
                61.176467,
                35.340395
              ],
              [
                61.17613,
                35.340996
              ],
              [
                61.176029,
                35.341335
              ],
              [
                61.17575,
                35.343314
              ],
              [
                61.175845,
                35.343594
              ],
              [
                61.175915,
                35.345223
              ],
              [
                61.176002,
                35.345896
              ],
              [
                61.175913,
                35.346474
              ],
              [
                61.17571,
                35.346882
              ],
              [
                61.175874,
                35.347272
              ],
              [
                61.176484,
                35.348231
              ],
              [
                61.176984,
                35.348543
              ],
              [
                61.177271,
                35.348603
              ],
              [
                61.17764,
                35.348946
              ],
              [
                61.178359,
                35.34994
              ],
              [
                61.178213,
                35.350639
              ],
              [
                61.178081,
                35.351843
              ],
              [
                61.177184,
                35.35252
              ],
              [
                61.177103,
                35.352766
              ],
              [
                61.177085,
                35.353591
              ],
              [
                61.1737888,
                35.3545663
              ],
              [
                61.153713,
                35.3567782
              ],
              [
                61.1478742,
                35.3588431
              ],
              [
                61.1386073,
                35.3658759
              ],
              [
                61.1344528,
                35.3675656
              ],
              [
                61.1259978,
                35.3712055
              ],
              [
                61.1218476,
                35.3753321
              ],
              [
                61.1161645,
                35.3788565
              ],
              [
                61.1106197,
                35.3809902
              ],
              [
                61.108567,
                35.379545
              ],
              [
                61.0962579,
                35.3792535
              ],
              [
                61.0822677,
                35.383732
              ],
              [
                61.0744568,
                35.3848518
              ],
              [
                61.0722255,
                35.3841518
              ],
              [
                61.0690498,
                35.3811077
              ],
              [
                61.0629987,
                35.3772938
              ],
              [
                61.0621833,
                35.3742145
              ],
              [
                61.0560035,
                35.3685455
              ],
              [
                61.0520553,
                35.3667257
              ],
              [
                61.0461759,
                35.3669707
              ],
              [
                61.0412833,
                35.3678458
              ],
              [
                61.0384512,
                35.3664457
              ],
              [
                61.0363483,
                35.3664807
              ],
              [
                61.0336875,
                35.3646609
              ],
              [
                61.0309839,
                35.3620011
              ],
              [
                61.0293102,
                35.3620011
              ],
              [
                61.027379,
                35.3613361
              ],
              [
                61.0213279,
                35.3608812
              ],
              [
                61.0083,
                35.3614609
              ],
              [
                61.0011002,
                35.3652543
              ],
              [
                60.9986593,
                35.3684254
              ],
              [
                60.981674,
                35.3747745
              ],
              [
                60.9636496,
                35.3816327
              ],
              [
                60.9588431,
                35.3869509
              ],
              [
                60.9423636,
                35.3938081
              ],
              [
                60.9366987,
                35.4038829
              ],
              [
                60.9358404,
                35.4143762
              ],
              [
                60.9320639,
                35.4220704
              ],
              [
                60.9320555,
                35.431378
              ],
              [
                60.9274349,
                35.4367643
              ],
              [
                60.9107779,
                35.4429109
              ],
              [
                60.9059714,
                35.4457778
              ],
              [
                60.903182,
                35.4460224
              ],
              [
                60.8969591,
                35.4477706
              ],
              [
                60.8970451,
                35.4520356
              ],
              [
                60.8931398,
                35.4562306
              ],
              [
                60.8893584,
                35.4579958
              ],
              [
                60.8780077,
                35.4582845
              ],
              [
                60.8685163,
                35.4569212
              ],
              [
                60.8574492,
                35.4572707
              ],
              [
                60.8382121,
                35.4662021
              ],
              [
                60.8357026,
                35.4721787
              ],
              [
                60.8320283,
                35.4760837
              ],
              [
                60.8300972,
                35.4821645
              ],
              [
                60.8216617,
                35.4932687
              ],
              [
                60.8152484,
                35.4911451
              ],
              [
                60.807852,
                35.4920289
              ],
              [
                60.8033118,
                35.5001712
              ],
              [
                60.7960324,
                35.5054817
              ],
              [
                60.7920129,
                35.5084161
              ],
              [
                60.7821682,
                35.5180484
              ],
              [
                60.7847863,
                35.522849
              ],
              [
                60.7788735,
                35.5345054
              ],
              [
                60.7774797,
                35.5436734
              ],
              [
                60.7774797,
                35.5447822
              ],
              [
                60.7640072,
                35.5512229
              ],
              [
                60.7516476,
                35.5568093
              ],
              [
                60.7406511,
                35.5718812
              ],
              [
                60.7249481,
                35.5963627
              ],
              [
                60.7185612,
                35.6055319
              ],
              [
                60.7177284,
                35.6071909
              ],
              [
                60.6978151,
                35.6141072
              ],
              [
                60.6897618,
                35.6232681
              ],
              [
                60.6854018,
                35.6575222
              ],
              [
                60.6845689,
                35.6591898
              ],
              [
                60.6840158,
                35.6597397
              ],
              [
                60.680122,
                35.6653014
              ],
              [
                60.6600687,
                35.688817
              ],
              [
                60.6565635,
                35.691667
              ],
              [
                60.6422895,
                35.70327
              ],
              [
                60.6403426,
                35.7043791
              ],
              [
                60.639509,
                35.7052085
              ],
              [
                60.6372894,
                35.7063175
              ],
              [
                60.6353425,
                35.7077151
              ],
              [
                60.6320096,
                35.709383
              ],
              [
                60.6292292,
                35.7113216
              ],
              [
                60.6236759,
                35.7140985
              ],
              [
                60.6068791,
                35.7251304
              ],
              [
                60.6046597,
                35.7273575
              ],
              [
                60.5852217,
                35.7393788
              ],
              [
                60.584942,
                35.7396492
              ],
              [
                60.5781613,
                35.7356305
              ],
              [
                60.5670219,
                35.7212173
              ],
              [
                60.563259,
                35.7004646
              ],
              [
                60.5613127,
                35.6987964
              ],
              [
                60.5546665,
                35.6872436
              ],
              [
                60.5385705,
                35.6779573
              ],
              [
                60.5037372,
                35.6646766
              ],
              [
                60.4987371,
                35.6635587
              ],
              [
                60.4851239,
                35.6627292
              ],
              [
                60.4837376,
                35.6630087
              ],
              [
                60.4737095,
                35.6551986
              ],
              [
                60.4679511,
                35.6493402
              ],
              [
                60.4665643,
                35.6490607
              ],
              [
                60.4648979,
                35.6490607
              ],
              [
                60.4637846,
                35.6487812
              ],
              [
                60.4611961,
                35.6438988
              ],
              [
                60.4603559,
                35.6436193
              ],
              [
                60.458416,
                35.6433397
              ],
              [
                60.4523147,
                35.6409754
              ],
              [
                60.4445456,
                35.6363719
              ],
              [
                60.4357748,
                35.6416908
              ],
              [
                60.4243164,
                35.6524501
              ],
              [
                60.4122853,
                35.6553663
              ],
              [
                60.4116916,
                35.6552467
              ],
              [
                60.4108583,
                35.6552467
              ],
              [
                60.4100251,
                35.6555262
              ],
              [
                60.4022453,
                35.6566351
              ],
              [
                60.4002983,
                35.6566351
              ],
              [
                60.3930786,
                35.657744
              ],
              [
                60.3911317,
                35.657744
              ],
              [
                60.3891919,
                35.6580235
              ],
              [
                60.3841851,
                35.6580236
              ],
              [
                60.3830788,
                35.6577441
              ],
              [
                60.3685689,
                35.6619369
              ],
              [
                60.363009,
                35.6624867
              ],
              [
                60.3610691,
                35.6630457
              ],
              [
                60.3599558,
                35.6630457
              ],
              [
                60.3580088,
                35.6636046
              ],
              [
                60.3571756,
                35.6641545
              ],
              [
                60.3463425,
                35.6672107
              ],
              [
                60.3321759,
                35.6719345
              ],
              [
                60.3182897,
                35.6769378
              ],
              [
                60.311343,
                35.6791555
              ],
              [
                60.3013433,
                35.6822115
              ],
              [
                60.2993963,
                35.6824911
              ],
              [
                60.2966162,
                35.6827615
              ],
              [
                60.2739066,
                35.6749728
              ],
              [
                60.2730735,
                35.674414
              ],
              [
                60.2614067,
                35.6674721
              ],
              [
                60.2561269,
                35.6624685
              ],
              [
                60.2572968,
                35.6463511
              ],
              [
                60.2550397,
                35.6157094
              ],
              [
                60.2455899,
                35.6014858
              ],
              [
                60.2231236,
                35.6015394
              ],
              [
                60.2211837,
                35.6007099
              ],
              [
                60.1827873,
                35.6107996
              ],
              [
                60.1707455,
                35.6106973
              ],
              [
                60.1580478,
                35.601638
              ],
              [
                60.1541548,
                35.5946958
              ],
              [
                60.1544345,
                35.5916394
              ],
              [
                60.1561012,
                35.5858059
              ],
              [
                60.1656774,
                35.5785999
              ],
              [
                60.1670708,
                35.5697103
              ],
              [
                60.1676243,
                35.5688718
              ],
              [
                60.1607891,
                35.5573679
              ],
              [
                60.1597592,
                35.5445188
              ],
              [
                60.1404177,
                35.5364541
              ],
              [
                60.1390243,
                35.5372834
              ],
              [
                60.1192471,
                35.5333441
              ],
              [
                60.1085479,
                35.5180303
              ],
              [
                60.095775,
                35.5049742
              ],
              [
                60.0837183,
                35.4866616
              ],
              [
                60.0462992,
                35.4723408
              ],
              [
                60.028298,
                35.4684871
              ],
              [
                60.0200301,
                35.4665719
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554963,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تربت حیدریه",
          "name:ar": "مقاطعة تربت حيدريه",
          "name:en": "Torbat-e-Heydarieh County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1292889",
          "wikipedia": "fa:شهرستان تربت حیدریه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.6951854,
                35.5779196
              ],
              [
                58.720894,
                35.5756855
              ],
              [
                58.7595894,
                35.5742044
              ],
              [
                58.7623625,
                35.5630979
              ],
              [
                58.7722992,
                35.5430518
              ],
              [
                58.7734128,
                35.5425018
              ],
              [
                58.7736858,
                35.5419429
              ],
              [
                58.7747992,
                35.5413928
              ],
              [
                58.7820197,
                35.5348163
              ],
              [
                58.7767852,
                35.5148717
              ],
              [
                58.7723921,
                35.5002994
              ],
              [
                58.7725637,
                35.4944995
              ],
              [
                58.7650106,
                35.4868123
              ],
              [
                58.791425,
                35.4772256
              ],
              [
                58.7820052,
                35.4494137
              ],
              [
                58.7691305,
                35.432841
              ],
              [
                58.7693336,
                35.3884646
              ],
              [
                58.7707545,
                35.3816867
              ],
              [
                58.7707546,
                35.3814071
              ],
              [
                58.7786064,
                35.3696357
              ],
              [
                58.7795767,
                35.3681503
              ],
              [
                58.7899004,
                35.3453464
              ],
              [
                58.7904535,
                35.3453464
              ],
              [
                58.791287,
                35.3453464
              ],
              [
                58.7918469,
                35.345626
              ],
              [
                58.8052426,
                35.3364432
              ],
              [
                58.8060762,
                35.3361636
              ],
              [
                58.8319729,
                35.3142857
              ],
              [
                58.8747362,
                35.3148987
              ],
              [
                58.8845725,
                35.3152579
              ],
              [
                58.8999172,
                35.3183346
              ],
              [
                58.915386,
                35.3323525
              ],
              [
                58.936859,
                35.3392124
              ],
              [
                58.9572094,
                35.3323505
              ],
              [
                58.9822775,
                35.314978
              ],
              [
                58.9833493,
                35.3141966
              ],
              [
                58.9835092,
                35.3140801
              ],
              [
                58.9948652,
                35.3022376
              ],
              [
                59.0104864,
                35.294532
              ],
              [
                59.014332,
                35.2844192
              ],
              [
                59.0171121,
                35.2824798
              ],
              [
                59.0173851,
                35.2822002
              ],
              [
                59.0221118,
                35.2794219
              ],
              [
                59.0481513,
                35.268178
              ],
              [
                59.0518568,
                35.2580955
              ],
              [
                59.0516266,
                35.2482912
              ],
              [
                59.0527331,
                35.2421855
              ],
              [
                59.0555129,
                35.2380187
              ],
              [
                59.0628598,
                35.2191804
              ],
              [
                59.0785726,
                35.2055137
              ],
              [
                59.0859791,
                35.188931
              ],
              [
                59.085699,
                35.1864324
              ],
              [
                59.097092,
                35.1867257
              ],
              [
                59.0970919,
                35.1853366
              ],
              [
                59.0970919,
                35.1850569
              ],
              [
                59.097092,
                35.1844977
              ],
              [
                59.0968189,
                35.1808894
              ],
              [
                59.0968189,
                35.1803391
              ],
              [
                59.0968189,
                35.1800505
              ],
              [
                59.0965387,
                35.1753327
              ],
              [
                59.0965388,
                35.1750532
              ],
              [
                59.0965387,
                35.1745029
              ],
              [
                59.0968189,
                35.1711653
              ],
              [
                59.0968188,
                35.1703263
              ],
              [
                59.1006562,
                35.1662977
              ],
              [
                59.1006561,
                35.1660271
              ],
              [
                59.1006562,
                35.1654679
              ],
              [
                59.1006561,
                35.1651883
              ],
              [
                59.1006562,
                35.164638
              ],
              [
                59.0975182,
                35.151355
              ],
              [
                59.0789641,
                35.1160856
              ],
              [
                59.0448893,
                35.0781719
              ],
              [
                59.0504837,
                35.0710311
              ],
              [
                59.0566633,
                35.0578237
              ],
              [
                59.0631866,
                35.0428571
              ],
              [
                59.0752028,
                35.0299965
              ],
              [
                59.0917042,
                35.0063179
              ],
              [
                59.1246244,
                35.0096877
              ],
              [
                59.1401752,
                35.0109652
              ],
              [
                59.1970787,
                34.9899323
              ],
              [
                59.2064377,
                35.003074
              ],
              [
                59.2207714,
                35.0117211
              ],
              [
                59.2379376,
                35.0257796
              ],
              [
                59.256477,
                35.0302778
              ],
              [
                59.2775101,
                35.053752
              ],
              [
                59.2772304,
                35.0576401
              ],
              [
                59.2775101,
                35.0579287
              ],
              [
                59.2777902,
                35.0587497
              ],
              [
                59.2780636,
                35.0601479
              ],
              [
                59.2783437,
                35.0609779
              ],
              [
                59.2783437,
                35.0629265
              ],
              [
                59.27639,
                35.0780907
              ],
              [
                59.2766926,
                35.0833201
              ],
              [
                59.2842003,
                35.0897852
              ],
              [
                59.2889213,
                35.0954384
              ],
              [
                59.2908093,
                35.1013726
              ],
              [
                59.2947699,
                35.1189315
              ],
              [
                59.2947699,
                35.1236575
              ],
              [
                59.2944898,
                35.1250464
              ],
              [
                59.2936566,
                35.1267059
              ],
              [
                59.2897698,
                35.1328118
              ],
              [
                59.2785767,
                35.134124
              ],
              [
                59.2777433,
                35.134124
              ],
              [
                59.2573238,
                35.1480425
              ],
              [
                59.2550971,
                35.1488723
              ],
              [
                59.226981,
                35.1553129
              ],
              [
                59.2219814,
                35.1597592
              ],
              [
                59.2203145,
                35.1633668
              ],
              [
                59.2383006,
                35.1989035
              ],
              [
                59.2405272,
                35.2011311
              ],
              [
                59.2987057,
                35.2189783
              ],
              [
                59.3368112,
                35.2236082
              ],
              [
                59.340248,
                35.2209414
              ],
              [
                59.3442532,
                35.2194011
              ],
              [
                59.3427084,
                35.2304153
              ],
              [
                59.3423938,
                35.2342276
              ],
              [
                59.3416214,
                35.2488786
              ],
              [
                59.3399182,
                35.2604932
              ],
              [
                59.3386891,
                35.2622088
              ],
              [
                59.3288326,
                35.2799592
              ],
              [
                59.3286696,
                35.2819352
              ],
              [
                59.3285321,
                35.2870709
              ],
              [
                59.3309783,
                35.2918348
              ],
              [
                59.3332958,
                35.2945669
              ],
              [
                59.3356131,
                35.2990153
              ],
              [
                59.3446254,
                35.3097323
              ],
              [
                59.3540667,
                35.3224789
              ],
              [
                59.3565558,
                35.3264005
              ],
              [
                59.3356989,
                35.3411048
              ],
              [
                59.338188,
                35.3510461
              ],
              [
                59.3314075,
                35.3566463
              ],
              [
                59.323511,
                35.3610562
              ],
              [
                59.3199454,
                35.3648033
              ],
              [
                59.3174562,
                35.3727013
              ],
              [
                59.3201551,
                35.3762283
              ],
              [
                59.3217001,
                35.3812135
              ],
              [
                59.3219671,
                35.3991308
              ],
              [
                59.3222963,
                35.4085506
              ],
              [
                59.3231296,
                35.4208911
              ],
              [
                59.3228489,
                35.4245666
              ],
              [
                59.3284033,
                35.4395544
              ],
              [
                59.336637,
                35.4455263
              ],
              [
                59.3374702,
                35.4471945
              ],
              [
                59.3452261,
                35.4507422
              ],
              [
                59.3497237,
                35.4569993
              ],
              [
                59.3632507,
                35.46067
              ],
              [
                59.3681452,
                35.4627119
              ],
              [
                59.3744942,
                35.4678008
              ],
              [
                59.3788719,
                35.4730082
              ],
              [
                59.3794724,
                35.47708
              ],
              [
                59.3789955,
                35.4811925
              ],
              [
                59.380669,
                35.481103
              ],
              [
                59.3868542,
                35.4806618
              ],
              [
                59.4039344,
                35.4806619
              ],
              [
                59.4138908,
                35.4775166
              ],
              [
                59.4308131,
                35.4782296
              ],
              [
                59.4419156,
                35.4792864
              ],
              [
                59.4476981,
                35.4800287
              ],
              [
                59.4585962,
                35.4778969
              ],
              [
                59.47524,
                35.4749962
              ],
              [
                59.4782638,
                35.4741616
              ],
              [
                59.486761,
                35.4769575
              ],
              [
                59.4897859,
                35.4800461
              ],
              [
                59.5434093,
                35.4890486
              ],
              [
                59.5562716,
                35.4927567
              ],
              [
                59.5725059,
                35.4931717
              ],
              [
                59.5801016,
                35.5007537
              ],
              [
                59.5894146,
                35.502186
              ],
              [
                59.5941352,
                35.5040726
              ],
              [
                59.5981755,
                35.5062446
              ],
              [
                59.5931911,
                35.5056097
              ],
              [
                59.5899295,
                35.5062735
              ],
              [
                59.5799732,
                35.5025703
              ],
              [
                59.5560725,
                35.5002502
              ],
              [
                59.5413727,
                35.5016389
              ],
              [
                59.5346173,
                35.5030367
              ],
              [
                59.5269727,
                35.5080552
              ],
              [
                59.5217317,
                35.5130812
              ],
              [
                59.5147162,
                35.5201987
              ],
              [
                59.502291,
                35.5400195
              ],
              [
                59.4880354,
                35.5608065
              ],
              [
                59.4872023,
                35.5730237
              ],
              [
                59.488589,
                35.5805252
              ],
              [
                59.4891488,
                35.5816342
              ],
              [
                59.4894222,
                35.5830317
              ],
              [
                59.4868693,
                35.6019558
              ],
              [
                59.487429,
                35.6025057
              ],
              [
                59.4877025,
                35.6036237
              ],
              [
                59.4899292,
                35.6072296
              ],
              [
                59.4954296,
                35.6187913
              ],
              [
                59.5040127,
                35.6254892
              ],
              [
                59.4996624,
                35.6333315
              ],
              [
                59.4993889,
                35.6361081
              ],
              [
                59.4882759,
                35.6524975
              ],
              [
                59.4843895,
                35.6574918
              ],
              [
                59.4804961,
                35.6641628
              ],
              [
                59.4802226,
                35.6644423
              ],
              [
                59.4802226,
                35.6652717
              ],
              [
                59.4791093,
                35.6741604
              ],
              [
                59.4796628,
                35.6766664
              ],
              [
                59.4770432,
                35.6849271
              ],
              [
                59.4820434,
                35.6952058
              ],
              [
                59.482323,
                35.6960353
              ],
              [
                59.4828766,
                35.6963238
              ],
              [
                59.4905264,
                35.7027075
              ],
              [
                59.4905264,
                35.7032665
              ],
              [
                59.4908062,
                35.703537
              ],
              [
                59.4910796,
                35.7054844
              ],
              [
                59.4908061,
                35.7079819
              ],
              [
                59.4902463,
                35.7082705
              ],
              [
                59.4902464,
                35.7085409
              ],
              [
                59.4896928,
                35.7091
              ],
              [
                59.4888596,
                35.7077115
              ],
              [
                59.4863595,
                35.7066025
              ],
              [
                59.4860794,
                35.7063139
              ],
              [
                59.4852462,
                35.706314
              ],
              [
                59.4849732,
                35.7060435
              ],
              [
                59.4312397,
                35.711678
              ],
              [
                59.4301265,
                35.7116781
              ],
              [
                59.4295734,
                35.7119486
              ],
              [
                59.4291999,
                35.7121348
              ],
              [
                59.4115928,
                35.7146269
              ],
              [
                59.4096529,
                35.7160155
              ],
              [
                59.3924264,
                35.724627
              ],
              [
                59.37576,
                35.7265658
              ],
              [
                59.3727068,
                35.7262953
              ],
              [
                59.3519207,
                35.7228243
              ],
              [
                59.3165248,
                35.7349475
              ],
              [
                59.2817354,
                35.745835
              ],
              [
                59.2809018,
                35.7455555
              ],
              [
                59.2789552,
                35.7455555
              ],
              [
                59.278122,
                35.745276
              ],
              [
                59.276175,
                35.745276
              ],
              [
                59.275902,
                35.7455555
              ],
              [
                59.2684019,
                35.7455555
              ],
              [
                59.2675687,
                35.745835
              ],
              [
                59.2664553,
                35.7458349
              ],
              [
                59.2656222,
                35.7461144
              ],
              [
                59.2634021,
                35.7461145
              ],
              [
                59.2631221,
                35.7463938
              ],
              [
                59.2622888,
                35.7463938
              ],
              [
                59.2617354,
                35.7466733
              ],
              [
                59.2606221,
                35.7466733
              ],
              [
                59.2364524,
                35.7494033
              ],
              [
                59.2327176,
                35.7555124
              ],
              [
                59.2314731,
                35.7601112
              ],
              [
                59.2314552,
                35.7640755
              ],
              [
                59.2307802,
                35.766993
              ],
              [
                59.2310831,
                35.7776108
              ],
              [
                59.2299985,
                35.7811611
              ],
              [
                59.2265653,
                35.7849211
              ],
              [
                59.2208783,
                35.7870051
              ],
              [
                59.2168235,
                35.7964784
              ],
              [
                59.2132184,
                35.8075818
              ],
              [
                59.1844222,
                35.8172566
              ],
              [
                59.1722771,
                35.8101224
              ],
              [
                59.1590166,
                35.8133936
              ],
              [
                59.1446825,
                35.8112013
              ],
              [
                59.1397044,
                35.8295399
              ],
              [
                59.114792,
                35.8313144
              ],
              [
                59.0892185,
                35.8325689
              ],
              [
                59.0879059,
                35.8359067
              ],
              [
                59.0861273,
                35.8442952
              ],
              [
                59.0771138,
                35.8454643
              ],
              [
                59.0630718,
                35.8473758
              ],
              [
                59.0565227,
                35.848134
              ],
              [
                59.0497135,
                35.8490149
              ],
              [
                59.0459144,
                35.8496669
              ],
              [
                59.0414101,
                35.850467
              ],
              [
                59.0363482,
                35.8511638
              ],
              [
                59.0217344,
                35.8533565
              ],
              [
                59.0041437,
                35.8515966
              ],
              [
                58.9943109,
                35.8333136
              ],
              [
                58.9948892,
                35.8295611
              ],
              [
                58.9946161,
                35.8259464
              ],
              [
                58.9907311,
                35.8196844
              ],
              [
                58.990451,
                35.8177464
              ],
              [
                58.990178,
                35.8135818
              ],
              [
                58.9898979,
                35.8113552
              ],
              [
                58.9891027,
                35.809411
              ],
              [
                58.9883394,
                35.80637
              ],
              [
                58.9880593,
                35.8058111
              ],
              [
                58.9880593,
                35.8008173
              ],
              [
                58.9853629,
                35.7969378
              ],
              [
                58.9845296,
                35.7941524
              ],
              [
                58.973143,
                35.762766
              ],
              [
                58.9728628,
                35.7610984
              ],
              [
                58.9725827,
                35.7583221
              ],
              [
                58.9723097,
                35.7574838
              ],
              [
                58.9725111,
                35.7435785
              ],
              [
                58.9664514,
                35.7333488
              ],
              [
                58.9586103,
                35.7282694
              ],
              [
                58.9447801,
                35.7188007
              ],
              [
                58.9322089,
                35.7205245
              ],
              [
                58.9126395,
                35.7265868
              ],
              [
                58.9040629,
                35.731344
              ],
              [
                58.8970646,
                35.7348276
              ],
              [
                58.8825617,
                35.7426296
              ],
              [
                58.87411,
                35.7447279
              ],
              [
                58.8654061,
                35.7443778
              ],
              [
                58.8554363,
                35.742497
              ],
              [
                58.8357489,
                35.7401321
              ],
              [
                58.8269674,
                35.7395228
              ],
              [
                58.8213157,
                35.7310461
              ],
              [
                58.8201138,
                35.7158558
              ],
              [
                58.8158223,
                35.7003139
              ],
              [
                58.811531,
                35.6904852
              ],
              [
                58.7986562,
                35.6768211
              ],
              [
                58.7865704,
                35.6717213
              ],
              [
                58.7734002,
                35.6655284
              ],
              [
                58.7693909,
                35.6608037
              ],
              [
                58.7660685,
                35.6560801
              ],
              [
                58.7613755,
                35.6495566
              ],
              [
                58.7588919,
                35.6419752
              ],
              [
                58.7565358,
                35.6316651
              ],
              [
                58.7495228,
                35.6301507
              ],
              [
                58.7263418,
                35.6023538
              ],
              [
                58.7138803,
                35.5876929
              ],
              [
                58.7083766,
                35.5850574
              ],
              [
                58.6951854,
                35.5779196
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554976,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جغتای",
          "name:en": "Joghatai County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2610787",
          "wikipedia": "fa:شهرستان جغتای"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.6483228,
                36.6736649
              ],
              [
                56.6510994,
                36.6724587
              ],
              [
                56.6935633,
                36.6625424
              ],
              [
                56.6949532,
                36.6625424
              ],
              [
                56.69523,
                36.6628216
              ],
              [
                56.6980066,
                36.6636506
              ],
              [
                56.7043965,
                36.6644883
              ],
              [
                56.7060632,
                36.6639297
              ],
              [
                56.7134664,
                36.6688764
              ],
              [
                56.717913,
                36.6688763
              ],
              [
                56.7187464,
                36.6691556
              ],
              [
                56.7245796,
                36.6691556
              ],
              [
                56.7254129,
                36.6694349
              ],
              [
                56.7378928,
                36.675793
              ],
              [
                56.7442163,
                36.6796582
              ],
              [
                56.7453262,
                36.6796582
              ],
              [
                56.7503262,
                36.6802167
              ],
              [
                56.7531028,
                36.6802167
              ],
              [
                56.7542162,
                36.6804959
              ],
              [
                56.7572729,
                36.6804959
              ],
              [
                56.758106,
                36.6802167
              ],
              [
                56.7594928,
                36.6802167
              ],
              [
                56.7686151,
                36.6828182
              ],
              [
                56.7746649,
                36.6759816
              ],
              [
                56.774665,
                36.6754232
              ],
              [
                56.7733107,
                36.6735223
              ],
              [
                56.769825,
                36.6670998
              ],
              [
                56.7639526,
                36.6639856
              ],
              [
                56.7560184,
                36.6536822
              ],
              [
                56.7554617,
                36.652007
              ],
              [
                56.7554619,
                36.6517279
              ],
              [
                56.7557418,
                36.6497916
              ],
              [
                56.7568519,
                36.6450633
              ],
              [
                56.752872,
                36.6062699
              ],
              [
                56.7556487,
                36.5962619
              ],
              [
                56.7692617,
                36.5887672
              ],
              [
                56.7700952,
                36.5887672
              ],
              [
                56.7714853,
                36.5882088
              ],
              [
                56.7723185,
                36.5882088
              ],
              [
                56.7731519,
                36.5879295
              ],
              [
                56.7742619,
                36.5879295
              ],
              [
                56.7756517,
                36.5876502
              ],
              [
                56.7792618,
                36.5870917
              ],
              [
                56.7800951,
                36.5868124
              ],
              [
                56.8187677,
                36.5898147
              ],
              [
                56.8449108,
                36.5822785
              ],
              [
                56.8521339,
                36.5772796
              ],
              [
                56.8643572,
                36.5606075
              ],
              [
                56.8646337,
                36.5594996
              ],
              [
                56.8651905,
                36.5578243
              ],
              [
                56.8682436,
                36.5492223
              ],
              [
                56.8696337,
                36.5431063
              ],
              [
                56.8688172,
                36.5370548
              ],
              [
                56.8695813,
                36.5369354
              ],
              [
                56.8748578,
                36.5369354
              ],
              [
                56.8751344,
                36.5372145
              ],
              [
                56.8779145,
                36.5372146
              ],
              [
                56.8793011,
                36.5374938
              ],
              [
                56.8881909,
                36.5374938
              ],
              [
                56.9101714,
                36.5331124
              ],
              [
                56.9185047,
                36.5331125
              ],
              [
                56.9204481,
                36.5333917
              ],
              [
                56.9277544,
                36.530633
              ],
              [
                56.9341445,
                36.531741
              ],
              [
                56.9360876,
                36.5317409
              ],
              [
                56.9397009,
                36.5322995
              ],
              [
                56.941921,
                36.5322994
              ],
              [
                56.943311,
                36.5325787
              ],
              [
                56.9452542,
                36.5325787
              ],
              [
                56.9466443,
                36.532858
              ],
              [
                56.9488676,
                36.532858
              ],
              [
                56.9499775,
                36.5331372
              ],
              [
                56.9588674,
                36.5331371
              ],
              [
                56.9755268,
                36.5334442
              ],
              [
                56.9879756,
                36.5306055
              ],
              [
                56.9951298,
                36.5369995
              ],
              [
                57.004097,
                36.5440748
              ],
              [
                57.0044088,
                36.540088
              ],
              [
                57.0085263,
                36.5352973
              ],
              [
                57.0185185,
                36.5325387
              ],
              [
                57.0323124,
                36.523231
              ],
              [
                57.0398751,
                36.5174945
              ],
              [
                57.046337,
                36.5131545
              ],
              [
                57.075262,
                36.5019093
              ],
              [
                57.0819568,
                36.4995979
              ],
              [
                57.0952602,
                36.4963898
              ],
              [
                57.1018695,
                36.492836
              ],
              [
                57.1081349,
                36.4863153
              ],
              [
                57.119808,
                36.4804493
              ],
              [
                57.1303223,
                36.4748935
              ],
              [
                57.1358399,
                36.4717631
              ],
              [
                57.1412658,
                36.4695444
              ],
              [
                57.1639251,
                36.4571884
              ],
              [
                57.1695899,
                36.4504228
              ],
              [
                57.1727369,
                36.4502973
              ],
              [
                57.1797685,
                36.4501561
              ],
              [
                57.2041624,
                36.4487753
              ],
              [
                57.2208377,
                36.4398501
              ],
              [
                57.2291353,
                36.4361903
              ],
              [
                57.232694,
                36.4325306
              ],
              [
                57.2438149,
                36.43302
              ],
              [
                57.2604558,
                36.4321466
              ],
              [
                57.2632486,
                36.4406268
              ],
              [
                57.2710794,
                36.4657405
              ],
              [
                57.2708028,
                36.4674067
              ],
              [
                57.2710794,
                36.4682352
              ],
              [
                57.2728628,
                36.4794669
              ],
              [
                57.2738319,
                36.4932192
              ],
              [
                57.272329,
                36.4997706
              ],
              [
                57.2658917,
                36.5074978
              ],
              [
                57.2624585,
                36.5247431
              ],
              [
                57.2620293,
                36.5288124
              ],
              [
                57.2407433,
                36.5379849
              ],
              [
                57.2339626,
                36.5743882
              ],
              [
                57.2282511,
                36.5822432
              ],
              [
                57.2269678,
                36.5903778
              ],
              [
                57.2276541,
                36.597407
              ],
              [
                57.2326752,
                36.6097407
              ],
              [
                57.2364984,
                36.6188854
              ],
              [
                57.231711,
                36.6344565
              ],
              [
                57.224468,
                36.6537442
              ],
              [
                57.2048259,
                36.6588472
              ],
              [
                57.190041,
                36.6651193
              ],
              [
                57.1874427,
                36.6759916
              ],
              [
                57.1853825,
                36.687487
              ],
              [
                57.1897599,
                36.7042792
              ],
              [
                57.1857887,
                36.7226151
              ],
              [
                57.18461,
                36.7281536
              ],
              [
                57.1864986,
                36.735445
              ],
              [
                57.1980857,
                36.7402598
              ],
              [
                57.2168786,
                36.7498236
              ],
              [
                57.2221142,
                36.7588874
              ],
              [
                57.2167044,
                36.7687622
              ],
              [
                57.2127946,
                36.7701525
              ],
              [
                57.2130747,
                36.7723768
              ],
              [
                57.2133513,
                36.7737637
              ],
              [
                57.213628,
                36.775988
              ],
              [
                57.213908,
                36.7779332
              ],
              [
                57.228131,
                36.7970515
              ],
              [
                57.2426137,
                36.8179005
              ],
              [
                57.2428938,
                36.8181797
              ],
              [
                57.2431703,
                36.8195753
              ],
              [
                57.2432626,
                36.820776
              ],
              [
                57.2428937,
                36.8209621
              ],
              [
                57.2415037,
                36.8209619
              ],
              [
                57.2370604,
                36.8220696
              ],
              [
                57.2317805,
                36.822907
              ],
              [
                57.2068402,
                36.8241268
              ],
              [
                57.1959381,
                36.8347662
              ],
              [
                57.1945479,
                36.8347662
              ],
              [
                57.1931614,
                36.8350452
              ],
              [
                57.1903815,
                36.8350453
              ],
              [
                57.1895481,
                36.8353243
              ],
              [
                57.1878815,
                36.8353243
              ],
              [
                57.1870483,
                36.8356035
              ],
              [
                57.1851049,
                36.8356034
              ],
              [
                57.1820481,
                36.8361528
              ],
              [
                57.1784383,
                36.8361528
              ],
              [
                57.175105,
                36.836711
              ],
              [
                57.1731583,
                36.836711
              ],
              [
                57.1717682,
                36.8369901
              ],
              [
                57.169825,
                36.83699
              ],
              [
                57.168435,
                36.8372692
              ],
              [
                57.1662151,
                36.8372691
              ],
              [
                57.1648251,
                36.8375483
              ],
              [
                57.1512523,
                36.8361785
              ],
              [
                57.1468735,
                36.8374493
              ],
              [
                57.144649,
                36.8371789
              ],
              [
                57.1392165,
                36.837207
              ],
              [
                57.138651,
                36.8373205
              ],
              [
                57.137198,
                36.8371489
              ],
              [
                57.1363646,
                36.8374279
              ],
              [
                57.1336487,
                36.8375737
              ],
              [
                57.1297621,
                36.8386812
              ],
              [
                57.1222621,
                36.8414633
              ],
              [
                57.1178155,
                36.840931
              ],
              [
                57.1167056,
                36.8414892
              ],
              [
                57.1033722,
                36.8456581
              ],
              [
                57.102259,
                36.8456581
              ],
              [
                57.0907807,
                36.8476159
              ],
              [
                57.0597927,
                36.8536183
              ],
              [
                57.0589594,
                36.8541766
              ],
              [
                57.041683,
                36.8565555
              ],
              [
                57.0405698,
                36.8565556
              ],
              [
                57.0380698,
                36.8571139
              ],
              [
                57.0355698,
                36.8571138
              ],
              [
                57.0347364,
                36.8573931
              ],
              [
                57.03196,
                36.857393
              ],
              [
                57.0311265,
                36.8571138
              ],
              [
                57.0252932,
                36.8571139
              ],
              [
                57.02446,
                36.8568348
              ],
              [
                57.0230699,
                36.8568348
              ],
              [
                57.0222367,
                36.8565556
              ],
              [
                57.0165667,
                36.8601225
              ],
              [
                57.0157335,
                36.8601225
              ],
              [
                57.0137868,
                36.8595642
              ],
              [
                56.9884869,
                36.8678112
              ],
              [
                56.9582745,
                36.8711071
              ],
              [
                56.9428566,
                36.8820376
              ],
              [
                56.9405856,
                36.8814796
              ],
              [
                56.9329552,
                36.8853667
              ],
              [
                56.9320838,
                36.8851475
              ],
              [
                56.9243377,
                36.8885832
              ],
              [
                56.9132714,
                36.8906472
              ],
              [
                56.8889685,
                36.8823746
              ],
              [
                56.8822986,
                36.8809887
              ],
              [
                56.8519224,
                36.858965
              ],
              [
                56.8385226,
                36.8537116
              ],
              [
                56.8316393,
                36.8512392
              ],
              [
                56.8269527,
                36.8473761
              ],
              [
                56.8088161,
                36.8396154
              ],
              [
                56.8023929,
                36.829431
              ],
              [
                56.8004495,
                36.829152
              ],
              [
                56.7965596,
                36.8280447
              ],
              [
                56.7954496,
                36.8280446
              ],
              [
                56.7903629,
                36.823918
              ],
              [
                56.7892531,
                36.823639
              ],
              [
                56.7881162,
                36.8194794
              ],
              [
                56.7875595,
                36.8192003
              ],
              [
                56.7856161,
                36.8192003
              ],
              [
                56.7850594,
                36.8189212
              ],
              [
                56.7792993,
                36.816677
              ],
              [
                56.7773526,
                36.8161187
              ],
              [
                56.7745761,
                36.8147322
              ],
              [
                56.7731861,
                36.8144531
              ],
              [
                56.7634629,
                36.8105636
              ],
              [
                56.7242966,
                36.8000026
              ],
              [
                56.72263,
                36.7991742
              ],
              [
                56.7212399,
                36.7988951
              ],
              [
                56.7156833,
                36.796113
              ],
              [
                56.7129067,
                36.7952847
              ],
              [
                56.6999243,
                36.7782176
              ],
              [
                56.6921995,
                36.7670798
              ],
              [
                56.6752717,
                36.7591736
              ],
              [
                56.6733285,
                36.7583451
              ],
              [
                56.6551855,
                36.7514124
              ],
              [
                56.6518522,
                36.7489177
              ],
              [
                56.6142642,
                36.7227284
              ],
              [
                56.6125975,
                36.7210624
              ],
              [
                56.6100974,
                36.7196755
              ],
              [
                56.6073208,
                36.7174511
              ],
              [
                56.5991259,
                36.7106298
              ],
              [
                56.5992089,
                36.6950964
              ],
              [
                56.6104885,
                36.6849403
              ],
              [
                56.6251358,
                36.6806655
              ],
              [
                56.6410587,
                36.6759784
              ],
              [
                56.6483228,
                36.6736649
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554982,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جوین",
          "name:en": "Jowayin County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2610777",
          "wikipedia": "fa:شهرستان جوین"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.1857887,
                36.7226151
              ],
              [
                57.1897599,
                36.7042792
              ],
              [
                57.1853825,
                36.687487
              ],
              [
                57.1874427,
                36.6759916
              ],
              [
                57.190041,
                36.6651193
              ],
              [
                57.2048259,
                36.6588472
              ],
              [
                57.224468,
                36.6537442
              ],
              [
                57.231711,
                36.6344565
              ],
              [
                57.2364984,
                36.6188854
              ],
              [
                57.2326752,
                36.6097407
              ],
              [
                57.2276541,
                36.597407
              ],
              [
                57.2269678,
                36.5903778
              ],
              [
                57.2282511,
                36.5822432
              ],
              [
                57.2339626,
                36.5743882
              ],
              [
                57.2407433,
                36.5379849
              ],
              [
                57.2620293,
                36.5288124
              ],
              [
                57.2624585,
                36.5247431
              ],
              [
                57.2658917,
                36.5074978
              ],
              [
                57.272329,
                36.4997706
              ],
              [
                57.2738319,
                36.4932192
              ],
              [
                57.2728628,
                36.4794669
              ],
              [
                57.2710794,
                36.4682352
              ],
              [
                57.2708028,
                36.4674067
              ],
              [
                57.2710794,
                36.4657405
              ],
              [
                57.2632486,
                36.4406268
              ],
              [
                57.2604558,
                36.4321466
              ],
              [
                57.2655273,
                36.4292845
              ],
              [
                57.2820505,
                36.4198774
              ],
              [
                57.292532,
                36.4215028
              ],
              [
                57.3280334,
                36.4257717
              ],
              [
                57.3618223,
                36.4202721
              ],
              [
                57.3626555,
                36.4202721
              ],
              [
                57.3629355,
                36.4205513
              ],
              [
                57.3634886,
                36.4205513
              ],
              [
                57.3773354,
                36.4200196
              ],
              [
                57.3781686,
                36.4200196
              ],
              [
                57.3885982,
                36.4183799
              ],
              [
                57.3894318,
                36.4183798
              ],
              [
                57.389985,
                36.4186592
              ],
              [
                57.3919319,
                36.419488
              ],
              [
                57.392485,
                36.4194881
              ],
              [
                57.3927651,
                36.4197673
              ],
              [
                57.4033714,
                36.4203198
              ],
              [
                57.4047581,
                36.4203198
              ],
              [
                57.4067046,
                36.4208784
              ],
              [
                57.4080914,
                36.4208784
              ],
              [
                57.4092048,
                36.4211576
              ],
              [
                57.4105911,
                36.4211577
              ],
              [
                57.414758,
                36.4219865
              ],
              [
                57.423571,
                36.4230915
              ],
              [
                57.4238511,
                36.4233708
              ],
              [
                57.4257909,
                36.4233708
              ],
              [
                57.4263512,
                36.42365
              ],
              [
                57.4288512,
                36.42365
              ],
              [
                57.4294043,
                36.4239292
              ],
              [
                57.4310708,
                36.4239293
              ],
              [
                57.4319043,
                36.4242086
              ],
              [
                57.4332978,
                36.4242086
              ],
              [
                57.4344041,
                36.4244879
              ],
              [
                57.4407976,
                36.4250374
              ],
              [
                57.4460707,
                36.4250374
              ],
              [
                57.4534946,
                36.4252714
              ],
              [
                57.4579412,
                36.4241634
              ],
              [
                57.4836473,
                36.4249654
              ],
              [
                57.5051467,
                36.4395933
              ],
              [
                57.5076466,
                36.4395933
              ],
              [
                57.5148399,
                36.4359967
              ],
              [
                57.5273397,
                36.434889
              ],
              [
                57.5346269,
                36.4257268
              ],
              [
                57.5360137,
                36.4257268
              ],
              [
                57.5437737,
                36.4154907
              ],
              [
                57.547107,
                36.4154907
              ],
              [
                57.5476602,
                36.4152114
              ],
              [
                57.5493269,
                36.4154907
              ],
              [
                57.5504403,
                36.4152115
              ],
              [
                57.5546067,
                36.4152114
              ],
              [
                57.5601801,
                36.4168721
              ],
              [
                57.5721399,
                36.4224148
              ],
              [
                57.5738068,
                36.4224148
              ],
              [
                57.5796359,
                36.4422505
              ],
              [
                57.572607,
                36.4435435
              ],
              [
                57.577977,
                36.4528132
              ],
              [
                57.5858102,
                36.4605608
              ],
              [
                57.5860903,
                36.4627857
              ],
              [
                57.595633,
                36.4713586
              ],
              [
                57.6017496,
                36.4766365
              ],
              [
                57.6020297,
                36.4788613
              ],
              [
                57.6126728,
                36.4855498
              ],
              [
                57.6129462,
                36.4863785
              ],
              [
                57.6316408,
                36.5111523
              ],
              [
                57.6338607,
                36.5178269
              ],
              [
                57.6341055,
                36.5333642
              ],
              [
                57.6336441,
                36.5412672
              ],
              [
                57.6344774,
                36.5420958
              ],
              [
                57.6364243,
                36.5465452
              ],
              [
                57.65007,
                36.5551543
              ],
              [
                57.6722143,
                36.5558438
              ],
              [
                57.687254,
                36.5393682
              ],
              [
                57.7000235,
                36.5248119
              ],
              [
                57.7115248,
                36.5312952
              ],
              [
                57.7228446,
                36.5327723
              ],
              [
                57.7289581,
                36.5297099
              ],
              [
                57.7443121,
                36.5281226
              ],
              [
                57.7537535,
                36.5332263
              ],
              [
                57.7963275,
                36.5274227
              ],
              [
                57.7971608,
                36.5271435
              ],
              [
                57.8021609,
                36.5271434
              ],
              [
                57.8091468,
                36.5284065
              ],
              [
                57.828274,
                36.5318623
              ],
              [
                57.828547,
                36.5321415
              ],
              [
                57.8296603,
                36.5321415
              ],
              [
                57.8454186,
                36.5338459
              ],
              [
                57.8920442,
                36.5257205
              ],
              [
                57.8925654,
                36.5642002
              ],
              [
                57.8929269,
                36.5781914
              ],
              [
                57.8931573,
                36.5871648
              ],
              [
                57.8789634,
                36.5848372
              ],
              [
                57.8714637,
                36.5865036
              ],
              [
                57.8695239,
                36.5870531
              ],
              [
                57.8684105,
                36.5870531
              ],
              [
                57.8215709,
                36.6161078
              ],
              [
                57.7773976,
                36.6302737
              ],
              [
                57.7521249,
                36.6405581
              ],
              [
                57.7457318,
                36.6433319
              ],
              [
                57.7182321,
                36.6574973
              ],
              [
                57.715732,
                36.6583348
              ],
              [
                57.7079521,
                36.6619458
              ],
              [
                57.7018387,
                36.6636118
              ],
              [
                57.663742,
                36.6785129
              ],
              [
                57.6585061,
                36.6805595
              ],
              [
                57.6396198,
                36.6913835
              ],
              [
                57.6158232,
                36.7020259
              ],
              [
                57.6119368,
                36.7056372
              ],
              [
                57.6069366,
                36.7089693
              ],
              [
                57.5808837,
                36.7198556
              ],
              [
                57.5470742,
                36.7433823
              ],
              [
                57.5454077,
                36.7436524
              ],
              [
                57.5367942,
                36.7470404
              ],
              [
                57.5356876,
                36.7472633
              ],
              [
                57.5290243,
                36.7541792
              ],
              [
                57.5267976,
                36.7544584
              ],
              [
                57.5173877,
                36.758611
              ],
              [
                57.5101679,
                36.7613933
              ],
              [
                57.5096078,
                36.7619515
              ],
              [
                57.5062745,
                36.7630591
              ],
              [
                57.5057214,
                36.7636172
              ],
              [
                57.4993345,
                36.7658323
              ],
              [
                57.4921082,
                36.7683355
              ],
              [
                57.4898883,
                36.7691637
              ],
              [
                57.4548887,
                36.778618
              ],
              [
                57.4471085,
                36.7800045
              ],
              [
                57.4448888,
                36.7800045
              ],
              [
                57.4437751,
                36.7802837
              ],
              [
                57.4418286,
                36.7802836
              ],
              [
                57.4057157,
                36.7861182
              ],
              [
                57.4034958,
                36.7869465
              ],
              [
                57.4018293,
                36.7872256
              ],
              [
                57.3738159,
                36.7920128
              ],
              [
                57.371876,
                36.7931203
              ],
              [
                57.2967371,
                36.8092674
              ],
              [
                57.2956304,
                36.8095465
              ],
              [
                57.2936838,
                36.8095465
              ],
              [
                57.2928507,
                36.8098256
              ],
              [
                57.2432626,
                36.820776
              ],
              [
                57.2431703,
                36.8195753
              ],
              [
                57.2428938,
                36.8181797
              ],
              [
                57.2426137,
                36.8179005
              ],
              [
                57.228131,
                36.7970515
              ],
              [
                57.213908,
                36.7779332
              ],
              [
                57.213628,
                36.775988
              ],
              [
                57.2133513,
                36.7737637
              ],
              [
                57.2130747,
                36.7723768
              ],
              [
                57.2127946,
                36.7701525
              ],
              [
                57.2167044,
                36.7687622
              ],
              [
                57.2221142,
                36.7588874
              ],
              [
                57.2168786,
                36.7498236
              ],
              [
                57.1980857,
                36.7402598
              ],
              [
                57.1864986,
                36.735445
              ],
              [
                57.18461,
                36.7281536
              ],
              [
                57.1857887,
                36.7226151
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554996,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خلیل آباد",
          "name:en": "Khalilabad County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286292",
          "wikipedia": "fa:شهرستان خلیل آباد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.9723326,
                34.9051899
              ],
              [
                58.0008603,
                34.9124028
              ],
              [
                58.0272347,
                34.9262812
              ],
              [
                58.0283481,
                34.9265607
              ],
              [
                58.030295,
                34.9265607
              ],
              [
                58.0311282,
                34.9268403
              ],
              [
                58.0330747,
                34.9268402
              ],
              [
                58.0339084,
                34.9271198
              ],
              [
                58.0408479,
                34.9271198
              ],
              [
                58.0552943,
                34.9279494
              ],
              [
                58.056408,
                34.9282289
              ],
              [
                58.058348,
                34.9282289
              ],
              [
                58.0586276,
                34.9285084
              ],
              [
                58.0641808,
                34.9285084
              ],
              [
                58.0669611,
                34.928779
              ],
              [
                58.0677943,
                34.9290585
              ],
              [
                58.0689075,
                34.9290585
              ],
              [
                58.069461,
                34.9293381
              ],
              [
                58.0705744,
                34.9293381
              ],
              [
                58.0785366,
                34.9366081
              ],
              [
                58.0898663,
                34.9337935
              ],
              [
                58.1035992,
                34.9321047
              ],
              [
                58.11379,
                34.9291151
              ],
              [
                58.1179564,
                34.9313338
              ],
              [
                58.1196234,
                34.9321726
              ],
              [
                58.1301834,
                34.935221
              ],
              [
                58.1307365,
                34.9355006
              ],
              [
                58.1324029,
                34.9355006
              ],
              [
                58.132683,
                34.9357802
              ],
              [
                58.1482361,
                34.9360507
              ],
              [
                58.1487962,
                34.9363304
              ],
              [
                58.1514632,
                34.935909
              ],
              [
                58.1520233,
                34.9361887
              ],
              [
                58.1522964,
                34.935909
              ],
              [
                58.1553468,
                34.9341741
              ],
              [
                58.1564608,
                34.9344295
              ],
              [
                58.1570206,
                34.9344295
              ],
              [
                58.1560622,
                34.9587265
              ],
              [
                58.1648139,
                34.9732716
              ],
              [
                58.1650873,
                34.9735421
              ],
              [
                58.1761606,
                34.9788275
              ],
              [
                58.1764407,
                34.9796572
              ],
              [
                58.1769938,
                34.9799367
              ],
              [
                58.1769938,
                34.9802163
              ],
              [
                58.1772739,
                34.9804959
              ],
              [
                58.1898436,
                34.9918618
              ],
              [
                58.1934504,
                35.0071305
              ],
              [
                58.1931774,
                35.0074101
              ],
              [
                58.1934504,
                35.0079694
              ],
              [
                58.1931774,
                35.0085284
              ],
              [
                58.2001633,
                35.0147358
              ],
              [
                58.211388,
                35.0201937
              ],
              [
                58.2160376,
                35.0221245
              ],
              [
                58.2253292,
                35.0214509
              ],
              [
                58.2379736,
                35.0212907
              ],
              [
                58.2438071,
                35.0195683
              ],
              [
                58.2502167,
                35.0167202
              ],
              [
                58.2671473,
                35.0218632
              ],
              [
                58.2780073,
                35.0166417
              ],
              [
                58.2886666,
                35.0184406
              ],
              [
                58.2981598,
                35.0204241
              ],
              [
                58.3055161,
                35.0179421
              ],
              [
                58.313713,
                35.0156224
              ],
              [
                58.3213519,
                35.0139704
              ],
              [
                58.3351278,
                35.0123536
              ],
              [
                58.3437353,
                35.0137541
              ],
              [
                58.3542024,
                35.0154724
              ],
              [
                58.371005,
                35.0160793
              ],
              [
                58.3855533,
                35.0181178
              ],
              [
                58.4172323,
                35.0213046
              ],
              [
                58.4118218,
                35.0278388
              ],
              [
                58.4081343,
                35.033681
              ],
              [
                58.4023003,
                35.0404473
              ],
              [
                58.3985138,
                35.0452463
              ],
              [
                58.382506,
                35.058421
              ],
              [
                58.3661127,
                35.0589126
              ],
              [
                58.359203,
                35.0605287
              ],
              [
                58.3532381,
                35.0646735
              ],
              [
                58.3489036,
                35.0720497
              ],
              [
                58.3474013,
                35.0823053
              ],
              [
                58.3480021,
                35.086063
              ],
              [
                58.3519074,
                35.0919975
              ],
              [
                58.3554267,
                35.0998275
              ],
              [
                58.3605765,
                35.1181535
              ],
              [
                58.3633229,
                35.1314919
              ],
              [
                58.3671855,
                35.1372475
              ],
              [
                58.3697487,
                35.1543027
              ],
              [
                58.3751678,
                35.1665817
              ],
              [
                58.3804893,
                35.173668
              ],
              [
                58.3866644,
                35.1889189
              ],
              [
                58.3753395,
                35.1860852
              ],
              [
                58.3655973,
                35.1917673
              ],
              [
                58.3591175,
                35.199798
              ],
              [
                58.3541943,
                35.206313
              ],
              [
                58.3522939,
                35.2111943
              ],
              [
                58.3504005,
                35.2175437
              ],
              [
                58.3554697,
                35.2212919
              ],
              [
                58.3605766,
                35.2262
              ],
              [
                58.360705,
                35.2274623
              ],
              [
                58.3590531,
                35.2295654
              ],
              [
                58.3566495,
                35.2322298
              ],
              [
                58.3533668,
                35.2353142
              ],
              [
                58.352251,
                35.2379957
              ],
              [
                58.3481299,
                35.2418387
              ],
              [
                58.3456695,
                35.2489478
              ],
              [
                58.3494914,
                35.252886
              ],
              [
                58.3501126,
                35.2601288
              ],
              [
                58.3469295,
                35.2722515
              ],
              [
                58.3423804,
                35.2866854
              ],
              [
                58.3419513,
                35.2971939
              ],
              [
                58.3426373,
                35.3020035
              ],
              [
                58.3450311,
                35.3096958
              ],
              [
                58.3475265,
                35.3144415
              ],
              [
                58.3547398,
                35.3221638
              ],
              [
                58.3619324,
                35.3259037
              ],
              [
                58.3571431,
                35.3344532
              ],
              [
                58.3624649,
                35.3362035
              ],
              [
                58.3696882,
                35.3398288
              ],
              [
                58.3452127,
                35.3457255
              ],
              [
                58.3305136,
                35.3514953
              ],
              [
                58.29629,
                35.3690987
              ],
              [
                58.2784366,
                35.3730247
              ],
              [
                58.2707976,
                35.3772238
              ],
              [
                58.2552623,
                35.399895
              ],
              [
                58.2505416,
                35.3991954
              ],
              [
                58.2443618,
                35.4003848
              ],
              [
                58.2388986,
                35.4053358
              ],
              [
                58.2282042,
                35.3979885
              ],
              [
                58.2154728,
                35.3907071
              ],
              [
                58.2090273,
                35.3758575
              ],
              [
                58.1914901,
                35.3558412
              ],
              [
                58.1815394,
                35.3530454
              ],
              [
                58.1763057,
                35.34108
              ],
              [
                58.1726172,
                35.3272299
              ],
              [
                58.1749248,
                35.3221636
              ],
              [
                58.1727361,
                35.312884
              ],
              [
                58.1685289,
                35.3031364
              ],
              [
                58.1662559,
                35.2992254
              ],
              [
                58.1657823,
                35.2862126
              ],
              [
                58.1650705,
                35.2796617
              ],
              [
                58.1651172,
                35.2730321
              ],
              [
                58.1643607,
                35.2677294
              ],
              [
                58.1659638,
                35.2577223
              ],
              [
                58.1657409,
                35.2516473
              ],
              [
                58.1586169,
                35.2501753
              ],
              [
                58.1570545,
                35.2489352
              ],
              [
                58.1478593,
                35.249163
              ],
              [
                58.1427775,
                35.249102
              ],
              [
                58.1323527,
                35.2498249
              ],
              [
                58.1105305,
                35.2493206
              ],
              [
                58.1104551,
                35.2516821
              ],
              [
                58.1028441,
                35.2516712
              ],
              [
                58.0875242,
                35.2516337
              ],
              [
                58.0809093,
                35.2518809
              ],
              [
                58.0802106,
                35.2494043
              ],
              [
                58.0799101,
                35.2406772
              ],
              [
                58.0707263,
                35.2387495
              ],
              [
                58.0624639,
                35.2369671
              ],
              [
                58.0582809,
                35.2313532
              ],
              [
                58.0572508,
                35.2280932
              ],
              [
                58.05871,
                35.2203453
              ],
              [
                58.0599975,
                35.2177158
              ],
              [
                58.0639457,
                35.2151915
              ],
              [
                58.0664655,
                35.2123822
              ],
              [
                58.0656623,
                35.1982901
              ],
              [
                58.0648106,
                35.1863246
              ],
              [
                58.0719508,
                35.1805169
              ],
              [
                58.0773353,
                35.1786842
              ],
              [
                58.0815839,
                35.1786492
              ],
              [
                58.0872917,
                35.1793507
              ],
              [
                58.0981546,
                35.1783004
              ],
              [
                58.1051169,
                35.1771666
              ],
              [
                58.1053657,
                35.1742285
              ],
              [
                58.1068182,
                35.1676692
              ],
              [
                58.1076548,
                35.1617704
              ],
              [
                58.1069469,
                35.1554598
              ],
              [
                58.1073298,
                35.1523391
              ],
              [
                58.1021369,
                35.1450319
              ],
              [
                58.0961322,
                35.1351066
              ],
              [
                58.0916663,
                35.1247617
              ],
              [
                58.0786231,
                35.1111807
              ],
              [
                58.0545464,
                35.0746594
              ],
              [
                58.0547741,
                35.0695893
              ],
              [
                58.0560822,
                35.0624734
              ],
              [
                58.0146003,
                35.048039
              ],
              [
                57.9854882,
                35.0204133
              ],
              [
                57.9745941,
                35.0101882
              ],
              [
                57.9819204,
                35.0003067
              ],
              [
                57.9815482,
                34.9943554
              ],
              [
                57.9800032,
                34.9892928
              ],
              [
                57.9775999,
                34.9774082
              ],
              [
                57.975025,
                34.9695312
              ],
              [
                57.9727934,
                34.9442068
              ],
              [
                57.9737376,
                34.932386
              ],
              [
                57.9757976,
                34.9227452
              ],
              [
                57.9723326,
                34.9051899
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555002,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خواف",
          "name:en": "Khaf County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2571648",
          "wikipedia": "fa:شهرستان خواف"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.3764455,
                34.1171722
              ],
              [
                59.3767185,
                34.1168924
              ],
              [
                59.3769986,
                34.1166217
              ],
              [
                59.3772788,
                34.1163419
              ],
              [
                59.3781124,
                34.1155116
              ],
              [
                59.3781124,
                34.1152319
              ],
              [
                59.4044491,
                34.108678
              ],
              [
                59.4236752,
                34.0867869
              ],
              [
                59.4573208,
                34.0805313
              ],
              [
                59.4672772,
                34.0617616
              ],
              [
                59.4916531,
                34.0523753
              ],
              [
                59.5632369,
                34.0503742
              ],
              [
                59.563237,
                34.0500944
              ],
              [
                59.6222608,
                34.0478125
              ],
              [
                59.633274,
                34.0495305
              ],
              [
                59.6407757,
                34.0497767
              ],
              [
                59.6484806,
                34.0431196
              ],
              [
                59.6608505,
                34.03144
              ],
              [
                59.6692114,
                34.0304952
              ],
              [
                59.6734306,
                34.028219
              ],
              [
                59.7041652,
                34.0322782
              ],
              [
                59.7225379,
                34.0272684
              ],
              [
                59.7498247,
                34.0179848
              ],
              [
                59.7712897,
                34.0183763
              ],
              [
                59.8148916,
                34.0075621
              ],
              [
                59.8250197,
                33.9966042
              ],
              [
                59.8742118,
                33.9777986
              ],
              [
                59.9583621,
                33.9747657
              ],
              [
                60.0088541,
                33.9730135
              ],
              [
                60.0924676,
                33.9729763
              ],
              [
                60.1199334,
                33.9570306
              ],
              [
                60.0880562,
                33.9277046
              ],
              [
                60.0921432,
                33.9089644
              ],
              [
                60.1146895,
                33.9047552
              ],
              [
                60.1152426,
                33.9036452
              ],
              [
                60.1158028,
                33.9033655
              ],
              [
                60.1163559,
                33.9022556
              ],
              [
                60.119409,
                33.8983661
              ],
              [
                60.1336731,
                33.8841068
              ],
              [
                60.1352422,
                33.8825379
              ],
              [
                60.136909,
                33.8828177
              ],
              [
                60.1374691,
                33.8828176
              ],
              [
                60.1438556,
                33.8839276
              ],
              [
                60.145522,
                33.8839276
              ],
              [
                60.1460756,
                33.8842074
              ],
              [
                60.147742,
                33.8842074
              ],
              [
                60.1535823,
                33.8858678
              ],
              [
                60.1544156,
                33.8864273
              ],
              [
                60.1571887,
                33.8875372
              ],
              [
                60.1710819,
                33.8917063
              ],
              [
                60.1841417,
                33.9027955
              ],
              [
                60.1858081,
                33.9033549
              ],
              [
                60.1863617,
                33.9039053
              ],
              [
                60.2183077,
                33.9277889
              ],
              [
                60.2605676,
                33.9340951
              ],
              [
                60.2625075,
                33.9360357
              ],
              [
                60.2812951,
                33.9331065
              ],
              [
                60.3334801,
                33.9524742
              ],
              [
                60.3852783,
                33.931828
              ],
              [
                60.396945,
                33.9365513
              ],
              [
                60.4005513,
                33.9373823
              ],
              [
                60.4149977,
                33.9409948
              ],
              [
                60.533076,
                34.0002495
              ],
              [
                60.5176034,
                34.0617567
              ],
              [
                60.5193415,
                34.0662727
              ],
              [
                60.5180749,
                34.0703647
              ],
              [
                60.51788,
                34.0724107
              ],
              [
                60.5179774,
                34.0752362
              ],
              [
                60.5194389,
                34.0772822
              ],
              [
                60.5187569,
                34.0811794
              ],
              [
                60.5191466,
                34.0826408
              ],
              [
                60.5204132,
                34.0860509
              ],
              [
                60.5203158,
                34.0902404
              ],
              [
                60.5209978,
                34.0932607
              ],
              [
                60.5224592,
                34.0955016
              ],
              [
                60.5210952,
                34.1009576
              ],
              [
                60.5226541,
                34.1065111
              ],
              [
                60.5256744,
                34.1100186
              ],
              [
                60.528305,
                34.1153772
              ],
              [
                60.5285973,
                34.1187872
              ],
              [
                60.5308666,
                34.1226471
              ],
              [
                60.5316176,
                34.1254124
              ],
              [
                60.533761,
                34.1284328
              ],
              [
                60.5338585,
                34.1341811
              ],
              [
                60.5351251,
                34.1396372
              ],
              [
                60.5363916,
                34.1436318
              ],
              [
                60.5369762,
                34.1486981
              ],
              [
                60.5374215,
                34.150697
              ],
              [
                60.537991,
                34.151212
              ],
              [
                60.538363,
                34.15184
              ],
              [
                60.538645,
                34.152204
              ],
              [
                60.539007,
                34.152323
              ],
              [
                60.5399,
                34.153008
              ],
              [
                60.540809,
                34.154076
              ],
              [
                60.541025,
                34.154717
              ],
              [
                60.541289,
                34.15517
              ],
              [
                60.541832,
                34.155828
              ],
              [
                60.543006,
                34.156298
              ],
              [
                60.543292,
                34.156559
              ],
              [
                60.543409,
                34.157441
              ],
              [
                60.54382,
                34.158399
              ],
              [
                60.544884,
                34.160104
              ],
              [
                60.546077,
                34.160466
              ],
              [
                60.546719,
                34.160967
              ],
              [
                60.547109,
                34.161365
              ],
              [
                60.54802,
                34.161922
              ],
              [
                60.548589,
                34.162359
              ],
              [
                60.549418,
                34.162901
              ],
              [
                60.550573,
                34.163371
              ],
              [
                60.551236,
                34.164082
              ],
              [
                60.551847,
                34.165385
              ],
              [
                60.552249,
                34.165871
              ],
              [
                60.553875,
                34.166998
              ],
              [
                60.554707,
                34.168353
              ],
              [
                60.554832,
                34.170323
              ],
              [
                60.555394,
                34.171126
              ],
              [
                60.555569,
                34.171677
              ],
              [
                60.555514,
                34.172402
              ],
              [
                60.555807,
                34.172746
              ],
              [
                60.55607,
                34.173517
              ],
              [
                60.556518,
                34.174452
              ],
              [
                60.557455,
                34.17597
              ],
              [
                60.557639,
                34.176199
              ],
              [
                60.557658,
                34.176567
              ],
              [
                60.557999,
                34.177489
              ],
              [
                60.558159,
                34.177698
              ],
              [
                60.558242,
                34.177995
              ],
              [
                60.55851,
                34.178499
              ],
              [
                60.558746,
                34.178725
              ],
              [
                60.558773,
                34.179007
              ],
              [
                60.558636,
                34.17934
              ],
              [
                60.558641,
                34.179654
              ],
              [
                60.558887,
                34.180163
              ],
              [
                60.558886,
                34.180485
              ],
              [
                60.558538,
                34.181745
              ],
              [
                60.558256,
                34.182089
              ],
              [
                60.558119,
                34.182517
              ],
              [
                60.558286,
                34.182797
              ],
              [
                60.558572,
                34.182935
              ],
              [
                60.558916,
                34.183538
              ],
              [
                60.558912,
                34.183874
              ],
              [
                60.558846,
                34.184107
              ],
              [
                60.55934,
                34.184823
              ],
              [
                60.560024,
                34.185332
              ],
              [
                60.56067,
                34.185693
              ],
              [
                60.56109,
                34.186065
              ],
              [
                60.561441,
                34.186613
              ],
              [
                60.561845,
                34.187612
              ],
              [
                60.562257,
                34.188304
              ],
              [
                60.562629,
                34.189086
              ],
              [
                60.563501,
                34.19001
              ],
              [
                60.565261,
                34.192074
              ],
              [
                60.565496,
                34.192557
              ],
              [
                60.565676,
                34.192708
              ],
              [
                60.566147,
                34.192799
              ],
              [
                60.566573,
                34.192786
              ],
              [
                60.567065,
                34.192893
              ],
              [
                60.567522,
                34.193112
              ],
              [
                60.567988,
                34.19342
              ],
              [
                60.568494,
                34.193571
              ],
              [
                60.570696,
                34.195585
              ],
              [
                60.57199,
                34.196867
              ],
              [
                60.572697,
                34.197463
              ],
              [
                60.573477,
                34.198268
              ],
              [
                60.573887,
                34.19877
              ],
              [
                60.574326,
                34.198905
              ],
              [
                60.575368,
                34.200042
              ],
              [
                60.576014,
                34.200248
              ],
              [
                60.57677,
                34.200385
              ],
              [
                60.577765,
                34.200883
              ],
              [
                60.578171,
                34.201315
              ],
              [
                60.578553,
                34.201496
              ],
              [
                60.578999,
                34.201628
              ],
              [
                60.579738,
                34.202442
              ],
              [
                60.580202,
                34.202718
              ],
              [
                60.580632,
                34.203423
              ],
              [
                60.580968,
                34.204227
              ],
              [
                60.581084,
                34.204663
              ],
              [
                60.581633,
                34.205335
              ],
              [
                60.581626,
                34.206246
              ],
              [
                60.581927,
                34.207174
              ],
              [
                60.582415,
                34.208358
              ],
              [
                60.582812,
                34.20885
              ],
              [
                60.583481,
                34.209106
              ],
              [
                60.584044,
                34.209449
              ],
              [
                60.584483,
                34.209869
              ],
              [
                60.584796,
                34.210841
              ],
              [
                60.585105,
                34.211402
              ],
              [
                60.585601,
                34.211818
              ],
              [
                60.585831,
                34.212179
              ],
              [
                60.585931,
                34.21266
              ],
              [
                60.586545,
                34.213094
              ],
              [
                60.5872,
                34.213307
              ],
              [
                60.587616,
                34.213355
              ],
              [
                60.588539,
                34.213804
              ],
              [
                60.588709,
                34.213799
              ],
              [
                60.588945,
                34.213862
              ],
              [
                60.589708,
                34.21382
              ],
              [
                60.590055,
                34.214027
              ],
              [
                60.590143,
                34.214187
              ],
              [
                60.590453,
                34.214471
              ],
              [
                60.590592,
                34.214482
              ],
              [
                60.590977,
                34.214771
              ],
              [
                60.590997,
                34.215028
              ],
              [
                60.591083,
                34.215145
              ],
              [
                60.591468,
                34.215337
              ],
              [
                60.591654,
                34.215492
              ],
              [
                60.59175,
                34.215903
              ],
              [
                60.591746,
                34.216401
              ],
              [
                60.6022896,
                34.2263901
              ],
              [
                60.6206949,
                34.2438248
              ],
              [
                60.6339581,
                34.2528679
              ],
              [
                60.6405898,
                34.2582938
              ],
              [
                60.6426294,
                34.2589513
              ],
              [
                60.644407,
                34.259816
              ],
              [
                60.645202,
                34.260147
              ],
              [
                60.645864,
                34.260778
              ],
              [
                60.646716,
                34.26107
              ],
              [
                60.647652,
                34.261249
              ],
              [
                60.64867,
                34.261371
              ],
              [
                60.649524,
                34.261287
              ],
              [
                60.650294,
                34.261615
              ],
              [
                60.6509395,
                34.2619545
              ],
              [
                60.651254,
                34.26212
              ],
              [
                60.652607,
                34.263176
              ],
              [
                60.653456,
                34.263742
              ],
              [
                60.65478,
                34.264476
              ],
              [
                60.655171,
                34.264901
              ],
              [
                60.65546,
                34.265381
              ],
              [
                60.657025,
                34.266399
              ],
              [
                60.65735,
                34.26711
              ],
              [
                60.657587,
                34.267258
              ],
              [
                60.657954,
                34.267302
              ],
              [
                60.659029,
                34.267235
              ],
              [
                60.65968,
                34.267426
              ],
              [
                60.661672,
                34.267809
              ],
              [
                60.663668,
                34.268786
              ],
              [
                60.664366,
                34.269084
              ],
              [
                60.664996,
                34.269618
              ],
              [
                60.665939,
                34.270763
              ],
              [
                60.666498,
                34.27113
              ],
              [
                60.668959,
                34.272035
              ],
              [
                60.66949,
                34.272504
              ],
              [
                60.669679,
                34.272857
              ],
              [
                60.670531,
                34.273789
              ],
              [
                60.671018,
                34.274473
              ],
              [
                60.6713,
                34.275018
              ],
              [
                60.671421,
                34.275392
              ],
              [
                60.671481,
                34.275952
              ],
              [
                60.671443,
                34.277219
              ],
              [
                60.671478,
                34.27783
              ],
              [
                60.671647,
                34.278862
              ],
              [
                60.671616,
                34.279389
              ],
              [
                60.671253,
                34.279574
              ],
              [
                60.670894,
                34.279996
              ],
              [
                60.670076,
                34.281337
              ],
              [
                60.669904,
                34.281867
              ],
              [
                60.670017,
                34.282671
              ],
              [
                60.670137,
                34.28315
              ],
              [
                60.671032,
                34.285968
              ],
              [
                60.670956,
                34.286574
              ],
              [
                60.67163,
                34.289187
              ],
              [
                60.671705,
                34.289315
              ],
              [
                60.6725059,
                34.2899628
              ],
              [
                60.6727811,
                34.290704
              ],
              [
                60.673001,
                34.291879
              ],
              [
                60.672799,
                34.29307
              ],
              [
                60.6730099,
                34.2937434
              ],
              [
                60.6753553,
                34.3025138
              ],
              [
                60.6830315,
                34.3086327
              ],
              [
                60.686496,
                34.310708
              ],
              [
                60.696298,
                34.310742
              ],
              [
                60.737434,
                34.307223
              ],
              [
                60.784324,
                34.310058
              ],
              [
                60.834018,
                34.310593
              ],
              [
                60.882301,
                34.303396
              ],
              [
                60.918373,
                34.304756
              ],
              [
                60.897928,
                34.324435
              ],
              [
                60.897209,
                34.32447
              ],
              [
                60.896348,
                34.324638
              ],
              [
                60.896256,
                34.325084
              ],
              [
                60.89628,
                34.325435
              ],
              [
                60.896177,
                34.325554
              ],
              [
                60.89602,
                34.325901
              ],
              [
                60.895609,
                34.327118
              ],
              [
                60.895162,
                34.327661
              ],
              [
                60.895114,
                34.327844
              ],
              [
                60.895222,
                34.328838
              ],
              [
                60.895552,
                34.329663
              ],
              [
                60.895889,
                34.329988
              ],
              [
                60.896126,
                34.330093
              ],
              [
                60.896321,
                34.33031
              ],
              [
                60.896519,
                34.330843
              ],
              [
                60.896515,
                34.330991
              ],
              [
                60.896418,
                34.331084
              ],
              [
                60.896218,
                34.331151
              ],
              [
                60.895706,
                34.331618
              ],
              [
                60.895885,
                34.332768
              ],
              [
                60.895667,
                34.333301
              ],
              [
                60.89545,
                34.333568
              ],
              [
                60.895282,
                34.333712
              ],
              [
                60.895069,
                34.33375
              ],
              [
                60.894855,
                34.333588
              ],
              [
                60.894609,
                34.333379
              ],
              [
                60.894124,
                34.332767
              ],
              [
                60.893768,
                34.332152
              ],
              [
                60.893392,
                34.332026
              ],
              [
                60.89302,
                34.332058
              ],
              [
                60.892615,
                34.332001
              ],
              [
                60.8913311,
                34.332597
              ],
              [
                60.8886348,
                34.3358766
              ],
              [
                60.8871794,
                34.3380256
              ],
              [
                60.886175,
                34.3400047
              ],
              [
                60.885126,
                34.3409121
              ],
              [
                60.8848989,
                34.3409123
              ],
              [
                60.884278,
                34.3411503
              ],
              [
                60.882934,
                34.342794
              ],
              [
                60.883053,
                34.342991
              ],
              [
                60.88313,
                34.343496
              ],
              [
                60.883115,
                34.343762
              ],
              [
                60.883044,
                34.343954
              ],
              [
                60.882832,
                34.344268
              ],
              [
                60.882823,
                34.344506
              ],
              [
                60.882943,
                34.34497
              ],
              [
                60.882706,
                34.345242
              ],
              [
                60.88216,
                34.345634
              ],
              [
                60.881894,
                34.34595
              ],
              [
                60.881552,
                34.346687
              ],
              [
                60.88137,
                34.347275
              ],
              [
                60.881314,
                34.347877
              ],
              [
                60.881097,
                34.348308
              ],
              [
                60.881021,
                34.348134
              ],
              [
                60.8811,
                34.347659
              ],
              [
                60.881017,
                34.347423
              ],
              [
                60.880803,
                34.347124
              ],
              [
                60.880323,
                34.346992
              ],
              [
                60.8798693,
                34.3469798
              ],
              [
                60.879247,
                34.3468787
              ],
              [
                60.8788333,
                34.3473618
              ],
              [
                60.878344,
                34.347256
              ],
              [
                60.877599,
                34.347255
              ],
              [
                60.877116,
                34.347501
              ],
              [
                60.876647,
                34.347542
              ],
              [
                60.87622,
                34.347322
              ],
              [
                60.875766,
                34.347268
              ],
              [
                60.874213,
                34.347791
              ],
              [
                60.873756,
                34.347714
              ],
              [
                60.873546,
                34.347737
              ],
              [
                60.873159,
                34.347841
              ],
              [
                60.872367,
                34.347925
              ],
              [
                60.87168,
                34.348169
              ],
              [
                60.871173,
                34.348205
              ],
              [
                60.871119,
                34.348253
              ],
              [
                60.871107,
                34.348762
              ],
              [
                60.871328,
                34.34917
              ],
              [
                60.871165,
                34.349311
              ],
              [
                60.870672,
                34.349489
              ],
              [
                60.870213,
                34.349736
              ],
              [
                60.869843,
                34.350063
              ],
              [
                60.8707662,
                34.3525624
              ],
              [
                60.8707587,
                34.3559104
              ],
              [
                60.8695632,
                34.3572285
              ],
              [
                60.8689077,
                34.3575241
              ],
              [
                60.867688,
                34.357781
              ],
              [
                60.867553,
                34.357848
              ],
              [
                60.866977,
                34.35796
              ],
              [
                60.866873,
                34.358122
              ],
              [
                60.866682,
                34.358843
              ],
              [
                60.866648,
                34.359337
              ],
              [
                60.866729,
                34.359582
              ],
              [
                60.866703,
                34.359828
              ],
              [
                60.866638,
                34.359959
              ],
              [
                60.866412,
                34.360229
              ],
              [
                60.865904,
                34.360118
              ],
              [
                60.865742,
                34.360142
              ],
              [
                60.865206,
                34.360597
              ],
              [
                60.864972,
                34.36065
              ],
              [
                60.86458,
                34.360177
              ],
              [
                60.864361,
                34.360145
              ],
              [
                60.863606,
                34.36046
              ],
              [
                60.863436,
                34.360568
              ],
              [
                60.863157,
                34.360859
              ],
              [
                60.86302,
                34.361051
              ],
              [
                60.863128,
                34.361403
              ],
              [
                60.863114,
                34.361715
              ],
              [
                60.862789,
                34.362625
              ],
              [
                60.862773,
                34.362785
              ],
              [
                60.862875,
                34.363075
              ],
              [
                60.86281,
                34.363347
              ],
              [
                60.862718,
                34.363425
              ],
              [
                60.862153,
                34.363493
              ],
              [
                60.862001,
                34.363656
              ],
              [
                60.861839,
                34.363677
              ],
              [
                60.86135,
                34.363523
              ],
              [
                60.861216,
                34.363526
              ],
              [
                60.861028,
                34.363739
              ],
              [
                60.861261,
                34.364294
              ],
              [
                60.861535,
                34.364667
              ],
              [
                60.861722,
                34.365178
              ],
              [
                60.861714,
                34.365393
              ],
              [
                60.861604,
                34.365454
              ],
              [
                60.86078,
                34.365477
              ],
              [
                60.860625,
                34.365566
              ],
              [
                60.860469,
                34.36582
              ],
              [
                60.860462,
                34.366258
              ],
              [
                60.860411,
                34.366356
              ],
              [
                60.859693,
                34.366359
              ],
              [
                60.859273,
                34.366492
              ],
              [
                60.859224,
                34.366586
              ],
              [
                60.859143,
                34.367348
              ],
              [
                60.85893,
                34.367702
              ],
              [
                60.858834,
                34.367783
              ],
              [
                60.858531,
                34.36776
              ],
              [
                60.857176,
                34.367884
              ],
              [
                60.85658,
                34.367852
              ],
              [
                60.855985,
                34.367942
              ],
              [
                60.855011,
                34.367854
              ],
              [
                60.854229,
                34.367919
              ],
              [
                60.853923,
                34.367987
              ],
              [
                60.853466,
                34.367994
              ],
              [
                60.852514,
                34.367959
              ],
              [
                60.851906,
                34.367834
              ],
              [
                60.850855,
                34.367905
              ],
              [
                60.850088,
                34.368068
              ],
              [
                60.849798,
                34.368217
              ],
              [
                60.849631,
                34.368448
              ],
              [
                60.849552,
                34.368837
              ],
              [
                60.849302,
                34.369298
              ],
              [
                60.84887,
                34.370411
              ],
              [
                60.848547,
                34.370733
              ],
              [
                60.848311,
                34.371566
              ],
              [
                60.847872,
                34.372138
              ],
              [
                60.8479,
                34.372325
              ],
              [
                60.848172,
                34.373021
              ],
              [
                60.848487,
                34.373777
              ],
              [
                60.848704,
                34.374151
              ],
              [
                60.848838,
                34.374644
              ],
              [
                60.849186,
                34.375187
              ],
              [
                60.849283,
                34.37633
              ],
              [
                60.849752,
                34.377088
              ],
              [
                60.849885,
                34.377979
              ],
              [
                60.850123,
                34.378823
              ],
              [
                60.850143,
                34.37971
              ],
              [
                60.85007,
                34.380362
              ],
              [
                60.85026,
                34.380765
              ],
              [
                60.850057,
                34.381226
              ],
              [
                60.849864,
                34.382122
              ],
              [
                60.849786,
                34.382199
              ],
              [
                60.849626,
                34.382239
              ],
              [
                60.84863,
                34.382284
              ],
              [
                60.848429,
                34.38256
              ],
              [
                60.848475,
                34.383334
              ],
              [
                60.848387,
                34.38342
              ],
              [
                60.847742,
                34.383749
              ],
              [
                60.847539,
                34.384003
              ],
              [
                60.847094,
                34.384271
              ],
              [
                60.846922,
                34.385567
              ],
              [
                60.846833,
                34.385844
              ],
              [
                60.846562,
                34.386319
              ],
              [
                60.846383,
                34.386504
              ],
              [
                60.846342,
                34.386803
              ],
              [
                60.846406,
                34.387161
              ],
              [
                60.846715,
                34.387531
              ],
              [
                60.84677,
                34.387664
              ],
              [
                60.846782,
                34.38815
              ],
              [
                60.84672,
                34.388345
              ],
              [
                60.846497,
                34.38854
              ],
              [
                60.846038,
                34.389107
              ],
              [
                60.845898,
                34.38935
              ],
              [
                60.845526,
                34.389677
              ],
              [
                60.845453,
                34.389822
              ],
              [
                60.845365,
                34.390279
              ],
              [
                60.845919,
                34.391202
              ],
              [
                60.846072,
                34.391617
              ],
              [
                60.846062,
                34.391701
              ],
              [
                60.845741,
                34.392108
              ],
              [
                60.84546,
                34.39224
              ],
              [
                60.845241,
                34.392516
              ],
              [
                60.84445,
                34.393185
              ],
              [
                60.844279,
                34.393253
              ],
              [
                60.844024,
                34.393207
              ],
              [
                60.843867,
                34.393252
              ],
              [
                60.843575,
                34.393453
              ],
              [
                60.843514,
                34.393647
              ],
              [
                60.843684,
                34.394272
              ],
              [
                60.843704,
                34.394407
              ],
              [
                60.843653,
                34.394567
              ],
              [
                60.843077,
                34.394697
              ],
              [
                60.842895,
                34.394781
              ],
              [
                60.84265,
                34.394931
              ],
              [
                60.842321,
                34.395293
              ],
              [
                60.842322,
                34.3955
              ],
              [
                60.842141,
                34.395985
              ],
              [
                60.842237,
                34.396238
              ],
              [
                60.842413,
                34.396467
              ],
              [
                60.842292,
                34.396704
              ],
              [
                60.841432,
                34.397313
              ],
              [
                60.840365,
                34.397751
              ],
              [
                60.84003,
                34.398003
              ],
              [
                60.839882,
                34.398373
              ],
              [
                60.839699,
                34.398608
              ],
              [
                60.839662,
                34.398782
              ],
              [
                60.839719,
                34.399014
              ],
              [
                60.840053,
                34.399636
              ],
              [
                60.840093,
                34.399952
              ],
              [
                60.839557,
                34.400275
              ],
              [
                60.839164,
                34.400381
              ],
              [
                60.838638,
                34.40101
              ],
              [
                60.838627,
                34.401124
              ],
              [
                60.838804,
                34.401518
              ],
              [
                60.838769,
                34.401684
              ],
              [
                60.838616,
                34.401803
              ],
              [
                60.838169,
                34.401954
              ],
              [
                60.838074,
                34.402041
              ],
              [
                60.838103,
                34.40237
              ],
              [
                60.838289,
                34.402496
              ],
              [
                60.838651,
                34.403053
              ],
              [
                60.838753,
                34.403117
              ],
              [
                60.839318,
                34.403183
              ],
              [
                60.840387,
                34.403463
              ],
              [
                60.840937,
                34.403783
              ],
              [
                60.841111,
                34.403965
              ],
              [
                60.841367,
                34.404506
              ],
              [
                60.842705,
                34.40504
              ],
              [
                60.843687,
                34.405856
              ],
              [
                60.843833,
                34.406143
              ],
              [
                60.843893,
                34.406706
              ],
              [
                60.843873,
                34.40705
              ],
              [
                60.843754,
                34.407548
              ],
              [
                60.843599,
                34.407853
              ],
              [
                60.8415126,
                34.4083614
              ],
              [
                60.8291161,
                34.4126009
              ],
              [
                60.8135318,
                34.4193013
              ],
              [
                60.8057212,
                34.4206111
              ],
              [
                60.7970094,
                34.4205757
              ],
              [
                60.7901859,
                34.4178852
              ],
              [
                60.7631921,
                34.4250008
              ],
              [
                60.7551234,
                34.4179211
              ],
              [
                60.7300185,
                34.4182392
              ],
              [
                60.7083886,
                34.419939
              ],
              [
                60.7008361,
                34.4163275
              ],
              [
                60.6901073,
                34.413212
              ],
              [
                60.6845283,
                34.4187349
              ],
              [
                60.6825536,
                34.4231959
              ],
              [
                60.6798934,
                34.4461316
              ],
              [
                60.6655591,
                34.4554039
              ],
              [
                60.6368916,
                34.4483263
              ],
              [
                60.6308835,
                34.4548377
              ],
              [
                60.6254899,
                34.4614591
              ],
              [
                60.6092324,
                34.4528183
              ],
              [
                60.593853,
                34.4480124
              ],
              [
                60.5761476,
                34.4653926
              ],
              [
                60.569112,
                34.4660229
              ],
              [
                60.5555352,
                34.4659455
              ],
              [
                60.5524234,
                34.4693433
              ],
              [
                60.5490868,
                34.4737321
              ],
              [
                60.5433733,
                34.4851179
              ],
              [
                60.5363845,
                34.5009689
              ],
              [
                60.521989,
                34.5192981
              ],
              [
                60.5233869,
                34.5339695
              ],
              [
                60.5164715,
                34.5417729
              ],
              [
                60.4955082,
                34.5663462
              ],
              [
                60.4707817,
                34.578582
              ],
              [
                60.4521976,
                34.5856474
              ],
              [
                60.439825,
                34.5932969
              ],
              [
                60.4217902,
                34.6133933
              ],
              [
                60.4004287,
                34.6248388
              ],
              [
                60.4028812,
                34.6305707
              ],
              [
                60.4096984,
                34.6435181
              ],
              [
                60.367717,
                34.6394308
              ],
              [
                60.3576849,
                34.6656879
              ],
              [
                60.3528784,
                34.6748646
              ],
              [
                60.3430937,
                34.684605
              ],
              [
                60.3411092,
                34.6891627
              ],
              [
                60.3382383,
                34.6978667
              ],
              [
                60.3375982,
                34.7005758
              ],
              [
                60.3288459,
                34.7083159
              ],
              [
                60.3225768,
                34.7146543
              ],
              [
                60.3129672,
                34.7226379
              ],
              [
                60.3012084,
                34.7275054
              ],
              [
                60.3016376,
                34.7337834
              ],
              [
                60.3050211,
                34.7397807
              ],
              [
                60.3022365,
                34.7416121
              ],
              [
                60.2929233,
                34.7493079
              ],
              [
                60.2883338,
                34.7552237
              ],
              [
                60.2849006,
                34.7648841
              ],
              [
                60.2857589,
                34.7665058
              ],
              [
                60.2840423,
                34.7713002
              ],
              [
                60.2752017,
                34.7738383
              ],
              [
                60.2715968,
                34.7765174
              ],
              [
                60.2641871,
                34.7871297
              ],
              [
                60.2562331,
                34.7879376
              ],
              [
                60.2530574,
                34.7911801
              ],
              [
                60.2455043,
                34.7951977
              ],
              [
                60.2395817,
                34.800625
              ],
              [
                60.2433585,
                34.8106323
              ],
              [
                60.2436374,
                34.8208506
              ],
              [
                60.2186393,
                34.8529038
              ],
              [
                60.2084254,
                34.8695951
              ],
              [
                60.2024417,
                34.879684
              ],
              [
                60.1946312,
                34.8808439
              ],
              [
                60.1840925,
                34.8797702
              ],
              [
                60.1750373,
                34.8811432
              ],
              [
                60.1723625,
                34.8851241
              ],
              [
                60.1709174,
                34.8967025
              ],
              [
                60.1738357,
                34.9176781
              ],
              [
                60.1758956,
                34.9236601
              ],
              [
                60.1805302,
                34.9282345
              ],
              [
                60.1770114,
                34.9337933
              ],
              [
                60.1686667,
                34.9399794
              ],
              [
                60.157028,
                34.947349
              ],
              [
                60.1424064,
                34.9529434
              ],
              [
                60.1284953,
                34.9543903
              ],
              [
                60.1192474,
                34.9543901
              ],
              [
                60.1147903,
                34.9558112
              ],
              [
                60.1080939,
                34.957852
              ],
              [
                60.0965059,
                34.9653273
              ],
              [
                60.08011,
                34.9741157
              ],
              [
                60.0512692,
                34.9906289
              ],
              [
                60.036163,
                35.00216
              ],
              [
                60.013686,
                34.9882786
              ],
              [
                60.003695,
                34.9828716
              ],
              [
                59.9861389,
                34.9829164
              ],
              [
                59.9705028,
                34.9878863
              ],
              [
                59.9632946,
                34.9885098
              ],
              [
                59.9528481,
                34.9891913
              ],
              [
                59.9442386,
                34.9902068
              ],
              [
                59.9371755,
                34.99074
              ],
              [
                59.924459,
                34.9905672
              ],
              [
                59.9210396,
                34.9890073
              ],
              [
                59.8818691,
                34.9703194
              ],
              [
                59.8802023,
                34.9694896
              ],
              [
                59.879369,
                34.9686506
              ],
              [
                59.8587827,
                34.9535949
              ],
              [
                59.8554494,
                34.9524854
              ],
              [
                59.8521162,
                34.9508166
              ],
              [
                59.8188829,
                34.9177291
              ],
              [
                59.8174895,
                34.9157806
              ],
              [
                59.8158226,
                34.9141206
              ],
              [
                59.820166,
                34.8932362
              ],
              [
                59.8193324,
                34.8921265
              ],
              [
                59.8193324,
                34.8915671
              ],
              [
                59.8184992,
                34.8907282
              ],
              [
                59.8171058,
                34.8879494
              ],
              [
                59.8178097,
                34.8721304
              ],
              [
                59.7954937,
                34.8670602
              ],
              [
                59.7676846,
                34.8470578
              ],
              [
                59.7491452,
                34.8352231
              ],
              [
                59.7604748,
                34.8202864
              ],
              [
                59.7642514,
                34.8011184
              ],
              [
                59.7582051,
                34.794891
              ],
              [
                59.7562581,
                34.7943405
              ],
              [
                59.7551448,
                34.7943405
              ],
              [
                59.7543116,
                34.7946203
              ],
              [
                59.7540385,
                34.7943405
              ],
              [
                59.7512584,
                34.794891
              ],
              [
                59.7509783,
                34.7951708
              ],
              [
                59.7479251,
                34.7951708
              ],
              [
                59.7476451,
                34.7954505
              ],
              [
                59.7394919,
                34.7999614
              ],
              [
                59.7347722,
                34.8005119
              ],
              [
                59.7339386,
                34.8007917
              ],
              [
                59.731439,
                34.8007917
              ],
              [
                59.7308787,
                34.8010714
              ],
              [
                59.729492,
                34.8010714
              ],
              [
                59.7283787,
                34.8013511
              ],
              [
                59.7267119,
                34.8013511
              ],
              [
                59.7256056,
                34.8016309
              ],
              [
                59.7250455,
                34.8016309
              ],
              [
                59.711723,
                34.8076022
              ],
              [
                59.6935269,
                34.8360685
              ],
              [
                59.6619412,
                34.8408589
              ],
              [
                59.659201,
                34.8495268
              ],
              [
                59.6354441,
                34.8663771
              ],
              [
                59.6340507,
                34.8666566
              ],
              [
                59.6315511,
                34.8666566
              ],
              [
                59.6296112,
                34.8669362
              ],
              [
                59.6279444,
                34.8669362
              ],
              [
                59.6058683,
                34.8494653
              ],
              [
                59.6033682,
                34.8494652
              ],
              [
                59.5889286,
                34.8525138
              ],
              [
                59.587262,
                34.8533525
              ],
              [
                59.5737072,
                34.8464943
              ],
              [
                59.560661,
                34.8487483
              ],
              [
                59.5335132,
                34.8583821
              ],
              [
                59.5135038,
                34.8562952
              ],
              [
                59.5098218,
                34.854378
              ],
              [
                59.4798413,
                34.8321059
              ],
              [
                59.4776142,
                34.8268279
              ],
              [
                59.4773412,
                34.8248791
              ],
              [
                59.4770611,
                34.8229392
              ],
              [
                59.476781,
                34.8207106
              ],
              [
                59.4765079,
                34.8184911
              ],
              [
                59.4762279,
                34.8159919
              ],
              [
                59.4765079,
                34.8123829
              ],
              [
                59.473457,
                34.8042194
              ],
              [
                59.4800877,
                34.7783665
              ],
              [
                59.4985196,
                34.771794
              ],
              [
                59.5131903,
                34.7503988
              ],
              [
                59.5133912,
                34.7495976
              ],
              [
                59.5143035,
                34.7459604
              ],
              [
                59.5471992,
                34.7210984
              ],
              [
                59.5561978,
                34.7069049
              ],
              [
                59.5769217,
                34.7034074
              ],
              [
                59.5774749,
                34.6986879
              ],
              [
                59.5777551,
                34.6981286
              ],
              [
                59.5774749,
                34.6975691
              ],
              [
                59.6044571,
                34.6674517
              ],
              [
                59.6041769,
                34.6666125
              ],
              [
                59.6033437,
                34.6649519
              ],
              [
                59.6002905,
                34.658003
              ],
              [
                59.5859538,
                34.6458256
              ],
              [
                59.5771405,
                34.6349031
              ],
              [
                59.5781704,
                34.6219079
              ],
              [
                59.5758908,
                34.6121256
              ],
              [
                59.574224,
                34.6098961
              ],
              [
                59.5719973,
                34.6054547
              ],
              [
                59.5678308,
                34.5932322
              ],
              [
                59.5678308,
                34.5898922
              ],
              [
                59.5761539,
                34.5874322
              ],
              [
                59.5775403,
                34.5779811
              ],
              [
                59.5742704,
                34.5581638
              ],
              [
                59.5574313,
                34.5492703
              ],
              [
                59.5372317,
                34.5409947
              ],
              [
                59.5369516,
                34.5404352
              ],
              [
                59.5366786,
                34.5393343
              ],
              [
                59.5194457,
                34.5408338
              ],
              [
                59.5086123,
                34.5352844
              ],
              [
                59.507506,
                34.534725
              ],
              [
                59.4738,
                34.5218334
              ],
              [
                59.4262995,
                34.5213304
              ],
              [
                59.4257461,
                34.5213304
              ],
              [
                59.4249128,
                34.5210511
              ],
              [
                59.4237995,
                34.5207807
              ],
              [
                59.4232463,
                34.5205014
              ],
              [
                59.4232464,
                34.5188343
              ],
              [
                59.4229662,
                34.5179961
              ],
              [
                59.4236749,
                34.4788265
              ],
              [
                59.4394677,
                34.4624101
              ],
              [
                59.4483941,
                34.4154075
              ],
              [
                59.4250481,
                34.3870799
              ],
              [
                59.4161217,
                34.3598764
              ],
              [
                59.4280648,
                34.3416407
              ],
              [
                59.3919126,
                34.2341008
              ],
              [
                59.3855031,
                34.2108929
              ],
              [
                59.3625637,
                34.1941978
              ],
              [
                59.3587872,
                34.1791458
              ],
              [
                59.363937,
                34.1456241
              ],
              [
                59.3764455,
                34.1171722
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555006,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خوشاب",
          "name:en": "Khoshab County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q6402482",
          "wikipedia": "fa:شهرستان خوشاب"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.5796359,
                36.4422505
              ],
              [
                57.5808674,
                36.4424524
              ],
              [
                57.6094036,
                36.4338614
              ],
              [
                57.6210515,
                36.4363128
              ],
              [
                57.6432798,
                36.4410602
              ],
              [
                57.6503274,
                36.4335754
              ],
              [
                57.6572799,
                36.4355778
              ],
              [
                57.6607989,
                36.4382708
              ],
              [
                57.6712703,
                36.4535985
              ],
              [
                57.6787376,
                36.4557386
              ],
              [
                57.6878607,
                36.4543879
              ],
              [
                57.686031,
                36.4498919
              ],
              [
                57.6839729,
                36.4407568
              ],
              [
                57.6710125,
                36.4248741
              ],
              [
                57.6648327,
                36.4168624
              ],
              [
                57.6771923,
                36.4140996
              ],
              [
                57.6868054,
                36.413547
              ],
              [
                57.6964184,
                36.4102314
              ],
              [
                57.7132412,
                36.4187963
              ],
              [
                57.7202796,
                36.4101621
              ],
              [
                57.722597,
                36.4012509
              ],
              [
                57.7130698,
                36.3937204
              ],
              [
                57.7019977,
                36.3890221
              ],
              [
                57.6994228,
                36.3789337
              ],
              [
                57.6960754,
                36.376446
              ],
              [
                57.6965045,
                36.3737508
              ],
              [
                57.6960751,
                36.3673928
              ],
              [
                57.7158114,
                36.3640971
              ],
              [
                57.7393338,
                36.3809379
              ],
              [
                57.7641904,
                36.3817589
              ],
              [
                57.7913473,
                36.3584074
              ],
              [
                57.8008734,
                36.3506267
              ],
              [
                57.850716,
                36.3435726
              ],
              [
                57.8538321,
                36.340572
              ],
              [
                57.8647326,
                36.329371
              ],
              [
                57.8583812,
                36.3255677
              ],
              [
                57.8618143,
                36.316301
              ],
              [
                57.8710841,
                36.3138112
              ],
              [
                57.8775214,
                36.3127737
              ],
              [
                57.8874778,
                36.3129812
              ],
              [
                57.9025192,
                36.3099245
              ],
              [
                57.9170973,
                36.314815
              ],
              [
                57.9315369,
                36.3168517
              ],
              [
                57.9449734,
                36.3128173
              ],
              [
                57.945807,
                36.3128173
              ],
              [
                57.9483066,
                36.3119886
              ],
              [
                57.9496934,
                36.3119885
              ],
              [
                57.9527465,
                36.311151
              ],
              [
                57.9541399,
                36.311151
              ],
              [
                57.9546935,
                36.3108717
              ],
              [
                57.9555267,
                36.3108717
              ],
              [
                57.9560799,
                36.3105925
              ],
              [
                57.9851309,
                36.2887287
              ],
              [
                57.9892978,
                36.2881701
              ],
              [
                57.9898575,
                36.2881701
              ],
              [
                57.9906911,
                36.2878908
              ],
              [
                57.9917974,
                36.2878908
              ],
              [
                57.9920775,
                36.2876115
              ],
              [
                58.0013158,
                36.2844278
              ],
              [
                58.004386,
                36.2820793
              ],
              [
                58.0061065,
                36.2801406
              ],
              [
                58.0074933,
                36.2798613
              ],
              [
                58.0477207,
                36.2636776
              ],
              [
                58.053554,
                36.2636776
              ],
              [
                58.0538341,
                36.2633982
              ],
              [
                58.0552208,
                36.2633983
              ],
              [
                58.0574475,
                36.2625691
              ],
              [
                58.1131518,
                36.2578039
              ],
              [
                58.1205082,
                36.2602966
              ],
              [
                58.129666,
                36.262745
              ],
              [
                58.1438898,
                36.2612193
              ],
              [
                58.1525415,
                36.2603862
              ],
              [
                58.1605164,
                36.2595643
              ],
              [
                58.1605354,
                36.2603542
              ],
              [
                58.171663,
                36.2636349
              ],
              [
                58.1879592,
                36.2601721
              ],
              [
                58.1935731,
                36.251345
              ],
              [
                58.1998586,
                36.2581858
              ],
              [
                58.209095,
                36.2682872
              ],
              [
                58.2096688,
                36.2779004
              ],
              [
                58.205831,
                36.2817594
              ],
              [
                58.1966396,
                36.2867646
              ],
              [
                58.1940218,
                36.2925068
              ],
              [
                58.193593,
                36.2966573
              ],
              [
                58.1962963,
                36.3101457
              ],
              [
                58.1863402,
                36.3546747
              ],
              [
                58.1834219,
                36.3709865
              ],
              [
                58.1853101,
                36.3896442
              ],
              [
                58.1745978,
                36.4224397
              ],
              [
                58.1902885,
                36.4765154
              ],
              [
                58.2203289,
                36.5021855
              ],
              [
                58.2160374,
                36.511844
              ],
              [
                58.2271956,
                36.5181902
              ],
              [
                58.2411001,
                36.5319849
              ],
              [
                58.2448768,
                36.5348813
              ],
              [
                58.2505416,
                36.5402604
              ],
              [
                58.2547473,
                36.5453632
              ],
              [
                58.2619571,
                36.5512242
              ],
              [
                58.268893,
                36.5551161
              ],
              [
                58.2784428,
                36.5592053
              ],
              [
                58.2444473,
                36.571493
              ],
              [
                58.2368943,
                36.5748706
              ],
              [
                58.2273671,
                36.5909982
              ],
              [
                58.2136343,
                36.619799
              ],
              [
                58.2007597,
                36.6326112
              ],
              [
                58.2399324,
                36.6569572
              ],
              [
                58.234313,
                36.6683524
              ],
              [
                58.2353134,
                36.6780162
              ],
              [
                58.2378134,
                36.6824645
              ],
              [
                58.2389196,
                36.6841303
              ],
              [
                58.240313,
                36.687462
              ],
              [
                58.2433662,
                36.6916311
              ],
              [
                58.2545928,
                36.6950166
              ],
              [
                58.2681877,
                36.6940752
              ],
              [
                58.2684607,
                36.6946245
              ],
              [
                58.268827,
                36.6951151
              ],
              [
                58.2773207,
                36.7000813
              ],
              [
                58.2835003,
                36.7102657
              ],
              [
                58.283924,
                36.7175227
              ],
              [
                58.2842041,
                36.7186393
              ],
              [
                58.2793725,
                36.7263927
              ],
              [
                58.2788127,
                36.7272211
              ],
              [
                58.2760393,
                36.7280585
              ],
              [
                58.2750594,
                36.7324611
              ],
              [
                58.2744992,
                36.7327401
              ],
              [
                58.273946,
                36.7324611
              ],
              [
                58.273666,
                36.7327402
              ],
              [
                58.2733925,
                36.7324611
              ],
              [
                58.2728324,
                36.7327401
              ],
              [
                58.271719,
                36.732461
              ],
              [
                58.2644994,
                36.7324611
              ],
              [
                58.2636662,
                36.7327402
              ],
              [
                58.2592192,
                36.7327401
              ],
              [
                58.2578329,
                36.7330193
              ],
              [
                58.2511663,
                36.7330193
              ],
              [
                58.2497796,
                36.7327402
              ],
              [
                58.2483862,
                36.7327402
              ],
              [
                58.2475529,
                36.7324611
              ],
              [
                58.2428329,
                36.7324612
              ],
              [
                58.2411665,
                36.7327402
              ],
              [
                58.2372797,
                36.7327402
              ],
              [
                58.2364465,
                36.7330194
              ],
              [
                58.2350531,
                36.7330193
              ],
              [
                58.2297728,
                36.7341269
              ],
              [
                58.2289396,
                36.7344059
              ],
              [
                58.2278331,
                36.734406
              ],
              [
                58.2269998,
                36.7346851
              ],
              [
                58.2256064,
                36.734685
              ],
              [
                58.2222731,
                36.7360717
              ],
              [
                58.2188134,
                36.7394491
              ],
              [
                58.2186125,
                36.7460373
              ],
              [
                58.2247923,
                36.7498886
              ],
              [
                58.2478508,
                36.7493184
              ],
              [
                58.2492442,
                36.7545949
              ],
              [
                58.2479927,
                36.7623395
              ],
              [
                58.2496591,
                36.7681649
              ],
              [
                58.2475743,
                36.7775503
              ],
              [
                58.2314068,
                36.7877177
              ],
              [
                58.2316868,
                36.7885461
              ],
              [
                58.2311266,
                36.7907702
              ],
              [
                58.228627,
                36.7916077
              ],
              [
                58.2277934,
                36.7916077
              ],
              [
                58.2222401,
                36.7938318
              ],
              [
                58.211127,
                36.8016115
              ],
              [
                58.2086022,
                36.8020402
              ],
              [
                58.2069353,
                36.8039852
              ],
              [
                58.2027322,
                36.8030523
              ],
              [
                58.2002321,
                36.8049974
              ],
              [
                58.1826374,
                36.8109903
              ],
              [
                58.1818042,
                36.8134848
              ],
              [
                58.1726933,
                36.8254215
              ],
              [
                58.1832143,
                36.8348847
              ],
              [
                58.1810187,
                36.8509172
              ],
              [
                58.1870793,
                36.8551981
              ],
              [
                58.1867992,
                36.858809
              ],
              [
                58.196349,
                36.8657028
              ],
              [
                58.2022237,
                36.8692028
              ],
              [
                58.2065856,
                36.8767033
              ],
              [
                58.2110353,
                36.8790485
              ],
              [
                58.2049671,
                36.8922868
              ],
              [
                58.1939046,
                36.8894989
              ],
              [
                58.166099,
                36.8826335
              ],
              [
                58.1543878,
                36.8782624
              ],
              [
                58.142399,
                36.8740469
              ],
              [
                58.1303191,
                36.8715383
              ],
              [
                58.1099528,
                36.8669799
              ],
              [
                58.0925396,
                36.8628166
              ],
              [
                58.0815189,
                36.8601427
              ],
              [
                58.0761505,
                36.8588681
              ],
              [
                58.0781281,
                36.8542795
              ],
              [
                58.0819273,
                36.8455426
              ],
              [
                58.0850172,
                36.8392403
              ],
              [
                58.0898663,
                36.8279743
              ],
              [
                58.0943261,
                36.8176761
              ],
              [
                58.0969856,
                36.8111915
              ],
              [
                58.104182,
                36.8071776
              ],
              [
                58.1068826,
                36.8057628
              ],
              [
                58.1086452,
                36.8045164
              ],
              [
                58.1216214,
                36.7893409
              ],
              [
                58.1273054,
                36.7829016
              ],
              [
                58.128386,
                36.7744515
              ],
              [
                58.1282574,
                36.7683822
              ],
              [
                58.1246573,
                36.7664635
              ],
              [
                58.1079766,
                36.7584848
              ],
              [
                58.1006813,
                36.7532927
              ],
              [
                58.0957442,
                36.7481638
              ],
              [
                58.0995655,
                36.7407756
              ],
              [
                58.1010675,
                36.7371302
              ],
              [
                58.095102,
                36.7305269
              ],
              [
                58.0868625,
                36.723785
              ],
              [
                58.0817127,
                36.7177307
              ],
              [
                58.0798207,
                36.716483
              ],
              [
                58.0872917,
                36.7121921
              ],
              [
                58.0914545,
                36.7102655
              ],
              [
                58.0951775,
                36.7094058
              ],
              [
                58.0938379,
                36.7032503
              ],
              [
                58.094115,
                36.6976384
              ],
              [
                58.0819273,
                36.6907904
              ],
              [
                58.075962,
                36.6887944
              ],
              [
                58.0761337,
                36.687177
              ],
              [
                58.0796095,
                36.6843552
              ],
              [
                58.083558,
                36.6816705
              ],
              [
                58.0875492,
                36.6812231
              ],
              [
                58.0884504,
                36.678573
              ],
              [
                58.0863771,
                36.6753471
              ],
              [
                58.081157,
                36.6724085
              ],
              [
                58.0794382,
                36.6694516
              ],
              [
                58.0750608,
                36.6637373
              ],
              [
                58.0709343,
                36.6609173
              ],
              [
                58.0686664,
                36.6543732
              ],
              [
                58.066083,
                36.6497783
              ],
              [
                58.0658776,
                36.6459976
              ],
              [
                58.0709838,
                36.6414269
              ],
              [
                58.0750178,
                36.6395674
              ],
              [
                58.0765628,
                36.6363993
              ],
              [
                58.0812835,
                36.6330933
              ],
              [
                58.0839442,
                36.6299249
              ],
              [
                58.083433,
                36.6280121
              ],
              [
                58.0787086,
                36.6228988
              ],
              [
                58.0727004,
                36.6181456
              ],
              [
                58.068881,
                36.6116425
              ],
              [
                58.0637891,
                36.6088154
              ],
              [
                58.0376651,
                36.6010129
              ],
              [
                58.0190041,
                36.5951521
              ],
              [
                57.9996703,
                36.5814981
              ],
              [
                57.9884147,
                36.5728369
              ],
              [
                57.9851532,
                36.5712515
              ],
              [
                57.9739523,
                36.5695282
              ],
              [
                57.9699823,
                36.5690811
              ],
              [
                57.9638671,
                36.5680462
              ],
              [
                57.951538,
                36.568367
              ],
              [
                57.943698,
                36.5685225
              ],
              [
                57.9339201,
                36.5696269
              ],
              [
                57.930189,
                36.5704957
              ],
              [
                57.9238669,
                36.5717998
              ],
              [
                57.9170865,
                36.5752569
              ],
              [
                57.909708,
                36.5772139
              ],
              [
                57.9048156,
                36.5783512
              ],
              [
                57.8978204,
                36.5833137
              ],
              [
                57.8931573,
                36.5871648
              ],
              [
                57.8929269,
                36.5781914
              ],
              [
                57.8925654,
                36.5642002
              ],
              [
                57.8920442,
                36.5257205
              ],
              [
                57.8454186,
                36.5338459
              ],
              [
                57.8296603,
                36.5321415
              ],
              [
                57.828547,
                36.5321415
              ],
              [
                57.828274,
                36.5318623
              ],
              [
                57.8091468,
                36.5284065
              ],
              [
                57.8021609,
                36.5271434
              ],
              [
                57.7971608,
                36.5271435
              ],
              [
                57.7963275,
                36.5274227
              ],
              [
                57.7537535,
                36.5332263
              ],
              [
                57.7443121,
                36.5281226
              ],
              [
                57.7289581,
                36.5297099
              ],
              [
                57.7228446,
                36.5327723
              ],
              [
                57.7115248,
                36.5312952
              ],
              [
                57.7000235,
                36.5248119
              ],
              [
                57.687254,
                36.5393682
              ],
              [
                57.6722143,
                36.5558438
              ],
              [
                57.65007,
                36.5551543
              ],
              [
                57.6364243,
                36.5465452
              ],
              [
                57.6344774,
                36.5420958
              ],
              [
                57.6336441,
                36.5412672
              ],
              [
                57.6341055,
                36.5333642
              ],
              [
                57.6338607,
                36.5178269
              ],
              [
                57.6316408,
                36.5111523
              ],
              [
                57.6129462,
                36.4863785
              ],
              [
                57.6126728,
                36.4855498
              ],
              [
                57.6020297,
                36.4788613
              ],
              [
                57.6017496,
                36.4766365
              ],
              [
                57.595633,
                36.4713586
              ],
              [
                57.5860903,
                36.4627857
              ],
              [
                57.5858102,
                36.4605608
              ],
              [
                57.577977,
                36.4528132
              ],
              [
                57.572607,
                36.4435435
              ],
              [
                57.5796359,
                36.4422505
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555011,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان داورزن",
          "name:en": "Davarzan County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q5228173",
          "wikipedia": "fa:شهرستان داورزن"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.7581767,
                36.1535431
              ],
              [
                56.7592016,
                36.1532853
              ],
              [
                56.7644816,
                36.1521772
              ],
              [
                56.7819815,
                36.1485645
              ],
              [
                56.7847581,
                36.1485646
              ],
              [
                56.7864246,
                36.1482853
              ],
              [
                56.8041226,
                36.1389841
              ],
              [
                56.8235203,
                36.1364193
              ],
              [
                56.8371646,
                36.1335043
              ],
              [
                56.8487018,
                36.1303918
              ],
              [
                56.8744182,
                36.1274766
              ],
              [
                56.8840936,
                36.1246969
              ],
              [
                56.9012782,
                36.1159591
              ],
              [
                56.9252076,
                36.1076949
              ],
              [
                56.9492446,
                36.0989315
              ],
              [
                56.9810199,
                36.0861474
              ],
              [
                57.0190252,
                36.0644281
              ],
              [
                57.0245784,
                36.0660953
              ],
              [
                57.0359016,
                36.0705434
              ],
              [
                57.0375683,
                36.0705434
              ],
              [
                57.0386783,
                36.0708228
              ],
              [
                57.0403449,
                36.0708228
              ],
              [
                57.0499417,
                36.0718576
              ],
              [
                57.0564648,
                36.0787948
              ],
              [
                57.066125,
                36.0808233
              ],
              [
                57.0691782,
                36.08277
              ],
              [
                57.0816315,
                36.0883238
              ],
              [
                57.0894081,
                36.0905499
              ],
              [
                57.1034779,
                36.1019338
              ],
              [
                57.1168245,
                36.109991
              ],
              [
                57.1186542,
                36.1108528
              ],
              [
                57.1307043,
                36.1113776
              ],
              [
                57.1417175,
                36.1083264
              ],
              [
                57.1436606,
                36.1083265
              ],
              [
                57.1469939,
                36.1088852
              ],
              [
                57.1503273,
                36.1088851
              ],
              [
                57.1517173,
                36.1091645
              ],
              [
                57.1569973,
                36.1091645
              ],
              [
                57.1583838,
                36.1094438
              ],
              [
                57.1625505,
                36.1094439
              ],
              [
                57.169217,
                36.1091645
              ],
              [
                57.1733871,
                36.1091644
              ],
              [
                57.1747737,
                36.1088851
              ],
              [
                57.1814402,
                36.1088851
              ],
              [
                57.1831068,
                36.1086058
              ],
              [
                57.1853303,
                36.1086057
              ],
              [
                57.1861636,
                36.1083264
              ],
              [
                57.1878301,
                36.1083264
              ],
              [
                57.2188431,
                36.1079672
              ],
              [
                57.2244121,
                36.1108734
              ],
              [
                57.2568163,
                36.0935282
              ],
              [
                57.2701525,
                36.0841619
              ],
              [
                57.2779325,
                36.0841619
              ],
              [
                57.2826559,
                36.0847117
              ],
              [
                57.2840424,
                36.084991
              ],
              [
                57.2857091,
                36.0849911
              ],
              [
                57.3033139,
                36.0868412
              ],
              [
                57.3160554,
                36.0947071
              ],
              [
                57.318282,
                36.0947071
              ],
              [
                57.3199485,
                36.0949864
              ],
              [
                57.3238353,
                36.0949864
              ],
              [
                57.3246685,
                36.0952658
              ],
              [
                57.3547149,
                36.0913818
              ],
              [
                57.363328,
                36.0922108
              ],
              [
                57.3638816,
                36.0924902
              ],
              [
                57.365275,
                36.0924902
              ],
              [
                57.3655479,
                36.0927697
              ],
              [
                57.3925441,
                36.1028277
              ],
              [
                57.3958396,
                36.1035554
              ],
              [
                57.4016332,
                36.1076468
              ],
              [
                57.4070835,
                36.1079935
              ],
              [
                57.4127054,
                36.1101778
              ],
              [
                57.4141216,
                36.1124313
              ],
              [
                57.4182415,
                36.1139568
              ],
              [
                57.42455,
                36.1154475
              ],
              [
                57.4298286,
                36.1147888
              ],
              [
                57.4385833,
                36.1178743
              ],
              [
                57.444334,
                36.120301
              ],
              [
                57.4474239,
                36.1240448
              ],
              [
                57.4489259,
                36.1244608
              ],
              [
                57.4508571,
                36.1275459
              ],
              [
                57.4555349,
                36.125882
              ],
              [
                57.4616718,
                36.1338889
              ],
              [
                57.4639034,
                36.1377015
              ],
              [
                57.4658346,
                36.1415831
              ],
              [
                57.4681949,
                36.1466428
              ],
              [
                57.470684,
                36.1495884
              ],
              [
                57.474246,
                36.156692
              ],
              [
                57.4717569,
                36.1606767
              ],
              [
                57.4667787,
                36.165458
              ],
              [
                57.4617576,
                36.1680564
              ],
              [
                57.4498701,
                36.1828832
              ],
              [
                57.443304,
                36.1902608
              ],
              [
                57.4375104,
                36.1935511
              ],
              [
                57.4344205,
                36.1959062
              ],
              [
                57.424035,
                36.2031787
              ],
              [
                57.4172544,
                36.2113855
              ],
              [
                57.413392,
                36.2183104
              ],
              [
                57.4115467,
                36.2247846
              ],
              [
                57.4105167,
                36.2264117
              ],
              [
                57.4100446,
                36.2310852
              ],
              [
                57.4098301,
                36.236416
              ],
              [
                57.4132204,
                36.2407774
              ],
              [
                57.4132204,
                36.2449308
              ],
              [
                57.4140787,
                36.2501569
              ],
              [
                57.4136924,
                36.266802
              ],
              [
                57.4145451,
                36.2727475
              ],
              [
                57.415924,
                36.2806413
              ],
              [
                57.4162244,
                36.2852424
              ],
              [
                57.4166536,
                36.2908808
              ],
              [
                57.4162213,
                36.2945494
              ],
              [
                57.4160815,
                36.3010415
              ],
              [
                57.4045453,
                36.3096831
              ],
              [
                57.3959051,
                36.3164011
              ],
              [
                57.3922917,
                36.3183471
              ],
              [
                57.3750683,
                36.3397425
              ],
              [
                57.3474258,
                36.3356447
              ],
              [
                57.3342129,
                36.3416783
              ],
              [
                57.3280331,
                36.3549514
              ],
              [
                57.3446023,
                36.3747175
              ],
              [
                57.3429355,
                36.3774922
              ],
              [
                57.3205128,
                36.3852918
              ],
              [
                57.2984352,
                36.407925
              ],
              [
                57.2903672,
                36.4129704
              ],
              [
                57.2820505,
                36.4198774
              ],
              [
                57.2655273,
                36.4292845
              ],
              [
                57.2604558,
                36.4321466
              ],
              [
                57.2438149,
                36.43302
              ],
              [
                57.232694,
                36.4325306
              ],
              [
                57.2291353,
                36.4361903
              ],
              [
                57.2208377,
                36.4398501
              ],
              [
                57.2041624,
                36.4487753
              ],
              [
                57.1797685,
                36.4501561
              ],
              [
                57.1727369,
                36.4502973
              ],
              [
                57.1695899,
                36.4504228
              ],
              [
                57.1639251,
                36.4571884
              ],
              [
                57.1412658,
                36.4695444
              ],
              [
                57.1358399,
                36.4717631
              ],
              [
                57.1303223,
                36.4748935
              ],
              [
                57.119808,
                36.4804493
              ],
              [
                57.1081349,
                36.4863153
              ],
              [
                57.1018695,
                36.492836
              ],
              [
                57.0952602,
                36.4963898
              ],
              [
                57.0819568,
                36.4995979
              ],
              [
                57.075262,
                36.5019093
              ],
              [
                57.046337,
                36.5131545
              ],
              [
                57.0398751,
                36.5174945
              ],
              [
                57.0323124,
                36.523231
              ],
              [
                57.0185185,
                36.5325387
              ],
              [
                57.0085263,
                36.5352973
              ],
              [
                57.0044088,
                36.540088
              ],
              [
                57.004097,
                36.5440748
              ],
              [
                56.9951298,
                36.5369995
              ],
              [
                56.9879756,
                36.5306055
              ],
              [
                56.9755268,
                36.5334442
              ],
              [
                56.9588674,
                36.5331371
              ],
              [
                56.9499775,
                36.5331372
              ],
              [
                56.9488676,
                36.532858
              ],
              [
                56.9466443,
                36.532858
              ],
              [
                56.9452542,
                36.5325787
              ],
              [
                56.943311,
                36.5325787
              ],
              [
                56.941921,
                36.5322994
              ],
              [
                56.9397009,
                36.5322995
              ],
              [
                56.9360876,
                36.5317409
              ],
              [
                56.9341445,
                36.531741
              ],
              [
                56.9277544,
                36.530633
              ],
              [
                56.9204481,
                36.5333917
              ],
              [
                56.9185047,
                36.5331125
              ],
              [
                56.9101714,
                36.5331124
              ],
              [
                56.8881909,
                36.5374938
              ],
              [
                56.8793011,
                36.5374938
              ],
              [
                56.8779145,
                36.5372146
              ],
              [
                56.8751344,
                36.5372145
              ],
              [
                56.8748578,
                36.5369354
              ],
              [
                56.8695813,
                36.5369354
              ],
              [
                56.8688172,
                36.5370548
              ],
              [
                56.8684678,
                36.5358365
              ],
              [
                56.8681913,
                36.5344405
              ],
              [
                56.8640245,
                36.5208313
              ],
              [
                56.862358,
                36.5186066
              ],
              [
                56.8623579,
                36.5183274
              ],
              [
                56.860968,
                36.5161117
              ],
              [
                56.8579113,
                36.5111039
              ],
              [
                56.8568013,
                36.509996
              ],
              [
                56.8562447,
                36.5088882
              ],
              [
                56.8167982,
                36.4619424
              ],
              [
                56.8023551,
                36.4474943
              ],
              [
                56.8004083,
                36.4455487
              ],
              [
                56.7853515,
                36.4244048
              ],
              [
                56.7631286,
                36.4130196
              ],
              [
                56.7368284,
                36.3872493
              ],
              [
                56.7359952,
                36.3866908
              ],
              [
                56.7348852,
                36.3858619
              ],
              [
                56.7321053,
                36.3822493
              ],
              [
                56.7245726,
                36.345269
              ],
              [
                56.7276292,
                36.341107
              ],
              [
                56.7312391,
                36.3341612
              ],
              [
                56.7320724,
                36.3244404
              ],
              [
                56.7317958,
                36.3188819
              ],
              [
                56.7315157,
                36.3183233
              ],
              [
                56.7320724,
                36.31499
              ],
              [
                56.7329289,
                36.3134953
              ],
              [
                56.7331824,
                36.313053
              ],
              [
                56.7299645,
                36.2985255
              ],
              [
                56.7365324,
                36.2729126
              ],
              [
                56.7462557,
                36.2679012
              ],
              [
                56.7551454,
                36.2606814
              ],
              [
                56.7609788,
                36.2462326
              ],
              [
                56.7626454,
                36.2417799
              ],
              [
                56.7626454,
                36.2415004
              ],
              [
                56.7651453,
                36.2367772
              ],
              [
                56.7733182,
                36.1830371
              ],
              [
                56.7590231,
                36.1570581
              ],
              [
                56.7588859,
                36.1565084
              ],
              [
                56.7586093,
                36.1559498
              ],
              [
                56.7581767,
                36.1535431
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555014,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان درگز",
          "name:en": "Dargaz County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q265274",
          "wikipedia": "fa:شهرستان درگز"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.4896025,
                37.6443967
              ],
              [
                58.490669,
                37.6279775
              ],
              [
                58.4896591,
                37.6269661
              ],
              [
                58.489379,
                37.6250237
              ],
              [
                58.4896591,
                37.624745
              ],
              [
                58.4924392,
                37.6133602
              ],
              [
                58.4924392,
                37.6089088
              ],
              [
                58.4926159,
                37.595062
              ],
              [
                58.4923424,
                37.5947832
              ],
              [
                58.4962292,
                37.5775608
              ],
              [
                58.4935458,
                37.5655798
              ],
              [
                58.4932723,
                37.5608581
              ],
              [
                58.4929922,
                37.5605793
              ],
              [
                58.4929922,
                37.5589155
              ],
              [
                58.4918789,
                37.5541849
              ],
              [
                58.4876059,
                37.5399497
              ],
              [
                58.4768843,
                37.5292091
              ],
              [
                58.4826324,
                37.526416
              ],
              [
                58.4938505,
                37.5200667
              ],
              [
                58.4982722,
                37.5202959
              ],
              [
                58.5002188,
                37.5194685
              ],
              [
                58.5099219,
                37.514628
              ],
              [
                58.5196587,
                37.5136311
              ],
              [
                58.5315512,
                37.5083643
              ],
              [
                58.5379213,
                37.5098132
              ],
              [
                58.5471728,
                37.5025751
              ],
              [
                58.5549631,
                37.498012
              ],
              [
                58.5593971,
                37.4907755
              ],
              [
                58.562311,
                37.4829232
              ],
              [
                58.5637924,
                37.4781758
              ],
              [
                58.5637249,
                37.4722867
              ],
              [
                58.5697615,
                37.4674174
              ],
              [
                58.5733141,
                37.4647907
              ],
              [
                58.5793161,
                37.4585764
              ],
              [
                58.5807752,
                37.4580995
              ],
              [
                58.5893966,
                37.4503822
              ],
              [
                58.593422,
                37.4466072
              ],
              [
                58.5985032,
                37.4394246
              ],
              [
                58.6105539,
                37.4388317
              ],
              [
                58.6184738,
                37.437835
              ],
              [
                58.6236023,
                37.4365708
              ],
              [
                58.6283294,
                37.4344768
              ],
              [
                58.6328675,
                37.4322248
              ],
              [
                58.642472,
                37.4216326
              ],
              [
                58.6518859,
                37.4080055
              ],
              [
                58.6827421,
                37.3899703
              ],
              [
                58.6999528,
                37.3783828
              ],
              [
                58.7018268,
                37.3772477
              ],
              [
                58.709161,
                37.3697309
              ],
              [
                58.7155811,
                37.3666476
              ],
              [
                58.7235634,
                37.3612176
              ],
              [
                58.7313997,
                37.3561895
              ],
              [
                58.739588,
                37.3536105
              ],
              [
                58.7453042,
                37.350629
              ],
              [
                58.7500336,
                37.3478041
              ],
              [
                58.7537501,
                37.3450953
              ],
              [
                58.757003,
                37.3426798
              ],
              [
                58.7655946,
                37.337009
              ],
              [
                58.7674141,
                37.3343372
              ],
              [
                58.7694227,
                37.3324094
              ],
              [
                58.7717402,
                37.3321773
              ],
              [
                58.775813,
                37.3295973
              ],
              [
                58.7785383,
                37.3272368
              ],
              [
                58.7768817,
                37.3225478
              ],
              [
                58.7724124,
                37.3179898
              ],
              [
                58.7523183,
                37.2965252
              ],
              [
                58.7499045,
                37.2952911
              ],
              [
                58.7463855,
                37.2929012
              ],
              [
                58.7366949,
                37.285632
              ],
              [
                58.7322484,
                37.2766114
              ],
              [
                58.7300199,
                37.2716542
              ],
              [
                58.7327033,
                37.2683016
              ],
              [
                58.7395244,
                37.2602102
              ],
              [
                58.7423061,
                37.2542564
              ],
              [
                58.7607192,
                37.2306702
              ],
              [
                58.7667274,
                37.2271164
              ],
              [
                58.7729069,
                37.2249296
              ],
              [
                58.8126965,
                37.2148818
              ],
              [
                58.8166805,
                37.2147457
              ],
              [
                58.8211291,
                37.2105872
              ],
              [
                58.8263797,
                37.203398
              ],
              [
                58.8277528,
                37.1995013
              ],
              [
                58.8277034,
                37.1959772
              ],
              [
                58.8434299,
                37.1973814
              ],
              [
                58.8519492,
                37.1992522
              ],
              [
                58.8587044,
                37.2039521
              ],
              [
                58.8820836,
                37.1984075
              ],
              [
                58.900261,
                37.1780744
              ],
              [
                58.907318,
                37.1711919
              ],
              [
                58.9284056,
                37.1579726
              ],
              [
                58.951435,
                37.1458823
              ],
              [
                58.9584731,
                37.1434193
              ],
              [
                58.9590739,
                37.1384246
              ],
              [
                58.9679283,
                37.1190385
              ],
              [
                58.9759672,
                37.1103517
              ],
              [
                58.9907452,
                37.1065332
              ],
              [
                59.0000149,
                37.1027683
              ],
              [
                59.0190695,
                37.0894183
              ],
              [
                59.0333172,
                37.0736695
              ],
              [
                59.0446469,
                37.0625748
              ],
              [
                59.0631863,
                37.0576432
              ],
              [
                59.0885922,
                37.0510674
              ],
              [
                59.1027095,
                37.0427835
              ],
              [
                59.1139124,
                37.0326382
              ],
              [
                59.1234127,
                37.0284027
              ],
              [
                59.1315716,
                37.0230117
              ],
              [
                59.1397591,
                37.0170488
              ],
              [
                59.1442442,
                37.0142144
              ],
              [
                59.1468272,
                37.0124081
              ],
              [
                59.1476609,
                37.0120741
              ],
              [
                59.1723663,
                36.9996991
              ],
              [
                59.1892277,
                36.99314
              ],
              [
                59.1974059,
                36.9897136
              ],
              [
                59.2111632,
                36.9847887
              ],
              [
                59.2169043,
                36.9827797
              ],
              [
                59.2327071,
                36.9730828
              ],
              [
                59.2362255,
                36.9734353
              ],
              [
                59.2488203,
                36.9784951
              ],
              [
                59.2498589,
                36.9767117
              ],
              [
                59.2707072,
                36.9702409
              ],
              [
                59.2767033,
                36.9752822
              ],
              [
                59.2864903,
                36.9828588
              ],
              [
                59.2916284,
                36.9870021
              ],
              [
                59.303133,
                36.9879784
              ],
              [
                59.3058137,
                37.0104167
              ],
              [
                59.3059903,
                37.0134378
              ],
              [
                59.3088987,
                37.0223566
              ],
              [
                59.3100391,
                37.0279077
              ],
              [
                59.3131467,
                37.0377135
              ],
              [
                59.3251524,
                37.0481492
              ],
              [
                59.3280489,
                37.0613313
              ],
              [
                59.3303698,
                37.0706643
              ],
              [
                59.3323783,
                37.1030988
              ],
              [
                59.3332607,
                37.1131448
              ],
              [
                59.3954546,
                37.1167978
              ],
              [
                59.4079637,
                37.1344697
              ],
              [
                59.4245563,
                37.1700909
              ],
              [
                59.4318901,
                37.1855572
              ],
              [
                59.4244339,
                37.1957773
              ],
              [
                59.4122742,
                37.2124405
              ],
              [
                59.3990478,
                37.2306142
              ],
              [
                59.3890303,
                37.2451117
              ],
              [
                59.3958439,
                37.2629992
              ],
              [
                59.4037391,
                37.2851746
              ],
              [
                59.4024113,
                37.3003813
              ],
              [
                59.4005699,
                37.306019
              ],
              [
                59.3998972,
                37.3151972
              ],
              [
                59.3968977,
                37.3173029
              ],
              [
                59.3980986,
                37.3186101
              ],
              [
                59.399203,
                37.319639
              ],
              [
                59.4003109,
                37.3237491
              ],
              [
                59.3968741,
                37.3263958
              ],
              [
                59.3967691,
                37.3278076
              ],
              [
                59.392452,
                37.332375
              ],
              [
                59.3935153,
                37.3377539
              ],
              [
                59.39046,
                37.3421842
              ],
              [
                59.3894913,
                37.3512753
              ],
              [
                59.3903084,
                37.3605354
              ],
              [
                59.3878773,
                37.3736975
              ],
              [
                59.382786,
                37.39112
              ],
              [
                59.377877,
                37.4075897
              ],
              [
                59.3827188,
                37.4209632
              ],
              [
                59.3901516,
                37.4239452
              ],
              [
                59.3990807,
                37.4271861
              ],
              [
                59.4026247,
                37.4294995
              ],
              [
                59.4055379,
                37.4317512
              ],
              [
                59.4113447,
                37.4357739
              ],
              [
                59.4049358,
                37.4415594
              ],
              [
                59.4001112,
                37.4455288
              ],
              [
                59.3960773,
                37.4489972
              ],
              [
                59.3914769,
                37.4469292
              ],
              [
                59.3875995,
                37.4453161
              ],
              [
                59.384024,
                37.4478708
              ],
              [
                59.3814207,
                37.4497464
              ],
              [
                59.3858093,
                37.4615346
              ],
              [
                59.3889529,
                37.4699921
              ],
              [
                59.392131,
                37.4791374
              ],
              [
                59.3886849,
                37.4848569
              ],
              [
                59.3844199,
                37.4921965
              ],
              [
                59.3776157,
                37.4977869
              ],
              [
                59.3688302,
                37.5050204
              ],
              [
                59.3611089,
                37.5114385
              ],
              [
                59.3573493,
                37.5198096
              ],
              [
                59.3534794,
                37.5284162
              ],
              [
                59.3452644,
                37.5292494
              ],
              [
                59.3371858,
                37.5300645
              ],
              [
                59.329987,
                37.5295151
              ],
              [
                59.3193893,
                37.5300269
              ],
              [
                59.308131,
                37.5246593
              ],
              [
                59.2988826,
                37.520227
              ],
              [
                59.2928867,
                37.5172623
              ],
              [
                59.2883999,
                37.5146316
              ],
              [
                59.2840739,
                37.51323
              ],
              [
                59.2833763,
                37.5123833
              ],
              [
                59.2838802,
                37.5116126
              ],
              [
                59.2839538,
                37.510912
              ],
              [
                59.2837625,
                37.5103515
              ],
              [
                59.2833061,
                37.5102231
              ],
              [
                59.2820549,
                37.5107252
              ],
              [
                59.2816133,
                37.5110521
              ],
              [
                59.2811569,
                37.5110988
              ],
              [
                59.2804651,
                37.5107719
              ],
              [
                59.2796849,
                37.5097677
              ],
              [
                59.2789194,
                37.5091137
              ],
              [
                59.2777565,
                37.5085883
              ],
              [
                59.2761885,
                37.5086415
              ],
              [
                59.2738997,
                37.5081912
              ],
              [
                59.2724276,
                37.5081679
              ],
              [
                59.2714119,
                37.5084832
              ],
              [
                59.2698957,
                37.5091488
              ],
              [
                59.2686739,
                37.5091488
              ],
              [
                59.2680115,
                37.5095341
              ],
              [
                59.2675993,
                37.5103398
              ],
              [
                59.2669663,
                37.5107018
              ],
              [
                59.2660978,
                37.5107952
              ],
              [
                59.265877,
                37.510515
              ],
              [
                59.2660389,
                37.5100246
              ],
              [
                59.2656562,
                37.5097677
              ],
              [
                59.2647288,
                37.5099311
              ],
              [
                59.2634481,
                37.5106084
              ],
              [
                59.2620349,
                37.5121497
              ],
              [
                59.260681,
                37.5120376
              ],
              [
                59.2602655,
                37.5120236
              ],
              [
                59.2598769,
                37.5123319
              ],
              [
                59.2600064,
                37.5128714
              ],
              [
                59.2602331,
                37.5137319
              ],
              [
                59.2598283,
                37.5144512
              ],
              [
                59.2590511,
                37.5146567
              ],
              [
                59.2579824,
                37.5145026
              ],
              [
                59.2569467,
                37.5140046
              ],
              [
                59.256266,
                37.5139503
              ],
              [
                59.2559421,
                37.5141943
              ],
              [
                59.2556992,
                37.5152347
              ],
              [
                59.2548896,
                37.5159411
              ],
              [
                59.2542905,
                37.5166603
              ],
              [
                59.2539828,
                37.5168401
              ],
              [
                59.2536428,
                37.5165833
              ],
              [
                59.2528331,
                37.5166988
              ],
              [
                59.2519425,
                37.5170713
              ],
              [
                59.2510034,
                37.5176621
              ],
              [
                59.2497565,
                37.5182272
              ],
              [
                59.2488659,
                37.5182144
              ],
              [
                59.2470362,
                37.5178804
              ],
              [
                59.2469066,
                37.5174695
              ],
              [
                59.2469714,
                37.5166988
              ],
              [
                59.2466805,
                37.5162614
              ],
              [
                59.2463799,
                37.5161725
              ],
              [
                59.245757,
                37.5166988
              ],
              [
                59.2454169,
                37.5173667
              ],
              [
                59.2455465,
                37.5177777
              ],
              [
                59.246097,
                37.5180089
              ],
              [
                59.2463723,
                37.5186382
              ],
              [
                59.2461132,
                37.519229
              ],
              [
                59.2454655,
                37.5196271
              ],
              [
                59.2439434,
                37.5198455
              ],
              [
                59.2417574,
                37.5201922
              ],
              [
                59.240624,
                37.5207885
              ],
              [
                59.2396265,
                37.520958
              ],
              [
                59.2388962,
                37.5206896
              ],
              [
                59.2380057,
                37.5198137
              ],
              [
                59.2371329,
                37.5194747
              ],
              [
                59.236171,
                37.5186553
              ],
              [
                59.2357939,
                37.5175191
              ],
              [
                59.2358927,
                37.5166
              ],
              [
                59.235344,
                37.5156022
              ],
              [
                59.2340994,
                37.5147424
              ],
              [
                59.232614,
                37.5145726
              ],
              [
                59.2311762,
                37.5146576
              ],
              [
                59.2300243,
                37.5140067
              ],
              [
                59.2292497,
                37.5120499
              ],
              [
                59.2218124,
                37.5154619
              ],
              [
                59.2138749,
                37.5203529
              ],
              [
                59.2101439,
                37.5226521
              ],
              [
                59.2076254,
                37.5264841
              ],
              [
                59.2047827,
                37.5281238
              ],
              [
                59.2027225,
                37.5285994
              ],
              [
                59.2001879,
                37.5321254
              ],
              [
                59.1946714,
                37.5351358
              ],
              [
                59.1917995,
                37.5362889
              ],
              [
                59.1908416,
                37.538484
              ],
              [
                59.1897371,
                37.5400353
              ],
              [
                59.1882322,
                37.5406987
              ],
              [
                59.1863292,
                37.5412613
              ],
              [
                59.183853,
                37.5413346
              ],
              [
                59.1825742,
                37.5403355
              ],
              [
                59.1826373,
                37.5388343
              ],
              [
                59.1806178,
                37.5382838
              ],
              [
                59.1785667,
                37.5392847
              ],
              [
                59.174086,
                37.5427625
              ],
              [
                59.167074,
                37.5491704
              ],
              [
                59.154722,
                37.571111
              ],
              [
                59.147222,
                37.5725
              ],
              [
                59.140556,
                37.574722
              ],
              [
                59.133889,
                37.576667
              ],
              [
                59.128333,
                37.579444
              ],
              [
                59.122778,
                37.581944
              ],
              [
                59.118056,
                37.585278
              ],
              [
                59.113333,
                37.588611
              ],
              [
                59.108611,
                37.591667
              ],
              [
                59.105,
                37.595556
              ],
              [
                59.100278,
                37.598889
              ],
              [
                59.095556,
                37.601944
              ],
              [
                59.090833,
                37.605278
              ],
              [
                59.0898627,
                37.6060057
              ],
              [
                59.086389,
                37.608611
              ],
              [
                59.081667,
                37.611944
              ],
              [
                59.077778,
                37.615556
              ],
              [
                59.073333,
                37.618889
              ],
              [
                59.068611,
                37.622778
              ],
              [
                59.0663705,
                37.625191
              ],
              [
                59.065,
                37.626667
              ],
              [
                59.060278,
                37.63
              ],
              [
                59.052778,
                37.631389
              ],
              [
                59.045556,
                37.630833
              ],
              [
                59.038611,
                37.63
              ],
              [
                59.030833,
                37.630278
              ],
              [
                59.024167,
                37.632222
              ],
              [
                59.018333,
                37.635
              ],
              [
                59.012778,
                37.6375
              ],
              [
                59.008056,
                37.640833
              ],
              [
                59.003611,
                37.644167
              ],
              [
                58.997778,
                37.646667
              ],
              [
                58.992222,
                37.649444
              ],
              [
                58.986667,
                37.652222
              ],
              [
                58.980833,
                37.654722
              ],
              [
                58.974167,
                37.656667
              ],
              [
                58.9675,
                37.658889
              ],
              [
                58.961111,
                37.660833
              ],
              [
                58.954444,
                37.663056
              ],
              [
                58.947778,
                37.665
              ],
              [
                58.941111,
                37.667222
              ],
              [
                58.933611,
                37.668611
              ],
              [
                58.926111,
                37.67
              ],
              [
                58.918889,
                37.669444
              ],
              [
                58.9125,
                37.668056
              ],
              [
                58.905556,
                37.6675
              ],
              [
                58.898611,
                37.666667
              ],
              [
                58.890833,
                37.666944
              ],
              [
                58.883889,
                37.6675
              ],
              [
                58.876389,
                37.669167
              ],
              [
                58.870556,
                37.671667
              ],
              [
                58.865,
                37.674444
              ],
              [
                58.860278,
                37.6775
              ],
              [
                58.855556,
                37.680833
              ],
              [
                58.851944,
                37.684722
              ],
              [
                58.848056,
                37.688611
              ],
              [
                58.843333,
                37.691667
              ],
              [
                58.839722,
                37.695556
              ],
              [
                58.836111,
                37.699444
              ],
              [
                58.830278,
                37.701944
              ],
              [
                58.822778,
                37.703611
              ],
              [
                58.815556,
                37.702778
              ],
              [
                58.813056,
                37.6975
              ],
              [
                58.813889,
                37.691944
              ],
              [
                58.814722,
                37.686389
              ],
              [
                58.814722,
                37.680278
              ],
              [
                58.812778,
                37.674167
              ],
              [
                58.808611,
                37.670556
              ],
              [
                58.804444,
                37.666944
              ],
              [
                58.798889,
                37.664722
              ],
              [
                58.793333,
                37.6625
              ],
              [
                58.786389,
                37.661667
              ],
              [
                58.778611,
                37.661944
              ],
              [
                58.770833,
                37.663333
              ],
              [
                58.763333,
                37.664722
              ],
              [
                58.755833,
                37.666389
              ],
              [
                58.748889,
                37.666944
              ],
              [
                58.743333,
                37.664722
              ],
              [
                58.738611,
                37.661944
              ],
              [
                58.735,
                37.6575
              ],
              [
                58.731667,
                37.653056
              ],
              [
                58.726111,
                37.650833
              ],
              [
                58.72,
                37.649444
              ],
              [
                58.712778,
                37.648611
              ],
              [
                58.704444,
                37.649444
              ],
              [
                58.696389,
                37.649722
              ],
              [
                58.688056,
                37.650556
              ],
              [
                58.680278,
                37.651944
              ],
              [
                58.672778,
                37.653611
              ],
              [
                58.665278,
                37.655
              ],
              [
                58.659444,
                37.6575
              ],
              [
                58.652778,
                37.659722
              ],
              [
                58.646389,
                37.661667
              ],
              [
                58.640556,
                37.664444
              ],
              [
                58.635,
                37.666944
              ],
              [
                58.629167,
                37.669722
              ],
              [
                58.623611,
                37.672222
              ],
              [
                58.618056,
                37.675
              ],
              [
                58.613333,
                37.678056
              ],
              [
                58.608611,
                37.681389
              ],
              [
                58.603889,
                37.685278
              ],
              [
                58.5974623,
                37.6898565
              ],
              [
                58.5964395,
                37.6892126
              ],
              [
                58.5959665,
                37.6887156
              ],
              [
                58.5956028,
                37.6887759
              ],
              [
                58.5923108,
                37.6901517
              ],
              [
                58.5867908,
                37.6933769
              ],
              [
                58.5821818,
                37.6949411
              ],
              [
                58.5761695,
                37.6965679
              ],
              [
                58.570377,
                37.6985383
              ],
              [
                58.5662713,
                37.6998946
              ],
              [
                58.5566505,
                37.7055032
              ],
              [
                58.55,
                37.705833
              ],
              [
                58.544444,
                37.703611
              ],
              [
                58.539444,
                37.700833
              ],
              [
                58.534722,
                37.697778
              ],
              [
                58.531389,
                37.693333
              ],
              [
                58.527222,
                37.689722
              ],
              [
                58.524722,
                37.684444
              ],
              [
                58.522222,
                37.679167
              ],
              [
                58.518889,
                37.674722
              ],
              [
                58.516111,
                37.669444
              ],
              [
                58.513611,
                37.664167
              ],
              [
                58.510278,
                37.659722
              ],
              [
                58.506944,
                37.655278
              ],
              [
                58.502778,
                37.651389
              ],
              [
                58.498056,
                37.647778
              ],
              [
                58.4925,
                37.645556
              ],
              [
                58.4896025,
                37.6443967
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555043,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رشتخوار",
          "name:en": "Roshtkhar County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1292906",
          "wikipedia": "fa:شهرستان رشتخوار"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.0543865,
                34.7757401
              ],
              [
                59.0554998,
                34.7757402
              ],
              [
                59.0548276,
                34.7504065
              ],
              [
                59.0587231,
                34.7455623
              ],
              [
                59.0621563,
                34.7102917
              ],
              [
                59.0741301,
                34.7002038
              ],
              [
                59.0765759,
                34.6936387
              ],
              [
                59.0697094,
                34.6665351
              ],
              [
                59.0741726,
                34.6515679
              ],
              [
                59.0896222,
                34.6349031
              ],
              [
                59.1131624,
                34.5986226
              ],
              [
                59.1148292,
                34.5914057
              ],
              [
                59.1407769,
                34.5738647
              ],
              [
                59.1668276,
                34.5403516
              ],
              [
                59.1721078,
                34.5347944
              ],
              [
                59.1732145,
                34.5342441
              ],
              [
                59.1823806,
                34.5289667
              ],
              [
                59.2104406,
                34.5203511
              ],
              [
                59.2165541,
                34.5195212
              ],
              [
                59.2826994,
                34.5201408
              ],
              [
                59.2863129,
                34.519311
              ],
              [
                59.3336518,
                34.5296464
              ],
              [
                59.4207462,
                34.5202221
              ],
              [
                59.4229663,
                34.520222
              ],
              [
                59.4232463,
                34.5205014
              ],
              [
                59.4237995,
                34.5207807
              ],
              [
                59.4249128,
                34.5210511
              ],
              [
                59.4257461,
                34.5213304
              ],
              [
                59.4262995,
                34.5213304
              ],
              [
                59.4738,
                34.5218334
              ],
              [
                59.507506,
                34.534725
              ],
              [
                59.5086123,
                34.5352844
              ],
              [
                59.5194457,
                34.5408338
              ],
              [
                59.5366786,
                34.5393343
              ],
              [
                59.5369516,
                34.5404352
              ],
              [
                59.5372317,
                34.5409947
              ],
              [
                59.5574313,
                34.5492703
              ],
              [
                59.5742704,
                34.5581638
              ],
              [
                59.5775403,
                34.5779811
              ],
              [
                59.5761539,
                34.5874322
              ],
              [
                59.5678308,
                34.5898922
              ],
              [
                59.5678308,
                34.5932322
              ],
              [
                59.5719973,
                34.6054547
              ],
              [
                59.574224,
                34.6098961
              ],
              [
                59.5758908,
                34.6121256
              ],
              [
                59.5781704,
                34.6219079
              ],
              [
                59.5771405,
                34.6349031
              ],
              [
                59.5859538,
                34.6458256
              ],
              [
                59.6002905,
                34.658003
              ],
              [
                59.6033437,
                34.6649519
              ],
              [
                59.6041769,
                34.6666125
              ],
              [
                59.6044571,
                34.6674517
              ],
              [
                59.5774749,
                34.6975691
              ],
              [
                59.5777551,
                34.6981286
              ],
              [
                59.5774749,
                34.6986879
              ],
              [
                59.5769217,
                34.7034074
              ],
              [
                59.5561978,
                34.7069049
              ],
              [
                59.5471992,
                34.7210984
              ],
              [
                59.5143035,
                34.7459604
              ],
              [
                59.5133912,
                34.7495976
              ],
              [
                59.5131903,
                34.7503988
              ],
              [
                59.4985196,
                34.771794
              ],
              [
                59.4800877,
                34.7783665
              ],
              [
                59.473457,
                34.8042194
              ],
              [
                59.4765079,
                34.8123829
              ],
              [
                59.4762279,
                34.8159919
              ],
              [
                59.4765079,
                34.8184911
              ],
              [
                59.476781,
                34.8207106
              ],
              [
                59.4770611,
                34.8229392
              ],
              [
                59.4773412,
                34.8248791
              ],
              [
                59.4776142,
                34.8268279
              ],
              [
                59.4798413,
                34.8321059
              ],
              [
                59.5098218,
                34.854378
              ],
              [
                59.5135038,
                34.8562952
              ],
              [
                59.5335132,
                34.8583821
              ],
              [
                59.560661,
                34.8487483
              ],
              [
                59.5737072,
                34.8464943
              ],
              [
                59.587262,
                34.8533525
              ],
              [
                59.5889286,
                34.8525138
              ],
              [
                59.6033682,
                34.8494652
              ],
              [
                59.6058683,
                34.8494653
              ],
              [
                59.6279444,
                34.8669362
              ],
              [
                59.6296112,
                34.8669362
              ],
              [
                59.6315511,
                34.8666566
              ],
              [
                59.6340507,
                34.8666566
              ],
              [
                59.6354441,
                34.8663771
              ],
              [
                59.659201,
                34.8495268
              ],
              [
                59.6619412,
                34.8408589
              ],
              [
                59.6935269,
                34.8360685
              ],
              [
                59.711723,
                34.8076022
              ],
              [
                59.7250455,
                34.8016309
              ],
              [
                59.7256056,
                34.8016309
              ],
              [
                59.7267119,
                34.8013511
              ],
              [
                59.7283787,
                34.8013511
              ],
              [
                59.729492,
                34.8010714
              ],
              [
                59.7308787,
                34.8010714
              ],
              [
                59.731439,
                34.8007917
              ],
              [
                59.7339386,
                34.8007917
              ],
              [
                59.7347722,
                34.8005119
              ],
              [
                59.7394919,
                34.7999614
              ],
              [
                59.7476451,
                34.7954505
              ],
              [
                59.7479251,
                34.7951708
              ],
              [
                59.7509783,
                34.7951708
              ],
              [
                59.7512584,
                34.794891
              ],
              [
                59.7540385,
                34.7943405
              ],
              [
                59.7543116,
                34.7946203
              ],
              [
                59.7551448,
                34.7943405
              ],
              [
                59.7562581,
                34.7943405
              ],
              [
                59.7582051,
                34.794891
              ],
              [
                59.7642514,
                34.8011184
              ],
              [
                59.7604748,
                34.8202864
              ],
              [
                59.7491452,
                34.8352231
              ],
              [
                59.7676846,
                34.8470578
              ],
              [
                59.7954937,
                34.8670602
              ],
              [
                59.8178097,
                34.8721304
              ],
              [
                59.8171058,
                34.8879494
              ],
              [
                59.8184992,
                34.8907282
              ],
              [
                59.8193324,
                34.8915671
              ],
              [
                59.8193324,
                34.8921265
              ],
              [
                59.820166,
                34.8932362
              ],
              [
                59.8158226,
                34.9141206
              ],
              [
                59.8174895,
                34.9157806
              ],
              [
                59.8188829,
                34.9177291
              ],
              [
                59.8521162,
                34.9508166
              ],
              [
                59.8554494,
                34.9524854
              ],
              [
                59.8587827,
                34.9535949
              ],
              [
                59.879369,
                34.9686506
              ],
              [
                59.8802023,
                34.9694896
              ],
              [
                59.8818691,
                34.9703194
              ],
              [
                59.9210396,
                34.9890073
              ],
              [
                59.9153566,
                34.9931073
              ],
              [
                59.9162364,
                34.9983104
              ],
              [
                59.9169627,
                34.9999321
              ],
              [
                59.9102707,
                35.0081919
              ],
              [
                59.9061023,
                35.0127313
              ],
              [
                59.9092194,
                35.0148845
              ],
              [
                59.9134251,
                35.021
              ],
              [
                59.9148845,
                35.0245845
              ],
              [
                59.9128245,
                35.0264119
              ],
              [
                59.896641,
                35.0317738
              ],
              [
                59.8797795,
                35.036111
              ],
              [
                59.844482,
                35.0502894
              ],
              [
                59.8376881,
                35.0521718
              ],
              [
                59.8334959,
                35.066544
              ],
              [
                59.8290993,
                35.0794227
              ],
              [
                59.8203147,
                35.083215
              ],
              [
                59.7924041,
                35.0966674
              ],
              [
                59.7819327,
                35.102847
              ],
              [
                59.7757488,
                35.1082508
              ],
              [
                59.7740654,
                35.117079
              ],
              [
                59.77249,
                35.1287978
              ],
              [
                59.7717316,
                35.1346647
              ],
              [
                59.768114,
                35.1458804
              ],
              [
                59.7667835,
                35.1630384
              ],
              [
                59.7627149,
                35.1626837
              ],
              [
                59.7491209,
                35.1598886
              ],
              [
                59.7323646,
                35.1620368
              ],
              [
                59.7193631,
                35.1642405
              ],
              [
                59.712018,
                35.1658509
              ],
              [
                59.6996747,
                35.1694435
              ],
              [
                59.6955823,
                35.1701429
              ],
              [
                59.687415,
                35.169301
              ],
              [
                59.6830263,
                35.1668731
              ],
              [
                59.6732248,
                35.1571768
              ],
              [
                59.660654,
                35.135984
              ],
              [
                59.6555608,
                35.1310802
              ],
              [
                59.653898,
                35.1283482
              ],
              [
                59.6331453,
                35.1357734
              ],
              [
                59.6235752,
                35.1371422
              ],
              [
                59.6102285,
                35.1401603
              ],
              [
                59.6067953,
                35.1414938
              ],
              [
                59.6037481,
                35.1434942
              ],
              [
                59.5974978,
                35.1491972
              ],
              [
                59.5945215,
                35.1512141
              ],
              [
                59.5918394,
                35.1514718
              ],
              [
                59.5885992,
                35.1536001
              ],
              [
                59.5855511,
                35.1571879
              ],
              [
                59.5830245,
                35.1621955
              ],
              [
                59.5888053,
                35.1759222
              ],
              [
                59.5964526,
                35.1846121
              ],
              [
                59.6021885,
                35.1915045
              ],
              [
                59.602332,
                35.1933804
              ],
              [
                59.5972679,
                35.1952742
              ],
              [
                59.5678709,
                35.2046724
              ],
              [
                59.5599745,
                35.205514
              ],
              [
                59.5608328,
                35.1951339
              ],
              [
                59.5582579,
                35.1863659
              ],
              [
                59.5477866,
                35.1837703
              ],
              [
                59.5347425,
                35.1785471
              ],
              [
                59.5282172,
                35.173177
              ],
              [
                59.5193986,
                35.1680663
              ],
              [
                59.5026411,
                35.1734078
              ],
              [
                59.4849304,
                35.1781088
              ],
              [
                59.4574918,
                35.1698154
              ],
              [
                59.4385321,
                35.1644586
              ],
              [
                59.4137108,
                35.1715995
              ],
              [
                59.3991503,
                35.175727
              ],
              [
                59.3999004,
                35.1933803
              ],
              [
                59.3947502,
                35.2084596
              ],
              [
                59.3908023,
                35.2168744
              ],
              [
                59.3755242,
                35.2259899
              ],
              [
                59.3618771,
                35.2243072
              ],
              [
                59.3442532,
                35.2194011
              ],
              [
                59.340248,
                35.2209414
              ],
              [
                59.3368112,
                35.2236082
              ],
              [
                59.2987057,
                35.2189783
              ],
              [
                59.2405272,
                35.2011311
              ],
              [
                59.2383006,
                35.1989035
              ],
              [
                59.2203145,
                35.1633668
              ],
              [
                59.2219814,
                35.1597592
              ],
              [
                59.226981,
                35.1553129
              ],
              [
                59.2550971,
                35.1488723
              ],
              [
                59.2573238,
                35.1480425
              ],
              [
                59.2777433,
                35.134124
              ],
              [
                59.2785767,
                35.134124
              ],
              [
                59.2897698,
                35.1328118
              ],
              [
                59.2936566,
                35.1267059
              ],
              [
                59.2944898,
                35.1250464
              ],
              [
                59.2947699,
                35.1236575
              ],
              [
                59.2947699,
                35.1189315
              ],
              [
                59.2908093,
                35.1013726
              ],
              [
                59.2889213,
                35.0954384
              ],
              [
                59.2842003,
                35.0897852
              ],
              [
                59.2766926,
                35.0833201
              ],
              [
                59.27639,
                35.0780907
              ],
              [
                59.2783437,
                35.0629265
              ],
              [
                59.2783437,
                35.0609779
              ],
              [
                59.2780636,
                35.0601479
              ],
              [
                59.2777902,
                35.0587497
              ],
              [
                59.2775101,
                35.0579287
              ],
              [
                59.2772304,
                35.0576401
              ],
              [
                59.2775101,
                35.053752
              ],
              [
                59.256477,
                35.0302778
              ],
              [
                59.2379376,
                35.0257796
              ],
              [
                59.2207714,
                35.0117211
              ],
              [
                59.2064377,
                35.003074
              ],
              [
                59.1970787,
                34.9899323
              ],
              [
                59.1648101,
                34.9813464
              ],
              [
                59.1122817,
                34.9586285
              ],
              [
                59.1007682,
                34.9491211
              ],
              [
                59.098978,
                34.9408295
              ],
              [
                59.1007804,
                34.9378744
              ],
              [
                59.1101359,
                34.9308379
              ],
              [
                59.1093635,
                34.9284454
              ],
              [
                59.1104694,
                34.9177847
              ],
              [
                59.1315075,
                34.9157781
              ],
              [
                59.1723629,
                34.8969139
              ],
              [
                59.1727063,
                34.8842415
              ],
              [
                59.1669986,
                34.8743677
              ],
              [
                59.1664451,
                34.8740969
              ],
              [
                59.1468713,
                34.8589689
              ],
              [
                59.1460381,
                34.8581296
              ],
              [
                59.1276481,
                34.8399926
              ],
              [
                59.1281678,
                34.8117741
              ],
              [
                59.1278877,
                34.8112145
              ],
              [
                59.1267745,
                34.8092737
              ],
              [
                59.1060819,
                34.7808629
              ],
              [
                59.1060818,
                34.7803121
              ],
              [
                59.1060818,
                34.7800323
              ],
              [
                59.1058017,
                34.7778025
              ],
              [
                59.1055283,
                34.7772518
              ],
              [
                59.0543865,
                34.7757401
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555056,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زاوه",
          "name:en": "Zaveh County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2723570",
          "wikipedia": "fa:شهرستان زاوه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.3286696,
                35.2819352
              ],
              [
                59.3288326,
                35.2799592
              ],
              [
                59.3386891,
                35.2622088
              ],
              [
                59.3399182,
                35.2604932
              ],
              [
                59.3416214,
                35.2488786
              ],
              [
                59.3423938,
                35.2342276
              ],
              [
                59.3427084,
                35.2304153
              ],
              [
                59.3442532,
                35.2194011
              ],
              [
                59.3618771,
                35.2243072
              ],
              [
                59.3755242,
                35.2259899
              ],
              [
                59.3908023,
                35.2168744
              ],
              [
                59.3947502,
                35.2084596
              ],
              [
                59.3999004,
                35.1933803
              ],
              [
                59.3991503,
                35.175727
              ],
              [
                59.4137108,
                35.1715995
              ],
              [
                59.4385321,
                35.1644586
              ],
              [
                59.4574918,
                35.1698154
              ],
              [
                59.4849304,
                35.1781088
              ],
              [
                59.5026411,
                35.1734078
              ],
              [
                59.5193986,
                35.1680663
              ],
              [
                59.5282172,
                35.173177
              ],
              [
                59.5347425,
                35.1785471
              ],
              [
                59.5477866,
                35.1837703
              ],
              [
                59.5582579,
                35.1863659
              ],
              [
                59.5608328,
                35.1951339
              ],
              [
                59.5599745,
                35.205514
              ],
              [
                59.5678709,
                35.2046724
              ],
              [
                59.5972679,
                35.1952742
              ],
              [
                59.602332,
                35.1933804
              ],
              [
                59.6021885,
                35.1915045
              ],
              [
                59.5964526,
                35.1846121
              ],
              [
                59.5888053,
                35.1759222
              ],
              [
                59.5830245,
                35.1621955
              ],
              [
                59.5855511,
                35.1571879
              ],
              [
                59.5885992,
                35.1536001
              ],
              [
                59.5918394,
                35.1514718
              ],
              [
                59.5945215,
                35.1512141
              ],
              [
                59.5974978,
                35.1491972
              ],
              [
                59.6037481,
                35.1434942
              ],
              [
                59.6067953,
                35.1414938
              ],
              [
                59.6102285,
                35.1401603
              ],
              [
                59.6235752,
                35.1371422
              ],
              [
                59.6331453,
                35.1357734
              ],
              [
                59.653898,
                35.1283482
              ],
              [
                59.6555608,
                35.1310802
              ],
              [
                59.660654,
                35.135984
              ],
              [
                59.6732248,
                35.1571768
              ],
              [
                59.6830263,
                35.1668731
              ],
              [
                59.687415,
                35.169301
              ],
              [
                59.6955823,
                35.1701429
              ],
              [
                59.6996747,
                35.1694435
              ],
              [
                59.712018,
                35.1658509
              ],
              [
                59.7193631,
                35.1642405
              ],
              [
                59.7323646,
                35.1620368
              ],
              [
                59.7491209,
                35.1598886
              ],
              [
                59.7627149,
                35.1626837
              ],
              [
                59.7667835,
                35.1630384
              ],
              [
                59.768114,
                35.1458804
              ],
              [
                59.7717316,
                35.1346647
              ],
              [
                59.77249,
                35.1287978
              ],
              [
                59.7740654,
                35.117079
              ],
              [
                59.7757488,
                35.1082508
              ],
              [
                59.7819327,
                35.102847
              ],
              [
                59.7924041,
                35.0966674
              ],
              [
                59.8203147,
                35.083215
              ],
              [
                59.8290993,
                35.0794227
              ],
              [
                59.8334959,
                35.066544
              ],
              [
                59.8376881,
                35.0521718
              ],
              [
                59.844482,
                35.0502894
              ],
              [
                59.8797795,
                35.036111
              ],
              [
                59.896641,
                35.0317738
              ],
              [
                59.9128245,
                35.0264119
              ],
              [
                59.9148845,
                35.0245845
              ],
              [
                59.9134251,
                35.021
              ],
              [
                59.9092194,
                35.0148845
              ],
              [
                59.9061023,
                35.0127313
              ],
              [
                59.9102707,
                35.0081919
              ],
              [
                59.9169627,
                34.9999321
              ],
              [
                59.9162364,
                34.9983104
              ],
              [
                59.9153566,
                34.9931073
              ],
              [
                59.9210396,
                34.9890073
              ],
              [
                59.924459,
                34.9905672
              ],
              [
                59.9371755,
                34.99074
              ],
              [
                59.9442386,
                34.9902068
              ],
              [
                59.9528481,
                34.9891913
              ],
              [
                59.9632946,
                34.9885098
              ],
              [
                59.9705028,
                34.9878863
              ],
              [
                59.9861389,
                34.9829164
              ],
              [
                60.003695,
                34.9828716
              ],
              [
                60.013686,
                34.9882786
              ],
              [
                60.011208,
                34.9920174
              ],
              [
                60.0083329,
                34.9975229
              ],
              [
                60.0084185,
                35.0001736
              ],
              [
                60.0086546,
                35.003144
              ],
              [
                60.0092765,
                35.0055346
              ],
              [
                60.0220868,
                35.0145681
              ],
              [
                60.0324297,
                35.0195588
              ],
              [
                60.0405833,
                35.0224058
              ],
              [
                60.0352621,
                35.0278176
              ],
              [
                60.0308844,
                35.0332296
              ],
              [
                60.0316568,
                35.0395546
              ],
              [
                60.0340174,
                35.0434545
              ],
              [
                60.0287818,
                35.0548024
              ],
              [
                60.0312704,
                35.0713617
              ],
              [
                60.0303642,
                35.1252541
              ],
              [
                60.0292393,
                35.1379983
              ],
              [
                60.0478362,
                35.1660906
              ],
              [
                60.0590798,
                35.1810346
              ],
              [
                60.0547397,
                35.1933453
              ],
              [
                60.0687787,
                35.2060752
              ],
              [
                60.0691222,
                35.2108438
              ],
              [
                60.0747012,
                35.2201701
              ],
              [
                60.0771045,
                35.2280931
              ],
              [
                60.0831985,
                35.2342627
              ],
              [
                60.0898074,
                35.2509463
              ],
              [
                60.0926175,
                35.2687958
              ],
              [
                60.0873183,
                35.2754749
              ],
              [
                60.083078,
                35.2828781
              ],
              [
                60.0946897,
                35.2978094
              ],
              [
                60.0980929,
                35.3016231
              ],
              [
                60.1193835,
                35.3171453
              ],
              [
                60.1216151,
                35.3209062
              ],
              [
                60.1230239,
                35.3263303
              ],
              [
                60.1256847,
                35.3304618
              ],
              [
                60.1278645,
                35.3365663
              ],
              [
                60.1297187,
                35.3433451
              ],
              [
                60.1305771,
                35.34706
              ],
              [
                60.1237045,
                35.3514471
              ],
              [
                60.1225948,
                35.3553162
              ],
              [
                60.1189041,
                35.3580462
              ],
              [
                60.113368,
                35.3608812
              ],
              [
                60.1074008,
                35.3652416
              ],
              [
                60.1026669,
                35.3672082
              ],
              [
                60.089731,
                35.3740937
              ],
              [
                60.0848284,
                35.3776389
              ],
              [
                60.0714408,
                35.3776832
              ],
              [
                60.0597819,
                35.3777881
              ],
              [
                60.056306,
                35.3782431
              ],
              [
                60.0500342,
                35.3864551
              ],
              [
                60.0482538,
                35.3888334
              ],
              [
                60.0460912,
                35.392953
              ],
              [
                60.0422379,
                35.4007884
              ],
              [
                60.0403768,
                35.4044615
              ],
              [
                60.0351762,
                35.4117529
              ],
              [
                60.0292355,
                35.4186265
              ],
              [
                60.023117,
                35.4265116
              ],
              [
                60.0172643,
                35.4380279
              ],
              [
                60.0189113,
                35.4402886
              ],
              [
                60.0231866,
                35.4437416
              ],
              [
                60.021425,
                35.4513737
              ],
              [
                60.0200236,
                35.4578642
              ],
              [
                60.0200301,
                35.4665719
              ],
              [
                60.0089997,
                35.4641022
              ],
              [
                59.9997051,
                35.4613058
              ],
              [
                59.9917868,
                35.4598278
              ],
              [
                59.9715754,
                35.4660881
              ],
              [
                59.9674129,
                35.4610545
              ],
              [
                59.963164,
                35.4546228
              ],
              [
                59.9518188,
                35.4551645
              ],
              [
                59.9422293,
                35.4485421
              ],
              [
                59.9290917,
                35.4380032
              ],
              [
                59.9232027,
                35.4350162
              ],
              [
                59.9111841,
                35.4362747
              ],
              [
                59.8931216,
                35.4389669
              ],
              [
                59.8768401,
                35.4419739
              ],
              [
                59.8597153,
                35.4465893
              ],
              [
                59.8312127,
                35.444176
              ],
              [
                59.8156213,
                35.444624
              ],
              [
                59.8026609,
                35.4468266
              ],
              [
                59.800692,
                35.4474596
              ],
              [
                59.7747087,
                35.4596534
              ],
              [
                59.7747086,
                35.459924
              ],
              [
                59.7722086,
                35.459924
              ],
              [
                59.7716554,
                35.4602125
              ],
              [
                59.7711019,
                35.4602125
              ],
              [
                59.7586021,
                35.4604831
              ],
              [
                59.7469391,
                35.4652462
              ],
              [
                59.744712,
                35.4655167
              ],
              [
                59.741099,
                35.4655167
              ],
              [
                59.7355458,
                35.4655168
              ],
              [
                59.7341591,
                35.4658053
              ],
              [
                59.7269324,
                35.4658053
              ],
              [
                59.6967994,
                35.4722181
              ],
              [
                59.6954127,
                35.4724976
              ],
              [
                59.6945795,
                35.472218
              ],
              [
                59.693193,
                35.4724976
              ],
              [
                59.6884661,
                35.4724976
              ],
              [
                59.6879129,
                35.4727771
              ],
              [
                59.6546548,
                35.4786647
              ],
              [
                59.647041,
                35.4813905
              ],
              [
                59.6323728,
                35.4876508
              ],
              [
                59.6144004,
                35.4920297
              ],
              [
                59.6141203,
                35.4923092
              ],
              [
                59.6073134,
                35.4934878
              ],
              [
                59.6023321,
                35.4998801
              ],
              [
                59.5981755,
                35.5062446
              ],
              [
                59.5941352,
                35.5040726
              ],
              [
                59.5894146,
                35.502186
              ],
              [
                59.5801016,
                35.5007537
              ],
              [
                59.5725059,
                35.4931717
              ],
              [
                59.5562716,
                35.4927567
              ],
              [
                59.5434093,
                35.4890486
              ],
              [
                59.4897859,
                35.4800461
              ],
              [
                59.486761,
                35.4769575
              ],
              [
                59.4782638,
                35.4741616
              ],
              [
                59.47524,
                35.4749962
              ],
              [
                59.4585962,
                35.4778969
              ],
              [
                59.4476981,
                35.4800287
              ],
              [
                59.4419156,
                35.4792864
              ],
              [
                59.4308131,
                35.4782296
              ],
              [
                59.4138908,
                35.4775166
              ],
              [
                59.4039344,
                35.4806619
              ],
              [
                59.3868542,
                35.4806618
              ],
              [
                59.380669,
                35.481103
              ],
              [
                59.3789955,
                35.4811925
              ],
              [
                59.3794724,
                35.47708
              ],
              [
                59.3788719,
                35.4730082
              ],
              [
                59.3744942,
                35.4678008
              ],
              [
                59.3681452,
                35.4627119
              ],
              [
                59.3632507,
                35.46067
              ],
              [
                59.3497237,
                35.4569993
              ],
              [
                59.3452261,
                35.4507422
              ],
              [
                59.3374702,
                35.4471945
              ],
              [
                59.336637,
                35.4455263
              ],
              [
                59.3284033,
                35.4395544
              ],
              [
                59.3228489,
                35.4245666
              ],
              [
                59.3231296,
                35.4208911
              ],
              [
                59.3222963,
                35.4085506
              ],
              [
                59.3219671,
                35.3991308
              ],
              [
                59.3217001,
                35.3812135
              ],
              [
                59.3201551,
                35.3762283
              ],
              [
                59.3174562,
                35.3727013
              ],
              [
                59.3199454,
                35.3648033
              ],
              [
                59.323511,
                35.3610562
              ],
              [
                59.3314075,
                35.3566463
              ],
              [
                59.338188,
                35.3510461
              ],
              [
                59.3356989,
                35.3411048
              ],
              [
                59.3565558,
                35.3264005
              ],
              [
                59.3540667,
                35.3224789
              ],
              [
                59.3446254,
                35.3097323
              ],
              [
                59.3356131,
                35.2990153
              ],
              [
                59.3332958,
                35.2945669
              ],
              [
                59.3309783,
                35.2918348
              ],
              [
                59.3285321,
                35.2870709
              ],
              [
                59.3286696,
                35.2819352
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555067,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سبزوار",
          "name:ar": "مقاطعة سبزوار",
          "name:en": "Sabzevar County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q369235",
          "wikipedia": "fa:شهرستان سبزوار"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.7469299,
                36.0698285
              ],
              [
                56.7463732,
                36.06283
              ],
              [
                56.7467913,
                36.0505353
              ],
              [
                56.7465147,
                36.0460841
              ],
              [
                56.7462347,
                36.0444261
              ],
              [
                56.7451247,
                36.0335862
              ],
              [
                56.744848,
                36.0330366
              ],
              [
                56.7451246,
                36.0319193
              ],
              [
                56.7448481,
                36.0310903
              ],
              [
                56.7451246,
                36.0288646
              ],
              [
                56.7451246,
                36.0247016
              ],
              [
                56.7442912,
                36.0169253
              ],
              [
                56.7440146,
                36.0138706
              ],
              [
                56.7437346,
                36.0127622
              ],
              [
                56.743458,
                36.0116538
              ],
              [
                56.7596274,
                35.9830387
              ],
              [
                56.7593508,
                35.982489
              ],
              [
                56.7599074,
                35.9752603
              ],
              [
                56.7593507,
                35.9697082
              ],
              [
                56.7587941,
                35.9655351
              ],
              [
                56.7564574,
                35.9616502
              ],
              [
                56.7561775,
                35.9608119
              ],
              [
                56.7578475,
                35.9447056
              ],
              [
                56.7575674,
                35.9438673
              ],
              [
                56.7599317,
                35.9243064
              ],
              [
                56.7579801,
                35.9083778
              ],
              [
                56.7573541,
                35.8987346
              ],
              [
                56.7573451,
                35.884252
              ],
              [
                56.7538101,
                35.8533756
              ],
              [
                56.7652614,
                35.8463558
              ],
              [
                56.7839467,
                35.8348289
              ],
              [
                56.818493,
                35.8126847
              ],
              [
                56.8399318,
                35.7978493
              ],
              [
                56.8551921,
                35.7876017
              ],
              [
                56.8655593,
                35.7785791
              ],
              [
                56.8983079,
                35.7528377
              ],
              [
                56.9086911,
                35.7432314
              ],
              [
                56.9113254,
                35.7360625
              ],
              [
                56.9120853,
                35.7311819
              ],
              [
                56.9191061,
                35.7215946
              ],
              [
                56.930251,
                35.7146196
              ],
              [
                56.9358909,
                35.7121805
              ],
              [
                56.9426464,
                35.7050006
              ],
              [
                56.9463974,
                35.6984029
              ],
              [
                56.9503783,
                35.6922976
              ],
              [
                56.9582747,
                35.6639213
              ],
              [
                56.9584464,
                35.657924
              ],
              [
                56.9627379,
                35.6404178
              ],
              [
                56.9654845,
                35.6335118
              ],
              [
                56.9709777,
                35.6258378
              ],
              [
                56.974211,
                35.6168686
              ],
              [
                56.9879574,
                35.6036103
              ],
              [
                56.9855689,
                35.5973681
              ],
              [
                56.9856547,
                35.5948555
              ],
              [
                56.9828223,
                35.5900396
              ],
              [
                56.9853973,
                35.585014
              ],
              [
                56.9911933,
                35.5815763
              ],
              [
                56.9974501,
                35.5776884
              ],
              [
                57.0105396,
                35.5741175
              ],
              [
                57.0172344,
                35.5710454
              ],
              [
                57.0245719,
                35.5692997
              ],
              [
                57.0310877,
                35.5679775
              ],
              [
                57.0322608,
                35.5644896
              ],
              [
                57.0318317,
                35.5610684
              ],
              [
                57.0365523,
                35.5579263
              ],
              [
                57.0398252,
                35.5503299
              ],
              [
                57.0429951,
                35.5472653
              ],
              [
                57.0477103,
                35.545217
              ],
              [
                57.0499142,
                35.5423558
              ],
              [
                57.0509678,
                35.5378598
              ],
              [
                57.0513969,
                35.5345068
              ],
              [
                57.0491429,
                35.5304295
              ],
              [
                57.0484134,
                35.5292768
              ],
              [
                57.0463399,
                35.5281844
              ],
              [
                57.0441224,
                35.526751
              ],
              [
                57.0405435,
                35.5259397
              ],
              [
                57.0394706,
                35.520945
              ],
              [
                57.0371961,
                35.512352
              ],
              [
                57.0340633,
                35.5079853
              ],
              [
                57.030342,
                35.500141
              ],
              [
                57.0235732,
                35.4957848
              ],
              [
                57.0273685,
                35.4842612
              ],
              [
                57.0294284,
                35.4796484
              ],
              [
                57.0317512,
                35.4779512
              ],
              [
                57.040331,
                35.4758635
              ],
              [
                57.0481824,
                35.4709112
              ],
              [
                57.0511436,
                35.4687093
              ],
              [
                57.0577526,
                35.4653538
              ],
              [
                57.064564,
                35.4633859
              ],
              [
                57.0680522,
                35.4613341
              ],
              [
                57.0775342,
                35.4583873
              ],
              [
                57.0822382,
                35.4563597
              ],
              [
                57.0959603,
                35.4486596
              ],
              [
                57.0996809,
                35.4474559
              ],
              [
                57.1019125,
                35.4469314
              ],
              [
                57.1065044,
                35.4465119
              ],
              [
                57.1098947,
                35.4461273
              ],
              [
                57.1152997,
                35.4442264
              ],
              [
                57.119471,
                35.4438067
              ],
              [
                57.1236328,
                35.4436928
              ],
              [
                57.1270179,
                35.4448337
              ],
              [
                57.1322965,
                35.4453232
              ],
              [
                57.1368455,
                35.446442
              ],
              [
                57.1407535,
                35.4484897
              ],
              [
                57.1445703,
                35.4523502
              ],
              [
                57.1552133,
                35.4577337
              ],
              [
                57.1646116,
                35.4654239
              ],
              [
                57.2095012,
                35.4822344
              ],
              [
                57.2224221,
                35.487614
              ],
              [
                57.3243209,
                35.5030316
              ],
              [
                57.3287675,
                35.5035816
              ],
              [
                57.3373809,
                35.5055293
              ],
              [
                57.3412674,
                35.5074769
              ],
              [
                57.3440475,
                35.5083065
              ],
              [
                57.3609869,
                35.5171879
              ],
              [
                57.3618206,
                35.5171879
              ],
              [
                57.3687672,
                35.518306
              ],
              [
                57.3704336,
                35.5180265
              ],
              [
                57.3710282,
                35.5181262
              ],
              [
                57.3721005,
                35.518306
              ],
              [
                57.3729336,
                35.518306
              ],
              [
                57.3768271,
                35.518306
              ],
              [
                57.3776604,
                35.5185855
              ],
              [
                57.38488,
                35.518856
              ],
              [
                57.4165463,
                35.5180264
              ],
              [
                57.4271063,
                35.520524
              ],
              [
                57.4348795,
                35.5241398
              ],
              [
                57.4640528,
                35.5463656
              ],
              [
                57.4757989,
                35.5396361
              ],
              [
                57.4788592,
                35.5404747
              ],
              [
                57.4906554,
                35.5304084
              ],
              [
                57.4992686,
                35.5304084
              ],
              [
                57.5178125,
                35.5274913
              ],
              [
                57.5292016,
                35.5181465
              ],
              [
                57.5428822,
                35.5212207
              ],
              [
                57.5519228,
                35.5167408
              ],
              [
                57.5702631,
                35.5168718
              ],
              [
                57.5863336,
                35.5171589
              ],
              [
                57.5988225,
                35.5172989
              ],
              [
                57.6106218,
                35.5244698
              ],
              [
                57.6197465,
                35.5320132
              ],
              [
                57.6304862,
                35.5299876
              ],
              [
                57.6516473,
                35.5332628
              ],
              [
                57.6594913,
                35.5225694
              ],
              [
                57.6849603,
                35.5301657
              ],
              [
                57.7049589,
                35.5409568
              ],
              [
                57.7140998,
                35.5512925
              ],
              [
                57.731502,
                35.5448503
              ],
              [
                57.7323409,
                35.5449336
              ],
              [
                57.73324,
                35.5522004
              ],
              [
                57.7327251,
                35.5612778
              ],
              [
                57.7360725,
                35.5654671
              ],
              [
                57.7368449,
                35.5695165
              ],
              [
                57.7394199,
                35.577126
              ],
              [
                57.7353,
                35.5862705
              ],
              [
                57.7347212,
                35.5919613
              ],
              [
                57.7367591,
                35.5961118
              ],
              [
                57.7362441,
                35.600718
              ],
              [
                57.7345275,
                35.6028116
              ],
              [
                57.7226828,
                35.608185
              ],
              [
                57.7174472,
                35.6127904
              ],
              [
                57.7123831,
                35.6153025
              ],
              [
                57.7127264,
                35.6203262
              ],
              [
                57.7182196,
                35.6267449
              ],
              [
                57.7123831,
                35.6355349
              ],
              [
                57.7056883,
                35.6433474
              ],
              [
                57.7005385,
                35.6468349
              ],
              [
                57.6969336,
                35.6574359
              ],
              [
                57.6960753,
                35.6687328
              ],
              [
                57.6996802,
                35.6769604
              ],
              [
                57.7019118,
                35.6871391
              ],
              [
                57.7051733,
                35.693413
              ],
              [
                57.7125548,
                35.6964801
              ],
              [
                57.7221678,
                35.7026139
              ],
              [
                57.7199362,
                35.7113955
              ],
              [
                57.7218245,
                35.7197581
              ],
              [
                57.7286909,
                35.7302101
              ],
              [
                57.7365874,
                35.740382
              ],
              [
                57.7410505,
                35.7430293
              ],
              [
                57.7439688,
                35.7491595
              ],
              [
                57.7496336,
                35.7533389
              ],
              [
                57.7556418,
                35.7654579
              ],
              [
                57.7565001,
                35.77855
              ],
              [
                57.7451704,
                35.7798034
              ],
              [
                57.7376173,
                35.7830064
              ],
              [
                57.7216528,
                35.7874625
              ],
              [
                57.70483,
                35.7928931
              ],
              [
                57.6972769,
                35.8019432
              ],
              [
                57.7010326,
                35.8042798
              ],
              [
                57.701826,
                35.8079992
              ],
              [
                57.7025985,
                35.8140548
              ],
              [
                57.7005385,
                35.8189268
              ],
              [
                57.6991652,
                35.8263039
              ],
              [
                57.7007448,
                35.8329823
              ],
              [
                57.7028695,
                35.8379308
              ],
              [
                57.6548912,
                35.8852571
              ],
              [
                57.6535044,
                35.8860864
              ],
              [
                57.6357247,
                35.9008142
              ],
              [
                57.6226042,
                35.9268688
              ],
              [
                57.6231381,
                35.9362306
              ],
              [
                57.5553989,
                35.9732135
              ],
              [
                57.5429534,
                35.9747417
              ],
              [
                57.5236079,
                35.9812387
              ],
              [
                57.5111498,
                35.9841488
              ],
              [
                57.5000489,
                35.9864353
              ],
              [
                57.5068187,
                35.9897438
              ],
              [
                57.5112819,
                35.9938411
              ],
              [
                57.5152301,
                35.996341
              ],
              [
                57.5199508,
                35.9975909
              ],
              [
                57.5304221,
                36.007798
              ],
              [
                57.567844,
                36.051875
              ],
              [
                57.587242,
                36.057426
              ],
              [
                57.588272,
                36.0639482
              ],
              [
                57.600288,
                36.0716494
              ],
              [
                57.6138496,
                36.077754
              ],
              [
                57.6236343,
                36.0790721
              ],
              [
                57.6402854,
                36.0827485
              ],
              [
                57.6523875,
                36.0848295
              ],
              [
                57.6642322,
                36.0858699
              ],
              [
                57.6774134,
                36.0852855
              ],
              [
                57.7005383,
                36.0796272
              ],
              [
                57.8299709,
                36.0698457
              ],
              [
                57.8630943,
                36.0785457
              ],
              [
                57.8850276,
                36.0967981
              ],
              [
                57.9033889,
                36.111106
              ],
              [
                57.902584,
                36.1357259
              ],
              [
                57.9112339,
                36.14332
              ],
              [
                57.9204619,
                36.1408247
              ],
              [
                57.9326819,
                36.136383
              ],
              [
                57.9549888,
                36.1286903
              ],
              [
                57.9756065,
                36.1115686
              ],
              [
                57.9863716,
                36.107007
              ],
              [
                58.00039,
                36.1010384
              ],
              [
                58.0184345,
                36.0987498
              ],
              [
                58.0312116,
                36.0986783
              ],
              [
                58.0383705,
                36.0990299
              ],
              [
                58.0447807,
                36.0981977
              ],
              [
                58.05145,
                36.0988798
              ],
              [
                58.0590879,
                36.0990821
              ],
              [
                58.0716923,
                36.0958101
              ],
              [
                58.0839852,
                36.0936559
              ],
              [
                58.0976471,
                36.0885919
              ],
              [
                58.1037927,
                36.0856073
              ],
              [
                58.1155825,
                36.0808873
              ],
              [
                58.1248855,
                36.0760198
              ],
              [
                58.1342344,
                36.072071
              ],
              [
                58.1436094,
                36.0698526
              ],
              [
                58.1741845,
                36.0595791
              ],
              [
                58.1807871,
                36.0588126
              ],
              [
                58.1875444,
                36.0590711
              ],
              [
                58.2050616,
                36.0557446
              ],
              [
                58.2131897,
                36.0555663
              ],
              [
                58.2178475,
                36.0589491
              ],
              [
                58.2187709,
                36.0611255
              ],
              [
                58.2276044,
                36.0679977
              ],
              [
                58.2307911,
                36.0691732
              ],
              [
                58.2350197,
                36.0717981
              ],
              [
                58.2362937,
                36.0727592
              ],
              [
                58.2499407,
                36.1153437
              ],
              [
                58.2564934,
                36.1226055
              ],
              [
                58.2595466,
                36.126768
              ],
              [
                58.263149,
                36.1298213
              ],
              [
                58.2721966,
                36.1326179
              ],
              [
                58.2785863,
                36.1337274
              ],
              [
                58.2869952,
                36.1388696
              ],
              [
                58.2859897,
                36.1463656
              ],
              [
                58.2751622,
                36.1537643
              ],
              [
                58.2680939,
                36.1585632
              ],
              [
                58.2742428,
                36.1667921
              ],
              [
                58.2772942,
                36.1705415
              ],
              [
                58.2810543,
                36.1755742
              ],
              [
                58.2803677,
                36.1905726
              ],
              [
                58.2518757,
                36.1869332
              ],
              [
                58.2418727,
                36.187386
              ],
              [
                58.2357786,
                36.1881827
              ],
              [
                58.2331608,
                36.1899492
              ],
              [
                58.2322439,
                36.1945329
              ],
              [
                58.2321855,
                36.2039274
              ],
              [
                58.2368086,
                36.210139
              ],
              [
                58.2400273,
                36.2164062
              ],
              [
                58.2415181,
                36.2237434
              ],
              [
                58.2404113,
                36.2271806
              ],
              [
                58.233075,
                36.2381815
              ],
              [
                58.2336759,
                36.239289
              ],
              [
                58.2358215,
                36.2465576
              ],
              [
                58.2273672,
                36.2480458
              ],
              [
                58.2142424,
                36.2502368
              ],
              [
                58.1955902,
                36.247951
              ],
              [
                58.1935731,
                36.251345
              ],
              [
                58.1879592,
                36.2601721
              ],
              [
                58.171663,
                36.2636349
              ],
              [
                58.1605354,
                36.2603542
              ],
              [
                58.1605164,
                36.2595643
              ],
              [
                58.1525415,
                36.2603862
              ],
              [
                58.1438898,
                36.2612193
              ],
              [
                58.129666,
                36.262745
              ],
              [
                58.1205082,
                36.2602966
              ],
              [
                58.1131518,
                36.2578039
              ],
              [
                58.0574475,
                36.2625691
              ],
              [
                58.0552208,
                36.2633983
              ],
              [
                58.0538341,
                36.2633982
              ],
              [
                58.053554,
                36.2636776
              ],
              [
                58.0477207,
                36.2636776
              ],
              [
                58.0074933,
                36.2798613
              ],
              [
                58.0061065,
                36.2801406
              ],
              [
                58.004386,
                36.2820793
              ],
              [
                58.0013158,
                36.2844278
              ],
              [
                57.9920775,
                36.2876115
              ],
              [
                57.9917974,
                36.2878908
              ],
              [
                57.9906911,
                36.2878908
              ],
              [
                57.9898575,
                36.2881701
              ],
              [
                57.9892978,
                36.2881701
              ],
              [
                57.9851309,
                36.2887287
              ],
              [
                57.9560799,
                36.3105925
              ],
              [
                57.9555267,
                36.3108717
              ],
              [
                57.9546935,
                36.3108717
              ],
              [
                57.9541399,
                36.311151
              ],
              [
                57.9527465,
                36.311151
              ],
              [
                57.9496934,
                36.3119885
              ],
              [
                57.9483066,
                36.3119886
              ],
              [
                57.945807,
                36.3128173
              ],
              [
                57.9449734,
                36.3128173
              ],
              [
                57.9315369,
                36.3168517
              ],
              [
                57.9170973,
                36.314815
              ],
              [
                57.9025192,
                36.3099245
              ],
              [
                57.8874778,
                36.3129812
              ],
              [
                57.8775214,
                36.3127737
              ],
              [
                57.8710841,
                36.3138112
              ],
              [
                57.8618143,
                36.316301
              ],
              [
                57.8583812,
                36.3255677
              ],
              [
                57.8647326,
                36.329371
              ],
              [
                57.8538321,
                36.340572
              ],
              [
                57.850716,
                36.3435726
              ],
              [
                57.8008734,
                36.3506267
              ],
              [
                57.7913473,
                36.3584074
              ],
              [
                57.7641904,
                36.3817589
              ],
              [
                57.7393338,
                36.3809379
              ],
              [
                57.7158114,
                36.3640971
              ],
              [
                57.6960751,
                36.3673928
              ],
              [
                57.6965045,
                36.3737508
              ],
              [
                57.6960754,
                36.376446
              ],
              [
                57.6994228,
                36.3789337
              ],
              [
                57.7019977,
                36.3890221
              ],
              [
                57.7130698,
                36.3937204
              ],
              [
                57.722597,
                36.4012509
              ],
              [
                57.7202796,
                36.4101621
              ],
              [
                57.7132412,
                36.4187963
              ],
              [
                57.6964184,
                36.4102314
              ],
              [
                57.6868054,
                36.413547
              ],
              [
                57.6771923,
                36.4140996
              ],
              [
                57.6648327,
                36.4168624
              ],
              [
                57.6710125,
                36.4248741
              ],
              [
                57.6839729,
                36.4407568
              ],
              [
                57.686031,
                36.4498919
              ],
              [
                57.6878607,
                36.4543879
              ],
              [
                57.6787376,
                36.4557386
              ],
              [
                57.6712703,
                36.4535985
              ],
              [
                57.6607989,
                36.4382708
              ],
              [
                57.6572799,
                36.4355778
              ],
              [
                57.6503274,
                36.4335754
              ],
              [
                57.6432798,
                36.4410602
              ],
              [
                57.6210515,
                36.4363128
              ],
              [
                57.6094036,
                36.4338614
              ],
              [
                57.5808674,
                36.4424524
              ],
              [
                57.5796359,
                36.4422505
              ],
              [
                57.5738068,
                36.4224148
              ],
              [
                57.5721399,
                36.4224148
              ],
              [
                57.5601801,
                36.4168721
              ],
              [
                57.5546067,
                36.4152114
              ],
              [
                57.5504403,
                36.4152115
              ],
              [
                57.5493269,
                36.4154907
              ],
              [
                57.5476602,
                36.4152114
              ],
              [
                57.547107,
                36.4154907
              ],
              [
                57.5437737,
                36.4154907
              ],
              [
                57.5360137,
                36.4257268
              ],
              [
                57.5346269,
                36.4257268
              ],
              [
                57.5273397,
                36.434889
              ],
              [
                57.5148399,
                36.4359967
              ],
              [
                57.5076466,
                36.4395933
              ],
              [
                57.5051467,
                36.4395933
              ],
              [
                57.4836473,
                36.4249654
              ],
              [
                57.4579412,
                36.4241634
              ],
              [
                57.4534946,
                36.4252714
              ],
              [
                57.4460707,
                36.4250374
              ],
              [
                57.4407976,
                36.4250374
              ],
              [
                57.4344041,
                36.4244879
              ],
              [
                57.4332978,
                36.4242086
              ],
              [
                57.4319043,
                36.4242086
              ],
              [
                57.4310708,
                36.4239293
              ],
              [
                57.4294043,
                36.4239292
              ],
              [
                57.4288512,
                36.42365
              ],
              [
                57.4263512,
                36.42365
              ],
              [
                57.4257909,
                36.4233708
              ],
              [
                57.4238511,
                36.4233708
              ],
              [
                57.423571,
                36.4230915
              ],
              [
                57.414758,
                36.4219865
              ],
              [
                57.4105911,
                36.4211577
              ],
              [
                57.4092048,
                36.4211576
              ],
              [
                57.4080914,
                36.4208784
              ],
              [
                57.4067046,
                36.4208784
              ],
              [
                57.4047581,
                36.4203198
              ],
              [
                57.4033714,
                36.4203198
              ],
              [
                57.3927651,
                36.4197673
              ],
              [
                57.392485,
                36.4194881
              ],
              [
                57.3919319,
                36.419488
              ],
              [
                57.389985,
                36.4186592
              ],
              [
                57.3894318,
                36.4183798
              ],
              [
                57.3885982,
                36.4183799
              ],
              [
                57.3781686,
                36.4200196
              ],
              [
                57.3773354,
                36.4200196
              ],
              [
                57.3634886,
                36.4205513
              ],
              [
                57.3629355,
                36.4205513
              ],
              [
                57.3626555,
                36.4202721
              ],
              [
                57.3618223,
                36.4202721
              ],
              [
                57.3280334,
                36.4257717
              ],
              [
                57.292532,
                36.4215028
              ],
              [
                57.2820505,
                36.4198774
              ],
              [
                57.2903672,
                36.4129704
              ],
              [
                57.2984352,
                36.407925
              ],
              [
                57.3205128,
                36.3852918
              ],
              [
                57.3429355,
                36.3774922
              ],
              [
                57.3446023,
                36.3747175
              ],
              [
                57.3280331,
                36.3549514
              ],
              [
                57.3342129,
                36.3416783
              ],
              [
                57.3474258,
                36.3356447
              ],
              [
                57.3750683,
                36.3397425
              ],
              [
                57.3922917,
                36.3183471
              ],
              [
                57.3959051,
                36.3164011
              ],
              [
                57.4045453,
                36.3096831
              ],
              [
                57.4160815,
                36.3010415
              ],
              [
                57.4162213,
                36.2945494
              ],
              [
                57.4166536,
                36.2908808
              ],
              [
                57.4162244,
                36.2852424
              ],
              [
                57.415924,
                36.2806413
              ],
              [
                57.4145451,
                36.2727475
              ],
              [
                57.4136924,
                36.266802
              ],
              [
                57.4140787,
                36.2501569
              ],
              [
                57.4132204,
                36.2449308
              ],
              [
                57.4132204,
                36.2407774
              ],
              [
                57.4098301,
                36.236416
              ],
              [
                57.4100446,
                36.2310852
              ],
              [
                57.4105167,
                36.2264117
              ],
              [
                57.4115467,
                36.2247846
              ],
              [
                57.413392,
                36.2183104
              ],
              [
                57.4172544,
                36.2113855
              ],
              [
                57.424035,
                36.2031787
              ],
              [
                57.4344205,
                36.1959062
              ],
              [
                57.4375104,
                36.1935511
              ],
              [
                57.443304,
                36.1902608
              ],
              [
                57.4498701,
                36.1828832
              ],
              [
                57.4617576,
                36.1680564
              ],
              [
                57.4667787,
                36.165458
              ],
              [
                57.4717569,
                36.1606767
              ],
              [
                57.474246,
                36.156692
              ],
              [
                57.470684,
                36.1495884
              ],
              [
                57.4681949,
                36.1466428
              ],
              [
                57.4658346,
                36.1415831
              ],
              [
                57.4639034,
                36.1377015
              ],
              [
                57.4616718,
                36.1338889
              ],
              [
                57.4555349,
                36.125882
              ],
              [
                57.4508571,
                36.1275459
              ],
              [
                57.4489259,
                36.1244608
              ],
              [
                57.4474239,
                36.1240448
              ],
              [
                57.444334,
                36.120301
              ],
              [
                57.4385833,
                36.1178743
              ],
              [
                57.4298286,
                36.1147888
              ],
              [
                57.42455,
                36.1154475
              ],
              [
                57.4182415,
                36.1139568
              ],
              [
                57.4141216,
                36.1124313
              ],
              [
                57.4127054,
                36.1101778
              ],
              [
                57.4070835,
                36.1079935
              ],
              [
                57.4016332,
                36.1076468
              ],
              [
                57.3958396,
                36.1035554
              ],
              [
                57.3925441,
                36.1028277
              ],
              [
                57.3655479,
                36.0927697
              ],
              [
                57.365275,
                36.0924902
              ],
              [
                57.3638816,
                36.0924902
              ],
              [
                57.363328,
                36.0922108
              ],
              [
                57.3547149,
                36.0913818
              ],
              [
                57.3246685,
                36.0952658
              ],
              [
                57.3238353,
                36.0949864
              ],
              [
                57.3199485,
                36.0949864
              ],
              [
                57.318282,
                36.0947071
              ],
              [
                57.3160554,
                36.0947071
              ],
              [
                57.3033139,
                36.0868412
              ],
              [
                57.2857091,
                36.0849911
              ],
              [
                57.2840424,
                36.084991
              ],
              [
                57.2826559,
                36.0847117
              ],
              [
                57.2779325,
                36.0841619
              ],
              [
                57.2701525,
                36.0841619
              ],
              [
                57.2568163,
                36.0935282
              ],
              [
                57.2244121,
                36.1108734
              ],
              [
                57.2188431,
                36.1079672
              ],
              [
                57.1878301,
                36.1083264
              ],
              [
                57.1861636,
                36.1083264
              ],
              [
                57.1853303,
                36.1086057
              ],
              [
                57.1831068,
                36.1086058
              ],
              [
                57.1814402,
                36.1088851
              ],
              [
                57.1747737,
                36.1088851
              ],
              [
                57.1733871,
                36.1091644
              ],
              [
                57.169217,
                36.1091645
              ],
              [
                57.1625505,
                36.1094439
              ],
              [
                57.1583838,
                36.1094438
              ],
              [
                57.1569973,
                36.1091645
              ],
              [
                57.1517173,
                36.1091645
              ],
              [
                57.1503273,
                36.1088851
              ],
              [
                57.1469939,
                36.1088852
              ],
              [
                57.1436606,
                36.1083265
              ],
              [
                57.1417175,
                36.1083264
              ],
              [
                57.1307043,
                36.1113776
              ],
              [
                57.1186542,
                36.1108528
              ],
              [
                57.1168245,
                36.109991
              ],
              [
                57.1034779,
                36.1019338
              ],
              [
                57.0894081,
                36.0905499
              ],
              [
                57.0816315,
                36.0883238
              ],
              [
                57.0691782,
                36.08277
              ],
              [
                57.066125,
                36.0808233
              ],
              [
                57.0564648,
                36.0787948
              ],
              [
                57.0499417,
                36.0718576
              ],
              [
                57.0403449,
                36.0708228
              ],
              [
                57.0386783,
                36.0708228
              ],
              [
                57.0375683,
                36.0705434
              ],
              [
                57.0359016,
                36.0705434
              ],
              [
                57.0245784,
                36.0660953
              ],
              [
                57.0190252,
                36.0644281
              ],
              [
                56.9810199,
                36.0861474
              ],
              [
                56.9492446,
                36.0989315
              ],
              [
                56.9252076,
                36.1076949
              ],
              [
                56.9012782,
                36.1159591
              ],
              [
                56.8840936,
                36.1246969
              ],
              [
                56.8744182,
                36.1274766
              ],
              [
                56.8487018,
                36.1303918
              ],
              [
                56.8371646,
                36.1335043
              ],
              [
                56.8235203,
                36.1364193
              ],
              [
                56.8041226,
                36.1389841
              ],
              [
                56.7864246,
                36.1482853
              ],
              [
                56.7847581,
                36.1485646
              ],
              [
                56.7819815,
                36.1485645
              ],
              [
                56.7644816,
                36.1521772
              ],
              [
                56.7592016,
                36.1532853
              ],
              [
                56.7581767,
                36.1535431
              ],
              [
                56.7578116,
                36.1524475
              ],
              [
                56.757535,
                36.1521773
              ],
              [
                56.7533683,
                36.1394024
              ],
              [
                56.7528116,
                36.138844
              ],
              [
                56.7528116,
                36.1382944
              ],
              [
                56.750104,
                36.1318971
              ],
              [
                56.7482471,
                36.1137488
              ],
              [
                56.7488449,
                36.1066758
              ],
              [
                56.747847,
                36.0896383
              ],
              [
                56.7472255,
                36.0744876
              ],
              [
                56.7469299,
                36.0698285
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555073,
        "tags": {
          "admin_level": "5",
          "alt_name:tk": "Sarahs etraby",
          "alt_name:tk-Arab": "ساراحس اترابیٛ",
          "boundary": "administrative",
          "name": "شهرستان سرخس",
          "name:en": "Sarakhs County",
          "name:tk": "Sarahs şähristany",
          "name:tk-Arab": "ساراحس شأهریستانیٛ",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1278163",
          "wikipedia": "fa:شهرستان سرخس"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.2075168,
                36.4113761
              ],
              [
                60.2080699,
                36.4108267
              ],
              [
                60.2097368,
                36.4097096
              ],
              [
                60.2114032,
                36.4091601
              ],
              [
                60.2458495,
                36.3894321
              ],
              [
                60.2464093,
                36.3886033
              ],
              [
                60.2477962,
                36.3877655
              ],
              [
                60.2547427,
                36.3805408
              ],
              [
                60.2702957,
                36.3685955
              ],
              [
                60.2840056,
                36.3563535
              ],
              [
                60.294092,
                36.3521918
              ],
              [
                60.2979789,
                36.3488586
              ],
              [
                60.2988121,
                36.3483002
              ],
              [
                60.312225,
                36.3417933
              ],
              [
                60.3131781,
                36.3410836
              ],
              [
                60.3192916,
                36.3369127
              ],
              [
                60.3477182,
                36.3088519
              ],
              [
                60.3616114,
                36.3013565
              ],
              [
                60.3763308,
                36.2905279
              ],
              [
                60.3887871,
                36.2794467
              ],
              [
                60.4102636,
                36.2575447
              ],
              [
                60.4102636,
                36.2567065
              ],
              [
                60.4102635,
                36.2558776
              ],
              [
                60.4080436,
                36.2542104
              ],
              [
                60.3952636,
                36.2464336
              ],
              [
                60.3933167,
                36.2444869
              ],
              [
                60.3827637,
                36.2350338
              ],
              [
                60.3557965,
                36.2193493
              ],
              [
                60.3211288,
                36.2081495
              ],
              [
                60.3205756,
                36.2048144
              ],
              [
                60.3205757,
                36.2014791
              ],
              [
                60.3210789,
                36.1986818
              ],
              [
                60.3084181,
                36.1937244
              ],
              [
                60.3130557,
                36.1849464
              ],
              [
                60.3206222,
                36.1784024
              ],
              [
                60.324972,
                36.1731223
              ],
              [
                60.3280255,
                36.1670107
              ],
              [
                60.3297041,
                36.1629636
              ],
              [
                60.3190611,
                36.1500737
              ],
              [
                60.3089331,
                36.1459152
              ],
              [
                60.3155408,
                36.11859
              ],
              [
                60.3180408,
                36.1141352
              ],
              [
                60.318874,
                36.113585
              ],
              [
                60.3628514,
                36.0949388
              ],
              [
                60.3659045,
                36.089384
              ],
              [
                60.3709047,
                36.0788154
              ],
              [
                60.3952438,
                36.0853204
              ],
              [
                60.4078933,
                36.0869622
              ],
              [
                60.4208597,
                36.0874826
              ],
              [
                60.4311594,
                36.0889943
              ],
              [
                60.4465406,
                36.0904938
              ],
              [
                60.4509872,
                36.0913225
              ],
              [
                60.4532071,
                36.0913224
              ],
              [
                60.4543209,
                36.0916106
              ],
              [
                60.4707523,
                36.070797
              ],
              [
                60.4729472,
                36.0549777
              ],
              [
                60.4740605,
                36.0546983
              ],
              [
                60.4757269,
                36.0546983
              ],
              [
                60.4768406,
                36.0544189
              ],
              [
                60.4832387,
                36.0474849
              ],
              [
                60.4970674,
                36.045186
              ],
              [
                60.497621,
                36.0443569
              ],
              [
                60.4993209,
                36.035255
              ],
              [
                60.5004342,
                36.0313706
              ],
              [
                60.5082319,
                36.0200865
              ],
              [
                60.5162179,
                36.0144231
              ],
              [
                60.5163643,
                36.0096992
              ],
              [
                60.5163643,
                36.0041473
              ],
              [
                60.5158112,
                35.9958104
              ],
              [
                60.5183113,
                35.9899792
              ],
              [
                60.5286377,
                35.9730256
              ],
              [
                60.5303042,
                35.9727551
              ],
              [
                60.5359744,
                35.9721994
              ],
              [
                60.5365274,
                35.97192
              ],
              [
                60.5373611,
                35.9719201
              ],
              [
                60.5684021,
                35.9756765
              ],
              [
                60.5773167,
                35.9731796
              ],
              [
                60.5775969,
                35.9728913
              ],
              [
                60.5803945,
                35.9637587
              ],
              [
                60.5942768,
                35.9605334
              ],
              [
                60.5945569,
                35.9610832
              ],
              [
                60.6044464,
                35.9552502
              ],
              [
                60.6220964,
                35.95303
              ],
              [
                60.6232098,
                35.9535799
              ],
              [
                60.635236,
                35.9480186
              ],
              [
                60.6428967,
                35.9507933
              ],
              [
                60.6636359,
                35.9527405
              ],
              [
                60.6703024,
                35.9560859
              ],
              [
                60.6728025,
                35.9560859
              ],
              [
                60.6736361,
                35.9560859
              ],
              [
                60.6783557,
                35.9560859
              ],
              [
                60.6789088,
                35.9557972
              ],
              [
                60.6819691,
                35.9557972
              ],
              [
                60.6841887,
                35.9555268
              ],
              [
                60.6847425,
                35.9552472
              ],
              [
                60.6858558,
                35.9552472
              ],
              [
                60.6866887,
                35.9549678
              ],
              [
                60.6883559,
                35.9549677
              ],
              [
                60.6908551,
                35.9544087
              ],
              [
                60.692249,
                35.9544086
              ],
              [
                60.6964155,
                35.9532995
              ],
              [
                60.6972491,
                35.9532994
              ],
              [
                60.6978022,
                35.9530199
              ],
              [
                60.6986358,
                35.9530199
              ],
              [
                60.6986358,
                35.9527404
              ],
              [
                60.7030821,
                35.9524699
              ],
              [
                60.7128018,
                35.9510812
              ],
              [
                60.7197488,
                35.9488539
              ],
              [
                60.7214151,
                35.9485745
              ],
              [
                60.7247489,
                35.9471857
              ],
              [
                60.7255817,
                35.9471857
              ],
              [
                60.7297482,
                35.9455175
              ],
              [
                60.7484416,
                35.9427429
              ],
              [
                60.7523347,
                35.9413542
              ],
              [
                60.7662916,
                35.9449676
              ],
              [
                60.7685112,
                35.9446881
              ],
              [
                60.7776778,
                35.9435792
              ],
              [
                60.7796247,
                35.9430202
              ],
              [
                60.7912031,
                35.9477375
              ],
              [
                60.8012908,
                35.9414836
              ],
              [
                60.8024049,
                35.9417722
              ],
              [
                60.8108509,
                35.9428839
              ],
              [
                60.8155776,
                35.9423249
              ],
              [
                60.8161307,
                35.9420455
              ],
              [
                60.819121,
                35.9513565
              ],
              [
                60.8224183,
                35.9553153
              ],
              [
                60.8211145,
                35.969557
              ],
              [
                60.8219877,
                35.9713615
              ],
              [
                60.8244877,
                35.9713615
              ],
              [
                60.8256011,
                35.9716408
              ],
              [
                60.8454177,
                35.9659446
              ],
              [
                60.856669,
                35.9580291
              ],
              [
                60.8608355,
                35.9571908
              ],
              [
                60.8742138,
                35.9658095
              ],
              [
                60.884474,
                35.9701148
              ],
              [
                60.891019,
                35.9745574
              ],
              [
                60.8987868,
                35.9819214
              ],
              [
                60.8996204,
                35.9816511
              ],
              [
                60.9018471,
                35.9813316
              ],
              [
                60.9274289,
                35.9802291
              ],
              [
                60.9373852,
                35.9802291
              ],
              [
                60.9439083,
                35.9907857
              ],
              [
                60.9602791,
                35.9885994
              ],
              [
                60.969166,
                35.9863742
              ],
              [
                60.9836124,
                35.9838787
              ],
              [
                60.9899985,
                35.9824913
              ],
              [
                61.0107187,
                35.9597054
              ],
              [
                61.0193321,
                35.9549838
              ],
              [
                61.0204454,
                35.9547134
              ],
              [
                61.0168087,
                35.9374838
              ],
              [
                61.028404,
                35.9252663
              ],
              [
                61.0325705,
                35.9233198
              ],
              [
                61.0359839,
                35.9141529
              ],
              [
                61.0370972,
                35.9141529
              ],
              [
                61.0379309,
                35.9138736
              ],
              [
                61.0398046,
                35.9120662
              ],
              [
                61.0411913,
                35.9123456
              ],
              [
                61.0423047,
                35.9120662
              ],
              [
                61.0433209,
                35.9088684
              ],
              [
                61.0480405,
                35.9083185
              ],
              [
                61.0488741,
                35.9080302
              ],
              [
                61.0508202,
                35.9080303
              ],
              [
                61.0578987,
                35.9188793
              ],
              [
                61.0706731,
                35.9361297
              ],
              [
                61.0717864,
                35.9358504
              ],
              [
                61.0742857,
                35.9358505
              ],
              [
                61.0767857,
                35.9369585
              ],
              [
                61.0790132,
                35.9380665
              ],
              [
                61.1198247,
                35.9369373
              ],
              [
                61.1406178,
                35.9383207
              ],
              [
                61.169784,
                35.9394192
              ],
              [
                61.1722681,
                35.9474458
              ],
              [
                61.1602844,
                35.9507704
              ],
              [
                61.1592799,
                35.9505163
              ],
              [
                61.1586791,
                35.9503079
              ],
              [
                61.1544304,
                35.9467469
              ],
              [
                61.1540333,
                35.9465719
              ],
              [
                61.1534648,
                35.9464342
              ],
              [
                61.1530357,
                35.9463994
              ],
              [
                61.1527782,
                35.9463473
              ],
              [
                61.1521559,
                35.9465037
              ],
              [
                61.1518341,
                35.94666
              ],
              [
                61.1513405,
                35.946799
              ],
              [
                61.1478858,
                35.9475286
              ],
              [
                61.14677,
                35.9476154
              ],
              [
                61.1457615,
                35.9477023
              ],
              [
                61.1448389,
                35.9478934
              ],
              [
                61.1440235,
                35.9481365
              ],
              [
                61.1435943,
                35.948345
              ],
              [
                61.142972,
                35.948484
              ],
              [
                61.1424141,
                35.9485187
              ],
              [
                61.1418133,
                35.948484
              ],
              [
                61.1413842,
                35.9486056
              ],
              [
                61.1405688,
                35.9489356
              ],
              [
                61.1401825,
                35.9492135
              ],
              [
                61.139968,
                35.9496131
              ],
              [
                61.1397534,
                35.9501168
              ],
              [
                61.1392384,
                35.9509853
              ],
              [
                61.1390667,
                35.9514196
              ],
              [
                61.1391311,
                35.9516107
              ],
              [
                61.1393671,
                35.9521318
              ],
              [
                61.1393886,
                35.9524097
              ],
              [
                61.1392599,
                35.9526008
              ],
              [
                61.1391097,
                35.952705
              ],
              [
                61.1358695,
                35.9527745
              ],
              [
                61.135376,
                35.9528787
              ],
              [
                61.1339169,
                35.9533651
              ],
              [
                61.1334448,
                35.9537472
              ],
              [
                61.1332088,
                35.9540251
              ],
              [
                61.1330095,
                35.9543825
              ],
              [
                61.1327889,
                35.954586
              ],
              [
                61.1325405,
                35.95471
              ],
              [
                61.1323781,
                35.954792
              ],
              [
                61.132136,
                35.9550448
              ],
              [
                61.1319179,
                35.9553812
              ],
              [
                61.1317834,
                35.9555884
              ],
              [
                61.131578,
                35.9558836
              ],
              [
                61.1313849,
                35.9560052
              ],
              [
                61.1311887,
                35.956092
              ],
              [
                61.1310108,
                35.9562757
              ],
              [
                61.1304131,
                35.9574716
              ],
              [
                61.1301648,
                35.9580027
              ],
              [
                61.1300116,
                35.9582632
              ],
              [
                61.1294752,
                35.958628
              ],
              [
                61.1282092,
                35.9590969
              ],
              [
                61.1269646,
                35.9593227
              ],
              [
                61.1265324,
                35.9592607
              ],
              [
                61.1262351,
                35.9591316
              ],
              [
                61.1257844,
                35.9587669
              ],
              [
                61.1255913,
                35.9584543
              ],
              [
                61.125248,
                35.9582632
              ],
              [
                61.1248188,
                35.9579853
              ],
              [
                61.1246686,
                35.9577769
              ],
              [
                61.1247545,
                35.9575511
              ],
              [
                61.1248832,
                35.9573427
              ],
              [
                61.1250334,
                35.9568563
              ],
              [
                61.1250763,
                35.9562658
              ],
              [
                61.1249905,
                35.9559358
              ],
              [
                61.1247974,
                35.9557621
              ],
              [
                61.1245828,
                35.9556405
              ],
              [
                61.1241107,
                35.9555884
              ],
              [
                61.1236601,
                35.9555015
              ],
              [
                61.1229949,
                35.9555189
              ],
              [
                61.1215144,
                35.9556057
              ],
              [
                61.1206131,
                35.9558489
              ],
              [
                61.1202913,
                35.9560921
              ],
              [
                61.1200982,
                35.9561616
              ],
              [
                61.1194973,
                35.9565263
              ],
              [
                61.1192613,
                35.9568042
              ],
              [
                61.1191111,
                35.9571863
              ],
              [
                61.1188288,
                35.957488
              ],
              [
                61.118612,
                35.9577766
              ],
              [
                61.1185687,
                35.9578889
              ],
              [
                61.1186111,
                35.9580816
              ],
              [
                61.1185062,
                35.9582497
              ],
              [
                61.1182662,
                35.9585713
              ],
              [
                61.1181378,
                35.9589154
              ],
              [
                61.117864,
                35.9595572
              ],
              [
                61.1176073,
                35.9599867
              ],
              [
                61.1174994,
                35.9602125
              ],
              [
                61.1173844,
                35.9605586
              ],
              [
                61.1174086,
                35.9607072
              ],
              [
                61.1174444,
                35.9608474
              ],
              [
                61.1174752,
                35.9609684
              ],
              [
                61.1175236,
                35.9612149
              ],
              [
                61.1174631,
                35.9613798
              ],
              [
                61.1172817,
                35.9615897
              ],
              [
                61.1172049,
                35.9617209
              ],
              [
                61.1172277,
                35.9618918
              ],
              [
                61.1171678,
                35.9621307
              ],
              [
                61.117048,
                35.9624793
              ],
              [
                61.1169839,
                35.9628107
              ],
              [
                61.1169824,
                35.9629353
              ],
              [
                61.1170252,
                35.9630392
              ],
              [
                61.1170908,
                35.9631281
              ],
              [
                61.1172976,
                35.9631904
              ],
              [
                61.1175558,
                35.9632135
              ],
              [
                61.1179955,
                35.9631564
              ],
              [
                61.1183343,
                35.9631646
              ],
              [
                61.1185643,
                35.9632462
              ],
              [
                61.1187049,
                35.9633385
              ],
              [
                61.1188345,
                35.9634649
              ],
              [
                61.1190685,
                35.9637294
              ],
              [
                61.1192763,
                35.9640233
              ],
              [
                61.1195223,
                35.9643955
              ],
              [
                61.1196837,
                35.9647905
              ],
              [
                61.1198226,
                35.9649043
              ],
              [
                61.1199622,
                35.9649964
              ],
              [
                61.1201564,
                35.9651694
              ],
              [
                61.1204166,
                35.9654779
              ],
              [
                61.1207282,
                35.966054
              ],
              [
                61.1214848,
                35.9672104
              ],
              [
                61.1221635,
                35.9678233
              ],
              [
                61.1226745,
                35.968095
              ],
              [
                61.1232304,
                35.9682309
              ],
              [
                61.1240082,
                35.9682958
              ],
              [
                61.1244855,
                35.9682566
              ],
              [
                61.1268965,
                35.967853
              ],
              [
                61.1274293,
                35.9676665
              ],
              [
                61.1277785,
                35.9674652
              ],
              [
                61.128143,
                35.9673085
              ],
              [
                61.1292371,
                35.9670129
              ],
              [
                61.1295802,
                35.9670299
              ],
              [
                61.1300307,
                35.9670905
              ],
              [
                61.1310573,
                35.9677167
              ],
              [
                61.1316035,
                35.967986
              ],
              [
                61.1321243,
                35.9683116
              ],
              [
                61.1325533,
                35.9686371
              ],
              [
                61.1328785,
                35.9689903
              ],
              [
                61.1331039,
                35.9692627
              ],
              [
                61.1342505,
                35.9701215
              ],
              [
                61.1347583,
                35.9704978
              ],
              [
                61.1354828,
                35.9709272
              ],
              [
                61.1361446,
                35.9712758
              ],
              [
                61.1374653,
                35.9721184
              ],
              [
                61.1381042,
                35.9725685
              ],
              [
                61.1387261,
                35.9729817
              ],
              [
                61.139365,
                35.9734434
              ],
              [
                61.1395875,
                35.973635
              ],
              [
                61.1398385,
                35.9738774
              ],
              [
                61.1402321,
                35.9741844
              ],
              [
                61.1404518,
                35.9744361
              ],
              [
                61.1410223,
                35.9754171
              ],
              [
                61.1412761,
                35.975925
              ],
              [
                61.1415871,
                35.976569
              ],
              [
                61.1419237,
                35.9773493
              ],
              [
                61.1420748,
                35.9778709
              ],
              [
                61.1422831,
                35.978268
              ],
              [
                61.1425369,
                35.9790089
              ],
              [
                61.1429145,
                35.97974
              ],
              [
                61.1431061,
                35.9800224
              ],
              [
                61.1432271,
                35.9802689
              ],
              [
                61.143334,
                35.9805088
              ],
              [
                61.1434086,
                35.9807585
              ],
              [
                61.143531,
                35.9809532
              ],
              [
                61.1436944,
                35.9810936
              ],
              [
                61.1438538,
                35.9812878
              ],
              [
                61.1442995,
                35.9817611
              ],
              [
                61.144592,
                35.9819766
              ],
              [
                61.1449268,
                35.9822002
              ],
              [
                61.1452173,
                35.9824548
              ],
              [
                61.1456065,
                35.9826882
              ],
              [
                61.1461491,
                35.9829983
              ],
              [
                61.1468248,
                35.9833198
              ],
              [
                61.1471657,
                35.9834455
              ],
              [
                61.1477062,
                35.983625
              ],
              [
                61.1481769,
                35.9837727
              ],
              [
                61.1487522,
                35.9838998
              ],
              [
                61.1493997,
                35.9840417
              ],
              [
                61.1499181,
                35.9841446
              ],
              [
                61.1514385,
                35.9844679
              ],
              [
                61.152511,
                35.984768
              ],
              [
                61.1532584,
                35.9849573
              ],
              [
                61.1540755,
                35.9852524
              ],
              [
                61.1546242,
                35.9855511
              ],
              [
                61.1552696,
                35.9858155
              ],
              [
                61.1557892,
                35.9861236
              ],
              [
                61.1571225,
                35.9869308
              ],
              [
                61.1578849,
                35.9874302
              ],
              [
                61.1585707,
                35.9878219
              ],
              [
                61.1591009,
                35.988083
              ],
              [
                61.159906,
                35.9884896
              ],
              [
                61.160299,
                35.988771
              ],
              [
                61.1612118,
                35.9892072
              ],
              [
                61.1620789,
                35.9896549
              ],
              [
                61.1628348,
                35.9898811
              ],
              [
                61.1632855,
                35.9899757
              ],
              [
                61.1639673,
                35.9900819
              ],
              [
                61.1647973,
                35.9901004
              ],
              [
                61.1658214,
                35.9901465
              ],
              [
                61.1663434,
                35.9901604
              ],
              [
                61.1669937,
                35.9899919
              ],
              [
                61.1674016,
                35.989925
              ],
              [
                61.1679008,
                35.9898973
              ],
              [
                61.1683087,
                35.9899342
              ],
              [
                61.1685141,
                35.9900057
              ],
              [
                61.1687851,
                35.9902458
              ],
              [
                61.1690275,
                35.9903658
              ],
              [
                61.1691844,
                35.9906427
              ],
              [
                61.1693641,
                35.9910559
              ],
              [
                61.1696494,
                35.9915221
              ],
              [
                61.1699945,
                35.9922906
              ],
              [
                61.1703111,
                35.9932645
              ],
              [
                61.1704395,
                35.9935
              ],
              [
                61.1707789,
                35.9938577
              ],
              [
                61.1708897,
                35.9940946
              ],
              [
                61.1709764,
                35.9944487
              ],
              [
                61.1710491,
                35.9949138
              ],
              [
                61.1710491,
                35.9952173
              ],
              [
                61.171043,
                35.9953822
              ],
              [
                61.1709643,
                35.9956302
              ],
              [
                61.1707969,
                35.9960317
              ],
              [
                61.1705408,
                35.9963711
              ],
              [
                61.1701454,
                35.9967236
              ],
              [
                61.1694181,
                35.9974944
              ],
              [
                61.1691095,
                35.997756
              ],
              [
                61.1688251,
                35.9979078
              ],
              [
                61.1681797,
                35.9979682
              ],
              [
                61.1676802,
                35.9981311
              ],
              [
                61.1674227,
                35.9983915
              ],
              [
                61.1669292,
                35.9992074
              ],
              [
                61.1666717,
                35.9999713
              ],
              [
                61.1665859,
                36.0002664
              ],
              [
                61.166307,
                36.0007004
              ],
              [
                61.1658778,
                36.0015683
              ],
              [
                61.1656632,
                36.00228
              ],
              [
                61.1655619,
                36.0030545
              ],
              [
                61.1655189,
                36.0049293
              ],
              [
                61.1655833,
                36.0057625
              ],
              [
                61.1659052,
                36.0071859
              ],
              [
                61.1661841,
                36.0080885
              ],
              [
                61.1663558,
                36.0083836
              ],
              [
                61.1668279,
                36.0086613
              ],
              [
                61.1672141,
                36.0087307
              ],
              [
                61.1691024,
                36.0089043
              ],
              [
                61.1707761,
                36.0092514
              ],
              [
                61.1725141,
                36.0093382
              ],
              [
                61.1731793,
                36.0094771
              ],
              [
                61.1735012,
                36.0096854
              ],
              [
                61.1736277,
                36.009991
              ],
              [
                61.1736277,
                36.0131499
              ],
              [
                61.1735418,
                36.0138616
              ],
              [
                61.1733273,
                36.0145038
              ],
              [
                61.1729196,
                36.0153889
              ],
              [
                61.1712673,
                36.017975
              ],
              [
                61.1706021,
                36.0189122
              ],
              [
                61.1692932,
                36.0203353
              ],
              [
                61.1667397,
                36.0227303
              ],
              [
                61.1652592,
                36.0238236
              ],
              [
                61.1644652,
                36.024726
              ],
              [
                61.1641005,
                36.0252119
              ],
              [
                61.1639503,
                36.0257499
              ],
              [
                61.1638,
                36.0264614
              ],
              [
                61.1638644,
                36.0273638
              ],
              [
                61.1638644,
                36.0277282
              ],
              [
                61.1636498,
                36.0285786
              ],
              [
                61.1630919,
                36.0301403
              ],
              [
                61.1629847,
                36.0308171
              ],
              [
                61.1629203,
                36.0316153
              ],
              [
                61.1630276,
                36.0322053
              ],
              [
                61.1635426,
                36.0343223
              ],
              [
                61.163843,
                36.0350164
              ],
              [
                61.1649373,
                36.0364566
              ],
              [
                61.1657098,
                36.0372027
              ],
              [
                61.1669972,
                36.0383132
              ],
              [
                61.1686924,
                36.039441
              ],
              [
                61.1703446,
                36.0403432
              ],
              [
                61.1726406,
                36.0413322
              ],
              [
                61.1745074,
                36.0419221
              ],
              [
                61.1782411,
                36.0427897
              ],
              [
                61.1793139,
                36.0430326
              ],
              [
                61.1796573,
                36.0432234
              ],
              [
                61.1802581,
                36.0434663
              ],
              [
                61.180433,
                36.0437643
              ],
              [
                61.1807334,
                36.0446144
              ],
              [
                61.180948,
                36.045291
              ],
              [
                61.1822355,
                36.0482578
              ],
              [
                61.1827719,
                36.0497845
              ],
              [
                61.1829436,
                36.0503049
              ],
              [
                61.1838019,
                36.051901
              ],
              [
                61.1841667,
                36.0530286
              ],
              [
                61.1842954,
                36.0537919
              ],
              [
                61.1844456,
                36.0553011
              ],
              [
                61.1844027,
                36.0560644
              ],
              [
                61.1842954,
                36.0568277
              ],
              [
                61.1840594,
                36.0578859
              ],
              [
                61.1837804,
                36.0589093
              ],
              [
                61.1837804,
                36.0594818
              ],
              [
                61.183716,
                36.0598113
              ],
              [
                61.1829221,
                36.0609562
              ],
              [
                61.1826646,
                36.0616674
              ],
              [
                61.1825725,
                36.0623681
              ],
              [
                61.1825939,
                36.0638078
              ],
              [
                61.1825081,
                36.0646924
              ],
              [
                61.1825725,
                36.0650567
              ],
              [
                61.1828514,
                36.0659239
              ],
              [
                61.1831089,
                36.0664096
              ],
              [
                61.1831304,
                36.0666524
              ],
              [
                61.1831089,
                36.0668779
              ],
              [
                61.1831733,
                36.0671381
              ],
              [
                61.1837097,
                36.0677798
              ],
              [
                61.1842676,
                36.0684216
              ],
              [
                61.1849972,
                36.0691154
              ],
              [
                61.1857053,
                36.069601
              ],
              [
                61.1867782,
                36.0701387
              ],
              [
                61.1884304,
                36.0710752
              ],
              [
                61.1904045,
                36.0722893
              ],
              [
                61.1921211,
                36.0732085
              ],
              [
                61.1927863,
                36.0734513
              ],
              [
                61.1932584,
                36.0737635
              ],
              [
                61.1936017,
                36.0742144
              ],
              [
                61.1940309,
                36.0746133
              ],
              [
                61.1944327,
                36.0754346
              ],
              [
                61.1952696,
                36.0767006
              ],
              [
                61.1959348,
                36.0776718
              ],
              [
                61.1961493,
                36.0782615
              ],
              [
                61.1962352,
                36.0786777
              ],
              [
                61.1962352,
                36.0794928
              ],
              [
                61.1964068,
                36.0799263
              ],
              [
                61.1964283,
                36.0803599
              ],
              [
                61.1962995,
                36.0805333
              ],
              [
                61.1961064,
                36.0806547
              ],
              [
                61.1961493,
                36.0808454
              ],
              [
                61.196321,
                36.0810362
              ],
              [
                61.1964283,
                36.0816778
              ],
              [
                61.1966214,
                36.0821287
              ],
              [
                61.1969004,
                36.0831519
              ],
              [
                61.1974797,
                36.0843484
              ],
              [
                61.1977587,
                36.0847126
              ],
              [
                61.1985955,
                36.0851287
              ],
              [
                61.1988101,
                36.0852848
              ],
              [
                61.1996255,
                36.0862212
              ],
              [
                61.2013803,
                36.0878846
              ],
              [
                61.2020241,
                36.0884048
              ],
              [
                61.2029682,
                36.0890464
              ],
              [
                61.2049209,
                36.0898787
              ],
              [
                61.2054788,
                36.0902949
              ],
              [
                61.2058221,
                36.0907284
              ],
              [
                61.2066589,
                36.0915433
              ],
              [
                61.2072812,
                36.0920115
              ],
              [
                61.2074314,
                36.092393
              ],
              [
                61.2073885,
                36.0926704
              ],
              [
                61.2065516,
                36.0948551
              ],
              [
                61.2062083,
                36.0957394
              ],
              [
                61.2059079,
                36.0971958
              ],
              [
                61.2057362,
                36.0978546
              ],
              [
                61.2055002,
                36.0987735
              ],
              [
                61.2055002,
                36.0993977
              ],
              [
                61.2056719,
                36.1001952
              ],
              [
                61.2059903,
                36.1009515
              ],
              [
                61.2072563,
                36.1036734
              ],
              [
                61.2075567,
                36.1043495
              ],
              [
                61.207664,
                36.1046443
              ],
              [
                61.2080931,
                36.1049737
              ],
              [
                61.2085008,
                36.1052684
              ],
              [
                61.2092089,
                36.1060832
              ],
              [
                61.2095308,
                36.1064126
              ],
              [
                61.2107324,
                36.1070367
              ],
              [
                61.2112525,
                36.1074873
              ],
              [
                61.2122954,
                36.1084296
              ],
              [
                61.2128833,
                36.1089608
              ],
              [
                61.2131408,
                36.1093249
              ],
              [
                61.2133553,
                36.1094636
              ],
              [
                61.2139347,
                36.1097063
              ],
              [
                61.2148145,
                36.1103477
              ],
              [
                61.2160161,
                36.1107637
              ],
              [
                61.2164238,
                36.110729
              ],
              [
                61.2166598,
                36.1106597
              ],
              [
                61.2168744,
                36.1105383
              ],
              [
                61.2173465,
                36.1105383
              ],
              [
                61.2181404,
                36.1107117
              ],
              [
                61.2197497,
                36.1114051
              ],
              [
                61.2202432,
                36.1115611
              ],
              [
                61.2206724,
                36.1115785
              ],
              [
                61.221402,
                36.1114224
              ],
              [
                61.2222174,
                36.1111624
              ],
              [
                61.2229684,
                36.1106944
              ],
              [
                61.2238481,
                36.110365
              ],
              [
                61.2243202,
                36.1102783
              ],
              [
                61.2250069,
                36.1103477
              ],
              [
                61.2261024,
                36.1105576
              ],
              [
                61.2264992,
                36.1106977
              ],
              [
                61.2272566,
                36.1111425
              ],
              [
                61.2281711,
                36.1119938
              ],
              [
                61.22845,
                36.1123245
              ],
              [
                61.2291587,
                36.1134784
              ],
              [
                61.229585,
                36.1140126
              ],
              [
                61.229821,
                36.1145563
              ],
              [
                61.2301039,
                36.1154203
              ],
              [
                61.2304885,
                36.11605
              ],
              [
                61.2306475,
                36.1163528
              ],
              [
                61.2309142,
                36.1173118
              ],
              [
                61.230984,
                36.1179704
              ],
              [
                61.2308504,
                36.11873
              ],
              [
                61.2308104,
                36.1191354
              ],
              [
                61.2306936,
                36.1196586
              ],
              [
                61.2306185,
                36.119891
              ],
              [
                61.2301284,
                36.120725
              ],
              [
                61.2298471,
                36.121155
              ],
              [
                61.2295658,
                36.1214754
              ],
              [
                61.229246,
                36.1217464
              ],
              [
                61.2290723,
                36.1218741
              ],
              [
                61.2286217,
                36.1220647
              ],
              [
                61.2282355,
                36.1221514
              ],
              [
                61.2279136,
                36.1221167
              ],
              [
                61.2274844,
                36.1217701
              ],
              [
                61.2265618,
                36.1214407
              ],
              [
                61.225846,
                36.1212826
              ],
              [
                61.2242014,
                36.1209728
              ],
              [
                61.2224097,
                36.1206366
              ],
              [
                61.2220359,
                36.1205156
              ],
              [
                61.2215896,
                36.120233
              ],
              [
                61.2213905,
                36.1201234
              ],
              [
                61.2207896,
                36.1200714
              ],
              [
                61.2203063,
                36.1199677
              ],
              [
                61.2198944,
                36.1199541
              ],
              [
                61.2197585,
                36.1199815
              ],
              [
                61.2197361,
                36.1200524
              ],
              [
                61.2194381,
                36.1202089
              ],
              [
                61.2190998,
                36.1204218
              ],
              [
                61.2190178,
                36.1205221
              ],
              [
                61.2188995,
                36.1206313
              ],
              [
                61.2188446,
                36.1207084
              ],
              [
                61.2187793,
                36.1212318
              ],
              [
                61.2187229,
                36.1213761
              ],
              [
                61.2186031,
                36.1214727
              ],
              [
                61.2182147,
                36.1215967
              ],
              [
                61.2181244,
                36.1216555
              ],
              [
                61.2180431,
                36.1217874
              ],
              [
                61.2179572,
                36.1219954
              ],
              [
                61.2177355,
                36.1222501
              ],
              [
                61.2170636,
                36.1230219
              ],
              [
                61.2168677,
                36.123101
              ],
              [
                61.2162518,
                36.123173
              ],
              [
                61.2153096,
                36.1234186
              ],
              [
                61.2147386,
                36.1236246
              ],
              [
                61.2142094,
                36.1237428
              ],
              [
                61.2137618,
                36.1238756
              ],
              [
                61.2133009,
                36.12411
              ],
              [
                61.2126549,
                36.1245244
              ],
              [
                61.2125435,
                36.1246389
              ],
              [
                61.2120578,
                36.1252995
              ],
              [
                61.2113559,
                36.1260589
              ],
              [
                61.211241,
                36.1262245
              ],
              [
                61.2107358,
                36.1275945
              ],
              [
                61.2104933,
                36.1283499
              ],
              [
                61.2104845,
                36.1285286
              ],
              [
                61.2105047,
                36.1292232
              ],
              [
                61.2108635,
                36.130781
              ],
              [
                61.2109413,
                36.1312193
              ],
              [
                61.2110868,
                36.1316383
              ],
              [
                61.2113045,
                36.1319559
              ],
              [
                61.211929,
                36.1327928
              ],
              [
                61.2123134,
                36.1331907
              ],
              [
                61.2142432,
                36.1347526
              ],
              [
                61.2150426,
                36.1352752
              ],
              [
                61.216605,
                36.1359203
              ],
              [
                61.2182639,
                36.1364326
              ],
              [
                61.2188606,
                36.1365363
              ],
              [
                61.2196113,
                36.1366803
              ],
              [
                61.2204999,
                36.1368952
              ],
              [
                61.2209644,
                36.1372805
              ],
              [
                61.2219408,
                36.1376952
              ],
              [
                61.2230034,
                36.1382732
              ],
              [
                61.2233897,
                36.1384811
              ],
              [
                61.224248,
                36.1385851
              ],
              [
                61.2245269,
                36.1388624
              ],
              [
                61.2246771,
                36.1392089
              ],
              [
                61.2251492,
                36.1399714
              ],
              [
                61.2253852,
                36.1405952
              ],
              [
                61.2251921,
                36.1413404
              ],
              [
                61.2248059,
                36.1419469
              ],
              [
                61.2244411,
                36.1422414
              ],
              [
                61.2236686,
                36.1427266
              ],
              [
                61.2229176,
                36.1429866
              ],
              [
                61.2220164,
                36.1432291
              ],
              [
                61.2200637,
                36.1442688
              ],
              [
                61.2191304,
                36.1448975
              ],
              [
                61.2189158,
                36.1450881
              ],
              [
                61.2187012,
                36.145452
              ],
              [
                61.2184652,
                36.1457985
              ],
              [
                61.2182935,
                36.1460064
              ],
              [
                61.2174137,
                36.1463877
              ],
              [
                61.2169846,
                36.1467862
              ],
              [
                61.2157615,
                36.1482763
              ],
              [
                61.2154825,
                36.1487788
              ],
              [
                61.2154825,
                36.149056
              ],
              [
                61.2155469,
                36.1494372
              ],
              [
                61.2156113,
                36.1496624
              ],
              [
                61.2158259,
                36.1505461
              ],
              [
                61.2160619,
                36.1510139
              ],
              [
                61.2167271,
                36.1517936
              ],
              [
                61.2174352,
                36.1522961
              ],
              [
                61.2192591,
                36.1532317
              ],
              [
                61.219817,
                36.1534049
              ],
              [
                61.2200101,
                36.1535955
              ],
              [
                61.2222444,
                36.1553792
              ],
              [
                61.2231885,
                36.1564533
              ],
              [
                61.2242185,
                36.1579953
              ],
              [
                61.224476,
                36.1584804
              ],
              [
                61.2245833,
                36.1588788
              ],
              [
                61.2250339,
                36.1595718
              ],
              [
                61.2253772,
                36.1602301
              ],
              [
                61.2261926,
                36.1609577
              ],
              [
                61.2264715,
                36.1614948
              ],
              [
                61.2265359,
                36.1621358
              ],
              [
                61.2266003,
                36.1628461
              ],
              [
                61.226729,
                36.1644918
              ],
              [
                61.2265359,
                36.1657564
              ],
              [
                61.2260638,
                36.1685107
              ],
              [
                61.2257634,
                36.1697926
              ],
              [
                61.2255059,
                36.1704854
              ],
              [
                61.2249051,
                36.1709878
              ],
              [
                61.2245273,
                36.1714118
              ],
              [
                61.2242913,
                36.1719488
              ],
              [
                61.2241411,
                36.1724511
              ],
              [
                61.2241196,
                36.1734384
              ],
              [
                61.2241196,
                36.1741659
              ],
              [
                61.2236261,
                36.1764523
              ],
              [
                61.2230682,
                36.1783922
              ],
              [
                61.2220168,
                36.1806092
              ],
              [
                61.2219739,
                36.1809555
              ],
              [
                61.2220597,
                36.181198
              ],
              [
                61.2220597,
                36.1814232
              ],
              [
                61.2218666,
                36.182064
              ],
              [
                61.2217593,
                36.1824623
              ],
              [
                61.2216683,
                36.1826037
              ],
              [
                61.2214554,
                36.182755
              ],
              [
                61.2213538,
                36.1829511
              ],
              [
                61.2210636,
                36.1839572
              ],
              [
                61.2208937,
                36.1841917
              ],
              [
                61.2204373,
                36.1845099
              ],
              [
                61.220107,
                36.1846099
              ],
              [
                61.2199354,
                36.1847138
              ],
              [
                61.2197298,
                36.1851045
              ],
              [
                61.2194694,
                36.1853525
              ],
              [
                61.2192238,
                36.1861391
              ],
              [
                61.2183059,
                36.1873011
              ],
              [
                61.2179184,
                36.1880044
              ],
              [
                61.2178023,
                36.1884948
              ],
              [
                61.2178453,
                36.1889404
              ],
              [
                61.2180016,
                36.1893952
              ],
              [
                61.2181982,
                36.1896025
              ],
              [
                61.2184855,
                36.1898636
              ],
              [
                61.2187057,
                36.1901738
              ],
              [
                61.2189483,
                36.1906886
              ],
              [
                61.2193457,
                36.1917947
              ],
              [
                61.2194567,
                36.1921384
              ],
              [
                61.2194045,
                36.1925391
              ],
              [
                61.2192972,
                36.1926677
              ],
              [
                61.2184946,
                36.1928782
              ],
              [
                61.2183046,
                36.1930438
              ],
              [
                61.2181758,
                36.1933035
              ],
              [
                61.2181174,
                36.1937518
              ],
              [
                61.2179672,
                36.1939353
              ],
              [
                61.2170171,
                36.1947408
              ],
              [
                61.2165021,
                36.1949313
              ],
              [
                61.2162322,
                36.1951094
              ],
              [
                61.2160834,
                36.1951835
              ],
              [
                61.2146986,
                36.1950859
              ],
              [
                61.2142035,
                36.1949489
              ],
              [
                61.2135576,
                36.1950376
              ],
              [
                61.2131762,
                36.1951391
              ],
              [
                61.2127814,
                36.1951766
              ],
              [
                61.2124719,
                36.1951158
              ],
              [
                61.2122063,
                36.1950039
              ],
              [
                61.2118956,
                36.1950151
              ],
              [
                61.2115669,
                36.1950698
              ],
              [
                61.2108908,
                36.1952982
              ],
              [
                61.2100209,
                36.1957454
              ],
              [
                61.2098214,
                36.1960107
              ],
              [
                61.2092744,
                36.1964152
              ],
              [
                61.2089477,
                36.1963822
              ],
              [
                61.2083683,
                36.1966246
              ],
              [
                61.2079264,
                36.1969266
              ],
              [
                61.207816,
                36.1970808
              ],
              [
                61.2077659,
                36.1973745
              ],
              [
                61.2078195,
                36.1976732
              ],
              [
                61.2078843,
                36.1979955
              ],
              [
                61.2078638,
                36.1981556
              ],
              [
                61.2076527,
                36.1984922
              ],
              [
                61.2072297,
                36.1994267
              ],
              [
                61.2071529,
                36.1997191
              ],
              [
                61.2071526,
                36.2013488
              ],
              [
                61.2071866,
                36.2015695
              ],
              [
                61.2072737,
                36.2016844
              ],
              [
                61.2077394,
                36.2021791
              ],
              [
                61.2079309,
                36.2024869
              ],
              [
                61.2080234,
                36.2028084
              ],
              [
                61.2080402,
                36.2031837
              ],
              [
                61.2080388,
                36.203672
              ],
              [
                61.2079309,
                36.2043575
              ],
              [
                61.2075513,
                36.205452
              ],
              [
                61.2074584,
                36.2058559
              ],
              [
                61.2074692,
                36.206073
              ],
              [
                61.2075275,
                36.2067685
              ],
              [
                61.2074945,
                36.2069593
              ],
              [
                61.2073213,
                36.2076665
              ],
              [
                61.2066861,
                36.2087487
              ],
              [
                61.2064436,
                36.2090865
              ],
              [
                61.2064082,
                36.2092965
              ],
              [
                61.2062212,
                36.2105594
              ],
              [
                61.2061293,
                36.2109067
              ],
              [
                61.2056396,
                36.2117019
              ],
              [
                61.2053327,
                36.2121135
              ],
              [
                61.2050476,
                36.2130319
              ],
              [
                61.2049276,
                36.2132439
              ],
              [
                61.2044563,
                36.2138732
              ],
              [
                61.2041862,
                36.214178
              ],
              [
                61.2039931,
                36.2145334
              ],
              [
                61.2038977,
                36.2150098
              ],
              [
                61.2038475,
                36.2161592
              ],
              [
                61.2037739,
                36.216471
              ],
              [
                61.2036053,
                36.2167845
              ],
              [
                61.2033636,
                36.2170096
              ],
              [
                61.2027731,
                36.2174882
              ],
              [
                61.2025267,
                36.2176848
              ],
              [
                61.2022048,
                36.2181868
              ],
              [
                61.2020115,
                36.2183042
              ],
              [
                61.2017328,
                36.2184118
              ],
              [
                61.2013895,
                36.2184811
              ],
              [
                61.2000805,
                36.2185503
              ],
              [
                61.1994368,
                36.2186888
              ],
              [
                61.1986,
                36.2191562
              ],
              [
                61.1977846,
                36.2199525
              ],
              [
                61.1975056,
                36.2205584
              ],
              [
                61.1971838,
                36.2208873
              ],
              [
                61.1967975,
                36.2209912
              ],
              [
                61.1963254,
                36.2211816
              ],
              [
                61.195789,
                36.2217875
              ],
              [
                61.1951238,
                36.2221683
              ],
              [
                61.1943728,
                36.2224799
              ],
              [
                61.1937505,
                36.2229646
              ],
              [
                61.1930853,
                36.2239686
              ],
              [
                61.1929566,
                36.2242109
              ],
              [
                61.1929995,
                36.2245571
              ],
              [
                61.1932141,
                36.2248687
              ],
              [
                61.1932141,
                36.2251457
              ],
              [
                61.1930424,
                36.2255784
              ],
              [
                61.1926991,
                36.2259073
              ],
              [
                61.1920232,
                36.2265391
              ],
              [
                61.1916906,
                36.2269978
              ],
              [
                61.1911971,
                36.228573
              ],
              [
                61.1911971,
                36.2289884
              ],
              [
                61.1912829,
                36.2294038
              ],
              [
                61.192227,
                36.2305116
              ],
              [
                61.1923558,
                36.2309097
              ],
              [
                61.1923558,
                36.2314636
              ],
              [
                61.1922485,
                36.231879
              ],
              [
                61.1918837,
                36.2323117
              ],
              [
                61.1911327,
                36.233229
              ],
              [
                61.1905533,
                36.2341809
              ],
              [
                61.1903388,
                36.2353579
              ],
              [
                61.1903388,
                36.2358425
              ],
              [
                61.1907035,
                36.2372098
              ],
              [
                61.1906821,
                36.2376425
              ],
              [
                61.190489,
                36.2378848
              ],
              [
                61.1901242,
                36.2381963
              ],
              [
                61.1893088,
                36.2384386
              ],
              [
                61.1888153,
                36.238629
              ],
              [
                61.1885363,
                36.2388539
              ],
              [
                61.1883646,
                36.2392347
              ],
              [
                61.1883646,
                36.2398058
              ],
              [
                61.188193,
                36.2407404
              ],
              [
                61.1881501,
                36.2414846
              ],
              [
                61.1879999,
                36.241848
              ],
              [
                61.1879999,
                36.242073
              ],
              [
                61.1880642,
                36.2424537
              ],
              [
                61.1878926,
                36.2430421
              ],
              [
                61.1878926,
                36.2432671
              ],
              [
                61.1884076,
                36.2436651
              ],
              [
                61.1890981,
                36.2444313
              ],
              [
                61.1895272,
                36.2447428
              ],
              [
                61.1902997,
                36.2450197
              ],
              [
                61.1905786,
                36.2452446
              ],
              [
                61.1907288,
                36.2457292
              ],
              [
                61.1906001,
                36.2463349
              ],
              [
                61.1905357,
                36.2467675
              ],
              [
                61.1902782,
                36.2470098
              ],
              [
                61.1897632,
                36.247304
              ],
              [
                61.1891195,
                36.2478923
              ],
              [
                61.1887118,
                36.2484807
              ],
              [
                61.1885831,
                36.2489652
              ],
              [
                61.1882398,
                36.2499862
              ],
              [
                61.1882612,
                36.250315
              ],
              [
                61.1882398,
                36.2506611
              ],
              [
                61.188111,
                36.2509552
              ],
              [
                61.1876175,
                36.2513532
              ],
              [
                61.1874458,
                36.2517166
              ],
              [
                61.1873814,
                36.2520281
              ],
              [
                61.1875102,
                36.2527375
              ],
              [
                61.1874673,
                36.2533259
              ],
              [
                61.1875102,
                36.2544852
              ],
              [
                61.1874887,
                36.2548659
              ],
              [
                61.1873385,
                36.2550908
              ],
              [
                61.1869523,
                36.2553504
              ],
              [
                61.186609,
                36.2557137
              ],
              [
                61.1863944,
                36.2561982
              ],
              [
                61.1863515,
                36.2569942
              ],
              [
                61.1862871,
                36.2573575
              ],
              [
                61.1861584,
                36.2576517
              ],
              [
                61.185815,
                36.2578766
              ],
              [
                61.1846134,
                36.2583265
              ],
              [
                61.1842486,
                36.2586206
              ],
              [
                61.1840341,
                36.2589494
              ],
              [
                61.1838409,
                36.2595896
              ],
              [
                61.1838195,
                36.2598664
              ],
              [
                61.1836907,
                36.2601086
              ],
              [
                61.1831757,
                36.2604028
              ],
              [
                61.1829397,
                36.2606623
              ],
              [
                61.1828539,
                36.2609737
              ],
              [
                61.1827037,
                36.2619599
              ],
              [
                61.1827251,
                36.2631365
              ],
              [
                61.1825749,
                36.2634133
              ],
              [
                61.1822316,
                36.2636901
              ],
              [
                61.1820599,
                36.2639323
              ],
              [
                61.1812446,
                36.2647974
              ],
              [
                61.1811587,
                36.2650915
              ],
              [
                61.1813304,
                36.2655932
              ],
              [
                61.1813733,
                36.2658527
              ],
              [
                61.1812231,
                36.2661642
              ],
              [
                61.1801931,
                36.2671157
              ],
              [
                61.1799142,
                36.2673752
              ],
              [
                61.1793348,
                36.2683094
              ],
              [
                61.1786696,
                36.269728
              ],
              [
                61.1782834,
                36.2704892
              ],
              [
                61.1774251,
                36.2711985
              ],
              [
                61.1766741,
                36.2722365
              ],
              [
                61.176481,
                36.2727555
              ],
              [
                61.1762235,
                36.2730669
              ],
              [
                61.1751935,
                36.2738281
              ],
              [
                61.1748073,
                36.2742951
              ],
              [
                61.1744425,
                36.2750736
              ],
              [
                61.1742064,
                36.2753677
              ],
              [
                61.1733267,
                36.2761288
              ],
              [
                61.1731121,
                36.2767343
              ],
              [
                61.1730263,
                36.277184
              ],
              [
                61.1731336,
                36.2777549
              ],
              [
                61.1733696,
                36.2782219
              ],
              [
                61.1738631,
                36.2787409
              ],
              [
                61.1740289,
                36.2789982
              ],
              [
                61.1740289,
                36.2793614
              ],
              [
                61.1739431,
                36.2798112
              ],
              [
                61.1739646,
                36.2804166
              ],
              [
                61.1737285,
                36.2811258
              ],
              [
                61.1737285,
                36.2817312
              ],
              [
                61.1733852,
                36.2824058
              ],
              [
                61.1731492,
                36.2827345
              ],
              [
                61.1726771,
                36.2831669
              ],
              [
                61.1725269,
                36.2834955
              ],
              [
                61.1724411,
                36.2838242
              ],
              [
                61.1725055,
                36.284395
              ],
              [
                61.1721621,
                36.2855884
              ],
              [
                61.1721836,
                36.2861246
              ],
              [
                61.1720548,
                36.2866435
              ],
              [
                61.1717544,
                36.2870586
              ],
              [
                61.1712394,
                36.2874564
              ],
              [
                61.1702524,
                36.288131
              ],
              [
                61.169716,
                36.2887363
              ],
              [
                61.1696087,
                36.2892379
              ],
              [
                61.1696516,
                36.2897222
              ],
              [
                61.1698876,
                36.2901892
              ],
              [
                61.1699305,
                36.2904486
              ],
              [
                61.1698876,
                36.2909675
              ],
              [
                61.169716,
                36.2913653
              ],
              [
                61.1694155,
                36.2915209
              ],
              [
                61.1687718,
                36.2916247
              ],
              [
                61.1671839,
                36.2912442
              ],
              [
                61.1667763,
                36.2912961
              ],
              [
                61.1644803,
                36.2920571
              ],
              [
                61.1636434,
                36.2924895
              ],
              [
                61.1632787,
                36.2928526
              ],
              [
                61.1619483,
                36.2943919
              ],
              [
                61.1612616,
                36.2947897
              ],
              [
                61.1604248,
                36.2951183
              ],
              [
                61.1596094,
                36.2953085
              ],
              [
                61.1590515,
                36.2953777
              ],
              [
                61.1585794,
                36.2956544
              ],
              [
                61.1583434,
                36.2958273
              ],
              [
                61.1574636,
                36.2960348
              ],
              [
                61.1567126,
                36.2964845
              ],
              [
                61.156498,
                36.296692
              ],
              [
                61.1563907,
                36.2971244
              ],
              [
                61.1565624,
                36.298456
              ],
              [
                61.1566911,
                36.299044
              ],
              [
                61.1569272,
                36.2994417
              ],
              [
                61.1576567,
                36.3001681
              ],
              [
                61.1593519,
                36.3014132
              ],
              [
                61.1597811,
                36.3020184
              ],
              [
                61.1611329,
                36.30335
              ],
              [
                61.1614333,
                36.303886
              ],
              [
                61.1615406,
                36.3044048
              ],
              [
                61.1614679,
                36.3048336
              ],
              [
                61.1612646,
                36.3052227
              ],
              [
                61.1604133,
                36.3062671
              ],
              [
                61.1603879,
                36.306564
              ],
              [
                61.1604387,
                36.3067893
              ],
              [
                61.1605531,
                36.3071886
              ],
              [
                61.1606674,
                36.3081511
              ],
              [
                61.1607818,
                36.3085914
              ],
              [
                61.1611375,
                36.3094719
              ],
              [
                61.1613154,
                36.3100146
              ],
              [
                61.1613154,
                36.3103729
              ],
              [
                61.1612011,
                36.3109053
              ],
              [
                61.1609724,
                36.3113251
              ],
              [
                61.1606253,
                36.311627
              ],
              [
                61.1596597,
                36.3122516
              ],
              [
                61.1580842,
                36.3131014
              ],
              [
                61.1576694,
                36.3132173
              ],
              [
                61.1571312,
                36.3133676
              ],
              [
                61.1564451,
                36.313644
              ],
              [
                61.1555557,
                36.3141764
              ],
              [
                61.1551237,
                36.3143402
              ],
              [
                61.1547171,
                36.3144631
              ],
              [
                61.153942,
                36.3145654
              ],
              [
                61.1531984,
                36.3147279
              ],
              [
                61.1520874,
                36.3151272
              ],
              [
                61.1512641,
                36.3155577
              ],
              [
                61.1503204,
                36.3161328
              ],
              [
                61.1497802,
                36.3166284
              ],
              [
                61.1495607,
                36.3169049
              ],
              [
                61.1493831,
                36.3172169
              ],
              [
                61.149279,
                36.317514
              ],
              [
                61.1492409,
                36.3179337
              ],
              [
                61.1493157,
                36.3182352
              ],
              [
                61.1494837,
                36.3185206
              ],
              [
                61.149698,
                36.3187679
              ],
              [
                61.1502155,
                36.3191189
              ],
              [
                61.1517185,
                36.3197765
              ],
              [
                61.1526079,
                36.3202678
              ],
              [
                61.1538785,
                36.3212199
              ],
              [
                61.1541842,
                36.3213978
              ],
              [
                61.1545267,
                36.3215461
              ],
              [
                61.1548485,
                36.321632
              ],
              [
                61.1552255,
                36.3216587
              ],
              [
                61.1560768,
                36.3216792
              ],
              [
                61.1564819,
                36.3216207
              ],
              [
                61.1569789,
                36.3214437
              ],
              [
                61.158097,
                36.3209319
              ],
              [
                61.1594368,
                36.3199809
              ],
              [
                61.1598454,
                36.3199081
              ],
              [
                61.1601155,
                36.3199228
              ],
              [
                61.160257,
                36.3200412
              ],
              [
                61.1604603,
                36.3202357
              ],
              [
                61.1609431,
                36.3204712
              ],
              [
                61.1611464,
                36.3206964
              ],
              [
                61.1611973,
                36.3209728
              ],
              [
                61.161121,
                36.3213721
              ],
              [
                61.1606382,
                36.322406
              ],
              [
                61.160562,
                36.3228155
              ],
              [
                61.1605747,
                36.3231124
              ],
              [
                61.1607271,
                36.3236652
              ],
              [
                61.1607907,
                36.3240132
              ],
              [
                61.160689,
                36.3244636
              ],
              [
                61.160041,
                36.3266543
              ],
              [
                61.1599648,
                36.3271354
              ],
              [
                61.1599902,
                36.327422
              ],
              [
                61.1602951,
                36.3281897
              ],
              [
                61.1604095,
                36.3289882
              ],
              [
                61.1603968,
                36.3305031
              ],
              [
                61.160346,
                36.3309433
              ],
              [
                61.1602189,
                36.3312299
              ],
              [
                61.159914,
                36.3315267
              ],
              [
                61.1595201,
                36.3317724
              ],
              [
                61.1590246,
                36.3319054
              ],
              [
                61.1585671,
                36.3319976
              ],
              [
                61.1571568,
                36.332059
              ],
              [
                61.1547808,
                36.3322535
              ],
              [
                61.1541963,
                36.3324786
              ],
              [
                61.1539854,
                36.3326123
              ],
              [
                61.1529465,
                36.3330421
              ],
              [
                61.1525113,
                36.3333588
              ],
              [
                61.1522585,
                36.3337094
              ],
              [
                61.1520901,
                36.3339243
              ],
              [
                61.1518093,
                36.3341731
              ],
              [
                61.1513881,
                36.3344332
              ],
              [
                61.1510371,
                36.3348178
              ],
              [
                61.1492962,
                36.3370118
              ],
              [
                61.1488891,
                36.3374868
              ],
              [
                61.1481169,
                36.3384481
              ],
              [
                61.1478782,
                36.3390475
              ],
              [
                61.1478221,
                36.3394207
              ],
              [
                61.1478782,
                36.3399522
              ],
              [
                61.1479765,
                36.3403254
              ],
              [
                61.1483134,
                36.3412754
              ],
              [
                61.1484117,
                36.3418408
              ],
              [
                61.1483939,
                36.3425993
              ],
              [
                61.1481272,
                36.3437641
              ],
              [
                61.1481412,
                36.3440694
              ],
              [
                61.1482114,
                36.3443295
              ],
              [
                61.1484501,
                36.3445105
              ],
              [
                61.1485343,
                36.3446236
              ],
              [
                61.1485905,
                36.3449176
              ],
              [
                61.1488292,
                36.3453812
              ],
              [
                61.1495873,
                36.3461162
              ],
              [
                61.1500927,
                36.346512
              ],
              [
                61.1504016,
                36.3469078
              ],
              [
                61.1506824,
                36.3473601
              ],
              [
                61.150907,
                36.3476202
              ],
              [
                61.1512299,
                36.3479029
              ],
              [
                61.1514826,
                36.3485022
              ],
              [
                61.1517634,
                36.3488188
              ],
              [
                61.1521284,
                36.3492825
              ],
              [
                61.1522267,
                36.3497235
              ],
              [
                61.1521986,
                36.3500288
              ],
              [
                61.1517915,
                36.3506281
              ],
              [
                61.1517213,
                36.350956
              ],
              [
                61.1517213,
                36.3511369
              ],
              [
                61.1524794,
                36.3519737
              ],
              [
                61.1528585,
                36.3522903
              ],
              [
                61.1529989,
                36.3526408
              ],
              [
                61.1532095,
                36.3529122
              ],
              [
                61.153757,
                36.3533757
              ],
              [
                61.1551469,
                36.3540655
              ],
              [
                61.1556383,
                36.3544273
              ],
              [
                61.1562841,
                36.3551622
              ],
              [
                61.1564105,
                36.3554223
              ],
              [
                61.1563965,
                36.3559085
              ],
              [
                61.1563965,
                36.3564625
              ],
              [
                61.1564947,
                36.3569939
              ],
              [
                61.1565509,
                36.3576271
              ],
              [
                61.1565509,
                36.3581133
              ],
              [
                61.1564386,
                36.3584072
              ],
              [
                61.1561157,
                36.3587351
              ],
              [
                61.1557787,
                36.3590291
              ],
              [
                61.1554418,
                36.3595379
              ],
              [
                61.1553575,
                36.3598771
              ],
              [
                61.1551048,
                36.3607702
              ],
              [
                61.15481,
                36.3616521
              ],
              [
                61.1545011,
                36.3623757
              ],
              [
                61.1539957,
                36.3632462
              ],
              [
                61.1539676,
                36.3635515
              ],
              [
                61.154094,
                36.3639246
              ],
              [
                61.154094,
                36.3642863
              ],
              [
                61.1540378,
                36.364682
              ],
              [
                61.1537711,
                36.3656091
              ],
              [
                61.1535745,
                36.3663439
              ],
              [
                61.1535043,
                36.3672822
              ],
              [
                61.1535745,
                36.3675196
              ],
              [
                61.1538272,
                36.3677683
              ],
              [
                61.1545994,
                36.3680284
              ],
              [
                61.1547679,
                36.368164
              ],
              [
                61.1548381,
                36.3683675
              ],
              [
                61.1548381,
                36.3685258
              ],
              [
                61.1552171,
                36.369611
              ],
              [
                61.1552171,
                36.3699163
              ],
              [
                61.1550196,
                36.3706553
              ],
              [
                61.1547107,
                36.3710736
              ],
              [
                61.1543878,
                36.3713223
              ],
              [
                61.1541211,
                36.3715031
              ],
              [
                61.1535735,
                36.3716614
              ],
              [
                61.1529137,
                36.371797
              ],
              [
                61.1514676,
                36.3720005
              ],
              [
                61.1508779,
                36.3721701
              ],
              [
                61.1503304,
                36.3723962
              ],
              [
                61.149488,
                36.3728597
              ],
              [
                61.1490809,
                36.3731875
              ],
              [
                61.1485614,
                36.3738431
              ],
              [
                61.1483087,
                36.3741596
              ],
              [
                61.1478875,
                36.3746796
              ],
              [
                61.1475225,
                36.3750413
              ],
              [
                61.1472698,
                36.3756065
              ],
              [
                61.1472698,
                36.3759683
              ],
              [
                61.1473821,
                36.3763413
              ],
              [
                61.1474944,
                36.3764317
              ],
              [
                61.1477331,
                36.3765448
              ],
              [
                61.1478875,
                36.3767482
              ],
              [
                61.1478875,
                36.376963
              ],
              [
                61.1479998,
                36.3774943
              ],
              [
                61.1481543,
                36.3783194
              ],
              [
                61.1482104,
                36.3792463
              ],
              [
                61.1481122,
                36.3797323
              ],
              [
                61.1479296,
                36.3802975
              ],
              [
                61.1474663,
                36.3809757
              ],
              [
                61.1471434,
                36.3813035
              ],
              [
                61.1466661,
                36.3815182
              ],
              [
                61.1464555,
                36.3816991
              ],
              [
                61.1458237,
                36.3825129
              ],
              [
                61.1454446,
                36.3831006
              ],
              [
                61.1449954,
                36.3840614
              ],
              [
                61.1440828,
                36.3856211
              ],
              [
                61.1439143,
                36.3863897
              ],
              [
                61.1439284,
                36.3871243
              ],
              [
                61.1440547,
                36.3876103
              ],
              [
                61.1442934,
                36.3881189
              ],
              [
                61.1444759,
                36.3891022
              ],
              [
                61.1444478,
                36.3897577
              ],
              [
                61.1442513,
                36.3900515
              ],
              [
                61.1440547,
                36.3902098
              ],
              [
                61.1435072,
                36.3905488
              ],
              [
                61.1432124,
                36.390854
              ],
              [
                61.1430018,
                36.3912721
              ],
              [
                61.1427771,
                36.3918259
              ],
              [
                61.1425525,
                36.3921084
              ],
              [
                61.1422577,
                36.3923571
              ],
              [
                61.1419348,
                36.3927978
              ],
              [
                61.1414995,
                36.3934533
              ],
              [
                61.1413451,
                36.3935663
              ],
              [
                61.1410924,
                36.3936228
              ],
              [
                61.1405589,
                36.3935663
              ],
              [
                61.1404185,
                36.3936115
              ],
              [
                61.1403343,
                36.3937358
              ],
              [
                61.1404045,
                36.3939506
              ],
              [
                61.1411064,
                36.3949903
              ],
              [
                61.1418646,
                36.3966063
              ],
              [
                61.1421454,
                36.3970583
              ],
              [
                61.1434472,
                36.3983579
              ],
              [
                61.1445704,
                36.3991941
              ],
              [
                61.1450617,
                36.3995218
              ],
              [
                61.1462691,
                36.4006067
              ],
              [
                61.146578,
                36.4008666
              ],
              [
                61.14728,
                36.401296
              ],
              [
                61.1483049,
                36.4016124
              ],
              [
                61.1489366,
                36.4017819
              ],
              [
                61.1508179,
                36.4026294
              ],
              [
                61.1511268,
                36.402765
              ],
              [
                61.1526431,
                36.4029797
              ],
              [
                61.1531625,
                36.4030701
              ],
              [
                61.1537522,
                36.4032961
              ],
              [
                61.1546928,
                36.4038385
              ],
              [
                61.1557177,
                36.4045842
              ],
              [
                61.1566443,
                36.4055899
              ],
              [
                61.1570655,
                36.4062679
              ],
              [
                61.1579079,
                36.4069119
              ],
              [
                61.158315,
                36.4071944
              ],
              [
                61.1589889,
                36.408087
              ],
              [
                61.1593259,
                36.4087085
              ],
              [
                61.1595084,
                36.4090927
              ],
              [
                61.1596207,
                36.4093525
              ],
              [
                61.1606175,
                36.4102339
              ],
              [
                61.1614459,
                36.4107762
              ],
              [
                61.163285,
                36.4118835
              ],
              [
                61.1651242,
                36.4127309
              ],
              [
                61.1662474,
                36.4132054
              ],
              [
                61.1663878,
                36.4133749
              ],
              [
                61.1669915,
                36.4145951
              ],
              [
                61.1673565,
                36.4155893
              ],
              [
                61.1674829,
                36.4163463
              ],
              [
                61.1674407,
                36.4173857
              ],
              [
                61.1673565,
                36.4178263
              ],
              [
                61.167174,
                36.4182217
              ],
              [
                61.1669774,
                36.4186058
              ],
              [
                61.1665703,
                36.4192272
              ],
              [
                61.1663737,
                36.4196791
              ],
              [
                61.1660929,
                36.4206507
              ],
              [
                61.16577,
                36.4216335
              ],
              [
                61.1655454,
                36.4222775
              ],
              [
                61.1653067,
                36.4227181
              ],
              [
                61.1648294,
                36.4232716
              ],
              [
                61.1632289,
                36.4249887
              ],
              [
                61.1629481,
                36.4254632
              ],
              [
                61.1627515,
                36.4259715
              ],
              [
                61.1625269,
                36.4268753
              ],
              [
                61.162204,
                36.4281066
              ],
              [
                61.1618951,
                36.4287843
              ],
              [
                61.1617968,
                36.4291458
              ],
              [
                61.1617968,
                36.4294847
              ],
              [
                61.1618138,
                36.430086
              ],
              [
                61.1617997,
                36.4308654
              ],
              [
                61.1619121,
                36.4329777
              ],
              [
                61.1620665,
                36.4337006
              ],
              [
                61.1625579,
                36.4348302
              ],
              [
                61.1630633,
                36.4357564
              ],
              [
                61.1642426,
                36.4373377
              ],
              [
                61.1645936,
                36.4379024
              ],
              [
                61.1648744,
                36.438806
              ],
              [
                61.1649165,
                36.4392804
              ],
              [
                61.1648884,
                36.4397322
              ],
              [
                61.1646076,
                36.4403759
              ],
              [
                61.1643128,
                36.44076
              ],
              [
                61.164032,
                36.4409858
              ],
              [
                61.1634704,
                36.4413134
              ],
              [
                61.1617015,
                36.4423863
              ],
              [
                61.1609433,
                36.4431092
              ],
              [
                61.1605502,
                36.443832
              ],
              [
                61.1604519,
                36.4443515
              ],
              [
                61.1604941,
                36.4446677
              ],
              [
                61.1605502,
                36.4451646
              ],
              [
                61.1604519,
                36.4456842
              ],
              [
                61.1602133,
                36.4461133
              ],
              [
                61.1598763,
                36.447796
              ],
              [
                61.1598061,
                36.4487221
              ],
              [
                61.1599044,
                36.4489367
              ],
              [
                61.1599044,
                36.4492529
              ],
              [
                61.15975,
                36.4495465
              ],
              [
                61.1596938,
                36.4498175
              ],
              [
                61.1595675,
                36.4502692
              ],
              [
                61.1594271,
                36.4504499
              ],
              [
                61.1588795,
                36.4508226
              ],
              [
                61.158711,
                36.4510485
              ],
              [
                61.1584864,
                36.4520761
              ],
              [
                61.1585707,
                36.4523358
              ],
              [
                61.1587672,
                36.4526182
              ],
              [
                61.1589216,
                36.453499
              ],
              [
                61.1588795,
                36.4541652
              ],
              [
                61.1589638,
                36.4544814
              ],
              [
                61.1591182,
                36.4548315
              ],
              [
                61.1593709,
                36.4551251
              ],
              [
                61.1599184,
                36.4554074
              ],
              [
                61.1613364,
                36.455972
              ],
              [
                61.1634283,
                36.456706
              ],
              [
                61.1642988,
                36.4570561
              ],
              [
                61.1674296,
                36.4577336
              ],
              [
                61.1687212,
                36.4578465
              ],
              [
                61.1704762,
                36.4578013
              ],
              [
                61.1710377,
                36.4578917
              ],
              [
                61.1716836,
                36.4581288
              ],
              [
                61.1720626,
                36.4583885
              ],
              [
                61.1724557,
                36.4587047
              ],
              [
                61.1727646,
                36.459066
              ],
              [
                61.1741124,
                36.4603081
              ],
              [
                61.1742809,
                36.4605226
              ],
              [
                61.1744353,
                36.4609743
              ],
              [
                61.1747863,
                36.4627019
              ],
              [
                61.1747863,
                36.4630406
              ],
              [
                61.1747021,
                36.4633342
              ],
              [
                61.1738597,
                36.4646778
              ],
              [
                61.1736351,
                36.4652423
              ],
              [
                61.1735508,
                36.4657165
              ],
              [
                61.1735087,
                36.4661682
              ],
              [
                61.1734378,
                36.4666324
              ],
              [
                61.1734037,
                36.4668555
              ],
              [
                61.1733756,
                36.4672281
              ],
              [
                61.1732072,
                36.4676684
              ],
              [
                61.1729123,
                36.4682216
              ],
              [
                61.1724069,
                36.4689217
              ],
              [
                61.1713961,
                36.4703442
              ],
              [
                61.1711995,
                36.4707055
              ],
              [
                61.1710872,
                36.4711797
              ],
              [
                61.1709187,
                36.4715748
              ],
              [
                61.1696692,
                36.4730877
              ],
              [
                61.1691076,
                36.4738441
              ],
              [
                61.1687286,
                36.4744311
              ],
              [
                61.1684337,
                36.4747134
              ],
              [
                61.1678862,
                36.4750633
              ],
              [
                61.1677177,
                36.4751762
              ],
              [
                61.1675633,
                36.4754472
              ],
              [
                61.167451,
                36.4758649
              ],
              [
                61.1674229,
                36.4764971
              ],
              [
                61.1675633,
                36.4779646
              ],
              [
                61.1677739,
                36.4792629
              ],
              [
                61.1677037,
                36.4794999
              ],
              [
                61.1675212,
                36.4797596
              ],
              [
                61.1673246,
                36.4800418
              ],
              [
                61.1669596,
                36.480911
              ],
              [
                61.1666928,
                36.4812835
              ],
              [
                61.1664261,
                36.4814754
              ],
              [
                61.1658083,
                36.4817577
              ],
              [
                61.164278,
                36.4821527
              ],
              [
                61.1636182,
                36.4822318
              ],
              [
                61.1628179,
                36.4821753
              ],
              [
                61.1609366,
                36.4821527
              ],
              [
                61.1604733,
                36.4821979
              ],
              [
                61.1600521,
                36.4823785
              ],
              [
                61.1597152,
                36.4826043
              ],
              [
                61.1593642,
                36.482751
              ],
              [
                61.1591396,
                36.4829091
              ],
              [
                61.1587605,
                36.4833606
              ],
              [
                61.1586341,
                36.4836541
              ],
              [
                61.1582551,
                36.4840717
              ],
              [
                61.1575952,
                36.4846249
              ],
              [
                61.1572302,
                36.485099
              ],
              [
                61.1570336,
                36.4857311
              ],
              [
                61.1569211,
                36.4865636
              ],
              [
                61.1569211,
                36.486812
              ],
              [
                61.1569772,
                36.4870603
              ],
              [
                61.1572299,
                36.4875344
              ],
              [
                61.1578758,
                36.4887083
              ],
              [
                61.1587322,
                36.4906948
              ],
              [
                61.1590551,
                36.4912931
              ],
              [
                61.1605994,
                36.4935843
              ],
              [
                61.1607258,
                36.4938326
              ],
              [
                61.160796,
                36.4940696
              ],
              [
                61.1609785,
                36.4946678
              ],
              [
                61.1614278,
                36.4957739
              ],
              [
                61.1620174,
                36.497591
              ],
              [
                61.1620455,
                36.4977828
              ],
              [
                61.1620034,
                36.4980198
              ],
              [
                61.1619753,
                36.4983471
              ],
              [
                61.1620034,
                36.4988776
              ],
              [
                61.161863,
                36.4994419
              ],
              [
                61.1617928,
                36.5000964
              ],
              [
                61.1618349,
                36.500672
              ],
              [
                61.1619191,
                36.501146
              ],
              [
                61.1621438,
                36.5015523
              ],
              [
                61.1621578,
                36.5017329
              ],
              [
                61.1620876,
                36.5020601
              ],
              [
                61.161863,
                36.5023874
              ],
              [
                61.1613856,
                36.5026583
              ],
              [
                61.1612312,
                36.5027034
              ],
              [
                61.1603467,
                36.5033128
              ],
              [
                61.1598694,
                36.5036062
              ],
              [
                61.1593647,
                36.5037837
              ],
              [
                61.1590839,
                36.5038739
              ],
              [
                61.158747,
                36.5040884
              ],
              [
                61.1581292,
                36.5045623
              ],
              [
                61.1576098,
                36.5051604
              ],
              [
                61.1568657,
                36.5059955
              ],
              [
                61.1567253,
                36.5062664
              ],
              [
                61.1566972,
                36.5065146
              ],
              [
                61.1567674,
                36.5067968
              ],
              [
                61.1571465,
                36.5078688
              ],
              [
                61.1575536,
                36.5083089
              ],
              [
                61.1578484,
                36.5085233
              ],
              [
                61.1581713,
                36.5086474
              ],
              [
                61.1587189,
                36.5086587
              ],
              [
                61.1591681,
                36.508591
              ],
              [
                61.1599403,
                36.5086361
              ],
              [
                61.1606563,
                36.508828
              ],
              [
                61.16126,
                36.508986
              ],
              [
                61.1619339,
                36.5093471
              ],
              [
                61.1624815,
                36.5097646
              ],
              [
                61.1628044,
                36.5101257
              ],
              [
                61.1631694,
                36.510656
              ],
              [
                61.1633519,
                36.51113
              ],
              [
                61.1636327,
                36.5121343
              ],
              [
                61.1640118,
                36.5132062
              ],
              [
                61.1642645,
                36.5140864
              ],
              [
                61.1643206,
                36.5145941
              ],
              [
                61.164447,
                36.5154517
              ],
              [
                61.1645593,
                36.5156548
              ],
              [
                61.1653034,
                36.5166252
              ],
              [
                61.1656544,
                36.5171442
              ],
              [
                61.1667916,
                36.5189382
              ],
              [
                61.1671508,
                36.51933
              ],
              [
                61.1674597,
                36.5196347
              ],
              [
                61.1677966,
                36.5198942
              ],
              [
                61.1699728,
                36.5214625
              ],
              [
                61.1705624,
                36.5217558
              ],
              [
                61.1709836,
                36.5220266
              ],
              [
                61.1721208,
                36.5223764
              ],
              [
                61.1728087,
                36.5226133
              ],
              [
                61.1733984,
                36.5226359
              ],
              [
                61.1754482,
                36.5229631
              ],
              [
                61.1777647,
                36.5234482
              ],
              [
                61.1792669,
                36.5238318
              ],
              [
                61.1798425,
                36.5240349
              ],
              [
                61.1806147,
                36.5244185
              ],
              [
                61.1813058,
                36.5248746
              ],
              [
                61.1816287,
                36.5251002
              ],
              [
                61.1819235,
                36.525371
              ],
              [
                61.1825974,
                36.5259915
              ],
              [
                61.1831881,
                36.5267233
              ],
              [
                61.1833846,
                36.5270956
              ],
              [
                61.1835952,
                36.5275808
              ],
              [
                61.1835952,
                36.5280659
              ],
              [
                61.1835391,
                36.5283705
              ],
              [
                61.1833706,
                36.5287653
              ],
              [
                61.182809,
                36.5294197
              ],
              [
                61.1824018,
                36.5299048
              ],
              [
                61.1816297,
                36.5308975
              ],
              [
                61.1813208,
                36.5312247
              ],
              [
                61.1810962,
                36.5313601
              ],
              [
                61.1806329,
                36.531518
              ],
              [
                61.1801976,
                36.5316534
              ],
              [
                61.1797624,
                36.5318677
              ],
              [
                61.1790885,
                36.5323641
              ],
              [
                61.1779373,
                36.5333342
              ],
              [
                61.1771791,
                36.5340675
              ],
              [
                61.1766176,
                36.534812
              ],
              [
                61.1763368,
                36.5353986
              ],
              [
                61.1761262,
                36.5359739
              ],
              [
                61.1760279,
                36.5366846
              ],
              [
                61.1758594,
                36.5371471
              ],
              [
                61.1757892,
                36.5376434
              ],
              [
                61.1758735,
                36.5379818
              ],
              [
                61.176056,
                36.5382413
              ],
              [
                61.1768013,
                36.539244
              ],
              [
                61.1775314,
                36.5401464
              ],
              [
                61.1778543,
                36.5407329
              ],
              [
                61.1786545,
                36.5416691
              ],
              [
                61.1798339,
                36.542876
              ],
              [
                61.1808728,
                36.5438686
              ],
              [
                61.1819258,
                36.5446131
              ],
              [
                61.18413,
                36.5463613
              ],
              [
                61.1847056,
                36.5468125
              ],
              [
                61.185562,
                36.5480081
              ],
              [
                61.1857585,
                36.5483239
              ],
              [
                61.1858849,
                36.5490683
              ],
              [
                61.1858989,
                36.5494517
              ],
              [
                61.1858007,
                36.5497675
              ],
              [
                61.1856603,
                36.549948
              ],
              [
                61.1854637,
                36.5500044
              ],
              [
                61.1852812,
                36.550151
              ],
              [
                61.1851689,
                36.550354
              ],
              [
                61.1851408,
                36.5505796
              ],
              [
                61.1848881,
                36.5511886
              ],
              [
                61.1845371,
                36.551933
              ],
              [
                61.1842844,
                36.5525758
              ],
              [
                61.184158,
                36.5527675
              ],
              [
                61.1835684,
                36.5532525
              ],
              [
                61.1833718,
                36.5535119
              ],
              [
                61.1829506,
                36.5538164
              ],
              [
                61.1825856,
                36.5540758
              ],
              [
                61.1819538,
                36.5548652
              ],
              [
                61.1817994,
                36.5552374
              ],
              [
                61.1817994,
                36.5556321
              ],
              [
                61.1818556,
                36.5562524
              ],
              [
                61.1820662,
                36.5570644
              ],
              [
                61.1825718,
                36.5583315
              ],
              [
                61.1832598,
                36.5598878
              ],
              [
                61.183695,
                36.5608125
              ],
              [
                61.1841723,
                36.5613312
              ],
              [
                61.1843548,
                36.5616921
              ],
              [
                61.1845654,
                36.5623687
              ],
              [
                61.1849164,
                36.5639136
              ],
              [
                61.1849585,
                36.5641616
              ],
              [
                61.1852955,
                36.5645676
              ],
              [
                61.1856605,
                36.5652442
              ],
              [
                61.185843,
                36.5657741
              ],
              [
                61.185829,
                36.5661237
              ],
              [
                61.1857588,
                36.5666311
              ],
              [
                61.1853236,
                36.5678151
              ],
              [
                61.1848883,
                36.5686157
              ],
              [
                61.1844391,
                36.569202
              ],
              [
                61.183709,
                36.5698335
              ],
              [
                61.1827543,
                36.5707242
              ],
              [
                61.1818558,
                36.5717954
              ],
              [
                61.1813644,
                36.5724381
              ],
              [
                61.1800026,
                36.5744563
              ],
              [
                61.1793781,
                36.5756603
              ],
              [
                61.1789148,
                36.5767652
              ],
              [
                61.1788165,
                36.5772049
              ],
              [
                61.1788305,
                36.5775544
              ],
              [
                61.1790131,
                36.5781858
              ],
              [
                61.1790131,
                36.5784338
              ],
              [
                61.1785497,
                36.5800911
              ],
              [
                61.1784374,
                36.5803391
              ],
              [
                61.1782549,
                36.5805646
              ],
              [
                61.1778618,
                36.5807901
              ],
              [
                61.1776933,
                36.5809479
              ],
              [
                61.1776231,
                36.5811847
              ],
              [
                61.177567,
                36.5815229
              ],
              [
                61.1774547,
                36.582064
              ],
              [
                61.1769914,
                36.5839918
              ],
              [
                61.1769352,
                36.5843864
              ],
              [
                61.1769071,
                36.5846795
              ],
              [
                61.1767948,
                36.584905
              ],
              [
                61.1766404,
                36.5855814
              ],
              [
                61.1763596,
                36.5865283
              ],
              [
                61.1762192,
                36.5874866
              ],
              [
                61.1762052,
                36.5878924
              ],
              [
                61.1762473,
                36.5881066
              ],
              [
                61.1764579,
                36.5884448
              ],
              [
                61.1771177,
                36.5894255
              ],
              [
                61.1773002,
                36.5897073
              ],
              [
                61.1773424,
                36.5899553
              ],
              [
                61.1773424,
                36.5901131
              ],
              [
                61.177216,
                36.5904851
              ],
              [
                61.1770054,
                36.5907331
              ],
              [
                61.1765842,
                36.5911727
              ],
              [
                61.1764298,
                36.5914658
              ],
              [
                61.1764017,
                36.5916462
              ],
              [
                61.1763455,
                36.5919618
              ],
              [
                61.1762718,
                36.5920569
              ],
              [
                61.1759208,
                36.5922372
              ],
              [
                61.1751767,
                36.5928797
              ],
              [
                61.174924,
                36.5930263
              ],
              [
                61.1744326,
                36.5931841
              ],
              [
                61.1741939,
                36.5932855
              ],
              [
                61.1738008,
                36.5936237
              ],
              [
                61.172088,
                36.5949989
              ],
              [
                61.1719897,
                36.5952243
              ],
              [
                61.1716388,
                36.5957541
              ],
              [
                61.171021,
                36.5968587
              ],
              [
                61.1709087,
                36.5971292
              ],
              [
                61.1709368,
                36.5975012
              ],
              [
                61.1709368,
                36.5979295
              ],
              [
                61.1708385,
                36.5983466
              ],
              [
                61.1708666,
                36.5987411
              ],
              [
                61.1711053,
                36.599237
              ],
              [
                61.1712737,
                36.5994399
              ],
              [
                61.171386,
                36.6003416
              ],
              [
                61.1714843,
                36.6006346
              ],
              [
                61.1716528,
                36.6008037
              ],
              [
                61.1722565,
                36.6010967
              ],
              [
                61.172453,
                36.6012658
              ],
              [
                61.1725654,
                36.601525
              ],
              [
                61.1734077,
                36.6027085
              ],
              [
                61.1735341,
                36.6032269
              ],
              [
                61.1736043,
                36.6034862
              ],
              [
                61.1736324,
                36.6037679
              ],
              [
                61.173857,
                36.6042187
              ],
              [
                61.1739412,
                36.604523
              ],
              [
                61.1739553,
                36.6053232
              ],
              [
                61.1739132,
                36.6055825
              ],
              [
                61.1737868,
                36.6058191
              ],
              [
                61.1731691,
                36.6061009
              ],
              [
                61.1724671,
                36.60627
              ],
              [
                61.1721161,
                36.6062812
              ],
              [
                61.1718072,
                36.6062023
              ],
              [
                61.1705016,
                36.6054923
              ],
              [
                61.1702208,
                36.605481
              ],
              [
                61.1699961,
                36.6055261
              ],
              [
                61.1697013,
                36.6057177
              ],
              [
                61.1695609,
                36.6058755
              ],
              [
                61.1694486,
                36.6061009
              ],
              [
                61.1694345,
                36.6064277
              ],
              [
                61.1695188,
                36.6068898
              ],
              [
                61.169603,
                36.6074308
              ],
              [
                61.1695328,
                36.6081408
              ],
              [
                61.169603,
                36.6085803
              ],
              [
                61.169603,
                36.6088283
              ],
              [
                61.1693363,
                36.6092565
              ],
              [
                61.1689291,
                36.609651
              ],
              [
                61.1684398,
                36.6098469
              ],
              [
                61.1681169,
                36.6098807
              ],
              [
                61.1673447,
                36.6098357
              ],
              [
                61.1671902,
                36.6098695
              ],
              [
                61.1670358,
                36.6099822
              ],
              [
                61.1667691,
                36.6102414
              ],
              [
                61.1665865,
                36.6105795
              ],
              [
                61.1661934,
                36.6115486
              ],
              [
                61.1657985,
                36.612317
              ],
              [
                61.1655037,
                36.6128354
              ],
              [
                61.1654476,
                36.6131172
              ],
              [
                61.1654897,
                36.6133876
              ],
              [
                61.1655318,
                36.6137257
              ],
              [
                61.1652931,
                36.6144807
              ],
              [
                61.1651387,
                36.6148301
              ],
              [
                61.164886,
                36.6151005
              ],
              [
                61.1645069,
                36.6153372
              ],
              [
                61.1640576,
                36.6155062
              ],
              [
                61.1633697,
                36.6156076
              ],
              [
                61.1630468,
                36.6156076
              ],
              [
                61.1625273,
                36.615664
              ],
              [
                61.1610532,
                36.6155513
              ],
              [
                61.160646,
                36.6155964
              ],
              [
                61.1603091,
                36.6157203
              ],
              [
                61.1592983,
                36.6163514
              ],
              [
                61.1589332,
                36.6165317
              ],
              [
                61.1584418,
                36.6166556
              ],
              [
                61.1580487,
                36.6167683
              ],
              [
                61.1576135,
                36.6170388
              ],
              [
                61.1571221,
                36.617512
              ],
              [
                61.1568694,
                36.6176247
              ],
              [
                61.1565465,
                36.6177036
              ],
              [
                61.1559568,
                36.6176698
              ],
              [
                61.1555216,
                36.6177374
              ],
              [
                61.1551987,
                36.6178501
              ],
              [
                61.154595,
                36.6182107
              ],
              [
                61.1535842,
                36.6192249
              ],
              [
                61.1534578,
                36.6194615
              ],
              [
                61.1534578,
                36.6199122
              ],
              [
                61.153514,
                36.6202277
              ],
              [
                61.1537246,
                36.6206897
              ],
              [
                61.1538228,
                36.6210616
              ],
              [
                61.1536965,
                36.6215461
              ],
              [
                61.1536263,
                36.6218278
              ],
              [
                61.1533174,
                36.6223349
              ],
              [
                61.1529524,
                36.6228419
              ],
              [
                61.1526154,
                36.6235856
              ],
              [
                61.1524329,
                36.6242617
              ],
              [
                61.1520679,
                36.6250955
              ],
              [
                61.1519837,
                36.6253433
              ],
              [
                61.1519837,
                36.6256025
              ],
              [
                61.15211,
                36.6259518
              ],
              [
                61.1522925,
                36.6263574
              ],
              [
                61.1525312,
                36.6266616
              ],
              [
                61.1529664,
                36.627056
              ],
              [
                61.1530787,
                36.6271686
              ],
              [
                61.1531068,
                36.6273264
              ],
              [
                61.1531068,
                36.6274841
              ],
              [
                61.1530507,
                36.6277095
              ],
              [
                61.1529103,
                36.6279573
              ],
              [
                61.1525611,
                36.6286053
              ],
              [
                61.1522522,
                36.6288757
              ],
              [
                61.1519574,
                36.6290334
              ],
              [
                61.151466,
                36.6293038
              ],
              [
                61.1512133,
                36.6294165
              ],
              [
                61.1502165,
                36.6295404
              ],
              [
                61.1497532,
                36.6296531
              ],
              [
                61.1490091,
                36.6301263
              ],
              [
                61.1482369,
                36.6305995
              ],
              [
                61.1474788,
                36.6311853
              ],
              [
                61.1470716,
                36.6315459
              ],
              [
                61.1467347,
                36.6319515
              ],
              [
                61.146496,
                36.6324923
              ],
              [
                61.1463275,
                36.632988
              ],
              [
                61.1462714,
                36.6334386
              ],
              [
                61.1462012,
                36.6336865
              ],
              [
                61.1460608,
                36.6342498
              ],
              [
                61.1459344,
                36.6344639
              ],
              [
                61.1457519,
                36.6346441
              ],
              [
                61.1454571,
                36.63523
              ],
              [
                61.1454009,
                36.6355003
              ],
              [
                61.1453027,
                36.6362101
              ],
              [
                61.1452044,
                36.6369536
              ],
              [
                61.1451201,
                36.6371339
              ],
              [
                61.144713,
                36.6376296
              ],
              [
                61.1441655,
                36.6385534
              ],
              [
                61.1438847,
                36.6389815
              ],
              [
                61.143646,
                36.639218
              ],
              [
                61.1434354,
                36.6395222
              ],
              [
                61.1433652,
                36.6397475
              ],
              [
                61.1434055,
                36.6401656
              ],
              [
                61.143524,
                36.6407426
              ],
              [
                61.143705,
                36.6412655
              ],
              [
                61.1440107,
                36.6418158
              ],
              [
                61.1440606,
                36.6423081
              ],
              [
                61.1442821,
                36.6430218
              ],
              [
                61.1444193,
                36.6435552
              ],
              [
                61.1444528,
                36.6440585
              ],
              [
                61.1446662,
                36.6449297
              ],
              [
                61.1448795,
                36.6453278
              ],
              [
                61.1450308,
                36.6458838
              ],
              [
                61.1454174,
                36.6464182
              ],
              [
                61.1387816,
                36.6457884
              ],
              [
                61.1288645,
                36.6442951
              ],
              [
                61.1012954,
                36.6438284
              ],
              [
                61.076954,
                36.6426837
              ],
              [
                61.0625952,
                36.6419809
              ],
              [
                61.0370811,
                36.6407337
              ],
              [
                61.0159768,
                36.6397418
              ],
              [
                61.0071691,
                36.6392999
              ],
              [
                60.9968859,
                36.6389012
              ],
              [
                60.979364,
                36.6380015
              ],
              [
                60.9528391,
                36.6368252
              ],
              [
                60.928845,
                36.6356881
              ],
              [
                60.9044014,
                36.6345934
              ],
              [
                60.8804153,
                36.6333557
              ],
              [
                60.8530171,
                36.6320521
              ],
              [
                60.8252384,
                36.6305155
              ],
              [
                60.807335,
                36.629649
              ],
              [
                60.7840906,
                36.6283703
              ],
              [
                60.7781099,
                36.6280533
              ],
              [
                60.7572982,
                36.6269504
              ],
              [
                60.7382641,
                36.6258818
              ],
              [
                60.7158069,
                36.6245699
              ],
              [
                60.6937018,
                36.6232501
              ],
              [
                60.6752205,
                36.6222116
              ],
              [
                60.6536179,
                36.6240625
              ],
              [
                60.6384009,
                36.6253586
              ],
              [
                60.6362567,
                36.6255412
              ],
              [
                60.6087152,
                36.627961
              ],
              [
                60.5857407,
                36.6281783
              ],
              [
                60.5711248,
                36.6283152
              ],
              [
                60.5447238,
                36.6285362
              ],
              [
                60.5120363,
                36.6270305
              ],
              [
                60.4888549,
                36.6259902
              ],
              [
                60.4519776,
                36.6262977
              ],
              [
                60.4349428,
                36.6269578
              ],
              [
                60.4226264,
                36.6274122
              ],
              [
                60.3899738,
                36.6285373
              ],
              [
                60.3606236,
                36.6294918
              ],
              [
                60.3615684,
                36.6280949
              ],
              [
                60.3677772,
                36.6146054
              ],
              [
                60.3688906,
                36.614047
              ],
              [
                60.3691639,
                36.6134886
              ],
              [
                60.3702773,
                36.6129303
              ],
              [
                60.3716571,
                36.6043275
              ],
              [
                60.3800009,
                36.5956842
              ],
              [
                60.403902,
                36.5961939
              ],
              [
                60.406402,
                36.5942492
              ],
              [
                60.4100416,
                36.5901712
              ],
              [
                60.4023843,
                36.5701759
              ],
              [
                60.4015507,
                36.5685098
              ],
              [
                60.4024551,
                36.5478398
              ],
              [
                60.4044669,
                36.5311063
              ],
              [
                60.4074239,
                36.5223288
              ],
              [
                60.4107283,
                36.5151551
              ],
              [
                60.4172945,
                36.5005294
              ],
              [
                60.4187534,
                36.4955617
              ],
              [
                60.4422505,
                36.4816007
              ],
              [
                60.4491806,
                36.4760667
              ],
              [
                60.4548025,
                36.4736166
              ],
              [
                60.4573418,
                36.4707301
              ],
              [
                60.4546607,
                36.4681618
              ],
              [
                60.4503895,
                36.4665389
              ],
              [
                60.4403241,
                36.465784
              ],
              [
                60.4293372,
                36.4630714
              ],
              [
                60.4243371,
                36.4616748
              ],
              [
                60.4040509,
                36.4581132
              ],
              [
                60.4012778,
                36.455897
              ],
              [
                60.3996109,
                36.4553384
              ],
              [
                60.3976645,
                36.4553384
              ],
              [
                60.3923843,
                36.4536719
              ],
              [
                60.3907179,
                36.4536719
              ],
              [
                60.3904444,
                36.4533925
              ],
              [
                60.3893311,
                36.4533925
              ],
              [
                60.38256,
                36.4551405
              ],
              [
                60.3817268,
                36.4551406
              ],
              [
                60.3572686,
                36.4519287
              ],
              [
                60.3556021,
                36.4519287
              ],
              [
                60.3542154,
                36.4516494
              ],
              [
                60.3519954,
                36.4516494
              ],
              [
                60.3492153,
                36.4510912
              ],
              [
                60.3433824,
                36.4510911
              ],
              [
                60.3425487,
                36.4513703
              ],
              [
                60.3322688,
                36.4513703
              ],
              [
                60.3300488,
                36.4510912
              ],
              [
                60.3275493,
                36.4510912
              ],
              [
                60.3261558,
                36.4508122
              ],
              [
                60.3239358,
                36.4508121
              ],
              [
                60.3217158,
                36.4505329
              ],
              [
                60.3100492,
                36.4497045
              ],
              [
                60.2905413,
                36.4442955
              ],
              [
                60.289428,
                36.4442955
              ],
              [
                60.2891545,
                36.4440163
              ],
              [
                60.2880412,
                36.4440164
              ],
              [
                60.2849881,
                36.4434581
              ],
              [
                60.2634428,
                36.4277745
              ],
              [
                60.2394102,
                36.4268076
              ],
              [
                60.2244899,
                36.4194431
              ],
              [
                60.2174863,
                36.4145304
              ],
              [
                60.2123705,
                36.412283
              ],
              [
                60.2075168,
                36.4113761
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555137,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فریمان",
          "name:en": "Fariman County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q301694",
          "wikipedia": "fa:شهرستان فریمان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.4867139,
                35.7885218
              ],
              [
                59.4867138,
                35.7882422
              ],
              [
                59.4865033,
                35.7777146
              ],
              [
                59.4923397,
                35.7509707
              ],
              [
                59.4977462,
                35.71799
              ],
              [
                59.4974731,
                35.71744
              ],
              [
                59.4966395,
                35.7168811
              ],
              [
                59.4963594,
                35.7166015
              ],
              [
                59.4899729,
                35.7093796
              ],
              [
                59.4896928,
                35.7091
              ],
              [
                59.4902464,
                35.7085409
              ],
              [
                59.4902463,
                35.7082705
              ],
              [
                59.4908061,
                35.7079819
              ],
              [
                59.4910796,
                35.7054844
              ],
              [
                59.4908062,
                35.703537
              ],
              [
                59.4905264,
                35.7032665
              ],
              [
                59.4905264,
                35.7027075
              ],
              [
                59.4828766,
                35.6963238
              ],
              [
                59.482323,
                35.6960353
              ],
              [
                59.4820434,
                35.6952058
              ],
              [
                59.4770432,
                35.6849271
              ],
              [
                59.4796628,
                35.6766664
              ],
              [
                59.4791093,
                35.6741604
              ],
              [
                59.4802226,
                35.6652717
              ],
              [
                59.4802226,
                35.6644423
              ],
              [
                59.4804961,
                35.6641628
              ],
              [
                59.4843895,
                35.6574918
              ],
              [
                59.4882759,
                35.6524975
              ],
              [
                59.4993889,
                35.6361081
              ],
              [
                59.4996624,
                35.6333315
              ],
              [
                59.5040127,
                35.6254892
              ],
              [
                59.4954296,
                35.6187913
              ],
              [
                59.4899292,
                35.6072296
              ],
              [
                59.4877025,
                35.6036237
              ],
              [
                59.487429,
                35.6025057
              ],
              [
                59.4868693,
                35.6019558
              ],
              [
                59.4894222,
                35.5830317
              ],
              [
                59.4891488,
                35.5816342
              ],
              [
                59.488589,
                35.5805252
              ],
              [
                59.4872023,
                35.5730237
              ],
              [
                59.4880354,
                35.5608065
              ],
              [
                59.502291,
                35.5400195
              ],
              [
                59.5147162,
                35.5201987
              ],
              [
                59.5217317,
                35.5130812
              ],
              [
                59.5269727,
                35.5080552
              ],
              [
                59.5346173,
                35.5030367
              ],
              [
                59.5413727,
                35.5016389
              ],
              [
                59.5560725,
                35.5002502
              ],
              [
                59.5799732,
                35.5025703
              ],
              [
                59.5899295,
                35.5062735
              ],
              [
                59.5931911,
                35.5056097
              ],
              [
                59.5981755,
                35.5062446
              ],
              [
                59.6023321,
                35.4998801
              ],
              [
                59.6073134,
                35.4934878
              ],
              [
                59.6141203,
                35.4923092
              ],
              [
                59.6144004,
                35.4920297
              ],
              [
                59.6323728,
                35.4876508
              ],
              [
                59.647041,
                35.4813905
              ],
              [
                59.6546548,
                35.4786647
              ],
              [
                59.6879129,
                35.4727771
              ],
              [
                59.6884661,
                35.4724976
              ],
              [
                59.693193,
                35.4724976
              ],
              [
                59.6945795,
                35.472218
              ],
              [
                59.6954127,
                35.4724976
              ],
              [
                59.6967994,
                35.4722181
              ],
              [
                59.7269324,
                35.4658053
              ],
              [
                59.7341591,
                35.4658053
              ],
              [
                59.7355458,
                35.4655168
              ],
              [
                59.741099,
                35.4655167
              ],
              [
                59.744712,
                35.4655167
              ],
              [
                59.7469391,
                35.4652462
              ],
              [
                59.7586021,
                35.4604831
              ],
              [
                59.7711019,
                35.4602125
              ],
              [
                59.7716554,
                35.4602125
              ],
              [
                59.7722086,
                35.459924
              ],
              [
                59.7747086,
                35.459924
              ],
              [
                59.7747087,
                35.4596534
              ],
              [
                59.800692,
                35.4474596
              ],
              [
                59.8026609,
                35.4468266
              ],
              [
                59.8156213,
                35.444624
              ],
              [
                59.8312127,
                35.444176
              ],
              [
                59.8597153,
                35.4465893
              ],
              [
                59.8768401,
                35.4419739
              ],
              [
                59.8931216,
                35.4389669
              ],
              [
                59.9111841,
                35.4362747
              ],
              [
                59.9232027,
                35.4350162
              ],
              [
                59.9290917,
                35.4380032
              ],
              [
                59.9422293,
                35.4485421
              ],
              [
                59.9518188,
                35.4551645
              ],
              [
                59.963164,
                35.4546228
              ],
              [
                59.9674129,
                35.4610545
              ],
              [
                59.9715754,
                35.4660881
              ],
              [
                59.9917868,
                35.4598278
              ],
              [
                59.9997051,
                35.4613058
              ],
              [
                60.0089997,
                35.4641022
              ],
              [
                60.0200301,
                35.4665719
              ],
              [
                60.028298,
                35.4684871
              ],
              [
                60.0462992,
                35.4723408
              ],
              [
                60.0837183,
                35.4866616
              ],
              [
                60.095775,
                35.5049742
              ],
              [
                60.1085479,
                35.5180303
              ],
              [
                60.1192471,
                35.5333441
              ],
              [
                60.1390243,
                35.5372834
              ],
              [
                60.1404177,
                35.5364541
              ],
              [
                60.1597592,
                35.5445188
              ],
              [
                60.1607891,
                35.5573679
              ],
              [
                60.1676243,
                35.5688718
              ],
              [
                60.1670708,
                35.5697103
              ],
              [
                60.1656774,
                35.5785999
              ],
              [
                60.1561012,
                35.5858059
              ],
              [
                60.1544345,
                35.5916394
              ],
              [
                60.1541548,
                35.5946958
              ],
              [
                60.1580478,
                35.601638
              ],
              [
                60.1707455,
                35.6106973
              ],
              [
                60.1827873,
                35.6107996
              ],
              [
                60.2211837,
                35.6007099
              ],
              [
                60.2231236,
                35.6015394
              ],
              [
                60.2455899,
                35.6014858
              ],
              [
                60.2550397,
                35.6157094
              ],
              [
                60.2572968,
                35.6463511
              ],
              [
                60.2561269,
                35.6624685
              ],
              [
                60.2614067,
                35.6674721
              ],
              [
                60.2730735,
                35.674414
              ],
              [
                60.2739066,
                35.6749728
              ],
              [
                60.2966162,
                35.6827615
              ],
              [
                60.2993963,
                35.6824911
              ],
              [
                60.3013433,
                35.6822115
              ],
              [
                60.311343,
                35.6791555
              ],
              [
                60.3182897,
                35.6769378
              ],
              [
                60.3321759,
                35.6719345
              ],
              [
                60.3463425,
                35.6672107
              ],
              [
                60.3571756,
                35.6641545
              ],
              [
                60.3580088,
                35.6636046
              ],
              [
                60.3599558,
                35.6630457
              ],
              [
                60.3610691,
                35.6630457
              ],
              [
                60.363009,
                35.6624867
              ],
              [
                60.3685689,
                35.6619369
              ],
              [
                60.3830788,
                35.6577441
              ],
              [
                60.3841851,
                35.6580236
              ],
              [
                60.3891919,
                35.6580235
              ],
              [
                60.3911317,
                35.657744
              ],
              [
                60.3930786,
                35.657744
              ],
              [
                60.4002983,
                35.6566351
              ],
              [
                60.4022453,
                35.6566351
              ],
              [
                60.4100251,
                35.6555262
              ],
              [
                60.4108583,
                35.6552467
              ],
              [
                60.4116916,
                35.6552467
              ],
              [
                60.4122853,
                35.6553663
              ],
              [
                60.4243164,
                35.6524501
              ],
              [
                60.4357748,
                35.6416908
              ],
              [
                60.4445456,
                35.6363719
              ],
              [
                60.4523147,
                35.6409754
              ],
              [
                60.458416,
                35.6433397
              ],
              [
                60.4603559,
                35.6436193
              ],
              [
                60.4611961,
                35.6438988
              ],
              [
                60.4637846,
                35.6487812
              ],
              [
                60.4648979,
                35.6490607
              ],
              [
                60.4665643,
                35.6490607
              ],
              [
                60.4679511,
                35.6493402
              ],
              [
                60.4737095,
                35.6551986
              ],
              [
                60.4837376,
                35.6630087
              ],
              [
                60.4851239,
                35.6627292
              ],
              [
                60.4987371,
                35.6635587
              ],
              [
                60.5037372,
                35.6646766
              ],
              [
                60.5385705,
                35.6779573
              ],
              [
                60.5546665,
                35.6872436
              ],
              [
                60.5613127,
                35.6987964
              ],
              [
                60.563259,
                35.7004646
              ],
              [
                60.5670219,
                35.7212173
              ],
              [
                60.5530227,
                35.7203821
              ],
              [
                60.5431926,
                35.7205394
              ],
              [
                60.5426394,
                35.7208191
              ],
              [
                60.5328412,
                35.7243728
              ],
              [
                60.5201555,
                35.7363542
              ],
              [
                60.5184891,
                35.7363542
              ],
              [
                60.5154158,
                35.7449861
              ],
              [
                60.5134689,
                35.744986
              ],
              [
                60.5012657,
                35.750004
              ],
              [
                60.4995993,
                35.7497247
              ],
              [
                60.4957124,
                35.7497246
              ],
              [
                60.491546,
                35.7491657
              ],
              [
                60.4879326,
                35.7491658
              ],
              [
                60.4865458,
                35.7488863
              ],
              [
                60.483486,
                35.7488864
              ],
              [
                60.4829324,
                35.748607
              ],
              [
                60.4815461,
                35.748607
              ],
              [
                60.4576849,
                35.7438869
              ],
              [
                60.4510183,
                35.7424988
              ],
              [
                60.4490785,
                35.7424989
              ],
              [
                60.4443515,
                35.7416606
              ],
              [
                60.4401849,
                35.7413901
              ],
              [
                60.4390782,
                35.7411107
              ],
              [
                60.4337984,
                35.7411107
              ],
              [
                60.3302078,
                35.7741524
              ],
              [
                60.3212598,
                35.7799864
              ],
              [
                60.3187598,
                35.7813655
              ],
              [
                60.3055267,
                35.7862228
              ],
              [
                60.3002466,
                35.7889992
              ],
              [
                60.2949734,
                35.7934523
              ],
              [
                60.2938601,
                35.7948404
              ],
              [
                60.279757,
                35.8126279
              ],
              [
                60.2780902,
                35.8134661
              ],
              [
                60.2558474,
                35.829142
              ],
              [
                60.2501373,
                35.8483258
              ],
              [
                60.2392973,
                35.8522103
              ],
              [
                60.2381911,
                35.8522103
              ],
              [
                60.2397141,
                35.8438595
              ],
              [
                60.2324874,
                35.8435801
              ],
              [
                60.2274877,
                35.842192
              ],
              [
                60.2143477,
                35.8342369
              ],
              [
                60.2008241,
                35.8352632
              ],
              [
                60.1891879,
                35.8493142
              ],
              [
                60.1864082,
                35.8493142
              ],
              [
                60.1880145,
                35.8280204
              ],
              [
                60.186348,
                35.8274616
              ],
              [
                60.1778695,
                35.8194123
              ],
              [
                60.1561218,
                35.8119164
              ],
              [
                60.1533417,
                35.8110871
              ],
              [
                60.1516752,
                35.8102487
              ],
              [
                60.1432419,
                35.8110969
              ],
              [
                60.1271957,
                35.8125551
              ],
              [
                60.1091356,
                35.8111676
              ],
              [
                60.1085824,
                35.8114469
              ],
              [
                60.106916,
                35.8114469
              ],
              [
                60.1066358,
                35.8117263
              ],
              [
                60.1044159,
                35.8117263
              ],
              [
                60.1038623,
                35.8120056
              ],
              [
                60.1021959,
                35.8120055
              ],
              [
                60.0960825,
                35.8136725
              ],
              [
                60.0952493,
                35.8136725
              ],
              [
                60.0949692,
                35.8139428
              ],
              [
                60.0854812,
                35.8075349
              ],
              [
                60.0838144,
                35.8083729
              ],
              [
                60.0509084,
                35.8105793
              ],
              [
                60.0478481,
                35.8111291
              ],
              [
                60.0369497,
                35.8016405
              ],
              [
                60.0352833,
                35.8021994
              ],
              [
                60.0269499,
                35.8060845
              ],
              [
                60.0233366,
                35.8083109
              ],
              [
                60.0106466,
                35.7910194
              ],
              [
                60.0037001,
                35.7926877
              ],
              [
                59.9747073,
                35.8196847
              ],
              [
                59.973594,
                35.8199641
              ],
              [
                59.9352944,
                35.8533298
              ],
              [
                59.9103781,
                35.8747167
              ],
              [
                59.9095448,
                35.8755458
              ],
              [
                59.8646522,
                35.9111032
              ],
              [
                59.8593725,
                35.9174836
              ],
              [
                59.8557658,
                35.923044
              ],
              [
                59.8554857,
                35.9236028
              ],
              [
                59.8554857,
                35.9242464
              ],
              [
                59.8552057,
                35.9316593
              ],
              [
                59.852186,
                35.9444363
              ],
              [
                59.8524591,
                35.9447067
              ],
              [
                59.8563526,
                35.9541505
              ],
              [
                59.8563525,
                35.9544299
              ],
              [
                59.856626,
                35.9552588
              ],
              [
                59.8594892,
                35.9630411
              ],
              [
                59.8629224,
                35.9680364
              ],
              [
                59.8631959,
                35.9683157
              ],
              [
                59.8637561,
                35.9713706
              ],
              [
                59.8699992,
                35.973031
              ],
              [
                59.8694456,
                35.9763657
              ],
              [
                59.8799722,
                35.978312
              ],
              [
                59.8806378,
                35.9871744
              ],
              [
                59.8727414,
                35.9980078
              ],
              [
                59.8591658,
                35.9985905
              ],
              [
                59.8547824,
                35.993865
              ],
              [
                59.8441296,
                35.9927565
              ],
              [
                59.8126601,
                36.0059928
              ],
              [
                59.807682,
                36.0124498
              ],
              [
                59.8036479,
                36.0198782
              ],
              [
                59.7912025,
                36.0180733
              ],
              [
                59.77777,
                36.0170839
              ],
              [
                59.7774511,
                36.0172037
              ],
              [
                59.769166,
                36.0157371
              ],
              [
                59.7641659,
                36.0154668
              ],
              [
                59.7515755,
                36.0153974
              ],
              [
                59.7496286,
                36.015118
              ],
              [
                59.7142717,
                36.0162239
              ],
              [
                59.7126052,
                36.0159447
              ],
              [
                59.6824443,
                36.0138635
              ],
              [
                59.679111,
                36.0138635
              ],
              [
                59.6779977,
                36.0141429
              ],
              [
                59.6774445,
                36.0138635
              ],
              [
                59.673496,
                36.0147024
              ],
              [
                59.6422179,
                35.9744192
              ],
              [
                59.6422178,
                35.9691464
              ],
              [
                59.6400947,
                35.9677569
              ],
              [
                59.6398145,
                35.9674774
              ],
              [
                59.6400946,
                35.9666482
              ],
              [
                59.6398145,
                35.9660894
              ],
              [
                59.6315747,
                35.9576177
              ],
              [
                59.6310217,
                35.9562206
              ],
              [
                59.5919155,
                35.9166402
              ],
              [
                59.5849818,
                35.9083099
              ],
              [
                59.5637791,
                35.8822105
              ],
              [
                59.563499,
                35.8816516
              ],
              [
                59.5632189,
                35.8811018
              ],
              [
                59.5596122,
                35.8760999
              ],
              [
                59.5573856,
                35.8738828
              ],
              [
                59.5454921,
                35.8366373
              ],
              [
                59.5432721,
                35.8310754
              ],
              [
                59.5273587,
                35.8211541
              ],
              [
                59.5174023,
                35.8208757
              ],
              [
                59.5022961,
                35.8153078
              ],
              [
                59.4892139,
                35.7960239
              ],
              [
                59.4867139,
                35.790749
              ],
              [
                59.4867139,
                35.7885218
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555145,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فیروزه",
          "name:en": "Firuzeh County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2723565",
          "wikipedia": "fa:شهرستان فیروزه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.1745978,
                36.4224397
              ],
              [
                58.1853101,
                36.3896442
              ],
              [
                58.1834219,
                36.3709865
              ],
              [
                58.1863402,
                36.3546747
              ],
              [
                58.1962963,
                36.3101457
              ],
              [
                58.193593,
                36.2966573
              ],
              [
                58.1940218,
                36.2925068
              ],
              [
                58.1966396,
                36.2867646
              ],
              [
                58.205831,
                36.2817594
              ],
              [
                58.2096688,
                36.2779004
              ],
              [
                58.209095,
                36.2682872
              ],
              [
                58.1998586,
                36.2581858
              ],
              [
                58.1935731,
                36.251345
              ],
              [
                58.1955902,
                36.247951
              ],
              [
                58.2142424,
                36.2502368
              ],
              [
                58.2273672,
                36.2480458
              ],
              [
                58.2358215,
                36.2465576
              ],
              [
                58.2336759,
                36.239289
              ],
              [
                58.233075,
                36.2381815
              ],
              [
                58.2404113,
                36.2271806
              ],
              [
                58.2415181,
                36.2237434
              ],
              [
                58.2400273,
                36.2164062
              ],
              [
                58.2368086,
                36.210139
              ],
              [
                58.2321855,
                36.2039274
              ],
              [
                58.2322439,
                36.1945329
              ],
              [
                58.2331608,
                36.1899492
              ],
              [
                58.2357786,
                36.1881827
              ],
              [
                58.2418727,
                36.187386
              ],
              [
                58.2518757,
                36.1869332
              ],
              [
                58.2803677,
                36.1905726
              ],
              [
                58.2810543,
                36.1755742
              ],
              [
                58.2772942,
                36.1705415
              ],
              [
                58.2742428,
                36.1667921
              ],
              [
                58.2680939,
                36.1585632
              ],
              [
                58.2751622,
                36.1537643
              ],
              [
                58.288393,
                36.1486874
              ],
              [
                58.3009243,
                36.1456032
              ],
              [
                58.3128976,
                36.1423109
              ],
              [
                58.3294199,
                36.1412713
              ],
              [
                58.3531092,
                36.1460539
              ],
              [
                58.3691596,
                36.1416871
              ],
              [
                58.3811696,
                36.140111
              ],
              [
                58.3922481,
                36.1369043
              ],
              [
                58.416445,
                36.128254
              ],
              [
                58.4449793,
                36.1231931
              ],
              [
                58.4560066,
                36.1221919
              ],
              [
                58.4613876,
                36.1173331
              ],
              [
                58.4670422,
                36.1124037
              ],
              [
                58.4753711,
                36.1053527
              ],
              [
                58.4829711,
                36.1009548
              ],
              [
                58.4939944,
                36.0953637
              ],
              [
                58.4946441,
                36.0781009
              ],
              [
                58.4946362,
                36.0631226
              ],
              [
                58.4950757,
                36.0618388
              ],
              [
                58.4954701,
                36.0607422
              ],
              [
                58.4978688,
                36.0616034
              ],
              [
                58.4994506,
                36.0627687
              ],
              [
                58.5433527,
                36.0730023
              ],
              [
                58.5664173,
                36.0741496
              ],
              [
                58.5753822,
                36.074088
              ],
              [
                58.5835064,
                36.0741146
              ],
              [
                58.5886563,
                36.0783919
              ],
              [
                58.5946342,
                36.0815501
              ],
              [
                58.5903883,
                36.0834421
              ],
              [
                58.584895,
                36.0867024
              ],
              [
                58.5866545,
                36.0937769
              ],
              [
                58.5863301,
                36.1241721
              ],
              [
                58.5866101,
                36.1284676
              ],
              [
                58.5868903,
                36.1298644
              ],
              [
                58.5871633,
                36.1312523
              ],
              [
                58.5877235,
                36.1340278
              ],
              [
                58.5877235,
                36.1345777
              ],
              [
                58.588277,
                36.135695
              ],
              [
                58.5882769,
                36.1365242
              ],
              [
                58.5891103,
                36.1381913
              ],
              [
                58.5896634,
                36.1390295
              ],
              [
                58.5896634,
                36.139588
              ],
              [
                58.5905436,
                36.1438896
              ],
              [
                58.5917905,
                36.1499888
              ],
              [
                58.5905748,
                36.1531073
              ],
              [
                58.5874271,
                36.1613697
              ],
              [
                58.5886287,
                36.1674675
              ],
              [
                58.5977267,
                36.1762669
              ],
              [
                58.6064906,
                36.1819479
              ],
              [
                58.614949,
                36.1900965
              ],
              [
                58.6220169,
                36.1934818
              ],
              [
                58.6171671,
                36.2002007
              ],
              [
                58.6100003,
                36.2088234
              ],
              [
                58.6146354,
                36.2171332
              ],
              [
                58.6261674,
                36.2286156
              ],
              [
                58.6246774,
                36.2316739
              ],
              [
                58.6248593,
                36.2359223
              ],
              [
                58.6326583,
                36.2384997
              ],
              [
                58.6426939,
                36.2417165
              ],
              [
                58.6543866,
                36.2480103
              ],
              [
                58.657818,
                36.2561671
              ],
              [
                58.6573362,
                36.2609541
              ],
              [
                58.6536259,
                36.2689823
              ],
              [
                58.6496543,
                36.2748637
              ],
              [
                58.6499671,
                36.284171
              ],
              [
                58.6513771,
                36.2938969
              ],
              [
                58.6572921,
                36.2960638
              ],
              [
                58.6741105,
                36.302159
              ],
              [
                58.6686757,
                36.3054632
              ],
              [
                58.6643314,
                36.3086239
              ],
              [
                58.6593912,
                36.3150106
              ],
              [
                58.6524009,
                36.3234931
              ],
              [
                58.6442468,
                36.3281264
              ],
              [
                58.6424299,
                36.340426
              ],
              [
                58.657664,
                36.348682
              ],
              [
                58.6634302,
                36.3556078
              ],
              [
                58.6657047,
                36.3616905
              ],
              [
                58.6696909,
                36.3666944
              ],
              [
                58.6612446,
                36.3728815
              ],
              [
                58.645792,
                36.3828906
              ],
              [
                58.6204796,
                36.3991776
              ],
              [
                58.6104507,
                36.4141599
              ],
              [
                58.6022352,
                36.4265969
              ],
              [
                58.5782397,
                36.4577386
              ],
              [
                58.5720062,
                36.4661765
              ],
              [
                58.5480442,
                36.4555936
              ],
              [
                58.5308383,
                36.4546385
              ],
              [
                58.5195426,
                36.4545092
              ],
              [
                58.5113249,
                36.4523218
              ],
              [
                58.5002228,
                36.4514241
              ],
              [
                58.4972324,
                36.4503542
              ],
              [
                58.4938287,
                36.4507679
              ],
              [
                58.4895623,
                36.4508125
              ],
              [
                58.4468767,
                36.4777753
              ],
              [
                58.4433893,
                36.476745
              ],
              [
                58.4397831,
                36.4781324
              ],
              [
                58.4323832,
                36.4798124
              ],
              [
                58.4261113,
                36.4930762
              ],
              [
                58.3819068,
                36.513636
              ],
              [
                58.3670002,
                36.5212238
              ],
              [
                58.3586024,
                36.5253637
              ],
              [
                58.349714,
                36.5302416
              ],
              [
                58.3036336,
                36.5345293
              ],
              [
                58.3036158,
                36.5345444
              ],
              [
                58.2951397,
                36.5417029
              ],
              [
                58.2822857,
                36.5525553
              ],
              [
                58.2784428,
                36.5592053
              ],
              [
                58.268893,
                36.5551161
              ],
              [
                58.2619571,
                36.5512242
              ],
              [
                58.2547473,
                36.5453632
              ],
              [
                58.2505416,
                36.5402604
              ],
              [
                58.2448768,
                36.5348813
              ],
              [
                58.2411001,
                36.5319849
              ],
              [
                58.2271956,
                36.5181902
              ],
              [
                58.2160374,
                36.511844
              ],
              [
                58.2203289,
                36.5021855
              ],
              [
                58.1902885,
                36.4765154
              ],
              [
                58.1745978,
                36.4224397
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555157,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قوچان",
          "name:ar": "مقاطعة قوتشان",
          "name:en": "Quchan County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1279046",
          "wikipedia": "fa:شهرستان قوچان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.1733704,
                37.0968941
              ],
              [
                58.1819782,
                37.0907336
              ],
              [
                58.1975814,
                37.0848411
              ],
              [
                58.2118877,
                37.0795245
              ],
              [
                58.2282808,
                37.0759122
              ],
              [
                58.2323491,
                37.0680569
              ],
              [
                58.2397744,
                37.0581835
              ],
              [
                58.2495559,
                37.0488613
              ],
              [
                58.2512799,
                37.0474909
              ],
              [
                58.2544429,
                37.0426138
              ],
              [
                58.2585023,
                37.0363777
              ],
              [
                58.2606529,
                37.0331495
              ],
              [
                58.2691814,
                37.0306166
              ],
              [
                58.2765811,
                37.028476
              ],
              [
                58.2859412,
                37.0260814
              ],
              [
                58.3023073,
                37.0218778
              ],
              [
                58.3128693,
                37.0192252
              ],
              [
                58.3230578,
                37.019693
              ],
              [
                58.333928,
                37.0186814
              ],
              [
                58.3448216,
                37.0137642
              ],
              [
                58.351308,
                37.0094025
              ],
              [
                58.3555755,
                37.0051087
              ],
              [
                58.357726,
                36.9999808
              ],
              [
                58.3581942,
                36.9971428
              ],
              [
                58.3559309,
                36.9905253
              ],
              [
                58.3544188,
                36.9856145
              ],
              [
                58.3524176,
                36.9766817
              ],
              [
                58.3443971,
                36.9631784
              ],
              [
                58.3407249,
                36.9576562
              ],
              [
                58.3360185,
                36.9541903
              ],
              [
                58.3274959,
                36.9476302
              ],
              [
                58.3227167,
                36.9445605
              ],
              [
                58.3454704,
                36.9348
              ],
              [
                58.3665847,
                36.9321586
              ],
              [
                58.4025478,
                36.9276989
              ],
              [
                58.4347196,
                36.9237721
              ],
              [
                58.4357827,
                36.923072
              ],
              [
                58.4467069,
                36.9146598
              ],
              [
                58.447946,
                36.9112651
              ],
              [
                58.4526727,
                36.9087596
              ],
              [
                58.46048,
                36.9047176
              ],
              [
                58.4689899,
                36.9032671
              ],
              [
                58.4778141,
                36.9029238
              ],
              [
                58.4837678,
                36.9042379
              ],
              [
                58.4916657,
                36.8866921
              ],
              [
                58.4924982,
                36.8662317
              ],
              [
                58.4932981,
                36.8492181
              ],
              [
                58.5103452,
                36.8488898
              ],
              [
                58.5216678,
                36.8379024
              ],
              [
                58.5348151,
                36.820928
              ],
              [
                58.5361618,
                36.8149812
              ],
              [
                58.5355363,
                36.8099705
              ],
              [
                58.5319767,
                36.807331
              ],
              [
                58.5285909,
                36.8046037
              ],
              [
                58.5202794,
                36.7939995
              ],
              [
                58.517417,
                36.7882028
              ],
              [
                58.515443,
                36.7800624
              ],
              [
                58.5237435,
                36.7718921
              ],
              [
                58.5322377,
                36.7616135
              ],
              [
                58.5372941,
                36.7507915
              ],
              [
                58.5390516,
                36.7462414
              ],
              [
                58.5411978,
                36.7413553
              ],
              [
                58.5456625,
                36.7341566
              ],
              [
                58.5504713,
                36.7313706
              ],
              [
                58.5586066,
                36.727481
              ],
              [
                58.5729382,
                36.7197277
              ],
              [
                58.5796298,
                36.7162712
              ],
              [
                58.5847611,
                36.7135496
              ],
              [
                58.5884874,
                36.7115106
              ],
              [
                58.5838174,
                36.6972534
              ],
              [
                58.5779011,
                36.6786712
              ],
              [
                58.5755988,
                36.670618
              ],
              [
                58.5939499,
                36.6534095
              ],
              [
                58.6099145,
                36.6457658
              ],
              [
                58.6340919,
                36.6339223
              ],
              [
                58.6367454,
                36.6328057
              ],
              [
                58.6424499,
                36.6296347
              ],
              [
                58.6485279,
                36.6282206
              ],
              [
                58.6591383,
                36.6257577
              ],
              [
                58.6652326,
                36.6244832
              ],
              [
                58.6786219,
                36.6285475
              ],
              [
                58.6800381,
                36.6366062
              ],
              [
                58.6814114,
                36.6448017
              ],
              [
                58.6866041,
                36.6561294
              ],
              [
                58.7029979,
                36.6574031
              ],
              [
                58.7187478,
                36.6590901
              ],
              [
                58.7397462,
                36.6613214
              ],
              [
                58.7370192,
                36.665841
              ],
              [
                58.7292663,
                36.6873006
              ],
              [
                58.7256955,
                36.7009736
              ],
              [
                58.7229581,
                36.7157172
              ],
              [
                58.723796,
                36.7232314
              ],
              [
                58.7268435,
                36.7287134
              ],
              [
                58.7332558,
                36.7351797
              ],
              [
                58.7390559,
                36.7344429
              ],
              [
                58.7464758,
                36.7320692
              ],
              [
                58.7510218,
                36.7308848
              ],
              [
                58.7663649,
                36.727924
              ],
              [
                58.773459,
                36.7263681
              ],
              [
                58.7912009,
                36.7186531
              ],
              [
                58.7999374,
                36.7135284
              ],
              [
                58.8067155,
                36.7093122
              ],
              [
                58.8115936,
                36.7125462
              ],
              [
                58.8161323,
                36.7156491
              ],
              [
                58.8213741,
                36.7191826
              ],
              [
                58.8294679,
                36.7246277
              ],
              [
                58.835089,
                36.7284439
              ],
              [
                58.8443127,
                36.7348544
              ],
              [
                58.8584555,
                36.7476363
              ],
              [
                58.8614455,
                36.7502528
              ],
              [
                58.8678571,
                36.7576384
              ],
              [
                58.8730645,
                36.7648354
              ],
              [
                58.8716124,
                36.7677673
              ],
              [
                58.8662051,
                36.7764301
              ],
              [
                58.8632852,
                36.7830975
              ],
              [
                58.8759536,
                36.7919175
              ],
              [
                58.8833936,
                36.7956451
              ],
              [
                58.8911819,
                36.8032029
              ],
              [
                58.8922918,
                36.8063687
              ],
              [
                58.8933824,
                36.8101897
              ],
              [
                58.8936625,
                36.8115763
              ],
              [
                58.8938975,
                36.8139762
              ],
              [
                58.8934192,
                36.8179689
              ],
              [
                58.8884097,
                36.8179084
              ],
              [
                58.8807377,
                36.817749
              ],
              [
                58.8639754,
                36.817503
              ],
              [
                58.857055,
                36.8186067
              ],
              [
                58.8546613,
                36.8189846
              ],
              [
                58.8522827,
                36.8193324
              ],
              [
                58.850714,
                36.8197742
              ],
              [
                58.8465378,
                36.8208093
              ],
              [
                58.84201,
                36.8220758
              ],
              [
                58.8401225,
                36.8301866
              ],
              [
                58.8371085,
                36.8377291
              ],
              [
                58.832846,
                36.8430062
              ],
              [
                58.8259135,
                36.8507506
              ],
              [
                58.8203469,
                36.854979
              ],
              [
                58.8131342,
                36.860019
              ],
              [
                58.8077746,
                36.8624358
              ],
              [
                58.8018936,
                36.8658308
              ],
              [
                58.7873501,
                36.8730451
              ],
              [
                58.7769738,
                36.8755143
              ],
              [
                58.7732177,
                36.8787287
              ],
              [
                58.7723666,
                36.8819279
              ],
              [
                58.7687494,
                36.8871571
              ],
              [
                58.7661477,
                36.8927803
              ],
              [
                58.7621148,
                36.9010731
              ],
              [
                58.7601813,
                36.9052435
              ],
              [
                58.7598093,
                36.9071376
              ],
              [
                58.7552424,
                36.9248836
              ],
              [
                58.7532659,
                36.9375035
              ],
              [
                58.7586033,
                36.9485473
              ],
              [
                58.7623457,
                36.9560804
              ],
              [
                58.7714688,
                36.967174
              ],
              [
                58.7840228,
                36.9707711
              ],
              [
                58.7998534,
                36.9753143
              ],
              [
                58.8098201,
                36.9784715
              ],
              [
                58.8181659,
                36.9808609
              ],
              [
                58.8287628,
                36.9839598
              ],
              [
                58.8467774,
                36.987532
              ],
              [
                58.8549695,
                36.9880756
              ],
              [
                58.8617251,
                36.9870472
              ],
              [
                58.8654358,
                36.986592
              ],
              [
                58.8720134,
                36.9863031
              ],
              [
                58.8780172,
                36.9841825
              ],
              [
                58.8814407,
                36.9828847
              ],
              [
                58.8864134,
                36.9822382
              ],
              [
                58.8920824,
                36.9812783
              ],
              [
                58.8997979,
                36.9801572
              ],
              [
                58.9046656,
                36.9785851
              ],
              [
                58.9103628,
                36.9852011
              ],
              [
                58.9163183,
                36.9977249
              ],
              [
                58.9266298,
                37.0065969
              ],
              [
                58.9409609,
                37.0230445
              ],
              [
                58.9489459,
                37.0407913
              ],
              [
                58.9498441,
                37.052959
              ],
              [
                58.9563082,
                37.0614282
              ],
              [
                58.96174,
                37.0734487
              ],
              [
                58.9653156,
                37.0827602
              ],
              [
                58.9693179,
                37.0962233
              ],
              [
                58.9717769,
                37.1034527
              ],
              [
                58.9759672,
                37.1103517
              ],
              [
                58.9679283,
                37.1190385
              ],
              [
                58.9590739,
                37.1384246
              ],
              [
                58.9584731,
                37.1434193
              ],
              [
                58.951435,
                37.1458823
              ],
              [
                58.9284056,
                37.1579726
              ],
              [
                58.907318,
                37.1711919
              ],
              [
                58.900261,
                37.1780744
              ],
              [
                58.8820836,
                37.1984075
              ],
              [
                58.8587044,
                37.2039521
              ],
              [
                58.8519492,
                37.1992522
              ],
              [
                58.8434299,
                37.1973814
              ],
              [
                58.8277034,
                37.1959772
              ],
              [
                58.8277528,
                37.1995013
              ],
              [
                58.8263797,
                37.203398
              ],
              [
                58.8211291,
                37.2105872
              ],
              [
                58.8166805,
                37.2147457
              ],
              [
                58.8126965,
                37.2148818
              ],
              [
                58.7729069,
                37.2249296
              ],
              [
                58.7667274,
                37.2271164
              ],
              [
                58.7607192,
                37.2306702
              ],
              [
                58.7423061,
                37.2542564
              ],
              [
                58.7395244,
                37.2602102
              ],
              [
                58.7327033,
                37.2683016
              ],
              [
                58.7300199,
                37.2716542
              ],
              [
                58.7322484,
                37.2766114
              ],
              [
                58.7366949,
                37.285632
              ],
              [
                58.7463855,
                37.2929012
              ],
              [
                58.7499045,
                37.2952911
              ],
              [
                58.7523183,
                37.2965252
              ],
              [
                58.7724124,
                37.3179898
              ],
              [
                58.7768817,
                37.3225478
              ],
              [
                58.7785383,
                37.3272368
              ],
              [
                58.775813,
                37.3295973
              ],
              [
                58.7717402,
                37.3321773
              ],
              [
                58.7694227,
                37.3324094
              ],
              [
                58.7674141,
                37.3343372
              ],
              [
                58.7655946,
                37.337009
              ],
              [
                58.757003,
                37.3426798
              ],
              [
                58.7537501,
                37.3450953
              ],
              [
                58.7500336,
                37.3478041
              ],
              [
                58.7453042,
                37.350629
              ],
              [
                58.739588,
                37.3536105
              ],
              [
                58.7313997,
                37.3561895
              ],
              [
                58.7235634,
                37.3612176
              ],
              [
                58.7155811,
                37.3666476
              ],
              [
                58.709161,
                37.3697309
              ],
              [
                58.7018268,
                37.3772477
              ],
              [
                58.6999528,
                37.3783828
              ],
              [
                58.6827421,
                37.3899703
              ],
              [
                58.6518859,
                37.4080055
              ],
              [
                58.642472,
                37.4216326
              ],
              [
                58.6328675,
                37.4322248
              ],
              [
                58.6283294,
                37.4344768
              ],
              [
                58.6236023,
                37.4365708
              ],
              [
                58.6184738,
                37.437835
              ],
              [
                58.6105539,
                37.4388317
              ],
              [
                58.5985032,
                37.4394246
              ],
              [
                58.593422,
                37.4466072
              ],
              [
                58.5893966,
                37.4503822
              ],
              [
                58.5807752,
                37.4580995
              ],
              [
                58.5793161,
                37.4585764
              ],
              [
                58.5733141,
                37.4647907
              ],
              [
                58.5697615,
                37.4674174
              ],
              [
                58.5637249,
                37.4722867
              ],
              [
                58.5637924,
                37.4781758
              ],
              [
                58.562311,
                37.4829232
              ],
              [
                58.5593971,
                37.4907755
              ],
              [
                58.5549631,
                37.498012
              ],
              [
                58.5471728,
                37.5025751
              ],
              [
                58.5379213,
                37.5098132
              ],
              [
                58.5315512,
                37.5083643
              ],
              [
                58.5196587,
                37.5136311
              ],
              [
                58.5099219,
                37.514628
              ],
              [
                58.5002188,
                37.5194685
              ],
              [
                58.4982722,
                37.5202959
              ],
              [
                58.4938505,
                37.5200667
              ],
              [
                58.4826324,
                37.526416
              ],
              [
                58.4768843,
                37.5292091
              ],
              [
                58.4876059,
                37.5399497
              ],
              [
                58.4918789,
                37.5541849
              ],
              [
                58.4929922,
                37.5589155
              ],
              [
                58.4929922,
                37.5605793
              ],
              [
                58.4932723,
                37.5608581
              ],
              [
                58.4935458,
                37.5655798
              ],
              [
                58.4962292,
                37.5775608
              ],
              [
                58.4923424,
                37.5947832
              ],
              [
                58.4926159,
                37.595062
              ],
              [
                58.4924392,
                37.6089088
              ],
              [
                58.4924392,
                37.6133602
              ],
              [
                58.4896591,
                37.624745
              ],
              [
                58.489379,
                37.6250237
              ],
              [
                58.4896591,
                37.6269661
              ],
              [
                58.490669,
                37.6279775
              ],
              [
                58.4896025,
                37.6443967
              ],
              [
                58.486944,
                37.643333
              ],
              [
                58.480556,
                37.641944
              ],
              [
                58.474167,
                37.640556
              ],
              [
                58.467222,
                37.64
              ],
              [
                58.460278,
                37.640556
              ],
              [
                58.451667,
                37.641389
              ],
              [
                58.4406358,
                37.6383426
              ],
              [
                58.4369193,
                37.6403328
              ],
              [
                58.432246,
                37.6414589
              ],
              [
                58.426976,
                37.6411584
              ],
              [
                58.4221653,
                37.6406504
              ],
              [
                58.4179744,
                37.6392897
              ],
              [
                58.4118479,
                37.633934
              ],
              [
                58.4076392,
                37.6297397
              ],
              [
                58.4072962,
                37.6296532
              ],
              [
                58.4062459,
                37.6294737
              ],
              [
                58.4056656,
                37.6293745
              ],
              [
                58.4052221,
                37.6292612
              ],
              [
                58.404247,
                37.6291591
              ],
              [
                58.4032943,
                37.6289658
              ],
              [
                58.4016235,
                37.62849
              ],
              [
                58.400195,
                37.6279969
              ],
              [
                58.3998687,
                37.6279806
              ],
              [
                58.394565,
                37.6288596
              ],
              [
                58.3921227,
                37.6289025
              ],
              [
                58.3918038,
                37.6286715
              ],
              [
                58.3903027,
                37.6272769
              ],
              [
                58.3901323,
                37.6272011
              ],
              [
                58.3887507,
                37.6269846
              ],
              [
                58.3884341,
                37.6269846
              ],
              [
                58.386803,
                37.6273721
              ],
              [
                58.3857285,
                37.6277748
              ],
              [
                58.3845824,
                37.6283563
              ],
              [
                58.3838397,
                37.6289559
              ],
              [
                58.3821193,
                37.6306773
              ],
              [
                58.3815693,
                37.6316008
              ],
              [
                58.3815824,
                37.6322591
              ],
              [
                58.3816386,
                37.6328399
              ],
              [
                58.3811408,
                37.633285
              ],
              [
                58.3806346,
                37.6337115
              ],
              [
                58.3807929,
                37.6350232
              ],
              [
                58.381023,
                37.6355997
              ],
              [
                58.3809882,
                37.6357968
              ],
              [
                58.3808705,
                37.6360024
              ],
              [
                58.3806671,
                37.6364285
              ],
              [
                58.3805586,
                37.6365004
              ],
              [
                58.3804387,
                37.6365163
              ],
              [
                58.3779896,
                37.6363297
              ],
              [
                58.3768681,
                37.6365523
              ],
              [
                58.3759206,
                37.6366116
              ],
              [
                58.3752487,
                37.6365464
              ],
              [
                58.3739587,
                37.6359185
              ],
              [
                58.3722591,
                37.6363467
              ],
              [
                58.3715762,
                37.6364015
              ],
              [
                58.3697024,
                37.6363476
              ],
              [
                58.3683798,
                37.6361797
              ],
              [
                58.3669427,
                37.6367737
              ],
              [
                58.3666521,
                37.6369806
              ],
              [
                58.3663087,
                37.6372465
              ],
              [
                58.36192,
                37.6436415
              ],
              [
                58.36369,
                37.648621
              ],
              [
                58.3583903,
                37.6539636
              ],
              [
                58.3581775,
                37.6595492
              ],
              [
                58.3596512,
                37.6611066
              ],
              [
                58.351667,
                37.661944
              ],
              [
                58.343889,
                37.663333
              ],
              [
                58.336111,
                37.663333
              ],
              [
                58.328333,
                37.663333
              ],
              [
                58.321389,
                37.662778
              ],
              [
                58.314167,
                37.662222
              ],
              [
                58.3112048,
                37.662222
              ],
              [
                58.2989117,
                37.6547113
              ],
              [
                58.299905,
                37.6525298
              ],
              [
                58.2979048,
                37.6373714
              ],
              [
                58.3142488,
                37.5874988
              ],
              [
                58.3207883,
                37.5672602
              ],
              [
                58.326206,
                37.5390237
              ],
              [
                58.3386524,
                37.4999863
              ],
              [
                58.3379169,
                37.4549378
              ],
              [
                58.3494197,
                37.4432959
              ],
              [
                58.3679434,
                37.4292921
              ],
              [
                58.3682234,
                37.4245692
              ],
              [
                58.3676632,
                37.4212407
              ],
              [
                58.3679433,
                37.4170664
              ],
              [
                58.3638601,
                37.4015364
              ],
              [
                58.35886,
                37.39487
              ],
              [
                58.3405666,
                37.3859172
              ],
              [
                58.3366803,
                37.3820307
              ],
              [
                58.3179871,
                37.3677918
              ],
              [
                58.3163206,
                37.3619622
              ],
              [
                58.3160406,
                37.3608556
              ],
              [
                58.3119206,
                37.3574911
              ],
              [
                58.3096638,
                37.3519522
              ],
              [
                58.3092495,
                37.3431405
              ],
              [
                58.3235402,
                37.3325165
              ],
              [
                58.3298302,
                37.327215
              ],
              [
                58.360372,
                37.3104508
              ],
              [
                58.3690499,
                37.2965152
              ],
              [
                58.3698832,
                37.2962452
              ],
              [
                58.3782328,
                37.2899205
              ],
              [
                58.4032325,
                37.2757505
              ],
              [
                58.4065658,
                37.2735281
              ],
              [
                58.4143257,
                37.2588648
              ],
              [
                58.4151594,
                37.2588647
              ],
              [
                58.4154325,
                37.2585858
              ],
              [
                58.4191121,
                37.2485478
              ],
              [
                58.4177258,
                37.2443819
              ],
              [
                58.4148067,
                37.2201301
              ],
              [
                58.4019899,
                37.213891
              ],
              [
                58.3939745,
                37.2138704
              ],
              [
                58.3899517,
                37.2138017
              ],
              [
                58.3764828,
                37.2167736
              ],
              [
                58.3701358,
                37.2181803
              ],
              [
                58.3633038,
                37.2196158
              ],
              [
                58.3519337,
                37.2216718
              ],
              [
                58.3409412,
                37.2224918
              ],
              [
                58.3350054,
                37.2179411
              ],
              [
                58.3313206,
                37.2141134
              ],
              [
                58.3268552,
                37.2130485
              ],
              [
                58.3193769,
                37.2126384
              ],
              [
                58.3114128,
                37.2101242
              ],
              [
                58.3005599,
                37.2020466
              ],
              [
                58.3001659,
                37.198409
              ],
              [
                58.308072,
                37.2005908
              ],
              [
                58.3099419,
                37.1989605
              ],
              [
                58.3079457,
                37.1961985
              ],
              [
                58.3040066,
                37.193598
              ],
              [
                58.3077558,
                37.1832852
              ],
              [
                58.3099874,
                37.1775119
              ],
              [
                58.3139811,
                37.1689323
              ],
              [
                58.2962668,
                37.1792603
              ],
              [
                58.2917436,
                37.1818301
              ],
              [
                58.2845425,
                37.1864574
              ],
              [
                58.2812687,
                37.1877413
              ],
              [
                58.2756895,
                37.1896338
              ],
              [
                58.2733726,
                37.1880488
              ],
              [
                58.2610988,
                37.183946
              ],
              [
                58.2526445,
                37.1833306
              ],
              [
                58.2484388,
                37.1839802
              ],
              [
                58.2409636,
                37.1818043
              ],
              [
                58.2385808,
                37.1790635
              ],
              [
                58.2384353,
                37.1757051
              ],
              [
                58.2395756,
                37.172165
              ],
              [
                58.2479289,
                37.167732
              ],
              [
                58.261399,
                37.1668831
              ],
              [
                58.2665062,
                37.1657202
              ],
              [
                58.2703685,
                37.1622319
              ],
              [
                58.270626,
                37.1592222
              ],
              [
                58.26848,
                37.1551864
              ],
              [
                58.2636737,
                37.1522447
              ],
              [
                58.2597255,
                37.1519026
              ],
              [
                58.2552621,
                37.1518344
              ],
              [
                58.2455631,
                37.1522449
              ],
              [
                58.2341476,
                37.1529974
              ],
              [
                58.2135671,
                37.1547662
              ],
              [
                58.2080379,
                37.1519387
              ],
              [
                58.1984725,
                37.1403551
              ],
              [
                58.1970691,
                37.137672
              ],
              [
                58.1927773,
                37.1280923
              ],
              [
                58.1841477,
                37.1121496
              ],
              [
                58.1733704,
                37.0968941
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555162,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کاشمر",
          "name:ar": "مقاطعة كاشمر",
          "name:en": "Kashmar County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286263",
          "wikipedia": "fa:شهرستان کاشمر"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.3474013,
                35.0823053
              ],
              [
                58.3489036,
                35.0720497
              ],
              [
                58.3532381,
                35.0646735
              ],
              [
                58.359203,
                35.0605287
              ],
              [
                58.3661127,
                35.0589126
              ],
              [
                58.382506,
                35.058421
              ],
              [
                58.3985138,
                35.0452463
              ],
              [
                58.4023003,
                35.0404473
              ],
              [
                58.4081343,
                35.033681
              ],
              [
                58.4118218,
                35.0278388
              ],
              [
                58.4172323,
                35.0213046
              ],
              [
                58.4230264,
                35.0235796
              ],
              [
                58.4313597,
                35.0235796
              ],
              [
                58.4333063,
                35.0232997
              ],
              [
                58.4383064,
                35.0232997
              ],
              [
                58.4402462,
                35.0230199
              ],
              [
                58.4585949,
                35.0263419
              ],
              [
                58.477821,
                35.0316834
              ],
              [
                58.4941084,
                35.0443847
              ],
              [
                58.496989,
                35.0747204
              ],
              [
                58.5067358,
                35.0965898
              ],
              [
                58.5186764,
                35.1140114
              ],
              [
                58.5247522,
                35.1105673
              ],
              [
                58.5313187,
                35.1077333
              ],
              [
                58.531879,
                35.1080129
              ],
              [
                58.5393541,
                35.1030977
              ],
              [
                58.5429674,
                35.1025474
              ],
              [
                58.5435206,
                35.1022677
              ],
              [
                58.5449073,
                35.1022677
              ],
              [
                58.5451874,
                35.101988
              ],
              [
                58.547687,
                35.1019881
              ],
              [
                58.5499069,
                35.1017085
              ],
              [
                58.5568787,
                35.1066238
              ],
              [
                58.5574318,
                35.1063441
              ],
              [
                58.5585451,
                35.1063442
              ],
              [
                58.5593788,
                35.1066238
              ],
              [
                58.5665984,
                35.1066238
              ],
              [
                58.5677117,
                35.1069034
              ],
              [
                58.5679919,
                35.1066238
              ],
              [
                58.5690985,
                35.1069033
              ],
              [
                58.5810452,
                35.1069033
              ],
              [
                58.5821585,
                35.1066237
              ],
              [
                58.5835448,
                35.1069033
              ],
              [
                58.5889984,
                35.1097246
              ],
              [
                58.5901051,
                35.1094451
              ],
              [
                58.5931654,
                35.109445
              ],
              [
                58.5942716,
                35.1091654
              ],
              [
                58.6111983,
                35.120399
              ],
              [
                58.6123046,
                35.1201194
              ],
              [
                58.6145316,
                35.1201194
              ],
              [
                58.6181379,
                35.1195692
              ],
              [
                58.6186981,
                35.1192898
              ],
              [
                58.6206379,
                35.1192897
              ],
              [
                58.6211981,
                35.1190101
              ],
              [
                58.634551,
                35.1119892
              ],
              [
                58.6353842,
                35.1117098
              ],
              [
                58.6376041,
                35.1117097
              ],
              [
                58.6398307,
                35.1117097
              ],
              [
                58.6412175,
                35.11143
              ],
              [
                58.6420507,
                35.1117096
              ],
              [
                58.6426042,
                35.1114301
              ],
              [
                58.6445507,
                35.1114301
              ],
              [
                58.6451038,
                35.1117097
              ],
              [
                58.646494,
                35.1117097
              ],
              [
                58.6478839,
                35.1117096
              ],
              [
                58.6489973,
                35.1119892
              ],
              [
                58.6509372,
                35.1119891
              ],
              [
                58.6562174,
                35.1128189
              ],
              [
                58.6567705,
                35.1130985
              ],
              [
                58.6578838,
                35.1130985
              ],
              [
                58.6796563,
                35.1146619
              ],
              [
                58.6823773,
                35.1146957
              ],
              [
                58.7032318,
                35.1174302
              ],
              [
                58.7132334,
                35.1209992
              ],
              [
                58.724023,
                35.1280182
              ],
              [
                58.7294072,
                35.1360519
              ],
              [
                58.7320518,
                35.1382301
              ],
              [
                58.736,
                35.1526177
              ],
              [
                58.7388674,
                35.1571456
              ],
              [
                58.7399217,
                35.1589968
              ],
              [
                58.7438964,
                35.1613893
              ],
              [
                58.7469863,
                35.1637752
              ],
              [
                58.7602041,
                35.1739488
              ],
              [
                58.7647729,
                35.1940419
              ],
              [
                58.7686658,
                35.2043175
              ],
              [
                58.7785075,
                35.2141666
              ],
              [
                58.7787876,
                35.2149967
              ],
              [
                58.7798943,
                35.2161062
              ],
              [
                58.7801651,
                35.2163767
              ],
              [
                58.7850884,
                35.2219624
              ],
              [
                58.7819725,
                35.2301338
              ],
              [
                58.7774441,
                35.2375346
              ],
              [
                58.7796589,
                35.2595085
              ],
              [
                58.7751628,
                35.2750509
              ],
              [
                58.775351,
                35.285033
              ],
              [
                58.7729877,
                35.2952749
              ],
              [
                58.7774343,
                35.3038889
              ],
              [
                58.7938498,
                35.3142849
              ],
              [
                58.7950514,
                35.3257702
              ],
              [
                58.7892149,
                35.3337529
              ],
              [
                58.7883328,
                35.3405506
              ],
              [
                58.788613,
                35.3422191
              ],
              [
                58.7899004,
                35.3453464
              ],
              [
                58.7795767,
                35.3681503
              ],
              [
                58.7786064,
                35.3696357
              ],
              [
                58.7557769,
                35.3685797
              ],
              [
                58.7477236,
                35.3674705
              ],
              [
                58.7471639,
                35.367182
              ],
              [
                58.7466103,
                35.3674706
              ],
              [
                58.7463302,
                35.367182
              ],
              [
                58.741103,
                35.367182
              ],
              [
                58.7349441,
                35.367182
              ],
              [
                58.7318908,
                35.3671821
              ],
              [
                58.7224442,
                35.3671821
              ],
              [
                58.721884,
                35.3674706
              ],
              [
                58.7216109,
                35.3671821
              ],
              [
                58.7135506,
                35.367182
              ],
              [
                58.7104974,
                35.3669115
              ],
              [
                58.7093841,
                35.3666319
              ],
              [
                58.7079973,
                35.366632
              ],
              [
                58.7068841,
                35.3663524
              ],
              [
                58.7046641,
                35.3663524
              ],
              [
                58.6879977,
                35.364134
              ],
              [
                58.6860512,
                35.3635749
              ],
              [
                58.6843845,
                35.3635749
              ],
              [
                58.6835512,
                35.3632953
              ],
              [
                58.680498,
                35.3632953
              ],
              [
                58.6735513,
                35.3624657
              ],
              [
                58.6729978,
                35.3621862
              ],
              [
                58.6693848,
                35.3621861
              ],
              [
                58.6682711,
                35.3619066
              ],
              [
                58.6646649,
                35.3619066
              ],
              [
                58.6616046,
                35.3616361
              ],
              [
                58.6579982,
                35.3613565
              ],
              [
                58.6382717,
                35.3605269
              ],
              [
                58.6054921,
                35.3588586
              ],
              [
                58.605212,
                35.358579
              ],
              [
                58.6010455,
                35.358579
              ],
              [
                58.600492,
                35.3588586
              ],
              [
                58.5963255,
                35.3588587
              ],
              [
                58.5932723,
                35.3591292
              ],
              [
                58.5924391,
                35.3594087
              ],
              [
                58.5879921,
                35.3594087
              ],
              [
                58.587439,
                35.3596883
              ],
              [
                58.5857725,
                35.3596883
              ],
              [
                58.5849389,
                35.3599679
              ],
              [
                58.5846589,
                35.3599679
              ],
              [
                58.5779923,
                35.3599678
              ],
              [
                58.5774391,
                35.3602475
              ],
              [
                58.5757723,
                35.3602474
              ],
              [
                58.5752126,
                35.3599679
              ],
              [
                58.5735457,
                35.3599679
              ],
              [
                58.5729926,
                35.3596883
              ],
              [
                58.5715991,
                35.3596884
              ],
              [
                58.5713257,
                35.3594088
              ],
              [
                58.5707655,
                35.3596883
              ],
              [
                58.5704926,
                35.3594088
              ],
              [
                58.5646592,
                35.3594088
              ],
              [
                58.5477127,
                35.3577495
              ],
              [
                58.5468795,
                35.3574609
              ],
              [
                58.5327129,
                35.3571904
              ],
              [
                58.5318796,
                35.3574609
              ],
              [
                58.5302131,
                35.3571904
              ],
              [
                58.5299331,
                35.357461
              ],
              [
                58.5282662,
                35.3571904
              ],
              [
                58.5243798,
                35.357461
              ],
              [
                58.5232665,
                35.3577496
              ],
              [
                58.5002133,
                35.3555221
              ],
              [
                58.4899333,
                35.3491283
              ],
              [
                58.4871536,
                35.3471894
              ],
              [
                58.4766003,
                35.3399659
              ],
              [
                58.4681222,
                35.3462926
              ],
              [
                58.4573996,
                35.3518355
              ],
              [
                58.4457917,
                35.3577274
              ],
              [
                58.4371885,
                35.3632472
              ],
              [
                58.4327602,
                35.3660958
              ],
              [
                58.4174823,
                35.3684055
              ],
              [
                58.4137916,
                35.3680556
              ],
              [
                58.4086417,
                35.3659558
              ],
              [
                58.4046077,
                35.363366
              ],
              [
                58.3979987,
                35.3465656
              ],
              [
                58.3955096,
                35.3458655
              ],
              [
                58.3696882,
                35.3398288
              ],
              [
                58.3624649,
                35.3362035
              ],
              [
                58.3571431,
                35.3344532
              ],
              [
                58.3619324,
                35.3259037
              ],
              [
                58.3547398,
                35.3221638
              ],
              [
                58.3475265,
                35.3144415
              ],
              [
                58.3450311,
                35.3096958
              ],
              [
                58.3426373,
                35.3020035
              ],
              [
                58.3419513,
                35.2971939
              ],
              [
                58.3423804,
                35.2866854
              ],
              [
                58.3469295,
                35.2722515
              ],
              [
                58.3501126,
                35.2601288
              ],
              [
                58.3494914,
                35.252886
              ],
              [
                58.3456695,
                35.2489478
              ],
              [
                58.3481299,
                35.2418387
              ],
              [
                58.352251,
                35.2379957
              ],
              [
                58.3533668,
                35.2353142
              ],
              [
                58.3566495,
                35.2322298
              ],
              [
                58.3590531,
                35.2295654
              ],
              [
                58.360705,
                35.2274623
              ],
              [
                58.3605766,
                35.2262
              ],
              [
                58.3554697,
                35.2212919
              ],
              [
                58.3504005,
                35.2175437
              ],
              [
                58.3522939,
                35.2111943
              ],
              [
                58.3541943,
                35.206313
              ],
              [
                58.3591175,
                35.199798
              ],
              [
                58.3655973,
                35.1917673
              ],
              [
                58.3753395,
                35.1860852
              ],
              [
                58.3866644,
                35.1889189
              ],
              [
                58.3804893,
                35.173668
              ],
              [
                58.3751678,
                35.1665817
              ],
              [
                58.3697487,
                35.1543027
              ],
              [
                58.3671855,
                35.1372475
              ],
              [
                58.3633229,
                35.1314919
              ],
              [
                58.3605765,
                35.1181535
              ],
              [
                58.3554267,
                35.0998275
              ],
              [
                58.3519074,
                35.0919975
              ],
              [
                58.3480021,
                35.086063
              ],
              [
                58.3474013,
                35.0823053
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555169,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کلات",
          "name:en": "Kalat County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286305",
          "wikipedia": "fa:شهرستان کلات"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.303133,
                36.9879784
              ],
              [
                59.3247127,
                36.9822264
              ],
              [
                59.346685,
                36.9753356
              ],
              [
                59.3481442,
                36.9699185
              ],
              [
                59.3508049,
                36.9631979
              ],
              [
                59.3788716,
                36.9465996
              ],
              [
                59.3825626,
                36.9443356
              ],
              [
                59.3896863,
                36.9417634
              ],
              [
                59.3939348,
                36.9395338
              ],
              [
                59.3965862,
                36.9380264
              ],
              [
                59.4009033,
                36.9380041
              ],
              [
                59.4041061,
                36.9387447
              ],
              [
                59.4090414,
                36.9437011
              ],
              [
                59.4103503,
                36.9460505
              ],
              [
                59.4152641,
                36.9475596
              ],
              [
                59.4274735,
                36.9475596
              ],
              [
                59.43228,
                36.9499261
              ],
              [
                59.4358849,
                36.9533214
              ],
              [
                59.4456053,
                36.9575052
              ],
              [
                59.4538879,
                36.9596828
              ],
              [
                59.4641876,
                36.9597685
              ],
              [
                59.4747877,
                36.9605229
              ],
              [
                59.4886279,
                36.9622375
              ],
              [
                59.4949794,
                36.9640206
              ],
              [
                59.5002579,
                36.9653064
              ],
              [
                59.5030474,
                36.965255
              ],
              [
                59.5044851,
                36.9654779
              ],
              [
                59.5082402,
                36.9599914
              ],
              [
                59.5140981,
                36.9563907
              ],
              [
                59.5169306,
                36.9547274
              ],
              [
                59.5186901,
                36.9532185
              ],
              [
                59.5294618,
                36.9505777
              ],
              [
                59.5388603,
                36.9446443
              ],
              [
                59.5437955,
                36.9413859
              ],
              [
                59.5453857,
                36.939948
              ],
              [
                59.5583868,
                36.9315068
              ],
              [
                59.5657682,
                36.9268755
              ],
              [
                59.5707464,
                36.9202541
              ],
              [
                59.5788145,
                36.9112644
              ],
              [
                59.5873791,
                36.9068421
              ],
              [
                59.5989883,
                36.9051573
              ],
              [
                59.6210843,
                36.9006918
              ],
              [
                59.6257167,
                36.8973101
              ],
              [
                59.6276197,
                36.8933811
              ],
              [
                59.630354,
                36.8877657
              ],
              [
                59.6389345,
                36.8787677
              ],
              [
                59.6504453,
                36.8626966
              ],
              [
                59.6520167,
                36.8592837
              ],
              [
                59.6655442,
                36.8402537
              ],
              [
                59.6732577,
                36.8311456
              ],
              [
                59.6821442,
                36.8264161
              ],
              [
                59.6904775,
                36.8197405
              ],
              [
                59.7055504,
                36.8026547
              ],
              [
                59.7202703,
                36.7973747
              ],
              [
                59.7241637,
                36.7957078
              ],
              [
                59.7283302,
                36.7932027
              ],
              [
                59.73998,
                36.7926136
              ],
              [
                59.7871023,
                36.7830041
              ],
              [
                59.7926555,
                36.7755087
              ],
              [
                59.8049622,
                36.7665088
              ],
              [
                59.8182334,
                36.7483078
              ],
              [
                59.8188723,
                36.7473094
              ],
              [
                59.8371822,
                36.7192122
              ],
              [
                59.8463486,
                36.7117109
              ],
              [
                59.8571584,
                36.7064657
              ],
              [
                59.8991677,
                36.6874983
              ],
              [
                59.9013944,
                36.6858324
              ],
              [
                59.9019479,
                36.6849949
              ],
              [
                59.9044476,
                36.683329
              ],
              [
                59.9058342,
                36.6833291
              ],
              [
                59.9273806,
                36.66463
              ],
              [
                59.9304338,
                36.6640715
              ],
              [
                59.9429337,
                36.650807
              ],
              [
                59.9757132,
                36.63079
              ],
              [
                59.9768265,
                36.6299522
              ],
              [
                59.9815131,
                36.6228116
              ],
              [
                59.9777926,
                36.6084671
              ],
              [
                59.9902539,
                36.5959396
              ],
              [
                60.0020003,
                36.5831491
              ],
              [
                60.0039469,
                36.5734299
              ],
              [
                60.0061201,
                36.5667763
              ],
              [
                60.0061195,
                36.5391548
              ],
              [
                60.0063926,
                36.5388847
              ],
              [
                60.0088927,
                36.5324899
              ],
              [
                60.0090159,
                36.5259991
              ],
              [
                60.0097593,
                36.5250115
              ],
              [
                60.0189971,
                36.5198456
              ],
              [
                60.0283514,
                36.5041504
              ],
              [
                60.0336189,
                36.499993
              ],
              [
                60.0347321,
                36.4994345
              ],
              [
                60.0350056,
                36.4988852
              ],
              [
                60.0494748,
                36.4875231
              ],
              [
                60.0500346,
                36.486974
              ],
              [
                60.0708679,
                36.4739194
              ],
              [
                60.0953006,
                36.4666454
              ],
              [
                60.1082608,
                36.4519418
              ],
              [
                60.1219939,
                36.4495943
              ],
              [
                60.1495909,
                36.4346764
              ],
              [
                60.1509773,
                36.4343972
              ],
              [
                60.1526441,
                36.4332803
              ],
              [
                60.1709137,
                36.4241288
              ],
              [
                60.1789669,
                36.4213456
              ],
              [
                60.1973534,
                36.4144787
              ],
              [
                60.1998534,
                36.4133707
              ],
              [
                60.2075168,
                36.4113761
              ],
              [
                60.2123705,
                36.412283
              ],
              [
                60.2174863,
                36.4145304
              ],
              [
                60.2244899,
                36.4194431
              ],
              [
                60.2394102,
                36.4268076
              ],
              [
                60.2634428,
                36.4277745
              ],
              [
                60.2849881,
                36.4434581
              ],
              [
                60.2880412,
                36.4440164
              ],
              [
                60.2891545,
                36.4440163
              ],
              [
                60.289428,
                36.4442955
              ],
              [
                60.2905413,
                36.4442955
              ],
              [
                60.3100492,
                36.4497045
              ],
              [
                60.3217158,
                36.4505329
              ],
              [
                60.3239358,
                36.4508121
              ],
              [
                60.3261558,
                36.4508122
              ],
              [
                60.3275493,
                36.4510912
              ],
              [
                60.3300488,
                36.4510912
              ],
              [
                60.3322688,
                36.4513703
              ],
              [
                60.3425487,
                36.4513703
              ],
              [
                60.3433824,
                36.4510911
              ],
              [
                60.3492153,
                36.4510912
              ],
              [
                60.3519954,
                36.4516494
              ],
              [
                60.3542154,
                36.4516494
              ],
              [
                60.3556021,
                36.4519287
              ],
              [
                60.3572686,
                36.4519287
              ],
              [
                60.3817268,
                36.4551406
              ],
              [
                60.38256,
                36.4551405
              ],
              [
                60.3893311,
                36.4533925
              ],
              [
                60.3904444,
                36.4533925
              ],
              [
                60.3907179,
                36.4536719
              ],
              [
                60.3923843,
                36.4536719
              ],
              [
                60.3976645,
                36.4553384
              ],
              [
                60.3996109,
                36.4553384
              ],
              [
                60.4012778,
                36.455897
              ],
              [
                60.4040509,
                36.4581132
              ],
              [
                60.4243371,
                36.4616748
              ],
              [
                60.4293372,
                36.4630714
              ],
              [
                60.4403241,
                36.465784
              ],
              [
                60.4503895,
                36.4665389
              ],
              [
                60.4546607,
                36.4681618
              ],
              [
                60.4573418,
                36.4707301
              ],
              [
                60.4548025,
                36.4736166
              ],
              [
                60.4491806,
                36.4760667
              ],
              [
                60.4422505,
                36.4816007
              ],
              [
                60.4187534,
                36.4955617
              ],
              [
                60.4172945,
                36.5005294
              ],
              [
                60.4107283,
                36.5151551
              ],
              [
                60.4074239,
                36.5223288
              ],
              [
                60.4044669,
                36.5311063
              ],
              [
                60.4024551,
                36.5478398
              ],
              [
                60.4015507,
                36.5685098
              ],
              [
                60.4023843,
                36.5701759
              ],
              [
                60.4100416,
                36.5901712
              ],
              [
                60.406402,
                36.5942492
              ],
              [
                60.403902,
                36.5961939
              ],
              [
                60.3800009,
                36.5956842
              ],
              [
                60.3716571,
                36.6043275
              ],
              [
                60.3702773,
                36.6129303
              ],
              [
                60.3691639,
                36.6134886
              ],
              [
                60.3688906,
                36.614047
              ],
              [
                60.3677772,
                36.6146054
              ],
              [
                60.3615684,
                36.6280949
              ],
              [
                60.3606236,
                36.6294918
              ],
              [
                60.3587263,
                36.6295535
              ],
              [
                60.3455423,
                36.6293939
              ],
              [
                60.3444209,
                36.6327734
              ],
              [
                60.3446242,
                36.6388088
              ],
              [
                60.3453503,
                36.6427331
              ],
              [
                60.3428842,
                36.6427507
              ],
              [
                60.340633,
                36.6430314
              ],
              [
                60.3363809,
                36.6446178
              ],
              [
                60.3318929,
                36.6500677
              ],
              [
                60.3254705,
                36.6589278
              ],
              [
                60.319665,
                36.6649908
              ],
              [
                60.3110201,
                36.6740091
              ],
              [
                60.307137,
                36.6798615
              ],
              [
                60.3029674,
                36.6864232
              ],
              [
                60.2970904,
                36.6969812
              ],
              [
                60.2930759,
                36.7056112
              ],
              [
                60.2892675,
                36.7134494
              ],
              [
                60.2834851,
                36.7231681
              ],
              [
                60.2771118,
                36.7327557
              ],
              [
                60.2683127,
                36.7425716
              ],
              [
                60.266905,
                36.7572095
              ],
              [
                60.2591345,
                36.7634717
              ],
              [
                60.2512524,
                36.7700098
              ],
              [
                60.2443207,
                36.7775324
              ],
              [
                60.2441431,
                36.7793412
              ],
              [
                60.2451033,
                36.7813382
              ],
              [
                60.2438735,
                36.78295
              ],
              [
                60.2408015,
                36.7847158
              ],
              [
                60.2386659,
                36.7859434
              ],
              [
                60.2314636,
                36.7917114
              ],
              [
                60.2211102,
                36.8043995
              ],
              [
                60.2171489,
                36.8126168
              ],
              [
                60.2149881,
                36.8203287
              ],
              [
                60.2135339,
                36.8217136
              ],
              [
                60.2095864,
                36.8229232
              ],
              [
                60.2042829,
                36.823054
              ],
              [
                60.1970182,
                36.8292718
              ],
              [
                60.1915655,
                36.8307899
              ],
              [
                60.1868484,
                36.8334484
              ],
              [
                60.1695941,
                36.8478373
              ],
              [
                60.1631638,
                36.8562322
              ],
              [
                60.1575597,
                36.8668635
              ],
              [
                60.1549135,
                36.8696993
              ],
              [
                60.1522346,
                36.8731511
              ],
              [
                60.1461891,
                36.8783853
              ],
              [
                60.1449563,
                36.8805282
              ],
              [
                60.1441137,
                36.8836215
              ],
              [
                60.1424111,
                36.8846519
              ],
              [
                60.1387775,
                36.8881394
              ],
              [
                60.1354793,
                36.8914479
              ],
              [
                60.135088,
                36.8930126
              ],
              [
                60.1354234,
                36.8955162
              ],
              [
                60.133411,
                36.8986903
              ],
              [
                60.130334,
                36.9008448
              ],
              [
                60.126631,
                36.9032363
              ],
              [
                60.1246395,
                36.9054923
              ],
              [
                60.1242365,
                36.9066676
              ],
              [
                60.1210597,
                36.9092267
              ],
              [
                60.110818,
                36.9169416
              ],
              [
                60.1071392,
                36.9211266
              ],
              [
                60.1042036,
                36.9244661
              ],
              [
                60.0945536,
                36.9366463
              ],
              [
                60.0931558,
                36.9395508
              ],
              [
                60.0921523,
                36.9427599
              ],
              [
                60.0917618,
                36.9449789
              ],
              [
                60.0912829,
                36.9470541
              ],
              [
                60.0916322,
                36.9505119
              ],
              [
                60.0921511,
                36.9530642
              ],
              [
                60.0928121,
                36.9561536
              ],
              [
                60.0929169,
                36.9585711
              ],
              [
                60.0925446,
                36.9623465
              ],
              [
                60.0919155,
                36.9651713
              ],
              [
                60.0911409,
                36.9677383
              ],
              [
                60.0890045,
                36.9717244
              ],
              [
                60.0864484,
                36.9756467
              ],
              [
                60.0849842,
                36.977755
              ],
              [
                60.0836651,
                36.9790754
              ],
              [
                60.08123,
                36.9818354
              ],
              [
                60.0709697,
                36.9909399
              ],
              [
                60.063879,
                36.9984967
              ],
              [
                60.0540668,
                37.0082608
              ],
              [
                60.0430687,
                37.0207635
              ],
              [
                60.035179,
                37.0241786
              ],
              [
                60.0299988,
                37.0267034
              ],
              [
                60.0168244,
                37.0356871
              ],
              [
                60.0148876,
                37.0365014
              ],
              [
                60.0125008,
                37.0371128
              ],
              [
                60.0095619,
                37.0374256
              ],
              [
                60.0078139,
                37.0382235
              ],
              [
                60.0059104,
                37.039928
              ],
              [
                60.0052514,
                37.0405962
              ],
              [
                60.0042005,
                37.0410369
              ],
              [
                60.001528,
                37.0419049
              ],
              [
                59.9814679,
                37.0471137
              ],
              [
                59.9684021,
                37.0433461
              ],
              [
                59.9604636,
                37.0430744
              ],
              [
                59.9497378,
                37.0426232
              ],
              [
                59.9310662,
                37.0423006
              ],
              [
                59.9182476,
                37.0454017
              ],
              [
                59.9114948,
                37.050266
              ],
              [
                59.9083995,
                37.0513353
              ],
              [
                59.9064308,
                37.0514011
              ],
              [
                59.9038474,
                37.051185
              ],
              [
                59.9022899,
                37.0513349
              ],
              [
                59.9007439,
                37.0511238
              ],
              [
                59.8995292,
                37.0514459
              ],
              [
                59.8982356,
                37.052847
              ],
              [
                59.8954175,
                37.0550961
              ],
              [
                59.8944011,
                37.0577507
              ],
              [
                59.8935838,
                37.0588629
              ],
              [
                59.8916291,
                37.0597415
              ],
              [
                59.8908899,
                37.0607001
              ],
              [
                59.8873326,
                37.0622853
              ],
              [
                59.883267,
                37.0650503
              ],
              [
                59.8794787,
                37.0674833
              ],
              [
                59.8767991,
                37.0680362
              ],
              [
                59.8739809,
                37.0676676
              ],
              [
                59.8724484,
                37.0678997
              ],
              [
                59.8613623,
                37.0766884
              ],
              [
                59.8592115,
                37.0780306
              ],
              [
                59.8571281,
                37.0799895
              ],
              [
                59.8548216,
                37.0814734
              ],
              [
                59.8535567,
                37.08272
              ],
              [
                59.8499109,
                37.0858658
              ],
              [
                59.8487948,
                37.0876465
              ],
              [
                59.8481766,
                37.0886765
              ],
              [
                59.8465071,
                37.0905814
              ],
              [
                59.8438344,
                37.0921042
              ],
              [
                59.8411236,
                37.0946929
              ],
              [
                59.8394486,
                37.096127
              ],
              [
                59.8354096,
                37.0991739
              ],
              [
                59.832418,
                37.1004384
              ],
              [
                59.8314637,
                37.1001746
              ],
              [
                59.8306237,
                37.0997178
              ],
              [
                59.8296071,
                37.0979039
              ],
              [
                59.8286601,
                37.0974723
              ],
              [
                59.8272397,
                37.0980144
              ],
              [
                59.8252654,
                37.0996124
              ],
              [
                59.8226401,
                37.1027054
              ],
              [
                59.8186493,
                37.1048632
              ],
              [
                59.8149291,
                37.1052409
              ],
              [
                59.8121123,
                37.1041901
              ],
              [
                59.8041354,
                37.1125597
              ],
              [
                59.8030289,
                37.1114189
              ],
              [
                59.8010138,
                37.1099253
              ],
              [
                59.7996514,
                37.1092288
              ],
              [
                59.7990698,
                37.1114189
              ],
              [
                59.7975157,
                37.1127131
              ],
              [
                59.7949132,
                37.1139153
              ],
              [
                59.7915142,
                37.1148278
              ],
              [
                59.7859847,
                37.1181225
              ],
              [
                59.7820609,
                37.1203614
              ],
              [
                59.7718478,
                37.1253495
              ],
              [
                59.7660984,
                37.1254574
              ],
              [
                59.7622957,
                37.1266865
              ],
              [
                59.7616704,
                37.1255177
              ],
              [
                59.7596412,
                37.1238458
              ],
              [
                59.7589648,
                37.1221739
              ],
              [
                59.7592776,
                37.1202818
              ],
              [
                59.7573414,
                37.1188839
              ],
              [
                59.7565974,
                37.1169961
              ],
              [
                59.7556504,
                37.1125192
              ],
              [
                59.7552859,
                37.108806
              ],
              [
                59.7497657,
                37.1087433
              ],
              [
                59.7474053,
                37.1077803
              ],
              [
                59.745572,
                37.1099301
              ],
              [
                59.7424605,
                37.110901
              ],
              [
                59.7365758,
                37.1121932
              ],
              [
                59.7345466,
                37.1129507
              ],
              [
                59.7323821,
                37.1147307
              ],
              [
                59.7296088,
                37.1182906
              ],
              [
                59.7262268,
                37.1229829
              ],
              [
                59.7266573,
                37.1265105
              ],
              [
                59.7222879,
                37.1274213
              ],
              [
                59.7147825,
                37.1303258
              ],
              [
                59.7103431,
                37.130764
              ],
              [
                59.685696,
                37.1385808
              ],
              [
                59.6825014,
                37.1401736
              ],
              [
                59.6789985,
                37.1412196
              ],
              [
                59.6674261,
                37.1411209
              ],
              [
                59.6640453,
                37.1426137
              ],
              [
                59.6613444,
                37.1430442
              ],
              [
                59.6572788,
                37.1424635
              ],
              [
                59.6534908,
                37.1422099
              ],
              [
                59.6527993,
                37.1397881
              ],
              [
                59.651246,
                37.1370743
              ],
              [
                59.6502583,
                37.1345214
              ],
              [
                59.6497021,
                37.1326989
              ],
              [
                59.6475649,
                37.1309156
              ],
              [
                59.646701,
                37.1292139
              ],
              [
                59.6451256,
                37.125162
              ],
              [
                59.6452309,
                37.1223821
              ],
              [
                59.6464056,
                37.1206207
              ],
              [
                59.6433988,
                37.1192367
              ],
              [
                59.6416912,
                37.1200653
              ],
              [
                59.6401597,
                37.1195151
              ],
              [
                59.6373565,
                37.1204462
              ],
              [
                59.6265288,
                37.1186537
              ],
              [
                59.6262749,
                37.1193262
              ],
              [
                59.6256995,
                37.1202866
              ],
              [
                59.6247895,
                37.1216738
              ],
              [
                59.6237724,
                37.1227622
              ],
              [
                59.623197,
                37.1229115
              ],
              [
                59.6224074,
                37.1226768
              ],
              [
                59.6211495,
                37.1216951
              ],
              [
                59.6204034,
                37.120519
              ],
              [
                59.6191538,
                37.1201592
              ],
              [
                59.6174112,
                37.1200725
              ],
              [
                59.6157175,
                37.1238402
              ],
              [
                59.6140167,
                37.1256944
              ],
              [
                59.6125359,
                37.1263847
              ],
              [
                59.6114365,
                37.12657
              ],
              [
                59.6108878,
                37.1269967
              ],
              [
                59.6097102,
                37.1281064
              ],
              [
                59.6088135,
                37.128021
              ],
              [
                59.6080374,
                37.1281704
              ],
              [
                59.6074485,
                37.1286292
              ],
              [
                59.6067278,
                37.1296851
              ],
              [
                59.6056285,
                37.1297708
              ],
              [
                59.6045476,
                37.1302568
              ],
              [
                59.6037416,
                37.1299735
              ],
              [
                59.6030559,
                37.1302568
              ],
              [
                59.6025066,
                37.1307191
              ],
              [
                59.6016022,
                37.1315623
              ],
              [
                59.6002659,
                37.1322496
              ],
              [
                59.5992237,
                37.13251
              ],
              [
                59.5975026,
                37.1314363
              ],
              [
                59.5961769,
                37.1310461
              ],
              [
                59.5951532,
                37.131027
              ],
              [
                59.5930364,
                37.1321618
              ],
              [
                59.5908222,
                37.1328698
              ],
              [
                59.5889122,
                37.133733
              ],
              [
                59.5883282,
                37.1336554
              ],
              [
                59.5876226,
                37.1331317
              ],
              [
                59.5867102,
                37.1331899
              ],
              [
                59.5854915,
                37.1337149
              ],
              [
                59.5848778,
                37.1342395
              ],
              [
                59.584145,
                37.1342223
              ],
              [
                59.5834793,
                37.1337363
              ],
              [
                59.5829711,
                37.1319941
              ],
              [
                59.5817139,
                37.1310498
              ],
              [
                59.5790089,
                37.1307151
              ],
              [
                59.5759986,
                37.1314745
              ],
              [
                59.5716174,
                37.1327635
              ],
              [
                59.5677057,
                37.1332209
              ],
              [
                59.5647067,
                37.1326803
              ],
              [
                59.5622552,
                37.131085
              ],
              [
                59.5602812,
                37.1311677
              ],
              [
                59.5581639,
                37.1317212
              ],
              [
                59.5570879,
                37.1325237
              ],
              [
                59.556116,
                37.1336582
              ],
              [
                59.5539292,
                37.1354016
              ],
              [
                59.5525408,
                37.136204
              ],
              [
                59.5508763,
                37.1381507
              ],
              [
                59.550779,
                37.1394598
              ],
              [
                59.5511383,
                37.1420407
              ],
              [
                59.5511457,
                37.142952
              ],
              [
                59.5506238,
                37.1431655
              ],
              [
                59.5494907,
                37.1432258
              ],
              [
                59.5485086,
                37.1436637
              ],
              [
                59.5470734,
                37.1448077
              ],
              [
                59.5461978,
                37.1473301
              ],
              [
                59.5463417,
                37.1536065
              ],
              [
                59.544272,
                37.1560376
              ],
              [
                59.5439359,
                37.158359
              ],
              [
                59.5455792,
                37.1609862
              ],
              [
                59.5465596,
                37.1628093
              ],
              [
                59.5481936,
                37.1647192
              ],
              [
                59.5476268,
                37.168267
              ],
              [
                59.5483406,
                37.1701781
              ],
              [
                59.5511393,
                37.1709475
              ],
              [
                59.552507,
                37.1720816
              ],
              [
                59.5528684,
                37.1746943
              ],
              [
                59.5528575,
                37.1755483
              ],
              [
                59.5525266,
                37.175807
              ],
              [
                59.5522582,
                37.1766327
              ],
              [
                59.5522569,
                37.1768473
              ],
              [
                59.5517307,
                37.1775677
              ],
              [
                59.5505156,
                37.1774792
              ],
              [
                59.5455565,
                37.1769477
              ],
              [
                59.5420137,
                37.1780435
              ],
              [
                59.5402549,
                37.1795328
              ],
              [
                59.538527,
                37.1820432
              ],
              [
                59.5377502,
                37.1852982
              ],
              [
                59.5359146,
                37.1856389
              ],
              [
                59.5335544,
                37.1856583
              ],
              [
                59.5319729,
                37.1865984
              ],
              [
                59.5307076,
                37.1871606
              ],
              [
                59.5292721,
                37.186046
              ],
              [
                59.5284326,
                37.1849895
              ],
              [
                59.527873,
                37.1851543
              ],
              [
                59.5267217,
                37.1862333
              ],
              [
                59.5238974,
                37.1883142
              ],
              [
                59.5223049,
                37.1903973
              ],
              [
                59.5114811,
                37.1945722
              ],
              [
                59.5002582,
                37.2000076
              ],
              [
                59.4911444,
                37.2071704
              ],
              [
                59.4891344,
                37.2077294
              ],
              [
                59.487103,
                37.2082922
              ],
              [
                59.4850768,
                37.209067
              ],
              [
                59.4822158,
                37.2106253
              ],
              [
                59.4747378,
                37.2147753
              ],
              [
                59.4744067,
                37.2186057
              ],
              [
                59.4745722,
                37.2188295
              ],
              [
                59.4751844,
                37.2190684
              ],
              [
                59.4780181,
                37.2186558
              ],
              [
                59.4804499,
                37.219074
              ],
              [
                59.4828723,
                37.2192086
              ],
              [
                59.4841954,
                37.2194418
              ],
              [
                59.4860559,
                37.2204773
              ],
              [
                59.4858946,
                37.2217568
              ],
              [
                59.4871855,
                37.2221908
              ],
              [
                59.4883964,
                37.2248586
              ],
              [
                59.4901572,
                37.2264937
              ],
              [
                59.491833,
                37.2300429
              ],
              [
                59.4921102,
                37.2321028
              ],
              [
                59.4919372,
                37.2336303
              ],
              [
                59.4887952,
                37.2403767
              ],
              [
                59.4834259,
                37.248484
              ],
              [
                59.4778425,
                37.2502896
              ],
              [
                59.473786,
                37.2522682
              ],
              [
                59.4723566,
                37.2525556
              ],
              [
                59.4678103,
                37.2578981
              ],
              [
                59.4657491,
                37.2607636
              ],
              [
                59.465128,
                37.2639747
              ],
              [
                59.4644703,
                37.2660859
              ],
              [
                59.4510826,
                37.2696096
              ],
              [
                59.4500736,
                37.2713549
              ],
              [
                59.4505022,
                37.2733042
              ],
              [
                59.4519806,
                37.276961
              ],
              [
                59.452283,
                37.2788556
              ],
              [
                59.4491242,
                37.2793576
              ],
              [
                59.446008,
                37.2802711
              ],
              [
                59.4408339,
                37.2824361
              ],
              [
                59.4383034,
                37.2844917
              ],
              [
                59.437648,
                37.284709
              ],
              [
                59.436972,
                37.2851741
              ],
              [
                59.435967,
                37.2869617
              ],
              [
                59.4357706,
                37.287311
              ],
              [
                59.435208,
                37.2879969
              ],
              [
                59.434366,
                37.2890146
              ],
              [
                59.4336227,
                37.2902334
              ],
              [
                59.4328046,
                37.2918685
              ],
              [
                59.432551,
                37.2925987
              ],
              [
                59.4337272,
                37.2936926
              ],
              [
                59.4346122,
                37.2949061
              ],
              [
                59.4350897,
                37.295938
              ],
              [
                59.4351204,
                37.2968466
              ],
              [
                59.4351937,
                37.3040829
              ],
              [
                59.4334955,
                37.3054859
              ],
              [
                59.4308059,
                37.307101
              ],
              [
                59.4285527,
                37.3077838
              ],
              [
                59.4269585,
                37.3082769
              ],
              [
                59.4259456,
                37.3078008
              ],
              [
                59.4231493,
                37.3059756
              ],
              [
                59.4172066,
                37.3080363
              ],
              [
                59.4153861,
                37.3074003
              ],
              [
                59.4144324,
                37.3068794
              ],
              [
                59.4136303,
                37.3066142
              ],
              [
                59.4117681,
                37.30749
              ],
              [
                59.4096793,
                37.3073225
              ],
              [
                59.4083029,
                37.3077733
              ],
              [
                59.4050366,
                37.310057
              ],
              [
                59.3998972,
                37.3151972
              ],
              [
                59.4005699,
                37.306019
              ],
              [
                59.4024113,
                37.3003813
              ],
              [
                59.4037391,
                37.2851746
              ],
              [
                59.3958439,
                37.2629992
              ],
              [
                59.3890303,
                37.2451117
              ],
              [
                59.3990478,
                37.2306142
              ],
              [
                59.4122742,
                37.2124405
              ],
              [
                59.4244339,
                37.1957773
              ],
              [
                59.4318901,
                37.1855572
              ],
              [
                59.4245563,
                37.1700909
              ],
              [
                59.4079637,
                37.1344697
              ],
              [
                59.3954546,
                37.1167978
              ],
              [
                59.3332607,
                37.1131448
              ],
              [
                59.3323783,
                37.1030988
              ],
              [
                59.3303698,
                37.0706643
              ],
              [
                59.3280489,
                37.0613313
              ],
              [
                59.3251524,
                37.0481492
              ],
              [
                59.3131467,
                37.0377135
              ],
              [
                59.3100391,
                37.0279077
              ],
              [
                59.3088987,
                37.0223566
              ],
              [
                59.3059903,
                37.0134378
              ],
              [
                59.3058137,
                37.0104167
              ],
              [
                59.303133,
                36.9879784
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555208,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مشهد",
          "name:ar": "مقاطعة مشهد",
          "name:en": "Mashhad County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1270617",
          "wikipedia": "fa:شهرستان مشهد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.0861273,
                35.8442952
              ],
              [
                59.0879059,
                35.8359067
              ],
              [
                59.0892185,
                35.8325689
              ],
              [
                59.114792,
                35.8313144
              ],
              [
                59.1397044,
                35.8295399
              ],
              [
                59.1446825,
                35.8112013
              ],
              [
                59.1590166,
                35.8133936
              ],
              [
                59.1722771,
                35.8101224
              ],
              [
                59.1844222,
                35.8172566
              ],
              [
                59.2132184,
                35.8075818
              ],
              [
                59.2168235,
                35.7964784
              ],
              [
                59.2208783,
                35.7870051
              ],
              [
                59.2265653,
                35.7849211
              ],
              [
                59.2299985,
                35.7811611
              ],
              [
                59.2310831,
                35.7776108
              ],
              [
                59.2307802,
                35.766993
              ],
              [
                59.2314552,
                35.7640755
              ],
              [
                59.2314731,
                35.7601112
              ],
              [
                59.2327176,
                35.7555124
              ],
              [
                59.2364524,
                35.7494033
              ],
              [
                59.2606221,
                35.7466733
              ],
              [
                59.2617354,
                35.7466733
              ],
              [
                59.2622888,
                35.7463938
              ],
              [
                59.2631221,
                35.7463938
              ],
              [
                59.2634021,
                35.7461145
              ],
              [
                59.2656222,
                35.7461144
              ],
              [
                59.2664553,
                35.7458349
              ],
              [
                59.2675687,
                35.745835
              ],
              [
                59.2684019,
                35.7455555
              ],
              [
                59.275902,
                35.7455555
              ],
              [
                59.276175,
                35.745276
              ],
              [
                59.278122,
                35.745276
              ],
              [
                59.2789552,
                35.7455555
              ],
              [
                59.2809018,
                35.7455555
              ],
              [
                59.2817354,
                35.745835
              ],
              [
                59.3165248,
                35.7349475
              ],
              [
                59.3519207,
                35.7228243
              ],
              [
                59.3727068,
                35.7262953
              ],
              [
                59.37576,
                35.7265658
              ],
              [
                59.3924264,
                35.724627
              ],
              [
                59.4096529,
                35.7160155
              ],
              [
                59.4115928,
                35.7146269
              ],
              [
                59.4291999,
                35.7121348
              ],
              [
                59.4295734,
                35.7119486
              ],
              [
                59.4301265,
                35.7116781
              ],
              [
                59.4312397,
                35.711678
              ],
              [
                59.4849732,
                35.7060435
              ],
              [
                59.4852462,
                35.706314
              ],
              [
                59.4860794,
                35.7063139
              ],
              [
                59.4863595,
                35.7066025
              ],
              [
                59.4888596,
                35.7077115
              ],
              [
                59.4896928,
                35.7091
              ],
              [
                59.4899729,
                35.7093796
              ],
              [
                59.4963594,
                35.7166015
              ],
              [
                59.4966395,
                35.7168811
              ],
              [
                59.4974731,
                35.71744
              ],
              [
                59.4977462,
                35.71799
              ],
              [
                59.4923397,
                35.7509707
              ],
              [
                59.4865033,
                35.7777146
              ],
              [
                59.4867138,
                35.7882422
              ],
              [
                59.4867139,
                35.7885218
              ],
              [
                59.4867139,
                35.790749
              ],
              [
                59.4892139,
                35.7960239
              ],
              [
                59.5022961,
                35.8153078
              ],
              [
                59.5174023,
                35.8208757
              ],
              [
                59.5273587,
                35.8211541
              ],
              [
                59.5432721,
                35.8310754
              ],
              [
                59.5454921,
                35.8366373
              ],
              [
                59.5573856,
                35.8738828
              ],
              [
                59.5596122,
                35.8760999
              ],
              [
                59.5632189,
                35.8811018
              ],
              [
                59.563499,
                35.8816516
              ],
              [
                59.5637791,
                35.8822105
              ],
              [
                59.5849818,
                35.9083099
              ],
              [
                59.5919155,
                35.9166402
              ],
              [
                59.6310217,
                35.9562206
              ],
              [
                59.6315747,
                35.9576177
              ],
              [
                59.6398145,
                35.9660894
              ],
              [
                59.6400946,
                35.9666482
              ],
              [
                59.6398145,
                35.9674774
              ],
              [
                59.6400947,
                35.9677569
              ],
              [
                59.6422178,
                35.9691464
              ],
              [
                59.6422179,
                35.9744192
              ],
              [
                59.673496,
                36.0147024
              ],
              [
                59.6774445,
                36.0138635
              ],
              [
                59.6779977,
                36.0141429
              ],
              [
                59.679111,
                36.0138635
              ],
              [
                59.6824443,
                36.0138635
              ],
              [
                59.7126052,
                36.0159447
              ],
              [
                59.7142717,
                36.0162239
              ],
              [
                59.7496286,
                36.015118
              ],
              [
                59.7515755,
                36.0153974
              ],
              [
                59.7641659,
                36.0154668
              ],
              [
                59.769166,
                36.0157371
              ],
              [
                59.7774511,
                36.0172037
              ],
              [
                59.77777,
                36.0170839
              ],
              [
                59.7912025,
                36.0180733
              ],
              [
                59.8036479,
                36.0198782
              ],
              [
                59.807682,
                36.0124498
              ],
              [
                59.8126601,
                36.0059928
              ],
              [
                59.8441296,
                35.9927565
              ],
              [
                59.8547824,
                35.993865
              ],
              [
                59.8591658,
                35.9985905
              ],
              [
                59.8727414,
                35.9980078
              ],
              [
                59.8806378,
                35.9871744
              ],
              [
                59.8799722,
                35.978312
              ],
              [
                59.8694456,
                35.9763657
              ],
              [
                59.8699992,
                35.973031
              ],
              [
                59.8637561,
                35.9713706
              ],
              [
                59.8631959,
                35.9683157
              ],
              [
                59.8629224,
                35.9680364
              ],
              [
                59.8594892,
                35.9630411
              ],
              [
                59.856626,
                35.9552588
              ],
              [
                59.8563525,
                35.9544299
              ],
              [
                59.8563526,
                35.9541505
              ],
              [
                59.8524591,
                35.9447067
              ],
              [
                59.852186,
                35.9444363
              ],
              [
                59.8552057,
                35.9316593
              ],
              [
                59.8554857,
                35.9242464
              ],
              [
                59.8554857,
                35.9236028
              ],
              [
                59.8557658,
                35.923044
              ],
              [
                59.8593725,
                35.9174836
              ],
              [
                59.8646522,
                35.9111032
              ],
              [
                59.9095448,
                35.8755458
              ],
              [
                59.9103781,
                35.8747167
              ],
              [
                59.9352944,
                35.8533298
              ],
              [
                59.973594,
                35.8199641
              ],
              [
                59.9747073,
                35.8196847
              ],
              [
                60.0037001,
                35.7926877
              ],
              [
                60.0106466,
                35.7910194
              ],
              [
                60.0233366,
                35.8083109
              ],
              [
                60.0269499,
                35.8060845
              ],
              [
                60.0352833,
                35.8021994
              ],
              [
                60.0369497,
                35.8016405
              ],
              [
                60.0478481,
                35.8111291
              ],
              [
                60.0509084,
                35.8105793
              ],
              [
                60.0838144,
                35.8083729
              ],
              [
                60.0854812,
                35.8075349
              ],
              [
                60.0949692,
                35.8139428
              ],
              [
                60.0952493,
                35.8136725
              ],
              [
                60.0960825,
                35.8136725
              ],
              [
                60.1021959,
                35.8120055
              ],
              [
                60.1038623,
                35.8120056
              ],
              [
                60.1044159,
                35.8117263
              ],
              [
                60.1066358,
                35.8117263
              ],
              [
                60.106916,
                35.8114469
              ],
              [
                60.1085824,
                35.8114469
              ],
              [
                60.1091356,
                35.8111676
              ],
              [
                60.1271957,
                35.8125551
              ],
              [
                60.1432419,
                35.8110969
              ],
              [
                60.1516752,
                35.8102487
              ],
              [
                60.1533417,
                35.8110871
              ],
              [
                60.1561218,
                35.8119164
              ],
              [
                60.1778695,
                35.8194123
              ],
              [
                60.186348,
                35.8274616
              ],
              [
                60.1880145,
                35.8280204
              ],
              [
                60.1864082,
                35.8493142
              ],
              [
                60.1891879,
                35.8493142
              ],
              [
                60.2008241,
                35.8352632
              ],
              [
                60.2143477,
                35.8342369
              ],
              [
                60.2274877,
                35.842192
              ],
              [
                60.2324874,
                35.8435801
              ],
              [
                60.2397141,
                35.8438595
              ],
              [
                60.2381911,
                35.8522103
              ],
              [
                60.2392973,
                35.8522103
              ],
              [
                60.2501373,
                35.8483258
              ],
              [
                60.2558474,
                35.829142
              ],
              [
                60.2780902,
                35.8134661
              ],
              [
                60.279757,
                35.8126279
              ],
              [
                60.2938601,
                35.7948404
              ],
              [
                60.2949734,
                35.7934523
              ],
              [
                60.3002466,
                35.7889992
              ],
              [
                60.3055267,
                35.7862228
              ],
              [
                60.3187598,
                35.7813655
              ],
              [
                60.3212598,
                35.7799864
              ],
              [
                60.3302078,
                35.7741524
              ],
              [
                60.4337984,
                35.7411107
              ],
              [
                60.4390782,
                35.7411107
              ],
              [
                60.4401849,
                35.7413901
              ],
              [
                60.4443515,
                35.7416606
              ],
              [
                60.4490785,
                35.7424989
              ],
              [
                60.4510183,
                35.7424988
              ],
              [
                60.4576849,
                35.7438869
              ],
              [
                60.4815461,
                35.748607
              ],
              [
                60.4829324,
                35.748607
              ],
              [
                60.483486,
                35.7488864
              ],
              [
                60.4865458,
                35.7488863
              ],
              [
                60.4879326,
                35.7491658
              ],
              [
                60.491546,
                35.7491657
              ],
              [
                60.4957124,
                35.7497246
              ],
              [
                60.4995993,
                35.7497247
              ],
              [
                60.5012657,
                35.750004
              ],
              [
                60.5134689,
                35.744986
              ],
              [
                60.5154158,
                35.7449861
              ],
              [
                60.5184891,
                35.7363542
              ],
              [
                60.5201555,
                35.7363542
              ],
              [
                60.5328412,
                35.7243728
              ],
              [
                60.5426394,
                35.7208191
              ],
              [
                60.5431926,
                35.7205394
              ],
              [
                60.5530227,
                35.7203821
              ],
              [
                60.5670219,
                35.7212173
              ],
              [
                60.5781613,
                35.7356305
              ],
              [
                60.584942,
                35.7396492
              ],
              [
                60.5846209,
                35.7465364
              ],
              [
                60.5846209,
                35.7493132
              ],
              [
                60.5906294,
                35.7678258
              ],
              [
                60.5836769,
                35.7754166
              ],
              [
                60.5886553,
                35.7837722
              ],
              [
                60.587962,
                35.7967826
              ],
              [
                60.587962,
                35.7981708
              ],
              [
                60.5882354,
                35.7992794
              ],
              [
                60.5879621,
                35.8028942
              ],
              [
                60.585462,
                35.8087263
              ],
              [
                60.5837956,
                35.8151082
              ],
              [
                60.5721044,
                35.8335962
              ],
              [
                60.5715441,
                35.8344254
              ],
              [
                60.5742801,
                35.8405443
              ],
              [
                60.5722614,
                35.8507963
              ],
              [
                60.5545791,
                35.8534431
              ],
              [
                60.5512458,
                35.8578958
              ],
              [
                60.541831,
                35.877191
              ],
              [
                60.5412708,
                35.8777499
              ],
              [
                60.5398845,
                35.8852581
              ],
              [
                60.5415509,
                35.8921983
              ],
              [
                60.5443311,
                35.9016443
              ],
              [
                60.5482176,
                35.9141455
              ],
              [
                60.5484977,
                35.914416
              ],
              [
                60.5487711,
                35.9152541
              ],
              [
                60.5521044,
                35.9224736
              ],
              [
                60.547318,
                35.921634
              ],
              [
                60.5473181,
                35.9233016
              ],
              [
                60.5425641,
                35.930761
              ],
              [
                60.5587003,
                35.9402124
              ],
              [
                60.5599977,
                35.9533152
              ],
              [
                60.571483,
                35.9619253
              ],
              [
                60.5803945,
                35.9637587
              ],
              [
                60.5775969,
                35.9728913
              ],
              [
                60.5773167,
                35.9731796
              ],
              [
                60.5684021,
                35.9756765
              ],
              [
                60.5373611,
                35.9719201
              ],
              [
                60.5365274,
                35.97192
              ],
              [
                60.5359744,
                35.9721994
              ],
              [
                60.5303042,
                35.9727551
              ],
              [
                60.5286377,
                35.9730256
              ],
              [
                60.5183113,
                35.9899792
              ],
              [
                60.5158112,
                35.9958104
              ],
              [
                60.5163643,
                36.0041473
              ],
              [
                60.5163643,
                36.0096992
              ],
              [
                60.5162179,
                36.0144231
              ],
              [
                60.5082319,
                36.0200865
              ],
              [
                60.5004342,
                36.0313706
              ],
              [
                60.4993209,
                36.035255
              ],
              [
                60.497621,
                36.0443569
              ],
              [
                60.4970674,
                36.045186
              ],
              [
                60.4832387,
                36.0474849
              ],
              [
                60.4768406,
                36.0544189
              ],
              [
                60.4757269,
                36.0546983
              ],
              [
                60.4740605,
                36.0546983
              ],
              [
                60.4729472,
                36.0549777
              ],
              [
                60.4707523,
                36.070797
              ],
              [
                60.4543209,
                36.0916106
              ],
              [
                60.4532071,
                36.0913224
              ],
              [
                60.4509872,
                36.0913225
              ],
              [
                60.4465406,
                36.0904938
              ],
              [
                60.4311594,
                36.0889943
              ],
              [
                60.4208597,
                36.0874826
              ],
              [
                60.4078933,
                36.0869622
              ],
              [
                60.3952438,
                36.0853204
              ],
              [
                60.3709047,
                36.0788154
              ],
              [
                60.3659045,
                36.089384
              ],
              [
                60.3628514,
                36.0949388
              ],
              [
                60.318874,
                36.113585
              ],
              [
                60.3180408,
                36.1141352
              ],
              [
                60.3155408,
                36.11859
              ],
              [
                60.3089331,
                36.1459152
              ],
              [
                60.3190611,
                36.1500737
              ],
              [
                60.3297041,
                36.1629636
              ],
              [
                60.3280255,
                36.1670107
              ],
              [
                60.324972,
                36.1731223
              ],
              [
                60.3206222,
                36.1784024
              ],
              [
                60.3130557,
                36.1849464
              ],
              [
                60.3084181,
                36.1937244
              ],
              [
                60.3210789,
                36.1986818
              ],
              [
                60.3205757,
                36.2014791
              ],
              [
                60.3205756,
                36.2048144
              ],
              [
                60.3211288,
                36.2081495
              ],
              [
                60.3557965,
                36.2193493
              ],
              [
                60.3827637,
                36.2350338
              ],
              [
                60.3933167,
                36.2444869
              ],
              [
                60.3952636,
                36.2464336
              ],
              [
                60.4080436,
                36.2542104
              ],
              [
                60.4102635,
                36.2558776
              ],
              [
                60.4102636,
                36.2567065
              ],
              [
                60.4102636,
                36.2575447
              ],
              [
                60.3887871,
                36.2794467
              ],
              [
                60.3763308,
                36.2905279
              ],
              [
                60.3616114,
                36.3013565
              ],
              [
                60.3477182,
                36.3088519
              ],
              [
                60.3192916,
                36.3369127
              ],
              [
                60.3131781,
                36.3410836
              ],
              [
                60.312225,
                36.3417933
              ],
              [
                60.2988121,
                36.3483002
              ],
              [
                60.2979789,
                36.3488586
              ],
              [
                60.294092,
                36.3521918
              ],
              [
                60.2840056,
                36.3563535
              ],
              [
                60.2702957,
                36.3685955
              ],
              [
                60.2547427,
                36.3805408
              ],
              [
                60.2477962,
                36.3877655
              ],
              [
                60.2464093,
                36.3886033
              ],
              [
                60.2458495,
                36.3894321
              ],
              [
                60.2114032,
                36.4091601
              ],
              [
                60.2097368,
                36.4097096
              ],
              [
                60.2080699,
                36.4108267
              ],
              [
                60.2075168,
                36.4113761
              ],
              [
                60.1998534,
                36.4133707
              ],
              [
                60.1973534,
                36.4144787
              ],
              [
                60.1789669,
                36.4213456
              ],
              [
                60.1709137,
                36.4241288
              ],
              [
                60.1526441,
                36.4332803
              ],
              [
                60.1509773,
                36.4343972
              ],
              [
                60.1495909,
                36.4346764
              ],
              [
                60.1219939,
                36.4495943
              ],
              [
                60.1082608,
                36.4519418
              ],
              [
                60.0953006,
                36.4666454
              ],
              [
                60.0708679,
                36.4739194
              ],
              [
                60.0500346,
                36.486974
              ],
              [
                60.0494748,
                36.4875231
              ],
              [
                60.0350056,
                36.4988852
              ],
              [
                60.0347321,
                36.4994345
              ],
              [
                60.0336189,
                36.499993
              ],
              [
                60.0283514,
                36.5041504
              ],
              [
                60.0189971,
                36.5198456
              ],
              [
                60.0097593,
                36.5250115
              ],
              [
                60.0090159,
                36.5259991
              ],
              [
                60.0088927,
                36.5324899
              ],
              [
                60.0063926,
                36.5388847
              ],
              [
                60.0061195,
                36.5391548
              ],
              [
                60.0061201,
                36.5667763
              ],
              [
                60.0039469,
                36.5734299
              ],
              [
                60.0020003,
                36.5831491
              ],
              [
                59.9902539,
                36.5959396
              ],
              [
                59.9777926,
                36.6084671
              ],
              [
                59.9815131,
                36.6228116
              ],
              [
                59.9768265,
                36.6299522
              ],
              [
                59.9757132,
                36.63079
              ],
              [
                59.9429337,
                36.650807
              ],
              [
                59.9304338,
                36.6640715
              ],
              [
                59.9273806,
                36.66463
              ],
              [
                59.9058342,
                36.6833291
              ],
              [
                59.9044476,
                36.683329
              ],
              [
                59.9019479,
                36.6849949
              ],
              [
                59.9013944,
                36.6858324
              ],
              [
                59.8991677,
                36.6874983
              ],
              [
                59.8571584,
                36.7064657
              ],
              [
                59.8463486,
                36.7117109
              ],
              [
                59.8371822,
                36.7192122
              ],
              [
                59.8188723,
                36.7473094
              ],
              [
                59.8182334,
                36.7483078
              ],
              [
                59.8049622,
                36.7665088
              ],
              [
                59.7926555,
                36.7755087
              ],
              [
                59.7871023,
                36.7830041
              ],
              [
                59.73998,
                36.7926136
              ],
              [
                59.7283302,
                36.7932027
              ],
              [
                59.7241637,
                36.7957078
              ],
              [
                59.7202703,
                36.7973747
              ],
              [
                59.7055504,
                36.8026547
              ],
              [
                59.6904775,
                36.8197405
              ],
              [
                59.6821442,
                36.8264161
              ],
              [
                59.6732577,
                36.8311456
              ],
              [
                59.6655442,
                36.8402537
              ],
              [
                59.6520167,
                36.8592837
              ],
              [
                59.6504453,
                36.8626966
              ],
              [
                59.6389345,
                36.8787677
              ],
              [
                59.630354,
                36.8877657
              ],
              [
                59.6276197,
                36.8933811
              ],
              [
                59.6257167,
                36.8973101
              ],
              [
                59.6210843,
                36.9006918
              ],
              [
                59.5989883,
                36.9051573
              ],
              [
                59.5873791,
                36.9068421
              ],
              [
                59.5788145,
                36.9112644
              ],
              [
                59.5707464,
                36.9202541
              ],
              [
                59.5657682,
                36.9268755
              ],
              [
                59.5583868,
                36.9315068
              ],
              [
                59.5453857,
                36.939948
              ],
              [
                59.5437955,
                36.9413859
              ],
              [
                59.5388603,
                36.9446443
              ],
              [
                59.5294618,
                36.9505777
              ],
              [
                59.5186901,
                36.9532185
              ],
              [
                59.5169306,
                36.9547274
              ],
              [
                59.5140981,
                36.9563907
              ],
              [
                59.5082402,
                36.9599914
              ],
              [
                59.5044851,
                36.9654779
              ],
              [
                59.5030474,
                36.965255
              ],
              [
                59.5002579,
                36.9653064
              ],
              [
                59.4949794,
                36.9640206
              ],
              [
                59.4886279,
                36.9622375
              ],
              [
                59.4747877,
                36.9605229
              ],
              [
                59.4641876,
                36.9597685
              ],
              [
                59.4538879,
                36.9596828
              ],
              [
                59.4456053,
                36.9575052
              ],
              [
                59.4358849,
                36.9533214
              ],
              [
                59.43228,
                36.9499261
              ],
              [
                59.4274735,
                36.9475596
              ],
              [
                59.4152641,
                36.9475596
              ],
              [
                59.4103503,
                36.9460505
              ],
              [
                59.4090414,
                36.9437011
              ],
              [
                59.4041061,
                36.9387447
              ],
              [
                59.4009033,
                36.9380041
              ],
              [
                59.3965862,
                36.9380264
              ],
              [
                59.3939348,
                36.9395338
              ],
              [
                59.3896863,
                36.9417634
              ],
              [
                59.3825626,
                36.9443356
              ],
              [
                59.3788716,
                36.9465996
              ],
              [
                59.3508049,
                36.9631979
              ],
              [
                59.3481442,
                36.9699185
              ],
              [
                59.346685,
                36.9753356
              ],
              [
                59.3247127,
                36.9822264
              ],
              [
                59.303133,
                36.9879784
              ],
              [
                59.2916284,
                36.9870021
              ],
              [
                59.2864903,
                36.9828588
              ],
              [
                59.2767033,
                36.9752822
              ],
              [
                59.2707072,
                36.9702409
              ],
              [
                59.2696075,
                36.9627734
              ],
              [
                59.2677785,
                36.9580812
              ],
              [
                59.2625712,
                36.9507836
              ],
              [
                59.2605113,
                36.9468051
              ],
              [
                59.2599962,
                36.9406313
              ],
              [
                59.260342,
                36.9353205
              ],
              [
                59.2610287,
                36.9269916
              ],
              [
                59.2666207,
                36.9220927
              ],
              [
                59.2763899,
                36.9159997
              ],
              [
                59.2908953,
                36.9057741
              ],
              [
                59.30274,
                36.9006951
              ],
              [
                59.3119471,
                36.8970036
              ],
              [
                59.3219643,
                36.894455
              ],
              [
                59.3257856,
                36.8904675
              ],
              [
                59.3304486,
                36.8844771
              ],
              [
                59.3330843,
                36.8780236
              ],
              [
                59.3328783,
                36.8768775
              ],
              [
                59.3314933,
                36.8731667
              ],
              [
                59.32774,
                36.8688302
              ],
              [
                59.326195,
                36.8637786
              ],
              [
                59.3268795,
                36.857319
              ],
              [
                59.3290987,
                36.8498488
              ],
              [
                59.333038,
                36.8426408
              ],
              [
                59.3273258,
                36.8383652
              ],
              [
                59.3224175,
                36.8328513
              ],
              [
                59.3183754,
                36.8276454
              ],
              [
                59.3122672,
                36.8222716
              ],
              [
                59.301188,
                36.8139844
              ],
              [
                59.3234826,
                36.8087903
              ],
              [
                59.3332659,
                36.8041235
              ],
              [
                59.3405913,
                36.7962271
              ],
              [
                59.3668554,
                36.7768426
              ],
              [
                59.3902014,
                36.7607539
              ],
              [
                59.3911915,
                36.7568076
              ],
              [
                59.393892,
                36.7496824
              ],
              [
                59.3988701,
                36.7463125
              ],
              [
                59.3983551,
                36.7441117
              ],
              [
                59.3956946,
                36.7391593
              ],
              [
                59.3900298,
                36.7327623
              ],
              [
                59.3894287,
                36.7255395
              ],
              [
                59.3898582,
                36.7214115
              ],
              [
                59.385395,
                36.7156323
              ],
              [
                59.3815179,
                36.7095721
              ],
              [
                59.380331,
                36.7055176
              ],
              [
                59.3817042,
                36.699049
              ],
              [
                59.3829917,
                36.6955392
              ],
              [
                59.3851375,
                36.6926487
              ],
              [
                59.3861674,
                36.6878997
              ],
              [
                59.3853091,
                36.6841829
              ],
              [
                59.384365,
                36.6813608
              ],
              [
                59.3821334,
                36.677506
              ],
              [
                59.3815326,
                36.6701401
              ],
              [
                59.3832325,
                36.6646364
              ],
              [
                59.3827342,
                36.6589866
              ],
              [
                59.3698596,
                36.6270319
              ],
              [
                59.3703746,
                36.6201434
              ],
              [
                59.3703317,
                36.6152866
              ],
              [
                59.3700076,
                36.6109135
              ],
              [
                59.3695928,
                36.605719
              ],
              [
                59.3653221,
                36.6041741
              ],
              [
                59.3647686,
                36.6041742
              ],
              [
                59.3508909,
                36.5989918
              ],
              [
                59.3386874,
                36.5938556
              ],
              [
                59.3371766,
                36.591092
              ],
              [
                59.3370075,
                36.58833
              ],
              [
                59.3456554,
                36.5845888
              ],
              [
                59.360504,
                36.580867
              ],
              [
                59.367113,
                36.5768693
              ],
              [
                59.3679713,
                36.5725958
              ],
              [
                59.3516387,
                36.5707344
              ],
              [
                59.3312619,
                36.5780909
              ],
              [
                59.3208072,
                36.5822678
              ],
              [
                59.3056601,
                36.5821492
              ],
              [
                59.2841976,
                36.5687453
              ],
              [
                59.2743301,
                36.5713549
              ],
              [
                59.2710256,
                36.5703209
              ],
              [
                59.2664547,
                36.5674743
              ],
              [
                59.2598097,
                36.564164
              ],
              [
                59.2588226,
                36.5632987
              ],
              [
                59.25651,
                36.5617063
              ],
              [
                59.2565506,
                36.5601159
              ],
              [
                59.2572927,
                36.5592564
              ],
              [
                59.2650175,
                36.5565331
              ],
              [
                59.2689537,
                36.5545026
              ],
              [
                59.2672193,
                36.5480448
              ],
              [
                59.2674768,
                36.5445207
              ],
              [
                59.2737292,
                36.5390881
              ],
              [
                59.2852306,
                36.5339848
              ],
              [
                59.3024825,
                36.5275018
              ],
              [
                59.3101731,
                36.5238668
              ],
              [
                59.3132471,
                36.5226768
              ],
              [
                59.3081473,
                36.5142582
              ],
              [
                59.3044005,
                36.5082682
              ],
              [
                59.3073693,
                36.504025
              ],
              [
                59.3115221,
                36.5030948
              ],
              [
                59.3179252,
                36.5003912
              ],
              [
                59.3212023,
                36.4976403
              ],
              [
                59.3242553,
                36.4921433
              ],
              [
                59.3272601,
                36.490445
              ],
              [
                59.3321639,
                36.4900469
              ],
              [
                59.3378795,
                36.4911974
              ],
              [
                59.3443679,
                36.4875227
              ],
              [
                59.3501132,
                36.484481
              ],
              [
                59.3523143,
                36.4833589
              ],
              [
                59.3538488,
                36.4817269
              ],
              [
                59.3569801,
                36.4801328
              ],
              [
                59.3589868,
                36.4794066
              ],
              [
                59.3606349,
                36.4781003
              ],
              [
                59.3732197,
                36.4734139
              ],
              [
                59.3822957,
                36.4709943
              ],
              [
                59.3916926,
                36.4702455
              ],
              [
                59.4028661,
                36.463723
              ],
              [
                59.4135887,
                36.4601539
              ],
              [
                59.4260787,
                36.4502847
              ],
              [
                59.4354793,
                36.4423461
              ],
              [
                59.4419868,
                36.4405112
              ],
              [
                59.444396,
                36.438197
              ],
              [
                59.4443546,
                36.4351181
              ],
              [
                59.4487057,
                36.4308592
              ],
              [
                59.4529821,
                36.4282024
              ],
              [
                59.4589733,
                36.4221849
              ],
              [
                59.4603729,
                36.419992
              ],
              [
                59.464821,
                36.4164535
              ],
              [
                59.4683165,
                36.4133277
              ],
              [
                59.4670904,
                36.4107404
              ],
              [
                59.4638869,
                36.4089255
              ],
              [
                59.4600649,
                36.4061882
              ],
              [
                59.4583054,
                36.4035346
              ],
              [
                59.4580385,
                36.3997122
              ],
              [
                59.4577585,
                36.399433
              ],
              [
                59.4583115,
                36.3986042
              ],
              [
                59.4591451,
                36.3955504
              ],
              [
                59.4613934,
                36.3944739
              ],
              [
                59.4694998,
                36.3904709
              ],
              [
                59.4608132,
                36.393794
              ],
              [
                59.455654,
                36.3914124
              ],
              [
                59.4521877,
                36.3897931
              ],
              [
                59.4514974,
                36.3890535
              ],
              [
                59.4500814,
                36.3882886
              ],
              [
                59.4495163,
                36.3882833
              ],
              [
                59.4484914,
                36.3881988
              ],
              [
                59.4469215,
                36.389946
              ],
              [
                59.4429016,
                36.3881239
              ],
              [
                59.4390738,
                36.3856256
              ],
              [
                59.4369454,
                36.3835386
              ],
              [
                59.4354343,
                36.3825615
              ],
              [
                59.4349886,
                36.3822635
              ],
              [
                59.4331086,
                36.3815747
              ],
              [
                59.430778,
                36.3798493
              ],
              [
                59.4291043,
                36.3781217
              ],
              [
                59.4279027,
                36.3764114
              ],
              [
                59.4269579,
                36.3745715
              ],
              [
                59.4267225,
                36.3725932
              ],
              [
                59.4266152,
                36.3718675
              ],
              [
                59.4243622,
                36.3693277
              ],
              [
                59.4233966,
                36.3663558
              ],
              [
                59.4201994,
                36.362589
              ],
              [
                59.4202603,
                36.361849
              ],
              [
                59.4290421,
                36.3583813
              ],
              [
                59.4315068,
                36.3573993
              ],
              [
                59.4366025,
                36.3551991
              ],
              [
                59.436911,
                36.3549701
              ],
              [
                59.4371409,
                36.354712
              ],
              [
                59.437405,
                36.3543667
              ],
              [
                59.4410107,
                36.3493868
              ],
              [
                59.4422256,
                36.3476696
              ],
              [
                59.4424436,
                36.347341
              ],
              [
                59.4422488,
                36.3473063
              ],
              [
                59.442069,
                36.3472392
              ],
              [
                59.4419314,
                36.3471293
              ],
              [
                59.4414609,
                36.3463165
              ],
              [
                59.4409717,
                36.3454049
              ],
              [
                59.4405635,
                36.3445844
              ],
              [
                59.4416831,
                36.3439879
              ],
              [
                59.4423828,
                36.3432464
              ],
              [
                59.4420432,
                36.3419257
              ],
              [
                59.4421631,
                36.3406843
              ],
              [
                59.4419647,
                36.339785
              ],
              [
                59.4412049,
                36.3387855
              ],
              [
                59.4397469,
                36.337628
              ],
              [
                59.4420661,
                36.3363866
              ],
              [
                59.442506,
                36.3355482
              ],
              [
                59.4411464,
                36.3348711
              ],
              [
                59.4415866,
                36.3342277
              ],
              [
                59.4429266,
                36.3333421
              ],
              [
                59.4401276,
                36.331633
              ],
              [
                59.4390682,
                36.3316016
              ],
              [
                59.4380086,
                36.3307148
              ],
              [
                59.436769,
                36.3307793
              ],
              [
                59.4361146,
                36.3296378
              ],
              [
                59.4379648,
                36.3295381
              ],
              [
                59.4374288,
                36.3285865
              ],
              [
                59.4400482,
                36.3285716
              ],
              [
                59.44608,
                36.3278996
              ],
              [
                59.4558584,
                36.3267605
              ],
              [
                59.4575936,
                36.3264392
              ],
              [
                59.4578141,
                36.3243616
              ],
              [
                59.4584339,
                36.3225556
              ],
              [
                59.4598937,
                36.3214606
              ],
              [
                59.4615131,
                36.3203157
              ],
              [
                59.4629327,
                36.3199126
              ],
              [
                59.4633925,
                36.3196546
              ],
              [
                59.4630854,
                36.3178785
              ],
              [
                59.4630856,
                36.3157989
              ],
              [
                59.4637455,
                36.3132358
              ],
              [
                59.4637602,
                36.3131871
              ],
              [
                59.4646116,
                36.310372
              ],
              [
                59.4650515,
                36.3082125
              ],
              [
                59.4646318,
                36.3064071
              ],
              [
                59.4649718,
                36.3035849
              ],
              [
                59.4653322,
                36.3005711
              ],
              [
                59.4658121,
                36.2987492
              ],
              [
                59.466332,
                36.2970891
              ],
              [
                59.4677318,
                36.2951224
              ],
              [
                59.4692116,
                36.2934305
              ],
              [
                59.471573,
                36.2920832
              ],
              [
                59.4739525,
                36.2911807
              ],
              [
                59.4768316,
                36.2906006
              ],
              [
                59.4797712,
                36.2897151
              ],
              [
                59.4818708,
                36.2891362
              ],
              [
                59.4847106,
                36.2876224
              ],
              [
                59.4869501,
                36.2865753
              ],
              [
                59.4897295,
                36.2854471
              ],
              [
                59.492149,
                36.2845131
              ],
              [
                59.4943888,
                36.2832081
              ],
              [
                59.4966298,
                36.2815187
              ],
              [
                59.4992125,
                36.2797388
              ],
              [
                59.5016722,
                36.2778697
              ],
              [
                59.5036119,
                36.2768062
              ],
              [
                59.5055517,
                36.2758073
              ],
              [
                59.5072916,
                36.2748084
              ],
              [
                59.5094312,
                36.2743585
              ],
              [
                59.5119305,
                36.2739395
              ],
              [
                59.5142901,
                36.2732474
              ],
              [
                59.5165297,
                36.2727972
              ],
              [
                59.5185895,
                36.2724763
              ],
              [
                59.5202492,
                36.2717199
              ],
              [
                59.5215561,
                36.270997
              ],
              [
                59.5228751,
                36.2704337
              ],
              [
                59.5244638,
                36.2696379
              ],
              [
                59.5259547,
                36.2685522
              ],
              [
                59.5274363,
                36.2677017
              ],
              [
                59.5290535,
                36.2671583
              ],
              [
                59.5327936,
                36.2654801
              ],
              [
                59.5357562,
                36.2637697
              ],
              [
                59.5396146,
                36.2611751
              ],
              [
                59.5436814,
                36.25936
              ],
              [
                59.546186,
                36.2586502
              ],
              [
                59.5542039,
                36.2570924
              ],
              [
                59.5625097,
                36.2557712
              ],
              [
                59.5693397,
                36.2551784
              ],
              [
                59.5736268,
                36.2551612
              ],
              [
                59.5784046,
                36.2545074
              ],
              [
                59.580108,
                36.2535433
              ],
              [
                59.5816067,
                36.2526622
              ],
              [
                59.5852411,
                36.2482274
              ],
              [
                59.5853269,
                36.2459691
              ],
              [
                59.5847953,
                36.2437602
              ],
              [
                59.5845076,
                36.2417077
              ],
              [
                59.5843284,
                36.2409058
              ],
              [
                59.5841514,
                36.2386731
              ],
              [
                59.5869225,
                36.2379307
              ],
              [
                59.5878412,
                36.2375106
              ],
              [
                59.588737,
                36.2217417
              ],
              [
                59.5871298,
                36.2201447
              ],
              [
                59.5864104,
                36.2099313
              ],
              [
                59.5920752,
                36.2067456
              ],
              [
                59.5956801,
                36.1989885
              ],
              [
                59.5894027,
                36.1908439
              ],
              [
                59.5880163,
                36.1908438
              ],
              [
                59.5877362,
                36.1905643
              ],
              [
                59.5866296,
                36.1905643
              ],
              [
                59.5860694,
                36.190285
              ],
              [
                59.5416266,
                36.1865639
              ],
              [
                59.540793,
                36.1865639
              ],
              [
                59.5405199,
                36.1862755
              ],
              [
                59.5382932,
                36.1862756
              ],
              [
                59.5380132,
                36.1865638
              ],
              [
                59.5357932,
                36.1868343
              ],
              [
                59.5357932,
                36.1871136
              ],
              [
                59.53496,
                36.1871136
              ],
              [
                59.5341264,
                36.1876724
              ],
              [
                59.5294067,
                36.1882222
              ],
              [
                59.5266266,
                36.1871136
              ],
              [
                59.5147135,
                36.1837722
              ],
              [
                59.5138802,
                36.1837721
              ],
              [
                59.5068569,
                36.1803198
              ],
              [
                59.5060237,
                36.1803198
              ],
              [
                59.5029634,
                36.1808697
              ],
              [
                59.5025852,
                36.1814191
              ],
              [
                59.4978584,
                36.1736413
              ],
              [
                59.4975854,
                36.1730826
              ],
              [
                59.4984185,
                36.1666926
              ],
              [
                59.4940768,
                36.1561381
              ],
              [
                59.4937972,
                36.1553089
              ],
              [
                59.4907436,
                36.1503067
              ],
              [
                59.4681555,
                36.1412047
              ],
              [
                59.466919,
                36.139735
              ],
              [
                59.4658123,
                36.1355623
              ],
              [
                59.4667706,
                36.1246073
              ],
              [
                59.4695472,
                36.1202954
              ],
              [
                59.467684,
                36.1183548
              ],
              [
                59.461017,
                36.113073
              ],
              [
                59.4546306,
                36.1116849
              ],
              [
                59.426851,
                36.1036269
              ],
              [
                59.3646984,
                36.1103269
              ],
              [
                59.3583054,
                36.1102567
              ],
              [
                59.3569187,
                36.110536
              ],
              [
                59.3546988,
                36.110536
              ],
              [
                59.3521986,
                36.1110947
              ],
              [
                59.3455321,
                36.1127618
              ],
              [
                59.3288591,
                36.1183217
              ],
              [
                59.3266392,
                36.1188714
              ],
              [
                59.323859,
                36.1188714
              ],
              [
                59.3250257,
                36.116922
              ],
              [
                59.3144367,
                36.1100534
              ],
              [
                59.3189121,
                36.1010896
              ],
              [
                59.3138591,
                36.0949825
              ],
              [
                59.3144193,
                36.0877555
              ],
              [
                59.3141392,
                36.0863767
              ],
              [
                59.311639,
                36.0816546
              ],
              [
                59.2988591,
                36.0677588
              ],
              [
                59.2977528,
                36.067209
              ],
              [
                59.2927528,
                36.0638748
              ],
              [
                59.290246,
                36.0627573
              ],
              [
                59.2888592,
                36.0616489
              ],
              [
                59.287746,
                36.0613695
              ],
              [
                59.2849728,
                36.0594229
              ],
              [
                59.2838596,
                36.0591526
              ],
              [
                59.2424664,
                36.0330363
              ],
              [
                59.2138531,
                36.0113712
              ],
              [
                59.2119133,
                36.0097039
              ],
              [
                59.2091336,
                36.0069282
              ],
              [
                59.2091336,
                36.0063693
              ],
              [
                59.2077468,
                36.0049815
              ],
              [
                59.2070627,
                36.0027832
              ],
              [
                59.1990719,
                36.0046992
              ],
              [
                59.1932624,
                35.9949415
              ],
              [
                59.175539,
                35.9881985
              ],
              [
                59.1721345,
                35.9874075
              ],
              [
                59.15914,
                35.98446
              ],
              [
                59.1539742,
                35.9841459
              ],
              [
                59.1372582,
                35.9830419
              ],
              [
                59.1359281,
                35.9795343
              ],
              [
                59.1331812,
                35.9736653
              ],
              [
                59.1385457,
                35.9605012
              ],
              [
                59.1404342,
                35.9584167
              ],
              [
                59.1418933,
                35.9562629
              ],
              [
                59.127731,
                35.9542483
              ],
              [
                59.1167045,
                35.9515804
              ],
              [
                59.1054811,
                35.9518901
              ],
              [
                59.09629,
                35.9479737
              ],
              [
                59.0884161,
                35.9447765
              ],
              [
                59.088242,
                35.9409625
              ],
              [
                59.089053,
                35.9369361
              ],
              [
                59.0796232,
                35.928641
              ],
              [
                59.0766619,
                35.9250617
              ],
              [
                59.0688911,
                35.9121338
              ],
              [
                59.0683227,
                35.9065921
              ],
              [
                59.0696483,
                35.8952556
              ],
              [
                59.0706977,
                35.8863072
              ],
              [
                59.0723704,
                35.8729161
              ],
              [
                59.0677354,
                35.8637352
              ],
              [
                59.0792517,
                35.852805
              ],
              [
                59.0861273,
                35.8442952
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555216,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مه ولات",
          "name:en": "Mahvelat County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2725429",
          "wikipedia": "fa:شهرستان مه‌ولات"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.1570206,
                34.9344295
              ],
              [
                58.1595206,
                34.9344295
              ],
              [
                58.2108455,
                34.9138459
              ],
              [
                58.2217631,
                34.911514
              ],
              [
                58.221763,
                34.9117937
              ],
              [
                58.223703,
                34.9117937
              ],
              [
                58.2242631,
                34.911514
              ],
              [
                58.2368322,
                34.9055767
              ],
              [
                58.238219,
                34.9055768
              ],
              [
                58.2401654,
                34.9050263
              ],
              [
                58.2412721,
                34.9050264
              ],
              [
                58.2418323,
                34.9047466
              ],
              [
                58.2451655,
                34.9047466
              ],
              [
                58.2515713,
                34.8971955
              ],
              [
                58.2680315,
                34.8957143
              ],
              [
                58.2685846,
                34.8957143
              ],
              [
                58.2685846,
                34.895994
              ],
              [
                58.2719179,
                34.8965444
              ],
              [
                58.272478,
                34.8968242
              ],
              [
                58.2744179,
                34.8968242
              ],
              [
                58.274698,
                34.8971039
              ],
              [
                58.2780313,
                34.8971039
              ],
              [
                58.2785844,
                34.8968242
              ],
              [
                58.2802512,
                34.8968242
              ],
              [
                58.2973747,
                34.8856898
              ],
              [
                58.3034881,
                34.884309
              ],
              [
                58.3040412,
                34.8840292
              ],
              [
                58.3054279,
                34.8840292
              ],
              [
                58.3068214,
                34.8834699
              ],
              [
                58.3076546,
                34.8834698
              ],
              [
                58.3079276,
                34.8831901
              ],
              [
                58.3087612,
                34.8831901
              ],
              [
                58.309321,
                34.8829103
              ],
              [
                58.3109879,
                34.8826306
              ],
              [
                58.3274456,
                34.8757921
              ],
              [
                58.3456417,
                34.8741021
              ],
              [
                58.3518207,
                34.8679116
              ],
              [
                58.3526539,
                34.8679116
              ],
              [
                58.352934,
                34.8676318
              ],
              [
                58.3537672,
                34.8676319
              ],
              [
                58.3601536,
                34.865132
              ],
              [
                58.3643205,
                34.864013
              ],
              [
                58.3654339,
                34.864013
              ],
              [
                58.3662671,
                34.8637422
              ],
              [
                58.4017261,
                34.8350076
              ],
              [
                58.414226,
                34.8330667
              ],
              [
                58.4231191,
                34.8302862
              ],
              [
                58.424786,
                34.8294466
              ],
              [
                58.4256192,
                34.8294466
              ],
              [
                58.437046,
                34.8223365
              ],
              [
                58.4387124,
                34.8209464
              ],
              [
                58.4571787,
                34.8248308
              ],
              [
                58.4824916,
                34.8295171
              ],
              [
                58.4836049,
                34.8289666
              ],
              [
                58.4904856,
                34.8207854
              ],
              [
                58.5002119,
                34.8160669
              ],
              [
                58.4987637,
                34.8087297
              ],
              [
                58.509646,
                34.7953822
              ],
              [
                58.5178497,
                34.7873832
              ],
              [
                58.5197966,
                34.7873832
              ],
              [
                58.5203496,
                34.7871035
              ],
              [
                58.5214631,
                34.7871034
              ],
              [
                58.5228497,
                34.786553
              ],
              [
                58.523683,
                34.786553
              ],
              [
                58.5245162,
                34.7862734
              ],
              [
                58.5261831,
                34.7862734
              ],
              [
                58.5264631,
                34.7859937
              ],
              [
                58.530903,
                34.7859936
              ],
              [
                58.5314628,
                34.785714
              ],
              [
                58.553352,
                34.7641792
              ],
              [
                58.5688015,
                34.7424591
              ],
              [
                58.5983273,
                34.7125494
              ],
              [
                58.6217405,
                34.7120875
              ],
              [
                58.6222937,
                34.7118075
              ],
              [
                58.6228469,
                34.7118075
              ],
              [
                58.6231268,
                34.7115366
              ],
              [
                58.6239604,
                34.7114661
              ],
              [
                58.6247937,
                34.7112566
              ],
              [
                58.6347934,
                34.7084661
              ],
              [
                58.6536024,
                34.7085982
              ],
              [
                58.6627005,
                34.710856
              ],
              [
                58.6740956,
                34.7165343
              ],
              [
                58.6782762,
                34.7207719
              ],
              [
                58.6995928,
                34.7505572
              ],
              [
                58.7125894,
                34.7595835
              ],
              [
                58.7134226,
                34.7593039
              ],
              [
                58.7447684,
                34.7689301
              ],
              [
                58.7474879,
                34.7633952
              ],
              [
                58.7581228,
                34.7635898
              ],
              [
                58.7614369,
                34.7646337
              ],
              [
                58.7806355,
                34.7728431
              ],
              [
                58.7847515,
                34.7701576
              ],
              [
                58.7954592,
                34.7664667
              ],
              [
                58.8056438,
                34.7682957
              ],
              [
                58.8219905,
                34.7689202
              ],
              [
                58.8363843,
                34.772573
              ],
              [
                58.851871,
                34.7748223
              ],
              [
                58.8878089,
                34.7813787
              ],
              [
                58.9135801,
                34.7875116
              ],
              [
                58.9160802,
                34.7880711
              ],
              [
                58.9177466,
                34.7880711
              ],
              [
                58.9202467,
                34.7886216
              ],
              [
                58.92164,
                34.7886215
              ],
              [
                58.9227467,
                34.7889012
              ],
              [
                58.9255264,
                34.7889012
              ],
              [
                58.9263601,
                34.7886215
              ],
              [
                58.966026,
                34.7892771
              ],
              [
                58.986282,
                34.7811
              ],
              [
                59.0013882,
                34.7847657
              ],
              [
                59.024674,
                34.7855311
              ],
              [
                59.0257873,
                34.7849716
              ],
              [
                59.026894,
                34.7849717
              ],
              [
                59.0271737,
                34.7846918
              ],
              [
                59.0443867,
                34.7796207
              ],
              [
                59.0455,
                34.7790702
              ],
              [
                59.0504997,
                34.7765704
              ],
              [
                59.0513334,
                34.7762906
              ],
              [
                59.0529999,
                34.7757402
              ],
              [
                59.0543865,
                34.7757401
              ],
              [
                59.1055283,
                34.7772518
              ],
              [
                59.1058017,
                34.7778025
              ],
              [
                59.1060818,
                34.7800323
              ],
              [
                59.1060818,
                34.7803121
              ],
              [
                59.1060819,
                34.7808629
              ],
              [
                59.1267745,
                34.8092737
              ],
              [
                59.1278877,
                34.8112145
              ],
              [
                59.1281678,
                34.8117741
              ],
              [
                59.1276481,
                34.8399926
              ],
              [
                59.1460381,
                34.8581296
              ],
              [
                59.1468713,
                34.8589689
              ],
              [
                59.1664451,
                34.8740969
              ],
              [
                59.1669986,
                34.8743677
              ],
              [
                59.1727063,
                34.8842415
              ],
              [
                59.1723629,
                34.8969139
              ],
              [
                59.1315075,
                34.9157781
              ],
              [
                59.1104694,
                34.9177847
              ],
              [
                59.1093635,
                34.9284454
              ],
              [
                59.1101359,
                34.9308379
              ],
              [
                59.1007804,
                34.9378744
              ],
              [
                59.098978,
                34.9408295
              ],
              [
                59.1007682,
                34.9491211
              ],
              [
                59.1122817,
                34.9586285
              ],
              [
                59.1648101,
                34.9813464
              ],
              [
                59.1970787,
                34.9899323
              ],
              [
                59.1401752,
                35.0109652
              ],
              [
                59.1246244,
                35.0096877
              ],
              [
                59.0917042,
                35.0063179
              ],
              [
                59.0752028,
                35.0299965
              ],
              [
                59.0631866,
                35.0428571
              ],
              [
                59.0566633,
                35.0578237
              ],
              [
                59.0504837,
                35.0710311
              ],
              [
                59.0448893,
                35.0781719
              ],
              [
                59.0789641,
                35.1160856
              ],
              [
                59.0975182,
                35.151355
              ],
              [
                59.1006562,
                35.164638
              ],
              [
                59.1006561,
                35.1651883
              ],
              [
                59.1006562,
                35.1654679
              ],
              [
                59.1006561,
                35.1660271
              ],
              [
                59.1006562,
                35.1662977
              ],
              [
                59.0968188,
                35.1703263
              ],
              [
                59.0968189,
                35.1711653
              ],
              [
                59.0965387,
                35.1745029
              ],
              [
                59.0965388,
                35.1750532
              ],
              [
                59.0965387,
                35.1753327
              ],
              [
                59.0968189,
                35.1800505
              ],
              [
                59.0968189,
                35.1803391
              ],
              [
                59.0968189,
                35.1808894
              ],
              [
                59.097092,
                35.1844977
              ],
              [
                59.0970919,
                35.1850569
              ],
              [
                59.0970919,
                35.1853366
              ],
              [
                59.097092,
                35.1867257
              ],
              [
                59.085699,
                35.1864324
              ],
              [
                59.0859791,
                35.188931
              ],
              [
                59.0785726,
                35.2055137
              ],
              [
                59.0628598,
                35.2191804
              ],
              [
                59.0555129,
                35.2380187
              ],
              [
                59.0527331,
                35.2421855
              ],
              [
                59.0516266,
                35.2482912
              ],
              [
                59.0518568,
                35.2580955
              ],
              [
                59.0481513,
                35.268178
              ],
              [
                59.0221118,
                35.2794219
              ],
              [
                59.0173851,
                35.2822002
              ],
              [
                59.0171121,
                35.2824798
              ],
              [
                59.014332,
                35.2844192
              ],
              [
                59.0104864,
                35.294532
              ],
              [
                58.9948652,
                35.3022376
              ],
              [
                58.9835092,
                35.3140801
              ],
              [
                58.9833493,
                35.3141966
              ],
              [
                58.9822775,
                35.314978
              ],
              [
                58.9572094,
                35.3323505
              ],
              [
                58.936859,
                35.3392124
              ],
              [
                58.915386,
                35.3323525
              ],
              [
                58.8999172,
                35.3183346
              ],
              [
                58.8845725,
                35.3152579
              ],
              [
                58.8747362,
                35.3148987
              ],
              [
                58.8319729,
                35.3142857
              ],
              [
                58.8060762,
                35.3361636
              ],
              [
                58.8052426,
                35.3364432
              ],
              [
                58.7918469,
                35.345626
              ],
              [
                58.791287,
                35.3453464
              ],
              [
                58.7904535,
                35.3453464
              ],
              [
                58.7899004,
                35.3453464
              ],
              [
                58.788613,
                35.3422191
              ],
              [
                58.7883328,
                35.3405506
              ],
              [
                58.7892149,
                35.3337529
              ],
              [
                58.7950514,
                35.3257702
              ],
              [
                58.7938498,
                35.3142849
              ],
              [
                58.7774343,
                35.3038889
              ],
              [
                58.7729877,
                35.2952749
              ],
              [
                58.775351,
                35.285033
              ],
              [
                58.7751628,
                35.2750509
              ],
              [
                58.7796589,
                35.2595085
              ],
              [
                58.7774441,
                35.2375346
              ],
              [
                58.7819725,
                35.2301338
              ],
              [
                58.7850884,
                35.2219624
              ],
              [
                58.7801651,
                35.2163767
              ],
              [
                58.7798943,
                35.2161062
              ],
              [
                58.7787876,
                35.2149967
              ],
              [
                58.7785075,
                35.2141666
              ],
              [
                58.7686658,
                35.2043175
              ],
              [
                58.7647729,
                35.1940419
              ],
              [
                58.7602041,
                35.1739488
              ],
              [
                58.7469863,
                35.1637752
              ],
              [
                58.7438964,
                35.1613893
              ],
              [
                58.7399217,
                35.1589968
              ],
              [
                58.7388674,
                35.1571456
              ],
              [
                58.736,
                35.1526177
              ],
              [
                58.7320518,
                35.1382301
              ],
              [
                58.7294072,
                35.1360519
              ],
              [
                58.724023,
                35.1280182
              ],
              [
                58.7132334,
                35.1209992
              ],
              [
                58.7032318,
                35.1174302
              ],
              [
                58.6823773,
                35.1146957
              ],
              [
                58.6796563,
                35.1146619
              ],
              [
                58.6578838,
                35.1130985
              ],
              [
                58.6567705,
                35.1130985
              ],
              [
                58.6562174,
                35.1128189
              ],
              [
                58.6509372,
                35.1119891
              ],
              [
                58.6489973,
                35.1119892
              ],
              [
                58.6478839,
                35.1117096
              ],
              [
                58.646494,
                35.1117097
              ],
              [
                58.6451038,
                35.1117097
              ],
              [
                58.6445507,
                35.1114301
              ],
              [
                58.6426042,
                35.1114301
              ],
              [
                58.6420507,
                35.1117096
              ],
              [
                58.6412175,
                35.11143
              ],
              [
                58.6398307,
                35.1117097
              ],
              [
                58.6376041,
                35.1117097
              ],
              [
                58.6353842,
                35.1117098
              ],
              [
                58.634551,
                35.1119892
              ],
              [
                58.6211981,
                35.1190101
              ],
              [
                58.6206379,
                35.1192897
              ],
              [
                58.6186981,
                35.1192898
              ],
              [
                58.6181379,
                35.1195692
              ],
              [
                58.6145316,
                35.1201194
              ],
              [
                58.6123046,
                35.1201194
              ],
              [
                58.6111983,
                35.120399
              ],
              [
                58.5942716,
                35.1091654
              ],
              [
                58.5931654,
                35.109445
              ],
              [
                58.5901051,
                35.1094451
              ],
              [
                58.5889984,
                35.1097246
              ],
              [
                58.5835448,
                35.1069033
              ],
              [
                58.5821585,
                35.1066237
              ],
              [
                58.5810452,
                35.1069033
              ],
              [
                58.5690985,
                35.1069033
              ],
              [
                58.5679919,
                35.1066238
              ],
              [
                58.5677117,
                35.1069034
              ],
              [
                58.5665984,
                35.1066238
              ],
              [
                58.5593788,
                35.1066238
              ],
              [
                58.5585451,
                35.1063442
              ],
              [
                58.5574318,
                35.1063441
              ],
              [
                58.5568787,
                35.1066238
              ],
              [
                58.5499069,
                35.1017085
              ],
              [
                58.547687,
                35.1019881
              ],
              [
                58.5451874,
                35.101988
              ],
              [
                58.5449073,
                35.1022677
              ],
              [
                58.5435206,
                35.1022677
              ],
              [
                58.5429674,
                35.1025474
              ],
              [
                58.5393541,
                35.1030977
              ],
              [
                58.531879,
                35.1080129
              ],
              [
                58.5313187,
                35.1077333
              ],
              [
                58.5247522,
                35.1105673
              ],
              [
                58.5186764,
                35.1140114
              ],
              [
                58.5067358,
                35.0965898
              ],
              [
                58.496989,
                35.0747204
              ],
              [
                58.4941084,
                35.0443847
              ],
              [
                58.477821,
                35.0316834
              ],
              [
                58.4585949,
                35.0263419
              ],
              [
                58.4402462,
                35.0230199
              ],
              [
                58.4383064,
                35.0232997
              ],
              [
                58.4333063,
                35.0232997
              ],
              [
                58.4313597,
                35.0235796
              ],
              [
                58.4230264,
                35.0235796
              ],
              [
                58.4172323,
                35.0213046
              ],
              [
                58.3855533,
                35.0181178
              ],
              [
                58.371005,
                35.0160793
              ],
              [
                58.3542024,
                35.0154724
              ],
              [
                58.3437353,
                35.0137541
              ],
              [
                58.3351278,
                35.0123536
              ],
              [
                58.3213519,
                35.0139704
              ],
              [
                58.313713,
                35.0156224
              ],
              [
                58.3055161,
                35.0179421
              ],
              [
                58.2981598,
                35.0204241
              ],
              [
                58.2886666,
                35.0184406
              ],
              [
                58.2780073,
                35.0166417
              ],
              [
                58.2671473,
                35.0218632
              ],
              [
                58.2502167,
                35.0167202
              ],
              [
                58.2438071,
                35.0195683
              ],
              [
                58.2379736,
                35.0212907
              ],
              [
                58.2253292,
                35.0214509
              ],
              [
                58.2160376,
                35.0221245
              ],
              [
                58.211388,
                35.0201937
              ],
              [
                58.2001633,
                35.0147358
              ],
              [
                58.1931774,
                35.0085284
              ],
              [
                58.1934504,
                35.0079694
              ],
              [
                58.1931774,
                35.0074101
              ],
              [
                58.1934504,
                35.0071305
              ],
              [
                58.1898436,
                34.9918618
              ],
              [
                58.1772739,
                34.9804959
              ],
              [
                58.1769938,
                34.9802163
              ],
              [
                58.1769938,
                34.9799367
              ],
              [
                58.1764407,
                34.9796572
              ],
              [
                58.1761606,
                34.9788275
              ],
              [
                58.1650873,
                34.9735421
              ],
              [
                58.1648139,
                34.9732716
              ],
              [
                58.1560622,
                34.9587265
              ],
              [
                58.1570206,
                34.9344295
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555245,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نیشابور",
          "name:ar": "مقاطعة نيسابور",
          "name:en": "Neyshabur County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1292899",
          "wikipedia": "fa:شهرستان نیشابور"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.2110353,
                36.8790485
              ],
              [
                58.2065856,
                36.8767033
              ],
              [
                58.2022237,
                36.8692028
              ],
              [
                58.196349,
                36.8657028
              ],
              [
                58.1867992,
                36.858809
              ],
              [
                58.1870793,
                36.8551981
              ],
              [
                58.1810187,
                36.8509172
              ],
              [
                58.1832143,
                36.8348847
              ],
              [
                58.1726933,
                36.8254215
              ],
              [
                58.1818042,
                36.8134848
              ],
              [
                58.1826374,
                36.8109903
              ],
              [
                58.2002321,
                36.8049974
              ],
              [
                58.2027322,
                36.8030523
              ],
              [
                58.2069353,
                36.8039852
              ],
              [
                58.2086022,
                36.8020402
              ],
              [
                58.211127,
                36.8016115
              ],
              [
                58.2222401,
                36.7938318
              ],
              [
                58.2277934,
                36.7916077
              ],
              [
                58.228627,
                36.7916077
              ],
              [
                58.2311266,
                36.7907702
              ],
              [
                58.2316868,
                36.7885461
              ],
              [
                58.2314068,
                36.7877177
              ],
              [
                58.2475743,
                36.7775503
              ],
              [
                58.2496591,
                36.7681649
              ],
              [
                58.2479927,
                36.7623395
              ],
              [
                58.2492442,
                36.7545949
              ],
              [
                58.2478508,
                36.7493184
              ],
              [
                58.2247923,
                36.7498886
              ],
              [
                58.2186125,
                36.7460373
              ],
              [
                58.2188134,
                36.7394491
              ],
              [
                58.2222731,
                36.7360717
              ],
              [
                58.2256064,
                36.734685
              ],
              [
                58.2269998,
                36.7346851
              ],
              [
                58.2278331,
                36.734406
              ],
              [
                58.2289396,
                36.7344059
              ],
              [
                58.2297728,
                36.7341269
              ],
              [
                58.2350531,
                36.7330193
              ],
              [
                58.2364465,
                36.7330194
              ],
              [
                58.2372797,
                36.7327402
              ],
              [
                58.2411665,
                36.7327402
              ],
              [
                58.2428329,
                36.7324612
              ],
              [
                58.2475529,
                36.7324611
              ],
              [
                58.2483862,
                36.7327402
              ],
              [
                58.2497796,
                36.7327402
              ],
              [
                58.2511663,
                36.7330193
              ],
              [
                58.2578329,
                36.7330193
              ],
              [
                58.2592192,
                36.7327401
              ],
              [
                58.2636662,
                36.7327402
              ],
              [
                58.2644994,
                36.7324611
              ],
              [
                58.271719,
                36.732461
              ],
              [
                58.2728324,
                36.7327401
              ],
              [
                58.2733925,
                36.7324611
              ],
              [
                58.273666,
                36.7327402
              ],
              [
                58.273946,
                36.7324611
              ],
              [
                58.2744992,
                36.7327401
              ],
              [
                58.2750594,
                36.7324611
              ],
              [
                58.2760393,
                36.7280585
              ],
              [
                58.2788127,
                36.7272211
              ],
              [
                58.2793725,
                36.7263927
              ],
              [
                58.2842041,
                36.7186393
              ],
              [
                58.283924,
                36.7175227
              ],
              [
                58.2835003,
                36.7102657
              ],
              [
                58.2773207,
                36.7000813
              ],
              [
                58.268827,
                36.6951151
              ],
              [
                58.2684607,
                36.6946245
              ],
              [
                58.2681877,
                36.6940752
              ],
              [
                58.2545928,
                36.6950166
              ],
              [
                58.2433662,
                36.6916311
              ],
              [
                58.240313,
                36.687462
              ],
              [
                58.2389196,
                36.6841303
              ],
              [
                58.2378134,
                36.6824645
              ],
              [
                58.2353134,
                36.6780162
              ],
              [
                58.234313,
                36.6683524
              ],
              [
                58.2399324,
                36.6569572
              ],
              [
                58.2007597,
                36.6326112
              ],
              [
                58.2136343,
                36.619799
              ],
              [
                58.2273671,
                36.5909982
              ],
              [
                58.2368943,
                36.5748706
              ],
              [
                58.2444473,
                36.571493
              ],
              [
                58.2784428,
                36.5592053
              ],
              [
                58.2822857,
                36.5525553
              ],
              [
                58.2951397,
                36.5417029
              ],
              [
                58.3036158,
                36.5345444
              ],
              [
                58.3036336,
                36.5345293
              ],
              [
                58.349714,
                36.5302416
              ],
              [
                58.3586024,
                36.5253637
              ],
              [
                58.3670002,
                36.5212238
              ],
              [
                58.3819068,
                36.513636
              ],
              [
                58.4261113,
                36.4930762
              ],
              [
                58.4323832,
                36.4798124
              ],
              [
                58.4397831,
                36.4781324
              ],
              [
                58.4433893,
                36.476745
              ],
              [
                58.4468767,
                36.4777753
              ],
              [
                58.4895623,
                36.4508125
              ],
              [
                58.4938287,
                36.4507679
              ],
              [
                58.4972324,
                36.4503542
              ],
              [
                58.5002228,
                36.4514241
              ],
              [
                58.5113249,
                36.4523218
              ],
              [
                58.5195426,
                36.4545092
              ],
              [
                58.5308383,
                36.4546385
              ],
              [
                58.5480442,
                36.4555936
              ],
              [
                58.5720062,
                36.4661765
              ],
              [
                58.5782397,
                36.4577386
              ],
              [
                58.6022352,
                36.4265969
              ],
              [
                58.6104507,
                36.4141599
              ],
              [
                58.6204796,
                36.3991776
              ],
              [
                58.645792,
                36.3828906
              ],
              [
                58.6612446,
                36.3728815
              ],
              [
                58.6696909,
                36.3666944
              ],
              [
                58.6657047,
                36.3616905
              ],
              [
                58.6634302,
                36.3556078
              ],
              [
                58.657664,
                36.348682
              ],
              [
                58.6424299,
                36.340426
              ],
              [
                58.6442468,
                36.3281264
              ],
              [
                58.6524009,
                36.3234931
              ],
              [
                58.6593912,
                36.3150106
              ],
              [
                58.6643314,
                36.3086239
              ],
              [
                58.6686757,
                36.3054632
              ],
              [
                58.6741105,
                36.302159
              ],
              [
                58.6572921,
                36.2960638
              ],
              [
                58.6513771,
                36.2938969
              ],
              [
                58.6499671,
                36.284171
              ],
              [
                58.6496543,
                36.2748637
              ],
              [
                58.6536259,
                36.2689823
              ],
              [
                58.6573362,
                36.2609541
              ],
              [
                58.657818,
                36.2561671
              ],
              [
                58.6543866,
                36.2480103
              ],
              [
                58.6426939,
                36.2417165
              ],
              [
                58.6326583,
                36.2384997
              ],
              [
                58.6248593,
                36.2359223
              ],
              [
                58.6246774,
                36.2316739
              ],
              [
                58.6261674,
                36.2286156
              ],
              [
                58.6146354,
                36.2171332
              ],
              [
                58.6100003,
                36.2088234
              ],
              [
                58.6171671,
                36.2002007
              ],
              [
                58.6220169,
                36.1934818
              ],
              [
                58.614949,
                36.1900965
              ],
              [
                58.6064906,
                36.1819479
              ],
              [
                58.5977267,
                36.1762669
              ],
              [
                58.5886287,
                36.1674675
              ],
              [
                58.5874271,
                36.1613697
              ],
              [
                58.5905748,
                36.1531073
              ],
              [
                58.5917905,
                36.1499888
              ],
              [
                58.5905436,
                36.1438896
              ],
              [
                58.5896634,
                36.139588
              ],
              [
                58.5896634,
                36.1390295
              ],
              [
                58.5891103,
                36.1381913
              ],
              [
                58.5882769,
                36.1365242
              ],
              [
                58.588277,
                36.135695
              ],
              [
                58.5877235,
                36.1345777
              ],
              [
                58.5877235,
                36.1340278
              ],
              [
                58.5871633,
                36.1312523
              ],
              [
                58.5868903,
                36.1298644
              ],
              [
                58.5866101,
                36.1284676
              ],
              [
                58.5863301,
                36.1241721
              ],
              [
                58.5866545,
                36.0937769
              ],
              [
                58.584895,
                36.0867024
              ],
              [
                58.5903883,
                36.0834421
              ],
              [
                58.5946342,
                36.0815501
              ],
              [
                58.5982418,
                36.0809103
              ],
              [
                58.6014911,
                36.0783595
              ],
              [
                58.6345714,
                36.0791603
              ],
              [
                58.6441612,
                36.0813612
              ],
              [
                58.6544805,
                36.0839438
              ],
              [
                58.6745211,
                36.0826537
              ],
              [
                58.6910844,
                36.089886
              ],
              [
                58.7057984,
                36.0891791
              ],
              [
                58.7129832,
                36.0907675
              ],
              [
                58.7406348,
                36.0802513
              ],
              [
                58.7456471,
                36.0814514
              ],
              [
                58.7504013,
                36.0836877
              ],
              [
                58.7739372,
                36.0822282
              ],
              [
                58.779745,
                36.0812757
              ],
              [
                58.8104876,
                36.0539984
              ],
              [
                58.8203549,
                36.0450468
              ],
              [
                58.8224981,
                36.0344854
              ],
              [
                58.8253179,
                36.0214343
              ],
              [
                58.8266372,
                36.0132829
              ],
              [
                58.8380527,
                36.0034237
              ],
              [
                58.8472365,
                35.9934244
              ],
              [
                58.8540172,
                35.990091
              ],
              [
                58.8579654,
                35.9830071
              ],
              [
                58.8673209,
                35.9734219
              ],
              [
                58.8662772,
                35.9679652
              ],
              [
                58.868895,
                35.961612
              ],
              [
                58.8773266,
                35.9555997
              ],
              [
                58.8775102,
                35.9464476
              ],
              [
                58.8784542,
                35.9399141
              ],
              [
                58.881361,
                35.9260262
              ],
              [
                58.892431,
                35.9249658
              ],
              [
                58.9090823,
                35.9202379
              ],
              [
                58.9244551,
                35.9148927
              ],
              [
                58.9369223,
                35.9090356
              ],
              [
                58.9353143,
                35.9181601
              ],
              [
                58.9345803,
                35.9214935
              ],
              [
                58.9343864,
                35.9304639
              ],
              [
                58.939247,
                35.9386138
              ],
              [
                58.9493751,
                35.9461881
              ],
              [
                58.9510058,
                35.9550818
              ],
              [
                58.955049,
                35.9621509
              ],
              [
                58.9633655,
                35.9678648
              ],
              [
                58.9522622,
                35.9835925
              ],
              [
                58.9482164,
                35.9879033
              ],
              [
                58.9421537,
                35.9927666
              ],
              [
                58.9515237,
                36.0001823
              ],
              [
                58.9497224,
                36.008854
              ],
              [
                58.94597,
                36.0102379
              ],
              [
                58.9391536,
                36.0111246
              ],
              [
                58.9303061,
                36.0098308
              ],
              [
                58.9250925,
                36.0113357
              ],
              [
                58.9210907,
                36.0152907
              ],
              [
                58.9173043,
                36.0193062
              ],
              [
                58.9130987,
                36.0296825
              ],
              [
                58.9131031,
                36.034653
              ],
              [
                58.9140558,
                36.0446576
              ],
              [
                58.9217728,
                36.0485291
              ],
              [
                58.9226671,
                36.054568
              ],
              [
                58.9346551,
                36.0609647
              ],
              [
                58.9456709,
                36.06658
              ],
              [
                58.9457273,
                36.0714758
              ],
              [
                58.9466997,
                36.0752631
              ],
              [
                58.9478516,
                36.0800252
              ],
              [
                58.9512755,
                36.085063
              ],
              [
                58.9538076,
                36.0886462
              ],
              [
                58.9603579,
                36.0919638
              ],
              [
                58.958559,
                36.0990997
              ],
              [
                58.9565769,
                36.105587
              ],
              [
                58.9348244,
                36.1194279
              ],
              [
                58.9373321,
                36.1250298
              ],
              [
                58.9364989,
                36.1261381
              ],
              [
                58.9362257,
                36.1272556
              ],
              [
                58.9428924,
                36.135582
              ],
              [
                58.9471769,
                36.1435984
              ],
              [
                58.9496769,
                36.1460944
              ],
              [
                58.9510632,
                36.1485904
              ],
              [
                58.956436,
                36.1599193
              ],
              [
                58.9373489,
                36.1658462
              ],
              [
                58.9378145,
                36.1725207
              ],
              [
                58.9448486,
                36.1745845
              ],
              [
                58.9488222,
                36.1768869
              ],
              [
                58.9535246,
                36.178631
              ],
              [
                58.9856787,
                36.1905301
              ],
              [
                58.9856787,
                36.1910798
              ],
              [
                59.0074496,
                36.205468
              ],
              [
                59.0322204,
                36.2654298
              ],
              [
                59.0388379,
                36.2726374
              ],
              [
                59.0476783,
                36.2826061
              ],
              [
                59.0463397,
                36.2927597
              ],
              [
                59.0456623,
                36.3049326
              ],
              [
                59.0523878,
                36.3098643
              ],
              [
                59.0593401,
                36.3149996
              ],
              [
                59.0667757,
                36.3207154
              ],
              [
                59.0601825,
                36.3228016
              ],
              [
                59.0462779,
                36.3246687
              ],
              [
                59.0327167,
                36.3261209
              ],
              [
                59.0312575,
                36.3281262
              ],
              [
                59.0281069,
                36.330335
              ],
              [
                59.0238318,
                36.3342589
              ],
              [
                59.0072679,
                36.339604
              ],
              [
                59.0060663,
                36.3448583
              ],
              [
                59.001646,
                36.3475199
              ],
              [
                58.9964582,
                36.3527956
              ],
              [
                58.9905309,
                36.3593404
              ],
              [
                58.9806649,
                36.3674901
              ],
              [
                58.9632368,
                36.3819742
              ],
              [
                58.9579388,
                36.3869528
              ],
              [
                58.961048,
                36.3975894
              ],
              [
                58.9604179,
                36.4011245
              ],
              [
                58.9543738,
                36.4050622
              ],
              [
                58.9524549,
                36.4072123
              ],
              [
                58.944534,
                36.4137079
              ],
              [
                58.9352988,
                36.4210753
              ],
              [
                58.929119,
                36.4271529
              ],
              [
                58.9237588,
                36.4355656
              ],
              [
                58.9162198,
                36.4415095
              ],
              [
                58.9136699,
                36.4460121
              ],
              [
                58.9255139,
                36.458017
              ],
              [
                58.9306637,
                36.4847971
              ],
              [
                58.94474,
                36.4961138
              ],
              [
                58.9283026,
                36.5168019
              ],
              [
                58.9223498,
                36.5190177
              ],
              [
                58.9070832,
                36.5245806
              ],
              [
                58.9034766,
                36.5262457
              ],
              [
                58.9029167,
                36.5268036
              ],
              [
                58.9021523,
                36.5271874
              ],
              [
                58.8912501,
                36.5334637
              ],
              [
                58.8890302,
                36.5354076
              ],
              [
                58.8507041,
                36.5421149
              ],
              [
                58.8426512,
                36.5448962
              ],
              [
                58.8220913,
                36.5498916
              ],
              [
                58.8207047,
                36.5504496
              ],
              [
                58.8035242,
                36.559267
              ],
              [
                58.804125,
                36.5762317
              ],
              [
                58.8051519,
                36.5912134
              ],
              [
                58.796334,
                36.5950731
              ],
              [
                58.782005,
                36.6019893
              ],
              [
                58.7718428,
                36.6046795
              ],
              [
                58.7645265,
                36.6053753
              ],
              [
                58.7624237,
                36.6107429
              ],
              [
                58.7598058,
                36.6161718
              ],
              [
                58.7571572,
                36.6215556
              ],
              [
                58.7591238,
                36.629278
              ],
              [
                58.7577803,
                36.6328941
              ],
              [
                58.757306,
                36.6346886
              ],
              [
                58.7549824,
                36.6382356
              ],
              [
                58.7506575,
                36.6447331
              ],
              [
                58.746651,
                36.6508003
              ],
              [
                58.7425987,
                36.6569455
              ],
              [
                58.7397462,
                36.6613214
              ],
              [
                58.7187478,
                36.6590901
              ],
              [
                58.7029979,
                36.6574031
              ],
              [
                58.6866041,
                36.6561294
              ],
              [
                58.6814114,
                36.6448017
              ],
              [
                58.6800381,
                36.6366062
              ],
              [
                58.6786219,
                36.6285475
              ],
              [
                58.6652326,
                36.6244832
              ],
              [
                58.6591383,
                36.6257577
              ],
              [
                58.6485279,
                36.6282206
              ],
              [
                58.6424499,
                36.6296347
              ],
              [
                58.6367454,
                36.6328057
              ],
              [
                58.6340919,
                36.6339223
              ],
              [
                58.6099145,
                36.6457658
              ],
              [
                58.5939499,
                36.6534095
              ],
              [
                58.5755988,
                36.670618
              ],
              [
                58.5779011,
                36.6786712
              ],
              [
                58.5838174,
                36.6972534
              ],
              [
                58.5884874,
                36.7115106
              ],
              [
                58.5847611,
                36.7135496
              ],
              [
                58.5796298,
                36.7162712
              ],
              [
                58.5729382,
                36.7197277
              ],
              [
                58.5586066,
                36.727481
              ],
              [
                58.5504713,
                36.7313706
              ],
              [
                58.5456625,
                36.7341566
              ],
              [
                58.5411978,
                36.7413553
              ],
              [
                58.5390516,
                36.7462414
              ],
              [
                58.5372941,
                36.7507915
              ],
              [
                58.5322377,
                36.7616135
              ],
              [
                58.5237435,
                36.7718921
              ],
              [
                58.515443,
                36.7800624
              ],
              [
                58.517417,
                36.7882028
              ],
              [
                58.5202794,
                36.7939995
              ],
              [
                58.5285909,
                36.8046037
              ],
              [
                58.5319767,
                36.807331
              ],
              [
                58.5355363,
                36.8099705
              ],
              [
                58.5361618,
                36.8149812
              ],
              [
                58.5348151,
                36.820928
              ],
              [
                58.5216678,
                36.8379024
              ],
              [
                58.5103452,
                36.8488898
              ],
              [
                58.4932981,
                36.8492181
              ],
              [
                58.4924982,
                36.8662317
              ],
              [
                58.4916657,
                36.8866921
              ],
              [
                58.4837678,
                36.9042379
              ],
              [
                58.4778141,
                36.9029238
              ],
              [
                58.4689899,
                36.9032671
              ],
              [
                58.46048,
                36.9047176
              ],
              [
                58.4526727,
                36.9087596
              ],
              [
                58.447946,
                36.9112651
              ],
              [
                58.4467069,
                36.9146598
              ],
              [
                58.4357827,
                36.923072
              ],
              [
                58.4347196,
                36.9237721
              ],
              [
                58.4025478,
                36.9276989
              ],
              [
                58.3665847,
                36.9321586
              ],
              [
                58.3454704,
                36.9348
              ],
              [
                58.3227167,
                36.9445605
              ],
              [
                58.3131959,
                36.939745
              ],
              [
                58.3019936,
                36.9341468
              ],
              [
                58.2978115,
                36.9305869
              ],
              [
                58.2909356,
                36.9262502
              ],
              [
                58.2797298,
                36.9198457
              ],
              [
                58.2763522,
                36.9179427
              ],
              [
                58.2721931,
                36.9156663
              ],
              [
                58.2626539,
                36.9106987
              ],
              [
                58.2475246,
                36.8965927
              ],
              [
                58.2382216,
                36.8893574
              ],
              [
                58.2301291,
                36.8844487
              ],
              [
                58.2261532,
                36.8815633
              ],
              [
                58.2226129,
                36.8795775
              ],
              [
                58.2195107,
                36.8797019
              ],
              [
                58.2178202,
                36.8801677
              ],
              [
                58.2110353,
                36.8790485
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555279,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چناران",
          "name:ar": "مقاطعة تشناران",
          "name:en": "Chenaran County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q784830",
          "wikipedia": "fa:شهرستان چناران"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.7397462,
                36.6613214
              ],
              [
                58.7425987,
                36.6569455
              ],
              [
                58.746651,
                36.6508003
              ],
              [
                58.7506575,
                36.6447331
              ],
              [
                58.7549824,
                36.6382356
              ],
              [
                58.757306,
                36.6346886
              ],
              [
                58.7577803,
                36.6328941
              ],
              [
                58.7591238,
                36.629278
              ],
              [
                58.7571572,
                36.6215556
              ],
              [
                58.7598058,
                36.6161718
              ],
              [
                58.7624237,
                36.6107429
              ],
              [
                58.7645265,
                36.6053753
              ],
              [
                58.7718428,
                36.6046795
              ],
              [
                58.782005,
                36.6019893
              ],
              [
                58.796334,
                36.5950731
              ],
              [
                58.8051519,
                36.5912134
              ],
              [
                58.804125,
                36.5762317
              ],
              [
                58.8035242,
                36.559267
              ],
              [
                58.8207047,
                36.5504496
              ],
              [
                58.8220913,
                36.5498916
              ],
              [
                58.8426512,
                36.5448962
              ],
              [
                58.8507041,
                36.5421149
              ],
              [
                58.8890302,
                36.5354076
              ],
              [
                58.8912501,
                36.5334637
              ],
              [
                58.9021523,
                36.5271874
              ],
              [
                58.9029167,
                36.5268036
              ],
              [
                58.9034766,
                36.5262457
              ],
              [
                58.9070832,
                36.5245806
              ],
              [
                58.9223498,
                36.5190177
              ],
              [
                58.9283026,
                36.5168019
              ],
              [
                58.9465032,
                36.5211181
              ],
              [
                58.9367997,
                36.5347376
              ],
              [
                58.9531174,
                36.5493893
              ],
              [
                58.9810465,
                36.5506037
              ],
              [
                58.9840506,
                36.5599804
              ],
              [
                59.0001867,
                36.5599804
              ],
              [
                59.0298673,
                36.5515549
              ],
              [
                59.052999,
                36.5684591
              ],
              [
                59.0923152,
                36.5575743
              ],
              [
                59.1160582,
                36.5976136
              ],
              [
                59.1232522,
                36.6054666
              ],
              [
                59.1331779,
                36.620141
              ],
              [
                59.1391995,
                36.6179349
              ],
              [
                59.1434911,
                36.6230899
              ],
              [
                59.160615,
                36.622653
              ],
              [
                59.162911,
                36.6252048
              ],
              [
                59.162618,
                36.6269725
              ],
              [
                59.1631782,
                36.6278392
              ],
              [
                59.1517568,
                36.6350301
              ],
              [
                59.1436271,
                36.6384552
              ],
              [
                59.1412067,
                36.6415647
              ],
              [
                59.1401338,
                36.6489333
              ],
              [
                59.1355848,
                36.6502761
              ],
              [
                59.1316795,
                36.6524796
              ],
              [
                59.1342115,
                36.6585735
              ],
              [
                59.1359822,
                36.6614601
              ],
              [
                59.1405722,
                36.6708594
              ],
              [
                59.1390609,
                36.674959
              ],
              [
                59.1371746,
                36.6800735
              ],
              [
                59.1384823,
                36.6848682
              ],
              [
                59.1418678,
                36.6882686
              ],
              [
                59.1508137,
                36.6947501
              ],
              [
                59.1589393,
                36.6954385
              ],
              [
                59.1638551,
                36.6947326
              ],
              [
                59.1716716,
                36.7027989
              ],
              [
                59.1837013,
                36.7043816
              ],
              [
                59.1895354,
                36.7041102
              ],
              [
                59.1974372,
                36.6913099
              ],
              [
                59.201188,
                36.6914357
              ],
              [
                59.2138987,
                36.693891
              ],
              [
                59.2156509,
                36.690725
              ],
              [
                59.22296,
                36.6859033
              ],
              [
                59.2298982,
                36.6841136
              ],
              [
                59.2497703,
                36.681089
              ],
              [
                59.2634304,
                36.6819837
              ],
              [
                59.2711902,
                36.6822176
              ],
              [
                59.2789705,
                36.721481
              ],
              [
                59.2797921,
                36.7233603
              ],
              [
                59.2777088,
                36.7244988
              ],
              [
                59.2698735,
                36.743794
              ],
              [
                59.265747,
                36.7500949
              ],
              [
                59.2656612,
                36.7599286
              ],
              [
                59.2660045,
                36.7674235
              ],
              [
                59.2666053,
                36.7742301
              ],
              [
                59.269266,
                36.7866041
              ],
              [
                59.2696094,
                36.7933403
              ],
              [
                59.2729031,
                36.7970624
              ],
              [
                59.2722701,
                36.8015879
              ],
              [
                59.2743301,
                36.8046117
              ],
              [
                59.2763042,
                36.8063985
              ],
              [
                59.2874621,
                36.8053677
              ],
              [
                59.2930411,
                36.8077729
              ],
              [
                59.2957512,
                36.8107382
              ],
              [
                59.301188,
                36.8139844
              ],
              [
                59.3122672,
                36.8222716
              ],
              [
                59.3183754,
                36.8276454
              ],
              [
                59.3224175,
                36.8328513
              ],
              [
                59.3273258,
                36.8383652
              ],
              [
                59.333038,
                36.8426408
              ],
              [
                59.3290987,
                36.8498488
              ],
              [
                59.3268795,
                36.857319
              ],
              [
                59.326195,
                36.8637786
              ],
              [
                59.32774,
                36.8688302
              ],
              [
                59.3314933,
                36.8731667
              ],
              [
                59.3328783,
                36.8768775
              ],
              [
                59.3330843,
                36.8780236
              ],
              [
                59.3304486,
                36.8844771
              ],
              [
                59.3257856,
                36.8904675
              ],
              [
                59.3219643,
                36.894455
              ],
              [
                59.3119471,
                36.8970036
              ],
              [
                59.30274,
                36.9006951
              ],
              [
                59.2908953,
                36.9057741
              ],
              [
                59.2763899,
                36.9159997
              ],
              [
                59.2666207,
                36.9220927
              ],
              [
                59.2610287,
                36.9269916
              ],
              [
                59.260342,
                36.9353205
              ],
              [
                59.2599962,
                36.9406313
              ],
              [
                59.2605113,
                36.9468051
              ],
              [
                59.2625712,
                36.9507836
              ],
              [
                59.2677785,
                36.9580812
              ],
              [
                59.2696075,
                36.9627734
              ],
              [
                59.2707072,
                36.9702409
              ],
              [
                59.2498589,
                36.9767117
              ],
              [
                59.2488203,
                36.9784951
              ],
              [
                59.2362255,
                36.9734353
              ],
              [
                59.2327071,
                36.9730828
              ],
              [
                59.2169043,
                36.9827797
              ],
              [
                59.2111632,
                36.9847887
              ],
              [
                59.1974059,
                36.9897136
              ],
              [
                59.1892277,
                36.99314
              ],
              [
                59.1723663,
                36.9996991
              ],
              [
                59.1476609,
                37.0120741
              ],
              [
                59.1468272,
                37.0124081
              ],
              [
                59.1442442,
                37.0142144
              ],
              [
                59.1397591,
                37.0170488
              ],
              [
                59.1315716,
                37.0230117
              ],
              [
                59.1234127,
                37.0284027
              ],
              [
                59.1139124,
                37.0326382
              ],
              [
                59.1027095,
                37.0427835
              ],
              [
                59.0885922,
                37.0510674
              ],
              [
                59.0631863,
                37.0576432
              ],
              [
                59.0446469,
                37.0625748
              ],
              [
                59.0333172,
                37.0736695
              ],
              [
                59.0190695,
                37.0894183
              ],
              [
                59.0000149,
                37.1027683
              ],
              [
                58.9907452,
                37.1065332
              ],
              [
                58.9759672,
                37.1103517
              ],
              [
                58.9717769,
                37.1034527
              ],
              [
                58.9693179,
                37.0962233
              ],
              [
                58.9653156,
                37.0827602
              ],
              [
                58.96174,
                37.0734487
              ],
              [
                58.9563082,
                37.0614282
              ],
              [
                58.9498441,
                37.052959
              ],
              [
                58.9489459,
                37.0407913
              ],
              [
                58.9409609,
                37.0230445
              ],
              [
                58.9266298,
                37.0065969
              ],
              [
                58.9163183,
                36.9977249
              ],
              [
                58.9103628,
                36.9852011
              ],
              [
                58.9046656,
                36.9785851
              ],
              [
                58.8997979,
                36.9801572
              ],
              [
                58.8920824,
                36.9812783
              ],
              [
                58.8864134,
                36.9822382
              ],
              [
                58.8814407,
                36.9828847
              ],
              [
                58.8780172,
                36.9841825
              ],
              [
                58.8720134,
                36.9863031
              ],
              [
                58.8654358,
                36.986592
              ],
              [
                58.8617251,
                36.9870472
              ],
              [
                58.8549695,
                36.9880756
              ],
              [
                58.8467774,
                36.987532
              ],
              [
                58.8287628,
                36.9839598
              ],
              [
                58.8181659,
                36.9808609
              ],
              [
                58.8098201,
                36.9784715
              ],
              [
                58.7998534,
                36.9753143
              ],
              [
                58.7840228,
                36.9707711
              ],
              [
                58.7714688,
                36.967174
              ],
              [
                58.7623457,
                36.9560804
              ],
              [
                58.7586033,
                36.9485473
              ],
              [
                58.7532659,
                36.9375035
              ],
              [
                58.7552424,
                36.9248836
              ],
              [
                58.7598093,
                36.9071376
              ],
              [
                58.7601813,
                36.9052435
              ],
              [
                58.7621148,
                36.9010731
              ],
              [
                58.7661477,
                36.8927803
              ],
              [
                58.7687494,
                36.8871571
              ],
              [
                58.7723666,
                36.8819279
              ],
              [
                58.7732177,
                36.8787287
              ],
              [
                58.7769738,
                36.8755143
              ],
              [
                58.7873501,
                36.8730451
              ],
              [
                58.8018936,
                36.8658308
              ],
              [
                58.8077746,
                36.8624358
              ],
              [
                58.8131342,
                36.860019
              ],
              [
                58.8203469,
                36.854979
              ],
              [
                58.8259135,
                36.8507506
              ],
              [
                58.832846,
                36.8430062
              ],
              [
                58.8371085,
                36.8377291
              ],
              [
                58.8401225,
                36.8301866
              ],
              [
                58.84201,
                36.8220758
              ],
              [
                58.8465378,
                36.8208093
              ],
              [
                58.850714,
                36.8197742
              ],
              [
                58.8522827,
                36.8193324
              ],
              [
                58.8546613,
                36.8189846
              ],
              [
                58.857055,
                36.8186067
              ],
              [
                58.8639754,
                36.817503
              ],
              [
                58.8807377,
                36.817749
              ],
              [
                58.8884097,
                36.8179084
              ],
              [
                58.8934192,
                36.8179689
              ],
              [
                58.8938975,
                36.8139762
              ],
              [
                58.8936625,
                36.8115763
              ],
              [
                58.8933824,
                36.8101897
              ],
              [
                58.8922918,
                36.8063687
              ],
              [
                58.8911819,
                36.8032029
              ],
              [
                58.8833936,
                36.7956451
              ],
              [
                58.8759536,
                36.7919175
              ],
              [
                58.8632852,
                36.7830975
              ],
              [
                58.8662051,
                36.7764301
              ],
              [
                58.8716124,
                36.7677673
              ],
              [
                58.8730645,
                36.7648354
              ],
              [
                58.8678571,
                36.7576384
              ],
              [
                58.8614455,
                36.7502528
              ],
              [
                58.8584555,
                36.7476363
              ],
              [
                58.8443127,
                36.7348544
              ],
              [
                58.835089,
                36.7284439
              ],
              [
                58.8294679,
                36.7246277
              ],
              [
                58.8213741,
                36.7191826
              ],
              [
                58.8161323,
                36.7156491
              ],
              [
                58.8115936,
                36.7125462
              ],
              [
                58.8067155,
                36.7093122
              ],
              [
                58.7999374,
                36.7135284
              ],
              [
                58.7912009,
                36.7186531
              ],
              [
                58.773459,
                36.7263681
              ],
              [
                58.7663649,
                36.727924
              ],
              [
                58.7510218,
                36.7308848
              ],
              [
                58.7464758,
                36.7320692
              ],
              [
                58.7390559,
                36.7344429
              ],
              [
                58.7332558,
                36.7351797
              ],
              [
                58.7268435,
                36.7287134
              ],
              [
                58.723796,
                36.7232314
              ],
              [
                58.7229581,
                36.7157172
              ],
              [
                58.7256955,
                36.7009736
              ],
              [
                58.7292663,
                36.6873006
              ],
              [
                58.7370192,
                36.665841
              ],
              [
                58.7397462,
                36.6613214
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555290,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گناباد",
          "name:en": "Gonabad County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1270649",
          "wikipedia": "fa:شهرستان گناباد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.2972266,
                34.4154173
              ],
              [
                58.3003561,
                34.4118222
              ],
              [
                58.294744,
                34.4054215
              ],
              [
                58.2917833,
                34.4006424
              ],
              [
                58.2865741,
                34.3935927
              ],
              [
                58.2856502,
                34.3910591
              ],
              [
                58.2835271,
                34.3847305
              ],
              [
                58.282814,
                34.3811293
              ],
              [
                58.2810971,
                34.3757459
              ],
              [
                58.278737,
                34.3708221
              ],
              [
                58.2777929,
                34.3683425
              ],
              [
                58.274892,
                34.3643139
              ],
              [
                58.2735872,
                34.3592027
              ],
              [
                58.2800251,
                34.3552595
              ],
              [
                58.2881355,
                34.3532153
              ],
              [
                58.2936261,
                34.3504778
              ],
              [
                58.3005308,
                34.3488516
              ],
              [
                58.3032843,
                34.3441096
              ],
              [
                58.3060309,
                34.3396449
              ],
              [
                58.3078333,
                34.3378376
              ],
              [
                58.3039712,
                34.3351442
              ],
              [
                58.3039712,
                34.3317066
              ],
              [
                58.3166313,
                34.328836
              ],
              [
                58.3176735,
                34.3222322
              ],
              [
                58.3187845,
                34.3162463
              ],
              [
                58.3218615,
                34.3063884
              ],
              [
                58.3270347,
                34.3064324
              ],
              [
                58.3323063,
                34.3065599
              ],
              [
                58.3348046,
                34.3065924
              ],
              [
                58.3381567,
                34.3066744
              ],
              [
                58.3413405,
                34.3069474
              ],
              [
                58.3458369,
                34.3074126
              ],
              [
                58.3613631,
                34.3105302
              ],
              [
                58.3632444,
                34.305363
              ],
              [
                58.3650814,
                34.2986035
              ],
              [
                58.3658978,
                34.2916868
              ],
              [
                58.3718204,
                34.288141
              ],
              [
                58.3786422,
                34.2818634
              ],
              [
                58.3838352,
                34.275102
              ],
              [
                58.3853816,
                34.2716162
              ],
              [
                58.3941755,
                34.2631686
              ],
              [
                58.3986895,
                34.2590667
              ],
              [
                58.4038992,
                34.2552993
              ],
              [
                58.4146198,
                34.2533691
              ],
              [
                58.4148982,
                34.2467382
              ],
              [
                58.4149074,
                34.2418919
              ],
              [
                58.4178256,
                34.2313192
              ],
              [
                58.4191346,
                34.2251806
              ],
              [
                58.4188342,
                34.2245952
              ],
              [
                58.4191131,
                34.2232468
              ],
              [
                58.4172214,
                34.2191257
              ],
              [
                58.418355,
                34.2165393
              ],
              [
                58.4195725,
                34.2158732
              ],
              [
                58.4216022,
                34.2149962
              ],
              [
                58.4237816,
                34.2127084
              ],
              [
                58.4306144,
                34.2002673
              ],
              [
                58.4330177,
                34.1959369
              ],
              [
                58.4343051,
                34.1948365
              ],
              [
                58.4331464,
                34.1925647
              ],
              [
                58.4324169,
                34.1902573
              ],
              [
                58.4316444,
                34.1863524
              ],
              [
                58.4359778,
                34.1815256
              ],
              [
                58.4384621,
                34.1783383
              ],
              [
                58.4431379,
                34.1738136
              ],
              [
                58.4424162,
                34.1727547
              ],
              [
                58.4432316,
                34.1721334
              ],
              [
                58.4435534,
                34.1707486
              ],
              [
                58.4435963,
                34.1683874
              ],
              [
                58.4447336,
                34.1653159
              ],
              [
                58.4450984,
                34.1645347
              ],
              [
                58.4452056,
                34.1616052
              ],
              [
                58.4469222,
                34.1577167
              ],
              [
                58.4671783,
                34.138307
              ],
              [
                58.4608268,
                34.1236003
              ],
              [
                58.4582519,
                34.1201897
              ],
              [
                58.4579085,
                34.1137233
              ],
              [
                58.4636163,
                34.1003627
              ],
              [
                58.4651613,
                34.0902697
              ],
              [
                58.4662771,
                34.0854716
              ],
              [
                58.4659338,
                34.0849296
              ],
              [
                58.46632,
                34.0836945
              ],
              [
                58.4654059,
                34.0815654
              ],
              [
                58.4694314,
                34.0815352
              ],
              [
                58.4739053,
                34.0807888
              ],
              [
                58.4774351,
                34.0796336
              ],
              [
                58.4860611,
                34.0780074
              ],
              [
                58.4912967,
                34.0756613
              ],
              [
                58.4939575,
                34.0764433
              ],
              [
                58.4950733,
                34.0774742
              ],
              [
                58.4963607,
                34.0777585
              ],
              [
                58.4988066,
                34.0799981
              ],
              [
                58.5124966,
                34.0901989
              ],
              [
                58.5245129,
                34.0811
              ],
              [
                58.542709,
                34.0762658
              ],
              [
                58.5560986,
                34.058633
              ],
              [
                58.5736728,
                34.0513003
              ],
              [
                58.6007306,
                34.0569264
              ],
              [
                58.6239816,
                34.0579138
              ],
              [
                58.6347347,
                34.0637928
              ],
              [
                58.6445614,
                34.0736577
              ],
              [
                58.6462279,
                34.074208
              ],
              [
                58.6473412,
                34.0744967
              ],
              [
                58.6481748,
                34.0744967
              ],
              [
                58.6509545,
                34.0761566
              ],
              [
                58.6559547,
                34.0836526
              ],
              [
                58.6562277,
                34.0839233
              ],
              [
                58.6578946,
                34.0875405
              ],
              [
                58.6692076,
                34.0878731
              ],
              [
                58.6725409,
                34.09703
              ],
              [
                58.6847031,
                34.105881
              ],
              [
                58.6861909,
                34.1082827
              ],
              [
                58.6940776,
                34.1064393
              ],
              [
                58.7057745,
                34.099937
              ],
              [
                58.7077145,
                34.099937
              ],
              [
                58.7085476,
                34.1002078
              ],
              [
                58.7118809,
                34.099937
              ],
              [
                58.7127141,
                34.0996573
              ],
              [
                58.7138275,
                34.0996572
              ],
              [
                58.7143809,
                34.0993774
              ],
              [
                58.7152142,
                34.0993774
              ],
              [
                58.7163274,
                34.0988268
              ],
              [
                58.7185475,
                34.0982672
              ],
              [
                58.748827,
                34.0893767
              ],
              [
                58.8079997,
                34.0946568
              ],
              [
                58.8113329,
                34.0985469
              ],
              [
                58.8213328,
                34.1063272
              ],
              [
                58.8249462,
                34.1082677
              ],
              [
                58.8468926,
                34.1129882
              ],
              [
                58.8477259,
                34.113268
              ],
              [
                58.8763125,
                34.0879617
              ],
              [
                58.8777059,
                34.0876818
              ],
              [
                58.8790923,
                34.0876818
              ],
              [
                58.8796458,
                34.0874019
              ],
              [
                58.8810392,
                34.0874019
              ],
              [
                58.8877057,
                34.0860115
              ],
              [
                58.8893722,
                34.0860115
              ],
              [
                58.8938121,
                34.0849009
              ],
              [
                58.8949254,
                34.0849009
              ],
              [
                58.9581295,
                34.0793939
              ],
              [
                58.9741776,
                34.0949408
              ],
              [
                58.9894575,
                34.0988308
              ],
              [
                58.9964509,
                34.1211839
              ],
              [
                58.997284,
                34.1217432
              ],
              [
                58.999231,
                34.1222937
              ],
              [
                59.0311905,
                34.1338057
              ],
              [
                59.0314705,
                34.1340765
              ],
              [
                59.0317439,
                34.1343562
              ],
              [
                59.0323037,
                34.134636
              ],
              [
                59.0323037,
                34.1349156
              ],
              [
                59.0328573,
                34.1349157
              ],
              [
                59.0331373,
                34.1351864
              ],
              [
                59.0481369,
                34.1338057
              ],
              [
                59.0489705,
                34.1335259
              ],
              [
                59.0525768,
                34.1335259
              ],
              [
                59.053137,
                34.1332462
              ],
              [
                59.0536901,
                34.1335258
              ],
              [
                59.0545238,
                34.1332462
              ],
              [
                59.0667502,
                34.1332461
              ],
              [
                59.0678568,
                34.1335258
              ],
              [
                59.0759168,
                34.1335258
              ],
              [
                59.0767499,
                34.1332461
              ],
              [
                59.101903,
                34.1218781
              ],
              [
                59.1032893,
                34.1221579
              ],
              [
                59.1113493,
                34.1216073
              ],
              [
                59.1132891,
                34.1210477
              ],
              [
                59.1155161,
                34.1210477
              ],
              [
                59.1199556,
                34.120488
              ],
              [
                59.1342541,
                34.1137946
              ],
              [
                59.1552352,
                34.1185475
              ],
              [
                59.162462,
                34.1190981
              ],
              [
                59.1627355,
                34.1193778
              ],
              [
                59.1641288,
                34.1193778
              ],
              [
                59.1644019,
                34.1196576
              ],
              [
                59.1657953,
                34.1196577
              ],
              [
                59.179916,
                34.1245952
              ],
              [
                59.1899116,
                34.1175212
              ],
              [
                59.1904652,
                34.1175212
              ],
              [
                59.2134686,
                34.1158542
              ],
              [
                59.2140287,
                34.1161341
              ],
              [
                59.2145822,
                34.1161343
              ],
              [
                59.2148623,
                34.1164141
              ],
              [
                59.219582,
                34.1169649
              ],
              [
                59.2215289,
                34.1161341
              ],
              [
                59.2223621,
                34.1161341
              ],
              [
                59.2248622,
                34.1150236
              ],
              [
                59.2490283,
                34.094464
              ],
              [
                59.2501415,
                34.0939042
              ],
              [
                59.2504149,
                34.0933535
              ],
              [
                59.2576417,
                34.0891818
              ],
              [
                59.259028,
                34.088631
              ],
              [
                59.2907938,
                34.0860941
              ],
              [
                59.291907,
                34.0855393
              ],
              [
                59.3030136,
                34.0805411
              ],
              [
                59.3466329,
                34.1082668
              ],
              [
                59.347193,
                34.1079869
              ],
              [
                59.349413,
                34.1079869
              ],
              [
                59.3499661,
                34.1077071
              ],
              [
                59.3753322,
                34.1168924
              ],
              [
                59.3758853,
                34.1171722
              ],
              [
                59.3764455,
                34.1171722
              ],
              [
                59.363937,
                34.1456241
              ],
              [
                59.3587872,
                34.1791458
              ],
              [
                59.3625637,
                34.1941978
              ],
              [
                59.3855031,
                34.2108929
              ],
              [
                59.3919126,
                34.2341008
              ],
              [
                59.4280648,
                34.3416407
              ],
              [
                59.4161217,
                34.3598764
              ],
              [
                59.4250481,
                34.3870799
              ],
              [
                59.4483941,
                34.4154075
              ],
              [
                59.4394677,
                34.4624101
              ],
              [
                59.4236749,
                34.4788265
              ],
              [
                59.4229662,
                34.5179961
              ],
              [
                59.4232464,
                34.5188343
              ],
              [
                59.4232463,
                34.5205014
              ],
              [
                59.4229663,
                34.520222
              ],
              [
                59.4207462,
                34.5202221
              ],
              [
                59.3336518,
                34.5296464
              ],
              [
                59.2863129,
                34.519311
              ],
              [
                59.2826994,
                34.5201408
              ],
              [
                59.2165541,
                34.5195212
              ],
              [
                59.2104406,
                34.5203511
              ],
              [
                59.1823806,
                34.5289667
              ],
              [
                59.1732145,
                34.5342441
              ],
              [
                59.1721078,
                34.5347944
              ],
              [
                59.1668276,
                34.5403516
              ],
              [
                59.1407769,
                34.5738647
              ],
              [
                59.1148292,
                34.5914057
              ],
              [
                59.1131624,
                34.5986226
              ],
              [
                59.0896222,
                34.6349031
              ],
              [
                59.0741726,
                34.6515679
              ],
              [
                59.0697094,
                34.6665351
              ],
              [
                59.0765759,
                34.6936387
              ],
              [
                59.0741301,
                34.7002038
              ],
              [
                59.0621563,
                34.7102917
              ],
              [
                59.0587231,
                34.7455623
              ],
              [
                59.0548276,
                34.7504065
              ],
              [
                59.0554998,
                34.7757402
              ],
              [
                59.0543865,
                34.7757401
              ],
              [
                59.0529999,
                34.7757402
              ],
              [
                59.0513334,
                34.7762906
              ],
              [
                59.0504997,
                34.7765704
              ],
              [
                59.0455,
                34.7790702
              ],
              [
                59.0443867,
                34.7796207
              ],
              [
                59.0271737,
                34.7846918
              ],
              [
                59.026894,
                34.7849717
              ],
              [
                59.0257873,
                34.7849716
              ],
              [
                59.024674,
                34.7855311
              ],
              [
                59.0013882,
                34.7847657
              ],
              [
                58.986282,
                34.7811
              ],
              [
                58.966026,
                34.7892771
              ],
              [
                58.9263601,
                34.7886215
              ],
              [
                58.9255264,
                34.7889012
              ],
              [
                58.9227467,
                34.7889012
              ],
              [
                58.92164,
                34.7886215
              ],
              [
                58.9202467,
                34.7886216
              ],
              [
                58.9177466,
                34.7880711
              ],
              [
                58.9160802,
                34.7880711
              ],
              [
                58.9135801,
                34.7875116
              ],
              [
                58.8878089,
                34.7813787
              ],
              [
                58.851871,
                34.7748223
              ],
              [
                58.8363843,
                34.772573
              ],
              [
                58.8219905,
                34.7689202
              ],
              [
                58.8056438,
                34.7682957
              ],
              [
                58.7954592,
                34.7664667
              ],
              [
                58.7847515,
                34.7701576
              ],
              [
                58.7806355,
                34.7728431
              ],
              [
                58.7614369,
                34.7646337
              ],
              [
                58.7581228,
                34.7635898
              ],
              [
                58.7474879,
                34.7633952
              ],
              [
                58.7447684,
                34.7689301
              ],
              [
                58.7134226,
                34.7593039
              ],
              [
                58.7125894,
                34.7595835
              ],
              [
                58.6995928,
                34.7505572
              ],
              [
                58.6782762,
                34.7207719
              ],
              [
                58.6740956,
                34.7165343
              ],
              [
                58.6627005,
                34.710856
              ],
              [
                58.6536024,
                34.7085982
              ],
              [
                58.6347934,
                34.7084661
              ],
              [
                58.6247937,
                34.7112566
              ],
              [
                58.6239604,
                34.7114661
              ],
              [
                58.6239604,
                34.7093061
              ],
              [
                58.6193889,
                34.7012871
              ],
              [
                58.6188353,
                34.6999053
              ],
              [
                58.6160506,
                34.6951752
              ],
              [
                58.6157705,
                34.6935134
              ],
              [
                58.6032736,
                34.6801398
              ],
              [
                58.5972703,
                34.6768623
              ],
              [
                58.5892055,
                34.6605926
              ],
              [
                58.5768698,
                34.6546744
              ],
              [
                58.5677717,
                34.6481786
              ],
              [
                58.5548914,
                34.6380629
              ],
              [
                58.550949,
                34.6360328
              ],
              [
                58.5492344,
                34.6339625
              ],
              [
                58.5350355,
                34.6237529
              ],
              [
                58.5351912,
                34.6053165
              ],
              [
                58.5294055,
                34.6041772
              ],
              [
                58.5270022,
                34.6029056
              ],
              [
                58.5258864,
                34.6009981
              ],
              [
                58.523811,
                34.5929574
              ],
              [
                58.5179042,
                34.5848177
              ],
              [
                58.5137843,
                34.5818498
              ],
              [
                58.5072611,
                34.5834045
              ],
              [
                58.4985506,
                34.5816186
              ],
              [
                58.4752463,
                34.5735816
              ],
              [
                58.4775637,
                34.5630507
              ],
              [
                58.4651183,
                34.5493372
              ],
              [
                58.4537838,
                34.5372198
              ],
              [
                58.4501956,
                34.5316065
              ],
              [
                58.448408,
                34.5206299
              ],
              [
                58.4468576,
                34.5031341
              ],
              [
                58.4463677,
                34.4873691
              ],
              [
                58.4429377,
                34.4818958
              ],
              [
                58.4308644,
                34.4607753
              ],
              [
                58.4131049,
                34.4525725
              ],
              [
                58.4104013,
                34.4497059
              ],
              [
                58.4068788,
                34.4467784
              ],
              [
                58.4024904,
                34.4435415
              ],
              [
                58.3965498,
                34.439494
              ],
              [
                58.3838126,
                34.4421677
              ],
              [
                58.3815926,
                34.4421676
              ],
              [
                58.3813125,
                34.4418879
              ],
              [
                58.3782593,
                34.4418879
              ],
              [
                58.3765926,
                34.4413374
              ],
              [
                58.350056,
                34.4314338
              ],
              [
                58.3497758,
                34.4317135
              ],
              [
                58.3492227,
                34.4314338
              ],
              [
                58.3470027,
                34.4314338
              ],
              [
                58.3461696,
                34.4314338
              ],
              [
                58.3431092,
                34.4314338
              ],
              [
                58.3428362,
                34.4317135
              ],
              [
                58.3428363,
                34.4314338
              ],
              [
                58.3356095,
                34.4258743
              ],
              [
                58.2972266,
                34.4154173
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555647,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان صالح آباد",
          "name:en": "Saleh Abad County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q5705037"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.5803945,
                35.9637587
              ],
              [
                60.571483,
                35.9619253
              ],
              [
                60.5599977,
                35.9533152
              ],
              [
                60.5587003,
                35.9402124
              ],
              [
                60.5425641,
                35.930761
              ],
              [
                60.5473181,
                35.9233016
              ],
              [
                60.547318,
                35.921634
              ],
              [
                60.5521044,
                35.9224736
              ],
              [
                60.5487711,
                35.9152541
              ],
              [
                60.5484977,
                35.914416
              ],
              [
                60.5482176,
                35.9141455
              ],
              [
                60.5443311,
                35.9016443
              ],
              [
                60.5415509,
                35.8921983
              ],
              [
                60.5398845,
                35.8852581
              ],
              [
                60.5412708,
                35.8777499
              ],
              [
                60.541831,
                35.877191
              ],
              [
                60.5512458,
                35.8578958
              ],
              [
                60.5545791,
                35.8534431
              ],
              [
                60.5722614,
                35.8507963
              ],
              [
                60.5742801,
                35.8405443
              ],
              [
                60.5715441,
                35.8344254
              ],
              [
                60.5721044,
                35.8335962
              ],
              [
                60.5837956,
                35.8151082
              ],
              [
                60.585462,
                35.8087263
              ],
              [
                60.5879621,
                35.8028942
              ],
              [
                60.5882354,
                35.7992794
              ],
              [
                60.587962,
                35.7981708
              ],
              [
                60.587962,
                35.7967826
              ],
              [
                60.5886553,
                35.7837722
              ],
              [
                60.5836769,
                35.7754166
              ],
              [
                60.5906294,
                35.7678258
              ],
              [
                60.5846209,
                35.7493132
              ],
              [
                60.5846209,
                35.7465364
              ],
              [
                60.584942,
                35.7396492
              ],
              [
                60.5852217,
                35.7393788
              ],
              [
                60.6046597,
                35.7273575
              ],
              [
                60.6068791,
                35.7251304
              ],
              [
                60.6236759,
                35.7140985
              ],
              [
                60.6292292,
                35.7113216
              ],
              [
                60.6320096,
                35.709383
              ],
              [
                60.6353425,
                35.7077151
              ],
              [
                60.6372894,
                35.7063175
              ],
              [
                60.639509,
                35.7052085
              ],
              [
                60.6403426,
                35.7043791
              ],
              [
                60.6422895,
                35.70327
              ],
              [
                60.6565635,
                35.691667
              ],
              [
                60.6600687,
                35.688817
              ],
              [
                60.680122,
                35.6653014
              ],
              [
                60.6840158,
                35.6597397
              ],
              [
                60.6845689,
                35.6591898
              ],
              [
                60.6854018,
                35.6575222
              ],
              [
                60.6897618,
                35.6232681
              ],
              [
                60.6978151,
                35.6141072
              ],
              [
                60.7177284,
                35.6071909
              ],
              [
                60.7185612,
                35.6055319
              ],
              [
                60.7249481,
                35.5963627
              ],
              [
                60.7406511,
                35.5718812
              ],
              [
                60.7516476,
                35.5568093
              ],
              [
                60.7640072,
                35.5512229
              ],
              [
                60.7774797,
                35.5447822
              ],
              [
                60.7774797,
                35.5436734
              ],
              [
                60.7788735,
                35.5345054
              ],
              [
                60.7847863,
                35.522849
              ],
              [
                60.7821682,
                35.5180484
              ],
              [
                60.7920129,
                35.5084161
              ],
              [
                60.7960324,
                35.5054817
              ],
              [
                60.8033118,
                35.5001712
              ],
              [
                60.807852,
                35.4920289
              ],
              [
                60.8152484,
                35.4911451
              ],
              [
                60.8216617,
                35.4932687
              ],
              [
                60.8300972,
                35.4821645
              ],
              [
                60.8320283,
                35.4760837
              ],
              [
                60.8357026,
                35.4721787
              ],
              [
                60.8382121,
                35.4662021
              ],
              [
                60.8574492,
                35.4572707
              ],
              [
                60.8685163,
                35.4569212
              ],
              [
                60.8780077,
                35.4582845
              ],
              [
                60.8893584,
                35.4579958
              ],
              [
                60.8931398,
                35.4562306
              ],
              [
                60.8970451,
                35.4520356
              ],
              [
                60.8969591,
                35.4477706
              ],
              [
                60.903182,
                35.4460224
              ],
              [
                60.9059714,
                35.4457778
              ],
              [
                60.9107779,
                35.4429109
              ],
              [
                60.9274349,
                35.4367643
              ],
              [
                60.9320555,
                35.431378
              ],
              [
                60.9320639,
                35.4220704
              ],
              [
                60.9358404,
                35.4143762
              ],
              [
                60.9366987,
                35.4038829
              ],
              [
                60.9423636,
                35.3938081
              ],
              [
                60.9588431,
                35.3869509
              ],
              [
                60.9636496,
                35.3816327
              ],
              [
                60.981674,
                35.3747745
              ],
              [
                60.9986593,
                35.3684254
              ],
              [
                61.0011002,
                35.3652543
              ],
              [
                61.0083,
                35.3614609
              ],
              [
                61.0213279,
                35.3608812
              ],
              [
                61.027379,
                35.3613361
              ],
              [
                61.0293102,
                35.3620011
              ],
              [
                61.0309839,
                35.3620011
              ],
              [
                61.0336875,
                35.3646609
              ],
              [
                61.0363483,
                35.3664807
              ],
              [
                61.0384512,
                35.3664457
              ],
              [
                61.0412833,
                35.3678458
              ],
              [
                61.0461759,
                35.3669707
              ],
              [
                61.0520553,
                35.3667257
              ],
              [
                61.0560035,
                35.3685455
              ],
              [
                61.0621833,
                35.3742145
              ],
              [
                61.0629987,
                35.3772938
              ],
              [
                61.0690498,
                35.3811077
              ],
              [
                61.0722255,
                35.3841518
              ],
              [
                61.0744568,
                35.3848518
              ],
              [
                61.0822677,
                35.383732
              ],
              [
                61.0962579,
                35.3792535
              ],
              [
                61.108567,
                35.379545
              ],
              [
                61.1106197,
                35.3809902
              ],
              [
                61.1161645,
                35.3788565
              ],
              [
                61.1218476,
                35.3753321
              ],
              [
                61.1259978,
                35.3712055
              ],
              [
                61.1344528,
                35.3675656
              ],
              [
                61.1386073,
                35.3658759
              ],
              [
                61.1478742,
                35.3588431
              ],
              [
                61.153713,
                35.3567782
              ],
              [
                61.1737888,
                35.3545663
              ],
              [
                61.177085,
                35.353591
              ],
              [
                61.176977,
                35.354108
              ],
              [
                61.17672,
                35.354598
              ],
              [
                61.176201,
                35.356365
              ],
              [
                61.176287,
                35.356743
              ],
              [
                61.17652,
                35.356987
              ],
              [
                61.177685,
                35.357816
              ],
              [
                61.178585,
                35.358233
              ],
              [
                61.179049,
                35.358272
              ],
              [
                61.179306,
                35.35815
              ],
              [
                61.179439,
                35.357947
              ],
              [
                61.180162,
                35.357442
              ],
              [
                61.180515,
                35.357325
              ],
              [
                61.180779,
                35.35729
              ],
              [
                61.18172,
                35.357548
              ],
              [
                61.183596,
                35.357778
              ],
              [
                61.184444,
                35.35781
              ],
              [
                61.185537,
                35.358022
              ],
              [
                61.185812,
                35.35814
              ],
              [
                61.185885,
                35.358331
              ],
              [
                61.185528,
                35.358835
              ],
              [
                61.185396,
                35.359224
              ],
              [
                61.185369,
                35.359776
              ],
              [
                61.185435,
                35.360198
              ],
              [
                61.185628,
                35.360629
              ],
              [
                61.18588,
                35.361455
              ],
              [
                61.186252,
                35.363453
              ],
              [
                61.186425,
                35.363909
              ],
              [
                61.186386,
                35.364126
              ],
              [
                61.18616,
                35.364341
              ],
              [
                61.18607,
                35.364642
              ],
              [
                61.186044,
                35.365037
              ],
              [
                61.185204,
                35.365915
              ],
              [
                61.185048,
                35.366707
              ],
              [
                61.184784,
                35.367375
              ],
              [
                61.184549,
                35.368186
              ],
              [
                61.184035,
                35.369109
              ],
              [
                61.183979,
                35.369543
              ],
              [
                61.184018,
                35.36991
              ],
              [
                61.184208,
                35.370729
              ],
              [
                61.184398,
                35.370953
              ],
              [
                61.185109,
                35.37139
              ],
              [
                61.186266,
                35.371597
              ],
              [
                61.186931,
                35.371773
              ],
              [
                61.187427,
                35.372151
              ],
              [
                61.188718,
                35.372949
              ],
              [
                61.188981,
                35.373296
              ],
              [
                61.189072,
                35.3737
              ],
              [
                61.188965,
                35.373908
              ],
              [
                61.188998,
                35.37419
              ],
              [
                61.189177,
                35.374656
              ],
              [
                61.19013,
                35.37538
              ],
              [
                61.192089,
                35.376035
              ],
              [
                61.193096,
                35.376261
              ],
              [
                61.19394,
                35.376183
              ],
              [
                61.194486,
                35.376058
              ],
              [
                61.194986,
                35.37557
              ],
              [
                61.195564,
                35.374421
              ],
              [
                61.195917,
                35.373992
              ],
              [
                61.197727,
                35.373163
              ],
              [
                61.199122,
                35.372872
              ],
              [
                61.199646,
                35.372677
              ],
              [
                61.199826,
                35.372689
              ],
              [
                61.200429,
                35.373588
              ],
              [
                61.200455,
                35.374249
              ],
              [
                61.200244,
                35.375681
              ],
              [
                61.199448,
                35.377334
              ],
              [
                61.198845,
                35.378009
              ],
              [
                61.198517,
                35.378307
              ],
              [
                61.197859,
                35.378451
              ],
              [
                61.195366,
                35.378622
              ],
              [
                61.194911,
                35.378816
              ],
              [
                61.194306,
                35.379152
              ],
              [
                61.193958,
                35.379462
              ],
              [
                61.193372,
                35.38026
              ],
              [
                61.193012,
                35.380473
              ],
              [
                61.192981,
                35.380707
              ],
              [
                61.193781,
                35.382305
              ],
              [
                61.194183,
                35.382709
              ],
              [
                61.194697,
                35.382774
              ],
              [
                61.195043,
                35.382753
              ],
              [
                61.195533,
                35.383005
              ],
              [
                61.195901,
                35.383378
              ],
              [
                61.196019,
                35.383681
              ],
              [
                61.196471,
                35.384016
              ],
              [
                61.198791,
                35.384735
              ],
              [
                61.199501,
                35.385186
              ],
              [
                61.199845,
                35.385676
              ],
              [
                61.200129,
                35.386341
              ],
              [
                61.200346,
                35.386971
              ],
              [
                61.200558,
                35.387843
              ],
              [
                61.200489,
                35.388443
              ],
              [
                61.200264,
                35.38896
              ],
              [
                61.200001,
                35.389289
              ],
              [
                61.199609,
                35.389558
              ],
              [
                61.198731,
                35.390049
              ],
              [
                61.198114,
                35.390149
              ],
              [
                61.197759,
                35.390087
              ],
              [
                61.197344,
                35.389798
              ],
              [
                61.196991,
                35.389468
              ],
              [
                61.196215,
                35.388434
              ],
              [
                61.196045,
                35.387815
              ],
              [
                61.195876,
                35.386545
              ],
              [
                61.195715,
                35.38605
              ],
              [
                61.195531,
                35.385595
              ],
              [
                61.195153,
                35.385218
              ],
              [
                61.194783,
                35.385052
              ],
              [
                61.1945,
                35.385129
              ],
              [
                61.19368,
                35.384982
              ],
              [
                61.19302,
                35.384944
              ],
              [
                61.192491,
                35.385065
              ],
              [
                61.191753,
                35.385422
              ],
              [
                61.191556,
                35.385619
              ],
              [
                61.191503,
                35.385985
              ],
              [
                61.191915,
                35.386394
              ],
              [
                61.191961,
                35.386668
              ],
              [
                61.192417,
                35.38741
              ],
              [
                61.193456,
                35.388503
              ],
              [
                61.193827,
                35.389104
              ],
              [
                61.194147,
                35.389457
              ],
              [
                61.194422,
                35.390176
              ],
              [
                61.194433,
                35.390358
              ],
              [
                61.194178,
                35.390726
              ],
              [
                61.194063,
                35.391011
              ],
              [
                61.193838,
                35.391225
              ],
              [
                61.193632,
                35.391546
              ],
              [
                61.193281,
                35.391895
              ],
              [
                61.192903,
                35.392559
              ],
              [
                61.192601,
                35.392926
              ],
              [
                61.19189,
                35.393543
              ],
              [
                61.191715,
                35.393755
              ],
              [
                61.191631,
                35.394319
              ],
              [
                61.191024,
                35.395318
              ],
              [
                61.190263,
                35.395789
              ],
              [
                61.189996,
                35.396193
              ],
              [
                61.18911,
                35.39677
              ],
              [
                61.188515,
                35.397006
              ],
              [
                61.188287,
                35.397223
              ],
              [
                61.187932,
                35.397433
              ],
              [
                61.187391,
                35.398387
              ],
              [
                61.187338,
                35.398589
              ],
              [
                61.187459,
                35.399592
              ],
              [
                61.187829,
                35.400039
              ],
              [
                61.188524,
                35.400423
              ],
              [
                61.189449,
                35.401243
              ],
              [
                61.189812,
                35.40143
              ],
              [
                61.190421,
                35.402006
              ],
              [
                61.191045,
                35.402699
              ],
              [
                61.191635,
                35.403134
              ],
              [
                61.191886,
                35.403412
              ],
              [
                61.191967,
                35.403788
              ],
              [
                61.192683,
                35.405126
              ],
              [
                61.192967,
                35.405442
              ],
              [
                61.193368,
                35.40567
              ],
              [
                61.194011,
                35.406705
              ],
              [
                61.194462,
                35.407062
              ],
              [
                61.195094,
                35.407508
              ],
              [
                61.196505,
                35.407413
              ],
              [
                61.197657,
                35.407447
              ],
              [
                61.197985,
                35.407637
              ],
              [
                61.198784,
                35.409177
              ],
              [
                61.198834,
                35.409564
              ],
              [
                61.199057,
                35.409885
              ],
              [
                61.199345,
                35.41098
              ],
              [
                61.199523,
                35.411393
              ],
              [
                61.200189,
                35.411875
              ],
              [
                61.200604,
                35.412072
              ],
              [
                61.201413,
                35.412207
              ],
              [
                61.202138,
                35.412421
              ],
              [
                61.202967,
                35.412595
              ],
              [
                61.203666,
                35.412864
              ],
              [
                61.204343,
                35.412993
              ],
              [
                61.204998,
                35.412956
              ],
              [
                61.206776,
                35.411862
              ],
              [
                61.207294,
                35.411702
              ],
              [
                61.207893,
                35.411737
              ],
              [
                61.208275,
                35.41193
              ],
              [
                61.209416,
                35.412009
              ],
              [
                61.210451,
                35.412346
              ],
              [
                61.210822,
                35.412517
              ],
              [
                61.211056,
                35.412915
              ],
              [
                61.212085,
                35.414176
              ],
              [
                61.212878,
                35.414843
              ],
              [
                61.213233,
                35.41533
              ],
              [
                61.213236,
                35.415785
              ],
              [
                61.213607,
                35.417215
              ],
              [
                61.213585,
                35.418471
              ],
              [
                61.213784,
                35.419018
              ],
              [
                61.213965,
                35.419356
              ],
              [
                61.213947,
                35.419646
              ],
              [
                61.214398,
                35.420043
              ],
              [
                61.215675,
                35.420455
              ],
              [
                61.216857,
                35.421184
              ],
              [
                61.217279,
                35.421264
              ],
              [
                61.217724,
                35.421155
              ],
              [
                61.218581,
                35.420569
              ],
              [
                61.219044,
                35.420391
              ],
              [
                61.22015,
                35.420138
              ],
              [
                61.221007,
                35.419887
              ],
              [
                61.221761,
                35.419749
              ],
              [
                61.222139,
                35.419858
              ],
              [
                61.222419,
                35.420358
              ],
              [
                61.223292,
                35.420564
              ],
              [
                61.224768,
                35.420759
              ],
              [
                61.225988,
                35.421101
              ],
              [
                61.226716,
                35.421256
              ],
              [
                61.227161,
                35.421655
              ],
              [
                61.227087,
                35.421967
              ],
              [
                61.227093,
                35.422664
              ],
              [
                61.227361,
                35.423042
              ],
              [
                61.227475,
                35.423486
              ],
              [
                61.227716,
                35.42397
              ],
              [
                61.228156,
                35.424196
              ],
              [
                61.228409,
                35.424401
              ],
              [
                61.2286,
                35.424711
              ],
              [
                61.228774,
                35.425255
              ],
              [
                61.229538,
                35.426125
              ],
              [
                61.229881,
                35.427097
              ],
              [
                61.230348,
                35.429118
              ],
              [
                61.230627,
                35.429709
              ],
              [
                61.230973,
                35.43033
              ],
              [
                61.231695,
                35.431158
              ],
              [
                61.232309,
                35.431726
              ],
              [
                61.232771,
                35.432481
              ],
              [
                61.232936,
                35.43312
              ],
              [
                61.232796,
                35.433371
              ],
              [
                61.232433,
                35.43356
              ],
              [
                61.2321,
                35.434014
              ],
              [
                61.231505,
                35.434573
              ],
              [
                61.230983,
                35.434941
              ],
              [
                61.23043,
                35.435222
              ],
              [
                61.229781,
                35.435422
              ],
              [
                61.228537,
                35.436057
              ],
              [
                61.227888,
                35.436882
              ],
              [
                61.227105,
                35.43748
              ],
              [
                61.226853,
                35.437846
              ],
              [
                61.226265,
                35.438261
              ],
              [
                61.225401,
                35.43855
              ],
              [
                61.224636,
                35.438971
              ],
              [
                61.223997,
                35.439468
              ],
              [
                61.222863,
                35.440747
              ],
              [
                61.222568,
                35.441177
              ],
              [
                61.22207,
                35.442909
              ],
              [
                61.222263,
                35.443312
              ],
              [
                61.222625,
                35.443882
              ],
              [
                61.223197,
                35.444385
              ],
              [
                61.223783,
                35.445258
              ],
              [
                61.224273,
                35.445739
              ],
              [
                61.225093,
                35.44631
              ],
              [
                61.225919,
                35.446736
              ],
              [
                61.228331,
                35.447815
              ],
              [
                61.229067,
                35.448427
              ],
              [
                61.229713,
                35.448775
              ],
              [
                61.230346,
                35.448978
              ],
              [
                61.231184,
                35.449082
              ],
              [
                61.231924,
                35.449096
              ],
              [
                61.232685,
                35.448947
              ],
              [
                61.234745,
                35.449269
              ],
              [
                61.235515,
                35.44951
              ],
              [
                61.235808,
                35.449811
              ],
              [
                61.235825,
                35.450172
              ],
              [
                61.23563,
                35.450752
              ],
              [
                61.23547,
                35.451707
              ],
              [
                61.235072,
                35.452966
              ],
              [
                61.23507,
                35.453237
              ],
              [
                61.235305,
                35.453695
              ],
              [
                61.235502,
                35.453951
              ],
              [
                61.235755,
                35.454717
              ],
              [
                61.236028,
                35.454957
              ],
              [
                61.236692,
                35.455832
              ],
              [
                61.236868,
                35.456571
              ],
              [
                61.237027,
                35.457996
              ],
              [
                61.236847,
                35.458675
              ],
              [
                61.236403,
                35.459461
              ],
              [
                61.235663,
                35.460022
              ],
              [
                61.234992,
                35.460389
              ],
              [
                61.234034,
                35.461607
              ],
              [
                61.233745,
                35.462285
              ],
              [
                61.234173,
                35.463115
              ],
              [
                61.23455,
                35.46362
              ],
              [
                61.235041,
                35.463946
              ],
              [
                61.236181,
                35.464413
              ],
              [
                61.236356,
                35.46468
              ],
              [
                61.236865,
                35.46514
              ],
              [
                61.237514,
                35.466027
              ],
              [
                61.237398,
                35.46636
              ],
              [
                61.237526,
                35.466697
              ],
              [
                61.238575,
                35.467901
              ],
              [
                61.239065,
                35.468688
              ],
              [
                61.239737,
                35.469238
              ],
              [
                61.239959,
                35.46961
              ],
              [
                61.240165,
                35.471235
              ],
              [
                61.240523,
                35.472258
              ],
              [
                61.241883,
                35.474048
              ],
              [
                61.243371,
                35.475529
              ],
              [
                61.243436,
                35.47594
              ],
              [
                61.24364,
                35.476137
              ],
              [
                61.24427,
                35.476297
              ],
              [
                61.244766,
                35.476335
              ],
              [
                61.245667,
                35.476539
              ],
              [
                61.246266,
                35.476731
              ],
              [
                61.247033,
                35.476854
              ],
              [
                61.247559,
                35.476755
              ],
              [
                61.247767,
                35.476838
              ],
              [
                61.248302,
                35.477132
              ],
              [
                61.248747,
                35.47749
              ],
              [
                61.248842,
                35.477785
              ],
              [
                61.25028,
                35.478986
              ],
              [
                61.251465,
                35.479367
              ],
              [
                61.252343,
                35.479534
              ],
              [
                61.254106,
                35.480032
              ],
              [
                61.254802,
                35.480435
              ],
              [
                61.255524,
                35.481009
              ],
              [
                61.255894,
                35.481726
              ],
              [
                61.255828,
                35.482378
              ],
              [
                61.25478,
                35.483433
              ],
              [
                61.254161,
                35.483762
              ],
              [
                61.252921,
                35.484271
              ],
              [
                61.252777,
                35.484503
              ],
              [
                61.252696,
                35.484808
              ],
              [
                61.25252,
                35.485153
              ],
              [
                61.252612,
                35.485624
              ],
              [
                61.252745,
                35.48586
              ],
              [
                61.253121,
                35.486094
              ],
              [
                61.25326,
                35.486413
              ],
              [
                61.253346,
                35.487309
              ],
              [
                61.253289,
                35.488662
              ],
              [
                61.253345,
                35.489315
              ],
              [
                61.253736,
                35.490073
              ],
              [
                61.254294,
                35.49058
              ],
              [
                61.255341,
                35.491101
              ],
              [
                61.256323,
                35.491457
              ],
              [
                61.257366,
                35.491706
              ],
              [
                61.258001,
                35.491808
              ],
              [
                61.258626,
                35.491788
              ],
              [
                61.258984,
                35.491992
              ],
              [
                61.25987,
                35.494055
              ],
              [
                61.260569,
                35.495384
              ],
              [
                61.26087,
                35.49627
              ],
              [
                61.261056,
                35.497002
              ],
              [
                61.261192,
                35.497752
              ],
              [
                61.261227,
                35.498536
              ],
              [
                61.261056,
                35.499054
              ],
              [
                61.260377,
                35.500013
              ],
              [
                61.259547,
                35.502136
              ],
              [
                61.259306,
                35.503088
              ],
              [
                61.259206,
                35.503762
              ],
              [
                61.259266,
                35.504342
              ],
              [
                61.259482,
                35.504768
              ],
              [
                61.259949,
                35.505074
              ],
              [
                61.260457,
                35.505303
              ],
              [
                61.261708,
                35.505515
              ],
              [
                61.262407,
                35.50576
              ],
              [
                61.263108,
                35.505824
              ],
              [
                61.264037,
                35.505815
              ],
              [
                61.265528,
                35.505702
              ],
              [
                61.266293,
                35.505774
              ],
              [
                61.267065,
                35.505983
              ],
              [
                61.267308,
                35.506411
              ],
              [
                61.267983,
                35.507253
              ],
              [
                61.268643,
                35.508658
              ],
              [
                61.269219,
                35.509133
              ],
              [
                61.269371,
                35.509554
              ],
              [
                61.269416,
                35.509901
              ],
              [
                61.269394,
                35.511116
              ],
              [
                61.269746,
                35.512653
              ],
              [
                61.269724,
                35.513036
              ],
              [
                61.271097,
                35.516148
              ],
              [
                61.2714059,
                35.5165231
              ],
              [
                61.2762629,
                35.5182067
              ],
              [
                61.277778,
                35.520278
              ],
              [
                61.2752663,
                35.5274851
              ],
              [
                61.2781129,
                35.5315247
              ],
              [
                61.2810104,
                35.5339777
              ],
              [
                61.2825792,
                35.5379033
              ],
              [
                61.2826012,
                35.5406178
              ],
              [
                61.282525,
                35.5467564
              ],
              [
                61.2832642,
                35.5502138
              ],
              [
                61.270421,
                35.5598025
              ],
              [
                61.2700927,
                35.5640488
              ],
              [
                61.2737979,
                35.5677383
              ],
              [
                61.2716472,
                35.5708354
              ],
              [
                61.2736386,
                35.5751103
              ],
              [
                61.2793361,
                35.5774781
              ],
              [
                61.2799673,
                35.5806089
              ],
              [
                61.2791447,
                35.5817385
              ],
              [
                61.2740793,
                35.5834932
              ],
              [
                61.2710306,
                35.5891943
              ],
              [
                61.27422,
                35.5915029
              ],
              [
                61.2744299,
                35.5954257
              ],
              [
                61.2773447,
                35.5988458
              ],
              [
                61.274257,
                35.6031805
              ],
              [
                61.2740947,
                35.604842
              ],
              [
                61.2737591,
                35.6094121
              ],
              [
                61.271017,
                35.6112956
              ],
              [
                61.270837,
                35.6144662
              ],
              [
                61.2684923,
                35.6157625
              ],
              [
                61.2610925,
                35.6184856
              ],
              [
                61.2471275,
                35.6265853
              ],
              [
                61.2462837,
                35.6286053
              ],
              [
                61.2503748,
                35.633426
              ],
              [
                61.2510641,
                35.6350874
              ],
              [
                61.2496683,
                35.6383565
              ],
              [
                61.2473786,
                35.6404601
              ],
              [
                61.2467931,
                35.645202
              ],
              [
                61.2416299,
                35.6476809
              ],
              [
                61.2340469,
                35.6483081
              ],
              [
                61.226226,
                35.6506896
              ],
              [
                61.2250065,
                35.6529994
              ],
              [
                61.2254286,
                35.6539141
              ],
              [
                61.2289462,
                35.6554766
              ],
              [
                61.2288524,
                35.6571152
              ],
              [
                61.2226941,
                35.6610901
              ],
              [
                61.2189635,
                35.6683383
              ],
              [
                61.2245995,
                35.6729036
              ],
              [
                61.2229325,
                35.6753891
              ],
              [
                61.2166545,
                35.675801
              ],
              [
                61.2162359,
                35.6832534
              ],
              [
                61.21909,
                35.688781
              ],
              [
                61.2207853,
                35.6931578
              ],
              [
                61.2248658,
                35.6981095
              ],
              [
                61.2261321,
                35.697881
              ],
              [
                61.2284488,
                35.696996
              ],
              [
                61.2294621,
                35.6975763
              ],
              [
                61.2302521,
                35.7005941
              ],
              [
                61.2315258,
                35.7024135
              ],
              [
                61.236389,
                35.704167
              ],
              [
                61.239722,
                35.708611
              ],
              [
                61.243889,
                35.712222
              ],
              [
                61.246389,
                35.7175
              ],
              [
                61.248333,
                35.723611
              ],
              [
                61.249722,
                35.730278
              ],
              [
                61.248889,
                35.735833
              ],
              [
                61.249444,
                35.742222
              ],
              [
                61.248611,
                35.747778
              ],
              [
                61.248889,
                35.753889
              ],
              [
                61.251111,
                35.76
              ],
              [
                61.253611,
                35.765278
              ],
              [
                61.255556,
                35.771111
              ],
              [
                61.255,
                35.776944
              ],
              [
                61.2525,
                35.781389
              ],
              [
                61.250833,
                35.786389
              ],
              [
                61.252222,
                35.793056
              ],
              [
                61.253056,
                35.798611
              ],
              [
                61.255833,
                35.803889
              ],
              [
                61.258611,
                35.808889
              ],
              [
                61.261944,
                35.813333
              ],
              [
                61.262222,
                35.819722
              ],
              [
                61.260556,
                35.824722
              ],
              [
                61.258889,
                35.829722
              ],
              [
                61.256389,
                35.834167
              ],
              [
                61.253889,
                35.838611
              ],
              [
                61.252222,
                35.843611
              ],
              [
                61.249444,
                35.848333
              ],
              [
                61.248056,
                35.853333
              ],
              [
                61.246389,
                35.858333
              ],
              [
                61.243611,
                35.862778
              ],
              [
                61.243056,
                35.868333
              ],
              [
                61.241389,
                35.873611
              ],
              [
                61.240833,
                35.879167
              ],
              [
                61.241111,
                35.885278
              ],
              [
                61.243889,
                35.890556
              ],
              [
                61.245,
                35.897222
              ],
              [
                61.239444,
                35.898611
              ],
              [
                61.233056,
                35.8975
              ],
              [
                61.2275,
                35.898889
              ],
              [
                61.225833,
                35.903889
              ],
              [
                61.226111,
                35.91
              ],
              [
                61.2225305,
                35.9144264
              ],
              [
                61.2106711,
                35.9218235
              ],
              [
                61.205404,
                35.9271198
              ],
              [
                61.1836284,
                35.9430414
              ],
              [
                61.1722681,
                35.9474458
              ],
              [
                61.169784,
                35.9394192
              ],
              [
                61.1406178,
                35.9383207
              ],
              [
                61.1198247,
                35.9369373
              ],
              [
                61.0790132,
                35.9380665
              ],
              [
                61.0767857,
                35.9369585
              ],
              [
                61.0742857,
                35.9358505
              ],
              [
                61.0717864,
                35.9358504
              ],
              [
                61.0706731,
                35.9361297
              ],
              [
                61.0578987,
                35.9188793
              ],
              [
                61.0508202,
                35.9080303
              ],
              [
                61.0488741,
                35.9080302
              ],
              [
                61.0480405,
                35.9083185
              ],
              [
                61.0433209,
                35.9088684
              ],
              [
                61.0423047,
                35.9120662
              ],
              [
                61.0411913,
                35.9123456
              ],
              [
                61.0398046,
                35.9120662
              ],
              [
                61.0379309,
                35.9138736
              ],
              [
                61.0370972,
                35.9141529
              ],
              [
                61.0359839,
                35.9141529
              ],
              [
                61.0325705,
                35.9233198
              ],
              [
                61.028404,
                35.9252663
              ],
              [
                61.0168087,
                35.9374838
              ],
              [
                61.0204454,
                35.9547134
              ],
              [
                61.0193321,
                35.9549838
              ],
              [
                61.0107187,
                35.9597054
              ],
              [
                60.9899985,
                35.9824913
              ],
              [
                60.9836124,
                35.9838787
              ],
              [
                60.969166,
                35.9863742
              ],
              [
                60.9602791,
                35.9885994
              ],
              [
                60.9439083,
                35.9907857
              ],
              [
                60.9373852,
                35.9802291
              ],
              [
                60.9274289,
                35.9802291
              ],
              [
                60.9018471,
                35.9813316
              ],
              [
                60.8996204,
                35.9816511
              ],
              [
                60.8987868,
                35.9819214
              ],
              [
                60.891019,
                35.9745574
              ],
              [
                60.884474,
                35.9701148
              ],
              [
                60.8742138,
                35.9658095
              ],
              [
                60.8608355,
                35.9571908
              ],
              [
                60.856669,
                35.9580291
              ],
              [
                60.8454177,
                35.9659446
              ],
              [
                60.8256011,
                35.9716408
              ],
              [
                60.8244877,
                35.9713615
              ],
              [
                60.8219877,
                35.9713615
              ],
              [
                60.8211145,
                35.969557
              ],
              [
                60.8224183,
                35.9553153
              ],
              [
                60.819121,
                35.9513565
              ],
              [
                60.8161307,
                35.9420455
              ],
              [
                60.8155776,
                35.9423249
              ],
              [
                60.8108509,
                35.9428839
              ],
              [
                60.8024049,
                35.9417722
              ],
              [
                60.8012908,
                35.9414836
              ],
              [
                60.7912031,
                35.9477375
              ],
              [
                60.7796247,
                35.9430202
              ],
              [
                60.7776778,
                35.9435792
              ],
              [
                60.7685112,
                35.9446881
              ],
              [
                60.7662916,
                35.9449676
              ],
              [
                60.7523347,
                35.9413542
              ],
              [
                60.7484416,
                35.9427429
              ],
              [
                60.7297482,
                35.9455175
              ],
              [
                60.7255817,
                35.9471857
              ],
              [
                60.7247489,
                35.9471857
              ],
              [
                60.7214151,
                35.9485745
              ],
              [
                60.7197488,
                35.9488539
              ],
              [
                60.7128018,
                35.9510812
              ],
              [
                60.7030821,
                35.9524699
              ],
              [
                60.6986358,
                35.9527404
              ],
              [
                60.6986358,
                35.9530199
              ],
              [
                60.6978022,
                35.9530199
              ],
              [
                60.6972491,
                35.9532994
              ],
              [
                60.6964155,
                35.9532995
              ],
              [
                60.692249,
                35.9544086
              ],
              [
                60.6908551,
                35.9544087
              ],
              [
                60.6883559,
                35.9549677
              ],
              [
                60.6866887,
                35.9549678
              ],
              [
                60.6858558,
                35.9552472
              ],
              [
                60.6847425,
                35.9552472
              ],
              [
                60.6841887,
                35.9555268
              ],
              [
                60.6819691,
                35.9557972
              ],
              [
                60.6789088,
                35.9557972
              ],
              [
                60.6783557,
                35.9560859
              ],
              [
                60.6736361,
                35.9560859
              ],
              [
                60.6728025,
                35.9560859
              ],
              [
                60.6703024,
                35.9560859
              ],
              [
                60.6636359,
                35.9527405
              ],
              [
                60.6428967,
                35.9507933
              ],
              [
                60.635236,
                35.9480186
              ],
              [
                60.6232098,
                35.9535799
              ],
              [
                60.6220964,
                35.95303
              ],
              [
                60.6044464,
                35.9552502
              ],
              [
                60.5945569,
                35.9610832
              ],
              [
                60.5942768,
                35.9605334
              ],
              [
                60.5803945,
                35.9637587
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6556233,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میان‌جلگه",
          "name:en": "Miyan Jolgeh County",
          "place": "district",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q6884343"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.2350197,
                36.0717981
              ],
              [
                58.2315994,
                36.0528881
              ],
              [
                58.2298606,
                36.0465111
              ],
              [
                58.229269,
                36.0432407
              ],
              [
                58.2279364,
                36.0372049
              ],
              [
                58.2263532,
                36.030336
              ],
              [
                58.2252215,
                36.0234186
              ],
              [
                58.2233822,
                36.020399
              ],
              [
                58.21475,
                36.01245
              ],
              [
                58.2201973,
                36.0078953
              ],
              [
                58.2245349,
                36.0051596
              ],
              [
                58.2296847,
                36.0030765
              ],
              [
                58.2350062,
                35.9959938
              ],
              [
                58.2404378,
                35.9906801
              ],
              [
                58.2453918,
                35.9887715
              ],
              [
                58.2516574,
                35.9868269
              ],
              [
                58.258598,
                35.9863039
              ],
              [
                58.2611503,
                35.9839409
              ],
              [
                58.2616996,
                35.9804372
              ],
              [
                58.2593822,
                35.9751584
              ],
              [
                58.259623,
                35.9708859
              ],
              [
                58.2616567,
                35.9688025
              ],
              [
                58.2626867,
                35.9665448
              ],
              [
                58.2618325,
                35.9622711
              ],
              [
                58.2612585,
                35.9589997
              ],
              [
                58.2574081,
                35.9534838
              ],
              [
                58.2539379,
                35.9479595
              ],
              [
                58.2501983,
                35.9457017
              ],
              [
                58.2493829,
                35.9434087
              ],
              [
                58.2459926,
                35.9395172
              ],
              [
                58.2436751,
                35.9323593
              ],
              [
                58.2409328,
                35.9233109
              ],
              [
                58.2415852,
                35.9158245
              ],
              [
                58.2443543,
                35.9117879
              ],
              [
                58.2463917,
                35.9065801
              ],
              [
                58.245689,
                35.9050145
              ],
              [
                58.2461214,
                35.902087
              ],
              [
                58.246246,
                35.8995108
              ],
              [
                58.2489109,
                35.8945433
              ],
              [
                58.2503699,
                35.8935699
              ],
              [
                58.2795523,
                35.8879376
              ],
              [
                58.2891654,
                35.8873813
              ],
              [
                58.3181761,
                35.8827917
              ],
              [
                58.3414793,
                35.8789667
              ],
              [
                58.3533668,
                35.8756981
              ],
              [
                58.3592161,
                35.8733051
              ],
              [
                58.3682301,
                35.8714355
              ],
              [
                58.3751129,
                35.8698169
              ],
              [
                58.3858302,
                35.8654348
              ],
              [
                58.394823,
                35.8638741
              ],
              [
                58.4158515,
                35.8647088
              ],
              [
                58.4384079,
                35.8628071
              ],
              [
                58.4518744,
                35.861416
              ],
              [
                58.4573996,
                35.8561612
              ],
              [
                58.4623718,
                35.8486394
              ],
              [
                58.4672404,
                35.8392342
              ],
              [
                58.4885863,
                35.8030906
              ],
              [
                58.4912103,
                35.7810572
              ],
              [
                58.4809106,
                35.7490206
              ],
              [
                58.4603117,
                35.7327183
              ],
              [
                58.45705,
                35.7237998
              ],
              [
                58.4603117,
                35.7094441
              ],
              [
                58.4645237,
                35.7019551
              ],
              [
                58.4679152,
                35.6970817
              ],
              [
                58.4731452,
                35.6903996
              ],
              [
                58.4840011,
                35.6833744
              ],
              [
                58.4936999,
                35.6821893
              ],
              [
                58.4988839,
                35.6822809
              ],
              [
                58.5180807,
                35.6835624
              ],
              [
                58.530092,
                35.6811302
              ],
              [
                58.541851,
                35.6794005
              ],
              [
                58.5553742,
                35.6792209
              ],
              [
                58.5701751,
                35.6754961
              ],
              [
                58.5847663,
                35.6747292
              ],
              [
                58.5940365,
                35.6765101
              ],
              [
                58.6101769,
                35.67501
              ],
              [
                58.6318012,
                35.6698485
              ],
              [
                58.6515083,
                35.656943
              ],
              [
                58.6605197,
                35.6516547
              ],
              [
                58.6687085,
                35.6377672
              ],
              [
                58.6607265,
                35.6268146
              ],
              [
                58.6584693,
                35.6214232
              ],
              [
                58.6584694,
                35.6190505
              ],
              [
                58.6596438,
                35.6141807
              ],
              [
                58.6615148,
                35.6026528
              ],
              [
                58.6687085,
                35.5928317
              ],
              [
                58.673515,
                35.583339
              ],
              [
                58.6875882,
                35.5796111
              ],
              [
                58.6951854,
                35.5779196
              ],
              [
                58.7083766,
                35.5850574
              ],
              [
                58.7138803,
                35.5876929
              ],
              [
                58.7263418,
                35.6023538
              ],
              [
                58.7495228,
                35.6301507
              ],
              [
                58.7565358,
                35.6316651
              ],
              [
                58.7588919,
                35.6419752
              ],
              [
                58.7613755,
                35.6495566
              ],
              [
                58.7660685,
                35.6560801
              ],
              [
                58.7693909,
                35.6608037
              ],
              [
                58.7734002,
                35.6655284
              ],
              [
                58.7865704,
                35.6717213
              ],
              [
                58.7986562,
                35.6768211
              ],
              [
                58.811531,
                35.6904852
              ],
              [
                58.8158223,
                35.7003139
              ],
              [
                58.8201138,
                35.7158558
              ],
              [
                58.8213157,
                35.7310461
              ],
              [
                58.8269674,
                35.7395228
              ],
              [
                58.8357489,
                35.7401321
              ],
              [
                58.8554363,
                35.742497
              ],
              [
                58.8654061,
                35.7443778
              ],
              [
                58.87411,
                35.7447279
              ],
              [
                58.8825617,
                35.7426296
              ],
              [
                58.8970646,
                35.7348276
              ],
              [
                58.9040629,
                35.731344
              ],
              [
                58.9126395,
                35.7265868
              ],
              [
                58.9322089,
                35.7205245
              ],
              [
                58.9447801,
                35.7188007
              ],
              [
                58.9586103,
                35.7282694
              ],
              [
                58.9664514,
                35.7333488
              ],
              [
                58.9725111,
                35.7435785
              ],
              [
                58.9723097,
                35.7574838
              ],
              [
                58.9725827,
                35.7583221
              ],
              [
                58.9728628,
                35.7610984
              ],
              [
                58.973143,
                35.762766
              ],
              [
                58.9845296,
                35.7941524
              ],
              [
                58.9853629,
                35.7969378
              ],
              [
                58.9880593,
                35.8008173
              ],
              [
                58.9880593,
                35.8058111
              ],
              [
                58.9883394,
                35.80637
              ],
              [
                58.9891027,
                35.809411
              ],
              [
                58.9898979,
                35.8113552
              ],
              [
                58.990178,
                35.8135818
              ],
              [
                58.990451,
                35.8177464
              ],
              [
                58.9907311,
                35.8196844
              ],
              [
                58.9946161,
                35.8259464
              ],
              [
                58.9948892,
                35.8295611
              ],
              [
                58.9943109,
                35.8333136
              ],
              [
                59.0041437,
                35.8515966
              ],
              [
                59.0022126,
                35.8543749
              ],
              [
                58.9982188,
                35.8625218
              ],
              [
                58.9965505,
                35.8663242
              ],
              [
                58.9612968,
                35.8756042
              ],
              [
                58.9560473,
                35.8856331
              ],
              [
                58.9494961,
                35.8957235
              ],
              [
                58.9369223,
                35.9090356
              ],
              [
                58.9244551,
                35.9148927
              ],
              [
                58.9090823,
                35.9202379
              ],
              [
                58.892431,
                35.9249658
              ],
              [
                58.881361,
                35.9260262
              ],
              [
                58.8784542,
                35.9399141
              ],
              [
                58.8775102,
                35.9464476
              ],
              [
                58.8773266,
                35.9555997
              ],
              [
                58.868895,
                35.961612
              ],
              [
                58.8662772,
                35.9679652
              ],
              [
                58.8673209,
                35.9734219
              ],
              [
                58.8579654,
                35.9830071
              ],
              [
                58.8540172,
                35.990091
              ],
              [
                58.8472365,
                35.9934244
              ],
              [
                58.8380527,
                36.0034237
              ],
              [
                58.8266372,
                36.0132829
              ],
              [
                58.8253179,
                36.0214343
              ],
              [
                58.8224981,
                36.0344854
              ],
              [
                58.8203549,
                36.0450468
              ],
              [
                58.8104876,
                36.0539984
              ],
              [
                58.779745,
                36.0812757
              ],
              [
                58.7739372,
                36.0822282
              ],
              [
                58.7504013,
                36.0836877
              ],
              [
                58.7456471,
                36.0814514
              ],
              [
                58.7406348,
                36.0802513
              ],
              [
                58.7129832,
                36.0907675
              ],
              [
                58.7057984,
                36.0891791
              ],
              [
                58.6910844,
                36.089886
              ],
              [
                58.6745211,
                36.0826537
              ],
              [
                58.6544805,
                36.0839438
              ],
              [
                58.6441612,
                36.0813612
              ],
              [
                58.6345714,
                36.0791603
              ],
              [
                58.6014911,
                36.0783595
              ],
              [
                58.5982418,
                36.0809103
              ],
              [
                58.5946342,
                36.0815501
              ],
              [
                58.5886563,
                36.0783919
              ],
              [
                58.5835064,
                36.0741146
              ],
              [
                58.5753822,
                36.074088
              ],
              [
                58.5664173,
                36.0741496
              ],
              [
                58.5433527,
                36.0730023
              ],
              [
                58.4994506,
                36.0627687
              ],
              [
                58.4978688,
                36.0616034
              ],
              [
                58.4954701,
                36.0607422
              ],
              [
                58.4950757,
                36.0618388
              ],
              [
                58.4946362,
                36.0631226
              ],
              [
                58.4946441,
                36.0781009
              ],
              [
                58.4939944,
                36.0953637
              ],
              [
                58.4829711,
                36.1009548
              ],
              [
                58.4753711,
                36.1053527
              ],
              [
                58.4670422,
                36.1124037
              ],
              [
                58.4613876,
                36.1173331
              ],
              [
                58.4560066,
                36.1221919
              ],
              [
                58.4449793,
                36.1231931
              ],
              [
                58.416445,
                36.128254
              ],
              [
                58.3922481,
                36.1369043
              ],
              [
                58.3811696,
                36.140111
              ],
              [
                58.3691596,
                36.1416871
              ],
              [
                58.3531092,
                36.1460539
              ],
              [
                58.3294199,
                36.1412713
              ],
              [
                58.3128976,
                36.1423109
              ],
              [
                58.3009243,
                36.1456032
              ],
              [
                58.288393,
                36.1486874
              ],
              [
                58.2751622,
                36.1537643
              ],
              [
                58.2859897,
                36.1463656
              ],
              [
                58.2869952,
                36.1388696
              ],
              [
                58.2785863,
                36.1337274
              ],
              [
                58.2721966,
                36.1326179
              ],
              [
                58.263149,
                36.1298213
              ],
              [
                58.2595466,
                36.126768
              ],
              [
                58.2564934,
                36.1226055
              ],
              [
                58.2499407,
                36.1153437
              ],
              [
                58.2362937,
                36.0727592
              ],
              [
                58.2350197,
                36.0717981
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11093556,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زبرخان",
          "name:en": "Zeberkhan County",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q8068261",
          "wikimedia_commons": "Category:Zeberkhan County",
          "wikipedia": "fa:شهرستان زبرخان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.9348244,
                36.1194279
              ],
              [
                58.9565769,
                36.105587
              ],
              [
                58.958559,
                36.0990997
              ],
              [
                58.9603579,
                36.0919638
              ],
              [
                58.9538076,
                36.0886462
              ],
              [
                58.9512755,
                36.085063
              ],
              [
                58.9478516,
                36.0800252
              ],
              [
                58.9466997,
                36.0752631
              ],
              [
                58.9457273,
                36.0714758
              ],
              [
                58.9456709,
                36.06658
              ],
              [
                58.9346551,
                36.0609647
              ],
              [
                58.9226671,
                36.054568
              ],
              [
                58.9217728,
                36.0485291
              ],
              [
                58.9140558,
                36.0446576
              ],
              [
                58.9131031,
                36.034653
              ],
              [
                58.9130987,
                36.0296825
              ],
              [
                58.9173043,
                36.0193062
              ],
              [
                58.9210907,
                36.0152907
              ],
              [
                58.9250925,
                36.0113357
              ],
              [
                58.9303061,
                36.0098308
              ],
              [
                58.9391536,
                36.0111246
              ],
              [
                58.94597,
                36.0102379
              ],
              [
                58.9497224,
                36.008854
              ],
              [
                58.9515237,
                36.0001823
              ],
              [
                58.9421537,
                35.9927666
              ],
              [
                58.9482164,
                35.9879033
              ],
              [
                58.9522622,
                35.9835925
              ],
              [
                58.9633655,
                35.9678648
              ],
              [
                58.955049,
                35.9621509
              ],
              [
                58.9510058,
                35.9550818
              ],
              [
                58.9493751,
                35.9461881
              ],
              [
                58.939247,
                35.9386138
              ],
              [
                58.9343864,
                35.9304639
              ],
              [
                58.9345803,
                35.9214935
              ],
              [
                58.9353143,
                35.9181601
              ],
              [
                58.9369223,
                35.9090356
              ],
              [
                58.9494961,
                35.8957235
              ],
              [
                58.9560473,
                35.8856331
              ],
              [
                58.9612968,
                35.8756042
              ],
              [
                58.9965505,
                35.8663242
              ],
              [
                58.9982188,
                35.8625218
              ],
              [
                59.0022126,
                35.8543749
              ],
              [
                59.0041437,
                35.8515966
              ],
              [
                59.0217344,
                35.8533565
              ],
              [
                59.0363482,
                35.8511638
              ],
              [
                59.0414101,
                35.850467
              ],
              [
                59.0459144,
                35.8496669
              ],
              [
                59.0497135,
                35.8490149
              ],
              [
                59.0565227,
                35.848134
              ],
              [
                59.0630718,
                35.8473758
              ],
              [
                59.0771138,
                35.8454643
              ],
              [
                59.0861273,
                35.8442952
              ],
              [
                59.0792517,
                35.852805
              ],
              [
                59.0677354,
                35.8637352
              ],
              [
                59.0723704,
                35.8729161
              ],
              [
                59.0706977,
                35.8863072
              ],
              [
                59.0696483,
                35.8952556
              ],
              [
                59.0683227,
                35.9065921
              ],
              [
                59.0688911,
                35.9121338
              ],
              [
                59.0766619,
                35.9250617
              ],
              [
                59.0796232,
                35.928641
              ],
              [
                59.089053,
                35.9369361
              ],
              [
                59.088242,
                35.9409625
              ],
              [
                59.0884161,
                35.9447765
              ],
              [
                59.09629,
                35.9479737
              ],
              [
                59.1054811,
                35.9518901
              ],
              [
                59.1167045,
                35.9515804
              ],
              [
                59.127731,
                35.9542483
              ],
              [
                59.1418933,
                35.9562629
              ],
              [
                59.1404342,
                35.9584167
              ],
              [
                59.1385457,
                35.9605012
              ],
              [
                59.1331812,
                35.9736653
              ],
              [
                59.1359281,
                35.9795343
              ],
              [
                59.1372582,
                35.9830419
              ],
              [
                59.1539742,
                35.9841459
              ],
              [
                59.15914,
                35.98446
              ],
              [
                59.1721345,
                35.9874075
              ],
              [
                59.175539,
                35.9881985
              ],
              [
                59.1932624,
                35.9949415
              ],
              [
                59.1990719,
                36.0046992
              ],
              [
                59.2070627,
                36.0027832
              ],
              [
                59.2077468,
                36.0049815
              ],
              [
                59.2091336,
                36.0063693
              ],
              [
                59.2091336,
                36.0069282
              ],
              [
                59.2119133,
                36.0097039
              ],
              [
                59.2138531,
                36.0113712
              ],
              [
                59.2424664,
                36.0330363
              ],
              [
                59.2838596,
                36.0591526
              ],
              [
                59.2849728,
                36.0594229
              ],
              [
                59.287746,
                36.0613695
              ],
              [
                59.2888592,
                36.0616489
              ],
              [
                59.290246,
                36.0627573
              ],
              [
                59.2927528,
                36.0638748
              ],
              [
                59.2977528,
                36.067209
              ],
              [
                59.2988591,
                36.0677588
              ],
              [
                59.311639,
                36.0816546
              ],
              [
                59.3141392,
                36.0863767
              ],
              [
                59.3144193,
                36.0877555
              ],
              [
                59.3138591,
                36.0949825
              ],
              [
                59.3189121,
                36.1010896
              ],
              [
                59.3144367,
                36.1100534
              ],
              [
                59.3141926,
                36.1105423
              ],
              [
                59.3139124,
                36.1108126
              ],
              [
                59.3128058,
                36.1130383
              ],
              [
                59.3089124,
                36.1183187
              ],
              [
                59.3094423,
                36.1338675
              ],
              [
                59.3008292,
                36.1463653
              ],
              [
                59.2961092,
                36.1499786
              ],
              [
                59.2902759,
                36.1513662
              ],
              [
                59.2897161,
                36.1516456
              ],
              [
                59.2724733,
                36.1494279
              ],
              [
                59.2719131,
                36.1497072
              ],
              [
                59.2708065,
                36.1497071
              ],
              [
                59.26914,
                36.1505361
              ],
              [
                59.2669134,
                36.1513742
              ],
              [
                59.2423195,
                36.1705681
              ],
              [
                59.2225301,
                36.185311
              ],
              [
                59.2189167,
                36.1883662
              ],
              [
                59.1929623,
                36.2091004
              ],
              [
                59.1749678,
                36.2277648
              ],
              [
                59.1744076,
                36.2283234
              ],
              [
                59.1533583,
                36.2511089
              ],
              [
                59.1508014,
                36.2538755
              ],
              [
                59.149135,
                36.2549837
              ],
              [
                59.1424684,
                36.258038
              ],
              [
                59.1396883,
                36.2588758
              ],
              [
                59.138575,
                36.2591552
              ],
              [
                59.1080909,
                36.2899734
              ],
              [
                59.0897508,
                36.3051227
              ],
              [
                59.0667757,
                36.3207154
              ],
              [
                59.0593401,
                36.3149996
              ],
              [
                59.0523878,
                36.3098643
              ],
              [
                59.0456623,
                36.3049326
              ],
              [
                59.0463397,
                36.2927597
              ],
              [
                59.0476783,
                36.2826061
              ],
              [
                59.0388379,
                36.2726374
              ],
              [
                59.0322204,
                36.2654298
              ],
              [
                59.0074496,
                36.205468
              ],
              [
                58.9856787,
                36.1910798
              ],
              [
                58.9856787,
                36.1905301
              ],
              [
                58.9535246,
                36.178631
              ],
              [
                58.9488222,
                36.1768869
              ],
              [
                58.9448486,
                36.1745845
              ],
              [
                58.9378145,
                36.1725207
              ],
              [
                58.9373489,
                36.1658462
              ],
              [
                58.956436,
                36.1599193
              ],
              [
                58.9510632,
                36.1485904
              ],
              [
                58.9496769,
                36.1460944
              ],
              [
                58.9471769,
                36.1435984
              ],
              [
                58.9428924,
                36.135582
              ],
              [
                58.9362257,
                36.1272556
              ],
              [
                58.9364989,
                36.1261381
              ],
              [
                58.9373321,
                36.1250298
              ],
              [
                58.9348244,
                36.1194279
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11093557,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ششتمد",
          "name:en": "Sheshtamad County",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q7495639",
          "wikipedia": "en:Sheshtamad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.5000489,
                35.9864353
              ],
              [
                57.5111498,
                35.9841488
              ],
              [
                57.5236079,
                35.9812387
              ],
              [
                57.5429534,
                35.9747417
              ],
              [
                57.5553989,
                35.9732135
              ],
              [
                57.6231381,
                35.9362306
              ],
              [
                57.6226042,
                35.9268688
              ],
              [
                57.6357247,
                35.9008142
              ],
              [
                57.6535044,
                35.8860864
              ],
              [
                57.6548912,
                35.8852571
              ],
              [
                57.7028695,
                35.8379308
              ],
              [
                57.7007448,
                35.8329823
              ],
              [
                57.6991652,
                35.8263039
              ],
              [
                57.7005385,
                35.8189268
              ],
              [
                57.7025985,
                35.8140548
              ],
              [
                57.701826,
                35.8079992
              ],
              [
                57.7010326,
                35.8042798
              ],
              [
                57.6972769,
                35.8019432
              ],
              [
                57.70483,
                35.7928931
              ],
              [
                57.7216528,
                35.7874625
              ],
              [
                57.7376173,
                35.7830064
              ],
              [
                57.7451704,
                35.7798034
              ],
              [
                57.7565001,
                35.77855
              ],
              [
                57.7556418,
                35.7654579
              ],
              [
                57.7496336,
                35.7533389
              ],
              [
                57.7439688,
                35.7491595
              ],
              [
                57.7410505,
                35.7430293
              ],
              [
                57.7365874,
                35.740382
              ],
              [
                57.7286909,
                35.7302101
              ],
              [
                57.7218245,
                35.7197581
              ],
              [
                57.7199362,
                35.7113955
              ],
              [
                57.7221678,
                35.7026139
              ],
              [
                57.7125548,
                35.6964801
              ],
              [
                57.7051733,
                35.693413
              ],
              [
                57.7019118,
                35.6871391
              ],
              [
                57.6996802,
                35.6769604
              ],
              [
                57.6960753,
                35.6687328
              ],
              [
                57.6969336,
                35.6574359
              ],
              [
                57.7005385,
                35.6468349
              ],
              [
                57.7056883,
                35.6433474
              ],
              [
                57.7123831,
                35.6355349
              ],
              [
                57.7182196,
                35.6267449
              ],
              [
                57.7127264,
                35.6203262
              ],
              [
                57.7123831,
                35.6153025
              ],
              [
                57.7174472,
                35.6127904
              ],
              [
                57.7226828,
                35.608185
              ],
              [
                57.7345275,
                35.6028116
              ],
              [
                57.7362441,
                35.600718
              ],
              [
                57.7367591,
                35.5961118
              ],
              [
                57.7347212,
                35.5919613
              ],
              [
                57.7353,
                35.5862705
              ],
              [
                57.7394199,
                35.577126
              ],
              [
                57.7368449,
                35.5695165
              ],
              [
                57.7360725,
                35.5654671
              ],
              [
                57.7327251,
                35.5612778
              ],
              [
                57.73324,
                35.5522004
              ],
              [
                57.7323409,
                35.5449336
              ],
              [
                57.7492043,
                35.5455315
              ],
              [
                57.7530669,
                35.5468232
              ],
              [
                57.7586459,
                35.5494769
              ],
              [
                57.7682734,
                35.5561768
              ],
              [
                57.7750766,
                35.5612918
              ],
              [
                57.7779697,
                35.5632293
              ],
              [
                57.7779642,
                35.5660748
              ],
              [
                57.7725076,
                35.5717156
              ],
              [
                57.7728939,
                35.5745779
              ],
              [
                57.7758447,
                35.581609
              ],
              [
                57.7833321,
                35.5849945
              ],
              [
                57.7887756,
                35.5872982
              ],
              [
                57.7980981,
                35.5893487
              ],
              [
                57.8004455,
                35.5893765
              ],
              [
                57.825379,
                35.5926572
              ],
              [
                57.8375887,
                35.5930932
              ],
              [
                57.8491189,
                35.5903836
              ],
              [
                57.8571796,
                35.5909644
              ],
              [
                57.8732728,
                35.5885564
              ],
              [
                57.873659,
                35.5875269
              ],
              [
                57.8678655,
                35.5838448
              ],
              [
                57.862544,
                35.5794645
              ],
              [
                57.8596713,
                35.5763136
              ],
              [
                57.8659341,
                35.5749272
              ],
              [
                57.8773495,
                35.5598816
              ],
              [
                57.893829,
                35.5528989
              ],
              [
                57.8941724,
                35.5341822
              ],
              [
                57.9072186,
                35.5308295
              ],
              [
                57.9123686,
                35.5251015
              ],
              [
                57.9103085,
                35.5199323
              ],
              [
                57.8907391,
                35.5054004
              ],
              [
                57.8909109,
                35.5002296
              ],
              [
                57.9014956,
                35.4940749
              ],
              [
                57.9238699,
                35.4849952
              ],
              [
                57.93587,
                35.4896051
              ],
              [
                57.9488468,
                35.4865657
              ],
              [
                57.9635235,
                35.4940804
              ],
              [
                57.985067,
                35.4934515
              ],
              [
                57.9955383,
                35.480033
              ],
              [
                57.9994008,
                35.4791244
              ],
              [
                58.0064685,
                35.4976848
              ],
              [
                58.0198016,
                35.5110222
              ],
              [
                58.0256415,
                35.5160182
              ],
              [
                58.0348081,
                35.5213025
              ],
              [
                58.0606412,
                35.5307441
              ],
              [
                58.0664745,
                35.5307441
              ],
              [
                58.1073758,
                35.5224472
              ],
              [
                58.1139518,
                35.5199303
              ],
              [
                58.1153381,
                35.5202099
              ],
              [
                58.1206184,
                35.5202099
              ],
              [
                58.1231185,
                35.5207599
              ],
              [
                58.1245048,
                35.52076
              ],
              [
                58.1253384,
                35.5210395
              ],
              [
                58.142401,
                35.5313777
              ],
              [
                58.144628,
                35.5310983
              ],
              [
                58.1501812,
                35.5308278
              ],
              [
                58.1529712,
                35.5277454
              ],
              [
                58.1568576,
                35.528584
              ],
              [
                58.160076,
                35.5320867
              ],
              [
                58.1699707,
                35.5302385
              ],
              [
                58.1722639,
                35.5442393
              ],
              [
                58.1779288,
                35.5522004
              ],
              [
                58.1873702,
                35.5553427
              ],
              [
                58.2094564,
                35.5537793
              ],
              [
                58.1939504,
                35.5708861
              ],
              [
                58.1688278,
                35.5755704
              ],
              [
                58.1251923,
                35.5891824
              ],
              [
                58.1243591,
                35.5939064
              ],
              [
                58.1238059,
                35.5966831
              ],
              [
                58.1238059,
                35.6011275
              ],
              [
                58.1240789,
                35.6016865
              ],
              [
                58.1447979,
                35.612372
              ],
              [
                58.1568142,
                35.6185122
              ],
              [
                58.1586281,
                35.6279011
              ],
              [
                58.1589011,
                35.6303975
              ],
              [
                58.1602945,
                35.6362286
              ],
              [
                58.1627946,
                35.6398336
              ],
              [
                58.1641813,
                35.6426095
              ],
              [
                58.217037,
                35.6641887
              ],
              [
                58.2287068,
                35.6683385
              ],
              [
                58.2298201,
                35.6702767
              ],
              [
                58.2339866,
                35.6805535
              ],
              [
                58.2345402,
                35.6813828
              ],
              [
                58.217144,
                35.6971905
              ],
              [
                58.2179778,
                35.6985879
              ],
              [
                58.2134895,
                35.7226894
              ],
              [
                58.2019782,
                35.7415995
              ],
              [
                58.1938927,
                35.750971
              ],
              [
                58.1835931,
                35.7699155
              ],
              [
                58.1829064,
                35.8033359
              ],
              [
                58.1842797,
                35.8194841
              ],
              [
                58.1897729,
                35.8233814
              ],
              [
                58.2268517,
                35.8239382
              ],
              [
                58.2653039,
                35.8384122
              ],
              [
                58.2783501,
                35.851214
              ],
              [
                58.3023827,
                35.8606748
              ],
              [
                58.3394616,
                35.8528836
              ],
              [
                58.3517172,
                35.8574347
              ],
              [
                58.3751129,
                35.8698169
              ],
              [
                58.3682301,
                35.8714355
              ],
              [
                58.3592161,
                35.8733051
              ],
              [
                58.3533668,
                35.8756981
              ],
              [
                58.3414793,
                35.8789667
              ],
              [
                58.3181761,
                35.8827917
              ],
              [
                58.2891654,
                35.8873813
              ],
              [
                58.2795523,
                35.8879376
              ],
              [
                58.2503699,
                35.8935699
              ],
              [
                58.2489109,
                35.8945433
              ],
              [
                58.246246,
                35.8995108
              ],
              [
                58.2461214,
                35.902087
              ],
              [
                58.245689,
                35.9050145
              ],
              [
                58.2463917,
                35.9065801
              ],
              [
                58.2443543,
                35.9117879
              ],
              [
                58.2415852,
                35.9158245
              ],
              [
                58.2409328,
                35.9233109
              ],
              [
                58.2436751,
                35.9323593
              ],
              [
                58.2459926,
                35.9395172
              ],
              [
                58.2493829,
                35.9434087
              ],
              [
                58.2501983,
                35.9457017
              ],
              [
                58.2539379,
                35.9479595
              ],
              [
                58.2574081,
                35.9534838
              ],
              [
                58.2612585,
                35.9589997
              ],
              [
                58.2618325,
                35.9622711
              ],
              [
                58.2626867,
                35.9665448
              ],
              [
                58.2616567,
                35.9688025
              ],
              [
                58.259623,
                35.9708859
              ],
              [
                58.2593822,
                35.9751584
              ],
              [
                58.2616996,
                35.9804372
              ],
              [
                58.2611503,
                35.9839409
              ],
              [
                58.258598,
                35.9863039
              ],
              [
                58.2516574,
                35.9868269
              ],
              [
                58.2453918,
                35.9887715
              ],
              [
                58.2404378,
                35.9906801
              ],
              [
                58.2350062,
                35.9959938
              ],
              [
                58.2296847,
                36.0030765
              ],
              [
                58.2245349,
                36.0051596
              ],
              [
                58.2201973,
                36.0078953
              ],
              [
                58.21475,
                36.01245
              ],
              [
                58.2233822,
                36.020399
              ],
              [
                58.2252215,
                36.0234186
              ],
              [
                58.2263532,
                36.030336
              ],
              [
                58.2279364,
                36.0372049
              ],
              [
                58.229269,
                36.0432407
              ],
              [
                58.2298606,
                36.0465111
              ],
              [
                58.2315994,
                36.0528881
              ],
              [
                58.2350197,
                36.0717981
              ],
              [
                58.2307911,
                36.0691732
              ],
              [
                58.2276044,
                36.0679977
              ],
              [
                58.2187709,
                36.0611255
              ],
              [
                58.2178475,
                36.0589491
              ],
              [
                58.2131897,
                36.0555663
              ],
              [
                58.2050616,
                36.0557446
              ],
              [
                58.1875444,
                36.0590711
              ],
              [
                58.1807871,
                36.0588126
              ],
              [
                58.1741845,
                36.0595791
              ],
              [
                58.1436094,
                36.0698526
              ],
              [
                58.1342344,
                36.072071
              ],
              [
                58.1248855,
                36.0760198
              ],
              [
                58.1155825,
                36.0808873
              ],
              [
                58.1037927,
                36.0856073
              ],
              [
                58.0976471,
                36.0885919
              ],
              [
                58.0839852,
                36.0936559
              ],
              [
                58.0716923,
                36.0958101
              ],
              [
                58.0590879,
                36.0990821
              ],
              [
                58.05145,
                36.0988798
              ],
              [
                58.0447807,
                36.0981977
              ],
              [
                58.0383705,
                36.0990299
              ],
              [
                58.0312116,
                36.0986783
              ],
              [
                58.0184345,
                36.0987498
              ],
              [
                58.00039,
                36.1010384
              ],
              [
                57.9863716,
                36.107007
              ],
              [
                57.9756065,
                36.1115686
              ],
              [
                57.9549888,
                36.1286903
              ],
              [
                57.9326819,
                36.136383
              ],
              [
                57.9204619,
                36.1408247
              ],
              [
                57.9112339,
                36.14332
              ],
              [
                57.902584,
                36.1357259
              ],
              [
                57.9033889,
                36.111106
              ],
              [
                57.8850276,
                36.0967981
              ],
              [
                57.8630943,
                36.0785457
              ],
              [
                57.8299709,
                36.0698457
              ],
              [
                57.7005383,
                36.0796272
              ],
              [
                57.6774134,
                36.0852855
              ],
              [
                57.6642322,
                36.0858699
              ],
              [
                57.6523875,
                36.0848295
              ],
              [
                57.6402854,
                36.0827485
              ],
              [
                57.6236343,
                36.0790721
              ],
              [
                57.6138496,
                36.077754
              ],
              [
                57.600288,
                36.0716494
              ],
              [
                57.588272,
                36.0639482
              ],
              [
                57.587242,
                36.057426
              ],
              [
                57.567844,
                36.051875
              ],
              [
                57.5304221,
                36.007798
              ],
              [
                57.5199508,
                35.9975909
              ],
              [
                57.5152301,
                35.996341
              ],
              [
                57.5112819,
                35.9938411
              ],
              [
                57.5068187,
                35.9897438
              ],
              [
                57.5000489,
                35.9864353
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11096697,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوهسرخ",
          "name:en": "KoohSorkh County",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q6442204",
          "wikipedia": "en:Kuhsorkh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.1699707,
                35.5302385
              ],
              [
                58.1586683,
                35.5159468
              ],
              [
                58.1644846,
                35.5067505
              ],
              [
                58.1755075,
                35.504202
              ],
              [
                58.1885718,
                35.4957574
              ],
              [
                58.1892584,
                35.4875112
              ],
              [
                58.1810187,
                35.4742315
              ],
              [
                58.1938933,
                35.472554
              ],
              [
                58.2060305,
                35.4560786
              ],
              [
                58.2333753,
                35.4294841
              ],
              [
                58.2332468,
                35.4237139
              ],
              [
                58.2319163,
                35.4174539
              ],
              [
                58.2293415,
                35.4138165
              ],
              [
                58.2248781,
                35.4062965
              ],
              [
                58.2238564,
                35.40566
              ],
              [
                58.2313641,
                35.4055675
              ],
              [
                58.2388986,
                35.4053358
              ],
              [
                58.2443618,
                35.4003848
              ],
              [
                58.2505416,
                35.3991954
              ],
              [
                58.2552623,
                35.399895
              ],
              [
                58.2707976,
                35.3772238
              ],
              [
                58.2784366,
                35.3730247
              ],
              [
                58.29629,
                35.3690987
              ],
              [
                58.3305136,
                35.3514953
              ],
              [
                58.3452127,
                35.3457255
              ],
              [
                58.3696882,
                35.3398288
              ],
              [
                58.3955096,
                35.3458655
              ],
              [
                58.3979987,
                35.3465656
              ],
              [
                58.4046077,
                35.363366
              ],
              [
                58.4086417,
                35.3659558
              ],
              [
                58.4137916,
                35.3680556
              ],
              [
                58.4174823,
                35.3684055
              ],
              [
                58.4327602,
                35.3660958
              ],
              [
                58.4371885,
                35.3632472
              ],
              [
                58.4457917,
                35.3577274
              ],
              [
                58.4573996,
                35.3518355
              ],
              [
                58.4681222,
                35.3462926
              ],
              [
                58.4766003,
                35.3399659
              ],
              [
                58.4871536,
                35.3471894
              ],
              [
                58.4899333,
                35.3491283
              ],
              [
                58.5002133,
                35.3555221
              ],
              [
                58.5232665,
                35.3577496
              ],
              [
                58.5243798,
                35.357461
              ],
              [
                58.5282662,
                35.3571904
              ],
              [
                58.5299331,
                35.357461
              ],
              [
                58.5302131,
                35.3571904
              ],
              [
                58.5318796,
                35.3574609
              ],
              [
                58.5327129,
                35.3571904
              ],
              [
                58.5468795,
                35.3574609
              ],
              [
                58.5477127,
                35.3577495
              ],
              [
                58.5646592,
                35.3594088
              ],
              [
                58.5704926,
                35.3594088
              ],
              [
                58.5707655,
                35.3596883
              ],
              [
                58.5713257,
                35.3594088
              ],
              [
                58.5715991,
                35.3596884
              ],
              [
                58.5729926,
                35.3596883
              ],
              [
                58.5735457,
                35.3599679
              ],
              [
                58.5752126,
                35.3599679
              ],
              [
                58.5757723,
                35.3602474
              ],
              [
                58.5774391,
                35.3602475
              ],
              [
                58.5779923,
                35.3599678
              ],
              [
                58.5846589,
                35.3599679
              ],
              [
                58.5849389,
                35.3599679
              ],
              [
                58.5857725,
                35.3596883
              ],
              [
                58.587439,
                35.3596883
              ],
              [
                58.5879921,
                35.3594087
              ],
              [
                58.5924391,
                35.3594087
              ],
              [
                58.5932723,
                35.3591292
              ],
              [
                58.5963255,
                35.3588587
              ],
              [
                58.600492,
                35.3588586
              ],
              [
                58.6010455,
                35.358579
              ],
              [
                58.605212,
                35.358579
              ],
              [
                58.6054921,
                35.3588586
              ],
              [
                58.6382717,
                35.3605269
              ],
              [
                58.6579982,
                35.3613565
              ],
              [
                58.6616046,
                35.3616361
              ],
              [
                58.6646649,
                35.3619066
              ],
              [
                58.6682711,
                35.3619066
              ],
              [
                58.6693848,
                35.3621861
              ],
              [
                58.6729978,
                35.3621862
              ],
              [
                58.6735513,
                35.3624657
              ],
              [
                58.680498,
                35.3632953
              ],
              [
                58.6835512,
                35.3632953
              ],
              [
                58.6843845,
                35.3635749
              ],
              [
                58.6860512,
                35.3635749
              ],
              [
                58.6879977,
                35.364134
              ],
              [
                58.7046641,
                35.3663524
              ],
              [
                58.7068841,
                35.3663524
              ],
              [
                58.7079973,
                35.366632
              ],
              [
                58.7093841,
                35.3666319
              ],
              [
                58.7104974,
                35.3669115
              ],
              [
                58.7135506,
                35.367182
              ],
              [
                58.7216109,
                35.3671821
              ],
              [
                58.721884,
                35.3674706
              ],
              [
                58.7224442,
                35.3671821
              ],
              [
                58.7318908,
                35.3671821
              ],
              [
                58.7349441,
                35.367182
              ],
              [
                58.741103,
                35.367182
              ],
              [
                58.7463302,
                35.367182
              ],
              [
                58.7466103,
                35.3674706
              ],
              [
                58.7471639,
                35.367182
              ],
              [
                58.7477236,
                35.3674705
              ],
              [
                58.7557769,
                35.3685797
              ],
              [
                58.7786064,
                35.3696357
              ],
              [
                58.7707546,
                35.3814071
              ],
              [
                58.7707545,
                35.3816867
              ],
              [
                58.7693336,
                35.3884646
              ],
              [
                58.7691305,
                35.432841
              ],
              [
                58.7820052,
                35.4494137
              ],
              [
                58.791425,
                35.4772256
              ],
              [
                58.7650106,
                35.4868123
              ],
              [
                58.7725637,
                35.4944995
              ],
              [
                58.7723921,
                35.5002994
              ],
              [
                58.7767852,
                35.5148717
              ],
              [
                58.7820197,
                35.5348163
              ],
              [
                58.7747992,
                35.5413928
              ],
              [
                58.7736858,
                35.5419429
              ],
              [
                58.7734128,
                35.5425018
              ],
              [
                58.7722992,
                35.5430518
              ],
              [
                58.7623625,
                35.5630979
              ],
              [
                58.7595894,
                35.5742044
              ],
              [
                58.720894,
                35.5756855
              ],
              [
                58.6951854,
                35.5779196
              ],
              [
                58.6875882,
                35.5796111
              ],
              [
                58.673515,
                35.583339
              ],
              [
                58.6687085,
                35.5928317
              ],
              [
                58.6615148,
                35.6026528
              ],
              [
                58.6596438,
                35.6141807
              ],
              [
                58.6584694,
                35.6190505
              ],
              [
                58.6584693,
                35.6214232
              ],
              [
                58.6607265,
                35.6268146
              ],
              [
                58.6687085,
                35.6377672
              ],
              [
                58.6605197,
                35.6516547
              ],
              [
                58.6515083,
                35.656943
              ],
              [
                58.6318012,
                35.6698485
              ],
              [
                58.6101769,
                35.67501
              ],
              [
                58.5940365,
                35.6765101
              ],
              [
                58.5847663,
                35.6747292
              ],
              [
                58.5701751,
                35.6754961
              ],
              [
                58.5553742,
                35.6792209
              ],
              [
                58.541851,
                35.6794005
              ],
              [
                58.530092,
                35.6811302
              ],
              [
                58.5180807,
                35.6835624
              ],
              [
                58.4988839,
                35.6822809
              ],
              [
                58.4936999,
                35.6821893
              ],
              [
                58.4840011,
                35.6833744
              ],
              [
                58.4731452,
                35.6903996
              ],
              [
                58.4679152,
                35.6970817
              ],
              [
                58.4645237,
                35.7019551
              ],
              [
                58.4603117,
                35.7094441
              ],
              [
                58.45705,
                35.7237998
              ],
              [
                58.4603117,
                35.7327183
              ],
              [
                58.4809106,
                35.7490206
              ],
              [
                58.4912103,
                35.7810572
              ],
              [
                58.4885863,
                35.8030906
              ],
              [
                58.4672404,
                35.8392342
              ],
              [
                58.4623718,
                35.8486394
              ],
              [
                58.4573996,
                35.8561612
              ],
              [
                58.4518744,
                35.861416
              ],
              [
                58.4384079,
                35.8628071
              ],
              [
                58.4158515,
                35.8647088
              ],
              [
                58.394823,
                35.8638741
              ],
              [
                58.3858302,
                35.8654348
              ],
              [
                58.3751129,
                35.8698169
              ],
              [
                58.3517172,
                35.8574347
              ],
              [
                58.3394616,
                35.8528836
              ],
              [
                58.3023827,
                35.8606748
              ],
              [
                58.2783501,
                35.851214
              ],
              [
                58.2653039,
                35.8384122
              ],
              [
                58.2268517,
                35.8239382
              ],
              [
                58.1897729,
                35.8233814
              ],
              [
                58.1842797,
                35.8194841
              ],
              [
                58.1829064,
                35.8033359
              ],
              [
                58.1835931,
                35.7699155
              ],
              [
                58.1938927,
                35.750971
              ],
              [
                58.2019782,
                35.7415995
              ],
              [
                58.2134895,
                35.7226894
              ],
              [
                58.2179778,
                35.6985879
              ],
              [
                58.217144,
                35.6971905
              ],
              [
                58.2345402,
                35.6813828
              ],
              [
                58.2339866,
                35.6805535
              ],
              [
                58.2298201,
                35.6702767
              ],
              [
                58.2287068,
                35.6683385
              ],
              [
                58.217037,
                35.6641887
              ],
              [
                58.1641813,
                35.6426095
              ],
              [
                58.1627946,
                35.6398336
              ],
              [
                58.1602945,
                35.6362286
              ],
              [
                58.1589011,
                35.6303975
              ],
              [
                58.1586281,
                35.6279011
              ],
              [
                58.1568142,
                35.6185122
              ],
              [
                58.1447979,
                35.612372
              ],
              [
                58.1240789,
                35.6016865
              ],
              [
                58.1238059,
                35.6011275
              ],
              [
                58.1238059,
                35.5966831
              ],
              [
                58.1243591,
                35.5939064
              ],
              [
                58.1251923,
                35.5891824
              ],
              [
                58.1688278,
                35.5755704
              ],
              [
                58.1939504,
                35.5708861
              ],
              [
                58.2094564,
                35.5537793
              ],
              [
                58.1873702,
                35.5553427
              ],
              [
                58.1779288,
                35.5522004
              ],
              [
                58.1722639,
                35.5442393
              ],
              [
                58.1699707,
                35.5302385
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 12173252,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گلبهار",
          "name:en": "Golbahar County",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.9283026,
                36.5168019
              ],
              [
                58.94474,
                36.4961138
              ],
              [
                58.9306637,
                36.4847971
              ],
              [
                58.9255139,
                36.458017
              ],
              [
                58.9136699,
                36.4460121
              ],
              [
                58.9162198,
                36.4415095
              ],
              [
                58.9237588,
                36.4355656
              ],
              [
                58.929119,
                36.4271529
              ],
              [
                58.9352988,
                36.4210753
              ],
              [
                58.944534,
                36.4137079
              ],
              [
                58.9524549,
                36.4072123
              ],
              [
                58.9543738,
                36.4050622
              ],
              [
                58.9604179,
                36.4011245
              ],
              [
                58.961048,
                36.3975894
              ],
              [
                58.9579388,
                36.3869528
              ],
              [
                58.9632368,
                36.3819742
              ],
              [
                58.9806649,
                36.3674901
              ],
              [
                58.9905309,
                36.3593404
              ],
              [
                58.9964582,
                36.3527956
              ],
              [
                59.001646,
                36.3475199
              ],
              [
                59.0060663,
                36.3448583
              ],
              [
                59.0072679,
                36.339604
              ],
              [
                59.0238318,
                36.3342589
              ],
              [
                59.0281069,
                36.330335
              ],
              [
                59.0312575,
                36.3281262
              ],
              [
                59.0327167,
                36.3261209
              ],
              [
                59.0462779,
                36.3246687
              ],
              [
                59.0601825,
                36.3228016
              ],
              [
                59.0667757,
                36.3207154
              ],
              [
                59.0742822,
                36.3271931
              ],
              [
                59.0796282,
                36.3331693
              ],
              [
                59.0774823,
                36.3392564
              ],
              [
                59.0765818,
                36.3430293
              ],
              [
                59.0809341,
                36.3484953
              ],
              [
                59.0845333,
                36.3702331
              ],
              [
                59.0874766,
                36.3781736
              ],
              [
                59.0927066,
                36.3864194
              ],
              [
                59.1029262,
                36.3953786
              ],
              [
                59.1101378,
                36.4031588
              ],
              [
                59.1151044,
                36.4061316
              ],
              [
                59.1254997,
                36.4095059
              ],
              [
                59.1360688,
                36.4118678
              ],
              [
                59.1437387,
                36.4132704
              ],
              [
                59.1498756,
                36.4134431
              ],
              [
                59.1565173,
                36.4200935
              ],
              [
                59.1656536,
                36.4220649
              ],
              [
                59.1803701,
                36.4274035
              ],
              [
                59.187415,
                36.4268332
              ],
              [
                59.2070586,
                36.4224131
              ],
              [
                59.2183683,
                36.4230783
              ],
              [
                59.2193126,
                36.4310201
              ],
              [
                59.2275927,
                36.4344661
              ],
              [
                59.233451,
                36.4365438
              ],
              [
                59.2435809,
                36.4408249
              ],
              [
                59.2496108,
                36.4437947
              ],
              [
                59.2566489,
                36.4415852
              ],
              [
                59.2680473,
                36.4416566
              ],
              [
                59.2781066,
                36.4497324
              ],
              [
                59.2791125,
                36.4556091
              ],
              [
                59.2850589,
                36.46844
              ],
              [
                59.2907237,
                36.4825196
              ],
              [
                59.2933845,
                36.4912145
              ],
              [
                59.2960452,
                36.4932846
              ],
              [
                59.2997359,
                36.4990805
              ],
              [
                59.3044005,
                36.5082682
              ],
              [
                59.3081473,
                36.5142582
              ],
              [
                59.3132471,
                36.5226768
              ],
              [
                59.3101731,
                36.5238668
              ],
              [
                59.3024825,
                36.5275018
              ],
              [
                59.2852306,
                36.5339848
              ],
              [
                59.2737292,
                36.5390881
              ],
              [
                59.2674768,
                36.5445207
              ],
              [
                59.2672193,
                36.5480448
              ],
              [
                59.2689537,
                36.5545026
              ],
              [
                59.2650175,
                36.5565331
              ],
              [
                59.2572927,
                36.5592564
              ],
              [
                59.2565506,
                36.5601159
              ],
              [
                59.25651,
                36.5617063
              ],
              [
                59.2588226,
                36.5632987
              ],
              [
                59.2598097,
                36.564164
              ],
              [
                59.2664547,
                36.5674743
              ],
              [
                59.2710256,
                36.5703209
              ],
              [
                59.2743301,
                36.5713549
              ],
              [
                59.2841976,
                36.5687453
              ],
              [
                59.3056601,
                36.5821492
              ],
              [
                59.3208072,
                36.5822678
              ],
              [
                59.3312619,
                36.5780909
              ],
              [
                59.3516387,
                36.5707344
              ],
              [
                59.3679713,
                36.5725958
              ],
              [
                59.367113,
                36.5768693
              ],
              [
                59.360504,
                36.580867
              ],
              [
                59.3456554,
                36.5845888
              ],
              [
                59.3370075,
                36.58833
              ],
              [
                59.3371766,
                36.591092
              ],
              [
                59.3386874,
                36.5938556
              ],
              [
                59.3508909,
                36.5989918
              ],
              [
                59.3647686,
                36.6041742
              ],
              [
                59.3653221,
                36.6041741
              ],
              [
                59.3695928,
                36.605719
              ],
              [
                59.3700076,
                36.6109135
              ],
              [
                59.3703317,
                36.6152866
              ],
              [
                59.3703746,
                36.6201434
              ],
              [
                59.3698596,
                36.6270319
              ],
              [
                59.3827342,
                36.6589866
              ],
              [
                59.3832325,
                36.6646364
              ],
              [
                59.3815326,
                36.6701401
              ],
              [
                59.3821334,
                36.677506
              ],
              [
                59.384365,
                36.6813608
              ],
              [
                59.3853091,
                36.6841829
              ],
              [
                59.3861674,
                36.6878997
              ],
              [
                59.3851375,
                36.6926487
              ],
              [
                59.3829917,
                36.6955392
              ],
              [
                59.3817042,
                36.699049
              ],
              [
                59.380331,
                36.7055176
              ],
              [
                59.3815179,
                36.7095721
              ],
              [
                59.385395,
                36.7156323
              ],
              [
                59.3898582,
                36.7214115
              ],
              [
                59.3894287,
                36.7255395
              ],
              [
                59.3900298,
                36.7327623
              ],
              [
                59.3956946,
                36.7391593
              ],
              [
                59.3983551,
                36.7441117
              ],
              [
                59.3988701,
                36.7463125
              ],
              [
                59.393892,
                36.7496824
              ],
              [
                59.3911915,
                36.7568076
              ],
              [
                59.3902014,
                36.7607539
              ],
              [
                59.3668554,
                36.7768426
              ],
              [
                59.3405913,
                36.7962271
              ],
              [
                59.3332659,
                36.8041235
              ],
              [
                59.3234826,
                36.8087903
              ],
              [
                59.301188,
                36.8139844
              ],
              [
                59.2957512,
                36.8107382
              ],
              [
                59.2930411,
                36.8077729
              ],
              [
                59.2874621,
                36.8053677
              ],
              [
                59.2763042,
                36.8063985
              ],
              [
                59.2743301,
                36.8046117
              ],
              [
                59.2722701,
                36.8015879
              ],
              [
                59.2729031,
                36.7970624
              ],
              [
                59.2696094,
                36.7933403
              ],
              [
                59.269266,
                36.7866041
              ],
              [
                59.2666053,
                36.7742301
              ],
              [
                59.2660045,
                36.7674235
              ],
              [
                59.2656612,
                36.7599286
              ],
              [
                59.265747,
                36.7500949
              ],
              [
                59.2698735,
                36.743794
              ],
              [
                59.2777088,
                36.7244988
              ],
              [
                59.2797921,
                36.7233603
              ],
              [
                59.2789705,
                36.721481
              ],
              [
                59.2711902,
                36.6822176
              ],
              [
                59.2634304,
                36.6819837
              ],
              [
                59.2497703,
                36.681089
              ],
              [
                59.2298982,
                36.6841136
              ],
              [
                59.22296,
                36.6859033
              ],
              [
                59.2156509,
                36.690725
              ],
              [
                59.2138987,
                36.693891
              ],
              [
                59.201188,
                36.6914357
              ],
              [
                59.1974372,
                36.6913099
              ],
              [
                59.1895354,
                36.7041102
              ],
              [
                59.1837013,
                36.7043816
              ],
              [
                59.1716716,
                36.7027989
              ],
              [
                59.1638551,
                36.6947326
              ],
              [
                59.1589393,
                36.6954385
              ],
              [
                59.1508137,
                36.6947501
              ],
              [
                59.1418678,
                36.6882686
              ],
              [
                59.1384823,
                36.6848682
              ],
              [
                59.1371746,
                36.6800735
              ],
              [
                59.1390609,
                36.674959
              ],
              [
                59.1405722,
                36.6708594
              ],
              [
                59.1359822,
                36.6614601
              ],
              [
                59.1342115,
                36.6585735
              ],
              [
                59.1316795,
                36.6524796
              ],
              [
                59.1355848,
                36.6502761
              ],
              [
                59.1401338,
                36.6489333
              ],
              [
                59.1412067,
                36.6415647
              ],
              [
                59.1436271,
                36.6384552
              ],
              [
                59.1517568,
                36.6350301
              ],
              [
                59.1631782,
                36.6278392
              ],
              [
                59.162618,
                36.6269725
              ],
              [
                59.162911,
                36.6252048
              ],
              [
                59.160615,
                36.622653
              ],
              [
                59.1434911,
                36.6230899
              ],
              [
                59.1391995,
                36.6179349
              ],
              [
                59.1331779,
                36.620141
              ],
              [
                59.1232522,
                36.6054666
              ],
              [
                59.1160582,
                36.5976136
              ],
              [
                59.0923152,
                36.5575743
              ],
              [
                59.052999,
                36.5684591
              ],
              [
                59.0298673,
                36.5515549
              ],
              [
                59.0001867,
                36.5599804
              ],
              [
                58.9840506,
                36.5599804
              ],
              [
                58.9810465,
                36.5506037
              ],
              [
                58.9531174,
                36.5493893
              ],
              [
                58.9367997,
                36.5347376
              ],
              [
                58.9465032,
                36.5211181
              ],
              [
                58.9283026,
                36.5168019
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 301192864
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.8762448,
          36.3512877
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 529657658
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.6859427,
          34.350302
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 529660378
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.1834619,
          34.5163087
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 689424695
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.1440373,
          34.5723166
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 681298011
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.464248,
          35.2444908
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 689323994
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.9685311,
          35.2611338
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 689324097
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.2863427,
          35.2545313
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139199
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.4586724,
          35.4751589
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139225
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.766785,
          35.9585753
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32675333
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.6808799,
          36.2134053
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139223
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.6829884,
          36.0433722
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 593880695
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.0386871,
          36.405159
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139247
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.5868002,
          36.2863586
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 344546541
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.7859967,
          35.0222084
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2055287338
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.2194494,
          35.2740853
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139184
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.5197222,
          35.2822222
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 689424437
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.6245967,
          34.9751301
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 689462984
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.3148224,
          34.9941781
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32675715
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.7922291,
          36.2105604
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139189
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.0597459,
          36.1063279
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 283421516
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.3741338,
          36.3097179
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 301435357
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.8465304,
          35.701215
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 26038568
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.6059232,
          36.2974945
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 314341491
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.7755127,
          34.7401763
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 280785801
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.626313,
          35.2432546
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139212
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.0943286,
          35.6871984
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139191
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.0743721,
          36.638031
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 835139206
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.4086684,
          36.7105093
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 265555072
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.5108056,
          37.105993
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 479109268
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.1185005,
          36.6483961
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 587748039
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.7642219,
          36.9953881
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 479109269
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.1064876,
          37.4470313
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3921022605
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.1564431,
          36.5399097
        ]
      }
    }
  ]
},
"خراسان شمالی.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 269911,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شیروان",
          "name:en": "Shirwan County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286343"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.4940048,
                37.7130052
              ],
              [
                57.4951115,
                37.7130053
              ],
              [
                57.4956716,
                37.7130052
              ],
              [
                57.4997806,
                37.7093562
              ],
              [
                57.501429,
                37.6985483
              ],
              [
                57.5014291,
                37.6971544
              ],
              [
                57.501429,
                37.6968757
              ],
              [
                57.5036429,
                37.6714569
              ],
              [
                57.5005585,
                37.6565338
              ],
              [
                57.5206207,
                37.6477629
              ],
              [
                57.5350235,
                37.6363549
              ],
              [
                57.5428342,
                37.6275794
              ],
              [
                57.5495505,
                37.62
              ],
              [
                57.5603859,
                37.6062992
              ],
              [
                57.568694,
                37.5947437
              ],
              [
                57.5909553,
                37.5821178
              ],
              [
                57.6010819,
                37.5696126
              ],
              [
                57.6065001,
                37.5633025
              ],
              [
                57.6290416,
                37.5562817
              ],
              [
                57.6414686,
                37.5537359
              ],
              [
                57.6553223,
                37.5505083
              ],
              [
                57.662773,
                37.5417191
              ],
              [
                57.6742744,
                37.5271537
              ],
              [
                57.677536,
                37.5205847
              ],
              [
                57.6798269,
                37.5179678
              ],
              [
                57.6645895,
                37.5128172
              ],
              [
                57.6820358,
                37.5066766
              ],
              [
                57.6986502,
                37.5005339
              ],
              [
                57.7028093,
                37.494267
              ],
              [
                57.7130232,
                37.477568
              ],
              [
                57.7197063,
                37.4652516
              ],
              [
                57.7125046,
                37.4578559
              ],
              [
                57.7054032,
                37.4475127
              ],
              [
                57.7011393,
                37.438066
              ],
              [
                57.6971812,
                37.4260344
              ],
              [
                57.6961286,
                37.4153136
              ],
              [
                57.7009678,
                37.4098633
              ],
              [
                57.7046798,
                37.4068849
              ],
              [
                57.7046098,
                37.4060082
              ],
              [
                57.6944328,
                37.398268
              ],
              [
                57.6907967,
                37.3954939
              ],
              [
                57.6798475,
                37.3833022
              ],
              [
                57.6695101,
                37.3648335
              ],
              [
                57.6667301,
                37.3614957
              ],
              [
                57.6645101,
                37.3587157
              ],
              [
                57.660713,
                37.3454604
              ],
              [
                57.6548765,
                37.3335866
              ],
              [
                57.6420538,
                37.3302828
              ],
              [
                57.6418303,
                37.3245777
              ],
              [
                57.6432036,
                37.3174789
              ],
              [
                57.6406286,
                37.3129736
              ],
              [
                57.639942,
                37.3046449
              ],
              [
                57.6261174,
                37.2948155
              ],
              [
                57.628784,
                37.284024
              ],
              [
                57.6258658,
                37.278424
              ],
              [
                57.6253508,
                37.2696816
              ],
              [
                57.6191711,
                37.2516814
              ],
              [
                57.6180982,
                37.2476846
              ],
              [
                57.6164245,
                37.2461815
              ],
              [
                57.6159757,
                37.2447521
              ],
              [
                57.6316072,
                37.242757
              ],
              [
                57.7216239,
                37.2268861
              ],
              [
                57.7499083,
                37.2167738
              ],
              [
                57.7614482,
                37.2094281
              ],
              [
                57.7658557,
                37.2069528
              ],
              [
                57.768774,
                37.20415
              ],
              [
                57.7843093,
                37.1975185
              ],
              [
                57.7910899,
                37.1936897
              ],
              [
                57.7949523,
                37.1901342
              ],
              [
                57.8070544,
                37.1858948
              ],
              [
                57.8116035,
                37.1819288
              ],
              [
                57.812376,
                37.1765263
              ],
              [
                57.8118979,
                37.173261
              ],
              [
                57.8142037,
                37.1673239
              ],
              [
                57.8164105,
                37.1596962
              ],
              [
                57.8172439,
                37.1551491
              ],
              [
                57.8207015,
                37.1503292
              ],
              [
                57.824993,
                37.1478663
              ],
              [
                57.8309209,
                37.1453922
              ],
              [
                57.8436183,
                37.1443087
              ],
              [
                57.8531455,
                37.1415035
              ],
              [
                57.8626521,
                37.1348789
              ],
              [
                57.8664493,
                37.1292554
              ],
              [
                57.8704895,
                37.125219
              ],
              [
                57.8839586,
                37.1239862
              ],
              [
                57.9012965,
                37.1224806
              ],
              [
                57.9036997,
                37.1207696
              ],
              [
                57.9185484,
                37.1285712
              ],
              [
                57.9331397,
                37.1442404
              ],
              [
                57.9404401,
                37.1510833
              ],
              [
                57.9560885,
                37.167983
              ],
              [
                57.9641814,
                37.1772389
              ],
              [
                57.9731368,
                37.1796722
              ],
              [
                57.9799174,
                37.1829545
              ],
              [
                57.9889731,
                37.1942825
              ],
              [
                58.0016097,
                37.2012079
              ],
              [
                58.0091095,
                37.2142654
              ],
              [
                58.0096631,
                37.2148233
              ],
              [
                58.0222703,
                37.2296797
              ],
              [
                58.0361257,
                37.2396804
              ],
              [
                58.0495691,
                37.2488461
              ],
              [
                58.054161,
                37.2540726
              ],
              [
                58.0639457,
                37.2584106
              ],
              [
                58.0717179,
                37.2633966
              ],
              [
                58.0729803,
                37.2641878
              ],
              [
                58.0779394,
                37.269082
              ],
              [
                58.0804681,
                37.2714574
              ],
              [
                58.087635,
                37.2768531
              ],
              [
                58.0945406,
                37.2798146
              ],
              [
                58.1019797,
                37.2817916
              ],
              [
                58.1117575,
                37.282947
              ],
              [
                58.1195202,
                37.2802495
              ],
              [
                58.1259414,
                37.2748829
              ],
              [
                58.1329106,
                37.2735065
              ],
              [
                58.1441973,
                37.2754531
              ],
              [
                58.1490319,
                37.2780496
              ],
              [
                58.1539768,
                37.2833422
              ],
              [
                58.1563185,
                37.2857703
              ],
              [
                58.1571917,
                37.2877641
              ],
              [
                58.1583469,
                37.290208
              ],
              [
                58.1611365,
                37.2960348
              ],
              [
                58.1599473,
                37.3006851
              ],
              [
                58.1525884,
                37.307819
              ],
              [
                58.1531119,
                37.3141576
              ],
              [
                58.1536427,
                37.3215928
              ],
              [
                58.1539657,
                37.325208
              ],
              [
                58.155146,
                37.3312156
              ],
              [
                58.1602327,
                37.3450656
              ],
              [
                58.1625667,
                37.3504623
              ],
              [
                58.1652803,
                37.3695717
              ],
              [
                58.166631,
                37.3747368
              ],
              [
                58.1672,
                37.3946415
              ],
              [
                58.1673717,
                37.3990055
              ],
              [
                58.1655477,
                37.4210529
              ],
              [
                58.168196,
                37.4277755
              ],
              [
                58.1712295,
                37.4323787
              ],
              [
                58.1731966,
                37.4339935
              ],
              [
                58.185442,
                37.4450859
              ],
              [
                58.2099801,
                37.4462296
              ],
              [
                58.2113665,
                37.4476235
              ],
              [
                58.2629814,
                37.470296
              ],
              [
                58.269648,
                37.475576
              ],
              [
                58.2701563,
                37.4836838
              ],
              [
                58.2709899,
                37.4850691
              ],
              [
                58.2718231,
                37.4884062
              ],
              [
                58.2718231,
                37.493677
              ],
              [
                58.2632433,
                37.4992464
              ],
              [
                58.2629702,
                37.5011896
              ],
              [
                58.26241,
                37.5023051
              ],
              [
                58.26241,
                37.5034117
              ],
              [
                58.2618565,
                37.5045272
              ],
              [
                58.2615764,
                37.5061914
              ],
              [
                58.2610233,
                37.5073069
              ],
              [
                58.2604702,
                37.5134153
              ],
              [
                58.261745,
                37.5423621
              ],
              [
                58.2620252,
                37.5431985
              ],
              [
                58.2612255,
                37.5503571
              ],
              [
                58.2550315,
                37.5836282
              ],
              [
                58.2553047,
                37.5847439
              ],
              [
                58.2491983,
                37.5969712
              ],
              [
                58.2411384,
                37.6019736
              ],
              [
                58.2210156,
                37.6204865
              ],
              [
                58.2134203,
                37.6290466
              ],
              [
                58.2128671,
                37.6293254
              ],
              [
                58.2192991,
                37.6418303
              ],
              [
                58.2194708,
                37.6555578
              ],
              [
                58.223934,
                37.6664293
              ],
              [
                58.2238155,
                37.6789146
              ],
              [
                58.2333025,
                37.6793376
              ],
              [
                58.2421005,
                37.680074
              ],
              [
                58.2357033,
                37.6817136
              ],
              [
                58.2270467,
                37.6840365
              ],
              [
                58.2260609,
                37.692836
              ],
              [
                58.2289739,
                37.6987164
              ],
              [
                58.2282752,
                37.7017188
              ],
              [
                58.229662,
                37.7030492
              ],
              [
                58.2325767,
                37.7043333
              ],
              [
                58.2335146,
                37.7053932
              ],
              [
                58.234376,
                37.7066255
              ],
              [
                58.2346464,
                37.7070215
              ],
              [
                58.2344858,
                37.7075144
              ],
              [
                58.2337484,
                37.7082837
              ],
              [
                58.2333865,
                37.708995
              ],
              [
                58.2326344,
                37.7097757
              ],
              [
                58.2321857,
                37.7105082
              ],
              [
                58.232053,
                37.7114041
              ],
              [
                58.2313292,
                37.7123107
              ],
              [
                58.229136,
                37.7259542
              ],
              [
                58.2278568,
                37.7290972
              ],
              [
                58.2259349,
                37.7307373
              ],
              [
                58.2253059,
                37.7332854
              ],
              [
                58.2252248,
                37.7358549
              ],
              [
                58.2250647,
                37.73651
              ],
              [
                58.2245287,
                37.7372095
              ],
              [
                58.222782,
                37.7380478
              ],
              [
                58.2216857,
                37.7382868
              ],
              [
                58.2208933,
                37.738322
              ],
              [
                58.2203892,
                37.7382056
              ],
              [
                58.2185295,
                37.7382969
              ],
              [
                58.2180233,
                37.7388362
              ],
              [
                58.2176762,
                37.7390763
              ],
              [
                58.2174578,
                37.739732
              ],
              [
                58.2175846,
                37.7405013
              ],
              [
                58.2172079,
                37.7410617
              ],
              [
                58.2171484,
                37.7417158
              ],
              [
                58.2168727,
                37.7422098
              ],
              [
                58.2165408,
                37.7422561
              ],
              [
                58.2155008,
                37.7429427
              ],
              [
                58.2141264,
                37.7443088
              ],
              [
                58.2138359,
                37.7449855
              ],
              [
                58.2138196,
                37.7454206
              ],
              [
                58.2137023,
                37.7460977
              ],
              [
                58.2138848,
                37.7474523
              ],
              [
                58.213782,
                37.7479806
              ],
              [
                58.2135344,
                37.7485419
              ],
              [
                58.2134424,
                37.7486465
              ],
              [
                58.2135489,
                37.7488685
              ],
              [
                58.2136832,
                37.7490091
              ],
              [
                58.2139412,
                37.7496936
              ],
              [
                58.2141272,
                37.7506989
              ],
              [
                58.2142329,
                37.7518717
              ],
              [
                58.2144477,
                37.7525567
              ],
              [
                58.214514,
                37.7542685
              ],
              [
                58.2142151,
                37.755121
              ],
              [
                58.2137963,
                37.7560626
              ],
              [
                58.2131418,
                37.7586943
              ],
              [
                58.2114241,
                37.7630877
              ],
              [
                58.2092512,
                37.7679521
              ],
              [
                58.2082201,
                37.7699545
              ],
              [
                58.2067575,
                37.7722182
              ],
              [
                58.2058141,
                37.7732485
              ],
              [
                58.2037562,
                37.7743015
              ],
              [
                58.2003642,
                37.7748003
              ],
              [
                58.1986587,
                37.7747839
              ],
              [
                58.1971946,
                37.7751795
              ],
              [
                58.1960306,
                37.7759597
              ],
              [
                58.194572,
                37.77718
              ],
              [
                58.1934393,
                37.7779282
              ],
              [
                58.1917512,
                37.7787858
              ],
              [
                58.1894425,
                37.7796247
              ],
              [
                58.1877775,
                37.7799795
              ],
              [
                58.1865012,
                37.7803664
              ],
              [
                58.1838395,
                37.7807019
              ],
              [
                58.1817778,
                37.7808825
              ],
              [
                58.1793399,
                37.7813734
              ],
              [
                58.1742164,
                37.7830378
              ],
              [
                58.1729211,
                37.7835284
              ],
              [
                58.1716078,
                37.784098
              ],
              [
                58.1703605,
                37.7847976
              ],
              [
                58.1688601,
                37.7859707
              ],
              [
                58.1677903,
                37.7865919
              ],
              [
                58.1665234,
                37.7870956
              ],
              [
                58.1629431,
                37.7878971
              ],
              [
                58.1614857,
                37.7887497
              ],
              [
                58.1606023,
                37.7894006
              ],
              [
                58.1586479,
                37.7906996
              ],
              [
                58.1574463,
                37.7916623
              ],
              [
                58.1562246,
                37.7924291
              ],
              [
                58.1548174,
                37.7928259
              ],
              [
                58.1538069,
                37.7927953
              ],
              [
                58.1531945,
                37.7925827
              ],
              [
                58.1525622,
                37.7921833
              ],
              [
                58.1515962,
                37.7911788
              ],
              [
                58.1505258,
                37.7896211
              ],
              [
                58.1489389,
                37.7889088
              ],
              [
                58.1466756,
                37.7874978
              ],
              [
                58.1457407,
                37.7867588
              ],
              [
                58.144853,
                37.7856183
              ],
              [
                58.1439205,
                37.7845233
              ],
              [
                58.1429788,
                37.7842553
              ],
              [
                58.1417406,
                37.7838167
              ],
              [
                58.1410053,
                37.7834498
              ],
              [
                58.1392236,
                37.7832011
              ],
              [
                58.1374255,
                37.783
              ],
              [
                58.1358233,
                37.7829298
              ],
              [
                58.133678,
                37.7827161
              ],
              [
                58.1322639,
                37.7826509
              ],
              [
                58.1311355,
                37.7826527
              ],
              [
                58.1300314,
                37.7827692
              ],
              [
                58.1288481,
                37.7827107
              ],
              [
                58.1266956,
                37.7823482
              ],
              [
                58.1261575,
                37.7827116
              ],
              [
                58.1264461,
                37.783351
              ],
              [
                58.1264279,
                37.783741
              ],
              [
                58.1258614,
                37.7856526
              ],
              [
                58.1255504,
                37.7864352
              ],
              [
                58.1251409,
                37.7880772
              ],
              [
                58.1247421,
                37.7888809
              ],
              [
                58.1241327,
                37.7898398
              ],
              [
                58.1238162,
                37.7907374
              ],
              [
                58.1231091,
                37.7919428
              ],
              [
                58.1212676,
                37.7945177
              ],
              [
                58.1207581,
                37.795514
              ],
              [
                58.1200794,
                37.7957931
              ],
              [
                58.1188086,
                37.7960643
              ],
              [
                58.1174264,
                37.7959197
              ],
              [
                58.1143314,
                37.7949778
              ],
              [
                58.11204,
                37.7941748
              ],
              [
                58.110486,
                37.7936915
              ],
              [
                58.1089092,
                37.7927736
              ],
              [
                58.1066502,
                37.7912807
              ],
              [
                58.1054131,
                37.7905217
              ],
              [
                58.1039518,
                37.7899157
              ],
              [
                58.1027572,
                37.7882483
              ],
              [
                58.1017586,
                37.7882531
              ],
              [
                58.1012632,
                37.7886408
              ],
              [
                58.1005433,
                37.7894902
              ],
              [
                58.1001216,
                37.7901566
              ],
              [
                58.0998834,
                37.7912291
              ],
              [
                58.0990845,
                37.7928341
              ],
              [
                58.0983034,
                37.7940626
              ],
              [
                58.0981186,
                37.7946209
              ],
              [
                58.0965082,
                37.7965578
              ],
              [
                58.096481,
                37.7983719
              ],
              [
                58.0960844,
                37.8006446
              ],
              [
                58.0961936,
                37.8014052
              ],
              [
                58.0958326,
                37.8020034
              ],
              [
                58.0954427,
                37.8019912
              ],
              [
                58.0951775,
                37.8017774
              ],
              [
                58.0940262,
                37.7998143
              ],
              [
                58.0927934,
                37.7983409
              ],
              [
                58.0923451,
                37.7980296
              ],
              [
                58.0914576,
                37.7978305
              ],
              [
                58.0898047,
                37.7979066
              ],
              [
                58.0887057,
                37.7978965
              ],
              [
                58.0881826,
                37.7979509
              ],
              [
                58.0876112,
                37.7981049
              ],
              [
                58.086693,
                37.7988592
              ],
              [
                58.0863809,
                37.7996529
              ],
              [
                58.0861583,
                37.8006915
              ],
              [
                58.0850925,
                37.8021298
              ],
              [
                58.0842294,
                37.8026312
              ],
              [
                58.0817618,
                37.8034177
              ],
              [
                58.0804796,
                37.8036098
              ],
              [
                58.0796279,
                37.8038699
              ],
              [
                58.0789645,
                37.8041374
              ],
              [
                58.0775558,
                37.8045671
              ],
              [
                58.0763766,
                37.8050128
              ],
              [
                58.0747472,
                37.8052056
              ],
              [
                58.0726943,
                37.805177
              ],
              [
                58.0705289,
                37.8047799
              ],
              [
                58.0671313,
                37.8038148
              ],
              [
                58.0657649,
                37.8033382
              ],
              [
                58.0640952,
                37.8025534
              ],
              [
                58.0631754,
                37.8024221
              ],
              [
                58.0617067,
                37.802584
              ],
              [
                58.0605395,
                37.8027793
              ],
              [
                58.0589563,
                37.8032239
              ],
              [
                58.0558992,
                37.8039115
              ],
              [
                58.0528316,
                37.8042206
              ],
              [
                58.0505039,
                37.8041851
              ],
              [
                58.0493747,
                37.8042087
              ],
              [
                58.0473058,
                37.804502
              ],
              [
                58.0456923,
                37.8046695
              ],
              [
                58.0442716,
                37.8047182
              ],
              [
                58.0418042,
                37.8042894
              ],
              [
                58.0398484,
                37.8040453
              ],
              [
                58.0379999,
                37.8039647
              ],
              [
                58.0348506,
                37.8041682
              ],
              [
                58.0340061,
                37.8042928
              ],
              [
                58.0323023,
                37.8048147
              ],
              [
                58.0310885,
                37.8050867
              ],
              [
                58.0299629,
                37.805626
              ],
              [
                58.0293189,
                37.8063887
              ],
              [
                58.0288454,
                37.807213
              ],
              [
                58.0280163,
                37.8091152
              ],
              [
                58.0271559,
                37.8107653
              ],
              [
                58.0264694,
                37.8114923
              ],
              [
                58.0259291,
                37.8119004
              ],
              [
                58.0251567,
                37.8123239
              ],
              [
                58.0240112,
                37.8126674
              ],
              [
                58.0235771,
                37.81289
              ],
              [
                58.0233139,
                37.8130249
              ],
              [
                58.0227759,
                37.8130904
              ],
              [
                58.0202834,
                37.8128642
              ],
              [
                58.0175249,
                37.8124464
              ],
              [
                58.0167114,
                37.8125143
              ],
              [
                58.0161448,
                37.8128752
              ],
              [
                58.0151954,
                37.8136495
              ],
              [
                58.01382,
                37.8142742
              ],
              [
                58.0126475,
                37.8148814
              ],
              [
                58.0114641,
                37.8151078
              ],
              [
                58.0107845,
                37.8151002
              ],
              [
                58.0091454,
                37.8151863
              ],
              [
                58.0082166,
                37.815548
              ],
              [
                58.0077859,
                37.815777
              ],
              [
                58.0069183,
                37.816359
              ],
              [
                58.0041208,
                37.8179489
              ],
              [
                58.002942,
                37.8189932
              ],
              [
                58.0009546,
                37.8196883
              ],
              [
                58.000599,
                37.8198625
              ],
              [
                57.9981361,
                37.8198947
              ],
              [
                57.9959321,
                37.8214929
              ],
              [
                57.9946572,
                37.8222111
              ],
              [
                57.9937729,
                37.8228856
              ],
              [
                57.9916948,
                37.8251495
              ],
              [
                57.9908677,
                37.8258572
              ],
              [
                57.9902708,
                37.8266824
              ],
              [
                57.9893556,
                37.8276545
              ],
              [
                57.9886597,
                37.8280884
              ],
              [
                57.9877878,
                37.8289565
              ],
              [
                57.9861492,
                37.8301193
              ],
              [
                57.9842625,
                37.8317417
              ],
              [
                57.9837251,
                37.8323478
              ],
              [
                57.9832583,
                37.8330344
              ],
              [
                57.9827659,
                37.83339
              ],
              [
                57.9821435,
                37.8336385
              ],
              [
                57.9816625,
                37.8343253
              ],
              [
                57.9795352,
                37.8351203
              ],
              [
                57.977897,
                37.8361141
              ],
              [
                57.9774482,
                37.8362846
              ],
              [
                57.975811,
                37.8372535
              ],
              [
                57.9747097,
                37.8377651
              ],
              [
                57.9737534,
                37.8383926
              ],
              [
                57.973232,
                37.8386087
              ],
              [
                57.9720571,
                37.8394656
              ],
              [
                57.9698541,
                37.8407411
              ],
              [
                57.9691286,
                37.8413126
              ],
              [
                57.9676797,
                37.8420298
              ],
              [
                57.9662883,
                37.842805
              ],
              [
                57.9651295,
                37.8433283
              ],
              [
                57.9645491,
                37.8437611
              ],
              [
                57.9632924,
                37.843803
              ],
              [
                57.9626137,
                37.843777
              ],
              [
                57.9620083,
                37.8436017
              ],
              [
                57.9610127,
                37.8434611
              ],
              [
                57.9597149,
                37.843181
              ],
              [
                57.9584185,
                37.8425787
              ],
              [
                57.955897,
                37.8416506
              ],
              [
                57.9556528,
                37.8413867
              ],
              [
                57.955541,
                37.8408694
              ],
              [
                57.9538507,
                37.8409439
              ],
              [
                57.9528503,
                37.8415356
              ],
              [
                57.9526836,
                37.8428213
              ],
              [
                57.9525046,
                37.8437037
              ],
              [
                57.9524718,
                37.8442988
              ],
              [
                57.9511998,
                37.8467493
              ],
              [
                57.9509331,
                37.8477249
              ],
              [
                57.9509462,
                37.8479659
              ],
              [
                57.9507989,
                37.8483884
              ],
              [
                57.9504616,
                37.8491797
              ],
              [
                57.9501994,
                37.8495581
              ],
              [
                57.9500335,
                37.8506928
              ],
              [
                57.9497425,
                37.8509904
              ],
              [
                57.9493224,
                37.851138
              ],
              [
                57.9484565,
                37.85103
              ],
              [
                57.9463086,
                37.8503916
              ],
              [
                57.9459197,
                37.8502055
              ],
              [
                57.9430656,
                37.8493338
              ],
              [
                57.9425466,
                37.8491375
              ],
              [
                57.9415102,
                37.8486388
              ],
              [
                57.9397936,
                37.8483348
              ],
              [
                57.9389129,
                37.8482855
              ],
              [
                57.937323,
                37.8484491
              ],
              [
                57.9367154,
                37.8485508
              ],
              [
                57.9334441,
                37.8496156
              ],
              [
                57.932414,
                37.850347
              ],
              [
                57.9325622,
                37.8519073
              ],
              [
                57.9327182,
                37.8523319
              ],
              [
                57.9326294,
                37.8526188
              ],
              [
                57.9321632,
                37.8532827
              ],
              [
                57.9302847,
                37.8533313
              ],
              [
                57.9295495,
                37.8531681
              ],
              [
                57.9283834,
                37.852578
              ],
              [
                57.9265964,
                37.8519859
              ],
              [
                57.9256705,
                37.8521419
              ],
              [
                57.9251354,
                37.8523016
              ],
              [
                57.9244969,
                37.8526536
              ],
              [
                57.9236509,
                37.853913
              ],
              [
                57.9227906,
                37.8550554
              ],
              [
                57.92206,
                37.85635
              ],
              [
                57.9220565,
                37.856866
              ],
              [
                57.921753,
                37.8589638
              ],
              [
                57.9214741,
                37.8596172
              ],
              [
                57.9211916,
                37.8608429
              ],
              [
                57.920783,
                37.8614612
              ],
              [
                57.9204461,
                37.8621376
              ],
              [
                57.9198801,
                37.8625025
              ],
              [
                57.9194005,
                37.8629591
              ],
              [
                57.9182981,
                37.8635626
              ],
              [
                57.9167347,
                37.8640592
              ],
              [
                57.9155186,
                37.8643774
              ],
              [
                57.9140447,
                37.8644722
              ],
              [
                57.9134092,
                37.8644478
              ],
              [
                57.9112443,
                37.8641627
              ],
              [
                57.9101464,
                37.8641013
              ],
              [
                57.9092955,
                37.8638916
              ],
              [
                57.908124,
                37.8640809
              ],
              [
                57.9077774,
                37.864034
              ],
              [
                57.9073148,
                37.8641457
              ],
              [
                57.9066298,
                37.8649576
              ],
              [
                57.9063261,
                37.8650478
              ],
              [
                57.9048293,
                37.8642054
              ],
              [
                57.9031006,
                37.8635089
              ],
              [
                57.9013673,
                37.8634208
              ],
              [
                57.9007773,
                37.8631076
              ],
              [
                57.9003184,
                37.8627055
              ],
              [
                57.8998434,
                37.8623824
              ],
              [
                57.8988775,
                37.8621239
              ],
              [
                57.8984287,
                37.8622603
              ],
              [
                57.8981961,
                37.8624198
              ],
              [
                57.897946,
                37.8630616
              ],
              [
                57.897912,
                37.8637716
              ],
              [
                57.897763,
                37.8644938
              ],
              [
                57.8975697,
                37.8651938
              ],
              [
                57.8972468,
                37.8659849
              ],
              [
                57.8973586,
                37.8664775
              ],
              [
                57.897383,
                37.8671442
              ],
              [
                57.8972572,
                37.8685422
              ],
              [
                57.8969187,
                37.8694596
              ],
              [
                57.8967111,
                37.870216
              ],
              [
                57.8961713,
                37.870878
              ],
              [
                57.8955917,
                37.8711393
              ],
              [
                57.8952299,
                37.8711848
              ],
              [
                57.8946959,
                37.871101
              ],
              [
                57.8945701,
                37.8705725
              ],
              [
                57.8946015,
                37.8702298
              ],
              [
                57.8943153,
                37.8698264
              ],
              [
                57.8942488,
                37.8690337
              ],
              [
                57.8941215,
                37.8686088
              ],
              [
                57.8936359,
                37.8678262
              ],
              [
                57.8934518,
                37.8672868
              ],
              [
                57.8929205,
                37.8668942
              ],
              [
                57.8921714,
                37.8665822
              ],
              [
                57.8917385,
                37.8665111
              ],
              [
                57.8914908,
                37.8667721
              ],
              [
                57.8911001,
                37.8688481
              ],
              [
                57.8903408,
                37.8699917
              ],
              [
                57.890135,
                37.8704281
              ],
              [
                57.8895527,
                37.8710566
              ],
              [
                57.8889578,
                37.8714554
              ],
              [
                57.888392,
                37.8717954
              ],
              [
                57.887175,
                37.8722372
              ],
              [
                57.8863789,
                37.8724528
              ],
              [
                57.8854512,
                37.872782
              ],
              [
                57.8843082,
                37.8730519
              ],
              [
                57.883599,
                37.8731744
              ],
              [
                57.8823704,
                37.8732377
              ],
              [
                57.8808827,
                37.8732083
              ],
              [
                57.8791353,
                37.8730862
              ],
              [
                57.8781428,
                37.8724492
              ],
              [
                57.8768269,
                37.8725806
              ],
              [
                57.8763767,
                37.872913
              ],
              [
                57.8760985,
                37.8734265
              ],
              [
                57.8756202,
                37.8735968
              ],
              [
                57.8749978,
                37.8737321
              ],
              [
                57.8741886,
                37.873808
              ],
              [
                57.8726711,
                37.8737787
              ],
              [
                57.8716475,
                37.8736353
              ],
              [
                57.8697812,
                37.8743459
              ],
              [
                57.8678325,
                37.8739043
              ],
              [
                57.8658477,
                37.8738046
              ],
              [
                57.8629066,
                37.8738189
              ],
              [
                57.860994,
                37.8741892
              ],
              [
                57.8592552,
                37.8739652
              ],
              [
                57.8539917,
                37.8720091
              ],
              [
                57.8511433,
                37.8723076
              ],
              [
                57.8488963,
                37.8703316
              ],
              [
                57.830253,
                37.8634927
              ],
              [
                57.8254738,
                37.8632465
              ],
              [
                57.819142,
                37.868518
              ],
              [
                57.8102291,
                37.8730303
              ],
              [
                57.8065511,
                37.8797415
              ],
              [
                57.8045346,
                37.8853088
              ],
              [
                57.8060473,
                37.8923401
              ],
              [
                57.8009965,
                37.8909821
              ],
              [
                57.7971539,
                37.893472
              ],
              [
                57.7958352,
                37.899553
              ],
              [
                57.7891254,
                37.8979745
              ],
              [
                57.7859965,
                37.9011983
              ],
              [
                57.781413,
                37.8982246
              ],
              [
                57.7718544,
                37.899318
              ],
              [
                57.7646001,
                37.8968444
              ],
              [
                57.7596075,
                37.8977141
              ],
              [
                57.7541404,
                37.8974949
              ],
              [
                57.7504987,
                37.902627
              ],
              [
                57.745,
                37.906667
              ],
              [
                57.7436599,
                37.9118129
              ],
              [
                57.7383007,
                37.9156219
              ],
              [
                57.7331372,
                37.9184216
              ],
              [
                57.726944,
                37.92
              ],
              [
                57.7203676,
                37.9218564
              ],
              [
                57.7135944,
                37.92246
              ],
              [
                57.707525,
                37.9217241
              ],
              [
                57.70058,
                37.9221383
              ],
              [
                57.6949174,
                37.9196836
              ],
              [
                57.6938263,
                37.9189108
              ],
              [
                57.6790627,
                37.9054016
              ],
              [
                57.6796881,
                37.9038901
              ],
              [
                57.6804455,
                37.9028769
              ],
              [
                57.6801654,
                37.9026073
              ],
              [
                57.6801654,
                37.9023287
              ],
              [
                57.6787786,
                37.9003869
              ],
              [
                57.6526753,
                37.855031
              ],
              [
                57.6460088,
                37.8500329
              ],
              [
                57.644622,
                37.849197
              ],
              [
                57.6398953,
                37.846698
              ],
              [
                57.6266621,
                37.8401246
              ],
              [
                57.6241621,
                37.8401245
              ],
              [
                57.619162,
                37.8392884
              ],
              [
                57.6141622,
                37.8392885
              ],
              [
                57.5915626,
                37.8461407
              ],
              [
                57.5843359,
                37.8486397
              ],
              [
                57.5815628,
                37.8500331
              ],
              [
                57.5807292,
                37.8500331
              ],
              [
                57.5679496,
                37.8544738
              ],
              [
                57.5676696,
                37.8541951
              ],
              [
                57.5657297,
                37.8539255
              ],
              [
                57.5538546,
                37.8531279
              ],
              [
                57.542118,
                37.8441413
              ],
              [
                57.537678,
                37.8366449
              ],
              [
                57.5371183,
                37.8360966
              ],
              [
                57.5336836,
                37.821989
              ],
              [
                57.5343703,
                37.8120896
              ],
              [
                57.530937,
                37.8095128
              ],
              [
                57.5307654,
                37.8044947
              ],
              [
                57.5273321,
                37.8015107
              ],
              [
                57.5216673,
                37.7920156
              ],
              [
                57.5057028,
                37.7867249
              ],
              [
                57.4911116,
                37.7846899
              ],
              [
                57.4860034,
                37.7641972
              ],
              [
                57.4784966,
                37.7514215
              ],
              [
                57.4724864,
                37.736105
              ],
              [
                57.4778381,
                37.7287671
              ],
              [
                57.477565,
                37.7276522
              ],
              [
                57.4785804,
                37.7216456
              ],
              [
                57.4839877,
                37.7196767
              ],
              [
                57.4940048,
                37.7130052
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 269912,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اسفراین",
          "name:en": "Esfarayen County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286451",
          "wikipedia": "en:Esfarayen County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.9329552,
                36.8853667
              ],
              [
                56.9405856,
                36.8814796
              ],
              [
                56.9428566,
                36.8820376
              ],
              [
                56.9582745,
                36.8711071
              ],
              [
                56.9884869,
                36.8678112
              ],
              [
                57.0137868,
                36.8595642
              ],
              [
                57.0157335,
                36.8601225
              ],
              [
                57.0165667,
                36.8601225
              ],
              [
                57.0222367,
                36.8565556
              ],
              [
                57.0230699,
                36.8568348
              ],
              [
                57.02446,
                36.8568348
              ],
              [
                57.0252932,
                36.8571139
              ],
              [
                57.0311265,
                36.8571138
              ],
              [
                57.03196,
                36.857393
              ],
              [
                57.0347364,
                36.8573931
              ],
              [
                57.0355698,
                36.8571138
              ],
              [
                57.0380698,
                36.8571139
              ],
              [
                57.0405698,
                36.8565556
              ],
              [
                57.041683,
                36.8565555
              ],
              [
                57.0589594,
                36.8541766
              ],
              [
                57.0597927,
                36.8536183
              ],
              [
                57.0907807,
                36.8476159
              ],
              [
                57.102259,
                36.8456581
              ],
              [
                57.1033722,
                36.8456581
              ],
              [
                57.1167056,
                36.8414892
              ],
              [
                57.1178155,
                36.840931
              ],
              [
                57.1222621,
                36.8414633
              ],
              [
                57.1297621,
                36.8386812
              ],
              [
                57.1336487,
                36.8375737
              ],
              [
                57.1363646,
                36.8374279
              ],
              [
                57.137198,
                36.8371489
              ],
              [
                57.138651,
                36.8373205
              ],
              [
                57.1392165,
                36.837207
              ],
              [
                57.144649,
                36.8371789
              ],
              [
                57.1468735,
                36.8374493
              ],
              [
                57.1512523,
                36.8361785
              ],
              [
                57.1648251,
                36.8375483
              ],
              [
                57.1662151,
                36.8372691
              ],
              [
                57.168435,
                36.8372692
              ],
              [
                57.169825,
                36.83699
              ],
              [
                57.1717682,
                36.8369901
              ],
              [
                57.1731583,
                36.836711
              ],
              [
                57.175105,
                36.836711
              ],
              [
                57.1784383,
                36.8361528
              ],
              [
                57.1820481,
                36.8361528
              ],
              [
                57.1851049,
                36.8356034
              ],
              [
                57.1870483,
                36.8356035
              ],
              [
                57.1878815,
                36.8353243
              ],
              [
                57.1895481,
                36.8353243
              ],
              [
                57.1903815,
                36.8350453
              ],
              [
                57.1931614,
                36.8350452
              ],
              [
                57.1945479,
                36.8347662
              ],
              [
                57.1959381,
                36.8347662
              ],
              [
                57.2068402,
                36.8241268
              ],
              [
                57.2317805,
                36.822907
              ],
              [
                57.2370604,
                36.8220696
              ],
              [
                57.2415037,
                36.8209619
              ],
              [
                57.2428937,
                36.8209621
              ],
              [
                57.2432626,
                36.820776
              ],
              [
                57.2928507,
                36.8098256
              ],
              [
                57.2936838,
                36.8095465
              ],
              [
                57.2956304,
                36.8095465
              ],
              [
                57.2967371,
                36.8092674
              ],
              [
                57.371876,
                36.7931203
              ],
              [
                57.3738159,
                36.7920128
              ],
              [
                57.4018293,
                36.7872256
              ],
              [
                57.4034958,
                36.7869465
              ],
              [
                57.4057157,
                36.7861182
              ],
              [
                57.4418286,
                36.7802836
              ],
              [
                57.4437751,
                36.7802837
              ],
              [
                57.4448888,
                36.7800045
              ],
              [
                57.4471085,
                36.7800045
              ],
              [
                57.4548887,
                36.778618
              ],
              [
                57.4898883,
                36.7691637
              ],
              [
                57.4921082,
                36.7683355
              ],
              [
                57.4993345,
                36.7658323
              ],
              [
                57.5057214,
                36.7636172
              ],
              [
                57.5062745,
                36.7630591
              ],
              [
                57.5096078,
                36.7619515
              ],
              [
                57.5101679,
                36.7613933
              ],
              [
                57.5173877,
                36.758611
              ],
              [
                57.5267976,
                36.7544584
              ],
              [
                57.5290243,
                36.7541792
              ],
              [
                57.5356876,
                36.7472633
              ],
              [
                57.5367942,
                36.7470404
              ],
              [
                57.5454077,
                36.7436524
              ],
              [
                57.5470742,
                36.7433823
              ],
              [
                57.5808837,
                36.7198556
              ],
              [
                57.6069366,
                36.7089693
              ],
              [
                57.6119368,
                36.7056372
              ],
              [
                57.6158232,
                36.7020259
              ],
              [
                57.6396198,
                36.6913835
              ],
              [
                57.6585061,
                36.6805595
              ],
              [
                57.663742,
                36.6785129
              ],
              [
                57.7018387,
                36.6636118
              ],
              [
                57.7079521,
                36.6619458
              ],
              [
                57.715732,
                36.6583348
              ],
              [
                57.7182321,
                36.6574973
              ],
              [
                57.7457318,
                36.6433319
              ],
              [
                57.7521249,
                36.6405581
              ],
              [
                57.7773976,
                36.6302737
              ],
              [
                57.8215709,
                36.6161078
              ],
              [
                57.8684105,
                36.5870531
              ],
              [
                57.8695239,
                36.5870531
              ],
              [
                57.8714637,
                36.5865036
              ],
              [
                57.8789634,
                36.5848372
              ],
              [
                57.8931573,
                36.5871648
              ],
              [
                57.8978204,
                36.5833137
              ],
              [
                57.9048156,
                36.5783512
              ],
              [
                57.909708,
                36.5772139
              ],
              [
                57.9170865,
                36.5752569
              ],
              [
                57.9238669,
                36.5717998
              ],
              [
                57.930189,
                36.5704957
              ],
              [
                57.9339201,
                36.5696269
              ],
              [
                57.943698,
                36.5685225
              ],
              [
                57.951538,
                36.568367
              ],
              [
                57.9638671,
                36.5680462
              ],
              [
                57.9699823,
                36.5690811
              ],
              [
                57.9739523,
                36.5695282
              ],
              [
                57.9851532,
                36.5712515
              ],
              [
                57.9884147,
                36.5728369
              ],
              [
                57.9996703,
                36.5814981
              ],
              [
                58.0190041,
                36.5951521
              ],
              [
                58.0376651,
                36.6010129
              ],
              [
                58.0637891,
                36.6088154
              ],
              [
                58.068881,
                36.6116425
              ],
              [
                58.0727004,
                36.6181456
              ],
              [
                58.0787086,
                36.6228988
              ],
              [
                58.083433,
                36.6280121
              ],
              [
                58.0839442,
                36.6299249
              ],
              [
                58.0812835,
                36.6330933
              ],
              [
                58.0765628,
                36.6363993
              ],
              [
                58.0750178,
                36.6395674
              ],
              [
                58.0709838,
                36.6414269
              ],
              [
                58.0658776,
                36.6459976
              ],
              [
                58.066083,
                36.6497783
              ],
              [
                58.0686664,
                36.6543732
              ],
              [
                58.0709343,
                36.6609173
              ],
              [
                58.0750608,
                36.6637373
              ],
              [
                58.0794382,
                36.6694516
              ],
              [
                58.081157,
                36.6724085
              ],
              [
                58.0863771,
                36.6753471
              ],
              [
                58.0884504,
                36.678573
              ],
              [
                58.0875492,
                36.6812231
              ],
              [
                58.083558,
                36.6816705
              ],
              [
                58.0796095,
                36.6843552
              ],
              [
                58.0761337,
                36.687177
              ],
              [
                58.075962,
                36.6887944
              ],
              [
                58.0819273,
                36.6907904
              ],
              [
                58.094115,
                36.6976384
              ],
              [
                58.0938379,
                36.7032503
              ],
              [
                58.0951775,
                36.7094058
              ],
              [
                58.0914545,
                36.7102655
              ],
              [
                58.0872917,
                36.7121921
              ],
              [
                58.0798207,
                36.716483
              ],
              [
                58.0817127,
                36.7177307
              ],
              [
                58.0868625,
                36.723785
              ],
              [
                58.095102,
                36.7305269
              ],
              [
                58.1010675,
                36.7371302
              ],
              [
                58.0995655,
                36.7407756
              ],
              [
                58.0957442,
                36.7481638
              ],
              [
                58.1006813,
                36.7532927
              ],
              [
                58.1079766,
                36.7584848
              ],
              [
                58.1246573,
                36.7664635
              ],
              [
                58.1282574,
                36.7683822
              ],
              [
                58.128386,
                36.7744515
              ],
              [
                58.1273054,
                36.7829016
              ],
              [
                58.1216214,
                36.7893409
              ],
              [
                58.1086452,
                36.8045164
              ],
              [
                58.1068826,
                36.8057628
              ],
              [
                58.104182,
                36.8071776
              ],
              [
                58.0969856,
                36.8111915
              ],
              [
                58.0943261,
                36.8176761
              ],
              [
                58.0898663,
                36.8279743
              ],
              [
                58.0850172,
                36.8392403
              ],
              [
                58.0819273,
                36.8455426
              ],
              [
                58.0781281,
                36.8542795
              ],
              [
                58.0761505,
                36.8588681
              ],
              [
                58.0815189,
                36.8601427
              ],
              [
                58.0925396,
                36.8628166
              ],
              [
                58.1099528,
                36.8669799
              ],
              [
                58.1303191,
                36.8715383
              ],
              [
                58.142399,
                36.8740469
              ],
              [
                58.1261357,
                36.8845936
              ],
              [
                58.1216551,
                36.896869
              ],
              [
                58.1159725,
                36.9100111
              ],
              [
                58.1043221,
                36.9173297
              ],
              [
                58.0960417,
                36.9232646
              ],
              [
                58.0957754,
                36.9262778
              ],
              [
                58.0925912,
                36.9335455
              ],
              [
                58.0883501,
                36.9390353
              ],
              [
                58.0820713,
                36.9411306
              ],
              [
                58.078023,
                36.9425143
              ],
              [
                58.0703924,
                36.9421449
              ],
              [
                58.0408586,
                36.9380033
              ],
              [
                58.0248336,
                36.9368821
              ],
              [
                58.0231441,
                36.9367159
              ],
              [
                58.0132695,
                36.9389969
              ],
              [
                58.0094981,
                36.9418842
              ],
              [
                58.0064045,
                36.9453421
              ],
              [
                58.0039699,
                36.9477586
              ],
              [
                58.0023191,
                36.9535641
              ],
              [
                58.0023682,
                36.960773
              ],
              [
                58.0020881,
                36.973582
              ],
              [
                58.0066025,
                36.9790646
              ],
              [
                58.0162314,
                36.9919072
              ],
              [
                58.0088939,
                36.9949858
              ],
              [
                58.0032579,
                36.9942027
              ],
              [
                58.0000147,
                36.9964181
              ],
              [
                57.9942111,
                37.002246
              ],
              [
                57.9893291,
                37.005644
              ],
              [
                57.9848759,
                37.0085161
              ],
              [
                57.9829215,
                37.0110177
              ],
              [
                57.978115,
                37.0134163
              ],
              [
                57.973523,
                37.0112918
              ],
              [
                57.9663133,
                37.0093041
              ],
              [
                57.9517219,
                37.0075907
              ],
              [
                57.9490184,
                37.0103665
              ],
              [
                57.9443618,
                37.0155265
              ],
              [
                57.9245473,
                37.0291879
              ],
              [
                57.9144286,
                37.0314733
              ],
              [
                57.9011791,
                37.0332266
              ],
              [
                57.8997945,
                37.0356528
              ],
              [
                57.8982738,
                37.0493687
              ],
              [
                57.8974401,
                37.0502059
              ],
              [
                57.8893658,
                37.0683278
              ],
              [
                57.8886792,
                37.0781891
              ],
              [
                57.8910824,
                37.0896923
              ],
              [
                57.884216,
                37.099277
              ],
              [
                57.8704895,
                37.125219
              ],
              [
                57.8664493,
                37.1292554
              ],
              [
                57.8626521,
                37.1348789
              ],
              [
                57.8531455,
                37.1415035
              ],
              [
                57.8436183,
                37.1443087
              ],
              [
                57.8309209,
                37.1453922
              ],
              [
                57.824993,
                37.1478663
              ],
              [
                57.8207015,
                37.1503292
              ],
              [
                57.8172439,
                37.1551491
              ],
              [
                57.8164105,
                37.1596962
              ],
              [
                57.8142037,
                37.1673239
              ],
              [
                57.8118979,
                37.173261
              ],
              [
                57.812376,
                37.1765263
              ],
              [
                57.8116035,
                37.1819288
              ],
              [
                57.8070544,
                37.1858948
              ],
              [
                57.7949523,
                37.1901342
              ],
              [
                57.7910899,
                37.1936897
              ],
              [
                57.7843093,
                37.1975185
              ],
              [
                57.768774,
                37.20415
              ],
              [
                57.7658557,
                37.2069528
              ],
              [
                57.7614482,
                37.2094281
              ],
              [
                57.7499083,
                37.2167738
              ],
              [
                57.7216239,
                37.2268861
              ],
              [
                57.6316072,
                37.242757
              ],
              [
                57.6159757,
                37.2447521
              ],
              [
                57.5845102,
                37.240191
              ],
              [
                57.5745408,
                37.2402745
              ],
              [
                57.565324,
                37.2427642
              ],
              [
                57.5608437,
                37.2445697
              ],
              [
                57.5558902,
                37.2481358
              ],
              [
                57.542095,
                37.2493244
              ],
              [
                57.5278052,
                37.2547021
              ],
              [
                57.526972,
                37.2547021
              ],
              [
                57.5261387,
                37.254981
              ],
              [
                57.5247453,
                37.2547021
              ],
              [
                57.5163458,
                37.2564296
              ],
              [
                57.5120543,
                37.2751457
              ],
              [
                57.5082777,
                37.2803362
              ],
              [
                57.5082777,
                37.2881213
              ],
              [
                57.4881933,
                37.2965884
              ],
              [
                57.4712751,
                37.3113607
              ],
              [
                57.470722,
                37.3113607
              ],
              [
                57.4693352,
                37.3116395
              ],
              [
                57.4682219,
                37.3119091
              ],
              [
                57.454376,
                37.3013678
              ],
              [
                57.4219958,
                37.3013314
              ],
              [
                57.3954962,
                37.2838874
              ],
              [
                57.3912047,
                37.2796533
              ],
              [
                57.3877714,
                37.2728235
              ],
              [
                57.3836516,
                37.2730967
              ],
              [
                57.3823837,
                37.2645906
              ],
              [
                57.3815501,
                37.2643118
              ],
              [
                57.3776637,
                37.2643117
              ],
              [
                57.3765504,
                37.2640328
              ],
              [
                57.3751636,
                37.2640329
              ],
              [
                57.3575525,
                37.2544078
              ],
              [
                57.3199507,
                37.2525706
              ],
              [
                57.3146708,
                37.2533983
              ],
              [
                57.3074508,
                37.2533983
              ],
              [
                57.306891,
                37.2531194
              ],
              [
                57.3038378,
                37.2531194
              ],
              [
                57.302451,
                37.2528406
              ],
              [
                57.2767028,
                37.2528023
              ],
              [
                57.266913,
                37.247743
              ],
              [
                57.2602464,
                37.2463574
              ],
              [
                57.2440909,
                37.2464549
              ],
              [
                57.2308315,
                37.2553666
              ],
              [
                57.2161101,
                37.2633975
              ],
              [
                57.2063254,
                37.2650369
              ],
              [
                57.1793745,
                37.2666762
              ],
              [
                57.16444,
                37.2635341
              ],
              [
                57.1490567,
                37.2640859
              ],
              [
                57.1479434,
                37.2640859
              ],
              [
                57.1451668,
                37.2646437
              ],
              [
                57.1398901,
                37.2646437
              ],
              [
                57.1387768,
                37.2643648
              ],
              [
                57.1360002,
                37.2643647
              ],
              [
                57.1348868,
                37.2640859
              ],
              [
                57.1332202,
                37.2640859
              ],
              [
                57.1274913,
                37.2617386
              ],
              [
                57.1241581,
                37.2617385
              ],
              [
                57.119438,
                37.2625752
              ],
              [
                57.1144381,
                37.2636818
              ],
              [
                57.1049916,
                37.2659039
              ],
              [
                57.0742518,
                37.2732061
              ],
              [
                57.0550915,
                37.2658567
              ],
              [
                57.0320889,
                37.2633976
              ],
              [
                57.0084354,
                37.2371732
              ],
              [
                57.0084806,
                37.2354003
              ],
              [
                57.0116372,
                37.2284475
              ],
              [
                57.0075172,
                37.219562
              ],
              [
                57.0072407,
                37.2187252
              ],
              [
                57.0102138,
                37.2095121
              ],
              [
                57.0115871,
                37.2017349
              ],
              [
                57.0273499,
                37.1845358
              ],
              [
                57.0307158,
                37.1738592
              ],
              [
                57.0305441,
                37.1380141
              ],
              [
                57.0233343,
                37.1161157
              ],
              [
                57.0058249,
                37.1009199
              ],
              [
                57.0027881,
                37.0925284
              ],
              [
                57.0000326,
                37.085824
              ],
              [
                56.9968985,
                37.0764085
              ],
              [
                56.9962118,
                37.0672319
              ],
              [
                57.0041083,
                37.0554512
              ],
              [
                56.9911694,
                37.0408933
              ],
              [
                56.9773291,
                37.030103
              ],
              [
                56.9616417,
                37.0223226
              ],
              [
                56.9613649,
                37.0220435
              ],
              [
                56.9602551,
                37.0220435
              ],
              [
                56.9599751,
                37.0217646
              ],
              [
                56.9594216,
                37.0217646
              ],
              [
                56.9535884,
                37.0189837
              ],
              [
                56.9491418,
                37.0125942
              ],
              [
                56.9507214,
                37.0050205
              ],
              [
                56.9369885,
                36.9943271
              ],
              [
                56.9095227,
                36.9992627
              ],
              [
                56.8931167,
                36.9965857
              ],
              [
                56.8928399,
                36.996316
              ],
              [
                56.8881168,
                36.9871491
              ],
              [
                56.8886734,
                36.9818775
              ],
              [
                56.9009396,
                36.9411117
              ],
              [
                56.9146725,
                36.910647
              ],
              [
                56.9293037,
                36.8959746
              ],
              [
                56.9309703,
                36.8884776
              ],
              [
                56.9329552,
                36.8853667
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554914,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بجنورد",
          "name:en": "Bojnurd County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286421",
          "wikipedia": "en:Bojnord County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.0052128,
                37.4437509
              ],
              [
                57.0049765,
                37.4386954
              ],
              [
                57.0054386,
                37.4377823
              ],
              [
                57.0052476,
                37.4365651
              ],
              [
                57.004971,
                37.4351798
              ],
              [
                57.0046943,
                37.4304567
              ],
              [
                57.0044144,
                37.4282257
              ],
              [
                57.0041376,
                37.4268402
              ],
              [
                57.0038611,
                37.4260126
              ],
              [
                57.0038611,
                37.4165663
              ],
              [
                57.0041626,
                37.4114404
              ],
              [
                57.0038858,
                37.4106037
              ],
              [
                57.0038859,
                37.409767
              ],
              [
                57.0038859,
                37.4086604
              ],
              [
                57.0036059,
                37.401715
              ],
              [
                57.0054114,
                37.3974764
              ],
              [
                57.0062968,
                37.3974763
              ],
              [
                57.0065734,
                37.3971975
              ],
              [
                57.0068834,
                37.3936428
              ],
              [
                57.0236863,
                37.371931
              ],
              [
                57.0250764,
                37.3716522
              ],
              [
                57.0325962,
                37.3601769
              ],
              [
                57.0331494,
                37.3601768
              ],
              [
                57.0447585,
                37.3426412
              ],
              [
                57.0490187,
                37.3348651
              ],
              [
                57.0501287,
                37.329872
              ],
              [
                57.049852,
                37.3281986
              ],
              [
                57.0492952,
                37.3256975
              ],
              [
                57.0541826,
                37.3044814
              ],
              [
                57.0599775,
                37.3008545
              ],
              [
                57.0742518,
                37.2732061
              ],
              [
                57.1049916,
                37.2659039
              ],
              [
                57.1144381,
                37.2636818
              ],
              [
                57.119438,
                37.2625752
              ],
              [
                57.1241581,
                37.2617385
              ],
              [
                57.1274913,
                37.2617386
              ],
              [
                57.1332202,
                37.2640859
              ],
              [
                57.1348868,
                37.2640859
              ],
              [
                57.1360002,
                37.2643647
              ],
              [
                57.1387768,
                37.2643648
              ],
              [
                57.1398901,
                37.2646437
              ],
              [
                57.1451668,
                37.2646437
              ],
              [
                57.1479434,
                37.2640859
              ],
              [
                57.1490567,
                37.2640859
              ],
              [
                57.16444,
                37.2635341
              ],
              [
                57.1793745,
                37.2666762
              ],
              [
                57.2063254,
                37.2650369
              ],
              [
                57.2161101,
                37.2633975
              ],
              [
                57.2308315,
                37.2553666
              ],
              [
                57.2440909,
                37.2464549
              ],
              [
                57.2602464,
                37.2463574
              ],
              [
                57.266913,
                37.247743
              ],
              [
                57.2767028,
                37.2528023
              ],
              [
                57.302451,
                37.2528406
              ],
              [
                57.3038378,
                37.2531194
              ],
              [
                57.306891,
                37.2531194
              ],
              [
                57.3074508,
                37.2533983
              ],
              [
                57.3146708,
                37.2533983
              ],
              [
                57.3199507,
                37.2525706
              ],
              [
                57.3575525,
                37.2544078
              ],
              [
                57.3751636,
                37.2640329
              ],
              [
                57.3765504,
                37.2640328
              ],
              [
                57.3776637,
                37.2643117
              ],
              [
                57.3815501,
                37.2643118
              ],
              [
                57.3823837,
                37.2645906
              ],
              [
                57.3836516,
                37.2730967
              ],
              [
                57.3877714,
                37.2728235
              ],
              [
                57.3912047,
                37.2796533
              ],
              [
                57.3954962,
                37.2838874
              ],
              [
                57.4219958,
                37.3013314
              ],
              [
                57.454376,
                37.3013678
              ],
              [
                57.4682219,
                37.3119091
              ],
              [
                57.4693352,
                37.3116395
              ],
              [
                57.470722,
                37.3113607
              ],
              [
                57.4712751,
                37.3113607
              ],
              [
                57.4881933,
                37.2965884
              ],
              [
                57.5082777,
                37.2881213
              ],
              [
                57.5082777,
                37.2803362
              ],
              [
                57.5120543,
                37.2751457
              ],
              [
                57.5163458,
                37.2564296
              ],
              [
                57.5247453,
                37.2547021
              ],
              [
                57.5261387,
                37.254981
              ],
              [
                57.526972,
                37.2547021
              ],
              [
                57.5278052,
                37.2547021
              ],
              [
                57.542095,
                37.2493244
              ],
              [
                57.5558902,
                37.2481358
              ],
              [
                57.5608437,
                37.2445697
              ],
              [
                57.565324,
                37.2427642
              ],
              [
                57.5745408,
                37.2402745
              ],
              [
                57.5845102,
                37.240191
              ],
              [
                57.6159757,
                37.2447521
              ],
              [
                57.6164245,
                37.2461815
              ],
              [
                57.6180982,
                37.2476846
              ],
              [
                57.6191711,
                37.2516814
              ],
              [
                57.6253508,
                37.2696816
              ],
              [
                57.6258658,
                37.278424
              ],
              [
                57.628784,
                37.284024
              ],
              [
                57.6261174,
                37.2948155
              ],
              [
                57.639942,
                37.3046449
              ],
              [
                57.6406286,
                37.3129736
              ],
              [
                57.6432036,
                37.3174789
              ],
              [
                57.6418303,
                37.3245777
              ],
              [
                57.6420538,
                37.3302828
              ],
              [
                57.6548765,
                37.3335866
              ],
              [
                57.660713,
                37.3454604
              ],
              [
                57.6645101,
                37.3587157
              ],
              [
                57.6667301,
                37.3614957
              ],
              [
                57.6695101,
                37.3648335
              ],
              [
                57.6798475,
                37.3833022
              ],
              [
                57.6907967,
                37.3954939
              ],
              [
                57.6944328,
                37.398268
              ],
              [
                57.7046098,
                37.4060082
              ],
              [
                57.7046798,
                37.4068849
              ],
              [
                57.7009678,
                37.4098633
              ],
              [
                57.6961286,
                37.4153136
              ],
              [
                57.6971812,
                37.4260344
              ],
              [
                57.7011393,
                37.438066
              ],
              [
                57.7054032,
                37.4475127
              ],
              [
                57.7125046,
                37.4578559
              ],
              [
                57.7197063,
                37.4652516
              ],
              [
                57.7130232,
                37.477568
              ],
              [
                57.7028093,
                37.494267
              ],
              [
                57.6986502,
                37.5005339
              ],
              [
                57.6820358,
                37.5066766
              ],
              [
                57.6645895,
                37.5128172
              ],
              [
                57.6798269,
                37.5179678
              ],
              [
                57.677536,
                37.5205847
              ],
              [
                57.6742744,
                37.5271537
              ],
              [
                57.662773,
                37.5417191
              ],
              [
                57.6553223,
                37.5505083
              ],
              [
                57.6414686,
                37.5537359
              ],
              [
                57.6290416,
                37.5562817
              ],
              [
                57.6065001,
                37.5633025
              ],
              [
                57.6010819,
                37.5696126
              ],
              [
                57.5909553,
                37.5821178
              ],
              [
                57.568694,
                37.5947437
              ],
              [
                57.5603859,
                37.6062992
              ],
              [
                57.5495505,
                37.62
              ],
              [
                57.5428342,
                37.6275794
              ],
              [
                57.5350235,
                37.6363549
              ],
              [
                57.5206207,
                37.6477629
              ],
              [
                57.5005585,
                37.6565338
              ],
              [
                57.5036429,
                37.6714569
              ],
              [
                57.501429,
                37.6968757
              ],
              [
                57.5014291,
                37.6971544
              ],
              [
                57.501429,
                37.6985483
              ],
              [
                57.4997806,
                37.7093562
              ],
              [
                57.4956716,
                37.7130052
              ],
              [
                57.4951115,
                37.7130053
              ],
              [
                57.4940048,
                37.7130052
              ],
              [
                57.4839877,
                37.7196767
              ],
              [
                57.4785804,
                37.7216456
              ],
              [
                57.477565,
                37.7276522
              ],
              [
                57.4778381,
                37.7287671
              ],
              [
                57.4724864,
                37.736105
              ],
              [
                57.4784966,
                37.7514215
              ],
              [
                57.4860034,
                37.7641972
              ],
              [
                57.4911116,
                37.7846899
              ],
              [
                57.5057028,
                37.7867249
              ],
              [
                57.5216673,
                37.7920156
              ],
              [
                57.5273321,
                37.8015107
              ],
              [
                57.5307654,
                37.8044947
              ],
              [
                57.530937,
                37.8095128
              ],
              [
                57.5343703,
                37.8120896
              ],
              [
                57.5336836,
                37.821989
              ],
              [
                57.5371183,
                37.8360966
              ],
              [
                57.537678,
                37.8366449
              ],
              [
                57.542118,
                37.8441413
              ],
              [
                57.5538546,
                37.8531279
              ],
              [
                57.5657297,
                37.8539255
              ],
              [
                57.5676696,
                37.8541951
              ],
              [
                57.5679496,
                37.8544738
              ],
              [
                57.5807292,
                37.8500331
              ],
              [
                57.5815628,
                37.8500331
              ],
              [
                57.5843359,
                37.8486397
              ],
              [
                57.5915626,
                37.8461407
              ],
              [
                57.6141622,
                37.8392885
              ],
              [
                57.619162,
                37.8392884
              ],
              [
                57.6241621,
                37.8401245
              ],
              [
                57.6266621,
                37.8401246
              ],
              [
                57.6398953,
                37.846698
              ],
              [
                57.644622,
                37.849197
              ],
              [
                57.6460088,
                37.8500329
              ],
              [
                57.6526753,
                37.855031
              ],
              [
                57.6787786,
                37.9003869
              ],
              [
                57.6801654,
                37.9023287
              ],
              [
                57.6801654,
                37.9026073
              ],
              [
                57.6804455,
                37.9028769
              ],
              [
                57.6796881,
                37.9038901
              ],
              [
                57.6790627,
                37.9054016
              ],
              [
                57.6938263,
                37.9189108
              ],
              [
                57.689698,
                37.9159867
              ],
              [
                57.6801062,
                37.9178701
              ],
              [
                57.6733903,
                37.9189593
              ],
              [
                57.6678759,
                37.9220725
              ],
              [
                57.6640192,
                37.9244888
              ],
              [
                57.6575406,
                37.9234301
              ],
              [
                57.6530633,
                37.9256169
              ],
              [
                57.643889,
                37.923889
              ],
              [
                57.6399427,
                37.9245945
              ],
              [
                57.6371816,
                37.9228343
              ],
              [
                57.6286443,
                37.9222182
              ],
              [
                57.622222,
                37.923889
              ],
              [
                57.6152936,
                37.9266184
              ],
              [
                57.607778,
                37.927222
              ],
              [
                57.6014463,
                37.9291136
              ],
              [
                57.5981779,
                37.9320639
              ],
              [
                57.5966337,
                37.9328471
              ],
              [
                57.5919896,
                37.9328615
              ],
              [
                57.5908736,
                37.9334481
              ],
              [
                57.5857355,
                37.9362122
              ],
              [
                57.5796241,
                37.9380422
              ],
              [
                57.5742482,
                37.9375884
              ],
              [
                57.5673183,
                37.9357969
              ],
              [
                57.5622414,
                37.9334778
              ],
              [
                57.5562652,
                37.9319685
              ],
              [
                57.5504361,
                37.929432
              ],
              [
                57.5429743,
                37.9247811
              ],
              [
                57.53406,
                37.9265863
              ],
              [
                57.5289782,
                37.9245717
              ],
              [
                57.52423,
                37.9219859
              ],
              [
                57.5220304,
                37.9200284
              ],
              [
                57.5121923,
                37.919263
              ],
              [
                57.5087742,
                37.9205996
              ],
              [
                57.5057939,
                37.9251374
              ],
              [
                57.4997377,
                37.927688
              ],
              [
                57.4987611,
                37.9328253
              ],
              [
                57.4938512,
                37.9371132
              ],
              [
                57.4879178,
                37.9381628
              ],
              [
                57.480556,
                37.939167
              ],
              [
                57.472778,
                37.939167
              ],
              [
                57.465833,
                37.938611
              ],
              [
                57.457778,
                37.937778
              ],
              [
                57.450278,
                37.939167
              ],
              [
                57.445556,
                37.9425
              ],
              [
                57.439722,
                37.945
              ],
              [
                57.435,
                37.948333
              ],
              [
                57.430278,
                37.951389
              ],
              [
                57.426389,
                37.955278
              ],
              [
                57.421667,
                37.958333
              ],
              [
                57.416944,
                37.961667
              ],
              [
                57.412222,
                37.964722
              ],
              [
                57.4075,
                37.968056
              ],
              [
                57.401667,
                37.970556
              ],
              [
                57.395,
                37.9725
              ],
              [
                57.386389,
                37.973333
              ],
              [
                57.378889,
                37.974722
              ],
              [
                57.375,
                37.978611
              ],
              [
                57.370278,
                37.981667
              ],
              [
                57.3625,
                37.983056
              ],
              [
                57.3588133,
                37.9848987
              ],
              [
                57.3538472,
                37.984541
              ],
              [
                57.3523853,
                37.9844798
              ],
              [
                57.3515521,
                37.9842012
              ],
              [
                57.351272,
                37.9839226
              ],
              [
                57.3332386,
                37.978066
              ],
              [
                57.3187235,
                37.9809491
              ],
              [
                57.3173368,
                37.980392
              ],
              [
                57.2760145,
                37.9743198
              ],
              [
                57.2743477,
                37.9743198
              ],
              [
                57.272681,
                37.9740412
              ],
              [
                57.2696278,
                37.9740413
              ],
              [
                57.2682377,
                37.9743198
              ],
              [
                57.2651561,
                37.966877
              ],
              [
                57.2462056,
                37.95112
              ],
              [
                57.2456489,
                37.9505717
              ],
              [
                57.2412056,
                37.946679
              ],
              [
                57.2412057,
                37.9464003
              ],
              [
                57.240649,
                37.945843
              ],
              [
                57.2406489,
                37.9455642
              ],
              [
                57.240649,
                37.9450068
              ],
              [
                57.2417622,
                37.9408445
              ],
              [
                57.2414821,
                37.938615
              ],
              [
                57.2391127,
                37.9355332
              ],
              [
                57.2397993,
                37.9295758
              ],
              [
                57.2420309,
                37.9237533
              ],
              [
                57.2377394,
                37.9225346
              ],
              [
                57.2269247,
                37.9260553
              ],
              [
                57.2140501,
                37.9263261
              ],
              [
                57.2114752,
                37.9205034
              ],
              [
                57.200323,
                37.912117
              ],
              [
                57.1997697,
                37.9118383
              ],
              [
                57.1947698,
                37.9059951
              ],
              [
                57.1860693,
                37.8940922
              ],
              [
                57.1833227,
                37.8856929
              ],
              [
                57.1792029,
                37.873634
              ],
              [
                57.1652983,
                37.8682137
              ],
              [
                57.1636432,
                37.8654032
              ],
              [
                57.1625333,
                37.8634612
              ],
              [
                57.1619766,
                37.8626251
              ],
              [
                57.1597533,
                37.8542906
              ],
              [
                57.1594766,
                37.8537332
              ],
              [
                57.1594766,
                37.852897
              ],
              [
                57.1586434,
                37.8501278
              ],
              [
                57.1594766,
                37.844014
              ],
              [
                57.1587912,
                37.8400234
              ],
              [
                57.1590712,
                37.839466
              ],
              [
                57.1590713,
                37.8386298
              ],
              [
                57.1593479,
                37.838351
              ],
              [
                57.1596247,
                37.8380722
              ],
              [
                57.1922491,
                37.8278195
              ],
              [
                57.2210882,
                37.8200906
              ],
              [
                57.2341531,
                37.8094171
              ],
              [
                57.2349864,
                37.8088598
              ],
              [
                57.2372097,
                37.807754
              ],
              [
                57.2473524,
                37.8073429
              ],
              [
                57.2736166,
                37.7975772
              ],
              [
                57.2870056,
                37.7818434
              ],
              [
                57.2872822,
                37.7812859
              ],
              [
                57.2872821,
                37.7810162
              ],
              [
                57.2866629,
                37.7751926
              ],
              [
                57.2837446,
                37.7667797
              ],
              [
                57.2821997,
                37.751444
              ],
              [
                57.2753332,
                37.7377342
              ],
              [
                57.2493059,
                37.7057927
              ],
              [
                57.2487658,
                37.6844728
              ],
              [
                57.2512658,
                37.6805795
              ],
              [
                57.2523791,
                37.6772435
              ],
              [
                57.2537657,
                37.6730802
              ],
              [
                57.2548792,
                37.6675232
              ],
              [
                57.2596605,
                37.6566689
              ],
              [
                57.260494,
                37.6519481
              ],
              [
                57.2684668,
                37.6222539
              ],
              [
                57.2365381,
                37.6027948
              ],
              [
                57.2362613,
                37.6025162
              ],
              [
                57.2308026,
                37.5987983
              ],
              [
                57.2054671,
                37.6089282
              ],
              [
                57.1937941,
                37.6187187
              ],
              [
                57.1936224,
                37.6332662
              ],
              [
                57.1922491,
                37.642374
              ],
              [
                57.1834944,
                37.6503933
              ],
              [
                57.1350859,
                37.636121
              ],
              [
                57.1218971,
                37.6360604
              ],
              [
                57.1202305,
                37.6360604
              ],
              [
                57.1188405,
                37.6363392
              ],
              [
                57.1146738,
                37.6363392
              ],
              [
                57.1138404,
                37.6366181
              ],
              [
                57.0968973,
                37.6493882
              ],
              [
                57.094674,
                37.6491095
              ],
              [
                57.0915874,
                37.6456721
              ],
              [
                57.0888074,
                37.6442784
              ],
              [
                57.0783042,
                37.6379331
              ],
              [
                57.0774707,
                37.6370969
              ],
              [
                57.0695112,
                37.6267406
              ],
              [
                57.0647755,
                37.6250808
              ],
              [
                57.0452144,
                37.6264199
              ],
              [
                57.0259326,
                37.6147718
              ],
              [
                57.0206559,
                37.6114358
              ],
              [
                57.0170425,
                37.609215
              ],
              [
                57.0223044,
                37.5983202
              ],
              [
                57.02487,
                37.5870563
              ],
              [
                57.0205117,
                37.5775504
              ],
              [
                57.0236348,
                37.5694504
              ],
              [
                57.0233642,
                37.5440639
              ],
              [
                57.0163566,
                37.5222282
              ],
              [
                57.0066181,
                37.5078948
              ],
              [
                57.0168112,
                37.4918855
              ],
              [
                57.0180077,
                37.4877769
              ],
              [
                57.0084102,
                37.469487
              ],
              [
                57.0052128,
                37.4437509
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554974,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جاجرم",
          "name:en": "Jajrom County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286391",
          "wikipedia": "en:Jajarm County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.1037794,
                36.8532569
              ],
              [
                56.1878582,
                36.8120337
              ],
              [
                56.2235638,
                36.7878416
              ],
              [
                56.2431332,
                36.7823424
              ],
              [
                56.2507752,
                36.7791028
              ],
              [
                56.2596127,
                36.7735428
              ],
              [
                56.2688824,
                36.7707927
              ],
              [
                56.2870785,
                36.7562155
              ],
              [
                56.3170652,
                36.7387089
              ],
              [
                56.3592771,
                36.6872246
              ],
              [
                56.3590005,
                36.6863872
              ],
              [
                56.3595572,
                36.6827762
              ],
              [
                56.3612239,
                36.6816685
              ],
              [
                56.3631671,
                36.6822268
              ],
              [
                56.3716719,
                36.6705307
              ],
              [
                56.3733385,
                36.6710891
              ],
              [
                56.3744486,
                36.6710891
              ],
              [
                56.3967703,
                36.6761293
              ],
              [
                56.4178597,
                36.6768119
              ],
              [
                56.4198064,
                36.6768119
              ],
              [
                56.4206398,
                36.6770911
              ],
              [
                56.4412346,
                36.6813653
              ],
              [
                56.4417911,
                36.6810862
              ],
              [
                56.4429011,
                36.6810861
              ],
              [
                56.4492494,
                36.6837056
              ],
              [
                56.4503627,
                36.6834265
              ],
              [
                56.4590809,
                36.684179
              ],
              [
                56.4618659,
                36.6836876
              ],
              [
                56.4629792,
                36.6831293
              ],
              [
                56.4695292,
                36.6778696
              ],
              [
                56.4709193,
                36.6775995
              ],
              [
                56.4780726,
                36.6620934
              ],
              [
                56.4894624,
                36.650141
              ],
              [
                56.4930723,
                36.6484746
              ],
              [
                56.4939057,
                36.6484746
              ],
              [
                56.4944624,
                36.6481954
              ],
              [
                56.4952957,
                36.6481955
              ],
              [
                56.4961289,
                36.6479162
              ],
              [
                56.4983523,
                36.6479162
              ],
              [
                56.5014057,
                36.6484747
              ],
              [
                56.5036289,
                36.6484746
              ],
              [
                56.5164087,
                36.6504202
              ],
              [
                56.5183521,
                36.6504202
              ],
              [
                56.5194621,
                36.6506994
              ],
              [
                56.5490338,
                36.6532718
              ],
              [
                56.573753,
                36.6576786
              ],
              [
                56.5792462,
                36.6590557
              ],
              [
                56.6053387,
                36.6543735
              ],
              [
                56.618385,
                36.6540981
              ],
              [
                56.6273114,
                36.6601573
              ],
              [
                56.6345211,
                36.6623606
              ],
              [
                56.6460995,
                36.6716304
              ],
              [
                56.6469328,
                36.6719094
              ],
              [
                56.6483228,
                36.6736649
              ],
              [
                56.6410587,
                36.6759784
              ],
              [
                56.6251358,
                36.6806655
              ],
              [
                56.6104885,
                36.6849403
              ],
              [
                56.5992089,
                36.6950964
              ],
              [
                56.5991259,
                36.7106298
              ],
              [
                56.6073208,
                36.7174511
              ],
              [
                56.6100974,
                36.7196755
              ],
              [
                56.6125975,
                36.7210624
              ],
              [
                56.6142642,
                36.7227284
              ],
              [
                56.6518522,
                36.7489177
              ],
              [
                56.6551855,
                36.7514124
              ],
              [
                56.6733285,
                36.7583451
              ],
              [
                56.6752717,
                36.7591736
              ],
              [
                56.6921995,
                36.7670798
              ],
              [
                56.6999243,
                36.7782176
              ],
              [
                56.7129067,
                36.7952847
              ],
              [
                56.7156833,
                36.796113
              ],
              [
                56.7212399,
                36.7988951
              ],
              [
                56.72263,
                36.7991742
              ],
              [
                56.7242966,
                36.8000026
              ],
              [
                56.7634629,
                36.8105636
              ],
              [
                56.7731861,
                36.8144531
              ],
              [
                56.7745761,
                36.8147322
              ],
              [
                56.7773526,
                36.8161187
              ],
              [
                56.7792993,
                36.816677
              ],
              [
                56.7850594,
                36.8189212
              ],
              [
                56.7856161,
                36.8192003
              ],
              [
                56.7875595,
                36.8192003
              ],
              [
                56.7881162,
                36.8194794
              ],
              [
                56.7892531,
                36.823639
              ],
              [
                56.7903629,
                36.823918
              ],
              [
                56.7954496,
                36.8280446
              ],
              [
                56.7965596,
                36.8280447
              ],
              [
                56.8004495,
                36.829152
              ],
              [
                56.8023929,
                36.829431
              ],
              [
                56.8088161,
                36.8396154
              ],
              [
                56.8269527,
                36.8473761
              ],
              [
                56.8316393,
                36.8512392
              ],
              [
                56.8385226,
                36.8537116
              ],
              [
                56.8519224,
                36.858965
              ],
              [
                56.8822986,
                36.8809887
              ],
              [
                56.8889685,
                36.8823746
              ],
              [
                56.9132714,
                36.8906472
              ],
              [
                56.9243377,
                36.8885832
              ],
              [
                56.9320838,
                36.8851475
              ],
              [
                56.9329552,
                36.8853667
              ],
              [
                56.9309703,
                36.8884776
              ],
              [
                56.9293037,
                36.8959746
              ],
              [
                56.9146725,
                36.910647
              ],
              [
                56.9009396,
                36.9411117
              ],
              [
                56.8886734,
                36.9818775
              ],
              [
                56.8881168,
                36.9871491
              ],
              [
                56.8928399,
                36.996316
              ],
              [
                56.8931167,
                36.9965857
              ],
              [
                56.9095227,
                36.9992627
              ],
              [
                56.9369885,
                36.9943271
              ],
              [
                56.9507214,
                37.0050205
              ],
              [
                56.9491418,
                37.0125942
              ],
              [
                56.9535884,
                37.0189837
              ],
              [
                56.9594216,
                37.0217646
              ],
              [
                56.9599751,
                37.0217646
              ],
              [
                56.9602551,
                37.0220435
              ],
              [
                56.9613649,
                37.0220435
              ],
              [
                56.9616417,
                37.0223226
              ],
              [
                56.9773291,
                37.030103
              ],
              [
                56.9911694,
                37.0408933
              ],
              [
                57.0041083,
                37.0554512
              ],
              [
                56.9962118,
                37.0672319
              ],
              [
                56.9968985,
                37.0764085
              ],
              [
                57.0000326,
                37.085824
              ],
              [
                57.0027881,
                37.0925284
              ],
              [
                57.0058249,
                37.1009199
              ],
              [
                57.0233343,
                37.1161157
              ],
              [
                57.0305441,
                37.1380141
              ],
              [
                57.0307158,
                37.1738592
              ],
              [
                57.0273499,
                37.1845358
              ],
              [
                57.0115871,
                37.2017349
              ],
              [
                57.0102138,
                37.2095121
              ],
              [
                57.0072407,
                37.2187252
              ],
              [
                57.0075172,
                37.219562
              ],
              [
                57.0116372,
                37.2284475
              ],
              [
                57.0084806,
                37.2354003
              ],
              [
                57.0084354,
                37.2371732
              ],
              [
                57.0320889,
                37.2633976
              ],
              [
                57.0550915,
                37.2658567
              ],
              [
                57.0742518,
                37.2732061
              ],
              [
                57.0599775,
                37.3008545
              ],
              [
                57.0541826,
                37.3044814
              ],
              [
                57.0492952,
                37.3256975
              ],
              [
                57.049852,
                37.3281986
              ],
              [
                57.0501287,
                37.329872
              ],
              [
                57.0490187,
                37.3348651
              ],
              [
                57.0447585,
                37.3426412
              ],
              [
                57.0331494,
                37.3601768
              ],
              [
                57.0325962,
                37.3601769
              ],
              [
                57.0250764,
                37.3716522
              ],
              [
                57.0236863,
                37.371931
              ],
              [
                57.0068834,
                37.3936428
              ],
              [
                57.0065734,
                37.3971975
              ],
              [
                57.0062968,
                37.3974763
              ],
              [
                57.0054114,
                37.3974764
              ],
              [
                56.972001,
                37.4011853
              ],
              [
                56.9711675,
                37.4014641
              ],
              [
                56.969501,
                37.4020216
              ],
              [
                56.9683909,
                37.4020215
              ],
              [
                56.855888,
                37.4024777
              ],
              [
                56.8242735,
                37.3827007
              ],
              [
                56.8229034,
                37.3820249
              ],
              [
                56.8184866,
                37.3807291
              ],
              [
                56.8165431,
                37.3804502
              ],
              [
                56.8132065,
                37.3804502
              ],
              [
                56.8063544,
                37.3802521
              ],
              [
                56.7951335,
                37.3797407
              ],
              [
                56.7931902,
                37.3797407
              ],
              [
                56.7920768,
                37.3794619
              ],
              [
                56.7906902,
                37.3794618
              ],
              [
                56.7901335,
                37.3791829
              ],
              [
                56.7731871,
                37.379183
              ],
              [
                56.771797,
                37.3789131
              ],
              [
                56.7679104,
                37.379183
              ],
              [
                56.764297,
                37.3797407
              ],
              [
                56.7590205,
                37.3816839
              ],
              [
                56.7337416,
                37.3854353
              ],
              [
                56.7275618,
                37.3923912
              ],
              [
                56.7187159,
                37.397483
              ],
              [
                56.7128827,
                37.3980407
              ],
              [
                56.6964845,
                37.3975168
              ],
              [
                56.6915094,
                37.3950587
              ],
              [
                56.6878996,
                37.3950588
              ],
              [
                56.6798295,
                37.3925611
              ],
              [
                56.6742812,
                37.3944705
              ],
              [
                56.670948,
                37.3936429
              ],
              [
                56.6520582,
                37.3853126
              ],
              [
                56.6517815,
                37.3850337
              ],
              [
                56.6473349,
                37.3819751
              ],
              [
                56.6326252,
                37.3797409
              ],
              [
                56.6254019,
                37.3789132
              ],
              [
                56.6242919,
                37.3786253
              ],
              [
                56.6226253,
                37.3786253
              ],
              [
                56.6198451,
                37.3780766
              ],
              [
                56.6173453,
                37.3780766
              ],
              [
                56.6162353,
                37.3777977
              ],
              [
                56.6042921,
                37.3777978
              ],
              [
                56.6031788,
                37.3775188
              ],
              [
                56.5919493,
                37.371658
              ],
              [
                56.5852468,
                37.3679694
              ],
              [
                56.5821458,
                37.3666052
              ],
              [
                56.5856507,
                37.3582042
              ],
              [
                56.5862073,
                37.3545963
              ],
              [
                56.5828512,
                37.3453239
              ],
              [
                56.5773581,
                37.3375448
              ],
              [
                56.5757712,
                37.3300763
              ],
              [
                56.5763278,
                37.3292394
              ],
              [
                56.5962408,
                37.3307203
              ],
              [
                56.6155217,
                37.3308774
              ],
              [
                56.6166686,
                37.3251919
              ],
              [
                56.6152335,
                37.3223711
              ],
              [
                56.6146769,
                37.3198699
              ],
              [
                56.6043948,
                37.3058055
              ],
              [
                56.6022487,
                37.2950335
              ],
              [
                56.6025253,
                37.2922623
              ],
              [
                56.6028053,
                37.2919834
              ],
              [
                56.6030819,
                37.2903189
              ],
              [
                56.6025252,
                37.2864229
              ],
              [
                56.6041786,
                37.2816853
              ],
              [
                56.6045828,
                37.2753282
              ],
              [
                56.6040087,
                37.2632971
              ],
              [
                56.6045653,
                37.2630182
              ],
              [
                56.6045653,
                37.2624603
              ],
              [
                56.6074888,
                37.2510014
              ],
              [
                56.6175859,
                37.2445454
              ],
              [
                56.6207176,
                37.2404328
              ],
              [
                56.6682158,
                37.2291611
              ],
              [
                56.6684926,
                37.2288913
              ],
              [
                56.6705703,
                37.2265014
              ],
              [
                56.6710816,
                37.2244964
              ],
              [
                56.6688249,
                37.2180794
              ],
              [
                56.6653116,
                37.2110485
              ],
              [
                56.6626318,
                37.2073299
              ],
              [
                56.6589184,
                37.2062122
              ],
              [
                56.6586419,
                37.2048266
              ],
              [
                56.6583651,
                37.2031622
              ],
              [
                56.6655063,
                37.1975185
              ],
              [
                56.6648196,
                37.1945102
              ],
              [
                56.6597556,
                37.1873992
              ],
              [
                56.6504001,
                37.1839118
              ],
              [
                56.642847,
                37.1823391
              ],
              [
                56.6334056,
                37.182681
              ],
              [
                56.6251659,
                37.1845957
              ],
              [
                56.6156386,
                37.1856214
              ],
              [
                56.6037352,
                37.1866838
              ],
              [
                56.5951719,
                37.1852129
              ],
              [
                56.5943386,
                37.1852129
              ],
              [
                56.5932286,
                37.184655
              ],
              [
                56.586562,
                37.1838272
              ],
              [
                56.5860053,
                37.1835482
              ],
              [
                56.5843385,
                37.1835482
              ],
              [
                56.5837819,
                37.1832692
              ],
              [
                56.5771153,
                37.1832693
              ],
              [
                56.5768388,
                37.1835482
              ],
              [
                56.5743387,
                37.1835483
              ],
              [
                56.5735056,
                37.1835482
              ],
              [
                56.5572074,
                37.1865588
              ],
              [
                56.5566505,
                37.1868377
              ],
              [
                56.5519522,
                37.1804244
              ],
              [
                56.5444357,
                37.1775377
              ],
              [
                56.5441589,
                37.1772587
              ],
              [
                56.5392258,
                37.1747966
              ],
              [
                56.5375591,
                37.1745267
              ],
              [
                56.5255163,
                37.1715339
              ],
              [
                56.5169333,
                37.1657887
              ],
              [
                56.5081395,
                37.1638409
              ],
              [
                56.5059197,
                37.1627339
              ],
              [
                56.5053629,
                37.1624549
              ],
              [
                56.4157664,
                37.0764585
              ],
              [
                56.4028039,
                37.0627561
              ],
              [
                56.3915632,
                37.0519623
              ],
              [
                56.3846917,
                37.0422603
              ],
              [
                56.3786197,
                37.0352294
              ],
              [
                56.3725933,
                37.028144
              ],
              [
                56.3687222,
                37.0228073
              ],
              [
                56.356804,
                37.0123956
              ],
              [
                56.3520067,
                37.0042696
              ],
              [
                56.3430928,
                36.9946687
              ],
              [
                56.3383013,
                36.9895341
              ],
              [
                56.3327928,
                36.9836664
              ],
              [
                56.3232941,
                36.9750709
              ],
              [
                56.3205634,
                36.973388
              ],
              [
                56.3206749,
                36.9729383
              ],
              [
                56.3210645,
                36.9722693
              ],
              [
                56.317328,
                36.9690819
              ],
              [
                56.312172,
                36.9642417
              ],
              [
                56.3046285,
                36.9579985
              ],
              [
                56.2958633,
                36.9518127
              ],
              [
                56.2828341,
                36.9425308
              ],
              [
                56.276531,
                36.9324298
              ],
              [
                56.2613479,
                36.927463
              ],
              [
                56.1182785,
                36.8613252
              ],
              [
                56.1069953,
                36.8561077
              ],
              [
                56.1037794,
                36.8532569
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555033,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان راز و جرگلان",
          "name:en": "Raz and Jargalan County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q7299437",
          "wikipedia": "en:Raz and Jargalan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.3280182,
                38.1565067
              ],
              [
                56.3314709,
                38.1560271
              ],
              [
                56.3317795,
                38.1558777
              ],
              [
                56.3320561,
                38.1555991
              ],
              [
                56.3328895,
                38.1553207
              ],
              [
                56.3348327,
                38.1553207
              ],
              [
                56.3348327,
                38.1550421
              ],
              [
                56.3384461,
                38.1550421
              ],
              [
                56.3384461,
                38.1547636
              ],
              [
                56.3428893,
                38.1547636
              ],
              [
                56.3431694,
                38.1544851
              ],
              [
                56.3442794,
                38.1544851
              ],
              [
                56.3615024,
                38.1494806
              ],
              [
                56.3623358,
                38.1494807
              ],
              [
                56.3797758,
                38.1276702
              ],
              [
                56.415552,
                38.1115196
              ],
              [
                56.415832,
                38.111241
              ],
              [
                56.4161088,
                38.1109623
              ],
              [
                56.4222186,
                38.1067923
              ],
              [
                56.4443205,
                38.1009284
              ],
              [
                56.4498137,
                38.1010635
              ],
              [
                56.4618867,
                38.1053427
              ],
              [
                56.4632732,
                38.1053427
              ],
              [
                56.4839743,
                38.1084927
              ],
              [
                56.4944456,
                38.1057913
              ],
              [
                56.5114609,
                38.0937453
              ],
              [
                56.5122943,
                38.0937452
              ],
              [
                56.5463898,
                38.0883338
              ],
              [
                56.5486906,
                38.0864729
              ],
              [
                56.5488623,
                38.0799873
              ],
              [
                56.5509222,
                38.0772847
              ],
              [
                56.5885161,
                38.0716091
              ],
              [
                56.6122053,
                38.0697172
              ],
              [
                56.6338347,
                38.071474
              ],
              [
                56.6709135,
                38.0645816
              ],
              [
                56.7041809,
                38.0668174
              ],
              [
                56.7169446,
                38.0675523
              ],
              [
                56.7207226,
                38.0524447
              ],
              [
                56.7124404,
                38.0468047
              ],
              [
                56.6944013,
                38.0341609
              ],
              [
                56.6957879,
                38.031106
              ],
              [
                56.696068,
                38.0308275
              ],
              [
                56.6841315,
                38.006308
              ],
              [
                56.6735641,
                37.9944114
              ],
              [
                56.6898739,
                37.9667942
              ],
              [
                56.6901506,
                37.9665156
              ],
              [
                56.6820715,
                37.9513721
              ],
              [
                56.6818193,
                37.9471687
              ],
              [
                56.7058908,
                37.9300922
              ],
              [
                56.7064474,
                37.9298134
              ],
              [
                56.73151,
                37.9321484
              ],
              [
                56.7474745,
                37.9310652
              ],
              [
                56.8134957,
                37.9198444
              ],
              [
                56.814329,
                37.9198445
              ],
              [
                56.8171089,
                37.9190085
              ],
              [
                56.8187756,
                37.9190085
              ],
              [
                56.8193289,
                37.9190085
              ],
              [
                56.8201621,
                37.9187299
              ],
              [
                56.8248854,
                37.9187299
              ],
              [
                56.8505002,
                37.9161724
              ],
              [
                56.8535567,
                37.9164511
              ],
              [
                56.85939,
                37.9164511
              ],
              [
                56.8914984,
                37.9062832
              ],
              [
                56.8983648,
                37.9060123
              ],
              [
                56.9314495,
                37.9000652
              ],
              [
                56.9385336,
                37.9079085
              ],
              [
                56.9488333,
                37.9038451
              ],
              [
                56.979904,
                37.8920602
              ],
              [
                57.0051382,
                37.8814928
              ],
              [
                57.0202388,
                37.8802642
              ],
              [
                57.0291287,
                37.8783225
              ],
              [
                57.0435954,
                37.8732186
              ],
              [
                57.0499418,
                37.8626574
              ],
              [
                57.05595,
                37.8585916
              ],
              [
                57.0781721,
                37.8525828
              ],
              [
                57.0798387,
                37.8523042
              ],
              [
                57.0803919,
                37.8523041
              ],
              [
                57.0921705,
                37.8463927
              ],
              [
                57.1323393,
                37.8409704
              ],
              [
                57.1565713,
                37.8389084
              ],
              [
                57.1571246,
                37.8386298
              ],
              [
                57.1590713,
                37.8386298
              ],
              [
                57.1590712,
                37.839466
              ],
              [
                57.1587912,
                37.8400234
              ],
              [
                57.1594766,
                37.844014
              ],
              [
                57.1586434,
                37.8501278
              ],
              [
                57.1594766,
                37.852897
              ],
              [
                57.1594766,
                37.8537332
              ],
              [
                57.1597533,
                37.8542906
              ],
              [
                57.1619766,
                37.8626251
              ],
              [
                57.1625333,
                37.8634612
              ],
              [
                57.1636432,
                37.8654032
              ],
              [
                57.1652983,
                37.8682137
              ],
              [
                57.1792029,
                37.873634
              ],
              [
                57.1833227,
                37.8856929
              ],
              [
                57.1860693,
                37.8940922
              ],
              [
                57.1947698,
                37.9059951
              ],
              [
                57.1997697,
                37.9118383
              ],
              [
                57.200323,
                37.912117
              ],
              [
                57.2114752,
                37.9205034
              ],
              [
                57.2140501,
                37.9263261
              ],
              [
                57.2269247,
                37.9260553
              ],
              [
                57.2377394,
                37.9225346
              ],
              [
                57.2420309,
                37.9237533
              ],
              [
                57.2397993,
                37.9295758
              ],
              [
                57.2391127,
                37.9355332
              ],
              [
                57.2414821,
                37.938615
              ],
              [
                57.2417622,
                37.9408445
              ],
              [
                57.240649,
                37.9450068
              ],
              [
                57.2406489,
                37.9455642
              ],
              [
                57.240649,
                37.945843
              ],
              [
                57.2412057,
                37.9464003
              ],
              [
                57.2412056,
                37.946679
              ],
              [
                57.2456489,
                37.9505717
              ],
              [
                57.2462056,
                37.95112
              ],
              [
                57.2651561,
                37.966877
              ],
              [
                57.2682377,
                37.9743198
              ],
              [
                57.2696278,
                37.9740413
              ],
              [
                57.272681,
                37.9740412
              ],
              [
                57.2743477,
                37.9743198
              ],
              [
                57.2760145,
                37.9743198
              ],
              [
                57.3173368,
                37.980392
              ],
              [
                57.3187235,
                37.9809491
              ],
              [
                57.3332386,
                37.978066
              ],
              [
                57.351272,
                37.9839226
              ],
              [
                57.3515521,
                37.9842012
              ],
              [
                57.3523853,
                37.9844798
              ],
              [
                57.3538472,
                37.984541
              ],
              [
                57.3588133,
                37.9848987
              ],
              [
                57.356944,
                37.985833
              ],
              [
                57.353056,
                37.989444
              ],
              [
                57.350278,
                37.993889
              ],
              [
                57.348333,
                37.998889
              ],
              [
                57.350278,
                38.005
              ],
              [
                57.351944,
                38.010833
              ],
              [
                57.353611,
                38.016944
              ],
              [
                57.356111,
                38.022222
              ],
              [
                57.358056,
                38.028333
              ],
              [
                57.359722,
                38.034167
              ],
              [
                57.361389,
                38.040278
              ],
              [
                57.363333,
                38.046389
              ],
              [
                57.365,
                38.052222
              ],
              [
                57.366944,
                38.058333
              ],
              [
                57.369444,
                38.063611
              ],
              [
                57.371111,
                38.069722
              ],
              [
                57.373056,
                38.075556
              ],
              [
                57.373889,
                38.0825
              ],
              [
                57.373056,
                38.088056
              ],
              [
                57.371111,
                38.093056
              ],
              [
                57.367222,
                38.096667
              ],
              [
                57.3625,
                38.1
              ],
              [
                57.357778,
                38.103056
              ],
              [
                57.353056,
                38.106389
              ],
              [
                57.349167,
                38.11
              ],
              [
                57.345556,
                38.113889
              ],
              [
                57.341667,
                38.1175
              ],
              [
                57.339722,
                38.1225
              ],
              [
                57.339722,
                38.128889
              ],
              [
                57.338056,
                38.133889
              ],
              [
                57.335,
                38.138056
              ],
              [
                57.332222,
                38.1425
              ],
              [
                57.328333,
                38.146389
              ],
              [
                57.324722,
                38.15
              ],
              [
                57.318889,
                38.152778
              ],
              [
                57.311389,
                38.154167
              ],
              [
                57.304444,
                38.156111
              ],
              [
                57.299722,
                38.159167
              ],
              [
                57.2963749,
                38.1615295
              ],
              [
                57.295,
                38.1625
              ],
              [
                57.292222,
                38.166944
              ],
              [
                57.288333,
                38.170556
              ],
              [
                57.2875,
                38.176111
              ],
              [
                57.288611,
                38.183056
              ],
              [
                57.288611,
                38.189167
              ],
              [
                57.288611,
                38.195278
              ],
              [
                57.286667,
                38.200278
              ],
              [
                57.284722,
                38.205278
              ],
              [
                57.281944,
                38.209722
              ],
              [
                57.28,
                38.214722
              ],
              [
                57.278333,
                38.219722
              ],
              [
                57.274444,
                38.223333
              ],
              [
                57.271667,
                38.227778
              ],
              [
                57.266667,
                38.230833
              ],
              [
                57.261944,
                38.232778
              ],
              [
                57.255278,
                38.234722
              ],
              [
                57.251389,
                38.238611
              ],
              [
                57.249444,
                38.243611
              ],
              [
                57.2475,
                38.248611
              ],
              [
                57.245556,
                38.253333
              ],
              [
                57.246667,
                38.260278
              ],
              [
                57.246667,
                38.266389
              ],
              [
                57.243889,
                38.270833
              ],
              [
                57.2420302,
                38.2717653
              ],
              [
                57.2318957,
                38.2705747
              ],
              [
                57.2228202,
                38.2726488
              ],
              [
                57.2185059,
                38.2740329
              ],
              [
                57.2164884,
                38.2774018
              ],
              [
                57.2127887,
                38.2762933
              ],
              [
                57.2030116,
                38.2764888
              ],
              [
                57.1916779,
                38.276843
              ],
              [
                57.1848766,
                38.2763114
              ],
              [
                57.161111,
                38.272222
              ],
              [
                57.156944,
                38.268333
              ],
              [
                57.152778,
                38.264722
              ],
              [
                57.149722,
                38.26
              ],
              [
                57.147222,
                38.255
              ],
              [
                57.1438512,
                38.2501988
              ],
              [
                57.1413292,
                38.2449203
              ],
              [
                57.1379823,
                38.240459
              ],
              [
                57.1346385,
                38.236058
              ],
              [
                57.1298342,
                38.2330077
              ],
              [
                57.1243492,
                38.2307956
              ],
              [
                57.1187133,
                38.2285742
              ],
              [
                57.1065063,
                38.226018
              ],
              [
                57.0954557,
                38.219645
              ],
              [
                57.0907536,
                38.2160363
              ],
              [
                57.086584,
                38.2121113
              ],
              [
                57.0832865,
                38.2077109
              ],
              [
                57.0801973,
                38.2032576
              ],
              [
                57.0761452,
                38.1994725
              ],
              [
                57.0704964,
                38.1971982
              ],
              [
                57.065,
                38.195
              ],
              [
                57.058611,
                38.193611
              ],
              [
                57.050833,
                38.193611
              ],
              [
                57.044167,
                38.195556
              ],
              [
                57.036389,
                38.196944
              ],
              [
                57.030556,
                38.199444
              ],
              [
                57.025,
                38.201944
              ],
              [
                57.0122329,
                38.1871898
              ],
              [
                57.0109915,
                38.1897015
              ],
              [
                57.0101597,
                38.1898024
              ],
              [
                57.0089296,
                38.1889853
              ],
              [
                57.0072842,
                38.1888092
              ],
              [
                57.0064349,
                38.1888614
              ],
              [
                57.0039172,
                38.1904923
              ],
              [
                57.0008947,
                38.1959582
              ],
              [
                56.9966494,
                38.2035305
              ],
              [
                56.9938588,
                38.2096027
              ],
              [
                56.9919985,
                38.2143439
              ],
              [
                56.985225,
                38.2145313
              ],
              [
                56.9766149,
                38.2143626
              ],
              [
                56.97,
                38.214444
              ],
              [
                56.9672894,
                38.2111581
              ],
              [
                56.9628532,
                38.2111581
              ],
              [
                56.9531699,
                38.2133694
              ],
              [
                56.9462771,
                38.2143064
              ],
              [
                56.9423894,
                38.2141565
              ],
              [
                56.9367846,
                38.2146062
              ],
              [
                56.934328,
                38.2142877
              ],
              [
                56.9309412,
                38.2164427
              ],
              [
                56.9248895,
                38.2147897
              ],
              [
                56.9189991,
                38.2158124
              ],
              [
                56.9098218,
                38.2146874
              ],
              [
                56.9017005,
                38.2178293
              ],
              [
                56.8972643,
                38.2201341
              ],
              [
                56.885983,
                38.2191598
              ],
              [
                56.8771821,
                38.2225513
              ],
              [
                56.8698123,
                38.2250808
              ],
              [
                56.8629264,
                38.2285703
              ],
              [
                56.8569383,
                38.2297718
              ],
              [
                56.8517964,
                38.2309989
              ],
              [
                56.8404712,
                38.2298997
              ],
              [
                56.8345157,
                38.2340665
              ],
              [
                56.8302851,
                38.2378241
              ],
              [
                56.8251757,
                38.2398945
              ],
              [
                56.8210101,
                38.2412748
              ],
              [
                56.8178859,
                38.2436774
              ],
              [
                56.8148594,
                38.2455688
              ],
              [
                56.8036584,
                38.2475542
              ],
              [
                56.7990346,
                38.2516414
              ],
              [
                56.7927133,
                38.2516589
              ],
              [
                56.78905,
                38.2582015
              ],
              [
                56.786111,
                38.261111
              ],
              [
                56.780556,
                38.264444
              ],
              [
                56.7744863,
                38.2663745
              ],
              [
                56.7717835,
                38.2685491
              ],
              [
                56.7668694,
                38.269882
              ],
              [
                56.7636975,
                38.2729508
              ],
              [
                56.7627594,
                38.2760196
              ],
              [
                56.7632954,
                38.2788076
              ],
              [
                56.7619999,
                38.2800526
              ],
              [
                56.7607937,
                38.2834016
              ],
              [
                56.7580686,
                38.2837347
              ],
              [
                56.756389,
                38.285
              ],
              [
                56.7539362,
                38.2845939
              ],
              [
                56.750833,
                38.282778
              ],
              [
                56.744444,
                38.281111
              ],
              [
                56.738889,
                38.278889
              ],
              [
                56.734167,
                38.275833
              ],
              [
                56.727778,
                38.274444
              ],
              [
                56.722222,
                38.272222
              ],
              [
                56.715833,
                38.270556
              ],
              [
                56.709722,
                38.269167
              ],
              [
                56.7025,
                38.268333
              ],
              [
                56.695278,
                38.266944
              ],
              [
                56.687778,
                38.268333
              ],
              [
                56.679167,
                38.269167
              ],
              [
                56.671111,
                38.269167
              ],
              [
                56.664167,
                38.268333
              ],
              [
                56.658611,
                38.266111
              ],
              [
                56.653056,
                38.263889
              ],
              [
                56.648056,
                38.260833
              ],
              [
                56.643333,
                38.257778
              ],
              [
                56.64,
                38.253333
              ],
              [
                56.636111,
                38.249444
              ],
              [
                56.631389,
                38.246389
              ],
              [
                56.625833,
                38.244167
              ],
              [
                56.620278,
                38.241944
              ],
              [
                56.613889,
                38.240556
              ],
              [
                56.605278,
                38.241111
              ],
              [
                56.5975,
                38.2425
              ],
              [
                56.591667,
                38.245278
              ],
              [
                56.586944,
                38.248333
              ],
              [
                56.582222,
                38.251389
              ],
              [
                56.578333,
                38.255278
              ],
              [
                56.5725,
                38.257778
              ],
              [
                56.566944,
                38.260278
              ],
              [
                56.561111,
                38.262778
              ],
              [
                56.554444,
                38.264722
              ],
              [
                56.546667,
                38.266111
              ],
              [
                56.538889,
                38.266111
              ],
              [
                56.5325,
                38.264722
              ],
              [
                56.525278,
                38.263889
              ],
              [
                56.518333,
                38.263056
              ],
              [
                56.511111,
                38.2625
              ],
              [
                56.504167,
                38.261667
              ],
              [
                56.495556,
                38.2625
              ],
              [
                56.486944,
                38.263056
              ],
              [
                56.478889,
                38.263056
              ],
              [
                56.4706157,
                38.2634415
              ],
              [
                56.4685938,
                38.263082
              ],
              [
                56.4665219,
                38.2643014
              ],
              [
                56.4653133,
                38.2635348
              ],
              [
                56.464167,
                38.262222
              ],
              [
                56.4629074,
                38.2613272
              ],
              [
                56.4611103,
                38.2644891
              ],
              [
                56.4606618,
                38.2649861
              ],
              [
                56.4598547,
                38.2649674
              ],
              [
                56.4585913,
                38.2640249
              ],
              [
                56.457492,
                38.2641986
              ],
              [
                56.4558539,
                38.2649655
              ],
              [
                56.4525193,
                38.2646529
              ],
              [
                56.4513827,
                38.2634402
              ],
              [
                56.4499849,
                38.2619749
              ],
              [
                56.4469283,
                38.2614729
              ],
              [
                56.442778,
                38.26
              ],
              [
                56.436389,
                38.258611
              ],
              [
                56.430833,
                38.256389
              ],
              [
                56.424444,
                38.254722
              ],
              [
                56.419722,
                38.251667
              ],
              [
                56.414167,
                38.249444
              ],
              [
                56.409444,
                38.246389
              ],
              [
                56.404722,
                38.243333
              ],
              [
                56.399722,
                38.240556
              ],
              [
                56.395,
                38.2375
              ],
              [
                56.390278,
                38.234444
              ],
              [
                56.385556,
                38.231389
              ],
              [
                56.381389,
                38.2275
              ],
              [
                56.376667,
                38.224444
              ],
              [
                56.371944,
                38.221667
              ],
              [
                56.367222,
                38.218611
              ],
              [
                56.363056,
                38.214722
              ],
              [
                56.358333,
                38.211667
              ],
              [
                56.354444,
                38.208056
              ],
              [
                56.349444,
                38.205
              ],
              [
                56.344722,
                38.201944
              ],
              [
                56.34,
                38.198889
              ],
              [
                56.3327792,
                38.1975537
              ],
              [
                56.3317439,
                38.1955008
              ],
              [
                56.330556,
                38.192778
              ],
              [
                56.326389,
                38.189167
              ],
              [
                56.3309536,
                38.1857985
              ],
              [
                56.3308832,
                38.1857084
              ],
              [
                56.3307836,
                38.1856627
              ],
              [
                56.3302975,
                38.1855822
              ],
              [
                56.3294815,
                38.1849731
              ],
              [
                56.3288768,
                38.1841887
              ],
              [
                56.3286538,
                38.1839949
              ],
              [
                56.3281606,
                38.1838103
              ],
              [
                56.327327,
                38.1828689
              ],
              [
                56.3269161,
                38.182712
              ],
              [
                56.3265521,
                38.1823752
              ],
              [
                56.3264288,
                38.1823429
              ],
              [
                56.3260472,
                38.1823336
              ],
              [
                56.3259239,
                38.1822644
              ],
              [
                56.3249025,
                38.1807831
              ],
              [
                56.3247205,
                38.1805339
              ],
              [
                56.3242743,
                38.1803909
              ],
              [
                56.3234231,
                38.1798556
              ],
              [
                56.3231648,
                38.1797633
              ],
              [
                56.3226658,
                38.179791
              ],
              [
                56.3220024,
                38.1799386
              ],
              [
                56.3210935,
                38.1802171
              ],
              [
                56.3206287,
                38.1803263
              ],
              [
                56.3201783,
                38.1803082
              ],
              [
                56.3188973,
                38.1794865
              ],
              [
                56.3185205,
                38.1790722
              ],
              [
                56.318919,
                38.1783983
              ],
              [
                56.3191186,
                38.1774753
              ],
              [
                56.319101,
                38.176137
              ],
              [
                56.3195109,
                38.1755807
              ],
              [
                56.3194868,
                38.1746204
              ],
              [
                56.3234677,
                38.1685081
              ],
              [
                56.3236376,
                38.1652846
              ],
              [
                56.3260871,
                38.160598
              ],
              [
                56.3280182,
                38.1565067
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555127,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فاروج",
          "name:en": "Faruj County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2610690",
          "wikipedia": "en:Faruj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.8704895,
                37.125219
              ],
              [
                57.884216,
                37.099277
              ],
              [
                57.8910824,
                37.0896923
              ],
              [
                57.8886792,
                37.0781891
              ],
              [
                57.8893658,
                37.0683278
              ],
              [
                57.8974401,
                37.0502059
              ],
              [
                57.8982738,
                37.0493687
              ],
              [
                57.8997945,
                37.0356528
              ],
              [
                57.9011791,
                37.0332266
              ],
              [
                57.9144286,
                37.0314733
              ],
              [
                57.9245473,
                37.0291879
              ],
              [
                57.9443618,
                37.0155265
              ],
              [
                57.9490184,
                37.0103665
              ],
              [
                57.9517219,
                37.0075907
              ],
              [
                57.9663133,
                37.0093041
              ],
              [
                57.973523,
                37.0112918
              ],
              [
                57.978115,
                37.0134163
              ],
              [
                57.9829215,
                37.0110177
              ],
              [
                57.9848759,
                37.0085161
              ],
              [
                57.9893291,
                37.005644
              ],
              [
                57.9942111,
                37.002246
              ],
              [
                58.0000147,
                36.9964181
              ],
              [
                58.0032579,
                36.9942027
              ],
              [
                58.0088939,
                36.9949858
              ],
              [
                58.0162314,
                36.9919072
              ],
              [
                58.0066025,
                36.9790646
              ],
              [
                58.0020881,
                36.973582
              ],
              [
                58.0023682,
                36.960773
              ],
              [
                58.0023191,
                36.9535641
              ],
              [
                58.0039699,
                36.9477586
              ],
              [
                58.0064045,
                36.9453421
              ],
              [
                58.0094981,
                36.9418842
              ],
              [
                58.0132695,
                36.9389969
              ],
              [
                58.0231441,
                36.9367159
              ],
              [
                58.0248336,
                36.9368821
              ],
              [
                58.0408586,
                36.9380033
              ],
              [
                58.0703924,
                36.9421449
              ],
              [
                58.078023,
                36.9425143
              ],
              [
                58.0820713,
                36.9411306
              ],
              [
                58.0883501,
                36.9390353
              ],
              [
                58.0925912,
                36.9335455
              ],
              [
                58.0957754,
                36.9262778
              ],
              [
                58.0960417,
                36.9232646
              ],
              [
                58.1043221,
                36.9173297
              ],
              [
                58.1159725,
                36.9100111
              ],
              [
                58.1216551,
                36.896869
              ],
              [
                58.1261357,
                36.8845936
              ],
              [
                58.142399,
                36.8740469
              ],
              [
                58.1543878,
                36.8782624
              ],
              [
                58.166099,
                36.8826335
              ],
              [
                58.1939046,
                36.8894989
              ],
              [
                58.2049671,
                36.8922868
              ],
              [
                58.2110353,
                36.8790485
              ],
              [
                58.2178202,
                36.8801677
              ],
              [
                58.2195107,
                36.8797019
              ],
              [
                58.2226129,
                36.8795775
              ],
              [
                58.2261532,
                36.8815633
              ],
              [
                58.2301291,
                36.8844487
              ],
              [
                58.2382216,
                36.8893574
              ],
              [
                58.2475246,
                36.8965927
              ],
              [
                58.2626539,
                36.9106987
              ],
              [
                58.2721931,
                36.9156663
              ],
              [
                58.2763522,
                36.9179427
              ],
              [
                58.2797298,
                36.9198457
              ],
              [
                58.2909356,
                36.9262502
              ],
              [
                58.2978115,
                36.9305869
              ],
              [
                58.3019936,
                36.9341468
              ],
              [
                58.3131959,
                36.939745
              ],
              [
                58.3227167,
                36.9445605
              ],
              [
                58.3274959,
                36.9476302
              ],
              [
                58.3360185,
                36.9541903
              ],
              [
                58.3407249,
                36.9576562
              ],
              [
                58.3443971,
                36.9631784
              ],
              [
                58.3524176,
                36.9766817
              ],
              [
                58.3544188,
                36.9856145
              ],
              [
                58.3559309,
                36.9905253
              ],
              [
                58.3581942,
                36.9971428
              ],
              [
                58.357726,
                36.9999808
              ],
              [
                58.3555755,
                37.0051087
              ],
              [
                58.351308,
                37.0094025
              ],
              [
                58.3448216,
                37.0137642
              ],
              [
                58.333928,
                37.0186814
              ],
              [
                58.3230578,
                37.019693
              ],
              [
                58.3128693,
                37.0192252
              ],
              [
                58.3023073,
                37.0218778
              ],
              [
                58.2859412,
                37.0260814
              ],
              [
                58.2765811,
                37.028476
              ],
              [
                58.2691814,
                37.0306166
              ],
              [
                58.2606529,
                37.0331495
              ],
              [
                58.2585023,
                37.0363777
              ],
              [
                58.2544429,
                37.0426138
              ],
              [
                58.2512799,
                37.0474909
              ],
              [
                58.2495559,
                37.0488613
              ],
              [
                58.2397744,
                37.0581835
              ],
              [
                58.2323491,
                37.0680569
              ],
              [
                58.2282808,
                37.0759122
              ],
              [
                58.2118877,
                37.0795245
              ],
              [
                58.1975814,
                37.0848411
              ],
              [
                58.1819782,
                37.0907336
              ],
              [
                58.1733704,
                37.0968941
              ],
              [
                58.1841477,
                37.1121496
              ],
              [
                58.1927773,
                37.1280923
              ],
              [
                58.1970691,
                37.137672
              ],
              [
                58.1984725,
                37.1403551
              ],
              [
                58.2080379,
                37.1519387
              ],
              [
                58.2135671,
                37.1547662
              ],
              [
                58.2341476,
                37.1529974
              ],
              [
                58.2455631,
                37.1522449
              ],
              [
                58.2552621,
                37.1518344
              ],
              [
                58.2597255,
                37.1519026
              ],
              [
                58.2636737,
                37.1522447
              ],
              [
                58.26848,
                37.1551864
              ],
              [
                58.270626,
                37.1592222
              ],
              [
                58.2703685,
                37.1622319
              ],
              [
                58.2665062,
                37.1657202
              ],
              [
                58.261399,
                37.1668831
              ],
              [
                58.2479289,
                37.167732
              ],
              [
                58.2395756,
                37.172165
              ],
              [
                58.2384353,
                37.1757051
              ],
              [
                58.2385808,
                37.1790635
              ],
              [
                58.2409636,
                37.1818043
              ],
              [
                58.2484388,
                37.1839802
              ],
              [
                58.2526445,
                37.1833306
              ],
              [
                58.2610988,
                37.183946
              ],
              [
                58.2733726,
                37.1880488
              ],
              [
                58.2756895,
                37.1896338
              ],
              [
                58.2812687,
                37.1877413
              ],
              [
                58.2845425,
                37.1864574
              ],
              [
                58.2917436,
                37.1818301
              ],
              [
                58.2962668,
                37.1792603
              ],
              [
                58.3139811,
                37.1689323
              ],
              [
                58.3099874,
                37.1775119
              ],
              [
                58.3077558,
                37.1832852
              ],
              [
                58.3040066,
                37.193598
              ],
              [
                58.3079457,
                37.1961985
              ],
              [
                58.3099419,
                37.1989605
              ],
              [
                58.308072,
                37.2005908
              ],
              [
                58.3001659,
                37.198409
              ],
              [
                58.3005599,
                37.2020466
              ],
              [
                58.3114128,
                37.2101242
              ],
              [
                58.3193769,
                37.2126384
              ],
              [
                58.3268552,
                37.2130485
              ],
              [
                58.3313206,
                37.2141134
              ],
              [
                58.3350054,
                37.2179411
              ],
              [
                58.3409412,
                37.2224918
              ],
              [
                58.3519337,
                37.2216718
              ],
              [
                58.3633038,
                37.2196158
              ],
              [
                58.3701358,
                37.2181803
              ],
              [
                58.3764828,
                37.2167736
              ],
              [
                58.3899517,
                37.2138017
              ],
              [
                58.3939745,
                37.2138704
              ],
              [
                58.4019899,
                37.213891
              ],
              [
                58.4148067,
                37.2201301
              ],
              [
                58.4177258,
                37.2443819
              ],
              [
                58.4191121,
                37.2485478
              ],
              [
                58.4154325,
                37.2585858
              ],
              [
                58.4151594,
                37.2588647
              ],
              [
                58.4143257,
                37.2588648
              ],
              [
                58.4065658,
                37.2735281
              ],
              [
                58.4032325,
                37.2757505
              ],
              [
                58.3782328,
                37.2899205
              ],
              [
                58.3698832,
                37.2962452
              ],
              [
                58.3690499,
                37.2965152
              ],
              [
                58.360372,
                37.3104508
              ],
              [
                58.3298302,
                37.327215
              ],
              [
                58.3235402,
                37.3325165
              ],
              [
                58.3092495,
                37.3431405
              ],
              [
                58.3096638,
                37.3519522
              ],
              [
                58.3119206,
                37.3574911
              ],
              [
                58.3160406,
                37.3608556
              ],
              [
                58.3163206,
                37.3619622
              ],
              [
                58.3179871,
                37.3677918
              ],
              [
                58.3366803,
                37.3820307
              ],
              [
                58.3405666,
                37.3859172
              ],
              [
                58.35886,
                37.39487
              ],
              [
                58.3638601,
                37.4015364
              ],
              [
                58.3679433,
                37.4170664
              ],
              [
                58.3676632,
                37.4212407
              ],
              [
                58.3682234,
                37.4245692
              ],
              [
                58.3679434,
                37.4292921
              ],
              [
                58.3494197,
                37.4432959
              ],
              [
                58.3379169,
                37.4549378
              ],
              [
                58.3386524,
                37.4999863
              ],
              [
                58.326206,
                37.5390237
              ],
              [
                58.3207883,
                37.5672602
              ],
              [
                58.3142488,
                37.5874988
              ],
              [
                58.2979048,
                37.6373714
              ],
              [
                58.299905,
                37.6525298
              ],
              [
                58.2989117,
                37.6547113
              ],
              [
                58.3112048,
                37.662222
              ],
              [
                58.306389,
                37.662222
              ],
              [
                58.298889,
                37.663611
              ],
              [
                58.288205,
                37.6662374
              ],
              [
                58.2864885,
                37.6681187
              ],
              [
                58.2816889,
                37.669368
              ],
              [
                58.2803236,
                37.6708576
              ],
              [
                58.273254,
                37.6717923
              ],
              [
                58.2628287,
                37.6737524
              ],
              [
                58.2578763,
                37.6756835
              ],
              [
                58.2516721,
                37.6772477
              ],
              [
                58.2460889,
                37.6790518
              ],
              [
                58.2421005,
                37.680074
              ],
              [
                58.2333025,
                37.6793376
              ],
              [
                58.2238155,
                37.6789146
              ],
              [
                58.223934,
                37.6664293
              ],
              [
                58.2194708,
                37.6555578
              ],
              [
                58.2192991,
                37.6418303
              ],
              [
                58.2128671,
                37.6293254
              ],
              [
                58.2134203,
                37.6290466
              ],
              [
                58.2210156,
                37.6204865
              ],
              [
                58.2411384,
                37.6019736
              ],
              [
                58.2491983,
                37.5969712
              ],
              [
                58.2553047,
                37.5847439
              ],
              [
                58.2550315,
                37.5836282
              ],
              [
                58.2612255,
                37.5503571
              ],
              [
                58.2620252,
                37.5431985
              ],
              [
                58.261745,
                37.5423621
              ],
              [
                58.2604702,
                37.5134153
              ],
              [
                58.2610233,
                37.5073069
              ],
              [
                58.2615764,
                37.5061914
              ],
              [
                58.2618565,
                37.5045272
              ],
              [
                58.26241,
                37.5034117
              ],
              [
                58.26241,
                37.5023051
              ],
              [
                58.2629702,
                37.5011896
              ],
              [
                58.2632433,
                37.4992464
              ],
              [
                58.2718231,
                37.493677
              ],
              [
                58.2718231,
                37.4884062
              ],
              [
                58.2709899,
                37.4850691
              ],
              [
                58.2701563,
                37.4836838
              ],
              [
                58.269648,
                37.475576
              ],
              [
                58.2629814,
                37.470296
              ],
              [
                58.2113665,
                37.4476235
              ],
              [
                58.2099801,
                37.4462296
              ],
              [
                58.185442,
                37.4450859
              ],
              [
                58.1731966,
                37.4339935
              ],
              [
                58.1712295,
                37.4323787
              ],
              [
                58.168196,
                37.4277755
              ],
              [
                58.1655477,
                37.4210529
              ],
              [
                58.1673717,
                37.3990055
              ],
              [
                58.1672,
                37.3946415
              ],
              [
                58.166631,
                37.3747368
              ],
              [
                58.1652803,
                37.3695717
              ],
              [
                58.1625667,
                37.3504623
              ],
              [
                58.1602327,
                37.3450656
              ],
              [
                58.155146,
                37.3312156
              ],
              [
                58.1539657,
                37.325208
              ],
              [
                58.1536427,
                37.3215928
              ],
              [
                58.1531119,
                37.3141576
              ],
              [
                58.1525884,
                37.307819
              ],
              [
                58.1599473,
                37.3006851
              ],
              [
                58.1611365,
                37.2960348
              ],
              [
                58.1583469,
                37.290208
              ],
              [
                58.1571917,
                37.2877641
              ],
              [
                58.1563185,
                37.2857703
              ],
              [
                58.1539768,
                37.2833422
              ],
              [
                58.1490319,
                37.2780496
              ],
              [
                58.1441973,
                37.2754531
              ],
              [
                58.1329106,
                37.2735065
              ],
              [
                58.1259414,
                37.2748829
              ],
              [
                58.1195202,
                37.2802495
              ],
              [
                58.1117575,
                37.282947
              ],
              [
                58.1019797,
                37.2817916
              ],
              [
                58.0945406,
                37.2798146
              ],
              [
                58.087635,
                37.2768531
              ],
              [
                58.0804681,
                37.2714574
              ],
              [
                58.0779394,
                37.269082
              ],
              [
                58.0729803,
                37.2641878
              ],
              [
                58.0717179,
                37.2633966
              ],
              [
                58.0639457,
                37.2584106
              ],
              [
                58.054161,
                37.2540726
              ],
              [
                58.0495691,
                37.2488461
              ],
              [
                58.0361257,
                37.2396804
              ],
              [
                58.0222703,
                37.2296797
              ],
              [
                58.0096631,
                37.2148233
              ],
              [
                58.0091095,
                37.2142654
              ],
              [
                58.0016097,
                37.2012079
              ],
              [
                57.9889731,
                37.1942825
              ],
              [
                57.9799174,
                37.1829545
              ],
              [
                57.9731368,
                37.1796722
              ],
              [
                57.9641814,
                37.1772389
              ],
              [
                57.9560885,
                37.167983
              ],
              [
                57.9404401,
                37.1510833
              ],
              [
                57.9331397,
                37.1442404
              ],
              [
                57.9185484,
                37.1285712
              ],
              [
                57.9036997,
                37.1207696
              ],
              [
                57.9012965,
                37.1224806
              ],
              [
                57.8839586,
                37.1239862
              ],
              [
                57.8704895,
                37.125219
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555195,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مانه و سملقان",
          "name:en": "Maneh and Samalqan County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q1286427",
          "wikipedia": "en:Maneh and Samalqan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.9942863,
                37.3658765
              ],
              [
                55.9942863,
                37.3655976
              ],
              [
                55.9997176,
                37.3589014
              ],
              [
                55.9999703,
                37.3496739
              ],
              [
                55.9996937,
                37.3480095
              ],
              [
                55.9995953,
                37.3471302
              ],
              [
                55.9994137,
                37.3455084
              ],
              [
                55.999137,
                37.3452295
              ],
              [
                56.0026752,
                37.3425087
              ],
              [
                56.0023784,
                37.3396602
              ],
              [
                55.9994135,
                37.3360704
              ],
              [
                56.000247,
                37.3346759
              ],
              [
                55.9998035,
                37.3328358
              ],
              [
                56.0037517,
                37.3322216
              ],
              [
                56.0094252,
                37.3337861
              ],
              [
                56.0167674,
                37.3297594
              ],
              [
                56.0170443,
                37.3300384
              ],
              [
                56.0187109,
                37.3300383
              ],
              [
                56.0216367,
                37.330789
              ],
              [
                56.0221935,
                37.3305101
              ],
              [
                56.03136,
                37.3305101
              ],
              [
                56.0316401,
                37.3302312
              ],
              [
                56.0333068,
                37.3302313
              ],
              [
                56.0338598,
                37.3299523
              ],
              [
                56.0346933,
                37.3299523
              ],
              [
                56.0474731,
                37.3263444
              ],
              [
                56.0576447,
                37.3174931
              ],
              [
                56.0595879,
                37.3158286
              ],
              [
                56.0704245,
                37.3074877
              ],
              [
                56.0709777,
                37.3069298
              ],
              [
                56.0818111,
                37.3016572
              ],
              [
                56.0834777,
                37.3016571
              ],
              [
                56.0840343,
                37.3013781
              ],
              [
                56.0854243,
                37.3013781
              ],
              [
                56.0857009,
                37.3010992
              ],
              [
                56.0865344,
                37.3010993
              ],
              [
                56.0948676,
                37.2994347
              ],
              [
                56.0976475,
                37.2994347
              ],
              [
                56.0984808,
                37.2991557
              ],
              [
                56.0998674,
                37.2991557
              ],
              [
                56.1007007,
                37.2988767
              ],
              [
                56.1023676,
                37.2988767
              ],
              [
                56.1032007,
                37.2985979
              ],
              [
                56.1051475,
                37.2985978
              ],
              [
                56.1059808,
                37.298049
              ],
              [
                56.1070907,
                37.2980489
              ],
              [
                56.1076473,
                37.2977699
              ],
              [
                56.1115374,
                37.29777
              ],
              [
                56.1126475,
                37.297491
              ],
              [
                56.1173707,
                37.297491
              ],
              [
                56.1187574,
                37.29777
              ],
              [
                56.1204239,
                37.29777
              ],
              [
                56.1218139,
                37.2974911
              ],
              [
                56.1234805,
                37.29777
              ],
              [
                56.1273706,
                37.29777
              ],
              [
                56.1282038,
                37.298049
              ],
              [
                56.1312606,
                37.2983189
              ],
              [
                56.1531828,
                37.3060104
              ],
              [
                56.1731683,
                37.3143404
              ],
              [
                56.1742783,
                37.3143404
              ],
              [
                56.1909483,
                37.3221205
              ],
              [
                56.2028863,
                37.3229536
              ],
              [
                56.2051063,
                37.3243392
              ],
              [
                56.2062196,
                37.324897
              ],
              [
                56.2196158,
                37.3293553
              ],
              [
                56.247764,
                37.3360138
              ],
              [
                56.2483206,
                37.3362927
              ],
              [
                56.2877653,
                37.3466886
              ],
              [
                56.29858,
                37.3476439
              ],
              [
                56.3028996,
                37.3491758
              ],
              [
                56.3045661,
                37.3494456
              ],
              [
                56.3045881,
                37.3543304
              ],
              [
                56.311373,
                37.3552909
              ],
              [
                56.3160964,
                37.3558397
              ],
              [
                56.316373,
                37.3561186
              ],
              [
                56.3169295,
                37.3561186
              ],
              [
                56.3222693,
                37.3533752
              ],
              [
                56.3289631,
                37.3539678
              ],
              [
                56.3610647,
                37.3614256
              ],
              [
                56.373081,
                37.3502367
              ],
              [
                56.3941954,
                37.3442322
              ],
              [
                56.4177008,
                37.3393081
              ],
              [
                56.418534,
                37.3395872
              ],
              [
                56.419644,
                37.3395871
              ],
              [
                56.4202007,
                37.3398661
              ],
              [
                56.4210341,
                37.3398661
              ],
              [
                56.4336775,
                37.3438228
              ],
              [
                56.4468954,
                37.3440957
              ],
              [
                56.459255,
                37.3464157
              ],
              [
                56.4787413,
                37.355239
              ],
              [
                56.49762,
                37.3664087
              ],
              [
                56.49873,
                37.3664086
              ],
              [
                56.4995632,
                37.3661297
              ],
              [
                56.5006732,
                37.3661298
              ],
              [
                56.5040064,
                37.365572
              ],
              [
                56.5051198,
                37.3658509
              ],
              [
                56.5065065,
                37.3658509
              ],
              [
                56.5073433,
                37.3661298
              ],
              [
                56.5087298,
                37.3661297
              ],
              [
                56.5092865,
                37.3664086
              ],
              [
                56.5112296,
                37.3664087
              ],
              [
                56.5115098,
                37.3666875
              ],
              [
                56.5126198,
                37.3666875
              ],
              [
                56.5301512,
                37.3499638
              ],
              [
                56.5349532,
                37.3488004
              ],
              [
                56.5366198,
                37.3488003
              ],
              [
                56.5371765,
                37.3490793
              ],
              [
                56.5380096,
                37.3490793
              ],
              [
                56.5385631,
                37.3493582
              ],
              [
                56.5405098,
                37.3496282
              ],
              [
                56.5413432,
                37.3496282
              ],
              [
                56.5443963,
                37.3504652
              ],
              [
                56.5457863,
                37.3504651
              ],
              [
                56.546063,
                37.3507441
              ],
              [
                56.5499529,
                37.3507441
              ],
              [
                56.5502295,
                37.3507441
              ],
              [
                56.5507863,
                37.3510231
              ],
              [
                56.552453,
                37.3510231
              ],
              [
                56.5530097,
                37.3513021
              ],
              [
                56.5541195,
                37.3513021
              ],
              [
                56.5546762,
                37.351581
              ],
              [
                56.5557862,
                37.351581
              ],
              [
                56.5605094,
                37.352688
              ],
              [
                56.5618995,
                37.352688
              ],
              [
                56.5624528,
                37.3529668
              ],
              [
                56.5728326,
                37.3597894
              ],
              [
                56.5733859,
                37.3595105
              ],
              [
                56.5821458,
                37.3666052
              ],
              [
                56.5852468,
                37.3679694
              ],
              [
                56.5919493,
                37.371658
              ],
              [
                56.6031788,
                37.3775188
              ],
              [
                56.6042921,
                37.3777978
              ],
              [
                56.6162353,
                37.3777977
              ],
              [
                56.6173453,
                37.3780766
              ],
              [
                56.6198451,
                37.3780766
              ],
              [
                56.6226253,
                37.3786253
              ],
              [
                56.6242919,
                37.3786253
              ],
              [
                56.6254019,
                37.3789132
              ],
              [
                56.6326252,
                37.3797409
              ],
              [
                56.6473349,
                37.3819751
              ],
              [
                56.6517815,
                37.3850337
              ],
              [
                56.6520582,
                37.3853126
              ],
              [
                56.670948,
                37.3936429
              ],
              [
                56.6742812,
                37.3944705
              ],
              [
                56.6798295,
                37.3925611
              ],
              [
                56.6878996,
                37.3950588
              ],
              [
                56.6915094,
                37.3950587
              ],
              [
                56.6964845,
                37.3975168
              ],
              [
                56.7128827,
                37.3980407
              ],
              [
                56.7187159,
                37.397483
              ],
              [
                56.7275618,
                37.3923912
              ],
              [
                56.7337416,
                37.3854353
              ],
              [
                56.7590205,
                37.3816839
              ],
              [
                56.764297,
                37.3797407
              ],
              [
                56.7679104,
                37.379183
              ],
              [
                56.771797,
                37.3789131
              ],
              [
                56.7731871,
                37.379183
              ],
              [
                56.7901335,
                37.3791829
              ],
              [
                56.7906902,
                37.3794618
              ],
              [
                56.7920768,
                37.3794619
              ],
              [
                56.7931902,
                37.3797407
              ],
              [
                56.7951335,
                37.3797407
              ],
              [
                56.8063544,
                37.3802521
              ],
              [
                56.8132065,
                37.3804502
              ],
              [
                56.8165431,
                37.3804502
              ],
              [
                56.8184866,
                37.3807291
              ],
              [
                56.8229034,
                37.3820249
              ],
              [
                56.8242735,
                37.3827007
              ],
              [
                56.855888,
                37.4024777
              ],
              [
                56.9683909,
                37.4020215
              ],
              [
                56.969501,
                37.4020216
              ],
              [
                56.9711675,
                37.4014641
              ],
              [
                56.972001,
                37.4011853
              ],
              [
                57.0054114,
                37.3974764
              ],
              [
                57.0036059,
                37.401715
              ],
              [
                57.0038859,
                37.4086604
              ],
              [
                57.0038859,
                37.409767
              ],
              [
                57.0038858,
                37.4106037
              ],
              [
                57.0041626,
                37.4114404
              ],
              [
                57.0038611,
                37.4165663
              ],
              [
                57.0038611,
                37.4260126
              ],
              [
                57.0041376,
                37.4268402
              ],
              [
                57.0044144,
                37.4282257
              ],
              [
                57.0046943,
                37.4304567
              ],
              [
                57.004971,
                37.4351798
              ],
              [
                57.0052476,
                37.4365651
              ],
              [
                57.0054386,
                37.4377823
              ],
              [
                57.0049765,
                37.4386954
              ],
              [
                57.0052128,
                37.4437509
              ],
              [
                57.0084102,
                37.469487
              ],
              [
                57.0180077,
                37.4877769
              ],
              [
                57.0168112,
                37.4918855
              ],
              [
                57.0066181,
                37.5078948
              ],
              [
                57.0163566,
                37.5222282
              ],
              [
                57.0233642,
                37.5440639
              ],
              [
                57.0236348,
                37.5694504
              ],
              [
                57.0205117,
                37.5775504
              ],
              [
                57.02487,
                37.5870563
              ],
              [
                57.0223044,
                37.5983202
              ],
              [
                57.0170425,
                37.609215
              ],
              [
                57.0206559,
                37.6114358
              ],
              [
                57.0259326,
                37.6147718
              ],
              [
                57.0452144,
                37.6264199
              ],
              [
                57.0647755,
                37.6250808
              ],
              [
                57.0695112,
                37.6267406
              ],
              [
                57.0774707,
                37.6370969
              ],
              [
                57.0783042,
                37.6379331
              ],
              [
                57.0888074,
                37.6442784
              ],
              [
                57.0915874,
                37.6456721
              ],
              [
                57.094674,
                37.6491095
              ],
              [
                57.0968973,
                37.6493882
              ],
              [
                57.1138404,
                37.6366181
              ],
              [
                57.1146738,
                37.6363392
              ],
              [
                57.1188405,
                37.6363392
              ],
              [
                57.1202305,
                37.6360604
              ],
              [
                57.1218971,
                37.6360604
              ],
              [
                57.1350859,
                37.636121
              ],
              [
                57.1834944,
                37.6503933
              ],
              [
                57.1922491,
                37.642374
              ],
              [
                57.1936224,
                37.6332662
              ],
              [
                57.1937941,
                37.6187187
              ],
              [
                57.2054671,
                37.6089282
              ],
              [
                57.2308026,
                37.5987983
              ],
              [
                57.2362613,
                37.6025162
              ],
              [
                57.2365381,
                37.6027948
              ],
              [
                57.2684668,
                37.6222539
              ],
              [
                57.260494,
                37.6519481
              ],
              [
                57.2596605,
                37.6566689
              ],
              [
                57.2548792,
                37.6675232
              ],
              [
                57.2537657,
                37.6730802
              ],
              [
                57.2523791,
                37.6772435
              ],
              [
                57.2512658,
                37.6805795
              ],
              [
                57.2487658,
                37.6844728
              ],
              [
                57.2493059,
                37.7057927
              ],
              [
                57.2753332,
                37.7377342
              ],
              [
                57.2821997,
                37.751444
              ],
              [
                57.2837446,
                37.7667797
              ],
              [
                57.2866629,
                37.7751926
              ],
              [
                57.2872821,
                37.7810162
              ],
              [
                57.2872822,
                37.7812859
              ],
              [
                57.2870056,
                37.7818434
              ],
              [
                57.2736166,
                37.7975772
              ],
              [
                57.2473524,
                37.8073429
              ],
              [
                57.2372097,
                37.807754
              ],
              [
                57.2349864,
                37.8088598
              ],
              [
                57.2341531,
                37.8094171
              ],
              [
                57.2210882,
                37.8200906
              ],
              [
                57.1922491,
                37.8278195
              ],
              [
                57.1596247,
                37.8380722
              ],
              [
                57.1593479,
                37.838351
              ],
              [
                57.1590713,
                37.8386298
              ],
              [
                57.1571246,
                37.8386298
              ],
              [
                57.1565713,
                37.8389084
              ],
              [
                57.1323393,
                37.8409704
              ],
              [
                57.0921705,
                37.8463927
              ],
              [
                57.0803919,
                37.8523041
              ],
              [
                57.0798387,
                37.8523042
              ],
              [
                57.0781721,
                37.8525828
              ],
              [
                57.05595,
                37.8585916
              ],
              [
                57.0499418,
                37.8626574
              ],
              [
                57.0435954,
                37.8732186
              ],
              [
                57.0291287,
                37.8783225
              ],
              [
                57.0202388,
                37.8802642
              ],
              [
                57.0051382,
                37.8814928
              ],
              [
                56.979904,
                37.8920602
              ],
              [
                56.9488333,
                37.9038451
              ],
              [
                56.9385336,
                37.9079085
              ],
              [
                56.9314495,
                37.9000652
              ],
              [
                56.8983648,
                37.9060123
              ],
              [
                56.8914984,
                37.9062832
              ],
              [
                56.85939,
                37.9164511
              ],
              [
                56.8535567,
                37.9164511
              ],
              [
                56.8505002,
                37.9161724
              ],
              [
                56.8248854,
                37.9187299
              ],
              [
                56.8201621,
                37.9187299
              ],
              [
                56.8193289,
                37.9190085
              ],
              [
                56.8187756,
                37.9190085
              ],
              [
                56.8171089,
                37.9190085
              ],
              [
                56.814329,
                37.9198445
              ],
              [
                56.8134957,
                37.9198444
              ],
              [
                56.7474745,
                37.9310652
              ],
              [
                56.73151,
                37.9321484
              ],
              [
                56.7064474,
                37.9298134
              ],
              [
                56.7058908,
                37.9300922
              ],
              [
                56.6818193,
                37.9471687
              ],
              [
                56.6820715,
                37.9513721
              ],
              [
                56.6901506,
                37.9665156
              ],
              [
                56.6898739,
                37.9667942
              ],
              [
                56.6735641,
                37.9944114
              ],
              [
                56.6841315,
                38.006308
              ],
              [
                56.696068,
                38.0308275
              ],
              [
                56.6957879,
                38.031106
              ],
              [
                56.6944013,
                38.0341609
              ],
              [
                56.7124404,
                38.0468047
              ],
              [
                56.7207226,
                38.0524447
              ],
              [
                56.7169446,
                38.0675523
              ],
              [
                56.7041809,
                38.0668174
              ],
              [
                56.6709135,
                38.0645816
              ],
              [
                56.6338347,
                38.071474
              ],
              [
                56.6122053,
                38.0697172
              ],
              [
                56.5885161,
                38.0716091
              ],
              [
                56.5509222,
                38.0772847
              ],
              [
                56.5488623,
                38.0799873
              ],
              [
                56.5486906,
                38.0864729
              ],
              [
                56.5463898,
                38.0883338
              ],
              [
                56.5122943,
                38.0937452
              ],
              [
                56.5114609,
                38.0937453
              ],
              [
                56.4944456,
                38.1057913
              ],
              [
                56.4839743,
                38.1084927
              ],
              [
                56.4632732,
                38.1053427
              ],
              [
                56.4618867,
                38.1053427
              ],
              [
                56.4498137,
                38.1010635
              ],
              [
                56.4443205,
                38.1009284
              ],
              [
                56.4222186,
                38.1067923
              ],
              [
                56.4161088,
                38.1109623
              ],
              [
                56.415832,
                38.111241
              ],
              [
                56.415552,
                38.1115196
              ],
              [
                56.3797758,
                38.1276702
              ],
              [
                56.3623358,
                38.1494807
              ],
              [
                56.3615024,
                38.1494806
              ],
              [
                56.3442794,
                38.1544851
              ],
              [
                56.3431694,
                38.1544851
              ],
              [
                56.3428893,
                38.1547636
              ],
              [
                56.3384461,
                38.1547636
              ],
              [
                56.3384461,
                38.1550421
              ],
              [
                56.3348327,
                38.1550421
              ],
              [
                56.3348327,
                38.1553207
              ],
              [
                56.3328895,
                38.1553207
              ],
              [
                56.3320561,
                38.1555991
              ],
              [
                56.3317795,
                38.1558777
              ],
              [
                56.3314709,
                38.1560271
              ],
              [
                56.3280182,
                38.1565067
              ],
              [
                56.3298621,
                38.1526001
              ],
              [
                56.3289752,
                38.1514465
              ],
              [
                56.3282343,
                38.15132
              ],
              [
                56.3277445,
                38.1514636
              ],
              [
                56.327346,
                38.1514342
              ],
              [
                56.3269693,
                38.1510574
              ],
              [
                56.3267451,
                38.1496602
              ],
              [
                56.327248,
                38.1479644
              ],
              [
                56.3276216,
                38.1473115
              ],
              [
                56.3282188,
                38.1468348
              ],
              [
                56.3294268,
                38.1468527
              ],
              [
                56.3314534,
                38.1472054
              ],
              [
                56.3344893,
                38.1438215
              ],
              [
                56.3357709,
                38.1428908
              ],
              [
                56.3386982,
                38.1417444
              ],
              [
                56.3398048,
                38.1414373
              ],
              [
                56.3408204,
                38.1414049
              ],
              [
                56.3417304,
                38.1415527
              ],
              [
                56.3422528,
                38.1417697
              ],
              [
                56.3427225,
                38.1424715
              ],
              [
                56.3431921,
                38.1428547
              ],
              [
                56.3434328,
                38.1429147
              ],
              [
                56.3437651,
                38.1428346
              ],
              [
                56.3448675,
                38.1371573
              ],
              [
                56.3454077,
                38.1351323
              ],
              [
                56.3448175,
                38.1314825
              ],
              [
                56.3461469,
                38.1293867
              ],
              [
                56.3485512,
                38.1286774
              ],
              [
                56.3498118,
                38.126605
              ],
              [
                56.3509634,
                38.1203805
              ],
              [
                56.3511514,
                38.119492
              ],
              [
                56.3518911,
                38.118088
              ],
              [
                56.352079,
                38.1171643
              ],
              [
                56.351895,
                38.1169157
              ],
              [
                56.3509365,
                38.116728
              ],
              [
                56.3498308,
                38.1166098
              ],
              [
                56.3491058,
                38.1163812
              ],
              [
                56.3482722,
                38.1160509
              ],
              [
                56.3479843,
                38.1157593
              ],
              [
                56.3475826,
                38.1153997
              ],
              [
                56.3471944,
                38.1151286
              ],
              [
                56.3464908,
                38.1148347
              ],
              [
                56.346084,
                38.1148428
              ],
              [
                56.3453866,
                38.1149326
              ],
              [
                56.344976,
                38.1148043
              ],
              [
                56.3446379,
                38.1144027
              ],
              [
                56.3444013,
                38.1137724
              ],
              [
                56.3443099,
                38.1127403
              ],
              [
                56.3443431,
                38.1122863
              ],
              [
                56.3442103,
                38.1120903
              ],
              [
                56.343679,
                38.1118944
              ],
              [
                56.343015,
                38.1115132
              ],
              [
                56.3424423,
                38.110791
              ],
              [
                56.3419081,
                38.1099041
              ],
              [
                56.3416146,
                38.109747
              ],
              [
                56.3410921,
                38.1097193
              ],
              [
                56.3405818,
                38.109636
              ],
              [
                56.3400663,
                38.1093909
              ],
              [
                56.3396056,
                38.108901
              ],
              [
                56.339315,
                38.108344
              ],
              [
                56.3388558,
                38.1063277
              ],
              [
                56.3383134,
                38.1060503
              ],
              [
                56.3369485,
                38.1049433
              ],
              [
                56.3330377,
                38.0992148
              ],
              [
                56.3340032,
                38.0911769
              ],
              [
                56.335248,
                38.0772496
              ],
              [
                56.3344803,
                38.0779115
              ],
              [
                56.3270746,
                38.0808261
              ],
              [
                56.321063,
                38.0810172
              ],
              [
                56.3205693,
                38.0795449
              ],
              [
                56.3204774,
                38.0788202
              ],
              [
                56.3202132,
                38.0777665
              ],
              [
                56.3199255,
                38.0769209
              ],
              [
                56.3196573,
                38.0767471
              ],
              [
                56.3187421,
                38.0758194
              ],
              [
                56.318531,
                38.0758118
              ],
              [
                56.3183934,
                38.075839
              ],
              [
                56.3183108,
                38.0758903
              ],
              [
                56.318273,
                38.0759665
              ],
              [
                56.3183159,
                38.0770281
              ],
              [
                56.3181218,
                38.0774602
              ],
              [
                56.3173365,
                38.0780299
              ],
              [
                56.3165557,
                38.0789911
              ],
              [
                56.3149706,
                38.0799569
              ],
              [
                56.3138264,
                38.0797704
              ],
              [
                56.3119126,
                38.0796041
              ],
              [
                56.3105976,
                38.0800662
              ],
              [
                56.3100105,
                38.0808055
              ],
              [
                56.3085391,
                38.0815863
              ],
              [
                56.3066056,
                38.0818222
              ],
              [
                56.3052201,
                38.0822103
              ],
              [
                56.3027929,
                38.0830573
              ],
              [
                56.3021733,
                38.0828203
              ],
              [
                56.3009052,
                38.0824506
              ],
              [
                56.2997605,
                38.0822611
              ],
              [
                56.2974944,
                38.0830605
              ],
              [
                56.2968076,
                38.0831021
              ],
              [
                56.2959094,
                38.0828711
              ],
              [
                56.2950304,
                38.0822677
              ],
              [
                56.2948009,
                38.082242
              ],
              [
                56.2947193,
                38.0823509
              ],
              [
                56.2945725,
                38.0830671
              ],
              [
                56.2940031,
                38.0834183
              ],
              [
                56.2937095,
                38.0835061
              ],
              [
                56.2920482,
                38.0840282
              ],
              [
                56.2894725,
                38.084991
              ],
              [
                56.2889756,
                38.0846583
              ],
              [
                56.2892888,
                38.0841197
              ],
              [
                56.2899866,
                38.0819364
              ],
              [
                56.3070235,
                38.0742522
              ],
              [
                56.3073034,
                38.0728594
              ],
              [
                56.3196942,
                38.0551205
              ],
              [
                56.368446,
                38.0213204
              ],
              [
                56.369476,
                38.0061728
              ],
              [
                56.3681027,
                37.9937279
              ],
              [
                56.3608929,
                37.9845281
              ],
              [
                56.3595196,
                37.9783041
              ],
              [
                56.3593179,
                37.944911
              ],
              [
                56.3573248,
                37.9395145
              ],
              [
                56.3561864,
                37.9369846
              ],
              [
                56.3560805,
                37.9361976
              ],
              [
                56.3449732,
                37.9221354
              ],
              [
                56.33948,
                37.9172148
              ],
              [
                56.3357953,
                37.9143766
              ],
              [
                56.3236712,
                37.9070818
              ],
              [
                56.310484,
                37.8898926
              ],
              [
                56.3041025,
                37.880633
              ],
              [
                56.2935619,
                37.8734377
              ],
              [
                56.2801286,
                37.8728814
              ],
              [
                56.2680631,
                37.8719782
              ],
              [
                56.2669532,
                37.8719782
              ],
              [
                56.2641766,
                37.8711423
              ],
              [
                56.2622298,
                37.8711423
              ],
              [
                56.2472235,
                37.8641571
              ],
              [
                56.2405569,
                37.8641572
              ],
              [
                56.2350003,
                37.8647055
              ],
              [
                56.232233,
                37.8635382
              ],
              [
                56.2319754,
                37.8603534
              ],
              [
                56.2354086,
                37.8523568
              ],
              [
                56.2360953,
                37.8352765
              ],
              [
                56.2307738,
                37.8251077
              ],
              [
                56.2286911,
                37.8159743
              ],
              [
                56.2275811,
                37.8143111
              ],
              [
                56.2270245,
                37.8126389
              ],
              [
                56.2256343,
                37.8098609
              ],
              [
                56.2077598,
                37.7975502
              ],
              [
                56.2074832,
                37.7964353
              ],
              [
                56.2044115,
                37.7901749
              ],
              [
                56.1648238,
                37.7453091
              ],
              [
                56.1488826,
                37.7258524
              ],
              [
                56.1390224,
                37.7095356
              ],
              [
                56.1277911,
                37.6891542
              ],
              [
                56.1264046,
                37.6822038
              ],
              [
                56.1153212,
                37.6640619
              ],
              [
                56.114488,
                37.6629471
              ],
              [
                56.113378,
                37.6596203
              ],
              [
                56.1125446,
                37.6582266
              ],
              [
                56.1066947,
                37.645894
              ],
              [
                56.0972514,
                37.6345112
              ],
              [
                56.0739149,
                37.6111783
              ],
              [
                56.0705817,
                37.6075637
              ],
              [
                56.0697483,
                37.6070152
              ],
              [
                56.056745,
                37.5757841
              ],
              [
                56.0570249,
                37.573563
              ],
              [
                56.0465118,
                37.5543064
              ],
              [
                56.0467886,
                37.549306
              ],
              [
                56.0465118,
                37.5484696
              ],
              [
                56.0400951,
                37.5140143
              ],
              [
                56.0376547,
                37.4887528
              ],
              [
                56.0154596,
                37.4756963
              ],
              [
                56.0152367,
                37.475363
              ],
              [
                56.0144036,
                37.4739691
              ],
              [
                56.0127638,
                37.4561918
              ],
              [
                56.0100172,
                37.4504684
              ],
              [
                56.0125921,
                37.4456985
              ],
              [
                56.016197,
                37.4405194
              ],
              [
                56.0169982,
                37.4317542
              ],
              [
                56.0172698,
                37.4233405
              ],
              [
                56.0100181,
                37.4036345
              ],
              [
                56.0100181,
                37.4025281
              ],
              [
                55.9951197,
                37.3661554
              ],
              [
                55.9942863,
                37.3658765
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555284,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گرمه",
          "name:en": "Garmeh County",
          "place": "county",
          "source": "Iran's New Boundaries maps (1397-2019) available on amar.org.ir website",
          "type": "boundary",
          "wikidata": "Q2610738",
          "wikipedia": "en:Garmeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.8692842,
                37.3230584
              ],
              [
                55.8692841,
                37.3226794
              ],
              [
                55.8838461,
                37.3197998
              ],
              [
                55.8967207,
                37.3236221
              ],
              [
                55.9109227,
                37.3225239
              ],
              [
                55.9136362,
                37.3063754
              ],
              [
                55.9097928,
                37.297721
              ],
              [
                55.9109686,
                37.2873019
              ],
              [
                55.9064431,
                37.2803711
              ],
              [
                55.9061629,
                37.2773208
              ],
              [
                55.9058863,
                37.2742615
              ],
              [
                55.9053296,
                37.267315
              ],
              [
                55.9050531,
                37.262591
              ],
              [
                55.9051029,
                37.2558231
              ],
              [
                55.9048262,
                37.2555443
              ],
              [
                55.9048262,
                37.2519272
              ],
              [
                55.9048262,
                37.2455388
              ],
              [
                55.9045463,
                37.2374858
              ],
              [
                55.9042696,
                37.233041
              ],
              [
                55.9039929,
                37.2305395
              ],
              [
                55.9037128,
                37.2288749
              ],
              [
                55.9034363,
                37.2260945
              ],
              [
                55.9039305,
                37.2132418
              ],
              [
                55.9060778,
                37.2049876
              ],
              [
                55.9092312,
                37.2003091
              ],
              [
                55.9089544,
                37.1989139
              ],
              [
                55.9107969,
                37.1876728
              ],
              [
                55.9197876,
                37.1825238
              ],
              [
                55.9220108,
                37.1825239
              ],
              [
                55.9228443,
                37.1822449
              ],
              [
                55.9278442,
                37.1822449
              ],
              [
                55.9336775,
                37.1822448
              ],
              [
                55.9342342,
                37.1822448
              ],
              [
                55.9361774,
                37.1825239
              ],
              [
                55.9367341,
                37.1825239
              ],
              [
                55.9375674,
                37.182803
              ],
              [
                55.9928576,
                37.1743985
              ],
              [
                56.0062405,
                37.1622321
              ],
              [
                56.0117,
                37.1477538
              ],
              [
                56.0120748,
                37.1375232
              ],
              [
                56.0100179,
                37.1046278
              ],
              [
                56.0074423,
                37.0705192
              ],
              [
                56.0129355,
                37.0575061
              ],
              [
                56.021855,
                37.0510878
              ],
              [
                56.029821,
                37.0408502
              ],
              [
                56.0298709,
                37.0349065
              ],
              [
                56.0306166,
                37.0316104
              ],
              [
                56.0350791,
                37.0255818
              ],
              [
                56.0337309,
                37.0176012
              ],
              [
                56.0275267,
                37.012971
              ],
              [
                56.02787,
                37.0100924
              ],
              [
                56.0326765,
                36.9995367
              ],
              [
                56.0240711,
                36.9951731
              ],
              [
                56.0216469,
                36.9813486
              ],
              [
                56.0209191,
                36.968641
              ],
              [
                56.0110741,
                36.9512318
              ],
              [
                56.0108647,
                36.9497598
              ],
              [
                56.0108498,
                36.9496553
              ],
              [
                56.0107975,
                36.9492872
              ],
              [
                56.0105175,
                36.948459
              ],
              [
                56.0076659,
                36.9418165
              ],
              [
                56.0037592,
                36.9303808
              ],
              [
                56.0034791,
                36.9295525
              ],
              [
                56.0010908,
                36.9203914
              ],
              [
                56.0000608,
                36.9061173
              ],
              [
                56.0038374,
                36.8951353
              ],
              [
                56.0057192,
                36.8883389
              ],
              [
                56.0038377,
                36.8776314
              ],
              [
                56.0046744,
                36.8743008
              ],
              [
                56.0049511,
                36.8737517
              ],
              [
                56.0181712,
                36.8746773
              ],
              [
                56.0278698,
                36.8730296
              ],
              [
                56.0330196,
                36.8683605
              ],
              [
                56.0635754,
                36.8592961
              ],
              [
                56.0773083,
                36.8581973
              ],
              [
                56.0927461,
                36.8563466
              ],
              [
                56.0930263,
                36.8560674
              ],
              [
                56.0974696,
                36.8546803
              ],
              [
                56.1037794,
                36.8532569
              ],
              [
                56.1069953,
                36.8561077
              ],
              [
                56.1182785,
                36.8613252
              ],
              [
                56.2613479,
                36.927463
              ],
              [
                56.276531,
                36.9324298
              ],
              [
                56.2828341,
                36.9425308
              ],
              [
                56.2958633,
                36.9518127
              ],
              [
                56.3046285,
                36.9579985
              ],
              [
                56.312172,
                36.9642417
              ],
              [
                56.317328,
                36.9690819
              ],
              [
                56.3210645,
                36.9722693
              ],
              [
                56.3206749,
                36.9729383
              ],
              [
                56.3205634,
                36.973388
              ],
              [
                56.3232941,
                36.9750709
              ],
              [
                56.3327928,
                36.9836664
              ],
              [
                56.3383013,
                36.9895341
              ],
              [
                56.3430928,
                36.9946687
              ],
              [
                56.3520067,
                37.0042696
              ],
              [
                56.356804,
                37.0123956
              ],
              [
                56.3687222,
                37.0228073
              ],
              [
                56.3725933,
                37.028144
              ],
              [
                56.3786197,
                37.0352294
              ],
              [
                56.3846917,
                37.0422603
              ],
              [
                56.3915632,
                37.0519623
              ],
              [
                56.4028039,
                37.0627561
              ],
              [
                56.4157664,
                37.0764585
              ],
              [
                56.5053629,
                37.1624549
              ],
              [
                56.5059197,
                37.1627339
              ],
              [
                56.5081395,
                37.1638409
              ],
              [
                56.5169333,
                37.1657887
              ],
              [
                56.5255163,
                37.1715339
              ],
              [
                56.5375591,
                37.1745267
              ],
              [
                56.5392258,
                37.1747966
              ],
              [
                56.5441589,
                37.1772587
              ],
              [
                56.5444357,
                37.1775377
              ],
              [
                56.5519522,
                37.1804244
              ],
              [
                56.5566505,
                37.1868377
              ],
              [
                56.5572074,
                37.1865588
              ],
              [
                56.5735056,
                37.1835482
              ],
              [
                56.5743387,
                37.1835483
              ],
              [
                56.5768388,
                37.1835482
              ],
              [
                56.5771153,
                37.1832693
              ],
              [
                56.5837819,
                37.1832692
              ],
              [
                56.5843385,
                37.1835482
              ],
              [
                56.5860053,
                37.1835482
              ],
              [
                56.586562,
                37.1838272
              ],
              [
                56.5932286,
                37.184655
              ],
              [
                56.5943386,
                37.1852129
              ],
              [
                56.5951719,
                37.1852129
              ],
              [
                56.6037352,
                37.1866838
              ],
              [
                56.6156386,
                37.1856214
              ],
              [
                56.6251659,
                37.1845957
              ],
              [
                56.6334056,
                37.182681
              ],
              [
                56.642847,
                37.1823391
              ],
              [
                56.6504001,
                37.1839118
              ],
              [
                56.6597556,
                37.1873992
              ],
              [
                56.6648196,
                37.1945102
              ],
              [
                56.6655063,
                37.1975185
              ],
              [
                56.6583651,
                37.2031622
              ],
              [
                56.6586419,
                37.2048266
              ],
              [
                56.6589184,
                37.2062122
              ],
              [
                56.6626318,
                37.2073299
              ],
              [
                56.6653116,
                37.2110485
              ],
              [
                56.6688249,
                37.2180794
              ],
              [
                56.6710816,
                37.2244964
              ],
              [
                56.6705703,
                37.2265014
              ],
              [
                56.6684926,
                37.2288913
              ],
              [
                56.6682158,
                37.2291611
              ],
              [
                56.6207176,
                37.2404328
              ],
              [
                56.6175859,
                37.2445454
              ],
              [
                56.6074888,
                37.2510014
              ],
              [
                56.6045653,
                37.2624603
              ],
              [
                56.6045653,
                37.2630182
              ],
              [
                56.6040087,
                37.2632971
              ],
              [
                56.6045828,
                37.2753282
              ],
              [
                56.6041786,
                37.2816853
              ],
              [
                56.6025252,
                37.2864229
              ],
              [
                56.6030819,
                37.2903189
              ],
              [
                56.6028053,
                37.2919834
              ],
              [
                56.6025253,
                37.2922623
              ],
              [
                56.6022487,
                37.2950335
              ],
              [
                56.6043948,
                37.3058055
              ],
              [
                56.6146769,
                37.3198699
              ],
              [
                56.6152335,
                37.3223711
              ],
              [
                56.6166686,
                37.3251919
              ],
              [
                56.6155217,
                37.3308774
              ],
              [
                56.5962408,
                37.3307203
              ],
              [
                56.5763278,
                37.3292394
              ],
              [
                56.5757712,
                37.3300763
              ],
              [
                56.5773581,
                37.3375448
              ],
              [
                56.5828512,
                37.3453239
              ],
              [
                56.5862073,
                37.3545963
              ],
              [
                56.5856507,
                37.3582042
              ],
              [
                56.5821458,
                37.3666052
              ],
              [
                56.5733859,
                37.3595105
              ],
              [
                56.5728326,
                37.3597894
              ],
              [
                56.5624528,
                37.3529668
              ],
              [
                56.5618995,
                37.352688
              ],
              [
                56.5605094,
                37.352688
              ],
              [
                56.5557862,
                37.351581
              ],
              [
                56.5546762,
                37.351581
              ],
              [
                56.5541195,
                37.3513021
              ],
              [
                56.5530097,
                37.3513021
              ],
              [
                56.552453,
                37.3510231
              ],
              [
                56.5507863,
                37.3510231
              ],
              [
                56.5502295,
                37.3507441
              ],
              [
                56.5499529,
                37.3507441
              ],
              [
                56.546063,
                37.3507441
              ],
              [
                56.5457863,
                37.3504651
              ],
              [
                56.5443963,
                37.3504652
              ],
              [
                56.5413432,
                37.3496282
              ],
              [
                56.5405098,
                37.3496282
              ],
              [
                56.5385631,
                37.3493582
              ],
              [
                56.5380096,
                37.3490793
              ],
              [
                56.5371765,
                37.3490793
              ],
              [
                56.5366198,
                37.3488003
              ],
              [
                56.5349532,
                37.3488004
              ],
              [
                56.5301512,
                37.3499638
              ],
              [
                56.5126198,
                37.3666875
              ],
              [
                56.5115098,
                37.3666875
              ],
              [
                56.5112296,
                37.3664087
              ],
              [
                56.5092865,
                37.3664086
              ],
              [
                56.5087298,
                37.3661297
              ],
              [
                56.5073433,
                37.3661298
              ],
              [
                56.5065065,
                37.3658509
              ],
              [
                56.5051198,
                37.3658509
              ],
              [
                56.5040064,
                37.365572
              ],
              [
                56.5006732,
                37.3661298
              ],
              [
                56.4995632,
                37.3661297
              ],
              [
                56.49873,
                37.3664086
              ],
              [
                56.49762,
                37.3664087
              ],
              [
                56.4787413,
                37.355239
              ],
              [
                56.459255,
                37.3464157
              ],
              [
                56.4468954,
                37.3440957
              ],
              [
                56.4336775,
                37.3438228
              ],
              [
                56.4210341,
                37.3398661
              ],
              [
                56.4202007,
                37.3398661
              ],
              [
                56.419644,
                37.3395871
              ],
              [
                56.418534,
                37.3395872
              ],
              [
                56.4177008,
                37.3393081
              ],
              [
                56.3941954,
                37.3442322
              ],
              [
                56.373081,
                37.3502367
              ],
              [
                56.3610647,
                37.3614256
              ],
              [
                56.3289631,
                37.3539678
              ],
              [
                56.3222693,
                37.3533752
              ],
              [
                56.3169295,
                37.3561186
              ],
              [
                56.316373,
                37.3561186
              ],
              [
                56.3160964,
                37.3558397
              ],
              [
                56.311373,
                37.3552909
              ],
              [
                56.3045881,
                37.3543304
              ],
              [
                56.3045661,
                37.3494456
              ],
              [
                56.3028996,
                37.3491758
              ],
              [
                56.29858,
                37.3476439
              ],
              [
                56.2877653,
                37.3466886
              ],
              [
                56.2483206,
                37.3362927
              ],
              [
                56.247764,
                37.3360138
              ],
              [
                56.2196158,
                37.3293553
              ],
              [
                56.2062196,
                37.324897
              ],
              [
                56.2051063,
                37.3243392
              ],
              [
                56.2028863,
                37.3229536
              ],
              [
                56.1909483,
                37.3221205
              ],
              [
                56.1742783,
                37.3143404
              ],
              [
                56.1731683,
                37.3143404
              ],
              [
                56.1531828,
                37.3060104
              ],
              [
                56.1312606,
                37.2983189
              ],
              [
                56.1282038,
                37.298049
              ],
              [
                56.1273706,
                37.29777
              ],
              [
                56.1234805,
                37.29777
              ],
              [
                56.1218139,
                37.2974911
              ],
              [
                56.1204239,
                37.29777
              ],
              [
                56.1187574,
                37.29777
              ],
              [
                56.1173707,
                37.297491
              ],
              [
                56.1126475,
                37.297491
              ],
              [
                56.1115374,
                37.29777
              ],
              [
                56.1076473,
                37.2977699
              ],
              [
                56.1070907,
                37.2980489
              ],
              [
                56.1059808,
                37.298049
              ],
              [
                56.1051475,
                37.2985978
              ],
              [
                56.1032007,
                37.2985979
              ],
              [
                56.1023676,
                37.2988767
              ],
              [
                56.1007007,
                37.2988767
              ],
              [
                56.0998674,
                37.2991557
              ],
              [
                56.0984808,
                37.2991557
              ],
              [
                56.0976475,
                37.2994347
              ],
              [
                56.0948676,
                37.2994347
              ],
              [
                56.0865344,
                37.3010993
              ],
              [
                56.0857009,
                37.3010992
              ],
              [
                56.0854243,
                37.3013781
              ],
              [
                56.0840343,
                37.3013781
              ],
              [
                56.0834777,
                37.3016571
              ],
              [
                56.0818111,
                37.3016572
              ],
              [
                56.0709777,
                37.3069298
              ],
              [
                56.0704245,
                37.3074877
              ],
              [
                56.0595879,
                37.3158286
              ],
              [
                56.0576447,
                37.3174931
              ],
              [
                56.0474731,
                37.3263444
              ],
              [
                56.0346933,
                37.3299523
              ],
              [
                56.0338598,
                37.3299523
              ],
              [
                56.0333068,
                37.3302313
              ],
              [
                56.0316401,
                37.3302312
              ],
              [
                56.03136,
                37.3305101
              ],
              [
                56.0221935,
                37.3305101
              ],
              [
                56.0216367,
                37.330789
              ],
              [
                56.0187109,
                37.3300383
              ],
              [
                56.0170443,
                37.3300384
              ],
              [
                56.0167674,
                37.3297594
              ],
              [
                56.0094252,
                37.3337861
              ],
              [
                56.0037517,
                37.3322216
              ],
              [
                55.9998035,
                37.3328358
              ],
              [
                56.000247,
                37.3346759
              ],
              [
                55.9994135,
                37.3360704
              ],
              [
                56.0023784,
                37.3396602
              ],
              [
                56.0026752,
                37.3425087
              ],
              [
                55.999137,
                37.3452295
              ],
              [
                55.9994137,
                37.3455084
              ],
              [
                55.9995953,
                37.3471302
              ],
              [
                55.9996937,
                37.3480095
              ],
              [
                55.9999703,
                37.3496739
              ],
              [
                55.9997176,
                37.3589014
              ],
              [
                55.9942863,
                37.3655976
              ],
              [
                55.9942863,
                37.3658765
              ],
              [
                55.983753,
                37.3540575
              ],
              [
                55.9692072,
                37.3458583
              ],
              [
                55.9499357,
                37.339319
              ],
              [
                55.9370611,
                37.3389096
              ],
              [
                55.9214795,
                37.3344626
              ],
              [
                55.9203695,
                37.3344627
              ],
              [
                55.9095953,
                37.3316757
              ],
              [
                55.898609,
                37.3301743
              ],
              [
                55.8865927,
                37.3245777
              ],
              [
                55.8788637,
                37.3232431
              ],
              [
                55.8692842,
                37.3230584
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 690428807
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.3792939,
          36.9499996
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 297201895
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.2192859,
          37.2317346
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32826331
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.3319881,
          37.4759752
        ]
      }
    }
  ]
},
"خوزستان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554852,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آبادان",
          "name:ar": "مقاطعة عبادان",
          "name:en": "Abadan County",
          "name:fa": "شهرستان آبادان",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279180",
          "wikipedia": "en:Abadan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.214517,
                30.3652008
              ],
              [
                48.2210648,
                30.3604431
              ],
              [
                48.2229665,
                30.3587977
              ],
              [
                48.2288861,
                30.3536757
              ],
              [
                48.2306242,
                30.3526017
              ],
              [
                48.2336283,
                30.3509537
              ],
              [
                48.2360637,
                30.3495279
              ],
              [
                48.2384562,
                30.3480651
              ],
              [
                48.241471,
                30.3461392
              ],
              [
                48.2442069,
                30.3443337
              ],
              [
                48.2462561,
                30.3429078
              ],
              [
                48.2471037,
                30.3422875
              ],
              [
                48.247565,
                30.3419171
              ],
              [
                48.2479837,
                30.3415384
              ],
              [
                48.2486925,
                30.3404332
              ],
              [
                48.2497082,
                30.3406648
              ],
              [
                48.2522042,
                30.3409857
              ],
              [
                48.2555133,
                30.3408364
              ],
              [
                48.2581734,
                30.3403972
              ],
              [
                48.2599633,
                30.3399802
              ],
              [
                48.2628166,
                30.3393154
              ],
              [
                48.2629273,
                30.3392896
              ],
              [
                48.2671971,
                30.3378773
              ],
              [
                48.2724511,
                30.3348376
              ],
              [
                48.272624,
                30.3347376
              ],
              [
                48.2747059,
                30.3334385
              ],
              [
                48.2748013,
                30.3333789
              ],
              [
                48.2768904,
                30.3319061
              ],
              [
                48.276961,
                30.3318492
              ],
              [
                48.2810907,
                30.328523
              ],
              [
                48.2861021,
                30.3229036
              ],
              [
                48.2863984,
                30.3225795
              ],
              [
                48.2913663,
                30.3171466
              ],
              [
                48.2937571,
                30.3146047
              ],
              [
                48.296057,
                30.3121255
              ],
              [
                48.2976729,
                30.3105013
              ],
              [
                48.3016346,
                30.3063201
              ],
              [
                48.3051628,
                30.3025965
              ],
              [
                48.3110124,
                30.2967259
              ],
              [
                48.314051,
                30.2936763
              ],
              [
                48.3163315,
                30.2913875
              ],
              [
                48.316846,
                30.290871
              ],
              [
                48.3177765,
                30.2899825
              ],
              [
                48.3189402,
                30.288947
              ],
              [
                48.3209934,
                30.286865
              ],
              [
                48.3261198,
                30.2806683
              ],
              [
                48.3307379,
                30.2754907
              ],
              [
                48.3357809,
                30.2698364
              ],
              [
                48.3407413,
                30.2644425
              ],
              [
                48.3414007,
                30.2637254
              ],
              [
                48.34495,
                30.2598657
              ],
              [
                48.3515649,
                30.2529267
              ],
              [
                48.357345,
                30.246863
              ],
              [
                48.3578373,
                30.2463805
              ],
              [
                48.3643315,
                30.2400155
              ],
              [
                48.3714295,
                30.2330582
              ],
              [
                48.3721786,
                30.2324762
              ],
              [
                48.3731251,
                30.2317409
              ],
              [
                48.3734609,
                30.23148
              ],
              [
                48.3766878,
                30.2288512
              ],
              [
                48.3832103,
                30.2235375
              ],
              [
                48.3883847,
                30.2193219
              ],
              [
                48.3897429,
                30.2182152
              ],
              [
                48.3898923,
                30.2180935
              ],
              [
                48.3992668,
                30.2104233
              ],
              [
                48.4073989,
                30.2024495
              ],
              [
                48.4075148,
                30.2023358
              ],
              [
                48.4113732,
                30.1974557
              ],
              [
                48.4120031,
                30.1966588
              ],
              [
                48.4150431,
                30.1928597
              ],
              [
                48.4157402,
                30.1912083
              ],
              [
                48.4161423,
                30.1894179
              ],
              [
                48.4169592,
                30.1859761
              ],
              [
                48.4176503,
                30.1800694
              ],
              [
                48.4171931,
                30.1771772
              ],
              [
                48.4158932,
                30.1724489
              ],
              [
                48.4144464,
                30.1677206
              ],
              [
                48.407751,
                30.1571818
              ],
              [
                48.4046102,
                30.1539697
              ],
              [
                48.404536,
                30.1538938
              ],
              [
                48.4014281,
                30.151164
              ],
              [
                48.4011856,
                30.150942
              ],
              [
                48.3994353,
                30.1493399
              ],
              [
                48.3993392,
                30.1492519
              ],
              [
                48.3981875,
                30.1480399
              ],
              [
                48.3978202,
                30.1476534
              ],
              [
                48.3952143,
                30.1449111
              ],
              [
                48.3937898,
                30.1434121
              ],
              [
                48.3931624,
                30.1427518
              ],
              [
                48.3870457,
                30.1366763
              ],
              [
                48.3864866,
                30.136121
              ],
              [
                48.3841504,
                30.1327981
              ],
              [
                48.3840846,
                30.1326249
              ],
              [
                48.3826143,
                30.128756
              ],
              [
                48.3824493,
                30.1268628
              ],
              [
                48.382432,
                30.1266642
              ],
              [
                48.3822991,
                30.1236552
              ],
              [
                48.3822963,
                30.1235919
              ],
              [
                48.3824261,
                30.1211262
              ],
              [
                48.382832,
                30.1199379
              ],
              [
                48.3834075,
                30.1187251
              ],
              [
                48.3865861,
                30.1148653
              ],
              [
                48.3896518,
                30.1111425
              ],
              [
                48.3948254,
                30.1076958
              ],
              [
                48.3996202,
                30.1045015
              ],
              [
                48.3998914,
                30.1043208
              ],
              [
                48.404429,
                30.1016319
              ],
              [
                48.4050264,
                30.1012779
              ],
              [
                48.4128905,
                30.0965144
              ],
              [
                48.4142103,
                30.0956536
              ],
              [
                48.415375,
                30.0948941
              ],
              [
                48.4214963,
                30.0905636
              ],
              [
                48.421556,
                30.0905214
              ],
              [
                48.4249312,
                30.0874076
              ],
              [
                48.4274903,
                30.0850466
              ],
              [
                48.4276308,
                30.0849088
              ],
              [
                48.4328125,
                30.079826
              ],
              [
                48.4366139,
                30.0751147
              ],
              [
                48.4397213,
                30.0708247
              ],
              [
                48.4399136,
                30.0705592
              ],
              [
                48.4434791,
                30.0648931
              ],
              [
                48.4456638,
                30.0606613
              ],
              [
                48.4459204,
                30.0598965
              ],
              [
                48.4460952,
                30.0593754
              ],
              [
                48.4465035,
                30.0577861
              ],
              [
                48.4466408,
                30.0572518
              ],
              [
                48.4471262,
                30.0553989
              ],
              [
                48.447519,
                30.0535666
              ],
              [
                48.4477279,
                30.0525922
              ],
              [
                48.4481684,
                30.0505375
              ],
              [
                48.4483204,
                30.0494464
              ],
              [
                48.4484091,
                30.0488099
              ],
              [
                48.4484532,
                30.0478783
              ],
              [
                48.4484895,
                30.0471109
              ],
              [
                48.4485569,
                30.0456885
              ],
              [
                48.4486788,
                30.0433381
              ],
              [
                48.448681,
                30.0432533
              ],
              [
                48.4487243,
                30.0415997
              ],
              [
                48.4487457,
                30.0407843
              ],
              [
                48.4487336,
                30.0399222
              ],
              [
                48.4486998,
                30.0375108
              ],
              [
                48.4486557,
                30.0343587
              ],
              [
                48.4486103,
                30.0336161
              ],
              [
                48.448459,
                30.0311433
              ],
              [
                48.4483462,
                30.0293004
              ],
              [
                48.448183,
                30.0272715
              ],
              [
                48.4479446,
                30.022172
              ],
              [
                48.4479762,
                30.0198541
              ],
              [
                48.4479777,
                30.0197412
              ],
              [
                48.4482984,
                30.0140722
              ],
              [
                48.4486937,
                30.0117311
              ],
              [
                48.4490282,
                30.0095349
              ],
              [
                48.449089,
                30.0091357
              ],
              [
                48.4496187,
                30.0071261
              ],
              [
                48.4496332,
                30.0070709
              ],
              [
                48.4501774,
                30.00543
              ],
              [
                48.4502688,
                30.0052338
              ],
              [
                48.4511487,
                30.003344
              ],
              [
                48.4512345,
                30.0031597
              ],
              [
                48.4520071,
                30.0019349
              ],
              [
                48.4531135,
                30.0001906
              ],
              [
                48.4532065,
                30.000044
              ],
              [
                48.4537824,
                29.9992989
              ],
              [
                48.4538642,
                29.9991931
              ],
              [
                48.4551935,
                29.9976487
              ],
              [
                48.4553329,
                29.9974867
              ],
              [
                48.4562582,
                29.9965332
              ],
              [
                48.4597907,
                29.9936741
              ],
              [
                48.4599081,
                29.9935791
              ],
              [
                48.4620719,
                29.9921674
              ],
              [
                48.4621448,
                29.9921199
              ],
              [
                48.4631729,
                29.9914997
              ],
              [
                48.4635253,
                29.9912781
              ],
              [
                48.4649189,
                29.9904018
              ],
              [
                48.4651829,
                29.9902562
              ],
              [
                48.4689097,
                29.9882011
              ],
              [
                48.4723229,
                29.9863188
              ],
              [
                48.4741566,
                29.9853152
              ],
              [
                48.4774643,
                29.9835049
              ],
              [
                48.4790433,
                29.9826406
              ],
              [
                48.4818062,
                29.9811284
              ],
              [
                48.4822242,
                29.9808996
              ],
              [
                48.4833698,
                29.9802275
              ],
              [
                48.4855625,
                29.9789412
              ],
              [
                48.485958,
                29.9787092
              ],
              [
                48.4881574,
                29.9773813
              ],
              [
                48.4891428,
                29.9767864
              ],
              [
                48.4945539,
                29.9735393
              ],
              [
                48.4956136,
                29.9729034
              ],
              [
                48.5025173,
                29.9686974
              ],
              [
                48.5034003,
                29.9681594
              ],
              [
                48.5061778,
                29.9664624
              ],
              [
                48.5073526,
                29.9657446
              ],
              [
                48.5106334,
                29.9637787
              ],
              [
                48.5137326,
                29.9625117
              ],
              [
                48.5144518,
                29.9622177
              ],
              [
                48.5178054,
                29.9609283
              ],
              [
                48.5255699,
                29.9580869
              ],
              [
                48.5403781,
                29.9538388
              ],
              [
                48.5486874,
                29.9522
              ],
              [
                48.5587479,
                29.9499882
              ],
              [
                48.5691414,
                29.9483389
              ],
              [
                48.5715604,
                29.9479429
              ],
              [
                48.5757064,
                29.9471445
              ],
              [
                48.5794394,
                29.9463942
              ],
              [
                48.5839637,
                29.9451092
              ],
              [
                48.5869306,
                29.944118
              ],
              [
                48.590143,
                29.9432176
              ],
              [
                48.5931535,
                29.9424327
              ],
              [
                48.5974859,
                29.9408007
              ],
              [
                48.6006204,
                29.9396136
              ],
              [
                48.6037434,
                29.9383817
              ],
              [
                48.6112542,
                29.9353374
              ],
              [
                48.6176008,
                29.932435
              ],
              [
                48.6176674,
                29.9323998
              ],
              [
                48.6235183,
                29.9293095
              ],
              [
                48.637415,
                29.9226729
              ],
              [
                48.6891496,
                29.8979601
              ],
              [
                48.8809795,
                29.8157281
              ],
              [
                48.9537333,
                29.8125171
              ],
              [
                49.0973992,
                29.8059254
              ],
              [
                49.1629583,
                29.8031143
              ],
              [
                49.1424695,
                29.8925109
              ],
              [
                49.1141237,
                30.0160739
              ],
              [
                49.085052,
                30.1426416
              ],
              [
                49.0570309,
                30.2644821
              ],
              [
                48.9604629,
                30.2889534
              ],
              [
                48.8650864,
                30.3131167
              ],
              [
                48.8648325,
                30.3133553
              ],
              [
                48.8644425,
                30.3136056
              ],
              [
                48.8642055,
                30.3137285
              ],
              [
                48.8640392,
                30.3138147
              ],
              [
                48.8635297,
                30.3141225
              ],
              [
                48.8633589,
                30.3141569
              ],
              [
                48.8629936,
                30.3144244
              ],
              [
                48.8629125,
                30.3144194
              ],
              [
                48.8624781,
                30.3147289
              ],
              [
                48.8620042,
                30.3149756
              ],
              [
                48.8619492,
                30.3150658
              ],
              [
                48.8614267,
                30.3154072
              ],
              [
                48.8611492,
                30.3155533
              ],
              [
                48.8610139,
                30.3156653
              ],
              [
                48.8606147,
                30.3159256
              ],
              [
                48.8604958,
                30.3160536
              ],
              [
                48.8602333,
                30.3162564
              ],
              [
                48.8598239,
                30.3164981
              ],
              [
                48.8593283,
                30.3168417
              ],
              [
                48.8590019,
                30.3170864
              ],
              [
                48.8586414,
                30.3172972
              ],
              [
                48.8581453,
                30.3176608
              ],
              [
                48.8576522,
                30.3180503
              ],
              [
                48.8571614,
                30.3184083
              ],
              [
                48.8566519,
                30.3187658
              ],
              [
                48.8562586,
                30.3190586
              ],
              [
                48.8557347,
                30.3194153
              ],
              [
                48.8553433,
                30.3196892
              ],
              [
                48.8549725,
                30.3199789
              ],
              [
                48.8544461,
                30.3203278
              ],
              [
                48.8539189,
                30.32067
              ],
              [
                48.8534094,
                30.3210364
              ],
              [
                48.8529042,
                30.3213731
              ],
              [
                48.8524178,
                30.3216931
              ],
              [
                48.8520553,
                30.3219239
              ],
              [
                48.8515864,
                30.322265
              ],
              [
                48.8511439,
                30.3226075
              ],
              [
                48.8507539,
                30.3228942
              ],
              [
                48.8502106,
                30.3232611
              ],
              [
                48.8500087,
                30.3233946
              ],
              [
                48.8497986,
                30.3235336
              ],
              [
                48.8494008,
                30.3238292
              ],
              [
                48.8491436,
                30.3240381
              ],
              [
                48.8485914,
                30.3244044
              ],
              [
                48.8482125,
                30.32467
              ],
              [
                48.8477192,
                30.3250514
              ],
              [
                48.8473347,
                30.3253294
              ],
              [
                48.8467947,
                30.3256722
              ],
              [
                48.8462572,
                30.3260364
              ],
              [
                48.8457392,
                30.3263967
              ],
              [
                48.8452228,
                30.3267289
              ],
              [
                48.8447067,
                30.3270519
              ],
              [
                48.8444197,
                30.3271619
              ],
              [
                48.8442667,
                30.3272556
              ],
              [
                48.8441653,
                30.3273719
              ],
              [
                48.8436383,
                30.3276775
              ],
              [
                48.8430978,
                30.3280011
              ],
              [
                48.8427081,
                30.3282533
              ],
              [
                48.8421717,
                30.3285597
              ],
              [
                48.8417781,
                30.3287831
              ],
              [
                48.8413708,
                30.3289767
              ],
              [
                48.8408161,
                30.3292094
              ],
              [
                48.8402717,
                30.3294286
              ],
              [
                48.8397353,
                30.3296564
              ],
              [
                48.8387803,
                30.3300522
              ],
              [
                48.8385078,
                30.3301422
              ],
              [
                48.8383903,
                30.3302267
              ],
              [
                48.8380553,
                30.3303347
              ],
              [
                48.8378553,
                30.3303994
              ],
              [
                48.8373631,
                30.3305561
              ],
              [
                48.8367806,
                30.3307442
              ],
              [
                48.8365697,
                30.3307392
              ],
              [
                48.8364286,
                30.3307675
              ],
              [
                48.8363239,
                30.3307697
              ],
              [
                48.8360908,
                30.3308275
              ],
              [
                48.8355089,
                30.3309761
              ],
              [
                48.8351233,
                30.3310769
              ],
              [
                48.8345267,
                30.3311833
              ],
              [
                48.8340439,
                30.3312506
              ],
              [
                48.8335211,
                30.3313469
              ],
              [
                48.8329936,
                30.3314486
              ],
              [
                48.8327092,
                30.3315242
              ],
              [
                48.8321667,
                30.3315911
              ],
              [
                48.8316119,
                30.3316608
              ],
              [
                48.8310503,
                30.3317406
              ],
              [
                48.8304958,
                30.3318058
              ],
              [
                48.8299353,
                30.3318683
              ],
              [
                48.8297769,
                30.3318857
              ],
              [
                48.8294069,
                30.3319261
              ],
              [
                48.8289811,
                30.33196
              ],
              [
                48.8284386,
                30.3320331
              ],
              [
                48.8280022,
                30.3320878
              ],
              [
                48.8274572,
                30.3321258
              ],
              [
                48.8269197,
                30.3321503
              ],
              [
                48.8264089,
                30.3321547
              ],
              [
                48.8260714,
                30.3321281
              ],
              [
                48.8255228,
                30.3321336
              ],
              [
                48.8251036,
                30.3321369
              ],
              [
                48.8244856,
                30.3321019
              ],
              [
                48.8239742,
                30.3320747
              ],
              [
                48.8233592,
                30.3320125
              ],
              [
                48.8227714,
                30.3319583
              ],
              [
                48.8221789,
                30.3318906
              ],
              [
                48.8215706,
                30.3318303
              ],
              [
                48.8210692,
                30.3318228
              ],
              [
                48.8204581,
                30.3317786
              ],
              [
                48.8198572,
                30.3317108
              ],
              [
                48.8192514,
                30.3316369
              ],
              [
                48.8186836,
                30.33155
              ],
              [
                48.8181178,
                30.3314342
              ],
              [
                48.8175381,
                30.3312806
              ],
              [
                48.8171528,
                30.3311689
              ],
              [
                48.8167664,
                30.3310303
              ],
              [
                48.8157457,
                30.3305134
              ],
              [
                48.815455,
                30.3303403
              ],
              [
                48.8150214,
                30.3300811
              ],
              [
                48.8145556,
                30.3297775
              ],
              [
                48.8140886,
                30.3294983
              ],
              [
                48.8137925,
                30.3293433
              ],
              [
                48.8133225,
                30.3290019
              ],
              [
                48.8128914,
                30.3286717
              ],
              [
                48.8125264,
                30.3284183
              ],
              [
                48.812105,
                30.3280736
              ],
              [
                48.8116844,
                30.3277369
              ],
              [
                48.8113517,
                30.3274533
              ],
              [
                48.8110672,
                30.3271694
              ],
              [
                48.810735,
                30.3267956
              ],
              [
                48.8104206,
                30.3263947
              ],
              [
                48.8100992,
                30.3259847
              ],
              [
                48.8097639,
                30.3255147
              ],
              [
                48.8094806,
                30.3251044
              ],
              [
                48.8091664,
                30.32468
              ],
              [
                48.8088839,
                30.3242508
              ],
              [
                48.8086092,
                30.3238089
              ],
              [
                48.8083697,
                30.3233808
              ],
              [
                48.8081353,
                30.3229447
              ],
              [
                48.8078917,
                30.3224844
              ],
              [
                48.8078806,
                30.3224656
              ],
              [
                48.8076231,
                30.3220269
              ],
              [
                48.8073992,
                30.3216008
              ],
              [
                48.8071511,
                30.3211106
              ],
              [
                48.8070011,
                30.3207844
              ],
              [
                48.8067544,
                30.3203422
              ],
              [
                48.8065447,
                30.3198967
              ],
              [
                48.8063208,
                30.3194622
              ],
              [
                48.8061081,
                30.3189978
              ],
              [
                48.805865,
                30.3185519
              ],
              [
                48.80555,
                30.3180367
              ],
              [
                48.8053178,
                30.3176303
              ],
              [
                48.8050375,
                30.3171028
              ],
              [
                48.8047972,
                30.3166981
              ],
              [
                48.8045328,
                30.3162344
              ],
              [
                48.8043136,
                30.3158197
              ],
              [
                48.8041058,
                30.3154858
              ],
              [
                48.8040322,
                30.3153672
              ],
              [
                48.8040028,
                30.3153242
              ],
              [
                48.8039811,
                30.3152931
              ],
              [
                48.8039553,
                30.3152572
              ],
              [
                48.8039272,
                30.3152186
              ],
              [
                48.8038969,
                30.3151822
              ],
              [
                48.8038667,
                30.3151464
              ],
              [
                48.8038361,
                30.3151125
              ],
              [
                48.8038053,
                30.3150794
              ],
              [
                48.8037747,
                30.3150439
              ],
              [
                48.8037183,
                30.3149706
              ],
              [
                48.8036925,
                30.3149303
              ],
              [
                48.8036669,
                30.3148872
              ],
              [
                48.8036403,
                30.3148442
              ],
              [
                48.8036131,
                30.3148022
              ],
              [
                48.8035864,
                30.3147628
              ],
              [
                48.8035597,
                30.3147236
              ],
              [
                48.8035047,
                30.3146386
              ],
              [
                48.8034775,
                30.3145928
              ],
              [
                48.8034506,
                30.3145464
              ],
              [
                48.8034253,
                30.3144969
              ],
              [
                48.8034011,
                30.3144503
              ],
              [
                48.8033761,
                30.3144064
              ],
              [
                48.8033492,
                30.3143636
              ],
              [
                48.8033211,
                30.3143189
              ],
              [
                48.8032931,
                30.3142731
              ],
              [
                48.8032639,
                30.3142256
              ],
              [
                48.8032353,
                30.3141764
              ],
              [
                48.8032067,
                30.3141264
              ],
              [
                48.8031772,
                30.3140769
              ],
              [
                48.8031467,
                30.3140306
              ],
              [
                48.8031153,
                30.3139839
              ],
              [
                48.8030828,
                30.3139367
              ],
              [
                48.8030497,
                30.3138883
              ],
              [
                48.8030172,
                30.3138381
              ],
              [
                48.8029858,
                30.3137861
              ],
              [
                48.8029533,
                30.3137361
              ],
              [
                48.8029194,
                30.3136878
              ],
              [
                48.8028847,
                30.3136422
              ],
              [
                48.8028503,
                30.3135947
              ],
              [
                48.8028164,
                30.3135456
              ],
              [
                48.8027831,
                30.3134956
              ],
              [
                48.8027492,
                30.3134436
              ],
              [
                48.8027158,
                30.3133936
              ],
              [
                48.8026819,
                30.3133453
              ],
              [
                48.8026483,
                30.3132989
              ],
              [
                48.8026147,
                30.3132522
              ],
              [
                48.8025811,
                30.3132058
              ],
              [
                48.8025486,
                30.3131575
              ],
              [
                48.8025142,
                30.3131064
              ],
              [
                48.8024775,
                30.3130547
              ],
              [
                48.8024411,
                30.3130044
              ],
              [
                48.8024058,
                30.3129572
              ],
              [
                48.8023722,
                30.3129089
              ],
              [
                48.8023394,
                30.3128597
              ],
              [
                48.8023058,
                30.3128086
              ],
              [
                48.8022706,
                30.3127558
              ],
              [
                48.8022339,
                30.3127022
              ],
              [
                48.8021969,
                30.3126494
              ],
              [
                48.8021606,
                30.3126003
              ],
              [
                48.8021242,
                30.3125528
              ],
              [
                48.8020858,
                30.3125039
              ],
              [
                48.8020478,
                30.3124547
              ],
              [
                48.80201,
                30.3124028
              ],
              [
                48.8019725,
                30.3123483
              ],
              [
                48.8019361,
                30.3122964
              ],
              [
                48.8018994,
                30.3122464
              ],
              [
                48.8018642,
                30.3121972
              ],
              [
                48.8018281,
                30.3121469
              ],
              [
                48.8017917,
                30.3120961
              ],
              [
                48.8017542,
                30.3120442
              ],
              [
                48.8017178,
                30.3119897
              ],
              [
                48.8016811,
                30.3119378
              ],
              [
                48.8016431,
                30.3118894
              ],
              [
                48.8016044,
                30.3118422
              ],
              [
                48.8015672,
                30.3117967
              ],
              [
                48.8015308,
                30.3117503
              ],
              [
                48.8014942,
                30.3117019
              ],
              [
                48.8014569,
                30.3116519
              ],
              [
                48.8014183,
                30.3116017
              ],
              [
                48.8013803,
                30.3115536
              ],
              [
                48.8013442,
                30.3115069
              ],
              [
                48.8013086,
                30.3114597
              ],
              [
                48.8012725,
                30.3114133
              ],
              [
                48.8012342,
                30.311365
              ],
              [
                48.8011936,
                30.3113142
              ],
              [
                48.8011544,
                30.3112614
              ],
              [
                48.8011172,
                30.3112114
              ],
              [
                48.8010811,
                30.3111622
              ],
              [
                48.801045,
                30.3111156
              ],
              [
                48.8010092,
                30.3110692
              ],
              [
                48.8009731,
                30.3110208
              ],
              [
                48.8009372,
                30.3109717
              ],
              [
                48.8009017,
                30.3109208
              ],
              [
                48.8008672,
                30.3108717
              ],
              [
                48.8008311,
                30.3108269
              ],
              [
                48.8007944,
                30.3107842
              ],
              [
                48.8007581,
                30.3107403
              ],
              [
                48.8007211,
                30.3106956
              ],
              [
                48.8006858,
                30.31065
              ],
              [
                48.8006511,
                30.3106053
              ],
              [
                48.8006153,
                30.3105589
              ],
              [
                48.8005783,
                30.3105142
              ],
              [
                48.8005422,
                30.3104722
              ],
              [
                48.8005097,
                30.3104367
              ],
              [
                48.8004814,
                30.3104053
              ],
              [
                48.80046,
                30.3103822
              ],
              [
                48.8004478,
                30.3103706
              ],
              [
                48.8004456,
                30.3103653
              ],
              [
                48.8004089,
                30.3103133
              ],
              [
                48.8003892,
                30.3102903
              ],
              [
                48.8003642,
                30.3102642
              ],
              [
                48.8003367,
                30.3102367
              ],
              [
                48.8003064,
                30.3102072
              ],
              [
                48.8002744,
                30.3101761
              ],
              [
                48.8002422,
                30.310145
              ],
              [
                48.8002097,
                30.3101128
              ],
              [
                48.8001772,
                30.3100817
              ],
              [
                48.8001444,
                30.3100478
              ],
              [
                48.8001119,
                30.3100139
              ],
              [
                48.8000794,
                30.30998
              ],
              [
                48.8000456,
                30.3099461
              ],
              [
                48.8000122,
                30.3099094
              ],
              [
                48.7999786,
                30.3098719
              ],
              [
                48.7999453,
                30.3098336
              ],
              [
                48.7999131,
                30.3097972
              ],
              [
                48.7998819,
                30.3097606
              ],
              [
                48.7998206,
                30.3096936
              ],
              [
                48.79979,
                30.3096597
              ],
              [
                48.7997597,
                30.3096247
              ],
              [
                48.7997292,
                30.3095892
              ],
              [
                48.7996994,
                30.3095517
              ],
              [
                48.7996703,
                30.3095122
              ],
              [
                48.7996406,
                30.3094731
              ],
              [
                48.7996117,
                30.3094372
              ],
              [
                48.7995833,
                30.3094025
              ],
              [
                48.7995539,
                30.3093694
              ],
              [
                48.7995225,
                30.3093364
              ],
              [
                48.7994922,
                30.3093025
              ],
              [
                48.7994617,
                30.3092667
              ],
              [
                48.7994303,
                30.3092319
              ],
              [
                48.7993994,
                30.3091944
              ],
              [
                48.7993678,
                30.3091578
              ],
              [
                48.7993033,
                30.3090811
              ],
              [
                48.7992703,
                30.3090453
              ],
              [
                48.7992375,
                30.3090106
              ],
              [
                48.7992036,
                30.3089767
              ],
              [
                48.7991694,
                30.3089428
              ],
              [
                48.799135,
                30.3089089
              ],
              [
                48.7990986,
                30.3088733
              ],
              [
                48.7990614,
                30.3088378
              ],
              [
                48.7989922,
                30.3087717
              ],
              [
                48.7989628,
                30.3087433
              ],
              [
                48.7989175,
                30.3086978
              ],
              [
                48.7989036,
                30.3086844
              ],
              [
                48.7988928,
                30.3086728
              ],
              [
                48.7988669,
                30.3086417
              ],
              [
                48.7988483,
                30.3086247
              ],
              [
                48.7988261,
                30.3086033
              ],
              [
                48.7988006,
                30.3085792
              ],
              [
                48.7987736,
                30.3085533
              ],
              [
                48.7987433,
                30.3085267
              ],
              [
                48.79871,
                30.3084992
              ],
              [
                48.7986753,
                30.3084717
              ],
              [
                48.7986403,
                30.3084422
              ],
              [
                48.7986067,
                30.3084128
              ],
              [
                48.7985433,
                30.3083569
              ],
              [
                48.7984839,
                30.3083053
              ],
              [
                48.7984536,
                30.3082794
              ],
              [
                48.7983697,
                30.308225
              ],
              [
                48.7979508,
                30.3078667
              ],
              [
                48.7976217,
                30.3075536
              ],
              [
                48.7973536,
                30.3073372
              ],
              [
                48.7969044,
                30.3069628
              ],
              [
                48.7965125,
                30.3066367
              ],
              [
                48.7961008,
                30.3063225
              ],
              [
                48.7957258,
                30.3060622
              ],
              [
                48.7952683,
                30.3057467
              ],
              [
                48.7948214,
                30.3054317
              ],
              [
                48.7945242,
                30.3051892
              ],
              [
                48.7941508,
                30.3049189
              ],
              [
                48.7936717,
                30.3045844
              ],
              [
                48.7933697,
                30.3044117
              ],
              [
                48.7929772,
                30.3041517
              ],
              [
                48.7924667,
                30.3038347
              ],
              [
                48.792155,
                30.3036872
              ],
              [
                48.7916439,
                30.3034297
              ],
              [
                48.7911886,
                30.3031658
              ],
              [
                48.7907353,
                30.3028983
              ],
              [
                48.79048,
                30.3028044
              ],
              [
                48.7899869,
                30.3026308
              ],
              [
                48.7895186,
                30.3024453
              ],
              [
                48.7891442,
                30.3022678
              ],
              [
                48.7886008,
                30.3020408
              ],
              [
                48.7880706,
                30.3018206
              ],
              [
                48.7875792,
                30.3016172
              ],
              [
                48.7870942,
                30.3014267
              ],
              [
                48.7865422,
                30.3012278
              ],
              [
                48.7860022,
                30.3010442
              ],
              [
                48.7855003,
                30.3008553
              ],
              [
                48.7851886,
                30.3008058
              ],
              [
                48.7847481,
                30.3007092
              ],
              [
                48.7842603,
                30.3005628
              ],
              [
                48.7836889,
                30.3004064
              ],
              [
                48.7831442,
                30.3002536
              ],
              [
                48.7828461,
                30.3002133
              ],
              [
                48.7822217,
                30.3001294
              ],
              [
                48.7819478,
                30.3000594
              ],
              [
                48.7813639,
                30.2999022
              ],
              [
                48.7807567,
                30.2997658
              ],
              [
                48.7802664,
                30.2996839
              ],
              [
                48.7796739,
                30.2996033
              ],
              [
                48.7789994,
                30.2995378
              ],
              [
                48.7784525,
                30.2994706
              ],
              [
                48.7778889,
                30.2994317
              ],
              [
                48.7773675,
                30.2994028
              ],
              [
                48.7768186,
                30.2993533
              ],
              [
                48.7762519,
                30.2992803
              ],
              [
                48.7756489,
                30.2992186
              ],
              [
                48.7756483,
                30.2992186
              ],
              [
                48.7753639,
                30.2992225
              ],
              [
                48.77478,
                30.2992381
              ],
              [
                48.774779,
                30.299238
              ],
              [
                48.7747789,
                30.299238
              ],
              [
                48.7742892,
                30.2992122
              ],
              [
                48.7742881,
                30.2992122
              ],
              [
                48.7736607,
                30.2992016
              ],
              [
                48.77366,
                30.2992016
              ],
              [
                48.7731631,
                30.2991605
              ],
              [
                48.7726075,
                30.2991317
              ],
              [
                48.7726064,
                30.2991316
              ],
              [
                48.7719358,
                30.2990942
              ],
              [
                48.7714022,
                30.2990872
              ],
              [
                48.7708456,
                30.2990839
              ],
              [
                48.7702431,
                30.2990722
              ],
              [
                48.7696336,
                30.2990572
              ],
              [
                48.7690694,
                30.2990597
              ],
              [
                48.7685483,
                30.2990792
              ],
              [
                48.7679664,
                30.2991022
              ],
              [
                48.7674131,
                30.299105
              ],
              [
                48.766885,
                30.2991208
              ],
              [
                48.7662886,
                30.2991594
              ],
              [
                48.7657436,
                30.2991719
              ],
              [
                48.7654125,
                30.2991775
              ],
              [
                48.7651289,
                30.2991822
              ],
              [
                48.7646056,
                30.2991856
              ],
              [
                48.7639919,
                30.2991889
              ],
              [
                48.7634714,
                30.2991947
              ],
              [
                48.76293,
                30.2992039
              ],
              [
                48.7623392,
                30.2992072
              ],
              [
                48.7617403,
                30.2992225
              ],
              [
                48.7611375,
                30.2992439
              ],
              [
                48.7599983,
                30.2992531
              ],
              [
                48.7594386,
                30.2992511
              ],
              [
                48.7588281,
                30.2992536
              ],
              [
                48.7582517,
                30.2992631
              ],
              [
                48.7577464,
                30.2992767
              ],
              [
                48.7575833,
                30.2992811
              ],
              [
                48.7569892,
                30.2992828
              ],
              [
                48.7564136,
                30.299275
              ],
              [
                48.7558247,
                30.2992767
              ],
              [
                48.7552794,
                30.2992611
              ],
              [
                48.7547364,
                30.299255
              ],
              [
                48.7542089,
                30.2992411
              ],
              [
                48.7542079,
                30.2992411
              ],
              [
                48.7542078,
                30.2992411
              ],
              [
                48.7538703,
                30.299226
              ],
              [
                48.7536381,
                30.2992156
              ],
              [
                48.753637,
                30.2992155
              ],
              [
                48.7531067,
                30.299195
              ],
              [
                48.7525567,
                30.2991967
              ],
              [
                48.7520283,
                30.2991861
              ],
              [
                48.7520272,
                30.2991861
              ],
              [
                48.7514419,
                30.2991639
              ],
              [
                48.7514418,
                30.2991639
              ],
              [
                48.7514408,
                30.2991638
              ],
              [
                48.7509867,
                30.2991211
              ],
              [
                48.7505033,
                30.299097
              ],
              [
                48.7505022,
                30.2990969
              ],
              [
                48.7500003,
                30.2990677
              ],
              [
                48.7499314,
                30.2990636
              ],
              [
                48.7493472,
                30.2990339
              ],
              [
                48.7493461,
                30.2990338
              ],
              [
                48.7487736,
                30.2990108
              ],
              [
                48.7487735,
                30.2990108
              ],
              [
                48.7481697,
                30.298965
              ],
              [
                48.7481686,
                30.2989649
              ],
              [
                48.7476069,
                30.2989394
              ],
              [
                48.7470744,
                30.2989017
              ],
              [
                48.7470734,
                30.2989016
              ],
              [
                48.7465125,
                30.2988769
              ],
              [
                48.7465114,
                30.2988769
              ],
              [
                48.7459469,
                30.298847
              ],
              [
                48.7459458,
                30.2988469
              ],
              [
                48.7458436,
                30.2988405
              ],
              [
                48.7453506,
                30.2988097
              ],
              [
                48.7449072,
                30.2987513
              ],
              [
                48.7443422,
                30.2986763
              ],
              [
                48.7437881,
                30.2986083
              ],
              [
                48.7432183,
                30.2985547
              ],
              [
                48.7429904,
                30.2985294
              ],
              [
                48.7426789,
                30.298495
              ],
              [
                48.7421161,
                30.2984541
              ],
              [
                48.741448,
                30.2983972
              ],
              [
                48.7410569,
                30.2983925
              ],
              [
                48.7404844,
                30.2983914
              ],
              [
                48.7398778,
                30.2983931
              ],
              [
                48.7392575,
                30.2984075
              ],
              [
                48.7386753,
                30.2984242
              ],
              [
                48.7381392,
                30.2984444
              ],
              [
                48.7376069,
                30.2984975
              ],
              [
                48.7371169,
                30.2985847
              ],
              [
                48.7366183,
                30.2987006
              ],
              [
                48.7362975,
                30.2988042
              ],
              [
                48.7360631,
                30.2989108
              ],
              [
                48.7357811,
                30.2990208
              ],
              [
                48.7352114,
                30.2991417
              ],
              [
                48.73493,
                30.2991406
              ],
              [
                48.7349295,
                30.2991405
              ],
              [
                48.7348888,
                30.2991368
              ],
              [
                48.7345131,
                30.2991025
              ],
              [
                48.734513,
                30.2991025
              ],
              [
                48.734512,
                30.2991025
              ],
              [
                48.7341227,
                30.2993484
              ],
              [
                48.7337628,
                30.2996309
              ],
              [
                48.7332281,
                30.3000316
              ],
              [
                48.7331889,
                30.3001216
              ],
              [
                48.7331131,
                30.3002022
              ],
              [
                48.7329995,
                30.3002855
              ],
              [
                48.7326861,
                30.3005808
              ],
              [
                48.7323303,
                30.3009694
              ],
              [
                48.7319481,
                30.3014311
              ],
              [
                48.7316211,
                30.3018813
              ],
              [
                48.7313947,
                30.3022194
              ],
              [
                48.731182,
                30.3025797
              ],
              [
                48.7311074,
                30.3027299
              ],
              [
                48.730942,
                30.3030633
              ],
              [
                48.7307767,
                30.303408
              ],
              [
                48.7306386,
                30.3039019
              ],
              [
                48.7305495,
                30.3042652
              ],
              [
                48.7305075,
                30.3045816
              ],
              [
                48.7305317,
                30.3048813
              ],
              [
                48.7304911,
                30.3052352
              ],
              [
                48.7303803,
                30.3056555
              ],
              [
                48.7302992,
                30.30606
              ],
              [
                48.7302436,
                30.3065091
              ],
              [
                48.730222,
                30.306598
              ],
              [
                48.7302145,
                30.3067255
              ],
              [
                48.7301964,
                30.3069597
              ],
              [
                48.7301795,
                30.307198
              ],
              [
                48.7301645,
                30.3073544
              ],
              [
                48.7301528,
                30.3075108
              ],
              [
                48.7301456,
                30.3076608
              ],
              [
                48.7301308,
                30.3078902
              ],
              [
                48.7301211,
                30.3080458
              ],
              [
                48.7301047,
                30.3082038
              ],
              [
                48.7300836,
                30.3083702
              ],
              [
                48.7300583,
                30.3085305
              ],
              [
                48.7300325,
                30.3086788
              ],
              [
                48.7300215,
                30.308749
              ],
              [
                48.7300086,
                30.3088311
              ],
              [
                48.729995,
                30.3089061
              ],
              [
                48.7299608,
                30.3090538
              ],
              [
                48.7299214,
                30.3092
              ],
              [
                48.7298825,
                30.309353
              ],
              [
                48.7298433,
                30.3094991
              ],
              [
                48.7297847,
                30.3097061
              ],
              [
                48.7297442,
                30.3098447
              ],
              [
                48.7296984,
                30.3099727
              ],
              [
                48.7296561,
                30.3101027
              ],
              [
                48.7296228,
                30.3102341
              ],
              [
                48.7295839,
                30.310363
              ],
              [
                48.7295425,
                30.31049
              ],
              [
                48.7294714,
                30.3106808
              ],
              [
                48.7294242,
                30.310808
              ],
              [
                48.7293989,
                30.3108716
              ],
              [
                48.7292722,
                30.311105
              ],
              [
                48.7292036,
                30.3112227
              ],
              [
                48.7291722,
                30.3112819
              ],
              [
                48.7290958,
                30.3114494
              ],
              [
                48.7290495,
                30.3115566
              ],
              [
                48.7290267,
                30.311613
              ],
              [
                48.7288211,
                30.3120083
              ],
              [
                48.7287703,
                30.3120925
              ],
              [
                48.72869,
                30.3122102
              ],
              [
                48.7285995,
                30.3123463
              ],
              [
                48.7285186,
                30.3124552
              ],
              [
                48.7284256,
                30.3125697
              ],
              [
                48.728327,
                30.3126869
              ],
              [
                48.7282739,
                30.3127447
              ],
              [
                48.7282203,
                30.312798
              ],
              [
                48.7281111,
                30.3128958
              ],
              [
                48.7280053,
                30.3129933
              ],
              [
                48.7278995,
                30.3130963
              ],
              [
                48.7277889,
                30.3131977
              ],
              [
                48.7274153,
                30.3135122
              ],
              [
                48.7271028,
                30.3137805
              ],
              [
                48.7269947,
                30.3138438
              ],
              [
                48.7268367,
                30.3139324
              ],
              [
                48.7267333,
                30.3139891
              ],
              [
                48.7266178,
                30.3140463
              ],
              [
                48.7264917,
                30.3141019
              ],
              [
                48.7262942,
                30.314195
              ],
              [
                48.726175,
                30.314253
              ],
              [
                48.7261153,
                30.3142783
              ],
              [
                48.7259867,
                30.3143241
              ],
              [
                48.7259164,
                30.3143452
              ],
              [
                48.7256261,
                30.314418
              ],
              [
                48.7254892,
                30.3144513
              ],
              [
                48.7252664,
                30.3144977
              ],
              [
                48.7251186,
                30.3145258
              ],
              [
                48.7250436,
                30.3145388
              ],
              [
                48.7248078,
                30.3145583
              ],
              [
                48.7247258,
                30.3145636
              ],
              [
                48.7244386,
                30.3145705
              ],
              [
                48.7242378,
                30.3145741
              ],
              [
                48.7241633,
                30.3145747
              ],
              [
                48.7240189,
                30.3145683
              ],
              [
                48.7240178,
                30.3145683
              ],
              [
                48.7237925,
                30.3145525
              ],
              [
                48.7236353,
                30.3145419
              ],
              [
                48.7234789,
                30.3145283
              ],
              [
                48.7232581,
                30.3145125
              ],
              [
                48.7231047,
                30.3145027
              ],
              [
                48.7230275,
                30.3144949
              ],
              [
                48.7228831,
                30.3144741
              ],
              [
                48.7227489,
                30.3144513
              ],
              [
                48.7226083,
                30.3144341
              ],
              [
                48.7224603,
                30.3144177
              ],
              [
                48.7223206,
                30.3144013
              ],
              [
                48.7221906,
                30.3143811
              ],
              [
                48.7220586,
                30.3143575
              ],
              [
                48.7217881,
                30.3143027
              ],
              [
                48.721655,
                30.3142763
              ],
              [
                48.7215222,
                30.3142516
              ],
              [
                48.7213839,
                30.314228
              ],
              [
                48.7212436,
                30.3142069
              ],
              [
                48.7210506,
                30.3141708
              ],
              [
                48.7209125,
                30.3141425
              ],
              [
                48.7206933,
                30.3140924
              ],
              [
                48.7205522,
                30.3140588
              ],
              [
                48.7204047,
                30.3140255
              ],
              [
                48.7202514,
                30.3139886
              ],
              [
                48.7201008,
                30.3139505
              ],
              [
                48.7198889,
                30.3139058
              ],
              [
                48.7197608,
                30.3138836
              ],
              [
                48.7196558,
                30.3138711
              ],
              [
                48.7195033,
                30.3138613
              ],
              [
                48.7193039,
                30.3138405
              ],
              [
                48.7191672,
                30.3138277
              ],
              [
                48.7190342,
                30.3138183
              ],
              [
                48.718901,
                30.3138108
              ],
              [
                48.7189006,
                30.3138108
              ],
              [
                48.7187625,
                30.3138061
              ],
              [
                48.7186153,
                30.3138033
              ],
              [
                48.7184644,
                30.3138025
              ],
              [
                48.7184633,
                30.3138025
              ],
              [
                48.7183169,
                30.3137961
              ],
              [
                48.7183158,
                30.3137961
              ],
              [
                48.7182442,
                30.3137894
              ],
              [
                48.7179478,
                30.3137433
              ],
              [
                48.7178028,
                30.3137188
              ],
              [
                48.7176608,
                30.3136988
              ],
              [
                48.7175078,
                30.31368
              ],
              [
                48.7173545,
                30.3136583
              ],
              [
                48.7172167,
                30.3136336
              ],
              [
                48.7170736,
                30.31361
              ],
              [
                48.7168456,
                30.3135844
              ],
              [
                48.7166978,
                30.3135691
              ],
              [
                48.7165953,
                30.3135552
              ],
              [
                48.7164914,
                30.3135411
              ],
              [
                48.7163472,
                30.3135222
              ],
              [
                48.7162089,
                30.3135075
              ],
              [
                48.7161587,
                30.3135039
              ],
              [
                48.7160885,
                30.3134989
              ],
              [
                48.7159633,
                30.3134958
              ],
              [
                48.7158467,
                30.3134964
              ],
              [
                48.7158186,
                30.3134967
              ],
              [
                48.7156633,
                30.3134994
              ],
              [
                48.7155869,
                30.3134981
              ],
              [
                48.7155866,
                30.313498
              ],
              [
                48.7155859,
                30.313498
              ],
              [
                48.7154331,
                30.3134844
              ],
              [
                48.7152706,
                30.3134674
              ],
              [
                48.7150986,
                30.3134472
              ],
              [
                48.7150178,
                30.3134388
              ],
              [
                48.71486,
                30.3134308
              ],
              [
                48.7145942,
                30.3134339
              ],
              [
                48.7144308,
                30.3134367
              ],
              [
                48.7142794,
                30.3134378
              ],
              [
                48.7141175,
                30.3134369
              ],
              [
                48.7138086,
                30.3134408
              ],
              [
                48.7136556,
                30.3134436
              ],
              [
                48.7134097,
                30.3134436
              ],
              [
                48.7132522,
                30.3134419
              ],
              [
                48.7132513,
                30.3134419
              ],
              [
                48.7132511,
                30.3134419
              ],
              [
                48.7131022,
                30.3134347
              ],
              [
                48.7131011,
                30.3134347
              ],
              [
                48.712935,
                30.3134222
              ],
              [
                48.712773,
                30.3134125
              ],
              [
                48.7127725,
                30.3134125
              ],
              [
                48.7126181,
                30.313408
              ],
              [
                48.7124545,
                30.3134083
              ],
              [
                48.71237,
                30.3134116
              ],
              [
                48.7122864,
                30.3134205
              ],
              [
                48.7122056,
                30.3134319
              ],
              [
                48.7121272,
                30.3134458
              ],
              [
                48.7118878,
                30.3134988
              ],
              [
                48.7115586,
                30.3135725
              ],
              [
                48.7113967,
                30.3136088
              ],
              [
                48.7112245,
                30.3136452
              ],
              [
                48.711055,
                30.313678
              ],
              [
                48.7108892,
                30.3137119
              ],
              [
                48.7107147,
                30.3137491
              ],
              [
                48.7106264,
                30.3137697
              ],
              [
                48.7104526,
                30.3138196
              ],
              [
                48.7103681,
                30.3138438
              ],
              [
                48.7101881,
                30.3138994
              ],
              [
                48.7100022,
                30.3139597
              ],
              [
                48.7098358,
                30.3140186
              ],
              [
                48.7097558,
                30.3140488
              ],
              [
                48.7095978,
                30.3141158
              ],
              [
                48.7094408,
                30.3141855
              ],
              [
                48.7092761,
                30.3142533
              ],
              [
                48.7090192,
                30.3143511
              ],
              [
                48.7089392,
                30.3143813
              ],
              [
                48.7088639,
                30.3144133
              ],
              [
                48.7087922,
                30.314448
              ],
              [
                48.708655,
                30.31453
              ],
              [
                48.7085831,
                30.3145727
              ],
              [
                48.7084395,
                30.3146511
              ],
              [
                48.7082322,
                30.314755
              ],
              [
                48.7080911,
                30.3148272
              ],
              [
                48.7078706,
                30.3149474
              ],
              [
                48.7078,
                30.3149866
              ],
              [
                48.7075875,
                30.3150905
              ],
              [
                48.7074433,
                30.31516
              ],
              [
                48.7072992,
                30.3152338
              ],
              [
                48.7070883,
                30.3153469
              ],
              [
                48.7069837,
                30.3154019
              ],
              [
                48.7069425,
                30.3154236
              ],
              [
                48.7067945,
                30.3155038
              ],
              [
                48.70672,
                30.315543
              ],
              [
                48.7065208,
                30.3156586
              ],
              [
                48.706395,
                30.315733
              ],
              [
                48.7062686,
                30.3158055
              ],
              [
                48.706155,
                30.3158788
              ],
              [
                48.7060497,
                30.3159574
              ],
              [
                48.7059395,
                30.3160444
              ],
              [
                48.7058217,
                30.3161294
              ],
              [
                48.7057608,
                30.3161711
              ],
              [
                48.7056453,
                30.3162608
              ],
              [
                48.7055911,
                30.3163086
              ],
              [
                48.7054872,
                30.3164108
              ],
              [
                48.7053845,
                30.3165144
              ],
              [
                48.7053306,
                30.3165641
              ],
              [
                48.7052164,
                30.3166602
              ],
              [
                48.7050408,
                30.3167969
              ],
              [
                48.7049308,
                30.3168836
              ],
              [
                48.7048133,
                30.3169669
              ],
              [
                48.7046375,
                30.3171027
              ],
              [
                48.7044728,
                30.3172286
              ],
              [
                48.7043697,
                30.3173061
              ],
              [
                48.7043101,
                30.3173474
              ],
              [
                48.70426,
                30.3173822
              ],
              [
                48.7041425,
                30.3174611
              ],
              [
                48.7040222,
                30.3175444
              ],
              [
                48.7039653,
                30.3175861
              ],
              [
                48.7037695,
                30.3177447
              ],
              [
                48.7036858,
                30.317813
              ],
              [
                48.7036064,
                30.3178838
              ],
              [
                48.7035297,
                30.3179566
              ],
              [
                48.7034056,
                30.3180624
              ],
              [
                48.7033517,
                30.318105
              ],
              [
                48.7032414,
                30.3181811
              ],
              [
                48.7031158,
                30.3182708
              ],
              [
                48.7029845,
                30.318358
              ],
              [
                48.7029214,
                30.3184016
              ],
              [
                48.7028011,
                30.3184922
              ],
              [
                48.7026806,
                30.3185855
              ],
              [
                48.7026189,
                30.3186308
              ],
              [
                48.7024245,
                30.3187616
              ],
              [
                48.7023572,
                30.3188061
              ],
              [
                48.7021695,
                30.3189458
              ],
              [
                48.7020539,
                30.3190325
              ],
              [
                48.7019958,
                30.3190725
              ],
              [
                48.7018722,
                30.3191477
              ],
              [
                48.7017517,
                30.3192174
              ],
              [
                48.7016464,
                30.3192836
              ],
              [
                48.7015489,
                30.319353
              ],
              [
                48.7014489,
                30.3194297
              ],
              [
                48.7012895,
                30.3195463
              ],
              [
                48.7011831,
                30.3196238
              ],
              [
                48.7010806,
                30.3197044
              ],
              [
                48.7009847,
                30.31979
              ],
              [
                48.7008961,
                30.3198772
              ],
              [
                48.7008031,
                30.3199638
              ],
              [
                48.7007061,
                30.320043
              ],
              [
                48.7006156,
                30.3201169
              ],
              [
                48.7005311,
                30.3201897
              ],
              [
                48.7004472,
                30.3202597
              ],
              [
                48.7003589,
                30.3203272
              ],
              [
                48.7002631,
                30.3203922
              ],
              [
                48.7001703,
                30.3204624
              ],
              [
                48.7000872,
                30.320538
              ],
              [
                48.6999103,
                30.3206908
              ],
              [
                48.6998172,
                30.3207702
              ],
              [
                48.6996839,
                30.3209008
              ],
              [
                48.699597,
                30.3209872
              ],
              [
                48.6995133,
                30.321068
              ],
              [
                48.6994331,
                30.3211488
              ],
              [
                48.6993503,
                30.321228
              ],
              [
                48.6993089,
                30.3212638
              ],
              [
                48.6991806,
                30.3213583
              ],
              [
                48.698952,
                30.3215202
              ],
              [
                48.6987531,
                30.3216636
              ],
              [
                48.6986153,
                30.3217619
              ],
              [
                48.6985381,
                30.32182
              ],
              [
                48.6984167,
                30.3219305
              ],
              [
                48.6983611,
                30.3219819
              ],
              [
                48.6982403,
                30.3220772
              ],
              [
                48.6981845,
                30.3221019
              ],
              [
                48.6981586,
                30.3221238
              ],
              [
                48.6980836,
                30.3222013
              ],
              [
                48.6979658,
                30.3223124
              ],
              [
                48.6978881,
                30.3223811
              ],
              [
                48.6977739,
                30.3224708
              ],
              [
                48.6976958,
                30.3225375
              ],
              [
                48.6976228,
                30.3226094
              ],
              [
                48.69751,
                30.3227113
              ],
              [
                48.6974036,
                30.3228041
              ],
              [
                48.6972922,
                30.3228952
              ],
              [
                48.6971483,
                30.3230341
              ],
              [
                48.6970411,
                30.3231358
              ],
              [
                48.6969378,
                30.3232302
              ],
              [
                48.6968683,
                30.3233091
              ],
              [
                48.696795,
                30.3233844
              ],
              [
                48.6967229,
                30.3234523
              ],
              [
                48.6967192,
                30.3234558
              ],
              [
                48.6966092,
                30.3235516
              ],
              [
                48.6965706,
                30.3235836
              ],
              [
                48.69646,
                30.3236952
              ],
              [
                48.6963931,
                30.3237666
              ],
              [
                48.696252,
                30.3238988
              ],
              [
                48.6961458,
                30.3239958
              ],
              [
                48.6960411,
                30.3241077
              ],
              [
                48.6959439,
                30.3242141
              ],
              [
                48.6958811,
                30.3242786
              ],
              [
                48.695822,
                30.3243458
              ],
              [
                48.6957606,
                30.3244202
              ],
              [
                48.6956945,
                30.3244894
              ],
              [
                48.6956411,
                30.3245552
              ],
              [
                48.6955542,
                30.3246738
              ],
              [
                48.69546,
                30.3247966
              ],
              [
                48.6954103,
                30.324858
              ],
              [
                48.6953675,
                30.3249216
              ],
              [
                48.6953347,
                30.3249794
              ],
              [
                48.6952617,
                30.325073
              ],
              [
                48.6951109,
                30.3252736
              ],
              [
                48.6950847,
                30.3253216
              ],
              [
                48.6950397,
                30.3253819
              ],
              [
                48.6949678,
                30.3254994
              ],
              [
                48.6949214,
                30.3255816
              ],
              [
                48.6948761,
                30.3256569
              ],
              [
                48.6947842,
                30.3258458
              ],
              [
                48.6947447,
                30.3259308
              ],
              [
                48.6947036,
                30.3260105
              ],
              [
                48.6946608,
                30.3260877
              ],
              [
                48.6946008,
                30.3262088
              ],
              [
                48.694567,
                30.3262938
              ],
              [
                48.694492,
                30.3264447
              ],
              [
                48.6944492,
                30.3265202
              ],
              [
                48.6944042,
                30.3266113
              ],
              [
                48.6943308,
                30.3267377
              ],
              [
                48.6942783,
                30.3268144
              ],
              [
                48.6941953,
                30.3269788
              ],
              [
                48.694155,
                30.3270666
              ],
              [
                48.6941089,
                30.3271516
              ],
              [
                48.6940667,
                30.3272252
              ],
              [
                48.6940311,
                30.327313
              ],
              [
                48.693987,
                30.3274383
              ],
              [
                48.6939,
                30.3276683
              ],
              [
                48.6938689,
                30.3277491
              ],
              [
                48.6938022,
                30.3279011
              ],
              [
                48.6937664,
                30.3279716
              ],
              [
                48.6937153,
                30.3281172
              ],
              [
                48.6936517,
                30.3283486
              ],
              [
                48.6936483,
                30.3284527
              ],
              [
                48.693648,
                30.3284907
              ],
              [
                48.6936467,
                30.3286175
              ],
              [
                48.6936467,
                30.3286997
              ],
              [
                48.6936395,
                30.3287977
              ],
              [
                48.6936081,
                30.3289702
              ],
              [
                48.6935878,
                30.3290952
              ],
              [
                48.6935728,
                30.3292425
              ],
              [
                48.6935514,
                30.3294838
              ],
              [
                48.6935408,
                30.3295925
              ],
              [
                48.6935339,
                30.3296908
              ],
              [
                48.6935333,
                30.3299794
              ],
              [
                48.6935331,
                30.3301122
              ],
              [
                48.6935383,
                30.3303966
              ],
              [
                48.6935406,
                30.330523
              ],
              [
                48.6935531,
                30.3306638
              ],
              [
                48.6935639,
                30.3307455
              ],
              [
                48.6935697,
                30.3309747
              ],
              [
                48.6935717,
                30.3310661
              ],
              [
                48.6935847,
                30.3312791
              ],
              [
                48.6935939,
                30.3314111
              ],
              [
                48.693602,
                30.3316122
              ],
              [
                48.6936078,
                30.3317055
              ],
              [
                48.6936289,
                30.3318663
              ],
              [
                48.6936703,
                30.3320838
              ],
              [
                48.6936981,
                30.3322422
              ],
              [
                48.6937142,
                30.3323238
              ],
              [
                48.6937253,
                30.3324169
              ],
              [
                48.6937489,
                30.33257
              ],
              [
                48.6937783,
                30.3327166
              ],
              [
                48.6937911,
                30.332798
              ],
              [
                48.6938061,
                30.3328744
              ],
              [
                48.6938286,
                30.3329469
              ],
              [
                48.6938753,
                30.3330652
              ],
              [
                48.6939653,
                30.3332608
              ],
              [
                48.6939964,
                30.3333244
              ],
              [
                48.6940197,
                30.3333988
              ],
              [
                48.6940397,
                30.3334833
              ],
              [
                48.6940811,
                30.3336361
              ],
              [
                48.6941256,
                30.3337827
              ],
              [
                48.6941439,
                30.3338666
              ],
              [
                48.6941942,
                30.3340119
              ],
              [
                48.6942506,
                30.3341577
              ],
              [
                48.6942772,
                30.3342358
              ],
              [
                48.6943081,
                30.3343088
              ],
              [
                48.6943495,
                30.3344372
              ],
              [
                48.6943683,
                30.3345161
              ],
              [
                48.6944467,
                30.3347174
              ],
              [
                48.6944986,
                30.3348333
              ],
              [
                48.6945267,
                30.3349022
              ],
              [
                48.6945967,
                30.3350308
              ],
              [
                48.6946347,
                30.3350883
              ],
              [
                48.6946695,
                30.3351513
              ],
              [
                48.6947392,
                30.3353011
              ],
              [
                48.6947947,
                30.3354294
              ],
              [
                48.6948197,
                30.3354808
              ],
              [
                48.6948792,
                30.3356405
              ],
              [
                48.6949211,
                30.3357486
              ],
              [
                48.6949428,
                30.3358008
              ],
              [
                48.6949706,
                30.3358986
              ],
              [
                48.694985,
                30.3359608
              ],
              [
                48.6950242,
                30.3360786
              ],
              [
                48.6950642,
                30.3361788
              ],
              [
                48.6951028,
                30.3362905
              ],
              [
                48.6951245,
                30.3363569
              ],
              [
                48.6951506,
                30.336423
              ],
              [
                48.6951806,
                30.3364888
              ],
              [
                48.6952011,
                30.3365491
              ],
              [
                48.6952142,
                30.3366127
              ],
              [
                48.6952353,
                30.336688
              ],
              [
                48.695302,
                30.3368219
              ],
              [
                48.6953347,
                30.3368811
              ],
              [
                48.6953578,
                30.3369444
              ],
              [
                48.6953767,
                30.3370197
              ],
              [
                48.6953997,
                30.3370963
              ],
              [
                48.6954275,
                30.3371663
              ],
              [
                48.6954903,
                30.3373744
              ],
              [
                48.6955106,
                30.3374544
              ],
              [
                48.6955542,
                30.3375911
              ],
              [
                48.6956039,
                30.3377322
              ],
              [
                48.6956367,
                30.3378166
              ],
              [
                48.6956986,
                30.3379497
              ],
              [
                48.695725,
                30.338013
              ],
              [
                48.6957783,
                30.3381719
              ],
              [
                48.6958278,
                30.3383119
              ],
              [
                48.6958556,
                30.3383808
              ],
              [
                48.6959167,
                30.3386113
              ],
              [
                48.6959342,
                30.3386763
              ],
              [
                48.6959606,
                30.3388022
              ],
              [
                48.6959695,
                30.33887
              ],
              [
                48.695992,
                30.3389897
              ],
              [
                48.6959983,
                30.3390411
              ],
              [
                48.6960703,
                30.3392502
              ],
              [
                48.6961175,
                30.3393786
              ],
              [
                48.6961633,
                30.3395138
              ],
              [
                48.6962106,
                30.3396705
              ],
              [
                48.6962325,
                30.3397344
              ],
              [
                48.696255,
                30.3397894
              ],
              [
                48.6962798,
                30.3398672
              ],
              [
                48.6962945,
                30.3399132
              ],
              [
                48.6963203,
                30.3399941
              ],
              [
                48.6963778,
                30.3401811
              ],
              [
                48.6964186,
                30.340323
              ],
              [
                48.6964358,
                30.3403883
              ],
              [
                48.696477,
                30.340498
              ],
              [
                48.6965028,
                30.3405522
              ],
              [
                48.6965314,
                30.3406752
              ],
              [
                48.6965431,
                30.3407705
              ],
              [
                48.6965595,
                30.3408147
              ],
              [
                48.6965814,
                30.3408658
              ],
              [
                48.6966033,
                30.3409374
              ],
              [
                48.6966245,
                30.3410194
              ],
              [
                48.6966475,
                30.3410961
              ],
              [
                48.6966725,
                30.3411683
              ],
              [
                48.6967011,
                30.3412363
              ],
              [
                48.6967311,
                30.3413186
              ],
              [
                48.6967828,
                30.3414758
              ],
              [
                48.6968472,
                30.3416894
              ],
              [
                48.6968711,
                30.3417666
              ],
              [
                48.6969017,
                30.3419013
              ],
              [
                48.6969156,
                30.3420516
              ],
              [
                48.6969264,
                30.3421333
              ],
              [
                48.6969581,
                30.3422755
              ],
              [
                48.6969731,
                30.3423477
              ],
              [
                48.6970097,
                30.3425836
              ],
              [
                48.6970197,
                30.3426522
              ],
              [
                48.6970247,
                30.3427269
              ],
              [
                48.6970175,
                30.3428797
              ],
              [
                48.6969956,
                30.3430694
              ],
              [
                48.6969861,
                30.3431441
              ],
              [
                48.6969806,
                30.3433569
              ],
              [
                48.6969847,
                30.3435852
              ],
              [
                48.6969889,
                30.3438716
              ],
              [
                48.6969903,
                30.3439491
              ],
              [
                48.6969833,
                30.3441602
              ],
              [
                48.6969795,
                30.3442419
              ],
              [
                48.6969575,
                30.3443916
              ],
              [
                48.6969386,
                30.3444919
              ],
              [
                48.6969308,
                30.3445713
              ],
              [
                48.6969203,
                30.3446499
              ],
              [
                48.6968997,
                30.3447177
              ],
              [
                48.6968747,
                30.3447802
              ],
              [
                48.6968397,
                30.3449119
              ],
              [
                48.6968272,
                30.3449886
              ],
              [
                48.6968103,
                30.3450627
              ],
              [
                48.6967895,
                30.3451333
              ],
              [
                48.6967583,
                30.3452691
              ],
              [
                48.6967014,
                30.3455394
              ],
              [
                48.696687,
                30.3456019
              ],
              [
                48.6966628,
                30.3456736
              ],
              [
                48.6965833,
                30.3458583
              ],
              [
                48.6965595,
                30.3459152
              ],
              [
                48.6965047,
                30.3460211
              ],
              [
                48.6964906,
                30.3460727
              ],
              [
                48.696465,
                30.3461694
              ],
              [
                48.696402,
                30.3462755
              ],
              [
                48.69638,
                30.346378
              ],
              [
                48.6963725,
                30.346438
              ],
              [
                48.6963575,
                30.3464969
              ],
              [
                48.6963353,
                30.3465563
              ],
              [
                48.6963097,
                30.3466138
              ],
              [
                48.696262,
                30.3467497
              ],
              [
                48.69624,
                30.3468291
              ],
              [
                48.6961731,
                30.3469722
              ],
              [
                48.6960903,
                30.347133
              ],
              [
                48.696052,
                30.347213
              ],
              [
                48.6959964,
                30.3473522
              ],
              [
                48.695942,
                30.3474955
              ],
              [
                48.6959147,
                30.3475705
              ],
              [
                48.6958733,
                30.3477019
              ],
              [
                48.6958342,
                30.3478172
              ],
              [
                48.6957975,
                30.3479016
              ],
              [
                48.6957206,
                30.3480419
              ],
              [
                48.6956889,
                30.348103
              ],
              [
                48.6956414,
                30.3482255
              ],
              [
                48.6956031,
                30.3483061
              ],
              [
                48.6955595,
                30.348383
              ],
              [
                48.6955175,
                30.3484513
              ],
              [
                48.6954808,
                30.3485227
              ],
              [
                48.6954081,
                30.3486855
              ],
              [
                48.695372,
                30.3487577
              ],
              [
                48.695312,
                30.34889
              ],
              [
                48.6952353,
                30.349043
              ],
              [
                48.6952003,
                30.3491147
              ],
              [
                48.6951492,
                30.3492491
              ],
              [
                48.6951239,
                30.3493297
              ],
              [
                48.6950911,
                30.3494047
              ],
              [
                48.6950158,
                30.3495477
              ],
              [
                48.6949281,
                30.3497063
              ],
              [
                48.6948858,
                30.3497844
              ],
              [
                48.6948508,
                30.3498597
              ],
              [
                48.6947767,
                30.3500508
              ],
              [
                48.6947203,
                30.3502127
              ],
              [
                48.6946942,
                30.3502838
              ],
              [
                48.6946736,
                30.3503641
              ],
              [
                48.6946483,
                30.3504488
              ],
              [
                48.6946158,
                30.350525
              ],
              [
                48.6945797,
                30.3505988
              ],
              [
                48.6945364,
                30.3506669
              ],
              [
                48.6944911,
                30.3507513
              ],
              [
                48.6944545,
                30.3508377
              ],
              [
                48.6944412,
                30.3508758
              ],
              [
                48.6943986,
                30.3509977
              ],
              [
                48.6943503,
                30.3511227
              ],
              [
                48.6943117,
                30.3512069
              ],
              [
                48.6942725,
                30.3512861
              ],
              [
                48.6941856,
                30.3514222
              ],
              [
                48.6941295,
                30.3515038
              ],
              [
                48.6940797,
                30.3515852
              ],
              [
                48.6939997,
                30.3518144
              ],
              [
                48.6939739,
                30.3519016
              ],
              [
                48.6938647,
                30.3521744
              ],
              [
                48.693847,
                30.3522188
              ],
              [
                48.6938392,
                30.3522326
              ],
              [
                48.6938017,
                30.3522988
              ],
              [
                48.6936867,
                30.3524272
              ],
              [
                48.6936447,
                30.3524955
              ],
              [
                48.6936147,
                30.3525897
              ],
              [
                48.6935861,
                30.3526786
              ],
              [
                48.69355,
                30.3527638
              ],
              [
                48.6934853,
                30.3528783
              ],
              [
                48.6933933,
                30.3530533
              ],
              [
                48.6933483,
                30.353138
              ],
              [
                48.6932225,
                30.3533488
              ],
              [
                48.6931781,
                30.3534322
              ],
              [
                48.6931317,
                30.3535113
              ],
              [
                48.6930292,
                30.3536694
              ],
              [
                48.6929286,
                30.3538352
              ],
              [
                48.6927856,
                30.3540666
              ],
              [
                48.6927367,
                30.3541477
              ],
              [
                48.6926922,
                30.3542269
              ],
              [
                48.6926467,
                30.3543019
              ],
              [
                48.6925992,
                30.3543894
              ],
              [
                48.6925472,
                30.3544719
              ],
              [
                48.6924992,
                30.3545433
              ],
              [
                48.6924017,
                30.3547191
              ],
              [
                48.6923786,
                30.3547627
              ],
              [
                48.6922942,
                30.3548797
              ],
              [
                48.6922372,
                30.3549519
              ],
              [
                48.6921858,
                30.3550133
              ],
              [
                48.6921331,
                30.3550825
              ],
              [
                48.6920589,
                30.3551941
              ],
              [
                48.6920189,
                30.3552588
              ],
              [
                48.6919847,
                30.3553241
              ],
              [
                48.6919495,
                30.3553788
              ],
              [
                48.6918561,
                30.3554963
              ],
              [
                48.6918083,
                30.3555575
              ],
              [
                48.6917639,
                30.3556205
              ],
              [
                48.6917178,
                30.3556763
              ],
              [
                48.6916711,
                30.3557213
              ],
              [
                48.6915161,
                30.3559544
              ],
              [
                48.691472,
                30.3559983
              ],
              [
                48.6914211,
                30.3560394
              ],
              [
                48.6913839,
                30.3560769
              ],
              [
                48.6913445,
                30.3561294
              ],
              [
                48.6913031,
                30.3561952
              ],
              [
                48.6911864,
                30.3563622
              ],
              [
                48.6911239,
                30.3564502
              ],
              [
                48.6910833,
                30.356505
              ],
              [
                48.6909667,
                30.3567091
              ],
              [
                48.6908764,
                30.3568
              ],
              [
                48.6908411,
                30.3568519
              ],
              [
                48.6908208,
                30.3569005
              ],
              [
                48.6907667,
                30.3570008
              ],
              [
                48.6907399,
                30.3570397
              ],
              [
                48.6904456,
                30.3594753
              ],
              [
                48.6896291,
                30.3603854
              ],
              [
                48.6889867,
                30.361114
              ],
              [
                48.6881673,
                30.3620712
              ],
              [
                48.6874678,
                30.3628446
              ],
              [
                48.6867709,
                30.3635708
              ],
              [
                48.6861856,
                30.3642545
              ],
              [
                48.684887,
                30.3659475
              ],
              [
                48.6840049,
                30.3670439
              ],
              [
                48.6833656,
                30.3677688
              ],
              [
                48.6833624,
                30.3677724
              ],
              [
                48.6832483,
                30.3679268
              ],
              [
                48.6828886,
                30.3684138
              ],
              [
                48.6823088,
                30.3690032
              ],
              [
                48.681846,
                30.3694558
              ],
              [
                48.6806512,
                30.370302
              ],
              [
                48.679541,
                30.3706316
              ],
              [
                48.6782414,
                30.370995
              ],
              [
                48.677933,
                30.3710812
              ],
              [
                48.6776167,
                30.3710947
              ],
              [
                48.6768393,
                30.3711278
              ],
              [
                48.674796,
                30.3715583
              ],
              [
                48.6726549,
                30.3717952
              ],
              [
                48.6717651,
                30.3720872
              ],
              [
                48.6710011,
                30.3725047
              ],
              [
                48.6708988,
                30.37251
              ],
              [
                48.6708678,
                30.3725116
              ],
              [
                48.6708374,
                30.3725126
              ],
              [
                48.6707306,
                30.3725161
              ],
              [
                48.6705883,
                30.3725197
              ],
              [
                48.6705161,
                30.3725244
              ],
              [
                48.6704531,
                30.3725297
              ],
              [
                48.670447,
                30.3725302
              ],
              [
                48.670362,
                30.3725389
              ],
              [
                48.6702995,
                30.3725452
              ],
              [
                48.670294,
                30.372546
              ],
              [
                48.6702395,
                30.3725536
              ],
              [
                48.6702082,
                30.3725553
              ],
              [
                48.6700931,
                30.3725616
              ],
              [
                48.6699739,
                30.3725705
              ],
              [
                48.6699089,
                30.3725755
              ],
              [
                48.669737,
                30.3725972
              ],
              [
                48.669625,
                30.3726125
              ],
              [
                48.6695008,
                30.372625
              ],
              [
                48.6694548,
                30.3726282
              ],
              [
                48.6693758,
                30.3726338
              ],
              [
                48.6693491,
                30.3726364
              ],
              [
                48.6693158,
                30.3726397
              ],
              [
                48.6692778,
                30.3726425
              ],
              [
                48.6692406,
                30.3726452
              ],
              [
                48.6691664,
                30.3726563
              ],
              [
                48.6691437,
                30.3726601
              ],
              [
                48.6690158,
                30.3726811
              ],
              [
                48.6689538,
                30.3726922
              ],
              [
                48.6689403,
                30.3726947
              ],
              [
                48.6689248,
                30.3726982
              ],
              [
                48.6688314,
                30.3727194
              ],
              [
                48.6687756,
                30.3727272
              ],
              [
                48.6686289,
                30.3727536
              ],
              [
                48.6684825,
                30.3727727
              ],
              [
                48.6682533,
                30.3728119
              ],
              [
                48.6681934,
                30.372823
              ],
              [
                48.6681406,
                30.3728255
              ],
              [
                48.6680495,
                30.3728393
              ],
              [
                48.6680233,
                30.3728433
              ],
              [
                48.6679765,
                30.3728537
              ],
              [
                48.6678778,
                30.3728758
              ],
              [
                48.6677585,
                30.3729054
              ],
              [
                48.6677322,
                30.3729119
              ],
              [
                48.6677086,
                30.372918
              ],
              [
                48.6675928,
                30.372948
              ],
              [
                48.6675195,
                30.3729677
              ],
              [
                48.6673747,
                30.3730172
              ],
              [
                48.6673033,
                30.3730449
              ],
              [
                48.6671961,
                30.3730936
              ],
              [
                48.6671955,
                30.3730943
              ],
              [
                48.6671918,
                30.3730995
              ],
              [
                48.6671508,
                30.373155
              ],
              [
                48.6671486,
                30.3732016
              ],
              [
                48.6671739,
                30.3733138
              ],
              [
                48.6672045,
                30.3734408
              ],
              [
                48.6672165,
                30.373504
              ],
              [
                48.6672181,
                30.3735124
              ],
              [
                48.6672303,
                30.37365
              ],
              [
                48.6672145,
                30.3737133
              ],
              [
                48.6672094,
                30.3737237
              ],
              [
                48.6671856,
                30.3737722
              ],
              [
                48.6671493,
                30.3738257
              ],
              [
                48.6671464,
                30.37383
              ],
              [
                48.6671439,
                30.3738328
              ],
              [
                48.6671014,
                30.3738827
              ],
              [
                48.6668675,
                30.3740197
              ],
              [
                48.6668172,
                30.3740608
              ],
              [
                48.6667725,
                30.3741047
              ],
              [
                48.6667716,
                30.3741056
              ],
              [
                48.6667711,
                30.3741061
              ],
              [
                48.6667281,
                30.3741569
              ],
              [
                48.6666911,
                30.3742088
              ],
              [
                48.6666754,
                30.3742408
              ],
              [
                48.6666467,
                30.3742994
              ],
              [
                48.6666459,
                30.3743327
              ],
              [
                48.666645,
                30.3743672
              ],
              [
                48.6666547,
                30.3744122
              ],
              [
                48.6666906,
                30.3745138
              ],
              [
                48.6666988,
                30.3745403
              ],
              [
                48.6667075,
                30.3745686
              ],
              [
                48.666716,
                30.3746288
              ],
              [
                48.6667242,
                30.3746875
              ],
              [
                48.6667247,
                30.3746902
              ],
              [
                48.6666897,
                30.3747394
              ],
              [
                48.6666827,
                30.3747428
              ],
              [
                48.6666428,
                30.3747619
              ],
              [
                48.6666097,
                30.3747693
              ],
              [
                48.6665319,
                30.3747869
              ],
              [
                48.6664749,
                30.3747805
              ],
              [
                48.6664731,
                30.3747803
              ],
              [
                48.6664581,
                30.3747733
              ],
              [
                48.6664214,
                30.3747561
              ],
              [
                48.6663617,
                30.3747072
              ],
              [
                48.6663306,
                30.3746675
              ],
              [
                48.6663257,
                30.3746515
              ],
              [
                48.6663167,
                30.3746217
              ],
              [
                48.666322,
                30.3745808
              ],
              [
                48.6663233,
                30.3745706
              ],
              [
                48.6663269,
                30.3745641
              ],
              [
                48.6663511,
                30.3745197
              ],
              [
                48.6665036,
                30.3742703
              ],
              [
                48.6664936,
                30.3740172
              ],
              [
                48.6665042,
                30.3739706
              ],
              [
                48.6665466,
                30.3738842
              ],
              [
                48.6665558,
                30.3738653
              ],
              [
                48.6665643,
                30.3738579
              ],
              [
                48.6665967,
                30.3738294
              ],
              [
                48.66667,
                30.3738094
              ],
              [
                48.66679,
                30.3738111
              ],
              [
                48.666907,
                30.3738153
              ],
              [
                48.6669081,
                30.3738153
              ],
              [
                48.6669128,
                30.3738155
              ],
              [
                48.6669139,
                30.3738156
              ],
              [
                48.666914,
                30.3738155
              ],
              [
                48.6669667,
                30.3738078
              ],
              [
                48.6670117,
                30.3737808
              ],
              [
                48.6670403,
                30.3737337
              ],
              [
                48.6670406,
                30.3737333
              ],
              [
                48.6670553,
                30.3736781
              ],
              [
                48.6670555,
                30.3736723
              ],
              [
                48.6670578,
                30.3736197
              ],
              [
                48.6670589,
                30.3735687
              ],
              [
                48.6670592,
                30.3735589
              ],
              [
                48.6670568,
                30.3735253
              ],
              [
                48.6670549,
                30.3734986
              ],
              [
                48.6670547,
                30.3734964
              ],
              [
                48.6669867,
                30.3734149
              ],
              [
                48.6668694,
                30.3732742
              ],
              [
                48.6668551,
                30.3732728
              ],
              [
                48.6668086,
                30.3732683
              ],
              [
                48.6668079,
                30.3732683
              ],
              [
                48.6668075,
                30.3732683
              ],
              [
                48.6667522,
                30.3732674
              ],
              [
                48.6667242,
                30.3732669
              ],
              [
                48.6666958,
                30.3732678
              ],
              [
                48.6666511,
                30.3732691
              ],
              [
                48.6665431,
                30.3732922
              ],
              [
                48.666435,
                30.3733294
              ],
              [
                48.6662003,
                30.3734363
              ],
              [
                48.6661433,
                30.3734555
              ],
              [
                48.666025,
                30.373513
              ],
              [
                48.6657556,
                30.3736488
              ],
              [
                48.6656208,
                30.3737166
              ],
              [
                48.66549,
                30.373788
              ],
              [
                48.6653503,
                30.3738691
              ],
              [
                48.6652114,
                30.3739555
              ],
              [
                48.66515,
                30.3739983
              ],
              [
                48.6650886,
                30.3740366
              ],
              [
                48.6650222,
                30.3740733
              ],
              [
                48.66483,
                30.3742105
              ],
              [
                48.6647708,
                30.3742561
              ],
              [
                48.6646599,
                30.3743311
              ],
              [
                48.6646431,
                30.3743425
              ],
              [
                48.6646241,
                30.3743542
              ],
              [
                48.6645756,
                30.3743844
              ],
              [
                48.6645327,
                30.3744152
              ],
              [
                48.6645172,
                30.3744263
              ],
              [
                48.6645076,
                30.3744342
              ],
              [
                48.6644611,
                30.3744716
              ],
              [
                48.6643196,
                30.3746058
              ],
              [
                48.6643003,
                30.3746241
              ],
              [
                48.6642813,
                30.3746427
              ],
              [
                48.664245,
                30.3746783
              ],
              [
                48.6641867,
                30.3747263
              ],
              [
                48.6640228,
                30.3748769
              ],
              [
                48.6638814,
                30.3750127
              ],
              [
                48.6638578,
                30.3750355
              ],
              [
                48.6638067,
                30.3750855
              ],
              [
                48.6636547,
                30.3752483
              ],
              [
                48.663497,
                30.3754202
              ],
              [
                48.6634036,
                30.3755236
              ],
              [
                48.66331,
                30.375635
              ],
              [
                48.6632086,
                30.3757558
              ],
              [
                48.6631315,
                30.3758499
              ],
              [
                48.6631131,
                30.3758725
              ],
              [
                48.66311,
                30.3758761
              ],
              [
                48.6630617,
                30.3759338
              ],
              [
                48.6630095,
                30.3759899
              ],
              [
                48.6629661,
                30.376043
              ],
              [
                48.6629159,
                30.3761047
              ],
              [
                48.6628278,
                30.3762116
              ],
              [
                48.66281,
                30.3762363
              ],
              [
                48.6627486,
                30.3763213
              ],
              [
                48.6626714,
                30.3764355
              ],
              [
                48.6626689,
                30.3764395
              ],
              [
                48.6625981,
                30.376553
              ],
              [
                48.6625561,
                30.376618
              ],
              [
                48.6624625,
                30.3767416
              ],
              [
                48.6623886,
                30.3768436
              ],
              [
                48.6623822,
                30.3768522
              ],
              [
                48.6623503,
                30.3769005
              ],
              [
                48.6623275,
                30.3769525
              ],
              [
                48.6622906,
                30.3770077
              ],
              [
                48.6622033,
                30.3771225
              ],
              [
                48.6621128,
                30.3772366
              ],
              [
                48.6620172,
                30.3773522
              ],
              [
                48.6619258,
                30.3774708
              ],
              [
                48.6618817,
                30.3775322
              ],
              [
                48.6618,
                30.3776364
              ],
              [
                48.6617903,
                30.3776488
              ],
              [
                48.6617865,
                30.3776536
              ],
              [
                48.661742,
                30.3777094
              ],
              [
                48.6616064,
                30.3778927
              ],
              [
                48.6615189,
                30.3780091
              ],
              [
                48.6614662,
                30.378085
              ],
              [
                48.6614317,
                30.3781347
              ],
              [
                48.6613893,
                30.3781948
              ],
              [
                48.66134,
                30.3782647
              ],
              [
                48.6612414,
                30.3783891
              ],
              [
                48.66119,
                30.3784505
              ],
              [
                48.6611142,
                30.3785569
              ],
              [
                48.6610986,
                30.3785786
              ],
              [
                48.6610061,
                30.3787111
              ],
              [
                48.6609145,
                30.3788444
              ],
              [
                48.6608281,
                30.3789663
              ],
              [
                48.6607839,
                30.3790233
              ],
              [
                48.6606953,
                30.3791505
              ],
              [
                48.6606503,
                30.3792172
              ],
              [
                48.660607,
                30.379285
              ],
              [
                48.660592,
                30.3793086
              ],
              [
                48.6605245,
                30.3794147
              ],
              [
                48.6603836,
                30.3796299
              ],
              [
                48.6602897,
                30.3797702
              ],
              [
                48.6602467,
                30.3798422
              ],
              [
                48.6601875,
                30.3799319
              ],
              [
                48.6601558,
                30.37998
              ],
              [
                48.6600645,
                30.3801161
              ],
              [
                48.6599789,
                30.3802494
              ],
              [
                48.6598986,
                30.3803766
              ],
              [
                48.6598122,
                30.3805058
              ],
              [
                48.6597785,
                30.3805563
              ],
              [
                48.6597689,
                30.3805708
              ],
              [
                48.6597595,
                30.3805866
              ],
              [
                48.6597286,
                30.3806383
              ],
              [
                48.6596895,
                30.3807058
              ],
              [
                48.6596495,
                30.3807691
              ],
              [
                48.659572,
                30.3809036
              ],
              [
                48.6595267,
                30.3809747
              ],
              [
                48.6594564,
                30.3810743
              ],
              [
                48.6594289,
                30.3811133
              ],
              [
                48.6594003,
                30.3811529
              ],
              [
                48.6593364,
                30.3812413
              ],
              [
                48.6592677,
                30.381339
              ],
              [
                48.65925,
                30.3813641
              ],
              [
                48.659212,
                30.3814211
              ],
              [
                48.6592075,
                30.3814271
              ],
              [
                48.6591761,
                30.3814694
              ],
              [
                48.6591422,
                30.3815052
              ],
              [
                48.6590277,
                30.3816588
              ],
              [
                48.6590158,
                30.3816747
              ],
              [
                48.6589406,
                30.3817844
              ],
              [
                48.6589278,
                30.381802
              ],
              [
                48.6588595,
                30.3818966
              ],
              [
                48.6588153,
                30.3819544
              ],
              [
                48.658722,
                30.382065
              ],
              [
                48.6586447,
                30.3821597
              ],
              [
                48.6585739,
                30.3822683
              ],
              [
                48.6585067,
                30.3823752
              ],
              [
                48.6585036,
                30.38238
              ],
              [
                48.6584686,
                30.3824352
              ],
              [
                48.6583845,
                30.3825475
              ],
              [
                48.6582908,
                30.3826666
              ],
              [
                48.6581533,
                30.3828466
              ],
              [
                48.6580186,
                30.3830291
              ],
              [
                48.6579281,
                30.3831466
              ],
              [
                48.6578378,
                30.3832588
              ],
              [
                48.6577925,
                30.3833166
              ],
              [
                48.6577453,
                30.3833711
              ],
              [
                48.657655,
                30.383485
              ],
              [
                48.6576158,
                30.3835375
              ],
              [
                48.6575275,
                30.3836447
              ],
              [
                48.6574353,
                30.3837602
              ],
              [
                48.6573478,
                30.3838805
              ],
              [
                48.6572746,
                30.3839775
              ],
              [
                48.6572511,
                30.3840086
              ],
              [
                48.6572262,
                30.3840399
              ],
              [
                48.6572008,
                30.3840716
              ],
              [
                48.6571255,
                30.3841754
              ],
              [
                48.6571053,
                30.3842033
              ],
              [
                48.6570762,
                30.3842405
              ],
              [
                48.6570128,
                30.3843216
              ],
              [
                48.6569172,
                30.3844399
              ],
              [
                48.6568147,
                30.3845538
              ],
              [
                48.6567142,
                30.3846625
              ],
              [
                48.6566663,
                30.3847111
              ],
              [
                48.6566597,
                30.3847177
              ],
              [
                48.6566527,
                30.3847263
              ],
              [
                48.6566106,
                30.3847775
              ],
              [
                48.6565611,
                30.3848422
              ],
              [
                48.6564525,
                30.3849613
              ],
              [
                48.6563367,
                30.3850708
              ],
              [
                48.6562783,
                30.3851286
              ],
              [
                48.656222,
                30.3851927
              ],
              [
                48.6560322,
                30.3853774
              ],
              [
                48.6559192,
                30.3854822
              ],
              [
                48.6558992,
                30.3855008
              ],
              [
                48.6558863,
                30.3855134
              ],
              [
                48.655772,
                30.3856261
              ],
              [
                48.6556561,
                30.3857452
              ],
              [
                48.6555353,
                30.3858677
              ],
              [
                48.6554798,
                30.3859242
              ],
              [
                48.6554725,
                30.3859316
              ],
              [
                48.655416,
                30.3859809
              ],
              [
                48.6554072,
                30.3859886
              ],
              [
                48.6553908,
                30.3860041
              ],
              [
                48.6553514,
                30.3860808
              ],
              [
                48.6553512,
                30.3860822
              ],
              [
                48.6553487,
                30.3861038
              ],
              [
                48.6553461,
                30.3861258
              ],
              [
                48.6553253,
                30.3861758
              ],
              [
                48.6552678,
                30.3862555
              ],
              [
                48.6552156,
                30.3863223
              ],
              [
                48.655202,
                30.3863397
              ],
              [
                48.6551826,
                30.3863617
              ],
              [
                48.6551372,
                30.3864133
              ],
              [
                48.655055,
                30.3865097
              ],
              [
                48.655005,
                30.3865341
              ],
              [
                48.6549208,
                30.3866441
              ],
              [
                48.6548681,
                30.3866986
              ],
              [
                48.6547497,
                30.3868072
              ],
              [
                48.6546781,
                30.3868633
              ],
              [
                48.6546182,
                30.3869201
              ],
              [
                48.6546072,
                30.3869305
              ],
              [
                48.6545841,
                30.3869538
              ],
              [
                48.6545008,
                30.3870377
              ],
              [
                48.6543817,
                30.3871499
              ],
              [
                48.6542572,
                30.3872666
              ],
              [
                48.6541511,
                30.387361
              ],
              [
                48.654137,
                30.3873736
              ],
              [
                48.6541312,
                30.3873786
              ],
              [
                48.6540217,
                30.3874736
              ],
              [
                48.6539228,
                30.3875677
              ],
              [
                48.6539092,
                30.3875808
              ],
              [
                48.6538524,
                30.3876409
              ],
              [
                48.6537989,
                30.3876974
              ],
              [
                48.653768,
                30.3877282
              ],
              [
                48.6536814,
                30.3878141
              ],
              [
                48.65357,
                30.387928
              ],
              [
                48.6534567,
                30.3880422
              ],
              [
                48.6533372,
                30.3881613
              ],
              [
                48.6533089,
                30.3881909
              ],
              [
                48.6532147,
                30.3882891
              ],
              [
                48.6531948,
                30.388308
              ],
              [
                48.6531289,
                30.3883702
              ],
              [
                48.6530408,
                30.3884394
              ],
              [
                48.6529106,
                30.3885366
              ],
              [
                48.6527764,
                30.3886383
              ],
              [
                48.6527422,
                30.3886686
              ],
              [
                48.6526864,
                30.3887177
              ],
              [
                48.6525558,
                30.3888377
              ],
              [
                48.6524758,
                30.3889233
              ],
              [
                48.6523661,
                30.3890375
              ],
              [
                48.6523522,
                30.3890519
              ],
              [
                48.6522339,
                30.3891774
              ],
              [
                48.6522249,
                30.3891869
              ],
              [
                48.6521095,
                30.3893077
              ],
              [
                48.6520283,
                30.3893819
              ],
              [
                48.6519375,
                30.3894458
              ],
              [
                48.6518287,
                30.3895596
              ],
              [
                48.6518111,
                30.389578
              ],
              [
                48.6517681,
                30.3896335
              ],
              [
                48.6517389,
                30.3896713
              ],
              [
                48.6516547,
                30.3897822
              ],
              [
                48.6515695,
                30.3899025
              ],
              [
                48.6515122,
                30.3899941
              ],
              [
                48.651422,
                30.3901336
              ],
              [
                48.6513658,
                30.3902297
              ],
              [
                48.6513097,
                30.3903319
              ],
              [
                48.65123,
                30.3904836
              ],
              [
                48.6511521,
                30.3906392
              ],
              [
                48.6511514,
                30.3906405
              ],
              [
                48.6511491,
                30.390645
              ],
              [
                48.6510972,
                30.3907472
              ],
              [
                48.6510278,
                30.3909022
              ],
              [
                48.6509672,
                30.3910583
              ],
              [
                48.6509067,
                30.3912094
              ],
              [
                48.6508614,
                30.391315
              ],
              [
                48.6508397,
                30.3913683
              ],
              [
                48.6508,
                30.3914661
              ],
              [
                48.6507834,
                30.3915072
              ],
              [
                48.6507425,
                30.3916083
              ],
              [
                48.6507081,
                30.3917018
              ],
              [
                48.6506892,
                30.391753
              ],
              [
                48.6506768,
                30.3917851
              ],
              [
                48.6506378,
                30.3918858
              ],
              [
                48.6505971,
                30.3919808
              ],
              [
                48.6505792,
                30.3920227
              ],
              [
                48.650558,
                30.3920661
              ],
              [
                48.650512,
                30.3921605
              ],
              [
                48.6504752,
                30.392226
              ],
              [
                48.6504608,
                30.3922516
              ],
              [
                48.6504411,
                30.392287
              ],
              [
                48.6503822,
                30.3923927
              ],
              [
                48.6503058,
                30.3925297
              ],
              [
                48.6502427,
                30.3926525
              ],
              [
                48.6502425,
                30.3926527
              ],
              [
                48.6502111,
                30.392703
              ],
              [
                48.6501817,
                30.3927305
              ],
              [
                48.650137,
                30.3927988
              ],
              [
                48.650077,
                30.3928769
              ],
              [
                48.6499939,
                30.3929936
              ],
              [
                48.6499247,
                30.3930905
              ],
              [
                48.6498345,
                30.3932091
              ],
              [
                48.6497339,
                30.3933319
              ],
              [
                48.6496256,
                30.3934597
              ],
              [
                48.6495231,
                30.3935808
              ],
              [
                48.6494256,
                30.3936986
              ],
              [
                48.6493211,
                30.3938205
              ],
              [
                48.6492442,
                30.3939016
              ],
              [
                48.6491278,
                30.3940269
              ],
              [
                48.6490145,
                30.3941497
              ],
              [
                48.648897,
                30.394268
              ],
              [
                48.6487745,
                30.3943827
              ],
              [
                48.6486614,
                30.3944798
              ],
              [
                48.6486481,
                30.3944913
              ],
              [
                48.6486432,
                30.3944952
              ],
              [
                48.6485208,
                30.3945916
              ],
              [
                48.6484339,
                30.39465
              ],
              [
                48.6483392,
                30.3947041
              ],
              [
                48.6482011,
                30.3947797
              ],
              [
                48.6481103,
                30.3948416
              ],
              [
                48.648082,
                30.3948686
              ],
              [
                48.6479972,
                30.3949166
              ],
              [
                48.6478853,
                30.3949786
              ],
              [
                48.6478148,
                30.3950104
              ],
              [
                48.6477906,
                30.3950213
              ],
              [
                48.6476406,
                30.3950872
              ],
              [
                48.6475996,
                30.3951025
              ],
              [
                48.6475331,
                30.3951275
              ],
              [
                48.6473597,
                30.3951897
              ],
              [
                48.6472531,
                30.3952369
              ],
              [
                48.64709,
                30.3953069
              ],
              [
                48.6469289,
                30.3953694
              ],
              [
                48.6467789,
                30.3954327
              ],
              [
                48.6466108,
                30.3954977
              ],
              [
                48.6465443,
                30.3955252
              ],
              [
                48.6464517,
                30.3955636
              ],
              [
                48.6463867,
                30.3955893
              ],
              [
                48.6462814,
                30.3956311
              ],
              [
                48.6461064,
                30.3956969
              ],
              [
                48.6459392,
                30.3957549
              ],
              [
                48.6457845,
                30.3958016
              ],
              [
                48.6456086,
                30.3958397
              ],
              [
                48.6454878,
                30.3958643
              ],
              [
                48.6454639,
                30.3958691
              ],
              [
                48.6454367,
                30.3958758
              ],
              [
                48.6454363,
                30.3958758
              ],
              [
                48.6453383,
                30.39589
              ],
              [
                48.6452084,
                30.3959127
              ],
              [
                48.6451764,
                30.3959183
              ],
              [
                48.6450178,
                30.3959452
              ],
              [
                48.6449998,
                30.3959487
              ],
              [
                48.644847,
                30.3959777
              ],
              [
                48.6446792,
                30.396008
              ],
              [
                48.6445575,
                30.3960219
              ],
              [
                48.644382,
                30.3960372
              ],
              [
                48.6441972,
                30.3960577
              ],
              [
                48.6440145,
                30.3960722
              ],
              [
                48.6438889,
                30.3960738
              ],
              [
                48.6437486,
                30.396073
              ],
              [
                48.6436596,
                30.3960717
              ],
              [
                48.6436131,
                30.3960711
              ],
              [
                48.6435629,
                30.3960704
              ],
              [
                48.6434808,
                30.3960694
              ],
              [
                48.6433746,
                30.3960674
              ],
              [
                48.6433466,
                30.3960669
              ],
              [
                48.6433464,
                30.3960669
              ],
              [
                48.6433164,
                30.3960654
              ],
              [
                48.6433153,
                30.3960653
              ],
              [
                48.6431661,
                30.3960578
              ],
              [
                48.643165,
                30.3960577
              ],
              [
                48.6429744,
                30.3960494
              ],
              [
                48.6429733,
                30.3960494
              ],
              [
                48.642785,
                30.3960361
              ],
              [
                48.6425986,
                30.3960183
              ],
              [
                48.642407,
                30.396003
              ],
              [
                48.6422739,
                30.3959969
              ],
              [
                48.6422728,
                30.3959969
              ],
              [
                48.6421414,
                30.3959925
              ],
              [
                48.6421411,
                30.3959925
              ],
              [
                48.6421403,
                30.3959924
              ],
              [
                48.641952,
                30.395978
              ],
              [
                48.6418813,
                30.3959706
              ],
              [
                48.6418186,
                30.3959641
              ],
              [
                48.6417745,
                30.3959597
              ],
              [
                48.6416872,
                30.3959511
              ],
              [
                48.6414958,
                30.3959308
              ],
              [
                48.6413645,
                30.3959174
              ],
              [
                48.6411922,
                30.395898
              ],
              [
                48.6410247,
                30.3958777
              ],
              [
                48.6408514,
                30.3958602
              ],
              [
                48.640675,
                30.3958433
              ],
              [
                48.6404936,
                30.3958202
              ],
              [
                48.6403203,
                30.3957991
              ],
              [
                48.6401332,
                30.3957744
              ],
              [
                48.6401331,
                30.3957744
              ],
              [
                48.6400439,
                30.3957712
              ],
              [
                48.6400428,
                30.3957712
              ],
              [
                48.6400089,
                30.39577
              ],
              [
                48.6399328,
                30.3957691
              ],
              [
                48.6398161,
                30.3957678
              ],
              [
                48.6396998,
                30.3957644
              ],
              [
                48.6396256,
                30.3957622
              ],
              [
                48.6396251,
                30.3957622
              ],
              [
                48.6396245,
                30.3957622
              ],
              [
                48.6395165,
                30.395755
              ],
              [
                48.6394953,
                30.3957536
              ],
              [
                48.6393639,
                30.3957447
              ],
              [
                48.6391936,
                30.3957367
              ],
              [
                48.63901,
                30.3957344
              ],
              [
                48.6389558,
                30.3957335
              ],
              [
                48.6388444,
                30.3957317
              ],
              [
                48.6388435,
                30.3957316
              ],
              [
                48.6388433,
                30.3957316
              ],
              [
                48.638812,
                30.39573
              ],
              [
                48.6388109,
                30.39573
              ],
              [
                48.6387061,
                30.3957247
              ],
              [
                48.638705,
                30.3957247
              ],
              [
                48.6386039,
                30.3957136
              ],
              [
                48.6384837,
                30.3957042
              ],
              [
                48.6384439,
                30.3957011
              ],
              [
                48.6383546,
                30.3957005
              ],
              [
                48.6383311,
                30.3957003
              ],
              [
                48.6381978,
                30.3956994
              ],
              [
                48.6380594,
                30.3956983
              ],
              [
                48.6379644,
                30.3956977
              ],
              [
                48.6379269,
                30.3956975
              ],
              [
                48.6378528,
                30.3956966
              ],
              [
                48.6377353,
                30.3956953
              ],
              [
                48.6376019,
                30.3956928
              ],
              [
                48.6374475,
                30.3956889
              ],
              [
                48.6373081,
                30.3956917
              ],
              [
                48.6371606,
                30.3956914
              ],
              [
                48.6369831,
                30.3956903
              ],
              [
                48.6368373,
                30.3956892
              ],
              [
                48.6368256,
                30.3956892
              ],
              [
                48.6368037,
                30.395689
              ],
              [
                48.6366711,
                30.3956881
              ],
              [
                48.6364944,
                30.3956869
              ],
              [
                48.6363707,
                30.3956861
              ],
              [
                48.6363311,
                30.3956858
              ],
              [
                48.6362423,
                30.3956852
              ],
              [
                48.6361767,
                30.3956847
              ],
              [
                48.6360131,
                30.3956836
              ],
              [
                48.6358686,
                30.3956825
              ],
              [
                48.6358675,
                30.3956825
              ],
              [
                48.6356981,
                30.3956761
              ],
              [
                48.6356977,
                30.3956761
              ],
              [
                48.635697,
                30.3956761
              ],
              [
                48.6355689,
                30.3956684
              ],
              [
                48.6355356,
                30.3956663
              ],
              [
                48.6355082,
                30.3956629
              ],
              [
                48.6353975,
                30.3956488
              ],
              [
                48.6353164,
                30.3956323
              ],
              [
                48.6352953,
                30.395628
              ],
              [
                48.63526,
                30.3956206
              ],
              [
                48.635142,
                30.3955958
              ],
              [
                48.634992,
                30.3955625
              ],
              [
                48.6348778,
                30.3955436
              ],
              [
                48.6347214,
                30.3955233
              ],
              [
                48.6345631,
                30.3955083
              ],
              [
                48.6344147,
                30.3954847
              ],
              [
                48.6343716,
                30.3954697
              ],
              [
                48.6343458,
                30.3954608
              ],
              [
                48.6342705,
                30.3954257
              ],
              [
                48.63427,
                30.3954255
              ],
              [
                48.6341211,
                30.3953644
              ],
              [
                48.634017,
                30.3953297
              ],
              [
                48.6338681,
                30.3952869
              ],
              [
                48.6336928,
                30.395238
              ],
              [
                48.6335808,
                30.3951963
              ],
              [
                48.6334789,
                30.3951494
              ],
              [
                48.6334335,
                30.3951297
              ],
              [
                48.6333611,
                30.3950983
              ],
              [
                48.6332433,
                30.3950408
              ],
              [
                48.6331364,
                30.3949802
              ],
              [
                48.6330129,
                30.394914
              ],
              [
                48.6329836,
                30.3948983
              ],
              [
                48.6328697,
                30.3948469
              ],
              [
                48.6327192,
                30.3947711
              ],
              [
                48.6326242,
                30.3947175
              ],
              [
                48.6325145,
                30.3946611
              ],
              [
                48.6323597,
                30.3945852
              ],
              [
                48.632225,
                30.3945163
              ],
              [
                48.6321281,
                30.3944583
              ],
              [
                48.6320345,
                30.3943944
              ],
              [
                48.631947,
                30.3943205
              ],
              [
                48.631877,
                30.3942561
              ],
              [
                48.6318633,
                30.3942436
              ],
              [
                48.6318497,
                30.3942329
              ],
              [
                48.6317725,
                30.3941725
              ],
              [
                48.6316464,
                30.3940594
              ],
              [
                48.6315658,
                30.3939736
              ],
              [
                48.6314674,
                30.3938646
              ],
              [
                48.6314497,
                30.393845
              ],
              [
                48.6313345,
                30.3937225
              ],
              [
                48.6312723,
                30.3936426
              ],
              [
                48.6312631,
                30.3936308
              ],
              [
                48.6311886,
                30.3935336
              ],
              [
                48.6311103,
                30.3934436
              ],
              [
                48.6310289,
                30.3933533
              ],
              [
                48.6309462,
                30.3932577
              ],
              [
                48.6309436,
                30.3932547
              ],
              [
                48.6308642,
                30.393153
              ],
              [
                48.6308489,
                30.3931312
              ],
              [
                48.630795,
                30.3930544
              ],
              [
                48.6307225,
                30.3929486
              ],
              [
                48.6306433,
                30.3928377
              ],
              [
                48.6305672,
                30.3927355
              ],
              [
                48.6305398,
                30.3926925
              ],
              [
                48.6304997,
                30.3926297
              ],
              [
                48.6304482,
                30.3925354
              ],
              [
                48.6304358,
                30.3925127
              ],
              [
                48.6303725,
                30.3924063
              ],
              [
                48.6303369,
                30.3923453
              ],
              [
                48.6303133,
                30.392305
              ],
              [
                48.6302472,
                30.3921933
              ],
              [
                48.6301828,
                30.3920944
              ],
              [
                48.6301562,
                30.3920452
              ],
              [
                48.6301395,
                30.3920141
              ],
              [
                48.6301089,
                30.3919619
              ],
              [
                48.630078,
                30.3919388
              ],
              [
                48.6300758,
                30.3919372
              ],
              [
                48.630048,
                30.3918857
              ],
              [
                48.6300286,
                30.39185
              ],
              [
                48.6299711,
                30.3917616
              ],
              [
                48.6299491,
                30.3917236
              ],
              [
                48.6299131,
                30.3916613
              ],
              [
                48.6298942,
                30.3916208
              ],
              [
                48.6298725,
                30.3915741
              ],
              [
                48.6298411,
                30.3915018
              ],
              [
                48.6298047,
                30.391418
              ],
              [
                48.629737,
                30.3912661
              ],
              [
                48.629692,
                30.3911486
              ],
              [
                48.62965,
                30.3910308
              ],
              [
                48.629612,
                30.3909183
              ],
              [
                48.6296077,
                30.3909054
              ],
              [
                48.6295708,
                30.3907936
              ],
              [
                48.6295289,
                30.3906725
              ],
              [
                48.6295188,
                30.3906476
              ],
              [
                48.6294817,
                30.3905558
              ],
              [
                48.6294289,
                30.3904274
              ],
              [
                48.6294059,
                30.3903681
              ],
              [
                48.6293808,
                30.3903036
              ],
              [
                48.6293736,
                30.3902824
              ],
              [
                48.6293397,
                30.3901841
              ],
              [
                48.6293082,
                30.3900831
              ],
              [
                48.6292997,
                30.3900561
              ],
              [
                48.6292925,
                30.3900333
              ],
              [
                48.6292617,
                30.3899386
              ],
              [
                48.6292488,
                30.3898998
              ],
              [
                48.6292228,
                30.3898216
              ],
              [
                48.6291999,
                30.3897527
              ],
              [
                48.6291817,
                30.389698
              ],
              [
                48.6291397,
                30.3895847
              ],
              [
                48.6290867,
                30.3894498
              ],
              [
                48.62907,
                30.3894074
              ],
              [
                48.629046,
                30.3893501
              ],
              [
                48.6290213,
                30.3892913
              ],
              [
                48.6290211,
                30.3892908
              ],
              [
                48.6289778,
                30.3891808
              ],
              [
                48.628945,
                30.3890555
              ],
              [
                48.6289388,
                30.38902
              ],
              [
                48.6289231,
                30.3889299
              ],
              [
                48.6289031,
                30.3888125
              ],
              [
                48.6289011,
                30.3888
              ],
              [
                48.6288822,
                30.3886836
              ],
              [
                48.6288642,
                30.3885788
              ],
              [
                48.6288611,
                30.3885608
              ],
              [
                48.6288504,
                30.3885132
              ],
              [
                48.6288342,
                30.3884416
              ],
              [
                48.6288022,
                30.3883144
              ],
              [
                48.6287672,
                30.3881941
              ],
              [
                48.6287432,
                30.3881283
              ],
              [
                48.6287242,
                30.3880763
              ],
              [
                48.6287093,
                30.3880362
              ],
              [
                48.6286792,
                30.3879544
              ],
              [
                48.628633,
                30.3878474
              ],
              [
                48.6286324,
                30.3878458
              ],
              [
                48.6286322,
                30.3878455
              ],
              [
                48.628605,
                30.3877461
              ],
              [
                48.6285731,
                30.3876258
              ],
              [
                48.6285378,
                30.3874959
              ],
              [
                48.6285331,
                30.3874786
              ],
              [
                48.6285318,
                30.3874729
              ],
              [
                48.6285006,
                30.3873313
              ],
              [
                48.6284745,
                30.387213
              ],
              [
                48.6284617,
                30.3871387
              ],
              [
                48.6284536,
                30.3870919
              ],
              [
                48.6284449,
                30.3870356
              ],
              [
                48.6284328,
                30.3869569
              ],
              [
                48.6284097,
                30.3868247
              ],
              [
                48.6283881,
                30.3866855
              ],
              [
                48.6283869,
                30.3866788
              ],
              [
                48.6283622,
                30.3865347
              ],
              [
                48.6283429,
                30.3864334
              ],
              [
                48.6283345,
                30.3863894
              ],
              [
                48.62831,
                30.3862291
              ],
              [
                48.6282926,
                30.3861291
              ],
              [
                48.6282861,
                30.3860916
              ],
              [
                48.6282815,
                30.3860563
              ],
              [
                48.6282675,
                30.3859497
              ],
              [
                48.6282578,
                30.3858113
              ],
              [
                48.6282509,
                30.3856716
              ],
              [
                48.6282508,
                30.3856697
              ],
              [
                48.6282508,
                30.3856684
              ],
              [
                48.6282414,
                30.3855166
              ],
              [
                48.6282314,
                30.3853852
              ],
              [
                48.628218,
                30.3852919
              ],
              [
                48.6282164,
                30.3852808
              ],
              [
                48.6282006,
                30.3851519
              ],
              [
                48.6281806,
                30.3850447
              ],
              [
                48.6281556,
                30.3849055
              ],
              [
                48.6281281,
                30.3847436
              ],
              [
                48.6281075,
                30.3845775
              ],
              [
                48.6280978,
                30.3844563
              ],
              [
                48.6280928,
                30.3843433
              ],
              [
                48.628091,
                30.3842305
              ],
              [
                48.6280908,
                30.3842224
              ],
              [
                48.628087,
                30.3841025
              ],
              [
                48.6280833,
                30.3839327
              ],
              [
                48.6280819,
                30.3838967
              ],
              [
                48.6280786,
                30.3838111
              ],
              [
                48.6280727,
                30.383718
              ],
              [
                48.6280681,
                30.3836441
              ],
              [
                48.6280642,
                30.3835275
              ],
              [
                48.6280572,
                30.3834066
              ],
              [
                48.6280529,
                30.3833561
              ],
              [
                48.6280472,
                30.3832891
              ],
              [
                48.6280364,
                30.3831655
              ],
              [
                48.6280256,
                30.3830419
              ],
              [
                48.6280237,
                30.3830265
              ],
              [
                48.6280114,
                30.3829252
              ],
              [
                48.6279956,
                30.3827999
              ],
              [
                48.6279908,
                30.3827626
              ],
              [
                48.6279797,
                30.3826763
              ],
              [
                48.6279769,
                30.3826531
              ],
              [
                48.6279656,
                30.3825605
              ],
              [
                48.6279613,
                30.3824501
              ],
              [
                48.6279608,
                30.382438
              ],
              [
                48.6279639,
                30.382355
              ],
              [
                48.627965,
                30.3823233
              ],
              [
                48.6279756,
                30.3821563
              ],
              [
                48.6279836,
                30.382038
              ],
              [
                48.627989,
                30.3819605
              ],
              [
                48.6279917,
                30.3819225
              ],
              [
                48.627992,
                30.3819137
              ],
              [
                48.6279967,
                30.3818024
              ],
              [
                48.6280028,
                30.3816804
              ],
              [
                48.6280031,
                30.3816747
              ],
              [
                48.6280038,
                30.3816654
              ],
              [
                48.6280122,
                30.3815522
              ],
              [
                48.6280214,
                30.3814244
              ],
              [
                48.6280258,
                30.3813613
              ],
              [
                48.6280306,
                30.3812941
              ],
              [
                48.6280417,
                30.3811733
              ],
              [
                48.6280454,
                30.3811269
              ],
              [
                48.628052,
                30.3810455
              ],
              [
                48.6280592,
                30.3809205
              ],
              [
                48.6280747,
                30.3807552
              ],
              [
                48.6280797,
                30.3806906
              ],
              [
                48.6280836,
                30.3806397
              ],
              [
                48.6280983,
                30.3805118
              ],
              [
                48.6281022,
                30.380478
              ],
              [
                48.6281195,
                30.3803563
              ],
              [
                48.6281386,
                30.3802338
              ],
              [
                48.6281608,
                30.3801186
              ],
              [
                48.6281779,
                30.3800211
              ],
              [
                48.6281831,
                30.3799916
              ],
              [
                48.628189,
                30.3799557
              ],
              [
                48.6282031,
                30.3798699
              ],
              [
                48.628207,
                30.3798448
              ],
              [
                48.6282174,
                30.3797792
              ],
              [
                48.6282211,
                30.3797555
              ],
              [
                48.6282323,
                30.3796895
              ],
              [
                48.6282425,
                30.3796294
              ],
              [
                48.6282625,
                30.3795097
              ],
              [
                48.6282748,
                30.3794337
              ],
              [
                48.6282816,
                30.379392
              ],
              [
                48.6282817,
                30.3793913
              ],
              [
                48.6282842,
                30.3793796
              ],
              [
                48.6283089,
                30.3792647
              ],
              [
                48.628324,
                30.3792032
              ],
              [
                48.6283383,
                30.379145
              ],
              [
                48.6283664,
                30.3790261
              ],
              [
                48.6283997,
                30.3789036
              ],
              [
                48.6284408,
                30.3787933
              ],
              [
                48.628477,
                30.3786833
              ],
              [
                48.6285092,
                30.3785625
              ],
              [
                48.6285422,
                30.3784516
              ],
              [
                48.628597,
                30.3782866
              ],
              [
                48.6286301,
                30.3781831
              ],
              [
                48.6286331,
                30.3781738
              ],
              [
                48.6286346,
                30.3781685
              ],
              [
                48.6286797,
                30.3780141
              ],
              [
                48.6287058,
                30.3778969
              ],
              [
                48.6287472,
                30.3777347
              ],
              [
                48.6287775,
                30.3776219
              ],
              [
                48.6288106,
                30.3775019
              ],
              [
                48.6288662,
                30.3773046
              ],
              [
                48.6288697,
                30.3772919
              ],
              [
                48.6288726,
                30.3772814
              ],
              [
                48.6289103,
                30.3771436
              ],
              [
                48.628937,
                30.3770863
              ],
              [
                48.6289931,
                30.3769886
              ],
              [
                48.6290063,
                30.3769492
              ],
              [
                48.6290106,
                30.3769363
              ],
              [
                48.6290193,
                30.3769072
              ],
              [
                48.6290497,
                30.3768063
              ],
              [
                48.629086,
                30.3767194
              ],
              [
                48.6290867,
                30.3767177
              ],
              [
                48.6290902,
                30.3767084
              ],
              [
                48.6291278,
                30.3766077
              ],
              [
                48.6291772,
                30.3764697
              ],
              [
                48.6292192,
                30.376383
              ],
              [
                48.629262,
                30.3762827
              ],
              [
                48.6292817,
                30.3762366
              ],
              [
                48.62929,
                30.3762196
              ],
              [
                48.6293533,
                30.3760902
              ],
              [
                48.6294086,
                30.3759661
              ],
              [
                48.6294528,
                30.3758544
              ],
              [
                48.6295008,
                30.3757511
              ],
              [
                48.6295261,
                30.375713
              ],
              [
                48.6295545,
                30.3756418
              ],
              [
                48.6295558,
                30.3756386
              ],
              [
                48.6295576,
                30.3756352
              ],
              [
                48.6296031,
                30.3755466
              ],
              [
                48.6296692,
                30.3754366
              ],
              [
                48.6297414,
                30.375325
              ],
              [
                48.6298025,
                30.3752133
              ],
              [
                48.6298639,
                30.3750988
              ],
              [
                48.6299228,
                30.3750122
              ],
              [
                48.6299286,
                30.3750022
              ],
              [
                48.6305992,
                30.3738258
              ],
              [
                48.6306311,
                30.3737633
              ],
              [
                48.6306392,
                30.3737474
              ],
              [
                48.6307439,
                30.3735538
              ],
              [
                48.630757,
                30.3735297
              ],
              [
                48.6307602,
                30.3734917
              ],
              [
                48.6307653,
                30.3734322
              ],
              [
                48.6307506,
                30.3733651
              ],
              [
                48.6307131,
                30.3731938
              ],
              [
                48.6307053,
                30.3729883
              ],
              [
                48.6306422,
                30.3729036
              ],
              [
                48.630628,
                30.372894
              ],
              [
                48.63056,
                30.372848
              ],
              [
                48.6303128,
                30.3727772
              ],
              [
                48.6300254,
                30.3727675
              ],
              [
                48.6300243,
                30.3727675
              ],
              [
                48.6296789,
                30.3727558
              ],
              [
                48.6294259,
                30.3727607
              ],
              [
                48.6291676,
                30.3727657
              ],
              [
                48.6291259,
                30.3727665
              ],
              [
                48.6291177,
                30.3727667
              ],
              [
                48.6291172,
                30.3727667
              ],
              [
                48.6288292,
                30.3729369
              ],
              [
                48.6287314,
                30.37297
              ],
              [
                48.6283775,
                30.3730403
              ],
              [
                48.6280003,
                30.3731611
              ],
              [
                48.6274806,
                30.3733194
              ],
              [
                48.6270669,
                30.3734211
              ],
              [
                48.6265233,
                30.3735731
              ],
              [
                48.6261911,
                30.3736311
              ],
              [
                48.6256206,
                30.3737611
              ],
              [
                48.6250572,
                30.3739025
              ],
              [
                48.625,
                30.3739125
              ],
              [
                48.6245986,
                30.3739808
              ],
              [
                48.6243836,
                30.3740592
              ],
              [
                48.6240781,
                30.3741281
              ],
              [
                48.6239058,
                30.3741581
              ],
              [
                48.6238019,
                30.3743233
              ],
              [
                48.62372,
                30.3743817
              ],
              [
                48.6235192,
                30.3744389
              ],
              [
                48.6234719,
                30.3745253
              ],
              [
                48.6235269,
                30.3746019
              ],
              [
                48.6236179,
                30.3746631
              ],
              [
                48.6236931,
                30.3747136
              ],
              [
                48.6238965,
                30.3749038
              ],
              [
                48.624,
                30.3750006
              ],
              [
                48.6240153,
                30.3750147
              ],
              [
                48.6241372,
                30.3752908
              ],
              [
                48.6241028,
                30.3753883
              ],
              [
                48.6240486,
                30.3754733
              ],
              [
                48.6239739,
                30.3755425
              ],
              [
                48.6238387,
                30.3756378
              ],
              [
                48.6237931,
                30.37567
              ],
              [
                48.6237525,
                30.3757247
              ],
              [
                48.6237317,
                30.3757528
              ],
              [
                48.6237317,
                30.3757521
              ],
              [
                48.6237318,
                30.3757511
              ],
              [
                48.6237306,
                30.3757527
              ],
              [
                48.6237306,
                30.3757521
              ],
              [
                48.623737,
                30.3756458
              ],
              [
                48.6237908,
                30.3755566
              ],
              [
                48.6239314,
                30.3753872
              ],
              [
                48.6239675,
                30.375307
              ],
              [
                48.6239708,
                30.3752997
              ],
              [
                48.6239708,
                30.3752995
              ],
              [
                48.6239436,
                30.3752036
              ],
              [
                48.6238125,
                30.3750161
              ],
              [
                48.6237964,
                30.3750005
              ],
              [
                48.6236447,
                30.3748555
              ],
              [
                48.6235987,
                30.3748144
              ],
              [
                48.6234095,
                30.3746455
              ],
              [
                48.6233952,
                30.3746237
              ],
              [
                48.6233558,
                30.3745636
              ],
              [
                48.6233445,
                30.3744683
              ],
              [
                48.623405,
                30.374385
              ],
              [
                48.6234917,
                30.3743222
              ],
              [
                48.6235661,
                30.3743036
              ],
              [
                48.6236086,
                30.374293
              ],
              [
                48.6236758,
                30.3742513
              ],
              [
                48.623695,
                30.3742394
              ],
              [
                48.6236062,
                30.3741741
              ],
              [
                48.6236059,
                30.3741739
              ],
              [
                48.6234906,
                30.3741731
              ],
              [
                48.6232442,
                30.3742114
              ],
              [
                48.6227789,
                30.3742439
              ],
              [
                48.6222939,
                30.3742539
              ],
              [
                48.6216789,
                30.3742669
              ],
              [
                48.6211422,
                30.3742689
              ],
              [
                48.6206122,
                30.3742708
              ],
              [
                48.6200167,
                30.3742575
              ],
              [
                48.6200163,
                30.3742575
              ],
              [
                48.6200156,
                30.3742575
              ],
              [
                48.6195786,
                30.3742211
              ],
              [
                48.6190264,
                30.3741616
              ],
              [
                48.6187993,
                30.3741477
              ],
              [
                48.6185597,
                30.374133
              ],
              [
                48.6181181,
                30.3740791
              ],
              [
                48.6176828,
                30.3739947
              ],
              [
                48.6173572,
                30.3739613
              ],
              [
                48.6170092,
                30.3738909
              ],
              [
                48.6169181,
                30.3738725
              ],
              [
                48.6163339,
                30.3737575
              ],
              [
                48.616129,
                30.3737275
              ],
              [
                48.6158753,
                30.3736905
              ],
              [
                48.6157443,
                30.3736613
              ],
              [
                48.6154156,
                30.373588
              ],
              [
                48.6154145,
                30.3735877
              ],
              [
                48.6154146,
                30.3735904
              ],
              [
                48.6154183,
                30.3736841
              ],
              [
                48.615483,
                30.3737601
              ],
              [
                48.6154824,
                30.37376
              ],
              [
                48.6154039,
                30.3737483
              ],
              [
                48.6153708,
                30.3737433
              ],
              [
                48.6152956,
                30.3736539
              ],
              [
                48.6152794,
                30.3736124
              ],
              [
                48.6152597,
                30.3735617
              ],
              [
                48.615193,
                30.3735231
              ],
              [
                48.6151575,
                30.3735025
              ],
              [
                48.6149394,
                30.3734425
              ],
              [
                48.6145953,
                30.3733892
              ],
              [
                48.6144591,
                30.373363
              ],
              [
                48.6140608,
                30.3732864
              ],
              [
                48.6137103,
                30.3731928
              ],
              [
                48.6133842,
                30.3731269
              ],
              [
                48.6129072,
                30.3730539
              ],
              [
                48.6128392,
                30.3730433
              ],
              [
                48.6126867,
                30.3729622
              ],
              [
                48.6123664,
                30.3727917
              ],
              [
                48.6120272,
                30.3726533
              ],
              [
                48.6116881,
                30.3725439
              ],
              [
                48.6113864,
                30.3724111
              ],
              [
                48.6109822,
                30.3722075
              ],
              [
                48.6106563,
                30.3720303
              ],
              [
                48.6104739,
                30.3719311
              ],
              [
                48.6101511,
                30.3717944
              ],
              [
                48.6098232,
                30.3716106
              ],
              [
                48.6098211,
                30.3716094
              ],
              [
                48.6093489,
                30.3713694
              ],
              [
                48.6088969,
                30.3710903
              ],
              [
                48.6088962,
                30.3710904
              ],
              [
                48.6088958,
                30.3710902
              ],
              [
                48.6088028,
                30.3711072
              ],
              [
                48.60878,
                30.3711113
              ],
              [
                48.6087775,
                30.3711127
              ],
              [
                48.6086931,
                30.3711579
              ],
              [
                48.6086919,
                30.3711585
              ],
              [
                48.6086908,
                30.3711591
              ],
              [
                48.6086908,
                30.3711583
              ],
              [
                48.608695,
                30.3710652
              ],
              [
                48.6087301,
                30.3709751
              ],
              [
                48.6087303,
                30.3709747
              ],
              [
                48.608723,
                30.3709596
              ],
              [
                48.6086867,
                30.3708847
              ],
              [
                48.6085575,
                30.3707366
              ],
              [
                48.6084694,
                30.3706795
              ],
              [
                48.6083808,
                30.3706222
              ],
              [
                48.6082989,
                30.370518
              ],
              [
                48.6082461,
                30.3704511
              ],
              [
                48.6081861,
                30.3703949
              ],
              [
                48.6079906,
                30.3702119
              ],
              [
                48.6077933,
                30.36997
              ],
              [
                48.6077008,
                30.3698191
              ],
              [
                48.6076089,
                30.3696691
              ],
              [
                48.6074314,
                30.3692872
              ],
              [
                48.6073411,
                30.3690936
              ],
              [
                48.6073067,
                30.3688886
              ],
              [
                48.6071545,
                30.3683669
              ],
              [
                48.6071311,
                30.3680863
              ],
              [
                48.607135,
                30.3676866
              ],
              [
                48.6071686,
                30.3671825
              ],
              [
                48.6072331,
                30.3668927
              ],
              [
                48.607255,
                30.3668118
              ],
              [
                48.6072595,
                30.3667952
              ],
              [
                48.6072822,
                30.3667112
              ],
              [
                48.6073756,
                30.3663672
              ],
              [
                48.6074448,
                30.3661895
              ],
              [
                48.6074454,
                30.366188
              ],
              [
                48.607368,
                30.3661491
              ],
              [
                48.6073683,
                30.3661488
              ],
              [
                48.6076737,
                30.3657509
              ],
              [
                48.6080398,
                30.3649728
              ],
              [
                48.6083566,
                30.3642841
              ],
              [
                48.6087759,
                30.3636446
              ],
              [
                48.6097794,
                30.3622693
              ],
              [
                48.6112519,
                30.3608936
              ],
              [
                48.6126747,
                30.3594718
              ],
              [
                48.6137811,
                30.3584186
              ],
              [
                48.6143073,
                30.3577765
              ],
              [
                48.6146775,
                30.3571361
              ],
              [
                48.6147806,
                30.3565855
              ],
              [
                48.6147269,
                30.3562643
              ],
              [
                48.6144636,
                30.3560362
              ],
              [
                48.613884,
                30.355852
              ],
              [
                48.6129836,
                30.3556687
              ],
              [
                48.6106111,
                30.355578
              ],
              [
                48.6088141,
                30.355624
              ],
              [
                48.6081812,
                30.3556688
              ],
              [
                48.6069184,
                30.3560809
              ],
              [
                48.6059152,
                30.3564481
              ],
              [
                48.6048087,
                30.3567706
              ],
              [
                48.6032258,
                30.3572738
              ],
              [
                48.6020126,
                30.3576394
              ],
              [
                48.600643,
                30.3582344
              ],
              [
                48.5997467,
                30.3587862
              ],
              [
                48.5989533,
                30.3591054
              ],
              [
                48.5981103,
                30.3595634
              ],
              [
                48.5974771,
                30.3598833
              ],
              [
                48.5952646,
                30.3606634
              ],
              [
                48.5943146,
                30.3611217
              ],
              [
                48.5935744,
                30.3615343
              ],
              [
                48.5925218,
                30.3622681
              ],
              [
                48.5916252,
                30.3630927
              ],
              [
                48.5905724,
                30.3642843
              ],
              [
                48.5897294,
                30.3650174
              ],
              [
                48.5895195,
                30.3655683
              ],
              [
                48.5893631,
                30.3659803
              ],
              [
                48.5890998,
                30.3669879
              ],
              [
                48.588997,
                30.3683165
              ],
              [
                48.5889436,
                30.3693258
              ],
              [
                48.589264,
                30.3699654
              ],
              [
                48.5896339,
                30.3702879
              ],
              [
                48.5899506,
                30.3704268
              ],
              [
                48.5902137,
                30.3705173
              ],
              [
                48.5907401,
                30.3704729
              ],
              [
                48.5913736,
                30.370426
              ],
              [
                48.5916365,
                30.3703339
              ],
              [
                48.5920068,
                30.370149
              ],
              [
                48.59243,
                30.3701501
              ],
              [
                48.59243,
                30.3702425
              ],
              [
                48.5921669,
                30.3703797
              ],
              [
                48.5915337,
                30.3706545
              ],
              [
                48.591324,
                30.3708829
              ],
              [
                48.5910568,
                30.3709749
              ],
              [
                48.5905303,
                30.3710216
              ],
              [
                48.5902673,
                30.3710212
              ],
              [
                48.5897902,
                30.3708839
              ],
              [
                48.589737,
                30.3707476
              ],
              [
                48.5894737,
                30.3706548
              ],
              [
                48.5893709,
                30.3708829
              ],
              [
                48.5893706,
                30.371158
              ],
              [
                48.5895271,
                30.3714338
              ],
              [
                48.5895805,
                30.3717076
              ],
              [
                48.589531,
                30.3719367
              ],
              [
                48.589424,
                30.3721219
              ],
              [
                48.5890044,
                30.372396
              ],
              [
                48.5887909,
                30.3726717
              ],
              [
                48.5885849,
                30.3741382
              ],
              [
                48.5881652,
                30.3767035
              ],
              [
                48.5879553,
                30.3778496
              ],
              [
                48.5875893,
                30.378905
              ],
              [
                48.5865364,
                30.3803694
              ],
              [
                48.585533,
                30.3814693
              ],
              [
                48.5844802,
                30.3825706
              ],
              [
                48.5826873,
                30.3840821
              ],
              [
                48.5821608,
                30.3844941
              ],
              [
                48.5815811,
                30.3849975
              ],
              [
                48.5813178,
                30.3853647
              ],
              [
                48.5812644,
                30.3857764
              ],
              [
                48.5803186,
                30.386052
              ],
              [
                48.5801048,
                30.3860999
              ],
              [
                48.578945,
                30.3875645
              ],
              [
                48.5779991,
                30.3884354
              ],
              [
                48.5772629,
                30.3897184
              ],
              [
                48.5764198,
                30.3911392
              ],
              [
                48.57621,
                30.3918276
              ],
              [
                48.5755232,
                30.3925139
              ],
              [
                48.5744171,
                30.393339
              ],
              [
                48.5730973,
                30.3940248
              ],
              [
                48.5718308,
                30.3944838
              ],
              [
                48.5707778,
                30.3948047
              ],
              [
                48.5687179,
                30.3952625
              ],
              [
                48.5670814,
                30.3955364
              ],
              [
                48.5661851,
                30.3956731
              ],
              [
                48.564602,
                30.3956278
              ],
              [
                48.5628091,
                30.3956281
              ],
              [
                48.5608025,
                30.3957192
              ],
              [
                48.5591126,
                30.3957192
              ],
              [
                48.5577392,
                30.3955356
              ],
              [
                48.5564195,
                30.3953982
              ],
              [
                48.5552598,
                30.3953517
              ],
              [
                48.5545196,
                30.3952138
              ],
              [
                48.5536232,
                30.3950301
              ],
              [
                48.5523567,
                30.3948485
              ],
              [
                48.5503501,
                30.394847
              ],
              [
                48.5485534,
                30.3949846
              ],
              [
                48.5464972,
                30.3954895
              ],
              [
                48.5443878,
                30.396221
              ],
              [
                48.5431215,
                30.3968624
              ],
              [
                48.542225,
                30.3973664
              ],
              [
                48.5410651,
                30.3980549
              ],
              [
                48.5403785,
                30.3983735
              ],
              [
                48.5395851,
                30.3985569
              ],
              [
                48.5386787,
                30.399184
              ],
              [
                48.5384788,
                30.3994268
              ],
              [
                48.5377923,
                30.3998423
              ],
              [
                48.5372657,
                30.4001616
              ],
              [
                48.5347862,
                30.4019481
              ],
              [
                48.532997,
                30.4035514
              ],
              [
                48.531414,
                30.4049715
              ],
              [
                48.5305709,
                30.405614
              ],
              [
                48.529991,
                30.4058871
              ],
              [
                48.5291441,
                30.4060718
              ],
              [
                48.5288277,
                30.4060703
              ],
              [
                48.5284043,
                30.4058413
              ],
              [
                48.5276145,
                30.405567
              ],
              [
                48.5268746,
                30.4052463
              ],
              [
                48.5266114,
                30.4052007
              ],
              [
                48.526558,
                30.404972
              ],
              [
                48.5265578,
                30.404512
              ],
              [
                48.5263977,
                30.4039632
              ],
              [
                48.5261308,
                30.4030449
              ],
              [
                48.5259744,
                30.4020385
              ],
              [
                48.5259171,
                30.4000688
              ],
              [
                48.5262872,
                30.3994737
              ],
              [
                48.5275498,
                30.397272
              ],
              [
                48.5280227,
                30.3961286
              ],
              [
                48.5280227,
                30.3958062
              ],
              [
                48.5279693,
                30.3952549
              ],
              [
                48.5275992,
                30.3949345
              ],
              [
                48.5270194,
                30.3942944
              ],
              [
                48.5265961,
                30.3939278
              ],
              [
                48.5259093,
                30.3934683
              ],
              [
                48.5253295,
                30.3933784
              ],
              [
                48.5245896,
                30.3931028
              ],
              [
                48.5237466,
                30.392965
              ],
              [
                48.5232162,
                30.3929662
              ],
              [
                48.5228463,
                30.3932411
              ],
              [
                48.5226898,
                30.393423
              ],
              [
                48.5225335,
                30.3937425
              ],
              [
                48.5222664,
                30.3941095
              ],
              [
                48.5218467,
                30.3941106
              ],
              [
                48.5216865,
                30.3940173
              ],
              [
                48.52174,
                30.3939259
              ],
              [
                48.5219497,
                30.3936052
              ],
              [
                48.5220567,
                30.3932847
              ],
              [
                48.5220566,
                30.3928743
              ],
              [
                48.5220565,
                30.3925068
              ],
              [
                48.5217896,
                30.3923687
              ],
              [
                48.5209999,
                30.3916817
              ],
              [
                48.5205764,
                30.3912249
              ],
              [
                48.5196228,
                30.390307
              ],
              [
                48.5189896,
                30.3895283
              ],
              [
                48.5180932,
                30.388474
              ],
              [
                48.5169295,
                30.387374
              ],
              [
                48.5162429,
                30.3865942
              ],
              [
                48.5149726,
                30.385632
              ],
              [
                48.5136528,
                30.3845786
              ],
              [
                48.5127564,
                30.3841196
              ],
              [
                48.5121231,
                30.3836159
              ],
              [
                48.5116463,
                30.3833858
              ],
              [
                48.5112762,
                30.3829751
              ],
              [
                48.5110665,
                30.3827456
              ],
              [
                48.5109596,
                30.3824234
              ],
              [
                48.5108528,
                30.3819208
              ],
              [
                48.5108529,
                30.3811879
              ],
              [
                48.5107995,
                30.3805893
              ],
              [
                48.510746,
                30.3798577
              ],
              [
                48.5106392,
                30.3795377
              ],
              [
                48.5103225,
                30.3787109
              ],
              [
                48.5105858,
                30.3782987
              ],
              [
                48.5109024,
                30.3783453
              ],
              [
                48.5111657,
                30.3783909
              ],
              [
                48.5115356,
                30.3784363
              ],
              [
                48.5119056,
                30.3783464
              ],
              [
                48.5125006,
                30.3782158
              ],
              [
                48.512539,
                30.3782074
              ],
              [
                48.5129586,
                30.3777035
              ],
              [
                48.5138054,
                30.377431
              ],
              [
                48.5148048,
                30.3769719
              ],
              [
                48.5178108,
                30.3751845
              ],
              [
                48.5189209,
                30.3746825
              ],
              [
                48.5198707,
                30.3744074
              ],
              [
                48.5208205,
                30.3742247
              ],
              [
                48.5220337,
                30.3738554
              ],
              [
                48.5231399,
                30.3735359
              ],
              [
                48.5239333,
                30.3733074
              ],
              [
                48.5247765,
                30.3730775
              ],
              [
                48.5253563,
                30.3725744
              ],
              [
                48.5255661,
                30.3722086
              ],
              [
                48.5255661,
                30.3717959
              ],
              [
                48.525303,
                30.3713354
              ],
              [
                48.524826,
                30.3707874
              ],
              [
                48.5241929,
                30.3703289
              ],
              [
                48.5231895,
                30.3696853
              ],
              [
                48.5225029,
                30.3694107
              ],
              [
                48.5220794,
                30.369229
              ],
              [
                48.5210228,
                30.3689992
              ],
              [
                48.520443,
                30.368862
              ],
              [
                48.5200729,
                30.3687715
              ],
              [
                48.5187531,
                30.3687712
              ],
              [
                48.5170135,
                30.3688171
              ],
              [
                48.5161171,
                30.3691834
              ],
              [
                48.515377,
                30.3694106
              ],
              [
                48.5147438,
                30.3698225
              ],
              [
                48.5138473,
                30.3702361
              ],
              [
                48.5132141,
                30.3705556
              ],
              [
                48.5127411,
                30.3708758
              ],
              [
                48.5121612,
                30.3710158
              ],
              [
                48.5117377,
                30.3711994
              ],
              [
                48.5108161,
                30.3712911
              ],
              [
                48.5099775,
                30.3714628
              ],
              [
                48.5092584,
                30.3716099
              ],
              [
                48.5081519,
                30.3716114
              ],
              [
                48.5072211,
                30.3716104
              ],
              [
                48.5072208,
                30.3716104
              ],
              [
                48.506569,
                30.3716105
              ],
              [
                48.5057755,
                30.3716111
              ],
              [
                48.5049325,
                30.3717484
              ],
              [
                48.5041389,
                30.3716543
              ],
              [
                48.5027656,
                30.3716551
              ],
              [
                48.502346,
                30.3715163
              ],
              [
                48.499984,
                30.3710787
              ],
              [
                48.4952621,
                30.3705959
              ],
              [
                48.4952297,
                30.3705975
              ],
              [
                48.4936143,
                30.3707424
              ],
              [
                48.4910775,
                30.3711086
              ],
              [
                48.4879608,
                30.3716102
              ],
              [
                48.4854774,
                30.3719751
              ],
              [
                48.4821472,
                30.372752
              ],
              [
                48.4799271,
                30.37307
              ],
              [
                48.4782372,
                30.3732967
              ],
              [
                48.4761239,
                30.3736166
              ],
              [
                48.4736938,
                30.3743025
              ],
              [
                48.4706306,
                30.3754451
              ],
              [
                48.4674607,
                30.3765856
              ],
              [
                48.4648209,
                30.3777723
              ],
              [
                48.4622841,
                30.3788234
              ],
              [
                48.4585343,
                30.3802861
              ],
              [
                48.4549941,
                30.3820234
              ],
              [
                48.4528847,
                30.3829383
              ],
              [
                48.4509811,
                30.3839429
              ],
              [
                48.4493981,
                30.3847193
              ],
              [
                48.4492416,
                30.3849936
              ],
              [
                48.448288,
                30.3854507
              ],
              [
                48.4468651,
                30.386503
              ],
              [
                48.4459151,
                30.3876006
              ],
              [
                48.4441757,
                30.3894292
              ],
              [
                48.4427528,
                30.3913495
              ],
              [
                48.4414864,
                30.3931332
              ],
              [
                48.4402771,
                30.3951457
              ],
              [
                48.4392776,
                30.3969751
              ],
              [
                48.4382248,
                30.3988485
              ],
              [
                48.4370117,
                30.4007234
              ],
              [
                48.4355889,
                30.4025535
              ],
              [
                48.4342728,
                30.4041985
              ],
              [
                48.4328499,
                30.4059361
              ],
              [
                48.4327831,
                30.4060238
              ],
              [
                48.4312133,
                30.4080866
              ],
              [
                48.4294777,
                30.411198
              ],
              [
                48.4277382,
                30.4142146
              ],
              [
                48.4264755,
                30.4165484
              ],
              [
                48.4251061,
                30.4193851
              ],
              [
                48.4237404,
                30.4225871
              ],
              [
                48.4224777,
                30.4253289
              ],
              [
                48.421112,
                30.4297666
              ],
              [
                48.4197829,
                30.4333945
              ],
              [
                48.4183807,
                30.4372213
              ],
              [
                48.4166985,
                30.4415219
              ],
              [
                48.4137536,
                30.4492045
              ],
              [
                48.4119683,
                30.4538276
              ],
              [
                48.410389,
                30.457943
              ],
              [
                48.4090233,
                30.4613726
              ],
              [
                48.4080772,
                30.4646211
              ],
              [
                48.407341,
                30.4671815
              ],
              [
                48.4061318,
                30.4695137
              ],
              [
                48.4056588,
                30.4710264
              ],
              [
                48.4044457,
                30.4723506
              ],
              [
                48.4034424,
                30.4735415
              ],
              [
                48.4023322,
                30.4748678
              ],
              [
                48.4010696,
                30.4768787
              ],
              [
                48.4002761,
                30.4780693
              ],
              [
                48.39954,
                30.4798066
              ],
              [
                48.3985939,
                30.4827348
              ],
              [
                48.3974914,
                30.4860748
              ],
              [
                48.3965988,
                30.4889116
              ],
              [
                48.3956528,
                30.4920224
              ],
              [
                48.3944968,
                30.4963218
              ],
              [
                48.3935547,
                30.5000731
              ],
              [
                48.3917695,
                30.5035278
              ],
              [
                48.3910374,
                30.5054401
              ],
              [
                48.3897472,
                30.5045667
              ],
              [
                48.3883609,
                30.5040162
              ],
              [
                48.3830806,
                30.5040161
              ],
              [
                48.3825275,
                30.5040161
              ],
              [
                48.3819709,
                30.5042959
              ],
              [
                48.3816944,
                30.5040161
              ],
              [
                48.3783611,
                30.5040161
              ],
              [
                48.378081,
                30.5037364
              ],
              [
                48.3689144,
                30.5031859
              ],
              [
                48.3686379,
                30.5034656
              ],
              [
                48.3636377,
                30.5034657
              ],
              [
                48.3630811,
                30.5031859
              ],
              [
                48.3622478,
                30.5031859
              ],
              [
                48.3611377,
                30.5029062
              ],
              [
                48.3600244,
                30.5029062
              ],
              [
                48.3591912,
                30.5026264
              ],
              [
                48.3575244,
                30.5026264
              ],
              [
                48.3572478,
                30.5023466
              ],
              [
                48.3564146,
                30.5023466
              ],
              [
                48.3414147,
                30.4962374
              ],
              [
                48.340858,
                30.4956869
              ],
              [
                48.3400249,
                30.4956869
              ],
              [
                48.3378014,
                30.4948477
              ],
              [
                48.3366915,
                30.4948477
              ],
              [
                48.3336349,
                30.4940175
              ],
              [
                48.3325251,
                30.4940174
              ],
              [
                48.3241917,
                30.4917885
              ],
              [
                48.3205784,
                30.4909582
              ],
              [
                48.3203018,
                30.4906876
              ],
              [
                48.3091888,
                30.4853995
              ],
              [
                48.2816891,
                30.4517945
              ],
              [
                48.2811325,
                30.4512351
              ],
              [
                48.2811325,
                30.4509554
              ],
              [
                48.2691894,
                30.4279087
              ],
              [
                48.2677995,
                30.4226298
              ],
              [
                48.2672428,
                30.4181813
              ],
              [
                48.2672429,
                30.415402
              ],
              [
                48.2672428,
                30.4117926
              ],
              [
                48.2675229,
                30.4106827
              ],
              [
                48.2677995,
                30.4087336
              ],
              [
                48.2680761,
                30.4070643
              ],
              [
                48.2683562,
                30.4048445
              ],
              [
                48.2686328,
                30.4034548
              ],
              [
                48.2693316,
                30.3997099
              ],
              [
                48.2686948,
                30.39986
              ],
              [
                48.2627739,
                30.4029152
              ],
              [
                48.2595062,
                30.3997889
              ],
              [
                48.2557297,
                30.4026205
              ],
              [
                48.2512021,
                30.4003442
              ],
              [
                48.2450198,
                30.4070642
              ],
              [
                48.2444663,
                30.4070642
              ],
              [
                48.2444663,
                30.407344
              ],
              [
                48.2433529,
                30.4073439
              ],
              [
                48.2430764,
                30.4076236
              ],
              [
                48.2416866,
                30.4076236
              ],
              [
                48.2414099,
                30.4073439
              ],
              [
                48.2402998,
                30.4073439
              ],
              [
                48.2400197,
                30.4070642
              ],
              [
                48.2319633,
                30.4045646
              ],
              [
                48.2277969,
                30.4023448
              ],
              [
                48.2264101,
                30.4020742
              ],
              [
                48.2258535,
                30.4020741
              ],
              [
                48.2125204,
                30.3948463
              ],
              [
                48.2122403,
                30.3942869
              ],
              [
                48.201407,
                30.3815097
              ],
              [
                48.201407,
                30.3806796
              ],
              [
                48.2011304,
                30.3798494
              ],
              [
                48.2008503,
                30.3787395
              ],
              [
                48.2005737,
                30.3756805
              ],
              [
                48.2011305,
                30.3745707
              ],
              [
                48.2048663,
                30.3713675
              ],
              [
                48.2116262,
                30.3668442
              ],
              [
                48.214517,
                30.3652008
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554863,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آغاجاری",
          "name:en": "Aghajari County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5868899",
          "wikipedia": "en:Aghajari County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.816319,
                30.7210226
              ],
              [
                49.8155823,
                30.7206008
              ],
              [
                49.8107111,
                30.7175201
              ],
              [
                49.8044015,
                30.7135193
              ],
              [
                49.8003386,
                30.7109915
              ],
              [
                49.7938195,
                30.706201
              ],
              [
                49.7908287,
                30.7040393
              ],
              [
                49.7905084,
                30.7034837
              ],
              [
                49.790348,
                30.7027897
              ],
              [
                49.7902909,
                30.7013523
              ],
              [
                49.7903862,
                30.6977374
              ],
              [
                49.7901,
                30.6901827
              ],
              [
                49.7899743,
                30.6832318
              ],
              [
                49.7898027,
                30.6791565
              ],
              [
                49.789585,
                30.6773025
              ],
              [
                49.7897948,
                30.6766503
              ],
              [
                49.7902184,
                30.675955
              ],
              [
                49.7909624,
                30.675071
              ],
              [
                49.792179,
                30.6737695
              ],
              [
                49.7938804,
                30.6726484
              ],
              [
                49.7942378,
                30.6724282
              ],
              [
                49.7960015,
                30.6713417
              ],
              [
                49.7987098,
                30.6704036
              ],
              [
                49.8017349,
                30.6690015
              ],
              [
                49.8058167,
                30.666436
              ],
              [
                49.8075143,
                30.6654095
              ],
              [
                49.809101,
                30.6641969
              ],
              [
                49.8104285,
                30.6632188
              ],
              [
                49.8114827,
                30.6620771
              ],
              [
                49.8118019,
                30.6617314
              ],
              [
                49.8140718,
                30.6587565
              ],
              [
                49.8157616,
                30.6566178
              ],
              [
                49.8182448,
                30.6536448
              ],
              [
                49.8205821,
                30.6510454
              ],
              [
                49.820671,
                30.6509465
              ],
              [
                49.822838,
                30.6488074
              ],
              [
                49.8254814,
                30.6465734
              ],
              [
                49.8255805,
                30.6464897
              ],
              [
                49.827961,
                30.6444799
              ],
              [
                49.829318,
                30.6435786
              ],
              [
                49.8307648,
                30.6426171
              ],
              [
                49.8330879,
                30.6408492
              ],
              [
                49.835884,
                30.638384
              ],
              [
                49.8378867,
                30.6364304
              ],
              [
                49.8406258,
                30.633827
              ],
              [
                49.8427316,
                30.6313645
              ],
              [
                49.8445204,
                30.6298781
              ],
              [
                49.847107,
                30.6279228
              ],
              [
                49.8490486,
                30.6256459
              ],
              [
                49.8508414,
                30.6244346
              ],
              [
                49.8534773,
                30.6227594
              ],
              [
                49.8559075,
                30.6215469
              ],
              [
                49.8581275,
                30.6208468
              ],
              [
                49.8610305,
                30.619864
              ],
              [
                49.863041,
                30.6196244
              ],
              [
                49.8658374,
                30.619254
              ],
              [
                49.8662681,
                30.6191969
              ],
              [
                49.8695489,
                30.6189074
              ],
              [
                49.8725625,
                30.6183877
              ],
              [
                49.8739635,
                30.6181141
              ],
              [
                49.8764228,
                30.6176339
              ],
              [
                49.8785565,
                30.6173559
              ],
              [
                49.8793297,
                30.6172552
              ],
              [
                49.8816032,
                30.6169228
              ],
              [
                49.8844699,
                30.616707
              ],
              [
                49.8848306,
                30.6166799
              ],
              [
                49.8872681,
                30.6167188
              ],
              [
                49.8896523,
                30.6168023
              ],
              [
                49.8917731,
                30.6171655
              ],
              [
                49.8944208,
                30.6170166
              ],
              [
                49.897278,
                30.6169597
              ],
              [
                49.8998185,
                30.6167669
              ],
              [
                49.9033088,
                30.6163385
              ],
              [
                49.9064295,
                30.6159565
              ],
              [
                49.9109763,
                30.6154352
              ],
              [
                49.9163093,
                30.6144895
              ],
              [
                49.9213792,
                30.6133631
              ],
              [
                49.9244386,
                30.6126147
              ],
              [
                49.9293479,
                30.6113943
              ],
              [
                49.9322528,
                30.6104504
              ],
              [
                49.9316863,
                30.6120789
              ],
              [
                49.9313432,
                30.6143477
              ],
              [
                49.9311027,
                30.6159676
              ],
              [
                49.9311218,
                30.6175851
              ],
              [
                49.931549,
                30.6217911
              ],
              [
                49.9320907,
                30.6266454
              ],
              [
                49.9327163,
                30.6298356
              ],
              [
                49.9335137,
                30.6339499
              ],
              [
                49.9343529,
                30.6371374
              ],
              [
                49.9351882,
                30.6401872
              ],
              [
                49.9363478,
                30.6434653
              ],
              [
                49.9374999,
                30.6460981
              ],
              [
                49.9389725,
                30.6490968
              ],
              [
                49.9403342,
                30.6516817
              ],
              [
                49.9410439,
                30.6529732
              ],
              [
                49.9416961,
                30.6541718
              ],
              [
                49.9432334,
                30.6576356
              ],
              [
                49.9446145,
                30.6612831
              ],
              [
                49.9457931,
                30.6657162
              ],
              [
                49.9459724,
                30.6671026
              ],
              [
                49.9467354,
                30.6684871
              ],
              [
                49.9481659,
                30.6717176
              ],
              [
                49.9495927,
                30.6747654
              ],
              [
                49.9511186,
                30.6772545
              ],
              [
                49.9524956,
                30.680577
              ],
              [
                49.9531174,
                30.6820344
              ],
              [
                49.9533232,
                30.6825169
              ],
              [
                49.9535064,
                30.6841335
              ],
              [
                49.9533693,
                30.6854745
              ],
              [
                49.952957,
                30.686493
              ],
              [
                49.9527632,
                30.686584
              ],
              [
                49.9528608,
                30.6866096
              ],
              [
                49.9537954,
                30.7031945
              ],
              [
                49.9534818,
                30.711784
              ],
              [
                49.9534034,
                30.7190378
              ],
              [
                49.9544363,
                30.7257298
              ],
              [
                49.9606438,
                30.7444886
              ],
              [
                49.9625053,
                30.7539527
              ],
              [
                49.9627076,
                30.7570424
              ],
              [
                49.9630012,
                30.7591628
              ],
              [
                49.9637491,
                30.7631727
              ],
              [
                49.9648628,
                30.7671359
              ],
              [
                49.9659843,
                30.7716066
              ],
              [
                49.9673196,
                30.7761219
              ],
              [
                49.9686394,
                30.779807
              ],
              [
                49.9703445,
                30.7841808
              ],
              [
                49.9718629,
                30.7867576
              ],
              [
                49.9734305,
                30.7892423
              ],
              [
                49.9748915,
                30.7914509
              ],
              [
                49.9775275,
                30.7945755
              ],
              [
                49.9801636,
                30.7973347
              ],
              [
                49.9820444,
                30.7993097
              ],
              [
                49.9834939,
                30.8007783
              ],
              [
                49.9862289,
                30.8033532
              ],
              [
                49.98806,
                30.8054202
              ],
              [
                49.9900092,
                30.8082257
              ],
              [
                49.9913557,
                30.8098806
              ],
              [
                49.9930342,
                30.8121336
              ],
              [
                49.9942169,
                30.8133744
              ],
              [
                49.9969557,
                30.8158994
              ],
              [
                49.9991413,
                30.8173194
              ],
              [
                49.9999718,
                30.8176867
              ],
              [
                50.001587,
                30.8186984
              ],
              [
                50.0033225,
                30.8201509
              ],
              [
                50.004666,
                30.8214988
              ],
              [
                50.0049516,
                30.8217853
              ],
              [
                50.006424,
                30.8231861
              ],
              [
                50.0073662,
                30.8244926
              ],
              [
                50.0078887,
                30.8254711
              ],
              [
                50.0092508,
                30.8271981
              ],
              [
                50.0103036,
                30.8284581
              ],
              [
                50.0111963,
                30.8292544
              ],
              [
                50.0121957,
                30.8301891
              ],
              [
                50.0135614,
                30.8318214
              ],
              [
                50.014347,
                30.8331266
              ],
              [
                50.0157089,
                30.8353634
              ],
              [
                50.0171738,
                30.8376009
              ],
              [
                50.0189551,
                30.8410024
              ],
              [
                50.0204164,
                30.8440271
              ],
              [
                50.0219343,
                30.8470545
              ],
              [
                50.024119,
                30.8516769
              ],
              [
                50.0242882,
                30.8520348
              ],
              [
                50.0251733,
                30.8543174
              ],
              [
                50.0265349,
                30.8570639
              ],
              [
                50.029255,
                30.8628814
              ],
              [
                50.0318298,
                30.8670264
              ],
              [
                50.0333405,
                30.8713077
              ],
              [
                50.0303689,
                30.8716171
              ],
              [
                50.0250053,
                30.8723753
              ],
              [
                50.0196419,
                30.873228
              ],
              [
                50.013855,
                30.8737074
              ],
              [
                50.0087051,
                30.8739117
              ],
              [
                50.0039788,
                30.8741168
              ],
              [
                50.0001564,
                30.874376
              ],
              [
                49.9922142,
                30.8767844
              ],
              [
                49.9856452,
                30.877412
              ],
              [
                49.9787026,
                30.8779507
              ],
              [
                49.9744035,
                30.8779234
              ],
              [
                49.968197,
                30.8778606
              ],
              [
                49.9619293,
                30.8776571
              ],
              [
                49.9577904,
                30.8776306
              ],
              [
                49.9555053,
                30.877364
              ],
              [
                49.9548836,
                30.8782884
              ],
              [
                49.9527475,
                30.8812508
              ],
              [
                49.9515057,
                30.8837558
              ],
              [
                49.9514504,
                30.8837304
              ],
              [
                49.9433403,
                30.8800014
              ],
              [
                49.9389866,
                30.877806
              ],
              [
                49.9377635,
                30.8759463
              ],
              [
                49.9352334,
                30.8730526
              ],
              [
                49.9327124,
                30.8693486
              ],
              [
                49.9311309,
                30.8656523
              ],
              [
                49.929125,
                30.8617315
              ],
              [
                49.9271964,
                30.858548
              ],
              [
                49.9261776,
                30.8580239
              ],
              [
                49.9231401,
                30.8547574
              ],
              [
                49.9207825,
                30.8517912
              ],
              [
                49.9187575,
                30.849638
              ],
              [
                49.91614,
                30.8470379
              ],
              [
                49.9102694,
                30.8452206
              ],
              [
                49.9071133,
                30.8449731
              ],
              [
                49.8948743,
                30.8401547
              ],
              [
                49.8901963,
                30.8386414
              ],
              [
                49.8873212,
                30.8362594
              ],
              [
                49.8820538,
                30.8355638
              ],
              [
                49.8801612,
                30.8353137
              ],
              [
                49.8757879,
                30.8355587
              ],
              [
                49.8727067,
                30.8383368
              ],
              [
                49.8701104,
                30.8406776
              ],
              [
                49.8665393,
                30.8412564
              ],
              [
                49.8641357,
                30.8414656
              ],
              [
                49.8595831,
                30.8399012
              ],
              [
                49.8590468,
                30.8393383
              ],
              [
                49.8569145,
                30.8378691
              ],
              [
                49.8545722,
                30.8369078
              ],
              [
                49.8516504,
                30.8356752
              ],
              [
                49.8496322,
                30.8353595
              ],
              [
                49.8480987,
                30.8353662
              ],
              [
                49.8449135,
                30.8346859
              ],
              [
                49.8410949,
                30.8337789
              ],
              [
                49.8352037,
                30.8318925
              ],
              [
                49.83285,
                30.8298133
              ],
              [
                49.8307528,
                30.8267741
              ],
              [
                49.8289127,
                30.8236636
              ],
              [
                49.8278515,
                30.8196762
              ],
              [
                49.8276942,
                30.8185698
              ],
              [
                49.8268721,
                30.8124735
              ],
              [
                49.8266418,
                30.8094789
              ],
              [
                49.8269672,
                30.8046476
              ],
              [
                49.8307339,
                30.8019192
              ],
              [
                49.8341059,
                30.7987268
              ],
              [
                49.8388302,
                30.793935
              ],
              [
                49.8434359,
                30.7878758
              ],
              [
                49.8532211,
                30.7721939
              ],
              [
                49.85959,
                30.7633872
              ],
              [
                49.8686638,
                30.7548216
              ],
              [
                49.8681374,
                30.7546862
              ],
              [
                49.864151,
                30.7518837
              ],
              [
                49.8618706,
                30.7501426
              ],
              [
                49.8617326,
                30.7499925
              ],
              [
                49.860195,
                30.7482985
              ],
              [
                49.8584176,
                30.7465956
              ],
              [
                49.8555679,
                30.7443419
              ],
              [
                49.8502464,
                30.7406181
              ],
              [
                49.8445626,
                30.7374525
              ],
              [
                49.8385544,
                30.7335936
              ],
              [
                49.8257486,
                30.7264339
              ],
              [
                49.8180872,
                30.7220374
              ],
              [
                49.816319,
                30.7210226
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554893,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان امیدیه",
          "name:en": "Omidieh County",
          "name:uk": "Омідіє шагрестан",
          "place": "county",
          "source:name:uk": "https://1drv.ms/b/s!Ar-WXIFaX7UdgQs-x7Qj83y_IvGR",
          "type": "boundary",
          "wikidata": "Q2639129",
          "wikipedia": "fa:شهرستان امیدیه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.362961,
                30.6570414
              ],
              [
                49.3619997,
                30.6549272
              ],
              [
                49.3615724,
                30.653228
              ],
              [
                49.3610381,
                30.6510717
              ],
              [
                49.3608779,
                30.6490488
              ],
              [
                49.3607675,
                30.6471663
              ],
              [
                49.3609809,
                30.6455158
              ],
              [
                49.3611907,
                30.6437704
              ],
              [
                49.3615609,
                30.6422549
              ],
              [
                49.3626174,
                30.6391331
              ],
              [
                49.3631477,
                30.6369767
              ],
              [
                49.3636208,
                30.6342671
              ],
              [
                49.3637237,
                30.6320625
              ],
              [
                49.36372,
                30.630134
              ],
              [
                49.3636132,
                30.6279764
              ],
              [
                49.3633422,
                30.625404
              ],
              [
                49.3628083,
                30.6232478
              ],
              [
                49.362114,
                30.6209046
              ],
              [
                49.3615304,
                30.6198034
              ],
              [
                49.3609964,
                30.619111
              ],
              [
                49.3602523,
                30.6174573
              ],
              [
                49.3598252,
                30.6162633
              ],
              [
                49.3592378,
                30.6150244
              ],
              [
                49.359024,
                30.613921
              ],
              [
                49.358761,
                30.6130493
              ],
              [
                49.3582269,
                30.6119938
              ],
              [
                49.3578531,
                30.6110282
              ],
              [
                49.3572158,
                30.6096985
              ],
              [
                49.3564681,
                30.6084575
              ],
              [
                49.3557242,
                30.6068039
              ],
              [
                49.3551368,
                30.60561
              ],
              [
                49.3544998,
                30.6046908
              ],
              [
                49.3534888,
                30.6033585
              ],
              [
                49.3526915,
                30.6023019
              ],
              [
                49.3516807,
                30.6013824
              ],
              [
                49.3507233,
                30.6002808
              ],
              [
                49.3495559,
                30.5993165
              ],
              [
                49.3490087,
                30.5988226
              ],
              [
                49.3484381,
                30.5983076
              ],
              [
                49.3474312,
                30.5974332
              ],
              [
                49.3466338,
                30.5965615
              ],
              [
                49.3462066,
                30.5958704
              ],
              [
                49.3455162,
                30.5944948
              ],
              [
                49.3445053,
                30.5929798
              ],
              [
                49.3433343,
                30.5909124
              ],
              [
                49.3425903,
                30.5893985
              ],
              [
                49.3423932,
                30.5889418
              ],
              [
                49.3418962,
                30.5877905
              ],
              [
                49.3414727,
                30.5863664
              ],
              [
                49.3407784,
                30.5854012
              ],
              [
                49.3401412,
                30.5840691
              ],
              [
                49.3396111,
                30.5833361
              ],
              [
                49.3388672,
                30.5825101
              ],
              [
                49.3376959,
                30.5813155
              ],
              [
                49.3368336,
                30.5806362
              ],
              [
                49.3365288,
                30.5803961
              ],
              [
                49.335518,
                30.5794765
              ],
              [
                49.3343467,
                30.5779639
              ],
              [
                49.333233,
                30.5767226
              ],
              [
                49.3318519,
                30.5747945
              ],
              [
                49.3307343,
                30.5730954
              ],
              [
                49.3298301,
                30.5716718
              ],
              [
                49.3290861,
                30.5696075
              ],
              [
                49.3281822,
                30.5679065
              ],
              [
                49.3280474,
                30.5675069
              ],
              [
                49.3275946,
                30.5661645
              ],
              [
                49.3267973,
                30.5643273
              ],
              [
                49.3264408,
                30.5633307
              ],
              [
                49.3263207,
                30.562995
              ],
              [
                49.3272209,
                30.5624449
              ],
              [
                49.3288116,
                30.5624
              ],
              [
                49.3313598,
                30.5626762
              ],
              [
                49.3332711,
                30.5629511
              ],
              [
                49.3367766,
                30.563641
              ],
              [
                49.3383674,
                30.5641462
              ],
              [
                49.3412895,
                30.5643775
              ],
              [
                49.3441543,
                30.5648357
              ],
              [
                49.3479232,
                30.5652039
              ],
              [
                49.3512153,
                30.5654802
              ],
              [
                49.3542404,
                30.5658478
              ],
              [
                49.3581163,
                30.5662148
              ],
              [
                49.3586408,
                30.5663189
              ],
              [
                49.3606644,
                30.5667205
              ],
              [
                49.3625756,
                30.5670897
              ],
              [
                49.3654404,
                30.5673648
              ],
              [
                49.3677217,
                30.5677791
              ],
              [
                49.3688928,
                30.5681028
              ],
              [
                49.3696862,
                30.568239
              ],
              [
                49.3708571,
                30.5682402
              ],
              [
                49.3721276,
                30.5681929
              ],
              [
                49.3734549,
                30.5676907
              ],
              [
                49.3747292,
                30.5671834
              ],
              [
                49.3757897,
                30.5664049
              ],
              [
                49.3777505,
                30.5655791
              ],
              [
                49.3803521,
                30.5644769
              ],
              [
                49.3815154,
                30.5638779
              ],
              [
                49.3836938,
                30.5633275
              ],
              [
                49.3862914,
                30.5626403
              ],
              [
                49.3884125,
                30.5621365
              ],
              [
                49.390854,
                30.5615848
              ],
              [
                49.393135,
                30.5611257
              ],
              [
                49.3952599,
                30.5609422
              ],
              [
                49.3970604,
                30.5604388
              ],
              [
                49.3988113,
                30.5601153
              ],
              [
                49.4019433,
                30.5600703
              ],
              [
                49.4039077,
                30.5599794
              ],
              [
                49.4054452,
                30.5599328
              ],
              [
                49.4075163,
                30.5602085
              ],
              [
                49.4086838,
                30.5604393
              ],
              [
                49.409958,
                30.5604391
              ],
              [
                49.4119225,
                30.5605781
              ],
              [
                49.4135133,
                30.5608073
              ],
              [
                49.4140063,
                30.5608753
              ],
              [
                49.4148408,
                30.5609904
              ],
              [
                49.4158517,
                30.5613139
              ],
              [
                49.4166488,
                30.5615875
              ],
              [
                49.4176025,
                30.5618202
              ],
              [
                49.4199372,
                30.5620042
              ],
              [
                49.4215318,
                30.5620957
              ],
              [
                49.422966,
                30.562095
              ],
              [
                49.4242898,
                30.5620051
              ],
              [
                49.426201,
                30.5621883
              ],
              [
                49.4278487,
                30.5622804
              ],
              [
                49.4283892,
                30.5623195
              ],
              [
                49.4297599,
                30.5624185
              ],
              [
                49.4298968,
                30.5624098
              ],
              [
                49.4319343,
                30.5622801
              ],
              [
                49.4349595,
                30.5621902
              ],
              [
                49.4372941,
                30.5626039
              ],
              [
                49.4392587,
                30.5629703
              ],
              [
                49.4408531,
                30.5632014
              ],
              [
                49.4434548,
                30.5640288
              ],
              [
                49.4457397,
                30.5649042
              ],
              [
                49.4474412,
                30.5658222
              ],
              [
                49.4496727,
                30.5667871
              ],
              [
                49.4517973,
                30.5681206
              ],
              [
                49.454136,
                30.5693168
              ],
              [
                49.4557838,
                30.5700965
              ],
              [
                49.4572716,
                30.5707885
              ],
              [
                49.4592896,
                30.5715229
              ],
              [
                49.4607774,
                30.5721202
              ],
              [
                49.4624788,
                30.5726253
              ],
              [
                49.4651871,
                30.5733159
              ],
              [
                49.4669379,
                30.5736387
              ],
              [
                49.4677352,
                30.5736842
              ],
              [
                49.4690093,
                30.5736857
              ],
              [
                49.4696998,
                30.5738697
              ],
              [
                49.4712408,
                30.5741923
              ],
              [
                49.4733621,
                30.5746052
              ],
              [
                49.4752199,
                30.5747443
              ],
              [
                49.4771346,
                30.5749291
              ],
              [
                49.4794159,
                30.5753888
              ],
              [
                49.4813804,
                30.5754366
              ],
              [
                49.4827079,
                30.5756212
              ],
              [
                49.4844242,
                30.5760393
              ],
              [
                49.4847793,
                30.5761258
              ],
              [
                49.4869042,
                30.5764031
              ],
              [
                49.4872265,
                30.5764031
              ],
              [
                49.4880714,
                30.5764032
              ],
              [
                49.489292,
                30.5764038
              ],
              [
                49.4917374,
                30.5767728
              ],
              [
                49.4946558,
                30.577278
              ],
              [
                49.4975243,
                30.5777397
              ],
              [
                49.500025,
                30.5783347
              ],
              [
                49.502556,
                30.5790518
              ],
              [
                49.5050928,
                30.5797351
              ],
              [
                49.508213,
                30.5804114
              ],
              [
                49.510643,
                30.5808182
              ],
              [
                49.5130234,
                30.5813146
              ],
              [
                49.5138701,
                30.5813107
              ],
              [
                49.5154534,
                30.5812566
              ],
              [
                49.5159748,
                30.5811888
              ],
              [
                49.5277596,
                30.5805055
              ],
              [
                49.531723,
                30.5806247
              ],
              [
                49.5332334,
                30.5805758
              ],
              [
                49.5354332,
                30.5805047
              ],
              [
                49.5367393,
                30.5804624
              ],
              [
                49.5399092,
                30.5804506
              ],
              [
                49.5436591,
                30.5807092
              ],
              [
                49.5478898,
                30.5811512
              ],
              [
                49.5515403,
                30.5818753
              ],
              [
                49.5542869,
                30.5823705
              ],
              [
                49.5562441,
                30.5826832
              ],
              [
                49.5587274,
                30.5827649
              ],
              [
                49.5617409,
                30.5827982
              ],
              [
                49.5645942,
                30.5828771
              ],
              [
                49.5673408,
                30.5830472
              ],
              [
                49.5733642,
                30.5830209
              ],
              [
                49.5791741,
                30.5828544
              ],
              [
                49.5826072,
                30.5827475
              ],
              [
                49.5859373,
                30.5827769
              ],
              [
                49.5944444,
                30.5828285
              ],
              [
                49.5996742,
                30.582851
              ],
              [
                49.6050605,
                30.5828254
              ],
              [
                49.6117171,
                30.5826553
              ],
              [
                49.6167908,
                30.5827702
              ],
              [
                49.6213874,
                30.5827491
              ],
              [
                49.6301041,
                30.5828479
              ],
              [
                49.6339606,
                30.5829222
              ],
              [
                49.6381873,
                30.5827162
              ],
              [
                49.6424638,
                30.5826503
              ],
              [
                49.6465341,
                30.5828619
              ],
              [
                49.6526642,
                30.5829255
              ],
              [
                49.6570473,
                30.5829054
              ],
              [
                49.6597976,
                30.5828931
              ],
              [
                49.6683006,
                30.5827594
              ],
              [
                49.6759073,
                30.5827265
              ],
              [
                49.6892204,
                30.582568
              ],
              [
                49.6960335,
                30.5824898
              ],
              [
                49.7074807,
                30.5823627
              ],
              [
                49.7110901,
                30.5823285
              ],
              [
                49.7293166,
                30.582289
              ],
              [
                49.7351799,
                30.5821228
              ],
              [
                49.738823,
                30.5818288
              ],
              [
                49.7424087,
                30.5813019
              ],
              [
                49.7449379,
                30.5808751
              ],
              [
                49.7477341,
                30.5803066
              ],
              [
                49.7500063,
                30.5798412
              ],
              [
                49.7534681,
                30.578927
              ],
              [
                49.7582702,
                30.5776059
              ],
              [
                49.7629166,
                30.5760622
              ],
              [
                49.7660295,
                30.5749413
              ],
              [
                49.7680854,
                30.5737766
              ],
              [
                49.7718315,
                30.5718202
              ],
              [
                49.7752039,
                30.5698173
              ],
              [
                49.7787896,
                30.5676291
              ],
              [
                49.7832144,
                30.5645577
              ],
              [
                49.7863692,
                30.56186
              ],
              [
                49.7888946,
                30.5597676
              ],
              [
                49.7946283,
                30.5553974
              ],
              [
                49.7992021,
                30.5516793
              ],
              [
                49.8009772,
                30.5501612
              ],
              [
                49.8055037,
                30.5462897
              ],
              [
                49.8107489,
                30.5410886
              ],
              [
                49.8156203,
                30.5361185
              ],
              [
                49.8183938,
                30.5326383
              ],
              [
                49.8222084,
                30.527999
              ],
              [
                49.825081,
                30.5238225
              ],
              [
                49.8287812,
                30.5179322
              ],
              [
                49.8325845,
                30.5124601
              ],
              [
                49.8347168,
                30.5091677
              ],
              [
                49.8362771,
                30.5068041
              ],
              [
                49.8392981,
                30.5025834
              ],
              [
                49.8408298,
                30.5000097
              ],
              [
                49.8449058,
                30.4939892
              ],
              [
                49.8499299,
                30.4889153
              ],
              [
                49.8531189,
                30.4855643
              ],
              [
                49.8559875,
                30.4823998
              ],
              [
                49.8590508,
                30.4782625
              ],
              [
                49.8620148,
                30.4744964
              ],
              [
                49.8647537,
                30.4702682
              ],
              [
                49.8670312,
                30.4668299
              ],
              [
                49.8674374,
                30.4660439
              ],
              [
                49.8687746,
                30.4634862
              ],
              [
                49.8698996,
                30.4611634
              ],
              [
                49.8719978,
                30.4568934
              ],
              [
                49.8740557,
                30.4524018
              ],
              [
                49.874798,
                30.4532632
              ],
              [
                49.8762056,
                30.4548273
              ],
              [
                49.8784179,
                30.4565269
              ],
              [
                49.8804169,
                30.458272
              ],
              [
                49.8827933,
                30.460291
              ],
              [
                49.8864098,
                30.4632747
              ],
              [
                49.8923417,
                30.4676766
              ],
              [
                49.8969267,
                30.4709322
              ],
              [
                49.9033509,
                30.4755657
              ],
              [
                49.9082185,
                30.4794684
              ],
              [
                49.9104918,
                30.4813981
              ],
              [
                49.9145661,
                30.4852601
              ],
              [
                49.9171716,
                30.4875556
              ],
              [
                49.919731,
                30.49018
              ],
              [
                49.9236527,
                30.4941827
              ],
              [
                49.9262619,
                30.496575
              ],
              [
                49.9283715,
                30.4981805
              ],
              [
                49.9307254,
                30.5000292
              ],
              [
                49.9332694,
                30.5025156
              ],
              [
                49.9368896,
                30.5061635
              ],
              [
                49.9410363,
                30.5099013
              ],
              [
                49.9451829,
                30.5131291
              ],
              [
                49.947895,
                30.5153437
              ],
              [
                49.9485321,
                30.5158518
              ],
              [
                49.9489556,
                30.5159883
              ],
              [
                49.9492186,
                30.5161281
              ],
              [
                49.9496384,
                30.5161269
              ],
              [
                49.9500045,
                30.5159427
              ],
              [
                49.9502641,
                30.5157575
              ],
              [
                49.9506263,
                30.5154785
              ],
              [
                49.9510347,
                30.5146922
              ],
              [
                49.9511543,
                30.5140962
              ],
              [
                49.9511834,
                30.5139513
              ],
              [
                49.9513818,
                30.5131182
              ],
              [
                49.9514772,
                30.5126092
              ],
              [
                49.9514693,
                30.5120091
              ],
              [
                49.9513549,
                30.5115006
              ],
              [
                49.9511375,
                30.5109462
              ],
              [
                49.9508666,
                30.5103913
              ],
              [
                49.9499625,
                30.5097005
              ],
              [
                49.948799,
                30.509055
              ],
              [
                49.9472124,
                30.5083632
              ],
              [
                49.9463653,
                30.5077654
              ],
              [
                49.9459915,
                30.5073022
              ],
              [
                49.9457168,
                30.506657
              ],
              [
                49.9457627,
                30.5061476
              ],
              [
                49.945755,
                30.5055001
              ],
              [
                49.9459077,
                30.5051765
              ],
              [
                49.9461632,
                30.5048515
              ],
              [
                49.9466819,
                30.5043436
              ],
              [
                49.9472578,
                30.5042039
              ],
              [
                49.9476778,
                30.5042479
              ],
              [
                49.9484673,
                30.5043851
              ],
              [
                49.9489937,
                30.50443
              ],
              [
                49.9495735,
                30.5045677
              ],
              [
                49.9504128,
                30.5046129
              ],
              [
                49.9506959,
                30.5046124
              ],
              [
                49.9513588,
                30.5046114
              ],
              [
                49.9520417,
                30.5045177
              ],
              [
                49.9527702,
                30.5042393
              ],
              [
                49.9533959,
                30.5038676
              ],
              [
                49.9539184,
                30.5036372
              ],
              [
                49.9544372,
                30.5032646
              ],
              [
                49.9546395,
                30.5027113
              ],
              [
                49.9546317,
                30.5022488
              ],
              [
                49.9546375,
                30.5015857
              ],
              [
                49.954675,
                30.5010401
              ],
              [
                49.954805,
                30.5006328
              ],
              [
                49.9550324,
                30.4999805
              ],
              [
                49.9550787,
                30.4998676
              ],
              [
                49.9554978,
                30.498845
              ],
              [
                49.9562112,
                30.4976349
              ],
              [
                49.9567298,
                30.4970299
              ],
              [
                49.9573022,
                30.496518
              ],
              [
                49.9581949,
                30.4958619
              ],
              [
                49.9588774,
                30.4955808
              ],
              [
                49.9591143,
                30.4954799
              ],
              [
                49.959984,
                30.4951092
              ],
              [
                49.9606208,
                30.4949654
              ],
              [
                49.9613113,
                30.4949168
              ],
              [
                49.9617387,
                30.4949585
              ],
              [
                49.9621696,
                30.4951875
              ],
              [
                49.9623985,
                30.4958368
              ],
              [
                49.9628334,
                30.4962508
              ],
              [
                49.9635315,
                30.4964323
              ],
              [
                49.9640693,
                30.4966576
              ],
              [
                49.9646033,
                30.4966574
              ],
              [
                49.9651872,
                30.496653
              ],
              [
                49.9654466,
                30.4963257
              ],
              [
                49.9657594,
                30.4960913
              ],
              [
                49.9661218,
                30.4957197
              ],
              [
                49.9664307,
                30.4953003
              ],
              [
                49.9668502,
                30.4949269
              ],
              [
                49.9670488,
                30.4944638
              ],
              [
                49.9676284,
                30.4940894
              ],
              [
                49.9681512,
                30.493762
              ],
              [
                49.9687882,
                30.4936632
              ],
              [
                49.9698028,
                30.4937502
              ],
              [
                49.9703903,
                30.4939331
              ],
              [
                49.9710349,
                30.4940667
              ],
              [
                49.9714585,
                30.4940633
              ],
              [
                49.9719849,
                30.4938306
              ],
              [
                49.9724046,
                30.4935497
              ],
              [
                49.97303,
                30.4930335
              ],
              [
                49.9736061,
                30.4927064
              ],
              [
                49.9745599,
                30.492423
              ],
              [
                49.9761545,
                30.4923182
              ],
              [
                49.9771157,
                30.4924069
              ],
              [
                49.9777984,
                30.4921709
              ],
              [
                49.9780539,
                30.491706
              ],
              [
                49.9789389,
                30.4909595
              ],
              [
                49.9798164,
                30.4898407
              ],
              [
                49.9803658,
                30.4884464
              ],
              [
                49.9804217,
                30.4880399
              ],
              [
                49.9804994,
                30.4874752
              ],
              [
                49.9804192,
                30.4863624
              ],
              [
                49.9805986,
                30.4851096
              ],
              [
                49.9806671,
                30.4837183
              ],
              [
                49.9809571,
                30.4825137
              ],
              [
                49.9815062,
                30.4812119
              ],
              [
                49.9823265,
                30.4800024
              ],
              [
                49.9840356,
                30.4782291
              ],
              [
                49.9866601,
                30.4748771
              ],
              [
                49.9876749,
                30.4730172
              ],
              [
                49.9883842,
                30.4716692
              ],
              [
                49.9897804,
                30.470313
              ],
              [
                49.9910353,
                30.4694249
              ],
              [
                49.9932517,
                30.4689006
              ],
              [
                49.9950449,
                30.4683798
              ],
              [
                49.9966239,
                30.4677197
              ],
              [
                49.9982643,
                30.4675225
              ],
              [
                49.999854,
                30.4674929
              ],
              [
                49.9999772,
                30.4674906
              ],
              [
                50.0010109,
                30.4698288
              ],
              [
                50.0016821,
                30.4713679
              ],
              [
                50.0030135,
                30.4751385
              ],
              [
                50.0042001,
                30.4781207
              ],
              [
                50.0052756,
                30.481242
              ],
              [
                50.0063552,
                30.4838963
              ],
              [
                50.0077057,
                30.4864624
              ],
              [
                50.008484,
                30.4882798
              ],
              [
                50.0091515,
                30.4901414
              ],
              [
                50.0101737,
                30.4931223
              ],
              [
                50.0115624,
                30.4970783
              ],
              [
                50.0122199,
                30.5000068
              ],
              [
                50.0134467,
                30.5032487
              ],
              [
                50.0147476,
                30.507328
              ],
              [
                50.0168381,
                30.5121036
              ],
              [
                50.0176733,
                30.514607
              ],
              [
                50.0188218,
                30.5169256
              ],
              [
                50.0197105,
                30.5194746
              ],
              [
                50.0205994,
                30.521701
              ],
              [
                50.0224344,
                30.5264272
              ],
              [
                50.0235864,
                30.5299504
              ],
              [
                50.0241622,
                30.5318518
              ],
              [
                50.0245286,
                30.5330569
              ],
              [
                50.0248414,
                30.5337067
              ],
              [
                50.0257873,
                30.5342619
              ],
              [
                50.0267332,
                30.5347247
              ],
              [
                50.0275191,
                30.5350035
              ],
              [
                50.0288847,
                30.5354197
              ],
              [
                50.0307235,
                30.5355598
              ],
              [
                50.0324022,
                30.5358813
              ],
              [
                50.0353432,
                30.5365302
              ],
              [
                50.037655,
                30.536994
              ],
              [
                50.0422746,
                30.5379191
              ],
              [
                50.0486336,
                30.5390733
              ],
              [
                50.0538864,
                30.5400905
              ],
              [
                50.0621377,
                30.5416616
              ],
              [
                50.0695494,
                30.543048
              ],
              [
                50.0722847,
                30.5435592
              ],
              [
                50.0747566,
                30.5438814
              ],
              [
                50.0751801,
                30.544807
              ],
              [
                50.075447,
                30.5457315
              ],
              [
                50.0760307,
                30.5469831
              ],
              [
                50.0762444,
                30.5479095
              ],
              [
                50.0763053,
                30.5495297
              ],
              [
                50.0763093,
                30.5504117
              ],
              [
                50.0763129,
                30.5516141
              ],
              [
                50.0760042,
                30.5529112
              ],
              [
                50.0757979,
                30.5538392
              ],
              [
                50.0750159,
                30.5559721
              ],
              [
                50.0739213,
                30.5587052
              ],
              [
                50.0734023,
                30.5598632
              ],
              [
                50.0716781,
                30.5631061
              ],
              [
                50.070833,
                30.5644027
              ],
              [
                50.0701064,
                30.5655176
              ],
              [
                50.0687981,
                30.5675565
              ],
              [
                50.066803,
                30.5698274
              ],
              [
                50.0658074,
                30.5711241
              ],
              [
                50.0639685,
                30.5730261
              ],
              [
                50.0618667,
                30.5751134
              ],
              [
                50.0601844,
                30.5767841
              ],
              [
                50.0581895,
                30.5785472
              ],
              [
                50.0552405,
                30.5807275
              ],
              [
                50.0532419,
                30.5822582
              ],
              [
                50.0506058,
                30.5837436
              ],
              [
                50.0488168,
                30.5849487
              ],
              [
                50.0472336,
                30.5858778
              ],
              [
                50.0456008,
                30.586529
              ],
              [
                50.0440712,
                30.5870389
              ],
              [
                50.0429115,
                30.5874116
              ],
              [
                50.0412782,
                30.5877941
              ],
              [
                50.0411187,
                30.5878315
              ],
              [
                50.0395357,
                30.5881582
              ],
              [
                50.0374794,
                30.5884859
              ],
              [
                50.0345765,
                30.5889043
              ],
              [
                50.0320434,
                30.5893253
              ],
              [
                50.029194,
                30.590026
              ],
              [
                50.0265045,
                30.5908631
              ],
              [
                50.0233878,
                30.5915593
              ],
              [
                50.0202752,
                30.59226
              ],
              [
                50.0196473,
                30.5924548
              ],
              [
                50.0184785,
                30.5928172
              ],
              [
                50.0172652,
                30.5930968
              ],
              [
                50.014572,
                30.5938885
              ],
              [
                50.0119325,
                30.5947257
              ],
              [
                50.0104521,
                30.5953303
              ],
              [
                50.0090255,
                30.5956127
              ],
              [
                50.007019,
                30.5963102
              ],
              [
                50.0053254,
                30.5970078
              ],
              [
                50.0019617,
                30.5980761
              ],
              [
                50.0000402,
                30.598517
              ],
              [
                49.995921,
                30.5982372
              ],
              [
                49.9924164,
                30.5982913
              ],
              [
                49.9915387,
                30.5983123
              ],
              [
                49.9901429,
                30.5983458
              ],
              [
                49.9873963,
                30.5985388
              ],
              [
                49.9856072,
                30.5989128
              ],
              [
                49.9841841,
                30.5991499
              ],
              [
                49.9836594,
                30.59946
              ],
              [
                49.9832422,
                30.5997065
              ],
              [
                49.9823569,
                30.6006334
              ],
              [
                49.9807893,
                30.6017017
              ],
              [
                49.9793816,
                30.6028614
              ],
              [
                49.9778634,
                30.6038375
              ],
              [
                49.9763413,
                30.6045361
              ],
              [
                49.9743958,
                30.605281
              ],
              [
                49.9732361,
                30.6055154
              ],
              [
                49.9718094,
                30.6056598
              ],
              [
                49.9684792,
                30.6058071
              ],
              [
                49.9642982,
                30.6057762
              ],
              [
                49.9606973,
                30.6056956
              ],
              [
                49.9578973,
                30.6057973
              ],
              [
                49.9537736,
                30.6061341
              ],
              [
                49.9513434,
                30.6063739
              ],
              [
                49.9474374,
                30.6068951
              ],
              [
                49.9435807,
                30.6074616
              ],
              [
                49.9396249,
                30.6082618
              ],
              [
                49.9367257,
                30.6090569
              ],
              [
                49.9350907,
                30.6095679
              ],
              [
                49.9329835,
                30.6102263
              ],
              [
                49.9322528,
                30.6104504
              ],
              [
                49.9293479,
                30.6113943
              ],
              [
                49.9244386,
                30.6126147
              ],
              [
                49.9213792,
                30.6133631
              ],
              [
                49.9163093,
                30.6144895
              ],
              [
                49.9109763,
                30.6154352
              ],
              [
                49.9064295,
                30.6159565
              ],
              [
                49.9033088,
                30.6163385
              ],
              [
                49.8998185,
                30.6167669
              ],
              [
                49.897278,
                30.6169597
              ],
              [
                49.8944208,
                30.6170166
              ],
              [
                49.8917731,
                30.6171655
              ],
              [
                49.8896523,
                30.6168023
              ],
              [
                49.8872681,
                30.6167188
              ],
              [
                49.8848306,
                30.6166799
              ],
              [
                49.8844699,
                30.616707
              ],
              [
                49.8816032,
                30.6169228
              ],
              [
                49.8793297,
                30.6172552
              ],
              [
                49.8785565,
                30.6173559
              ],
              [
                49.8764228,
                30.6176339
              ],
              [
                49.8739635,
                30.6181141
              ],
              [
                49.8725625,
                30.6183877
              ],
              [
                49.8695489,
                30.6189074
              ],
              [
                49.8662681,
                30.6191969
              ],
              [
                49.8658374,
                30.619254
              ],
              [
                49.863041,
                30.6196244
              ],
              [
                49.8610305,
                30.619864
              ],
              [
                49.8581275,
                30.6208468
              ],
              [
                49.8559075,
                30.6215469
              ],
              [
                49.8534773,
                30.6227594
              ],
              [
                49.8508414,
                30.6244346
              ],
              [
                49.8490486,
                30.6256459
              ],
              [
                49.847107,
                30.6279228
              ],
              [
                49.8445204,
                30.6298781
              ],
              [
                49.8427316,
                30.6313645
              ],
              [
                49.8406258,
                30.633827
              ],
              [
                49.8378867,
                30.6364304
              ],
              [
                49.835884,
                30.638384
              ],
              [
                49.8330879,
                30.6408492
              ],
              [
                49.8307648,
                30.6426171
              ],
              [
                49.829318,
                30.6435786
              ],
              [
                49.827961,
                30.6444799
              ],
              [
                49.8255805,
                30.6464897
              ],
              [
                49.8254814,
                30.6465734
              ],
              [
                49.822838,
                30.6488074
              ],
              [
                49.820671,
                30.6509465
              ],
              [
                49.8205821,
                30.6510454
              ],
              [
                49.8182448,
                30.6536448
              ],
              [
                49.8157616,
                30.6566178
              ],
              [
                49.8140718,
                30.6587565
              ],
              [
                49.8118019,
                30.6617314
              ],
              [
                49.8114827,
                30.6620771
              ],
              [
                49.8104285,
                30.6632188
              ],
              [
                49.809101,
                30.6641969
              ],
              [
                49.8075143,
                30.6654095
              ],
              [
                49.8058167,
                30.666436
              ],
              [
                49.8017349,
                30.6690015
              ],
              [
                49.7987098,
                30.6704036
              ],
              [
                49.7960015,
                30.6713417
              ],
              [
                49.7942378,
                30.6724282
              ],
              [
                49.7938804,
                30.6726484
              ],
              [
                49.792179,
                30.6737695
              ],
              [
                49.7909624,
                30.675071
              ],
              [
                49.7902184,
                30.675955
              ],
              [
                49.7897948,
                30.6766503
              ],
              [
                49.789585,
                30.6773025
              ],
              [
                49.7898027,
                30.6791565
              ],
              [
                49.7899743,
                30.6832318
              ],
              [
                49.7901,
                30.6901827
              ],
              [
                49.7903862,
                30.6977374
              ],
              [
                49.7902909,
                30.7013523
              ],
              [
                49.790348,
                30.7027897
              ],
              [
                49.7905084,
                30.7034837
              ],
              [
                49.7908287,
                30.7040393
              ],
              [
                49.7938195,
                30.706201
              ],
              [
                49.8003386,
                30.7109915
              ],
              [
                49.8044015,
                30.7135193
              ],
              [
                49.8107111,
                30.7175201
              ],
              [
                49.8155823,
                30.7206008
              ],
              [
                49.816319,
                30.7210226
              ],
              [
                49.8180872,
                30.7220374
              ],
              [
                49.8257486,
                30.7264339
              ],
              [
                49.8385544,
                30.7335936
              ],
              [
                49.8445626,
                30.7374525
              ],
              [
                49.8502464,
                30.7406181
              ],
              [
                49.8555679,
                30.7443419
              ],
              [
                49.8584176,
                30.7465956
              ],
              [
                49.860195,
                30.7482985
              ],
              [
                49.8617326,
                30.7499925
              ],
              [
                49.8618706,
                30.7501426
              ],
              [
                49.864151,
                30.7518837
              ],
              [
                49.8681374,
                30.7546862
              ],
              [
                49.8686638,
                30.7548216
              ],
              [
                49.85959,
                30.7633872
              ],
              [
                49.8532211,
                30.7721939
              ],
              [
                49.8434359,
                30.7878758
              ],
              [
                49.8388302,
                30.793935
              ],
              [
                49.8341059,
                30.7987268
              ],
              [
                49.8307339,
                30.8019192
              ],
              [
                49.8269672,
                30.8046476
              ],
              [
                49.8266418,
                30.8094789
              ],
              [
                49.8268721,
                30.8124735
              ],
              [
                49.8276942,
                30.8185698
              ],
              [
                49.8278515,
                30.8196762
              ],
              [
                49.8289127,
                30.8236636
              ],
              [
                49.8307528,
                30.8267741
              ],
              [
                49.83285,
                30.8298133
              ],
              [
                49.8352037,
                30.8318925
              ],
              [
                49.8410949,
                30.8337789
              ],
              [
                49.8449135,
                30.8346859
              ],
              [
                49.8480987,
                30.8353662
              ],
              [
                49.8496322,
                30.8353595
              ],
              [
                49.8516504,
                30.8356752
              ],
              [
                49.8545722,
                30.8369078
              ],
              [
                49.8569145,
                30.8378691
              ],
              [
                49.8590468,
                30.8393383
              ],
              [
                49.8595831,
                30.8399012
              ],
              [
                49.8641357,
                30.8414656
              ],
              [
                49.8665393,
                30.8412564
              ],
              [
                49.8701104,
                30.8406776
              ],
              [
                49.8727067,
                30.8383368
              ],
              [
                49.8757879,
                30.8355587
              ],
              [
                49.8801612,
                30.8353137
              ],
              [
                49.8820538,
                30.8355638
              ],
              [
                49.8873212,
                30.8362594
              ],
              [
                49.8901963,
                30.8386414
              ],
              [
                49.8948743,
                30.8401547
              ],
              [
                49.9071133,
                30.8449731
              ],
              [
                49.9102694,
                30.8452206
              ],
              [
                49.91614,
                30.8470379
              ],
              [
                49.9187575,
                30.849638
              ],
              [
                49.9207825,
                30.8517912
              ],
              [
                49.9231401,
                30.8547574
              ],
              [
                49.9261776,
                30.8580239
              ],
              [
                49.9271964,
                30.858548
              ],
              [
                49.929125,
                30.8617315
              ],
              [
                49.9311309,
                30.8656523
              ],
              [
                49.9327124,
                30.8693486
              ],
              [
                49.9352334,
                30.8730526
              ],
              [
                49.9377635,
                30.8759463
              ],
              [
                49.9389866,
                30.877806
              ],
              [
                49.9433403,
                30.8800014
              ],
              [
                49.9514504,
                30.8837304
              ],
              [
                49.9515057,
                30.8837558
              ],
              [
                49.9513917,
                30.8839374
              ],
              [
                49.9510383,
                30.8845001
              ],
              [
                49.9505233,
                30.8853201
              ],
              [
                49.9492835,
                30.8877236
              ],
              [
                49.9485626,
                30.8893418
              ],
              [
                49.9477959,
                30.8913747
              ],
              [
                49.9478149,
                30.8928974
              ],
              [
                49.9479026,
                30.8954335
              ],
              [
                49.9484596,
                30.8970937
              ],
              [
                49.94944,
                30.8988408
              ],
              [
                49.9500389,
                30.900084
              ],
              [
                49.9506415,
                30.9012799
              ],
              [
                49.950981,
                30.9028007
              ],
              [
                49.9511643,
                30.9044601
              ],
              [
                49.9513512,
                30.9063044
              ],
              [
                49.9511185,
                30.9088424
              ],
              [
                49.9510957,
                30.9183927
              ],
              [
                49.9509507,
                30.9232344
              ],
              [
                49.9511222,
                30.9264444
              ],
              [
                49.9512367,
                30.9285849
              ],
              [
                49.9511414,
                30.9293713
              ],
              [
                49.9507713,
                30.9296007
              ],
              [
                49.9500807,
                30.9296988
              ],
              [
                49.9488641,
                30.9301671
              ],
              [
                49.9475441,
                30.9307248
              ],
              [
                49.946808,
                30.9312827
              ],
              [
                49.9454421,
                30.9325348
              ],
              [
                49.9438704,
                30.9342949
              ],
              [
                49.9430848,
                30.9352674
              ],
              [
                49.942562,
                30.9358722
              ],
              [
                49.9422454,
                30.9361042
              ],
              [
                49.9418715,
                30.9361056
              ],
              [
                49.9415512,
                30.9359676
              ],
              [
                49.9411735,
                30.9356939
              ],
              [
                49.9408493,
                30.9352807
              ],
              [
                49.9405783,
                30.9348206
              ],
              [
                49.9402542,
                30.9346375
              ],
              [
                49.9398843,
                30.9346389
              ],
              [
                49.939617,
                30.934639
              ],
              [
                49.9392509,
                30.9349202
              ],
              [
                49.939041,
                30.9352884
              ],
              [
                49.9386253,
                30.9361219
              ],
              [
                49.9381064,
                30.9370469
              ],
              [
                49.9377403,
                30.9374635
              ],
              [
                49.937107,
                30.9378823
              ],
              [
                49.9361572,
                30.9383459
              ],
              [
                49.9353066,
                30.9385352
              ],
              [
                49.9341353,
                30.9384962
              ],
              [
                49.9334412,
                30.938407
              ],
              [
                49.93264,
                30.9381816
              ],
              [
                49.9321593,
                30.937907
              ],
              [
                49.9318351,
                30.9375862
              ],
              [
                49.9318277,
                30.9370786
              ],
              [
                49.9321443,
                30.9368467
              ],
              [
                49.932728,
                30.9366575
              ],
              [
                49.9328346,
                30.9365659
              ],
              [
                49.9343225,
                30.9363729
              ],
              [
                49.9352799,
                30.9363695
              ],
              [
                49.9357032,
                30.9363663
              ],
              [
                49.9359132,
                30.9360432
              ],
              [
                49.9358658,
                30.935721
              ],
              [
                49.935852,
                30.9356276
              ],
              [
                49.9355277,
                30.9352618
              ],
              [
                49.9352035,
                30.9346163
              ],
              [
                49.9348677,
                30.9336007
              ],
              [
                49.934536,
                30.9324521
              ],
              [
                49.9341544,
                30.9318512
              ],
              [
                49.9335098,
                30.9312549
              ],
              [
                49.9329757,
                30.9311648
              ],
              [
                49.9323921,
                30.9312615
              ],
              [
                49.9321282,
                30.9312326
              ],
              [
                49.9315911,
                30.9311737
              ],
              [
                49.9311638,
                30.9310371
              ],
              [
                49.9303092,
                30.9306262
              ],
              [
                49.9285392,
                30.9295266
              ],
              [
                49.9274672,
                30.9289809
              ],
              [
                49.9260216,
                30.9282471
              ],
              [
                49.9250604,
                30.9278376
              ],
              [
                49.9243128,
                30.9276554
              ],
              [
                49.9236754,
                30.9277065
              ],
              [
                49.9234123,
                30.9278915
              ],
              [
                49.9233094,
                30.9282606
              ],
              [
                49.9233131,
                30.9286306
              ],
              [
                49.9236372,
                30.9289513
              ],
              [
                49.9240151,
                30.9294101
              ],
              [
                49.9243432,
                30.9299632
              ],
              [
                49.9246675,
                30.9305614
              ],
              [
                49.9249953,
                30.9312521
              ],
              [
                49.9253274,
                30.9320353
              ],
              [
                49.9253885,
                30.9327711
              ],
              [
                49.9253921,
                30.933096
              ],
              [
                49.9252929,
                30.9336027
              ],
              [
                49.92519,
                30.9338815
              ],
              [
                49.9242936,
                30.9343929
              ],
              [
                49.92371,
                30.9347196
              ],
              [
                49.9230768,
                30.9349512
              ],
              [
                49.9225464,
                30.9351407
              ],
              [
                49.9219094,
                30.9350971
              ],
              [
                49.9213754,
                30.935052
              ],
              [
                49.9207345,
                30.9349181
              ],
              [
                49.920044,
                30.9349213
              ],
              [
                49.9195672,
                30.9351091
              ],
              [
                49.918934,
                30.935573
              ],
              [
                49.9181442,
                30.9360852
              ],
              [
                49.9169313,
                30.9371058
              ],
              [
                49.9130823,
                30.9399404
              ],
              [
                49.9036483,
                30.9476021
              ],
              [
                49.8972626,
                30.9524808
              ],
              [
                49.8936196,
                30.9553595
              ],
              [
                49.8908654,
                30.9566215
              ],
              [
                49.8904616,
                30.9569216
              ],
              [
                49.8884887,
                30.9583876
              ],
              [
                49.8877565,
                30.9594053
              ],
              [
                49.887024,
                30.9607005
              ],
              [
                49.8865088,
                30.9625502
              ],
              [
                49.8862115,
                30.9642596
              ],
              [
                49.8863183,
                30.9644455
              ],
              [
                49.8862764,
                30.9655504
              ],
              [
                49.8862343,
                30.9665222
              ],
              [
                49.8863526,
                30.9675834
              ],
              [
                49.8864136,
                30.9682741
              ],
              [
                49.8865028,
                30.9685714
              ],
              [
                49.8866347,
                30.9690114
              ],
              [
                49.8872908,
                30.9706704
              ],
              [
                49.8878975,
                30.9721914
              ],
              [
                49.8893241,
                30.9760134
              ],
              [
                49.8901521,
                30.9784092
              ],
              [
                49.8910408,
                30.9817281
              ],
              [
                49.8920938,
                30.9852762
              ],
              [
                49.8930895,
                30.9884087
              ],
              [
                49.8947334,
                30.9924603
              ],
              [
                49.8961754,
                30.9970674
              ],
              [
                49.8964579,
                30.9986811
              ],
              [
                49.896699,
                31.0000583
              ],
              [
                49.8975831,
                31.0031628
              ],
              [
                49.8981742,
                31.0045843
              ],
              [
                49.8986169,
                31.0073332
              ],
              [
                49.8989676,
                31.0085409
              ],
              [
                49.8990555,
                31.0088437
              ],
              [
                49.8992766,
                31.0104019
              ],
              [
                49.8997117,
                31.0117319
              ],
              [
                49.8999862,
                31.0131981
              ],
              [
                49.9005318,
                31.0155802
              ],
              [
                49.9011877,
                31.0182406
              ],
              [
                49.9014624,
                31.0195241
              ],
              [
                49.9013709,
                31.0214497
              ],
              [
                49.9013786,
                31.0229159
              ],
              [
                49.901123,
                31.0244768
              ],
              [
                49.9011306,
                31.0259002
              ],
              [
                49.9008712,
                31.0270461
              ],
              [
                49.9006653,
                31.0280999
              ],
              [
                49.9002992,
                31.0289291
              ],
              [
                49.8997687,
                31.0297096
              ],
              [
                49.89964,
                31.029799
              ],
              [
                49.8987082,
                31.0304471
              ],
              [
                49.8965378,
                31.0320594
              ],
              [
                49.8948402,
                31.0333012
              ],
              [
                49.8926124,
                31.0346851
              ],
              [
                49.8907014,
                31.0361123
              ],
              [
                49.8892708,
                31.0372165
              ],
              [
                49.8884317,
                31.0377788
              ],
              [
                49.8874131,
                31.0384613
              ],
              [
                49.8855552,
                31.0394761
              ],
              [
                49.8828429,
                31.0406301
              ],
              [
                49.8812485,
                31.0414147
              ],
              [
                49.8799743,
                31.0416473
              ],
              [
                49.8787459,
                31.0417426
              ],
              [
                49.8777353,
                31.0416098
              ],
              [
                49.8765601,
                31.0412454
              ],
              [
                49.8755454,
                31.0410652
              ],
              [
                49.8751878,
                31.0409749
              ],
              [
                49.8735732,
                31.0405675
              ],
              [
                49.8711206,
                31.0403454
              ],
              [
                49.867443,
                31.0401733
              ],
              [
                49.8654747,
                31.0401785
              ],
              [
                49.8638763,
                31.0404126
              ],
              [
                49.8622285,
                31.0408311
              ],
              [
                49.8603096,
                31.0413849
              ],
              [
                49.8585588,
                31.0424453
              ],
              [
                49.8579215,
                31.0429991
              ],
              [
                49.8572312,
                31.0434125
              ],
              [
                49.8564337,
                31.0439671
              ],
              [
                49.854884,
                31.0451892
              ],
              [
                49.854683,
                31.0453477
              ],
              [
                49.8528253,
                31.0464071
              ],
              [
                49.8508568,
                31.0474227
              ],
              [
                49.849848,
                31.0476746
              ],
              [
                49.8493653,
                31.0477951
              ],
              [
                49.8484077,
                31.0477956
              ],
              [
                49.8473397,
                31.0476168
              ],
              [
                49.8473184,
                31.0476108
              ],
              [
                49.846222,
                31.0472978
              ],
              [
                49.8452071,
                31.0468422
              ],
              [
                49.8441887,
                31.046021
              ],
              [
                49.8435478,
                31.0453815
              ],
              [
                49.8427428,
                31.0443277
              ],
              [
                49.8422546,
                31.0424038
              ],
              [
                49.8416022,
                31.0393326
              ],
              [
                49.8411674,
                31.0377295
              ],
              [
                49.8400344,
                31.0347984
              ],
              [
                49.839279,
                31.032554
              ],
              [
                49.8378296,
                31.0295321
              ],
              [
                49.8361626,
                31.0265555
              ],
              [
                49.8343926,
                31.023305
              ],
              [
                49.8323517,
                31.0195987
              ],
              [
                49.8313332,
                31.0179948
              ],
              [
                49.8301049,
                31.0164408
              ],
              [
                49.8279115,
                31.0141992
              ],
              [
                49.8267899,
                31.0131041
              ],
              [
                49.825718,
                31.0119146
              ],
              [
                49.8248596,
                31.0105873
              ],
              [
                49.8244168,
                31.0100298
              ],
              [
                49.8239519,
                31.0094445
              ],
              [
                49.822876,
                31.0070618
              ],
              [
                49.821911,
                31.0047275
              ],
              [
                49.820732,
                31.002486
              ],
              [
                49.819193,
                31.0000427
              ],
              [
                49.8167794,
                30.9983244
              ],
              [
                49.8156091,
                30.996958
              ],
              [
                49.8151206,
                30.9958055
              ],
              [
                49.8141937,
                30.9930858
              ],
              [
                49.8135301,
                30.9900865
              ],
              [
                49.8131409,
                30.9882424
              ],
              [
                49.8128625,
                30.9864872
              ],
              [
                49.8127899,
                30.984134
              ],
              [
                49.8125536,
                30.9811793
              ],
              [
                49.8116148,
                30.9768895
              ],
              [
                49.8114432,
                30.9753181
              ],
              [
                49.811062,
                30.9740762
              ],
              [
                49.8103064,
                30.9727859
              ],
              [
                49.8091242,
                30.9714983
              ],
              [
                49.8077316,
                30.9702584
              ],
              [
                49.8062288,
                30.9690198
              ],
              [
                49.8048363,
                30.9681949
              ],
              [
                49.8025932,
                30.9670057
              ],
              [
                49.8003998,
                30.9658643
              ],
              [
                49.7992211,
                30.9652241
              ],
              [
                49.7978325,
                30.9646766
              ],
              [
                49.7966079,
                30.9643133
              ],
              [
                49.7956467,
                30.9642254
              ],
              [
                49.7951125,
                30.964137
              ],
              [
                49.7946319,
                30.9639521
              ],
              [
                49.7941513,
                30.9637716
              ],
              [
                49.7934571,
                30.9636366
              ],
              [
                49.7928198,
                30.9637321
              ],
              [
                49.7923926,
                30.9638274
              ],
              [
                49.7919158,
                30.9641523
              ],
              [
                49.7911226,
                30.9649884
              ],
              [
                49.7903288,
                30.9658697
              ],
              [
                49.789486,
                30.9671678
              ],
              [
                49.78891,
                30.9684187
              ],
              [
                49.7885932,
                30.9694375
              ],
              [
                49.7883911,
                30.9705928
              ],
              [
                49.7880746,
                30.9711943
              ],
              [
                49.7876511,
                30.9717497
              ],
              [
                49.7871207,
                30.9722161
              ],
              [
                49.7862701,
                30.9725893
              ],
              [
                49.7852594,
                30.9728708
              ],
              [
                49.784195,
                30.9729713
              ],
              [
                49.7829133,
                30.9727923
              ],
              [
                49.7820052,
                30.9725672
              ],
              [
                49.780674,
                30.9721103
              ],
              [
                49.779869,
                30.971699
              ],
              [
                49.779068,
                30.9712403
              ],
              [
                49.7783737,
                30.9710601
              ],
              [
                49.7780533,
                30.9710615
              ],
              [
                49.7773094,
                30.9712507
              ],
              [
                49.7766723,
                30.9717161
              ],
              [
                49.775879,
                30.9723199
              ],
              [
                49.774868,
                30.9729261
              ],
              [
                49.7742309,
                30.9732065
              ],
              [
                49.7734834,
                30.9733505
              ],
              [
                49.7727396,
                30.9735848
              ],
              [
                49.7723694,
                30.9740031
              ],
              [
                49.7722131,
                30.9743264
              ],
              [
                49.7724876,
                30.9760364
              ],
              [
                49.7728729,
                30.9780205
              ],
              [
                49.7727699,
                30.9787593
              ],
              [
                49.7726135,
                30.9795451
              ],
              [
                49.7721938,
                30.9803328
              ],
              [
                49.7715035,
                30.9807976
              ],
              [
                49.7707024,
                30.9810359
              ],
              [
                49.7700652,
                30.9810388
              ],
              [
                49.7694246,
                30.9811793
              ],
              [
                49.7689475,
                30.9817364
              ],
              [
                49.768154,
                30.9830822
              ],
              [
                49.7673683,
                30.9851182
              ],
              [
                49.7670022,
                30.9865064
              ],
              [
                49.7667962,
                30.9878939
              ],
              [
                49.7667465,
                30.9886332
              ],
              [
                49.7660559,
                30.9894702
              ],
              [
                49.7658461,
                30.9899329
              ],
              [
                49.7658499,
                30.9906254
              ],
              [
                49.7659608,
                30.9910865
              ],
              [
                49.766281,
                30.99164
              ],
              [
                49.7666587,
                30.9921466
              ],
              [
                49.7673569,
                30.9931592
              ],
              [
                49.7678946,
                30.9941252
              ],
              [
                49.7680627,
                30.995002
              ],
              [
                49.7679595,
                30.995928
              ],
              [
                49.7677496,
                30.9966681
              ],
              [
                49.7672729,
                30.9975477
              ],
              [
                49.7669069,
                30.9982435
              ],
              [
                49.765629,
                30.9992192
              ],
              [
                49.7645149,
                31.000104
              ],
              [
                49.7634325,
                31.0010951
              ],
              [
                49.7627753,
                31.0020226
              ],
              [
                49.7625121,
                31.0027125
              ],
              [
                49.7622987,
                31.0034007
              ],
              [
                49.761608,
                31.0041361
              ],
              [
                49.7606543,
                31.0047337
              ],
              [
                49.7596434,
                31.0051503
              ],
              [
                49.7583656,
                31.0054764
              ],
              [
                49.7561303,
                31.0055744
              ],
              [
                49.7541085,
                31.0054895
              ],
              [
                49.7515525,
                31.0053137
              ],
              [
                49.750096,
                31.0053041
              ],
              [
                49.748291,
                31.0045874
              ],
              [
                49.7480607,
                31.0044936
              ],
              [
                49.747383,
                31.0042177
              ],
              [
                49.7464181,
                31.0033851
              ],
              [
                49.7454566,
                31.0026472
              ],
              [
                49.7432672,
                31.0016786
              ],
              [
                49.7426299,
                31.0013566
              ],
              [
                49.7417754,
                31.0011723
              ],
              [
                49.7412451,
                31.0011739
              ],
              [
                49.7407149,
                31.0012206
              ],
              [
                49.7403451,
                31.0015441
              ],
              [
                49.7401353,
                31.0018691
              ],
              [
                49.7399826,
                31.0023773
              ],
              [
                49.7399864,
                31.0029819
              ],
              [
                49.7399901,
                31.0033969
              ],
              [
                49.7404214,
                31.0039064
              ],
              [
                49.7409021,
                31.0044163
              ],
              [
                49.7412797,
                31.004923
              ],
              [
                49.7417107,
                31.0055226
              ],
              [
                49.7418748,
                31.0059866
              ],
              [
                49.7418785,
                31.0063566
              ],
              [
                49.7418824,
                31.0069588
              ],
              [
                49.7417792,
                31.0072375
              ],
              [
                49.7414094,
                31.0076083
              ],
              [
                49.7408296,
                31.0078869
              ],
              [
                49.7399291,
                31.0082593
              ],
              [
                49.7388689,
                31.008585
              ],
              [
                49.7369574,
                31.0088663
              ],
              [
                49.7355767,
                31.009146
              ],
              [
                49.733612,
                31.0092418
              ],
              [
                49.7326584,
                31.009476
              ],
              [
                49.7320253,
                31.0098465
              ],
              [
                49.7314452,
                31.0105423
              ],
              [
                49.7308119,
                31.0110503
              ],
              [
                49.7303924,
                31.0116078
              ],
              [
                49.7300223,
                31.0120711
              ],
              [
                49.7298735,
                31.0129966
              ],
              [
                49.7297347,
                31.0132001
              ],
              [
                49.729557,
                31.0134604
              ],
              [
                49.7289772,
                31.0141111
              ],
              [
                49.7279205,
                31.0148518
              ],
              [
                49.727394,
                31.0152232
              ],
              [
                49.7266008,
                31.0155492
              ],
              [
                49.7259635,
                31.0156873
              ],
              [
                49.7250059,
                31.015644
              ],
              [
                49.7239418,
                31.0154621
              ],
              [
                49.7225571,
                31.0154168
              ],
              [
                49.7218132,
                31.015326
              ],
              [
                49.7211228,
                31.0153282
              ],
              [
                49.7205888,
                31.0151424
              ],
              [
                49.7203752,
                31.0149576
              ],
              [
                49.7203179,
                31.014542
              ],
              [
                49.7203674,
                31.0142628
              ],
              [
                49.7205239,
                31.0138471
              ],
              [
                49.7205545,
                31.0137508
              ],
              [
                49.7206268,
                31.0135233
              ],
              [
                49.7206765,
                31.0131043
              ],
              [
                49.7206766,
                31.0127344
              ],
              [
                49.7204589,
                31.0124119
              ],
              [
                49.7201921,
                31.0119492
              ],
              [
                49.7194978,
                31.011534
              ],
              [
                49.7188034,
                31.0113963
              ],
              [
                49.7180061,
                31.0111651
              ],
              [
                49.7174722,
                31.0111666
              ],
              [
                49.7166748,
                31.011215
              ],
              [
                49.7158812,
                31.0114936
              ],
              [
                49.7151946,
                31.0117732
              ],
              [
                49.7146112,
                31.0120516
              ],
              [
                49.7141343,
                31.0121912
              ],
              [
                49.7134438,
                31.0124234
              ],
              [
                49.7129668,
                31.0124254
              ],
              [
                49.7125398,
                31.0121934
              ],
              [
                49.7122191,
                31.0119173
              ],
              [
                49.7118948,
                31.0115937
              ],
              [
                49.7116853,
                31.0115465
              ],
              [
                49.7112045,
                31.011641
              ],
              [
                49.7108344,
                31.0118267
              ],
              [
                49.7106819,
                31.0124274
              ],
              [
                49.7106857,
                31.013262
              ],
              [
                49.7106437,
                31.0144187
              ],
              [
                49.7106551,
                31.0159007
              ],
              [
                49.7104223,
                31.0168762
              ],
              [
                49.7103464,
                31.0171945
              ],
              [
                49.7101899,
                31.017705
              ],
              [
                49.7097701,
                31.0181226
              ],
              [
                49.7091864,
                31.0185859
              ],
              [
                49.7086068,
                31.0188643
              ],
              [
                49.7080725,
                31.0188657
              ],
              [
                49.7079273,
                31.0188029
              ],
              [
                49.7075384,
                31.0186348
              ],
              [
                49.7071647,
                31.0183581
              ],
              [
                49.706951,
                31.0179432
              ],
              [
                49.7070541,
                31.0174323
              ],
              [
                49.7068368,
                31.01697
              ],
              [
                49.7063561,
                31.0167396
              ],
              [
                49.7057725,
                31.0169255
              ],
              [
                49.7053528,
                31.0173904
              ],
              [
                49.7047196,
                31.0184081
              ],
              [
                49.7042504,
                31.0193349
              ],
              [
                49.7041512,
                31.0203985
              ],
              [
                49.7039985,
                31.0212789
              ],
              [
                49.704384,
                31.0230827
              ],
              [
                49.7044982,
                31.0240086
              ],
              [
                49.7047212,
                31.0245607
              ],
              [
                49.7050398,
                31.0253493
              ],
              [
                49.7058487,
                31.0267355
              ],
              [
                49.7063866,
                31.0277063
              ],
              [
                49.7068216,
                31.0285407
              ],
              [
                49.7070922,
                31.029326
              ],
              [
                49.7070959,
                31.0300208
              ],
              [
                49.7069968,
                31.0306671
              ],
              [
                49.7067871,
                31.0309447
              ],
              [
                49.7060968,
                31.0311769
              ],
              [
                49.7051924,
                31.0311791
              ],
              [
                49.7044486,
                31.0311784
              ],
              [
                49.7035408,
                31.0309054
              ],
              [
                49.7027397,
                31.0304891
              ],
              [
                49.7017251,
                31.029933
              ],
              [
                49.7012245,
                31.0293761
              ],
              [
                49.7011871,
                31.0293344
              ],
              [
                49.7008133,
                31.0289179
              ],
              [
                49.7004892,
                31.0284568
              ],
              [
                49.7003785,
                31.0278557
              ],
              [
                49.7001647,
                31.0273009
              ],
              [
                49.699997,
                31.0265594
              ],
              [
                49.699993,
                31.0258647
              ],
              [
                49.6997222,
                31.0251244
              ],
              [
                49.6993447,
                31.024665
              ],
              [
                49.6990241,
                31.024479
              ],
              [
                49.6982802,
                31.0243407
              ],
              [
                49.69796,
                31.024342
              ],
              [
                49.6973267,
                31.0246649
              ],
              [
                49.6967429,
                31.0250831
              ],
              [
                49.6962699,
                31.0260098
              ],
              [
                49.6959039,
                31.0267053
              ],
              [
                49.6954345,
                31.0281396
              ],
              [
                49.6951791,
                31.0291565
              ],
              [
                49.6947061,
                31.0301306
              ],
              [
                49.6944504,
                31.0314272
              ],
              [
                49.6944086,
                31.0328139
              ],
              [
                49.6938895,
                31.034665
              ],
              [
                49.6930505,
                31.0362399
              ],
              [
                49.6924208,
                31.0375823
              ],
              [
                49.6919564,
                31.038107
              ],
              [
                49.6916809,
                31.0384183
              ],
              [
                49.6908874,
                31.0388817
              ],
              [
                49.6900902,
                31.0390653
              ],
              [
                49.6893608,
                31.0389325
              ],
              [
                49.6893425,
                31.0389292
              ],
              [
                49.6879617,
                31.0389309
              ],
              [
                49.6866303,
                31.0389332
              ],
              [
                49.6854631,
                31.0391198
              ],
              [
                49.6842957,
                31.0397214
              ],
              [
                49.6835021,
                31.0401869
              ],
              [
                49.6826057,
                31.0413912
              ],
              [
                49.6821823,
                31.0421312
              ],
              [
                49.6817666,
                31.0434262
              ],
              [
                49.6811333,
                31.044261
              ],
              [
                49.6806067,
                31.0450924
              ],
              [
                49.6798135,
                31.0457903
              ],
              [
                49.6782225,
                31.046207
              ],
              [
                49.6769448,
                31.0465345
              ],
              [
                49.6758842,
                31.0467199
              ],
              [
                49.6747132,
                31.0468139
              ],
              [
                49.6735953,
                31.0469535
              ],
              [
                49.6726912,
                31.0471404
              ],
              [
                49.6718445,
                31.0474181
              ],
              [
                49.6713712,
                31.0476794
              ],
              [
                49.6708337,
                31.0479761
              ],
              [
                49.6698302,
                31.0486695
              ],
              [
                49.6690544,
                31.0494343
              ],
              [
                49.6685599,
                31.0499217
              ],
              [
                49.6674994,
                31.0509393
              ],
              [
                49.6662864,
                31.0522823
              ],
              [
                49.6657563,
                31.0528384
              ],
              [
                49.6655502,
                31.0537182
              ],
              [
                49.6655502,
                31.0539956
              ],
              [
                49.665928,
                31.0545499
              ],
              [
                49.6663017,
                31.0549191
              ],
              [
                49.6671028,
                31.0551485
              ],
              [
                49.6681709,
                31.0556557
              ],
              [
                49.6692353,
                31.0560727
              ],
              [
                49.6700935,
                31.0566725
              ],
              [
                49.6704742,
                31.057209
              ],
              [
                49.6705207,
                31.0572746
              ],
              [
                49.6709519,
                31.0578271
              ],
              [
                49.6711655,
                31.058197
              ],
              [
                49.6712227,
                31.0587975
              ],
              [
                49.6712264,
                31.0593073
              ],
              [
                49.6711236,
                31.0595408
              ],
              [
                49.6710166,
                31.0599096
              ],
              [
                49.6707,
                31.0601409
              ],
              [
                49.6702765,
                31.060326
              ],
              [
                49.6698495,
                31.0605133
              ],
              [
                49.6689452,
                31.060513
              ],
              [
                49.6683082,
                31.0604659
              ],
              [
                49.6678277,
                31.0602353
              ],
              [
                49.6669197,
                31.0597749
              ],
              [
                49.6658477,
                31.0591751
              ],
              [
                49.6651536,
                31.0588521
              ],
              [
                49.6644632,
                31.0586217
              ],
              [
                49.6633948,
                31.0582994
              ],
              [
                49.6615256,
                31.0573304
              ],
              [
                49.6606111,
                31.0571106
              ],
              [
                49.6605644,
                31.0570994
              ],
              [
                49.6598206,
                31.0571932
              ],
              [
                49.6590232,
                31.0576112
              ],
              [
                49.6582831,
                31.0583523
              ],
              [
                49.6579665,
                31.0587685
              ],
              [
                49.6580239,
                31.0594616
              ],
              [
                49.6581344,
                31.0601552
              ],
              [
                49.6581918,
                31.0609407
              ],
              [
                49.6579819,
                31.0613106
              ],
              [
                49.6577186,
                31.0620522
              ],
              [
                49.6574096,
                31.0633008
              ],
              [
                49.6568297,
                31.0648285
              ],
              [
                49.6561967,
                31.0658459
              ],
              [
                49.6546097,
                31.0675119
              ],
              [
                49.65403,
                31.0682998
              ],
              [
                49.6538237,
                31.0693645
              ],
              [
                49.6534042,
                31.0707044
              ],
              [
                49.6527337,
                31.0718168
              ],
              [
                49.6524544,
                31.0722801
              ],
              [
                49.6518744,
                31.0731582
              ],
              [
                49.6512911,
                31.0738062
              ],
              [
                49.6505508,
                31.0745021
              ],
              [
                49.6499137,
                31.0750571
              ],
              [
                49.6488495,
                31.0752422
              ],
              [
                49.6480483,
                31.0752428
              ],
              [
                49.6475183,
                31.075244
              ],
              [
                49.6465035,
                31.0750597
              ],
              [
                49.6459159,
                31.0746904
              ],
              [
                49.6457438,
                31.0745276
              ],
              [
                49.645378,
                31.0741817
              ],
              [
                49.6447373,
                31.0733969
              ],
              [
                49.6443063,
                31.0726571
              ],
              [
                49.6437187,
                31.0721028
              ],
              [
                49.6431848,
                31.0717792
              ],
              [
                49.642437,
                31.0715954
              ],
              [
                49.6415824,
                31.0714578
              ],
              [
                49.6409987,
                31.0715509
              ],
              [
                49.6398277,
                31.071922
              ],
              [
                49.6384467,
                31.0725705
              ],
              [
                49.6366919,
                31.073497
              ],
              [
                49.6360274,
                31.0737503
              ],
              [
                49.6354714,
                31.0739623
              ],
              [
                49.6344071,
                31.0744246
              ],
              [
                49.6334497,
                31.0745183
              ],
              [
                49.6325417,
                31.0744274
              ],
              [
                49.6313704,
                31.0741511
              ],
              [
                49.6305162,
                31.0737338
              ],
              [
                49.629982,
                31.0733673
              ],
              [
                49.6296578,
                31.0729511
              ],
              [
                49.6292305,
                31.0723037
              ],
              [
                49.6290665,
                31.0713795
              ],
              [
                49.6289521,
                31.0704084
              ],
              [
                49.6287253,
                31.0697412
              ],
              [
                49.6285743,
                31.0692969
              ],
              [
                49.6280936,
                31.0684663
              ],
              [
                49.6276627,
                31.0680512
              ],
              [
                49.6265449,
                31.0675905
              ],
              [
                49.626011,
                31.0674968
              ],
              [
                49.6249465,
                31.0677291
              ],
              [
                49.6240958,
                31.0680087
              ],
              [
                49.6231917,
                31.0685652
              ],
              [
                49.6229819,
                31.0691652
              ],
              [
                49.622879,
                31.0696287
              ],
              [
                49.6228972,
                31.0697863
              ],
              [
                49.6229325,
                31.0700916
              ],
              [
                49.6232528,
                31.070368
              ],
              [
                49.6235772,
                31.0711992
              ],
              [
                49.6235276,
                31.0717084
              ],
              [
                49.6234246,
                31.072402
              ],
              [
                49.6224138,
                31.0726799
              ],
              [
                49.6217727,
                31.0726347
              ],
              [
                49.6209716,
                31.0723577
              ],
              [
                49.6192666,
                31.0715726
              ],
              [
                49.6178781,
                31.0707886
              ],
              [
                49.6169372,
                31.0701396
              ],
              [
                49.6160049,
                31.0694965
              ],
              [
                49.6141891,
                31.0683898
              ],
              [
                49.6134949,
                31.0679741
              ],
              [
                49.6126443,
                31.0678815
              ],
              [
                49.611473,
                31.0680223
              ],
              [
                49.6104089,
                31.0685792
              ],
              [
                49.6086044,
                31.0698747
              ],
              [
                49.6071206,
                31.0714939
              ],
              [
                49.606327,
                31.0728814
              ],
              [
                49.6060105,
                31.0738524
              ],
              [
                49.6060552,
                31.0739876
              ],
              [
                49.6062242,
                31.0744998
              ],
              [
                49.606655,
                31.075145
              ],
              [
                49.6070825,
                31.0757924
              ],
              [
                49.6072464,
                31.0762092
              ],
              [
                49.6071929,
                31.0765785
              ],
              [
                49.6068231,
                31.0772263
              ],
              [
                49.6060296,
                31.0783364
              ],
              [
                49.6056701,
                31.0789293
              ],
              [
                49.6050757,
                31.0799095
              ],
              [
                49.6043854,
                31.0807884
              ],
              [
                49.602688,
                31.0822225
              ],
              [
                49.6001893,
                31.0840269
              ],
              [
                49.5949249,
                31.0878219
              ],
              [
                49.5882797,
                31.0928196
              ],
              [
                49.5853042,
                31.0950852
              ],
              [
                49.5828018,
                31.097029
              ],
              [
                49.5806235,
                31.098832
              ],
              [
                49.5780714,
                31.1016525
              ],
              [
                49.5741883,
                31.1053513
              ],
              [
                49.5722731,
                31.1070623
              ],
              [
                49.5698243,
                31.1090041
              ],
              [
                49.5671082,
                31.1109475
              ],
              [
                49.56221,
                31.1147835
              ],
              [
                49.5571517,
                31.1189469
              ],
              [
                49.5521966,
                31.1228744
              ],
              [
                49.5496832,
                31.1251115
              ],
              [
                49.5481452,
                31.1264803
              ],
              [
                49.5458031,
                31.1285582
              ],
              [
                49.5441475,
                31.1296672
              ],
              [
                49.5424959,
                31.1303613
              ],
              [
                49.5404662,
                31.130963
              ],
              [
                49.537159,
                31.1314262
              ],
              [
                49.5360168,
                31.131558
              ],
              [
                49.5347557,
                31.1317034
              ],
              [
                49.5328866,
                31.1317047
              ],
              [
                49.531124,
                31.1316575
              ],
              [
                49.5276527,
                31.1315209
              ],
              [
                49.5236512,
                31.1316172
              ],
              [
                49.5198594,
                31.1318962
              ],
              [
                49.5142022,
                31.1324039
              ],
              [
                49.5079004,
                31.1324055
              ],
              [
                49.5056575,
                31.1326253
              ],
              [
                49.5030902,
                31.1328977
              ],
              [
                49.4999119,
                31.1331359
              ],
              [
                49.4952605,
                31.132581
              ],
              [
                49.493504,
                31.1322323
              ],
              [
                49.488476,
                31.131234
              ],
              [
                49.4856376,
                31.1304361
              ],
              [
                49.4808656,
                31.1287831
              ],
              [
                49.4771654,
                31.1274425
              ],
              [
                49.4738388,
                31.1259146
              ],
              [
                49.4673918,
                31.1227234
              ],
              [
                49.4652405,
                31.1214596
              ],
              [
                49.4646455,
                31.120963
              ],
              [
                49.4642106,
                31.1204166
              ],
              [
                49.4641916,
                31.1189526
              ],
              [
                49.4645424,
                31.1175765
              ],
              [
                49.4648474,
                31.1165223
              ],
              [
                49.4656218,
                31.1148671
              ],
              [
                49.4735374,
                31.0988238
              ],
              [
                49.4821662,
                31.0808058
              ],
              [
                49.4900006,
                31.064825
              ],
              [
                49.5340918,
                31.0567576
              ],
              [
                49.5588149,
                30.9818355
              ],
              [
                49.5699843,
                30.946856
              ],
              [
                49.5709954,
                30.9461116
              ],
              [
                49.5721588,
                30.9450419
              ],
              [
                49.5734824,
                30.9436942
              ],
              [
                49.5747527,
                30.9421135
              ],
              [
                49.5761757,
                30.9402549
              ],
              [
                49.5783423,
                30.9375586
              ],
              [
                49.5801391,
                30.9355146
              ],
              [
                49.5819893,
                30.9337012
              ],
              [
                49.5835763,
                30.9321645
              ],
              [
                49.5852698,
                30.9307238
              ],
              [
                49.5873953,
                30.9288167
              ],
              [
                49.587967,
                30.9283038
              ],
              [
                49.5906104,
                30.9258854
              ],
              [
                49.5946272,
                30.9221624
              ],
              [
                49.5979005,
                30.9189094
              ],
              [
                49.6003265,
                30.9165832
              ],
              [
                49.6038589,
                30.9130013
              ],
              [
                49.6097565,
                30.906817
              ],
              [
                49.6118088,
                30.9046309
              ],
              [
                49.6147574,
                30.9018859
              ],
              [
                49.6178092,
                30.8989548
              ],
              [
                49.6195487,
                30.8976043
              ],
              [
                49.6221315,
                30.8954643
              ],
              [
                49.6242904,
                30.8935542
              ],
              [
                49.6262283,
                30.8912313
              ],
              [
                49.6280098,
                30.8889992
              ],
              [
                49.6295778,
                30.8868618
              ],
              [
                49.6300431,
                30.885978
              ],
              [
                49.6303522,
                30.8850971
              ],
              [
                49.6304435,
                30.8841237
              ],
              [
                49.6303824,
                30.8833381
              ],
              [
                49.6300469,
                30.8820399
              ],
              [
                49.6298384,
                30.8816881
              ],
              [
                49.6295014,
                30.8811139
              ],
              [
                49.6291733,
                30.8803751
              ],
              [
                49.6284715,
                30.8796797
              ],
              [
                49.6283167,
                30.8795833
              ],
              [
                49.6275102,
                30.8790808
              ],
              [
                49.6259536,
                30.8781598
              ],
              [
                49.6223182,
                30.8764115
              ],
              [
                49.6190565,
                30.8748024
              ],
              [
                49.6156349,
                30.8730516
              ],
              [
                49.6138193,
                30.8721796
              ],
              [
                49.6125907,
                30.8717198
              ],
              [
                49.611313,
                30.8714467
              ],
              [
                49.6090738,
                30.8709445
              ],
              [
                49.6065217,
                30.8704434
              ],
              [
                49.6040726,
                30.8700832
              ],
              [
                49.6026878,
                30.8698088
              ],
              [
                49.6011961,
                30.869398
              ],
              [
                49.5996512,
                30.8690317
              ],
              [
                49.5986901,
                30.8686649
              ],
              [
                49.5980493,
                30.8682497
              ],
              [
                49.5974618,
                30.8677878
              ],
              [
                49.5968704,
                30.8671881
              ],
              [
                49.5962791,
                30.8664961
              ],
              [
                49.5957908,
                30.8657103
              ],
              [
                49.5955199,
                30.8650601
              ],
              [
                49.5952454,
                30.8642744
              ],
              [
                49.5952425,
                30.8642397
              ],
              [
                49.5952391,
                30.8641978
              ],
              [
                49.5951882,
                30.8635791
              ],
              [
                49.5952874,
                30.8631155
              ],
              [
                49.5952796,
                30.8625132
              ],
              [
                49.5955391,
                30.8617717
              ],
              [
                49.5959587,
                30.8612146
              ],
              [
                49.5963783,
                30.8606553
              ],
              [
                49.5967445,
                30.8602375
              ],
              [
                49.5979042,
                30.8594426
              ],
              [
                49.5986373,
                30.8589293
              ],
              [
                49.59943,
                30.8583742
              ],
              [
                49.600853,
                30.8575798
              ],
              [
                49.6048582,
                30.855063
              ],
              [
                49.6061744,
                30.8540374
              ],
              [
                49.6061174,
                30.8535744
              ],
              [
                49.6061097,
                30.853157
              ],
              [
                49.6056288,
                30.8525564
              ],
              [
                49.6055937,
                30.8525329
              ],
              [
                49.604664,
                30.8519122
              ],
              [
                49.6035386,
                30.8508941
              ],
              [
                49.6026801,
                30.8500164
              ],
              [
                49.6020356,
                30.8491862
              ],
              [
                49.6006392,
                30.8475674
              ],
              [
                49.5993501,
                30.8459521
              ],
              [
                49.5977936,
                30.8443812
              ],
              [
                49.5968285,
                30.8432723
              ],
              [
                49.595436,
                30.8420279
              ],
              [
                49.5916863,
                30.8381031
              ],
              [
                49.5832863,
                30.8297901
              ],
              [
                49.5808831,
                30.8272962
              ],
              [
                49.5786895,
                30.8250347
              ],
              [
                49.577137,
                30.8230012
              ],
              [
                49.5734483,
                30.8188917
              ],
              [
                49.5662421,
                30.811132
              ],
              [
                49.5640527,
                30.8087304
              ],
              [
                49.5618133,
                30.806423
              ],
              [
                49.560856,
                30.8055011
              ],
              [
                49.5596313,
                30.8044387
              ],
              [
                49.5551617,
                30.7998328
              ],
              [
                49.5539854,
                30.798622
              ],
              [
                49.5464288,
                30.790219
              ],
              [
                49.5387763,
                30.782277
              ],
              [
                49.5367087,
                30.7805259
              ],
              [
                49.5346413,
                30.7785876
              ],
              [
                49.5332602,
                30.7771578
              ],
              [
                49.5315131,
                30.7757734
              ],
              [
                49.5296059,
                30.7741594
              ],
              [
                49.527012,
                30.7723165
              ],
              [
                49.5233041,
                30.7693196
              ],
              [
                49.5194435,
                30.7662306
              ],
              [
                49.5182801,
                30.7652159
              ],
              [
                49.5151099,
                30.7634226
              ],
              [
                49.5132104,
                30.7623633
              ],
              [
                49.5115738,
                30.7614897
              ],
              [
                49.510727,
                30.7608461
              ],
              [
                49.5099868,
                30.7601993
              ],
              [
                49.5096169,
                30.7594575
              ],
              [
                49.5088197,
                30.7578875
              ],
              [
                49.5082361,
                30.7565455
              ],
              [
                49.5079652,
                30.75525
              ],
              [
                49.5076981,
                30.7535372
              ],
              [
                49.5071108,
                30.7516381
              ],
              [
                49.507186,
                30.7500015
              ],
              [
                49.5072174,
                30.7492755
              ],
              [
                49.5068932,
                30.7480741
              ],
              [
                49.5063019,
                30.7461343
              ],
              [
                49.5054398,
                30.743596
              ],
              [
                49.5044213,
                30.7407332
              ],
              [
                49.5036699,
                30.7387487
              ],
              [
                49.502865,
                30.7367636
              ],
              [
                49.5018996,
                30.7351961
              ],
              [
                49.5012588,
                30.7339978
              ],
              [
                49.5012551,
                30.7327031
              ],
              [
                49.5011291,
                30.7284026
              ],
              [
                49.5010641,
                30.7257223
              ],
              [
                49.5010568,
                30.7234554
              ],
              [
                49.5011426,
                30.7220944
              ],
              [
                49.5011558,
                30.7218844
              ],
              [
                49.5012549,
                30.7203563
              ],
              [
                49.5013009,
                30.7191547
              ],
              [
                49.5014039,
                30.7177687
              ],
              [
                49.5013962,
                30.7162416
              ],
              [
                49.501442,
                30.7144828
              ],
              [
                49.5013315,
                30.7131891
              ],
              [
                49.5012703,
                30.712081
              ],
              [
                49.5012627,
                30.7094464
              ],
              [
                49.5012436,
                30.7054697
              ],
              [
                49.501133,
                30.7043136
              ],
              [
                49.5008589,
                30.7039292
              ],
              [
                49.5004998,
                30.7036702
              ],
              [
                49.4999805,
                30.7034477
              ],
              [
                49.4960384,
                30.7023069
              ],
              [
                49.4938508,
                30.7016738
              ],
              [
                49.4875825,
                30.699431
              ],
              [
                49.4862406,
                30.6989508
              ],
              [
                49.4795876,
                30.6968747
              ],
              [
                49.4737359,
                30.6947986
              ],
              [
                49.4666063,
                30.6923057
              ],
              [
                49.4607544,
                30.6902764
              ],
              [
                49.4539986,
                30.68797
              ],
              [
                49.449318,
                30.6863556
              ],
              [
                49.4449539,
                30.6849253
              ],
              [
                49.4386253,
                30.6827585
              ],
              [
                49.4321898,
                30.6804977
              ],
              [
                49.4264983,
                30.6786086
              ],
              [
                49.4215544,
                30.6769495
              ],
              [
                49.4170876,
                30.6754268
              ],
              [
                49.4129906,
                30.6740438
              ],
              [
                49.4061317,
                30.6716457
              ],
              [
                49.3991128,
                30.6691595
              ],
              [
                49.3910827,
                30.6664846
              ],
              [
                49.3852348,
                30.6645061
              ],
              [
                49.381302,
                30.6631671
              ],
              [
                49.3765677,
                30.6615562
              ],
              [
                49.362961,
                30.6570414
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554895,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اندیکا",
          "name:en": "Andika County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610702",
          "wikipedia": "en:Andika County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.2362099,
                32.2491604
              ],
              [
                49.2362022,
                32.247963
              ],
              [
                49.2366258,
                32.2464874
              ],
              [
                49.2369958,
                32.2446413
              ],
              [
                49.2371484,
                32.2433514
              ],
              [
                49.2372475,
                32.2417383
              ],
              [
                49.2372515,
                32.2416806
              ],
              [
                49.2373504,
                32.2402605
              ],
              [
                49.2377702,
                32.2381851
              ],
              [
                49.2379264,
                32.2373078
              ],
              [
                49.2382372,
                32.236359
              ],
              [
                49.23835,
                32.2360149
              ],
              [
                49.2387771,
                32.2348145
              ],
              [
                49.2394716,
                32.2336584
              ],
              [
                49.2403792,
                32.2319032
              ],
              [
                49.2412834,
                32.2301908
              ],
              [
                49.2428856,
                32.2272343
              ],
              [
                49.2437935,
                32.2256617
              ],
              [
                49.244631,
                32.2242838
              ],
              [
                49.2453957,
                32.2230254
              ],
              [
                49.2468909,
                32.2206199
              ],
              [
                49.249939,
                32.2171783
              ],
              [
                49.2508355,
                32.2154702
              ],
              [
                49.2533684,
                32.2104339
              ],
              [
                49.2555809,
                32.2056322
              ],
              [
                49.2578469,
                32.2006913
              ],
              [
                49.2594834,
                32.1974555
              ],
              [
                49.2604867,
                32.1955143
              ],
              [
                49.2651292,
                32.1860916
              ],
              [
                49.2672882,
                32.1814264
              ],
              [
                49.2691269,
                32.1768605
              ],
              [
                49.269458,
                32.1758643
              ],
              [
                49.2699088,
                32.174508
              ],
              [
                49.27071,
                32.1736711
              ],
              [
                49.2717247,
                32.1727447
              ],
              [
                49.2726783,
                32.1714025
              ],
              [
                49.2732087,
                32.1707986
              ],
              [
                49.2735787,
                32.1699265
              ],
              [
                49.2736818,
                32.1694183
              ],
              [
                49.2736168,
                32.1683125
              ],
              [
                49.2734947,
                32.167163
              ],
              [
                49.2734872,
                32.1662407
              ],
              [
                49.2733154,
                32.1653702
              ],
              [
                49.2735711,
                32.1640771
              ],
              [
                49.2736167,
                32.1632952
              ],
              [
                49.2735596,
                32.1626518
              ],
              [
                49.2734414,
                32.1619602
              ],
              [
                49.2734336,
                32.1611776
              ],
              [
                49.2734298,
                32.1605349
              ],
              [
                49.2734221,
                32.1597523
              ],
              [
                49.273679,
                32.1591099
              ],
              [
                49.2737351,
                32.1589696
              ],
              [
                49.273942,
                32.1586486
              ],
              [
                49.2742119,
                32.1582297
              ],
              [
                49.274906,
                32.1575807
              ],
              [
                49.2753334,
                32.1571626
              ],
              [
                49.2757073,
                32.1569287
              ],
              [
                49.276085,
                32.1569293
              ],
              [
                49.2766267,
                32.1572456
              ],
              [
                49.2770615,
                32.1577026
              ],
              [
                49.2777671,
                32.1582939
              ],
              [
                49.2778948,
                32.1586128
              ],
              [
                49.2779886,
                32.1588472
              ],
              [
                49.2785834,
                32.1591642
              ],
              [
                49.2790718,
                32.1595316
              ],
              [
                49.2797738,
                32.1597554
              ],
              [
                49.2803115,
                32.1599341
              ],
              [
                49.2811306,
                32.1598692
              ],
              [
                49.2815513,
                32.1598359
              ],
              [
                49.2825736,
                32.159692
              ],
              [
                49.2840768,
                32.159541
              ],
              [
                49.2851337,
                32.1595015
              ],
              [
                49.2855835,
                32.1594848
              ],
              [
                49.2864439,
                32.15911
              ],
              [
                49.286869,
                32.1589249
              ],
              [
                49.2878545,
                32.1584813
              ],
              [
                49.2885322,
                32.1581762
              ],
              [
                49.2893625,
                32.1577218
              ],
              [
                49.2908324,
                32.1569175
              ],
              [
                49.2924425,
                32.156398
              ],
              [
                49.293354,
                32.1558615
              ],
              [
                49.2939522,
                32.1562459
              ],
              [
                49.2941666,
                32.1563875
              ],
              [
                49.296318,
                32.1563714
              ],
              [
                49.2977677,
                32.155994
              ],
              [
                49.2997551,
                32.1555675
              ],
              [
                49.3012656,
                32.1556058
              ],
              [
                49.3028794,
                32.1554538
              ],
              [
                49.3043251,
                32.1549839
              ],
              [
                49.3067933,
                32.1541398
              ],
              [
                49.3085559,
                32.1535024
              ],
              [
                49.3089942,
                32.1533439
              ],
              [
                49.3124811,
                32.1522133
              ],
              [
                49.3152198,
                32.151641
              ],
              [
                49.3181228,
                32.151161
              ],
              [
                49.3200569,
                32.1509161
              ],
              [
                49.3225327,
                32.150764
              ],
              [
                49.3234485,
                32.1506015
              ],
              [
                49.3236084,
                32.1505731
              ],
              [
                49.3248492,
                32.1501706
              ],
              [
                49.3260728,
                32.1497736
              ],
              [
                49.3266846,
                32.1483055
              ],
              [
                49.3316223,
                32.1469637
              ],
              [
                49.3378817,
                32.1416212
              ],
              [
                49.3382558,
                32.1367763
              ],
              [
                49.3387323,
                32.1313678
              ],
              [
                49.335015,
                32.1217144
              ],
              [
                49.3314485,
                32.1143453
              ],
              [
                49.3310126,
                32.1134376
              ],
              [
                49.334876,
                32.1079251
              ],
              [
                49.3390991,
                32.1051342
              ],
              [
                49.3395657,
                32.1021998
              ],
              [
                49.338093,
                32.0976292
              ],
              [
                49.3417556,
                32.0939084
              ],
              [
                49.3467807,
                32.0906938
              ],
              [
                49.3498407,
                32.0837466
              ],
              [
                49.3544832,
                32.0793201
              ],
              [
                49.3566589,
                32.0753294
              ],
              [
                49.3573419,
                32.0668926
              ],
              [
                49.3642472,
                32.0639262
              ],
              [
                49.3690318,
                32.0575041
              ],
              [
                49.3699855,
                32.0536277
              ],
              [
                49.3685196,
                32.0483596
              ],
              [
                49.3812943,
                32.0280491
              ],
              [
                49.3902626,
                32.0245573
              ],
              [
                49.4001317,
                32.0231406
              ],
              [
                49.4076708,
                32.0225175
              ],
              [
                49.4112138,
                32.0177626
              ],
              [
                49.4143811,
                32.0156412
              ],
              [
                49.4178057,
                32.0169691
              ],
              [
                49.4233859,
                32.0189391
              ],
              [
                49.4267603,
                32.0186589
              ],
              [
                49.4431112,
                32.0061555
              ],
              [
                49.4526386,
                32.0071639
              ],
              [
                49.4771186,
                32.0072548
              ],
              [
                49.4840236,
                32.0087604
              ],
              [
                49.4897113,
                32.0061123
              ],
              [
                49.4935317,
                32.0017572
              ],
              [
                49.4975157,
                32.0005841
              ],
              [
                49.5003605,
                32.0002879
              ],
              [
                49.5085627,
                31.9998923
              ],
              [
                49.5086174,
                32.0023009
              ],
              [
                49.5099145,
                32.0023004
              ],
              [
                49.5127869,
                32.0023431
              ],
              [
                49.5141411,
                32.002571
              ],
              [
                49.5175018,
                32.0033522
              ],
              [
                49.5193977,
                32.0040464
              ],
              [
                49.5221063,
                32.0048741
              ],
              [
                49.5237311,
                32.0053823
              ],
              [
                49.5257912,
                32.0059317
              ],
              [
                49.5268782,
                32.0065758
              ],
              [
                49.5277444,
                32.0074992
              ],
              [
                49.5289955,
                32.008975
              ],
              [
                49.5300596,
                32.0097979
              ],
              [
                49.5301324,
                32.0098542
              ],
              [
                49.5313796,
                32.0105429
              ],
              [
                49.533928,
                32.011188
              ],
              [
                49.5353355,
                32.0113261
              ],
              [
                49.5367451,
                32.0113264
              ],
              [
                49.5371247,
                32.0113264
              ],
              [
                49.5388564,
                32.0110465
              ],
              [
                49.5411302,
                32.0108607
              ],
              [
                49.5431901,
                32.0110444
              ],
              [
                49.5459519,
                32.0117346
              ],
              [
                49.5470925,
                32.012334
              ],
              [
                49.5493165,
                32.0132074
              ],
              [
                49.5506705,
                32.0135296
              ],
              [
                49.5522424,
                32.0138046
              ],
              [
                49.5544089,
                32.0141721
              ],
              [
                49.5553817,
                32.0141268
              ],
              [
                49.556034,
                32.0143354
              ],
              [
                49.5565224,
                32.0144916
              ],
              [
                49.5572816,
                32.0147709
              ],
              [
                49.558689,
                32.0152785
              ],
              [
                49.5595589,
                32.0155071
              ],
              [
                49.5601538,
                32.0157349
              ],
              [
                49.5608023,
                32.0157355
              ],
              [
                49.5615616,
                32.0157351
              ],
              [
                49.5622672,
                32.0155943
              ],
              [
                49.5626386,
                32.015437
              ],
              [
                49.5629157,
                32.0153197
              ],
              [
                49.5637246,
                32.0148553
              ],
              [
                49.5647546,
                32.0145309
              ],
              [
                49.5658913,
                32.0141153
              ],
              [
                49.5667572,
                32.0140687
              ],
              [
                49.5676766,
                32.0138807
              ],
              [
                49.5683288,
                32.0140188
              ],
              [
                49.568924,
                32.0145758
              ],
              [
                49.569416,
                32.0155917
              ],
              [
                49.5699042,
                32.0163278
              ],
              [
                49.5699082,
                32.0171127
              ],
              [
                49.5700188,
                32.0181738
              ],
              [
                49.5702361,
                32.0193286
              ],
              [
                49.5705109,
                32.0205315
              ],
              [
                49.5708923,
                32.0214536
              ],
              [
                49.571598,
                32.0228846
              ],
              [
                49.5720902,
                32.0236208
              ],
              [
                49.5726319,
                32.0241749
              ],
              [
                49.5728988,
                32.0243308
              ],
              [
                49.5734979,
                32.0246807
              ],
              [
                49.5740966,
                32.0250979
              ],
              [
                49.5750734,
                32.025375
              ],
              [
                49.5766983,
                32.0255128
              ],
              [
                49.5781593,
                32.0253713
              ],
              [
                49.5798911,
                32.0249058
              ],
              [
                49.5813522,
                32.0243539
              ],
              [
                49.5827599,
                32.0237495
              ],
              [
                49.5844346,
                32.0227308
              ],
              [
                49.5855714,
                32.0219001
              ],
              [
                49.5871962,
                32.0210229
              ],
              [
                49.5883294,
                32.0205123
              ],
              [
                49.5895232,
                32.0201873
              ],
              [
                49.590767,
                32.0200952
              ],
              [
                49.5923386,
                32.0198172
              ],
              [
                49.5947725,
                32.0187978
              ],
              [
                49.5961761,
                32.0176429
              ],
              [
                49.5990448,
                32.0161164
              ],
              [
                49.6038018,
                32.012741
              ],
              [
                49.6087226,
                32.0092274
              ],
              [
                49.6137505,
                32.0053901
              ],
              [
                49.6143009,
                32.0047165
              ],
              [
                49.6182799,
                31.9998467
              ],
              [
                49.6197821,
                31.998343
              ],
              [
                49.6218299,
                31.997046
              ],
              [
                49.6237793,
                31.9957569
              ],
              [
                49.624779,
                31.9953588
              ],
              [
                49.6264305,
                31.9947009
              ],
              [
                49.6287042,
                31.993598
              ],
              [
                49.6305465,
                31.9930924
              ],
              [
                49.6321602,
                31.9920985
              ],
              [
                49.6353024,
                31.990351
              ],
              [
                49.6507416,
                31.9911889
              ],
              [
                49.655715,
                31.9915503
              ],
              [
                49.6623774,
                31.9920896
              ],
              [
                49.6698246,
                31.9923803
              ],
              [
                49.6845366,
                31.9922234
              ],
              [
                49.6856728,
                31.9952335
              ],
              [
                49.6960238,
                32.0219595
              ],
              [
                49.6861973,
                32.0277061
              ],
              [
                49.6788751,
                32.0308054
              ],
              [
                49.6756228,
                32.0317803
              ],
              [
                49.6700133,
                32.0347986
              ],
              [
                49.6615182,
                32.0390795
              ],
              [
                49.6515638,
                32.0440922
              ],
              [
                49.6286573,
                32.0560684
              ],
              [
                49.6239662,
                32.066163
              ],
              [
                49.6216288,
                32.0743283
              ],
              [
                49.6204901,
                32.0824016
              ],
              [
                49.6230287,
                32.091571
              ],
              [
                49.6247073,
                32.0937482
              ],
              [
                49.6282865,
                32.0990497
              ],
              [
                49.6339036,
                32.1034382
              ],
              [
                49.6354903,
                32.1068673
              ],
              [
                49.6376163,
                32.113984
              ],
              [
                49.6371757,
                32.1216554
              ],
              [
                49.6354808,
                32.1266867
              ],
              [
                49.6344518,
                32.1297055
              ],
              [
                49.6315908,
                32.1351048
              ],
              [
                49.6299285,
                32.1382721
              ],
              [
                49.6275264,
                32.1423182
              ],
              [
                49.6249026,
                32.147052
              ],
              [
                49.6222679,
                32.1516744
              ],
              [
                49.6201802,
                32.1559904
              ],
              [
                49.6197179,
                32.1578549
              ],
              [
                49.6188781,
                32.1621441
              ],
              [
                49.6222081,
                32.1652404
              ],
              [
                49.6225891,
                32.1672713
              ],
              [
                49.6268273,
                32.1677745
              ],
              [
                49.6275978,
                32.1698468
              ],
              [
                49.6381018,
                32.1703841
              ],
              [
                49.6463198,
                32.1758685
              ],
              [
                49.6520572,
                32.1798862
              ],
              [
                49.657373,
                32.1869227
              ],
              [
                49.659907,
                32.195116
              ],
              [
                49.6620113,
                32.1976447
              ],
              [
                49.6722163,
                32.2012384
              ],
              [
                49.6772233,
                32.203172
              ],
              [
                49.6826377,
                32.2053923
              ],
              [
                49.6863203,
                32.2068772
              ],
              [
                49.6878203,
                32.2119174
              ],
              [
                49.6881235,
                32.2127326
              ],
              [
                49.6892504,
                32.2154408
              ],
              [
                49.6898957,
                32.2170651
              ],
              [
                49.6909448,
                32.2196246
              ],
              [
                49.6914855,
                32.2209593
              ],
              [
                49.691742,
                32.2215296
              ],
              [
                49.6948601,
                32.2249354
              ],
              [
                49.6993502,
                32.2296317
              ],
              [
                49.7040232,
                32.2305295
              ],
              [
                49.713452,
                32.2324357
              ],
              [
                49.7253369,
                32.2347662
              ],
              [
                49.7335949,
                32.2364378
              ],
              [
                49.7416088,
                32.2380492
              ],
              [
                49.7452936,
                32.2387901
              ],
              [
                49.7578718,
                32.2418015
              ],
              [
                49.7660588,
                32.2438885
              ],
              [
                49.7733783,
                32.2459296
              ],
              [
                49.7807933,
                32.248099
              ],
              [
                49.7849627,
                32.2492006
              ],
              [
                49.7872158,
                32.2501056
              ],
              [
                49.78814,
                32.2504242
              ],
              [
                49.7929775,
                32.2523486
              ],
              [
                49.7972221,
                32.2539949
              ],
              [
                49.8012375,
                32.2555331
              ],
              [
                49.804165,
                32.2567286
              ],
              [
                49.8068365,
                32.2587616
              ],
              [
                49.8092457,
                32.2606887
              ],
              [
                49.8110653,
                32.2620778
              ],
              [
                49.8125344,
                32.2632747
              ],
              [
                49.8141078,
                32.264394
              ],
              [
                49.8180432,
                32.2680343
              ],
              [
                49.821348,
                32.2710134
              ],
              [
                49.8227348,
                32.2750785
              ],
              [
                49.8243561,
                32.2771074
              ],
              [
                49.8263437,
                32.2803927
              ],
              [
                49.8267861,
                32.2811239
              ],
              [
                49.8290025,
                32.2842137
              ],
              [
                49.8306199,
                32.2879068
              ],
              [
                49.8319704,
                32.28994
              ],
              [
                49.8327254,
                32.2916451
              ],
              [
                49.8331566,
                32.2927045
              ],
              [
                49.8337517,
                32.2942277
              ],
              [
                49.8340759,
                32.2952432
              ],
              [
                49.8344535,
                32.2964893
              ],
              [
                49.8351022,
                32.2980107
              ],
              [
                49.8361815,
                32.3003187
              ],
              [
                49.8372612,
                32.3023989
              ],
              [
                49.8386652,
                32.3048428
              ],
              [
                49.8397979,
                32.3073813
              ],
              [
                49.8410415,
                32.3097832
              ],
              [
                49.8432578,
                32.3143048
              ],
              [
                49.8444442,
                32.316246
              ],
              [
                49.8452529,
                32.3182289
              ],
              [
                49.846443,
                32.3196651
              ],
              [
                49.8471452,
                32.3210494
              ],
              [
                49.8478507,
                32.3222014
              ],
              [
                49.8488235,
                32.3228959
              ],
              [
                49.8523406,
                32.3259498
              ],
              [
                49.8539433,
                32.3273208
              ],
              [
                49.8568421,
                32.3317144
              ],
              [
                49.864008,
                32.3360223
              ],
              [
                49.87014,
                32.3413552
              ],
              [
                49.874349,
                32.3450448
              ],
              [
                49.8671969,
                32.3496697
              ],
              [
                49.8530845,
                32.3596866
              ],
              [
                49.8289508,
                32.377623
              ],
              [
                49.8167877,
                32.386262
              ],
              [
                49.8102129,
                32.3930142
              ],
              [
                49.8045235,
                32.4100631
              ],
              [
                49.8010942,
                32.4196634
              ],
              [
                49.7982388,
                32.4275802
              ],
              [
                49.7904243,
                32.4342615
              ],
              [
                49.7857571,
                32.4389686
              ],
              [
                49.778963,
                32.4456327
              ],
              [
                49.7714177,
                32.4524451
              ],
              [
                49.7640036,
                32.4577814
              ],
              [
                49.7616233,
                32.4610782
              ],
              [
                49.7575284,
                32.4655334
              ],
              [
                49.7540742,
                32.4673315
              ],
              [
                49.749868,
                32.4698087
              ],
              [
                49.7462014,
                32.4717702
              ],
              [
                49.7425242,
                32.4744554
              ],
              [
                49.7404517,
                32.476356
              ],
              [
                49.7381668,
                32.4785701
              ],
              [
                49.7360458,
                32.4805941
              ],
              [
                49.7325097,
                32.4846041
              ],
              [
                49.7312048,
                32.486634
              ],
              [
                49.7292441,
                32.4886122
              ],
              [
                49.7273407,
                32.4906428
              ],
              [
                49.7233847,
                32.4944183
              ],
              [
                49.7177055,
                32.4994095
              ],
              [
                49.7174808,
                32.499608
              ],
              [
                49.7152214,
                32.5018039
              ],
              [
                49.7111625,
                32.5056568
              ],
              [
                49.7090254,
                32.5080787
              ],
              [
                49.7072716,
                32.510066
              ],
              [
                49.7055131,
                32.5118339
              ],
              [
                49.7043381,
                32.5129922
              ],
              [
                49.7031022,
                32.5137822
              ],
              [
                49.7018739,
                32.5147595
              ],
              [
                49.6978455,
                32.5168602
              ],
              [
                49.6943625,
                32.5190926
              ],
              [
                49.691677,
                32.5205372
              ],
              [
                49.6895295,
                32.521798
              ],
              [
                49.6864089,
                32.5230147
              ],
              [
                49.6841545,
                32.5242269
              ],
              [
                49.6822244,
                32.5254356
              ],
              [
                49.6799164,
                32.5270193
              ],
              [
                49.6781998,
                32.5283655
              ],
              [
                49.6762163,
                32.5296706
              ],
              [
                49.6746065,
                32.5306007
              ],
              [
                49.6729394,
                32.5313499
              ],
              [
                49.6706276,
                32.5326987
              ],
              [
                49.6684798,
                32.534047
              ],
              [
                49.6659052,
                32.5358621
              ],
              [
                49.6644555,
                32.5369765
              ],
              [
                49.6629104,
                32.5392917
              ],
              [
                49.6613617,
                32.5413318
              ],
              [
                49.6579895,
                32.5447663
              ],
              [
                49.6538046,
                32.5483859
              ],
              [
                49.6504287,
                32.551633
              ],
              [
                49.646515,
                32.555253
              ],
              [
                49.6424369,
                32.5590087
              ],
              [
                49.6429138,
                32.5618039
              ],
              [
                49.6339988,
                32.5683713
              ],
              [
                49.625492,
                32.573668
              ],
              [
                49.6214599,
                32.5804755
              ],
              [
                49.615553,
                32.5897906
              ],
              [
                49.6096134,
                32.5985551
              ],
              [
                49.6044446,
                32.6053229
              ],
              [
                49.5981825,
                32.6136233
              ],
              [
                49.5937501,
                32.6180594
              ],
              [
                49.5850411,
                32.6271839
              ],
              [
                49.5804386,
                32.6324168
              ],
              [
                49.5674783,
                32.6325492
              ],
              [
                49.5654716,
                32.6311533
              ],
              [
                49.5652999,
                32.6310338
              ],
              [
                49.5623589,
                32.6290159
              ],
              [
                49.5586585,
                32.6259879
              ],
              [
                49.5561524,
                32.6240154
              ],
              [
                49.5538674,
                32.6219529
              ],
              [
                49.5514717,
                32.6196545
              ],
              [
                49.5498924,
                32.6179992
              ],
              [
                49.5483093,
                32.6160237
              ],
              [
                49.5462378,
                32.6133614
              ],
              [
                49.5442734,
                32.6105538
              ],
              [
                49.5428046,
                32.6090395
              ],
              [
                49.5408974,
                32.6070669
              ],
              [
                49.5392113,
                32.6054125
              ],
              [
                49.5369262,
                32.6033474
              ],
              [
                49.5344277,
                32.6014219
              ],
              [
                49.5320932,
                32.5995411
              ],
              [
                49.5294304,
                32.597476
              ],
              [
                49.5274733,
                32.5961046
              ],
              [
                49.5267677,
                32.5950478
              ],
              [
                49.525627,
                32.5941324
              ],
              [
                49.5242119,
                32.5929365
              ],
              [
                49.52166,
                32.5910574
              ],
              [
                49.5198707,
                32.589821
              ],
              [
                49.5190203,
                32.5891384
              ],
              [
                49.5187301,
                32.5889056
              ],
              [
                49.5169907,
                32.5874374
              ],
              [
                49.5153617,
                32.5860178
              ],
              [
                49.5140611,
                32.5851433
              ],
              [
                49.5132906,
                32.5844017
              ],
              [
                49.5129203,
                32.5840452
              ],
              [
                49.5108605,
                32.5825348
              ],
              [
                49.5098267,
                32.5818934
              ],
              [
                49.5091781,
                32.5816197
              ],
              [
                49.5085296,
                32.5814361
              ],
              [
                49.507717,
                32.5813949
              ],
              [
                49.506256,
                32.5814023
              ],
              [
                49.5050123,
                32.581498
              ],
              [
                49.5031165,
                32.5816919
              ],
              [
                49.5015674,
                32.5816979
              ],
              [
                49.5011139,
                32.5816996
              ],
              [
                49.5000234,
                32.5816888
              ],
              [
                49.4985137,
                32.5815693
              ],
              [
                49.4969206,
                32.5816518
              ],
              [
                49.4944688,
                32.5817261
              ],
              [
                49.4925691,
                32.5817327
              ],
              [
                49.4902879,
                32.5816534
              ],
              [
                49.4887695,
                32.5814751
              ],
              [
                49.4869765,
                32.5813903
              ],
              [
                49.4860534,
                32.5812079
              ],
              [
                49.484909,
                32.5808445
              ],
              [
                49.483219,
                32.5801612
              ],
              [
                49.4808441,
                32.5792103
              ],
              [
                49.4778823,
                32.578065
              ],
              [
                49.4754334,
                32.5771063
              ],
              [
                49.4735096,
                32.576376
              ],
              [
                49.472439,
                32.5759695
              ],
              [
                49.4691161,
                32.5745536
              ],
              [
                49.4677601,
                32.5740656
              ],
              [
                49.4659577,
                32.5734169
              ],
              [
                49.4644889,
                32.5729593
              ],
              [
                49.4626923,
                32.5725089
              ],
              [
                49.4610635,
                32.5722387
              ],
              [
                49.4595574,
                32.5721004
              ],
              [
                49.4591066,
                32.5720591
              ],
              [
                49.4575348,
                32.5719767
              ],
              [
                49.4549827,
                32.5721708
              ],
              [
                49.4518393,
                32.5723644
              ],
              [
                49.4489669,
                32.5727912
              ],
              [
                49.4471778,
                32.5732111
              ],
              [
                49.4460983,
                32.5737682
              ],
              [
                49.4444197,
                32.5742796
              ],
              [
                49.442524,
                32.5749326
              ],
              [
                49.4409599,
                32.5757678
              ],
              [
                49.4401193,
                32.5762688
              ],
              [
                49.4399914,
                32.5763451
              ],
              [
                49.4390144,
                32.5769274
              ],
              [
                49.4368018,
                32.5784536
              ],
              [
                49.4346309,
                32.5801165
              ],
              [
                49.4343223,
                32.5803529
              ],
              [
                49.4311982,
                32.5830355
              ],
              [
                49.4282912,
                32.5857615
              ],
              [
                49.4258691,
                32.5881687
              ],
              [
                49.4235039,
                32.5909418
              ],
              [
                49.4209252,
                32.5939445
              ],
              [
                49.4181824,
                32.5971796
              ],
              [
                49.4153366,
                32.6006929
              ],
              [
                49.4132997,
                32.6034203
              ],
              [
                49.4110984,
                32.6062404
              ],
              [
                49.4096528,
                32.6087295
              ],
              [
                49.4061624,
                32.6128929
              ],
              [
                49.4021837,
                32.6176564
              ],
              [
                49.3992844,
                32.6213535
              ],
              [
                49.395954,
                32.6253766
              ],
              [
                49.3940736,
                32.6276434
              ],
              [
                49.3924638,
                32.6295846
              ],
              [
                49.3900415,
                32.6323631
              ],
              [
                49.3880539,
                32.6347209
              ],
              [
                49.3865511,
                32.6366611
              ],
              [
                49.3853151,
                32.6380049
              ],
              [
                49.3840256,
                32.6394855
              ],
              [
                49.3830567,
                32.6404561
              ],
              [
                49.3822517,
                32.6416138
              ],
              [
                49.3808517,
                32.6430478
              ],
              [
                49.3795624,
                32.6445307
              ],
              [
                49.3784332,
                32.6460561
              ],
              [
                49.3777925,
                32.6468889
              ],
              [
                49.3769342,
                32.6482781
              ],
              [
                49.3760187,
                32.6492922
              ],
              [
                49.3753777,
                32.6501723
              ],
              [
                49.3745118,
                32.6508218
              ],
              [
                49.3735388,
                32.6512872
              ],
              [
                49.3723488,
                32.6517069
              ],
              [
                49.3708877,
                32.6519924
              ],
              [
                49.3689346,
                32.652091
              ],
              [
                49.3666002,
                32.6520111
              ],
              [
                49.3642615,
                32.6517483
              ],
              [
                49.3623619,
                32.6514823
              ],
              [
                49.3599166,
                32.6511685
              ],
              [
                49.3580133,
                32.6509475
              ],
              [
                49.3571361,
                32.6507787
              ],
              [
                49.3556747,
                32.6504974
              ],
              [
                49.3550165,
                32.6503229
              ],
              [
                49.352955,
                32.6497763
              ],
              [
                49.3500708,
                32.6487283
              ],
              [
                49.3464737,
                32.6473167
              ],
              [
                49.3432617,
                32.646041
              ],
              [
                49.3418999,
                32.6455878
              ],
              [
                49.3408661,
                32.6452675
              ],
              [
                49.3396186,
                32.6450413
              ],
              [
                49.3372229,
                32.6444549
              ],
              [
                49.3345566,
                32.6437296
              ],
              [
                49.3319473,
                32.6429148
              ],
              [
                49.3303642,
                32.6421812
              ],
              [
                49.3290024,
                32.6412657
              ],
              [
                49.32769,
                32.6401681
              ],
              [
                49.3265914,
                32.6385571
              ],
              [
                49.3257562,
                32.636025
              ],
              [
                49.3256301,
                32.6342285
              ],
              [
                49.3257295,
                32.6328431
              ],
              [
                49.3261527,
                32.63155
              ],
              [
                49.3263548,
                32.6309897
              ],
              [
                49.3267364,
                32.629932
              ],
              [
                49.3274765,
                32.6275338
              ],
              [
                49.3281631,
                32.6255
              ],
              [
                49.3285255,
                32.623329
              ],
              [
                49.3291386,
                32.6217312
              ],
              [
                49.3292693,
                32.6213907
              ],
              [
                49.3297998,
                32.6200494
              ],
              [
                49.3309249,
                32.6183394
              ],
              [
                49.3319435,
                32.6169504
              ],
              [
                49.3328056,
                32.6160238
              ],
              [
                49.3338279,
                32.6148221
              ],
              [
                49.3357087,
                32.6125989
              ],
              [
                49.3374474,
                32.6109175
              ],
              [
                49.3383447,
                32.6100498
              ],
              [
                49.339691,
                32.6085704
              ],
              [
                49.3406563,
                32.6073678
              ],
              [
                49.342003,
                32.6060259
              ],
              [
                49.3440476,
                32.6038928
              ],
              [
                49.3455542,
                32.6025056
              ],
              [
                49.3469504,
                32.6005623
              ],
              [
                49.3481294,
                32.5989904
              ],
              [
                49.3505515,
                32.5963525
              ],
              [
                49.3523787,
                32.5944102
              ],
              [
                49.3539429,
                32.5929718
              ],
              [
                49.3556137,
                32.5916746
              ],
              [
                49.3571739,
                32.5900107
              ],
              [
                49.3581389,
                32.5886681
              ],
              [
                49.3591042,
                32.5872376
              ],
              [
                49.3611411,
                32.5841413
              ],
              [
                49.3639793,
                32.5796122
              ],
              [
                49.3648337,
                32.5781328
              ],
              [
                49.3651504,
                32.5769351
              ],
              [
                49.3655168,
                32.5754584
              ],
              [
                49.3655128,
                32.5749059
              ],
              [
                49.3654075,
                32.5743542
              ],
              [
                49.3653985,
                32.5743069
              ],
              [
                49.3654078,
                32.573705
              ],
              [
                49.3656122,
                32.5737031
              ],
              [
                49.3663294,
                32.573548
              ],
              [
                49.3671264,
                32.5733756
              ],
              [
                49.3688049,
                32.5728179
              ],
              [
                49.3711853,
                32.5716559
              ],
              [
                49.3731841,
                32.5706829
              ],
              [
                49.3765373,
                32.5695605
              ],
              [
                49.3795127,
                32.5683069
              ],
              [
                49.3831367,
                32.5667729
              ],
              [
                49.3864897,
                32.5654225
              ],
              [
                49.389679,
                32.5640293
              ],
              [
                49.3920554,
                32.5627316
              ],
              [
                49.3943825,
                32.5618008
              ],
              [
                49.3962174,
                32.5605502
              ],
              [
                49.3981054,
                32.5593003
              ],
              [
                49.4002112,
                32.5578186
              ],
              [
                49.4022522,
                32.5556911
              ],
              [
                49.4043541,
                32.5536118
              ],
              [
                49.4059601,
                32.5509804
              ],
              [
                49.4076234,
                32.5489473
              ],
              [
                49.4092864,
                32.5464564
              ],
              [
                49.410572,
                32.5445605
              ],
              [
                49.4114228,
                32.5428079
              ],
              [
                49.4123804,
                32.5404547
              ],
              [
                49.4133951,
                32.5384245
              ],
              [
                49.4146232,
                32.5362099
              ],
              [
                49.4160768,
                32.5345912
              ],
              [
                49.4174689,
                32.5325613
              ],
              [
                49.4188118,
                32.5307607
              ],
              [
                49.4205247,
                32.5281305
              ],
              [
                49.4211082,
                32.5266541
              ],
              [
                49.4215316,
                32.5255004
              ],
              [
                49.4216882,
                32.5244403
              ],
              [
                49.4216727,
                32.5225528
              ],
              [
                49.4218102,
                32.5197449
              ],
              [
                49.4216233,
                32.5168878
              ],
              [
                49.4217147,
                32.5149543
              ],
              [
                49.4216925,
                32.5142473
              ],
              [
                49.4216425,
                32.5126534
              ],
              [
                49.422104,
                32.5097503
              ],
              [
                49.4226226,
                32.5068931
              ],
              [
                49.422928,
                32.5044526
              ],
              [
                49.4236108,
                32.5019605
              ],
              [
                49.423739,
                32.500104
              ],
              [
                49.4242591,
                32.4966763
              ],
              [
                49.4254226,
                32.493676
              ],
              [
                49.4256854,
                32.4930778
              ],
              [
                49.4261131,
                32.492104
              ],
              [
                49.4262695,
                32.491089
              ],
              [
                49.4263611,
                32.4891509
              ],
              [
                49.4263604,
                32.4890451
              ],
              [
                49.4263497,
                32.4874009
              ],
              [
                49.4266548,
                32.4849086
              ],
              [
                49.4268076,
                32.4835237
              ],
              [
                49.4267845,
                32.4808536
              ],
              [
                49.4309292,
                32.479809
              ],
              [
                49.430959,
                32.4750247
              ],
              [
                49.4308357,
                32.4644522
              ],
              [
                49.4193134,
                32.4543759
              ],
              [
                49.4067674,
                32.4478897
              ],
              [
                49.4100334,
                32.4369015
              ],
              [
                49.410176,
                32.4329345
              ],
              [
                49.390833,
                32.4268992
              ],
              [
                49.3752974,
                32.4236757
              ],
              [
                49.3717193,
                32.4221232
              ],
              [
                49.3681946,
                32.4207066
              ],
              [
                49.3659743,
                32.4198841
              ],
              [
                49.3646202,
                32.419384
              ],
              [
                49.3635864,
                32.4188339
              ],
              [
                49.3628847,
                32.418606
              ],
              [
                49.3582229,
                32.4171496
              ],
              [
                49.355133,
                32.4159164
              ],
              [
                49.3531799,
                32.4148627
              ],
              [
                49.3492737,
                32.41294
              ],
              [
                49.3462907,
                32.411248
              ],
              [
                49.3441162,
                32.4097786
              ],
              [
                49.3423766,
                32.4086801
              ],
              [
                49.3411294,
                32.4080391
              ],
              [
                49.3413965,
                32.4076232
              ],
              [
                49.3414855,
                32.4069045
              ],
              [
                49.3414994,
                32.4067925
              ],
              [
                49.3417626,
                32.4060067
              ],
              [
                49.3417588,
                32.405452
              ],
              [
                49.3417512,
                32.4046672
              ],
              [
                49.3419076,
                32.4040221
              ],
              [
                49.3423308,
                32.4030986
              ],
              [
                49.3423804,
                32.4022221
              ],
              [
                49.3425461,
                32.4010612
              ],
              [
                49.3427888,
                32.3993615
              ],
              [
                49.3431548,
                32.3976052
              ],
              [
                49.3434637,
                32.3958053
              ],
              [
                49.343666,
                32.3940965
              ],
              [
                49.3436583,
                32.3929893
              ],
              [
                49.3435898,
                32.3915588
              ],
              [
                49.3433608,
                32.3895804
              ],
              [
                49.3432899,
                32.388407
              ],
              [
                49.343235,
                32.3874998
              ],
              [
                49.3428995,
                32.3863025
              ],
              [
                49.3427277,
                32.3849225
              ],
              [
                49.3428841,
                32.3840902
              ],
              [
                49.3427696,
                32.3834461
              ],
              [
                49.3427657,
                32.3828936
              ],
              [
                49.3424301,
                32.3816445
              ],
              [
                49.3406143,
                32.3776406
              ],
              [
                49.3388022,
                32.3739097
              ],
              [
                49.338417,
                32.372944
              ],
              [
                49.3382453,
                32.372112
              ],
              [
                49.3383446,
                32.3709137
              ],
              [
                49.3383371,
                32.3700364
              ],
              [
                49.3386575,
                32.3692063
              ],
              [
                49.3388673,
                32.3684649
              ],
              [
                49.3394013,
                32.3676332
              ],
              [
                49.3403626,
                32.3662455
              ],
              [
                49.3420219,
                32.3644409
              ],
              [
                49.3441698,
                32.3625907
              ],
              [
                49.3442649,
                32.3625006
              ],
              [
                49.3458327,
                32.3610161
              ],
              [
                49.3492163,
                32.3581877
              ],
              [
                49.3512001,
                32.3561977
              ],
              [
                49.3523256,
                32.3548595
              ],
              [
                49.3529129,
                32.3539313
              ],
              [
                49.3532831,
                32.3528719
              ],
              [
                49.3533286,
                32.351993
              ],
              [
                49.3531111,
                32.35144
              ],
              [
                49.3529433,
                32.35075
              ],
              [
                49.3516845,
                32.3491394
              ],
              [
                49.3510857,
                32.3483581
              ],
              [
                49.3499375,
                32.3470239
              ],
              [
                49.3494454,
                32.3459622
              ],
              [
                49.3485719,
                32.3449518
              ],
              [
                49.3479117,
                32.3437548
              ],
              [
                49.3472556,
                32.3426052
              ],
              [
                49.346817,
                32.3417291
              ],
              [
                49.3466454,
                32.3409015
              ],
              [
                49.3463173,
                32.3401193
              ],
              [
                49.3458747,
                32.3392859
              ],
              [
                49.345276,
                32.3385046
              ],
              [
                49.3446732,
                32.3377684
              ],
              [
                49.3442841,
                32.3364329
              ],
              [
                49.3436278,
                32.3353735
              ],
              [
                49.3431322,
                32.3342237
              ],
              [
                49.3431281,
                32.3336667
              ],
              [
                49.3431778,
                32.3330698
              ],
              [
                49.3439256,
                32.3317289
              ],
              [
                49.3447265,
                32.3306661
              ],
              [
                49.3453141,
                32.3299702
              ],
              [
                49.3454209,
                32.3294643
              ],
              [
                49.3453063,
                32.3287728
              ],
              [
                49.3452987,
                32.3278955
              ],
              [
                49.3455658,
                32.327342
              ],
              [
                49.3462639,
                32.3266476
              ],
              [
                49.3462761,
                32.3266283
              ],
              [
                49.3468514,
                32.3257218
              ],
              [
                49.3474884,
                32.3246613
              ],
              [
                49.3475874,
                32.3235058
              ],
              [
                49.3474732,
                32.3226317
              ],
              [
                49.3471983,
                32.3219381
              ],
              [
                49.3469811,
                32.3216173
              ],
              [
                49.3465423,
                32.321156
              ],
              [
                49.3461608,
                32.3205602
              ],
              [
                49.3459358,
                32.3194997
              ],
              [
                49.3456574,
                32.3184859
              ],
              [
                49.3453827,
                32.3180245
              ],
              [
                49.3452868,
                32.3178967
              ],
              [
                49.3447264,
                32.31715
              ],
              [
                49.3443986,
                32.3165978
              ],
              [
                49.3445016,
                32.3160444
              ],
              [
                49.3447686,
                32.3154909
              ],
              [
                49.3449584,
                32.3153385
              ],
              [
                49.3455201,
                32.3148874
              ],
              [
                49.3462181,
                32.314193
              ],
              [
                49.3464318,
                32.3139613
              ],
              [
                49.3464281,
                32.3135441
              ],
              [
                49.3463172,
                32.3131796
              ],
              [
                49.3455009,
                32.3125804
              ],
              [
                49.3451196,
                32.3121221
              ],
              [
                49.3448983,
                32.3116615
              ],
              [
                49.3448868,
                32.3101393
              ],
              [
                49.3446579,
                32.3087089
              ],
              [
                49.3443756,
                32.3071853
              ],
              [
                49.3439941,
                32.3066324
              ],
              [
                49.343609,
                32.3059418
              ],
              [
                49.3432806,
                32.3056218
              ],
              [
                49.3426321,
                32.3054397
              ],
              [
                49.3422548,
                32.3054392
              ],
              [
                49.3416596,
                32.3056253
              ],
              [
                49.3410682,
                32.306046
              ],
              [
                49.3404235,
                32.3065066
              ],
              [
                49.339451,
                32.3067847
              ],
              [
                49.3386955,
                32.3068807
              ],
              [
                49.3384948,
                32.3069388
              ],
              [
                49.3380469,
                32.3070683
              ],
              [
                49.3369673,
                32.3071173
              ],
              [
                49.3358308,
                32.3068881
              ],
              [
                49.3346902,
                32.3065708
              ],
              [
                49.3337669,
                32.3060648
              ],
              [
                49.3330042,
                32.3053783
              ],
              [
                49.332405,
                32.3047322
              ],
              [
                49.3316918,
                32.3035344
              ],
              [
                49.3310889,
                32.3025704
              ],
              [
                49.3286895,
                32.2998553
              ],
              [
                49.32798,
                32.2991649
              ],
              [
                49.3271637,
                32.2985655
              ],
              [
                49.3264579,
                32.2982901
              ],
              [
                49.3258627,
                32.2980612
              ],
              [
                49.3239669,
                32.2979323
              ],
              [
                49.3230478,
                32.2979765
              ],
              [
                49.3218041,
                32.2978449
              ],
              [
                49.321476,
                32.2976602
              ],
              [
                49.3210946,
                32.2973394
              ],
              [
                49.3210372,
                32.2966915
              ],
              [
                49.3206521,
                32.2961429
              ],
              [
                49.3203811,
                32.2959567
              ],
              [
                49.3198396,
                32.2958232
              ],
              [
                49.3188668,
                32.2958689
              ],
              [
                49.3173668,
                32.2960012
              ],
              [
                49.3172453,
                32.2960119
              ],
              [
                49.3162729,
                32.2961071
              ],
              [
                49.3154107,
                32.2964316
              ],
              [
                49.3147089,
                32.296898
              ],
              [
                49.3133968,
                32.2976327
              ],
              [
                49.3125573,
                32.2981027
              ],
              [
                49.3109932,
                32.2987515
              ],
              [
                49.3082505,
                32.3003316
              ],
              [
                49.306366,
                32.301445
              ],
              [
                49.3047982,
                32.3016788
              ],
              [
                49.3032876,
                32.3021929
              ],
              [
                49.302208,
                32.302334
              ],
              [
                49.301285,
                32.3019675
              ],
              [
                49.3009035,
                32.3014596
              ],
              [
                49.3006821,
                32.3006786
              ],
              [
                49.3008384,
                32.299984
              ],
              [
                49.3009948,
                32.2994314
              ],
              [
                49.300827,
                32.2990142
              ],
              [
                49.3002318,
                32.2987401
              ],
              [
                49.299202,
                32.2984196
              ],
              [
                49.2983895,
                32.2981448
              ],
              [
                49.2975731,
                32.2978248
              ],
              [
                49.2970277,
                32.2970891
              ],
              [
                49.2968597,
                32.2967193
              ],
              [
                49.2968522,
                32.2955219
              ],
              [
                49.2969932,
                32.2931674
              ],
              [
                49.2971419,
                32.2914579
              ],
              [
                49.2971841,
                32.290074
              ],
              [
                49.2972831,
                32.2887336
              ],
              [
                49.2972717,
                32.2875361
              ],
              [
                49.2967757,
                32.2862892
              ],
              [
                49.2963906,
                32.2855534
              ],
              [
                49.2958984,
                32.2848162
              ],
              [
                49.2955132,
                32.284263
              ],
              [
                49.2946433,
                32.2837597
              ],
              [
                49.2937203,
                32.2832985
              ],
              [
                49.2920915,
                32.2826586
              ],
              [
                49.2911148,
                32.2822463
              ],
              [
                49.2905196,
                32.2821548
              ],
              [
                49.2897643,
                32.2824783
              ],
              [
                49.2889594,
                32.2828981
              ],
              [
                49.288044,
                32.2834088
              ],
              [
                49.2866975,
                32.2842903
              ],
              [
                49.2865523,
                32.284332
              ],
              [
                49.2858885,
                32.2845228
              ],
              [
                49.2848626,
                32.2848922
              ],
              [
                49.2831383,
                32.2853626
              ],
              [
                49.2817307,
                32.2855035
              ],
              [
                49.2800027,
                32.2856942
              ],
              [
                49.2792275,
                32.2860418
              ],
              [
                49.2787628,
                32.2862501
              ],
              [
                49.2766038,
                32.2867167
              ],
              [
                49.2755776,
                32.2867658
              ],
              [
                49.2744942,
                32.2869066
              ],
              [
                49.2735749,
                32.2868647
              ],
              [
                49.2723273,
                32.2864079
              ],
              [
                49.2714044,
                32.2858541
              ],
              [
                49.2706946,
                32.2853506
              ],
              [
                49.2700921,
                32.2842442
              ],
              [
                49.2695465,
                32.2834633
              ],
              [
                49.2692641,
                32.2821245
              ],
              [
                49.2694703,
                32.2810134
              ],
              [
                49.2694625,
                32.2803233
              ],
              [
                49.269333,
                32.27769
              ],
              [
                49.2690164,
                32.2723844
              ],
              [
                49.2689971,
                32.27003
              ],
              [
                49.2686081,
                32.2685545
              ],
              [
                49.2685928,
                32.2669871
              ],
              [
                49.2683679,
                32.265922
              ],
              [
                49.2677652,
                32.2648156
              ],
              [
                49.2671548,
                32.2634362
              ],
              [
                49.2664987,
                32.2625117
              ],
              [
                49.2655143,
                32.2613144
              ],
              [
                49.26437,
                32.2602118
              ],
              [
                49.2635535,
                32.2596594
              ],
              [
                49.2626876,
                32.2594761
              ],
              [
                49.2612763,
                32.2589268
              ],
              [
                49.2594833,
                32.2580993
              ],
              [
                49.2582895,
                32.2577333
              ],
              [
                49.2567672,
                32.2569547
              ],
              [
                49.2551956,
                32.2563106
              ],
              [
                49.2536734,
                32.2555319
              ],
              [
                49.2517738,
                32.2548901
              ],
              [
                49.2499809,
                32.2540625
              ],
              [
                49.2480347,
                32.2539002
              ],
              [
                49.246333,
                32.2533535
              ],
              [
                49.2438794,
                32.2527376
              ],
              [
                49.2424734,
                32.2523888
              ],
              [
                49.2406109,
                32.2517608
              ],
              [
                49.2383682,
                32.2508569
              ],
              [
                49.236329,
                32.2500708
              ],
              [
                49.2362099,
                32.2491604
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554896,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اندیمشک",
          "name:en": "Andimeshk County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279176",
          "wikipedia": "en:Andimeshk County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.9164832,
                32.6029102
              ],
              [
                47.9159812,
                32.6028754
              ],
              [
                47.9152184,
                32.6027823
              ],
              [
                47.9147264,
                32.6024163
              ],
              [
                47.9145584,
                32.6018172
              ],
              [
                47.9146117,
                32.6011739
              ],
              [
                47.9148217,
                32.5999327
              ],
              [
                47.9151993,
                32.5986911
              ],
              [
                47.9159012,
                32.5969435
              ],
              [
                47.9166068,
                32.5959331
              ],
              [
                47.9180222,
                32.5948297
              ],
              [
                47.9207917,
                32.5926213
              ],
              [
                47.9230765,
                32.5905046
              ],
              [
                47.9247055,
                32.5888022
              ],
              [
                47.9266052,
                32.5869172
              ],
              [
                47.9275283,
                32.58632
              ],
              [
                47.9280561,
                32.5860883
              ],
              [
                47.928997,
                32.5856752
              ],
              [
                47.9305763,
                32.5850287
              ],
              [
                47.93161,
                32.584522
              ],
              [
                47.9323197,
                32.5840638
              ],
              [
                47.9326973,
                32.5835569
              ],
              [
                47.9328575,
                32.5828666
              ],
              [
                47.9328576,
                32.5824091
              ],
              [
                47.9325256,
                32.581673
              ],
              [
                47.9324847,
                32.5815836
              ],
              [
                47.9320832,
                32.5807065
              ],
              [
                47.9311524,
                32.5795095
              ],
              [
                47.9305497,
                32.5788682
              ],
              [
                47.930142,
                32.5785614
              ],
              [
                47.9300575,
                32.5784978
              ],
              [
                47.9296188,
                32.5783158
              ],
              [
                47.928421,
                32.5781332
              ],
              [
                47.9274902,
                32.578133
              ],
              [
                47.9265099,
                32.5781315
              ],
              [
                47.9257469,
                32.5784103
              ],
              [
                47.9251481,
                32.5785489
              ],
              [
                47.9247704,
                32.5791482
              ],
              [
                47.9244995,
                32.5797434
              ],
              [
                47.9240647,
                32.5803864
              ],
              [
                47.9238007,
                32.5806698
              ],
              [
                47.9232647,
                32.580911
              ],
              [
                47.9228133,
                32.5809868
              ],
              [
                47.9221611,
                32.5809392
              ],
              [
                47.9207954,
                32.5805744
              ],
              [
                47.9200162,
                32.5802791
              ],
              [
                47.9192124,
                32.5799744
              ],
              [
                47.9180641,
                32.579518
              ],
              [
                47.9170047,
                32.5793351
              ],
              [
                47.9162063,
                32.5791974
              ],
              [
                47.9145165,
                32.5791964
              ],
              [
                47.913536,
                32.5791971
              ],
              [
                47.9128266,
                32.5795178
              ],
              [
                47.9122848,
                32.5797952
              ],
              [
                47.9116288,
                32.5797948
              ],
              [
                47.9104842,
                32.5796134
              ],
              [
                47.9101259,
                32.5794954
              ],
              [
                47.9095001,
                32.5792894
              ],
              [
                47.9082985,
                32.5786468
              ],
              [
                47.9078064,
                32.5783687
              ],
              [
                47.9073677,
                32.5776817
              ],
              [
                47.9070891,
                32.5769469
              ],
              [
                47.9067146,
                32.5763164
              ],
              [
                47.9065972,
                32.5761189
              ],
              [
                47.9063226,
                32.5753819
              ],
              [
                47.9062081,
                32.5743716
              ],
              [
                47.9062576,
                32.5733157
              ],
              [
                47.9064178,
                32.5722581
              ],
              [
                47.90625,
                32.571659
              ],
              [
                47.9059219,
                32.5711528
              ],
              [
                47.9051552,
                32.5708319
              ],
              [
                47.9037362,
                32.5703281
              ],
              [
                47.9035525,
                32.5702541
              ],
              [
                47.9025917,
                32.5698671
              ],
              [
                47.9012794,
                32.5690391
              ],
              [
                47.9006195,
                32.5683061
              ],
              [
                47.9005089,
                32.5676159
              ],
              [
                47.9007103,
                32.5669758
              ],
              [
                47.9007263,
                32.5669249
              ],
              [
                47.9011575,
                32.5661422
              ],
              [
                47.9019203,
                32.5655434
              ],
              [
                47.9025689,
                32.5647616
              ],
              [
                47.9034385,
                32.5642579
              ],
              [
                47.9049644,
                32.5636599
              ],
              [
                47.9067078,
                32.5634729
              ],
              [
                47.9077987,
                32.5634277
              ],
              [
                47.9092063,
                32.5633867
              ],
              [
                47.9094354,
                32.5633801
              ],
              [
                47.9102515,
                32.5633821
              ],
              [
                47.9111241,
                32.5634937
              ],
              [
                47.9116707,
                32.5635635
              ],
              [
                47.912922,
                32.5633802
              ],
              [
                47.9135208,
                32.5632867
              ],
              [
                47.9142303,
                32.5628737
              ],
              [
                47.9147721,
                32.5619088
              ],
              [
                47.915474,
                32.5602537
              ],
              [
                47.9159547,
                32.5581806
              ],
              [
                47.9159618,
                32.5581211
              ],
              [
                47.9162178,
                32.5559738
              ],
              [
                47.9163208,
                32.5551492
              ],
              [
                47.916388,
                32.5550781
              ],
              [
                47.9169731,
                32.5544597
              ],
              [
                47.9175187,
                32.5540877
              ],
              [
                47.9182243,
                32.5538143
              ],
              [
                47.9192048,
                32.5537189
              ],
              [
                47.9202956,
                32.5539056
              ],
              [
                47.9210624,
                32.5543639
              ],
              [
                47.9218826,
                32.5548213
              ],
              [
                47.9222642,
                32.5554189
              ],
              [
                47.9229239,
                32.5562487
              ],
              [
                47.9234161,
                32.5568919
              ],
              [
                47.923748,
                32.5575333
              ],
              [
                47.9241868,
                32.5581774
              ],
              [
                47.9248962,
                32.5588236
              ],
              [
                47.925663,
                32.5593721
              ],
              [
                47.9267578,
                32.5600164
              ],
              [
                47.9280128,
                32.5605204
              ],
              [
                47.928997,
                32.5610268
              ],
              [
                47.9300347,
                32.56153
              ],
              [
                47.9315644,
                32.5623585
              ],
              [
                47.9333114,
                32.5628159
              ],
              [
                47.9350548,
                32.562908
              ],
              [
                47.93898,
                32.5629091
              ],
              [
                47.9409098,
                32.5629074
              ],
              [
                47.9409448,
                32.5629074
              ],
              [
                47.9413652,
                32.5628336
              ],
              [
                47.942524,
                32.5626303
              ],
              [
                47.9433936,
                32.5622638
              ],
              [
                47.944046,
                32.561572
              ],
              [
                47.9442595,
                32.5610205
              ],
              [
                47.9442063,
                32.5606044
              ],
              [
                47.9436569,
                32.5601471
              ],
              [
                47.9430292,
                32.5598838
              ],
              [
                47.9430007,
                32.5598719
              ],
              [
                47.9420737,
                32.5596893
              ],
              [
                47.9407653,
                32.559689
              ],
              [
                47.940384,
                32.5593642
              ],
              [
                47.9401092,
                32.5590442
              ],
              [
                47.9399413,
                32.5584
              ],
              [
                47.9398842,
                32.557941
              ],
              [
                47.9398842,
                32.5573888
              ],
              [
                47.9398804,
                32.5566517
              ],
              [
                47.9397659,
                32.5559164
              ],
              [
                47.9395981,
                32.5549499
              ],
              [
                47.9393234,
                32.5541679
              ],
              [
                47.9391021,
                32.5535742
              ],
              [
                47.9387169,
                32.5528842
              ],
              [
                47.9389305,
                32.5518729
              ],
              [
                47.938816,
                32.5506755
              ],
              [
                47.9385911,
                32.5495724
              ],
              [
                47.9383163,
                32.549018
              ],
              [
                47.9380951,
                32.5486069
              ],
              [
                47.9376029,
                32.5483785
              ],
              [
                47.9368973,
                32.5483771
              ],
              [
                47.9357528,
                32.5483785
              ],
              [
                47.9346047,
                32.54824
              ],
              [
                47.9335136,
                32.5480579
              ],
              [
                47.9323159,
                32.547828
              ],
              [
                47.9318238,
                32.5474126
              ],
              [
                47.9317131,
                32.5468644
              ],
              [
                47.9318161,
                32.5462178
              ],
              [
                47.9321441,
                32.545757
              ],
              [
                47.9327926,
                32.5449299
              ],
              [
                47.9328728,
                32.5448256
              ],
              [
                47.9336053,
                32.5438724
              ],
              [
                47.9343604,
                32.5424461
              ],
              [
                47.934486,
                32.5420723
              ],
              [
                47.9346848,
                32.5414803
              ],
              [
                47.9346806,
                32.5407961
              ],
              [
                47.9346772,
                32.5402382
              ],
              [
                47.9342385,
                32.539317
              ],
              [
                47.9339254,
                32.539005
              ],
              [
                47.9336891,
                32.5387694
              ],
              [
                47.933033,
                32.5380321
              ],
              [
                47.9325408,
                32.5375738
              ],
              [
                47.9323197,
                32.5371582
              ],
              [
                47.9323197,
                32.5365136
              ],
              [
                47.9324226,
                32.5358287
              ],
              [
                47.9328002,
                32.5349499
              ],
              [
                47.9337768,
                32.5339392
              ],
              [
                47.9344825,
                32.5332036
              ],
              [
                47.936058,
                32.5325591
              ],
              [
                47.9371889,
                32.5321876
              ],
              [
                47.9377441,
                32.5320052
              ],
              [
                47.9393768,
                32.5315897
              ],
              [
                47.9397397,
                32.5315727
              ],
              [
                47.9413413,
                32.5314978
              ],
              [
                47.9424821,
                32.5314985
              ],
              [
                47.9433022,
                32.5317731
              ],
              [
                47.9438477,
                32.532138
              ],
              [
                47.944397,
                32.5325548
              ],
              [
                47.9448357,
                32.5332462
              ],
              [
                47.9457131,
                32.5345297
              ],
              [
                47.9460449,
                32.5357706
              ],
              [
                47.9463805,
                32.5369218
              ],
              [
                47.9464341,
                32.5371054
              ],
              [
                47.9465485,
                32.5381157
              ],
              [
                47.9466096,
                32.5394515
              ],
              [
                47.9468841,
                32.5397263
              ],
              [
                47.9472122,
                32.5399101
              ],
              [
                47.9476471,
                32.5400018
              ],
              [
                47.9481925,
                32.5400917
              ],
              [
                47.9493903,
                32.5400013
              ],
              [
                47.9506988,
                32.5399091
              ],
              [
                47.951098,
                32.5397963
              ],
              [
                47.9513907,
                32.5398946
              ],
              [
                47.9525009,
                32.5398947
              ],
              [
                47.954444,
                32.5398947
              ],
              [
                47.9544439,
                32.5396147
              ],
              [
                47.9550816,
                32.5387652
              ],
              [
                47.9552775,
                32.5385041
              ],
              [
                47.9558342,
                32.5357321
              ],
              [
                47.9554319,
                32.5351251
              ],
              [
                47.9553095,
                32.5349405
              ],
              [
                47.9554099,
                32.5341114
              ],
              [
                47.9550247,
                32.5329165
              ],
              [
                47.9543647,
                32.5320891
              ],
              [
                47.9540841,
                32.5318702
              ],
              [
                47.953598,
                32.5314913
              ],
              [
                47.9531632,
                32.5313522
              ],
              [
                47.9521828,
                32.5311707
              ],
              [
                47.9517975,
                32.5309405
              ],
              [
                47.951416,
                32.5307081
              ],
              [
                47.9513055,
                32.5304327
              ],
              [
                47.9513588,
                32.530434
              ],
              [
                47.9510841,
                32.5296519
              ],
              [
                47.9509697,
                32.5286867
              ],
              [
                47.9509125,
                32.5278131
              ],
              [
                47.95047,
                32.526849
              ],
              [
                47.9498139,
                32.5259292
              ],
              [
                47.9491006,
                32.5252831
              ],
              [
                47.9484978,
                32.5247793
              ],
              [
                47.9476815,
                32.5245048
              ],
              [
                47.9464264,
                32.5244135
              ],
              [
                47.9438096,
                32.5240929
              ],
              [
                47.9424477,
                32.5240012
              ],
              [
                47.9414674,
                32.5237271
              ],
              [
                47.9407005,
                32.5232667
              ],
              [
                47.9399338,
                32.5223465
              ],
              [
                47.9393311,
                32.5216105
              ],
              [
                47.9389992,
                32.5208316
              ],
              [
                47.9388351,
                32.5200951
              ],
              [
                47.9388313,
                32.5194977
              ],
              [
                47.939373,
                32.5188055
              ],
              [
                47.9405671,
                32.5178406
              ],
              [
                47.9425773,
                32.5170105
              ],
              [
                47.9444276,
                32.5164559
              ],
              [
                47.9447129,
                32.5164253
              ],
              [
                47.9465523,
                32.5162281
              ],
              [
                47.9491653,
                32.515994
              ],
              [
                47.9509049,
                32.5156711
              ],
              [
                47.9526481,
                32.5153054
              ],
              [
                47.9538422,
                32.515118
              ],
              [
                47.9541702,
                32.5151643
              ],
              [
                47.954609,
                32.5153462
              ],
              [
                47.9548798,
                32.5155781
              ],
              [
                47.9548835,
                32.5160831
              ],
              [
                47.9547806,
                32.5169101
              ],
              [
                47.9546776,
                32.5183365
              ],
              [
                47.9546814,
                32.5191661
              ],
              [
                47.9549561,
                32.5196235
              ],
              [
                47.9555054,
                32.5201755
              ],
              [
                47.9565964,
                32.5209119
              ],
              [
                47.9573632,
                32.5214151
              ],
              [
                47.9588929,
                32.5222883
              ],
              [
                47.9606399,
                32.5232998
              ],
              [
                47.9622765,
                32.5238487
              ],
              [
                47.9637489,
                32.5242201
              ],
              [
                47.9659843,
                32.5244477
              ],
              [
                47.9687119,
                32.5247659
              ],
              [
                47.9716529,
                32.5249946
              ],
              [
                47.9772149,
                32.5253134
              ],
              [
                47.9791428,
                32.5256299
              ],
              [
                47.9794502,
                32.5256804
              ],
              [
                47.9802132,
                32.5258633
              ],
              [
                47.9806519,
                32.5263674
              ],
              [
                47.9809838,
                32.5270583
              ],
              [
                47.9810372,
                32.5275194
              ],
              [
                47.981041,
                32.5280717
              ],
              [
                47.9808274,
                32.5285309
              ],
              [
                47.9804497,
                32.5294955
              ],
              [
                47.9803749,
                32.5296238
              ],
              [
                47.9798584,
                32.5305091
              ],
              [
                47.9792061,
                32.5312463
              ],
              [
                47.9787751,
                32.5321194
              ],
              [
                47.9785614,
                32.5330384
              ],
              [
                47.9785651,
                32.5337305
              ],
              [
                47.978569,
                32.5343278
              ],
              [
                47.9786835,
                32.5349234
              ],
              [
                47.9789581,
                32.5354777
              ],
              [
                47.9793968,
                32.535939
              ],
              [
                47.9799423,
                32.5361663
              ],
              [
                47.9805985,
                32.5363511
              ],
              [
                47.9813614,
                32.536304
              ],
              [
                47.9823951,
                32.5362094
              ],
              [
                47.9842686,
                32.5359781
              ],
              [
                47.9846267,
                32.5359339
              ],
              [
                47.986805,
                32.5357923
              ],
              [
                47.9898032,
                32.5357019
              ],
              [
                47.9935607,
                32.5354696
              ],
              [
                47.9969368,
                32.5350995
              ],
              [
                47.9975361,
                32.5349377
              ],
              [
                47.9999885,
                32.5342753
              ],
              [
                48.001091,
                32.5340379
              ],
              [
                48.0029297,
                32.5336986
              ],
              [
                48.0043374,
                32.5334122
              ],
              [
                48.0057411,
                32.5330309
              ],
              [
                48.0064964,
                32.5326116
              ],
              [
                48.0079422,
                32.5313523
              ],
              [
                48.0091745,
                32.5302205
              ],
              [
                48.0098152,
                32.529632
              ],
              [
                48.0111542,
                32.5285617
              ],
              [
                48.0119158,
                32.5279594
              ],
              [
                48.0129776,
                32.5271197
              ],
              [
                48.0146828,
                32.5251654
              ],
              [
                48.0156975,
                32.5242384
              ],
              [
                48.0160638,
                32.5233567
              ],
              [
                48.0162659,
                32.5223878
              ],
              [
                48.0163041,
                32.5214646
              ],
              [
                48.016182,
                32.520497
              ],
              [
                48.0157318,
                32.5196231
              ],
              [
                48.0154489,
                32.5191301
              ],
              [
                48.0152321,
                32.5187524
              ],
              [
                48.0148392,
                32.5181075
              ],
              [
                48.0145607,
                32.5176501
              ],
              [
                48.0145493,
                32.5169601
              ],
              [
                48.0147018,
                32.516265
              ],
              [
                48.0149651,
                32.5158001
              ],
              [
                48.0153961,
                32.5156143
              ],
              [
                48.0157204,
                32.5154259
              ],
              [
                48.0159301,
                32.5150116
              ],
              [
                48.015976,
                32.5144582
              ],
              [
                48.0163384,
                32.513439
              ],
              [
                48.0168113,
                32.5124202
              ],
              [
                48.0175552,
                32.5112613
              ],
              [
                48.0182458,
                32.5103333
              ],
              [
                48.0191041,
                32.5097766
              ],
              [
                48.0197983,
                32.5090335
              ],
              [
                48.0198957,
                32.5085354
              ],
              [
                48.0205197,
                32.508549
              ],
              [
                48.021038,
                32.5085602
              ],
              [
                48.0225029,
                32.5085025
              ],
              [
                48.0237542,
                32.5085862
              ],
              [
                48.0247345,
                32.5087199
              ],
              [
                48.0259857,
                32.5090786
              ],
              [
                48.0269203,
                32.5097611
              ],
              [
                48.0276909,
                32.5103113
              ],
              [
                48.0284042,
                32.5108105
              ],
              [
                48.0292283,
                32.5115422
              ],
              [
                48.0300522,
                32.5120463
              ],
              [
                48.0306549,
                32.5123626
              ],
              [
                48.0315285,
                32.5127258
              ],
              [
                48.0325661,
                32.5129464
              ],
              [
                48.0337563,
                32.5128483
              ],
              [
                48.0350036,
                32.5126996
              ],
              [
                48.0368423,
                32.5123643
              ],
              [
                48.0379754,
                32.5119402
              ],
              [
                48.0400772,
                32.5110025
              ],
              [
                48.0412025,
                32.510071
              ],
              [
                48.0416743,
                32.5096192
              ],
              [
                48.042755,
                32.5085839
              ],
              [
                48.0443116,
                32.5075566
              ],
              [
                48.0452729,
                32.5064883
              ],
              [
                48.0466155,
                32.5055574
              ],
              [
                48.0471001,
                32.5052329
              ],
              [
                48.0478019,
                32.505042
              ],
              [
                48.0487252,
                32.5050344
              ],
              [
                48.0497055,
                32.5053053
              ],
              [
                48.0507431,
                32.5056182
              ],
              [
                48.0516204,
                32.5062135
              ],
              [
                48.0522271,
                32.5068544
              ],
              [
                48.0525628,
                32.5074032
              ],
              [
                48.0529557,
                32.5081856
              ],
              [
                48.0529709,
                32.509198
              ],
              [
                48.0529805,
                32.5098252
              ],
              [
                48.05299,
                32.5104449
              ],
              [
                48.052948,
                32.5112734
              ],
              [
                48.0532876,
                32.511962
              ],
              [
                48.0537338,
                32.512696
              ],
              [
                48.0542832,
                32.5131529
              ],
              [
                48.0557518,
                32.5133294
              ],
              [
                48.0564041,
                32.5133198
              ],
              [
                48.0576477,
                32.5131258
              ],
              [
                48.0584564,
                32.512615
              ],
              [
                48.0593147,
                32.5120085
              ],
              [
                48.0605468,
                32.5111245
              ],
              [
                48.0615082,
                32.5100087
              ],
              [
                48.0625802,
                32.5092651
              ],
              [
                48.063652,
                32.5083818
              ],
              [
                48.0647278,
                32.5077284
              ],
              [
                48.066185,
                32.5070727
              ],
              [
                48.066826,
                32.5065602
              ],
              [
                48.0670357,
                32.5060039
              ],
              [
                48.0671883,
                32.5053605
              ],
              [
                48.067337,
                32.5046202
              ],
              [
                48.0672722,
                32.5037915
              ],
              [
                48.0670433,
                32.5031933
              ],
              [
                48.0667534,
                32.5019987
              ],
              [
                48.0660896,
                32.5013588
              ],
              [
                48.0654798,
                32.5008993
              ],
              [
                48.0652007,
                32.5006889
              ],
              [
                48.0638428,
                32.4999923
              ],
              [
                48.0635435,
                32.4998005
              ],
              [
                48.0621203,
                32.4992285
              ],
              [
                48.0604973,
                32.4986316
              ],
              [
                48.0583305,
                32.4979971
              ],
              [
                48.0555688,
                32.4973216
              ],
              [
                48.0530777,
                32.4968756
              ],
              [
                48.0505333,
                32.4961555
              ],
              [
                48.049015,
                32.4956082
              ],
              [
                48.0483589,
                32.4948309
              ],
              [
                48.0478134,
                32.493912
              ],
              [
                48.0478096,
                32.4935423
              ],
              [
                48.04813,
                32.4928511
              ],
              [
                48.0486106,
                32.4919247
              ],
              [
                48.0497931,
                32.4909066
              ],
              [
                48.0512466,
                32.4901585
              ],
              [
                48.0525933,
                32.4895973
              ],
              [
                48.0526649,
                32.4895759
              ],
              [
                48.0541572,
                32.489129
              ],
              [
                48.0556717,
                32.4890293
              ],
              [
                48.0569153,
                32.48925
              ],
              [
                48.0588645,
                32.4897915
              ],
              [
                48.0606041,
                32.4908419
              ],
              [
                48.0616875,
                32.4915277
              ],
              [
                48.0630493,
                32.4924859
              ],
              [
                48.0642968,
                32.4934009
              ],
              [
                48.0653801,
                32.4937169
              ],
              [
                48.0667343,
                32.4937553
              ],
              [
                48.0674895,
                32.4937526
              ],
              [
                48.0686799,
                32.4937894
              ],
              [
                48.0699805,
                32.4940113
              ],
              [
                48.0710602,
                32.4941897
              ],
              [
                48.0714416,
                32.494557
              ],
              [
                48.0718841,
                32.4956583
              ],
              [
                48.0721091,
                32.4965831
              ],
              [
                48.0721168,
                32.4977351
              ],
              [
                48.0719987,
                32.4990442
              ],
              [
                48.071902,
                32.4997677
              ],
              [
                48.0717316,
                32.5008998
              ],
              [
                48.0716897,
                32.501823
              ],
              [
                48.0715842,
                32.502783
              ],
              [
                48.071663,
                32.5035737
              ],
              [
                48.0720558,
                32.5042659
              ],
              [
                48.0725517,
                32.5047192
              ],
              [
                48.0731544,
                32.5049924
              ],
              [
                48.073967,
                32.5050767
              ],
              [
                48.0749435,
                32.5050251
              ],
              [
                48.0757027,
                32.5048827
              ],
              [
                48.0767823,
                32.5045517
              ],
              [
                48.0781861,
                32.5041245
              ],
              [
                48.0790558,
                32.5039824
              ],
              [
                48.0799751,
                32.5038347
              ],
              [
                48.0820312,
                32.503497
              ],
              [
                48.0832787,
                32.5034403
              ],
              [
                48.0844727,
                32.5032493
              ],
              [
                48.0853311,
                32.5027801
              ],
              [
                48.0864602,
                32.5019002
              ],
              [
                48.0874214,
                32.5010141
              ],
              [
                48.0885963,
                32.4998083
              ],
              [
                48.089167,
                32.4991589
              ],
              [
                48.0897303,
                32.4982973
              ],
              [
                48.0899286,
                32.4978939
              ],
              [
                48.0903282,
                32.4963795
              ],
              [
                48.0905813,
                32.4957767
              ],
              [
                48.090908,
                32.4949954
              ],
              [
                48.0910829,
                32.494221
              ],
              [
                48.091221,
                32.4936096
              ],
              [
                48.0915412,
                32.4929205
              ],
              [
                48.0922852,
                32.4917183
              ],
              [
                48.0930329,
                32.4906536
              ],
              [
                48.0937271,
                32.4897726
              ],
              [
                48.0943183,
                32.489216
              ],
              [
                48.0954437,
                32.4883809
              ],
              [
                48.0961952,
                32.4879159
              ],
              [
                48.0972215,
                32.4877232
              ],
              [
                48.0974703,
                32.4876898
              ],
              [
                48.0979233,
                32.487629
              ],
              [
                48.098263,
                32.4876287
              ],
              [
                48.0983009,
                32.4876287
              ],
              [
                48.0986824,
                32.4877164
              ],
              [
                48.0991173,
                32.4880825
              ],
              [
                48.0994342,
                32.4888017
              ],
              [
                48.0995026,
                32.488957
              ],
              [
                48.0995064,
                32.4894642
              ],
              [
                48.0998383,
                32.4900579
              ],
              [
                48.1009255,
                32.4906082
              ],
              [
                48.1014377,
                32.4908811
              ],
              [
                48.1021195,
                32.4912443
              ],
              [
                48.1032599,
                32.4919288
              ],
              [
                48.1036454,
                32.4923862
              ],
              [
                48.1043548,
                32.4931689
              ],
              [
                48.1046829,
                32.4938099
              ],
              [
                48.1048499,
                32.4944223
              ],
              [
                48.1049081,
                32.4946355
              ],
              [
                48.1050263,
                32.4956977
              ],
              [
                48.1052017,
                32.497124
              ],
              [
                48.1055908,
                32.4981811
              ],
              [
                48.1061936,
                32.4988667
              ],
              [
                48.1067428,
                32.4997854
              ],
              [
                48.1074711,
                32.5000569
              ],
              [
                48.1111869,
                32.5003317
              ],
              [
                48.1141853,
                32.5009122
              ],
              [
                48.1165771,
                32.5012173
              ],
              [
                48.1194573,
                32.5013306
              ],
              [
                48.1215707,
                32.5011784
              ],
              [
                48.1241187,
                32.5007904
              ],
              [
                48.1252451,
                32.500406
              ],
              [
                48.1263312,
                32.4999935
              ],
              [
                48.1273647,
                32.499546
              ],
              [
                48.1275814,
                32.4994157
              ],
              [
                48.1279002,
                32.4991638
              ],
              [
                48.1285744,
                32.4982302
              ],
              [
                48.1289901,
                32.4968918
              ],
              [
                48.1295203,
                32.4959234
              ],
              [
                48.1298196,
                32.4952562
              ],
              [
                48.1299934,
                32.4946291
              ],
              [
                48.1299858,
                32.4938016
              ],
              [
                48.1298599,
                32.4921871
              ],
              [
                48.1298485,
                32.4912221
              ],
              [
                48.1297836,
                32.4902536
              ],
              [
                48.129505,
                32.4892893
              ],
              [
                48.1291695,
                32.4884611
              ],
              [
                48.1285629,
                32.4871287
              ],
              [
                48.1279487,
                32.4855188
              ],
              [
                48.1274986,
                32.4836804
              ],
              [
                48.1271601,
                32.4827876
              ],
              [
                48.1269418,
                32.4822116
              ],
              [
                48.1270943,
                32.4811985
              ],
              [
                48.1269722,
                32.4800461
              ],
              [
                48.1269073,
                32.4788928
              ],
              [
                48.1271668,
                32.4778776
              ],
              [
                48.1273727,
                32.4769581
              ],
              [
                48.1280098,
                32.4758952
              ],
              [
                48.1285439,
                32.4754792
              ],
              [
                48.1292915,
                32.4747817
              ],
              [
                48.1302566,
                32.474132
              ],
              [
                48.1311187,
                32.473942
              ],
              [
                48.1323585,
                32.4736592
              ],
              [
                48.1336555,
                32.4736054
              ],
              [
                48.1352196,
                32.4735982
              ],
              [
                48.1373329,
                32.4740453
              ],
              [
                48.1394997,
                32.4745409
              ],
              [
                48.1403159,
                32.4746615
              ],
              [
                48.1406898,
                32.4747167
              ],
              [
                48.1414986,
                32.4745751
              ],
              [
                48.142086,
                32.4741106
              ],
              [
                48.1428909,
                32.4737366
              ],
              [
                48.143425,
                32.4729035
              ],
              [
                48.1437874,
                32.4718433
              ],
              [
                48.1443711,
                32.4708737
              ],
              [
                48.144413,
                32.4698153
              ],
              [
                48.1448861,
                32.468708
              ],
              [
                48.1449852,
                32.4676936
              ],
              [
                48.1450195,
                32.4663127
              ],
              [
                48.1448478,
                32.4651614
              ],
              [
                48.1448044,
                32.4650098
              ],
              [
                48.1446762,
                32.4645624
              ],
              [
                48.1446113,
                32.4634587
              ],
              [
                48.1447106,
                32.4628141
              ],
              [
                48.1449203,
                32.46212
              ],
              [
                48.1457252,
                32.4618881
              ],
              [
                48.146965,
                32.461648
              ],
              [
                48.1487389,
                32.4611314
              ],
              [
                48.1492458,
                32.4609915
              ],
              [
                48.1507836,
                32.4605669
              ],
              [
                48.1519128,
                32.4602386
              ],
              [
                48.153202,
                32.4594495
              ],
              [
                48.1543808,
                32.4587053
              ],
              [
                48.1554452,
                32.4576406
              ],
              [
                48.1557084,
                32.4569974
              ],
              [
                48.15596,
                32.4555199
              ],
              [
                48.1559983,
                32.4542765
              ],
              [
                48.1556626,
                32.4531756
              ],
              [
                48.1550026,
                32.4521171
              ],
              [
                48.1543961,
                32.4511521
              ],
              [
                48.1533623,
                32.4505607
              ],
              [
                48.1523285,
                32.4495545
              ],
              [
                48.1522213,
                32.4494878
              ],
              [
                48.1510773,
                32.4487756
              ],
              [
                48.1491814,
                32.4480046
              ],
              [
                48.1471177,
                32.4468195
              ],
              [
                48.1460266,
                32.445812
              ],
              [
                48.1450995,
                32.4449434
              ],
              [
                48.1444434,
                32.4441644
              ],
              [
                48.1440468,
                32.442555
              ],
              [
                48.1439285,
                32.4415402
              ],
              [
                48.1440239,
                32.4407128
              ],
              [
                48.1443328,
                32.4392367
              ],
              [
                48.1444777,
                32.4380385
              ],
              [
                48.1453284,
                32.4369285
              ],
              [
                48.1463929,
                32.4354942
              ],
              [
                48.1478767,
                32.4335059
              ],
              [
                48.1493187,
                32.4323958
              ],
              [
                48.1506004,
                32.4313744
              ],
              [
                48.1515046,
                32.4303557
              ],
              [
                48.1524087,
                32.4292897
              ],
              [
                48.1527253,
                32.4286454
              ],
              [
                48.1530418,
                32.4279515
              ],
              [
                48.1536712,
                32.4266629
              ],
              [
                48.1536561,
                32.4253732
              ],
              [
                48.1537972,
                32.4236678
              ],
              [
                48.1537819,
                32.4222406
              ],
              [
                48.1536064,
                32.4211343
              ],
              [
                48.1529884,
                32.4191142
              ],
              [
                48.1525344,
                32.4170865
              ],
              [
                48.1509475,
                32.4151143
              ],
              [
                48.1500702,
                32.4136
              ],
              [
                48.1493569,
                32.4126394
              ],
              [
                48.1488076,
                32.4117659
              ],
              [
                48.1484718,
                32.4107101
              ],
              [
                48.1484565,
                32.4092378
              ],
              [
                48.1483765,
                32.4072569
              ],
              [
                48.1482468,
                32.4051396
              ],
              [
                48.1486474,
                32.4025114
              ],
              [
                48.1489563,
                32.3968019
              ],
              [
                48.1490708,
                32.3928824
              ],
              [
                48.1490937,
                32.3903966
              ],
              [
                48.1491165,
                32.3875434
              ],
              [
                48.1492538,
                32.3856553
              ],
              [
                48.1492958,
                32.3847321
              ],
              [
                48.1499291,
                32.3834413
              ],
              [
                48.1508217,
                32.38187
              ],
              [
                48.1517715,
                32.3800702
              ],
              [
                48.1528854,
                32.3790517
              ],
              [
                48.1548203,
                32.3780744
              ],
              [
                48.1555595,
                32.377701
              ],
              [
                48.1574212,
                32.3761246
              ],
              [
                48.1580544,
                32.3752485
              ],
              [
                48.1589049,
                32.374463
              ],
              [
                48.1593781,
                32.3733105
              ],
              [
                48.1595725,
                32.3719263
              ],
              [
                48.1596642,
                32.3704993
              ],
              [
                48.1595954,
                32.3691633
              ],
              [
                48.1591453,
                32.3674625
              ],
              [
                48.1582183,
                32.3666392
              ],
              [
                48.1560058,
                32.3657733
              ],
              [
                48.1543273,
                32.3648157
              ],
              [
                48.1542175,
                32.364745
              ],
              [
                48.1529733,
                32.3639443
              ],
              [
                48.1521072,
                32.36312
              ],
              [
                48.1514015,
                32.3626172
              ],
              [
                48.1501465,
                32.3610605
              ],
              [
                48.1493263,
                32.3598675
              ],
              [
                48.1483422,
                32.358211
              ],
              [
                48.1481057,
                32.3566008
              ],
              [
                48.1479224,
                32.3548091
              ],
              [
                48.1479454,
                32.3520438
              ],
              [
                48.1476402,
                32.3487774
              ],
              [
                48.148201,
                32.3462407
              ],
              [
                48.1479416,
                32.3443681
              ],
              [
                48.1509362,
                32.3370178
              ],
              [
                48.152955,
                32.3321407
              ],
              [
                48.170556,
                32.3335482
              ],
              [
                48.1737462,
                32.3349755
              ],
              [
                48.1744881,
                32.3365403
              ],
              [
                48.1756249,
                32.3373637
              ],
              [
                48.1768189,
                32.3383259
              ],
              [
                48.177475,
                32.3393324
              ],
              [
                48.1778717,
                32.3408516
              ],
              [
                48.1784859,
                32.342689
              ],
              [
                48.1790619,
                32.3457269
              ],
              [
                48.1796418,
                32.3489002
              ],
              [
                48.179882,
                32.3508802
              ],
              [
                48.1808243,
                32.3529436
              ],
              [
                48.1813813,
                32.3546444
              ],
              [
                48.1820412,
                32.3556555
              ],
              [
                48.1831856,
                32.3567991
              ],
              [
                48.1843223,
                32.3576698
              ],
              [
                48.1858406,
                32.3584905
              ],
              [
                48.187889,
                32.3590366
              ],
              [
                48.1899872,
                32.3592525
              ],
              [
                48.1920242,
                32.3589665
              ],
              [
                48.1976471,
                32.3576513
              ],
              [
                48.2038536,
                32.3560557
              ],
              [
                48.2072257,
                32.3553054
              ],
              [
                48.2094192,
                32.3546935
              ],
              [
                48.2109681,
                32.3539501
              ],
              [
                48.2118112,
                32.3528394
              ],
              [
                48.2121163,
                32.3518746
              ],
              [
                48.2122193,
                32.3513675
              ],
              [
                48.2125855,
                32.3508143
              ],
              [
                48.2127991,
                32.35081
              ],
              [
                48.2137147,
                32.3510353
              ],
              [
                48.2140389,
                32.3511733
              ],
              [
                48.2151146,
                32.3512601
              ],
              [
                48.2159691,
                32.3508868
              ],
              [
                48.2163963,
                32.3507046
              ],
              [
                48.2175026,
                32.3492706
              ],
              [
                48.2224618,
                32.3434492
              ],
              [
                48.226635,
                32.3391003
              ],
              [
                48.2304268,
                32.3344341
              ],
              [
                48.2311592,
                32.3333749
              ],
              [
                48.2317276,
                32.3320349
              ],
              [
                48.2323456,
                32.3302834
              ],
              [
                48.2324295,
                32.3288583
              ],
              [
                48.2327804,
                32.32734
              ],
              [
                48.2329063,
                32.3250344
              ],
              [
                48.2329901,
                32.3236576
              ],
              [
                48.2329903,
                32.3236544
              ],
              [
                48.2331924,
                32.3226896
              ],
              [
                48.2335586,
                32.3221318
              ],
              [
                48.2348068,
                32.3211315
              ],
              [
                48.234829,
                32.3211137
              ],
              [
                48.2367325,
                32.3194963
              ],
              [
                48.2373123,
                32.3187561
              ],
              [
                48.2381019,
                32.3179236
              ],
              [
                48.238884,
                32.3165859
              ],
              [
                48.2396735,
                32.3155708
              ],
              [
                48.2405014,
                32.3138667
              ],
              [
                48.2419815,
                32.312524
              ],
              [
                48.2432441,
                32.310906
              ],
              [
                48.2450919,
                32.3085575
              ],
              [
                48.2451325,
                32.308506
              ],
              [
                48.245178,
                32.3084687
              ],
              [
                48.2459258,
                32.3078583
              ],
              [
                48.247194,
                32.307345
              ],
              [
                48.2485884,
                32.3069065
              ],
              [
                48.2500973,
                32.3066599
              ],
              [
                48.2525367,
                32.3049976
              ],
              [
                48.2536506,
                32.3041156
              ],
              [
                48.2546005,
                32.3031377
              ],
              [
                48.2556573,
                32.3022117
              ],
              [
                48.2567711,
                32.3014221
              ],
              [
                48.2575607,
                32.3005872
              ],
              [
                48.2581367,
                32.2996146
              ],
              [
                48.2587586,
                32.2983207
              ],
              [
                48.259594,
                32.2969773
              ],
              [
                48.260212,
                32.2955885
              ],
              [
                48.2610473,
                32.2942
              ],
              [
                48.2618828,
                32.2928115
              ],
              [
                48.2628212,
                32.2911006
              ],
              [
                48.2635459,
                32.2895745
              ],
              [
                48.2644086,
                32.2854331
              ],
              [
                48.2657433,
                32.2807825
              ],
              [
                48.268846,
                32.281059
              ],
              [
                48.2722283,
                32.2816855
              ],
              [
                48.2733993,
                32.2810368
              ],
              [
                48.2749481,
                32.2802429
              ],
              [
                48.2763367,
                32.2795899
              ],
              [
                48.2776718,
                32.2789875
              ],
              [
                48.2787933,
                32.2786149
              ],
              [
                48.2797547,
                32.2781488
              ],
              [
                48.2807084,
                32.2773127
              ],
              [
                48.2810012,
                32.2770305
              ],
              [
                48.2821885,
                32.2783271
              ],
              [
                48.2836608,
                32.2799349
              ],
              [
                48.2843936,
                32.2811901
              ],
              [
                48.2854347,
                32.2829734
              ],
              [
                48.2871476,
                32.2855531
              ],
              [
                48.2875404,
                32.2864294
              ],
              [
                48.288311,
                32.2875325
              ],
              [
                48.2886466,
                32.2883197
              ],
              [
                48.2891006,
                32.2897001
              ],
              [
                48.2897949,
                32.2925599
              ],
              [
                48.2902183,
                32.2953755
              ],
              [
                48.290741,
                32.2975463
              ],
              [
                48.2912064,
                32.2997136
              ],
              [
                48.2913132,
                32.3028065
              ],
              [
                48.2912407,
                32.3048405
              ],
              [
                48.2914963,
                32.3071927
              ],
              [
                48.2923126,
                32.3110695
              ],
              [
                48.2925643,
                32.3132864
              ],
              [
                48.292839,
                32.3167007
              ],
              [
                48.2931405,
                32.3187788
              ],
              [
                48.2932969,
                32.3216406
              ],
              [
                48.293869,
                32.3268083
              ],
              [
                48.294365,
                32.3308721
              ],
              [
                48.2949562,
                32.3339618
              ],
              [
                48.2956962,
                32.3364529
              ],
              [
                48.2966537,
                32.3393138
              ],
              [
                48.2982808,
                32.3423265
              ],
              [
                48.3000145,
                32.3452221
              ],
              [
                48.3009171,
                32.3468013
              ],
              [
                48.3022019,
                32.3485962
              ],
              [
                48.3032654,
                32.3501022
              ],
              [
                48.3041294,
                32.3516085
              ],
              [
                48.3065883,
                32.3555519
              ],
              [
                48.3072529,
                32.356682
              ],
              [
                48.3082255,
                32.3580576
              ],
              [
                48.3094239,
                32.3598054
              ],
              [
                48.3101107,
                32.3605595
              ],
              [
                48.3106646,
                32.3611777
              ],
              [
                48.3113957,
                32.3619552
              ],
              [
                48.3122153,
                32.3629961
              ],
              [
                48.313035,
                32.364125
              ],
              [
                48.313611,
                32.3649894
              ],
              [
                48.3147186,
                32.3672266
              ],
              [
                48.3153833,
                32.3684671
              ],
              [
                48.3163566,
                32.3700748
              ],
              [
                48.3174057,
                32.3718262
              ],
              [
                48.3187255,
                32.3740387
              ],
              [
                48.3194961,
                32.3754189
              ],
              [
                48.320057,
                32.3769412
              ],
              [
                48.3202896,
                32.3781386
              ],
              [
                48.3208542,
                32.3798481
              ],
              [
                48.3216362,
                32.3819702
              ],
              [
                48.3223534,
                32.3833042
              ],
              [
                48.3230744,
                32.384778
              ],
              [
                48.3233032,
                32.3857454
              ],
              [
                48.3235856,
                32.3868515
              ],
              [
                48.3241996,
                32.3884651
              ],
              [
                48.3248176,
                32.3903132
              ],
              [
                48.3253785,
                32.3919256
              ],
              [
                48.3262025,
                32.3931694
              ],
              [
                48.3274612,
                32.3949161
              ],
              [
                48.3282813,
                32.3962523
              ],
              [
                48.3294792,
                32.3975401
              ],
              [
                48.3310014,
                32.3990128
              ],
              [
                48.3332825,
                32.4012185
              ],
              [
                48.3351822,
                32.4029652
              ],
              [
                48.3393058,
                32.4065938
              ],
              [
                48.342289,
                32.4094431
              ],
              [
                48.3451653,
                32.4122494
              ],
              [
                48.3470923,
                32.4095408
              ],
              [
                48.3501399,
                32.4059277
              ],
              [
                48.3401745,
                32.4211795
              ],
              [
                48.349349,
                32.4261173
              ],
              [
                48.3514903,
                32.4276206
              ],
              [
                48.3517181,
                32.4276594
              ],
              [
                48.3538316,
                32.4280737
              ],
              [
                48.3540661,
                32.4278001
              ],
              [
                48.3544082,
                32.4278367
              ],
              [
                48.3546811,
                32.4276441
              ],
              [
                48.3554733,
                32.4276756
              ],
              [
                48.3565781,
                32.4278634
              ],
              [
                48.3588155,
                32.4282392
              ],
              [
                48.361568,
                32.4285599
              ],
              [
                48.3626569,
                32.4288136
              ],
              [
                48.3643584,
                32.4283913
              ],
              [
                48.3649212,
                32.4286289
              ],
              [
                48.3621704,
                32.4330685
              ],
              [
                48.3655484,
                32.4343152
              ],
              [
                48.3662796,
                32.4351784
              ],
              [
                48.3618395,
                32.4430282
              ],
              [
                48.3620031,
                32.4433187
              ],
              [
                48.3621073,
                32.4440886
              ],
              [
                48.3662796,
                32.4474382
              ],
              [
                48.3693909,
                32.4504078
              ],
              [
                48.372395,
                32.4532325
              ],
              [
                48.3732748,
                32.4535765
              ],
              [
                48.386364,
                32.45861
              ],
              [
                48.3995647,
                32.4442187
              ],
              [
                48.4020937,
                32.4418168
              ],
              [
                48.4023352,
                32.441702
              ],
              [
                48.4078225,
                32.4437098
              ],
              [
                48.4116023,
                32.4405129
              ],
              [
                48.4184317,
                32.4341476
              ],
              [
                48.4211744,
                32.4282806
              ],
              [
                48.422709,
                32.4246913
              ],
              [
                48.4238591,
                32.4226041
              ],
              [
                48.4287612,
                32.4179988
              ],
              [
                48.4304044,
                32.4196619
              ],
              [
                48.4328989,
                32.4151516
              ],
              [
                48.4344792,
                32.4163185
              ],
              [
                48.4400337,
                32.4199784
              ],
              [
                48.4456971,
                32.4236122
              ],
              [
                48.4491851,
                32.4285432
              ],
              [
                48.4492883,
                32.4306776
              ],
              [
                48.4501991,
                32.4308542
              ],
              [
                48.4504203,
                32.4316815
              ],
              [
                48.450428,
                32.4323309
              ],
              [
                48.4503288,
                32.433021
              ],
              [
                48.4501763,
                32.433852
              ],
              [
                48.4498063,
                32.4345005
              ],
              [
                48.4490127,
                32.4353366
              ],
              [
                48.4479027,
                32.4363105
              ],
              [
                48.4472656,
                32.4369626
              ],
              [
                48.4463653,
                32.4377018
              ],
              [
                48.4459991,
                32.4383504
              ],
              [
                48.4456292,
                32.4389065
              ],
              [
                48.44553,
                32.439689
              ],
              [
                48.4455413,
                32.4406135
              ],
              [
                48.445652,
                32.4413529
              ],
              [
                48.4460944,
                32.4425973
              ],
              [
                48.4465866,
                32.4437029
              ],
              [
                48.4471283,
                32.4446224
              ],
              [
                48.447834,
                32.4456827
              ],
              [
                48.448803,
                32.4466018
              ],
              [
                48.4498253,
                32.44738
              ],
              [
                48.451172,
                32.4483902
              ],
              [
                48.4522972,
                32.4489405
              ],
              [
                48.4534225,
                32.4491661
              ],
              [
                48.4563892,
                32.4492198
              ],
              [
                48.4580173,
                32.4492919
              ],
              [
                48.4606986,
                32.4494
              ],
              [
                48.4625534,
                32.4497086
              ],
              [
                48.4649142,
                32.4505784
              ],
              [
                48.4670639,
                32.4517814
              ],
              [
                48.4685097,
                32.4522817
              ],
              [
                48.469635,
                32.4528318
              ],
              [
                48.4702835,
                32.4534265
              ],
              [
                48.4706613,
                32.4539796
              ],
              [
                48.4710426,
                32.4547605
              ],
              [
                48.471531,
                32.4557758
              ],
              [
                48.4718588,
                32.4566999
              ],
              [
                48.4726142,
                32.4576191
              ],
              [
                48.4731521,
                32.4580311
              ],
              [
                48.4741174,
                32.4583008
              ],
              [
                48.4754523,
                32.4586679
              ],
              [
                48.477375,
                32.4587065
              ],
              [
                48.4795608,
                32.4584618
              ],
              [
                48.4816933,
                32.4581753
              ],
              [
                48.4835625,
                32.457985
              ],
              [
                48.4869271,
                32.4581064
              ],
              [
                48.4885788,
                32.4580988
              ],
              [
                48.4898109,
                32.4582789
              ],
              [
                48.4911996,
                32.4587327
              ],
              [
                48.492649,
                32.4593725
              ],
              [
                48.4937209,
                32.4599236
              ],
              [
                48.494953,
                32.460656
              ],
              [
                48.4963493,
                32.4616194
              ],
              [
                48.4973144,
                32.4624907
              ],
              [
                48.4981233,
                32.4634559
              ],
              [
                48.4989319,
                32.4647457
              ],
              [
                48.4995307,
                32.4662658
              ],
              [
                48.4999732,
                32.4681998
              ],
              [
                48.5001718,
                32.4697457
              ],
              [
                48.5004998,
                32.4712266
              ],
              [
                48.500881,
                32.4723366
              ],
              [
                48.5016976,
                32.4736783
              ],
              [
                48.5017015,
                32.4741406
              ],
              [
                48.5017549,
                32.4746015
              ],
              [
                48.5020828,
                32.4762695
              ],
              [
                48.5025215,
                32.4779329
              ],
              [
                48.502468,
                32.4795077
              ],
              [
                48.5025253,
                32.4804308
              ],
              [
                48.5029067,
                32.4814033
              ],
              [
                48.5029105,
                32.4821428
              ],
              [
                48.5031816,
                32.4830657
              ],
              [
                48.5034027,
                32.4840395
              ],
              [
                48.5038376,
                32.4855202
              ],
              [
                48.5044404,
                32.4867698
              ],
              [
                48.5047682,
                32.4879734
              ],
              [
                48.5050966,
                32.4892198
              ],
              [
                48.5049897,
                32.4899594
              ],
              [
                48.5047188,
                32.491257
              ],
              [
                48.5039595,
                32.4925991
              ],
              [
                48.5037994,
                32.4935675
              ],
              [
                48.5037995,
                32.4943092
              ],
              [
                48.5036927,
                32.4954185
              ],
              [
                48.5040208,
                32.4962997
              ],
              [
                48.5046197,
                32.4974545
              ],
              [
                48.5052224,
                32.4985666
              ],
              [
                48.5051116,
                32.4998697
              ],
              [
                48.504841,
                32.5010727
              ],
              [
                48.5044633,
                32.5019489
              ],
              [
                48.504303,
                32.5027798
              ],
              [
                48.5044709,
                32.5034302
              ],
              [
                48.5047456,
                32.5042607
              ],
              [
                48.5052911,
                32.5052792
              ],
              [
                48.5059026,
                32.5059815
              ],
              [
                48.5062181,
                32.5063437
              ],
              [
                48.5067673,
                32.5073126
              ],
              [
                48.5072059,
                32.5085184
              ],
              [
                48.507534,
                32.5094875
              ],
              [
                48.5076448,
                32.5101367
              ],
              [
                48.5074845,
                32.5106881
              ],
              [
                48.5069426,
                32.5114281
              ],
              [
                48.5058592,
                32.5126758
              ],
              [
                48.5049936,
                32.5135536
              ],
              [
                48.5040169,
                32.5144765
              ],
              [
                48.5035056,
                32.5147589
              ],
              [
                48.5029334,
                32.515075
              ],
              [
                48.5020637,
                32.5156754
              ],
              [
                48.5013086,
                32.5164607
              ],
              [
                48.5001971,
                32.517949
              ],
              [
                48.5001716,
                32.5179823
              ],
              [
                48.4995573,
                32.5191807
              ],
              [
                48.4988824,
                32.520707
              ],
              [
                48.4985733,
                32.5216251
              ],
              [
                48.4985924,
                32.5227346
              ],
              [
                48.4987755,
                32.5242532
              ],
              [
                48.4987984,
                32.5255003
              ],
              [
                48.4988027,
                32.5257789
              ],
              [
                48.4988211,
                32.5269729
              ],
              [
                48.4989546,
                32.5285423
              ],
              [
                48.4987184,
                32.530571
              ],
              [
                48.4983672,
                32.5322345
              ],
              [
                48.4981193,
                32.533616
              ],
              [
                48.4975968,
                32.534584
              ],
              [
                48.4967041,
                32.536018
              ],
              [
                48.4958534,
                32.5365714
              ],
              [
                48.494568,
                32.5372198
              ],
              [
                48.4934463,
                32.5376844
              ],
              [
                48.4922745,
                32.5379625
              ],
              [
                48.4916765,
                32.5381045
              ],
              [
                48.4892654,
                32.5389851
              ],
              [
                48.4874419,
                32.5394063
              ],
              [
                48.4861563,
                32.5400096
              ],
              [
                48.4849853,
                32.5407481
              ],
              [
                48.4842414,
                32.5414433
              ],
              [
                48.483181,
                32.5425538
              ],
              [
                48.4820671,
                32.543618
              ],
              [
                48.4807395,
                32.5449102
              ],
              [
                48.4794121,
                32.5462069
              ],
              [
                48.4786225,
                32.5476383
              ],
              [
                48.4779929,
                32.5487484
              ],
              [
                48.4776382,
                32.5501299
              ],
              [
                48.4776002,
                32.5511436
              ],
              [
                48.4776648,
                32.5520669
              ],
              [
                48.4776407,
                32.5522892
              ],
              [
                48.4775697,
                32.5529442
              ],
              [
                48.477581,
                32.5535892
              ],
              [
                48.4775429,
                32.5547449
              ],
              [
                48.4775582,
                32.555852
              ],
              [
                48.4771995,
                32.5569111
              ],
              [
                48.4767302,
                32.5579725
              ],
              [
                48.4762536,
                32.5586663
              ],
              [
                48.4756814,
                32.5600502
              ],
              [
                48.4746286,
                32.5617131
              ],
              [
                48.4741058,
                32.5629605
              ],
              [
                48.4732094,
                32.5643965
              ],
              [
                48.4720382,
                32.5654572
              ],
              [
                48.4709741,
                32.5665201
              ],
              [
                48.4697954,
                32.5669856
              ],
              [
                48.4693109,
                32.5671269
              ],
              [
                48.4682885,
                32.5671311
              ],
              [
                48.4678595,
                32.5672437
              ],
              [
                48.4670524,
                32.5674556
              ],
              [
                48.4653817,
                32.5676
              ],
              [
                48.4644165,
                32.5679705
              ],
              [
                48.4632378,
                32.5685734
              ],
              [
                48.4622268,
                32.5696373
              ],
              [
                48.4605828,
                32.571811
              ],
              [
                48.458786,
                32.5745858
              ],
              [
                48.458632,
                32.5749212
              ],
              [
                48.4583868,
                32.5754555
              ],
              [
                48.4577904,
                32.5767546
              ],
              [
                48.4569511,
                32.5785568
              ],
              [
                48.4564362,
                32.580174
              ],
              [
                48.456398,
                32.5815551
              ],
              [
                48.4564666,
                32.5825236
              ],
              [
                48.4568061,
                32.5835833
              ],
              [
                48.4574089,
                32.5843191
              ],
              [
                48.4583932,
                32.5851483
              ],
              [
                48.4589386,
                32.5857928
              ],
              [
                48.4600411,
                32.5872646
              ],
              [
                48.4609222,
                32.5886012
              ],
              [
                48.4621506,
                32.5913154
              ],
              [
                48.4627114,
                32.5929747
              ],
              [
                48.4630508,
                32.5940365
              ],
              [
                48.4633331,
                32.5950048
              ],
              [
                48.4634552,
                32.5959744
              ],
              [
                48.4634667,
                32.596802
              ],
              [
                48.4633713,
                32.5976341
              ],
              [
                48.4632721,
                32.5984189
              ],
              [
                48.4627976,
                32.5992095
              ],
              [
                48.462168,
                32.6003202
              ],
              [
                48.4618606,
                32.6016952
              ],
              [
                48.4617614,
                32.6023897
              ],
              [
                48.4619369,
                32.603268
              ],
              [
                48.4624978,
                32.6049227
              ],
              [
                48.466808,
                32.6050861
              ],
              [
                48.4642718,
                32.6129738
              ],
              [
                48.4708594,
                32.6312543
              ],
              [
                48.473759,
                32.6392993
              ],
              [
                48.4548919,
                32.6456601
              ],
              [
                48.4528961,
                32.6496499
              ],
              [
                48.4548527,
                32.6532407
              ],
              [
                48.4500085,
                32.6543766
              ],
              [
                48.4505195,
                32.6561273
              ],
              [
                48.4511871,
                32.6573266
              ],
              [
                48.4520759,
                32.6587987
              ],
              [
                48.4533463,
                32.6607316
              ],
              [
                48.45467,
                32.6624334
              ],
              [
                48.4559403,
                32.6639515
              ],
              [
                48.4573708,
                32.6654661
              ],
              [
                48.4588088,
                32.6676301
              ],
              [
                48.4595871,
                32.6688271
              ],
              [
                48.4600411,
                32.6702069
              ],
              [
                48.4601097,
                32.6712678
              ],
              [
                48.4603958,
                32.6725585
              ],
              [
                48.4606323,
                32.6737558
              ],
              [
                48.460804,
                32.6745866
              ],
              [
                48.4608115,
                32.6751864
              ],
              [
                48.4607697,
                32.6758799
              ],
              [
                48.4605384,
                32.6764185
              ],
              [
                48.460453,
                32.6766174
              ],
              [
                48.459816,
                32.677682
              ],
              [
                48.4590188,
                32.6789779
              ],
              [
                48.4580498,
                32.6796255
              ],
              [
                48.4569129,
                32.6797219
              ],
              [
                48.4560967,
                32.6797256
              ],
              [
                48.4537048,
                32.6795531
              ],
              [
                48.4509315,
                32.6790076
              ],
              [
                48.4474983,
                32.6782412
              ],
              [
                48.4442902,
                32.6778828
              ],
              [
                48.4435297,
                32.6778728
              ],
              [
                48.4417953,
                32.6778499
              ],
              [
                48.4392968,
                32.6778598
              ],
              [
                48.436638,
                32.6780084
              ],
              [
                48.4352302,
                32.678338
              ],
              [
                48.4340439,
                32.6789427
              ],
              [
                48.4333495,
                32.6800082
              ],
              [
                48.4328194,
                32.6810682
              ],
              [
                48.4328346,
                32.6821776
              ],
              [
                48.4331208,
                32.6835134
              ],
              [
                48.4336166,
                32.6840669
              ],
              [
                48.4341126,
                32.6846654
              ],
              [
                48.4351005,
                32.6853979
              ],
              [
                48.4353861,
                32.6855278
              ],
              [
                48.4370118,
                32.6862689
              ],
              [
                48.4396857,
                32.6871801
              ],
              [
                48.4423027,
                32.6881375
              ],
              [
                48.4468842,
                32.6893625
              ],
              [
                48.4509658,
                32.6900362
              ],
              [
                48.4540673,
                32.6904373
              ],
              [
                48.4559708,
                32.6904286
              ],
              [
                48.4571609,
                32.6902882
              ],
              [
                48.4585686,
                32.689911
              ],
              [
                48.4594879,
                32.689587
              ],
              [
                48.4619751,
                32.6885598
              ],
              [
                48.4625367,
                32.688234
              ],
              [
                48.4652596,
                32.6866538
              ],
              [
                48.4679031,
                32.6853524
              ],
              [
                48.4696311,
                32.6844675
              ],
              [
                48.4709852,
                32.684186
              ],
              [
                48.4721223,
                32.6840398
              ],
              [
                48.4735872,
                32.6840356
              ],
              [
                48.4748957,
                32.6842603
              ],
              [
                48.475933,
                32.6845787
              ],
              [
                48.475939,
                32.6845821
              ],
              [
                48.4775199,
                32.685447
              ],
              [
                48.478504,
                32.6859064
              ],
              [
                48.4794998,
                32.6872407
              ],
              [
                48.4806594,
                32.6883889
              ],
              [
                48.4811058,
                32.6893086
              ],
              [
                48.4816704,
                32.6906432
              ],
              [
                48.4819643,
                32.6920693
              ],
              [
                48.482315,
                32.6938212
              ],
              [
                48.4826164,
                32.6956667
              ],
              [
                48.4830741,
                32.6973689
              ],
              [
                48.4833641,
                32.6986123
              ],
              [
                48.4834329,
                32.6995808
              ],
              [
                48.4838791,
                32.7003179
              ],
              [
                48.4842682,
                32.7008239
              ],
              [
                48.484928,
                32.7014187
              ],
              [
                48.486084,
                32.7022444
              ],
              [
                48.4878311,
                32.7027889
              ],
              [
                48.4897346,
                32.702782
              ],
              [
                48.4915773,
                32.7024492
              ],
              [
                48.4934119,
                32.7015684
              ],
              [
                48.4951323,
                32.7002682
              ],
              [
                48.4960901,
                32.6990655
              ],
              [
                48.4970397,
                32.6970331
              ],
              [
                48.4970702,
                32.6969104
              ],
              [
                48.4983141,
                32.6919097
              ],
              [
                48.4990671,
                32.6894991
              ],
              [
                48.5001518,
                32.6859026
              ],
              [
                48.5032464,
                32.6861987
              ],
              [
                48.5032606,
                32.6861999
              ],
              [
                48.5054169,
                32.6863816
              ],
              [
                48.5083429,
                32.6866111
              ],
              [
                48.5106202,
                32.6869314
              ],
              [
                48.513008,
                32.6871141
              ],
              [
                48.514904,
                32.6875259
              ],
              [
                48.5174561,
                32.6880791
              ],
              [
                48.5192986,
                32.6886792
              ],
              [
                48.5208741,
                32.689461
              ],
              [
                48.5218505,
                32.6900146
              ],
              [
                48.5227737,
                32.6908444
              ],
              [
                48.5234832,
                32.6917218
              ],
              [
                48.5238544,
                32.6923911
              ],
              [
                48.5239181,
                32.6925059
              ],
              [
                48.5241929,
                32.6935235
              ],
              [
                48.5243567,
                32.6944465
              ],
              [
                48.5244827,
                32.6959046
              ],
              [
                48.5245284,
                32.6964337
              ],
              [
                48.5246367,
                32.6976243
              ],
              [
                48.5246964,
                32.6982811
              ],
              [
                48.5246662,
                32.6995993
              ],
              [
                48.5246466,
                32.7004555
              ],
              [
                48.5247079,
                32.7020257
              ],
              [
                48.5248186,
                32.7030874
              ],
              [
                48.525093,
                32.704335
              ],
              [
                48.5254211,
                32.7052116
              ],
              [
                48.5265082,
                32.7067367
              ],
              [
                48.5274352,
                32.7078439
              ],
              [
                48.5284117,
                32.7088122
              ],
              [
                48.5292283,
                32.7095023
              ],
              [
                48.5303117,
                32.710103
              ],
              [
                48.5312347,
                32.7104256
              ],
              [
                48.5319406,
                32.7106085
              ],
              [
                48.5326423,
                32.7106066
              ],
              [
                48.5334014,
                32.7104682
              ],
              [
                48.5342142,
                32.7100987
              ],
              [
                48.5350267,
                32.7094948
              ],
              [
                48.5357284,
                32.7088007
              ],
              [
                48.5363198,
                32.7078294
              ],
              [
                48.5369684,
                32.7068593
              ],
              [
                48.5376702,
                32.7057955
              ],
              [
                48.538044,
                32.7048673
              ],
              [
                48.5385283,
                32.7032515
              ],
              [
                48.5388216,
                32.7016357
              ],
              [
                48.5389556,
                32.7008973
              ],
              [
                48.5397036,
                32.6965972
              ],
              [
                48.5401267,
                32.6939161
              ],
              [
                48.5404471,
                32.6919791
              ],
              [
                48.5407714,
                32.6909598
              ],
              [
                48.5409316,
                32.690219
              ],
              [
                48.5411987,
                32.6896674
              ],
              [
                48.541687,
                32.6889714
              ],
              [
                48.5427131,
                32.6878621
              ],
              [
                48.5434685,
                32.687169
              ],
              [
                48.5437926,
                32.6866614
              ],
              [
                48.5446054,
                32.6859672
              ],
              [
                48.5455781,
                32.6854542
              ],
              [
                48.5469856,
                32.6847604
              ],
              [
                48.5477982,
                32.6844832
              ],
              [
                48.5487213,
                32.6843457
              ],
              [
                48.5502931,
                32.6844328
              ],
              [
                48.5514871,
                32.6847108
              ],
              [
                48.5522994,
                32.6848484
              ],
              [
                48.5531691,
                32.6853095
              ],
              [
                48.5538759,
                32.6859899
              ],
              [
                48.5539818,
                32.6860918
              ],
              [
                48.5549621,
                32.6871074
              ],
              [
                48.5557214,
                32.6880307
              ],
              [
                48.5564843,
                32.6893689
              ],
              [
                48.5571938,
                32.6909359
              ],
              [
                48.5576287,
                32.6923263
              ],
              [
                48.5581245,
                32.694446
              ],
              [
                48.5589486,
                32.6992954
              ],
              [
                48.5598259,
                32.7032193
              ],
              [
                48.5604247,
                32.7050209
              ],
              [
                48.5609704,
                32.7062691
              ],
              [
                48.5616228,
                32.7073278
              ],
              [
                48.5624391,
                32.7081102
              ],
              [
                48.5636329,
                32.7088503
              ],
              [
                48.564827,
                32.7095408
              ],
              [
                48.5661279,
                32.710044
              ],
              [
                48.5680237,
                32.7105519
              ],
              [
                48.5700302,
                32.710823
              ],
              [
                48.5730134,
                32.7115143
              ],
              [
                48.5743141,
                32.7117424
              ],
              [
                48.5758858,
                32.7122462
              ],
              [
                48.5772935,
                32.7126612
              ],
              [
                48.5791399,
                32.7130282
              ],
              [
                48.5811995,
                32.7135324
              ],
              [
                48.5830423,
                32.7140346
              ],
              [
                48.5843964,
                32.7144507
              ],
              [
                48.5858612,
                32.7151868
              ],
              [
                48.5875969,
                32.7161513
              ],
              [
                48.5890617,
                32.7171624
              ],
              [
                48.5904197,
                32.7181782
              ],
              [
                48.5912323,
                32.7191
              ],
              [
                48.592266,
                32.7203914
              ],
              [
                48.5930785,
                32.7215883
              ],
              [
                48.5938951,
                32.7234796
              ],
              [
                48.5948754,
                32.725879
              ],
              [
                48.5955809,
                32.7272654
              ],
              [
                48.5960693,
                32.7280007
              ],
              [
                48.5966681,
                32.7285082
              ],
              [
                48.597046,
                32.7287363
              ],
              [
                48.5976449,
                32.7289191
              ],
              [
                48.5987281,
                32.7287325
              ],
              [
                48.5996477,
                32.7283173
              ],
              [
                48.6008377,
                32.7275781
              ],
              [
                48.6022987,
                32.7267877
              ],
              [
                48.6038132,
                32.7259555
              ],
              [
                48.6055451,
                32.7251207
              ],
              [
                48.6067608,
                32.7246197
              ],
              [
                48.6068991,
                32.7245627
              ],
              [
                48.6077927,
                32.724379
              ],
              [
                48.6082534,
                32.7242842
              ],
              [
                48.6099321,
                32.72419
              ],
              [
                48.6116638,
                32.7240945
              ],
              [
                48.6135597,
                32.7241825
              ],
              [
                48.615242,
                32.7243656
              ],
              [
                48.6162147,
                32.7245937
              ],
              [
                48.6170844,
                32.7249597
              ],
              [
                48.6178438,
                32.7253754
              ],
              [
                48.6184922,
                32.725789
              ],
              [
                48.6190911,
                32.7265736
              ],
              [
                48.6195795,
                32.7272637
              ],
              [
                48.6200142,
                32.7284172
              ],
              [
                48.6203955,
                32.7300769
              ],
              [
                48.6208841,
                32.7315516
              ],
              [
                48.6209054,
                32.7316264
              ],
              [
                48.6212118,
                32.7327053
              ],
              [
                48.6217003,
                32.7335825
              ],
              [
                48.6222991,
                32.7344099
              ],
              [
                48.6230011,
                32.7349169
              ],
              [
                48.6239776,
                32.7354247
              ],
              [
                48.6250075,
                32.7356989
              ],
              [
                48.6264687,
                32.7360197
              ],
              [
                48.6283645,
                32.7361976
              ],
              [
                48.6295585,
                32.7361954
              ],
              [
                48.6305314,
                32.736286
              ],
              [
                48.6312905,
                32.7364243
              ],
              [
                48.6320495,
                32.7366979
              ],
              [
                48.6324845,
                32.7370691
              ],
              [
                48.6328086,
                32.7373435
              ],
              [
                48.6331329,
                32.737663
              ],
              [
                48.633297,
                32.7379411
              ],
              [
                48.6332969,
                32.7383582
              ],
              [
                48.6331366,
                32.7389097
              ],
              [
                48.632866,
                32.7396508
              ],
              [
                48.6321106,
                32.740802
              ],
              [
                48.6310806,
                32.7420495
              ],
              [
                48.6303252,
                32.7434397
              ],
              [
                48.6299477,
                32.7443614
              ],
              [
                48.6297875,
                32.7449603
              ],
              [
                48.6295698,
                32.7455603
              ],
              [
                48.6295701,
                32.7462547
              ],
              [
                48.6297341,
                32.7465734
              ],
              [
                48.6300585,
                32.7468523
              ],
              [
                48.6308173,
                32.7473108
              ],
              [
                48.6317405,
                32.7476303
              ],
              [
                48.6327134,
                32.7478133
              ],
              [
                48.6341745,
                32.7480438
              ],
              [
                48.6354751,
                32.7483186
              ],
              [
                48.6364519,
                32.7485918
              ],
              [
                48.63813,
                32.7491419
              ],
              [
                48.6396483,
                32.7498739
              ],
              [
                48.6408674,
                32.7501848
              ],
              [
                48.6411949,
                32.7502683
              ],
              [
                48.6418156,
                32.750582
              ],
              [
                48.6423365,
                32.7512772
              ],
              [
                48.6422921,
                32.7518084
              ],
              [
                48.6419361,
                32.7524494
              ],
              [
                48.6419105,
                32.7524955
              ],
              [
                48.641529,
                32.7527724
              ],
              [
                48.6410904,
                32.7535104
              ],
              [
                48.6407622,
                32.7537386
              ],
              [
                48.640381,
                32.7541958
              ],
              [
                48.6402208,
                32.7544295
              ],
              [
                48.6402741,
                32.7548859
              ],
              [
                48.6403312,
                32.7559443
              ],
              [
                48.6403313,
                32.7568619
              ],
              [
                48.6403351,
                32.7576915
              ],
              [
                48.6401176,
                32.7580594
              ],
              [
                48.6399004,
                32.7586595
              ],
              [
                48.6394081,
                32.7590267
              ],
              [
                48.6390267,
                32.7597161
              ],
              [
                48.638809,
                32.7604064
              ],
              [
                48.6387557,
                32.7607728
              ],
              [
                48.6388092,
                32.7613712
              ],
              [
                48.6394653,
                32.7617375
              ],
              [
                48.6405068,
                32.7626116
              ],
              [
                48.641819,
                32.7634389
              ],
              [
                48.6426392,
                32.763576
              ],
              [
                48.6437301,
                32.7635763
              ],
              [
                48.6452598,
                32.7633435
              ],
              [
                48.6469535,
                32.762654
              ],
              [
                48.6488647,
                32.7618264
              ],
              [
                48.6505014,
                32.7612259
              ],
              [
                48.6511001,
                32.7610433
              ],
              [
                48.6519737,
                32.7608117
              ],
              [
                48.6523019,
                32.7608111
              ],
              [
                48.6529045,
                32.7608111
              ],
              [
                48.6533431,
                32.76118
              ],
              [
                48.6536713,
                32.7614093
              ],
              [
                48.6543275,
                32.7617305
              ],
              [
                48.6548729,
                32.7620969
              ],
              [
                48.6554755,
                32.7622367
              ],
              [
                48.6564026,
                32.7621886
              ],
              [
                48.657551,
                32.7621876
              ],
              [
                48.6598433,
                32.7620974
              ],
              [
                48.6615371,
                32.7620502
              ],
              [
                48.6631204,
                32.7620459
              ],
              [
                48.6638334,
                32.7620479
              ],
              [
                48.6651994,
                32.7623214
              ],
              [
                48.6663477,
                32.7627824
              ],
              [
                48.6672745,
                32.7630116
              ],
              [
                48.6679879,
                32.7634239
              ],
              [
                48.6682624,
                32.7637018
              ],
              [
                48.6688613,
                32.7642067
              ],
              [
                48.6689719,
                32.7646213
              ],
              [
                48.6692999,
                32.7648055
              ],
              [
                48.6698455,
                32.7647593
              ],
              [
                48.6705552,
                32.7642968
              ],
              [
                48.6713218,
                32.7638827
              ],
              [
                48.6727904,
                32.762226
              ],
              [
                48.6744841,
                32.7607988
              ],
              [
                48.6760101,
                32.7591905
              ],
              [
                48.6778069,
                32.7573053
              ],
              [
                48.6782417,
                32.7566145
              ],
              [
                48.6785164,
                32.7561078
              ],
              [
                48.6785304,
                32.7560717
              ],
              [
                48.6786232,
                32.7558325
              ],
              [
                48.6790048,
                32.7554203
              ],
              [
                48.6793327,
                32.7553249
              ],
              [
                48.6800264,
                32.7553244
              ],
              [
                48.6801528,
                32.7553243
              ],
              [
                48.6805342,
                32.7556492
              ],
              [
                48.6808089,
                32.756015
              ],
              [
                48.6811904,
                32.7564279
              ],
              [
                48.6814119,
                32.757442
              ],
              [
                48.6817436,
                32.758271
              ],
              [
                48.6818544,
                32.7588186
              ],
              [
                48.6823462,
                32.7590937
              ],
              [
                48.6830025,
                32.7594192
              ],
              [
                48.6836586,
                32.7595553
              ],
              [
                48.6849672,
                32.7595096
              ],
              [
                48.6854059,
                32.759414
              ],
              [
                48.6864434,
                32.7589102
              ],
              [
                48.6864967,
                32.7586316
              ],
              [
                48.6872597,
                32.7578973
              ],
              [
                48.6878586,
                32.7569321
              ],
              [
                48.6880486,
                32.7562859
              ],
              [
                48.688183,
                32.755829
              ],
              [
                48.6885605,
                32.7545396
              ],
              [
                48.6887778,
                32.7535743
              ],
              [
                48.6890487,
                32.7530675
              ],
              [
                48.6898116,
                32.7521933
              ],
              [
                48.6902505,
                32.7518723
              ],
              [
                48.6908492,
                32.751827
              ],
              [
                48.6915054,
                32.7520104
              ],
              [
                48.6930352,
                32.7523316
              ],
              [
                48.6939125,
                32.7526972
              ],
              [
                48.6943473,
                32.7531133
              ],
              [
                48.6944046,
                32.7534796
              ],
              [
                48.6944044,
                32.7541694
              ],
              [
                48.6942978,
                32.7548145
              ],
              [
                48.6935349,
                32.7557788
              ],
              [
                48.6928826,
                32.7565153
              ],
              [
                48.6921197,
                32.7574797
              ],
              [
                48.6917423,
                32.758318
              ],
              [
                48.6916848,
                32.7584455
              ],
              [
                48.6914672,
                32.7593185
              ],
              [
                48.6911966,
                32.7601003
              ],
              [
                48.6909257,
                32.760837
              ],
              [
                48.6904373,
                32.7618515
              ],
              [
                48.6894036,
                32.7630927
              ],
              [
                48.6884766,
                32.7646108
              ],
              [
                48.6880416,
                32.7653467
              ],
              [
                48.6877709,
                32.7661285
              ],
              [
                48.6876069,
                32.7670927
              ],
              [
                48.6874465,
                32.7679667
              ],
              [
                48.6872863,
                32.7692104
              ],
              [
                48.6873434,
                32.7703139
              ],
              [
                48.6875114,
                32.7715073
              ],
              [
                48.6876757,
                32.7727502
              ],
              [
                48.6876794,
                32.773625
              ],
              [
                48.6872977,
                32.7745445
              ],
              [
                48.686863,
                32.7758328
              ],
              [
                48.6866494,
                32.7767532
              ],
              [
                48.6865959,
                32.7778546
              ],
              [
                48.6863824,
                32.7794648
              ],
              [
                48.6863823,
                32.7807971
              ],
              [
                48.6864967,
                32.7824968
              ],
              [
                48.6868286,
                32.7836955
              ],
              [
                48.6872101,
                32.7842932
              ],
              [
                48.6880873,
                32.7851639
              ],
              [
                48.6893999,
                32.7858554
              ],
              [
                48.6908227,
                32.7865895
              ],
              [
                48.6919173,
                32.7873266
              ],
              [
                48.693508,
                32.7883839
              ],
              [
                48.6943282,
                32.7891656
              ],
              [
                48.6953696,
                32.7898971
              ],
              [
                48.6960793,
                32.7903588
              ],
              [
                48.6964645,
                32.7907266
              ],
              [
                48.6969568,
                32.7911865
              ],
              [
                48.6973952,
                32.7916906
              ],
              [
                48.6981087,
                32.7923823
              ],
              [
                48.6990395,
                32.7928886
              ],
              [
                48.7001877,
                32.7933471
              ],
              [
                48.7011717,
                32.7936672
              ],
              [
                48.7023201,
                32.7937582
              ],
              [
                48.7031937,
                32.793896
              ],
              [
                48.7040138,
                32.7938952
              ],
              [
                48.7050516,
                32.7938489
              ],
              [
                48.7058717,
                32.793758
              ],
              [
                48.7064172,
                32.7936665
              ],
              [
                48.7069627,
                32.7932504
              ],
              [
                48.7079468,
                32.7929303
              ],
              [
                48.7090949,
                32.7928386
              ],
              [
                48.7099685,
                32.7927937
              ],
              [
                48.7116088,
                32.7927899
              ],
              [
                48.7126998,
                32.7927895
              ],
              [
                48.7137412,
                32.7932504
              ],
              [
                48.7153816,
                32.7937538
              ],
              [
                48.7164073,
                32.7940746
              ],
              [
                48.7172966,
                32.7943546
              ],
              [
                48.7185553,
                32.7949479
              ],
              [
                48.7196504,
                32.7955472
              ],
              [
                48.7212945,
                32.7963752
              ],
              [
                48.7226602,
                32.7971576
              ],
              [
                48.7236481,
                32.7979849
              ],
              [
                48.7244147,
                32.7985805
              ],
              [
                48.7251281,
                32.7993622
              ],
              [
                48.7258376,
                32.7996862
              ],
              [
                48.7266043,
                32.7999616
              ],
              [
                48.7274781,
                32.8000068
              ],
              [
                48.7287941,
                32.8002809
              ],
              [
                48.7297211,
                32.8006066
              ],
              [
                48.7302171,
                32.8010169
              ],
              [
                48.7309304,
                32.8016633
              ],
              [
                48.7314225,
                32.8022584
              ],
              [
                48.7316438,
                32.8032273
              ],
              [
                48.7318115,
                32.8041006
              ],
              [
                48.7320861,
                32.804836
              ],
              [
                48.732525,
                32.8055676
              ],
              [
                48.7329102,
                32.8058925
              ],
              [
                48.7337836,
                32.8061224
              ],
              [
                48.7350961,
                32.8063964
              ],
              [
                48.7373923,
                32.8059848
              ],
              [
                48.7387045,
                32.8056614
              ],
              [
                48.7404517,
                32.8049242
              ],
              [
                48.7412146,
                32.8043247
              ],
              [
                48.7417032,
                32.8033596
              ],
              [
                48.7424659,
                32.8025325
              ],
              [
                48.7428435,
                32.8017051
              ],
              [
                48.7434998,
                32.8011511
              ],
              [
                48.7440987,
                32.8008756
              ],
              [
                48.7445906,
                32.8007402
              ],
              [
                48.7453004,
                32.8007394
              ],
              [
                48.7461776,
                32.8008319
              ],
              [
                48.7471086,
                32.8010132
              ],
              [
                48.7476007,
                32.801243
              ],
              [
                48.7480928,
                32.801563
              ],
              [
                48.7486952,
                32.8024824
              ],
              [
                48.7493552,
                32.8032652
              ],
              [
                48.7500698,
                32.8039837
              ],
              [
                48.7506677,
                32.8045581
              ],
              [
                48.7511024,
                32.8048793
              ],
              [
                48.751812,
                32.8053361
              ],
              [
                48.7525751,
                32.805564
              ],
              [
                48.7537154,
                32.8059317
              ],
              [
                48.754532,
                32.8062056
              ],
              [
                48.7555124,
                32.8063382
              ],
              [
                48.7564316,
                32.8063817
              ],
              [
                48.758171,
                32.8063745
              ],
              [
                48.7592544,
                32.8062316
              ],
              [
                48.7599565,
                32.8060458
              ],
              [
                48.7608222,
                32.8056713
              ],
              [
                48.7616311,
                32.8051108
              ],
              [
                48.7623862,
                32.8046464
              ],
              [
                48.7629775,
                32.8040438
              ],
              [
                48.7634086,
                32.8034856
              ],
              [
                48.7635689,
                32.8030691
              ],
              [
                48.7637785,
                32.8022387
              ],
              [
                48.763771,
                32.8014991
              ],
              [
                48.7640916,
                32.800664
              ],
              [
                48.7645149,
                32.7997359
              ],
              [
                48.7649382,
                32.7983931
              ],
              [
                48.7652166,
                32.7977412
              ],
              [
                48.7654724,
                32.7971424
              ],
              [
                48.7660599,
                32.7960775
              ],
              [
                48.766918,
                32.7951053
              ],
              [
                48.76762,
                32.7943604
              ],
              [
                48.7684822,
                32.7936633
              ],
              [
                48.7694512,
                32.7931508
              ],
              [
                48.7701569,
                32.7928703
              ],
              [
                48.7708587,
                32.792637
              ],
              [
                48.7717286,
                32.7926322
              ],
              [
                48.7727722,
                32.7927033
              ],
              [
                48.7730292,
                32.7927208
              ],
              [
                48.7741698,
                32.7929011
              ],
              [
                48.7751999,
                32.7928969
              ],
              [
                48.7766684,
                32.7930763
              ],
              [
                48.7772103,
                32.7931175
              ],
              [
                48.77808,
                32.7933471
              ],
              [
                48.7789001,
                32.7935389
              ],
              [
                48.7790602,
                32.7935764
              ],
              [
                48.7797659,
                32.7938031
              ],
              [
                48.7804716,
                32.7940298
              ],
              [
                48.7810709,
                32.7942591
              ],
              [
                48.7815628,
                32.794349
              ],
              [
                48.7819405,
                32.7945338
              ],
              [
                48.7821085,
                32.7950395
              ],
              [
                48.7823295,
                32.7954109
              ],
              [
                48.7823334,
                32.7959633
              ],
              [
                48.7820703,
                32.7967522
              ],
              [
                48.7814332,
                32.7984205
              ],
              [
                48.7808495,
                32.8001325
              ],
              [
                48.7803688,
                32.8010145
              ],
              [
                48.7799988,
                32.8019368
              ],
              [
                48.7796782,
                32.8028194
              ],
              [
                48.779579,
                32.8036946
              ],
              [
                48.7795297,
                32.8042979
              ],
              [
                48.7795868,
                32.8049933
              ],
              [
                48.7798117,
                32.8058247
              ],
              [
                48.780033,
                32.8064238
              ],
              [
                48.7800369,
                32.8067936
              ],
              [
                48.7798806,
                32.8072552
              ],
              [
                48.7794458,
                32.8075361
              ],
              [
                48.7786332,
                32.8077246
              ],
              [
                48.7780418,
                32.8080477
              ],
              [
                48.7772827,
                32.8083296
              ],
              [
                48.777069,
                32.8087474
              ],
              [
                48.7769088,
                32.8090714
              ],
              [
                48.7770194,
                32.8093484
              ],
              [
                48.7771913,
                32.8100436
              ],
              [
                48.7776869,
                32.8110579
              ],
              [
                48.7784005,
                32.8119769
              ],
              [
                48.7786752,
                32.8124845
              ],
              [
                48.7788428,
                32.8130871
              ],
              [
                48.7786867,
                32.813781
              ],
              [
                48.7780953,
                32.8146137
              ],
              [
                48.77713,
                32.8159605
              ],
              [
                48.7764319,
                32.8168408
              ],
              [
                48.7757302,
                32.8173987
              ],
              [
                48.7745973,
                32.8179129
              ],
              [
                48.7730255,
                32.8183358
              ],
              [
                48.7717286,
                32.8186194
              ],
              [
                48.7708052,
                32.8186683
              ],
              [
                48.7698607,
                32.8189542
              ],
              [
                48.769722,
                32.8189962
              ],
              [
                48.7691842,
                32.8195524
              ],
              [
                48.7689232,
                32.8202124
              ],
              [
                48.7687071,
                32.8207591
              ],
              [
                48.7688256,
                32.8221883
              ],
              [
                48.7690546,
                32.8235743
              ],
              [
                48.7692299,
                32.8249166
              ],
              [
                48.7692375,
                32.8258411
              ],
              [
                48.7690238,
                32.8262566
              ],
              [
                48.7686461,
                32.8264933
              ],
              [
                48.7677231,
                32.8264971
              ],
              [
                48.7659837,
                32.8262249
              ],
              [
                48.7643769,
                32.8263136
              ],
              [
                48.7641946,
                32.8263237
              ],
              [
                48.763218,
                32.8264663
              ],
              [
                48.7611618,
                32.8271667
              ],
              [
                48.7594338,
                32.8279158
              ],
              [
                48.7574881,
                32.8291254
              ],
              [
                48.7560884,
                32.830196
              ],
              [
                48.7555504,
                32.8310272
              ],
              [
                48.7552337,
                32.8320473
              ],
              [
                48.7554056,
                32.8329229
              ],
              [
                48.7553595,
                32.8338509
              ],
              [
                48.755638,
                32.8349605
              ],
              [
                48.7558097,
                32.8358834
              ],
              [
                48.7556535,
                32.8364826
              ],
              [
                48.755661,
                32.8374566
              ],
              [
                48.7553404,
                32.8384293
              ],
              [
                48.7541085,
                32.8400506
              ],
              [
                48.7527619,
                32.8413498
              ],
              [
                48.7517929,
                32.8421395
              ],
              [
                48.7509308,
                32.8430709
              ],
              [
                48.7506675,
                32.8438101
              ],
              [
                48.7505647,
                32.8446424
              ],
              [
                48.7506789,
                32.8454741
              ],
              [
                48.7506295,
                32.8461224
              ],
              [
                48.7510146,
                32.8466298
              ],
              [
                48.7513999,
                32.8473672
              ],
              [
                48.7520026,
                32.8478289
              ],
              [
                48.7524375,
                32.8480577
              ],
              [
                48.7525481,
                32.8482896
              ],
              [
                48.7521706,
                32.8487518
              ],
              [
                48.7513619,
                32.8493121
              ],
              [
                48.7499787,
                32.849657
              ],
              [
                48.7492567,
                32.8497589
              ],
              [
                48.7490431,
                32.8499805
              ],
              [
                48.7487602,
                32.8509899
              ],
              [
                48.7488167,
                32.8521497
              ],
              [
                48.7488714,
                32.8533816
              ],
              [
                48.7487563,
                32.8545383
              ],
              [
                48.7486164,
                32.8555165
              ],
              [
                48.748873,
                32.8560532
              ],
              [
                48.7489361,
                32.8560901
              ],
              [
                48.7491434,
                32.8562113
              ],
              [
                48.749441,
                32.8562866
              ],
              [
                48.7500817,
                32.8564469
              ],
              [
                48.7512589,
                32.8564748
              ],
              [
                48.7519073,
                32.8562881
              ],
              [
                48.7526129,
                32.856285
              ],
              [
                48.7535895,
                32.8563769
              ],
              [
                48.7539749,
                32.8566521
              ],
              [
                48.7543031,
                32.8569714
              ],
              [
                48.7544669,
                32.8573869
              ],
              [
                48.754528,
                32.8581274
              ],
              [
                48.7545889,
                32.8587305
              ],
              [
                48.7543258,
                32.859977
              ],
              [
                48.7535783,
                32.8615078
              ],
              [
                48.7529411,
                32.863221
              ],
              [
                48.7525711,
                32.864425
              ],
              [
                48.7520942,
                32.8655819
              ],
              [
                48.7516135,
                32.866554
              ],
              [
                48.7508088,
                32.8675314
              ],
              [
                48.7498931,
                32.8687369
              ],
              [
                48.7490235,
                32.869136
              ],
              [
                48.748043,
                32.8700111
              ],
              [
                48.7473868,
                32.8705133
              ],
              [
                48.7465666,
                32.870884
              ],
              [
                48.7458,
                32.8710663
              ],
              [
                48.7449264,
                32.8711588
              ],
              [
                48.744217,
                32.8712046
              ],
              [
                48.7434503,
                32.8711119
              ],
              [
                48.7430024,
                32.8710915
              ],
              [
                48.7424623,
                32.871067
              ],
              [
                48.7416991,
                32.8711118
              ],
              [
                48.741207,
                32.8711593
              ],
              [
                48.7406044,
                32.8715249
              ],
              [
                48.7401122,
                32.8718497
              ],
              [
                48.7396201,
                32.872215
              ],
              [
                48.7392958,
                32.8727682
              ],
              [
                48.7388039,
                32.8734131
              ],
              [
                48.7384263,
                32.8745155
              ],
              [
                48.7379874,
                32.8750689
              ],
              [
                48.7379915,
                32.8758039
              ],
              [
                48.7377206,
                32.8767233
              ],
              [
                48.7377236,
                32.8774031
              ],
              [
                48.7377243,
                32.877553
              ],
              [
                48.7373962,
                32.8780588
              ],
              [
                48.7370148,
                32.8784261
              ],
              [
                48.7365229,
                32.8788861
              ],
              [
                48.7357024,
                32.879117
              ],
              [
                48.7352904,
                32.8792365
              ],
              [
                48.7342833,
                32.8795286
              ],
              [
                48.7335701,
                32.8798516
              ],
              [
                48.7326964,
                32.8801266
              ],
              [
                48.731823,
                32.8808637
              ],
              [
                48.7307854,
                32.8814153
              ],
              [
                48.729637,
                32.8818273
              ],
              [
                48.7289811,
                32.8823361
              ],
              [
                48.7285994,
                32.882886
              ],
              [
                48.7283823,
                32.883254
              ],
              [
                48.7281647,
                32.8842668
              ],
              [
                48.7280801,
                32.8846688
              ],
              [
                48.7280579,
                32.8847744
              ],
              [
                48.7280043,
                32.8853686
              ],
              [
                48.7276228,
                32.8858305
              ],
              [
                48.7272414,
                32.8861956
              ],
              [
                48.7265855,
                32.8867044
              ],
              [
                48.7259863,
                32.8869776
              ],
              [
                48.7254944,
                32.8871603
              ],
              [
                48.7248706,
                32.8870866
              ],
              [
                48.7247275,
                32.8870696
              ],
              [
                48.7235756,
                32.8868864
              ],
              [
                48.7224273,
                32.8866129
              ],
              [
                48.7213286,
                32.8861511
              ],
              [
                48.7202872,
                32.8856429
              ],
              [
                48.7195204,
                32.8854598
              ],
              [
                48.7189216,
                32.8855526
              ],
              [
                48.7182656,
                32.8855519
              ],
              [
                48.7176095,
                32.8860133
              ],
              [
                48.7171174,
                32.886241
              ],
              [
                48.7165147,
                32.8869785
              ],
              [
                48.7161369,
                32.8877606
              ],
              [
                48.7158089,
                32.8884512
              ],
              [
                48.7155913,
                32.8891867
              ],
              [
                48.7153779,
                32.8902897
              ],
              [
                48.7155362,
                32.8905613
              ],
              [
                48.71599,
                32.8908361
              ],
              [
                48.716316,
                32.8911555
              ],
              [
                48.7137121,
                32.8923774
              ],
              [
                48.7108999,
                32.8962061
              ],
              [
                48.7072031,
                32.902423
              ],
              [
                48.7050813,
                32.9052725
              ],
              [
                48.6993687,
                32.907042
              ],
              [
                48.6953008,
                32.9084942
              ],
              [
                48.6942528,
                32.9119811
              ],
              [
                48.6911346,
                32.9150081
              ],
              [
                48.6890955,
                32.9169516
              ],
              [
                48.686695,
                32.9189753
              ],
              [
                48.6839021,
                32.9213477
              ],
              [
                48.6774157,
                32.9292254
              ],
              [
                48.6685134,
                32.934377
              ],
              [
                48.6632446,
                32.9361646
              ],
              [
                48.6559733,
                32.939888
              ],
              [
                48.6503898,
                32.9476055
              ],
              [
                48.6471638,
                32.9491458
              ],
              [
                48.6409962,
                32.9548677
              ],
              [
                48.636806,
                32.9541694
              ],
              [
                48.6354814,
                32.9505641
              ],
              [
                48.6312258,
                32.9430486
              ],
              [
                48.6267391,
                32.937627
              ],
              [
                48.6208507,
                32.9379036
              ],
              [
                48.6156796,
                32.9396993
              ],
              [
                48.6082857,
                32.9464485
              ],
              [
                48.5912501,
                32.9558476
              ],
              [
                48.5745374,
                32.9639392
              ],
              [
                48.56248,
                32.9686038
              ],
              [
                48.5595102,
                32.9711164
              ],
              [
                48.5596838,
                32.9737084
              ],
              [
                48.5565902,
                32.9756971
              ],
              [
                48.5509963,
                32.9760485
              ],
              [
                48.5490732,
                32.9790728
              ],
              [
                48.5460216,
                32.9790355
              ],
              [
                48.5437075,
                32.9805279
              ],
              [
                48.5427459,
                32.9802953
              ],
              [
                48.5402817,
                32.9798486
              ],
              [
                48.5396919,
                32.9815595
              ],
              [
                48.5378264,
                32.9807743
              ],
              [
                48.5366744,
                32.9800866
              ],
              [
                48.5351944,
                32.9790272
              ],
              [
                48.5340461,
                32.9780149
              ],
              [
                48.53207,
                32.9762694
              ],
              [
                48.5288393,
                32.9740143
              ],
              [
                48.5265924,
                32.9726376
              ],
              [
                48.5229936,
                32.9702654
              ],
              [
                48.5222625,
                32.9697835
              ],
              [
                48.5174943,
                32.9670716
              ],
              [
                48.5143167,
                32.9654619
              ],
              [
                48.5098801,
                32.963622
              ],
              [
                48.5071413,
                32.9622869
              ],
              [
                48.5045663,
                32.9616899
              ],
              [
                48.5022086,
                32.9615053
              ],
              [
                48.499612,
                32.9612031
              ],
              [
                48.492817,
                32.9626357
              ],
              [
                48.4877931,
                32.9638332
              ],
              [
                48.4832037,
                32.96494
              ],
              [
                48.4808459,
                32.9651948
              ],
              [
                48.4790381,
                32.9653902
              ],
              [
                48.4754716,
                32.9658816
              ],
              [
                48.4738998,
                32.9658002
              ],
              [
                48.4697837,
                32.9656943
              ],
              [
                48.4675103,
                32.9658511
              ],
              [
                48.466053,
                32.9662814
              ],
              [
                48.4629248,
                32.9672323
              ],
              [
                48.4593582,
                32.9680479
              ],
              [
                48.4561157,
                32.9684935
              ],
              [
                48.4538955,
                32.9685565
              ],
              [
                48.4496193,
                32.9686856
              ],
              [
                48.4445801,
                32.9686772
              ],
              [
                48.4399184,
                32.9682052
              ],
              [
                48.4365539,
                32.9678161
              ],
              [
                48.4347648,
                32.967599
              ],
              [
                48.4326477,
                32.9670573
              ],
              [
                48.4304695,
                32.9662393
              ],
              [
                48.4275323,
                32.9651982
              ],
              [
                48.4259033,
                32.9647025
              ],
              [
                48.4238433,
                32.9646713
              ],
              [
                48.422586,
                32.964731
              ],
              [
                48.4212455,
                32.9647867
              ],
              [
                48.4172973,
                32.9651875
              ],
              [
                48.4134559,
                32.9655881
              ],
              [
                48.4097213,
                32.9657135
              ],
              [
                48.406414,
                32.9655524
              ],
              [
                48.4039555,
                32.9658055
              ],
              [
                48.4030076,
                32.9659031
              ],
              [
                48.3976441,
                32.9657621
              ],
              [
                48.3934212,
                32.965701
              ],
              [
                48.389679,
                32.9654538
              ],
              [
                48.3861084,
                32.9658547
              ],
              [
                48.3833542,
                32.9663402
              ],
              [
                48.3806038,
                32.9671977
              ],
              [
                48.3782348,
                32.9683269
              ],
              [
                48.3763504,
                32.9693152
              ],
              [
                48.3740844,
                32.9700272
              ],
              [
                48.371601,
                32.9707413
              ],
              [
                48.3696594,
                32.971176
              ],
              [
                48.3664246,
                32.9725009
              ],
              [
                48.3617935,
                32.974434
              ],
              [
                48.3591004,
                32.9756168
              ],
              [
                48.3575363,
                32.9762307
              ],
              [
                48.3555908,
                32.9765253
              ],
              [
                48.352726,
                32.9771949
              ],
              [
                48.3471642,
                32.9784879
              ],
              [
                48.3438224,
                32.9795799
              ],
              [
                48.3410682,
                32.9803891
              ],
              [
                48.3401491,
                32.9806775
              ],
              [
                48.3378868,
                32.9813875
              ],
              [
                48.3352432,
                32.9821515
              ],
              [
                48.3340034,
                32.9827607
              ],
              [
                48.3323364,
                32.9836087
              ],
              [
                48.330288,
                32.9844124
              ],
              [
                48.3281822,
                32.9849399
              ],
              [
                48.3266182,
                32.9854631
              ],
              [
                48.3253784,
                32.9861173
              ],
              [
                48.3231735,
                32.9871565
              ],
              [
                48.320423,
                32.9882899
              ],
              [
                48.3134689,
                32.9906582
              ],
              [
                48.3068352,
                32.9929811
              ],
              [
                48.3048363,
                32.9935533
              ],
              [
                48.3024064,
                32.9941252
              ],
              [
                48.2990609,
                32.9949409
              ],
              [
                48.296196,
                32.9956091
              ],
              [
                48.2930603,
                32.9959604
              ],
              [
                48.2901383,
                32.9962148
              ],
              [
                48.2881356,
                32.9962772
              ],
              [
                48.2869492,
                32.9965625
              ],
              [
                48.2855416,
                32.9968069
              ],
              [
                48.2827414,
                32.9970014
              ],
              [
                48.2818107,
                32.997066
              ],
              [
                48.2796974,
                32.9971281
              ],
              [
                48.2775841,
                32.996913
              ],
              [
                48.2759552,
                32.9966971
              ],
              [
                48.2759018,
                32.9966508
              ],
              [
                48.2745972,
                32.9963338
              ],
              [
                48.2736169,
                32.9957421
              ],
              [
                48.2730141,
                32.9953773
              ],
              [
                48.272419,
                32.9952426
              ],
              [
                48.2710571,
                32.994602
              ],
              [
                48.2699622,
                32.9938702
              ],
              [
                48.2689253,
                32.9930986
              ],
              [
                48.268486,
                32.9927718
              ],
              [
                48.26614,
                32.9912147
              ],
              [
                48.2635194,
                32.9897079
              ],
              [
                48.2620506,
                32.9889341
              ],
              [
                48.2609995,
                32.9883782
              ],
              [
                48.2604141,
                32.9880687
              ],
              [
                48.2593193,
                32.9871949
              ],
              [
                48.2580071,
                32.9861404
              ],
              [
                48.2569122,
                32.985084
              ],
              [
                48.2551003,
                32.9831553
              ],
              [
                48.2531777,
                32.9810415
              ],
              [
                48.2514267,
                32.9794815
              ],
              [
                48.2499466,
                32.9781032
              ],
              [
                48.24965,
                32.9765745
              ],
              [
                48.2491394,
                32.9739425
              ],
              [
                48.2470818,
                32.971465
              ],
              [
                48.2451249,
                32.9682955
              ],
              [
                48.2441292,
                32.9673809
              ],
              [
                48.2404862,
                32.9643972
              ],
              [
                48.2386664,
                32.9629753
              ],
              [
                48.2358436,
                32.9599871
              ],
              [
                48.2348116,
                32.9591663
              ],
              [
                48.23452,
                32.9589344
              ],
              [
                48.2321015,
                32.9573751
              ],
              [
                48.2303963,
                32.9560886
              ],
              [
                48.2286873,
                32.9547163
              ],
              [
                48.2273064,
                32.9534752
              ],
              [
                48.2254257,
                32.9513169
              ],
              [
                48.222599,
                32.9479181
              ],
              [
                48.2205544,
                32.9457132
              ],
              [
                48.2189483,
                32.9438787
              ],
              [
                48.2164649,
                32.9413034
              ],
              [
                48.2134857,
                32.9384126
              ],
              [
                48.2103462,
                32.9355205
              ],
              [
                48.2073631,
                32.9322622
              ],
              [
                48.2039413,
                32.9284011
              ],
              [
                48.2006875,
                32.9250058
              ],
              [
                48.1991997,
                32.9235389
              ],
              [
                48.1973725,
                32.920917
              ],
              [
                48.1943398,
                32.9175649
              ],
              [
                48.1914673,
                32.9137541
              ],
              [
                48.1879959,
                32.9098961
              ],
              [
                48.1861687,
                32.9070014
              ],
              [
                48.183361,
                32.9040146
              ],
              [
                48.1820567,
                32.9026734
              ],
              [
                48.1817093,
                32.9023162
              ],
              [
                48.1796875,
                32.9009407
              ],
              [
                48.1780471,
                32.9001621
              ],
              [
                48.1767425,
                32.8997539
              ],
              [
                48.1755486,
                32.8997563
              ],
              [
                48.1718635,
                32.9000403
              ],
              [
                48.1691018,
                32.9005548
              ],
              [
                48.1657486,
                32.9015764
              ],
              [
                48.1652247,
                32.9018459
              ],
              [
                48.1641738,
                32.9023863
              ],
              [
                48.1633224,
                32.9028242
              ],
              [
                48.1610031,
                32.9040292
              ],
              [
                48.1594926,
                32.9049979
              ],
              [
                48.1586081,
                32.9059827
              ],
              [
                48.158207,
                32.9064293
              ],
              [
                48.1575737,
                32.9079521
              ],
              [
                48.1554795,
                32.9100276
              ],
              [
                48.1537055,
                32.9117363
              ],
              [
                48.1515046,
                32.9139018
              ],
              [
                48.1496734,
                32.9152913
              ],
              [
                48.1484908,
                32.9165806
              ],
              [
                48.1473046,
                32.9172748
              ],
              [
                48.1456833,
                32.9180605
              ],
              [
                48.1436807,
                32.9188036
              ],
              [
                48.1415176,
                32.9194979
              ],
              [
                48.1397248,
                32.9197341
              ],
              [
                48.1385345,
                32.9198759
              ],
              [
                48.1376648,
                32.9198808
              ],
              [
                48.1368485,
                32.9197426
              ],
              [
                48.1356505,
                32.919377
              ],
              [
                48.1341172,
                32.9183231
              ],
              [
                48.1327477,
                32.9171759
              ],
              [
                48.1310501,
                32.9156606
              ],
              [
                48.1295127,
                32.9139168
              ],
              [
                48.1280898,
                32.9126331
              ],
              [
                48.1265488,
                32.9106097
              ],
              [
                48.1238519,
                32.9066122
              ],
              [
                48.1225853,
                32.9046356
              ],
              [
                48.1206055,
                32.901741
              ],
              [
                48.1195068,
                32.9001807
              ],
              [
                48.1186829,
                32.8990325
              ],
              [
                48.1187325,
                32.8984792
              ],
              [
                48.1190986,
                32.8971893
              ],
              [
                48.1194688,
                32.8961746
              ],
              [
                48.1202163,
                32.8947944
              ],
              [
                48.1212311,
                32.893089
              ],
              [
                48.1219787,
                32.8920243
              ],
              [
                48.1230507,
                32.8905073
              ],
              [
                48.1243973,
                32.8893504
              ],
              [
                48.1245472,
                32.8889917
              ],
              [
                48.1248208,
                32.8883369
              ],
              [
                48.1253547,
                32.8874633
              ],
              [
                48.1255646,
                32.886632
              ],
              [
                48.1253549,
                32.8859945
              ],
              [
                48.1251716,
                32.8854373
              ],
              [
                48.1253853,
                32.8848833
              ],
              [
                48.1257586,
                32.8844964
              ],
              [
                48.1259193,
                32.8843298
              ],
              [
                48.1266212,
                32.8839154
              ],
              [
                48.1273155,
                32.8829915
              ],
              [
                48.1280097,
                32.8816528
              ],
              [
                48.1285935,
                32.8804085
              ],
              [
                48.1285323,
                32.8795822
              ],
              [
                48.1285248,
                32.87889
              ],
              [
                48.1285668,
                32.8777392
              ],
              [
                48.1285591,
                32.8766819
              ],
              [
                48.1282767,
                32.8757175
              ],
              [
                48.1282081,
                32.8742914
              ],
              [
                48.1285249,
                32.8733205
              ],
              [
                48.1286773,
                32.8724021
              ],
              [
                48.1288833,
                32.8712956
              ],
              [
                48.1288223,
                32.8704693
              ],
              [
                48.1282768,
                32.8702404
              ],
              [
                48.1276245,
                32.8699188
              ],
              [
                48.1263809,
                32.8699691
              ],
              [
                48.1256751,
                32.8700611
              ],
              [
                48.1246986,
                32.8698809
              ],
              [
                48.1239929,
                32.8693778
              ],
              [
                48.1236611,
                32.8689148
              ],
              [
                48.1230049,
                32.868228
              ],
              [
                48.1226234,
                32.8676761
              ],
              [
                48.1219635,
                32.8668021
              ],
              [
                48.1207658,
                32.866069
              ],
              [
                48.1195371,
                32.865538
              ],
              [
                48.1187553,
                32.8652
              ],
              [
                48.1173362,
                32.8639637
              ],
              [
                48.1161346,
                32.8629983
              ],
              [
                48.1151542,
                32.8624505
              ],
              [
                48.1146012,
                32.8608848
              ],
              [
                48.1138915,
                32.8602914
              ],
              [
                48.1141502,
                32.859774
              ],
              [
                48.1144218,
                32.8592307
              ],
              [
                48.1141433,
                32.8583114
              ],
              [
                48.1141319,
                32.8570219
              ],
              [
                48.1138001,
                32.8559639
              ],
              [
                48.1135178,
                32.8548124
              ],
              [
                48.1127548,
                32.8541253
              ],
              [
                48.1119347,
                32.8529772
              ],
              [
                48.1104622,
                32.8518748
              ],
              [
                48.1092605,
                32.8505893
              ],
              [
                48.1073569,
                32.8492627
              ],
              [
                48.106936,
                32.8491029
              ],
              [
                48.1062699,
                32.8488499
              ],
              [
                48.105236,
                32.8480236
              ],
              [
                48.1043091,
                32.8469653
              ],
              [
                48.1040841,
                32.8459548
              ],
              [
                48.1045036,
                32.8445738
              ],
              [
                48.1043761,
                32.8442421
              ],
              [
                48.105734,
                32.8435321
              ],
              [
                48.1064337,
                32.8425198
              ],
              [
                48.1077472,
                32.8373066
              ],
              [
                48.1114794,
                32.8353214
              ],
              [
                48.1149866,
                32.832806
              ],
              [
                48.1183216,
                32.8335299
              ],
              [
                48.1208057,
                32.8307657
              ],
              [
                48.1144269,
                32.8246248
              ],
              [
                48.109829,
                32.8208779
              ],
              [
                48.1071238,
                32.8155439
              ],
              [
                48.0979953,
                32.8061275
              ],
              [
                48.0899842,
                32.8047236
              ],
              [
                48.0797724,
                32.8002151
              ],
              [
                48.0783467,
                32.8007824
              ],
              [
                48.0789286,
                32.8034739
              ],
              [
                48.074976,
                32.8078603
              ],
              [
                48.0654841,
                32.8086245
              ],
              [
                48.0579445,
                32.8101805
              ],
              [
                48.0575661,
                32.8099624
              ],
              [
                48.0574592,
                32.8099007
              ],
              [
                48.0562783,
                32.8092197
              ],
              [
                48.049889,
                32.8061937
              ],
              [
                48.0490266,
                32.8057852
              ],
              [
                48.0488091,
                32.8054172
              ],
              [
                48.0490227,
                32.8050954
              ],
              [
                48.0499955,
                32.8049538
              ],
              [
                48.0501533,
                32.8049608
              ],
              [
                48.0509682,
                32.804997
              ],
              [
                48.0517769,
                32.8049057
              ],
              [
                48.0526351,
                32.8044864
              ],
              [
                48.0536041,
                32.8037947
              ],
              [
                48.0544091,
                32.8032389
              ],
              [
                48.0546761,
                32.8024563
              ],
              [
                48.0548325,
                32.8015832
              ],
              [
                48.0547219,
                32.8006587
              ],
              [
                48.0544472,
                32.7997845
              ],
              [
                48.0543862,
                32.7990956
              ],
              [
                48.0543614,
                32.7990261
              ],
              [
                48.0542222,
                32.7986365
              ],
              [
                48.0540542,
                32.7975349
              ],
              [
                48.0542068,
                32.7952778
              ],
              [
                48.0543666,
                32.7946053
              ],
              [
                48.05447,
                32.7941705
              ],
              [
                48.0545196,
                32.7935248
              ],
              [
                48.054512,
                32.7920528
              ],
              [
                48.0543441,
                32.7912262
              ],
              [
                48.0544558,
                32.7903377
              ],
              [
                48.0546192,
                32.7896279
              ],
              [
                48.0550052,
                32.7879504
              ],
              [
                48.0550873,
                32.7878686
              ],
              [
                48.0551873,
                32.7872656
              ],
              [
                48.0552368,
                32.7866221
              ],
              [
                48.0553437,
                32.786255
              ],
              [
                48.0555573,
                32.7861586
              ],
              [
                48.055935,
                32.7863884
              ],
              [
                48.0562592,
                32.7867115
              ],
              [
                48.0565091,
                32.7869798
              ],
              [
                48.0568581,
                32.7873545
              ],
              [
                48.0571862,
                32.7881353
              ],
              [
                48.0578384,
                32.7894669
              ],
              [
                48.0584373,
                32.7901572
              ],
              [
                48.0589791,
                32.7907514
              ],
              [
                48.0591966,
                32.7909842
              ],
              [
                48.0605469,
                32.7913472
              ],
              [
                48.0616799,
                32.7914347
              ],
              [
                48.0629195,
                32.7916644
              ],
              [
                48.0638923,
                32.7916602
              ],
              [
                48.065403,
                32.7915649
              ],
              [
                48.0661545,
                32.7913323
              ],
              [
                48.0672837,
                32.7907299
              ],
              [
                48.0677644,
                32.7902679
              ],
              [
                48.0680847,
                32.7896691
              ],
              [
                48.0682412,
                32.7888861
              ],
              [
                48.0682373,
                32.7883338
              ],
              [
                48.0679093,
                32.7876004
              ],
              [
                48.0675278,
                32.7865411
              ],
              [
                48.0670357,
                32.7856685
              ],
              [
                48.0659485,
                32.7843808
              ],
              [
                48.0640564,
                32.7828714
              ],
              [
                48.0622635,
                32.781033
              ],
              [
                48.060154,
                32.7795229
              ],
              [
                48.0595055,
                32.778969
              ],
              [
                48.058693,
                32.7784202
              ],
              [
                48.0584903,
                32.7783338
              ],
              [
                48.0578308,
                32.7780528
              ],
              [
                48.0569115,
                32.7776863
              ],
              [
                48.0562095,
                32.7773205
              ],
              [
                48.0551262,
                32.7765895
              ],
              [
                48.054802,
                32.7760342
              ],
              [
                48.0545807,
                32.7755309
              ],
              [
                48.0542527,
                32.7741956
              ],
              [
                48.0538101,
                32.7720822
              ],
              [
                48.0537675,
                32.7706794
              ],
              [
                48.0537415,
                32.7698244
              ],
              [
                48.0535697,
                32.767758
              ],
              [
                48.05373,
                32.7672051
              ],
              [
                48.0540505,
                32.7670165
              ],
              [
                48.0544815,
                32.7668802
              ],
              [
                48.054966,
                32.7669682
              ],
              [
                48.0554505,
                32.7671509
              ],
              [
                48.0560989,
                32.7676124
              ],
              [
                48.0565339,
                32.7678864
              ],
              [
                48.0572357,
                32.7683897
              ],
              [
                48.0575599,
                32.7686205
              ],
              [
                48.0580445,
                32.7688032
              ],
              [
                48.0587465,
                32.768752
              ],
              [
                48.0601997,
                32.7685202
              ],
              [
                48.0614929,
                32.7685619
              ],
              [
                48.0627824,
                32.7686034
              ],
              [
                48.0635375,
                32.7685129
              ],
              [
                48.0644494,
                32.76823
              ],
              [
                48.0649873,
                32.767864
              ],
              [
                48.0661125,
                32.767124
              ],
              [
                48.0670242,
                32.766521
              ],
              [
                48.0676155,
                32.7658767
              ],
              [
                48.0680924,
                32.76509
              ],
              [
                48.0686799,
                32.764263
              ],
              [
                48.0687829,
                32.7633391
              ],
              [
                48.0686684,
                32.7624213
              ],
              [
                48.0683975,
                32.7618717
              ],
              [
                48.0681762,
                32.7613639
              ],
              [
                48.067852,
                32.7609055
              ],
              [
                48.066986,
                32.760448
              ],
              [
                48.0663948,
                32.7602651
              ],
              [
                48.0655861,
                32.760174
              ],
              [
                48.0646171,
                32.7601783
              ],
              [
                48.062893,
                32.7599058
              ],
              [
                48.0626224,
                32.7599175
              ],
              [
                48.0617103,
                32.7599569
              ],
              [
                48.060955,
                32.7598197
              ],
              [
                48.0596085,
                32.7595018
              ],
              [
                48.0590133,
                32.7590416
              ],
              [
                48.058792,
                32.7579838
              ],
              [
                48.0588379,
                32.7568782
              ],
              [
                48.0589272,
                32.7566284
              ],
              [
                48.0593148,
                32.7555438
              ],
              [
                48.0600128,
                32.7548074
              ],
              [
                48.0610275,
                32.7541122
              ],
              [
                48.0623664,
                32.7528656
              ],
              [
                48.063221,
                32.7515761
              ],
              [
                48.0636444,
                32.7507431
              ],
              [
                48.063501,
                32.7501199
              ],
              [
                48.0634499,
                32.7491833
              ],
              [
                48.0634422,
                32.7485858
              ],
              [
                48.0639153,
                32.747657
              ],
              [
                48.0641213,
                32.7469631
              ],
              [
                48.0645408,
                32.7461773
              ],
              [
                48.0647468,
                32.7454834
              ],
              [
                48.0648994,
                32.7447432
              ],
              [
                48.0648919,
                32.7442358
              ],
              [
                48.0646095,
                32.7435959
              ],
              [
                48.064331,
                32.7431836
              ],
              [
                48.063884,
                32.7429377
              ],
              [
                48.063839,
                32.7429129
              ],
              [
                48.0631828,
                32.7426406
              ],
              [
                48.0625267,
                32.7424651
              ],
              [
                48.0618209,
                32.7423787
              ],
              [
                48.0611686,
                32.7423859
              ],
              [
                48.0604096,
                32.7423028
              ],
              [
                48.0600776,
                32.7419817
              ],
              [
                48.0598526,
                32.7415233
              ],
              [
                48.0597916,
                32.7409697
              ],
              [
                48.0599975,
                32.7403727
              ],
              [
                48.0609626,
                32.7396245
              ],
              [
                48.061689,
                32.7392354
              ],
              [
                48.0635986,
                32.7382123
              ],
              [
                48.0648422,
                32.7378312
              ],
              [
                48.0656013,
                32.7376822
              ],
              [
                48.0664139,
                32.737584
              ],
              [
                48.0671158,
                32.7373007
              ],
              [
                48.0678138,
                32.737015
              ],
              [
                48.0684585,
                32.73655
              ],
              [
                48.0686188,
                32.7364073
              ],
              [
                48.0686684,
                32.7360388
              ],
              [
                48.0686645,
                32.7357141
              ],
              [
                48.0684395,
                32.7352107
              ],
              [
                48.0681114,
                32.7350768
              ],
              [
                48.0677834,
                32.7350804
              ],
              [
                48.0673484,
                32.7350837
              ],
              [
                48.0670739,
                32.7349015
              ],
              [
                48.0667457,
                32.7345399
              ],
              [
                48.066655,
                32.7340791
              ],
              [
                48.0666276,
                32.7339399
              ],
              [
                48.066616,
                32.7332499
              ],
              [
                48.0665475,
                32.732509
              ],
              [
                48.0665359,
                32.7317739
              ],
              [
                48.0665779,
                32.7310379
              ],
              [
                48.0669441,
                32.7302012
              ],
              [
                48.0675392,
                32.729965
              ],
              [
                48.0678112,
                32.7299255
              ],
              [
                48.0685693,
                32.7298155
              ],
              [
                48.0700874,
                32.729709
              ],
              [
                48.0714988,
                32.7298322
              ],
              [
                48.072319,
                32.7301444
              ],
              [
                48.0728683,
                32.7305562
              ],
              [
                48.0742874,
                32.7310942
              ],
              [
                48.0757636,
                32.7316787
              ],
              [
                48.0776711,
                32.7321672
              ],
              [
                48.0785941,
                32.7321549
              ],
              [
                48.0793038,
                32.7323293
              ],
              [
                48.0800628,
                32.732232
              ],
              [
                48.0805474,
                32.731948
              ],
              [
                48.0809746,
                32.7315793
              ],
              [
                48.0811272,
                32.7309292
              ],
              [
                48.081543,
                32.7299111
              ],
              [
                48.0819626,
                32.7288931
              ],
              [
                48.0819511,
                32.7281107
              ],
              [
                48.0819397,
                32.7273756
              ],
              [
                48.0816003,
                32.7265923
              ],
              [
                48.0814285,
                32.7260429
              ],
              [
                48.0814209,
                32.7254905
              ],
              [
                48.0816344,
                32.7252588
              ],
              [
                48.081955,
                32.7250679
              ],
              [
                48.0824966,
                32.7250625
              ],
              [
                48.0828782,
                32.7250601
              ],
              [
                48.0835839,
                32.7250517
              ],
              [
                48.0839082,
                32.725048
              ],
              [
                48.0843392,
                32.72472
              ],
              [
                48.0845986,
                32.7239799
              ],
              [
                48.0845795,
                32.7228773
              ],
              [
                48.0845681,
                32.7220926
              ],
              [
                48.084938,
                32.7215806
              ],
              [
                48.0854149,
                32.7207487
              ],
              [
                48.0859489,
                32.7200962
              ],
              [
                48.0860481,
                32.7196815
              ],
              [
                48.0860444,
                32.7194064
              ],
              [
                48.0859832,
                32.7189452
              ],
              [
                48.0858688,
                32.7184827
              ],
              [
                48.0854187,
                32.7177037
              ],
              [
                48.0848656,
                32.7170191
              ],
              [
                48.0842057,
                32.7164718
              ],
              [
                48.0835496,
                32.7161094
              ],
              [
                48.0830421,
                32.7160785
              ],
              [
                48.0829505,
                32.7160729
              ],
              [
                48.0820235,
                32.7158057
              ],
              [
                48.0802841,
                32.715684
              ],
              [
                48.078659,
                32.715885
              ],
              [
                48.0765991,
                32.7161819
              ],
              [
                48.0753594,
                32.7166556
              ],
              [
                48.0741157,
                32.7168542
              ],
              [
                48.0732459,
                32.7167707
              ],
              [
                48.0724297,
                32.7167314
              ],
              [
                48.0718802,
                32.7164165
              ],
              [
                48.0710068,
                32.7161031
              ],
              [
                48.0705643,
                32.7154166
              ],
              [
                48.0703392,
                32.7150033
              ],
              [
                48.0701065,
                32.714085
              ],
              [
                48.0698814,
                32.7135321
              ],
              [
                48.0696526,
                32.7127942
              ],
              [
                48.0692672,
                32.7124786
              ],
              [
                48.0686645,
                32.7121625
              ],
              [
                48.0678977,
                32.7118448
              ],
              [
                48.0669747,
                32.7117646
              ],
              [
                48.0661583,
                32.7115899
              ],
              [
                48.0652351,
                32.7115976
              ],
              [
                48.0645828,
                32.7115598
              ],
              [
                48.0640908,
                32.7113341
              ],
              [
                48.0638122,
                32.710967
              ],
              [
                48.0636979,
                32.7104143
              ],
              [
                48.0637931,
                32.7096299
              ],
              [
                48.0639953,
                32.7087511
              ],
              [
                48.0645027,
                32.7082663
              ],
              [
                48.0645294,
                32.7082407
              ],
              [
                48.0656623,
                32.7077218
              ],
              [
                48.0677147,
                32.7071004
              ],
              [
                48.0693359,
                32.7067597
              ],
              [
                48.0705796,
                32.7064281
              ],
              [
                48.0718193,
                32.7057223
              ],
              [
                48.072731,
                32.704975
              ],
              [
                48.0737457,
                32.7040453
              ],
              [
                48.0744362,
                32.7032094
              ],
              [
                48.0748558,
                32.7022364
              ],
              [
                48.0753365,
                32.7015827
              ],
              [
                48.0759773,
                32.7009801
              ],
              [
                48.0764655,
                32.7009284
              ],
              [
                48.0771714,
                32.7009201
              ],
              [
                48.0776063,
                32.7010564
              ],
              [
                48.0781517,
                32.7012337
              ],
              [
                48.0789222,
                32.7018737
              ],
              [
                48.0798531,
                32.7023237
              ],
              [
                48.0804672,
                32.7032847
              ],
              [
                48.0814055,
                32.7042893
              ],
              [
                48.0821724,
                32.704697
              ],
              [
                48.0826072,
                32.7048762
              ],
              [
                48.0832634,
                32.7051462
              ],
              [
                48.0844574,
                32.7051357
              ],
              [
                48.0852738,
                32.7051276
              ],
              [
                48.0859222,
                32.7049827
              ],
              [
                48.0865632,
                32.7042853
              ],
              [
                48.0866013,
                32.7034522
              ],
              [
                48.08675,
                32.7024391
              ],
              [
                48.0870552,
                32.7012832
              ],
              [
                48.0874786,
                32.7005424
              ],
              [
                48.088005,
                32.6995246
              ],
              [
                48.0889702,
                32.6987311
              ],
              [
                48.0895538,
                32.6978025
              ],
              [
                48.0900269,
                32.6969231
              ],
              [
                48.0903968,
                32.6962285
              ],
              [
                48.0904389,
                32.6956299
              ],
              [
                48.0903205,
                32.6948473
              ],
              [
                48.0901947,
                32.6939698
              ],
              [
                48.0899544,
                32.6925465
              ],
              [
                48.0897255,
                32.6917658
              ],
              [
                48.0891686,
                32.6908941
              ],
              [
                48.0886116,
                32.6899795
              ],
              [
                48.0883137,
                32.689622
              ],
              [
                48.0881156,
                32.6893842
              ],
              [
                48.0873985,
                32.6888852
              ],
              [
                48.0865288,
                32.6886644
              ],
              [
                48.0853843,
                32.688489
              ],
              [
                48.0846749,
                32.6882674
              ],
              [
                48.0840225,
                32.6880426
              ],
              [
                48.0833663,
                32.6878628
              ],
              [
                48.0818368,
                32.6873697
              ],
              [
                48.0798188,
                32.6866532
              ],
              [
                48.0767631,
                32.6857638
              ],
              [
                48.0756226,
                32.6855885
              ],
              [
                48.0749093,
                32.685272
              ],
              [
                48.0745811,
                32.685048
              ],
              [
                48.0744629,
                32.6845403
              ],
              [
                48.0744553,
                32.684033
              ],
              [
                48.0743942,
                32.6834839
              ],
              [
                48.0744324,
                32.6826981
              ],
              [
                48.0744924,
                32.6821173
              ],
              [
                48.0745278,
                32.681774
              ],
              [
                48.0745164,
                32.6811291
              ],
              [
                48.0738564,
                32.6804465
              ],
              [
                48.0737267,
                32.6792939
              ],
              [
                48.0732269,
                32.6786083
              ],
              [
                48.0730592,
                32.6782415
              ],
              [
                48.0729942,
                32.6775976
              ],
              [
                48.0727691,
                32.6770897
              ],
              [
                48.0718955,
                32.6766862
              ],
              [
                48.070919,
                32.6766927
              ],
              [
                48.0700981,
                32.6766379
              ],
              [
                48.0697212,
                32.6766128
              ],
              [
                48.068798,
                32.676483
              ],
              [
                48.0676537,
                32.6762196
              ],
              [
                48.066887,
                32.6758568
              ],
              [
                48.0658416,
                32.6751291
              ],
              [
                48.064911,
                32.6745416
              ],
              [
                48.0630035,
                32.6741904
              ],
              [
                48.0618629,
                32.6739698
              ],
              [
                48.0594102,
                32.6735337
              ],
              [
                48.057129,
                32.6733697
              ],
              [
                48.0546874,
                32.6733484
              ],
              [
                48.0525704,
                32.6735534
              ],
              [
                48.0510559,
                32.6738423
              ],
              [
                48.0499763,
                32.6743173
              ],
              [
                48.0492248,
                32.6747369
              ],
              [
                48.0484772,
                32.6755284
              ],
              [
                48.0480004,
                32.6763151
              ],
              [
                48.0478516,
                32.6770554
              ],
              [
                48.0473175,
                32.6775703
              ],
              [
                48.0468864,
                32.6777562
              ],
              [
                48.0462342,
                32.6777183
              ],
              [
                48.0452004,
                32.6776353
              ],
              [
                48.0443802,
                32.6774131
              ],
              [
                48.043129,
                32.6770546
              ],
              [
                48.0416526,
                32.6764269
              ],
              [
                48.0400123,
                32.6757954
              ],
              [
                48.0388145,
                32.6755756
              ],
              [
                48.0371322,
                32.6754998
              ],
              [
                48.0352325,
                32.675563
              ],
              [
                48.0335502,
                32.6756292
              ],
              [
                48.0322495,
                32.6757314
              ],
              [
                48.030674,
                32.6757459
              ],
              [
                48.0298042,
                32.6757095
              ],
              [
                48.0291482,
                32.675437
              ],
              [
                48.0283851,
                32.675171
              ],
              [
                48.0276146,
                32.6744833
              ],
              [
                48.0271683,
                32.673889
              ],
              [
                48.0265656,
                32.6734352
              ],
              [
                48.0260125,
                32.6728856
              ],
              [
                48.0255241,
                32.6727072
              ],
              [
                48.0247613,
                32.6725314
              ],
              [
                48.0239448,
                32.6724015
              ],
              [
                48.0231819,
                32.6723586
              ],
              [
                48.0223694,
                32.6725084
              ],
              [
                48.0211753,
                32.6725206
              ],
              [
                48.0202561,
                32.6727557
              ],
              [
                48.0188485,
                32.6729544
              ],
              [
                48.0178756,
                32.673195
              ],
              [
                48.0159835,
                32.6737224
              ],
              [
                48.0145759,
                32.6739662
              ],
              [
                48.0132789,
                32.6743477
              ],
              [
                48.0119285,
                32.6748204
              ],
              [
                48.0107421,
                32.675155
              ],
              [
                48.0100366,
                32.6753456
              ],
              [
                48.0093917,
                32.6756322
              ],
              [
                48.0086326,
                32.6756366
              ],
              [
                48.0082474,
                32.6755035
              ],
              [
                48.0073776,
                32.6752348
              ],
              [
                48.0067215,
                32.6750568
              ],
              [
                48.0062828,
                32.6748773
              ],
              [
                48.0058479,
                32.6746979
              ],
              [
                48.0050887,
                32.6747023
              ],
              [
                48.0042152,
                32.6745259
              ],
              [
                48.0034026,
                32.6745335
              ],
              [
                48.0020447,
                32.6745484
              ],
              [
                48.0014992,
                32.6743235
              ],
              [
                48.0011634,
                32.6738669
              ],
              [
                48.0009957,
                32.673358
              ],
              [
                48.0012512,
                32.6724806
              ],
              [
                48.0012435,
                32.6718786
              ],
              [
                48.0012401,
                32.6716658
              ],
              [
                48.001236,
                32.6714164
              ],
              [
                48.0013351,
                32.6708643
              ],
              [
                48.0014801,
                32.6698941
              ],
              [
                48.0018043,
                32.6698004
              ],
              [
                48.0021782,
                32.6692887
              ],
              [
                48.0021668,
                32.6685942
              ],
              [
                48.0019418,
                32.6681358
              ],
              [
                48.0012818,
                32.6675904
              ],
              [
                47.9999771,
                32.6668875
              ],
              [
                47.9995906,
                32.666628
              ],
              [
                47.9995515,
                32.6665736
              ],
              [
                47.9993879,
                32.666346
              ],
              [
                47.9989549,
                32.6649968
              ],
              [
                47.998066,
                32.6627419
              ],
              [
                47.9972381,
                32.661133
              ],
              [
                47.9963569,
                32.6597528
              ],
              [
                47.9952049,
                32.6589702
              ],
              [
                47.9944344,
                32.6580501
              ],
              [
                47.9941389,
                32.6578166
              ],
              [
                47.9934464,
                32.6572691
              ],
              [
                47.9919662,
                32.6564876
              ],
              [
                47.9908715,
                32.6557964
              ],
              [
                47.9904131,
                32.6556886
              ],
              [
                47.9891205,
                32.6553847
              ],
              [
                47.9878082,
                32.6549227
              ],
              [
                47.9867668,
                32.6546025
              ],
              [
                47.9852371,
                32.6540946
              ],
              [
                47.984447,
                32.6537829
              ],
              [
                47.9843064,
                32.6537274
              ],
              [
                47.9831008,
                32.6534955
              ],
              [
                47.9821206,
                32.6534494
              ],
              [
                47.9815216,
                32.653728
              ],
              [
                47.9804878,
                32.65451
              ],
              [
                47.9798889,
                32.6552011
              ],
              [
                47.9789657,
                32.6559835
              ],
              [
                47.9774399,
                32.6568573
              ],
              [
                47.9748801,
                32.6579135
              ],
              [
                47.973133,
                32.6584213
              ],
              [
                47.9720422,
                32.6586947
              ],
              [
                47.9713326,
                32.6586956
              ],
              [
                47.970131,
                32.6585111
              ],
              [
                47.9691466,
                32.6582799
              ],
              [
                47.9686507,
                32.6577766
              ],
              [
                47.968212,
                32.6571777
              ],
              [
                47.9679909,
                32.6565323
              ],
              [
                47.9677696,
                32.6558913
              ],
              [
                47.9672737,
                32.655246
              ],
              [
                47.9665603,
                32.6544196
              ],
              [
                47.9654617,
                32.6535005
              ],
              [
                47.9648349,
                32.6530119
              ],
              [
                47.9639816,
                32.6523467
              ],
              [
                47.962883,
                32.6512901
              ],
              [
                47.9621123,
                32.6502346
              ],
              [
                47.961506,
                32.6489442
              ],
              [
                47.9610634,
                32.6478877
              ],
              [
                47.960949,
                32.6469225
              ],
              [
                47.9609451,
                32.6460502
              ],
              [
                47.9612694,
                32.6454495
              ],
              [
                47.9615936,
                32.6449435
              ],
              [
                47.9617428,
                32.6447949
              ],
              [
                47.9621925,
                32.6443472
              ],
              [
                47.9624062,
                32.6437956
              ],
              [
                47.9624595,
                32.6429675
              ],
              [
                47.9620704,
                32.6422774
              ],
              [
                47.9611931,
                32.6414042
              ],
              [
                47.9606476,
                32.6409875
              ],
              [
                47.9592781,
                32.6402083
              ],
              [
                47.9579087,
                32.6392397
              ],
              [
                47.9569065,
                32.6387883
              ],
              [
                47.9564858,
                32.6385989
              ],
              [
                47.9553872,
                32.6379547
              ],
              [
                47.9548378,
                32.6372178
              ],
              [
                47.9545594,
                32.6359782
              ],
              [
                47.9546661,
                32.6353339
              ],
              [
                47.9554824,
                32.6345514
              ],
              [
                47.9569511,
                32.6334465
              ],
              [
                47.9583626,
                32.6322051
              ],
              [
                47.9596672,
                32.6311503
              ],
              [
                47.9611358,
                32.6303181
              ],
              [
                47.9626046,
                32.6293981
              ],
              [
                47.9639664,
                32.6288495
              ],
              [
                47.9693031,
                32.6262243
              ],
              [
                47.9713173,
                32.6252136
              ],
              [
                47.9733315,
                32.6243404
              ],
              [
                47.9748039,
                32.6238778
              ],
              [
                47.9762229,
                32.6235085
              ],
              [
                47.977581,
                32.6228177
              ],
              [
                47.9785081,
                32.622085
              ],
              [
                47.9794808,
                32.6207493
              ],
              [
                47.9809493,
                32.6195991
              ],
              [
                47.9821434,
                32.6188164
              ],
              [
                47.9835626,
                32.6183119
              ],
              [
                47.9851417,
                32.6176218
              ],
              [
                47.9864998,
                32.6168408
              ],
              [
                47.9882964,
                32.6157344
              ],
              [
                47.9889985,
                32.614906
              ],
              [
                47.9892159,
                32.6143523
              ],
              [
                47.9893189,
                32.6134802
              ],
              [
                47.9892081,
                32.6128352
              ],
              [
                47.9887123,
                32.6121494
              ],
              [
                47.9883271,
                32.6114121
              ],
              [
                47.9876671,
                32.6107223
              ],
              [
                47.9870071,
                32.6100303
              ],
              [
                47.9858589,
                32.6094325
              ],
              [
                47.9847862,
                32.6090954
              ],
              [
                47.9845467,
                32.6090201
              ],
              [
                47.9829636,
                32.6088829
              ],
              [
                47.9818192,
                32.609065
              ],
              [
                47.9807281,
                32.6093452
              ],
              [
                47.9797477,
                32.6098941
              ],
              [
                47.9793716,
                32.6101549
              ],
              [
                47.9785538,
                32.6107219
              ],
              [
                47.9770851,
                32.611827
              ],
              [
                47.9756164,
                32.6124272
              ],
              [
                47.9745788,
                32.6126546
              ],
              [
                47.9725609,
                32.6128381
              ],
              [
                47.9702149,
                32.6126553
              ],
              [
                47.9674836,
                32.6125172
              ],
              [
                47.9652482,
                32.6124722
              ],
              [
                47.963829,
                32.612706
              ],
              [
                47.961483,
                32.6129333
              ],
              [
                47.9600639,
                32.6129349
              ],
              [
                47.9588623,
                32.6127052
              ],
              [
                47.95755,
                32.6123399
              ],
              [
                47.9560203,
                32.6116942
              ],
              [
                47.9545441,
                32.611282
              ],
              [
                47.951374,
                32.6100398
              ],
              [
                47.9507905,
                32.6098908
              ],
              [
                47.9501152,
                32.6097184
              ],
              [
                47.9493523,
                32.6095804
              ],
              [
                47.9485893,
                32.6097647
              ],
              [
                47.9475517,
                32.6099964
              ],
              [
                47.9459191,
                32.6104097
              ],
              [
                47.9457398,
                32.6104506
              ],
              [
                47.9445,
                32.6107336
              ],
              [
                47.9433556,
                32.6109153
              ],
              [
                47.9424287,
                32.6109153
              ],
              [
                47.9413376,
                32.6108256
              ],
              [
                47.9403534,
                32.6103621
              ],
              [
                47.9393121,
                32.6099513
              ],
              [
                47.9383277,
                32.6090775
              ],
              [
                47.9380707,
                32.6087862
              ],
              [
                47.9380447,
                32.6087568
              ],
              [
                47.9375573,
                32.6082045
              ],
              [
                47.9366265,
                32.6070549
              ],
              [
                47.9359665,
                32.6058577
              ],
              [
                47.9353065,
                32.6046628
              ],
              [
                47.9352649,
                32.6044632
              ],
              [
                47.9349709,
                32.6030544
              ],
              [
                47.934475,
                32.601859
              ],
              [
                47.9341431,
                32.6009854
              ],
              [
                47.9335938,
                32.6003409
              ],
              [
                47.932991,
                32.5998348
              ],
              [
                47.9323882,
                32.599606
              ],
              [
                47.9315719,
                32.5994215
              ],
              [
                47.9304809,
                32.5993768
              ],
              [
                47.9289513,
                32.5994678
              ],
              [
                47.926609,
                32.5998838
              ],
              [
                47.924862,
                32.6002535
              ],
              [
                47.9230652,
                32.600667
              ],
              [
                47.920723,
                32.6015404
              ],
              [
                47.9188727,
                32.6023221
              ],
              [
                47.9176177,
                32.6026925
              ],
              [
                47.9166373,
                32.6029208
              ],
              [
                47.9164832,
                32.6029102
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554898,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اهواز",
          "name:ar": "مقاطعة الأهواز",
          "name:en": "Ahvaz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1272922",
          "wikipedia": "en:Ahvaz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.0307025,
                31.0057707
              ],
              [
                48.032859,
                30.9909788
              ],
              [
                48.0335364,
                30.8974702
              ],
              [
                48.0727119,
                30.9107515
              ],
              [
                48.1021625,
                30.9200735
              ],
              [
                48.1547433,
                30.9367005
              ],
              [
                48.199396,
                30.9511443
              ],
              [
                48.2064199,
                30.9510768
              ],
              [
                48.2156467,
                30.9519969
              ],
              [
                48.2251606,
                30.9518662
              ],
              [
                48.2747116,
                30.9533671
              ],
              [
                48.2881432,
                30.9544251
              ],
              [
                48.3119087,
                30.9552963
              ],
              [
                48.3151283,
                30.9554018
              ],
              [
                48.3211041,
                30.9556282
              ],
              [
                48.3559742,
                30.9557125
              ],
              [
                48.3580122,
                30.9617695
              ],
              [
                48.3592892,
                30.9656708
              ],
              [
                48.3595434,
                30.9664201
              ],
              [
                48.3596344,
                30.9680572
              ],
              [
                48.3599433,
                30.9711727
              ],
              [
                48.359726,
                30.9742369
              ],
              [
                48.3593978,
                30.9770305
              ],
              [
                48.3594475,
                30.9802332
              ],
              [
                48.3599205,
                30.9820195
              ],
              [
                48.3605575,
                30.983302
              ],
              [
                48.3616181,
                30.9844487
              ],
              [
                48.3631058,
                30.9853697
              ],
              [
                48.3658218,
                30.9861083
              ],
              [
                48.3684273,
                30.9867545
              ],
              [
                48.3718338,
                30.9873605
              ],
              [
                48.3738518,
                30.9880036
              ],
              [
                48.3761939,
                30.9887434
              ],
              [
                48.3778419,
                30.9898005
              ],
              [
                48.3786925,
                30.9907197
              ],
              [
                48.3804969,
                30.9930583
              ],
              [
                48.3809737,
                30.9943397
              ],
              [
                48.3812904,
                30.9962175
              ],
              [
                48.3812866,
                30.9980031
              ],
              [
                48.3811761,
                30.9991913
              ],
              [
                48.3809089,
                31.0001058
              ],
              [
                48.3806694,
                31.0004265
              ],
              [
                48.3792229,
                31.0023624
              ],
              [
                48.3768616,
                31.004732
              ],
              [
                48.3760605,
                31.0055358
              ],
              [
                48.3743705,
                31.0069625
              ],
              [
                48.3703381,
                31.0104437
              ],
              [
                48.3698368,
                31.0108765
              ],
              [
                48.3697319,
                31.010967
              ],
              [
                48.3691821,
                31.0115277
              ],
              [
                48.367569,
                31.0131731
              ],
              [
                48.3658333,
                31.0152886
              ],
              [
                48.3642082,
                31.0175394
              ],
              [
                48.3632622,
                31.0189631
              ],
              [
                48.3628997,
                31.0198801
              ],
              [
                48.3626938,
                31.0209356
              ],
              [
                48.3627052,
                31.0221714
              ],
              [
                48.3628769,
                31.0232684
              ],
              [
                48.3633118,
                31.0244565
              ],
              [
                48.3637544,
                31.0252723
              ],
              [
                48.3639068,
                31.0255531
              ],
              [
                48.3647117,
                31.0262347
              ],
              [
                48.3660507,
                31.0272361
              ],
              [
                48.3676568,
                31.0283714
              ],
              [
                48.368515,
                31.0290089
              ],
              [
                48.3706475,
                31.0295936
              ],
              [
                48.3716621,
                31.0300922
              ],
              [
                48.3733636,
                31.0302216
              ],
              [
                48.3754921,
                31.0300755
              ],
              [
                48.3772964,
                31.0297898
              ],
              [
                48.3788337,
                31.0292799
              ],
              [
                48.3815995,
                31.0289911
              ],
              [
                48.3831863,
                31.0284349
              ],
              [
                48.3856812,
                31.0278271
              ],
              [
                48.3879089,
                31.0270853
              ],
              [
                48.3901901,
                31.0265724
              ],
              [
                48.3927918,
                31.0260545
              ],
              [
                48.3945999,
                31.0258182
              ],
              [
                48.3966713,
                31.0258533
              ],
              [
                48.3967928,
                31.0258864
              ],
              [
                48.3981286,
                31.02625
              ],
              [
                48.398444,
                31.0263359
              ],
              [
                48.3984872,
                31.0263476
              ],
              [
                48.4006195,
                31.0267942
              ],
              [
                48.4025383,
                31.0273357
              ],
              [
                48.4040375,
                31.0284729
              ],
              [
                48.4040483,
                31.0284825
              ],
              [
                48.4053803,
                31.0296543
              ],
              [
                48.405654,
                31.0299085
              ],
              [
                48.406559,
                31.030749
              ],
              [
                48.4073716,
                31.0320257
              ],
              [
                48.4078064,
                31.0330762
              ],
              [
                48.4081917,
                31.034448
              ],
              [
                48.4084167,
                31.0357309
              ],
              [
                48.4084281,
                31.0370118
              ],
              [
                48.4083366,
                31.0383854
              ],
              [
                48.4080353,
                31.0403093
              ],
              [
                48.4074134,
                31.0418233
              ],
              [
                48.4068413,
                31.0433833
              ],
              [
                48.4061088,
                31.0447146
              ],
              [
                48.4053192,
                31.0454045
              ],
              [
                48.4041557,
                31.0463258
              ],
              [
                48.4028358,
                31.0473386
              ],
              [
                48.4011993,
                31.0485367
              ],
              [
                48.3987618,
                31.0496915
              ],
              [
                48.3972815,
                31.0507078
              ],
              [
                48.3955917,
                31.0517222
              ],
              [
                48.3932076,
                31.0528306
              ],
              [
                48.390934,
                31.0545365
              ],
              [
                48.3895331,
                31.0557198
              ],
              [
                48.3876076,
                31.0573461
              ],
              [
                48.3840752,
                31.0606588
              ],
              [
                48.3815917,
                31.0623197
              ],
              [
                48.379219,
                31.0649861
              ],
              [
                48.3771095,
                31.0670558
              ],
              [
                48.3759574,
                31.0687572
              ],
              [
                48.3745919,
                31.0708668
              ],
              [
                48.3744554,
                31.071333
              ],
              [
                48.3739205,
                31.0731596
              ],
              [
                48.3733521,
                31.0750397
              ],
              [
                48.372776,
                31.0760493
              ],
              [
                48.3720474,
                31.0776105
              ],
              [
                48.3716355,
                31.0790766
              ],
              [
                48.3711242,
                31.0812758
              ],
              [
                48.3705559,
                31.0832032
              ],
              [
                48.3703651,
                31.0855396
              ],
              [
                48.370327,
                31.0874147
              ],
              [
                48.3702431,
                31.0898413
              ],
              [
                48.3702506,
                31.0908042
              ],
              [
                48.3703689,
                31.0920399
              ],
              [
                48.3708688,
                31.0939598
              ],
              [
                48.3716965,
                31.0972053
              ],
              [
                48.3721924,
                31.0992627
              ],
              [
                48.3732872,
                31.1024618
              ],
              [
                48.3734269,
                31.102828
              ],
              [
                48.3741073,
                31.1046115
              ],
              [
                48.3750006,
                31.1060943
              ],
              [
                48.3757286,
                31.1073027
              ],
              [
                48.3770218,
                31.1088983
              ],
              [
                48.3786392,
                31.1110416
              ],
              [
                48.3803596,
                31.1129119
              ],
              [
                48.3827705,
                31.1144107
              ],
              [
                48.3837064,
                31.1151104
              ],
              [
                48.3859329,
                31.1167747
              ],
              [
                48.392147,
                31.1206344
              ],
              [
                48.398304,
                31.1242221
              ],
              [
                48.4034958,
                31.1267124
              ],
              [
                48.4049925,
                31.1273791
              ],
              [
                48.4065438,
                31.1280702
              ],
              [
                48.4111976,
                31.1300623
              ],
              [
                48.4135552,
                31.1315144
              ],
              [
                48.4165039,
                31.133835
              ],
              [
                48.4187051,
                31.1355184
              ],
              [
                48.4193249,
                31.1363352
              ],
              [
                48.4205398,
                31.1379361
              ],
              [
                48.4221039,
                31.1396674
              ],
              [
                48.4231262,
                31.1408062
              ],
              [
                48.4241485,
                31.141945
              ],
              [
                48.4254914,
                31.1430384
              ],
              [
                48.4269372,
                31.1436242
              ],
              [
                48.4290694,
                31.14412
              ],
              [
                48.4310455,
                31.1446104
              ],
              [
                48.433548,
                31.1444619
              ],
              [
                48.4355697,
                31.1440873
              ],
              [
                48.4376449,
                31.1438919
              ],
              [
                48.4395028,
                31.1431036
              ],
              [
                48.4412574,
                31.1429604
              ],
              [
                48.4435958,
                31.1424455
              ],
              [
                48.4458848,
                31.1422496
              ],
              [
                48.4486579,
                31.1425121
              ],
              [
                48.4507905,
                31.1426828
              ],
              [
                48.4528197,
                31.1431311
              ],
              [
                48.4541549,
                31.1438091
              ],
              [
                48.4542171,
                31.1438354
              ],
              [
                48.4559747,
                31.1445779
              ],
              [
                48.4573707,
                31.145672
              ],
              [
                48.457983,
                31.1464805
              ],
              [
                48.4581226,
                31.1466649
              ],
              [
                48.4581299,
                31.1466745
              ],
              [
                48.4588318,
                31.1478608
              ],
              [
                48.4594307,
                31.1489572
              ],
              [
                48.4601975,
                31.1508753
              ],
              [
                48.46064,
                31.1526585
              ],
              [
                48.4610328,
                31.1544881
              ],
              [
                48.4620819,
                31.1581907
              ],
              [
                48.4629211,
                31.1620312
              ],
              [
                48.4634495,
                31.1641549
              ],
              [
                48.4634781,
                31.1642699
              ],
              [
                48.4638825,
                31.1671977
              ],
              [
                48.4648666,
                31.1696635
              ],
              [
                48.4657441,
                31.1720865
              ],
              [
                48.4671059,
                31.1747807
              ],
              [
                48.4675522,
                31.1769292
              ],
              [
                48.4689713,
                31.1800348
              ],
              [
                48.470108,
                31.1818136
              ],
              [
                48.4717217,
                31.1833177
              ],
              [
                48.4727477,
                31.1844111
              ],
              [
                48.4736595,
                31.1850919
              ],
              [
                48.4748917,
                31.1854971
              ],
              [
                48.4760627,
                31.1855832
              ],
              [
                48.4776611,
                31.1853463
              ],
              [
                48.4789345,
                31.1848604
              ],
              [
                48.4793349,
                31.1847076
              ],
              [
                48.4793586,
                31.1846986
              ],
              [
                48.4794311,
                31.1846032
              ],
              [
                48.4799882,
                31.1838699
              ],
              [
                48.481411,
                31.1820782
              ],
              [
                48.4830251,
                31.1806989
              ],
              [
                48.483944,
                31.1799137
              ],
              [
                48.48563,
                31.1778903
              ],
              [
                48.487568,
                31.1748144
              ],
              [
                48.4887161,
                31.1725663
              ],
              [
                48.4901772,
                31.1697223
              ],
              [
                48.4913254,
                31.1674719
              ],
              [
                48.4926986,
                31.1663217
              ],
              [
                48.4935379,
                31.1651724
              ],
              [
                48.4949646,
                31.1641607
              ],
              [
                48.496132,
                31.1634664
              ],
              [
                48.4978333,
                31.1633214
              ],
              [
                48.4999272,
                31.1636372
              ],
              [
                48.5031319,
                31.1649575
              ],
              [
                48.5057943,
                31.1667949
              ],
              [
                48.5087813,
                31.168722
              ],
              [
                48.5121384,
                31.1717046
              ],
              [
                48.5138969,
                31.173725
              ],
              [
                48.5158157,
                31.1759267
              ],
              [
                48.5176277,
                31.1786786
              ],
              [
                48.5191727,
                31.1805145
              ],
              [
                48.5201836,
                31.1815712
              ],
              [
                48.5217322,
                31.1825796
              ],
              [
                48.5238649,
                31.1831776
              ],
              [
                48.5259438,
                31.1837745
              ],
              [
                48.5293581,
                31.1841445
              ],
              [
                48.5305863,
                31.1838727
              ],
              [
                48.5328827,
                31.1833689
              ],
              [
                48.5357628,
                31.1825921
              ],
              [
                48.5377882,
                31.1821822
              ],
              [
                48.5405656,
                31.1820933
              ],
              [
                48.542057,
                31.1821398
              ],
              [
                48.5434455,
                31.1824617
              ],
              [
                48.5447234,
                31.1829686
              ],
              [
                48.5451104,
                31.1832015
              ],
              [
                48.5457916,
                31.1836113
              ],
              [
                48.5461122,
                31.1842984
              ],
              [
                48.5470198,
                31.1850801
              ],
              [
                48.5474432,
                31.1860893
              ],
              [
                48.5474432,
                31.1873722
              ],
              [
                48.5473901,
                31.1882867
              ],
              [
                48.5470696,
                31.1889299
              ],
              [
                48.5469627,
                31.1902131
              ],
              [
                48.5465888,
                31.1913131
              ],
              [
                48.5460015,
                31.1924586
              ],
              [
                48.5443992,
                31.1956207
              ],
              [
                48.5435448,
                31.1975458
              ],
              [
                48.5430641,
                31.198461
              ],
              [
                48.54237,
                31.1994241
              ],
              [
                48.5421029,
                31.2004336
              ],
              [
                48.5420551,
                31.2007512
              ],
              [
                48.5418891,
                31.2018546
              ],
              [
                48.5418893,
                31.203
              ],
              [
                48.541889,
                31.2038703
              ],
              [
                48.5422629,
                31.205201
              ],
              [
                48.543064,
                31.2066684
              ],
              [
                48.5436478,
                31.2076784
              ],
              [
                48.5446625,
                31.2086876
              ],
              [
                48.5459975,
                31.2094234
              ],
              [
                48.5488242,
                31.210616
              ],
              [
                48.5515479,
                31.2112158
              ],
              [
                48.5556029,
                31.2122264
              ],
              [
                48.5578461,
                31.2124133
              ],
              [
                48.5598181,
                31.2128273
              ],
              [
                48.5622215,
                31.2131503
              ],
              [
                48.5643043,
                31.2134287
              ],
              [
                48.566227,
                31.2134764
              ],
              [
                48.5678787,
                31.213661
              ],
              [
                48.5690537,
                31.2136607
              ],
              [
                48.5698014,
                31.2134313
              ],
              [
                48.5714571,
                31.2131131
              ],
              [
                48.5726319,
                31.2128399
              ],
              [
                48.5732183,
                31.2128003
              ],
              [
                48.5739633,
                31.21275
              ],
              [
                48.5750848,
                31.2127487
              ],
              [
                48.5765802,
                31.2131624
              ],
              [
                48.5774346,
                31.2133476
              ],
              [
                48.5781289,
                31.2136696
              ],
              [
                48.5785028,
                31.2145403
              ],
              [
                48.5783426,
                31.2153196
              ],
              [
                48.5785026,
                31.216193
              ],
              [
                48.5782889,
                31.2167414
              ],
              [
                48.5779151,
                31.2173815
              ],
              [
                48.5773276,
                31.2177492
              ],
              [
                48.5765799,
                31.2180688
              ],
              [
                48.575405,
                31.2186645
              ],
              [
                48.5741807,
                31.2194892
              ],
              [
                48.5726319,
                31.2201747
              ],
              [
                48.57119,
                31.2209525
              ],
              [
                48.5700148,
                31.2214556
              ],
              [
                48.5688934,
                31.2218696
              ],
              [
                48.5678846,
                31.2223561
              ],
              [
                48.5676651,
                31.2224619
              ],
              [
                48.566864,
                31.2230578
              ],
              [
                48.5656394,
                31.224065
              ],
              [
                48.5652139,
                31.2246859
              ],
              [
                48.5651055,
                31.2248441
              ],
              [
                48.5640908,
                31.2260808
              ],
              [
                48.5631294,
                31.2273636
              ],
              [
                48.5625939,
                31.2280173
              ],
              [
                48.5621146,
                31.2286025
              ],
              [
                48.5616341,
                31.2297005
              ],
              [
                48.5613136,
                31.230939
              ],
              [
                48.5612069,
                31.2321298
              ],
              [
                48.5612118,
                31.2321644
              ],
              [
                48.5613671,
                31.233276
              ],
              [
                48.5612069,
                31.2346055
              ],
              [
                48.5612068,
                31.2358885
              ],
              [
                48.5615273,
                31.2388708
              ],
              [
                48.5617408,
                31.2407486
              ],
              [
                48.5622144,
                31.2430421
              ],
              [
                48.5623284,
                31.243594
              ],
              [
                48.5627557,
                31.2453338
              ],
              [
                48.5630761,
                31.2466657
              ],
              [
                48.56307,
                31.247705
              ],
              [
                48.5630561,
                31.2500497
              ],
              [
                48.563076,
                31.251191
              ],
              [
                48.5637206,
                31.2528402
              ],
              [
                48.5644721,
                31.2540314
              ],
              [
                48.5653839,
                31.2551761
              ],
              [
                48.5665587,
                31.2559086
              ],
              [
                48.5677873,
                31.2559995
              ],
              [
                48.5693894,
                31.2561403
              ],
              [
                48.5708846,
                31.2559544
              ],
              [
                48.5724298,
                31.2551764
              ],
              [
                48.5732858,
                31.2543679
              ],
              [
                48.5740776,
                31.2536202
              ],
              [
                48.5750351,
                31.2521997
              ],
              [
                48.5758818,
                31.2506869
              ],
              [
                48.5763615,
                31.2500308
              ],
              [
                48.577923,
                31.2482384
              ],
              [
                48.5793077,
                31.2461292
              ],
              [
                48.580269,
                31.2438384
              ],
              [
                48.5807496,
                31.2422804
              ],
              [
                48.5820848,
                31.24054
              ],
              [
                48.58255,
                31.2401516
              ],
              [
                48.5840073,
                31.2389347
              ],
              [
                48.5856628,
                31.237516
              ],
              [
                48.5880089,
                31.2357314
              ],
              [
                48.5903588,
                31.2343121
              ],
              [
                48.5929224,
                31.2336724
              ],
              [
                48.5960879,
                31.2332013
              ],
              [
                48.5962867,
                31.2331717
              ],
              [
                48.5975898,
                31.2331723
              ],
              [
                48.5986365,
                31.2331728
              ],
              [
                48.6008386,
                31.2335132
              ],
              [
                48.6016235,
                31.2336344
              ],
              [
                48.6037598,
                31.2340486
              ],
              [
                48.6059492,
                31.2350139
              ],
              [
                48.607605,
                31.2361631
              ],
              [
                48.6079291,
                31.2370327
              ],
              [
                48.6079293,
                31.2387306
              ],
              [
                48.6073951,
                31.2404253
              ],
              [
                48.6065444,
                31.2419382
              ],
              [
                48.6054763,
                31.2431742
              ],
              [
                48.6037673,
                31.244272
              ],
              [
                48.602112,
                31.2458308
              ],
              [
                48.6001356,
                31.247158
              ],
              [
                48.5979318,
                31.2485419
              ],
              [
                48.5943496,
                31.2500983
              ],
              [
                48.5904072,
                31.2515519
              ],
              [
                48.5890247,
                31.2520616
              ],
              [
                48.5858856,
                31.2542537
              ],
              [
                48.5850219,
                31.2548568
              ],
              [
                48.5834943,
                31.2564053
              ],
              [
                48.5826263,
                31.2572852
              ],
              [
                48.5815126,
                31.2587975
              ],
              [
                48.5811959,
                31.259804
              ],
              [
                48.5811462,
                31.2612258
              ],
              [
                48.5813636,
                31.2626436
              ],
              [
                48.5817018,
                31.2634432
              ],
              [
                48.5818482,
                31.2637892
              ],
              [
                48.5820625,
                31.2641218
              ],
              [
                48.5824393,
                31.2647067
              ],
              [
                48.5832956,
                31.2654413
              ],
              [
                48.5834737,
                31.2653078
              ],
              [
                48.5957395,
                31.2666418
              ],
              [
                48.6083485,
                31.2680231
              ],
              [
                48.6135186,
                31.2685891
              ],
              [
                48.6156948,
                31.2688272
              ],
              [
                48.6197033,
                31.2686
              ],
              [
                48.6209345,
                31.2685302
              ],
              [
                48.6311785,
                31.2682567
              ],
              [
                48.633151,
                31.268204
              ],
              [
                48.6333714,
                31.267527
              ],
              [
                48.6355025,
                31.2609803
              ],
              [
                48.6357171,
                31.260321
              ],
              [
                48.6357384,
                31.2601249
              ],
              [
                48.6358199,
                31.2578345
              ],
              [
                48.6343821,
                31.2510022
              ],
              [
                48.6336951,
                31.2502472
              ],
              [
                48.6335105,
                31.2500454
              ],
              [
                48.632932,
                31.2494766
              ],
              [
                48.6314887,
                31.2480577
              ],
              [
                48.6304702,
                31.2470017
              ],
              [
                48.6295091,
                31.2455815
              ],
              [
                48.6289176,
                31.243654
              ],
              [
                48.6289178,
                31.2424612
              ],
              [
                48.6292383,
                31.2414525
              ],
              [
                48.6295013,
                31.2401698
              ],
              [
                48.6296864,
                31.2398789
              ],
              [
                48.6301422,
                31.2391624
              ],
              [
                48.6309431,
                31.2384309
              ],
              [
                48.6327056,
                31.2378816
              ],
              [
                48.6344682,
                31.2377449
              ],
              [
                48.6355361,
                31.2378818
              ],
              [
                48.6366343,
                31.2384795
              ],
              [
                48.6373858,
                31.2382416
              ],
              [
                48.6426215,
                31.2417281
              ],
              [
                48.6465616,
                31.2483034
              ],
              [
                48.6469391,
                31.2486215
              ],
              [
                48.648739,
                31.2501379
              ],
              [
                48.6517753,
                31.2536207
              ],
              [
                48.6546744,
                31.2583367
              ],
              [
                48.6550555,
                31.2592339
              ],
              [
                48.656735,
                31.2631881
              ],
              [
                48.6580456,
                31.2671357
              ],
              [
                48.6589075,
                31.2699245
              ],
              [
                48.660798,
                31.269339
              ],
              [
                48.6685276,
                31.2669452
              ],
              [
                48.6764898,
                31.2644793
              ],
              [
                48.6765989,
                31.2644827
              ],
              [
                48.6799458,
                31.2645861
              ],
              [
                48.6879969,
                31.2615335
              ],
              [
                48.6947275,
                31.2589815
              ],
              [
                48.7158931,
                31.2509521
              ],
              [
                48.7251027,
                31.2544686
              ],
              [
                48.729163,
                31.2560186
              ],
              [
                48.7326354,
                31.247003
              ],
              [
                48.7343828,
                31.2421903
              ],
              [
                48.7361869,
                31.237701
              ],
              [
                48.7381517,
                31.2336226
              ],
              [
                48.7393187,
                31.2307343
              ],
              [
                48.7409095,
                31.227664
              ],
              [
                48.7420806,
                31.2254658
              ],
              [
                48.7431946,
                31.2233094
              ],
              [
                48.7445221,
                31.2206538
              ],
              [
                48.745529,
                31.2183173
              ],
              [
                48.74691,
                31.2162084
              ],
              [
                48.7480775,
                31.2141904
              ],
              [
                48.7500232,
                31.2113833
              ],
              [
                48.7547837,
                31.1999506
              ],
              [
                48.7579307,
                31.1928912
              ],
              [
                48.761242,
                31.1857353
              ],
              [
                48.7649345,
                31.1754191
              ],
              [
                48.7761061,
                31.1493808
              ],
              [
                48.7833519,
                31.1327254
              ],
              [
                48.7948972,
                31.1084096
              ],
              [
                48.802948,
                31.0924636
              ],
              [
                48.8104953,
                31.0786563
              ],
              [
                48.8153038,
                31.0681516
              ],
              [
                48.8329696,
                31.0363853
              ],
              [
                48.8675157,
                30.9695209
              ],
              [
                48.8800619,
                30.942133
              ],
              [
                48.8869324,
                30.930227
              ],
              [
                48.9016112,
                30.8991117
              ],
              [
                48.9186335,
                30.8647514
              ],
              [
                48.9321707,
                30.8668323
              ],
              [
                48.9408416,
                30.8705033
              ],
              [
                48.9522077,
                30.8759631
              ],
              [
                48.9602221,
                30.8789157
              ],
              [
                48.9717722,
                30.8837377
              ],
              [
                48.9792442,
                30.8883647
              ],
              [
                48.9910927,
                30.8956952
              ],
              [
                48.9999021,
                30.9075492
              ],
              [
                49.0015105,
                30.9075041
              ],
              [
                49.0039596,
                30.907551
              ],
              [
                49.0065117,
                30.9077347
              ],
              [
                49.0099184,
                30.9081931
              ],
              [
                49.0130578,
                30.9085142
              ],
              [
                49.0157165,
                30.9088798
              ],
              [
                49.0177384,
                30.9090168
              ],
              [
                49.0208243,
                30.9094294
              ],
              [
                49.0248146,
                30.9097949
              ],
              [
                49.0284844,
                30.9100246
              ],
              [
                49.0308801,
                30.9102076
              ],
              [
                49.0339127,
                30.9103914
              ],
              [
                49.0371591,
                30.9105737
              ],
              [
                49.0408819,
                30.9108038
              ],
              [
                49.0443915,
                30.9112178
              ],
              [
                49.0478515,
                30.9117662
              ],
              [
                49.0523757,
                30.9124998
              ],
              [
                49.0560455,
                30.9130962
              ],
              [
                49.0601996,
                30.9140133
              ],
              [
                49.0646706,
                30.9152057
              ],
              [
                49.0693016,
                30.9163056
              ],
              [
                49.0719072,
                30.9165813
              ],
              [
                49.074356,
                30.9169019
              ],
              [
                49.0763779,
                30.9173605
              ],
              [
                49.0777625,
                30.9177284
              ],
              [
                49.0792543,
                30.9180483
              ],
              [
                49.0808486,
                30.9185094
              ],
              [
                49.0820732,
                30.9187825
              ],
              [
                49.0838815,
                30.9188747
              ],
              [
                49.0855331,
                30.9188743
              ],
              [
                49.087555,
                30.9191952
              ],
              [
                49.0891,
                30.9197007
              ],
              [
                49.0903779,
                30.9201119
              ],
              [
                49.0917092,
                30.9208916
              ],
              [
                49.0940514,
                30.9219952
              ],
              [
                49.0964509,
                30.9234152
              ],
              [
                49.0983161,
                30.9245184
              ],
              [
                49.0999144,
                30.9254824
              ],
              [
                49.1007118,
                30.925988
              ],
              [
                49.102951,
                30.9269049
              ],
              [
                49.1054535,
                30.9276858
              ],
              [
                49.1082192,
                30.9283736
              ],
              [
                49.110775,
                30.9290154
              ],
              [
                49.1135978,
                30.9296114
              ],
              [
                49.1179084,
                30.9302538
              ],
              [
                49.1214752,
                30.930759
              ],
              [
                49.1248285,
                30.9311257
              ],
              [
                49.1275979,
                30.9314004
              ],
              [
                49.1292456,
                30.9316768
              ],
              [
                49.1308975,
                30.9319962
              ],
              [
                49.1339301,
                30.9325948
              ],
              [
                49.1364862,
                30.9329158
              ],
              [
                49.1393625,
                30.933282
              ],
              [
                49.1415444,
                30.9336043
              ],
              [
                49.1435127,
                30.9338311
              ],
              [
                49.1454315,
                30.9343368
              ],
              [
                49.1474532,
                30.9347965
              ],
              [
                49.1503793,
                30.9350256
              ],
              [
                49.1535758,
                30.9353013
              ],
              [
                49.1570855,
                30.935392
              ],
              [
                49.1607589,
                30.9351624
              ],
              [
                49.1649588,
                30.9348861
              ],
              [
                49.168419,
                30.9346578
              ],
              [
                49.1716651,
                30.9346113
              ],
              [
                49.1762924,
                30.9344737
              ],
              [
                49.1813468,
                30.9344727
              ],
              [
                49.1822547,
                30.9351621
              ],
              [
                49.1846048,
                30.9380525
              ],
              [
                49.1866914,
                30.9404409
              ],
              [
                49.1888276,
                30.9431028
              ],
              [
                49.1908037,
                30.9455368
              ],
              [
                49.1932639,
                30.9482009
              ],
              [
                49.195774,
                30.9511385
              ],
              [
                49.1978073,
                30.9538011
              ],
              [
                49.1993064,
                30.9559127
              ],
              [
                49.2009088,
                30.9581181
              ],
              [
                49.2025146,
                30.9606889
              ],
              [
                49.2043343,
                30.9631229
              ],
              [
                49.2070618,
                30.9665663
              ],
              [
                49.2133178,
                30.9740503
              ],
              [
                49.2188796,
                30.9808457
              ],
              [
                49.2225724,
                30.9855763
              ],
              [
                49.225197,
                30.9887924
              ],
              [
                49.2270166,
                30.9913636
              ],
              [
                49.227764,
                30.992603
              ],
              [
                49.2293701,
                30.9946232
              ],
              [
                49.2305854,
                30.9963841
              ],
              [
                49.2315339,
                30.9977584
              ],
              [
                49.2325975,
                31.0000102
              ],
              [
                49.2330999,
                31.0013971
              ],
              [
                49.2337379,
                31.0031585
              ],
              [
                49.2350198,
                31.0060921
              ],
              [
                49.2363511,
                31.008749
              ],
              [
                49.2380599,
                31.0117741
              ],
              [
                49.2400857,
                31.0151667
              ],
              [
                49.2424851,
                31.0184222
              ],
              [
                49.2448844,
                31.021495
              ],
              [
                49.2473908,
                31.0245218
              ],
              [
                49.2500133,
                31.0276878
              ],
              [
                49.2522431,
                31.0306927
              ],
              [
                49.2549515,
                31.0343311
              ],
              [
                49.257065,
                31.0372871
              ],
              [
                49.2594489,
                31.040515
              ],
              [
                49.2607574,
                31.0428849
              ],
              [
                49.2620659,
                31.0452549
              ],
              [
                49.2630464,
                31.0471219
              ],
              [
                49.2634849,
                31.0480322
              ],
              [
                49.2644006,
                31.0488023
              ],
              [
                49.2663957,
                31.0505702
              ],
              [
                49.2680207,
                31.0528
              ],
              [
                49.2698022,
                31.0547973
              ],
              [
                49.2718009,
                31.0569757
              ],
              [
                49.2738532,
                31.0591096
              ],
              [
                49.2757988,
                31.061197
              ],
              [
                49.2773132,
                31.0630598
              ],
              [
                49.2785607,
                31.0647431
              ],
              [
                49.2804032,
                31.0671989
              ],
              [
                49.2829477,
                31.0705639
              ],
              [
                49.2839241,
                31.0717452
              ],
              [
                49.2848472,
                31.0731557
              ],
              [
                49.2857169,
                31.0744303
              ],
              [
                49.2872315,
                31.0761577
              ],
              [
                49.2883108,
                31.077338
              ],
              [
                49.2893411,
                31.0787928
              ],
              [
                49.2897302,
                31.0793685
              ],
              [
                49.2909697,
                31.0812028
              ],
              [
                49.2937392,
                31.085069
              ],
              [
                49.2955359,
                31.0880765
              ],
              [
                49.2970048,
                31.0902588
              ],
              [
                49.2984123,
                31.0921222
              ],
              [
                49.2993393,
                31.0936726
              ],
              [
                49.30064,
                31.0954466
              ],
              [
                49.3019448,
                31.0973086
              ],
              [
                49.3032455,
                31.0990376
              ],
              [
                49.304821,
                31.101176
              ],
              [
                49.3071977,
                31.1037174
              ],
              [
                49.3089867,
                31.1058519
              ],
              [
                49.3111718,
                31.1084067
              ],
              [
                49.3112028,
                31.108443
              ],
              [
                49.3133698,
                31.1108958
              ],
              [
                49.31147,
                31.1124677
              ],
              [
                49.3089904,
                31.1143657
              ],
              [
                49.3063582,
                31.1168616
              ],
              [
                49.3038864,
                31.1194452
              ],
              [
                49.299408,
                31.1235585
              ],
              [
                49.2962419,
                31.1262884
              ],
              [
                49.2929269,
                31.1297041
              ],
              [
                49.288868,
                31.1333083
              ],
              [
                49.2814903,
                31.1399647
              ],
              [
                49.2783889,
                31.1436986
              ],
              [
                49.2753373,
                31.1469775
              ],
              [
                49.2721252,
                31.1500242
              ],
              [
                49.2686959,
                31.1529844
              ],
              [
                49.2645227,
                31.1562254
              ],
              [
                49.2609369,
                31.1594133
              ],
              [
                49.2588732,
                31.1609438
              ],
              [
                49.2571868,
                31.1623756
              ],
              [
                49.2553406,
                31.1640872
              ],
              [
                49.2543281,
                31.1652198
              ],
              [
                49.2538147,
                31.165794
              ],
              [
                49.2532385,
                31.1667131
              ],
              [
                49.2527121,
                31.1674051
              ],
              [
                49.2523003,
                31.1684617
              ],
              [
                49.2518882,
                31.1696559
              ],
              [
                49.2515832,
                31.1708019
              ],
              [
                49.2516061,
                31.1769817
              ],
              [
                49.2514686,
                31.1788607
              ],
              [
                49.251335,
                31.1811479
              ],
              [
                49.2511443,
                31.1828909
              ],
              [
                49.2508468,
                31.1846775
              ],
              [
                49.2509271,
                31.1867828
              ],
              [
                49.2510031,
                31.1886579
              ],
              [
                49.2513581,
                31.1913578
              ],
              [
                49.251381,
                31.1933224
              ],
              [
                49.2514572,
                31.1950622
              ],
              [
                49.25169,
                31.196617
              ],
              [
                49.252243,
                31.1983971
              ],
              [
                49.253128,
                31.2007231
              ],
              [
                49.2546653,
                31.2043252
              ],
              [
                49.2571297,
                31.2092029
              ],
              [
                49.2600211,
                31.2144404
              ],
              [
                49.2664491,
                31.2246826
              ],
              [
                49.2701416,
                31.2298653
              ],
              [
                49.2718353,
                31.2327342
              ],
              [
                49.2727715,
                31.2342351
              ],
              [
                49.2730865,
                31.2347401
              ],
              [
                49.2759628,
                31.2385112
              ],
              [
                49.2768821,
                31.239892
              ],
              [
                49.2791747,
                31.2433354
              ],
              [
                49.2802019,
                31.2451728
              ],
              [
                49.2828436,
                31.2498976
              ],
              [
                49.2829519,
                31.250093
              ],
              [
                49.282388,
                31.2518417
              ],
              [
                49.2823487,
                31.2519635
              ],
              [
                49.2824478,
                31.2546644
              ],
              [
                49.2823333,
                31.2578698
              ],
              [
                49.2824365,
                31.2603429
              ],
              [
                49.2826957,
                31.2621754
              ],
              [
                49.2830658,
                31.2635944
              ],
              [
                49.2835961,
                31.2647404
              ],
              [
                49.2843895,
                31.2661605
              ],
              [
                49.2861937,
                31.2683135
              ],
              [
                49.2887916,
                31.2722114
              ],
              [
                49.2905428,
                31.2748215
              ],
              [
                49.2926101,
                31.2780311
              ],
              [
                49.2945749,
                31.2805515
              ],
              [
                49.2960091,
                31.2820207
              ],
              [
                49.296915,
                31.2827233
              ],
              [
                49.2976035,
                31.2832574
              ],
              [
                49.2992515,
                31.2848196
              ],
              [
                49.3002052,
                31.2863319
              ],
              [
                49.3008422,
                31.2875244
              ],
              [
                49.3012657,
                31.2884388
              ],
              [
                49.3013155,
                31.2895829
              ],
              [
                49.3014182,
                31.2909577
              ],
              [
                49.3013114,
                31.292332
              ],
              [
                49.2993242,
                31.29663
              ],
              [
                49.2842617,
                31.3016161
              ],
              [
                49.2849845,
                31.3054949
              ],
              [
                49.2754645,
                31.3133643
              ],
              [
                49.2704603,
                31.3169885
              ],
              [
                49.2683849,
                31.330206
              ],
              [
                49.2716216,
                31.336264
              ],
              [
                49.2739697,
                31.3389781
              ],
              [
                49.2831782,
                31.3496598
              ],
              [
                49.2966193,
                31.3623506
              ],
              [
                49.3064088,
                31.372109
              ],
              [
                49.2774848,
                31.3946808
              ],
              [
                49.2672213,
                31.4019911
              ],
              [
                49.2598686,
                31.4074308
              ],
              [
                49.2451629,
                31.4179572
              ],
              [
                49.216718,
                31.439082
              ],
              [
                49.2048818,
                31.4323742
              ],
              [
                49.1774845,
                31.4174551
              ],
              [
                49.1578349,
                31.406955
              ],
              [
                49.1431769,
                31.4034822
              ],
              [
                49.1322023,
                31.3982867
              ],
              [
                49.1236037,
                31.3941309
              ],
              [
                49.1187304,
                31.392399
              ],
              [
                49.1062965,
                31.3850036
              ],
              [
                49.100444,
                31.380765
              ],
              [
                49.0893535,
                31.3729519
              ],
              [
                49.0764618,
                31.3611599
              ],
              [
                49.0642119,
                31.3499326
              ],
              [
                49.056121,
                31.3497497
              ],
              [
                49.0387213,
                31.3489777
              ],
              [
                49.000532,
                31.3467482
              ],
              [
                48.985302,
                31.3480596
              ],
              [
                48.9528504,
                31.3477659
              ],
              [
                48.9332752,
                31.3469917
              ],
              [
                48.9193516,
                31.3465913
              ],
              [
                48.8894101,
                31.345947
              ],
              [
                48.8439272,
                31.343155
              ],
              [
                48.8198089,
                31.3445477
              ],
              [
                48.8002687,
                31.3463027
              ],
              [
                48.8021929,
                31.3505348
              ],
              [
                48.8018909,
                31.3521221
              ],
              [
                48.8013805,
                31.3537989
              ],
              [
                48.8004601,
                31.3562102
              ],
              [
                48.7987465,
                31.358945
              ],
              [
                48.7831288,
                31.3809989
              ],
              [
                48.7815201,
                31.3834858
              ],
              [
                48.7800662,
                31.3855412
              ],
              [
                48.7792743,
                31.38673
              ],
              [
                48.7781373,
                31.3884354
              ],
              [
                48.7751312,
                31.3925586
              ],
              [
                48.770827,
                31.3990213
              ],
              [
                48.7700521,
                31.4000088
              ],
              [
                48.7689054,
                31.4011727
              ],
              [
                48.768105,
                31.4018947
              ],
              [
                48.7671146,
                31.4027574
              ],
              [
                48.765769,
                31.4037318
              ],
              [
                48.764283,
                31.4041799
              ],
              [
                48.7627659,
                31.4044414
              ],
              [
                48.7612996,
                31.4045799
              ],
              [
                48.7589942,
                31.4045994
              ],
              [
                48.7570768,
                31.4044379
              ],
              [
                48.7560781,
                31.404524
              ],
              [
                48.7555364,
                31.4045106
              ],
              [
                48.7550887,
                31.4053591
              ],
              [
                48.7547111,
                31.4079275
              ],
              [
                48.7541733,
                31.4109531
              ],
              [
                48.7542709,
                31.4113518
              ],
              [
                48.754757,
                31.4133377
              ],
              [
                48.7553444,
                31.416135
              ],
              [
                48.7556609,
                31.4189344
              ],
              [
                48.7559241,
                31.4206752
              ],
              [
                48.7568816,
                31.4235196
              ],
              [
                48.7574652,
                31.4265468
              ],
              [
                48.7576789,
                31.4291143
              ],
              [
                48.7578888,
                31.4321418
              ],
              [
                48.7578663,
                31.4331679
              ],
              [
                48.7578315,
                31.4347564
              ],
              [
                48.7580414,
                31.4379665
              ],
              [
                48.7584153,
                31.4392042
              ],
              [
                48.7588919,
                31.4404888
              ],
              [
                48.7599602,
                31.4415447
              ],
              [
                48.7610283,
                31.4424157
              ],
              [
                48.763378,
                31.4432437
              ],
              [
                48.7662621,
                31.4441171
              ],
              [
                48.7688292,
                31.4448068
              ],
              [
                48.7702179,
                31.4450835
              ],
              [
                48.7715531,
                31.4449015
              ],
              [
                48.7727852,
                31.4443502
              ],
              [
                48.7733725,
                31.4433413
              ],
              [
                48.7738533,
                31.4420576
              ],
              [
                48.7739638,
                31.4398587
              ],
              [
                48.774124,
                31.4384365
              ],
              [
                48.7741279,
                31.437061
              ],
              [
                48.7742392,
                31.4365358
              ],
              [
                48.7744484,
                31.4355491
              ],
              [
                48.7747727,
                31.4340372
              ],
              [
                48.7757874,
                31.432844
              ],
              [
                48.7763749,
                31.4317425
              ],
              [
                48.7776071,
                31.4306906
              ],
              [
                48.7784615,
                31.4298643
              ],
              [
                48.7793159,
                31.4290403
              ],
              [
                48.7809977,
                31.4283438
              ],
              [
                48.7810822,
                31.4283088
              ],
              [
                48.7824174,
                31.4278043
              ],
              [
                48.7843933,
                31.4276243
              ],
              [
                48.7873877,
                31.4278091
              ],
              [
                48.7909662,
                31.4281797
              ],
              [
                48.7950248,
                31.4294673
              ],
              [
                48.7983894,
                31.430709
              ],
              [
                48.8011704,
                31.4319474
              ],
              [
                48.8048552,
                31.4337852
              ],
              [
                48.8068312,
                31.4350705
              ],
              [
                48.8072569,
                31.4353044
              ],
              [
                48.8100891,
                31.4368603
              ],
              [
                48.8117447,
                31.4382844
              ],
              [
                48.8123855,
                31.439752
              ],
              [
                48.8125458,
                31.4424583
              ],
              [
                48.8115271,
                31.4448424
              ],
              [
                48.8107865,
                31.4468291
              ],
              [
                48.8106726,
                31.4471345
              ],
              [
                48.8088532,
                31.4493358
              ],
              [
                48.8070336,
                31.4512596
              ],
              [
                48.8043595,
                31.4534574
              ],
              [
                48.8021697,
                31.4552891
              ],
              [
                48.7994424,
                31.4571679
              ],
              [
                48.7958602,
                31.4591379
              ],
              [
                48.7930795,
                31.4608308
              ],
              [
                48.7909393,
                31.4626181
              ],
              [
                48.7889594,
                31.4644509
              ],
              [
                48.787639,
                31.4660706
              ],
              [
                48.7873534,
                31.466421
              ],
              [
                48.7860184,
                31.4679786
              ],
              [
                48.7852135,
                31.4695385
              ],
              [
                48.7849465,
                31.4703615
              ],
              [
                48.7848095,
                31.4707403
              ],
              [
                48.7840347,
                31.4728824
              ],
              [
                48.7833901,
                31.4752682
              ],
              [
                48.7831727,
                31.4782949
              ],
              [
                48.7830122,
                31.479715
              ],
              [
                48.7832795,
                31.4813679
              ],
              [
                48.7837561,
                31.4833852
              ],
              [
                48.7847709,
                31.4852653
              ],
              [
                48.7859458,
                31.4872857
              ],
              [
                48.7877083,
                31.4896252
              ],
              [
                48.7894707,
                31.4917347
              ],
              [
                48.7916106,
                31.4940761
              ],
              [
                48.7939072,
                31.4959128
              ],
              [
                48.7967376,
                31.4980248
              ],
              [
                48.7977236,
                31.4986997
              ],
              [
                48.7987384,
                31.4993942
              ],
              [
                48.7989955,
                31.4994707
              ],
              [
                48.7993582,
                31.4996438
              ],
              [
                48.7935465,
                31.5038711
              ],
              [
                48.7876109,
                31.5056621
              ],
              [
                48.7821976,
                31.5087241
              ],
              [
                48.7751083,
                31.5125458
              ],
              [
                48.7702728,
                31.5145128
              ],
              [
                48.7639642,
                31.516454
              ],
              [
                48.7572721,
                31.5190192
              ],
              [
                48.7526087,
                31.5214619
              ],
              [
                48.7488657,
                31.5239207
              ],
              [
                48.7447732,
                31.5255843
              ],
              [
                48.7416126,
                31.5267908
              ],
              [
                48.7366144,
                31.5278069
              ],
              [
                48.7292148,
                31.5290958
              ],
              [
                48.7227471,
                31.5299275
              ],
              [
                48.7195304,
                31.530513
              ],
              [
                48.71551,
                31.5312446
              ],
              [
                48.7158851,
                31.5328031
              ],
              [
                48.7162551,
                31.5356485
              ],
              [
                48.7170563,
                31.5419357
              ],
              [
                48.7178535,
                31.5450119
              ],
              [
                48.7196161,
                31.5519453
              ],
              [
                48.7206842,
                31.5554323
              ],
              [
                48.720791,
                31.5563068
              ],
              [
                48.7207872,
                31.5583699
              ],
              [
                48.7204665,
                31.5607542
              ],
              [
                48.7200356,
                31.564149
              ],
              [
                48.7196242,
                31.5689694
              ],
              [
                48.7194443,
                31.5710765
              ],
              [
                48.7185289,
                31.5776802
              ],
              [
                48.718155,
                31.5796059
              ],
              [
                48.7179375,
                31.5835975
              ],
              [
                48.7175596,
                31.5897914
              ],
              [
                48.7172395,
                31.590983
              ],
              [
                48.7168657,
                31.5917158
              ],
              [
                48.7155267,
                31.5923548
              ],
              [
                48.7119942,
                31.5935813
              ],
              [
                48.7084084,
                31.593756
              ],
              [
                48.7055389,
                31.5944822
              ],
              [
                48.7028425,
                31.5951645
              ],
              [
                48.6965829,
                31.5969818
              ],
              [
                48.6931036,
                31.597981
              ],
              [
                48.6929434,
                31.598668
              ],
              [
                48.6926416,
                31.6009325
              ],
              [
                48.6926194,
                31.6010996
              ],
              [
                48.6920815,
                31.6058699
              ],
              [
                48.6914862,
                31.6107317
              ],
              [
                48.6907312,
                31.6167383
              ],
              [
                48.6908876,
                31.6213273
              ],
              [
                48.6904029,
                31.6269712
              ],
              [
                48.6906166,
                31.6279333
              ],
              [
                48.6910439,
                31.6280267
              ],
              [
                48.6918983,
                31.6280287
              ],
              [
                48.693451,
                31.6277118
              ],
              [
                48.6958083,
                31.6273981
              ],
              [
                48.697895,
                31.6270817
              ],
              [
                48.6998749,
                31.6270859
              ],
              [
                48.7029267,
                31.6271408
              ],
              [
                48.7080116,
                31.6271556
              ],
              [
                48.7111169,
                31.627394
              ],
              [
                48.7163581,
                31.6280493
              ],
              [
                48.7260171,
                31.6293184
              ],
              [
                48.7270621,
                31.6294557
              ],
              [
                48.7358399,
                31.6303513
              ],
              [
                48.7432823,
                31.6304177
              ],
              [
                48.7468695,
                31.6303198
              ],
              [
                48.7499518,
                31.6302356
              ],
              [
                48.7536502,
                31.6292787
              ],
              [
                48.7536888,
                31.6292687
              ],
              [
                48.7534141,
                31.6299539
              ],
              [
                48.7533493,
                31.6308682
              ],
              [
                48.7531702,
                31.6325629
              ],
              [
                48.7531509,
                31.6344881
              ],
              [
                48.7533949,
                31.6363662
              ],
              [
                48.7535401,
                31.6377419
              ],
              [
                48.7534714,
                31.6390237
              ],
              [
                48.7531852,
                31.640854
              ],
              [
                48.7529527,
                31.6425478
              ],
              [
                48.752639,
                31.6431624
              ],
              [
                48.7523002,
                31.6438261
              ],
              [
                48.7519187,
                31.6444168
              ],
              [
                48.7511636,
                31.645098
              ],
              [
                48.7498094,
                31.6454845
              ],
              [
                48.7488976,
                31.6458044
              ],
              [
                48.7479362,
                31.6459836
              ],
              [
                48.7463301,
                31.6456125
              ],
              [
                48.745472,
                31.645196
              ],
              [
                48.7449911,
                31.6443713
              ],
              [
                48.7444574,
                31.6432683
              ],
              [
                48.7441495,
                31.6425983
              ],
              [
                48.7438661,
                31.6419816
              ],
              [
                48.7434386,
                31.6408331
              ],
              [
                48.7422067,
                31.639499
              ],
              [
                48.7412454,
                31.6385328
              ],
              [
                48.7401198,
                31.6378882
              ],
              [
                48.7390517,
                31.6375627
              ],
              [
                48.737873,
                31.6373321
              ],
              [
                48.7366409,
                31.6372358
              ],
              [
                48.7346077,
                31.6375989
              ],
              [
                48.7323608,
                31.6383256
              ],
              [
                48.730751,
                31.6391019
              ],
              [
                48.729145,
                31.6401985
              ],
              [
                48.7287843,
                31.6406315
              ],
              [
                48.7280771,
                31.6414805
              ],
              [
                48.7269515,
                31.6426239
              ],
              [
                48.7257194,
                31.6441352
              ],
              [
                48.7248612,
                31.6456915
              ],
              [
                48.7242166,
                31.6467916
              ],
              [
                48.7238425,
                31.6488097
              ],
              [
                48.7240029,
                31.6506908
              ],
              [
                48.7243233,
                31.6516999
              ],
              [
                48.7248573,
                31.6533531
              ],
              [
                48.7251243,
                31.6554187
              ],
              [
                48.7251777,
                31.6567951
              ],
              [
                48.7251741,
                31.6581727
              ],
              [
                48.7248536,
                31.6590892
              ],
              [
                48.7240487,
                31.6598662
              ],
              [
                48.7233009,
                31.6607368
              ],
              [
                48.7222825,
                31.6615123
              ],
              [
                48.7205161,
                31.6624255
              ],
              [
                48.7191772,
                31.6630193
              ],
              [
                48.7176248,
                31.6635192
              ],
              [
                48.716015,
                31.6637902
              ],
              [
                48.7148934,
                31.6637859
              ],
              [
                48.7133406,
                31.6634627
              ],
              [
                48.7120551,
                31.6630902
              ],
              [
                48.7113039,
                31.6624003
              ],
              [
                48.7102891,
                31.6612502
              ],
              [
                48.7086295,
                31.6590445
              ],
              [
                48.7059556,
                31.655824
              ],
              [
                48.7041895,
                31.654029
              ],
              [
                48.7033882,
                31.653248
              ],
              [
                48.7026901,
                31.6529265
              ],
              [
                48.7017824,
                31.6528313
              ],
              [
                48.7009772,
                31.652828
              ],
              [
                48.6999626,
                31.6529631
              ],
              [
                48.6989974,
                31.6532365
              ],
              [
                48.6971246,
                31.6540099
              ],
              [
                48.6961498,
                31.6545524
              ],
              [
                48.6958922,
                31.6546957
              ],
              [
                48.6946067,
                31.6557029
              ],
              [
                48.6939086,
                31.6569394
              ],
              [
                48.6935311,
                31.6577623
              ],
              [
                48.6935309,
                31.6594601
              ],
              [
                48.6936911,
                31.6607911
              ],
              [
                48.6942253,
                31.6618018
              ],
              [
                48.6958848,
                31.6632298
              ],
              [
                48.6970427,
                31.6642254
              ],
              [
                48.6979712,
                31.6650239
              ],
              [
                48.6995202,
                31.6670473
              ],
              [
                48.7010191,
                31.6688871
              ],
              [
                48.7023583,
                31.6710465
              ],
              [
                48.702942,
                31.6732509
              ],
              [
                48.7026213,
                31.6751774
              ],
              [
                48.7017632,
                31.6767809
              ],
              [
                48.7012254,
                31.6782481
              ],
              [
                48.7000466,
                31.6797127
              ],
              [
                48.6984404,
                31.6806262
              ],
              [
                48.6961899,
                31.6813522
              ],
              [
                48.6924402,
                31.6821231
              ],
              [
                48.6879921,
                31.6823875
              ],
              [
                48.6831742,
                31.6825571
              ],
              [
                48.6802293,
                31.6826862
              ],
              [
                48.6801068,
                31.6827306
              ],
              [
                48.6794777,
                31.6829589
              ],
              [
                48.6792106,
                31.6835988
              ],
              [
                48.6791534,
                31.6844253
              ],
              [
                48.6792601,
                31.6852502
              ],
              [
                48.679901,
                31.686263
              ],
              [
                48.6808662,
                31.6875049
              ],
              [
                48.6831664,
                31.6887958
              ],
              [
                48.6853065,
                31.6899959
              ],
              [
                48.691681,
                31.69171
              ],
              [
                48.6983224,
                31.6932416
              ],
              [
                48.7030097,
                31.6946937
              ],
              [
                48.7034074,
                31.6948169
              ],
              [
                48.7038092,
                31.6950338
              ],
              [
                48.7061387,
                31.6962911
              ],
              [
                48.7067668,
                31.6966452
              ],
              [
                48.707531,
                31.697076
              ],
              [
                48.7081757,
                31.6979489
              ],
              [
                48.7083894,
                31.6992334
              ],
              [
                48.7082787,
                31.7003814
              ],
              [
                48.7079048,
                31.7012968
              ],
              [
                48.7071534,
                31.702077
              ],
              [
                48.7061347,
                31.7032176
              ],
              [
                48.704689,
                31.7042265
              ],
              [
                48.702652,
                31.7049993
              ],
              [
                48.6996521,
                31.7056323
              ],
              [
                48.6996498,
                31.7056328
              ],
              [
                48.6964875,
                31.7068631
              ],
              [
                48.6941298,
                31.7080944
              ],
              [
                48.6932181,
                31.7092865
              ],
              [
                48.6930046,
                31.7101574
              ],
              [
                48.6927338,
                31.7116249
              ],
              [
                48.6925735,
                31.7129072
              ],
              [
                48.6931076,
                31.7147454
              ],
              [
                48.6941224,
                31.7170884
              ],
              [
                48.695835,
                31.719205
              ],
              [
                48.6965827,
                31.7216356
              ],
              [
                48.6977616,
                31.7243919
              ],
              [
                48.6985053,
                31.7280648
              ],
              [
                48.6983987,
                31.7298554
              ],
              [
                48.6985055,
                31.7308178
              ],
              [
                48.6979143,
                31.7320563
              ],
              [
                48.6975366,
                31.7332467
              ],
              [
                48.6970557,
                31.7343
              ],
              [
                48.6969489,
                31.7348054
              ],
              [
                48.6962508,
                31.7352166
              ],
              [
                48.6957665,
                31.7355822
              ],
              [
                48.6948547,
                31.7355814
              ],
              [
                48.6936759,
                31.7355759
              ],
              [
                48.6922302,
                31.7350672
              ],
              [
                48.6912653,
                31.7347882
              ],
              [
                48.6892319,
                31.7346927
              ],
              [
                48.6874084,
                31.7346889
              ],
              [
                48.685211,
                31.7350481
              ],
              [
                48.683014,
                31.735777
              ],
              [
                48.680439,
                31.736641
              ],
              [
                48.6790999,
                31.7375095
              ],
              [
                48.6777039,
                31.7385145
              ],
              [
                48.6772727,
                31.739431
              ],
              [
                48.6772727,
                31.7404862
              ],
              [
                48.6774862,
                31.7413131
              ],
              [
                48.6780739,
                31.7422776
              ],
              [
                48.6793594,
                31.7436583
              ],
              [
                48.6806983,
                31.7449453
              ],
              [
                48.6828386,
                31.7467407
              ],
              [
                48.6845551,
                31.7483525
              ],
              [
                48.6860192,
                31.7500341
              ],
              [
                48.68647,
                31.7504459
              ],
              [
                48.686905,
                31.7535675
              ],
              [
                48.6871758,
                31.7556332
              ],
              [
                48.6872292,
                31.7566421
              ],
              [
                48.6870727,
                31.7599897
              ],
              [
                48.6865998,
                31.7645312
              ],
              [
                48.6861229,
                31.7675618
              ],
              [
                48.6855042,
                31.7689058
              ],
              [
                48.685215,
                31.769534
              ],
              [
                48.684574,
                31.7707263
              ],
              [
                48.6838265,
                31.7710938
              ],
              [
                48.682167,
                31.7713229
              ],
              [
                48.6808817,
                31.7710447
              ],
              [
                48.6790581,
                31.7700374
              ],
              [
                48.6771316,
                31.769026
              ],
              [
                48.6752013,
                31.7672366
              ],
              [
                48.6733779,
                31.7651718
              ],
              [
                48.670967,
                31.7624649
              ],
              [
                48.6674805,
                31.7589311
              ],
              [
                48.6633034,
                31.7557183
              ],
              [
                48.6638539,
                31.7541179
              ],
              [
                48.6562254,
                31.753044
              ],
              [
                48.654738,
                31.7528294
              ],
              [
                48.6519778,
                31.7499383
              ],
              [
                48.6355228,
                31.7470796
              ],
              [
                48.6306624,
                31.745648
              ],
              [
                48.61711,
                31.7414304
              ],
              [
                48.6070137,
                31.7368106
              ],
              [
                48.6051727,
                31.7358619
              ],
              [
                48.5909454,
                31.7409112
              ],
              [
                48.5883026,
                31.7409296
              ],
              [
                48.5834235,
                31.7409611
              ],
              [
                48.5761909,
                31.7409882
              ],
              [
                48.5684737,
                31.7408299
              ],
              [
                48.5622558,
                31.74095
              ],
              [
                48.5540543,
                31.7409258
              ],
              [
                48.5471382,
                31.7411828
              ],
              [
                48.5394133,
                31.7415429
              ],
              [
                48.5384663,
                31.741587
              ],
              [
                48.5350265,
                31.7417471
              ],
              [
                48.5305747,
                31.7418706
              ],
              [
                48.5215723,
                31.7420316
              ],
              [
                48.5202331,
                31.7420281
              ],
              [
                48.519268,
                31.7417478
              ],
              [
                48.5184631,
                31.7414255
              ],
              [
                48.5178756,
                31.7410105
              ],
              [
                48.5156326,
                31.7391247
              ],
              [
                48.513813,
                31.7372833
              ],
              [
                48.5120505,
                31.7360855
              ],
              [
                48.509327,
                31.7330044
              ],
              [
                48.5069235,
                31.7300602
              ],
              [
                48.5052185,
                31.7271184
              ],
              [
                48.5035132,
                31.7236738
              ],
              [
                48.5025063,
                31.7205991
              ],
              [
                48.5011751,
                31.7176105
              ],
              [
                48.4999078,
                31.7149793
              ],
              [
                48.4993292,
                31.7092353
              ],
              [
                48.5086411,
                31.7043407
              ],
              [
                48.5158479,
                31.6984196
              ],
              [
                48.5153033,
                31.688981
              ],
              [
                48.5234047,
                31.6856016
              ],
              [
                48.5272727,
                31.6912095
              ],
              [
                48.5321161,
                31.6909745
              ],
              [
                48.5355493,
                31.6824925
              ],
              [
                48.5421269,
                31.6807821
              ],
              [
                48.5454045,
                31.6780926
              ],
              [
                48.5456608,
                31.6727811
              ],
              [
                48.5443902,
                31.6697238
              ],
              [
                48.5452131,
                31.6670958
              ],
              [
                48.5482905,
                31.6701012
              ],
              [
                48.5539112,
                31.6752832
              ],
              [
                48.5590325,
                31.6758589
              ],
              [
                48.5617722,
                31.6732933
              ],
              [
                48.5663328,
                31.6692028
              ],
              [
                48.5692188,
                31.6656653
              ],
              [
                48.5772381,
                31.6631016
              ],
              [
                48.583211,
                31.6619119
              ],
              [
                48.5821486,
                31.6572215
              ],
              [
                48.5798524,
                31.6533569
              ],
              [
                48.5781444,
                31.6501313
              ],
              [
                48.5768158,
                31.6459755
              ],
              [
                48.5753223,
                31.6399464
              ],
              [
                48.582681,
                31.6334573
              ],
              [
                48.5892534,
                31.6239669
              ],
              [
                48.5880485,
                31.6195522
              ],
              [
                48.5817239,
                31.613508
              ],
              [
                48.5728258,
                31.6149814
              ],
              [
                48.56779,
                31.612937
              ],
              [
                48.5699144,
                31.5997961
              ],
              [
                48.5678475,
                31.597226
              ],
              [
                48.5608061,
                31.5997907
              ],
              [
                48.5534515,
                31.5983887
              ],
              [
                48.5468719,
                31.5956567
              ],
              [
                48.5430118,
                31.5930125
              ],
              [
                48.5448578,
                31.582038
              ],
              [
                48.5425435,
                31.5804315
              ],
              [
                48.5364537,
                31.5841656
              ],
              [
                48.5329386,
                31.5846234
              ],
              [
                48.529115,
                31.5814291
              ],
              [
                48.523607,
                31.5815971
              ],
              [
                48.5160063,
                31.5834839
              ],
              [
                48.5103145,
                31.5832584
              ],
              [
                48.5112985,
                31.5770715
              ],
              [
                48.5104193,
                31.5708926
              ],
              [
                48.5072676,
                31.5694666
              ],
              [
                48.5086981,
                31.5632921
              ],
              [
                48.5107193,
                31.5546628
              ],
              [
                48.5129655,
                31.5453007
              ],
              [
                48.5195699,
                31.5274156
              ],
              [
                48.526001,
                31.5085152
              ],
              [
                48.5279885,
                31.5054444
              ],
              [
                48.530094,
                31.5024594
              ],
              [
                48.5319662,
                31.5001484
              ],
              [
                48.5323104,
                31.4995418
              ],
              [
                48.5344391,
                31.4954635
              ],
              [
                48.536518,
                31.4920742
              ],
              [
                48.5377387,
                31.4887292
              ],
              [
                48.5389632,
                31.486807
              ],
              [
                48.5412559,
                31.48369
              ],
              [
                48.5432244,
                31.4804382
              ],
              [
                48.5461579,
                31.4765443
              ],
              [
                48.5481795,
                31.472971
              ],
              [
                48.5497247,
                31.4703604
              ],
              [
                48.5513688,
                31.466649
              ],
              [
                48.5545579,
                31.4599144
              ],
              [
                48.5555153,
                31.4583115
              ],
              [
                48.5567399,
                31.4561118
              ],
              [
                48.5589219,
                31.4521265
              ],
              [
                48.5598792,
                31.4505213
              ],
              [
                48.5606193,
                31.4479561
              ],
              [
                48.5615157,
                31.4433284
              ],
              [
                48.5622558,
                31.4406729
              ],
              [
                48.5627701,
                31.4390661
              ],
              [
                48.5644263,
                31.4338915
              ],
              [
                48.5662844,
                31.4293565
              ],
              [
                48.569683,
                31.4220729
              ],
              [
                48.5722887,
                31.4174911
              ],
              [
                48.5742035,
                31.4147428
              ],
              [
                48.5783911,
                31.4098323
              ],
              [
                48.5806503,
                31.4071828
              ],
              [
                48.5874672,
                31.3997151
              ],
              [
                48.5907669,
                31.3962801
              ],
              [
                48.5939102,
                31.3929796
              ],
              [
                48.5966225,
                31.3894071
              ],
              [
                48.5994414,
                31.385009
              ],
              [
                48.6017837,
                31.3820315
              ],
              [
                48.6030579,
                31.3796044
              ],
              [
                48.6041719,
                31.378092
              ],
              [
                48.6059305,
                31.3767178
              ],
              [
                48.6061198,
                31.3765941
              ],
              [
                48.6089332,
                31.3668487
              ],
              [
                48.6112916,
                31.3586776
              ],
              [
                48.6086464,
                31.3584846
              ],
              [
                48.6043167,
                31.3577522
              ],
              [
                48.6009483,
                31.357112
              ],
              [
                48.5976866,
                31.3562843
              ],
              [
                48.5933035,
                31.3548199
              ],
              [
                48.5904692,
                31.3535829
              ],
              [
                48.5873643,
                31.3520252
              ],
              [
                48.583458,
                31.3496427
              ],
              [
                48.5812072,
                31.3479949
              ],
              [
                48.5786399,
                31.346526
              ],
              [
                48.5758019,
                31.3447858
              ],
              [
                48.5721131,
                31.3430453
              ],
              [
                48.5659637,
                31.340665
              ],
              [
                48.5631827,
                31.3397463
              ],
              [
                48.5599214,
                31.3391049
              ],
              [
                48.5579985,
                31.3387842
              ],
              [
                48.5570375,
                31.3388313
              ],
              [
                48.5557557,
                31.3388767
              ],
              [
                48.553196,
                31.339563
              ],
              [
                48.546583,
                31.3457684
              ],
              [
                48.5300168,
                31.3388205
              ],
              [
                48.5262561,
                31.337264
              ],
              [
                48.5150041,
                31.3401671
              ],
              [
                48.4908466,
                31.3465326
              ],
              [
                48.4783439,
                31.3501424
              ],
              [
                48.4760476,
                31.3412304
              ],
              [
                48.4694861,
                31.3280483
              ],
              [
                48.4605447,
                31.3157762
              ],
              [
                48.4490928,
                31.303488
              ],
              [
                48.4325104,
                31.2922321
              ],
              [
                48.4218806,
                31.2877626
              ],
              [
                48.411703,
                31.2842467
              ],
              [
                48.3946247,
                31.2803891
              ],
              [
                48.3869304,
                31.2836881
              ],
              [
                48.3685055,
                31.291695
              ],
              [
                48.3584967,
                31.2958699
              ],
              [
                48.3499212,
                31.2995769
              ],
              [
                48.3304415,
                31.3079948
              ],
              [
                48.3161049,
                31.3139396
              ],
              [
                48.2908059,
                31.3246871
              ],
              [
                48.280675,
                31.3289218
              ],
              [
                48.2626418,
                31.2993221
              ],
              [
                48.245388,
                31.2720379
              ],
              [
                48.2295952,
                31.2453538
              ],
              [
                48.1992119,
                31.1961669
              ],
              [
                48.1974927,
                31.1929709
              ],
              [
                48.1749116,
                31.1557681
              ],
              [
                48.1488189,
                31.1130067
              ],
              [
                48.1234131,
                31.0704683
              ],
              [
                48.1113396,
                31.0548484
              ],
              [
                48.0934867,
                31.0320148
              ],
              [
                48.0845602,
                31.0200687
              ],
              [
                48.0797501,
                31.018244
              ],
              [
                48.0714244,
                31.0151387
              ],
              [
                48.0575733,
                31.0113327
              ],
              [
                48.0518322,
                31.0104347
              ],
              [
                48.0395108,
                31.0079027
              ],
              [
                48.0350247,
                31.007351
              ],
              [
                48.0307025,
                31.0057707
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554900,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ایذه",
          "name:ar": "مقاطعة إيذه",
          "name:en": "Izeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q6637444",
          "wikipedia": "en:Izeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.5572816,
                32.0147709
              ],
              [
                49.5574186,
                32.0143355
              ],
              [
                49.5575233,
                32.0140029
              ],
              [
                49.5583571,
                32.0113531
              ],
              [
                49.5585672,
                32.0093642
              ],
              [
                49.558941,
                32.006642
              ],
              [
                49.5591544,
                32.004608
              ],
              [
                49.5592538,
                32.0017473
              ],
              [
                49.5593043,
                32.0009162
              ],
              [
                49.5593606,
                31.9999896
              ],
              [
                49.558567,
                31.9948794
              ],
              [
                49.5583,
                31.9933564
              ],
              [
                49.5577621,
                31.99013
              ],
              [
                49.5575486,
                31.9880077
              ],
              [
                49.5572852,
                31.9840424
              ],
              [
                49.5573999,
                31.980219
              ],
              [
                49.5572433,
                31.9757475
              ],
              [
                49.5571977,
                31.9691101
              ],
              [
                49.5570985,
                31.9643145
              ],
              [
                49.5565642,
                31.9586458
              ],
              [
                49.5563546,
                31.9560184
              ],
              [
                49.5561943,
                31.9537592
              ],
              [
                49.5560876,
                31.9521455
              ],
              [
                49.5553894,
                31.9505319
              ],
              [
                49.5545806,
                31.9483645
              ],
              [
                49.5541001,
                31.9456912
              ],
              [
                49.5536688,
                31.9436161
              ],
              [
                49.5538331,
                31.9420957
              ],
              [
                49.5538368,
                31.9398338
              ],
              [
                49.5540582,
                31.9384066
              ],
              [
                49.5548173,
                31.9367938
              ],
              [
                49.5554694,
                31.9348144
              ],
              [
                49.556553,
                31.9327407
              ],
              [
                49.5567406,
                31.9324326
              ],
              [
                49.5573655,
                31.9314058
              ],
              [
                49.5580139,
                31.9302089
              ],
              [
                49.5598565,
                31.9280423
              ],
              [
                49.5622367,
                31.9252368
              ],
              [
                49.5649413,
                31.9217358
              ],
              [
                49.5672151,
                31.9189741
              ],
              [
                49.5690536,
                31.9169945
              ],
              [
                49.5709992,
                31.9149236
              ],
              [
                49.5724603,
                31.9128968
              ],
              [
                49.5734328,
                31.9111014
              ],
              [
                49.5744058,
                31.908936
              ],
              [
                49.5748469,
                31.9076226
              ],
              [
                49.5749475,
                31.9073229
              ],
              [
                49.5764046,
                31.9056208
              ],
              [
                49.577648,
                31.9038689
              ],
              [
                49.579918,
                31.9017519
              ],
              [
                49.5822943,
                31.8996811
              ],
              [
                49.5849953,
                31.8976116
              ],
              [
                49.5869368,
                31.8962305
              ],
              [
                49.5895807,
                31.8942979
              ],
              [
                49.5919037,
                31.8921812
              ],
              [
                49.5938988,
                31.8901105
              ],
              [
                49.5963821,
                31.8877158
              ],
              [
                49.598053,
                31.8855535
              ],
              [
                49.598915,
                31.8843091
              ],
              [
                49.6001586,
                31.8813618
              ],
              [
                49.6006965,
                31.8795184
              ],
              [
                49.6011275,
                31.8780438
              ],
              [
                49.6015586,
                31.8758767
              ],
              [
                49.6017226,
                31.8744488
              ],
              [
                49.6024209,
                31.8706248
              ],
              [
                49.6026384,
                31.8687351
              ],
              [
                49.6028519,
                31.8663379
              ],
              [
                49.6030121,
                31.8637552
              ],
              [
                49.6030654,
                31.861451
              ],
              [
                49.6033364,
                31.8585493
              ],
              [
                49.6035501,
                31.8559198
              ],
              [
                49.6041412,
                31.8532945
              ],
              [
                49.6041986,
                31.8520051
              ],
              [
                49.6045189,
                31.8497918
              ],
              [
                49.6047362,
                31.8479967
              ],
              [
                49.6052171,
                31.8456927
              ],
              [
                49.6060789,
                31.8430184
              ],
              [
                49.6071013,
                31.8407158
              ],
              [
                49.6087189,
                31.838043
              ],
              [
                49.6104393,
                31.8351413
              ],
              [
                49.6111374,
                31.8339447
              ],
              [
                49.6128616,
                31.8320578
              ],
              [
                49.6133178,
                31.8316011
              ],
              [
                49.6153908,
                31.8295257
              ],
              [
                49.6183471,
                31.8269034
              ],
              [
                49.6203919,
                31.825153
              ],
              [
                49.6232414,
                31.8235443
              ],
              [
                49.6237588,
                31.8231534
              ],
              [
                49.6255571,
                31.8217945
              ],
              [
                49.6270065,
                31.8203217
              ],
              [
                49.6300941,
                31.8171932
              ],
              [
                49.6323243,
                31.8137847
              ],
              [
                49.6347427,
                31.8101436
              ],
              [
                49.6368369,
                31.8075207
              ],
              [
                49.637675,
                31.8068012
              ],
              [
                49.6381798,
                31.8063691
              ],
              [
                49.6403808,
                31.804805
              ],
              [
                49.6425819,
                31.8026882
              ],
              [
                49.6443557,
                31.8008917
              ],
              [
                49.6460191,
                31.7989586
              ],
              [
                49.6475183,
                31.7966088
              ],
              [
                49.6497154,
                31.7929245
              ],
              [
                49.652237,
                31.7897465
              ],
              [
                49.6539536,
                31.7874914
              ],
              [
                49.6557235,
                31.7853743
              ],
              [
                49.6574402,
                31.7838995
              ],
              [
                49.6592103,
                31.7826123
              ],
              [
                49.6608199,
                31.7816437
              ],
              [
                49.6627503,
                31.7806334
              ],
              [
                49.6640931,
                31.7799912
              ],
              [
                49.6665079,
                31.7787941
              ],
              [
                49.6689757,
                31.7776923
              ],
              [
                49.6710128,
                31.7765882
              ],
              [
                49.6732138,
                31.7751159
              ],
              [
                49.6754646,
                31.7736892
              ],
              [
                49.6776659,
                31.7723567
              ],
              [
                49.6793252,
                31.7707907
              ],
              [
                49.6810379,
                31.7691802
              ],
              [
                49.6820564,
                31.7680744
              ],
              [
                49.683876,
                31.7665551
              ],
              [
                49.685646,
                31.76513
              ],
              [
                49.6874658,
                31.7637933
              ],
              [
                49.688591,
                31.7627359
              ],
              [
                49.6903573,
                31.7613536
              ],
              [
                49.6921769,
                31.7597913
              ],
              [
                49.6936759,
                31.7587783
              ],
              [
                49.6948549,
                31.7581815
              ],
              [
                49.69535,
                31.7578666
              ],
              [
                49.696087,
                31.757398
              ],
              [
                49.6974831,
                31.7568484
              ],
              [
                49.6986083,
                31.7563886
              ],
              [
                49.6998938,
                31.7556507
              ],
              [
                49.7004813,
                31.7552372
              ],
              [
                49.701393,
                31.7547774
              ],
              [
                49.702141,
                31.7538107
              ],
              [
                49.7026749,
                31.7530719
              ],
              [
                49.7032624,
                31.7522457
              ],
              [
                49.7042236,
                31.7509565
              ],
              [
                49.7046715,
                31.7500409
              ],
              [
                49.7054096,
                31.7470714
              ],
              [
                49.7064247,
                31.7434484
              ],
              [
                49.707321,
                31.7409519
              ],
              [
                49.7083702,
                31.7378976
              ],
              [
                49.7090532,
                31.7357237
              ],
              [
                49.7095719,
                31.7336879
              ],
              [
                49.7102967,
                31.7306821
              ],
              [
                49.7108612,
                31.7278146
              ],
              [
                49.7110062,
                31.7260592
              ],
              [
                49.7112388,
                31.7224531
              ],
              [
                49.7113763,
                31.7199556
              ],
              [
                49.7113649,
                31.7188481
              ],
              [
                49.7112197,
                31.7155179
              ],
              [
                49.7107086,
                31.7128402
              ],
              [
                49.7105827,
                31.7113617
              ],
              [
                49.7100832,
                31.7100215
              ],
              [
                49.709751,
                31.709098
              ],
              [
                49.7085423,
                31.7075093
              ],
              [
                49.7088623,
                31.7069284
              ],
              [
                49.7105714,
                31.704934
              ],
              [
                49.7114257,
                31.7040563
              ],
              [
                49.7125511,
                31.7031745
              ],
              [
                49.7132453,
                31.7025703
              ],
              [
                49.7146376,
                31.7013192
              ],
              [
                49.7159232,
                31.7002992
              ],
              [
                49.7175828,
                31.6989988
              ],
              [
                49.7192458,
                31.6977931
              ],
              [
                49.7210122,
                31.6965411
              ],
              [
                49.7229995,
                31.6953793
              ],
              [
                49.7249297,
                31.6941717
              ],
              [
                49.7269134,
                31.6931495
              ],
              [
                49.7290611,
                31.6918945
              ],
              [
                49.7317429,
                31.6905928
              ],
              [
                49.7337304,
                31.6895706
              ],
              [
                49.7372743,
                31.6878488
              ],
              [
                49.7328683,
                31.683638
              ],
              [
                49.7418136,
                31.6793881
              ],
              [
                49.7480083,
                31.6766412
              ],
              [
                49.7648335,
                31.6726363
              ],
              [
                49.7811927,
                31.6843097
              ],
              [
                49.7973556,
                31.6954975
              ],
              [
                49.8096543,
                31.7031439
              ],
              [
                49.8216877,
                31.7109413
              ],
              [
                49.8335304,
                31.7189082
              ],
              [
                49.8413619,
                31.7180645
              ],
              [
                49.8475551,
                31.7178285
              ],
              [
                49.8503933,
                31.7169714
              ],
              [
                49.8583431,
                31.7104561
              ],
              [
                49.8723965,
                31.698884
              ],
              [
                49.8843156,
                31.6930635
              ],
              [
                49.8897915,
                31.6905585
              ],
              [
                49.9059969,
                31.6859067
              ],
              [
                49.9220429,
                31.683781
              ],
              [
                49.9342885,
                31.6874465
              ],
              [
                49.9434253,
                31.6903609
              ],
              [
                49.9603654,
                31.7001991
              ],
              [
                49.9689704,
                31.7075445
              ],
              [
                49.974017,
                31.711616
              ],
              [
                49.978176,
                31.7164708
              ],
              [
                49.9869804,
                31.7261706
              ],
              [
                49.9914132,
                31.7235489
              ],
              [
                49.9989653,
                31.7177576
              ],
              [
                50.0037344,
                31.7140153
              ],
              [
                50.0198659,
                31.7229669
              ],
              [
                50.0257244,
                31.7246229
              ],
              [
                50.0310506,
                31.7264516
              ],
              [
                50.0358201,
                31.7354484
              ],
              [
                50.0365791,
                31.7378787
              ],
              [
                50.0383766,
                31.7422319
              ],
              [
                50.0412607,
                31.752215
              ],
              [
                50.0436565,
                31.7595204
              ],
              [
                50.0455943,
                31.7670942
              ],
              [
                50.0486509,
                31.7775643
              ],
              [
                50.0511913,
                31.7882935
              ],
              [
                50.0546498,
                31.8020046
              ],
              [
                50.0578754,
                31.8120634
              ],
              [
                50.0651782,
                31.8164667
              ],
              [
                50.0727719,
                31.8217409
              ],
              [
                50.0810591,
                31.826453
              ],
              [
                50.0774291,
                31.8350333
              ],
              [
                50.0758385,
                31.8424582
              ],
              [
                50.0732505,
                31.8464388
              ],
              [
                50.0686601,
                31.8484178
              ],
              [
                50.0648183,
                31.8545292
              ],
              [
                50.058147,
                31.8629133
              ],
              [
                50.0515966,
                31.8669364
              ],
              [
                50.0490704,
                31.8698815
              ],
              [
                50.0525477,
                31.8756973
              ],
              [
                50.054102,
                31.8782372
              ],
              [
                50.055025,
                31.8803214
              ],
              [
                50.0494209,
                31.8845598
              ],
              [
                50.0546531,
                31.8884082
              ],
              [
                50.0679021,
                31.8936409
              ],
              [
                50.0820983,
                31.8963046
              ],
              [
                50.0935993,
                31.8984011
              ],
              [
                50.110429,
                31.9011438
              ],
              [
                50.1351995,
                31.9051619
              ],
              [
                50.148592,
                31.9075459
              ],
              [
                50.156019,
                31.9087748
              ],
              [
                50.1683654,
                31.910996
              ],
              [
                50.1784204,
                31.9124488
              ],
              [
                50.1946154,
                31.9154409
              ],
              [
                50.2131495,
                31.9190734
              ],
              [
                50.2185152,
                31.9203501
              ],
              [
                50.2307377,
                31.922802
              ],
              [
                50.2417223,
                31.9251826
              ],
              [
                50.2420449,
                31.9252258
              ],
              [
                50.2418073,
                31.930283
              ],
              [
                50.2397404,
                31.9318632
              ],
              [
                50.2399325,
                31.9345101
              ],
              [
                50.240243,
                31.9363772
              ],
              [
                50.2385688,
                31.9391792
              ],
              [
                50.2375261,
                31.9409835
              ],
              [
                50.2371643,
                31.9415882
              ],
              [
                50.236076,
                31.9434398
              ],
              [
                50.2345071,
                31.9461685
              ],
              [
                50.2309664,
                31.9477381
              ],
              [
                50.2264832,
                31.9496986
              ],
              [
                50.2246314,
                31.9512991
              ],
              [
                50.2207655,
                31.9545741
              ],
              [
                50.2134921,
                31.9572585
              ],
              [
                50.2088598,
                31.9618277
              ],
              [
                50.2051625,
                31.9653588
              ],
              [
                50.2038212,
                31.9668946
              ],
              [
                50.2004484,
                31.969383
              ],
              [
                50.1923634,
                31.9720886
              ],
              [
                50.1883103,
                31.9769883
              ],
              [
                50.1847512,
                31.9798737
              ],
              [
                50.1792568,
                31.9802829
              ],
              [
                50.1694679,
                31.988155
              ],
              [
                50.1561069,
                31.9944648
              ],
              [
                50.1436824,
                32.0019204
              ],
              [
                50.132555,
                32.0115769
              ],
              [
                50.1238784,
                32.0190257
              ],
              [
                50.1195602,
                32.0228919
              ],
              [
                50.1098917,
                32.0313638
              ],
              [
                50.0963785,
                32.0426499
              ],
              [
                50.0775086,
                32.0559369
              ],
              [
                50.0569324,
                32.0723358
              ],
              [
                50.0420244,
                32.0845968
              ],
              [
                50.0225048,
                32.1009987
              ],
              [
                50.0159342,
                32.1063199
              ],
              [
                50.0124581,
                32.1100709
              ],
              [
                50.0067901,
                32.1159335
              ],
              [
                49.9961013,
                32.1268392
              ],
              [
                49.9864806,
                32.1369787
              ],
              [
                49.9726179,
                32.1512555
              ],
              [
                49.967267,
                32.156911
              ],
              [
                49.9612093,
                32.1633836
              ],
              [
                49.947463,
                32.1775298
              ],
              [
                49.9422491,
                32.1893702
              ],
              [
                49.9380597,
                32.1992988
              ],
              [
                49.9350575,
                32.2060517
              ],
              [
                49.9313677,
                32.2130224
              ],
              [
                49.9305791,
                32.2178471
              ],
              [
                49.9293527,
                32.2261526
              ],
              [
                49.9276542,
                32.2314887
              ],
              [
                49.9264878,
                32.2372759
              ],
              [
                49.924183,
                32.2453158
              ],
              [
                49.9235078,
                32.2528076
              ],
              [
                49.922121,
                32.2576828
              ],
              [
                49.9195109,
                32.2670891
              ],
              [
                49.9232014,
                32.2669626
              ],
              [
                49.9225233,
                32.2791611
              ],
              [
                49.9221257,
                32.2853031
              ],
              [
                49.9217128,
                32.2908507
              ],
              [
                49.9214428,
                32.3037715
              ],
              [
                49.9115182,
                32.3160824
              ],
              [
                49.9051973,
                32.325037
              ],
              [
                49.8791293,
                32.3419225
              ],
              [
                49.874349,
                32.3450448
              ],
              [
                49.87014,
                32.3413552
              ],
              [
                49.864008,
                32.3360223
              ],
              [
                49.8568421,
                32.3317144
              ],
              [
                49.8539433,
                32.3273208
              ],
              [
                49.8523406,
                32.3259498
              ],
              [
                49.8488235,
                32.3228959
              ],
              [
                49.8478507,
                32.3222014
              ],
              [
                49.8471452,
                32.3210494
              ],
              [
                49.846443,
                32.3196651
              ],
              [
                49.8452529,
                32.3182289
              ],
              [
                49.8444442,
                32.316246
              ],
              [
                49.8432578,
                32.3143048
              ],
              [
                49.8410415,
                32.3097832
              ],
              [
                49.8397979,
                32.3073813
              ],
              [
                49.8386652,
                32.3048428
              ],
              [
                49.8372612,
                32.3023989
              ],
              [
                49.8361815,
                32.3003187
              ],
              [
                49.8351022,
                32.2980107
              ],
              [
                49.8344535,
                32.2964893
              ],
              [
                49.8340759,
                32.2952432
              ],
              [
                49.8337517,
                32.2942277
              ],
              [
                49.8331566,
                32.2927045
              ],
              [
                49.8327254,
                32.2916451
              ],
              [
                49.8319704,
                32.28994
              ],
              [
                49.8306199,
                32.2879068
              ],
              [
                49.8290025,
                32.2842137
              ],
              [
                49.8267861,
                32.2811239
              ],
              [
                49.8263437,
                32.2803927
              ],
              [
                49.8243561,
                32.2771074
              ],
              [
                49.8227348,
                32.2750785
              ],
              [
                49.821348,
                32.2710134
              ],
              [
                49.8180432,
                32.2680343
              ],
              [
                49.8141078,
                32.264394
              ],
              [
                49.8125344,
                32.2632747
              ],
              [
                49.8110653,
                32.2620778
              ],
              [
                49.8092457,
                32.2606887
              ],
              [
                49.8068365,
                32.2587616
              ],
              [
                49.804165,
                32.2567286
              ],
              [
                49.8012375,
                32.2555331
              ],
              [
                49.7972221,
                32.2539949
              ],
              [
                49.7929775,
                32.2523486
              ],
              [
                49.78814,
                32.2504242
              ],
              [
                49.7872158,
                32.2501056
              ],
              [
                49.7849627,
                32.2492006
              ],
              [
                49.7807933,
                32.248099
              ],
              [
                49.7733783,
                32.2459296
              ],
              [
                49.7660588,
                32.2438885
              ],
              [
                49.7578718,
                32.2418015
              ],
              [
                49.7452936,
                32.2387901
              ],
              [
                49.7416088,
                32.2380492
              ],
              [
                49.7335949,
                32.2364378
              ],
              [
                49.7253369,
                32.2347662
              ],
              [
                49.713452,
                32.2324357
              ],
              [
                49.7040232,
                32.2305295
              ],
              [
                49.6993502,
                32.2296317
              ],
              [
                49.6948601,
                32.2249354
              ],
              [
                49.691742,
                32.2215296
              ],
              [
                49.6914855,
                32.2209593
              ],
              [
                49.6909448,
                32.2196246
              ],
              [
                49.6898957,
                32.2170651
              ],
              [
                49.6892504,
                32.2154408
              ],
              [
                49.6881235,
                32.2127326
              ],
              [
                49.6878203,
                32.2119174
              ],
              [
                49.6863203,
                32.2068772
              ],
              [
                49.6826377,
                32.2053923
              ],
              [
                49.6772233,
                32.203172
              ],
              [
                49.6722163,
                32.2012384
              ],
              [
                49.6620113,
                32.1976447
              ],
              [
                49.659907,
                32.195116
              ],
              [
                49.657373,
                32.1869227
              ],
              [
                49.6520572,
                32.1798862
              ],
              [
                49.6463198,
                32.1758685
              ],
              [
                49.6381018,
                32.1703841
              ],
              [
                49.6275978,
                32.1698468
              ],
              [
                49.6268273,
                32.1677745
              ],
              [
                49.6225891,
                32.1672713
              ],
              [
                49.6222081,
                32.1652404
              ],
              [
                49.6188781,
                32.1621441
              ],
              [
                49.6197179,
                32.1578549
              ],
              [
                49.6201802,
                32.1559904
              ],
              [
                49.6222679,
                32.1516744
              ],
              [
                49.6249026,
                32.147052
              ],
              [
                49.6275264,
                32.1423182
              ],
              [
                49.6299285,
                32.1382721
              ],
              [
                49.6315908,
                32.1351048
              ],
              [
                49.6344518,
                32.1297055
              ],
              [
                49.6354808,
                32.1266867
              ],
              [
                49.6371757,
                32.1216554
              ],
              [
                49.6376163,
                32.113984
              ],
              [
                49.6354903,
                32.1068673
              ],
              [
                49.6339036,
                32.1034382
              ],
              [
                49.6282865,
                32.0990497
              ],
              [
                49.6247073,
                32.0937482
              ],
              [
                49.6230287,
                32.091571
              ],
              [
                49.6204901,
                32.0824016
              ],
              [
                49.6216288,
                32.0743283
              ],
              [
                49.6239662,
                32.066163
              ],
              [
                49.6286573,
                32.0560684
              ],
              [
                49.6515638,
                32.0440922
              ],
              [
                49.6615182,
                32.0390795
              ],
              [
                49.6700133,
                32.0347986
              ],
              [
                49.6756228,
                32.0317803
              ],
              [
                49.6788751,
                32.0308054
              ],
              [
                49.6861973,
                32.0277061
              ],
              [
                49.6960238,
                32.0219595
              ],
              [
                49.6856728,
                31.9952335
              ],
              [
                49.6845366,
                31.9922234
              ],
              [
                49.6698246,
                31.9923803
              ],
              [
                49.6623774,
                31.9920896
              ],
              [
                49.655715,
                31.9915503
              ],
              [
                49.6507416,
                31.9911889
              ],
              [
                49.6353024,
                31.990351
              ],
              [
                49.6321602,
                31.9920985
              ],
              [
                49.6305465,
                31.9930924
              ],
              [
                49.6287042,
                31.993598
              ],
              [
                49.6264305,
                31.9947009
              ],
              [
                49.624779,
                31.9953588
              ],
              [
                49.6237793,
                31.9957569
              ],
              [
                49.6218299,
                31.997046
              ],
              [
                49.6197821,
                31.998343
              ],
              [
                49.6182799,
                31.9998467
              ],
              [
                49.6143009,
                32.0047165
              ],
              [
                49.6137505,
                32.0053901
              ],
              [
                49.6087226,
                32.0092274
              ],
              [
                49.6038018,
                32.012741
              ],
              [
                49.5990448,
                32.0161164
              ],
              [
                49.5961761,
                32.0176429
              ],
              [
                49.5947725,
                32.0187978
              ],
              [
                49.5923386,
                32.0198172
              ],
              [
                49.590767,
                32.0200952
              ],
              [
                49.5895232,
                32.0201873
              ],
              [
                49.5883294,
                32.0205123
              ],
              [
                49.5871962,
                32.0210229
              ],
              [
                49.5855714,
                32.0219001
              ],
              [
                49.5844346,
                32.0227308
              ],
              [
                49.5827599,
                32.0237495
              ],
              [
                49.5813522,
                32.0243539
              ],
              [
                49.5798911,
                32.0249058
              ],
              [
                49.5781593,
                32.0253713
              ],
              [
                49.5766983,
                32.0255128
              ],
              [
                49.5750734,
                32.025375
              ],
              [
                49.5740966,
                32.0250979
              ],
              [
                49.5734979,
                32.0246807
              ],
              [
                49.5728988,
                32.0243308
              ],
              [
                49.5726319,
                32.0241749
              ],
              [
                49.5720902,
                32.0236208
              ],
              [
                49.571598,
                32.0228846
              ],
              [
                49.5708923,
                32.0214536
              ],
              [
                49.5705109,
                32.0205315
              ],
              [
                49.5702361,
                32.0193286
              ],
              [
                49.5700188,
                32.0181738
              ],
              [
                49.5699082,
                32.0171127
              ],
              [
                49.5699042,
                32.0163278
              ],
              [
                49.569416,
                32.0155917
              ],
              [
                49.568924,
                32.0145758
              ],
              [
                49.5683288,
                32.0140188
              ],
              [
                49.5676766,
                32.0138807
              ],
              [
                49.5667572,
                32.0140687
              ],
              [
                49.5658913,
                32.0141153
              ],
              [
                49.5647546,
                32.0145309
              ],
              [
                49.5637246,
                32.0148553
              ],
              [
                49.5629157,
                32.0153197
              ],
              [
                49.5626386,
                32.015437
              ],
              [
                49.5622672,
                32.0155943
              ],
              [
                49.5615616,
                32.0157351
              ],
              [
                49.5608023,
                32.0157355
              ],
              [
                49.5601538,
                32.0157349
              ],
              [
                49.5595589,
                32.0155071
              ],
              [
                49.558689,
                32.0152785
              ],
              [
                49.5572816,
                32.0147709
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554908,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان باغ ملک",
          "name:en": "Baghmalek County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279175",
          "wikipedia": "en:Bagh-e Malek County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.4755122,
                31.6938718
              ],
              [
                49.4759217,
                31.6933422
              ],
              [
                49.4786835,
                31.6891241
              ],
              [
                49.4810754,
                31.6856413
              ],
              [
                49.4850616,
                31.679771
              ],
              [
                49.4871863,
                31.6761045
              ],
              [
                49.4915467,
                31.6698686
              ],
              [
                49.4918388,
                31.669439
              ],
              [
                49.4940415,
                31.6661995
              ],
              [
                49.4967104,
                31.6609718
              ],
              [
                49.4969573,
                31.6604643
              ],
              [
                49.5000231,
                31.6541616
              ],
              [
                49.5015144,
                31.6470323
              ],
              [
                49.5031282,
                31.644027
              ],
              [
                49.504631,
                31.6420848
              ],
              [
                49.506031,
                31.6402339
              ],
              [
                49.510273,
                31.6351438
              ],
              [
                49.5139276,
                31.6308834
              ],
              [
                49.5201567,
                31.6234796
              ],
              [
                49.5256273,
                31.6168584
              ],
              [
                49.5308874,
                31.6112109
              ],
              [
                49.5348016,
                31.6070431
              ],
              [
                49.5370116,
                31.6052555
              ],
              [
                49.5381281,
                31.6043523
              ],
              [
                49.5408629,
                31.6019908
              ],
              [
                49.5478896,
                31.5967484
              ],
              [
                49.5540008,
                31.5924313
              ],
              [
                49.5549127,
                31.5919206
              ],
              [
                49.5565758,
                31.5911771
              ],
              [
                49.5586168,
                31.590386
              ],
              [
                49.5589062,
                31.5902655
              ],
              [
                49.5624236,
                31.5888006
              ],
              [
                49.5667724,
                31.5871693
              ],
              [
                49.5714379,
                31.5855819
              ],
              [
                49.5751953,
                31.5846
              ],
              [
                49.5792733,
                31.5833825
              ],
              [
                49.5840492,
                31.5815658
              ],
              [
                49.5877992,
                31.5800286
              ],
              [
                49.5934868,
                31.5781135
              ],
              [
                49.5944691,
                31.5777096
              ],
              [
                49.5974503,
                31.5764836
              ],
              [
                49.6018981,
                31.5743425
              ],
              [
                49.6055413,
                31.5727111
              ],
              [
                49.6078948,
                31.5715031
              ],
              [
                49.6105192,
                31.5698763
              ],
              [
                49.614525,
                31.5669044
              ],
              [
                49.6191254,
                31.5640246
              ],
              [
                49.6248968,
                31.560167
              ],
              [
                49.6297074,
                31.5572394
              ],
              [
                49.6326485,
                31.555381
              ],
              [
                49.6348342,
                31.5536159
              ],
              [
                49.6366462,
                31.5518084
              ],
              [
                49.6387216,
                31.5494444
              ],
              [
                49.6405829,
                31.5473577
              ],
              [
                49.6430932,
                31.5456839
              ],
              [
                49.645977,
                31.544147
              ],
              [
                49.6495018,
                31.5417778
              ],
              [
                49.6549415,
                31.5378274
              ],
              [
                49.6593095,
                31.5343933
              ],
              [
                49.6610679,
                31.5330924
              ],
              [
                49.662876,
                31.5313769
              ],
              [
                49.6643638,
                31.5297055
              ],
              [
                49.6665918,
                31.5267855
              ],
              [
                49.6693991,
                31.5229852
              ],
              [
                49.6727257,
                31.5175189
              ],
              [
                49.6750031,
                31.5142746
              ],
              [
                49.6761665,
                31.5126064
              ],
              [
                49.6782342,
                31.5102416
              ],
              [
                49.6800882,
                31.5079219
              ],
              [
                49.6812552,
                31.5069461
              ],
              [
                49.6829568,
                31.5052766
              ],
              [
                49.6838381,
                31.5036461
              ],
              [
                49.6842677,
                31.5018056
              ],
              [
                49.6841573,
                31.5000746
              ],
              [
                49.6838684,
                31.4991853
              ],
              [
                49.6839714,
                31.4966964
              ],
              [
                49.6838569,
                31.4941602
              ],
              [
                49.683655,
                31.4926344
              ],
              [
                49.6835823,
                31.4920847
              ],
              [
                49.6833075,
                31.4906091
              ],
              [
                49.6833039,
                31.4893168
              ],
              [
                49.6835707,
                31.4881174
              ],
              [
                49.6838874,
                31.4864585
              ],
              [
                49.6842041,
                31.4846123
              ],
              [
                49.6848984,
                31.48171
              ],
              [
                49.685856,
                31.4783458
              ],
              [
                49.6868669,
                31.47521
              ],
              [
                49.6881446,
                31.4715716
              ],
              [
                49.6891593,
                31.4692184
              ],
              [
                49.6895867,
                31.4687131
              ],
              [
                49.6902659,
                31.4676477
              ],
              [
                49.690933,
                31.4669493
              ],
              [
                49.6916771,
                31.4664114
              ],
              [
                49.6930694,
                31.4657693
              ],
              [
                49.6943921,
                31.4651065
              ],
              [
                49.7000426,
                31.4622746
              ],
              [
                49.7028273,
                31.4607579
              ],
              [
                49.7067413,
                31.4585962
              ],
              [
                49.7111891,
                31.4558376
              ],
              [
                49.7153109,
                31.4533823
              ],
              [
                49.7165483,
                31.4523527
              ],
              [
                49.7185783,
                31.4509161
              ],
              [
                49.7187807,
                31.4507061
              ],
              [
                49.720131,
                31.4493055
              ],
              [
                49.722267,
                31.4470488
              ],
              [
                49.7244606,
                31.4445604
              ],
              [
                49.725792,
                31.4426701
              ],
              [
                49.7273444,
                31.4410143
              ],
              [
                49.7283059,
                31.4397248
              ],
              [
                49.7320976,
                31.4352561
              ],
              [
                49.7354583,
                31.4309725
              ],
              [
                49.7374838,
                31.4282093
              ],
              [
                49.7443733,
                31.4213935
              ],
              [
                49.7486459,
                31.4175717
              ],
              [
                49.7499415,
                31.4167544
              ],
              [
                49.7594873,
                31.4066121
              ],
              [
                49.7656249,
                31.3987818
              ],
              [
                49.7695975,
                31.3932823
              ],
              [
                49.7734376,
                31.3879654
              ],
              [
                49.7806014,
                31.3782519
              ],
              [
                49.7813096,
                31.3772633
              ],
              [
                49.7869035,
                31.3694545
              ],
              [
                49.7849771,
                31.3686604
              ],
              [
                49.7650324,
                31.3609845
              ],
              [
                49.7614442,
                31.359603
              ],
              [
                49.7546539,
                31.3571759
              ],
              [
                49.7570191,
                31.3549794
              ],
              [
                49.7611046,
                31.3513223
              ],
              [
                49.7677116,
                31.3460225
              ],
              [
                49.7729835,
                31.3411268
              ],
              [
                49.7761003,
                31.3382448
              ],
              [
                49.7808762,
                31.335604
              ],
              [
                49.7828635,
                31.3346034
              ],
              [
                49.7872085,
                31.3326936
              ],
              [
                49.7929063,
                31.3295495
              ],
              [
                49.7947235,
                31.3285466
              ],
              [
                49.7949244,
                31.3286816
              ],
              [
                49.7959631,
                31.3245837
              ],
              [
                49.7966233,
                31.3219785
              ],
              [
                49.7970319,
                31.3205032
              ],
              [
                49.7971582,
                31.3200473
              ],
              [
                49.7973762,
                31.3192603
              ],
              [
                49.7990151,
                31.3133422
              ],
              [
                49.8005866,
                31.3087941
              ],
              [
                49.8009683,
                31.3066346
              ],
              [
                49.8010214,
                31.3060594
              ],
              [
                49.8011932,
                31.3041963
              ],
              [
                49.8014145,
                31.3023106
              ],
              [
                49.8014679,
                31.3018983
              ],
              [
                49.8016852,
                31.3012079
              ],
              [
                49.80217,
                31.3005223
              ],
              [
                49.8035736,
                31.2981355
              ],
              [
                49.8048628,
                31.2963476
              ],
              [
                49.8058852,
                31.2952046
              ],
              [
                49.807068,
                31.2939683
              ],
              [
                49.8083039,
                31.2927325
              ],
              [
                49.8102378,
                31.2911806
              ],
              [
                49.8136255,
                31.2883904
              ],
              [
                49.8165244,
                31.2861526
              ],
              [
                49.8192635,
                31.2843734
              ],
              [
                49.8211403,
                31.2831411
              ],
              [
                49.8228036,
                31.2822745
              ],
              [
                49.8240927,
                31.2815916
              ],
              [
                49.8260765,
                31.2809579
              ],
              [
                49.8274727,
                31.2803662
              ],
              [
                49.8297767,
                31.2796902
              ],
              [
                49.8316001,
                31.2790099
              ],
              [
                49.8330994,
                31.278419
              ],
              [
                49.834282,
                31.2777351
              ],
              [
                49.8349799,
                31.2769565
              ],
              [
                49.8363761,
                31.2757219
              ],
              [
                49.8372382,
                31.2744847
              ],
              [
                49.8382605,
                31.2736143
              ],
              [
                49.8407861,
                31.2709598
              ],
              [
                49.8443871,
                31.2674376
              ],
              [
                49.8453253,
                31.2666167
              ],
              [
                49.8501891,
                31.2623606
              ],
              [
                49.8519631,
                31.2604367
              ],
              [
                49.8541144,
                31.2575959
              ],
              [
                49.8569146,
                31.2542963
              ],
              [
                49.8585441,
                31.250032
              ],
              [
                49.8587953,
                31.2471066
              ],
              [
                49.8596422,
                31.244491
              ],
              [
                49.8604356,
                31.2430206
              ],
              [
                49.8609084,
                31.2411415
              ],
              [
                49.8614884,
                31.239349
              ],
              [
                49.861805,
                31.2382037
              ],
              [
                49.8622778,
                31.2362298
              ],
              [
                49.8628044,
                31.2343489
              ],
              [
                49.8637963,
                31.2297135
              ],
              [
                49.8644218,
                31.2262726
              ],
              [
                49.8648161,
                31.2243065
              ],
              [
                49.8652039,
                31.222373
              ],
              [
                49.8656235,
                31.2206737
              ],
              [
                49.8659441,
                31.2166575
              ],
              [
                49.8659749,
                31.2162718
              ],
              [
                49.8662453,
                31.2162697
              ],
              [
                49.8680113,
                31.2161747
              ],
              [
                49.8715439,
                31.2161652
              ],
              [
                49.8756712,
                31.216384
              ],
              [
                49.8797417,
                31.2165571
              ],
              [
                49.8840257,
                31.2167274
              ],
              [
                49.8921662,
                31.2166625
              ],
              [
                49.8960189,
                31.2164678
              ],
              [
                49.9000357,
                31.2164571
              ],
              [
                49.9029808,
                31.2162183
              ],
              [
                49.9043158,
                31.2161237
              ],
              [
                49.9064025,
                31.2157062
              ],
              [
                49.9080085,
                31.215289
              ],
              [
                49.910038,
                31.2145032
              ],
              [
                49.9121172,
                31.2134427
              ],
              [
                49.9139327,
                31.2126596
              ],
              [
                49.9153212,
                31.2121503
              ],
              [
                49.9170342,
                31.2117812
              ],
              [
                49.9198686,
                31.211681
              ],
              [
                49.9265596,
                31.2113423
              ],
              [
                49.9362488,
                31.2108567
              ],
              [
                49.939354,
                31.2108507
              ],
              [
                49.942192,
                31.2108425
              ],
              [
                49.9456138,
                31.210512
              ],
              [
                49.9487723,
                31.2105017
              ],
              [
                49.9503733,
                31.2103497
              ],
              [
                49.9527319,
                31.2101258
              ],
              [
                49.9541243,
                31.2101664
              ],
              [
                49.95467,
                31.2114047
              ],
              [
                49.9557419,
                31.2114495
              ],
              [
                49.9587403,
                31.2114399
              ],
              [
                49.9621696,
                31.2115691
              ],
              [
                49.9665641,
                31.2122902
              ],
              [
                49.9748268,
                31.2144247
              ],
              [
                49.9783211,
                31.2157449
              ],
              [
                49.9812318,
                31.218213
              ],
              [
                49.9828035,
                31.2199984
              ],
              [
                49.984478,
                31.2216469
              ],
              [
                49.9858934,
                31.2243489
              ],
              [
                49.987835,
                31.2260424
              ],
              [
                49.9902726,
                31.2291088
              ],
              [
                49.9916268,
                31.2306171
              ],
              [
                49.9968414,
                31.2327623
              ],
              [
                50.0000124,
                31.2330397
              ],
              [
                50.0117279,
                31.2381406
              ],
              [
                50.0436708,
                31.2467033
              ],
              [
                50.0729367,
                31.254194
              ],
              [
                50.1015739,
                31.2579107
              ],
              [
                50.1028171,
                31.2580592
              ],
              [
                50.1040305,
                31.2580857
              ],
              [
                50.1052627,
                31.2580808
              ],
              [
                50.106594,
                31.2578916
              ],
              [
                50.1075554,
                31.2574742
              ],
              [
                50.1092606,
                31.2566853
              ],
              [
                50.1114921,
                31.2550654
              ],
              [
                50.1137198,
                31.2529402
              ],
              [
                50.1167451,
                31.2499363
              ],
              [
                50.1174392,
                31.2499817
              ],
              [
                50.1190988,
                31.2502976
              ],
              [
                50.120968,
                31.2503825
              ],
              [
                50.1224632,
                31.2505597
              ],
              [
                50.1242791,
                31.250554
              ],
              [
                50.1269493,
                31.2504053
              ],
              [
                50.1299934,
                31.2503492
              ],
              [
                50.1329308,
                31.2504773
              ],
              [
                50.1352805,
                31.2503759
              ],
              [
                50.1399269,
                31.2504499
              ],
              [
                50.1424943,
                31.2504874
              ],
              [
                50.1454848,
                31.2506606
              ],
              [
                50.1484221,
                31.2508786
              ],
              [
                50.1504553,
                31.2511966
              ],
              [
                50.1509552,
                31.2513377
              ],
              [
                50.1527063,
                31.2518317
              ],
              [
                50.1552239,
                31.2531114
              ],
              [
                50.1576751,
                31.2541667
              ],
              [
                50.160103,
                31.2552118
              ],
              [
                50.1634293,
                31.2566252
              ],
              [
                50.1656798,
                31.2576774
              ],
              [
                50.1698685,
                31.2601022
              ],
              [
                50.1766931,
                31.2642694
              ],
              [
                50.1800841,
                31.2671557
              ],
              [
                50.1831511,
                31.2692639
              ],
              [
                50.1892815,
                31.2730628
              ],
              [
                50.1948128,
                31.2760367
              ],
              [
                50.196644,
                31.2772752
              ],
              [
                50.1984252,
                31.2787885
              ],
              [
                50.2008516,
                31.2810818
              ],
              [
                50.2035562,
                31.283882
              ],
              [
                50.2052803,
                31.2853498
              ],
              [
                50.2064668,
                31.2861286
              ],
              [
                50.2077559,
                31.2868606
              ],
              [
                50.2093124,
                31.2874093
              ],
              [
                50.2107049,
                31.2876344
              ],
              [
                50.2114526,
                31.2875871
              ],
              [
                50.2124176,
                31.2874915
              ],
              [
                50.213642,
                31.2871629
              ],
              [
                50.2155608,
                31.2865115
              ],
              [
                50.2166786,
                31.286092
              ],
              [
                50.2176399,
                31.2858137
              ],
              [
                50.2182273,
                31.2858127
              ],
              [
                50.2187117,
                31.2859488
              ],
              [
                50.2191429,
                31.2864521
              ],
              [
                50.2193642,
                31.2870038
              ],
              [
                50.2193184,
                31.2877434
              ],
              [
                50.2191163,
                31.2888023
              ],
              [
                50.2179222,
                31.2922619
              ],
              [
                50.2168311,
                31.2954424
              ],
              [
                50.2167894,
                31.2963173
              ],
              [
                50.2166901,
                31.2972844
              ],
              [
                50.2168654,
                31.2984381
              ],
              [
                50.2171975,
                31.2995408
              ],
              [
                50.2177429,
                31.30069
              ],
              [
                50.2183417,
                31.3016997
              ],
              [
                50.2193716,
                31.302757
              ],
              [
                50.220665,
                31.3037213
              ],
              [
                50.2218553,
                31.30473
              ],
              [
                50.2236329,
                31.3059227
              ],
              [
                50.2249794,
                31.3067451
              ],
              [
                50.2263262,
                31.3073396
              ],
              [
                50.2279892,
                31.3079339
              ],
              [
                50.229763,
                31.308434
              ],
              [
                50.2317467,
                31.3086105
              ],
              [
                50.2343711,
                31.3087412
              ],
              [
                50.236351,
                31.308735
              ],
              [
                50.2467612,
                31.306489
              ],
              [
                50.2551509,
                31.3151904
              ],
              [
                50.2710175,
                31.330101
              ],
              [
                50.2763604,
                31.3351205
              ],
              [
                50.2882563,
                31.344356
              ],
              [
                50.2967432,
                31.3524734
              ],
              [
                50.297566,
                31.3537631
              ],
              [
                50.2978882,
                31.354037
              ],
              [
                50.2981126,
                31.3546198
              ],
              [
                50.2986931,
                31.3561277
              ],
              [
                50.2992784,
                31.3576481
              ],
              [
                50.2995551,
                31.357928
              ],
              [
                50.2998317,
                31.3584786
              ],
              [
                50.2998316,
                31.3587585
              ],
              [
                50.2995551,
                31.3590383
              ],
              [
                50.2973316,
                31.3618189
              ],
              [
                50.2967785,
                31.3620987
              ],
              [
                50.2774065,
                31.3757213
              ],
              [
                50.2751766,
                31.3780288
              ],
              [
                50.270004,
                31.3835008
              ],
              [
                50.2648108,
                31.3915394
              ],
              [
                50.2601251,
                31.3965859
              ],
              [
                50.2600674,
                31.3966481
              ],
              [
                50.2457794,
                31.3941911
              ],
              [
                50.234202,
                31.4017872
              ],
              [
                50.2236915,
                31.4162242
              ],
              [
                50.2129705,
                31.4343179
              ],
              [
                50.2053185,
                31.4541371
              ],
              [
                50.2036667,
                31.455708
              ],
              [
                50.2010575,
                31.458845
              ],
              [
                50.1997263,
                31.4616991
              ],
              [
                50.1899665,
                31.467941
              ],
              [
                50.189251,
                31.4686365
              ],
              [
                50.1861143,
                31.4703752
              ],
              [
                50.1792884,
                31.4747048
              ],
              [
                50.1479784,
                31.4893443
              ],
              [
                50.1365272,
                31.4985521
              ],
              [
                50.1317867,
                31.503473
              ],
              [
                50.1274357,
                31.5084913
              ],
              [
                50.1228319,
                31.5125236
              ],
              [
                50.0938958,
                31.5390191
              ],
              [
                50.089156,
                31.546218
              ],
              [
                50.0816079,
                31.5571465
              ],
              [
                50.07792,
                31.5623552
              ],
              [
                50.0730277,
                31.5705404
              ],
              [
                50.060732,
                31.5904474
              ],
              [
                50.0469741,
                31.620216
              ],
              [
                50.040743,
                31.6333592
              ],
              [
                50.0330695,
                31.6496991
              ],
              [
                50.0305318,
                31.6588804
              ],
              [
                50.0291157,
                31.6645763
              ],
              [
                50.0263671,
                31.670265
              ],
              [
                50.0220527,
                31.6790168
              ],
              [
                50.0167818,
                31.6896065
              ],
              [
                50.0097379,
                31.702802
              ],
              [
                50.0037344,
                31.7140153
              ],
              [
                49.9989653,
                31.7177576
              ],
              [
                49.9914132,
                31.7235489
              ],
              [
                49.9869804,
                31.7261706
              ],
              [
                49.978176,
                31.7164708
              ],
              [
                49.974017,
                31.711616
              ],
              [
                49.9689704,
                31.7075445
              ],
              [
                49.9603654,
                31.7001991
              ],
              [
                49.9434253,
                31.6903609
              ],
              [
                49.9342885,
                31.6874465
              ],
              [
                49.9220429,
                31.683781
              ],
              [
                49.9059969,
                31.6859067
              ],
              [
                49.8897915,
                31.6905585
              ],
              [
                49.8843156,
                31.6930635
              ],
              [
                49.8723965,
                31.698884
              ],
              [
                49.8583431,
                31.7104561
              ],
              [
                49.8503933,
                31.7169714
              ],
              [
                49.8475551,
                31.7178285
              ],
              [
                49.8413619,
                31.7180645
              ],
              [
                49.8335304,
                31.7189082
              ],
              [
                49.8216877,
                31.7109413
              ],
              [
                49.8096543,
                31.7031439
              ],
              [
                49.7973556,
                31.6954975
              ],
              [
                49.7811927,
                31.6843097
              ],
              [
                49.7648335,
                31.6726363
              ],
              [
                49.7480083,
                31.6766412
              ],
              [
                49.7418136,
                31.6793881
              ],
              [
                49.7328683,
                31.683638
              ],
              [
                49.7372743,
                31.6878488
              ],
              [
                49.7337304,
                31.6895706
              ],
              [
                49.7317429,
                31.6905928
              ],
              [
                49.7290611,
                31.6918945
              ],
              [
                49.7269134,
                31.6931495
              ],
              [
                49.7249297,
                31.6941717
              ],
              [
                49.7229995,
                31.6953793
              ],
              [
                49.7210122,
                31.6965411
              ],
              [
                49.7192458,
                31.6977931
              ],
              [
                49.7175828,
                31.6989988
              ],
              [
                49.7159232,
                31.7002992
              ],
              [
                49.7146376,
                31.7013192
              ],
              [
                49.7132453,
                31.7025703
              ],
              [
                49.7125511,
                31.7031745
              ],
              [
                49.7114257,
                31.7040563
              ],
              [
                49.7105714,
                31.704934
              ],
              [
                49.7088623,
                31.7069284
              ],
              [
                49.7085423,
                31.7075093
              ],
              [
                49.7077865,
                31.7074385
              ],
              [
                49.7070259,
                31.7072909
              ],
              [
                49.7056771,
                31.7070291
              ],
              [
                49.7032967,
                31.7067118
              ],
              [
                49.7012404,
                31.7063931
              ],
              [
                49.6969109,
                31.705528
              ],
              [
                49.6934509,
                31.705028
              ],
              [
                49.6882592,
                31.704535
              ],
              [
                49.6830673,
                31.703762
              ],
              [
                49.6769601,
                31.7031327
              ],
              [
                49.6738244,
                31.7028633
              ],
              [
                49.6698798,
                31.7025967
              ],
              [
                49.6664771,
                31.7025612
              ],
              [
                49.6598358,
                31.7025795
              ],
              [
                49.6577834,
                31.7025376
              ],
              [
                49.6556779,
                31.7024974
              ],
              [
                49.6515695,
                31.7023232
              ],
              [
                49.6477889,
                31.7021501
              ],
              [
                49.6461144,
                31.7020173
              ],
              [
                49.644603,
                31.701886
              ],
              [
                49.6445465,
                31.7018811
              ],
              [
                49.6434669,
                31.7017005
              ],
              [
                49.6419525,
                31.7014724
              ],
              [
                49.6403846,
                31.7012459
              ],
              [
                49.6380615,
                31.7010678
              ],
              [
                49.6354674,
                31.7010739
              ],
              [
                49.633793,
                31.700986
              ],
              [
                49.6295814,
                31.7009521
              ],
              [
                49.622345,
                31.7011109
              ],
              [
                49.6162986,
                31.7012665
              ],
              [
                49.609497,
                31.7016097
              ],
              [
                49.6005324,
                31.7016334
              ],
              [
                49.5951347,
                31.7016936
              ],
              [
                49.584442,
                31.7016768
              ],
              [
                49.5796889,
                31.7017367
              ],
              [
                49.5726698,
                31.7018026
              ],
              [
                49.5657004,
                31.7017289
              ],
              [
                49.5620308,
                31.7015546
              ],
              [
                49.5605073,
                31.7014493
              ],
              [
                49.5575446,
                31.7012445
              ],
              [
                49.5544661,
                31.7010202
              ],
              [
                49.5521431,
                31.7007503
              ],
              [
                49.5483627,
                31.7003916
              ],
              [
                49.5457154,
                31.7002148
              ],
              [
                49.5435028,
                31.6999911
              ],
              [
                49.5418281,
                31.6997645
              ],
              [
                49.538044,
                31.6992656
              ],
              [
                49.5359384,
                31.6989956
              ],
              [
                49.5335617,
                31.6989548
              ],
              [
                49.5295106,
                31.6987367
              ],
              [
                49.5268223,
                31.6984873
              ],
              [
                49.5265961,
                31.6984663
              ],
              [
                49.5230866,
                31.6981551
              ],
              [
                49.519413,
                31.6979817
              ],
              [
                49.514824,
                31.6976689
              ],
              [
                49.5115851,
                31.6974485
              ],
              [
                49.5069922,
                31.6969077
              ],
              [
                49.5012628,
                31.6966443
              ],
              [
                49.4942209,
                31.6961486
              ],
              [
                49.4779203,
                31.694165
              ],
              [
                49.4755122,
                31.6938718
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554912,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان باوی",
          "name:en": "Bavi County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4808811",
          "wikipedia": "en:Bavi County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.71551,
                31.5312446
              ],
              [
                48.7195304,
                31.530513
              ],
              [
                48.7227471,
                31.5299275
              ],
              [
                48.7292148,
                31.5290958
              ],
              [
                48.7366144,
                31.5278069
              ],
              [
                48.7416126,
                31.5267908
              ],
              [
                48.7447732,
                31.5255843
              ],
              [
                48.7488657,
                31.5239207
              ],
              [
                48.7526087,
                31.5214619
              ],
              [
                48.7572721,
                31.5190192
              ],
              [
                48.7639642,
                31.516454
              ],
              [
                48.7702728,
                31.5145128
              ],
              [
                48.7751083,
                31.5125458
              ],
              [
                48.7821976,
                31.5087241
              ],
              [
                48.7876109,
                31.5056621
              ],
              [
                48.7935465,
                31.5038711
              ],
              [
                48.7993582,
                31.4996438
              ],
              [
                48.7989955,
                31.4994707
              ],
              [
                48.7987384,
                31.4993942
              ],
              [
                48.7977236,
                31.4986997
              ],
              [
                48.7967376,
                31.4980248
              ],
              [
                48.7939072,
                31.4959128
              ],
              [
                48.7916106,
                31.4940761
              ],
              [
                48.7894707,
                31.4917347
              ],
              [
                48.7877083,
                31.4896252
              ],
              [
                48.7859458,
                31.4872857
              ],
              [
                48.7847709,
                31.4852653
              ],
              [
                48.7837561,
                31.4833852
              ],
              [
                48.7832795,
                31.4813679
              ],
              [
                48.7830122,
                31.479715
              ],
              [
                48.7831727,
                31.4782949
              ],
              [
                48.7833901,
                31.4752682
              ],
              [
                48.7840347,
                31.4728824
              ],
              [
                48.7848095,
                31.4707403
              ],
              [
                48.7849465,
                31.4703615
              ],
              [
                48.7852135,
                31.4695385
              ],
              [
                48.7860184,
                31.4679786
              ],
              [
                48.7873534,
                31.466421
              ],
              [
                48.787639,
                31.4660706
              ],
              [
                48.7889594,
                31.4644509
              ],
              [
                48.7909393,
                31.4626181
              ],
              [
                48.7930795,
                31.4608308
              ],
              [
                48.7958602,
                31.4591379
              ],
              [
                48.7994424,
                31.4571679
              ],
              [
                48.8021697,
                31.4552891
              ],
              [
                48.8043595,
                31.4534574
              ],
              [
                48.8070336,
                31.4512596
              ],
              [
                48.8088532,
                31.4493358
              ],
              [
                48.8106726,
                31.4471345
              ],
              [
                48.8107865,
                31.4468291
              ],
              [
                48.8115271,
                31.4448424
              ],
              [
                48.8125458,
                31.4424583
              ],
              [
                48.8123855,
                31.439752
              ],
              [
                48.8117447,
                31.4382844
              ],
              [
                48.8100891,
                31.4368603
              ],
              [
                48.8072569,
                31.4353044
              ],
              [
                48.8068312,
                31.4350705
              ],
              [
                48.8048552,
                31.4337852
              ],
              [
                48.8011704,
                31.4319474
              ],
              [
                48.7983894,
                31.430709
              ],
              [
                48.7950248,
                31.4294673
              ],
              [
                48.7909662,
                31.4281797
              ],
              [
                48.7873877,
                31.4278091
              ],
              [
                48.7843933,
                31.4276243
              ],
              [
                48.7824174,
                31.4278043
              ],
              [
                48.7810822,
                31.4283088
              ],
              [
                48.7809977,
                31.4283438
              ],
              [
                48.7793159,
                31.4290403
              ],
              [
                48.7784615,
                31.4298643
              ],
              [
                48.7776071,
                31.4306906
              ],
              [
                48.7763749,
                31.4317425
              ],
              [
                48.7757874,
                31.432844
              ],
              [
                48.7747727,
                31.4340372
              ],
              [
                48.7744484,
                31.4355491
              ],
              [
                48.7742392,
                31.4365358
              ],
              [
                48.7741279,
                31.437061
              ],
              [
                48.774124,
                31.4384365
              ],
              [
                48.7739638,
                31.4398587
              ],
              [
                48.7738533,
                31.4420576
              ],
              [
                48.7733725,
                31.4433413
              ],
              [
                48.7727852,
                31.4443502
              ],
              [
                48.7715531,
                31.4449015
              ],
              [
                48.7702179,
                31.4450835
              ],
              [
                48.7688292,
                31.4448068
              ],
              [
                48.7662621,
                31.4441171
              ],
              [
                48.763378,
                31.4432437
              ],
              [
                48.7610283,
                31.4424157
              ],
              [
                48.7599602,
                31.4415447
              ],
              [
                48.7588919,
                31.4404888
              ],
              [
                48.7584153,
                31.4392042
              ],
              [
                48.7580414,
                31.4379665
              ],
              [
                48.7578315,
                31.4347564
              ],
              [
                48.7578663,
                31.4331679
              ],
              [
                48.7578888,
                31.4321418
              ],
              [
                48.7576789,
                31.4291143
              ],
              [
                48.7574652,
                31.4265468
              ],
              [
                48.7568816,
                31.4235196
              ],
              [
                48.7559241,
                31.4206752
              ],
              [
                48.7556609,
                31.4189344
              ],
              [
                48.7553444,
                31.416135
              ],
              [
                48.754757,
                31.4133377
              ],
              [
                48.7542709,
                31.4113518
              ],
              [
                48.7541733,
                31.4109531
              ],
              [
                48.7547111,
                31.4079275
              ],
              [
                48.7550887,
                31.4053591
              ],
              [
                48.7555364,
                31.4045106
              ],
              [
                48.7560781,
                31.404524
              ],
              [
                48.7570768,
                31.4044379
              ],
              [
                48.7589942,
                31.4045994
              ],
              [
                48.7612996,
                31.4045799
              ],
              [
                48.7627659,
                31.4044414
              ],
              [
                48.764283,
                31.4041799
              ],
              [
                48.765769,
                31.4037318
              ],
              [
                48.7671146,
                31.4027574
              ],
              [
                48.768105,
                31.4018947
              ],
              [
                48.7689054,
                31.4011727
              ],
              [
                48.7700521,
                31.4000088
              ],
              [
                48.770827,
                31.3990213
              ],
              [
                48.7751312,
                31.3925586
              ],
              [
                48.7781373,
                31.3884354
              ],
              [
                48.7792743,
                31.38673
              ],
              [
                48.7800662,
                31.3855412
              ],
              [
                48.7815201,
                31.3834858
              ],
              [
                48.7831288,
                31.3809989
              ],
              [
                48.7987465,
                31.358945
              ],
              [
                48.8004601,
                31.3562102
              ],
              [
                48.8013805,
                31.3537989
              ],
              [
                48.8018909,
                31.3521221
              ],
              [
                48.8021929,
                31.3505348
              ],
              [
                48.8002687,
                31.3463027
              ],
              [
                48.8198089,
                31.3445477
              ],
              [
                48.8439272,
                31.343155
              ],
              [
                48.8894101,
                31.345947
              ],
              [
                48.9193516,
                31.3465913
              ],
              [
                48.9332752,
                31.3469917
              ],
              [
                48.9528504,
                31.3477659
              ],
              [
                48.985302,
                31.3480596
              ],
              [
                49.000532,
                31.3467482
              ],
              [
                49.0387213,
                31.3489777
              ],
              [
                49.056121,
                31.3497497
              ],
              [
                49.0642119,
                31.3499326
              ],
              [
                49.0764618,
                31.3611599
              ],
              [
                49.0893535,
                31.3729519
              ],
              [
                49.100444,
                31.380765
              ],
              [
                49.1062965,
                31.3850036
              ],
              [
                49.1187304,
                31.392399
              ],
              [
                49.1236037,
                31.3941309
              ],
              [
                49.1322023,
                31.3982867
              ],
              [
                49.1431769,
                31.4034822
              ],
              [
                49.1578349,
                31.406955
              ],
              [
                49.1774845,
                31.4174551
              ],
              [
                49.2048818,
                31.4323742
              ],
              [
                49.216718,
                31.439082
              ],
              [
                49.2068331,
                31.4464985
              ],
              [
                49.2009164,
                31.453998
              ],
              [
                49.1859208,
                31.4704535
              ],
              [
                49.1764528,
                31.4855899
              ],
              [
                49.1763992,
                31.4901246
              ],
              [
                49.1742478,
                31.4950868
              ],
              [
                49.1732159,
                31.4985421
              ],
              [
                49.172755,
                31.5000853
              ],
              [
                49.1725618,
                31.5006328
              ],
              [
                49.1702995,
                31.5048108
              ],
              [
                49.1672897,
                31.5093117
              ],
              [
                49.1658136,
                31.5116088
              ],
              [
                49.1655071,
                31.5120472
              ],
              [
                49.164337,
                31.5137209
              ],
              [
                49.1610716,
                31.5192779
              ],
              [
                49.1598586,
                31.5214818
              ],
              [
                49.157379,
                31.5251557
              ],
              [
                49.1551667,
                31.5286462
              ],
              [
                49.1540071,
                31.5309861
              ],
              [
                49.1525955,
                31.5344295
              ],
              [
                49.1513976,
                31.5386495
              ],
              [
                49.1503107,
                31.5429139
              ],
              [
                49.1494942,
                31.5479083
              ],
              [
                49.1489906,
                31.5515768
              ],
              [
                49.1486916,
                31.5540522
              ],
              [
                49.1485368,
                31.555334
              ],
              [
                49.1485444,
                31.5560196
              ],
              [
                49.1480942,
                31.5603744
              ],
              [
                49.1480103,
                31.5631695
              ],
              [
                49.1478728,
                31.5661938
              ],
              [
                49.1478919,
                31.5683454
              ],
              [
                49.147583,
                31.5700435
              ],
              [
                49.1473312,
                31.5718755
              ],
              [
                49.1470796,
                31.5738924
              ],
              [
                49.1470833,
                31.5746704
              ],
              [
                49.1497306,
                31.5782786
              ],
              [
                49.1535035,
                31.5826629
              ],
              [
                49.1568984,
                31.5865433
              ],
              [
                49.1598091,
                31.5898754
              ],
              [
                49.1628264,
                31.5929339
              ],
              [
                49.1658937,
                31.5957607
              ],
              [
                49.1711617,
                31.599954
              ],
              [
                49.1726376,
                31.6011285
              ],
              [
                49.1763763,
                31.6041035
              ],
              [
                49.1790657,
                31.6061083
              ],
              [
                49.1808966,
                31.6077039
              ],
              [
                49.1825104,
                31.6094385
              ],
              [
                49.1845749,
                31.6118914
              ],
              [
                49.1867752,
                31.6145054
              ],
              [
                49.1888844,
                31.6170488
              ],
              [
                49.1892012,
                31.6174309
              ],
              [
                49.1919594,
                31.6210375
              ],
              [
                49.192466,
                31.6218821
              ],
              [
                49.1940153,
                31.624465
              ],
              [
                49.1948318,
                31.6263843
              ],
              [
                49.1957094,
                31.6288119
              ],
              [
                49.1964228,
                31.63128
              ],
              [
                49.1967088,
                31.6336158
              ],
              [
                49.1967241,
                31.6354021
              ],
              [
                49.1966284,
                31.6366861
              ],
              [
                49.1964263,
                31.6381987
              ],
              [
                49.1958006,
                31.6398496
              ],
              [
                49.1950151,
                31.6419154
              ],
              [
                49.193226,
                31.645541
              ],
              [
                49.1914367,
                31.6490291
              ],
              [
                49.1898574,
                31.6519676
              ],
              [
                49.1881674,
                31.6544016
              ],
              [
                49.1857871,
                31.6575271
              ],
              [
                49.1809158,
                31.6633187
              ],
              [
                49.1790619,
                31.6655698
              ],
              [
                49.1777878,
                31.6667649
              ],
              [
                49.177101,
                31.667639
              ],
              [
                49.1761513,
                31.6692017
              ],
              [
                49.1742973,
                31.6712228
              ],
              [
                49.1731835,
                31.6723727
              ],
              [
                49.169567,
                31.6749976
              ],
              [
                49.1666822,
                31.6776181
              ],
              [
                49.1662751,
                31.6779879
              ],
              [
                49.1652147,
                31.6792287
              ],
              [
                49.1646384,
                31.6807448
              ],
              [
                49.1643258,
                31.6817528
              ],
              [
                49.1643296,
                31.6822106
              ],
              [
                49.1612244,
                31.6817645
              ],
              [
                49.1565666,
                31.6810501
              ],
              [
                49.1533011,
                31.6803759
              ],
              [
                49.149231,
                31.6797036
              ],
              [
                49.143875,
                31.6784418
              ],
              [
                49.1410332,
                31.6776743
              ],
              [
                49.1376076,
                31.6771373
              ],
              [
                49.1341782,
                31.6762347
              ],
              [
                49.1301614,
                31.6752897
              ],
              [
                49.1259309,
                31.6744338
              ],
              [
                49.1218604,
                31.6733975
              ],
              [
                49.1169853,
                31.6722726
              ],
              [
                49.1127549,
                31.6713261
              ],
              [
                49.10997,
                31.6706512
              ],
              [
                49.1079863,
                31.6700603
              ],
              [
                49.1061136,
                31.6696559
              ],
              [
                49.1032754,
                31.6692101
              ],
              [
                49.1007082,
                31.6688088
              ],
              [
                49.0956764,
                31.6683234
              ],
              [
                49.0919343,
                31.667972
              ],
              [
                49.0893631,
                31.6676607
              ],
              [
                49.0875434,
                31.6674395
              ],
              [
                49.0857239,
                31.6670807
              ],
              [
                49.0846521,
                31.6667625
              ],
              [
                49.081707,
                31.6657666
              ],
              [
                49.0786553,
                31.6650915
              ],
              [
                49.0761908,
                31.6646891
              ],
              [
                49.074318,
                31.6646044
              ],
              [
                49.0737936,
                31.6645932
              ],
              [
                49.0707892,
                31.6645286
              ],
              [
                49.068119,
                31.664628
              ],
              [
                49.0656053,
                31.6647297
              ],
              [
                49.0634156,
                31.6648769
              ],
              [
                49.0622406,
                31.6652469
              ],
              [
                49.0609628,
                31.6657551
              ],
              [
                49.0602149,
                31.6660797
              ],
              [
                49.0589371,
                31.6665902
              ],
              [
                49.05542,
                31.668388
              ],
              [
                49.0508316,
                31.6705372
              ],
              [
                49.0495035,
                31.6711592
              ],
              [
                49.0472108,
                31.6723148
              ],
              [
                49.0444946,
                31.6738381
              ],
              [
                49.0412482,
                31.6760027
              ],
              [
                49.0374681,
                31.6786754
              ],
              [
                49.0339545,
                31.6807499
              ],
              [
                49.0308112,
                31.6824558
              ],
              [
                49.0256386,
                31.6847661
              ],
              [
                49.0204126,
                31.68694
              ],
              [
                49.0165711,
                31.6886053
              ],
              [
                49.0126761,
                31.6899473
              ],
              [
                49.0090446,
                31.6909234
              ],
              [
                49.00568,
                31.691624
              ],
              [
                49.0027963,
                31.6919103
              ],
              [
                48.9998837,
                31.6920247
              ],
              [
                48.9974107,
                31.6921099
              ],
              [
                48.9944537,
                31.6921875
              ],
              [
                48.987816,
                31.6925745
              ],
              [
                48.9866181,
                31.6926513
              ],
              [
                48.9802817,
                31.6930574
              ],
              [
                48.9763833,
                31.69307
              ],
              [
                48.9733392,
                31.693042
              ],
              [
                48.9724275,
                31.6931244
              ],
              [
                48.9712485,
                31.6934349
              ],
              [
                48.9698564,
                31.6941591
              ],
              [
                48.9686203,
                31.6949264
              ],
              [
                48.9653932,
                31.6972832
              ],
              [
                48.9608267,
                31.7004077
              ],
              [
                48.9583419,
                31.7020313
              ],
              [
                48.9572258,
                31.7027605
              ],
              [
                48.9528237,
                31.7051072
              ],
              [
                48.9483186,
                31.7072671
              ],
              [
                48.9435998,
                31.7090604
              ],
              [
                48.9378204,
                31.7102906
              ],
              [
                48.9327353,
                31.7112545
              ],
              [
                48.9296342,
                31.7112718
              ],
              [
                48.928192,
                31.7112597
              ],
              [
                48.928356,
                31.710985
              ],
              [
                48.9285736,
                31.7105285
              ],
              [
                48.9286647,
                31.7102746
              ],
              [
                48.9287377,
                31.7100712
              ],
              [
                48.9285279,
                31.7097498
              ],
              [
                48.9279444,
                31.7094224
              ],
              [
                48.9266129,
                31.708952
              ],
              [
                48.9251212,
                31.7081589
              ],
              [
                48.9239539,
                31.7073664
              ],
              [
                48.9232908,
                31.7068223
              ],
              [
                48.9231072,
                31.7066716
              ],
              [
                48.9225769,
                31.7059798
              ],
              [
                48.9222107,
                31.7051508
              ],
              [
                48.9220619,
                31.704048
              ],
              [
                48.9221565,
                31.703291
              ],
              [
                48.9222336,
                31.7026753
              ],
              [
                48.922409,
                31.701253
              ],
              [
                48.922573,
                31.7006582
              ],
              [
                48.9223177,
                31.6995108
              ],
              [
                48.921955,
                31.6983143
              ],
              [
                48.9211121,
                31.6970694
              ],
              [
                48.9198419,
                31.6957273
              ],
              [
                48.9180907,
                31.6941045
              ],
              [
                48.9160768,
                31.692527
              ],
              [
                48.915857,
                31.6923343
              ],
              [
                48.9153901,
                31.691925
              ],
              [
                48.9150773,
                31.6910968
              ],
              [
                48.9148675,
                31.6904553
              ],
              [
                48.9148746,
                31.6903704
              ],
              [
                48.9149284,
                31.6897212
              ],
              [
                48.9150963,
                31.6888039
              ],
              [
                48.9153174,
                31.6880273
              ],
              [
                48.9153786,
                31.6873406
              ],
              [
                48.9153825,
                31.6866507
              ],
              [
                48.9150657,
                31.6863276
              ],
              [
                48.9146423,
                31.6861402
              ],
              [
                48.9140013,
                31.6861343
              ],
              [
                48.9117324,
                31.686522
              ],
              [
                48.9117013,
                31.6865273
              ],
              [
                48.9100914,
                31.6869248
              ],
              [
                48.9089164,
                31.6869597
              ],
              [
                48.9082795,
                31.6867711
              ],
              [
                48.9078026,
                31.6864476
              ],
              [
                48.9074859,
                31.6857547
              ],
              [
                48.9074593,
                31.6847913
              ],
              [
                48.9074479,
                31.6843786
              ],
              [
                48.9076196,
                31.6831434
              ],
              [
                48.9080619,
                31.6812205
              ],
              [
                48.9082337,
                31.6803056
              ],
              [
                48.9082069,
                31.6774617
              ],
              [
                48.9082222,
                31.6757641
              ],
              [
                48.9078597,
                31.6743398
              ],
              [
                48.9074401,
                31.6736497
              ],
              [
                48.90691,
                31.6732306
              ],
              [
                48.9061125,
                31.6728567
              ],
              [
                48.9051551,
                31.6723449
              ],
              [
                48.905025,
                31.6723193
              ],
              [
                48.9039308,
                31.6721038
              ],
              [
                48.9028624,
                31.6718202
              ],
              [
                48.9023856,
                31.6714944
              ],
              [
                48.9021225,
                31.6709872
              ],
              [
                48.9017619,
                31.6704246
              ],
              [
                48.9016494,
                31.6702489
              ],
              [
                48.9011232,
                31.6695096
              ],
              [
                48.9005432,
                31.6685418
              ],
              [
                48.9000168,
                31.6679874
              ],
              [
                48.899433,
                31.6675697
              ],
              [
                48.8987427,
                31.6672877
              ],
              [
                48.8979416,
                31.6670513
              ],
              [
                48.8966102,
                31.6665829
              ],
              [
                48.8958022,
                31.6663793
              ],
              [
                48.8952791,
                31.6662475
              ],
              [
                48.8936311,
                31.6654559
              ],
              [
                48.893154,
                31.6650398
              ],
              [
                48.8930015,
                31.6643947
              ],
              [
                48.8930091,
                31.663432
              ],
              [
                48.8935584,
                31.6620611
              ],
              [
                48.8936487,
                31.661876
              ],
              [
                48.894539,
                31.6600524
              ],
              [
                48.8949774,
                31.6588172
              ],
              [
                48.8950424,
                31.6574427
              ],
              [
                48.8949434,
                31.6565707
              ],
              [
                48.894577,
                31.6559265
              ],
              [
                48.8935737,
                31.6547239
              ],
              [
                48.8930436,
                31.6541244
              ],
              [
                48.8924064,
                31.6538433
              ],
              [
                48.8916799,
                31.6537477
              ],
              [
                48.8912887,
                31.6536963
              ],
              [
                48.8886185,
                31.6533973
              ],
              [
                48.8865433,
                31.6528736
              ],
              [
                48.8853187,
                31.6523122
              ],
              [
                48.8844185,
                31.6515712
              ],
              [
                48.8835717,
                31.650786
              ],
              [
                48.8834191,
                31.6502332
              ],
              [
                48.882515,
                31.6497673
              ],
              [
                48.882097,
                31.6497626
              ],
              [
                48.8816604,
                31.6497598
              ],
              [
                48.8809089,
                31.6501645
              ],
              [
                48.8801574,
                31.6507541
              ],
              [
                48.8789178,
                31.6518
              ],
              [
                48.8775712,
                31.6528419
              ],
              [
                48.8765564,
                31.6531994
              ],
              [
                48.8760195,
                31.6532639
              ],
              [
                48.8757658,
                31.6532944
              ],
              [
                48.8751106,
                31.6533715
              ],
              [
                48.8734015,
                31.6533114
              ],
              [
                48.8712694,
                31.6532916
              ],
              [
                48.8691825,
                31.6536401
              ],
              [
                48.8677331,
                31.6543149
              ],
              [
                48.8669244,
                31.6552259
              ],
              [
                48.8663198,
                31.6557088
              ],
              [
                48.8658487,
                31.6560851
              ],
              [
                48.8651428,
                31.6569977
              ],
              [
                48.8641206,
                31.6579051
              ],
              [
                48.8635293,
                31.6583146
              ],
              [
                48.862671,
                31.6586272
              ],
              [
                48.8616563,
                31.658847
              ],
              [
                48.8603746,
                31.6589269
              ],
              [
                48.8582917,
                31.6589078
              ],
              [
                48.8568496,
                31.6587122
              ],
              [
                48.8547744,
                31.6581903
              ],
              [
                48.8520088,
                31.6568833
              ],
              [
                48.849083,
                31.6558959
              ],
              [
                48.8469628,
                31.6554288
              ],
              [
                48.8466412,
                31.6553579
              ],
              [
                48.8460465,
                31.6552269
              ],
              [
                48.8448205,
                31.6551489
              ],
              [
                48.8435364,
                31.6550672
              ],
              [
                48.8411404,
                31.6550457
              ],
              [
                48.840973,
                31.6550442
              ],
              [
                48.8383066,
                31.6549291
              ],
              [
                48.8358499,
                31.6547251
              ],
              [
                48.8340913,
                31.6545261
              ],
              [
                48.832016,
                31.6540038
              ],
              [
                48.8305741,
                31.6537629
              ],
              [
                48.829567,
                31.6531572
              ],
              [
                48.8288148,
                31.6522913
              ],
              [
                48.828724,
                31.6521868
              ],
              [
                48.8281355,
                31.6514008
              ],
              [
                48.8279305,
                31.6511271
              ],
              [
                48.8277246,
                31.6503907
              ],
              [
                48.827362,
                31.6495638
              ],
              [
                48.827366,
                31.6491917
              ],
              [
                48.8273733,
                31.6485087
              ],
              [
                48.8274843,
                31.6477755
              ],
              [
                48.8279763,
                31.646909
              ],
              [
                48.8291093,
                31.6456363
              ],
              [
                48.8303528,
                31.6440881
              ],
              [
                48.8311653,
                31.6431796
              ],
              [
                48.832508,
                31.6421359
              ],
              [
                48.8344498,
                31.640365
              ],
              [
                48.8359031,
                31.6389556
              ],
              [
                48.8375245,
                31.6371814
              ],
              [
                48.8386041,
                31.6360001
              ],
              [
                48.8392028,
                31.634858
              ],
              [
                48.8395347,
                31.6338535
              ],
              [
                48.8393823,
                31.6329354
              ],
              [
                48.8391799,
                31.6320165
              ],
              [
                48.8383369,
                31.6308185
              ],
              [
                48.837284,
                31.6292966
              ],
              [
                48.8362352,
                31.6275471
              ],
              [
                48.8349648,
                31.6263891
              ],
              [
                48.8341752,
                31.6254648
              ],
              [
                48.8320999,
                31.6244848
              ],
              [
                48.8295556,
                31.6228113
              ],
              [
                48.8285561,
                31.6216127
              ],
              [
                48.8271333,
                31.6197215
              ],
              [
                48.8257597,
                31.6183362
              ],
              [
                48.8240203,
                31.6162118
              ],
              [
                48.8218537,
                31.6141748
              ],
              [
                48.8204804,
                31.6125594
              ],
              [
                48.8193788,
                31.6115623
              ],
              [
                48.8190002,
                31.6112196
              ],
              [
                48.81736,
                31.6099672
              ],
              [
                48.8160323,
                31.6092229
              ],
              [
                48.8141174,
                31.6085204
              ],
              [
                48.8113519,
                31.6077628
              ],
              [
                48.8092728,
                31.6074227
              ],
              [
                48.806015,
                31.6075336
              ],
              [
                48.8034515,
                31.6077421
              ],
              [
                48.8016854,
                31.608325
              ],
              [
                48.8007251,
                31.6088127
              ],
              [
                48.8001824,
                31.6090883
              ],
              [
                48.7994803,
                31.6100932
              ],
              [
                48.7993661,
                31.6105963
              ],
              [
                48.7995718,
                31.6112853
              ],
              [
                48.7998885,
                31.6118364
              ],
              [
                48.8004724,
                31.6121622
              ],
              [
                48.8007271,
                31.612267
              ],
              [
                48.8020669,
                31.6128187
              ],
              [
                48.8032836,
                31.6135161
              ],
              [
                48.8047142,
                31.6146727
              ],
              [
                48.8057173,
                31.6158286
              ],
              [
                48.8060264,
                31.6167471
              ],
              [
                48.8061256,
                31.6173892
              ],
              [
                48.8060152,
                31.6179848
              ],
              [
                48.80595,
                31.618809
              ],
              [
                48.8057823,
                31.619584
              ],
              [
                48.8054543,
                31.6204082
              ],
              [
                48.8048019,
                31.6214567
              ],
              [
                48.8036118,
                31.6229132
              ],
              [
                48.802803,
                31.6237313
              ],
              [
                48.8018914,
                31.6242725
              ],
              [
                48.8004988,
                31.6248122
              ],
              [
                48.7988357,
                31.6253022
              ],
              [
                48.7970198,
                31.6255617
              ],
              [
                48.7951468,
                31.6259127
              ],
              [
                48.7910308,
                31.626518
              ],
              [
                48.788143,
                31.6268603
              ],
              [
                48.7861136,
                31.6270258
              ],
              [
                48.784836,
                31.6267849
              ],
              [
                48.7838784,
                31.6265496
              ],
              [
                48.7828674,
                31.6261735
              ],
              [
                48.7821806,
                31.6256182
              ],
              [
                48.7813301,
                31.6251073
              ],
              [
                48.7809677,
                31.624278
              ],
              [
                48.7805977,
                31.6237259
              ],
              [
                48.7804033,
                31.6221194
              ],
              [
                48.7804052,
                31.6219132
              ],
              [
                48.7804146,
                31.6208817
              ],
              [
                48.7802696,
                31.6196908
              ],
              [
                48.7799606,
                31.6184047
              ],
              [
                48.7791709,
                31.6174823
              ],
              [
                48.7782248,
                31.6162821
              ],
              [
                48.7770613,
                31.6151254
              ],
              [
                48.7761114,
                31.6142948
              ],
              [
                48.7753142,
                31.6138751
              ],
              [
                48.7738228,
                31.6137228
              ],
              [
                48.7727011,
                31.6136221
              ],
              [
                48.771633,
                31.6138447
              ],
              [
                48.7706681,
                31.6141571
              ],
              [
                48.7698098,
                31.6145164
              ],
              [
                48.7685203,
                31.6153304
              ],
              [
                48.7675025,
                31.6161874
              ],
              [
                48.7670669,
                31.6165541
              ],
              [
                48.7650758,
                31.6177729
              ],
              [
                48.7639623,
                31.6185188
              ],
              [
                48.7627105,
                31.6193572
              ],
              [
                48.7604521,
                31.6208486
              ],
              [
                48.7587815,
                31.6222105
              ],
              [
                48.7570571,
                31.6238443
              ],
              [
                48.7552758,
                31.6255695
              ],
              [
                48.7546271,
                31.6264825
              ],
              [
                48.7540778,
                31.6276679
              ],
              [
                48.7538034,
                31.6284906
              ],
              [
                48.7536941,
                31.6292329
              ],
              [
                48.7536888,
                31.6292687
              ],
              [
                48.7536502,
                31.6292787
              ],
              [
                48.7499518,
                31.6302356
              ],
              [
                48.7468695,
                31.6303198
              ],
              [
                48.7432823,
                31.6304177
              ],
              [
                48.7358399,
                31.6303513
              ],
              [
                48.7270621,
                31.6294557
              ],
              [
                48.7260171,
                31.6293184
              ],
              [
                48.7163581,
                31.6280493
              ],
              [
                48.7111169,
                31.627394
              ],
              [
                48.7080116,
                31.6271556
              ],
              [
                48.7029267,
                31.6271408
              ],
              [
                48.6998749,
                31.6270859
              ],
              [
                48.697895,
                31.6270817
              ],
              [
                48.6958083,
                31.6273981
              ],
              [
                48.693451,
                31.6277118
              ],
              [
                48.6918983,
                31.6280287
              ],
              [
                48.6910439,
                31.6280267
              ],
              [
                48.6906166,
                31.6279333
              ],
              [
                48.6904029,
                31.6269712
              ],
              [
                48.6908876,
                31.6213273
              ],
              [
                48.6907312,
                31.6167383
              ],
              [
                48.6914862,
                31.6107317
              ],
              [
                48.6920815,
                31.6058699
              ],
              [
                48.6926194,
                31.6010996
              ],
              [
                48.6926416,
                31.6009325
              ],
              [
                48.6929434,
                31.598668
              ],
              [
                48.6931036,
                31.597981
              ],
              [
                48.6965829,
                31.5969818
              ],
              [
                48.7028425,
                31.5951645
              ],
              [
                48.7055389,
                31.5944822
              ],
              [
                48.7084084,
                31.593756
              ],
              [
                48.7119942,
                31.5935813
              ],
              [
                48.7155267,
                31.5923548
              ],
              [
                48.7168657,
                31.5917158
              ],
              [
                48.7172395,
                31.590983
              ],
              [
                48.7175596,
                31.5897914
              ],
              [
                48.7179375,
                31.5835975
              ],
              [
                48.718155,
                31.5796059
              ],
              [
                48.7185289,
                31.5776802
              ],
              [
                48.7194443,
                31.5710765
              ],
              [
                48.7196242,
                31.5689694
              ],
              [
                48.7200356,
                31.564149
              ],
              [
                48.7204665,
                31.5607542
              ],
              [
                48.7207872,
                31.5583699
              ],
              [
                48.720791,
                31.5563068
              ],
              [
                48.7206842,
                31.5554323
              ],
              [
                48.7196161,
                31.5519453
              ],
              [
                48.7178535,
                31.5450119
              ],
              [
                48.7170563,
                31.5419357
              ],
              [
                48.7162551,
                31.5356485
              ],
              [
                48.7158851,
                31.5328031
              ],
              [
                48.71551,
                31.5312446
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554940,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بندر ماهشهر",
          "name:en": "Bandar-e-Mahshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279126",
          "wikipedia": "en:Mahshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.9599104,
                30.770994
              ],
              [
                48.9588028,
                30.767316
              ],
              [
                48.9572136,
                30.7632049
              ],
              [
                48.954833,
                30.7556475
              ],
              [
                48.9515488,
                30.7469156
              ],
              [
                48.9447324,
                30.7269978
              ],
              [
                48.9492188,
                30.7012494
              ],
              [
                48.9486621,
                30.6959608
              ],
              [
                48.9483856,
                30.69319
              ],
              [
                48.946439,
                30.6834701
              ],
              [
                48.9433855,
                30.6709705
              ],
              [
                48.9278295,
                30.6395731
              ],
              [
                48.9242161,
                30.636243
              ],
              [
                48.9228294,
                30.6345823
              ],
              [
                48.9228294,
                30.6343026
              ],
              [
                48.9192161,
                30.6276334
              ],
              [
                48.9189395,
                30.6254042
              ],
              [
                48.919216,
                30.6231841
              ],
              [
                48.9228294,
                30.6162442
              ],
              [
                48.9239395,
                30.6151251
              ],
              [
                48.9569958,
                30.582348
              ],
              [
                48.957829,
                30.5815177
              ],
              [
                48.9644955,
                30.5762385
              ],
              [
                48.9644955,
                30.5762384
              ],
              [
                48.9647756,
                30.5756879
              ],
              [
                48.9653288,
                30.5754082
              ],
              [
                48.9733855,
                30.5667989
              ],
              [
                48.9792189,
                30.5548507
              ],
              [
                48.9978318,
                30.5170752
              ],
              [
                48.9980272,
                30.5165095
              ],
              [
                48.9980991,
                30.5163015
              ],
              [
                49.0008314,
                30.5083913
              ],
              [
                49.0149354,
                30.4472364
              ],
              [
                49.0290696,
                30.3859119
              ],
              [
                49.0431658,
                30.324714
              ],
              [
                49.0570309,
                30.2644821
              ],
              [
                49.085052,
                30.1426416
              ],
              [
                49.1141237,
                30.0160739
              ],
              [
                49.1424695,
                29.8925109
              ],
              [
                49.1629583,
                29.8031143
              ],
              [
                49.4643006,
                29.7895783
              ],
              [
                49.4813096,
                30.0618104
              ],
              [
                49.4865876,
                30.1461338
              ],
              [
                49.486537,
                30.250757
              ],
              [
                49.4864437,
                30.2694165
              ],
              [
                49.4846687,
                30.2814702
              ],
              [
                49.483736,
                30.2904289
              ],
              [
                49.4832164,
                30.2983573
              ],
              [
                49.4819177,
                30.3052418
              ],
              [
                49.4805868,
                30.3141957
              ],
              [
                49.4792663,
                30.3224598
              ],
              [
                49.4783058,
                30.3331429
              ],
              [
                49.4799446,
                30.3435031
              ],
              [
                49.4826016,
                30.3493586
              ],
              [
                49.4858448,
                30.3568095
              ],
              [
                49.491205,
                30.3656084
              ],
              [
                49.4920192,
                30.3722368
              ],
              [
                49.4921863,
                30.3812404
              ],
              [
                49.4911036,
                30.392083
              ],
              [
                49.4911254,
                30.394911
              ],
              [
                49.4911342,
                30.3960612
              ],
              [
                49.4911347,
                30.3961148
              ],
              [
                49.4911928,
                30.4036559
              ],
              [
                49.4915522,
                30.4086819
              ],
              [
                49.4916045,
                30.4190939
              ],
              [
                49.491462,
                30.4283587
              ],
              [
                49.491967,
                30.4352481
              ],
              [
                49.4912541,
                30.4418587
              ],
              [
                49.4917999,
                30.4461011
              ],
              [
                49.4920158,
                30.4519282
              ],
              [
                49.4928976,
                30.4573074
              ],
              [
                49.4926068,
                30.4761884
              ],
              [
                49.4932532,
                30.4871382
              ],
              [
                49.4940448,
                30.4941535
              ],
              [
                49.4943209,
                30.4966001
              ],
              [
                49.494493,
                30.4981244
              ],
              [
                49.4950891,
                30.50108
              ],
              [
                49.4960279,
                30.5029337
              ],
              [
                49.4976038,
                30.5052972
              ],
              [
                49.4994849,
                30.5071481
              ],
              [
                49.5327471,
                30.5398596
              ],
              [
                49.5336347,
                30.5405822
              ],
              [
                49.5346311,
                30.5412707
              ],
              [
                49.5356263,
                30.5420594
              ],
              [
                49.5364589,
                30.542799
              ],
              [
                49.5377203,
                30.5439911
              ],
              [
                49.5386307,
                30.5449908
              ],
              [
                49.5392736,
                30.5456812
              ],
              [
                49.5398091,
                30.5470248
              ],
              [
                49.5404385,
                30.5486092
              ],
              [
                49.5406045,
                30.5499532
              ],
              [
                49.5405589,
                30.5530025
              ],
              [
                49.5406998,
                30.5566682
              ],
              [
                49.5406579,
                30.5594635
              ],
              [
                49.5406199,
                30.5620046
              ],
              [
                49.5404331,
                30.5646711
              ],
              [
                49.5402368,
                30.5679729
              ],
              [
                49.5401931,
                30.5708952
              ],
              [
                49.5400063,
                30.5735618
              ],
              [
                49.5399092,
                30.5804506
              ],
              [
                49.5367393,
                30.5804624
              ],
              [
                49.5354332,
                30.5805047
              ],
              [
                49.5332334,
                30.5805758
              ],
              [
                49.531723,
                30.5806247
              ],
              [
                49.5277596,
                30.5805055
              ],
              [
                49.5159748,
                30.5811888
              ],
              [
                49.5154534,
                30.5812566
              ],
              [
                49.5138701,
                30.5813107
              ],
              [
                49.5130234,
                30.5813146
              ],
              [
                49.510643,
                30.5808182
              ],
              [
                49.508213,
                30.5804114
              ],
              [
                49.5050928,
                30.5797351
              ],
              [
                49.502556,
                30.5790518
              ],
              [
                49.500025,
                30.5783347
              ],
              [
                49.4975243,
                30.5777397
              ],
              [
                49.4946558,
                30.577278
              ],
              [
                49.4917374,
                30.5767728
              ],
              [
                49.489292,
                30.5764038
              ],
              [
                49.4880714,
                30.5764032
              ],
              [
                49.4872265,
                30.5764031
              ],
              [
                49.4869042,
                30.5764031
              ],
              [
                49.4847793,
                30.5761258
              ],
              [
                49.4844242,
                30.5760393
              ],
              [
                49.4827079,
                30.5756212
              ],
              [
                49.4813804,
                30.5754366
              ],
              [
                49.4794159,
                30.5753888
              ],
              [
                49.4771346,
                30.5749291
              ],
              [
                49.4752199,
                30.5747443
              ],
              [
                49.4733621,
                30.5746052
              ],
              [
                49.4712408,
                30.5741923
              ],
              [
                49.4696998,
                30.5738697
              ],
              [
                49.4690093,
                30.5736857
              ],
              [
                49.4677352,
                30.5736842
              ],
              [
                49.4669379,
                30.5736387
              ],
              [
                49.4651871,
                30.5733159
              ],
              [
                49.4624788,
                30.5726253
              ],
              [
                49.4607774,
                30.5721202
              ],
              [
                49.4592896,
                30.5715229
              ],
              [
                49.4572716,
                30.5707885
              ],
              [
                49.4557838,
                30.5700965
              ],
              [
                49.454136,
                30.5693168
              ],
              [
                49.4517973,
                30.5681206
              ],
              [
                49.4496727,
                30.5667871
              ],
              [
                49.4474412,
                30.5658222
              ],
              [
                49.4457397,
                30.5649042
              ],
              [
                49.4434548,
                30.5640288
              ],
              [
                49.4408531,
                30.5632014
              ],
              [
                49.4392587,
                30.5629703
              ],
              [
                49.4372941,
                30.5626039
              ],
              [
                49.4349595,
                30.5621902
              ],
              [
                49.4319343,
                30.5622801
              ],
              [
                49.4298968,
                30.5624098
              ],
              [
                49.4297599,
                30.5624185
              ],
              [
                49.4283892,
                30.5623195
              ],
              [
                49.4278487,
                30.5622804
              ],
              [
                49.426201,
                30.5621883
              ],
              [
                49.4242898,
                30.5620051
              ],
              [
                49.422966,
                30.562095
              ],
              [
                49.4215318,
                30.5620957
              ],
              [
                49.4199372,
                30.5620042
              ],
              [
                49.4176025,
                30.5618202
              ],
              [
                49.4166488,
                30.5615875
              ],
              [
                49.4158517,
                30.5613139
              ],
              [
                49.4148408,
                30.5609904
              ],
              [
                49.4140063,
                30.5608753
              ],
              [
                49.4135133,
                30.5608073
              ],
              [
                49.4119225,
                30.5605781
              ],
              [
                49.409958,
                30.5604391
              ],
              [
                49.4086838,
                30.5604393
              ],
              [
                49.4075163,
                30.5602085
              ],
              [
                49.4054452,
                30.5599328
              ],
              [
                49.4039077,
                30.5599794
              ],
              [
                49.4019433,
                30.5600703
              ],
              [
                49.3988113,
                30.5601153
              ],
              [
                49.3970604,
                30.5604388
              ],
              [
                49.3952599,
                30.5609422
              ],
              [
                49.393135,
                30.5611257
              ],
              [
                49.390854,
                30.5615848
              ],
              [
                49.3884125,
                30.5621365
              ],
              [
                49.3862914,
                30.5626403
              ],
              [
                49.3836938,
                30.5633275
              ],
              [
                49.3815154,
                30.5638779
              ],
              [
                49.3803521,
                30.5644769
              ],
              [
                49.3777505,
                30.5655791
              ],
              [
                49.3757897,
                30.5664049
              ],
              [
                49.3747292,
                30.5671834
              ],
              [
                49.3734549,
                30.5676907
              ],
              [
                49.3721276,
                30.5681929
              ],
              [
                49.3708571,
                30.5682402
              ],
              [
                49.3696862,
                30.568239
              ],
              [
                49.3688928,
                30.5681028
              ],
              [
                49.3677217,
                30.5677791
              ],
              [
                49.3654404,
                30.5673648
              ],
              [
                49.3625756,
                30.5670897
              ],
              [
                49.3606644,
                30.5667205
              ],
              [
                49.3586408,
                30.5663189
              ],
              [
                49.3581163,
                30.5662148
              ],
              [
                49.3542404,
                30.5658478
              ],
              [
                49.3512153,
                30.5654802
              ],
              [
                49.3479232,
                30.5652039
              ],
              [
                49.3441543,
                30.5648357
              ],
              [
                49.3412895,
                30.5643775
              ],
              [
                49.3383674,
                30.5641462
              ],
              [
                49.3367766,
                30.563641
              ],
              [
                49.3332711,
                30.5629511
              ],
              [
                49.3313598,
                30.5626762
              ],
              [
                49.3288116,
                30.5624
              ],
              [
                49.3272209,
                30.5624449
              ],
              [
                49.3263207,
                30.562995
              ],
              [
                49.3264408,
                30.5633307
              ],
              [
                49.3267973,
                30.5643273
              ],
              [
                49.3275946,
                30.5661645
              ],
              [
                49.3280474,
                30.5675069
              ],
              [
                49.3281822,
                30.5679065
              ],
              [
                49.3290861,
                30.5696075
              ],
              [
                49.3298301,
                30.5716718
              ],
              [
                49.3307343,
                30.5730954
              ],
              [
                49.3318519,
                30.5747945
              ],
              [
                49.333233,
                30.5767226
              ],
              [
                49.3343467,
                30.5779639
              ],
              [
                49.335518,
                30.5794765
              ],
              [
                49.3365288,
                30.5803961
              ],
              [
                49.3368336,
                30.5806362
              ],
              [
                49.3376959,
                30.5813155
              ],
              [
                49.3388672,
                30.5825101
              ],
              [
                49.3396111,
                30.5833361
              ],
              [
                49.3401412,
                30.5840691
              ],
              [
                49.3407784,
                30.5854012
              ],
              [
                49.3414727,
                30.5863664
              ],
              [
                49.3418962,
                30.5877905
              ],
              [
                49.3423932,
                30.5889418
              ],
              [
                49.3425903,
                30.5893985
              ],
              [
                49.3433343,
                30.5909124
              ],
              [
                49.3445053,
                30.5929798
              ],
              [
                49.3455162,
                30.5944948
              ],
              [
                49.3462066,
                30.5958704
              ],
              [
                49.3466338,
                30.5965615
              ],
              [
                49.3474312,
                30.5974332
              ],
              [
                49.3484381,
                30.5983076
              ],
              [
                49.3490087,
                30.5988226
              ],
              [
                49.3495559,
                30.5993165
              ],
              [
                49.3507233,
                30.6002808
              ],
              [
                49.3516807,
                30.6013824
              ],
              [
                49.3526915,
                30.6023019
              ],
              [
                49.3534888,
                30.6033585
              ],
              [
                49.3544998,
                30.6046908
              ],
              [
                49.3551368,
                30.60561
              ],
              [
                49.3557242,
                30.6068039
              ],
              [
                49.3564681,
                30.6084575
              ],
              [
                49.3572158,
                30.6096985
              ],
              [
                49.3578531,
                30.6110282
              ],
              [
                49.3582269,
                30.6119938
              ],
              [
                49.358761,
                30.6130493
              ],
              [
                49.359024,
                30.613921
              ],
              [
                49.3592378,
                30.6150244
              ],
              [
                49.3598252,
                30.6162633
              ],
              [
                49.3602523,
                30.6174573
              ],
              [
                49.3609964,
                30.619111
              ],
              [
                49.3615304,
                30.6198034
              ],
              [
                49.362114,
                30.6209046
              ],
              [
                49.3628083,
                30.6232478
              ],
              [
                49.3633422,
                30.625404
              ],
              [
                49.3636132,
                30.6279764
              ],
              [
                49.36372,
                30.630134
              ],
              [
                49.3637237,
                30.6320625
              ],
              [
                49.3636208,
                30.6342671
              ],
              [
                49.3631477,
                30.6369767
              ],
              [
                49.3626174,
                30.6391331
              ],
              [
                49.3615609,
                30.6422549
              ],
              [
                49.3611907,
                30.6437704
              ],
              [
                49.3609809,
                30.6455158
              ],
              [
                49.3607675,
                30.6471663
              ],
              [
                49.3608779,
                30.6490488
              ],
              [
                49.3610381,
                30.6510717
              ],
              [
                49.3615724,
                30.653228
              ],
              [
                49.3619997,
                30.6549272
              ],
              [
                49.362961,
                30.6570414
              ],
              [
                49.3565386,
                30.654657
              ],
              [
                49.3558922,
                30.654417
              ],
              [
                49.3497771,
                30.6523006
              ],
              [
                49.3446771,
                30.6505486
              ],
              [
                49.3397331,
                30.6488007
              ],
              [
                49.329052,
                30.6450731
              ],
              [
                49.3237195,
                30.6431837
              ],
              [
                49.3220368,
                30.6425874
              ],
              [
                49.3162956,
                30.6406998
              ],
              [
                49.3110886,
                30.6388121
              ],
              [
                49.3043938,
                30.6364221
              ],
              [
                49.3041544,
                30.6363446
              ],
              [
                49.2995606,
                30.6348568
              ],
              [
                49.2990304,
                30.6351769
              ],
              [
                49.2972757,
                30.6365523
              ],
              [
                49.294941,
                30.6384795
              ],
              [
                49.2935067,
                30.639762
              ],
              [
                49.2923928,
                30.641139
              ],
              [
                49.2913284,
                30.642652
              ],
              [
                49.2903746,
                30.6442115
              ],
              [
                49.2894707,
                30.6455867
              ],
              [
                49.2891541,
                30.6464576
              ],
              [
                49.2886237,
                30.6476528
              ],
              [
                49.2883033,
                30.648844
              ],
              [
                49.2878799,
                30.6509991
              ],
              [
                49.287403,
                30.6531558
              ],
              [
                49.2868727,
                30.6553569
              ],
              [
                49.2868195,
                30.6569169
              ],
              [
                49.2862892,
                30.658615
              ],
              [
                49.2859192,
                30.6604957
              ],
              [
                49.2857095,
                30.662471
              ],
              [
                49.2856561,
                30.6642588
              ],
              [
                49.2855491,
                30.6660482
              ],
              [
                49.2848588,
                30.6688471
              ],
              [
                49.2842751,
                30.67137
              ],
              [
                49.2837447,
                30.6736635
              ],
              [
                49.2831612,
                30.6765541
              ],
              [
                49.2823145,
                30.6808665
              ],
              [
                49.2822476,
                30.6811727
              ],
              [
                49.281624,
                30.6840308
              ],
              [
                49.2813605,
                30.6863256
              ],
              [
                49.2812003,
                30.6888495
              ],
              [
                49.2809372,
                30.6909571
              ],
              [
                49.2806703,
                30.6927466
              ],
              [
                49.2806167,
                30.6950871
              ],
              [
                49.2800902,
                30.7004548
              ],
              [
                49.27977,
                30.7040321
              ],
              [
                49.2792396,
                30.7085292
              ],
              [
                49.2788696,
                30.7113751
              ],
              [
                49.2783928,
                30.7142647
              ],
              [
                49.2778626,
                30.7168311
              ],
              [
                49.2773818,
                30.7189877
              ],
              [
                49.2765885,
                30.7218303
              ],
              [
                49.2759515,
                30.7238494
              ],
              [
                49.2752074,
                30.7265099
              ],
              [
                49.273613,
                30.7294884
              ],
              [
                49.2722815,
                30.7319178
              ],
              [
                49.2709009,
                30.7341165
              ],
              [
                49.2696761,
                30.7359045
              ],
              [
                49.2691459,
                30.7369146
              ],
              [
                49.2688789,
                30.7381064
              ],
              [
                49.2686157,
                30.7391156
              ],
              [
                49.2682953,
                30.7401691
              ],
              [
                49.2682419,
                30.7415464
              ],
              [
                49.2682418,
                30.7430124
              ],
              [
                49.2682417,
                30.744528
              ],
              [
                49.2682953,
                30.7462248
              ],
              [
                49.2687225,
                30.7479243
              ],
              [
                49.2693099,
                30.749026
              ],
              [
                49.2698284,
                30.7501697
              ],
              [
                49.2698937,
                30.7503126
              ],
              [
                49.2706644,
                30.7517213
              ],
              [
                49.2718849,
                30.7535103
              ],
              [
                49.2734756,
                30.7563484
              ],
              [
                49.2751235,
                30.7594197
              ],
              [
                49.2766647,
                30.7622594
              ],
              [
                49.2779922,
                30.7658812
              ],
              [
                49.2793199,
                30.7690428
              ],
              [
                49.2801209,
                30.7712412
              ],
              [
                49.2806511,
                30.7734427
              ],
              [
                49.2818794,
                30.7788043
              ],
              [
                49.2827301,
                30.7817386
              ],
              [
                49.2831575,
                30.783526
              ],
              [
                49.2834219,
                30.7842347
              ],
              [
                49.2836877,
                30.7849471
              ],
              [
                49.2842218,
                30.7860007
              ],
              [
                49.284752,
                30.7871467
              ],
              [
                49.2854957,
                30.787743
              ],
              [
                49.2862931,
                30.7886128
              ],
              [
                49.2864098,
                30.7887502
              ],
              [
                49.2868766,
                30.7892994
              ],
              [
                49.2870367,
                30.7898969
              ],
              [
                49.287037,
                30.7901247
              ],
              [
                49.2868768,
                30.7903527
              ],
              [
                49.2865602,
                30.790583
              ],
              [
                49.2857131,
                30.7906756
              ],
              [
                49.284176,
                30.7906755
              ],
              [
                49.2831688,
                30.7907705
              ],
              [
                49.2820107,
                30.7909632
              ],
              [
                49.281788,
                30.7910003
              ],
              [
                49.2813644,
                30.7911841
              ],
              [
                49.281208,
                30.7918248
              ],
              [
                49.2812616,
                30.7921007
              ],
              [
                49.2815285,
                30.7927876
              ],
              [
                49.2823752,
                30.7937484
              ],
              [
                49.2832794,
                30.794252
              ],
              [
                49.2836233,
                30.7945357
              ],
              [
                49.2844467,
                30.7952147
              ],
              [
                49.2855074,
                30.7959933
              ],
              [
                49.2864648,
                30.7970457
              ],
              [
                49.2872583,
                30.7976426
              ],
              [
                49.2875786,
                30.7986054
              ],
              [
                49.287262,
                30.7992936
              ],
              [
                49.2868918,
                30.799706
              ],
              [
                49.2864152,
                30.7999342
              ],
              [
                49.2852478,
                30.8002571
              ],
              [
                49.2841339,
                30.8005784
              ],
              [
                49.2837886,
                30.8006308
              ],
              [
                49.282917,
                30.800763
              ],
              [
                49.2817498,
                30.8009483
              ],
              [
                49.2809561,
                30.8011317
              ],
              [
                49.2805329,
                30.8015907
              ],
              [
                49.2804259,
                30.802002
              ],
              [
                49.2804259,
                30.8026448
              ],
              [
                49.2806931,
                30.8031942
              ],
              [
                49.2809563,
                30.8034683
              ],
              [
                49.282074,
                30.8040177
              ],
              [
                49.2831345,
                30.8043836
              ],
              [
                49.2841416,
                30.8047961
              ],
              [
                49.2852555,
                30.8051176
              ],
              [
                49.2876931,
                30.8054814
              ],
              [
                49.288807,
                30.8056179
              ],
              [
                49.2896042,
                30.8060299
              ],
              [
                49.2919386,
                30.8071297
              ],
              [
                49.2927359,
                30.8073116
              ],
              [
                49.2934227,
                30.8073568
              ],
              [
                49.2936897,
                30.8072182
              ],
              [
                49.2936896,
                30.8068528
              ],
              [
                49.2936897,
                30.8064401
              ],
              [
                49.2933158,
                30.8059345
              ],
              [
                49.2924652,
                30.8051113
              ],
              [
                49.2917131,
                30.8042907
              ],
              [
                49.291668,
                30.8042415
              ],
              [
                49.2907142,
                30.8029569
              ],
              [
                49.2901268,
                30.80195
              ],
              [
                49.2899665,
                30.8009871
              ],
              [
                49.2899665,
                30.8002518
              ],
              [
                49.2901268,
                30.7998863
              ],
              [
                49.2901763,
                30.7990615
              ],
              [
                49.2903863,
                30.7974561
              ],
              [
                49.2905959,
                30.7960809
              ],
              [
                49.2907561,
                30.795165
              ],
              [
                49.2910728,
                30.794982
              ],
              [
                49.2912827,
                30.7948427
              ],
              [
                49.2914962,
                30.7948432
              ],
              [
                49.2916085,
                30.7948644
              ],
              [
                49.2919731,
                30.794933
              ],
              [
                49.2924499,
                30.7952077
              ],
              [
                49.294098,
                30.7964924
              ],
              [
                49.2949982,
                30.7972237
              ],
              [
                49.2960091,
                30.7977738
              ],
              [
                49.2970696,
                30.798232
              ],
              [
                49.2983934,
                30.7988719
              ],
              [
                49.2995605,
                30.7991917
              ],
              [
                49.3012045,
                30.799511
              ],
              [
                49.3023184,
                30.7996474
              ],
              [
                49.3038027,
                30.7996916
              ],
              [
                49.3052901,
                30.7997382
              ],
              [
                49.3068182,
                30.7997798
              ],
              [
                49.3068809,
                30.7997815
              ],
              [
                49.3071443,
                30.799918
              ],
              [
                49.3074111,
                30.8006071
              ],
              [
                49.3076249,
                30.8010655
              ],
              [
                49.3077849,
                30.8016608
              ],
              [
                49.3082122,
                30.8030354
              ],
              [
                49.3084794,
                30.8038147
              ],
              [
                49.3087424,
                30.8046865
              ],
              [
                49.3090134,
                30.8059237
              ],
              [
                49.3092804,
                30.8069782
              ],
              [
                49.3092803,
                30.8078037
              ],
              [
                49.3094406,
                30.8083088
              ],
              [
                49.3096544,
                30.8092701
              ],
              [
                49.309761,
                30.8107375
              ],
              [
                49.3101388,
                30.8137624
              ],
              [
                49.3102494,
                30.8160102
              ],
              [
                49.3102531,
                30.8188047
              ],
              [
                49.3100471,
                30.8215559
              ],
              [
                49.3101576,
                30.824124
              ],
              [
                49.3101615,
                30.8266456
              ],
              [
                49.3103296,
                30.8299925
              ],
              [
                49.3105431,
                30.8317342
              ],
              [
                49.3103333,
                30.8338425
              ],
              [
                49.3101806,
                30.8356764
              ],
              [
                49.3093873,
                30.8385665
              ],
              [
                49.308384,
                30.8408584
              ],
              [
                49.3075409,
                30.8426472
              ],
              [
                49.3061639,
                30.8445733
              ],
              [
                49.3048935,
                30.8461332
              ],
              [
                49.302986,
                30.848747
              ],
              [
                49.3020896,
                30.85072
              ],
              [
                49.3012962,
                30.8525545
              ],
              [
                49.3006096,
                30.8548009
              ],
              [
                49.3002929,
                30.8563597
              ],
              [
                49.2997133,
                30.8589278
              ],
              [
                49.2990799,
                30.8611726
              ],
              [
                49.2981833,
                30.8638808
              ],
              [
                49.2972297,
                30.8660807
              ],
              [
                49.2958527,
                30.8682819
              ],
              [
                49.2948493,
                30.8702061
              ],
              [
                49.2940561,
                30.8720879
              ],
              [
                49.2926789,
                30.8747942
              ],
              [
                49.2914084,
                30.8772245
              ],
              [
                49.289982,
                30.8814412
              ],
              [
                49.2889785,
                30.8847885
              ],
              [
                49.2879716,
                30.8872177
              ],
              [
                49.2871819,
                30.8900626
              ],
              [
                49.2862815,
                30.892951
              ],
              [
                49.2860438,
                30.8944845
              ],
              [
                49.2860185,
                30.8946481
              ],
              [
                49.2857017,
                30.8965722
              ],
              [
                49.285389,
                30.8986362
              ],
              [
                49.284912,
                30.9012958
              ],
              [
                49.2848849,
                30.9015324
              ],
              [
                49.2847022,
                30.9031266
              ],
              [
                49.2849694,
                30.9041834
              ],
              [
                49.2850799,
                30.9050081
              ],
              [
                49.2849199,
                30.9053284
              ],
              [
                49.2846032,
                30.905649
              ],
              [
                49.2843361,
                30.9059251
              ],
              [
                49.2834855,
                30.9059725
              ],
              [
                49.2821579,
                30.9057429
              ],
              [
                49.2818781,
                30.9056643
              ],
              [
                49.2798729,
                30.9051013
              ],
              [
                49.2774277,
                30.9041869
              ],
              [
                49.2751464,
                30.9034528
              ],
              [
                49.2730713,
                30.9028139
              ],
              [
                49.27063,
                30.9019423
              ],
              [
                49.2681847,
                30.9009353
              ],
              [
                49.2660108,
                30.9001029
              ],
              [
                49.2653161,
                30.8998368
              ],
              [
                49.2626609,
                30.8988314
              ],
              [
                49.2598458,
                30.8980516
              ],
              [
                49.2574538,
                30.8975953
              ],
              [
                49.2563399,
                30.8974563
              ],
              [
                49.2547455,
                30.8974596
              ],
              [
                49.2528344,
                30.8975962
              ],
              [
                49.2500172,
                30.8974949
              ],
              [
                49.2475981,
                30.8973652
              ],
              [
                49.2447205,
                30.8968142
              ],
              [
                49.24094,
                30.8958517
              ],
              [
                49.2362022,
                30.8946122
              ],
              [
                49.2327422,
                30.8939695
              ],
              [
                49.2301864,
                30.8934204
              ],
              [
                49.2268332,
                30.8929144
              ],
              [
                49.2232703,
                30.8923648
              ],
              [
                49.2199171,
                30.8917211
              ],
              [
                49.2161904,
                30.8909886
              ],
              [
                49.2127838,
                30.890071
              ],
              [
                49.2091637,
                30.8890602
              ],
              [
                49.2047463,
                30.8880517
              ],
              [
                49.2005425,
                30.8872716
              ],
              [
                49.1970824,
                30.8866303
              ],
              [
                49.1928786,
                30.8859424
              ],
              [
                49.1898461,
                30.8856677
              ],
              [
                49.1864929,
                30.8854855
              ],
              [
                49.1840476,
                30.8857601
              ],
              [
                49.1824533,
                30.8859926
              ],
              [
                49.1812859,
                30.8864972
              ],
              [
                49.1801187,
                30.8871867
              ],
              [
                49.1790047,
                30.8885174
              ],
              [
                49.1779481,
                30.8900767
              ],
              [
                49.1770517,
                30.8923735
              ],
              [
                49.1764184,
                30.8941192
              ],
              [
                49.1761092,
                30.8961852
              ],
              [
                49.1760635,
                30.8986654
              ],
              [
                49.1759682,
                30.9023808
              ],
              [
                49.1762465,
                30.9061015
              ],
              [
                49.1765785,
                30.9098657
              ],
              [
                49.1771203,
                30.9122978
              ],
              [
                49.1777153,
                30.9151456
              ],
              [
                49.1782569,
                30.9180377
              ],
              [
                49.178852,
                30.9204706
              ],
              [
                49.1791763,
                30.9221689
              ],
              [
                49.1796645,
                30.9246024
              ],
              [
                49.1799355,
                30.9268503
              ],
              [
                49.1800067,
                30.9271393
              ],
              [
                49.1800609,
                30.9273593
              ],
              [
                49.1806373,
                30.9296995
              ],
              [
                49.1811258,
                30.9320858
              ],
              [
                49.1813429,
                30.9336923
              ],
              [
                49.1813468,
                30.9344727
              ],
              [
                49.1762924,
                30.9344737
              ],
              [
                49.1716651,
                30.9346113
              ],
              [
                49.168419,
                30.9346578
              ],
              [
                49.1649588,
                30.9348861
              ],
              [
                49.1607589,
                30.9351624
              ],
              [
                49.1570855,
                30.935392
              ],
              [
                49.1535758,
                30.9353013
              ],
              [
                49.1503793,
                30.9350256
              ],
              [
                49.1474532,
                30.9347965
              ],
              [
                49.1454315,
                30.9343368
              ],
              [
                49.1435127,
                30.9338311
              ],
              [
                49.1415444,
                30.9336043
              ],
              [
                49.1393625,
                30.933282
              ],
              [
                49.1364862,
                30.9329158
              ],
              [
                49.1339301,
                30.9325948
              ],
              [
                49.1308975,
                30.9319962
              ],
              [
                49.1292456,
                30.9316768
              ],
              [
                49.1275979,
                30.9314004
              ],
              [
                49.1248285,
                30.9311257
              ],
              [
                49.1214752,
                30.930759
              ],
              [
                49.1179084,
                30.9302538
              ],
              [
                49.1135978,
                30.9296114
              ],
              [
                49.110775,
                30.9290154
              ],
              [
                49.1082192,
                30.9283736
              ],
              [
                49.1054535,
                30.9276858
              ],
              [
                49.102951,
                30.9269049
              ],
              [
                49.1007118,
                30.925988
              ],
              [
                49.0999144,
                30.9254824
              ],
              [
                49.0983161,
                30.9245184
              ],
              [
                49.0964509,
                30.9234152
              ],
              [
                49.0940514,
                30.9219952
              ],
              [
                49.0917092,
                30.9208916
              ],
              [
                49.0903779,
                30.9201119
              ],
              [
                49.0891,
                30.9197007
              ],
              [
                49.087555,
                30.9191952
              ],
              [
                49.0855331,
                30.9188743
              ],
              [
                49.0838815,
                30.9188747
              ],
              [
                49.0820732,
                30.9187825
              ],
              [
                49.0808486,
                30.9185094
              ],
              [
                49.0792543,
                30.9180483
              ],
              [
                49.0777625,
                30.9177284
              ],
              [
                49.0763779,
                30.9173605
              ],
              [
                49.074356,
                30.9169019
              ],
              [
                49.0719072,
                30.9165813
              ],
              [
                49.0693016,
                30.9163056
              ],
              [
                49.0646706,
                30.9152057
              ],
              [
                49.0601996,
                30.9140133
              ],
              [
                49.0560455,
                30.9130962
              ],
              [
                49.0523757,
                30.9124998
              ],
              [
                49.0478515,
                30.9117662
              ],
              [
                49.0443915,
                30.9112178
              ],
              [
                49.0408819,
                30.9108038
              ],
              [
                49.0371591,
                30.9105737
              ],
              [
                49.0339127,
                30.9103914
              ],
              [
                49.0308801,
                30.9102076
              ],
              [
                49.0284844,
                30.9100246
              ],
              [
                49.0248146,
                30.9097949
              ],
              [
                49.0208243,
                30.9094294
              ],
              [
                49.0177384,
                30.9090168
              ],
              [
                49.0157165,
                30.9088798
              ],
              [
                49.0130578,
                30.9085142
              ],
              [
                49.0099184,
                30.9081931
              ],
              [
                49.0065117,
                30.9077347
              ],
              [
                49.0039596,
                30.907551
              ],
              [
                49.0015105,
                30.9075041
              ],
              [
                48.9999021,
                30.9075492
              ],
              [
                48.9910927,
                30.8956952
              ],
              [
                48.989977,
                30.8910843
              ],
              [
                48.988634,
                30.8841133
              ],
              [
                48.9866264,
                30.8770439
              ],
              [
                48.9864253,
                30.8743964
              ],
              [
                48.9856732,
                30.8699822
              ],
              [
                48.9843922,
                30.8610368
              ],
              [
                48.9828721,
                30.8495898
              ],
              [
                48.9809932,
                30.8425718
              ],
              [
                48.9782601,
                30.8339509
              ],
              [
                48.976595,
                30.8275185
              ],
              [
                48.9743443,
                30.8204956
              ],
              [
                48.9726258,
                30.8153408
              ],
              [
                48.9697362,
                30.803879
              ],
              [
                48.9655457,
                30.7893788
              ],
              [
                48.9599104,
                30.770994
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554946,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بهبهان",
          "name:ar": "مقاطعة بهبهان",
          "name:en": "Behbahan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279163",
          "wikipedia": "en:Behbahan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.8740557,
                30.4524018
              ],
              [
                49.8741912,
                30.452112
              ],
              [
                49.8760837,
                30.4483727
              ],
              [
                49.8771057,
                30.4463533
              ],
              [
                49.8787994,
                30.4433338
              ],
              [
                49.8793525,
                30.4423495
              ],
              [
                49.8816186,
                30.4383163
              ],
              [
                49.8840293,
                30.434087
              ],
              [
                49.8874246,
                30.4286953
              ],
              [
                49.8886643,
                30.4270659
              ],
              [
                49.8889861,
                30.4265477
              ],
              [
                49.890049,
                30.4248355
              ],
              [
                49.8932456,
                30.420554
              ],
              [
                49.8968008,
                30.4156687
              ],
              [
                49.900364,
                30.4111984
              ],
              [
                49.9044418,
                30.4062135
              ],
              [
                49.9110373,
                30.3978793
              ],
              [
                49.9125102,
                30.3960392
              ],
              [
                49.9132004,
                30.3951768
              ],
              [
                49.9188765,
                30.3886527
              ],
              [
                49.9225425,
                30.3848256
              ],
              [
                49.9268875,
                30.3806271
              ],
              [
                49.9290123,
                30.3787113
              ],
              [
                49.9314041,
                30.3770255
              ],
              [
                49.9357223,
                30.3742116
              ],
              [
                49.9442178,
                30.3694215
              ],
              [
                49.9482728,
                30.3667021
              ],
              [
                49.9531136,
                30.3637925
              ],
              [
                49.9573211,
                30.361514
              ],
              [
                49.9591026,
                30.3605491
              ],
              [
                49.9665529,
                30.3568297
              ],
              [
                49.971817,
                30.3541935
              ],
              [
                49.976246,
                30.3521168
              ],
              [
                49.9809378,
                30.3500397
              ],
              [
                49.9864235,
                30.3481423
              ],
              [
                49.9918596,
                30.3463368
              ],
              [
                49.9956055,
                30.3444978
              ],
              [
                49.9986458,
                30.3429988
              ],
              [
                50.0000118,
                30.3423253
              ],
              [
                50.0000634,
                30.3423009
              ],
              [
                50.0035236,
                30.3416356
              ],
              [
                50.0045661,
                30.3414352
              ],
              [
                50.0093917,
                30.3405582
              ],
              [
                50.0150679,
                30.339137
              ],
              [
                50.0227087,
                30.3373626
              ],
              [
                50.0264205,
                30.336427
              ],
              [
                50.0349122,
                30.3342025
              ],
              [
                50.0443536,
                30.331752
              ],
              [
                50.0528373,
                30.3294337
              ],
              [
                50.0602607,
                30.327475
              ],
              [
                50.0714949,
                30.324494
              ],
              [
                50.0793914,
                30.3224496
              ],
              [
                50.0822485,
                30.3217839
              ],
              [
                50.0839461,
                30.3213401
              ],
              [
                50.0869676,
                30.3203077
              ],
              [
                50.0914689,
                30.3190126
              ],
              [
                50.0951803,
                30.3177569
              ],
              [
                50.0986747,
                30.3167298
              ],
              [
                50.1022223,
                30.3157052
              ],
              [
                50.1084177,
                30.3136879
              ],
              [
                50.1142426,
                30.3118077
              ],
              [
                50.1175805,
                30.3108264
              ],
              [
                50.1246148,
                30.3089133
              ],
              [
                50.1335029,
                30.3063285
              ],
              [
                50.1393738,
                30.3048219
              ],
              [
                50.140554,
                30.3044799
              ],
              [
                50.1427613,
                30.3038403
              ],
              [
                50.1447145,
                30.3033071
              ],
              [
                50.1461409,
                30.3030006
              ],
              [
                50.1479415,
                30.3026018
              ],
              [
                50.1493683,
                30.3022952
              ],
              [
                50.1510048,
                30.3020374
              ],
              [
                50.1530648,
                30.3017823
              ],
              [
                50.153484,
                30.3017437
              ],
              [
                50.1561812,
                30.3014956
              ],
              [
                50.1577109,
                30.3014197
              ],
              [
                50.1598243,
                30.3012574
              ],
              [
                50.1623039,
                30.3011018
              ],
              [
                50.1646713,
                30.3008395
              ],
              [
                50.1653671,
                30.3007672
              ],
              [
                50.1681633,
                30.3005211
              ],
              [
                50.1728133,
                30.2998354
              ],
              [
                50.1787262,
                30.2987469
              ],
              [
                50.184906,
                30.2974749
              ],
              [
                50.1892357,
                30.2967844
              ],
              [
                50.1925621,
                30.2962229
              ],
              [
                50.196415,
                30.295527
              ],
              [
                50.2000071,
                30.2949624
              ],
              [
                50.2006949,
                30.2940959
              ],
              [
                50.2024806,
                30.2921888
              ],
              [
                50.2033959,
                30.2912112
              ],
              [
                50.2074127,
                30.2876035
              ],
              [
                50.2117995,
                30.2839979
              ],
              [
                50.2162398,
                30.2809046
              ],
              [
                50.2215194,
                30.2773581
              ],
              [
                50.2270583,
                30.2740025
              ],
              [
                50.231804,
                30.2714226
              ],
              [
                50.2354966,
                30.269662
              ],
              [
                50.2393989,
                30.2679544
              ],
              [
                50.2429276,
                30.2664701
              ],
              [
                50.2473028,
                30.26495
              ],
              [
                50.2500241,
                30.2642369
              ],
              [
                50.252697,
                30.262664
              ],
              [
                50.2564697,
                30.2593669
              ],
              [
                50.2602425,
                30.2566292
              ],
              [
                50.2641181,
                30.253707
              ],
              [
                50.2695071,
                30.2499607
              ],
              [
                50.2758979,
                30.2460888
              ],
              [
                50.2835046,
                30.2417247
              ],
              [
                50.291855,
                30.2374928
              ],
              [
                50.3110696,
                30.2277207
              ],
              [
                50.3186148,
                30.2236858
              ],
              [
                50.3239478,
                30.2217507
              ],
              [
                50.330967,
                30.2190615
              ],
              [
                50.3400917,
                30.2156177
              ],
              [
                50.3482169,
                30.2126466
              ],
              [
                50.3511657,
                30.2113776
              ],
              [
                50.3578606,
                30.2086492
              ],
              [
                50.3648186,
                30.2059172
              ],
              [
                50.3698731,
                30.2035705
              ],
              [
                50.3799286,
                30.1990636
              ],
              [
                50.3882902,
                30.1950804
              ],
              [
                50.3970222,
                30.1910487
              ],
              [
                50.3987811,
                30.1902193
              ],
              [
                50.406063,
                30.1867854
              ],
              [
                50.4165763,
                30.1821897
              ],
              [
                50.4229433,
                30.1800701
              ],
              [
                50.4302521,
                30.1775753
              ],
              [
                50.4367293,
                30.1760579
              ],
              [
                50.4422037,
                30.1747299
              ],
              [
                50.4483032,
                30.1731223
              ],
              [
                50.4561959,
                30.1711339
              ],
              [
                50.4628793,
                30.1695686
              ],
              [
                50.4693565,
                30.1684692
              ],
              [
                50.4731942,
                30.1675214
              ],
              [
                50.4768295,
                30.1670373
              ],
              [
                50.4836769,
                30.1662094
              ],
              [
                50.5003508,
                30.1659333
              ],
              [
                50.5030833,
                30.1660572
              ],
              [
                50.5044213,
                30.1661179
              ],
              [
                50.5090712,
                30.166158
              ],
              [
                50.5138933,
                30.1660606
              ],
              [
                50.5143547,
                30.1660513
              ],
              [
                50.520584,
                30.1655169
              ],
              [
                50.5198137,
                30.1677048
              ],
              [
                50.5180168,
                30.1725464
              ],
              [
                50.5169868,
                30.1752928
              ],
              [
                50.5155563,
                30.1798966
              ],
              [
                50.5143279,
                30.1838988
              ],
              [
                50.5123368,
                30.1908762
              ],
              [
                50.5114821,
                30.1951956
              ],
              [
                50.5108339,
                30.198866
              ],
              [
                50.5103415,
                30.2024422
              ],
              [
                50.510002,
                30.2058295
              ],
              [
                50.5099449,
                30.2102805
              ],
              [
                50.5096484,
                30.2172528
              ],
              [
                50.5096016,
                30.2183513
              ],
              [
                50.5093766,
                30.2275799
              ],
              [
                50.5099334,
                30.2302148
              ],
              [
                50.5101126,
                30.2323903
              ],
              [
                50.5099716,
                30.2390225
              ],
              [
                50.5102916,
                30.2500804
              ],
              [
                50.510479,
                30.2539367
              ],
              [
                50.5107079,
                30.2575652
              ],
              [
                50.5111047,
                30.260028
              ],
              [
                50.5113982,
                30.262495
              ],
              [
                50.5113679,
                30.2659804
              ],
              [
                50.5117532,
                30.2699344
              ],
              [
                50.5119515,
                30.2711421
              ],
              [
                50.5120315,
                30.2738857
              ],
              [
                50.5124702,
                30.2775601
              ],
              [
                50.5126076,
                30.2802566
              ],
              [
                50.512783,
                30.2838827
              ],
              [
                50.5129661,
                30.2872764
              ],
              [
                50.5135116,
                30.2907188
              ],
              [
                50.5139656,
                30.2932788
              ],
              [
                50.514202,
                30.2961607
              ],
              [
                50.5143851,
                30.2994145
              ],
              [
                50.5146788,
                30.3017393
              ],
              [
                50.5153694,
                30.3072262
              ],
              [
                50.5162049,
                30.3140627
              ],
              [
                50.5164946,
                30.3175493
              ],
              [
                50.5165826,
                30.3196861
              ],
              [
                50.5164527,
                30.3222417
              ],
              [
                50.5164853,
                30.3230336
              ],
              [
                50.5165406,
                30.3244732
              ],
              [
                50.5171167,
                30.331214
              ],
              [
                50.5176659,
                30.334979
              ],
              [
                50.518055,
                30.3390254
              ],
              [
                50.5184517,
                30.34228
              ],
              [
                50.5184365,
                30.3439066
              ],
              [
                50.5185318,
                30.3453011
              ],
              [
                50.5186233,
                30.3468807
              ],
              [
                50.5188217,
                30.3486478
              ],
              [
                50.5190011,
                30.3524589
              ],
              [
                50.5190888,
                30.3545956
              ],
              [
                50.5190698,
                30.3569666
              ],
              [
                50.5190047,
                30.3584982
              ],
              [
                50.5189704,
                30.362913
              ],
              [
                50.5188982,
                30.365189
              ],
              [
                50.5188753,
                30.3680676
              ],
              [
                50.5190657,
                30.3704844
              ],
              [
                50.5193597,
                30.3735537
              ],
              [
                50.5196572,
                30.3758311
              ],
              [
                50.519909,
                30.377551
              ],
              [
                50.5202522,
                30.3809904
              ],
              [
                50.5206032,
                30.3834552
              ],
              [
                50.5206949,
                30.3849896
              ],
              [
                50.5206796,
                30.3869884
              ],
              [
                50.520977,
                30.3894981
              ],
              [
                50.5207594,
                30.3904245
              ],
              [
                50.5204887,
                30.3909808
              ],
              [
                50.5197448,
                30.3914428
              ],
              [
                50.5158655,
                30.3937995
              ],
              [
                50.5105476,
                30.3969831
              ],
              [
                50.5086325,
                30.3979528
              ],
              [
                50.5070419,
                30.3986462
              ],
              [
                50.505764,
                30.3992437
              ],
              [
                50.5045928,
                30.4002161
              ],
              [
                50.5035247,
                30.4010039
              ],
              [
                50.5020903,
                30.4017857
              ],
              [
                50.4999294,
                30.4023888
              ],
              [
                50.4985314,
                30.4028482
              ],
              [
                50.4963265,
                30.4039632
              ],
              [
                50.4930686,
                30.4053583
              ],
              [
                50.4882317,
                30.4074984
              ],
              [
                50.4841346,
                30.4094969
              ],
              [
                50.4800911,
                30.4117278
              ],
              [
                50.4749986,
                30.4144687
              ],
              [
                50.4704855,
                30.4175344
              ],
              [
                50.4667092,
                30.4201811
              ],
              [
                50.4646646,
                30.4215285
              ],
              [
                50.4594308,
                30.4261204
              ],
              [
                50.4557647,
                30.4294169
              ],
              [
                50.4557129,
                30.4294643
              ],
              [
                50.4526215,
                30.4322936
              ],
              [
                50.4494857,
                30.4355877
              ],
              [
                50.4491238,
                30.4360099
              ],
              [
                50.4466629,
                30.4388807
              ],
              [
                50.4441069,
                30.4420801
              ],
              [
                50.4412308,
                30.4455126
              ],
              [
                50.4389838,
                30.4482958
              ],
              [
                50.4347039,
                30.4540932
              ],
              [
                50.4316786,
                30.4585468
              ],
              [
                50.4303209,
                30.460402
              ],
              [
                50.4285966,
                30.4628129
              ],
              [
                50.4260408,
                30.4666638
              ],
              [
                50.4241676,
                30.4700936
              ],
              [
                50.4220351,
                30.4743118
              ],
              [
                50.4202689,
                30.4777894
              ],
              [
                50.4185982,
                30.4803401
              ],
              [
                50.4162485,
                30.4840993
              ],
              [
                50.4132081,
                30.4882749
              ],
              [
                50.4086954,
                30.493847
              ],
              [
                50.4044305,
                30.497613
              ],
              [
                50.4012108,
                30.5001249
              ],
              [
                50.4003105,
                30.5019142
              ],
              [
                50.3968087,
                30.5076303
              ],
              [
                50.3943139,
                30.5119636
              ],
              [
                50.3934057,
                30.5137642
              ],
              [
                50.3911819,
                30.5168963
              ],
              [
                50.3889543,
                30.5198885
              ],
              [
                50.3875197,
                30.5221467
              ],
              [
                50.3868295,
                30.5229285
              ],
              [
                50.3865662,
                30.5231573
              ],
              [
                50.3864593,
                30.5235268
              ],
              [
                50.3864555,
                30.524084
              ],
              [
                50.3866615,
                30.52427
              ],
              [
                50.3870811,
                30.5244592
              ],
              [
                50.387863,
                30.5247448
              ],
              [
                50.3894348,
                30.5250364
              ],
              [
                50.3937797,
                30.5261869
              ],
              [
                50.3967662,
                30.5271928
              ],
              [
                50.3980178,
                30.5276143
              ],
              [
                50.3993264,
                30.5278121
              ],
              [
                50.4006882,
                30.5281003
              ],
              [
                50.401947,
                30.5283904
              ],
              [
                50.4034653,
                30.5284966
              ],
              [
                50.4071923,
                30.5285271
              ],
              [
                50.4105989,
                30.5287434
              ],
              [
                50.4155809,
                30.5291606
              ],
              [
                50.4169997,
                30.5291715
              ],
              [
                50.4202462,
                30.5300815
              ],
              [
                50.4237021,
                30.5311301
              ],
              [
                50.4245413,
                30.5312759
              ],
              [
                50.4264296,
                30.5312933
              ],
              [
                50.4279517,
                30.5312142
              ],
              [
                50.4291612,
                30.5309917
              ],
              [
                50.430889,
                30.5311459
              ],
              [
                50.4313089,
                30.5314297
              ],
              [
                50.4320947,
                30.5318076
              ],
              [
                50.4325675,
                30.5319495
              ],
              [
                50.4331932,
                30.5321869
              ],
              [
                50.4335098,
                30.5321431
              ],
              [
                50.4339828,
                30.5319625
              ],
              [
                50.4345093,
                30.531782
              ],
              [
                50.4353485,
                30.5316029
              ],
              [
                50.4362946,
                30.5314739
              ],
              [
                50.4374505,
                30.5313909
              ],
              [
                50.4381294,
                30.5313961
              ],
              [
                50.4388123,
                30.5315886
              ],
              [
                50.4394913,
                30.5319186
              ],
              [
                50.4408531,
                30.532626
              ],
              [
                50.4419518,
                30.5333775
              ],
              [
                50.4428939,
                30.5336635
              ],
              [
                50.4433669,
                30.5336655
              ],
              [
                50.443947,
                30.5336274
              ],
              [
                50.4446793,
                30.5334478
              ],
              [
                50.4460487,
                30.5324858
              ],
              [
                50.4468918,
                30.5320292
              ],
              [
                50.4477311,
                30.5317598
              ],
              [
                50.4486238,
                30.5316282
              ],
              [
                50.4502524,
                30.5313644
              ],
              [
                50.4515112,
                30.5312817
              ],
              [
                50.4524574,
                30.5312451
              ],
              [
                50.4537164,
                30.5312549
              ],
              [
                50.4552382,
                30.5310357
              ],
              [
                50.4564438,
                30.5308151
              ],
              [
                50.4579696,
                30.5304583
              ],
              [
                50.4600677,
                30.5298737
              ],
              [
                50.4618168,
                30.5291406
              ],
              [
                50.4626174,
                30.5290165
              ],
              [
                50.4665655,
                30.5280763
              ],
              [
                50.470664,
                30.5271002
              ],
              [
                50.4742872,
                30.5262371
              ],
              [
                50.4751207,
                30.5262371
              ],
              [
                50.4754325,
                30.5260846
              ],
              [
                50.4760299,
                30.5261395
              ],
              [
                50.4763044,
                30.5261648
              ],
              [
                50.4763411,
                30.5261682
              ],
              [
                50.4770735,
                30.5263155
              ],
              [
                50.477703,
                30.5264128
              ],
              [
                50.4782295,
                30.5263246
              ],
              [
                50.4791718,
                30.5261479
              ],
              [
                50.4799358,
                30.5260427
              ],
              [
                50.4809537,
                30.5259664
              ],
              [
                50.486414,
                30.5279651
              ],
              [
                50.4892871,
                30.5290166
              ],
              [
                50.4926203,
                30.5276359
              ],
              [
                50.4928969,
                30.5273561
              ],
              [
                50.4937305,
                30.5273561
              ],
              [
                50.4937305,
                30.5270764
              ],
              [
                50.4957074,
                30.5270764
              ],
              [
                50.4965857,
                30.5267646
              ],
              [
                50.4973184,
                30.526632
              ],
              [
                50.4980011,
                30.5266369
              ],
              [
                50.4986838,
                30.527014
              ],
              [
                50.49905,
                30.5275749
              ],
              [
                50.500044,
                30.5281788
              ],
              [
                50.500885,
                30.528455
              ],
              [
                50.5017205,
                30.5289658
              ],
              [
                50.5027657,
                30.5292405
              ],
              [
                50.5039711,
                30.5297955
              ],
              [
                50.5050162,
                30.5301672
              ],
              [
                50.5060119,
                30.5305816
              ],
              [
                50.5065878,
                30.5310891
              ],
              [
                50.5069543,
                30.5315981
              ],
              [
                50.5073205,
                30.5321093
              ],
              [
                50.5076333,
                30.5324782
              ],
              [
                50.5078429,
                30.5331716
              ],
              [
                50.5077934,
                30.533679
              ],
              [
                50.5076866,
                30.5341884
              ],
              [
                50.5075301,
                30.5347924
              ],
              [
                50.5075303,
                30.5352075
              ],
              [
                50.5076369,
                30.5355779
              ],
              [
                50.5079498,
                30.5356693
              ],
              [
                50.5085257,
                30.5358091
              ],
              [
                50.5093649,
                30.5358077
              ],
              [
                50.5100976,
                30.535806
              ],
              [
                50.5103074,
                30.5359917
              ],
              [
                50.5104638,
                30.5363149
              ],
              [
                50.5105172,
                30.5367776
              ],
              [
                50.5103606,
                30.5372868
              ],
              [
                50.5099944,
                30.5377953
              ],
              [
                50.5098436,
                30.5382292
              ],
              [
                50.513329,
                30.540057
              ],
              [
                50.5141333,
                30.5399675
              ],
              [
                50.5150758,
                30.5399665
              ],
              [
                50.5158616,
                30.5402424
              ],
              [
                50.5170173,
                30.5411219
              ],
              [
                50.5173341,
                30.5419533
              ],
              [
                50.518013,
                30.5425559
              ],
              [
                50.5188524,
                30.5430621
              ],
              [
                50.5193786,
                30.5432467
              ],
              [
                50.5202676,
                30.5433854
              ],
              [
                50.5213164,
                30.5438472
              ],
              [
                50.5226288,
                30.5446326
              ],
              [
                50.523468,
                30.5452334
              ],
              [
                50.5243074,
                30.5458795
              ],
              [
                50.5251463,
                30.5464803
              ],
              [
                50.5257797,
                30.5470805
              ],
              [
                50.5263556,
                30.5477729
              ],
              [
                50.5267256,
                30.5484668
              ],
              [
                50.5267864,
                30.5487614
              ],
              [
                50.5269354,
                30.549485
              ],
              [
                50.5269393,
                30.5499001
              ],
              [
                50.5270996,
                30.5509655
              ],
              [
                50.5273628,
                30.5517966
              ],
              [
                50.5275192,
                30.5523972
              ],
              [
                50.5277329,
                30.5528131
              ],
              [
                50.5281526,
                30.5529974
              ],
              [
                50.5286752,
                30.552997
              ],
              [
                50.5303535,
                30.5526714
              ],
              [
                50.530983,
                30.552394
              ],
              [
                50.5318183,
                30.5518826
              ],
              [
                50.5326578,
                30.5515134
              ],
              [
                50.5328161,
                30.5514853
              ],
              [
                50.5331802,
                30.5514205
              ],
              [
                50.5335502,
                30.5515143
              ],
              [
                50.5335663,
                30.5515232
              ],
              [
                50.53397,
                30.5517437
              ],
              [
                50.5341797,
                30.5519746
              ],
              [
                50.53434,
                30.5523902
              ],
              [
                50.5346528,
                30.5528064
              ],
              [
                50.5351792,
                30.5534535
              ],
              [
                50.5356027,
                30.5540055
              ],
              [
                50.5358125,
                30.5542859
              ],
              [
                50.5359192,
                30.5543314
              ],
              [
                50.5364419,
                30.5547935
              ],
              [
                50.5370752,
                30.5552988
              ],
              [
                50.5376549,
                30.5557611
              ],
              [
                50.5386008,
                30.5563172
              ],
              [
                50.5397034,
                30.5570091
              ],
              [
                50.5401763,
                30.557471
              ],
              [
                50.5402833,
                30.5577917
              ],
              [
                50.5402831,
                30.5579767
              ],
              [
                50.5403365,
                30.5583942
              ],
              [
                50.5404471,
                30.5589947
              ],
              [
                50.5406075,
                30.5600127
              ],
              [
                50.5411376,
                30.5613523
              ],
              [
                50.5419272,
                30.5622281
              ],
              [
                50.5426636,
                30.5628759
              ],
              [
                50.5434531,
                30.5632915
              ],
              [
                50.5443991,
                30.5635656
              ],
              [
                50.5451851,
                30.563566
              ],
              [
                50.546238,
                30.5634253
              ],
              [
                50.5472334,
                30.5630092
              ],
              [
                50.548542,
                30.562822
              ],
              [
                50.5491753,
                30.5628671
              ],
              [
                50.5495662,
                30.5630552
              ],
              [
                50.5495663,
                30.5662419
              ],
              [
                50.5492897,
                30.5665216
              ],
              [
                50.548733,
                30.5684709
              ],
              [
                50.5487199,
                30.5685105
              ],
              [
                50.5486349,
                30.5687654
              ],
              [
                50.5483093,
                30.5691558
              ],
              [
                50.5467414,
                30.5711446
              ],
              [
                50.544548,
                30.5747983
              ],
              [
                50.5429307,
                30.5770666
              ],
              [
                50.5413132,
                30.5806749
              ],
              [
                50.5403748,
                30.5828959
              ],
              [
                50.5389672,
                30.586735
              ],
              [
                50.5376624,
                30.5902496
              ],
              [
                50.5367776,
                30.5928882
              ],
              [
                50.5357856,
                30.5955263
              ],
              [
                50.5350533,
                30.5974683
              ],
              [
                50.5343743,
                30.5987652
              ],
              [
                50.5339013,
                30.5996434
              ],
              [
                50.5329589,
                30.6008018
              ],
              [
                50.5300177,
                30.6041367
              ],
              [
                50.52602,
                30.6083543
              ],
              [
                50.5233918,
                30.6115977
              ],
              [
                50.5198097,
                30.6151195
              ],
              [
                50.5169641,
                30.6178093
              ],
              [
                50.513804,
                30.620318
              ],
              [
                50.5123432,
                30.6209666
              ],
              [
                50.51151,
                30.6215262
              ],
              [
                50.5076201,
                30.6229159
              ],
              [
                50.5028964,
                30.6242967
              ],
              [
                50.4901201,
                30.6295762
              ],
              [
                50.4892869,
                30.6295761
              ],
              [
                50.4640264,
                30.6425948
              ],
              [
                50.4531741,
                30.6481851
              ],
              [
                50.4237277,
                30.6651337
              ],
              [
                50.4190046,
                30.6706931
              ],
              [
                50.4165046,
                30.6745829
              ],
              [
                50.416254,
                30.6754609
              ],
              [
                50.4142847,
                30.6823624
              ],
              [
                50.4142846,
                30.6860279
              ],
              [
                50.4142846,
                30.6893026
              ],
              [
                50.4151178,
                30.6979125
              ],
              [
                50.4153944,
                30.6981923
              ],
              [
                50.4153944,
                30.7043707
              ],
              [
                50.4153943,
                30.7079123
              ],
              [
                50.4151177,
                30.7087426
              ],
              [
                50.4148209,
                30.7095593
              ],
              [
                50.4117845,
                30.7179121
              ],
              [
                50.3967815,
                30.7276412
              ],
              [
                50.3942814,
                30.7284716
              ],
              [
                50.392841,
                30.7313077
              ],
              [
                50.3927478,
                30.7313133
              ],
              [
                50.3907014,
                30.7314233
              ],
              [
                50.388466,
                30.731494
              ],
              [
                50.3845788,
                30.7313651
              ],
              [
                50.3812791,
                30.731196
              ],
              [
                50.3772889,
                30.7307889
              ],
              [
                50.3730353,
                30.7301932
              ],
              [
                50.3703805,
                30.7297066
              ],
              [
                50.368042,
                30.7292666
              ],
              [
                50.3654364,
                30.7287328
              ],
              [
                50.363262,
                30.7280635
              ],
              [
                50.3604507,
                30.7270187
              ],
              [
                50.3584366,
                30.7262125
              ],
              [
                50.3561593,
                30.7251252
              ],
              [
                50.3543625,
                30.7240425
              ],
              [
                50.3528862,
                30.7227335
              ],
              [
                50.3513525,
                30.7216521
              ],
              [
                50.3498231,
                30.7204804
              ],
              [
                50.3483505,
                30.7191218
              ],
              [
                50.3477487,
                30.7185075
              ],
              [
                50.3469313,
                30.7176732
              ],
              [
                50.3455657,
                30.7159925
              ],
              [
                50.3441505,
                30.7140318
              ],
              [
                50.3427888,
                30.7122586
              ],
              [
                50.3418999,
                30.7110923
              ],
              [
                50.3411103,
                30.7102514
              ],
              [
                50.3404275,
                30.7097336
              ],
              [
                50.3396377,
                30.7091724
              ],
              [
                50.3388443,
                30.7087488
              ],
              [
                50.3378372,
                30.7084594
              ],
              [
                50.3368263,
                30.7084971
              ],
              [
                50.3354417,
                30.7087156
              ],
              [
                50.3341065,
                30.7091667
              ],
              [
                50.3332291,
                30.7094355
              ],
              [
                50.3317604,
                30.7098855
              ],
              [
                50.3289299,
                30.7107868
              ],
              [
                50.3262597,
                30.7118761
              ],
              [
                50.323204,
                30.7135137
              ],
              [
                50.3209572,
                30.7145148
              ],
              [
                50.3177489,
                30.7160139
              ],
              [
                50.3155516,
                30.717198
              ],
              [
                50.313568,
                30.718338
              ],
              [
                50.3003693,
                30.7259553
              ],
              [
                50.2920409,
                30.7308336
              ],
              [
                50.2811319,
                30.7372218
              ],
              [
                50.2697295,
                30.7437902
              ],
              [
                50.2626725,
                30.7479867
              ],
              [
                50.261055,
                30.7489903
              ],
              [
                50.2599656,
                30.7500083
              ],
              [
                50.2580224,
                30.7519123
              ],
              [
                50.2561264,
                30.7535821
              ],
              [
                50.2541923,
                30.7555605
              ],
              [
                50.2541769,
                30.7555763
              ],
              [
                50.2528573,
                30.7569628
              ],
              [
                50.2515412,
                30.7587711
              ],
              [
                50.2499919,
                30.7610021
              ],
              [
                50.2490157,
                30.7635568
              ],
              [
                50.2460289,
                30.7673337
              ],
              [
                50.243309,
                30.7719468
              ],
              [
                50.2404329,
                30.7772965
              ],
              [
                50.2379189,
                30.7814008
              ],
              [
                50.2377263,
                30.7816365
              ],
              [
                50.2373972,
                30.7820344
              ],
              [
                50.2368162,
                30.7827365
              ],
              [
                50.2351876,
                30.784624
              ],
              [
                50.2328758,
                30.7879422
              ],
              [
                50.2315138,
                30.7905283
              ],
              [
                50.2312051,
                30.7921438
              ],
              [
                50.230793,
                30.7945032
              ],
              [
                50.2302208,
                30.7969541
              ],
              [
                50.2302283,
                30.7984362
              ],
              [
                50.2304459,
                30.8001067
              ],
              [
                50.2309267,
                30.8012668
              ],
              [
                50.2316741,
                30.8026608
              ],
              [
                50.2325783,
                30.8036835
              ],
              [
                50.234436,
                30.8054563
              ],
              [
                50.236187,
                30.806811
              ],
              [
                50.2383653,
                30.8089533
              ],
              [
                50.2409666,
                30.8116552
              ],
              [
                50.2420846,
                30.8127738
              ],
              [
                50.2426896,
                30.8178604
              ],
              [
                50.2430764,
                30.8211125
              ],
              [
                50.2433091,
                30.82519
              ],
              [
                50.2434387,
                30.8299144
              ],
              [
                50.2434539,
                30.8325063
              ],
              [
                50.2432976,
                30.8331528
              ],
              [
                50.2422011,
                30.8353968
              ],
              [
                50.2411993,
                30.8374468
              ],
              [
                50.2379493,
                30.8444657
              ],
              [
                50.2340089,
                30.8515256
              ],
              [
                50.2333795,
                30.8533287
              ],
              [
                50.2322771,
                30.8555441
              ],
              [
                50.2305947,
                30.8586381
              ],
              [
                50.2293816,
                30.8606227
              ],
              [
                50.228592,
                30.8621947
              ],
              [
                50.22723,
                30.8659831
              ],
              [
                50.225387,
                30.8698891
              ],
              [
                50.2251816,
                30.8703244
              ],
              [
                50.2247086,
                30.8716186
              ],
              [
                50.2244989,
                30.8724971
              ],
              [
                50.2242927,
                30.8737005
              ],
              [
                50.2240333,
                30.8751809
              ],
              [
                50.2238807,
                30.8774042
              ],
              [
                50.2231559,
                30.8814286
              ],
              [
                50.2217485,
                30.8884604
              ],
              [
                50.2210732,
                30.8923926
              ],
              [
                50.2206775,
                30.8942058
              ],
              [
                50.2201843,
                30.8964656
              ],
              [
                50.2195587,
                30.8993808
              ],
              [
                50.2190362,
                30.9017845
              ],
              [
                50.2185668,
                30.9044682
              ],
              [
                50.2183609,
                30.9062265
              ],
              [
                50.2181014,
                30.907337
              ],
              [
                50.2174186,
                30.9097871
              ],
              [
                50.2151109,
                30.9183923
              ],
              [
                50.213482,
                30.9244052
              ],
              [
                50.2115289,
                30.9292115
              ],
              [
                50.2108461,
                30.9316661
              ],
              [
                50.2104225,
                30.9322635
              ],
              [
                50.2097283,
                30.932354
              ],
              [
                50.2090912,
                30.9322577
              ],
              [
                50.2045593,
                30.9296899
              ],
              [
                50.1977386,
                30.9255333
              ],
              [
                50.1935807,
                30.9232901
              ],
              [
                50.1865006,
                30.919596
              ],
              [
                50.1804846,
                30.9163233
              ],
              [
                50.1741525,
                30.9122114
              ],
              [
                50.168564,
                30.908986
              ],
              [
                50.1644708,
                30.9062325
              ],
              [
                50.1606943,
                30.9037561
              ],
              [
                50.1564941,
                30.9005369
              ],
              [
                50.1527749,
                30.8978283
              ],
              [
                50.1499594,
                30.8954503
              ],
              [
                50.1461335,
                30.8926957
              ],
              [
                50.1431617,
                30.8901316
              ],
              [
                50.1384887,
                30.8862568
              ],
              [
                50.1357306,
                30.8837842
              ],
              [
                50.1336595,
                30.882153
              ],
              [
                50.1322289,
                30.8805216
              ],
              [
                50.1301613,
                30.8783309
              ],
              [
                50.128254,
                30.8761413
              ],
              [
                50.1262932,
                30.8739062
              ],
              [
                50.1249658,
                30.8725979
              ],
              [
                50.1235885,
                30.8712464
              ],
              [
                50.1223678,
                30.8704058
              ],
              [
                50.1205675,
                30.8690965
              ],
              [
                50.1197028,
                30.8685872
              ],
              [
                50.1188203,
                30.8680673
              ],
              [
                50.117176,
                30.8667613
              ],
              [
                50.1146353,
                30.8644725
              ],
              [
                50.1117746,
                30.8621385
              ],
              [
                50.1094437,
                30.860733
              ],
              [
                50.1055261,
                30.8587638
              ],
              [
                50.1022949,
                30.8566594
              ],
              [
                50.0986442,
                30.8541798
              ],
              [
                50.0962639,
                30.8522639
              ],
              [
                50.0891227,
                30.8468881
              ],
              [
                50.086006,
                30.8445044
              ],
              [
                50.0809859,
                30.8406229
              ],
              [
                50.0766565,
                30.8369333
              ],
              [
                50.0724335,
                30.8330097
              ],
              [
                50.0706565,
                30.8309732
              ],
              [
                50.0697479,
                30.8299317
              ],
              [
                50.0690295,
                30.8306933
              ],
              [
                50.0687905,
                30.8309467
              ],
              [
                50.0654909,
                30.8346381
              ],
              [
                50.0613443,
                30.8386052
              ],
              [
                50.0578269,
                30.8428543
              ],
              [
                50.0528181,
                30.8487187
              ],
              [
                50.0479164,
                30.8538415
              ],
              [
                50.0435448,
                30.8586929
              ],
              [
                50.0401801,
                30.8629426
              ],
              [
                50.035267,
                30.8685769
              ],
              [
                50.0333405,
                30.8713077
              ],
              [
                50.0318298,
                30.8670264
              ],
              [
                50.029255,
                30.8628814
              ],
              [
                50.0265349,
                30.8570639
              ],
              [
                50.0251733,
                30.8543174
              ],
              [
                50.0242882,
                30.8520348
              ],
              [
                50.024119,
                30.8516769
              ],
              [
                50.0219343,
                30.8470545
              ],
              [
                50.0204164,
                30.8440271
              ],
              [
                50.0189551,
                30.8410024
              ],
              [
                50.0171738,
                30.8376009
              ],
              [
                50.0157089,
                30.8353634
              ],
              [
                50.014347,
                30.8331266
              ],
              [
                50.0135614,
                30.8318214
              ],
              [
                50.0121957,
                30.8301891
              ],
              [
                50.0111963,
                30.8292544
              ],
              [
                50.0103036,
                30.8284581
              ],
              [
                50.0092508,
                30.8271981
              ],
              [
                50.0078887,
                30.8254711
              ],
              [
                50.0073662,
                30.8244926
              ],
              [
                50.006424,
                30.8231861
              ],
              [
                50.0049516,
                30.8217853
              ],
              [
                50.004666,
                30.8214988
              ],
              [
                50.0033225,
                30.8201509
              ],
              [
                50.001587,
                30.8186984
              ],
              [
                49.9999718,
                30.8176867
              ],
              [
                49.9991413,
                30.8173194
              ],
              [
                49.9969557,
                30.8158994
              ],
              [
                49.9942169,
                30.8133744
              ],
              [
                49.9930342,
                30.8121336
              ],
              [
                49.9913557,
                30.8098806
              ],
              [
                49.9900092,
                30.8082257
              ],
              [
                49.98806,
                30.8054202
              ],
              [
                49.9862289,
                30.8033532
              ],
              [
                49.9834939,
                30.8007783
              ],
              [
                49.9820444,
                30.7993097
              ],
              [
                49.9801636,
                30.7973347
              ],
              [
                49.9775275,
                30.7945755
              ],
              [
                49.9748915,
                30.7914509
              ],
              [
                49.9734305,
                30.7892423
              ],
              [
                49.9718629,
                30.7867576
              ],
              [
                49.9703445,
                30.7841808
              ],
              [
                49.9686394,
                30.779807
              ],
              [
                49.9673196,
                30.7761219
              ],
              [
                49.9659843,
                30.7716066
              ],
              [
                49.9648628,
                30.7671359
              ],
              [
                49.9637491,
                30.7631727
              ],
              [
                49.9630012,
                30.7591628
              ],
              [
                49.9627076,
                30.7570424
              ],
              [
                49.9625053,
                30.7539527
              ],
              [
                49.9606438,
                30.7444886
              ],
              [
                49.9544363,
                30.7257298
              ],
              [
                49.9534034,
                30.7190378
              ],
              [
                49.9534818,
                30.711784
              ],
              [
                49.9537954,
                30.7031945
              ],
              [
                49.9528608,
                30.6866096
              ],
              [
                49.9527632,
                30.686584
              ],
              [
                49.952957,
                30.686493
              ],
              [
                49.9533693,
                30.6854745
              ],
              [
                49.9535064,
                30.6841335
              ],
              [
                49.9533232,
                30.6825169
              ],
              [
                49.9531174,
                30.6820344
              ],
              [
                49.9524956,
                30.680577
              ],
              [
                49.9511186,
                30.6772545
              ],
              [
                49.9495927,
                30.6747654
              ],
              [
                49.9481659,
                30.6717176
              ],
              [
                49.9467354,
                30.6684871
              ],
              [
                49.9459724,
                30.6671026
              ],
              [
                49.9457931,
                30.6657162
              ],
              [
                49.9446145,
                30.6612831
              ],
              [
                49.9432334,
                30.6576356
              ],
              [
                49.9416961,
                30.6541718
              ],
              [
                49.9410439,
                30.6529732
              ],
              [
                49.9403342,
                30.6516817
              ],
              [
                49.9389725,
                30.6490968
              ],
              [
                49.9374999,
                30.6460981
              ],
              [
                49.9363478,
                30.6434653
              ],
              [
                49.9351882,
                30.6401872
              ],
              [
                49.9343529,
                30.6371374
              ],
              [
                49.9335137,
                30.6339499
              ],
              [
                49.9327163,
                30.6298356
              ],
              [
                49.9320907,
                30.6266454
              ],
              [
                49.931549,
                30.6217911
              ],
              [
                49.9311218,
                30.6175851
              ],
              [
                49.9311027,
                30.6159676
              ],
              [
                49.9313432,
                30.6143477
              ],
              [
                49.9316863,
                30.6120789
              ],
              [
                49.9322528,
                30.6104504
              ],
              [
                49.9329835,
                30.6102263
              ],
              [
                49.9350907,
                30.6095679
              ],
              [
                49.9367257,
                30.6090569
              ],
              [
                49.9396249,
                30.6082618
              ],
              [
                49.9435807,
                30.6074616
              ],
              [
                49.9474374,
                30.6068951
              ],
              [
                49.9513434,
                30.6063739
              ],
              [
                49.9537736,
                30.6061341
              ],
              [
                49.9578973,
                30.6057973
              ],
              [
                49.9606973,
                30.6056956
              ],
              [
                49.9642982,
                30.6057762
              ],
              [
                49.9684792,
                30.6058071
              ],
              [
                49.9718094,
                30.6056598
              ],
              [
                49.9732361,
                30.6055154
              ],
              [
                49.9743958,
                30.605281
              ],
              [
                49.9763413,
                30.6045361
              ],
              [
                49.9778634,
                30.6038375
              ],
              [
                49.9793816,
                30.6028614
              ],
              [
                49.9807893,
                30.6017017
              ],
              [
                49.9823569,
                30.6006334
              ],
              [
                49.9832422,
                30.5997065
              ],
              [
                49.9836594,
                30.59946
              ],
              [
                49.9841841,
                30.5991499
              ],
              [
                49.9856072,
                30.5989128
              ],
              [
                49.9873963,
                30.5985388
              ],
              [
                49.9901429,
                30.5983458
              ],
              [
                49.9915387,
                30.5983123
              ],
              [
                49.9924164,
                30.5982913
              ],
              [
                49.995921,
                30.5982372
              ],
              [
                50.0000402,
                30.598517
              ],
              [
                50.0019617,
                30.5980761
              ],
              [
                50.0053254,
                30.5970078
              ],
              [
                50.007019,
                30.5963102
              ],
              [
                50.0090255,
                30.5956127
              ],
              [
                50.0104521,
                30.5953303
              ],
              [
                50.0119325,
                30.5947257
              ],
              [
                50.014572,
                30.5938885
              ],
              [
                50.0172652,
                30.5930968
              ],
              [
                50.0184785,
                30.5928172
              ],
              [
                50.0196473,
                30.5924548
              ],
              [
                50.0202752,
                30.59226
              ],
              [
                50.0233878,
                30.5915593
              ],
              [
                50.0265045,
                30.5908631
              ],
              [
                50.029194,
                30.590026
              ],
              [
                50.0320434,
                30.5893253
              ],
              [
                50.0345765,
                30.5889043
              ],
              [
                50.0374794,
                30.5884859
              ],
              [
                50.0395357,
                30.5881582
              ],
              [
                50.0411187,
                30.5878315
              ],
              [
                50.0412782,
                30.5877941
              ],
              [
                50.0429115,
                30.5874116
              ],
              [
                50.0440712,
                30.5870389
              ],
              [
                50.0456008,
                30.586529
              ],
              [
                50.0472336,
                30.5858778
              ],
              [
                50.0488168,
                30.5849487
              ],
              [
                50.0506058,
                30.5837436
              ],
              [
                50.0532419,
                30.5822582
              ],
              [
                50.0552405,
                30.5807275
              ],
              [
                50.0581895,
                30.5785472
              ],
              [
                50.0601844,
                30.5767841
              ],
              [
                50.0618667,
                30.5751134
              ],
              [
                50.0639685,
                30.5730261
              ],
              [
                50.0658074,
                30.5711241
              ],
              [
                50.066803,
                30.5698274
              ],
              [
                50.0687981,
                30.5675565
              ],
              [
                50.0701064,
                30.5655176
              ],
              [
                50.070833,
                30.5644027
              ],
              [
                50.0716781,
                30.5631061
              ],
              [
                50.0734023,
                30.5598632
              ],
              [
                50.0739213,
                30.5587052
              ],
              [
                50.0750159,
                30.5559721
              ],
              [
                50.0757979,
                30.5538392
              ],
              [
                50.0760042,
                30.5529112
              ],
              [
                50.0763129,
                30.5516141
              ],
              [
                50.0763093,
                30.5504117
              ],
              [
                50.0763053,
                30.5495297
              ],
              [
                50.0762444,
                30.5479095
              ],
              [
                50.0760307,
                30.5469831
              ],
              [
                50.075447,
                30.5457315
              ],
              [
                50.0751801,
                30.544807
              ],
              [
                50.0747566,
                30.5438814
              ],
              [
                50.0722847,
                30.5435592
              ],
              [
                50.0695494,
                30.543048
              ],
              [
                50.0621377,
                30.5416616
              ],
              [
                50.0538864,
                30.5400905
              ],
              [
                50.0486336,
                30.5390733
              ],
              [
                50.0422746,
                30.5379191
              ],
              [
                50.037655,
                30.536994
              ],
              [
                50.0353432,
                30.5365302
              ],
              [
                50.0324022,
                30.5358813
              ],
              [
                50.0307235,
                30.5355598
              ],
              [
                50.0288847,
                30.5354197
              ],
              [
                50.0275191,
                30.5350035
              ],
              [
                50.0267332,
                30.5347247
              ],
              [
                50.0257873,
                30.5342619
              ],
              [
                50.0248414,
                30.5337067
              ],
              [
                50.0245286,
                30.5330569
              ],
              [
                50.0241622,
                30.5318518
              ],
              [
                50.0235864,
                30.5299504
              ],
              [
                50.0224344,
                30.5264272
              ],
              [
                50.0205994,
                30.521701
              ],
              [
                50.0197105,
                30.5194746
              ],
              [
                50.0188218,
                30.5169256
              ],
              [
                50.0176733,
                30.514607
              ],
              [
                50.0168381,
                30.5121036
              ],
              [
                50.0147476,
                30.507328
              ],
              [
                50.0134467,
                30.5032487
              ],
              [
                50.0122199,
                30.5000068
              ],
              [
                50.0115624,
                30.4970783
              ],
              [
                50.0101737,
                30.4931223
              ],
              [
                50.0091515,
                30.4901414
              ],
              [
                50.008484,
                30.4882798
              ],
              [
                50.0077057,
                30.4864624
              ],
              [
                50.0063552,
                30.4838963
              ],
              [
                50.0052756,
                30.481242
              ],
              [
                50.0042001,
                30.4781207
              ],
              [
                50.0030135,
                30.4751385
              ],
              [
                50.0016821,
                30.4713679
              ],
              [
                50.0010109,
                30.4698288
              ],
              [
                49.9999772,
                30.4674906
              ],
              [
                49.999854,
                30.4674929
              ],
              [
                49.9982643,
                30.4675225
              ],
              [
                49.9966239,
                30.4677197
              ],
              [
                49.9950449,
                30.4683798
              ],
              [
                49.9932517,
                30.4689006
              ],
              [
                49.9910353,
                30.4694249
              ],
              [
                49.9897804,
                30.470313
              ],
              [
                49.9883842,
                30.4716692
              ],
              [
                49.9876749,
                30.4730172
              ],
              [
                49.9866601,
                30.4748771
              ],
              [
                49.9840356,
                30.4782291
              ],
              [
                49.9823265,
                30.4800024
              ],
              [
                49.9815062,
                30.4812119
              ],
              [
                49.9809571,
                30.4825137
              ],
              [
                49.9806671,
                30.4837183
              ],
              [
                49.9805986,
                30.4851096
              ],
              [
                49.9804192,
                30.4863624
              ],
              [
                49.9804994,
                30.4874752
              ],
              [
                49.9804217,
                30.4880399
              ],
              [
                49.9803658,
                30.4884464
              ],
              [
                49.9798164,
                30.4898407
              ],
              [
                49.9789389,
                30.4909595
              ],
              [
                49.9780539,
                30.491706
              ],
              [
                49.9777984,
                30.4921709
              ],
              [
                49.9771157,
                30.4924069
              ],
              [
                49.9761545,
                30.4923182
              ],
              [
                49.9745599,
                30.492423
              ],
              [
                49.9736061,
                30.4927064
              ],
              [
                49.97303,
                30.4930335
              ],
              [
                49.9724046,
                30.4935497
              ],
              [
                49.9719849,
                30.4938306
              ],
              [
                49.9714585,
                30.4940633
              ],
              [
                49.9710349,
                30.4940667
              ],
              [
                49.9703903,
                30.4939331
              ],
              [
                49.9698028,
                30.4937502
              ],
              [
                49.9687882,
                30.4936632
              ],
              [
                49.9681512,
                30.493762
              ],
              [
                49.9676284,
                30.4940894
              ],
              [
                49.9670488,
                30.4944638
              ],
              [
                49.9668502,
                30.4949269
              ],
              [
                49.9664307,
                30.4953003
              ],
              [
                49.9661218,
                30.4957197
              ],
              [
                49.9657594,
                30.4960913
              ],
              [
                49.9654466,
                30.4963257
              ],
              [
                49.9651872,
                30.496653
              ],
              [
                49.9646033,
                30.4966574
              ],
              [
                49.9640693,
                30.4966576
              ],
              [
                49.9635315,
                30.4964323
              ],
              [
                49.9628334,
                30.4962508
              ],
              [
                49.9623985,
                30.4958368
              ],
              [
                49.9621696,
                30.4951875
              ],
              [
                49.9617387,
                30.4949585
              ],
              [
                49.9613113,
                30.4949168
              ],
              [
                49.9606208,
                30.4949654
              ],
              [
                49.959984,
                30.4951092
              ],
              [
                49.9591143,
                30.4954799
              ],
              [
                49.9588774,
                30.4955808
              ],
              [
                49.9581949,
                30.4958619
              ],
              [
                49.9573022,
                30.496518
              ],
              [
                49.9567298,
                30.4970299
              ],
              [
                49.9562112,
                30.4976349
              ],
              [
                49.9554978,
                30.498845
              ],
              [
                49.9550787,
                30.4998676
              ],
              [
                49.9550324,
                30.4999805
              ],
              [
                49.954805,
                30.5006328
              ],
              [
                49.954675,
                30.5010401
              ],
              [
                49.9546375,
                30.5015857
              ],
              [
                49.9546317,
                30.5022488
              ],
              [
                49.9546395,
                30.5027113
              ],
              [
                49.9544372,
                30.5032646
              ],
              [
                49.9539184,
                30.5036372
              ],
              [
                49.9533959,
                30.5038676
              ],
              [
                49.9527702,
                30.5042393
              ],
              [
                49.9520417,
                30.5045177
              ],
              [
                49.9513588,
                30.5046114
              ],
              [
                49.9506959,
                30.5046124
              ],
              [
                49.9504128,
                30.5046129
              ],
              [
                49.9495735,
                30.5045677
              ],
              [
                49.9489937,
                30.50443
              ],
              [
                49.9484673,
                30.5043851
              ],
              [
                49.9476778,
                30.5042479
              ],
              [
                49.9472578,
                30.5042039
              ],
              [
                49.9466819,
                30.5043436
              ],
              [
                49.9461632,
                30.5048515
              ],
              [
                49.9459077,
                30.5051765
              ],
              [
                49.945755,
                30.5055001
              ],
              [
                49.9457627,
                30.5061476
              ],
              [
                49.9457168,
                30.506657
              ],
              [
                49.9459915,
                30.5073022
              ],
              [
                49.9463653,
                30.5077654
              ],
              [
                49.9472124,
                30.5083632
              ],
              [
                49.948799,
                30.509055
              ],
              [
                49.9499625,
                30.5097005
              ],
              [
                49.9508666,
                30.5103913
              ],
              [
                49.9511375,
                30.5109462
              ],
              [
                49.9513549,
                30.5115006
              ],
              [
                49.9514693,
                30.5120091
              ],
              [
                49.9514772,
                30.5126092
              ],
              [
                49.9513818,
                30.5131182
              ],
              [
                49.9511834,
                30.5139513
              ],
              [
                49.9511543,
                30.5140962
              ],
              [
                49.9510347,
                30.5146922
              ],
              [
                49.9506263,
                30.5154785
              ],
              [
                49.9502641,
                30.5157575
              ],
              [
                49.9500045,
                30.5159427
              ],
              [
                49.9496384,
                30.5161269
              ],
              [
                49.9492186,
                30.5161281
              ],
              [
                49.9489556,
                30.5159883
              ],
              [
                49.9485321,
                30.5158518
              ],
              [
                49.947895,
                30.5153437
              ],
              [
                49.9451829,
                30.5131291
              ],
              [
                49.9410363,
                30.5099013
              ],
              [
                49.9368896,
                30.5061635
              ],
              [
                49.9332694,
                30.5025156
              ],
              [
                49.9307254,
                30.5000292
              ],
              [
                49.9283715,
                30.4981805
              ],
              [
                49.9262619,
                30.496575
              ],
              [
                49.9236527,
                30.4941827
              ],
              [
                49.919731,
                30.49018
              ],
              [
                49.9171716,
                30.4875556
              ],
              [
                49.9145661,
                30.4852601
              ],
              [
                49.9104918,
                30.4813981
              ],
              [
                49.9082185,
                30.4794684
              ],
              [
                49.9033509,
                30.4755657
              ],
              [
                49.8969267,
                30.4709322
              ],
              [
                49.8923417,
                30.4676766
              ],
              [
                49.8864098,
                30.4632747
              ],
              [
                49.8827933,
                30.460291
              ],
              [
                49.8804169,
                30.458272
              ],
              [
                49.8784179,
                30.4565269
              ],
              [
                49.8762056,
                30.4548273
              ],
              [
                49.874798,
                30.4532632
              ],
              [
                49.8740557,
                30.4524018
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554985,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان حمیدیه",
          "name:en": "Hamidieh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q10877602"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.265604,
                31.6600805
              ],
              [
                48.28746,
                31.6498119
              ],
              [
                48.2940336,
                31.6467298
              ],
              [
                48.3065682,
                31.6394703
              ],
              [
                48.3241404,
                31.6292135
              ],
              [
                48.3384196,
                31.6151446
              ],
              [
                48.3491365,
                31.6089273
              ],
              [
                48.3622822,
                31.5959557
              ],
              [
                48.3722166,
                31.5862699
              ],
              [
                48.388564,
                31.5719398
              ],
              [
                48.3961032,
                31.5650234
              ],
              [
                48.4165296,
                31.5462902
              ],
              [
                48.4285191,
                31.5355621
              ],
              [
                48.4409382,
                31.5230668
              ],
              [
                48.45615,
                31.5149518
              ],
              [
                48.4619095,
                31.5088426
              ],
              [
                48.4615776,
                31.5048046
              ],
              [
                48.4561287,
                31.5020384
              ],
              [
                48.4461869,
                31.5060677
              ],
              [
                48.4452362,
                31.5064222
              ],
              [
                48.442894,
                31.5062401
              ],
              [
                48.4407082,
                31.5056012
              ],
              [
                48.438469,
                31.5047311
              ],
              [
                48.4369774,
                31.5035875
              ],
              [
                48.4352684,
                31.5021689
              ],
              [
                48.4345703,
                31.5001506
              ],
              [
                48.4345137,
                31.4993986
              ],
              [
                48.4343285,
                31.4970637
              ],
              [
                48.4339626,
                31.4951264
              ],
              [
                48.433403,
                31.4933138
              ],
              [
                48.4328155,
                31.4922581
              ],
              [
                48.4323416,
                31.4909584
              ],
              [
                48.432331,
                31.4909294
              ],
              [
                48.4312057,
                31.4885418
              ],
              [
                48.4304543,
                31.4873498
              ],
              [
                48.4297601,
                31.4863866
              ],
              [
                48.4291235,
                31.4855679
              ],
              [
                48.4290122,
                31.4854247
              ],
              [
                48.4288144,
                31.4852152
              ],
              [
                48.4281005,
                31.4844594
              ],
              [
                48.4272462,
                31.4833127
              ],
              [
                48.4260177,
                31.4821178
              ],
              [
                48.4248924,
                31.4809273
              ],
              [
                48.4232902,
                31.4794115
              ],
              [
                48.4215278,
                31.4778519
              ],
              [
                48.4199753,
                31.4765197
              ],
              [
                48.4179458,
                31.4749614
              ],
              [
                48.4161835,
                31.4737197
              ],
              [
                48.4142075,
                31.4726652
              ],
              [
                48.4120712,
                31.4716548
              ],
              [
                48.4103661,
                31.4709214
              ],
              [
                48.4082832,
                31.4702299
              ],
              [
                48.4062538,
                31.4696341
              ],
              [
                48.40588,
                31.4694033
              ],
              [
                48.4044952,
                31.4690822
              ],
              [
                48.4033737,
                31.468622
              ],
              [
                48.4017715,
                31.467841
              ],
              [
                48.4007034,
                31.4671993
              ],
              [
                48.3995286,
                31.4662353
              ],
              [
                48.3990491,
                31.4659111
              ],
              [
                48.3980331,
                31.4652241
              ],
              [
                48.3965912,
                31.4641712
              ],
              [
                48.3952561,
                31.4630235
              ],
              [
                48.3938675,
                31.4619243
              ],
              [
                48.3926392,
                31.4608216
              ],
              [
                48.3912505,
                31.4595375
              ],
              [
                48.3904495,
                31.4585292
              ],
              [
                48.389698,
                31.4575218
              ],
              [
                48.3891106,
                31.4565584
              ],
              [
                48.3886833,
                31.4557313
              ],
              [
                48.3881493,
                31.4551838
              ],
              [
                48.3872575,
                31.4542708
              ],
              [
                48.3867607,
                31.4537622
              ],
              [
                48.3856392,
                31.452754
              ],
              [
                48.3843575,
                31.4516524
              ],
              [
                48.3826485,
                31.4503662
              ],
              [
                48.3818474,
                31.4497253
              ],
              [
                48.380619,
                31.4489471
              ],
              [
                48.3790169,
                31.4481658
              ],
              [
                48.3779488,
                31.4477066
              ],
              [
                48.3765641,
                31.4475226
              ],
              [
                48.3753357,
                31.4475673
              ],
              [
                48.3736839,
                31.4474297
              ],
              [
                48.3713379,
                31.4473816
              ],
              [
                48.3691521,
                31.4471969
              ],
              [
                48.3665883,
                31.4468401
              ],
              [
                48.3658447,
                31.4467366
              ],
              [
                48.3631783,
                31.4460482
              ],
              [
                48.3601914,
                31.4452201
              ],
              [
                48.3582154,
                31.4446269
              ],
              [
                48.3564567,
                31.4439368
              ],
              [
                48.3538933,
                31.4428377
              ],
              [
                48.3520813,
                31.4419661
              ],
              [
                48.3505859,
                31.4413219
              ],
              [
                48.349041,
                31.4406339
              ],
              [
                48.3469048,
                31.439397
              ],
              [
                48.3468015,
                31.4393357
              ],
              [
                48.3438111,
                31.437563
              ],
              [
                48.3411941,
                31.4359598
              ],
              [
                48.3392219,
                31.4347668
              ],
              [
                48.3378335,
                31.4338045
              ],
              [
                48.3364449,
                31.4326597
              ],
              [
                48.3349047,
                31.4313825
              ],
              [
                48.3348999,
                31.4313785
              ],
              [
                48.3336715,
                31.4299574
              ],
              [
                48.3327636,
                31.4287661
              ],
              [
                48.3323083,
                31.4280365
              ],
              [
                48.3319626,
                31.4274824
              ],
              [
                48.3311042,
                31.4256518
              ],
              [
                48.3305169,
                31.4239555
              ],
              [
                48.329876,
                31.4219874
              ],
              [
                48.3292846,
                31.419698
              ],
              [
                48.3286438,
                31.4177751
              ],
              [
                48.3280563,
                31.4165386
              ],
              [
                48.3270416,
                31.4148896
              ],
              [
                48.3261336,
                31.4131956
              ],
              [
                48.3250122,
                31.4118217
              ],
              [
                48.3237305,
                31.4097613
              ],
              [
                48.3220215,
                31.4077461
              ],
              [
                48.3207932,
                31.4063272
              ],
              [
                48.3186311,
                31.4034755
              ],
              [
                48.3185005,
                31.4033032
              ],
              [
                48.3174859,
                31.4019293
              ],
              [
                48.3173859,
                31.4017806
              ],
              [
                48.3171221,
                31.4013891
              ],
              [
                48.3166847,
                31.4007401
              ],
              [
                48.3156699,
                31.3994586
              ],
              [
                48.3146552,
                31.3980395
              ],
              [
                48.313961,
                31.3972156
              ],
              [
                48.3133241,
                31.3961155
              ],
              [
                48.3124695,
                31.3950177
              ],
              [
                48.3116684,
                31.3936437
              ],
              [
                48.3107605,
                31.3921344
              ],
              [
                48.3099595,
                31.3906679
              ],
              [
                48.3089447,
                31.388976
              ],
              [
                48.3081971,
                31.3873731
              ],
              [
                48.3077698,
                31.3860452
              ],
              [
                48.3072358,
                31.3845348
              ],
              [
                48.3066483,
                31.3828879
              ],
              [
                48.3061638,
                31.3808734
              ],
              [
                48.3055763,
                31.3790868
              ],
              [
                48.304882,
                31.3767996
              ],
              [
                48.3042411,
                31.3749216
              ],
              [
                48.3032265,
                31.3714892
              ],
              [
                48.3022118,
                31.3687872
              ],
              [
                48.3013573,
                31.3666365
              ],
              [
                48.3004494,
                31.364807
              ],
              [
                48.2998619,
                31.3637553
              ],
              [
                48.2992211,
                31.36238
              ],
              [
                48.2979928,
                31.360413
              ],
              [
                48.2967148,
                31.35872
              ],
              [
                48.2947946,
                31.3561836
              ],
              [
                48.2920226,
                31.353138
              ],
              [
                48.2913818,
                31.3524052
              ],
              [
                48.2897797,
                31.3505768
              ],
              [
                48.2880744,
                31.3487461
              ],
              [
                48.2864761,
                31.3471905
              ],
              [
                48.280675,
                31.3289218
              ],
              [
                48.2908059,
                31.3246871
              ],
              [
                48.3161049,
                31.3139396
              ],
              [
                48.3304415,
                31.3079948
              ],
              [
                48.3499212,
                31.2995769
              ],
              [
                48.3584967,
                31.2958699
              ],
              [
                48.3685055,
                31.291695
              ],
              [
                48.3869304,
                31.2836881
              ],
              [
                48.3946247,
                31.2803891
              ],
              [
                48.411703,
                31.2842467
              ],
              [
                48.4218806,
                31.2877626
              ],
              [
                48.4325104,
                31.2922321
              ],
              [
                48.4490928,
                31.303488
              ],
              [
                48.4605447,
                31.3157762
              ],
              [
                48.4694861,
                31.3280483
              ],
              [
                48.4760476,
                31.3412304
              ],
              [
                48.4783439,
                31.3501424
              ],
              [
                48.4908466,
                31.3465326
              ],
              [
                48.5150041,
                31.3401671
              ],
              [
                48.5262561,
                31.337264
              ],
              [
                48.5300168,
                31.3388205
              ],
              [
                48.546583,
                31.3457684
              ],
              [
                48.553196,
                31.339563
              ],
              [
                48.5557557,
                31.3388767
              ],
              [
                48.5570375,
                31.3388313
              ],
              [
                48.5579985,
                31.3387842
              ],
              [
                48.5599214,
                31.3391049
              ],
              [
                48.5631827,
                31.3397463
              ],
              [
                48.5659637,
                31.340665
              ],
              [
                48.5721131,
                31.3430453
              ],
              [
                48.5758019,
                31.3447858
              ],
              [
                48.5786399,
                31.346526
              ],
              [
                48.5812072,
                31.3479949
              ],
              [
                48.583458,
                31.3496427
              ],
              [
                48.5873643,
                31.3520252
              ],
              [
                48.5904692,
                31.3535829
              ],
              [
                48.5933035,
                31.3548199
              ],
              [
                48.5976866,
                31.3562843
              ],
              [
                48.6009483,
                31.357112
              ],
              [
                48.6043167,
                31.3577522
              ],
              [
                48.6086464,
                31.3584846
              ],
              [
                48.6112916,
                31.3586776
              ],
              [
                48.6089332,
                31.3668487
              ],
              [
                48.6061198,
                31.3765941
              ],
              [
                48.6059305,
                31.3767178
              ],
              [
                48.6041719,
                31.378092
              ],
              [
                48.6030579,
                31.3796044
              ],
              [
                48.6017837,
                31.3820315
              ],
              [
                48.5994414,
                31.385009
              ],
              [
                48.5966225,
                31.3894071
              ],
              [
                48.5939102,
                31.3929796
              ],
              [
                48.5907669,
                31.3962801
              ],
              [
                48.5874672,
                31.3997151
              ],
              [
                48.5806503,
                31.4071828
              ],
              [
                48.5783911,
                31.4098323
              ],
              [
                48.5742035,
                31.4147428
              ],
              [
                48.5722887,
                31.4174911
              ],
              [
                48.569683,
                31.4220729
              ],
              [
                48.5662844,
                31.4293565
              ],
              [
                48.5644263,
                31.4338915
              ],
              [
                48.5627701,
                31.4390661
              ],
              [
                48.5622558,
                31.4406729
              ],
              [
                48.5615157,
                31.4433284
              ],
              [
                48.5606193,
                31.4479561
              ],
              [
                48.5598792,
                31.4505213
              ],
              [
                48.5589219,
                31.4521265
              ],
              [
                48.5567399,
                31.4561118
              ],
              [
                48.5555153,
                31.4583115
              ],
              [
                48.5545579,
                31.4599144
              ],
              [
                48.5513688,
                31.466649
              ],
              [
                48.5497247,
                31.4703604
              ],
              [
                48.5481795,
                31.472971
              ],
              [
                48.5461579,
                31.4765443
              ],
              [
                48.5432244,
                31.4804382
              ],
              [
                48.5412559,
                31.48369
              ],
              [
                48.5389632,
                31.486807
              ],
              [
                48.5377387,
                31.4887292
              ],
              [
                48.536518,
                31.4920742
              ],
              [
                48.5344391,
                31.4954635
              ],
              [
                48.5323104,
                31.4995418
              ],
              [
                48.5319662,
                31.5001484
              ],
              [
                48.530094,
                31.5024594
              ],
              [
                48.5279885,
                31.5054444
              ],
              [
                48.526001,
                31.5085152
              ],
              [
                48.5195699,
                31.5274156
              ],
              [
                48.5129655,
                31.5453007
              ],
              [
                48.5107193,
                31.5546628
              ],
              [
                48.5086981,
                31.5632921
              ],
              [
                48.5072676,
                31.5694666
              ],
              [
                48.5104193,
                31.5708926
              ],
              [
                48.5112985,
                31.5770715
              ],
              [
                48.5103145,
                31.5832584
              ],
              [
                48.5160063,
                31.5834839
              ],
              [
                48.523607,
                31.5815971
              ],
              [
                48.529115,
                31.5814291
              ],
              [
                48.5329386,
                31.5846234
              ],
              [
                48.5364537,
                31.5841656
              ],
              [
                48.5425435,
                31.5804315
              ],
              [
                48.5448578,
                31.582038
              ],
              [
                48.5430118,
                31.5930125
              ],
              [
                48.5468719,
                31.5956567
              ],
              [
                48.5534515,
                31.5983887
              ],
              [
                48.5608061,
                31.5997907
              ],
              [
                48.5678475,
                31.597226
              ],
              [
                48.5699144,
                31.5997961
              ],
              [
                48.56779,
                31.612937
              ],
              [
                48.5728258,
                31.6149814
              ],
              [
                48.5817239,
                31.613508
              ],
              [
                48.5880485,
                31.6195522
              ],
              [
                48.5892534,
                31.6239669
              ],
              [
                48.582681,
                31.6334573
              ],
              [
                48.5753223,
                31.6399464
              ],
              [
                48.5768158,
                31.6459755
              ],
              [
                48.5781444,
                31.6501313
              ],
              [
                48.5798524,
                31.6533569
              ],
              [
                48.5821486,
                31.6572215
              ],
              [
                48.583211,
                31.6619119
              ],
              [
                48.5772381,
                31.6631016
              ],
              [
                48.5692188,
                31.6656653
              ],
              [
                48.5663328,
                31.6692028
              ],
              [
                48.5617722,
                31.6732933
              ],
              [
                48.5590325,
                31.6758589
              ],
              [
                48.5539112,
                31.6752832
              ],
              [
                48.5482905,
                31.6701012
              ],
              [
                48.5452131,
                31.6670958
              ],
              [
                48.5443902,
                31.6697238
              ],
              [
                48.5456608,
                31.6727811
              ],
              [
                48.5454045,
                31.6780926
              ],
              [
                48.5421269,
                31.6807821
              ],
              [
                48.5355493,
                31.6824925
              ],
              [
                48.5321161,
                31.6909745
              ],
              [
                48.5272727,
                31.6912095
              ],
              [
                48.5234047,
                31.6856016
              ],
              [
                48.5153033,
                31.688981
              ],
              [
                48.5158479,
                31.6984196
              ],
              [
                48.5086411,
                31.7043407
              ],
              [
                48.4993292,
                31.7092353
              ],
              [
                48.4994667,
                31.7064348
              ],
              [
                48.4979442,
                31.7048451
              ],
              [
                48.4766985,
                31.7009592
              ],
              [
                48.4639223,
                31.6985141
              ],
              [
                48.4287692,
                31.6922308
              ],
              [
                48.3990256,
                31.6870536
              ],
              [
                48.3678525,
                31.6816091
              ],
              [
                48.341924,
                31.6771515
              ],
              [
                48.3264621,
                31.6743996
              ],
              [
                48.3084461,
                31.6712195
              ],
              [
                48.3012542,
                31.669774
              ],
              [
                48.2758578,
                31.6646692
              ],
              [
                48.265604,
                31.6600805
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554994,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خرمشهر",
          "name:en": "Khoramshahr County",
          "name:uk": "Хорремшегр",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279493",
          "wikipedia": "en:Khorramshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.0251519,
                30.4776043
              ],
              [
                48.0366633,
                30.475662
              ],
              [
                48.0385639,
                30.4755062
              ],
              [
                48.0416503,
                30.4744986
              ],
              [
                48.0478934,
                30.4719393
              ],
              [
                48.0537623,
                30.468997
              ],
              [
                48.057784,
                30.4671227
              ],
              [
                48.0622017,
                30.4652183
              ],
              [
                48.0696757,
                30.4627394
              ],
              [
                48.0782305,
                30.4601974
              ],
              [
                48.0853444,
                30.4583893
              ],
              [
                48.0944603,
                30.4567501
              ],
              [
                48.099876,
                30.4556165
              ],
              [
                48.1047587,
                30.4546872
              ],
              [
                48.1072497,
                30.4540662
              ],
              [
                48.10857,
                30.4533166
              ],
              [
                48.1089571,
                30.4522908
              ],
              [
                48.108819,
                30.4508883
              ],
              [
                48.1136987,
                30.4501858
              ],
              [
                48.1200099,
                30.4488043
              ],
              [
                48.1229509,
                30.4481078
              ],
              [
                48.1257847,
                30.4472494
              ],
              [
                48.1281784,
                30.4464048
              ],
              [
                48.1285511,
                30.4462733
              ],
              [
                48.1320928,
                30.4448574
              ],
              [
                48.1324082,
                30.4447308
              ],
              [
                48.1332702,
                30.4443848
              ],
              [
                48.1357176,
                30.4434426
              ],
              [
                48.1381016,
                30.4424377
              ],
              [
                48.1420289,
                30.4403907
              ],
              [
                48.1424605,
                30.4401657
              ],
              [
                48.1440703,
                30.4393616
              ],
              [
                48.1450668,
                30.4388638
              ],
              [
                48.1476057,
                30.4373422
              ],
              [
                48.1499223,
                30.4359538
              ],
              [
                48.1520193,
                30.4346343
              ],
              [
                48.1529024,
                30.4340786
              ],
              [
                48.1548309,
                30.4327998
              ],
              [
                48.1584317,
                30.4304121
              ],
              [
                48.158686,
                30.4302434
              ],
              [
                48.1627579,
                30.4273979
              ],
              [
                48.1632534,
                30.4268594
              ],
              [
                48.163423,
                30.4266457
              ],
              [
                48.1669286,
                30.422229
              ],
              [
                48.1670674,
                30.4220541
              ],
              [
                48.1682479,
                30.4205461
              ],
              [
                48.1684927,
                30.4202309
              ],
              [
                48.1701666,
                30.4180761
              ],
              [
                48.1727075,
                30.4145566
              ],
              [
                48.1734178,
                30.4133856
              ],
              [
                48.1734634,
                30.4133104
              ],
              [
                48.1737878,
                30.4127364
              ],
              [
                48.1739427,
                30.4124621
              ],
              [
                48.1760223,
                30.4091829
              ],
              [
                48.179491,
                30.403196
              ],
              [
                48.1805997,
                30.3995153
              ],
              [
                48.1812926,
                30.3973527
              ],
              [
                48.1823543,
                30.3937365
              ],
              [
                48.1825438,
                30.3917197
              ],
              [
                48.1829127,
                30.3844677
              ],
              [
                48.1831635,
                30.380617
              ],
              [
                48.1831703,
                30.3805119
              ],
              [
                48.1861437,
                30.3690659
              ],
              [
                48.1862043,
                30.3687632
              ],
              [
                48.1865037,
                30.3675081
              ],
              [
                48.1900993,
                30.3511506
              ],
              [
                48.1919435,
                30.3435403
              ],
              [
                48.191975,
                30.34344
              ],
              [
                48.1926977,
                30.3383227
              ],
              [
                48.1936671,
                30.3353293
              ],
              [
                48.1978618,
                30.3271977
              ],
              [
                48.1986602,
                30.3260393
              ],
              [
                48.1991826,
                30.3252385
              ],
              [
                48.2024504,
                30.3210285
              ],
              [
                48.2042624,
                30.3195542
              ],
              [
                48.2056449,
                30.3188115
              ],
              [
                48.2067938,
                30.3180076
              ],
              [
                48.2085199,
                30.3174036
              ],
              [
                48.2106712,
                30.316938
              ],
              [
                48.2129332,
                30.3164779
              ],
              [
                48.215088,
                30.316305
              ],
              [
                48.2171993,
                30.3164824
              ],
              [
                48.2194017,
                30.3171921
              ],
              [
                48.2222526,
                30.3185629
              ],
              [
                48.2244046,
                30.3203433
              ],
              [
                48.2265845,
                30.3224466
              ],
              [
                48.2276564,
                30.3234524
              ],
              [
                48.2308614,
                30.3263675
              ],
              [
                48.2373447,
                30.333122
              ],
              [
                48.243422,
                30.3381059
              ],
              [
                48.246425,
                30.3396403
              ],
              [
                48.2486925,
                30.3404332
              ],
              [
                48.2479837,
                30.3415384
              ],
              [
                48.247565,
                30.3419171
              ],
              [
                48.2471037,
                30.3422875
              ],
              [
                48.2462561,
                30.3429078
              ],
              [
                48.2442069,
                30.3443337
              ],
              [
                48.241471,
                30.3461392
              ],
              [
                48.2384562,
                30.3480651
              ],
              [
                48.2360637,
                30.3495279
              ],
              [
                48.2336283,
                30.3509537
              ],
              [
                48.2306242,
                30.3526017
              ],
              [
                48.2288861,
                30.3536757
              ],
              [
                48.2229665,
                30.3587977
              ],
              [
                48.2210648,
                30.3604431
              ],
              [
                48.214517,
                30.3652008
              ],
              [
                48.2116262,
                30.3668442
              ],
              [
                48.2048663,
                30.3713675
              ],
              [
                48.2011305,
                30.3745707
              ],
              [
                48.2005737,
                30.3756805
              ],
              [
                48.2008503,
                30.3787395
              ],
              [
                48.2011304,
                30.3798494
              ],
              [
                48.201407,
                30.3806796
              ],
              [
                48.201407,
                30.3815097
              ],
              [
                48.2122403,
                30.3942869
              ],
              [
                48.2125204,
                30.3948463
              ],
              [
                48.2258535,
                30.4020741
              ],
              [
                48.2264101,
                30.4020742
              ],
              [
                48.2277969,
                30.4023448
              ],
              [
                48.2319633,
                30.4045646
              ],
              [
                48.2400197,
                30.4070642
              ],
              [
                48.2402998,
                30.4073439
              ],
              [
                48.2414099,
                30.4073439
              ],
              [
                48.2416866,
                30.4076236
              ],
              [
                48.2430764,
                30.4076236
              ],
              [
                48.2433529,
                30.4073439
              ],
              [
                48.2444663,
                30.407344
              ],
              [
                48.2444663,
                30.4070642
              ],
              [
                48.2450198,
                30.4070642
              ],
              [
                48.2512021,
                30.4003442
              ],
              [
                48.2557297,
                30.4026205
              ],
              [
                48.2595062,
                30.3997889
              ],
              [
                48.2627739,
                30.4029152
              ],
              [
                48.2686948,
                30.39986
              ],
              [
                48.2693316,
                30.3997099
              ],
              [
                48.2686328,
                30.4034548
              ],
              [
                48.2683562,
                30.4048445
              ],
              [
                48.2680761,
                30.4070643
              ],
              [
                48.2677995,
                30.4087336
              ],
              [
                48.2675229,
                30.4106827
              ],
              [
                48.2672428,
                30.4117926
              ],
              [
                48.2672429,
                30.415402
              ],
              [
                48.2672428,
                30.4181813
              ],
              [
                48.2677995,
                30.4226298
              ],
              [
                48.2691894,
                30.4279087
              ],
              [
                48.2811325,
                30.4509554
              ],
              [
                48.2811325,
                30.4512351
              ],
              [
                48.2816891,
                30.4517945
              ],
              [
                48.3091888,
                30.4853995
              ],
              [
                48.3203018,
                30.4906876
              ],
              [
                48.3205784,
                30.4909582
              ],
              [
                48.3241917,
                30.4917885
              ],
              [
                48.3325251,
                30.4940174
              ],
              [
                48.3336349,
                30.4940175
              ],
              [
                48.3366915,
                30.4948477
              ],
              [
                48.3378014,
                30.4948477
              ],
              [
                48.3400249,
                30.4956869
              ],
              [
                48.340858,
                30.4956869
              ],
              [
                48.3414147,
                30.4962374
              ],
              [
                48.3564146,
                30.5023466
              ],
              [
                48.3572478,
                30.5023466
              ],
              [
                48.3575244,
                30.5026264
              ],
              [
                48.3591912,
                30.5026264
              ],
              [
                48.3600244,
                30.5029062
              ],
              [
                48.3611377,
                30.5029062
              ],
              [
                48.3622478,
                30.5031859
              ],
              [
                48.3630811,
                30.5031859
              ],
              [
                48.3636377,
                30.5034657
              ],
              [
                48.3686379,
                30.5034656
              ],
              [
                48.3689144,
                30.5031859
              ],
              [
                48.378081,
                30.5037364
              ],
              [
                48.3783611,
                30.5040161
              ],
              [
                48.3816944,
                30.5040161
              ],
              [
                48.3819709,
                30.5042959
              ],
              [
                48.3825275,
                30.5040161
              ],
              [
                48.3830806,
                30.5040161
              ],
              [
                48.3883609,
                30.5040162
              ],
              [
                48.3897472,
                30.5045667
              ],
              [
                48.3910374,
                30.5054401
              ],
              [
                48.3909797,
                30.505591
              ],
              [
                48.3902969,
                30.5084297
              ],
              [
                48.3896141,
                30.5108129
              ],
              [
                48.3887253,
                30.5165855
              ],
              [
                48.3880959,
                30.5195177
              ],
              [
                48.3875198,
                30.5214881
              ],
              [
                48.3863601,
                30.5245111
              ],
              [
                48.3854141,
                30.5273986
              ],
              [
                48.3843613,
                30.5306965
              ],
              [
                48.3828887,
                30.5343175
              ],
              [
                48.3818359,
                30.5378003
              ],
              [
                48.3809433,
                30.5408219
              ],
              [
                48.3797874,
                30.5451752
              ],
              [
                48.3791046,
                30.5487489
              ],
              [
                48.3782119,
                30.5520928
              ],
              [
                48.3776855,
                30.5544768
              ],
              [
                48.3767891,
                30.5572254
              ],
              [
                48.3759995,
                30.5595635
              ],
              [
                48.3751565,
                30.5616254
              ],
              [
                48.3735771,
                30.564969
              ],
              [
                48.3725204,
                30.5673513
              ],
              [
                48.3714638,
                30.5693661
              ],
              [
                48.3705673,
                30.5707414
              ],
              [
                48.3703502,
                30.5715818
              ],
              [
                48.3700932,
                30.5725762
              ],
              [
                48.370041,
                30.5728029
              ],
              [
                48.3691977,
                30.5744522
              ],
              [
                48.3689347,
                30.5756892
              ],
              [
                48.3683014,
                30.5769278
              ],
              [
                48.3676682,
                30.5785746
              ],
              [
                48.3669852,
                30.5803172
              ],
              [
                48.3662987,
                30.5824251
              ],
              [
                48.3652992,
                30.5860441
              ],
              [
                48.3639794,
                30.589616
              ],
              [
                48.3635597,
                30.5916323
              ],
              [
                48.3635597,
                30.59232
              ],
              [
                48.3639336,
                30.5930987
              ],
              [
                48.3645706,
                30.5939684
              ],
              [
                48.3647308,
                30.5951149
              ],
              [
                48.3647309,
                30.5960303
              ],
              [
                48.3640975,
                30.5974989
              ],
              [
                48.3630943,
                30.5992846
              ],
              [
                48.3616677,
                30.6012985
              ],
              [
                48.3604507,
                30.6031318
              ],
              [
                48.3596612,
                30.6040041
              ],
              [
                48.3587075,
                30.6055135
              ],
              [
                48.3571204,
                30.6073933
              ],
              [
                48.3541603,
                30.6103703
              ],
              [
                48.3527832,
                30.6111968
              ],
              [
                48.3514061,
                30.6115633
              ],
              [
                48.3500824,
                30.611746
              ],
              [
                48.3482819,
                30.6117927
              ],
              [
                48.3469582,
                30.6116079
              ],
              [
                48.3449973,
                30.6115611
              ],
              [
                48.34309,
                30.6111952
              ],
              [
                48.3419265,
                30.6108738
              ],
              [
                48.3400727,
                30.6104165
              ],
              [
                48.339119,
                30.6098648
              ],
              [
                48.3375816,
                30.609087
              ],
              [
                48.3360443,
                30.6084918
              ],
              [
                48.3342971,
                30.6078946
              ],
              [
                48.3322296,
                30.6073922
              ],
              [
                48.3305321,
                30.6069786
              ],
              [
                48.3286285,
                30.606705
              ],
              [
                48.3269843,
                30.606705
              ],
              [
                48.3268225,
                30.6068166
              ],
              [
                48.3264541,
                30.6070706
              ],
              [
                48.3257675,
                30.6076653
              ],
              [
                48.3252906,
                30.6083996
              ],
              [
                48.324871,
                30.6095454
              ],
              [
                48.3250847,
                30.6127515
              ],
              [
                48.3257751,
                30.6146755
              ],
              [
                48.3269423,
                30.6165551
              ],
              [
                48.3281631,
                30.6180661
              ],
              [
                48.3301773,
                30.6201751
              ],
              [
                48.3325615,
                30.6214552
              ],
              [
                48.335266,
                30.6224193
              ],
              [
                48.3378067,
                30.623105
              ],
              [
                48.3403511,
                30.6239327
              ],
              [
                48.3418351,
                30.6244817
              ],
              [
                48.343122,
                30.6245999
              ],
              [
                48.3433189,
                30.624618
              ],
              [
                48.3440629,
                30.6248474
              ],
              [
                48.3447495,
                30.625123
              ],
              [
                48.3453332,
                30.6252612
              ],
              [
                48.3456002,
                30.6257649
              ],
              [
                48.3459702,
                30.6262685
              ],
              [
                48.3458633,
                30.6268638
              ],
              [
                48.3455467,
                30.6274594
              ],
              [
                48.3446502,
                30.6286496
              ],
              [
                48.3426896,
                30.6300706
              ],
              [
                48.3401489,
                30.6317188
              ],
              [
                48.3372383,
                30.6335531
              ],
              [
                48.334484,
                30.6354312
              ],
              [
                48.3331604,
                30.6367141
              ],
              [
                48.3304062,
                30.6393249
              ],
              [
                48.3280258,
                30.6426243
              ],
              [
                48.3260688,
                30.6456933
              ],
              [
                48.3244285,
                30.6488996
              ],
              [
                48.3233185,
                30.6518755
              ],
              [
                48.322891,
                30.6540394
              ],
              [
                48.3227387,
                30.6548105
              ],
              [
                48.3225822,
                30.6568253
              ],
              [
                48.3226891,
                30.6588432
              ],
              [
                48.3229561,
                30.6611778
              ],
              [
                48.3237534,
                30.6634693
              ],
              [
                48.325348,
                30.6666295
              ],
              [
                48.3265152,
                30.6684618
              ],
              [
                48.3278962,
                30.6703865
              ],
              [
                48.3298606,
                30.6729522
              ],
              [
                48.331768,
                30.6752439
              ],
              [
                48.3336792,
                30.6771681
              ],
              [
                48.3356971,
                30.6795071
              ],
              [
                48.3388824,
                30.6824382
              ],
              [
                48.3418006,
                30.6850504
              ],
              [
                48.3446693,
                30.6874337
              ],
              [
                48.347641,
                30.6899995
              ],
              [
                48.3507196,
                30.6922427
              ],
              [
                48.3527908,
                30.69394
              ],
              [
                48.3550721,
                30.6959549
              ],
              [
                48.3586311,
                30.6990262
              ],
              [
                48.3623505,
                30.7023712
              ],
              [
                48.366066,
                30.7052133
              ],
              [
                48.3743514,
                30.7124995
              ],
              [
                48.3780707,
                30.7157066
              ],
              [
                48.3822709,
                30.7191893
              ],
              [
                48.3856163,
                30.7220775
              ],
              [
                48.3890724,
                30.7248732
              ],
              [
                48.3921547,
                30.7273929
              ],
              [
                48.395237,
                30.7296374
              ],
              [
                48.397255,
                30.7310128
              ],
              [
                48.401081,
                30.7336712
              ],
              [
                48.4030457,
                30.7350928
              ],
              [
                48.4062347,
                30.7375669
              ],
              [
                48.4116592,
                30.7412785
              ],
              [
                48.4122342,
                30.7416431
              ],
              [
                48.4152718,
                30.7435692
              ],
              [
                48.4178237,
                30.7454036
              ],
              [
                48.4203224,
                30.7467792
              ],
              [
                48.423298,
                30.7486106
              ],
              [
                48.4246761,
                30.7493797
              ],
              [
                48.4260254,
                30.7501327
              ],
              [
                48.4271354,
                30.7521028
              ],
              [
                48.4278259,
                30.7536137
              ],
              [
                48.4282989,
                30.7550797
              ],
              [
                48.428669,
                30.7568661
              ],
              [
                48.4287186,
                30.7588355
              ],
              [
                48.4287186,
                30.759418
              ],
              [
                48.4287185,
                30.7603913
              ],
              [
                48.4280777,
                30.7629987
              ],
              [
                48.4276505,
                30.7649654
              ],
              [
                48.4270096,
                30.7672526
              ],
              [
                48.4266891,
                30.7692643
              ],
              [
                48.4264183,
                30.7724224
              ],
              [
                48.426628,
                30.7744378
              ],
              [
                48.4266972,
                30.7747217
              ],
              [
                48.427208,
                30.7768169
              ],
              [
                48.4281616,
                30.779156
              ],
              [
                48.4299622,
                30.7829594
              ],
              [
                48.4309158,
                30.7846086
              ],
              [
                48.4326631,
                30.7861224
              ],
              [
                48.4337769,
                30.7872718
              ],
              [
                48.4351577,
                30.7881424
              ],
              [
                48.4368554,
                30.7887443
              ],
              [
                48.4390334,
                30.7892541
              ],
              [
                48.4412078,
                30.7893489
              ],
              [
                48.4430122,
                30.789035
              ],
              [
                48.4449807,
                30.7886274
              ],
              [
                48.4466247,
                30.7882652
              ],
              [
                48.4476891,
                30.7882681
              ],
              [
                48.4487496,
                30.7886836
              ],
              [
                48.4488328,
                30.7887613
              ],
              [
                48.4493866,
                30.7892779
              ],
              [
                48.4495431,
                30.7903317
              ],
              [
                48.4493294,
                30.7912475
              ],
              [
                48.4486923,
                30.7922519
              ],
              [
                48.4473114,
                30.7932551
              ],
              [
                48.4459305,
                30.7939855
              ],
              [
                48.4436454,
                30.7944365
              ],
              [
                48.4413071,
                30.7944287
              ],
              [
                48.4384956,
                30.7946053
              ],
              [
                48.4364242,
                30.7951055
              ],
              [
                48.4354667,
                30.7955127
              ],
              [
                48.4347763,
                30.7959681
              ],
              [
                48.4345093,
                30.7967474
              ],
              [
                48.4340821,
                30.798394
              ],
              [
                48.4335976,
                30.8028308
              ],
              [
                48.4338673,
                30.8061482
              ],
              [
                48.4339141,
                30.8067244
              ],
              [
                48.4344406,
                30.8097923
              ],
              [
                48.4354973,
                30.8124491
              ],
              [
                48.4371948,
                30.8151073
              ],
              [
                48.4390526,
                30.817356
              ],
              [
                48.4410668,
                30.8197859
              ],
              [
                48.4439316,
                30.8218988
              ],
              [
                48.4462128,
                30.8237364
              ],
              [
                48.4482307,
                30.824978
              ],
              [
                48.4509391,
                30.8270426
              ],
              [
                48.4540177,
                30.8290198
              ],
              [
                48.4561957,
                30.8301246
              ],
              [
                48.4599114,
                30.8312776
              ],
              [
                48.4621429,
                30.8318332
              ],
              [
                48.4646377,
                30.8323872
              ],
              [
                48.4683037,
                30.8331759
              ],
              [
                48.4713821,
                30.8340073
              ],
              [
                48.4724795,
                30.8344818
              ],
              [
                48.4729767,
                30.8346968
              ],
              [
                48.4736671,
                30.8355243
              ],
              [
                48.4743041,
                30.8365784
              ],
              [
                48.4744606,
                30.8379975
              ],
              [
                48.4744606,
                30.840011
              ],
              [
                48.4740333,
                30.8415653
              ],
              [
                48.4731826,
                30.8438982
              ],
              [
                48.4722786,
                30.8454995
              ],
              [
                48.471428,
                30.8472349
              ],
              [
                48.4704171,
                30.8488341
              ],
              [
                48.4692993,
                30.8502959
              ],
              [
                48.4676514,
                30.8516188
              ],
              [
                48.4655227,
                30.8529413
              ],
              [
                48.463398,
                30.8541263
              ],
              [
                48.4616433,
                30.8550366
              ],
              [
                48.4593582,
                30.8562229
              ],
              [
                48.457283,
                30.8566286
              ],
              [
                48.4550514,
                30.8565779
              ],
              [
                48.4530335,
                30.8560219
              ],
              [
                48.4497948,
                30.8544113
              ],
              [
                48.4470864,
                30.8528021
              ],
              [
                48.4429435,
                30.8496335
              ],
              [
                48.4380608,
                30.8464186
              ],
              [
                48.4328576,
                30.8428792
              ],
              [
                48.4299889,
                30.8412236
              ],
              [
                48.426857,
                30.8396597
              ],
              [
                48.4219207,
                30.8376788
              ],
              [
                48.4187355,
                30.8366638
              ],
              [
                48.4168739,
                30.8363403
              ],
              [
                48.4152595,
                30.8361805
              ],
              [
                48.4149628,
                30.8361511
              ],
              [
                48.4135285,
                30.8364223
              ],
              [
                48.4120942,
                30.8370588
              ],
              [
                48.4110832,
                30.8381547
              ],
              [
                48.4108123,
                30.8396194
              ],
              [
                48.4107055,
                30.8411753
              ],
              [
                48.4109687,
                30.8432797
              ],
              [
                48.4113884,
                30.8457097
              ],
              [
                48.4126053,
                30.8490982
              ],
              [
                48.4146195,
                30.8518509
              ],
              [
                48.4173775,
                30.8555181
              ],
              [
                48.4213562,
                30.8596019
              ],
              [
                48.4247017,
                30.8632288
              ],
              [
                48.4260253,
                30.8650161
              ],
              [
                48.4271927,
                30.8675827
              ],
              [
                48.4276161,
                30.8691853
              ],
              [
                48.4279861,
                30.8703313
              ],
              [
                48.4283561,
                30.8712
              ],
              [
                48.4289932,
                30.871844
              ],
              [
                48.430214,
                30.8725785
              ],
              [
                48.4317551,
                30.8730848
              ],
              [
                48.4340401,
                30.873412
              ],
              [
                48.4364319,
                30.8734189
              ],
              [
                48.4391441,
                30.8733328
              ],
              [
                48.4419594,
                30.8731112
              ],
              [
                48.4439277,
                30.8725683
              ],
              [
                48.4456323,
                30.8721267
              ],
              [
                48.4456825,
                30.8721137
              ],
              [
                48.4481277,
                30.8717088
              ],
              [
                48.4505196,
                30.8718529
              ],
              [
                48.4525909,
                30.872498
              ],
              [
                48.4541855,
                30.8735553
              ],
              [
                48.4551391,
                30.8747488
              ],
              [
                48.4554557,
                30.8764416
              ],
              [
                48.4555092,
                30.8780909
              ],
              [
                48.4552421,
                30.8800586
              ],
              [
                48.4545479,
                30.8826627
              ],
              [
                48.4540138,
                30.8841742
              ],
              [
                48.4526825,
                30.886414
              ],
              [
                48.451088,
                30.8879632
              ],
              [
                48.4494361,
                30.8893805
              ],
              [
                48.4473075,
                30.8906102
              ],
              [
                48.4445953,
                30.8917471
              ],
              [
                48.4412994,
                30.8930664
              ],
              [
                48.4378968,
                30.8939257
              ],
              [
                48.4330025,
                30.894557
              ],
              [
                48.4290695,
                30.8951846
              ],
              [
                48.4250259,
                30.8957715
              ],
              [
                48.422264,
                30.8959014
              ],
              [
                48.4193916,
                30.8959839
              ],
              [
                48.4159889,
                30.8957017
              ],
              [
                48.4126397,
                30.8950057
              ],
              [
                48.410038,
                30.8944959
              ],
              [
                48.4058379,
                30.8926552
              ],
              [
                48.4030762,
                30.891504
              ],
              [
                48.3999444,
                30.8901694
              ],
              [
                48.3982429,
                30.8900269
              ],
              [
                48.3969117,
                30.8902504
              ],
              [
                48.3958473,
                30.8905695
              ],
              [
                48.3952102,
                30.8913458
              ],
              [
                48.3950463,
                30.8926277
              ],
              [
                48.3950424,
                30.8950086
              ],
              [
                48.3959427,
                30.89826
              ],
              [
                48.3967857,
                30.9026106
              ],
              [
                48.3973122,
                30.9055411
              ],
              [
                48.3974114,
                30.9093851
              ],
              [
                48.3971404,
                30.9119929
              ],
              [
                48.3965492,
                30.9158817
              ],
              [
                48.3955346,
                30.9185805
              ],
              [
                48.3938789,
                30.9208176
              ],
              [
                48.39159,
                30.9226902
              ],
              [
                48.389141,
                30.9244242
              ],
              [
                48.3877563,
                30.925244
              ],
              [
                48.3860015,
                30.9258804
              ],
              [
                48.3829154,
                30.9266026
              ],
              [
                48.3813705,
                30.9266457
              ],
              [
                48.3787651,
                30.9264103
              ],
              [
                48.3768539,
                30.9258101
              ],
              [
                48.3755265,
                30.9246174
              ],
              [
                48.3738822,
                30.9223699
              ],
              [
                48.3716546,
                30.9192064
              ],
              [
                48.3698006,
                30.9155386
              ],
              [
                48.3679445,
                30.9124869
              ],
              [
                48.3676262,
                30.9119634
              ],
              [
                48.3663559,
                30.9101744
              ],
              [
                48.3657722,
                30.9096236
              ],
              [
                48.3648147,
                30.9091193
              ],
              [
                48.3637665,
                30.9086856
              ],
              [
                48.363594,
                30.9086142
              ],
              [
                48.362423,
                30.9083355
              ],
              [
                48.3609352,
                30.9081947
              ],
              [
                48.3599243,
                30.9083747
              ],
              [
                48.3588599,
                30.9087836
              ],
              [
                48.356781,
                30.9101954
              ],
              [
                48.3537445,
                30.9130734
              ],
              [
                48.3507043,
                30.9166344
              ],
              [
                48.348835,
                30.9206117
              ],
              [
                48.3473358,
                30.925415
              ],
              [
                48.3469505,
                30.9296707
              ],
              [
                48.3467827,
                30.9345215
              ],
              [
                48.3481622,
                30.9416481
              ],
              [
                48.3526325,
                30.9491997
              ],
              [
                48.3559742,
                30.9557125
              ],
              [
                48.3211041,
                30.9556282
              ],
              [
                48.3151283,
                30.9554018
              ],
              [
                48.3119087,
                30.9552963
              ],
              [
                48.2881432,
                30.9544251
              ],
              [
                48.2747116,
                30.9533671
              ],
              [
                48.2251606,
                30.9518662
              ],
              [
                48.2156467,
                30.9519969
              ],
              [
                48.2064199,
                30.9510768
              ],
              [
                48.199396,
                30.9511443
              ],
              [
                48.1547433,
                30.9367005
              ],
              [
                48.1021625,
                30.9200735
              ],
              [
                48.0727119,
                30.9107515
              ],
              [
                48.0335364,
                30.8974702
              ],
              [
                48.0299781,
                30.8644217
              ],
              [
                48.029968,
                30.8588067
              ],
              [
                48.026586,
                30.5227934
              ],
              [
                48.0256918,
                30.5055349
              ],
              [
                48.0257241,
                30.5014546
              ],
              [
                48.0257251,
                30.5013912
              ],
              [
                48.0259641,
                30.4865463
              ],
              [
                48.0255254,
                30.4803075
              ],
              [
                48.0251519,
                30.4776043
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555015,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دزفول",
          "name:en": "Dezful County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279478",
          "wikipedia": "en:Dezful County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.2810012,
                32.2770305
              ],
              [
                48.2812386,
                32.2768011
              ],
              [
                48.2821301,
                32.2765775
              ],
              [
                48.282364,
                32.2765188
              ],
              [
                48.2836494,
                32.2761925
              ],
              [
                48.2844009,
                32.2760509
              ],
              [
                48.2850989,
                32.2759104
              ],
              [
                48.2857399,
                32.2755364
              ],
              [
                48.2861062,
                32.2750281
              ],
              [
                48.2864189,
                32.2745163
              ],
              [
                48.286358,
                32.2739177
              ],
              [
                48.286293,
                32.273364
              ],
              [
                48.2862854,
                32.2729039
              ],
              [
                48.2864418,
                32.2725331
              ],
              [
                48.2866986,
                32.2719818
              ],
              [
                48.2870711,
                32.271699
              ],
              [
                48.2877656,
                32.2713735
              ],
              [
                48.2888947,
                32.2713234
              ],
              [
                48.2897567,
                32.2713667
              ],
              [
                48.2901879,
                32.2713625
              ],
              [
                48.2906188,
                32.2714078
              ],
              [
                48.2911033,
                32.2712671
              ],
              [
                48.2914772,
                32.271079
              ],
              [
                48.2920074,
                32.2706193
              ],
              [
                48.2925338,
                32.269925
              ],
              [
                48.2926865,
                32.2694594
              ],
              [
                48.2929459,
                32.2688135
              ],
              [
                48.2933655,
                32.2681665
              ],
              [
                48.2938424,
                32.2676537
              ],
              [
                48.2948036,
                32.2670972
              ],
              [
                48.2957077,
                32.2666319
              ],
              [
                48.2965659,
                32.2663505
              ],
              [
                48.2973748,
                32.2663002
              ],
              [
                48.2983437,
                32.2663908
              ],
              [
                48.2993698,
                32.2665706
              ],
              [
                48.3005028,
                32.2666128
              ],
              [
                48.301361,
                32.2665636
              ],
              [
                48.302494,
                32.2666058
              ],
              [
                48.3034668,
                32.2667393
              ],
              [
                48.3054084,
                32.2668732
              ],
              [
                48.3062667,
                32.266869
              ],
              [
                48.3072357,
                32.2668198
              ],
              [
                48.3083649,
                32.2665373
              ],
              [
                48.3096465,
                32.2659762
              ],
              [
                48.3112525,
                32.2654153
              ],
              [
                48.312645,
                32.2649964
              ],
              [
                48.3138237,
                32.2644849
              ],
              [
                48.3145714,
                32.2641109
              ],
              [
                48.3149948,
                32.2635991
              ],
              [
                48.3151473,
                32.2630929
              ],
              [
                48.3151398,
                32.2625382
              ],
              [
                48.315075,
                32.2619394
              ],
              [
                48.3149566,
                32.2612922
              ],
              [
                48.314785,
                32.2606934
              ],
              [
                48.3145637,
                32.2602761
              ],
              [
                48.3141824,
                32.2599096
              ],
              [
                48.3136941,
                32.2598181
              ],
              [
                48.3132095,
                32.2596815
              ],
              [
                48.3128853,
                32.2595912
              ],
              [
                48.3126107,
                32.2594523
              ],
              [
                48.3125534,
                32.2591784
              ],
              [
                48.312439,
                32.2587634
              ],
              [
                48.3128091,
                32.2583925
              ],
              [
                48.3135567,
                32.257881
              ],
              [
                48.3144645,
                32.2572781
              ],
              [
                48.315155,
                32.2568126
              ],
              [
                48.3158951,
                32.2559311
              ],
              [
                48.3170623,
                32.2547724
              ],
              [
                48.3180732,
                32.2537998
              ],
              [
                48.3199921,
                32.2525443
              ],
              [
                48.3226662,
                32.2511019
              ],
              [
                48.3254055,
                32.249848
              ],
              [
                48.3269883,
                32.2489618
              ],
              [
                48.3278504,
                32.2484931
              ],
              [
                48.3288193,
                32.2477945
              ],
              [
                48.3301163,
                32.2472764
              ],
              [
                48.3313523,
                32.2462091
              ],
              [
                48.3329048,
                32.2443461
              ],
              [
                48.3340836,
                32.2428132
              ],
              [
                48.335743,
                32.24086
              ],
              [
                48.336708,
                32.2395638
              ],
              [
                48.337944,
                32.23835
              ],
              [
                48.3390159,
                32.2373266
              ],
              [
                48.3400346,
                32.2359346
              ],
              [
                48.3409996,
                32.2347714
              ],
              [
                48.3418007,
                32.2335213
              ],
              [
                48.3423843,
                32.2321292
              ],
              [
                48.3430214,
                32.2308306
              ],
              [
                48.3437614,
                32.2286527
              ],
              [
                48.3441849,
                32.227726
              ],
              [
                48.3448792,
                32.2264737
              ],
              [
                48.345787,
                32.225174
              ],
              [
                48.3464317,
                32.2245676
              ],
              [
                48.3475074,
                32.2239162
              ],
              [
                48.3486939,
                32.2231228
              ],
              [
                48.3498725,
                32.221867
              ],
              [
                48.3514824,
                32.2200545
              ],
              [
                48.3531456,
                32.2185181
              ],
              [
                48.3538438,
                32.217773
              ],
              [
                48.3543244,
                32.2173119
              ],
              [
                48.3546448,
                32.21671
              ],
              [
                48.3548013,
                32.2159648
              ],
              [
                48.3548508,
                32.2155488
              ],
              [
                48.3548469,
                32.2150415
              ],
              [
                48.3551101,
                32.2143482
              ],
              [
                48.3552666,
                32.2136999
              ],
              [
                48.35532,
                32.2132367
              ],
              [
                48.3554484,
                32.2124957
              ],
              [
                48.3554726,
                32.2123562
              ],
              [
                48.355793,
                32.2117542
              ],
              [
                48.3562775,
                32.2112887
              ],
              [
                48.3571319,
                32.210362
              ],
              [
                48.3575813,
                32.2099919
              ],
              [
                48.3582077,
                32.209476
              ],
              [
                48.3598213,
                32.2083081
              ],
              [
                48.3612708,
                32.2070084
              ],
              [
                48.362774,
                32.2056578
              ],
              [
                48.3642234,
                32.2043107
              ],
              [
                48.3657227,
                32.2025001
              ],
              [
                48.3677025,
                32.1999895
              ],
              [
                48.3687706,
                32.1983683
              ],
              [
                48.3688901,
                32.1981762
              ],
              [
                48.3702125,
                32.1960493
              ],
              [
                48.3705292,
                32.1953052
              ],
              [
                48.3712273,
                32.1944247
              ],
              [
                48.3718643,
                32.1930358
              ],
              [
                48.3728218,
                32.191135
              ],
              [
                48.3739929,
                32.1891394
              ],
              [
                48.3750573,
                32.1868711
              ],
              [
                48.3763847,
                32.1844144
              ],
              [
                48.3777122,
                32.1812633
              ],
              [
                48.3785592,
                32.1791798
              ],
              [
                48.3793984,
                32.176404
              ],
              [
                48.3803482,
                32.1738086
              ],
              [
                48.380764,
                32.1720047
              ],
              [
                48.3810768,
                32.1703836
              ],
              [
                48.3813821,
                32.1684872
              ],
              [
                48.3815384,
                32.1675639
              ],
              [
                48.381855,
                32.1666371
              ],
              [
                48.3823319,
                32.1656641
              ],
              [
                48.382595,
                32.1648783
              ],
              [
                48.3829689,
                32.1642255
              ],
              [
                48.3835563,
                32.1634396
              ],
              [
                48.3842544,
                32.162789
              ],
              [
                48.3851661,
                32.1619985
              ],
              [
                48.3860282,
                32.1614843
              ],
              [
                48.3866729,
                32.1612046
              ],
              [
                48.3872108,
                32.1609722
              ],
              [
                48.3878594,
                32.1607354
              ],
              [
                48.3882369,
                32.1606418
              ],
              [
                48.3892098,
                32.1604995
              ],
              [
                48.3907279,
                32.1606751
              ],
              [
                48.3917579,
                32.1608993
              ],
              [
                48.3930015,
                32.1610805
              ],
              [
                48.3939209,
                32.1608898
              ],
              [
                48.3944588,
                32.1606551
              ],
              [
                48.3949967,
                32.1603281
              ],
              [
                48.3952638,
                32.1598196
              ],
              [
                48.3953667,
                32.1594497
              ],
              [
                48.3953095,
                32.1591262
              ],
              [
                48.3951454,
                32.1586651
              ],
              [
                48.3948708,
                32.1582041
              ],
              [
                48.394596,
                32.1578377
              ],
              [
                48.394104,
                32.1572369
              ],
              [
                48.3934478,
                32.1567342
              ],
              [
                48.3927422,
                32.1561358
              ],
              [
                48.3919754,
                32.1553084
              ],
              [
                48.3909416,
                32.1544349
              ],
              [
                48.3902817,
                32.1536075
              ],
              [
                48.390171,
                32.153098
              ],
              [
                48.3902168,
                32.1524046
              ],
              [
                48.390213,
                32.1518522
              ],
              [
                48.3904761,
                32.1512489
              ],
              [
                48.3910141,
                32.1506919
              ],
              [
                48.3922005,
                32.1501776
              ],
              [
                48.3940849,
                32.1493845
              ],
              [
                48.3958129,
                32.1489602
              ],
              [
                48.3974839,
                32.1484874
              ],
              [
                48.3994293,
                32.1479232
              ],
              [
                48.4010429,
                32.1471291
              ],
              [
                48.402607,
                32.1465683
              ],
              [
                48.4036293,
                32.1460527
              ],
              [
                48.4043273,
                32.1455869
              ],
              [
                48.4047585,
                32.145217
              ],
              [
                48.4055062,
                32.1444275
              ],
              [
                48.4059905,
                32.1437769
              ],
              [
                48.4062537,
                32.1431781
              ],
              [
                48.4064636,
                32.1426662
              ],
              [
                48.4068375,
                32.142108
              ],
              [
                48.4075889,
                32.1414155
              ],
              [
                48.4085007,
                32.1406249
              ],
              [
                48.4096298,
                32.1397395
              ],
              [
                48.4101143,
                32.1393661
              ],
              [
                48.410652,
                32.1387922
              ],
              [
                48.4108086,
                32.1386251
              ],
              [
                48.4112892,
                32.137882
              ],
              [
                48.4113713,
                32.1375508
              ],
              [
                48.4113921,
                32.137467
              ],
              [
                48.4116021,
                32.1365899
              ],
              [
                48.411377,
                32.1358481
              ],
              [
                48.411213,
                32.1353871
              ],
              [
                48.4106141,
                32.1349758
              ],
              [
                48.4095802,
                32.1345218
              ],
              [
                48.4077301,
                32.1333725
              ],
              [
                48.4072419,
                32.1329612
              ],
              [
                48.4070739,
                32.1325001
              ],
              [
                48.4071235,
                32.1321765
              ],
              [
                48.4072304,
                32.1318044
              ],
              [
                48.4073334,
                32.1313895
              ],
              [
                48.4076577,
                32.1310647
              ],
              [
                48.408947,
                32.1304599
              ],
              [
                48.4101371,
                32.1302679
              ],
              [
                48.4114876,
                32.1301692
              ],
              [
                48.4127313,
                32.1300233
              ],
              [
                48.4138108,
                32.1298786
              ],
              [
                48.4145661,
                32.1297836
              ],
              [
                48.4158097,
                32.1296376
              ],
              [
                48.4160764,
                32.1294296
              ],
              [
                48.4163475,
                32.129218
              ],
              [
                48.4165039,
                32.1288492
              ],
              [
                48.4166642,
                32.1284783
              ],
              [
                48.4168123,
                32.1281591
              ],
              [
                48.4168777,
                32.1280182
              ],
              [
                48.4169807,
                32.1275063
              ],
              [
                48.4170303,
                32.1272323
              ],
              [
                48.4170265,
                32.1268152
              ],
              [
                48.4170761,
                32.126212
              ],
              [
                48.4171257,
                32.1257509
              ],
              [
                48.4170074,
                32.1246911
              ],
              [
                48.4170571,
                32.1242751
              ],
              [
                48.4171029,
                32.1234892
              ],
              [
                48.4172592,
                32.1227034
              ],
              [
                48.4177398,
                32.1221924
              ],
              [
                48.4183311,
                32.121819
              ],
              [
                48.4190865,
                32.1214895
              ],
              [
                48.4202716,
                32.1212117
              ],
              [
                48.421299,
                32.120971
              ],
              [
                48.4229165,
                32.1203186
              ],
              [
                48.4238282,
                32.1197578
              ],
              [
                48.4239883,
                32.1196213
              ],
              [
                48.4244729,
                32.1191554
              ],
              [
                48.4246864,
                32.1187405
              ],
              [
                48.4247894,
                32.1182331
              ],
              [
                48.4245682,
                32.1177258
              ],
              [
                48.4244576,
                32.1174012
              ],
              [
                48.4239082,
                32.1167565
              ],
              [
                48.423252,
                32.1161164
              ],
              [
                48.4227531,
                32.115695
              ],
              [
                48.4224891,
                32.1154719
              ],
              [
                48.4220542,
                32.1150099
              ],
              [
                48.4219399,
                32.1145026
              ],
              [
                48.421936,
                32.1140855
              ],
              [
                48.4221496,
                32.1135781
              ],
              [
                48.4223594,
                32.1129759
              ],
              [
                48.4226799,
                32.1125135
              ],
              [
                48.4229469,
                32.1120951
              ],
              [
                48.4232636,
                32.1114004
              ],
              [
                48.4234695,
                32.1104781
              ],
              [
                48.4237901,
                32.109691
              ],
              [
                48.4242134,
                32.1089016
              ],
              [
                48.4252854,
                32.1077872
              ],
              [
                48.426571,
                32.1066275
              ],
              [
                48.4282341,
                32.1053267
              ],
              [
                48.4291286,
                32.1048384
              ],
              [
                48.4296876,
                32.1045333
              ],
              [
                48.4315185,
                32.1037905
              ],
              [
                48.433567,
                32.1029934
              ],
              [
                48.4336124,
                32.1029792
              ],
              [
                48.4350739,
                32.1025234
              ],
              [
                48.4364243,
                32.102287
              ],
              [
                48.4376144,
                32.1022841
              ],
              [
                48.439125,
                32.1020441
              ],
              [
                48.4407463,
                32.1018988
              ],
              [
                48.4424744,
                32.1016114
              ],
              [
                48.4436074,
                32.1013299
              ],
              [
                48.4447795,
                32.1008609
              ],
              [
                48.4450073,
                32.1007698
              ],
              [
                48.4457588,
                32.1002123
              ],
              [
                48.4462394,
                32.0996561
              ],
              [
                48.4466706,
                32.0991936
              ],
              [
                48.4469208,
                32.098903
              ],
              [
                48.4473114,
                32.0984491
              ],
              [
                48.4482765,
                32.0977065
              ],
              [
                48.4492454,
                32.0971038
              ],
              [
                48.4495767,
                32.0969592
              ],
              [
                48.449795,
                32.0968638
              ],
              [
                48.4503211,
                32.096634
              ],
              [
                48.4507523,
                32.0964511
              ],
              [
                48.4515076,
                32.0963062
              ],
              [
                48.4519921,
                32.0962596
              ],
              [
                48.4526978,
                32.0964384
              ],
              [
                48.4532432,
                32.0969476
              ],
              [
                48.4536819,
                32.0976373
              ],
              [
                48.4539032,
                32.0980498
              ],
              [
                48.4539643,
                32.0988356
              ],
              [
                48.4539605,
                32.0992168
              ],
              [
                48.4539375,
                32.1015133
              ],
              [
                48.4541093,
                32.1023892
              ],
              [
                48.4542199,
                32.1029438
              ],
              [
                48.4543343,
                32.1033587
              ],
              [
                48.4545556,
                32.1038208
              ],
              [
                48.4549943,
                32.1045104
              ],
              [
                48.4553757,
                32.104969
              ],
              [
                48.4559746,
                32.105477
              ],
              [
                48.456684,
                32.1057979
              ],
              [
                48.4574394,
                32.1059753
              ],
              [
                48.4584695,
                32.1059261
              ],
              [
                48.4596558,
                32.1057809
              ],
              [
                48.4609528,
                32.1055905
              ],
              [
                48.4626771,
                32.105075
              ],
              [
                48.4644012,
                32.1042371
              ],
              [
                48.4664993,
                32.103348
              ],
              [
                48.4677925,
                32.1027877
              ],
              [
                48.4686545,
                32.1025096
              ],
              [
                48.4695702,
                32.1022258
              ],
              [
                48.470543,
                32.1021303
              ],
              [
                48.4717826,
                32.1018913
              ],
              [
                48.4730263,
                32.1018868
              ],
              [
                48.4756278,
                32.1023378
              ],
              [
                48.4776878,
                32.1027869
              ],
              [
                48.4797974,
                32.1030994
              ],
              [
                48.4809912,
                32.103511
              ],
              [
                48.4816971,
                32.1036445
              ],
              [
                48.4825632,
                32.1038736
              ],
              [
                48.4832114,
                32.1037783
              ],
              [
                48.4838067,
                32.1037293
              ],
              [
                48.4843978,
                32.1035426
              ],
              [
                48.4852067,
                32.1029861
              ],
              [
                48.4882194,
                32.100407
              ],
              [
                48.491853,
                32.1007841
              ],
              [
                48.4929962,
                32.1010002
              ],
              [
                48.4999406,
                32.0989215
              ],
              [
                48.5019898,
                32.0955223
              ],
              [
                48.5006897,
                32.0919427
              ],
              [
                48.500195,
                32.086823
              ],
              [
                48.5057164,
                32.0797107
              ],
              [
                48.5091292,
                32.0732449
              ],
              [
                48.5143098,
                32.0712604
              ],
              [
                48.5178102,
                32.0675136
              ],
              [
                48.5110242,
                32.06172
              ],
              [
                48.5143105,
                32.0599754
              ],
              [
                48.5200929,
                32.0620567
              ],
              [
                48.5236212,
                32.0641711
              ],
              [
                48.5265155,
                32.0637198
              ],
              [
                48.5293883,
                32.0632174
              ],
              [
                48.5331307,
                32.0595577
              ],
              [
                48.5350519,
                32.0575363
              ],
              [
                48.5325776,
                32.0527037
              ],
              [
                48.5156075,
                32.0443358
              ],
              [
                48.5128781,
                32.0376093
              ],
              [
                48.5090486,
                32.0343903
              ],
              [
                48.5000197,
                32.0364615
              ],
              [
                48.499445,
                32.0353303
              ],
              [
                48.5070702,
                32.0311872
              ],
              [
                48.5158396,
                32.0353652
              ],
              [
                48.5255384,
                32.0388251
              ],
              [
                48.5295616,
                32.0363046
              ],
              [
                48.5303612,
                32.0313521
              ],
              [
                48.5311985,
                32.0267242
              ],
              [
                48.5350603,
                32.0238575
              ],
              [
                48.5437434,
                32.0294958
              ],
              [
                48.5467724,
                32.0288863
              ],
              [
                48.5497509,
                32.0282178
              ],
              [
                48.5511512,
                32.0269353
              ],
              [
                48.5534479,
                32.0241734
              ],
              [
                48.5480444,
                32.0171817
              ],
              [
                48.5492497,
                32.0151212
              ],
              [
                48.5556506,
                32.0172188
              ],
              [
                48.5603848,
                32.0162888
              ],
              [
                48.5683397,
                32.0115408
              ],
              [
                48.5724978,
                32.0065922
              ],
              [
                48.5759386,
                32.0025482
              ],
              [
                48.5769711,
                32.0036473
              ],
              [
                48.5749863,
                32.0117114
              ],
              [
                48.578513,
                32.0145671
              ],
              [
                48.5836562,
                32.0158976
              ],
              [
                48.5829975,
                32.0215956
              ],
              [
                48.5851478,
                32.0235591
              ],
              [
                48.5875683,
                32.0259393
              ],
              [
                48.588078,
                32.0333727
              ],
              [
                48.5912339,
                32.0363276
              ],
              [
                48.5898267,
                32.0400123
              ],
              [
                48.5850741,
                32.0448914
              ],
              [
                48.5745137,
                32.0515107
              ],
              [
                48.5744548,
                32.0577003
              ],
              [
                48.5672032,
                32.0626432
              ],
              [
                48.5671433,
                32.0672367
              ],
              [
                48.5713436,
                32.0666805
              ],
              [
                48.576319,
                32.0661012
              ],
              [
                48.5800711,
                32.0679332
              ],
              [
                48.5813573,
                32.0708317
              ],
              [
                48.5816657,
                32.0716074
              ],
              [
                48.5835108,
                32.0740929
              ],
              [
                48.5802963,
                32.0761402
              ],
              [
                48.580695,
                32.0782851
              ],
              [
                48.5810863,
                32.0802502
              ],
              [
                48.5835264,
                32.0818346
              ],
              [
                48.5842478,
                32.0823663
              ],
              [
                48.5823506,
                32.0836513
              ],
              [
                48.5745885,
                32.084591
              ],
              [
                48.573861,
                32.0885231
              ],
              [
                48.5726933,
                32.0943817
              ],
              [
                48.571721,
                32.0994074
              ],
              [
                48.5712626,
                32.1016715
              ],
              [
                48.5707221,
                32.11022
              ],
              [
                48.5704784,
                32.1146992
              ],
              [
                48.570321,
                32.1159885
              ],
              [
                48.5706305,
                32.1230103
              ],
              [
                48.5708787,
                32.1320908
              ],
              [
                48.5723532,
                32.1394273
              ],
              [
                48.573555,
                32.1457432
              ],
              [
                48.5747926,
                32.1515668
              ],
              [
                48.5738677,
                32.1632022
              ],
              [
                48.5759173,
                32.1715344
              ],
              [
                48.5785389,
                32.1818964
              ],
              [
                48.5770065,
                32.1894072
              ],
              [
                48.579113,
                32.1820794
              ],
              [
                48.5798836,
                32.191651
              ],
              [
                48.5810929,
                32.2017293
              ],
              [
                48.5819169,
                32.2113921
              ],
              [
                48.5819182,
                32.2114072
              ],
              [
                48.5822754,
                32.2157817
              ],
              [
                48.5889054,
                32.2192947
              ],
              [
                48.5956993,
                32.2228059
              ],
              [
                48.600811,
                32.2253425
              ],
              [
                48.6021713,
                32.2258866
              ],
              [
                48.60532,
                32.227146
              ],
              [
                48.6099927,
                32.2288307
              ],
              [
                48.6103706,
                32.2289055
              ],
              [
                48.6226578,
                32.2337906
              ],
              [
                48.6264648,
                32.2355013
              ],
              [
                48.6312486,
                32.2372549
              ],
              [
                48.6336976,
                32.2381778
              ],
              [
                48.6350592,
                32.2389631
              ],
              [
                48.6362571,
                32.2397498
              ],
              [
                48.6376137,
                32.241013
              ],
              [
                48.63829,
                32.2419928
              ],
              [
                48.6383296,
                32.2438581
              ],
              [
                48.6375839,
                32.2455576
              ],
              [
                48.636501,
                32.2467299
              ],
              [
                48.6347051,
                32.2483376
              ],
              [
                48.6337061,
                32.2496603
              ],
              [
                48.6333734,
                32.2510181
              ],
              [
                48.6333848,
                32.2525446
              ],
              [
                48.6340521,
                32.2553663
              ],
              [
                48.6345519,
                32.25731
              ],
              [
                48.6362649,
                32.263001
              ],
              [
                48.6385157,
                32.2689657
              ],
              [
                48.6395646,
                32.2720222
              ],
              [
                48.6402283,
                32.2743793
              ],
              [
                48.6407396,
                32.2775272
              ],
              [
                48.6410332,
                32.2807657
              ],
              [
                48.641085,
                32.2812448
              ],
              [
                48.641323,
                32.2834472
              ],
              [
                48.641178,
                32.285575
              ],
              [
                48.6410828,
                32.2868696
              ],
              [
                48.6406119,
                32.2882315
              ],
              [
                48.6419564,
                32.2884911
              ],
              [
                48.6449775,
                32.2890435
              ],
              [
                48.6490783,
                32.2894627
              ],
              [
                48.6537705,
                32.2900167
              ],
              [
                48.6583556,
                32.2905731
              ],
              [
                48.6615907,
                32.2906646
              ],
              [
                48.6649361,
                32.290801
              ],
              [
                48.6674688,
                32.2911274
              ],
              [
                48.6706544,
                32.2914973
              ],
              [
                48.6729203,
                32.2916834
              ],
              [
                48.6752929,
                32.2917745
              ],
              [
                48.6769142,
                32.2921448
              ],
              [
                48.6799927,
                32.292747
              ],
              [
                48.6829604,
                32.2934419
              ],
              [
                48.6848527,
                32.2937629
              ],
              [
                48.6869048,
                32.2943642
              ],
              [
                48.6896628,
                32.295197
              ],
              [
                48.6935614,
                32.2966775
              ],
              [
                48.6968651,
                32.2981604
              ],
              [
                48.7025566,
                32.3009336
              ],
              [
                48.7085685,
                32.3036199
              ],
              [
                48.7127992,
                32.3056063
              ],
              [
                48.7151872,
                32.3069504
              ],
              [
                48.7170869,
                32.3081053
              ],
              [
                48.7187158,
                32.3090772
              ],
              [
                48.7197532,
                32.3100023
              ],
              [
                48.7204094,
                32.3109746
              ],
              [
                48.7210771,
                32.3125919
              ],
              [
                48.7219659,
                32.3149076
              ],
              [
                48.722969,
                32.3174982
              ],
              [
                48.7240297,
                32.3204573
              ],
              [
                48.7255783,
                32.3236958
              ],
              [
                48.7275048,
                32.3268891
              ],
              [
                48.7292098,
                32.3297088
              ],
              [
                48.7316779,
                32.3329457
              ],
              [
                48.7332689,
                32.334796
              ],
              [
                48.7350157,
                32.3365093
              ],
              [
                48.737152,
                32.3389172
              ],
              [
                48.7408141,
                32.3423376
              ],
              [
                48.7437096,
                32.3451153
              ],
              [
                48.7461702,
                32.3471952
              ],
              [
                48.7492832,
                32.3498774
              ],
              [
                48.7504349,
                32.3508426
              ],
              [
                48.7535706,
                32.3516267
              ],
              [
                48.7555732,
                32.3521381
              ],
              [
                48.7571411,
                32.3527364
              ],
              [
                48.7588729,
                32.353385
              ],
              [
                48.7612,
                32.3544048
              ],
              [
                48.7630919,
                32.3554687
              ],
              [
                48.76569,
                32.3566714
              ],
              [
                48.7676393,
                32.3577386
              ],
              [
                48.7687226,
                32.3584319
              ],
              [
                48.7705652,
                32.3594024
              ],
              [
                48.7726785,
                32.3606527
              ],
              [
                48.7751161,
                32.3618546
              ],
              [
                48.7759998,
                32.3622702
              ],
              [
                48.7772827,
                32.3628736
              ],
              [
                48.7783662,
                32.3634293
              ],
              [
                48.7802049,
                32.3643071
              ],
              [
                48.782158,
                32.3652343
              ],
              [
                48.783352,
                32.366067
              ],
              [
                48.7844352,
                32.3667602
              ],
              [
                48.7857894,
                32.3674536
              ],
              [
                48.7869836,
                32.3681036
              ],
              [
                48.7879029,
                32.3686563
              ],
              [
                48.7897492,
                32.369816
              ],
              [
                48.7919732,
                32.3712055
              ],
              [
                48.7934381,
                32.3721736
              ],
              [
                48.7951737,
                32.3733335
              ],
              [
                48.7963143,
                32.3742553
              ],
              [
                48.7978362,
                32.3755986
              ],
              [
                48.799198,
                32.3768511
              ],
              [
                48.8002852,
                32.3780064
              ],
              [
                48.8014792,
                32.3790711
              ],
              [
                48.8025705,
                32.380089
              ],
              [
                48.8040351,
                32.3811065
              ],
              [
                48.8048515,
                32.3815694
              ],
              [
                48.8059882,
                32.3821258
              ],
              [
                48.8067512,
                32.3827253
              ],
              [
                48.8076209,
                32.3834191
              ],
              [
                48.8093072,
                32.3846253
              ],
              [
                48.8104476,
                32.3854568
              ],
              [
                48.8119164,
                32.3863345
              ],
              [
                48.8126756,
                32.3867535
              ],
              [
                48.8137091,
                32.3875854
              ],
              [
                48.8149603,
                32.3885089
              ],
              [
                48.8165398,
                32.3899928
              ],
              [
                48.8176309,
                32.3909609
              ],
              [
                48.8193742,
                32.3928602
              ],
              [
                48.8203011,
                32.394017
              ],
              [
                48.8211213,
                32.3951766
              ],
              [
                48.8218347,
                32.3965642
              ],
              [
                48.8226587,
                32.3980913
              ],
              [
                48.8233146,
                32.3992051
              ],
              [
                48.8238105,
                32.400314
              ],
              [
                48.8244171,
                32.4017944
              ],
              [
                48.824585,
                32.4028119
              ],
              [
                48.8246993,
                32.4038352
              ],
              [
                48.8249645,
                32.4054007
              ],
              [
                48.8249816,
                32.4055017
              ],
              [
                48.8249053,
                32.4102734
              ],
              [
                48.8258818,
                32.41027
              ],
              [
                48.8274575,
                32.4104528
              ],
              [
                48.8296241,
                32.4105442
              ],
              [
                48.831684,
                32.4104038
              ],
              [
                48.83239,
                32.4104047
              ],
              [
                48.8335837,
                32.4104456
              ],
              [
                48.8346863,
                32.4106451
              ],
              [
                48.835373,
                32.4107694
              ],
              [
                48.8375472,
                32.4113231
              ],
              [
                48.8395041,
                32.4119226
              ],
              [
                48.842167,
                32.4123808
              ],
              [
                48.8441237,
                32.4130298
              ],
              [
                48.8466795,
                32.4139032
              ],
              [
                48.8515204,
                32.4156115
              ],
              [
                48.8557625,
                32.4172711
              ],
              [
                48.8585967,
                32.4187059
              ],
              [
                48.8597568,
                32.4193007
              ],
              [
                48.8621941,
                32.4205504
              ],
              [
                48.8646469,
                32.4217081
              ],
              [
                48.8667717,
                32.4228128
              ],
              [
                48.869442,
                32.424107
              ],
              [
                48.8717307,
                32.4250746
              ],
              [
                48.873146,
                32.4255382
              ],
              [
                48.8747293,
                32.42646
              ],
              [
                48.8764765,
                32.4273823
              ],
              [
                48.8777315,
                32.4281227
              ],
              [
                48.8793108,
                32.4287671
              ],
              [
                48.8805124,
                32.4293217
              ],
              [
                48.8813819,
                32.429555
              ],
              [
                48.8829079,
                32.4299662
              ],
              [
                48.8843767,
                32.4303359
              ],
              [
                48.885788,
                32.4305197
              ],
              [
                48.8878595,
                32.4310256
              ],
              [
                48.8893281,
                32.4313479
              ],
              [
                48.8909608,
                32.4319457
              ],
              [
                48.8930284,
                32.4321742
              ],
              [
                48.8950426,
                32.4328189
              ],
              [
                48.8971709,
                32.4336007
              ],
              [
                48.8988609,
                32.4342963
              ],
              [
                48.9007188,
                32.4352179
              ],
              [
                48.9027404,
                32.4364668
              ],
              [
                48.9037781,
                32.4369734
              ],
              [
                48.9050903,
                32.4378024
              ],
              [
                48.9066735,
                32.4384961
              ],
              [
                48.9093474,
                32.4394649
              ],
              [
                48.9130555,
                32.4406132
              ],
              [
                48.9161607,
                32.4414898
              ],
              [
                48.9200287,
                32.4424557
              ],
              [
                48.9234047,
                32.4431427
              ],
              [
                48.9270555,
                32.4438319
              ],
              [
                48.9304313,
                32.4444286
              ],
              [
                48.932556,
                32.44484
              ],
              [
                48.935604,
                32.4452981
              ],
              [
                48.9382211,
                32.4458506
              ],
              [
                48.9403457,
                32.4463994
              ],
              [
                48.9422569,
                32.4470439
              ],
              [
                48.9449348,
                32.447967
              ],
              [
                48.9472236,
                32.4486537
              ],
              [
                48.9500084,
                32.449486
              ],
              [
                48.9519195,
                32.4500807
              ],
              [
                48.9540519,
                32.4508662
              ],
              [
                48.9576111,
                32.4527097
              ],
              [
                48.9611701,
                32.4545103
              ],
              [
                48.9647829,
                32.4562147
              ],
              [
                48.9669762,
                32.4573211
              ],
              [
                48.969616,
                32.4592125
              ],
              [
                48.9716141,
                32.4606562
              ],
              [
                48.9727479,
                32.4614749
              ],
              [
                48.9754449,
                32.4633175
              ],
              [
                48.9777031,
                32.4651643
              ],
              [
                48.9781066,
                32.4655385
              ],
              [
                48.9787522,
                32.4661372
              ],
              [
                48.9800835,
                32.4677504
              ],
              [
                48.9810296,
                32.4690936
              ],
              [
                48.9822578,
                32.4709847
              ],
              [
                48.9828147,
                32.4718165
              ],
              [
                48.9838715,
                32.4733892
              ],
              [
                48.9846001,
                32.4747266
              ],
              [
                48.9854964,
                32.4761615
              ],
              [
                48.9862327,
                32.477871
              ],
              [
                48.9868585,
                32.4796284
              ],
              [
                48.9876558,
                32.4816636
              ],
              [
                48.9879455,
                32.4829557
              ],
              [
                48.9879847,
                32.4832887
              ],
              [
                48.988201,
                32.485131
              ],
              [
                48.988392,
                32.4869356
              ],
              [
                48.9889261,
                32.4894288
              ],
              [
                48.9892312,
                32.4914674
              ],
              [
                48.9894143,
                32.4928051
              ],
              [
                48.9899788,
                32.4940068
              ],
              [
                48.9902687,
                32.4950712
              ],
              [
                48.9898074,
                32.4999632
              ],
              [
                48.9900934,
                32.5015326
              ],
              [
                48.9916381,
                32.5034061
              ],
              [
                48.9936942,
                32.5066112
              ],
              [
                48.9950828,
                32.5087663
              ],
              [
                48.9970816,
                32.5117879
              ],
              [
                48.9983063,
                32.5138005
              ],
              [
                48.9993094,
                32.5155909
              ],
              [
                48.9995474,
                32.5160769
              ],
              [
                48.9998704,
                32.5167362
              ],
              [
                49.0001601,
                32.5177013
              ],
              [
                49.0003396,
                32.5186646
              ],
              [
                49.000305,
                32.5198207
              ],
              [
                49.0001677,
                32.5211105
              ],
              [
                49.0000266,
                32.5222672
              ],
              [
                48.999508,
                32.5234223
              ],
              [
                48.9989358,
                32.5245811
              ],
              [
                48.9980429,
                32.5260189
              ],
              [
                48.9964524,
                32.5276981
              ],
              [
                48.9944839,
                32.5293307
              ],
              [
                48.9921419,
                32.5311083
              ],
              [
                48.9912878,
                32.5316549
              ],
              [
                48.9907531,
                32.531997
              ],
              [
                48.9892044,
                32.5330726
              ],
              [
                48.9879264,
                32.5340577
              ],
              [
                48.9870222,
                32.5347106
              ],
              [
                48.9863358,
                32.5356398
              ],
              [
                48.9857558,
                32.5364309
              ],
              [
                48.9851381,
                32.5380512
              ],
              [
                48.9846191,
                32.5393438
              ],
              [
                48.9841232,
                32.5417483
              ],
              [
                48.9836771,
                32.5438718
              ],
              [
                48.9832955,
                32.5467832
              ],
              [
                48.9829215,
                32.5499202
              ],
              [
                48.9828071,
                32.5525519
              ],
              [
                48.9827345,
                32.5544401
              ],
              [
                48.9828606,
                32.5554996
              ],
              [
                48.9829369,
                32.5567431
              ],
              [
                48.9832229,
                32.5575706
              ],
              [
                48.9837302,
                32.5588572
              ],
              [
                48.9844056,
                32.5603245
              ],
              [
                48.9848098,
                32.5616567
              ],
              [
                48.985367,
                32.5627547
              ],
              [
                48.9858818,
                32.5642285
              ],
              [
                48.9861678,
                32.5651484
              ],
              [
                48.9869499,
                32.5665656
              ],
              [
                48.9879569,
                32.5684464
              ],
              [
                48.988964,
                32.5703248
              ],
              [
                48.9894638,
                32.5711513
              ],
              [
                48.9905701,
                32.5727044
              ],
              [
                48.9915199,
                32.574264
              ],
              [
                48.9924584,
                32.5754515
              ],
              [
                48.9933433,
                32.5765501
              ],
              [
                48.9944459,
                32.577828
              ],
              [
                48.9954949,
                32.5790623
              ],
              [
                48.9964867,
                32.580113
              ],
              [
                48.9977492,
                32.5813913
              ],
              [
                48.9989673,
                32.5828086
              ],
              [
                48.9999628,
                32.5841366
              ],
              [
                49.0000672,
                32.5842758
              ],
              [
                49.0019492,
                32.5859156
              ],
              [
                49.004383,
                32.5878978
              ],
              [
                49.0070304,
                32.5898315
              ],
              [
                49.0087091,
                32.5909381
              ],
              [
                49.0120085,
                32.5931549
              ],
              [
                49.0164413,
                32.5961944
              ],
              [
                49.0208245,
                32.5985497
              ],
              [
                49.02396,
                32.6001165
              ],
              [
                49.0296937,
                32.6033429
              ],
              [
                49.0338592,
                32.6054193
              ],
              [
                49.0375403,
                32.6069402
              ],
              [
                49.041977,
                32.6086035
              ],
              [
                49.0460855,
                32.6099437
              ],
              [
                49.0502511,
                32.6114198
              ],
              [
                49.0541458,
                32.6123889
              ],
              [
                49.0581512,
                32.6134024
              ],
              [
                49.0589189,
                32.6134998
              ],
              [
                49.0608023,
                32.6137387
              ],
              [
                49.0610696,
                32.6137744
              ],
              [
                49.0634995,
                32.6138187
              ],
              [
                49.067173,
                32.6135934
              ],
              [
                49.0699845,
                32.6133188
              ],
              [
                49.0730629,
                32.6129084
              ],
              [
                49.0761946,
                32.6123995
              ],
              [
                49.0797004,
                32.6113889
              ],
              [
                49.0845565,
                32.6100111
              ],
              [
                49.0888136,
                32.608448
              ],
              [
                49.0924264,
                32.6068841
              ],
              [
                49.0944747,
                32.6060111
              ],
              [
                49.0974388,
                32.6048633
              ],
              [
                49.0998649,
                32.6042642
              ],
              [
                49.1030504,
                32.603805
              ],
              [
                49.1055871,
                32.6035772
              ],
              [
                49.1081275,
                32.6035344
              ],
              [
                49.1108818,
                32.6035353
              ],
              [
                49.1125378,
                32.603716
              ],
              [
                49.1132095,
                32.6037892
              ],
              [
                49.1137914,
                32.6038527
              ],
              [
                49.1138534,
                32.6038595
              ],
              [
                49.1153241,
                32.6040692
              ],
              [
                49.1164512,
                32.6042299
              ],
              [
                49.1191521,
                32.6045072
              ],
              [
                49.1212617,
                32.6049243
              ],
              [
                49.1216926,
                32.604924
              ],
              [
                49.1254807,
                32.6056164
              ],
              [
                49.13002,
                32.6061711
              ],
              [
                49.1329955,
                32.606495
              ],
              [
                49.1344032,
                32.6067729
              ],
              [
                49.1361351,
                32.6072361
              ],
              [
                49.1384049,
                32.6077432
              ],
              [
                49.1400832,
                32.6078831
              ],
              [
                49.1430017,
                32.608021
              ],
              [
                49.1455918,
                32.6076557
              ],
              [
                49.1483422,
                32.6070131
              ],
              [
                49.1494749,
                32.6066442
              ],
              [
                49.1510354,
                32.6058149
              ],
              [
                49.1539383,
                32.6042071
              ],
              [
                49.1559793,
                32.6030128
              ],
              [
                49.1575395,
                32.6019106
              ],
              [
                49.1596909,
                32.6009455
              ],
              [
                49.161953,
                32.6001173
              ],
              [
                49.1638946,
                32.5997038
              ],
              [
                49.1670228,
                32.5992422
              ],
              [
                49.1717683,
                32.5985109
              ],
              [
                49.1775971,
                32.5979147
              ],
              [
                49.1813164,
                32.5975041
              ],
              [
                49.1852036,
                32.597141
              ],
              [
                49.1989668,
                32.5964575
              ],
              [
                49.1999346,
                32.596415
              ],
              [
                49.2040941,
                32.5962333
              ],
              [
                49.2056617,
                32.5961429
              ],
              [
                49.2076532,
                32.5958219
              ],
              [
                49.2108383,
                32.5954096
              ],
              [
                49.2131575,
                32.595181
              ],
              [
                49.2163926,
                32.5949519
              ],
              [
                49.2194671,
                32.5946303
              ],
              [
                49.2235718,
                32.5944517
              ],
              [
                49.2278368,
                32.594451
              ],
              [
                49.2304228,
                32.5941763
              ],
              [
                49.2322044,
                32.5938564
              ],
              [
                49.2340851,
                32.5932155
              ],
              [
                49.2366106,
                32.5922047
              ],
              [
                49.2403183,
                32.5905949
              ],
              [
                49.246702,
                32.5880269
              ],
              [
                49.2502252,
                32.5866093
              ],
              [
                49.2532667,
                32.5864163
              ],
              [
                49.2533722,
                32.5864096
              ],
              [
                49.2572745,
                32.5859339
              ],
              [
                49.2609101,
                32.5854567
              ],
              [
                49.2644843,
                32.5846605
              ],
              [
                49.2681655,
                32.583629
              ],
              [
                49.2717399,
                32.5826907
              ],
              [
                49.2755357,
                32.5820303
              ],
              [
                49.2787323,
                32.5814676
              ],
              [
                49.2836112,
                32.5808444
              ],
              [
                49.2884905,
                32.5803179
              ],
              [
                49.2938041,
                32.5795131
              ],
              [
                49.2975959,
                32.5787618
              ],
              [
                49.301876,
                32.5779606
              ],
              [
                49.3058321,
                32.5772541
              ],
              [
                49.3089219,
                32.5769192
              ],
              [
                49.3123933,
                32.5766299
              ],
              [
                49.3154297,
                32.5763866
              ],
              [
                49.32156,
                32.5758553
              ],
              [
                49.3260652,
                32.575841
              ],
              [
                49.330677,
                32.5757287
              ],
              [
                49.3346366,
                32.5757136
              ],
              [
                49.3379441,
                32.5753335
              ],
              [
                49.3419037,
                32.574901
              ],
              [
                49.3456458,
                32.5743799
              ],
              [
                49.3477591,
                32.574189
              ],
              [
                49.3512305,
                32.5738535
              ],
              [
                49.3538894,
                32.5736584
              ],
              [
                49.3577919,
                32.573414
              ],
              [
                49.3602906,
                32.5733114
              ],
              [
                49.3626571,
                32.5734809
              ],
              [
                49.3633308,
                32.5735291
              ],
              [
                49.3643608,
                32.573617
              ],
              [
                49.3650133,
                32.5737066
              ],
              [
                49.3654078,
                32.573705
              ],
              [
                49.3653985,
                32.5743069
              ],
              [
                49.3654075,
                32.5743542
              ],
              [
                49.3655128,
                32.5749059
              ],
              [
                49.3655168,
                32.5754584
              ],
              [
                49.3651504,
                32.5769351
              ],
              [
                49.3648337,
                32.5781328
              ],
              [
                49.3639793,
                32.5796122
              ],
              [
                49.3611411,
                32.5841413
              ],
              [
                49.3591042,
                32.5872376
              ],
              [
                49.3581389,
                32.5886681
              ],
              [
                49.3571739,
                32.5900107
              ],
              [
                49.3556137,
                32.5916746
              ],
              [
                49.3539429,
                32.5929718
              ],
              [
                49.3523787,
                32.5944102
              ],
              [
                49.3505515,
                32.5963525
              ],
              [
                49.3481294,
                32.5989904
              ],
              [
                49.3469504,
                32.6005623
              ],
              [
                49.3455542,
                32.6025056
              ],
              [
                49.3440476,
                32.6038928
              ],
              [
                49.342003,
                32.6060259
              ],
              [
                49.3406563,
                32.6073678
              ],
              [
                49.339691,
                32.6085704
              ],
              [
                49.3383447,
                32.6100498
              ],
              [
                49.3374474,
                32.6109175
              ],
              [
                49.3357087,
                32.6125989
              ],
              [
                49.3338279,
                32.6148221
              ],
              [
                49.3328056,
                32.6160238
              ],
              [
                49.3319435,
                32.6169504
              ],
              [
                49.3309249,
                32.6183394
              ],
              [
                49.3297998,
                32.6200494
              ],
              [
                49.3292693,
                32.6213907
              ],
              [
                49.3291386,
                32.6217312
              ],
              [
                49.3285255,
                32.623329
              ],
              [
                49.3281631,
                32.6255
              ],
              [
                49.3274765,
                32.6275338
              ],
              [
                49.3267364,
                32.629932
              ],
              [
                49.3263548,
                32.6309897
              ],
              [
                49.3261527,
                32.63155
              ],
              [
                49.3257295,
                32.6328431
              ],
              [
                49.3256301,
                32.6342285
              ],
              [
                49.3257562,
                32.636025
              ],
              [
                49.3265914,
                32.6385571
              ],
              [
                49.32769,
                32.6401681
              ],
              [
                49.3290024,
                32.6412657
              ],
              [
                49.3303642,
                32.6421812
              ],
              [
                49.3319473,
                32.6429148
              ],
              [
                49.3345566,
                32.6437296
              ],
              [
                49.3372229,
                32.6444549
              ],
              [
                49.3396186,
                32.6450413
              ],
              [
                49.3408661,
                32.6452675
              ],
              [
                49.3418999,
                32.6455878
              ],
              [
                49.3432617,
                32.646041
              ],
              [
                49.3464737,
                32.6473167
              ],
              [
                49.3500708,
                32.6487283
              ],
              [
                49.352955,
                32.6497763
              ],
              [
                49.3550165,
                32.6503229
              ],
              [
                49.3556747,
                32.6504974
              ],
              [
                49.3571361,
                32.6507787
              ],
              [
                49.3580133,
                32.6509475
              ],
              [
                49.3599166,
                32.6511685
              ],
              [
                49.3623619,
                32.6514823
              ],
              [
                49.3642615,
                32.6517483
              ],
              [
                49.3666002,
                32.6520111
              ],
              [
                49.3689346,
                32.652091
              ],
              [
                49.3708877,
                32.6519924
              ],
              [
                49.3723488,
                32.6517069
              ],
              [
                49.3735388,
                32.6512872
              ],
              [
                49.3745118,
                32.6508218
              ],
              [
                49.3753777,
                32.6501723
              ],
              [
                49.3760187,
                32.6492922
              ],
              [
                49.3769342,
                32.6482781
              ],
              [
                49.3777925,
                32.6468889
              ],
              [
                49.3784332,
                32.6460561
              ],
              [
                49.3795624,
                32.6445307
              ],
              [
                49.3808517,
                32.6430478
              ],
              [
                49.3822517,
                32.6416138
              ],
              [
                49.3830567,
                32.6404561
              ],
              [
                49.3840256,
                32.6394855
              ],
              [
                49.3853151,
                32.6380049
              ],
              [
                49.3865511,
                32.6366611
              ],
              [
                49.3880539,
                32.6347209
              ],
              [
                49.3900415,
                32.6323631
              ],
              [
                49.3924638,
                32.6295846
              ],
              [
                49.3940736,
                32.6276434
              ],
              [
                49.395954,
                32.6253766
              ],
              [
                49.3992844,
                32.6213535
              ],
              [
                49.4021837,
                32.6176564
              ],
              [
                49.4061624,
                32.6128929
              ],
              [
                49.4096528,
                32.6087295
              ],
              [
                49.4110984,
                32.6062404
              ],
              [
                49.4132997,
                32.6034203
              ],
              [
                49.4153366,
                32.6006929
              ],
              [
                49.4181824,
                32.5971796
              ],
              [
                49.4209252,
                32.5939445
              ],
              [
                49.4235039,
                32.5909418
              ],
              [
                49.4258691,
                32.5881687
              ],
              [
                49.4282912,
                32.5857615
              ],
              [
                49.4311982,
                32.5830355
              ],
              [
                49.4343223,
                32.5803529
              ],
              [
                49.4346309,
                32.5801165
              ],
              [
                49.4368018,
                32.5784536
              ],
              [
                49.4390144,
                32.5769274
              ],
              [
                49.4399914,
                32.5763451
              ],
              [
                49.4401193,
                32.5762688
              ],
              [
                49.4409599,
                32.5757678
              ],
              [
                49.442524,
                32.5749326
              ],
              [
                49.4444197,
                32.5742796
              ],
              [
                49.4460983,
                32.5737682
              ],
              [
                49.4471778,
                32.5732111
              ],
              [
                49.4489669,
                32.5727912
              ],
              [
                49.4518393,
                32.5723644
              ],
              [
                49.4549827,
                32.5721708
              ],
              [
                49.4575348,
                32.5719767
              ],
              [
                49.4591066,
                32.5720591
              ],
              [
                49.4595574,
                32.5721004
              ],
              [
                49.4610635,
                32.5722387
              ],
              [
                49.4626923,
                32.5725089
              ],
              [
                49.4644889,
                32.5729593
              ],
              [
                49.4659577,
                32.5734169
              ],
              [
                49.4677601,
                32.5740656
              ],
              [
                49.4691161,
                32.5745536
              ],
              [
                49.472439,
                32.5759695
              ],
              [
                49.4735096,
                32.576376
              ],
              [
                49.4754334,
                32.5771063
              ],
              [
                49.4778823,
                32.578065
              ],
              [
                49.4808441,
                32.5792103
              ],
              [
                49.483219,
                32.5801612
              ],
              [
                49.484909,
                32.5808445
              ],
              [
                49.4860534,
                32.5812079
              ],
              [
                49.4869765,
                32.5813903
              ],
              [
                49.4887695,
                32.5814751
              ],
              [
                49.4902879,
                32.5816534
              ],
              [
                49.4925691,
                32.5817327
              ],
              [
                49.4944688,
                32.5817261
              ],
              [
                49.4969206,
                32.5816518
              ],
              [
                49.4985137,
                32.5815693
              ],
              [
                49.5000234,
                32.5816888
              ],
              [
                49.5011139,
                32.5816996
              ],
              [
                49.5015674,
                32.5816979
              ],
              [
                49.5031165,
                32.5816919
              ],
              [
                49.5050123,
                32.581498
              ],
              [
                49.506256,
                32.5814023
              ],
              [
                49.507717,
                32.5813949
              ],
              [
                49.5085296,
                32.5814361
              ],
              [
                49.5091781,
                32.5816197
              ],
              [
                49.5098267,
                32.5818934
              ],
              [
                49.5108605,
                32.5825348
              ],
              [
                49.5129203,
                32.5840452
              ],
              [
                49.5132906,
                32.5844017
              ],
              [
                49.5140611,
                32.5851433
              ],
              [
                49.5153617,
                32.5860178
              ],
              [
                49.5169907,
                32.5874374
              ],
              [
                49.5187301,
                32.5889056
              ],
              [
                49.5190203,
                32.5891384
              ],
              [
                49.5198707,
                32.589821
              ],
              [
                49.52166,
                32.5910574
              ],
              [
                49.5242119,
                32.5929365
              ],
              [
                49.525627,
                32.5941324
              ],
              [
                49.5267677,
                32.5950478
              ],
              [
                49.5274733,
                32.5961046
              ],
              [
                49.5294304,
                32.597476
              ],
              [
                49.5320932,
                32.5995411
              ],
              [
                49.5344277,
                32.6014219
              ],
              [
                49.5369262,
                32.6033474
              ],
              [
                49.5392113,
                32.6054125
              ],
              [
                49.5408974,
                32.6070669
              ],
              [
                49.5428046,
                32.6090395
              ],
              [
                49.5442734,
                32.6105538
              ],
              [
                49.5462378,
                32.6133614
              ],
              [
                49.5483093,
                32.6160237
              ],
              [
                49.5498924,
                32.6179992
              ],
              [
                49.5514717,
                32.6196545
              ],
              [
                49.5538674,
                32.6219529
              ],
              [
                49.5561524,
                32.6240154
              ],
              [
                49.5586585,
                32.6259879
              ],
              [
                49.5623589,
                32.6290159
              ],
              [
                49.5652999,
                32.6310338
              ],
              [
                49.5654716,
                32.6311533
              ],
              [
                49.5674783,
                32.6325492
              ],
              [
                49.5804386,
                32.6324168
              ],
              [
                49.5649528,
                32.63671
              ],
              [
                49.5632821,
                32.638885
              ],
              [
                49.5615042,
                32.6411511
              ],
              [
                49.5600471,
                32.6425392
              ],
              [
                49.5591317,
                32.6437418
              ],
              [
                49.5578346,
                32.6450393
              ],
              [
                49.5570297,
                32.6460538
              ],
              [
                49.5556298,
                32.6482272
              ],
              [
                49.5540123,
                32.6502155
              ],
              [
                49.5522843,
                32.6520649
              ],
              [
                49.5504495,
                32.6539198
              ],
              [
                49.547474,
                32.6562801
              ],
              [
                49.5458526,
                32.6576233
              ],
              [
                49.5437966,
                32.6589659
              ],
              [
                49.5424463,
                32.6599424
              ],
              [
                49.5419617,
                32.6611409
              ],
              [
                49.5370444,
                32.6660918
              ],
              [
                49.5337981,
                32.6690056
              ],
              [
                49.5259551,
                32.676179
              ],
              [
                49.5207596,
                32.6808058
              ],
              [
                49.5166427,
                32.6844458
              ],
              [
                49.5160483,
                32.6849713
              ],
              [
                49.5143737,
                32.6875581
              ],
              [
                49.5124283,
                32.6904213
              ],
              [
                49.5102616,
                32.6930992
              ],
              [
                49.5086364,
                32.6948139
              ],
              [
                49.5067979,
                32.6968462
              ],
              [
                49.5050086,
                32.6987415
              ],
              [
                49.5033838,
                32.7005418
              ],
              [
                49.5019189,
                32.7017893
              ],
              [
                49.5005647,
                32.7029502
              ],
              [
                49.5000772,
                32.7030932
              ],
              [
                49.5002055,
                32.7096321
              ],
              [
                49.5002391,
                32.7113466
              ],
              [
                49.500289,
                32.7138876
              ],
              [
                49.5004487,
                32.7147847
              ],
              [
                49.5008256,
                32.7156708
              ],
              [
                49.5008323,
                32.7160473
              ],
              [
                49.5004575,
                32.7160295
              ],
              [
                49.4878946,
                32.7207446
              ],
              [
                49.4863205,
                32.7224433
              ],
              [
                49.4799022,
                32.7294881
              ],
              [
                49.4767932,
                32.7274907
              ],
              [
                49.4731551,
                32.7278668
              ],
              [
                49.4699917,
                32.7349729
              ],
              [
                49.4649419,
                32.7404657
              ],
              [
                49.4525131,
                32.7457109
              ],
              [
                49.4456033,
                32.751201
              ],
              [
                49.4420354,
                32.7572068
              ],
              [
                49.4366243,
                32.76428
              ],
              [
                49.4354586,
                32.7693499
              ],
              [
                49.4354877,
                32.7737911
              ],
              [
                49.430839,
                32.7807178
              ],
              [
                49.4290062,
                32.7839756
              ],
              [
                49.4271499,
                32.7871361
              ],
              [
                49.4263378,
                32.7886019
              ],
              [
                49.4230656,
                32.7901943
              ],
              [
                49.4201087,
                32.7900201
              ],
              [
                49.4189986,
                32.7910884
              ],
              [
                49.4185258,
                32.7916913
              ],
              [
                49.4182129,
                32.7924765
              ],
              [
                49.4181671,
                32.7929878
              ],
              [
                49.4180678,
                32.7935457
              ],
              [
                49.4181824,
                32.7939147
              ],
              [
                49.418293,
                32.7941889
              ],
              [
                49.4183044,
                32.7947911
              ],
              [
                49.4182548,
                32.7952527
              ],
              [
                49.4181519,
                32.7954859
              ],
              [
                49.417942,
                32.7959026
              ],
              [
                49.4174689,
                32.7965551
              ],
              [
                49.4170456,
                32.7970165
              ],
              [
                49.4164735,
                32.7982674
              ],
              [
                49.4157411,
                32.7995186
              ],
              [
                49.415432,
                32.8003535
              ],
              [
                49.4152259,
                32.80091
              ],
              [
                49.41502,
                32.8016042
              ],
              [
                49.4146539,
                32.8022985
              ],
              [
                49.4143905,
                32.8028115
              ],
              [
                49.4139213,
                32.803597
              ],
              [
                49.4132347,
                32.8044316
              ],
              [
                49.4123306,
                32.8053131
              ],
              [
                49.4112167,
                32.8062437
              ],
              [
                49.4103165,
                32.8071703
              ],
              [
                49.4098433,
                32.8080053
              ],
              [
                49.4088898,
                32.8089785
              ],
              [
                49.4080964,
                32.8097689
              ],
              [
                49.4076196,
                32.8104167
              ],
              [
                49.4073562,
                32.8109275
              ],
              [
                49.4072569,
                32.8114403
              ],
              [
                49.4071579,
                32.8119013
              ],
              [
                49.4068412,
                32.8124587
              ],
              [
                49.4063684,
                32.813199
              ],
              [
                49.4054145,
                32.8143571
              ],
              [
                49.4043006,
                32.815335
              ],
              [
                49.4036635,
                32.8160755
              ],
              [
                49.4029236,
                32.8169093
              ],
              [
                49.4023934,
                32.8176985
              ],
              [
                49.4018671,
                32.8184426
              ],
              [
                49.4016038,
                32.8189038
              ],
              [
                49.4011231,
                32.819184
              ],
              [
                49.400692,
                32.8192326
              ],
              [
                49.4000474,
                32.8191409
              ],
              [
                49.3996696,
                32.8191406
              ],
              [
                49.3992386,
                32.8192366
              ],
              [
                49.3985976,
                32.8193749
              ],
              [
                49.3981132,
                32.8195604
              ],
              [
                49.3976364,
                32.8199804
              ],
              [
                49.3967323,
                32.8207693
              ],
              [
                49.3958818,
                32.8216062
              ],
              [
                49.3937529,
                32.8236015
              ],
              [
                49.3916206,
                32.8254117
              ],
              [
                49.3908807,
                32.8262929
              ],
              [
                49.3898658,
                32.8270374
              ],
              [
                49.3892118,
                32.8274854
              ],
              [
                49.3888511,
                32.8277324
              ],
              [
                49.3877793,
                32.8281515
              ],
              [
                49.3870811,
                32.8283837
              ],
              [
                49.3866182,
                32.8284349
              ],
              [
                49.3862228,
                32.8284787
              ],
              [
                49.3855783,
                32.8287116
              ],
              [
                49.3850976,
                32.8290414
              ],
              [
                49.3836593,
                32.8303418
              ],
              [
                49.3830185,
                32.8308477
              ],
              [
                49.3825913,
                32.8311758
              ],
              [
                49.3815726,
                32.8317331
              ],
              [
                49.3805047,
                32.8324318
              ],
              [
                49.3795966,
                32.8331303
              ],
              [
                49.3781547,
                32.8342886
              ],
              [
                49.3773003,
                32.8349382
              ],
              [
                49.3765563,
                32.8357741
              ],
              [
                49.3760261,
                32.8364707
              ],
              [
                49.3756561,
                32.8371198
              ],
              [
                49.3754427,
                32.8374891
              ],
              [
                49.3753928,
                32.8378605
              ],
              [
                49.3754501,
                32.8381836
              ],
              [
                49.375468,
                32.8383206
              ],
              [
                49.375511,
                32.8386489
              ],
              [
                49.3754615,
                32.8389279
              ],
              [
                49.3751946,
                32.8391566
              ],
              [
                49.374981,
                32.8393906
              ],
              [
                49.3728944,
                32.8408314
              ],
              [
                49.3727408,
                32.8409445
              ],
              [
                49.3711282,
                32.8421319
              ],
              [
                49.3697394,
                32.8432006
              ],
              [
                49.3692588,
                32.8435754
              ],
              [
                49.3682145,
                32.8440701
              ],
              [
                49.3675957,
                32.8443632
              ],
              [
                49.3671645,
                32.8445515
              ],
              [
                49.3664666,
                32.8446461
              ],
              [
                49.3660316,
                32.8446472
              ],
              [
                49.365383,
                32.8445102
              ],
              [
                49.3653722,
                32.8445071
              ],
              [
                49.3647346,
                32.8443258
              ],
              [
                49.3640862,
                32.8441437
              ],
              [
                49.3633841,
                32.8439587
              ],
              [
                49.3625184,
                32.843776
              ],
              [
                49.3615456,
                32.8436393
              ],
              [
                49.3610078,
                32.843639
              ],
              [
                49.3598214,
                32.8437339
              ],
              [
                49.3583108,
                32.8438336
              ],
              [
                49.3569105,
                32.8437927
              ],
              [
                49.354805,
                32.8437966
              ],
              [
                49.3535117,
                32.8438449
              ],
              [
                49.3526496,
                32.8439869
              ],
              [
                49.3519517,
                32.8442641
              ],
              [
                49.3514137,
                32.8444509
              ],
              [
                49.3510399,
                32.8446399
              ],
              [
                49.3507158,
                32.8448724
              ],
              [
                49.350506,
                32.8451492
              ],
              [
                49.3502923,
                32.8453831
              ],
              [
                49.3500785,
                32.8456622
              ],
              [
                49.349594,
                32.8457527
              ],
              [
                49.3490523,
                32.8457568
              ],
              [
                49.3480263,
                32.8456644
              ],
              [
                49.3471689,
                32.8454926
              ],
              [
                49.3471109,
                32.8454809
              ],
              [
                49.3464049,
                32.8452529
              ],
              [
                49.3455391,
                32.845025
              ],
              [
                49.3450508,
                32.8446533
              ],
              [
                49.3445626,
                32.8444258
              ],
              [
                49.3440247,
                32.8442428
              ],
              [
                49.3434297,
                32.8441042
              ],
              [
                49.3428879,
                32.8439685
              ],
              [
                49.3421288,
                32.8436428
              ],
              [
                49.3418044,
                32.8434153
              ],
              [
                49.3413162,
                32.8430435
              ],
              [
                49.3404998,
                32.8420248
              ],
              [
                49.3400916,
                32.8415562
              ],
              [
                49.3397369,
                32.8411489
              ],
              [
                49.3390845,
                32.8405044
              ],
              [
                49.3385391,
                32.839992
              ],
              [
                49.3382148,
                32.8397645
              ],
              [
                49.3376197,
                32.8395807
              ],
              [
                49.3371352,
                32.8395811
              ],
              [
                49.3363801,
                32.8396297
              ],
              [
                49.335144,
                32.8399582
              ],
              [
                49.333313,
                32.8402856
              ],
              [
                49.3316992,
                32.840706
              ],
              [
                49.3312682,
                32.8408468
              ],
              [
                49.3305665,
                32.8408961
              ],
              [
                49.3302419,
                32.8409244
              ],
              [
                49.3300284,
                32.840943
              ],
              [
                49.3293801,
                32.8408509
              ],
              [
                49.3287315,
                32.8406686
              ],
              [
                49.3280829,
                32.8403939
              ],
              [
                49.3280678,
                32.8403825
              ],
              [
                49.3276483,
                32.8400679
              ],
              [
                49.3269996,
                32.8398405
              ],
              [
                49.3266754,
                32.8396987
              ],
              [
                49.3262443,
                32.8397019
              ],
              [
                49.3258667,
                32.8397036
              ],
              [
                49.3256434,
                32.8397739
              ],
              [
                49.3239518,
                32.8393477
              ],
              [
                49.3199377,
                32.8393477
              ],
              [
                49.3195037,
                32.8392553
              ],
              [
                49.3190156,
                32.8391653
              ],
              [
                49.3187445,
                32.8391639
              ],
              [
                49.3184241,
                32.8393513
              ],
              [
                49.3181039,
                32.8395837
              ],
              [
                49.3179437,
                32.8399536
              ],
              [
                49.3177486,
                32.8401788
              ],
              [
                49.3162667,
                32.8407837
              ],
              [
                49.3154145,
                32.8409342
              ],
              [
                49.3145026,
                32.8412579
              ],
              [
                49.3134268,
                32.8417733
              ],
              [
                49.3125113,
                32.8422863
              ],
              [
                49.3123916,
                32.8423652
              ],
              [
                49.3120373,
                32.8425988
              ],
              [
                49.310791,
                32.843555
              ],
              [
                49.3105813,
                32.8437281
              ],
              [
                49.3098296,
                32.8444214
              ],
              [
                49.3087579,
                32.8452615
              ],
              [
                49.3083834,
                32.8454356
              ],
              [
                49.3073579,
                32.8459122
              ],
              [
                49.3063354,
                32.8466063
              ],
              [
                49.3051529,
                32.8472126
              ],
              [
                49.3042374,
                32.8476331
              ],
              [
                49.3034859,
                32.8479612
              ],
              [
                49.3028411,
                32.8484733
              ],
              [
                49.3025207,
                32.8488883
              ],
              [
                49.3021965,
                32.849168
              ],
              [
                49.3018104,
                32.8492679
              ],
              [
                49.3016586,
                32.8493072
              ],
              [
                49.3011169,
                32.8492616
              ],
              [
                49.3006325,
                32.8490791
              ],
              [
                49.3001976,
                32.8488951
              ],
              [
                49.2996655,
                32.8487117
              ],
              [
                49.2996596,
                32.8487096
              ],
              [
                49.2990112,
                32.8486219
              ],
              [
                49.298416,
                32.8486679
              ],
              [
                49.2973403,
                32.848854
              ],
              [
                49.2965911,
                32.8490722
              ],
              [
                49.2963716,
                32.8491362
              ],
              [
                49.2955095,
                32.8496926
              ],
              [
                49.2941664,
                32.8506235
              ],
              [
                49.2934113,
                32.851089
              ],
              [
                49.2924423,
                32.8514185
              ],
              [
                49.291256,
                32.8514677
              ],
              [
                49.2903366,
                32.8514213
              ],
              [
                49.2897415,
                32.8511471
              ],
              [
                49.2891466,
                32.850918
              ],
              [
                49.2882804,
                32.8505026
              ],
              [
                49.2873076,
                32.849761
              ],
              [
                49.2871645,
                32.8496655
              ],
              [
                49.2865487,
                32.8492545
              ],
              [
                49.2859039,
                32.8491172
              ],
              [
                49.2846605,
                32.8491204
              ],
              [
                49.2837981,
                32.8492168
              ],
              [
                49.283043,
                32.8495402
              ],
              [
                49.2818071,
                32.8501004
              ],
              [
                49.2805671,
                32.850753
              ],
              [
                49.2800291,
                32.8514491
              ],
              [
                49.2797277,
                32.8519744
              ],
              [
                49.2796556,
                32.8521001
              ],
              [
                49.2793311,
                32.8525624
              ],
              [
                49.2789001,
                32.8527481
              ],
              [
                49.278633,
                32.8527489
              ],
              [
                49.2783623,
                32.8526573
              ],
              [
                49.2781981,
                32.8524295
              ],
              [
                49.2780393,
                32.8523094
              ],
              [
                49.2777673,
                32.8521034
              ],
              [
                49.2774926,
                32.8517344
              ],
              [
                49.2770082,
                32.8515045
              ],
              [
                49.276306,
                32.8515061
              ],
              [
                49.2755508,
                32.8515543
              ],
              [
                49.2746886,
                32.8516055
              ],
              [
                49.2734452,
                32.8517913
              ],
              [
                49.2724227,
                32.8519328
              ],
              [
                49.2710188,
                32.8520284
              ],
              [
                49.2697257,
                32.8522653
              ],
              [
                49.2692413,
                32.8524502
              ],
              [
                49.268753,
                32.8527298
              ],
              [
                49.2684328,
                32.8533319
              ],
              [
                49.268055,
                32.8540775
              ],
              [
                49.2678415,
                32.8546337
              ],
              [
                49.2674674,
                32.8555146
              ],
              [
                49.2673074,
                32.8561167
              ],
              [
                49.2667694,
                32.8567203
              ],
              [
                49.2661742,
                32.8572779
              ],
              [
                49.2656899,
                32.8578845
              ],
              [
                49.2652587,
                32.8581626
              ],
              [
                49.2641257,
                32.8586272
              ],
              [
                49.2624548,
                32.8589106
              ],
              [
                49.2618573,
                32.8591114
              ],
              [
                49.2612115,
                32.8593285
              ],
              [
                49.2603492,
                32.8599816
              ],
              [
                49.2594873,
                32.8607701
              ],
              [
                49.2587318,
                32.8613728
              ],
              [
                49.2584115,
                32.8617021
              ],
              [
                49.2576523,
                32.8618426
              ],
              [
                49.2570075,
                32.8618426
              ],
              [
                49.2565727,
                32.8615186
              ],
              [
                49.2558708,
                32.8609204
              ],
              [
                49.2555465,
                32.860271
              ],
              [
                49.2553291,
                32.8594405
              ],
              [
                49.2552185,
                32.8587445
              ],
              [
                49.2551612,
                32.8578643
              ],
              [
                49.2548371,
                32.8574495
              ],
              [
                49.2543595,
                32.8570382
              ],
              [
                49.2543527,
                32.8570323
              ],
              [
                49.2543293,
                32.8570265
              ],
              [
                49.2538108,
                32.8568963
              ],
              [
                49.2533262,
                32.8568963
              ],
              [
                49.2527848,
                32.8569902
              ],
              [
                49.2520867,
                32.8575937
              ],
              [
                49.2513275,
                32.8578762
              ],
              [
                49.2500496,
                32.8577884
              ],
              [
                49.2492332,
                32.8575132
              ],
              [
                49.2485771,
                32.8572425
              ],
              [
                49.2480851,
                32.8569222
              ],
              [
                49.2478103,
                32.8566027
              ],
              [
                49.2478599,
                32.8561862
              ],
              [
                49.2478027,
                32.8556781
              ],
              [
                49.2478525,
                32.855034
              ],
              [
                49.2478414,
                32.8549973
              ],
              [
                49.2477418,
                32.8546672
              ],
              [
                49.2473603,
                32.8544386
              ],
              [
                49.2467041,
                32.8543054
              ],
              [
                49.2461625,
                32.8543046
              ],
              [
                49.2455634,
                32.8543097
              ],
              [
                49.2443123,
                32.8546416
              ],
              [
                49.2434425,
                32.8548278
              ],
              [
                49.2424089,
                32.8553432
              ],
              [
                49.2415962,
                32.8558999
              ],
              [
                49.2407578,
                32.8563194
              ],
              [
                49.2405662,
                32.8564153
              ],
              [
                49.2395323,
                32.8569261
              ],
              [
                49.2377435,
                32.8580891
              ],
              [
                49.2372016,
                32.8581401
              ],
              [
                49.2368736,
                32.8580927
              ],
              [
                49.2364351,
                32.8579602
              ],
              [
                49.2357789,
                32.8574572
              ],
              [
                49.2348479,
                32.856815
              ],
              [
                49.2336958,
                32.8556218
              ],
              [
                49.2324408,
                32.8547563
              ],
              [
                49.231781,
                32.8542983
              ],
              [
                49.2307472,
                32.8539815
              ],
              [
                49.2298737,
                32.8538474
              ],
              [
                49.2288359,
                32.8535757
              ],
              [
                49.2274744,
                32.8534008
              ],
              [
                49.2264403,
                32.853314
              ],
              [
                49.2257844,
                32.8530883
              ],
              [
                49.2248572,
                32.8528632
              ],
              [
                49.2237665,
                32.8530078
              ],
              [
                49.2230605,
                32.8531961
              ],
              [
                49.2222444,
                32.8531981
              ],
              [
                49.2215348,
                32.8530662
              ],
              [
                49.2210999,
                32.8527917
              ],
              [
                49.2204399,
                32.8523337
              ],
              [
                49.2198409,
                32.8520163
              ],
              [
                49.2193488,
                32.8519258
              ],
              [
                49.2188074,
                32.8520196
              ],
              [
                49.2179907,
                32.8521658
              ],
              [
                49.217121,
                32.8524938
              ],
              [
                49.2161445,
                32.8530053
              ],
              [
                49.2154923,
                32.853607
              ],
              [
                49.215168,
                32.8539766
              ],
              [
                49.2149581,
                32.8546726
              ],
              [
                49.2144737,
                32.8559644
              ],
              [
                49.2140999,
                32.8567054
              ],
              [
                49.2137224,
                32.8571667
              ],
              [
                49.2130698,
                32.8575858
              ],
              [
                49.2123145,
                32.8584678
              ],
              [
                49.2113382,
                32.8593941
              ],
              [
                49.2100412,
                32.86069
              ],
              [
                49.2085228,
                32.8618542
              ],
              [
                49.2072791,
                32.8628736
              ],
              [
                49.2062493,
                32.8636637
              ],
              [
                49.205059,
                32.8645485
              ],
              [
                49.2042998,
                32.8649683
              ],
              [
                49.2037544,
                32.8649221
              ],
              [
                49.2033692,
                32.8646505
              ],
              [
                49.2030945,
                32.8643264
              ],
              [
                49.2028199,
                32.8638693
              ],
              [
                49.2027628,
                32.8634062
              ],
              [
                49.2027054,
                32.8630401
              ],
              [
                49.2024522,
                32.8630096
              ],
              [
                49.2017232,
                32.8632389
              ],
              [
                49.2002749,
                32.8637652
              ],
              [
                49.2000427,
                32.864021
              ],
              [
                49.1996118,
                32.8646235
              ],
              [
                49.1989631,
                32.8654597
              ],
              [
                49.1983146,
                32.8661989
              ],
              [
                49.1976129,
                32.8666645
              ],
              [
                49.1966896,
                32.867039
              ],
              [
                49.1959839,
                32.867322
              ],
              [
                49.1947367,
                32.8683885
              ],
              [
                49.1932717,
                32.869321
              ],
              [
                49.1918107,
                32.8701544
              ],
              [
                49.190235,
                32.8709952
              ],
              [
                49.1888238,
                32.8717887
              ],
              [
                49.1870919,
                32.8729518
              ],
              [
                49.1853028,
                32.8741614
              ],
              [
                49.1838914,
                32.8749504
              ],
              [
                49.1825369,
                32.8757897
              ],
              [
                49.181343,
                32.8764871
              ],
              [
                49.1804771,
                32.8772321
              ],
              [
                49.1791765,
                32.8780203
              ],
              [
                49.1780394,
                32.8788605
              ],
              [
                49.1768457,
                32.8797427
              ],
              [
                49.176033,
                32.8803486
              ],
              [
                49.1751709,
                32.8812763
              ],
              [
                49.174141,
                32.8822939
              ],
              [
                49.1732751,
                32.883129
              ],
              [
                49.1725733,
                32.8836395
              ],
              [
                49.1719742,
                32.8839216
              ],
              [
                49.171215,
                32.8839714
              ],
              [
                49.1706694,
                32.883977
              ],
              [
                49.1699028,
                32.8836546
              ],
              [
                49.1695213,
                32.8834303
              ],
              [
                49.1689187,
                32.8828308
              ],
              [
                49.1684228,
                32.8818675
              ],
              [
                49.1679268,
                32.8810892
              ],
              [
                49.167431,
                32.8806264
              ],
              [
                49.1669961,
                32.8804465
              ],
              [
                49.1662332,
                32.8802233
              ],
              [
                49.1652489,
                32.8800894
              ],
              [
                49.164486,
                32.8797693
              ],
              [
                49.1636124,
                32.8794521
              ],
              [
                49.1630095,
                32.8791321
              ],
              [
                49.1624108,
                32.8787693
              ],
              [
                49.1620787,
                32.8784488
              ],
              [
                49.1619681,
                32.8778046
              ],
              [
                49.1620751,
                32.8775243
              ],
              [
                49.1622314,
                32.8768299
              ],
              [
                49.1624449,
                32.8760462
              ],
              [
                49.1628722,
                32.8751687
              ],
              [
                49.1630468,
                32.8748122
              ],
              [
                49.1631431,
                32.8746157
              ],
              [
                49.1629754,
                32.8738737
              ],
              [
                49.1624793,
                32.8732802
              ],
              [
                49.1618195,
                32.8725468
              ],
              [
                49.1614379,
                32.8720857
              ],
              [
                49.1608888,
                32.8718612
              ],
              [
                49.1596908,
                32.8716362
              ],
              [
                49.1585997,
                32.8713653
              ],
              [
                49.15707,
                32.8708693
              ],
              [
                49.156086,
                32.8704557
              ],
              [
                49.1549949,
                32.8699572
              ],
              [
                49.1542854,
                32.8695003
              ],
              [
                49.1536827,
                32.8694125
              ],
              [
                49.1531399,
                32.8693448
              ],
              [
                49.1522674,
                32.869236
              ],
              [
                49.1508521,
                32.8691519
              ],
              [
                49.1491622,
                32.8689759
              ],
              [
                49.1472015,
                32.8688972
              ],
              [
                49.1453476,
                32.8690005
              ],
              [
                49.1430627,
                32.869014
              ],
              [
                49.1425723,
                32.8690717
              ],
              [
                49.1414299,
                32.8692061
              ],
              [
                49.1393089,
                32.8694948
              ],
              [
                49.1370774,
                32.8698313
              ],
              [
                49.1350668,
                32.8705364
              ],
              [
                49.1332781,
                32.8711928
              ],
              [
                49.1317023,
                32.8718953
              ],
              [
                49.1304017,
                32.8727304
              ],
              [
                49.1293718,
                32.8734748
              ],
              [
                49.1283988,
                32.8743553
              ],
              [
                49.1278037,
                32.8750994
              ],
              [
                49.1270484,
                32.8760261
              ],
              [
                49.1265641,
                32.8769026
              ],
              [
                49.1264077,
                32.8775068
              ],
              [
                49.1261979,
                32.8787031
              ],
              [
                49.1259309,
                32.8796303
              ],
              [
                49.1257486,
                32.8801527
              ],
              [
                49.1255608,
                32.8806912
              ],
              [
                49.1250229,
                32.8815737
              ],
              [
                49.1245383,
                32.8823127
              ],
              [
                49.1236724,
                32.8832399
              ],
              [
                49.1225356,
                32.8842622
              ],
              [
                49.1211815,
                32.8851933
              ],
              [
                49.1202623,
                32.885892
              ],
              [
                49.11874,
                32.8864508
              ],
              [
                49.1172217,
                32.887199
              ],
              [
                49.1157569,
                32.887948
              ],
              [
                49.114891,
                32.888458
              ],
              [
                49.1141321,
                32.8887397
              ],
              [
                49.1134225,
                32.8888846
              ],
              [
                49.1125527,
                32.8889346
              ],
              [
                49.1116255,
                32.8888484
              ],
              [
                49.1108094,
                32.8887594
              ],
              [
                49.1098825,
                32.8884433
              ],
              [
                49.1086806,
                32.8880351
              ],
              [
                49.1074218,
                32.8873982
              ],
              [
                49.1058921,
                32.8866243
              ],
              [
                49.1038704,
                32.8857572
              ],
              [
                49.1023445,
                32.8852605
              ],
              [
                49.1009788,
                32.8850369
              ],
              [
                49.0999451,
                32.8849062
              ],
              [
                49.0984191,
                32.8848695
              ],
              [
                49.09684,
                32.8849717
              ],
              [
                49.0950469,
                32.8852127
              ],
              [
                49.0935784,
                32.8855443
              ],
              [
                49.0925447,
                32.8858712
              ],
              [
                49.0915146,
                32.8864778
              ],
              [
                49.0908662,
                32.8868512
              ],
              [
                49.0901604,
                32.8873184
              ],
              [
                49.0894584,
                32.8879209
              ],
              [
                49.0887567,
                32.8886181
              ],
              [
                49.0880547,
                32.8894506
              ],
              [
                49.0874632,
                32.8903321
              ],
              [
                49.0871927,
                32.890842
              ],
              [
                49.0870362,
                32.8915792
              ],
              [
                49.0868225,
                32.892135
              ],
              [
                49.0865554,
                32.8926427
              ],
              [
                49.0859071,
                32.8934783
              ],
              [
                49.0851516,
                32.8945422
              ],
              [
                49.0847207,
                32.8950992
              ],
              [
                49.0840719,
                32.8955199
              ],
              [
                49.0832595,
                32.8960305
              ],
              [
                49.0822296,
                32.8967317
              ],
              [
                49.0809822,
                32.8975671
              ],
              [
                49.0804978,
                32.897988
              ],
              [
                49.08012,
                32.8983565
              ],
              [
                49.0790291,
                32.8983645
              ],
              [
                49.078594,
                32.8983691
              ],
              [
                49.0782128,
                32.89814
              ],
              [
                49.0764657,
                32.897412
              ],
              [
                49.0749893,
                32.8967737
              ],
              [
                49.0739518,
                32.8965503
              ],
              [
                49.0728607,
                32.8963238
              ],
              [
                49.0717201,
                32.896331
              ],
              [
                49.0709572,
                32.8963846
              ],
              [
                49.0701982,
                32.8966187
              ],
              [
                49.0693282,
                32.8971779
              ],
              [
                49.0691799,
                32.897382
              ],
              [
                49.0687903,
                32.8979181
              ],
              [
                49.0684699,
                32.8986121
              ],
              [
                49.0684522,
                32.8987119
              ],
              [
                49.0683135,
                32.8994912
              ],
              [
                49.0680503,
                32.9005085
              ],
              [
                49.0677262,
                32.9010626
              ],
              [
                49.0672417,
                32.9016188
              ],
              [
                49.0667535,
                32.9019021
              ],
              [
                49.0658303,
                32.9021381
              ],
              [
                49.0646896,
                32.9023752
              ],
              [
                49.0634347,
                32.9023354
              ],
              [
                49.0616952,
                32.9025317
              ],
              [
                49.0602798,
                32.9027262
              ],
              [
                49.0588684,
                32.9030109
              ],
              [
                49.0577277,
                32.9033855
              ],
              [
                49.0570755,
                32.9038037
              ],
              [
                49.0564803,
                32.9042251
              ],
              [
                49.0559426,
                32.9047353
              ],
              [
                49.0553438,
                32.9051092
              ],
              [
                49.0549659,
                32.9051552
              ],
              [
                49.0544206,
                32.9051129
              ],
              [
                49.0538215,
                32.9050247
              ],
              [
                49.0531656,
                32.9049378
              ],
              [
                49.0527841,
                32.9047537
              ],
              [
                49.0521279,
                32.9043422
              ],
              [
                49.0516358,
                32.9040685
              ],
              [
                49.050537,
                32.9029241
              ],
              [
                49.0499902,
                32.902344
              ],
              [
                49.049713,
                32.9020499
              ],
              [
                49.0488357,
                32.9014095
              ],
              [
                49.0476341,
                32.900676
              ],
              [
                49.0463753,
                32.8999033
              ],
              [
                49.0454482,
                32.8995393
              ],
              [
                49.045233,
                32.8994584
              ],
              [
                49.0443535,
                32.8991277
              ],
              [
                49.0429917,
                32.8987704
              ],
              [
                49.041191,
                32.8984108
              ],
              [
                49.0398828,
                32.8981851
              ],
              [
                49.038685,
                32.8981934
              ],
              [
                49.0379792,
                32.8984303
              ],
              [
                49.0371094,
                32.898712
              ],
              [
                49.0362931,
                32.8989021
              ],
              [
                49.0355339,
                32.8992757
              ],
              [
                49.0342904,
                32.8999754
              ],
              [
                49.0332605,
                32.9006265
              ],
              [
                49.0317422,
                32.9014661
              ],
              [
                49.0304946,
                32.9023055
              ],
              [
                49.0293005,
                32.9027759
              ],
              [
                49.0281065,
                32.9031989
              ],
              [
                49.0275118,
                32.9033384
              ],
              [
                49.026638,
                32.9033471
              ],
              [
                49.0258217,
                32.9033049
              ],
              [
                49.0247306,
                32.9031253
              ],
              [
                49.0234755,
                32.9027628
              ],
              [
                49.0223314,
                32.9023096
              ],
              [
                49.0209083,
                32.9018091
              ],
              [
                49.0200348,
                32.9013556
              ],
              [
                49.0190505,
                32.9007155
              ],
              [
                49.0182837,
                32.9001645
              ],
              [
                49.0176813,
                32.8996161
              ],
              [
                49.0171318,
                32.8993413
              ],
              [
                49.0164975,
                32.8988382
              ],
              [
                49.015971,
                32.8983364
              ],
              [
                49.0149645,
                32.8976369
              ],
              [
                49.0143367,
                32.8977427
              ],
              [
                49.0135984,
                32.8981726
              ],
              [
                49.0129846,
                32.8987095
              ],
              [
                49.0123785,
                32.8992193
              ],
              [
                49.0121241,
                32.8998486
              ],
              [
                49.012134,
                32.9004414
              ],
              [
                49.0120107,
                32.9010313
              ],
              [
                49.0119983,
                32.9018629
              ],
              [
                49.0116669,
                32.9023
              ],
              [
                49.0111636,
                32.9026628
              ],
              [
                49.0103606,
                32.903213
              ],
              [
                49.0099401,
                32.9036536
              ],
              [
                49.0092057,
                32.9042565
              ],
              [
                49.0084071,
                32.9046388
              ],
              [
                49.0073588,
                32.9051483
              ],
              [
                49.0064843,
                32.9056441
              ],
              [
                49.0055757,
                32.9060345
              ],
              [
                49.0046672,
                32.90663
              ],
              [
                49.0043156,
                32.907493
              ],
              [
                49.0045852,
                32.9082745
              ],
              [
                49.0046932,
                32.9086448
              ],
              [
                49.0052678,
                32.9094995
              ],
              [
                49.0060777,
                32.9102298
              ],
              [
                49.0067972,
                32.9109612
              ],
              [
                49.0078093,
                32.9114754
              ],
              [
                49.0082096,
                32.911829
              ],
              [
                49.0089463,
                32.9123462
              ],
              [
                49.0093005,
                32.9131483
              ],
              [
                49.009278,
                32.9140496
              ],
              [
                49.0085389,
                32.9146367
              ],
              [
                49.0080594,
                32.9148737
              ],
              [
                49.0063003,
                32.9151821
              ],
              [
                49.0045269,
                32.9144738
              ],
              [
                49.0034524,
                32.9138847
              ],
              [
                49.0021237,
                32.9129934
              ],
              [
                49.0005791,
                32.9123828
              ],
              [
                48.9988196,
                32.9120676
              ],
              [
                48.9971083,
                32.9121711
              ],
              [
                48.9956257,
                32.9126932
              ],
              [
                48.9948882,
                32.9127856
              ],
              [
                48.9942167,
                32.9126556
              ],
              [
                48.9938003,
                32.9122802
              ],
              [
                48.9935767,
                32.9119628
              ],
              [
                48.9934882,
                32.9129332
              ],
              [
                48.9928323,
                32.9125665
              ],
              [
                48.9920122,
                32.9119671
              ],
              [
                48.9910851,
                32.9113277
              ],
              [
                48.9905397,
                32.911098
              ],
              [
                48.9901581,
                32.9110535
              ],
              [
                48.9898337,
                32.9110979
              ],
              [
                48.9896203,
                32.9112861
              ],
              [
                48.9894026,
                32.9114269
              ],
              [
                48.9890251,
                32.9117974
              ],
              [
                48.9884339,
                32.9121711
              ],
              [
                48.9881096,
                32.9124026
              ],
              [
                48.9875146,
                32.9126365
              ],
              [
                48.9869194,
                32.9128231
              ],
              [
                48.986431,
                32.9129189
              ],
              [
                48.9861604,
                32.9129642
              ],
              [
                48.9855652,
                32.9129681
              ],
              [
                48.9850731,
                32.9129218
              ],
              [
                48.9845846,
                32.9128351
              ],
              [
                48.9843674,
                32.9126016
              ],
              [
                48.983986,
                32.9123722
              ],
              [
                48.9837113,
                32.9120522
              ],
              [
                48.9836006,
                32.9118204
              ],
              [
                48.9835435,
                32.9115399
              ],
              [
                48.9835398,
                32.9112197
              ],
              [
                48.9836463,
                32.9108968
              ],
              [
                48.9837495,
                32.9106189
              ],
              [
                48.9839631,
                32.910203
              ],
              [
                48.9840697,
                32.9098778
              ],
              [
                48.9841195,
                32.9095089
              ],
              [
                48.9841157,
                32.908997
              ],
              [
                48.9841118,
                32.9085799
              ],
              [
                48.9840547,
                32.9081641
              ],
              [
                48.9838869,
                32.9078908
              ],
              [
                48.9835051,
                32.9074293
              ],
              [
                48.9830667,
                32.9071088
              ],
              [
                48.9826849,
                32.9069719
              ],
              [
                48.9822501,
                32.9068341
              ],
              [
                48.9812736,
                32.9066966
              ],
              [
                48.9806746,
                32.906608
              ],
              [
                48.9799155,
                32.9066115
              ],
              [
                48.9794809,
                32.9065662
              ],
              [
                48.9791528,
                32.9065203
              ],
              [
                48.9788246,
                32.9063369
              ],
              [
                48.9785003,
                32.9061558
              ],
              [
                48.978279,
                32.9059267
              ],
              [
                48.9781684,
                32.9056927
              ],
              [
                48.9781646,
                32.9054176
              ],
              [
                48.9782714,
                32.9049526
              ],
              [
                48.9784812,
                32.9043045
              ],
              [
                48.9785309,
                32.9037056
              ],
              [
                48.978548,
                32.903547
              ],
              [
                48.9785805,
                32.9032442
              ],
              [
                48.9785194,
                32.9026412
              ],
              [
                48.978405,
                32.9020893
              ],
              [
                48.9781305,
                32.9017173
              ],
              [
                48.9778594,
                32.9014424
              ],
              [
                48.9774208,
                32.9011648
              ],
              [
                48.976986,
                32.9009368
              ],
              [
                48.9763833,
                32.9006159
              ],
              [
                48.9757882,
                32.9006198
              ],
              [
                48.9749755,
                32.9008524
              ],
              [
                48.9742936,
                32.9009437
              ],
              [
                48.9742698,
                32.9009469
              ],
              [
                48.9734,
                32.9007682
              ],
              [
                48.9728011,
                32.90063
              ],
              [
                48.9719352,
                32.9005438
              ],
              [
                48.971119,
                32.9005463
              ],
              [
                48.9701425,
                32.9005057
              ],
              [
                48.9694901,
                32.900459
              ],
              [
                48.9691084,
                32.9002769
              ],
              [
                48.9688874,
                32.8998157
              ],
              [
                48.9688836,
                32.8994436
              ],
              [
                48.9688759,
                32.8987536
              ],
              [
                48.9688185,
                32.8984303
              ],
              [
                48.9685441,
                32.8980132
              ],
              [
                48.9681624,
                32.8977861
              ],
              [
                48.9678346,
                32.8976477
              ],
              [
                48.9672927,
                32.8976479
              ],
              [
                48.9667511,
                32.8977428
              ],
              [
                48.9663163,
                32.8977921
              ],
              [
                48.9655038,
                32.8977969
              ],
              [
                48.9647981,
                32.8977043
              ],
              [
                48.9642526,
                32.8975714
              ],
              [
                48.9637643,
                32.89748
              ],
              [
                48.963272,
                32.897109
              ],
              [
                48.9628333,
                32.8968358
              ],
              [
                48.9623986,
                32.896698
              ],
              [
                48.9617461,
                32.8966107
              ],
              [
                48.9612578,
                32.8965644
              ],
              [
                48.9607696,
                32.8964279
              ],
              [
                48.9603348,
                32.896245
              ],
              [
                48.9601136,
                32.8960159
              ],
              [
                48.9596216,
                32.8956945
              ],
              [
                48.9588586,
                32.8953732
              ],
              [
                48.9584236,
                32.8951902
              ],
              [
                48.9580423,
                32.8950081
              ],
              [
                48.9576035,
                32.894638
              ],
              [
                48.9570044,
                32.8941345
              ],
              [
                48.9569465,
                32.8940734
              ],
              [
                48.9565657,
                32.8936719
              ],
              [
                48.9560164,
                32.8932571
              ],
              [
                48.9554858,
                32.8927051
              ],
              [
                48.9547279,
                32.8922238
              ],
              [
                48.9540458,
                32.8924041
              ],
              [
                48.953536,
                32.8923488
              ],
              [
                48.9530369,
                32.8924726
              ],
              [
                48.9526053,
                32.8925958
              ],
              [
                48.9521096,
                32.8927271
              ],
              [
                48.9514281,
                32.8930684
              ],
              [
                48.9509538,
                32.893425
              ],
              [
                48.9506413,
                32.8938859
              ],
              [
                48.9501643,
                32.8944258
              ],
              [
                48.9495884,
                32.8947777
              ],
              [
                48.9488323,
                32.8948033
              ],
              [
                48.9481622,
                32.8949095
              ],
              [
                48.9477526,
                32.8949317
              ],
              [
                48.9470357,
                32.8948738
              ],
              [
                48.9462585,
                32.8949625
              ],
              [
                48.9458426,
                32.895264
              ],
              [
                48.945519,
                32.8957407
              ],
              [
                48.9452623,
                32.8961189
              ],
              [
                48.9448573,
                32.8970623
              ],
              [
                48.9445691,
                32.8975598
              ],
              [
                48.9439869,
                32.8978808
              ],
              [
                48.9433844,
                32.8979521
              ],
              [
                48.9428747,
                32.8980117
              ],
              [
                48.9421483,
                32.8980449
              ],
              [
                48.9409318,
                32.8976906
              ],
              [
                48.9399465,
                32.8976454
              ],
              [
                48.9389514,
                32.8976503
              ],
              [
                48.9379344,
                32.8976102
              ],
              [
                48.9372455,
                32.8976971
              ],
              [
                48.9365662,
                32.8977851
              ],
              [
                48.9359048,
                32.897532
              ],
              [
                48.9356049,
                32.8970048
              ],
              [
                48.9352907,
                32.896405
              ],
              [
                48.9350484,
                32.8957949
              ],
              [
                48.9346994,
                32.8951421
              ],
              [
                48.9340791,
                32.8949579
              ],
              [
                48.933495,
                32.8951319
              ],
              [
                48.9327228,
                32.8954973
              ],
              [
                48.9322987,
                32.895801
              ],
              [
                48.9317133,
                32.8961375
              ],
              [
                48.930464,
                32.8964691
              ],
              [
                48.9296511,
                32.896754
              ],
              [
                48.9286326,
                32.897098
              ],
              [
                48.9279404,
                32.8973039
              ],
              [
                48.9273769,
                32.8973934
              ],
              [
                48.9266875,
                32.8974549
              ],
              [
                48.9259578,
                32.8973634
              ],
              [
                48.9258221,
                32.8969771
              ],
              [
                48.9256943,
                32.8962231
              ],
              [
                48.9253914,
                32.8953696
              ],
              [
                48.9248394,
                32.8945836
              ],
              [
                48.924318,
                32.8938144
              ],
              [
                48.9236119,
                32.8928987
              ],
              [
                48.9229989,
                32.8920576
              ],
              [
                48.9224554,
                32.8909413
              ],
              [
                48.9217318,
                32.8900871
              ],
              [
                48.92066,
                32.889651
              ],
              [
                48.9196081,
                32.889379
              ],
              [
                48.9190962,
                32.8890716
              ],
              [
                48.9184442,
                32.8888278
              ],
              [
                48.9173241,
                32.8878253
              ],
              [
                48.9166728,
                32.8872015
              ],
              [
                48.9158238,
                32.8864134
              ],
              [
                48.9142887,
                32.8853111
              ],
              [
                48.913933,
                32.8851643
              ],
              [
                48.9133704,
                32.8851298
              ],
              [
                48.91285,
                32.885314
              ],
              [
                48.912365,
                32.8854903
              ],
              [
                48.9118416,
                32.8856589
              ],
              [
                48.9111427,
                32.8859125
              ],
              [
                48.9104226,
                32.88618
              ],
              [
                48.9098605,
                32.8868235
              ],
              [
                48.9092138,
                32.8871442
              ],
              [
                48.9084323,
                32.8873212
              ],
              [
                48.9074345,
                32.8872711
              ],
              [
                48.9062979,
                32.8870113
              ],
              [
                48.9050066,
                32.886696
              ],
              [
                48.9037978,
                32.8860204
              ],
              [
                48.9034158,
                32.88631
              ],
              [
                48.9027061,
                32.8858539
              ],
              [
                48.9021136,
                32.8854446
              ],
              [
                48.9021073,
                32.8854403
              ],
              [
                48.9015617,
                32.8851651
              ],
              [
                48.9009095,
                32.8850753
              ],
              [
                48.9006385,
                32.8849828
              ],
              [
                48.9004747,
                32.8848448
              ],
              [
                48.9001466,
                32.8848911
              ],
              [
                48.8998756,
                32.8849407
              ],
              [
                48.8994981,
                32.8851282
              ],
              [
                48.8989602,
                32.8853604
              ],
              [
                48.8980369,
                32.8856898
              ],
              [
                48.8970107,
                32.8861077
              ],
              [
                48.8964157,
                32.8864787
              ],
              [
                48.8960954,
                32.886807
              ],
              [
                48.8957178,
                32.8870396
              ],
              [
                48.8943137,
                32.8877825
              ],
              [
                48.893284,
                32.8882476
              ],
              [
                48.8923151,
                32.8888084
              ],
              [
                48.8912314,
                32.889462
              ],
              [
                48.8900986,
                32.8901598
              ],
              [
                48.8893968,
                32.8906259
              ],
              [
                48.8893,
                32.8907304
              ],
              [
                48.8889693,
                32.8910876
              ],
              [
                48.8884851,
                32.8915055
              ],
              [
                48.887947,
                32.8921097
              ],
              [
                48.8872986,
                32.8925744
              ],
              [
                48.8869208,
                32.8928994
              ],
              [
                48.8866396,
                32.8929874
              ],
              [
                48.8863258,
                32.8930855
              ],
              [
                48.8857842,
                32.893277
              ],
              [
                48.8854065,
                32.8934126
              ],
              [
                48.8845938,
                32.8935094
              ],
              [
                48.8837813,
                32.8937008
              ],
              [
                48.8832399,
                32.8937953
              ],
              [
                48.8825342,
                32.8938893
              ],
              [
                48.8821565,
                32.8939821
              ],
              [
                48.881939,
                32.8941678
              ],
              [
                48.8818321,
                32.8944478
              ],
              [
                48.8817292,
                32.8947707
              ],
              [
                48.8816795,
                32.895232
              ],
              [
                48.8816835,
                32.8956943
              ],
              [
                48.8817406,
                32.8962025
              ],
              [
                48.8819084,
                32.8966179
              ],
              [
                48.8820725,
                32.8968958
              ],
              [
                48.882618,
                32.8972161
              ],
              [
                48.8830568,
                32.8975865
              ],
              [
                48.8833848,
                32.8979528
              ],
              [
                48.883385,
                32.897953
              ],
              [
                48.8835489,
                32.8980908
              ],
              [
                48.8836594,
                32.8984602
              ],
              [
                48.8837205,
                32.8989212
              ],
              [
                48.8836708,
                32.8995245
              ],
              [
                48.8835105,
                32.8998036
              ],
              [
                48.8833466,
                32.9000353
              ],
              [
                48.8830262,
                32.900359
              ],
              [
                48.8825951,
                32.9007305
              ],
              [
                48.8820533,
                32.9010121
              ],
              [
                48.8814584,
                32.9012455
              ],
              [
                48.8803787,
                32.9018517
              ],
              [
                48.8793527,
                32.9023168
              ],
              [
                48.8786467,
                32.9025032
              ],
              [
                48.8777277,
                32.9026454
              ],
              [
                48.8768042,
                32.90265
              ],
              [
                48.8756104,
                32.9026568
              ],
              [
                48.874958,
                32.9027967
              ],
              [
                48.8739852,
                32.9032176
              ],
              [
                48.8733369,
                32.90345
              ],
              [
                48.8729592,
                32.9037773
              ],
              [
                48.8726386,
                32.9043309
              ],
              [
                48.8723184,
                32.9048417
              ],
              [
                48.8722152,
                32.9053991
              ],
              [
                48.872326,
                32.905906
              ],
              [
                48.8723833,
                32.9062767
              ],
              [
                48.8725509,
                32.9066425
              ],
              [
                48.8727189,
                32.9071053
              ],
              [
                48.8727226,
                32.9074278
              ],
              [
                48.8727225,
                32.9077524
              ],
              [
                48.872673,
                32.9080762
              ],
              [
                48.8725129,
                32.9084004
              ],
              [
                48.8721352,
                32.9085878
              ],
              [
                48.8716468,
                32.9086832
              ],
              [
                48.8711053,
                32.908683
              ],
              [
                48.8701782,
                32.9084598
              ],
              [
                48.8697432,
                32.9083216
              ],
              [
                48.8685454,
                32.9077263
              ],
              [
                48.8677827,
                32.9074067
              ],
              [
                48.8674011,
                32.9072694
              ],
              [
                48.8668022,
                32.9072231
              ],
              [
                48.8662604,
                32.9073176
              ],
              [
                48.8659934,
                32.9075971
              ],
              [
                48.8656693,
                32.9079207
              ],
              [
                48.8652915,
                32.9081532
              ],
              [
                48.8649672,
                32.9083867
              ],
              [
                48.8645364,
                32.9085732
              ],
              [
                48.864048,
                32.9087136
              ],
              [
                48.8635062,
                32.908763
              ],
              [
                48.8629609,
                32.90881
              ],
              [
                48.8620949,
                32.9089079
              ],
              [
                48.8608473,
                32.9089136
              ],
              [
                48.8589477,
                32.9090119
              ],
              [
                48.8584299,
                32.9090526
              ],
              [
                48.8577005,
                32.90911
              ],
              [
                48.856617,
                32.9093484
              ],
              [
                48.8558578,
                32.9095338
              ],
              [
                48.8552094,
                32.9098631
              ],
              [
                48.8544006,
                32.9103745
              ],
              [
                48.8538629,
                32.9108387
              ],
              [
                48.8534315,
                32.9113926
              ],
              [
                48.8531648,
                32.9119945
              ],
              [
                48.8530083,
                32.9126885
              ],
              [
                48.8530119,
                32.9132454
              ],
              [
                48.8529727,
                32.9135383
              ],
              [
                48.8529129,
                32.9139854
              ],
              [
                48.8527526,
                32.9144944
              ],
              [
                48.852539,
                32.9148176
              ],
              [
                48.8521614,
                32.9151921
              ],
              [
                48.8517304,
                32.9156063
              ],
              [
                48.8509749,
                32.9158436
              ],
              [
                48.8504867,
                32.9158893
              ],
              [
                48.8503727,
                32.9159263
              ],
              [
                48.8500519,
                32.9160306
              ],
              [
                48.8495139,
                32.9164497
              ],
              [
                48.8491363,
                32.916867
              ],
              [
                48.8488693,
                32.9173765
              ],
              [
                48.8488198,
                32.9176552
              ],
              [
                48.8486024,
                32.9178881
              ],
              [
                48.8484421,
                32.9181176
              ],
              [
                48.8482819,
                32.9185364
              ],
              [
                48.8482322,
                32.9188129
              ],
              [
                48.8482971,
                32.9199683
              ],
              [
                48.848297,
                32.9202456
              ],
              [
                48.848301,
                32.9204282
              ],
              [
                48.8483542,
                32.9206163
              ],
              [
                48.8486861,
                32.9211225
              ],
              [
                48.8492888,
                32.9219963
              ],
              [
                48.849617,
                32.9223221
              ],
              [
                48.8497313,
                32.9227366
              ],
              [
                48.8497886,
                32.9230623
              ],
              [
                48.8496862,
                32.9234168
              ],
              [
                48.8496817,
                32.9234324
              ],
              [
                48.8496324,
                32.9239388
              ],
              [
                48.8495253,
                32.9242639
              ],
              [
                48.849312,
                32.9245871
              ],
              [
                48.8491517,
                32.9247737
              ],
              [
                48.8487204,
                32.9250075
              ],
              [
                48.8486794,
                32.9250271
              ],
              [
                48.8482322,
                32.9252403
              ],
              [
                48.8474769,
                32.9255227
              ],
              [
                48.8467713,
                32.9258915
              ],
              [
                48.8465042,
                32.9260334
              ],
              [
                48.8462332,
                32.9262655
              ],
              [
                48.8460731,
                32.9266821
              ],
              [
                48.8459701,
                32.9271425
              ],
              [
                48.8458633,
                32.9275622
              ],
              [
                48.8458708,
                32.9282995
              ],
              [
                48.8460352,
                32.9291872
              ],
              [
                48.8460425,
                32.9292268
              ],
              [
                48.8461532,
                32.9297337
              ],
              [
                48.8461569,
                32.9302411
              ],
              [
                48.8460008,
                32.9306554
              ],
              [
                48.8456765,
                32.9308437
              ],
              [
                48.8450776,
                32.9308469
              ],
              [
                48.8445358,
                32.9308511
              ],
              [
                48.8442076,
                32.9307147
              ],
              [
                48.843609,
                32.9304857
              ],
              [
                48.8431207,
                32.9302563
              ],
              [
                48.8425808,
                32.9300067
              ],
              [
                48.8425179,
                32.9299776
              ],
              [
                48.8420868,
                32.9299363
              ],
              [
                48.8414878,
                32.9299846
              ],
              [
                48.8411637,
                32.9301233
              ],
              [
                48.8407325,
                32.9302646
              ],
              [
                48.8403548,
                32.9305422
              ],
              [
                48.8398132,
                32.930871
              ],
              [
                48.839382,
                32.931382
              ],
              [
                48.8390618,
                32.9316606
              ],
              [
                48.8389017,
                32.9320749
              ],
              [
                48.8388481,
                32.9323535
              ],
              [
                48.8386344,
                32.932679
              ],
              [
                48.8383675,
                32.9331388
              ],
              [
                48.8383178,
                32.9337421
              ],
              [
                48.8383751,
                32.9341579
              ],
              [
                48.8384858,
                32.9344326
              ],
              [
                48.8388176,
                32.9350358
              ],
              [
                48.8394737,
                32.9357731
              ],
              [
                48.8400232,
                32.9364161
              ],
              [
                48.8402977,
                32.9368785
              ],
              [
                48.8405188,
                32.9372949
              ],
              [
                48.8405801,
                32.9378009
              ],
              [
                48.8405944,
                32.9378669
              ],
              [
                48.8406907,
                32.9383078
              ],
              [
                48.8405875,
                32.9388155
              ],
              [
                48.8405379,
                32.9393265
              ],
              [
                48.8403778,
                32.939743
              ],
              [
                48.8402175,
                32.9400671
              ],
              [
                48.8398932,
                32.9403456
              ],
              [
                48.8395158,
                32.9406231
              ],
              [
                48.8389778,
                32.9408122
              ],
              [
                48.8385965,
                32.9408146
              ],
              [
                48.8381615,
                32.9407237
              ],
              [
                48.8377228,
                32.9404478
              ],
              [
                48.8370706,
                32.9400826
              ],
              [
                48.8363609,
                32.9396216
              ],
              [
                48.8357049,
                32.9393465
              ],
              [
                48.8350524,
                32.9391639
              ],
              [
                48.8345108,
                32.9392131
              ],
              [
                48.8341866,
                32.9393089
              ],
              [
                48.8340509,
                32.9394025
              ],
              [
                48.8339157,
                32.9394958
              ],
              [
                48.8333741,
                32.9396826
              ],
              [
                48.8328896,
                32.9398681
              ],
              [
                48.8322944,
                32.9401012
              ],
              [
                48.8316995,
                32.9405666
              ],
              [
                48.8311616,
                32.9411231
              ],
              [
                48.8305703,
                32.9417261
              ],
              [
                48.8298685,
                32.942424
              ],
              [
                48.8295481,
                32.9426529
              ],
              [
                48.8293343,
                32.943073
              ],
              [
                48.8292276,
                32.9434432
              ],
              [
                48.8292312,
                32.943858
              ],
              [
                48.829342,
                32.9442748
              ],
              [
                48.8296203,
                32.9449199
              ],
              [
                48.8301163,
                32.9457965
              ],
              [
                48.8307723,
                32.9465789
              ],
              [
                48.8310509,
                32.9471316
              ],
              [
                48.8310749,
                32.9472019
              ],
              [
                48.8311616,
                32.9474559
              ],
              [
                48.8311118,
                32.947827
              ],
              [
                48.8310051,
                32.9481047
              ],
              [
                48.8308984,
                32.9483373
              ],
              [
                48.8307382,
                32.9485216
              ],
              [
                48.830303,
                32.948753
              ],
              [
                48.8298188,
                32.9489408
              ],
              [
                48.8294944,
                32.9491267
              ],
              [
                48.8292238,
                32.9493137
              ],
              [
                48.8288459,
                32.949501
              ],
              [
                48.8285219,
                32.9496419
              ],
              [
                48.8282508,
                32.9498739
              ],
              [
                48.8279266,
                32.9501072
              ],
              [
                48.8273314,
                32.9504328
              ],
              [
                48.8265762,
                32.9508052
              ],
              [
                48.8261452,
                32.951084
              ],
              [
                48.8256569,
                32.9511792
              ],
              [
                48.8247336,
                32.9513209
              ],
              [
                48.8243028,
                32.9515524
              ],
              [
                48.8235435,
                32.9516992
              ],
              [
                48.8227843,
                32.9518393
              ],
              [
                48.8222427,
                32.9519809
              ],
              [
                48.8215371,
                32.9519798
              ],
              [
                48.8211022,
                32.9517513
              ],
              [
                48.8204459,
                32.951431
              ],
              [
                48.8197367,
                32.9509272
              ],
              [
                48.8193317,
                32.9507402
              ],
              [
                48.8192442,
                32.9506999
              ],
              [
                48.8188097,
                32.9506066
              ],
              [
                48.818161,
                32.9506562
              ],
              [
                48.8177833,
                32.9508885
              ],
              [
                48.8170816,
                32.9514917
              ],
              [
                48.8169646,
                32.951629
              ],
              [
                48.8163299,
                32.9523736
              ],
              [
                48.8158988,
                32.9530221
              ],
              [
                48.8151473,
                32.9538566
              ],
              [
                48.8143387,
                32.9543723
              ],
              [
                48.8136367,
                32.9548379
              ],
              [
                48.8130416,
                32.9554407
              ],
              [
                48.8126144,
                32.9559021
              ],
              [
                48.8123436,
                32.956231
              ],
              [
                48.8119127,
                32.9566924
              ],
              [
                48.8112106,
                32.9571581
              ],
              [
                48.8105622,
                32.9574398
              ],
              [
                48.8096962,
                32.9576252
              ],
              [
                48.8088301,
                32.9578174
              ],
              [
                48.808235,
                32.9580505
              ],
              [
                48.8076934,
                32.9583273
              ],
              [
                48.8072624,
                32.9586534
              ],
              [
                48.8069953,
                32.9591176
              ],
              [
                48.806942,
                32.9594886
              ],
              [
                48.8065645,
                32.9596285
              ],
              [
                48.8063468,
                32.9596292
              ],
              [
                48.8060761,
                32.959629
              ],
              [
                48.8058014,
                32.9594911
              ],
              [
                48.805313,
                32.9593541
              ],
              [
                48.8045501,
                32.9591287
              ],
              [
                48.8036805,
                32.9588542
              ],
              [
                48.8028107,
                32.9587171
              ],
              [
                48.802105,
                32.9587205
              ],
              [
                48.8015061,
                32.9587708
              ],
              [
                48.800911,
                32.9590038
              ],
              [
                48.8004264,
                32.9593763
              ],
              [
                48.7997781,
                32.9598428
              ],
              [
                48.7992935,
                32.9599334
              ],
              [
                48.7984772,
                32.959892
              ],
              [
                48.7976609,
                32.9597581
              ],
              [
                48.7972794,
                32.9594809
              ],
              [
                48.7964592,
                32.9588848
              ],
              [
                48.795639,
                32.9581939
              ],
              [
                48.7948761,
                32.9579663
              ],
              [
                48.7940635,
                32.9578325
              ],
              [
                48.7930299,
                32.9578367
              ],
              [
                48.7921066,
                32.9579309
              ],
              [
                48.7916221,
                32.9582605
              ],
              [
                48.7913017,
                32.9587666
              ],
              [
                48.790924,
                32.9591409
              ],
              [
                48.7905464,
                32.9593236
              ],
              [
                48.7902184,
                32.9593268
              ],
              [
                48.7900544,
                32.9590939
              ],
              [
                48.789074,
                32.9587317
              ],
              [
                48.7882044,
                32.958457
              ],
              [
                48.7874985,
                32.9584129
              ],
              [
                48.7869568,
                32.9585544
              ],
              [
                48.7863579,
                32.9586024
              ],
              [
                48.7855987,
                32.9586994
              ],
              [
                48.7852212,
                32.9588392
              ],
              [
                48.78479,
                32.9590254
              ],
              [
                48.7846259,
                32.9591172
              ],
              [
                48.7841379,
                32.9593047
              ],
              [
                48.7831651,
                32.9595873
              ],
              [
                48.7824591,
                32.9598701
              ],
              [
                48.7815401,
                32.9602888
              ],
              [
                48.7805139,
                32.9607553
              ],
              [
                48.7798652,
                32.9613119
              ],
              [
                48.7792206,
                32.9618234
              ],
              [
                48.7787363,
                32.9621958
              ],
              [
                48.7779236,
                32.9627991
              ],
              [
                48.7769547,
                32.9636836
              ],
              [
                48.7766305,
                32.9639619
              ],
              [
                48.7764701,
                32.9643332
              ],
              [
                48.7762566,
                32.9644241
              ],
              [
                48.7759859,
                32.9644734
              ],
              [
                48.7756042,
                32.9643359
              ],
              [
                48.7751121,
                32.9641535
              ],
              [
                48.7744598,
                32.9639705
              ],
              [
                48.7739721,
                32.9638066
              ],
              [
                48.7739145,
                32.9637872
              ],
              [
                48.7733194,
                32.9637901
              ],
              [
                48.7727202,
                32.9637952
              ],
              [
                48.7721788,
                32.9639366
              ],
              [
                48.7717478,
                32.9641679
              ],
              [
                48.7713701,
                32.9645376
              ],
              [
                48.7711563,
                32.964863
              ],
              [
                48.7709961,
                32.9652794
              ],
              [
                48.7707292,
                32.9657909
              ],
              [
                48.7703513,
                32.9663004
              ],
              [
                48.7702554,
                32.9664153
              ],
              [
                48.7696534,
                32.9671356
              ],
              [
                48.7691689,
                32.9674606
              ],
              [
                48.768303,
                32.9678351
              ],
              [
                48.7682184,
                32.9678449
              ],
              [
                48.7674903,
                32.9679288
              ],
              [
                48.7670555,
                32.9679346
              ],
              [
                48.7665138,
                32.9680737
              ],
              [
                48.7658617,
                32.9682153
              ],
              [
                48.7649711,
                32.9683453
              ],
              [
                48.7648849,
                32.9683579
              ],
              [
                48.7642898,
                32.9683608
              ],
              [
                48.7638015,
                32.9683159
              ],
              [
                48.7634202,
                32.9681784
              ],
              [
                48.7628212,
                32.9679489
              ],
              [
                48.7624397,
                32.9676738
              ],
              [
                48.7622185,
                32.9674444
              ],
              [
                48.7619974,
                32.9671203
              ],
              [
                48.7620505,
                32.9667516
              ],
              [
                48.7621573,
                32.9664266
              ],
              [
                48.762314,
                32.965965
              ],
              [
                48.7623528,
                32.965926
              ],
              [
                48.7629622,
                32.9653138
              ],
              [
                48.7634466,
                32.9647566
              ],
              [
                48.7637102,
                32.9640625
              ],
              [
                48.7640343,
                32.9637369
              ],
              [
                48.7646789,
                32.9629481
              ],
              [
                48.7653236,
                32.9621571
              ],
              [
                48.7658615,
                32.9613732
              ],
              [
                48.7662888,
                32.9606775
              ],
              [
                48.7664489,
                32.9601212
              ],
              [
                48.7663878,
                32.9593356
              ],
              [
                48.7661094,
                32.9588279
              ],
              [
                48.7657813,
                32.9584117
              ],
              [
                48.7654533,
                32.9579505
              ],
              [
                48.7648506,
                32.9575384
              ],
              [
                48.7640877,
                32.9569859
              ],
              [
                48.7628325,
                32.9562082
              ],
              [
                48.7618483,
                32.9554714
              ],
              [
                48.761135,
                32.9546899
              ],
              [
                48.7605858,
                32.9538572
              ],
              [
                48.7603072,
                32.9529346
              ],
              [
                48.7602995,
                32.9522852
              ],
              [
                48.7604064,
                32.951825
              ],
              [
                48.7606735,
                32.951176
              ],
              [
                48.7612647,
                32.9505261
              ],
              [
                48.7620202,
                32.949967
              ],
              [
                48.7626649,
                32.949318
              ],
              [
                48.76326,
                32.9488057
              ],
              [
                48.7641717,
                32.9476925
              ],
              [
                48.7650338,
                32.9466258
              ],
              [
                48.765457,
                32.9455603
              ],
              [
                48.7657777,
                32.9447297
              ],
              [
                48.7658768,
                32.9438477
              ],
              [
                48.7659798,
                32.9431529
              ],
              [
                48.7660254,
                32.9419522
              ],
              [
                48.7659607,
                32.9409365
              ],
              [
                48.7660066,
                32.9399634
              ],
              [
                48.7659453,
                32.9389456
              ],
              [
                48.7657737,
                32.9380227
              ],
              [
                48.7656059,
                32.9373321
              ],
              [
                48.7656518,
                32.936359
              ],
              [
                48.765648,
                32.9358968
              ],
              [
                48.7657546,
                32.9355267
              ],
              [
                48.7659148,
                32.935108
              ],
              [
                48.7663421,
                32.9345047
              ],
              [
                48.7669335,
                32.9335775
              ],
              [
                48.7675209,
                32.9327426
              ],
              [
                48.7681124,
                32.9316778
              ],
              [
                48.7684822,
                32.9308435
              ],
              [
                48.7689628,
                32.929921
              ],
              [
                48.7693368,
                32.9288523
              ],
              [
                48.769436,
                32.9278824
              ],
              [
                48.7695885,
                32.9264942
              ],
              [
                48.7695772,
                32.9252022
              ],
              [
                48.7692414,
                32.9242291
              ],
              [
                48.7689666,
                32.9235839
              ],
              [
                48.7686882,
                32.922986
              ],
              [
                48.767975,
                32.9220625
              ],
              [
                48.7674254,
                32.9213268
              ],
              [
                48.7666627,
                32.920727
              ],
              [
                48.7661171,
                32.9203137
              ],
              [
                48.7642897,
                32.9180377
              ],
              [
                48.7616349,
                32.9168185
              ],
              [
                48.7598593,
                32.9170436
              ],
              [
                48.755292,
                32.9164744
              ],
              [
                48.752983,
                32.9152229
              ],
              [
                48.7512282,
                32.9115579
              ],
              [
                48.7492017,
                32.9074671
              ],
              [
                48.7471753,
                32.9039224
              ],
              [
                48.7457799,
                32.9017432
              ],
              [
                48.741708,
                32.8989916
              ],
              [
                48.7401009,
                32.8978049
              ],
              [
                48.7380218,
                32.8973087
              ],
              [
                48.7351807,
                32.8975835
              ],
              [
                48.7338685,
                32.8994216
              ],
              [
                48.7341929,
                32.9011541
              ],
              [
                48.7338408,
                32.902442
              ],
              [
                48.7315063,
                32.9026102
              ],
              [
                48.7291155,
                32.9021081
              ],
              [
                48.7275411,
                32.9012338
              ],
              [
                48.7268628,
                32.899461
              ],
              [
                48.7252617,
                32.8980398
              ],
              [
                48.7217883,
                32.8973072
              ],
              [
                48.7199026,
                32.8956084
              ],
              [
                48.716316,
                32.8911555
              ],
              [
                48.71599,
                32.8908361
              ],
              [
                48.7155362,
                32.8905613
              ],
              [
                48.7153779,
                32.8902897
              ],
              [
                48.7155913,
                32.8891867
              ],
              [
                48.7158089,
                32.8884512
              ],
              [
                48.7161369,
                32.8877606
              ],
              [
                48.7165147,
                32.8869785
              ],
              [
                48.7171174,
                32.886241
              ],
              [
                48.7176095,
                32.8860133
              ],
              [
                48.7182656,
                32.8855519
              ],
              [
                48.7189216,
                32.8855526
              ],
              [
                48.7195204,
                32.8854598
              ],
              [
                48.7202872,
                32.8856429
              ],
              [
                48.7213286,
                32.8861511
              ],
              [
                48.7224273,
                32.8866129
              ],
              [
                48.7235756,
                32.8868864
              ],
              [
                48.7247275,
                32.8870696
              ],
              [
                48.7248706,
                32.8870866
              ],
              [
                48.7254944,
                32.8871603
              ],
              [
                48.7259863,
                32.8869776
              ],
              [
                48.7265855,
                32.8867044
              ],
              [
                48.7272414,
                32.8861956
              ],
              [
                48.7276228,
                32.8858305
              ],
              [
                48.7280043,
                32.8853686
              ],
              [
                48.7280579,
                32.8847744
              ],
              [
                48.7280801,
                32.8846688
              ],
              [
                48.7281647,
                32.8842668
              ],
              [
                48.7283823,
                32.883254
              ],
              [
                48.7285994,
                32.882886
              ],
              [
                48.7289811,
                32.8823361
              ],
              [
                48.729637,
                32.8818273
              ],
              [
                48.7307854,
                32.8814153
              ],
              [
                48.731823,
                32.8808637
              ],
              [
                48.7326964,
                32.8801266
              ],
              [
                48.7335701,
                32.8798516
              ],
              [
                48.7342833,
                32.8795286
              ],
              [
                48.7352904,
                32.8792365
              ],
              [
                48.7357024,
                32.879117
              ],
              [
                48.7365229,
                32.8788861
              ],
              [
                48.7370148,
                32.8784261
              ],
              [
                48.7373962,
                32.8780588
              ],
              [
                48.7377243,
                32.877553
              ],
              [
                48.7377236,
                32.8774031
              ],
              [
                48.7377206,
                32.8767233
              ],
              [
                48.7379915,
                32.8758039
              ],
              [
                48.7379874,
                32.8750689
              ],
              [
                48.7384263,
                32.8745155
              ],
              [
                48.7388039,
                32.8734131
              ],
              [
                48.7392958,
                32.8727682
              ],
              [
                48.7396201,
                32.872215
              ],
              [
                48.7401122,
                32.8718497
              ],
              [
                48.7406044,
                32.8715249
              ],
              [
                48.741207,
                32.8711593
              ],
              [
                48.7416991,
                32.8711118
              ],
              [
                48.7424623,
                32.871067
              ],
              [
                48.7430024,
                32.8710915
              ],
              [
                48.7434503,
                32.8711119
              ],
              [
                48.744217,
                32.8712046
              ],
              [
                48.7449264,
                32.8711588
              ],
              [
                48.7458,
                32.8710663
              ],
              [
                48.7465666,
                32.870884
              ],
              [
                48.7473868,
                32.8705133
              ],
              [
                48.748043,
                32.8700111
              ],
              [
                48.7490235,
                32.869136
              ],
              [
                48.7498931,
                32.8687369
              ],
              [
                48.7508088,
                32.8675314
              ],
              [
                48.7516135,
                32.866554
              ],
              [
                48.7520942,
                32.8655819
              ],
              [
                48.7525711,
                32.864425
              ],
              [
                48.7529411,
                32.863221
              ],
              [
                48.7535783,
                32.8615078
              ],
              [
                48.7543258,
                32.859977
              ],
              [
                48.7545889,
                32.8587305
              ],
              [
                48.754528,
                32.8581274
              ],
              [
                48.7544669,
                32.8573869
              ],
              [
                48.7543031,
                32.8569714
              ],
              [
                48.7539749,
                32.8566521
              ],
              [
                48.7535895,
                32.8563769
              ],
              [
                48.7526129,
                32.856285
              ],
              [
                48.7519073,
                32.8562881
              ],
              [
                48.7512589,
                32.8564748
              ],
              [
                48.7500817,
                32.8564469
              ],
              [
                48.749441,
                32.8562866
              ],
              [
                48.7491434,
                32.8562113
              ],
              [
                48.7489361,
                32.8560901
              ],
              [
                48.748873,
                32.8560532
              ],
              [
                48.7486164,
                32.8555165
              ],
              [
                48.7487563,
                32.8545383
              ],
              [
                48.7488714,
                32.8533816
              ],
              [
                48.7488167,
                32.8521497
              ],
              [
                48.7487602,
                32.8509899
              ],
              [
                48.7490431,
                32.8499805
              ],
              [
                48.7492567,
                32.8497589
              ],
              [
                48.7499787,
                32.849657
              ],
              [
                48.7513619,
                32.8493121
              ],
              [
                48.7521706,
                32.8487518
              ],
              [
                48.7525481,
                32.8482896
              ],
              [
                48.7524375,
                32.8480577
              ],
              [
                48.7520026,
                32.8478289
              ],
              [
                48.7513999,
                32.8473672
              ],
              [
                48.7510146,
                32.8466298
              ],
              [
                48.7506295,
                32.8461224
              ],
              [
                48.7506789,
                32.8454741
              ],
              [
                48.7505647,
                32.8446424
              ],
              [
                48.7506675,
                32.8438101
              ],
              [
                48.7509308,
                32.8430709
              ],
              [
                48.7517929,
                32.8421395
              ],
              [
                48.7527619,
                32.8413498
              ],
              [
                48.7541085,
                32.8400506
              ],
              [
                48.7553404,
                32.8384293
              ],
              [
                48.755661,
                32.8374566
              ],
              [
                48.7556535,
                32.8364826
              ],
              [
                48.7558097,
                32.8358834
              ],
              [
                48.755638,
                32.8349605
              ],
              [
                48.7553595,
                32.8338509
              ],
              [
                48.7554056,
                32.8329229
              ],
              [
                48.7552337,
                32.8320473
              ],
              [
                48.7555504,
                32.8310272
              ],
              [
                48.7560884,
                32.830196
              ],
              [
                48.7574881,
                32.8291254
              ],
              [
                48.7594338,
                32.8279158
              ],
              [
                48.7611618,
                32.8271667
              ],
              [
                48.763218,
                32.8264663
              ],
              [
                48.7641946,
                32.8263237
              ],
              [
                48.7643769,
                32.8263136
              ],
              [
                48.7659837,
                32.8262249
              ],
              [
                48.7677231,
                32.8264971
              ],
              [
                48.7686461,
                32.8264933
              ],
              [
                48.7690238,
                32.8262566
              ],
              [
                48.7692375,
                32.8258411
              ],
              [
                48.7692299,
                32.8249166
              ],
              [
                48.7690546,
                32.8235743
              ],
              [
                48.7688256,
                32.8221883
              ],
              [
                48.7687071,
                32.8207591
              ],
              [
                48.7689232,
                32.8202124
              ],
              [
                48.7691842,
                32.8195524
              ],
              [
                48.769722,
                32.8189962
              ],
              [
                48.7698607,
                32.8189542
              ],
              [
                48.7708052,
                32.8186683
              ],
              [
                48.7717286,
                32.8186194
              ],
              [
                48.7730255,
                32.8183358
              ],
              [
                48.7745973,
                32.8179129
              ],
              [
                48.7757302,
                32.8173987
              ],
              [
                48.7764319,
                32.8168408
              ],
              [
                48.77713,
                32.8159605
              ],
              [
                48.7780953,
                32.8146137
              ],
              [
                48.7786867,
                32.813781
              ],
              [
                48.7788428,
                32.8130871
              ],
              [
                48.7786752,
                32.8124845
              ],
              [
                48.7784005,
                32.8119769
              ],
              [
                48.7776869,
                32.8110579
              ],
              [
                48.7771913,
                32.8100436
              ],
              [
                48.7770194,
                32.8093484
              ],
              [
                48.7769088,
                32.8090714
              ],
              [
                48.777069,
                32.8087474
              ],
              [
                48.7772827,
                32.8083296
              ],
              [
                48.7780418,
                32.8080477
              ],
              [
                48.7786332,
                32.8077246
              ],
              [
                48.7794458,
                32.8075361
              ],
              [
                48.7798806,
                32.8072552
              ],
              [
                48.7800369,
                32.8067936
              ],
              [
                48.780033,
                32.8064238
              ],
              [
                48.7798117,
                32.8058247
              ],
              [
                48.7795868,
                32.8049933
              ],
              [
                48.7795297,
                32.8042979
              ],
              [
                48.779579,
                32.8036946
              ],
              [
                48.7796782,
                32.8028194
              ],
              [
                48.7799988,
                32.8019368
              ],
              [
                48.7803688,
                32.8010145
              ],
              [
                48.7808495,
                32.8001325
              ],
              [
                48.7814332,
                32.7984205
              ],
              [
                48.7820703,
                32.7967522
              ],
              [
                48.7823334,
                32.7959633
              ],
              [
                48.7823295,
                32.7954109
              ],
              [
                48.7821085,
                32.7950395
              ],
              [
                48.7819405,
                32.7945338
              ],
              [
                48.7815628,
                32.794349
              ],
              [
                48.7810709,
                32.7942591
              ],
              [
                48.7804716,
                32.7940298
              ],
              [
                48.7797659,
                32.7938031
              ],
              [
                48.7790602,
                32.7935764
              ],
              [
                48.7789001,
                32.7935389
              ],
              [
                48.77808,
                32.7933471
              ],
              [
                48.7772103,
                32.7931175
              ],
              [
                48.7766684,
                32.7930763
              ],
              [
                48.7751999,
                32.7928969
              ],
              [
                48.7741698,
                32.7929011
              ],
              [
                48.7730292,
                32.7927208
              ],
              [
                48.7727722,
                32.7927033
              ],
              [
                48.7717286,
                32.7926322
              ],
              [
                48.7708587,
                32.792637
              ],
              [
                48.7701569,
                32.7928703
              ],
              [
                48.7694512,
                32.7931508
              ],
              [
                48.7684822,
                32.7936633
              ],
              [
                48.76762,
                32.7943604
              ],
              [
                48.766918,
                32.7951053
              ],
              [
                48.7660599,
                32.7960775
              ],
              [
                48.7654724,
                32.7971424
              ],
              [
                48.7652166,
                32.7977412
              ],
              [
                48.7649382,
                32.7983931
              ],
              [
                48.7645149,
                32.7997359
              ],
              [
                48.7640916,
                32.800664
              ],
              [
                48.763771,
                32.8014991
              ],
              [
                48.7637785,
                32.8022387
              ],
              [
                48.7635689,
                32.8030691
              ],
              [
                48.7634086,
                32.8034856
              ],
              [
                48.7629775,
                32.8040438
              ],
              [
                48.7623862,
                32.8046464
              ],
              [
                48.7616311,
                32.8051108
              ],
              [
                48.7608222,
                32.8056713
              ],
              [
                48.7599565,
                32.8060458
              ],
              [
                48.7592544,
                32.8062316
              ],
              [
                48.758171,
                32.8063745
              ],
              [
                48.7564316,
                32.8063817
              ],
              [
                48.7555124,
                32.8063382
              ],
              [
                48.754532,
                32.8062056
              ],
              [
                48.7537154,
                32.8059317
              ],
              [
                48.7525751,
                32.805564
              ],
              [
                48.751812,
                32.8053361
              ],
              [
                48.7511024,
                32.8048793
              ],
              [
                48.7506677,
                32.8045581
              ],
              [
                48.7500698,
                32.8039837
              ],
              [
                48.7493552,
                32.8032652
              ],
              [
                48.7486952,
                32.8024824
              ],
              [
                48.7480928,
                32.801563
              ],
              [
                48.7476007,
                32.801243
              ],
              [
                48.7471086,
                32.8010132
              ],
              [
                48.7461776,
                32.8008319
              ],
              [
                48.7453004,
                32.8007394
              ],
              [
                48.7445906,
                32.8007402
              ],
              [
                48.7440987,
                32.8008756
              ],
              [
                48.7434998,
                32.8011511
              ],
              [
                48.7428435,
                32.8017051
              ],
              [
                48.7424659,
                32.8025325
              ],
              [
                48.7417032,
                32.8033596
              ],
              [
                48.7412146,
                32.8043247
              ],
              [
                48.7404517,
                32.8049242
              ],
              [
                48.7387045,
                32.8056614
              ],
              [
                48.7373923,
                32.8059848
              ],
              [
                48.7350961,
                32.8063964
              ],
              [
                48.7337836,
                32.8061224
              ],
              [
                48.7329102,
                32.8058925
              ],
              [
                48.732525,
                32.8055676
              ],
              [
                48.7320861,
                32.804836
              ],
              [
                48.7318115,
                32.8041006
              ],
              [
                48.7316438,
                32.8032273
              ],
              [
                48.7314225,
                32.8022584
              ],
              [
                48.7309304,
                32.8016633
              ],
              [
                48.7302171,
                32.8010169
              ],
              [
                48.7297211,
                32.8006066
              ],
              [
                48.7287941,
                32.8002809
              ],
              [
                48.7274781,
                32.8000068
              ],
              [
                48.7266043,
                32.7999616
              ],
              [
                48.7258376,
                32.7996862
              ],
              [
                48.7251281,
                32.7993622
              ],
              [
                48.7244147,
                32.7985805
              ],
              [
                48.7236481,
                32.7979849
              ],
              [
                48.7226602,
                32.7971576
              ],
              [
                48.7212945,
                32.7963752
              ],
              [
                48.7196504,
                32.7955472
              ],
              [
                48.7185553,
                32.7949479
              ],
              [
                48.7172966,
                32.7943546
              ],
              [
                48.7164073,
                32.7940746
              ],
              [
                48.7153816,
                32.7937538
              ],
              [
                48.7137412,
                32.7932504
              ],
              [
                48.7126998,
                32.7927895
              ],
              [
                48.7116088,
                32.7927899
              ],
              [
                48.7099685,
                32.7927937
              ],
              [
                48.7090949,
                32.7928386
              ],
              [
                48.7079468,
                32.7929303
              ],
              [
                48.7069627,
                32.7932504
              ],
              [
                48.7064172,
                32.7936665
              ],
              [
                48.7058717,
                32.793758
              ],
              [
                48.7050516,
                32.7938489
              ],
              [
                48.7040138,
                32.7938952
              ],
              [
                48.7031937,
                32.793896
              ],
              [
                48.7023201,
                32.7937582
              ],
              [
                48.7011717,
                32.7936672
              ],
              [
                48.7001877,
                32.7933471
              ],
              [
                48.6990395,
                32.7928886
              ],
              [
                48.6981087,
                32.7923823
              ],
              [
                48.6973952,
                32.7916906
              ],
              [
                48.6969568,
                32.7911865
              ],
              [
                48.6964645,
                32.7907266
              ],
              [
                48.6960793,
                32.7903588
              ],
              [
                48.6953696,
                32.7898971
              ],
              [
                48.6943282,
                32.7891656
              ],
              [
                48.693508,
                32.7883839
              ],
              [
                48.6919173,
                32.7873266
              ],
              [
                48.6908227,
                32.7865895
              ],
              [
                48.6893999,
                32.7858554
              ],
              [
                48.6880873,
                32.7851639
              ],
              [
                48.6872101,
                32.7842932
              ],
              [
                48.6868286,
                32.7836955
              ],
              [
                48.6864967,
                32.7824968
              ],
              [
                48.6863823,
                32.7807971
              ],
              [
                48.6863824,
                32.7794648
              ],
              [
                48.6865959,
                32.7778546
              ],
              [
                48.6866494,
                32.7767532
              ],
              [
                48.686863,
                32.7758328
              ],
              [
                48.6872977,
                32.7745445
              ],
              [
                48.6876794,
                32.773625
              ],
              [
                48.6876757,
                32.7727502
              ],
              [
                48.6875114,
                32.7715073
              ],
              [
                48.6873434,
                32.7703139
              ],
              [
                48.6872863,
                32.7692104
              ],
              [
                48.6874465,
                32.7679667
              ],
              [
                48.6876069,
                32.7670927
              ],
              [
                48.6877709,
                32.7661285
              ],
              [
                48.6880416,
                32.7653467
              ],
              [
                48.6884766,
                32.7646108
              ],
              [
                48.6894036,
                32.7630927
              ],
              [
                48.6904373,
                32.7618515
              ],
              [
                48.6909257,
                32.760837
              ],
              [
                48.6911966,
                32.7601003
              ],
              [
                48.6914672,
                32.7593185
              ],
              [
                48.6916848,
                32.7584455
              ],
              [
                48.6917423,
                32.758318
              ],
              [
                48.6921197,
                32.7574797
              ],
              [
                48.6928826,
                32.7565153
              ],
              [
                48.6935349,
                32.7557788
              ],
              [
                48.6942978,
                32.7548145
              ],
              [
                48.6944044,
                32.7541694
              ],
              [
                48.6944046,
                32.7534796
              ],
              [
                48.6943473,
                32.7531133
              ],
              [
                48.6939125,
                32.7526972
              ],
              [
                48.6930352,
                32.7523316
              ],
              [
                48.6915054,
                32.7520104
              ],
              [
                48.6908492,
                32.751827
              ],
              [
                48.6902505,
                32.7518723
              ],
              [
                48.6898116,
                32.7521933
              ],
              [
                48.6890487,
                32.7530675
              ],
              [
                48.6887778,
                32.7535743
              ],
              [
                48.6885605,
                32.7545396
              ],
              [
                48.688183,
                32.755829
              ],
              [
                48.6880486,
                32.7562859
              ],
              [
                48.6878586,
                32.7569321
              ],
              [
                48.6872597,
                32.7578973
              ],
              [
                48.6864967,
                32.7586316
              ],
              [
                48.6864434,
                32.7589102
              ],
              [
                48.6854059,
                32.759414
              ],
              [
                48.6849672,
                32.7595096
              ],
              [
                48.6836586,
                32.7595553
              ],
              [
                48.6830025,
                32.7594192
              ],
              [
                48.6823462,
                32.7590937
              ],
              [
                48.6818544,
                32.7588186
              ],
              [
                48.6817436,
                32.758271
              ],
              [
                48.6814119,
                32.757442
              ],
              [
                48.6811904,
                32.7564279
              ],
              [
                48.6808089,
                32.756015
              ],
              [
                48.6805342,
                32.7556492
              ],
              [
                48.6801528,
                32.7553243
              ],
              [
                48.6800264,
                32.7553244
              ],
              [
                48.6793327,
                32.7553249
              ],
              [
                48.6790048,
                32.7554203
              ],
              [
                48.6786232,
                32.7558325
              ],
              [
                48.6785304,
                32.7560717
              ],
              [
                48.6785164,
                32.7561078
              ],
              [
                48.6782417,
                32.7566145
              ],
              [
                48.6778069,
                32.7573053
              ],
              [
                48.6760101,
                32.7591905
              ],
              [
                48.6744841,
                32.7607988
              ],
              [
                48.6727904,
                32.762226
              ],
              [
                48.6713218,
                32.7638827
              ],
              [
                48.6705552,
                32.7642968
              ],
              [
                48.6698455,
                32.7647593
              ],
              [
                48.6692999,
                32.7648055
              ],
              [
                48.6689719,
                32.7646213
              ],
              [
                48.6688613,
                32.7642067
              ],
              [
                48.6682624,
                32.7637018
              ],
              [
                48.6679879,
                32.7634239
              ],
              [
                48.6672745,
                32.7630116
              ],
              [
                48.6663477,
                32.7627824
              ],
              [
                48.6651994,
                32.7623214
              ],
              [
                48.6638334,
                32.7620479
              ],
              [
                48.6631204,
                32.7620459
              ],
              [
                48.6615371,
                32.7620502
              ],
              [
                48.6598433,
                32.7620974
              ],
              [
                48.657551,
                32.7621876
              ],
              [
                48.6564026,
                32.7621886
              ],
              [
                48.6554755,
                32.7622367
              ],
              [
                48.6548729,
                32.7620969
              ],
              [
                48.6543275,
                32.7617305
              ],
              [
                48.6536713,
                32.7614093
              ],
              [
                48.6533431,
                32.76118
              ],
              [
                48.6529045,
                32.7608111
              ],
              [
                48.6523019,
                32.7608111
              ],
              [
                48.6519737,
                32.7608117
              ],
              [
                48.6511001,
                32.7610433
              ],
              [
                48.6505014,
                32.7612259
              ],
              [
                48.6488647,
                32.7618264
              ],
              [
                48.6469535,
                32.762654
              ],
              [
                48.6452598,
                32.7633435
              ],
              [
                48.6437301,
                32.7635763
              ],
              [
                48.6426392,
                32.763576
              ],
              [
                48.641819,
                32.7634389
              ],
              [
                48.6405068,
                32.7626116
              ],
              [
                48.6394653,
                32.7617375
              ],
              [
                48.6388092,
                32.7613712
              ],
              [
                48.6387557,
                32.7607728
              ],
              [
                48.638809,
                32.7604064
              ],
              [
                48.6390267,
                32.7597161
              ],
              [
                48.6394081,
                32.7590267
              ],
              [
                48.6399004,
                32.7586595
              ],
              [
                48.6401176,
                32.7580594
              ],
              [
                48.6403351,
                32.7576915
              ],
              [
                48.6403313,
                32.7568619
              ],
              [
                48.6403312,
                32.7559443
              ],
              [
                48.6402741,
                32.7548859
              ],
              [
                48.6402208,
                32.7544295
              ],
              [
                48.640381,
                32.7541958
              ],
              [
                48.6407622,
                32.7537386
              ],
              [
                48.6410904,
                32.7535104
              ],
              [
                48.641529,
                32.7527724
              ],
              [
                48.6419105,
                32.7524955
              ],
              [
                48.6419361,
                32.7524494
              ],
              [
                48.6422921,
                32.7518084
              ],
              [
                48.6423365,
                32.7512772
              ],
              [
                48.6418156,
                32.750582
              ],
              [
                48.6411949,
                32.7502683
              ],
              [
                48.6408674,
                32.7501848
              ],
              [
                48.6396483,
                32.7498739
              ],
              [
                48.63813,
                32.7491419
              ],
              [
                48.6364519,
                32.7485918
              ],
              [
                48.6354751,
                32.7483186
              ],
              [
                48.6341745,
                32.7480438
              ],
              [
                48.6327134,
                32.7478133
              ],
              [
                48.6317405,
                32.7476303
              ],
              [
                48.6308173,
                32.7473108
              ],
              [
                48.6300585,
                32.7468523
              ],
              [
                48.6297341,
                32.7465734
              ],
              [
                48.6295701,
                32.7462547
              ],
              [
                48.6295698,
                32.7455603
              ],
              [
                48.6297875,
                32.7449603
              ],
              [
                48.6299477,
                32.7443614
              ],
              [
                48.6303252,
                32.7434397
              ],
              [
                48.6310806,
                32.7420495
              ],
              [
                48.6321106,
                32.740802
              ],
              [
                48.632866,
                32.7396508
              ],
              [
                48.6331366,
                32.7389097
              ],
              [
                48.6332969,
                32.7383582
              ],
              [
                48.633297,
                32.7379411
              ],
              [
                48.6331329,
                32.737663
              ],
              [
                48.6328086,
                32.7373435
              ],
              [
                48.6324845,
                32.7370691
              ],
              [
                48.6320495,
                32.7366979
              ],
              [
                48.6312905,
                32.7364243
              ],
              [
                48.6305314,
                32.736286
              ],
              [
                48.6295585,
                32.7361954
              ],
              [
                48.6283645,
                32.7361976
              ],
              [
                48.6264687,
                32.7360197
              ],
              [
                48.6250075,
                32.7356989
              ],
              [
                48.6239776,
                32.7354247
              ],
              [
                48.6230011,
                32.7349169
              ],
              [
                48.6222991,
                32.7344099
              ],
              [
                48.6217003,
                32.7335825
              ],
              [
                48.6212118,
                32.7327053
              ],
              [
                48.6209054,
                32.7316264
              ],
              [
                48.6208841,
                32.7315516
              ],
              [
                48.6203955,
                32.7300769
              ],
              [
                48.6200142,
                32.7284172
              ],
              [
                48.6195795,
                32.7272637
              ],
              [
                48.6190911,
                32.7265736
              ],
              [
                48.6184922,
                32.725789
              ],
              [
                48.6178438,
                32.7253754
              ],
              [
                48.6170844,
                32.7249597
              ],
              [
                48.6162147,
                32.7245937
              ],
              [
                48.615242,
                32.7243656
              ],
              [
                48.6135597,
                32.7241825
              ],
              [
                48.6116638,
                32.7240945
              ],
              [
                48.6099321,
                32.72419
              ],
              [
                48.6082534,
                32.7242842
              ],
              [
                48.6077927,
                32.724379
              ],
              [
                48.6068991,
                32.7245627
              ],
              [
                48.6067608,
                32.7246197
              ],
              [
                48.6055451,
                32.7251207
              ],
              [
                48.6038132,
                32.7259555
              ],
              [
                48.6022987,
                32.7267877
              ],
              [
                48.6008377,
                32.7275781
              ],
              [
                48.5996477,
                32.7283173
              ],
              [
                48.5987281,
                32.7287325
              ],
              [
                48.5976449,
                32.7289191
              ],
              [
                48.597046,
                32.7287363
              ],
              [
                48.5966681,
                32.7285082
              ],
              [
                48.5960693,
                32.7280007
              ],
              [
                48.5955809,
                32.7272654
              ],
              [
                48.5948754,
                32.725879
              ],
              [
                48.5938951,
                32.7234796
              ],
              [
                48.5930785,
                32.7215883
              ],
              [
                48.592266,
                32.7203914
              ],
              [
                48.5912323,
                32.7191
              ],
              [
                48.5904197,
                32.7181782
              ],
              [
                48.5890617,
                32.7171624
              ],
              [
                48.5875969,
                32.7161513
              ],
              [
                48.5858612,
                32.7151868
              ],
              [
                48.5843964,
                32.7144507
              ],
              [
                48.5830423,
                32.7140346
              ],
              [
                48.5811995,
                32.7135324
              ],
              [
                48.5791399,
                32.7130282
              ],
              [
                48.5772935,
                32.7126612
              ],
              [
                48.5758858,
                32.7122462
              ],
              [
                48.5743141,
                32.7117424
              ],
              [
                48.5730134,
                32.7115143
              ],
              [
                48.5700302,
                32.710823
              ],
              [
                48.5680237,
                32.7105519
              ],
              [
                48.5661279,
                32.710044
              ],
              [
                48.564827,
                32.7095408
              ],
              [
                48.5636329,
                32.7088503
              ],
              [
                48.5624391,
                32.7081102
              ],
              [
                48.5616228,
                32.7073278
              ],
              [
                48.5609704,
                32.7062691
              ],
              [
                48.5604247,
                32.7050209
              ],
              [
                48.5598259,
                32.7032193
              ],
              [
                48.5589486,
                32.6992954
              ],
              [
                48.5581245,
                32.694446
              ],
              [
                48.5576287,
                32.6923263
              ],
              [
                48.5571938,
                32.6909359
              ],
              [
                48.5564843,
                32.6893689
              ],
              [
                48.5557214,
                32.6880307
              ],
              [
                48.5549621,
                32.6871074
              ],
              [
                48.5539818,
                32.6860918
              ],
              [
                48.5538759,
                32.6859899
              ],
              [
                48.5531691,
                32.6853095
              ],
              [
                48.5522994,
                32.6848484
              ],
              [
                48.5514871,
                32.6847108
              ],
              [
                48.5502931,
                32.6844328
              ],
              [
                48.5487213,
                32.6843457
              ],
              [
                48.5477982,
                32.6844832
              ],
              [
                48.5469856,
                32.6847604
              ],
              [
                48.5455781,
                32.6854542
              ],
              [
                48.5446054,
                32.6859672
              ],
              [
                48.5437926,
                32.6866614
              ],
              [
                48.5434685,
                32.687169
              ],
              [
                48.5427131,
                32.6878621
              ],
              [
                48.541687,
                32.6889714
              ],
              [
                48.5411987,
                32.6896674
              ],
              [
                48.5409316,
                32.690219
              ],
              [
                48.5407714,
                32.6909598
              ],
              [
                48.5404471,
                32.6919791
              ],
              [
                48.5401267,
                32.6939161
              ],
              [
                48.5397036,
                32.6965972
              ],
              [
                48.5389556,
                32.7008973
              ],
              [
                48.5388216,
                32.7016357
              ],
              [
                48.5385283,
                32.7032515
              ],
              [
                48.538044,
                32.7048673
              ],
              [
                48.5376702,
                32.7057955
              ],
              [
                48.5369684,
                32.7068593
              ],
              [
                48.5363198,
                32.7078294
              ],
              [
                48.5357284,
                32.7088007
              ],
              [
                48.5350267,
                32.7094948
              ],
              [
                48.5342142,
                32.7100987
              ],
              [
                48.5334014,
                32.7104682
              ],
              [
                48.5326423,
                32.7106066
              ],
              [
                48.5319406,
                32.7106085
              ],
              [
                48.5312347,
                32.7104256
              ],
              [
                48.5303117,
                32.710103
              ],
              [
                48.5292283,
                32.7095023
              ],
              [
                48.5284117,
                32.7088122
              ],
              [
                48.5274352,
                32.7078439
              ],
              [
                48.5265082,
                32.7067367
              ],
              [
                48.5254211,
                32.7052116
              ],
              [
                48.525093,
                32.704335
              ],
              [
                48.5248186,
                32.7030874
              ],
              [
                48.5247079,
                32.7020257
              ],
              [
                48.5246466,
                32.7004555
              ],
              [
                48.5246662,
                32.6995993
              ],
              [
                48.5246964,
                32.6982811
              ],
              [
                48.5246367,
                32.6976243
              ],
              [
                48.5245284,
                32.6964337
              ],
              [
                48.5244827,
                32.6959046
              ],
              [
                48.5243567,
                32.6944465
              ],
              [
                48.5241929,
                32.6935235
              ],
              [
                48.5239181,
                32.6925059
              ],
              [
                48.5238544,
                32.6923911
              ],
              [
                48.5234832,
                32.6917218
              ],
              [
                48.5227737,
                32.6908444
              ],
              [
                48.5218505,
                32.6900146
              ],
              [
                48.5208741,
                32.689461
              ],
              [
                48.5192986,
                32.6886792
              ],
              [
                48.5174561,
                32.6880791
              ],
              [
                48.514904,
                32.6875259
              ],
              [
                48.513008,
                32.6871141
              ],
              [
                48.5106202,
                32.6869314
              ],
              [
                48.5083429,
                32.6866111
              ],
              [
                48.5054169,
                32.6863816
              ],
              [
                48.5032606,
                32.6861999
              ],
              [
                48.5032464,
                32.6861987
              ],
              [
                48.5001518,
                32.6859026
              ],
              [
                48.4990671,
                32.6894991
              ],
              [
                48.4983141,
                32.6919097
              ],
              [
                48.4970702,
                32.6969104
              ],
              [
                48.4970397,
                32.6970331
              ],
              [
                48.4960901,
                32.6990655
              ],
              [
                48.4951323,
                32.7002682
              ],
              [
                48.4934119,
                32.7015684
              ],
              [
                48.4915773,
                32.7024492
              ],
              [
                48.4897346,
                32.702782
              ],
              [
                48.4878311,
                32.7027889
              ],
              [
                48.486084,
                32.7022444
              ],
              [
                48.484928,
                32.7014187
              ],
              [
                48.4842682,
                32.7008239
              ],
              [
                48.4838791,
                32.7003179
              ],
              [
                48.4834329,
                32.6995808
              ],
              [
                48.4833641,
                32.6986123
              ],
              [
                48.4830741,
                32.6973689
              ],
              [
                48.4826164,
                32.6956667
              ],
              [
                48.482315,
                32.6938212
              ],
              [
                48.4819643,
                32.6920693
              ],
              [
                48.4816704,
                32.6906432
              ],
              [
                48.4811058,
                32.6893086
              ],
              [
                48.4806594,
                32.6883889
              ],
              [
                48.4794998,
                32.6872407
              ],
              [
                48.478504,
                32.6859064
              ],
              [
                48.4775199,
                32.685447
              ],
              [
                48.475939,
                32.6845821
              ],
              [
                48.475933,
                32.6845787
              ],
              [
                48.4748957,
                32.6842603
              ],
              [
                48.4735872,
                32.6840356
              ],
              [
                48.4721223,
                32.6840398
              ],
              [
                48.4709852,
                32.684186
              ],
              [
                48.4696311,
                32.6844675
              ],
              [
                48.4679031,
                32.6853524
              ],
              [
                48.4652596,
                32.6866538
              ],
              [
                48.4625367,
                32.688234
              ],
              [
                48.4619751,
                32.6885598
              ],
              [
                48.4594879,
                32.689587
              ],
              [
                48.4585686,
                32.689911
              ],
              [
                48.4571609,
                32.6902882
              ],
              [
                48.4559708,
                32.6904286
              ],
              [
                48.4540673,
                32.6904373
              ],
              [
                48.4509658,
                32.6900362
              ],
              [
                48.4468842,
                32.6893625
              ],
              [
                48.4423027,
                32.6881375
              ],
              [
                48.4396857,
                32.6871801
              ],
              [
                48.4370118,
                32.6862689
              ],
              [
                48.4353861,
                32.6855278
              ],
              [
                48.4351005,
                32.6853979
              ],
              [
                48.4341126,
                32.6846654
              ],
              [
                48.4336166,
                32.6840669
              ],
              [
                48.4331208,
                32.6835134
              ],
              [
                48.4328346,
                32.6821776
              ],
              [
                48.4328194,
                32.6810682
              ],
              [
                48.4333495,
                32.6800082
              ],
              [
                48.4340439,
                32.6789427
              ],
              [
                48.4352302,
                32.678338
              ],
              [
                48.436638,
                32.6780084
              ],
              [
                48.4392968,
                32.6778598
              ],
              [
                48.4417953,
                32.6778499
              ],
              [
                48.4435297,
                32.6778728
              ],
              [
                48.4442902,
                32.6778828
              ],
              [
                48.4474983,
                32.6782412
              ],
              [
                48.4509315,
                32.6790076
              ],
              [
                48.4537048,
                32.6795531
              ],
              [
                48.4560967,
                32.6797256
              ],
              [
                48.4569129,
                32.6797219
              ],
              [
                48.4580498,
                32.6796255
              ],
              [
                48.4590188,
                32.6789779
              ],
              [
                48.459816,
                32.677682
              ],
              [
                48.460453,
                32.6766174
              ],
              [
                48.4605384,
                32.6764185
              ],
              [
                48.4607697,
                32.6758799
              ],
              [
                48.4608115,
                32.6751864
              ],
              [
                48.460804,
                32.6745866
              ],
              [
                48.4606323,
                32.6737558
              ],
              [
                48.4603958,
                32.6725585
              ],
              [
                48.4601097,
                32.6712678
              ],
              [
                48.4600411,
                32.6702069
              ],
              [
                48.4595871,
                32.6688271
              ],
              [
                48.4588088,
                32.6676301
              ],
              [
                48.4573708,
                32.6654661
              ],
              [
                48.4559403,
                32.6639515
              ],
              [
                48.45467,
                32.6624334
              ],
              [
                48.4533463,
                32.6607316
              ],
              [
                48.4520759,
                32.6587987
              ],
              [
                48.4511871,
                32.6573266
              ],
              [
                48.4505195,
                32.6561273
              ],
              [
                48.4500085,
                32.6543766
              ],
              [
                48.4548527,
                32.6532407
              ],
              [
                48.4528961,
                32.6496499
              ],
              [
                48.4548919,
                32.6456601
              ],
              [
                48.473759,
                32.6392993
              ],
              [
                48.4708594,
                32.6312543
              ],
              [
                48.4642718,
                32.6129738
              ],
              [
                48.466808,
                32.6050861
              ],
              [
                48.4624978,
                32.6049227
              ],
              [
                48.4619369,
                32.603268
              ],
              [
                48.4617614,
                32.6023897
              ],
              [
                48.4618606,
                32.6016952
              ],
              [
                48.462168,
                32.6003202
              ],
              [
                48.4627976,
                32.5992095
              ],
              [
                48.4632721,
                32.5984189
              ],
              [
                48.4633713,
                32.5976341
              ],
              [
                48.4634667,
                32.596802
              ],
              [
                48.4634552,
                32.5959744
              ],
              [
                48.4633331,
                32.5950048
              ],
              [
                48.4630508,
                32.5940365
              ],
              [
                48.4627114,
                32.5929747
              ],
              [
                48.4621506,
                32.5913154
              ],
              [
                48.4609222,
                32.5886012
              ],
              [
                48.4600411,
                32.5872646
              ],
              [
                48.4589386,
                32.5857928
              ],
              [
                48.4583932,
                32.5851483
              ],
              [
                48.4574089,
                32.5843191
              ],
              [
                48.4568061,
                32.5835833
              ],
              [
                48.4564666,
                32.5825236
              ],
              [
                48.456398,
                32.5815551
              ],
              [
                48.4564362,
                32.580174
              ],
              [
                48.4569511,
                32.5785568
              ],
              [
                48.4577904,
                32.5767546
              ],
              [
                48.4583868,
                32.5754555
              ],
              [
                48.458632,
                32.5749212
              ],
              [
                48.458786,
                32.5745858
              ],
              [
                48.4605828,
                32.571811
              ],
              [
                48.4622268,
                32.5696373
              ],
              [
                48.4632378,
                32.5685734
              ],
              [
                48.4644165,
                32.5679705
              ],
              [
                48.4653817,
                32.5676
              ],
              [
                48.4670524,
                32.5674556
              ],
              [
                48.4678595,
                32.5672437
              ],
              [
                48.4682885,
                32.5671311
              ],
              [
                48.4693109,
                32.5671269
              ],
              [
                48.4697954,
                32.5669856
              ],
              [
                48.4709741,
                32.5665201
              ],
              [
                48.4720382,
                32.5654572
              ],
              [
                48.4732094,
                32.5643965
              ],
              [
                48.4741058,
                32.5629605
              ],
              [
                48.4746286,
                32.5617131
              ],
              [
                48.4756814,
                32.5600502
              ],
              [
                48.4762536,
                32.5586663
              ],
              [
                48.4767302,
                32.5579725
              ],
              [
                48.4771995,
                32.5569111
              ],
              [
                48.4775582,
                32.555852
              ],
              [
                48.4775429,
                32.5547449
              ],
              [
                48.477581,
                32.5535892
              ],
              [
                48.4775697,
                32.5529442
              ],
              [
                48.4776407,
                32.5522892
              ],
              [
                48.4776648,
                32.5520669
              ],
              [
                48.4776002,
                32.5511436
              ],
              [
                48.4776382,
                32.5501299
              ],
              [
                48.4779929,
                32.5487484
              ],
              [
                48.4786225,
                32.5476383
              ],
              [
                48.4794121,
                32.5462069
              ],
              [
                48.4807395,
                32.5449102
              ],
              [
                48.4820671,
                32.543618
              ],
              [
                48.483181,
                32.5425538
              ],
              [
                48.4842414,
                32.5414433
              ],
              [
                48.4849853,
                32.5407481
              ],
              [
                48.4861563,
                32.5400096
              ],
              [
                48.4874419,
                32.5394063
              ],
              [
                48.4892654,
                32.5389851
              ],
              [
                48.4916765,
                32.5381045
              ],
              [
                48.4922745,
                32.5379625
              ],
              [
                48.4934463,
                32.5376844
              ],
              [
                48.494568,
                32.5372198
              ],
              [
                48.4958534,
                32.5365714
              ],
              [
                48.4967041,
                32.536018
              ],
              [
                48.4975968,
                32.534584
              ],
              [
                48.4981193,
                32.533616
              ],
              [
                48.4983672,
                32.5322345
              ],
              [
                48.4987184,
                32.530571
              ],
              [
                48.4989546,
                32.5285423
              ],
              [
                48.4988211,
                32.5269729
              ],
              [
                48.4988027,
                32.5257789
              ],
              [
                48.4987984,
                32.5255003
              ],
              [
                48.4987755,
                32.5242532
              ],
              [
                48.4985924,
                32.5227346
              ],
              [
                48.4985733,
                32.5216251
              ],
              [
                48.4988824,
                32.520707
              ],
              [
                48.4995573,
                32.5191807
              ],
              [
                48.5001716,
                32.5179823
              ],
              [
                48.5001971,
                32.517949
              ],
              [
                48.5013086,
                32.5164607
              ],
              [
                48.5020637,
                32.5156754
              ],
              [
                48.5029334,
                32.515075
              ],
              [
                48.5035056,
                32.5147589
              ],
              [
                48.5040169,
                32.5144765
              ],
              [
                48.5049936,
                32.5135536
              ],
              [
                48.5058592,
                32.5126758
              ],
              [
                48.5069426,
                32.5114281
              ],
              [
                48.5074845,
                32.5106881
              ],
              [
                48.5076448,
                32.5101367
              ],
              [
                48.507534,
                32.5094875
              ],
              [
                48.5072059,
                32.5085184
              ],
              [
                48.5067673,
                32.5073126
              ],
              [
                48.5062181,
                32.5063437
              ],
              [
                48.5059026,
                32.5059815
              ],
              [
                48.5052911,
                32.5052792
              ],
              [
                48.5047456,
                32.5042607
              ],
              [
                48.5044709,
                32.5034302
              ],
              [
                48.504303,
                32.5027798
              ],
              [
                48.5044633,
                32.5019489
              ],
              [
                48.504841,
                32.5010727
              ],
              [
                48.5051116,
                32.4998697
              ],
              [
                48.5052224,
                32.4985666
              ],
              [
                48.5046197,
                32.4974545
              ],
              [
                48.5040208,
                32.4962997
              ],
              [
                48.5036927,
                32.4954185
              ],
              [
                48.5037995,
                32.4943092
              ],
              [
                48.5037994,
                32.4935675
              ],
              [
                48.5039595,
                32.4925991
              ],
              [
                48.5047188,
                32.491257
              ],
              [
                48.5049897,
                32.4899594
              ],
              [
                48.5050966,
                32.4892198
              ],
              [
                48.5047682,
                32.4879734
              ],
              [
                48.5044404,
                32.4867698
              ],
              [
                48.5038376,
                32.4855202
              ],
              [
                48.5034027,
                32.4840395
              ],
              [
                48.5031816,
                32.4830657
              ],
              [
                48.5029105,
                32.4821428
              ],
              [
                48.5029067,
                32.4814033
              ],
              [
                48.5025253,
                32.4804308
              ],
              [
                48.502468,
                32.4795077
              ],
              [
                48.5025215,
                32.4779329
              ],
              [
                48.5020828,
                32.4762695
              ],
              [
                48.5017549,
                32.4746015
              ],
              [
                48.5017015,
                32.4741406
              ],
              [
                48.5016976,
                32.4736783
              ],
              [
                48.500881,
                32.4723366
              ],
              [
                48.5004998,
                32.4712266
              ],
              [
                48.5001718,
                32.4697457
              ],
              [
                48.4999732,
                32.4681998
              ],
              [
                48.4995307,
                32.4662658
              ],
              [
                48.4989319,
                32.4647457
              ],
              [
                48.4981233,
                32.4634559
              ],
              [
                48.4973144,
                32.4624907
              ],
              [
                48.4963493,
                32.4616194
              ],
              [
                48.494953,
                32.460656
              ],
              [
                48.4937209,
                32.4599236
              ],
              [
                48.492649,
                32.4593725
              ],
              [
                48.4911996,
                32.4587327
              ],
              [
                48.4898109,
                32.4582789
              ],
              [
                48.4885788,
                32.4580988
              ],
              [
                48.4869271,
                32.4581064
              ],
              [
                48.4835625,
                32.457985
              ],
              [
                48.4816933,
                32.4581753
              ],
              [
                48.4795608,
                32.4584618
              ],
              [
                48.477375,
                32.4587065
              ],
              [
                48.4754523,
                32.4586679
              ],
              [
                48.4741174,
                32.4583008
              ],
              [
                48.4731521,
                32.4580311
              ],
              [
                48.4726142,
                32.4576191
              ],
              [
                48.4718588,
                32.4566999
              ],
              [
                48.471531,
                32.4557758
              ],
              [
                48.4710426,
                32.4547605
              ],
              [
                48.4706613,
                32.4539796
              ],
              [
                48.4702835,
                32.4534265
              ],
              [
                48.469635,
                32.4528318
              ],
              [
                48.4685097,
                32.4522817
              ],
              [
                48.4670639,
                32.4517814
              ],
              [
                48.4649142,
                32.4505784
              ],
              [
                48.4625534,
                32.4497086
              ],
              [
                48.4606986,
                32.4494
              ],
              [
                48.4580173,
                32.4492919
              ],
              [
                48.4563892,
                32.4492198
              ],
              [
                48.4534225,
                32.4491661
              ],
              [
                48.4522972,
                32.4489405
              ],
              [
                48.451172,
                32.4483902
              ],
              [
                48.4498253,
                32.44738
              ],
              [
                48.448803,
                32.4466018
              ],
              [
                48.447834,
                32.4456827
              ],
              [
                48.4471283,
                32.4446224
              ],
              [
                48.4465866,
                32.4437029
              ],
              [
                48.4460944,
                32.4425973
              ],
              [
                48.445652,
                32.4413529
              ],
              [
                48.4455413,
                32.4406135
              ],
              [
                48.44553,
                32.439689
              ],
              [
                48.4456292,
                32.4389065
              ],
              [
                48.4459991,
                32.4383504
              ],
              [
                48.4463653,
                32.4377018
              ],
              [
                48.4472656,
                32.4369626
              ],
              [
                48.4479027,
                32.4363105
              ],
              [
                48.4490127,
                32.4353366
              ],
              [
                48.4498063,
                32.4345005
              ],
              [
                48.4501763,
                32.433852
              ],
              [
                48.4503288,
                32.433021
              ],
              [
                48.450428,
                32.4323309
              ],
              [
                48.4504203,
                32.4316815
              ],
              [
                48.4501991,
                32.4308542
              ],
              [
                48.4492883,
                32.4306776
              ],
              [
                48.4491851,
                32.4285432
              ],
              [
                48.4456971,
                32.4236122
              ],
              [
                48.4400337,
                32.4199784
              ],
              [
                48.4344792,
                32.4163185
              ],
              [
                48.4328989,
                32.4151516
              ],
              [
                48.4304044,
                32.4196619
              ],
              [
                48.4287612,
                32.4179988
              ],
              [
                48.4238591,
                32.4226041
              ],
              [
                48.422709,
                32.4246913
              ],
              [
                48.4211744,
                32.4282806
              ],
              [
                48.4184317,
                32.4341476
              ],
              [
                48.4116023,
                32.4405129
              ],
              [
                48.4078225,
                32.4437098
              ],
              [
                48.4023352,
                32.441702
              ],
              [
                48.4020937,
                32.4418168
              ],
              [
                48.3995647,
                32.4442187
              ],
              [
                48.386364,
                32.45861
              ],
              [
                48.3732748,
                32.4535765
              ],
              [
                48.372395,
                32.4532325
              ],
              [
                48.3693909,
                32.4504078
              ],
              [
                48.3662796,
                32.4474382
              ],
              [
                48.3621073,
                32.4440886
              ],
              [
                48.3620031,
                32.4433187
              ],
              [
                48.3618395,
                32.4430282
              ],
              [
                48.3662796,
                32.4351784
              ],
              [
                48.3655484,
                32.4343152
              ],
              [
                48.3621704,
                32.4330685
              ],
              [
                48.3649212,
                32.4286289
              ],
              [
                48.3643584,
                32.4283913
              ],
              [
                48.3626569,
                32.4288136
              ],
              [
                48.361568,
                32.4285599
              ],
              [
                48.3588155,
                32.4282392
              ],
              [
                48.3565781,
                32.4278634
              ],
              [
                48.3554733,
                32.4276756
              ],
              [
                48.3546811,
                32.4276441
              ],
              [
                48.3544082,
                32.4278367
              ],
              [
                48.3540661,
                32.4278001
              ],
              [
                48.3538316,
                32.4280737
              ],
              [
                48.3517181,
                32.4276594
              ],
              [
                48.3514903,
                32.4276206
              ],
              [
                48.349349,
                32.4261173
              ],
              [
                48.3401745,
                32.4211795
              ],
              [
                48.3501399,
                32.4059277
              ],
              [
                48.3470923,
                32.4095408
              ],
              [
                48.3451653,
                32.4122494
              ],
              [
                48.342289,
                32.4094431
              ],
              [
                48.3393058,
                32.4065938
              ],
              [
                48.3351822,
                32.4029652
              ],
              [
                48.3332825,
                32.4012185
              ],
              [
                48.3310014,
                32.3990128
              ],
              [
                48.3294792,
                32.3975401
              ],
              [
                48.3282813,
                32.3962523
              ],
              [
                48.3274612,
                32.3949161
              ],
              [
                48.3262025,
                32.3931694
              ],
              [
                48.3253785,
                32.3919256
              ],
              [
                48.3248176,
                32.3903132
              ],
              [
                48.3241996,
                32.3884651
              ],
              [
                48.3235856,
                32.3868515
              ],
              [
                48.3233032,
                32.3857454
              ],
              [
                48.3230744,
                32.384778
              ],
              [
                48.3223534,
                32.3833042
              ],
              [
                48.3216362,
                32.3819702
              ],
              [
                48.3208542,
                32.3798481
              ],
              [
                48.3202896,
                32.3781386
              ],
              [
                48.320057,
                32.3769412
              ],
              [
                48.3194961,
                32.3754189
              ],
              [
                48.3187255,
                32.3740387
              ],
              [
                48.3174057,
                32.3718262
              ],
              [
                48.3163566,
                32.3700748
              ],
              [
                48.3153833,
                32.3684671
              ],
              [
                48.3147186,
                32.3672266
              ],
              [
                48.313611,
                32.3649894
              ],
              [
                48.313035,
                32.364125
              ],
              [
                48.3122153,
                32.3629961
              ],
              [
                48.3113957,
                32.3619552
              ],
              [
                48.3106646,
                32.3611777
              ],
              [
                48.3101107,
                32.3605595
              ],
              [
                48.3094239,
                32.3598054
              ],
              [
                48.3082255,
                32.3580576
              ],
              [
                48.3072529,
                32.356682
              ],
              [
                48.3065883,
                32.3555519
              ],
              [
                48.3041294,
                32.3516085
              ],
              [
                48.3032654,
                32.3501022
              ],
              [
                48.3022019,
                32.3485962
              ],
              [
                48.3009171,
                32.3468013
              ],
              [
                48.3000145,
                32.3452221
              ],
              [
                48.2982808,
                32.3423265
              ],
              [
                48.2966537,
                32.3393138
              ],
              [
                48.2956962,
                32.3364529
              ],
              [
                48.2949562,
                32.3339618
              ],
              [
                48.294365,
                32.3308721
              ],
              [
                48.293869,
                32.3268083
              ],
              [
                48.2932969,
                32.3216406
              ],
              [
                48.2931405,
                32.3187788
              ],
              [
                48.292839,
                32.3167007
              ],
              [
                48.2925643,
                32.3132864
              ],
              [
                48.2923126,
                32.3110695
              ],
              [
                48.2914963,
                32.3071927
              ],
              [
                48.2912407,
                32.3048405
              ],
              [
                48.2913132,
                32.3028065
              ],
              [
                48.2912064,
                32.2997136
              ],
              [
                48.290741,
                32.2975463
              ],
              [
                48.2902183,
                32.2953755
              ],
              [
                48.2897949,
                32.2925599
              ],
              [
                48.2891006,
                32.2897001
              ],
              [
                48.2886466,
                32.2883197
              ],
              [
                48.288311,
                32.2875325
              ],
              [
                48.2875404,
                32.2864294
              ],
              [
                48.2871476,
                32.2855531
              ],
              [
                48.2854347,
                32.2829734
              ],
              [
                48.2843936,
                32.2811901
              ],
              [
                48.2836608,
                32.2799349
              ],
              [
                48.2821885,
                32.2783271
              ],
              [
                48.2810012,
                32.2770305
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555016,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دشت آزادگان",
          "name:en": "Dasht-e-Azadegan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1180627",
          "wikipedia": "en:Dasht-e Azadegan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.717659,
                31.986296
              ],
              [
                47.717693,
                31.98601
              ],
              [
                47.717653,
                31.985456
              ],
              [
                47.71775,
                31.984175
              ],
              [
                47.717669,
                31.983776
              ],
              [
                47.717174,
                31.982641
              ],
              [
                47.71641,
                31.981573
              ],
              [
                47.714244,
                31.97946
              ],
              [
                47.713967,
                31.979128
              ],
              [
                47.713596,
                31.97851
              ],
              [
                47.712338,
                31.975966
              ],
              [
                47.711993,
                31.974024
              ],
              [
                47.711476,
                31.971825
              ],
              [
                47.711473,
                31.971073
              ],
              [
                47.711573,
                31.970599
              ],
              [
                47.711769,
                31.970159
              ],
              [
                47.712018,
                31.969902
              ],
              [
                47.712855,
                31.969461
              ],
              [
                47.713141,
                31.96922
              ],
              [
                47.71341,
                31.96891
              ],
              [
                47.714221,
                31.9676
              ],
              [
                47.714505,
                31.967271
              ],
              [
                47.715289,
                31.966592
              ],
              [
                47.717023,
                31.965339
              ],
              [
                47.717441,
                31.965146
              ],
              [
                47.719307,
                31.964705
              ],
              [
                47.720922,
                31.964461
              ],
              [
                47.72258,
                31.964386
              ],
              [
                47.723023,
                31.964275
              ],
              [
                47.724413,
                31.963708
              ],
              [
                47.724656,
                31.963407
              ],
              [
                47.72475,
                31.963185
              ],
              [
                47.725093,
                31.962962
              ],
              [
                47.726179,
                31.960416
              ],
              [
                47.726274,
                31.959666
              ],
              [
                47.726917,
                31.957656
              ],
              [
                47.727459,
                31.956198
              ],
              [
                47.728622,
                31.953977
              ],
              [
                47.728771,
                31.953076
              ],
              [
                47.728833,
                31.951229
              ],
              [
                47.728739,
                31.948037
              ],
              [
                47.729796,
                31.946169
              ],
              [
                47.730693,
                31.94537
              ],
              [
                47.730855,
                31.944924
              ],
              [
                47.73132,
                31.944124
              ],
              [
                47.731422,
                31.943524
              ],
              [
                47.731192,
                31.942959
              ],
              [
                47.731025,
                31.942245
              ],
              [
                47.730813,
                31.941831
              ],
              [
                47.730748,
                31.941391
              ],
              [
                47.731181,
                31.941201
              ],
              [
                47.731391,
                31.941001
              ],
              [
                47.731374,
                31.940091
              ],
              [
                47.731546,
                31.939555
              ],
              [
                47.731711,
                31.939258
              ],
              [
                47.732178,
                31.9392
              ],
              [
                47.732481,
                31.93934
              ],
              [
                47.732768,
                31.939368
              ],
              [
                47.733567,
                31.938857
              ],
              [
                47.734098,
                31.938656
              ],
              [
                47.734525,
                31.93855
              ],
              [
                47.734654,
                31.938424
              ],
              [
                47.734757,
                31.938015
              ],
              [
                47.735128,
                31.937606
              ],
              [
                47.735195,
                31.937424
              ],
              [
                47.73518,
                31.937151
              ],
              [
                47.734944,
                31.936301
              ],
              [
                47.734995,
                31.936078
              ],
              [
                47.735938,
                31.934685
              ],
              [
                47.736174,
                31.934507
              ],
              [
                47.736564,
                31.934358
              ],
              [
                47.736916,
                31.934457
              ],
              [
                47.737175,
                31.934319
              ],
              [
                47.738003,
                31.933682
              ],
              [
                47.738671,
                31.933287
              ],
              [
                47.73887,
                31.932857
              ],
              [
                47.739011,
                31.932729
              ],
              [
                47.73953,
                31.932431
              ],
              [
                47.740738,
                31.931317
              ],
              [
                47.740898,
                31.93108
              ],
              [
                47.741105,
                31.930473
              ],
              [
                47.741598,
                31.93007
              ],
              [
                47.741671,
                31.929777
              ],
              [
                47.741738,
                31.929699
              ],
              [
                47.742148,
                31.929711
              ],
              [
                47.742737,
                31.929396
              ],
              [
                47.743771,
                31.928598
              ],
              [
                47.74423,
                31.927986
              ],
              [
                47.74442,
                31.92781
              ],
              [
                47.744713,
                31.927677
              ],
              [
                47.745529,
                31.926438
              ],
              [
                47.745683,
                31.926016
              ],
              [
                47.746587,
                31.924547
              ],
              [
                47.747234,
                31.924095
              ],
              [
                47.747461,
                31.923858
              ],
              [
                47.747947,
                31.922928
              ],
              [
                47.748086,
                31.922789
              ],
              [
                47.748178,
                31.922521
              ],
              [
                47.749287,
                31.92083
              ],
              [
                47.749798,
                31.919868
              ],
              [
                47.750483,
                31.918931
              ],
              [
                47.750734,
                31.918817
              ],
              [
                47.751168,
                31.918814
              ],
              [
                47.751418,
                31.918667
              ],
              [
                47.751629,
                31.918367
              ],
              [
                47.752273,
                31.91819
              ],
              [
                47.752555,
                31.917988
              ],
              [
                47.753152,
                31.917836
              ],
              [
                47.753354,
                31.917659
              ],
              [
                47.753459,
                31.917492
              ],
              [
                47.753519,
                31.917174
              ],
              [
                47.753682,
                31.916871
              ],
              [
                47.754284,
                31.916399
              ],
              [
                47.754537,
                31.91563
              ],
              [
                47.754728,
                31.91546
              ],
              [
                47.754994,
                31.915376
              ],
              [
                47.755307,
                31.915449
              ],
              [
                47.755422,
                31.915616
              ],
              [
                47.755747,
                31.915632
              ],
              [
                47.75613,
                31.915561
              ],
              [
                47.756565,
                31.915404
              ],
              [
                47.756802,
                31.915182
              ],
              [
                47.756923,
                31.914947
              ],
              [
                47.757076,
                31.914838
              ],
              [
                47.757437,
                31.914732
              ],
              [
                47.757691,
                31.914601
              ],
              [
                47.758073,
                31.914183
              ],
              [
                47.758105,
                31.913996
              ],
              [
                47.758047,
                31.913605
              ],
              [
                47.758118,
                31.913439
              ],
              [
                47.758275,
                31.913318
              ],
              [
                47.759035,
                31.913232
              ],
              [
                47.759209,
                31.913131
              ],
              [
                47.759106,
                31.912379
              ],
              [
                47.759125,
                31.912216
              ],
              [
                47.759232,
                31.912137
              ],
              [
                47.759879,
                31.912054
              ],
              [
                47.760632,
                31.911864
              ],
              [
                47.760989,
                31.911952
              ],
              [
                47.761798,
                31.912324
              ],
              [
                47.761948,
                31.912524
              ],
              [
                47.762035,
                31.912998
              ],
              [
                47.762162,
                31.913103
              ],
              [
                47.762423,
                31.91313
              ],
              [
                47.763409,
                31.912724
              ],
              [
                47.76385,
                31.912593
              ],
              [
                47.764641,
                31.912656
              ],
              [
                47.765073,
                31.91262
              ],
              [
                47.766356,
                31.912279
              ],
              [
                47.767853,
                31.91199
              ],
              [
                47.768479,
                31.911772
              ],
              [
                47.769453,
                31.911265
              ],
              [
                47.769904,
                31.911094
              ],
              [
                47.770164,
                31.910934
              ],
              [
                47.77039,
                31.910609
              ],
              [
                47.770841,
                31.909674
              ],
              [
                47.771627,
                31.908979
              ],
              [
                47.771888,
                31.908874
              ],
              [
                47.772283,
                31.9088
              ],
              [
                47.773171,
                31.908797
              ],
              [
                47.774181,
                31.908722
              ],
              [
                47.775373,
                31.90826
              ],
              [
                47.775965,
                31.908092
              ],
              [
                47.776318,
                31.908059
              ],
              [
                47.777201,
                31.908221
              ],
              [
                47.777932,
                31.908656
              ],
              [
                47.778284,
                31.908646
              ],
              [
                47.778796,
                31.908558
              ],
              [
                47.78096,
                31.90789
              ],
              [
                47.781573,
                31.90747
              ],
              [
                47.783335,
                31.905786
              ],
              [
                47.783334,
                31.896723
              ],
              [
                47.784644,
                31.896499
              ],
              [
                47.785434,
                31.89586
              ],
              [
                47.785546,
                31.895484
              ],
              [
                47.785622,
                31.894957
              ],
              [
                47.785283,
                31.893717
              ],
              [
                47.785246,
                31.892927
              ],
              [
                47.785338,
                31.89227
              ],
              [
                47.785648,
                31.892001
              ],
              [
                47.785727,
                31.891839
              ],
              [
                47.785619,
                31.891467
              ],
              [
                47.78582,
                31.890652
              ],
              [
                47.785945,
                31.89051
              ],
              [
                47.786414,
                31.890303
              ],
              [
                47.786789,
                31.889887
              ],
              [
                47.786925,
                31.889633
              ],
              [
                47.787076,
                31.888963
              ],
              [
                47.787212,
                31.888682
              ],
              [
                47.787652,
                31.888255
              ],
              [
                47.787926,
                31.888181
              ],
              [
                47.788119,
                31.888077
              ],
              [
                47.788761,
                31.88743
              ],
              [
                47.789073,
                31.887294
              ],
              [
                47.789585,
                31.887267
              ],
              [
                47.789893,
                31.887171
              ],
              [
                47.790356,
                31.88713
              ],
              [
                47.790606,
                31.886961
              ],
              [
                47.791153,
                31.886758
              ],
              [
                47.791566,
                31.886496
              ],
              [
                47.791977,
                31.886354
              ],
              [
                47.792846,
                31.886266
              ],
              [
                47.793125,
                31.886158
              ],
              [
                47.793779,
                31.885635
              ],
              [
                47.794658,
                31.885271
              ],
              [
                47.795019,
                31.885198
              ],
              [
                47.795242,
                31.885264
              ],
              [
                47.795411,
                31.885405
              ],
              [
                47.795647,
                31.885469
              ],
              [
                47.7962,
                31.885341
              ],
              [
                47.796543,
                31.885327
              ],
              [
                47.796911,
                31.885335
              ],
              [
                47.797318,
                31.885446
              ],
              [
                47.797522,
                31.885411
              ],
              [
                47.797656,
                31.885202
              ],
              [
                47.797991,
                31.885134
              ],
              [
                47.798255,
                31.885176
              ],
              [
                47.798747,
                31.88512
              ],
              [
                47.799275,
                31.885314
              ],
              [
                47.800041,
                31.885369
              ],
              [
                47.800561,
                31.885214
              ],
              [
                47.801173,
                31.885241
              ],
              [
                47.801498,
                31.885186
              ],
              [
                47.802133,
                31.885219
              ],
              [
                47.802526,
                31.885327
              ],
              [
                47.802722,
                31.885288
              ],
              [
                47.803598,
                31.884908
              ],
              [
                47.804083,
                31.884535
              ],
              [
                47.804454,
                31.884346
              ],
              [
                47.805558,
                31.883576
              ],
              [
                47.805741,
                31.88343
              ],
              [
                47.806205,
                31.882661
              ],
              [
                47.806386,
                31.882482
              ],
              [
                47.806594,
                31.882381
              ],
              [
                47.80705,
                31.882292
              ],
              [
                47.807632,
                31.882356
              ],
              [
                47.80792,
                31.882335
              ],
              [
                47.808117,
                31.882273
              ],
              [
                47.808832,
                31.881861
              ],
              [
                47.809742,
                31.881486
              ],
              [
                47.80986,
                31.881373
              ],
              [
                47.810224,
                31.880681
              ],
              [
                47.810311,
                31.880365
              ],
              [
                47.810303,
                31.880016
              ],
              [
                47.810209,
                31.879698
              ],
              [
                47.810051,
                31.879467
              ],
              [
                47.809813,
                31.879289
              ],
              [
                47.809384,
                31.879121
              ],
              [
                47.808588,
                31.878945
              ],
              [
                47.808441,
                31.878839
              ],
              [
                47.808285,
                31.87851
              ],
              [
                47.808276,
                31.878292
              ],
              [
                47.808457,
                31.877823
              ],
              [
                47.808422,
                31.877418
              ],
              [
                47.80794,
                31.876778
              ],
              [
                47.807923,
                31.876551
              ],
              [
                47.808175,
                31.875785
              ],
              [
                47.808416,
                31.875393
              ],
              [
                47.808662,
                31.874814
              ],
              [
                47.808864,
                31.874506
              ],
              [
                47.808869,
                31.874368
              ],
              [
                47.80881,
                31.874241
              ],
              [
                47.808639,
                31.874194
              ],
              [
                47.807738,
                31.874342
              ],
              [
                47.807459,
                31.874264
              ],
              [
                47.806938,
                31.873943
              ],
              [
                47.806029,
                31.873534
              ],
              [
                47.805955,
                31.873399
              ],
              [
                47.805956,
                31.87319
              ],
              [
                47.806139,
                31.872677
              ],
              [
                47.806143,
                31.872485
              ],
              [
                47.806077,
                31.872326
              ],
              [
                47.805929,
                31.872187
              ],
              [
                47.805627,
                31.87202
              ],
              [
                47.805536,
                31.871899
              ],
              [
                47.805589,
                31.871632
              ],
              [
                47.80555,
                31.87148
              ],
              [
                47.805389,
                31.871261
              ],
              [
                47.805183,
                31.871105
              ],
              [
                47.804787,
                31.870909
              ],
              [
                47.804606,
                31.870743
              ],
              [
                47.804464,
                31.870527
              ],
              [
                47.804313,
                31.869873
              ],
              [
                47.804265,
                31.86929
              ],
              [
                47.804194,
                31.869089
              ],
              [
                47.803923,
                31.868779
              ],
              [
                47.803757,
                31.868703
              ],
              [
                47.803614,
                31.868717
              ],
              [
                47.803374,
                31.868846
              ],
              [
                47.80302,
                31.868895
              ],
              [
                47.802803,
                31.86885
              ],
              [
                47.802568,
                31.868633
              ],
              [
                47.801805,
                31.868484
              ],
              [
                47.80108,
                31.868143
              ],
              [
                47.799872,
                31.868158
              ],
              [
                47.799671,
                31.868044
              ],
              [
                47.799616,
                31.867906
              ],
              [
                47.799621,
                31.867741
              ],
              [
                47.79981,
                31.867171
              ],
              [
                47.79995,
                31.867016
              ],
              [
                47.800045,
                31.866786
              ],
              [
                47.800023,
                31.866593
              ],
              [
                47.79944,
                31.865499
              ],
              [
                47.799058,
                31.864485
              ],
              [
                47.799079,
                31.864043
              ],
              [
                47.799368,
                31.863288
              ],
              [
                47.79949,
                31.863036
              ],
              [
                47.799624,
                31.862931
              ],
              [
                47.799684,
                31.862773
              ],
              [
                47.799667,
                31.86242
              ],
              [
                47.799499,
                31.861989
              ],
              [
                47.799347,
                31.861862
              ],
              [
                47.799009,
                31.860736
              ],
              [
                47.79896,
                31.860383
              ],
              [
                47.799017,
                31.860056
              ],
              [
                47.799259,
                31.859538
              ],
              [
                47.799212,
                31.859327
              ],
              [
                47.799108,
                31.859098
              ],
              [
                47.798719,
                31.858771
              ],
              [
                47.798654,
                31.858645
              ],
              [
                47.798666,
                31.858457
              ],
              [
                47.799056,
                31.857787
              ],
              [
                47.799335,
                31.857099
              ],
              [
                47.799557,
                31.856738
              ],
              [
                47.79962,
                31.856278
              ],
              [
                47.799784,
                31.856086
              ],
              [
                47.800121,
                31.855836
              ],
              [
                47.800486,
                31.855281
              ],
              [
                47.800993,
                31.854756
              ],
              [
                47.801271,
                31.854566
              ],
              [
                47.801849,
                31.854325
              ],
              [
                47.802011,
                31.854177
              ],
              [
                47.802134,
                31.853953
              ],
              [
                47.802104,
                31.853674
              ],
              [
                47.802028,
                31.853506
              ],
              [
                47.801592,
                31.853175
              ],
              [
                47.801409,
                31.852982
              ],
              [
                47.80136,
                31.852837
              ],
              [
                47.801385,
                31.852619
              ],
              [
                47.801524,
                31.852381
              ],
              [
                47.801821,
                31.852161
              ],
              [
                47.802139,
                31.851997
              ],
              [
                47.802339,
                31.851788
              ],
              [
                47.802423,
                31.851538
              ],
              [
                47.802315,
                31.851113
              ],
              [
                47.802426,
                31.850946
              ],
              [
                47.802849,
                31.850775
              ],
              [
                47.803194,
                31.850535
              ],
              [
                47.803608,
                31.850147
              ],
              [
                47.804017,
                31.849868
              ],
              [
                47.80431,
                31.849501
              ],
              [
                47.804986,
                31.848805
              ],
              [
                47.805101,
                31.848571
              ],
              [
                47.805,
                31.847882
              ],
              [
                47.805172,
                31.846905
              ],
              [
                47.80504,
                31.846621
              ],
              [
                47.804867,
                31.846486
              ],
              [
                47.804829,
                31.845967
              ],
              [
                47.804956,
                31.845759
              ],
              [
                47.805232,
                31.845559
              ],
              [
                47.805358,
                31.8454
              ],
              [
                47.805351,
                31.845029
              ],
              [
                47.805429,
                31.844813
              ],
              [
                47.805615,
                31.844573
              ],
              [
                47.806028,
                31.844179
              ],
              [
                47.80555,
                31.843631
              ],
              [
                47.805337,
                31.842578
              ],
              [
                47.805441,
                31.842412
              ],
              [
                47.805678,
                31.84224
              ],
              [
                47.806318,
                31.842142
              ],
              [
                47.806635,
                31.842049
              ],
              [
                47.807301,
                31.842105
              ],
              [
                47.807513,
                31.842047
              ],
              [
                47.807807,
                31.842106
              ],
              [
                47.808611,
                31.842073
              ],
              [
                47.808908,
                31.842197
              ],
              [
                47.80915,
                31.842232
              ],
              [
                47.809666,
                31.842221
              ],
              [
                47.810771,
                31.841955
              ],
              [
                47.812406,
                31.841845
              ],
              [
                47.812783,
                31.841781
              ],
              [
                47.813152,
                31.841608
              ],
              [
                47.813832,
                31.840928
              ],
              [
                47.814042,
                31.840601
              ],
              [
                47.814296,
                31.840339
              ],
              [
                47.814767,
                31.840072
              ],
              [
                47.815176,
                31.839581
              ],
              [
                47.815899,
                31.839101
              ],
              [
                47.816613,
                31.838447
              ],
              [
                47.816887,
                31.838401
              ],
              [
                47.81743,
                31.838439
              ],
              [
                47.817538,
                31.838552
              ],
              [
                47.817561,
                31.838904
              ],
              [
                47.818008,
                31.83949
              ],
              [
                47.818161,
                31.839767
              ],
              [
                47.818886,
                31.840123
              ],
              [
                47.820027,
                31.840179
              ],
              [
                47.821045,
                31.839965
              ],
              [
                47.822015,
                31.838923
              ],
              [
                47.822481,
                31.838306
              ],
              [
                47.823075,
                31.837687
              ],
              [
                47.823607,
                31.836925
              ],
              [
                47.824122,
                31.836339
              ],
              [
                47.824419,
                31.835606
              ],
              [
                47.824538,
                31.834877
              ],
              [
                47.824615,
                31.833908
              ],
              [
                47.824948,
                31.833016
              ],
              [
                47.825222,
                31.832504
              ],
              [
                47.843989,
                31.822082
              ],
              [
                47.844525,
                31.821891
              ],
              [
                47.845302,
                31.821377
              ],
              [
                47.845392,
                31.821214
              ],
              [
                47.846293,
                31.820961
              ],
              [
                47.846694,
                31.820782
              ],
              [
                47.848556,
                31.820145
              ],
              [
                47.849628,
                31.819725
              ],
              [
                47.850297,
                31.819637
              ],
              [
                47.850516,
                31.819501
              ],
              [
                47.850706,
                31.818937
              ],
              [
                47.850977,
                31.818617
              ],
              [
                47.851403,
                31.818483
              ],
              [
                47.852366,
                31.818373
              ],
              [
                47.852568,
                31.818223
              ],
              [
                47.852865,
                31.817345
              ],
              [
                47.853084,
                31.816896
              ],
              [
                47.853237,
                31.816344
              ],
              [
                47.853647,
                31.815836
              ],
              [
                47.853815,
                31.815686
              ],
              [
                47.854137,
                31.81551
              ],
              [
                47.854399,
                31.815022
              ],
              [
                47.854614,
                31.814793
              ],
              [
                47.854718,
                31.814573
              ],
              [
                47.854954,
                31.814351
              ],
              [
                47.855132,
                31.814003
              ],
              [
                47.855497,
                31.813869
              ],
              [
                47.855645,
                31.81369
              ],
              [
                47.856029,
                31.813027
              ],
              [
                47.856069,
                31.812763
              ],
              [
                47.856002,
                31.812369
              ],
              [
                47.85614,
                31.812176
              ],
              [
                47.856187,
                31.811943
              ],
              [
                47.856094,
                31.81134
              ],
              [
                47.856123,
                31.804563
              ],
              [
                47.865855,
                31.783613
              ],
              [
                47.850052,
                31.75
              ],
              [
                47.8275773,
                31.695542
              ],
              [
                47.8216193,
                31.6828874
              ],
              [
                47.8266525,
                31.6809659
              ],
              [
                47.8369903,
                31.6772198
              ],
              [
                47.8474885,
                31.6734272
              ],
              [
                47.853897,
                31.671079
              ],
              [
                47.858471,
                31.669454
              ],
              [
                47.861702,
                31.6682803
              ],
              [
                47.8641204,
                31.6677898
              ],
              [
                47.8705215,
                31.6668156
              ],
              [
                47.8774605,
                31.6651126
              ],
              [
                47.8849822,
                31.6630764
              ],
              [
                47.9008141,
                31.6574483
              ],
              [
                47.9091567,
                31.6532757
              ],
              [
                47.9141122,
                31.6508238
              ],
              [
                47.9226189,
                31.6453197
              ],
              [
                47.924881,
                31.6439091
              ],
              [
                47.9268189,
                31.642867
              ],
              [
                47.9288062,
                31.6420967
              ],
              [
                47.9338608,
                31.6410236
              ],
              [
                47.9419822,
                31.6385903
              ],
              [
                47.9467126,
                31.6370558
              ],
              [
                47.969944,
                31.6273151
              ],
              [
                47.9770965,
                31.6238668
              ],
              [
                47.9837685,
                31.620001
              ],
              [
                47.9869867,
                31.6169733
              ],
              [
                47.9911423,
                31.6130632
              ],
              [
                47.9997594,
                31.6052908
              ],
              [
                48.0025482,
                31.6039948
              ],
              [
                48.0052757,
                31.6020323
              ],
              [
                48.0068159,
                31.6008782
              ],
              [
                48.0087547,
                31.5994291
              ],
              [
                48.0104655,
                31.5978627
              ],
              [
                48.0110016,
                31.5973718
              ],
              [
                48.0143203,
                31.5938991
              ],
              [
                48.0156594,
                31.5915207
              ],
              [
                48.0191918,
                31.5870407
              ],
              [
                48.020161,
                31.585561
              ],
              [
                48.0214386,
                31.5836104
              ],
              [
                48.0242234,
                31.5801362
              ],
              [
                48.0262902,
                31.5777821
              ],
              [
                48.0308036,
                31.5726408
              ],
              [
                48.0325165,
                31.5706743
              ],
              [
                48.033638,
                31.5697603
              ],
              [
                48.0350266,
                31.5692606
              ],
              [
                48.0371132,
                31.5683487
              ],
              [
                48.0397835,
                31.5677118
              ],
              [
                48.0430985,
                31.5669388
              ],
              [
                48.0455551,
                31.5660263
              ],
              [
                48.0483322,
                31.5645666
              ],
              [
                48.0520745,
                31.5625566
              ],
              [
                48.0530357,
                31.5618732
              ],
              [
                48.055336,
                31.5598614
              ],
              [
                48.0569382,
                31.5584916
              ],
              [
                48.0586509,
                31.5574423
              ],
              [
                48.0589153,
                31.5572972
              ],
              [
                48.0614815,
                31.5558889
              ],
              [
                48.0649566,
                31.554109
              ],
              [
                48.067894,
                31.5527427
              ],
              [
                48.0730744,
                31.5504157
              ],
              [
                48.0744294,
                31.549999
              ],
              [
                48.0763358,
                31.5494128
              ],
              [
                48.0794334,
                31.5487307
              ],
              [
                48.0816764,
                31.5479569
              ],
              [
                48.0837594,
                31.5465843
              ],
              [
                48.0861625,
                31.5447117
              ],
              [
                48.0888366,
                31.5432961
              ],
              [
                48.0920944,
                31.5418824
              ],
              [
                48.0952987,
                31.5401496
              ],
              [
                48.0966203,
                31.5389846
              ],
              [
                48.0970612,
                31.5385959
              ],
              [
                48.1000518,
                31.5361277
              ],
              [
                48.1014442,
                31.5339771
              ],
              [
                48.1049157,
                31.528535
              ],
              [
                48.1069985,
                31.5254735
              ],
              [
                48.108503,
                31.5233569
              ],
              [
                48.1086579,
                31.5231395
              ],
              [
                48.1122332,
                31.5207759
              ],
              [
                48.1132846,
                31.5200808
              ],
              [
                48.1140955,
                31.5195406
              ],
              [
                48.1183504,
                31.5167242
              ],
              [
                48.118799,
                31.5163076
              ],
              [
                48.1209787,
                31.5144095
              ],
              [
                48.1221864,
                31.5131903
              ],
              [
                48.1238741,
                31.5114883
              ],
              [
                48.124007,
                31.5113522
              ],
              [
                48.1245183,
                31.5108359
              ],
              [
                48.1252287,
                31.5100295
              ],
              [
                48.1289047,
                31.5060946
              ],
              [
                48.129598,
                31.5053908
              ],
              [
                48.129981,
                31.5046871
              ],
              [
                48.1305917,
                31.5036271
              ],
              [
                48.1311024,
                31.5029516
              ],
              [
                48.1317662,
                31.502145
              ],
              [
                48.1323537,
                31.5014603
              ],
              [
                48.1325058,
                31.5010826
              ],
              [
                48.1327615,
                31.500447
              ],
              [
                48.1341454,
                31.499348
              ],
              [
                48.1370978,
                31.4969327
              ],
              [
                48.1433986,
                31.4940911
              ],
              [
                48.1513104,
                31.4913933
              ],
              [
                48.1589637,
                31.4890071
              ],
              [
                48.1666133,
                31.4867285
              ],
              [
                48.1724206,
                31.4840278
              ],
              [
                48.1736246,
                31.4833781
              ],
              [
                48.1785088,
                31.4807423
              ],
              [
                48.1839561,
                31.4779632
              ],
              [
                48.1904678,
                31.4746797
              ],
              [
                48.1977844,
                31.4715825
              ],
              [
                48.2045135,
                31.4688959
              ],
              [
                48.2063113,
                31.4681861
              ],
              [
                48.2073975,
                31.4677573
              ],
              [
                48.209961,
                31.4672587
              ],
              [
                48.2131118,
                31.4667615
              ],
              [
                48.2154617,
                31.4667179
              ],
              [
                48.2186126,
                31.4669533
              ],
              [
                48.2203133,
                31.4673689
              ],
              [
                48.220817,
                31.467492
              ],
              [
                48.2210732,
                31.4675546
              ],
              [
                48.2212545,
                31.4676488
              ],
              [
                48.2228394,
                31.4684722
              ],
              [
                48.2250824,
                31.4693459
              ],
              [
                48.2285042,
                31.4706781
              ],
              [
                48.2318192,
                31.4717373
              ],
              [
                48.2367401,
                31.4731625
              ],
              [
                48.2383956,
                31.4734868
              ],
              [
                48.240532,
                31.4730798
              ],
              [
                48.242241,
                31.4723501
              ],
              [
                48.2441063,
                31.4709813
              ],
              [
                48.2453666,
                31.4701496
              ],
              [
                48.2499988,
                31.4670929
              ],
              [
                48.2530784,
                31.464093
              ],
              [
                48.2565956,
                31.4606199
              ],
              [
                48.2571108,
                31.4602006
              ],
              [
                48.2607536,
                31.4572348
              ],
              [
                48.2654991,
                31.4543582
              ],
              [
                48.2699241,
                31.4510664
              ],
              [
                48.2748795,
                31.4468141
              ],
              [
                48.2780227,
                31.444392
              ],
              [
                48.2794609,
                31.4426078
              ],
              [
                48.2816467,
                31.4400457
              ],
              [
                48.2835083,
                31.4375309
              ],
              [
                48.2871857,
                31.4332758
              ],
              [
                48.2915001,
                31.4287476
              ],
              [
                48.2956543,
                31.4246285
              ],
              [
                48.3002891,
                31.4204202
              ],
              [
                48.3060378,
                31.4141971
              ],
              [
                48.3091811,
                31.4108115
              ],
              [
                48.3137055,
                31.4063704
              ],
              [
                48.3173859,
                31.4017806
              ],
              [
                48.3174859,
                31.4019293
              ],
              [
                48.3185005,
                31.4033032
              ],
              [
                48.3186311,
                31.4034755
              ],
              [
                48.3207932,
                31.4063272
              ],
              [
                48.3220215,
                31.4077461
              ],
              [
                48.3237305,
                31.4097613
              ],
              [
                48.3250122,
                31.4118217
              ],
              [
                48.3261336,
                31.4131956
              ],
              [
                48.3270416,
                31.4148896
              ],
              [
                48.3280563,
                31.4165386
              ],
              [
                48.3286438,
                31.4177751
              ],
              [
                48.3292846,
                31.419698
              ],
              [
                48.329876,
                31.4219874
              ],
              [
                48.3305169,
                31.4239555
              ],
              [
                48.3311042,
                31.4256518
              ],
              [
                48.3319626,
                31.4274824
              ],
              [
                48.3323083,
                31.4280365
              ],
              [
                48.3327636,
                31.4287661
              ],
              [
                48.3336715,
                31.4299574
              ],
              [
                48.3348999,
                31.4313785
              ],
              [
                48.3349047,
                31.4313825
              ],
              [
                48.3364449,
                31.4326597
              ],
              [
                48.3378335,
                31.4338045
              ],
              [
                48.3392219,
                31.4347668
              ],
              [
                48.3411941,
                31.4359598
              ],
              [
                48.3438111,
                31.437563
              ],
              [
                48.3468015,
                31.4393357
              ],
              [
                48.3469048,
                31.439397
              ],
              [
                48.349041,
                31.4406339
              ],
              [
                48.3505859,
                31.4413219
              ],
              [
                48.3520813,
                31.4419661
              ],
              [
                48.3538933,
                31.4428377
              ],
              [
                48.3564567,
                31.4439368
              ],
              [
                48.3582154,
                31.4446269
              ],
              [
                48.3601914,
                31.4452201
              ],
              [
                48.3631783,
                31.4460482
              ],
              [
                48.3658447,
                31.4467366
              ],
              [
                48.3665883,
                31.4468401
              ],
              [
                48.3691521,
                31.4471969
              ],
              [
                48.3713379,
                31.4473816
              ],
              [
                48.3736839,
                31.4474297
              ],
              [
                48.3753357,
                31.4475673
              ],
              [
                48.3765641,
                31.4475226
              ],
              [
                48.3779488,
                31.4477066
              ],
              [
                48.3790169,
                31.4481658
              ],
              [
                48.380619,
                31.4489471
              ],
              [
                48.3818474,
                31.4497253
              ],
              [
                48.3826485,
                31.4503662
              ],
              [
                48.3843575,
                31.4516524
              ],
              [
                48.3856392,
                31.452754
              ],
              [
                48.3867607,
                31.4537622
              ],
              [
                48.3872575,
                31.4542708
              ],
              [
                48.3881493,
                31.4551838
              ],
              [
                48.3886833,
                31.4557313
              ],
              [
                48.3891106,
                31.4565584
              ],
              [
                48.389698,
                31.4575218
              ],
              [
                48.3904495,
                31.4585292
              ],
              [
                48.3912505,
                31.4595375
              ],
              [
                48.3926392,
                31.4608216
              ],
              [
                48.3938675,
                31.4619243
              ],
              [
                48.3952561,
                31.4630235
              ],
              [
                48.3965912,
                31.4641712
              ],
              [
                48.3980331,
                31.4652241
              ],
              [
                48.3990491,
                31.4659111
              ],
              [
                48.3995286,
                31.4662353
              ],
              [
                48.4007034,
                31.4671993
              ],
              [
                48.4017715,
                31.467841
              ],
              [
                48.4033737,
                31.468622
              ],
              [
                48.4044952,
                31.4690822
              ],
              [
                48.40588,
                31.4694033
              ],
              [
                48.4062538,
                31.4696341
              ],
              [
                48.4082832,
                31.4702299
              ],
              [
                48.4103661,
                31.4709214
              ],
              [
                48.4120712,
                31.4716548
              ],
              [
                48.4142075,
                31.4726652
              ],
              [
                48.4161835,
                31.4737197
              ],
              [
                48.4179458,
                31.4749614
              ],
              [
                48.4199753,
                31.4765197
              ],
              [
                48.4215278,
                31.4778519
              ],
              [
                48.4232902,
                31.4794115
              ],
              [
                48.4248924,
                31.4809273
              ],
              [
                48.4260177,
                31.4821178
              ],
              [
                48.4272462,
                31.4833127
              ],
              [
                48.4281005,
                31.4844594
              ],
              [
                48.4288144,
                31.4852152
              ],
              [
                48.4290122,
                31.4854247
              ],
              [
                48.4291235,
                31.4855679
              ],
              [
                48.4297601,
                31.4863866
              ],
              [
                48.4304543,
                31.4873498
              ],
              [
                48.4312057,
                31.4885418
              ],
              [
                48.432331,
                31.4909294
              ],
              [
                48.4323416,
                31.4909584
              ],
              [
                48.4328155,
                31.4922581
              ],
              [
                48.433403,
                31.4933138
              ],
              [
                48.4339626,
                31.4951264
              ],
              [
                48.4343285,
                31.4970637
              ],
              [
                48.4345137,
                31.4993986
              ],
              [
                48.4345703,
                31.5001506
              ],
              [
                48.4352684,
                31.5021689
              ],
              [
                48.4369774,
                31.5035875
              ],
              [
                48.438469,
                31.5047311
              ],
              [
                48.4407082,
                31.5056012
              ],
              [
                48.442894,
                31.5062401
              ],
              [
                48.4452362,
                31.5064222
              ],
              [
                48.4461869,
                31.5060677
              ],
              [
                48.4561287,
                31.5020384
              ],
              [
                48.4615776,
                31.5048046
              ],
              [
                48.4619095,
                31.5088426
              ],
              [
                48.45615,
                31.5149518
              ],
              [
                48.4409382,
                31.5230668
              ],
              [
                48.4285191,
                31.5355621
              ],
              [
                48.4165296,
                31.5462902
              ],
              [
                48.3961032,
                31.5650234
              ],
              [
                48.388564,
                31.5719398
              ],
              [
                48.3722166,
                31.5862699
              ],
              [
                48.3622822,
                31.5959557
              ],
              [
                48.3491365,
                31.6089273
              ],
              [
                48.3384196,
                31.6151446
              ],
              [
                48.3241404,
                31.6292135
              ],
              [
                48.3065682,
                31.6394703
              ],
              [
                48.2940336,
                31.6467298
              ],
              [
                48.28746,
                31.6498119
              ],
              [
                48.265604,
                31.6600805
              ],
              [
                48.2666629,
                31.6695123
              ],
              [
                48.263773,
                31.68501
              ],
              [
                48.2614732,
                31.6948928
              ],
              [
                48.2596755,
                31.6997189
              ],
              [
                48.2538423,
                31.7132598
              ],
              [
                48.2506645,
                31.7209062
              ],
              [
                48.2433576,
                31.7312515
              ],
              [
                48.2318164,
                31.7484302
              ],
              [
                48.2189827,
                31.7681094
              ],
              [
                48.2015387,
                31.7765477
              ],
              [
                48.1818404,
                31.7826128
              ],
              [
                48.1695554,
                31.783809
              ],
              [
                48.1572188,
                31.7851069
              ],
              [
                48.1300446,
                31.7848198
              ],
              [
                48.120315,
                31.7941781
              ],
              [
                48.1141931,
                31.804492
              ],
              [
                48.1075539,
                31.8161667
              ],
              [
                48.0973622,
                31.833579
              ],
              [
                48.0820515,
                31.8617832
              ],
              [
                48.068189,
                31.8841487
              ],
              [
                48.0573861,
                31.9046224
              ],
              [
                48.0471652,
                31.9163755
              ],
              [
                48.0353492,
                31.9305635
              ],
              [
                48.0247163,
                31.9425452
              ],
              [
                48.0169066,
                31.9523103
              ],
              [
                48.0110261,
                31.9590117
              ],
              [
                47.9970589,
                31.968854
              ],
              [
                47.9954757,
                31.9722833
              ],
              [
                47.993309,
                31.9762713
              ],
              [
                47.9910377,
                31.9796849
              ],
              [
                47.9910279,
                31.9796998
              ],
              [
                47.9883194,
                31.9837311
              ],
              [
                47.9858169,
                31.9869288
              ],
              [
                47.9835854,
                31.9900788
              ],
              [
                47.9817772,
                31.9923507
              ],
              [
                47.980339,
                31.9939732
              ],
              [
                47.9782563,
                31.9961957
              ],
              [
                47.9767646,
                31.9980039
              ],
              [
                47.9749263,
                31.99984
              ],
              [
                47.9747524,
                32.0000139
              ],
              [
                47.9712983,
                32.0029564
              ],
              [
                47.9690361,
                32.0056725
              ],
              [
                47.9668808,
                32.0077465
              ],
              [
                47.9651032,
                32.0098656
              ],
              [
                47.9631119,
                32.0121689
              ],
              [
                47.9613877,
                32.0141021
              ],
              [
                47.9599876,
                32.0157117
              ],
              [
                47.9590187,
                32.0165405
              ],
              [
                47.9573974,
                32.0176016
              ],
              [
                47.9554596,
                32.0195814
              ],
              [
                47.9511452,
                32.0234944
              ],
              [
                47.9455414,
                32.0294341
              ],
              [
                47.9397698,
                32.0347743
              ],
              [
                47.9355659,
                32.0393791
              ],
              [
                47.9337348,
                32.0411763
              ],
              [
                47.9317932,
                32.0432481
              ],
              [
                47.9290962,
                32.0454593
              ],
              [
                47.9266662,
                32.0473027
              ],
              [
                47.9244537,
                32.0490026
              ],
              [
                47.9224013,
                32.0504314
              ],
              [
                47.9197007,
                32.0522726
              ],
              [
                47.9162446,
                32.0544357
              ],
              [
                47.9134903,
                32.0562327
              ],
              [
                47.9108962,
                32.0576143
              ],
              [
                47.9087906,
                32.0589017
              ],
              [
                47.9045754,
                32.061019
              ],
              [
                47.9001464,
                32.0638768
              ],
              [
                47.8955536,
                32.0673752
              ],
              [
                47.8924217,
                32.0694464
              ],
              [
                47.8897743,
                32.0712882
              ],
              [
                47.8890688,
                32.0719552
              ],
              [
                47.7180257,
                31.9865163
              ],
              [
                47.717659,
                31.986296
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555035,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رامشیر",
          "name:en": "Ramshir County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2639174",
          "wikipedia": "en:Ramshir County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.1796645,
                30.9246024
              ],
              [
                49.1791763,
                30.9221689
              ],
              [
                49.178852,
                30.9204706
              ],
              [
                49.1782569,
                30.9180377
              ],
              [
                49.1777153,
                30.9151456
              ],
              [
                49.1771203,
                30.9122978
              ],
              [
                49.1765785,
                30.9098657
              ],
              [
                49.1762465,
                30.9061015
              ],
              [
                49.1759682,
                30.9023808
              ],
              [
                49.1760635,
                30.8986654
              ],
              [
                49.1761092,
                30.8961852
              ],
              [
                49.1764184,
                30.8941192
              ],
              [
                49.1770517,
                30.8923735
              ],
              [
                49.1779481,
                30.8900767
              ],
              [
                49.1790047,
                30.8885174
              ],
              [
                49.1801187,
                30.8871867
              ],
              [
                49.1812859,
                30.8864972
              ],
              [
                49.1824533,
                30.8859926
              ],
              [
                49.1840476,
                30.8857601
              ],
              [
                49.1864929,
                30.8854855
              ],
              [
                49.1898461,
                30.8856677
              ],
              [
                49.1928786,
                30.8859424
              ],
              [
                49.1970824,
                30.8866303
              ],
              [
                49.2005425,
                30.8872716
              ],
              [
                49.2047463,
                30.8880517
              ],
              [
                49.2091637,
                30.8890602
              ],
              [
                49.2127838,
                30.890071
              ],
              [
                49.2161904,
                30.8909886
              ],
              [
                49.2199171,
                30.8917211
              ],
              [
                49.2232703,
                30.8923648
              ],
              [
                49.2268332,
                30.8929144
              ],
              [
                49.2301864,
                30.8934204
              ],
              [
                49.2327422,
                30.8939695
              ],
              [
                49.2362022,
                30.8946122
              ],
              [
                49.24094,
                30.8958517
              ],
              [
                49.2447205,
                30.8968142
              ],
              [
                49.2475981,
                30.8973652
              ],
              [
                49.2500172,
                30.8974949
              ],
              [
                49.2528344,
                30.8975962
              ],
              [
                49.2547455,
                30.8974596
              ],
              [
                49.2563399,
                30.8974563
              ],
              [
                49.2574538,
                30.8975953
              ],
              [
                49.2598458,
                30.8980516
              ],
              [
                49.2626609,
                30.8988314
              ],
              [
                49.2653161,
                30.8998368
              ],
              [
                49.2660108,
                30.9001029
              ],
              [
                49.2681847,
                30.9009353
              ],
              [
                49.27063,
                30.9019423
              ],
              [
                49.2730713,
                30.9028139
              ],
              [
                49.2751464,
                30.9034528
              ],
              [
                49.2774277,
                30.9041869
              ],
              [
                49.2798729,
                30.9051013
              ],
              [
                49.2818781,
                30.9056643
              ],
              [
                49.2821579,
                30.9057429
              ],
              [
                49.2834855,
                30.9059725
              ],
              [
                49.2843361,
                30.9059251
              ],
              [
                49.2846032,
                30.905649
              ],
              [
                49.2849199,
                30.9053284
              ],
              [
                49.2850799,
                30.9050081
              ],
              [
                49.2849694,
                30.9041834
              ],
              [
                49.2847022,
                30.9031266
              ],
              [
                49.2848849,
                30.9015324
              ],
              [
                49.284912,
                30.9012958
              ],
              [
                49.285389,
                30.8986362
              ],
              [
                49.2857017,
                30.8965722
              ],
              [
                49.2860185,
                30.8946481
              ],
              [
                49.2860438,
                30.8944845
              ],
              [
                49.2862815,
                30.892951
              ],
              [
                49.2871819,
                30.8900626
              ],
              [
                49.2879716,
                30.8872177
              ],
              [
                49.2889785,
                30.8847885
              ],
              [
                49.289982,
                30.8814412
              ],
              [
                49.2914084,
                30.8772245
              ],
              [
                49.2926789,
                30.8747942
              ],
              [
                49.2940561,
                30.8720879
              ],
              [
                49.2948493,
                30.8702061
              ],
              [
                49.2958527,
                30.8682819
              ],
              [
                49.2972297,
                30.8660807
              ],
              [
                49.2981833,
                30.8638808
              ],
              [
                49.2990799,
                30.8611726
              ],
              [
                49.2997133,
                30.8589278
              ],
              [
                49.3002929,
                30.8563597
              ],
              [
                49.3006096,
                30.8548009
              ],
              [
                49.3012962,
                30.8525545
              ],
              [
                49.3020896,
                30.85072
              ],
              [
                49.302986,
                30.848747
              ],
              [
                49.3048935,
                30.8461332
              ],
              [
                49.3061639,
                30.8445733
              ],
              [
                49.3075409,
                30.8426472
              ],
              [
                49.308384,
                30.8408584
              ],
              [
                49.3093873,
                30.8385665
              ],
              [
                49.3101806,
                30.8356764
              ],
              [
                49.3103333,
                30.8338425
              ],
              [
                49.3105431,
                30.8317342
              ],
              [
                49.3103296,
                30.8299925
              ],
              [
                49.3101615,
                30.8266456
              ],
              [
                49.3101576,
                30.824124
              ],
              [
                49.3100471,
                30.8215559
              ],
              [
                49.3102531,
                30.8188047
              ],
              [
                49.3102494,
                30.8160102
              ],
              [
                49.3101388,
                30.8137624
              ],
              [
                49.309761,
                30.8107375
              ],
              [
                49.3096544,
                30.8092701
              ],
              [
                49.3094406,
                30.8083088
              ],
              [
                49.3092803,
                30.8078037
              ],
              [
                49.3092804,
                30.8069782
              ],
              [
                49.3090134,
                30.8059237
              ],
              [
                49.3087424,
                30.8046865
              ],
              [
                49.3084794,
                30.8038147
              ],
              [
                49.3082122,
                30.8030354
              ],
              [
                49.3077849,
                30.8016608
              ],
              [
                49.3076249,
                30.8010655
              ],
              [
                49.3074111,
                30.8006071
              ],
              [
                49.3071443,
                30.799918
              ],
              [
                49.3068809,
                30.7997815
              ],
              [
                49.3068182,
                30.7997798
              ],
              [
                49.3052901,
                30.7997382
              ],
              [
                49.3038027,
                30.7996916
              ],
              [
                49.3023184,
                30.7996474
              ],
              [
                49.3012045,
                30.799511
              ],
              [
                49.2995605,
                30.7991917
              ],
              [
                49.2983934,
                30.7988719
              ],
              [
                49.2970696,
                30.798232
              ],
              [
                49.2960091,
                30.7977738
              ],
              [
                49.2949982,
                30.7972237
              ],
              [
                49.294098,
                30.7964924
              ],
              [
                49.2924499,
                30.7952077
              ],
              [
                49.2919731,
                30.794933
              ],
              [
                49.2916085,
                30.7948644
              ],
              [
                49.2914962,
                30.7948432
              ],
              [
                49.2912827,
                30.7948427
              ],
              [
                49.2910728,
                30.794982
              ],
              [
                49.2907561,
                30.795165
              ],
              [
                49.2905959,
                30.7960809
              ],
              [
                49.2903863,
                30.7974561
              ],
              [
                49.2901763,
                30.7990615
              ],
              [
                49.2901268,
                30.7998863
              ],
              [
                49.2899665,
                30.8002518
              ],
              [
                49.2899665,
                30.8009871
              ],
              [
                49.2901268,
                30.80195
              ],
              [
                49.2907142,
                30.8029569
              ],
              [
                49.291668,
                30.8042415
              ],
              [
                49.2917131,
                30.8042907
              ],
              [
                49.2924652,
                30.8051113
              ],
              [
                49.2933158,
                30.8059345
              ],
              [
                49.2936897,
                30.8064401
              ],
              [
                49.2936896,
                30.8068528
              ],
              [
                49.2936897,
                30.8072182
              ],
              [
                49.2934227,
                30.8073568
              ],
              [
                49.2927359,
                30.8073116
              ],
              [
                49.2919386,
                30.8071297
              ],
              [
                49.2896042,
                30.8060299
              ],
              [
                49.288807,
                30.8056179
              ],
              [
                49.2876931,
                30.8054814
              ],
              [
                49.2852555,
                30.8051176
              ],
              [
                49.2841416,
                30.8047961
              ],
              [
                49.2831345,
                30.8043836
              ],
              [
                49.282074,
                30.8040177
              ],
              [
                49.2809563,
                30.8034683
              ],
              [
                49.2806931,
                30.8031942
              ],
              [
                49.2804259,
                30.8026448
              ],
              [
                49.2804259,
                30.802002
              ],
              [
                49.2805329,
                30.8015907
              ],
              [
                49.2809561,
                30.8011317
              ],
              [
                49.2817498,
                30.8009483
              ],
              [
                49.282917,
                30.800763
              ],
              [
                49.2837886,
                30.8006308
              ],
              [
                49.2841339,
                30.8005784
              ],
              [
                49.2852478,
                30.8002571
              ],
              [
                49.2864152,
                30.7999342
              ],
              [
                49.2868918,
                30.799706
              ],
              [
                49.287262,
                30.7992936
              ],
              [
                49.2875786,
                30.7986054
              ],
              [
                49.2872583,
                30.7976426
              ],
              [
                49.2864648,
                30.7970457
              ],
              [
                49.2855074,
                30.7959933
              ],
              [
                49.2844467,
                30.7952147
              ],
              [
                49.2836233,
                30.7945357
              ],
              [
                49.2832794,
                30.794252
              ],
              [
                49.2823752,
                30.7937484
              ],
              [
                49.2815285,
                30.7927876
              ],
              [
                49.2812616,
                30.7921007
              ],
              [
                49.281208,
                30.7918248
              ],
              [
                49.2813644,
                30.7911841
              ],
              [
                49.281788,
                30.7910003
              ],
              [
                49.2820107,
                30.7909632
              ],
              [
                49.2831688,
                30.7907705
              ],
              [
                49.284176,
                30.7906755
              ],
              [
                49.2857131,
                30.7906756
              ],
              [
                49.2865602,
                30.790583
              ],
              [
                49.2868768,
                30.7903527
              ],
              [
                49.287037,
                30.7901247
              ],
              [
                49.2870367,
                30.7898969
              ],
              [
                49.2868766,
                30.7892994
              ],
              [
                49.2864098,
                30.7887502
              ],
              [
                49.2862931,
                30.7886128
              ],
              [
                49.2854957,
                30.787743
              ],
              [
                49.284752,
                30.7871467
              ],
              [
                49.2842218,
                30.7860007
              ],
              [
                49.2836877,
                30.7849471
              ],
              [
                49.2834219,
                30.7842347
              ],
              [
                49.2831575,
                30.783526
              ],
              [
                49.2827301,
                30.7817386
              ],
              [
                49.2818794,
                30.7788043
              ],
              [
                49.2806511,
                30.7734427
              ],
              [
                49.2801209,
                30.7712412
              ],
              [
                49.2793199,
                30.7690428
              ],
              [
                49.2779922,
                30.7658812
              ],
              [
                49.2766647,
                30.7622594
              ],
              [
                49.2751235,
                30.7594197
              ],
              [
                49.2734756,
                30.7563484
              ],
              [
                49.2718849,
                30.7535103
              ],
              [
                49.2706644,
                30.7517213
              ],
              [
                49.2698937,
                30.7503126
              ],
              [
                49.2698284,
                30.7501697
              ],
              [
                49.2693099,
                30.749026
              ],
              [
                49.2687225,
                30.7479243
              ],
              [
                49.2682953,
                30.7462248
              ],
              [
                49.2682417,
                30.744528
              ],
              [
                49.2682418,
                30.7430124
              ],
              [
                49.2682419,
                30.7415464
              ],
              [
                49.2682953,
                30.7401691
              ],
              [
                49.2686157,
                30.7391156
              ],
              [
                49.2688789,
                30.7381064
              ],
              [
                49.2691459,
                30.7369146
              ],
              [
                49.2696761,
                30.7359045
              ],
              [
                49.2709009,
                30.7341165
              ],
              [
                49.2722815,
                30.7319178
              ],
              [
                49.273613,
                30.7294884
              ],
              [
                49.2752074,
                30.7265099
              ],
              [
                49.2759515,
                30.7238494
              ],
              [
                49.2765885,
                30.7218303
              ],
              [
                49.2773818,
                30.7189877
              ],
              [
                49.2778626,
                30.7168311
              ],
              [
                49.2783928,
                30.7142647
              ],
              [
                49.2788696,
                30.7113751
              ],
              [
                49.2792396,
                30.7085292
              ],
              [
                49.27977,
                30.7040321
              ],
              [
                49.2800902,
                30.7004548
              ],
              [
                49.2806167,
                30.6950871
              ],
              [
                49.2806703,
                30.6927466
              ],
              [
                49.2809372,
                30.6909571
              ],
              [
                49.2812003,
                30.6888495
              ],
              [
                49.2813605,
                30.6863256
              ],
              [
                49.281624,
                30.6840308
              ],
              [
                49.2822476,
                30.6811727
              ],
              [
                49.2823145,
                30.6808665
              ],
              [
                49.2831612,
                30.6765541
              ],
              [
                49.2837447,
                30.6736635
              ],
              [
                49.2842751,
                30.67137
              ],
              [
                49.2848588,
                30.6688471
              ],
              [
                49.2855491,
                30.6660482
              ],
              [
                49.2856561,
                30.6642588
              ],
              [
                49.2857095,
                30.662471
              ],
              [
                49.2859192,
                30.6604957
              ],
              [
                49.2862892,
                30.658615
              ],
              [
                49.2868195,
                30.6569169
              ],
              [
                49.2868727,
                30.6553569
              ],
              [
                49.287403,
                30.6531558
              ],
              [
                49.2878799,
                30.6509991
              ],
              [
                49.2883033,
                30.648844
              ],
              [
                49.2886237,
                30.6476528
              ],
              [
                49.2891541,
                30.6464576
              ],
              [
                49.2894707,
                30.6455867
              ],
              [
                49.2903746,
                30.6442115
              ],
              [
                49.2913284,
                30.642652
              ],
              [
                49.2923928,
                30.641139
              ],
              [
                49.2935067,
                30.639762
              ],
              [
                49.294941,
                30.6384795
              ],
              [
                49.2972757,
                30.6365523
              ],
              [
                49.2990304,
                30.6351769
              ],
              [
                49.2995606,
                30.6348568
              ],
              [
                49.3041544,
                30.6363446
              ],
              [
                49.3043938,
                30.6364221
              ],
              [
                49.3110886,
                30.6388121
              ],
              [
                49.3162956,
                30.6406998
              ],
              [
                49.3220368,
                30.6425874
              ],
              [
                49.3237195,
                30.6431837
              ],
              [
                49.329052,
                30.6450731
              ],
              [
                49.3397331,
                30.6488007
              ],
              [
                49.3446771,
                30.6505486
              ],
              [
                49.3497771,
                30.6523006
              ],
              [
                49.3558922,
                30.654417
              ],
              [
                49.3565386,
                30.654657
              ],
              [
                49.362961,
                30.6570414
              ],
              [
                49.3765677,
                30.6615562
              ],
              [
                49.381302,
                30.6631671
              ],
              [
                49.3852348,
                30.6645061
              ],
              [
                49.3910827,
                30.6664846
              ],
              [
                49.3991128,
                30.6691595
              ],
              [
                49.4061317,
                30.6716457
              ],
              [
                49.4129906,
                30.6740438
              ],
              [
                49.4170876,
                30.6754268
              ],
              [
                49.4215544,
                30.6769495
              ],
              [
                49.4264983,
                30.6786086
              ],
              [
                49.4321898,
                30.6804977
              ],
              [
                49.4386253,
                30.6827585
              ],
              [
                49.4449539,
                30.6849253
              ],
              [
                49.449318,
                30.6863556
              ],
              [
                49.4539986,
                30.68797
              ],
              [
                49.4607544,
                30.6902764
              ],
              [
                49.4666063,
                30.6923057
              ],
              [
                49.4737359,
                30.6947986
              ],
              [
                49.4795876,
                30.6968747
              ],
              [
                49.4862406,
                30.6989508
              ],
              [
                49.4875825,
                30.699431
              ],
              [
                49.4938508,
                30.7016738
              ],
              [
                49.4960384,
                30.7023069
              ],
              [
                49.4999805,
                30.7034477
              ],
              [
                49.5004998,
                30.7036702
              ],
              [
                49.5008589,
                30.7039292
              ],
              [
                49.501133,
                30.7043136
              ],
              [
                49.5012436,
                30.7054697
              ],
              [
                49.5012627,
                30.7094464
              ],
              [
                49.5012703,
                30.712081
              ],
              [
                49.5013315,
                30.7131891
              ],
              [
                49.501442,
                30.7144828
              ],
              [
                49.5013962,
                30.7162416
              ],
              [
                49.5014039,
                30.7177687
              ],
              [
                49.5013009,
                30.7191547
              ],
              [
                49.5012549,
                30.7203563
              ],
              [
                49.5011558,
                30.7218844
              ],
              [
                49.5011426,
                30.7220944
              ],
              [
                49.5010568,
                30.7234554
              ],
              [
                49.5010641,
                30.7257223
              ],
              [
                49.5011291,
                30.7284026
              ],
              [
                49.5012551,
                30.7327031
              ],
              [
                49.5012588,
                30.7339978
              ],
              [
                49.5018996,
                30.7351961
              ],
              [
                49.502865,
                30.7367636
              ],
              [
                49.5036699,
                30.7387487
              ],
              [
                49.5044213,
                30.7407332
              ],
              [
                49.5054398,
                30.743596
              ],
              [
                49.5063019,
                30.7461343
              ],
              [
                49.5068932,
                30.7480741
              ],
              [
                49.5072174,
                30.7492755
              ],
              [
                49.507186,
                30.7500015
              ],
              [
                49.5071108,
                30.7516381
              ],
              [
                49.5076981,
                30.7535372
              ],
              [
                49.5079652,
                30.75525
              ],
              [
                49.5082361,
                30.7565455
              ],
              [
                49.5088197,
                30.7578875
              ],
              [
                49.5096169,
                30.7594575
              ],
              [
                49.5099868,
                30.7601993
              ],
              [
                49.510727,
                30.7608461
              ],
              [
                49.5115738,
                30.7614897
              ],
              [
                49.5132104,
                30.7623633
              ],
              [
                49.5151099,
                30.7634226
              ],
              [
                49.5182801,
                30.7652159
              ],
              [
                49.5194435,
                30.7662306
              ],
              [
                49.5233041,
                30.7693196
              ],
              [
                49.527012,
                30.7723165
              ],
              [
                49.5296059,
                30.7741594
              ],
              [
                49.5315131,
                30.7757734
              ],
              [
                49.5332602,
                30.7771578
              ],
              [
                49.5346413,
                30.7785876
              ],
              [
                49.5367087,
                30.7805259
              ],
              [
                49.5387763,
                30.782277
              ],
              [
                49.5464288,
                30.790219
              ],
              [
                49.5539854,
                30.798622
              ],
              [
                49.5551617,
                30.7998328
              ],
              [
                49.5596313,
                30.8044387
              ],
              [
                49.560856,
                30.8055011
              ],
              [
                49.5618133,
                30.806423
              ],
              [
                49.5640527,
                30.8087304
              ],
              [
                49.5662421,
                30.811132
              ],
              [
                49.5734483,
                30.8188917
              ],
              [
                49.577137,
                30.8230012
              ],
              [
                49.5786895,
                30.8250347
              ],
              [
                49.5808831,
                30.8272962
              ],
              [
                49.5832863,
                30.8297901
              ],
              [
                49.5916863,
                30.8381031
              ],
              [
                49.595436,
                30.8420279
              ],
              [
                49.5968285,
                30.8432723
              ],
              [
                49.5977936,
                30.8443812
              ],
              [
                49.5993501,
                30.8459521
              ],
              [
                49.6006392,
                30.8475674
              ],
              [
                49.6020356,
                30.8491862
              ],
              [
                49.6026801,
                30.8500164
              ],
              [
                49.6035386,
                30.8508941
              ],
              [
                49.604664,
                30.8519122
              ],
              [
                49.6055937,
                30.8525329
              ],
              [
                49.6056288,
                30.8525564
              ],
              [
                49.6061097,
                30.853157
              ],
              [
                49.6061174,
                30.8535744
              ],
              [
                49.6061744,
                30.8540374
              ],
              [
                49.6048582,
                30.855063
              ],
              [
                49.600853,
                30.8575798
              ],
              [
                49.59943,
                30.8583742
              ],
              [
                49.5986373,
                30.8589293
              ],
              [
                49.5979042,
                30.8594426
              ],
              [
                49.5967445,
                30.8602375
              ],
              [
                49.5963783,
                30.8606553
              ],
              [
                49.5959587,
                30.8612146
              ],
              [
                49.5955391,
                30.8617717
              ],
              [
                49.5952796,
                30.8625132
              ],
              [
                49.5952874,
                30.8631155
              ],
              [
                49.5951882,
                30.8635791
              ],
              [
                49.5952391,
                30.8641978
              ],
              [
                49.5952425,
                30.8642397
              ],
              [
                49.5952454,
                30.8642744
              ],
              [
                49.5955199,
                30.8650601
              ],
              [
                49.5957908,
                30.8657103
              ],
              [
                49.5962791,
                30.8664961
              ],
              [
                49.5968704,
                30.8671881
              ],
              [
                49.5974618,
                30.8677878
              ],
              [
                49.5980493,
                30.8682497
              ],
              [
                49.5986901,
                30.8686649
              ],
              [
                49.5996512,
                30.8690317
              ],
              [
                49.6011961,
                30.869398
              ],
              [
                49.6026878,
                30.8698088
              ],
              [
                49.6040726,
                30.8700832
              ],
              [
                49.6065217,
                30.8704434
              ],
              [
                49.6090738,
                30.8709445
              ],
              [
                49.611313,
                30.8714467
              ],
              [
                49.6125907,
                30.8717198
              ],
              [
                49.6138193,
                30.8721796
              ],
              [
                49.6156349,
                30.8730516
              ],
              [
                49.6190565,
                30.8748024
              ],
              [
                49.6223182,
                30.8764115
              ],
              [
                49.6259536,
                30.8781598
              ],
              [
                49.6275102,
                30.8790808
              ],
              [
                49.6283167,
                30.8795833
              ],
              [
                49.6284715,
                30.8796797
              ],
              [
                49.6291733,
                30.8803751
              ],
              [
                49.6295014,
                30.8811139
              ],
              [
                49.6298384,
                30.8816881
              ],
              [
                49.6300469,
                30.8820399
              ],
              [
                49.6303824,
                30.8833381
              ],
              [
                49.6304435,
                30.8841237
              ],
              [
                49.6303522,
                30.8850971
              ],
              [
                49.6300431,
                30.885978
              ],
              [
                49.6295778,
                30.8868618
              ],
              [
                49.6280098,
                30.8889992
              ],
              [
                49.6262283,
                30.8912313
              ],
              [
                49.6242904,
                30.8935542
              ],
              [
                49.6221315,
                30.8954643
              ],
              [
                49.6195487,
                30.8976043
              ],
              [
                49.6178092,
                30.8989548
              ],
              [
                49.6147574,
                30.9018859
              ],
              [
                49.6118088,
                30.9046309
              ],
              [
                49.6097565,
                30.906817
              ],
              [
                49.6038589,
                30.9130013
              ],
              [
                49.6003265,
                30.9165832
              ],
              [
                49.5979005,
                30.9189094
              ],
              [
                49.5946272,
                30.9221624
              ],
              [
                49.5906104,
                30.9258854
              ],
              [
                49.587967,
                30.9283038
              ],
              [
                49.5873953,
                30.9288167
              ],
              [
                49.5852698,
                30.9307238
              ],
              [
                49.5835763,
                30.9321645
              ],
              [
                49.5819893,
                30.9337012
              ],
              [
                49.5801391,
                30.9355146
              ],
              [
                49.5783423,
                30.9375586
              ],
              [
                49.5761757,
                30.9402549
              ],
              [
                49.5747527,
                30.9421135
              ],
              [
                49.5734824,
                30.9436942
              ],
              [
                49.5721588,
                30.9450419
              ],
              [
                49.5709954,
                30.9461116
              ],
              [
                49.5699843,
                30.946856
              ],
              [
                49.5588149,
                30.9818355
              ],
              [
                49.5340918,
                31.0567576
              ],
              [
                49.4900006,
                31.064825
              ],
              [
                49.4821662,
                31.0808058
              ],
              [
                49.4735374,
                31.0988238
              ],
              [
                49.4656218,
                31.1148671
              ],
              [
                49.4648474,
                31.1165223
              ],
              [
                49.4645424,
                31.1175765
              ],
              [
                49.4641916,
                31.1189526
              ],
              [
                49.4642106,
                31.1204166
              ],
              [
                49.4626713,
                31.1267131
              ],
              [
                49.4642548,
                31.1420922
              ],
              [
                49.4648784,
                31.1602167
              ],
              [
                49.4669967,
                31.1708759
              ],
              [
                49.4682375,
                31.1791615
              ],
              [
                49.4644909,
                31.1842368
              ],
              [
                49.4593059,
                31.1932333
              ],
              [
                49.4462099,
                31.2096173
              ],
              [
                49.4386597,
                31.2229166
              ],
              [
                49.435306,
                31.2281789
              ],
              [
                49.4344255,
                31.2295604
              ],
              [
                49.4306425,
                31.2366035
              ],
              [
                49.4283055,
                31.2393318
              ],
              [
                49.4217652,
                31.2467347
              ],
              [
                49.4197208,
                31.2477602
              ],
              [
                49.4162063,
                31.2502108
              ],
              [
                49.4120088,
                31.2544913
              ],
              [
                49.4059775,
                31.2587488
              ],
              [
                49.4017792,
                31.2630289
              ],
              [
                49.3994142,
                31.2673317
              ],
              [
                49.3979658,
                31.2716458
              ],
              [
                49.3924379,
                31.2731521
              ],
              [
                49.3901525,
                31.2727297
              ],
              [
                49.3846714,
                31.2714794
              ],
              [
                49.3778153,
                31.2702115
              ],
              [
                49.3714178,
                31.268949
              ],
              [
                49.3576861,
                31.2675927
              ],
              [
                49.3512754,
                31.2671168
              ],
              [
                49.3471567,
                31.26667
              ],
              [
                49.3444132,
                31.2662409
              ],
              [
                49.3421488,
                31.2646363
              ],
              [
                49.3408013,
                31.2630436
              ],
              [
                49.3390023,
                31.2610512
              ],
              [
                49.3339949,
                31.2590172
              ],
              [
                49.3267099,
                31.2561658
              ],
              [
                49.32171,
                31.2537376
              ],
              [
                49.3180714,
                31.2521147
              ],
              [
                49.3144609,
                31.2489167
              ],
              [
                49.3108365,
                31.2465062
              ],
              [
                49.297624,
                31.2419997
              ],
              [
                49.2939795,
                31.2407908
              ],
              [
                49.2889668,
                31.239128
              ],
              [
                49.2807612,
                31.2366555
              ],
              [
                49.2757493,
                31.2350131
              ],
              [
                49.2746581,
                31.234728
              ],
              [
                49.2727715,
                31.2342351
              ],
              [
                49.2718353,
                31.2327342
              ],
              [
                49.2701416,
                31.2298653
              ],
              [
                49.2664491,
                31.2246826
              ],
              [
                49.2600211,
                31.2144404
              ],
              [
                49.2571297,
                31.2092029
              ],
              [
                49.2546653,
                31.2043252
              ],
              [
                49.253128,
                31.2007231
              ],
              [
                49.252243,
                31.1983971
              ],
              [
                49.25169,
                31.196617
              ],
              [
                49.2514572,
                31.1950622
              ],
              [
                49.251381,
                31.1933224
              ],
              [
                49.2513581,
                31.1913578
              ],
              [
                49.2510031,
                31.1886579
              ],
              [
                49.2509271,
                31.1867828
              ],
              [
                49.2508468,
                31.1846775
              ],
              [
                49.2511443,
                31.1828909
              ],
              [
                49.251335,
                31.1811479
              ],
              [
                49.2514686,
                31.1788607
              ],
              [
                49.2516061,
                31.1769817
              ],
              [
                49.2515832,
                31.1708019
              ],
              [
                49.2518882,
                31.1696559
              ],
              [
                49.2523003,
                31.1684617
              ],
              [
                49.2527121,
                31.1674051
              ],
              [
                49.2532385,
                31.1667131
              ],
              [
                49.2538147,
                31.165794
              ],
              [
                49.2543281,
                31.1652198
              ],
              [
                49.2553406,
                31.1640872
              ],
              [
                49.2571868,
                31.1623756
              ],
              [
                49.2588732,
                31.1609438
              ],
              [
                49.2609369,
                31.1594133
              ],
              [
                49.2645227,
                31.1562254
              ],
              [
                49.2686959,
                31.1529844
              ],
              [
                49.2721252,
                31.1500242
              ],
              [
                49.2753373,
                31.1469775
              ],
              [
                49.2783889,
                31.1436986
              ],
              [
                49.2814903,
                31.1399647
              ],
              [
                49.288868,
                31.1333083
              ],
              [
                49.2929269,
                31.1297041
              ],
              [
                49.2962419,
                31.1262884
              ],
              [
                49.299408,
                31.1235585
              ],
              [
                49.3038864,
                31.1194452
              ],
              [
                49.3063582,
                31.1168616
              ],
              [
                49.3089904,
                31.1143657
              ],
              [
                49.31147,
                31.1124677
              ],
              [
                49.3133698,
                31.1108958
              ],
              [
                49.3112028,
                31.108443
              ],
              [
                49.3111718,
                31.1084067
              ],
              [
                49.3089867,
                31.1058519
              ],
              [
                49.3071977,
                31.1037174
              ],
              [
                49.304821,
                31.101176
              ],
              [
                49.3032455,
                31.0990376
              ],
              [
                49.3019448,
                31.0973086
              ],
              [
                49.30064,
                31.0954466
              ],
              [
                49.2993393,
                31.0936726
              ],
              [
                49.2984123,
                31.0921222
              ],
              [
                49.2970048,
                31.0902588
              ],
              [
                49.2955359,
                31.0880765
              ],
              [
                49.2937392,
                31.085069
              ],
              [
                49.2909697,
                31.0812028
              ],
              [
                49.2897302,
                31.0793685
              ],
              [
                49.2893411,
                31.0787928
              ],
              [
                49.2883108,
                31.077338
              ],
              [
                49.2872315,
                31.0761577
              ],
              [
                49.2857169,
                31.0744303
              ],
              [
                49.2848472,
                31.0731557
              ],
              [
                49.2839241,
                31.0717452
              ],
              [
                49.2829477,
                31.0705639
              ],
              [
                49.2804032,
                31.0671989
              ],
              [
                49.2785607,
                31.0647431
              ],
              [
                49.2773132,
                31.0630598
              ],
              [
                49.2757988,
                31.061197
              ],
              [
                49.2738532,
                31.0591096
              ],
              [
                49.2718009,
                31.0569757
              ],
              [
                49.2698022,
                31.0547973
              ],
              [
                49.2680207,
                31.0528
              ],
              [
                49.2663957,
                31.0505702
              ],
              [
                49.2644006,
                31.0488023
              ],
              [
                49.2634849,
                31.0480322
              ],
              [
                49.2630464,
                31.0471219
              ],
              [
                49.2620659,
                31.0452549
              ],
              [
                49.2607574,
                31.0428849
              ],
              [
                49.2594489,
                31.040515
              ],
              [
                49.257065,
                31.0372871
              ],
              [
                49.2549515,
                31.0343311
              ],
              [
                49.2522431,
                31.0306927
              ],
              [
                49.2500133,
                31.0276878
              ],
              [
                49.2473908,
                31.0245218
              ],
              [
                49.2448844,
                31.021495
              ],
              [
                49.2424851,
                31.0184222
              ],
              [
                49.2400857,
                31.0151667
              ],
              [
                49.2380599,
                31.0117741
              ],
              [
                49.2363511,
                31.008749
              ],
              [
                49.2350198,
                31.0060921
              ],
              [
                49.2337379,
                31.0031585
              ],
              [
                49.2330999,
                31.0013971
              ],
              [
                49.2325975,
                31.0000102
              ],
              [
                49.2315339,
                30.9977584
              ],
              [
                49.2305854,
                30.9963841
              ],
              [
                49.2293701,
                30.9946232
              ],
              [
                49.227764,
                30.992603
              ],
              [
                49.2270166,
                30.9913636
              ],
              [
                49.225197,
                30.9887924
              ],
              [
                49.2225724,
                30.9855763
              ],
              [
                49.2188796,
                30.9808457
              ],
              [
                49.2133178,
                30.9740503
              ],
              [
                49.2070618,
                30.9665663
              ],
              [
                49.2043343,
                30.9631229
              ],
              [
                49.2025146,
                30.9606889
              ],
              [
                49.2009088,
                30.9581181
              ],
              [
                49.1993064,
                30.9559127
              ],
              [
                49.1978073,
                30.9538011
              ],
              [
                49.195774,
                30.9511385
              ],
              [
                49.1932639,
                30.9482009
              ],
              [
                49.1908037,
                30.9455368
              ],
              [
                49.1888276,
                30.9431028
              ],
              [
                49.1866914,
                30.9404409
              ],
              [
                49.1846048,
                30.9380525
              ],
              [
                49.1822547,
                30.9351621
              ],
              [
                49.1813468,
                30.9344727
              ],
              [
                49.1813429,
                30.9336923
              ],
              [
                49.1811258,
                30.9320858
              ],
              [
                49.1806373,
                30.9296995
              ],
              [
                49.1800609,
                30.9273593
              ],
              [
                49.1800067,
                30.9271393
              ],
              [
                49.1799355,
                30.9268503
              ],
              [
                49.1796645,
                30.9246024
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555036,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رامهرمز",
          "name:en": "Ramhormoz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279505",
          "wikipedia": "en:Ramhormoz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.2727715,
                31.2342351
              ],
              [
                49.2746581,
                31.234728
              ],
              [
                49.2757493,
                31.2350131
              ],
              [
                49.2807612,
                31.2366555
              ],
              [
                49.2889668,
                31.239128
              ],
              [
                49.2939795,
                31.2407908
              ],
              [
                49.297624,
                31.2419997
              ],
              [
                49.3108365,
                31.2465062
              ],
              [
                49.3144609,
                31.2489167
              ],
              [
                49.3180714,
                31.2521147
              ],
              [
                49.32171,
                31.2537376
              ],
              [
                49.3267099,
                31.2561658
              ],
              [
                49.3339949,
                31.2590172
              ],
              [
                49.3390023,
                31.2610512
              ],
              [
                49.3408013,
                31.2630436
              ],
              [
                49.3421488,
                31.2646363
              ],
              [
                49.3444132,
                31.2662409
              ],
              [
                49.3471567,
                31.26667
              ],
              [
                49.3512754,
                31.2671168
              ],
              [
                49.3576861,
                31.2675927
              ],
              [
                49.3714178,
                31.268949
              ],
              [
                49.3778153,
                31.2702115
              ],
              [
                49.3846714,
                31.2714794
              ],
              [
                49.3901525,
                31.2727297
              ],
              [
                49.3924379,
                31.2731521
              ],
              [
                49.3979658,
                31.2716458
              ],
              [
                49.3994142,
                31.2673317
              ],
              [
                49.4017792,
                31.2630289
              ],
              [
                49.4059775,
                31.2587488
              ],
              [
                49.4120088,
                31.2544913
              ],
              [
                49.4162063,
                31.2502108
              ],
              [
                49.4197208,
                31.2477602
              ],
              [
                49.4217652,
                31.2467347
              ],
              [
                49.4283055,
                31.2393318
              ],
              [
                49.4306425,
                31.2366035
              ],
              [
                49.4344255,
                31.2295604
              ],
              [
                49.435306,
                31.2281789
              ],
              [
                49.4386597,
                31.2229166
              ],
              [
                49.4462099,
                31.2096173
              ],
              [
                49.4593059,
                31.1932333
              ],
              [
                49.4644909,
                31.1842368
              ],
              [
                49.4682375,
                31.1791615
              ],
              [
                49.4669967,
                31.1708759
              ],
              [
                49.4648784,
                31.1602167
              ],
              [
                49.4642548,
                31.1420922
              ],
              [
                49.4626713,
                31.1267131
              ],
              [
                49.4642106,
                31.1204166
              ],
              [
                49.4646455,
                31.120963
              ],
              [
                49.4652405,
                31.1214596
              ],
              [
                49.4673918,
                31.1227234
              ],
              [
                49.4738388,
                31.1259146
              ],
              [
                49.4771654,
                31.1274425
              ],
              [
                49.4808656,
                31.1287831
              ],
              [
                49.4856376,
                31.1304361
              ],
              [
                49.488476,
                31.131234
              ],
              [
                49.493504,
                31.1322323
              ],
              [
                49.4952605,
                31.132581
              ],
              [
                49.4999119,
                31.1331359
              ],
              [
                49.5030902,
                31.1328977
              ],
              [
                49.5056575,
                31.1326253
              ],
              [
                49.5079004,
                31.1324055
              ],
              [
                49.5142022,
                31.1324039
              ],
              [
                49.5198594,
                31.1318962
              ],
              [
                49.5236512,
                31.1316172
              ],
              [
                49.5276527,
                31.1315209
              ],
              [
                49.531124,
                31.1316575
              ],
              [
                49.5328866,
                31.1317047
              ],
              [
                49.5347557,
                31.1317034
              ],
              [
                49.5360168,
                31.131558
              ],
              [
                49.537159,
                31.1314262
              ],
              [
                49.5404662,
                31.130963
              ],
              [
                49.5424959,
                31.1303613
              ],
              [
                49.5441475,
                31.1296672
              ],
              [
                49.5458031,
                31.1285582
              ],
              [
                49.5481452,
                31.1264803
              ],
              [
                49.5496832,
                31.1251115
              ],
              [
                49.5521966,
                31.1228744
              ],
              [
                49.5571517,
                31.1189469
              ],
              [
                49.56221,
                31.1147835
              ],
              [
                49.5671082,
                31.1109475
              ],
              [
                49.5698243,
                31.1090041
              ],
              [
                49.5722731,
                31.1070623
              ],
              [
                49.5741883,
                31.1053513
              ],
              [
                49.5780714,
                31.1016525
              ],
              [
                49.5806235,
                31.098832
              ],
              [
                49.5828018,
                31.097029
              ],
              [
                49.5853042,
                31.0950852
              ],
              [
                49.5882797,
                31.0928196
              ],
              [
                49.5949249,
                31.0878219
              ],
              [
                49.6001893,
                31.0840269
              ],
              [
                49.602688,
                31.0822225
              ],
              [
                49.6043854,
                31.0807884
              ],
              [
                49.6050757,
                31.0799095
              ],
              [
                49.6056701,
                31.0789293
              ],
              [
                49.6060296,
                31.0783364
              ],
              [
                49.6068231,
                31.0772263
              ],
              [
                49.6071929,
                31.0765785
              ],
              [
                49.6072464,
                31.0762092
              ],
              [
                49.6070825,
                31.0757924
              ],
              [
                49.606655,
                31.075145
              ],
              [
                49.6062242,
                31.0744998
              ],
              [
                49.6060552,
                31.0739876
              ],
              [
                49.6060105,
                31.0738524
              ],
              [
                49.606327,
                31.0728814
              ],
              [
                49.6071206,
                31.0714939
              ],
              [
                49.6086044,
                31.0698747
              ],
              [
                49.6104089,
                31.0685792
              ],
              [
                49.611473,
                31.0680223
              ],
              [
                49.6126443,
                31.0678815
              ],
              [
                49.6134949,
                31.0679741
              ],
              [
                49.6141891,
                31.0683898
              ],
              [
                49.6160049,
                31.0694965
              ],
              [
                49.6169372,
                31.0701396
              ],
              [
                49.6178781,
                31.0707886
              ],
              [
                49.6192666,
                31.0715726
              ],
              [
                49.6209716,
                31.0723577
              ],
              [
                49.6217727,
                31.0726347
              ],
              [
                49.6224138,
                31.0726799
              ],
              [
                49.6234246,
                31.072402
              ],
              [
                49.6235276,
                31.0717084
              ],
              [
                49.6235772,
                31.0711992
              ],
              [
                49.6232528,
                31.070368
              ],
              [
                49.6229325,
                31.0700916
              ],
              [
                49.6228972,
                31.0697863
              ],
              [
                49.622879,
                31.0696287
              ],
              [
                49.6229819,
                31.0691652
              ],
              [
                49.6231917,
                31.0685652
              ],
              [
                49.6240958,
                31.0680087
              ],
              [
                49.6249465,
                31.0677291
              ],
              [
                49.626011,
                31.0674968
              ],
              [
                49.6265449,
                31.0675905
              ],
              [
                49.6276627,
                31.0680512
              ],
              [
                49.6280936,
                31.0684663
              ],
              [
                49.6285743,
                31.0692969
              ],
              [
                49.6287253,
                31.0697412
              ],
              [
                49.6289521,
                31.0704084
              ],
              [
                49.6290665,
                31.0713795
              ],
              [
                49.6292305,
                31.0723037
              ],
              [
                49.6296578,
                31.0729511
              ],
              [
                49.629982,
                31.0733673
              ],
              [
                49.6305162,
                31.0737338
              ],
              [
                49.6313704,
                31.0741511
              ],
              [
                49.6325417,
                31.0744274
              ],
              [
                49.6334497,
                31.0745183
              ],
              [
                49.6344071,
                31.0744246
              ],
              [
                49.6354714,
                31.0739623
              ],
              [
                49.6360274,
                31.0737503
              ],
              [
                49.6366919,
                31.073497
              ],
              [
                49.6384467,
                31.0725705
              ],
              [
                49.6398277,
                31.071922
              ],
              [
                49.6409987,
                31.0715509
              ],
              [
                49.6415824,
                31.0714578
              ],
              [
                49.642437,
                31.0715954
              ],
              [
                49.6431848,
                31.0717792
              ],
              [
                49.6437187,
                31.0721028
              ],
              [
                49.6443063,
                31.0726571
              ],
              [
                49.6447373,
                31.0733969
              ],
              [
                49.645378,
                31.0741817
              ],
              [
                49.6457438,
                31.0745276
              ],
              [
                49.6459159,
                31.0746904
              ],
              [
                49.6465035,
                31.0750597
              ],
              [
                49.6475183,
                31.075244
              ],
              [
                49.6480483,
                31.0752428
              ],
              [
                49.6488495,
                31.0752422
              ],
              [
                49.6499137,
                31.0750571
              ],
              [
                49.6505508,
                31.0745021
              ],
              [
                49.6512911,
                31.0738062
              ],
              [
                49.6518744,
                31.0731582
              ],
              [
                49.6524544,
                31.0722801
              ],
              [
                49.6527337,
                31.0718168
              ],
              [
                49.6534042,
                31.0707044
              ],
              [
                49.6538237,
                31.0693645
              ],
              [
                49.65403,
                31.0682998
              ],
              [
                49.6546097,
                31.0675119
              ],
              [
                49.6561967,
                31.0658459
              ],
              [
                49.6568297,
                31.0648285
              ],
              [
                49.6574096,
                31.0633008
              ],
              [
                49.6577186,
                31.0620522
              ],
              [
                49.6579819,
                31.0613106
              ],
              [
                49.6581918,
                31.0609407
              ],
              [
                49.6581344,
                31.0601552
              ],
              [
                49.6580239,
                31.0594616
              ],
              [
                49.6579665,
                31.0587685
              ],
              [
                49.6582831,
                31.0583523
              ],
              [
                49.6590232,
                31.0576112
              ],
              [
                49.6598206,
                31.0571932
              ],
              [
                49.6605644,
                31.0570994
              ],
              [
                49.6606111,
                31.0571106
              ],
              [
                49.6615256,
                31.0573304
              ],
              [
                49.6633948,
                31.0582994
              ],
              [
                49.6644632,
                31.0586217
              ],
              [
                49.6651536,
                31.0588521
              ],
              [
                49.6658477,
                31.0591751
              ],
              [
                49.6669197,
                31.0597749
              ],
              [
                49.6678277,
                31.0602353
              ],
              [
                49.6683082,
                31.0604659
              ],
              [
                49.6689452,
                31.060513
              ],
              [
                49.6698495,
                31.0605133
              ],
              [
                49.6702765,
                31.060326
              ],
              [
                49.6707,
                31.0601409
              ],
              [
                49.6710166,
                31.0599096
              ],
              [
                49.6711236,
                31.0595408
              ],
              [
                49.6712264,
                31.0593073
              ],
              [
                49.6712227,
                31.0587975
              ],
              [
                49.6711655,
                31.058197
              ],
              [
                49.6709519,
                31.0578271
              ],
              [
                49.6705207,
                31.0572746
              ],
              [
                49.6704742,
                31.057209
              ],
              [
                49.6700935,
                31.0566725
              ],
              [
                49.6692353,
                31.0560727
              ],
              [
                49.6681709,
                31.0556557
              ],
              [
                49.6671028,
                31.0551485
              ],
              [
                49.6663017,
                31.0549191
              ],
              [
                49.665928,
                31.0545499
              ],
              [
                49.6655502,
                31.0539956
              ],
              [
                49.6655502,
                31.0537182
              ],
              [
                49.6657563,
                31.0528384
              ],
              [
                49.6662864,
                31.0522823
              ],
              [
                49.6674994,
                31.0509393
              ],
              [
                49.6685599,
                31.0499217
              ],
              [
                49.6690544,
                31.0494343
              ],
              [
                49.6698302,
                31.0486695
              ],
              [
                49.6708337,
                31.0479761
              ],
              [
                49.6713712,
                31.0476794
              ],
              [
                49.6718445,
                31.0474181
              ],
              [
                49.6726912,
                31.0471404
              ],
              [
                49.6735953,
                31.0469535
              ],
              [
                49.6747132,
                31.0468139
              ],
              [
                49.6758842,
                31.0467199
              ],
              [
                49.6769448,
                31.0465345
              ],
              [
                49.6782225,
                31.046207
              ],
              [
                49.6798135,
                31.0457903
              ],
              [
                49.6806067,
                31.0450924
              ],
              [
                49.6811333,
                31.044261
              ],
              [
                49.6817666,
                31.0434262
              ],
              [
                49.6821823,
                31.0421312
              ],
              [
                49.6826057,
                31.0413912
              ],
              [
                49.6835021,
                31.0401869
              ],
              [
                49.6842957,
                31.0397214
              ],
              [
                49.6854631,
                31.0391198
              ],
              [
                49.6866303,
                31.0389332
              ],
              [
                49.6879617,
                31.0389309
              ],
              [
                49.6893425,
                31.0389292
              ],
              [
                49.6893608,
                31.0389325
              ],
              [
                49.6900902,
                31.0390653
              ],
              [
                49.6908874,
                31.0388817
              ],
              [
                49.6916809,
                31.0384183
              ],
              [
                49.6919564,
                31.038107
              ],
              [
                49.6924208,
                31.0375823
              ],
              [
                49.6930505,
                31.0362399
              ],
              [
                49.6938895,
                31.034665
              ],
              [
                49.6944086,
                31.0328139
              ],
              [
                49.6944504,
                31.0314272
              ],
              [
                49.6947061,
                31.0301306
              ],
              [
                49.6951791,
                31.0291565
              ],
              [
                49.6954345,
                31.0281396
              ],
              [
                49.6959039,
                31.0267053
              ],
              [
                49.6962699,
                31.0260098
              ],
              [
                49.6967429,
                31.0250831
              ],
              [
                49.6973267,
                31.0246649
              ],
              [
                49.69796,
                31.024342
              ],
              [
                49.6982802,
                31.0243407
              ],
              [
                49.6990241,
                31.024479
              ],
              [
                49.6993447,
                31.024665
              ],
              [
                49.6997222,
                31.0251244
              ],
              [
                49.699993,
                31.0258647
              ],
              [
                49.699997,
                31.0265594
              ],
              [
                49.7001647,
                31.0273009
              ],
              [
                49.7003785,
                31.0278557
              ],
              [
                49.7004892,
                31.0284568
              ],
              [
                49.7008133,
                31.0289179
              ],
              [
                49.7011871,
                31.0293344
              ],
              [
                49.7012245,
                31.0293761
              ],
              [
                49.7017251,
                31.029933
              ],
              [
                49.7027397,
                31.0304891
              ],
              [
                49.7035408,
                31.0309054
              ],
              [
                49.7044486,
                31.0311784
              ],
              [
                49.7051924,
                31.0311791
              ],
              [
                49.7060968,
                31.0311769
              ],
              [
                49.7067871,
                31.0309447
              ],
              [
                49.7069968,
                31.0306671
              ],
              [
                49.7070959,
                31.0300208
              ],
              [
                49.7070922,
                31.029326
              ],
              [
                49.7068216,
                31.0285407
              ],
              [
                49.7063866,
                31.0277063
              ],
              [
                49.7058487,
                31.0267355
              ],
              [
                49.7050398,
                31.0253493
              ],
              [
                49.7047212,
                31.0245607
              ],
              [
                49.7044982,
                31.0240086
              ],
              [
                49.704384,
                31.0230827
              ],
              [
                49.7039985,
                31.0212789
              ],
              [
                49.7041512,
                31.0203985
              ],
              [
                49.7042504,
                31.0193349
              ],
              [
                49.7047196,
                31.0184081
              ],
              [
                49.7053528,
                31.0173904
              ],
              [
                49.7057725,
                31.0169255
              ],
              [
                49.7063561,
                31.0167396
              ],
              [
                49.7068368,
                31.01697
              ],
              [
                49.7070541,
                31.0174323
              ],
              [
                49.706951,
                31.0179432
              ],
              [
                49.7071647,
                31.0183581
              ],
              [
                49.7075384,
                31.0186348
              ],
              [
                49.7079273,
                31.0188029
              ],
              [
                49.7080725,
                31.0188657
              ],
              [
                49.7086068,
                31.0188643
              ],
              [
                49.7091864,
                31.0185859
              ],
              [
                49.7097701,
                31.0181226
              ],
              [
                49.7101899,
                31.017705
              ],
              [
                49.7103464,
                31.0171945
              ],
              [
                49.7104223,
                31.0168762
              ],
              [
                49.7106551,
                31.0159007
              ],
              [
                49.7106437,
                31.0144187
              ],
              [
                49.7106857,
                31.013262
              ],
              [
                49.7106819,
                31.0124274
              ],
              [
                49.7108344,
                31.0118267
              ],
              [
                49.7112045,
                31.011641
              ],
              [
                49.7116853,
                31.0115465
              ],
              [
                49.7118948,
                31.0115937
              ],
              [
                49.7122191,
                31.0119173
              ],
              [
                49.7125398,
                31.0121934
              ],
              [
                49.7129668,
                31.0124254
              ],
              [
                49.7134438,
                31.0124234
              ],
              [
                49.7141343,
                31.0121912
              ],
              [
                49.7146112,
                31.0120516
              ],
              [
                49.7151946,
                31.0117732
              ],
              [
                49.7158812,
                31.0114936
              ],
              [
                49.7166748,
                31.011215
              ],
              [
                49.7174722,
                31.0111666
              ],
              [
                49.7180061,
                31.0111651
              ],
              [
                49.7188034,
                31.0113963
              ],
              [
                49.7194978,
                31.011534
              ],
              [
                49.7201921,
                31.0119492
              ],
              [
                49.7204589,
                31.0124119
              ],
              [
                49.7206766,
                31.0127344
              ],
              [
                49.7206765,
                31.0131043
              ],
              [
                49.7206268,
                31.0135233
              ],
              [
                49.7205545,
                31.0137508
              ],
              [
                49.7205239,
                31.0138471
              ],
              [
                49.7203674,
                31.0142628
              ],
              [
                49.7203179,
                31.014542
              ],
              [
                49.7203752,
                31.0149576
              ],
              [
                49.7205888,
                31.0151424
              ],
              [
                49.7211228,
                31.0153282
              ],
              [
                49.7218132,
                31.015326
              ],
              [
                49.7225571,
                31.0154168
              ],
              [
                49.7239418,
                31.0154621
              ],
              [
                49.7250059,
                31.015644
              ],
              [
                49.7259635,
                31.0156873
              ],
              [
                49.7266008,
                31.0155492
              ],
              [
                49.727394,
                31.0152232
              ],
              [
                49.7279205,
                31.0148518
              ],
              [
                49.7289772,
                31.0141111
              ],
              [
                49.729557,
                31.0134604
              ],
              [
                49.7297347,
                31.0132001
              ],
              [
                49.7298735,
                31.0129966
              ],
              [
                49.7300223,
                31.0120711
              ],
              [
                49.7303924,
                31.0116078
              ],
              [
                49.7308119,
                31.0110503
              ],
              [
                49.7314452,
                31.0105423
              ],
              [
                49.7320253,
                31.0098465
              ],
              [
                49.7326584,
                31.009476
              ],
              [
                49.733612,
                31.0092418
              ],
              [
                49.7355767,
                31.009146
              ],
              [
                49.7369574,
                31.0088663
              ],
              [
                49.7388689,
                31.008585
              ],
              [
                49.7399291,
                31.0082593
              ],
              [
                49.7408296,
                31.0078869
              ],
              [
                49.7414094,
                31.0076083
              ],
              [
                49.7417792,
                31.0072375
              ],
              [
                49.7418824,
                31.0069588
              ],
              [
                49.7418785,
                31.0063566
              ],
              [
                49.7418748,
                31.0059866
              ],
              [
                49.7417107,
                31.0055226
              ],
              [
                49.7412797,
                31.004923
              ],
              [
                49.7409021,
                31.0044163
              ],
              [
                49.7404214,
                31.0039064
              ],
              [
                49.7399901,
                31.0033969
              ],
              [
                49.7399864,
                31.0029819
              ],
              [
                49.7399826,
                31.0023773
              ],
              [
                49.7401353,
                31.0018691
              ],
              [
                49.7403451,
                31.0015441
              ],
              [
                49.7407149,
                31.0012206
              ],
              [
                49.7412451,
                31.0011739
              ],
              [
                49.7417754,
                31.0011723
              ],
              [
                49.7426299,
                31.0013566
              ],
              [
                49.7432672,
                31.0016786
              ],
              [
                49.7454566,
                31.0026472
              ],
              [
                49.7464181,
                31.0033851
              ],
              [
                49.747383,
                31.0042177
              ],
              [
                49.7480607,
                31.0044936
              ],
              [
                49.748291,
                31.0045874
              ],
              [
                49.750096,
                31.0053041
              ],
              [
                49.7515525,
                31.0053137
              ],
              [
                49.7541085,
                31.0054895
              ],
              [
                49.7561303,
                31.0055744
              ],
              [
                49.7583656,
                31.0054764
              ],
              [
                49.7596434,
                31.0051503
              ],
              [
                49.7606543,
                31.0047337
              ],
              [
                49.761608,
                31.0041361
              ],
              [
                49.7622987,
                31.0034007
              ],
              [
                49.7625121,
                31.0027125
              ],
              [
                49.7627753,
                31.0020226
              ],
              [
                49.7634325,
                31.0010951
              ],
              [
                49.7645149,
                31.000104
              ],
              [
                49.765629,
                30.9992192
              ],
              [
                49.7669069,
                30.9982435
              ],
              [
                49.7672729,
                30.9975477
              ],
              [
                49.7677496,
                30.9966681
              ],
              [
                49.7679595,
                30.995928
              ],
              [
                49.7680627,
                30.995002
              ],
              [
                49.7678946,
                30.9941252
              ],
              [
                49.7673569,
                30.9931592
              ],
              [
                49.7666587,
                30.9921466
              ],
              [
                49.766281,
                30.99164
              ],
              [
                49.7659608,
                30.9910865
              ],
              [
                49.7658499,
                30.9906254
              ],
              [
                49.7658461,
                30.9899329
              ],
              [
                49.7660559,
                30.9894702
              ],
              [
                49.7667465,
                30.9886332
              ],
              [
                49.7667962,
                30.9878939
              ],
              [
                49.7670022,
                30.9865064
              ],
              [
                49.7673683,
                30.9851182
              ],
              [
                49.768154,
                30.9830822
              ],
              [
                49.7689475,
                30.9817364
              ],
              [
                49.7694246,
                30.9811793
              ],
              [
                49.7700652,
                30.9810388
              ],
              [
                49.7707024,
                30.9810359
              ],
              [
                49.7715035,
                30.9807976
              ],
              [
                49.7721938,
                30.9803328
              ],
              [
                49.7726135,
                30.9795451
              ],
              [
                49.7727699,
                30.9787593
              ],
              [
                49.7728729,
                30.9780205
              ],
              [
                49.7724876,
                30.9760364
              ],
              [
                49.7722131,
                30.9743264
              ],
              [
                49.7723694,
                30.9740031
              ],
              [
                49.7727396,
                30.9735848
              ],
              [
                49.7734834,
                30.9733505
              ],
              [
                49.7742309,
                30.9732065
              ],
              [
                49.774868,
                30.9729261
              ],
              [
                49.775879,
                30.9723199
              ],
              [
                49.7766723,
                30.9717161
              ],
              [
                49.7773094,
                30.9712507
              ],
              [
                49.7780533,
                30.9710615
              ],
              [
                49.7783737,
                30.9710601
              ],
              [
                49.779068,
                30.9712403
              ],
              [
                49.779869,
                30.971699
              ],
              [
                49.780674,
                30.9721103
              ],
              [
                49.7820052,
                30.9725672
              ],
              [
                49.7829133,
                30.9727923
              ],
              [
                49.784195,
                30.9729713
              ],
              [
                49.7852594,
                30.9728708
              ],
              [
                49.7862701,
                30.9725893
              ],
              [
                49.7871207,
                30.9722161
              ],
              [
                49.7876511,
                30.9717497
              ],
              [
                49.7880746,
                30.9711943
              ],
              [
                49.7883911,
                30.9705928
              ],
              [
                49.7885932,
                30.9694375
              ],
              [
                49.78891,
                30.9684187
              ],
              [
                49.789486,
                30.9671678
              ],
              [
                49.7903288,
                30.9658697
              ],
              [
                49.7911226,
                30.9649884
              ],
              [
                49.7919158,
                30.9641523
              ],
              [
                49.7923926,
                30.9638274
              ],
              [
                49.7928198,
                30.9637321
              ],
              [
                49.7934571,
                30.9636366
              ],
              [
                49.7941513,
                30.9637716
              ],
              [
                49.7946319,
                30.9639521
              ],
              [
                49.7951125,
                30.964137
              ],
              [
                49.7956467,
                30.9642254
              ],
              [
                49.7966079,
                30.9643133
              ],
              [
                49.7978325,
                30.9646766
              ],
              [
                49.7992211,
                30.9652241
              ],
              [
                49.8003998,
                30.9658643
              ],
              [
                49.8025932,
                30.9670057
              ],
              [
                49.8048363,
                30.9681949
              ],
              [
                49.8062288,
                30.9690198
              ],
              [
                49.8077316,
                30.9702584
              ],
              [
                49.8091242,
                30.9714983
              ],
              [
                49.8103064,
                30.9727859
              ],
              [
                49.811062,
                30.9740762
              ],
              [
                49.8114432,
                30.9753181
              ],
              [
                49.8116148,
                30.9768895
              ],
              [
                49.8125536,
                30.9811793
              ],
              [
                49.8127899,
                30.984134
              ],
              [
                49.8128625,
                30.9864872
              ],
              [
                49.8131409,
                30.9882424
              ],
              [
                49.8135301,
                30.9900865
              ],
              [
                49.8141937,
                30.9930858
              ],
              [
                49.8151206,
                30.9958055
              ],
              [
                49.8156091,
                30.996958
              ],
              [
                49.8167794,
                30.9983244
              ],
              [
                49.819193,
                31.0000427
              ],
              [
                49.820732,
                31.002486
              ],
              [
                49.821911,
                31.0047275
              ],
              [
                49.822876,
                31.0070618
              ],
              [
                49.8239519,
                31.0094445
              ],
              [
                49.8244168,
                31.0100298
              ],
              [
                49.8248596,
                31.0105873
              ],
              [
                49.825718,
                31.0119146
              ],
              [
                49.8267899,
                31.0131041
              ],
              [
                49.8279115,
                31.0141992
              ],
              [
                49.8301049,
                31.0164408
              ],
              [
                49.8313332,
                31.0179948
              ],
              [
                49.8323517,
                31.0195987
              ],
              [
                49.8343926,
                31.023305
              ],
              [
                49.8361626,
                31.0265555
              ],
              [
                49.8378296,
                31.0295321
              ],
              [
                49.839279,
                31.032554
              ],
              [
                49.8400344,
                31.0347984
              ],
              [
                49.8411674,
                31.0377295
              ],
              [
                49.8416022,
                31.0393326
              ],
              [
                49.8422546,
                31.0424038
              ],
              [
                49.8427428,
                31.0443277
              ],
              [
                49.8435478,
                31.0453815
              ],
              [
                49.8441887,
                31.046021
              ],
              [
                49.8452071,
                31.0468422
              ],
              [
                49.846222,
                31.0472978
              ],
              [
                49.8473184,
                31.0476108
              ],
              [
                49.8473397,
                31.0476168
              ],
              [
                49.8484077,
                31.0477956
              ],
              [
                49.8493653,
                31.0477951
              ],
              [
                49.849848,
                31.0476746
              ],
              [
                49.8508568,
                31.0474227
              ],
              [
                49.8528253,
                31.0464071
              ],
              [
                49.854683,
                31.0453477
              ],
              [
                49.854884,
                31.0451892
              ],
              [
                49.8564337,
                31.0439671
              ],
              [
                49.8572312,
                31.0434125
              ],
              [
                49.8579215,
                31.0429991
              ],
              [
                49.8585588,
                31.0424453
              ],
              [
                49.8603096,
                31.0413849
              ],
              [
                49.8622285,
                31.0408311
              ],
              [
                49.8638763,
                31.0404126
              ],
              [
                49.8654747,
                31.0401785
              ],
              [
                49.867443,
                31.0401733
              ],
              [
                49.8711206,
                31.0403454
              ],
              [
                49.8735732,
                31.0405675
              ],
              [
                49.8751878,
                31.0409749
              ],
              [
                49.8755454,
                31.0410652
              ],
              [
                49.8765601,
                31.0412454
              ],
              [
                49.8777353,
                31.0416098
              ],
              [
                49.8787459,
                31.0417426
              ],
              [
                49.8799743,
                31.0416473
              ],
              [
                49.8812485,
                31.0414147
              ],
              [
                49.8828429,
                31.0406301
              ],
              [
                49.8855552,
                31.0394761
              ],
              [
                49.8874131,
                31.0384613
              ],
              [
                49.8884317,
                31.0377788
              ],
              [
                49.8892708,
                31.0372165
              ],
              [
                49.8907014,
                31.0361123
              ],
              [
                49.8926124,
                31.0346851
              ],
              [
                49.8948402,
                31.0333012
              ],
              [
                49.8965378,
                31.0320594
              ],
              [
                49.8987082,
                31.0304471
              ],
              [
                49.89964,
                31.029799
              ],
              [
                49.8997687,
                31.0297096
              ],
              [
                49.9002992,
                31.0289291
              ],
              [
                49.9006653,
                31.0280999
              ],
              [
                49.9008712,
                31.0270461
              ],
              [
                49.9011306,
                31.0259002
              ],
              [
                49.901123,
                31.0244768
              ],
              [
                49.9013786,
                31.0229159
              ],
              [
                49.9013709,
                31.0214497
              ],
              [
                49.9014624,
                31.0195241
              ],
              [
                49.9011877,
                31.0182406
              ],
              [
                49.9005318,
                31.0155802
              ],
              [
                49.8999862,
                31.0131981
              ],
              [
                49.8997117,
                31.0117319
              ],
              [
                49.8992766,
                31.0104019
              ],
              [
                49.8990555,
                31.0088437
              ],
              [
                49.8989676,
                31.0085409
              ],
              [
                49.8986169,
                31.0073332
              ],
              [
                49.8981742,
                31.0045843
              ],
              [
                49.8975831,
                31.0031628
              ],
              [
                49.896699,
                31.0000583
              ],
              [
                49.8964579,
                30.9986811
              ],
              [
                49.8961754,
                30.9970674
              ],
              [
                49.8947334,
                30.9924603
              ],
              [
                49.8930895,
                30.9884087
              ],
              [
                49.8920938,
                30.9852762
              ],
              [
                49.8910408,
                30.9817281
              ],
              [
                49.8901521,
                30.9784092
              ],
              [
                49.8893241,
                30.9760134
              ],
              [
                49.8878975,
                30.9721914
              ],
              [
                49.8872908,
                30.9706704
              ],
              [
                49.8866347,
                30.9690114
              ],
              [
                49.8865028,
                30.9685714
              ],
              [
                49.8864136,
                30.9682741
              ],
              [
                49.8863526,
                30.9675834
              ],
              [
                49.8862343,
                30.9665222
              ],
              [
                49.8862764,
                30.9655504
              ],
              [
                49.8863183,
                30.9644455
              ],
              [
                49.8864899,
                30.9653673
              ],
              [
                49.8869782,
                30.9664249
              ],
              [
                49.8872591,
                30.9667821
              ],
              [
                49.8877372,
                30.96739
              ],
              [
                49.8886491,
                30.9681242
              ],
              [
                49.8896179,
                30.9688115
              ],
              [
                49.8918649,
                30.9697691
              ],
              [
                49.894774,
                30.9707405
              ],
              [
                49.8951303,
                30.9708595
              ],
              [
                49.8990898,
                30.9725466
              ],
              [
                49.9061737,
                30.9765699
              ],
              [
                49.914173,
                30.9812795
              ],
              [
                49.9171257,
                30.9828787
              ],
              [
                49.9195481,
                30.9845275
              ],
              [
                49.9226724,
                30.9870957
              ],
              [
                49.9281769,
                30.9914723
              ],
              [
                49.9347242,
                30.9941859
              ],
              [
                49.9394119,
                30.9951493
              ],
              [
                49.9465117,
                30.9964795
              ],
              [
                49.9533472,
                30.9974599
              ],
              [
                49.9615079,
                31.0000702
              ],
              [
                49.9643708,
                31.0030458
              ],
              [
                49.9700286,
                31.0094322
              ],
              [
                49.97143,
                31.0129259
              ],
              [
                49.971397,
                31.0159952
              ],
              [
                49.9708385,
                31.0188329
              ],
              [
                49.9705635,
                31.0198539
              ],
              [
                49.9678881,
                31.0231294
              ],
              [
                49.9640355,
                31.0284276
              ],
              [
                49.9631278,
                31.0299551
              ],
              [
                49.9616205,
                31.0319893
              ],
              [
                49.9596116,
                31.0346164
              ],
              [
                49.9591027,
                31.0356305
              ],
              [
                49.9587183,
                31.0369295
              ],
              [
                49.9576118,
                31.0401995
              ],
              [
                49.9582391,
                31.0424496
              ],
              [
                49.9587258,
                31.043221
              ],
              [
                49.9598992,
                31.0445947
              ],
              [
                49.9610819,
                31.0451158
              ],
              [
                49.961962,
                31.046146
              ],
              [
                49.9630448,
                31.0467516
              ],
              [
                49.9649783,
                31.0480603
              ],
              [
                49.9658939,
                31.0488634
              ],
              [
                49.9666738,
                31.0500066
              ],
              [
                49.9666664,
                31.0506886
              ],
              [
                49.9659878,
                31.0523885
              ],
              [
                49.9647859,
                31.0536294
              ],
              [
                49.9631682,
                31.0566859
              ],
              [
                49.9623524,
                31.0588394
              ],
              [
                49.9606185,
                31.060417
              ],
              [
                49.9605733,
                31.0605056
              ],
              [
                49.9594041,
                31.0627947
              ],
              [
                49.9571307,
                31.0653911
              ],
              [
                49.9557977,
                31.0665171
              ],
              [
                49.9548584,
                31.0678738
              ],
              [
                49.9531217,
                31.0696786
              ],
              [
                49.9523193,
                31.0705816
              ],
              [
                49.9512541,
                31.0713688
              ],
              [
                49.9495135,
                31.0735146
              ],
              [
                49.9475175,
                31.0748626
              ],
              [
                49.948037,
                31.0756626
              ],
              [
                49.9486948,
                31.0758953
              ],
              [
                49.949486,
                31.0760155
              ],
              [
                49.9506746,
                31.0760252
              ],
              [
                49.9528854,
                31.0764245
              ],
              [
                49.9539702,
                31.0766204
              ],
              [
                49.956872,
                31.0769849
              ],
              [
                49.9597714,
                31.0775768
              ],
              [
                49.9613452,
                31.0786126
              ],
              [
                49.9634448,
                31.0798801
              ],
              [
                49.9655383,
                31.0817159
              ],
              [
                49.9671386,
                31.0831285
              ],
              [
                49.9682825,
                31.0844663
              ],
              [
                49.9701108,
                31.0864136
              ],
              [
                49.9711793,
                31.0875851
              ],
              [
                49.9728776,
                31.0892809
              ],
              [
                49.9741615,
                31.0905386
              ],
              [
                49.9751083,
                31.0917968
              ],
              [
                49.9754568,
                31.0929363
              ],
              [
                49.975841,
                31.0936531
              ],
              [
                49.9760461,
                31.09458
              ],
              [
                49.9770115,
                31.0957907
              ],
              [
                49.9775375,
                31.0960223
              ],
              [
                49.9785858,
                31.0968264
              ],
              [
                49.9807439,
                31.0976705
              ],
              [
                49.9822591,
                31.0992429
              ],
              [
                49.9806907,
                31.100751
              ],
              [
                49.9791954,
                31.1015918
              ],
              [
                49.9780954,
                31.102521
              ],
              [
                49.9777836,
                31.1038828
              ],
              [
                49.9779216,
                31.1045065
              ],
              [
                49.9779726,
                31.1047369
              ],
              [
                49.9793461,
                31.1060267
              ],
              [
                49.9809242,
                31.1067213
              ],
              [
                49.9837072,
                31.1093051
              ],
              [
                49.986223,
                31.1116406
              ],
              [
                49.9885354,
                31.1150946
              ],
              [
                49.9904163,
                31.12067
              ],
              [
                49.9900285,
                31.1232389
              ],
              [
                49.9899942,
                31.1256725
              ],
              [
                49.9891626,
                31.1278742
              ],
              [
                49.9878502,
                31.1307217
              ],
              [
                49.9856912,
                31.1341693
              ],
              [
                49.9806406,
                31.1431721
              ],
              [
                49.9778062,
                31.1493277
              ],
              [
                49.9756583,
                31.1542864
              ],
              [
                49.9747691,
                31.1561136
              ],
              [
                49.9735565,
                31.1586049
              ],
              [
                49.9710768,
                31.1626497
              ],
              [
                49.9678573,
                31.167796
              ],
              [
                49.9631462,
                31.1736339
              ],
              [
                49.9615067,
                31.1758131
              ],
              [
                49.9588584,
                31.1793329
              ],
              [
                49.9557381,
                31.1836992
              ],
              [
                49.9544639,
                31.1850783
              ],
              [
                49.9539642,
                31.1894816
              ],
              [
                49.953641,
                31.1933333
              ],
              [
                49.9536081,
                31.1937247
              ],
              [
                49.9535713,
                31.1941632
              ],
              [
                49.953125,
                31.1983843
              ],
              [
                49.9532775,
                31.2042545
              ],
              [
                49.9534682,
                31.2080589
              ],
              [
                49.9541243,
                31.2101664
              ],
              [
                49.9527319,
                31.2101258
              ],
              [
                49.9503733,
                31.2103497
              ],
              [
                49.9487723,
                31.2105017
              ],
              [
                49.9456138,
                31.210512
              ],
              [
                49.942192,
                31.2108425
              ],
              [
                49.939354,
                31.2108507
              ],
              [
                49.9362488,
                31.2108567
              ],
              [
                49.9265596,
                31.2113423
              ],
              [
                49.9198686,
                31.211681
              ],
              [
                49.9170342,
                31.2117812
              ],
              [
                49.9153212,
                31.2121503
              ],
              [
                49.9139327,
                31.2126596
              ],
              [
                49.9121172,
                31.2134427
              ],
              [
                49.910038,
                31.2145032
              ],
              [
                49.9080085,
                31.215289
              ],
              [
                49.9064025,
                31.2157062
              ],
              [
                49.9043158,
                31.2161237
              ],
              [
                49.9029808,
                31.2162183
              ],
              [
                49.9000357,
                31.2164571
              ],
              [
                49.8960189,
                31.2164678
              ],
              [
                49.8921662,
                31.2166625
              ],
              [
                49.8840257,
                31.2167274
              ],
              [
                49.8797417,
                31.2165571
              ],
              [
                49.8756712,
                31.216384
              ],
              [
                49.8715439,
                31.2161652
              ],
              [
                49.8680113,
                31.2161747
              ],
              [
                49.8662453,
                31.2162697
              ],
              [
                49.8659749,
                31.2162718
              ],
              [
                49.8659441,
                31.2166575
              ],
              [
                49.8656235,
                31.2206737
              ],
              [
                49.8652039,
                31.222373
              ],
              [
                49.8648161,
                31.2243065
              ],
              [
                49.8644218,
                31.2262726
              ],
              [
                49.8637963,
                31.2297135
              ],
              [
                49.8628044,
                31.2343489
              ],
              [
                49.8622778,
                31.2362298
              ],
              [
                49.861805,
                31.2382037
              ],
              [
                49.8614884,
                31.239349
              ],
              [
                49.8609084,
                31.2411415
              ],
              [
                49.8604356,
                31.2430206
              ],
              [
                49.8596422,
                31.244491
              ],
              [
                49.8587953,
                31.2471066
              ],
              [
                49.8585441,
                31.250032
              ],
              [
                49.8569146,
                31.2542963
              ],
              [
                49.8541144,
                31.2575959
              ],
              [
                49.8519631,
                31.2604367
              ],
              [
                49.8501891,
                31.2623606
              ],
              [
                49.8453253,
                31.2666167
              ],
              [
                49.8443871,
                31.2674376
              ],
              [
                49.8407861,
                31.2709598
              ],
              [
                49.8382605,
                31.2736143
              ],
              [
                49.8372382,
                31.2744847
              ],
              [
                49.8363761,
                31.2757219
              ],
              [
                49.8349799,
                31.2769565
              ],
              [
                49.834282,
                31.2777351
              ],
              [
                49.8330994,
                31.278419
              ],
              [
                49.8316001,
                31.2790099
              ],
              [
                49.8297767,
                31.2796902
              ],
              [
                49.8274727,
                31.2803662
              ],
              [
                49.8260765,
                31.2809579
              ],
              [
                49.8240927,
                31.2815916
              ],
              [
                49.8228036,
                31.2822745
              ],
              [
                49.8211403,
                31.2831411
              ],
              [
                49.8192635,
                31.2843734
              ],
              [
                49.8165244,
                31.2861526
              ],
              [
                49.8136255,
                31.2883904
              ],
              [
                49.8102378,
                31.2911806
              ],
              [
                49.8083039,
                31.2927325
              ],
              [
                49.807068,
                31.2939683
              ],
              [
                49.8058852,
                31.2952046
              ],
              [
                49.8048628,
                31.2963476
              ],
              [
                49.8035736,
                31.2981355
              ],
              [
                49.80217,
                31.3005223
              ],
              [
                49.8016852,
                31.3012079
              ],
              [
                49.8014679,
                31.3018983
              ],
              [
                49.8014145,
                31.3023106
              ],
              [
                49.8011932,
                31.3041963
              ],
              [
                49.8010214,
                31.3060594
              ],
              [
                49.8009683,
                31.3066346
              ],
              [
                49.8005866,
                31.3087941
              ],
              [
                49.7990151,
                31.3133422
              ],
              [
                49.7973762,
                31.3192603
              ],
              [
                49.7971582,
                31.3200473
              ],
              [
                49.7970319,
                31.3205032
              ],
              [
                49.7966233,
                31.3219785
              ],
              [
                49.7959631,
                31.3245837
              ],
              [
                49.7949244,
                31.3286816
              ],
              [
                49.7947235,
                31.3285466
              ],
              [
                49.7929063,
                31.3295495
              ],
              [
                49.7872085,
                31.3326936
              ],
              [
                49.7828635,
                31.3346034
              ],
              [
                49.7808762,
                31.335604
              ],
              [
                49.7761003,
                31.3382448
              ],
              [
                49.7729835,
                31.3411268
              ],
              [
                49.7677116,
                31.3460225
              ],
              [
                49.7611046,
                31.3513223
              ],
              [
                49.7570191,
                31.3549794
              ],
              [
                49.7546539,
                31.3571759
              ],
              [
                49.7614442,
                31.359603
              ],
              [
                49.7650324,
                31.3609845
              ],
              [
                49.7849771,
                31.3686604
              ],
              [
                49.7869035,
                31.3694545
              ],
              [
                49.7813096,
                31.3772633
              ],
              [
                49.7806014,
                31.3782519
              ],
              [
                49.7734376,
                31.3879654
              ],
              [
                49.7695975,
                31.3932823
              ],
              [
                49.7656249,
                31.3987818
              ],
              [
                49.7594873,
                31.4066121
              ],
              [
                49.7499415,
                31.4167544
              ],
              [
                49.7486459,
                31.4175717
              ],
              [
                49.7443733,
                31.4213935
              ],
              [
                49.7374838,
                31.4282093
              ],
              [
                49.7354583,
                31.4309725
              ],
              [
                49.7320976,
                31.4352561
              ],
              [
                49.7283059,
                31.4397248
              ],
              [
                49.7273444,
                31.4410143
              ],
              [
                49.725792,
                31.4426701
              ],
              [
                49.7244606,
                31.4445604
              ],
              [
                49.722267,
                31.4470488
              ],
              [
                49.720131,
                31.4493055
              ],
              [
                49.7187807,
                31.4507061
              ],
              [
                49.7185783,
                31.4509161
              ],
              [
                49.7165483,
                31.4523527
              ],
              [
                49.7153109,
                31.4533823
              ],
              [
                49.7111891,
                31.4558376
              ],
              [
                49.7067413,
                31.4585962
              ],
              [
                49.7028273,
                31.4607579
              ],
              [
                49.7000426,
                31.4622746
              ],
              [
                49.6943921,
                31.4651065
              ],
              [
                49.6930694,
                31.4657693
              ],
              [
                49.6916771,
                31.4664114
              ],
              [
                49.690933,
                31.4669493
              ],
              [
                49.6902659,
                31.4676477
              ],
              [
                49.6895867,
                31.4687131
              ],
              [
                49.6899568,
                31.4669599
              ],
              [
                49.6907007,
                31.463828
              ],
              [
                49.6914445,
                31.4605992
              ],
              [
                49.6920816,
                31.4579714
              ],
              [
                49.6924516,
                31.4562656
              ],
              [
                49.693676,
                31.4529943
              ],
              [
                49.6959686,
                31.4474649
              ],
              [
                49.6966058,
                31.4457596
              ],
              [
                49.6971931,
                31.4441462
              ],
              [
                49.6977235,
                31.4425796
              ],
              [
                49.6981507,
                31.4413344
              ],
              [
                49.6989478,
                31.4398134
              ],
              [
                49.7000696,
                31.4381084
              ],
              [
                49.7014045,
                31.4358981
              ],
              [
                49.7025793,
                31.4340088
              ],
              [
                49.7035409,
                31.4323969
              ],
              [
                49.7043952,
                31.431244
              ],
              [
                49.7050896,
                31.4300466
              ],
              [
                49.7054597,
                31.4291708
              ],
              [
                49.7055129,
                31.4283864
              ],
              [
                49.7054023,
                31.4274177
              ],
              [
                49.7051316,
                31.4266346
              ],
              [
                49.7048033,
                31.425666
              ],
              [
                49.7045327,
                31.4249731
              ],
              [
                49.7044792,
                31.4243253
              ],
              [
                49.7045287,
                31.4227583
              ],
              [
                49.7045939,
                31.4222329
              ],
              [
                49.7047349,
                31.4210982
              ],
              [
                49.7049981,
                31.4194386
              ],
              [
                49.7052614,
                31.4181489
              ],
              [
                49.7058984,
                31.4161661
              ],
              [
                49.706379,
                31.4149214
              ],
              [
                49.7078745,
                31.4138156
              ],
              [
                49.7086221,
                31.4128037
              ],
              [
                49.7093695,
                31.4121143
              ],
              [
                49.7099572,
                31.4109158
              ],
              [
                49.7107008,
                31.4087491
              ],
              [
                49.7111778,
                31.4075022
              ],
              [
                49.7118149,
                31.406029
              ],
              [
                49.7118646,
                31.4051071
              ],
              [
                49.7118643,
                31.4040921
              ],
              [
                49.7116469,
                31.4032622
              ],
              [
                49.7112122,
                31.4024775
              ],
              [
                49.7106742,
                31.4012293
              ],
              [
                49.7102928,
                31.4000301
              ],
              [
                49.7101288,
                31.3987858
              ],
              [
                49.7099647,
                31.3975865
              ],
              [
                49.7099608,
                31.3965715
              ],
              [
                49.7095793,
                31.3955099
              ],
              [
                49.7094687,
                31.3940789
              ],
              [
                49.709194,
                31.3924657
              ],
              [
                49.7091904,
                31.3912658
              ],
              [
                49.7095604,
                31.3894224
              ],
              [
                49.7065543,
                31.3911328
              ],
              [
                49.7044883,
                31.3927304
              ],
              [
                49.7011627,
                31.3944502
              ],
              [
                49.7000529,
                31.3951133
              ],
              [
                49.6984603,
                31.3965808
              ],
              [
                49.6963904,
                31.3984481
              ],
              [
                49.694807,
                31.3992412
              ],
              [
                49.6927444,
                31.400569
              ],
              [
                49.6908539,
                31.4008194
              ],
              [
                49.6884045,
                31.4002717
              ],
              [
                49.6855759,
                31.4001416
              ],
              [
                49.6835755,
                31.3998176
              ],
              [
                49.6819304,
                31.3993961
              ],
              [
                49.680413,
                31.3982677
              ],
              [
                49.6797183,
                31.3973502
              ],
              [
                49.6789056,
                31.3964314
              ],
              [
                49.677036,
                31.3951982
              ],
              [
                49.6765729,
                31.3945865
              ],
              [
                49.6764678,
                31.393675
              ],
              [
                49.6756538,
                31.3928573
              ],
              [
                49.6742488,
                31.3921347
              ],
              [
                49.6728339,
                31.39212
              ],
              [
                49.6724916,
                31.3913072
              ],
              [
                49.6718112,
                31.3893782
              ],
              [
                49.6708808,
                31.3884582
              ],
              [
                49.6701862,
                31.3875405
              ],
              [
                49.6691422,
                31.3863158
              ],
              [
                49.6691579,
                31.3852032
              ],
              [
                49.6694137,
                31.3837897
              ],
              [
                49.6682447,
                31.3830695
              ],
              [
                49.6677645,
                31.3836714
              ],
              [
                49.6658768,
                31.3837529
              ],
              [
                49.6650572,
                31.3833398
              ],
              [
                49.6643599,
                31.3826244
              ],
              [
                49.6629537,
                31.3820028
              ],
              [
                49.6622621,
                31.3808829
              ],
              [
                49.6618071,
                31.3805229
              ],
              [
                49.6610961,
                31.3799603
              ],
              [
                49.6599215,
                31.3796446
              ],
              [
                49.6592285,
                31.3786257
              ],
              [
                49.6584234,
                31.3772011
              ],
              [
                49.6581991,
                31.3763895
              ],
              [
                49.6577391,
                31.3755754
              ],
              [
                49.6572497,
                31.3747975
              ],
              [
                49.6571626,
                31.374659
              ],
              [
                49.6566983,
                31.3741483
              ],
              [
                49.6556445,
                31.3736315
              ],
              [
                49.6545865,
                31.3734181
              ],
              [
                49.6527047,
                31.3730949
              ],
              [
                49.6507137,
                31.3721635
              ],
              [
                49.6497909,
                31.3707376
              ],
              [
                49.6492015,
                31.3707314
              ],
              [
                49.6480401,
                31.3695053
              ],
              [
                49.6441762,
                31.3676437
              ],
              [
                49.6431502,
                31.3652051
              ],
              [
                49.6411755,
                31.363161
              ],
              [
                49.6385112,
                31.3598957
              ],
              [
                49.6365294,
                31.3583573
              ],
              [
                49.6351308,
                31.3569245
              ],
              [
                49.6345024,
                31.3580913
              ],
              [
                49.6319351,
                31.3631138
              ],
              [
                49.6307068,
                31.3652794
              ],
              [
                49.6297454,
                31.3667554
              ],
              [
                49.6285707,
                31.3683193
              ],
              [
                49.6270713,
                31.3701617
              ],
              [
                49.6265908,
                31.3708061
              ],
              [
                49.6263237,
                31.3716829
              ],
              [
                49.626217,
                31.3725591
              ],
              [
                49.6259537,
                31.374956
              ],
              [
                49.6257935,
                31.3767518
              ],
              [
                49.6254729,
                31.3795653
              ],
              [
                49.6253168,
                31.3817784
              ],
              [
                49.6253165,
                31.3827482
              ],
              [
                49.6254274,
                31.3844522
              ],
              [
                49.6254271,
                31.3852371
              ],
              [
                49.6251601,
                31.3866664
              ],
              [
                49.6251069,
                31.3877258
              ],
              [
                49.625107,
                31.3885107
              ],
              [
                49.6251601,
                31.3889714
              ],
              [
                49.6253242,
                31.3896182
              ],
              [
                49.6253243,
                31.3900833
              ],
              [
                49.6253243,
                31.3901707
              ],
              [
                49.6250573,
                31.3905851
              ],
              [
                49.6242524,
                31.3907231
              ],
              [
                49.6233941,
                31.3908108
              ],
              [
                49.6219481,
                31.3904886
              ],
              [
                49.6206627,
                31.3900237
              ],
              [
                49.6200646,
                31.3898761
              ],
              [
                49.6193501,
                31.3896998
              ],
              [
                49.6189303,
                31.3895962
              ],
              [
                49.6180345,
                31.3893752
              ],
              [
                49.6147117,
                31.3885409
              ],
              [
                49.6114425,
                31.3879349
              ],
              [
                49.6085511,
                31.387333
              ],
              [
                49.6061402,
                31.3869144
              ],
              [
                49.6044769,
                31.3865895
              ],
              [
                49.602871,
                31.3864029
              ],
              [
                49.6007805,
                31.3861207
              ],
              [
                49.5985297,
                31.3857488
              ],
              [
                49.5949935,
                31.3850516
              ],
              [
                49.5915642,
                31.3843103
              ],
              [
                49.5886192,
                31.3837975
              ],
              [
                49.5866357,
                31.3838884
              ],
              [
                49.5842247,
                31.3837919
              ],
              [
                49.5816003,
                31.3839275
              ],
              [
                49.5790254,
                31.384199
              ],
              [
                49.5768622,
                31.3845948
              ],
              [
                49.5762396,
                31.3847087
              ],
              [
                49.576027,
                31.3847476
              ],
              [
                49.5720595,
                31.3852944
              ],
              [
                49.5696486,
                31.3858449
              ],
              [
                49.5667573,
                31.3863471
              ],
              [
                49.5633278,
                31.3867102
              ],
              [
                49.5605393,
                31.3872134
              ],
              [
                49.5581818,
                31.3874869
              ],
              [
                49.5550193,
                31.387988
              ],
              [
                49.5529288,
                31.3880795
              ],
              [
                49.5512161,
                31.388306
              ],
              [
                49.5492859,
                31.3884871
              ],
              [
                49.5476226,
                31.388854
              ],
              [
                49.5453187,
                31.3895879
              ],
              [
                49.5433349,
                31.3906434
              ],
              [
                49.5411911,
                31.3918392
              ],
              [
                49.5394951,
                31.3931678
              ],
              [
                49.5386657,
                31.3938176
              ],
              [
                49.5367354,
                31.3952436
              ],
              [
                49.5351256,
                31.3963483
              ],
              [
                49.5340537,
                31.3969924
              ],
              [
                49.5309943,
                31.3979542
              ],
              [
                49.5277787,
                31.3986864
              ],
              [
                49.524563,
                31.3992358
              ],
              [
                49.5218277,
                31.3995561
              ],
              [
                49.5193061,
                31.3999194
              ],
              [
                49.5161439,
                31.4001896
              ],
              [
                49.5138398,
                31.4005102
              ],
              [
                49.5112113,
                31.4008744
              ],
              [
                49.5100398,
                31.4011249
              ],
              [
                49.509281,
                31.4012872
              ],
              [
                49.5078851,
                31.4015619
              ],
              [
                49.5067595,
                31.4019277
              ],
              [
                49.5066453,
                31.4037238
              ],
              [
                49.5066413,
                31.4063986
              ],
              [
                49.5060959,
                31.4096241
              ],
              [
                49.505867,
                31.4146485
              ],
              [
                49.5058634,
                31.4160027
              ],
              [
                49.5058557,
                31.4188884
              ],
              [
                49.5057984,
                31.4207776
              ],
              [
                49.5052565,
                31.4221132
              ],
              [
                49.5045587,
                31.4228944
              ],
              [
                49.5035361,
                31.4238162
              ],
              [
                49.5016595,
                31.4245047
              ],
              [
                49.5001873,
                31.4246927
              ],
              [
                49.4973372,
                31.4255434
              ],
              [
                49.4923248,
                31.4267227
              ],
              [
                49.4882165,
                31.4274456
              ],
              [
                49.4834138,
                31.4285773
              ],
              [
                49.4792556,
                31.4293896
              ],
              [
                49.4738123,
                31.430475
              ],
              [
                49.4707185,
                31.4312455
              ],
              [
                49.4678918,
                31.4315591
              ],
              [
                49.4652748,
                31.4317803
              ],
              [
                49.4630889,
                31.4320496
              ],
              [
                49.459675,
                31.432728
              ],
              [
                49.4573249,
                31.4335454
              ],
              [
                49.4549255,
                31.4354651
              ],
              [
                49.4533766,
                31.4367454
              ],
              [
                49.4517249,
                31.4375193
              ],
              [
                49.4499627,
                31.437789
              ],
              [
                49.4479903,
                31.4377831
              ],
              [
                49.4452134,
                31.437454
              ],
              [
                49.4410514,
                31.4367088
              ],
              [
                49.4385451,
                31.4359679
              ],
              [
                49.4367827,
                31.4355968
              ],
              [
                49.4332619,
                31.4339819
              ],
              [
                49.4300614,
                31.432276
              ],
              [
                49.4148102,
                31.4209563
              ],
              [
                49.4131586,
                31.4195736
              ],
              [
                49.4126244,
                31.418931
              ],
              [
                49.4118231,
                31.4174168
              ],
              [
                49.4101181,
                31.414527
              ],
              [
                49.4087334,
                31.4124575
              ],
              [
                49.4074554,
                31.4108043
              ],
              [
                49.4054831,
                31.4087839
              ],
              [
                49.4023896,
                31.4067585
              ],
              [
                49.399353,
                31.405514
              ],
              [
                49.3962592,
                31.4045439
              ],
              [
                49.3931657,
                31.4038467
              ],
              [
                49.3907129,
                31.4032431
              ],
              [
                49.3877296,
                31.4021839
              ],
              [
                49.3811188,
                31.3974909
              ],
              [
                49.3755799,
                31.3931245
              ],
              [
                49.3708917,
                31.3894454
              ],
              [
                49.359066,
                31.3805758
              ],
              [
                49.3564568,
                31.3789659
              ],
              [
                49.3547515,
                31.3782269
              ],
              [
                49.3499564,
                31.3764288
              ],
              [
                49.3483583,
                31.3754632
              ],
              [
                49.3465139,
                31.3729296
              ],
              [
                49.3349704,
                31.3643636
              ],
              [
                49.3305378,
                31.3625996
              ],
              [
                49.324976,
                31.3650768
              ],
              [
                49.3173215,
                31.368047
              ],
              [
                49.3064088,
                31.372109
              ],
              [
                49.2966193,
                31.3623506
              ],
              [
                49.2831782,
                31.3496598
              ],
              [
                49.2739697,
                31.3389781
              ],
              [
                49.2716216,
                31.336264
              ],
              [
                49.2683849,
                31.330206
              ],
              [
                49.2704603,
                31.3169885
              ],
              [
                49.2754645,
                31.3133643
              ],
              [
                49.2849845,
                31.3054949
              ],
              [
                49.2842617,
                31.3016161
              ],
              [
                49.2993242,
                31.29663
              ],
              [
                49.3013114,
                31.292332
              ],
              [
                49.3014182,
                31.2909577
              ],
              [
                49.3013155,
                31.2895829
              ],
              [
                49.3012657,
                31.2884388
              ],
              [
                49.3008422,
                31.2875244
              ],
              [
                49.3002052,
                31.2863319
              ],
              [
                49.2992515,
                31.2848196
              ],
              [
                49.2976035,
                31.2832574
              ],
              [
                49.296915,
                31.2827233
              ],
              [
                49.2960091,
                31.2820207
              ],
              [
                49.2945749,
                31.2805515
              ],
              [
                49.2926101,
                31.2780311
              ],
              [
                49.2905428,
                31.2748215
              ],
              [
                49.2887916,
                31.2722114
              ],
              [
                49.2861937,
                31.2683135
              ],
              [
                49.2843895,
                31.2661605
              ],
              [
                49.2835961,
                31.2647404
              ],
              [
                49.2830658,
                31.2635944
              ],
              [
                49.2826957,
                31.2621754
              ],
              [
                49.2824365,
                31.2603429
              ],
              [
                49.2823333,
                31.2578698
              ],
              [
                49.2824478,
                31.2546644
              ],
              [
                49.2823487,
                31.2519635
              ],
              [
                49.282388,
                31.2518417
              ],
              [
                49.2829519,
                31.250093
              ],
              [
                49.2828436,
                31.2498976
              ],
              [
                49.2802019,
                31.2451728
              ],
              [
                49.2791747,
                31.2433354
              ],
              [
                49.2768821,
                31.239892
              ],
              [
                49.2759628,
                31.2385112
              ],
              [
                49.2730865,
                31.2347401
              ],
              [
                49.2727715,
                31.2342351
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555097,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شادگان",
          "name:en": "Shadegan County",
          "name:uk": "Шадеґан бахш",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279136",
          "wikipedia": "en:Shadegan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.3559742,
                30.9557125
              ],
              [
                48.3526325,
                30.9491997
              ],
              [
                48.3481622,
                30.9416481
              ],
              [
                48.3467827,
                30.9345215
              ],
              [
                48.3469505,
                30.9296707
              ],
              [
                48.3473358,
                30.925415
              ],
              [
                48.348835,
                30.9206117
              ],
              [
                48.3507043,
                30.9166344
              ],
              [
                48.3537445,
                30.9130734
              ],
              [
                48.356781,
                30.9101954
              ],
              [
                48.3588599,
                30.9087836
              ],
              [
                48.3599243,
                30.9083747
              ],
              [
                48.3609352,
                30.9081947
              ],
              [
                48.362423,
                30.9083355
              ],
              [
                48.363594,
                30.9086142
              ],
              [
                48.3637665,
                30.9086856
              ],
              [
                48.3648147,
                30.9091193
              ],
              [
                48.3657722,
                30.9096236
              ],
              [
                48.3663559,
                30.9101744
              ],
              [
                48.3676262,
                30.9119634
              ],
              [
                48.3679445,
                30.9124869
              ],
              [
                48.3698006,
                30.9155386
              ],
              [
                48.3716546,
                30.9192064
              ],
              [
                48.3738822,
                30.9223699
              ],
              [
                48.3755265,
                30.9246174
              ],
              [
                48.3768539,
                30.9258101
              ],
              [
                48.3787651,
                30.9264103
              ],
              [
                48.3813705,
                30.9266457
              ],
              [
                48.3829154,
                30.9266026
              ],
              [
                48.3860015,
                30.9258804
              ],
              [
                48.3877563,
                30.925244
              ],
              [
                48.389141,
                30.9244242
              ],
              [
                48.39159,
                30.9226902
              ],
              [
                48.3938789,
                30.9208176
              ],
              [
                48.3955346,
                30.9185805
              ],
              [
                48.3965492,
                30.9158817
              ],
              [
                48.3971404,
                30.9119929
              ],
              [
                48.3974114,
                30.9093851
              ],
              [
                48.3973122,
                30.9055411
              ],
              [
                48.3967857,
                30.9026106
              ],
              [
                48.3959427,
                30.89826
              ],
              [
                48.3950424,
                30.8950086
              ],
              [
                48.3950463,
                30.8926277
              ],
              [
                48.3952102,
                30.8913458
              ],
              [
                48.3958473,
                30.8905695
              ],
              [
                48.3969117,
                30.8902504
              ],
              [
                48.3982429,
                30.8900269
              ],
              [
                48.3999444,
                30.8901694
              ],
              [
                48.4030762,
                30.891504
              ],
              [
                48.4058379,
                30.8926552
              ],
              [
                48.410038,
                30.8944959
              ],
              [
                48.4126397,
                30.8950057
              ],
              [
                48.4159889,
                30.8957017
              ],
              [
                48.4193916,
                30.8959839
              ],
              [
                48.422264,
                30.8959014
              ],
              [
                48.4250259,
                30.8957715
              ],
              [
                48.4290695,
                30.8951846
              ],
              [
                48.4330025,
                30.894557
              ],
              [
                48.4378968,
                30.8939257
              ],
              [
                48.4412994,
                30.8930664
              ],
              [
                48.4445953,
                30.8917471
              ],
              [
                48.4473075,
                30.8906102
              ],
              [
                48.4494361,
                30.8893805
              ],
              [
                48.451088,
                30.8879632
              ],
              [
                48.4526825,
                30.886414
              ],
              [
                48.4540138,
                30.8841742
              ],
              [
                48.4545479,
                30.8826627
              ],
              [
                48.4552421,
                30.8800586
              ],
              [
                48.4555092,
                30.8780909
              ],
              [
                48.4554557,
                30.8764416
              ],
              [
                48.4551391,
                30.8747488
              ],
              [
                48.4541855,
                30.8735553
              ],
              [
                48.4525909,
                30.872498
              ],
              [
                48.4505196,
                30.8718529
              ],
              [
                48.4481277,
                30.8717088
              ],
              [
                48.4456825,
                30.8721137
              ],
              [
                48.4456323,
                30.8721267
              ],
              [
                48.4439277,
                30.8725683
              ],
              [
                48.4419594,
                30.8731112
              ],
              [
                48.4391441,
                30.8733328
              ],
              [
                48.4364319,
                30.8734189
              ],
              [
                48.4340401,
                30.873412
              ],
              [
                48.4317551,
                30.8730848
              ],
              [
                48.430214,
                30.8725785
              ],
              [
                48.4289932,
                30.871844
              ],
              [
                48.4283561,
                30.8712
              ],
              [
                48.4279861,
                30.8703313
              ],
              [
                48.4276161,
                30.8691853
              ],
              [
                48.4271927,
                30.8675827
              ],
              [
                48.4260253,
                30.8650161
              ],
              [
                48.4247017,
                30.8632288
              ],
              [
                48.4213562,
                30.8596019
              ],
              [
                48.4173775,
                30.8555181
              ],
              [
                48.4146195,
                30.8518509
              ],
              [
                48.4126053,
                30.8490982
              ],
              [
                48.4113884,
                30.8457097
              ],
              [
                48.4109687,
                30.8432797
              ],
              [
                48.4107055,
                30.8411753
              ],
              [
                48.4108123,
                30.8396194
              ],
              [
                48.4110832,
                30.8381547
              ],
              [
                48.4120942,
                30.8370588
              ],
              [
                48.4135285,
                30.8364223
              ],
              [
                48.4149628,
                30.8361511
              ],
              [
                48.4152595,
                30.8361805
              ],
              [
                48.4168739,
                30.8363403
              ],
              [
                48.4187355,
                30.8366638
              ],
              [
                48.4219207,
                30.8376788
              ],
              [
                48.426857,
                30.8396597
              ],
              [
                48.4299889,
                30.8412236
              ],
              [
                48.4328576,
                30.8428792
              ],
              [
                48.4380608,
                30.8464186
              ],
              [
                48.4429435,
                30.8496335
              ],
              [
                48.4470864,
                30.8528021
              ],
              [
                48.4497948,
                30.8544113
              ],
              [
                48.4530335,
                30.8560219
              ],
              [
                48.4550514,
                30.8565779
              ],
              [
                48.457283,
                30.8566286
              ],
              [
                48.4593582,
                30.8562229
              ],
              [
                48.4616433,
                30.8550366
              ],
              [
                48.463398,
                30.8541263
              ],
              [
                48.4655227,
                30.8529413
              ],
              [
                48.4676514,
                30.8516188
              ],
              [
                48.4692993,
                30.8502959
              ],
              [
                48.4704171,
                30.8488341
              ],
              [
                48.471428,
                30.8472349
              ],
              [
                48.4722786,
                30.8454995
              ],
              [
                48.4731826,
                30.8438982
              ],
              [
                48.4740333,
                30.8415653
              ],
              [
                48.4744606,
                30.840011
              ],
              [
                48.4744606,
                30.8379975
              ],
              [
                48.4743041,
                30.8365784
              ],
              [
                48.4736671,
                30.8355243
              ],
              [
                48.4729767,
                30.8346968
              ],
              [
                48.4724795,
                30.8344818
              ],
              [
                48.4713821,
                30.8340073
              ],
              [
                48.4683037,
                30.8331759
              ],
              [
                48.4646377,
                30.8323872
              ],
              [
                48.4621429,
                30.8318332
              ],
              [
                48.4599114,
                30.8312776
              ],
              [
                48.4561957,
                30.8301246
              ],
              [
                48.4540177,
                30.8290198
              ],
              [
                48.4509391,
                30.8270426
              ],
              [
                48.4482307,
                30.824978
              ],
              [
                48.4462128,
                30.8237364
              ],
              [
                48.4439316,
                30.8218988
              ],
              [
                48.4410668,
                30.8197859
              ],
              [
                48.4390526,
                30.817356
              ],
              [
                48.4371948,
                30.8151073
              ],
              [
                48.4354973,
                30.8124491
              ],
              [
                48.4344406,
                30.8097923
              ],
              [
                48.4339141,
                30.8067244
              ],
              [
                48.4338673,
                30.8061482
              ],
              [
                48.4335976,
                30.8028308
              ],
              [
                48.4340821,
                30.798394
              ],
              [
                48.4345093,
                30.7967474
              ],
              [
                48.4347763,
                30.7959681
              ],
              [
                48.4354667,
                30.7955127
              ],
              [
                48.4364242,
                30.7951055
              ],
              [
                48.4384956,
                30.7946053
              ],
              [
                48.4413071,
                30.7944287
              ],
              [
                48.4436454,
                30.7944365
              ],
              [
                48.4459305,
                30.7939855
              ],
              [
                48.4473114,
                30.7932551
              ],
              [
                48.4486923,
                30.7922519
              ],
              [
                48.4493294,
                30.7912475
              ],
              [
                48.4495431,
                30.7903317
              ],
              [
                48.4493866,
                30.7892779
              ],
              [
                48.4488328,
                30.7887613
              ],
              [
                48.4487496,
                30.7886836
              ],
              [
                48.4476891,
                30.7882681
              ],
              [
                48.4466247,
                30.7882652
              ],
              [
                48.4449807,
                30.7886274
              ],
              [
                48.4430122,
                30.789035
              ],
              [
                48.4412078,
                30.7893489
              ],
              [
                48.4390334,
                30.7892541
              ],
              [
                48.4368554,
                30.7887443
              ],
              [
                48.4351577,
                30.7881424
              ],
              [
                48.4337769,
                30.7872718
              ],
              [
                48.4326631,
                30.7861224
              ],
              [
                48.4309158,
                30.7846086
              ],
              [
                48.4299622,
                30.7829594
              ],
              [
                48.4281616,
                30.779156
              ],
              [
                48.427208,
                30.7768169
              ],
              [
                48.4266972,
                30.7747217
              ],
              [
                48.426628,
                30.7744378
              ],
              [
                48.4264183,
                30.7724224
              ],
              [
                48.4266891,
                30.7692643
              ],
              [
                48.4270096,
                30.7672526
              ],
              [
                48.4276505,
                30.7649654
              ],
              [
                48.4280777,
                30.7629987
              ],
              [
                48.4287185,
                30.7603913
              ],
              [
                48.4287186,
                30.759418
              ],
              [
                48.4287186,
                30.7588355
              ],
              [
                48.428669,
                30.7568661
              ],
              [
                48.4282989,
                30.7550797
              ],
              [
                48.4278259,
                30.7536137
              ],
              [
                48.4271354,
                30.7521028
              ],
              [
                48.4260254,
                30.7501327
              ],
              [
                48.4246761,
                30.7493797
              ],
              [
                48.423298,
                30.7486106
              ],
              [
                48.4203224,
                30.7467792
              ],
              [
                48.4178237,
                30.7454036
              ],
              [
                48.4152718,
                30.7435692
              ],
              [
                48.4122342,
                30.7416431
              ],
              [
                48.4116592,
                30.7412785
              ],
              [
                48.4062347,
                30.7375669
              ],
              [
                48.4030457,
                30.7350928
              ],
              [
                48.401081,
                30.7336712
              ],
              [
                48.397255,
                30.7310128
              ],
              [
                48.395237,
                30.7296374
              ],
              [
                48.3921547,
                30.7273929
              ],
              [
                48.3890724,
                30.7248732
              ],
              [
                48.3856163,
                30.7220775
              ],
              [
                48.3822709,
                30.7191893
              ],
              [
                48.3780707,
                30.7157066
              ],
              [
                48.3743514,
                30.7124995
              ],
              [
                48.366066,
                30.7052133
              ],
              [
                48.3623505,
                30.7023712
              ],
              [
                48.3586311,
                30.6990262
              ],
              [
                48.3550721,
                30.6959549
              ],
              [
                48.3527908,
                30.69394
              ],
              [
                48.3507196,
                30.6922427
              ],
              [
                48.347641,
                30.6899995
              ],
              [
                48.3446693,
                30.6874337
              ],
              [
                48.3418006,
                30.6850504
              ],
              [
                48.3388824,
                30.6824382
              ],
              [
                48.3356971,
                30.6795071
              ],
              [
                48.3336792,
                30.6771681
              ],
              [
                48.331768,
                30.6752439
              ],
              [
                48.3298606,
                30.6729522
              ],
              [
                48.3278962,
                30.6703865
              ],
              [
                48.3265152,
                30.6684618
              ],
              [
                48.325348,
                30.6666295
              ],
              [
                48.3237534,
                30.6634693
              ],
              [
                48.3229561,
                30.6611778
              ],
              [
                48.3226891,
                30.6588432
              ],
              [
                48.3225822,
                30.6568253
              ],
              [
                48.3227387,
                30.6548105
              ],
              [
                48.322891,
                30.6540394
              ],
              [
                48.3233185,
                30.6518755
              ],
              [
                48.3244285,
                30.6488996
              ],
              [
                48.3260688,
                30.6456933
              ],
              [
                48.3280258,
                30.6426243
              ],
              [
                48.3304062,
                30.6393249
              ],
              [
                48.3331604,
                30.6367141
              ],
              [
                48.334484,
                30.6354312
              ],
              [
                48.3372383,
                30.6335531
              ],
              [
                48.3401489,
                30.6317188
              ],
              [
                48.3426896,
                30.6300706
              ],
              [
                48.3446502,
                30.6286496
              ],
              [
                48.3455467,
                30.6274594
              ],
              [
                48.3458633,
                30.6268638
              ],
              [
                48.3459702,
                30.6262685
              ],
              [
                48.3456002,
                30.6257649
              ],
              [
                48.3453332,
                30.6252612
              ],
              [
                48.3447495,
                30.625123
              ],
              [
                48.3440629,
                30.6248474
              ],
              [
                48.3433189,
                30.624618
              ],
              [
                48.343122,
                30.6245999
              ],
              [
                48.3418351,
                30.6244817
              ],
              [
                48.3403511,
                30.6239327
              ],
              [
                48.3378067,
                30.623105
              ],
              [
                48.335266,
                30.6224193
              ],
              [
                48.3325615,
                30.6214552
              ],
              [
                48.3301773,
                30.6201751
              ],
              [
                48.3281631,
                30.6180661
              ],
              [
                48.3269423,
                30.6165551
              ],
              [
                48.3257751,
                30.6146755
              ],
              [
                48.3250847,
                30.6127515
              ],
              [
                48.324871,
                30.6095454
              ],
              [
                48.3252906,
                30.6083996
              ],
              [
                48.3257675,
                30.6076653
              ],
              [
                48.3264541,
                30.6070706
              ],
              [
                48.3268225,
                30.6068166
              ],
              [
                48.3269843,
                30.606705
              ],
              [
                48.3286285,
                30.606705
              ],
              [
                48.3305321,
                30.6069786
              ],
              [
                48.3322296,
                30.6073922
              ],
              [
                48.3342971,
                30.6078946
              ],
              [
                48.3360443,
                30.6084918
              ],
              [
                48.3375816,
                30.609087
              ],
              [
                48.339119,
                30.6098648
              ],
              [
                48.3400727,
                30.6104165
              ],
              [
                48.3419265,
                30.6108738
              ],
              [
                48.34309,
                30.6111952
              ],
              [
                48.3449973,
                30.6115611
              ],
              [
                48.3469582,
                30.6116079
              ],
              [
                48.3482819,
                30.6117927
              ],
              [
                48.3500824,
                30.611746
              ],
              [
                48.3514061,
                30.6115633
              ],
              [
                48.3527832,
                30.6111968
              ],
              [
                48.3541603,
                30.6103703
              ],
              [
                48.3571204,
                30.6073933
              ],
              [
                48.3587075,
                30.6055135
              ],
              [
                48.3596612,
                30.6040041
              ],
              [
                48.3604507,
                30.6031318
              ],
              [
                48.3616677,
                30.6012985
              ],
              [
                48.3630943,
                30.5992846
              ],
              [
                48.3640975,
                30.5974989
              ],
              [
                48.3647309,
                30.5960303
              ],
              [
                48.3647308,
                30.5951149
              ],
              [
                48.3645706,
                30.5939684
              ],
              [
                48.3639336,
                30.5930987
              ],
              [
                48.3635597,
                30.59232
              ],
              [
                48.3635597,
                30.5916323
              ],
              [
                48.3639794,
                30.589616
              ],
              [
                48.3652992,
                30.5860441
              ],
              [
                48.3662987,
                30.5824251
              ],
              [
                48.3669852,
                30.5803172
              ],
              [
                48.3676682,
                30.5785746
              ],
              [
                48.3683014,
                30.5769278
              ],
              [
                48.3689347,
                30.5756892
              ],
              [
                48.3691977,
                30.5744522
              ],
              [
                48.370041,
                30.5728029
              ],
              [
                48.3700932,
                30.5725762
              ],
              [
                48.3703502,
                30.5715818
              ],
              [
                48.3705673,
                30.5707414
              ],
              [
                48.3714638,
                30.5693661
              ],
              [
                48.3725204,
                30.5673513
              ],
              [
                48.3735771,
                30.564969
              ],
              [
                48.3751565,
                30.5616254
              ],
              [
                48.3759995,
                30.5595635
              ],
              [
                48.3767891,
                30.5572254
              ],
              [
                48.3776855,
                30.5544768
              ],
              [
                48.3782119,
                30.5520928
              ],
              [
                48.3791046,
                30.5487489
              ],
              [
                48.3797874,
                30.5451752
              ],
              [
                48.3809433,
                30.5408219
              ],
              [
                48.3818359,
                30.5378003
              ],
              [
                48.3828887,
                30.5343175
              ],
              [
                48.3843613,
                30.5306965
              ],
              [
                48.3854141,
                30.5273986
              ],
              [
                48.3863601,
                30.5245111
              ],
              [
                48.3875198,
                30.5214881
              ],
              [
                48.3880959,
                30.5195177
              ],
              [
                48.3887253,
                30.5165855
              ],
              [
                48.3896141,
                30.5108129
              ],
              [
                48.3902969,
                30.5084297
              ],
              [
                48.3909797,
                30.505591
              ],
              [
                48.3910374,
                30.5054401
              ],
              [
                48.3917695,
                30.5035278
              ],
              [
                48.3935547,
                30.5000731
              ],
              [
                48.3944968,
                30.4963218
              ],
              [
                48.3956528,
                30.4920224
              ],
              [
                48.3965988,
                30.4889116
              ],
              [
                48.3974914,
                30.4860748
              ],
              [
                48.3985939,
                30.4827348
              ],
              [
                48.39954,
                30.4798066
              ],
              [
                48.4002761,
                30.4780693
              ],
              [
                48.4010696,
                30.4768787
              ],
              [
                48.4023322,
                30.4748678
              ],
              [
                48.4034424,
                30.4735415
              ],
              [
                48.4044457,
                30.4723506
              ],
              [
                48.4056588,
                30.4710264
              ],
              [
                48.4061318,
                30.4695137
              ],
              [
                48.407341,
                30.4671815
              ],
              [
                48.4080772,
                30.4646211
              ],
              [
                48.4090233,
                30.4613726
              ],
              [
                48.410389,
                30.457943
              ],
              [
                48.4119683,
                30.4538276
              ],
              [
                48.4137536,
                30.4492045
              ],
              [
                48.4166985,
                30.4415219
              ],
              [
                48.4183807,
                30.4372213
              ],
              [
                48.4197829,
                30.4333945
              ],
              [
                48.421112,
                30.4297666
              ],
              [
                48.4224777,
                30.4253289
              ],
              [
                48.4237404,
                30.4225871
              ],
              [
                48.4251061,
                30.4193851
              ],
              [
                48.4264755,
                30.4165484
              ],
              [
                48.4277382,
                30.4142146
              ],
              [
                48.4294777,
                30.411198
              ],
              [
                48.4312133,
                30.4080866
              ],
              [
                48.4327831,
                30.4060238
              ],
              [
                48.4328499,
                30.4059361
              ],
              [
                48.4342728,
                30.4041985
              ],
              [
                48.4355889,
                30.4025535
              ],
              [
                48.4370117,
                30.4007234
              ],
              [
                48.4382248,
                30.3988485
              ],
              [
                48.4392776,
                30.3969751
              ],
              [
                48.4402771,
                30.3951457
              ],
              [
                48.4414864,
                30.3931332
              ],
              [
                48.4427528,
                30.3913495
              ],
              [
                48.4441757,
                30.3894292
              ],
              [
                48.4459151,
                30.3876006
              ],
              [
                48.4468651,
                30.386503
              ],
              [
                48.448288,
                30.3854507
              ],
              [
                48.4492416,
                30.3849936
              ],
              [
                48.4493981,
                30.3847193
              ],
              [
                48.4509811,
                30.3839429
              ],
              [
                48.4528847,
                30.3829383
              ],
              [
                48.4549941,
                30.3820234
              ],
              [
                48.4585343,
                30.3802861
              ],
              [
                48.4622841,
                30.3788234
              ],
              [
                48.4648209,
                30.3777723
              ],
              [
                48.4674607,
                30.3765856
              ],
              [
                48.4706306,
                30.3754451
              ],
              [
                48.4736938,
                30.3743025
              ],
              [
                48.4761239,
                30.3736166
              ],
              [
                48.4782372,
                30.3732967
              ],
              [
                48.4799271,
                30.37307
              ],
              [
                48.4821472,
                30.372752
              ],
              [
                48.4854774,
                30.3719751
              ],
              [
                48.4879608,
                30.3716102
              ],
              [
                48.4910775,
                30.3711086
              ],
              [
                48.4936143,
                30.3707424
              ],
              [
                48.4952297,
                30.3705975
              ],
              [
                48.4952621,
                30.3705959
              ],
              [
                48.499984,
                30.3710787
              ],
              [
                48.502346,
                30.3715163
              ],
              [
                48.5027656,
                30.3716551
              ],
              [
                48.5041389,
                30.3716543
              ],
              [
                48.5049325,
                30.3717484
              ],
              [
                48.5057755,
                30.3716111
              ],
              [
                48.506569,
                30.3716105
              ],
              [
                48.5072208,
                30.3716104
              ],
              [
                48.5072211,
                30.3716104
              ],
              [
                48.5081519,
                30.3716114
              ],
              [
                48.5092584,
                30.3716099
              ],
              [
                48.5099775,
                30.3714628
              ],
              [
                48.5108161,
                30.3712911
              ],
              [
                48.5117377,
                30.3711994
              ],
              [
                48.5121612,
                30.3710158
              ],
              [
                48.5127411,
                30.3708758
              ],
              [
                48.5132141,
                30.3705556
              ],
              [
                48.5138473,
                30.3702361
              ],
              [
                48.5147438,
                30.3698225
              ],
              [
                48.515377,
                30.3694106
              ],
              [
                48.5161171,
                30.3691834
              ],
              [
                48.5170135,
                30.3688171
              ],
              [
                48.5187531,
                30.3687712
              ],
              [
                48.5200729,
                30.3687715
              ],
              [
                48.520443,
                30.368862
              ],
              [
                48.5210228,
                30.3689992
              ],
              [
                48.5220794,
                30.369229
              ],
              [
                48.5225029,
                30.3694107
              ],
              [
                48.5231895,
                30.3696853
              ],
              [
                48.5241929,
                30.3703289
              ],
              [
                48.524826,
                30.3707874
              ],
              [
                48.525303,
                30.3713354
              ],
              [
                48.5255661,
                30.3717959
              ],
              [
                48.5255661,
                30.3722086
              ],
              [
                48.5253563,
                30.3725744
              ],
              [
                48.5247765,
                30.3730775
              ],
              [
                48.5239333,
                30.3733074
              ],
              [
                48.5231399,
                30.3735359
              ],
              [
                48.5220337,
                30.3738554
              ],
              [
                48.5208205,
                30.3742247
              ],
              [
                48.5198707,
                30.3744074
              ],
              [
                48.5189209,
                30.3746825
              ],
              [
                48.5178108,
                30.3751845
              ],
              [
                48.5148048,
                30.3769719
              ],
              [
                48.5138054,
                30.377431
              ],
              [
                48.5129586,
                30.3777035
              ],
              [
                48.512539,
                30.3782074
              ],
              [
                48.5125006,
                30.3782158
              ],
              [
                48.5119056,
                30.3783464
              ],
              [
                48.5115356,
                30.3784363
              ],
              [
                48.5111657,
                30.3783909
              ],
              [
                48.5109024,
                30.3783453
              ],
              [
                48.5105858,
                30.3782987
              ],
              [
                48.5103225,
                30.3787109
              ],
              [
                48.5106392,
                30.3795377
              ],
              [
                48.510746,
                30.3798577
              ],
              [
                48.5107995,
                30.3805893
              ],
              [
                48.5108529,
                30.3811879
              ],
              [
                48.5108528,
                30.3819208
              ],
              [
                48.5109596,
                30.3824234
              ],
              [
                48.5110665,
                30.3827456
              ],
              [
                48.5112762,
                30.3829751
              ],
              [
                48.5116463,
                30.3833858
              ],
              [
                48.5121231,
                30.3836159
              ],
              [
                48.5127564,
                30.3841196
              ],
              [
                48.5136528,
                30.3845786
              ],
              [
                48.5149726,
                30.385632
              ],
              [
                48.5162429,
                30.3865942
              ],
              [
                48.5169295,
                30.387374
              ],
              [
                48.5180932,
                30.388474
              ],
              [
                48.5189896,
                30.3895283
              ],
              [
                48.5196228,
                30.390307
              ],
              [
                48.5205764,
                30.3912249
              ],
              [
                48.5209999,
                30.3916817
              ],
              [
                48.5217896,
                30.3923687
              ],
              [
                48.5220565,
                30.3925068
              ],
              [
                48.5220566,
                30.3928743
              ],
              [
                48.5220567,
                30.3932847
              ],
              [
                48.5219497,
                30.3936052
              ],
              [
                48.52174,
                30.3939259
              ],
              [
                48.5216865,
                30.3940173
              ],
              [
                48.5218467,
                30.3941106
              ],
              [
                48.5222664,
                30.3941095
              ],
              [
                48.5225335,
                30.3937425
              ],
              [
                48.5226898,
                30.393423
              ],
              [
                48.5228463,
                30.3932411
              ],
              [
                48.5232162,
                30.3929662
              ],
              [
                48.5237466,
                30.392965
              ],
              [
                48.5245896,
                30.3931028
              ],
              [
                48.5253295,
                30.3933784
              ],
              [
                48.5259093,
                30.3934683
              ],
              [
                48.5265961,
                30.3939278
              ],
              [
                48.5270194,
                30.3942944
              ],
              [
                48.5275992,
                30.3949345
              ],
              [
                48.5279693,
                30.3952549
              ],
              [
                48.5280227,
                30.3958062
              ],
              [
                48.5280227,
                30.3961286
              ],
              [
                48.5275498,
                30.397272
              ],
              [
                48.5262872,
                30.3994737
              ],
              [
                48.5259171,
                30.4000688
              ],
              [
                48.5259744,
                30.4020385
              ],
              [
                48.5261308,
                30.4030449
              ],
              [
                48.5263977,
                30.4039632
              ],
              [
                48.5265578,
                30.404512
              ],
              [
                48.526558,
                30.404972
              ],
              [
                48.5266114,
                30.4052007
              ],
              [
                48.5268746,
                30.4052463
              ],
              [
                48.5276145,
                30.405567
              ],
              [
                48.5284043,
                30.4058413
              ],
              [
                48.5288277,
                30.4060703
              ],
              [
                48.5291441,
                30.4060718
              ],
              [
                48.529991,
                30.4058871
              ],
              [
                48.5305709,
                30.405614
              ],
              [
                48.531414,
                30.4049715
              ],
              [
                48.532997,
                30.4035514
              ],
              [
                48.5347862,
                30.4019481
              ],
              [
                48.5372657,
                30.4001616
              ],
              [
                48.5377923,
                30.3998423
              ],
              [
                48.5384788,
                30.3994268
              ],
              [
                48.5386787,
                30.399184
              ],
              [
                48.5395851,
                30.3985569
              ],
              [
                48.5403785,
                30.3983735
              ],
              [
                48.5410651,
                30.3980549
              ],
              [
                48.542225,
                30.3973664
              ],
              [
                48.5431215,
                30.3968624
              ],
              [
                48.5443878,
                30.396221
              ],
              [
                48.5464972,
                30.3954895
              ],
              [
                48.5485534,
                30.3949846
              ],
              [
                48.5503501,
                30.394847
              ],
              [
                48.5523567,
                30.3948485
              ],
              [
                48.5536232,
                30.3950301
              ],
              [
                48.5545196,
                30.3952138
              ],
              [
                48.5552598,
                30.3953517
              ],
              [
                48.5564195,
                30.3953982
              ],
              [
                48.5577392,
                30.3955356
              ],
              [
                48.5591126,
                30.3957192
              ],
              [
                48.5608025,
                30.3957192
              ],
              [
                48.5628091,
                30.3956281
              ],
              [
                48.564602,
                30.3956278
              ],
              [
                48.5661851,
                30.3956731
              ],
              [
                48.5670814,
                30.3955364
              ],
              [
                48.5687179,
                30.3952625
              ],
              [
                48.5707778,
                30.3948047
              ],
              [
                48.5718308,
                30.3944838
              ],
              [
                48.5730973,
                30.3940248
              ],
              [
                48.5744171,
                30.393339
              ],
              [
                48.5755232,
                30.3925139
              ],
              [
                48.57621,
                30.3918276
              ],
              [
                48.5764198,
                30.3911392
              ],
              [
                48.5772629,
                30.3897184
              ],
              [
                48.5779991,
                30.3884354
              ],
              [
                48.578945,
                30.3875645
              ],
              [
                48.5801048,
                30.3860999
              ],
              [
                48.5803186,
                30.386052
              ],
              [
                48.5812644,
                30.3857764
              ],
              [
                48.5813178,
                30.3853647
              ],
              [
                48.5815811,
                30.3849975
              ],
              [
                48.5821608,
                30.3844941
              ],
              [
                48.5826873,
                30.3840821
              ],
              [
                48.5844802,
                30.3825706
              ],
              [
                48.585533,
                30.3814693
              ],
              [
                48.5865364,
                30.3803694
              ],
              [
                48.5875893,
                30.378905
              ],
              [
                48.5879553,
                30.3778496
              ],
              [
                48.5881652,
                30.3767035
              ],
              [
                48.5885849,
                30.3741382
              ],
              [
                48.5887909,
                30.3726717
              ],
              [
                48.5890044,
                30.372396
              ],
              [
                48.589424,
                30.3721219
              ],
              [
                48.589531,
                30.3719367
              ],
              [
                48.5895805,
                30.3717076
              ],
              [
                48.5895271,
                30.3714338
              ],
              [
                48.5893706,
                30.371158
              ],
              [
                48.5893709,
                30.3708829
              ],
              [
                48.5894737,
                30.3706548
              ],
              [
                48.589737,
                30.3707476
              ],
              [
                48.5897902,
                30.3708839
              ],
              [
                48.5902673,
                30.3710212
              ],
              [
                48.5905303,
                30.3710216
              ],
              [
                48.5910568,
                30.3709749
              ],
              [
                48.591324,
                30.3708829
              ],
              [
                48.5915337,
                30.3706545
              ],
              [
                48.5921669,
                30.3703797
              ],
              [
                48.59243,
                30.3702425
              ],
              [
                48.59243,
                30.3701501
              ],
              [
                48.5920068,
                30.370149
              ],
              [
                48.5916365,
                30.3703339
              ],
              [
                48.5913736,
                30.370426
              ],
              [
                48.5907401,
                30.3704729
              ],
              [
                48.5902137,
                30.3705173
              ],
              [
                48.5899506,
                30.3704268
              ],
              [
                48.5896339,
                30.3702879
              ],
              [
                48.589264,
                30.3699654
              ],
              [
                48.5889436,
                30.3693258
              ],
              [
                48.588997,
                30.3683165
              ],
              [
                48.5890998,
                30.3669879
              ],
              [
                48.5893631,
                30.3659803
              ],
              [
                48.5895195,
                30.3655683
              ],
              [
                48.5897294,
                30.3650174
              ],
              [
                48.5905724,
                30.3642843
              ],
              [
                48.5916252,
                30.3630927
              ],
              [
                48.5925218,
                30.3622681
              ],
              [
                48.5935744,
                30.3615343
              ],
              [
                48.5943146,
                30.3611217
              ],
              [
                48.5952646,
                30.3606634
              ],
              [
                48.5974771,
                30.3598833
              ],
              [
                48.5981103,
                30.3595634
              ],
              [
                48.5989533,
                30.3591054
              ],
              [
                48.5997467,
                30.3587862
              ],
              [
                48.600643,
                30.3582344
              ],
              [
                48.6020126,
                30.3576394
              ],
              [
                48.6032258,
                30.3572738
              ],
              [
                48.6048087,
                30.3567706
              ],
              [
                48.6059152,
                30.3564481
              ],
              [
                48.6069184,
                30.3560809
              ],
              [
                48.6081812,
                30.3556688
              ],
              [
                48.6088141,
                30.355624
              ],
              [
                48.6106111,
                30.355578
              ],
              [
                48.6129836,
                30.3556687
              ],
              [
                48.613884,
                30.355852
              ],
              [
                48.6144636,
                30.3560362
              ],
              [
                48.6147269,
                30.3562643
              ],
              [
                48.6147806,
                30.3565855
              ],
              [
                48.6146775,
                30.3571361
              ],
              [
                48.6143073,
                30.3577765
              ],
              [
                48.6137811,
                30.3584186
              ],
              [
                48.6126747,
                30.3594718
              ],
              [
                48.6112519,
                30.3608936
              ],
              [
                48.6097794,
                30.3622693
              ],
              [
                48.6087759,
                30.3636446
              ],
              [
                48.6083566,
                30.3642841
              ],
              [
                48.6080398,
                30.3649728
              ],
              [
                48.6076737,
                30.3657509
              ],
              [
                48.6073683,
                30.3661488
              ],
              [
                48.607368,
                30.3661491
              ],
              [
                48.6074454,
                30.366188
              ],
              [
                48.6074448,
                30.3661895
              ],
              [
                48.6073756,
                30.3663672
              ],
              [
                48.6072822,
                30.3667112
              ],
              [
                48.6072595,
                30.3667952
              ],
              [
                48.607255,
                30.3668118
              ],
              [
                48.6072331,
                30.3668927
              ],
              [
                48.6071686,
                30.3671825
              ],
              [
                48.607135,
                30.3676866
              ],
              [
                48.6071311,
                30.3680863
              ],
              [
                48.6071545,
                30.3683669
              ],
              [
                48.6073067,
                30.3688886
              ],
              [
                48.6073411,
                30.3690936
              ],
              [
                48.6074314,
                30.3692872
              ],
              [
                48.6076089,
                30.3696691
              ],
              [
                48.6077008,
                30.3698191
              ],
              [
                48.6077933,
                30.36997
              ],
              [
                48.6079906,
                30.3702119
              ],
              [
                48.6081861,
                30.3703949
              ],
              [
                48.6082461,
                30.3704511
              ],
              [
                48.6082989,
                30.370518
              ],
              [
                48.6083808,
                30.3706222
              ],
              [
                48.6084694,
                30.3706795
              ],
              [
                48.6085575,
                30.3707366
              ],
              [
                48.6086867,
                30.3708847
              ],
              [
                48.608723,
                30.3709596
              ],
              [
                48.6087303,
                30.3709747
              ],
              [
                48.6087301,
                30.3709751
              ],
              [
                48.608695,
                30.3710652
              ],
              [
                48.6086908,
                30.3711583
              ],
              [
                48.6086908,
                30.3711591
              ],
              [
                48.6086919,
                30.3711585
              ],
              [
                48.6086931,
                30.3711579
              ],
              [
                48.6087775,
                30.3711127
              ],
              [
                48.60878,
                30.3711113
              ],
              [
                48.6088028,
                30.3711072
              ],
              [
                48.6088958,
                30.3710902
              ],
              [
                48.6088962,
                30.3710904
              ],
              [
                48.6088969,
                30.3710903
              ],
              [
                48.6093489,
                30.3713694
              ],
              [
                48.6098211,
                30.3716094
              ],
              [
                48.6098232,
                30.3716106
              ],
              [
                48.6101511,
                30.3717944
              ],
              [
                48.6104739,
                30.3719311
              ],
              [
                48.6106563,
                30.3720303
              ],
              [
                48.6109822,
                30.3722075
              ],
              [
                48.6113864,
                30.3724111
              ],
              [
                48.6116881,
                30.3725439
              ],
              [
                48.6120272,
                30.3726533
              ],
              [
                48.6123664,
                30.3727917
              ],
              [
                48.6126867,
                30.3729622
              ],
              [
                48.6128392,
                30.3730433
              ],
              [
                48.6129072,
                30.3730539
              ],
              [
                48.6133842,
                30.3731269
              ],
              [
                48.6137103,
                30.3731928
              ],
              [
                48.6140608,
                30.3732864
              ],
              [
                48.6144591,
                30.373363
              ],
              [
                48.6145953,
                30.3733892
              ],
              [
                48.6149394,
                30.3734425
              ],
              [
                48.6151575,
                30.3735025
              ],
              [
                48.615193,
                30.3735231
              ],
              [
                48.6152597,
                30.3735617
              ],
              [
                48.6152794,
                30.3736124
              ],
              [
                48.6152956,
                30.3736539
              ],
              [
                48.6153708,
                30.3737433
              ],
              [
                48.6154039,
                30.3737483
              ],
              [
                48.6154824,
                30.37376
              ],
              [
                48.615483,
                30.3737601
              ],
              [
                48.6154183,
                30.3736841
              ],
              [
                48.6154146,
                30.3735904
              ],
              [
                48.6154145,
                30.3735877
              ],
              [
                48.6154156,
                30.373588
              ],
              [
                48.6157443,
                30.3736613
              ],
              [
                48.6158753,
                30.3736905
              ],
              [
                48.616129,
                30.3737275
              ],
              [
                48.6163339,
                30.3737575
              ],
              [
                48.6169181,
                30.3738725
              ],
              [
                48.6170092,
                30.3738909
              ],
              [
                48.6173572,
                30.3739613
              ],
              [
                48.6176828,
                30.3739947
              ],
              [
                48.6181181,
                30.3740791
              ],
              [
                48.6185597,
                30.374133
              ],
              [
                48.6187993,
                30.3741477
              ],
              [
                48.6190264,
                30.3741616
              ],
              [
                48.6195786,
                30.3742211
              ],
              [
                48.6200156,
                30.3742575
              ],
              [
                48.6200163,
                30.3742575
              ],
              [
                48.6200167,
                30.3742575
              ],
              [
                48.6206122,
                30.3742708
              ],
              [
                48.6211422,
                30.3742689
              ],
              [
                48.6216789,
                30.3742669
              ],
              [
                48.6222939,
                30.3742539
              ],
              [
                48.6227789,
                30.3742439
              ],
              [
                48.6232442,
                30.3742114
              ],
              [
                48.6234906,
                30.3741731
              ],
              [
                48.6236059,
                30.3741739
              ],
              [
                48.6236062,
                30.3741741
              ],
              [
                48.623695,
                30.3742394
              ],
              [
                48.6236758,
                30.3742513
              ],
              [
                48.6236086,
                30.374293
              ],
              [
                48.6235661,
                30.3743036
              ],
              [
                48.6234917,
                30.3743222
              ],
              [
                48.623405,
                30.374385
              ],
              [
                48.6233445,
                30.3744683
              ],
              [
                48.6233558,
                30.3745636
              ],
              [
                48.6233952,
                30.3746237
              ],
              [
                48.6234095,
                30.3746455
              ],
              [
                48.6235987,
                30.3748144
              ],
              [
                48.6236447,
                30.3748555
              ],
              [
                48.6237964,
                30.3750005
              ],
              [
                48.6238125,
                30.3750161
              ],
              [
                48.6239436,
                30.3752036
              ],
              [
                48.6239708,
                30.3752995
              ],
              [
                48.6239708,
                30.3752997
              ],
              [
                48.6239675,
                30.375307
              ],
              [
                48.6239314,
                30.3753872
              ],
              [
                48.6237908,
                30.3755566
              ],
              [
                48.623737,
                30.3756458
              ],
              [
                48.6237306,
                30.3757521
              ],
              [
                48.6237306,
                30.3757527
              ],
              [
                48.6237318,
                30.3757511
              ],
              [
                48.6237317,
                30.3757521
              ],
              [
                48.6237317,
                30.3757528
              ],
              [
                48.6237525,
                30.3757247
              ],
              [
                48.6237931,
                30.37567
              ],
              [
                48.6238387,
                30.3756378
              ],
              [
                48.6239739,
                30.3755425
              ],
              [
                48.6240486,
                30.3754733
              ],
              [
                48.6241028,
                30.3753883
              ],
              [
                48.6241372,
                30.3752908
              ],
              [
                48.6240153,
                30.3750147
              ],
              [
                48.624,
                30.3750006
              ],
              [
                48.6238965,
                30.3749038
              ],
              [
                48.6236931,
                30.3747136
              ],
              [
                48.6236179,
                30.3746631
              ],
              [
                48.6235269,
                30.3746019
              ],
              [
                48.6234719,
                30.3745253
              ],
              [
                48.6235192,
                30.3744389
              ],
              [
                48.62372,
                30.3743817
              ],
              [
                48.6238019,
                30.3743233
              ],
              [
                48.6239058,
                30.3741581
              ],
              [
                48.6240781,
                30.3741281
              ],
              [
                48.6243836,
                30.3740592
              ],
              [
                48.6245986,
                30.3739808
              ],
              [
                48.625,
                30.3739125
              ],
              [
                48.6250572,
                30.3739025
              ],
              [
                48.6256206,
                30.3737611
              ],
              [
                48.6261911,
                30.3736311
              ],
              [
                48.6265233,
                30.3735731
              ],
              [
                48.6270669,
                30.3734211
              ],
              [
                48.6274806,
                30.3733194
              ],
              [
                48.6280003,
                30.3731611
              ],
              [
                48.6283775,
                30.3730403
              ],
              [
                48.6287314,
                30.37297
              ],
              [
                48.6288292,
                30.3729369
              ],
              [
                48.6291172,
                30.3727667
              ],
              [
                48.6291177,
                30.3727667
              ],
              [
                48.6291259,
                30.3727665
              ],
              [
                48.6291676,
                30.3727657
              ],
              [
                48.6294259,
                30.3727607
              ],
              [
                48.6296789,
                30.3727558
              ],
              [
                48.6300243,
                30.3727675
              ],
              [
                48.6300254,
                30.3727675
              ],
              [
                48.6303128,
                30.3727772
              ],
              [
                48.63056,
                30.372848
              ],
              [
                48.630628,
                30.372894
              ],
              [
                48.6306422,
                30.3729036
              ],
              [
                48.6307053,
                30.3729883
              ],
              [
                48.6307131,
                30.3731938
              ],
              [
                48.6307506,
                30.3733651
              ],
              [
                48.6307653,
                30.3734322
              ],
              [
                48.6307602,
                30.3734917
              ],
              [
                48.630757,
                30.3735297
              ],
              [
                48.6307439,
                30.3735538
              ],
              [
                48.6306392,
                30.3737474
              ],
              [
                48.6306311,
                30.3737633
              ],
              [
                48.6305992,
                30.3738258
              ],
              [
                48.6299286,
                30.3750022
              ],
              [
                48.6299228,
                30.3750122
              ],
              [
                48.6298639,
                30.3750988
              ],
              [
                48.6298025,
                30.3752133
              ],
              [
                48.6297414,
                30.375325
              ],
              [
                48.6296692,
                30.3754366
              ],
              [
                48.6296031,
                30.3755466
              ],
              [
                48.6295576,
                30.3756352
              ],
              [
                48.6295558,
                30.3756386
              ],
              [
                48.6295545,
                30.3756418
              ],
              [
                48.6295261,
                30.375713
              ],
              [
                48.6295008,
                30.3757511
              ],
              [
                48.6294528,
                30.3758544
              ],
              [
                48.6294086,
                30.3759661
              ],
              [
                48.6293533,
                30.3760902
              ],
              [
                48.62929,
                30.3762196
              ],
              [
                48.6292817,
                30.3762366
              ],
              [
                48.629262,
                30.3762827
              ],
              [
                48.6292192,
                30.376383
              ],
              [
                48.6291772,
                30.3764697
              ],
              [
                48.6291278,
                30.3766077
              ],
              [
                48.6290902,
                30.3767084
              ],
              [
                48.6290867,
                30.3767177
              ],
              [
                48.629086,
                30.3767194
              ],
              [
                48.6290497,
                30.3768063
              ],
              [
                48.6290193,
                30.3769072
              ],
              [
                48.6290106,
                30.3769363
              ],
              [
                48.6290063,
                30.3769492
              ],
              [
                48.6289931,
                30.3769886
              ],
              [
                48.628937,
                30.3770863
              ],
              [
                48.6289103,
                30.3771436
              ],
              [
                48.6288726,
                30.3772814
              ],
              [
                48.6288697,
                30.3772919
              ],
              [
                48.6288662,
                30.3773046
              ],
              [
                48.6288106,
                30.3775019
              ],
              [
                48.6287775,
                30.3776219
              ],
              [
                48.6287472,
                30.3777347
              ],
              [
                48.6287058,
                30.3778969
              ],
              [
                48.6286797,
                30.3780141
              ],
              [
                48.6286346,
                30.3781685
              ],
              [
                48.6286331,
                30.3781738
              ],
              [
                48.6286301,
                30.3781831
              ],
              [
                48.628597,
                30.3782866
              ],
              [
                48.6285422,
                30.3784516
              ],
              [
                48.6285092,
                30.3785625
              ],
              [
                48.628477,
                30.3786833
              ],
              [
                48.6284408,
                30.3787933
              ],
              [
                48.6283997,
                30.3789036
              ],
              [
                48.6283664,
                30.3790261
              ],
              [
                48.6283383,
                30.379145
              ],
              [
                48.628324,
                30.3792032
              ],
              [
                48.6283089,
                30.3792647
              ],
              [
                48.6282842,
                30.3793796
              ],
              [
                48.6282817,
                30.3793913
              ],
              [
                48.6282816,
                30.379392
              ],
              [
                48.6282748,
                30.3794337
              ],
              [
                48.6282625,
                30.3795097
              ],
              [
                48.6282425,
                30.3796294
              ],
              [
                48.6282323,
                30.3796895
              ],
              [
                48.6282211,
                30.3797555
              ],
              [
                48.6282174,
                30.3797792
              ],
              [
                48.628207,
                30.3798448
              ],
              [
                48.6282031,
                30.3798699
              ],
              [
                48.628189,
                30.3799557
              ],
              [
                48.6281831,
                30.3799916
              ],
              [
                48.6281779,
                30.3800211
              ],
              [
                48.6281608,
                30.3801186
              ],
              [
                48.6281386,
                30.3802338
              ],
              [
                48.6281195,
                30.3803563
              ],
              [
                48.6281022,
                30.380478
              ],
              [
                48.6280983,
                30.3805118
              ],
              [
                48.6280836,
                30.3806397
              ],
              [
                48.6280797,
                30.3806906
              ],
              [
                48.6280747,
                30.3807552
              ],
              [
                48.6280592,
                30.3809205
              ],
              [
                48.628052,
                30.3810455
              ],
              [
                48.6280454,
                30.3811269
              ],
              [
                48.6280417,
                30.3811733
              ],
              [
                48.6280306,
                30.3812941
              ],
              [
                48.6280258,
                30.3813613
              ],
              [
                48.6280214,
                30.3814244
              ],
              [
                48.6280122,
                30.3815522
              ],
              [
                48.6280038,
                30.3816654
              ],
              [
                48.6280031,
                30.3816747
              ],
              [
                48.6280028,
                30.3816804
              ],
              [
                48.6279967,
                30.3818024
              ],
              [
                48.627992,
                30.3819137
              ],
              [
                48.6279917,
                30.3819225
              ],
              [
                48.627989,
                30.3819605
              ],
              [
                48.6279836,
                30.382038
              ],
              [
                48.6279756,
                30.3821563
              ],
              [
                48.627965,
                30.3823233
              ],
              [
                48.6279639,
                30.382355
              ],
              [
                48.6279608,
                30.382438
              ],
              [
                48.6279613,
                30.3824501
              ],
              [
                48.6279656,
                30.3825605
              ],
              [
                48.6279769,
                30.3826531
              ],
              [
                48.6279797,
                30.3826763
              ],
              [
                48.6279908,
                30.3827626
              ],
              [
                48.6279956,
                30.3827999
              ],
              [
                48.6280114,
                30.3829252
              ],
              [
                48.6280237,
                30.3830265
              ],
              [
                48.6280256,
                30.3830419
              ],
              [
                48.6280364,
                30.3831655
              ],
              [
                48.6280472,
                30.3832891
              ],
              [
                48.6280529,
                30.3833561
              ],
              [
                48.6280572,
                30.3834066
              ],
              [
                48.6280642,
                30.3835275
              ],
              [
                48.6280681,
                30.3836441
              ],
              [
                48.6280727,
                30.383718
              ],
              [
                48.6280786,
                30.3838111
              ],
              [
                48.6280819,
                30.3838967
              ],
              [
                48.6280833,
                30.3839327
              ],
              [
                48.628087,
                30.3841025
              ],
              [
                48.6280908,
                30.3842224
              ],
              [
                48.628091,
                30.3842305
              ],
              [
                48.6280928,
                30.3843433
              ],
              [
                48.6280978,
                30.3844563
              ],
              [
                48.6281075,
                30.3845775
              ],
              [
                48.6281281,
                30.3847436
              ],
              [
                48.6281556,
                30.3849055
              ],
              [
                48.6281806,
                30.3850447
              ],
              [
                48.6282006,
                30.3851519
              ],
              [
                48.6282164,
                30.3852808
              ],
              [
                48.628218,
                30.3852919
              ],
              [
                48.6282314,
                30.3853852
              ],
              [
                48.6282414,
                30.3855166
              ],
              [
                48.6282508,
                30.3856684
              ],
              [
                48.6282508,
                30.3856697
              ],
              [
                48.6282509,
                30.3856716
              ],
              [
                48.6282578,
                30.3858113
              ],
              [
                48.6282675,
                30.3859497
              ],
              [
                48.6282815,
                30.3860563
              ],
              [
                48.6282861,
                30.3860916
              ],
              [
                48.6282926,
                30.3861291
              ],
              [
                48.62831,
                30.3862291
              ],
              [
                48.6283345,
                30.3863894
              ],
              [
                48.6283429,
                30.3864334
              ],
              [
                48.6283622,
                30.3865347
              ],
              [
                48.6283869,
                30.3866788
              ],
              [
                48.6283881,
                30.3866855
              ],
              [
                48.6284097,
                30.3868247
              ],
              [
                48.6284328,
                30.3869569
              ],
              [
                48.6284449,
                30.3870356
              ],
              [
                48.6284536,
                30.3870919
              ],
              [
                48.6284617,
                30.3871387
              ],
              [
                48.6284745,
                30.387213
              ],
              [
                48.6285006,
                30.3873313
              ],
              [
                48.6285318,
                30.3874729
              ],
              [
                48.6285331,
                30.3874786
              ],
              [
                48.6285378,
                30.3874959
              ],
              [
                48.6285731,
                30.3876258
              ],
              [
                48.628605,
                30.3877461
              ],
              [
                48.6286322,
                30.3878455
              ],
              [
                48.6286324,
                30.3878458
              ],
              [
                48.628633,
                30.3878474
              ],
              [
                48.6286792,
                30.3879544
              ],
              [
                48.6287093,
                30.3880362
              ],
              [
                48.6287242,
                30.3880763
              ],
              [
                48.6287432,
                30.3881283
              ],
              [
                48.6287672,
                30.3881941
              ],
              [
                48.6288022,
                30.3883144
              ],
              [
                48.6288342,
                30.3884416
              ],
              [
                48.6288504,
                30.3885132
              ],
              [
                48.6288611,
                30.3885608
              ],
              [
                48.6288642,
                30.3885788
              ],
              [
                48.6288822,
                30.3886836
              ],
              [
                48.6289011,
                30.3888
              ],
              [
                48.6289031,
                30.3888125
              ],
              [
                48.6289231,
                30.3889299
              ],
              [
                48.6289388,
                30.38902
              ],
              [
                48.628945,
                30.3890555
              ],
              [
                48.6289778,
                30.3891808
              ],
              [
                48.6290211,
                30.3892908
              ],
              [
                48.6290213,
                30.3892913
              ],
              [
                48.629046,
                30.3893501
              ],
              [
                48.62907,
                30.3894074
              ],
              [
                48.6290867,
                30.3894498
              ],
              [
                48.6291397,
                30.3895847
              ],
              [
                48.6291817,
                30.389698
              ],
              [
                48.6291999,
                30.3897527
              ],
              [
                48.6292228,
                30.3898216
              ],
              [
                48.6292488,
                30.3898998
              ],
              [
                48.6292617,
                30.3899386
              ],
              [
                48.6292925,
                30.3900333
              ],
              [
                48.6292997,
                30.3900561
              ],
              [
                48.6293082,
                30.3900831
              ],
              [
                48.6293397,
                30.3901841
              ],
              [
                48.6293736,
                30.3902824
              ],
              [
                48.6293808,
                30.3903036
              ],
              [
                48.6294059,
                30.3903681
              ],
              [
                48.6294289,
                30.3904274
              ],
              [
                48.6294817,
                30.3905558
              ],
              [
                48.6295188,
                30.3906476
              ],
              [
                48.6295289,
                30.3906725
              ],
              [
                48.6295708,
                30.3907936
              ],
              [
                48.6296077,
                30.3909054
              ],
              [
                48.629612,
                30.3909183
              ],
              [
                48.62965,
                30.3910308
              ],
              [
                48.629692,
                30.3911486
              ],
              [
                48.629737,
                30.3912661
              ],
              [
                48.6298047,
                30.391418
              ],
              [
                48.6298411,
                30.3915018
              ],
              [
                48.6298725,
                30.3915741
              ],
              [
                48.6298942,
                30.3916208
              ],
              [
                48.6299131,
                30.3916613
              ],
              [
                48.6299491,
                30.3917236
              ],
              [
                48.6299711,
                30.3917616
              ],
              [
                48.6300286,
                30.39185
              ],
              [
                48.630048,
                30.3918857
              ],
              [
                48.6300758,
                30.3919372
              ],
              [
                48.630078,
                30.3919388
              ],
              [
                48.6301089,
                30.3919619
              ],
              [
                48.6301395,
                30.3920141
              ],
              [
                48.6301562,
                30.3920452
              ],
              [
                48.6301828,
                30.3920944
              ],
              [
                48.6302472,
                30.3921933
              ],
              [
                48.6303133,
                30.392305
              ],
              [
                48.6303369,
                30.3923453
              ],
              [
                48.6303725,
                30.3924063
              ],
              [
                48.6304358,
                30.3925127
              ],
              [
                48.6304482,
                30.3925354
              ],
              [
                48.6304997,
                30.3926297
              ],
              [
                48.6305398,
                30.3926925
              ],
              [
                48.6305672,
                30.3927355
              ],
              [
                48.6306433,
                30.3928377
              ],
              [
                48.6307225,
                30.3929486
              ],
              [
                48.630795,
                30.3930544
              ],
              [
                48.6308489,
                30.3931312
              ],
              [
                48.6308642,
                30.393153
              ],
              [
                48.6309436,
                30.3932547
              ],
              [
                48.6309462,
                30.3932577
              ],
              [
                48.6310289,
                30.3933533
              ],
              [
                48.6311103,
                30.3934436
              ],
              [
                48.6311886,
                30.3935336
              ],
              [
                48.6312631,
                30.3936308
              ],
              [
                48.6312723,
                30.3936426
              ],
              [
                48.6313345,
                30.3937225
              ],
              [
                48.6314497,
                30.393845
              ],
              [
                48.6314674,
                30.3938646
              ],
              [
                48.6315658,
                30.3939736
              ],
              [
                48.6316464,
                30.3940594
              ],
              [
                48.6317725,
                30.3941725
              ],
              [
                48.6318497,
                30.3942329
              ],
              [
                48.6318633,
                30.3942436
              ],
              [
                48.631877,
                30.3942561
              ],
              [
                48.631947,
                30.3943205
              ],
              [
                48.6320345,
                30.3943944
              ],
              [
                48.6321281,
                30.3944583
              ],
              [
                48.632225,
                30.3945163
              ],
              [
                48.6323597,
                30.3945852
              ],
              [
                48.6325145,
                30.3946611
              ],
              [
                48.6326242,
                30.3947175
              ],
              [
                48.6327192,
                30.3947711
              ],
              [
                48.6328697,
                30.3948469
              ],
              [
                48.6329836,
                30.3948983
              ],
              [
                48.6330129,
                30.394914
              ],
              [
                48.6331364,
                30.3949802
              ],
              [
                48.6332433,
                30.3950408
              ],
              [
                48.6333611,
                30.3950983
              ],
              [
                48.6334335,
                30.3951297
              ],
              [
                48.6334789,
                30.3951494
              ],
              [
                48.6335808,
                30.3951963
              ],
              [
                48.6336928,
                30.395238
              ],
              [
                48.6338681,
                30.3952869
              ],
              [
                48.634017,
                30.3953297
              ],
              [
                48.6341211,
                30.3953644
              ],
              [
                48.63427,
                30.3954255
              ],
              [
                48.6342705,
                30.3954257
              ],
              [
                48.6343458,
                30.3954608
              ],
              [
                48.6343716,
                30.3954697
              ],
              [
                48.6344147,
                30.3954847
              ],
              [
                48.6345631,
                30.3955083
              ],
              [
                48.6347214,
                30.3955233
              ],
              [
                48.6348778,
                30.3955436
              ],
              [
                48.634992,
                30.3955625
              ],
              [
                48.635142,
                30.3955958
              ],
              [
                48.63526,
                30.3956206
              ],
              [
                48.6352953,
                30.395628
              ],
              [
                48.6353164,
                30.3956323
              ],
              [
                48.6353975,
                30.3956488
              ],
              [
                48.6355082,
                30.3956629
              ],
              [
                48.6355356,
                30.3956663
              ],
              [
                48.6355689,
                30.3956684
              ],
              [
                48.635697,
                30.3956761
              ],
              [
                48.6356977,
                30.3956761
              ],
              [
                48.6356981,
                30.3956761
              ],
              [
                48.6358675,
                30.3956825
              ],
              [
                48.6358686,
                30.3956825
              ],
              [
                48.6360131,
                30.3956836
              ],
              [
                48.6361767,
                30.3956847
              ],
              [
                48.6362423,
                30.3956852
              ],
              [
                48.6363311,
                30.3956858
              ],
              [
                48.6363707,
                30.3956861
              ],
              [
                48.6364944,
                30.3956869
              ],
              [
                48.6366711,
                30.3956881
              ],
              [
                48.6368037,
                30.395689
              ],
              [
                48.6368256,
                30.3956892
              ],
              [
                48.6368373,
                30.3956892
              ],
              [
                48.6369831,
                30.3956903
              ],
              [
                48.6371606,
                30.3956914
              ],
              [
                48.6373081,
                30.3956917
              ],
              [
                48.6374475,
                30.3956889
              ],
              [
                48.6376019,
                30.3956928
              ],
              [
                48.6377353,
                30.3956953
              ],
              [
                48.6378528,
                30.3956966
              ],
              [
                48.6379269,
                30.3956975
              ],
              [
                48.6379644,
                30.3956977
              ],
              [
                48.6380594,
                30.3956983
              ],
              [
                48.6381978,
                30.3956994
              ],
              [
                48.6383311,
                30.3957003
              ],
              [
                48.6383546,
                30.3957005
              ],
              [
                48.6384439,
                30.3957011
              ],
              [
                48.6384837,
                30.3957042
              ],
              [
                48.6386039,
                30.3957136
              ],
              [
                48.638705,
                30.3957247
              ],
              [
                48.6387061,
                30.3957247
              ],
              [
                48.6388109,
                30.39573
              ],
              [
                48.638812,
                30.39573
              ],
              [
                48.6388433,
                30.3957316
              ],
              [
                48.6388435,
                30.3957316
              ],
              [
                48.6388444,
                30.3957317
              ],
              [
                48.6389558,
                30.3957335
              ],
              [
                48.63901,
                30.3957344
              ],
              [
                48.6391936,
                30.3957367
              ],
              [
                48.6393639,
                30.3957447
              ],
              [
                48.6394953,
                30.3957536
              ],
              [
                48.6395165,
                30.395755
              ],
              [
                48.6396245,
                30.3957622
              ],
              [
                48.6396251,
                30.3957622
              ],
              [
                48.6396256,
                30.3957622
              ],
              [
                48.6396998,
                30.3957644
              ],
              [
                48.6398161,
                30.3957678
              ],
              [
                48.6399328,
                30.3957691
              ],
              [
                48.6400089,
                30.39577
              ],
              [
                48.6400428,
                30.3957712
              ],
              [
                48.6400439,
                30.3957712
              ],
              [
                48.6401331,
                30.3957744
              ],
              [
                48.6401332,
                30.3957744
              ],
              [
                48.6403203,
                30.3957991
              ],
              [
                48.6404936,
                30.3958202
              ],
              [
                48.640675,
                30.3958433
              ],
              [
                48.6408514,
                30.3958602
              ],
              [
                48.6410247,
                30.3958777
              ],
              [
                48.6411922,
                30.395898
              ],
              [
                48.6413645,
                30.3959174
              ],
              [
                48.6414958,
                30.3959308
              ],
              [
                48.6416872,
                30.3959511
              ],
              [
                48.6417745,
                30.3959597
              ],
              [
                48.6418186,
                30.3959641
              ],
              [
                48.6418813,
                30.3959706
              ],
              [
                48.641952,
                30.395978
              ],
              [
                48.6421403,
                30.3959924
              ],
              [
                48.6421411,
                30.3959925
              ],
              [
                48.6421414,
                30.3959925
              ],
              [
                48.6422728,
                30.3959969
              ],
              [
                48.6422739,
                30.3959969
              ],
              [
                48.642407,
                30.396003
              ],
              [
                48.6425986,
                30.3960183
              ],
              [
                48.642785,
                30.3960361
              ],
              [
                48.6429733,
                30.3960494
              ],
              [
                48.6429744,
                30.3960494
              ],
              [
                48.643165,
                30.3960577
              ],
              [
                48.6431661,
                30.3960578
              ],
              [
                48.6433153,
                30.3960653
              ],
              [
                48.6433164,
                30.3960654
              ],
              [
                48.6433464,
                30.3960669
              ],
              [
                48.6433466,
                30.3960669
              ],
              [
                48.6433746,
                30.3960674
              ],
              [
                48.6434808,
                30.3960694
              ],
              [
                48.6435629,
                30.3960704
              ],
              [
                48.6436131,
                30.3960711
              ],
              [
                48.6436596,
                30.3960717
              ],
              [
                48.6437486,
                30.396073
              ],
              [
                48.6438889,
                30.3960738
              ],
              [
                48.6440145,
                30.3960722
              ],
              [
                48.6441972,
                30.3960577
              ],
              [
                48.644382,
                30.3960372
              ],
              [
                48.6445575,
                30.3960219
              ],
              [
                48.6446792,
                30.396008
              ],
              [
                48.644847,
                30.3959777
              ],
              [
                48.6449998,
                30.3959487
              ],
              [
                48.6450178,
                30.3959452
              ],
              [
                48.6451764,
                30.3959183
              ],
              [
                48.6452084,
                30.3959127
              ],
              [
                48.6453383,
                30.39589
              ],
              [
                48.6454363,
                30.3958758
              ],
              [
                48.6454367,
                30.3958758
              ],
              [
                48.6454639,
                30.3958691
              ],
              [
                48.6454878,
                30.3958643
              ],
              [
                48.6456086,
                30.3958397
              ],
              [
                48.6457845,
                30.3958016
              ],
              [
                48.6459392,
                30.3957549
              ],
              [
                48.6461064,
                30.3956969
              ],
              [
                48.6462814,
                30.3956311
              ],
              [
                48.6463867,
                30.3955893
              ],
              [
                48.6464517,
                30.3955636
              ],
              [
                48.6465443,
                30.3955252
              ],
              [
                48.6466108,
                30.3954977
              ],
              [
                48.6467789,
                30.3954327
              ],
              [
                48.6469289,
                30.3953694
              ],
              [
                48.64709,
                30.3953069
              ],
              [
                48.6472531,
                30.3952369
              ],
              [
                48.6473597,
                30.3951897
              ],
              [
                48.6475331,
                30.3951275
              ],
              [
                48.6475996,
                30.3951025
              ],
              [
                48.6476406,
                30.3950872
              ],
              [
                48.6477906,
                30.3950213
              ],
              [
                48.6478148,
                30.3950104
              ],
              [
                48.6478853,
                30.3949786
              ],
              [
                48.6479972,
                30.3949166
              ],
              [
                48.648082,
                30.3948686
              ],
              [
                48.6481103,
                30.3948416
              ],
              [
                48.6482011,
                30.3947797
              ],
              [
                48.6483392,
                30.3947041
              ],
              [
                48.6484339,
                30.39465
              ],
              [
                48.6485208,
                30.3945916
              ],
              [
                48.6486432,
                30.3944952
              ],
              [
                48.6486481,
                30.3944913
              ],
              [
                48.6486614,
                30.3944798
              ],
              [
                48.6487745,
                30.3943827
              ],
              [
                48.648897,
                30.394268
              ],
              [
                48.6490145,
                30.3941497
              ],
              [
                48.6491278,
                30.3940269
              ],
              [
                48.6492442,
                30.3939016
              ],
              [
                48.6493211,
                30.3938205
              ],
              [
                48.6494256,
                30.3936986
              ],
              [
                48.6495231,
                30.3935808
              ],
              [
                48.6496256,
                30.3934597
              ],
              [
                48.6497339,
                30.3933319
              ],
              [
                48.6498345,
                30.3932091
              ],
              [
                48.6499247,
                30.3930905
              ],
              [
                48.6499939,
                30.3929936
              ],
              [
                48.650077,
                30.3928769
              ],
              [
                48.650137,
                30.3927988
              ],
              [
                48.6501817,
                30.3927305
              ],
              [
                48.6502111,
                30.392703
              ],
              [
                48.6502425,
                30.3926527
              ],
              [
                48.6502427,
                30.3926525
              ],
              [
                48.6503058,
                30.3925297
              ],
              [
                48.6503822,
                30.3923927
              ],
              [
                48.6504411,
                30.392287
              ],
              [
                48.6504608,
                30.3922516
              ],
              [
                48.6504752,
                30.392226
              ],
              [
                48.650512,
                30.3921605
              ],
              [
                48.650558,
                30.3920661
              ],
              [
                48.6505792,
                30.3920227
              ],
              [
                48.6505971,
                30.3919808
              ],
              [
                48.6506378,
                30.3918858
              ],
              [
                48.6506768,
                30.3917851
              ],
              [
                48.6506892,
                30.391753
              ],
              [
                48.6507081,
                30.3917018
              ],
              [
                48.6507425,
                30.3916083
              ],
              [
                48.6507834,
                30.3915072
              ],
              [
                48.6508,
                30.3914661
              ],
              [
                48.6508397,
                30.3913683
              ],
              [
                48.6508614,
                30.391315
              ],
              [
                48.6509067,
                30.3912094
              ],
              [
                48.6509672,
                30.3910583
              ],
              [
                48.6510278,
                30.3909022
              ],
              [
                48.6510972,
                30.3907472
              ],
              [
                48.6511491,
                30.390645
              ],
              [
                48.6511514,
                30.3906405
              ],
              [
                48.6511521,
                30.3906392
              ],
              [
                48.65123,
                30.3904836
              ],
              [
                48.6513097,
                30.3903319
              ],
              [
                48.6513658,
                30.3902297
              ],
              [
                48.651422,
                30.3901336
              ],
              [
                48.6515122,
                30.3899941
              ],
              [
                48.6515695,
                30.3899025
              ],
              [
                48.6516547,
                30.3897822
              ],
              [
                48.6517389,
                30.3896713
              ],
              [
                48.6517681,
                30.3896335
              ],
              [
                48.6518111,
                30.389578
              ],
              [
                48.6518287,
                30.3895596
              ],
              [
                48.6519375,
                30.3894458
              ],
              [
                48.6520283,
                30.3893819
              ],
              [
                48.6521095,
                30.3893077
              ],
              [
                48.6522249,
                30.3891869
              ],
              [
                48.6522339,
                30.3891774
              ],
              [
                48.6523522,
                30.3890519
              ],
              [
                48.6523661,
                30.3890375
              ],
              [
                48.6524758,
                30.3889233
              ],
              [
                48.6525558,
                30.3888377
              ],
              [
                48.6526864,
                30.3887177
              ],
              [
                48.6527422,
                30.3886686
              ],
              [
                48.6527764,
                30.3886383
              ],
              [
                48.6529106,
                30.3885366
              ],
              [
                48.6530408,
                30.3884394
              ],
              [
                48.6531289,
                30.3883702
              ],
              [
                48.6531948,
                30.388308
              ],
              [
                48.6532147,
                30.3882891
              ],
              [
                48.6533089,
                30.3881909
              ],
              [
                48.6533372,
                30.3881613
              ],
              [
                48.6534567,
                30.3880422
              ],
              [
                48.65357,
                30.387928
              ],
              [
                48.6536814,
                30.3878141
              ],
              [
                48.653768,
                30.3877282
              ],
              [
                48.6537989,
                30.3876974
              ],
              [
                48.6538524,
                30.3876409
              ],
              [
                48.6539092,
                30.3875808
              ],
              [
                48.6539228,
                30.3875677
              ],
              [
                48.6540217,
                30.3874736
              ],
              [
                48.6541312,
                30.3873786
              ],
              [
                48.654137,
                30.3873736
              ],
              [
                48.6541511,
                30.387361
              ],
              [
                48.6542572,
                30.3872666
              ],
              [
                48.6543817,
                30.3871499
              ],
              [
                48.6545008,
                30.3870377
              ],
              [
                48.6545841,
                30.3869538
              ],
              [
                48.6546072,
                30.3869305
              ],
              [
                48.6546182,
                30.3869201
              ],
              [
                48.6546781,
                30.3868633
              ],
              [
                48.6547497,
                30.3868072
              ],
              [
                48.6548681,
                30.3866986
              ],
              [
                48.6549208,
                30.3866441
              ],
              [
                48.655005,
                30.3865341
              ],
              [
                48.655055,
                30.3865097
              ],
              [
                48.6551372,
                30.3864133
              ],
              [
                48.6551826,
                30.3863617
              ],
              [
                48.655202,
                30.3863397
              ],
              [
                48.6552156,
                30.3863223
              ],
              [
                48.6552678,
                30.3862555
              ],
              [
                48.6553253,
                30.3861758
              ],
              [
                48.6553461,
                30.3861258
              ],
              [
                48.6553487,
                30.3861038
              ],
              [
                48.6553512,
                30.3860822
              ],
              [
                48.6553514,
                30.3860808
              ],
              [
                48.6553908,
                30.3860041
              ],
              [
                48.6554072,
                30.3859886
              ],
              [
                48.655416,
                30.3859809
              ],
              [
                48.6554725,
                30.3859316
              ],
              [
                48.6554798,
                30.3859242
              ],
              [
                48.6555353,
                30.3858677
              ],
              [
                48.6556561,
                30.3857452
              ],
              [
                48.655772,
                30.3856261
              ],
              [
                48.6558863,
                30.3855134
              ],
              [
                48.6558992,
                30.3855008
              ],
              [
                48.6559192,
                30.3854822
              ],
              [
                48.6560322,
                30.3853774
              ],
              [
                48.656222,
                30.3851927
              ],
              [
                48.6562783,
                30.3851286
              ],
              [
                48.6563367,
                30.3850708
              ],
              [
                48.6564525,
                30.3849613
              ],
              [
                48.6565611,
                30.3848422
              ],
              [
                48.6566106,
                30.3847775
              ],
              [
                48.6566527,
                30.3847263
              ],
              [
                48.6566597,
                30.3847177
              ],
              [
                48.6566663,
                30.3847111
              ],
              [
                48.6567142,
                30.3846625
              ],
              [
                48.6568147,
                30.3845538
              ],
              [
                48.6569172,
                30.3844399
              ],
              [
                48.6570128,
                30.3843216
              ],
              [
                48.6570762,
                30.3842405
              ],
              [
                48.6571053,
                30.3842033
              ],
              [
                48.6571255,
                30.3841754
              ],
              [
                48.6572008,
                30.3840716
              ],
              [
                48.6572262,
                30.3840399
              ],
              [
                48.6572511,
                30.3840086
              ],
              [
                48.6572746,
                30.3839775
              ],
              [
                48.6573478,
                30.3838805
              ],
              [
                48.6574353,
                30.3837602
              ],
              [
                48.6575275,
                30.3836447
              ],
              [
                48.6576158,
                30.3835375
              ],
              [
                48.657655,
                30.383485
              ],
              [
                48.6577453,
                30.3833711
              ],
              [
                48.6577925,
                30.3833166
              ],
              [
                48.6578378,
                30.3832588
              ],
              [
                48.6579281,
                30.3831466
              ],
              [
                48.6580186,
                30.3830291
              ],
              [
                48.6581533,
                30.3828466
              ],
              [
                48.6582908,
                30.3826666
              ],
              [
                48.6583845,
                30.3825475
              ],
              [
                48.6584686,
                30.3824352
              ],
              [
                48.6585036,
                30.38238
              ],
              [
                48.6585067,
                30.3823752
              ],
              [
                48.6585739,
                30.3822683
              ],
              [
                48.6586447,
                30.3821597
              ],
              [
                48.658722,
                30.382065
              ],
              [
                48.6588153,
                30.3819544
              ],
              [
                48.6588595,
                30.3818966
              ],
              [
                48.6589278,
                30.381802
              ],
              [
                48.6589406,
                30.3817844
              ],
              [
                48.6590158,
                30.3816747
              ],
              [
                48.6590277,
                30.3816588
              ],
              [
                48.6591422,
                30.3815052
              ],
              [
                48.6591761,
                30.3814694
              ],
              [
                48.6592075,
                30.3814271
              ],
              [
                48.659212,
                30.3814211
              ],
              [
                48.65925,
                30.3813641
              ],
              [
                48.6592677,
                30.381339
              ],
              [
                48.6593364,
                30.3812413
              ],
              [
                48.6594003,
                30.3811529
              ],
              [
                48.6594289,
                30.3811133
              ],
              [
                48.6594564,
                30.3810743
              ],
              [
                48.6595267,
                30.3809747
              ],
              [
                48.659572,
                30.3809036
              ],
              [
                48.6596495,
                30.3807691
              ],
              [
                48.6596895,
                30.3807058
              ],
              [
                48.6597286,
                30.3806383
              ],
              [
                48.6597595,
                30.3805866
              ],
              [
                48.6597689,
                30.3805708
              ],
              [
                48.6597785,
                30.3805563
              ],
              [
                48.6598122,
                30.3805058
              ],
              [
                48.6598986,
                30.3803766
              ],
              [
                48.6599789,
                30.3802494
              ],
              [
                48.6600645,
                30.3801161
              ],
              [
                48.6601558,
                30.37998
              ],
              [
                48.6601875,
                30.3799319
              ],
              [
                48.6602467,
                30.3798422
              ],
              [
                48.6602897,
                30.3797702
              ],
              [
                48.6603836,
                30.3796299
              ],
              [
                48.6605245,
                30.3794147
              ],
              [
                48.660592,
                30.3793086
              ],
              [
                48.660607,
                30.379285
              ],
              [
                48.6606503,
                30.3792172
              ],
              [
                48.6606953,
                30.3791505
              ],
              [
                48.6607839,
                30.3790233
              ],
              [
                48.6608281,
                30.3789663
              ],
              [
                48.6609145,
                30.3788444
              ],
              [
                48.6610061,
                30.3787111
              ],
              [
                48.6610986,
                30.3785786
              ],
              [
                48.6611142,
                30.3785569
              ],
              [
                48.66119,
                30.3784505
              ],
              [
                48.6612414,
                30.3783891
              ],
              [
                48.66134,
                30.3782647
              ],
              [
                48.6613893,
                30.3781948
              ],
              [
                48.6614317,
                30.3781347
              ],
              [
                48.6614662,
                30.378085
              ],
              [
                48.6615189,
                30.3780091
              ],
              [
                48.6616064,
                30.3778927
              ],
              [
                48.661742,
                30.3777094
              ],
              [
                48.6617865,
                30.3776536
              ],
              [
                48.6617903,
                30.3776488
              ],
              [
                48.6618,
                30.3776364
              ],
              [
                48.6618817,
                30.3775322
              ],
              [
                48.6619258,
                30.3774708
              ],
              [
                48.6620172,
                30.3773522
              ],
              [
                48.6621128,
                30.3772366
              ],
              [
                48.6622033,
                30.3771225
              ],
              [
                48.6622906,
                30.3770077
              ],
              [
                48.6623275,
                30.3769525
              ],
              [
                48.6623503,
                30.3769005
              ],
              [
                48.6623822,
                30.3768522
              ],
              [
                48.6623886,
                30.3768436
              ],
              [
                48.6624625,
                30.3767416
              ],
              [
                48.6625561,
                30.376618
              ],
              [
                48.6625981,
                30.376553
              ],
              [
                48.6626689,
                30.3764395
              ],
              [
                48.6626714,
                30.3764355
              ],
              [
                48.6627486,
                30.3763213
              ],
              [
                48.66281,
                30.3762363
              ],
              [
                48.6628278,
                30.3762116
              ],
              [
                48.6629159,
                30.3761047
              ],
              [
                48.6629661,
                30.376043
              ],
              [
                48.6630095,
                30.3759899
              ],
              [
                48.6630617,
                30.3759338
              ],
              [
                48.66311,
                30.3758761
              ],
              [
                48.6631131,
                30.3758725
              ],
              [
                48.6631315,
                30.3758499
              ],
              [
                48.6632086,
                30.3757558
              ],
              [
                48.66331,
                30.375635
              ],
              [
                48.6634036,
                30.3755236
              ],
              [
                48.663497,
                30.3754202
              ],
              [
                48.6636547,
                30.3752483
              ],
              [
                48.6638067,
                30.3750855
              ],
              [
                48.6638578,
                30.3750355
              ],
              [
                48.6638814,
                30.3750127
              ],
              [
                48.6640228,
                30.3748769
              ],
              [
                48.6641867,
                30.3747263
              ],
              [
                48.664245,
                30.3746783
              ],
              [
                48.6642813,
                30.3746427
              ],
              [
                48.6643003,
                30.3746241
              ],
              [
                48.6643196,
                30.3746058
              ],
              [
                48.6644611,
                30.3744716
              ],
              [
                48.6645076,
                30.3744342
              ],
              [
                48.6645172,
                30.3744263
              ],
              [
                48.6645327,
                30.3744152
              ],
              [
                48.6645756,
                30.3743844
              ],
              [
                48.6646241,
                30.3743542
              ],
              [
                48.6646431,
                30.3743425
              ],
              [
                48.6646599,
                30.3743311
              ],
              [
                48.6647708,
                30.3742561
              ],
              [
                48.66483,
                30.3742105
              ],
              [
                48.6650222,
                30.3740733
              ],
              [
                48.6650886,
                30.3740366
              ],
              [
                48.66515,
                30.3739983
              ],
              [
                48.6652114,
                30.3739555
              ],
              [
                48.6653503,
                30.3738691
              ],
              [
                48.66549,
                30.373788
              ],
              [
                48.6656208,
                30.3737166
              ],
              [
                48.6657556,
                30.3736488
              ],
              [
                48.666025,
                30.373513
              ],
              [
                48.6661433,
                30.3734555
              ],
              [
                48.6662003,
                30.3734363
              ],
              [
                48.666435,
                30.3733294
              ],
              [
                48.6665431,
                30.3732922
              ],
              [
                48.6666511,
                30.3732691
              ],
              [
                48.6666958,
                30.3732678
              ],
              [
                48.6667242,
                30.3732669
              ],
              [
                48.6667522,
                30.3732674
              ],
              [
                48.6668075,
                30.3732683
              ],
              [
                48.6668079,
                30.3732683
              ],
              [
                48.6668086,
                30.3732683
              ],
              [
                48.6668551,
                30.3732728
              ],
              [
                48.6668694,
                30.3732742
              ],
              [
                48.6669867,
                30.3734149
              ],
              [
                48.6670547,
                30.3734964
              ],
              [
                48.6670549,
                30.3734986
              ],
              [
                48.6670568,
                30.3735253
              ],
              [
                48.6670592,
                30.3735589
              ],
              [
                48.6670589,
                30.3735687
              ],
              [
                48.6670578,
                30.3736197
              ],
              [
                48.6670555,
                30.3736723
              ],
              [
                48.6670553,
                30.3736781
              ],
              [
                48.6670406,
                30.3737333
              ],
              [
                48.6670403,
                30.3737337
              ],
              [
                48.6670117,
                30.3737808
              ],
              [
                48.6669667,
                30.3738078
              ],
              [
                48.666914,
                30.3738155
              ],
              [
                48.6669139,
                30.3738156
              ],
              [
                48.6669128,
                30.3738155
              ],
              [
                48.6669081,
                30.3738153
              ],
              [
                48.666907,
                30.3738153
              ],
              [
                48.66679,
                30.3738111
              ],
              [
                48.66667,
                30.3738094
              ],
              [
                48.6665967,
                30.3738294
              ],
              [
                48.6665643,
                30.3738579
              ],
              [
                48.6665558,
                30.3738653
              ],
              [
                48.6665466,
                30.3738842
              ],
              [
                48.6665042,
                30.3739706
              ],
              [
                48.6664936,
                30.3740172
              ],
              [
                48.6665036,
                30.3742703
              ],
              [
                48.6663511,
                30.3745197
              ],
              [
                48.6663269,
                30.3745641
              ],
              [
                48.6663233,
                30.3745706
              ],
              [
                48.666322,
                30.3745808
              ],
              [
                48.6663167,
                30.3746217
              ],
              [
                48.6663257,
                30.3746515
              ],
              [
                48.6663306,
                30.3746675
              ],
              [
                48.6663617,
                30.3747072
              ],
              [
                48.6664214,
                30.3747561
              ],
              [
                48.6664581,
                30.3747733
              ],
              [
                48.6664731,
                30.3747803
              ],
              [
                48.6664749,
                30.3747805
              ],
              [
                48.6665319,
                30.3747869
              ],
              [
                48.6666097,
                30.3747693
              ],
              [
                48.6666428,
                30.3747619
              ],
              [
                48.6666827,
                30.3747428
              ],
              [
                48.6666897,
                30.3747394
              ],
              [
                48.6667247,
                30.3746902
              ],
              [
                48.6667242,
                30.3746875
              ],
              [
                48.666716,
                30.3746288
              ],
              [
                48.6667075,
                30.3745686
              ],
              [
                48.6666988,
                30.3745403
              ],
              [
                48.6666906,
                30.3745138
              ],
              [
                48.6666547,
                30.3744122
              ],
              [
                48.666645,
                30.3743672
              ],
              [
                48.6666459,
                30.3743327
              ],
              [
                48.6666467,
                30.3742994
              ],
              [
                48.6666754,
                30.3742408
              ],
              [
                48.6666911,
                30.3742088
              ],
              [
                48.6667281,
                30.3741569
              ],
              [
                48.6667711,
                30.3741061
              ],
              [
                48.6667716,
                30.3741056
              ],
              [
                48.6667725,
                30.3741047
              ],
              [
                48.6668172,
                30.3740608
              ],
              [
                48.6668675,
                30.3740197
              ],
              [
                48.6671014,
                30.3738827
              ],
              [
                48.6671439,
                30.3738328
              ],
              [
                48.6671464,
                30.37383
              ],
              [
                48.6671493,
                30.3738257
              ],
              [
                48.6671856,
                30.3737722
              ],
              [
                48.6672094,
                30.3737237
              ],
              [
                48.6672145,
                30.3737133
              ],
              [
                48.6672303,
                30.37365
              ],
              [
                48.6672181,
                30.3735124
              ],
              [
                48.6672165,
                30.373504
              ],
              [
                48.6672045,
                30.3734408
              ],
              [
                48.6671739,
                30.3733138
              ],
              [
                48.6671486,
                30.3732016
              ],
              [
                48.6671508,
                30.373155
              ],
              [
                48.6671918,
                30.3730995
              ],
              [
                48.6671955,
                30.3730943
              ],
              [
                48.6671961,
                30.3730936
              ],
              [
                48.6673033,
                30.3730449
              ],
              [
                48.6673747,
                30.3730172
              ],
              [
                48.6675195,
                30.3729677
              ],
              [
                48.6675928,
                30.372948
              ],
              [
                48.6677086,
                30.372918
              ],
              [
                48.6677322,
                30.3729119
              ],
              [
                48.6677585,
                30.3729054
              ],
              [
                48.6678778,
                30.3728758
              ],
              [
                48.6679765,
                30.3728537
              ],
              [
                48.6680233,
                30.3728433
              ],
              [
                48.6680495,
                30.3728393
              ],
              [
                48.6681406,
                30.3728255
              ],
              [
                48.6681934,
                30.372823
              ],
              [
                48.6682533,
                30.3728119
              ],
              [
                48.6684825,
                30.3727727
              ],
              [
                48.6686289,
                30.3727536
              ],
              [
                48.6687756,
                30.3727272
              ],
              [
                48.6688314,
                30.3727194
              ],
              [
                48.6689248,
                30.3726982
              ],
              [
                48.6689403,
                30.3726947
              ],
              [
                48.6689538,
                30.3726922
              ],
              [
                48.6690158,
                30.3726811
              ],
              [
                48.6691437,
                30.3726601
              ],
              [
                48.6691664,
                30.3726563
              ],
              [
                48.6692406,
                30.3726452
              ],
              [
                48.6692778,
                30.3726425
              ],
              [
                48.6693158,
                30.3726397
              ],
              [
                48.6693491,
                30.3726364
              ],
              [
                48.6693758,
                30.3726338
              ],
              [
                48.6694548,
                30.3726282
              ],
              [
                48.6695008,
                30.372625
              ],
              [
                48.669625,
                30.3726125
              ],
              [
                48.669737,
                30.3725972
              ],
              [
                48.6699089,
                30.3725755
              ],
              [
                48.6699739,
                30.3725705
              ],
              [
                48.6700931,
                30.3725616
              ],
              [
                48.6702082,
                30.3725553
              ],
              [
                48.6702395,
                30.3725536
              ],
              [
                48.670294,
                30.372546
              ],
              [
                48.6702995,
                30.3725452
              ],
              [
                48.670362,
                30.3725389
              ],
              [
                48.670447,
                30.3725302
              ],
              [
                48.6704531,
                30.3725297
              ],
              [
                48.6705161,
                30.3725244
              ],
              [
                48.6705883,
                30.3725197
              ],
              [
                48.6707306,
                30.3725161
              ],
              [
                48.6708374,
                30.3725126
              ],
              [
                48.6708678,
                30.3725116
              ],
              [
                48.6708988,
                30.37251
              ],
              [
                48.6710011,
                30.3725047
              ],
              [
                48.6717651,
                30.3720872
              ],
              [
                48.6726549,
                30.3717952
              ],
              [
                48.674796,
                30.3715583
              ],
              [
                48.6768393,
                30.3711278
              ],
              [
                48.6776167,
                30.3710947
              ],
              [
                48.677933,
                30.3710812
              ],
              [
                48.6782414,
                30.370995
              ],
              [
                48.679541,
                30.3706316
              ],
              [
                48.6806512,
                30.370302
              ],
              [
                48.681846,
                30.3694558
              ],
              [
                48.6823088,
                30.3690032
              ],
              [
                48.6828886,
                30.3684138
              ],
              [
                48.6832483,
                30.3679268
              ],
              [
                48.6833624,
                30.3677724
              ],
              [
                48.6833656,
                30.3677688
              ],
              [
                48.6840049,
                30.3670439
              ],
              [
                48.684887,
                30.3659475
              ],
              [
                48.6861856,
                30.3642545
              ],
              [
                48.6867709,
                30.3635708
              ],
              [
                48.6874678,
                30.3628446
              ],
              [
                48.6881673,
                30.3620712
              ],
              [
                48.6889867,
                30.361114
              ],
              [
                48.6896291,
                30.3603854
              ],
              [
                48.6904456,
                30.3594753
              ],
              [
                48.6907399,
                30.3570397
              ],
              [
                48.6907667,
                30.3570008
              ],
              [
                48.6908208,
                30.3569005
              ],
              [
                48.6908411,
                30.3568519
              ],
              [
                48.6908764,
                30.3568
              ],
              [
                48.6909667,
                30.3567091
              ],
              [
                48.6910833,
                30.356505
              ],
              [
                48.6911239,
                30.3564502
              ],
              [
                48.6911864,
                30.3563622
              ],
              [
                48.6913031,
                30.3561952
              ],
              [
                48.6913445,
                30.3561294
              ],
              [
                48.6913839,
                30.3560769
              ],
              [
                48.6914211,
                30.3560394
              ],
              [
                48.691472,
                30.3559983
              ],
              [
                48.6915161,
                30.3559544
              ],
              [
                48.6916711,
                30.3557213
              ],
              [
                48.6917178,
                30.3556763
              ],
              [
                48.6917639,
                30.3556205
              ],
              [
                48.6918083,
                30.3555575
              ],
              [
                48.6918561,
                30.3554963
              ],
              [
                48.6919495,
                30.3553788
              ],
              [
                48.6919847,
                30.3553241
              ],
              [
                48.6920189,
                30.3552588
              ],
              [
                48.6920589,
                30.3551941
              ],
              [
                48.6921331,
                30.3550825
              ],
              [
                48.6921858,
                30.3550133
              ],
              [
                48.6922372,
                30.3549519
              ],
              [
                48.6922942,
                30.3548797
              ],
              [
                48.6923786,
                30.3547627
              ],
              [
                48.6924017,
                30.3547191
              ],
              [
                48.6924992,
                30.3545433
              ],
              [
                48.6925472,
                30.3544719
              ],
              [
                48.6925992,
                30.3543894
              ],
              [
                48.6926467,
                30.3543019
              ],
              [
                48.6926922,
                30.3542269
              ],
              [
                48.6927367,
                30.3541477
              ],
              [
                48.6927856,
                30.3540666
              ],
              [
                48.6929286,
                30.3538352
              ],
              [
                48.6930292,
                30.3536694
              ],
              [
                48.6931317,
                30.3535113
              ],
              [
                48.6931781,
                30.3534322
              ],
              [
                48.6932225,
                30.3533488
              ],
              [
                48.6933483,
                30.353138
              ],
              [
                48.6933933,
                30.3530533
              ],
              [
                48.6934853,
                30.3528783
              ],
              [
                48.69355,
                30.3527638
              ],
              [
                48.6935861,
                30.3526786
              ],
              [
                48.6936147,
                30.3525897
              ],
              [
                48.6936447,
                30.3524955
              ],
              [
                48.6936867,
                30.3524272
              ],
              [
                48.6938017,
                30.3522988
              ],
              [
                48.6938392,
                30.3522326
              ],
              [
                48.693847,
                30.3522188
              ],
              [
                48.6938647,
                30.3521744
              ],
              [
                48.6939739,
                30.3519016
              ],
              [
                48.6939997,
                30.3518144
              ],
              [
                48.6940797,
                30.3515852
              ],
              [
                48.6941295,
                30.3515038
              ],
              [
                48.6941856,
                30.3514222
              ],
              [
                48.6942725,
                30.3512861
              ],
              [
                48.6943117,
                30.3512069
              ],
              [
                48.6943503,
                30.3511227
              ],
              [
                48.6943986,
                30.3509977
              ],
              [
                48.6944412,
                30.3508758
              ],
              [
                48.6944545,
                30.3508377
              ],
              [
                48.6944911,
                30.3507513
              ],
              [
                48.6945364,
                30.3506669
              ],
              [
                48.6945797,
                30.3505988
              ],
              [
                48.6946158,
                30.350525
              ],
              [
                48.6946483,
                30.3504488
              ],
              [
                48.6946736,
                30.3503641
              ],
              [
                48.6946942,
                30.3502838
              ],
              [
                48.6947203,
                30.3502127
              ],
              [
                48.6947767,
                30.3500508
              ],
              [
                48.6948508,
                30.3498597
              ],
              [
                48.6948858,
                30.3497844
              ],
              [
                48.6949281,
                30.3497063
              ],
              [
                48.6950158,
                30.3495477
              ],
              [
                48.6950911,
                30.3494047
              ],
              [
                48.6951239,
                30.3493297
              ],
              [
                48.6951492,
                30.3492491
              ],
              [
                48.6952003,
                30.3491147
              ],
              [
                48.6952353,
                30.349043
              ],
              [
                48.695312,
                30.34889
              ],
              [
                48.695372,
                30.3487577
              ],
              [
                48.6954081,
                30.3486855
              ],
              [
                48.6954808,
                30.3485227
              ],
              [
                48.6955175,
                30.3484513
              ],
              [
                48.6955595,
                30.348383
              ],
              [
                48.6956031,
                30.3483061
              ],
              [
                48.6956414,
                30.3482255
              ],
              [
                48.6956889,
                30.348103
              ],
              [
                48.6957206,
                30.3480419
              ],
              [
                48.6957975,
                30.3479016
              ],
              [
                48.6958342,
                30.3478172
              ],
              [
                48.6958733,
                30.3477019
              ],
              [
                48.6959147,
                30.3475705
              ],
              [
                48.695942,
                30.3474955
              ],
              [
                48.6959964,
                30.3473522
              ],
              [
                48.696052,
                30.347213
              ],
              [
                48.6960903,
                30.347133
              ],
              [
                48.6961731,
                30.3469722
              ],
              [
                48.69624,
                30.3468291
              ],
              [
                48.696262,
                30.3467497
              ],
              [
                48.6963097,
                30.3466138
              ],
              [
                48.6963353,
                30.3465563
              ],
              [
                48.6963575,
                30.3464969
              ],
              [
                48.6963725,
                30.346438
              ],
              [
                48.69638,
                30.346378
              ],
              [
                48.696402,
                30.3462755
              ],
              [
                48.696465,
                30.3461694
              ],
              [
                48.6964906,
                30.3460727
              ],
              [
                48.6965047,
                30.3460211
              ],
              [
                48.6965595,
                30.3459152
              ],
              [
                48.6965833,
                30.3458583
              ],
              [
                48.6966628,
                30.3456736
              ],
              [
                48.696687,
                30.3456019
              ],
              [
                48.6967014,
                30.3455394
              ],
              [
                48.6967583,
                30.3452691
              ],
              [
                48.6967895,
                30.3451333
              ],
              [
                48.6968103,
                30.3450627
              ],
              [
                48.6968272,
                30.3449886
              ],
              [
                48.6968397,
                30.3449119
              ],
              [
                48.6968747,
                30.3447802
              ],
              [
                48.6968997,
                30.3447177
              ],
              [
                48.6969203,
                30.3446499
              ],
              [
                48.6969308,
                30.3445713
              ],
              [
                48.6969386,
                30.3444919
              ],
              [
                48.6969575,
                30.3443916
              ],
              [
                48.6969795,
                30.3442419
              ],
              [
                48.6969833,
                30.3441602
              ],
              [
                48.6969903,
                30.3439491
              ],
              [
                48.6969889,
                30.3438716
              ],
              [
                48.6969847,
                30.3435852
              ],
              [
                48.6969806,
                30.3433569
              ],
              [
                48.6969861,
                30.3431441
              ],
              [
                48.6969956,
                30.3430694
              ],
              [
                48.6970175,
                30.3428797
              ],
              [
                48.6970247,
                30.3427269
              ],
              [
                48.6970197,
                30.3426522
              ],
              [
                48.6970097,
                30.3425836
              ],
              [
                48.6969731,
                30.3423477
              ],
              [
                48.6969581,
                30.3422755
              ],
              [
                48.6969264,
                30.3421333
              ],
              [
                48.6969156,
                30.3420516
              ],
              [
                48.6969017,
                30.3419013
              ],
              [
                48.6968711,
                30.3417666
              ],
              [
                48.6968472,
                30.3416894
              ],
              [
                48.6967828,
                30.3414758
              ],
              [
                48.6967311,
                30.3413186
              ],
              [
                48.6967011,
                30.3412363
              ],
              [
                48.6966725,
                30.3411683
              ],
              [
                48.6966475,
                30.3410961
              ],
              [
                48.6966245,
                30.3410194
              ],
              [
                48.6966033,
                30.3409374
              ],
              [
                48.6965814,
                30.3408658
              ],
              [
                48.6965595,
                30.3408147
              ],
              [
                48.6965431,
                30.3407705
              ],
              [
                48.6965314,
                30.3406752
              ],
              [
                48.6965028,
                30.3405522
              ],
              [
                48.696477,
                30.340498
              ],
              [
                48.6964358,
                30.3403883
              ],
              [
                48.6964186,
                30.340323
              ],
              [
                48.6963778,
                30.3401811
              ],
              [
                48.6963203,
                30.3399941
              ],
              [
                48.6962945,
                30.3399132
              ],
              [
                48.6962798,
                30.3398672
              ],
              [
                48.696255,
                30.3397894
              ],
              [
                48.6962325,
                30.3397344
              ],
              [
                48.6962106,
                30.3396705
              ],
              [
                48.6961633,
                30.3395138
              ],
              [
                48.6961175,
                30.3393786
              ],
              [
                48.6960703,
                30.3392502
              ],
              [
                48.6959983,
                30.3390411
              ],
              [
                48.695992,
                30.3389897
              ],
              [
                48.6959695,
                30.33887
              ],
              [
                48.6959606,
                30.3388022
              ],
              [
                48.6959342,
                30.3386763
              ],
              [
                48.6959167,
                30.3386113
              ],
              [
                48.6958556,
                30.3383808
              ],
              [
                48.6958278,
                30.3383119
              ],
              [
                48.6957783,
                30.3381719
              ],
              [
                48.695725,
                30.338013
              ],
              [
                48.6956986,
                30.3379497
              ],
              [
                48.6956367,
                30.3378166
              ],
              [
                48.6956039,
                30.3377322
              ],
              [
                48.6955542,
                30.3375911
              ],
              [
                48.6955106,
                30.3374544
              ],
              [
                48.6954903,
                30.3373744
              ],
              [
                48.6954275,
                30.3371663
              ],
              [
                48.6953997,
                30.3370963
              ],
              [
                48.6953767,
                30.3370197
              ],
              [
                48.6953578,
                30.3369444
              ],
              [
                48.6953347,
                30.3368811
              ],
              [
                48.695302,
                30.3368219
              ],
              [
                48.6952353,
                30.336688
              ],
              [
                48.6952142,
                30.3366127
              ],
              [
                48.6952011,
                30.3365491
              ],
              [
                48.6951806,
                30.3364888
              ],
              [
                48.6951506,
                30.336423
              ],
              [
                48.6951245,
                30.3363569
              ],
              [
                48.6951028,
                30.3362905
              ],
              [
                48.6950642,
                30.3361788
              ],
              [
                48.6950242,
                30.3360786
              ],
              [
                48.694985,
                30.3359608
              ],
              [
                48.6949706,
                30.3358986
              ],
              [
                48.6949428,
                30.3358008
              ],
              [
                48.6949211,
                30.3357486
              ],
              [
                48.6948792,
                30.3356405
              ],
              [
                48.6948197,
                30.3354808
              ],
              [
                48.6947947,
                30.3354294
              ],
              [
                48.6947392,
                30.3353011
              ],
              [
                48.6946695,
                30.3351513
              ],
              [
                48.6946347,
                30.3350883
              ],
              [
                48.6945967,
                30.3350308
              ],
              [
                48.6945267,
                30.3349022
              ],
              [
                48.6944986,
                30.3348333
              ],
              [
                48.6944467,
                30.3347174
              ],
              [
                48.6943683,
                30.3345161
              ],
              [
                48.6943495,
                30.3344372
              ],
              [
                48.6943081,
                30.3343088
              ],
              [
                48.6942772,
                30.3342358
              ],
              [
                48.6942506,
                30.3341577
              ],
              [
                48.6941942,
                30.3340119
              ],
              [
                48.6941439,
                30.3338666
              ],
              [
                48.6941256,
                30.3337827
              ],
              [
                48.6940811,
                30.3336361
              ],
              [
                48.6940397,
                30.3334833
              ],
              [
                48.6940197,
                30.3333988
              ],
              [
                48.6939964,
                30.3333244
              ],
              [
                48.6939653,
                30.3332608
              ],
              [
                48.6938753,
                30.3330652
              ],
              [
                48.6938286,
                30.3329469
              ],
              [
                48.6938061,
                30.3328744
              ],
              [
                48.6937911,
                30.332798
              ],
              [
                48.6937783,
                30.3327166
              ],
              [
                48.6937489,
                30.33257
              ],
              [
                48.6937253,
                30.3324169
              ],
              [
                48.6937142,
                30.3323238
              ],
              [
                48.6936981,
                30.3322422
              ],
              [
                48.6936703,
                30.3320838
              ],
              [
                48.6936289,
                30.3318663
              ],
              [
                48.6936078,
                30.3317055
              ],
              [
                48.693602,
                30.3316122
              ],
              [
                48.6935939,
                30.3314111
              ],
              [
                48.6935847,
                30.3312791
              ],
              [
                48.6935717,
                30.3310661
              ],
              [
                48.6935697,
                30.3309747
              ],
              [
                48.6935639,
                30.3307455
              ],
              [
                48.6935531,
                30.3306638
              ],
              [
                48.6935406,
                30.330523
              ],
              [
                48.6935383,
                30.3303966
              ],
              [
                48.6935331,
                30.3301122
              ],
              [
                48.6935333,
                30.3299794
              ],
              [
                48.6935339,
                30.3296908
              ],
              [
                48.6935408,
                30.3295925
              ],
              [
                48.6935514,
                30.3294838
              ],
              [
                48.6935728,
                30.3292425
              ],
              [
                48.6935878,
                30.3290952
              ],
              [
                48.6936081,
                30.3289702
              ],
              [
                48.6936395,
                30.3287977
              ],
              [
                48.6936467,
                30.3286997
              ],
              [
                48.6936467,
                30.3286175
              ],
              [
                48.693648,
                30.3284907
              ],
              [
                48.6936483,
                30.3284527
              ],
              [
                48.6936517,
                30.3283486
              ],
              [
                48.6937153,
                30.3281172
              ],
              [
                48.6937664,
                30.3279716
              ],
              [
                48.6938022,
                30.3279011
              ],
              [
                48.6938689,
                30.3277491
              ],
              [
                48.6939,
                30.3276683
              ],
              [
                48.693987,
                30.3274383
              ],
              [
                48.6940311,
                30.327313
              ],
              [
                48.6940667,
                30.3272252
              ],
              [
                48.6941089,
                30.3271516
              ],
              [
                48.694155,
                30.3270666
              ],
              [
                48.6941953,
                30.3269788
              ],
              [
                48.6942783,
                30.3268144
              ],
              [
                48.6943308,
                30.3267377
              ],
              [
                48.6944042,
                30.3266113
              ],
              [
                48.6944492,
                30.3265202
              ],
              [
                48.694492,
                30.3264447
              ],
              [
                48.694567,
                30.3262938
              ],
              [
                48.6946008,
                30.3262088
              ],
              [
                48.6946608,
                30.3260877
              ],
              [
                48.6947036,
                30.3260105
              ],
              [
                48.6947447,
                30.3259308
              ],
              [
                48.6947842,
                30.3258458
              ],
              [
                48.6948761,
                30.3256569
              ],
              [
                48.6949214,
                30.3255816
              ],
              [
                48.6949678,
                30.3254994
              ],
              [
                48.6950397,
                30.3253819
              ],
              [
                48.6950847,
                30.3253216
              ],
              [
                48.6951109,
                30.3252736
              ],
              [
                48.6952617,
                30.325073
              ],
              [
                48.6953347,
                30.3249794
              ],
              [
                48.6953675,
                30.3249216
              ],
              [
                48.6954103,
                30.324858
              ],
              [
                48.69546,
                30.3247966
              ],
              [
                48.6955542,
                30.3246738
              ],
              [
                48.6956411,
                30.3245552
              ],
              [
                48.6956945,
                30.3244894
              ],
              [
                48.6957606,
                30.3244202
              ],
              [
                48.695822,
                30.3243458
              ],
              [
                48.6958811,
                30.3242786
              ],
              [
                48.6959439,
                30.3242141
              ],
              [
                48.6960411,
                30.3241077
              ],
              [
                48.6961458,
                30.3239958
              ],
              [
                48.696252,
                30.3238988
              ],
              [
                48.6963931,
                30.3237666
              ],
              [
                48.69646,
                30.3236952
              ],
              [
                48.6965706,
                30.3235836
              ],
              [
                48.6966092,
                30.3235516
              ],
              [
                48.6967192,
                30.3234558
              ],
              [
                48.6967229,
                30.3234523
              ],
              [
                48.696795,
                30.3233844
              ],
              [
                48.6968683,
                30.3233091
              ],
              [
                48.6969378,
                30.3232302
              ],
              [
                48.6970411,
                30.3231358
              ],
              [
                48.6971483,
                30.3230341
              ],
              [
                48.6972922,
                30.3228952
              ],
              [
                48.6974036,
                30.3228041
              ],
              [
                48.69751,
                30.3227113
              ],
              [
                48.6976228,
                30.3226094
              ],
              [
                48.6976958,
                30.3225375
              ],
              [
                48.6977739,
                30.3224708
              ],
              [
                48.6978881,
                30.3223811
              ],
              [
                48.6979658,
                30.3223124
              ],
              [
                48.6980836,
                30.3222013
              ],
              [
                48.6981586,
                30.3221238
              ],
              [
                48.6981845,
                30.3221019
              ],
              [
                48.6982403,
                30.3220772
              ],
              [
                48.6983611,
                30.3219819
              ],
              [
                48.6984167,
                30.3219305
              ],
              [
                48.6985381,
                30.32182
              ],
              [
                48.6986153,
                30.3217619
              ],
              [
                48.6987531,
                30.3216636
              ],
              [
                48.698952,
                30.3215202
              ],
              [
                48.6991806,
                30.3213583
              ],
              [
                48.6993089,
                30.3212638
              ],
              [
                48.6993503,
                30.321228
              ],
              [
                48.6994331,
                30.3211488
              ],
              [
                48.6995133,
                30.321068
              ],
              [
                48.699597,
                30.3209872
              ],
              [
                48.6996839,
                30.3209008
              ],
              [
                48.6998172,
                30.3207702
              ],
              [
                48.6999103,
                30.3206908
              ],
              [
                48.7000872,
                30.320538
              ],
              [
                48.7001703,
                30.3204624
              ],
              [
                48.7002631,
                30.3203922
              ],
              [
                48.7003589,
                30.3203272
              ],
              [
                48.7004472,
                30.3202597
              ],
              [
                48.7005311,
                30.3201897
              ],
              [
                48.7006156,
                30.3201169
              ],
              [
                48.7007061,
                30.320043
              ],
              [
                48.7008031,
                30.3199638
              ],
              [
                48.7008961,
                30.3198772
              ],
              [
                48.7009847,
                30.31979
              ],
              [
                48.7010806,
                30.3197044
              ],
              [
                48.7011831,
                30.3196238
              ],
              [
                48.7012895,
                30.3195463
              ],
              [
                48.7014489,
                30.3194297
              ],
              [
                48.7015489,
                30.319353
              ],
              [
                48.7016464,
                30.3192836
              ],
              [
                48.7017517,
                30.3192174
              ],
              [
                48.7018722,
                30.3191477
              ],
              [
                48.7019958,
                30.3190725
              ],
              [
                48.7020539,
                30.3190325
              ],
              [
                48.7021695,
                30.3189458
              ],
              [
                48.7023572,
                30.3188061
              ],
              [
                48.7024245,
                30.3187616
              ],
              [
                48.7026189,
                30.3186308
              ],
              [
                48.7026806,
                30.3185855
              ],
              [
                48.7028011,
                30.3184922
              ],
              [
                48.7029214,
                30.3184016
              ],
              [
                48.7029845,
                30.318358
              ],
              [
                48.7031158,
                30.3182708
              ],
              [
                48.7032414,
                30.3181811
              ],
              [
                48.7033517,
                30.318105
              ],
              [
                48.7034056,
                30.3180624
              ],
              [
                48.7035297,
                30.3179566
              ],
              [
                48.7036064,
                30.3178838
              ],
              [
                48.7036858,
                30.317813
              ],
              [
                48.7037695,
                30.3177447
              ],
              [
                48.7039653,
                30.3175861
              ],
              [
                48.7040222,
                30.3175444
              ],
              [
                48.7041425,
                30.3174611
              ],
              [
                48.70426,
                30.3173822
              ],
              [
                48.7043101,
                30.3173474
              ],
              [
                48.7043697,
                30.3173061
              ],
              [
                48.7044728,
                30.3172286
              ],
              [
                48.7046375,
                30.3171027
              ],
              [
                48.7048133,
                30.3169669
              ],
              [
                48.7049308,
                30.3168836
              ],
              [
                48.7050408,
                30.3167969
              ],
              [
                48.7052164,
                30.3166602
              ],
              [
                48.7053306,
                30.3165641
              ],
              [
                48.7053845,
                30.3165144
              ],
              [
                48.7054872,
                30.3164108
              ],
              [
                48.7055911,
                30.3163086
              ],
              [
                48.7056453,
                30.3162608
              ],
              [
                48.7057608,
                30.3161711
              ],
              [
                48.7058217,
                30.3161294
              ],
              [
                48.7059395,
                30.3160444
              ],
              [
                48.7060497,
                30.3159574
              ],
              [
                48.706155,
                30.3158788
              ],
              [
                48.7062686,
                30.3158055
              ],
              [
                48.706395,
                30.315733
              ],
              [
                48.7065208,
                30.3156586
              ],
              [
                48.70672,
                30.315543
              ],
              [
                48.7067945,
                30.3155038
              ],
              [
                48.7069425,
                30.3154236
              ],
              [
                48.7069837,
                30.3154019
              ],
              [
                48.7070883,
                30.3153469
              ],
              [
                48.7072992,
                30.3152338
              ],
              [
                48.7074433,
                30.31516
              ],
              [
                48.7075875,
                30.3150905
              ],
              [
                48.7078,
                30.3149866
              ],
              [
                48.7078706,
                30.3149474
              ],
              [
                48.7080911,
                30.3148272
              ],
              [
                48.7082322,
                30.314755
              ],
              [
                48.7084395,
                30.3146511
              ],
              [
                48.7085831,
                30.3145727
              ],
              [
                48.708655,
                30.31453
              ],
              [
                48.7087922,
                30.314448
              ],
              [
                48.7088639,
                30.3144133
              ],
              [
                48.7089392,
                30.3143813
              ],
              [
                48.7090192,
                30.3143511
              ],
              [
                48.7092761,
                30.3142533
              ],
              [
                48.7094408,
                30.3141855
              ],
              [
                48.7095978,
                30.3141158
              ],
              [
                48.7097558,
                30.3140488
              ],
              [
                48.7098358,
                30.3140186
              ],
              [
                48.7100022,
                30.3139597
              ],
              [
                48.7101881,
                30.3138994
              ],
              [
                48.7103681,
                30.3138438
              ],
              [
                48.7104526,
                30.3138196
              ],
              [
                48.7106264,
                30.3137697
              ],
              [
                48.7107147,
                30.3137491
              ],
              [
                48.7108892,
                30.3137119
              ],
              [
                48.711055,
                30.313678
              ],
              [
                48.7112245,
                30.3136452
              ],
              [
                48.7113967,
                30.3136088
              ],
              [
                48.7115586,
                30.3135725
              ],
              [
                48.7118878,
                30.3134988
              ],
              [
                48.7121272,
                30.3134458
              ],
              [
                48.7122056,
                30.3134319
              ],
              [
                48.7122864,
                30.3134205
              ],
              [
                48.71237,
                30.3134116
              ],
              [
                48.7124545,
                30.3134083
              ],
              [
                48.7126181,
                30.313408
              ],
              [
                48.7127725,
                30.3134125
              ],
              [
                48.712773,
                30.3134125
              ],
              [
                48.712935,
                30.3134222
              ],
              [
                48.7131011,
                30.3134347
              ],
              [
                48.7131022,
                30.3134347
              ],
              [
                48.7132511,
                30.3134419
              ],
              [
                48.7132513,
                30.3134419
              ],
              [
                48.7132522,
                30.3134419
              ],
              [
                48.7134097,
                30.3134436
              ],
              [
                48.7136556,
                30.3134436
              ],
              [
                48.7138086,
                30.3134408
              ],
              [
                48.7141175,
                30.3134369
              ],
              [
                48.7142794,
                30.3134378
              ],
              [
                48.7144308,
                30.3134367
              ],
              [
                48.7145942,
                30.3134339
              ],
              [
                48.71486,
                30.3134308
              ],
              [
                48.7150178,
                30.3134388
              ],
              [
                48.7150986,
                30.3134472
              ],
              [
                48.7152706,
                30.3134674
              ],
              [
                48.7154331,
                30.3134844
              ],
              [
                48.7155859,
                30.313498
              ],
              [
                48.7155866,
                30.313498
              ],
              [
                48.7155869,
                30.3134981
              ],
              [
                48.7156633,
                30.3134994
              ],
              [
                48.7158186,
                30.3134967
              ],
              [
                48.7158467,
                30.3134964
              ],
              [
                48.7159633,
                30.3134958
              ],
              [
                48.7160885,
                30.3134989
              ],
              [
                48.7161587,
                30.3135039
              ],
              [
                48.7162089,
                30.3135075
              ],
              [
                48.7163472,
                30.3135222
              ],
              [
                48.7164914,
                30.3135411
              ],
              [
                48.7165953,
                30.3135552
              ],
              [
                48.7166978,
                30.3135691
              ],
              [
                48.7168456,
                30.3135844
              ],
              [
                48.7170736,
                30.31361
              ],
              [
                48.7172167,
                30.3136336
              ],
              [
                48.7173545,
                30.3136583
              ],
              [
                48.7175078,
                30.31368
              ],
              [
                48.7176608,
                30.3136988
              ],
              [
                48.7178028,
                30.3137188
              ],
              [
                48.7179478,
                30.3137433
              ],
              [
                48.7182442,
                30.3137894
              ],
              [
                48.7183158,
                30.3137961
              ],
              [
                48.7183169,
                30.3137961
              ],
              [
                48.7184633,
                30.3138025
              ],
              [
                48.7184644,
                30.3138025
              ],
              [
                48.7186153,
                30.3138033
              ],
              [
                48.7187625,
                30.3138061
              ],
              [
                48.7189006,
                30.3138108
              ],
              [
                48.718901,
                30.3138108
              ],
              [
                48.7190342,
                30.3138183
              ],
              [
                48.7191672,
                30.3138277
              ],
              [
                48.7193039,
                30.3138405
              ],
              [
                48.7195033,
                30.3138613
              ],
              [
                48.7196558,
                30.3138711
              ],
              [
                48.7197608,
                30.3138836
              ],
              [
                48.7198889,
                30.3139058
              ],
              [
                48.7201008,
                30.3139505
              ],
              [
                48.7202514,
                30.3139886
              ],
              [
                48.7204047,
                30.3140255
              ],
              [
                48.7205522,
                30.3140588
              ],
              [
                48.7206933,
                30.3140924
              ],
              [
                48.7209125,
                30.3141425
              ],
              [
                48.7210506,
                30.3141708
              ],
              [
                48.7212436,
                30.3142069
              ],
              [
                48.7213839,
                30.314228
              ],
              [
                48.7215222,
                30.3142516
              ],
              [
                48.721655,
                30.3142763
              ],
              [
                48.7217881,
                30.3143027
              ],
              [
                48.7220586,
                30.3143575
              ],
              [
                48.7221906,
                30.3143811
              ],
              [
                48.7223206,
                30.3144013
              ],
              [
                48.7224603,
                30.3144177
              ],
              [
                48.7226083,
                30.3144341
              ],
              [
                48.7227489,
                30.3144513
              ],
              [
                48.7228831,
                30.3144741
              ],
              [
                48.7230275,
                30.3144949
              ],
              [
                48.7231047,
                30.3145027
              ],
              [
                48.7232581,
                30.3145125
              ],
              [
                48.7234789,
                30.3145283
              ],
              [
                48.7236353,
                30.3145419
              ],
              [
                48.7237925,
                30.3145525
              ],
              [
                48.7240178,
                30.3145683
              ],
              [
                48.7240189,
                30.3145683
              ],
              [
                48.7241633,
                30.3145747
              ],
              [
                48.7242378,
                30.3145741
              ],
              [
                48.7244386,
                30.3145705
              ],
              [
                48.7247258,
                30.3145636
              ],
              [
                48.7248078,
                30.3145583
              ],
              [
                48.7250436,
                30.3145388
              ],
              [
                48.7251186,
                30.3145258
              ],
              [
                48.7252664,
                30.3144977
              ],
              [
                48.7254892,
                30.3144513
              ],
              [
                48.7256261,
                30.314418
              ],
              [
                48.7259164,
                30.3143452
              ],
              [
                48.7259867,
                30.3143241
              ],
              [
                48.7261153,
                30.3142783
              ],
              [
                48.726175,
                30.314253
              ],
              [
                48.7262942,
                30.314195
              ],
              [
                48.7264917,
                30.3141019
              ],
              [
                48.7266178,
                30.3140463
              ],
              [
                48.7267333,
                30.3139891
              ],
              [
                48.7268367,
                30.3139324
              ],
              [
                48.7269947,
                30.3138438
              ],
              [
                48.7271028,
                30.3137805
              ],
              [
                48.7274153,
                30.3135122
              ],
              [
                48.7277889,
                30.3131977
              ],
              [
                48.7278995,
                30.3130963
              ],
              [
                48.7280053,
                30.3129933
              ],
              [
                48.7281111,
                30.3128958
              ],
              [
                48.7282203,
                30.312798
              ],
              [
                48.7282739,
                30.3127447
              ],
              [
                48.728327,
                30.3126869
              ],
              [
                48.7284256,
                30.3125697
              ],
              [
                48.7285186,
                30.3124552
              ],
              [
                48.7285995,
                30.3123463
              ],
              [
                48.72869,
                30.3122102
              ],
              [
                48.7287703,
                30.3120925
              ],
              [
                48.7288211,
                30.3120083
              ],
              [
                48.7290267,
                30.311613
              ],
              [
                48.7290495,
                30.3115566
              ],
              [
                48.7290958,
                30.3114494
              ],
              [
                48.7291722,
                30.3112819
              ],
              [
                48.7292036,
                30.3112227
              ],
              [
                48.7292722,
                30.311105
              ],
              [
                48.7293989,
                30.3108716
              ],
              [
                48.7294242,
                30.310808
              ],
              [
                48.7294714,
                30.3106808
              ],
              [
                48.7295425,
                30.31049
              ],
              [
                48.7295839,
                30.310363
              ],
              [
                48.7296228,
                30.3102341
              ],
              [
                48.7296561,
                30.3101027
              ],
              [
                48.7296984,
                30.3099727
              ],
              [
                48.7297442,
                30.3098447
              ],
              [
                48.7297847,
                30.3097061
              ],
              [
                48.7298433,
                30.3094991
              ],
              [
                48.7298825,
                30.309353
              ],
              [
                48.7299214,
                30.3092
              ],
              [
                48.7299608,
                30.3090538
              ],
              [
                48.729995,
                30.3089061
              ],
              [
                48.7300086,
                30.3088311
              ],
              [
                48.7300215,
                30.308749
              ],
              [
                48.7300325,
                30.3086788
              ],
              [
                48.7300583,
                30.3085305
              ],
              [
                48.7300836,
                30.3083702
              ],
              [
                48.7301047,
                30.3082038
              ],
              [
                48.7301211,
                30.3080458
              ],
              [
                48.7301308,
                30.3078902
              ],
              [
                48.7301456,
                30.3076608
              ],
              [
                48.7301528,
                30.3075108
              ],
              [
                48.7301645,
                30.3073544
              ],
              [
                48.7301795,
                30.307198
              ],
              [
                48.7301964,
                30.3069597
              ],
              [
                48.7302145,
                30.3067255
              ],
              [
                48.730222,
                30.306598
              ],
              [
                48.7302436,
                30.3065091
              ],
              [
                48.7302992,
                30.30606
              ],
              [
                48.7303803,
                30.3056555
              ],
              [
                48.7304911,
                30.3052352
              ],
              [
                48.7305317,
                30.3048813
              ],
              [
                48.7305075,
                30.3045816
              ],
              [
                48.7305495,
                30.3042652
              ],
              [
                48.7306386,
                30.3039019
              ],
              [
                48.7307767,
                30.303408
              ],
              [
                48.730942,
                30.3030633
              ],
              [
                48.7311074,
                30.3027299
              ],
              [
                48.731182,
                30.3025797
              ],
              [
                48.7313947,
                30.3022194
              ],
              [
                48.7316211,
                30.3018813
              ],
              [
                48.7319481,
                30.3014311
              ],
              [
                48.7323303,
                30.3009694
              ],
              [
                48.7326861,
                30.3005808
              ],
              [
                48.7329995,
                30.3002855
              ],
              [
                48.7331131,
                30.3002022
              ],
              [
                48.7331889,
                30.3001216
              ],
              [
                48.7332281,
                30.3000316
              ],
              [
                48.7337628,
                30.2996309
              ],
              [
                48.7341227,
                30.2993484
              ],
              [
                48.734512,
                30.2991025
              ],
              [
                48.734513,
                30.2991025
              ],
              [
                48.7345131,
                30.2991025
              ],
              [
                48.7348888,
                30.2991368
              ],
              [
                48.7349295,
                30.2991405
              ],
              [
                48.73493,
                30.2991406
              ],
              [
                48.7352114,
                30.2991417
              ],
              [
                48.7357811,
                30.2990208
              ],
              [
                48.7360631,
                30.2989108
              ],
              [
                48.7362975,
                30.2988042
              ],
              [
                48.7366183,
                30.2987006
              ],
              [
                48.7371169,
                30.2985847
              ],
              [
                48.7376069,
                30.2984975
              ],
              [
                48.7381392,
                30.2984444
              ],
              [
                48.7386753,
                30.2984242
              ],
              [
                48.7392575,
                30.2984075
              ],
              [
                48.7398778,
                30.2983931
              ],
              [
                48.7404844,
                30.2983914
              ],
              [
                48.7410569,
                30.2983925
              ],
              [
                48.741448,
                30.2983972
              ],
              [
                48.7421161,
                30.2984541
              ],
              [
                48.7426789,
                30.298495
              ],
              [
                48.7429904,
                30.2985294
              ],
              [
                48.7432183,
                30.2985547
              ],
              [
                48.7437881,
                30.2986083
              ],
              [
                48.7443422,
                30.2986763
              ],
              [
                48.7449072,
                30.2987513
              ],
              [
                48.7453506,
                30.2988097
              ],
              [
                48.7458436,
                30.2988405
              ],
              [
                48.7459458,
                30.2988469
              ],
              [
                48.7459469,
                30.298847
              ],
              [
                48.7465114,
                30.2988769
              ],
              [
                48.7465125,
                30.2988769
              ],
              [
                48.7470734,
                30.2989016
              ],
              [
                48.7470744,
                30.2989017
              ],
              [
                48.7476069,
                30.2989394
              ],
              [
                48.7481686,
                30.2989649
              ],
              [
                48.7481697,
                30.298965
              ],
              [
                48.7487735,
                30.2990108
              ],
              [
                48.7487736,
                30.2990108
              ],
              [
                48.7493461,
                30.2990338
              ],
              [
                48.7493472,
                30.2990339
              ],
              [
                48.7499314,
                30.2990636
              ],
              [
                48.7500003,
                30.2990677
              ],
              [
                48.7505022,
                30.2990969
              ],
              [
                48.7505033,
                30.299097
              ],
              [
                48.7509867,
                30.2991211
              ],
              [
                48.7514408,
                30.2991638
              ],
              [
                48.7514418,
                30.2991639
              ],
              [
                48.7514419,
                30.2991639
              ],
              [
                48.7520272,
                30.2991861
              ],
              [
                48.7520283,
                30.2991861
              ],
              [
                48.7525567,
                30.2991967
              ],
              [
                48.7531067,
                30.299195
              ],
              [
                48.753637,
                30.2992155
              ],
              [
                48.7536381,
                30.2992156
              ],
              [
                48.7538703,
                30.299226
              ],
              [
                48.7542078,
                30.2992411
              ],
              [
                48.7542079,
                30.2992411
              ],
              [
                48.7542089,
                30.2992411
              ],
              [
                48.7547364,
                30.299255
              ],
              [
                48.7552794,
                30.2992611
              ],
              [
                48.7558247,
                30.2992767
              ],
              [
                48.7564136,
                30.299275
              ],
              [
                48.7569892,
                30.2992828
              ],
              [
                48.7575833,
                30.2992811
              ],
              [
                48.7577464,
                30.2992767
              ],
              [
                48.7582517,
                30.2992631
              ],
              [
                48.7588281,
                30.2992536
              ],
              [
                48.7594386,
                30.2992511
              ],
              [
                48.7599983,
                30.2992531
              ],
              [
                48.7611375,
                30.2992439
              ],
              [
                48.7617403,
                30.2992225
              ],
              [
                48.7623392,
                30.2992072
              ],
              [
                48.76293,
                30.2992039
              ],
              [
                48.7634714,
                30.2991947
              ],
              [
                48.7639919,
                30.2991889
              ],
              [
                48.7646056,
                30.2991856
              ],
              [
                48.7651289,
                30.2991822
              ],
              [
                48.7654125,
                30.2991775
              ],
              [
                48.7657436,
                30.2991719
              ],
              [
                48.7662886,
                30.2991594
              ],
              [
                48.766885,
                30.2991208
              ],
              [
                48.7674131,
                30.299105
              ],
              [
                48.7679664,
                30.2991022
              ],
              [
                48.7685483,
                30.2990792
              ],
              [
                48.7690694,
                30.2990597
              ],
              [
                48.7696336,
                30.2990572
              ],
              [
                48.7702431,
                30.2990722
              ],
              [
                48.7708456,
                30.2990839
              ],
              [
                48.7714022,
                30.2990872
              ],
              [
                48.7719358,
                30.2990942
              ],
              [
                48.7726064,
                30.2991316
              ],
              [
                48.7726075,
                30.2991317
              ],
              [
                48.7731631,
                30.2991605
              ],
              [
                48.77366,
                30.2992016
              ],
              [
                48.7736607,
                30.2992016
              ],
              [
                48.7742881,
                30.2992122
              ],
              [
                48.7742892,
                30.2992122
              ],
              [
                48.7747789,
                30.299238
              ],
              [
                48.774779,
                30.299238
              ],
              [
                48.77478,
                30.2992381
              ],
              [
                48.7753639,
                30.2992225
              ],
              [
                48.7756483,
                30.2992186
              ],
              [
                48.7756489,
                30.2992186
              ],
              [
                48.7762519,
                30.2992803
              ],
              [
                48.7768186,
                30.2993533
              ],
              [
                48.7773675,
                30.2994028
              ],
              [
                48.7778889,
                30.2994317
              ],
              [
                48.7784525,
                30.2994706
              ],
              [
                48.7789994,
                30.2995378
              ],
              [
                48.7796739,
                30.2996033
              ],
              [
                48.7802664,
                30.2996839
              ],
              [
                48.7807567,
                30.2997658
              ],
              [
                48.7813639,
                30.2999022
              ],
              [
                48.7819478,
                30.3000594
              ],
              [
                48.7822217,
                30.3001294
              ],
              [
                48.7828461,
                30.3002133
              ],
              [
                48.7831442,
                30.3002536
              ],
              [
                48.7836889,
                30.3004064
              ],
              [
                48.7842603,
                30.3005628
              ],
              [
                48.7847481,
                30.3007092
              ],
              [
                48.7851886,
                30.3008058
              ],
              [
                48.7855003,
                30.3008553
              ],
              [
                48.7860022,
                30.3010442
              ],
              [
                48.7865422,
                30.3012278
              ],
              [
                48.7870942,
                30.3014267
              ],
              [
                48.7875792,
                30.3016172
              ],
              [
                48.7880706,
                30.3018206
              ],
              [
                48.7886008,
                30.3020408
              ],
              [
                48.7891442,
                30.3022678
              ],
              [
                48.7895186,
                30.3024453
              ],
              [
                48.7899869,
                30.3026308
              ],
              [
                48.79048,
                30.3028044
              ],
              [
                48.7907353,
                30.3028983
              ],
              [
                48.7911886,
                30.3031658
              ],
              [
                48.7916439,
                30.3034297
              ],
              [
                48.792155,
                30.3036872
              ],
              [
                48.7924667,
                30.3038347
              ],
              [
                48.7929772,
                30.3041517
              ],
              [
                48.7933697,
                30.3044117
              ],
              [
                48.7936717,
                30.3045844
              ],
              [
                48.7941508,
                30.3049189
              ],
              [
                48.7945242,
                30.3051892
              ],
              [
                48.7948214,
                30.3054317
              ],
              [
                48.7952683,
                30.3057467
              ],
              [
                48.7957258,
                30.3060622
              ],
              [
                48.7961008,
                30.3063225
              ],
              [
                48.7965125,
                30.3066367
              ],
              [
                48.7969044,
                30.3069628
              ],
              [
                48.7973536,
                30.3073372
              ],
              [
                48.7976217,
                30.3075536
              ],
              [
                48.7979508,
                30.3078667
              ],
              [
                48.7983697,
                30.308225
              ],
              [
                48.7984536,
                30.3082794
              ],
              [
                48.7984839,
                30.3083053
              ],
              [
                48.7985433,
                30.3083569
              ],
              [
                48.7986067,
                30.3084128
              ],
              [
                48.7986403,
                30.3084422
              ],
              [
                48.7986753,
                30.3084717
              ],
              [
                48.79871,
                30.3084992
              ],
              [
                48.7987433,
                30.3085267
              ],
              [
                48.7987736,
                30.3085533
              ],
              [
                48.7988006,
                30.3085792
              ],
              [
                48.7988261,
                30.3086033
              ],
              [
                48.7988483,
                30.3086247
              ],
              [
                48.7988669,
                30.3086417
              ],
              [
                48.7988928,
                30.3086728
              ],
              [
                48.7989036,
                30.3086844
              ],
              [
                48.7989175,
                30.3086978
              ],
              [
                48.7989628,
                30.3087433
              ],
              [
                48.7989922,
                30.3087717
              ],
              [
                48.7990614,
                30.3088378
              ],
              [
                48.7990986,
                30.3088733
              ],
              [
                48.799135,
                30.3089089
              ],
              [
                48.7991694,
                30.3089428
              ],
              [
                48.7992036,
                30.3089767
              ],
              [
                48.7992375,
                30.3090106
              ],
              [
                48.7992703,
                30.3090453
              ],
              [
                48.7993033,
                30.3090811
              ],
              [
                48.7993678,
                30.3091578
              ],
              [
                48.7993994,
                30.3091944
              ],
              [
                48.7994303,
                30.3092319
              ],
              [
                48.7994617,
                30.3092667
              ],
              [
                48.7994922,
                30.3093025
              ],
              [
                48.7995225,
                30.3093364
              ],
              [
                48.7995539,
                30.3093694
              ],
              [
                48.7995833,
                30.3094025
              ],
              [
                48.7996117,
                30.3094372
              ],
              [
                48.7996406,
                30.3094731
              ],
              [
                48.7996703,
                30.3095122
              ],
              [
                48.7996994,
                30.3095517
              ],
              [
                48.7997292,
                30.3095892
              ],
              [
                48.7997597,
                30.3096247
              ],
              [
                48.79979,
                30.3096597
              ],
              [
                48.7998206,
                30.3096936
              ],
              [
                48.7998819,
                30.3097606
              ],
              [
                48.7999131,
                30.3097972
              ],
              [
                48.7999453,
                30.3098336
              ],
              [
                48.7999786,
                30.3098719
              ],
              [
                48.8000122,
                30.3099094
              ],
              [
                48.8000456,
                30.3099461
              ],
              [
                48.8000794,
                30.30998
              ],
              [
                48.8001119,
                30.3100139
              ],
              [
                48.8001444,
                30.3100478
              ],
              [
                48.8001772,
                30.3100817
              ],
              [
                48.8002097,
                30.3101128
              ],
              [
                48.8002422,
                30.310145
              ],
              [
                48.8002744,
                30.3101761
              ],
              [
                48.8003064,
                30.3102072
              ],
              [
                48.8003367,
                30.3102367
              ],
              [
                48.8003642,
                30.3102642
              ],
              [
                48.8003892,
                30.3102903
              ],
              [
                48.8004089,
                30.3103133
              ],
              [
                48.8004456,
                30.3103653
              ],
              [
                48.8004478,
                30.3103706
              ],
              [
                48.80046,
                30.3103822
              ],
              [
                48.8004814,
                30.3104053
              ],
              [
                48.8005097,
                30.3104367
              ],
              [
                48.8005422,
                30.3104722
              ],
              [
                48.8005783,
                30.3105142
              ],
              [
                48.8006153,
                30.3105589
              ],
              [
                48.8006511,
                30.3106053
              ],
              [
                48.8006858,
                30.31065
              ],
              [
                48.8007211,
                30.3106956
              ],
              [
                48.8007581,
                30.3107403
              ],
              [
                48.8007944,
                30.3107842
              ],
              [
                48.8008311,
                30.3108269
              ],
              [
                48.8008672,
                30.3108717
              ],
              [
                48.8009017,
                30.3109208
              ],
              [
                48.8009372,
                30.3109717
              ],
              [
                48.8009731,
                30.3110208
              ],
              [
                48.8010092,
                30.3110692
              ],
              [
                48.801045,
                30.3111156
              ],
              [
                48.8010811,
                30.3111622
              ],
              [
                48.8011172,
                30.3112114
              ],
              [
                48.8011544,
                30.3112614
              ],
              [
                48.8011936,
                30.3113142
              ],
              [
                48.8012342,
                30.311365
              ],
              [
                48.8012725,
                30.3114133
              ],
              [
                48.8013086,
                30.3114597
              ],
              [
                48.8013442,
                30.3115069
              ],
              [
                48.8013803,
                30.3115536
              ],
              [
                48.8014183,
                30.3116017
              ],
              [
                48.8014569,
                30.3116519
              ],
              [
                48.8014942,
                30.3117019
              ],
              [
                48.8015308,
                30.3117503
              ],
              [
                48.8015672,
                30.3117967
              ],
              [
                48.8016044,
                30.3118422
              ],
              [
                48.8016431,
                30.3118894
              ],
              [
                48.8016811,
                30.3119378
              ],
              [
                48.8017178,
                30.3119897
              ],
              [
                48.8017542,
                30.3120442
              ],
              [
                48.8017917,
                30.3120961
              ],
              [
                48.8018281,
                30.3121469
              ],
              [
                48.8018642,
                30.3121972
              ],
              [
                48.8018994,
                30.3122464
              ],
              [
                48.8019361,
                30.3122964
              ],
              [
                48.8019725,
                30.3123483
              ],
              [
                48.80201,
                30.3124028
              ],
              [
                48.8020478,
                30.3124547
              ],
              [
                48.8020858,
                30.3125039
              ],
              [
                48.8021242,
                30.3125528
              ],
              [
                48.8021606,
                30.3126003
              ],
              [
                48.8021969,
                30.3126494
              ],
              [
                48.8022339,
                30.3127022
              ],
              [
                48.8022706,
                30.3127558
              ],
              [
                48.8023058,
                30.3128086
              ],
              [
                48.8023394,
                30.3128597
              ],
              [
                48.8023722,
                30.3129089
              ],
              [
                48.8024058,
                30.3129572
              ],
              [
                48.8024411,
                30.3130044
              ],
              [
                48.8024775,
                30.3130547
              ],
              [
                48.8025142,
                30.3131064
              ],
              [
                48.8025486,
                30.3131575
              ],
              [
                48.8025811,
                30.3132058
              ],
              [
                48.8026147,
                30.3132522
              ],
              [
                48.8026483,
                30.3132989
              ],
              [
                48.8026819,
                30.3133453
              ],
              [
                48.8027158,
                30.3133936
              ],
              [
                48.8027492,
                30.3134436
              ],
              [
                48.8027831,
                30.3134956
              ],
              [
                48.8028164,
                30.3135456
              ],
              [
                48.8028503,
                30.3135947
              ],
              [
                48.8028847,
                30.3136422
              ],
              [
                48.8029194,
                30.3136878
              ],
              [
                48.8029533,
                30.3137361
              ],
              [
                48.8029858,
                30.3137861
              ],
              [
                48.8030172,
                30.3138381
              ],
              [
                48.8030497,
                30.3138883
              ],
              [
                48.8030828,
                30.3139367
              ],
              [
                48.8031153,
                30.3139839
              ],
              [
                48.8031467,
                30.3140306
              ],
              [
                48.8031772,
                30.3140769
              ],
              [
                48.8032067,
                30.3141264
              ],
              [
                48.8032353,
                30.3141764
              ],
              [
                48.8032639,
                30.3142256
              ],
              [
                48.8032931,
                30.3142731
              ],
              [
                48.8033211,
                30.3143189
              ],
              [
                48.8033492,
                30.3143636
              ],
              [
                48.8033761,
                30.3144064
              ],
              [
                48.8034011,
                30.3144503
              ],
              [
                48.8034253,
                30.3144969
              ],
              [
                48.8034506,
                30.3145464
              ],
              [
                48.8034775,
                30.3145928
              ],
              [
                48.8035047,
                30.3146386
              ],
              [
                48.8035597,
                30.3147236
              ],
              [
                48.8035864,
                30.3147628
              ],
              [
                48.8036131,
                30.3148022
              ],
              [
                48.8036403,
                30.3148442
              ],
              [
                48.8036669,
                30.3148872
              ],
              [
                48.8036925,
                30.3149303
              ],
              [
                48.8037183,
                30.3149706
              ],
              [
                48.8037747,
                30.3150439
              ],
              [
                48.8038053,
                30.3150794
              ],
              [
                48.8038361,
                30.3151125
              ],
              [
                48.8038667,
                30.3151464
              ],
              [
                48.8038969,
                30.3151822
              ],
              [
                48.8039272,
                30.3152186
              ],
              [
                48.8039553,
                30.3152572
              ],
              [
                48.8039811,
                30.3152931
              ],
              [
                48.8040028,
                30.3153242
              ],
              [
                48.8040322,
                30.3153672
              ],
              [
                48.8041058,
                30.3154858
              ],
              [
                48.8043136,
                30.3158197
              ],
              [
                48.8045328,
                30.3162344
              ],
              [
                48.8047972,
                30.3166981
              ],
              [
                48.8050375,
                30.3171028
              ],
              [
                48.8053178,
                30.3176303
              ],
              [
                48.80555,
                30.3180367
              ],
              [
                48.805865,
                30.3185519
              ],
              [
                48.8061081,
                30.3189978
              ],
              [
                48.8063208,
                30.3194622
              ],
              [
                48.8065447,
                30.3198967
              ],
              [
                48.8067544,
                30.3203422
              ],
              [
                48.8070011,
                30.3207844
              ],
              [
                48.8071511,
                30.3211106
              ],
              [
                48.8073992,
                30.3216008
              ],
              [
                48.8076231,
                30.3220269
              ],
              [
                48.8078806,
                30.3224656
              ],
              [
                48.8078917,
                30.3224844
              ],
              [
                48.8081353,
                30.3229447
              ],
              [
                48.8083697,
                30.3233808
              ],
              [
                48.8086092,
                30.3238089
              ],
              [
                48.8088839,
                30.3242508
              ],
              [
                48.8091664,
                30.32468
              ],
              [
                48.8094806,
                30.3251044
              ],
              [
                48.8097639,
                30.3255147
              ],
              [
                48.8100992,
                30.3259847
              ],
              [
                48.8104206,
                30.3263947
              ],
              [
                48.810735,
                30.3267956
              ],
              [
                48.8110672,
                30.3271694
              ],
              [
                48.8113517,
                30.3274533
              ],
              [
                48.8116844,
                30.3277369
              ],
              [
                48.812105,
                30.3280736
              ],
              [
                48.8125264,
                30.3284183
              ],
              [
                48.8128914,
                30.3286717
              ],
              [
                48.8133225,
                30.3290019
              ],
              [
                48.8137925,
                30.3293433
              ],
              [
                48.8140886,
                30.3294983
              ],
              [
                48.8145556,
                30.3297775
              ],
              [
                48.8150214,
                30.3300811
              ],
              [
                48.815455,
                30.3303403
              ],
              [
                48.8157457,
                30.3305134
              ],
              [
                48.8167664,
                30.3310303
              ],
              [
                48.8171528,
                30.3311689
              ],
              [
                48.8175381,
                30.3312806
              ],
              [
                48.8181178,
                30.3314342
              ],
              [
                48.8186836,
                30.33155
              ],
              [
                48.8192514,
                30.3316369
              ],
              [
                48.8198572,
                30.3317108
              ],
              [
                48.8204581,
                30.3317786
              ],
              [
                48.8210692,
                30.3318228
              ],
              [
                48.8215706,
                30.3318303
              ],
              [
                48.8221789,
                30.3318906
              ],
              [
                48.8227714,
                30.3319583
              ],
              [
                48.8233592,
                30.3320125
              ],
              [
                48.8239742,
                30.3320747
              ],
              [
                48.8244856,
                30.3321019
              ],
              [
                48.8251036,
                30.3321369
              ],
              [
                48.8255228,
                30.3321336
              ],
              [
                48.8260714,
                30.3321281
              ],
              [
                48.8264089,
                30.3321547
              ],
              [
                48.8269197,
                30.3321503
              ],
              [
                48.8274572,
                30.3321258
              ],
              [
                48.8280022,
                30.3320878
              ],
              [
                48.8284386,
                30.3320331
              ],
              [
                48.8289811,
                30.33196
              ],
              [
                48.8294069,
                30.3319261
              ],
              [
                48.8297769,
                30.3318857
              ],
              [
                48.8299353,
                30.3318683
              ],
              [
                48.8304958,
                30.3318058
              ],
              [
                48.8310503,
                30.3317406
              ],
              [
                48.8316119,
                30.3316608
              ],
              [
                48.8321667,
                30.3315911
              ],
              [
                48.8327092,
                30.3315242
              ],
              [
                48.8329936,
                30.3314486
              ],
              [
                48.8335211,
                30.3313469
              ],
              [
                48.8340439,
                30.3312506
              ],
              [
                48.8345267,
                30.3311833
              ],
              [
                48.8351233,
                30.3310769
              ],
              [
                48.8355089,
                30.3309761
              ],
              [
                48.8360908,
                30.3308275
              ],
              [
                48.8363239,
                30.3307697
              ],
              [
                48.8364286,
                30.3307675
              ],
              [
                48.8365697,
                30.3307392
              ],
              [
                48.8367806,
                30.3307442
              ],
              [
                48.8373631,
                30.3305561
              ],
              [
                48.8378553,
                30.3303994
              ],
              [
                48.8380553,
                30.3303347
              ],
              [
                48.8383903,
                30.3302267
              ],
              [
                48.8385078,
                30.3301422
              ],
              [
                48.8387803,
                30.3300522
              ],
              [
                48.8397353,
                30.3296564
              ],
              [
                48.8402717,
                30.3294286
              ],
              [
                48.8408161,
                30.3292094
              ],
              [
                48.8413708,
                30.3289767
              ],
              [
                48.8417781,
                30.3287831
              ],
              [
                48.8421717,
                30.3285597
              ],
              [
                48.8427081,
                30.3282533
              ],
              [
                48.8430978,
                30.3280011
              ],
              [
                48.8436383,
                30.3276775
              ],
              [
                48.8441653,
                30.3273719
              ],
              [
                48.8442667,
                30.3272556
              ],
              [
                48.8444197,
                30.3271619
              ],
              [
                48.8447067,
                30.3270519
              ],
              [
                48.8452228,
                30.3267289
              ],
              [
                48.8457392,
                30.3263967
              ],
              [
                48.8462572,
                30.3260364
              ],
              [
                48.8467947,
                30.3256722
              ],
              [
                48.8473347,
                30.3253294
              ],
              [
                48.8477192,
                30.3250514
              ],
              [
                48.8482125,
                30.32467
              ],
              [
                48.8485914,
                30.3244044
              ],
              [
                48.8491436,
                30.3240381
              ],
              [
                48.8494008,
                30.3238292
              ],
              [
                48.8497986,
                30.3235336
              ],
              [
                48.8500087,
                30.3233946
              ],
              [
                48.8502106,
                30.3232611
              ],
              [
                48.8507539,
                30.3228942
              ],
              [
                48.8511439,
                30.3226075
              ],
              [
                48.8515864,
                30.322265
              ],
              [
                48.8520553,
                30.3219239
              ],
              [
                48.8524178,
                30.3216931
              ],
              [
                48.8529042,
                30.3213731
              ],
              [
                48.8534094,
                30.3210364
              ],
              [
                48.8539189,
                30.32067
              ],
              [
                48.8544461,
                30.3203278
              ],
              [
                48.8549725,
                30.3199789
              ],
              [
                48.8553433,
                30.3196892
              ],
              [
                48.8557347,
                30.3194153
              ],
              [
                48.8562586,
                30.3190586
              ],
              [
                48.8566519,
                30.3187658
              ],
              [
                48.8571614,
                30.3184083
              ],
              [
                48.8576522,
                30.3180503
              ],
              [
                48.8581453,
                30.3176608
              ],
              [
                48.8586414,
                30.3172972
              ],
              [
                48.8590019,
                30.3170864
              ],
              [
                48.8593283,
                30.3168417
              ],
              [
                48.8598239,
                30.3164981
              ],
              [
                48.8602333,
                30.3162564
              ],
              [
                48.8604958,
                30.3160536
              ],
              [
                48.8606147,
                30.3159256
              ],
              [
                48.8610139,
                30.3156653
              ],
              [
                48.8611492,
                30.3155533
              ],
              [
                48.8614267,
                30.3154072
              ],
              [
                48.8619492,
                30.3150658
              ],
              [
                48.8620042,
                30.3149756
              ],
              [
                48.8624781,
                30.3147289
              ],
              [
                48.8629125,
                30.3144194
              ],
              [
                48.8629936,
                30.3144244
              ],
              [
                48.8633589,
                30.3141569
              ],
              [
                48.8635297,
                30.3141225
              ],
              [
                48.8640392,
                30.3138147
              ],
              [
                48.8642055,
                30.3137285
              ],
              [
                48.8644425,
                30.3136056
              ],
              [
                48.8648325,
                30.3133553
              ],
              [
                48.8650864,
                30.3131167
              ],
              [
                48.9604629,
                30.2889534
              ],
              [
                49.0570309,
                30.2644821
              ],
              [
                49.0431658,
                30.324714
              ],
              [
                49.0290696,
                30.3859119
              ],
              [
                49.0149354,
                30.4472364
              ],
              [
                49.0008314,
                30.5083913
              ],
              [
                48.9980991,
                30.5163015
              ],
              [
                48.9980272,
                30.5165095
              ],
              [
                48.9978318,
                30.5170752
              ],
              [
                48.9792189,
                30.5548507
              ],
              [
                48.9733855,
                30.5667989
              ],
              [
                48.9653288,
                30.5754082
              ],
              [
                48.9647756,
                30.5756879
              ],
              [
                48.9644955,
                30.5762384
              ],
              [
                48.9644955,
                30.5762385
              ],
              [
                48.957829,
                30.5815177
              ],
              [
                48.9569958,
                30.582348
              ],
              [
                48.9239395,
                30.6151251
              ],
              [
                48.9228294,
                30.6162442
              ],
              [
                48.919216,
                30.6231841
              ],
              [
                48.9189395,
                30.6254042
              ],
              [
                48.9192161,
                30.6276334
              ],
              [
                48.9228294,
                30.6343026
              ],
              [
                48.9228294,
                30.6345823
              ],
              [
                48.9242161,
                30.636243
              ],
              [
                48.9278295,
                30.6395731
              ],
              [
                48.9433855,
                30.6709705
              ],
              [
                48.946439,
                30.6834701
              ],
              [
                48.9483856,
                30.69319
              ],
              [
                48.9486621,
                30.6959608
              ],
              [
                48.9492188,
                30.7012494
              ],
              [
                48.9447324,
                30.7269978
              ],
              [
                48.9515488,
                30.7469156
              ],
              [
                48.954833,
                30.7556475
              ],
              [
                48.9572136,
                30.7632049
              ],
              [
                48.9588028,
                30.767316
              ],
              [
                48.9599104,
                30.770994
              ],
              [
                48.9655457,
                30.7893788
              ],
              [
                48.9697362,
                30.803879
              ],
              [
                48.9726258,
                30.8153408
              ],
              [
                48.9743443,
                30.8204956
              ],
              [
                48.976595,
                30.8275185
              ],
              [
                48.9782601,
                30.8339509
              ],
              [
                48.9809932,
                30.8425718
              ],
              [
                48.9828721,
                30.8495898
              ],
              [
                48.9843922,
                30.8610368
              ],
              [
                48.9856732,
                30.8699822
              ],
              [
                48.9864253,
                30.8743964
              ],
              [
                48.9866264,
                30.8770439
              ],
              [
                48.988634,
                30.8841133
              ],
              [
                48.989977,
                30.8910843
              ],
              [
                48.9910927,
                30.8956952
              ],
              [
                48.9792442,
                30.8883647
              ],
              [
                48.9717722,
                30.8837377
              ],
              [
                48.9602221,
                30.8789157
              ],
              [
                48.9522077,
                30.8759631
              ],
              [
                48.9408416,
                30.8705033
              ],
              [
                48.9321707,
                30.8668323
              ],
              [
                48.9186335,
                30.8647514
              ],
              [
                48.9130783,
                30.863592
              ],
              [
                48.9035149,
                30.8665428
              ],
              [
                48.8970453,
                30.8731694
              ],
              [
                48.8859483,
                30.8779186
              ],
              [
                48.8779334,
                30.8779062
              ],
              [
                48.8653639,
                30.884277
              ],
              [
                48.858984,
                30.8887578
              ],
              [
                48.8455105,
                30.8958464
              ],
              [
                48.8431932,
                30.9038357
              ],
              [
                48.8427466,
                30.9106193
              ],
              [
                48.842697,
                30.9138304
              ],
              [
                48.8408396,
                30.9156125
              ],
              [
                48.8388749,
                30.9177648
              ],
              [
                48.8364336,
                30.9205112
              ],
              [
                48.8343621,
                30.9229842
              ],
              [
                48.8322411,
                30.9259118
              ],
              [
                48.8306503,
                30.9284311
              ],
              [
                48.8286324,
                30.931313
              ],
              [
                48.826725,
                30.9340592
              ],
              [
                48.8247069,
                30.937171
              ],
              [
                48.8226395,
                30.9400565
              ],
              [
                48.8205303,
                30.9423661
              ],
              [
                48.820301,
                30.9426171
              ],
              [
                48.8186567,
                30.9443123
              ],
              [
                48.8161583,
                30.9457313
              ],
              [
                48.8134461,
                30.9466912
              ],
              [
                48.8106309,
                30.947196
              ],
              [
                48.8075485,
                30.9474211
              ],
              [
                48.8046762,
                30.9473295
              ],
              [
                48.8024407,
                30.9469194
              ],
              [
                48.800476,
                30.9463696
              ],
              [
                48.7984542,
                30.9456834
              ],
              [
                48.7965394,
                30.9446744
              ],
              [
                48.7947846,
                30.9439431
              ],
              [
                48.7930259,
                30.9427991
              ],
              [
                48.7908477,
                30.941472
              ],
              [
                48.7892493,
                30.9403735
              ],
              [
                48.7878685,
                30.9396418
              ],
              [
                48.7870177,
                30.9395506
              ],
              [
                48.7859,
                30.9395495
              ],
              [
                48.7845191,
                30.9398708
              ],
              [
                48.7831383,
                30.9403726
              ],
              [
                48.7817537,
                30.940784
              ],
              [
                48.7805863,
                30.9416547
              ],
              [
                48.7790986,
                30.9424793
              ],
              [
                48.7772409,
                30.94431
              ],
              [
                48.7756462,
                30.9458656
              ],
              [
                48.7727242,
                30.9489317
              ],
              [
                48.7691651,
                30.9526362
              ],
              [
                48.7656593,
                30.9558408
              ],
              [
                48.7630538,
                30.958495
              ],
              [
                48.7598648,
                30.9610127
              ],
              [
                48.7570495,
                30.9627498
              ],
              [
                48.7547607,
                30.9634812
              ],
              [
                48.7534333,
                30.9639858
              ],
              [
                48.7513582,
                30.9641684
              ],
              [
                48.7500179,
                30.9642872
              ],
              [
                48.7471351,
                30.9640114
              ],
              [
                48.7446367,
                30.9637897
              ],
              [
                48.7419243,
                30.9631537
              ],
              [
                48.7401656,
                30.9626088
              ],
              [
                48.7381401,
                30.9618788
              ],
              [
                48.7362214,
                30.9609229
              ],
              [
                48.7342453,
                30.9596007
              ],
              [
                48.733017,
                30.9587335
              ],
              [
                48.7312546,
                30.9574082
              ],
              [
                48.7294884,
                30.9559024
              ],
              [
                48.7284203,
                30.9549433
              ],
              [
                48.7272987,
                30.9542584
              ],
              [
                48.7257005,
                30.953574
              ],
              [
                48.7244226,
                30.9530284
              ],
              [
                48.7226106,
                30.9521621
              ],
              [
                48.7210084,
                30.9512499
              ],
              [
                48.7201536,
                30.9504749
              ],
              [
                48.7189789,
                30.9493312
              ],
              [
                48.717106,
                30.947458
              ],
              [
                48.7147521,
                30.9449923
              ],
              [
                48.7110024,
                30.9407407
              ],
              [
                48.7091295,
                30.9388675
              ],
              [
                48.7069892,
                30.936446
              ],
              [
                48.7052765,
                30.9342508
              ],
              [
                48.7032395,
                30.9316462
              ],
              [
                48.7018473,
                30.9299077
              ],
              [
                48.7004547,
                30.9281737
              ],
              [
                48.6985283,
                30.9260265
              ],
              [
                48.6961213,
                30.9235122
              ],
              [
                48.6937714,
                30.921089
              ],
              [
                48.6916847,
                30.9189885
              ],
              [
                48.689335,
                30.9169328
              ],
              [
                48.6873588,
                30.9153799
              ],
              [
                48.6840019,
                30.9133738
              ],
              [
                48.6838003,
                30.9132717
              ],
              [
                48.6799508,
                30.9113235
              ],
              [
                48.6776086,
                30.9103209
              ],
              [
                48.6752168,
                30.9095022
              ],
              [
                48.6728211,
                30.9087758
              ],
              [
                48.6703563,
                30.9083395
              ],
              [
                48.6702688,
                30.908324
              ],
              [
                48.6681442,
                30.9079632
              ],
              [
                48.6662291,
                30.9078745
              ],
              [
                48.6650546,
                30.908036
              ],
              [
                48.6648176,
                30.9081076
              ],
              [
                48.6640548,
                30.9083381
              ],
              [
                48.6622048,
                30.9093487
              ],
              [
                48.6608812,
                30.9102223
              ],
              [
                48.6576539,
                30.9123849
              ],
              [
                48.6531562,
                30.9151423
              ],
              [
                48.6498222,
                30.9171631
              ],
              [
                48.6460112,
                30.9190984
              ],
              [
                48.6412965,
                30.9216281
              ],
              [
                48.6388787,
                30.9230517
              ],
              [
                48.6381761,
                30.9234653
              ],
              [
                48.6347885,
                30.9254891
              ],
              [
                48.6307105,
                30.9282015
              ],
              [
                48.6277503,
                30.9304066
              ],
              [
                48.6242065,
                30.9330249
              ],
              [
                48.6218759,
                30.93445
              ],
              [
                48.6201286,
                30.9355543
              ],
              [
                48.6176378,
                30.9367057
              ],
              [
                48.6149865,
                30.9375362
              ],
              [
                48.6121217,
                30.938365
              ],
              [
                48.6088867,
                30.9389681
              ],
              [
                48.6061784,
                30.9394343
              ],
              [
                48.6034699,
                30.9399433
              ],
              [
                48.6012421,
                30.9401771
              ],
              [
                48.5982705,
                30.9405977
              ],
              [
                48.5937578,
                30.9412037
              ],
              [
                48.5899353,
                30.9417165
              ],
              [
                48.5853691,
                30.9424159
              ],
              [
                48.5789987,
                30.9436203
              ],
              [
                48.5744859,
                30.9444106
              ],
              [
                48.5707704,
                30.9449676
              ],
              [
                48.5670013,
                30.9458009
              ],
              [
                48.5648269,
                30.9464476
              ],
              [
                48.5625991,
                30.9470483
              ],
              [
                48.5605278,
                30.9477397
              ],
              [
                48.5584602,
                30.9482486
              ],
              [
                48.5564957,
                30.9484821
              ],
              [
                48.554264,
                30.9485345
              ],
              [
                48.5520288,
                30.9482171
              ],
              [
                48.5500641,
                30.9480852
              ],
              [
                48.5476189,
                30.947908
              ],
              [
                48.5452804,
                30.9478681
              ],
              [
                48.5434761,
                30.9481021
              ],
              [
                48.5417252,
                30.9485626
              ],
              [
                48.5397605,
                30.9493009
              ],
              [
                48.5370558,
                30.9503159
              ],
              [
                48.5341414,
                30.9517891
              ],
              [
                48.5310136,
                30.9533054
              ],
              [
                48.5283089,
                30.9548704
              ],
              [
                48.5245439,
                30.9570779
              ],
              [
                48.5201989,
                30.959653
              ],
              [
                48.516327,
                30.9616305
              ],
              [
                48.5128786,
                30.9631493
              ],
              [
                48.5092697,
                30.9644394
              ],
              [
                48.5057144,
                30.9657304
              ],
              [
                48.5032033,
                30.9663042
              ],
              [
                48.5011375,
                30.9670467
              ],
              [
                48.5000969,
                30.9676173
              ],
              [
                48.4971389,
                30.9700583
              ],
              [
                48.4945832,
                30.9719749
              ],
              [
                48.4919739,
                30.9737078
              ],
              [
                48.4886208,
                30.9751624
              ],
              [
                48.4861184,
                30.9761171
              ],
              [
                48.4839898,
                30.9765694
              ],
              [
                48.4811173,
                30.9772034
              ],
              [
                48.4765396,
                30.9776033
              ],
              [
                48.4720687,
                30.9776849
              ],
              [
                48.4661063,
                30.9778972
              ],
              [
                48.4621697,
                30.9783002
              ],
              [
                48.4588661,
                30.9791596
              ],
              [
                48.4547691,
                30.9800643
              ],
              [
                48.4500314,
                30.9811049
              ],
              [
                48.4411393,
                30.9827305
              ],
              [
                48.4295884,
                30.984988
              ],
              [
                48.4206962,
                30.9865694
              ],
              [
                48.4148941,
                30.9876055
              ],
              [
                48.4120712,
                30.9878285
              ],
              [
                48.4047241,
                30.9884521
              ],
              [
                48.3992424,
                30.9890317
              ],
              [
                48.3941307,
                30.9896118
              ],
              [
                48.3909913,
                30.9899723
              ],
              [
                48.3874206,
                30.9906035
              ],
              [
                48.3827361,
                30.9909573
              ],
              [
                48.3808947,
                30.9911281
              ],
              [
                48.3808212,
                30.9911349
              ],
              [
                48.3794899,
                30.9909951
              ],
              [
                48.3786925,
                30.9907197
              ],
              [
                48.3778419,
                30.9898005
              ],
              [
                48.3761939,
                30.9887434
              ],
              [
                48.3738518,
                30.9880036
              ],
              [
                48.3718338,
                30.9873605
              ],
              [
                48.3684273,
                30.9867545
              ],
              [
                48.3658218,
                30.9861083
              ],
              [
                48.3631058,
                30.9853697
              ],
              [
                48.3616181,
                30.9844487
              ],
              [
                48.3605575,
                30.983302
              ],
              [
                48.3599205,
                30.9820195
              ],
              [
                48.3594475,
                30.9802332
              ],
              [
                48.3593978,
                30.9770305
              ],
              [
                48.359726,
                30.9742369
              ],
              [
                48.3599433,
                30.9711727
              ],
              [
                48.3596344,
                30.9680572
              ],
              [
                48.3595434,
                30.9664201
              ],
              [
                48.3592892,
                30.9656708
              ],
              [
                48.3580122,
                30.9617695
              ],
              [
                48.3559742,
                30.9557125
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555110,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شوش",
          "name:en": "Shush County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1274936",
          "wikipedia": "en:Shush County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.664111,
                32.048542
              ],
              [
                47.664464,
                32.048271
              ],
              [
                47.665077,
                32.048078
              ],
              [
                47.667338,
                32.046688
              ],
              [
                47.667594,
                32.046333
              ],
              [
                47.667517,
                32.04614
              ],
              [
                47.667276,
                32.045988
              ],
              [
                47.666991,
                32.045905
              ],
              [
                47.666902,
                32.045808
              ],
              [
                47.666998,
                32.045605
              ],
              [
                47.667532,
                32.044931
              ],
              [
                47.667551,
                32.044721
              ],
              [
                47.667423,
                32.044569
              ],
              [
                47.66738,
                32.044411
              ],
              [
                47.667518,
                32.044129
              ],
              [
                47.667762,
                32.043868
              ],
              [
                47.668212,
                32.043724
              ],
              [
                47.66957,
                32.042334
              ],
              [
                47.669565,
                32.042128
              ],
              [
                47.669761,
                32.041598
              ],
              [
                47.669694,
                32.041393
              ],
              [
                47.669747,
                32.041074
              ],
              [
                47.670037,
                32.040424
              ],
              [
                47.670587,
                32.039622
              ],
              [
                47.670613,
                32.039205
              ],
              [
                47.670555,
                32.038752
              ],
              [
                47.67042,
                32.038343
              ],
              [
                47.670412,
                32.037983
              ],
              [
                47.670334,
                32.037647
              ],
              [
                47.67011,
                32.036903
              ],
              [
                47.67015,
                32.036369
              ],
              [
                47.669981,
                32.035974
              ],
              [
                47.670169,
                32.035635
              ],
              [
                47.669869,
                32.035447
              ],
              [
                47.669831,
                32.035335
              ],
              [
                47.670546,
                32.034056
              ],
              [
                47.670884,
                32.033342
              ],
              [
                47.670959,
                32.032553
              ],
              [
                47.671182,
                32.032006
              ],
              [
                47.671513,
                32.031977
              ],
              [
                47.671764,
                32.031746
              ],
              [
                47.671981,
                32.031665
              ],
              [
                47.672306,
                32.031709
              ],
              [
                47.672569,
                32.031992
              ],
              [
                47.67299,
                32.032112
              ],
              [
                47.673517,
                32.03216
              ],
              [
                47.675086,
                32.032495
              ],
              [
                47.675451,
                32.032408
              ],
              [
                47.675919,
                32.031952
              ],
              [
                47.676354,
                32.031894
              ],
              [
                47.677205,
                32.031328
              ],
              [
                47.677595,
                32.031236
              ],
              [
                47.677829,
                32.03108
              ],
              [
                47.678127,
                32.030789
              ],
              [
                47.678499,
                32.030681
              ],
              [
                47.678764,
                32.030736
              ],
              [
                47.678901,
                32.030917
              ],
              [
                47.679066,
                32.031021
              ],
              [
                47.679482,
                32.031121
              ],
              [
                47.679814,
                32.031144
              ],
              [
                47.680057,
                32.031306
              ],
              [
                47.680191,
                32.031478
              ],
              [
                47.680451,
                32.031513
              ],
              [
                47.680782,
                32.031484
              ],
              [
                47.681096,
                32.031345
              ],
              [
                47.682648,
                32.031291
              ],
              [
                47.68344,
                32.030974
              ],
              [
                47.684042,
                32.030635
              ],
              [
                47.684756,
                32.030372
              ],
              [
                47.686398,
                32.030396
              ],
              [
                47.686487,
                32.030317
              ],
              [
                47.686833,
                32.030254
              ],
              [
                47.687062,
                32.030264
              ],
              [
                47.687363,
                32.030127
              ],
              [
                47.687603,
                32.029898
              ],
              [
                47.687723,
                32.029598
              ],
              [
                47.687701,
                32.029282
              ],
              [
                47.687618,
                32.029112
              ],
              [
                47.687354,
                32.028922
              ],
              [
                47.687359,
                32.028798
              ],
              [
                47.688073,
                32.028142
              ],
              [
                47.68816,
                32.027951
              ],
              [
                47.688173,
                32.027763
              ],
              [
                47.688318,
                32.027603
              ],
              [
                47.688324,
                32.027488
              ],
              [
                47.688111,
                32.027393
              ],
              [
                47.688008,
                32.027288
              ],
              [
                47.688011,
                32.027112
              ],
              [
                47.688807,
                32.026364
              ],
              [
                47.688902,
                32.026202
              ],
              [
                47.688839,
                32.025848
              ],
              [
                47.688609,
                32.025621
              ],
              [
                47.688411,
                32.025538
              ],
              [
                47.688013,
                32.025574
              ],
              [
                47.687174,
                32.025742
              ],
              [
                47.686664,
                32.025896
              ],
              [
                47.686429,
                32.026022
              ],
              [
                47.686147,
                32.026049
              ],
              [
                47.685921,
                32.025974
              ],
              [
                47.685621,
                32.025748
              ],
              [
                47.685546,
                32.025522
              ],
              [
                47.685621,
                32.025335
              ],
              [
                47.685959,
                32.025184
              ],
              [
                47.686493,
                32.024859
              ],
              [
                47.686619,
                32.024697
              ],
              [
                47.686722,
                32.024472
              ],
              [
                47.686688,
                32.02418
              ],
              [
                47.686568,
                32.023969
              ],
              [
                47.685206,
                32.023164
              ],
              [
                47.68497,
                32.022959
              ],
              [
                47.68484,
                32.022802
              ],
              [
                47.684405,
                32.021973
              ],
              [
                47.683858,
                32.021474
              ],
              [
                47.683316,
                32.020876
              ],
              [
                47.683114,
                32.020428
              ],
              [
                47.68307,
                32.019487
              ],
              [
                47.682984,
                32.019214
              ],
              [
                47.682729,
                32.018821
              ],
              [
                47.682665,
                32.018632
              ],
              [
                47.682652,
                32.018418
              ],
              [
                47.682828,
                32.018185
              ],
              [
                47.683147,
                32.018044
              ],
              [
                47.6836,
                32.018003
              ],
              [
                47.684218,
                32.017876
              ],
              [
                47.68515,
                32.017939
              ],
              [
                47.685475,
                32.017911
              ],
              [
                47.68629,
                32.017516
              ],
              [
                47.687292,
                32.017139
              ],
              [
                47.687776,
                32.01686
              ],
              [
                47.688191,
                32.016517
              ],
              [
                47.688821,
                32.015779
              ],
              [
                47.689026,
                32.015443
              ],
              [
                47.689848,
                32.013736
              ],
              [
                47.690072,
                32.013402
              ],
              [
                47.690236,
                32.013243
              ],
              [
                47.690799,
                32.013167
              ],
              [
                47.691144,
                32.013264
              ],
              [
                47.691352,
                32.013407
              ],
              [
                47.691581,
                32.01384
              ],
              [
                47.691773,
                32.014512
              ],
              [
                47.691892,
                32.014676
              ],
              [
                47.692038,
                32.014778
              ],
              [
                47.692215,
                32.014875
              ],
              [
                47.692558,
                32.014942
              ],
              [
                47.694595,
                32.015263
              ],
              [
                47.694981,
                32.015389
              ],
              [
                47.69529,
                32.015559
              ],
              [
                47.695634,
                32.015765
              ],
              [
                47.695849,
                32.016004
              ],
              [
                47.696094,
                32.016331
              ],
              [
                47.696243,
                32.016836
              ],
              [
                47.696223,
                32.017412
              ],
              [
                47.696049,
                32.018048
              ],
              [
                47.696076,
                32.018265
              ],
              [
                47.696869,
                32.019137
              ],
              [
                47.69708,
                32.019476
              ],
              [
                47.69724,
                32.019906
              ],
              [
                47.697323,
                32.02019
              ],
              [
                47.697292,
                32.020474
              ],
              [
                47.697432,
                32.021202
              ],
              [
                47.697475,
                32.022057
              ],
              [
                47.697583,
                32.022228
              ],
              [
                47.69788,
                32.022375
              ],
              [
                47.698846,
                32.022653
              ],
              [
                47.699067,
                32.022845
              ],
              [
                47.699423,
                32.02293
              ],
              [
                47.699799,
                32.022954
              ],
              [
                47.700117,
                32.022854
              ],
              [
                47.700574,
                32.02257
              ],
              [
                47.700864,
                32.022321
              ],
              [
                47.701141,
                32.021997
              ],
              [
                47.701498,
                32.021715
              ],
              [
                47.70183,
                32.021623
              ],
              [
                47.702807,
                32.021569
              ],
              [
                47.703443,
                32.021251
              ],
              [
                47.703802,
                32.021139
              ],
              [
                47.704433,
                32.021039
              ],
              [
                47.706477,
                32.020966
              ],
              [
                47.708098,
                32.020788
              ],
              [
                47.708956,
                32.020668
              ],
              [
                47.70999,
                32.02036
              ],
              [
                47.711699,
                32.019507
              ],
              [
                47.712108,
                32.01921
              ],
              [
                47.712418,
                32.018895
              ],
              [
                47.712962,
                32.018073
              ],
              [
                47.713107,
                32.017355
              ],
              [
                47.712958,
                32.016639
              ],
              [
                47.712598,
                32.016142
              ],
              [
                47.712499,
                32.015845
              ],
              [
                47.712438,
                32.015526
              ],
              [
                47.7124,
                32.01464
              ],
              [
                47.712294,
                32.014504
              ],
              [
                47.712015,
                32.014307
              ],
              [
                47.71121,
                32.013881
              ],
              [
                47.710376,
                32.013672
              ],
              [
                47.710006,
                32.013673
              ],
              [
                47.709446,
                32.013734
              ],
              [
                47.709002,
                32.013949
              ],
              [
                47.708723,
                32.014403
              ],
              [
                47.708623,
                32.014756
              ],
              [
                47.708592,
                32.015128
              ],
              [
                47.70885,
                32.015944
              ],
              [
                47.70912,
                32.016596
              ],
              [
                47.709112,
                32.016778
              ],
              [
                47.708996,
                32.01714
              ],
              [
                47.708871,
                32.017395
              ],
              [
                47.70868,
                32.017616
              ],
              [
                47.708486,
                32.017734
              ],
              [
                47.707739,
                32.017803
              ],
              [
                47.707466,
                32.01777
              ],
              [
                47.706822,
                32.017217
              ],
              [
                47.706653,
                32.017103
              ],
              [
                47.706508,
                32.017078
              ],
              [
                47.706333,
                32.017079
              ],
              [
                47.705894,
                32.017361
              ],
              [
                47.70553,
                32.017474
              ],
              [
                47.705126,
                32.017583
              ],
              [
                47.704983,
                32.017542
              ],
              [
                47.704671,
                32.017104
              ],
              [
                47.704434,
                32.016321
              ],
              [
                47.703962,
                32.015592
              ],
              [
                47.703663,
                32.015321
              ],
              [
                47.703338,
                32.015117
              ],
              [
                47.702446,
                32.014785
              ],
              [
                47.701822,
                32.014377
              ],
              [
                47.701399,
                32.013928
              ],
              [
                47.701235,
                32.013596
              ],
              [
                47.701156,
                32.013306
              ],
              [
                47.701131,
                32.012908
              ],
              [
                47.701385,
                32.011943
              ],
              [
                47.701608,
                32.011608
              ],
              [
                47.701815,
                32.0114
              ],
              [
                47.702086,
                32.011216
              ],
              [
                47.702425,
                32.011056
              ],
              [
                47.702814,
                32.010939
              ],
              [
                47.703168,
                32.0109
              ],
              [
                47.703562,
                32.010921
              ],
              [
                47.70409,
                32.011088
              ],
              [
                47.704551,
                32.011448
              ],
              [
                47.705171,
                32.011561
              ],
              [
                47.705512,
                32.011566
              ],
              [
                47.705684,
                32.011509
              ],
              [
                47.705982,
                32.011264
              ],
              [
                47.707145,
                32.010179
              ],
              [
                47.707741,
                32.009575
              ],
              [
                47.70794,
                32.009291
              ],
              [
                47.708284,
                32.00833
              ],
              [
                47.708325,
                32.00795
              ],
              [
                47.708295,
                32.007605
              ],
              [
                47.708202,
                32.007281
              ],
              [
                47.708007,
                32.006956
              ],
              [
                47.707745,
                32.00673
              ],
              [
                47.706952,
                32.006136
              ],
              [
                47.706175,
                32.005721
              ],
              [
                47.706006,
                32.005535
              ],
              [
                47.705963,
                32.005377
              ],
              [
                47.706032,
                32.005143
              ],
              [
                47.706279,
                32.004969
              ],
              [
                47.706496,
                32.004888
              ],
              [
                47.706694,
                32.00497
              ],
              [
                47.706881,
                32.004988
              ],
              [
                47.70703,
                32.004914
              ],
              [
                47.70716,
                32.004653
              ],
              [
                47.707533,
                32.004198
              ],
              [
                47.708458,
                32.003394
              ],
              [
                47.709292,
                32.002901
              ],
              [
                47.710389,
                32.002479
              ],
              [
                47.71161,
                32.002287
              ],
              [
                47.712211,
                32.002141
              ],
              [
                47.712732,
                32.001958
              ],
              [
                47.71335,
                32.001665
              ],
              [
                47.713998,
                32.001139
              ],
              [
                47.71451,
                32.000106
              ],
              [
                47.714608,
                31.999794
              ],
              [
                47.714601,
                31.999444
              ],
              [
                47.714471,
                31.999122
              ],
              [
                47.714007,
                31.998473
              ],
              [
                47.71332,
                31.998181
              ],
              [
                47.712886,
                31.998131
              ],
              [
                47.712633,
                31.998193
              ],
              [
                47.712366,
                31.998319
              ],
              [
                47.712237,
                31.998446
              ],
              [
                47.712176,
                31.998663
              ],
              [
                47.712194,
                31.998892
              ],
              [
                47.712412,
                31.999327
              ],
              [
                47.712383,
                31.999524
              ],
              [
                47.712178,
                31.999902
              ],
              [
                47.710969,
                32.000143
              ],
              [
                47.710686,
                32.000138
              ],
              [
                47.710003,
                31.999839
              ],
              [
                47.709663,
                31.999535
              ],
              [
                47.709271,
                31.999266
              ],
              [
                47.709134,
                31.999084
              ],
              [
                47.708995,
                31.998521
              ],
              [
                47.708953,
                31.99762
              ],
              [
                47.70885,
                31.997448
              ],
              [
                47.708505,
                31.99717
              ],
              [
                47.707883,
                31.996794
              ],
              [
                47.707114,
                31.996242
              ],
              [
                47.70613,
                31.995828
              ],
              [
                47.705707,
                31.995539
              ],
              [
                47.705396,
                31.994873
              ],
              [
                47.705359,
                31.994575
              ],
              [
                47.705397,
                31.994321
              ],
              [
                47.70559,
                31.99413
              ],
              [
                47.706569,
                31.994014
              ],
              [
                47.706819,
                31.993824
              ],
              [
                47.707534,
                31.992635
              ],
              [
                47.707803,
                31.991564
              ],
              [
                47.707956,
                31.9912
              ],
              [
                47.708193,
                31.990894
              ],
              [
                47.708468,
                31.990751
              ],
              [
                47.708737,
                31.990722
              ],
              [
                47.709069,
                31.99077
              ],
              [
                47.709253,
                31.990891
              ],
              [
                47.709833,
                31.991508
              ],
              [
                47.710038,
                31.991641
              ],
              [
                47.710287,
                31.991771
              ],
              [
                47.710834,
                31.991754
              ],
              [
                47.71132,
                31.991975
              ],
              [
                47.711919,
                31.992495
              ],
              [
                47.712191,
                31.992667
              ],
              [
                47.712434,
                31.992757
              ],
              [
                47.712794,
                31.992882
              ],
              [
                47.71316,
                31.992888
              ],
              [
                47.713634,
                31.992807
              ],
              [
                47.71392,
                31.992661
              ],
              [
                47.714125,
                31.992464
              ],
              [
                47.714229,
                31.99227
              ],
              [
                47.714205,
                31.992109
              ],
              [
                47.713928,
                31.991803
              ],
              [
                47.713865,
                31.991639
              ],
              [
                47.713921,
                31.991407
              ],
              [
                47.714746,
                31.990545
              ],
              [
                47.715047,
                31.989861
              ],
              [
                47.715188,
                31.989309
              ],
              [
                47.715417,
                31.988764
              ],
              [
                47.716066,
                31.987498
              ],
              [
                47.716583,
                31.986904
              ],
              [
                47.7169,
                31.986651
              ],
              [
                47.717107,
                31.986544
              ],
              [
                47.717379,
                31.986509
              ],
              [
                47.717542,
                31.986442
              ],
              [
                47.717659,
                31.986296
              ],
              [
                47.7180257,
                31.9865163
              ],
              [
                47.8890688,
                32.0719552
              ],
              [
                47.8897743,
                32.0712882
              ],
              [
                47.8924217,
                32.0694464
              ],
              [
                47.8955536,
                32.0673752
              ],
              [
                47.9001464,
                32.0638768
              ],
              [
                47.9045754,
                32.061019
              ],
              [
                47.9087906,
                32.0589017
              ],
              [
                47.9108962,
                32.0576143
              ],
              [
                47.9134903,
                32.0562327
              ],
              [
                47.9162446,
                32.0544357
              ],
              [
                47.9197007,
                32.0522726
              ],
              [
                47.9224013,
                32.0504314
              ],
              [
                47.9244537,
                32.0490026
              ],
              [
                47.9266662,
                32.0473027
              ],
              [
                47.9290962,
                32.0454593
              ],
              [
                47.9317932,
                32.0432481
              ],
              [
                47.9337348,
                32.0411763
              ],
              [
                47.9355659,
                32.0393791
              ],
              [
                47.9397698,
                32.0347743
              ],
              [
                47.9455414,
                32.0294341
              ],
              [
                47.9511452,
                32.0234944
              ],
              [
                47.9554596,
                32.0195814
              ],
              [
                47.9573974,
                32.0176016
              ],
              [
                47.9590187,
                32.0165405
              ],
              [
                47.9599876,
                32.0157117
              ],
              [
                47.9613877,
                32.0141021
              ],
              [
                47.9631119,
                32.0121689
              ],
              [
                47.9651032,
                32.0098656
              ],
              [
                47.9668808,
                32.0077465
              ],
              [
                47.9690361,
                32.0056725
              ],
              [
                47.9712983,
                32.0029564
              ],
              [
                47.9747524,
                32.0000139
              ],
              [
                47.9749263,
                31.99984
              ],
              [
                47.9767646,
                31.9980039
              ],
              [
                47.9782563,
                31.9961957
              ],
              [
                47.980339,
                31.9939732
              ],
              [
                47.9817772,
                31.9923507
              ],
              [
                47.9835854,
                31.9900788
              ],
              [
                47.9858169,
                31.9869288
              ],
              [
                47.9883194,
                31.9837311
              ],
              [
                47.9910279,
                31.9796998
              ],
              [
                47.9910377,
                31.9796849
              ],
              [
                47.993309,
                31.9762713
              ],
              [
                47.9954757,
                31.9722833
              ],
              [
                47.9970589,
                31.968854
              ],
              [
                48.0110261,
                31.9590117
              ],
              [
                48.0261013,
                31.962978
              ],
              [
                48.0425239,
                31.9658378
              ],
              [
                48.0512296,
                31.9672694
              ],
              [
                48.068002,
                31.9681809
              ],
              [
                48.0910915,
                31.9658029
              ],
              [
                48.1083401,
                31.959473
              ],
              [
                48.1277016,
                31.9502993
              ],
              [
                48.1557853,
                31.9380385
              ],
              [
                48.1855146,
                31.924263
              ],
              [
                48.1987169,
                31.9183073
              ],
              [
                48.2225013,
                31.9091856
              ],
              [
                48.2381664,
                31.9100882
              ],
              [
                48.250299,
                31.9110285
              ],
              [
                48.252213,
                31.913156
              ],
              [
                48.2444319,
                31.914356
              ],
              [
                48.2433647,
                31.915835
              ],
              [
                48.2454092,
                31.9160906
              ],
              [
                48.2522318,
                31.9155532
              ],
              [
                48.2562716,
                31.919198
              ],
              [
                48.2592508,
                31.9253643
              ],
              [
                48.2605524,
                31.9284008
              ],
              [
                48.2652243,
                31.9351565
              ],
              [
                48.2633943,
                31.9412271
              ],
              [
                48.2494461,
                31.9421076
              ],
              [
                48.2490366,
                31.9439835
              ],
              [
                48.2592648,
                31.9469182
              ],
              [
                48.2698378,
                31.9579651
              ],
              [
                48.2701751,
                31.9625526
              ],
              [
                48.2671398,
                31.9667571
              ],
              [
                48.26315,
                31.965771
              ],
              [
                48.2577582,
                31.9619024
              ],
              [
                48.2488738,
                31.9606002
              ],
              [
                48.2484253,
                31.9617574
              ],
              [
                48.2518742,
                31.9675431
              ],
              [
                48.2472528,
                31.9733417
              ],
              [
                48.2498592,
                31.9778766
              ],
              [
                48.2556595,
                31.9771149
              ],
              [
                48.2613636,
                31.9778676
              ],
              [
                48.261839,
                31.9826345
              ],
              [
                48.2590225,
                31.9867925
              ],
              [
                48.2603965,
                31.9881893
              ],
              [
                48.2627366,
                31.9896459
              ],
              [
                48.2658914,
                31.9916251
              ],
              [
                48.2688429,
                31.9935526
              ],
              [
                48.272997,
                31.9982149
              ],
              [
                48.2745398,
                31.9994284
              ],
              [
                48.2757408,
                32.0013822
              ],
              [
                48.2760254,
                32.0057465
              ],
              [
                48.2762356,
                32.0086007
              ],
              [
                48.2739449,
                32.0092457
              ],
              [
                48.2701981,
                32.0080382
              ],
              [
                48.2664602,
                32.0068123
              ],
              [
                48.2621562,
                32.0085581
              ],
              [
                48.2594967,
                32.0094167
              ],
              [
                48.2554619,
                32.0119027
              ],
              [
                48.2496748,
                32.0154889
              ],
              [
                48.2470784,
                32.0171021
              ],
              [
                48.2461092,
                32.0199676
              ],
              [
                48.2450978,
                32.0230291
              ],
              [
                48.2403731,
                32.0222395
              ],
              [
                48.2375276,
                32.0233328
              ],
              [
                48.2327255,
                32.0249699
              ],
              [
                48.2324272,
                32.028839
              ],
              [
                48.2335286,
                32.0318009
              ],
              [
                48.2310404,
                32.0359347
              ],
              [
                48.2323479,
                32.0428222
              ],
              [
                48.2317969,
                32.0461504
              ],
              [
                48.2315013,
                32.0473854
              ],
              [
                48.2359073,
                32.0492054
              ],
              [
                48.2468968,
                32.0513079
              ],
              [
                48.2567749,
                32.0499548
              ],
              [
                48.2662171,
                32.0486546
              ],
              [
                48.2810517,
                32.0540071
              ],
              [
                48.2834239,
                32.0595928
              ],
              [
                48.2862991,
                32.0659705
              ],
              [
                48.2885779,
                32.0713112
              ],
              [
                48.2926455,
                32.0807895
              ],
              [
                48.3019018,
                32.0850404
              ],
              [
                48.3148537,
                32.075138
              ],
              [
                48.325714,
                32.0724096
              ],
              [
                48.3361282,
                32.0696709
              ],
              [
                48.3477478,
                32.0667585
              ],
              [
                48.3517275,
                32.0656633
              ],
              [
                48.3611962,
                32.0543823
              ],
              [
                48.4046306,
                32.0482959
              ],
              [
                48.415351,
                32.0441895
              ],
              [
                48.438571,
                32.0434143
              ],
              [
                48.4536802,
                32.0432715
              ],
              [
                48.4713695,
                32.0098533
              ],
              [
                48.5148299,
                31.9894295
              ],
              [
                48.558844,
                31.9713495
              ],
              [
                48.5842756,
                31.9573578
              ],
              [
                48.5868814,
                31.9607933
              ],
              [
                48.5940291,
                31.9707288
              ],
              [
                48.5964877,
                31.9746507
              ],
              [
                48.6096637,
                31.9784498
              ],
              [
                48.6120137,
                31.9824431
              ],
              [
                48.6096403,
                31.9872282
              ],
              [
                48.6004481,
                31.9865428
              ],
              [
                48.5949517,
                31.9879558
              ],
              [
                48.5938401,
                31.9898411
              ],
              [
                48.5909113,
                31.995097
              ],
              [
                48.5887919,
                31.9985609
              ],
              [
                48.5852475,
                31.998466
              ],
              [
                48.5868431,
                32.0062002
              ],
              [
                48.5870172,
                32.0137341
              ],
              [
                48.5836562,
                32.0158976
              ],
              [
                48.578513,
                32.0145671
              ],
              [
                48.5749863,
                32.0117114
              ],
              [
                48.5769711,
                32.0036473
              ],
              [
                48.5759386,
                32.0025482
              ],
              [
                48.5724978,
                32.0065922
              ],
              [
                48.5683397,
                32.0115408
              ],
              [
                48.5603848,
                32.0162888
              ],
              [
                48.5556506,
                32.0172188
              ],
              [
                48.5492497,
                32.0151212
              ],
              [
                48.5480444,
                32.0171817
              ],
              [
                48.5534479,
                32.0241734
              ],
              [
                48.5511512,
                32.0269353
              ],
              [
                48.5497509,
                32.0282178
              ],
              [
                48.5467724,
                32.0288863
              ],
              [
                48.5437434,
                32.0294958
              ],
              [
                48.5350603,
                32.0238575
              ],
              [
                48.5311985,
                32.0267242
              ],
              [
                48.5303612,
                32.0313521
              ],
              [
                48.5295616,
                32.0363046
              ],
              [
                48.5255384,
                32.0388251
              ],
              [
                48.5158396,
                32.0353652
              ],
              [
                48.5070702,
                32.0311872
              ],
              [
                48.499445,
                32.0353303
              ],
              [
                48.5000197,
                32.0364615
              ],
              [
                48.5090486,
                32.0343903
              ],
              [
                48.5128781,
                32.0376093
              ],
              [
                48.5156075,
                32.0443358
              ],
              [
                48.5325776,
                32.0527037
              ],
              [
                48.5350519,
                32.0575363
              ],
              [
                48.5331307,
                32.0595577
              ],
              [
                48.5293883,
                32.0632174
              ],
              [
                48.5265155,
                32.0637198
              ],
              [
                48.5236212,
                32.0641711
              ],
              [
                48.5200929,
                32.0620567
              ],
              [
                48.5143105,
                32.0599754
              ],
              [
                48.5110242,
                32.06172
              ],
              [
                48.5178102,
                32.0675136
              ],
              [
                48.5143098,
                32.0712604
              ],
              [
                48.5091292,
                32.0732449
              ],
              [
                48.5057164,
                32.0797107
              ],
              [
                48.500195,
                32.086823
              ],
              [
                48.5006897,
                32.0919427
              ],
              [
                48.5019898,
                32.0955223
              ],
              [
                48.4999406,
                32.0989215
              ],
              [
                48.4929962,
                32.1010002
              ],
              [
                48.491853,
                32.1007841
              ],
              [
                48.4882194,
                32.100407
              ],
              [
                48.4852067,
                32.1029861
              ],
              [
                48.4843978,
                32.1035426
              ],
              [
                48.4838067,
                32.1037293
              ],
              [
                48.4832114,
                32.1037783
              ],
              [
                48.4825632,
                32.1038736
              ],
              [
                48.4816971,
                32.1036445
              ],
              [
                48.4809912,
                32.103511
              ],
              [
                48.4797974,
                32.1030994
              ],
              [
                48.4776878,
                32.1027869
              ],
              [
                48.4756278,
                32.1023378
              ],
              [
                48.4730263,
                32.1018868
              ],
              [
                48.4717826,
                32.1018913
              ],
              [
                48.470543,
                32.1021303
              ],
              [
                48.4695702,
                32.1022258
              ],
              [
                48.4686545,
                32.1025096
              ],
              [
                48.4677925,
                32.1027877
              ],
              [
                48.4664993,
                32.103348
              ],
              [
                48.4644012,
                32.1042371
              ],
              [
                48.4626771,
                32.105075
              ],
              [
                48.4609528,
                32.1055905
              ],
              [
                48.4596558,
                32.1057809
              ],
              [
                48.4584695,
                32.1059261
              ],
              [
                48.4574394,
                32.1059753
              ],
              [
                48.456684,
                32.1057979
              ],
              [
                48.4559746,
                32.105477
              ],
              [
                48.4553757,
                32.104969
              ],
              [
                48.4549943,
                32.1045104
              ],
              [
                48.4545556,
                32.1038208
              ],
              [
                48.4543343,
                32.1033587
              ],
              [
                48.4542199,
                32.1029438
              ],
              [
                48.4541093,
                32.1023892
              ],
              [
                48.4539375,
                32.1015133
              ],
              [
                48.4539605,
                32.0992168
              ],
              [
                48.4539643,
                32.0988356
              ],
              [
                48.4539032,
                32.0980498
              ],
              [
                48.4536819,
                32.0976373
              ],
              [
                48.4532432,
                32.0969476
              ],
              [
                48.4526978,
                32.0964384
              ],
              [
                48.4519921,
                32.0962596
              ],
              [
                48.4515076,
                32.0963062
              ],
              [
                48.4507523,
                32.0964511
              ],
              [
                48.4503211,
                32.096634
              ],
              [
                48.449795,
                32.0968638
              ],
              [
                48.4495767,
                32.0969592
              ],
              [
                48.4492454,
                32.0971038
              ],
              [
                48.4482765,
                32.0977065
              ],
              [
                48.4473114,
                32.0984491
              ],
              [
                48.4469208,
                32.098903
              ],
              [
                48.4466706,
                32.0991936
              ],
              [
                48.4462394,
                32.0996561
              ],
              [
                48.4457588,
                32.1002123
              ],
              [
                48.4450073,
                32.1007698
              ],
              [
                48.4447795,
                32.1008609
              ],
              [
                48.4436074,
                32.1013299
              ],
              [
                48.4424744,
                32.1016114
              ],
              [
                48.4407463,
                32.1018988
              ],
              [
                48.439125,
                32.1020441
              ],
              [
                48.4376144,
                32.1022841
              ],
              [
                48.4364243,
                32.102287
              ],
              [
                48.4350739,
                32.1025234
              ],
              [
                48.4336124,
                32.1029792
              ],
              [
                48.433567,
                32.1029934
              ],
              [
                48.4315185,
                32.1037905
              ],
              [
                48.4296876,
                32.1045333
              ],
              [
                48.4291286,
                32.1048384
              ],
              [
                48.4282341,
                32.1053267
              ],
              [
                48.426571,
                32.1066275
              ],
              [
                48.4252854,
                32.1077872
              ],
              [
                48.4242134,
                32.1089016
              ],
              [
                48.4237901,
                32.109691
              ],
              [
                48.4234695,
                32.1104781
              ],
              [
                48.4232636,
                32.1114004
              ],
              [
                48.4229469,
                32.1120951
              ],
              [
                48.4226799,
                32.1125135
              ],
              [
                48.4223594,
                32.1129759
              ],
              [
                48.4221496,
                32.1135781
              ],
              [
                48.421936,
                32.1140855
              ],
              [
                48.4219399,
                32.1145026
              ],
              [
                48.4220542,
                32.1150099
              ],
              [
                48.4224891,
                32.1154719
              ],
              [
                48.4227531,
                32.115695
              ],
              [
                48.423252,
                32.1161164
              ],
              [
                48.4239082,
                32.1167565
              ],
              [
                48.4244576,
                32.1174012
              ],
              [
                48.4245682,
                32.1177258
              ],
              [
                48.4247894,
                32.1182331
              ],
              [
                48.4246864,
                32.1187405
              ],
              [
                48.4244729,
                32.1191554
              ],
              [
                48.4239883,
                32.1196213
              ],
              [
                48.4238282,
                32.1197578
              ],
              [
                48.4229165,
                32.1203186
              ],
              [
                48.421299,
                32.120971
              ],
              [
                48.4202716,
                32.1212117
              ],
              [
                48.4190865,
                32.1214895
              ],
              [
                48.4183311,
                32.121819
              ],
              [
                48.4177398,
                32.1221924
              ],
              [
                48.4172592,
                32.1227034
              ],
              [
                48.4171029,
                32.1234892
              ],
              [
                48.4170571,
                32.1242751
              ],
              [
                48.4170074,
                32.1246911
              ],
              [
                48.4171257,
                32.1257509
              ],
              [
                48.4170761,
                32.126212
              ],
              [
                48.4170265,
                32.1268152
              ],
              [
                48.4170303,
                32.1272323
              ],
              [
                48.4169807,
                32.1275063
              ],
              [
                48.4168777,
                32.1280182
              ],
              [
                48.4168123,
                32.1281591
              ],
              [
                48.4166642,
                32.1284783
              ],
              [
                48.4165039,
                32.1288492
              ],
              [
                48.4163475,
                32.129218
              ],
              [
                48.4160764,
                32.1294296
              ],
              [
                48.4158097,
                32.1296376
              ],
              [
                48.4145661,
                32.1297836
              ],
              [
                48.4138108,
                32.1298786
              ],
              [
                48.4127313,
                32.1300233
              ],
              [
                48.4114876,
                32.1301692
              ],
              [
                48.4101371,
                32.1302679
              ],
              [
                48.408947,
                32.1304599
              ],
              [
                48.4076577,
                32.1310647
              ],
              [
                48.4073334,
                32.1313895
              ],
              [
                48.4072304,
                32.1318044
              ],
              [
                48.4071235,
                32.1321765
              ],
              [
                48.4070739,
                32.1325001
              ],
              [
                48.4072419,
                32.1329612
              ],
              [
                48.4077301,
                32.1333725
              ],
              [
                48.4095802,
                32.1345218
              ],
              [
                48.4106141,
                32.1349758
              ],
              [
                48.411213,
                32.1353871
              ],
              [
                48.411377,
                32.1358481
              ],
              [
                48.4116021,
                32.1365899
              ],
              [
                48.4113921,
                32.137467
              ],
              [
                48.4113713,
                32.1375508
              ],
              [
                48.4112892,
                32.137882
              ],
              [
                48.4108086,
                32.1386251
              ],
              [
                48.410652,
                32.1387922
              ],
              [
                48.4101143,
                32.1393661
              ],
              [
                48.4096298,
                32.1397395
              ],
              [
                48.4085007,
                32.1406249
              ],
              [
                48.4075889,
                32.1414155
              ],
              [
                48.4068375,
                32.142108
              ],
              [
                48.4064636,
                32.1426662
              ],
              [
                48.4062537,
                32.1431781
              ],
              [
                48.4059905,
                32.1437769
              ],
              [
                48.4055062,
                32.1444275
              ],
              [
                48.4047585,
                32.145217
              ],
              [
                48.4043273,
                32.1455869
              ],
              [
                48.4036293,
                32.1460527
              ],
              [
                48.402607,
                32.1465683
              ],
              [
                48.4010429,
                32.1471291
              ],
              [
                48.3994293,
                32.1479232
              ],
              [
                48.3974839,
                32.1484874
              ],
              [
                48.3958129,
                32.1489602
              ],
              [
                48.3940849,
                32.1493845
              ],
              [
                48.3922005,
                32.1501776
              ],
              [
                48.3910141,
                32.1506919
              ],
              [
                48.3904761,
                32.1512489
              ],
              [
                48.390213,
                32.1518522
              ],
              [
                48.3902168,
                32.1524046
              ],
              [
                48.390171,
                32.153098
              ],
              [
                48.3902817,
                32.1536075
              ],
              [
                48.3909416,
                32.1544349
              ],
              [
                48.3919754,
                32.1553084
              ],
              [
                48.3927422,
                32.1561358
              ],
              [
                48.3934478,
                32.1567342
              ],
              [
                48.394104,
                32.1572369
              ],
              [
                48.394596,
                32.1578377
              ],
              [
                48.3948708,
                32.1582041
              ],
              [
                48.3951454,
                32.1586651
              ],
              [
                48.3953095,
                32.1591262
              ],
              [
                48.3953667,
                32.1594497
              ],
              [
                48.3952638,
                32.1598196
              ],
              [
                48.3949967,
                32.1603281
              ],
              [
                48.3944588,
                32.1606551
              ],
              [
                48.3939209,
                32.1608898
              ],
              [
                48.3930015,
                32.1610805
              ],
              [
                48.3917579,
                32.1608993
              ],
              [
                48.3907279,
                32.1606751
              ],
              [
                48.3892098,
                32.1604995
              ],
              [
                48.3882369,
                32.1606418
              ],
              [
                48.3878594,
                32.1607354
              ],
              [
                48.3872108,
                32.1609722
              ],
              [
                48.3866729,
                32.1612046
              ],
              [
                48.3860282,
                32.1614843
              ],
              [
                48.3851661,
                32.1619985
              ],
              [
                48.3842544,
                32.162789
              ],
              [
                48.3835563,
                32.1634396
              ],
              [
                48.3829689,
                32.1642255
              ],
              [
                48.382595,
                32.1648783
              ],
              [
                48.3823319,
                32.1656641
              ],
              [
                48.381855,
                32.1666371
              ],
              [
                48.3815384,
                32.1675639
              ],
              [
                48.3813821,
                32.1684872
              ],
              [
                48.3810768,
                32.1703836
              ],
              [
                48.380764,
                32.1720047
              ],
              [
                48.3803482,
                32.1738086
              ],
              [
                48.3793984,
                32.176404
              ],
              [
                48.3785592,
                32.1791798
              ],
              [
                48.3777122,
                32.1812633
              ],
              [
                48.3763847,
                32.1844144
              ],
              [
                48.3750573,
                32.1868711
              ],
              [
                48.3739929,
                32.1891394
              ],
              [
                48.3728218,
                32.191135
              ],
              [
                48.3718643,
                32.1930358
              ],
              [
                48.3712273,
                32.1944247
              ],
              [
                48.3705292,
                32.1953052
              ],
              [
                48.3702125,
                32.1960493
              ],
              [
                48.3688901,
                32.1981762
              ],
              [
                48.3687706,
                32.1983683
              ],
              [
                48.3677025,
                32.1999895
              ],
              [
                48.3657227,
                32.2025001
              ],
              [
                48.3642234,
                32.2043107
              ],
              [
                48.362774,
                32.2056578
              ],
              [
                48.3612708,
                32.2070084
              ],
              [
                48.3598213,
                32.2083081
              ],
              [
                48.3582077,
                32.209476
              ],
              [
                48.3575813,
                32.2099919
              ],
              [
                48.3571319,
                32.210362
              ],
              [
                48.3562775,
                32.2112887
              ],
              [
                48.355793,
                32.2117542
              ],
              [
                48.3554726,
                32.2123562
              ],
              [
                48.3554484,
                32.2124957
              ],
              [
                48.35532,
                32.2132367
              ],
              [
                48.3552666,
                32.2136999
              ],
              [
                48.3551101,
                32.2143482
              ],
              [
                48.3548469,
                32.2150415
              ],
              [
                48.3548508,
                32.2155488
              ],
              [
                48.3548013,
                32.2159648
              ],
              [
                48.3546448,
                32.21671
              ],
              [
                48.3543244,
                32.2173119
              ],
              [
                48.3538438,
                32.217773
              ],
              [
                48.3531456,
                32.2185181
              ],
              [
                48.3514824,
                32.2200545
              ],
              [
                48.3498725,
                32.221867
              ],
              [
                48.3486939,
                32.2231228
              ],
              [
                48.3475074,
                32.2239162
              ],
              [
                48.3464317,
                32.2245676
              ],
              [
                48.345787,
                32.225174
              ],
              [
                48.3448792,
                32.2264737
              ],
              [
                48.3441849,
                32.227726
              ],
              [
                48.3437614,
                32.2286527
              ],
              [
                48.3430214,
                32.2308306
              ],
              [
                48.3423843,
                32.2321292
              ],
              [
                48.3418007,
                32.2335213
              ],
              [
                48.3409996,
                32.2347714
              ],
              [
                48.3400346,
                32.2359346
              ],
              [
                48.3390159,
                32.2373266
              ],
              [
                48.337944,
                32.23835
              ],
              [
                48.336708,
                32.2395638
              ],
              [
                48.335743,
                32.24086
              ],
              [
                48.3340836,
                32.2428132
              ],
              [
                48.3329048,
                32.2443461
              ],
              [
                48.3313523,
                32.2462091
              ],
              [
                48.3301163,
                32.2472764
              ],
              [
                48.3288193,
                32.2477945
              ],
              [
                48.3278504,
                32.2484931
              ],
              [
                48.3269883,
                32.2489618
              ],
              [
                48.3254055,
                32.249848
              ],
              [
                48.3226662,
                32.2511019
              ],
              [
                48.3199921,
                32.2525443
              ],
              [
                48.3180732,
                32.2537998
              ],
              [
                48.3170623,
                32.2547724
              ],
              [
                48.3158951,
                32.2559311
              ],
              [
                48.315155,
                32.2568126
              ],
              [
                48.3144645,
                32.2572781
              ],
              [
                48.3135567,
                32.257881
              ],
              [
                48.3128091,
                32.2583925
              ],
              [
                48.312439,
                32.2587634
              ],
              [
                48.3125534,
                32.2591784
              ],
              [
                48.3126107,
                32.2594523
              ],
              [
                48.3128853,
                32.2595912
              ],
              [
                48.3132095,
                32.2596815
              ],
              [
                48.3136941,
                32.2598181
              ],
              [
                48.3141824,
                32.2599096
              ],
              [
                48.3145637,
                32.2602761
              ],
              [
                48.314785,
                32.2606934
              ],
              [
                48.3149566,
                32.2612922
              ],
              [
                48.315075,
                32.2619394
              ],
              [
                48.3151398,
                32.2625382
              ],
              [
                48.3151473,
                32.2630929
              ],
              [
                48.3149948,
                32.2635991
              ],
              [
                48.3145714,
                32.2641109
              ],
              [
                48.3138237,
                32.2644849
              ],
              [
                48.312645,
                32.2649964
              ],
              [
                48.3112525,
                32.2654153
              ],
              [
                48.3096465,
                32.2659762
              ],
              [
                48.3083649,
                32.2665373
              ],
              [
                48.3072357,
                32.2668198
              ],
              [
                48.3062667,
                32.266869
              ],
              [
                48.3054084,
                32.2668732
              ],
              [
                48.3034668,
                32.2667393
              ],
              [
                48.302494,
                32.2666058
              ],
              [
                48.301361,
                32.2665636
              ],
              [
                48.3005028,
                32.2666128
              ],
              [
                48.2993698,
                32.2665706
              ],
              [
                48.2983437,
                32.2663908
              ],
              [
                48.2973748,
                32.2663002
              ],
              [
                48.2965659,
                32.2663505
              ],
              [
                48.2957077,
                32.2666319
              ],
              [
                48.2948036,
                32.2670972
              ],
              [
                48.2938424,
                32.2676537
              ],
              [
                48.2933655,
                32.2681665
              ],
              [
                48.2929459,
                32.2688135
              ],
              [
                48.2926865,
                32.2694594
              ],
              [
                48.2925338,
                32.269925
              ],
              [
                48.2920074,
                32.2706193
              ],
              [
                48.2914772,
                32.271079
              ],
              [
                48.2911033,
                32.2712671
              ],
              [
                48.2906188,
                32.2714078
              ],
              [
                48.2901879,
                32.2713625
              ],
              [
                48.2897567,
                32.2713667
              ],
              [
                48.2888947,
                32.2713234
              ],
              [
                48.2877656,
                32.2713735
              ],
              [
                48.2870711,
                32.271699
              ],
              [
                48.2866986,
                32.2719818
              ],
              [
                48.2864418,
                32.2725331
              ],
              [
                48.2862854,
                32.2729039
              ],
              [
                48.286293,
                32.273364
              ],
              [
                48.286358,
                32.2739177
              ],
              [
                48.2864189,
                32.2745163
              ],
              [
                48.2861062,
                32.2750281
              ],
              [
                48.2857399,
                32.2755364
              ],
              [
                48.2850989,
                32.2759104
              ],
              [
                48.2844009,
                32.2760509
              ],
              [
                48.2836494,
                32.2761925
              ],
              [
                48.282364,
                32.2765188
              ],
              [
                48.2821301,
                32.2765775
              ],
              [
                48.2812386,
                32.2768011
              ],
              [
                48.2810012,
                32.2770305
              ],
              [
                48.2807084,
                32.2773127
              ],
              [
                48.2797547,
                32.2781488
              ],
              [
                48.2787933,
                32.2786149
              ],
              [
                48.2776718,
                32.2789875
              ],
              [
                48.2763367,
                32.2795899
              ],
              [
                48.2749481,
                32.2802429
              ],
              [
                48.2733993,
                32.2810368
              ],
              [
                48.2722283,
                32.2816855
              ],
              [
                48.268846,
                32.281059
              ],
              [
                48.2657433,
                32.2807825
              ],
              [
                48.2644086,
                32.2854331
              ],
              [
                48.2635459,
                32.2895745
              ],
              [
                48.2628212,
                32.2911006
              ],
              [
                48.2618828,
                32.2928115
              ],
              [
                48.2610473,
                32.2942
              ],
              [
                48.260212,
                32.2955885
              ],
              [
                48.259594,
                32.2969773
              ],
              [
                48.2587586,
                32.2983207
              ],
              [
                48.2581367,
                32.2996146
              ],
              [
                48.2575607,
                32.3005872
              ],
              [
                48.2567711,
                32.3014221
              ],
              [
                48.2556573,
                32.3022117
              ],
              [
                48.2546005,
                32.3031377
              ],
              [
                48.2536506,
                32.3041156
              ],
              [
                48.2525367,
                32.3049976
              ],
              [
                48.2500973,
                32.3066599
              ],
              [
                48.2485884,
                32.3069065
              ],
              [
                48.247194,
                32.307345
              ],
              [
                48.2459258,
                32.3078583
              ],
              [
                48.245178,
                32.3084687
              ],
              [
                48.2451325,
                32.308506
              ],
              [
                48.2450919,
                32.3085575
              ],
              [
                48.2432441,
                32.310906
              ],
              [
                48.2419815,
                32.312524
              ],
              [
                48.2405014,
                32.3138667
              ],
              [
                48.2396735,
                32.3155708
              ],
              [
                48.238884,
                32.3165859
              ],
              [
                48.2381019,
                32.3179236
              ],
              [
                48.2373123,
                32.3187561
              ],
              [
                48.2367325,
                32.3194963
              ],
              [
                48.234829,
                32.3211137
              ],
              [
                48.2348068,
                32.3211315
              ],
              [
                48.2335586,
                32.3221318
              ],
              [
                48.2331924,
                32.3226896
              ],
              [
                48.2329903,
                32.3236544
              ],
              [
                48.2329901,
                32.3236576
              ],
              [
                48.2329063,
                32.3250344
              ],
              [
                48.2327804,
                32.32734
              ],
              [
                48.2324295,
                32.3288583
              ],
              [
                48.2323456,
                32.3302834
              ],
              [
                48.2317276,
                32.3320349
              ],
              [
                48.2311592,
                32.3333749
              ],
              [
                48.2304268,
                32.3344341
              ],
              [
                48.226635,
                32.3391003
              ],
              [
                48.2224618,
                32.3434492
              ],
              [
                48.2175026,
                32.3492706
              ],
              [
                48.2163963,
                32.3507046
              ],
              [
                48.2159691,
                32.3508868
              ],
              [
                48.2151146,
                32.3512601
              ],
              [
                48.2140389,
                32.3511733
              ],
              [
                48.2137147,
                32.3510353
              ],
              [
                48.2127991,
                32.35081
              ],
              [
                48.2125855,
                32.3508143
              ],
              [
                48.2122193,
                32.3513675
              ],
              [
                48.2121163,
                32.3518746
              ],
              [
                48.2118112,
                32.3528394
              ],
              [
                48.2109681,
                32.3539501
              ],
              [
                48.2094192,
                32.3546935
              ],
              [
                48.2072257,
                32.3553054
              ],
              [
                48.2038536,
                32.3560557
              ],
              [
                48.1976471,
                32.3576513
              ],
              [
                48.1920242,
                32.3589665
              ],
              [
                48.1899872,
                32.3592525
              ],
              [
                48.187889,
                32.3590366
              ],
              [
                48.1858406,
                32.3584905
              ],
              [
                48.1843223,
                32.3576698
              ],
              [
                48.1831856,
                32.3567991
              ],
              [
                48.1820412,
                32.3556555
              ],
              [
                48.1813813,
                32.3546444
              ],
              [
                48.1808243,
                32.3529436
              ],
              [
                48.179882,
                32.3508802
              ],
              [
                48.1796418,
                32.3489002
              ],
              [
                48.1790619,
                32.3457269
              ],
              [
                48.1784859,
                32.342689
              ],
              [
                48.1778717,
                32.3408516
              ],
              [
                48.177475,
                32.3393324
              ],
              [
                48.1768189,
                32.3383259
              ],
              [
                48.1756249,
                32.3373637
              ],
              [
                48.1744881,
                32.3365403
              ],
              [
                48.1737462,
                32.3349755
              ],
              [
                48.170556,
                32.3335482
              ],
              [
                48.152955,
                32.3321407
              ],
              [
                48.1509362,
                32.3370178
              ],
              [
                48.1479416,
                32.3443681
              ],
              [
                48.148201,
                32.3462407
              ],
              [
                48.1476402,
                32.3487774
              ],
              [
                48.1479454,
                32.3520438
              ],
              [
                48.1479224,
                32.3548091
              ],
              [
                48.1481057,
                32.3566008
              ],
              [
                48.1483422,
                32.358211
              ],
              [
                48.1493263,
                32.3598675
              ],
              [
                48.1501465,
                32.3610605
              ],
              [
                48.1514015,
                32.3626172
              ],
              [
                48.1521072,
                32.36312
              ],
              [
                48.1529733,
                32.3639443
              ],
              [
                48.1542175,
                32.364745
              ],
              [
                48.1543273,
                32.3648157
              ],
              [
                48.1560058,
                32.3657733
              ],
              [
                48.1582183,
                32.3666392
              ],
              [
                48.1591453,
                32.3674625
              ],
              [
                48.1595954,
                32.3691633
              ],
              [
                48.1596642,
                32.3704993
              ],
              [
                48.1595725,
                32.3719263
              ],
              [
                48.1593781,
                32.3733105
              ],
              [
                48.1589049,
                32.374463
              ],
              [
                48.1580544,
                32.3752485
              ],
              [
                48.1574212,
                32.3761246
              ],
              [
                48.1555595,
                32.377701
              ],
              [
                48.1548203,
                32.3780744
              ],
              [
                48.1528854,
                32.3790517
              ],
              [
                48.1517715,
                32.3800702
              ],
              [
                48.1508217,
                32.38187
              ],
              [
                48.1499291,
                32.3834413
              ],
              [
                48.1492958,
                32.3847321
              ],
              [
                48.1492538,
                32.3856553
              ],
              [
                48.1491165,
                32.3875434
              ],
              [
                48.1490937,
                32.3903966
              ],
              [
                48.1490708,
                32.3928824
              ],
              [
                48.1489563,
                32.3968019
              ],
              [
                48.1486474,
                32.4025114
              ],
              [
                48.1482468,
                32.4051396
              ],
              [
                48.1483765,
                32.4072569
              ],
              [
                48.1484565,
                32.4092378
              ],
              [
                48.1484718,
                32.4107101
              ],
              [
                48.1488076,
                32.4117659
              ],
              [
                48.1493569,
                32.4126394
              ],
              [
                48.1500702,
                32.4136
              ],
              [
                48.1509475,
                32.4151143
              ],
              [
                48.1525344,
                32.4170865
              ],
              [
                48.1529884,
                32.4191142
              ],
              [
                48.1536064,
                32.4211343
              ],
              [
                48.1537819,
                32.4222406
              ],
              [
                48.1537972,
                32.4236678
              ],
              [
                48.1536561,
                32.4253732
              ],
              [
                48.1536712,
                32.4266629
              ],
              [
                48.1530418,
                32.4279515
              ],
              [
                48.1527253,
                32.4286454
              ],
              [
                48.1524087,
                32.4292897
              ],
              [
                48.1515046,
                32.4303557
              ],
              [
                48.1506004,
                32.4313744
              ],
              [
                48.1493187,
                32.4323958
              ],
              [
                48.1478767,
                32.4335059
              ],
              [
                48.1463929,
                32.4354942
              ],
              [
                48.1453284,
                32.4369285
              ],
              [
                48.1444777,
                32.4380385
              ],
              [
                48.1443328,
                32.4392367
              ],
              [
                48.1440239,
                32.4407128
              ],
              [
                48.1439285,
                32.4415402
              ],
              [
                48.1440468,
                32.442555
              ],
              [
                48.1444434,
                32.4441644
              ],
              [
                48.1450995,
                32.4449434
              ],
              [
                48.1460266,
                32.445812
              ],
              [
                48.1471177,
                32.4468195
              ],
              [
                48.1491814,
                32.4480046
              ],
              [
                48.1510773,
                32.4487756
              ],
              [
                48.1522213,
                32.4494878
              ],
              [
                48.1523285,
                32.4495545
              ],
              [
                48.1533623,
                32.4505607
              ],
              [
                48.1543961,
                32.4511521
              ],
              [
                48.1550026,
                32.4521171
              ],
              [
                48.1556626,
                32.4531756
              ],
              [
                48.1559983,
                32.4542765
              ],
              [
                48.15596,
                32.4555199
              ],
              [
                48.1557084,
                32.4569974
              ],
              [
                48.1554452,
                32.4576406
              ],
              [
                48.1543808,
                32.4587053
              ],
              [
                48.153202,
                32.4594495
              ],
              [
                48.1519128,
                32.4602386
              ],
              [
                48.1507836,
                32.4605669
              ],
              [
                48.1492458,
                32.4609915
              ],
              [
                48.1487389,
                32.4611314
              ],
              [
                48.146965,
                32.461648
              ],
              [
                48.1457252,
                32.4618881
              ],
              [
                48.1449203,
                32.46212
              ],
              [
                48.1447106,
                32.4628141
              ],
              [
                48.1446113,
                32.4634587
              ],
              [
                48.1446762,
                32.4645624
              ],
              [
                48.1448044,
                32.4650098
              ],
              [
                48.1448478,
                32.4651614
              ],
              [
                48.1450195,
                32.4663127
              ],
              [
                48.1449852,
                32.4676936
              ],
              [
                48.1448861,
                32.468708
              ],
              [
                48.144413,
                32.4698153
              ],
              [
                48.1443711,
                32.4708737
              ],
              [
                48.1437874,
                32.4718433
              ],
              [
                48.143425,
                32.4729035
              ],
              [
                48.1428909,
                32.4737366
              ],
              [
                48.142086,
                32.4741106
              ],
              [
                48.1414986,
                32.4745751
              ],
              [
                48.1406898,
                32.4747167
              ],
              [
                48.1403159,
                32.4746615
              ],
              [
                48.1394997,
                32.4745409
              ],
              [
                48.1373329,
                32.4740453
              ],
              [
                48.1352196,
                32.4735982
              ],
              [
                48.1336555,
                32.4736054
              ],
              [
                48.1323585,
                32.4736592
              ],
              [
                48.1311187,
                32.473942
              ],
              [
                48.1302566,
                32.474132
              ],
              [
                48.1292915,
                32.4747817
              ],
              [
                48.1285439,
                32.4754792
              ],
              [
                48.1280098,
                32.4758952
              ],
              [
                48.1273727,
                32.4769581
              ],
              [
                48.1271668,
                32.4778776
              ],
              [
                48.1269073,
                32.4788928
              ],
              [
                48.1269722,
                32.4800461
              ],
              [
                48.1270943,
                32.4811985
              ],
              [
                48.1269418,
                32.4822116
              ],
              [
                48.1271601,
                32.4827876
              ],
              [
                48.1274986,
                32.4836804
              ],
              [
                48.1279487,
                32.4855188
              ],
              [
                48.1285629,
                32.4871287
              ],
              [
                48.1291695,
                32.4884611
              ],
              [
                48.129505,
                32.4892893
              ],
              [
                48.1297836,
                32.4902536
              ],
              [
                48.1298485,
                32.4912221
              ],
              [
                48.1298599,
                32.4921871
              ],
              [
                48.1299858,
                32.4938016
              ],
              [
                48.1299934,
                32.4946291
              ],
              [
                48.1298196,
                32.4952562
              ],
              [
                48.1295203,
                32.4959234
              ],
              [
                48.1289901,
                32.4968918
              ],
              [
                48.1285744,
                32.4982302
              ],
              [
                48.1279002,
                32.4991638
              ],
              [
                48.1275814,
                32.4994157
              ],
              [
                48.1273647,
                32.499546
              ],
              [
                48.1263312,
                32.4999935
              ],
              [
                48.1252451,
                32.500406
              ],
              [
                48.1241187,
                32.5007904
              ],
              [
                48.1215707,
                32.5011784
              ],
              [
                48.1194573,
                32.5013306
              ],
              [
                48.1165771,
                32.5012173
              ],
              [
                48.1141853,
                32.5009122
              ],
              [
                48.1111869,
                32.5003317
              ],
              [
                48.1074711,
                32.5000569
              ],
              [
                48.1067428,
                32.4997854
              ],
              [
                48.1061936,
                32.4988667
              ],
              [
                48.1055908,
                32.4981811
              ],
              [
                48.1052017,
                32.497124
              ],
              [
                48.1050263,
                32.4956977
              ],
              [
                48.1049081,
                32.4946355
              ],
              [
                48.1048499,
                32.4944223
              ],
              [
                48.1046829,
                32.4938099
              ],
              [
                48.1043548,
                32.4931689
              ],
              [
                48.1036454,
                32.4923862
              ],
              [
                48.1032599,
                32.4919288
              ],
              [
                48.1021195,
                32.4912443
              ],
              [
                48.1014377,
                32.4908811
              ],
              [
                48.1009255,
                32.4906082
              ],
              [
                48.0998383,
                32.4900579
              ],
              [
                48.0995064,
                32.4894642
              ],
              [
                48.0995026,
                32.488957
              ],
              [
                48.0994342,
                32.4888017
              ],
              [
                48.0991173,
                32.4880825
              ],
              [
                48.0986824,
                32.4877164
              ],
              [
                48.0983009,
                32.4876287
              ],
              [
                48.098263,
                32.4876287
              ],
              [
                48.0979233,
                32.487629
              ],
              [
                48.0974703,
                32.4876898
              ],
              [
                48.0972215,
                32.4877232
              ],
              [
                48.0961952,
                32.4879159
              ],
              [
                48.0954437,
                32.4883809
              ],
              [
                48.0943183,
                32.489216
              ],
              [
                48.0937271,
                32.4897726
              ],
              [
                48.0930329,
                32.4906536
              ],
              [
                48.0922852,
                32.4917183
              ],
              [
                48.0915412,
                32.4929205
              ],
              [
                48.091221,
                32.4936096
              ],
              [
                48.0910829,
                32.494221
              ],
              [
                48.090908,
                32.4949954
              ],
              [
                48.0905813,
                32.4957767
              ],
              [
                48.0903282,
                32.4963795
              ],
              [
                48.0899286,
                32.4978939
              ],
              [
                48.0897303,
                32.4982973
              ],
              [
                48.089167,
                32.4991589
              ],
              [
                48.0885963,
                32.4998083
              ],
              [
                48.0874214,
                32.5010141
              ],
              [
                48.0864602,
                32.5019002
              ],
              [
                48.0853311,
                32.5027801
              ],
              [
                48.0844727,
                32.5032493
              ],
              [
                48.0832787,
                32.5034403
              ],
              [
                48.0820312,
                32.503497
              ],
              [
                48.0799751,
                32.5038347
              ],
              [
                48.0790558,
                32.5039824
              ],
              [
                48.0781861,
                32.5041245
              ],
              [
                48.0767823,
                32.5045517
              ],
              [
                48.0757027,
                32.5048827
              ],
              [
                48.0749435,
                32.5050251
              ],
              [
                48.073967,
                32.5050767
              ],
              [
                48.0731544,
                32.5049924
              ],
              [
                48.0725517,
                32.5047192
              ],
              [
                48.0720558,
                32.5042659
              ],
              [
                48.071663,
                32.5035737
              ],
              [
                48.0715842,
                32.502783
              ],
              [
                48.0716897,
                32.501823
              ],
              [
                48.0717316,
                32.5008998
              ],
              [
                48.071902,
                32.4997677
              ],
              [
                48.0719987,
                32.4990442
              ],
              [
                48.0721168,
                32.4977351
              ],
              [
                48.0721091,
                32.4965831
              ],
              [
                48.0718841,
                32.4956583
              ],
              [
                48.0714416,
                32.494557
              ],
              [
                48.0710602,
                32.4941897
              ],
              [
                48.0699805,
                32.4940113
              ],
              [
                48.0686799,
                32.4937894
              ],
              [
                48.0674895,
                32.4937526
              ],
              [
                48.0667343,
                32.4937553
              ],
              [
                48.0653801,
                32.4937169
              ],
              [
                48.0642968,
                32.4934009
              ],
              [
                48.0630493,
                32.4924859
              ],
              [
                48.0616875,
                32.4915277
              ],
              [
                48.0606041,
                32.4908419
              ],
              [
                48.0588645,
                32.4897915
              ],
              [
                48.0569153,
                32.48925
              ],
              [
                48.0556717,
                32.4890293
              ],
              [
                48.0541572,
                32.489129
              ],
              [
                48.0526649,
                32.4895759
              ],
              [
                48.0525933,
                32.4895973
              ],
              [
                48.0512466,
                32.4901585
              ],
              [
                48.0497931,
                32.4909066
              ],
              [
                48.0486106,
                32.4919247
              ],
              [
                48.04813,
                32.4928511
              ],
              [
                48.0478096,
                32.4935423
              ],
              [
                48.0478134,
                32.493912
              ],
              [
                48.0483589,
                32.4948309
              ],
              [
                48.049015,
                32.4956082
              ],
              [
                48.0505333,
                32.4961555
              ],
              [
                48.0530777,
                32.4968756
              ],
              [
                48.0555688,
                32.4973216
              ],
              [
                48.0583305,
                32.4979971
              ],
              [
                48.0604973,
                32.4986316
              ],
              [
                48.0621203,
                32.4992285
              ],
              [
                48.0635435,
                32.4998005
              ],
              [
                48.0638428,
                32.4999923
              ],
              [
                48.0652007,
                32.5006889
              ],
              [
                48.0654798,
                32.5008993
              ],
              [
                48.0660896,
                32.5013588
              ],
              [
                48.0667534,
                32.5019987
              ],
              [
                48.0670433,
                32.5031933
              ],
              [
                48.0672722,
                32.5037915
              ],
              [
                48.067337,
                32.5046202
              ],
              [
                48.0671883,
                32.5053605
              ],
              [
                48.0670357,
                32.5060039
              ],
              [
                48.066826,
                32.5065602
              ],
              [
                48.066185,
                32.5070727
              ],
              [
                48.0647278,
                32.5077284
              ],
              [
                48.063652,
                32.5083818
              ],
              [
                48.0625802,
                32.5092651
              ],
              [
                48.0615082,
                32.5100087
              ],
              [
                48.0605468,
                32.5111245
              ],
              [
                48.0593147,
                32.5120085
              ],
              [
                48.0584564,
                32.512615
              ],
              [
                48.0576477,
                32.5131258
              ],
              [
                48.0564041,
                32.5133198
              ],
              [
                48.0557518,
                32.5133294
              ],
              [
                48.0542832,
                32.5131529
              ],
              [
                48.0537338,
                32.512696
              ],
              [
                48.0532876,
                32.511962
              ],
              [
                48.052948,
                32.5112734
              ],
              [
                48.05299,
                32.5104449
              ],
              [
                48.0529805,
                32.5098252
              ],
              [
                48.0529709,
                32.509198
              ],
              [
                48.0529557,
                32.5081856
              ],
              [
                48.0525628,
                32.5074032
              ],
              [
                48.0522271,
                32.5068544
              ],
              [
                48.0516204,
                32.5062135
              ],
              [
                48.0507431,
                32.5056182
              ],
              [
                48.0497055,
                32.5053053
              ],
              [
                48.0487252,
                32.5050344
              ],
              [
                48.0478019,
                32.505042
              ],
              [
                48.0471001,
                32.5052329
              ],
              [
                48.0466155,
                32.5055574
              ],
              [
                48.0452729,
                32.5064883
              ],
              [
                48.0443116,
                32.5075566
              ],
              [
                48.042755,
                32.5085839
              ],
              [
                48.0416743,
                32.5096192
              ],
              [
                48.0412025,
                32.510071
              ],
              [
                48.0400772,
                32.5110025
              ],
              [
                48.0379754,
                32.5119402
              ],
              [
                48.0368423,
                32.5123643
              ],
              [
                48.0350036,
                32.5126996
              ],
              [
                48.0337563,
                32.5128483
              ],
              [
                48.0325661,
                32.5129464
              ],
              [
                48.0315285,
                32.5127258
              ],
              [
                48.0306549,
                32.5123626
              ],
              [
                48.0300522,
                32.5120463
              ],
              [
                48.0292283,
                32.5115422
              ],
              [
                48.0284042,
                32.5108105
              ],
              [
                48.0276909,
                32.5103113
              ],
              [
                48.0269203,
                32.5097611
              ],
              [
                48.0259857,
                32.5090786
              ],
              [
                48.0247345,
                32.5087199
              ],
              [
                48.0237542,
                32.5085862
              ],
              [
                48.0225029,
                32.5085025
              ],
              [
                48.021038,
                32.5085602
              ],
              [
                48.0205197,
                32.508549
              ],
              [
                48.0198957,
                32.5085354
              ],
              [
                48.0198975,
                32.5085264
              ],
              [
                48.0200997,
                32.5075981
              ],
              [
                48.0203553,
                32.5066755
              ],
              [
                48.0205039,
                32.5057075
              ],
              [
                48.0205917,
                32.5044136
              ],
              [
                48.0206794,
                32.5030295
              ],
              [
                48.0206565,
                32.5016022
              ],
              [
                48.0206565,
                32.5000604
              ],
              [
                48.0204696,
                32.4957306
              ],
              [
                48.0202407,
                32.4935186
              ],
              [
                48.0201188,
                32.4912144
              ],
              [
                48.0203819,
                32.4896022
              ],
              [
                48.020588,
                32.4877093
              ],
              [
                48.0208398,
                32.4848978
              ],
              [
                48.020939,
                32.4828219
              ],
              [
                48.0213547,
                32.4805147
              ],
              [
                48.0215072,
                32.4786272
              ],
              [
                48.0217094,
                32.4758573
              ],
              [
                48.0216904,
                32.4725841
              ],
              [
                48.0218849,
                32.4691739
              ],
              [
                48.022129,
                32.4649309
              ],
              [
                48.0223846,
                32.4620248
              ],
              [
                48.0224724,
                32.4588443
              ],
              [
                48.022892,
                32.4566769
              ],
              [
                48.0228843,
                32.4549253
              ],
              [
                48.0229226,
                32.4528052
              ],
              [
                48.0225334,
                32.4506412
              ],
              [
                48.0220871,
                32.4481084
              ],
              [
                48.0212592,
                32.4446109
              ],
              [
                48.0201607,
                32.4412039
              ],
              [
                48.0197144,
                32.4382091
              ],
              [
                48.0193673,
                32.4344795
              ],
              [
                48.019291,
                32.4306076
              ],
              [
                48.0188942,
                32.4270594
              ],
              [
                48.0182038,
                32.4189061
              ],
              [
                48.0187225,
                32.4155397
              ],
              [
                48.0194015,
                32.4119832
              ],
              [
                48.0195504,
                32.4096786
              ],
              [
                48.0200082,
                32.4050214
              ],
              [
                48.0214232,
                32.3980111
              ],
              [
                48.0221062,
                32.395194
              ],
              [
                48.022892,
                32.3915476
              ],
              [
                48.0233115,
                32.3897024
              ],
              [
                48.0243263,
                32.3881756
              ],
              [
                48.0257073,
                32.3852645
              ],
              [
                48.0271415,
                32.3826296
              ],
              [
                48.0292741,
                32.379486
              ],
              [
                48.030491,
                32.3763005
              ],
              [
                48.0311241,
                32.3742665
              ],
              [
                48.0316505,
                32.3723292
              ],
              [
                48.0324859,
                32.3682713
              ],
              [
                48.0332718,
                32.3654092
              ],
              [
                48.0345955,
                32.3621292
              ],
              [
                48.0354385,
                32.3597755
              ],
              [
                48.0356369,
                32.357285
              ],
              [
                48.0356255,
                32.3553508
              ],
              [
                48.0354539,
                32.3539695
              ],
              [
                48.0348587,
                32.3530043
              ],
              [
                48.0342637,
                32.3521766
              ],
              [
                48.0335046,
                32.3511647
              ],
              [
                48.0322647,
                32.3503421
              ],
              [
                48.0312957,
                32.3501164
              ],
              [
                48.0290909,
                32.3495303
              ],
              [
                48.0260811,
                32.3491279
              ],
              [
                48.020977,
                32.3483695
              ],
              [
                48.0175934,
                32.3482016
              ],
              [
                48.0135651,
                32.347714
              ],
              [
                48.0085144,
                32.3473665
              ],
              [
                48.0046012,
                32.3461353
              ],
              [
                48.0008122,
                32.3442443
              ],
              [
                48.0000037,
                32.3437787
              ],
              [
                47.9963929,
                32.3424035
              ],
              [
                47.9890137,
                32.3395992
              ],
              [
                47.9848061,
                32.3380155
              ],
              [
                47.9812584,
                32.3367991
              ],
              [
                47.9778594,
                32.3347477
              ],
              [
                47.9760476,
                32.3335637
              ],
              [
                47.9746055,
                32.3317259
              ],
              [
                47.9717102,
                32.3274573
              ],
              [
                47.969574,
                32.3230445
              ],
              [
                47.9670754,
                32.3166462
              ],
              [
                47.9655799,
                32.311532
              ],
              [
                47.9647218,
                32.3090929
              ],
              [
                47.9643098,
                32.3070634
              ],
              [
                47.9638901,
                32.3048962
              ],
              [
                47.9633637,
                32.3026386
              ],
              [
                47.9627876,
                32.3005668
              ],
              [
                47.9625512,
                32.2995063
              ],
              [
                47.9621429,
                32.2977113
              ],
              [
                47.9618987,
                32.2962809
              ],
              [
                47.9617768,
                32.2954034
              ],
              [
                47.9619751,
                32.2943871
              ],
              [
                47.9624443,
                32.2933661
              ],
              [
                47.9630279,
                32.292438
              ],
              [
                47.9656447,
                32.2901546
              ],
              [
                47.9681548,
                32.288148
              ],
              [
                47.9723396,
                32.2856181
              ],
              [
                47.9772225,
                32.2828028
              ],
              [
                47.9806177,
                32.2810063
              ],
              [
                47.9810371,
                32.2807844
              ],
              [
                47.9836159,
                32.2795139
              ],
              [
                47.9849549,
                32.2785339
              ],
              [
                47.9858627,
                32.2777396
              ],
              [
                47.9861221,
                32.2770922
              ],
              [
                47.9866448,
                32.2760746
              ],
              [
                47.9870034,
                32.2749133
              ],
              [
                47.9870987,
                32.274174
              ],
              [
                47.987194,
                32.2732972
              ],
              [
                47.9870606,
                32.2720025
              ],
              [
                47.9869232,
                32.2703899
              ],
              [
                47.9866752,
                32.2686393
              ],
              [
                47.9860992,
                32.2667007
              ],
              [
                47.9856416,
                32.2651818
              ],
              [
                47.9850235,
                32.2638935
              ],
              [
                47.9840813,
                32.2627485
              ],
              [
                47.9830932,
                32.2620667
              ],
              [
                47.9813995,
                32.2612486
              ],
              [
                47.9795952,
                32.2603421
              ],
              [
                47.9781799,
                32.2598913
              ],
              [
                47.9770354,
                32.25967
              ],
              [
                47.9759483,
                32.2594028
              ],
              [
                47.9751319,
                32.259133
              ],
              [
                47.9727859,
                32.2581369
              ],
              [
                47.9681892,
                32.2555922
              ],
              [
                47.9643631,
                32.2537309
              ],
              [
                47.9620591,
                32.2520436
              ],
              [
                47.9598738,
                32.2499872
              ],
              [
                47.9564797,
                32.2476356
              ],
              [
                47.9552192,
                32.2467622
              ],
              [
                47.9517365,
                32.2440906
              ],
              [
                47.9485816,
                32.24165
              ],
              [
                47.9453125,
                32.2384717
              ],
              [
                47.9434051,
                32.2360769
              ],
              [
                47.942245,
                32.2343375
              ],
              [
                47.9417152,
                32.2335431
              ],
              [
                47.9385491,
                32.2282484
              ],
              [
                47.9352799,
                32.2231405
              ],
              [
                47.9316292,
                32.2190443
              ],
              [
                47.9283103,
                32.2156795
              ],
              [
                47.925045,
                32.2125978
              ],
              [
                47.9212913,
                32.2094658
              ],
              [
                47.9182472,
                32.2069775
              ],
              [
                47.9158553,
                32.2051814
              ],
              [
                47.9118881,
                32.2025104
              ],
              [
                47.9075966,
                32.1999329
              ],
              [
                47.9031983,
                32.1975396
              ],
              [
                47.8954316,
                32.1931183
              ],
              [
                47.8904231,
                32.19042
              ],
              [
                47.8900528,
                32.1902205
              ],
              [
                47.8860893,
                32.1876864
              ],
              [
                47.8835907,
                32.1858441
              ],
              [
                47.8816871,
                32.1840977
              ],
              [
                47.8802185,
                32.1823011
              ],
              [
                47.8782616,
                32.1800913
              ],
              [
                47.8729857,
                32.1731878
              ],
              [
                47.8685798,
                32.1673402
              ],
              [
                47.8650436,
                32.162738
              ],
              [
                47.8576547,
                32.1550512
              ],
              [
                47.8503762,
                32.1480092
              ],
              [
                47.8463593,
                32.1446499
              ],
              [
                47.8388139,
                32.1374699
              ],
              [
                47.8309441,
                32.1310724
              ],
              [
                47.8265496,
                32.1279443
              ],
              [
                47.8213958,
                32.1241275
              ],
              [
                47.8186303,
                32.1218717
              ],
              [
                47.8143997,
                32.1192025
              ],
              [
                47.8107982,
                32.1166055
              ],
              [
                47.8100625,
                32.116073
              ],
              [
                47.8050728,
                32.1130373
              ],
              [
                47.8020364,
                32.111011
              ],
              [
                47.7981873,
                32.1086192
              ],
              [
                47.7930374,
                32.1058585
              ],
              [
                47.7884331,
                32.1034653
              ],
              [
                47.7851791,
                32.1020845
              ],
              [
                47.7839936,
                32.1014906
              ],
              [
                47.7818756,
                32.1004295
              ],
              [
                47.7782975,
                32.0987743
              ],
              [
                47.7724457,
                32.0959656
              ],
              [
                47.7670287,
                32.0933459
              ],
              [
                47.7605285,
                32.0907703
              ],
              [
                47.7558687,
                32.0888433
              ],
              [
                47.7500797,
                32.0867543
              ],
              [
                47.7326755,
                32.0791152
              ],
              [
                47.7001868,
                32.0648534
              ],
              [
                47.6656316,
                32.0496671
              ],
              [
                47.6651397,
                32.0493721
              ],
              [
                47.6646987,
                32.0491255
              ],
              [
                47.6644396,
                32.0488708
              ],
              [
                47.664111,
                32.048542
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555111,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شوشتر",
          "name:en": "Shushtar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279468",
          "wikipedia": "en:Shushtar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.5678798,
                31.9302424
              ],
              [
                48.5778031,
                31.9204551
              ],
              [
                48.5868748,
                31.918281
              ],
              [
                48.5945703,
                31.91881
              ],
              [
                48.6070049,
                31.9213074
              ],
              [
                48.6159314,
                31.9172175
              ],
              [
                48.615574,
                31.9122251
              ],
              [
                48.6065472,
                31.9044196
              ],
              [
                48.6059181,
                31.8998993
              ],
              [
                48.6044575,
                31.8923071
              ],
              [
                48.6169789,
                31.8849115
              ],
              [
                48.6247531,
                31.8833256
              ],
              [
                48.631532,
                31.8756027
              ],
              [
                48.636488,
                31.8743607
              ],
              [
                48.6361056,
                31.8781567
              ],
              [
                48.6306463,
                31.8834995
              ],
              [
                48.6300913,
                31.8874673
              ],
              [
                48.6436531,
                31.8901629
              ],
              [
                48.6474735,
                31.8875814
              ],
              [
                48.65131,
                31.882727
              ],
              [
                48.6545383,
                31.8808038
              ],
              [
                48.6546964,
                31.8780594
              ],
              [
                48.6532386,
                31.875264
              ],
              [
                48.6502166,
                31.8695528
              ],
              [
                48.6472528,
                31.8625488
              ],
              [
                48.647194,
                31.8582194
              ],
              [
                48.6471965,
                31.8507332
              ],
              [
                48.6416877,
                31.8515309
              ],
              [
                48.6378815,
                31.8592606
              ],
              [
                48.6346793,
                31.8630936
              ],
              [
                48.6269689,
                31.8619613
              ],
              [
                48.6278279,
                31.856532
              ],
              [
                48.6359316,
                31.8500067
              ],
              [
                48.6485012,
                31.8439161
              ],
              [
                48.6550358,
                31.8410504
              ],
              [
                48.6591873,
                31.8392732
              ],
              [
                48.6623134,
                31.8320701
              ],
              [
                48.6604938,
                31.8264189
              ],
              [
                48.6595508,
                31.8235749
              ],
              [
                48.657352,
                31.8221491
              ],
              [
                48.6559267,
                31.8211871
              ],
              [
                48.6479004,
                31.8202898
              ],
              [
                48.6444176,
                31.8197999
              ],
              [
                48.6366532,
                31.8186324
              ],
              [
                48.6330733,
                31.8171932
              ],
              [
                48.6335246,
                31.8120793
              ],
              [
                48.6379853,
                31.8096539
              ],
              [
                48.6426075,
                31.8071341
              ],
              [
                48.6457316,
                31.8014395
              ],
              [
                48.6490238,
                31.7953989
              ],
              [
                48.6476413,
                31.790986
              ],
              [
                48.6463059,
                31.7866875
              ],
              [
                48.644074,
                31.7841236
              ],
              [
                48.6426305,
                31.7824388
              ],
              [
                48.6412434,
                31.7808153
              ],
              [
                48.6436273,
                31.7749278
              ],
              [
                48.6524124,
                31.7719664
              ],
              [
                48.6541725,
                31.7705112
              ],
              [
                48.6573693,
                31.7676782
              ],
              [
                48.6569775,
                31.7657027
              ],
              [
                48.6558737,
                31.7590793
              ],
              [
                48.6554464,
                31.7569221
              ],
              [
                48.654738,
                31.7528294
              ],
              [
                48.6562254,
                31.753044
              ],
              [
                48.6638539,
                31.7541179
              ],
              [
                48.6633034,
                31.7557183
              ],
              [
                48.6674805,
                31.7589311
              ],
              [
                48.670967,
                31.7624649
              ],
              [
                48.6733779,
                31.7651718
              ],
              [
                48.6752013,
                31.7672366
              ],
              [
                48.6771316,
                31.769026
              ],
              [
                48.6790581,
                31.7700374
              ],
              [
                48.6808817,
                31.7710447
              ],
              [
                48.682167,
                31.7713229
              ],
              [
                48.6838265,
                31.7710938
              ],
              [
                48.684574,
                31.7707263
              ],
              [
                48.685215,
                31.769534
              ],
              [
                48.6855042,
                31.7689058
              ],
              [
                48.6861229,
                31.7675618
              ],
              [
                48.6865998,
                31.7645312
              ],
              [
                48.6870727,
                31.7599897
              ],
              [
                48.6872292,
                31.7566421
              ],
              [
                48.6871758,
                31.7556332
              ],
              [
                48.686905,
                31.7535675
              ],
              [
                48.68647,
                31.7504459
              ],
              [
                48.6860192,
                31.7500341
              ],
              [
                48.6845551,
                31.7483525
              ],
              [
                48.6828386,
                31.7467407
              ],
              [
                48.6806983,
                31.7449453
              ],
              [
                48.6793594,
                31.7436583
              ],
              [
                48.6780739,
                31.7422776
              ],
              [
                48.6774862,
                31.7413131
              ],
              [
                48.6772727,
                31.7404862
              ],
              [
                48.6772727,
                31.739431
              ],
              [
                48.6777039,
                31.7385145
              ],
              [
                48.6790999,
                31.7375095
              ],
              [
                48.680439,
                31.736641
              ],
              [
                48.683014,
                31.735777
              ],
              [
                48.685211,
                31.7350481
              ],
              [
                48.6874084,
                31.7346889
              ],
              [
                48.6892319,
                31.7346927
              ],
              [
                48.6912653,
                31.7347882
              ],
              [
                48.6922302,
                31.7350672
              ],
              [
                48.6936759,
                31.7355759
              ],
              [
                48.6948547,
                31.7355814
              ],
              [
                48.6957665,
                31.7355822
              ],
              [
                48.6962508,
                31.7352166
              ],
              [
                48.6969489,
                31.7348054
              ],
              [
                48.6970557,
                31.7343
              ],
              [
                48.6975366,
                31.7332467
              ],
              [
                48.6979143,
                31.7320563
              ],
              [
                48.6985055,
                31.7308178
              ],
              [
                48.6983987,
                31.7298554
              ],
              [
                48.6985053,
                31.7280648
              ],
              [
                48.6977616,
                31.7243919
              ],
              [
                48.6965827,
                31.7216356
              ],
              [
                48.695835,
                31.719205
              ],
              [
                48.6941224,
                31.7170884
              ],
              [
                48.6931076,
                31.7147454
              ],
              [
                48.6925735,
                31.7129072
              ],
              [
                48.6927338,
                31.7116249
              ],
              [
                48.6930046,
                31.7101574
              ],
              [
                48.6932181,
                31.7092865
              ],
              [
                48.6941298,
                31.7080944
              ],
              [
                48.6964875,
                31.7068631
              ],
              [
                48.6996498,
                31.7056328
              ],
              [
                48.6996521,
                31.7056323
              ],
              [
                48.702652,
                31.7049993
              ],
              [
                48.704689,
                31.7042265
              ],
              [
                48.7061347,
                31.7032176
              ],
              [
                48.7071534,
                31.702077
              ],
              [
                48.7079048,
                31.7012968
              ],
              [
                48.7082787,
                31.7003814
              ],
              [
                48.7083894,
                31.6992334
              ],
              [
                48.7081757,
                31.6979489
              ],
              [
                48.707531,
                31.697076
              ],
              [
                48.7067668,
                31.6966452
              ],
              [
                48.7061387,
                31.6962911
              ],
              [
                48.7038092,
                31.6950338
              ],
              [
                48.7034074,
                31.6948169
              ],
              [
                48.7030097,
                31.6946937
              ],
              [
                48.6983224,
                31.6932416
              ],
              [
                48.691681,
                31.69171
              ],
              [
                48.6853065,
                31.6899959
              ],
              [
                48.6831664,
                31.6887958
              ],
              [
                48.6808662,
                31.6875049
              ],
              [
                48.679901,
                31.686263
              ],
              [
                48.6792601,
                31.6852502
              ],
              [
                48.6791534,
                31.6844253
              ],
              [
                48.6792106,
                31.6835988
              ],
              [
                48.6794777,
                31.6829589
              ],
              [
                48.6801068,
                31.6827306
              ],
              [
                48.6802293,
                31.6826862
              ],
              [
                48.6831742,
                31.6825571
              ],
              [
                48.6879921,
                31.6823875
              ],
              [
                48.6924402,
                31.6821231
              ],
              [
                48.6961899,
                31.6813522
              ],
              [
                48.6984404,
                31.6806262
              ],
              [
                48.7000466,
                31.6797127
              ],
              [
                48.7012254,
                31.6782481
              ],
              [
                48.7017632,
                31.6767809
              ],
              [
                48.7026213,
                31.6751774
              ],
              [
                48.702942,
                31.6732509
              ],
              [
                48.7023583,
                31.6710465
              ],
              [
                48.7010191,
                31.6688871
              ],
              [
                48.6995202,
                31.6670473
              ],
              [
                48.6979712,
                31.6650239
              ],
              [
                48.6970427,
                31.6642254
              ],
              [
                48.6958848,
                31.6632298
              ],
              [
                48.6942253,
                31.6618018
              ],
              [
                48.6936911,
                31.6607911
              ],
              [
                48.6935309,
                31.6594601
              ],
              [
                48.6935311,
                31.6577623
              ],
              [
                48.6939086,
                31.6569394
              ],
              [
                48.6946067,
                31.6557029
              ],
              [
                48.6958922,
                31.6546957
              ],
              [
                48.6961498,
                31.6545524
              ],
              [
                48.6971246,
                31.6540099
              ],
              [
                48.6989974,
                31.6532365
              ],
              [
                48.6999626,
                31.6529631
              ],
              [
                48.7009772,
                31.652828
              ],
              [
                48.7017824,
                31.6528313
              ],
              [
                48.7026901,
                31.6529265
              ],
              [
                48.7033882,
                31.653248
              ],
              [
                48.7041895,
                31.654029
              ],
              [
                48.7059556,
                31.655824
              ],
              [
                48.7086295,
                31.6590445
              ],
              [
                48.7102891,
                31.6612502
              ],
              [
                48.7113039,
                31.6624003
              ],
              [
                48.7120551,
                31.6630902
              ],
              [
                48.7133406,
                31.6634627
              ],
              [
                48.7148934,
                31.6637859
              ],
              [
                48.716015,
                31.6637902
              ],
              [
                48.7176248,
                31.6635192
              ],
              [
                48.7191772,
                31.6630193
              ],
              [
                48.7205161,
                31.6624255
              ],
              [
                48.7222825,
                31.6615123
              ],
              [
                48.7233009,
                31.6607368
              ],
              [
                48.7240487,
                31.6598662
              ],
              [
                48.7248536,
                31.6590892
              ],
              [
                48.7251741,
                31.6581727
              ],
              [
                48.7251777,
                31.6567951
              ],
              [
                48.7251243,
                31.6554187
              ],
              [
                48.7248573,
                31.6533531
              ],
              [
                48.7243233,
                31.6516999
              ],
              [
                48.7240029,
                31.6506908
              ],
              [
                48.7238425,
                31.6488097
              ],
              [
                48.7242166,
                31.6467916
              ],
              [
                48.7248612,
                31.6456915
              ],
              [
                48.7257194,
                31.6441352
              ],
              [
                48.7269515,
                31.6426239
              ],
              [
                48.7280771,
                31.6414805
              ],
              [
                48.7287843,
                31.6406315
              ],
              [
                48.729145,
                31.6401985
              ],
              [
                48.730751,
                31.6391019
              ],
              [
                48.7323608,
                31.6383256
              ],
              [
                48.7346077,
                31.6375989
              ],
              [
                48.7366409,
                31.6372358
              ],
              [
                48.737873,
                31.6373321
              ],
              [
                48.7390517,
                31.6375627
              ],
              [
                48.7401198,
                31.6378882
              ],
              [
                48.7412454,
                31.6385328
              ],
              [
                48.7422067,
                31.639499
              ],
              [
                48.7434386,
                31.6408331
              ],
              [
                48.7438661,
                31.6419816
              ],
              [
                48.7441495,
                31.6425983
              ],
              [
                48.7444574,
                31.6432683
              ],
              [
                48.7449911,
                31.6443713
              ],
              [
                48.745472,
                31.645196
              ],
              [
                48.7463301,
                31.6456125
              ],
              [
                48.7479362,
                31.6459836
              ],
              [
                48.7488976,
                31.6458044
              ],
              [
                48.7498094,
                31.6454845
              ],
              [
                48.7511636,
                31.645098
              ],
              [
                48.7519187,
                31.6444168
              ],
              [
                48.7523002,
                31.6438261
              ],
              [
                48.752639,
                31.6431624
              ],
              [
                48.7529527,
                31.6425478
              ],
              [
                48.7531852,
                31.640854
              ],
              [
                48.7534714,
                31.6390237
              ],
              [
                48.7535401,
                31.6377419
              ],
              [
                48.7533949,
                31.6363662
              ],
              [
                48.7531509,
                31.6344881
              ],
              [
                48.7531702,
                31.6325629
              ],
              [
                48.7533493,
                31.6308682
              ],
              [
                48.7534141,
                31.6299539
              ],
              [
                48.7536888,
                31.6292687
              ],
              [
                48.7536941,
                31.6292329
              ],
              [
                48.7538034,
                31.6284906
              ],
              [
                48.7540778,
                31.6276679
              ],
              [
                48.7546271,
                31.6264825
              ],
              [
                48.7552758,
                31.6255695
              ],
              [
                48.7570571,
                31.6238443
              ],
              [
                48.7587815,
                31.6222105
              ],
              [
                48.7604521,
                31.6208486
              ],
              [
                48.7627105,
                31.6193572
              ],
              [
                48.7639623,
                31.6185188
              ],
              [
                48.7650758,
                31.6177729
              ],
              [
                48.7670669,
                31.6165541
              ],
              [
                48.7675025,
                31.6161874
              ],
              [
                48.7685203,
                31.6153304
              ],
              [
                48.7698098,
                31.6145164
              ],
              [
                48.7706681,
                31.6141571
              ],
              [
                48.771633,
                31.6138447
              ],
              [
                48.7727011,
                31.6136221
              ],
              [
                48.7738228,
                31.6137228
              ],
              [
                48.7753142,
                31.6138751
              ],
              [
                48.7761114,
                31.6142948
              ],
              [
                48.7770613,
                31.6151254
              ],
              [
                48.7782248,
                31.6162821
              ],
              [
                48.7791709,
                31.6174823
              ],
              [
                48.7799606,
                31.6184047
              ],
              [
                48.7802696,
                31.6196908
              ],
              [
                48.7804146,
                31.6208817
              ],
              [
                48.7804052,
                31.6219132
              ],
              [
                48.7804033,
                31.6221194
              ],
              [
                48.7805977,
                31.6237259
              ],
              [
                48.7809677,
                31.624278
              ],
              [
                48.7813301,
                31.6251073
              ],
              [
                48.7821806,
                31.6256182
              ],
              [
                48.7828674,
                31.6261735
              ],
              [
                48.7838784,
                31.6265496
              ],
              [
                48.784836,
                31.6267849
              ],
              [
                48.7861136,
                31.6270258
              ],
              [
                48.788143,
                31.6268603
              ],
              [
                48.7910308,
                31.626518
              ],
              [
                48.7951468,
                31.6259127
              ],
              [
                48.7970198,
                31.6255617
              ],
              [
                48.7988357,
                31.6253022
              ],
              [
                48.8004988,
                31.6248122
              ],
              [
                48.8018914,
                31.6242725
              ],
              [
                48.802803,
                31.6237313
              ],
              [
                48.8036118,
                31.6229132
              ],
              [
                48.8048019,
                31.6214567
              ],
              [
                48.8054543,
                31.6204082
              ],
              [
                48.8057823,
                31.619584
              ],
              [
                48.80595,
                31.618809
              ],
              [
                48.8060152,
                31.6179848
              ],
              [
                48.8061256,
                31.6173892
              ],
              [
                48.8060264,
                31.6167471
              ],
              [
                48.8057173,
                31.6158286
              ],
              [
                48.8047142,
                31.6146727
              ],
              [
                48.8032836,
                31.6135161
              ],
              [
                48.8020669,
                31.6128187
              ],
              [
                48.8007271,
                31.612267
              ],
              [
                48.8004724,
                31.6121622
              ],
              [
                48.7998885,
                31.6118364
              ],
              [
                48.7995718,
                31.6112853
              ],
              [
                48.7993661,
                31.6105963
              ],
              [
                48.7994803,
                31.6100932
              ],
              [
                48.8001824,
                31.6090883
              ],
              [
                48.8007251,
                31.6088127
              ],
              [
                48.8016854,
                31.608325
              ],
              [
                48.8034515,
                31.6077421
              ],
              [
                48.806015,
                31.6075336
              ],
              [
                48.8092728,
                31.6074227
              ],
              [
                48.8113519,
                31.6077628
              ],
              [
                48.8141174,
                31.6085204
              ],
              [
                48.8160323,
                31.6092229
              ],
              [
                48.81736,
                31.6099672
              ],
              [
                48.8190002,
                31.6112196
              ],
              [
                48.8193788,
                31.6115623
              ],
              [
                48.8204804,
                31.6125594
              ],
              [
                48.8218537,
                31.6141748
              ],
              [
                48.8240203,
                31.6162118
              ],
              [
                48.8257597,
                31.6183362
              ],
              [
                48.8271333,
                31.6197215
              ],
              [
                48.8285561,
                31.6216127
              ],
              [
                48.8295556,
                31.6228113
              ],
              [
                48.8320999,
                31.6244848
              ],
              [
                48.8341752,
                31.6254648
              ],
              [
                48.8349648,
                31.6263891
              ],
              [
                48.8362352,
                31.6275471
              ],
              [
                48.837284,
                31.6292966
              ],
              [
                48.8383369,
                31.6308185
              ],
              [
                48.8391799,
                31.6320165
              ],
              [
                48.8393823,
                31.6329354
              ],
              [
                48.8395347,
                31.6338535
              ],
              [
                48.8392028,
                31.634858
              ],
              [
                48.8386041,
                31.6360001
              ],
              [
                48.8375245,
                31.6371814
              ],
              [
                48.8359031,
                31.6389556
              ],
              [
                48.8344498,
                31.640365
              ],
              [
                48.832508,
                31.6421359
              ],
              [
                48.8311653,
                31.6431796
              ],
              [
                48.8303528,
                31.6440881
              ],
              [
                48.8291093,
                31.6456363
              ],
              [
                48.8279763,
                31.646909
              ],
              [
                48.8274843,
                31.6477755
              ],
              [
                48.8273733,
                31.6485087
              ],
              [
                48.827366,
                31.6491917
              ],
              [
                48.827362,
                31.6495638
              ],
              [
                48.8277246,
                31.6503907
              ],
              [
                48.8279305,
                31.6511271
              ],
              [
                48.8281355,
                31.6514008
              ],
              [
                48.828724,
                31.6521868
              ],
              [
                48.8288148,
                31.6522913
              ],
              [
                48.829567,
                31.6531572
              ],
              [
                48.8305741,
                31.6537629
              ],
              [
                48.832016,
                31.6540038
              ],
              [
                48.8340913,
                31.6545261
              ],
              [
                48.8358499,
                31.6547251
              ],
              [
                48.8383066,
                31.6549291
              ],
              [
                48.840973,
                31.6550442
              ],
              [
                48.8411404,
                31.6550457
              ],
              [
                48.8435364,
                31.6550672
              ],
              [
                48.8448205,
                31.6551489
              ],
              [
                48.8460465,
                31.6552269
              ],
              [
                48.8466412,
                31.6553579
              ],
              [
                48.8469628,
                31.6554288
              ],
              [
                48.849083,
                31.6558959
              ],
              [
                48.8520088,
                31.6568833
              ],
              [
                48.8547744,
                31.6581903
              ],
              [
                48.8568496,
                31.6587122
              ],
              [
                48.8582917,
                31.6589078
              ],
              [
                48.8603746,
                31.6589269
              ],
              [
                48.8616563,
                31.658847
              ],
              [
                48.862671,
                31.6586272
              ],
              [
                48.8635293,
                31.6583146
              ],
              [
                48.8641206,
                31.6579051
              ],
              [
                48.8651428,
                31.6569977
              ],
              [
                48.8658487,
                31.6560851
              ],
              [
                48.8663198,
                31.6557088
              ],
              [
                48.8669244,
                31.6552259
              ],
              [
                48.8677331,
                31.6543149
              ],
              [
                48.8691825,
                31.6536401
              ],
              [
                48.8712694,
                31.6532916
              ],
              [
                48.8734015,
                31.6533114
              ],
              [
                48.8751106,
                31.6533715
              ],
              [
                48.8757658,
                31.6532944
              ],
              [
                48.8760195,
                31.6532639
              ],
              [
                48.8765564,
                31.6531994
              ],
              [
                48.8775712,
                31.6528419
              ],
              [
                48.8789178,
                31.6518
              ],
              [
                48.8801574,
                31.6507541
              ],
              [
                48.8809089,
                31.6501645
              ],
              [
                48.8816604,
                31.6497598
              ],
              [
                48.882097,
                31.6497626
              ],
              [
                48.882515,
                31.6497673
              ],
              [
                48.8834191,
                31.6502332
              ],
              [
                48.8835717,
                31.650786
              ],
              [
                48.8844185,
                31.6515712
              ],
              [
                48.8853187,
                31.6523122
              ],
              [
                48.8865433,
                31.6528736
              ],
              [
                48.8886185,
                31.6533973
              ],
              [
                48.8912887,
                31.6536963
              ],
              [
                48.8916799,
                31.6537477
              ],
              [
                48.8924064,
                31.6538433
              ],
              [
                48.8930436,
                31.6541244
              ],
              [
                48.8935737,
                31.6547239
              ],
              [
                48.894577,
                31.6559265
              ],
              [
                48.8949434,
                31.6565707
              ],
              [
                48.8950424,
                31.6574427
              ],
              [
                48.8949774,
                31.6588172
              ],
              [
                48.894539,
                31.6600524
              ],
              [
                48.8936487,
                31.661876
              ],
              [
                48.8935584,
                31.6620611
              ],
              [
                48.8930091,
                31.663432
              ],
              [
                48.8930015,
                31.6643947
              ],
              [
                48.893154,
                31.6650398
              ],
              [
                48.8936311,
                31.6654559
              ],
              [
                48.8952791,
                31.6662475
              ],
              [
                48.8958022,
                31.6663793
              ],
              [
                48.8966102,
                31.6665829
              ],
              [
                48.8979416,
                31.6670513
              ],
              [
                48.8987427,
                31.6672877
              ],
              [
                48.899433,
                31.6675697
              ],
              [
                48.9000168,
                31.6679874
              ],
              [
                48.9005432,
                31.6685418
              ],
              [
                48.9011232,
                31.6695096
              ],
              [
                48.9016494,
                31.6702489
              ],
              [
                48.9017619,
                31.6704246
              ],
              [
                48.9021225,
                31.6709872
              ],
              [
                48.9023856,
                31.6714944
              ],
              [
                48.9028624,
                31.6718202
              ],
              [
                48.9039308,
                31.6721038
              ],
              [
                48.905025,
                31.6723193
              ],
              [
                48.9051551,
                31.6723449
              ],
              [
                48.9061125,
                31.6728567
              ],
              [
                48.90691,
                31.6732306
              ],
              [
                48.9074401,
                31.6736497
              ],
              [
                48.9078597,
                31.6743398
              ],
              [
                48.9082222,
                31.6757641
              ],
              [
                48.9082069,
                31.6774617
              ],
              [
                48.9082337,
                31.6803056
              ],
              [
                48.9080619,
                31.6812205
              ],
              [
                48.9076196,
                31.6831434
              ],
              [
                48.9074479,
                31.6843786
              ],
              [
                48.9074593,
                31.6847913
              ],
              [
                48.9074859,
                31.6857547
              ],
              [
                48.9078026,
                31.6864476
              ],
              [
                48.9082795,
                31.6867711
              ],
              [
                48.9089164,
                31.6869597
              ],
              [
                48.9100914,
                31.6869248
              ],
              [
                48.9117013,
                31.6865273
              ],
              [
                48.9117324,
                31.686522
              ],
              [
                48.9140013,
                31.6861343
              ],
              [
                48.9146423,
                31.6861402
              ],
              [
                48.9150657,
                31.6863276
              ],
              [
                48.9153825,
                31.6866507
              ],
              [
                48.9153786,
                31.6873406
              ],
              [
                48.9153174,
                31.6880273
              ],
              [
                48.9150963,
                31.6888039
              ],
              [
                48.9149284,
                31.6897212
              ],
              [
                48.9148746,
                31.6903704
              ],
              [
                48.9148675,
                31.6904553
              ],
              [
                48.9150773,
                31.6910968
              ],
              [
                48.9153901,
                31.691925
              ],
              [
                48.915857,
                31.6923343
              ],
              [
                48.9160768,
                31.692527
              ],
              [
                48.9180907,
                31.6941045
              ],
              [
                48.9198419,
                31.6957273
              ],
              [
                48.9211121,
                31.6970694
              ],
              [
                48.921955,
                31.6983143
              ],
              [
                48.9223177,
                31.6995108
              ],
              [
                48.922573,
                31.7006582
              ],
              [
                48.922409,
                31.701253
              ],
              [
                48.9222336,
                31.7026753
              ],
              [
                48.9221565,
                31.703291
              ],
              [
                48.9220619,
                31.704048
              ],
              [
                48.9222107,
                31.7051508
              ],
              [
                48.9225769,
                31.7059798
              ],
              [
                48.9231072,
                31.7066716
              ],
              [
                48.9232908,
                31.7068223
              ],
              [
                48.9239539,
                31.7073664
              ],
              [
                48.9251212,
                31.7081589
              ],
              [
                48.9266129,
                31.708952
              ],
              [
                48.9279444,
                31.7094224
              ],
              [
                48.9285279,
                31.7097498
              ],
              [
                48.9287377,
                31.7100712
              ],
              [
                48.9286647,
                31.7102746
              ],
              [
                48.9285736,
                31.7105285
              ],
              [
                48.928356,
                31.710985
              ],
              [
                48.928192,
                31.7112597
              ],
              [
                48.9296342,
                31.7112718
              ],
              [
                48.9327353,
                31.7112545
              ],
              [
                48.9378204,
                31.7102906
              ],
              [
                48.9435998,
                31.7090604
              ],
              [
                48.9483186,
                31.7072671
              ],
              [
                48.9528237,
                31.7051072
              ],
              [
                48.9572258,
                31.7027605
              ],
              [
                48.9583419,
                31.7020313
              ],
              [
                48.9608267,
                31.7004077
              ],
              [
                48.9653932,
                31.6972832
              ],
              [
                48.9686203,
                31.6949264
              ],
              [
                48.9698564,
                31.6941591
              ],
              [
                48.9712485,
                31.6934349
              ],
              [
                48.9724275,
                31.6931244
              ],
              [
                48.9733392,
                31.693042
              ],
              [
                48.9763833,
                31.69307
              ],
              [
                48.9802817,
                31.6930574
              ],
              [
                48.9866181,
                31.6926513
              ],
              [
                48.987816,
                31.6925745
              ],
              [
                48.9944537,
                31.6921875
              ],
              [
                48.9974107,
                31.6921099
              ],
              [
                48.9998837,
                31.6920247
              ],
              [
                49.0027963,
                31.6919103
              ],
              [
                49.00568,
                31.691624
              ],
              [
                49.0090446,
                31.6909234
              ],
              [
                49.0126761,
                31.6899473
              ],
              [
                49.0165711,
                31.6886053
              ],
              [
                49.0204126,
                31.68694
              ],
              [
                49.0256386,
                31.6847661
              ],
              [
                49.0308112,
                31.6824558
              ],
              [
                49.0339545,
                31.6807499
              ],
              [
                49.0374681,
                31.6786754
              ],
              [
                49.0412482,
                31.6760027
              ],
              [
                49.0444946,
                31.6738381
              ],
              [
                49.0472108,
                31.6723148
              ],
              [
                49.0495035,
                31.6711592
              ],
              [
                49.0508316,
                31.6705372
              ],
              [
                49.05542,
                31.668388
              ],
              [
                49.0589371,
                31.6665902
              ],
              [
                49.0602149,
                31.6660797
              ],
              [
                49.0609628,
                31.6657551
              ],
              [
                49.0622406,
                31.6652469
              ],
              [
                49.0634156,
                31.6648769
              ],
              [
                49.0656053,
                31.6647297
              ],
              [
                49.068119,
                31.664628
              ],
              [
                49.0707892,
                31.6645286
              ],
              [
                49.0737936,
                31.6645932
              ],
              [
                49.074318,
                31.6646044
              ],
              [
                49.0761908,
                31.6646891
              ],
              [
                49.0786553,
                31.6650915
              ],
              [
                49.081707,
                31.6657666
              ],
              [
                49.0846521,
                31.6667625
              ],
              [
                49.0857239,
                31.6670807
              ],
              [
                49.0875434,
                31.6674395
              ],
              [
                49.0893631,
                31.6676607
              ],
              [
                49.0919343,
                31.667972
              ],
              [
                49.0956764,
                31.6683234
              ],
              [
                49.1007082,
                31.6688088
              ],
              [
                49.1032754,
                31.6692101
              ],
              [
                49.1061136,
                31.6696559
              ],
              [
                49.1079863,
                31.6700603
              ],
              [
                49.10997,
                31.6706512
              ],
              [
                49.1127549,
                31.6713261
              ],
              [
                49.1169853,
                31.6722726
              ],
              [
                49.1218604,
                31.6733975
              ],
              [
                49.1259309,
                31.6744338
              ],
              [
                49.1301614,
                31.6752897
              ],
              [
                49.1341782,
                31.6762347
              ],
              [
                49.1376076,
                31.6771373
              ],
              [
                49.1410332,
                31.6776743
              ],
              [
                49.143875,
                31.6784418
              ],
              [
                49.149231,
                31.6797036
              ],
              [
                49.1533011,
                31.6803759
              ],
              [
                49.1565666,
                31.6810501
              ],
              [
                49.1612244,
                31.6817645
              ],
              [
                49.1643296,
                31.6822106
              ],
              [
                49.1643334,
                31.6826234
              ],
              [
                49.1648253,
                31.6840399
              ],
              [
                49.1660805,
                31.6871969
              ],
              [
                49.1677628,
                31.6902609
              ],
              [
                49.1702002,
                31.6940979
              ],
              [
                49.1714402,
                31.6956176
              ],
              [
                49.1744117,
                31.6992592
              ],
              [
                49.1770019,
                31.7021354
              ],
              [
                49.1810988,
                31.7061041
              ],
              [
                49.1836318,
                31.7083863
              ],
              [
                49.184166,
                31.7085202
              ],
              [
                49.1901053,
                31.7087264
              ],
              [
                49.1949195,
                31.7087067
              ],
              [
                49.197811,
                31.7087882
              ],
              [
                49.1981317,
                31.7088785
              ],
              [
                49.1982461,
                31.7100707
              ],
              [
                49.1982555,
                31.7101515
              ],
              [
                49.1984214,
                31.7115796
              ],
              [
                49.198433,
                31.7132282
              ],
              [
                49.1981813,
                31.714925
              ],
              [
                49.1981926,
                31.716436
              ],
              [
                49.198311,
                31.7177636
              ],
              [
                49.1980551,
                31.7194152
              ],
              [
                49.1979104,
                31.7209286
              ],
              [
                49.1979751,
                31.7225306
              ],
              [
                49.1980476,
                31.7247303
              ],
              [
                49.1981774,
                31.7274314
              ],
              [
                49.1982499,
                31.7296288
              ],
              [
                49.1982614,
                31.731097
              ],
              [
                49.1981163,
                31.7330208
              ],
              [
                49.1980783,
                31.7347612
              ],
              [
                49.1980514,
                31.7381975
              ],
              [
                49.1980742,
                31.7411745
              ],
              [
                49.1979445,
                31.7448416
              ],
              [
                49.1973761,
                31.7472239
              ],
              [
                49.1971911,
                31.7499453
              ],
              [
                49.1971907,
                31.7518215
              ],
              [
                49.1970254,
                31.7537112
              ],
              [
                49.1962012,
                31.7620161
              ],
              [
                49.1962318,
                31.7707796
              ],
              [
                49.1963005,
                31.7748171
              ],
              [
                49.1968499,
                31.779035
              ],
              [
                49.1974069,
                31.7854111
              ],
              [
                49.1976319,
                31.7885307
              ],
              [
                49.1985627,
                31.7944927
              ],
              [
                49.1993828,
                31.7987144
              ],
              [
                49.2000884,
                31.8013718
              ],
              [
                49.2005807,
                31.8041705
              ],
              [
                49.2005917,
                31.8042035
              ],
              [
                49.2017745,
                31.8079758
              ],
              [
                49.2020989,
                31.808711
              ],
              [
                49.2021524,
                31.8091695
              ],
              [
                49.2005156,
                31.815731
              ],
              [
                49.1991958,
                31.8215145
              ],
              [
                49.1976089,
                31.8273416
              ],
              [
                49.1959762,
                31.8347758
              ],
              [
                49.1947631,
                31.8399158
              ],
              [
                49.19339,
                31.8458337
              ],
              [
                49.1918029,
                31.8518929
              ],
              [
                49.1907996,
                31.8565284
              ],
              [
                49.1902236,
                31.8597404
              ],
              [
                49.1896399,
                31.8617571
              ],
              [
                49.1891634,
                31.8635453
              ],
              [
                49.1886865,
                31.8650606
              ],
              [
                49.1878853,
                31.8663931
              ],
              [
                49.1869278,
                31.8679084
              ],
              [
                49.185646,
                31.8699264
              ],
              [
                49.1843146,
                31.8721781
              ],
              [
                49.1833001,
                31.8739203
              ],
              [
                49.1819686,
                31.8763547
              ],
              [
                49.1803703,
                31.8786477
              ],
              [
                49.1790353,
                31.8809895
              ],
              [
                49.1783448,
                31.882504
              ],
              [
                49.177864,
                31.8836517
              ],
              [
                49.1772766,
                31.8841551
              ],
              [
                49.1766892,
                31.8844782
              ],
              [
                49.1756171,
                31.8849837
              ],
              [
                49.1745986,
                31.8854877
              ],
              [
                49.1734773,
                31.8862248
              ],
              [
                49.17305,
                31.8870507
              ],
              [
                49.1723022,
                31.8881968
              ],
              [
                49.1718788,
                31.8898481
              ],
              [
                49.1718293,
                31.8909501
              ],
              [
                49.1719932,
                31.891683
              ],
              [
                49.1720548,
                31.8918488
              ],
              [
                49.1723175,
                31.8925559
              ],
              [
                49.1726418,
                31.8931513
              ],
              [
                49.173233,
                31.893931
              ],
              [
                49.1737711,
                31.8943875
              ],
              [
                49.1739882,
                31.8951686
              ],
              [
                49.1738815,
                31.8954895
              ],
              [
                49.173561,
                31.8956743
              ],
              [
                49.1728629,
                31.895856
              ],
              [
                49.1716309,
                31.895951
              ],
              [
                49.1704521,
                31.8963174
              ],
              [
                49.1694336,
                31.8967785
              ],
              [
                49.168953,
                31.8972384
              ],
              [
                49.1679381,
                31.8987526
              ],
              [
                49.1666069,
                31.9007697
              ],
              [
                49.1656457,
                31.9022847
              ],
              [
                49.1646844,
                31.9035245
              ],
              [
                49.1639899,
                31.905084
              ],
              [
                49.1632424,
                31.9056369
              ],
              [
                49.1625443,
                31.9058658
              ],
              [
                49.1614722,
                31.9063239
              ],
              [
                49.1605646,
                31.9067843
              ],
              [
                49.1599235,
                31.9075642
              ],
              [
                49.1597098,
                31.908391
              ],
              [
                49.159069,
                31.9091236
              ],
              [
                49.1588021,
                31.9097669
              ],
              [
                49.1581611,
                31.910044
              ],
              [
                49.1574122,
                31.9102436
              ],
              [
                49.1573027,
                31.9102728
              ],
              [
                49.1562844,
                31.9105489
              ],
              [
                49.1551591,
                31.9109182
              ],
              [
                49.1547216,
                31.911198
              ],
              [
                49.1545144,
                31.9113305
              ],
              [
                49.1539802,
                31.9117895
              ],
              [
                49.1538201,
                31.9123396
              ],
              [
                49.1538239,
                31.9128448
              ],
              [
                49.1539307,
                31.9133041
              ],
              [
                49.1539878,
                31.9142205
              ],
              [
                49.1539613,
                31.9144142
              ],
              [
                49.153881,
                31.9150014
              ],
              [
                49.1538848,
                31.9156869
              ],
              [
                49.1534577,
                31.9162377
              ],
              [
                49.1534305,
                31.9162542
              ],
              [
                49.1529235,
                31.9165614
              ],
              [
                49.1520118,
                31.9167894
              ],
              [
                49.1509362,
                31.9168369
              ],
              [
                49.1497574,
                31.9168378
              ],
              [
                49.1486855,
                31.9169304
              ],
              [
                49.1476134,
                31.9171606
              ],
              [
                49.146595,
                31.9176193
              ],
              [
                49.1449892,
                31.9182633
              ],
              [
                49.1447025,
                31.9184504
              ],
              [
                49.1438637,
                31.9189977
              ],
              [
                49.1432227,
                31.9197799
              ],
              [
                49.1429558,
                31.920236
              ],
              [
                49.1428491,
                31.9207418
              ],
              [
                49.1429597,
                31.9222091
              ],
              [
                49.1431237,
                31.923127
              ],
              [
                49.1433946,
                31.9239067
              ],
              [
                49.1435524,
                31.9240846
              ],
              [
                49.1437187,
                31.9242722
              ],
              [
                49.1444167,
                31.9246838
              ],
              [
                49.1450614,
                31.9250518
              ],
              [
                49.1455995,
                31.9256933
              ],
              [
                49.1457063,
                31.9261977
              ],
              [
                49.1456529,
                31.9264743
              ],
              [
                49.1452788,
                31.9267484
              ],
              [
                49.144638,
                31.9269307
              ],
              [
                49.1437798,
                31.9272993
              ],
              [
                49.1425477,
                31.9277593
              ],
              [
                49.1395453,
                31.9286331
              ],
              [
                49.1372374,
                31.9294156
              ],
              [
                49.1361656,
                31.9296434
              ],
              [
                49.1353645,
                31.9299654
              ],
              [
                49.1347732,
                31.9301957
              ],
              [
                49.1336479,
                31.9307
              ],
              [
                49.1327362,
                31.9307024
              ],
              [
                49.1321879,
                31.930702
              ],
              [
                49.1320914,
                31.930702
              ],
              [
                49.1306421,
                31.9304732
              ],
              [
                49.1290855,
                31.9306126
              ],
              [
                49.1283913,
                31.9312563
              ],
              [
                49.1276437,
                31.9320345
              ],
              [
                49.1275903,
                31.9326313
              ],
              [
                49.1275903,
                31.9333642
              ],
              [
                49.1277542,
                31.9345572
              ],
              [
                49.128025,
                31.9351542
              ],
              [
                49.1282959,
                31.935749
              ],
              [
                49.1289941,
                31.9363456
              ],
              [
                49.1295319,
                31.9368045
              ],
              [
                49.13023,
                31.9370335
              ],
              [
                49.131195,
                31.9371221
              ],
              [
                49.1320001,
                31.9370303
              ],
              [
                49.1327516,
                31.9369398
              ],
              [
                49.1334494,
                31.9367088
              ],
              [
                49.1339875,
                31.9366626
              ],
              [
                49.1342544,
                31.9367996
              ],
              [
                49.134739,
                31.9372577
              ],
              [
                49.1350633,
                31.9382208
              ],
              [
                49.1352805,
                31.9390019
              ],
              [
                49.1354445,
                31.9399176
              ],
              [
                49.1352845,
                31.9403753
              ],
              [
                49.1349789,
                31.9404731
              ],
              [
                49.1348534,
                31.9405132
              ],
              [
                49.1344261,
                31.9403762
              ],
              [
                49.134123,
                31.9400863
              ],
              [
                49.1339951,
                31.939964
              ],
              [
                49.1337775,
                31.9394602
              ],
              [
                49.1334001,
                31.9387714
              ],
              [
                49.1328087,
                31.9384966
              ],
              [
                49.132164,
                31.9382233
              ],
              [
                49.1313058,
                31.9381317
              ],
              [
                49.130718,
                31.9381343
              ],
              [
                49.130443,
                31.9382031
              ],
              [
                49.1298064,
                31.9383622
              ],
              [
                49.129055,
                31.9385473
              ],
              [
                49.1283571,
                31.9391887
              ],
              [
                49.127716,
                31.9398309
              ],
              [
                49.1264839,
                31.9407035
              ],
              [
                49.1256294,
                31.9414846
              ],
              [
                49.1246108,
                31.9424008
              ],
              [
                49.1238061,
                31.9428625
              ],
              [
                49.1226272,
                31.9435508
              ],
              [
                49.1216034,
                31.9438917
              ],
              [
                49.1213951,
                31.9439611
              ],
              [
                49.120163,
                31.9446509
              ],
              [
                49.119465,
                31.9450645
              ],
              [
                49.1192514,
                31.9455709
              ],
              [
                49.1192016,
                31.9462106
              ],
              [
                49.1193085,
                31.9468075
              ],
              [
                49.119522,
                31.9470669
              ],
              [
                49.1196862,
                31.9472663
              ],
              [
                49.1199531,
                31.9475859
              ],
              [
                49.1208153,
                31.9484127
              ],
              [
                49.1215134,
                31.9491446
              ],
              [
                49.1219446,
                31.9496945
              ],
              [
                49.121891,
                31.949971
              ],
              [
                49.1216239,
                31.9501993
              ],
              [
                49.1207122,
                31.9505218
              ],
              [
                49.1200179,
                31.9507506
              ],
              [
                49.11932,
                31.9510266
              ],
              [
                49.1191062,
                31.9513008
              ],
              [
                49.1186219,
                31.9516228
              ],
              [
                49.1178168,
                31.9518071
              ],
              [
                49.1161776,
                31.9521682
              ],
              [
                49.1157263,
                31.9522676
              ],
              [
                49.1140632,
                31.9524053
              ],
              [
                49.1130982,
                31.9526345
              ],
              [
                49.11224,
                31.9529577
              ],
              [
                49.1118126,
                31.9535985
              ],
              [
                49.1117059,
                31.9535969
              ],
              [
                49.1111678,
                31.9543782
              ],
              [
                49.110958,
                31.9550199
              ],
              [
                49.1109581,
                31.9553875
              ],
              [
                49.1112785,
                31.9557553
              ],
              [
                49.1119231,
                31.9559836
              ],
              [
                49.1127319,
                31.9563497
              ],
              [
                49.1129227,
                31.9567188
              ],
              [
                49.1129456,
                31.9567633
              ],
              [
                49.1129457,
                31.9570361
              ],
              [
                49.1128388,
                31.9572668
              ],
              [
                49.1126633,
                31.957342
              ],
              [
                49.1123048,
                31.9574956
              ],
              [
                49.1116066,
                31.9578167
              ],
              [
                49.110321,
                31.9582305
              ],
              [
                49.1094094,
                31.9587356
              ],
              [
                49.1087647,
                31.959425
              ],
              [
                49.1083373,
                31.9600207
              ],
              [
                49.1083413,
                31.960616
              ],
              [
                49.1083414,
                31.9613038
              ],
              [
                49.1086653,
                31.9618543
              ],
              [
                49.1092034,
                31.9622208
              ],
              [
                49.1099015,
                31.9626326
              ],
              [
                49.1107598,
                31.9631821
              ],
              [
                49.1112442,
                31.9635974
              ],
              [
                49.111622,
                31.9645118
              ],
              [
                49.1123238,
                31.9650634
              ],
              [
                49.113182,
                31.9657504
              ],
              [
                49.1132401,
                31.9659231
              ],
              [
                49.1135062,
                31.9667136
              ],
              [
                49.1135064,
                31.967124
              ],
              [
                49.1131859,
                31.9674011
              ],
              [
                49.1128119,
                31.96763
              ],
              [
                49.1123276,
                31.9679498
              ],
              [
                49.1116332,
                31.9682732
              ],
              [
                49.1115541,
                31.9682833
              ],
              [
                49.1105574,
                31.9684105
              ],
              [
                49.1091081,
                31.9686414
              ],
              [
                49.1083068,
                31.9688234
              ],
              [
                49.107876,
                31.9691462
              ],
              [
                49.1075554,
                31.9698788
              ],
              [
                49.1073418,
                31.9705228
              ],
              [
                49.1075058,
                31.9710709
              ],
              [
                49.1075591,
                31.9717144
              ],
              [
                49.1079901,
                31.9727693
              ],
              [
                49.1081543,
                31.9732273
              ],
              [
                49.1082078,
                31.9737309
              ],
              [
                49.1081046,
                31.9742818
              ],
              [
                49.1079978,
                31.9748778
              ],
              [
                49.107624,
                31.9753818
              ],
              [
                49.1072464,
                31.9760256
              ],
              [
                49.1064987,
                31.976621
              ],
              [
                49.1063386,
                31.977126
              ],
              [
                49.1063918,
                31.9777221
              ],
              [
                49.1069297,
                31.9782262
              ],
              [
                49.1077919,
                31.9786382
              ],
              [
                49.1088106,
                31.9790029
              ],
              [
                49.1092416,
                31.9791423
              ],
              [
                49.1092413,
                31.9795099
              ],
              [
                49.1092453,
                31.9801052
              ],
              [
                49.1089209,
                31.98038
              ],
              [
                49.1083871,
                31.9809313
              ],
              [
                49.107582,
                31.9816657
              ],
              [
                49.1068344,
                31.9820762
              ],
              [
                49.10635,
                31.9829935
              ],
              [
                49.1063002,
                31.9835001
              ],
              [
                49.1064604,
                31.983958
              ],
              [
                49.1067313,
                31.9842326
              ],
              [
                49.107212,
                31.9843683
              ],
              [
                49.1081809,
                31.9843692
              ],
              [
                49.1088792,
                31.9844608
              ],
              [
                49.1090394,
                31.9845985
              ],
              [
                49.1093635,
                31.984919
              ],
              [
                49.1096877,
                31.9852869
              ],
              [
                49.1097946,
                31.985974
              ],
              [
                49.1096878,
                31.9865699
              ],
              [
                49.1096916,
                31.9870277
              ],
              [
                49.1094782,
                31.9874868
              ],
              [
                49.1093712,
                31.9879452
              ],
              [
                49.1091577,
                31.9884043
              ],
              [
                49.1091415,
                31.9885296
              ],
              [
                49.1091043,
                31.9888161
              ],
              [
                49.1089439,
                31.9894136
              ],
              [
                49.1085166,
                31.9897815
              ],
              [
                49.1081389,
                31.9900555
              ],
              [
                49.1071741,
                31.9902395
              ],
              [
                49.1060449,
                31.9902407
              ],
              [
                49.1044885,
                31.99024
              ],
              [
                49.1031455,
                31.9906078
              ],
              [
                49.102398,
                31.9909754
              ],
              [
                49.1018067,
                31.9909282
              ],
              [
                49.1014291,
                31.9906994
              ],
              [
                49.1007447,
                31.9903881
              ],
              [
                49.100624,
                31.9903333
              ],
              [
                49.0997619,
                31.990379
              ],
              [
                49.0986902,
                31.9906561
              ],
              [
                49.0977785,
                31.9910686
              ],
              [
                49.097587,
                31.9912574
              ],
              [
                49.0970803,
                31.9917571
              ],
              [
                49.0960616,
                31.9924454
              ],
              [
                49.0946694,
                31.9933625
              ],
              [
                49.0941316,
                31.9940061
              ],
              [
                49.0932198,
                31.9940961
              ],
              [
                49.0924683,
                31.994051
              ],
              [
                49.0917166,
                31.9937759
              ],
              [
                49.0907596,
                31.9934391
              ],
              [
                49.0901567,
                31.993227
              ],
              [
                49.0891914,
                31.9930907
              ],
              [
                49.0885468,
                31.9929976
              ],
              [
                49.0877418,
                31.9931365
              ],
              [
                49.0870973,
                31.9936409
              ],
              [
                49.0867767,
                31.9950161
              ],
              [
                49.0867271,
                31.9961157
              ],
              [
                49.0867807,
                31.9969418
              ],
              [
                49.0868911,
                31.997629
              ],
              [
                49.0874825,
                31.9984091
              ],
              [
                49.0879668,
                31.9988222
              ],
              [
                49.0890959,
                31.9990512
              ],
              [
                49.0900613,
                31.9993251
              ],
              [
                49.0909233,
                31.9996447
              ],
              [
                49.0924622,
                32.000049
              ],
              [
                49.0940056,
                32.0010688
              ],
              [
                49.0945473,
                32.0018549
              ],
              [
                49.0950354,
                32.0025026
              ],
              [
                49.0955239,
                32.0031932
              ],
              [
                49.0956877,
                32.0037008
              ],
              [
                49.0955849,
                32.0042562
              ],
              [
                49.0954782,
                32.0049062
              ],
              [
                49.0951042,
                32.0057823
              ],
              [
                49.09457,
                32.0063853
              ],
              [
                49.093872,
                32.0071257
              ],
              [
                49.092907,
                32.0077697
              ],
              [
                49.0921556,
                32.0081439
              ],
              [
                49.0911331,
                32.0081894
              ],
              [
                49.0903243,
                32.0081908
              ],
              [
                49.0892448,
                32.0080077
              ],
              [
                49.0886535,
                32.0078702
              ],
              [
                49.0879517,
                32.0074989
              ],
              [
                49.0871393,
                32.0070379
              ],
              [
                49.0866547,
                32.0066224
              ],
              [
                49.0862198,
                32.0059326
              ],
              [
                49.0855139,
                32.005329
              ],
              [
                49.0848656,
                32.0050553
              ],
              [
                49.0844878,
                32.0048219
              ],
              [
                49.0837363,
                32.0048218
              ],
              [
                49.0828743,
                32.0050095
              ],
              [
                49.0823363,
                32.0052877
              ],
              [
                49.0819627,
                32.0056113
              ],
              [
                49.0814782,
                32.0062601
              ],
              [
                49.0813752,
                32.0065833
              ],
              [
                49.0812148,
                32.0071829
              ],
              [
                49.0810546,
                32.0076946
              ],
              [
                49.0812187,
                32.0082022
              ],
              [
                49.0813333,
                32.0088962
              ],
              [
                49.0814438,
                32.0100523
              ],
              [
                49.0814476,
                32.0108371
              ],
              [
                49.0812377,
                32.0114833
              ],
              [
                49.0809175,
                32.012085
              ],
              [
                49.0806502,
                32.0127327
              ],
              [
                49.0800627,
                32.0133822
              ],
              [
                49.0797958,
                32.0138427
              ],
              [
                49.0789338,
                32.0141678
              ],
              [
                49.0782889,
                32.0144918
              ],
              [
                49.0775376,
                32.0144917
              ],
              [
                49.0769957,
                32.0144
              ],
              [
                49.076187,
                32.0141713
              ],
              [
                49.0750008,
                32.0138015
              ],
              [
                49.0741385,
                32.0135269
              ],
              [
                49.07349,
                32.0132983
              ],
              [
                49.0724638,
                32.0127911
              ],
              [
                49.0710069,
                32.012557
              ],
              [
                49.0702552,
                32.0125614
              ],
              [
                49.0692331,
                32.0127938
              ],
              [
                49.0688552,
                32.013115
              ],
              [
                49.0684815,
                32.0134882
              ],
              [
                49.0682144,
                32.0139509
              ],
              [
                49.0678903,
                32.0141827
              ],
              [
                49.0676802,
                32.0146913
              ],
              [
                49.0674667,
                32.0152473
              ],
              [
                49.0673601,
                32.0157079
              ],
              [
                49.0675774,
                32.0162163
              ],
              [
                49.0677413,
                32.0165864
              ],
              [
                49.0680656,
                32.0169115
              ],
              [
                49.0686607,
                32.0173265
              ],
              [
                49.0690288,
                32.0175246
              ],
              [
                49.0692557,
                32.0176467
              ],
              [
                49.0702285,
                32.0179704
              ],
              [
                49.0710372,
                32.0183413
              ],
              [
                49.0715789,
                32.0185231
              ],
              [
                49.0719565,
                32.0188491
              ],
              [
                49.07201,
                32.0192174
              ],
              [
                49.0719605,
                32.0195887
              ],
              [
                49.0719072,
                32.0200502
              ],
              [
                49.0718537,
                32.0202342
              ],
              [
                49.0713196,
                32.0207447
              ],
              [
                49.070942,
                32.0210231
              ],
              [
                49.0706061,
                32.0212654
              ],
              [
                49.0696564,
                32.0219506
              ],
              [
                49.0687941,
                32.0223659
              ],
              [
                49.0670205,
                32.0224606
              ],
              [
                49.0658341,
                32.0224606
              ],
              [
                49.0641098,
                32.0223283
              ],
              [
                49.0631371,
                32.0221443
              ],
              [
                49.0620041,
                32.0217752
              ],
              [
                49.0610886,
                32.0215448
              ],
              [
                49.0606575,
                32.0215449
              ],
              [
                49.060173,
                32.0212669
              ],
              [
                49.0596313,
                32.0209475
              ],
              [
                49.0590936,
                32.0208558
              ],
              [
                49.0588759,
                32.0208547
              ],
              [
                49.0585022,
                32.0210384
              ],
              [
                49.0580711,
                32.0211784
              ],
              [
                49.0575866,
                32.02164
              ],
              [
                49.0568351,
                32.0221516
              ],
              [
                49.056301,
                32.0227996
              ],
              [
                49.0558738,
                32.0235867
              ],
              [
                49.0555534,
                32.0242808
              ],
              [
                49.0551262,
                32.0252078
              ],
              [
                49.0547562,
                32.0259011
              ],
              [
                49.0546492,
                32.0265512
              ],
              [
                49.054653,
                32.0271037
              ],
              [
                49.0544394,
                32.0275694
              ],
              [
                49.0544395,
                32.0277971
              ],
              [
                49.0545501,
                32.0280311
              ],
              [
                49.0548744,
                32.0281668
              ],
              [
                49.0554124,
                32.0283059
              ],
              [
                49.0560912,
                32.0283655
              ],
              [
                49.0564385,
                32.028396
              ],
              [
                49.0573541,
                32.0285341
              ],
              [
                49.0582693,
                32.0288593
              ],
              [
                49.058918,
                32.0293202
              ],
              [
                49.0594063,
                32.0298733
              ],
              [
                49.0594634,
                32.0303342
              ],
              [
                49.0596274,
                32.0308418
              ],
              [
                49.0597381,
                32.0316305
              ],
              [
                49.0597953,
                32.0321387
              ],
              [
                49.0596922,
                32.0328339
              ],
              [
                49.0596962,
                32.0336186
              ],
              [
                49.0596465,
                32.0343597
              ],
              [
                49.0596505,
                32.0354692
              ],
              [
                49.0594408,
                32.0363002
              ],
              [
                49.0594444,
                32.0373646
              ],
              [
                49.0592881,
                32.0379688
              ],
              [
                49.0591813,
                32.0382918
              ],
              [
                49.0585365,
                32.0386157
              ],
              [
                49.0576743,
                32.0388483
              ],
              [
                49.0567056,
                32.0388537
              ],
              [
                49.0558433,
                32.0388067
              ],
              [
                49.0553714,
                32.0387016
              ],
              [
                49.054821,
                32.038579
              ],
              [
                49.0534173,
                32.0383004
              ],
              [
                49.0520134,
                32.0378865
              ],
              [
                49.0503961,
                32.037334
              ],
              [
                49.0488853,
                32.0368778
              ],
              [
                49.0479698,
                32.0367848
              ],
              [
                49.047161,
                32.0365063
              ],
              [
                49.0459747,
                32.036603
              ],
              [
                49.0445746,
                32.0365611
              ],
              [
                49.0436058,
                32.0366972
              ],
              [
                49.0431214,
                32.0369761
              ],
              [
                49.0428386,
                32.0374723
              ],
              [
                49.0427381,
                32.0376376
              ],
              [
                49.0425376,
                32.0382276
              ],
              [
                49.0423242,
                32.0386933
              ],
              [
                49.042324,
                32.0390135
              ],
              [
                49.0425414,
                32.0392919
              ],
              [
                49.0426523,
                32.039571
              ],
              [
                49.042923,
                32.0399404
              ],
              [
                49.0432474,
                32.0403107
              ],
              [
                49.0437356,
                32.0407715
              ],
              [
                49.0437418,
                32.0407758
              ],
              [
                49.0448685,
                32.0415534
              ],
              [
                49.0456277,
                32.0421559
              ],
              [
                49.046383,
                32.0428011
              ],
              [
                49.0470315,
                32.0433072
              ],
              [
                49.0476303,
                32.0441394
              ],
              [
                49.0481186,
                32.0448798
              ],
              [
                49.0482825,
                32.0455294
              ],
              [
                49.0482863,
                32.0461767
              ],
              [
                49.0483436,
                32.0465924
              ],
              [
                49.048237,
                32.0471906
              ],
              [
                49.0480805,
                32.0476572
              ],
              [
                49.0478095,
                32.0479822
              ],
              [
                49.0475961,
                32.0482608
              ],
              [
                49.0468446,
                32.0486303
              ],
              [
                49.0461464,
                32.0489532
              ],
              [
                49.0460608,
                32.0489782
              ],
              [
                49.0451774,
                32.0492359
              ],
              [
                49.0447502,
                32.0494187
              ],
              [
                49.0442658,
                32.0496976
              ],
              [
                49.0438918,
                32.050118
              ],
              [
                49.0434074,
                32.0507194
              ],
              [
                49.0431404,
                32.0510896
              ],
              [
                49.0429803,
                32.0515967
              ],
              [
                49.0430376,
                32.052017
              ],
              [
                49.0429877,
                32.0524784
              ],
              [
                49.0430451,
                32.0530318
              ],
              [
                49.0433159,
                32.0534486
              ],
              [
                49.0435265,
                32.0537711
              ],
              [
                49.0435867,
                32.0538632
              ],
              [
                49.0442351,
                32.0547458
              ],
              [
                49.0449983,
                32.0559459
              ],
              [
                49.0454864,
                32.0570064
              ],
              [
                49.0458145,
                32.0578886
              ],
              [
                49.0460358,
                32.0590894
              ],
              [
                49.0459327,
                32.0597372
              ],
              [
                49.0459364,
                32.0604791
              ],
              [
                49.0457268,
                32.0613101
              ],
              [
                49.045513,
                32.0617759
              ],
              [
                49.0450822,
                32.0621909
              ],
              [
                49.0440101,
                32.0626569
              ],
              [
                49.0425035,
                32.0630304
              ],
              [
                49.0412635,
                32.0631263
              ],
              [
                49.0399171,
                32.0630333
              ],
              [
                49.0386771,
                32.0626669
              ],
              [
                49.0377045,
                32.0623474
              ],
              [
                49.0376948,
                32.062342
              ],
              [
                49.0366248,
                32.0617489
              ],
              [
                49.0352746,
                32.0611958
              ],
              [
                49.0343019,
                32.0608245
              ],
              [
                49.0335997,
                32.0604596
              ],
              [
                49.0330619,
                32.0601356
              ],
              [
                49.0326309,
                32.0600432
              ],
              [
                49.0321464,
                32.0601349
              ],
              [
                49.0319329,
                32.0605081
              ],
              [
                49.0305763,
                32.0596532
              ],
              [
                49.0296499,
                32.0594804
              ],
              [
                49.0288925,
                32.0601023
              ],
              [
                49.0279458,
                32.0608796
              ],
              [
                49.0282871,
                32.0623105
              ],
              [
                49.0280637,
                32.0640496
              ],
              [
                49.0282055,
                32.0661111
              ],
              [
                49.027972,
                32.0683251
              ],
              [
                49.0272009,
                32.0695804
              ],
              [
                49.0267949,
                32.0711581
              ],
              [
                49.0263957,
                32.0724192
              ],
              [
                49.025814,
                32.073519
              ],
              [
                49.0254284,
                32.0741466
              ],
              [
                49.0250394,
                32.0749326
              ],
              [
                49.0246402,
                32.0761936
              ],
              [
                49.0244338,
                32.0771408
              ],
              [
                49.0244134,
                32.078091
              ],
              [
                49.0242861,
                32.0783315
              ],
              [
                49.0238315,
                32.0791907
              ],
              [
                49.0236285,
                32.0799796
              ],
              [
                49.0232463,
                32.0804489
              ],
              [
                49.0226781,
                32.0809152
              ],
              [
                49.0213659,
                32.0813699
              ],
              [
                49.0206151,
                32.081675
              ],
              [
                49.0200469,
                32.0821414
              ],
              [
                49.019465,
                32.0832411
              ],
              [
                49.0192687,
                32.0837133
              ],
              [
                49.0185111,
                32.084335
              ],
              [
                49.0181322,
                32.0846459
              ],
              [
                49.0177431,
                32.0854319
              ],
              [
                49.0175366,
                32.0863791
              ],
              [
                49.0169581,
                32.0873205
              ],
              [
                49.0161969,
                32.0881006
              ],
              [
                49.0148949,
                32.0880802
              ],
              [
                49.0137857,
                32.087746
              ],
              [
                49.0125008,
                32.0869338
              ],
              [
                49.0117705,
                32.0862887
              ],
              [
                49.0108508,
                32.085799
              ],
              [
                49.0101205,
                32.0851539
              ],
              [
                49.0091905,
                32.0851393
              ],
              [
                49.0078885,
                32.0851188
              ],
              [
                49.0069516,
                32.0854209
              ],
              [
                49.006373,
                32.0863622
              ],
              [
                49.0057909,
                32.0874619
              ],
              [
                49.0048265,
                32.0890308
              ],
              [
                49.0042478,
                32.0899721
              ],
              [
                49.0036725,
                32.0907551
              ],
              [
                49.0025565,
                32.0907375
              ],
              [
                49.0016264,
                32.0907228
              ],
              [
                49.0014439,
                32.0905615
              ],
              [
                49.0007102,
                32.0900747
              ],
              [
                48.9999765,
                32.0895879
              ],
              [
                48.9992497,
                32.0887844
              ],
              [
                48.998709,
                32.0879838
              ],
              [
                48.9981682,
                32.0871833
              ],
              [
                48.9981889,
                32.0862331
              ],
              [
                48.9978342,
                32.0854355
              ],
              [
                48.997476,
                32.0847962
              ],
              [
                48.9971109,
                32.0844736
              ],
              [
                48.9967424,
                32.0843094
              ],
              [
                48.9961879,
                32.0841422
              ],
              [
                48.9952579,
                32.0841275
              ],
              [
                48.9946895,
                32.0845937
              ],
              [
                48.9941246,
                32.0849016
              ],
              [
                48.9936394,
                32.0851996
              ],
              [
                48.9933702,
                32.0853649
              ],
              [
                48.9928053,
                32.0856727
              ],
              [
                48.9926568,
                32.0860297
              ],
              [
                48.9926089,
                32.0861448
              ],
              [
                48.9924056,
                32.0869336
              ],
              [
                48.9923814,
                32.0880421
              ],
              [
                48.9921746,
                32.0889892
              ],
              [
                48.9921573,
                32.089781
              ],
              [
                48.9917714,
                32.0904085
              ],
              [
                48.9908171,
                32.0915022
              ],
              [
                48.9902382,
                32.0924435
              ],
              [
                48.9892943,
                32.0930621
              ],
              [
                48.9887258,
                32.0935283
              ],
              [
                48.9883399,
                32.0941558
              ],
              [
                48.9877749,
                32.0944636
              ],
              [
                48.986452,
                32.095393
              ],
              [
                48.9855045,
                32.09617
              ],
              [
                48.984936,
                32.0966361
              ],
              [
                48.9847361,
                32.0972666
              ],
              [
                48.9845361,
                32.097897
              ],
              [
                48.9836025,
                32.0980405
              ],
              [
                48.982462,
                32.0991312
              ],
              [
                48.9815075,
                32.1002248
              ],
              [
                48.9807564,
                32.1005297
              ],
              [
                48.9798298,
                32.1003565
              ],
              [
                48.9788892,
                32.1008167
              ],
              [
                48.9779556,
                32.1009602
              ],
              [
                48.977766,
                32.1011156
              ],
              [
                48.9768324,
                32.1012591
              ],
              [
                48.9764638,
                32.1010948
              ],
              [
                48.9755232,
                32.1015549
              ],
              [
                48.9749651,
                32.101546
              ],
              [
                48.9744035,
                32.1016954
              ],
              [
                48.9740245,
                32.1020062
              ],
              [
                48.9736419,
                32.1024753
              ],
              [
                48.9728768,
                32.1034135
              ],
              [
                48.9721117,
                32.1043516
              ],
              [
                48.9715396,
                32.1049761
              ],
              [
                48.9713465,
                32.1052898
              ],
              [
                48.9709674,
                32.1056005
              ],
              [
                48.9709569,
                32.1060756
              ],
              [
                48.9709464,
                32.1065506
              ],
              [
                48.9707534,
                32.1068643
              ],
              [
                48.9701848,
                32.1073304
              ],
              [
                48.9696126,
                32.1079549
              ],
              [
                48.9688614,
                32.1082596
              ],
              [
                48.9686754,
                32.1082566
              ],
              [
                48.9681138,
                32.108406
              ],
              [
                48.9673661,
                32.1085524
              ],
              [
                48.9660638,
                32.1085315
              ],
              [
                48.9640173,
                32.1084986
              ],
              [
                48.9630906,
                32.1083253
              ],
              [
                48.9617919,
                32.108146
              ],
              [
                48.9608616,
                32.108131
              ],
              [
                48.9604684,
                32.1090751
              ],
              [
                48.9602577,
                32.1101806
              ],
              [
                48.9604227,
                32.1111336
              ],
              [
                48.960405,
                32.1119254
              ],
              [
                48.9594642,
                32.1123854
              ],
              [
                48.9583444,
                32.1125258
              ],
              [
                48.9566735,
                32.1123404
              ],
              [
                48.9552028,
                32.1115246
              ],
              [
                48.9542902,
                32.1107179
              ],
              [
                48.9528336,
                32.1092687
              ],
              [
                48.9517209,
                32.1090923
              ],
              [
                48.9502255,
                32.1093849
              ],
              [
                48.9494636,
                32.1101646
              ],
              [
                48.9485228,
                32.1106245
              ],
              [
                48.9472169,
                32.1107618
              ],
              [
                48.9461148,
                32.1101103
              ],
              [
                48.9453849,
                32.1094648
              ],
              [
                48.9450341,
                32.1085087
              ],
              [
                48.9450447,
                32.1080337
              ],
              [
                48.945238,
                32.1064298
              ],
              [
                48.9452733,
                32.1061365
              ],
              [
                48.9458563,
                32.1050372
              ],
              [
                48.9464321,
                32.1042545
              ],
              [
                48.9447365,
                32.1051774
              ],
              [
                48.9438853,
                32.1052669
              ],
              [
                48.9434307,
                32.1053146
              ],
              [
                48.9428726,
                32.1053055
              ],
              [
                48.942311,
                32.1054548
              ],
              [
                48.9413702,
                32.1059147
              ],
              [
                48.9406118,
                32.106536
              ],
              [
                48.9402362,
                32.1066883
              ],
              [
                48.9394885,
                32.1068345
              ],
              [
                48.9389268,
                32.1069838
              ],
              [
                48.9376174,
                32.1072793
              ],
              [
                48.9362902,
                32.1083665
              ],
              [
                48.9355425,
                32.1085127
              ],
              [
                48.9353494,
                32.1088263
              ],
              [
                48.9349701,
                32.109137
              ],
              [
                48.9345802,
                32.1099226
              ],
              [
                48.9341974,
                32.1103916
              ],
              [
                48.9332601,
                32.1106931
              ],
              [
                48.9323227,
                32.1109946
              ],
              [
                48.9315786,
                32.1109824
              ],
              [
                48.9313925,
                32.1109794
              ],
              [
                48.9310204,
                32.1109733
              ],
              [
                48.9304659,
                32.1108058
              ],
              [
                48.929922,
                32.1101633
              ],
              [
                48.9295607,
                32.1096822
              ],
              [
                48.9288416,
                32.1085616
              ],
              [
                48.9282978,
                32.1079191
              ],
              [
                48.9277396,
                32.10791
              ],
              [
                48.927178,
                32.1080592
              ],
              [
                48.9264302,
                32.1082053
              ],
              [
                48.926237,
                32.108519
              ],
              [
                48.9260403,
                32.108991
              ],
              [
                48.9254786,
                32.1091402
              ],
              [
                48.9247272,
                32.1094447
              ],
              [
                48.9241691,
                32.1094355
              ],
              [
                48.9232282,
                32.1098953
              ],
              [
                48.9226593,
                32.1103612
              ],
              [
                48.9220904,
                32.110827
              ],
              [
                48.9217111,
                32.1111376
              ],
              [
                48.9213283,
                32.1116065
              ],
              [
                48.9207666,
                32.1117557
              ],
              [
                48.9203945,
                32.1117496
              ],
              [
                48.9200188,
                32.1119018
              ],
              [
                48.9196323,
                32.1125291
              ],
              [
                48.9194355,
                32.1130011
              ],
              [
                48.9190562,
                32.1133116
              ],
              [
                48.9186769,
                32.1136222
              ],
              [
                48.9179292,
                32.1137683
              ],
              [
                48.9169953,
                32.1139113
              ],
              [
                48.91643,
                32.1142188
              ],
              [
                48.9160471,
                32.1146877
              ],
              [
                48.9154781,
                32.1151536
              ],
              [
                48.9150917,
                32.1157808
              ],
              [
                48.9145299,
                32.11593
              ],
              [
                48.9137749,
                32.1163927
              ],
              [
                48.913578,
                32.1168647
              ],
              [
                48.9135564,
                32.1178147
              ],
              [
                48.9135348,
                32.1187648
              ],
              [
                48.9134771,
                32.1212983
              ],
              [
                48.9154648,
                32.1227063
              ],
              [
                48.9064813,
                32.1243949
              ],
              [
                48.901212,
                32.1274796
              ],
              [
                48.8973491,
                32.1225077
              ],
              [
                48.9032614,
                32.1176393
              ],
              [
                48.9013263,
                32.1150176
              ],
              [
                48.8947195,
                32.1154046
              ],
              [
                48.89138,
                32.1207619
              ],
              [
                48.887108,
                32.1188314
              ],
              [
                48.8862743,
                32.1138649
              ],
              [
                48.8838824,
                32.1132315
              ],
              [
                48.8889971,
                32.1056759
              ],
              [
                48.8863362,
                32.1031602
              ],
              [
                48.8685543,
                32.1096122
              ],
              [
                48.8549233,
                32.1146777
              ],
              [
                48.8144018,
                32.1178633
              ],
              [
                48.7912796,
                32.119665
              ],
              [
                48.7454568,
                32.1239319
              ],
              [
                48.7108682,
                32.1220364
              ],
              [
                48.6814686,
                32.1203437
              ],
              [
                48.6501512,
                32.1189826
              ],
              [
                48.6078255,
                32.1154504
              ],
              [
                48.5935421,
                32.1148551
              ],
              [
                48.5893685,
                32.1236346
              ],
              [
                48.576708,
                32.1293721
              ],
              [
                48.5708787,
                32.1320908
              ],
              [
                48.5706305,
                32.1230103
              ],
              [
                48.570321,
                32.1159885
              ],
              [
                48.5704784,
                32.1146992
              ],
              [
                48.5707221,
                32.11022
              ],
              [
                48.5712626,
                32.1016715
              ],
              [
                48.571721,
                32.0994074
              ],
              [
                48.5726933,
                32.0943817
              ],
              [
                48.573861,
                32.0885231
              ],
              [
                48.5745885,
                32.084591
              ],
              [
                48.5823506,
                32.0836513
              ],
              [
                48.5842478,
                32.0823663
              ],
              [
                48.5835264,
                32.0818346
              ],
              [
                48.5810863,
                32.0802502
              ],
              [
                48.580695,
                32.0782851
              ],
              [
                48.5802963,
                32.0761402
              ],
              [
                48.5835108,
                32.0740929
              ],
              [
                48.5816657,
                32.0716074
              ],
              [
                48.5813573,
                32.0708317
              ],
              [
                48.5800711,
                32.0679332
              ],
              [
                48.576319,
                32.0661012
              ],
              [
                48.5713436,
                32.0666805
              ],
              [
                48.5671433,
                32.0672367
              ],
              [
                48.5672032,
                32.0626432
              ],
              [
                48.5744548,
                32.0577003
              ],
              [
                48.5745137,
                32.0515107
              ],
              [
                48.5850741,
                32.0448914
              ],
              [
                48.5898267,
                32.0400123
              ],
              [
                48.5912339,
                32.0363276
              ],
              [
                48.588078,
                32.0333727
              ],
              [
                48.5875683,
                32.0259393
              ],
              [
                48.5851478,
                32.0235591
              ],
              [
                48.5829975,
                32.0215956
              ],
              [
                48.5836562,
                32.0158976
              ],
              [
                48.5870172,
                32.0137341
              ],
              [
                48.5868431,
                32.0062002
              ],
              [
                48.5852475,
                31.998466
              ],
              [
                48.5887919,
                31.9985609
              ],
              [
                48.5909113,
                31.995097
              ],
              [
                48.5938401,
                31.9898411
              ],
              [
                48.5949517,
                31.9879558
              ],
              [
                48.6004481,
                31.9865428
              ],
              [
                48.6096403,
                31.9872282
              ],
              [
                48.6120137,
                31.9824431
              ],
              [
                48.6096637,
                31.9784498
              ],
              [
                48.5964877,
                31.9746507
              ],
              [
                48.5940291,
                31.9707288
              ],
              [
                48.5868814,
                31.9607933
              ],
              [
                48.5842756,
                31.9573578
              ],
              [
                48.5780756,
                31.9539924
              ],
              [
                48.5724147,
                31.9508567
              ],
              [
                48.5642357,
                31.9490909
              ],
              [
                48.5606175,
                31.9465105
              ],
              [
                48.5637292,
                31.9393681
              ],
              [
                48.5658891,
                31.9349488
              ],
              [
                48.5678798,
                31.9302424
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555159,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کارون",
          "name:en": "Karun County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5962331",
          "wikipedia": "en:Karun County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.3786925,
                30.9907197
              ],
              [
                48.3794899,
                30.9909951
              ],
              [
                48.3808212,
                30.9911349
              ],
              [
                48.3808947,
                30.9911281
              ],
              [
                48.3827361,
                30.9909573
              ],
              [
                48.3874206,
                30.9906035
              ],
              [
                48.3909913,
                30.9899723
              ],
              [
                48.3941307,
                30.9896118
              ],
              [
                48.3992424,
                30.9890317
              ],
              [
                48.4047241,
                30.9884521
              ],
              [
                48.4120712,
                30.9878285
              ],
              [
                48.4148941,
                30.9876055
              ],
              [
                48.4206962,
                30.9865694
              ],
              [
                48.4295884,
                30.984988
              ],
              [
                48.4411393,
                30.9827305
              ],
              [
                48.4500314,
                30.9811049
              ],
              [
                48.4547691,
                30.9800643
              ],
              [
                48.4588661,
                30.9791596
              ],
              [
                48.4621697,
                30.9783002
              ],
              [
                48.4661063,
                30.9778972
              ],
              [
                48.4720687,
                30.9776849
              ],
              [
                48.4765396,
                30.9776033
              ],
              [
                48.4811173,
                30.9772034
              ],
              [
                48.4839898,
                30.9765694
              ],
              [
                48.4861184,
                30.9761171
              ],
              [
                48.4886208,
                30.9751624
              ],
              [
                48.4919739,
                30.9737078
              ],
              [
                48.4945832,
                30.9719749
              ],
              [
                48.4971389,
                30.9700583
              ],
              [
                48.5000969,
                30.9676173
              ],
              [
                48.5011375,
                30.9670467
              ],
              [
                48.5032033,
                30.9663042
              ],
              [
                48.5057144,
                30.9657304
              ],
              [
                48.5092697,
                30.9644394
              ],
              [
                48.5128786,
                30.9631493
              ],
              [
                48.516327,
                30.9616305
              ],
              [
                48.5201989,
                30.959653
              ],
              [
                48.5245439,
                30.9570779
              ],
              [
                48.5283089,
                30.9548704
              ],
              [
                48.5310136,
                30.9533054
              ],
              [
                48.5341414,
                30.9517891
              ],
              [
                48.5370558,
                30.9503159
              ],
              [
                48.5397605,
                30.9493009
              ],
              [
                48.5417252,
                30.9485626
              ],
              [
                48.5434761,
                30.9481021
              ],
              [
                48.5452804,
                30.9478681
              ],
              [
                48.5476189,
                30.947908
              ],
              [
                48.5500641,
                30.9480852
              ],
              [
                48.5520288,
                30.9482171
              ],
              [
                48.554264,
                30.9485345
              ],
              [
                48.5564957,
                30.9484821
              ],
              [
                48.5584602,
                30.9482486
              ],
              [
                48.5605278,
                30.9477397
              ],
              [
                48.5625991,
                30.9470483
              ],
              [
                48.5648269,
                30.9464476
              ],
              [
                48.5670013,
                30.9458009
              ],
              [
                48.5707704,
                30.9449676
              ],
              [
                48.5744859,
                30.9444106
              ],
              [
                48.5789987,
                30.9436203
              ],
              [
                48.5853691,
                30.9424159
              ],
              [
                48.5899353,
                30.9417165
              ],
              [
                48.5937578,
                30.9412037
              ],
              [
                48.5982705,
                30.9405977
              ],
              [
                48.6012421,
                30.9401771
              ],
              [
                48.6034699,
                30.9399433
              ],
              [
                48.6061784,
                30.9394343
              ],
              [
                48.6088867,
                30.9389681
              ],
              [
                48.6121217,
                30.938365
              ],
              [
                48.6149865,
                30.9375362
              ],
              [
                48.6176378,
                30.9367057
              ],
              [
                48.6201286,
                30.9355543
              ],
              [
                48.6218759,
                30.93445
              ],
              [
                48.6242065,
                30.9330249
              ],
              [
                48.6277503,
                30.9304066
              ],
              [
                48.6307105,
                30.9282015
              ],
              [
                48.6347885,
                30.9254891
              ],
              [
                48.6381761,
                30.9234653
              ],
              [
                48.6388787,
                30.9230517
              ],
              [
                48.6412965,
                30.9216281
              ],
              [
                48.6460112,
                30.9190984
              ],
              [
                48.6498222,
                30.9171631
              ],
              [
                48.6531562,
                30.9151423
              ],
              [
                48.6576539,
                30.9123849
              ],
              [
                48.6608812,
                30.9102223
              ],
              [
                48.6622048,
                30.9093487
              ],
              [
                48.6640548,
                30.9083381
              ],
              [
                48.6648176,
                30.9081076
              ],
              [
                48.6650546,
                30.908036
              ],
              [
                48.6662291,
                30.9078745
              ],
              [
                48.6681442,
                30.9079632
              ],
              [
                48.6702688,
                30.908324
              ],
              [
                48.6703563,
                30.9083395
              ],
              [
                48.6728211,
                30.9087758
              ],
              [
                48.6752168,
                30.9095022
              ],
              [
                48.6776086,
                30.9103209
              ],
              [
                48.6799508,
                30.9113235
              ],
              [
                48.6838003,
                30.9132717
              ],
              [
                48.6840019,
                30.9133738
              ],
              [
                48.6873588,
                30.9153799
              ],
              [
                48.689335,
                30.9169328
              ],
              [
                48.6916847,
                30.9189885
              ],
              [
                48.6937714,
                30.921089
              ],
              [
                48.6961213,
                30.9235122
              ],
              [
                48.6985283,
                30.9260265
              ],
              [
                48.7004547,
                30.9281737
              ],
              [
                48.7018473,
                30.9299077
              ],
              [
                48.7032395,
                30.9316462
              ],
              [
                48.7052765,
                30.9342508
              ],
              [
                48.7069892,
                30.936446
              ],
              [
                48.7091295,
                30.9388675
              ],
              [
                48.7110024,
                30.9407407
              ],
              [
                48.7147521,
                30.9449923
              ],
              [
                48.717106,
                30.947458
              ],
              [
                48.7189789,
                30.9493312
              ],
              [
                48.7201536,
                30.9504749
              ],
              [
                48.7210084,
                30.9512499
              ],
              [
                48.7226106,
                30.9521621
              ],
              [
                48.7244226,
                30.9530284
              ],
              [
                48.7257005,
                30.953574
              ],
              [
                48.7272987,
                30.9542584
              ],
              [
                48.7284203,
                30.9549433
              ],
              [
                48.7294884,
                30.9559024
              ],
              [
                48.7312546,
                30.9574082
              ],
              [
                48.733017,
                30.9587335
              ],
              [
                48.7342453,
                30.9596007
              ],
              [
                48.7362214,
                30.9609229
              ],
              [
                48.7381401,
                30.9618788
              ],
              [
                48.7401656,
                30.9626088
              ],
              [
                48.7419243,
                30.9631537
              ],
              [
                48.7446367,
                30.9637897
              ],
              [
                48.7471351,
                30.9640114
              ],
              [
                48.7500179,
                30.9642872
              ],
              [
                48.7513582,
                30.9641684
              ],
              [
                48.7534333,
                30.9639858
              ],
              [
                48.7547607,
                30.9634812
              ],
              [
                48.7570495,
                30.9627498
              ],
              [
                48.7598648,
                30.9610127
              ],
              [
                48.7630538,
                30.958495
              ],
              [
                48.7656593,
                30.9558408
              ],
              [
                48.7691651,
                30.9526362
              ],
              [
                48.7727242,
                30.9489317
              ],
              [
                48.7756462,
                30.9458656
              ],
              [
                48.7772409,
                30.94431
              ],
              [
                48.7790986,
                30.9424793
              ],
              [
                48.7805863,
                30.9416547
              ],
              [
                48.7817537,
                30.940784
              ],
              [
                48.7831383,
                30.9403726
              ],
              [
                48.7845191,
                30.9398708
              ],
              [
                48.7859,
                30.9395495
              ],
              [
                48.7870177,
                30.9395506
              ],
              [
                48.7878685,
                30.9396418
              ],
              [
                48.7892493,
                30.9403735
              ],
              [
                48.7908477,
                30.941472
              ],
              [
                48.7930259,
                30.9427991
              ],
              [
                48.7947846,
                30.9439431
              ],
              [
                48.7965394,
                30.9446744
              ],
              [
                48.7984542,
                30.9456834
              ],
              [
                48.800476,
                30.9463696
              ],
              [
                48.8024407,
                30.9469194
              ],
              [
                48.8046762,
                30.9473295
              ],
              [
                48.8075485,
                30.9474211
              ],
              [
                48.8106309,
                30.947196
              ],
              [
                48.8134461,
                30.9466912
              ],
              [
                48.8161583,
                30.9457313
              ],
              [
                48.8186567,
                30.9443123
              ],
              [
                48.820301,
                30.9426171
              ],
              [
                48.8205303,
                30.9423661
              ],
              [
                48.8226395,
                30.9400565
              ],
              [
                48.8247069,
                30.937171
              ],
              [
                48.826725,
                30.9340592
              ],
              [
                48.8286324,
                30.931313
              ],
              [
                48.8306503,
                30.9284311
              ],
              [
                48.8322411,
                30.9259118
              ],
              [
                48.8343621,
                30.9229842
              ],
              [
                48.8364336,
                30.9205112
              ],
              [
                48.8388749,
                30.9177648
              ],
              [
                48.8408396,
                30.9156125
              ],
              [
                48.842697,
                30.9138304
              ],
              [
                48.8427466,
                30.9106193
              ],
              [
                48.8431932,
                30.9038357
              ],
              [
                48.8455105,
                30.8958464
              ],
              [
                48.858984,
                30.8887578
              ],
              [
                48.8653639,
                30.884277
              ],
              [
                48.8779334,
                30.8779062
              ],
              [
                48.8859483,
                30.8779186
              ],
              [
                48.8970453,
                30.8731694
              ],
              [
                48.9035149,
                30.8665428
              ],
              [
                48.9130783,
                30.863592
              ],
              [
                48.9186335,
                30.8647514
              ],
              [
                48.9016112,
                30.8991117
              ],
              [
                48.8869324,
                30.930227
              ],
              [
                48.8800619,
                30.942133
              ],
              [
                48.8675157,
                30.9695209
              ],
              [
                48.8329696,
                31.0363853
              ],
              [
                48.8153038,
                31.0681516
              ],
              [
                48.8104953,
                31.0786563
              ],
              [
                48.802948,
                31.0924636
              ],
              [
                48.7948972,
                31.1084096
              ],
              [
                48.7833519,
                31.1327254
              ],
              [
                48.7761061,
                31.1493808
              ],
              [
                48.7649345,
                31.1754191
              ],
              [
                48.761242,
                31.1857353
              ],
              [
                48.7579307,
                31.1928912
              ],
              [
                48.7547837,
                31.1999506
              ],
              [
                48.7500232,
                31.2113833
              ],
              [
                48.7480775,
                31.2141904
              ],
              [
                48.74691,
                31.2162084
              ],
              [
                48.745529,
                31.2183173
              ],
              [
                48.7445221,
                31.2206538
              ],
              [
                48.7431946,
                31.2233094
              ],
              [
                48.7420806,
                31.2254658
              ],
              [
                48.7409095,
                31.227664
              ],
              [
                48.7393187,
                31.2307343
              ],
              [
                48.7381517,
                31.2336226
              ],
              [
                48.7361869,
                31.237701
              ],
              [
                48.7343828,
                31.2421903
              ],
              [
                48.7326354,
                31.247003
              ],
              [
                48.729163,
                31.2560186
              ],
              [
                48.7251027,
                31.2544686
              ],
              [
                48.7158931,
                31.2509521
              ],
              [
                48.6947275,
                31.2589815
              ],
              [
                48.6879969,
                31.2615335
              ],
              [
                48.6799458,
                31.2645861
              ],
              [
                48.6765989,
                31.2644827
              ],
              [
                48.6764898,
                31.2644793
              ],
              [
                48.6685276,
                31.2669452
              ],
              [
                48.660798,
                31.269339
              ],
              [
                48.6589075,
                31.2699245
              ],
              [
                48.6580456,
                31.2671357
              ],
              [
                48.656735,
                31.2631881
              ],
              [
                48.6550555,
                31.2592339
              ],
              [
                48.6546744,
                31.2583367
              ],
              [
                48.6517753,
                31.2536207
              ],
              [
                48.648739,
                31.2501379
              ],
              [
                48.6469391,
                31.2486215
              ],
              [
                48.6465616,
                31.2483034
              ],
              [
                48.6426215,
                31.2417281
              ],
              [
                48.6373858,
                31.2382416
              ],
              [
                48.6366343,
                31.2384795
              ],
              [
                48.6355361,
                31.2378818
              ],
              [
                48.6344682,
                31.2377449
              ],
              [
                48.6327056,
                31.2378816
              ],
              [
                48.6309431,
                31.2384309
              ],
              [
                48.6301422,
                31.2391624
              ],
              [
                48.6296864,
                31.2398789
              ],
              [
                48.6295013,
                31.2401698
              ],
              [
                48.6292383,
                31.2414525
              ],
              [
                48.6289178,
                31.2424612
              ],
              [
                48.6289176,
                31.243654
              ],
              [
                48.6295091,
                31.2455815
              ],
              [
                48.6304702,
                31.2470017
              ],
              [
                48.6314887,
                31.2480577
              ],
              [
                48.632932,
                31.2494766
              ],
              [
                48.6335105,
                31.2500454
              ],
              [
                48.6336951,
                31.2502472
              ],
              [
                48.6343821,
                31.2510022
              ],
              [
                48.6358199,
                31.2578345
              ],
              [
                48.6357384,
                31.2601249
              ],
              [
                48.6357171,
                31.260321
              ],
              [
                48.6355025,
                31.2609803
              ],
              [
                48.6333714,
                31.267527
              ],
              [
                48.633151,
                31.268204
              ],
              [
                48.6311785,
                31.2682567
              ],
              [
                48.6209345,
                31.2685302
              ],
              [
                48.6197033,
                31.2686
              ],
              [
                48.6156948,
                31.2688272
              ],
              [
                48.6135186,
                31.2685891
              ],
              [
                48.6083485,
                31.2680231
              ],
              [
                48.5957395,
                31.2666418
              ],
              [
                48.5834737,
                31.2653078
              ],
              [
                48.5832956,
                31.2654413
              ],
              [
                48.5824393,
                31.2647067
              ],
              [
                48.5820625,
                31.2641218
              ],
              [
                48.5818482,
                31.2637892
              ],
              [
                48.5817018,
                31.2634432
              ],
              [
                48.5813636,
                31.2626436
              ],
              [
                48.5811462,
                31.2612258
              ],
              [
                48.5811959,
                31.259804
              ],
              [
                48.5815126,
                31.2587975
              ],
              [
                48.5826263,
                31.2572852
              ],
              [
                48.5834943,
                31.2564053
              ],
              [
                48.5850219,
                31.2548568
              ],
              [
                48.5858856,
                31.2542537
              ],
              [
                48.5890247,
                31.2520616
              ],
              [
                48.5904072,
                31.2515519
              ],
              [
                48.5943496,
                31.2500983
              ],
              [
                48.5979318,
                31.2485419
              ],
              [
                48.6001356,
                31.247158
              ],
              [
                48.602112,
                31.2458308
              ],
              [
                48.6037673,
                31.244272
              ],
              [
                48.6054763,
                31.2431742
              ],
              [
                48.6065444,
                31.2419382
              ],
              [
                48.6073951,
                31.2404253
              ],
              [
                48.6079293,
                31.2387306
              ],
              [
                48.6079291,
                31.2370327
              ],
              [
                48.607605,
                31.2361631
              ],
              [
                48.6059492,
                31.2350139
              ],
              [
                48.6037598,
                31.2340486
              ],
              [
                48.6016235,
                31.2336344
              ],
              [
                48.6008386,
                31.2335132
              ],
              [
                48.5986365,
                31.2331728
              ],
              [
                48.5975898,
                31.2331723
              ],
              [
                48.5962867,
                31.2331717
              ],
              [
                48.5960879,
                31.2332013
              ],
              [
                48.5929224,
                31.2336724
              ],
              [
                48.5903588,
                31.2343121
              ],
              [
                48.5880089,
                31.2357314
              ],
              [
                48.5856628,
                31.237516
              ],
              [
                48.5840073,
                31.2389347
              ],
              [
                48.58255,
                31.2401516
              ],
              [
                48.5820848,
                31.24054
              ],
              [
                48.5807496,
                31.2422804
              ],
              [
                48.580269,
                31.2438384
              ],
              [
                48.5793077,
                31.2461292
              ],
              [
                48.577923,
                31.2482384
              ],
              [
                48.5763615,
                31.2500308
              ],
              [
                48.5758818,
                31.2506869
              ],
              [
                48.5750351,
                31.2521997
              ],
              [
                48.5740776,
                31.2536202
              ],
              [
                48.5732858,
                31.2543679
              ],
              [
                48.5724298,
                31.2551764
              ],
              [
                48.5708846,
                31.2559544
              ],
              [
                48.5693894,
                31.2561403
              ],
              [
                48.5677873,
                31.2559995
              ],
              [
                48.5665587,
                31.2559086
              ],
              [
                48.5653839,
                31.2551761
              ],
              [
                48.5644721,
                31.2540314
              ],
              [
                48.5637206,
                31.2528402
              ],
              [
                48.563076,
                31.251191
              ],
              [
                48.5630561,
                31.2500497
              ],
              [
                48.56307,
                31.247705
              ],
              [
                48.5630761,
                31.2466657
              ],
              [
                48.5627557,
                31.2453338
              ],
              [
                48.5623284,
                31.243594
              ],
              [
                48.5622144,
                31.2430421
              ],
              [
                48.5617408,
                31.2407486
              ],
              [
                48.5615273,
                31.2388708
              ],
              [
                48.5612068,
                31.2358885
              ],
              [
                48.5612069,
                31.2346055
              ],
              [
                48.5613671,
                31.233276
              ],
              [
                48.5612118,
                31.2321644
              ],
              [
                48.5612069,
                31.2321298
              ],
              [
                48.5613136,
                31.230939
              ],
              [
                48.5616341,
                31.2297005
              ],
              [
                48.5621146,
                31.2286025
              ],
              [
                48.5625939,
                31.2280173
              ],
              [
                48.5631294,
                31.2273636
              ],
              [
                48.5640908,
                31.2260808
              ],
              [
                48.5651055,
                31.2248441
              ],
              [
                48.5652139,
                31.2246859
              ],
              [
                48.5656394,
                31.224065
              ],
              [
                48.566864,
                31.2230578
              ],
              [
                48.5676651,
                31.2224619
              ],
              [
                48.5678846,
                31.2223561
              ],
              [
                48.5688934,
                31.2218696
              ],
              [
                48.5700148,
                31.2214556
              ],
              [
                48.57119,
                31.2209525
              ],
              [
                48.5726319,
                31.2201747
              ],
              [
                48.5741807,
                31.2194892
              ],
              [
                48.575405,
                31.2186645
              ],
              [
                48.5765799,
                31.2180688
              ],
              [
                48.5773276,
                31.2177492
              ],
              [
                48.5779151,
                31.2173815
              ],
              [
                48.5782889,
                31.2167414
              ],
              [
                48.5785026,
                31.216193
              ],
              [
                48.5783426,
                31.2153196
              ],
              [
                48.5785028,
                31.2145403
              ],
              [
                48.5781289,
                31.2136696
              ],
              [
                48.5774346,
                31.2133476
              ],
              [
                48.5765802,
                31.2131624
              ],
              [
                48.5750848,
                31.2127487
              ],
              [
                48.5739633,
                31.21275
              ],
              [
                48.5732183,
                31.2128003
              ],
              [
                48.5726319,
                31.2128399
              ],
              [
                48.5714571,
                31.2131131
              ],
              [
                48.5698014,
                31.2134313
              ],
              [
                48.5690537,
                31.2136607
              ],
              [
                48.5678787,
                31.213661
              ],
              [
                48.566227,
                31.2134764
              ],
              [
                48.5643043,
                31.2134287
              ],
              [
                48.5622215,
                31.2131503
              ],
              [
                48.5598181,
                31.2128273
              ],
              [
                48.5578461,
                31.2124133
              ],
              [
                48.5556029,
                31.2122264
              ],
              [
                48.5515479,
                31.2112158
              ],
              [
                48.5488242,
                31.210616
              ],
              [
                48.5459975,
                31.2094234
              ],
              [
                48.5446625,
                31.2086876
              ],
              [
                48.5436478,
                31.2076784
              ],
              [
                48.543064,
                31.2066684
              ],
              [
                48.5422629,
                31.205201
              ],
              [
                48.541889,
                31.2038703
              ],
              [
                48.5418893,
                31.203
              ],
              [
                48.5418891,
                31.2018546
              ],
              [
                48.5420551,
                31.2007512
              ],
              [
                48.5421029,
                31.2004336
              ],
              [
                48.54237,
                31.1994241
              ],
              [
                48.5430641,
                31.198461
              ],
              [
                48.5435448,
                31.1975458
              ],
              [
                48.5443992,
                31.1956207
              ],
              [
                48.5460015,
                31.1924586
              ],
              [
                48.5465888,
                31.1913131
              ],
              [
                48.5469627,
                31.1902131
              ],
              [
                48.5470696,
                31.1889299
              ],
              [
                48.5473901,
                31.1882867
              ],
              [
                48.5474432,
                31.1873722
              ],
              [
                48.5474432,
                31.1860893
              ],
              [
                48.5470198,
                31.1850801
              ],
              [
                48.5461122,
                31.1842984
              ],
              [
                48.5457916,
                31.1836113
              ],
              [
                48.5451104,
                31.1832015
              ],
              [
                48.5447234,
                31.1829686
              ],
              [
                48.5434455,
                31.1824617
              ],
              [
                48.542057,
                31.1821398
              ],
              [
                48.5405656,
                31.1820933
              ],
              [
                48.5377882,
                31.1821822
              ],
              [
                48.5357628,
                31.1825921
              ],
              [
                48.5328827,
                31.1833689
              ],
              [
                48.5305863,
                31.1838727
              ],
              [
                48.5293581,
                31.1841445
              ],
              [
                48.5259438,
                31.1837745
              ],
              [
                48.5238649,
                31.1831776
              ],
              [
                48.5217322,
                31.1825796
              ],
              [
                48.5201836,
                31.1815712
              ],
              [
                48.5191727,
                31.1805145
              ],
              [
                48.5176277,
                31.1786786
              ],
              [
                48.5158157,
                31.1759267
              ],
              [
                48.5138969,
                31.173725
              ],
              [
                48.5121384,
                31.1717046
              ],
              [
                48.5087813,
                31.168722
              ],
              [
                48.5057943,
                31.1667949
              ],
              [
                48.5031319,
                31.1649575
              ],
              [
                48.4999272,
                31.1636372
              ],
              [
                48.4978333,
                31.1633214
              ],
              [
                48.496132,
                31.1634664
              ],
              [
                48.4949646,
                31.1641607
              ],
              [
                48.4935379,
                31.1651724
              ],
              [
                48.4926986,
                31.1663217
              ],
              [
                48.4913254,
                31.1674719
              ],
              [
                48.4901772,
                31.1697223
              ],
              [
                48.4887161,
                31.1725663
              ],
              [
                48.487568,
                31.1748144
              ],
              [
                48.48563,
                31.1778903
              ],
              [
                48.483944,
                31.1799137
              ],
              [
                48.4830251,
                31.1806989
              ],
              [
                48.481411,
                31.1820782
              ],
              [
                48.4799882,
                31.1838699
              ],
              [
                48.4794311,
                31.1846032
              ],
              [
                48.4793586,
                31.1846986
              ],
              [
                48.4793349,
                31.1847076
              ],
              [
                48.4789345,
                31.1848604
              ],
              [
                48.4776611,
                31.1853463
              ],
              [
                48.4760627,
                31.1855832
              ],
              [
                48.4748917,
                31.1854971
              ],
              [
                48.4736595,
                31.1850919
              ],
              [
                48.4727477,
                31.1844111
              ],
              [
                48.4717217,
                31.1833177
              ],
              [
                48.470108,
                31.1818136
              ],
              [
                48.4689713,
                31.1800348
              ],
              [
                48.4675522,
                31.1769292
              ],
              [
                48.4671059,
                31.1747807
              ],
              [
                48.4657441,
                31.1720865
              ],
              [
                48.4648666,
                31.1696635
              ],
              [
                48.4638825,
                31.1671977
              ],
              [
                48.4634781,
                31.1642699
              ],
              [
                48.4634495,
                31.1641549
              ],
              [
                48.4629211,
                31.1620312
              ],
              [
                48.4620819,
                31.1581907
              ],
              [
                48.4610328,
                31.1544881
              ],
              [
                48.46064,
                31.1526585
              ],
              [
                48.4601975,
                31.1508753
              ],
              [
                48.4594307,
                31.1489572
              ],
              [
                48.4588318,
                31.1478608
              ],
              [
                48.4581299,
                31.1466745
              ],
              [
                48.4581226,
                31.1466649
              ],
              [
                48.457983,
                31.1464805
              ],
              [
                48.4573707,
                31.145672
              ],
              [
                48.4559747,
                31.1445779
              ],
              [
                48.4542171,
                31.1438354
              ],
              [
                48.4541549,
                31.1438091
              ],
              [
                48.4528197,
                31.1431311
              ],
              [
                48.4507905,
                31.1426828
              ],
              [
                48.4486579,
                31.1425121
              ],
              [
                48.4458848,
                31.1422496
              ],
              [
                48.4435958,
                31.1424455
              ],
              [
                48.4412574,
                31.1429604
              ],
              [
                48.4395028,
                31.1431036
              ],
              [
                48.4376449,
                31.1438919
              ],
              [
                48.4355697,
                31.1440873
              ],
              [
                48.433548,
                31.1444619
              ],
              [
                48.4310455,
                31.1446104
              ],
              [
                48.4290694,
                31.14412
              ],
              [
                48.4269372,
                31.1436242
              ],
              [
                48.4254914,
                31.1430384
              ],
              [
                48.4241485,
                31.141945
              ],
              [
                48.4231262,
                31.1408062
              ],
              [
                48.4221039,
                31.1396674
              ],
              [
                48.4205398,
                31.1379361
              ],
              [
                48.4193249,
                31.1363352
              ],
              [
                48.4187051,
                31.1355184
              ],
              [
                48.4165039,
                31.133835
              ],
              [
                48.4135552,
                31.1315144
              ],
              [
                48.4111976,
                31.1300623
              ],
              [
                48.4065438,
                31.1280702
              ],
              [
                48.4049925,
                31.1273791
              ],
              [
                48.4034958,
                31.1267124
              ],
              [
                48.398304,
                31.1242221
              ],
              [
                48.392147,
                31.1206344
              ],
              [
                48.3859329,
                31.1167747
              ],
              [
                48.3837064,
                31.1151104
              ],
              [
                48.3827705,
                31.1144107
              ],
              [
                48.3803596,
                31.1129119
              ],
              [
                48.3786392,
                31.1110416
              ],
              [
                48.3770218,
                31.1088983
              ],
              [
                48.3757286,
                31.1073027
              ],
              [
                48.3750006,
                31.1060943
              ],
              [
                48.3741073,
                31.1046115
              ],
              [
                48.3734269,
                31.102828
              ],
              [
                48.3732872,
                31.1024618
              ],
              [
                48.3721924,
                31.0992627
              ],
              [
                48.3716965,
                31.0972053
              ],
              [
                48.3708688,
                31.0939598
              ],
              [
                48.3703689,
                31.0920399
              ],
              [
                48.3702506,
                31.0908042
              ],
              [
                48.3702431,
                31.0898413
              ],
              [
                48.370327,
                31.0874147
              ],
              [
                48.3703651,
                31.0855396
              ],
              [
                48.3705559,
                31.0832032
              ],
              [
                48.3711242,
                31.0812758
              ],
              [
                48.3716355,
                31.0790766
              ],
              [
                48.3720474,
                31.0776105
              ],
              [
                48.372776,
                31.0760493
              ],
              [
                48.3733521,
                31.0750397
              ],
              [
                48.3739205,
                31.0731596
              ],
              [
                48.3744554,
                31.071333
              ],
              [
                48.3745919,
                31.0708668
              ],
              [
                48.3759574,
                31.0687572
              ],
              [
                48.3771095,
                31.0670558
              ],
              [
                48.379219,
                31.0649861
              ],
              [
                48.3815917,
                31.0623197
              ],
              [
                48.3840752,
                31.0606588
              ],
              [
                48.3876076,
                31.0573461
              ],
              [
                48.3895331,
                31.0557198
              ],
              [
                48.390934,
                31.0545365
              ],
              [
                48.3932076,
                31.0528306
              ],
              [
                48.3955917,
                31.0517222
              ],
              [
                48.3972815,
                31.0507078
              ],
              [
                48.3987618,
                31.0496915
              ],
              [
                48.4011993,
                31.0485367
              ],
              [
                48.4028358,
                31.0473386
              ],
              [
                48.4041557,
                31.0463258
              ],
              [
                48.4053192,
                31.0454045
              ],
              [
                48.4061088,
                31.0447146
              ],
              [
                48.4068413,
                31.0433833
              ],
              [
                48.4074134,
                31.0418233
              ],
              [
                48.4080353,
                31.0403093
              ],
              [
                48.4083366,
                31.0383854
              ],
              [
                48.4084281,
                31.0370118
              ],
              [
                48.4084167,
                31.0357309
              ],
              [
                48.4081917,
                31.034448
              ],
              [
                48.4078064,
                31.0330762
              ],
              [
                48.4073716,
                31.0320257
              ],
              [
                48.406559,
                31.030749
              ],
              [
                48.405654,
                31.0299085
              ],
              [
                48.4053803,
                31.0296543
              ],
              [
                48.4040483,
                31.0284825
              ],
              [
                48.4040375,
                31.0284729
              ],
              [
                48.4025383,
                31.0273357
              ],
              [
                48.4006195,
                31.0267942
              ],
              [
                48.3984872,
                31.0263476
              ],
              [
                48.398444,
                31.0263359
              ],
              [
                48.3981286,
                31.02625
              ],
              [
                48.3967928,
                31.0258864
              ],
              [
                48.3966713,
                31.0258533
              ],
              [
                48.3945999,
                31.0258182
              ],
              [
                48.3927918,
                31.0260545
              ],
              [
                48.3901901,
                31.0265724
              ],
              [
                48.3879089,
                31.0270853
              ],
              [
                48.3856812,
                31.0278271
              ],
              [
                48.3831863,
                31.0284349
              ],
              [
                48.3815995,
                31.0289911
              ],
              [
                48.3788337,
                31.0292799
              ],
              [
                48.3772964,
                31.0297898
              ],
              [
                48.3754921,
                31.0300755
              ],
              [
                48.3733636,
                31.0302216
              ],
              [
                48.3716621,
                31.0300922
              ],
              [
                48.3706475,
                31.0295936
              ],
              [
                48.368515,
                31.0290089
              ],
              [
                48.3676568,
                31.0283714
              ],
              [
                48.3660507,
                31.0272361
              ],
              [
                48.3647117,
                31.0262347
              ],
              [
                48.3639068,
                31.0255531
              ],
              [
                48.3637544,
                31.0252723
              ],
              [
                48.3633118,
                31.0244565
              ],
              [
                48.3628769,
                31.0232684
              ],
              [
                48.3627052,
                31.0221714
              ],
              [
                48.3626938,
                31.0209356
              ],
              [
                48.3628997,
                31.0198801
              ],
              [
                48.3632622,
                31.0189631
              ],
              [
                48.3642082,
                31.0175394
              ],
              [
                48.3658333,
                31.0152886
              ],
              [
                48.367569,
                31.0131731
              ],
              [
                48.3691821,
                31.0115277
              ],
              [
                48.3697319,
                31.010967
              ],
              [
                48.3698368,
                31.0108765
              ],
              [
                48.3703381,
                31.0104437
              ],
              [
                48.3743705,
                31.0069625
              ],
              [
                48.3760605,
                31.0055358
              ],
              [
                48.3768616,
                31.004732
              ],
              [
                48.3792229,
                31.0023624
              ],
              [
                48.3806694,
                31.0004265
              ],
              [
                48.3809089,
                31.0001058
              ],
              [
                48.3811761,
                30.9991913
              ],
              [
                48.3812866,
                30.9980031
              ],
              [
                48.3812904,
                30.9962175
              ],
              [
                48.3809737,
                30.9943397
              ],
              [
                48.3804969,
                30.9930583
              ],
              [
                48.3786925,
                30.9907197
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555186,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لالی",
          "name:en": "Lali County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279155",
          "wikipedia": "en:Lali County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.9215926,
                32.4240293
              ],
              [
                48.9211578,
                32.4237065
              ],
              [
                48.9207231,
                32.4237512
              ],
              [
                48.920128,
                32.4239398
              ],
              [
                48.9197621,
                32.4238828
              ],
              [
                48.919529,
                32.4238464
              ],
              [
                48.9193651,
                32.4237062
              ],
              [
                48.919197,
                32.4231533
              ],
              [
                48.919304,
                32.4229657
              ],
              [
                48.919403,
                32.4224577
              ],
              [
                48.9194148,
                32.4224246
              ],
              [
                48.9196663,
                32.421718
              ],
              [
                48.9196626,
                32.4212986
              ],
              [
                48.9193343,
                32.4210249
              ],
              [
                48.9190559,
                32.4209172
              ],
              [
                48.9187316,
                32.4207917
              ],
              [
                48.9182396,
                32.4204679
              ],
              [
                48.9182356,
                32.4201477
              ],
              [
                48.9183924,
                32.4195889
              ],
              [
                48.9185447,
                32.4188
              ],
              [
                48.9185461,
                32.4187761
              ],
              [
                48.9185907,
                32.4180139
              ],
              [
                48.9183655,
                32.4174149
              ],
              [
                48.9180917,
                32.4168675
              ],
              [
                48.918087,
                32.4168579
              ],
              [
                48.9178086,
                32.4160732
              ],
              [
                48.9174194,
                32.4155167
              ],
              [
                48.9170341,
                32.4149624
              ],
              [
                48.9163742,
                32.4140361
              ],
              [
                48.9160882,
                32.4130213
              ],
              [
                48.9157526,
                32.4122311
              ],
              [
                48.9157448,
                32.411399
              ],
              [
                48.9158441,
                32.4107062
              ],
              [
                48.9161109,
                32.410289
              ],
              [
                48.9162179,
                32.4100563
              ],
              [
                48.9165384,
                32.4096422
              ],
              [
                48.9170722,
                32.4092677
              ],
              [
                48.9182663,
                32.4092221
              ],
              [
                48.9196739,
                32.4091709
              ],
              [
                48.9206506,
                32.4089391
              ],
              [
                48.9218368,
                32.4086159
              ],
              [
                48.9223748,
                32.4082911
              ],
              [
                48.9226913,
                32.4075004
              ],
              [
                48.9229507,
                32.4065735
              ],
              [
                48.9230501,
                32.4058334
              ],
              [
                48.9226607,
                32.4050491
              ],
              [
                48.9222718,
                32.4042175
              ],
              [
                48.9223175,
                32.4036591
              ],
              [
                48.9220886,
                32.402688
              ],
              [
                48.9218636,
                32.4020417
              ],
              [
                48.9217493,
                32.4013477
              ],
              [
                48.9219589,
                32.4008822
              ],
              [
                48.9223329,
                32.4004667
              ],
              [
                48.9232521,
                32.4001888
              ],
              [
                48.9237901,
                32.400139
              ],
              [
                48.9245529,
                32.4003252
              ],
              [
                48.9251815,
                32.4007792
              ],
              [
                48.9253196,
                32.4008789
              ],
              [
                48.9259797,
                32.4016181
              ],
              [
                48.9266358,
                32.4021271
              ],
              [
                48.9270746,
                32.4026822
              ],
              [
                48.9275131,
                32.4030029
              ],
              [
                48.9283828,
                32.4031908
              ],
              [
                48.9291955,
                32.4031861
              ],
              [
                48.92968,
                32.4029077
              ],
              [
                48.930107,
                32.4025382
              ],
              [
                48.9302722,
                32.4021028
              ],
              [
                48.9303169,
                32.4019847
              ],
              [
                48.9303094,
                32.4011504
              ],
              [
                48.9300842,
                32.4005966
              ],
              [
                48.9300767,
                32.3999944
              ],
              [
                48.9301262,
                32.3997157
              ],
              [
                48.9304466,
                32.3993917
              ],
              [
                48.9308242,
                32.399204
              ],
              [
                48.9316903,
                32.3991574
              ],
              [
                48.9326667,
                32.3991576
              ],
              [
                48.9334258,
                32.3991543
              ],
              [
                48.9340209,
                32.3990626
              ],
              [
                48.9348259,
                32.3986925
              ],
              [
                48.9350188,
                32.3985876
              ],
              [
                48.9358481,
                32.3981366
              ],
              [
                48.9362717,
                32.3973927
              ],
              [
                48.9362714,
                32.3973591
              ],
              [
                48.9362679,
                32.3968853
              ],
              [
                48.9357682,
                32.3961917
              ],
              [
                48.9354971,
                32.3959122
              ],
              [
                48.9352723,
                32.3953133
              ],
              [
                48.9349404,
                32.3948028
              ],
              [
                48.9348793,
                32.3944816
              ],
              [
                48.9350357,
                32.3940626
              ],
              [
                48.9355697,
                32.3933679
              ],
              [
                48.9363708,
                32.3925828
              ],
              [
                48.9370155,
                32.3921176
              ],
              [
                48.9379846,
                32.3917457
              ],
              [
                48.938526,
                32.3915133
              ],
              [
                48.9391173,
                32.3912344
              ],
              [
                48.9394914,
                32.3908662
              ],
              [
                48.9401856,
                32.3901222
              ],
              [
                48.9406624,
                32.3894266
              ],
              [
                48.9408723,
                32.3888731
              ],
              [
                48.9409713,
                32.3882705
              ],
              [
                48.9411279,
                32.3878559
              ],
              [
                48.9415588,
                32.3875315
              ],
              [
                48.9418756,
                32.3871105
              ],
              [
                48.94252,
                32.3867423
              ],
              [
                48.9431648,
                32.3863718
              ],
              [
                48.9440307,
                32.3860928
              ],
              [
                48.9452095,
                32.3852124
              ],
              [
                48.9471361,
                32.3836813
              ],
              [
                48.9486885,
                32.3825228
              ],
              [
                48.9494972,
                32.3822452
              ],
              [
                48.9501954,
                32.3819206
              ],
              [
                48.9505691,
                32.381505
              ],
              [
                48.9511031,
                32.381038
              ],
              [
                48.9513702,
                32.3806229
              ],
              [
                48.9514694,
                32.380115
              ],
              [
                48.9518433,
                32.3795596
              ],
              [
                48.9522705,
                32.3791878
              ],
              [
                48.9528085,
                32.3789553
              ],
              [
                48.9534035,
                32.3790484
              ],
              [
                48.9536579,
                32.3790606
              ],
              [
                48.9543228,
                32.3790926
              ],
              [
                48.9547041,
                32.3790943
              ],
              [
                48.9556771,
                32.3789973
              ],
              [
                48.9562149,
                32.3788144
              ],
              [
                48.9566994,
                32.3786283
              ],
              [
                48.9568024,
                32.378258
              ],
              [
                48.9570123,
                32.377842
              ],
              [
                48.9570578,
                32.3772385
              ],
              [
                48.9568367,
                32.3768223
              ],
              [
                48.9563369,
                32.3760386
              ],
              [
                48.9556731,
                32.3749275
              ],
              [
                48.955626,
                32.3748684
              ],
              [
                48.9551202,
                32.3742331
              ],
              [
                48.9541856,
                32.3732191
              ],
              [
                48.9536934,
                32.3728481
              ],
              [
                48.9533121,
                32.3726616
              ],
              [
                48.9530906,
                32.3722904
              ],
              [
                48.9531402,
                32.3720635
              ],
              [
                48.9535141,
                32.371551
              ],
              [
                48.9540481,
                32.3712733
              ],
              [
                48.9547501,
                32.3709939
              ],
              [
                48.9558831,
                32.3708071
              ],
              [
                48.9580383,
                32.3703415
              ],
              [
                48.9592783,
                32.3700639
              ],
              [
                48.9611206,
                32.370202
              ],
              [
                48.9618759,
                32.370018
              ],
              [
                48.9630052,
                32.3695989
              ],
              [
                48.9635963,
                32.3692747
              ],
              [
                48.9642335,
                32.3686266
              ],
              [
                48.9645464,
                32.3677929
              ],
              [
                48.9649124,
                32.3670052
              ],
              [
                48.9661332,
                32.3654331
              ],
              [
                48.9674491,
                32.3629313
              ],
              [
                48.9679793,
                32.3622814
              ],
              [
                48.9685135,
                32.3619586
              ],
              [
                48.9692115,
                32.3616339
              ],
              [
                48.9700736,
                32.3614967
              ],
              [
                48.9711534,
                32.3613089
              ],
              [
                48.9721222,
                32.3610765
              ],
              [
                48.9733048,
                32.3605183
              ],
              [
                48.9744338,
                32.3601035
              ],
              [
                48.9748611,
                32.3597339
              ],
              [
                48.9754981,
                32.3591759
              ],
              [
                48.9757042,
                32.3584825
              ],
              [
                48.9760741,
                32.3579293
              ],
              [
                48.976223,
                32.3570478
              ],
              [
                48.9764328,
                32.3565867
              ],
              [
                48.9766923,
                32.3558468
              ],
              [
                48.9769514,
                32.3552895
              ],
              [
                48.9773256,
                32.3549641
              ],
              [
                48.9776497,
                32.3548746
              ],
              [
                48.9780272,
                32.3549641
              ],
              [
                48.9781419,
                32.3551982
              ],
              [
                48.9784735,
                32.3557514
              ],
              [
                48.978592,
                32.356353
              ],
              [
                48.9786608,
                32.3572763
              ],
              [
                48.9787825,
                32.3582501
              ],
              [
                48.9787863,
                32.3585029
              ],
              [
                48.9787902,
                32.3587575
              ],
              [
                48.9790267,
                32.3600081
              ],
              [
                48.9790915,
                32.3607487
              ],
              [
                48.979374,
                32.3614387
              ],
              [
                48.9795456,
                32.3619961
              ],
              [
                48.9799843,
                32.3625037
              ],
              [
                48.9806443,
                32.3631974
              ],
              [
                48.9811401,
                32.3637037
              ],
              [
                48.9814148,
                32.3640282
              ],
              [
                48.9817427,
                32.3642161
              ],
              [
                48.9819602,
                32.3643075
              ],
              [
                48.9821739,
                32.3640742
              ],
              [
                48.9821701,
                32.3637968
              ],
              [
                48.9821624,
                32.3633796
              ],
              [
                48.9821509,
                32.3626872
              ],
              [
                48.9819755,
                32.3617622
              ],
              [
                48.9819679,
                32.3612976
              ],
              [
                48.9820138,
                32.3607437
              ],
              [
                48.9820288,
                32.3606845
              ],
              [
                48.9821663,
                32.3601419
              ],
              [
                48.9819945,
                32.3597716
              ],
              [
                48.9818803,
                32.3592647
              ],
              [
                48.9816017,
                32.3588025
              ],
              [
                48.9814872,
                32.358246
              ],
              [
                48.9815865,
                32.3577832
              ],
              [
                48.9814681,
                32.3570891
              ],
              [
                48.9814607,
                32.3567192
              ],
              [
                48.9817238,
                32.3561619
              ],
              [
                48.9819335,
                32.3558384
              ],
              [
                48.9824103,
                32.3551944
              ],
              [
                48.9831008,
                32.3544997
              ],
              [
                48.9836312,
                32.3538521
              ],
              [
                48.9844322,
                32.353202
              ],
              [
                48.985611,
                32.3526008
              ],
              [
                48.9863053,
                32.3520437
              ],
              [
                48.9865686,
                32.3516262
              ],
              [
                48.9866105,
                32.35107
              ],
              [
                48.986763,
                32.3502855
              ],
              [
                48.987072,
                32.3494066
              ],
              [
                48.987381,
                32.3484803
              ],
              [
                48.9879648,
                32.3478313
              ],
              [
                48.9884415,
                32.3473248
              ],
              [
                48.9888651,
                32.3469077
              ],
              [
                48.9895668,
                32.3466753
              ],
              [
                48.9903757,
                32.34658
              ],
              [
                48.9916154,
                32.3465795
              ],
              [
                48.9924774,
                32.3464421
              ],
              [
                48.9936067,
                32.3461647
              ],
              [
                48.9939776,
                32.3460042
              ],
              [
                48.9941444,
                32.345932
              ],
              [
                48.9951552,
                32.3450056
              ],
              [
                48.9957924,
                32.3442649
              ],
              [
                48.9967957,
                32.3429686
              ],
              [
                48.9970703,
                32.3422332
              ],
              [
                48.9971581,
                32.3419981
              ],
              [
                48.9970894,
                32.3412123
              ],
              [
                48.9969712,
                32.3405182
              ],
              [
                48.9966887,
                32.3399613
              ],
              [
                48.9965705,
                32.3392673
              ],
              [
                48.9966697,
                32.3387593
              ],
              [
                48.9967119,
                32.3381579
              ],
              [
                48.9967612,
                32.3377867
              ],
              [
                48.9969177,
                32.3374171
              ],
              [
                48.997547,
                32.3363539
              ],
              [
                48.9983367,
                32.3352886
              ],
              [
                48.9991837,
                32.3341341
              ],
              [
                48.9991189,
                32.3335807
              ],
              [
                48.9988974,
                32.33316
              ],
              [
                48.9985122,
                32.3327436
              ],
              [
                48.9979134,
                32.3324252
              ],
              [
                48.9975852,
                32.3323298
              ],
              [
                48.9970474,
                32.3323776
              ],
              [
                48.9959183,
                32.3325626
              ],
              [
                48.9942436,
                32.3325157
              ],
              [
                48.9931067,
                32.3322879
              ],
              [
                48.9924507,
                32.3318242
              ],
              [
                48.9920616,
                32.3312679
              ],
              [
                48.99189,
                32.3306226
              ],
              [
                48.9922601,
                32.3301121
              ],
              [
                48.9926262,
                32.329419
              ],
              [
                48.9932632,
                32.3288654
              ],
              [
                48.9943312,
                32.3280301
              ],
              [
                48.9945907,
                32.3276149
              ],
              [
                48.9945869,
                32.3272901
              ],
              [
                48.994423,
                32.3270598
              ],
              [
                48.9941978,
                32.3266909
              ],
              [
                48.9932708,
                32.3259502
              ],
              [
                48.99255,
                32.3249331
              ],
              [
                48.9911194,
                32.3231268
              ],
              [
                48.988804,
                32.3200753
              ],
              [
                48.9860037,
                32.3171198
              ],
              [
                48.984684,
                32.3156399
              ],
              [
                48.9837531,
                32.3145743
              ],
              [
                48.9826546,
                32.313373
              ],
              [
                48.9819908,
                32.3123545
              ],
              [
                48.981262,
                32.3106924
              ],
              [
                48.9808083,
                32.309303
              ],
              [
                48.9802437,
                32.3075894
              ],
              [
                48.9796792,
                32.3059276
              ],
              [
                48.9792863,
                32.3050465
              ],
              [
                48.9791106,
                32.3042139
              ],
              [
                48.9791489,
                32.3031954
              ],
              [
                48.9790152,
                32.3015338
              ],
              [
                48.9801597,
                32.302224
              ],
              [
                48.9805586,
                32.3024699
              ],
              [
                48.9811362,
                32.3028259
              ],
              [
                48.9820633,
                32.3034292
              ],
              [
                48.9836388,
                32.3042593
              ],
              [
                48.985321,
                32.304904
              ],
              [
                48.9869386,
                32.3050921
              ],
              [
                48.9878044,
                32.3051826
              ],
              [
                48.9889337,
                32.3051826
              ],
              [
                48.9899026,
                32.3050424
              ],
              [
                48.9908678,
                32.3047647
              ],
              [
                48.9917222,
                32.3042575
              ],
              [
                48.9931108,
                32.3035174
              ],
              [
                48.9931482,
                32.3034973
              ],
              [
                48.9942321,
                32.302913
              ],
              [
                48.995304,
                32.3027316
              ],
              [
                48.9959526,
                32.3027261
              ],
              [
                48.9966585,
                32.3031928
              ],
              [
                48.9970435,
                32.3036543
              ],
              [
                48.9971762,
                32.3039656
              ],
              [
                48.9974364,
                32.304576
              ],
              [
                48.9976731,
                32.3057319
              ],
              [
                48.9976922,
                32.3067514
              ],
              [
                48.9976999,
                32.3073535
              ],
              [
                48.997547,
                32.3077705
              ],
              [
                48.9975625,
                32.3086478
              ],
              [
                48.9978983,
                32.309528
              ],
              [
                48.9981765,
                32.3100826
              ],
              [
                48.998562,
                32.3104968
              ],
              [
                48.9988936,
                32.3109598
              ],
              [
                48.9999009,
                32.3111381
              ],
              [
                49.0011407,
                32.310948
              ],
              [
                49.0021096,
                32.3111257
              ],
              [
                49.0035629,
                32.3113066
              ],
              [
                49.0049628,
                32.3118067
              ],
              [
                49.0060424,
                32.312171
              ],
              [
                49.0069619,
                32.3127673
              ],
              [
                49.0078238,
                32.3130424
              ],
              [
                49.0091135,
                32.3128463
              ],
              [
                49.0104066,
                32.3127066
              ],
              [
                49.0123406,
                32.3121419
              ],
              [
                49.0131456,
                32.3116765
              ],
              [
                49.014328,
                32.3116681
              ],
              [
                49.0149726,
                32.3114821
              ],
              [
                49.0159415,
                32.3110621
              ],
              [
                49.0164222,
                32.3108284
              ],
              [
                49.0173872,
                32.3102686
              ],
              [
                49.0183562,
                32.3098938
              ],
              [
                49.0188369,
                32.309155
              ],
              [
                49.0191573,
                32.3086482
              ],
              [
                49.0195311,
                32.3082279
              ],
              [
                49.0202826,
                32.3079489
              ],
              [
                49.0211944,
                32.3076204
              ],
              [
                49.0222168,
                32.3072464
              ],
              [
                49.0230712,
                32.3066871
              ],
              [
                49.0237693,
                32.3061749
              ],
              [
                49.0241968,
                32.3056224
              ],
              [
                49.0252112,
                32.3045087
              ],
              [
                49.0260162,
                32.303811
              ],
              [
                49.026333,
                32.3026998
              ],
              [
                49.0265428,
                32.3018238
              ],
              [
                49.0273438,
                32.3010787
              ],
              [
                49.028202,
                32.3002939
              ],
              [
                49.0285721,
                32.2996436
              ],
              [
                49.029213,
                32.2986727
              ],
              [
                49.0299606,
                32.2980644
              ],
              [
                49.0307123,
                32.2975079
              ],
              [
                49.0313531,
                32.2966769
              ],
              [
                49.0324251,
                32.2959788
              ],
              [
                49.0334967,
                32.2954183
              ],
              [
                49.0347253,
                32.2943506
              ],
              [
                49.0352632,
                32.2939802
              ],
              [
                49.0366019,
                32.2934193
              ],
              [
                49.0379981,
                32.2930419
              ],
              [
                49.0391274,
                32.2930369
              ],
              [
                49.0406874,
                32.293122
              ],
              [
                49.0418167,
                32.293117
              ],
              [
                49.0438576,
                32.2928781
              ],
              [
                49.0457879,
                32.2921301
              ],
              [
                49.047989,
                32.2913772
              ],
              [
                49.0498659,
                32.2909553
              ],
              [
                49.051155,
                32.2905806
              ],
              [
                49.0526008,
                32.2898791
              ],
              [
                49.0539971,
                32.2896887
              ],
              [
                49.0545882,
                32.2898714
              ],
              [
                49.0553969,
                32.2899132
              ],
              [
                49.0561485,
                32.2897715
              ],
              [
                49.0571137,
                32.2893534
              ],
              [
                49.0579681,
                32.288884
              ],
              [
                49.0587655,
                32.2875908
              ],
              [
                49.0589753,
                32.2868048
              ],
              [
                49.0589713,
                32.2862929
              ],
              [
                49.05875,
                32.2853741
              ],
              [
                49.0583686,
                32.2848203
              ],
              [
                49.0576667,
                32.284318
              ],
              [
                49.0576642,
                32.2843164
              ],
              [
                49.0565872,
                32.2836272
              ],
              [
                49.0563697,
                32.2832134
              ],
              [
                49.0561522,
                32.2827073
              ],
              [
                49.0558777,
                32.2819702
              ],
              [
                49.0558128,
                32.2808599
              ],
              [
                49.0559692,
                32.2800303
              ],
              [
                49.0562324,
                32.2789656
              ],
              [
                49.0563773,
                32.2772113
              ],
              [
                49.0563697,
                32.276059
              ],
              [
                49.0564194,
                32.2754104
              ],
              [
                49.0562517,
                32.2744856
              ],
              [
                49.0558699,
                32.2737514
              ],
              [
                49.0553817,
                32.2730133
              ],
              [
                49.0545731,
                32.2726018
              ],
              [
                49.0540315,
                32.2722349
              ],
              [
                49.0535471,
                32.2716818
              ],
              [
                49.0532188,
                32.2710386
              ],
              [
                49.053215,
                32.2703937
              ],
              [
                49.0532646,
                32.2699322
              ],
              [
                49.0534746,
                32.2693289
              ],
              [
                49.0541154,
                32.2686353
              ],
              [
                49.0550233,
                32.2682141
              ],
              [
                49.0559843,
                32.2676089
              ],
              [
                49.0580712,
                32.2663986
              ],
              [
                49.058631,
                32.2661966
              ],
              [
                49.0596236,
                32.2658384
              ],
              [
                49.0605889,
                32.265373
              ],
              [
                49.0613366,
                32.2650914
              ],
              [
                49.062191,
                32.2645791
              ],
              [
                49.0628359,
                32.2643004
              ],
              [
                49.0633165,
                32.2639267
              ],
              [
                49.0635263,
                32.2634203
              ],
              [
                49.0643769,
                32.262306
              ],
              [
                49.06492,
                32.261476
              ],
              [
                49.0650139,
                32.2613326
              ],
              [
                49.0659713,
                32.2603597
              ],
              [
                49.0670395,
                32.2596635
              ],
              [
                49.0676803,
                32.2593374
              ],
              [
                49.0685921,
                32.259056
              ],
              [
                49.0695039,
                32.2586821
              ],
              [
                49.0701445,
                32.2586783
              ],
              [
                49.0708428,
                32.2587322
              ],
              [
                49.0712738,
                32.2587655
              ],
              [
                49.0721894,
                32.258899
              ],
              [
                49.0729942,
                32.2591751
              ],
              [
                49.0742342,
                32.2595818
              ],
              [
                49.074772,
                32.2598561
              ],
              [
                49.0754204,
                32.2603643
              ],
              [
                49.076126,
                32.2611462
              ],
              [
                49.0769919,
                32.2618335
              ],
              [
                49.0773239,
                32.2630765
              ],
              [
                49.0776559,
                32.2643239
              ],
              [
                49.0777167,
                32.2652922
              ],
              [
                49.0776177,
                32.2663527
              ],
              [
                49.0774652,
                32.2671846
              ],
              [
                49.077362,
                32.2679249
              ],
              [
                49.07769,
                32.2685252
              ],
              [
                49.0782851,
                32.2689356
              ],
              [
                49.0790404,
                32.2693484
              ],
              [
                49.0803338,
                32.2697108
              ],
              [
                49.0816232,
                32.2700777
              ],
              [
                49.0830231,
                32.2702523
              ],
              [
                49.0844192,
                32.2702937
              ],
              [
                49.085064,
                32.2704275
              ],
              [
                49.086357,
                32.2706072
              ],
              [
                49.0873222,
                32.270694
              ],
              [
                49.0888864,
                32.2711033
              ],
              [
                49.0896378,
                32.2710064
              ],
              [
                49.0910835,
                32.2706788
              ],
              [
                49.0922329,
                32.2704499
              ],
              [
                49.0922624,
                32.2704441
              ],
              [
                49.0930673,
                32.2704382
              ],
              [
                49.0939789,
                32.2701566
              ],
              [
                49.0949441,
                32.2698284
              ],
              [
                49.0961723,
                32.2693644
              ],
              [
                49.0965463,
                32.2688514
              ],
              [
                49.0968628,
                32.2684368
              ],
              [
                49.0970689,
                32.2676056
              ],
              [
                49.0970649,
                32.2670013
              ],
              [
                49.0970574,
                32.2662165
              ],
              [
                49.0973739,
                32.2656621
              ],
              [
                49.0976371,
                32.2649242
              ],
              [
                49.0978965,
                32.2639991
              ],
              [
                49.0978891,
                32.2633068
              ],
              [
                49.0977745,
                32.2626602
              ],
              [
                49.0978242,
                32.2619664
              ],
              [
                49.0982438,
                32.2609491
              ],
              [
                49.0985565,
                32.2599346
              ],
              [
                49.0987626,
                32.2591011
              ],
              [
                49.0992355,
                32.2578501
              ],
              [
                49.0997619,
                32.2568321
              ],
              [
                49.1011886,
                32.2545671
              ],
              [
                49.1018714,
                32.2528524
              ],
              [
                49.102501,
                32.2516511
              ],
              [
                49.1038891,
                32.2501341
              ],
              [
                49.1045266,
                32.2484864
              ],
              [
                49.1049536,
                32.2476495
              ],
              [
                49.1053811,
                32.2470922
              ],
              [
                49.1059722,
                32.2467696
              ],
              [
                49.1068344,
                32.2464871
              ],
              [
                49.1075861,
                32.246433
              ],
              [
                49.1087722,
                32.2465207
              ],
              [
                49.1095732,
                32.2467323
              ],
              [
                49.1097948,
                32.2467908
              ],
              [
                49.111145,
                32.2474288
              ],
              [
                49.1121177,
                32.2480251
              ],
              [
                49.1133613,
                32.2488013
              ],
              [
                49.1143994,
                32.2490738
              ],
              [
                49.1155204,
                32.2495573
              ],
              [
                49.1161688,
                32.2498782
              ],
              [
                49.1167068,
                32.250247
              ],
              [
                49.117298,
                32.2503347
              ],
              [
                49.1180497,
                32.2503775
              ],
              [
                49.1185876,
                32.2503787
              ],
              [
                49.1192361,
                32.2506477
              ],
              [
                49.1199342,
                32.2508317
              ],
              [
                49.1203688,
                32.2513387
              ],
              [
                49.1204797,
                32.2517508
              ],
              [
                49.1204834,
                32.2521206
              ],
              [
                49.1207579,
                32.25272
              ],
              [
                49.1207617,
                32.2529072
              ],
              [
                49.1211395,
                32.2530864
              ],
              [
                49.1216239,
                32.2532244
              ],
              [
                49.1228065,
                32.2533119
              ],
              [
                49.1235542,
                32.2533072
              ],
              [
                49.1244699,
                32.2534403
              ],
              [
                49.1255379,
                32.253021
              ],
              [
                49.1265564,
                32.2527858
              ],
              [
                49.1274148,
                32.2527354
              ],
              [
                49.1282197,
                32.2528691
              ],
              [
                49.1288642,
                32.2529147
              ],
              [
                49.1293489,
                32.2529107
              ],
              [
                49.1303672,
                32.2528603
              ],
              [
                49.1309546,
                32.2525331
              ],
              [
                49.131916,
                32.2522993
              ],
              [
                49.1325607,
                32.2522051
              ],
              [
                49.1331481,
                32.2520627
              ],
              [
                49.133522,
                32.2518765
              ],
              [
                49.1339988,
                32.251365
              ],
              [
                49.1342658,
                32.2513193
              ],
              [
                49.1346435,
                32.2512708
              ],
              [
                49.1357153,
                32.2513114
              ],
              [
                49.1362534,
                32.2513081
              ],
              [
                49.1371117,
                32.2511674
              ],
              [
                49.1375485,
                32.2510994
              ],
              [
                49.1379089,
                32.2508454
              ],
              [
                49.137916,
                32.2505005
              ],
              [
                49.1378173,
                32.249764
              ],
              [
                49.137867,
                32.2491154
              ],
              [
                49.1379132,
                32.2489749
              ],
              [
                49.1380806,
                32.2484668
              ],
              [
                49.1384009,
                32.2481424
              ],
              [
                49.138654,
                32.2480071
              ],
              [
                49.1390991,
                32.2477693
              ],
              [
                49.1396332,
                32.2472563
              ],
              [
                49.1395797,
                32.2466129
              ],
              [
                49.1396294,
                32.2462889
              ],
              [
                49.1396009,
                32.2462471
              ],
              [
                49.1392517,
                32.2457354
              ],
              [
                49.1384392,
                32.2447697
              ],
              [
                49.1379507,
                32.2439891
              ],
              [
                49.1376762,
                32.2432522
              ],
              [
                49.1375085,
                32.2424199
              ],
              [
                49.1373978,
                32.2415885
              ],
              [
                49.137394,
                32.2409436
              ],
              [
                49.13739,
                32.2400213
              ],
              [
                49.1376571,
                32.2392811
              ],
              [
                49.1377602,
                32.2385859
              ],
              [
                49.137596,
                32.2380333
              ],
              [
                49.1373215,
                32.2372513
              ],
              [
                49.1368905,
                32.2367444
              ],
              [
                49.1361313,
                32.2361492
              ],
              [
                49.1353758,
                32.2358742
              ],
              [
                49.1347274,
                32.2356031
              ],
              [
                49.1339721,
                32.2349132
              ],
              [
                49.1335908,
                32.2343597
              ],
              [
                49.1334268,
                32.2336244
              ],
              [
                49.1331482,
                32.2320554
              ],
              [
                49.1331444,
                32.2307633
              ],
              [
                49.1332437,
                32.2292834
              ],
              [
                49.1337204,
                32.2276647
              ],
              [
                49.1345214,
                32.2262266
              ],
              [
                49.1351089,
                32.2254867
              ],
              [
                49.1360167,
                32.2241404
              ],
              [
                49.1370886,
                32.2227943
              ],
              [
                49.1386988,
                32.2214921
              ],
              [
                49.1396598,
                32.2203789
              ],
              [
                49.1405715,
                32.2196797
              ],
              [
                49.1414337,
                32.2191693
              ],
              [
                49.1421852,
                32.2190293
              ],
              [
                49.1427231,
                32.2189786
              ],
              [
                49.1433183,
                32.2192489
              ],
              [
                49.1441307,
                32.2200771
              ],
              [
                49.1442902,
                32.2202954
              ],
              [
                49.1448366,
                32.2210435
              ],
              [
                49.1454849,
                32.2219662
              ],
              [
                49.1461372,
                32.2226973
              ],
              [
                49.1465148,
                32.2231606
              ],
              [
                49.1469459,
                32.2234353
              ],
              [
                49.1477012,
                32.2235681
              ],
              [
                49.148239,
                32.2235647
              ],
              [
                49.1487236,
                32.2233779
              ],
              [
                49.1489173,
                32.2232264
              ],
              [
                49.1492613,
                32.2229574
              ],
              [
                49.149582,
                32.2224502
              ],
              [
                49.1501694,
                32.2218477
              ],
              [
                49.1502762,
                32.2212901
              ],
              [
                49.1502722,
                32.2205549
              ],
              [
                49.1501581,
                32.2191192
              ],
              [
                49.1503142,
                32.2183345
              ],
              [
                49.1504708,
                32.2170876
              ],
              [
                49.1507338,
                32.2158851
              ],
              [
                49.1513213,
                32.2150526
              ],
              [
                49.1519839,
                32.2145252
              ],
              [
                49.1520195,
                32.2144969
              ],
              [
                49.1528243,
                32.2140284
              ],
              [
                49.1542778,
                32.2136505
              ],
              [
                49.1557845,
                32.2134132
              ],
              [
                49.1563759,
                32.2133181
              ],
              [
                49.1569671,
                32.2133132
              ],
              [
                49.1577757,
                32.2134941
              ],
              [
                49.1582642,
                32.2137673
              ],
              [
                49.1590728,
                32.2146427
              ],
              [
                49.1602708,
                32.2165271
              ],
              [
                49.16119,
                32.2174921
              ],
              [
                49.1614609,
                32.2179064
              ],
              [
                49.1616212,
                32.218044
              ],
              [
                49.1621093,
                32.2180398
              ],
              [
                49.1626435,
                32.2177612
              ],
              [
                49.1634521,
                32.2174348
              ],
              [
                49.1639863,
                32.2167864
              ],
              [
                49.1642113,
                32.2164269
              ],
              [
                49.1643066,
                32.2162747
              ],
              [
                49.164627,
                32.2154427
              ],
              [
                49.1649474,
                32.2147935
              ],
              [
                49.1658553,
                32.2136792
              ],
              [
                49.1672479,
                32.2123375
              ],
              [
                49.1683197,
                32.2113609
              ],
              [
                49.1689109,
                32.2107133
              ],
              [
                49.1696626,
                32.2102935
              ],
              [
                49.1707381,
                32.2100114
              ],
              [
                49.1719206,
                32.2098662
              ],
              [
                49.1734559,
                32.2098577
              ],
              [
                49.1742936,
                32.2098531
              ],
              [
                49.1754799,
                32.2100303
              ],
              [
                49.176716,
                32.2102083
              ],
              [
                49.1774748,
                32.2105755
              ],
              [
                49.1778488,
                32.2105719
              ],
              [
                49.178173,
                32.2105247
              ],
              [
                49.1784401,
                32.2103842
              ],
              [
                49.1786004,
                32.2100596
              ],
              [
                49.1786536,
                32.209553
              ],
              [
                49.1787032,
                32.2090914
              ],
              [
                49.1782686,
                32.2083095
              ],
              [
                49.1779038,
                32.2076422
              ],
              [
                49.1778908,
                32.2076186
              ],
              [
                49.1778336,
                32.206833
              ],
              [
                49.1779899,
                32.2059108
              ],
              [
                49.1783105,
                32.2054938
              ],
              [
                49.1785241,
                32.2049872
              ],
              [
                49.1789514,
                32.204707
              ],
              [
                49.1797066,
                32.2044721
              ],
              [
                49.1804045,
                32.2042837
              ],
              [
                49.181156,
                32.2041863
              ],
              [
                49.1818139,
                32.2039253
              ],
              [
                49.1818581,
                32.2039078
              ],
              [
                49.1827162,
                32.2035796
              ],
              [
                49.1833609,
                32.2033003
              ],
              [
                49.1842193,
                32.202927
              ],
              [
                49.1848107,
                32.2026942
              ],
              [
                49.1855127,
                32.2027359
              ],
              [
                49.1858368,
                32.202824
              ],
              [
                49.1860544,
                32.2032848
              ],
              [
                49.1863252,
                32.2038389
              ],
              [
                49.1862756,
                32.2047154
              ],
              [
                49.1863327,
                32.2051288
              ],
              [
                49.1862831,
                32.20564
              ],
              [
                49.1862831,
                32.2061924
              ],
              [
                49.1863403,
                32.2068359
              ],
              [
                49.1868287,
                32.2076637
              ],
              [
                49.1873742,
                32.2086298
              ],
              [
                49.1878622,
                32.2094125
              ],
              [
                49.1882399,
                32.2096412
              ],
              [
                49.188835,
                32.2099609
              ],
              [
                49.1897505,
                32.2101859
              ],
              [
                49.1906663,
                32.2103659
              ],
              [
                49.1914216,
                32.2105481
              ],
              [
                49.1923372,
                32.210586
              ],
              [
                49.1931993,
                32.2106276
              ],
              [
                49.1942252,
                32.2108069
              ],
              [
                49.1950874,
                32.2107132
              ],
              [
                49.1957854,
                32.2105721
              ],
              [
                49.1962167,
                32.2103393
              ],
              [
                49.1965371,
                32.2100101
              ],
              [
                49.1966437,
                32.2097816
              ],
              [
                49.1965333,
                32.2092276
              ],
              [
                49.1962053,
                32.2087674
              ],
              [
                49.1958915,
                32.2084474
              ],
              [
                49.1956671,
                32.2082186
              ],
              [
                49.1946412,
                32.2078093
              ],
              [
                49.1936149,
                32.2077676
              ],
              [
                49.1925391,
                32.2077703
              ],
              [
                49.1915702,
                32.207779
              ],
              [
                49.1906013,
                32.2075531
              ],
              [
                49.1899527,
                32.2071425
              ],
              [
                49.1895714,
                32.2069138
              ],
              [
                49.1895179,
                32.2064508
              ],
              [
                49.1895676,
                32.2056645
              ],
              [
                49.1897241,
                32.2049249
              ],
              [
                49.1902086,
                32.2044177
              ],
              [
                49.1909562,
                32.2036279
              ],
              [
                49.1916541,
                32.2033042
              ],
              [
                49.192192,
                32.2029759
              ],
              [
                49.1927299,
                32.2026972
              ],
              [
                49.1933211,
                32.2026944
              ],
              [
                49.1937524,
                32.2028765
              ],
              [
                49.1940658,
                32.2029776
              ],
              [
                49.194454,
                32.2031029
              ],
              [
                49.1949959,
                32.2033768
              ],
              [
                49.1956442,
                32.2040219
              ],
              [
                49.1959724,
                32.2048947
              ],
              [
                49.1966249,
                32.205815
              ],
              [
                49.1970598,
                32.206642
              ],
              [
                49.1974907,
                32.2071465
              ],
              [
                49.1980859,
                32.2075112
              ],
              [
                49.1988412,
                32.2075085
              ],
              [
                49.199917,
                32.2072712
              ],
              [
                49.2012597,
                32.206898
              ],
              [
                49.2020646,
                32.2064788
              ],
              [
                49.2032508,
                32.2062408
              ],
              [
                49.2043799,
                32.2061419
              ],
              [
                49.2057267,
                32.2061339
              ],
              [
                49.2080422,
                32.2060766
              ],
              [
                49.2098197,
                32.2059282
              ],
              [
                49.2113266,
                32.2057849
              ],
              [
                49.2131005,
                32.2054988
              ],
              [
                49.2142867,
                32.2051232
              ],
              [
                49.2154693,
                32.2047949
              ],
              [
                49.216057,
                32.204377
              ],
              [
                49.2164346,
                32.2039156
              ],
              [
                49.2168617,
                32.2032654
              ],
              [
                49.21688,
                32.2032175
              ],
              [
                49.2173385,
                32.2020184
              ],
              [
                49.2176589,
                32.2011413
              ],
              [
                49.2179223,
                32.2004009
              ],
              [
                49.2177583,
                32.1999408
              ],
              [
                49.2179146,
                32.1988787
              ],
              [
                49.2180212,
                32.1982353
              ],
              [
                49.218605,
                32.1969425
              ],
              [
                49.2191924,
                32.1959225
              ],
              [
                49.2195662,
                32.1952287
              ],
              [
                49.2200469,
                32.1944418
              ],
              [
                49.2204311,
                32.194194
              ],
              [
                49.220478,
                32.1941637
              ],
              [
                49.2210694,
                32.1940232
              ],
              [
                49.2227899,
                32.1936911
              ],
              [
                49.2238158,
                32.1936424
              ],
              [
                49.2252122,
                32.193405
              ],
              [
                49.226181,
                32.1931232
              ],
              [
                49.2273141,
                32.192979
              ],
              [
                49.228279,
                32.1924671
              ],
              [
                49.2291376,
                32.1920011
              ],
              [
                49.2302132,
                32.1913487
              ],
              [
                49.2315522,
                32.1900528
              ],
              [
                49.232731,
                32.1887592
              ],
              [
                49.2329968,
                32.1883911
              ],
              [
                49.233532,
                32.1876497
              ],
              [
                49.2345506,
                32.1863966
              ],
              [
                49.2359467,
                32.1851917
              ],
              [
                49.2372323,
                32.1841273
              ],
              [
                49.2385178,
                32.1831057
              ],
              [
                49.2398606,
                32.1822697
              ],
              [
                49.2413672,
                32.1816187
              ],
              [
                49.2426034,
                32.1809685
              ],
              [
                49.2434615,
                32.1805497
              ],
              [
                49.2442703,
                32.1802678
              ],
              [
                49.2456664,
                32.1801226
              ],
              [
                49.2464218,
                32.1801195
              ],
              [
                49.2482735,
                32.1803098
              ],
              [
                49.249984,
                32.180462
              ],
              [
                49.2520496,
                32.1805109
              ],
              [
                49.254303,
                32.1805082
              ],
              [
                49.2560271,
                32.180541
              ],
              [
                49.2579079,
                32.1802512
              ],
              [
                49.2605935,
                32.1794967
              ],
              [
                49.2623633,
                32.1788874
              ],
              [
                49.2647208,
                32.1777652
              ],
              [
                49.2672883,
                32.1761363
              ],
              [
                49.2690545,
                32.1752021
              ],
              [
                49.269553,
                32.1747963
              ],
              [
                49.2699088,
                32.174508
              ],
              [
                49.269458,
                32.1758643
              ],
              [
                49.2691269,
                32.1768605
              ],
              [
                49.2672882,
                32.1814264
              ],
              [
                49.2651292,
                32.1860916
              ],
              [
                49.2604867,
                32.1955143
              ],
              [
                49.2594834,
                32.1974555
              ],
              [
                49.2578469,
                32.2006913
              ],
              [
                49.2555809,
                32.2056322
              ],
              [
                49.2533684,
                32.2104339
              ],
              [
                49.2508355,
                32.2154702
              ],
              [
                49.249939,
                32.2171783
              ],
              [
                49.2468909,
                32.2206199
              ],
              [
                49.2453957,
                32.2230254
              ],
              [
                49.244631,
                32.2242838
              ],
              [
                49.2437935,
                32.2256617
              ],
              [
                49.2428856,
                32.2272343
              ],
              [
                49.2412834,
                32.2301908
              ],
              [
                49.2403792,
                32.2319032
              ],
              [
                49.2394716,
                32.2336584
              ],
              [
                49.2387771,
                32.2348145
              ],
              [
                49.23835,
                32.2360149
              ],
              [
                49.2382372,
                32.236359
              ],
              [
                49.2379264,
                32.2373078
              ],
              [
                49.2377702,
                32.2381851
              ],
              [
                49.2373504,
                32.2402605
              ],
              [
                49.2372515,
                32.2416806
              ],
              [
                49.2372475,
                32.2417383
              ],
              [
                49.2371484,
                32.2433514
              ],
              [
                49.2369958,
                32.2446413
              ],
              [
                49.2366258,
                32.2464874
              ],
              [
                49.2362022,
                32.247963
              ],
              [
                49.2362099,
                32.2491604
              ],
              [
                49.236329,
                32.2500708
              ],
              [
                49.2383682,
                32.2508569
              ],
              [
                49.2406109,
                32.2517608
              ],
              [
                49.2424734,
                32.2523888
              ],
              [
                49.2438794,
                32.2527376
              ],
              [
                49.246333,
                32.2533535
              ],
              [
                49.2480347,
                32.2539002
              ],
              [
                49.2499809,
                32.2540625
              ],
              [
                49.2517738,
                32.2548901
              ],
              [
                49.2536734,
                32.2555319
              ],
              [
                49.2551956,
                32.2563106
              ],
              [
                49.2567672,
                32.2569547
              ],
              [
                49.2582895,
                32.2577333
              ],
              [
                49.2594833,
                32.2580993
              ],
              [
                49.2612763,
                32.2589268
              ],
              [
                49.2626876,
                32.2594761
              ],
              [
                49.2635535,
                32.2596594
              ],
              [
                49.26437,
                32.2602118
              ],
              [
                49.2655143,
                32.2613144
              ],
              [
                49.2664987,
                32.2625117
              ],
              [
                49.2671548,
                32.2634362
              ],
              [
                49.2677652,
                32.2648156
              ],
              [
                49.2683679,
                32.265922
              ],
              [
                49.2685928,
                32.2669871
              ],
              [
                49.2686081,
                32.2685545
              ],
              [
                49.2689971,
                32.27003
              ],
              [
                49.2690164,
                32.2723844
              ],
              [
                49.269333,
                32.27769
              ],
              [
                49.2694625,
                32.2803233
              ],
              [
                49.2694703,
                32.2810134
              ],
              [
                49.2692641,
                32.2821245
              ],
              [
                49.2695465,
                32.2834633
              ],
              [
                49.2700921,
                32.2842442
              ],
              [
                49.2706946,
                32.2853506
              ],
              [
                49.2714044,
                32.2858541
              ],
              [
                49.2723273,
                32.2864079
              ],
              [
                49.2735749,
                32.2868647
              ],
              [
                49.2744942,
                32.2869066
              ],
              [
                49.2755776,
                32.2867658
              ],
              [
                49.2766038,
                32.2867167
              ],
              [
                49.2787628,
                32.2862501
              ],
              [
                49.2792275,
                32.2860418
              ],
              [
                49.2800027,
                32.2856942
              ],
              [
                49.2817307,
                32.2855035
              ],
              [
                49.2831383,
                32.2853626
              ],
              [
                49.2848626,
                32.2848922
              ],
              [
                49.2858885,
                32.2845228
              ],
              [
                49.2865523,
                32.284332
              ],
              [
                49.2866975,
                32.2842903
              ],
              [
                49.288044,
                32.2834088
              ],
              [
                49.2889594,
                32.2828981
              ],
              [
                49.2897643,
                32.2824783
              ],
              [
                49.2905196,
                32.2821548
              ],
              [
                49.2911148,
                32.2822463
              ],
              [
                49.2920915,
                32.2826586
              ],
              [
                49.2937203,
                32.2832985
              ],
              [
                49.2946433,
                32.2837597
              ],
              [
                49.2955132,
                32.284263
              ],
              [
                49.2958984,
                32.2848162
              ],
              [
                49.2963906,
                32.2855534
              ],
              [
                49.2967757,
                32.2862892
              ],
              [
                49.2972717,
                32.2875361
              ],
              [
                49.2972831,
                32.2887336
              ],
              [
                49.2971841,
                32.290074
              ],
              [
                49.2971419,
                32.2914579
              ],
              [
                49.2969932,
                32.2931674
              ],
              [
                49.2968522,
                32.2955219
              ],
              [
                49.2968597,
                32.2967193
              ],
              [
                49.2970277,
                32.2970891
              ],
              [
                49.2975731,
                32.2978248
              ],
              [
                49.2983895,
                32.2981448
              ],
              [
                49.299202,
                32.2984196
              ],
              [
                49.3002318,
                32.2987401
              ],
              [
                49.300827,
                32.2990142
              ],
              [
                49.3009948,
                32.2994314
              ],
              [
                49.3008384,
                32.299984
              ],
              [
                49.3006821,
                32.3006786
              ],
              [
                49.3009035,
                32.3014596
              ],
              [
                49.301285,
                32.3019675
              ],
              [
                49.302208,
                32.302334
              ],
              [
                49.3032876,
                32.3021929
              ],
              [
                49.3047982,
                32.3016788
              ],
              [
                49.306366,
                32.301445
              ],
              [
                49.3082505,
                32.3003316
              ],
              [
                49.3109932,
                32.2987515
              ],
              [
                49.3125573,
                32.2981027
              ],
              [
                49.3133968,
                32.2976327
              ],
              [
                49.3147089,
                32.296898
              ],
              [
                49.3154107,
                32.2964316
              ],
              [
                49.3162729,
                32.2961071
              ],
              [
                49.3172453,
                32.2960119
              ],
              [
                49.3173668,
                32.2960012
              ],
              [
                49.3188668,
                32.2958689
              ],
              [
                49.3198396,
                32.2958232
              ],
              [
                49.3203811,
                32.2959567
              ],
              [
                49.3206521,
                32.2961429
              ],
              [
                49.3210372,
                32.2966915
              ],
              [
                49.3210946,
                32.2973394
              ],
              [
                49.321476,
                32.2976602
              ],
              [
                49.3218041,
                32.2978449
              ],
              [
                49.3230478,
                32.2979765
              ],
              [
                49.3239669,
                32.2979323
              ],
              [
                49.3258627,
                32.2980612
              ],
              [
                49.3264579,
                32.2982901
              ],
              [
                49.3271637,
                32.2985655
              ],
              [
                49.32798,
                32.2991649
              ],
              [
                49.3286895,
                32.2998553
              ],
              [
                49.3310889,
                32.3025704
              ],
              [
                49.3316918,
                32.3035344
              ],
              [
                49.332405,
                32.3047322
              ],
              [
                49.3330042,
                32.3053783
              ],
              [
                49.3337669,
                32.3060648
              ],
              [
                49.3346902,
                32.3065708
              ],
              [
                49.3358308,
                32.3068881
              ],
              [
                49.3369673,
                32.3071173
              ],
              [
                49.3380469,
                32.3070683
              ],
              [
                49.3384948,
                32.3069388
              ],
              [
                49.3386955,
                32.3068807
              ],
              [
                49.339451,
                32.3067847
              ],
              [
                49.3404235,
                32.3065066
              ],
              [
                49.3410682,
                32.306046
              ],
              [
                49.3416596,
                32.3056253
              ],
              [
                49.3422548,
                32.3054392
              ],
              [
                49.3426321,
                32.3054397
              ],
              [
                49.3432806,
                32.3056218
              ],
              [
                49.343609,
                32.3059418
              ],
              [
                49.3439941,
                32.3066324
              ],
              [
                49.3443756,
                32.3071853
              ],
              [
                49.3446579,
                32.3087089
              ],
              [
                49.3448868,
                32.3101393
              ],
              [
                49.3448983,
                32.3116615
              ],
              [
                49.3451196,
                32.3121221
              ],
              [
                49.3455009,
                32.3125804
              ],
              [
                49.3463172,
                32.3131796
              ],
              [
                49.3464281,
                32.3135441
              ],
              [
                49.3464318,
                32.3139613
              ],
              [
                49.3462181,
                32.314193
              ],
              [
                49.3455201,
                32.3148874
              ],
              [
                49.3449584,
                32.3153385
              ],
              [
                49.3447686,
                32.3154909
              ],
              [
                49.3445016,
                32.3160444
              ],
              [
                49.3443986,
                32.3165978
              ],
              [
                49.3447264,
                32.31715
              ],
              [
                49.3452868,
                32.3178967
              ],
              [
                49.3453827,
                32.3180245
              ],
              [
                49.3456574,
                32.3184859
              ],
              [
                49.3459358,
                32.3194997
              ],
              [
                49.3461608,
                32.3205602
              ],
              [
                49.3465423,
                32.321156
              ],
              [
                49.3469811,
                32.3216173
              ],
              [
                49.3471983,
                32.3219381
              ],
              [
                49.3474732,
                32.3226317
              ],
              [
                49.3475874,
                32.3235058
              ],
              [
                49.3474884,
                32.3246613
              ],
              [
                49.3468514,
                32.3257218
              ],
              [
                49.3462761,
                32.3266283
              ],
              [
                49.3462639,
                32.3266476
              ],
              [
                49.3455658,
                32.327342
              ],
              [
                49.3452987,
                32.3278955
              ],
              [
                49.3453063,
                32.3287728
              ],
              [
                49.3454209,
                32.3294643
              ],
              [
                49.3453141,
                32.3299702
              ],
              [
                49.3447265,
                32.3306661
              ],
              [
                49.3439256,
                32.3317289
              ],
              [
                49.3431778,
                32.3330698
              ],
              [
                49.3431281,
                32.3336667
              ],
              [
                49.3431322,
                32.3342237
              ],
              [
                49.3436278,
                32.3353735
              ],
              [
                49.3442841,
                32.3364329
              ],
              [
                49.3446732,
                32.3377684
              ],
              [
                49.345276,
                32.3385046
              ],
              [
                49.3458747,
                32.3392859
              ],
              [
                49.3463173,
                32.3401193
              ],
              [
                49.3466454,
                32.3409015
              ],
              [
                49.346817,
                32.3417291
              ],
              [
                49.3472556,
                32.3426052
              ],
              [
                49.3479117,
                32.3437548
              ],
              [
                49.3485719,
                32.3449518
              ],
              [
                49.3494454,
                32.3459622
              ],
              [
                49.3499375,
                32.3470239
              ],
              [
                49.3510857,
                32.3483581
              ],
              [
                49.3516845,
                32.3491394
              ],
              [
                49.3529433,
                32.35075
              ],
              [
                49.3531111,
                32.35144
              ],
              [
                49.3533286,
                32.351993
              ],
              [
                49.3532831,
                32.3528719
              ],
              [
                49.3529129,
                32.3539313
              ],
              [
                49.3523256,
                32.3548595
              ],
              [
                49.3512001,
                32.3561977
              ],
              [
                49.3492163,
                32.3581877
              ],
              [
                49.3458327,
                32.3610161
              ],
              [
                49.3442649,
                32.3625006
              ],
              [
                49.3441698,
                32.3625907
              ],
              [
                49.3420219,
                32.3644409
              ],
              [
                49.3403626,
                32.3662455
              ],
              [
                49.3394013,
                32.3676332
              ],
              [
                49.3388673,
                32.3684649
              ],
              [
                49.3386575,
                32.3692063
              ],
              [
                49.3383371,
                32.3700364
              ],
              [
                49.3383446,
                32.3709137
              ],
              [
                49.3382453,
                32.372112
              ],
              [
                49.338417,
                32.372944
              ],
              [
                49.3388022,
                32.3739097
              ],
              [
                49.3406143,
                32.3776406
              ],
              [
                49.3424301,
                32.3816445
              ],
              [
                49.3427657,
                32.3828936
              ],
              [
                49.3427696,
                32.3834461
              ],
              [
                49.3428841,
                32.3840902
              ],
              [
                49.3427277,
                32.3849225
              ],
              [
                49.3428995,
                32.3863025
              ],
              [
                49.343235,
                32.3874998
              ],
              [
                49.3432899,
                32.388407
              ],
              [
                49.3433608,
                32.3895804
              ],
              [
                49.3435898,
                32.3915588
              ],
              [
                49.3436583,
                32.3929893
              ],
              [
                49.343666,
                32.3940965
              ],
              [
                49.3434637,
                32.3958053
              ],
              [
                49.3431548,
                32.3976052
              ],
              [
                49.3427888,
                32.3993615
              ],
              [
                49.3425461,
                32.4010612
              ],
              [
                49.3423804,
                32.4022221
              ],
              [
                49.3423308,
                32.4030986
              ],
              [
                49.3419076,
                32.4040221
              ],
              [
                49.3417512,
                32.4046672
              ],
              [
                49.3417588,
                32.405452
              ],
              [
                49.3417626,
                32.4060067
              ],
              [
                49.3414994,
                32.4067925
              ],
              [
                49.3414855,
                32.4069045
              ],
              [
                49.3413965,
                32.4076232
              ],
              [
                49.3411294,
                32.4080391
              ],
              [
                49.3423766,
                32.4086801
              ],
              [
                49.3441162,
                32.4097786
              ],
              [
                49.3462907,
                32.411248
              ],
              [
                49.3492737,
                32.41294
              ],
              [
                49.3531799,
                32.4148627
              ],
              [
                49.355133,
                32.4159164
              ],
              [
                49.3582229,
                32.4171496
              ],
              [
                49.3628847,
                32.418606
              ],
              [
                49.3635864,
                32.4188339
              ],
              [
                49.3646202,
                32.419384
              ],
              [
                49.3659743,
                32.4198841
              ],
              [
                49.3681946,
                32.4207066
              ],
              [
                49.3717193,
                32.4221232
              ],
              [
                49.3752974,
                32.4236757
              ],
              [
                49.390833,
                32.4268992
              ],
              [
                49.410176,
                32.4329345
              ],
              [
                49.4100334,
                32.4369015
              ],
              [
                49.4067674,
                32.4478897
              ],
              [
                49.4193134,
                32.4543759
              ],
              [
                49.4308357,
                32.4644522
              ],
              [
                49.430959,
                32.4750247
              ],
              [
                49.4309292,
                32.479809
              ],
              [
                49.4267845,
                32.4808536
              ],
              [
                49.4268076,
                32.4835237
              ],
              [
                49.4266548,
                32.4849086
              ],
              [
                49.4263497,
                32.4874009
              ],
              [
                49.4263604,
                32.4890451
              ],
              [
                49.4263611,
                32.4891509
              ],
              [
                49.4262695,
                32.491089
              ],
              [
                49.4261131,
                32.492104
              ],
              [
                49.4256854,
                32.4930778
              ],
              [
                49.4254226,
                32.493676
              ],
              [
                49.4242591,
                32.4966763
              ],
              [
                49.423739,
                32.500104
              ],
              [
                49.4236108,
                32.5019605
              ],
              [
                49.422928,
                32.5044526
              ],
              [
                49.4226226,
                32.5068931
              ],
              [
                49.422104,
                32.5097503
              ],
              [
                49.4216425,
                32.5126534
              ],
              [
                49.4216925,
                32.5142473
              ],
              [
                49.4217147,
                32.5149543
              ],
              [
                49.4216233,
                32.5168878
              ],
              [
                49.4218102,
                32.5197449
              ],
              [
                49.4216727,
                32.5225528
              ],
              [
                49.4216882,
                32.5244403
              ],
              [
                49.4215316,
                32.5255004
              ],
              [
                49.4211082,
                32.5266541
              ],
              [
                49.4205247,
                32.5281305
              ],
              [
                49.4188118,
                32.5307607
              ],
              [
                49.4174689,
                32.5325613
              ],
              [
                49.4160768,
                32.5345912
              ],
              [
                49.4146232,
                32.5362099
              ],
              [
                49.4133951,
                32.5384245
              ],
              [
                49.4123804,
                32.5404547
              ],
              [
                49.4114228,
                32.5428079
              ],
              [
                49.410572,
                32.5445605
              ],
              [
                49.4092864,
                32.5464564
              ],
              [
                49.4076234,
                32.5489473
              ],
              [
                49.4059601,
                32.5509804
              ],
              [
                49.4043541,
                32.5536118
              ],
              [
                49.4022522,
                32.5556911
              ],
              [
                49.4002112,
                32.5578186
              ],
              [
                49.3981054,
                32.5593003
              ],
              [
                49.3962174,
                32.5605502
              ],
              [
                49.3943825,
                32.5618008
              ],
              [
                49.3920554,
                32.5627316
              ],
              [
                49.389679,
                32.5640293
              ],
              [
                49.3864897,
                32.5654225
              ],
              [
                49.3831367,
                32.5667729
              ],
              [
                49.3795127,
                32.5683069
              ],
              [
                49.3765373,
                32.5695605
              ],
              [
                49.3731841,
                32.5706829
              ],
              [
                49.3711853,
                32.5716559
              ],
              [
                49.3688049,
                32.5728179
              ],
              [
                49.3671264,
                32.5733756
              ],
              [
                49.3663294,
                32.573548
              ],
              [
                49.3656122,
                32.5737031
              ],
              [
                49.3654078,
                32.573705
              ],
              [
                49.3650133,
                32.5737066
              ],
              [
                49.3643608,
                32.573617
              ],
              [
                49.3633308,
                32.5735291
              ],
              [
                49.3626571,
                32.5734809
              ],
              [
                49.3602906,
                32.5733114
              ],
              [
                49.3577919,
                32.573414
              ],
              [
                49.3538894,
                32.5736584
              ],
              [
                49.3512305,
                32.5738535
              ],
              [
                49.3477591,
                32.574189
              ],
              [
                49.3456458,
                32.5743799
              ],
              [
                49.3419037,
                32.574901
              ],
              [
                49.3379441,
                32.5753335
              ],
              [
                49.3346366,
                32.5757136
              ],
              [
                49.330677,
                32.5757287
              ],
              [
                49.3260652,
                32.575841
              ],
              [
                49.32156,
                32.5758553
              ],
              [
                49.3154297,
                32.5763866
              ],
              [
                49.3123933,
                32.5766299
              ],
              [
                49.3089219,
                32.5769192
              ],
              [
                49.3058321,
                32.5772541
              ],
              [
                49.301876,
                32.5779606
              ],
              [
                49.2975959,
                32.5787618
              ],
              [
                49.2938041,
                32.5795131
              ],
              [
                49.2884905,
                32.5803179
              ],
              [
                49.2836112,
                32.5808444
              ],
              [
                49.2787323,
                32.5814676
              ],
              [
                49.2755357,
                32.5820303
              ],
              [
                49.2717399,
                32.5826907
              ],
              [
                49.2681655,
                32.583629
              ],
              [
                49.2644843,
                32.5846605
              ],
              [
                49.2609101,
                32.5854567
              ],
              [
                49.2572745,
                32.5859339
              ],
              [
                49.2533722,
                32.5864096
              ],
              [
                49.2532667,
                32.5864163
              ],
              [
                49.2502252,
                32.5866093
              ],
              [
                49.246702,
                32.5880269
              ],
              [
                49.2403183,
                32.5905949
              ],
              [
                49.2366106,
                32.5922047
              ],
              [
                49.2340851,
                32.5932155
              ],
              [
                49.2322044,
                32.5938564
              ],
              [
                49.2304228,
                32.5941763
              ],
              [
                49.2278368,
                32.594451
              ],
              [
                49.2235718,
                32.5944517
              ],
              [
                49.2194671,
                32.5946303
              ],
              [
                49.2163926,
                32.5949519
              ],
              [
                49.2131575,
                32.595181
              ],
              [
                49.2108383,
                32.5954096
              ],
              [
                49.2076532,
                32.5958219
              ],
              [
                49.2056617,
                32.5961429
              ],
              [
                49.2040941,
                32.5962333
              ],
              [
                49.1999346,
                32.596415
              ],
              [
                49.1989668,
                32.5964575
              ],
              [
                49.1852036,
                32.597141
              ],
              [
                49.1813164,
                32.5975041
              ],
              [
                49.1775971,
                32.5979147
              ],
              [
                49.1717683,
                32.5985109
              ],
              [
                49.1670228,
                32.5992422
              ],
              [
                49.1638946,
                32.5997038
              ],
              [
                49.161953,
                32.6001173
              ],
              [
                49.1596909,
                32.6009455
              ],
              [
                49.1575395,
                32.6019106
              ],
              [
                49.1559793,
                32.6030128
              ],
              [
                49.1539383,
                32.6042071
              ],
              [
                49.1510354,
                32.6058149
              ],
              [
                49.1494749,
                32.6066442
              ],
              [
                49.1483422,
                32.6070131
              ],
              [
                49.1455918,
                32.6076557
              ],
              [
                49.1430017,
                32.608021
              ],
              [
                49.1400832,
                32.6078831
              ],
              [
                49.1384049,
                32.6077432
              ],
              [
                49.1361351,
                32.6072361
              ],
              [
                49.1344032,
                32.6067729
              ],
              [
                49.1329955,
                32.606495
              ],
              [
                49.13002,
                32.6061711
              ],
              [
                49.1254807,
                32.6056164
              ],
              [
                49.1216926,
                32.604924
              ],
              [
                49.1212617,
                32.6049243
              ],
              [
                49.1191521,
                32.6045072
              ],
              [
                49.1164512,
                32.6042299
              ],
              [
                49.1153241,
                32.6040692
              ],
              [
                49.1138534,
                32.6038595
              ],
              [
                49.1137914,
                32.6038527
              ],
              [
                49.1132095,
                32.6037892
              ],
              [
                49.1125378,
                32.603716
              ],
              [
                49.1108818,
                32.6035353
              ],
              [
                49.1081275,
                32.6035344
              ],
              [
                49.1055871,
                32.6035772
              ],
              [
                49.1030504,
                32.603805
              ],
              [
                49.0998649,
                32.6042642
              ],
              [
                49.0974388,
                32.6048633
              ],
              [
                49.0944747,
                32.6060111
              ],
              [
                49.0924264,
                32.6068841
              ],
              [
                49.0888136,
                32.608448
              ],
              [
                49.0845565,
                32.6100111
              ],
              [
                49.0797004,
                32.6113889
              ],
              [
                49.0761946,
                32.6123995
              ],
              [
                49.0730629,
                32.6129084
              ],
              [
                49.0699845,
                32.6133188
              ],
              [
                49.067173,
                32.6135934
              ],
              [
                49.0634995,
                32.6138187
              ],
              [
                49.0610696,
                32.6137744
              ],
              [
                49.0608023,
                32.6137387
              ],
              [
                49.0589189,
                32.6134998
              ],
              [
                49.0581512,
                32.6134024
              ],
              [
                49.0541458,
                32.6123889
              ],
              [
                49.0502511,
                32.6114198
              ],
              [
                49.0460855,
                32.6099437
              ],
              [
                49.041977,
                32.6086035
              ],
              [
                49.0375403,
                32.6069402
              ],
              [
                49.0338592,
                32.6054193
              ],
              [
                49.0296937,
                32.6033429
              ],
              [
                49.02396,
                32.6001165
              ],
              [
                49.0208245,
                32.5985497
              ],
              [
                49.0164413,
                32.5961944
              ],
              [
                49.0120085,
                32.5931549
              ],
              [
                49.0087091,
                32.5909381
              ],
              [
                49.0070304,
                32.5898315
              ],
              [
                49.004383,
                32.5878978
              ],
              [
                49.0019492,
                32.5859156
              ],
              [
                49.0000672,
                32.5842758
              ],
              [
                48.9999628,
                32.5841366
              ],
              [
                48.9989673,
                32.5828086
              ],
              [
                48.9977492,
                32.5813913
              ],
              [
                48.9964867,
                32.580113
              ],
              [
                48.9954949,
                32.5790623
              ],
              [
                48.9944459,
                32.577828
              ],
              [
                48.9933433,
                32.5765501
              ],
              [
                48.9924584,
                32.5754515
              ],
              [
                48.9915199,
                32.574264
              ],
              [
                48.9905701,
                32.5727044
              ],
              [
                48.9894638,
                32.5711513
              ],
              [
                48.988964,
                32.5703248
              ],
              [
                48.9879569,
                32.5684464
              ],
              [
                48.9869499,
                32.5665656
              ],
              [
                48.9861678,
                32.5651484
              ],
              [
                48.9858818,
                32.5642285
              ],
              [
                48.985367,
                32.5627547
              ],
              [
                48.9848098,
                32.5616567
              ],
              [
                48.9844056,
                32.5603245
              ],
              [
                48.9837302,
                32.5588572
              ],
              [
                48.9832229,
                32.5575706
              ],
              [
                48.9829369,
                32.5567431
              ],
              [
                48.9828606,
                32.5554996
              ],
              [
                48.9827345,
                32.5544401
              ],
              [
                48.9828071,
                32.5525519
              ],
              [
                48.9829215,
                32.5499202
              ],
              [
                48.9832955,
                32.5467832
              ],
              [
                48.9836771,
                32.5438718
              ],
              [
                48.9841232,
                32.5417483
              ],
              [
                48.9846191,
                32.5393438
              ],
              [
                48.9851381,
                32.5380512
              ],
              [
                48.9857558,
                32.5364309
              ],
              [
                48.9863358,
                32.5356398
              ],
              [
                48.9870222,
                32.5347106
              ],
              [
                48.9879264,
                32.5340577
              ],
              [
                48.9892044,
                32.5330726
              ],
              [
                48.9907531,
                32.531997
              ],
              [
                48.9912878,
                32.5316549
              ],
              [
                48.9921419,
                32.5311083
              ],
              [
                48.9944839,
                32.5293307
              ],
              [
                48.9964524,
                32.5276981
              ],
              [
                48.9980429,
                32.5260189
              ],
              [
                48.9989358,
                32.5245811
              ],
              [
                48.999508,
                32.5234223
              ],
              [
                49.0000266,
                32.5222672
              ],
              [
                49.0001677,
                32.5211105
              ],
              [
                49.000305,
                32.5198207
              ],
              [
                49.0003396,
                32.5186646
              ],
              [
                49.0001601,
                32.5177013
              ],
              [
                48.9998704,
                32.5167362
              ],
              [
                48.9995474,
                32.5160769
              ],
              [
                48.9993094,
                32.5155909
              ],
              [
                48.9983063,
                32.5138005
              ],
              [
                48.9970816,
                32.5117879
              ],
              [
                48.9950828,
                32.5087663
              ],
              [
                48.9936942,
                32.5066112
              ],
              [
                48.9916381,
                32.5034061
              ],
              [
                48.9900934,
                32.5015326
              ],
              [
                48.9898074,
                32.4999632
              ],
              [
                48.9902687,
                32.4950712
              ],
              [
                48.9899788,
                32.4940068
              ],
              [
                48.9894143,
                32.4928051
              ],
              [
                48.9892312,
                32.4914674
              ],
              [
                48.9889261,
                32.4894288
              ],
              [
                48.988392,
                32.4869356
              ],
              [
                48.988201,
                32.485131
              ],
              [
                48.9879847,
                32.4832887
              ],
              [
                48.9879455,
                32.4829557
              ],
              [
                48.9876558,
                32.4816636
              ],
              [
                48.9868585,
                32.4796284
              ],
              [
                48.9862327,
                32.477871
              ],
              [
                48.9854964,
                32.4761615
              ],
              [
                48.9846001,
                32.4747266
              ],
              [
                48.9838715,
                32.4733892
              ],
              [
                48.9828147,
                32.4718165
              ],
              [
                48.9822578,
                32.4709847
              ],
              [
                48.9810296,
                32.4690936
              ],
              [
                48.9800835,
                32.4677504
              ],
              [
                48.9787522,
                32.4661372
              ],
              [
                48.9781066,
                32.4655385
              ],
              [
                48.9777031,
                32.4651643
              ],
              [
                48.9754449,
                32.4633175
              ],
              [
                48.9727479,
                32.4614749
              ],
              [
                48.9716141,
                32.4606562
              ],
              [
                48.969616,
                32.4592125
              ],
              [
                48.9669762,
                32.4573211
              ],
              [
                48.9647829,
                32.4562147
              ],
              [
                48.9611701,
                32.4545103
              ],
              [
                48.9576111,
                32.4527097
              ],
              [
                48.9540519,
                32.4508662
              ],
              [
                48.9519195,
                32.4500807
              ],
              [
                48.9500084,
                32.449486
              ],
              [
                48.9472236,
                32.4486537
              ],
              [
                48.9449348,
                32.447967
              ],
              [
                48.9422569,
                32.4470439
              ],
              [
                48.9403457,
                32.4463994
              ],
              [
                48.9382211,
                32.4458506
              ],
              [
                48.935604,
                32.4452981
              ],
              [
                48.932556,
                32.44484
              ],
              [
                48.9304313,
                32.4444286
              ],
              [
                48.9270555,
                32.4438319
              ],
              [
                48.926918,
                32.4415637
              ],
              [
                48.9268869,
                32.4407293
              ],
              [
                48.9267541,
                32.4371644
              ],
              [
                48.9267272,
                32.4351776
              ],
              [
                48.9263306,
                32.433789
              ],
              [
                48.9258843,
                32.4328617
              ],
              [
                48.9258233,
                32.4322159
              ],
              [
                48.9254378,
                32.4317518
              ],
              [
                48.9248849,
                32.4311971
              ],
              [
                48.9247741,
                32.4307827
              ],
              [
                48.9247666,
                32.4301805
              ],
              [
                48.9247551,
                32.4294386
              ],
              [
                48.9247475,
                32.4289289
              ],
              [
                48.9245795,
                32.4285135
              ],
              [
                48.9243584,
                32.4281424
              ],
              [
                48.9235345,
                32.4272652
              ],
              [
                48.922821,
                32.4265252
              ],
              [
                48.9223252,
                32.4260638
              ],
              [
                48.9221037,
                32.4256927
              ],
              [
                48.9220429,
                32.4250446
              ],
              [
                48.9219285,
                32.4245828
              ],
              [
                48.9215926,
                32.4240293
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555207,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مسجدسلیمان",
          "name:en": "Masjedsoleyman County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278711",
          "wikipedia": "fa:شهرستان مسجدسلیمان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.9573021,
                32.1935044
              ],
              [
                48.9597167,
                32.1923912
              ],
              [
                48.963154,
                32.1909111
              ],
              [
                48.9700279,
                32.1879913
              ],
              [
                48.9729766,
                32.1862325
              ],
              [
                48.9760361,
                32.1849828
              ],
              [
                48.9802247,
                32.183406
              ],
              [
                48.9829596,
                32.1820179
              ],
              [
                48.9859083,
                32.1804009
              ],
              [
                48.9882126,
                32.1791952
              ],
              [
                48.9904672,
                32.1783178
              ],
              [
                48.9946594,
                32.1771082
              ],
              [
                48.9974023,
                32.1765068
              ],
              [
                48.9974387,
                32.1764966
              ],
              [
                48.9992295,
                32.1759946
              ],
              [
                48.9989175,
                32.1751411
              ],
              [
                48.9988937,
                32.1750761
              ],
              [
                48.9981765,
                32.173324
              ],
              [
                48.9979362,
                32.1711579
              ],
              [
                48.9977533,
                32.1694481
              ],
              [
                48.9977989,
                32.1686664
              ],
              [
                48.9977227,
                32.1664081
              ],
              [
                48.9985718,
                32.1648117
              ],
              [
                49.0003662,
                32.164335
              ],
              [
                49.0025176,
                32.1640781
              ],
              [
                49.0039178,
                32.1638837
              ],
              [
                49.0046324,
                32.1637338
              ],
              [
                49.0050469,
                32.1636468
              ],
              [
                49.006176,
                32.1633196
              ],
              [
                49.0070914,
                32.1628988
              ],
              [
                49.0081102,
                32.162155
              ],
              [
                49.0090712,
                32.1610382
              ],
              [
                49.0104639,
                32.1589474
              ],
              [
                49.0121726,
                32.156627
              ],
              [
                49.0133476,
                32.1546793
              ],
              [
                49.0147362,
                32.1518487
              ],
              [
                49.0152922,
                32.1503646
              ],
              [
                49.0157968,
                32.1490176
              ],
              [
                49.0175936,
                32.1445019
              ],
              [
                49.017605,
                32.1444731
              ],
              [
                49.0187544,
                32.1421116
              ],
              [
                49.0201111,
                32.1393241
              ],
              [
                49.0214386,
                32.1360821
              ],
              [
                49.0224293,
                32.1335966
              ],
              [
                49.0236207,
                32.1306077
              ],
              [
                49.0250549,
                32.1269953
              ],
              [
                49.0257415,
                32.124077
              ],
              [
                49.0266417,
                32.1208306
              ],
              [
                49.0275878,
                32.1164326
              ],
              [
                49.0282746,
                32.1136045
              ],
              [
                49.0285797,
                32.1105494
              ],
              [
                49.0290948,
                32.1060591
              ],
              [
                49.0296592,
                32.1002684
              ],
              [
                49.0298042,
                32.0973552
              ],
              [
                49.0300599,
                32.0942543
              ],
              [
                49.0303192,
                32.0927228
              ],
              [
                49.0304185,
                32.0912902
              ],
              [
                49.0312079,
                32.0871198
              ],
              [
                49.0316773,
                32.0845295
              ],
              [
                49.0318259,
                32.0818891
              ],
              [
                49.0319215,
                32.0794824
              ],
              [
                49.0321084,
                32.0742992
              ],
              [
                49.0321237,
                32.066155
              ],
              [
                49.0320622,
                32.0653107
              ],
              [
                49.0318909,
                32.0629607
              ],
              [
                49.03183,
                32.0616182
              ],
              [
                49.031826,
                32.061016
              ],
              [
                49.0319329,
                32.0605081
              ],
              [
                49.0321464,
                32.0601349
              ],
              [
                49.0326309,
                32.0600432
              ],
              [
                49.0330619,
                32.0601356
              ],
              [
                49.0335997,
                32.0604596
              ],
              [
                49.0343019,
                32.0608245
              ],
              [
                49.0352746,
                32.0611958
              ],
              [
                49.0366248,
                32.0617489
              ],
              [
                49.0376948,
                32.062342
              ],
              [
                49.0377045,
                32.0623474
              ],
              [
                49.0386771,
                32.0626669
              ],
              [
                49.0399171,
                32.0630333
              ],
              [
                49.0412635,
                32.0631263
              ],
              [
                49.0425035,
                32.0630304
              ],
              [
                49.0440101,
                32.0626569
              ],
              [
                49.0450822,
                32.0621909
              ],
              [
                49.045513,
                32.0617759
              ],
              [
                49.0457268,
                32.0613101
              ],
              [
                49.0459364,
                32.0604791
              ],
              [
                49.0459327,
                32.0597372
              ],
              [
                49.0460358,
                32.0590894
              ],
              [
                49.0458145,
                32.0578886
              ],
              [
                49.0454864,
                32.0570064
              ],
              [
                49.0449983,
                32.0559459
              ],
              [
                49.0442351,
                32.0547458
              ],
              [
                49.0435867,
                32.0538632
              ],
              [
                49.0435265,
                32.0537711
              ],
              [
                49.0433159,
                32.0534486
              ],
              [
                49.0430451,
                32.0530318
              ],
              [
                49.0429877,
                32.0524784
              ],
              [
                49.0430376,
                32.052017
              ],
              [
                49.0429803,
                32.0515967
              ],
              [
                49.0431404,
                32.0510896
              ],
              [
                49.0434074,
                32.0507194
              ],
              [
                49.0438918,
                32.050118
              ],
              [
                49.0442658,
                32.0496976
              ],
              [
                49.0447502,
                32.0494187
              ],
              [
                49.0451774,
                32.0492359
              ],
              [
                49.0460608,
                32.0489782
              ],
              [
                49.0461464,
                32.0489532
              ],
              [
                49.0468446,
                32.0486303
              ],
              [
                49.0475961,
                32.0482608
              ],
              [
                49.0478095,
                32.0479822
              ],
              [
                49.0480805,
                32.0476572
              ],
              [
                49.048237,
                32.0471906
              ],
              [
                49.0483436,
                32.0465924
              ],
              [
                49.0482863,
                32.0461767
              ],
              [
                49.0482825,
                32.0455294
              ],
              [
                49.0481186,
                32.0448798
              ],
              [
                49.0476303,
                32.0441394
              ],
              [
                49.0470315,
                32.0433072
              ],
              [
                49.046383,
                32.0428011
              ],
              [
                49.0456277,
                32.0421559
              ],
              [
                49.0448685,
                32.0415534
              ],
              [
                49.0437418,
                32.0407758
              ],
              [
                49.0437356,
                32.0407715
              ],
              [
                49.0432474,
                32.0403107
              ],
              [
                49.042923,
                32.0399404
              ],
              [
                49.0426523,
                32.039571
              ],
              [
                49.0425414,
                32.0392919
              ],
              [
                49.042324,
                32.0390135
              ],
              [
                49.0423242,
                32.0386933
              ],
              [
                49.0425376,
                32.0382276
              ],
              [
                49.0427381,
                32.0376376
              ],
              [
                49.0428386,
                32.0374723
              ],
              [
                49.0431214,
                32.0369761
              ],
              [
                49.0436058,
                32.0366972
              ],
              [
                49.0445746,
                32.0365611
              ],
              [
                49.0459747,
                32.036603
              ],
              [
                49.047161,
                32.0365063
              ],
              [
                49.0479698,
                32.0367848
              ],
              [
                49.0488853,
                32.0368778
              ],
              [
                49.0503961,
                32.037334
              ],
              [
                49.0520134,
                32.0378865
              ],
              [
                49.0534173,
                32.0383004
              ],
              [
                49.054821,
                32.038579
              ],
              [
                49.0553714,
                32.0387016
              ],
              [
                49.0558433,
                32.0388067
              ],
              [
                49.0567056,
                32.0388537
              ],
              [
                49.0576743,
                32.0388483
              ],
              [
                49.0585365,
                32.0386157
              ],
              [
                49.0591813,
                32.0382918
              ],
              [
                49.0592881,
                32.0379688
              ],
              [
                49.0594444,
                32.0373646
              ],
              [
                49.0594408,
                32.0363002
              ],
              [
                49.0596505,
                32.0354692
              ],
              [
                49.0596465,
                32.0343597
              ],
              [
                49.0596962,
                32.0336186
              ],
              [
                49.0596922,
                32.0328339
              ],
              [
                49.0597953,
                32.0321387
              ],
              [
                49.0597381,
                32.0316305
              ],
              [
                49.0596274,
                32.0308418
              ],
              [
                49.0594634,
                32.0303342
              ],
              [
                49.0594063,
                32.0298733
              ],
              [
                49.058918,
                32.0293202
              ],
              [
                49.0582693,
                32.0288593
              ],
              [
                49.0573541,
                32.0285341
              ],
              [
                49.0564385,
                32.028396
              ],
              [
                49.0560912,
                32.0283655
              ],
              [
                49.0554124,
                32.0283059
              ],
              [
                49.0548744,
                32.0281668
              ],
              [
                49.0545501,
                32.0280311
              ],
              [
                49.0544395,
                32.0277971
              ],
              [
                49.0544394,
                32.0275694
              ],
              [
                49.054653,
                32.0271037
              ],
              [
                49.0546492,
                32.0265512
              ],
              [
                49.0547562,
                32.0259011
              ],
              [
                49.0551262,
                32.0252078
              ],
              [
                49.0555534,
                32.0242808
              ],
              [
                49.0558738,
                32.0235867
              ],
              [
                49.056301,
                32.0227996
              ],
              [
                49.0568351,
                32.0221516
              ],
              [
                49.0575866,
                32.02164
              ],
              [
                49.0580711,
                32.0211784
              ],
              [
                49.0585022,
                32.0210384
              ],
              [
                49.0588759,
                32.0208547
              ],
              [
                49.0590936,
                32.0208558
              ],
              [
                49.0596313,
                32.0209475
              ],
              [
                49.060173,
                32.0212669
              ],
              [
                49.0606575,
                32.0215449
              ],
              [
                49.0610886,
                32.0215448
              ],
              [
                49.0620041,
                32.0217752
              ],
              [
                49.0631371,
                32.0221443
              ],
              [
                49.0641098,
                32.0223283
              ],
              [
                49.0658341,
                32.0224606
              ],
              [
                49.0670205,
                32.0224606
              ],
              [
                49.0687941,
                32.0223659
              ],
              [
                49.0696564,
                32.0219506
              ],
              [
                49.0706061,
                32.0212654
              ],
              [
                49.070942,
                32.0210231
              ],
              [
                49.0713196,
                32.0207447
              ],
              [
                49.0718537,
                32.0202342
              ],
              [
                49.0719072,
                32.0200502
              ],
              [
                49.0719605,
                32.0195887
              ],
              [
                49.07201,
                32.0192174
              ],
              [
                49.0719565,
                32.0188491
              ],
              [
                49.0715789,
                32.0185231
              ],
              [
                49.0710372,
                32.0183413
              ],
              [
                49.0702285,
                32.0179704
              ],
              [
                49.0692557,
                32.0176467
              ],
              [
                49.0690288,
                32.0175246
              ],
              [
                49.0686607,
                32.0173265
              ],
              [
                49.0680656,
                32.0169115
              ],
              [
                49.0677413,
                32.0165864
              ],
              [
                49.0675774,
                32.0162163
              ],
              [
                49.0673601,
                32.0157079
              ],
              [
                49.0674667,
                32.0152473
              ],
              [
                49.0676802,
                32.0146913
              ],
              [
                49.0678903,
                32.0141827
              ],
              [
                49.0682144,
                32.0139509
              ],
              [
                49.0684815,
                32.0134882
              ],
              [
                49.0688552,
                32.013115
              ],
              [
                49.0692331,
                32.0127938
              ],
              [
                49.0702552,
                32.0125614
              ],
              [
                49.0710069,
                32.012557
              ],
              [
                49.0724638,
                32.0127911
              ],
              [
                49.07349,
                32.0132983
              ],
              [
                49.0741385,
                32.0135269
              ],
              [
                49.0750008,
                32.0138015
              ],
              [
                49.076187,
                32.0141713
              ],
              [
                49.0769957,
                32.0144
              ],
              [
                49.0775376,
                32.0144917
              ],
              [
                49.0782889,
                32.0144918
              ],
              [
                49.0789338,
                32.0141678
              ],
              [
                49.0797958,
                32.0138427
              ],
              [
                49.0800627,
                32.0133822
              ],
              [
                49.0806502,
                32.0127327
              ],
              [
                49.0809175,
                32.012085
              ],
              [
                49.0812377,
                32.0114833
              ],
              [
                49.0814476,
                32.0108371
              ],
              [
                49.0814438,
                32.0100523
              ],
              [
                49.0813333,
                32.0088962
              ],
              [
                49.0812187,
                32.0082022
              ],
              [
                49.0810546,
                32.0076946
              ],
              [
                49.0812148,
                32.0071829
              ],
              [
                49.0813752,
                32.0065833
              ],
              [
                49.0814782,
                32.0062601
              ],
              [
                49.0819627,
                32.0056113
              ],
              [
                49.0823363,
                32.0052877
              ],
              [
                49.0828743,
                32.0050095
              ],
              [
                49.0837363,
                32.0048218
              ],
              [
                49.0844878,
                32.0048219
              ],
              [
                49.0848656,
                32.0050553
              ],
              [
                49.0855139,
                32.005329
              ],
              [
                49.0862198,
                32.0059326
              ],
              [
                49.0866547,
                32.0066224
              ],
              [
                49.0871393,
                32.0070379
              ],
              [
                49.0879517,
                32.0074989
              ],
              [
                49.0886535,
                32.0078702
              ],
              [
                49.0892448,
                32.0080077
              ],
              [
                49.0903243,
                32.0081908
              ],
              [
                49.0911331,
                32.0081894
              ],
              [
                49.0921556,
                32.0081439
              ],
              [
                49.092907,
                32.0077697
              ],
              [
                49.093872,
                32.0071257
              ],
              [
                49.09457,
                32.0063853
              ],
              [
                49.0951042,
                32.0057823
              ],
              [
                49.0954782,
                32.0049062
              ],
              [
                49.0955849,
                32.0042562
              ],
              [
                49.0956877,
                32.0037008
              ],
              [
                49.0955239,
                32.0031932
              ],
              [
                49.0950354,
                32.0025026
              ],
              [
                49.0945473,
                32.0018549
              ],
              [
                49.0940056,
                32.0010688
              ],
              [
                49.0924622,
                32.000049
              ],
              [
                49.0909233,
                31.9996447
              ],
              [
                49.0900613,
                31.9993251
              ],
              [
                49.0890959,
                31.9990512
              ],
              [
                49.0879668,
                31.9988222
              ],
              [
                49.0874825,
                31.9984091
              ],
              [
                49.0868911,
                31.997629
              ],
              [
                49.0867807,
                31.9969418
              ],
              [
                49.0867271,
                31.9961157
              ],
              [
                49.0867767,
                31.9950161
              ],
              [
                49.0870973,
                31.9936409
              ],
              [
                49.0877418,
                31.9931365
              ],
              [
                49.0885468,
                31.9929976
              ],
              [
                49.0891914,
                31.9930907
              ],
              [
                49.0901567,
                31.993227
              ],
              [
                49.0907596,
                31.9934391
              ],
              [
                49.0917166,
                31.9937759
              ],
              [
                49.0924683,
                31.994051
              ],
              [
                49.0932198,
                31.9940961
              ],
              [
                49.0941316,
                31.9940061
              ],
              [
                49.0946694,
                31.9933625
              ],
              [
                49.0960616,
                31.9924454
              ],
              [
                49.0970803,
                31.9917571
              ],
              [
                49.097587,
                31.9912574
              ],
              [
                49.0977785,
                31.9910686
              ],
              [
                49.0986902,
                31.9906561
              ],
              [
                49.0997619,
                31.990379
              ],
              [
                49.100624,
                31.9903333
              ],
              [
                49.1007447,
                31.9903881
              ],
              [
                49.1014291,
                31.9906994
              ],
              [
                49.1018067,
                31.9909282
              ],
              [
                49.102398,
                31.9909754
              ],
              [
                49.1031455,
                31.9906078
              ],
              [
                49.1044885,
                31.99024
              ],
              [
                49.1060449,
                31.9902407
              ],
              [
                49.1071741,
                31.9902395
              ],
              [
                49.1081389,
                31.9900555
              ],
              [
                49.1085166,
                31.9897815
              ],
              [
                49.1089439,
                31.9894136
              ],
              [
                49.1091043,
                31.9888161
              ],
              [
                49.1091415,
                31.9885296
              ],
              [
                49.1091577,
                31.9884043
              ],
              [
                49.1093712,
                31.9879452
              ],
              [
                49.1094782,
                31.9874868
              ],
              [
                49.1096916,
                31.9870277
              ],
              [
                49.1096878,
                31.9865699
              ],
              [
                49.1097946,
                31.985974
              ],
              [
                49.1096877,
                31.9852869
              ],
              [
                49.1093635,
                31.984919
              ],
              [
                49.1090394,
                31.9845985
              ],
              [
                49.1088792,
                31.9844608
              ],
              [
                49.1081809,
                31.9843692
              ],
              [
                49.107212,
                31.9843683
              ],
              [
                49.1067313,
                31.9842326
              ],
              [
                49.1064604,
                31.983958
              ],
              [
                49.1063002,
                31.9835001
              ],
              [
                49.10635,
                31.9829935
              ],
              [
                49.1068344,
                31.9820762
              ],
              [
                49.107582,
                31.9816657
              ],
              [
                49.1083871,
                31.9809313
              ],
              [
                49.1089209,
                31.98038
              ],
              [
                49.1092453,
                31.9801052
              ],
              [
                49.1092413,
                31.9795099
              ],
              [
                49.1092416,
                31.9791423
              ],
              [
                49.1088106,
                31.9790029
              ],
              [
                49.1077919,
                31.9786382
              ],
              [
                49.1069297,
                31.9782262
              ],
              [
                49.1063918,
                31.9777221
              ],
              [
                49.1063386,
                31.977126
              ],
              [
                49.1064987,
                31.976621
              ],
              [
                49.1072464,
                31.9760256
              ],
              [
                49.107624,
                31.9753818
              ],
              [
                49.1079978,
                31.9748778
              ],
              [
                49.1081046,
                31.9742818
              ],
              [
                49.1082078,
                31.9737309
              ],
              [
                49.1081543,
                31.9732273
              ],
              [
                49.1079901,
                31.9727693
              ],
              [
                49.1075591,
                31.9717144
              ],
              [
                49.1075058,
                31.9710709
              ],
              [
                49.1073418,
                31.9705228
              ],
              [
                49.1075554,
                31.9698788
              ],
              [
                49.107876,
                31.9691462
              ],
              [
                49.1083068,
                31.9688234
              ],
              [
                49.1091081,
                31.9686414
              ],
              [
                49.1105574,
                31.9684105
              ],
              [
                49.1115541,
                31.9682833
              ],
              [
                49.1116332,
                31.9682732
              ],
              [
                49.1123276,
                31.9679498
              ],
              [
                49.1128119,
                31.96763
              ],
              [
                49.1131859,
                31.9674011
              ],
              [
                49.1135064,
                31.967124
              ],
              [
                49.1135062,
                31.9667136
              ],
              [
                49.1132401,
                31.9659231
              ],
              [
                49.113182,
                31.9657504
              ],
              [
                49.1123238,
                31.9650634
              ],
              [
                49.111622,
                31.9645118
              ],
              [
                49.1112442,
                31.9635974
              ],
              [
                49.1107598,
                31.9631821
              ],
              [
                49.1099015,
                31.9626326
              ],
              [
                49.1092034,
                31.9622208
              ],
              [
                49.1086653,
                31.9618543
              ],
              [
                49.1083414,
                31.9613038
              ],
              [
                49.1083413,
                31.960616
              ],
              [
                49.1083373,
                31.9600207
              ],
              [
                49.1087647,
                31.959425
              ],
              [
                49.1094094,
                31.9587356
              ],
              [
                49.110321,
                31.9582305
              ],
              [
                49.1116066,
                31.9578167
              ],
              [
                49.1123048,
                31.9574956
              ],
              [
                49.1126633,
                31.957342
              ],
              [
                49.1128388,
                31.9572668
              ],
              [
                49.1129457,
                31.9570361
              ],
              [
                49.1129456,
                31.9567633
              ],
              [
                49.1129227,
                31.9567188
              ],
              [
                49.1127319,
                31.9563497
              ],
              [
                49.1119231,
                31.9559836
              ],
              [
                49.1112785,
                31.9557553
              ],
              [
                49.1109581,
                31.9553875
              ],
              [
                49.110958,
                31.9550199
              ],
              [
                49.1111678,
                31.9543782
              ],
              [
                49.1117059,
                31.9535969
              ],
              [
                49.1118126,
                31.9535985
              ],
              [
                49.11224,
                31.9529577
              ],
              [
                49.1130982,
                31.9526345
              ],
              [
                49.1140632,
                31.9524053
              ],
              [
                49.1157263,
                31.9522676
              ],
              [
                49.1161776,
                31.9521682
              ],
              [
                49.1178168,
                31.9518071
              ],
              [
                49.1186219,
                31.9516228
              ],
              [
                49.1191062,
                31.9513008
              ],
              [
                49.11932,
                31.9510266
              ],
              [
                49.1200179,
                31.9507506
              ],
              [
                49.1207122,
                31.9505218
              ],
              [
                49.1216239,
                31.9501993
              ],
              [
                49.121891,
                31.949971
              ],
              [
                49.1219446,
                31.9496945
              ],
              [
                49.1215134,
                31.9491446
              ],
              [
                49.1208153,
                31.9484127
              ],
              [
                49.1199531,
                31.9475859
              ],
              [
                49.1196862,
                31.9472663
              ],
              [
                49.119522,
                31.9470669
              ],
              [
                49.1193085,
                31.9468075
              ],
              [
                49.1192016,
                31.9462106
              ],
              [
                49.1192514,
                31.9455709
              ],
              [
                49.119465,
                31.9450645
              ],
              [
                49.120163,
                31.9446509
              ],
              [
                49.1213951,
                31.9439611
              ],
              [
                49.1216034,
                31.9438917
              ],
              [
                49.1226272,
                31.9435508
              ],
              [
                49.1238061,
                31.9428625
              ],
              [
                49.1246108,
                31.9424008
              ],
              [
                49.1256294,
                31.9414846
              ],
              [
                49.1264839,
                31.9407035
              ],
              [
                49.127716,
                31.9398309
              ],
              [
                49.1283571,
                31.9391887
              ],
              [
                49.129055,
                31.9385473
              ],
              [
                49.1298064,
                31.9383622
              ],
              [
                49.130443,
                31.9382031
              ],
              [
                49.130718,
                31.9381343
              ],
              [
                49.1313058,
                31.9381317
              ],
              [
                49.132164,
                31.9382233
              ],
              [
                49.1328087,
                31.9384966
              ],
              [
                49.1334001,
                31.9387714
              ],
              [
                49.1337775,
                31.9394602
              ],
              [
                49.1339951,
                31.939964
              ],
              [
                49.134123,
                31.9400863
              ],
              [
                49.1344261,
                31.9403762
              ],
              [
                49.1348534,
                31.9405132
              ],
              [
                49.1349789,
                31.9404731
              ],
              [
                49.1352845,
                31.9403753
              ],
              [
                49.1354445,
                31.9399176
              ],
              [
                49.1352805,
                31.9390019
              ],
              [
                49.1350633,
                31.9382208
              ],
              [
                49.134739,
                31.9372577
              ],
              [
                49.1342544,
                31.9367996
              ],
              [
                49.1339875,
                31.9366626
              ],
              [
                49.1334494,
                31.9367088
              ],
              [
                49.1327516,
                31.9369398
              ],
              [
                49.1320001,
                31.9370303
              ],
              [
                49.131195,
                31.9371221
              ],
              [
                49.13023,
                31.9370335
              ],
              [
                49.1295319,
                31.9368045
              ],
              [
                49.1289941,
                31.9363456
              ],
              [
                49.1282959,
                31.935749
              ],
              [
                49.128025,
                31.9351542
              ],
              [
                49.1277542,
                31.9345572
              ],
              [
                49.1275903,
                31.9333642
              ],
              [
                49.1275903,
                31.9326313
              ],
              [
                49.1276437,
                31.9320345
              ],
              [
                49.1283913,
                31.9312563
              ],
              [
                49.1290855,
                31.9306126
              ],
              [
                49.1306421,
                31.9304732
              ],
              [
                49.1320914,
                31.930702
              ],
              [
                49.1321879,
                31.930702
              ],
              [
                49.1327362,
                31.9307024
              ],
              [
                49.1336479,
                31.9307
              ],
              [
                49.1347732,
                31.9301957
              ],
              [
                49.1353645,
                31.9299654
              ],
              [
                49.1361656,
                31.9296434
              ],
              [
                49.1372374,
                31.9294156
              ],
              [
                49.1395453,
                31.9286331
              ],
              [
                49.1425477,
                31.9277593
              ],
              [
                49.1437798,
                31.9272993
              ],
              [
                49.144638,
                31.9269307
              ],
              [
                49.1452788,
                31.9267484
              ],
              [
                49.1456529,
                31.9264743
              ],
              [
                49.1457063,
                31.9261977
              ],
              [
                49.1455995,
                31.9256933
              ],
              [
                49.1450614,
                31.9250518
              ],
              [
                49.1444167,
                31.9246838
              ],
              [
                49.1437187,
                31.9242722
              ],
              [
                49.1435524,
                31.9240846
              ],
              [
                49.1433946,
                31.9239067
              ],
              [
                49.1431237,
                31.923127
              ],
              [
                49.1429597,
                31.9222091
              ],
              [
                49.1428491,
                31.9207418
              ],
              [
                49.1429558,
                31.920236
              ],
              [
                49.1432227,
                31.9197799
              ],
              [
                49.1438637,
                31.9189977
              ],
              [
                49.1447025,
                31.9184504
              ],
              [
                49.1449892,
                31.9182633
              ],
              [
                49.146595,
                31.9176193
              ],
              [
                49.1476134,
                31.9171606
              ],
              [
                49.1486855,
                31.9169304
              ],
              [
                49.1497574,
                31.9168378
              ],
              [
                49.1509362,
                31.9168369
              ],
              [
                49.1520118,
                31.9167894
              ],
              [
                49.1529235,
                31.9165614
              ],
              [
                49.1534305,
                31.9162542
              ],
              [
                49.1534577,
                31.9162377
              ],
              [
                49.1538848,
                31.9156869
              ],
              [
                49.153881,
                31.9150014
              ],
              [
                49.1539613,
                31.9144142
              ],
              [
                49.1539878,
                31.9142205
              ],
              [
                49.1539307,
                31.9133041
              ],
              [
                49.1538239,
                31.9128448
              ],
              [
                49.1538201,
                31.9123396
              ],
              [
                49.1539802,
                31.9117895
              ],
              [
                49.1545144,
                31.9113305
              ],
              [
                49.1547216,
                31.911198
              ],
              [
                49.1551591,
                31.9109182
              ],
              [
                49.1562844,
                31.9105489
              ],
              [
                49.1573027,
                31.9102728
              ],
              [
                49.1574122,
                31.9102436
              ],
              [
                49.1581611,
                31.910044
              ],
              [
                49.1588021,
                31.9097669
              ],
              [
                49.159069,
                31.9091236
              ],
              [
                49.1597098,
                31.908391
              ],
              [
                49.1599235,
                31.9075642
              ],
              [
                49.1605646,
                31.9067843
              ],
              [
                49.1614722,
                31.9063239
              ],
              [
                49.1625443,
                31.9058658
              ],
              [
                49.1632424,
                31.9056369
              ],
              [
                49.1639899,
                31.905084
              ],
              [
                49.1646844,
                31.9035245
              ],
              [
                49.1656457,
                31.9022847
              ],
              [
                49.1666069,
                31.9007697
              ],
              [
                49.1679381,
                31.8987526
              ],
              [
                49.168953,
                31.8972384
              ],
              [
                49.1694336,
                31.8967785
              ],
              [
                49.1704521,
                31.8963174
              ],
              [
                49.1716309,
                31.895951
              ],
              [
                49.1728629,
                31.895856
              ],
              [
                49.173561,
                31.8956743
              ],
              [
                49.1738815,
                31.8954895
              ],
              [
                49.1739882,
                31.8951686
              ],
              [
                49.1737711,
                31.8943875
              ],
              [
                49.173233,
                31.893931
              ],
              [
                49.1726418,
                31.8931513
              ],
              [
                49.1723175,
                31.8925559
              ],
              [
                49.1720548,
                31.8918488
              ],
              [
                49.1719932,
                31.891683
              ],
              [
                49.1718293,
                31.8909501
              ],
              [
                49.1718788,
                31.8898481
              ],
              [
                49.1723022,
                31.8881968
              ],
              [
                49.17305,
                31.8870507
              ],
              [
                49.1734773,
                31.8862248
              ],
              [
                49.1745986,
                31.8854877
              ],
              [
                49.1756171,
                31.8849837
              ],
              [
                49.1766892,
                31.8844782
              ],
              [
                49.1772766,
                31.8841551
              ],
              [
                49.177864,
                31.8836517
              ],
              [
                49.1783448,
                31.882504
              ],
              [
                49.1790353,
                31.8809895
              ],
              [
                49.1803703,
                31.8786477
              ],
              [
                49.1819686,
                31.8763547
              ],
              [
                49.1833001,
                31.8739203
              ],
              [
                49.1843146,
                31.8721781
              ],
              [
                49.185646,
                31.8699264
              ],
              [
                49.1869278,
                31.8679084
              ],
              [
                49.1878853,
                31.8663931
              ],
              [
                49.1886865,
                31.8650606
              ],
              [
                49.1891634,
                31.8635453
              ],
              [
                49.1896399,
                31.8617571
              ],
              [
                49.1902236,
                31.8597404
              ],
              [
                49.1907996,
                31.8565284
              ],
              [
                49.1918029,
                31.8518929
              ],
              [
                49.19339,
                31.8458337
              ],
              [
                49.1947631,
                31.8399158
              ],
              [
                49.1959762,
                31.8347758
              ],
              [
                49.1976089,
                31.8273416
              ],
              [
                49.1991958,
                31.8215145
              ],
              [
                49.2005156,
                31.815731
              ],
              [
                49.2021524,
                31.8091695
              ],
              [
                49.2020989,
                31.808711
              ],
              [
                49.2017745,
                31.8079758
              ],
              [
                49.2005917,
                31.8042035
              ],
              [
                49.2005807,
                31.8041705
              ],
              [
                49.2000884,
                31.8013718
              ],
              [
                49.1993828,
                31.7987144
              ],
              [
                49.1985627,
                31.7944927
              ],
              [
                49.1976319,
                31.7885307
              ],
              [
                49.1974069,
                31.7854111
              ],
              [
                49.1968499,
                31.779035
              ],
              [
                49.1963005,
                31.7748171
              ],
              [
                49.1962318,
                31.7707796
              ],
              [
                49.1962012,
                31.7620161
              ],
              [
                49.1970254,
                31.7537112
              ],
              [
                49.1971907,
                31.7518215
              ],
              [
                49.1971911,
                31.7499453
              ],
              [
                49.1973761,
                31.7472239
              ],
              [
                49.1979445,
                31.7448416
              ],
              [
                49.1980742,
                31.7411745
              ],
              [
                49.1980514,
                31.7381975
              ],
              [
                49.1980783,
                31.7347612
              ],
              [
                49.1981163,
                31.7330208
              ],
              [
                49.1982614,
                31.731097
              ],
              [
                49.1982499,
                31.7296288
              ],
              [
                49.1981774,
                31.7274314
              ],
              [
                49.1980476,
                31.7247303
              ],
              [
                49.1979751,
                31.7225306
              ],
              [
                49.1979104,
                31.7209286
              ],
              [
                49.1980551,
                31.7194152
              ],
              [
                49.198311,
                31.7177636
              ],
              [
                49.1981926,
                31.716436
              ],
              [
                49.1981813,
                31.714925
              ],
              [
                49.198433,
                31.7132282
              ],
              [
                49.1984214,
                31.7115796
              ],
              [
                49.1982555,
                31.7101515
              ],
              [
                49.1982461,
                31.7100707
              ],
              [
                49.1981317,
                31.7088785
              ],
              [
                49.1983412,
                31.7086491
              ],
              [
                49.2006949,
                31.7085944
              ],
              [
                49.2021904,
                31.7081758
              ],
              [
                49.2029876,
                31.7078059
              ],
              [
                49.206932,
                31.7060484
              ],
              [
                49.2123185,
                31.7040133
              ],
              [
                49.2157324,
                31.7029449
              ],
              [
                49.219631,
                31.7021989
              ],
              [
                49.2224123,
                31.7021407
              ],
              [
                49.2272796,
                31.7021679
              ],
              [
                49.2323607,
                31.7022407
              ],
              [
                49.2374993,
                31.7025869
              ],
              [
                49.2416192,
                31.7029844
              ],
              [
                49.2459491,
                31.7037684
              ],
              [
                49.2460671,
                31.7037898
              ],
              [
                49.2498365,
                31.704243
              ],
              [
                49.2501335,
                31.7042787
              ],
              [
                49.2533835,
                31.7058657
              ],
              [
                49.2577247,
                31.707648
              ],
              [
                49.2608299,
                31.7090186
              ],
              [
                49.2620086,
                31.7092918
              ],
              [
                49.2640458,
                31.7100683
              ],
              [
                49.2681693,
                31.7113917
              ],
              [
                49.2723998,
                31.7127165
              ],
              [
                49.2762566,
                31.7136752
              ],
              [
                49.2820932,
                31.7150417
              ],
              [
                49.2882539,
                31.7163649
              ],
              [
                49.2949487,
                31.7175957
              ],
              [
                49.2975198,
                31.7183269
              ],
              [
                49.3018037,
                31.7192387
              ],
              [
                49.3081779,
                31.7206969
              ],
              [
                49.3141212,
                31.7217927
              ],
              [
                49.3204385,
                31.7226563
              ],
              [
                49.3260612,
                31.723019
              ],
              [
                49.3315241,
                31.7234717
              ],
              [
                49.3328095,
                31.7236081
              ],
              [
                49.334362,
                31.7234683
              ],
              [
                49.3360175,
                31.7230118
              ],
              [
                49.3381041,
                31.7227346
              ],
              [
                49.3407822,
                31.722686
              ],
              [
                49.3435669,
                31.722729
              ],
              [
                49.3465119,
                31.7230469
              ],
              [
                49.3496703,
                31.7234577
              ],
              [
                49.3515967,
                31.7239584
              ],
              [
                49.3533135,
                31.7245061
              ],
              [
                49.3542784,
                31.7248275
              ],
              [
                49.3549727,
                31.7249176
              ],
              [
                49.3558311,
                31.7249626
              ],
              [
                49.3579179,
                31.7245948
              ],
              [
                49.3613928,
                31.7239517
              ],
              [
                49.3661576,
                31.723077
              ],
              [
                49.3697928,
                31.7223884
              ],
              [
                49.3733787,
                31.7219719
              ],
              [
                49.3769645,
                31.7215553
              ],
              [
                49.379959,
                31.7211424
              ],
              [
                49.3830604,
                31.7204511
              ],
              [
                49.3832787,
                31.7204131
              ],
              [
                49.3875542,
                31.7196691
              ],
              [
                49.3909799,
                31.7187968
              ],
              [
                49.3927956,
                31.7182446
              ],
              [
                49.3948289,
                31.7179681
              ],
              [
                49.3979338,
                31.717829
              ],
              [
                49.402321,
                31.7176879
              ],
              [
                49.4053194,
                31.717457
              ],
              [
                49.4070319,
                31.7172259
              ],
              [
                49.4081,
                31.7169032
              ],
              [
                49.409649,
                31.7162618
              ],
              [
                49.410984,
                31.7153899
              ],
              [
                49.4119988,
                31.714841
              ],
              [
                49.4125329,
                31.7145184
              ],
              [
                49.4133376,
                31.7145171
              ],
              [
                49.4149973,
                31.7149279
              ],
              [
                49.4177817,
                31.7151091
              ],
              [
                49.4208337,
                31.7154266
              ],
              [
                49.4249038,
                31.7157904
              ],
              [
                49.4265642,
                31.7159327
              ],
              [
                49.4296685,
                31.7161988
              ],
              [
                49.4339524,
                31.7164229
              ],
              [
                49.4379121,
                31.7166947
              ],
              [
                49.4419288,
                31.7165995
              ],
              [
                49.4465826,
                31.7163226
              ],
              [
                49.4485093,
                31.7159987
              ],
              [
                49.4504854,
                31.7154026
              ],
              [
                49.4532088,
                31.7140262
              ],
              [
                49.4573784,
                31.711914
              ],
              [
                49.4603652,
                31.7100332
              ],
              [
                49.4635125,
                31.7073266
              ],
              [
                49.4670828,
                31.7042078
              ],
              [
                49.467232,
                31.7040334
              ],
              [
                49.4699059,
                31.7009063
              ],
              [
                49.4732094,
                31.6972383
              ],
              [
                49.4755122,
                31.6938718
              ],
              [
                49.4779203,
                31.694165
              ],
              [
                49.4942209,
                31.6961486
              ],
              [
                49.5012628,
                31.6966443
              ],
              [
                49.5069922,
                31.6969077
              ],
              [
                49.5115851,
                31.6974485
              ],
              [
                49.514824,
                31.6976689
              ],
              [
                49.519413,
                31.6979817
              ],
              [
                49.5230866,
                31.6981551
              ],
              [
                49.5265961,
                31.6984663
              ],
              [
                49.5268223,
                31.6984873
              ],
              [
                49.5295106,
                31.6987367
              ],
              [
                49.5335617,
                31.6989548
              ],
              [
                49.5359384,
                31.6989956
              ],
              [
                49.538044,
                31.6992656
              ],
              [
                49.5418281,
                31.6997645
              ],
              [
                49.5435028,
                31.6999911
              ],
              [
                49.5457154,
                31.7002148
              ],
              [
                49.5483627,
                31.7003916
              ],
              [
                49.5521431,
                31.7007503
              ],
              [
                49.5544661,
                31.7010202
              ],
              [
                49.5575446,
                31.7012445
              ],
              [
                49.5605073,
                31.7014493
              ],
              [
                49.5620308,
                31.7015546
              ],
              [
                49.5657004,
                31.7017289
              ],
              [
                49.5726698,
                31.7018026
              ],
              [
                49.5796889,
                31.7017367
              ],
              [
                49.584442,
                31.7016768
              ],
              [
                49.5951347,
                31.7016936
              ],
              [
                49.6005324,
                31.7016334
              ],
              [
                49.609497,
                31.7016097
              ],
              [
                49.6162986,
                31.7012665
              ],
              [
                49.622345,
                31.7011109
              ],
              [
                49.6295814,
                31.7009521
              ],
              [
                49.633793,
                31.700986
              ],
              [
                49.6354674,
                31.7010739
              ],
              [
                49.6380615,
                31.7010678
              ],
              [
                49.6403846,
                31.7012459
              ],
              [
                49.6419525,
                31.7014724
              ],
              [
                49.6434669,
                31.7017005
              ],
              [
                49.6445465,
                31.7018811
              ],
              [
                49.644603,
                31.701886
              ],
              [
                49.6461144,
                31.7020173
              ],
              [
                49.6477889,
                31.7021501
              ],
              [
                49.6515695,
                31.7023232
              ],
              [
                49.6556779,
                31.7024974
              ],
              [
                49.6577834,
                31.7025376
              ],
              [
                49.6598358,
                31.7025795
              ],
              [
                49.6664771,
                31.7025612
              ],
              [
                49.6698798,
                31.7025967
              ],
              [
                49.6738244,
                31.7028633
              ],
              [
                49.6769601,
                31.7031327
              ],
              [
                49.6830673,
                31.703762
              ],
              [
                49.6882592,
                31.704535
              ],
              [
                49.6934509,
                31.705028
              ],
              [
                49.6969109,
                31.705528
              ],
              [
                49.7012404,
                31.7063931
              ],
              [
                49.7032967,
                31.7067118
              ],
              [
                49.7056771,
                31.7070291
              ],
              [
                49.7070259,
                31.7072909
              ],
              [
                49.7077865,
                31.7074385
              ],
              [
                49.7085423,
                31.7075093
              ],
              [
                49.709751,
                31.709098
              ],
              [
                49.7100832,
                31.7100215
              ],
              [
                49.7105827,
                31.7113617
              ],
              [
                49.7107086,
                31.7128402
              ],
              [
                49.7112197,
                31.7155179
              ],
              [
                49.7113649,
                31.7188481
              ],
              [
                49.7113763,
                31.7199556
              ],
              [
                49.7112388,
                31.7224531
              ],
              [
                49.7110062,
                31.7260592
              ],
              [
                49.7108612,
                31.7278146
              ],
              [
                49.7102967,
                31.7306821
              ],
              [
                49.7095719,
                31.7336879
              ],
              [
                49.7090532,
                31.7357237
              ],
              [
                49.7083702,
                31.7378976
              ],
              [
                49.707321,
                31.7409519
              ],
              [
                49.7064247,
                31.7434484
              ],
              [
                49.7054096,
                31.7470714
              ],
              [
                49.7046715,
                31.7500409
              ],
              [
                49.7042236,
                31.7509565
              ],
              [
                49.7032624,
                31.7522457
              ],
              [
                49.7026749,
                31.7530719
              ],
              [
                49.702141,
                31.7538107
              ],
              [
                49.701393,
                31.7547774
              ],
              [
                49.7004813,
                31.7552372
              ],
              [
                49.6998938,
                31.7556507
              ],
              [
                49.6986083,
                31.7563886
              ],
              [
                49.6974831,
                31.7568484
              ],
              [
                49.696087,
                31.757398
              ],
              [
                49.69535,
                31.7578666
              ],
              [
                49.6948549,
                31.7581815
              ],
              [
                49.6936759,
                31.7587783
              ],
              [
                49.6921769,
                31.7597913
              ],
              [
                49.6903573,
                31.7613536
              ],
              [
                49.688591,
                31.7627359
              ],
              [
                49.6874658,
                31.7637933
              ],
              [
                49.685646,
                31.76513
              ],
              [
                49.683876,
                31.7665551
              ],
              [
                49.6820564,
                31.7680744
              ],
              [
                49.6810379,
                31.7691802
              ],
              [
                49.6793252,
                31.7707907
              ],
              [
                49.6776659,
                31.7723567
              ],
              [
                49.6754646,
                31.7736892
              ],
              [
                49.6732138,
                31.7751159
              ],
              [
                49.6710128,
                31.7765882
              ],
              [
                49.6689757,
                31.7776923
              ],
              [
                49.6665079,
                31.7787941
              ],
              [
                49.6640931,
                31.7799912
              ],
              [
                49.6627503,
                31.7806334
              ],
              [
                49.6608199,
                31.7816437
              ],
              [
                49.6592103,
                31.7826123
              ],
              [
                49.6574402,
                31.7838995
              ],
              [
                49.6557235,
                31.7853743
              ],
              [
                49.6539536,
                31.7874914
              ],
              [
                49.652237,
                31.7897465
              ],
              [
                49.6497154,
                31.7929245
              ],
              [
                49.6475183,
                31.7966088
              ],
              [
                49.6460191,
                31.7989586
              ],
              [
                49.6443557,
                31.8008917
              ],
              [
                49.6425819,
                31.8026882
              ],
              [
                49.6403808,
                31.804805
              ],
              [
                49.6381798,
                31.8063691
              ],
              [
                49.637675,
                31.8068012
              ],
              [
                49.6368369,
                31.8075207
              ],
              [
                49.6347427,
                31.8101436
              ],
              [
                49.6323243,
                31.8137847
              ],
              [
                49.6300941,
                31.8171932
              ],
              [
                49.6270065,
                31.8203217
              ],
              [
                49.6255571,
                31.8217945
              ],
              [
                49.6237588,
                31.8231534
              ],
              [
                49.6232414,
                31.8235443
              ],
              [
                49.6203919,
                31.825153
              ],
              [
                49.6183471,
                31.8269034
              ],
              [
                49.6153908,
                31.8295257
              ],
              [
                49.6133178,
                31.8316011
              ],
              [
                49.6128616,
                31.8320578
              ],
              [
                49.6111374,
                31.8339447
              ],
              [
                49.6104393,
                31.8351413
              ],
              [
                49.6087189,
                31.838043
              ],
              [
                49.6071013,
                31.8407158
              ],
              [
                49.6060789,
                31.8430184
              ],
              [
                49.6052171,
                31.8456927
              ],
              [
                49.6047362,
                31.8479967
              ],
              [
                49.6045189,
                31.8497918
              ],
              [
                49.6041986,
                31.8520051
              ],
              [
                49.6041412,
                31.8532945
              ],
              [
                49.6035501,
                31.8559198
              ],
              [
                49.6033364,
                31.8585493
              ],
              [
                49.6030654,
                31.861451
              ],
              [
                49.6030121,
                31.8637552
              ],
              [
                49.6028519,
                31.8663379
              ],
              [
                49.6026384,
                31.8687351
              ],
              [
                49.6024209,
                31.8706248
              ],
              [
                49.6017226,
                31.8744488
              ],
              [
                49.6015586,
                31.8758767
              ],
              [
                49.6011275,
                31.8780438
              ],
              [
                49.6006965,
                31.8795184
              ],
              [
                49.6001586,
                31.8813618
              ],
              [
                49.598915,
                31.8843091
              ],
              [
                49.598053,
                31.8855535
              ],
              [
                49.5963821,
                31.8877158
              ],
              [
                49.5938988,
                31.8901105
              ],
              [
                49.5919037,
                31.8921812
              ],
              [
                49.5895807,
                31.8942979
              ],
              [
                49.5869368,
                31.8962305
              ],
              [
                49.5849953,
                31.8976116
              ],
              [
                49.5822943,
                31.8996811
              ],
              [
                49.579918,
                31.9017519
              ],
              [
                49.577648,
                31.9038689
              ],
              [
                49.5764046,
                31.9056208
              ],
              [
                49.5749475,
                31.9073229
              ],
              [
                49.5748469,
                31.9076226
              ],
              [
                49.5744058,
                31.908936
              ],
              [
                49.5734328,
                31.9111014
              ],
              [
                49.5724603,
                31.9128968
              ],
              [
                49.5709992,
                31.9149236
              ],
              [
                49.5690536,
                31.9169945
              ],
              [
                49.5672151,
                31.9189741
              ],
              [
                49.5649413,
                31.9217358
              ],
              [
                49.5622367,
                31.9252368
              ],
              [
                49.5598565,
                31.9280423
              ],
              [
                49.5580139,
                31.9302089
              ],
              [
                49.5573655,
                31.9314058
              ],
              [
                49.5567406,
                31.9324326
              ],
              [
                49.556553,
                31.9327407
              ],
              [
                49.5554694,
                31.9348144
              ],
              [
                49.5548173,
                31.9367938
              ],
              [
                49.5540582,
                31.9384066
              ],
              [
                49.5538368,
                31.9398338
              ],
              [
                49.5538331,
                31.9420957
              ],
              [
                49.5536688,
                31.9436161
              ],
              [
                49.5541001,
                31.9456912
              ],
              [
                49.5545806,
                31.9483645
              ],
              [
                49.5553894,
                31.9505319
              ],
              [
                49.5560876,
                31.9521455
              ],
              [
                49.5561943,
                31.9537592
              ],
              [
                49.5563546,
                31.9560184
              ],
              [
                49.5565642,
                31.9586458
              ],
              [
                49.5570985,
                31.9643145
              ],
              [
                49.5571977,
                31.9691101
              ],
              [
                49.5572433,
                31.9757475
              ],
              [
                49.5573999,
                31.980219
              ],
              [
                49.5572852,
                31.9840424
              ],
              [
                49.5575486,
                31.9880077
              ],
              [
                49.5577621,
                31.99013
              ],
              [
                49.5583,
                31.9933564
              ],
              [
                49.558567,
                31.9948794
              ],
              [
                49.5593606,
                31.9999896
              ],
              [
                49.5593043,
                32.0009162
              ],
              [
                49.5592538,
                32.0017473
              ],
              [
                49.5591544,
                32.004608
              ],
              [
                49.558941,
                32.006642
              ],
              [
                49.5585672,
                32.0093642
              ],
              [
                49.5583571,
                32.0113531
              ],
              [
                49.5575233,
                32.0140029
              ],
              [
                49.5574186,
                32.0143355
              ],
              [
                49.5572816,
                32.0147709
              ],
              [
                49.5565224,
                32.0144916
              ],
              [
                49.556034,
                32.0143354
              ],
              [
                49.5553817,
                32.0141268
              ],
              [
                49.5544089,
                32.0141721
              ],
              [
                49.5522424,
                32.0138046
              ],
              [
                49.5506705,
                32.0135296
              ],
              [
                49.5493165,
                32.0132074
              ],
              [
                49.5470925,
                32.012334
              ],
              [
                49.5459519,
                32.0117346
              ],
              [
                49.5431901,
                32.0110444
              ],
              [
                49.5411302,
                32.0108607
              ],
              [
                49.5388564,
                32.0110465
              ],
              [
                49.5371247,
                32.0113264
              ],
              [
                49.5367451,
                32.0113264
              ],
              [
                49.5353355,
                32.0113261
              ],
              [
                49.533928,
                32.011188
              ],
              [
                49.5313796,
                32.0105429
              ],
              [
                49.5301324,
                32.0098542
              ],
              [
                49.5300596,
                32.0097979
              ],
              [
                49.5289955,
                32.008975
              ],
              [
                49.5277444,
                32.0074992
              ],
              [
                49.5268782,
                32.0065758
              ],
              [
                49.5257912,
                32.0059317
              ],
              [
                49.5237311,
                32.0053823
              ],
              [
                49.5221063,
                32.0048741
              ],
              [
                49.5193977,
                32.0040464
              ],
              [
                49.5175018,
                32.0033522
              ],
              [
                49.5141411,
                32.002571
              ],
              [
                49.5127869,
                32.0023431
              ],
              [
                49.5099145,
                32.0023004
              ],
              [
                49.5086174,
                32.0023009
              ],
              [
                49.5085627,
                31.9998923
              ],
              [
                49.5003605,
                32.0002879
              ],
              [
                49.4975157,
                32.0005841
              ],
              [
                49.4935317,
                32.0017572
              ],
              [
                49.4897113,
                32.0061123
              ],
              [
                49.4840236,
                32.0087604
              ],
              [
                49.4771186,
                32.0072548
              ],
              [
                49.4526386,
                32.0071639
              ],
              [
                49.4431112,
                32.0061555
              ],
              [
                49.4267603,
                32.0186589
              ],
              [
                49.4233859,
                32.0189391
              ],
              [
                49.4178057,
                32.0169691
              ],
              [
                49.4143811,
                32.0156412
              ],
              [
                49.4112138,
                32.0177626
              ],
              [
                49.4076708,
                32.0225175
              ],
              [
                49.4001317,
                32.0231406
              ],
              [
                49.3902626,
                32.0245573
              ],
              [
                49.3812943,
                32.0280491
              ],
              [
                49.3685196,
                32.0483596
              ],
              [
                49.3699855,
                32.0536277
              ],
              [
                49.3690318,
                32.0575041
              ],
              [
                49.3642472,
                32.0639262
              ],
              [
                49.3573419,
                32.0668926
              ],
              [
                49.3566589,
                32.0753294
              ],
              [
                49.3544832,
                32.0793201
              ],
              [
                49.3498407,
                32.0837466
              ],
              [
                49.3467807,
                32.0906938
              ],
              [
                49.3417556,
                32.0939084
              ],
              [
                49.338093,
                32.0976292
              ],
              [
                49.3395657,
                32.1021998
              ],
              [
                49.3390991,
                32.1051342
              ],
              [
                49.334876,
                32.1079251
              ],
              [
                49.3310126,
                32.1134376
              ],
              [
                49.3314485,
                32.1143453
              ],
              [
                49.335015,
                32.1217144
              ],
              [
                49.3387323,
                32.1313678
              ],
              [
                49.3382558,
                32.1367763
              ],
              [
                49.3378817,
                32.1416212
              ],
              [
                49.3316223,
                32.1469637
              ],
              [
                49.3266846,
                32.1483055
              ],
              [
                49.3260728,
                32.1497736
              ],
              [
                49.3248492,
                32.1501706
              ],
              [
                49.3236084,
                32.1505731
              ],
              [
                49.3234485,
                32.1506015
              ],
              [
                49.3225327,
                32.150764
              ],
              [
                49.3200569,
                32.1509161
              ],
              [
                49.3181228,
                32.151161
              ],
              [
                49.3152198,
                32.151641
              ],
              [
                49.3124811,
                32.1522133
              ],
              [
                49.3089942,
                32.1533439
              ],
              [
                49.3085559,
                32.1535024
              ],
              [
                49.3067933,
                32.1541398
              ],
              [
                49.3043251,
                32.1549839
              ],
              [
                49.3028794,
                32.1554538
              ],
              [
                49.3012656,
                32.1556058
              ],
              [
                49.2997551,
                32.1555675
              ],
              [
                49.2977677,
                32.155994
              ],
              [
                49.296318,
                32.1563714
              ],
              [
                49.2941666,
                32.1563875
              ],
              [
                49.2939522,
                32.1562459
              ],
              [
                49.293354,
                32.1558615
              ],
              [
                49.2924425,
                32.156398
              ],
              [
                49.2908324,
                32.1569175
              ],
              [
                49.2893625,
                32.1577218
              ],
              [
                49.2885322,
                32.1581762
              ],
              [
                49.2878545,
                32.1584813
              ],
              [
                49.286869,
                32.1589249
              ],
              [
                49.2864439,
                32.15911
              ],
              [
                49.2855835,
                32.1594848
              ],
              [
                49.2851337,
                32.1595015
              ],
              [
                49.2840768,
                32.159541
              ],
              [
                49.2825736,
                32.159692
              ],
              [
                49.2815513,
                32.1598359
              ],
              [
                49.2811306,
                32.1598692
              ],
              [
                49.2803115,
                32.1599341
              ],
              [
                49.2797738,
                32.1597554
              ],
              [
                49.2790718,
                32.1595316
              ],
              [
                49.2785834,
                32.1591642
              ],
              [
                49.2779886,
                32.1588472
              ],
              [
                49.2778948,
                32.1586128
              ],
              [
                49.2777671,
                32.1582939
              ],
              [
                49.2770615,
                32.1577026
              ],
              [
                49.2766267,
                32.1572456
              ],
              [
                49.276085,
                32.1569293
              ],
              [
                49.2757073,
                32.1569287
              ],
              [
                49.2753334,
                32.1571626
              ],
              [
                49.274906,
                32.1575807
              ],
              [
                49.2742119,
                32.1582297
              ],
              [
                49.273942,
                32.1586486
              ],
              [
                49.2737351,
                32.1589696
              ],
              [
                49.273679,
                32.1591099
              ],
              [
                49.2734221,
                32.1597523
              ],
              [
                49.2734298,
                32.1605349
              ],
              [
                49.2734336,
                32.1611776
              ],
              [
                49.2734414,
                32.1619602
              ],
              [
                49.2735596,
                32.1626518
              ],
              [
                49.2736167,
                32.1632952
              ],
              [
                49.2735711,
                32.1640771
              ],
              [
                49.2733154,
                32.1653702
              ],
              [
                49.2734872,
                32.1662407
              ],
              [
                49.2734947,
                32.167163
              ],
              [
                49.2736168,
                32.1683125
              ],
              [
                49.2736818,
                32.1694183
              ],
              [
                49.2735787,
                32.1699265
              ],
              [
                49.2732087,
                32.1707986
              ],
              [
                49.2726783,
                32.1714025
              ],
              [
                49.2717247,
                32.1727447
              ],
              [
                49.27071,
                32.1736711
              ],
              [
                49.2699088,
                32.174508
              ],
              [
                49.269553,
                32.1747963
              ],
              [
                49.2690545,
                32.1752021
              ],
              [
                49.2672883,
                32.1761363
              ],
              [
                49.2647208,
                32.1777652
              ],
              [
                49.2623633,
                32.1788874
              ],
              [
                49.2605935,
                32.1794967
              ],
              [
                49.2579079,
                32.1802512
              ],
              [
                49.2560271,
                32.180541
              ],
              [
                49.254303,
                32.1805082
              ],
              [
                49.2520496,
                32.1805109
              ],
              [
                49.249984,
                32.180462
              ],
              [
                49.2482735,
                32.1803098
              ],
              [
                49.2464218,
                32.1801195
              ],
              [
                49.2456664,
                32.1801226
              ],
              [
                49.2442703,
                32.1802678
              ],
              [
                49.2434615,
                32.1805497
              ],
              [
                49.2426034,
                32.1809685
              ],
              [
                49.2413672,
                32.1816187
              ],
              [
                49.2398606,
                32.1822697
              ],
              [
                49.2385178,
                32.1831057
              ],
              [
                49.2372323,
                32.1841273
              ],
              [
                49.2359467,
                32.1851917
              ],
              [
                49.2345506,
                32.1863966
              ],
              [
                49.233532,
                32.1876497
              ],
              [
                49.2329968,
                32.1883911
              ],
              [
                49.232731,
                32.1887592
              ],
              [
                49.2315522,
                32.1900528
              ],
              [
                49.2302132,
                32.1913487
              ],
              [
                49.2291376,
                32.1920011
              ],
              [
                49.228279,
                32.1924671
              ],
              [
                49.2273141,
                32.192979
              ],
              [
                49.226181,
                32.1931232
              ],
              [
                49.2252122,
                32.193405
              ],
              [
                49.2238158,
                32.1936424
              ],
              [
                49.2227899,
                32.1936911
              ],
              [
                49.2210694,
                32.1940232
              ],
              [
                49.220478,
                32.1941637
              ],
              [
                49.2204311,
                32.194194
              ],
              [
                49.2200469,
                32.1944418
              ],
              [
                49.2195662,
                32.1952287
              ],
              [
                49.2191924,
                32.1959225
              ],
              [
                49.218605,
                32.1969425
              ],
              [
                49.2180212,
                32.1982353
              ],
              [
                49.2179146,
                32.1988787
              ],
              [
                49.2177583,
                32.1999408
              ],
              [
                49.2179223,
                32.2004009
              ],
              [
                49.2176589,
                32.2011413
              ],
              [
                49.2173385,
                32.2020184
              ],
              [
                49.21688,
                32.2032175
              ],
              [
                49.2168617,
                32.2032654
              ],
              [
                49.2164346,
                32.2039156
              ],
              [
                49.216057,
                32.204377
              ],
              [
                49.2154693,
                32.2047949
              ],
              [
                49.2142867,
                32.2051232
              ],
              [
                49.2131005,
                32.2054988
              ],
              [
                49.2113266,
                32.2057849
              ],
              [
                49.2098197,
                32.2059282
              ],
              [
                49.2080422,
                32.2060766
              ],
              [
                49.2057267,
                32.2061339
              ],
              [
                49.2043799,
                32.2061419
              ],
              [
                49.2032508,
                32.2062408
              ],
              [
                49.2020646,
                32.2064788
              ],
              [
                49.2012597,
                32.206898
              ],
              [
                49.199917,
                32.2072712
              ],
              [
                49.1988412,
                32.2075085
              ],
              [
                49.1980859,
                32.2075112
              ],
              [
                49.1974907,
                32.2071465
              ],
              [
                49.1970598,
                32.206642
              ],
              [
                49.1966249,
                32.205815
              ],
              [
                49.1959724,
                32.2048947
              ],
              [
                49.1956442,
                32.2040219
              ],
              [
                49.1949959,
                32.2033768
              ],
              [
                49.194454,
                32.2031029
              ],
              [
                49.1940658,
                32.2029776
              ],
              [
                49.1937524,
                32.2028765
              ],
              [
                49.1933211,
                32.2026944
              ],
              [
                49.1927299,
                32.2026972
              ],
              [
                49.192192,
                32.2029759
              ],
              [
                49.1916541,
                32.2033042
              ],
              [
                49.1909562,
                32.2036279
              ],
              [
                49.1902086,
                32.2044177
              ],
              [
                49.1897241,
                32.2049249
              ],
              [
                49.1895676,
                32.2056645
              ],
              [
                49.1895179,
                32.2064508
              ],
              [
                49.1895714,
                32.2069138
              ],
              [
                49.1899527,
                32.2071425
              ],
              [
                49.1906013,
                32.2075531
              ],
              [
                49.1915702,
                32.207779
              ],
              [
                49.1925391,
                32.2077703
              ],
              [
                49.1936149,
                32.2077676
              ],
              [
                49.1946412,
                32.2078093
              ],
              [
                49.1956671,
                32.2082186
              ],
              [
                49.1958915,
                32.2084474
              ],
              [
                49.1962053,
                32.2087674
              ],
              [
                49.1965333,
                32.2092276
              ],
              [
                49.1966437,
                32.2097816
              ],
              [
                49.1965371,
                32.2100101
              ],
              [
                49.1962167,
                32.2103393
              ],
              [
                49.1957854,
                32.2105721
              ],
              [
                49.1950874,
                32.2107132
              ],
              [
                49.1942252,
                32.2108069
              ],
              [
                49.1931993,
                32.2106276
              ],
              [
                49.1923372,
                32.210586
              ],
              [
                49.1914216,
                32.2105481
              ],
              [
                49.1906663,
                32.2103659
              ],
              [
                49.1897505,
                32.2101859
              ],
              [
                49.188835,
                32.2099609
              ],
              [
                49.1882399,
                32.2096412
              ],
              [
                49.1878622,
                32.2094125
              ],
              [
                49.1873742,
                32.2086298
              ],
              [
                49.1868287,
                32.2076637
              ],
              [
                49.1863403,
                32.2068359
              ],
              [
                49.1862831,
                32.2061924
              ],
              [
                49.1862831,
                32.20564
              ],
              [
                49.1863327,
                32.2051288
              ],
              [
                49.1862756,
                32.2047154
              ],
              [
                49.1863252,
                32.2038389
              ],
              [
                49.1860544,
                32.2032848
              ],
              [
                49.1858368,
                32.202824
              ],
              [
                49.1855127,
                32.2027359
              ],
              [
                49.1848107,
                32.2026942
              ],
              [
                49.1842193,
                32.202927
              ],
              [
                49.1833609,
                32.2033003
              ],
              [
                49.1827162,
                32.2035796
              ],
              [
                49.1818581,
                32.2039078
              ],
              [
                49.1818139,
                32.2039253
              ],
              [
                49.181156,
                32.2041863
              ],
              [
                49.1804045,
                32.2042837
              ],
              [
                49.1797066,
                32.2044721
              ],
              [
                49.1789514,
                32.204707
              ],
              [
                49.1785241,
                32.2049872
              ],
              [
                49.1783105,
                32.2054938
              ],
              [
                49.1779899,
                32.2059108
              ],
              [
                49.1778336,
                32.206833
              ],
              [
                49.1778908,
                32.2076186
              ],
              [
                49.1779038,
                32.2076422
              ],
              [
                49.1782686,
                32.2083095
              ],
              [
                49.1787032,
                32.2090914
              ],
              [
                49.1786536,
                32.209553
              ],
              [
                49.1786004,
                32.2100596
              ],
              [
                49.1784401,
                32.2103842
              ],
              [
                49.178173,
                32.2105247
              ],
              [
                49.1778488,
                32.2105719
              ],
              [
                49.1774748,
                32.2105755
              ],
              [
                49.176716,
                32.2102083
              ],
              [
                49.1754799,
                32.2100303
              ],
              [
                49.1742936,
                32.2098531
              ],
              [
                49.1734559,
                32.2098577
              ],
              [
                49.1719206,
                32.2098662
              ],
              [
                49.1707381,
                32.2100114
              ],
              [
                49.1696626,
                32.2102935
              ],
              [
                49.1689109,
                32.2107133
              ],
              [
                49.1683197,
                32.2113609
              ],
              [
                49.1672479,
                32.2123375
              ],
              [
                49.1658553,
                32.2136792
              ],
              [
                49.1649474,
                32.2147935
              ],
              [
                49.164627,
                32.2154427
              ],
              [
                49.1643066,
                32.2162747
              ],
              [
                49.1642113,
                32.2164269
              ],
              [
                49.1639863,
                32.2167864
              ],
              [
                49.1634521,
                32.2174348
              ],
              [
                49.1626435,
                32.2177612
              ],
              [
                49.1621093,
                32.2180398
              ],
              [
                49.1616212,
                32.218044
              ],
              [
                49.1614609,
                32.2179064
              ],
              [
                49.16119,
                32.2174921
              ],
              [
                49.1602708,
                32.2165271
              ],
              [
                49.1590728,
                32.2146427
              ],
              [
                49.1582642,
                32.2137673
              ],
              [
                49.1577757,
                32.2134941
              ],
              [
                49.1569671,
                32.2133132
              ],
              [
                49.1563759,
                32.2133181
              ],
              [
                49.1557845,
                32.2134132
              ],
              [
                49.1542778,
                32.2136505
              ],
              [
                49.1528243,
                32.2140284
              ],
              [
                49.1520195,
                32.2144969
              ],
              [
                49.1519839,
                32.2145252
              ],
              [
                49.1513213,
                32.2150526
              ],
              [
                49.1507338,
                32.2158851
              ],
              [
                49.1504708,
                32.2170876
              ],
              [
                49.1503142,
                32.2183345
              ],
              [
                49.1501581,
                32.2191192
              ],
              [
                49.1502722,
                32.2205549
              ],
              [
                49.1502762,
                32.2212901
              ],
              [
                49.1501694,
                32.2218477
              ],
              [
                49.149582,
                32.2224502
              ],
              [
                49.1492613,
                32.2229574
              ],
              [
                49.1489173,
                32.2232264
              ],
              [
                49.1487236,
                32.2233779
              ],
              [
                49.148239,
                32.2235647
              ],
              [
                49.1477012,
                32.2235681
              ],
              [
                49.1469459,
                32.2234353
              ],
              [
                49.1465148,
                32.2231606
              ],
              [
                49.1461372,
                32.2226973
              ],
              [
                49.1454849,
                32.2219662
              ],
              [
                49.1448366,
                32.2210435
              ],
              [
                49.1442902,
                32.2202954
              ],
              [
                49.1441307,
                32.2200771
              ],
              [
                49.1433183,
                32.2192489
              ],
              [
                49.1427231,
                32.2189786
              ],
              [
                49.1421852,
                32.2190293
              ],
              [
                49.1414337,
                32.2191693
              ],
              [
                49.1405715,
                32.2196797
              ],
              [
                49.1396598,
                32.2203789
              ],
              [
                49.1386988,
                32.2214921
              ],
              [
                49.1370886,
                32.2227943
              ],
              [
                49.1360167,
                32.2241404
              ],
              [
                49.1351089,
                32.2254867
              ],
              [
                49.1345214,
                32.2262266
              ],
              [
                49.1337204,
                32.2276647
              ],
              [
                49.1332437,
                32.2292834
              ],
              [
                49.1331444,
                32.2307633
              ],
              [
                49.1331482,
                32.2320554
              ],
              [
                49.1334268,
                32.2336244
              ],
              [
                49.1335908,
                32.2343597
              ],
              [
                49.1339721,
                32.2349132
              ],
              [
                49.1347274,
                32.2356031
              ],
              [
                49.1353758,
                32.2358742
              ],
              [
                49.1361313,
                32.2361492
              ],
              [
                49.1368905,
                32.2367444
              ],
              [
                49.1373215,
                32.2372513
              ],
              [
                49.137596,
                32.2380333
              ],
              [
                49.1377602,
                32.2385859
              ],
              [
                49.1376571,
                32.2392811
              ],
              [
                49.13739,
                32.2400213
              ],
              [
                49.137394,
                32.2409436
              ],
              [
                49.1373978,
                32.2415885
              ],
              [
                49.1375085,
                32.2424199
              ],
              [
                49.1376762,
                32.2432522
              ],
              [
                49.1379507,
                32.2439891
              ],
              [
                49.1384392,
                32.2447697
              ],
              [
                49.1392517,
                32.2457354
              ],
              [
                49.1396009,
                32.2462471
              ],
              [
                49.1396294,
                32.2462889
              ],
              [
                49.1395797,
                32.2466129
              ],
              [
                49.1396332,
                32.2472563
              ],
              [
                49.1390991,
                32.2477693
              ],
              [
                49.138654,
                32.2480071
              ],
              [
                49.1384009,
                32.2481424
              ],
              [
                49.1380806,
                32.2484668
              ],
              [
                49.1379132,
                32.2489749
              ],
              [
                49.137867,
                32.2491154
              ],
              [
                49.1378173,
                32.249764
              ],
              [
                49.137916,
                32.2505005
              ],
              [
                49.1379089,
                32.2508454
              ],
              [
                49.1375485,
                32.2510994
              ],
              [
                49.1371117,
                32.2511674
              ],
              [
                49.1362534,
                32.2513081
              ],
              [
                49.1357153,
                32.2513114
              ],
              [
                49.1346435,
                32.2512708
              ],
              [
                49.1342658,
                32.2513193
              ],
              [
                49.1339988,
                32.251365
              ],
              [
                49.133522,
                32.2518765
              ],
              [
                49.1331481,
                32.2520627
              ],
              [
                49.1325607,
                32.2522051
              ],
              [
                49.131916,
                32.2522993
              ],
              [
                49.1309546,
                32.2525331
              ],
              [
                49.1303672,
                32.2528603
              ],
              [
                49.1293489,
                32.2529107
              ],
              [
                49.1288642,
                32.2529147
              ],
              [
                49.1282197,
                32.2528691
              ],
              [
                49.1274148,
                32.2527354
              ],
              [
                49.1265564,
                32.2527858
              ],
              [
                49.1255379,
                32.253021
              ],
              [
                49.1244699,
                32.2534403
              ],
              [
                49.1235542,
                32.2533072
              ],
              [
                49.1228065,
                32.2533119
              ],
              [
                49.1216239,
                32.2532244
              ],
              [
                49.1211395,
                32.2530864
              ],
              [
                49.1207617,
                32.2529072
              ],
              [
                49.1207579,
                32.25272
              ],
              [
                49.1204834,
                32.2521206
              ],
              [
                49.1204797,
                32.2517508
              ],
              [
                49.1203688,
                32.2513387
              ],
              [
                49.1199342,
                32.2508317
              ],
              [
                49.1192361,
                32.2506477
              ],
              [
                49.1185876,
                32.2503787
              ],
              [
                49.1180497,
                32.2503775
              ],
              [
                49.117298,
                32.2503347
              ],
              [
                49.1167068,
                32.250247
              ],
              [
                49.1161688,
                32.2498782
              ],
              [
                49.1155204,
                32.2495573
              ],
              [
                49.1143994,
                32.2490738
              ],
              [
                49.1133613,
                32.2488013
              ],
              [
                49.1121177,
                32.2480251
              ],
              [
                49.111145,
                32.2474288
              ],
              [
                49.1097948,
                32.2467908
              ],
              [
                49.1095732,
                32.2467323
              ],
              [
                49.1087722,
                32.2465207
              ],
              [
                49.1075861,
                32.246433
              ],
              [
                49.1068344,
                32.2464871
              ],
              [
                49.1059722,
                32.2467696
              ],
              [
                49.1053811,
                32.2470922
              ],
              [
                49.1049536,
                32.2476495
              ],
              [
                49.1045266,
                32.2484864
              ],
              [
                49.1038891,
                32.2501341
              ],
              [
                49.102501,
                32.2516511
              ],
              [
                49.1018714,
                32.2528524
              ],
              [
                49.1011886,
                32.2545671
              ],
              [
                49.0997619,
                32.2568321
              ],
              [
                49.0992355,
                32.2578501
              ],
              [
                49.0987626,
                32.2591011
              ],
              [
                49.0985565,
                32.2599346
              ],
              [
                49.0982438,
                32.2609491
              ],
              [
                49.0978242,
                32.2619664
              ],
              [
                49.0977745,
                32.2626602
              ],
              [
                49.0978891,
                32.2633068
              ],
              [
                49.0978965,
                32.2639991
              ],
              [
                49.0976371,
                32.2649242
              ],
              [
                49.0973739,
                32.2656621
              ],
              [
                49.0970574,
                32.2662165
              ],
              [
                49.0970649,
                32.2670013
              ],
              [
                49.0970689,
                32.2676056
              ],
              [
                49.0968628,
                32.2684368
              ],
              [
                49.0965463,
                32.2688514
              ],
              [
                49.0961723,
                32.2693644
              ],
              [
                49.0949441,
                32.2698284
              ],
              [
                49.0939789,
                32.2701566
              ],
              [
                49.0930673,
                32.2704382
              ],
              [
                49.0922624,
                32.2704441
              ],
              [
                49.0922329,
                32.2704499
              ],
              [
                49.0910835,
                32.2706788
              ],
              [
                49.0896378,
                32.2710064
              ],
              [
                49.0888864,
                32.2711033
              ],
              [
                49.0873222,
                32.270694
              ],
              [
                49.086357,
                32.2706072
              ],
              [
                49.085064,
                32.2704275
              ],
              [
                49.0844192,
                32.2702937
              ],
              [
                49.0830231,
                32.2702523
              ],
              [
                49.0816232,
                32.2700777
              ],
              [
                49.0803338,
                32.2697108
              ],
              [
                49.0790404,
                32.2693484
              ],
              [
                49.0782851,
                32.2689356
              ],
              [
                49.07769,
                32.2685252
              ],
              [
                49.077362,
                32.2679249
              ],
              [
                49.0774652,
                32.2671846
              ],
              [
                49.0776177,
                32.2663527
              ],
              [
                49.0777167,
                32.2652922
              ],
              [
                49.0776559,
                32.2643239
              ],
              [
                49.0773239,
                32.2630765
              ],
              [
                49.0769919,
                32.2618335
              ],
              [
                49.076126,
                32.2611462
              ],
              [
                49.0754204,
                32.2603643
              ],
              [
                49.074772,
                32.2598561
              ],
              [
                49.0742342,
                32.2595818
              ],
              [
                49.0729942,
                32.2591751
              ],
              [
                49.0721894,
                32.258899
              ],
              [
                49.0712738,
                32.2587655
              ],
              [
                49.0708428,
                32.2587322
              ],
              [
                49.0701445,
                32.2586783
              ],
              [
                49.0695039,
                32.2586821
              ],
              [
                49.0685921,
                32.259056
              ],
              [
                49.0676803,
                32.2593374
              ],
              [
                49.0670395,
                32.2596635
              ],
              [
                49.0659713,
                32.2603597
              ],
              [
                49.0650139,
                32.2613326
              ],
              [
                49.06492,
                32.261476
              ],
              [
                49.0643769,
                32.262306
              ],
              [
                49.0635263,
                32.2634203
              ],
              [
                49.0633165,
                32.2639267
              ],
              [
                49.0628359,
                32.2643004
              ],
              [
                49.062191,
                32.2645791
              ],
              [
                49.0613366,
                32.2650914
              ],
              [
                49.0605889,
                32.265373
              ],
              [
                49.0596236,
                32.2658384
              ],
              [
                49.058631,
                32.2661966
              ],
              [
                49.0580712,
                32.2663986
              ],
              [
                49.0559843,
                32.2676089
              ],
              [
                49.0550233,
                32.2682141
              ],
              [
                49.0541154,
                32.2686353
              ],
              [
                49.0534746,
                32.2693289
              ],
              [
                49.0532646,
                32.2699322
              ],
              [
                49.053215,
                32.2703937
              ],
              [
                49.0532188,
                32.2710386
              ],
              [
                49.0535471,
                32.2716818
              ],
              [
                49.0540315,
                32.2722349
              ],
              [
                49.0545731,
                32.2726018
              ],
              [
                49.0553817,
                32.2730133
              ],
              [
                49.0558699,
                32.2737514
              ],
              [
                49.0562517,
                32.2744856
              ],
              [
                49.0564194,
                32.2754104
              ],
              [
                49.0563697,
                32.276059
              ],
              [
                49.0563773,
                32.2772113
              ],
              [
                49.0562324,
                32.2789656
              ],
              [
                49.0559692,
                32.2800303
              ],
              [
                49.0558128,
                32.2808599
              ],
              [
                49.0558777,
                32.2819702
              ],
              [
                49.0561522,
                32.2827073
              ],
              [
                49.0563697,
                32.2832134
              ],
              [
                49.0565872,
                32.2836272
              ],
              [
                49.0576642,
                32.2843164
              ],
              [
                49.0576667,
                32.284318
              ],
              [
                49.0583686,
                32.2848203
              ],
              [
                49.05875,
                32.2853741
              ],
              [
                49.0589713,
                32.2862929
              ],
              [
                49.0589753,
                32.2868048
              ],
              [
                49.0587655,
                32.2875908
              ],
              [
                49.0579681,
                32.288884
              ],
              [
                49.0571137,
                32.2893534
              ],
              [
                49.0561485,
                32.2897715
              ],
              [
                49.0553969,
                32.2899132
              ],
              [
                49.0545882,
                32.2898714
              ],
              [
                49.0539971,
                32.2896887
              ],
              [
                49.0526008,
                32.2898791
              ],
              [
                49.051155,
                32.2905806
              ],
              [
                49.0498659,
                32.2909553
              ],
              [
                49.047989,
                32.2913772
              ],
              [
                49.0457879,
                32.2921301
              ],
              [
                49.0438576,
                32.2928781
              ],
              [
                49.0418167,
                32.293117
              ],
              [
                49.0406874,
                32.293122
              ],
              [
                49.0391274,
                32.2930369
              ],
              [
                49.0379981,
                32.2930419
              ],
              [
                49.0366019,
                32.2934193
              ],
              [
                49.0352632,
                32.2939802
              ],
              [
                49.0347253,
                32.2943506
              ],
              [
                49.0334967,
                32.2954183
              ],
              [
                49.0324251,
                32.2959788
              ],
              [
                49.0313531,
                32.2966769
              ],
              [
                49.0307123,
                32.2975079
              ],
              [
                49.0299606,
                32.2980644
              ],
              [
                49.029213,
                32.2986727
              ],
              [
                49.0285721,
                32.2996436
              ],
              [
                49.028202,
                32.3002939
              ],
              [
                49.0273438,
                32.3010787
              ],
              [
                49.0265428,
                32.3018238
              ],
              [
                49.026333,
                32.3026998
              ],
              [
                49.0260162,
                32.303811
              ],
              [
                49.0252112,
                32.3045087
              ],
              [
                49.0241968,
                32.3056224
              ],
              [
                49.0237693,
                32.3061749
              ],
              [
                49.0230712,
                32.3066871
              ],
              [
                49.0222168,
                32.3072464
              ],
              [
                49.0211944,
                32.3076204
              ],
              [
                49.0202826,
                32.3079489
              ],
              [
                49.0195311,
                32.3082279
              ],
              [
                49.0191573,
                32.3086482
              ],
              [
                49.0188369,
                32.309155
              ],
              [
                49.0183562,
                32.3098938
              ],
              [
                49.0173872,
                32.3102686
              ],
              [
                49.0164222,
                32.3108284
              ],
              [
                49.0159415,
                32.3110621
              ],
              [
                49.0149726,
                32.3114821
              ],
              [
                49.014328,
                32.3116681
              ],
              [
                49.0131456,
                32.3116765
              ],
              [
                49.0123406,
                32.3121419
              ],
              [
                49.0104066,
                32.3127066
              ],
              [
                49.0091135,
                32.3128463
              ],
              [
                49.0078238,
                32.3130424
              ],
              [
                49.0069619,
                32.3127673
              ],
              [
                49.0060424,
                32.312171
              ],
              [
                49.0049628,
                32.3118067
              ],
              [
                49.0035629,
                32.3113066
              ],
              [
                49.0021096,
                32.3111257
              ],
              [
                49.0011407,
                32.310948
              ],
              [
                48.9999009,
                32.3111381
              ],
              [
                48.9988936,
                32.3109598
              ],
              [
                48.998562,
                32.3104968
              ],
              [
                48.9981765,
                32.3100826
              ],
              [
                48.9978983,
                32.309528
              ],
              [
                48.9975625,
                32.3086478
              ],
              [
                48.997547,
                32.3077705
              ],
              [
                48.9976999,
                32.3073535
              ],
              [
                48.9976922,
                32.3067514
              ],
              [
                48.9976731,
                32.3057319
              ],
              [
                48.9974364,
                32.304576
              ],
              [
                48.9971762,
                32.3039656
              ],
              [
                48.9970435,
                32.3036543
              ],
              [
                48.9966585,
                32.3031928
              ],
              [
                48.9959526,
                32.3027261
              ],
              [
                48.995304,
                32.3027316
              ],
              [
                48.9942321,
                32.302913
              ],
              [
                48.9931482,
                32.3034973
              ],
              [
                48.9931108,
                32.3035174
              ],
              [
                48.9917222,
                32.3042575
              ],
              [
                48.9908678,
                32.3047647
              ],
              [
                48.9899026,
                32.3050424
              ],
              [
                48.9889337,
                32.3051826
              ],
              [
                48.9878044,
                32.3051826
              ],
              [
                48.9869386,
                32.3050921
              ],
              [
                48.985321,
                32.304904
              ],
              [
                48.9836388,
                32.3042593
              ],
              [
                48.9820633,
                32.3034292
              ],
              [
                48.9811362,
                32.3028259
              ],
              [
                48.9805586,
                32.3024699
              ],
              [
                48.9801597,
                32.302224
              ],
              [
                48.9790152,
                32.3015338
              ],
              [
                48.9788743,
                32.2995406
              ],
              [
                48.9787331,
                32.2972295
              ],
              [
                48.978428,
                32.2950555
              ],
              [
                48.9783479,
                32.293388
              ],
              [
                48.9783745,
                32.2916793
              ],
              [
                48.9781913,
                32.2903822
              ],
              [
                48.9782219,
                32.2888562
              ],
              [
                48.978283,
                32.287778
              ],
              [
                48.9783058,
                32.2873762
              ],
              [
                48.9782791,
                32.2857095
              ],
              [
                48.9782143,
                32.2849689
              ],
              [
                48.978199,
                32.2839518
              ],
              [
                48.9780615,
                32.2821931
              ],
              [
                48.9777718,
                32.2809438
              ],
              [
                48.9777537,
                32.2808916
              ],
              [
                48.977436,
                32.2799712
              ],
              [
                48.9767646,
                32.2784452
              ],
              [
                48.9762077,
                32.2772909
              ],
              [
                48.9758264,
                32.2768744
              ],
              [
                48.9757653,
                32.2765037
              ],
              [
                48.9756928,
                32.275303
              ],
              [
                48.9755668,
                32.2741939
              ],
              [
                48.9755374,
                32.2740087
              ],
              [
                48.9753305,
                32.2727087
              ],
              [
                48.9749336,
                32.2713698
              ],
              [
                48.9742547,
                32.2692417
              ],
              [
                48.9736863,
                32.2672506
              ],
              [
                48.9728468,
                32.2651718
              ],
              [
                48.9720534,
                32.2625774
              ],
              [
                48.9714929,
                32.2611434
              ],
              [
                48.9709814,
                32.2592931
              ],
              [
                48.9701843,
                32.2562859
              ],
              [
                48.9693832,
                32.253281
              ],
              [
                48.9683608,
                32.2496727
              ],
              [
                48.9679449,
                32.2485996
              ],
              [
                48.9665795,
                32.2470827
              ],
              [
                48.9653245,
                32.245793
              ],
              [
                48.9643897,
                32.2441816
              ],
              [
                48.9635085,
                32.2424764
              ],
              [
                48.9631082,
                32.2402648
              ],
              [
                48.9628679,
                32.2379565
              ],
              [
                48.9623985,
                32.2341768
              ],
              [
                48.9623834,
                32.2326546
              ],
              [
                48.9622038,
                32.2307622
              ],
              [
                48.9616965,
                32.2285962
              ],
              [
                48.9605827,
                32.2254644
              ],
              [
                48.9605578,
                32.22535
              ],
              [
                48.959961,
                32.2226021
              ],
              [
                48.9591826,
                32.2202536
              ],
              [
                48.9592057,
                32.2169801
              ],
              [
                48.9590149,
                32.2141653
              ],
              [
                48.9586038,
                32.2113863
              ],
              [
                48.9584352,
                32.2102462
              ],
              [
                48.9579734,
                32.2072039
              ],
              [
                48.9577293,
                32.2041132
              ],
              [
                48.9573783,
                32.2014379
              ],
              [
                48.9568633,
                32.1983495
              ],
              [
                48.9563524,
                32.1956739
              ],
              [
                48.9556848,
                32.1936
              ],
              [
                48.9573021,
                32.1935044
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555252,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هفتکل",
          "name:en": "Haftkel County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610721",
          "wikipedia": "en:Haftkel County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.1485444,
                31.5560196
              ],
              [
                49.1485368,
                31.555334
              ],
              [
                49.1486916,
                31.5540522
              ],
              [
                49.1489906,
                31.5515768
              ],
              [
                49.1494942,
                31.5479083
              ],
              [
                49.1503107,
                31.5429139
              ],
              [
                49.1513976,
                31.5386495
              ],
              [
                49.1525955,
                31.5344295
              ],
              [
                49.1540071,
                31.5309861
              ],
              [
                49.1551667,
                31.5286462
              ],
              [
                49.157379,
                31.5251557
              ],
              [
                49.1598586,
                31.5214818
              ],
              [
                49.1610716,
                31.5192779
              ],
              [
                49.164337,
                31.5137209
              ],
              [
                49.1655071,
                31.5120472
              ],
              [
                49.1658136,
                31.5116088
              ],
              [
                49.1672897,
                31.5093117
              ],
              [
                49.1702995,
                31.5048108
              ],
              [
                49.1725618,
                31.5006328
              ],
              [
                49.172755,
                31.5000853
              ],
              [
                49.1732159,
                31.4985421
              ],
              [
                49.1742478,
                31.4950868
              ],
              [
                49.1763992,
                31.4901246
              ],
              [
                49.1764528,
                31.4855899
              ],
              [
                49.1859208,
                31.4704535
              ],
              [
                49.2009164,
                31.453998
              ],
              [
                49.2068331,
                31.4464985
              ],
              [
                49.216718,
                31.439082
              ],
              [
                49.2451629,
                31.4179572
              ],
              [
                49.2598686,
                31.4074308
              ],
              [
                49.2672213,
                31.4019911
              ],
              [
                49.2774848,
                31.3946808
              ],
              [
                49.3064088,
                31.372109
              ],
              [
                49.3173215,
                31.368047
              ],
              [
                49.324976,
                31.3650768
              ],
              [
                49.3305378,
                31.3625996
              ],
              [
                49.3349704,
                31.3643636
              ],
              [
                49.3465139,
                31.3729296
              ],
              [
                49.3483583,
                31.3754632
              ],
              [
                49.3499564,
                31.3764288
              ],
              [
                49.3547515,
                31.3782269
              ],
              [
                49.3564568,
                31.3789659
              ],
              [
                49.359066,
                31.3805758
              ],
              [
                49.3708917,
                31.3894454
              ],
              [
                49.3755799,
                31.3931245
              ],
              [
                49.3811188,
                31.3974909
              ],
              [
                49.3877296,
                31.4021839
              ],
              [
                49.3907129,
                31.4032431
              ],
              [
                49.3931657,
                31.4038467
              ],
              [
                49.3962592,
                31.4045439
              ],
              [
                49.399353,
                31.405514
              ],
              [
                49.4023896,
                31.4067585
              ],
              [
                49.4054831,
                31.4087839
              ],
              [
                49.4074554,
                31.4108043
              ],
              [
                49.4087334,
                31.4124575
              ],
              [
                49.4101181,
                31.414527
              ],
              [
                49.4118231,
                31.4174168
              ],
              [
                49.4126244,
                31.418931
              ],
              [
                49.4131586,
                31.4195736
              ],
              [
                49.4148102,
                31.4209563
              ],
              [
                49.4300614,
                31.432276
              ],
              [
                49.4332619,
                31.4339819
              ],
              [
                49.4367827,
                31.4355968
              ],
              [
                49.4385451,
                31.4359679
              ],
              [
                49.4410514,
                31.4367088
              ],
              [
                49.4452134,
                31.437454
              ],
              [
                49.4479903,
                31.4377831
              ],
              [
                49.4499627,
                31.437789
              ],
              [
                49.4517249,
                31.4375193
              ],
              [
                49.4533766,
                31.4367454
              ],
              [
                49.4549255,
                31.4354651
              ],
              [
                49.4573249,
                31.4335454
              ],
              [
                49.459675,
                31.432728
              ],
              [
                49.4630889,
                31.4320496
              ],
              [
                49.4652748,
                31.4317803
              ],
              [
                49.4678918,
                31.4315591
              ],
              [
                49.4707185,
                31.4312455
              ],
              [
                49.4738123,
                31.430475
              ],
              [
                49.4792556,
                31.4293896
              ],
              [
                49.4834138,
                31.4285773
              ],
              [
                49.4882165,
                31.4274456
              ],
              [
                49.4923248,
                31.4267227
              ],
              [
                49.4973372,
                31.4255434
              ],
              [
                49.5001873,
                31.4246927
              ],
              [
                49.5016595,
                31.4245047
              ],
              [
                49.5035361,
                31.4238162
              ],
              [
                49.5045587,
                31.4228944
              ],
              [
                49.5052565,
                31.4221132
              ],
              [
                49.5057984,
                31.4207776
              ],
              [
                49.5058557,
                31.4188884
              ],
              [
                49.5058634,
                31.4160027
              ],
              [
                49.505867,
                31.4146485
              ],
              [
                49.5060959,
                31.4096241
              ],
              [
                49.5066413,
                31.4063986
              ],
              [
                49.5066453,
                31.4037238
              ],
              [
                49.5067595,
                31.4019277
              ],
              [
                49.5078851,
                31.4015619
              ],
              [
                49.509281,
                31.4012872
              ],
              [
                49.5100398,
                31.4011249
              ],
              [
                49.5112113,
                31.4008744
              ],
              [
                49.5138398,
                31.4005102
              ],
              [
                49.5161439,
                31.4001896
              ],
              [
                49.5193061,
                31.3999194
              ],
              [
                49.5218277,
                31.3995561
              ],
              [
                49.524563,
                31.3992358
              ],
              [
                49.5277787,
                31.3986864
              ],
              [
                49.5309943,
                31.3979542
              ],
              [
                49.5340537,
                31.3969924
              ],
              [
                49.5351256,
                31.3963483
              ],
              [
                49.5367354,
                31.3952436
              ],
              [
                49.5386657,
                31.3938176
              ],
              [
                49.5394951,
                31.3931678
              ],
              [
                49.5411911,
                31.3918392
              ],
              [
                49.5433349,
                31.3906434
              ],
              [
                49.5453187,
                31.3895879
              ],
              [
                49.5476226,
                31.388854
              ],
              [
                49.5492859,
                31.3884871
              ],
              [
                49.5512161,
                31.388306
              ],
              [
                49.5529288,
                31.3880795
              ],
              [
                49.5550193,
                31.387988
              ],
              [
                49.5581818,
                31.3874869
              ],
              [
                49.5605393,
                31.3872134
              ],
              [
                49.5633278,
                31.3867102
              ],
              [
                49.5667573,
                31.3863471
              ],
              [
                49.5696486,
                31.3858449
              ],
              [
                49.5720595,
                31.3852944
              ],
              [
                49.576027,
                31.3847476
              ],
              [
                49.5762396,
                31.3847087
              ],
              [
                49.5768622,
                31.3845948
              ],
              [
                49.5790254,
                31.384199
              ],
              [
                49.5816003,
                31.3839275
              ],
              [
                49.5842247,
                31.3837919
              ],
              [
                49.5866357,
                31.3838884
              ],
              [
                49.5886192,
                31.3837975
              ],
              [
                49.5915642,
                31.3843103
              ],
              [
                49.5949935,
                31.3850516
              ],
              [
                49.5985297,
                31.3857488
              ],
              [
                49.6007805,
                31.3861207
              ],
              [
                49.602871,
                31.3864029
              ],
              [
                49.6044769,
                31.3865895
              ],
              [
                49.6061402,
                31.3869144
              ],
              [
                49.6085511,
                31.387333
              ],
              [
                49.6114425,
                31.3879349
              ],
              [
                49.6147117,
                31.3885409
              ],
              [
                49.6180345,
                31.3893752
              ],
              [
                49.6189303,
                31.3895962
              ],
              [
                49.6193501,
                31.3896998
              ],
              [
                49.6200646,
                31.3898761
              ],
              [
                49.6206627,
                31.3900237
              ],
              [
                49.6219481,
                31.3904886
              ],
              [
                49.6233941,
                31.3908108
              ],
              [
                49.6242524,
                31.3907231
              ],
              [
                49.6250573,
                31.3905851
              ],
              [
                49.6253243,
                31.3901707
              ],
              [
                49.6253243,
                31.3900833
              ],
              [
                49.6253242,
                31.3896182
              ],
              [
                49.6251601,
                31.3889714
              ],
              [
                49.625107,
                31.3885107
              ],
              [
                49.6251069,
                31.3877258
              ],
              [
                49.6251601,
                31.3866664
              ],
              [
                49.6254271,
                31.3852371
              ],
              [
                49.6254274,
                31.3844522
              ],
              [
                49.6253165,
                31.3827482
              ],
              [
                49.6253168,
                31.3817784
              ],
              [
                49.6254729,
                31.3795653
              ],
              [
                49.6257935,
                31.3767518
              ],
              [
                49.6259537,
                31.374956
              ],
              [
                49.626217,
                31.3725591
              ],
              [
                49.6263237,
                31.3716829
              ],
              [
                49.6265908,
                31.3708061
              ],
              [
                49.6270713,
                31.3701617
              ],
              [
                49.6285707,
                31.3683193
              ],
              [
                49.6297454,
                31.3667554
              ],
              [
                49.6307068,
                31.3652794
              ],
              [
                49.6319351,
                31.3631138
              ],
              [
                49.6345024,
                31.3580913
              ],
              [
                49.6351308,
                31.3569245
              ],
              [
                49.6365294,
                31.3583573
              ],
              [
                49.6385112,
                31.3598957
              ],
              [
                49.6411755,
                31.363161
              ],
              [
                49.6431502,
                31.3652051
              ],
              [
                49.6441762,
                31.3676437
              ],
              [
                49.6480401,
                31.3695053
              ],
              [
                49.6492015,
                31.3707314
              ],
              [
                49.6497909,
                31.3707376
              ],
              [
                49.6507137,
                31.3721635
              ],
              [
                49.6527047,
                31.3730949
              ],
              [
                49.6545865,
                31.3734181
              ],
              [
                49.6556445,
                31.3736315
              ],
              [
                49.6566983,
                31.3741483
              ],
              [
                49.6571626,
                31.374659
              ],
              [
                49.6572497,
                31.3747975
              ],
              [
                49.6577391,
                31.3755754
              ],
              [
                49.6581991,
                31.3763895
              ],
              [
                49.6584234,
                31.3772011
              ],
              [
                49.6592285,
                31.3786257
              ],
              [
                49.6599215,
                31.3796446
              ],
              [
                49.6610961,
                31.3799603
              ],
              [
                49.6618071,
                31.3805229
              ],
              [
                49.6622621,
                31.3808829
              ],
              [
                49.6629537,
                31.3820028
              ],
              [
                49.6643599,
                31.3826244
              ],
              [
                49.6650572,
                31.3833398
              ],
              [
                49.6658768,
                31.3837529
              ],
              [
                49.6677645,
                31.3836714
              ],
              [
                49.6682447,
                31.3830695
              ],
              [
                49.6694137,
                31.3837897
              ],
              [
                49.6691579,
                31.3852032
              ],
              [
                49.6691422,
                31.3863158
              ],
              [
                49.6701862,
                31.3875405
              ],
              [
                49.6708808,
                31.3884582
              ],
              [
                49.6718112,
                31.3893782
              ],
              [
                49.6724916,
                31.3913072
              ],
              [
                49.6728339,
                31.39212
              ],
              [
                49.6742488,
                31.3921347
              ],
              [
                49.6756538,
                31.3928573
              ],
              [
                49.6764678,
                31.393675
              ],
              [
                49.6765729,
                31.3945865
              ],
              [
                49.677036,
                31.3951982
              ],
              [
                49.6789056,
                31.3964314
              ],
              [
                49.6797183,
                31.3973502
              ],
              [
                49.680413,
                31.3982677
              ],
              [
                49.6819304,
                31.3993961
              ],
              [
                49.6835755,
                31.3998176
              ],
              [
                49.6855759,
                31.4001416
              ],
              [
                49.6884045,
                31.4002717
              ],
              [
                49.6908539,
                31.4008194
              ],
              [
                49.6927444,
                31.400569
              ],
              [
                49.694807,
                31.3992412
              ],
              [
                49.6963904,
                31.3984481
              ],
              [
                49.6984603,
                31.3965808
              ],
              [
                49.7000529,
                31.3951133
              ],
              [
                49.7011627,
                31.3944502
              ],
              [
                49.7044883,
                31.3927304
              ],
              [
                49.7065543,
                31.3911328
              ],
              [
                49.7095604,
                31.3894224
              ],
              [
                49.7091904,
                31.3912658
              ],
              [
                49.709194,
                31.3924657
              ],
              [
                49.7094687,
                31.3940789
              ],
              [
                49.7095793,
                31.3955099
              ],
              [
                49.7099608,
                31.3965715
              ],
              [
                49.7099647,
                31.3975865
              ],
              [
                49.7101288,
                31.3987858
              ],
              [
                49.7102928,
                31.4000301
              ],
              [
                49.7106742,
                31.4012293
              ],
              [
                49.7112122,
                31.4024775
              ],
              [
                49.7116469,
                31.4032622
              ],
              [
                49.7118643,
                31.4040921
              ],
              [
                49.7118646,
                31.4051071
              ],
              [
                49.7118149,
                31.406029
              ],
              [
                49.7111778,
                31.4075022
              ],
              [
                49.7107008,
                31.4087491
              ],
              [
                49.7099572,
                31.4109158
              ],
              [
                49.7093695,
                31.4121143
              ],
              [
                49.7086221,
                31.4128037
              ],
              [
                49.7078745,
                31.4138156
              ],
              [
                49.706379,
                31.4149214
              ],
              [
                49.7058984,
                31.4161661
              ],
              [
                49.7052614,
                31.4181489
              ],
              [
                49.7049981,
                31.4194386
              ],
              [
                49.7047349,
                31.4210982
              ],
              [
                49.7045939,
                31.4222329
              ],
              [
                49.7045287,
                31.4227583
              ],
              [
                49.7044792,
                31.4243253
              ],
              [
                49.7045327,
                31.4249731
              ],
              [
                49.7048033,
                31.425666
              ],
              [
                49.7051316,
                31.4266346
              ],
              [
                49.7054023,
                31.4274177
              ],
              [
                49.7055129,
                31.4283864
              ],
              [
                49.7054597,
                31.4291708
              ],
              [
                49.7050896,
                31.4300466
              ],
              [
                49.7043952,
                31.431244
              ],
              [
                49.7035409,
                31.4323969
              ],
              [
                49.7025793,
                31.4340088
              ],
              [
                49.7014045,
                31.4358981
              ],
              [
                49.7000696,
                31.4381084
              ],
              [
                49.6989478,
                31.4398134
              ],
              [
                49.6981507,
                31.4413344
              ],
              [
                49.6977235,
                31.4425796
              ],
              [
                49.6971931,
                31.4441462
              ],
              [
                49.6966058,
                31.4457596
              ],
              [
                49.6959686,
                31.4474649
              ],
              [
                49.693676,
                31.4529943
              ],
              [
                49.6924516,
                31.4562656
              ],
              [
                49.6920816,
                31.4579714
              ],
              [
                49.6914445,
                31.4605992
              ],
              [
                49.6907007,
                31.463828
              ],
              [
                49.6899568,
                31.4669599
              ],
              [
                49.6895867,
                31.4687131
              ],
              [
                49.6891593,
                31.4692184
              ],
              [
                49.6881446,
                31.4715716
              ],
              [
                49.6868669,
                31.47521
              ],
              [
                49.685856,
                31.4783458
              ],
              [
                49.6848984,
                31.48171
              ],
              [
                49.6842041,
                31.4846123
              ],
              [
                49.6838874,
                31.4864585
              ],
              [
                49.6835707,
                31.4881174
              ],
              [
                49.6833039,
                31.4893168
              ],
              [
                49.6833075,
                31.4906091
              ],
              [
                49.6835823,
                31.4920847
              ],
              [
                49.683655,
                31.4926344
              ],
              [
                49.6838569,
                31.4941602
              ],
              [
                49.6839714,
                31.4966964
              ],
              [
                49.6838684,
                31.4991853
              ],
              [
                49.6841573,
                31.5000746
              ],
              [
                49.6842677,
                31.5018056
              ],
              [
                49.6838381,
                31.5036461
              ],
              [
                49.6829568,
                31.5052766
              ],
              [
                49.6812552,
                31.5069461
              ],
              [
                49.6800882,
                31.5079219
              ],
              [
                49.6782342,
                31.5102416
              ],
              [
                49.6761665,
                31.5126064
              ],
              [
                49.6750031,
                31.5142746
              ],
              [
                49.6727257,
                31.5175189
              ],
              [
                49.6693991,
                31.5229852
              ],
              [
                49.6665918,
                31.5267855
              ],
              [
                49.6643638,
                31.5297055
              ],
              [
                49.662876,
                31.5313769
              ],
              [
                49.6610679,
                31.5330924
              ],
              [
                49.6593095,
                31.5343933
              ],
              [
                49.6549415,
                31.5378274
              ],
              [
                49.6495018,
                31.5417778
              ],
              [
                49.645977,
                31.544147
              ],
              [
                49.6430932,
                31.5456839
              ],
              [
                49.6405829,
                31.5473577
              ],
              [
                49.6387216,
                31.5494444
              ],
              [
                49.6366462,
                31.5518084
              ],
              [
                49.6348342,
                31.5536159
              ],
              [
                49.6326485,
                31.555381
              ],
              [
                49.6297074,
                31.5572394
              ],
              [
                49.6248968,
                31.560167
              ],
              [
                49.6191254,
                31.5640246
              ],
              [
                49.614525,
                31.5669044
              ],
              [
                49.6105192,
                31.5698763
              ],
              [
                49.6078948,
                31.5715031
              ],
              [
                49.6055413,
                31.5727111
              ],
              [
                49.6018981,
                31.5743425
              ],
              [
                49.5974503,
                31.5764836
              ],
              [
                49.5944691,
                31.5777096
              ],
              [
                49.5934868,
                31.5781135
              ],
              [
                49.5877992,
                31.5800286
              ],
              [
                49.5840492,
                31.5815658
              ],
              [
                49.5792733,
                31.5833825
              ],
              [
                49.5751953,
                31.5846
              ],
              [
                49.5714379,
                31.5855819
              ],
              [
                49.5667724,
                31.5871693
              ],
              [
                49.5624236,
                31.5888006
              ],
              [
                49.5589062,
                31.5902655
              ],
              [
                49.5586168,
                31.590386
              ],
              [
                49.5565758,
                31.5911771
              ],
              [
                49.5549127,
                31.5919206
              ],
              [
                49.5540008,
                31.5924313
              ],
              [
                49.5478896,
                31.5967484
              ],
              [
                49.5408629,
                31.6019908
              ],
              [
                49.5381281,
                31.6043523
              ],
              [
                49.5370116,
                31.6052555
              ],
              [
                49.5348016,
                31.6070431
              ],
              [
                49.5308874,
                31.6112109
              ],
              [
                49.5256273,
                31.6168584
              ],
              [
                49.5201567,
                31.6234796
              ],
              [
                49.5139276,
                31.6308834
              ],
              [
                49.510273,
                31.6351438
              ],
              [
                49.506031,
                31.6402339
              ],
              [
                49.504631,
                31.6420848
              ],
              [
                49.5031282,
                31.644027
              ],
              [
                49.5015144,
                31.6470323
              ],
              [
                49.5000231,
                31.6541616
              ],
              [
                49.4969573,
                31.6604643
              ],
              [
                49.4967104,
                31.6609718
              ],
              [
                49.4940415,
                31.6661995
              ],
              [
                49.4918388,
                31.669439
              ],
              [
                49.4915467,
                31.6698686
              ],
              [
                49.4871863,
                31.6761045
              ],
              [
                49.4850616,
                31.679771
              ],
              [
                49.4810754,
                31.6856413
              ],
              [
                49.4786835,
                31.6891241
              ],
              [
                49.4759217,
                31.6933422
              ],
              [
                49.4755122,
                31.6938718
              ],
              [
                49.4732094,
                31.6972383
              ],
              [
                49.4699059,
                31.7009063
              ],
              [
                49.467232,
                31.7040334
              ],
              [
                49.4670828,
                31.7042078
              ],
              [
                49.4635125,
                31.7073266
              ],
              [
                49.4603652,
                31.7100332
              ],
              [
                49.4573784,
                31.711914
              ],
              [
                49.4532088,
                31.7140262
              ],
              [
                49.4504854,
                31.7154026
              ],
              [
                49.4485093,
                31.7159987
              ],
              [
                49.4465826,
                31.7163226
              ],
              [
                49.4419288,
                31.7165995
              ],
              [
                49.4379121,
                31.7166947
              ],
              [
                49.4339524,
                31.7164229
              ],
              [
                49.4296685,
                31.7161988
              ],
              [
                49.4265642,
                31.7159327
              ],
              [
                49.4249038,
                31.7157904
              ],
              [
                49.4208337,
                31.7154266
              ],
              [
                49.4177817,
                31.7151091
              ],
              [
                49.4149973,
                31.7149279
              ],
              [
                49.4133376,
                31.7145171
              ],
              [
                49.4125329,
                31.7145184
              ],
              [
                49.4119988,
                31.714841
              ],
              [
                49.410984,
                31.7153899
              ],
              [
                49.409649,
                31.7162618
              ],
              [
                49.4081,
                31.7169032
              ],
              [
                49.4070319,
                31.7172259
              ],
              [
                49.4053194,
                31.717457
              ],
              [
                49.402321,
                31.7176879
              ],
              [
                49.3979338,
                31.717829
              ],
              [
                49.3948289,
                31.7179681
              ],
              [
                49.3927956,
                31.7182446
              ],
              [
                49.3909799,
                31.7187968
              ],
              [
                49.3875542,
                31.7196691
              ],
              [
                49.3832787,
                31.7204131
              ],
              [
                49.3830604,
                31.7204511
              ],
              [
                49.379959,
                31.7211424
              ],
              [
                49.3769645,
                31.7215553
              ],
              [
                49.3733787,
                31.7219719
              ],
              [
                49.3697928,
                31.7223884
              ],
              [
                49.3661576,
                31.723077
              ],
              [
                49.3613928,
                31.7239517
              ],
              [
                49.3579179,
                31.7245948
              ],
              [
                49.3558311,
                31.7249626
              ],
              [
                49.3549727,
                31.7249176
              ],
              [
                49.3542784,
                31.7248275
              ],
              [
                49.3533135,
                31.7245061
              ],
              [
                49.3515967,
                31.7239584
              ],
              [
                49.3496703,
                31.7234577
              ],
              [
                49.3465119,
                31.7230469
              ],
              [
                49.3435669,
                31.722729
              ],
              [
                49.3407822,
                31.722686
              ],
              [
                49.3381041,
                31.7227346
              ],
              [
                49.3360175,
                31.7230118
              ],
              [
                49.334362,
                31.7234683
              ],
              [
                49.3328095,
                31.7236081
              ],
              [
                49.3315241,
                31.7234717
              ],
              [
                49.3260612,
                31.723019
              ],
              [
                49.3204385,
                31.7226563
              ],
              [
                49.3141212,
                31.7217927
              ],
              [
                49.3081779,
                31.7206969
              ],
              [
                49.3018037,
                31.7192387
              ],
              [
                49.2975198,
                31.7183269
              ],
              [
                49.2949487,
                31.7175957
              ],
              [
                49.2882539,
                31.7163649
              ],
              [
                49.2820932,
                31.7150417
              ],
              [
                49.2762566,
                31.7136752
              ],
              [
                49.2723998,
                31.7127165
              ],
              [
                49.2681693,
                31.7113917
              ],
              [
                49.2640458,
                31.7100683
              ],
              [
                49.2620086,
                31.7092918
              ],
              [
                49.2608299,
                31.7090186
              ],
              [
                49.2577247,
                31.707648
              ],
              [
                49.2533835,
                31.7058657
              ],
              [
                49.2501335,
                31.7042787
              ],
              [
                49.2498365,
                31.704243
              ],
              [
                49.2460671,
                31.7037898
              ],
              [
                49.2459491,
                31.7037684
              ],
              [
                49.2416192,
                31.7029844
              ],
              [
                49.2374993,
                31.7025869
              ],
              [
                49.2323607,
                31.7022407
              ],
              [
                49.2272796,
                31.7021679
              ],
              [
                49.2224123,
                31.7021407
              ],
              [
                49.219631,
                31.7021989
              ],
              [
                49.2157324,
                31.7029449
              ],
              [
                49.2123185,
                31.7040133
              ],
              [
                49.206932,
                31.7060484
              ],
              [
                49.2029876,
                31.7078059
              ],
              [
                49.2021904,
                31.7081758
              ],
              [
                49.2006949,
                31.7085944
              ],
              [
                49.1983412,
                31.7086491
              ],
              [
                49.1981317,
                31.7088785
              ],
              [
                49.197811,
                31.7087882
              ],
              [
                49.1949195,
                31.7087067
              ],
              [
                49.1901053,
                31.7087264
              ],
              [
                49.184166,
                31.7085202
              ],
              [
                49.1836318,
                31.7083863
              ],
              [
                49.1810988,
                31.7061041
              ],
              [
                49.1770019,
                31.7021354
              ],
              [
                49.1744117,
                31.6992592
              ],
              [
                49.1714402,
                31.6956176
              ],
              [
                49.1702002,
                31.6940979
              ],
              [
                49.1677628,
                31.6902609
              ],
              [
                49.1660805,
                31.6871969
              ],
              [
                49.1648253,
                31.6840399
              ],
              [
                49.1643334,
                31.6826234
              ],
              [
                49.1643296,
                31.6822106
              ],
              [
                49.1643258,
                31.6817528
              ],
              [
                49.1646384,
                31.6807448
              ],
              [
                49.1652147,
                31.6792287
              ],
              [
                49.1662751,
                31.6779879
              ],
              [
                49.1666822,
                31.6776181
              ],
              [
                49.169567,
                31.6749976
              ],
              [
                49.1731835,
                31.6723727
              ],
              [
                49.1742973,
                31.6712228
              ],
              [
                49.1761513,
                31.6692017
              ],
              [
                49.177101,
                31.667639
              ],
              [
                49.1777878,
                31.6667649
              ],
              [
                49.1790619,
                31.6655698
              ],
              [
                49.1809158,
                31.6633187
              ],
              [
                49.1857871,
                31.6575271
              ],
              [
                49.1881674,
                31.6544016
              ],
              [
                49.1898574,
                31.6519676
              ],
              [
                49.1914367,
                31.6490291
              ],
              [
                49.193226,
                31.645541
              ],
              [
                49.1950151,
                31.6419154
              ],
              [
                49.1958006,
                31.6398496
              ],
              [
                49.1964263,
                31.6381987
              ],
              [
                49.1966284,
                31.6366861
              ],
              [
                49.1967241,
                31.6354021
              ],
              [
                49.1967088,
                31.6336158
              ],
              [
                49.1964228,
                31.63128
              ],
              [
                49.1957094,
                31.6288119
              ],
              [
                49.1948318,
                31.6263843
              ],
              [
                49.1940153,
                31.624465
              ],
              [
                49.192466,
                31.6218821
              ],
              [
                49.1919594,
                31.6210375
              ],
              [
                49.1892012,
                31.6174309
              ],
              [
                49.1888844,
                31.6170488
              ],
              [
                49.1867752,
                31.6145054
              ],
              [
                49.1845749,
                31.6118914
              ],
              [
                49.1825104,
                31.6094385
              ],
              [
                49.1808966,
                31.6077039
              ],
              [
                49.1790657,
                31.6061083
              ],
              [
                49.1763763,
                31.6041035
              ],
              [
                49.1726376,
                31.6011285
              ],
              [
                49.1711617,
                31.599954
              ],
              [
                49.1658937,
                31.5957607
              ],
              [
                49.1628264,
                31.5929339
              ],
              [
                49.1598091,
                31.5898754
              ],
              [
                49.1568984,
                31.5865433
              ],
              [
                49.1535035,
                31.5826629
              ],
              [
                49.1497306,
                31.5782786
              ],
              [
                49.1470833,
                31.5746704
              ],
              [
                49.1470796,
                31.5738924
              ],
              [
                49.1473312,
                31.5718755
              ],
              [
                49.147583,
                31.5700435
              ],
              [
                49.1478919,
                31.5683454
              ],
              [
                49.1478728,
                31.5661938
              ],
              [
                49.1480103,
                31.5631695
              ],
              [
                49.1480942,
                31.5603744
              ],
              [
                49.1485444,
                31.5560196
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555254,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هندیجان",
          "name:en": "Hendijan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278754",
          "wikipedia": "fa:شهرستان هندیجان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.4643006,
                29.7895783
              ],
              [
                49.5801433,
                29.6674426
              ],
              [
                50.1161772,
                30.1541459
              ],
              [
                50.1168438,
                30.1547139
              ],
              [
                50.1189118,
                30.1565697
              ],
              [
                50.1208266,
                30.1585497
              ],
              [
                50.1234323,
                30.1608028
              ],
              [
                50.1259385,
                30.1637049
              ],
              [
                50.1292915,
                30.1671112
              ],
              [
                50.1324843,
                30.1699162
              ],
              [
                50.1390342,
                30.1759444
              ],
              [
                50.1439932,
                30.1810483
              ],
              [
                50.1495512,
                30.1872635
              ],
              [
                50.1552275,
                30.1943072
              ],
              [
                50.1580161,
                30.1980362
              ],
              [
                50.1605453,
                30.2019507
              ],
              [
                50.1634027,
                30.2066952
              ],
              [
                50.1659927,
                30.2113026
              ],
              [
                50.1688117,
                30.2169221
              ],
              [
                50.1701622,
                30.2193174
              ],
              [
                50.1718979,
                30.2229109
              ],
              [
                50.1732026,
                30.2258158
              ],
              [
                50.1743433,
                30.2281669
              ],
              [
                50.1759261,
                30.2318992
              ],
              [
                50.177616,
                30.2357698
              ],
              [
                50.1793595,
                30.2397782
              ],
              [
                50.1805687,
                30.2431427
              ],
              [
                50.1814574,
                30.2464171
              ],
              [
                50.1825508,
                30.2501372
              ],
              [
                50.1828957,
                30.2512019
              ],
              [
                50.1846658,
                30.2561332
              ],
              [
                50.1864356,
                30.2609674
              ],
              [
                50.1890869,
                30.2689158
              ],
              [
                50.1934164,
                30.2796154
              ],
              [
                50.1951446,
                30.283477
              ],
              [
                50.1975481,
                30.2891068
              ],
              [
                50.1978716,
                30.2898572
              ],
              [
                50.1988062,
                30.292025
              ],
              [
                50.1992722,
                30.2931058
              ],
              [
                50.2000071,
                30.2949624
              ],
              [
                50.196415,
                30.295527
              ],
              [
                50.1925621,
                30.2962229
              ],
              [
                50.1892357,
                30.2967844
              ],
              [
                50.184906,
                30.2974749
              ],
              [
                50.1787262,
                30.2987469
              ],
              [
                50.1728133,
                30.2998354
              ],
              [
                50.1681633,
                30.3005211
              ],
              [
                50.1653671,
                30.3007672
              ],
              [
                50.1646713,
                30.3008395
              ],
              [
                50.1623039,
                30.3011018
              ],
              [
                50.1598243,
                30.3012574
              ],
              [
                50.1577109,
                30.3014197
              ],
              [
                50.1561812,
                30.3014956
              ],
              [
                50.153484,
                30.3017437
              ],
              [
                50.1530648,
                30.3017823
              ],
              [
                50.1510048,
                30.3020374
              ],
              [
                50.1493683,
                30.3022952
              ],
              [
                50.1479415,
                30.3026018
              ],
              [
                50.1461409,
                30.3030006
              ],
              [
                50.1447145,
                30.3033071
              ],
              [
                50.1427613,
                30.3038403
              ],
              [
                50.140554,
                30.3044799
              ],
              [
                50.1393738,
                30.3048219
              ],
              [
                50.1335029,
                30.3063285
              ],
              [
                50.1246148,
                30.3089133
              ],
              [
                50.1175805,
                30.3108264
              ],
              [
                50.1142426,
                30.3118077
              ],
              [
                50.1084177,
                30.3136879
              ],
              [
                50.1022223,
                30.3157052
              ],
              [
                50.0986747,
                30.3167298
              ],
              [
                50.0951803,
                30.3177569
              ],
              [
                50.0914689,
                30.3190126
              ],
              [
                50.0869676,
                30.3203077
              ],
              [
                50.0839461,
                30.3213401
              ],
              [
                50.0822485,
                30.3217839
              ],
              [
                50.0793914,
                30.3224496
              ],
              [
                50.0714949,
                30.324494
              ],
              [
                50.0602607,
                30.327475
              ],
              [
                50.0528373,
                30.3294337
              ],
              [
                50.0443536,
                30.331752
              ],
              [
                50.0349122,
                30.3342025
              ],
              [
                50.0264205,
                30.336427
              ],
              [
                50.0227087,
                30.3373626
              ],
              [
                50.0150679,
                30.339137
              ],
              [
                50.0093917,
                30.3405582
              ],
              [
                50.0045661,
                30.3414352
              ],
              [
                50.0035236,
                30.3416356
              ],
              [
                50.0000634,
                30.3423009
              ],
              [
                50.0000118,
                30.3423253
              ],
              [
                49.9986458,
                30.3429988
              ],
              [
                49.9956055,
                30.3444978
              ],
              [
                49.9918596,
                30.3463368
              ],
              [
                49.9864235,
                30.3481423
              ],
              [
                49.9809378,
                30.3500397
              ],
              [
                49.976246,
                30.3521168
              ],
              [
                49.971817,
                30.3541935
              ],
              [
                49.9665529,
                30.3568297
              ],
              [
                49.9591026,
                30.3605491
              ],
              [
                49.9573211,
                30.361514
              ],
              [
                49.9531136,
                30.3637925
              ],
              [
                49.9482728,
                30.3667021
              ],
              [
                49.9442178,
                30.3694215
              ],
              [
                49.9357223,
                30.3742116
              ],
              [
                49.9314041,
                30.3770255
              ],
              [
                49.9290123,
                30.3787113
              ],
              [
                49.9268875,
                30.3806271
              ],
              [
                49.9225425,
                30.3848256
              ],
              [
                49.9188765,
                30.3886527
              ],
              [
                49.9132004,
                30.3951768
              ],
              [
                49.9125102,
                30.3960392
              ],
              [
                49.9110373,
                30.3978793
              ],
              [
                49.9044418,
                30.4062135
              ],
              [
                49.900364,
                30.4111984
              ],
              [
                49.8968008,
                30.4156687
              ],
              [
                49.8932456,
                30.420554
              ],
              [
                49.890049,
                30.4248355
              ],
              [
                49.8889861,
                30.4265477
              ],
              [
                49.8886643,
                30.4270659
              ],
              [
                49.8874246,
                30.4286953
              ],
              [
                49.8840293,
                30.434087
              ],
              [
                49.8816186,
                30.4383163
              ],
              [
                49.8793525,
                30.4423495
              ],
              [
                49.8787994,
                30.4433338
              ],
              [
                49.8771057,
                30.4463533
              ],
              [
                49.8760837,
                30.4483727
              ],
              [
                49.8741912,
                30.452112
              ],
              [
                49.8740557,
                30.4524018
              ],
              [
                49.8719978,
                30.4568934
              ],
              [
                49.8698996,
                30.4611634
              ],
              [
                49.8687746,
                30.4634862
              ],
              [
                49.8674374,
                30.4660439
              ],
              [
                49.8670312,
                30.4668299
              ],
              [
                49.8647537,
                30.4702682
              ],
              [
                49.8620148,
                30.4744964
              ],
              [
                49.8590508,
                30.4782625
              ],
              [
                49.8559875,
                30.4823998
              ],
              [
                49.8531189,
                30.4855643
              ],
              [
                49.8499299,
                30.4889153
              ],
              [
                49.8449058,
                30.4939892
              ],
              [
                49.8408298,
                30.5000097
              ],
              [
                49.8392981,
                30.5025834
              ],
              [
                49.8362771,
                30.5068041
              ],
              [
                49.8347168,
                30.5091677
              ],
              [
                49.8325845,
                30.5124601
              ],
              [
                49.8287812,
                30.5179322
              ],
              [
                49.825081,
                30.5238225
              ],
              [
                49.8222084,
                30.527999
              ],
              [
                49.8183938,
                30.5326383
              ],
              [
                49.8156203,
                30.5361185
              ],
              [
                49.8107489,
                30.5410886
              ],
              [
                49.8055037,
                30.5462897
              ],
              [
                49.8009772,
                30.5501612
              ],
              [
                49.7992021,
                30.5516793
              ],
              [
                49.7946283,
                30.5553974
              ],
              [
                49.7888946,
                30.5597676
              ],
              [
                49.7863692,
                30.56186
              ],
              [
                49.7832144,
                30.5645577
              ],
              [
                49.7787896,
                30.5676291
              ],
              [
                49.7752039,
                30.5698173
              ],
              [
                49.7718315,
                30.5718202
              ],
              [
                49.7680854,
                30.5737766
              ],
              [
                49.7660295,
                30.5749413
              ],
              [
                49.7629166,
                30.5760622
              ],
              [
                49.7582702,
                30.5776059
              ],
              [
                49.7534681,
                30.578927
              ],
              [
                49.7500063,
                30.5798412
              ],
              [
                49.7477341,
                30.5803066
              ],
              [
                49.7449379,
                30.5808751
              ],
              [
                49.7424087,
                30.5813019
              ],
              [
                49.738823,
                30.5818288
              ],
              [
                49.7351799,
                30.5821228
              ],
              [
                49.7293166,
                30.582289
              ],
              [
                49.7110901,
                30.5823285
              ],
              [
                49.7074807,
                30.5823627
              ],
              [
                49.6960335,
                30.5824898
              ],
              [
                49.6892204,
                30.582568
              ],
              [
                49.6759073,
                30.5827265
              ],
              [
                49.6683006,
                30.5827594
              ],
              [
                49.6597976,
                30.5828931
              ],
              [
                49.6570473,
                30.5829054
              ],
              [
                49.6526642,
                30.5829255
              ],
              [
                49.6465341,
                30.5828619
              ],
              [
                49.6424638,
                30.5826503
              ],
              [
                49.6381873,
                30.5827162
              ],
              [
                49.6339606,
                30.5829222
              ],
              [
                49.6301041,
                30.5828479
              ],
              [
                49.6213874,
                30.5827491
              ],
              [
                49.6167908,
                30.5827702
              ],
              [
                49.6117171,
                30.5826553
              ],
              [
                49.6050605,
                30.5828254
              ],
              [
                49.5996742,
                30.582851
              ],
              [
                49.5944444,
                30.5828285
              ],
              [
                49.5859373,
                30.5827769
              ],
              [
                49.5826072,
                30.5827475
              ],
              [
                49.5791741,
                30.5828544
              ],
              [
                49.5733642,
                30.5830209
              ],
              [
                49.5673408,
                30.5830472
              ],
              [
                49.5645942,
                30.5828771
              ],
              [
                49.5617409,
                30.5827982
              ],
              [
                49.5587274,
                30.5827649
              ],
              [
                49.5562441,
                30.5826832
              ],
              [
                49.5542869,
                30.5823705
              ],
              [
                49.5515403,
                30.5818753
              ],
              [
                49.5478898,
                30.5811512
              ],
              [
                49.5436591,
                30.5807092
              ],
              [
                49.5399092,
                30.5804506
              ],
              [
                49.5400063,
                30.5735618
              ],
              [
                49.5401931,
                30.5708952
              ],
              [
                49.5402368,
                30.5679729
              ],
              [
                49.5404331,
                30.5646711
              ],
              [
                49.5406199,
                30.5620046
              ],
              [
                49.5406579,
                30.5594635
              ],
              [
                49.5406998,
                30.5566682
              ],
              [
                49.5405589,
                30.5530025
              ],
              [
                49.5406045,
                30.5499532
              ],
              [
                49.5404385,
                30.5486092
              ],
              [
                49.5398091,
                30.5470248
              ],
              [
                49.5392736,
                30.5456812
              ],
              [
                49.5386307,
                30.5449908
              ],
              [
                49.5377203,
                30.5439911
              ],
              [
                49.5364589,
                30.542799
              ],
              [
                49.5356263,
                30.5420594
              ],
              [
                49.5346311,
                30.5412707
              ],
              [
                49.5336347,
                30.5405822
              ],
              [
                49.5327471,
                30.5398596
              ],
              [
                49.4994849,
                30.5071481
              ],
              [
                49.4976038,
                30.5052972
              ],
              [
                49.4960279,
                30.5029337
              ],
              [
                49.4950891,
                30.50108
              ],
              [
                49.494493,
                30.4981244
              ],
              [
                49.4943209,
                30.4966001
              ],
              [
                49.4940448,
                30.4941535
              ],
              [
                49.4932532,
                30.4871382
              ],
              [
                49.4926068,
                30.4761884
              ],
              [
                49.4928976,
                30.4573074
              ],
              [
                49.4920158,
                30.4519282
              ],
              [
                49.4917999,
                30.4461011
              ],
              [
                49.4912541,
                30.4418587
              ],
              [
                49.491967,
                30.4352481
              ],
              [
                49.491462,
                30.4283587
              ],
              [
                49.4916045,
                30.4190939
              ],
              [
                49.4915522,
                30.4086819
              ],
              [
                49.4911928,
                30.4036559
              ],
              [
                49.4911347,
                30.3961148
              ],
              [
                49.4911342,
                30.3960612
              ],
              [
                49.4911254,
                30.394911
              ],
              [
                49.4911036,
                30.392083
              ],
              [
                49.4921863,
                30.3812404
              ],
              [
                49.4920192,
                30.3722368
              ],
              [
                49.491205,
                30.3656084
              ],
              [
                49.4858448,
                30.3568095
              ],
              [
                49.4826016,
                30.3493586
              ],
              [
                49.4799446,
                30.3435031
              ],
              [
                49.4783058,
                30.3331429
              ],
              [
                49.4792663,
                30.3224598
              ],
              [
                49.4805868,
                30.3141957
              ],
              [
                49.4819177,
                30.3052418
              ],
              [
                49.4832164,
                30.2983573
              ],
              [
                49.483736,
                30.2904289
              ],
              [
                49.4846687,
                30.2814702
              ],
              [
                49.4864437,
                30.2694165
              ],
              [
                49.486537,
                30.250757
              ],
              [
                49.4865876,
                30.1461338
              ],
              [
                49.4813096,
                30.0618104
              ],
              [
                49.4643006,
                29.7895783
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555255,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هویزه",
          "name:en": "Hoveyzeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610447",
          "wikipedia": "en:Hoveyzeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.6850105,
                31.2448995
              ],
              [
                47.6849362,
                31.2402344
              ],
              [
                47.6849929,
                31.2151123
              ],
              [
                47.6849688,
                31.2026175
              ],
              [
                47.6849481,
                31.1960523
              ],
              [
                47.6849547,
                31.1681613
              ],
              [
                47.6849591,
                31.1559627
              ],
              [
                47.6849719,
                31.1306581
              ],
              [
                47.6850136,
                31.1188321
              ],
              [
                47.6849461,
                31.1129169
              ],
              [
                47.6849182,
                31.1053909
              ],
              [
                47.6848923,
                31.0975014
              ],
              [
                47.6848698,
                31.0821878
              ],
              [
                47.6846639,
                31.0758186
              ],
              [
                47.684463,
                31.0615979
              ],
              [
                47.6844189,
                31.0538664
              ],
              [
                47.6850854,
                31.0487744
              ],
              [
                47.685381,
                31.0465162
              ],
              [
                47.6854417,
                31.0408728
              ],
              [
                47.687027,
                31.0159873
              ],
              [
                47.6871111,
                31.0007127
              ],
              [
                47.6964971,
                31.0005319
              ],
              [
                47.7318265,
                31.000468
              ],
              [
                47.7768986,
                31.0006268
              ],
              [
                47.7999634,
                31.0005512
              ],
              [
                47.7989943,
                31.0028666
              ],
              [
                47.8703929,
                31.0101038
              ],
              [
                47.9565999,
                31.0056998
              ],
              [
                47.9838282,
                31.007415
              ],
              [
                47.9894612,
                31.0059069
              ],
              [
                48.0073306,
                31.0043777
              ],
              [
                48.0253238,
                31.0045923
              ],
              [
                48.0307025,
                31.0057707
              ],
              [
                48.0350247,
                31.007351
              ],
              [
                48.0395108,
                31.0079027
              ],
              [
                48.0518322,
                31.0104347
              ],
              [
                48.0575733,
                31.0113327
              ],
              [
                48.0714244,
                31.0151387
              ],
              [
                48.0797501,
                31.018244
              ],
              [
                48.0845602,
                31.0200687
              ],
              [
                48.0934867,
                31.0320148
              ],
              [
                48.1113396,
                31.0548484
              ],
              [
                48.1234131,
                31.0704683
              ],
              [
                48.1488189,
                31.1130067
              ],
              [
                48.1749116,
                31.1557681
              ],
              [
                48.1974927,
                31.1929709
              ],
              [
                48.1992119,
                31.1961669
              ],
              [
                48.2295952,
                31.2453538
              ],
              [
                48.245388,
                31.2720379
              ],
              [
                48.2626418,
                31.2993221
              ],
              [
                48.280675,
                31.3289218
              ],
              [
                48.2864761,
                31.3471905
              ],
              [
                48.2880744,
                31.3487461
              ],
              [
                48.2897797,
                31.3505768
              ],
              [
                48.2913818,
                31.3524052
              ],
              [
                48.2920226,
                31.353138
              ],
              [
                48.2947946,
                31.3561836
              ],
              [
                48.2967148,
                31.35872
              ],
              [
                48.2979928,
                31.360413
              ],
              [
                48.2992211,
                31.36238
              ],
              [
                48.2998619,
                31.3637553
              ],
              [
                48.3004494,
                31.364807
              ],
              [
                48.3013573,
                31.3666365
              ],
              [
                48.3022118,
                31.3687872
              ],
              [
                48.3032265,
                31.3714892
              ],
              [
                48.3042411,
                31.3749216
              ],
              [
                48.304882,
                31.3767996
              ],
              [
                48.3055763,
                31.3790868
              ],
              [
                48.3061638,
                31.3808734
              ],
              [
                48.3066483,
                31.3828879
              ],
              [
                48.3072358,
                31.3845348
              ],
              [
                48.3077698,
                31.3860452
              ],
              [
                48.3081971,
                31.3873731
              ],
              [
                48.3089447,
                31.388976
              ],
              [
                48.3099595,
                31.3906679
              ],
              [
                48.3107605,
                31.3921344
              ],
              [
                48.3116684,
                31.3936437
              ],
              [
                48.3124695,
                31.3950177
              ],
              [
                48.3133241,
                31.3961155
              ],
              [
                48.313961,
                31.3972156
              ],
              [
                48.3146552,
                31.3980395
              ],
              [
                48.3156699,
                31.3994586
              ],
              [
                48.3166847,
                31.4007401
              ],
              [
                48.3171221,
                31.4013891
              ],
              [
                48.3173859,
                31.4017806
              ],
              [
                48.3137055,
                31.4063704
              ],
              [
                48.3091811,
                31.4108115
              ],
              [
                48.3060378,
                31.4141971
              ],
              [
                48.3002891,
                31.4204202
              ],
              [
                48.2956543,
                31.4246285
              ],
              [
                48.2915001,
                31.4287476
              ],
              [
                48.2871857,
                31.4332758
              ],
              [
                48.2835083,
                31.4375309
              ],
              [
                48.2816467,
                31.4400457
              ],
              [
                48.2794609,
                31.4426078
              ],
              [
                48.2780227,
                31.444392
              ],
              [
                48.2748795,
                31.4468141
              ],
              [
                48.2699241,
                31.4510664
              ],
              [
                48.2654991,
                31.4543582
              ],
              [
                48.2607536,
                31.4572348
              ],
              [
                48.2571108,
                31.4602006
              ],
              [
                48.2565956,
                31.4606199
              ],
              [
                48.2530784,
                31.464093
              ],
              [
                48.2499988,
                31.4670929
              ],
              [
                48.2453666,
                31.4701496
              ],
              [
                48.2441063,
                31.4709813
              ],
              [
                48.242241,
                31.4723501
              ],
              [
                48.240532,
                31.4730798
              ],
              [
                48.2383956,
                31.4734868
              ],
              [
                48.2367401,
                31.4731625
              ],
              [
                48.2318192,
                31.4717373
              ],
              [
                48.2285042,
                31.4706781
              ],
              [
                48.2250824,
                31.4693459
              ],
              [
                48.2228394,
                31.4684722
              ],
              [
                48.2212545,
                31.4676488
              ],
              [
                48.2210732,
                31.4675546
              ],
              [
                48.220817,
                31.467492
              ],
              [
                48.2203133,
                31.4673689
              ],
              [
                48.2186126,
                31.4669533
              ],
              [
                48.2154617,
                31.4667179
              ],
              [
                48.2131118,
                31.4667615
              ],
              [
                48.209961,
                31.4672587
              ],
              [
                48.2073975,
                31.4677573
              ],
              [
                48.2063113,
                31.4681861
              ],
              [
                48.2045135,
                31.4688959
              ],
              [
                48.1977844,
                31.4715825
              ],
              [
                48.1904678,
                31.4746797
              ],
              [
                48.1839561,
                31.4779632
              ],
              [
                48.1785088,
                31.4807423
              ],
              [
                48.1736246,
                31.4833781
              ],
              [
                48.1724206,
                31.4840278
              ],
              [
                48.1666133,
                31.4867285
              ],
              [
                48.1589637,
                31.4890071
              ],
              [
                48.1513104,
                31.4913933
              ],
              [
                48.1433986,
                31.4940911
              ],
              [
                48.1370978,
                31.4969327
              ],
              [
                48.1341454,
                31.499348
              ],
              [
                48.1327615,
                31.500447
              ],
              [
                48.1325058,
                31.5010826
              ],
              [
                48.1323537,
                31.5014603
              ],
              [
                48.1317662,
                31.502145
              ],
              [
                48.1311024,
                31.5029516
              ],
              [
                48.1305917,
                31.5036271
              ],
              [
                48.129981,
                31.5046871
              ],
              [
                48.129598,
                31.5053908
              ],
              [
                48.1289047,
                31.5060946
              ],
              [
                48.1252287,
                31.5100295
              ],
              [
                48.1245183,
                31.5108359
              ],
              [
                48.124007,
                31.5113522
              ],
              [
                48.1238741,
                31.5114883
              ],
              [
                48.1221864,
                31.5131903
              ],
              [
                48.1209787,
                31.5144095
              ],
              [
                48.118799,
                31.5163076
              ],
              [
                48.1183504,
                31.5167242
              ],
              [
                48.1140955,
                31.5195406
              ],
              [
                48.1132846,
                31.5200808
              ],
              [
                48.1122332,
                31.5207759
              ],
              [
                48.1086579,
                31.5231395
              ],
              [
                48.108503,
                31.5233569
              ],
              [
                48.1069985,
                31.5254735
              ],
              [
                48.1049157,
                31.528535
              ],
              [
                48.1014442,
                31.5339771
              ],
              [
                48.1000518,
                31.5361277
              ],
              [
                48.0970612,
                31.5385959
              ],
              [
                48.0966203,
                31.5389846
              ],
              [
                48.0952987,
                31.5401496
              ],
              [
                48.0920944,
                31.5418824
              ],
              [
                48.0888366,
                31.5432961
              ],
              [
                48.0861625,
                31.5447117
              ],
              [
                48.0837594,
                31.5465843
              ],
              [
                48.0816764,
                31.5479569
              ],
              [
                48.0794334,
                31.5487307
              ],
              [
                48.0763358,
                31.5494128
              ],
              [
                48.0744294,
                31.549999
              ],
              [
                48.0730744,
                31.5504157
              ],
              [
                48.067894,
                31.5527427
              ],
              [
                48.0649566,
                31.554109
              ],
              [
                48.0614815,
                31.5558889
              ],
              [
                48.0589153,
                31.5572972
              ],
              [
                48.0586509,
                31.5574423
              ],
              [
                48.0569382,
                31.5584916
              ],
              [
                48.055336,
                31.5598614
              ],
              [
                48.0530357,
                31.5618732
              ],
              [
                48.0520745,
                31.5625566
              ],
              [
                48.0483322,
                31.5645666
              ],
              [
                48.0455551,
                31.5660263
              ],
              [
                48.0430985,
                31.5669388
              ],
              [
                48.0397835,
                31.5677118
              ],
              [
                48.0371132,
                31.5683487
              ],
              [
                48.0350266,
                31.5692606
              ],
              [
                48.033638,
                31.5697603
              ],
              [
                48.0325165,
                31.5706743
              ],
              [
                48.0308036,
                31.5726408
              ],
              [
                48.0262902,
                31.5777821
              ],
              [
                48.0242234,
                31.5801362
              ],
              [
                48.0214386,
                31.5836104
              ],
              [
                48.020161,
                31.585561
              ],
              [
                48.0191918,
                31.5870407
              ],
              [
                48.0156594,
                31.5915207
              ],
              [
                48.0143203,
                31.5938991
              ],
              [
                48.0110016,
                31.5973718
              ],
              [
                48.0104655,
                31.5978627
              ],
              [
                48.0087547,
                31.5994291
              ],
              [
                48.0068159,
                31.6008782
              ],
              [
                48.0052757,
                31.6020323
              ],
              [
                48.0025482,
                31.6039948
              ],
              [
                47.9997594,
                31.6052908
              ],
              [
                47.9911423,
                31.6130632
              ],
              [
                47.9869867,
                31.6169733
              ],
              [
                47.9837685,
                31.620001
              ],
              [
                47.9770965,
                31.6238668
              ],
              [
                47.969944,
                31.6273151
              ],
              [
                47.9467126,
                31.6370558
              ],
              [
                47.9419822,
                31.6385903
              ],
              [
                47.9338608,
                31.6410236
              ],
              [
                47.9288062,
                31.6420967
              ],
              [
                47.9268189,
                31.642867
              ],
              [
                47.924881,
                31.6439091
              ],
              [
                47.9226189,
                31.6453197
              ],
              [
                47.9141122,
                31.6508238
              ],
              [
                47.9091567,
                31.6532757
              ],
              [
                47.9008141,
                31.6574483
              ],
              [
                47.8849822,
                31.6630764
              ],
              [
                47.8774605,
                31.6651126
              ],
              [
                47.8705215,
                31.6668156
              ],
              [
                47.8641204,
                31.6677898
              ],
              [
                47.861702,
                31.6682803
              ],
              [
                47.858471,
                31.669454
              ],
              [
                47.853897,
                31.671079
              ],
              [
                47.8474885,
                31.6734272
              ],
              [
                47.8369903,
                31.6772198
              ],
              [
                47.8266525,
                31.6809659
              ],
              [
                47.8216193,
                31.6828874
              ],
              [
                47.7925145,
                31.6202521
              ],
              [
                47.7876095,
                31.609671
              ],
              [
                47.7864635,
                31.6075349
              ],
              [
                47.7564203,
                31.5438096
              ],
              [
                47.7524852,
                31.5356392
              ],
              [
                47.7281329,
                31.4838542
              ],
              [
                47.7204431,
                31.4667499
              ],
              [
                47.7168324,
                31.4589055
              ],
              [
                47.7122005,
                31.4490706
              ],
              [
                47.7077828,
                31.4414011
              ],
              [
                47.7050752,
                31.4368463
              ],
              [
                47.702283,
                31.4310081
              ],
              [
                47.6971048,
                31.4200567
              ],
              [
                47.6852868,
                31.3948254
              ],
              [
                47.6850838,
                31.3748765
              ],
              [
                47.6851613,
                31.3682863
              ],
              [
                47.6851096,
                31.3621052
              ],
              [
                47.6851068,
                31.3572988
              ],
              [
                47.6853314,
                31.3440242
              ],
              [
                47.6853403,
                31.3434985
              ],
              [
                47.6853567,
                31.3425272
              ],
              [
                47.6852819,
                31.3314979
              ],
              [
                47.685266,
                31.3260081
              ],
              [
                47.6852646,
                31.3255214
              ],
              [
                47.6852507,
                31.3206918
              ],
              [
                47.6852565,
                31.315065
              ],
              [
                47.6849662,
                31.3048861
              ],
              [
                47.6850073,
                31.2871605
              ],
              [
                47.6850475,
                31.2721091
              ],
              [
                47.6849799,
                31.262729
              ],
              [
                47.6849965,
                31.2570519
              ],
              [
                47.6850105,
                31.2448995
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555281,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گتوند",
          "name:en": "Gotvand County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2639215",
          "wikipedia": "en:Gotvand County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.5708787,
                32.1320908
              ],
              [
                48.576708,
                32.1293721
              ],
              [
                48.5893685,
                32.1236346
              ],
              [
                48.5935421,
                32.1148551
              ],
              [
                48.6078255,
                32.1154504
              ],
              [
                48.6501512,
                32.1189826
              ],
              [
                48.6814686,
                32.1203437
              ],
              [
                48.7108682,
                32.1220364
              ],
              [
                48.7454568,
                32.1239319
              ],
              [
                48.7912796,
                32.119665
              ],
              [
                48.8144018,
                32.1178633
              ],
              [
                48.8549233,
                32.1146777
              ],
              [
                48.8685543,
                32.1096122
              ],
              [
                48.8863362,
                32.1031602
              ],
              [
                48.8889971,
                32.1056759
              ],
              [
                48.8838824,
                32.1132315
              ],
              [
                48.8862743,
                32.1138649
              ],
              [
                48.887108,
                32.1188314
              ],
              [
                48.89138,
                32.1207619
              ],
              [
                48.8947195,
                32.1154046
              ],
              [
                48.9013263,
                32.1150176
              ],
              [
                48.9032614,
                32.1176393
              ],
              [
                48.8973491,
                32.1225077
              ],
              [
                48.901212,
                32.1274796
              ],
              [
                48.9064813,
                32.1243949
              ],
              [
                48.9154648,
                32.1227063
              ],
              [
                48.9134771,
                32.1212983
              ],
              [
                48.9135348,
                32.1187648
              ],
              [
                48.9135564,
                32.1178147
              ],
              [
                48.913578,
                32.1168647
              ],
              [
                48.9137749,
                32.1163927
              ],
              [
                48.9145299,
                32.11593
              ],
              [
                48.9150917,
                32.1157808
              ],
              [
                48.9154781,
                32.1151536
              ],
              [
                48.9160471,
                32.1146877
              ],
              [
                48.91643,
                32.1142188
              ],
              [
                48.9169953,
                32.1139113
              ],
              [
                48.9179292,
                32.1137683
              ],
              [
                48.9186769,
                32.1136222
              ],
              [
                48.9190562,
                32.1133116
              ],
              [
                48.9194355,
                32.1130011
              ],
              [
                48.9196323,
                32.1125291
              ],
              [
                48.9200188,
                32.1119018
              ],
              [
                48.9203945,
                32.1117496
              ],
              [
                48.9207666,
                32.1117557
              ],
              [
                48.9213283,
                32.1116065
              ],
              [
                48.9217111,
                32.1111376
              ],
              [
                48.9220904,
                32.110827
              ],
              [
                48.9226593,
                32.1103612
              ],
              [
                48.9232282,
                32.1098953
              ],
              [
                48.9241691,
                32.1094355
              ],
              [
                48.9247272,
                32.1094447
              ],
              [
                48.9254786,
                32.1091402
              ],
              [
                48.9260403,
                32.108991
              ],
              [
                48.926237,
                32.108519
              ],
              [
                48.9264302,
                32.1082053
              ],
              [
                48.927178,
                32.1080592
              ],
              [
                48.9277396,
                32.10791
              ],
              [
                48.9282978,
                32.1079191
              ],
              [
                48.9288416,
                32.1085616
              ],
              [
                48.9295607,
                32.1096822
              ],
              [
                48.929922,
                32.1101633
              ],
              [
                48.9304659,
                32.1108058
              ],
              [
                48.9310204,
                32.1109733
              ],
              [
                48.9313925,
                32.1109794
              ],
              [
                48.9315786,
                32.1109824
              ],
              [
                48.9323227,
                32.1109946
              ],
              [
                48.9332601,
                32.1106931
              ],
              [
                48.9341974,
                32.1103916
              ],
              [
                48.9345802,
                32.1099226
              ],
              [
                48.9349701,
                32.109137
              ],
              [
                48.9353494,
                32.1088263
              ],
              [
                48.9355425,
                32.1085127
              ],
              [
                48.9362902,
                32.1083665
              ],
              [
                48.9376174,
                32.1072793
              ],
              [
                48.9389268,
                32.1069838
              ],
              [
                48.9394885,
                32.1068345
              ],
              [
                48.9402362,
                32.1066883
              ],
              [
                48.9406118,
                32.106536
              ],
              [
                48.9413702,
                32.1059147
              ],
              [
                48.942311,
                32.1054548
              ],
              [
                48.9428726,
                32.1053055
              ],
              [
                48.9434307,
                32.1053146
              ],
              [
                48.9438853,
                32.1052669
              ],
              [
                48.9447365,
                32.1051774
              ],
              [
                48.9464321,
                32.1042545
              ],
              [
                48.9458563,
                32.1050372
              ],
              [
                48.9452733,
                32.1061365
              ],
              [
                48.945238,
                32.1064298
              ],
              [
                48.9450447,
                32.1080337
              ],
              [
                48.9450341,
                32.1085087
              ],
              [
                48.9453849,
                32.1094648
              ],
              [
                48.9461148,
                32.1101103
              ],
              [
                48.9472169,
                32.1107618
              ],
              [
                48.9485228,
                32.1106245
              ],
              [
                48.9494636,
                32.1101646
              ],
              [
                48.9502255,
                32.1093849
              ],
              [
                48.9517209,
                32.1090923
              ],
              [
                48.9528336,
                32.1092687
              ],
              [
                48.9542902,
                32.1107179
              ],
              [
                48.9552028,
                32.1115246
              ],
              [
                48.9566735,
                32.1123404
              ],
              [
                48.9583444,
                32.1125258
              ],
              [
                48.9594642,
                32.1123854
              ],
              [
                48.960405,
                32.1119254
              ],
              [
                48.9604227,
                32.1111336
              ],
              [
                48.9602577,
                32.1101806
              ],
              [
                48.9604684,
                32.1090751
              ],
              [
                48.9608616,
                32.108131
              ],
              [
                48.9617919,
                32.108146
              ],
              [
                48.9630906,
                32.1083253
              ],
              [
                48.9640173,
                32.1084986
              ],
              [
                48.9660638,
                32.1085315
              ],
              [
                48.9673661,
                32.1085524
              ],
              [
                48.9681138,
                32.108406
              ],
              [
                48.9686754,
                32.1082566
              ],
              [
                48.9688614,
                32.1082596
              ],
              [
                48.9696126,
                32.1079549
              ],
              [
                48.9701848,
                32.1073304
              ],
              [
                48.9707534,
                32.1068643
              ],
              [
                48.9709464,
                32.1065506
              ],
              [
                48.9709569,
                32.1060756
              ],
              [
                48.9709674,
                32.1056005
              ],
              [
                48.9713465,
                32.1052898
              ],
              [
                48.9715396,
                32.1049761
              ],
              [
                48.9721117,
                32.1043516
              ],
              [
                48.9728768,
                32.1034135
              ],
              [
                48.9736419,
                32.1024753
              ],
              [
                48.9740245,
                32.1020062
              ],
              [
                48.9744035,
                32.1016954
              ],
              [
                48.9749651,
                32.101546
              ],
              [
                48.9755232,
                32.1015549
              ],
              [
                48.9764638,
                32.1010948
              ],
              [
                48.9768324,
                32.1012591
              ],
              [
                48.977766,
                32.1011156
              ],
              [
                48.9779556,
                32.1009602
              ],
              [
                48.9788892,
                32.1008167
              ],
              [
                48.9798298,
                32.1003565
              ],
              [
                48.9807564,
                32.1005297
              ],
              [
                48.9815075,
                32.1002248
              ],
              [
                48.982462,
                32.0991312
              ],
              [
                48.9836025,
                32.0980405
              ],
              [
                48.9845361,
                32.097897
              ],
              [
                48.9847361,
                32.0972666
              ],
              [
                48.984936,
                32.0966361
              ],
              [
                48.9855045,
                32.09617
              ],
              [
                48.986452,
                32.095393
              ],
              [
                48.9877749,
                32.0944636
              ],
              [
                48.9883399,
                32.0941558
              ],
              [
                48.9887258,
                32.0935283
              ],
              [
                48.9892943,
                32.0930621
              ],
              [
                48.9902382,
                32.0924435
              ],
              [
                48.9908171,
                32.0915022
              ],
              [
                48.9917714,
                32.0904085
              ],
              [
                48.9921573,
                32.089781
              ],
              [
                48.9921746,
                32.0889892
              ],
              [
                48.9923814,
                32.0880421
              ],
              [
                48.9924056,
                32.0869336
              ],
              [
                48.9926089,
                32.0861448
              ],
              [
                48.9926568,
                32.0860297
              ],
              [
                48.9928053,
                32.0856727
              ],
              [
                48.9933702,
                32.0853649
              ],
              [
                48.9936394,
                32.0851996
              ],
              [
                48.9941246,
                32.0849016
              ],
              [
                48.9946895,
                32.0845937
              ],
              [
                48.9952579,
                32.0841275
              ],
              [
                48.9961879,
                32.0841422
              ],
              [
                48.9967424,
                32.0843094
              ],
              [
                48.9971109,
                32.0844736
              ],
              [
                48.997476,
                32.0847962
              ],
              [
                48.9978342,
                32.0854355
              ],
              [
                48.9981889,
                32.0862331
              ],
              [
                48.9981682,
                32.0871833
              ],
              [
                48.998709,
                32.0879838
              ],
              [
                48.9992497,
                32.0887844
              ],
              [
                48.9999765,
                32.0895879
              ],
              [
                49.0007102,
                32.0900747
              ],
              [
                49.0014439,
                32.0905615
              ],
              [
                49.0016264,
                32.0907228
              ],
              [
                49.0025565,
                32.0907375
              ],
              [
                49.0036725,
                32.0907551
              ],
              [
                49.0042478,
                32.0899721
              ],
              [
                49.0048265,
                32.0890308
              ],
              [
                49.0057909,
                32.0874619
              ],
              [
                49.006373,
                32.0863622
              ],
              [
                49.0069516,
                32.0854209
              ],
              [
                49.0078885,
                32.0851188
              ],
              [
                49.0091905,
                32.0851393
              ],
              [
                49.0101205,
                32.0851539
              ],
              [
                49.0108508,
                32.085799
              ],
              [
                49.0117705,
                32.0862887
              ],
              [
                49.0125008,
                32.0869338
              ],
              [
                49.0137857,
                32.087746
              ],
              [
                49.0148949,
                32.0880802
              ],
              [
                49.0161969,
                32.0881006
              ],
              [
                49.0169581,
                32.0873205
              ],
              [
                49.0175366,
                32.0863791
              ],
              [
                49.0177431,
                32.0854319
              ],
              [
                49.0181322,
                32.0846459
              ],
              [
                49.0185111,
                32.084335
              ],
              [
                49.0192687,
                32.0837133
              ],
              [
                49.019465,
                32.0832411
              ],
              [
                49.0200469,
                32.0821414
              ],
              [
                49.0206151,
                32.081675
              ],
              [
                49.0213659,
                32.0813699
              ],
              [
                49.0226781,
                32.0809152
              ],
              [
                49.0232463,
                32.0804489
              ],
              [
                49.0236285,
                32.0799796
              ],
              [
                49.0238315,
                32.0791907
              ],
              [
                49.0242861,
                32.0783315
              ],
              [
                49.0244134,
                32.078091
              ],
              [
                49.0244338,
                32.0771408
              ],
              [
                49.0246402,
                32.0761936
              ],
              [
                49.0250394,
                32.0749326
              ],
              [
                49.0254284,
                32.0741466
              ],
              [
                49.025814,
                32.073519
              ],
              [
                49.0263957,
                32.0724192
              ],
              [
                49.0267949,
                32.0711581
              ],
              [
                49.0272009,
                32.0695804
              ],
              [
                49.027972,
                32.0683251
              ],
              [
                49.0282055,
                32.0661111
              ],
              [
                49.0280637,
                32.0640496
              ],
              [
                49.0282871,
                32.0623105
              ],
              [
                49.0279458,
                32.0608796
              ],
              [
                49.0288925,
                32.0601023
              ],
              [
                49.0296499,
                32.0594804
              ],
              [
                49.0305763,
                32.0596532
              ],
              [
                49.0319329,
                32.0605081
              ],
              [
                49.031826,
                32.061016
              ],
              [
                49.03183,
                32.0616182
              ],
              [
                49.0318909,
                32.0629607
              ],
              [
                49.0320622,
                32.0653107
              ],
              [
                49.0321237,
                32.066155
              ],
              [
                49.0321084,
                32.0742992
              ],
              [
                49.0319215,
                32.0794824
              ],
              [
                49.0318259,
                32.0818891
              ],
              [
                49.0316773,
                32.0845295
              ],
              [
                49.0312079,
                32.0871198
              ],
              [
                49.0304185,
                32.0912902
              ],
              [
                49.0303192,
                32.0927228
              ],
              [
                49.0300599,
                32.0942543
              ],
              [
                49.0298042,
                32.0973552
              ],
              [
                49.0296592,
                32.1002684
              ],
              [
                49.0290948,
                32.1060591
              ],
              [
                49.0285797,
                32.1105494
              ],
              [
                49.0282746,
                32.1136045
              ],
              [
                49.0275878,
                32.1164326
              ],
              [
                49.0266417,
                32.1208306
              ],
              [
                49.0257415,
                32.124077
              ],
              [
                49.0250549,
                32.1269953
              ],
              [
                49.0236207,
                32.1306077
              ],
              [
                49.0224293,
                32.1335966
              ],
              [
                49.0214386,
                32.1360821
              ],
              [
                49.0201111,
                32.1393241
              ],
              [
                49.0187544,
                32.1421116
              ],
              [
                49.017605,
                32.1444731
              ],
              [
                49.0175936,
                32.1445019
              ],
              [
                49.0157968,
                32.1490176
              ],
              [
                49.0152922,
                32.1503646
              ],
              [
                49.0147362,
                32.1518487
              ],
              [
                49.0133476,
                32.1546793
              ],
              [
                49.0121726,
                32.156627
              ],
              [
                49.0104639,
                32.1589474
              ],
              [
                49.0090712,
                32.1610382
              ],
              [
                49.0081102,
                32.162155
              ],
              [
                49.0070914,
                32.1628988
              ],
              [
                49.006176,
                32.1633196
              ],
              [
                49.0050469,
                32.1636468
              ],
              [
                49.0046324,
                32.1637338
              ],
              [
                49.0039178,
                32.1638837
              ],
              [
                49.0025176,
                32.1640781
              ],
              [
                49.0003662,
                32.164335
              ],
              [
                48.9985718,
                32.1648117
              ],
              [
                48.9977227,
                32.1664081
              ],
              [
                48.9977989,
                32.1686664
              ],
              [
                48.9977533,
                32.1694481
              ],
              [
                48.9979362,
                32.1711579
              ],
              [
                48.9981765,
                32.173324
              ],
              [
                48.9988937,
                32.1750761
              ],
              [
                48.9989175,
                32.1751411
              ],
              [
                48.9992295,
                32.1759946
              ],
              [
                48.9974387,
                32.1764966
              ],
              [
                48.9974023,
                32.1765068
              ],
              [
                48.9946594,
                32.1771082
              ],
              [
                48.9904672,
                32.1783178
              ],
              [
                48.9882126,
                32.1791952
              ],
              [
                48.9859083,
                32.1804009
              ],
              [
                48.9829596,
                32.1820179
              ],
              [
                48.9802247,
                32.183406
              ],
              [
                48.9760361,
                32.1849828
              ],
              [
                48.9729766,
                32.1862325
              ],
              [
                48.9700279,
                32.1879913
              ],
              [
                48.963154,
                32.1909111
              ],
              [
                48.9597167,
                32.1923912
              ],
              [
                48.9573021,
                32.1935044
              ],
              [
                48.9556848,
                32.1936
              ],
              [
                48.9563524,
                32.1956739
              ],
              [
                48.9568633,
                32.1983495
              ],
              [
                48.9573783,
                32.2014379
              ],
              [
                48.9577293,
                32.2041132
              ],
              [
                48.9579734,
                32.2072039
              ],
              [
                48.9584352,
                32.2102462
              ],
              [
                48.9586038,
                32.2113863
              ],
              [
                48.9590149,
                32.2141653
              ],
              [
                48.9592057,
                32.2169801
              ],
              [
                48.9591826,
                32.2202536
              ],
              [
                48.959961,
                32.2226021
              ],
              [
                48.9605578,
                32.22535
              ],
              [
                48.9605827,
                32.2254644
              ],
              [
                48.9616965,
                32.2285962
              ],
              [
                48.9622038,
                32.2307622
              ],
              [
                48.9623834,
                32.2326546
              ],
              [
                48.9623985,
                32.2341768
              ],
              [
                48.9628679,
                32.2379565
              ],
              [
                48.9631082,
                32.2402648
              ],
              [
                48.9635085,
                32.2424764
              ],
              [
                48.9643897,
                32.2441816
              ],
              [
                48.9653245,
                32.245793
              ],
              [
                48.9665795,
                32.2470827
              ],
              [
                48.9679449,
                32.2485996
              ],
              [
                48.9683608,
                32.2496727
              ],
              [
                48.9693832,
                32.253281
              ],
              [
                48.9701843,
                32.2562859
              ],
              [
                48.9709814,
                32.2592931
              ],
              [
                48.9714929,
                32.2611434
              ],
              [
                48.9720534,
                32.2625774
              ],
              [
                48.9728468,
                32.2651718
              ],
              [
                48.9736863,
                32.2672506
              ],
              [
                48.9742547,
                32.2692417
              ],
              [
                48.9749336,
                32.2713698
              ],
              [
                48.9753305,
                32.2727087
              ],
              [
                48.9755374,
                32.2740087
              ],
              [
                48.9755668,
                32.2741939
              ],
              [
                48.9756928,
                32.275303
              ],
              [
                48.9757653,
                32.2765037
              ],
              [
                48.9758264,
                32.2768744
              ],
              [
                48.9762077,
                32.2772909
              ],
              [
                48.9767646,
                32.2784452
              ],
              [
                48.977436,
                32.2799712
              ],
              [
                48.9777537,
                32.2808916
              ],
              [
                48.9777718,
                32.2809438
              ],
              [
                48.9780615,
                32.2821931
              ],
              [
                48.978199,
                32.2839518
              ],
              [
                48.9782143,
                32.2849689
              ],
              [
                48.9782791,
                32.2857095
              ],
              [
                48.9783058,
                32.2873762
              ],
              [
                48.978283,
                32.287778
              ],
              [
                48.9782219,
                32.2888562
              ],
              [
                48.9781913,
                32.2903822
              ],
              [
                48.9783745,
                32.2916793
              ],
              [
                48.9783479,
                32.293388
              ],
              [
                48.978428,
                32.2950555
              ],
              [
                48.9787331,
                32.2972295
              ],
              [
                48.9788743,
                32.2995406
              ],
              [
                48.9790152,
                32.3015338
              ],
              [
                48.9791489,
                32.3031954
              ],
              [
                48.9791106,
                32.3042139
              ],
              [
                48.9792863,
                32.3050465
              ],
              [
                48.9796792,
                32.3059276
              ],
              [
                48.9802437,
                32.3075894
              ],
              [
                48.9808083,
                32.309303
              ],
              [
                48.981262,
                32.3106924
              ],
              [
                48.9819908,
                32.3123545
              ],
              [
                48.9826546,
                32.313373
              ],
              [
                48.9837531,
                32.3145743
              ],
              [
                48.984684,
                32.3156399
              ],
              [
                48.9860037,
                32.3171198
              ],
              [
                48.988804,
                32.3200753
              ],
              [
                48.9911194,
                32.3231268
              ],
              [
                48.99255,
                32.3249331
              ],
              [
                48.9932708,
                32.3259502
              ],
              [
                48.9941978,
                32.3266909
              ],
              [
                48.994423,
                32.3270598
              ],
              [
                48.9945869,
                32.3272901
              ],
              [
                48.9945907,
                32.3276149
              ],
              [
                48.9943312,
                32.3280301
              ],
              [
                48.9932632,
                32.3288654
              ],
              [
                48.9926262,
                32.329419
              ],
              [
                48.9922601,
                32.3301121
              ],
              [
                48.99189,
                32.3306226
              ],
              [
                48.9920616,
                32.3312679
              ],
              [
                48.9924507,
                32.3318242
              ],
              [
                48.9931067,
                32.3322879
              ],
              [
                48.9942436,
                32.3325157
              ],
              [
                48.9959183,
                32.3325626
              ],
              [
                48.9970474,
                32.3323776
              ],
              [
                48.9975852,
                32.3323298
              ],
              [
                48.9979134,
                32.3324252
              ],
              [
                48.9985122,
                32.3327436
              ],
              [
                48.9988974,
                32.33316
              ],
              [
                48.9991189,
                32.3335807
              ],
              [
                48.9991837,
                32.3341341
              ],
              [
                48.9983367,
                32.3352886
              ],
              [
                48.997547,
                32.3363539
              ],
              [
                48.9969177,
                32.3374171
              ],
              [
                48.9967612,
                32.3377867
              ],
              [
                48.9967119,
                32.3381579
              ],
              [
                48.9966697,
                32.3387593
              ],
              [
                48.9965705,
                32.3392673
              ],
              [
                48.9966887,
                32.3399613
              ],
              [
                48.9969712,
                32.3405182
              ],
              [
                48.9970894,
                32.3412123
              ],
              [
                48.9971581,
                32.3419981
              ],
              [
                48.9970703,
                32.3422332
              ],
              [
                48.9967957,
                32.3429686
              ],
              [
                48.9957924,
                32.3442649
              ],
              [
                48.9951552,
                32.3450056
              ],
              [
                48.9941444,
                32.345932
              ],
              [
                48.9939776,
                32.3460042
              ],
              [
                48.9936067,
                32.3461647
              ],
              [
                48.9924774,
                32.3464421
              ],
              [
                48.9916154,
                32.3465795
              ],
              [
                48.9903757,
                32.34658
              ],
              [
                48.9895668,
                32.3466753
              ],
              [
                48.9888651,
                32.3469077
              ],
              [
                48.9884415,
                32.3473248
              ],
              [
                48.9879648,
                32.3478313
              ],
              [
                48.987381,
                32.3484803
              ],
              [
                48.987072,
                32.3494066
              ],
              [
                48.986763,
                32.3502855
              ],
              [
                48.9866105,
                32.35107
              ],
              [
                48.9865686,
                32.3516262
              ],
              [
                48.9863053,
                32.3520437
              ],
              [
                48.985611,
                32.3526008
              ],
              [
                48.9844322,
                32.353202
              ],
              [
                48.9836312,
                32.3538521
              ],
              [
                48.9831008,
                32.3544997
              ],
              [
                48.9824103,
                32.3551944
              ],
              [
                48.9819335,
                32.3558384
              ],
              [
                48.9817238,
                32.3561619
              ],
              [
                48.9814607,
                32.3567192
              ],
              [
                48.9814681,
                32.3570891
              ],
              [
                48.9815865,
                32.3577832
              ],
              [
                48.9814872,
                32.358246
              ],
              [
                48.9816017,
                32.3588025
              ],
              [
                48.9818803,
                32.3592647
              ],
              [
                48.9819945,
                32.3597716
              ],
              [
                48.9821663,
                32.3601419
              ],
              [
                48.9820288,
                32.3606845
              ],
              [
                48.9820138,
                32.3607437
              ],
              [
                48.9819679,
                32.3612976
              ],
              [
                48.9819755,
                32.3617622
              ],
              [
                48.9821509,
                32.3626872
              ],
              [
                48.9821624,
                32.3633796
              ],
              [
                48.9821701,
                32.3637968
              ],
              [
                48.9821739,
                32.3640742
              ],
              [
                48.9819602,
                32.3643075
              ],
              [
                48.9817427,
                32.3642161
              ],
              [
                48.9814148,
                32.3640282
              ],
              [
                48.9811401,
                32.3637037
              ],
              [
                48.9806443,
                32.3631974
              ],
              [
                48.9799843,
                32.3625037
              ],
              [
                48.9795456,
                32.3619961
              ],
              [
                48.979374,
                32.3614387
              ],
              [
                48.9790915,
                32.3607487
              ],
              [
                48.9790267,
                32.3600081
              ],
              [
                48.9787902,
                32.3587575
              ],
              [
                48.9787863,
                32.3585029
              ],
              [
                48.9787825,
                32.3582501
              ],
              [
                48.9786608,
                32.3572763
              ],
              [
                48.978592,
                32.356353
              ],
              [
                48.9784735,
                32.3557514
              ],
              [
                48.9781419,
                32.3551982
              ],
              [
                48.9780272,
                32.3549641
              ],
              [
                48.9776497,
                32.3548746
              ],
              [
                48.9773256,
                32.3549641
              ],
              [
                48.9769514,
                32.3552895
              ],
              [
                48.9766923,
                32.3558468
              ],
              [
                48.9764328,
                32.3565867
              ],
              [
                48.976223,
                32.3570478
              ],
              [
                48.9760741,
                32.3579293
              ],
              [
                48.9757042,
                32.3584825
              ],
              [
                48.9754981,
                32.3591759
              ],
              [
                48.9748611,
                32.3597339
              ],
              [
                48.9744338,
                32.3601035
              ],
              [
                48.9733048,
                32.3605183
              ],
              [
                48.9721222,
                32.3610765
              ],
              [
                48.9711534,
                32.3613089
              ],
              [
                48.9700736,
                32.3614967
              ],
              [
                48.9692115,
                32.3616339
              ],
              [
                48.9685135,
                32.3619586
              ],
              [
                48.9679793,
                32.3622814
              ],
              [
                48.9674491,
                32.3629313
              ],
              [
                48.9661332,
                32.3654331
              ],
              [
                48.9649124,
                32.3670052
              ],
              [
                48.9645464,
                32.3677929
              ],
              [
                48.9642335,
                32.3686266
              ],
              [
                48.9635963,
                32.3692747
              ],
              [
                48.9630052,
                32.3695989
              ],
              [
                48.9618759,
                32.370018
              ],
              [
                48.9611206,
                32.370202
              ],
              [
                48.9592783,
                32.3700639
              ],
              [
                48.9580383,
                32.3703415
              ],
              [
                48.9558831,
                32.3708071
              ],
              [
                48.9547501,
                32.3709939
              ],
              [
                48.9540481,
                32.3712733
              ],
              [
                48.9535141,
                32.371551
              ],
              [
                48.9531402,
                32.3720635
              ],
              [
                48.9530906,
                32.3722904
              ],
              [
                48.9533121,
                32.3726616
              ],
              [
                48.9536934,
                32.3728481
              ],
              [
                48.9541856,
                32.3732191
              ],
              [
                48.9551202,
                32.3742331
              ],
              [
                48.955626,
                32.3748684
              ],
              [
                48.9556731,
                32.3749275
              ],
              [
                48.9563369,
                32.3760386
              ],
              [
                48.9568367,
                32.3768223
              ],
              [
                48.9570578,
                32.3772385
              ],
              [
                48.9570123,
                32.377842
              ],
              [
                48.9568024,
                32.378258
              ],
              [
                48.9566994,
                32.3786283
              ],
              [
                48.9562149,
                32.3788144
              ],
              [
                48.9556771,
                32.3789973
              ],
              [
                48.9547041,
                32.3790943
              ],
              [
                48.9543228,
                32.3790926
              ],
              [
                48.9536579,
                32.3790606
              ],
              [
                48.9534035,
                32.3790484
              ],
              [
                48.9528085,
                32.3789553
              ],
              [
                48.9522705,
                32.3791878
              ],
              [
                48.9518433,
                32.3795596
              ],
              [
                48.9514694,
                32.380115
              ],
              [
                48.9513702,
                32.3806229
              ],
              [
                48.9511031,
                32.381038
              ],
              [
                48.9505691,
                32.381505
              ],
              [
                48.9501954,
                32.3819206
              ],
              [
                48.9494972,
                32.3822452
              ],
              [
                48.9486885,
                32.3825228
              ],
              [
                48.9471361,
                32.3836813
              ],
              [
                48.9452095,
                32.3852124
              ],
              [
                48.9440307,
                32.3860928
              ],
              [
                48.9431648,
                32.3863718
              ],
              [
                48.94252,
                32.3867423
              ],
              [
                48.9418756,
                32.3871105
              ],
              [
                48.9415588,
                32.3875315
              ],
              [
                48.9411279,
                32.3878559
              ],
              [
                48.9409713,
                32.3882705
              ],
              [
                48.9408723,
                32.3888731
              ],
              [
                48.9406624,
                32.3894266
              ],
              [
                48.9401856,
                32.3901222
              ],
              [
                48.9394914,
                32.3908662
              ],
              [
                48.9391173,
                32.3912344
              ],
              [
                48.938526,
                32.3915133
              ],
              [
                48.9379846,
                32.3917457
              ],
              [
                48.9370155,
                32.3921176
              ],
              [
                48.9363708,
                32.3925828
              ],
              [
                48.9355697,
                32.3933679
              ],
              [
                48.9350357,
                32.3940626
              ],
              [
                48.9348793,
                32.3944816
              ],
              [
                48.9349404,
                32.3948028
              ],
              [
                48.9352723,
                32.3953133
              ],
              [
                48.9354971,
                32.3959122
              ],
              [
                48.9357682,
                32.3961917
              ],
              [
                48.9362679,
                32.3968853
              ],
              [
                48.9362714,
                32.3973591
              ],
              [
                48.9362717,
                32.3973927
              ],
              [
                48.9358481,
                32.3981366
              ],
              [
                48.9350188,
                32.3985876
              ],
              [
                48.9348259,
                32.3986925
              ],
              [
                48.9340209,
                32.3990626
              ],
              [
                48.9334258,
                32.3991543
              ],
              [
                48.9326667,
                32.3991576
              ],
              [
                48.9316903,
                32.3991574
              ],
              [
                48.9308242,
                32.399204
              ],
              [
                48.9304466,
                32.3993917
              ],
              [
                48.9301262,
                32.3997157
              ],
              [
                48.9300767,
                32.3999944
              ],
              [
                48.9300842,
                32.4005966
              ],
              [
                48.9303094,
                32.4011504
              ],
              [
                48.9303169,
                32.4019847
              ],
              [
                48.9302722,
                32.4021028
              ],
              [
                48.930107,
                32.4025382
              ],
              [
                48.92968,
                32.4029077
              ],
              [
                48.9291955,
                32.4031861
              ],
              [
                48.9283828,
                32.4031908
              ],
              [
                48.9275131,
                32.4030029
              ],
              [
                48.9270746,
                32.4026822
              ],
              [
                48.9266358,
                32.4021271
              ],
              [
                48.9259797,
                32.4016181
              ],
              [
                48.9253196,
                32.4008789
              ],
              [
                48.9251815,
                32.4007792
              ],
              [
                48.9245529,
                32.4003252
              ],
              [
                48.9237901,
                32.400139
              ],
              [
                48.9232521,
                32.4001888
              ],
              [
                48.9223329,
                32.4004667
              ],
              [
                48.9219589,
                32.4008822
              ],
              [
                48.9217493,
                32.4013477
              ],
              [
                48.9218636,
                32.4020417
              ],
              [
                48.9220886,
                32.402688
              ],
              [
                48.9223175,
                32.4036591
              ],
              [
                48.9222718,
                32.4042175
              ],
              [
                48.9226607,
                32.4050491
              ],
              [
                48.9230501,
                32.4058334
              ],
              [
                48.9229507,
                32.4065735
              ],
              [
                48.9226913,
                32.4075004
              ],
              [
                48.9223748,
                32.4082911
              ],
              [
                48.9218368,
                32.4086159
              ],
              [
                48.9206506,
                32.4089391
              ],
              [
                48.9196739,
                32.4091709
              ],
              [
                48.9182663,
                32.4092221
              ],
              [
                48.9170722,
                32.4092677
              ],
              [
                48.9165384,
                32.4096422
              ],
              [
                48.9162179,
                32.4100563
              ],
              [
                48.9161109,
                32.410289
              ],
              [
                48.9158441,
                32.4107062
              ],
              [
                48.9157448,
                32.411399
              ],
              [
                48.9157526,
                32.4122311
              ],
              [
                48.9160882,
                32.4130213
              ],
              [
                48.9163742,
                32.4140361
              ],
              [
                48.9170341,
                32.4149624
              ],
              [
                48.9174194,
                32.4155167
              ],
              [
                48.9178086,
                32.4160732
              ],
              [
                48.918087,
                32.4168579
              ],
              [
                48.9180917,
                32.4168675
              ],
              [
                48.9183655,
                32.4174149
              ],
              [
                48.9185907,
                32.4180139
              ],
              [
                48.9185461,
                32.4187761
              ],
              [
                48.9185447,
                32.4188
              ],
              [
                48.9183924,
                32.4195889
              ],
              [
                48.9182356,
                32.4201477
              ],
              [
                48.9182396,
                32.4204679
              ],
              [
                48.9187316,
                32.4207917
              ],
              [
                48.9190559,
                32.4209172
              ],
              [
                48.9193343,
                32.4210249
              ],
              [
                48.9196626,
                32.4212986
              ],
              [
                48.9196663,
                32.421718
              ],
              [
                48.9194148,
                32.4224246
              ],
              [
                48.919403,
                32.4224577
              ],
              [
                48.919304,
                32.4229657
              ],
              [
                48.919197,
                32.4231533
              ],
              [
                48.9193651,
                32.4237062
              ],
              [
                48.919529,
                32.4238464
              ],
              [
                48.9197621,
                32.4238828
              ],
              [
                48.920128,
                32.4239398
              ],
              [
                48.9207231,
                32.4237512
              ],
              [
                48.9211578,
                32.4237065
              ],
              [
                48.9215926,
                32.4240293
              ],
              [
                48.9219285,
                32.4245828
              ],
              [
                48.9220429,
                32.4250446
              ],
              [
                48.9221037,
                32.4256927
              ],
              [
                48.9223252,
                32.4260638
              ],
              [
                48.922821,
                32.4265252
              ],
              [
                48.9235345,
                32.4272652
              ],
              [
                48.9243584,
                32.4281424
              ],
              [
                48.9245795,
                32.4285135
              ],
              [
                48.9247475,
                32.4289289
              ],
              [
                48.9247551,
                32.4294386
              ],
              [
                48.9247666,
                32.4301805
              ],
              [
                48.9247741,
                32.4307827
              ],
              [
                48.9248849,
                32.4311971
              ],
              [
                48.9254378,
                32.4317518
              ],
              [
                48.9258233,
                32.4322159
              ],
              [
                48.9258843,
                32.4328617
              ],
              [
                48.9263306,
                32.433789
              ],
              [
                48.9267272,
                32.4351776
              ],
              [
                48.9267541,
                32.4371644
              ],
              [
                48.9268869,
                32.4407293
              ],
              [
                48.926918,
                32.4415637
              ],
              [
                48.9270555,
                32.4438319
              ],
              [
                48.9234047,
                32.4431427
              ],
              [
                48.9200287,
                32.4424557
              ],
              [
                48.9161607,
                32.4414898
              ],
              [
                48.9130555,
                32.4406132
              ],
              [
                48.9093474,
                32.4394649
              ],
              [
                48.9066735,
                32.4384961
              ],
              [
                48.9050903,
                32.4378024
              ],
              [
                48.9037781,
                32.4369734
              ],
              [
                48.9027404,
                32.4364668
              ],
              [
                48.9007188,
                32.4352179
              ],
              [
                48.8988609,
                32.4342963
              ],
              [
                48.8971709,
                32.4336007
              ],
              [
                48.8950426,
                32.4328189
              ],
              [
                48.8930284,
                32.4321742
              ],
              [
                48.8909608,
                32.4319457
              ],
              [
                48.8893281,
                32.4313479
              ],
              [
                48.8878595,
                32.4310256
              ],
              [
                48.885788,
                32.4305197
              ],
              [
                48.8843767,
                32.4303359
              ],
              [
                48.8829079,
                32.4299662
              ],
              [
                48.8813819,
                32.429555
              ],
              [
                48.8805124,
                32.4293217
              ],
              [
                48.8793108,
                32.4287671
              ],
              [
                48.8777315,
                32.4281227
              ],
              [
                48.8764765,
                32.4273823
              ],
              [
                48.8747293,
                32.42646
              ],
              [
                48.873146,
                32.4255382
              ],
              [
                48.8717307,
                32.4250746
              ],
              [
                48.869442,
                32.424107
              ],
              [
                48.8667717,
                32.4228128
              ],
              [
                48.8646469,
                32.4217081
              ],
              [
                48.8621941,
                32.4205504
              ],
              [
                48.8597568,
                32.4193007
              ],
              [
                48.8585967,
                32.4187059
              ],
              [
                48.8557625,
                32.4172711
              ],
              [
                48.8515204,
                32.4156115
              ],
              [
                48.8466795,
                32.4139032
              ],
              [
                48.8441237,
                32.4130298
              ],
              [
                48.842167,
                32.4123808
              ],
              [
                48.8395041,
                32.4119226
              ],
              [
                48.8375472,
                32.4113231
              ],
              [
                48.835373,
                32.4107694
              ],
              [
                48.8346863,
                32.4106451
              ],
              [
                48.8335837,
                32.4104456
              ],
              [
                48.83239,
                32.4104047
              ],
              [
                48.831684,
                32.4104038
              ],
              [
                48.8296241,
                32.4105442
              ],
              [
                48.8274575,
                32.4104528
              ],
              [
                48.8258818,
                32.41027
              ],
              [
                48.8249053,
                32.4102734
              ],
              [
                48.8249816,
                32.4055017
              ],
              [
                48.8249645,
                32.4054007
              ],
              [
                48.8246993,
                32.4038352
              ],
              [
                48.824585,
                32.4028119
              ],
              [
                48.8244171,
                32.4017944
              ],
              [
                48.8238105,
                32.400314
              ],
              [
                48.8233146,
                32.3992051
              ],
              [
                48.8226587,
                32.3980913
              ],
              [
                48.8218347,
                32.3965642
              ],
              [
                48.8211213,
                32.3951766
              ],
              [
                48.8203011,
                32.394017
              ],
              [
                48.8193742,
                32.3928602
              ],
              [
                48.8176309,
                32.3909609
              ],
              [
                48.8165398,
                32.3899928
              ],
              [
                48.8149603,
                32.3885089
              ],
              [
                48.8137091,
                32.3875854
              ],
              [
                48.8126756,
                32.3867535
              ],
              [
                48.8119164,
                32.3863345
              ],
              [
                48.8104476,
                32.3854568
              ],
              [
                48.8093072,
                32.3846253
              ],
              [
                48.8076209,
                32.3834191
              ],
              [
                48.8067512,
                32.3827253
              ],
              [
                48.8059882,
                32.3821258
              ],
              [
                48.8048515,
                32.3815694
              ],
              [
                48.8040351,
                32.3811065
              ],
              [
                48.8025705,
                32.380089
              ],
              [
                48.8014792,
                32.3790711
              ],
              [
                48.8002852,
                32.3780064
              ],
              [
                48.799198,
                32.3768511
              ],
              [
                48.7978362,
                32.3755986
              ],
              [
                48.7963143,
                32.3742553
              ],
              [
                48.7951737,
                32.3733335
              ],
              [
                48.7934381,
                32.3721736
              ],
              [
                48.7919732,
                32.3712055
              ],
              [
                48.7897492,
                32.369816
              ],
              [
                48.7879029,
                32.3686563
              ],
              [
                48.7869836,
                32.3681036
              ],
              [
                48.7857894,
                32.3674536
              ],
              [
                48.7844352,
                32.3667602
              ],
              [
                48.783352,
                32.366067
              ],
              [
                48.782158,
                32.3652343
              ],
              [
                48.7802049,
                32.3643071
              ],
              [
                48.7783662,
                32.3634293
              ],
              [
                48.7772827,
                32.3628736
              ],
              [
                48.7759998,
                32.3622702
              ],
              [
                48.7751161,
                32.3618546
              ],
              [
                48.7726785,
                32.3606527
              ],
              [
                48.7705652,
                32.3594024
              ],
              [
                48.7687226,
                32.3584319
              ],
              [
                48.7676393,
                32.3577386
              ],
              [
                48.76569,
                32.3566714
              ],
              [
                48.7630919,
                32.3554687
              ],
              [
                48.7612,
                32.3544048
              ],
              [
                48.7588729,
                32.353385
              ],
              [
                48.7571411,
                32.3527364
              ],
              [
                48.7555732,
                32.3521381
              ],
              [
                48.7535706,
                32.3516267
              ],
              [
                48.7504349,
                32.3508426
              ],
              [
                48.7492832,
                32.3498774
              ],
              [
                48.7461702,
                32.3471952
              ],
              [
                48.7437096,
                32.3451153
              ],
              [
                48.7408141,
                32.3423376
              ],
              [
                48.737152,
                32.3389172
              ],
              [
                48.7350157,
                32.3365093
              ],
              [
                48.7332689,
                32.334796
              ],
              [
                48.7316779,
                32.3329457
              ],
              [
                48.7292098,
                32.3297088
              ],
              [
                48.7275048,
                32.3268891
              ],
              [
                48.7255783,
                32.3236958
              ],
              [
                48.7240297,
                32.3204573
              ],
              [
                48.722969,
                32.3174982
              ],
              [
                48.7219659,
                32.3149076
              ],
              [
                48.7210771,
                32.3125919
              ],
              [
                48.7204094,
                32.3109746
              ],
              [
                48.7197532,
                32.3100023
              ],
              [
                48.7187158,
                32.3090772
              ],
              [
                48.7170869,
                32.3081053
              ],
              [
                48.7151872,
                32.3069504
              ],
              [
                48.7127992,
                32.3056063
              ],
              [
                48.7085685,
                32.3036199
              ],
              [
                48.7025566,
                32.3009336
              ],
              [
                48.6968651,
                32.2981604
              ],
              [
                48.6935614,
                32.2966775
              ],
              [
                48.6896628,
                32.295197
              ],
              [
                48.6869048,
                32.2943642
              ],
              [
                48.6848527,
                32.2937629
              ],
              [
                48.6829604,
                32.2934419
              ],
              [
                48.6799927,
                32.292747
              ],
              [
                48.6769142,
                32.2921448
              ],
              [
                48.6752929,
                32.2917745
              ],
              [
                48.6729203,
                32.2916834
              ],
              [
                48.6706544,
                32.2914973
              ],
              [
                48.6674688,
                32.2911274
              ],
              [
                48.6649361,
                32.290801
              ],
              [
                48.6615907,
                32.2906646
              ],
              [
                48.6583556,
                32.2905731
              ],
              [
                48.6537705,
                32.2900167
              ],
              [
                48.6490783,
                32.2894627
              ],
              [
                48.6449775,
                32.2890435
              ],
              [
                48.6419564,
                32.2884911
              ],
              [
                48.6406119,
                32.2882315
              ],
              [
                48.6410828,
                32.2868696
              ],
              [
                48.641178,
                32.285575
              ],
              [
                48.641323,
                32.2834472
              ],
              [
                48.641085,
                32.2812448
              ],
              [
                48.6410332,
                32.2807657
              ],
              [
                48.6407396,
                32.2775272
              ],
              [
                48.6402283,
                32.2743793
              ],
              [
                48.6395646,
                32.2720222
              ],
              [
                48.6385157,
                32.2689657
              ],
              [
                48.6362649,
                32.263001
              ],
              [
                48.6345519,
                32.25731
              ],
              [
                48.6340521,
                32.2553663
              ],
              [
                48.6333848,
                32.2525446
              ],
              [
                48.6333734,
                32.2510181
              ],
              [
                48.6337061,
                32.2496603
              ],
              [
                48.6347051,
                32.2483376
              ],
              [
                48.636501,
                32.2467299
              ],
              [
                48.6375839,
                32.2455576
              ],
              [
                48.6383296,
                32.2438581
              ],
              [
                48.63829,
                32.2419928
              ],
              [
                48.6376137,
                32.241013
              ],
              [
                48.6362571,
                32.2397498
              ],
              [
                48.6350592,
                32.2389631
              ],
              [
                48.6336976,
                32.2381778
              ],
              [
                48.6312486,
                32.2372549
              ],
              [
                48.6264648,
                32.2355013
              ],
              [
                48.6226578,
                32.2337906
              ],
              [
                48.6103706,
                32.2289055
              ],
              [
                48.6099927,
                32.2288307
              ],
              [
                48.60532,
                32.227146
              ],
              [
                48.6021713,
                32.2258866
              ],
              [
                48.600811,
                32.2253425
              ],
              [
                48.5956993,
                32.2228059
              ],
              [
                48.5889054,
                32.2192947
              ],
              [
                48.5822754,
                32.2157817
              ],
              [
                48.5819182,
                32.2114072
              ],
              [
                48.5819169,
                32.2113921
              ],
              [
                48.5810929,
                32.2017293
              ],
              [
                48.5798836,
                32.191651
              ],
              [
                48.579113,
                32.1820794
              ],
              [
                48.5770065,
                32.1894072
              ],
              [
                48.5785389,
                32.1818964
              ],
              [
                48.5759173,
                32.1715344
              ],
              [
                48.5738677,
                32.1632022
              ],
              [
                48.5747926,
                32.1515668
              ],
              [
                48.573555,
                32.1457432
              ],
              [
                48.5723532,
                32.1394273
              ],
              [
                48.5708787,
                32.1320908
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 13073995,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کرخه",
          "ref:sci": "0628",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.0110261,
                31.9590117
              ],
              [
                48.0169066,
                31.9523103
              ],
              [
                48.0247163,
                31.9425452
              ],
              [
                48.0353492,
                31.9305635
              ],
              [
                48.0471652,
                31.9163755
              ],
              [
                48.0573861,
                31.9046224
              ],
              [
                48.068189,
                31.8841487
              ],
              [
                48.0820515,
                31.8617832
              ],
              [
                48.0973622,
                31.833579
              ],
              [
                48.1075539,
                31.8161667
              ],
              [
                48.1141931,
                31.804492
              ],
              [
                48.120315,
                31.7941781
              ],
              [
                48.1300446,
                31.7848198
              ],
              [
                48.1572188,
                31.7851069
              ],
              [
                48.1695554,
                31.783809
              ],
              [
                48.1818404,
                31.7826128
              ],
              [
                48.2015387,
                31.7765477
              ],
              [
                48.2189827,
                31.7681094
              ],
              [
                48.2318164,
                31.7484302
              ],
              [
                48.2433576,
                31.7312515
              ],
              [
                48.2506645,
                31.7209062
              ],
              [
                48.2538423,
                31.7132598
              ],
              [
                48.2596755,
                31.6997189
              ],
              [
                48.2614732,
                31.6948928
              ],
              [
                48.263773,
                31.68501
              ],
              [
                48.2666629,
                31.6695123
              ],
              [
                48.265604,
                31.6600805
              ],
              [
                48.2758578,
                31.6646692
              ],
              [
                48.3012542,
                31.669774
              ],
              [
                48.3084461,
                31.6712195
              ],
              [
                48.3264621,
                31.6743996
              ],
              [
                48.341924,
                31.6771515
              ],
              [
                48.3678525,
                31.6816091
              ],
              [
                48.3990256,
                31.6870536
              ],
              [
                48.4287692,
                31.6922308
              ],
              [
                48.4639223,
                31.6985141
              ],
              [
                48.4766985,
                31.7009592
              ],
              [
                48.4979442,
                31.7048451
              ],
              [
                48.4994667,
                31.7064348
              ],
              [
                48.4993292,
                31.7092353
              ],
              [
                48.4999078,
                31.7149793
              ],
              [
                48.5011751,
                31.7176105
              ],
              [
                48.5025063,
                31.7205991
              ],
              [
                48.5035132,
                31.7236738
              ],
              [
                48.5052185,
                31.7271184
              ],
              [
                48.5069235,
                31.7300602
              ],
              [
                48.509327,
                31.7330044
              ],
              [
                48.5120505,
                31.7360855
              ],
              [
                48.513813,
                31.7372833
              ],
              [
                48.5156326,
                31.7391247
              ],
              [
                48.5178756,
                31.7410105
              ],
              [
                48.5184631,
                31.7414255
              ],
              [
                48.519268,
                31.7417478
              ],
              [
                48.5202331,
                31.7420281
              ],
              [
                48.5215723,
                31.7420316
              ],
              [
                48.5305747,
                31.7418706
              ],
              [
                48.5350265,
                31.7417471
              ],
              [
                48.5384663,
                31.741587
              ],
              [
                48.5394133,
                31.7415429
              ],
              [
                48.5471382,
                31.7411828
              ],
              [
                48.5540543,
                31.7409258
              ],
              [
                48.5622558,
                31.74095
              ],
              [
                48.5684737,
                31.7408299
              ],
              [
                48.5761909,
                31.7409882
              ],
              [
                48.5834235,
                31.7409611
              ],
              [
                48.5883026,
                31.7409296
              ],
              [
                48.5909454,
                31.7409112
              ],
              [
                48.6051727,
                31.7358619
              ],
              [
                48.6070137,
                31.7368106
              ],
              [
                48.61711,
                31.7414304
              ],
              [
                48.6306624,
                31.745648
              ],
              [
                48.6355228,
                31.7470796
              ],
              [
                48.6519778,
                31.7499383
              ],
              [
                48.654738,
                31.7528294
              ],
              [
                48.6554464,
                31.7569221
              ],
              [
                48.6558737,
                31.7590793
              ],
              [
                48.6569775,
                31.7657027
              ],
              [
                48.6573693,
                31.7676782
              ],
              [
                48.6541725,
                31.7705112
              ],
              [
                48.6524124,
                31.7719664
              ],
              [
                48.6436273,
                31.7749278
              ],
              [
                48.6412434,
                31.7808153
              ],
              [
                48.6426305,
                31.7824388
              ],
              [
                48.644074,
                31.7841236
              ],
              [
                48.6463059,
                31.7866875
              ],
              [
                48.6476413,
                31.790986
              ],
              [
                48.6490238,
                31.7953989
              ],
              [
                48.6457316,
                31.8014395
              ],
              [
                48.6426075,
                31.8071341
              ],
              [
                48.6379853,
                31.8096539
              ],
              [
                48.6335246,
                31.8120793
              ],
              [
                48.6330733,
                31.8171932
              ],
              [
                48.6366532,
                31.8186324
              ],
              [
                48.6444176,
                31.8197999
              ],
              [
                48.6479004,
                31.8202898
              ],
              [
                48.6559267,
                31.8211871
              ],
              [
                48.657352,
                31.8221491
              ],
              [
                48.6595508,
                31.8235749
              ],
              [
                48.6604938,
                31.8264189
              ],
              [
                48.6623134,
                31.8320701
              ],
              [
                48.6591873,
                31.8392732
              ],
              [
                48.6550358,
                31.8410504
              ],
              [
                48.6485012,
                31.8439161
              ],
              [
                48.6359316,
                31.8500067
              ],
              [
                48.6278279,
                31.856532
              ],
              [
                48.6269689,
                31.8619613
              ],
              [
                48.6346793,
                31.8630936
              ],
              [
                48.6378815,
                31.8592606
              ],
              [
                48.6416877,
                31.8515309
              ],
              [
                48.6471965,
                31.8507332
              ],
              [
                48.647194,
                31.8582194
              ],
              [
                48.6472528,
                31.8625488
              ],
              [
                48.6502166,
                31.8695528
              ],
              [
                48.6532386,
                31.875264
              ],
              [
                48.6546964,
                31.8780594
              ],
              [
                48.6545383,
                31.8808038
              ],
              [
                48.65131,
                31.882727
              ],
              [
                48.6474735,
                31.8875814
              ],
              [
                48.6436531,
                31.8901629
              ],
              [
                48.6300913,
                31.8874673
              ],
              [
                48.6306463,
                31.8834995
              ],
              [
                48.6361056,
                31.8781567
              ],
              [
                48.636488,
                31.8743607
              ],
              [
                48.631532,
                31.8756027
              ],
              [
                48.6247531,
                31.8833256
              ],
              [
                48.6169789,
                31.8849115
              ],
              [
                48.6044575,
                31.8923071
              ],
              [
                48.6059181,
                31.8998993
              ],
              [
                48.6065472,
                31.9044196
              ],
              [
                48.615574,
                31.9122251
              ],
              [
                48.6159314,
                31.9172175
              ],
              [
                48.6070049,
                31.9213074
              ],
              [
                48.5945703,
                31.91881
              ],
              [
                48.5868748,
                31.918281
              ],
              [
                48.5778031,
                31.9204551
              ],
              [
                48.5678798,
                31.9302424
              ],
              [
                48.5658891,
                31.9349488
              ],
              [
                48.5637292,
                31.9393681
              ],
              [
                48.5606175,
                31.9465105
              ],
              [
                48.5642357,
                31.9490909
              ],
              [
                48.5724147,
                31.9508567
              ],
              [
                48.5780756,
                31.9539924
              ],
              [
                48.5842756,
                31.9573578
              ],
              [
                48.558844,
                31.9713495
              ],
              [
                48.5148299,
                31.9894295
              ],
              [
                48.4713695,
                32.0098533
              ],
              [
                48.4536802,
                32.0432715
              ],
              [
                48.438571,
                32.0434143
              ],
              [
                48.415351,
                32.0441895
              ],
              [
                48.4046306,
                32.0482959
              ],
              [
                48.3611962,
                32.0543823
              ],
              [
                48.3517275,
                32.0656633
              ],
              [
                48.3477478,
                32.0667585
              ],
              [
                48.3361282,
                32.0696709
              ],
              [
                48.325714,
                32.0724096
              ],
              [
                48.3148537,
                32.075138
              ],
              [
                48.3019018,
                32.0850404
              ],
              [
                48.2926455,
                32.0807895
              ],
              [
                48.2885779,
                32.0713112
              ],
              [
                48.2862991,
                32.0659705
              ],
              [
                48.2834239,
                32.0595928
              ],
              [
                48.2810517,
                32.0540071
              ],
              [
                48.2662171,
                32.0486546
              ],
              [
                48.2567749,
                32.0499548
              ],
              [
                48.2468968,
                32.0513079
              ],
              [
                48.2359073,
                32.0492054
              ],
              [
                48.2315013,
                32.0473854
              ],
              [
                48.2317969,
                32.0461504
              ],
              [
                48.2323479,
                32.0428222
              ],
              [
                48.2310404,
                32.0359347
              ],
              [
                48.2335286,
                32.0318009
              ],
              [
                48.2324272,
                32.028839
              ],
              [
                48.2327255,
                32.0249699
              ],
              [
                48.2375276,
                32.0233328
              ],
              [
                48.2403731,
                32.0222395
              ],
              [
                48.2450978,
                32.0230291
              ],
              [
                48.2461092,
                32.0199676
              ],
              [
                48.2470784,
                32.0171021
              ],
              [
                48.2496748,
                32.0154889
              ],
              [
                48.2554619,
                32.0119027
              ],
              [
                48.2594967,
                32.0094167
              ],
              [
                48.2621562,
                32.0085581
              ],
              [
                48.2664602,
                32.0068123
              ],
              [
                48.2701981,
                32.0080382
              ],
              [
                48.2739449,
                32.0092457
              ],
              [
                48.2762356,
                32.0086007
              ],
              [
                48.2760254,
                32.0057465
              ],
              [
                48.2757408,
                32.0013822
              ],
              [
                48.2745398,
                31.9994284
              ],
              [
                48.272997,
                31.9982149
              ],
              [
                48.2688429,
                31.9935526
              ],
              [
                48.2658914,
                31.9916251
              ],
              [
                48.2627366,
                31.9896459
              ],
              [
                48.2603965,
                31.9881893
              ],
              [
                48.2590225,
                31.9867925
              ],
              [
                48.261839,
                31.9826345
              ],
              [
                48.2613636,
                31.9778676
              ],
              [
                48.2556595,
                31.9771149
              ],
              [
                48.2498592,
                31.9778766
              ],
              [
                48.2472528,
                31.9733417
              ],
              [
                48.2518742,
                31.9675431
              ],
              [
                48.2484253,
                31.9617574
              ],
              [
                48.2488738,
                31.9606002
              ],
              [
                48.2577582,
                31.9619024
              ],
              [
                48.26315,
                31.965771
              ],
              [
                48.2671398,
                31.9667571
              ],
              [
                48.2701751,
                31.9625526
              ],
              [
                48.2698378,
                31.9579651
              ],
              [
                48.2592648,
                31.9469182
              ],
              [
                48.2490366,
                31.9439835
              ],
              [
                48.2494461,
                31.9421076
              ],
              [
                48.2633943,
                31.9412271
              ],
              [
                48.2652243,
                31.9351565
              ],
              [
                48.2605524,
                31.9284008
              ],
              [
                48.2592508,
                31.9253643
              ],
              [
                48.2562716,
                31.919198
              ],
              [
                48.2522318,
                31.9155532
              ],
              [
                48.2454092,
                31.9160906
              ],
              [
                48.2433647,
                31.915835
              ],
              [
                48.2444319,
                31.914356
              ],
              [
                48.252213,
                31.913156
              ],
              [
                48.250299,
                31.9110285
              ],
              [
                48.2381664,
                31.9100882
              ],
              [
                48.2225013,
                31.9091856
              ],
              [
                48.1987169,
                31.9183073
              ],
              [
                48.1855146,
                31.924263
              ],
              [
                48.1557853,
                31.9380385
              ],
              [
                48.1277016,
                31.9502993
              ],
              [
                48.1083401,
                31.959473
              ],
              [
                48.0910915,
                31.9658029
              ],
              [
                48.068002,
                31.9681809
              ],
              [
                48.0512296,
                31.9672694
              ],
              [
                48.0425239,
                31.9658378
              ],
              [
                48.0261013,
                31.962978
              ],
              [
                48.0110261,
                31.9590117
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14485001,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دزپارت",
          "ref:sci": "0629",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.0037344,
                31.7140153
              ],
              [
                50.0097379,
                31.702802
              ],
              [
                50.0167818,
                31.6896065
              ],
              [
                50.0220527,
                31.6790168
              ],
              [
                50.0263671,
                31.670265
              ],
              [
                50.0291157,
                31.6645763
              ],
              [
                50.0305318,
                31.6588804
              ],
              [
                50.0330695,
                31.6496991
              ],
              [
                50.040743,
                31.6333592
              ],
              [
                50.0469741,
                31.620216
              ],
              [
                50.060732,
                31.5904474
              ],
              [
                50.0730277,
                31.5705404
              ],
              [
                50.07792,
                31.5623552
              ],
              [
                50.0816079,
                31.5571465
              ],
              [
                50.089156,
                31.546218
              ],
              [
                50.0938958,
                31.5390191
              ],
              [
                50.1228319,
                31.5125236
              ],
              [
                50.1274357,
                31.5084913
              ],
              [
                50.1317867,
                31.503473
              ],
              [
                50.1365272,
                31.4985521
              ],
              [
                50.1479784,
                31.4893443
              ],
              [
                50.1792884,
                31.4747048
              ],
              [
                50.1861143,
                31.4703752
              ],
              [
                50.189251,
                31.4686365
              ],
              [
                50.1899665,
                31.467941
              ],
              [
                50.1997263,
                31.4616991
              ],
              [
                50.2010575,
                31.458845
              ],
              [
                50.2036667,
                31.455708
              ],
              [
                50.2053185,
                31.4541371
              ],
              [
                50.2129705,
                31.4343179
              ],
              [
                50.2236915,
                31.4162242
              ],
              [
                50.234202,
                31.4017872
              ],
              [
                50.2368137,
                31.4082167
              ],
              [
                50.2607013,
                31.42384
              ],
              [
                50.272572,
                31.4314116
              ],
              [
                50.2906772,
                31.4405047
              ],
              [
                50.3009213,
                31.4456747
              ],
              [
                50.3078535,
                31.450065
              ],
              [
                50.3189523,
                31.4572918
              ],
              [
                50.3233738,
                31.4601098
              ],
              [
                50.3350126,
                31.4733068
              ],
              [
                50.3478221,
                31.4920615
              ],
              [
                50.3495668,
                31.4989908
              ],
              [
                50.3490391,
                31.5029313
              ],
              [
                50.3519581,
                31.5125104
              ],
              [
                50.3613097,
                31.5302529
              ],
              [
                50.3637172,
                31.5350593
              ],
              [
                50.3662024,
                31.5403525
              ],
              [
                50.3694927,
                31.5468553
              ],
              [
                50.3692391,
                31.5500495
              ],
              [
                50.3622079,
                31.5498707
              ],
              [
                50.3612668,
                31.5520873
              ],
              [
                50.363045,
                31.5571383
              ],
              [
                50.3632014,
                31.5576644
              ],
              [
                50.3631932,
                31.5581894
              ],
              [
                50.3649115,
                31.5618989
              ],
              [
                50.3702234,
                31.5696634
              ],
              [
                50.3749127,
                31.5681997
              ],
              [
                50.3781561,
                31.5684996
              ],
              [
                50.3808016,
                31.5688514
              ],
              [
                50.3831806,
                31.5740522
              ],
              [
                50.3843071,
                31.5795029
              ],
              [
                50.3873748,
                31.5836988
              ],
              [
                50.3916923,
                31.5885383
              ],
              [
                50.3948177,
                31.5928883
              ],
              [
                50.3938986,
                31.5949796
              ],
              [
                50.3934777,
                31.5960909
              ],
              [
                50.396157,
                31.5971395
              ],
              [
                50.4007967,
                31.5982059
              ],
              [
                50.4056058,
                31.5956991
              ],
              [
                50.4106532,
                31.6005631
              ],
              [
                50.4168909,
                31.6043103
              ],
              [
                50.4279251,
                31.6109122
              ],
              [
                50.441513,
                31.6189189
              ],
              [
                50.4096387,
                31.6550502
              ],
              [
                50.4056337,
                31.6650457
              ],
              [
                50.3944141,
                31.676361
              ],
              [
                50.387064,
                31.686168
              ],
              [
                50.3835957,
                31.6939611
              ],
              [
                50.3832816,
                31.7030614
              ],
              [
                50.3858906,
                31.7159837
              ],
              [
                50.3868137,
                31.7301895
              ],
              [
                50.3512564,
                31.7570168
              ],
              [
                50.3232211,
                31.77797
              ],
              [
                50.3214341,
                31.7917363
              ],
              [
                50.3077107,
                31.8060296
              ],
              [
                50.3118202,
                31.8196353
              ],
              [
                50.3126157,
                31.8222215
              ],
              [
                50.3081556,
                31.826769
              ],
              [
                50.3014001,
                31.8343512
              ],
              [
                50.2967343,
                31.8391379
              ],
              [
                50.2923275,
                31.8439207
              ],
              [
                50.2859096,
                31.8445838
              ],
              [
                50.2850119,
                31.8484667
              ],
              [
                50.2841049,
                31.8524667
              ],
              [
                50.2792148,
                31.8509172
              ],
              [
                50.2790087,
                31.8526348
              ],
              [
                50.2782641,
                31.8577355
              ],
              [
                50.2815276,
                31.8588175
              ],
              [
                50.2848089,
                31.8608721
              ],
              [
                50.2891691,
                31.86344
              ],
              [
                50.2881296,
                31.8661445
              ],
              [
                50.2862618,
                31.8683982
              ],
              [
                50.2835757,
                31.8721109
              ],
              [
                50.2825244,
                31.8761586
              ],
              [
                50.281511,
                31.8803941
              ],
              [
                50.2741246,
                31.8871328
              ],
              [
                50.2674633,
                31.8918215
              ],
              [
                50.2597861,
                31.8972734
              ],
              [
                50.2563841,
                31.901378
              ],
              [
                50.2526596,
                31.9057781
              ],
              [
                50.2526574,
                31.9130624
              ],
              [
                50.2468437,
                31.9175632
              ],
              [
                50.2426374,
                31.9214044
              ],
              [
                50.2417223,
                31.9251826
              ],
              [
                50.2307377,
                31.922802
              ],
              [
                50.2185152,
                31.9203501
              ],
              [
                50.2131495,
                31.9190734
              ],
              [
                50.1946154,
                31.9154409
              ],
              [
                50.1784204,
                31.9124488
              ],
              [
                50.1683654,
                31.910996
              ],
              [
                50.156019,
                31.9087748
              ],
              [
                50.148592,
                31.9075459
              ],
              [
                50.1351995,
                31.9051619
              ],
              [
                50.110429,
                31.9011438
              ],
              [
                50.0935993,
                31.8984011
              ],
              [
                50.0820983,
                31.8963046
              ],
              [
                50.0679021,
                31.8936409
              ],
              [
                50.0546531,
                31.8884082
              ],
              [
                50.0494209,
                31.8845598
              ],
              [
                50.055025,
                31.8803214
              ],
              [
                50.054102,
                31.8782372
              ],
              [
                50.0525477,
                31.8756973
              ],
              [
                50.0490704,
                31.8698815
              ],
              [
                50.0515966,
                31.8669364
              ],
              [
                50.058147,
                31.8629133
              ],
              [
                50.0648183,
                31.8545292
              ],
              [
                50.0686601,
                31.8484178
              ],
              [
                50.0732505,
                31.8464388
              ],
              [
                50.0758385,
                31.8424582
              ],
              [
                50.0774291,
                31.8350333
              ],
              [
                50.0810591,
                31.826453
              ],
              [
                50.0727719,
                31.8217409
              ],
              [
                50.0651782,
                31.8164667
              ],
              [
                50.0578754,
                31.8120634
              ],
              [
                50.0546498,
                31.8020046
              ],
              [
                50.0511913,
                31.7882935
              ],
              [
                50.0486509,
                31.7775643
              ],
              [
                50.0455943,
                31.7670942
              ],
              [
                50.0436565,
                31.7595204
              ],
              [
                50.0412607,
                31.752215
              ],
              [
                50.0383766,
                31.7422319
              ],
              [
                50.0365791,
                31.7378787
              ],
              [
                50.0358201,
                31.7354484
              ],
              [
                50.0310506,
                31.7264516
              ],
              [
                50.0257244,
                31.7246229
              ],
              [
                50.0198659,
                31.7229669
              ],
              [
                50.0037344,
                31.7140153
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 8387045450
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          48.6563167,
          31.2397079
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5922679170
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          48.851281,
          32.0492034
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32827436
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.3013154,
          31.9461316
        ]
      }
    }
  ]
},
"زنجان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554868,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ابهر",
          "name:en": "Abhar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q374413",
          "wikipedia": "en:Abhar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.8499037,
                35.9698378
              ],
              [
                48.8450036,
                35.9344009
              ],
              [
                48.8563827,
                35.9447618
              ],
              [
                48.8676456,
                35.9603298
              ],
              [
                48.8864978,
                35.9704722
              ],
              [
                48.9008541,
                35.9714417
              ],
              [
                48.9115106,
                35.957416
              ],
              [
                48.9417549,
                35.936653
              ],
              [
                48.9600912,
                35.9244323
              ],
              [
                48.9603682,
                35.9241529
              ],
              [
                48.9609248,
                35.9238735
              ],
              [
                48.9748145,
                35.9197097
              ],
              [
                48.978981,
                35.9188716
              ],
              [
                48.9809245,
                35.9188716
              ],
              [
                48.9825379,
                35.9116458
              ],
              [
                48.9839278,
                35.9113665
              ],
              [
                48.9867044,
                35.9113665
              ],
              [
                48.9919843,
                35.9102579
              ],
              [
                49.0078174,
                35.9044263
              ],
              [
                49.0307004,
                35.881905
              ],
              [
                49.0357005,
                35.875243
              ],
              [
                49.0357004,
                35.8749545
              ],
              [
                49.0362536,
                35.8746841
              ],
              [
                49.0415338,
                35.8702397
              ],
              [
                49.0540338,
                35.8657954
              ],
              [
                49.0570905,
                35.8657954
              ],
              [
                49.0579236,
                35.8655161
              ],
              [
                49.0615335,
                35.865516
              ],
              [
                49.0623667,
                35.8657955
              ],
              [
                49.0645902,
                35.8657955
              ],
              [
                49.06598,
                35.866066
              ],
              [
                49.0665336,
                35.8663543
              ],
              [
                49.0673668,
                35.8663544
              ],
              [
                49.07959,
                35.872187
              ],
              [
                49.0807034,
                35.8732959
              ],
              [
                49.0823698,
                35.8741252
              ],
              [
                49.0839388,
                35.8760101
              ],
              [
                49.0851465,
                35.8774608
              ],
              [
                49.085423,
                35.8782902
              ],
              [
                49.0862743,
                35.8890786
              ],
              [
                49.0854238,
                35.8913505
              ],
              [
                49.085423,
                35.8913526
              ],
              [
                49.0978696,
                35.9163777
              ],
              [
                49.0970363,
                35.916657
              ],
              [
                49.093423,
                35.9235965
              ],
              [
                49.093146,
                35.9255432
              ],
              [
                49.098146,
                35.931374
              ],
              [
                49.1186564,
                35.9324755
              ],
              [
                49.1208796,
                35.932205
              ],
              [
                49.1217128,
                35.9319256
              ],
              [
                49.1230995,
                35.9319257
              ],
              [
                49.1233795,
                35.9316463
              ],
              [
                49.1244894,
                35.9316463
              ],
              [
                49.1247664,
                35.9313668
              ],
              [
                49.1314361,
                35.9313669
              ],
              [
                49.1353228,
                35.9308171
              ],
              [
                49.1358794,
                35.9305377
              ],
              [
                49.1375459,
                35.9305376
              ],
              [
                49.1378224,
                35.9302582
              ],
              [
                49.1406026,
                35.9302582
              ],
              [
                49.1411561,
                35.9299789
              ],
              [
                49.1464359,
                35.9299788
              ],
              [
                49.1475458,
                35.9296995
              ],
              [
                49.1506025,
                35.9296995
              ],
              [
                49.1517126,
                35.9299788
              ],
              [
                49.1517127,
                35.9305377
              ],
              [
                49.1525458,
                35.9324755
              ],
              [
                49.1636589,
                35.9391451
              ],
              [
                49.163659,
                35.9394244
              ],
              [
                49.1739357,
                35.9516459
              ],
              [
                49.1808823,
                35.9555394
              ],
              [
                49.1817156,
                35.9555395
              ],
              [
                49.1861585,
                35.958036
              ],
              [
                49.2110478,
                35.9726679
              ],
              [
                49.2458848,
                35.9749799
              ],
              [
                49.2583847,
                35.9722041
              ],
              [
                49.2592179,
                35.9719247
              ],
              [
                49.2625511,
                35.9719247
              ],
              [
                49.3006554,
                35.9569164
              ],
              [
                49.3017656,
                35.9571959
              ],
              [
                49.3031555,
                35.9571959
              ],
              [
                49.3039887,
                35.9574753
              ],
              [
                49.3053786,
                35.9574753
              ],
              [
                49.3131553,
                35.9597019
              ],
              [
                49.3361667,
                35.9966461
              ],
              [
                49.3431102,
                35.9988722
              ],
              [
                49.3388406,
                36.0131753
              ],
              [
                49.3468935,
                36.0190057
              ],
              [
                49.3477271,
                36.0203934
              ],
              [
                49.3477271,
                36.0206728
              ],
              [
                49.3477271,
                36.0215108
              ],
              [
                49.3931127,
                36.0405444
              ],
              [
                49.3978359,
                36.0463661
              ],
              [
                49.4068258,
                36.0541541
              ],
              [
                49.4162689,
                36.072205
              ],
              [
                49.4196022,
                36.0938781
              ],
              [
                49.4193257,
                36.0944278
              ],
              [
                49.4184924,
                36.1002673
              ],
              [
                49.4165489,
                36.1149919
              ],
              [
                49.416549,
                36.1211017
              ],
              [
                49.4157157,
                36.1235977
              ],
              [
                49.4157156,
                36.1238771
              ],
              [
                49.4151591,
                36.1263733
              ],
              [
                49.415159,
                36.1308158
              ],
              [
                49.4148821,
                36.1316539
              ],
              [
                49.4146024,
                36.1333209
              ],
              [
                49.4143254,
                36.134988
              ],
              [
                49.4168254,
                36.1449903
              ],
              [
                49.4246021,
                36.1580472
              ],
              [
                49.432382,
                36.1716536
              ],
              [
                49.4336719,
                36.1930405
              ],
              [
                49.4333917,
                36.1941488
              ],
              [
                49.4331153,
                36.1944371
              ],
              [
                49.4328386,
                36.1955453
              ],
              [
                49.4317253,
                36.196933
              ],
              [
                49.4317253,
                36.1972123
              ],
              [
                49.4317254,
                36.1974916
              ],
              [
                49.4264486,
                36.2038709
              ],
              [
                49.4231153,
                36.2077634
              ],
              [
                49.4142804,
                36.2116728
              ],
              [
                49.4005726,
                36.2206729
              ],
              [
                49.4036687,
                36.2480471
              ],
              [
                49.4091223,
                36.2738951
              ],
              [
                49.4177498,
                36.2902789
              ],
              [
                49.4167251,
                36.3077621
              ],
              [
                49.4175583,
                36.3086
              ],
              [
                49.4154036,
                36.3240319
              ],
              [
                49.376897,
                36.34579
              ],
              [
                49.3461655,
                36.3797152
              ],
              [
                49.3444992,
                36.3852644
              ],
              [
                49.3408892,
                36.388048
              ],
              [
                49.3369993,
                36.3894352
              ],
              [
                49.3065477,
                36.394258
              ],
              [
                49.3048813,
                36.3914748
              ],
              [
                49.3031096,
                36.3786072
              ],
              [
                49.2925532,
                36.3533292
              ],
              [
                49.2886632,
                36.3491581
              ],
              [
                49.2883868,
                36.3485995
              ],
              [
                49.2514402,
                36.3180503
              ],
              [
                49.248107,
                36.3169332
              ],
              [
                49.2467171,
                36.3099871
              ],
              [
                49.2464406,
                36.3091583
              ],
              [
                49.2464406,
                36.308879
              ],
              [
                49.2450502,
                36.3033203
              ],
              [
                49.2447738,
                36.3027708
              ],
              [
                49.2456069,
                36.299158
              ],
              [
                49.2492172,
                36.2911037
              ],
              [
                49.2493958,
                36.2908349
              ],
              [
                49.2533836,
                36.2852656
              ],
              [
                49.2539404,
                36.2841575
              ],
              [
                49.2617172,
                36.2716523
              ],
              [
                49.2706069,
                36.2491551
              ],
              [
                49.2722737,
                36.2369287
              ],
              [
                49.2722737,
                36.2313786
              ],
              [
                49.2714405,
                36.2249905
              ],
              [
                49.2661639,
                36.2105382
              ],
              [
                49.2531074,
                36.1930402
              ],
              [
                49.2528273,
                36.1927609
              ],
              [
                49.2481073,
                36.1880394
              ],
              [
                49.2458842,
                36.1860931
              ],
              [
                49.2292175,
                36.1785964
              ],
              [
                49.228102,
                36.1788114
              ],
              [
                49.2148478,
                36.1760321
              ],
              [
                49.1916376,
                36.1746003
              ],
              [
                49.1633037,
                36.1764095
              ],
              [
                49.1604831,
                36.1699846
              ],
              [
                49.1627371,
                36.160767
              ],
              [
                49.1620107,
                36.1598198
              ],
              [
                49.1601493,
                36.1573927
              ],
              [
                49.1502261,
                36.1581671
              ],
              [
                49.1267278,
                36.1618672
              ],
              [
                49.1054905,
                36.1650536
              ],
              [
                49.104209,
                36.1644315
              ],
              [
                49.1033758,
                36.1644315
              ],
              [
                49.0594862,
                36.167486
              ],
              [
                49.0480965,
                36.167486
              ],
              [
                49.0478199,
                36.1677652
              ],
              [
                49.0425397,
                36.1677652
              ],
              [
                49.0414299,
                36.167486
              ],
              [
                49.0383731,
                36.167486
              ],
              [
                49.0367063,
                36.1672067
              ],
              [
                49.0361533,
                36.167486
              ],
              [
                49.0390746,
                36.1773246
              ],
              [
                49.0338195,
                36.177396
              ],
              [
                49.0275324,
                36.1768418
              ],
              [
                49.0233323,
                36.1770518
              ],
              [
                49.0160287,
                36.1782227
              ],
              [
                49.0054123,
                36.1787872
              ],
              [
                49.0020674,
                36.1810734
              ],
              [
                48.9960211,
                36.1802443
              ],
              [
                48.9847162,
                36.183431
              ],
              [
                48.9794579,
                36.184611
              ],
              [
                48.9737324,
                36.1862735
              ],
              [
                48.9676139,
                36.1873881
              ],
              [
                48.963664,
                36.1885718
              ],
              [
                48.9562168,
                36.1914183
              ],
              [
                48.9513135,
                36.1926067
              ],
              [
                48.9414204,
                36.1944009
              ],
              [
                48.9349004,
                36.1973341
              ],
              [
                48.9322838,
                36.1953122
              ],
              [
                48.9288646,
                36.1894829
              ],
              [
                48.9209174,
                36.1741884
              ],
              [
                48.9163684,
                36.1650423
              ],
              [
                48.9158096,
                36.1582402
              ],
              [
                48.9177371,
                36.1499112
              ],
              [
                48.9196696,
                36.1449831
              ],
              [
                48.9201879,
                36.143004
              ],
              [
                48.9210462,
                36.1417564
              ],
              [
                48.9217329,
                36.1353793
              ],
              [
                48.9208316,
                36.1339929
              ],
              [
                48.9212608,
                36.1324678
              ],
              [
                48.9205741,
                36.1311161
              ],
              [
                48.9208746,
                36.1292097
              ],
              [
                48.9198017,
                36.1281005
              ],
              [
                48.9202308,
                36.1267833
              ],
              [
                48.9190721,
                36.1249808
              ],
              [
                48.9212823,
                36.1238368
              ],
              [
                48.9263356,
                36.1249547
              ],
              [
                48.9286637,
                36.1251714
              ],
              [
                48.9302248,
                36.1250241
              ],
              [
                48.9314479,
                36.1250717
              ],
              [
                48.9331537,
                36.1247121
              ],
              [
                48.9330947,
                36.1244348
              ],
              [
                48.9349025,
                36.1239408
              ],
              [
                48.937161,
                36.1240101
              ],
              [
                48.9368606,
                36.1235595
              ],
              [
                48.9370536,
                36.1234902
              ],
              [
                48.9393711,
                36.1234555
              ],
              [
                48.9423752,
                36.1201969
              ],
              [
                48.9440274,
                36.1176143
              ],
              [
                48.9454221,
                36.1131247
              ],
              [
                48.9460229,
                36.1084789
              ],
              [
                48.9465379,
                36.103382
              ],
              [
                48.9466238,
                36.0979034
              ],
              [
                48.9461517,
                36.0843439
              ],
              [
                48.9446926,
                36.0745282
              ],
              [
                48.9441776,
                36.0685619
              ],
              [
                48.9440059,
                36.0594382
              ],
              [
                48.9409654,
                36.0535877
              ],
              [
                48.9364581,
                36.0493437
              ],
              [
                48.9290713,
                36.0434778
              ],
              [
                48.9169692,
                36.0363987
              ],
              [
                48.913021,
                36.032373
              ],
              [
                48.9088153,
                36.0261259
              ],
              [
                48.9040088,
                36.0172402
              ],
              [
                48.8792037,
                35.9918272
              ],
              [
                48.8651275,
                35.983146
              ],
              [
                48.8554286,
                35.9759225
              ],
              [
                48.851839,
                35.9722517
              ],
              [
                48.8499037,
                35.9698378
              ]
            ]
          ],
          [
            [
              [
                48.8616943,
                36.2667674
              ],
              [
                48.8638376,
                36.2599809
              ],
              [
                48.8792036,
                36.2614387
              ],
              [
                48.8916885,
                36.2594964
              ],
              [
                48.9006922,
                36.2562435
              ],
              [
                48.906653,
                36.253334
              ],
              [
                48.9128113,
                36.2501502
              ],
              [
                48.9184093,
                36.2463406
              ],
              [
                48.9259169,
                36.2407548
              ],
              [
                48.9298511,
                36.2372713
              ],
              [
                48.9318609,
                36.2349968
              ],
              [
                48.9347434,
                36.2343935
              ],
              [
                48.9442043,
                36.2369281
              ],
              [
                48.9442043,
                36.2372075
              ],
              [
                48.9455905,
                36.2372075
              ],
              [
                48.9458707,
                36.2374867
              ],
              [
                48.9467042,
                36.2374867
              ],
              [
                48.9494804,
                36.238604
              ],
              [
                48.9508708,
                36.238604
              ],
              [
                48.9567041,
                36.2399825
              ],
              [
                48.9572607,
                36.2402618
              ],
              [
                48.958647,
                36.2402619
              ],
              [
                48.9594807,
                36.2405412
              ],
              [
                48.9628139,
                36.2405411
              ],
              [
                48.9633706,
                36.2408204
              ],
              [
                48.9653136,
                36.2408205
              ],
              [
                48.9655937,
                36.2410998
              ],
              [
                48.9669804,
                36.2410997
              ],
              [
                48.9758705,
                36.2433162
              ],
              [
                48.9769838,
                36.2433162
              ],
              [
                48.9775369,
                36.2435955
              ],
              [
                48.9853168,
                36.2435955
              ],
              [
                48.9855937,
                36.2433162
              ],
              [
                48.9894837,
                36.2433162
              ],
              [
                48.9900368,
                36.2430369
              ],
              [
                48.9914267,
                36.2430369
              ],
              [
                48.9919834,
                36.2433163
              ],
              [
                48.9942068,
                36.2433162
              ],
              [
                48.9944834,
                36.2435955
              ],
              [
                48.9958736,
                36.2435956
              ],
              [
                48.9964268,
                36.2438749
              ],
              [
                48.99726,
                36.2438748
              ],
              [
                48.9975401,
                36.2441542
              ],
              [
                48.9989268,
                36.2441541
              ],
              [
                48.9992069,
                36.2444335
              ],
              [
                49.0000402,
                36.2444335
              ],
              [
                49.0005933,
                36.2447128
              ],
              [
                49.0017066,
                36.2447128
              ],
              [
                49.0161498,
                36.249425
              ],
              [
                49.016983,
                36.2499926
              ],
              [
                49.0344862,
                36.2583176
              ],
              [
                49.0353198,
                36.2583176
              ],
              [
                49.0355963,
                36.2585969
              ],
              [
                49.0367061,
                36.2585969
              ],
              [
                49.0369862,
                36.2588763
              ],
              [
                49.0392062,
                36.2588762
              ],
              [
                49.0397628,
                36.2591555
              ],
              [
                49.0436528,
                36.2591555
              ],
              [
                49.0442063,
                36.2594348
              ],
              [
                49.0467059,
                36.2594348
              ],
              [
                49.0508764,
                36.2599845
              ],
              [
                49.0680959,
                36.2649848
              ],
              [
                49.0686525,
                36.2652641
              ],
              [
                49.0747659,
                36.2677598
              ],
              [
                49.0830989,
                36.2722105
              ],
              [
                49.0853189,
                36.268877
              ],
              [
                49.0875423,
                36.2633181
              ],
              [
                49.0875424,
                36.2624891
              ],
              [
                49.0925425,
                36.2522091
              ],
              [
                49.0933757,
                36.2513802
              ],
              [
                49.0939324,
                36.2508217
              ],
              [
                49.1025424,
                36.2438751
              ],
              [
                49.109489,
                36.2405414
              ],
              [
                49.111432,
                36.2399828
              ],
              [
                49.1119887,
                36.2394332
              ],
              [
                49.1303218,
                36.2344327
              ],
              [
                49.1314352,
                36.2344327
              ],
              [
                49.1319887,
                36.2341534
              ],
              [
                49.133102,
                36.2341535
              ],
              [
                49.1339352,
                36.2338741
              ],
              [
                49.1408783,
                36.2338741
              ],
              [
                49.1475449,
                36.2349823
              ],
              [
                49.1483785,
                36.2352706
              ],
              [
                49.1583783,
                36.2380368
              ],
              [
                49.1636581,
                36.2405415
              ],
              [
                49.1647683,
                36.2416588
              ],
              [
                49.1650483,
                36.2447131
              ],
              [
                49.1647682,
                36.2449924
              ],
              [
                49.1564348,
                36.2655436
              ],
              [
                49.1561583,
                36.2663815
              ],
              [
                49.1558782,
                36.2672103
              ],
              [
                49.1558782,
                36.2674897
              ],
              [
                49.1550449,
                36.2705439
              ],
              [
                49.1508781,
                36.2766524
              ],
              [
                49.1483784,
                36.2777605
              ],
              [
                49.1481018,
                36.2780399
              ],
              [
                49.1425451,
                36.2780398
              ],
              [
                49.1347684,
                36.2763821
              ],
              [
                49.1186555,
                36.2672103
              ],
              [
                49.1180985,
                36.266931
              ],
              [
                49.1158789,
                36.2661021
              ],
              [
                49.1130987,
                36.2661021
              ],
              [
                49.1103221,
                36.2672103
              ],
              [
                49.1003223,
                36.2749855
              ],
              [
                49.098932,
                36.2772108
              ],
              [
                49.0986554,
                36.2780397
              ],
              [
                49.1019887,
                36.2852654
              ],
              [
                49.1097654,
                36.2880402
              ],
              [
                49.1103221,
                36.2883196
              ],
              [
                49.1311549,
                36.3024913
              ],
              [
                49.131435,
                36.3027706
              ],
              [
                49.1453251,
                36.3163744
              ],
              [
                49.1456017,
                36.3166537
              ],
              [
                49.1531015,
                36.3241583
              ],
              [
                49.1631012,
                36.3385996
              ],
              [
                49.1683813,
                36.3572116
              ],
              [
                49.167268,
                36.361653
              ],
              [
                49.167268,
                36.3619322
              ],
              [
                49.1408779,
                36.3983261
              ],
              [
                49.1406013,
                36.3988846
              ],
              [
                49.1400446,
                36.3991549
              ],
              [
                49.1306014,
                36.4063794
              ],
              [
                49.1217114,
                36.4230442
              ],
              [
                49.1214313,
                36.4241612
              ],
              [
                49.1211548,
                36.4252692
              ],
              [
                49.1208782,
                36.4269356
              ],
              [
                49.1203216,
                36.4288813
              ],
              [
                49.120045,
                36.4294398
              ],
              [
                49.1192117,
                36.42971
              ],
              [
                49.109765,
                36.4336014
              ],
              [
                49.105875,
                36.4366551
              ],
              [
                49.1053216,
                36.4369343
              ],
              [
                49.1050414,
                36.4374927
              ],
              [
                49.1042083,
                36.4377721
              ],
              [
                49.0955983,
                36.4463834
              ],
              [
                49.0950416,
                36.4474913
              ],
              [
                49.092542,
                36.4511034
              ],
              [
                49.0814319,
                36.4716585
              ],
              [
                49.0681144,
                36.4891203
              ],
              [
                48.9929342,
                36.4593179
              ],
              [
                48.9868784,
                36.4584999
              ],
              [
                48.9841747,
                36.4572919
              ],
              [
                48.9799261,
                36.4541508
              ],
              [
                48.9769219,
                36.4494908
              ],
              [
                48.9309152,
                36.4015628
              ],
              [
                48.8835664,
                36.3446034
              ],
              [
                48.87361,
                36.3315087
              ],
              [
                48.8665052,
                36.3212603
              ],
              [
                48.8617404,
                36.3109031
              ],
              [
                48.8592052,
                36.3055806
              ],
              [
                48.8587858,
                36.2996347
              ],
              [
                48.8580894,
                36.2939594
              ],
              [
                48.8587759,
                36.2880099
              ],
              [
                48.8616943,
                36.2667674
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554899,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ایجرود",
          "name:en": "Ijrud County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279528",
          "wikipedia": "en:Ijrud County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8908192,
                36.3316511
              ],
              [
                47.8916524,
                36.3316512
              ],
              [
                47.8927622,
                36.3313809
              ],
              [
                47.8933192,
                36.3313809
              ],
              [
                47.8980424,
                36.3313808
              ],
              [
                47.8985955,
                36.3311017
              ],
              [
                47.8994323,
                36.3311016
              ],
              [
                47.8997088,
                36.3308133
              ],
              [
                47.9185988,
                36.3205431
              ],
              [
                47.9194323,
                36.3205431
              ],
              [
                47.9197089,
                36.3202638
              ],
              [
                47.9202655,
                36.3202638
              ],
              [
                47.9341553,
                36.3152638
              ],
              [
                47.9347084,
                36.3147053
              ],
              [
                47.9385987,
                36.31248
              ],
              [
                47.9410984,
                36.310543
              ],
              [
                47.9413786,
                36.3102638
              ],
              [
                47.956102,
                36.2816503
              ],
              [
                47.9563786,
                36.2813709
              ],
              [
                47.956102,
                36.2755418
              ],
              [
                47.9544317,
                36.2735957
              ],
              [
                47.9458221,
                36.2685954
              ],
              [
                47.943322,
                36.2666493
              ],
              [
                47.9430455,
                36.2660997
              ],
              [
                47.9422119,
                36.2649825
              ],
              [
                47.9419323,
                36.2635951
              ],
              [
                47.9416552,
                36.2610994
              ],
              [
                47.9416553,
                36.2569279
              ],
              [
                47.9455457,
                36.2485939
              ],
              [
                47.9424357,
                36.2127732
              ],
              [
                47.9760418,
                36.2069315
              ],
              [
                47.9821519,
                36.1980384
              ],
              [
                47.9733218,
                36.1885955
              ],
              [
                47.9736019,
                36.1855409
              ],
              [
                47.9738785,
                36.1852616
              ],
              [
                47.9738785,
                36.1816485
              ],
              [
                47.9744352,
                36.1791525
              ],
              [
                47.9744352,
                36.1760979
              ],
              [
                47.9744352,
                36.1738723
              ],
              [
                47.9747122,
                36.171097
              ],
              [
                47.9749887,
                36.169421
              ],
              [
                47.9752688,
                36.1683128
              ],
              [
                47.9758255,
                36.1666458
              ],
              [
                47.9761021,
                36.1663755
              ],
              [
                47.976102,
                36.1658168
              ],
              [
                47.9769353,
                36.1638705
              ],
              [
                48.0033052,
                36.148272
              ],
              [
                48.0197147,
                36.153319
              ],
              [
                48.0249915,
                36.152481
              ],
              [
                48.0255481,
                36.1522017
              ],
              [
                48.0272149,
                36.1522017
              ],
              [
                48.0311049,
                36.1513727
              ],
              [
                48.0324947,
                36.1513727
              ],
              [
                48.0344382,
                36.150814
              ],
              [
                48.035828,
                36.1508141
              ],
              [
                48.0363815,
                36.1505347
              ],
              [
                48.0394378,
                36.1505347
              ],
              [
                48.0399949,
                36.1508141
              ],
              [
                48.0413812,
                36.150814
              ],
              [
                48.0424945,
                36.1510934
              ],
              [
                48.0441613,
                36.1510934
              ],
              [
                48.0483279,
                36.1519224
              ],
              [
                48.0561046,
                36.1549861
              ],
              [
                48.0572179,
                36.1549861
              ],
              [
                48.0580511,
                36.1552655
              ],
              [
                48.0624946,
                36.1552654
              ],
              [
                48.0808274,
                36.1502555
              ],
              [
                48.0824942,
                36.1497058
              ],
              [
                48.0922175,
                36.1433171
              ],
              [
                48.0961075,
                36.1405328
              ],
              [
                48.1083308,
                36.1299809
              ],
              [
                48.130277,
                36.1169239
              ],
              [
                48.1336103,
                36.1160949
              ],
              [
                48.1466668,
                36.1119227
              ],
              [
                48.1519434,
                36.1091473
              ],
              [
                48.1616668,
                36.0991447
              ],
              [
                48.1713901,
                36.0902595
              ],
              [
                48.1727768,
                36.0894215
              ],
              [
                48.1744433,
                36.0877543
              ],
              [
                48.1911132,
                36.0769225
              ],
              [
                48.1916663,
                36.0769225
              ],
              [
                48.1924999,
                36.0766522
              ],
              [
                48.1939437,
                36.0784345
              ],
              [
                48.1977593,
                36.0844093
              ],
              [
                48.2017836,
                36.0878697
              ],
              [
                48.2094338,
                36.0944465
              ],
              [
                48.2215094,
                36.1012903
              ],
              [
                48.2377573,
                36.1050846
              ],
              [
                48.2592042,
                36.1050656
              ],
              [
                48.2683786,
                36.1042516
              ],
              [
                48.2760303,
                36.1018665
              ],
              [
                48.2798736,
                36.1001624
              ],
              [
                48.2888952,
                36.0974779
              ],
              [
                48.2905621,
                36.0988747
              ],
              [
                48.2941719,
                36.1041463
              ],
              [
                48.2950052,
                36.1158159
              ],
              [
                48.2944484,
                36.11915
              ],
              [
                48.2944484,
                36.129702
              ],
              [
                48.2947285,
                36.131369
              ],
              [
                48.2947285,
                36.1319277
              ],
              [
                48.295005,
                36.1391545
              ],
              [
                48.2944484,
                36.1424795
              ],
              [
                48.2944484,
                36.1460929
              ],
              [
                48.2941718,
                36.1466516
              ],
              [
                48.2941718,
                36.148589
              ],
              [
                48.2941717,
                36.1541486
              ],
              [
                48.2944483,
                36.1563742
              ],
              [
                48.2958382,
                36.1610959
              ],
              [
                48.2963952,
                36.1619249
              ],
              [
                48.2963952,
                36.1622042
              ],
              [
                48.2963952,
                36.1658175
              ],
              [
                48.2961183,
                36.1663762
              ],
              [
                48.2961182,
                36.1780359
              ],
              [
                48.3019515,
                36.1980391
              ],
              [
                48.3023913,
                36.1989269
              ],
              [
                48.3027848,
                36.199706
              ],
              [
                48.3030617,
                36.2002647
              ],
              [
                48.3050047,
                36.2041571
              ],
              [
                48.3055613,
                36.2052653
              ],
              [
                48.334451,
                36.2305388
              ],
              [
                48.3355642,
                36.2313768
              ],
              [
                48.3402842,
                36.2383235
              ],
              [
                48.3433409,
                36.2447115
              ],
              [
                48.3472307,
                36.2555413
              ],
              [
                48.3488976,
                36.2638752
              ],
              [
                48.3491741,
                36.2669295
              ],
              [
                48.3502839,
                36.2705423
              ],
              [
                48.3502839,
                36.2713712
              ],
              [
                48.3502839,
                36.2716505
              ],
              [
                48.3502839,
                36.2733173
              ],
              [
                48.3502839,
                36.2774887
              ],
              [
                48.350564,
                36.2791555
              ],
              [
                48.3513972,
                36.2822097
              ],
              [
                48.3694537,
                36.3027691
              ],
              [
                48.4114487,
                36.3324653
              ],
              [
                48.4205481,
                36.3372696
              ],
              [
                48.4216513,
                36.3380139
              ],
              [
                48.4240433,
                36.3403029
              ],
              [
                48.4550125,
                36.3511024
              ],
              [
                48.4844588,
                36.3624894
              ],
              [
                48.4939019,
                36.3669306
              ],
              [
                48.4941821,
                36.36721
              ],
              [
                48.4961255,
                36.3680477
              ],
              [
                48.4969587,
                36.3680477
              ],
              [
                48.5000154,
                36.3694351
              ],
              [
                48.5008486,
                36.369435
              ],
              [
                48.5491847,
                36.3935957
              ],
              [
                48.5625178,
                36.4013788
              ],
              [
                48.5630744,
                36.4022075
              ],
              [
                48.5650178,
                36.4033245
              ],
              [
                48.5739078,
                36.412765
              ],
              [
                48.5766844,
                36.4166565
              ],
              [
                48.5802978,
                36.4233224
              ],
              [
                48.5805744,
                36.4236017
              ],
              [
                48.5786278,
                36.4294387
              ],
              [
                48.5789074,
                36.4344292
              ],
              [
                48.5786278,
                36.435546
              ],
              [
                48.5658509,
                36.4558223
              ],
              [
                48.5655743,
                36.4561015
              ],
              [
                48.5616843,
                36.4574887
              ],
              [
                48.5597409,
                36.4586057
              ],
              [
                48.5294614,
                36.4799983
              ],
              [
                48.5069581,
                36.494716
              ],
              [
                48.506405,
                36.494716
              ],
              [
                48.5058483,
                36.4952744
              ],
              [
                48.5033482,
                36.4961031
              ],
              [
                48.5025151,
                36.4966615
              ],
              [
                48.4764019,
                36.5027682
              ],
              [
                48.4752918,
                36.5030474
              ],
              [
                48.4719585,
                36.5030475
              ],
              [
                48.4705686,
                36.5033266
              ],
              [
                48.4691788,
                36.5033267
              ],
              [
                48.4680686,
                36.5036059
              ],
              [
                48.4669587,
                36.5036059
              ],
              [
                48.4664021,
                36.5038851
              ],
              [
                48.4636219,
                36.5038851
              ],
              [
                48.4625121,
                36.5041643
              ],
              [
                48.4608454,
                36.5041643
              ],
              [
                48.4597355,
                36.5038851
              ],
              [
                48.4558456,
                36.5038851
              ],
              [
                48.455012,
                36.5041643
              ],
              [
                48.4525124,
                36.5041643
              ],
              [
                48.4505689,
                36.5044345
              ],
              [
                48.4497357,
                36.5047137
              ],
              [
                48.448622,
                36.5047137
              ],
              [
                48.4408457,
                36.5069384
              ],
              [
                48.4350124,
                36.5105502
              ],
              [
                48.4283458,
                36.5138828
              ],
              [
                48.4280657,
                36.514162
              ],
              [
                48.425009,
                36.5149906
              ],
              [
                48.4211226,
                36.5161075
              ],
              [
                48.4197323,
                36.5161074
              ],
              [
                48.4188991,
                36.5163867
              ],
              [
                48.4155657,
                36.5163866
              ],
              [
                48.414176,
                36.5166659
              ],
              [
                48.4130658,
                36.5163867
              ],
              [
                48.4111227,
                36.5163867
              ],
              [
                48.4100094,
                36.5161074
              ],
              [
                48.4080661,
                36.5161075
              ],
              [
                48.4052859,
                36.515549
              ],
              [
                48.4008429,
                36.5155489
              ],
              [
                48.3997326,
                36.5152697
              ],
              [
                48.3975095,
                36.5152697
              ],
              [
                48.3963994,
                36.5149906
              ],
              [
                48.3950095,
                36.5149906
              ],
              [
                48.3925095,
                36.5144411
              ],
              [
                48.3911195,
                36.5144411
              ],
              [
                48.390286,
                36.5141619
              ],
              [
                48.3858429,
                36.5141619
              ],
              [
                48.3847296,
                36.5138826
              ],
              [
                48.3791764,
                36.5138827
              ],
              [
                48.3780631,
                36.5136035
              ],
              [
                48.375843,
                36.5136034
              ],
              [
                48.3750099,
                36.5133243
              ],
              [
                48.3719531,
                36.5133242
              ],
              [
                48.3716766,
                36.5136035
              ],
              [
                48.3700062,
                36.5136034
              ],
              [
                48.369173,
                36.5138826
              ],
              [
                48.3680632,
                36.5138827
              ],
              [
                48.3672296,
                36.5141619
              ],
              [
                48.3661199,
                36.5141619
              ],
              [
                48.3566731,
                36.5188815
              ],
              [
                48.3552867,
                36.5202685
              ],
              [
                48.3419501,
                36.5322114
              ],
              [
                48.3400067,
                36.5349945
              ],
              [
                48.3425067,
                36.5466581
              ],
              [
                48.3377831,
                36.5527735
              ],
              [
                48.3372299,
                36.5530437
              ],
              [
                48.3363968,
                36.5536021
              ],
              [
                48.3263935,
                36.5574929
              ],
              [
                48.3252833,
                36.5574929
              ],
              [
                48.3225066,
                36.5583305
              ],
              [
                48.3211168,
                36.5583305
              ],
              [
                48.3130603,
                36.5602668
              ],
              [
                48.3119502,
                36.5608252
              ],
              [
                48.3055601,
                36.5622122
              ],
              [
                48.3050035,
                36.5624914
              ],
              [
                48.3038937,
                36.5624913
              ],
              [
                48.3033371,
                36.5627706
              ],
              [
                48.3011171,
                36.5627706
              ],
              [
                48.300837,
                36.5630497
              ],
              [
                48.2958369,
                36.5630498
              ],
              [
                48.2886135,
                36.5619419
              ],
              [
                48.2880605,
                36.5619419
              ],
              [
                48.2854386,
                36.5619419
              ],
              [
                48.2832076,
                36.5617297
              ],
              [
                48.28265,
                36.5616766
              ],
              [
                48.2774788,
                36.5616628
              ],
              [
                48.2752806,
                36.5616627
              ],
              [
                48.2747239,
                36.5619419
              ],
              [
                48.2733372,
                36.5619419
              ],
              [
                48.272224,
                36.5622121
              ],
              [
                48.2722239,
                36.5624913
              ],
              [
                48.2708375,
                36.5624913
              ],
              [
                48.2705574,
                36.5627705
              ],
              [
                48.2694473,
                36.5627705
              ],
              [
                48.2691706,
                36.5630497
              ],
              [
                48.2686141,
                36.5630497
              ],
              [
                48.2683374,
                36.5633289
              ],
              [
                48.2669472,
                36.563329
              ],
              [
                48.2655574,
                36.5638873
              ],
              [
                48.2544477,
                36.5644366
              ],
              [
                48.2505574,
                36.5641664
              ],
              [
                48.2500007,
                36.5638872
              ],
              [
                48.2477807,
                36.5638872
              ],
              [
                48.2469476,
                36.5636081
              ],
              [
                48.2458343,
                36.563608
              ],
              [
                48.2430576,
                36.5627704
              ],
              [
                48.2422244,
                36.5627705
              ],
              [
                48.2375008,
                36.5608251
              ],
              [
                48.2250014,
                36.5508279
              ],
              [
                48.2238912,
                36.5499903
              ],
              [
                48.2227779,
                36.5488824
              ],
              [
                48.2169446,
                36.5430462
              ],
              [
                48.2122215,
                36.5402722
              ],
              [
                48.2116679,
                36.5394346
              ],
              [
                48.2044448,
                36.534715
              ],
              [
                48.2008315,
                36.5327696
              ],
              [
                48.2002783,
                36.5324904
              ],
              [
                48.1841651,
                36.5186018
              ],
              [
                48.1830552,
                36.5169356
              ],
              [
                48.1802752,
                36.513603
              ],
              [
                48.1797221,
                36.5055418
              ],
              [
                48.1799987,
                36.5049923
              ],
              [
                48.1841652,
                36.4938776
              ],
              [
                48.1863887,
                36.4836095
              ],
              [
                48.1861118,
                36.4783222
              ],
              [
                48.1858321,
                36.4777726
              ],
              [
                48.1858321,
                36.4763855
              ],
              [
                48.1813886,
                36.4766558
              ],
              [
                48.1811085,
                36.476935
              ],
              [
                48.1797222,
                36.476935
              ],
              [
                48.1791655,
                36.4766557
              ],
              [
                48.1755553,
                36.4766558
              ],
              [
                48.1744419,
                36.476935
              ],
              [
                48.1713887,
                36.476935
              ],
              [
                48.1605521,
                36.4783221
              ],
              [
                48.1597191,
                36.4786013
              ],
              [
                48.1586088,
                36.4786013
              ],
              [
                48.1580521,
                36.4788806
              ],
              [
                48.1572189,
                36.4788806
              ],
              [
                48.1566654,
                36.4791597
              ],
              [
                48.1558322,
                36.4791597
              ],
              [
                48.1552756,
                36.479439
              ],
              [
                48.1538856,
                36.479439
              ],
              [
                48.1530525,
                36.4797182
              ],
              [
                48.1472191,
                36.4802677
              ],
              [
                48.1463855,
                36.4805468
              ],
              [
                48.144719,
                36.4805468
              ],
              [
                48.1441624,
                36.480826
              ],
              [
                48.1430522,
                36.480826
              ],
              [
                48.1424955,
                36.4811053
              ],
              [
                48.1388857,
                36.4811053
              ],
              [
                48.1380525,
                36.4808261
              ],
              [
                48.1363857,
                36.4808261
              ],
              [
                48.1361091,
                36.4805468
              ],
              [
                48.133886,
                36.4805469
              ],
              [
                48.1330524,
                36.4802676
              ],
              [
                48.1313859,
                36.4802676
              ],
              [
                48.1311094,
                36.4805468
              ],
              [
                48.1258292,
                36.4805469
              ],
              [
                48.1252726,
                36.4802676
              ],
              [
                48.1236061,
                36.4802676
              ],
              [
                48.1211061,
                36.4797182
              ],
              [
                48.1208295,
                36.4794389
              ],
              [
                48.1197193,
                36.4794389
              ],
              [
                48.1188861,
                36.4791597
              ],
              [
                48.1180529,
                36.4791596
              ],
              [
                48.1177727,
                36.4788805
              ],
              [
                48.1169392,
                36.4788805
              ],
              [
                48.1080527,
                36.4702694
              ],
              [
                48.1069393,
                36.4691615
              ],
              [
                48.1005494,
                36.4630454
              ],
              [
                48.0844398,
                36.4558213
              ],
              [
                48.0749935,
                36.4536055
              ],
              [
                48.0744399,
                36.4533262
              ],
              [
                48.0716598,
                36.4533262
              ],
              [
                48.0711066,
                36.453047
              ],
              [
                48.0686034,
                36.453047
              ],
              [
                48.0680499,
                36.4527677
              ],
              [
                48.06416,
                36.4527677
              ],
              [
                48.0633268,
                36.4524885
              ],
              [
                48.0622166,
                36.4524885
              ],
              [
                48.0613833,
                36.4527677
              ],
              [
                48.06027,
                36.4527677
              ],
              [
                48.0588833,
                36.4524884
              ],
              [
                48.05777,
                36.4522092
              ],
              [
                48.0544367,
                36.4522092
              ],
              [
                48.0477701,
                36.455542
              ],
              [
                48.0477702,
                36.4563798
              ],
              [
                48.0474936,
                36.4566589
              ],
              [
                48.0477701,
                36.4602709
              ],
              [
                48.0572168,
                36.4705484
              ],
              [
                48.0577699,
                36.4724942
              ],
              [
                48.0561035,
                36.4744397
              ],
              [
                48.0558269,
                36.4747099
              ],
              [
                48.0499936,
                36.477214
              ],
              [
                48.049437,
                36.477214
              ],
              [
                48.04916,
                36.4774931
              ],
              [
                48.0466603,
                36.4774932
              ],
              [
                48.0463803,
                36.4777723
              ],
              [
                48.040827,
                36.4777724
              ],
              [
                48.0405469,
                36.4774931
              ],
              [
                48.0372137,
                36.4774932
              ],
              [
                48.036937,
                36.4772139
              ],
              [
                48.0347136,
                36.4772139
              ],
              [
                48.034437,
                36.4769347
              ],
              [
                48.0302705,
                36.4769347
              ],
              [
                48.0299904,
                36.4766554
              ],
              [
                48.0255469,
                36.4766555
              ],
              [
                48.0224902,
                36.4763852
              ],
              [
                48.0222137,
                36.476106
              ],
              [
                48.0208238,
                36.4761059
              ],
              [
                48.0202703,
                36.4758267
              ],
              [
                48.0166573,
                36.4758268
              ],
              [
                48.0158237,
                36.4758267
              ],
              [
                48.0155471,
                36.476106
              ],
              [
                48.0124904,
                36.4761059
              ],
              [
                48.0122139,
                36.4758268
              ],
              [
                48.0091571,
                36.4758268
              ],
              [
                48.0086005,
                36.476106
              ],
              [
                48.0055473,
                36.4761059
              ],
              [
                48.0049907,
                36.4763851
              ],
              [
                48.0041574,
                36.4763851
              ],
              [
                47.9992631,
                36.4755585
              ],
              [
                47.9986006,
                36.4755475
              ],
              [
                47.9980475,
                36.4755475
              ],
              [
                47.9977675,
                36.4758267
              ],
              [
                47.9936006,
                36.4758267
              ],
              [
                47.993324,
                36.4761059
              ],
              [
                47.9913775,
                36.4761059
              ],
              [
                47.990824,
                36.4763852
              ],
              [
                47.9844344,
                36.4772138
              ],
              [
                47.9813776,
                36.4772138
              ],
              [
                47.9811011,
                36.4774931
              ],
              [
                47.978601,
                36.477493
              ],
              [
                47.9780444,
                36.4777723
              ],
              [
                47.9758244,
                36.4777722
              ],
              [
                47.9752678,
                36.4780515
              ],
              [
                47.9716544,
                36.4783217
              ],
              [
                47.9666544,
                36.4783216
              ],
              [
                47.9661011,
                36.4786009
              ],
              [
                47.9616545,
                36.4786009
              ],
              [
                47.960821,
                36.4783216
              ],
              [
                47.9555447,
                36.477493
              ],
              [
                47.9530446,
                36.477493
              ],
              [
                47.9522114,
                36.4772137
              ],
              [
                47.9491547,
                36.4761058
              ],
              [
                47.9480445,
                36.4761058
              ],
              [
                47.9477644,
                36.4758266
              ],
              [
                47.9466546,
                36.4758266
              ],
              [
                47.946378,
                36.4755474
              ],
              [
                47.9452648,
                36.4755474
              ],
              [
                47.9449878,
                36.4752681
              ],
              [
                47.9419315,
                36.4752681
              ],
              [
                47.9410979,
                36.4755474
              ],
              [
                47.9399881,
                36.4755474
              ],
              [
                47.9341547,
                36.4774929
              ],
              [
                47.9330414,
                36.4774929
              ],
              [
                47.9319312,
                36.4780514
              ],
              [
                47.9274883,
                36.4788801
              ],
              [
                47.9222084,
                36.47888
              ],
              [
                47.9213748,
                36.4786008
              ],
              [
                47.9199884,
                36.4786007
              ],
              [
                47.9194318,
                36.4783216
              ],
              [
                47.9152649,
                36.4774929
              ],
              [
                47.9060983,
                36.4711066
              ],
              [
                47.9055416,
                36.4680441
              ],
              [
                47.904985,
                36.4660985
              ],
              [
                47.9047084,
                36.4630449
              ],
              [
                47.904985,
                36.4622163
              ],
              [
                47.9022084,
                36.4497138
              ],
              [
                47.900542,
                36.4469394
              ],
              [
                47.8980419,
                36.4419402
              ],
              [
                47.8747058,
                36.4052598
              ],
              [
                47.8738724,
                36.4024853
              ],
              [
                47.8730389,
                36.3980442
              ],
              [
                47.8727623,
                36.3952698
              ],
              [
                47.8727623,
                36.3905404
              ],
              [
                47.873319,
                36.3860993
              ],
              [
                47.8735956,
                36.3844327
              ],
              [
                47.875539,
                36.3791538
              ],
              [
                47.8799856,
                36.3744334
              ],
              [
                47.8808192,
                36.3741542
              ],
              [
                47.8894288,
                36.3663798
              ],
              [
                47.8908191,
                36.3635962
              ],
              [
                47.8913757,
                36.3605423
              ],
              [
                47.8916523,
                36.3594342
              ],
              [
                47.8919289,
                36.3577586
              ],
              [
                47.892209,
                36.356101
              ],
              [
                47.8924856,
                36.3544345
              ],
              [
                47.8927621,
                36.3527678
              ],
              [
                47.8930422,
                36.3513714
              ],
              [
                47.8933192,
                36.3497049
              ],
              [
                47.8935957,
                36.3483175
              ],
              [
                47.8938758,
                36.3466599
              ],
              [
                47.8941525,
                36.3463807
              ],
              [
                47.892209,
                36.3344348
              ],
              [
                47.8910957,
                36.3327683
              ],
              [
                47.8908192,
                36.3316511
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554989,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خدابنده",
          "name:en": "Khodabandeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286131",
          "wikipedia": "en:Khodabandeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8737635,
                36.0015048
              ],
              [
                47.8715943,
                35.9981812
              ],
              [
                47.8772163,
                35.9966188
              ],
              [
                47.8851985,
                35.9948827
              ],
              [
                47.8922366,
                35.9953688
              ],
              [
                47.902193,
                35.9968965
              ],
              [
                47.9263982,
                35.9978261
              ],
              [
                47.9474698,
                35.9963685
              ],
              [
                47.9544829,
                35.9938686
              ],
              [
                47.9663085,
                35.9879381
              ],
              [
                47.9720915,
                35.983315
              ],
              [
                47.9736897,
                35.9796735
              ],
              [
                47.9719327,
                35.9706714
              ],
              [
                47.9620169,
                35.9648082
              ],
              [
                47.9574895,
                35.963306
              ],
              [
                47.9391566,
                35.9574747
              ],
              [
                47.9380464,
                35.9574747
              ],
              [
                47.9369331,
                35.956925
              ],
              [
                47.9358234,
                35.956925
              ],
              [
                47.9352663,
                35.9566456
              ],
              [
                47.9344331,
                35.9566456
              ],
              [
                47.9341566,
                35.9563662
              ],
              [
                47.9316566,
                35.9563661
              ],
              [
                47.9310999,
                35.9560868
              ],
              [
                47.9274899,
                35.9560867
              ],
              [
                47.9266567,
                35.9558073
              ],
              [
                47.9258232,
                35.9560867
              ],
              [
                47.9249899,
                35.9558073
              ],
              [
                47.9213766,
                35.955537
              ],
              [
                47.9199902,
                35.9555369
              ],
              [
                47.9177667,
                35.9549781
              ],
              [
                47.9160999,
                35.9549782
              ],
              [
                47.9158203,
                35.9546988
              ],
              [
                47.9144334,
                35.9546987
              ],
              [
                47.9141534,
                35.9544193
              ],
              [
                47.8939034,
                35.9483138
              ],
              [
                47.8881283,
                35.9453899
              ],
              [
                47.8780035,
                35.9420623
              ],
              [
                47.8677327,
                35.9391239
              ],
              [
                47.8666387,
                35.9322449
              ],
              [
                47.8543852,
                35.9282588
              ],
              [
                47.8664121,
                35.9127809
              ],
              [
                47.870693,
                35.9076837
              ],
              [
                47.8835701,
                35.89367
              ],
              [
                47.8892937,
                35.887184
              ],
              [
                47.8955133,
                35.8796541
              ],
              [
                47.9013347,
                35.8830003
              ],
              [
                47.9059304,
                35.881636
              ],
              [
                47.913491,
                35.8838841
              ],
              [
                47.9300876,
                35.8932206
              ],
              [
                47.9422535,
                35.9021973
              ],
              [
                47.9507819,
                35.9083679
              ],
              [
                47.9740332,
                35.9243667
              ],
              [
                47.9881538,
                35.9313978
              ],
              [
                47.9943839,
                35.9305875
              ],
              [
                48.0021391,
                35.9302797
              ],
              [
                48.0065729,
                35.9226428
              ],
              [
                48.0101385,
                35.9113748
              ],
              [
                48.0139401,
                35.8992142
              ],
              [
                48.0173567,
                35.8888396
              ],
              [
                48.0226296,
                35.8741134
              ],
              [
                48.0246578,
                35.8640675
              ],
              [
                48.027939,
                35.8489995
              ],
              [
                48.0313825,
                35.8387804
              ],
              [
                48.0348974,
                35.833974
              ],
              [
                48.0384911,
                35.8264395
              ],
              [
                48.0450991,
                35.8136412
              ],
              [
                48.0732267,
                35.8141399
              ],
              [
                48.0787466,
                35.8126628
              ],
              [
                48.0917,
                35.8132946
              ],
              [
                48.100518,
                35.8062978
              ],
              [
                48.1147119,
                35.7988264
              ],
              [
                48.1325648,
                35.7887638
              ],
              [
                48.1417255,
                35.7821427
              ],
              [
                48.1465344,
                35.779117
              ],
              [
                48.1604523,
                35.7663192
              ],
              [
                48.1850644,
                35.7441817
              ],
              [
                48.1911277,
                35.7372279
              ],
              [
                48.2012943,
                35.7292838
              ],
              [
                48.2100006,
                35.7294262
              ],
              [
                48.220004,
                35.7305252
              ],
              [
                48.2280604,
                35.7299535
              ],
              [
                48.2350039,
                35.7283075
              ],
              [
                48.2415847,
                35.725919
              ],
              [
                48.249434,
                35.723168
              ],
              [
                48.2524032,
                35.7196275
              ],
              [
                48.2704315,
                35.707128
              ],
              [
                48.2779578,
                35.6990005
              ],
              [
                48.2799138,
                35.6969894
              ],
              [
                48.2817249,
                35.695222
              ],
              [
                48.2901766,
                35.6861535
              ],
              [
                48.2961198,
                35.6805276
              ],
              [
                48.311953,
                35.6727473
              ],
              [
                48.3280627,
                35.6666349
              ],
              [
                48.3433427,
                35.6621994
              ],
              [
                48.353066,
                35.6596931
              ],
              [
                48.357509,
                35.6574753
              ],
              [
                48.3916789,
                35.6430234
              ],
              [
                48.3947357,
                35.6427529
              ],
              [
                48.3952889,
                35.6424734
              ],
              [
                48.4016788,
                35.6424734
              ],
              [
                48.4141787,
                35.6408055
              ],
              [
                48.4216784,
                35.6446913
              ],
              [
                48.4258449,
                35.6474681
              ],
              [
                48.435015,
                35.6541396
              ],
              [
                48.4380682,
                35.6549691
              ],
              [
                48.4391815,
                35.6549691
              ],
              [
                48.4414015,
                35.6557986
              ],
              [
                48.4422351,
                35.6557985
              ],
              [
                48.4425148,
                35.656087
              ],
              [
                48.4447347,
                35.6560871
              ],
              [
                48.4450148,
                35.6557985
              ],
              [
                48.4489047,
                35.6557986
              ],
              [
                48.4508482,
                35.6555281
              ],
              [
                48.4514048,
                35.6552486
              ],
              [
                48.4527916,
                35.6552486
              ],
              [
                48.4550147,
                35.6546897
              ],
              [
                48.4558482,
                35.6546897
              ],
              [
                48.456958,
                35.6541397
              ],
              [
                48.4580714,
                35.6541397
              ],
              [
                48.4611245,
                35.6527513
              ],
              [
                48.4616811,
                35.6527513
              ],
              [
                48.4622378,
                35.6521924
              ],
              [
                48.4680713,
                35.6505245
              ],
              [
                48.4719611,
                35.6499746
              ],
              [
                48.4811277,
                35.6458094
              ],
              [
                48.4816813,
                35.6458093
              ],
              [
                48.4836278,
                35.6452504
              ],
              [
                48.4839044,
                35.644971
              ],
              [
                48.484181,
                35.6446914
              ],
              [
                48.4905709,
                35.6374699
              ],
              [
                48.4919613,
                35.6355225
              ],
              [
                48.4925179,
                35.635252
              ],
              [
                48.4952945,
                35.6296893
              ],
              [
                48.4958511,
                35.6277509
              ],
              [
                48.4977946,
                35.6219177
              ],
              [
                48.4980712,
                35.6213587
              ],
              [
                48.4983512,
                35.6199703
              ],
              [
                48.495018,
                35.5999729
              ],
              [
                48.4961278,
                35.598864
              ],
              [
                48.5211275,
                35.5902536
              ],
              [
                48.5255742,
                35.5883061
              ],
              [
                48.5364072,
                35.5855292
              ],
              [
                48.538074,
                35.5849702
              ],
              [
                48.5427971,
                35.5849702
              ],
              [
                48.5430737,
                35.5852497
              ],
              [
                48.5450207,
                35.5852497
              ],
              [
                48.5726632,
                35.5779816
              ],
              [
                48.5729397,
                35.5782611
              ],
              [
                48.5737733,
                35.5782611
              ],
              [
                48.5743299,
                35.5785406
              ],
              [
                48.5754397,
                35.5785406
              ],
              [
                48.6032196,
                35.5874314
              ],
              [
                48.6040528,
                35.5874315
              ],
              [
                48.6084993,
                35.5899291
              ],
              [
                48.6090525,
                35.5904882
              ],
              [
                48.6096179,
                35.5907677
              ],
              [
                48.6126659,
                35.5918768
              ],
              [
                48.6146092,
                35.5918768
              ],
              [
                48.6193324,
                35.593545
              ],
              [
                48.6318323,
                35.595204
              ],
              [
                48.6340558,
                35.5949336
              ],
              [
                48.634889,
                35.594654
              ],
              [
                48.6433559,
                35.6013616
              ],
              [
                48.6441895,
                35.6010822
              ],
              [
                48.6472458,
                35.6010822
              ],
              [
                48.6480795,
                35.6008027
              ],
              [
                48.6505795,
                35.6008027
              ],
              [
                48.6639126,
                35.5988642
              ],
              [
                48.669469,
                35.5971873
              ],
              [
                48.6698229,
                35.5972334
              ],
              [
                48.7469617,
                35.6471266
              ],
              [
                48.7466851,
                35.6476856
              ],
              [
                48.7464051,
                35.651581
              ],
              [
                48.7458519,
                35.6543583
              ],
              [
                48.7466851,
                35.6637992
              ],
              [
                48.7517546,
                35.6788427
              ],
              [
                48.7506448,
                35.6794017
              ],
              [
                48.7466946,
                35.6846935
              ],
              [
                48.7458613,
                35.684973
              ],
              [
                48.7455261,
                35.6892958
              ],
              [
                48.7460613,
                35.6962608
              ],
              [
                48.743506,
                35.7141494
              ],
              [
                48.7350278,
                35.7224759
              ],
              [
                48.7350277,
                35.7227464
              ],
              [
                48.7363237,
                35.7239575
              ],
              [
                48.7328047,
                35.7299764
              ],
              [
                48.7308612,
                35.7335823
              ],
              [
                48.7247478,
                35.7494213
              ],
              [
                48.7244712,
                35.7513594
              ],
              [
                48.7247478,
                35.7569124
              ],
              [
                48.7255814,
                35.7602479
              ],
              [
                48.7361379,
                35.7783039
              ],
              [
                48.7361378,
                35.7788628
              ],
              [
                48.7383609,
                35.7821982
              ],
              [
                48.7486411,
                35.799695
              ],
              [
                48.7528076,
                35.8060861
              ],
              [
                48.7564174,
                35.8233031
              ],
              [
                48.7561408,
                35.8235915
              ],
              [
                48.756379,
                35.8245463
              ],
              [
                48.7564174,
                35.8247002
              ],
              [
                48.756694,
                35.8249707
              ],
              [
                48.7578073,
                35.8260884
              ],
              [
                48.7583608,
                35.8263678
              ],
              [
                48.7583608,
                35.8266472
              ],
              [
                48.7594741,
                35.827756
              ],
              [
                48.7714173,
                35.8388611
              ],
              [
                48.771974,
                35.8391406
              ],
              [
                48.7747505,
                35.8449726
              ],
              [
                48.7803068,
                35.8766376
              ],
              [
                48.7816971,
                35.8794228
              ],
              [
                48.7844737,
                35.8841459
              ],
              [
                48.7872534,
                35.8872014
              ],
              [
                48.8275331,
                35.9144217
              ],
              [
                48.8450036,
                35.9344009
              ],
              [
                48.8499037,
                35.9698378
              ],
              [
                48.851839,
                35.9722517
              ],
              [
                48.8554286,
                35.9759225
              ],
              [
                48.8651275,
                35.983146
              ],
              [
                48.8792037,
                35.9918272
              ],
              [
                48.9040088,
                36.0172402
              ],
              [
                48.9088153,
                36.0261259
              ],
              [
                48.913021,
                36.032373
              ],
              [
                48.9169692,
                36.0363987
              ],
              [
                48.9290713,
                36.0434778
              ],
              [
                48.9364581,
                36.0493437
              ],
              [
                48.9409654,
                36.0535877
              ],
              [
                48.9440059,
                36.0594382
              ],
              [
                48.9441776,
                36.0685619
              ],
              [
                48.9446926,
                36.0745282
              ],
              [
                48.9461517,
                36.0843439
              ],
              [
                48.9466238,
                36.0979034
              ],
              [
                48.9465379,
                36.103382
              ],
              [
                48.9460229,
                36.1084789
              ],
              [
                48.9454221,
                36.1131247
              ],
              [
                48.9440274,
                36.1176143
              ],
              [
                48.9423752,
                36.1201969
              ],
              [
                48.9393711,
                36.1234555
              ],
              [
                48.9370536,
                36.1234902
              ],
              [
                48.9368606,
                36.1235595
              ],
              [
                48.937161,
                36.1240101
              ],
              [
                48.9349025,
                36.1239408
              ],
              [
                48.9330947,
                36.1244348
              ],
              [
                48.9331537,
                36.1247121
              ],
              [
                48.9314479,
                36.1250717
              ],
              [
                48.9302248,
                36.1250241
              ],
              [
                48.9286637,
                36.1251714
              ],
              [
                48.9263356,
                36.1249547
              ],
              [
                48.9212823,
                36.1238368
              ],
              [
                48.9190721,
                36.1249808
              ],
              [
                48.9202308,
                36.1267833
              ],
              [
                48.9198017,
                36.1281005
              ],
              [
                48.9208746,
                36.1292097
              ],
              [
                48.9205741,
                36.1311161
              ],
              [
                48.9212608,
                36.1324678
              ],
              [
                48.9208316,
                36.1339929
              ],
              [
                48.9217329,
                36.1353793
              ],
              [
                48.9210462,
                36.1417564
              ],
              [
                48.9201879,
                36.143004
              ],
              [
                48.9196696,
                36.1449831
              ],
              [
                48.9177371,
                36.1499112
              ],
              [
                48.9158096,
                36.1582402
              ],
              [
                48.9163684,
                36.1650423
              ],
              [
                48.9209174,
                36.1741884
              ],
              [
                48.9288646,
                36.1894829
              ],
              [
                48.9322838,
                36.1953122
              ],
              [
                48.9349004,
                36.1973341
              ],
              [
                48.9373895,
                36.2008666
              ],
              [
                48.9392778,
                36.2044726
              ],
              [
                48.9408974,
                36.2084964
              ],
              [
                48.9414982,
                36.2118389
              ],
              [
                48.9406585,
                36.2170639
              ],
              [
                48.9389484,
                36.2259638
              ],
              [
                48.9379978,
                36.2264463
              ],
              [
                48.9371442,
                36.2279143
              ],
              [
                48.9367401,
                36.2315199
              ],
              [
                48.9347434,
                36.2343935
              ],
              [
                48.9318609,
                36.2349968
              ],
              [
                48.9298511,
                36.2372713
              ],
              [
                48.9259169,
                36.2407548
              ],
              [
                48.9184093,
                36.2463406
              ],
              [
                48.9128113,
                36.2501502
              ],
              [
                48.906653,
                36.253334
              ],
              [
                48.9006922,
                36.2562435
              ],
              [
                48.8916885,
                36.2594964
              ],
              [
                48.8792036,
                36.2614387
              ],
              [
                48.8638376,
                36.2599809
              ],
              [
                48.8453408,
                36.2542966
              ],
              [
                48.8350421,
                36.2494184
              ],
              [
                48.8186849,
                36.2437423
              ],
              [
                48.8089942,
                36.2435118
              ],
              [
                48.8036543,
                36.2460571
              ],
              [
                48.8016469,
                36.2491092
              ],
              [
                48.8003253,
                36.2538946
              ],
              [
                48.802076,
                36.2652587
              ],
              [
                48.8075351,
                36.2723726
              ],
              [
                48.8148156,
                36.2790773
              ],
              [
                48.8185934,
                36.282369
              ],
              [
                48.8201093,
                36.2852424
              ],
              [
                48.8192869,
                36.2896042
              ],
              [
                48.8146527,
                36.2949126
              ],
              [
                48.8133716,
                36.2961731
              ],
              [
                48.7965879,
                36.3028376
              ],
              [
                48.7783868,
                36.309756
              ],
              [
                48.7559726,
                36.3171188
              ],
              [
                48.7467722,
                36.3197431
              ],
              [
                48.7413895,
                36.3221635
              ],
              [
                48.7326049,
                36.3280571
              ],
              [
                48.7252198,
                36.3321013
              ],
              [
                48.7142272,
                36.3382493
              ],
              [
                48.7025234,
                36.3502651
              ],
              [
                48.7022463,
                36.3505444
              ],
              [
                48.6997467,
                36.3516524
              ],
              [
                48.6886331,
                36.3599944
              ],
              [
                48.6811333,
                36.3661023
              ],
              [
                48.6716901,
                36.3708227
              ],
              [
                48.6519671,
                36.3763809
              ],
              [
                48.6500201,
                36.3766511
              ],
              [
                48.6433535,
                36.3788852
              ],
              [
                48.6383539,
                36.3816597
              ],
              [
                48.6361339,
                36.3838758
              ],
              [
                48.630297,
                36.3913797
              ],
              [
                48.6301586,
                36.3916591
              ],
              [
                48.6297438,
                36.3919382
              ],
              [
                48.6297438,
                36.3922086
              ],
              [
                48.6294638,
                36.3930463
              ],
              [
                48.6275203,
                36.3980459
              ],
              [
                48.6272437,
                36.3988837
              ],
              [
                48.6191873,
                36.4113779
              ],
              [
                48.6080741,
                36.4180438
              ],
              [
                48.6075206,
                36.4180438
              ],
              [
                48.6069639,
                36.4186023
              ],
              [
                48.6036307,
                36.4197192
              ],
              [
                48.5869644,
                36.4233224
              ],
              [
                48.585574,
                36.4233224
              ],
              [
                48.5844642,
                36.4236017
              ],
              [
                48.5830744,
                36.4236017
              ],
              [
                48.5822407,
                36.4238809
              ],
              [
                48.5805744,
                36.4236017
              ],
              [
                48.5802978,
                36.4233224
              ],
              [
                48.5766844,
                36.4166565
              ],
              [
                48.5739078,
                36.412765
              ],
              [
                48.5650178,
                36.4033245
              ],
              [
                48.5630744,
                36.4022075
              ],
              [
                48.5625178,
                36.4013788
              ],
              [
                48.5491847,
                36.3935957
              ],
              [
                48.5008486,
                36.369435
              ],
              [
                48.5000154,
                36.3694351
              ],
              [
                48.4969587,
                36.3680477
              ],
              [
                48.4961255,
                36.3680477
              ],
              [
                48.4941821,
                36.36721
              ],
              [
                48.4939019,
                36.3669306
              ],
              [
                48.4844588,
                36.3624894
              ],
              [
                48.4550125,
                36.3511024
              ],
              [
                48.4240433,
                36.3403029
              ],
              [
                48.4216513,
                36.3380139
              ],
              [
                48.4205481,
                36.3372696
              ],
              [
                48.4114487,
                36.3324653
              ],
              [
                48.3694537,
                36.3027691
              ],
              [
                48.3513972,
                36.2822097
              ],
              [
                48.350564,
                36.2791555
              ],
              [
                48.3502839,
                36.2774887
              ],
              [
                48.3502839,
                36.2733173
              ],
              [
                48.3502839,
                36.2716505
              ],
              [
                48.3502839,
                36.2713712
              ],
              [
                48.3502839,
                36.2705423
              ],
              [
                48.3491741,
                36.2669295
              ],
              [
                48.3488976,
                36.2638752
              ],
              [
                48.3472307,
                36.2555413
              ],
              [
                48.3433409,
                36.2447115
              ],
              [
                48.3402842,
                36.2383235
              ],
              [
                48.3355642,
                36.2313768
              ],
              [
                48.334451,
                36.2305388
              ],
              [
                48.3055613,
                36.2052653
              ],
              [
                48.3050047,
                36.2041571
              ],
              [
                48.3030617,
                36.2002647
              ],
              [
                48.3027848,
                36.199706
              ],
              [
                48.3023913,
                36.1989269
              ],
              [
                48.3019515,
                36.1980391
              ],
              [
                48.2961182,
                36.1780359
              ],
              [
                48.2961183,
                36.1663762
              ],
              [
                48.2963952,
                36.1658175
              ],
              [
                48.2963952,
                36.1622042
              ],
              [
                48.2963952,
                36.1619249
              ],
              [
                48.2958382,
                36.1610959
              ],
              [
                48.2944483,
                36.1563742
              ],
              [
                48.2941717,
                36.1541486
              ],
              [
                48.2941718,
                36.148589
              ],
              [
                48.2941718,
                36.1466516
              ],
              [
                48.2944484,
                36.1460929
              ],
              [
                48.2944484,
                36.1424795
              ],
              [
                48.295005,
                36.1391545
              ],
              [
                48.2947285,
                36.1319277
              ],
              [
                48.2947285,
                36.131369
              ],
              [
                48.2944484,
                36.129702
              ],
              [
                48.2944484,
                36.11915
              ],
              [
                48.2950052,
                36.1158159
              ],
              [
                48.2941719,
                36.1041463
              ],
              [
                48.2905621,
                36.0988747
              ],
              [
                48.2888952,
                36.0974779
              ],
              [
                48.2798736,
                36.1001624
              ],
              [
                48.2760303,
                36.1018665
              ],
              [
                48.2683786,
                36.1042516
              ],
              [
                48.2592042,
                36.1050656
              ],
              [
                48.2377573,
                36.1050846
              ],
              [
                48.2215094,
                36.1012903
              ],
              [
                48.2094338,
                36.0944465
              ],
              [
                48.2017836,
                36.0878697
              ],
              [
                48.1977593,
                36.0844093
              ],
              [
                48.1939437,
                36.0784345
              ],
              [
                48.1924999,
                36.0766522
              ],
              [
                48.1916663,
                36.0769225
              ],
              [
                48.1911132,
                36.0769225
              ],
              [
                48.1744433,
                36.0877543
              ],
              [
                48.1727768,
                36.0894215
              ],
              [
                48.1713901,
                36.0902595
              ],
              [
                48.1616668,
                36.0991447
              ],
              [
                48.1519434,
                36.1091473
              ],
              [
                48.1466668,
                36.1119227
              ],
              [
                48.1336103,
                36.1160949
              ],
              [
                48.130277,
                36.1169239
              ],
              [
                48.1083308,
                36.1299809
              ],
              [
                48.0961075,
                36.1405328
              ],
              [
                48.0922175,
                36.1433171
              ],
              [
                48.0824942,
                36.1497058
              ],
              [
                48.0808274,
                36.1502555
              ],
              [
                48.0624946,
                36.1552654
              ],
              [
                48.0580511,
                36.1552655
              ],
              [
                48.0572179,
                36.1549861
              ],
              [
                48.0561046,
                36.1549861
              ],
              [
                48.0483279,
                36.1519224
              ],
              [
                48.0441613,
                36.1510934
              ],
              [
                48.0424945,
                36.1510934
              ],
              [
                48.0413812,
                36.150814
              ],
              [
                48.0399949,
                36.1508141
              ],
              [
                48.0394378,
                36.1505347
              ],
              [
                48.0363815,
                36.1505347
              ],
              [
                48.035828,
                36.1508141
              ],
              [
                48.0344382,
                36.150814
              ],
              [
                48.0324947,
                36.1513727
              ],
              [
                48.0311049,
                36.1513727
              ],
              [
                48.0272149,
                36.1522017
              ],
              [
                48.0255481,
                36.1522017
              ],
              [
                48.0249915,
                36.152481
              ],
              [
                48.0197147,
                36.153319
              ],
              [
                48.0033052,
                36.148272
              ],
              [
                47.9845046,
                36.1275459
              ],
              [
                47.9715439,
                36.1171465
              ],
              [
                47.9585749,
                36.1055342
              ],
              [
                47.9507105,
                36.0985882
              ],
              [
                47.9445129,
                36.093172
              ],
              [
                47.9409079,
                36.0904008
              ],
              [
                47.9318918,
                36.082269
              ],
              [
                47.937299,
                36.0815716
              ],
              [
                47.9404306,
                36.0803553
              ],
              [
                47.9479837,
                36.0795229
              ],
              [
                47.956309,
                36.0775809
              ],
              [
                47.9640768,
                36.0674173
              ],
              [
                47.961116,
                36.0606759
              ],
              [
                47.9534911,
                36.0483259
              ],
              [
                47.9503546,
                36.0453968
              ],
              [
                47.9455727,
                36.0405353
              ],
              [
                47.9431341,
                36.0389667
              ],
              [
                47.936611,
                36.0348024
              ],
              [
                47.9313831,
                36.0331749
              ],
              [
                47.9215048,
                36.032026
              ],
              [
                47.9146233,
                36.0330238
              ],
              [
                47.9072921,
                36.0339977
              ],
              [
                47.9013347,
                36.0313318
              ],
              [
                47.8885459,
                36.0211278
              ],
              [
                47.8826236,
                36.015088
              ],
              [
                47.8780669,
                36.0069949
              ],
              [
                47.8737635,
                36.0015048
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554993,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خرمدره",
          "name:en": "Khoramdareh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1285914"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.9347434,
                36.2343935
              ],
              [
                48.9367401,
                36.2315199
              ],
              [
                48.9371442,
                36.2279143
              ],
              [
                48.9379978,
                36.2264463
              ],
              [
                48.9389484,
                36.2259638
              ],
              [
                48.9406585,
                36.2170639
              ],
              [
                48.9414982,
                36.2118389
              ],
              [
                48.9408974,
                36.2084964
              ],
              [
                48.9392778,
                36.2044726
              ],
              [
                48.9373895,
                36.2008666
              ],
              [
                48.9349004,
                36.1973341
              ],
              [
                48.9414204,
                36.1944009
              ],
              [
                48.9513135,
                36.1926067
              ],
              [
                48.9562168,
                36.1914183
              ],
              [
                48.963664,
                36.1885718
              ],
              [
                48.9676139,
                36.1873881
              ],
              [
                48.9737324,
                36.1862735
              ],
              [
                48.9794579,
                36.184611
              ],
              [
                48.9847162,
                36.183431
              ],
              [
                48.9960211,
                36.1802443
              ],
              [
                49.0020674,
                36.1810734
              ],
              [
                49.0054123,
                36.1787872
              ],
              [
                49.0160287,
                36.1782227
              ],
              [
                49.0233323,
                36.1770518
              ],
              [
                49.0275324,
                36.1768418
              ],
              [
                49.0338195,
                36.177396
              ],
              [
                49.0390746,
                36.1773246
              ],
              [
                49.0361533,
                36.167486
              ],
              [
                49.0367063,
                36.1672067
              ],
              [
                49.0383731,
                36.167486
              ],
              [
                49.0414299,
                36.167486
              ],
              [
                49.0425397,
                36.1677652
              ],
              [
                49.0478199,
                36.1677652
              ],
              [
                49.0480965,
                36.167486
              ],
              [
                49.0594862,
                36.167486
              ],
              [
                49.1033758,
                36.1644315
              ],
              [
                49.104209,
                36.1644315
              ],
              [
                49.1054905,
                36.1650536
              ],
              [
                49.1267278,
                36.1618672
              ],
              [
                49.1502261,
                36.1581671
              ],
              [
                49.1601493,
                36.1573927
              ],
              [
                49.1620107,
                36.1598198
              ],
              [
                49.1627371,
                36.160767
              ],
              [
                49.1604831,
                36.1699846
              ],
              [
                49.1633037,
                36.1764095
              ],
              [
                49.1916376,
                36.1746003
              ],
              [
                49.2148478,
                36.1760321
              ],
              [
                49.228102,
                36.1788114
              ],
              [
                49.2292175,
                36.1785964
              ],
              [
                49.2458842,
                36.1860931
              ],
              [
                49.2481073,
                36.1880394
              ],
              [
                49.2528273,
                36.1927609
              ],
              [
                49.2531074,
                36.1930402
              ],
              [
                49.2661639,
                36.2105382
              ],
              [
                49.2714405,
                36.2249905
              ],
              [
                49.2722737,
                36.2313786
              ],
              [
                49.2722737,
                36.2369287
              ],
              [
                49.2706069,
                36.2491551
              ],
              [
                49.2617172,
                36.2716523
              ],
              [
                49.2539404,
                36.2841575
              ],
              [
                49.2533836,
                36.2852656
              ],
              [
                49.2493958,
                36.2908349
              ],
              [
                49.2492172,
                36.2911037
              ],
              [
                49.2456069,
                36.299158
              ],
              [
                49.2447738,
                36.3027708
              ],
              [
                49.2450502,
                36.3033203
              ],
              [
                49.2464406,
                36.308879
              ],
              [
                49.2464406,
                36.3091583
              ],
              [
                49.2467171,
                36.3099871
              ],
              [
                49.248107,
                36.3169332
              ],
              [
                49.2514402,
                36.3180503
              ],
              [
                49.2883868,
                36.3485995
              ],
              [
                49.2886632,
                36.3491581
              ],
              [
                49.2925532,
                36.3533292
              ],
              [
                49.3031096,
                36.3786072
              ],
              [
                49.3048813,
                36.3914748
              ],
              [
                49.3065477,
                36.394258
              ],
              [
                49.2729622,
                36.390203
              ],
              [
                49.2669967,
                36.3927682
              ],
              [
                49.26644,
                36.3930475
              ],
              [
                49.2356038,
                36.3992007
              ],
              [
                49.2015212,
                36.4076573
              ],
              [
                49.153171,
                36.4197651
              ],
              [
                49.1509475,
                36.419765
              ],
              [
                49.1492811,
                36.4194858
              ],
              [
                49.1487245,
                36.419765
              ],
              [
                49.1473346,
                36.4194858
              ],
              [
                49.1440009,
                36.4194858
              ],
              [
                49.1426145,
                36.419765
              ],
              [
                49.1403911,
                36.419765
              ],
              [
                49.138168,
                36.4192065
              ],
              [
                49.1205981,
                36.4294398
              ],
              [
                49.120045,
                36.4294398
              ],
              [
                49.1203216,
                36.4288813
              ],
              [
                49.1208782,
                36.4269356
              ],
              [
                49.1211548,
                36.4252692
              ],
              [
                49.1214313,
                36.4241612
              ],
              [
                49.1217114,
                36.4230442
              ],
              [
                49.1306014,
                36.4063794
              ],
              [
                49.1400446,
                36.3991549
              ],
              [
                49.1406013,
                36.3988846
              ],
              [
                49.1408779,
                36.3983261
              ],
              [
                49.167268,
                36.3619322
              ],
              [
                49.167268,
                36.361653
              ],
              [
                49.1683813,
                36.3572116
              ],
              [
                49.1631012,
                36.3385996
              ],
              [
                49.1531015,
                36.3241583
              ],
              [
                49.1456017,
                36.3166537
              ],
              [
                49.1453251,
                36.3163744
              ],
              [
                49.131435,
                36.3027706
              ],
              [
                49.1311549,
                36.3024913
              ],
              [
                49.1103221,
                36.2883196
              ],
              [
                49.1097654,
                36.2880402
              ],
              [
                49.1019887,
                36.2852654
              ],
              [
                49.0986554,
                36.2780397
              ],
              [
                49.098932,
                36.2772108
              ],
              [
                49.1003223,
                36.2749855
              ],
              [
                49.1103221,
                36.2672103
              ],
              [
                49.1130987,
                36.2661021
              ],
              [
                49.1158789,
                36.2661021
              ],
              [
                49.1180985,
                36.266931
              ],
              [
                49.1186555,
                36.2672103
              ],
              [
                49.1347684,
                36.2763821
              ],
              [
                49.1425451,
                36.2780398
              ],
              [
                49.1481018,
                36.2780399
              ],
              [
                49.1483784,
                36.2777605
              ],
              [
                49.1508781,
                36.2766524
              ],
              [
                49.1550449,
                36.2705439
              ],
              [
                49.1558782,
                36.2674897
              ],
              [
                49.1558782,
                36.2672103
              ],
              [
                49.1561583,
                36.2663815
              ],
              [
                49.1564348,
                36.2655436
              ],
              [
                49.1647682,
                36.2449924
              ],
              [
                49.1650483,
                36.2447131
              ],
              [
                49.1647683,
                36.2416588
              ],
              [
                49.1636581,
                36.2405415
              ],
              [
                49.1583783,
                36.2380368
              ],
              [
                49.1483785,
                36.2352706
              ],
              [
                49.1475449,
                36.2349823
              ],
              [
                49.1408783,
                36.2338741
              ],
              [
                49.1339352,
                36.2338741
              ],
              [
                49.133102,
                36.2341535
              ],
              [
                49.1319887,
                36.2341534
              ],
              [
                49.1314352,
                36.2344327
              ],
              [
                49.1303218,
                36.2344327
              ],
              [
                49.1119887,
                36.2394332
              ],
              [
                49.111432,
                36.2399828
              ],
              [
                49.109489,
                36.2405414
              ],
              [
                49.1025424,
                36.2438751
              ],
              [
                49.0939324,
                36.2508217
              ],
              [
                49.0933757,
                36.2513802
              ],
              [
                49.0925425,
                36.2522091
              ],
              [
                49.0875424,
                36.2624891
              ],
              [
                49.0875423,
                36.2633181
              ],
              [
                49.0853189,
                36.268877
              ],
              [
                49.0830989,
                36.2722105
              ],
              [
                49.0747659,
                36.2677598
              ],
              [
                49.0686525,
                36.2652641
              ],
              [
                49.0680959,
                36.2649848
              ],
              [
                49.0508764,
                36.2599845
              ],
              [
                49.0467059,
                36.2594348
              ],
              [
                49.0442063,
                36.2594348
              ],
              [
                49.0436528,
                36.2591555
              ],
              [
                49.0397628,
                36.2591555
              ],
              [
                49.0392062,
                36.2588762
              ],
              [
                49.0369862,
                36.2588763
              ],
              [
                49.0367061,
                36.2585969
              ],
              [
                49.0355963,
                36.2585969
              ],
              [
                49.0353198,
                36.2583176
              ],
              [
                49.0344862,
                36.2583176
              ],
              [
                49.016983,
                36.2499926
              ],
              [
                49.0161498,
                36.249425
              ],
              [
                49.0017066,
                36.2447128
              ],
              [
                49.0005933,
                36.2447128
              ],
              [
                49.0000402,
                36.2444335
              ],
              [
                48.9992069,
                36.2444335
              ],
              [
                48.9989268,
                36.2441541
              ],
              [
                48.9975401,
                36.2441542
              ],
              [
                48.99726,
                36.2438748
              ],
              [
                48.9964268,
                36.2438749
              ],
              [
                48.9958736,
                36.2435956
              ],
              [
                48.9944834,
                36.2435955
              ],
              [
                48.9942068,
                36.2433162
              ],
              [
                48.9919834,
                36.2433163
              ],
              [
                48.9914267,
                36.2430369
              ],
              [
                48.9900368,
                36.2430369
              ],
              [
                48.9894837,
                36.2433162
              ],
              [
                48.9855937,
                36.2433162
              ],
              [
                48.9853168,
                36.2435955
              ],
              [
                48.9775369,
                36.2435955
              ],
              [
                48.9769838,
                36.2433162
              ],
              [
                48.9758705,
                36.2433162
              ],
              [
                48.9669804,
                36.2410997
              ],
              [
                48.9655937,
                36.2410998
              ],
              [
                48.9653136,
                36.2408205
              ],
              [
                48.9633706,
                36.2408204
              ],
              [
                48.9628139,
                36.2405411
              ],
              [
                48.9594807,
                36.2405412
              ],
              [
                48.958647,
                36.2402619
              ],
              [
                48.9572607,
                36.2402618
              ],
              [
                48.9567041,
                36.2399825
              ],
              [
                48.9508708,
                36.238604
              ],
              [
                48.9494804,
                36.238604
              ],
              [
                48.9467042,
                36.2374867
              ],
              [
                48.9458707,
                36.2374867
              ],
              [
                48.9455905,
                36.2372075
              ],
              [
                48.9442043,
                36.2372075
              ],
              [
                48.9442043,
                36.2369281
              ],
              [
                48.9347434,
                36.2343935
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555060,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زنجان",
          "name:en": "Zanjan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282142",
          "wikipedia": "en:Zanjan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.4281849,
                36.9573415
              ],
              [
                47.4352387,
                36.9499983
              ],
              [
                47.459685,
                36.9352804
              ],
              [
                47.4602417,
                36.9352803
              ],
              [
                47.4641285,
                36.933615
              ],
              [
                47.4888548,
                36.9236137
              ],
              [
                47.5044114,
                36.9188968
              ],
              [
                47.5055212,
                36.9186177
              ],
              [
                47.5063544,
                36.9186177
              ],
              [
                47.5066314,
                36.9183387
              ],
              [
                47.5124644,
                36.9183387
              ],
              [
                47.5182976,
                36.9191669
              ],
              [
                47.5205211,
                36.9197249
              ],
              [
                47.5216309,
                36.919725
              ],
              [
                47.5233013,
                36.9202832
              ],
              [
                47.5238544,
                36.9202831
              ],
              [
                47.5241486,
                36.9205528
              ],
              [
                47.5263545,
                36.9205532
              ],
              [
                47.5474674,
                36.9302755
              ],
              [
                47.5480241,
                36.9308336
              ],
              [
                47.5716338,
                36.937225
              ],
              [
                47.5724671,
                36.9372251
              ],
              [
                47.5730238,
                36.9375041
              ],
              [
                47.573857,
                36.9375041
              ],
              [
                47.5771902,
                36.9380622
              ],
              [
                47.5799704,
                36.9383322
              ],
              [
                47.5808037,
                36.9386113
              ],
              [
                47.5835803,
                36.9386114
              ],
              [
                47.5838568,
                36.9388904
              ],
              [
                47.5966368,
                36.9388904
              ],
              [
                47.5971903,
                36.9386114
              ],
              [
                47.5999701,
                36.9386114
              ],
              [
                47.6046936,
                36.9380623
              ],
              [
                47.6055269,
                36.9377832
              ],
              [
                47.6094132,
                36.9377832
              ],
              [
                47.6096933,
                36.9375042
              ],
              [
                47.6113602,
                36.9375042
              ],
              [
                47.6202498,
                36.9352807
              ],
              [
                47.6208033,
                36.9352807
              ],
              [
                47.6210835,
                36.9350017
              ],
              [
                47.6219166,
                36.9350016
              ],
              [
                47.6313598,
                36.9302757
              ],
              [
                47.6319165,
                36.9302757
              ],
              [
                47.63636,
                36.9261077
              ],
              [
                47.6371932,
                36.9252796
              ],
              [
                47.6399729,
                36.9216697
              ],
              [
                47.648583,
                36.9044486
              ],
              [
                47.6488596,
                36.9033413
              ],
              [
                47.6505264,
                36.8941678
              ],
              [
                47.6538597,
                36.8863897
              ],
              [
                47.6546965,
                36.8852825
              ],
              [
                47.6546965,
                36.8847243
              ],
              [
                47.6591396,
                36.8797189
              ],
              [
                47.6594165,
                36.8794487
              ],
              [
                47.6624732,
                36.8791697
              ],
              [
                47.6823344,
                36.8726863
              ],
              [
                47.6863629,
                36.8658278
              ],
              [
                47.6866394,
                36.8641623
              ],
              [
                47.6869195,
                36.8627758
              ],
              [
                47.687196,
                36.8625057
              ],
              [
                47.6866395,
                36.8527827
              ],
              [
                47.6896962,
                36.8430504
              ],
              [
                47.6905294,
                36.8405565
              ],
              [
                47.690806,
                36.8402775
              ],
              [
                47.6902529,
                36.8338852
              ],
              [
                47.6896962,
                36.8327778
              ],
              [
                47.6896962,
                36.8319405
              ],
              [
                47.6869197,
                36.8272228
              ],
              [
                47.6769199,
                36.8133307
              ],
              [
                47.6763632,
                36.8111069
              ],
              [
                47.6758066,
                36.8047234
              ],
              [
                47.6760866,
                36.8022204
              ],
              [
                47.6763632,
                36.8005547
              ],
              [
                47.6766398,
                36.8002756
              ],
              [
                47.6774731,
                36.7983309
              ],
              [
                47.6783063,
                36.7963861
              ],
              [
                47.6838631,
                36.7908308
              ],
              [
                47.7046964,
                36.7844472
              ],
              [
                47.7060863,
                36.7844472
              ],
              [
                47.7063628,
                36.7841681
              ],
              [
                47.7074761,
                36.7841681
              ],
              [
                47.7077527,
                36.783889
              ],
              [
                47.709696,
                36.7838891
              ],
              [
                47.7102527,
                36.7836099
              ],
              [
                47.7121996,
                36.7836099
              ],
              [
                47.7130328,
                36.7833307
              ],
              [
                47.7146993,
                36.7833308
              ],
              [
                47.7149763,
                36.7830517
              ],
              [
                47.7294192,
                36.781386
              ],
              [
                47.7316427,
                36.7811159
              ],
              [
                47.7391424,
                36.7786128
              ],
              [
                47.7535893,
                36.7694379
              ],
              [
                47.7783122,
                36.7361137
              ],
              [
                47.7824786,
                36.7333313
              ],
              [
                47.7849788,
                36.7322147
              ],
              [
                47.7855354,
                36.7322147
              ],
              [
                47.786092,
                36.7319356
              ],
              [
                47.7880354,
                36.7316655
              ],
              [
                47.7908121,
                36.7308281
              ],
              [
                47.8027588,
                36.7308281
              ],
              [
                47.803592,
                36.7311072
              ],
              [
                47.8066487,
                36.7311072
              ],
              [
                47.8072019,
                36.7313864
              ],
              [
                47.809982,
                36.7313864
              ],
              [
                47.8108153,
                36.7316655
              ],
              [
                47.8158154,
                36.7316656
              ],
              [
                47.816092,
                36.7313864
              ],
              [
                47.8177584,
                36.7313864
              ],
              [
                47.818315,
                36.7311073
              ],
              [
                47.8191487,
                36.7311073
              ],
              [
                47.8199818,
                36.7308282
              ],
              [
                47.8210917,
                36.7308282
              ],
              [
                47.8219253,
                36.730549
              ],
              [
                47.8258152,
                36.7299998
              ],
              [
                47.835815,
                36.7249933
              ],
              [
                47.8435949,
                36.7172134
              ],
              [
                47.8480384,
                36.7111083
              ],
              [
                47.8499814,
                36.708605
              ],
              [
                47.8502615,
                36.7083259
              ],
              [
                47.8505381,
                36.7074974
              ],
              [
                47.8513717,
                36.7066691
              ],
              [
                47.8516482,
                36.7058316
              ],
              [
                47.8522049,
                36.7052733
              ],
              [
                47.8635947,
                36.6761065
              ],
              [
                47.8638717,
                36.6758273
              ],
              [
                47.8638717,
                36.6741614
              ],
              [
                47.8644283,
                36.6708295
              ],
              [
                47.8635948,
                36.6624907
              ],
              [
                47.862485,
                36.6611129
              ],
              [
                47.8616518,
                36.6599963
              ],
              [
                47.8622049,
                36.659438
              ],
              [
                47.862485,
                36.6588796
              ],
              [
                47.8855413,
                36.6499915
              ],
              [
                47.8891512,
                36.6494422
              ],
              [
                47.8919278,
                36.6494422
              ],
              [
                47.8927611,
                36.6491629
              ],
              [
                47.8966515,
                36.649163
              ],
              [
                47.897208,
                36.6488838
              ],
              [
                47.9030414,
                36.6488839
              ],
              [
                47.9041511,
                36.649163
              ],
              [
                47.9063746,
                36.649163
              ],
              [
                47.9072079,
                36.6494422
              ],
              [
                47.9116509,
                36.6494421
              ],
              [
                47.911931,
                36.6497214
              ],
              [
                47.9238743,
                36.6516575
              ],
              [
                47.9263743,
                36.6522159
              ],
              [
                47.9274876,
                36.6522159
              ],
              [
                47.9558206,
                36.6611131
              ],
              [
                47.9658204,
                36.6669395
              ],
              [
                47.9658288,
                36.6669438
              ],
              [
                47.966377,
                36.6672211
              ],
              [
                47.9663771,
                36.6669395
              ],
              [
                47.9661006,
                36.6449936
              ],
              [
                47.9669338,
                36.6402748
              ],
              [
                47.9672105,
                36.6324941
              ],
              [
                47.9686007,
                36.6216602
              ],
              [
                47.9686007,
                36.6208317
              ],
              [
                47.9686007,
                36.619715
              ],
              [
                47.9644338,
                36.6016584
              ],
              [
                47.9647109,
                36.6008298
              ],
              [
                47.9644339,
                36.6002714
              ],
              [
                47.9633205,
                36.598047
              ],
              [
                47.9572107,
                36.590554
              ],
              [
                47.9561009,
                36.590554
              ],
              [
                47.9538774,
                36.5899955
              ],
              [
                47.9497109,
                36.5899956
              ],
              [
                47.9488778,
                36.5902748
              ],
              [
                47.943321,
                36.5902748
              ],
              [
                47.9427643,
                36.5899956
              ],
              [
                47.9416541,
                36.5899956
              ],
              [
                47.9410975,
                36.5897164
              ],
              [
                47.9399877,
                36.5897163
              ],
              [
                47.9308212,
                36.5858257
              ],
              [
                47.9299879,
                36.5841596
              ],
              [
                47.9294313,
                36.583322
              ],
              [
                47.9291543,
                36.5799897
              ],
              [
                47.9327645,
                36.5711006
              ],
              [
                47.9333213,
                36.5708304
              ],
              [
                47.9402644,
                36.5494402
              ],
              [
                47.9405444,
                36.5486026
              ],
              [
                47.9408211,
                36.5480443
              ],
              [
                47.940821,
                36.5474948
              ],
              [
                47.9410976,
                36.5466573
              ],
              [
                47.9413777,
                36.5460988
              ],
              [
                47.9416543,
                36.5455494
              ],
              [
                47.9480443,
                36.5280495
              ],
              [
                47.9483209,
                36.5269417
              ],
              [
                47.9485978,
                36.5266624
              ],
              [
                47.9485979,
                36.5255456
              ],
              [
                47.9491545,
                36.5241586
              ],
              [
                47.9494311,
                36.5227715
              ],
              [
                47.9497112,
                36.5199884
              ],
              [
                47.9499878,
                36.5197092
              ],
              [
                47.9485979,
                36.5122155
              ],
              [
                47.9480444,
                36.5105492
              ],
              [
                47.9469311,
                36.5083244
              ],
              [
                47.946378,
                36.5049918
              ],
              [
                47.9460978,
                36.5033255
              ],
              [
                47.9458213,
                36.5005514
              ],
              [
                47.946098,
                36.4988851
              ],
              [
                47.9491546,
                36.4927692
              ],
              [
                47.954431,
                36.4866533
              ],
              [
                47.9547111,
                36.4855454
              ],
              [
                47.954988,
                36.4852753
              ],
              [
                47.954431,
                36.4786009
              ],
              [
                47.9541545,
                36.4780514
              ],
              [
                47.9530446,
                36.477493
              ],
              [
                47.9555447,
                36.477493
              ],
              [
                47.960821,
                36.4783216
              ],
              [
                47.9616545,
                36.4786009
              ],
              [
                47.9661011,
                36.4786009
              ],
              [
                47.9666544,
                36.4783216
              ],
              [
                47.9716544,
                36.4783217
              ],
              [
                47.9752678,
                36.4780515
              ],
              [
                47.9758244,
                36.4777722
              ],
              [
                47.9780444,
                36.4777723
              ],
              [
                47.978601,
                36.477493
              ],
              [
                47.9811011,
                36.4774931
              ],
              [
                47.9813776,
                36.4772138
              ],
              [
                47.9844344,
                36.4772138
              ],
              [
                47.990824,
                36.4763852
              ],
              [
                47.9913775,
                36.4761059
              ],
              [
                47.993324,
                36.4761059
              ],
              [
                47.9936006,
                36.4758267
              ],
              [
                47.9977675,
                36.4758267
              ],
              [
                47.9980475,
                36.4755475
              ],
              [
                47.9986006,
                36.4755475
              ],
              [
                47.9992631,
                36.4755585
              ],
              [
                48.0041574,
                36.4763851
              ],
              [
                48.0049907,
                36.4763851
              ],
              [
                48.0055473,
                36.4761059
              ],
              [
                48.0086005,
                36.476106
              ],
              [
                48.0091571,
                36.4758268
              ],
              [
                48.0122139,
                36.4758268
              ],
              [
                48.0124904,
                36.4761059
              ],
              [
                48.0155471,
                36.476106
              ],
              [
                48.0158237,
                36.4758267
              ],
              [
                48.0166573,
                36.4758268
              ],
              [
                48.0202703,
                36.4758267
              ],
              [
                48.0208238,
                36.4761059
              ],
              [
                48.0222137,
                36.476106
              ],
              [
                48.0224902,
                36.4763852
              ],
              [
                48.0255469,
                36.4766555
              ],
              [
                48.0299904,
                36.4766554
              ],
              [
                48.0302705,
                36.4769347
              ],
              [
                48.034437,
                36.4769347
              ],
              [
                48.0347136,
                36.4772139
              ],
              [
                48.036937,
                36.4772139
              ],
              [
                48.0372137,
                36.4774932
              ],
              [
                48.0405469,
                36.4774931
              ],
              [
                48.040827,
                36.4777724
              ],
              [
                48.0463803,
                36.4777723
              ],
              [
                48.0466603,
                36.4774932
              ],
              [
                48.04916,
                36.4774931
              ],
              [
                48.049437,
                36.477214
              ],
              [
                48.0499936,
                36.477214
              ],
              [
                48.0558269,
                36.4747099
              ],
              [
                48.0561035,
                36.4744397
              ],
              [
                48.0577699,
                36.4724942
              ],
              [
                48.0572168,
                36.4705484
              ],
              [
                48.0477701,
                36.4602709
              ],
              [
                48.0474936,
                36.4566589
              ],
              [
                48.0477702,
                36.4563798
              ],
              [
                48.0477701,
                36.455542
              ],
              [
                48.0544367,
                36.4522092
              ],
              [
                48.05777,
                36.4522092
              ],
              [
                48.0588833,
                36.4524884
              ],
              [
                48.06027,
                36.4527677
              ],
              [
                48.0613833,
                36.4527677
              ],
              [
                48.0622166,
                36.4524885
              ],
              [
                48.0633268,
                36.4524885
              ],
              [
                48.06416,
                36.4527677
              ],
              [
                48.0680499,
                36.4527677
              ],
              [
                48.0686034,
                36.453047
              ],
              [
                48.0711066,
                36.453047
              ],
              [
                48.0716598,
                36.4533262
              ],
              [
                48.0744399,
                36.4533262
              ],
              [
                48.0749935,
                36.4536055
              ],
              [
                48.0844398,
                36.4558213
              ],
              [
                48.1005494,
                36.4630454
              ],
              [
                48.1069393,
                36.4691615
              ],
              [
                48.1080527,
                36.4702694
              ],
              [
                48.1169392,
                36.4788805
              ],
              [
                48.1177727,
                36.4788805
              ],
              [
                48.1180529,
                36.4791596
              ],
              [
                48.1188861,
                36.4791597
              ],
              [
                48.1197193,
                36.4794389
              ],
              [
                48.1208295,
                36.4794389
              ],
              [
                48.1211061,
                36.4797182
              ],
              [
                48.1236061,
                36.4802676
              ],
              [
                48.1252726,
                36.4802676
              ],
              [
                48.1258292,
                36.4805469
              ],
              [
                48.1311094,
                36.4805468
              ],
              [
                48.1313859,
                36.4802676
              ],
              [
                48.1330524,
                36.4802676
              ],
              [
                48.133886,
                36.4805469
              ],
              [
                48.1361091,
                36.4805468
              ],
              [
                48.1363857,
                36.4808261
              ],
              [
                48.1380525,
                36.4808261
              ],
              [
                48.1388857,
                36.4811053
              ],
              [
                48.1424955,
                36.4811053
              ],
              [
                48.1430522,
                36.480826
              ],
              [
                48.1441624,
                36.480826
              ],
              [
                48.144719,
                36.4805468
              ],
              [
                48.1463855,
                36.4805468
              ],
              [
                48.1472191,
                36.4802677
              ],
              [
                48.1530525,
                36.4797182
              ],
              [
                48.1538856,
                36.479439
              ],
              [
                48.1552756,
                36.479439
              ],
              [
                48.1558322,
                36.4791597
              ],
              [
                48.1566654,
                36.4791597
              ],
              [
                48.1572189,
                36.4788806
              ],
              [
                48.1580521,
                36.4788806
              ],
              [
                48.1586088,
                36.4786013
              ],
              [
                48.1597191,
                36.4786013
              ],
              [
                48.1605521,
                36.4783221
              ],
              [
                48.1713887,
                36.476935
              ],
              [
                48.1744419,
                36.476935
              ],
              [
                48.1755553,
                36.4766558
              ],
              [
                48.1791655,
                36.4766557
              ],
              [
                48.1797222,
                36.476935
              ],
              [
                48.1811085,
                36.476935
              ],
              [
                48.1813886,
                36.4766558
              ],
              [
                48.1858321,
                36.4763855
              ],
              [
                48.1858321,
                36.4777726
              ],
              [
                48.1861118,
                36.4783222
              ],
              [
                48.1863887,
                36.4836095
              ],
              [
                48.1841652,
                36.4938776
              ],
              [
                48.1799987,
                36.5049923
              ],
              [
                48.1797221,
                36.5055418
              ],
              [
                48.1802752,
                36.513603
              ],
              [
                48.1830552,
                36.5169356
              ],
              [
                48.1841651,
                36.5186018
              ],
              [
                48.2002783,
                36.5324904
              ],
              [
                48.2008315,
                36.5327696
              ],
              [
                48.2044448,
                36.534715
              ],
              [
                48.2116679,
                36.5394346
              ],
              [
                48.2122215,
                36.5402722
              ],
              [
                48.2169446,
                36.5430462
              ],
              [
                48.2227779,
                36.5488824
              ],
              [
                48.2238912,
                36.5499903
              ],
              [
                48.2250014,
                36.5508279
              ],
              [
                48.2375008,
                36.5608251
              ],
              [
                48.2422244,
                36.5627705
              ],
              [
                48.2430576,
                36.5627704
              ],
              [
                48.2458343,
                36.563608
              ],
              [
                48.2469476,
                36.5636081
              ],
              [
                48.2477807,
                36.5638872
              ],
              [
                48.2500007,
                36.5638872
              ],
              [
                48.2505574,
                36.5641664
              ],
              [
                48.2544477,
                36.5644366
              ],
              [
                48.2655574,
                36.5638873
              ],
              [
                48.2669472,
                36.563329
              ],
              [
                48.2683374,
                36.5633289
              ],
              [
                48.2686141,
                36.5630497
              ],
              [
                48.2691706,
                36.5630497
              ],
              [
                48.2694473,
                36.5627705
              ],
              [
                48.2705574,
                36.5627705
              ],
              [
                48.2708375,
                36.5624913
              ],
              [
                48.2722239,
                36.5624913
              ],
              [
                48.272224,
                36.5622121
              ],
              [
                48.2733372,
                36.5619419
              ],
              [
                48.2747239,
                36.5619419
              ],
              [
                48.2752806,
                36.5616627
              ],
              [
                48.2774788,
                36.5616628
              ],
              [
                48.28265,
                36.5616766
              ],
              [
                48.2832076,
                36.5617297
              ],
              [
                48.2854386,
                36.5619419
              ],
              [
                48.2880605,
                36.5619419
              ],
              [
                48.2886135,
                36.5619419
              ],
              [
                48.2958369,
                36.5630498
              ],
              [
                48.300837,
                36.5630497
              ],
              [
                48.3011171,
                36.5627706
              ],
              [
                48.3033371,
                36.5627706
              ],
              [
                48.3038937,
                36.5624913
              ],
              [
                48.3050035,
                36.5624914
              ],
              [
                48.3055601,
                36.5622122
              ],
              [
                48.3119502,
                36.5608252
              ],
              [
                48.3130603,
                36.5602668
              ],
              [
                48.3211168,
                36.5583305
              ],
              [
                48.3225066,
                36.5583305
              ],
              [
                48.3252833,
                36.5574929
              ],
              [
                48.3263935,
                36.5574929
              ],
              [
                48.3363968,
                36.5536021
              ],
              [
                48.3372299,
                36.5530437
              ],
              [
                48.3377831,
                36.5527735
              ],
              [
                48.3425067,
                36.5466581
              ],
              [
                48.3400067,
                36.5349945
              ],
              [
                48.3419501,
                36.5322114
              ],
              [
                48.3552867,
                36.5202685
              ],
              [
                48.3566731,
                36.5188815
              ],
              [
                48.3661199,
                36.5141619
              ],
              [
                48.3672296,
                36.5141619
              ],
              [
                48.3680632,
                36.5138827
              ],
              [
                48.369173,
                36.5138826
              ],
              [
                48.3700062,
                36.5136034
              ],
              [
                48.3716766,
                36.5136035
              ],
              [
                48.3719531,
                36.5133242
              ],
              [
                48.3750099,
                36.5133243
              ],
              [
                48.375843,
                36.5136034
              ],
              [
                48.3780631,
                36.5136035
              ],
              [
                48.3791764,
                36.5138827
              ],
              [
                48.3847296,
                36.5138826
              ],
              [
                48.3858429,
                36.5141619
              ],
              [
                48.390286,
                36.5141619
              ],
              [
                48.3911195,
                36.5144411
              ],
              [
                48.3925095,
                36.5144411
              ],
              [
                48.3950095,
                36.5149906
              ],
              [
                48.3963994,
                36.5149906
              ],
              [
                48.3975095,
                36.5152697
              ],
              [
                48.3997326,
                36.5152697
              ],
              [
                48.4008429,
                36.5155489
              ],
              [
                48.4052859,
                36.515549
              ],
              [
                48.4080661,
                36.5161075
              ],
              [
                48.4100094,
                36.5161074
              ],
              [
                48.4111227,
                36.5163867
              ],
              [
                48.4130658,
                36.5163867
              ],
              [
                48.414176,
                36.5166659
              ],
              [
                48.4155657,
                36.5163866
              ],
              [
                48.4188991,
                36.5163867
              ],
              [
                48.4197323,
                36.5161074
              ],
              [
                48.4211226,
                36.5161075
              ],
              [
                48.425009,
                36.5149906
              ],
              [
                48.4280657,
                36.514162
              ],
              [
                48.4283458,
                36.5138828
              ],
              [
                48.4350124,
                36.5105502
              ],
              [
                48.4408457,
                36.5069384
              ],
              [
                48.448622,
                36.5047137
              ],
              [
                48.4497357,
                36.5047137
              ],
              [
                48.4505689,
                36.5044345
              ],
              [
                48.4525124,
                36.5041643
              ],
              [
                48.455012,
                36.5041643
              ],
              [
                48.4558456,
                36.5038851
              ],
              [
                48.4597355,
                36.5038851
              ],
              [
                48.4608454,
                36.5041643
              ],
              [
                48.4625121,
                36.5041643
              ],
              [
                48.4636219,
                36.5038851
              ],
              [
                48.4664021,
                36.5038851
              ],
              [
                48.4669587,
                36.5036059
              ],
              [
                48.4680686,
                36.5036059
              ],
              [
                48.4691788,
                36.5033267
              ],
              [
                48.4705686,
                36.5033266
              ],
              [
                48.4719585,
                36.5030475
              ],
              [
                48.4752918,
                36.5030474
              ],
              [
                48.4764019,
                36.5027682
              ],
              [
                48.5025151,
                36.4966615
              ],
              [
                48.5033482,
                36.4961031
              ],
              [
                48.5058483,
                36.4952744
              ],
              [
                48.506405,
                36.494716
              ],
              [
                48.5069581,
                36.494716
              ],
              [
                48.5294614,
                36.4799983
              ],
              [
                48.5597409,
                36.4586057
              ],
              [
                48.5616843,
                36.4574887
              ],
              [
                48.5655743,
                36.4561015
              ],
              [
                48.5650176,
                36.4566601
              ],
              [
                48.564741,
                36.4569393
              ],
              [
                48.5647411,
                36.4572185
              ],
              [
                48.5630742,
                36.4608216
              ],
              [
                48.5627946,
                36.4611008
              ],
              [
                48.561961,
                36.4630464
              ],
              [
                48.5619609,
                36.4633256
              ],
              [
                48.5586275,
                36.4699911
              ],
              [
                48.558071,
                36.4708288
              ],
              [
                48.5577944,
                36.4722159
              ],
              [
                48.5580709,
                36.4766566
              ],
              [
                48.5650176,
                36.4844389
              ],
              [
                48.5858507,
                36.495824
              ],
              [
                48.586964,
                36.4966617
              ],
              [
                48.5939072,
                36.4991566
              ],
              [
                48.5950174,
                36.4996028
              ],
              [
                48.5980737,
                36.5002735
              ],
              [
                48.5982255,
                36.5003013
              ],
              [
                48.5983538,
                36.5002735
              ],
              [
                48.6016871,
                36.5016606
              ],
              [
                48.6025206,
                36.5022191
              ],
              [
                48.6214102,
                36.5077675
              ],
              [
                48.6247434,
                36.5077675
              ],
              [
                48.6261301,
                36.5080467
              ],
              [
                48.6286301,
                36.5080466
              ],
              [
                48.6689108,
                36.5298888
              ],
              [
                48.6908566,
                36.5393302
              ],
              [
                48.7008591,
                36.5432072
              ],
              [
                48.7098646,
                36.5474876
              ],
              [
                48.7125052,
                36.5489735
              ],
              [
                48.7145197,
                36.5489115
              ],
              [
                48.7244987,
                36.5542558
              ],
              [
                48.7352881,
                36.5568411
              ],
              [
                48.7357281,
                36.5581243
              ],
              [
                48.7373256,
                36.5608024
              ],
              [
                48.7376961,
                36.5640568
              ],
              [
                48.7395483,
                36.5674599
              ],
              [
                48.7442388,
                36.5673123
              ],
              [
                48.745999,
                36.5669226
              ],
              [
                48.7536256,
                36.5657491
              ],
              [
                48.7640446,
                36.566121
              ],
              [
                48.7670545,
                36.5666417
              ],
              [
                48.7697866,
                36.5666045
              ],
              [
                48.780194,
                36.5686036
              ],
              [
                48.7807211,
                36.5710646
              ],
              [
                48.786596,
                36.5753441
              ],
              [
                48.7916897,
                36.5805874
              ],
              [
                48.7995387,
                36.5902549
              ],
              [
                48.8040884,
                36.5967938
              ],
              [
                48.8074803,
                36.6028582
              ],
              [
                48.8197979,
                36.6302881
              ],
              [
                48.8259103,
                36.6470831
              ],
              [
                48.8322081,
                36.6553307
              ],
              [
                48.8407285,
                36.6640231
              ],
              [
                48.8457296,
                36.6681089
              ],
              [
                48.8472519,
                36.667752
              ],
              [
                48.8491247,
                36.6682844
              ],
              [
                48.850909,
                36.6689812
              ],
              [
                48.8553535,
                36.6708549
              ],
              [
                48.8626177,
                36.6753413
              ],
              [
                48.8662537,
                36.6766424
              ],
              [
                48.8667603,
                36.6776849
              ],
              [
                48.869022,
                36.6790653
              ],
              [
                48.8695313,
                36.6806622
              ],
              [
                48.8755512,
                36.6832618
              ],
              [
                48.8896022,
                36.687741
              ],
              [
                48.8903088,
                36.6933951
              ],
              [
                48.8910495,
                36.6974857
              ],
              [
                48.892019,
                36.7030963
              ],
              [
                48.8930843,
                36.7080439
              ],
              [
                48.8941037,
                36.7123574
              ],
              [
                48.8958633,
                36.7170672
              ],
              [
                48.8989194,
                36.7227686
              ],
              [
                48.9069762,
                36.7452824
              ],
              [
                48.9058664,
                36.7477766
              ],
              [
                48.9023565,
                36.7527896
              ],
              [
                48.9035987,
                36.7540464
              ],
              [
                48.9008372,
                36.7558136
              ],
              [
                48.8970726,
                36.7630362
              ],
              [
                48.8958699,
                36.7671122
              ],
              [
                48.8937376,
                36.7697084
              ],
              [
                48.8835091,
                36.7756727
              ],
              [
                48.8696995,
                36.7787432
              ],
              [
                48.8615353,
                36.7794307
              ],
              [
                48.8580727,
                36.7797221
              ],
              [
                48.8541461,
                36.7800524
              ],
              [
                48.8477407,
                36.7805909
              ],
              [
                48.8461277,
                36.7807265
              ],
              [
                48.8423804,
                36.7841095
              ],
              [
                48.8380848,
                36.7854018
              ],
              [
                48.8348857,
                36.7880844
              ],
              [
                48.8245197,
                36.7931484
              ],
              [
                48.8166098,
                36.8016825
              ],
              [
                48.8109047,
                36.8078363
              ],
              [
                48.8105331,
                36.808237
              ],
              [
                48.8065849,
                36.8124949
              ],
              [
                48.7975718,
                36.8206366
              ],
              [
                48.795584,
                36.8244432
              ],
              [
                48.7955841,
                36.8255596
              ],
              [
                48.800304,
                36.8288908
              ],
              [
                48.8014173,
                36.8291699
              ],
              [
                48.8075272,
                36.82944
              ],
              [
                48.8111406,
                36.8308355
              ],
              [
                48.812527,
                36.8313847
              ],
              [
                48.8141938,
                36.8327802
              ],
              [
                48.8147505,
                36.8361115
              ],
              [
                48.8119738,
                36.8422245
              ],
              [
                48.8094737,
                36.8461138
              ],
              [
                48.8080839,
                36.8488957
              ],
              [
                48.806694,
                36.8502822
              ],
              [
                48.8055837,
                36.8519477
              ],
              [
                48.7950272,
                36.8608426
              ],
              [
                48.7905838,
                36.8625081
              ],
              [
                48.7825273,
                36.8636154
              ],
              [
                48.7805809,
                36.8636154
              ],
              [
                48.7758608,
                36.8644437
              ],
              [
                48.7750276,
                36.8641646
              ],
              [
                48.7739143,
                36.8641645
              ],
              [
                48.7733608,
                36.8641646
              ],
              [
                48.7589144,
                36.8602843
              ],
              [
                48.7555811,
                36.8588889
              ],
              [
                48.7528045,
                36.8580606
              ],
              [
                48.7519712,
                36.8575024
              ],
              [
                48.7491912,
                36.8569443
              ],
              [
                48.7483579,
                36.8563861
              ],
              [
                48.7478013,
                36.8563861
              ],
              [
                48.7472477,
                36.856107
              ],
              [
                48.7469677,
                36.856107
              ],
              [
                48.7457805,
                36.8564414
              ],
              [
                48.7380811,
                36.8586097
              ],
              [
                48.7369678,
                36.8586098
              ],
              [
                48.7286348,
                36.8611125
              ],
              [
                48.7247445,
                36.862508
              ],
              [
                48.7128016,
                36.8686119
              ],
              [
                48.7091883,
                36.8722219
              ],
              [
                48.7078014,
                36.8744455
              ],
              [
                48.7041881,
                36.882782
              ],
              [
                48.703648,
                36.8843992
              ],
              [
                48.6648884,
                36.9066032
              ],
              [
                48.6505086,
                36.9182004
              ],
              [
                48.6475188,
                36.9191693
              ],
              [
                48.6447422,
                36.9191693
              ],
              [
                48.6352955,
                36.9208347
              ],
              [
                48.6339087,
                36.9208347
              ],
              [
                48.6272422,
                36.9225001
              ],
              [
                48.6041858,
                36.9261099
              ],
              [
                48.5983525,
                36.9272261
              ],
              [
                48.596406,
                36.927226
              ],
              [
                48.5950161,
                36.9275051
              ],
              [
                48.5930727,
                36.9275052
              ],
              [
                48.5916824,
                36.9277842
              ],
              [
                48.5891828,
                36.9277842
              ],
              [
                48.5880725,
                36.9280633
              ],
              [
                48.5855725,
                36.9280633
              ],
              [
                48.5808493,
                36.9286213
              ],
              [
                48.5789243,
                36.9287461
              ],
              [
                48.5766829,
                36.9288914
              ],
              [
                48.5672396,
                36.9299986
              ],
              [
                48.5644595,
                36.9305568
              ],
              [
                48.5627931,
                36.9305568
              ],
              [
                48.5530698,
                36.9327802
              ],
              [
                48.5519597,
                36.9333383
              ],
              [
                48.5511264,
                36.9333383
              ],
              [
                48.5330697,
                36.9430603
              ],
              [
                48.5252934,
                36.946391
              ],
              [
                48.5025136,
                36.9500006
              ],
              [
                48.5022335,
                36.9502797
              ],
              [
                48.5014003,
                36.9500007
              ],
              [
                48.5011237,
                36.9502797
              ],
              [
                48.5002901,
                36.9500006
              ],
              [
                48.4941802,
                36.9500007
              ],
              [
                48.4936235,
                36.9502797
              ],
              [
                48.4925137,
                36.9502796
              ],
              [
                48.4916805,
                36.9505587
              ],
              [
                48.4911234,
                36.9505587
              ],
              [
                48.4900137,
                36.9508378
              ],
              [
                48.4886238,
                36.9547265
              ],
              [
                48.4886238,
                36.9608386
              ],
              [
                48.4883468,
                36.9616668
              ],
              [
                48.4867264,
                36.9726045
              ],
              [
                48.4861236,
                36.9766723
              ],
              [
                48.4861236,
                36.9808399
              ],
              [
                48.4858471,
                36.9825051
              ],
              [
                48.4818713,
                36.99412
              ],
              [
                48.4817523,
                37.0124039
              ],
              [
                48.5095796,
                37.045483
              ],
              [
                48.5180281,
                37.0447649
              ],
              [
                48.56379,
                37.0727874
              ],
              [
                48.5649715,
                37.0797298
              ],
              [
                48.5612392,
                37.0873402
              ],
              [
                48.5604179,
                37.0915295
              ],
              [
                48.5600961,
                37.1016553
              ],
              [
                48.56183,
                37.1107356
              ],
              [
                48.5627718,
                37.114105
              ],
              [
                48.5635447,
                37.1165488
              ],
              [
                48.565251,
                37.121159
              ],
              [
                48.5597312,
                37.1183228
              ],
              [
                48.5561263,
                37.1194606
              ],
              [
                48.5497159,
                37.1194413
              ],
              [
                48.5475111,
                37.1210261
              ],
              [
                48.5469317,
                37.1230279
              ],
              [
                48.5476827,
                37.1269458
              ],
              [
                48.5476613,
                37.1315991
              ],
              [
                48.5451937,
                37.1352599
              ],
              [
                48.5380053,
                37.1349862
              ],
              [
                48.534497,
                37.1351744
              ],
              [
                48.5308814,
                37.135756
              ],
              [
                48.528403,
                37.1363633
              ],
              [
                48.5251522,
                37.1362863
              ],
              [
                48.5216117,
                37.1362008
              ],
              [
                48.5182214,
                37.135833
              ],
              [
                48.5155177,
                37.1360982
              ],
              [
                48.5119343,
                37.1369535
              ],
              [
                48.5086298,
                37.1387325
              ],
              [
                48.5059905,
                37.1404943
              ],
              [
                48.5041451,
                37.1436929
              ],
              [
                48.50039,
                37.1486188
              ],
              [
                48.4981155,
                37.1550237
              ],
              [
                48.4955406,
                37.1594444
              ],
              [
                48.4966564,
                37.1639931
              ],
              [
                48.4972465,
                37.1656261
              ],
              [
                48.4957445,
                37.1673617
              ],
              [
                48.4938347,
                37.1694478
              ],
              [
                48.4927833,
                37.169747
              ],
              [
                48.4914207,
                37.1702428
              ],
              [
                48.4911096,
                37.1706019
              ],
              [
                48.4912491,
                37.1717988
              ],
              [
                48.492279,
                37.172893
              ],
              [
                48.4944463,
                37.1739702
              ],
              [
                48.4959376,
                37.1753807
              ],
              [
                48.4947145,
                37.1776717
              ],
              [
                48.4920645,
                37.1797917
              ],
              [
                48.4891248,
                37.1799969
              ],
              [
                48.487494,
                37.1798772
              ],
              [
                48.4850585,
                37.1796207
              ],
              [
                48.4830737,
                37.1791848
              ],
              [
                48.4803378,
                37.1784582
              ],
              [
                48.4790289,
                37.1787317
              ],
              [
                48.4782886,
                37.1794669
              ],
              [
                48.4808528,
                37.1819629
              ],
              [
                48.4850156,
                37.1839032
              ],
              [
                48.4868288,
                37.1858008
              ],
              [
                48.4869468,
                37.1895445
              ],
              [
                48.4872687,
                37.1925786
              ],
              [
                48.4891784,
                37.1957921
              ],
              [
                48.4887493,
                37.198279
              ],
              [
                48.487376,
                37.1993729
              ],
              [
                48.4809279,
                37.200783
              ],
              [
                48.4792864,
                37.2026887
              ],
              [
                48.4784335,
                37.2037697
              ],
              [
                48.477425,
                37.2045558
              ],
              [
                48.4761482,
                37.2053591
              ],
              [
                48.4757405,
                37.2062307
              ],
              [
                48.4764004,
                37.2071023
              ],
              [
                48.4777576,
                37.2071621
              ],
              [
                48.4826875,
                37.2084182
              ],
              [
                48.4818774,
                37.2100033
              ],
              [
                48.480531,
                37.2106313
              ],
              [
                48.4795868,
                37.2106997
              ],
              [
                48.4779882,
                37.2111397
              ],
              [
                48.4760034,
                37.2111824
              ],
              [
                48.4750593,
                37.211379
              ],
              [
                48.4720069,
                37.2116481
              ],
              [
                48.4694427,
                37.2126094
              ],
              [
                48.4680802,
                37.2127803
              ],
              [
                48.4649849,
                37.2131904
              ],
              [
                48.4638476,
                37.212729
              ],
              [
                48.4641051,
                37.2113619
              ],
              [
                48.4633755,
                37.2097897
              ],
              [
                48.4634507,
                37.2086724
              ],
              [
                48.4625199,
                37.2081106
              ],
              [
                48.460586,
                37.2089865
              ],
              [
                48.4602642,
                37.2086959
              ],
              [
                48.457582,
                37.210422
              ],
              [
                48.4560478,
                37.2104989
              ],
              [
                48.4541595,
                37.2099862
              ],
              [
                48.4537679,
                37.2082003
              ],
              [
                48.4521854,
                37.2076812
              ],
              [
                48.4509301,
                37.2082345
              ],
              [
                48.4463811,
                37.2104049
              ],
              [
                48.442347,
                37.2118575
              ],
              [
                48.4375191,
                37.2153265
              ],
              [
                48.4303187,
                37.221039
              ],
              [
                48.4265327,
                37.2213413
              ],
              [
                48.4214902,
                37.222674
              ],
              [
                48.4202456,
                37.2242289
              ],
              [
                48.4202456,
                37.2286712
              ],
              [
                48.4263825,
                37.2378368
              ],
              [
                48.4261894,
                37.2396476
              ],
              [
                48.4247196,
                37.2409117
              ],
              [
                48.4235608,
                37.2408348
              ],
              [
                48.4196448,
                37.2410398
              ],
              [
                48.4167695,
                37.2425174
              ],
              [
                48.4166729,
                37.2446014
              ],
              [
                48.4153533,
                37.2466426
              ],
              [
                48.4125638,
                37.2483849
              ],
              [
                48.4098709,
                37.2479749
              ],
              [
                48.4039378,
                37.2461345
              ],
              [
                48.3968782,
                37.2492219
              ],
              [
                48.3919859,
                37.2489144
              ],
              [
                48.384304,
                37.2453616
              ],
              [
                48.3800554,
                37.24379
              ],
              [
                48.3789289,
                37.244405
              ],
              [
                48.3761716,
                37.2471721
              ],
              [
                48.3736181,
                37.2483336
              ],
              [
                48.3691871,
                37.2486582
              ],
              [
                48.3667731,
                37.2476675
              ],
              [
                48.3623207,
                37.2468818
              ],
              [
                48.3558726,
                37.2480945
              ],
              [
                48.3529973,
                37.2461814
              ],
              [
                48.3486414,
                37.2422356
              ],
              [
                48.342483,
                37.2416719
              ],
              [
                48.3402622,
                37.2406725
              ],
              [
                48.3376121,
                37.2394768
              ],
              [
                48.3365285,
                37.2397458
              ],
              [
                48.3346724,
                37.2402028
              ],
              [
                48.332526,
                37.2424966
              ],
              [
                48.3314906,
                37.2427598
              ],
              [
                48.3226926,
                37.2445594
              ],
              [
                48.3172246,
                37.2455298
              ],
              [
                48.3137847,
                37.2454136
              ],
              [
                48.2947248,
                37.2452939
              ],
              [
                48.275835,
                37.2375107
              ],
              [
                48.273335,
                37.2375107
              ],
              [
                48.2730548,
                37.2372317
              ],
              [
                48.2708353,
                37.2372318
              ],
              [
                48.2700017,
                37.2375107
              ],
              [
                48.2680552,
                37.2375107
              ],
              [
                48.2672219,
                37.2377896
              ],
              [
                48.265002,
                37.2377896
              ],
              [
                48.2644453,
                37.2380685
              ],
              [
                48.2616687,
                37.2380685
              ],
              [
                48.260835,
                37.2377896
              ],
              [
                48.2605554,
                37.2380685
              ],
              [
                48.2597217,
                37.2377895
              ],
              [
                48.2580553,
                37.2377896
              ],
              [
                48.2574987,
                37.2375106
              ],
              [
                48.2569451,
                37.2377896
              ],
              [
                48.2561119,
                37.2375107
              ],
              [
                48.249722,
                37.2375106
              ],
              [
                48.2488887,
                37.2377895
              ],
              [
                48.2472219,
                37.2377896
              ],
              [
                48.2463887,
                37.2380685
              ],
              [
                48.2416655,
                37.2380684
              ],
              [
                48.2405553,
                37.2380685
              ],
              [
                48.2399987,
                37.2377895
              ],
              [
                48.2377756,
                37.2377896
              ],
              [
                48.236942,
                37.2375106
              ],
              [
                48.2358322,
                37.2375106
              ],
              [
                48.234999,
                37.2372316
              ],
              [
                48.2336087,
                37.2372316
              ],
              [
                48.2252757,
                37.2350091
              ],
              [
                48.219719,
                37.2327866
              ],
              [
                48.2130524,
                37.2311219
              ],
              [
                48.2074991,
                37.2294572
              ],
              [
                48.2063858,
                37.2294573
              ],
              [
                48.2055526,
                37.2291783
              ],
              [
                48.2044424,
                37.2291784
              ],
              [
                48.202776,
                37.2286204
              ],
              [
                48.2013857,
                37.2286205
              ],
              [
                48.1913859,
                37.2269557
              ],
              [
                48.1872194,
                37.2269557
              ],
              [
                48.1863862,
                37.2266768
              ],
              [
                48.1858295,
                37.2269558
              ],
              [
                48.1849959,
                37.2266768
              ],
              [
                48.1774961,
                37.2266768
              ],
              [
                48.1763864,
                37.2263979
              ],
              [
                48.1736062,
                37.2263978
              ],
              [
                48.1730532,
                37.2261188
              ],
              [
                48.1658295,
                37.2250121
              ],
              [
                48.1644396,
                37.2247332
              ],
              [
                48.1613829,
                37.2238963
              ],
              [
                48.1602731,
                37.2238963
              ],
              [
                48.1594395,
                37.2236174
              ],
              [
                48.1502733,
                37.2211248
              ],
              [
                48.1402731,
                37.2133413
              ],
              [
                48.1319402,
                37.2055667
              ],
              [
                48.1313836,
                37.2044509
              ],
              [
                48.1169368,
                37.1883434
              ],
              [
                48.1163837,
                37.1872366
              ],
              [
                48.1094371,
                37.1716777
              ],
              [
                48.1058273,
                37.1650095
              ],
              [
                48.1055471,
                37.1647305
              ],
              [
                48.0997139,
                37.1558395
              ],
              [
                48.0966606,
                37.1541746
              ],
              [
                48.0955474,
                37.1541746
              ],
              [
                48.0955474,
                37.1538956
              ],
              [
                48.0947141,
                37.1538957
              ],
              [
                48.0941606,
                37.1541746
              ],
              [
                48.0933274,
                37.1538956
              ],
              [
                48.0899941,
                37.1538956
              ],
              [
                48.0894375,
                37.1536166
              ],
              [
                48.0836042,
                37.1519518
              ],
              [
                48.0824909,
                37.1511148
              ],
              [
                48.0811042,
                37.1508449
              ],
              [
                48.0644342,
                37.1525097
              ],
              [
                48.0561012,
                37.1525096
              ],
              [
                48.0555477,
                37.1522307
              ],
              [
                48.0536011,
                37.1522307
              ],
              [
                48.0530479,
                37.1519518
              ],
              [
                48.0519343,
                37.1519518
              ],
              [
                48.0508245,
                37.1516728
              ],
              [
                48.0494347,
                37.1516727
              ],
              [
                48.0472111,
                37.1511147
              ],
              [
                48.0449912,
                37.1508448
              ],
              [
                48.044158,
                37.1505658
              ],
              [
                48.0411012,
                37.1494499
              ],
              [
                48.0336014,
                37.1452833
              ],
              [
                48.0095666,
                37.1400672
              ],
              [
                47.9833218,
                37.1477849
              ],
              [
                47.9755419,
                37.1533464
              ],
              [
                47.9724852,
                37.1552812
              ],
              [
                47.9483186,
                37.1652881
              ],
              [
                47.9472089,
                37.1652881
              ],
              [
                47.9469288,
                37.165567
              ],
              [
                47.9385958,
                37.1669528
              ],
              [
                47.9380423,
                37.1666739
              ],
              [
                47.9327625,
                37.1666739
              ],
              [
                47.9322058,
                37.1669529
              ],
              [
                47.9302624,
                37.1669529
              ],
              [
                47.9299859,
                37.1672318
              ],
              [
                47.9288725,
                37.1672318
              ],
              [
                47.9285956,
                37.1675107
              ],
              [
                47.9274858,
                37.1675108
              ],
              [
                47.9272057,
                37.1677898
              ],
              [
                47.9058158,
                37.1727841
              ],
              [
                47.9044294,
                37.1727841
              ],
              [
                47.9022059,
                37.1733419
              ],
              [
                47.9005394,
                37.173342
              ],
              [
                47.8980394,
                37.1738999
              ],
              [
                47.8960929,
                37.1738999
              ],
              [
                47.8949827,
                37.1741789
              ],
              [
                47.8922061,
                37.1744489
              ],
              [
                47.8891493,
                37.1744488
              ],
              [
                47.8880396,
                37.1747278
              ],
              [
                47.8788695,
                37.1747278
              ],
              [
                47.8769264,
                37.1747278
              ],
              [
                47.8719263,
                37.1747277
              ],
              [
                47.8713697,
                37.1744488
              ],
              [
                47.8641496,
                37.1736208
              ],
              [
                47.8608132,
                37.1736209
              ],
              [
                47.8605367,
                37.1733419
              ],
              [
                47.8591464,
                37.1733419
              ],
              [
                47.8588698,
                37.1730629
              ],
              [
                47.8569265,
                37.173063
              ],
              [
                47.8549799,
                37.172514
              ],
              [
                47.8538697,
                37.172514
              ],
              [
                47.8524798,
                37.171956
              ],
              [
                47.8508135,
                37.171956
              ],
              [
                47.8477599,
                37.1708402
              ],
              [
                47.8474801,
                37.1705612
              ],
              [
                47.8472031,
                37.1702822
              ],
              [
                47.8460934,
                37.1702822
              ],
              [
                47.8441465,
                37.1694544
              ],
              [
                47.8433133,
                37.1694543
              ],
              [
                47.8433133,
                37.1691754
              ],
              [
                47.8424799,
                37.1691754
              ],
              [
                47.8072004,
                37.1513932
              ],
              [
                47.805534,
                37.1505653
              ],
              [
                47.7935908,
                37.1444548
              ],
              [
                47.7933107,
                37.1438968
              ],
              [
                47.7927575,
                37.1436179
              ],
              [
                47.7788675,
                37.1322247
              ],
              [
                47.7785874,
                37.1316757
              ],
              [
                47.7783108,
                37.1305598
              ],
              [
                47.7780342,
                37.1236213
              ],
              [
                47.7785874,
                37.1197244
              ],
              [
                47.7777542,
                37.1100048
              ],
              [
                47.7758108,
                37.0919512
              ],
              [
                47.7755343,
                37.0908442
              ],
              [
                47.7730343,
                37.0813942
              ],
              [
                47.772201,
                37.0802872
              ],
              [
                47.7683112,
                37.0772272
              ],
              [
                47.7660877,
                37.0763991
              ],
              [
                47.7649779,
                37.0763992
              ],
              [
                47.7644212,
                37.0761201
              ],
              [
                47.759698,
                37.0761201
              ],
              [
                47.7591445,
                37.0763991
              ],
              [
                47.7421981,
                37.0786131
              ],
              [
                47.7402547,
                37.0794501
              ],
              [
                47.737755,
                37.0802871
              ],
              [
                47.729418,
                37.0841751
              ],
              [
                47.7266414,
                37.0869471
              ],
              [
                47.7266414,
                37.087505
              ],
              [
                47.7216417,
                37.0930581
              ],
              [
                47.7199749,
                37.093616
              ],
              [
                47.7177518,
                37.093616
              ],
              [
                47.7060851,
                37.087784
              ],
              [
                47.705252,
                37.0877841
              ],
              [
                47.7049754,
                37.0875051
              ],
              [
                47.7038617,
                37.0875051
              ],
              [
                47.7033085,
                37.087226
              ],
              [
                47.7019187,
                37.0872261
              ],
              [
                47.6971951,
                37.0863981
              ],
              [
                47.696642,
                37.0863981
              ],
              [
                47.6924501,
                37.07914
              ],
              [
                47.6913137,
                37.0771896
              ],
              [
                47.6909501,
                37.0769173
              ],
              [
                47.6899976,
                37.076313
              ],
              [
                47.6728854,
                37.066302
              ],
              [
                47.6549822,
                37.0577032
              ],
              [
                47.6457039,
                37.0490355
              ],
              [
                47.6454274,
                37.0487563
              ],
              [
                47.6448708,
                37.0484772
              ],
              [
                47.6448708,
                37.0479279
              ],
              [
                47.6440371,
                37.0465325
              ],
              [
                47.6362577,
                37.0407871
              ],
              [
                47.6365342,
                37.0399498
              ],
              [
                47.6373675,
                37.0377349
              ],
              [
                47.6359776,
                37.0321709
              ],
              [
                47.6255512,
                37.0310382
              ],
              [
                47.6183279,
                37.0299309
              ],
              [
                47.6090614,
                37.031092
              ],
              [
                47.59886,
                37.0375081
              ],
              [
                47.5963563,
                37.0375081
              ],
              [
                47.5946899,
                37.0402803
              ],
              [
                47.5944133,
                37.0419544
              ],
              [
                47.5941364,
                37.0430615
              ],
              [
                47.5938566,
                37.0444476
              ],
              [
                47.5935797,
                37.0447266
              ],
              [
                47.5935796,
                37.0452846
              ],
              [
                47.5921898,
                37.0477777
              ],
              [
                47.5844135,
                37.0527819
              ],
              [
                47.5827466,
                37.05334
              ],
              [
                47.5821899,
                37.05334
              ],
              [
                47.5821899,
                37.053619
              ],
              [
                47.5816369,
                37.053619
              ],
              [
                47.5810798,
                37.053898
              ],
              [
                47.5793754,
                37.0544088
              ],
              [
                47.5755234,
                37.0555631
              ],
              [
                47.5696901,
                37.0591722
              ],
              [
                47.5677466,
                37.0591722
              ],
              [
                47.56719,
                37.0588932
              ],
              [
                47.5658001,
                37.0588932
              ],
              [
                47.5638567,
                37.0580561
              ],
              [
                47.5599668,
                37.0572281
              ],
              [
                47.5585769,
                37.0572281
              ],
              [
                47.5577433,
                37.0575071
              ],
              [
                47.5566335,
                37.0575071
              ],
              [
                47.5499669,
                37.0608372
              ],
              [
                47.5483001,
                37.0608373
              ],
              [
                47.5477436,
                37.0605582
              ],
              [
                47.5433004,
                37.0605582
              ],
              [
                47.5424672,
                37.0602792
              ],
              [
                47.541357,
                37.0602792
              ],
              [
                47.5388538,
                37.0608372
              ],
              [
                47.5371869,
                37.0616742
              ],
              [
                47.5369104,
                37.0622322
              ],
              [
                47.5294106,
                37.0683344
              ],
              [
                47.5241339,
                37.0672274
              ],
              [
                47.5174638,
                37.0616742
              ],
              [
                47.5155205,
                37.056949
              ],
              [
                47.515244,
                37.0555629
              ],
              [
                47.5149639,
                37.0508378
              ],
              [
                47.514964,
                37.039731
              ],
              [
                47.515244,
                37.0366708
              ],
              [
                47.512744,
                37.0213966
              ],
              [
                47.5099643,
                37.0172292
              ],
              [
                47.4941312,
                37.0025036
              ],
              [
                47.4935745,
                37.0019455
              ],
              [
                47.4935746,
                37.0016665
              ],
              [
                47.4924644,
                37.0000012
              ],
              [
                47.4874647,
                36.9966709
              ],
              [
                47.486908,
                36.9966709
              ],
              [
                47.4585751,
                36.98334
              ],
              [
                47.4507948,
                36.977228
              ],
              [
                47.4505182,
                36.9769489
              ],
              [
                47.4382953,
                36.9633387
              ],
              [
                47.4374617,
                36.9630597
              ],
              [
                47.4291288,
                36.9577757
              ],
              [
                47.4285721,
                36.9575056
              ],
              [
                47.4281849,
                36.9573415
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555082,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سلطانیه",
          "name:en": "Soltanieh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4811211"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.5655743,
                36.4561015
              ],
              [
                48.5658509,
                36.4558223
              ],
              [
                48.5786278,
                36.435546
              ],
              [
                48.5789074,
                36.4344292
              ],
              [
                48.5786278,
                36.4294387
              ],
              [
                48.5805744,
                36.4236017
              ],
              [
                48.5822407,
                36.4238809
              ],
              [
                48.5830744,
                36.4236017
              ],
              [
                48.5844642,
                36.4236017
              ],
              [
                48.585574,
                36.4233224
              ],
              [
                48.5869644,
                36.4233224
              ],
              [
                48.6036307,
                36.4197192
              ],
              [
                48.6069639,
                36.4186023
              ],
              [
                48.6075206,
                36.4180438
              ],
              [
                48.6080741,
                36.4180438
              ],
              [
                48.6191873,
                36.4113779
              ],
              [
                48.6272437,
                36.3988837
              ],
              [
                48.6275203,
                36.3980459
              ],
              [
                48.6294638,
                36.3930463
              ],
              [
                48.6297438,
                36.3922086
              ],
              [
                48.6297438,
                36.3919382
              ],
              [
                48.6301586,
                36.3916591
              ],
              [
                48.630297,
                36.3913797
              ],
              [
                48.6361339,
                36.3838758
              ],
              [
                48.6383539,
                36.3816597
              ],
              [
                48.6433535,
                36.3788852
              ],
              [
                48.6500201,
                36.3766511
              ],
              [
                48.6519671,
                36.3763809
              ],
              [
                48.6716901,
                36.3708227
              ],
              [
                48.6811333,
                36.3661023
              ],
              [
                48.6886331,
                36.3599944
              ],
              [
                48.6997467,
                36.3516524
              ],
              [
                48.7022463,
                36.3505444
              ],
              [
                48.7025234,
                36.3502651
              ],
              [
                48.7142272,
                36.3382493
              ],
              [
                48.7252198,
                36.3321013
              ],
              [
                48.7326049,
                36.3280571
              ],
              [
                48.7413895,
                36.3221635
              ],
              [
                48.7467722,
                36.3197431
              ],
              [
                48.7559726,
                36.3171188
              ],
              [
                48.7783868,
                36.309756
              ],
              [
                48.7965879,
                36.3028376
              ],
              [
                48.8133716,
                36.2961731
              ],
              [
                48.8146527,
                36.2949126
              ],
              [
                48.8192869,
                36.2896042
              ],
              [
                48.8201093,
                36.2852424
              ],
              [
                48.8185934,
                36.282369
              ],
              [
                48.8148156,
                36.2790773
              ],
              [
                48.8075351,
                36.2723726
              ],
              [
                48.802076,
                36.2652587
              ],
              [
                48.8003253,
                36.2538946
              ],
              [
                48.8016469,
                36.2491092
              ],
              [
                48.8036543,
                36.2460571
              ],
              [
                48.8089942,
                36.2435118
              ],
              [
                48.8186849,
                36.2437423
              ],
              [
                48.8350421,
                36.2494184
              ],
              [
                48.8453408,
                36.2542966
              ],
              [
                48.8638376,
                36.2599809
              ],
              [
                48.8616943,
                36.2667674
              ],
              [
                48.8587759,
                36.2880099
              ],
              [
                48.8580894,
                36.2939594
              ],
              [
                48.8587858,
                36.2996347
              ],
              [
                48.8592052,
                36.3055806
              ],
              [
                48.8617404,
                36.3109031
              ],
              [
                48.8665052,
                36.3212603
              ],
              [
                48.87361,
                36.3315087
              ],
              [
                48.8835664,
                36.3446034
              ],
              [
                48.9309152,
                36.4015628
              ],
              [
                48.9769219,
                36.4494908
              ],
              [
                48.9799261,
                36.4541508
              ],
              [
                48.9841747,
                36.4572919
              ],
              [
                48.9868784,
                36.4584999
              ],
              [
                48.9929342,
                36.4593179
              ],
              [
                49.0681144,
                36.4891203
              ],
              [
                49.0633964,
                36.4923186
              ],
              [
                49.0583324,
                36.4972176
              ],
              [
                49.0441703,
                36.5053589
              ],
              [
                49.0288066,
                36.5080495
              ],
              [
                49.0148162,
                36.5137753
              ],
              [
                48.9943885,
                36.5252257
              ],
              [
                48.977481,
                36.5401706
              ],
              [
                48.9717891,
                36.5558654
              ],
              [
                48.9812231,
                36.5741542
              ],
              [
                48.9896509,
                36.5848636
              ],
              [
                49.0033577,
                36.6105157
              ],
              [
                49.0036484,
                36.6157139
              ],
              [
                49.001095,
                36.6210996
              ],
              [
                49.0028716,
                36.6235801
              ],
              [
                49.0038339,
                36.6267846
              ],
              [
                49.003973,
                36.6303089
              ],
              [
                49.0033696,
                36.6347619
              ],
              [
                49.0119374,
                36.6397611
              ],
              [
                49.0104427,
                36.6454112
              ],
              [
                49.0121098,
                36.649015
              ],
              [
                49.0122024,
                36.6515042
              ],
              [
                49.0089609,
                36.6536589
              ],
              [
                49.0079434,
                36.6573224
              ],
              [
                49.010489,
                36.6623144
              ],
              [
                49.0141472,
                36.6670238
              ],
              [
                49.0265026,
                36.6732976
              ],
              [
                49.0159612,
                36.6824402
              ],
              [
                49.0159622,
                36.6836245
              ],
              [
                49.0155693,
                36.6852632
              ],
              [
                49.0156144,
                36.6874599
              ],
              [
                49.014966,
                36.6885106
              ],
              [
                49.0149902,
                36.6904243
              ],
              [
                49.0145738,
                36.6925337
              ],
              [
                49.0146436,
                36.6937225
              ],
              [
                49.0138796,
                36.6983268
              ],
              [
                49.0131408,
                36.7046527
              ],
              [
                49.0119833,
                36.7105939
              ],
              [
                49.0015206,
                36.7164833
              ],
              [
                48.9896211,
                36.7194542
              ],
              [
                48.9881372,
                36.7179695
              ],
              [
                48.9856591,
                36.7174497
              ],
              [
                48.9729064,
                36.7125992
              ],
              [
                48.9578151,
                36.7066707
              ],
              [
                48.9439228,
                36.7015111
              ],
              [
                48.9366085,
                36.6990785
              ],
              [
                48.9276263,
                36.6957549
              ],
              [
                48.9154978,
                36.6919985
              ],
              [
                48.9095708,
                36.6908283
              ],
              [
                48.9014204,
                36.6894172
              ],
              [
                48.8896022,
                36.687741
              ],
              [
                48.8755512,
                36.6832618
              ],
              [
                48.8695313,
                36.6806622
              ],
              [
                48.869022,
                36.6790653
              ],
              [
                48.8667603,
                36.6776849
              ],
              [
                48.8662537,
                36.6766424
              ],
              [
                48.8626177,
                36.6753413
              ],
              [
                48.8553535,
                36.6708549
              ],
              [
                48.850909,
                36.6689812
              ],
              [
                48.8491247,
                36.6682844
              ],
              [
                48.8472519,
                36.667752
              ],
              [
                48.8457296,
                36.6681089
              ],
              [
                48.8407285,
                36.6640231
              ],
              [
                48.8322081,
                36.6553307
              ],
              [
                48.8259103,
                36.6470831
              ],
              [
                48.8197979,
                36.6302881
              ],
              [
                48.8074803,
                36.6028582
              ],
              [
                48.8040884,
                36.5967938
              ],
              [
                48.7995387,
                36.5902549
              ],
              [
                48.7916897,
                36.5805874
              ],
              [
                48.786596,
                36.5753441
              ],
              [
                48.7807211,
                36.5710646
              ],
              [
                48.780194,
                36.5686036
              ],
              [
                48.7697866,
                36.5666045
              ],
              [
                48.7670545,
                36.5666417
              ],
              [
                48.7640446,
                36.566121
              ],
              [
                48.7536256,
                36.5657491
              ],
              [
                48.745999,
                36.5669226
              ],
              [
                48.7442388,
                36.5673123
              ],
              [
                48.7395483,
                36.5674599
              ],
              [
                48.7376961,
                36.5640568
              ],
              [
                48.7373256,
                36.5608024
              ],
              [
                48.7357281,
                36.5581243
              ],
              [
                48.7352881,
                36.5568411
              ],
              [
                48.7244987,
                36.5542558
              ],
              [
                48.7145197,
                36.5489115
              ],
              [
                48.7125052,
                36.5489735
              ],
              [
                48.7098646,
                36.5474876
              ],
              [
                48.7008591,
                36.5432072
              ],
              [
                48.6908566,
                36.5393302
              ],
              [
                48.6689108,
                36.5298888
              ],
              [
                48.6286301,
                36.5080466
              ],
              [
                48.6261301,
                36.5080467
              ],
              [
                48.6247434,
                36.5077675
              ],
              [
                48.6214102,
                36.5077675
              ],
              [
                48.6025206,
                36.5022191
              ],
              [
                48.6016871,
                36.5016606
              ],
              [
                48.5983538,
                36.5002735
              ],
              [
                48.5982255,
                36.5003013
              ],
              [
                48.5980737,
                36.5002735
              ],
              [
                48.5950174,
                36.4996028
              ],
              [
                48.5939072,
                36.4991566
              ],
              [
                48.586964,
                36.4966617
              ],
              [
                48.5858507,
                36.495824
              ],
              [
                48.5650176,
                36.4844389
              ],
              [
                48.5580709,
                36.4766566
              ],
              [
                48.5577944,
                36.4722159
              ],
              [
                48.558071,
                36.4708288
              ],
              [
                48.5586275,
                36.4699911
              ],
              [
                48.5619609,
                36.4633256
              ],
              [
                48.561961,
                36.4630464
              ],
              [
                48.5627946,
                36.4611008
              ],
              [
                48.5630742,
                36.4608216
              ],
              [
                48.5647411,
                36.4572185
              ],
              [
                48.564741,
                36.4569393
              ],
              [
                48.5650176,
                36.4566601
              ],
              [
                48.5655743,
                36.4561015
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555117,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان طارم",
          "name:en": "Tarom County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1271024",
          "wikipedia": "en:Tarom County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.4867264,
                36.9726045
              ],
              [
                48.4883468,
                36.9616668
              ],
              [
                48.4886238,
                36.9608386
              ],
              [
                48.4886238,
                36.9547265
              ],
              [
                48.4900137,
                36.9508378
              ],
              [
                48.4911234,
                36.9505587
              ],
              [
                48.4916805,
                36.9505587
              ],
              [
                48.4925137,
                36.9502796
              ],
              [
                48.4936235,
                36.9502797
              ],
              [
                48.4941802,
                36.9500007
              ],
              [
                48.5002901,
                36.9500006
              ],
              [
                48.5011237,
                36.9502797
              ],
              [
                48.5014003,
                36.9500007
              ],
              [
                48.5022335,
                36.9502797
              ],
              [
                48.5025136,
                36.9500006
              ],
              [
                48.5252934,
                36.946391
              ],
              [
                48.5330697,
                36.9430603
              ],
              [
                48.5511264,
                36.9333383
              ],
              [
                48.5519597,
                36.9333383
              ],
              [
                48.5530698,
                36.9327802
              ],
              [
                48.5627931,
                36.9305568
              ],
              [
                48.5644595,
                36.9305568
              ],
              [
                48.5672396,
                36.9299986
              ],
              [
                48.5766829,
                36.9288914
              ],
              [
                48.5789243,
                36.9287461
              ],
              [
                48.5808493,
                36.9286213
              ],
              [
                48.5855725,
                36.9280633
              ],
              [
                48.5880725,
                36.9280633
              ],
              [
                48.5891828,
                36.9277842
              ],
              [
                48.5916824,
                36.9277842
              ],
              [
                48.5930727,
                36.9275052
              ],
              [
                48.5950161,
                36.9275051
              ],
              [
                48.596406,
                36.927226
              ],
              [
                48.5983525,
                36.9272261
              ],
              [
                48.6041858,
                36.9261099
              ],
              [
                48.6272422,
                36.9225001
              ],
              [
                48.6339087,
                36.9208347
              ],
              [
                48.6352955,
                36.9208347
              ],
              [
                48.6447422,
                36.9191693
              ],
              [
                48.6475188,
                36.9191693
              ],
              [
                48.6505086,
                36.9182004
              ],
              [
                48.6648884,
                36.9066032
              ],
              [
                48.703648,
                36.8843992
              ],
              [
                48.7041881,
                36.882782
              ],
              [
                48.7078014,
                36.8744455
              ],
              [
                48.7091883,
                36.8722219
              ],
              [
                48.7128016,
                36.8686119
              ],
              [
                48.7247445,
                36.862508
              ],
              [
                48.7286348,
                36.8611125
              ],
              [
                48.7369678,
                36.8586098
              ],
              [
                48.7380811,
                36.8586097
              ],
              [
                48.7457805,
                36.8564414
              ],
              [
                48.7469677,
                36.856107
              ],
              [
                48.7472477,
                36.856107
              ],
              [
                48.7478013,
                36.8563861
              ],
              [
                48.7483579,
                36.8563861
              ],
              [
                48.7491912,
                36.8569443
              ],
              [
                48.7519712,
                36.8575024
              ],
              [
                48.7528045,
                36.8580606
              ],
              [
                48.7555811,
                36.8588889
              ],
              [
                48.7589144,
                36.8602843
              ],
              [
                48.7733608,
                36.8641646
              ],
              [
                48.7739143,
                36.8641645
              ],
              [
                48.7750276,
                36.8641646
              ],
              [
                48.7758608,
                36.8644437
              ],
              [
                48.7805809,
                36.8636154
              ],
              [
                48.7825273,
                36.8636154
              ],
              [
                48.7905838,
                36.8625081
              ],
              [
                48.7950272,
                36.8608426
              ],
              [
                48.8055837,
                36.8519477
              ],
              [
                48.806694,
                36.8502822
              ],
              [
                48.8080839,
                36.8488957
              ],
              [
                48.8094737,
                36.8461138
              ],
              [
                48.8119738,
                36.8422245
              ],
              [
                48.8147505,
                36.8361115
              ],
              [
                48.8141938,
                36.8327802
              ],
              [
                48.812527,
                36.8313847
              ],
              [
                48.8111406,
                36.8308355
              ],
              [
                48.8075272,
                36.82944
              ],
              [
                48.8014173,
                36.8291699
              ],
              [
                48.800304,
                36.8288908
              ],
              [
                48.7955841,
                36.8255596
              ],
              [
                48.795584,
                36.8244432
              ],
              [
                48.7975718,
                36.8206366
              ],
              [
                48.8065849,
                36.8124949
              ],
              [
                48.8105331,
                36.808237
              ],
              [
                48.8109047,
                36.8078363
              ],
              [
                48.8166098,
                36.8016825
              ],
              [
                48.8245197,
                36.7931484
              ],
              [
                48.8348857,
                36.7880844
              ],
              [
                48.8380848,
                36.7854018
              ],
              [
                48.8423804,
                36.7841095
              ],
              [
                48.8461277,
                36.7807265
              ],
              [
                48.8477407,
                36.7805909
              ],
              [
                48.8541461,
                36.7800524
              ],
              [
                48.8580727,
                36.7797221
              ],
              [
                48.8615353,
                36.7794307
              ],
              [
                48.8696995,
                36.7787432
              ],
              [
                48.8835091,
                36.7756727
              ],
              [
                48.8937376,
                36.7697084
              ],
              [
                48.8958699,
                36.7671122
              ],
              [
                48.8970726,
                36.7630362
              ],
              [
                48.9008372,
                36.7558136
              ],
              [
                48.9035987,
                36.7540464
              ],
              [
                48.9023565,
                36.7527896
              ],
              [
                48.9058664,
                36.7477766
              ],
              [
                48.9069762,
                36.7452824
              ],
              [
                48.8989194,
                36.7227686
              ],
              [
                48.8958633,
                36.7170672
              ],
              [
                48.8941037,
                36.7123574
              ],
              [
                48.8930843,
                36.7080439
              ],
              [
                48.892019,
                36.7030963
              ],
              [
                48.8910495,
                36.6974857
              ],
              [
                48.8903088,
                36.6933951
              ],
              [
                48.8896022,
                36.687741
              ],
              [
                48.9014204,
                36.6894172
              ],
              [
                48.9095708,
                36.6908283
              ],
              [
                48.9154978,
                36.6919985
              ],
              [
                48.9276263,
                36.6957549
              ],
              [
                48.9366085,
                36.6990785
              ],
              [
                48.9439228,
                36.7015111
              ],
              [
                48.9578151,
                36.7066707
              ],
              [
                48.9729064,
                36.7125992
              ],
              [
                48.9856591,
                36.7174497
              ],
              [
                48.9881372,
                36.7179695
              ],
              [
                48.9896211,
                36.7194542
              ],
              [
                49.0015206,
                36.7164833
              ],
              [
                49.0119833,
                36.7105939
              ],
              [
                49.0131408,
                36.7046527
              ],
              [
                49.0138796,
                36.6983268
              ],
              [
                49.0146436,
                36.6937225
              ],
              [
                49.0145738,
                36.6925337
              ],
              [
                49.0149902,
                36.6904243
              ],
              [
                49.014966,
                36.6885106
              ],
              [
                49.0156144,
                36.6874599
              ],
              [
                49.0155693,
                36.6852632
              ],
              [
                49.0159622,
                36.6836245
              ],
              [
                49.0159612,
                36.6824402
              ],
              [
                49.0265026,
                36.6732976
              ],
              [
                49.0325217,
                36.675142
              ],
              [
                49.0359132,
                36.6758816
              ],
              [
                49.0491207,
                36.6757847
              ],
              [
                49.0609606,
                36.682277
              ],
              [
                49.0706317,
                36.6842745
              ],
              [
                49.0716909,
                36.688649
              ],
              [
                49.0747826,
                36.6904169
              ],
              [
                49.0737272,
                36.6962685
              ],
              [
                49.0728278,
                36.7012539
              ],
              [
                49.0737758,
                36.7054519
              ],
              [
                49.0749411,
                36.7095408
              ],
              [
                49.0760992,
                36.7123053
              ],
              [
                49.0794553,
                36.7176155
              ],
              [
                49.0818379,
                36.7201542
              ],
              [
                49.0853884,
                36.7234202
              ],
              [
                49.0875042,
                36.7265086
              ],
              [
                49.0943518,
                36.7386594
              ],
              [
                49.0977787,
                36.7444468
              ],
              [
                49.0993761,
                36.7480551
              ],
              [
                49.1014726,
                36.7506841
              ],
              [
                49.1074016,
                36.7616524
              ],
              [
                49.1090241,
                36.7631163
              ],
              [
                49.1179787,
                36.7711937
              ],
              [
                49.1235109,
                36.7745358
              ],
              [
                49.1253571,
                36.7770862
              ],
              [
                49.1328093,
                36.7795253
              ],
              [
                49.1383159,
                36.7791745
              ],
              [
                49.148246,
                36.7789104
              ],
              [
                49.1538301,
                36.7783325
              ],
              [
                49.157837,
                36.7780093
              ],
              [
                49.166473,
                36.775486
              ],
              [
                49.1712707,
                36.7723737
              ],
              [
                49.1749472,
                36.7700707
              ],
              [
                49.1772993,
                36.7685972
              ],
              [
                49.1834839,
                36.769005
              ],
              [
                49.192995,
                36.7714758
              ],
              [
                49.2087653,
                36.7790003
              ],
              [
                49.2258041,
                36.7829726
              ],
              [
                49.2371898,
                36.7891701
              ],
              [
                49.26733,
                36.8125833
              ],
              [
                49.2758416,
                36.8151799
              ],
              [
                49.2681048,
                36.8365409
              ],
              [
                49.2638796,
                36.8454154
              ],
              [
                49.2589381,
                36.854392
              ],
              [
                49.2499516,
                36.8729205
              ],
              [
                49.2443617,
                36.8849074
              ],
              [
                49.2393046,
                36.902649
              ],
              [
                49.2326744,
                36.9130993
              ],
              [
                49.2298946,
                36.9167409
              ],
              [
                49.2270998,
                36.9200325
              ],
              [
                49.2220402,
                36.9263899
              ],
              [
                49.2061682,
                36.9455976
              ],
              [
                49.1996944,
                36.9594611
              ],
              [
                49.1834031,
                36.9914532
              ],
              [
                49.1790761,
                37.0020017
              ],
              [
                49.1748046,
                37.0116002
              ],
              [
                49.1708095,
                37.0212894
              ],
              [
                49.1599379,
                37.038942
              ],
              [
                49.1585477,
                37.0431084
              ],
              [
                49.1393832,
                37.0716808
              ],
              [
                49.1298434,
                37.0840608
              ],
              [
                49.1240481,
                37.09095
              ],
              [
                49.1078642,
                37.1051205
              ],
              [
                49.0908318,
                37.1161689
              ],
              [
                49.0715641,
                37.121786
              ],
              [
                49.0351731,
                37.1304778
              ],
              [
                49.0343394,
                37.1313055
              ],
              [
                49.0197518,
                37.1334077
              ],
              [
                48.9978216,
                37.1371931
              ],
              [
                48.988134,
                37.1360832
              ],
              [
                48.9682959,
                37.1339087
              ],
              [
                48.9554211,
                37.132814
              ],
              [
                48.9394534,
                37.1448358
              ],
              [
                48.9319782,
                37.1502887
              ],
              [
                48.9314215,
                37.1513956
              ],
              [
                48.9308649,
                37.1516745
              ],
              [
                48.9261449,
                37.1600077
              ],
              [
                48.9247551,
                37.1622304
              ],
              [
                48.9228116,
                37.1672339
              ],
              [
                48.9182611,
                37.1706893
              ],
              [
                48.9176765,
                37.1706893
              ],
              [
                48.9167022,
                37.1702752
              ],
              [
                48.9162691,
                37.1703787
              ],
              [
                48.9147318,
                37.1713104
              ],
              [
                48.9151865,
                37.1713277
              ],
              [
                48.9160309,
                37.1712069
              ],
              [
                48.9163124,
                37.1712932
              ],
              [
                48.9164207,
                37.1718453
              ],
              [
                48.9159443,
                37.171759
              ],
              [
                48.9152081,
                37.1723974
              ],
              [
                48.9142987,
                37.1723284
              ],
              [
                48.9154463,
                37.1729495
              ],
              [
                48.9148184,
                37.173191
              ],
              [
                48.9135728,
                37.1732827
              ],
              [
                48.9130192,
                37.1731801
              ],
              [
                48.9128132,
                37.1731801
              ],
              [
                48.9130836,
                37.1734776
              ],
              [
                48.9131495,
                37.1736115
              ],
              [
                48.912278,
                37.1735684
              ],
              [
                48.9112587,
                37.1733343
              ],
              [
                48.9108588,
                37.1733033
              ],
              [
                48.9105509,
                37.1732215
              ],
              [
                48.9101935,
                37.1730185
              ],
              [
                48.9098678,
                37.173151
              ],
              [
                48.9091565,
                37.1732835
              ],
              [
                48.9088379,
                37.1732553
              ],
              [
                48.9084062,
                37.173402
              ],
              [
                48.90767,
                37.1732892
              ],
              [
                48.9074435,
                37.1731143
              ],
              [
                48.9070259,
                37.1730269
              ],
              [
                48.9062402,
                37.172948
              ],
              [
                48.9059995,
                37.1728041
              ],
              [
                48.9052209,
                37.1727082
              ],
              [
                48.9050085,
                37.1725926
              ],
              [
                48.9049484,
                37.1724742
              ],
              [
                48.90446,
                37.1723755
              ],
              [
                48.9040965,
                37.1722961
              ],
              [
                48.90378,
                37.1722042
              ],
              [
                48.9035241,
                37.1722319
              ],
              [
                48.9035166,
                37.1720233
              ],
              [
                48.9033821,
                37.1716624
              ],
              [
                48.9032087,
                37.1714283
              ],
              [
                48.9029857,
                37.1712957
              ],
              [
                48.9027876,
                37.1712196
              ],
              [
                48.9026283,
                37.1711096
              ],
              [
                48.9025858,
                37.170963
              ],
              [
                48.9025858,
                37.1706838
              ],
              [
                48.9024655,
                37.1704694
              ],
              [
                48.9023862,
                37.1704344
              ],
              [
                48.9018143,
                37.1701818
              ],
              [
                48.9014851,
                37.1700972
              ],
              [
                48.9013011,
                37.16999
              ],
              [
                48.9010994,
                37.1696967
              ],
              [
                48.9009189,
                37.1693696
              ],
              [
                48.9007348,
                37.1691298
              ],
              [
                48.9005685,
                37.1689634
              ],
              [
                48.9004128,
                37.1686758
              ],
              [
                48.9000624,
                37.1683486
              ],
              [
                48.8994961,
                37.1679002
              ],
              [
                48.8992767,
                37.1677902
              ],
              [
                48.8989404,
                37.1673503
              ],
              [
                48.8983211,
                37.1668877
              ],
              [
                48.8977513,
                37.1666649
              ],
              [
                48.8973301,
                37.1662729
              ],
              [
                48.8971355,
                37.1661516
              ],
              [
                48.8968983,
                37.1661037
              ],
              [
                48.8964205,
                37.1658329
              ],
              [
                48.8950084,
                37.1653112
              ],
              [
                48.8947465,
                37.1651983
              ],
              [
                48.8943926,
                37.1651758
              ],
              [
                48.8942899,
                37.1650799
              ],
              [
                48.8942369,
                37.1649417
              ],
              [
                48.8940917,
                37.164843
              ],
              [
                48.8933379,
                37.1646737
              ],
              [
                48.8930654,
                37.1647302
              ],
              [
                48.892531,
                37.1649078
              ],
              [
                48.8922691,
                37.1648768
              ],
              [
                48.8920567,
                37.1646145
              ],
              [
                48.8918762,
                37.1642422
              ],
              [
                48.8919045,
                37.1640702
              ],
              [
                48.8921417,
                37.1638192
              ],
              [
                48.8921593,
                37.1635879
              ],
              [
                48.8920886,
                37.1632974
              ],
              [
                48.8918691,
                37.1630746
              ],
              [
                48.891494,
                37.16288
              ],
              [
                48.8912356,
                37.1628264
              ],
              [
                48.8907755,
                37.1625246
              ],
              [
                48.890641,
                37.1622792
              ],
              [
                48.890641,
                37.1620394
              ],
              [
                48.8907154,
                37.1619012
              ],
              [
                48.890726,
                37.1617207
              ],
              [
                48.890595,
                37.1615966
              ],
              [
                48.890319,
                37.1614612
              ],
              [
                48.889873,
                37.1614161
              ],
              [
                48.889643,
                37.1615289
              ],
              [
                48.8893917,
                37.1616079
              ],
              [
                48.8890519,
                37.1616079
              ],
              [
                48.8888821,
                37.1615205
              ],
              [
                48.8887016,
                37.1613682
              ],
              [
                48.8884927,
                37.1613456
              ],
              [
                48.8882839,
                37.1611425
              ],
              [
                48.8882592,
                37.1608971
              ],
              [
                48.8885104,
                37.1604289
              ],
              [
                48.8885918,
                37.1602343
              ],
              [
                48.8885812,
                37.1599128
              ],
              [
                48.8883936,
                37.1596843
              ],
              [
                48.8883547,
                37.1594474
              ],
              [
                48.8880149,
                37.1590243
              ],
              [
                48.8879371,
                37.1585673
              ],
              [
                48.8880008,
                37.1582345
              ],
              [
                48.8878238,
                37.1579045
              ],
              [
                48.8860259,
                37.1579186
              ],
              [
                48.8857003,
                37.1577296
              ],
              [
                48.8855411,
                37.1573545
              ],
              [
                48.8853216,
                37.1571965
              ],
              [
                48.8851428,
                37.15701
              ],
              [
                48.8851014,
                37.1568011
              ],
              [
                48.8850675,
                37.1566365
              ],
              [
                48.8850798,
                37.1564659
              ],
              [
                48.8850921,
                37.1563468
              ],
              [
                48.8850705,
                37.1562019
              ],
              [
                48.8850243,
                37.1560497
              ],
              [
                48.8848302,
                37.1559355
              ],
              [
                48.8846377,
                37.1558864
              ],
              [
                48.8843511,
                37.1557796
              ],
              [
                48.8840295,
                37.1554796
              ],
              [
                48.8837894,
                37.1553112
              ],
              [
                48.883597,
                37.1552505
              ],
              [
                48.8833551,
                37.1552287
              ],
              [
                48.8830096,
                37.1551855
              ],
              [
                48.882942,
                37.1551459
              ],
              [
                48.8828366,
                37.1550841
              ],
              [
                48.8827241,
                37.1550871
              ],
              [
                48.8825073,
                37.1550886
              ],
              [
                48.8824193,
                37.1550748
              ],
              [
                48.8822606,
                37.1550416
              ],
              [
                48.8820942,
                37.1550331
              ],
              [
                48.8819941,
                37.1550809
              ],
              [
                48.8819202,
                37.15513
              ],
              [
                48.8817923,
                37.1551681
              ],
              [
                48.881672,
                37.1552048
              ],
              [
                48.8815551,
                37.1552406
              ],
              [
                48.8812146,
                37.1553204
              ],
              [
                48.8809589,
                37.15541
              ],
              [
                48.8808541,
                37.1554358
              ],
              [
                48.880717,
                37.1553989
              ],
              [
                48.880546,
                37.1554075
              ],
              [
                48.880489,
                37.1555094
              ],
              [
                48.880221,
                37.1555696
              ],
              [
                48.8798589,
                37.155491
              ],
              [
                48.8790748,
                37.1554002
              ],
              [
                48.8784735,
                37.1553566
              ],
              [
                48.8782346,
                37.1553792
              ],
              [
                48.8780523,
                37.1553383
              ],
              [
                48.8775993,
                37.1550605
              ],
              [
                48.8773746,
                37.1549829
              ],
              [
                48.8771782,
                37.1549632
              ],
              [
                48.8770879,
                37.1549039
              ],
              [
                48.8770596,
                37.1548179
              ],
              [
                48.8770118,
                37.1548024
              ],
              [
                48.876849,
                37.154784
              ],
              [
                48.876534,
                37.1545499
              ],
              [
                48.8763783,
                37.1545118
              ],
              [
                48.8762913,
                37.154378
              ],
              [
                48.8762238,
                37.154271
              ],
              [
                48.8760626,
                37.1541287
              ],
              [
                48.8758379,
                37.1540213
              ],
              [
                48.875536,
                37.1539956
              ],
              [
                48.8751219,
                37.1541254
              ],
              [
                48.8747839,
                37.1541635
              ],
              [
                48.874322,
                37.1541
              ],
              [
                48.8737097,
                37.1540323
              ],
              [
                48.8735186,
                37.1538715
              ],
              [
                48.8732981,
                37.1536535
              ],
              [
                48.8732152,
                37.1535506
              ],
              [
                48.8730245,
                37.1534657
              ],
              [
                48.8727559,
                37.153454
              ],
              [
                48.8726144,
                37.1534484
              ],
              [
                48.8724834,
                37.1533877
              ],
              [
                48.8723631,
                37.1532721
              ],
              [
                48.8721419,
                37.1532495
              ],
              [
                48.8719189,
                37.1533031
              ],
              [
                48.8709617,
                37.1527252
              ],
              [
                48.8705793,
                37.1521302
              ],
              [
                48.8698146,
                37.1516513
              ],
              [
                48.8691956,
                37.1504033
              ],
              [
                48.8685765,
                37.1493874
              ],
              [
                48.865372,
                37.1475733
              ],
              [
                48.8639188,
                37.1475078
              ],
              [
                48.8622525,
                37.1475078
              ],
              [
                48.8614189,
                37.1475078
              ],
              [
                48.8608622,
                37.1475078
              ],
              [
                48.8608623,
                37.1477868
              ],
              [
                48.8589193,
                37.1477867
              ],
              [
                48.8586392,
                37.1480657
              ],
              [
                48.8580856,
                37.1477868
              ],
              [
                48.8564192,
                37.1477867
              ],
              [
                48.8561391,
                37.1480657
              ],
              [
                48.8550288,
                37.1480658
              ],
              [
                48.8434979,
                37.1518344
              ],
              [
                48.8366314,
                37.160864
              ],
              [
                48.8400647,
                37.1780994
              ],
              [
                48.8336827,
                37.1869766
              ],
              [
                48.8331261,
                37.1869766
              ],
              [
                48.8328495,
                37.1872554
              ],
              [
                48.8320159,
                37.1872553
              ],
              [
                48.8314593,
                37.1875342
              ],
              [
                48.8295162,
                37.1875342
              ],
              [
                48.8286826,
                37.1878131
              ],
              [
                48.8228498,
                37.1878131
              ],
              [
                48.8220162,
                37.1875342
              ],
              [
                48.8167398,
                37.1875342
              ],
              [
                48.8122928,
                37.1883618
              ],
              [
                48.8117363,
                37.1886406
              ],
              [
                48.8097931,
                37.1886405
              ],
              [
                48.8092361,
                37.1889195
              ],
              [
                48.8064599,
                37.1889195
              ],
              [
                48.8053497,
                37.1889195
              ],
              [
                48.8028497,
                37.188092
              ],
              [
                48.797836,
                37.1802878
              ],
              [
                48.8105389,
                37.159496
              ],
              [
                48.8101956,
                37.1485507
              ],
              [
                48.8019696,
                37.1419551
              ],
              [
                48.7941932,
                37.1394533
              ],
              [
                48.7939163,
                37.1391744
              ],
              [
                48.7900263,
                37.1391743
              ],
              [
                48.7886364,
                37.1397323
              ],
              [
                48.7883598,
                37.1400113
              ],
              [
                48.7875266,
                37.1400113
              ],
              [
                48.7872497,
                37.1402902
              ],
              [
                48.7866931,
                37.1402902
              ],
              [
                48.7833598,
                37.1436199
              ],
              [
                48.7769698,
                37.1466797
              ],
              [
                48.7764131,
                37.1469497
              ],
              [
                48.7680801,
                37.1502884
              ],
              [
                48.7647469,
                37.1566778
              ],
              [
                48.7589134,
                37.1647319
              ],
              [
                48.7572466,
                37.1658387
              ],
              [
                48.7553037,
                37.1663967
              ],
              [
                48.7553036,
                37.1666756
              ],
              [
                48.7539134,
                37.1666756
              ],
              [
                48.7522469,
                37.1694563
              ],
              [
                48.7519703,
                37.179454
              ],
              [
                48.7519703,
                37.1802909
              ],
              [
                48.7519703,
                37.1808398
              ],
              [
                48.7516902,
                37.1811188
              ],
              [
                48.7511367,
                37.1825136
              ],
              [
                48.7511367,
                37.1827925
              ],
              [
                48.7461334,
                37.1858431
              ],
              [
                48.7450237,
                37.185843
              ],
              [
                48.744467,
                37.1861221
              ],
              [
                48.7436334,
                37.1861221
              ],
              [
                48.7430802,
                37.1858431
              ],
              [
                48.7394669,
                37.1858431
              ],
              [
                48.7391904,
                37.1855641
              ],
              [
                48.7375235,
                37.1855641
              ],
              [
                48.7336336,
                37.1841783
              ],
              [
                48.7278003,
                37.1802908
              ],
              [
                48.726967,
                37.1800119
              ],
              [
                48.7262264,
                37.1796396
              ],
              [
                48.6958538,
                37.1600073
              ],
              [
                48.6947441,
                37.1594493
              ],
              [
                48.6801978,
                37.145938
              ],
              [
                48.6658128,
                37.1343733
              ],
              [
                48.6627641,
                37.1320892
              ],
              [
                48.6525098,
                37.1267122
              ],
              [
                48.6397556,
                37.1248841
              ],
              [
                48.6351956,
                37.1239982
              ],
              [
                48.630885,
                37.123635
              ],
              [
                48.6230422,
                37.121853
              ],
              [
                48.6150598,
                37.119914
              ],
              [
                48.6092532,
                37.1178706
              ],
              [
                48.5946321,
                37.1110506
              ],
              [
                48.5898256,
                37.1086207
              ],
              [
                48.5852766,
                37.1064645
              ],
              [
                48.5799122,
                37.1043254
              ],
              [
                48.5761249,
                37.1050014
              ],
              [
                48.57171,
                37.1084667
              ],
              [
                48.5708249,
                37.1113843
              ],
              [
                48.570621,
                37.1145456
              ],
              [
                48.5705191,
                37.1165134
              ],
              [
                48.5693872,
                37.1189345
              ],
              [
                48.5687005,
                37.1204316
              ],
              [
                48.5654497,
                37.1212614
              ],
              [
                48.565251,
                37.121159
              ],
              [
                48.5635447,
                37.1165488
              ],
              [
                48.5627718,
                37.114105
              ],
              [
                48.56183,
                37.1107356
              ],
              [
                48.5600961,
                37.1016553
              ],
              [
                48.5604179,
                37.0915295
              ],
              [
                48.5612392,
                37.0873402
              ],
              [
                48.5649715,
                37.0797298
              ],
              [
                48.56379,
                37.0727874
              ],
              [
                48.5180281,
                37.0447649
              ],
              [
                48.5095796,
                37.045483
              ],
              [
                48.4817523,
                37.0124039
              ],
              [
                48.4818713,
                36.99412
              ],
              [
                48.4858471,
                36.9825051
              ],
              [
                48.4861236,
                36.9808399
              ],
              [
                48.4861236,
                36.9766723
              ],
              [
                48.4867264,
                36.9726045
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555196,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ماه نشان",
          "name:en": "Mahneshan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286221",
          "wikipedia": "en:Mahneshan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.1799518,
                36.791667
              ],
              [
                47.1802322,
                36.7913878
              ],
              [
                47.1802322,
                36.7911087
              ],
              [
                47.1810651,
                36.7902714
              ],
              [
                47.1810651,
                36.789443
              ],
              [
                47.1813416,
                36.7886056
              ],
              [
                47.2123715,
                36.7685925
              ],
              [
                47.2615784,
                36.7185076
              ],
              [
                47.270231,
                36.7011117
              ],
              [
                47.2713451,
                36.7008326
              ],
              [
                47.2778646,
                36.6815396
              ],
              [
                47.2784216,
                36.6812603
              ],
              [
                47.2786983,
                36.6809813
              ],
              [
                47.2920314,
                36.6693083
              ],
              [
                47.3212543,
                36.6457958
              ],
              [
                47.3229208,
                36.6435716
              ],
              [
                47.3232004,
                36.6427341
              ],
              [
                47.3434775,
                36.614683
              ],
              [
                47.3702399,
                36.5726373
              ],
              [
                47.3771661,
                36.5598429
              ],
              [
                47.3943322,
                36.5504662
              ],
              [
                47.4142449,
                36.5361232
              ],
              [
                47.4533646,
                36.5288049
              ],
              [
                47.456978,
                36.5226991
              ],
              [
                47.4578115,
                36.5204746
              ],
              [
                47.4583646,
                36.5188085
              ],
              [
                47.4586444,
                36.5179709
              ],
              [
                47.458921,
                36.5165842
              ],
              [
                47.4597546,
                36.5127026
              ],
              [
                47.4603116,
                36.5110365
              ],
              [
                47.4597546,
                36.507146
              ],
              [
                47.4586445,
                36.5046423
              ],
              [
                47.4586445,
                36.5043631
              ],
              [
                47.4578116,
                36.5024179
              ],
              [
                47.3950188,
                36.473203
              ],
              [
                47.3751061,
                36.455532
              ],
              [
                47.3696133,
                36.43178
              ],
              [
                47.3881527,
                36.4171387
              ],
              [
                47.4293515,
                36.3958624
              ],
              [
                47.4640271,
                36.4008366
              ],
              [
                47.4840119,
                36.3994962
              ],
              [
                47.4879121,
                36.3992346
              ],
              [
                47.4887463,
                36.3991786
              ],
              [
                47.4914504,
                36.4032449
              ],
              [
                47.4902416,
                36.3990154
              ],
              [
                47.5069172,
                36.397196
              ],
              [
                47.5071679,
                36.3963705
              ],
              [
                47.5183364,
                36.3963641
              ],
              [
                47.5116402,
                36.4146039
              ],
              [
                47.5479697,
                36.4389613
              ],
              [
                47.589144,
                36.4305233
              ],
              [
                47.595534,
                36.4305233
              ],
              [
                47.5963672,
                36.4307935
              ],
              [
                47.5969204,
                36.4305233
              ],
              [
                47.6192751,
                36.4068722
              ],
              [
                47.6195549,
                36.406593
              ],
              [
                47.6203885,
                36.4063138
              ],
              [
                47.6209416,
                36.4063139
              ],
              [
                47.6212217,
                36.4060346
              ],
              [
                47.6374085,
                36.3916205
              ],
              [
                47.6385183,
                36.3916205
              ],
              [
                47.6393519,
                36.3913414
              ],
              [
                47.6404652,
                36.3913414
              ],
              [
                47.6410184,
                36.3910621
              ],
              [
                47.6596985,
                36.3805406
              ],
              [
                47.6655314,
                36.3797118
              ],
              [
                47.6699748,
                36.3788831
              ],
              [
                47.6710846,
                36.3788831
              ],
              [
                47.6741413,
                36.3783245
              ],
              [
                47.6758081,
                36.3783246
              ],
              [
                47.6769214,
                36.3780363
              ],
              [
                47.6935878,
                36.3774868
              ],
              [
                47.6944211,
                36.3777662
              ],
              [
                47.6991446,
                36.3783246
              ],
              [
                47.7002543,
                36.3788832
              ],
              [
                47.7069209,
                36.3799912
              ],
              [
                47.709421,
                36.3799913
              ],
              [
                47.7099776,
                36.3802705
              ],
              [
                47.7110877,
                36.3802705
              ],
              [
                47.7113675,
                36.3802705
              ],
              [
                47.7141441,
                36.3802705
              ],
              [
                47.7147007,
                36.3802705
              ],
              [
                47.7152543,
                36.3799912
              ],
              [
                47.7241444,
                36.3799913
              ],
              [
                47.724701,
                36.379712
              ],
              [
                47.7255342,
                36.379712
              ],
              [
                47.726644,
                36.3794328
              ],
              [
                47.7283108,
                36.3794328
              ],
              [
                47.7463671,
                36.3760997
              ],
              [
                47.748314,
                36.3760996
              ],
              [
                47.7488672,
                36.3758204
              ],
              [
                47.7505339,
                36.3758204
              ],
              [
                47.7513671,
                36.3755411
              ],
              [
                47.7524806,
                36.3755412
              ],
              [
                47.7533137,
                36.3752619
              ],
              [
                47.7599803,
                36.3747124
              ],
              [
                47.7644237,
                36.3747124
              ],
              [
                47.7652569,
                36.3744331
              ],
              [
                47.7666472,
                36.3744331
              ],
              [
                47.7674805,
                36.3741539
              ],
              [
                47.7685903,
                36.3741539
              ],
              [
                47.7710903,
                36.3735953
              ],
              [
                47.7822034,
                36.3719379
              ],
              [
                47.7877602,
                36.3694335
              ],
              [
                47.7919267,
                36.3674877
              ],
              [
                47.7963702,
                36.3655418
              ],
              [
                47.80026,
                36.3627671
              ],
              [
                47.8155366,
                36.3472092
              ],
              [
                47.81665,
                36.3466597
              ],
              [
                47.8269264,
                36.3422094
              ],
              [
                47.8277595,
                36.3422094
              ],
              [
                47.8283166,
                36.3419301
              ],
              [
                47.8297064,
                36.3416599
              ],
              [
                47.8319264,
                36.3416599
              ],
              [
                47.8322065,
                36.3413806
              ],
              [
                47.8333164,
                36.3413806
              ],
              [
                47.833873,
                36.3411013
              ],
              [
                47.8352597,
                36.3411013
              ],
              [
                47.8355399,
                36.340822
              ],
              [
                47.8383165,
                36.3408221
              ],
              [
                47.838593,
                36.3405427
              ],
              [
                47.8399829,
                36.3405428
              ],
              [
                47.8402595,
                36.3402635
              ],
              [
                47.8410931,
                36.3402635
              ],
              [
                47.8422064,
                36.3399842
              ],
              [
                47.8435962,
                36.3399842
              ],
              [
                47.8483163,
                36.3388762
              ],
              [
                47.866096,
                36.3297052
              ],
              [
                47.8669293,
                36.3297052
              ],
              [
                47.8674859,
                36.3294258
              ],
              [
                47.8708195,
                36.3288763
              ],
              [
                47.8741528,
                36.3288763
              ],
              [
                47.8747059,
                36.3291556
              ],
              [
                47.8758192,
                36.3291556
              ],
              [
                47.8835959,
                36.3311015
              ],
              [
                47.8849858,
                36.3311016
              ],
              [
                47.8849859,
                36.3313809
              ],
              [
                47.8863758,
                36.3313809
              ],
              [
                47.8874859,
                36.3313809
              ],
              [
                47.8885956,
                36.3316512
              ],
              [
                47.8908192,
                36.3316511
              ],
              [
                47.8910957,
                36.3327683
              ],
              [
                47.892209,
                36.3344348
              ],
              [
                47.8941525,
                36.3463807
              ],
              [
                47.8938758,
                36.3466599
              ],
              [
                47.8935957,
                36.3483175
              ],
              [
                47.8933192,
                36.3497049
              ],
              [
                47.8930422,
                36.3513714
              ],
              [
                47.8927621,
                36.3527678
              ],
              [
                47.8924856,
                36.3544345
              ],
              [
                47.892209,
                36.356101
              ],
              [
                47.8919289,
                36.3577586
              ],
              [
                47.8916523,
                36.3594342
              ],
              [
                47.8913757,
                36.3605423
              ],
              [
                47.8908191,
                36.3635962
              ],
              [
                47.8894288,
                36.3663798
              ],
              [
                47.8808192,
                36.3741542
              ],
              [
                47.8799856,
                36.3744334
              ],
              [
                47.875539,
                36.3791538
              ],
              [
                47.8735956,
                36.3844327
              ],
              [
                47.873319,
                36.3860993
              ],
              [
                47.8727623,
                36.3905404
              ],
              [
                47.8727623,
                36.3952698
              ],
              [
                47.8730389,
                36.3980442
              ],
              [
                47.8738724,
                36.4024853
              ],
              [
                47.8747058,
                36.4052598
              ],
              [
                47.8980419,
                36.4419402
              ],
              [
                47.900542,
                36.4469394
              ],
              [
                47.9022084,
                36.4497138
              ],
              [
                47.904985,
                36.4622163
              ],
              [
                47.9047084,
                36.4630449
              ],
              [
                47.904985,
                36.4660985
              ],
              [
                47.9055416,
                36.4680441
              ],
              [
                47.9060983,
                36.4711066
              ],
              [
                47.9152649,
                36.4774929
              ],
              [
                47.9194318,
                36.4783216
              ],
              [
                47.9199884,
                36.4786007
              ],
              [
                47.9213748,
                36.4786008
              ],
              [
                47.9222084,
                36.47888
              ],
              [
                47.9274883,
                36.4788801
              ],
              [
                47.9319312,
                36.4780514
              ],
              [
                47.9330414,
                36.4774929
              ],
              [
                47.9341547,
                36.4774929
              ],
              [
                47.9399881,
                36.4755474
              ],
              [
                47.9410979,
                36.4755474
              ],
              [
                47.9419315,
                36.4752681
              ],
              [
                47.9449878,
                36.4752681
              ],
              [
                47.9452648,
                36.4755474
              ],
              [
                47.946378,
                36.4755474
              ],
              [
                47.9466546,
                36.4758266
              ],
              [
                47.9477644,
                36.4758266
              ],
              [
                47.9480445,
                36.4761058
              ],
              [
                47.9491547,
                36.4761058
              ],
              [
                47.9522114,
                36.4772137
              ],
              [
                47.9530446,
                36.477493
              ],
              [
                47.9541545,
                36.4780514
              ],
              [
                47.954431,
                36.4786009
              ],
              [
                47.954988,
                36.4852753
              ],
              [
                47.9547111,
                36.4855454
              ],
              [
                47.954431,
                36.4866533
              ],
              [
                47.9491546,
                36.4927692
              ],
              [
                47.946098,
                36.4988851
              ],
              [
                47.9458213,
                36.5005514
              ],
              [
                47.9460978,
                36.5033255
              ],
              [
                47.946378,
                36.5049918
              ],
              [
                47.9469311,
                36.5083244
              ],
              [
                47.9480444,
                36.5105492
              ],
              [
                47.9485979,
                36.5122155
              ],
              [
                47.9499878,
                36.5197092
              ],
              [
                47.9497112,
                36.5199884
              ],
              [
                47.9494311,
                36.5227715
              ],
              [
                47.9491545,
                36.5241586
              ],
              [
                47.9485979,
                36.5255456
              ],
              [
                47.9485978,
                36.5266624
              ],
              [
                47.9483209,
                36.5269417
              ],
              [
                47.9480443,
                36.5280495
              ],
              [
                47.9416543,
                36.5455494
              ],
              [
                47.9413777,
                36.5460988
              ],
              [
                47.9410976,
                36.5466573
              ],
              [
                47.940821,
                36.5474948
              ],
              [
                47.9408211,
                36.5480443
              ],
              [
                47.9405444,
                36.5486026
              ],
              [
                47.9402644,
                36.5494402
              ],
              [
                47.9333213,
                36.5708304
              ],
              [
                47.9327645,
                36.5711006
              ],
              [
                47.9291543,
                36.5799897
              ],
              [
                47.9294313,
                36.583322
              ],
              [
                47.9299879,
                36.5841596
              ],
              [
                47.9308212,
                36.5858257
              ],
              [
                47.9399877,
                36.5897163
              ],
              [
                47.9410975,
                36.5897164
              ],
              [
                47.9416541,
                36.5899956
              ],
              [
                47.9427643,
                36.5899956
              ],
              [
                47.943321,
                36.5902748
              ],
              [
                47.9488778,
                36.5902748
              ],
              [
                47.9497109,
                36.5899956
              ],
              [
                47.9538774,
                36.5899955
              ],
              [
                47.9561009,
                36.590554
              ],
              [
                47.9572107,
                36.590554
              ],
              [
                47.9633205,
                36.598047
              ],
              [
                47.9644339,
                36.6002714
              ],
              [
                47.9647109,
                36.6008298
              ],
              [
                47.9644338,
                36.6016584
              ],
              [
                47.9686007,
                36.619715
              ],
              [
                47.9686007,
                36.6208317
              ],
              [
                47.9686007,
                36.6216602
              ],
              [
                47.9672105,
                36.6324941
              ],
              [
                47.9669338,
                36.6402748
              ],
              [
                47.9661006,
                36.6449936
              ],
              [
                47.9663771,
                36.6669395
              ],
              [
                47.966377,
                36.6672211
              ],
              [
                47.9658288,
                36.6669438
              ],
              [
                47.9658204,
                36.6669395
              ],
              [
                47.9558206,
                36.6611131
              ],
              [
                47.9274876,
                36.6522159
              ],
              [
                47.9263743,
                36.6522159
              ],
              [
                47.9238743,
                36.6516575
              ],
              [
                47.911931,
                36.6497214
              ],
              [
                47.9116509,
                36.6494421
              ],
              [
                47.9072079,
                36.6494422
              ],
              [
                47.9063746,
                36.649163
              ],
              [
                47.9041511,
                36.649163
              ],
              [
                47.9030414,
                36.6488839
              ],
              [
                47.897208,
                36.6488838
              ],
              [
                47.8966515,
                36.649163
              ],
              [
                47.8927611,
                36.6491629
              ],
              [
                47.8919278,
                36.6494422
              ],
              [
                47.8891512,
                36.6494422
              ],
              [
                47.8855413,
                36.6499915
              ],
              [
                47.862485,
                36.6588796
              ],
              [
                47.8622049,
                36.659438
              ],
              [
                47.8616518,
                36.6599963
              ],
              [
                47.862485,
                36.6611129
              ],
              [
                47.8635948,
                36.6624907
              ],
              [
                47.8644283,
                36.6708295
              ],
              [
                47.8638717,
                36.6741614
              ],
              [
                47.8638717,
                36.6758273
              ],
              [
                47.8635947,
                36.6761065
              ],
              [
                47.8522049,
                36.7052733
              ],
              [
                47.8516482,
                36.7058316
              ],
              [
                47.8513717,
                36.7066691
              ],
              [
                47.8505381,
                36.7074974
              ],
              [
                47.8502615,
                36.7083259
              ],
              [
                47.8499814,
                36.708605
              ],
              [
                47.8480384,
                36.7111083
              ],
              [
                47.8435949,
                36.7172134
              ],
              [
                47.835815,
                36.7249933
              ],
              [
                47.8258152,
                36.7299998
              ],
              [
                47.8219253,
                36.730549
              ],
              [
                47.8210917,
                36.7308282
              ],
              [
                47.8199818,
                36.7308282
              ],
              [
                47.8191487,
                36.7311073
              ],
              [
                47.818315,
                36.7311073
              ],
              [
                47.8177584,
                36.7313864
              ],
              [
                47.816092,
                36.7313864
              ],
              [
                47.8158154,
                36.7316656
              ],
              [
                47.8108153,
                36.7316655
              ],
              [
                47.809982,
                36.7313864
              ],
              [
                47.8072019,
                36.7313864
              ],
              [
                47.8066487,
                36.7311072
              ],
              [
                47.803592,
                36.7311072
              ],
              [
                47.8027588,
                36.7308281
              ],
              [
                47.7908121,
                36.7308281
              ],
              [
                47.7880354,
                36.7316655
              ],
              [
                47.786092,
                36.7319356
              ],
              [
                47.7855354,
                36.7322147
              ],
              [
                47.7849788,
                36.7322147
              ],
              [
                47.7824786,
                36.7333313
              ],
              [
                47.7783122,
                36.7361137
              ],
              [
                47.7535893,
                36.7694379
              ],
              [
                47.7391424,
                36.7786128
              ],
              [
                47.7316427,
                36.7811159
              ],
              [
                47.7294192,
                36.781386
              ],
              [
                47.7149763,
                36.7830517
              ],
              [
                47.7146993,
                36.7833308
              ],
              [
                47.7130328,
                36.7833307
              ],
              [
                47.7121996,
                36.7836099
              ],
              [
                47.7102527,
                36.7836099
              ],
              [
                47.709696,
                36.7838891
              ],
              [
                47.7077527,
                36.783889
              ],
              [
                47.7074761,
                36.7841681
              ],
              [
                47.7063628,
                36.7841681
              ],
              [
                47.7060863,
                36.7844472
              ],
              [
                47.7046964,
                36.7844472
              ],
              [
                47.6838631,
                36.7908308
              ],
              [
                47.6783063,
                36.7963861
              ],
              [
                47.6774731,
                36.7983309
              ],
              [
                47.6766398,
                36.8002756
              ],
              [
                47.6763632,
                36.8005547
              ],
              [
                47.6760866,
                36.8022204
              ],
              [
                47.6758066,
                36.8047234
              ],
              [
                47.6763632,
                36.8111069
              ],
              [
                47.6769199,
                36.8133307
              ],
              [
                47.6869197,
                36.8272228
              ],
              [
                47.6896962,
                36.8319405
              ],
              [
                47.6896962,
                36.8327778
              ],
              [
                47.6902529,
                36.8338852
              ],
              [
                47.690806,
                36.8402775
              ],
              [
                47.6905294,
                36.8405565
              ],
              [
                47.6896962,
                36.8430504
              ],
              [
                47.6866395,
                36.8527827
              ],
              [
                47.687196,
                36.8625057
              ],
              [
                47.6869195,
                36.8627758
              ],
              [
                47.6866394,
                36.8641623
              ],
              [
                47.6863629,
                36.8658278
              ],
              [
                47.6823344,
                36.8726863
              ],
              [
                47.6624732,
                36.8791697
              ],
              [
                47.6594165,
                36.8794487
              ],
              [
                47.6591396,
                36.8797189
              ],
              [
                47.6546965,
                36.8847243
              ],
              [
                47.6546965,
                36.8852825
              ],
              [
                47.6538597,
                36.8863897
              ],
              [
                47.6505264,
                36.8941678
              ],
              [
                47.6488596,
                36.9033413
              ],
              [
                47.648583,
                36.9044486
              ],
              [
                47.6399729,
                36.9216697
              ],
              [
                47.6371932,
                36.9252796
              ],
              [
                47.63636,
                36.9261077
              ],
              [
                47.6319165,
                36.9302757
              ],
              [
                47.6313598,
                36.9302757
              ],
              [
                47.6219166,
                36.9350016
              ],
              [
                47.6210835,
                36.9350017
              ],
              [
                47.6208033,
                36.9352807
              ],
              [
                47.6202498,
                36.9352807
              ],
              [
                47.6113602,
                36.9375042
              ],
              [
                47.6096933,
                36.9375042
              ],
              [
                47.6094132,
                36.9377832
              ],
              [
                47.6055269,
                36.9377832
              ],
              [
                47.6046936,
                36.9380623
              ],
              [
                47.5999701,
                36.9386114
              ],
              [
                47.5971903,
                36.9386114
              ],
              [
                47.5966368,
                36.9388904
              ],
              [
                47.5838568,
                36.9388904
              ],
              [
                47.5835803,
                36.9386114
              ],
              [
                47.5808037,
                36.9386113
              ],
              [
                47.5799704,
                36.9383322
              ],
              [
                47.5771902,
                36.9380622
              ],
              [
                47.573857,
                36.9375041
              ],
              [
                47.5730238,
                36.9375041
              ],
              [
                47.5724671,
                36.9372251
              ],
              [
                47.5716338,
                36.937225
              ],
              [
                47.5480241,
                36.9308336
              ],
              [
                47.5474674,
                36.9302755
              ],
              [
                47.5263545,
                36.9205532
              ],
              [
                47.5241486,
                36.9205528
              ],
              [
                47.5238544,
                36.9202831
              ],
              [
                47.5233013,
                36.9202832
              ],
              [
                47.5216309,
                36.919725
              ],
              [
                47.5205211,
                36.9197249
              ],
              [
                47.5182976,
                36.9191669
              ],
              [
                47.5124644,
                36.9183387
              ],
              [
                47.5066314,
                36.9183387
              ],
              [
                47.5063544,
                36.9186177
              ],
              [
                47.5055212,
                36.9186177
              ],
              [
                47.5044114,
                36.9188968
              ],
              [
                47.4888548,
                36.9236137
              ],
              [
                47.4641285,
                36.933615
              ],
              [
                47.4602417,
                36.9352803
              ],
              [
                47.459685,
                36.9352804
              ],
              [
                47.4352387,
                36.9499983
              ],
              [
                47.4281849,
                36.9573415
              ],
              [
                47.4121824,
                36.9505563
              ],
              [
                47.4113487,
                36.9505563
              ],
              [
                47.4094057,
                36.9497282
              ],
              [
                47.4085721,
                36.9497281
              ],
              [
                47.4080159,
                36.9494491
              ],
              [
                47.4071823,
                36.9494491
              ],
              [
                47.4010728,
                36.9474957
              ],
              [
                47.3955156,
                36.9466675
              ],
              [
                47.3727362,
                36.9372245
              ],
              [
                47.3713495,
                36.9366664
              ],
              [
                47.3188468,
                36.9055551
              ],
              [
                47.3168999,
                36.9044478
              ],
              [
                47.3027333,
                36.8972278
              ],
              [
                47.3005113,
                36.8952734
              ],
              [
                47.2999567,
                36.8947162
              ],
              [
                47.2955105,
                36.883337
              ],
              [
                47.2910675,
                36.8780615
              ],
              [
                47.2693975,
                36.8713904
              ],
              [
                47.2577309,
                36.8663849
              ],
              [
                47.2568973,
                36.8658267
              ],
              [
                47.2432876,
                36.8461104
              ],
              [
                47.2410643,
                36.839169
              ],
              [
                47.2405079,
                36.8383317
              ],
              [
                47.2263413,
                36.8275008
              ],
              [
                47.223285,
                36.8252771
              ],
              [
                47.2091182,
                36.811943
              ],
              [
                47.1982853,
                36.7994371
              ],
              [
                47.1907851,
                36.7955565
              ],
              [
                47.1880082,
                36.7924952
              ],
              [
                47.1868988,
                36.7924952
              ],
              [
                47.1852316,
                36.7922161
              ],
              [
                47.1846753,
                36.7922162
              ],
              [
                47.1843987,
                36.7919371
              ],
              [
                47.1799518,
                36.791667
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820252492
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          48.2816192,
          36.4284545
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32828378
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          48.5089736,
          36.6763063
        ]
      }
    }
  ]
},
"سمنان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554857,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آرادان",
          "name:en": "Aradan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q10843583",
          "wikipedia": "en:Aradan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.4022866,
                34.4291127
              ],
              [
                52.403813,
                34.428833
              ],
              [
                52.4040897,
                34.4285532
              ],
              [
                52.4054797,
                34.4285532
              ],
              [
                52.4060364,
                34.4282734
              ],
              [
                52.4068696,
                34.4282734
              ],
              [
                52.4090895,
                34.4282735
              ],
              [
                52.4096462,
                34.4285532
              ],
              [
                52.4102029,
                34.4282735
              ],
              [
                52.4160362,
                34.4274432
              ],
              [
                52.4174262,
                34.4271725
              ],
              [
                52.429646,
                34.4271725
              ],
              [
                52.4307592,
                34.4274433
              ],
              [
                52.4368693,
                34.426613
              ],
              [
                52.4440925,
                34.426613
              ],
              [
                52.4446492,
                34.4263332
              ],
              [
                52.4474257,
                34.4263332
              ],
              [
                52.4485358,
                34.4260534
              ],
              [
                52.4504824,
                34.4260535
              ],
              [
                52.4532591,
                34.425503
              ],
              [
                52.4563157,
                34.4255031
              ],
              [
                52.4590923,
                34.4249435
              ],
              [
                52.4796487,
                34.4221641
              ],
              [
                52.4821486,
                34.4221641
              ],
              [
                52.4829819,
                34.4218843
              ],
              [
                52.4888186,
                34.4210631
              ],
              [
                52.4999285,
                34.4191138
              ],
              [
                52.5025119,
                34.4184128
              ],
              [
                52.5264463,
                34.4102747
              ],
              [
                52.5612699,
                34.4013693
              ],
              [
                52.5804843,
                34.3960065
              ],
              [
                52.5928844,
                34.3920049
              ],
              [
                52.6035292,
                34.390082
              ],
              [
                52.6095714,
                34.3882974
              ],
              [
                52.6528082,
                34.3775899
              ],
              [
                52.6732697,
                34.3666098
              ],
              [
                52.677993,
                34.3643897
              ],
              [
                52.7416319,
                34.3327637
              ],
              [
                52.7639419,
                34.3198834
              ],
              [
                52.8017401,
                34.3005397
              ],
              [
                52.8163312,
                34.2988339
              ],
              [
                52.8163313,
                34.3002237
              ],
              [
                52.8163313,
                34.302164
              ],
              [
                52.815498,
                34.314104
              ],
              [
                52.8163313,
                34.3629999
              ],
              [
                52.8166113,
                34.36411
              ],
              [
                52.8163312,
                34.36633
              ],
              [
                52.8171645,
                34.3877272
              ],
              [
                52.8174446,
                34.3918875
              ],
              [
                52.8179978,
                34.3949468
              ],
              [
                52.8193879,
                34.4205038
              ],
              [
                52.8191112,
                34.4230035
              ],
              [
                52.8188311,
                34.4291129
              ],
              [
                52.8185545,
                34.4327226
              ],
              [
                52.8193879,
                34.4502295
              ],
              [
                52.8193879,
                34.4516102
              ],
              [
                52.8199445,
                34.4818949
              ],
              [
                52.8193878,
                34.4935629
              ],
              [
                52.8193879,
                34.5205081
              ],
              [
                52.8179978,
                34.5374455
              ],
              [
                52.8174445,
                34.5405045
              ],
              [
                52.8168878,
                34.549113
              ],
              [
                52.821331,
                34.6577262
              ],
              [
                52.8260543,
                34.7327321
              ],
              [
                52.8260542,
                34.7344012
              ],
              [
                52.8277209,
                34.7821745
              ],
              [
                52.8280009,
                34.7838437
              ],
              [
                52.8277208,
                34.7871728
              ],
              [
                52.8280009,
                34.8319039
              ],
              [
                52.8282776,
                34.836902
              ],
              [
                52.8280009,
                34.840231
              ],
              [
                52.8277208,
                34.8524555
              ],
              [
                52.8274442,
                34.8635703
              ],
              [
                52.8252208,
                34.8963455
              ],
              [
                52.8254975,
                34.9074599
              ],
              [
                52.8252208,
                34.9102295
              ],
              [
                52.8254975,
                34.9169052
              ],
              [
                52.8252207,
                34.9194041
              ],
              [
                52.8249442,
                34.9374556
              ],
              [
                52.8254974,
                34.9557954
              ],
              [
                52.8257774,
                34.9569051
              ],
              [
                52.8252208,
                34.9680189
              ],
              [
                52.8254974,
                34.974956
              ],
              [
                52.8260541,
                34.9796829
              ],
              [
                52.8321674,
                34.9994024
              ],
              [
                52.8310539,
                35.0019012
              ],
              [
                52.831054,
                35.0071873
              ],
              [
                52.8310539,
                35.0080172
              ],
              [
                52.8313341,
                35.008847
              ],
              [
                52.831054,
                35.009686
              ],
              [
                52.831334,
                35.0119051
              ],
              [
                52.8310539,
                35.0121848
              ],
              [
                52.8307774,
                35.0169025
              ],
              [
                52.8318873,
                35.0385789
              ],
              [
                52.8310539,
                35.0471844
              ],
              [
                52.831334,
                35.0688511
              ],
              [
                52.832444,
                35.0863503
              ],
              [
                52.8327206,
                35.0871801
              ],
              [
                52.8327205,
                35.0924659
              ],
              [
                52.8327206,
                35.0955238
              ],
              [
                52.832444,
                35.0960739
              ],
              [
                52.8327205,
                35.0985725
              ],
              [
                52.832444,
                35.0991317
              ],
              [
                52.8321673,
                35.1044085
              ],
              [
                52.832444,
                35.1049586
              ],
              [
                52.8318872,
                35.1080165
              ],
              [
                52.829944,
                35.1244056
              ],
              [
                52.8296674,
                35.1263539
              ],
              [
                52.8293872,
                35.1313509
              ],
              [
                52.8291106,
                35.1374663
              ],
              [
                52.8288341,
                35.1424632
              ],
              [
                52.8291106,
                35.1605205
              ],
              [
                52.8330006,
                35.1957955
              ],
              [
                52.8327205,
                35.2007922
              ],
              [
                52.8324438,
                35.2052387
              ],
              [
                52.8327204,
                35.2124631
              ],
              [
                52.8332773,
                35.2205172
              ],
              [
                52.8330006,
                35.2210764
              ],
              [
                52.8299439,
                35.2444086
              ],
              [
                52.8247491,
                35.2613306
              ],
              [
                52.8191106,
                35.2796902
              ],
              [
                52.8182773,
                35.2827475
              ],
              [
                52.8182774,
                35.283027
              ],
              [
                52.8163306,
                35.2891326
              ],
              [
                52.816054,
                35.2908011
              ],
              [
                52.8157774,
                35.2930287
              ],
              [
                52.8474437,
                35.340799
              ],
              [
                52.8502236,
                35.3446859
              ],
              [
                52.8535568,
                35.3499705
              ],
              [
                52.8580002,
                35.3588623
              ],
              [
                52.8585569,
                35.3627401
              ],
              [
                52.8588334,
                35.3632991
              ],
              [
                52.8585568,
                35.3638583
              ],
              [
                52.8571668,
                35.3683042
              ],
              [
                52.8568902,
                35.3685837
              ],
              [
                52.838277,
                35.3846896
              ],
              [
                52.8371671,
                35.3858079
              ],
              [
                52.8196639,
                35.3963587
              ],
              [
                52.8177206,
                35.3971883
              ],
              [
                52.8132773,
                35.4002454
              ],
              [
                52.7982742,
                35.4113551
              ],
              [
                52.7974408,
                35.4116346
              ],
              [
                52.7971642,
                35.4121937
              ],
              [
                52.7963309,
                35.4124732
              ],
              [
                52.7916076,
                35.4188578
              ],
              [
                52.7843843,
                35.4482996
              ],
              [
                52.7841075,
                35.4496973
              ],
              [
                52.783551,
                35.4555225
              ],
              [
                52.7832743,
                35.4616362
              ],
              [
                52.7835509,
                35.4644135
              ],
              [
                52.7832743,
                35.4655226
              ],
              [
                52.7835508,
                35.4691384
              ],
              [
                52.7829976,
                35.4755316
              ],
              [
                52.783831,
                35.4941428
              ],
              [
                52.7835508,
                35.4955224
              ],
              [
                52.7866675,
                35.516445
              ],
              [
                52.7874409,
                35.521635
              ],
              [
                52.7877175,
                35.5244122
              ],
              [
                52.7913308,
                35.5344206
              ],
              [
                52.7921642,
                35.5377478
              ],
              [
                52.7943875,
                35.5446904
              ],
              [
                52.7943875,
                35.5459445
              ],
              [
                52.7932741,
                35.545529
              ],
              [
                52.7929974,
                35.5452495
              ],
              [
                52.7821642,
                35.5410839
              ],
              [
                52.7788309,
                35.5410839
              ],
              [
                52.7768843,
                35.5416429
              ],
              [
                52.7668843,
                35.5469175
              ],
              [
                52.7660511,
                35.5469175
              ],
              [
                52.7343849,
                35.5533102
              ],
              [
                52.7277148,
                35.5555282
              ],
              [
                52.7266049,
                35.5555282
              ],
              [
                52.7260482,
                35.5552487
              ],
              [
                52.725495,
                35.5555282
              ],
              [
                52.7163284,
                35.5555282
              ],
              [
                52.715215,
                35.5552487
              ],
              [
                52.7132718,
                35.5552487
              ],
              [
                52.7121583,
                35.5549692
              ],
              [
                52.7085484,
                35.5544192
              ],
              [
                52.7077151,
                35.5544192
              ],
              [
                52.6977153,
                35.5519216
              ],
              [
                52.6727122,
                35.5391362
              ],
              [
                52.6696589,
                35.5369182
              ],
              [
                52.6674356,
                35.5358092
              ],
              [
                52.6671589,
                35.5352501
              ],
              [
                52.6599357,
                35.5294163
              ],
              [
                52.6596591,
                35.5285868
              ],
              [
                52.6591023,
                35.5283073
              ],
              [
                52.6377126,
                35.5083082
              ],
              [
                52.634656,
                35.5038628
              ],
              [
                52.6338227,
                35.5027448
              ],
              [
                52.6152095,
                35.4724748
              ],
              [
                52.6115996,
                35.4674702
              ],
              [
                52.6082664,
                35.4641428
              ],
              [
                52.6071564,
                35.4624657
              ],
              [
                52.6063231,
                35.4619156
              ],
              [
                52.5629869,
                35.4174689
              ],
              [
                52.555207,
                35.4119141
              ],
              [
                52.5513204,
                35.4099663
              ],
              [
                52.5502071,
                35.4091366
              ],
              [
                52.5363172,
                35.4016339
              ],
              [
                52.5349306,
                35.4013544
              ],
              [
                52.5340973,
                35.4008043
              ],
              [
                52.5327073,
                35.4005247
              ],
              [
                52.5318739,
                35.3999656
              ],
              [
                52.5310407,
                35.3999656
              ],
              [
                52.5302073,
                35.3994155
              ],
              [
                52.5246748,
                35.397823
              ],
              [
                52.5227074,
                35.3916423
              ],
              [
                52.5218741,
                35.3883057
              ],
              [
                52.5213174,
                35.387476
              ],
              [
                52.5182608,
                35.3794141
              ],
              [
                52.5149275,
                35.3677449
              ],
              [
                52.5029843,
                35.3474632
              ],
              [
                52.4999278,
                35.343856
              ],
              [
                52.4965944,
                35.341358
              ],
              [
                52.4752047,
                35.3196871
              ],
              [
                52.4740948,
                35.3191369
              ],
              [
                52.4724281,
                35.3174686
              ],
              [
                52.4395193,
                35.2959114
              ],
              [
                52.4349479,
                35.2924726
              ],
              [
                52.4331454,
                35.2911696
              ],
              [
                52.4288196,
                35.2894041
              ],
              [
                52.4262704,
                35.2886265
              ],
              [
                52.423026,
                35.2874495
              ],
              [
                52.4190864,
                35.2856839
              ],
              [
                52.4179019,
                35.2849903
              ],
              [
                52.4174642,
                35.2847591
              ],
              [
                52.4170522,
                35.2843597
              ],
              [
                52.416151,
                35.2832457
              ],
              [
                52.4156875,
                35.2822788
              ],
              [
                52.415842,
                35.2809966
              ],
              [
                52.415121,
                35.2796513
              ],
              [
                52.414709,
                35.2789367
              ],
              [
                52.4146833,
                35.277297
              ],
              [
                52.4153012,
                35.2738916
              ],
              [
                52.4167432,
                35.271432
              ],
              [
                52.4182624,
                35.2696451
              ],
              [
                52.4192151,
                35.2673746
              ],
              [
                52.4209236,
                35.2637979
              ],
              [
                52.4213497,
                35.2612549
              ],
              [
                52.421118,
                35.2552206
              ],
              [
                52.4204743,
                35.2505105
              ],
              [
                52.4205,
                35.2470408
              ],
              [
                52.4235127,
                35.2390496
              ],
              [
                52.4281733,
                35.2311206
              ],
              [
                52.4325506,
                35.2256309
              ],
              [
                52.435383,
                35.2215922
              ],
              [
                52.437443,
                35.2184158
              ],
              [
                52.4373142,
                35.2167119
              ],
              [
                52.4400436,
                35.2103586
              ],
              [
                52.4471762,
                35.1990814
              ],
              [
                52.4492876,
                35.1937578
              ],
              [
                52.4519655,
                35.1920113
              ],
              [
                52.4547207,
                35.1901595
              ],
              [
                52.4578878,
                35.1877394
              ],
              [
                52.459716,
                35.1857402
              ],
              [
                52.460231,
                35.1825835
              ],
              [
                52.459819,
                35.1812155
              ],
              [
                52.4579908,
                35.1769221
              ],
              [
                52.4588406,
                35.1756382
              ],
              [
                52.4632437,
                35.1730494
              ],
              [
                52.4740068,
                35.1671347
              ],
              [
                52.4800322,
                35.1625248
              ],
              [
                52.4824268,
                35.160946
              ],
              [
                52.4924948,
                35.1562515
              ],
              [
                52.4961543,
                35.1547457
              ],
              [
                52.5040335,
                35.1476086
              ],
              [
                52.503879,
                35.1454189
              ],
              [
                52.5014844,
                35.1437134
              ],
              [
                52.4936566,
                35.1400707
              ],
              [
                52.4852624,
                35.1340484
              ],
              [
                52.4816832,
                35.1282362
              ],
              [
                52.480885,
                35.1234556
              ],
              [
                52.4837432,
                35.1195803
              ],
              [
                52.4993729,
                35.111071
              ],
              [
                52.5018449,
                35.1082063
              ],
              [
                52.503879,
                35.1043935
              ],
              [
                52.5035186,
                35.1025818
              ],
              [
                52.4999279,
                35.0957942
              ],
              [
                52.497428,
                35.0905174
              ],
              [
                52.4971513,
                35.089408
              ],
              [
                52.4965948,
                35.0888487
              ],
              [
                52.4879848,
                35.07107
              ],
              [
                52.4827049,
                35.0566285
              ],
              [
                52.4743716,
                35.0399588
              ],
              [
                52.470205,
                35.0288456
              ],
              [
                52.467425,
                35.0238482
              ],
              [
                52.4660385,
                35.0207992
              ],
              [
                52.4660384,
                35.02024
              ],
              [
                52.4629818,
                35.014124
              ],
              [
                52.4624251,
                35.014124
              ],
              [
                52.4621484,
                35.0138444
              ],
              [
                52.4615917,
                35.0021806
              ],
              [
                52.4604819,
                35.0021806
              ],
              [
                52.4524252,
                34.9982927
              ],
              [
                52.4496487,
                34.981072
              ],
              [
                52.447982,
                34.9769043
              ],
              [
                52.4482586,
                34.9757947
              ],
              [
                52.447982,
                34.9752354
              ],
              [
                52.4482586,
                34.9744055
              ],
              [
                52.449092,
                34.9730163
              ],
              [
                52.4485353,
                34.9641216
              ],
              [
                52.4488154,
                34.9632918
              ],
              [
                52.4468687,
                34.9544061
              ],
              [
                52.445202,
                34.9482898
              ],
              [
                52.4446487,
                34.9438514
              ],
              [
                52.4435354,
                34.9346768
              ],
              [
                52.4427021,
                34.9282899
              ],
              [
                52.4424254,
                34.9244017
              ],
              [
                52.4368688,
                34.8646797
              ],
              [
                52.4329824,
                34.8477279
              ],
              [
                52.422979,
                34.7968984
              ],
              [
                52.4221457,
                34.7943993
              ],
              [
                52.4207591,
                34.783293
              ],
              [
                52.4202025,
                34.777176
              ],
              [
                52.4190926,
                34.7688395
              ],
              [
                52.4177026,
                34.7635704
              ],
              [
                52.4071461,
                34.7296822
              ],
              [
                52.3765898,
                34.6788395
              ],
              [
                52.3726997,
                34.6657834
              ],
              [
                52.3713099,
                34.657726
              ],
              [
                52.3688098,
                34.635791
              ],
              [
                52.3676999,
                34.6124481
              ],
              [
                52.3685333,
                34.6055092
              ],
              [
                52.3682567,
                34.588004
              ],
              [
                52.3677,
                34.5757864
              ],
              [
                52.3679766,
                34.5732869
              ],
              [
                52.3685332,
                34.571058
              ],
              [
                52.3685333,
                34.5682878
              ],
              [
                52.3702,
                34.5552218
              ],
              [
                52.3704766,
                34.5455034
              ],
              [
                52.3707566,
                34.5405043
              ],
              [
                52.3718666,
                34.5366151
              ],
              [
                52.37409,
                34.5221681
              ],
              [
                52.3743666,
                34.5205078
              ],
              [
                52.3738134,
                34.5113397
              ],
              [
                52.37409,
                34.5099499
              ],
              [
                52.3751999,
                34.5060607
              ],
              [
                52.3760332,
                34.5035611
              ],
              [
                52.3793666,
                34.4902238
              ],
              [
                52.3871465,
                34.4663373
              ],
              [
                52.3990897,
                34.4393913
              ],
              [
                52.3993697,
                34.4371713
              ],
              [
                52.3996463,
                34.4363321
              ],
              [
                52.3999231,
                34.4355018
              ],
              [
                52.4002031,
                34.4341121
              ],
              [
                52.4015897,
                34.4305025
              ],
              [
                52.4022866,
                34.4291127
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555010,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دامغان",
          "name:ar": "مقاطعة دامغان",
          "name:en": "Damghan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278624",
          "wikipedia": "en:Damghan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.7060189,
                35.9914912
              ],
              [
                53.70943,
                35.9847086
              ],
              [
                53.7077633,
                35.9783187
              ],
              [
                53.7074833,
                35.9760927
              ],
              [
                53.7072066,
                35.9713701
              ],
              [
                53.7077633,
                35.9644303
              ],
              [
                53.70804,
                35.9622042
              ],
              [
                53.7116499,
                35.9538765
              ],
              [
                53.7124832,
                35.9530382
              ],
              [
                53.7133166,
                35.9513799
              ],
              [
                53.7222065,
                35.940258
              ],
              [
                53.7258198,
                35.9369322
              ],
              [
                53.7260964,
                35.9366438
              ],
              [
                53.7283198,
                35.9352558
              ],
              [
                53.7588761,
                35.9210963
              ],
              [
                53.7794324,
                35.9141472
              ],
              [
                53.7805425,
                35.913318
              ],
              [
                53.8252686,
                35.8952645
              ],
              [
                53.826102,
                35.8944262
              ],
              [
                53.829992,
                35.8930382
              ],
              [
                53.8719381,
                35.8738755
              ],
              [
                53.8752714,
                35.8724874
              ],
              [
                53.8758247,
                35.8719286
              ],
              [
                53.880548,
                35.8697023
              ],
              [
                53.8813814,
                35.8697022
              ],
              [
                53.9074944,
                35.8597061
              ],
              [
                53.9694403,
                35.8327548
              ],
              [
                53.9755536,
                35.8305374
              ],
              [
                53.9827768,
                35.8285904
              ],
              [
                53.9880535,
                35.8266523
              ],
              [
                53.9899967,
                35.8260935
              ],
              [
                53.9905534,
                35.8260935
              ],
              [
                53.9913867,
                35.8258141
              ],
              [
                53.9927768,
                35.8258141
              ],
              [
                53.99333,
                35.8255346
              ],
              [
                53.99583,
                35.8255347
              ],
              [
                54.0032982,
                35.8243475
              ],
              [
                54.0069433,
                35.815538
              ],
              [
                54.0072199,
                35.8149791
              ],
              [
                54.0080531,
                35.8094265
              ],
              [
                54.0119432,
                35.7777592
              ],
              [
                54.0124998,
                35.7672033
              ],
              [
                54.0130532,
                35.7633179
              ],
              [
                54.0136098,
                35.7291521
              ],
              [
                54.0133331,
                35.723031
              ],
              [
                54.0108332,
                35.708039
              ],
              [
                54.0099999,
                35.7013678
              ],
              [
                54.0083332,
                35.6777569
              ],
              [
                54.0080532,
                35.6760891
              ],
              [
                54.0075,
                35.6680293
              ],
              [
                54.0083333,
                35.645815
              ],
              [
                54.0080531,
                35.6433087
              ],
              [
                54.0086099,
                35.6349782
              ],
              [
                54.017592,
                35.5949746
              ],
              [
                54.017682,
                35.5947016
              ],
              [
                54.0177764,
                35.5944156
              ],
              [
                54.0180565,
                35.5941451
              ],
              [
                54.0191665,
                35.5894207
              ],
              [
                54.0186097,
                35.5858052
              ],
              [
                54.0177764,
                35.5797013
              ],
              [
                54.0174998,
                35.5783128
              ],
              [
                54.0202764,
                35.5666367
              ],
              [
                54.0202764,
                35.5510835
              ],
              [
                54.0211097,
                35.5494153
              ],
              [
                54.0238897,
                35.5316438
              ],
              [
                54.025833,
                35.5071904
              ],
              [
                54.0263897,
                35.5044132
              ],
              [
                54.0263897,
                35.5008065
              ],
              [
                54.0266663,
                35.4960817
              ],
              [
                54.027223,
                35.4924749
              ],
              [
                54.0272231,
                35.4902477
              ],
              [
                54.0316662,
                35.4699683
              ],
              [
                54.0386129,
                35.4555227
              ],
              [
                54.0652792,
                35.4266401
              ],
              [
                54.0894456,
                35.4058005
              ],
              [
                54.0994489,
                35.3985863
              ],
              [
                54.1055588,
                35.393861
              ],
              [
                54.1088919,
                35.3905245
              ],
              [
                54.137505,
                35.3688545
              ],
              [
                54.1447282,
                35.3624698
              ],
              [
                54.1688946,
                35.3441359
              ],
              [
                54.1780612,
                35.3260815
              ],
              [
                54.1788945,
                35.3213559
              ],
              [
                54.1794512,
                35.3171894
              ],
              [
                54.1797278,
                35.3080267
              ],
              [
                54.1791745,
                35.3016327
              ],
              [
                54.1794512,
                35.2988549
              ],
              [
                54.1811178,
                35.2652423
              ],
              [
                54.1808411,
                35.260246
              ],
              [
                54.1805611,
                35.2580274
              ],
              [
                54.1808411,
                35.2471866
              ],
              [
                54.1805611,
                35.2452476
              ],
              [
                54.1808411,
                35.2444088
              ],
              [
                54.1805611,
                35.2316289
              ],
              [
                54.1769512,
                35.203859
              ],
              [
                54.1761179,
                35.1905194
              ],
              [
                54.1758412,
                35.1860729
              ],
              [
                54.1750079,
                35.174961
              ],
              [
                54.1744512,
                35.1680159
              ],
              [
                54.1738946,
                35.1630191
              ],
              [
                54.1738946,
                35.1599615
              ],
              [
                54.1733413,
                35.1510772
              ],
              [
                54.1750079,
                35.1369072
              ],
              [
                54.1766746,
                35.1294028
              ],
              [
                54.1769511,
                35.1269043
              ],
              [
                54.1791745,
                35.0902382
              ],
              [
                54.1788945,
                35.0880193
              ],
              [
                54.1791745,
                35.0846818
              ],
              [
                54.1788944,
                35.0827425
              ],
              [
                54.1791745,
                35.081633
              ],
              [
                54.1788944,
                35.0796847
              ],
              [
                54.1791745,
                35.0777363
              ],
              [
                54.1805611,
                35.0302352
              ],
              [
                54.1802845,
                35.0291256
              ],
              [
                54.1805611,
                35.0277365
              ],
              [
                54.1802844,
                35.0266269
              ],
              [
                54.1805611,
                35.0238486
              ],
              [
                54.180561,
                35.0202404
              ],
              [
                54.1808411,
                35.0141244
              ],
              [
                54.1811178,
                34.9988524
              ],
              [
                54.1819511,
                34.9957944
              ],
              [
                54.1833411,
                34.9910765
              ],
              [
                54.1838944,
                34.9869089
              ],
              [
                54.1822277,
                34.9605137
              ],
              [
                54.1780611,
                34.9271806
              ],
              [
                54.1783412,
                34.9169055
              ],
              [
                54.1791745,
                34.9071805
              ],
              [
                54.1794511,
                34.8969051
              ],
              [
                54.1788944,
                34.8860703
              ],
              [
                54.180199,
                34.8616548
              ],
              [
                54.1819511,
                34.8288457
              ],
              [
                54.1827844,
                34.8221785
              ],
              [
                54.1833411,
                34.8127325
              ],
              [
                54.1863978,
                34.7785659
              ],
              [
                54.1891743,
                34.7177278
              ],
              [
                54.1883411,
                34.6957848
              ],
              [
                54.1877843,
                34.6871771
              ],
              [
                54.1877843,
                34.6744008
              ],
              [
                54.1877843,
                34.6605055
              ],
              [
                54.1875077,
                34.6582859
              ],
              [
                54.1875077,
                34.6480087
              ],
              [
                54.1866744,
                34.6277339
              ],
              [
                54.185841,
                34.5841154
              ],
              [
                54.1855644,
                34.5768967
              ],
              [
                54.1852843,
                34.5721774
              ],
              [
                54.1858411,
                34.5480034
              ],
              [
                54.1866743,
                34.5377255
              ],
              [
                54.1866743,
                34.5316165
              ],
              [
                54.185841,
                34.5218889
              ],
              [
                54.1836178,
                34.5038413
              ],
              [
                54.183341,
                34.4980028
              ],
              [
                54.1841744,
                34.4610587
              ],
              [
                54.1838943,
                34.4518902
              ],
              [
                54.1836177,
                34.4480009
              ],
              [
                54.1847276,
                34.4263337
              ],
              [
                54.1855644,
                34.4080053
              ],
              [
                54.1847276,
                34.397167
              ],
              [
                54.185826,
                34.3853162
              ],
              [
                54.1861177,
                34.3821683
              ],
              [
                54.1866743,
                34.3807785
              ],
              [
                54.187231,
                34.3774485
              ],
              [
                54.1883409,
                34.3657798
              ],
              [
                54.1886176,
                34.3485518
              ],
              [
                54.1886177,
                34.347162
              ],
              [
                54.1891743,
                34.3305023
              ],
              [
                54.1888977,
                34.3218927
              ],
              [
                54.1886176,
                34.3149435
              ],
              [
                54.188341,
                34.3127234
              ],
              [
                54.188341,
                34.3093843
              ],
              [
                54.186951,
                34.2866052
              ],
              [
                54.1866743,
                34.2852245
              ],
              [
                54.186951,
                34.2738349
              ],
              [
                54.1866744,
                34.2710552
              ],
              [
                54.185841,
                34.2674451
              ],
              [
                54.1861177,
                34.266335
              ],
              [
                54.187231,
                34.2599452
              ],
              [
                54.1866743,
                34.2585554
              ],
              [
                54.187231,
                34.2574453
              ],
              [
                54.1880643,
                34.2546655
              ],
              [
                54.1857244,
                34.2430591
              ],
              [
                54.1854478,
                34.2424995
              ],
              [
                54.197569,
                34.2385802
              ],
              [
                54.2222209,
                34.2366143
              ],
              [
                54.2339897,
                34.2355854
              ],
              [
                54.2499703,
                34.2342332
              ],
              [
                54.3447677,
                34.237036
              ],
              [
                54.4302967,
                34.237015
              ],
              [
                54.4967596,
                34.2382882
              ],
              [
                54.5054053,
                34.2390538
              ],
              [
                54.5254896,
                34.2379185
              ],
              [
                54.5677183,
                34.2389119
              ],
              [
                54.6105335,
                34.2385698
              ],
              [
                54.612659,
                34.241636
              ],
              [
                54.6140455,
                34.2444072
              ],
              [
                54.6143256,
                34.246077
              ],
              [
                54.612659,
                34.2585786
              ],
              [
                54.612249,
                34.2910545
              ],
              [
                54.6125257,
                34.2971644
              ],
              [
                54.6155823,
                34.336612
              ],
              [
                54.615859,
                34.3421622
              ],
              [
                54.6164157,
                34.3516111
              ],
              [
                54.6139157,
                34.432443
              ],
              [
                54.6141924,
                34.4352225
              ],
              [
                54.6136391,
                34.4621687
              ],
              [
                54.613359,
                34.4738367
              ],
              [
                54.6130824,
                34.4827253
              ],
              [
                54.6114158,
                34.5143901
              ],
              [
                54.6139158,
                34.542174
              ],
              [
                54.6136391,
                34.5555019
              ],
              [
                54.6153058,
                34.5930033
              ],
              [
                54.6155824,
                34.6060601
              ],
              [
                54.6166924,
                34.6271744
              ],
              [
                54.6158591,
                34.6513381
              ],
              [
                54.6144724,
                34.6663433
              ],
              [
                54.6141924,
                34.6769
              ],
              [
                54.6150258,
                34.692735
              ],
              [
                54.6141924,
                34.7093999
              ],
              [
                54.6119726,
                34.7296826
              ],
              [
                54.6116925,
                34.7543951
              ],
              [
                54.6105825,
                34.7641212
              ],
              [
                54.6089159,
                34.7855129
              ],
              [
                54.605306,
                34.849677
              ],
              [
                54.607526,
                34.8794033
              ],
              [
                54.6078059,
                34.8852312
              ],
              [
                54.6108865,
                34.9088513
              ],
              [
                54.6111392,
                34.9107889
              ],
              [
                54.6114159,
                34.9119077
              ],
              [
                54.6139159,
                34.9307981
              ],
              [
                54.6139159,
                34.9377355
              ],
              [
                54.6125259,
                34.9513483
              ],
              [
                54.6133592,
                34.956346
              ],
              [
                54.6141925,
                34.9585742
              ],
              [
                54.6155825,
                34.9638424
              ],
              [
                54.6158592,
                34.9666208
              ],
              [
                54.6155825,
                34.9749562
              ],
              [
                54.6166925,
                34.984401
              ],
              [
                54.6169726,
                34.9855106
              ],
              [
                54.6166925,
                34.9919064
              ],
              [
                54.6169726,
                34.9927363
              ],
              [
                54.6169726,
                34.9955146
              ],
              [
                54.6178059,
                35.0001513
              ],
              [
                54.6183591,
                35.0094066
              ],
              [
                54.6183591,
                35.0121849
              ],
              [
                54.6186392,
                35.0130148
              ],
              [
                54.6189159,
                35.0180122
              ],
              [
                54.6161393,
                35.0999618
              ],
              [
                54.6164158,
                35.1030196
              ],
              [
                54.6161393,
                35.1185789
              ],
              [
                54.6158592,
                35.1216366
              ],
              [
                54.6147493,
                35.1344087
              ],
              [
                54.6086394,
                35.1949659
              ],
              [
                54.6058594,
                35.2219153
              ],
              [
                54.6000262,
                35.2816384
              ],
              [
                54.6003062,
                35.2855254
              ],
              [
                54.5947496,
                35.369134
              ],
              [
                54.5950262,
                35.3705228
              ],
              [
                54.5961362,
                35.3785757
              ],
              [
                54.5975263,
                35.382742
              ],
              [
                54.5975262,
                35.3830216
              ],
              [
                54.5994695,
                35.3866377
              ],
              [
                54.6558622,
                35.4474703
              ],
              [
                54.6619755,
                35.4555226
              ],
              [
                54.6730855,
                35.4794182
              ],
              [
                54.6730854,
                35.4799682
              ],
              [
                54.6753087,
                35.4874703
              ],
              [
                54.6753088,
                35.4883089
              ],
              [
                54.6758654,
                35.4916362
              ],
              [
                54.6758654,
                35.4941429
              ],
              [
                54.676142,
                35.495811
              ],
              [
                54.6766988,
                35.5066403
              ],
              [
                54.6764187,
                35.5121946
              ],
              [
                54.6758654,
                35.5160899
              ],
              [
                54.6753088,
                35.517749
              ],
              [
                54.6741953,
                35.5485858
              ],
              [
                54.6739187,
                35.556358
              ],
              [
                54.6758654,
                35.5624711
              ],
              [
                54.6778087,
                35.5655276
              ],
              [
                54.6978085,
                35.5849756
              ],
              [
                54.7028084,
                35.5899705
              ],
              [
                54.7283648,
                35.614422
              ],
              [
                54.7339214,
                35.6216438
              ],
              [
                54.7400347,
                35.6316423
              ],
              [
                54.7417013,
                35.6341396
              ],
              [
                54.762811,
                35.6791452
              ],
              [
                54.766701,
                35.6897021
              ],
              [
                54.7780909,
                35.7416466
              ],
              [
                54.7789242,
                35.745541
              ],
              [
                54.7825342,
                35.7572059
              ],
              [
                54.7928141,
                35.7705385
              ],
              [
                54.7933708,
                35.7719268
              ],
              [
                54.7944807,
                35.773315
              ],
              [
                54.7972574,
                35.7788678
              ],
              [
                54.7986474,
                35.7822032
              ],
              [
                54.799204,
                35.7841413
              ],
              [
                54.7997574,
                35.7849797
              ],
              [
                54.8039239,
                35.8063705
              ],
              [
                54.8039239,
                35.8180348
              ],
              [
                54.804204,
                35.8191435
              ],
              [
                54.805009,
                35.8284683
              ],
              [
                54.8061473,
                35.8416514
              ],
              [
                54.8058706,
                35.8580384
              ],
              [
                54.8055906,
                35.859706
              ],
              [
                54.8061473,
                35.8663762
              ],
              [
                54.8064239,
                35.8747047
              ],
              [
                54.8061473,
                35.8805364
              ],
              [
                54.8064239,
                35.8824833
              ],
              [
                54.806704,
                35.8833216
              ],
              [
                54.8072573,
                35.8910911
              ],
              [
                54.8075374,
                35.8960935
              ],
              [
                54.8069806,
                35.9044309
              ],
              [
                54.805314,
                35.9180408
              ],
              [
                54.8050375,
                35.9505416
              ],
              [
                54.805314,
                35.9510913
              ],
              [
                54.8050374,
                35.9547055
              ],
              [
                54.8050374,
                35.9722081
              ],
              [
                54.806424,
                35.979986
              ],
              [
                54.8072573,
                35.9886019
              ],
              [
                54.806704,
                35.9930451
              ],
              [
                54.8033638,
                36.0002517
              ],
              [
                54.8028141,
                36.0035985
              ],
              [
                54.8025374,
                36.0116555
              ],
              [
                54.8033708,
                36.0158191
              ],
              [
                54.8033708,
                36.0174864
              ],
              [
                54.8042041,
                36.0213706
              ],
              [
                54.8036475,
                36.0455409
              ],
              [
                54.803924,
                36.0474874
              ],
              [
                54.8042042,
                36.05248
              ],
              [
                54.803924,
                36.059428
              ],
              [
                54.8025375,
                36.0688813
              ],
              [
                54.8022574,
                36.0697104
              ],
              [
                54.8042042,
                36.0733241
              ],
              [
                54.8042042,
                36.0738738
              ],
              [
                54.8036474,
                36.0758203
              ],
              [
                54.8033708,
                36.077208
              ],
              [
                54.8033709,
                36.0780461
              ],
              [
                54.8030908,
                36.0783255
              ],
              [
                54.8030219,
                36.0810302
              ],
              [
                54.8025375,
                36.0863818
              ],
              [
                54.8028141,
                36.0874902
              ],
              [
                54.8005908,
                36.1049902
              ],
              [
                54.7997574,
                36.1088832
              ],
              [
                54.7947576,
                36.1194352
              ],
              [
                54.7800343,
                36.1522082
              ],
              [
                54.7758678,
                36.1649854
              ],
              [
                54.7747577,
                36.1674904
              ],
              [
                54.7744812,
                36.1694277
              ],
              [
                54.7739245,
                36.1702657
              ],
              [
                54.7703112,
                36.1858269
              ],
              [
                54.7700345,
                36.1874938
              ],
              [
                54.7686446,
                36.1941525
              ],
              [
                54.766978,
                36.215543
              ],
              [
                54.7672579,
                36.2174891
              ],
              [
                54.7661445,
                36.2361038
              ],
              [
                54.759478,
                36.2472131
              ],
              [
                54.7542015,
                36.2522135
              ],
              [
                54.7536447,
                36.2522135
              ],
              [
                54.7530915,
                36.252772
              ],
              [
                54.7508681,
                36.2533307
              ],
              [
                54.7494781,
                36.2533307
              ],
              [
                54.7486449,
                36.253601
              ],
              [
                54.7478116,
                36.253601
              ],
              [
                54.7472548,
                36.2538803
              ],
              [
                54.7461448,
                36.2538803
              ],
              [
                54.7436448,
                36.2547092
              ],
              [
                54.7380883,
                36.2616557
              ],
              [
                54.7358683,
                36.2699896
              ],
              [
                54.734755,
                36.2744313
              ],
              [
                54.7264217,
                36.3002702
              ],
              [
                54.7166985,
                36.3138831
              ],
              [
                54.6914188,
                36.3352706
              ],
              [
                54.6736423,
                36.3441622
              ],
              [
                54.6144416,
                36.3810587
              ],
              [
                54.6139164,
                36.3813858
              ],
              [
                54.6130831,
                36.3822146
              ],
              [
                54.6089164,
                36.3866647
              ],
              [
                54.6078065,
                36.3874934
              ],
              [
                54.6075264,
                36.3877727
              ],
              [
                54.6019382,
                36.3965262
              ],
              [
                54.5991932,
                36.4008257
              ],
              [
                54.5989166,
                36.4016634
              ],
              [
                54.5978033,
                36.4027714
              ],
              [
                54.5944699,
                36.4086087
              ],
              [
                54.5890256,
                36.4231773
              ],
              [
                54.5833601,
                36.4383349
              ],
              [
                54.5625705,
                36.497349
              ],
              [
                54.5628471,
                36.4981777
              ],
              [
                54.5631238,
                36.5037454
              ],
              [
                54.5597573,
                36.5157002
              ],
              [
                54.5580906,
                36.5207093
              ],
              [
                54.557814,
                36.5223759
              ],
              [
                54.5572145,
                36.5229677
              ],
              [
                54.5564239,
                36.5226551
              ],
              [
                54.5561473,
                36.522376
              ],
              [
                54.5439241,
                36.5182047
              ],
              [
                54.5334708,
                36.5170059
              ],
              [
                54.4958949,
                36.5224634
              ],
              [
                54.4910582,
                36.5290731
              ],
              [
                54.4899481,
                36.5290731
              ],
              [
                54.4893915,
                36.528794
              ],
              [
                54.4807816,
                36.5268488
              ],
              [
                54.4727251,
                36.5257322
              ],
              [
                54.4699484,
                36.5257322
              ],
              [
                54.4685585,
                36.5254531
              ],
              [
                54.4657784,
                36.5251829
              ],
              [
                54.4618918,
                36.5251828
              ],
              [
                54.4593919,
                36.5249037
              ],
              [
                54.4580019,
                36.5251828
              ],
              [
                54.436705,
                36.5128061
              ],
              [
                54.4319816,
                36.5139141
              ],
              [
                54.4314251,
                36.5139141
              ],
              [
                54.4122585,
                36.511724
              ],
              [
                54.3961454,
                36.511724
              ],
              [
                54.3950354,
                36.5120032
              ],
              [
                54.3836455,
                36.5120031
              ],
              [
                54.3830924,
                36.511724
              ],
              [
                54.3803123,
                36.511724
              ],
              [
                54.3792023,
                36.5114448
              ],
              [
                54.3775357,
                36.5114448
              ],
              [
                54.3734451,
                36.5102939
              ],
              [
                54.3444595,
                36.5122222
              ],
              [
                54.3419595,
                36.511943
              ],
              [
                54.3414028,
                36.5116638
              ],
              [
                54.3405695,
                36.5116638
              ],
              [
                54.3400162,
                36.5113846
              ],
              [
                54.3377929,
                36.5113846
              ],
              [
                54.3344595,
                36.5105559
              ],
              [
                54.3327929,
                36.510556
              ],
              [
                54.3311263,
                36.5102768
              ],
              [
                54.3258463,
                36.5102767
              ],
              [
                54.325013,
                36.5099976
              ],
              [
                54.3230697,
                36.5099975
              ],
              [
                54.3150131,
                36.5086104
              ],
              [
                54.3127897,
                36.5086104
              ],
              [
                54.3111232,
                36.5083312
              ],
              [
                54.3091799,
                36.5083312
              ],
              [
                54.3019566,
                36.5074936
              ],
              [
                54.2994566,
                36.5074936
              ],
              [
                54.2914,
                36.506665
              ],
              [
                54.2766769,
                36.5066649
              ],
              [
                54.2747335,
                36.5063857
              ],
              [
                54.2597338,
                36.5063857
              ],
              [
                54.2489006,
                36.505548
              ],
              [
                54.234454,
                36.5049987
              ],
              [
                54.2225074,
                36.5049987
              ],
              [
                54.2063842,
                36.5088451
              ],
              [
                54.2032262,
                36.5088453
              ],
              [
                54.2020733,
                36.5088453
              ],
              [
                54.2007506,
                36.5088454
              ],
              [
                54.1993511,
                36.5088454
              ],
              [
                54.1983021,
                36.5088455
              ],
              [
                54.1965468,
                36.5085857
              ],
              [
                54.1951303,
                36.508376
              ],
              [
                54.1936936,
                36.5081633
              ],
              [
                54.1920782,
                36.5079241
              ],
              [
                54.1905883,
                36.5077036
              ],
              [
                54.189106,
                36.5074841
              ],
              [
                54.1876265,
                36.5072651
              ],
              [
                54.1860666,
                36.5070342
              ],
              [
                54.1843423,
                36.5067789
              ],
              [
                54.1827294,
                36.5065402
              ],
              [
                54.1813369,
                36.506334
              ],
              [
                54.1795801,
                36.5060739
              ],
              [
                54.1789886,
                36.5057919
              ],
              [
                54.1779369,
                36.5057919
              ],
              [
                54.1762582,
                36.505792
              ],
              [
                54.1759101,
                36.5056977
              ],
              [
                54.1746296,
                36.5053178
              ],
              [
                54.1729727,
                36.504826
              ],
              [
                54.1721106,
                36.5047405
              ],
              [
                54.1707936,
                36.5042344
              ],
              [
                54.1701908,
                36.5033492
              ],
              [
                54.1700597,
                36.5021057
              ],
              [
                54.1688804,
                36.5007357
              ],
              [
                54.1630099,
                36.4979536
              ],
              [
                54.1588167,
                36.4966046
              ],
              [
                54.1540732,
                36.4963727
              ],
              [
                54.1486932,
                36.4975881
              ],
              [
                54.1465012,
                36.4971818
              ],
              [
                54.1041687,
                36.4841652
              ],
              [
                54.093059,
                36.4788868
              ],
              [
                54.0730592,
                36.4719422
              ],
              [
                54.0613791,
                36.4688563
              ],
              [
                54.0532813,
                36.4590488
              ],
              [
                54.0468223,
                36.4455875
              ],
              [
                54.0462657,
                36.4453083
              ],
              [
                54.0444564,
                36.4446138
              ],
              [
                54.0437658,
                36.4444795
              ],
              [
                54.0432125,
                36.4442003
              ],
              [
                54.033536,
                36.4162916
              ],
              [
                54.0252027,
                36.413507
              ],
              [
                54.0236202,
                36.4134109
              ],
              [
                54.005427,
                36.4027964
              ],
              [
                53.9924609,
                36.4043407
              ],
              [
                53.9871567,
                36.4046775
              ],
              [
                53.9838234,
                36.4046775
              ],
              [
                53.9832667,
                36.4049569
              ],
              [
                53.9796568,
                36.4049568
              ],
              [
                53.9788235,
                36.4052272
              ],
              [
                53.9777134,
                36.4049569
              ],
              [
                53.9763235,
                36.4049569
              ],
              [
                53.966047,
                36.4027308
              ],
              [
                53.9126928,
                36.4032289
              ],
              [
                53.9033888,
                36.3919932
              ],
              [
                53.8863943,
                36.371954
              ],
              [
                53.882532,
                36.3633148
              ],
              [
                53.885536,
                36.3584074
              ],
              [
                53.8987539,
                36.3527392
              ],
              [
                53.9188163,
                36.3409097
              ],
              [
                53.9317124,
                36.3342115
              ],
              [
                53.9566038,
                36.3206579
              ],
              [
                53.967335,
                36.302558
              ],
              [
                53.9701866,
                36.291906
              ],
              [
                53.9699934,
                36.2834436
              ],
              [
                53.9627836,
                36.2751406
              ],
              [
                53.9479122,
                36.2675452
              ],
              [
                53.9504204,
                36.2642822
              ],
              [
                53.9494206,
                36.2618379
              ],
              [
                53.9478756,
                36.2601833
              ],
              [
                53.9459015,
                36.2578807
              ],
              [
                53.9411747,
                36.2525794
              ],
              [
                53.9352965,
                36.2480353
              ],
              [
                53.9250181,
                36.243858
              ],
              [
                53.9135168,
                36.2369354
              ],
              [
                53.88707,
                36.2237766
              ],
              [
                53.8601138,
                36.2133532
              ],
              [
                53.8512323,
                36.2081977
              ],
              [
                53.8457552,
                36.198635
              ],
              [
                53.8380346,
                36.1908982
              ],
              [
                53.8289905,
                36.1865184
              ],
              [
                53.8209851,
                36.1826056
              ],
              [
                53.8155622,
                36.1774271
              ],
              [
                53.8068723,
                36.1649287
              ],
              [
                53.8022449,
                36.1601574
              ],
              [
                53.8196181,
                36.144529
              ],
              [
                53.832836,
                36.135934
              ],
              [
                53.8440799,
                36.1245648
              ],
              [
                53.8495351,
                36.1211318
              ],
              [
                53.8417019,
                36.1188786
              ],
              [
                53.834378,
                36.1154706
              ],
              [
                53.8309449,
                36.1119303
              ],
              [
                53.8279599,
                36.1080345
              ],
              [
                53.8250643,
                36.1063754
              ],
              [
                53.8187128,
                36.105267
              ],
              [
                53.8136271,
                36.1053917
              ],
              [
                53.8048645,
                36.106566
              ],
              [
                53.7966365,
                36.1017792
              ],
              [
                53.7838727,
                36.0947034
              ],
              [
                53.7813251,
                36.0913049
              ],
              [
                53.7827968,
                36.0869797
              ],
              [
                53.7844829,
                36.0858235
              ],
              [
                53.7882915,
                36.0846443
              ],
              [
                53.7920298,
                36.0852359
              ],
              [
                53.7981605,
                36.0850722
              ],
              [
                53.7994565,
                36.0845768
              ],
              [
                53.8028193,
                36.0813918
              ],
              [
                53.80313,
                36.0776881
              ],
              [
                53.7993831,
                36.0744304
              ],
              [
                53.7982493,
                36.0725881
              ],
              [
                53.7892081,
                36.0649865
              ],
              [
                53.7793635,
                36.0594382
              ],
              [
                53.7737846,
                36.0558301
              ],
              [
                53.7702659,
                36.0538715
              ],
              [
                53.7666002,
                36.0507525
              ],
              [
                53.7617683,
                36.0493072
              ],
              [
                53.7567901,
                36.0461844
              ],
              [
                53.7504386,
                36.0449352
              ],
              [
                53.741063,
                36.0390786
              ],
              [
                53.7316417,
                36.0330671
              ],
              [
                53.7216033,
                36.0246379
              ],
              [
                53.7180066,
                36.020332
              ],
              [
                53.710941,
                36.0124106
              ],
              [
                53.7075658,
                36.0063092
              ],
              [
                53.7028569,
                35.9994237
              ],
              [
                53.7060189,
                35.9914912
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555074,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سرخه",
          "name:en": "Sorkheh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q6321520",
          "wikipedia": "en:Sorkheh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.7866675,
                35.516445
              ],
              [
                52.7835508,
                35.4955224
              ],
              [
                52.783831,
                35.4941428
              ],
              [
                52.7829976,
                35.4755316
              ],
              [
                52.7835508,
                35.4691384
              ],
              [
                52.7832743,
                35.4655226
              ],
              [
                52.7835509,
                35.4644135
              ],
              [
                52.7832743,
                35.4616362
              ],
              [
                52.783551,
                35.4555225
              ],
              [
                52.7841075,
                35.4496973
              ],
              [
                52.7843843,
                35.4482996
              ],
              [
                52.7916076,
                35.4188578
              ],
              [
                52.7963309,
                35.4124732
              ],
              [
                52.7971642,
                35.4121937
              ],
              [
                52.7974408,
                35.4116346
              ],
              [
                52.7982742,
                35.4113551
              ],
              [
                52.8132773,
                35.4002454
              ],
              [
                52.8177206,
                35.3971883
              ],
              [
                52.8196639,
                35.3963587
              ],
              [
                52.8371671,
                35.3858079
              ],
              [
                52.838277,
                35.3846896
              ],
              [
                52.8568902,
                35.3685837
              ],
              [
                52.8571668,
                35.3683042
              ],
              [
                52.8585568,
                35.3638583
              ],
              [
                52.8588334,
                35.3632991
              ],
              [
                52.8585569,
                35.3627401
              ],
              [
                52.8580002,
                35.3588623
              ],
              [
                52.8535568,
                35.3499705
              ],
              [
                52.8502236,
                35.3446859
              ],
              [
                52.8474437,
                35.340799
              ],
              [
                52.8157774,
                35.2930287
              ],
              [
                52.816054,
                35.2908011
              ],
              [
                52.8163306,
                35.2891326
              ],
              [
                52.8182774,
                35.283027
              ],
              [
                52.8182773,
                35.2827475
              ],
              [
                52.8191106,
                35.2796902
              ],
              [
                52.8247491,
                35.2613306
              ],
              [
                52.8299439,
                35.2444086
              ],
              [
                52.8330006,
                35.2210764
              ],
              [
                52.8332773,
                35.2205172
              ],
              [
                52.8327204,
                35.2124631
              ],
              [
                52.8324438,
                35.2052387
              ],
              [
                52.8327205,
                35.2007922
              ],
              [
                52.8330006,
                35.1957955
              ],
              [
                52.8291106,
                35.1605205
              ],
              [
                52.8288341,
                35.1424632
              ],
              [
                52.8291106,
                35.1374663
              ],
              [
                52.8293872,
                35.1313509
              ],
              [
                52.8296674,
                35.1263539
              ],
              [
                52.829944,
                35.1244056
              ],
              [
                52.8318872,
                35.1080165
              ],
              [
                52.832444,
                35.1049586
              ],
              [
                52.8321673,
                35.1044085
              ],
              [
                52.832444,
                35.0991317
              ],
              [
                52.8327205,
                35.0985725
              ],
              [
                52.832444,
                35.0960739
              ],
              [
                52.8327206,
                35.0955238
              ],
              [
                52.8327205,
                35.0924659
              ],
              [
                52.8327206,
                35.0871801
              ],
              [
                52.832444,
                35.0863503
              ],
              [
                52.831334,
                35.0688511
              ],
              [
                52.8310539,
                35.0471844
              ],
              [
                52.8318873,
                35.0385789
              ],
              [
                52.8307774,
                35.0169025
              ],
              [
                52.8310539,
                35.0121848
              ],
              [
                52.831334,
                35.0119051
              ],
              [
                52.831054,
                35.009686
              ],
              [
                52.8313341,
                35.008847
              ],
              [
                52.8310539,
                35.0080172
              ],
              [
                52.831054,
                35.0071873
              ],
              [
                52.8310539,
                35.0019012
              ],
              [
                52.8321674,
                34.9994024
              ],
              [
                52.8260541,
                34.9796829
              ],
              [
                52.8254974,
                34.974956
              ],
              [
                52.8252208,
                34.9680189
              ],
              [
                52.8257774,
                34.9569051
              ],
              [
                52.8254974,
                34.9557954
              ],
              [
                52.8249442,
                34.9374556
              ],
              [
                52.8252207,
                34.9194041
              ],
              [
                52.8254975,
                34.9169052
              ],
              [
                52.8252208,
                34.9102295
              ],
              [
                52.8254975,
                34.9074599
              ],
              [
                52.8252208,
                34.8963455
              ],
              [
                52.8274442,
                34.8635703
              ],
              [
                52.8277208,
                34.8524555
              ],
              [
                52.8280009,
                34.840231
              ],
              [
                52.8282776,
                34.836902
              ],
              [
                52.8280009,
                34.8319039
              ],
              [
                52.8277208,
                34.7871728
              ],
              [
                52.8280009,
                34.7838437
              ],
              [
                52.8277209,
                34.7821745
              ],
              [
                52.8260542,
                34.7344012
              ],
              [
                52.8260543,
                34.7327321
              ],
              [
                52.821331,
                34.6577262
              ],
              [
                52.8168878,
                34.549113
              ],
              [
                52.8174445,
                34.5405045
              ],
              [
                52.8179978,
                34.5374455
              ],
              [
                52.8193879,
                34.5205081
              ],
              [
                52.8193878,
                34.4935629
              ],
              [
                52.8199445,
                34.4818949
              ],
              [
                52.8193879,
                34.4516102
              ],
              [
                52.8193879,
                34.4502295
              ],
              [
                52.8185545,
                34.4327226
              ],
              [
                52.8188311,
                34.4291129
              ],
              [
                52.8191112,
                34.4230035
              ],
              [
                52.8193879,
                34.4205038
              ],
              [
                52.8179978,
                34.3949468
              ],
              [
                52.8174446,
                34.3918875
              ],
              [
                52.8171645,
                34.3877272
              ],
              [
                52.8163312,
                34.36633
              ],
              [
                52.8166113,
                34.36411
              ],
              [
                52.8163313,
                34.3629999
              ],
              [
                52.815498,
                34.314104
              ],
              [
                52.8163313,
                34.302164
              ],
              [
                52.8163313,
                34.3002237
              ],
              [
                52.8163312,
                34.2988339
              ],
              [
                52.8017401,
                34.3005397
              ],
              [
                52.820325,
                34.2909465
              ],
              [
                52.8418053,
                34.2797346
              ],
              [
                52.852427,
                34.2764549
              ],
              [
                52.865566,
                34.2720898
              ],
              [
                52.8804077,
                34.2674397
              ],
              [
                52.8943325,
                34.265161
              ],
              [
                52.9205728,
                34.2654891
              ],
              [
                52.9502034,
                34.2647483
              ],
              [
                52.9678454,
                34.2644171
              ],
              [
                52.9816033,
                34.2642252
              ],
              [
                53.0033984,
                34.2640873
              ],
              [
                53.0256643,
                34.2620971
              ],
              [
                53.0413023,
                34.2611081
              ],
              [
                53.0697114,
                34.2595554
              ],
              [
                53.0810578,
                34.2585583
              ],
              [
                53.1004753,
                34.2578449
              ],
              [
                53.1351516,
                34.2554909
              ],
              [
                53.1697219,
                34.2534174
              ],
              [
                53.1735702,
                34.2532756
              ],
              [
                53.194365,
                34.2519147
              ],
              [
                53.2078925,
                34.2510909
              ],
              [
                53.285751,
                34.2470006
              ],
              [
                53.3660885,
                34.2461493
              ],
              [
                53.4983972,
                34.2458472
              ],
              [
                53.5121409,
                34.2459223
              ],
              [
                53.5166735,
                34.2458552
              ],
              [
                53.5190209,
                34.2458592
              ],
              [
                53.5174761,
                34.2752247
              ],
              [
                53.518866,
                34.3018844
              ],
              [
                53.5185859,
                34.3038338
              ],
              [
                53.518866,
                34.3288327
              ],
              [
                53.5144193,
                34.4263337
              ],
              [
                53.5080327,
                34.5543921
              ],
              [
                53.5074761,
                34.5702284
              ],
              [
                53.5071994,
                34.5766169
              ],
              [
                53.5069193,
                34.5905039
              ],
              [
                53.5066426,
                34.5994009
              ],
              [
                53.5066427,
                34.6030102
              ],
              [
                53.5066426,
                34.6080091
              ],
              [
                53.5024761,
                34.6994028
              ],
              [
                53.4994194,
                34.7702293
              ],
              [
                53.4991428,
                34.7743975
              ],
              [
                53.4988626,
                34.8027361
              ],
              [
                53.4966427,
                34.847178
              ],
              [
                53.4955293,
                34.8666198
              ],
              [
                53.4927528,
                34.8871799
              ],
              [
                53.4910861,
                34.9080104
              ],
              [
                53.4885861,
                34.926901
              ],
              [
                53.4877529,
                34.9391247
              ],
              [
                53.497476,
                34.9999619
              ],
              [
                53.4888628,
                35.0502335
              ],
              [
                53.4888628,
                35.0524615
              ],
              [
                53.4885862,
                35.0538506
              ],
              [
                53.4883095,
                35.0566289
              ],
              [
                53.4877527,
                35.0607963
              ],
              [
                53.487196,
                35.0658025
              ],
              [
                53.4874762,
                35.069131
              ],
              [
                53.4869194,
                35.0696813
              ],
              [
                53.4869195,
                35.0702405
              ],
              [
                53.4860861,
                35.0707997
              ],
              [
                53.4863627,
                35.0716295
              ],
              [
                53.4852528,
                35.0816329
              ],
              [
                53.4846961,
                35.0866301
              ],
              [
                53.4846961,
                35.0885694
              ],
              [
                53.4841394,
                35.0913477
              ],
              [
                53.4816394,
                35.1202476
              ],
              [
                53.4813629,
                35.123576
              ],
              [
                53.4810861,
                35.1288526
              ],
              [
                53.4808061,
                35.1371868
              ],
              [
                53.4821961,
                35.18941
              ],
              [
                53.4827528,
                35.2060777
              ],
              [
                53.4808061,
                35.225523
              ],
              [
                53.4799727,
                35.2355251
              ],
              [
                53.4794195,
                35.2441382
              ],
              [
                53.4788629,
                35.2452476
              ],
              [
                53.4785861,
                35.2474662
              ],
              [
                53.4769196,
                35.2549699
              ],
              [
                53.4671963,
                35.2963568
              ],
              [
                53.462473,
                35.3152504
              ],
              [
                53.4621964,
                35.3177395
              ],
              [
                53.4527497,
                35.3538574
              ],
              [
                53.4519164,
                35.3635789
              ],
              [
                53.4521965,
                35.3735799
              ],
              [
                53.4519164,
                35.3749686
              ],
              [
                53.4494164,
                35.3896857
              ],
              [
                53.4480264,
                35.3957998
              ],
              [
                53.4474732,
                35.3977476
              ],
              [
                53.4333067,
                35.4094165
              ],
              [
                53.4308066,
                35.4110847
              ],
              [
                53.4244168,
                35.4144122
              ],
              [
                53.3885805,
                35.4294174
              ],
              [
                53.3566342,
                35.445243
              ],
              [
                53.350801,
                35.4480293
              ],
              [
                53.3283013,
                35.4599682
              ],
              [
                53.3252446,
                35.463025
              ],
              [
                53.3246879,
                35.4633045
              ],
              [
                53.322468,
                35.46775
              ],
              [
                53.3219113,
                35.4685796
              ],
              [
                53.3210779,
                35.4724751
              ],
              [
                53.3213546,
                35.4727546
              ],
              [
                53.321078,
                35.4730251
              ],
              [
                53.3208013,
                35.4769114
              ],
              [
                53.3205212,
                35.4785885
              ],
              [
                53.3202447,
                35.4821954
              ],
              [
                53.319968,
                35.4841431
              ],
              [
                53.3199679,
                35.4885884
              ],
              [
                53.3202446,
                35.4941429
              ],
              [
                53.3205213,
                35.4969111
              ],
              [
                53.3202447,
                35.4974701
              ],
              [
                53.3199679,
                35.5013564
              ],
              [
                53.3196879,
                35.502745
              ],
              [
                53.3194113,
                35.5063608
              ],
              [
                53.3194113,
                35.5119151
              ],
              [
                53.3194114,
                35.5171899
              ],
              [
                53.3191346,
                35.5177489
              ],
              [
                53.3194113,
                35.5202467
              ],
              [
                53.319688,
                35.5316437
              ],
              [
                53.3194113,
                35.5327528
              ],
              [
                53.3191347,
                35.5358093
              ],
              [
                53.3185779,
                35.539975
              ],
              [
                53.3183013,
                35.5446906
              ],
              [
                53.3221878,
                35.5638596
              ],
              [
                53.322468,
                35.5652481
              ],
              [
                53.3221879,
                35.5658071
              ],
              [
                53.322468,
                35.5683137
              ],
              [
                53.3233012,
                35.5710906
              ],
              [
                53.3372026,
                35.5976481
              ],
              [
                53.3230212,
                35.6072002
              ],
              [
                53.322468,
                35.6072003
              ],
              [
                53.3210779,
                35.6085887
              ],
              [
                53.3052448,
                35.6171989
              ],
              [
                53.3024648,
                35.6188668
              ],
              [
                53.3016314,
                35.6191373
              ],
              [
                53.2944083,
                35.6233116
              ],
              [
                53.2335722,
                35.6574811
              ],
              [
                53.2207957,
                35.6683087
              ],
              [
                53.2102392,
                35.6749801
              ],
              [
                53.1880161,
                35.6871958
              ],
              [
                53.1860728,
                35.6883047
              ],
              [
                53.1774596,
                35.6924788
              ],
              [
                53.165513,
                35.6985911
              ],
              [
                53.1627364,
                35.7005293
              ],
              [
                53.161903,
                35.7005293
              ],
              [
                53.1577364,
                35.7030265
              ],
              [
                53.1571798,
                35.7035854
              ],
              [
                53.1505131,
                35.7060917
              ],
              [
                53.1496798,
                35.7066415
              ],
              [
                53.1316234,
                35.7116449
              ],
              [
                53.1307901,
                35.7122038
              ],
              [
                53.0810673,
                35.7255279
              ],
              [
                53.080234,
                35.7255279
              ],
              [
                53.0649542,
                35.7324784
              ],
              [
                53.0626664,
                35.7333319
              ],
              [
                53.0555043,
                35.7262102
              ],
              [
                53.0537982,
                35.7249015
              ],
              [
                53.0528843,
                35.7236171
              ],
              [
                53.0501364,
                35.7226807
              ],
              [
                53.0482405,
                35.720593
              ],
              [
                53.0450542,
                35.7186159
              ],
              [
                53.0396417,
                35.7173855
              ],
              [
                53.0345465,
                35.7157818
              ],
              [
                53.0294194,
                35.7107269
              ],
              [
                53.0260515,
                35.7086249
              ],
              [
                53.0236118,
                35.7059191
              ],
              [
                53.0124514,
                35.7008087
              ],
              [
                53.001895,
                35.6833102
              ],
              [
                53.0010616,
                35.6827602
              ],
              [
                52.999675,
                35.6813629
              ],
              [
                52.995785,
                35.6788656
              ],
              [
                52.9952283,
                35.6785861
              ],
              [
                52.9846717,
                35.6727532
              ],
              [
                52.9752286,
                35.6699764
              ],
              [
                52.9743952,
                35.6694265
              ],
              [
                52.9296691,
                35.6555337
              ],
              [
                52.9291158,
                35.6549747
              ],
              [
                52.9263359,
                35.6541452
              ],
              [
                52.9143926,
                35.6497006
              ],
              [
                52.8991128,
                35.6419201
              ],
              [
                52.8857797,
                35.6322011
              ],
              [
                52.8846697,
                35.6313716
              ],
              [
                52.8771663,
                35.6260885
              ],
              [
                52.8299438,
                35.5810896
              ],
              [
                52.8291104,
                35.579701
              ],
              [
                52.8227204,
                35.572479
              ],
              [
                52.8024406,
                35.5508037
              ],
              [
                52.8021641,
                35.5505331
              ],
              [
                52.801054,
                35.5494151
              ],
              [
                52.7943875,
                35.5459445
              ],
              [
                52.7943875,
                35.5446904
              ],
              [
                52.7921642,
                35.5377478
              ],
              [
                52.7913308,
                35.5344206
              ],
              [
                52.7877175,
                35.5244122
              ],
              [
                52.7874409,
                35.521635
              ],
              [
                52.7866675,
                35.516445
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555084,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سمنان",
          "name:en": "Semnan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286484",
          "wikipedia": "en:Semnan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.3194113,
                35.5119151
              ],
              [
                53.3194113,
                35.5063608
              ],
              [
                53.3196879,
                35.502745
              ],
              [
                53.3199679,
                35.5013564
              ],
              [
                53.3202447,
                35.4974701
              ],
              [
                53.3205213,
                35.4969111
              ],
              [
                53.3202446,
                35.4941429
              ],
              [
                53.3199679,
                35.4885884
              ],
              [
                53.319968,
                35.4841431
              ],
              [
                53.3202447,
                35.4821954
              ],
              [
                53.3205212,
                35.4785885
              ],
              [
                53.3208013,
                35.4769114
              ],
              [
                53.321078,
                35.4730251
              ],
              [
                53.3213546,
                35.4727546
              ],
              [
                53.3210779,
                35.4724751
              ],
              [
                53.3219113,
                35.4685796
              ],
              [
                53.322468,
                35.46775
              ],
              [
                53.3246879,
                35.4633045
              ],
              [
                53.3252446,
                35.463025
              ],
              [
                53.3283013,
                35.4599682
              ],
              [
                53.350801,
                35.4480293
              ],
              [
                53.3566342,
                35.445243
              ],
              [
                53.3885805,
                35.4294174
              ],
              [
                53.4244168,
                35.4144122
              ],
              [
                53.4308066,
                35.4110847
              ],
              [
                53.4333067,
                35.4094165
              ],
              [
                53.4474732,
                35.3977476
              ],
              [
                53.4480264,
                35.3957998
              ],
              [
                53.4494164,
                35.3896857
              ],
              [
                53.4519164,
                35.3749686
              ],
              [
                53.4521965,
                35.3735799
              ],
              [
                53.4519164,
                35.3635789
              ],
              [
                53.4527497,
                35.3538574
              ],
              [
                53.4621964,
                35.3177395
              ],
              [
                53.462473,
                35.3152504
              ],
              [
                53.4671963,
                35.2963568
              ],
              [
                53.4769196,
                35.2549699
              ],
              [
                53.4785861,
                35.2474662
              ],
              [
                53.4788629,
                35.2452476
              ],
              [
                53.4794195,
                35.2441382
              ],
              [
                53.4799727,
                35.2355251
              ],
              [
                53.4808061,
                35.225523
              ],
              [
                53.4827528,
                35.2060777
              ],
              [
                53.4821961,
                35.18941
              ],
              [
                53.4808061,
                35.1371868
              ],
              [
                53.4810861,
                35.1288526
              ],
              [
                53.4813629,
                35.123576
              ],
              [
                53.4816394,
                35.1202476
              ],
              [
                53.4841394,
                35.0913477
              ],
              [
                53.4846961,
                35.0885694
              ],
              [
                53.4846961,
                35.0866301
              ],
              [
                53.4852528,
                35.0816329
              ],
              [
                53.4863627,
                35.0716295
              ],
              [
                53.4860861,
                35.0707997
              ],
              [
                53.4869195,
                35.0702405
              ],
              [
                53.4869194,
                35.0696813
              ],
              [
                53.4874762,
                35.069131
              ],
              [
                53.487196,
                35.0658025
              ],
              [
                53.4877527,
                35.0607963
              ],
              [
                53.4883095,
                35.0566289
              ],
              [
                53.4885862,
                35.0538506
              ],
              [
                53.4888628,
                35.0524615
              ],
              [
                53.4888628,
                35.0502335
              ],
              [
                53.497476,
                34.9999619
              ],
              [
                53.4877529,
                34.9391247
              ],
              [
                53.4885861,
                34.926901
              ],
              [
                53.4910861,
                34.9080104
              ],
              [
                53.4927528,
                34.8871799
              ],
              [
                53.4955293,
                34.8666198
              ],
              [
                53.4966427,
                34.847178
              ],
              [
                53.4988626,
                34.8027361
              ],
              [
                53.4991428,
                34.7743975
              ],
              [
                53.4994194,
                34.7702293
              ],
              [
                53.5024761,
                34.6994028
              ],
              [
                53.5066426,
                34.6080091
              ],
              [
                53.5066427,
                34.6030102
              ],
              [
                53.5066426,
                34.5994009
              ],
              [
                53.5069193,
                34.5905039
              ],
              [
                53.5071994,
                34.5766169
              ],
              [
                53.5074761,
                34.5702284
              ],
              [
                53.5080327,
                34.5543921
              ],
              [
                53.5144193,
                34.4263337
              ],
              [
                53.518866,
                34.3288327
              ],
              [
                53.5185859,
                34.3038338
              ],
              [
                53.518866,
                34.3018844
              ],
              [
                53.5174761,
                34.2752247
              ],
              [
                53.5190209,
                34.2458592
              ],
              [
                53.5343699,
                34.2450538
              ],
              [
                53.8446401,
                34.2457763
              ],
              [
                53.8732993,
                34.2468984
              ],
              [
                53.9072441,
                34.2465018
              ],
              [
                53.9991759,
                34.2479938
              ],
              [
                54.0271567,
                34.2465748
              ],
              [
                54.1546961,
                34.2397033
              ],
              [
                54.1807712,
                34.2392897
              ],
              [
                54.197569,
                34.2385802
              ],
              [
                54.1854478,
                34.2424995
              ],
              [
                54.1857244,
                34.2430591
              ],
              [
                54.1880643,
                34.2546655
              ],
              [
                54.187231,
                34.2574453
              ],
              [
                54.1866743,
                34.2585554
              ],
              [
                54.187231,
                34.2599452
              ],
              [
                54.1861177,
                34.266335
              ],
              [
                54.185841,
                34.2674451
              ],
              [
                54.1866744,
                34.2710552
              ],
              [
                54.186951,
                34.2738349
              ],
              [
                54.1866743,
                34.2852245
              ],
              [
                54.186951,
                34.2866052
              ],
              [
                54.188341,
                34.3093843
              ],
              [
                54.188341,
                34.3127234
              ],
              [
                54.1886176,
                34.3149435
              ],
              [
                54.1888977,
                34.3218927
              ],
              [
                54.1891743,
                34.3305023
              ],
              [
                54.1886177,
                34.347162
              ],
              [
                54.1886176,
                34.3485518
              ],
              [
                54.1883409,
                34.3657798
              ],
              [
                54.187231,
                34.3774485
              ],
              [
                54.1866743,
                34.3807785
              ],
              [
                54.1861177,
                34.3821683
              ],
              [
                54.185826,
                34.3853162
              ],
              [
                54.1847276,
                34.397167
              ],
              [
                54.1855644,
                34.4080053
              ],
              [
                54.1847276,
                34.4263337
              ],
              [
                54.1836177,
                34.4480009
              ],
              [
                54.1838943,
                34.4518902
              ],
              [
                54.1841744,
                34.4610587
              ],
              [
                54.183341,
                34.4980028
              ],
              [
                54.1836178,
                34.5038413
              ],
              [
                54.185841,
                34.5218889
              ],
              [
                54.1866743,
                34.5316165
              ],
              [
                54.1866743,
                34.5377255
              ],
              [
                54.1858411,
                34.5480034
              ],
              [
                54.1852843,
                34.5721774
              ],
              [
                54.1855644,
                34.5768967
              ],
              [
                54.185841,
                34.5841154
              ],
              [
                54.1866744,
                34.6277339
              ],
              [
                54.1875077,
                34.6480087
              ],
              [
                54.1875077,
                34.6582859
              ],
              [
                54.1877843,
                34.6605055
              ],
              [
                54.1877843,
                34.6744008
              ],
              [
                54.1877843,
                34.6871771
              ],
              [
                54.1883411,
                34.6957848
              ],
              [
                54.1891743,
                34.7177278
              ],
              [
                54.1863978,
                34.7785659
              ],
              [
                54.1833411,
                34.8127325
              ],
              [
                54.1827844,
                34.8221785
              ],
              [
                54.1819511,
                34.8288457
              ],
              [
                54.180199,
                34.8616548
              ],
              [
                54.1788944,
                34.8860703
              ],
              [
                54.1794511,
                34.8969051
              ],
              [
                54.1791745,
                34.9071805
              ],
              [
                54.1783412,
                34.9169055
              ],
              [
                54.1780611,
                34.9271806
              ],
              [
                54.1822277,
                34.9605137
              ],
              [
                54.1838944,
                34.9869089
              ],
              [
                54.1833411,
                34.9910765
              ],
              [
                54.1819511,
                34.9957944
              ],
              [
                54.1811178,
                34.9988524
              ],
              [
                54.1808411,
                35.0141244
              ],
              [
                54.180561,
                35.0202404
              ],
              [
                54.1805611,
                35.0238486
              ],
              [
                54.1802844,
                35.0266269
              ],
              [
                54.1805611,
                35.0277365
              ],
              [
                54.1802845,
                35.0291256
              ],
              [
                54.1805611,
                35.0302352
              ],
              [
                54.1791745,
                35.0777363
              ],
              [
                54.1788944,
                35.0796847
              ],
              [
                54.1791745,
                35.081633
              ],
              [
                54.1788944,
                35.0827425
              ],
              [
                54.1791745,
                35.0846818
              ],
              [
                54.1788945,
                35.0880193
              ],
              [
                54.1791745,
                35.0902382
              ],
              [
                54.1769511,
                35.1269043
              ],
              [
                54.1766746,
                35.1294028
              ],
              [
                54.1750079,
                35.1369072
              ],
              [
                54.1733413,
                35.1510772
              ],
              [
                54.1738946,
                35.1599615
              ],
              [
                54.1738946,
                35.1630191
              ],
              [
                54.1744512,
                35.1680159
              ],
              [
                54.1750079,
                35.174961
              ],
              [
                54.1758412,
                35.1860729
              ],
              [
                54.1761179,
                35.1905194
              ],
              [
                54.1769512,
                35.203859
              ],
              [
                54.1805611,
                35.2316289
              ],
              [
                54.1808411,
                35.2444088
              ],
              [
                54.1805611,
                35.2452476
              ],
              [
                54.1808411,
                35.2471866
              ],
              [
                54.1805611,
                35.2580274
              ],
              [
                54.1808411,
                35.260246
              ],
              [
                54.1811178,
                35.2652423
              ],
              [
                54.1794512,
                35.2988549
              ],
              [
                54.1791745,
                35.3016327
              ],
              [
                54.1797278,
                35.3080267
              ],
              [
                54.1794512,
                35.3171894
              ],
              [
                54.1788945,
                35.3213559
              ],
              [
                54.1780612,
                35.3260815
              ],
              [
                54.1688946,
                35.3441359
              ],
              [
                54.1447282,
                35.3624698
              ],
              [
                54.137505,
                35.3688545
              ],
              [
                54.1088919,
                35.3905245
              ],
              [
                54.1055588,
                35.393861
              ],
              [
                54.0994489,
                35.3985863
              ],
              [
                54.0894456,
                35.4058005
              ],
              [
                54.0652792,
                35.4266401
              ],
              [
                54.0386129,
                35.4555227
              ],
              [
                54.0316662,
                35.4699683
              ],
              [
                54.0272231,
                35.4902477
              ],
              [
                54.027223,
                35.4924749
              ],
              [
                54.0266663,
                35.4960817
              ],
              [
                54.0263897,
                35.5008065
              ],
              [
                54.0263897,
                35.5044132
              ],
              [
                54.025833,
                35.5071904
              ],
              [
                54.0238897,
                35.5316438
              ],
              [
                54.0211097,
                35.5494153
              ],
              [
                54.0202764,
                35.5510835
              ],
              [
                54.0202764,
                35.5666367
              ],
              [
                54.0174998,
                35.5783128
              ],
              [
                54.0177764,
                35.5797013
              ],
              [
                54.0186097,
                35.5858052
              ],
              [
                54.0191665,
                35.5894207
              ],
              [
                54.0180565,
                35.5941451
              ],
              [
                54.0177764,
                35.5944156
              ],
              [
                54.017682,
                35.5947016
              ],
              [
                54.017592,
                35.5949746
              ],
              [
                54.0086099,
                35.6349782
              ],
              [
                54.0080531,
                35.6433087
              ],
              [
                54.0083333,
                35.645815
              ],
              [
                54.0075,
                35.6680293
              ],
              [
                54.0080532,
                35.6760891
              ],
              [
                54.0083332,
                35.6777569
              ],
              [
                54.0099999,
                35.7013678
              ],
              [
                54.0108332,
                35.708039
              ],
              [
                54.0133331,
                35.723031
              ],
              [
                54.0136098,
                35.7291521
              ],
              [
                54.0130532,
                35.7633179
              ],
              [
                54.0124998,
                35.7672033
              ],
              [
                54.0119432,
                35.7777592
              ],
              [
                54.0080531,
                35.8094265
              ],
              [
                54.0072199,
                35.8149791
              ],
              [
                54.0069433,
                35.815538
              ],
              [
                54.0032982,
                35.8243475
              ],
              [
                53.99583,
                35.8255347
              ],
              [
                53.99333,
                35.8255346
              ],
              [
                53.9927768,
                35.8258141
              ],
              [
                53.9913867,
                35.8258141
              ],
              [
                53.9905534,
                35.8260935
              ],
              [
                53.9899967,
                35.8260935
              ],
              [
                53.9880535,
                35.8266523
              ],
              [
                53.9827768,
                35.8285904
              ],
              [
                53.9755536,
                35.8305374
              ],
              [
                53.9694403,
                35.8327548
              ],
              [
                53.9074944,
                35.8597061
              ],
              [
                53.8813814,
                35.8697022
              ],
              [
                53.880548,
                35.8697023
              ],
              [
                53.8758247,
                35.8719286
              ],
              [
                53.8752714,
                35.8724874
              ],
              [
                53.8719381,
                35.8738755
              ],
              [
                53.829992,
                35.8930382
              ],
              [
                53.826102,
                35.8944262
              ],
              [
                53.8252686,
                35.8952645
              ],
              [
                53.7805425,
                35.913318
              ],
              [
                53.7794324,
                35.9141472
              ],
              [
                53.7588761,
                35.9210963
              ],
              [
                53.7283198,
                35.9352558
              ],
              [
                53.7260964,
                35.9366438
              ],
              [
                53.7258198,
                35.9369322
              ],
              [
                53.7222065,
                35.940258
              ],
              [
                53.7133166,
                35.9513799
              ],
              [
                53.7124832,
                35.9530382
              ],
              [
                53.7116499,
                35.9538765
              ],
              [
                53.70804,
                35.9622042
              ],
              [
                53.7077633,
                35.9644303
              ],
              [
                53.7072066,
                35.9713701
              ],
              [
                53.7074833,
                35.9760927
              ],
              [
                53.7077633,
                35.9783187
              ],
              [
                53.70943,
                35.9847086
              ],
              [
                53.7060189,
                35.9914912
              ],
              [
                53.7047067,
                35.9830413
              ],
              [
                53.6785936,
                35.9624836
              ],
              [
                53.6255376,
                35.9163734
              ],
              [
                53.6191477,
                35.9113711
              ],
              [
                53.5733116,
                35.8691433
              ],
              [
                53.5674783,
                35.8588768
              ],
              [
                53.5666449,
                35.8522067
              ],
              [
                53.5674782,
                35.8508185
              ],
              [
                53.5704584,
                35.848031
              ],
              [
                53.5802548,
                35.8388662
              ],
              [
                53.5824781,
                35.8363693
              ],
              [
                53.5833114,
                35.8358105
              ],
              [
                53.5838682,
                35.8349812
              ],
              [
                53.5910914,
                35.8266523
              ],
              [
                53.5897013,
                35.8199819
              ],
              [
                53.5888681,
                35.8183144
              ],
              [
                53.5535885,
                35.7797063
              ],
              [
                53.543032,
                35.7724857
              ],
              [
                53.5388653,
                35.7699797
              ],
              [
                53.5374754,
                35.7694208
              ],
              [
                53.5219188,
                35.7608119
              ],
              [
                53.5205322,
                35.7608118
              ],
              [
                53.5196989,
                35.7605324
              ],
              [
                53.5124756,
                35.7605324
              ],
              [
                53.5116423,
                35.7602529
              ],
              [
                53.4974758,
                35.7577559
              ],
              [
                53.4935858,
                35.7566471
              ],
              [
                53.4927526,
                35.7560882
              ],
              [
                53.4844194,
                35.7538706
              ],
              [
                53.4835859,
                35.7533117
              ],
              [
                53.4583063,
                35.7444231
              ],
              [
                53.4533063,
                35.742476
              ],
              [
                53.4433064,
                35.7380317
              ],
              [
                53.4360832,
                35.7344258
              ],
              [
                53.4352499,
                35.7335874
              ],
              [
                53.4155267,
                35.7233104
              ],
              [
                53.4152502,
                35.7227515
              ],
              [
                53.4085801,
                35.718866
              ],
              [
                53.3958036,
                35.7033151
              ],
              [
                53.3946937,
                35.7002589
              ],
              [
                53.3935803,
                35.6963644
              ],
              [
                53.3791372,
                35.6599784
              ],
              [
                53.3546909,
                35.6344191
              ],
              [
                53.3496909,
                35.6305334
              ],
              [
                53.3480243,
                35.6277565
              ],
              [
                53.3474676,
                35.626368
              ],
              [
                53.347191,
                35.6255296
              ],
              [
                53.3474676,
                35.6252501
              ],
              [
                53.3449677,
                35.6124746
              ],
              [
                53.3445476,
                35.6116726
              ],
              [
                53.3372026,
                35.5976481
              ],
              [
                53.3233012,
                35.5710906
              ],
              [
                53.322468,
                35.5683137
              ],
              [
                53.3221879,
                35.5658071
              ],
              [
                53.322468,
                35.5652481
              ],
              [
                53.3221878,
                35.5638596
              ],
              [
                53.3183013,
                35.5446906
              ],
              [
                53.3185779,
                35.539975
              ],
              [
                53.3191347,
                35.5358093
              ],
              [
                53.3194113,
                35.5327528
              ],
              [
                53.319688,
                35.5316437
              ],
              [
                53.3194113,
                35.5202467
              ],
              [
                53.3191346,
                35.5177489
              ],
              [
                53.3194114,
                35.5171899
              ],
              [
                53.3194113,
                35.5119151
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555099,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شاهرود",
          "name:ar": "مقاطعة شاهرود",
          "name:en": "Shahrud County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286402",
          "wikipedia": "en:Shahrud County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.5572145,
                36.5229677
              ],
              [
                54.557814,
                36.5223759
              ],
              [
                54.5580906,
                36.5207093
              ],
              [
                54.5597573,
                36.5157002
              ],
              [
                54.5631238,
                36.5037454
              ],
              [
                54.5628471,
                36.4981777
              ],
              [
                54.5625705,
                36.497349
              ],
              [
                54.5833601,
                36.4383349
              ],
              [
                54.5890256,
                36.4231773
              ],
              [
                54.5944699,
                36.4086087
              ],
              [
                54.5978033,
                36.4027714
              ],
              [
                54.5989166,
                36.4016634
              ],
              [
                54.5991932,
                36.4008257
              ],
              [
                54.6019382,
                36.3965262
              ],
              [
                54.6075264,
                36.3877727
              ],
              [
                54.6078065,
                36.3874934
              ],
              [
                54.6089164,
                36.3866647
              ],
              [
                54.6130831,
                36.3822146
              ],
              [
                54.6139164,
                36.3813858
              ],
              [
                54.6144416,
                36.3810587
              ],
              [
                54.6736423,
                36.3441622
              ],
              [
                54.6914188,
                36.3352706
              ],
              [
                54.7166985,
                36.3138831
              ],
              [
                54.7264217,
                36.3002702
              ],
              [
                54.734755,
                36.2744313
              ],
              [
                54.7358683,
                36.2699896
              ],
              [
                54.7380883,
                36.2616557
              ],
              [
                54.7436448,
                36.2547092
              ],
              [
                54.7461448,
                36.2538803
              ],
              [
                54.7472548,
                36.2538803
              ],
              [
                54.7478116,
                36.253601
              ],
              [
                54.7486449,
                36.253601
              ],
              [
                54.7494781,
                36.2533307
              ],
              [
                54.7508681,
                36.2533307
              ],
              [
                54.7530915,
                36.252772
              ],
              [
                54.7536447,
                36.2522135
              ],
              [
                54.7542015,
                36.2522135
              ],
              [
                54.759478,
                36.2472131
              ],
              [
                54.7661445,
                36.2361038
              ],
              [
                54.7672579,
                36.2174891
              ],
              [
                54.766978,
                36.215543
              ],
              [
                54.7686446,
                36.1941525
              ],
              [
                54.7700345,
                36.1874938
              ],
              [
                54.7703112,
                36.1858269
              ],
              [
                54.7739245,
                36.1702657
              ],
              [
                54.7744812,
                36.1694277
              ],
              [
                54.7747577,
                36.1674904
              ],
              [
                54.7758678,
                36.1649854
              ],
              [
                54.7800343,
                36.1522082
              ],
              [
                54.7947576,
                36.1194352
              ],
              [
                54.7997574,
                36.1088832
              ],
              [
                54.8005908,
                36.1049902
              ],
              [
                54.8028141,
                36.0874902
              ],
              [
                54.8025375,
                36.0863818
              ],
              [
                54.8030219,
                36.0810302
              ],
              [
                54.8030908,
                36.0783255
              ],
              [
                54.8033709,
                36.0780461
              ],
              [
                54.8033708,
                36.077208
              ],
              [
                54.8036474,
                36.0758203
              ],
              [
                54.8042042,
                36.0738738
              ],
              [
                54.8042042,
                36.0733241
              ],
              [
                54.8022574,
                36.0697104
              ],
              [
                54.8025375,
                36.0688813
              ],
              [
                54.803924,
                36.059428
              ],
              [
                54.8042042,
                36.05248
              ],
              [
                54.803924,
                36.0474874
              ],
              [
                54.8036475,
                36.0455409
              ],
              [
                54.8042041,
                36.0213706
              ],
              [
                54.8033708,
                36.0174864
              ],
              [
                54.8033708,
                36.0158191
              ],
              [
                54.8025374,
                36.0116555
              ],
              [
                54.8028141,
                36.0035985
              ],
              [
                54.8033638,
                36.0002517
              ],
              [
                54.806704,
                35.9930451
              ],
              [
                54.8072573,
                35.9886019
              ],
              [
                54.806424,
                35.979986
              ],
              [
                54.8050374,
                35.9722081
              ],
              [
                54.8050374,
                35.9547055
              ],
              [
                54.805314,
                35.9510913
              ],
              [
                54.8050375,
                35.9505416
              ],
              [
                54.805314,
                35.9180408
              ],
              [
                54.8069806,
                35.9044309
              ],
              [
                54.8075374,
                35.8960935
              ],
              [
                54.8072573,
                35.8910911
              ],
              [
                54.806704,
                35.8833216
              ],
              [
                54.8064239,
                35.8824833
              ],
              [
                54.8061473,
                35.8805364
              ],
              [
                54.8064239,
                35.8747047
              ],
              [
                54.8061473,
                35.8663762
              ],
              [
                54.8055906,
                35.859706
              ],
              [
                54.8058706,
                35.8580384
              ],
              [
                54.8061473,
                35.8416514
              ],
              [
                54.805009,
                35.8284683
              ],
              [
                54.804204,
                35.8191435
              ],
              [
                54.8039239,
                35.8180348
              ],
              [
                54.8039239,
                35.8063705
              ],
              [
                54.7997574,
                35.7849797
              ],
              [
                54.799204,
                35.7841413
              ],
              [
                54.7986474,
                35.7822032
              ],
              [
                54.7972574,
                35.7788678
              ],
              [
                54.7944807,
                35.773315
              ],
              [
                54.7933708,
                35.7719268
              ],
              [
                54.7928141,
                35.7705385
              ],
              [
                54.7825342,
                35.7572059
              ],
              [
                54.7789242,
                35.745541
              ],
              [
                54.7780909,
                35.7416466
              ],
              [
                54.766701,
                35.6897021
              ],
              [
                54.762811,
                35.6791452
              ],
              [
                54.7417013,
                35.6341396
              ],
              [
                54.7400347,
                35.6316423
              ],
              [
                54.7339214,
                35.6216438
              ],
              [
                54.7283648,
                35.614422
              ],
              [
                54.7028084,
                35.5899705
              ],
              [
                54.6978085,
                35.5849756
              ],
              [
                54.6778087,
                35.5655276
              ],
              [
                54.6758654,
                35.5624711
              ],
              [
                54.6739187,
                35.556358
              ],
              [
                54.6741953,
                35.5485858
              ],
              [
                54.6753088,
                35.517749
              ],
              [
                54.6758654,
                35.5160899
              ],
              [
                54.6764187,
                35.5121946
              ],
              [
                54.6766988,
                35.5066403
              ],
              [
                54.676142,
                35.495811
              ],
              [
                54.6758654,
                35.4941429
              ],
              [
                54.6758654,
                35.4916362
              ],
              [
                54.6753088,
                35.4883089
              ],
              [
                54.6753087,
                35.4874703
              ],
              [
                54.6730854,
                35.4799682
              ],
              [
                54.6730855,
                35.4794182
              ],
              [
                54.6619755,
                35.4555226
              ],
              [
                54.6558622,
                35.4474703
              ],
              [
                54.5994695,
                35.3866377
              ],
              [
                54.5975262,
                35.3830216
              ],
              [
                54.5975263,
                35.382742
              ],
              [
                54.5961362,
                35.3785757
              ],
              [
                54.5950262,
                35.3705228
              ],
              [
                54.5947496,
                35.369134
              ],
              [
                54.6003062,
                35.2855254
              ],
              [
                54.6000262,
                35.2816384
              ],
              [
                54.6058594,
                35.2219153
              ],
              [
                54.6086394,
                35.1949659
              ],
              [
                54.6147493,
                35.1344087
              ],
              [
                54.6158592,
                35.1216366
              ],
              [
                54.6161393,
                35.1185789
              ],
              [
                54.6164158,
                35.1030196
              ],
              [
                54.6161393,
                35.0999618
              ],
              [
                54.6189159,
                35.0180122
              ],
              [
                54.6186392,
                35.0130148
              ],
              [
                54.6183591,
                35.0121849
              ],
              [
                54.6183591,
                35.0094066
              ],
              [
                54.6178059,
                35.0001513
              ],
              [
                54.6169726,
                34.9955146
              ],
              [
                54.6169726,
                34.9927363
              ],
              [
                54.6166925,
                34.9919064
              ],
              [
                54.6169726,
                34.9855106
              ],
              [
                54.6166925,
                34.984401
              ],
              [
                54.6155825,
                34.9749562
              ],
              [
                54.6158592,
                34.9666208
              ],
              [
                54.6155825,
                34.9638424
              ],
              [
                54.6141925,
                34.9585742
              ],
              [
                54.6133592,
                34.956346
              ],
              [
                54.6125259,
                34.9513483
              ],
              [
                54.6139159,
                34.9377355
              ],
              [
                54.6139159,
                34.9307981
              ],
              [
                54.6114159,
                34.9119077
              ],
              [
                54.6111392,
                34.9107889
              ],
              [
                54.6108865,
                34.9088513
              ],
              [
                54.6078059,
                34.8852312
              ],
              [
                54.607526,
                34.8794033
              ],
              [
                54.605306,
                34.849677
              ],
              [
                54.6089159,
                34.7855129
              ],
              [
                54.6105825,
                34.7641212
              ],
              [
                54.6116925,
                34.7543951
              ],
              [
                54.6119726,
                34.7296826
              ],
              [
                54.6141924,
                34.7093999
              ],
              [
                54.6150258,
                34.692735
              ],
              [
                54.6141924,
                34.6769
              ],
              [
                54.6144724,
                34.6663433
              ],
              [
                54.6158591,
                34.6513381
              ],
              [
                54.6166924,
                34.6271744
              ],
              [
                54.6155824,
                34.6060601
              ],
              [
                54.6153058,
                34.5930033
              ],
              [
                54.6136391,
                34.5555019
              ],
              [
                54.6139158,
                34.542174
              ],
              [
                54.6114158,
                34.5143901
              ],
              [
                54.6130824,
                34.4827253
              ],
              [
                54.613359,
                34.4738367
              ],
              [
                54.6136391,
                34.4621687
              ],
              [
                54.6141924,
                34.4352225
              ],
              [
                54.6139157,
                34.432443
              ],
              [
                54.6164157,
                34.3516111
              ],
              [
                54.615859,
                34.3421622
              ],
              [
                54.6155823,
                34.336612
              ],
              [
                54.6125257,
                34.2971644
              ],
              [
                54.612249,
                34.2910545
              ],
              [
                54.612659,
                34.2585786
              ],
              [
                54.6143256,
                34.246077
              ],
              [
                54.6140455,
                34.2444072
              ],
              [
                54.612659,
                34.241636
              ],
              [
                54.6105335,
                34.2385698
              ],
              [
                55.0405855,
                34.2397823
              ],
              [
                55.1082144,
                34.2399589
              ],
              [
                55.1337097,
                34.2403038
              ],
              [
                55.1604007,
                34.2380332
              ],
              [
                55.1818967,
                34.2384549
              ],
              [
                55.1997496,
                34.2390266
              ],
              [
                55.4016493,
                34.2393376
              ],
              [
                55.5007367,
                34.2674919
              ],
              [
                55.5209677,
                34.2718896
              ],
              [
                55.5338286,
                34.2684953
              ],
              [
                55.5524977,
                34.2622428
              ],
              [
                55.5957227,
                34.2647793
              ],
              [
                55.6534093,
                34.242445
              ],
              [
                55.6547961,
                34.2421651
              ],
              [
                55.6584094,
                34.2421652
              ],
              [
                55.6597993,
                34.242445
              ],
              [
                55.6689659,
                34.2427157
              ],
              [
                55.6697991,
                34.2424449
              ],
              [
                55.6775756,
                34.242445
              ],
              [
                55.6786891,
                34.2421652
              ],
              [
                55.7095219,
                34.2427157
              ],
              [
                55.710912,
                34.2429954
              ],
              [
                55.7228551,
                34.2429955
              ],
              [
                55.7236884,
                34.2427157
              ],
              [
                55.7259118,
                34.2427157
              ],
              [
                55.7267452,
                34.2424449
              ],
              [
                55.7464682,
                34.2427157
              ],
              [
                55.7489681,
                34.243555
              ],
              [
                55.7492449,
                34.2438258
              ],
              [
                55.7498016,
                34.2441056
              ],
              [
                55.7520248,
                34.2441055
              ],
              [
                55.7525815,
                34.2438258
              ],
              [
                55.7531348,
                34.2441056
              ],
              [
                55.7623014,
                34.243555
              ],
              [
                55.7631346,
                34.2432752
              ],
              [
                55.773138,
                34.2432752
              ],
              [
                55.7775812,
                34.243555
              ],
              [
                55.7823046,
                34.243555
              ],
              [
                55.7828577,
                34.2432752
              ],
              [
                55.7861909,
                34.2432753
              ],
              [
                55.7867478,
                34.2429954
              ],
              [
                55.788691,
                34.2429954
              ],
              [
                55.7892477,
                34.2427157
              ],
              [
                55.7911944,
                34.2427157
              ],
              [
                55.7914709,
                34.2424449
              ],
              [
                55.7936944,
                34.2424449
              ],
              [
                55.7945276,
                34.2421651
              ],
              [
                55.7973043,
                34.2421651
              ],
              [
                55.7978609,
                34.2424449
              ],
              [
                55.7986944,
                34.242165
              ],
              [
                55.7998043,
                34.2424449
              ],
              [
                55.8075809,
                34.2424449
              ],
              [
                55.8100842,
                34.2427157
              ],
              [
                55.8106373,
                34.2429954
              ],
              [
                55.8417543,
                34.2384212
              ],
              [
                55.8434209,
                34.2384211
              ],
              [
                55.8445342,
                34.2387008
              ],
              [
                55.8514775,
                34.2387009
              ],
              [
                55.8525872,
                34.2384211
              ],
              [
                55.8553674,
                34.2384211
              ],
              [
                55.8564774,
                34.2381412
              ],
              [
                55.8670338,
                34.2381413
              ],
              [
                55.8678673,
                34.2378615
              ],
              [
                55.8864532,
                34.2441054
              ],
              [
                55.88701,
                34.2438257
              ],
              [
                55.88951,
                34.2438257
              ],
              [
                55.8900633,
                34.2435549
              ],
              [
                55.8908965,
                34.2438257
              ],
              [
                55.8931198,
                34.2435549
              ],
              [
                55.8936766,
                34.2432751
              ],
              [
                55.9014532,
                34.2432751
              ],
              [
                55.9036764,
                34.2438257
              ],
              [
                55.9042331,
                34.2441054
              ],
              [
                55.9047864,
                34.2441054
              ],
              [
                55.9050666,
                34.2443853
              ],
              [
                55.9058998,
                34.2443852
              ],
              [
                55.909233,
                34.2457751
              ],
              [
                55.9095096,
                34.2460549
              ],
              [
                55.9100665,
                34.2466054
              ],
              [
                55.9100664,
                34.2468852
              ],
              [
                55.9103431,
                34.247165
              ],
              [
                55.9108997,
                34.2474447
              ],
              [
                55.9436991,
                34.282272
              ],
              [
                56.0098882,
                34.3758018
              ],
              [
                56.0107213,
                34.3766319
              ],
              [
                56.0132214,
                34.3813517
              ],
              [
                56.0168348,
                34.3866309
              ],
              [
                56.2256594,
                34.7060607
              ],
              [
                56.2270463,
                34.7080096
              ],
              [
                56.2273261,
                34.7088397
              ],
              [
                56.2276029,
                34.7091193
              ],
              [
                56.2279736,
                34.7104172
              ],
              [
                56.2284362,
                34.7118984
              ],
              [
                56.2237229,
                34.7229952
              ],
              [
                56.226223,
                34.7260448
              ],
              [
                56.221837,
                34.7446398
              ],
              [
                56.2235036,
                34.7471391
              ],
              [
                56.2237801,
                34.7482579
              ],
              [
                56.2307568,
                34.7852731
              ],
              [
                56.23159,
                34.7858323
              ],
              [
                56.2554798,
                34.8199904
              ],
              [
                56.2579799,
                34.8230391
              ],
              [
                56.3125957,
                34.8659688
              ],
              [
                56.3279786,
                34.8775023
              ],
              [
                56.3324253,
                34.8816692
              ],
              [
                56.3335353,
                34.8833287
              ],
              [
                56.3338118,
                34.8836082
              ],
              [
                56.3413118,
                34.8899939
              ],
              [
                56.348535,
                34.9005461
              ],
              [
                56.3488151,
                34.9013759
              ],
              [
                56.3490918,
                34.9016555
              ],
              [
                56.3490919,
                34.901935
              ],
              [
                56.3883746,
                34.9345305
              ],
              [
                56.3900413,
                34.9367495
              ],
              [
                56.3903212,
                34.9375884
              ],
              [
                56.3939312,
                34.9431357
              ],
              [
                56.3944879,
                34.943695
              ],
              [
                56.3944879,
                34.9442453
              ],
              [
                56.4428905,
                34.9796821
              ],
              [
                56.4537237,
                34.9999609
              ],
              [
                56.4815034,
                35.0221877
              ],
              [
                56.4884468,
                35.0285743
              ],
              [
                56.5170597,
                35.0413472
              ],
              [
                56.5178931,
                35.0413472
              ],
              [
                56.5190065,
                35.0421861
              ],
              [
                56.5328961,
                35.0466241
              ],
              [
                56.5345628,
                35.0469038
              ],
              [
                56.5367828,
                35.0477427
              ],
              [
                56.5620626,
                35.0524603
              ],
              [
                56.5637292,
                35.0524603
              ],
              [
                56.5645624,
                35.0527399
              ],
              [
                56.5687292,
                35.0527399
              ],
              [
                56.5703958,
                35.0530195
              ],
              [
                56.5717858,
                35.0530195
              ],
              [
                56.5723425,
                35.0530195
              ],
              [
                56.580119,
                35.0538494
              ],
              [
                56.5815089,
                35.0538494
              ],
              [
                56.5820622,
                35.0541291
              ],
              [
                56.5840089,
                35.0541291
              ],
              [
                56.585119,
                35.0544087
              ],
              [
                56.5870657,
                35.0544087
              ],
              [
                56.5895655,
                35.0549589
              ],
              [
                56.5915089,
                35.0549589
              ],
              [
                56.5937322,
                35.0555181
              ],
              [
                56.5948422,
                35.0555182
              ],
              [
                56.6240117,
                35.0641325
              ],
              [
                56.6253985,
                35.0644031
              ],
              [
                56.6265119,
                35.0649624
              ],
              [
                56.6401217,
                35.0666221
              ],
              [
                56.641235,
                35.0669017
              ],
              [
                56.6520682,
                35.0669018
              ],
              [
                56.6531782,
                35.0666221
              ],
              [
                56.6579014,
                35.0666221
              ],
              [
                56.6582224,
                35.0636936
              ],
              [
                56.6598891,
                35.0631254
              ],
              [
                56.6615556,
                35.0628548
              ],
              [
                56.6647249,
                35.0604994
              ],
              [
                56.6666683,
                35.0604993
              ],
              [
                56.6672249,
                35.0602197
              ],
              [
                56.6700016,
                35.0602197
              ],
              [
                56.6705582,
                35.0604994
              ],
              [
                56.6725014,
                35.0604994
              ],
              [
                56.6733348,
                35.060779
              ],
              [
                56.6750014,
                35.060779
              ],
              [
                56.6758348,
                35.0610586
              ],
              [
                56.6772248,
                35.0610587
              ],
              [
                56.6869549,
                35.0822105
              ],
              [
                56.6908783,
                35.0872661
              ],
              [
                56.6944748,
                35.0920132
              ],
              [
                56.6969749,
                35.0936727
              ],
              [
                56.6972514,
                35.0942319
              ],
              [
                56.6986415,
                35.0953413
              ],
              [
                56.7133647,
                35.1092306
              ],
              [
                56.7608636,
                35.126087
              ],
              [
                56.7737402,
                35.1469087
              ],
              [
                56.77513,
                35.1482977
              ],
              [
                56.7823499,
                35.1535742
              ],
              [
                56.8112432,
                35.1674643
              ],
              [
                56.8270763,
                35.1846825
              ],
              [
                56.828743,
                35.1860714
              ],
              [
                56.828743,
                35.1863511
              ],
              [
                56.8306861,
                35.1882992
              ],
              [
                56.8429093,
                35.1969036
              ],
              [
                56.8437427,
                35.1977425
              ],
              [
                56.8556893,
                35.2024685
              ],
              [
                56.8573559,
                35.2024685
              ],
              [
                56.8612425,
                35.2032983
              ],
              [
                56.8623558,
                35.2032983
              ],
              [
                56.8629091,
                35.2035779
              ],
              [
                56.865409,
                35.2035779
              ],
              [
                56.8662458,
                35.2032983
              ],
              [
                56.8684657,
                35.2032983
              ],
              [
                56.8695792,
                35.2030187
              ],
              [
                56.8740223,
                35.2030187
              ],
              [
                56.8751322,
                35.202739
              ],
              [
                56.8765224,
                35.2030187
              ],
              [
                56.8826322,
                35.2030186
              ],
              [
                56.8837455,
                35.2027391
              ],
              [
                56.8870788,
                35.2027391
              ],
              [
                56.8876357,
                35.2030187
              ],
              [
                56.8898554,
                35.2030186
              ],
              [
                56.8904122,
                35.2032982
              ],
              [
                56.8912455,
                35.2032983
              ],
              [
                56.8918022,
                35.2035778
              ],
              [
                56.8934688,
                35.2035778
              ],
              [
                56.8940221,
                35.2038575
              ],
              [
                56.8951354,
                35.2038574
              ],
              [
                56.9076353,
                35.2074651
              ],
              [
                56.9081919,
                35.2080153
              ],
              [
                56.9093019,
                35.2083039
              ],
              [
                56.9098586,
                35.2088541
              ],
              [
                56.9109685,
                35.2091336
              ],
              [
                56.9165251,
                35.2133005
              ],
              [
                56.9348583,
                35.2205158
              ],
              [
                56.9354149,
                35.2207954
              ],
              [
                56.9368015,
                35.2207954
              ],
              [
                56.9370816,
                35.221075
              ],
              [
                56.9409682,
                35.221075
              ],
              [
                56.9415249,
                35.2207954
              ],
              [
                56.9426381,
                35.2207954
              ],
              [
                56.9465248,
                35.2196861
              ],
              [
                56.9473582,
                35.219686
              ],
              [
                56.9515247,
                35.2180175
              ],
              [
                56.9523581,
                35.217747
              ],
              [
                56.9656947,
                35.2144099
              ],
              [
                56.966528,
                35.2141303
              ],
              [
                56.967638,
                35.2141303
              ],
              [
                56.9751379,
                35.2116319
              ],
              [
                56.9806945,
                35.2108021
              ],
              [
                56.980971,
                35.2105226
              ],
              [
                56.9831945,
                35.2105226
              ],
              [
                56.9837511,
                35.2108022
              ],
              [
                56.9868043,
                35.2108022
              ],
              [
                56.9906943,
                35.2119116
              ],
              [
                57.0002296,
                35.2152486
              ],
              [
                57.010694,
                35.2235732
              ],
              [
                57.0312505,
                35.2674683
              ],
              [
                57.0315306,
                35.2677479
              ],
              [
                57.0318073,
                35.2688572
              ],
              [
                57.0393071,
                35.2810776
              ],
              [
                57.0501403,
                35.3071863
              ],
              [
                57.0520871,
                35.3149691
              ],
              [
                57.0523637,
                35.3210836
              ],
              [
                57.036254,
                35.3374608
              ],
              [
                57.0359739,
                35.3380199
              ],
              [
                57.0354173,
                35.3382996
              ],
              [
                57.0343073,
                35.3394088
              ],
              [
                57.0195842,
                35.3641364
              ],
              [
                57.0102242,
                35.3856591
              ],
              [
                57.0096676,
                35.3940024
              ],
              [
                57.009391,
                35.3953914
              ],
              [
                56.9906272,
                35.4168259
              ],
              [
                56.9869149,
                35.4193241
              ],
              [
                56.9816383,
                35.4290465
              ],
              [
                56.9813584,
                35.4376594
              ],
              [
                56.9813585,
                35.437939
              ],
              [
                56.9841383,
                35.4415465
              ],
              [
                56.9940279,
                35.4558096
              ],
              [
                56.9943047,
                35.4583075
              ],
              [
                56.9945848,
                35.4605257
              ],
              [
                56.995418,
                35.4663598
              ],
              [
                57.0018744,
                35.4727813
              ],
              [
                57.0024312,
                35.4747289
              ],
              [
                57.0235732,
                35.4957848
              ],
              [
                57.030342,
                35.500141
              ],
              [
                57.0340633,
                35.5079853
              ],
              [
                57.0371961,
                35.512352
              ],
              [
                57.0394706,
                35.520945
              ],
              [
                57.0405435,
                35.5259397
              ],
              [
                57.0441224,
                35.526751
              ],
              [
                57.0463399,
                35.5281844
              ],
              [
                57.0484134,
                35.5292768
              ],
              [
                57.0491429,
                35.5304295
              ],
              [
                57.0513969,
                35.5345068
              ],
              [
                57.0509678,
                35.5378598
              ],
              [
                57.0499142,
                35.5423558
              ],
              [
                57.0477103,
                35.545217
              ],
              [
                57.0429951,
                35.5472653
              ],
              [
                57.0398252,
                35.5503299
              ],
              [
                57.0365523,
                35.5579263
              ],
              [
                57.0318317,
                35.5610684
              ],
              [
                57.0322608,
                35.5644896
              ],
              [
                57.0310877,
                35.5679775
              ],
              [
                57.0245719,
                35.5692997
              ],
              [
                57.0172344,
                35.5710454
              ],
              [
                57.0105396,
                35.5741175
              ],
              [
                56.9974501,
                35.5776884
              ],
              [
                56.9911933,
                35.5815763
              ],
              [
                56.9853973,
                35.585014
              ],
              [
                56.9828223,
                35.5900396
              ],
              [
                56.9856547,
                35.5948555
              ],
              [
                56.9855689,
                35.5973681
              ],
              [
                56.9879574,
                35.6036103
              ],
              [
                56.974211,
                35.6168686
              ],
              [
                56.9709777,
                35.6258378
              ],
              [
                56.9654845,
                35.6335118
              ],
              [
                56.9627379,
                35.6404178
              ],
              [
                56.9584464,
                35.657924
              ],
              [
                56.9582747,
                35.6639213
              ],
              [
                56.9503783,
                35.6922976
              ],
              [
                56.9463974,
                35.6984029
              ],
              [
                56.9426464,
                35.7050006
              ],
              [
                56.9358909,
                35.7121805
              ],
              [
                56.930251,
                35.7146196
              ],
              [
                56.9191061,
                35.7215946
              ],
              [
                56.9120853,
                35.7311819
              ],
              [
                56.9113254,
                35.7360625
              ],
              [
                56.9086911,
                35.7432314
              ],
              [
                56.8983079,
                35.7528377
              ],
              [
                56.8655593,
                35.7785791
              ],
              [
                56.8551921,
                35.7876017
              ],
              [
                56.8399318,
                35.7978493
              ],
              [
                56.818493,
                35.8126847
              ],
              [
                56.7839467,
                35.8348289
              ],
              [
                56.7652614,
                35.8463558
              ],
              [
                56.7538101,
                35.8533756
              ],
              [
                56.7573451,
                35.884252
              ],
              [
                56.7573541,
                35.8987346
              ],
              [
                56.7579801,
                35.9083778
              ],
              [
                56.7599317,
                35.9243064
              ],
              [
                56.7575674,
                35.9438673
              ],
              [
                56.7578475,
                35.9447056
              ],
              [
                56.7561775,
                35.9608119
              ],
              [
                56.7564574,
                35.9616502
              ],
              [
                56.7587941,
                35.9655351
              ],
              [
                56.7593507,
                35.9697082
              ],
              [
                56.7599074,
                35.9752603
              ],
              [
                56.7593508,
                35.982489
              ],
              [
                56.7596274,
                35.9830387
              ],
              [
                56.743458,
                36.0116538
              ],
              [
                56.7437346,
                36.0127622
              ],
              [
                56.7440146,
                36.0138706
              ],
              [
                56.7442912,
                36.0169253
              ],
              [
                56.7451246,
                36.0247016
              ],
              [
                56.7451246,
                36.0288646
              ],
              [
                56.7448481,
                36.0310903
              ],
              [
                56.7451246,
                36.0319193
              ],
              [
                56.744848,
                36.0330366
              ],
              [
                56.7451247,
                36.0335862
              ],
              [
                56.7462347,
                36.0444261
              ],
              [
                56.7465147,
                36.0460841
              ],
              [
                56.7467913,
                36.0505353
              ],
              [
                56.7463732,
                36.06283
              ],
              [
                56.7469299,
                36.0698285
              ],
              [
                56.7472255,
                36.0744876
              ],
              [
                56.747847,
                36.0896383
              ],
              [
                56.7488449,
                36.1066758
              ],
              [
                56.7482471,
                36.1137488
              ],
              [
                56.750104,
                36.1318971
              ],
              [
                56.7528116,
                36.1382944
              ],
              [
                56.7528116,
                36.138844
              ],
              [
                56.7533683,
                36.1394024
              ],
              [
                56.757535,
                36.1521773
              ],
              [
                56.7578116,
                36.1524475
              ],
              [
                56.7581767,
                36.1535431
              ],
              [
                56.7586093,
                36.1559498
              ],
              [
                56.7588859,
                36.1565084
              ],
              [
                56.7590231,
                36.1570581
              ],
              [
                56.7544393,
                36.1570582
              ],
              [
                56.7541626,
                36.1567786
              ],
              [
                56.7533293,
                36.1567786
              ],
              [
                56.7527727,
                36.1565084
              ],
              [
                56.7384452,
                36.1562243
              ],
              [
                56.737612,
                36.1565038
              ],
              [
                56.7348354,
                36.1565038
              ],
              [
                56.7345553,
                36.1567829
              ],
              [
                56.7328886,
                36.1567829
              ],
              [
                56.7326121,
                36.1570623
              ],
              [
                56.7315021,
                36.1570623
              ],
              [
                56.7309454,
                36.1573416
              ],
              [
                56.7298354,
                36.1573416
              ],
              [
                56.7122773,
                36.1622012
              ],
              [
                56.7106107,
                36.1633185
              ],
              [
                56.7047774,
                36.1658143
              ],
              [
                56.6997775,
                36.1669226
              ],
              [
                56.6992209,
                36.1672018
              ],
              [
                56.6884591,
                36.1638759
              ],
              [
                56.6879026,
                36.1638759
              ],
              [
                56.6856827,
                36.1641552
              ],
              [
                56.6817927,
                36.1641553
              ],
              [
                56.6812361,
                36.1644346
              ],
              [
                56.6792929,
                36.1644346
              ],
              [
                56.6759596,
                36.1655429
              ],
              [
                56.6702229,
                36.1673547
              ],
              [
                56.6685562,
                36.168463
              ],
              [
                56.6532113,
                36.1781921
              ],
              [
                56.6487644,
                36.1790301
              ],
              [
                56.633305,
                36.1801386
              ],
              [
                56.631915,
                36.1804179
              ],
              [
                56.6310815,
                36.1801386
              ],
              [
                56.6296917,
                36.1804179
              ],
              [
                56.6271916,
                36.1804179
              ],
              [
                56.625805,
                36.1801386
              ],
              [
                56.6174684,
                36.1806883
              ],
              [
                56.6088335,
                36.1787572
              ],
              [
                56.6025603,
                36.1752997
              ],
              [
                56.6020037,
                36.1752996
              ],
              [
                56.6008936,
                36.175579
              ],
              [
                56.5964471,
                36.1755791
              ],
              [
                56.5692208,
                36.1776444
              ],
              [
                56.5486644,
                36.1761139
              ],
              [
                56.5389962,
                36.169601
              ],
              [
                56.5376063,
                36.1693217
              ],
              [
                56.5364963,
                36.169601
              ],
              [
                56.5362163,
                36.1693217
              ],
              [
                56.5112531,
                36.1827776
              ],
              [
                56.507643,
                36.1827775
              ],
              [
                56.5068098,
                36.1830568
              ],
              [
                56.5009765,
                36.1830568
              ],
              [
                56.4976432,
                36.1825073
              ],
              [
                56.4965299,
                36.1819396
              ],
              [
                56.4937532,
                36.1813898
              ],
              [
                56.4923631,
                36.1808312
              ],
              [
                56.4906965,
                36.1805609
              ],
              [
                56.4895866,
                36.1802814
              ],
              [
                56.4747332,
                36.1744511
              ],
              [
                56.4739,
                36.1741718
              ],
              [
                56.4730666,
                36.1741718
              ],
              [
                56.468875,
                36.1705669
              ],
              [
                56.467765,
                36.1702875
              ],
              [
                56.4580419,
                36.1627809
              ],
              [
                56.4523886,
                36.1502123
              ],
              [
                56.4462267,
                36.1426128
              ],
              [
                56.4440721,
                36.1412059
              ],
              [
                56.4425261,
                36.1387505
              ],
              [
                56.4417107,
                36.1403621
              ],
              [
                56.4407881,
                36.1425455
              ],
              [
                56.4393429,
                36.1445806
              ],
              [
                56.43905,
                36.1452486
              ],
              [
                56.4388708,
                36.1458629
              ],
              [
                56.4393075,
                36.1464962
              ],
              [
                56.440051,
                36.1468332
              ],
              [
                56.4406518,
                36.1470411
              ],
              [
                56.4410885,
                36.1475185
              ],
              [
                56.4412601,
                36.1482982
              ],
              [
                56.4409383,
                36.1489566
              ],
              [
                56.4402516,
                36.1498403
              ],
              [
                56.4397506,
                36.1510783
              ],
              [
                56.4396218,
                36.1516327
              ],
              [
                56.4392217,
                36.1533402
              ],
              [
                56.4384846,
                36.1551672
              ],
              [
                56.4376123,
                36.1565627
              ],
              [
                56.437548,
                36.157273
              ],
              [
                56.4385994,
                36.1591788
              ],
              [
                56.4387925,
                36.1607726
              ],
              [
                56.4400295,
                36.1616119
              ],
              [
                56.4409093,
                36.1618198
              ],
              [
                56.4407315,
                36.161927
              ],
              [
                56.4406518,
                36.1621663
              ],
              [
                56.4406304,
                36.162686
              ],
              [
                56.4403729,
                36.1633097
              ],
              [
                56.4400939,
                36.1641239
              ],
              [
                56.4396218,
                36.164453
              ],
              [
                56.438785,
                36.1642798
              ],
              [
                56.4379986,
                36.1641161
              ],
              [
                56.4370684,
                36.1636735
              ],
              [
                56.4362101,
                36.1631018
              ],
              [
                56.4357165,
                36.1632923
              ],
              [
                56.4350084,
                36.1635522
              ],
              [
                56.4345578,
                36.1639333
              ],
              [
                56.4344291,
                36.1645223
              ],
              [
                56.4343647,
                36.165094
              ],
              [
                56.4342145,
                36.1658216
              ],
              [
                56.434236,
                36.1666704
              ],
              [
                56.4342789,
                36.1674499
              ],
              [
                56.4342574,
                36.1685412
              ],
              [
                56.4331631,
                36.1700483
              ],
              [
                56.4320902,
                36.1710703
              ],
              [
                56.4314036,
                36.1717805
              ],
              [
                56.4306096,
                36.1718324
              ],
              [
                56.4298801,
                36.171971
              ],
              [
                56.4286999,
                36.1729237
              ],
              [
                56.4276699,
                36.173478
              ],
              [
                56.426876,
                36.1735819
              ],
              [
                56.425846,
                36.1732528
              ],
              [
                56.4247088,
                36.1737205
              ],
              [
                56.4241723,
                36.1742747
              ],
              [
                56.4235286,
                36.1747251
              ],
              [
                56.4224986,
                36.1750888
              ],
              [
                56.4212755,
                36.1750715
              ],
              [
                56.4204816,
                36.175799
              ],
              [
                56.4204601,
                36.1818264
              ],
              [
                56.4192371,
                36.1848746
              ],
              [
                56.4191941,
                36.1865199
              ],
              [
                56.4201812,
                36.1884076
              ],
              [
                56.4204172,
                36.1914208
              ],
              [
                56.4200954,
                36.1930833
              ],
              [
                56.4194302,
                36.1945725
              ],
              [
                56.4174132,
                36.1987631
              ],
              [
                56.4168982,
                36.2013258
              ],
              [
                56.4178208,
                36.2043385
              ],
              [
                56.4182071,
                36.2060873
              ],
              [
                56.4194945,
                36.208996
              ],
              [
                56.4205031,
                36.2130646
              ],
              [
                56.4206103,
                36.2137917
              ],
              [
                56.420296,
                36.2143206
              ],
              [
                56.4196233,
                36.2157307
              ],
              [
                56.419795,
                36.216579
              ],
              [
                56.4201812,
                36.2174965
              ],
              [
                56.4209108,
                36.2187256
              ],
              [
                56.4221124,
                36.2203182
              ],
              [
                56.4227776,
                36.2218762
              ],
              [
                56.421533,
                36.2246978
              ],
              [
                56.4204387,
                36.2260133
              ],
              [
                56.4193229,
                36.2270519
              ],
              [
                56.4185719,
                36.2290252
              ],
              [
                56.4184217,
                36.230583
              ],
              [
                56.4188508,
                36.2316042
              ],
              [
                56.4213184,
                36.2339062
              ],
              [
                56.4244084,
                36.23581
              ],
              [
                56.4266829,
                36.2383888
              ],
              [
                56.4283995,
                36.2399118
              ],
              [
                56.4291366,
                36.241202
              ],
              [
                56.4306096,
                36.2422309
              ],
              [
                56.4319475,
                36.2441267
              ],
              [
                56.4342574,
                36.2463669
              ],
              [
                56.435016,
                36.2474667
              ],
              [
                56.434973,
                36.2489549
              ],
              [
                56.4344581,
                36.2509276
              ],
              [
                56.4340289,
                36.2520004
              ],
              [
                56.4343218,
                36.2529945
              ],
              [
                56.4339785,
                36.2539982
              ],
              [
                56.4334849,
                36.2547941
              ],
              [
                56.4343003,
                36.2568359
              ],
              [
                56.4344291,
                36.2580644
              ],
              [
                56.4346726,
                36.2603578
              ],
              [
                56.4354666,
                36.2607904
              ],
              [
                56.435974,
                36.261594
              ],
              [
                56.4363463,
                36.2623129
              ],
              [
                56.4361886,
                36.2633242
              ],
              [
                56.4359815,
                36.2647005
              ],
              [
                56.4359526,
                36.2662827
              ],
              [
                56.4360131,
                36.2678589
              ],
              [
                56.4357299,
                36.2699765
              ],
              [
                56.4362964,
                36.2707238
              ],
              [
                56.4377627,
                36.2718744
              ],
              [
                56.4443227,
                36.2816797
              ],
              [
                56.4445992,
                36.282788
              ],
              [
                56.4445993,
                36.2830673
              ],
              [
                56.4398794,
                36.2830672
              ],
              [
                56.4112663,
                36.2855721
              ],
              [
                56.3901553,
                36.2879244
              ],
              [
                56.3807017,
                36.2877808
              ],
              [
                56.350702,
                36.2909813
              ],
              [
                56.3495885,
                36.2909813
              ],
              [
                56.3476453,
                36.29154
              ],
              [
                56.302159,
                36.2929487
              ],
              [
                56.2999354,
                36.2929486
              ],
              [
                56.2985457,
                36.2932371
              ],
              [
                56.2932689,
                36.2932371
              ],
              [
                56.2774327,
                36.2972415
              ],
              [
                56.2754895,
                36.2969622
              ],
              [
                56.2629862,
                36.2969622
              ],
              [
                56.2615995,
                36.2966829
              ],
              [
                56.248263,
                36.2966829
              ],
              [
                56.2458297,
                36.2979254
              ],
              [
                56.2422198,
                36.2979255
              ],
              [
                56.2397198,
                36.2976551
              ],
              [
                56.2288832,
                36.2979255
              ],
              [
                56.2272165,
                36.2982048
              ],
              [
                56.2230501,
                36.2982047
              ],
              [
                56.2211066,
                36.2984841
              ],
              [
                56.2183267,
                36.2984841
              ],
              [
                56.2161068,
                36.2987635
              ],
              [
                56.2127734,
                36.2987635
              ],
              [
                56.2069401,
                36.299313
              ],
              [
                56.2047168,
                36.299313
              ],
              [
                56.2036069,
                36.2996013
              ],
              [
                56.2013836,
                36.2996013
              ],
              [
                56.1977702,
                36.3001509
              ],
              [
                56.1955503,
                36.3001509
              ],
              [
                56.1794372,
                36.3023763
              ],
              [
                56.1769371,
                36.3023764
              ],
              [
                56.1586041,
                36.3046018
              ],
              [
                56.1558239,
                36.3046018
              ],
              [
                56.1524906,
                36.3051514
              ],
              [
                56.1132623,
                36.305967
              ],
              [
                56.1102057,
                36.3059669
              ],
              [
                56.1082625,
                36.3059669
              ],
              [
                56.1057624,
                36.305967
              ],
              [
                56.0943725,
                36.3084714
              ],
              [
                56.0855475,
                36.3145963
              ],
              [
                56.0597112,
                36.334048
              ],
              [
                56.0109274,
                36.348603
              ],
              [
                56.0031506,
                36.3513776
              ],
              [
                55.9986106,
                36.3524373
              ],
              [
                55.9877773,
                36.3549418
              ],
              [
                55.9714216,
                36.356782
              ],
              [
                55.9697548,
                36.3570612
              ],
              [
                55.9667015,
                36.3570613
              ],
              [
                55.9553912,
                36.3575121
              ],
              [
                55.9523344,
                36.3575121
              ],
              [
                55.9509445,
                36.3577914
              ],
              [
                55.9476111,
                36.3577914
              ],
              [
                55.9445578,
                36.3580707
              ],
              [
                55.9395579,
                36.3580707
              ],
              [
                55.9362247,
                36.3583499
              ],
              [
                55.934558,
                36.3583499
              ],
              [
                55.9220548,
                36.3588996
              ],
              [
                55.8987217,
                36.3588996
              ],
              [
                55.8967786,
                36.3586203
              ],
              [
                55.8909418,
                36.3586203
              ],
              [
                55.8831653,
                36.3580706
              ],
              [
                55.8528658,
                36.3622151
              ],
              [
                55.8481425,
                36.3622152
              ],
              [
                55.8331427,
                36.3647195
              ],
              [
                55.8306426,
                36.3647195
              ],
              [
                55.828976,
                36.3649989
              ],
              [
                55.8281428,
                36.3647196
              ],
              [
                55.8242526,
                36.3647195
              ],
              [
                55.8177526,
                36.3627758
              ],
              [
                55.8163625,
                36.3624966
              ],
              [
                55.814976,
                36.3624966
              ],
              [
                55.812196,
                36.3616678
              ],
              [
                55.7991428,
                36.3552716
              ],
              [
                55.791279,
                36.3451973
              ],
              [
                55.7901657,
                36.3440894
              ],
              [
                55.7846091,
                36.3388111
              ],
              [
                55.7651659,
                36.3227063
              ],
              [
                55.7415528,
                36.3018723
              ],
              [
                55.7337763,
                36.2940987
              ],
              [
                55.7284963,
                36.2863251
              ],
              [
                55.7232198,
                36.2796595
              ],
              [
                55.6820407,
                36.2464035
              ],
              [
                55.6453746,
                36.2244538
              ],
              [
                55.6434278,
                36.2233365
              ],
              [
                55.6156316,
                36.2208225
              ],
              [
                55.6147983,
                36.2205432
              ],
              [
                55.5970185,
                36.2149929
              ],
              [
                55.534499,
                36.1975138
              ],
              [
                55.5336658,
                36.1972344
              ],
              [
                55.5300559,
                36.1972344
              ],
              [
                55.5294993,
                36.196955
              ],
              [
                55.5278326,
                36.196955
              ],
              [
                55.5264426,
                36.1966757
              ],
              [
                55.5228327,
                36.1966758
              ],
              [
                55.5206093,
                36.1964054
              ],
              [
                55.5192227,
                36.1961171
              ],
              [
                55.518875,
                36.1960289
              ],
              [
                55.5188244,
                36.196016
              ],
              [
                55.5017195,
                36.1916745
              ],
              [
                55.4933863,
                36.1933416
              ],
              [
                55.4892197,
                36.1947293
              ],
              [
                55.4844963,
                36.1961171
              ],
              [
                55.4833864,
                36.1961171
              ],
              [
                55.4572734,
                36.2039027
              ],
              [
                55.430607,
                36.2100122
              ],
              [
                55.4289404,
                36.2100121
              ],
              [
                55.4264404,
                36.2105708
              ],
              [
                55.4250504,
                36.2105709
              ],
              [
                55.4175505,
                36.212238
              ],
              [
                55.4161606,
                36.2122379
              ],
              [
                55.4156073,
                36.2125173
              ],
              [
                55.4108839,
                36.2133463
              ],
              [
                55.3894942,
                36.2200144
              ],
              [
                55.3303382,
                36.2736022
              ],
              [
                55.3300616,
                36.2738815
              ],
              [
                55.3295049,
                36.2744311
              ],
              [
                55.3292282,
                36.2747104
              ],
              [
                55.3275616,
                36.2761068
              ],
              [
                55.327005,
                36.2766564
              ],
              [
                55.3206184,
                36.2836027
              ],
              [
                55.3122817,
                36.2991619
              ],
              [
                55.3108952,
                36.3086035
              ],
              [
                55.3111718,
                36.3091621
              ],
              [
                55.3147818,
                36.3260992
              ],
              [
                55.315895,
                36.3302704
              ],
              [
                55.3486749,
                36.4030504
              ],
              [
                55.3567313,
                36.4172201
              ],
              [
                55.3556616,
                36.4236428
              ],
              [
                55.3587182,
                36.4314261
              ],
              [
                55.3595516,
                36.4330928
              ],
              [
                55.3601082,
                36.433372
              ],
              [
                55.3612182,
                36.4355881
              ],
              [
                55.3614948,
                36.4358673
              ],
              [
                55.3617748,
                36.4369844
              ],
              [
                55.3623282,
                36.4369844
              ],
              [
                55.3653847,
                36.436426
              ],
              [
                55.367608,
                36.436426
              ],
              [
                55.4115008,
                36.4330835
              ],
              [
                55.4137242,
                36.4330836
              ],
              [
                55.4267806,
                36.4311287
              ],
              [
                55.4345572,
                36.4302999
              ],
              [
                55.4398372,
                36.4302999
              ],
              [
                55.4406705,
                36.4300207
              ],
              [
                55.4483005,
                36.4261534
              ],
              [
                55.4499671,
                36.425874
              ],
              [
                55.4538571,
                36.425874
              ],
              [
                55.4569137,
                36.4253245
              ],
              [
                55.458857,
                36.4253246
              ],
              [
                55.4613569,
                36.4247659
              ],
              [
                55.4630236,
                36.424766
              ],
              [
                55.4791368,
                36.4219912
              ],
              [
                55.4816367,
                36.4217119
              ],
              [
                55.4819134,
                36.4214326
              ],
              [
                55.4833034,
                36.4214326
              ],
              [
                55.48358,
                36.4211533
              ],
              [
                55.48469,
                36.4211534
              ],
              [
                55.4852467,
                36.4208742
              ],
              [
                55.4966365,
                36.4180993
              ],
              [
                55.526316,
                36.428354
              ],
              [
                55.5575725,
                36.4466666
              ],
              [
                55.601742,
                36.4672289
              ],
              [
                55.605352,
                36.4691746
              ],
              [
                55.638158,
                36.4827712
              ],
              [
                55.6542378,
                36.4939138
              ],
              [
                55.6564911,
                36.5113866
              ],
              [
                55.6564911,
                36.5147192
              ],
              [
                55.6450649,
                36.5719667
              ],
              [
                55.6458982,
                36.580577
              ],
              [
                55.6458663,
                36.5820939
              ],
              [
                55.6384084,
                36.5963871
              ],
              [
                55.6347984,
                36.6355531
              ],
              [
                55.6374816,
                36.6442877
              ],
              [
                55.637205,
                36.644567
              ],
              [
                55.635815,
                36.6487373
              ],
              [
                55.6335484,
                36.6522425
              ],
              [
                55.6297051,
                36.6581855
              ],
              [
                55.6277583,
                36.6601309
              ],
              [
                55.6274817,
                36.6606892
              ],
              [
                55.5718227,
                36.69423
              ],
              [
                55.5634893,
                36.6997864
              ],
              [
                55.5526527,
                36.7089538
              ],
              [
                55.5437765,
                36.7307157
              ],
              [
                55.5429431,
                36.7323813
              ],
              [
                55.5288797,
                36.7660327
              ],
              [
                55.5192033,
                36.7794276
              ],
              [
                55.5175366,
                36.7819315
              ],
              [
                55.51587,
                36.7844262
              ],
              [
                55.5150368,
                36.7905415
              ],
              [
                55.5153132,
                36.7908207
              ],
              [
                55.5339265,
                36.8086078
              ],
              [
                55.5344832,
                36.8086079
              ],
              [
                55.5527113,
                36.8183552
              ],
              [
                55.5680057,
                36.8332083
              ],
              [
                55.5721723,
                36.8373866
              ],
              [
                55.5749991,
                36.8583965
              ],
              [
                55.5691574,
                36.8711017
              ],
              [
                55.5525223,
                36.9166124
              ],
              [
                55.5511324,
                36.9171704
              ],
              [
                55.5508557,
                36.9177195
              ],
              [
                55.5494657,
                36.9182774
              ],
              [
                55.548357,
                36.9193923
              ],
              [
                55.5472424,
                36.9188355
              ],
              [
                55.5430758,
                36.9168915
              ],
              [
                55.5416891,
                36.9168915
              ],
              [
                55.5397425,
                36.9163334
              ],
              [
                55.50618,
                36.8994503
              ],
              [
                55.5000701,
                36.9011157
              ],
              [
                55.4706239,
                36.8772322
              ],
              [
                55.4164544,
                36.8277791
              ],
              [
                55.4128444,
                36.8252852
              ],
              [
                55.4008978,
                36.8169571
              ],
              [
                55.3736748,
                36.8105647
              ],
              [
                55.362285,
                36.8086199
              ],
              [
                55.3603416,
                36.80862
              ],
              [
                55.3595083,
                36.8083409
              ],
              [
                55.3542283,
                36.8077827
              ],
              [
                55.3245054,
                36.803614
              ],
              [
                55.3220055,
                36.8036141
              ],
              [
                55.3183956,
                36.8030648
              ],
              [
                55.3164487,
                36.8030648
              ],
              [
                55.2983922,
                36.8005618
              ],
              [
                55.2967257,
                36.8000036
              ],
              [
                55.295339,
                36.8000036
              ],
              [
                55.2947823,
                36.7997245
              ],
              [
                55.2925589,
                36.7997245
              ],
              [
                55.2872823,
                36.7991753
              ],
              [
                55.2867258,
                36.7991753
              ],
              [
                55.2845059,
                36.7986171
              ],
              [
                55.2820058,
                36.798617
              ],
              [
                55.2811725,
                36.798338
              ],
              [
                55.273116,
                36.798338
              ],
              [
                55.2728359,
                36.7980589
              ],
              [
                55.2683926,
                36.7955648
              ],
              [
                55.2661693,
                36.7947275
              ],
              [
                55.2542261,
                36.7922245
              ],
              [
                55.231723,
                36.7894513
              ],
              [
                55.229223,
                36.7894514
              ],
              [
                55.2281131,
                36.7891722
              ],
              [
                55.2258898,
                36.7891723
              ],
              [
                55.2233898,
                36.7888932
              ],
              [
                55.2197798,
                36.7888931
              ],
              [
                55.2172799,
                36.788614
              ],
              [
                55.2075566,
                36.788614
              ],
              [
                55.1986668,
                36.7877857
              ],
              [
                55.1945001,
                36.7877857
              ],
              [
                55.1906102,
                36.7872275
              ],
              [
                55.1878336,
                36.7872274
              ],
              [
                55.1806102,
                36.7866692
              ],
              [
                55.1553305,
                36.7855618
              ],
              [
                55.1417208,
                36.7841753
              ],
              [
                55.1386642,
                36.7841752
              ],
              [
                55.1372741,
                36.7838961
              ],
              [
                55.1317209,
                36.7838961
              ],
              [
                55.1311642,
                36.783617
              ],
              [
                55.1303308,
                36.783617
              ],
              [
                55.1297741,
                36.7833379
              ],
              [
                55.1281075,
                36.7833379
              ],
              [
                55.1278309,
                36.7830587
              ],
              [
                55.1219976,
                36.781123
              ],
              [
                55.1161643,
                36.781123
              ],
              [
                55.115331,
                36.7811229
              ],
              [
                55.1125511,
                36.7811229
              ],
              [
                55.1111644,
                36.7811229
              ],
              [
                55.1097745,
                36.7808438
              ],
              [
                55.1069943,
                36.7808439
              ],
              [
                55.0956079,
                36.778899
              ],
              [
                55.0908846,
                36.7775034
              ],
              [
                55.084218,
                36.7769542
              ],
              [
                55.0808847,
                36.7769542
              ],
              [
                55.079218,
                36.776675
              ],
              [
                55.0761615,
                36.7766751
              ],
              [
                55.072828,
                36.7763959
              ],
              [
                55.0667149,
                36.776396
              ],
              [
                55.0656049,
                36.7761168
              ],
              [
                55.0619949,
                36.7761168
              ],
              [
                55.0611616,
                36.7758377
              ],
              [
                55.0583817,
                36.7758377
              ],
              [
                55.0575483,
                36.7755586
              ],
              [
                55.0561617,
                36.7755586
              ],
              [
                55.0525483,
                36.7750094
              ],
              [
                55.0500485,
                36.7750094
              ],
              [
                55.0406052,
                36.7733347
              ],
              [
                55.0383819,
                36.7733347
              ],
              [
                55.0375485,
                36.7730645
              ],
              [
                55.0100454,
                36.767221
              ],
              [
                55.0014356,
                36.7641687
              ],
              [
                54.9872691,
                36.7547233
              ],
              [
                54.9806026,
                36.7472319
              ],
              [
                54.9769892,
                36.7422255
              ],
              [
                54.9589327,
                36.7183369
              ],
              [
                54.9478228,
                36.7058384
              ],
              [
                54.9478227,
                36.7055593
              ],
              [
                54.9475428,
                36.7052802
              ],
              [
                54.9472661,
                36.7050009
              ],
              [
                54.9472661,
                36.7047219
              ],
              [
                54.923653,
                36.6766626
              ],
              [
                54.9228197,
                36.6750057
              ],
              [
                54.9122631,
                36.6644427
              ],
              [
                54.8598237,
                36.6377129
              ],
              [
                54.842324,
                36.6304911
              ],
              [
                54.8378773,
                36.6291045
              ],
              [
                54.8231499,
                36.6100166
              ],
              [
                54.7889245,
                36.6027817
              ],
              [
                54.7780913,
                36.6002781
              ],
              [
                54.7678114,
                36.6002781
              ],
              [
                54.7669781,
                36.6005573
              ],
              [
                54.7655915,
                36.6005573
              ],
              [
                54.7642015,
                36.6008365
              ],
              [
                54.7617015,
                36.6008365
              ],
              [
                54.7550349,
                36.6019442
              ],
              [
                54.747255,
                36.6041687
              ],
              [
                54.7253119,
                36.6158312
              ],
              [
                54.7219787,
                36.6175062
              ],
              [
                54.7008655,
                36.6325007
              ],
              [
                54.6994755,
                36.6316631
              ],
              [
                54.6911422,
                36.6294478
              ],
              [
                54.690309,
                36.6288895
              ],
              [
                54.6894756,
                36.6288894
              ],
              [
                54.686419,
                36.6277817
              ],
              [
                54.685309,
                36.6277817
              ],
              [
                54.6755857,
                36.6252782
              ],
              [
                54.6662316,
                36.6252218
              ],
              [
                54.6620898,
                36.6243932
              ],
              [
                54.6587123,
                36.6232821
              ],
              [
                54.6567691,
                36.6227237
              ],
              [
                54.6448226,
                36.612449
              ],
              [
                54.6437125,
                36.610783
              ],
              [
                54.630216,
                36.5828156
              ],
              [
                54.6271593,
                36.5797623
              ],
              [
                54.6099469,
                36.5728027
              ],
              [
                54.5776745,
                36.5739056
              ],
              [
                54.5745846,
                36.5595669
              ],
              [
                54.5714947,
                36.5303298
              ],
              [
                54.5578139,
                36.5232048
              ],
              [
                54.5572145,
                36.5229677
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555218,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مهدی شهر",
          "name:en": "Mehdishahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610757",
          "wikipedia": "en:Mehdishahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.0174514,
                35.8535946
              ],
              [
                53.018008,
                35.8530357
              ],
              [
                53.0202313,
                35.8516477
              ],
              [
                53.021898,
                35.8499801
              ],
              [
                53.0221746,
                35.8491508
              ],
              [
                53.0221746,
                35.8483126
              ],
              [
                53.0221745,
                35.8480331
              ],
              [
                53.0216179,
                35.8449774
              ],
              [
                53.0205078,
                35.8355399
              ],
              [
                53.0318978,
                35.8266521
              ],
              [
                53.0330078,
                35.8263727
              ],
              [
                53.0410644,
                35.8221993
              ],
              [
                53.0471743,
                35.8199818
              ],
              [
                53.0485643,
                35.8199818
              ],
              [
                53.0499543,
                35.8197024
              ],
              [
                53.0566209,
                35.8191436
              ],
              [
                53.0580109,
                35.819432
              ],
              [
                53.0585641,
                35.8191435
              ],
              [
                53.0602307,
                35.8194319
              ],
              [
                53.0652308,
                35.819432
              ],
              [
                53.0657875,
                35.8191435
              ],
              [
                53.0766207,
                35.8183142
              ],
              [
                53.0807873,
                35.8183142
              ],
              [
                53.0816206,
                35.8180348
              ],
              [
                53.0830106,
                35.8183142
              ],
              [
                53.0846771,
                35.8185937
              ],
              [
                53.0855106,
                35.8185937
              ],
              [
                53.0891205,
                35.8191436
              ],
              [
                53.0913438,
                35.8191435
              ],
              [
                53.0938437,
                35.8197024
              ],
              [
                53.0971771,
                35.8197024
              ],
              [
                53.0980104,
                35.8199818
              ],
              [
                53.1052337,
                35.8199818
              ],
              [
                53.107457,
                35.8202523
              ],
              [
                53.1180136,
                35.8202523
              ],
              [
                53.1199568,
                35.8205407
              ],
              [
                53.1285701,
                35.8205406
              ],
              [
                53.1394032,
                35.8180348
              ],
              [
                53.1399566,
                35.8183142
              ],
              [
                53.1410699,
                35.8177554
              ],
              [
                53.1532932,
                35.8113644
              ],
              [
                53.1560697,
                35.8077587
              ],
              [
                53.1566264,
                35.8055322
              ],
              [
                53.1563464,
                35.8052618
              ],
              [
                53.1569031,
                35.8038645
              ],
              [
                53.1560698,
                35.7960943
              ],
              [
                53.1546798,
                35.7941472
              ],
              [
                53.1527365,
                35.7919297
              ],
              [
                53.1482932,
                35.7894237
              ],
              [
                53.1469033,
                35.7888739
              ],
              [
                53.13329,
                35.7847001
              ],
              [
                53.1099569,
                35.772756
              ],
              [
                53.0969005,
                35.7555382
              ],
              [
                53.0944005,
                35.7499851
              ],
              [
                53.0938438,
                35.7496967
              ],
              [
                53.0932904,
                35.7488673
              ],
              [
                53.0880105,
                35.744982
              ],
              [
                53.0655109,
                35.7349755
              ],
              [
                53.0649541,
                35.7347051
              ],
              [
                53.0626664,
                35.7333319
              ],
              [
                53.0649542,
                35.7324784
              ],
              [
                53.080234,
                35.7255279
              ],
              [
                53.0810673,
                35.7255279
              ],
              [
                53.1307901,
                35.7122038
              ],
              [
                53.1316234,
                35.7116449
              ],
              [
                53.1496798,
                35.7066415
              ],
              [
                53.1505131,
                35.7060917
              ],
              [
                53.1571798,
                35.7035854
              ],
              [
                53.1577364,
                35.7030265
              ],
              [
                53.161903,
                35.7005293
              ],
              [
                53.1627364,
                35.7005293
              ],
              [
                53.165513,
                35.6985911
              ],
              [
                53.1774596,
                35.6924788
              ],
              [
                53.1860728,
                35.6883047
              ],
              [
                53.1880161,
                35.6871958
              ],
              [
                53.2102392,
                35.6749801
              ],
              [
                53.2207957,
                35.6683087
              ],
              [
                53.2335722,
                35.6574811
              ],
              [
                53.2944083,
                35.6233116
              ],
              [
                53.3016314,
                35.6191373
              ],
              [
                53.3024648,
                35.6188668
              ],
              [
                53.3052448,
                35.6171989
              ],
              [
                53.3210779,
                35.6085887
              ],
              [
                53.322468,
                35.6072003
              ],
              [
                53.3230212,
                35.6072002
              ],
              [
                53.3372026,
                35.5976481
              ],
              [
                53.3445476,
                35.6116726
              ],
              [
                53.3449677,
                35.6124746
              ],
              [
                53.3474676,
                35.6252501
              ],
              [
                53.347191,
                35.6255296
              ],
              [
                53.3474676,
                35.626368
              ],
              [
                53.3480243,
                35.6277565
              ],
              [
                53.3496909,
                35.6305334
              ],
              [
                53.3546909,
                35.6344191
              ],
              [
                53.3791372,
                35.6599784
              ],
              [
                53.3935803,
                35.6963644
              ],
              [
                53.3946937,
                35.7002589
              ],
              [
                53.3958036,
                35.7033151
              ],
              [
                53.4085801,
                35.718866
              ],
              [
                53.4152502,
                35.7227515
              ],
              [
                53.4155267,
                35.7233104
              ],
              [
                53.4352499,
                35.7335874
              ],
              [
                53.4360832,
                35.7344258
              ],
              [
                53.4433064,
                35.7380317
              ],
              [
                53.4533063,
                35.742476
              ],
              [
                53.4583063,
                35.7444231
              ],
              [
                53.4835859,
                35.7533117
              ],
              [
                53.4844194,
                35.7538706
              ],
              [
                53.4927526,
                35.7560882
              ],
              [
                53.4935858,
                35.7566471
              ],
              [
                53.4974758,
                35.7577559
              ],
              [
                53.5116423,
                35.7602529
              ],
              [
                53.5124756,
                35.7605324
              ],
              [
                53.5196989,
                35.7605324
              ],
              [
                53.5205322,
                35.7608118
              ],
              [
                53.5219188,
                35.7608119
              ],
              [
                53.5374754,
                35.7694208
              ],
              [
                53.5388653,
                35.7699797
              ],
              [
                53.543032,
                35.7724857
              ],
              [
                53.5535885,
                35.7797063
              ],
              [
                53.5888681,
                35.8183144
              ],
              [
                53.5897013,
                35.8199819
              ],
              [
                53.5910914,
                35.8266523
              ],
              [
                53.5838682,
                35.8349812
              ],
              [
                53.5833114,
                35.8358105
              ],
              [
                53.5824781,
                35.8363693
              ],
              [
                53.5802548,
                35.8388662
              ],
              [
                53.5704584,
                35.848031
              ],
              [
                53.5674782,
                35.8508185
              ],
              [
                53.5666449,
                35.8522067
              ],
              [
                53.5674783,
                35.8588768
              ],
              [
                53.5733116,
                35.8691433
              ],
              [
                53.6191477,
                35.9113711
              ],
              [
                53.6255376,
                35.9163734
              ],
              [
                53.6785936,
                35.9624836
              ],
              [
                53.7047067,
                35.9830413
              ],
              [
                53.7060189,
                35.9914912
              ],
              [
                53.7028569,
                35.9994237
              ],
              [
                53.7075658,
                36.0063092
              ],
              [
                53.710941,
                36.0124106
              ],
              [
                53.7180066,
                36.020332
              ],
              [
                53.7216033,
                36.0246379
              ],
              [
                53.7316417,
                36.0330671
              ],
              [
                53.741063,
                36.0390786
              ],
              [
                53.7504386,
                36.0449352
              ],
              [
                53.7567901,
                36.0461844
              ],
              [
                53.7617683,
                36.0493072
              ],
              [
                53.7666002,
                36.0507525
              ],
              [
                53.7702659,
                36.0538715
              ],
              [
                53.7737846,
                36.0558301
              ],
              [
                53.7793635,
                36.0594382
              ],
              [
                53.7892081,
                36.0649865
              ],
              [
                53.7982493,
                36.0725881
              ],
              [
                53.7993831,
                36.0744304
              ],
              [
                53.80313,
                36.0776881
              ],
              [
                53.8028193,
                36.0813918
              ],
              [
                53.7994565,
                36.0845768
              ],
              [
                53.7981605,
                36.0850722
              ],
              [
                53.7920298,
                36.0852359
              ],
              [
                53.7882915,
                36.0846443
              ],
              [
                53.7844829,
                36.0858235
              ],
              [
                53.7827968,
                36.0869797
              ],
              [
                53.7813251,
                36.0913049
              ],
              [
                53.7838727,
                36.0947034
              ],
              [
                53.7966365,
                36.1017792
              ],
              [
                53.8048645,
                36.106566
              ],
              [
                53.8136271,
                36.1053917
              ],
              [
                53.8187128,
                36.105267
              ],
              [
                53.8250643,
                36.1063754
              ],
              [
                53.8279599,
                36.1080345
              ],
              [
                53.8309449,
                36.1119303
              ],
              [
                53.834378,
                36.1154706
              ],
              [
                53.8417019,
                36.1188786
              ],
              [
                53.8495351,
                36.1211318
              ],
              [
                53.8440799,
                36.1245648
              ],
              [
                53.832836,
                36.135934
              ],
              [
                53.8196181,
                36.144529
              ],
              [
                53.8022449,
                36.1601574
              ],
              [
                53.7906518,
                36.1531735
              ],
              [
                53.7859473,
                36.1490848
              ],
              [
                53.7765443,
                36.1451998
              ],
              [
                53.7666842,
                36.1424764
              ],
              [
                53.7613953,
                36.1399947
              ],
              [
                53.7556811,
                36.138895
              ],
              [
                53.7466851,
                36.1355286
              ],
              [
                53.7353324,
                36.1325372
              ],
              [
                53.7306749,
                36.1298444
              ],
              [
                53.7258362,
                36.1259769
              ],
              [
                53.7198227,
                36.1238228
              ],
              [
                53.7030601,
                36.118741
              ],
              [
                53.6767959,
                36.1142342
              ],
              [
                53.6590289,
                36.1065373
              ],
              [
                53.6523189,
                36.1006872
              ],
              [
                53.6506688,
                36.0970745
              ],
              [
                53.6458267,
                36.0914855
              ],
              [
                53.6401325,
                36.0886239
              ],
              [
                53.6390791,
                36.0885863
              ],
              [
                53.6377863,
                36.0887792
              ],
              [
                53.6364513,
                36.0888897
              ],
              [
                53.6348499,
                36.0889227
              ],
              [
                53.6336699,
                36.0888969
              ],
              [
                53.6321954,
                36.0886769
              ],
              [
                53.6298915,
                36.0884549
              ],
              [
                53.6278828,
                36.0884044
              ],
              [
                53.6264086,
                36.0879432
              ],
              [
                53.6252721,
                36.0873463
              ],
              [
                53.6228969,
                36.0876507
              ],
              [
                53.6225742,
                36.0877664
              ],
              [
                53.6216322,
                36.0881042
              ],
              [
                53.6196501,
                36.0885825
              ],
              [
                53.6175005,
                36.0889314
              ],
              [
                53.6148016,
                36.0896911
              ],
              [
                53.6147427,
                36.0896842
              ],
              [
                53.6137203,
                36.0895638
              ],
              [
                53.6124856,
                36.0887255
              ],
              [
                53.6106327,
                36.0879322
              ],
              [
                53.608751,
                36.0875045
              ],
              [
                53.6066446,
                36.0871223
              ],
              [
                53.6046504,
                36.0869246
              ],
              [
                53.6029358,
                36.0870813
              ],
              [
                53.6013489,
                36.0870887
              ],
              [
                53.5977505,
                36.0877436
              ],
              [
                53.5955166,
                36.0879566
              ],
              [
                53.5934928,
                36.0882933
              ],
              [
                53.5913845,
                36.0888031
              ],
              [
                53.5897678,
                36.0892797
              ],
              [
                53.5884188,
                36.0895184
              ],
              [
                53.586312,
                36.0892733
              ],
              [
                53.5843456,
                36.0889485
              ],
              [
                53.582323,
                36.0888163
              ],
              [
                53.5799771,
                36.0887069
              ],
              [
                53.5763521,
                36.0888931
              ],
              [
                53.5745684,
                36.088785
              ],
              [
                53.5722084,
                36.0887343
              ],
              [
                53.5704108,
                36.0884102
              ],
              [
                53.5684595,
                36.0879924
              ],
              [
                53.5666194,
                36.0878155
              ],
              [
                53.5651298,
                36.0880412
              ],
              [
                53.5638787,
                36.0883474
              ],
              [
                53.5625012,
                36.088458
              ],
              [
                53.5580204,
                36.088218
              ],
              [
                53.554565,
                36.0879448
              ],
              [
                53.552921,
                36.0880542
              ],
              [
                53.5511934,
                36.0880505
              ],
              [
                53.550016,
                36.0870278
              ],
              [
                53.5470294,
                36.0848921
              ],
              [
                53.5454312,
                36.0839054
              ],
              [
                53.5438866,
                36.0835236
              ],
              [
                53.5418936,
                36.0831175
              ],
              [
                53.5405454,
                36.0829523
              ],
              [
                53.5390276,
                36.0829935
              ],
              [
                53.5373424,
                36.0829436
              ],
              [
                53.5360227,
                36.0825615
              ],
              [
                53.5349712,
                36.0819754
              ],
              [
                53.5334578,
                36.080554
              ],
              [
                53.5323226,
                36.0798637
              ],
              [
                53.5303713,
                36.079434
              ],
              [
                53.5278863,
                36.0787857
              ],
              [
                53.5268202,
                36.0783035
              ],
              [
                53.5253344,
                36.0773254
              ],
              [
                53.5240162,
                36.0767042
              ],
              [
                53.5230195,
                36.0763917
              ],
              [
                53.5191989,
                36.0764609
              ],
              [
                53.5173718,
                36.0768102
              ],
              [
                53.5162474,
                36.0769105
              ],
              [
                53.5157293,
                36.0764617
              ],
              [
                53.5133597,
                36.0750941
              ],
              [
                53.5119419,
                36.074849
              ],
              [
                53.5098776,
                36.0745925
              ],
              [
                53.5076179,
                36.074036
              ],
              [
                53.5033262,
                36.0721564
              ],
              [
                53.5020919,
                36.0715467
              ],
              [
                53.500717,
                36.0711203
              ],
              [
                53.4990026,
                36.0711268
              ],
              [
                53.498526,
                36.0710849
              ],
              [
                53.4975455,
                36.0714997
              ],
              [
                53.4965134,
                36.0717555
              ],
              [
                53.4953071,
                36.0722268
              ],
              [
                53.4942895,
                36.0729848
              ],
              [
                53.4922456,
                36.0748187
              ],
              [
                53.4914197,
                36.075762
              ],
              [
                53.4909191,
                36.0766107
              ],
              [
                53.4901085,
                36.0775086
              ],
              [
                53.4893201,
                36.0780995
              ],
              [
                53.4885817,
                36.0784056
              ],
              [
                53.4866772,
                36.0787042
              ],
              [
                53.4828351,
                36.0789574
              ],
              [
                53.4809439,
                36.0787758
              ],
              [
                53.4780592,
                36.0778936
              ],
              [
                53.4773561,
                36.0774034
              ],
              [
                53.476712,
                36.0768219
              ],
              [
                53.4758662,
                36.0764067
              ],
              [
                53.4743359,
                36.0758457
              ],
              [
                53.4734714,
                36.0750772
              ],
              [
                53.4724618,
                36.0745009
              ],
              [
                53.4713296,
                36.0742877
              ],
              [
                53.4700321,
                36.0744699
              ],
              [
                53.4685118,
                36.0746049
              ],
              [
                53.4673047,
                36.0745712
              ],
              [
                53.4648097,
                36.074893
              ],
              [
                53.461092,
                36.0747035
              ],
              [
                53.4579124,
                36.0748995
              ],
              [
                53.4568859,
                36.0754523
              ],
              [
                53.4559759,
                36.0763588
              ],
              [
                53.4549891,
                36.0770032
              ],
              [
                53.4538792,
                36.0775307
              ],
              [
                53.4522649,
                36.0774804
              ],
              [
                53.4485929,
                36.0771769
              ],
              [
                53.4480186,
                36.0773525
              ],
              [
                53.447085,
                36.077399
              ],
              [
                53.4442405,
                36.0773102
              ],
              [
                53.4425107,
                36.0770685
              ],
              [
                53.4415977,
                36.077078
              ],
              [
                53.4400225,
                36.0768302
              ],
              [
                53.4387853,
                36.0765455
              ],
              [
                53.4375008,
                36.0763844
              ],
              [
                53.4367259,
                36.0761231
              ],
              [
                53.4358428,
                36.0761114
              ],
              [
                53.4305672,
                36.0771359
              ],
              [
                53.427861,
                36.0763974
              ],
              [
                53.4266345,
                36.0762061
              ],
              [
                53.4236164,
                36.0762265
              ],
              [
                53.4189566,
                36.0772894
              ],
              [
                53.417354,
                36.0773711
              ],
              [
                53.4123718,
                36.0761522
              ],
              [
                53.4094107,
                36.0745566
              ],
              [
                53.4050333,
                36.0722499
              ],
              [
                53.3936178,
                36.0674282
              ],
              [
                53.3857858,
                36.0643408
              ],
              [
                53.383404,
                36.0630919
              ],
              [
                53.3788335,
                36.0623287
              ],
              [
                53.3773409,
                36.0617712
              ],
              [
                53.3754432,
                36.0610625
              ],
              [
                53.3688771,
                36.058634
              ],
              [
                53.3648431,
                36.0566738
              ],
              [
                53.3592641,
                36.0568299
              ],
              [
                53.3558952,
                36.0550431
              ],
              [
                53.3536851,
                36.0539849
              ],
              [
                53.349694,
                36.050151
              ],
              [
                53.3483153,
                36.0493307
              ],
              [
                53.3469005,
                36.0484889
              ],
              [
                53.3447372,
                36.0472017
              ],
              [
                53.3407461,
                36.0449462
              ],
              [
                53.3373773,
                36.0438185
              ],
              [
                53.3352744,
                36.0415283
              ],
              [
                53.3326566,
                36.040574
              ],
              [
                53.32785,
                36.037017
              ],
              [
                53.3262193,
                36.0354901
              ],
              [
                53.3246529,
                36.0338763
              ],
              [
                53.323065,
                36.0312908
              ],
              [
                53.3173358,
                36.0292084
              ],
              [
                53.313173,
                36.0263625
              ],
              [
                53.3100831,
                36.0241759
              ],
              [
                53.308345,
                36.0216942
              ],
              [
                53.2994615,
                36.0160189
              ],
              [
                53.2862865,
                36.0104474
              ],
              [
                53.2741543,
                36.0016722
              ],
              [
                53.2635751,
                35.9933154
              ],
              [
                53.2246855,
                35.9680443
              ],
              [
                53.2246856,
                35.9674855
              ],
              [
                53.2232955,
                35.9660976
              ],
              [
                53.223375,
                35.9655388
              ],
              [
                53.2235722,
                35.9641508
              ],
              [
                53.2246856,
                35.9591489
              ],
              [
                53.2249622,
                35.9580402
              ],
              [
                53.2455284,
                35.9316373
              ],
              [
                53.2458051,
                35.9310874
              ],
              [
                53.2480283,
                35.923019
              ],
              [
                53.245805,
                35.9141301
              ],
              [
                53.2408051,
                35.9099652
              ],
              [
                53.2380251,
                35.9085768
              ],
              [
                53.2349719,
                35.9077474
              ],
              [
                53.2338585,
                35.9077473
              ],
              [
                53.2333052,
                35.907468
              ],
              [
                53.2321918,
                35.907468
              ],
              [
                53.2302486,
                35.9069091
              ],
              [
                53.2026988,
                35.9091427
              ],
              [
                53.1850458,
                35.9133158
              ],
              [
                53.1792126,
                35.9133159
              ],
              [
                53.1781025,
                35.9130274
              ],
              [
                53.1736559,
                35.9135863
              ],
              [
                53.170046,
                35.9135863
              ],
              [
                53.1678226,
                35.9138657
              ],
              [
                53.1644895,
                35.9138657
              ],
              [
                53.161156,
                35.9141452
              ],
              [
                53.1592128,
                35.9138657
              ],
              [
                53.1567129,
                35.9138658
              ],
              [
                53.1385699,
                35.9197082
              ],
              [
                53.1349565,
                35.9197082
              ],
              [
                53.1341232,
                35.9197082
              ],
              [
                53.1330134,
                35.9197082
              ],
              [
                53.1324566,
                35.9194288
              ],
              [
                53.1285701,
                35.9194288
              ],
              [
                53.1274566,
                35.9197082
              ],
              [
                53.1205134,
                35.9197082
              ],
              [
                53.1191234,
                35.9194288
              ],
              [
                53.1166235,
                35.9194287
              ],
              [
                53.1149568,
                35.9191494
              ],
              [
                53.1124569,
                35.9191493
              ],
              [
                53.108567,
                35.9188699
              ],
              [
                53.107457,
                35.9191494
              ],
              [
                53.1041237,
                35.91887
              ],
              [
                53.1032903,
                35.9191494
              ],
              [
                53.1019003,
                35.9191493
              ],
              [
                53.1015565,
                35.9190917
              ],
              [
                53.1002336,
                35.91887
              ],
              [
                53.097457,
                35.9188699
              ],
              [
                53.0938437,
                35.9183201
              ],
              [
                53.0905105,
                35.9183202
              ],
              [
                53.0874537,
                35.9177614
              ],
              [
                53.0844205,
                35.9177614
              ],
              [
                53.0780106,
                35.9177613
              ],
              [
                53.0763439,
                35.917482
              ],
              [
                53.0744006,
                35.917482
              ],
              [
                53.0649541,
                35.9149853
              ],
              [
                53.0504237,
                35.8905439
              ],
              [
                53.0465337,
                35.8855415
              ],
              [
                53.0482004,
                35.8794305
              ],
              [
                53.0484805,
                35.8785922
              ],
              [
                53.0482004,
                35.8713725
              ],
              [
                53.0470905,
                35.8677671
              ],
              [
                53.0174514,
                35.8535946
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555223,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میامی",
          "name:en": "Mayami County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q12016079"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.3300616,
                36.2738815
              ],
              [
                55.3303382,
                36.2736022
              ],
              [
                55.3894942,
                36.2200144
              ],
              [
                55.4108839,
                36.2133463
              ],
              [
                55.4156073,
                36.2125173
              ],
              [
                55.4161606,
                36.2122379
              ],
              [
                55.4175505,
                36.212238
              ],
              [
                55.4250504,
                36.2105709
              ],
              [
                55.4264404,
                36.2105708
              ],
              [
                55.4289404,
                36.2100121
              ],
              [
                55.430607,
                36.2100122
              ],
              [
                55.4572734,
                36.2039027
              ],
              [
                55.4833864,
                36.1961171
              ],
              [
                55.4844963,
                36.1961171
              ],
              [
                55.4892197,
                36.1947293
              ],
              [
                55.4933863,
                36.1933416
              ],
              [
                55.5017195,
                36.1916745
              ],
              [
                55.5188244,
                36.196016
              ],
              [
                55.518875,
                36.1960289
              ],
              [
                55.5192227,
                36.1961171
              ],
              [
                55.5206093,
                36.1964054
              ],
              [
                55.5228327,
                36.1966758
              ],
              [
                55.5264426,
                36.1966757
              ],
              [
                55.5278326,
                36.196955
              ],
              [
                55.5294993,
                36.196955
              ],
              [
                55.5300559,
                36.1972344
              ],
              [
                55.5336658,
                36.1972344
              ],
              [
                55.534499,
                36.1975138
              ],
              [
                55.5970185,
                36.2149929
              ],
              [
                55.6147983,
                36.2205432
              ],
              [
                55.6156316,
                36.2208225
              ],
              [
                55.6434278,
                36.2233365
              ],
              [
                55.6453746,
                36.2244538
              ],
              [
                55.6820407,
                36.2464035
              ],
              [
                55.7232198,
                36.2796595
              ],
              [
                55.7284963,
                36.2863251
              ],
              [
                55.7337763,
                36.2940987
              ],
              [
                55.7415528,
                36.3018723
              ],
              [
                55.7651659,
                36.3227063
              ],
              [
                55.7846091,
                36.3388111
              ],
              [
                55.7901657,
                36.3440894
              ],
              [
                55.791279,
                36.3451973
              ],
              [
                55.7991428,
                36.3552716
              ],
              [
                55.812196,
                36.3616678
              ],
              [
                55.814976,
                36.3624966
              ],
              [
                55.8163625,
                36.3624966
              ],
              [
                55.8177526,
                36.3627758
              ],
              [
                55.8242526,
                36.3647195
              ],
              [
                55.8281428,
                36.3647196
              ],
              [
                55.828976,
                36.3649989
              ],
              [
                55.8306426,
                36.3647195
              ],
              [
                55.8331427,
                36.3647195
              ],
              [
                55.8481425,
                36.3622152
              ],
              [
                55.8528658,
                36.3622151
              ],
              [
                55.8831653,
                36.3580706
              ],
              [
                55.8909418,
                36.3586203
              ],
              [
                55.8967786,
                36.3586203
              ],
              [
                55.8987217,
                36.3588996
              ],
              [
                55.9220548,
                36.3588996
              ],
              [
                55.934558,
                36.3583499
              ],
              [
                55.9362247,
                36.3583499
              ],
              [
                55.9395579,
                36.3580707
              ],
              [
                55.9445578,
                36.3580707
              ],
              [
                55.9476111,
                36.3577914
              ],
              [
                55.9509445,
                36.3577914
              ],
              [
                55.9523344,
                36.3575121
              ],
              [
                55.9553912,
                36.3575121
              ],
              [
                55.9667015,
                36.3570613
              ],
              [
                55.9697548,
                36.3570612
              ],
              [
                55.9714216,
                36.356782
              ],
              [
                55.9877773,
                36.3549418
              ],
              [
                55.9986106,
                36.3524373
              ],
              [
                56.0031506,
                36.3513776
              ],
              [
                56.0109274,
                36.348603
              ],
              [
                56.0597112,
                36.334048
              ],
              [
                56.0855475,
                36.3145963
              ],
              [
                56.0943725,
                36.3084714
              ],
              [
                56.1057624,
                36.305967
              ],
              [
                56.1082625,
                36.3059669
              ],
              [
                56.1102057,
                36.3059669
              ],
              [
                56.1132623,
                36.305967
              ],
              [
                56.1524906,
                36.3051514
              ],
              [
                56.1558239,
                36.3046018
              ],
              [
                56.1586041,
                36.3046018
              ],
              [
                56.1769371,
                36.3023764
              ],
              [
                56.1794372,
                36.3023763
              ],
              [
                56.1955503,
                36.3001509
              ],
              [
                56.1977702,
                36.3001509
              ],
              [
                56.2013836,
                36.2996013
              ],
              [
                56.2036069,
                36.2996013
              ],
              [
                56.2047168,
                36.299313
              ],
              [
                56.2069401,
                36.299313
              ],
              [
                56.2127734,
                36.2987635
              ],
              [
                56.2161068,
                36.2987635
              ],
              [
                56.2183267,
                36.2984841
              ],
              [
                56.2211066,
                36.2984841
              ],
              [
                56.2230501,
                36.2982047
              ],
              [
                56.2272165,
                36.2982048
              ],
              [
                56.2288832,
                36.2979255
              ],
              [
                56.2397198,
                36.2976551
              ],
              [
                56.2422198,
                36.2979255
              ],
              [
                56.2458297,
                36.2979254
              ],
              [
                56.248263,
                36.2966829
              ],
              [
                56.2615995,
                36.2966829
              ],
              [
                56.2629862,
                36.2969622
              ],
              [
                56.2754895,
                36.2969622
              ],
              [
                56.2774327,
                36.2972415
              ],
              [
                56.2932689,
                36.2932371
              ],
              [
                56.2985457,
                36.2932371
              ],
              [
                56.2999354,
                36.2929486
              ],
              [
                56.302159,
                36.2929487
              ],
              [
                56.3476453,
                36.29154
              ],
              [
                56.3495885,
                36.2909813
              ],
              [
                56.350702,
                36.2909813
              ],
              [
                56.3807017,
                36.2877808
              ],
              [
                56.3901553,
                36.2879244
              ],
              [
                56.4112663,
                36.2855721
              ],
              [
                56.4398794,
                36.2830672
              ],
              [
                56.4445993,
                36.2830673
              ],
              [
                56.4445992,
                36.282788
              ],
              [
                56.4443227,
                36.2816797
              ],
              [
                56.4377627,
                36.2718744
              ],
              [
                56.4362964,
                36.2707238
              ],
              [
                56.4357299,
                36.2699765
              ],
              [
                56.4360131,
                36.2678589
              ],
              [
                56.4359526,
                36.2662827
              ],
              [
                56.4359815,
                36.2647005
              ],
              [
                56.4361886,
                36.2633242
              ],
              [
                56.4363463,
                36.2623129
              ],
              [
                56.435974,
                36.261594
              ],
              [
                56.4354666,
                36.2607904
              ],
              [
                56.4346726,
                36.2603578
              ],
              [
                56.4344291,
                36.2580644
              ],
              [
                56.4343003,
                36.2568359
              ],
              [
                56.4334849,
                36.2547941
              ],
              [
                56.4339785,
                36.2539982
              ],
              [
                56.4343218,
                36.2529945
              ],
              [
                56.4340289,
                36.2520004
              ],
              [
                56.4344581,
                36.2509276
              ],
              [
                56.434973,
                36.2489549
              ],
              [
                56.435016,
                36.2474667
              ],
              [
                56.4342574,
                36.2463669
              ],
              [
                56.4319475,
                36.2441267
              ],
              [
                56.4306096,
                36.2422309
              ],
              [
                56.4291366,
                36.241202
              ],
              [
                56.4283995,
                36.2399118
              ],
              [
                56.4266829,
                36.2383888
              ],
              [
                56.4244084,
                36.23581
              ],
              [
                56.4213184,
                36.2339062
              ],
              [
                56.4188508,
                36.2316042
              ],
              [
                56.4184217,
                36.230583
              ],
              [
                56.4185719,
                36.2290252
              ],
              [
                56.4193229,
                36.2270519
              ],
              [
                56.4204387,
                36.2260133
              ],
              [
                56.421533,
                36.2246978
              ],
              [
                56.4227776,
                36.2218762
              ],
              [
                56.4221124,
                36.2203182
              ],
              [
                56.4209108,
                36.2187256
              ],
              [
                56.4201812,
                36.2174965
              ],
              [
                56.419795,
                36.216579
              ],
              [
                56.4196233,
                36.2157307
              ],
              [
                56.420296,
                36.2143206
              ],
              [
                56.4206103,
                36.2137917
              ],
              [
                56.4205031,
                36.2130646
              ],
              [
                56.4194945,
                36.208996
              ],
              [
                56.4182071,
                36.2060873
              ],
              [
                56.4178208,
                36.2043385
              ],
              [
                56.4168982,
                36.2013258
              ],
              [
                56.4174132,
                36.1987631
              ],
              [
                56.4194302,
                36.1945725
              ],
              [
                56.4200954,
                36.1930833
              ],
              [
                56.4204172,
                36.1914208
              ],
              [
                56.4201812,
                36.1884076
              ],
              [
                56.4191941,
                36.1865199
              ],
              [
                56.4192371,
                36.1848746
              ],
              [
                56.4204601,
                36.1818264
              ],
              [
                56.4204816,
                36.175799
              ],
              [
                56.4212755,
                36.1750715
              ],
              [
                56.4224986,
                36.1750888
              ],
              [
                56.4235286,
                36.1747251
              ],
              [
                56.4241723,
                36.1742747
              ],
              [
                56.4247088,
                36.1737205
              ],
              [
                56.425846,
                36.1732528
              ],
              [
                56.426876,
                36.1735819
              ],
              [
                56.4276699,
                36.173478
              ],
              [
                56.4286999,
                36.1729237
              ],
              [
                56.4298801,
                36.171971
              ],
              [
                56.4306096,
                36.1718324
              ],
              [
                56.4314036,
                36.1717805
              ],
              [
                56.4320902,
                36.1710703
              ],
              [
                56.4331631,
                36.1700483
              ],
              [
                56.4342574,
                36.1685412
              ],
              [
                56.4342789,
                36.1674499
              ],
              [
                56.434236,
                36.1666704
              ],
              [
                56.4342145,
                36.1658216
              ],
              [
                56.4343647,
                36.165094
              ],
              [
                56.4344291,
                36.1645223
              ],
              [
                56.4345578,
                36.1639333
              ],
              [
                56.4350084,
                36.1635522
              ],
              [
                56.4357165,
                36.1632923
              ],
              [
                56.4362101,
                36.1631018
              ],
              [
                56.4370684,
                36.1636735
              ],
              [
                56.4379986,
                36.1641161
              ],
              [
                56.438785,
                36.1642798
              ],
              [
                56.4396218,
                36.164453
              ],
              [
                56.4400939,
                36.1641239
              ],
              [
                56.4403729,
                36.1633097
              ],
              [
                56.4406304,
                36.162686
              ],
              [
                56.4406518,
                36.1621663
              ],
              [
                56.4407315,
                36.161927
              ],
              [
                56.4409093,
                36.1618198
              ],
              [
                56.4400295,
                36.1616119
              ],
              [
                56.4387925,
                36.1607726
              ],
              [
                56.4385994,
                36.1591788
              ],
              [
                56.437548,
                36.157273
              ],
              [
                56.4376123,
                36.1565627
              ],
              [
                56.4384846,
                36.1551672
              ],
              [
                56.4392217,
                36.1533402
              ],
              [
                56.4396218,
                36.1516327
              ],
              [
                56.4397506,
                36.1510783
              ],
              [
                56.4402516,
                36.1498403
              ],
              [
                56.4409383,
                36.1489566
              ],
              [
                56.4412601,
                36.1482982
              ],
              [
                56.4410885,
                36.1475185
              ],
              [
                56.4406518,
                36.1470411
              ],
              [
                56.440051,
                36.1468332
              ],
              [
                56.4393075,
                36.1464962
              ],
              [
                56.4388708,
                36.1458629
              ],
              [
                56.43905,
                36.1452486
              ],
              [
                56.4393429,
                36.1445806
              ],
              [
                56.4407881,
                36.1425455
              ],
              [
                56.4417107,
                36.1403621
              ],
              [
                56.4425261,
                36.1387505
              ],
              [
                56.4440721,
                36.1412059
              ],
              [
                56.4462267,
                36.1426128
              ],
              [
                56.4523886,
                36.1502123
              ],
              [
                56.4580419,
                36.1627809
              ],
              [
                56.467765,
                36.1702875
              ],
              [
                56.468875,
                36.1705669
              ],
              [
                56.4730666,
                36.1741718
              ],
              [
                56.4739,
                36.1741718
              ],
              [
                56.4747332,
                36.1744511
              ],
              [
                56.4895866,
                36.1802814
              ],
              [
                56.4906965,
                36.1805609
              ],
              [
                56.4923631,
                36.1808312
              ],
              [
                56.4937532,
                36.1813898
              ],
              [
                56.4965299,
                36.1819396
              ],
              [
                56.4976432,
                36.1825073
              ],
              [
                56.5009765,
                36.1830568
              ],
              [
                56.5068098,
                36.1830568
              ],
              [
                56.507643,
                36.1827775
              ],
              [
                56.5112531,
                36.1827776
              ],
              [
                56.5362163,
                36.1693217
              ],
              [
                56.5364963,
                36.169601
              ],
              [
                56.5376063,
                36.1693217
              ],
              [
                56.5389962,
                36.169601
              ],
              [
                56.5486644,
                36.1761139
              ],
              [
                56.5692208,
                36.1776444
              ],
              [
                56.5964471,
                36.1755791
              ],
              [
                56.6008936,
                36.175579
              ],
              [
                56.6020037,
                36.1752996
              ],
              [
                56.6025603,
                36.1752997
              ],
              [
                56.6088335,
                36.1787572
              ],
              [
                56.6174684,
                36.1806883
              ],
              [
                56.625805,
                36.1801386
              ],
              [
                56.6271916,
                36.1804179
              ],
              [
                56.6296917,
                36.1804179
              ],
              [
                56.6310815,
                36.1801386
              ],
              [
                56.631915,
                36.1804179
              ],
              [
                56.633305,
                36.1801386
              ],
              [
                56.6487644,
                36.1790301
              ],
              [
                56.6532113,
                36.1781921
              ],
              [
                56.6685562,
                36.168463
              ],
              [
                56.6702229,
                36.1673547
              ],
              [
                56.6759596,
                36.1655429
              ],
              [
                56.6792929,
                36.1644346
              ],
              [
                56.6812361,
                36.1644346
              ],
              [
                56.6817927,
                36.1641553
              ],
              [
                56.6856827,
                36.1641552
              ],
              [
                56.6879026,
                36.1638759
              ],
              [
                56.6884591,
                36.1638759
              ],
              [
                56.6992209,
                36.1672018
              ],
              [
                56.6997775,
                36.1669226
              ],
              [
                56.7047774,
                36.1658143
              ],
              [
                56.7106107,
                36.1633185
              ],
              [
                56.7122773,
                36.1622012
              ],
              [
                56.7298354,
                36.1573416
              ],
              [
                56.7309454,
                36.1573416
              ],
              [
                56.7315021,
                36.1570623
              ],
              [
                56.7326121,
                36.1570623
              ],
              [
                56.7328886,
                36.1567829
              ],
              [
                56.7345553,
                36.1567829
              ],
              [
                56.7348354,
                36.1565038
              ],
              [
                56.737612,
                36.1565038
              ],
              [
                56.7384452,
                36.1562243
              ],
              [
                56.7527727,
                36.1565084
              ],
              [
                56.7533293,
                36.1567786
              ],
              [
                56.7541626,
                36.1567786
              ],
              [
                56.7544393,
                36.1570582
              ],
              [
                56.7590231,
                36.1570581
              ],
              [
                56.7733182,
                36.1830371
              ],
              [
                56.7651453,
                36.2367772
              ],
              [
                56.7626454,
                36.2415004
              ],
              [
                56.7626454,
                36.2417799
              ],
              [
                56.7609788,
                36.2462326
              ],
              [
                56.7551454,
                36.2606814
              ],
              [
                56.7462557,
                36.2679012
              ],
              [
                56.7365324,
                36.2729126
              ],
              [
                56.7299645,
                36.2985255
              ],
              [
                56.7331824,
                36.313053
              ],
              [
                56.7329289,
                36.3134953
              ],
              [
                56.7320724,
                36.31499
              ],
              [
                56.7315157,
                36.3183233
              ],
              [
                56.7317958,
                36.3188819
              ],
              [
                56.7320724,
                36.3244404
              ],
              [
                56.7312391,
                36.3341612
              ],
              [
                56.7276292,
                36.341107
              ],
              [
                56.7245726,
                36.345269
              ],
              [
                56.7321053,
                36.3822493
              ],
              [
                56.7348852,
                36.3858619
              ],
              [
                56.7359952,
                36.3866908
              ],
              [
                56.7368284,
                36.3872493
              ],
              [
                56.7631286,
                36.4130196
              ],
              [
                56.7853515,
                36.4244048
              ],
              [
                56.8004083,
                36.4455487
              ],
              [
                56.8023551,
                36.4474943
              ],
              [
                56.8167982,
                36.4619424
              ],
              [
                56.8562447,
                36.5088882
              ],
              [
                56.8568013,
                36.509996
              ],
              [
                56.8579113,
                36.5111039
              ],
              [
                56.860968,
                36.5161117
              ],
              [
                56.8623579,
                36.5183274
              ],
              [
                56.862358,
                36.5186066
              ],
              [
                56.8640245,
                36.5208313
              ],
              [
                56.8681913,
                36.5344405
              ],
              [
                56.8684678,
                36.5358365
              ],
              [
                56.8688172,
                36.5370548
              ],
              [
                56.8696337,
                36.5431063
              ],
              [
                56.8682436,
                36.5492223
              ],
              [
                56.8651905,
                36.5578243
              ],
              [
                56.8646337,
                36.5594996
              ],
              [
                56.8643572,
                36.5606075
              ],
              [
                56.8521339,
                36.5772796
              ],
              [
                56.8449108,
                36.5822785
              ],
              [
                56.8187677,
                36.5898147
              ],
              [
                56.7800951,
                36.5868124
              ],
              [
                56.7792618,
                36.5870917
              ],
              [
                56.7756517,
                36.5876502
              ],
              [
                56.7742619,
                36.5879295
              ],
              [
                56.7731519,
                36.5879295
              ],
              [
                56.7723185,
                36.5882088
              ],
              [
                56.7714853,
                36.5882088
              ],
              [
                56.7700952,
                36.5887672
              ],
              [
                56.7692617,
                36.5887672
              ],
              [
                56.7556487,
                36.5962619
              ],
              [
                56.752872,
                36.6062699
              ],
              [
                56.7568519,
                36.6450633
              ],
              [
                56.7557418,
                36.6497916
              ],
              [
                56.7554619,
                36.6517279
              ],
              [
                56.7554617,
                36.652007
              ],
              [
                56.7560184,
                36.6536822
              ],
              [
                56.7639526,
                36.6639856
              ],
              [
                56.769825,
                36.6670998
              ],
              [
                56.7733107,
                36.6735223
              ],
              [
                56.774665,
                36.6754232
              ],
              [
                56.7746649,
                36.6759816
              ],
              [
                56.7686151,
                36.6828182
              ],
              [
                56.7594928,
                36.6802167
              ],
              [
                56.758106,
                36.6802167
              ],
              [
                56.7572729,
                36.6804959
              ],
              [
                56.7542162,
                36.6804959
              ],
              [
                56.7531028,
                36.6802167
              ],
              [
                56.7503262,
                36.6802167
              ],
              [
                56.7453262,
                36.6796582
              ],
              [
                56.7442163,
                36.6796582
              ],
              [
                56.7378928,
                36.675793
              ],
              [
                56.7254129,
                36.6694349
              ],
              [
                56.7245796,
                36.6691556
              ],
              [
                56.7187464,
                36.6691556
              ],
              [
                56.717913,
                36.6688763
              ],
              [
                56.7134664,
                36.6688764
              ],
              [
                56.7060632,
                36.6639297
              ],
              [
                56.7043965,
                36.6644883
              ],
              [
                56.6980066,
                36.6636506
              ],
              [
                56.69523,
                36.6628216
              ],
              [
                56.6949532,
                36.6625424
              ],
              [
                56.6935633,
                36.6625424
              ],
              [
                56.6510994,
                36.6724587
              ],
              [
                56.6483228,
                36.6736649
              ],
              [
                56.6469328,
                36.6719094
              ],
              [
                56.6460995,
                36.6716304
              ],
              [
                56.6345211,
                36.6623606
              ],
              [
                56.6273114,
                36.6601573
              ],
              [
                56.618385,
                36.6540981
              ],
              [
                56.6053387,
                36.6543735
              ],
              [
                56.5792462,
                36.6590557
              ],
              [
                56.573753,
                36.6576786
              ],
              [
                56.5490338,
                36.6532718
              ],
              [
                56.5194621,
                36.6506994
              ],
              [
                56.5183521,
                36.6504202
              ],
              [
                56.5164087,
                36.6504202
              ],
              [
                56.5036289,
                36.6484746
              ],
              [
                56.5014057,
                36.6484747
              ],
              [
                56.4983523,
                36.6479162
              ],
              [
                56.4961289,
                36.6479162
              ],
              [
                56.4952957,
                36.6481955
              ],
              [
                56.4944624,
                36.6481954
              ],
              [
                56.4939057,
                36.6484746
              ],
              [
                56.4930723,
                36.6484746
              ],
              [
                56.4894624,
                36.650141
              ],
              [
                56.4780726,
                36.6620934
              ],
              [
                56.4709193,
                36.6775995
              ],
              [
                56.4695292,
                36.6778696
              ],
              [
                56.4629792,
                36.6831293
              ],
              [
                56.4618659,
                36.6836876
              ],
              [
                56.4590809,
                36.684179
              ],
              [
                56.4503627,
                36.6834265
              ],
              [
                56.4492494,
                36.6837056
              ],
              [
                56.4429011,
                36.6810861
              ],
              [
                56.4417911,
                36.6810862
              ],
              [
                56.4412346,
                36.6813653
              ],
              [
                56.4206398,
                36.6770911
              ],
              [
                56.4198064,
                36.6768119
              ],
              [
                56.4178597,
                36.6768119
              ],
              [
                56.3967703,
                36.6761293
              ],
              [
                56.3744486,
                36.6710891
              ],
              [
                56.3733385,
                36.6710891
              ],
              [
                56.3716719,
                36.6705307
              ],
              [
                56.3631671,
                36.6822268
              ],
              [
                56.3612239,
                36.6816685
              ],
              [
                56.3595572,
                36.6827762
              ],
              [
                56.3590005,
                36.6863872
              ],
              [
                56.3592771,
                36.6872246
              ],
              [
                56.3170652,
                36.7387089
              ],
              [
                56.2870785,
                36.7562155
              ],
              [
                56.2688824,
                36.7707927
              ],
              [
                56.2596127,
                36.7735428
              ],
              [
                56.2507752,
                36.7791028
              ],
              [
                56.2431332,
                36.7823424
              ],
              [
                56.2235638,
                36.7878416
              ],
              [
                56.1878582,
                36.8120337
              ],
              [
                56.1037794,
                36.8532569
              ],
              [
                56.0974696,
                36.8546803
              ],
              [
                56.0930263,
                36.8560674
              ],
              [
                56.0927461,
                36.8563466
              ],
              [
                56.0773083,
                36.8581973
              ],
              [
                56.0635754,
                36.8592961
              ],
              [
                56.0330196,
                36.8683605
              ],
              [
                56.0278698,
                36.8730296
              ],
              [
                56.0181712,
                36.8746773
              ],
              [
                56.0049511,
                36.8737517
              ],
              [
                56.0046744,
                36.8743008
              ],
              [
                56.0038377,
                36.8776314
              ],
              [
                56.0057192,
                36.8883389
              ],
              [
                56.0038374,
                36.8951353
              ],
              [
                56.0000608,
                36.9061173
              ],
              [
                56.0010908,
                36.9203914
              ],
              [
                56.0034791,
                36.9295525
              ],
              [
                56.0037592,
                36.9303808
              ],
              [
                56.0076659,
                36.9418165
              ],
              [
                56.0105175,
                36.948459
              ],
              [
                56.0107975,
                36.9492872
              ],
              [
                56.0108498,
                36.9496553
              ],
              [
                56.0108647,
                36.9497598
              ],
              [
                56.0110741,
                36.9512318
              ],
              [
                56.0209191,
                36.968641
              ],
              [
                56.0216469,
                36.9813486
              ],
              [
                56.0240711,
                36.9951731
              ],
              [
                56.0326765,
                36.9995367
              ],
              [
                56.02787,
                37.0100924
              ],
              [
                56.0275267,
                37.012971
              ],
              [
                56.0337309,
                37.0176012
              ],
              [
                56.0350791,
                37.0255818
              ],
              [
                56.0306166,
                37.0316104
              ],
              [
                56.0298709,
                37.0349065
              ],
              [
                56.029821,
                37.0408502
              ],
              [
                56.021855,
                37.0510878
              ],
              [
                56.0129355,
                37.0575061
              ],
              [
                56.0074423,
                37.0705192
              ],
              [
                56.0100179,
                37.1046278
              ],
              [
                56.0120748,
                37.1375232
              ],
              [
                56.0117,
                37.1477538
              ],
              [
                56.0062405,
                37.1622321
              ],
              [
                55.9928576,
                37.1743985
              ],
              [
                55.9375674,
                37.182803
              ],
              [
                55.9367341,
                37.1825239
              ],
              [
                55.9361774,
                37.1825239
              ],
              [
                55.9342342,
                37.1822448
              ],
              [
                55.9336775,
                37.1822448
              ],
              [
                55.9278442,
                37.1822449
              ],
              [
                55.9228443,
                37.1822449
              ],
              [
                55.9220108,
                37.1825239
              ],
              [
                55.9197876,
                37.1825238
              ],
              [
                55.9107969,
                37.1876728
              ],
              [
                55.9089544,
                37.1989139
              ],
              [
                55.9092312,
                37.2003091
              ],
              [
                55.9060778,
                37.2049876
              ],
              [
                55.9039305,
                37.2132418
              ],
              [
                55.9034363,
                37.2260945
              ],
              [
                55.9037128,
                37.2288749
              ],
              [
                55.9039929,
                37.2305395
              ],
              [
                55.9042696,
                37.233041
              ],
              [
                55.9045463,
                37.2374858
              ],
              [
                55.9048262,
                37.2455388
              ],
              [
                55.9048262,
                37.2519272
              ],
              [
                55.9048262,
                37.2555443
              ],
              [
                55.9051029,
                37.2558231
              ],
              [
                55.9050531,
                37.262591
              ],
              [
                55.9053296,
                37.267315
              ],
              [
                55.9058863,
                37.2742615
              ],
              [
                55.9061629,
                37.2773208
              ],
              [
                55.9064431,
                37.2803711
              ],
              [
                55.9109686,
                37.2873019
              ],
              [
                55.9097928,
                37.297721
              ],
              [
                55.9136362,
                37.3063754
              ],
              [
                55.9109227,
                37.3225239
              ],
              [
                55.8967207,
                37.3236221
              ],
              [
                55.8838461,
                37.3197998
              ],
              [
                55.8692841,
                37.3226794
              ],
              [
                55.8692842,
                37.3230584
              ],
              [
                55.8514767,
                37.3261317
              ],
              [
                55.8453635,
                37.3255739
              ],
              [
                55.8417534,
                37.3255739
              ],
              [
                55.8292538,
                37.3239094
              ],
              [
                55.8278637,
                37.3233517
              ],
              [
                55.8253636,
                37.3230728
              ],
              [
                55.8223071,
                37.322245
              ],
              [
                55.8086256,
                37.3178633
              ],
              [
                55.7889741,
                37.3080749
              ],
              [
                55.7578612,
                37.2925188
              ],
              [
                55.7513466,
                37.2885519
              ],
              [
                55.7450811,
                37.284736
              ],
              [
                55.7348443,
                37.2626619
              ],
              [
                55.7312344,
                37.2579377
              ],
              [
                55.7301211,
                37.2537713
              ],
              [
                55.7298443,
                37.2493259
              ],
              [
                55.7278978,
                37.233209
              ],
              [
                55.7276211,
                37.2315442
              ],
              [
                55.7273445,
                37.2293215
              ],
              [
                55.7270644,
                37.2284845
              ],
              [
                55.7273445,
                37.2226531
              ],
              [
                55.7270644,
                37.2157058
              ],
              [
                55.7267877,
                37.2120972
              ],
              [
                55.720528,
                37.2018572
              ],
              [
                55.7205279,
                37.2004712
              ],
              [
                55.7140049,
                37.1951219
              ],
              [
                55.7109782,
                37.1912503
              ],
              [
                55.7072883,
                37.1870346
              ],
              [
                55.7006349,
                37.1830671
              ],
              [
                55.686745,
                37.1639085
              ],
              [
                55.6770253,
                37.1552875
              ],
              [
                55.6767451,
                37.1544595
              ],
              [
                55.6756351,
                37.1536226
              ],
              [
                55.6603553,
                37.1408438
              ],
              [
                55.6547987,
                37.1361281
              ],
              [
                55.6511887,
                37.1330683
              ],
              [
                55.6416647,
                37.1234176
              ],
              [
                55.6306323,
                37.1122344
              ],
              [
                55.6303556,
                37.1119554
              ],
              [
                55.6214658,
                37.0991758
              ],
              [
                55.6070192,
                37.0688997
              ],
              [
                55.6045191,
                37.0558493
              ],
              [
                55.6041872,
                37.0530682
              ],
              [
                55.6041866,
                37.0530654
              ],
              [
                55.6039659,
                37.0519521
              ],
              [
                55.6036858,
                37.051124
              ],
              [
                55.6025759,
                37.0439057
              ],
              [
                55.6020192,
                37.0380643
              ],
              [
                55.6017425,
                37.0327899
              ],
              [
                55.5992426,
                37.0130691
              ],
              [
                55.5989626,
                37.0094507
              ],
              [
                55.5986859,
                37.0091717
              ],
              [
                55.5989626,
                37.0086226
              ],
              [
                55.5986859,
                37.0083436
              ],
              [
                55.5986858,
                37.0063993
              ],
              [
                55.5970192,
                37.0019529
              ],
              [
                55.5961859,
                36.9983434
              ],
              [
                55.5914625,
                36.9889012
              ],
              [
                55.585076,
                36.9708445
              ],
              [
                55.5795194,
                36.9572341
              ],
              [
                55.5792393,
                36.9555598
              ],
              [
                55.5636862,
                36.9294545
              ],
              [
                55.5625728,
                36.9283473
              ],
              [
                55.5603495,
                36.9252866
              ],
              [
                55.5525223,
                36.9207796
              ],
              [
                55.5511324,
                36.9207795
              ],
              [
                55.5508557,
                36.9205006
              ],
              [
                55.548357,
                36.9193923
              ],
              [
                55.5494657,
                36.9182774
              ],
              [
                55.5508557,
                36.9177195
              ],
              [
                55.5511324,
                36.9171704
              ],
              [
                55.5525223,
                36.9166124
              ],
              [
                55.5691574,
                36.8711017
              ],
              [
                55.5749991,
                36.8583965
              ],
              [
                55.5721723,
                36.8373866
              ],
              [
                55.5680057,
                36.8332083
              ],
              [
                55.5527113,
                36.8183552
              ],
              [
                55.5344832,
                36.8086079
              ],
              [
                55.5339265,
                36.8086078
              ],
              [
                55.5153132,
                36.7908207
              ],
              [
                55.5150368,
                36.7905415
              ],
              [
                55.51587,
                36.7844262
              ],
              [
                55.5175366,
                36.7819315
              ],
              [
                55.5192033,
                36.7794276
              ],
              [
                55.5288797,
                36.7660327
              ],
              [
                55.5429431,
                36.7323813
              ],
              [
                55.5437765,
                36.7307157
              ],
              [
                55.5526527,
                36.7089538
              ],
              [
                55.5634893,
                36.6997864
              ],
              [
                55.5718227,
                36.69423
              ],
              [
                55.6274817,
                36.6606892
              ],
              [
                55.6277583,
                36.6601309
              ],
              [
                55.6297051,
                36.6581855
              ],
              [
                55.6335484,
                36.6522425
              ],
              [
                55.635815,
                36.6487373
              ],
              [
                55.637205,
                36.644567
              ],
              [
                55.6374816,
                36.6442877
              ],
              [
                55.6347984,
                36.6355531
              ],
              [
                55.6384084,
                36.5963871
              ],
              [
                55.6458663,
                36.5820939
              ],
              [
                55.6458982,
                36.580577
              ],
              [
                55.6450649,
                36.5719667
              ],
              [
                55.6564911,
                36.5147192
              ],
              [
                55.6564911,
                36.5113866
              ],
              [
                55.6542378,
                36.4939138
              ],
              [
                55.638158,
                36.4827712
              ],
              [
                55.605352,
                36.4691746
              ],
              [
                55.601742,
                36.4672289
              ],
              [
                55.5575725,
                36.4466666
              ],
              [
                55.526316,
                36.428354
              ],
              [
                55.4966365,
                36.4180993
              ],
              [
                55.4852467,
                36.4208742
              ],
              [
                55.48469,
                36.4211534
              ],
              [
                55.48358,
                36.4211533
              ],
              [
                55.4833034,
                36.4214326
              ],
              [
                55.4819134,
                36.4214326
              ],
              [
                55.4816367,
                36.4217119
              ],
              [
                55.4791368,
                36.4219912
              ],
              [
                55.4630236,
                36.424766
              ],
              [
                55.4613569,
                36.4247659
              ],
              [
                55.458857,
                36.4253246
              ],
              [
                55.4569137,
                36.4253245
              ],
              [
                55.4538571,
                36.425874
              ],
              [
                55.4499671,
                36.425874
              ],
              [
                55.4483005,
                36.4261534
              ],
              [
                55.4406705,
                36.4300207
              ],
              [
                55.4398372,
                36.4302999
              ],
              [
                55.4345572,
                36.4302999
              ],
              [
                55.4267806,
                36.4311287
              ],
              [
                55.4137242,
                36.4330836
              ],
              [
                55.4115008,
                36.4330835
              ],
              [
                55.367608,
                36.436426
              ],
              [
                55.3653847,
                36.436426
              ],
              [
                55.3623282,
                36.4369844
              ],
              [
                55.3617748,
                36.4369844
              ],
              [
                55.3614948,
                36.4358673
              ],
              [
                55.3612182,
                36.4355881
              ],
              [
                55.3601082,
                36.433372
              ],
              [
                55.3595516,
                36.4330928
              ],
              [
                55.3587182,
                36.4314261
              ],
              [
                55.3556616,
                36.4236428
              ],
              [
                55.3567313,
                36.4172201
              ],
              [
                55.3486749,
                36.4030504
              ],
              [
                55.315895,
                36.3302704
              ],
              [
                55.3147818,
                36.3260992
              ],
              [
                55.3111718,
                36.3091621
              ],
              [
                55.3108952,
                36.3086035
              ],
              [
                55.3122817,
                36.2991619
              ],
              [
                55.3206184,
                36.2836027
              ],
              [
                55.327005,
                36.2766564
              ],
              [
                55.3275616,
                36.2761068
              ],
              [
                55.3292282,
                36.2747104
              ],
              [
                55.3295049,
                36.2744311
              ],
              [
                55.3300616,
                36.2738815
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555283,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گرمسار",
          "name:en": "Garmsar County",
          "name:uk": "Ґермсар",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286379",
          "wikipedia": "en:Garmsar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8341678,
                34.5059559
              ],
              [
                51.83462,
                34.5057806
              ],
              [
                51.8346199,
                34.5055009
              ],
              [
                51.856843,
                34.4905032
              ],
              [
                51.8587863,
                34.4899527
              ],
              [
                51.8598996,
                34.4899527
              ],
              [
                51.8612863,
                34.4893932
              ],
              [
                51.8615663,
                34.4888337
              ],
              [
                51.8732329,
                34.4849444
              ],
              [
                51.8776761,
                34.4830043
              ],
              [
                51.8779563,
                34.4827246
              ],
              [
                51.9065692,
                34.4724462
              ],
              [
                51.9671251,
                34.4463306
              ],
              [
                51.9776816,
                34.4424411
              ],
              [
                52.0146278,
                34.4305022
              ],
              [
                52.0157411,
                34.4305022
              ],
              [
                52.0557406,
                34.4224435
              ],
              [
                52.0665738,
                34.4193933
              ],
              [
                52.0679639,
                34.4193933
              ],
              [
                52.1024101,
                34.4113346
              ],
              [
                52.1065766,
                34.4102246
              ],
              [
                52.1071334,
                34.4102246
              ],
              [
                52.1088002,
                34.4096742
              ],
              [
                52.1099099,
                34.4096742
              ],
              [
                52.1168565,
                34.4077249
              ],
              [
                52.1185232,
                34.4077249
              ],
              [
                52.1187999,
                34.4074452
              ],
              [
                52.12019,
                34.4074451
              ],
              [
                52.1207431,
                34.4071654
              ],
              [
                52.1215765,
                34.4071654
              ],
              [
                52.1247214,
                34.4057632
              ],
              [
                52.129913,
                34.4046656
              ],
              [
                52.1307464,
                34.4046656
              ],
              [
                52.1343563,
                34.4035556
              ],
              [
                52.1354663,
                34.4035556
              ],
              [
                52.139633,
                34.4027254
              ],
              [
                52.1412997,
                34.4027254
              ],
              [
                52.1424129,
                34.4024456
              ],
              [
                52.1440795,
                34.4024456
              ],
              [
                52.1459888,
                34.4021873
              ],
              [
                52.1493562,
                34.4016154
              ],
              [
                52.1529695,
                34.4016154
              ],
              [
                52.1551893,
                34.4013356
              ],
              [
                52.1585226,
                34.4013357
              ],
              [
                52.1607461,
                34.4016154
              ],
              [
                52.1614274,
                34.4016155
              ],
              [
                52.1738027,
                34.4016155
              ],
              [
                52.1751925,
                34.4013357
              ],
              [
                52.1782459,
                34.4013356
              ],
              [
                52.1793592,
                34.4010559
              ],
              [
                52.182969,
                34.4010559
              ],
              [
                52.1838024,
                34.4013358
              ],
              [
                52.1871357,
                34.4013356
              ],
              [
                52.1876924,
                34.4016155
              ],
              [
                52.1907491,
                34.4016154
              ],
              [
                52.1915822,
                34.4018952
              ],
              [
                52.2065822,
                34.4018952
              ],
              [
                52.2082488,
                34.4021659
              ],
              [
                52.2135253,
                34.402166
              ],
              [
                52.2146387,
                34.4024457
              ],
              [
                52.217972,
                34.4024457
              ],
              [
                52.2218587,
                34.4029962
              ],
              [
                52.224082,
                34.4029962
              ],
              [
                52.2254719,
                34.4032759
              ],
              [
                52.229362,
                34.403276
              ],
              [
                52.2307485,
                34.4035557
              ],
              [
                52.2329717,
                34.4035557
              ],
              [
                52.2474183,
                34.4055049
              ],
              [
                52.2535283,
                34.406606
              ],
              [
                52.2596381,
                34.4074453
              ],
              [
                52.2615848,
                34.4074453
              ],
              [
                52.2801979,
                34.4102248
              ],
              [
                52.2840846,
                34.4104954
              ],
              [
                52.2854744,
                34.4107753
              ],
              [
                52.2868645,
                34.4110549
              ],
              [
                52.2874178,
                34.4113348
              ],
              [
                52.2915843,
                34.4118943
              ],
              [
                52.3029742,
                34.4141143
              ],
              [
                52.3129742,
                34.415504
              ],
              [
                52.3285306,
                34.419944
              ],
              [
                52.3296438,
                34.4199439
              ],
              [
                52.3313105,
                34.4205035
              ],
              [
                52.3324205,
                34.4205035
              ],
              [
                52.3527004,
                34.4243929
              ],
              [
                52.3546436,
                34.424393
              ],
              [
                52.3768666,
                34.4277229
              ],
              [
                52.3788133,
                34.427723
              ],
              [
                52.3799233,
                34.4280027
              ],
              [
                52.3885331,
                34.428833
              ],
              [
                52.3929798,
                34.4291127
              ],
              [
                52.3943698,
                34.4293925
              ],
              [
                52.3952031,
                34.4291127
              ],
              [
                52.3954797,
                34.4293924
              ],
              [
                52.3993698,
                34.4293924
              ],
              [
                52.399923,
                34.4291127
              ],
              [
                52.4022866,
                34.4291127
              ],
              [
                52.4015897,
                34.4305025
              ],
              [
                52.4002031,
                34.4341121
              ],
              [
                52.3999231,
                34.4355018
              ],
              [
                52.3996463,
                34.4363321
              ],
              [
                52.3993697,
                34.4371713
              ],
              [
                52.3990897,
                34.4393913
              ],
              [
                52.3871465,
                34.4663373
              ],
              [
                52.3793666,
                34.4902238
              ],
              [
                52.3760332,
                34.5035611
              ],
              [
                52.3751999,
                34.5060607
              ],
              [
                52.37409,
                34.5099499
              ],
              [
                52.3738134,
                34.5113397
              ],
              [
                52.3743666,
                34.5205078
              ],
              [
                52.37409,
                34.5221681
              ],
              [
                52.3718666,
                34.5366151
              ],
              [
                52.3707566,
                34.5405043
              ],
              [
                52.3704766,
                34.5455034
              ],
              [
                52.3702,
                34.5552218
              ],
              [
                52.3685333,
                34.5682878
              ],
              [
                52.3685332,
                34.571058
              ],
              [
                52.3679766,
                34.5732869
              ],
              [
                52.3677,
                34.5757864
              ],
              [
                52.3682567,
                34.588004
              ],
              [
                52.3685333,
                34.6055092
              ],
              [
                52.3676999,
                34.6124481
              ],
              [
                52.3688098,
                34.635791
              ],
              [
                52.3713099,
                34.657726
              ],
              [
                52.3726997,
                34.6657834
              ],
              [
                52.3765898,
                34.6788395
              ],
              [
                52.4071461,
                34.7296822
              ],
              [
                52.4177026,
                34.7635704
              ],
              [
                52.4190926,
                34.7688395
              ],
              [
                52.4202025,
                34.777176
              ],
              [
                52.4207591,
                34.783293
              ],
              [
                52.4221457,
                34.7943993
              ],
              [
                52.422979,
                34.7968984
              ],
              [
                52.4329824,
                34.8477279
              ],
              [
                52.4368688,
                34.8646797
              ],
              [
                52.4424254,
                34.9244017
              ],
              [
                52.4427021,
                34.9282899
              ],
              [
                52.4435354,
                34.9346768
              ],
              [
                52.4446487,
                34.9438514
              ],
              [
                52.445202,
                34.9482898
              ],
              [
                52.4468687,
                34.9544061
              ],
              [
                52.4488154,
                34.9632918
              ],
              [
                52.4485353,
                34.9641216
              ],
              [
                52.449092,
                34.9730163
              ],
              [
                52.4482586,
                34.9744055
              ],
              [
                52.447982,
                34.9752354
              ],
              [
                52.4482586,
                34.9757947
              ],
              [
                52.447982,
                34.9769043
              ],
              [
                52.4496487,
                34.981072
              ],
              [
                52.4524252,
                34.9982927
              ],
              [
                52.4604819,
                35.0021806
              ],
              [
                52.4615917,
                35.0021806
              ],
              [
                52.4621484,
                35.0138444
              ],
              [
                52.4624251,
                35.014124
              ],
              [
                52.4629818,
                35.014124
              ],
              [
                52.4660384,
                35.02024
              ],
              [
                52.4660385,
                35.0207992
              ],
              [
                52.467425,
                35.0238482
              ],
              [
                52.470205,
                35.0288456
              ],
              [
                52.4743716,
                35.0399588
              ],
              [
                52.4827049,
                35.0566285
              ],
              [
                52.4879848,
                35.07107
              ],
              [
                52.4965948,
                35.0888487
              ],
              [
                52.4971513,
                35.089408
              ],
              [
                52.497428,
                35.0905174
              ],
              [
                52.4999279,
                35.0957942
              ],
              [
                52.5035186,
                35.1025818
              ],
              [
                52.503879,
                35.1043935
              ],
              [
                52.5018449,
                35.1082063
              ],
              [
                52.4993729,
                35.111071
              ],
              [
                52.4837432,
                35.1195803
              ],
              [
                52.480885,
                35.1234556
              ],
              [
                52.4816832,
                35.1282362
              ],
              [
                52.4852624,
                35.1340484
              ],
              [
                52.4936566,
                35.1400707
              ],
              [
                52.5014844,
                35.1437134
              ],
              [
                52.503879,
                35.1454189
              ],
              [
                52.5040335,
                35.1476086
              ],
              [
                52.4961543,
                35.1547457
              ],
              [
                52.4924948,
                35.1562515
              ],
              [
                52.4824268,
                35.160946
              ],
              [
                52.4800322,
                35.1625248
              ],
              [
                52.4740068,
                35.1671347
              ],
              [
                52.4632437,
                35.1730494
              ],
              [
                52.4588406,
                35.1756382
              ],
              [
                52.4579908,
                35.1769221
              ],
              [
                52.459819,
                35.1812155
              ],
              [
                52.460231,
                35.1825835
              ],
              [
                52.459716,
                35.1857402
              ],
              [
                52.4578878,
                35.1877394
              ],
              [
                52.4547207,
                35.1901595
              ],
              [
                52.4519655,
                35.1920113
              ],
              [
                52.4492876,
                35.1937578
              ],
              [
                52.4471762,
                35.1990814
              ],
              [
                52.4400436,
                35.2103586
              ],
              [
                52.4373142,
                35.2167119
              ],
              [
                52.437443,
                35.2184158
              ],
              [
                52.435383,
                35.2215922
              ],
              [
                52.4325506,
                35.2256309
              ],
              [
                52.4281733,
                35.2311206
              ],
              [
                52.4235127,
                35.2390496
              ],
              [
                52.4205,
                35.2470408
              ],
              [
                52.4204743,
                35.2505105
              ],
              [
                52.421118,
                35.2552206
              ],
              [
                52.4213497,
                35.2612549
              ],
              [
                52.4209236,
                35.2637979
              ],
              [
                52.4192151,
                35.2673746
              ],
              [
                52.4182624,
                35.2696451
              ],
              [
                52.4167432,
                35.271432
              ],
              [
                52.4153012,
                35.2738916
              ],
              [
                52.4146833,
                35.277297
              ],
              [
                52.414709,
                35.2789367
              ],
              [
                52.415121,
                35.2796513
              ],
              [
                52.415842,
                35.2809966
              ],
              [
                52.4156875,
                35.2822788
              ],
              [
                52.416151,
                35.2832457
              ],
              [
                52.4170522,
                35.2843597
              ],
              [
                52.4174642,
                35.2847591
              ],
              [
                52.4179019,
                35.2849903
              ],
              [
                52.4190864,
                35.2856839
              ],
              [
                52.423026,
                35.2874495
              ],
              [
                52.4262704,
                35.2886265
              ],
              [
                52.4288196,
                35.2894041
              ],
              [
                52.4331454,
                35.2911696
              ],
              [
                52.4349479,
                35.2924726
              ],
              [
                52.4395193,
                35.2959114
              ],
              [
                52.4724281,
                35.3174686
              ],
              [
                52.4740948,
                35.3191369
              ],
              [
                52.4752047,
                35.3196871
              ],
              [
                52.4965944,
                35.341358
              ],
              [
                52.4999278,
                35.343856
              ],
              [
                52.5029843,
                35.3474632
              ],
              [
                52.5149275,
                35.3677449
              ],
              [
                52.5182608,
                35.3794141
              ],
              [
                52.5213174,
                35.387476
              ],
              [
                52.5218741,
                35.3883057
              ],
              [
                52.5227074,
                35.3916423
              ],
              [
                52.5246748,
                35.397823
              ],
              [
                52.5232607,
                35.3974677
              ],
              [
                52.5227074,
                35.3971882
              ],
              [
                52.5210407,
                35.3969177
              ],
              [
                52.5188174,
                35.396079
              ],
              [
                52.5171509,
                35.3957995
              ],
              [
                52.499651,
                35.3869169
              ],
              [
                52.4957611,
                35.3863578
              ],
              [
                52.4949278,
                35.3860782
              ],
              [
                52.4935377,
                35.3860782
              ],
              [
                52.4218687,
                35.3660765
              ],
              [
                52.4104788,
                35.3585825
              ],
              [
                52.4085355,
                35.3569142
              ],
              [
                52.4001154,
                35.3507378
              ],
              [
                52.3829791,
                35.3380212
              ],
              [
                52.3801991,
                35.337462
              ],
              [
                52.3790892,
                35.3374621
              ],
              [
                52.3785325,
                35.3377506
              ],
              [
                52.3688092,
                35.3410783
              ],
              [
                52.3601994,
                35.3474632
              ],
              [
                52.3451995,
                35.3610805
              ],
              [
                52.3401997,
                35.3660764
              ],
              [
                52.3331994,
                35.3749235
              ],
              [
                52.3326963,
                35.3755273
              ],
              [
                52.324363,
                35.3860782
              ],
              [
                52.2810271,
                35.4255273
              ],
              [
                52.2807503,
                35.4258009
              ],
              [
                52.27692,
                35.4282479
              ],
              [
                52.2576937,
                35.4405264
              ],
              [
                52.2568606,
                35.4405265
              ],
              [
                52.254084,
                35.4416356
              ],
              [
                52.2521372,
                35.4421946
              ],
              [
                52.2515839,
                35.4421946
              ],
              [
                52.2374141,
                35.445531
              ],
              [
                52.2143577,
                35.4488584
              ],
              [
                52.2121377,
                35.4488584
              ],
              [
                52.2060245,
                35.449697
              ],
              [
                52.2029677,
                35.449697
              ],
              [
                52.2021344,
                35.4499675
              ],
              [
                52.1968579,
                35.4505266
              ],
              [
                52.169601,
                35.4561513
              ],
              [
                52.1496353,
                35.4602472
              ],
              [
                52.1299753,
                35.4611969
              ],
              [
                52.1264953,
                35.4585216
              ],
              [
                52.1177488,
                35.4555851
              ],
              [
                52.0764298,
                35.4509236
              ],
              [
                52.0689299,
                35.4537018
              ],
              [
                52.0511501,
                35.4589783
              ],
              [
                52.0500402,
                35.4589783
              ],
              [
                52.0296149,
                35.4776577
              ],
              [
                52.027115,
                35.4787669
              ],
              [
                52.017115,
                35.4868295
              ],
              [
                52.003967,
                35.5060285
              ],
              [
                52.0056003,
                35.5169627
              ],
              [
                52.0056003,
                35.5183514
              ],
              [
                52.0096592,
                35.5282986
              ],
              [
                52.0117525,
                35.5392061
              ],
              [
                52.0096267,
                35.5488646
              ],
              [
                51.9935134,
                35.5685834
              ],
              [
                51.9857369,
                35.575526
              ],
              [
                51.9804602,
                35.577194
              ],
              [
                51.979347,
                35.577194
              ],
              [
                51.972957,
                35.5785825
              ],
              [
                51.9704571,
                35.5785825
              ],
              [
                51.9696237,
                35.5785825
              ],
              [
                51.9693471,
                35.578312
              ],
              [
                51.9662904,
                35.578312
              ],
              [
                51.9657371,
                35.5785825
              ],
              [
                51.9629571,
                35.5785825
              ],
              [
                51.9604572,
                35.5785825
              ],
              [
                51.9579572,
                35.5780235
              ],
              [
                51.9365676,
                35.5616408
              ],
              [
                51.9357341,
                35.5616408
              ],
              [
                51.9296242,
                35.5585843
              ],
              [
                51.9243442,
                35.548585
              ],
              [
                51.923511,
                35.5458079
              ],
              [
                51.9229577,
                35.5374767
              ],
              [
                51.9229577,
                35.5355292
              ],
              [
                51.921011,
                35.5099668
              ],
              [
                51.9212911,
                35.5085782
              ],
              [
                51.921011,
                35.5080282
              ],
              [
                51.9212911,
                35.5055305
              ],
              [
                51.9215677,
                35.5035829
              ],
              [
                51.9286453,
                35.490324
              ],
              [
                51.9289218,
                35.4889353
              ],
              [
                51.929202,
                35.4883853
              ],
              [
                51.929202,
                35.4880967
              ],
              [
                51.9257344,
                35.4810856
              ],
              [
                51.9260109,
                35.4799675
              ],
              [
                51.9257344,
                35.4794175
              ],
              [
                51.9257344,
                35.4763606
              ],
              [
                51.9254578,
                35.4708061
              ],
              [
                51.9251778,
                35.4702471
              ],
              [
                51.9196211,
                35.4480285
              ],
              [
                51.9190678,
                35.4471991
              ],
              [
                51.9176778,
                35.4413558
              ],
              [
                51.9135113,
                35.4255302
              ],
              [
                51.9135114,
                35.4241415
              ],
              [
                51.9129545,
                35.4224732
              ],
              [
                51.9119893,
                35.4143066
              ],
              [
                51.9209319,
                35.4047028
              ],
              [
                51.9231206,
                35.4000854
              ],
              [
                51.9242793,
                35.3949219
              ],
              [
                51.9253093,
                35.38176
              ],
              [
                51.9243566,
                35.3698347
              ],
              [
                51.9297557,
                35.3679098
              ],
              [
                51.9392057,
                35.3649071
              ],
              [
                51.952724,
                35.3603924
              ],
              [
                51.9593158,
                35.3584395
              ],
              [
                51.9646716,
                35.3576205
              ],
              [
                51.9718557,
                35.3560875
              ],
              [
                51.9706455,
                35.3549955
              ],
              [
                51.9694095,
                35.3537774
              ],
              [
                51.9676071,
                35.3526014
              ],
              [
                51.9671178,
                35.3516353
              ],
              [
                51.9664998,
                35.3500392
              ],
              [
                51.9661394,
                35.348569
              ],
              [
                51.9655214,
                35.3478129
              ],
              [
                51.9641567,
                35.3463217
              ],
              [
                51.962998,
                35.3446835
              ],
              [
                51.962998,
                35.3433813
              ],
              [
                51.9629722,
                35.3424361
              ],
              [
                51.9629722,
                35.34168
              ],
              [
                51.9632297,
                35.3401677
              ],
              [
                51.9628177,
                35.3395375
              ],
              [
                51.9625345,
                35.3377311
              ],
              [
                51.9616332,
                35.3355046
              ],
              [
                51.9607578,
                35.3345593
              ],
              [
                51.960217,
                35.333572
              ],
              [
                51.9593673,
                35.3323536
              ],
              [
                51.9593673,
                35.3315134
              ],
              [
                51.9586978,
                35.3311563
              ],
              [
                51.9579769,
                35.3307151
              ],
              [
                51.9567409,
                35.3295387
              ],
              [
                51.9558654,
                35.3287825
              ],
              [
                51.9554019,
                35.3279422
              ],
              [
                51.9554019,
                35.3271859
              ],
              [
                51.9555307,
                35.3267237
              ],
              [
                51.9555307,
                35.3261355
              ],
              [
                51.9550929,
                35.3253792
              ],
              [
                51.9543977,
                35.3244758
              ],
              [
                51.9535222,
                35.3235094
              ],
              [
                51.9498144,
                35.3215346
              ],
              [
                51.9494281,
                35.3209043
              ],
              [
                51.9491706,
                35.320337
              ],
              [
                51.9476772,
                35.3190344
              ],
              [
                51.9471364,
                35.318215
              ],
              [
                51.946261,
                35.3176268
              ],
              [
                51.9452825,
                35.3162401
              ],
              [
                51.9443555,
                35.3156938
              ],
              [
                51.9436603,
                35.3134876
              ],
              [
                51.9413686,
                35.3121009
              ],
              [
                51.9359957,
                35.3126593
              ],
              [
                51.932262,
                35.3128064
              ],
              [
                51.9043448,
                35.3180273
              ],
              [
                51.9024015,
                35.3152496
              ],
              [
                51.8976783,
                35.3094148
              ],
              [
                51.8846339,
                35.2955786
              ],
              [
                51.867592,
                35.2777152
              ],
              [
                51.8678688,
                35.2763263
              ],
              [
                51.8681487,
                35.2749373
              ],
              [
                51.868702,
                35.2727096
              ],
              [
                51.8689821,
                35.2721594
              ],
              [
                51.869169,
                35.2709737
              ],
              [
                51.8692586,
                35.2702112
              ],
              [
                51.8695355,
                35.2699317
              ],
              [
                51.8770353,
                35.2516048
              ],
              [
                51.8789819,
                35.2490975
              ],
              [
                51.8792587,
                35.2485472
              ],
              [
                51.8953718,
                35.2307702
              ],
              [
                51.9328714,
                35.1779876
              ],
              [
                51.9334282,
                35.176319
              ],
              [
                51.9417613,
                35.1613189
              ],
              [
                51.9431513,
                35.1579815
              ],
              [
                51.9464847,
                35.1521547
              ],
              [
                51.9467612,
                35.1515954
              ],
              [
                51.9478745,
                35.150486
              ],
              [
                51.9500945,
                35.1474282
              ],
              [
                51.9637077,
                35.1365951
              ],
              [
                51.9645411,
                35.1360359
              ],
              [
                52.0025974,
                35.1132599
              ],
              [
                52.0298238,
                35.087146
              ],
              [
                52.0309338,
                35.0854772
              ],
              [
                52.0320438,
                35.0829785
              ],
              [
                52.0323237,
                35.0826989
              ],
              [
                52.0378768,
                35.0693666
              ],
              [
                52.0381569,
                35.0688163
              ],
              [
                52.0387103,
                35.065199
              ],
              [
                52.0389904,
                35.0607609
              ],
              [
                52.039267,
                35.0524257
              ],
              [
                52.0395435,
                35.0482492
              ],
              [
                52.0398237,
                35.0463098
              ],
              [
                52.035657,
                35.0118681
              ],
              [
                52.0320438,
                34.9996445
              ],
              [
                52.0309338,
                34.9965863
              ],
              [
                52.0215739,
                34.9677388
              ],
              [
                52.0212938,
                34.9671794
              ],
              [
                52.0015707,
                34.9185647
              ],
              [
                51.9987942,
                34.9149561
              ],
              [
                51.9985176,
                34.9146855
              ],
              [
                51.985181,
                34.896345
              ],
              [
                51.9785145,
                34.8838502
              ],
              [
                51.9774045,
                34.8824519
              ],
              [
                51.9768479,
                34.8810717
              ],
              [
                51.9699045,
                34.8718967
              ],
              [
                51.9696244,
                34.871617
              ],
              [
                51.9654579,
                34.8657891
              ],
              [
                51.9649046,
                34.8652387
              ],
              [
                51.9590713,
                34.8580124
              ],
              [
                51.9504581,
                34.8343934
              ],
              [
                51.9487915,
                34.8257865
              ],
              [
                51.9401818,
                34.7955087
              ],
              [
                51.9390683,
                34.7846731
              ],
              [
                51.9379583,
                34.776896
              ],
              [
                51.9376784,
                34.7763456
              ],
              [
                51.9343568,
                34.7593378
              ],
              [
                51.9329584,
                34.7521748
              ],
              [
                51.9279585,
                34.7335616
              ],
              [
                51.9176787,
                34.704951
              ],
              [
                51.9157355,
                34.7010622
              ],
              [
                51.9143454,
                34.6969028
              ],
              [
                51.9135122,
                34.6955133
              ],
              [
                51.8885126,
                34.635511
              ],
              [
                51.8848992,
                34.6291226
              ],
              [
                51.8619819,
                34.5833108
              ],
              [
                51.8557255,
                34.5736958
              ],
              [
                51.8503768,
                34.5678171
              ],
              [
                51.8403823,
                34.5680611
              ],
              [
                51.8412099,
                34.5548442
              ],
              [
                51.8407554,
                34.5329227
              ],
              [
                51.839545,
                34.5237742
              ],
              [
                51.8387866,
                34.5230069
              ],
              [
                51.83712,
                34.5163384
              ],
              [
                51.8360101,
                34.5121695
              ],
              [
                51.8351766,
                34.5105
              ],
              [
                51.8348966,
                34.5099496
              ],
              [
                51.8337865,
                34.5082802
              ],
              [
                51.8335099,
                34.5071703
              ],
              [
                51.8337865,
                34.5068905
              ],
              [
                51.8341678,
                34.5059559
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 304669513
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.3383855,
          35.2222875
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836434379
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.4928417,
          35.2478246
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836434382
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.2135038,
          35.4638851
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 510139522
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.3379993,
          36.167451
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2048982952
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.9649915,
          36.4195026
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 301198375
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.6545685,
          36.4086479
        ]
      }
    }
  ]
},
"سیستان و بلوچستان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554901,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ایرانشهر",
          "name:en": "Iranshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278141",
          "wikipedia": "en:Iranshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.5710238,
                27.6346311
              ],
              [
                59.5627641,
                27.6268894
              ],
              [
                59.5531511,
                27.613885
              ],
              [
                59.5521211,
                27.6115653
              ],
              [
                59.5509624,
                27.6070019
              ],
              [
                59.5511503,
                27.603266
              ],
              [
                59.5519109,
                27.5883076
              ],
              [
                59.555036,
                27.5734918
              ],
              [
                59.5637826,
                27.5403186
              ],
              [
                59.5789828,
                27.5179943
              ],
              [
                59.6774039,
                27.5017163
              ],
              [
                59.764145,
                27.4851672
              ],
              [
                59.9665552,
                27.4457842
              ],
              [
                60.020369,
                27.4493745
              ],
              [
                60.0452612,
                27.444611
              ],
              [
                60.0591624,
                27.4387707
              ],
              [
                60.0745924,
                27.4317724
              ],
              [
                60.1148031,
                27.4309078
              ],
              [
                60.1424536,
                27.4254284
              ],
              [
                60.2213327,
                27.4098456
              ],
              [
                60.2343927,
                27.4063411
              ],
              [
                60.2445101,
                27.4033689
              ],
              [
                60.2704214,
                27.3947184
              ],
              [
                60.2802656,
                27.3934122
              ],
              [
                60.2992807,
                27.3841564
              ],
              [
                60.3511239,
                27.3659532
              ],
              [
                60.3750227,
                27.3583517
              ],
              [
                60.3990553,
                27.3531679
              ],
              [
                60.4197394,
                27.3458958
              ],
              [
                60.4444319,
                27.3345492
              ],
              [
                60.4764724,
                27.3589293
              ],
              [
                60.4991815,
                27.3810175
              ],
              [
                60.5080567,
                27.384901
              ],
              [
                60.5311438,
                27.4024589
              ],
              [
                60.5479311,
                27.4173008
              ],
              [
                60.5521279,
                27.4068614
              ],
              [
                60.5560812,
                27.3993414
              ],
              [
                60.5645928,
                27.3646824
              ],
              [
                60.5687777,
                27.3394752
              ],
              [
                60.5701331,
                27.3329117
              ],
              [
                60.5716351,
                27.3261963
              ],
              [
                60.5743184,
                27.3138967
              ],
              [
                60.5746649,
                27.2930792
              ],
              [
                60.5784801,
                27.2628672
              ],
              [
                60.5789696,
                27.2437131
              ],
              [
                60.5779284,
                27.2316308
              ],
              [
                60.576555,
                27.2209196
              ],
              [
                60.5758665,
                27.2056332
              ],
              [
                60.579536,
                27.2043442
              ],
              [
                60.5799246,
                27.1958141
              ],
              [
                60.5763815,
                27.1947931
              ],
              [
                60.5775213,
                27.1872891
              ],
              [
                60.5792998,
                27.1804397
              ],
              [
                60.5837646,
                27.1745938
              ],
              [
                60.5801581,
                27.1665427
              ],
              [
                60.5739029,
                27.1529751
              ],
              [
                60.565198,
                27.1390004
              ],
              [
                60.5564688,
                27.1251467
              ],
              [
                60.5623053,
                27.1172018
              ],
              [
                60.5629919,
                27.111854
              ],
              [
                60.5566405,
                27.1072699
              ],
              [
                60.5480574,
                27.108034
              ],
              [
                60.5398176,
                27.1046722
              ],
              [
                60.5365319,
                27.0967343
              ],
              [
                60.5367277,
                27.0867922
              ],
              [
                60.5307268,
                27.06962
              ],
              [
                60.5263254,
                27.0484359
              ],
              [
                60.5219505,
                27.0379413
              ],
              [
                60.5217932,
                27.0282418
              ],
              [
                60.5313815,
                27.0197724
              ],
              [
                60.577185,
                26.9880312
              ],
              [
                60.6071089,
                26.9676719
              ],
              [
                60.6318281,
                26.962776
              ],
              [
                60.6507009,
                26.9555388
              ],
              [
                60.68263,
                26.9298577
              ],
              [
                60.7098995,
                26.9048107
              ],
              [
                60.7198391,
                26.8705317
              ],
              [
                60.7384297,
                26.8364788
              ],
              [
                60.7506176,
                26.8202412
              ],
              [
                60.7949443,
                26.8030001
              ],
              [
                60.8051733,
                26.7944953
              ],
              [
                60.8206612,
                26.7819051
              ],
              [
                60.8412995,
                26.7586372
              ],
              [
                60.8743568,
                26.7714877
              ],
              [
                60.9267434,
                26.7918
              ],
              [
                60.9372098,
                26.8201447
              ],
              [
                60.9243097,
                26.8351843
              ],
              [
                60.894931,
                26.855374
              ],
              [
                60.8735947,
                26.8743627
              ],
              [
                60.8441199,
                26.9022183
              ],
              [
                60.7958074,
                26.9525718
              ],
              [
                60.7866302,
                26.9628942
              ],
              [
                60.7611988,
                26.9879562
              ],
              [
                60.770075,
                26.9995811
              ],
              [
                60.7761222,
                27.0026128
              ],
              [
                60.7873134,
                27.0039893
              ],
              [
                60.8067625,
                27.0034667
              ],
              [
                60.8368867,
                27.0030079
              ],
              [
                60.8459183,
                27.0114936
              ],
              [
                60.8569068,
                27.0286321
              ],
              [
                60.8671561,
                27.0289447
              ],
              [
                60.8782457,
                27.0124691
              ],
              [
                60.8865244,
                27.008438
              ],
              [
                60.8935129,
                27.0019084
              ],
              [
                60.9107659,
                27.0017759
              ],
              [
                60.9351553,
                27.0043487
              ],
              [
                60.9587476,
                27.0056129
              ],
              [
                60.973262,
                27.0070872
              ],
              [
                60.9872407,
                27.0031588
              ],
              [
                60.9934798,
                27.0062328
              ],
              [
                61.0127362,
                27.0150716
              ],
              [
                61.0338271,
                27.0252987
              ],
              [
                61.0589056,
                27.0358747
              ],
              [
                61.0909942,
                27.0481827
              ],
              [
                61.113005,
                27.0517484
              ],
              [
                61.1181156,
                27.0486143
              ],
              [
                61.1248309,
                27.0543967
              ],
              [
                61.1428604,
                27.0634782
              ],
              [
                61.1434001,
                27.0724875
              ],
              [
                61.1381271,
                27.0772709
              ],
              [
                61.1369969,
                27.0823321
              ],
              [
                61.1334489,
                27.0850326
              ],
              [
                61.1423491,
                27.0898488
              ],
              [
                61.1476706,
                27.0956561
              ],
              [
                61.1670444,
                27.0958958
              ],
              [
                61.175823,
                27.0906129
              ],
              [
                61.1840628,
                27.1002407
              ],
              [
                61.1916024,
                27.0978095
              ],
              [
                61.199684,
                27.0938223
              ],
              [
                61.2005106,
                27.1089665
              ],
              [
                61.200199,
                27.1280495
              ],
              [
                61.1947058,
                27.1352298
              ],
              [
                61.197909,
                27.1431522
              ],
              [
                61.1929684,
                27.1508856
              ],
              [
                61.1899054,
                27.1599546
              ],
              [
                61.1796479,
                27.1714449
              ],
              [
                61.2037377,
                27.1809754
              ],
              [
                61.2183213,
                27.1987626
              ],
              [
                61.2250505,
                27.1981475
              ],
              [
                61.2295813,
                27.2022674
              ],
              [
                61.2364174,
                27.2250546
              ],
              [
                61.2361439,
                27.2261697
              ],
              [
                61.2380825,
                27.2323174
              ],
              [
                61.2425993,
                27.2416577
              ],
              [
                61.2389944,
                27.2489833
              ],
              [
                61.2340162,
                27.2512724
              ],
              [
                61.2225666,
                27.2552507
              ],
              [
                61.2165868,
                27.2559997
              ],
              [
                61.1916989,
                27.2703315
              ],
              [
                61.1900316,
                27.2711678
              ],
              [
                61.1811385,
                27.2786678
              ],
              [
                61.156139,
                27.2958894
              ],
              [
                61.1553062,
                27.2961681
              ],
              [
                61.151139,
                27.2989471
              ],
              [
                61.1436396,
                27.3039473
              ],
              [
                61.1229513,
                27.3177896
              ],
              [
                61.1076735,
                27.3309053
              ],
              [
                61.0946272,
                27.3504234
              ],
              [
                61.0791009,
                27.3690356
              ],
              [
                61.0705319,
                27.3805384
              ],
              [
                61.0596083,
                27.3929549
              ],
              [
                61.0532409,
                27.4041094
              ],
              [
                61.0427508,
                27.4207036
              ],
              [
                61.0368201,
                27.4349991
              ],
              [
                61.026306,
                27.4535988
              ],
              [
                61.0156207,
                27.4690938
              ],
              [
                61.0091429,
                27.4756428
              ],
              [
                61.0067312,
                27.4791313
              ],
              [
                61.0028077,
                27.4833193
              ],
              [
                60.9999703,
                27.4866478
              ],
              [
                60.999349,
                27.488106
              ],
              [
                60.9974006,
                27.4914452
              ],
              [
                60.9944026,
                27.494432
              ],
              [
                60.9872091,
                27.5001421
              ],
              [
                60.9811274,
                27.5014966
              ],
              [
                60.9747156,
                27.5022323
              ],
              [
                60.9609831,
                27.5017294
              ],
              [
                60.9527251,
                27.5023889
              ],
              [
                60.9472812,
                27.5017295
              ],
              [
                60.9372561,
                27.5007397
              ],
              [
                60.9300171,
                27.5011708
              ],
              [
                60.9239099,
                27.5017286
              ],
              [
                60.9216833,
                27.5017286
              ],
              [
                60.9189107,
                27.5020075
              ],
              [
                60.9084644,
                27.5023775
              ],
              [
                60.8998125,
                27.5026821
              ],
              [
                60.8933278,
                27.5031894
              ],
              [
                60.8842835,
                27.5040772
              ],
              [
                60.8661246,
                27.5050662
              ],
              [
                60.8477187,
                27.5057929
              ],
              [
                60.8259424,
                27.5081113
              ],
              [
                60.8007583,
                27.5127965
              ],
              [
                60.782197,
                27.5208653
              ],
              [
                60.7725458,
                27.5292124
              ],
              [
                60.7574843,
                27.5379571
              ],
              [
                60.7499264,
                27.5402651
              ],
              [
                60.7369833,
                27.5450095
              ],
              [
                60.7126075,
                27.5680829
              ],
              [
                60.6674019,
                27.6015921
              ],
              [
                60.6071105,
                27.6504654
              ],
              [
                60.5624815,
                27.7055053
              ],
              [
                60.5368587,
                27.73128
              ],
              [
                60.5078762,
                27.7573895
              ],
              [
                60.4970871,
                27.7678733
              ],
              [
                60.4854169,
                27.780811
              ],
              [
                60.4773612,
                27.7865172
              ],
              [
                60.4670357,
                27.7962358
              ],
              [
                60.463171,
                27.7998304
              ],
              [
                60.4583941,
                27.803728
              ],
              [
                60.4497515,
                27.8110394
              ],
              [
                60.4105996,
                27.8695736
              ],
              [
                60.394678,
                27.8905979
              ],
              [
                60.3842386,
                27.9059608
              ],
              [
                60.3792318,
                27.9248976
              ],
              [
                60.3730361,
                27.9399397
              ],
              [
                60.3624915,
                27.950663
              ],
              [
                60.353125,
                27.9614304
              ],
              [
                60.3481532,
                27.9748221
              ],
              [
                60.3445282,
                27.9892727
              ],
              [
                60.3412078,
                27.9987048
              ],
              [
                60.3367195,
                28.0033034
              ],
              [
                60.3317187,
                28.0082255
              ],
              [
                60.323319,
                28.0342658
              ],
              [
                60.3196785,
                28.0448038
              ],
              [
                60.3160401,
                28.0542977
              ],
              [
                60.3107579,
                28.0695507
              ],
              [
                60.3066627,
                28.082879
              ],
              [
                60.3012328,
                28.0981313
              ],
              [
                60.306077,
                28.1297972
              ],
              [
                60.3071307,
                28.1477627
              ],
              [
                60.2939984,
                28.1570711
              ],
              [
                60.2775189,
                28.1543468
              ],
              [
                60.2655026,
                28.1485197
              ],
              [
                60.2595805,
                28.1452652
              ],
              [
                60.2503964,
                28.1419354
              ],
              [
                60.2450751,
                28.1406485
              ],
              [
                60.2406975,
                28.1405731
              ],
              [
                60.232914,
                28.1574427
              ],
              [
                60.2280944,
                28.1718312
              ],
              [
                60.220184,
                28.1909674
              ],
              [
                60.2057644,
                28.2148699
              ],
              [
                60.1909452,
                28.235728
              ],
              [
                60.1718527,
                28.2587186
              ],
              [
                60.1470461,
                28.2924798
              ],
              [
                60.1441708,
                28.2976817
              ],
              [
                60.142152,
                28.3050188
              ],
              [
                60.1388272,
                28.3194348
              ],
              [
                60.1372186,
                28.3311556
              ],
              [
                60.1363988,
                28.3397512
              ],
              [
                60.1360555,
                28.3553289
              ],
              [
                60.1360701,
                28.3836985
              ],
              [
                60.140874,
                28.4112397
              ],
              [
                60.1457057,
                28.4234121
              ],
              [
                60.1491163,
                28.4350346
              ],
              [
                60.1618193,
                28.4542037
              ],
              [
                60.1820753,
                28.4756328
              ],
              [
                60.2077387,
                28.4890615
              ],
              [
                60.2229298,
                28.4945819
              ],
              [
                60.2326297,
                28.4989432
              ],
              [
                60.242258,
                28.500757
              ],
              [
                60.2382086,
                28.5153104
              ],
              [
                60.2315138,
                28.5296389
              ],
              [
                60.2134894,
                28.5305438
              ],
              [
                60.2206991,
                28.5407988
              ],
              [
                60.2066229,
                28.5483385
              ],
              [
                60.1935532,
                28.5521003
              ],
              [
                60.1699748,
                28.5598432
              ],
              [
                60.1506753,
                28.5638297
              ],
              [
                60.1167116,
                28.5698824
              ],
              [
                60.0823814,
                28.5752565
              ],
              [
                60.0607051,
                28.5794666
              ],
              [
                60.0161579,
                28.5818685
              ],
              [
                59.9712684,
                28.5815048
              ],
              [
                59.9080913,
                28.5814321
              ],
              [
                59.8524661,
                28.5820892
              ],
              [
                59.7844345,
                28.5823508
              ],
              [
                59.7446821,
                28.582713
              ],
              [
                59.7257994,
                28.5787937
              ],
              [
                59.7227095,
                28.5792459
              ],
              [
                59.7130964,
                28.5774369
              ],
              [
                59.6970081,
                28.5776668
              ],
              [
                59.6205665,
                28.5794848
              ],
              [
                59.585699,
                28.5801563
              ],
              [
                59.5978032,
                28.5717089
              ],
              [
                59.6821137,
                28.5189455
              ],
              [
                59.7254961,
                28.4868834
              ],
              [
                59.709973,
                28.4390211
              ],
              [
                59.6371254,
                28.3995574
              ],
              [
                59.5559179,
                28.3835777
              ],
              [
                59.4433078,
                28.3977557
              ],
              [
                59.415842,
                28.3448278
              ],
              [
                59.4186717,
                28.3197897
              ],
              [
                59.4383044,
                28.3081032
              ],
              [
                59.4783579,
                28.287017
              ],
              [
                59.5310793,
                28.3116972
              ],
              [
                59.5964291,
                28.2957708
              ],
              [
                59.6050252,
                28.2680902
              ],
              [
                59.5779227,
                28.2259113
              ],
              [
                59.5650865,
                28.2039522
              ],
              [
                59.5227946,
                28.1584981
              ],
              [
                59.5139315,
                28.1392267
              ],
              [
                59.506103,
                28.1205522
              ],
              [
                59.4973983,
                28.0982945
              ],
              [
                59.4832945,
                28.0859233
              ],
              [
                59.5220382,
                28.0550237
              ],
              [
                59.5357724,
                28.0442869
              ],
              [
                59.5401477,
                28.0427054
              ],
              [
                59.5452976,
                28.0417964
              ],
              [
                59.5482158,
                28.0420994
              ],
              [
                59.5493316,
                28.0447129
              ],
              [
                59.5516491,
                28.0451674
              ],
              [
                59.5530653,
                28.0412282
              ],
              [
                59.5519495,
                28.03441
              ],
              [
                59.5504903,
                28.0246745
              ],
              [
                59.5457696,
                28.0174385
              ],
              [
                59.5523357,
                28.0164914
              ],
              [
                59.5637512,
                28.0153548
              ],
              [
                59.5677423,
                28.0151653
              ],
              [
                59.5748234,
                28.0139435
              ],
              [
                59.5813992,
                28.0135536
              ],
              [
                59.6058832,
                28.0111867
              ],
              [
                59.6162415,
                28.0103771
              ],
              [
                59.6264412,
                28.0087099
              ],
              [
                59.6332203,
                28.0082522
              ],
              [
                59.6432975,
                28.007646
              ],
              [
                59.6622255,
                28.0080768
              ],
              [
                59.6679418,
                28.008001
              ],
              [
                59.7054951,
                28.0069919
              ],
              [
                59.7272832,
                28.0042308
              ],
              [
                59.7298071,
                28.0021089
              ],
              [
                59.7231263,
                27.9959021
              ],
              [
                59.7048567,
                27.9924311
              ],
              [
                59.6842199,
                27.984964
              ],
              [
                59.6710394,
                27.9769689
              ],
              [
                59.6615384,
                27.9577828
              ],
              [
                59.6692632,
                27.9160785
              ],
              [
                59.7197014,
                27.8841969
              ],
              [
                59.7176782,
                27.855952
              ],
              [
                59.6867205,
                27.8003036
              ],
              [
                59.6884268,
                27.7802217
              ],
              [
                59.680921,
                27.7586581
              ],
              [
                59.6653022,
                27.7490008
              ],
              [
                59.6596219,
                27.7431242
              ],
              [
                59.6535325,
                27.7373426
              ],
              [
                59.6487652,
                27.731492
              ],
              [
                59.6442193,
                27.7264524
              ],
              [
                59.6390119,
                27.7210503
              ],
              [
                59.6356288,
                27.7174352
              ],
              [
                59.6284746,
                27.7111786
              ],
              [
                59.6196622,
                27.7016997
              ],
              [
                59.6095847,
                27.6871764
              ],
              [
                59.6012857,
                27.6718978
              ],
              [
                59.5931514,
                27.6609114
              ],
              [
                59.5805213,
                27.6472935
              ],
              [
                59.5764748,
                27.6416274
              ],
              [
                59.5737918,
                27.6378344
              ],
              [
                59.5710238,
                27.6346311
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554987,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خاش",
          "name:en": "Khash County",
          "name:uk": "Хаш",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278689",
          "wikipedia": "en:Khash County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.4670357,
                27.7962358
              ],
              [
                60.4773612,
                27.7865172
              ],
              [
                60.4854169,
                27.780811
              ],
              [
                60.4970871,
                27.7678733
              ],
              [
                60.5078762,
                27.7573895
              ],
              [
                60.5368587,
                27.73128
              ],
              [
                60.5624815,
                27.7055053
              ],
              [
                60.6071105,
                27.6504654
              ],
              [
                60.6674019,
                27.6015921
              ],
              [
                60.7126075,
                27.5680829
              ],
              [
                60.7369833,
                27.5450095
              ],
              [
                60.7499264,
                27.5402651
              ],
              [
                60.7574843,
                27.5379571
              ],
              [
                60.7725458,
                27.5292124
              ],
              [
                60.782197,
                27.5208653
              ],
              [
                60.8007583,
                27.5127965
              ],
              [
                60.8259424,
                27.5081113
              ],
              [
                60.8477187,
                27.5057929
              ],
              [
                60.8661246,
                27.5050662
              ],
              [
                60.8842835,
                27.5040772
              ],
              [
                60.8933278,
                27.5031894
              ],
              [
                60.8998125,
                27.5026821
              ],
              [
                60.9084644,
                27.5023775
              ],
              [
                60.9189107,
                27.5020075
              ],
              [
                60.9216833,
                27.5017286
              ],
              [
                60.9239099,
                27.5017286
              ],
              [
                60.9300171,
                27.5011708
              ],
              [
                60.9372561,
                27.5007397
              ],
              [
                60.9472812,
                27.5017295
              ],
              [
                60.9527251,
                27.5023889
              ],
              [
                60.9609831,
                27.5017294
              ],
              [
                60.9747156,
                27.5022323
              ],
              [
                60.9811274,
                27.5014966
              ],
              [
                60.9872091,
                27.5001421
              ],
              [
                60.9944026,
                27.494432
              ],
              [
                60.9974006,
                27.4914452
              ],
              [
                60.999349,
                27.488106
              ],
              [
                60.9999703,
                27.4866478
              ],
              [
                61.0028077,
                27.4833193
              ],
              [
                61.0067312,
                27.4791313
              ],
              [
                61.0091429,
                27.4756428
              ],
              [
                61.0156207,
                27.4690938
              ],
              [
                61.026306,
                27.4535988
              ],
              [
                61.0368201,
                27.4349991
              ],
              [
                61.0624443,
                27.4374356
              ],
              [
                61.0873843,
                27.4504002
              ],
              [
                61.1516792,
                27.4639609
              ],
              [
                61.1907576,
                27.4804055
              ],
              [
                61.2067061,
                27.4810156
              ],
              [
                61.2355612,
                27.5035516
              ],
              [
                61.2952331,
                27.506048
              ],
              [
                61.3121824,
                27.507827
              ],
              [
                61.3268703,
                27.5119274
              ],
              [
                61.3435362,
                27.5204512
              ],
              [
                61.3469694,
                27.5273017
              ],
              [
                61.3469694,
                27.5371199
              ],
              [
                61.3436832,
                27.5500099
              ],
              [
                61.3380473,
                27.5645013
              ],
              [
                61.3215575,
                27.5903991
              ],
              [
                61.297531,
                27.6189045
              ],
              [
                61.2860698,
                27.6397328
              ],
              [
                61.2714384,
                27.6652854
              ],
              [
                61.2648086,
                27.6777893
              ],
              [
                61.2531718,
                27.7077718
              ],
              [
                61.2338944,
                27.7548351
              ],
              [
                61.2290381,
                27.787606
              ],
              [
                61.2158244,
                27.8291791
              ],
              [
                61.2139362,
                27.8327636
              ],
              [
                61.2025438,
                27.8660813
              ],
              [
                61.1971515,
                27.9009011
              ],
              [
                61.2005219,
                27.9245109
              ],
              [
                61.2064647,
                27.9408819
              ],
              [
                61.2105495,
                27.948026
              ],
              [
                61.2248022,
                27.9528487
              ],
              [
                61.238838,
                27.9350692
              ],
              [
                61.2601665,
                27.9355539
              ],
              [
                61.2671999,
                27.9449644
              ],
              [
                61.2671347,
                27.9515362
              ],
              [
                61.2694452,
                27.9581875
              ],
              [
                61.2699737,
                27.9615077
              ],
              [
                61.2718521,
                27.9640238
              ],
              [
                61.2932691,
                27.9677139
              ],
              [
                61.2995616,
                27.9685993
              ],
              [
                61.3044395,
                27.9688022
              ],
              [
                61.3094395,
                27.9688023
              ],
              [
                61.3164494,
                27.9685776
              ],
              [
                61.3240219,
                27.9689989
              ],
              [
                61.3334297,
                27.9696594
              ],
              [
                61.3430638,
                27.9707478
              ],
              [
                61.3484061,
                27.9713515
              ],
              [
                61.3551586,
                27.9719065
              ],
              [
                61.3615574,
                27.9720067
              ],
              [
                61.3686788,
                27.9719553
              ],
              [
                61.3949708,
                27.9710455
              ],
              [
                61.3994178,
                27.9704877
              ],
              [
                61.4132743,
                27.971955
              ],
              [
                61.419702,
                27.9732193
              ],
              [
                61.4253371,
                27.9736741
              ],
              [
                61.4314043,
                27.9741739
              ],
              [
                61.4348707,
                27.974201
              ],
              [
                61.4486276,
                27.9731118
              ],
              [
                61.4537297,
                27.9727842
              ],
              [
                61.4575897,
                27.9726326
              ],
              [
                61.4663626,
                27.9724296
              ],
              [
                61.4758148,
                27.9725387
              ],
              [
                61.4841903,
                27.973118
              ],
              [
                61.4875487,
                27.9732426
              ],
              [
                61.4941295,
                27.9731667
              ],
              [
                61.5009836,
                27.9732769
              ],
              [
                61.5029799,
                27.97261
              ],
              [
                61.5093055,
                27.969502
              ],
              [
                61.5186081,
                27.9657116
              ],
              [
                61.5270599,
                27.9618003
              ],
              [
                61.5369718,
                27.9570999
              ],
              [
                61.5492725,
                27.9504355
              ],
              [
                61.5637867,
                27.9441863
              ],
              [
                61.5722309,
                27.9309921
              ],
              [
                61.5815447,
                27.9223032
              ],
              [
                61.6016609,
                27.9098524
              ],
              [
                61.6212707,
                27.9113178
              ],
              [
                61.6286421,
                27.9224287
              ],
              [
                61.6296989,
                27.9306342
              ],
              [
                61.6107991,
                27.9491358
              ],
              [
                61.605643,
                27.9625614
              ],
              [
                61.6091433,
                27.9728711
              ],
              [
                61.6272362,
                27.9992961
              ],
              [
                61.6491184,
                28.0496053
              ],
              [
                61.6842545,
                28.0809644
              ],
              [
                61.7171605,
                28.1070844
              ],
              [
                61.759229,
                28.1265905
              ],
              [
                61.7883918,
                28.1402745
              ],
              [
                61.79613,
                28.1400044
              ],
              [
                61.8327708,
                28.1357326
              ],
              [
                61.8675359,
                28.128476
              ],
              [
                61.8808972,
                28.1236875
              ],
              [
                61.9214996,
                28.108536
              ],
              [
                61.9361662,
                28.1069328
              ],
              [
                61.9439997,
                28.1087735
              ],
              [
                61.9625145,
                28.1083193
              ],
              [
                61.9795011,
                28.1021117
              ],
              [
                62.0005623,
                28.0899664
              ],
              [
                62.0262012,
                28.081
              ],
              [
                62.0413414,
                28.0755475
              ],
              [
                62.0515075,
                28.0719362
              ],
              [
                62.0676988,
                28.0698485
              ],
              [
                62.1215056,
                28.0651642
              ],
              [
                62.1384265,
                28.061788
              ],
              [
                62.1660183,
                28.0565123
              ],
              [
                62.1904648,
                28.0504219
              ],
              [
                62.2172939,
                28.0419898
              ],
              [
                62.2420243,
                28.0299459
              ],
              [
                62.2650989,
                28.0250413
              ],
              [
                62.2759029,
                28.0202731
              ],
              [
                62.3316244,
                28.0277981
              ],
              [
                62.3674133,
                28.0326468
              ],
              [
                62.4397218,
                28.0457101
              ],
              [
                62.4751674,
                28.0663126
              ],
              [
                62.5011977,
                28.0800958
              ],
              [
                62.5176128,
                28.092256
              ],
              [
                62.5510748,
                28.0996762
              ],
              [
                62.5800712,
                28.1235714
              ],
              [
                62.6104178,
                28.1460054
              ],
              [
                62.6371762,
                28.1549522
              ],
              [
                62.7019234,
                28.1572357
              ],
              [
                62.7230069,
                28.1579792
              ],
              [
                62.7432629,
                28.1625194
              ],
              [
                62.7840067,
                28.1656224
              ],
              [
                62.794427,
                28.2272528
              ],
              [
                62.7929605,
                28.2789044
              ],
              [
                62.6879425,
                28.2630526
              ],
              [
                62.597191,
                28.24842
              ],
              [
                62.596553,
                28.250002
              ],
              [
                62.595425,
                28.251245
              ],
              [
                62.594813,
                28.251711
              ],
              [
                62.593638,
                28.252734
              ],
              [
                62.593176,
                28.253251
              ],
              [
                62.591686,
                28.25452
              ],
              [
                62.589056,
                28.25693
              ],
              [
                62.587418,
                28.258302
              ],
              [
                62.585457,
                28.259816
              ],
              [
                62.584691,
                28.260655
              ],
              [
                62.583976,
                28.261617
              ],
              [
                62.583533,
                28.262641
              ],
              [
                62.583517,
                28.263305
              ],
              [
                62.583048,
                28.263814
              ],
              [
                62.582845,
                28.264538
              ],
              [
                62.582139,
                28.266141
              ],
              [
                62.581257,
                28.266886
              ],
              [
                62.579754,
                28.267865
              ],
              [
                62.578442,
                28.269222
              ],
              [
                62.577637,
                28.269762
              ],
              [
                62.577363,
                28.270065
              ],
              [
                62.576345,
                28.270984
              ],
              [
                62.575098,
                28.271928
              ],
              [
                62.574739,
                28.272272
              ],
              [
                62.574422,
                28.272464
              ],
              [
                62.574053,
                28.272601
              ],
              [
                62.573609,
                28.272923
              ],
              [
                62.572598,
                28.273526
              ],
              [
                62.571815,
                28.273848
              ],
              [
                62.568999,
                28.275669
              ],
              [
                62.568666,
                28.275722
              ],
              [
                62.568062,
                28.276036
              ],
              [
                62.567689,
                28.276597
              ],
              [
                62.567155,
                28.277729
              ],
              [
                62.566915,
                28.278003
              ],
              [
                62.566461,
                28.278395
              ],
              [
                62.565884,
                28.278604
              ],
              [
                62.56471,
                28.279472
              ],
              [
                62.563746,
                28.280432
              ],
              [
                62.562662,
                28.281298
              ],
              [
                62.562034,
                28.281944
              ],
              [
                62.560916,
                28.282652
              ],
              [
                62.557161,
                28.285182
              ],
              [
                62.553523,
                28.288791
              ],
              [
                62.552973,
                28.289474
              ],
              [
                62.552031,
                28.290379
              ],
              [
                62.551601,
                28.290878
              ],
              [
                62.550626,
                28.291534
              ],
              [
                62.549285,
                28.292015
              ],
              [
                62.547225,
                28.294741
              ],
              [
                62.546515,
                28.296003
              ],
              [
                62.545663,
                28.297299
              ],
              [
                62.544475,
                28.298935
              ],
              [
                62.542831,
                28.300532
              ],
              [
                62.541618,
                28.301584
              ],
              [
                62.539959,
                28.303184
              ],
              [
                62.539299,
                28.303936
              ],
              [
                62.538723,
                28.304874
              ],
              [
                62.537687,
                28.305846
              ],
              [
                62.534934,
                28.307825
              ],
              [
                62.534376,
                28.308472
              ],
              [
                62.533734,
                28.30908
              ],
              [
                62.532666,
                28.309889
              ],
              [
                62.531101,
                28.311409
              ],
              [
                62.52977,
                28.312893
              ],
              [
                62.528158,
                28.314899
              ],
              [
                62.527146,
                28.31603
              ],
              [
                62.525481,
                28.317739
              ],
              [
                62.524638,
                28.318491
              ],
              [
                62.523017,
                28.319463
              ],
              [
                62.520958,
                28.319464
              ],
              [
                62.518806,
                28.319644
              ],
              [
                62.516372,
                28.320071
              ],
              [
                62.515275,
                28.320489
              ],
              [
                62.514381,
                28.321048
              ],
              [
                62.513266,
                28.321956
              ],
              [
                62.512278,
                28.322855
              ],
              [
                62.510949,
                28.324561
              ],
              [
                62.510534,
                28.325345
              ],
              [
                62.510261,
                28.325989
              ],
              [
                62.509009,
                28.330533
              ],
              [
                62.50793,
                28.334694
              ],
              [
                62.507802,
                28.335953
              ],
              [
                62.507812,
                28.337323
              ],
              [
                62.507575,
                28.33796
              ],
              [
                62.507078,
                28.338537
              ],
              [
                62.505756,
                28.340512
              ],
              [
                62.505003,
                28.341124
              ],
              [
                62.503506,
                28.341836
              ],
              [
                62.502505,
                28.342373
              ],
              [
                62.501797,
                28.342962
              ],
              [
                62.501432,
                28.343599
              ],
              [
                62.500673,
                28.345533
              ],
              [
                62.50099,
                28.346707
              ],
              [
                62.501628,
                28.348453
              ],
              [
                62.502049,
                28.350369
              ],
              [
                62.50216,
                28.351526
              ],
              [
                62.502136,
                28.35223
              ],
              [
                62.501816,
                28.353389
              ],
              [
                62.501514,
                28.354033
              ],
              [
                62.501025,
                28.354813
              ],
              [
                62.500171,
                28.355894
              ],
              [
                62.499443,
                28.356073
              ],
              [
                62.497361,
                28.356906
              ],
              [
                62.495457,
                28.358095
              ],
              [
                62.49403,
                28.35982
              ],
              [
                62.493077,
                28.362
              ],
              [
                62.492781,
                28.363093
              ],
              [
                62.492414,
                28.365169
              ],
              [
                62.491394,
                28.368088
              ],
              [
                62.491204,
                28.368849
              ],
              [
                62.490915,
                28.370422
              ],
              [
                62.490497,
                28.371382
              ],
              [
                62.489723,
                28.372353
              ],
              [
                62.488771,
                28.373405
              ],
              [
                62.48755,
                28.374481
              ],
              [
                62.486364,
                28.374873
              ],
              [
                62.485161,
                28.374602
              ],
              [
                62.483887,
                28.374651
              ],
              [
                62.482243,
                28.374791
              ],
              [
                62.480294,
                28.374832
              ],
              [
                62.47919,
                28.374811
              ],
              [
                62.476992,
                28.374583
              ],
              [
                62.47405,
                28.374976
              ],
              [
                62.470733,
                28.375543
              ],
              [
                62.468047,
                28.376449
              ],
              [
                62.465315,
                28.376924
              ],
              [
                62.464246,
                28.377313
              ],
              [
                62.463069,
                28.377888
              ],
              [
                62.461401,
                28.37921
              ],
              [
                62.460104,
                28.380414
              ],
              [
                62.456874,
                28.383216
              ],
              [
                62.45524,
                28.384134
              ],
              [
                62.451196,
                28.38601
              ],
              [
                62.44959,
                28.386809
              ],
              [
                62.448528,
                28.387537
              ],
              [
                62.447557,
                28.388508
              ],
              [
                62.446421,
                28.389184
              ],
              [
                62.444997,
                28.389806
              ],
              [
                62.443374,
                28.39058
              ],
              [
                62.441868,
                28.391185
              ],
              [
                62.43815,
                28.392851
              ],
              [
                62.437345,
                28.393601
              ],
              [
                62.437117,
                28.394127
              ],
              [
                62.436265,
                28.397899
              ],
              [
                62.435792,
                28.398245
              ],
              [
                62.434533,
                28.399326
              ],
              [
                62.434111,
                28.400357
              ],
              [
                62.433686,
                28.400966
              ],
              [
                62.432411,
                28.402304
              ],
              [
                62.42899,
                28.406329
              ],
              [
                62.425597,
                28.408494
              ],
              [
                62.424149,
                28.409276
              ],
              [
                62.42311,
                28.409679
              ],
              [
                62.422557,
                28.409978
              ],
              [
                62.421009,
                28.410979
              ],
              [
                62.42069,
                28.411229
              ],
              [
                62.420048,
                28.411985
              ],
              [
                62.419333,
                28.412636
              ],
              [
                62.418876,
                28.412966
              ],
              [
                62.418397,
                28.413394
              ],
              [
                62.418219,
                28.413854
              ],
              [
                62.417619,
                28.414646
              ],
              [
                62.416186,
                28.415717
              ],
              [
                62.413605,
                28.417847
              ],
              [
                62.412212,
                28.418816
              ],
              [
                62.4117,
                28.419128
              ],
              [
                62.410335,
                28.419703
              ],
              [
                62.408554,
                28.420354
              ],
              [
                62.406597,
                28.420936
              ],
              [
                62.405393,
                28.421789
              ],
              [
                62.404735,
                28.422482
              ],
              [
                62.403375,
                28.423106
              ],
              [
                62.402182,
                28.423567
              ],
              [
                62.399697,
                28.424906
              ],
              [
                62.398625,
                28.42555
              ],
              [
                62.397698,
                28.426235
              ],
              [
                62.396171,
                28.427599
              ],
              [
                62.395259,
                28.428203
              ],
              [
                62.392468,
                28.430296
              ],
              [
                62.391584,
                28.431109
              ],
              [
                62.390737,
                28.431661
              ],
              [
                62.389486,
                28.432248
              ],
              [
                62.388535,
                28.432674
              ],
              [
                62.387444,
                28.432795
              ],
              [
                62.38272,
                28.433163
              ],
              [
                62.379238,
                28.433563
              ],
              [
                62.377348,
                28.433593
              ],
              [
                62.375253,
                28.433448
              ],
              [
                62.374385,
                28.433276
              ],
              [
                62.372474,
                28.433058
              ],
              [
                62.371553,
                28.433036
              ],
              [
                62.370788,
                28.432947
              ],
              [
                62.368743,
                28.432955
              ],
              [
                62.367094,
                28.432846
              ],
              [
                62.365724,
                28.432672
              ],
              [
                62.364724,
                28.432675
              ],
              [
                62.364648,
                28.432636
              ],
              [
                62.360936,
                28.433338
              ],
              [
                62.358875,
                28.433615
              ],
              [
                62.357255,
                28.434133
              ],
              [
                62.353621,
                28.435078
              ],
              [
                62.351979,
                28.435611
              ],
              [
                62.350832,
                28.436066
              ],
              [
                62.347666,
                28.437858
              ],
              [
                62.345674,
                28.439184
              ],
              [
                62.344219,
                28.440257
              ],
              [
                62.342999,
                28.440828
              ],
              [
                62.340998,
                28.442061
              ],
              [
                62.338566,
                28.443849
              ],
              [
                62.337564,
                28.444471
              ],
              [
                62.336526,
                28.445186
              ],
              [
                62.333577,
                28.446839
              ],
              [
                62.332989,
                28.447051
              ],
              [
                62.331777,
                28.447592
              ],
              [
                62.331485,
                28.447818
              ],
              [
                62.329873,
                28.448799
              ],
              [
                62.328281,
                28.449457
              ],
              [
                62.326656,
                28.449972
              ],
              [
                62.325617,
                28.450176
              ],
              [
                62.322742,
                28.450531
              ],
              [
                62.321343,
                28.45037
              ],
              [
                62.317101,
                28.450737
              ],
              [
                62.313348,
                28.451349
              ],
              [
                62.312341,
                28.451347
              ],
              [
                62.310777,
                28.451442
              ],
              [
                62.308265,
                28.451748
              ],
              [
                62.306408,
                28.452201
              ],
              [
                62.303503,
                28.452255
              ],
              [
                62.300752,
                28.452415
              ],
              [
                62.299733,
                28.452539
              ],
              [
                62.296997,
                28.452754
              ],
              [
                62.295025,
                28.452826
              ],
              [
                62.292576,
                28.452526
              ],
              [
                62.290482,
                28.452138
              ],
              [
                62.287141,
                28.451347
              ],
              [
                62.283371,
                28.450818
              ],
              [
                62.282794,
                28.450635
              ],
              [
                62.282088,
                28.450552
              ],
              [
                62.28036,
                28.450526
              ],
              [
                62.278664,
                28.450731
              ],
              [
                62.278008,
                28.450887
              ],
              [
                62.27528,
                28.451979
              ],
              [
                62.272558,
                28.452709
              ],
              [
                62.271792,
                28.453064
              ],
              [
                62.269754,
                28.454077
              ],
              [
                62.267163,
                28.456013
              ],
              [
                62.263423,
                28.457902
              ],
              [
                62.261329,
                28.458727
              ],
              [
                62.256908,
                28.460274
              ],
              [
                62.255491,
                28.460759
              ],
              [
                62.251802,
                28.461915
              ],
              [
                62.24976,
                28.462663
              ],
              [
                62.248672,
                28.462938
              ],
              [
                62.247747,
                28.462925
              ],
              [
                62.247106,
                28.463015
              ],
              [
                62.245601,
                28.46335
              ],
              [
                62.243481,
                28.463218
              ],
              [
                62.242213,
                28.463025
              ],
              [
                62.240997,
                28.462964
              ],
              [
                62.237906,
                28.462464
              ],
              [
                62.232107,
                28.463136
              ],
              [
                62.22741,
                28.464056
              ],
              [
                62.22489,
                28.465
              ],
              [
                62.224566,
                28.465031
              ],
              [
                62.22326,
                28.46531
              ],
              [
                62.222346,
                28.465413
              ],
              [
                62.221634,
                28.465683
              ],
              [
                62.217359,
                28.467014
              ],
              [
                62.211277,
                28.468462
              ],
              [
                62.208119,
                28.469562
              ],
              [
                62.207078,
                28.469871
              ],
              [
                62.203148,
                28.472155
              ],
              [
                62.199046,
                28.475212
              ],
              [
                62.197253,
                28.476149
              ],
              [
                62.196264,
                28.476611
              ],
              [
                62.19545,
                28.477071
              ],
              [
                62.193877,
                28.478051
              ],
              [
                62.191392,
                28.479761
              ],
              [
                62.187734,
                28.48155
              ],
              [
                62.179916,
                28.484527
              ],
              [
                62.176291,
                28.485802
              ],
              [
                62.173878,
                28.486409
              ],
              [
                62.171533,
                28.486645
              ],
              [
                62.168297,
                28.488768
              ],
              [
                62.167533,
                28.488885
              ],
              [
                62.158319,
                28.489831
              ],
              [
                62.152109,
                28.490179
              ],
              [
                62.141615,
                28.492939
              ],
              [
                62.141329,
                28.493071
              ],
              [
                62.140329,
                28.493827
              ],
              [
                62.139144,
                28.494392
              ],
              [
                62.137714,
                28.49466
              ],
              [
                62.137105,
                28.494726
              ],
              [
                62.133934,
                28.494611
              ],
              [
                62.131517,
                28.494978
              ],
              [
                62.128029,
                28.49526
              ],
              [
                62.126625,
                28.495532
              ],
              [
                62.124542,
                28.496276
              ],
              [
                62.119445,
                28.496927
              ],
              [
                62.118006,
                28.497187
              ],
              [
                62.114543,
                28.497601
              ],
              [
                62.109484,
                28.49758
              ],
              [
                62.107581,
                28.497677
              ],
              [
                62.103564,
                28.499483
              ],
              [
                62.099416,
                28.500749
              ],
              [
                62.095785,
                28.502009
              ],
              [
                62.092969,
                28.503199
              ],
              [
                62.090482,
                28.504364
              ],
              [
                62.089495,
                28.50488
              ],
              [
                62.088512,
                28.505486
              ],
              [
                62.08764,
                28.50573
              ],
              [
                62.08663,
                28.505948
              ],
              [
                62.085381,
                28.505963
              ],
              [
                62.083267,
                28.506307
              ],
              [
                62.082571,
                28.506465
              ],
              [
                62.080274,
                28.50646
              ],
              [
                62.076939,
                28.506381
              ],
              [
                62.074448,
                28.506476
              ],
              [
                62.071979,
                28.506727
              ],
              [
                62.069587,
                28.506913
              ],
              [
                62.06552,
                28.507839
              ],
              [
                62.062047,
                28.508255
              ],
              [
                62.057555,
                28.508545
              ],
              [
                62.0564037,
                28.5085945
              ],
              [
                62.0559548,
                28.5075105
              ],
              [
                62.0480459,
                28.4919075
              ],
              [
                62.0379519,
                28.4787491
              ],
              [
                62.0314497,
                28.4760251
              ],
              [
                62.0144872,
                28.4515433
              ],
              [
                62.009463,
                28.4442909
              ],
              [
                62.002244,
                28.4435913
              ],
              [
                61.9941736,
                28.4382032
              ],
              [
                61.9842049,
                28.437987
              ],
              [
                61.9687025,
                28.4383844
              ],
              [
                61.8791839,
                28.5053737
              ],
              [
                61.8634291,
                28.5100541
              ],
              [
                61.7503735,
                28.532957
              ],
              [
                61.5785115,
                28.5518147
              ],
              [
                61.5739753,
                28.5532238
              ],
              [
                61.5730432,
                28.5565625
              ],
              [
                61.5745803,
                28.558039
              ],
              [
                61.5769967,
                28.5603599
              ],
              [
                61.5781036,
                28.5606392
              ],
              [
                61.5791912,
                28.56118
              ],
              [
                61.5686594,
                28.5637852
              ],
              [
                61.5201332,
                28.5819525
              ],
              [
                61.5003251,
                28.6011967
              ],
              [
                61.4828248,
                28.6136923
              ],
              [
                61.4811584,
                28.6145302
              ],
              [
                61.4319858,
                28.6467474
              ],
              [
                61.4275459,
                28.6503602
              ],
              [
                61.4042066,
                28.6798037
              ],
              [
                61.3983737,
                28.6923093
              ],
              [
                61.3983737,
                28.6950844
              ],
              [
                61.3989338,
                28.7009138
              ],
              [
                61.3992066,
                28.7014725
              ],
              [
                61.4017066,
                28.7131405
              ],
              [
                61.4014333,
                28.7278631
              ],
              [
                61.3981005,
                28.7406398
              ],
              [
                61.3942073,
                28.7406398
              ],
              [
                61.3936534,
                28.7403605
              ],
              [
                61.3872674,
                28.7384233
              ],
              [
                61.3600411,
                28.7186999
              ],
              [
                61.3489276,
                28.7081401
              ],
              [
                61.3297615,
                28.6792543
              ],
              [
                61.3292076,
                28.6773082
              ],
              [
                61.3257853,
                28.669224
              ],
              [
                61.3230941,
                28.6628657
              ],
              [
                61.3222613,
                28.6617485
              ],
              [
                61.3189277,
                28.658415
              ],
              [
                61.3150417,
                28.6553608
              ],
              [
                61.310315,
                28.651748
              ],
              [
                61.3094813,
                28.6511984
              ],
              [
                61.3083751,
                28.649811
              ],
              [
                61.3061477,
                28.6481442
              ],
              [
                61.2742017,
                28.6150802
              ],
              [
                61.2555951,
                28.6050802
              ],
              [
                61.2461488,
                28.6023055
              ],
              [
                61.2344822,
                28.6000893
              ],
              [
                61.2317026,
                28.6000894
              ],
              [
                61.2308689,
                28.5998101
              ],
              [
                61.227536,
                28.5998101
              ],
              [
                61.2258688,
                28.5995308
              ],
              [
                61.2222562,
                28.5995308
              ],
              [
                61.220589,
                28.5992515
              ],
              [
                61.2186492,
                28.5992515
              ],
              [
                61.2178163,
                28.5989723
              ],
              [
                61.2142029,
                28.5989723
              ],
              [
                61.2133694,
                28.598693
              ],
              [
                61.2114225,
                28.598693
              ],
              [
                61.209756,
                28.5984138
              ],
              [
                61.2069762,
                28.5984138
              ],
              [
                61.2050363,
                28.5981345
              ],
              [
                61.2019761,
                28.5981346
              ],
              [
                61.1997558,
                28.5978552
              ],
              [
                61.1942035,
                28.597585
              ],
              [
                61.1867033,
                28.597585
              ],
              [
                61.1828094,
                28.5973057
              ],
              [
                61.1714234,
                28.5973057
              ],
              [
                61.1689233,
                28.5973058
              ],
              [
                61.1678099,
                28.597585
              ],
              [
                61.1478104,
                28.5978554
              ],
              [
                61.1469768,
                28.5975851
              ],
              [
                61.146571,
                28.5957233
              ],
              [
                61.1401621,
                28.5951393
              ],
              [
                61.1386433,
                28.5953654
              ],
              [
                61.1328753,
                28.5958896
              ],
              [
                61.1315673,
                28.5930594
              ],
              [
                61.1295344,
                28.5887074
              ],
              [
                61.1278012,
                28.5841457
              ],
              [
                61.1238097,
                28.5722359
              ],
              [
                61.1215478,
                28.5606405
              ],
              [
                61.112821,
                28.5434162
              ],
              [
                61.1087034,
                28.5337109
              ],
              [
                61.1050986,
                28.5156121
              ],
              [
                61.1041545,
                28.506486
              ],
              [
                61.1049269,
                28.4932859
              ],
              [
                61.1078603,
                28.4846067
              ],
              [
                61.1096136,
                28.4687503
              ],
              [
                61.1103632,
                28.4556435
              ],
              [
                61.1096765,
                28.425554
              ],
              [
                61.0815862,
                28.4288164
              ],
              [
                61.0635375,
                28.4306743
              ],
              [
                61.0403095,
                28.4235616
              ],
              [
                61.0337412,
                28.4209675
              ],
              [
                61.015959,
                28.4129228
              ],
              [
                61.0095744,
                28.4080912
              ],
              [
                60.9942584,
                28.3967139
              ],
              [
                60.9823516,
                28.3906488
              ],
              [
                60.9640849,
                28.3811642
              ],
              [
                60.9474238,
                28.3666336
              ],
              [
                60.9368922,
                28.3516031
              ],
              [
                60.9309984,
                28.3441802
              ],
              [
                60.9181593,
                28.3199469
              ],
              [
                60.916786,
                28.2965214
              ],
              [
                60.9209228,
                28.2506548
              ],
              [
                60.9273559,
                28.2257416
              ],
              [
                60.9214476,
                28.2293718
              ],
              [
                60.9157216,
                28.2330205
              ],
              [
                60.9090744,
                28.2368247
              ],
              [
                60.8959417,
                28.2434266
              ],
              [
                60.8821203,
                28.2515224
              ],
              [
                60.8599873,
                28.2563144
              ],
              [
                60.8385748,
                28.2582733
              ],
              [
                60.8099187,
                28.2585757
              ],
              [
                60.7816886,
                28.2517718
              ],
              [
                60.762315,
                28.2436867
              ],
              [
                60.7502352,
                28.2362009
              ],
              [
                60.7445973,
                28.241465
              ],
              [
                60.7214432,
                28.2406333
              ],
              [
                60.7107649,
                28.2402785
              ],
              [
                60.6913661,
                28.2403694
              ],
              [
                60.6735186,
                28.2403371
              ],
              [
                60.6582447,
                28.2404219
              ],
              [
                60.6293972,
                28.2402685
              ],
              [
                60.5923383,
                28.2404257
              ],
              [
                60.5575418,
                28.2402034
              ],
              [
                60.5562135,
                28.2360942
              ],
              [
                60.5543325,
                28.208022
              ],
              [
                60.5522249,
                28.1875747
              ],
              [
                60.5511182,
                28.1867373
              ],
              [
                60.5504347,
                28.1828329
              ],
              [
                60.548845,
                28.177409
              ],
              [
                60.5463145,
                28.1612773
              ],
              [
                60.547838,
                28.1580041
              ],
              [
                60.5592098,
                28.1261113
              ],
              [
                60.5535069,
                28.1161667
              ],
              [
                60.5384169,
                28.0928408
              ],
              [
                60.5277775,
                28.06666
              ],
              [
                60.5224174,
                28.0429814
              ],
              [
                60.5193023,
                28.023204
              ],
              [
                60.5195376,
                28.0086858
              ],
              [
                60.5154018,
                28.0021661
              ],
              [
                60.5189841,
                27.9946595
              ],
              [
                60.5244305,
                27.9770504
              ],
              [
                60.5571628,
                27.9154832
              ],
              [
                60.5721221,
                27.873763
              ],
              [
                60.5676087,
                27.8580503
              ],
              [
                60.5538422,
                27.838575
              ],
              [
                60.5179901,
                27.8190186
              ],
              [
                60.4986972,
                27.8145829
              ],
              [
                60.4836157,
                27.8082302
              ],
              [
                60.4708957,
                27.8003619
              ],
              [
                60.4670357,
                27.7962358
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555021,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دلگان",
          "name:en": "Dalagan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2723577",
          "wikipedia": "en:Dalgan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.8382624,
                27.1351502
              ],
              [
                58.8385358,
                27.1344983
              ],
              [
                58.8385358,
                27.1342286
              ],
              [
                58.8385359,
                27.1339499
              ],
              [
                58.8485422,
                27.1017277
              ],
              [
                58.8504821,
                27.096729
              ],
              [
                58.8552091,
                27.0872804
              ],
              [
                58.8593755,
                27.0742269
              ],
              [
                58.8599286,
                27.071449
              ],
              [
                58.8702084,
                27.048669
              ],
              [
                58.8713151,
                27.0472756
              ],
              [
                58.8746484,
                27.040893
              ],
              [
                58.8757616,
                27.0394997
              ],
              [
                58.8768749,
                27.0372794
              ],
              [
                58.8893747,
                27.0203346
              ],
              [
                58.8907615,
                27.0189413
              ],
              [
                58.9049277,
                27.0072735
              ],
              [
                58.908541,
                27.0053319
              ],
              [
                58.9129876,
                26.9999296
              ],
              [
                58.9118742,
                26.9886666
              ],
              [
                58.8988213,
                26.9697817
              ],
              [
                58.897988,
                26.9692244
              ],
              [
                58.8765946,
                26.933946
              ],
              [
                58.8643748,
                26.9086636
              ],
              [
                58.8502084,
                26.8619934
              ],
              [
                58.8493752,
                26.857554
              ],
              [
                58.8502084,
                26.846725
              ],
              [
                58.8504814,
                26.8361659
              ],
              [
                58.8502084,
                26.8331105
              ],
              [
                58.8507615,
                26.8311605
              ],
              [
                58.8510417,
                26.8303338
              ],
              [
                58.8535417,
                26.8247712
              ],
              [
                58.8602082,
                26.8206106
              ],
              [
                58.8613147,
                26.8194963
              ],
              [
                58.8629813,
                26.8186696
              ],
              [
                58.886321,
                26.8000505
              ],
              [
                58.899374,
                26.7911635
              ],
              [
                58.9057608,
                26.7878299
              ],
              [
                58.9560463,
                26.7672709
              ],
              [
                58.957153,
                26.7669923
              ],
              [
                58.9585465,
                26.7661657
              ],
              [
                58.9718794,
                26.7619965
              ],
              [
                58.9721753,
                26.7619965
              ],
              [
                58.9732662,
                26.7619965
              ],
              [
                58.9734638,
                26.7617998
              ],
              [
                58.9735462,
                26.7617179
              ],
              [
                58.9742731,
                26.7617179
              ],
              [
                58.9754861,
                26.7617179
              ],
              [
                58.9758815,
                26.7615213
              ],
              [
                58.9760463,
                26.7614393
              ],
              [
                58.9765753,
                26.7614394
              ],
              [
                58.9768795,
                26.7614394
              ],
              [
                58.9772702,
                26.7612427
              ],
              [
                58.9774327,
                26.7611609
              ],
              [
                58.9779666,
                26.7611609
              ],
              [
                58.9790995,
                26.7611609
              ],
              [
                58.9792973,
                26.7609642
              ],
              [
                58.9793796,
                26.7608823
              ],
              [
                58.9801064,
                26.7608823
              ],
              [
                58.9818796,
                26.7608822
              ],
              [
                58.9820724,
                26.7606855
              ],
              [
                58.9821526,
                26.7606037
              ],
              [
                58.9828843,
                26.7606037
              ],
              [
                58.9840992,
                26.7606037
              ],
              [
                58.9844901,
                26.760407
              ],
              [
                58.9846526,
                26.7603252
              ],
              [
                58.9851862,
                26.7603252
              ],
              [
                58.9865992,
                26.7603251
              ],
              [
                58.9865992,
                26.7601284
              ],
              [
                58.9865992,
                26.7600466
              ],
              [
                58.9871527,
                26.7600466
              ],
              [
                58.9872348,
                26.7601284
              ],
              [
                58.9874324,
                26.7603252
              ],
              [
                58.9881834,
                26.7599556
              ],
              [
                58.9885461,
                26.7597771
              ],
              [
                58.9890709,
                26.7597771
              ],
              [
                58.9893793,
                26.759777
              ],
              [
                58.989968,
                26.7595803
              ],
              [
                58.9902126,
                26.7594986
              ],
              [
                58.9904926,
                26.75922
              ],
              [
                58.9904926,
                26.7586629
              ],
              [
                58.9913563,
                26.7590837
              ],
              [
                59.0115988,
                26.768942
              ],
              [
                59.0149321,
                26.7703258
              ],
              [
                59.0163255,
                26.7711614
              ],
              [
                59.0827181,
                26.805882
              ],
              [
                59.1257704,
                26.8272779
              ],
              [
                59.1274372,
                26.8281047
              ],
              [
                59.1911391,
                26.8520914
              ],
              [
                59.2418888,
                26.8711683
              ],
              [
                59.278382,
                26.8787781
              ],
              [
                59.2810628,
                26.8808175
              ],
              [
                59.2875383,
                26.883748
              ],
              [
                59.2938015,
                26.8867827
              ],
              [
                59.3017746,
                26.8908613
              ],
              [
                59.3123199,
                26.8964839
              ],
              [
                59.3172025,
                26.8979226
              ],
              [
                59.3299119,
                26.8996273
              ],
              [
                59.3400555,
                26.9007433
              ],
              [
                59.3529181,
                26.9021085
              ],
              [
                59.3700517,
                26.9009466
              ],
              [
                59.3874773,
                26.9000133
              ],
              [
                59.4050792,
                26.8989441
              ],
              [
                59.4169666,
                26.8993823
              ],
              [
                59.4262546,
                26.8995294
              ],
              [
                59.4354605,
                26.900936
              ],
              [
                59.4384958,
                26.9014507
              ],
              [
                59.4435642,
                26.9031996
              ],
              [
                59.4505182,
                26.906022
              ],
              [
                59.4660131,
                26.9026543
              ],
              [
                59.4754759,
                26.9007208
              ],
              [
                59.4814117,
                26.8996558
              ],
              [
                59.4845785,
                26.8993447
              ],
              [
                59.4895315,
                26.9015036
              ],
              [
                59.4954524,
                26.9066132
              ],
              [
                59.5002808,
                26.9139675
              ],
              [
                59.5030242,
                26.9181371
              ],
              [
                59.5051057,
                26.9223529
              ],
              [
                59.5086222,
                26.9274802
              ],
              [
                59.510671,
                26.9304561
              ],
              [
                59.5169133,
                26.9350318
              ],
              [
                59.5241832,
                26.93286
              ],
              [
                59.5347401,
                26.9301054
              ],
              [
                59.5446153,
                26.9311564
              ],
              [
                59.5527237,
                26.9319174
              ],
              [
                59.569928,
                26.9324637
              ],
              [
                59.6070097,
                26.9260495
              ],
              [
                59.6460913,
                26.9285544
              ],
              [
                59.6768759,
                26.930641
              ],
              [
                59.6890366,
                26.9345941
              ],
              [
                59.7080279,
                26.9572849
              ],
              [
                59.7176426,
                26.9643406
              ],
              [
                59.7312926,
                26.9695078
              ],
              [
                59.746836,
                26.9863909
              ],
              [
                59.7570216,
                26.9974558
              ],
              [
                59.763409,
                27.0042518
              ],
              [
                59.7705801,
                27.0113055
              ],
              [
                59.7780925,
                27.0183487
              ],
              [
                59.7840529,
                27.0235209
              ],
              [
                59.7927604,
                27.0319756
              ],
              [
                59.8033577,
                27.042044
              ],
              [
                59.8168082,
                27.0544278
              ],
              [
                59.8394901,
                27.0759352
              ],
              [
                59.840821,
                27.0763961
              ],
              [
                59.8470315,
                27.0840534
              ],
              [
                59.8613377,
                27.1031197
              ],
              [
                59.8645234,
                27.1081675
              ],
              [
                59.8681519,
                27.1134203
              ],
              [
                59.87005,
                27.1174961
              ],
              [
                59.8711601,
                27.1205259
              ],
              [
                59.8797967,
                27.1340761
              ],
              [
                59.8866881,
                27.144545
              ],
              [
                59.9055289,
                27.1688334
              ],
              [
                59.9249437,
                27.1923272
              ],
              [
                59.9256563,
                27.1921018
              ],
              [
                59.9411981,
                27.1923534
              ],
              [
                59.9499267,
                27.1942427
              ],
              [
                59.9567547,
                27.1965175
              ],
              [
                59.9638785,
                27.2004606
              ],
              [
                59.969387,
                27.2006712
              ],
              [
                59.98003,
                27.1974649
              ],
              [
                59.9985694,
                27.1974649
              ],
              [
                60.0002002,
                27.1967779
              ],
              [
                60.015993,
                27.2007476
              ],
              [
                60.0186538,
                27.2142587
              ],
              [
                60.0077533,
                27.2241048
              ],
              [
                59.973936,
                27.2340263
              ],
              [
                59.9674129,
                27.2377657
              ],
              [
                59.9656083,
                27.2400437
              ],
              [
                59.9661877,
                27.242917
              ],
              [
                59.967885,
                27.246217
              ],
              [
                59.9716176,
                27.2499399
              ],
              [
                59.9832057,
                27.2560794
              ],
              [
                59.9882005,
                27.2585775
              ],
              [
                59.9983689,
                27.2657341
              ],
              [
                60.0000286,
                27.2674476
              ],
              [
                60.0022743,
                27.2709718
              ],
              [
                60.0064959,
                27.2776587
              ],
              [
                60.0144145,
                27.2896583
              ],
              [
                60.0198431,
                27.301153
              ],
              [
                60.0236408,
                27.3091894
              ],
              [
                60.0313406,
                27.3216959
              ],
              [
                60.0398575,
                27.3315381
              ],
              [
                60.0484607,
                27.3375764
              ],
              [
                60.0543438,
                27.3425778
              ],
              [
                60.0875567,
                27.354267
              ],
              [
                60.1056298,
                27.362605
              ],
              [
                60.1288807,
                27.3690732
              ],
              [
                60.1514997,
                27.3784147
              ],
              [
                60.1564161,
                27.3806471
              ],
              [
                60.1653478,
                27.3848895
              ],
              [
                60.1765892,
                27.3900458
              ],
              [
                60.2109145,
                27.4071284
              ],
              [
                60.2213327,
                27.4098456
              ],
              [
                60.1424536,
                27.4254284
              ],
              [
                60.1148031,
                27.4309078
              ],
              [
                60.0745924,
                27.4317724
              ],
              [
                60.0591624,
                27.4387707
              ],
              [
                60.0452612,
                27.444611
              ],
              [
                60.020369,
                27.4493745
              ],
              [
                59.9665552,
                27.4457842
              ],
              [
                59.764145,
                27.4851672
              ],
              [
                59.6774039,
                27.5017163
              ],
              [
                59.5789828,
                27.5179943
              ],
              [
                59.5637826,
                27.5403186
              ],
              [
                59.555036,
                27.5734918
              ],
              [
                59.5519109,
                27.5883076
              ],
              [
                59.5511503,
                27.603266
              ],
              [
                59.5509624,
                27.6070019
              ],
              [
                59.5521211,
                27.6115653
              ],
              [
                59.5531511,
                27.613885
              ],
              [
                59.5627641,
                27.6268894
              ],
              [
                59.5710238,
                27.6346311
              ],
              [
                59.5737918,
                27.6378344
              ],
              [
                59.5764748,
                27.6416274
              ],
              [
                59.5805213,
                27.6472935
              ],
              [
                59.5931514,
                27.6609114
              ],
              [
                59.6012857,
                27.6718978
              ],
              [
                59.6095847,
                27.6871764
              ],
              [
                59.6196622,
                27.7016997
              ],
              [
                59.6284746,
                27.7111786
              ],
              [
                59.6356288,
                27.7174352
              ],
              [
                59.6390119,
                27.7210503
              ],
              [
                59.6442193,
                27.7264524
              ],
              [
                59.6487652,
                27.731492
              ],
              [
                59.6535325,
                27.7373426
              ],
              [
                59.6596219,
                27.7431242
              ],
              [
                59.6653022,
                27.7490008
              ],
              [
                59.680921,
                27.7586581
              ],
              [
                59.6884268,
                27.7802217
              ],
              [
                59.6867205,
                27.8003036
              ],
              [
                59.7176782,
                27.855952
              ],
              [
                59.7197014,
                27.8841969
              ],
              [
                59.6692632,
                27.9160785
              ],
              [
                59.6615384,
                27.9577828
              ],
              [
                59.6710394,
                27.9769689
              ],
              [
                59.6842199,
                27.984964
              ],
              [
                59.7048567,
                27.9924311
              ],
              [
                59.7231263,
                27.9959021
              ],
              [
                59.7298071,
                28.0021089
              ],
              [
                59.7272832,
                28.0042308
              ],
              [
                59.7054951,
                28.0069919
              ],
              [
                59.6679418,
                28.008001
              ],
              [
                59.6622255,
                28.0080768
              ],
              [
                59.6432975,
                28.007646
              ],
              [
                59.6332203,
                28.0082522
              ],
              [
                59.6264412,
                28.0087099
              ],
              [
                59.6162415,
                28.0103771
              ],
              [
                59.6058832,
                28.0111867
              ],
              [
                59.5813992,
                28.0135536
              ],
              [
                59.5487308,
                28.0134225
              ],
              [
                59.5123812,
                28.0133091
              ],
              [
                59.4725131,
                28.0144834
              ],
              [
                59.4363781,
                28.0141048
              ],
              [
                59.3556973,
                28.0162264
              ],
              [
                59.332723,
                28.0152965
              ],
              [
                59.3272015,
                28.0141048
              ],
              [
                59.2732998,
                27.973179
              ],
              [
                59.2454907,
                27.9543783
              ],
              [
                59.2434307,
                27.9328443
              ],
              [
                59.1946789,
                27.9091824
              ],
              [
                59.1572567,
                27.9067553
              ],
              [
                59.1098782,
                27.9452799
              ],
              [
                59.0930554,
                27.9865195
              ],
              [
                59.0940854,
                28.0077396
              ],
              [
                59.0872189,
                28.0189542
              ],
              [
                59.0658764,
                28.0285756
              ],
              [
                59.0212942,
                28.0535882
              ],
              [
                59.0100459,
                28.0602271
              ],
              [
                59.0027146,
                28.0641416
              ],
              [
                58.9998553,
                28.0658079
              ],
              [
                58.9895225,
                28.0735847
              ],
              [
                58.9823901,
                28.0788858
              ],
              [
                58.9796304,
                28.0812005
              ],
              [
                58.9723105,
                28.085223
              ],
              [
                58.9602105,
                28.0917223
              ],
              [
                58.9485012,
                28.0780233
              ],
              [
                58.94428,
                28.0740423
              ],
              [
                58.9422858,
                28.0692869
              ],
              [
                58.9390263,
                28.0633086
              ],
              [
                58.936339,
                28.0581839
              ],
              [
                58.9347672,
                28.0540425
              ],
              [
                58.9325627,
                28.0456031
              ],
              [
                58.9304873,
                28.0378334
              ],
              [
                58.9295566,
                28.0314211
              ],
              [
                58.9283298,
                28.0216955
              ],
              [
                58.9273857,
                28.0180088
              ],
              [
                58.9240764,
                28.0075521
              ],
              [
                58.9197468,
                28.0014716
              ],
              [
                58.9170634,
                27.9987454
              ],
              [
                58.9140843,
                27.99296
              ],
              [
                58.9097296,
                27.9816713
              ],
              [
                58.9047288,
                27.9702735
              ],
              [
                58.9025446,
                27.9674952
              ],
              [
                58.9002412,
                27.961406
              ],
              [
                58.8907634,
                27.8989606
              ],
              [
                58.8904901,
                27.8981235
              ],
              [
                58.8918767,
                27.8811839
              ],
              [
                58.8935435,
                27.8756305
              ],
              [
                58.8952099,
                27.8675749
              ],
              [
                58.8974299,
                27.8545152
              ],
              [
                58.8988233,
                27.848962
              ],
              [
                58.900763,
                27.8372976
              ],
              [
                58.9021564,
                27.8189554
              ],
              [
                58.9027096,
                27.8025757
              ],
              [
                58.9024294,
                27.8003528
              ],
              [
                58.9027095,
                27.7975718
              ],
              [
                58.9024295,
                27.7953489
              ],
              [
                58.9029896,
                27.7847923
              ],
              [
                58.9032629,
                27.7689624
              ],
              [
                58.9029895,
                27.7617359
              ],
              [
                58.9032629,
                27.759792
              ],
              [
                58.9038231,
                27.7492361
              ],
              [
                58.9049293,
                27.7139605
              ],
              [
                58.9049293,
                27.7114589
              ],
              [
                58.9052094,
                27.7056278
              ],
              [
                58.9050365,
                27.7018484
              ],
              [
                58.9050376,
                27.7015338
              ],
              [
                58.9057628,
                27.6797935
              ],
              [
                58.9057628,
                27.6706244
              ],
              [
                58.9029893,
                27.6456281
              ],
              [
                58.9024291,
                27.6411833
              ],
              [
                58.9019541,
                27.6377946
              ],
              [
                58.9002095,
                27.6253475
              ],
              [
                58.9010426,
                27.6042397
              ],
              [
                58.9007626,
                27.603124
              ],
              [
                58.9010426,
                27.5995162
              ],
              [
                58.9007625,
                27.5986794
              ],
              [
                58.9010426,
                27.5945137
              ],
              [
                58.9010426,
                27.5764568
              ],
              [
                58.8985424,
                27.5589582
              ],
              [
                58.8971558,
                27.5542349
              ],
              [
                58.8922721,
                27.5383758
              ],
              [
                58.8910427,
                27.5347847
              ],
              [
                58.8904892,
                27.5339571
              ],
              [
                58.8904892,
                27.5336782
              ],
              [
                58.8904892,
                27.5328415
              ],
              [
                58.8860426,
                27.5145073
              ],
              [
                58.879096,
                27.4972891
              ],
              [
                58.8788229,
                27.495346
              ],
              [
                58.8754825,
                27.4811779
              ],
              [
                58.8752095,
                27.4797925
              ],
              [
                58.8749294,
                27.4786771
              ],
              [
                58.8746492,
                27.4781193
              ],
              [
                58.8746493,
                27.4772913
              ],
              [
                58.8746493,
                27.4770128
              ],
              [
                58.8746493,
                27.4767341
              ],
              [
                58.8740962,
                27.4756186
              ],
              [
                58.8707629,
                27.4620085
              ],
              [
                58.8657628,
                27.4372808
              ],
              [
                58.8624294,
                27.426172
              ],
              [
                58.854096,
                27.3931258
              ],
              [
                58.8368694,
                27.3017311
              ],
              [
                58.835483,
                27.2920006
              ],
              [
                58.8318696,
                27.2620006
              ],
              [
                58.8310364,
                27.2536735
              ],
              [
                58.8330053,
                27.183222
              ],
              [
                58.8335358,
                27.1642226
              ],
              [
                58.8346491,
                27.1572813
              ],
              [
                58.8349292,
                27.1545031
              ],
              [
                58.8352026,
                27.1508887
              ],
              [
                58.8382624,
                27.1351502
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555054,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زابل",
          "name:en": "Zabol County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q606064",
          "wikipedia": "en:Zabol County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                61.4761104,
                31.0060584
              ],
              [
                61.4749458,
                31.0032745
              ],
              [
                61.4752054,
                30.9980298
              ],
              [
                61.477603,
                30.9941881
              ],
              [
                61.4817465,
                30.9898468
              ],
              [
                61.48368,
                30.9853548
              ],
              [
                61.4859032,
                30.9783474
              ],
              [
                61.4881225,
                30.9660039
              ],
              [
                61.4889915,
                30.9587719
              ],
              [
                61.4895819,
                30.9491747
              ],
              [
                61.4955644,
                30.9473684
              ],
              [
                61.4996838,
                30.9457421
              ],
              [
                61.5076612,
                30.943597
              ],
              [
                61.5104598,
                30.9412299
              ],
              [
                61.5144125,
                30.9385355
              ],
              [
                61.5174204,
                30.9370773
              ],
              [
                61.5209841,
                30.9363482
              ],
              [
                61.5253324,
                30.936264
              ],
              [
                61.5294694,
                30.9369946
              ],
              [
                61.5309231,
                30.9389
              ],
              [
                61.5320347,
                30.9412556
              ],
              [
                61.5322308,
                30.9451533
              ],
              [
                61.5315134,
                30.9492073
              ],
              [
                61.5350752,
                30.9517706
              ],
              [
                61.5432986,
                30.9485761
              ],
              [
                61.5485327,
                30.9533999
              ],
              [
                61.5502829,
                30.9575794
              ],
              [
                61.552298,
                30.9640226
              ],
              [
                61.5620217,
                30.9740698
              ],
              [
                61.5639878,
                30.9866879
              ],
              [
                61.5718533,
                30.9981946
              ],
              [
                61.5735937,
                31.0000581
              ],
              [
                61.5772118,
                31.0003121
              ],
              [
                61.5839065,
                31.0014964
              ],
              [
                61.5872393,
                30.9988505
              ],
              [
                61.5935443,
                30.9947441
              ],
              [
                61.5984281,
                30.9915611
              ],
              [
                61.601758,
                30.990799
              ],
              [
                61.6043329,
                30.9916083
              ],
              [
                61.6067791,
                30.9926936
              ],
              [
                61.6121433,
                30.997145
              ],
              [
                61.6183232,
                30.9998212
              ],
              [
                61.6230869,
                31.0006028
              ],
              [
                61.6281508,
                31.0015961
              ],
              [
                61.640682,
                30.9989475
              ],
              [
                61.6587494,
                30.9972186
              ],
              [
                61.6750143,
                30.9960046
              ],
              [
                61.684799,
                30.9942388
              ],
              [
                61.6945837,
                30.9882054
              ],
              [
                61.7041968,
                30.9783451
              ],
              [
                61.7150803,
                30.9691506
              ],
              [
                61.7176083,
                30.9661281
              ],
              [
                61.7257467,
                30.9563971
              ],
              [
                61.7291533,
                30.9510002
              ],
              [
                61.7374543,
                30.9436552
              ],
              [
                61.7536025,
                30.9332941
              ],
              [
                61.7708773,
                30.9317371
              ],
              [
                61.7837609,
                30.9340048
              ],
              [
                61.7769079,
                30.9371148
              ],
              [
                61.7715278,
                30.9403423
              ],
              [
                61.7676606,
                30.9435095
              ],
              [
                61.7647435,
                30.9466077
              ],
              [
                61.7597989,
                30.9532101
              ],
              [
                61.7498471,
                30.9599731
              ],
              [
                61.7400831,
                30.9723706
              ],
              [
                61.7321538,
                30.9798417
              ],
              [
                61.7303081,
                30.9839323
              ],
              [
                61.7227769,
                31.0006214
              ],
              [
                61.7154226,
                31.0015066
              ],
              [
                61.7079118,
                31.0017212
              ],
              [
                61.6999003,
                31.0024187
              ],
              [
                61.6918262,
                31.0038672
              ],
              [
                61.6868521,
                31.0061012
              ],
              [
                61.6822046,
                31.0092216
              ],
              [
                61.6774842,
                31.013083
              ],
              [
                61.6750484,
                31.0160335
              ],
              [
                61.6730054,
                31.0209805
              ],
              [
                61.6728313,
                31.0219584
              ],
              [
                61.6630812,
                31.0392243
              ],
              [
                61.656124,
                31.0513393
              ],
              [
                61.6510049,
                31.0594238
              ],
              [
                61.648172,
                31.0641126
              ],
              [
                61.647442,
                31.06561
              ],
              [
                61.6445533,
                31.0703692
              ],
              [
                61.6336174,
                31.086342
              ],
              [
                61.6214291,
                31.1005356
              ],
              [
                61.6067037,
                31.1243914
              ],
              [
                61.6108347,
                31.1296421
              ],
              [
                61.6082059,
                31.1321066
              ],
              [
                61.6021347,
                31.1339817
              ],
              [
                61.594749,
                31.1325352
              ],
              [
                61.5910083,
                31.1386325
              ],
              [
                61.5886153,
                31.144696
              ],
              [
                61.5913066,
                31.1544986
              ],
              [
                61.5891786,
                31.163336
              ],
              [
                61.5769251,
                31.1748619
              ],
              [
                61.5675356,
                31.1702514
              ],
              [
                61.5708824,
                31.164284
              ],
              [
                61.5594943,
                31.1569421
              ],
              [
                61.5544223,
                31.1537642
              ],
              [
                61.5491204,
                31.1512652
              ],
              [
                61.5411682,
                31.1466765
              ],
              [
                61.5338325,
                31.1422776
              ],
              [
                61.5272358,
                31.1372879
              ],
              [
                61.5231208,
                31.1335043
              ],
              [
                61.5185992,
                31.1291584
              ],
              [
                61.5129714,
                31.1231065
              ],
              [
                61.512949,
                31.1146172
              ],
              [
                61.5133241,
                31.1061558
              ],
              [
                61.5174869,
                31.0922978
              ],
              [
                61.5218848,
                31.0837146
              ],
              [
                61.5241593,
                31.0791567
              ],
              [
                61.5251711,
                31.0738844
              ],
              [
                61.5266561,
                31.0674919
              ],
              [
                61.5273562,
                31.0622702
              ],
              [
                61.5289306,
                31.0564818
              ],
              [
                61.5276861,
                31.0555811
              ],
              [
                61.5254813,
                31.0551721
              ],
              [
                61.5238934,
                31.0544598
              ],
              [
                61.5222788,
                31.0545195
              ],
              [
                61.5218613,
                31.0542429
              ],
              [
                61.5198769,
                31.0555903
              ],
              [
                61.5170645,
                31.0567391
              ],
              [
                61.5129447,
                31.0585589
              ],
              [
                61.5056062,
                31.058081
              ],
              [
                61.4982676,
                31.0596802
              ],
              [
                61.4914669,
                31.0597038
              ],
              [
                61.4899635,
                31.0602132
              ],
              [
                61.4877319,
                31.0596802
              ],
              [
                61.4868686,
                31.0575493
              ],
              [
                61.4867341,
                31.0572446
              ],
              [
                61.4799213,
                31.0516288
              ],
              [
                61.4801787,
                31.0494781
              ],
              [
                61.4767455,
                31.0483015
              ],
              [
                61.4669654,
                31.0527996
              ],
              [
                61.46533,
                31.0508752
              ],
              [
                61.4656734,
                31.0465367
              ],
              [
                61.4692634,
                31.0423377
              ],
              [
                61.4714053,
                31.0391921
              ],
              [
                61.4721778,
                31.0334844
              ],
              [
                61.4723759,
                31.0317287
              ],
              [
                61.4726746,
                31.028131
              ],
              [
                61.46945,
                31.0270478
              ],
              [
                61.4657163,
                31.0257607
              ],
              [
                61.4709325,
                31.0149033
              ],
              [
                61.4737939,
                31.0112001
              ],
              [
                61.4761104,
                31.0060584
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555055,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زاهدان",
          "name:ar": "مقاطعة زاهدان",
          "name:en": "Zahedan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278993",
          "wikipedia": "en:Zahedan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.4263478,
                30.1934567
              ],
              [
                59.4263478,
                30.1926266
              ],
              [
                59.4285743,
                30.1845698
              ],
              [
                59.4291275,
                30.1787324
              ],
              [
                59.4296809,
                30.1515038
              ],
              [
                59.4294074,
                30.1456756
              ],
              [
                59.4296809,
                30.1445659
              ],
              [
                59.4305141,
                30.1381784
              ],
              [
                59.4313473,
                30.1348403
              ],
              [
                59.4316273,
                30.1312315
              ],
              [
                59.4313473,
                30.1301218
              ],
              [
                59.4316274,
                30.1287325
              ],
              [
                59.4319075,
                30.1234548
              ],
              [
                59.4319074,
                30.120676
              ],
              [
                59.4321805,
                30.1187273
              ],
              [
                59.4338473,
                30.1045631
              ],
              [
                59.4344074,
                30.0990059
              ],
              [
                59.4352405,
                30.0709488
              ],
              [
                59.4357937,
                30.0692797
              ],
              [
                59.4382937,
                30.0545659
              ],
              [
                59.4385738,
                30.0520669
              ],
              [
                59.4407937,
                30.0370645
              ],
              [
                59.441627,
                30.0351159
              ],
              [
                59.4449602,
                30.0176148
              ],
              [
                59.4474601,
                30.0000509
              ],
              [
                59.4494066,
                29.9934475
              ],
              [
                59.449127,
                29.9926175
              ],
              [
                59.4488535,
                29.9909486
              ],
              [
                59.4482934,
                29.9881703
              ],
              [
                59.4480202,
                29.9865013
              ],
              [
                59.4477402,
                29.9851121
              ],
              [
                59.4474601,
                29.9837319
              ],
              [
                59.447187,
                29.9826134
              ],
              [
                59.446907,
                29.9809535
              ],
              [
                59.4432935,
                29.9684506
              ],
              [
                59.4405134,
                29.9548383
              ],
              [
                59.4405134,
                29.9545587
              ],
              [
                59.4402404,
                29.9528989
              ],
              [
                59.4399602,
                29.95123
              ],
              [
                59.4355133,
                29.9312224
              ],
              [
                59.4352403,
                29.9290033
              ],
              [
                59.4349601,
                29.9256748
              ],
              [
                59.43468,
                29.9231671
              ],
              [
                59.434407,
                29.9206684
              ],
              [
                59.4341269,
                29.9192883
              ],
              [
                59.4327401,
                29.9103941
              ],
              [
                59.4321799,
                29.9078955
              ],
              [
                59.43246,
                29.9020593
              ],
              [
                59.4330135,
                29.8887273
              ],
              [
                59.4335736,
                29.8723377
              ],
              [
                59.4335736,
                29.8717785
              ],
              [
                59.4388466,
                29.8148358
              ],
              [
                59.4449594,
                29.7548381
              ],
              [
                59.4460728,
                29.7503916
              ],
              [
                59.4466262,
                29.7470545
              ],
              [
                59.4466263,
                29.7456656
              ],
              [
                59.4485728,
                29.7353927
              ],
              [
                59.4488528,
                29.7303872
              ],
              [
                59.4485727,
                29.7295574
              ],
              [
                59.4488528,
                29.7273296
              ],
              [
                59.4485727,
                29.7117809
              ],
              [
                59.4474593,
                29.6990011
              ],
              [
                59.4477394,
                29.6937251
              ],
              [
                59.4474593,
                29.6745513
              ],
              [
                59.4477394,
                29.6723327
              ],
              [
                59.4480194,
                29.6506611
              ],
              [
                59.4488525,
                29.6390003
              ],
              [
                59.449126,
                29.6295489
              ],
              [
                59.4499592,
                29.6239937
              ],
              [
                59.4499592,
                29.6214957
              ],
              [
                59.4519057,
                29.6114945
              ],
              [
                59.4519057,
                29.6109443
              ],
              [
                59.4557924,
                29.5917809
              ],
              [
                59.4560725,
                29.5881647
              ],
              [
                59.4563521,
                29.5789934
              ],
              [
                59.4560724,
                29.5773341
              ],
              [
                59.4563521,
                29.5745476
              ],
              [
                59.4560724,
                29.5728883
              ],
              [
                59.4552386,
                29.5042734
              ],
              [
                59.4577387,
                29.4801072
              ],
              [
                59.4580187,
                29.4720459
              ],
              [
                59.4580187,
                29.4717754
              ],
              [
                59.4580187,
                29.4662209
              ],
              [
                59.4574585,
                29.461496
              ],
              [
                59.4596851,
                29.4437146
              ],
              [
                59.4607917,
                29.4420465
              ],
              [
                59.4607917,
                29.4412169
              ],
              [
                59.4616249,
                29.4398284
              ],
              [
                59.4616249,
                29.4395489
              ],
              [
                59.4616249,
                29.4392693
              ],
              [
                59.461905,
                29.4387194
              ],
              [
                59.4632917,
                29.4337151
              ],
              [
                59.4632917,
                29.4181612
              ],
              [
                59.4627386,
                29.4142661
              ],
              [
                59.4624584,
                29.4048257
              ],
              [
                59.461905,
                29.4006601
              ],
              [
                59.462185,
                29.3978831
              ],
              [
                59.4635717,
                29.3742691
              ],
              [
                59.464685,
                29.3706626
              ],
              [
                59.4655181,
                29.3673267
              ],
              [
                59.4669049,
                29.3631612
              ],
              [
                59.469958,
                29.3539918
              ],
              [
                59.4735714,
                29.3295495
              ],
              [
                59.4741245,
                29.3284315
              ],
              [
                59.4807979,
                29.2981567
              ],
              [
                59.4838511,
                29.2801076
              ],
              [
                59.4846842,
                29.2762129
              ],
              [
                59.4919043,
                29.2534401
              ],
              [
                59.4944042,
                29.2445422
              ],
              [
                59.5088505,
                29.2092665
              ],
              [
                59.5094036,
                29.2070489
              ],
              [
                59.5107971,
                29.2031544
              ],
              [
                59.5136732,
                29.1929828
              ],
              [
                59.5282968,
                29.1609301
              ],
              [
                59.5513496,
                29.1234308
              ],
              [
                59.5527429,
                29.1206545
              ],
              [
                59.5694092,
                29.0923238
              ],
              [
                59.5696892,
                29.0909266
              ],
              [
                59.5694091,
                29.0906562
              ],
              [
                59.5694091,
                29.0884298
              ],
              [
                59.5707959,
                29.0820391
              ],
              [
                59.5660759,
                29.0723224
              ],
              [
                59.5655226,
                29.0720431
              ],
              [
                59.5655227,
                29.0714842
              ],
              [
                59.5649625,
                29.0709343
              ],
              [
                59.5641293,
                29.0692669
              ],
              [
                59.5374632,
                29.0453722
              ],
              [
                59.5374631,
                29.0450928
              ],
              [
                59.5360763,
                29.0425961
              ],
              [
                59.5294099,
                29.0328708
              ],
              [
                59.5082965,
                29.0042633
              ],
              [
                59.5055168,
                28.9998199
              ],
              [
                59.4969032,
                28.96093
              ],
              [
                59.5005165,
                28.9475915
              ],
              [
                59.4989987,
                28.917061
              ],
              [
                59.4985021,
                28.8706622
              ],
              [
                59.4986104,
                28.8403558
              ],
              [
                59.4996122,
                28.8001384
              ],
              [
                59.5053182,
                28.7448984
              ],
              [
                59.5069348,
                28.7237471
              ],
              [
                59.50801,
                28.7109369
              ],
              [
                59.511895,
                28.6913351
              ],
              [
                59.5153424,
                28.667094
              ],
              [
                59.5314785,
                28.6246107
              ],
              [
                59.5644375,
                28.5950731
              ],
              [
                59.585699,
                28.5801563
              ],
              [
                59.6205665,
                28.5794848
              ],
              [
                59.6970081,
                28.5776668
              ],
              [
                59.7130964,
                28.5774369
              ],
              [
                59.7227095,
                28.5792459
              ],
              [
                59.7257994,
                28.5787937
              ],
              [
                59.7446821,
                28.582713
              ],
              [
                59.7844345,
                28.5823508
              ],
              [
                59.8524661,
                28.5820892
              ],
              [
                59.9080913,
                28.5814321
              ],
              [
                59.9712684,
                28.5815048
              ],
              [
                60.0161579,
                28.5818685
              ],
              [
                60.0607051,
                28.5794666
              ],
              [
                60.0823814,
                28.5752565
              ],
              [
                60.1167116,
                28.5698824
              ],
              [
                60.1506753,
                28.5638297
              ],
              [
                60.1699748,
                28.5598432
              ],
              [
                60.1935532,
                28.5521003
              ],
              [
                60.2066229,
                28.5483385
              ],
              [
                60.2206991,
                28.5407988
              ],
              [
                60.2134894,
                28.5305438
              ],
              [
                60.2315138,
                28.5296389
              ],
              [
                60.2382086,
                28.5153104
              ],
              [
                60.242258,
                28.500757
              ],
              [
                60.2493666,
                28.5023376
              ],
              [
                60.2637861,
                28.503997
              ],
              [
                60.2838705,
                28.5064106
              ],
              [
                60.2973095,
                28.5093885
              ],
              [
                60.3126602,
                28.5157053
              ],
              [
                60.3194044,
                28.5199862
              ],
              [
                60.3348144,
                28.5366142
              ],
              [
                60.3345106,
                28.5638687
              ],
              [
                60.3340521,
                28.5888911
              ],
              [
                60.33185,
                28.5914555
              ],
              [
                60.3290176,
                28.5940179
              ],
              [
                60.329275,
                28.5963541
              ],
              [
                60.3320216,
                28.5981627
              ],
              [
                60.335884,
                28.5998206
              ],
              [
                60.3410338,
                28.6104456
              ],
              [
                60.3539084,
                28.612254
              ],
              [
                60.3595519,
                28.605356
              ],
              [
                60.3751944,
                28.603061
              ],
              [
                60.3806875,
                28.6036638
              ],
              [
                60.3844641,
                28.6166242
              ],
              [
                60.385874,
                28.6293419
              ],
              [
                60.4054068,
                28.6393762
              ],
              [
                60.4206394,
                28.6432465
              ],
              [
                60.4388807,
                28.6443478
              ],
              [
                60.446777,
                28.6481142
              ],
              [
                60.4476353,
                28.6542905
              ],
              [
                60.4769894,
                28.6618222
              ],
              [
                60.4902739,
                28.6620873
              ],
              [
                60.4982438,
                28.6630928
              ],
              [
                60.5049704,
                28.6681481
              ],
              [
                60.5231907,
                28.7028616
              ],
              [
                60.5320071,
                28.7185176
              ],
              [
                60.5447959,
                28.7313132
              ],
              [
                60.5677272,
                28.7485807
              ],
              [
                60.5711958,
                28.7614844
              ],
              [
                60.5772445,
                28.7845689
              ],
              [
                60.5832024,
                28.8252611
              ],
              [
                60.5884809,
                28.845337
              ],
              [
                60.5945776,
                28.8511393
              ],
              [
                60.598746,
                28.8531672
              ],
              [
                60.6407545,
                28.8541463
              ],
              [
                60.6867892,
                28.8540271
              ],
              [
                60.7051275,
                28.8592581
              ],
              [
                60.7212198,
                28.8642281
              ],
              [
                60.7198374,
                28.9117596
              ],
              [
                60.7295497,
                28.9177559
              ],
              [
                60.7229367,
                28.9499583
              ],
              [
                60.7145251,
                28.9903758
              ],
              [
                60.7074553,
                29.020101
              ],
              [
                60.7369816,
                29.0284211
              ],
              [
                60.7560894,
                29.0334614
              ],
              [
                60.7755867,
                29.041765
              ],
              [
                60.7950846,
                29.049858
              ],
              [
                60.8082195,
                29.0588914
              ],
              [
                60.8157612,
                29.0742473
              ],
              [
                60.8211707,
                29.0909021
              ],
              [
                60.8266627,
                29.1123614
              ],
              [
                60.83582,
                29.139699
              ],
              [
                60.8334302,
                29.1509454
              ],
              [
                60.8474254,
                29.1751317
              ],
              [
                60.8602097,
                29.1784659
              ],
              [
                60.9012142,
                29.1645958
              ],
              [
                60.9351651,
                29.1582869
              ],
              [
                60.9784925,
                29.134184
              ],
              [
                61.0493103,
                29.1360415
              ],
              [
                61.1014753,
                29.1372019
              ],
              [
                61.1124951,
                29.1527668
              ],
              [
                61.1118405,
                29.1538845
              ],
              [
                61.1088158,
                29.1972425
              ],
              [
                61.1058802,
                29.248028
              ],
              [
                61.1269536,
                29.2871745
              ],
              [
                61.1436679,
                29.3179048
              ],
              [
                61.179757,
                29.3495115
              ],
              [
                61.1897074,
                29.3581751
              ],
              [
                61.2117064,
                29.3774138
              ],
              [
                61.2279434,
                29.3864063
              ],
              [
                61.237109,
                29.3914848
              ],
              [
                61.2615384,
                29.4036646
              ],
              [
                61.321114,
                29.3882669
              ],
              [
                61.3217201,
                29.3888221
              ],
              [
                61.320686,
                29.389512
              ],
              [
                61.320115,
                29.389821
              ],
              [
                61.31897,
                29.390628
              ],
              [
                61.318524,
                29.390878
              ],
              [
                61.317207,
                29.391401
              ],
              [
                61.316024,
                29.391804
              ],
              [
                61.314358,
                29.392759
              ],
              [
                61.311383,
                29.393731
              ],
              [
                61.310747,
                29.394097
              ],
              [
                61.308947,
                29.395202
              ],
              [
                61.308121,
                29.395941
              ],
              [
                61.30607,
                29.398003
              ],
              [
                61.305513,
                29.398435
              ],
              [
                61.303527,
                29.399676
              ],
              [
                61.302753,
                29.400209
              ],
              [
                61.302513,
                29.400497
              ],
              [
                61.302134,
                29.400803
              ],
              [
                61.301268,
                29.401372
              ],
              [
                61.300881,
                29.401864
              ],
              [
                61.300736,
                29.402491
              ],
              [
                61.300743,
                29.403183
              ],
              [
                61.300541,
                29.403838
              ],
              [
                61.300017,
                29.404691
              ],
              [
                61.299873,
                29.405135
              ],
              [
                61.299979,
                29.405865
              ],
              [
                61.30035,
                29.406628
              ],
              [
                61.300363,
                29.407031
              ],
              [
                61.300304,
                29.407286
              ],
              [
                61.29994,
                29.407932
              ],
              [
                61.299716,
                29.408438
              ],
              [
                61.299624,
                29.409541
              ],
              [
                61.299458,
                29.410114
              ],
              [
                61.299412,
                29.411513
              ],
              [
                61.299478,
                29.411996
              ],
              [
                61.299486,
                29.412804
              ],
              [
                61.299428,
                29.413184
              ],
              [
                61.2353421,
                29.4641137
              ],
              [
                61.2320235,
                29.4696912
              ],
              [
                61.2217156,
                29.4780548
              ],
              [
                61.2212034,
                29.4809464
              ],
              [
                61.2210133,
                29.4808725
              ],
              [
                61.2208561,
                29.4808567
              ],
              [
                61.2204549,
                29.4809071
              ],
              [
                61.220136,
                29.4808732
              ],
              [
                61.2198594,
                29.4810547
              ],
              [
                61.2197639,
                29.4810869
              ],
              [
                61.2193373,
                29.4810763
              ],
              [
                61.2185057,
                29.4811886
              ],
              [
                61.2176493,
                29.4813308
              ],
              [
                61.2171237,
                29.4815133
              ],
              [
                61.2169451,
                29.4817619
              ],
              [
                61.2167532,
                29.4820097
              ],
              [
                61.216194,
                29.4824562
              ],
              [
                61.215709,
                29.4827213
              ],
              [
                61.2153039,
                29.4828529
              ],
              [
                61.2149821,
                29.4833843
              ],
              [
                61.214763,
                29.4833446
              ],
              [
                61.2144958,
                29.4834782
              ],
              [
                61.2143707,
                29.483707
              ],
              [
                61.2139346,
                29.48367
              ],
              [
                61.2136377,
                29.4836931
              ],
              [
                61.2133225,
                29.4837535
              ],
              [
                61.213215,
                29.4838792
              ],
              [
                61.2132162,
                29.4841029
              ],
              [
                61.2130954,
                29.4843746
              ],
              [
                61.2127678,
                29.48445
              ],
              [
                61.2126143,
                29.484631
              ],
              [
                61.2125319,
                29.4848215
              ],
              [
                61.2123365,
                29.4850465
              ],
              [
                61.2121797,
                29.4853006
              ],
              [
                61.2120362,
                29.4854206
              ],
              [
                61.2118719,
                29.4857112
              ],
              [
                61.2121128,
                29.487542
              ],
              [
                61.2087381,
                29.4883635
              ],
              [
                61.2050326,
                29.4882717
              ],
              [
                61.2048662,
                29.489315
              ],
              [
                61.1975959,
                29.4910862
              ],
              [
                61.1908924,
                29.4929592
              ],
              [
                61.1889622,
                29.4935552
              ],
              [
                61.184553,
                29.4952085
              ],
              [
                61.1816175,
                29.4963737
              ],
              [
                61.1777387,
                29.4976165
              ],
              [
                61.1770493,
                29.4977398
              ],
              [
                61.1716957,
                29.4980154
              ],
              [
                61.1662274,
                29.4976687
              ],
              [
                61.1616195,
                29.5024401
              ],
              [
                61.1546667,
                29.5071932
              ],
              [
                61.1477422,
                29.5121783
              ],
              [
                61.1453607,
                29.5139524
              ],
              [
                61.1434524,
                29.5167712
              ],
              [
                61.1417798,
                29.5186262
              ],
              [
                61.1396231,
                29.5228239
              ],
              [
                61.1358982,
                29.5259038
              ],
              [
                61.1304355,
                29.5292473
              ],
              [
                61.1255348,
                29.5325189
              ],
              [
                61.1251865,
                29.5328019
              ],
              [
                61.1247366,
                29.5330909
              ],
              [
                61.1247226,
                29.5331575
              ],
              [
                61.1247329,
                29.5333425
              ],
              [
                61.1245932,
                29.5340108
              ],
              [
                61.1244863,
                29.5343929
              ],
              [
                61.1249178,
                29.5348847
              ],
              [
                61.1254562,
                29.5354717
              ],
              [
                61.1270274,
                29.5368172
              ],
              [
                61.1277035,
                29.537373
              ],
              [
                61.127964,
                29.5375169
              ],
              [
                61.1288759,
                29.5376687
              ],
              [
                61.1298431,
                29.5381779
              ],
              [
                61.1302485,
                29.5384736
              ],
              [
                61.1302995,
                29.5387005
              ],
              [
                61.1301796,
                29.5394228
              ],
              [
                61.1301651,
                29.5409235
              ],
              [
                61.1299939,
                29.5413236
              ],
              [
                61.1298535,
                29.5414268
              ],
              [
                61.1296707,
                29.5417384
              ],
              [
                61.1296481,
                29.5423279
              ],
              [
                61.1290635,
                29.5457343
              ],
              [
                61.1242566,
                29.5659628
              ],
              [
                61.1256414,
                29.5675799
              ],
              [
                61.1260893,
                29.5682972
              ],
              [
                61.1278575,
                29.5711296
              ],
              [
                61.1214366,
                29.579641
              ],
              [
                61.0824282,
                29.632812
              ],
              [
                61.0598972,
                29.6496589
              ],
              [
                61.0511645,
                29.6606111
              ],
              [
                61.0485059,
                29.6617761
              ],
              [
                61.0475092,
                29.6623818
              ],
              [
                61.0475215,
                29.6627166
              ],
              [
                61.0475837,
                29.6629895
              ],
              [
                61.0475967,
                29.6634815
              ],
              [
                61.0478767,
                29.6642135
              ],
              [
                61.0473777,
                29.6648579
              ],
              [
                61.0471458,
                29.6650573
              ],
              [
                61.0467581,
                29.6651906
              ],
              [
                61.0461985,
                29.6656488
              ],
              [
                61.0455751,
                29.6662632
              ],
              [
                60.9890737,
                29.7261254
              ],
              [
                60.9889353,
                29.726272
              ],
              [
                60.9869687,
                29.7280507
              ],
              [
                60.9870739,
                29.7281382
              ],
              [
                60.9869031,
                29.7286477
              ],
              [
                60.9868952,
                29.7288632
              ],
              [
                60.9867658,
                29.729307
              ],
              [
                60.9868749,
                29.7295256
              ],
              [
                60.9868765,
                29.7296915
              ],
              [
                60.9867313,
                29.7297534
              ],
              [
                60.9864228,
                29.7297481
              ],
              [
                60.9863332,
                29.7298024
              ],
              [
                60.9861196,
                29.7298162
              ],
              [
                60.9855934,
                29.729777
              ],
              [
                60.9852514,
                29.7300784
              ],
              [
                60.9833993,
                29.7319824
              ],
              [
                60.9826762,
                29.7326937
              ],
              [
                60.9824107,
                29.7330216
              ],
              [
                60.9820923,
                29.7332904
              ],
              [
                60.9818767,
                29.7335617
              ],
              [
                60.9815569,
                29.7338062
              ],
              [
                60.9812748,
                29.7340814
              ],
              [
                60.9809359,
                29.7345189
              ],
              [
                60.9802493,
                29.7354073
              ],
              [
                60.9799609,
                29.7359196
              ],
              [
                60.9796349,
                29.7368863
              ],
              [
                60.9789989,
                29.737594
              ],
              [
                60.9787482,
                29.7380742
              ],
              [
                60.9783053,
                29.7392336
              ],
              [
                60.9778205,
                29.7398235
              ],
              [
                60.9773728,
                29.7412116
              ],
              [
                60.977311,
                29.7413213
              ],
              [
                60.9769457,
                29.741523
              ],
              [
                60.9767994,
                29.7417029
              ],
              [
                60.9667485,
                29.7550472
              ],
              [
                60.9257775,
                29.7967758
              ],
              [
                60.9233131,
                29.7985416
              ],
              [
                60.9223443,
                29.7995166
              ],
              [
                60.9182806,
                29.8033451
              ],
              [
                60.9169556,
                29.8043632
              ],
              [
                60.9150266,
                29.8055859
              ],
              [
                60.9144612,
                29.8061048
              ],
              [
                60.91653,
                29.8085422
              ],
              [
                60.9141018,
                29.811776
              ],
              [
                60.9136522,
                29.8115175
              ],
              [
                60.9130577,
                29.8116629
              ],
              [
                60.9119498,
                29.8121369
              ],
              [
                60.9112495,
                29.812881
              ],
              [
                60.9101075,
                29.8132449
              ],
              [
                60.9088215,
                29.8132331
              ],
              [
                60.9085198,
                29.8133439
              ],
              [
                60.9074985,
                29.8139791
              ],
              [
                60.9056323,
                29.8146325
              ],
              [
                60.9044456,
                29.8153518
              ],
              [
                60.9040822,
                29.8155771
              ],
              [
                60.9032023,
                29.815713
              ],
              [
                60.9028211,
                29.8156333
              ],
              [
                60.9014022,
                29.8150671
              ],
              [
                60.901667,
                29.826944
              ],
              [
                60.895,
                29.834167
              ],
              [
                60.888056,
                29.841111
              ],
              [
                60.881389,
                29.848333
              ],
              [
                60.874444,
                29.855556
              ],
              [
                60.872855,
                29.8585456
              ],
              [
                60.8976706,
                29.8851747
              ],
              [
                60.9154075,
                29.9061962
              ],
              [
                60.9168581,
                29.9073884
              ],
              [
                60.9182781,
                29.9092513
              ],
              [
                60.9183524,
                29.9094263
              ],
              [
                60.9195775,
                29.9118131
              ],
              [
                60.9227175,
                29.9133608
              ],
              [
                60.9743855,
                29.9670825
              ],
              [
                61.0346146,
                30.0313412
              ],
              [
                61.094819,
                30.0955321
              ],
              [
                61.0887242,
                30.1028543
              ],
              [
                61.078658,
                30.1077621
              ],
              [
                61.0666421,
                30.1155351
              ],
              [
                61.0561105,
                30.1258111
              ],
              [
                61.0502769,
                30.1359687
              ],
              [
                61.0457527,
                30.1435789
              ],
              [
                61.0447467,
                30.145271
              ],
              [
                61.0381507,
                30.1508422
              ],
              [
                61.0251336,
                30.1531651
              ],
              [
                61.0086873,
                30.1506146
              ],
              [
                60.982777,
                30.1439151
              ],
              [
                60.9264222,
                30.1319121
              ],
              [
                60.9032238,
                30.1306021
              ],
              [
                60.8823058,
                30.1316586
              ],
              [
                60.8734517,
                30.1330691
              ],
              [
                60.8622485,
                30.1373174
              ],
              [
                60.8557852,
                30.1419936
              ],
              [
                60.848509,
                30.1511314
              ],
              [
                60.8440579,
                30.1599423
              ],
              [
                60.8372211,
                30.1682078
              ],
              [
                60.828123,
                30.1765184
              ],
              [
                60.81645,
                30.18468
              ],
              [
                60.8020755,
                30.1923918
              ],
              [
                60.7905608,
                30.196874
              ],
              [
                60.7833546,
                30.2001211
              ],
              [
                60.7768329,
                30.2043468
              ],
              [
                60.7625057,
                30.21904
              ],
              [
                60.7596693,
                30.2219487
              ],
              [
                60.7469226,
                30.2299613
              ],
              [
                60.7276432,
                30.2358466
              ],
              [
                60.7151214,
                30.2406495
              ],
              [
                60.7080665,
                30.2473203
              ],
              [
                60.6949785,
                30.259201
              ],
              [
                60.6834935,
                30.2673531
              ],
              [
                60.675488,
                30.2713699
              ],
              [
                60.6682197,
                30.2734331
              ],
              [
                60.6538407,
                30.2800783
              ],
              [
                60.6525979,
                30.2810691
              ],
              [
                60.6422077,
                30.2893519
              ],
              [
                60.6354331,
                30.2995376
              ],
              [
                60.6231012,
                30.3274955
              ],
              [
                60.607263,
                30.3493665
              ],
              [
                60.5941807,
                30.3669144
              ],
              [
                60.5805472,
                30.3845469
              ],
              [
                60.5677358,
                30.4001773
              ],
              [
                60.5620826,
                30.407345
              ],
              [
                60.5573935,
                30.414065
              ],
              [
                60.5462832,
                30.4373872
              ],
              [
                60.5222328,
                30.4842967
              ],
              [
                60.5216793,
                30.4845673
              ],
              [
                60.5216793,
                30.4848472
              ],
              [
                60.5200129,
                30.4867963
              ],
              [
                60.4853865,
                30.5306937
              ],
              [
                60.4851064,
                30.5312443
              ],
              [
                60.4842732,
                30.5323542
              ],
              [
                60.4464937,
                30.5762507
              ],
              [
                60.4439941,
                30.5781912
              ],
              [
                60.4362209,
                30.5845808
              ],
              [
                60.4001083,
                30.6118094
              ],
              [
                60.399548,
                30.6118094
              ],
              [
                60.3973281,
                30.61347
              ],
              [
                60.3659354,
                30.6340293
              ],
              [
                60.3587153,
                30.6390292
              ],
              [
                60.3378825,
                30.649309
              ],
              [
                60.3339892,
                30.6509788
              ],
              [
                60.3076028,
                30.6645889
              ],
              [
                60.2945432,
                30.672089
              ],
              [
                60.2695435,
                30.6815386
              ],
              [
                60.2664904,
                30.6826487
              ],
              [
                60.2481572,
                30.6881995
              ],
              [
                60.247324,
                30.688759
              ],
              [
                60.2464904,
                30.6887591
              ],
              [
                60.2262107,
                30.6968189
              ],
              [
                60.1953711,
                30.7043101
              ],
              [
                60.1942645,
                30.7045899
              ],
              [
                60.1912046,
                30.7048696
              ],
              [
                60.1745384,
                30.7079204
              ],
              [
                60.1742649,
                30.7082001
              ],
              [
                60.1734317,
                30.7082001
              ],
              [
                60.1728715,
                30.7084799
              ],
              [
                60.1717649,
                30.7084799
              ],
              [
                60.1712051,
                30.7087597
              ],
              [
                60.1692652,
                30.7087597
              ],
              [
                60.1542587,
                30.71098
              ],
              [
                60.1534251,
                30.7112598
              ],
              [
                60.1523188,
                30.7112599
              ],
              [
                60.1517586,
                30.7115396
              ],
              [
                60.150925,
                30.7115396
              ],
              [
                60.150652,
                30.7118194
              ],
              [
                60.1489851,
                30.7118193
              ],
              [
                60.1331525,
                30.7151499
              ],
              [
                60.1320388,
                30.7151499
              ],
              [
                60.1248125,
                30.7170905
              ],
              [
                60.124259,
                30.7170904
              ],
              [
                60.1225925,
                30.71765
              ],
              [
                60.1053727,
                30.7207007
              ],
              [
                60.1039793,
                30.7212603
              ],
              [
                60.1028726,
                30.7212604
              ],
              [
                60.1020394,
                30.7215401
              ],
              [
                60.1000928,
                30.7215401
              ],
              [
                60.0998127,
                30.7218199
              ],
              [
                60.0989791,
                30.7218199
              ],
              [
                60.0887063,
                30.7265403
              ],
              [
                60.087593,
                30.7268111
              ],
              [
                60.0711998,
                30.740151
              ],
              [
                60.0698131,
                30.7420915
              ],
              [
                60.0673135,
                30.7451513
              ],
              [
                60.0667599,
                30.7465412
              ],
              [
                60.0503667,
                30.7620928
              ],
              [
                60.0495335,
                30.7623726
              ],
              [
                60.0487002,
                30.7623726
              ],
              [
                60.0481472,
                30.7626523
              ],
              [
                60.0462002,
                30.7626523
              ],
              [
                60.0459201,
                30.7623726
              ],
              [
                60.0450869,
                30.7623726
              ],
              [
                60.0448135,
                30.7626524
              ],
              [
                60.0437001,
                30.7626523
              ],
              [
                60.0434201,
                30.7623725
              ],
              [
                60.0417536,
                30.7623726
              ],
              [
                60.0414802,
                30.7620928
              ],
              [
                60.0403668,
                30.7618129
              ],
              [
                60.0264807,
                30.7593219
              ],
              [
                60.0259205,
                30.759042
              ],
              [
                60.0239806,
                30.759042
              ],
              [
                60.0187008,
                30.7579319
              ],
              [
                60.0184207,
                30.7576521
              ],
              [
                60.0178673,
                30.757652
              ],
              [
                60.0175871,
                30.7573722
              ],
              [
                60.0142538,
                30.7573722
              ],
              [
                60.0134207,
                30.7570924
              ],
              [
                60.012034,
                30.7570925
              ],
              [
                60.0109206,
                30.7568217
              ],
              [
                60.0039741,
                30.7559824
              ],
              [
                59.9959211,
                30.7573723
              ],
              [
                59.9923077,
                30.7573723
              ],
              [
                59.9917542,
                30.7576521
              ],
              [
                59.9878678,
                30.7576521
              ],
              [
                59.9873077,
                30.757932
              ],
              [
                59.9789744,
                30.757932
              ],
              [
                59.9784212,
                30.7582118
              ],
              [
                59.9675882,
                30.7582118
              ],
              [
                59.9673081,
                30.757932
              ],
              [
                59.9606416,
                30.757932
              ],
              [
                59.9600881,
                30.7576521
              ],
              [
                59.9371653,
                30.7576522
              ],
              [
                59.936332,
                30.7576522
              ],
              [
                59.9357789,
                30.7576522
              ],
              [
                59.9354989,
                30.7573724
              ],
              [
                59.9307789,
                30.7573724
              ],
              [
                59.9302258,
                30.7570926
              ],
              [
                59.9249455,
                30.7568219
              ],
              [
                59.9243924,
                30.7562623
              ],
              [
                59.9243924,
                30.7559825
              ],
              [
                59.9193923,
                30.7487619
              ],
              [
                59.8789208,
                30.7214737
              ],
              [
                59.8673429,
                30.7135844
              ],
              [
                59.8656764,
                30.7124744
              ],
              [
                59.865123,
                30.7119149
              ],
              [
                59.8576352,
                30.7002209
              ],
              [
                59.8583218,
                30.6822117
              ],
              [
                59.8030468,
                30.6379123
              ],
              [
                59.776611,
                30.6423432
              ],
              [
                59.7388455,
                30.6219596
              ],
              [
                59.7051988,
                30.6024591
              ],
              [
                59.6976468,
                30.5876819
              ],
              [
                59.6701809,
                30.5900462
              ],
              [
                59.6416851,
                30.5764503
              ],
              [
                59.519861,
                30.5484436
              ],
              [
                59.5083903,
                30.5361684
              ],
              [
                59.5029529,
                30.5332544
              ],
              [
                59.4881025,
                30.52283
              ],
              [
                59.4830583,
                30.5275894
              ],
              [
                59.4682947,
                30.4995767
              ],
              [
                59.4680213,
                30.4987374
              ],
              [
                59.4680212,
                30.4898487
              ],
              [
                59.467188,
                30.4851292
              ],
              [
                59.4666278,
                30.4834598
              ],
              [
                59.4663547,
                30.4826205
              ],
              [
                59.4602413,
                30.460124
              ],
              [
                59.4602413,
                30.4590141
              ],
              [
                59.4596878,
                30.4551248
              ],
              [
                59.4594081,
                30.4540149
              ],
              [
                59.4538547,
                30.4298494
              ],
              [
                59.4535747,
                30.4270701
              ],
              [
                59.4532946,
                30.4234606
              ],
              [
                59.4530211,
                30.4226305
              ],
              [
                59.4530212,
                30.4179021
              ],
              [
                59.4460745,
                30.3834595
              ],
              [
                59.4460745,
                30.3826203
              ],
              [
                59.4452412,
                30.3806803
              ],
              [
                59.444408,
                30.3773417
              ],
              [
                59.4432946,
                30.3745715
              ],
              [
                59.4421814,
                30.3687334
              ],
              [
                59.4419079,
                30.3648443
              ],
              [
                59.4416278,
                30.3620742
              ],
              [
                59.4413477,
                30.3595657
              ],
              [
                59.4410747,
                30.3579055
              ],
              [
                59.4394079,
                30.345679
              ],
              [
                59.4391277,
                30.3426292
              ],
              [
                59.4388479,
                30.337901
              ],
              [
                59.4385746,
                30.3359611
              ],
              [
                59.4363479,
                30.3242942
              ],
              [
                59.4360745,
                30.320676
              ],
              [
                59.4357944,
                30.3181767
              ],
              [
                59.4352413,
                30.3148471
              ],
              [
                59.4349611,
                30.3131779
              ],
              [
                59.432181,
                30.299842
              ],
              [
                59.4313477,
                30.2954027
              ],
              [
                59.4307946,
                30.2917936
              ],
              [
                59.4291277,
                30.2826264
              ],
              [
                59.4288476,
                30.2809572
              ],
              [
                59.4280145,
                30.2728999
              ],
              [
                59.4277414,
                30.2704005
              ],
              [
                59.4271812,
                30.2654019
              ],
              [
                59.4269078,
                30.2631824
              ],
              [
                59.426348,
                30.2595734
              ],
              [
                59.4249612,
                30.2526259
              ],
              [
                59.4260745,
                30.2348424
              ],
              [
                59.4257943,
                30.2115104
              ],
              [
                59.4257943,
                30.2090112
              ],
              [
                59.4260744,
                30.1945665
              ],
              [
                59.4260744,
                30.1937364
              ],
              [
                59.4263478,
                30.1934567
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555061,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زهک",
          "name:en": "Zehak County",
          "name:fa": "شهرستان زهک",
          "place": "county",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                61.4889856,
                30.8150763
              ],
              [
                61.4911435,
                30.8051372
              ],
              [
                61.4938778,
                30.7965561
              ],
              [
                61.4940114,
                30.7862003
              ],
              [
                61.4929271,
                30.7798307
              ],
              [
                61.4899545,
                30.7677904
              ],
              [
                61.4901506,
                30.7580834
              ],
              [
                61.4915374,
                30.7538133
              ],
              [
                61.4917634,
                30.7486583
              ],
              [
                61.4979347,
                30.7434986
              ],
              [
                61.4997655,
                30.7405201
              ],
              [
                61.507442,
                30.7339123
              ],
              [
                61.5142542,
                30.7239566
              ],
              [
                61.5164443,
                30.7185161
              ],
              [
                61.518604,
                30.7094389
              ],
              [
                61.5206121,
                30.7012436
              ],
              [
                61.5197743,
                30.6947057
              ],
              [
                61.5209896,
                30.6858354
              ],
              [
                61.521588,
                30.6757973
              ],
              [
                61.5225558,
                30.6694477
              ],
              [
                61.5244821,
                30.664242
              ],
              [
                61.5280637,
                30.6582816
              ],
              [
                61.5302187,
                30.6555108
              ],
              [
                61.5344213,
                30.6501071
              ],
              [
                61.5417448,
                30.6418375
              ],
              [
                61.5467797,
                30.6381244
              ],
              [
                61.5522069,
                30.6357052
              ],
              [
                61.5584842,
                30.6346924
              ],
              [
                61.5622024,
                30.6344596
              ],
              [
                61.570908,
                30.6342986
              ],
              [
                61.5767958,
                30.6336172
              ],
              [
                61.5854242,
                30.6254087
              ],
              [
                61.5932492,
                30.6219804
              ],
              [
                61.7059509,
                30.7399732
              ],
              [
                61.7199835,
                30.7546141
              ],
              [
                61.7445693,
                30.7806815
              ],
              [
                61.7711277,
                30.8081202
              ],
              [
                61.7713942,
                30.8082672
              ],
              [
                61.7723573,
                30.8084247
              ],
              [
                61.7735229,
                30.8085428
              ],
              [
                61.7740032,
                30.8086154
              ],
              [
                61.7741524,
                30.8087763
              ],
              [
                61.7743367,
                30.808975
              ],
              [
                61.7745239,
                30.8095694
              ],
              [
                61.7747723,
                30.8102272
              ],
              [
                61.7749268,
                30.810507
              ],
              [
                61.775177,
                30.8108509
              ],
              [
                61.7755054,
                30.8110966
              ],
              [
                61.7757512,
                30.8112183
              ],
              [
                61.7759796,
                30.811419
              ],
              [
                61.7760964,
                30.8116027
              ],
              [
                61.7762665,
                30.8119782
              ],
              [
                61.7768557,
                30.8130861
              ],
              [
                61.7772979,
                30.8137525
              ],
              [
                61.7779852,
                30.8145739
              ],
              [
                61.7796881,
                30.8158208
              ],
              [
                61.7825354,
                30.8179303
              ],
              [
                61.7838261,
                30.8190787
              ],
              [
                61.7845664,
                30.8198555
              ],
              [
                61.7864665,
                30.8216512
              ],
              [
                61.7885303,
                30.8234019
              ],
              [
                61.7906335,
                30.825085
              ],
              [
                61.7922977,
                30.8261657
              ],
              [
                61.7927787,
                30.8263649
              ],
              [
                61.7931435,
                30.8265189
              ],
              [
                61.793475,
                30.8267607
              ],
              [
                61.7950625,
                30.8282315
              ],
              [
                61.7953139,
                30.8285639
              ],
              [
                61.7988489,
                30.831287
              ],
              [
                61.8008451,
                30.8329047
              ],
              [
                61.8030683,
                30.8353078
              ],
              [
                61.8040577,
                30.8391965
              ],
              [
                61.8025085,
                30.8424519
              ],
              [
                61.7975319,
                30.8496063
              ],
              [
                61.7938642,
                30.8629467
              ],
              [
                61.792721,
                30.8672981
              ],
              [
                61.7921152,
                30.8714082
              ],
              [
                61.7951324,
                30.8799105
              ],
              [
                61.7949664,
                30.8826111
              ],
              [
                61.7928245,
                30.885965
              ],
              [
                61.7915445,
                30.8881245
              ],
              [
                61.7877922,
                30.8917912
              ],
              [
                61.7852925,
                30.8954514
              ],
              [
                61.7849892,
                30.8965145
              ],
              [
                61.7828947,
                30.9054798
              ],
              [
                61.7793107,
                30.9139247
              ],
              [
                61.7778256,
                30.9175664
              ],
              [
                61.7786308,
                30.9229748
              ],
              [
                61.7799581,
                30.9302049
              ],
              [
                61.7837609,
                30.9340048
              ],
              [
                61.7708773,
                30.9317371
              ],
              [
                61.7536025,
                30.9332941
              ],
              [
                61.7374543,
                30.9436552
              ],
              [
                61.7291533,
                30.9510002
              ],
              [
                61.7257467,
                30.9563971
              ],
              [
                61.7176083,
                30.9661281
              ],
              [
                61.7150803,
                30.9691506
              ],
              [
                61.7041968,
                30.9783451
              ],
              [
                61.6945837,
                30.9882054
              ],
              [
                61.684799,
                30.9942388
              ],
              [
                61.6750143,
                30.9960046
              ],
              [
                61.6587494,
                30.9972186
              ],
              [
                61.640682,
                30.9989475
              ],
              [
                61.6281508,
                31.0015961
              ],
              [
                61.6230869,
                31.0006028
              ],
              [
                61.6183232,
                30.9998212
              ],
              [
                61.6121433,
                30.997145
              ],
              [
                61.6067791,
                30.9926936
              ],
              [
                61.6043329,
                30.9916083
              ],
              [
                61.601758,
                30.990799
              ],
              [
                61.5984281,
                30.9915611
              ],
              [
                61.5935443,
                30.9947441
              ],
              [
                61.5872393,
                30.9988505
              ],
              [
                61.5839065,
                31.0014964
              ],
              [
                61.5772118,
                31.0003121
              ],
              [
                61.5735937,
                31.0000581
              ],
              [
                61.5718533,
                30.9981946
              ],
              [
                61.5639878,
                30.9866879
              ],
              [
                61.5620217,
                30.9740698
              ],
              [
                61.552298,
                30.9640226
              ],
              [
                61.5502829,
                30.9575794
              ],
              [
                61.5485327,
                30.9533999
              ],
              [
                61.5432986,
                30.9485761
              ],
              [
                61.5350752,
                30.9517706
              ],
              [
                61.5315134,
                30.9492073
              ],
              [
                61.5322308,
                30.9451533
              ],
              [
                61.5320347,
                30.9412556
              ],
              [
                61.5309231,
                30.9389
              ],
              [
                61.5294694,
                30.9369946
              ],
              [
                61.5253324,
                30.936264
              ],
              [
                61.5209841,
                30.9363482
              ],
              [
                61.5174204,
                30.9370773
              ],
              [
                61.5144125,
                30.9385355
              ],
              [
                61.5104598,
                30.9412299
              ],
              [
                61.5076612,
                30.943597
              ],
              [
                61.4996838,
                30.9457421
              ],
              [
                61.4955644,
                30.9473684
              ],
              [
                61.4895819,
                30.9491747
              ],
              [
                61.4898265,
                30.9324782
              ],
              [
                61.490884,
                30.9167848
              ],
              [
                61.4901811,
                30.896429
              ],
              [
                61.4905734,
                30.8909398
              ],
              [
                61.4938582,
                30.877293
              ],
              [
                61.4968849,
                30.8665255
              ],
              [
                61.4965035,
                30.8610565
              ],
              [
                61.4970957,
                30.8577383
              ],
              [
                61.496162,
                30.8510702
              ],
              [
                61.4948235,
                30.8463592
              ],
              [
                61.4918998,
                30.8375837
              ],
              [
                61.4903115,
                30.8312652
              ],
              [
                61.4898357,
                30.8234213
              ],
              [
                61.4899545,
                30.8176484
              ],
              [
                61.4889856,
                30.8150763
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555069,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سراوان",
          "name:ar": "مقاطعة سراوان",
          "name:en": "Saravan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279055",
          "wikipedia": "en:Saravan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                61.6016609,
                27.9098524
              ],
              [
                61.6136772,
                27.8969386
              ],
              [
                61.6214987,
                27.8873232
              ],
              [
                61.6416211,
                27.8711693
              ],
              [
                61.6597289,
                27.8638155
              ],
              [
                61.6799737,
                27.8606219
              ],
              [
                61.6876482,
                27.8574733
              ],
              [
                61.6933582,
                27.8532728
              ],
              [
                61.7481316,
                27.822316
              ],
              [
                61.7528313,
                27.8095078
              ],
              [
                61.7750573,
                27.7697835
              ],
              [
                61.7794972,
                27.762845
              ],
              [
                61.8071816,
                27.7231373
              ],
              [
                61.8422767,
                27.6727797
              ],
              [
                61.8608627,
                27.6437703
              ],
              [
                61.8727921,
                27.6263051
              ],
              [
                61.8827221,
                27.6147102
              ],
              [
                61.8911681,
                27.6050604
              ],
              [
                61.9009082,
                27.5969752
              ],
              [
                61.9072929,
                27.5898937
              ],
              [
                61.9319914,
                27.5674824
              ],
              [
                61.9457332,
                27.5438179
              ],
              [
                61.9494749,
                27.5389135
              ],
              [
                61.968212,
                27.5210601
              ],
              [
                61.9792842,
                27.5151227
              ],
              [
                62.0109314,
                27.5174881
              ],
              [
                62.016259,
                27.516179
              ],
              [
                62.0202913,
                27.5170594
              ],
              [
                62.0313658,
                27.5128695
              ],
              [
                62.0382979,
                27.509264
              ],
              [
                62.0553143,
                27.5022465
              ],
              [
                62.0701789,
                27.4938825
              ],
              [
                62.0824527,
                27.4834513
              ],
              [
                62.0928589,
                27.4734104
              ],
              [
                62.0941916,
                27.4668365
              ],
              [
                62.0949248,
                27.4567205
              ],
              [
                62.099844,
                27.4359766
              ],
              [
                62.100071,
                27.4242214
              ],
              [
                62.1100043,
                27.3668892
              ],
              [
                62.1108626,
                27.3514907
              ],
              [
                62.1108308,
                27.3327908
              ],
              [
                62.1157454,
                27.3230092
              ],
              [
                62.1203436,
                27.3158876
              ],
              [
                62.1247904,
                27.3122813
              ],
              [
                62.1322651,
                27.3085896
              ],
              [
                62.1399616,
                27.306392
              ],
              [
                62.1440517,
                27.3050217
              ],
              [
                62.1534034,
                27.3022717
              ],
              [
                62.1734129,
                27.2965367
              ],
              [
                62.1903493,
                27.2911651
              ],
              [
                62.2242886,
                27.2801434
              ],
              [
                62.2312543,
                27.2773972
              ],
              [
                62.2367083,
                27.2751703
              ],
              [
                62.2480574,
                27.2694513
              ],
              [
                62.2628258,
                27.2659417
              ],
              [
                62.2763071,
                27.2637703
              ],
              [
                62.2832499,
                27.2630103
              ],
              [
                62.293422,
                27.2604105
              ],
              [
                62.3034667,
                27.2570713
              ],
              [
                62.3091315,
                27.2531036
              ],
              [
                62.3127955,
                27.2499476
              ],
              [
                62.3139495,
                27.2487914
              ],
              [
                62.3159544,
                27.2453605
              ],
              [
                62.317222,
                27.2396638
              ],
              [
                62.317959,
                27.2319298
              ],
              [
                62.3128947,
                27.222961
              ],
              [
                62.3045503,
                27.217927
              ],
              [
                62.2951811,
                27.1912726
              ],
              [
                62.2812238,
                27.1523612
              ],
              [
                62.267606,
                27.113688
              ],
              [
                62.2692272,
                27.0559427
              ],
              [
                62.3409762,
                27.0650271
              ],
              [
                62.4353099,
                27.0605821
              ],
              [
                62.4351493,
                27.0217678
              ],
              [
                62.4349166,
                26.9964613
              ],
              [
                62.4251777,
                26.9820781
              ],
              [
                62.4007756,
                26.9766897
              ],
              [
                62.4000423,
                26.9705293
              ],
              [
                62.4086883,
                26.9603692
              ],
              [
                62.4812177,
                26.9682813
              ],
              [
                62.4955221,
                26.9536135
              ],
              [
                62.493017,
                26.916146
              ],
              [
                62.4750809,
                26.8874452
              ],
              [
                62.4360751,
                26.8830336
              ],
              [
                62.4098868,
                26.8780026
              ],
              [
                62.3906034,
                26.8642055
              ],
              [
                62.3705417,
                26.850472
              ],
              [
                62.3701503,
                26.8469794
              ],
              [
                62.3659176,
                26.8297594
              ],
              [
                62.3635843,
                26.8292419
              ],
              [
                62.3109678,
                26.8272835
              ],
              [
                62.2546528,
                26.8047826
              ],
              [
                62.240836,
                26.7492432
              ],
              [
                62.2863701,
                26.7212705
              ],
              [
                62.3057847,
                26.705252
              ],
              [
                62.3196964,
                26.6857604
              ],
              [
                62.3592414,
                26.6544207
              ],
              [
                62.3985721,
                26.6416785
              ],
              [
                62.4270363,
                26.6286756
              ],
              [
                62.4286577,
                26.6281795
              ],
              [
                62.4456474,
                26.622981
              ],
              [
                62.4716532,
                26.5913145
              ],
              [
                62.485658,
                26.5842732
              ],
              [
                62.5085696,
                26.5850721
              ],
              [
                62.5174113,
                26.5763444
              ],
              [
                62.5169577,
                26.5757508
              ],
              [
                62.517283,
                26.575498
              ],
              [
                62.518229,
                26.57454
              ],
              [
                62.519264,
                26.573214
              ],
              [
                62.520929,
                26.572006
              ],
              [
                62.522331,
                26.571535
              ],
              [
                62.523247,
                26.571726
              ],
              [
                62.524433,
                26.571534
              ],
              [
                62.525835,
                26.571166
              ],
              [
                62.526835,
                26.570956
              ],
              [
                62.527646,
                26.570906
              ],
              [
                62.528924,
                26.570996
              ],
              [
                62.530448,
                26.571338
              ],
              [
                62.5319,
                26.571405
              ],
              [
                62.533152,
                26.571576
              ],
              [
                62.534207,
                26.571876
              ],
              [
                62.535115,
                26.572301
              ],
              [
                62.536011,
                26.572787
              ],
              [
                62.536799,
                26.572974
              ],
              [
                62.539298,
                26.573295
              ],
              [
                62.540934,
                26.573822
              ],
              [
                62.543209,
                26.574349
              ],
              [
                62.54672,
                26.574436
              ],
              [
                62.548093,
                26.574117
              ],
              [
                62.54833,
                26.574167
              ],
              [
                62.5505,
                26.575072
              ],
              [
                62.552043,
                26.575738
              ],
              [
                62.552462,
                26.575968
              ],
              [
                62.558237,
                26.57681
              ],
              [
                62.559429,
                26.576935
              ],
              [
                62.561001,
                26.576816
              ],
              [
                62.562715,
                26.576542
              ],
              [
                62.563596,
                26.576337
              ],
              [
                62.565713,
                26.576241
              ],
              [
                62.569542,
                26.576172
              ],
              [
                62.571718,
                26.576478
              ],
              [
                62.576476,
                26.577442
              ],
              [
                62.577197,
                26.57753
              ],
              [
                62.578337,
                26.577578
              ],
              [
                62.579633,
                26.577571
              ],
              [
                62.581254,
                26.577438
              ],
              [
                62.583973,
                26.577406
              ],
              [
                62.58567,
                26.577073
              ],
              [
                62.587378,
                26.576824
              ],
              [
                62.5884451,
                26.576841
              ],
              [
                62.590457,
                26.576873
              ],
              [
                62.591526,
                26.576787
              ],
              [
                62.592412,
                26.576774
              ],
              [
                62.59445,
                26.576247
              ],
              [
                62.595729,
                26.576007
              ],
              [
                62.601445,
                26.575989
              ],
              [
                62.604098,
                26.576273
              ],
              [
                62.604424,
                26.576492
              ],
              [
                62.604557,
                26.577937
              ],
              [
                62.604697,
                26.57839
              ],
              [
                62.605151,
                26.579441
              ],
              [
                62.605833,
                26.580323
              ],
              [
                62.607539,
                26.581549
              ],
              [
                62.609283,
                26.582487
              ],
              [
                62.610743,
                26.583143
              ],
              [
                62.614006,
                26.584013
              ],
              [
                62.614825,
                26.584316
              ],
              [
                62.615597,
                26.584834
              ],
              [
                62.619983,
                26.586231
              ],
              [
                62.621932,
                26.586746
              ],
              [
                62.622958,
                26.587143
              ],
              [
                62.623721,
                26.587631
              ],
              [
                62.624795,
                26.588749
              ],
              [
                62.626824,
                26.590226
              ],
              [
                62.62828,
                26.590743
              ],
              [
                62.629425,
                26.591092
              ],
              [
                62.63045,
                26.591231
              ],
              [
                62.633609,
                26.591522
              ],
              [
                62.634975,
                26.592231
              ],
              [
                62.635831,
                26.593085
              ],
              [
                62.637055,
                26.595075
              ],
              [
                62.637436,
                26.596206
              ],
              [
                62.638224,
                26.597291
              ],
              [
                62.641782,
                26.599162
              ],
              [
                62.642822,
                26.599523
              ],
              [
                62.644306,
                26.59984
              ],
              [
                62.64617,
                26.600902
              ],
              [
                62.646892,
                26.601754
              ],
              [
                62.647749,
                26.603082
              ],
              [
                62.647913,
                26.603874
              ],
              [
                62.647828,
                26.605271
              ],
              [
                62.648111,
                26.606866
              ],
              [
                62.648636,
                26.60859
              ],
              [
                62.649324,
                26.609622
              ],
              [
                62.651571,
                26.610976
              ],
              [
                62.653724,
                26.610854
              ],
              [
                62.655738,
                26.610623
              ],
              [
                62.657836,
                26.610266
              ],
              [
                62.659415,
                26.610239
              ],
              [
                62.661921,
                26.610642
              ],
              [
                62.663932,
                26.611208
              ],
              [
                62.665505,
                26.611753
              ],
              [
                62.668034,
                26.61228
              ],
              [
                62.670853,
                26.612561
              ],
              [
                62.672106,
                26.612291
              ],
              [
                62.673134,
                26.611797
              ],
              [
                62.674239,
                26.610968
              ],
              [
                62.674896,
                26.610541
              ],
              [
                62.675644,
                26.610309
              ],
              [
                62.676465,
                26.60991
              ],
              [
                62.676823,
                26.609276
              ],
              [
                62.677578,
                26.608375
              ],
              [
                62.678564,
                26.607551
              ],
              [
                62.680177,
                26.605189
              ],
              [
                62.681213,
                26.604037
              ],
              [
                62.681912,
                26.60338
              ],
              [
                62.683483,
                26.602275
              ],
              [
                62.684569,
                26.601649
              ],
              [
                62.685838,
                26.601123
              ],
              [
                62.687096,
                26.600803
              ],
              [
                62.688486,
                26.600529
              ],
              [
                62.689236,
                26.60049
              ],
              [
                62.689732,
                26.600632
              ],
              [
                62.690577,
                26.601217
              ],
              [
                62.691378,
                26.602027
              ],
              [
                62.692421,
                26.60324
              ],
              [
                62.694718,
                26.606484
              ],
              [
                62.695751,
                26.60785
              ],
              [
                62.696561,
                26.608879
              ],
              [
                62.696979,
                26.609269
              ],
              [
                62.697616,
                26.609444
              ],
              [
                62.698575,
                26.609358
              ],
              [
                62.699025,
                26.609257
              ],
              [
                62.699875,
                26.60898
              ],
              [
                62.701038,
                26.608311
              ],
              [
                62.703983,
                26.608129
              ],
              [
                62.705112,
                26.608011
              ],
              [
                62.706109,
                26.608083
              ],
              [
                62.706898,
                26.608261
              ],
              [
                62.708731,
                26.60878
              ],
              [
                62.710144,
                26.609088
              ],
              [
                62.713637,
                26.610295
              ],
              [
                62.714847,
                26.610835
              ],
              [
                62.715952,
                26.612077
              ],
              [
                62.716872,
                26.612925
              ],
              [
                62.71759,
                26.613862
              ],
              [
                62.718326,
                26.614337
              ],
              [
                62.719142,
                26.61453
              ],
              [
                62.720102,
                26.614573
              ],
              [
                62.72077,
                26.61452
              ],
              [
                62.721568,
                26.614314
              ],
              [
                62.723213,
                26.613757
              ],
              [
                62.724258,
                26.613744
              ],
              [
                62.724828,
                26.613788
              ],
              [
                62.725351,
                26.613983
              ],
              [
                62.725668,
                26.61446
              ],
              [
                62.725715,
                26.61523
              ],
              [
                62.72598,
                26.616321
              ],
              [
                62.726347,
                26.61704
              ],
              [
                62.727204,
                26.618259
              ],
              [
                62.727305,
                26.61834
              ],
              [
                62.728322,
                26.618523
              ],
              [
                62.729383,
                26.618387
              ],
              [
                62.730194,
                26.618205
              ],
              [
                62.730796,
                26.617484
              ],
              [
                62.731632,
                26.616237
              ],
              [
                62.73231,
                26.615047
              ],
              [
                62.733059,
                26.614293
              ],
              [
                62.733389,
                26.614025
              ],
              [
                62.733826,
                26.61375
              ],
              [
                62.734673,
                26.61363
              ],
              [
                62.735578,
                26.613567
              ],
              [
                62.736343,
                26.613433
              ],
              [
                62.737316,
                26.613188
              ],
              [
                62.738103,
                26.613237
              ],
              [
                62.738544,
                26.613542
              ],
              [
                62.73877,
                26.614121
              ],
              [
                62.738858,
                26.614994
              ],
              [
                62.738479,
                26.615762
              ],
              [
                62.737362,
                26.617179
              ],
              [
                62.735907,
                26.619442
              ],
              [
                62.734547,
                26.621263
              ],
              [
                62.733008,
                26.622856
              ],
              [
                62.732201,
                26.623575
              ],
              [
                62.731781,
                26.624411
              ],
              [
                62.731681,
                26.625402
              ],
              [
                62.73235,
                26.627629
              ],
              [
                62.732607,
                26.628067
              ],
              [
                62.733263,
                26.629538
              ],
              [
                62.733898,
                26.630563
              ],
              [
                62.734834,
                26.6313
              ],
              [
                62.7354,
                26.631662
              ],
              [
                62.735558,
                26.631713
              ],
              [
                62.737552,
                26.632794
              ],
              [
                62.739098,
                26.632894
              ],
              [
                62.740947,
                26.632947
              ],
              [
                62.742177,
                26.632908
              ],
              [
                62.74355,
                26.633412
              ],
              [
                62.74425,
                26.63414
              ],
              [
                62.744453,
                26.634449
              ],
              [
                62.744813,
                26.63513
              ],
              [
                62.745423,
                26.636746
              ],
              [
                62.7461,
                26.637764
              ],
              [
                62.747259,
                26.63913
              ],
              [
                62.74946,
                26.640942
              ],
              [
                62.752246,
                26.642764
              ],
              [
                62.7530063,
                26.6431979
              ],
              [
                62.7535368,
                26.6450164
              ],
              [
                62.7551262,
                26.6458089
              ],
              [
                62.7563549,
                26.6458244
              ],
              [
                62.7588178,
                26.6458556
              ],
              [
                62.7608113,
                26.6454665
              ],
              [
                62.7622559,
                26.6461599
              ],
              [
                62.765293,
                26.644437
              ],
              [
                62.7664,
                26.643643
              ],
              [
                62.767513,
                26.643084
              ],
              [
                62.7690289,
                26.641007
              ],
              [
                62.7718851,
                26.6396411
              ],
              [
                62.7745082,
                26.6387006
              ],
              [
                62.7763719,
                26.6387984
              ],
              [
                62.7772269,
                26.6388074
              ],
              [
                62.7789669,
                26.6389914
              ],
              [
                62.779941,
                26.639972
              ],
              [
                62.780403,
                26.641686
              ],
              [
                62.781358,
                26.643
              ],
              [
                62.782303,
                26.643317
              ],
              [
                62.783592,
                26.643923
              ],
              [
                62.785461,
                26.645024
              ],
              [
                62.788217,
                26.647164
              ],
              [
                62.790634,
                26.649111
              ],
              [
                62.793525,
                26.650715
              ],
              [
                62.7947,
                26.651003
              ],
              [
                62.795972,
                26.650248
              ],
              [
                62.796656,
                26.649097
              ],
              [
                62.796876,
                26.64807
              ],
              [
                62.797338,
                26.647311
              ],
              [
                62.797983,
                26.647029
              ],
              [
                62.800239,
                26.646937
              ],
              [
                62.801253,
                26.64712
              ],
              [
                62.802319,
                26.647861
              ],
              [
                62.803744,
                26.648738
              ],
              [
                62.805235,
                26.649472
              ],
              [
                62.805932,
                26.649919
              ],
              [
                62.806387,
                26.650011
              ],
              [
                62.807767,
                26.650146
              ],
              [
                62.809164,
                26.650169
              ],
              [
                62.809988,
                26.649847
              ],
              [
                62.811339,
                26.648827
              ],
              [
                62.812196,
                26.647949
              ],
              [
                62.813421,
                26.646903
              ],
              [
                62.815903,
                26.645514
              ],
              [
                62.81756,
                26.644233
              ],
              [
                62.819331,
                26.643141
              ],
              [
                62.821488,
                26.641233
              ],
              [
                62.823375,
                26.639084
              ],
              [
                62.823982,
                26.638165
              ],
              [
                62.824409,
                26.637995
              ],
              [
                62.825304,
                26.638301
              ],
              [
                62.826831,
                26.639328
              ],
              [
                62.828261,
                26.640558
              ],
              [
                62.829285,
                26.641868
              ],
              [
                62.830622,
                26.644699
              ],
              [
                62.831594,
                26.645235
              ],
              [
                62.833002,
                26.644794
              ],
              [
                62.83415,
                26.644357
              ],
              [
                62.836332,
                26.642454
              ],
              [
                62.837637,
                26.641691
              ],
              [
                62.838757,
                26.641282
              ],
              [
                62.840862,
                26.641245
              ],
              [
                62.842079,
                26.641555
              ],
              [
                62.844085,
                26.642346
              ],
              [
                62.845741,
                26.64257
              ],
              [
                62.848523,
                26.642823
              ],
              [
                62.851218,
                26.643149
              ],
              [
                62.853909,
                26.64338
              ],
              [
                62.856741,
                26.642676
              ],
              [
                62.857673,
                26.642695
              ],
              [
                62.8587,
                26.642846
              ],
              [
                62.860477,
                26.642678
              ],
              [
                62.861284,
                26.642522
              ],
              [
                62.862828,
                26.641671
              ],
              [
                62.863323,
                26.641453
              ],
              [
                62.864598,
                26.641318
              ],
              [
                62.866953,
                26.641436
              ],
              [
                62.871063,
                26.642269
              ],
              [
                62.873058,
                26.642747
              ],
              [
                62.875403,
                26.642749
              ],
              [
                62.877413,
                26.643772
              ],
              [
                62.878641,
                26.644218
              ],
              [
                62.879982,
                26.644767
              ],
              [
                62.882253,
                26.645172
              ],
              [
                62.883534,
                26.645509
              ],
              [
                62.883949,
                26.645556
              ],
              [
                62.884404,
                26.64553
              ],
              [
                62.885541,
                26.646028
              ],
              [
                62.886958,
                26.646431
              ],
              [
                62.887814,
                26.646358
              ],
              [
                62.889057,
                26.646026
              ],
              [
                62.89172,
                26.64515
              ],
              [
                62.893371,
                26.64434
              ],
              [
                62.894331,
                26.643018
              ],
              [
                62.895087,
                26.642225
              ],
              [
                62.896041,
                26.641377
              ],
              [
                62.89723,
                26.640896
              ],
              [
                62.899402,
                26.640582
              ],
              [
                62.9005901,
                26.6404345
              ],
              [
                62.9024412,
                26.6406291
              ],
              [
                62.9037999,
                26.6431029
              ],
              [
                62.905987,
                26.643946
              ],
              [
                62.9081696,
                26.6430714
              ],
              [
                62.908906,
                26.6425304
              ],
              [
                62.910632,
                26.643294
              ],
              [
                62.9118904,
                26.6439926
              ],
              [
                62.9166813,
                26.6456178
              ],
              [
                62.91852,
                26.645579
              ],
              [
                62.918664,
                26.645587
              ],
              [
                62.9200712,
                26.6450989
              ],
              [
                62.9201696,
                26.6435198
              ],
              [
                62.9227511,
                26.6410358
              ],
              [
                62.925477,
                26.640362
              ],
              [
                62.927121,
                26.639843
              ],
              [
                62.929703,
                26.639257
              ],
              [
                62.931568,
                26.639157
              ],
              [
                62.933721,
                26.639178
              ],
              [
                62.934241,
                26.639642
              ],
              [
                62.934491,
                26.64176
              ],
              [
                62.93474,
                26.643005
              ],
              [
                62.935365,
                26.643575
              ],
              [
                62.936519,
                26.644226
              ],
              [
                62.937338,
                26.64446
              ],
              [
                62.938797,
                26.644399
              ],
              [
                62.939719,
                26.644228
              ],
              [
                62.940779,
                26.643861
              ],
              [
                62.942055,
                26.64254
              ],
              [
                62.943207,
                26.641143
              ],
              [
                62.943479,
                26.640727
              ],
              [
                62.944086,
                26.640613
              ],
              [
                62.944987,
                26.640658
              ],
              [
                62.945861,
                26.641065
              ],
              [
                62.94682,
                26.643387
              ],
              [
                62.949386,
                26.645984
              ],
              [
                62.95114,
                26.647441
              ],
              [
                62.951955,
                26.647705
              ],
              [
                62.953534,
                26.648007
              ],
              [
                62.955922,
                26.647537
              ],
              [
                62.956972,
                26.647442
              ],
              [
                62.960722,
                26.64685
              ],
              [
                62.962336,
                26.64736
              ],
              [
                62.963392,
                26.647781
              ],
              [
                62.96425,
                26.648486
              ],
              [
                62.96509,
                26.64896
              ],
              [
                62.96594,
                26.649242
              ],
              [
                62.966934,
                26.649074
              ],
              [
                62.96771,
                26.648744
              ],
              [
                62.968079,
                26.648665
              ],
              [
                62.970196,
                26.648385
              ],
              [
                62.970628,
                26.648385
              ],
              [
                62.972195,
                26.64811
              ],
              [
                62.973944,
                26.647699
              ],
              [
                62.974777,
                26.64684
              ],
              [
                62.975157,
                26.64675
              ],
              [
                62.975376,
                26.646574
              ],
              [
                62.975468,
                26.646358
              ],
              [
                62.975943,
                26.645929
              ],
              [
                62.976165,
                26.645815
              ],
              [
                62.976481,
                26.64576
              ],
              [
                62.977091,
                26.645718
              ],
              [
                62.977382,
                26.645636
              ],
              [
                62.977653,
                26.645643
              ],
              [
                62.97953,
                26.646038
              ],
              [
                62.980439,
                26.646421
              ],
              [
                62.980943,
                26.646674
              ],
              [
                62.982804,
                26.647923
              ],
              [
                62.983428,
                26.648241
              ],
              [
                62.984739,
                26.649039
              ],
              [
                62.986139,
                26.649419
              ],
              [
                62.987784,
                26.649792
              ],
              [
                62.989011,
                26.649921
              ],
              [
                62.989971,
                26.649943
              ],
              [
                62.992146,
                26.649058
              ],
              [
                62.992682,
                26.648658
              ],
              [
                62.993824,
                26.648468
              ],
              [
                62.994835,
                26.64836
              ],
              [
                62.995261,
                26.648028
              ],
              [
                62.995668,
                26.647544
              ],
              [
                62.996246,
                26.646501
              ],
              [
                62.996715,
                26.644579
              ],
              [
                62.99698,
                26.643993
              ],
              [
                62.997252,
                26.642873
              ],
              [
                62.998122,
                26.640136
              ],
              [
                62.99832,
                26.639296
              ],
              [
                62.998621,
                26.63917
              ],
              [
                62.999257,
                26.639054
              ],
              [
                62.99986,
                26.639156
              ],
              [
                63.000461,
                26.639392
              ],
              [
                63.000899,
                26.639724
              ],
              [
                63.002421,
                26.641067
              ],
              [
                63.003135,
                26.641553
              ],
              [
                63.004337,
                26.642078
              ],
              [
                63.004958,
                26.642271
              ],
              [
                63.006349,
                26.642533
              ],
              [
                63.008544,
                26.642618
              ],
              [
                63.009945,
                26.642801
              ],
              [
                63.010852,
                26.643113
              ],
              [
                63.011656,
                26.643747
              ],
              [
                63.012153,
                26.644591
              ],
              [
                63.012565,
                26.645539
              ],
              [
                63.013772,
                26.646011
              ],
              [
                63.014727,
                26.646273
              ],
              [
                63.015172,
                26.646465
              ],
              [
                63.01593,
                26.64645
              ],
              [
                63.016474,
                26.646076
              ],
              [
                63.016469,
                26.645939
              ],
              [
                63.016569,
                26.645733
              ],
              [
                63.016732,
                26.645625
              ],
              [
                63.016872,
                26.645456
              ],
              [
                63.016918,
                26.645268
              ],
              [
                63.017135,
                26.64488
              ],
              [
                63.017383,
                26.644568
              ],
              [
                63.018866,
                26.642213
              ],
              [
                63.019826,
                26.641491
              ],
              [
                63.021724,
                26.640515
              ],
              [
                63.023589,
                26.639891
              ],
              [
                63.02439,
                26.6395
              ],
              [
                63.025092,
                26.638938
              ],
              [
                63.02553,
                26.638393
              ],
              [
                63.025837,
                26.637853
              ],
              [
                63.026393,
                26.637207
              ],
              [
                63.027616,
                26.636188
              ],
              [
                63.028626,
                26.635875
              ],
              [
                63.030339,
                26.635113
              ],
              [
                63.030633,
                26.634816
              ],
              [
                63.031953,
                26.634128
              ],
              [
                63.032925,
                26.633688
              ],
              [
                63.033943,
                26.633416
              ],
              [
                63.034617,
                26.633102
              ],
              [
                63.03505,
                26.632554
              ],
              [
                63.035425,
                26.631572
              ],
              [
                63.035648,
                26.631213
              ],
              [
                63.035911,
                26.63059
              ],
              [
                63.03639,
                26.629653
              ],
              [
                63.036927,
                26.629524
              ],
              [
                63.037328,
                26.629292
              ],
              [
                63.038425,
                26.628865
              ],
              [
                63.041188,
                26.62856
              ],
              [
                63.042474,
                26.628775
              ],
              [
                63.04342,
                26.629325
              ],
              [
                63.044029,
                26.629314
              ],
              [
                63.045012,
                26.629051
              ],
              [
                63.046014,
                26.628323
              ],
              [
                63.046336,
                26.628183
              ],
              [
                63.048857,
                26.627541
              ],
              [
                63.049491,
                26.627821
              ],
              [
                63.050361,
                26.628569
              ],
              [
                63.05159,
                26.629196
              ],
              [
                63.053278,
                26.629679
              ],
              [
                63.054437,
                26.630987
              ],
              [
                63.054884,
                26.631642
              ],
              [
                63.055522,
                26.634324
              ],
              [
                63.055967,
                26.635828
              ],
              [
                63.056406,
                26.636905
              ],
              [
                63.057121,
                26.637772
              ],
              [
                63.05803,
                26.638299
              ],
              [
                63.058472,
                26.638371
              ],
              [
                63.060435,
                26.638293
              ],
              [
                63.062039,
                26.638678
              ],
              [
                63.062811,
                26.639313
              ],
              [
                63.063225,
                26.639914
              ],
              [
                63.063472,
                26.641215
              ],
              [
                63.063696,
                26.641546
              ],
              [
                63.064194,
                26.64194
              ],
              [
                63.064759,
                26.642146
              ],
              [
                63.065478,
                26.642044
              ],
              [
                63.066437,
                26.64167
              ],
              [
                63.0676,
                26.641099
              ],
              [
                63.069266,
                26.639985
              ],
              [
                63.072085,
                26.638357
              ],
              [
                63.072737,
                26.637632
              ],
              [
                63.073837,
                26.637041
              ],
              [
                63.075448,
                26.636327
              ],
              [
                63.076361,
                26.636544
              ],
              [
                63.077874,
                26.63733
              ],
              [
                63.078574,
                26.637823
              ],
              [
                63.079167,
                26.63796
              ],
              [
                63.080186,
                26.638275
              ],
              [
                63.081444,
                26.638559
              ],
              [
                63.082184,
                26.638637
              ],
              [
                63.082648,
                26.638616
              ],
              [
                63.083415,
                26.638492
              ],
              [
                63.084819,
                26.638589
              ],
              [
                63.086628,
                26.638963
              ],
              [
                63.086802,
                26.63917
              ],
              [
                63.087203,
                26.639265
              ],
              [
                63.088225,
                26.639305
              ],
              [
                63.090389,
                26.639747
              ],
              [
                63.091161,
                26.639835
              ],
              [
                63.091794,
                26.639743
              ],
              [
                63.092249,
                26.639819
              ],
              [
                63.092899,
                26.640114
              ],
              [
                63.093491,
                26.640449
              ],
              [
                63.093505,
                26.640644
              ],
              [
                63.093375,
                26.641139
              ],
              [
                63.093512,
                26.641498
              ],
              [
                63.09378,
                26.641921
              ],
              [
                63.094003,
                26.642135
              ],
              [
                63.09408,
                26.642564
              ],
              [
                63.094504,
                26.643544
              ],
              [
                63.095383,
                26.644933
              ],
              [
                63.095881,
                26.645474
              ],
              [
                63.096504,
                26.646004
              ],
              [
                63.097567,
                26.647102
              ],
              [
                63.097948,
                26.64771
              ],
              [
                63.099007,
                26.649064
              ],
              [
                63.1007,
                26.650391
              ],
              [
                63.102875,
                26.65107
              ],
              [
                63.103997,
                26.651204
              ],
              [
                63.105046,
                26.651094
              ],
              [
                63.105568,
                26.651265
              ],
              [
                63.106426,
                26.651858
              ],
              [
                63.107195,
                26.652267
              ],
              [
                63.108061,
                26.652392
              ],
              [
                63.108576,
                26.652419
              ],
              [
                63.109824,
                26.652088
              ],
              [
                63.111069,
                26.651817
              ],
              [
                63.111425,
                26.651608
              ],
              [
                63.112031,
                26.651088
              ],
              [
                63.113012,
                26.650617
              ],
              [
                63.114488,
                26.649825
              ],
              [
                63.115055,
                26.649474
              ],
              [
                63.11619,
                26.64909
              ],
              [
                63.118958,
                26.648473
              ],
              [
                63.119862,
                26.648383
              ],
              [
                63.121974,
                26.64899
              ],
              [
                63.122859,
                26.649116
              ],
              [
                63.123527,
                26.649121
              ],
              [
                63.124369,
                26.649345
              ],
              [
                63.125878,
                26.650026
              ],
              [
                63.126524,
                26.650053
              ],
              [
                63.128505,
                26.649806
              ],
              [
                63.129303,
                26.64995
              ],
              [
                63.13007,
                26.650174
              ],
              [
                63.130583,
                26.650379
              ],
              [
                63.131023,
                26.650644
              ],
              [
                63.131712,
                26.650499
              ],
              [
                63.132896,
                26.650544
              ],
              [
                63.13399,
                26.6508
              ],
              [
                63.13444,
                26.65099
              ],
              [
                63.137351,
                26.650574
              ],
              [
                63.138705,
                26.651218
              ],
              [
                63.147787,
                26.649686
              ],
              [
                63.148756,
                26.649605
              ],
              [
                63.149587,
                26.649615
              ],
              [
                63.150302,
                26.649519
              ],
              [
                63.151846,
                26.649407
              ],
              [
                63.15556,
                26.649485
              ],
              [
                63.157746,
                26.649256
              ],
              [
                63.158044,
                26.649019
              ],
              [
                63.158764,
                26.648701
              ],
              [
                63.160169,
                26.648875
              ],
              [
                63.161394,
                26.648755
              ],
              [
                63.162841,
                26.648322
              ],
              [
                63.163802,
                26.648253
              ],
              [
                63.16493,
                26.647956
              ],
              [
                63.165446,
                26.647951
              ],
              [
                63.166175,
                26.647793
              ],
              [
                63.168107,
                26.647177
              ],
              [
                63.168549,
                26.647178
              ],
              [
                63.169195,
                26.646763
              ],
              [
                63.169394,
                26.64682
              ],
              [
                63.169737,
                26.64682
              ],
              [
                63.170132,
                26.646918
              ],
              [
                63.17047,
                26.646899
              ],
              [
                63.170954,
                26.646797
              ],
              [
                63.171228,
                26.646666
              ],
              [
                63.171775,
                26.646707
              ],
              [
                63.1726275,
                26.646383
              ],
              [
                63.172646,
                26.646376
              ],
              [
                63.172928,
                26.646426
              ],
              [
                63.173282,
                26.646735
              ],
              [
                63.173677,
                26.646682
              ],
              [
                63.174138,
                26.646695
              ],
              [
                63.17591,
                26.646556
              ],
              [
                63.177344,
                26.646316
              ],
              [
                63.177515,
                26.646374
              ],
              [
                63.177988,
                26.646221
              ],
              [
                63.178136,
                26.646249
              ],
              [
                63.179009,
                26.64617
              ],
              [
                63.179523,
                26.646381
              ],
              [
                63.1797812,
                26.6463454
              ],
              [
                63.180169,
                26.646292
              ],
              [
                63.181329,
                26.645928
              ],
              [
                63.182101,
                26.646199
              ],
              [
                63.182439,
                26.646216
              ],
              [
                63.18289,
                26.64596
              ],
              [
                63.183103,
                26.645879
              ],
              [
                63.183398,
                26.645845
              ],
              [
                63.18345,
                26.645881
              ],
              [
                63.183516,
                26.646076
              ],
              [
                63.1837797,
                26.6463347
              ],
              [
                63.184047,
                26.646597
              ],
              [
                63.184506,
                26.646498
              ],
              [
                63.184845,
                26.646696
              ],
              [
                63.184992,
                26.646716
              ],
              [
                63.185217,
                26.646447
              ],
              [
                63.18612,
                26.64629
              ],
              [
                63.186407,
                26.64635
              ],
              [
                63.186671,
                26.646506
              ],
              [
                63.187097,
                26.646931
              ],
              [
                63.187394,
                26.647012
              ],
              [
                63.18779,
                26.647054
              ],
              [
                63.188114,
                26.646975
              ],
              [
                63.189532,
                26.646831
              ],
              [
                63.189774,
                26.646766
              ],
              [
                63.189885,
                26.646772
              ],
              [
                63.189996,
                26.646871
              ],
              [
                63.190098,
                26.646896
              ],
              [
                63.190327,
                26.646888
              ],
              [
                63.190465,
                26.646943
              ],
              [
                63.190826,
                26.646924
              ],
              [
                63.191046,
                26.646989
              ],
              [
                63.191587,
                26.647053
              ],
              [
                63.191676,
                26.647034
              ],
              [
                63.191723,
                26.646832
              ],
              [
                63.192,
                26.64647
              ],
              [
                63.192216,
                26.646347
              ],
              [
                63.193163,
                26.646129
              ],
              [
                63.193439,
                26.64615
              ],
              [
                63.19365,
                26.646265
              ],
              [
                63.19391,
                26.646323
              ],
              [
                63.194262,
                26.646248
              ],
              [
                63.195087,
                26.646296
              ],
              [
                63.195313,
                26.646544
              ],
              [
                63.195746,
                26.646604
              ],
              [
                63.196149,
                26.64673
              ],
              [
                63.196532,
                26.647023
              ],
              [
                63.19692,
                26.647126
              ],
              [
                63.196871,
                26.647325
              ],
              [
                63.196915,
                26.647571
              ],
              [
                63.196698,
                26.64775
              ],
              [
                63.196524,
                26.64781
              ],
              [
                63.195053,
                26.647895
              ],
              [
                63.19489,
                26.647958
              ],
              [
                63.194732,
                26.648338
              ],
              [
                63.194852,
                26.648744
              ],
              [
                63.194827,
                26.649002
              ],
              [
                63.194382,
                26.649361
              ],
              [
                63.193631,
                26.64983
              ],
              [
                63.193172,
                26.650779
              ],
              [
                63.192929,
                26.651471
              ],
              [
                63.192895,
                26.651734
              ],
              [
                63.192575,
                26.652243
              ],
              [
                63.1925,
                26.652472
              ],
              [
                63.192467,
                26.65301
              ],
              [
                63.192537,
                26.653214
              ],
              [
                63.192726,
                26.653493
              ],
              [
                63.192821,
                26.654041
              ],
              [
                63.192642,
                26.654325
              ],
              [
                63.192628,
                26.654734
              ],
              [
                63.192178,
                26.657
              ],
              [
                63.19184,
                26.657657
              ],
              [
                63.191622,
                26.658449
              ],
              [
                63.191695,
                26.658948
              ],
              [
                63.191984,
                26.659453
              ],
              [
                63.192027,
                26.659641
              ],
              [
                63.191867,
                26.659988
              ],
              [
                63.191888,
                26.660173
              ],
              [
                63.191492,
                26.660944
              ],
              [
                63.191593,
                26.661316
              ],
              [
                63.191484,
                26.661436
              ],
              [
                63.191379,
                26.661676
              ],
              [
                63.191467,
                26.662179
              ],
              [
                63.191448,
                26.662296
              ],
              [
                63.191295,
                26.662428
              ],
              [
                63.19119,
                26.662452
              ],
              [
                63.191117,
                26.662574
              ],
              [
                63.191067,
                26.662931
              ],
              [
                63.19085,
                26.663536
              ],
              [
                63.190809,
                26.663883
              ],
              [
                63.19066,
                26.664101
              ],
              [
                63.19067,
                26.664266
              ],
              [
                63.190529,
                26.664375
              ],
              [
                63.190523,
                26.664927
              ],
              [
                63.190562,
                26.665018
              ],
              [
                63.190459,
                26.665157
              ],
              [
                63.190506,
                26.665256
              ],
              [
                63.190489,
                26.665348
              ],
              [
                63.19033,
                26.66549
              ],
              [
                63.190304,
                26.665601
              ],
              [
                63.190473,
                26.666127
              ],
              [
                63.201,
                26.674222
              ],
              [
                63.188476,
                26.695306
              ],
              [
                63.19065,
                26.710533
              ],
              [
                63.190822,
                26.710655
              ],
              [
                63.190999,
                26.710661
              ],
              [
                63.191262,
                26.710557
              ],
              [
                63.191668,
                26.710943
              ],
              [
                63.191836,
                26.71088
              ],
              [
                63.192199,
                26.710858
              ],
              [
                63.192334,
                26.710769
              ],
              [
                63.193243,
                26.71104
              ],
              [
                63.193415,
                26.711153
              ],
              [
                63.193643,
                26.711101
              ],
              [
                63.193885,
                26.710925
              ],
              [
                63.194258,
                26.710933
              ],
              [
                63.194466,
                26.710878
              ],
              [
                63.194685,
                26.710725
              ],
              [
                63.194959,
                26.710797
              ],
              [
                63.195365,
                26.710717
              ],
              [
                63.195834,
                26.710691
              ],
              [
                63.196106,
                26.710796
              ],
              [
                63.196532,
                26.710691
              ],
              [
                63.196702,
                26.710769
              ],
              [
                63.197082,
                26.710803
              ],
              [
                63.197364,
                26.710735
              ],
              [
                63.197611,
                26.710824
              ],
              [
                63.197941,
                26.710775
              ],
              [
                63.198097,
                26.710822
              ],
              [
                63.198436,
                26.710634
              ],
              [
                63.198865,
                26.710539
              ],
              [
                63.199027,
                26.710643
              ],
              [
                63.199131,
                26.710666
              ],
              [
                63.199357,
                26.71063
              ],
              [
                63.199508,
                26.710709
              ],
              [
                63.19964,
                26.71072
              ],
              [
                63.200163,
                26.710636
              ],
              [
                63.200394,
                26.710539
              ],
              [
                63.200675,
                26.710529
              ],
              [
                63.200815,
                26.710466
              ],
              [
                63.200906,
                26.710337
              ],
              [
                63.201131,
                26.710281
              ],
              [
                63.201182,
                26.710553
              ],
              [
                63.201154,
                26.711011
              ],
              [
                63.201187,
                26.711154
              ],
              [
                63.200864,
                26.711984
              ],
              [
                63.200604,
                26.712294
              ],
              [
                63.200501,
                26.712685
              ],
              [
                63.200532,
                26.712753
              ],
              [
                63.20047,
                26.713032
              ],
              [
                63.200308,
                26.713162
              ],
              [
                63.200147,
                26.713205
              ],
              [
                63.200033,
                26.713377
              ],
              [
                63.200137,
                26.71362
              ],
              [
                63.199997,
                26.714182
              ],
              [
                63.200299,
                26.714646
              ],
              [
                63.200656,
                26.714769
              ],
              [
                63.200904,
                26.715556
              ],
              [
                63.200967,
                26.715663
              ],
              [
                63.201218,
                26.715848
              ],
              [
                63.201166,
                26.71613
              ],
              [
                63.201357,
                26.716793
              ],
              [
                63.201705,
                26.716936
              ],
              [
                63.201972,
                26.717231
              ],
              [
                63.202001,
                26.717422
              ],
              [
                63.202328,
                26.717564
              ],
              [
                63.202793,
                26.717659
              ],
              [
                63.202919,
                26.717798
              ],
              [
                63.203202,
                26.717776
              ],
              [
                63.203318,
                26.717906
              ],
              [
                63.204034,
                26.718447
              ],
              [
                63.203814,
                26.718884
              ],
              [
                63.203647,
                26.718976
              ],
              [
                63.203666,
                26.719091
              ],
              [
                63.2036,
                26.719153
              ],
              [
                63.203215,
                26.719227
              ],
              [
                63.203161,
                26.719259
              ],
              [
                63.203143,
                26.719368
              ],
              [
                63.203046,
                26.719427
              ],
              [
                63.203018,
                26.719578
              ],
              [
                63.202903,
                26.719722
              ],
              [
                63.202982,
                26.719898
              ],
              [
                63.202881,
                26.720041
              ],
              [
                63.202883,
                26.720132
              ],
              [
                63.202836,
                26.720104
              ],
              [
                63.202632,
                26.72023
              ],
              [
                63.20253,
                26.720187
              ],
              [
                63.20251,
                26.720119
              ],
              [
                63.202312,
                26.720051
              ],
              [
                63.2021,
                26.720113
              ],
              [
                63.201925,
                26.720091
              ],
              [
                63.20175,
                26.720316
              ],
              [
                63.201641,
                26.720342
              ],
              [
                63.201581,
                26.720407
              ],
              [
                63.20153,
                26.720478
              ],
              [
                63.20153,
                26.720609
              ],
              [
                63.201334,
                26.720744
              ],
              [
                63.201046,
                26.721131
              ],
              [
                63.200915,
                26.721431
              ],
              [
                63.200789,
                26.721769
              ],
              [
                63.200798,
                26.722006
              ],
              [
                63.200664,
                26.722122
              ],
              [
                63.200678,
                26.722279
              ],
              [
                63.200535,
                26.722354
              ],
              [
                63.200527,
                26.722847
              ],
              [
                63.200487,
                26.722942
              ],
              [
                63.20058,
                26.723071
              ],
              [
                63.20057,
                26.723333
              ],
              [
                63.200472,
                26.723374
              ],
              [
                63.200425,
                26.723524
              ],
              [
                63.200349,
                26.72357
              ],
              [
                63.200295,
                26.723717
              ],
              [
                63.200093,
                26.723951
              ],
              [
                63.200118,
                26.72416
              ],
              [
                63.200168,
                26.724174
              ],
              [
                63.200244,
                26.724339
              ],
              [
                63.200252,
                26.724506
              ],
              [
                63.20016,
                26.724586
              ],
              [
                63.200139,
                26.724707
              ],
              [
                63.200029,
                26.724733
              ],
              [
                63.199813,
                26.725187
              ],
              [
                63.19988,
                26.72526
              ],
              [
                63.199843,
                26.725331
              ],
              [
                63.199775,
                26.725395
              ],
              [
                63.199615,
                26.725382
              ],
              [
                63.199665,
                26.725523
              ],
              [
                63.199627,
                26.725951
              ],
              [
                63.199722,
                26.726062
              ],
              [
                63.199739,
                26.726286
              ],
              [
                63.199849,
                26.726429
              ],
              [
                63.199804,
                26.726681
              ],
              [
                63.199753,
                26.726685
              ],
              [
                63.199645,
                26.726824
              ],
              [
                63.199699,
                26.726921
              ],
              [
                63.199651,
                26.727018
              ],
              [
                63.199647,
                26.727672
              ],
              [
                63.199606,
                26.727801
              ],
              [
                63.199435,
                26.727937
              ],
              [
                63.19925,
                26.72837
              ],
              [
                63.199114,
                26.728544
              ],
              [
                63.198977,
                26.729074
              ],
              [
                63.198739,
                26.729347
              ],
              [
                63.19822,
                26.730223
              ],
              [
                63.197837,
                26.730617
              ],
              [
                63.197715,
                26.730826
              ],
              [
                63.197776,
                26.73104
              ],
              [
                63.197934,
                26.73116
              ],
              [
                63.197997,
                26.732
              ],
              [
                63.198173,
                26.732013
              ],
              [
                63.198064,
                26.732429
              ],
              [
                63.198049,
                26.732809
              ],
              [
                63.197898,
                26.733224
              ],
              [
                63.197461,
                26.733582
              ],
              [
                63.197269,
                26.733992
              ],
              [
                63.197122,
                26.734141
              ],
              [
                63.196944,
                26.734491
              ],
              [
                63.196757,
                26.734669
              ],
              [
                63.196654,
                26.73488
              ],
              [
                63.196597,
                26.735516
              ],
              [
                63.196503,
                26.735794
              ],
              [
                63.196166,
                26.736506
              ],
              [
                63.195666,
                26.737151
              ],
              [
                63.195508,
                26.737748
              ],
              [
                63.194968,
                26.73855
              ],
              [
                63.194873,
                26.738866
              ],
              [
                63.194692,
                26.73911
              ],
              [
                63.194773,
                26.739441
              ],
              [
                63.19455,
                26.740378
              ],
              [
                63.194367,
                26.740931
              ],
              [
                63.194653,
                26.741416
              ],
              [
                63.19478,
                26.74179
              ],
              [
                63.194892,
                26.741953
              ],
              [
                63.195257,
                26.742265
              ],
              [
                63.195408,
                26.742266
              ],
              [
                63.195639,
                26.742152
              ],
              [
                63.1959,
                26.742123
              ],
              [
                63.196087,
                26.742283
              ],
              [
                63.19592,
                26.742604
              ],
              [
                63.195999,
                26.742782
              ],
              [
                63.196204,
                26.742883
              ],
              [
                63.196352,
                26.742869
              ],
              [
                63.196596,
                26.742954
              ],
              [
                63.196745,
                26.743398
              ],
              [
                63.196924,
                26.743605
              ],
              [
                63.197474,
                26.74361
              ],
              [
                63.198036,
                26.743695
              ],
              [
                63.19832,
                26.743885
              ],
              [
                63.198433,
                26.744055
              ],
              [
                63.19862,
                26.744117
              ],
              [
                63.198857,
                26.744357
              ],
              [
                63.199073,
                26.744389
              ],
              [
                63.199171,
                26.744464
              ],
              [
                63.199546,
                26.745336
              ],
              [
                63.199472,
                26.745681
              ],
              [
                63.199539,
                26.745765
              ],
              [
                63.199351,
                26.746388
              ],
              [
                63.199417,
                26.74653
              ],
              [
                63.199311,
                26.746617
              ],
              [
                63.199699,
                26.747045
              ],
              [
                63.199841,
                26.747065
              ],
              [
                63.200046,
                26.746991
              ],
              [
                63.200107,
                26.747519
              ],
              [
                63.199982,
                26.747574
              ],
              [
                63.199974,
                26.747668
              ],
              [
                63.200418,
                26.748822
              ],
              [
                63.200389,
                26.749294
              ],
              [
                63.200547,
                26.750179
              ],
              [
                63.201261,
                26.750295
              ],
              [
                63.201256,
                26.750517
              ],
              [
                63.201582,
                26.75079
              ],
              [
                63.20184,
                26.750934
              ],
              [
                63.201699,
                26.751772
              ],
              [
                63.201752,
                26.752917
              ],
              [
                63.201474,
                26.752972
              ],
              [
                63.201435,
                26.753341
              ],
              [
                63.201447,
                26.753496
              ],
              [
                63.201604,
                26.75365
              ],
              [
                63.201694,
                26.753862
              ],
              [
                63.201542,
                26.754159
              ],
              [
                63.201738,
                26.754257
              ],
              [
                63.201852,
                26.754383
              ],
              [
                63.201899,
                26.754731
              ],
              [
                63.201848,
                26.755018
              ],
              [
                63.201878,
                26.755129
              ],
              [
                63.20178,
                26.755309
              ],
              [
                63.201819,
                26.755563
              ],
              [
                63.201558,
                26.755695
              ],
              [
                63.201528,
                26.755817
              ],
              [
                63.201511,
                26.756013
              ],
              [
                63.201577,
                26.756162
              ],
              [
                63.201525,
                26.756272
              ],
              [
                63.201544,
                26.756387
              ],
              [
                63.201442,
                26.756536
              ],
              [
                63.201487,
                26.756733
              ],
              [
                63.201379,
                26.756779
              ],
              [
                63.201201,
                26.756952
              ],
              [
                63.201191,
                26.757395
              ],
              [
                63.201063,
                26.757526
              ],
              [
                63.200848,
                26.757598
              ],
              [
                63.200766,
                26.757682
              ],
              [
                63.200957,
                26.75799
              ],
              [
                63.200888,
                26.758149
              ],
              [
                63.200814,
                26.758151
              ],
              [
                63.200741,
                26.758277
              ],
              [
                63.200617,
                26.758309
              ],
              [
                63.200529,
                26.758407
              ],
              [
                63.200623,
                26.758654
              ],
              [
                63.200474,
                26.7587
              ],
              [
                63.200392,
                26.759233
              ],
              [
                63.200213,
                26.759357
              ],
              [
                63.200051,
                26.75933
              ],
              [
                63.199935,
                26.759396
              ],
              [
                63.199461,
                26.759498
              ],
              [
                63.199142,
                26.759389
              ],
              [
                63.198904,
                26.759381
              ],
              [
                63.198999,
                26.759695
              ],
              [
                63.19903,
                26.759997
              ],
              [
                63.19894,
                26.760103
              ],
              [
                63.199099,
                26.760192
              ],
              [
                63.199108,
                26.76026
              ],
              [
                63.199065,
                26.760466
              ],
              [
                63.198916,
                26.760629
              ],
              [
                63.199121,
                26.761252
              ],
              [
                63.199171,
                26.761264
              ],
              [
                63.198926,
                26.761384
              ],
              [
                63.198892,
                26.761518
              ],
              [
                63.198931,
                26.761685
              ],
              [
                63.198818,
                26.761784
              ],
              [
                63.198959,
                26.761992
              ],
              [
                63.198857,
                26.762007
              ],
              [
                63.19878,
                26.762126
              ],
              [
                63.198817,
                26.7622
              ],
              [
                63.198782,
                26.762338
              ],
              [
                63.198979,
                26.762679
              ],
              [
                63.199432,
                26.762888
              ],
              [
                63.199088,
                26.76298
              ],
              [
                63.199005,
                26.763087
              ],
              [
                63.198881,
                26.763106
              ],
              [
                63.198771,
                26.763205
              ],
              [
                63.198669,
                26.763194
              ],
              [
                63.198382,
                26.763305
              ],
              [
                63.198201,
                26.763493
              ],
              [
                63.197864,
                26.763563
              ],
              [
                63.197825,
                26.763746
              ],
              [
                63.197652,
                26.763883
              ],
              [
                63.197587,
                26.764016
              ],
              [
                63.197184,
                26.764214
              ],
              [
                63.197216,
                26.764317
              ],
              [
                63.197185,
                26.764505
              ],
              [
                63.19728,
                26.76476
              ],
              [
                63.197464,
                26.765021
              ],
              [
                63.197466,
                26.765119
              ],
              [
                63.197741,
                26.765211
              ],
              [
                63.198409,
                26.765041
              ],
              [
                63.198465,
                26.765258
              ],
              [
                63.198643,
                26.765437
              ],
              [
                63.198681,
                26.765875
              ],
              [
                63.198793,
                26.765977
              ],
              [
                63.198806,
                26.76605
              ],
              [
                63.198932,
                26.766101
              ],
              [
                63.19913,
                26.766444
              ],
              [
                63.199211,
                26.766469
              ],
              [
                63.199163,
                26.766552
              ],
              [
                63.199212,
                26.766608
              ],
              [
                63.199327,
                26.766607
              ],
              [
                63.199424,
                26.766853
              ],
              [
                63.19898,
                26.766976
              ],
              [
                63.198713,
                26.767256
              ],
              [
                63.198703,
                26.767356
              ],
              [
                63.198646,
                26.767409
              ],
              [
                63.198063,
                26.767493
              ],
              [
                63.197783,
                26.767642
              ],
              [
                63.197375,
                26.767685
              ],
              [
                63.197237,
                26.767768
              ],
              [
                63.196583,
                26.767986
              ],
              [
                63.196068,
                26.768332
              ],
              [
                63.195067,
                26.768577
              ],
              [
                63.194898,
                26.768696
              ],
              [
                63.194652,
                26.768781
              ],
              [
                63.194513,
                26.768951
              ],
              [
                63.194328,
                26.769077
              ],
              [
                63.193989,
                26.769188
              ],
              [
                63.193914,
                26.769486
              ],
              [
                63.192732,
                26.769903
              ],
              [
                63.192672,
                26.769967
              ],
              [
                63.192423,
                26.770056
              ],
              [
                63.192259,
                26.770181
              ],
              [
                63.19219,
                26.770316
              ],
              [
                63.191791,
                26.770303
              ],
              [
                63.191485,
                26.770481
              ],
              [
                63.19161,
                26.770912
              ],
              [
                63.191993,
                26.770969
              ],
              [
                63.192156,
                26.770913
              ],
              [
                63.192299,
                26.770948
              ],
              [
                63.192417,
                26.770854
              ],
              [
                63.192464,
                26.770869
              ],
              [
                63.192917,
                26.770692
              ],
              [
                63.19331,
                26.770675
              ],
              [
                63.193486,
                26.770625
              ],
              [
                63.193638,
                26.770643
              ],
              [
                63.193669,
                26.770707
              ],
              [
                63.194041,
                26.770766
              ],
              [
                63.194469,
                26.770727
              ],
              [
                63.19451,
                26.770849
              ],
              [
                63.194668,
                26.771031
              ],
              [
                63.195088,
                26.77123
              ],
              [
                63.195261,
                26.771178
              ],
              [
                63.195582,
                26.771227
              ],
              [
                63.19624,
                26.771147
              ],
              [
                63.196278,
                26.771225
              ],
              [
                63.196446,
                26.771336
              ],
              [
                63.196727,
                26.7714
              ],
              [
                63.196861,
                26.771351
              ],
              [
                63.196995,
                26.771359
              ],
              [
                63.197166,
                26.7712
              ],
              [
                63.197384,
                26.771125
              ],
              [
                63.197582,
                26.771308
              ],
              [
                63.197922,
                26.771425
              ],
              [
                63.197967,
                26.77165
              ],
              [
                63.198155,
                26.771685
              ],
              [
                63.198236,
                26.7718
              ],
              [
                63.1982,
                26.771923
              ],
              [
                63.198266,
                26.772056
              ],
              [
                63.19842,
                26.772193
              ],
              [
                63.198885,
                26.772268
              ],
              [
                63.198985,
                26.772243
              ],
              [
                63.199115,
                26.772134
              ],
              [
                63.19925,
                26.772142
              ],
              [
                63.199988,
                26.772008
              ],
              [
                63.199977,
                26.771956
              ],
              [
                63.200058,
                26.771844
              ],
              [
                63.200246,
                26.771819
              ],
              [
                63.200377,
                26.771748
              ],
              [
                63.200581,
                26.771781
              ],
              [
                63.200983,
                26.771653
              ],
              [
                63.201176,
                26.771754
              ],
              [
                63.201993,
                26.771654
              ],
              [
                63.202328,
                26.771718
              ],
              [
                63.202603,
                26.771707
              ],
              [
                63.202613,
                26.771757
              ],
              [
                63.202879,
                26.771851
              ],
              [
                63.203025,
                26.771832
              ],
              [
                63.203543,
                26.771924
              ],
              [
                63.203629,
                26.771974
              ],
              [
                63.203691,
                26.771612
              ],
              [
                63.203818,
                26.771464
              ],
              [
                63.20417,
                26.771231
              ],
              [
                63.204918,
                26.770391
              ],
              [
                63.204944,
                26.770454
              ],
              [
                63.205183,
                26.770493
              ],
              [
                63.205512,
                26.770675
              ],
              [
                63.205583,
                26.770616
              ],
              [
                63.205708,
                26.7706
              ],
              [
                63.206048,
                26.770735
              ],
              [
                63.206121,
                26.770829
              ],
              [
                63.206202,
                26.770856
              ],
              [
                63.206184,
                26.770978
              ],
              [
                63.20634,
                26.771078
              ],
              [
                63.206354,
                26.771146
              ],
              [
                63.206739,
                26.771284
              ],
              [
                63.206761,
                26.771358
              ],
              [
                63.207516,
                26.771694
              ],
              [
                63.207531,
                26.771753
              ],
              [
                63.207861,
                26.771966
              ],
              [
                63.20865,
                26.772712
              ],
              [
                63.208783,
                26.772997
              ],
              [
                63.208876,
                26.773084
              ],
              [
                63.208945,
                26.77333
              ],
              [
                63.208906,
                26.773337
              ],
              [
                63.208932,
                26.773444
              ],
              [
                63.208733,
                26.773578
              ],
              [
                63.208488,
                26.773651
              ],
              [
                63.208385,
                26.773622
              ],
              [
                63.208325,
                26.773692
              ],
              [
                63.208095,
                26.773739
              ],
              [
                63.207829,
                26.773761
              ],
              [
                63.207633,
                26.773835
              ],
              [
                63.20762,
                26.773876
              ],
              [
                63.207026,
                26.77397
              ],
              [
                63.207081,
                26.774325
              ],
              [
                63.207016,
                26.774403
              ],
              [
                63.206909,
                26.774426
              ],
              [
                63.206956,
                26.774744
              ],
              [
                63.206888,
                26.77491
              ],
              [
                63.206782,
                26.774936
              ],
              [
                63.206369,
                26.774857
              ],
              [
                63.205467,
                26.774922
              ],
              [
                63.205208,
                26.774964
              ],
              [
                63.20501,
                26.775068
              ],
              [
                63.204868,
                26.775089
              ],
              [
                63.204769,
                26.775194
              ],
              [
                63.204489,
                26.775254
              ],
              [
                63.203835,
                26.775152
              ],
              [
                63.203542,
                26.775183
              ],
              [
                63.203373,
                26.775119
              ],
              [
                63.202808,
                26.77513
              ],
              [
                63.202385,
                26.775076
              ],
              [
                63.202326,
                26.775122
              ],
              [
                63.202215,
                26.775081
              ],
              [
                63.201874,
                26.775077
              ],
              [
                63.201559,
                26.775206
              ],
              [
                63.201126,
                26.775303
              ],
              [
                63.20105,
                26.77537
              ],
              [
                63.200968,
                26.775353
              ],
              [
                63.200745,
                26.775474
              ],
              [
                63.200605,
                26.775464
              ],
              [
                63.200573,
                26.775705
              ],
              [
                63.200494,
                26.775775
              ],
              [
                63.200256,
                26.77581
              ],
              [
                63.200147,
                26.775868
              ],
              [
                63.199829,
                26.775868
              ],
              [
                63.199722,
                26.775992
              ],
              [
                63.199626,
                26.77598
              ],
              [
                63.199548,
                26.776024
              ],
              [
                63.199253,
                26.775999
              ],
              [
                63.199094,
                26.776086
              ],
              [
                63.1986,
                26.776061
              ],
              [
                63.198527,
                26.776131
              ],
              [
                63.198317,
                26.776134
              ],
              [
                63.198232,
                26.7762
              ],
              [
                63.198239,
                26.776463
              ],
              [
                63.197964,
                26.776645
              ],
              [
                63.197981,
                26.776938
              ],
              [
                63.197632,
                26.777483
              ],
              [
                63.197768,
                26.778383
              ],
              [
                63.197769,
                26.778751
              ],
              [
                63.197486,
                26.778968
              ],
              [
                63.197026,
                26.779156
              ],
              [
                63.197085,
                26.77945
              ],
              [
                63.197004,
                26.779824
              ],
              [
                63.196825,
                26.779918
              ],
              [
                63.196895,
                26.780439
              ],
              [
                63.196715,
                26.780819
              ],
              [
                63.196701,
                26.781464
              ],
              [
                63.196816,
                26.781602
              ],
              [
                63.197014,
                26.782217
              ],
              [
                63.196554,
                26.782335
              ],
              [
                63.19622,
                26.782309
              ],
              [
                63.195811,
                26.78238
              ],
              [
                63.195595,
                26.782491
              ],
              [
                63.195546,
                26.782579
              ],
              [
                63.195099,
                26.782701
              ],
              [
                63.19519,
                26.783202
              ],
              [
                63.195593,
                26.783932
              ],
              [
                63.195557,
                26.784051
              ],
              [
                63.195774,
                26.784493
              ],
              [
                63.195355,
                26.784602
              ],
              [
                63.195326,
                26.784568
              ],
              [
                63.194815,
                26.784649
              ],
              [
                63.194124,
                26.784879
              ],
              [
                63.19362,
                26.784966
              ],
              [
                63.193237,
                26.784953
              ],
              [
                63.19293,
                26.784866
              ],
              [
                63.192417,
                26.784983
              ],
              [
                63.192378,
                26.785162
              ],
              [
                63.192469,
                26.785332
              ],
              [
                63.19247,
                26.785437
              ],
              [
                63.192512,
                26.78543
              ],
              [
                63.192567,
                26.785516
              ],
              [
                63.192505,
                26.785964
              ],
              [
                63.192395,
                26.786139
              ],
              [
                63.192272,
                26.786198
              ],
              [
                63.192159,
                26.786186
              ],
              [
                63.191905,
                26.786306
              ],
              [
                63.192063,
                26.787108
              ],
              [
                63.191729,
                26.787519
              ],
              [
                63.191886,
                26.787827
              ],
              [
                63.192092,
                26.78807
              ],
              [
                63.191958,
                26.788195
              ],
              [
                63.191956,
                26.788402
              ],
              [
                63.191979,
                26.788524
              ],
              [
                63.192075,
                26.788647
              ],
              [
                63.192046,
                26.788723
              ],
              [
                63.192258,
                26.789133
              ],
              [
                63.192255,
                26.789259
              ],
              [
                63.192651,
                26.789288
              ],
              [
                63.193014,
                26.789204
              ],
              [
                63.19345,
                26.78928
              ],
              [
                63.193634,
                26.789233
              ],
              [
                63.193768,
                26.789257
              ],
              [
                63.194124,
                26.789215
              ],
              [
                63.194109,
                26.789609
              ],
              [
                63.194335,
                26.789789
              ],
              [
                63.1944,
                26.78992
              ],
              [
                63.194598,
                26.789956
              ],
              [
                63.194754,
                26.790406
              ],
              [
                63.194505,
                26.791085
              ],
              [
                63.194549,
                26.79141
              ],
              [
                63.19485,
                26.791336
              ],
              [
                63.195133,
                26.791497
              ],
              [
                63.195198,
                26.791427
              ],
              [
                63.195376,
                26.791412
              ],
              [
                63.195299,
                26.791644
              ],
              [
                63.195317,
                26.791788
              ],
              [
                63.195258,
                26.791854
              ],
              [
                63.195035,
                26.791907
              ],
              [
                63.194959,
                26.791966
              ],
              [
                63.194939,
                26.792072
              ],
              [
                63.194706,
                26.792248
              ],
              [
                63.194642,
                26.792413
              ],
              [
                63.194728,
                26.792529
              ],
              [
                63.195168,
                26.792674
              ],
              [
                63.195128,
                26.792766
              ],
              [
                63.194994,
                26.792912
              ],
              [
                63.19477,
                26.792986
              ],
              [
                63.19438,
                26.792915
              ],
              [
                63.194228,
                26.792935
              ],
              [
                63.1941,
                26.793029
              ],
              [
                63.193911,
                26.793048
              ],
              [
                63.193805,
                26.793202
              ],
              [
                63.193686,
                26.793248
              ],
              [
                63.19263,
                26.793188
              ],
              [
                63.192573,
                26.793257
              ],
              [
                63.192605,
                26.793421
              ],
              [
                63.192233,
                26.793548
              ],
              [
                63.191699,
                26.79361
              ],
              [
                63.191498,
                26.793674
              ],
              [
                63.191421,
                26.793729
              ],
              [
                63.191426,
                26.793957
              ],
              [
                63.191514,
                26.794096
              ],
              [
                63.19151,
                26.794254
              ],
              [
                63.191181,
                26.794363
              ],
              [
                63.19118,
                26.794507
              ],
              [
                63.190984,
                26.794666
              ],
              [
                63.190613,
                26.79461
              ],
              [
                63.190287,
                26.794506
              ],
              [
                63.189937,
                26.794523
              ],
              [
                63.189742,
                26.794456
              ],
              [
                63.189422,
                26.794427
              ],
              [
                63.189393,
                26.794867
              ],
              [
                63.189324,
                26.794961
              ],
              [
                63.189338,
                26.795043
              ],
              [
                63.189349,
                26.795083
              ],
              [
                63.189415,
                26.795087
              ],
              [
                63.189492,
                26.795264
              ],
              [
                63.189454,
                26.795371
              ],
              [
                63.189589,
                26.795546
              ],
              [
                63.18969,
                26.795895
              ],
              [
                63.189886,
                26.796196
              ],
              [
                63.189901,
                26.796281
              ],
              [
                63.189828,
                26.796373
              ],
              [
                63.189818,
                26.796511
              ],
              [
                63.189749,
                26.796561
              ],
              [
                63.189034,
                26.796535
              ],
              [
                63.189006,
                26.796504
              ],
              [
                63.188559,
                26.796543
              ],
              [
                63.188484,
                26.79671
              ],
              [
                63.188365,
                26.796871
              ],
              [
                63.188297,
                26.796898
              ],
              [
                63.188225,
                26.797311
              ],
              [
                63.188148,
                26.797337
              ],
              [
                63.1881,
                26.797502
              ],
              [
                63.188007,
                26.7976
              ],
              [
                63.188108,
                26.79773
              ],
              [
                63.188105,
                26.797892
              ],
              [
                63.18793,
                26.797991
              ],
              [
                63.187878,
                26.798152
              ],
              [
                63.187581,
                26.798196
              ],
              [
                63.187562,
                26.798485
              ],
              [
                63.187601,
                26.798569
              ],
              [
                63.187708,
                26.79864
              ],
              [
                63.187545,
                26.798925
              ],
              [
                63.187727,
                26.79934
              ],
              [
                63.188132,
                26.799305
              ],
              [
                63.188518,
                26.799358
              ],
              [
                63.188991,
                26.799451
              ],
              [
                63.189514,
                26.7997
              ],
              [
                63.18977,
                26.799704
              ],
              [
                63.190092,
                26.799773
              ],
              [
                63.190513,
                26.799936
              ],
              [
                63.190655,
                26.800043
              ],
              [
                63.190764,
                26.80002
              ],
              [
                63.191016,
                26.80015
              ],
              [
                63.19147,
                26.800282
              ],
              [
                63.191489,
                26.800415
              ],
              [
                63.191384,
                26.800484
              ],
              [
                63.191377,
                26.800539
              ],
              [
                63.191633,
                26.800759
              ],
              [
                63.192541,
                26.800958
              ],
              [
                63.192551,
                26.801034
              ],
              [
                63.192651,
                26.801102
              ],
              [
                63.192807,
                26.801096
              ],
              [
                63.19285,
                26.800968
              ],
              [
                63.193256,
                26.800944
              ],
              [
                63.193728,
                26.801068
              ],
              [
                63.193781,
                26.80094
              ],
              [
                63.194098,
                26.801049
              ],
              [
                63.194376,
                26.801085
              ],
              [
                63.194654,
                26.801221
              ],
              [
                63.194683,
                26.801416
              ],
              [
                63.194842,
                26.801688
              ],
              [
                63.194819,
                26.801754
              ],
              [
                63.194519,
                26.801832
              ],
              [
                63.194066,
                26.802096
              ],
              [
                63.193829,
                26.802823
              ],
              [
                63.193709,
                26.802835
              ],
              [
                63.193618,
                26.802784
              ],
              [
                63.193443,
                26.80281
              ],
              [
                63.19315,
                26.802965
              ],
              [
                63.193006,
                26.802992
              ],
              [
                63.192639,
                26.803481
              ],
              [
                63.191438,
                26.804534
              ],
              [
                63.191746,
                26.804672
              ],
              [
                63.191781,
                26.804733
              ],
              [
                63.192034,
                26.804799
              ],
              [
                63.192028,
                26.804857
              ],
              [
                63.191935,
                26.804865
              ],
              [
                63.191983,
                26.805109
              ],
              [
                63.192138,
                26.805131
              ],
              [
                63.192282,
                26.805215
              ],
              [
                63.1925,
                26.805212
              ],
              [
                63.192806,
                26.805341
              ],
              [
                63.193254,
                26.805353
              ],
              [
                63.193334,
                26.805455
              ],
              [
                63.19358,
                26.805573
              ],
              [
                63.193691,
                26.805547
              ],
              [
                63.194202,
                26.805595
              ],
              [
                63.194219,
                26.805746
              ],
              [
                63.194162,
                26.805928
              ],
              [
                63.194233,
                26.806119
              ],
              [
                63.194037,
                26.806337
              ],
              [
                63.193998,
                26.80637
              ],
              [
                63.193679,
                26.806243
              ],
              [
                63.193556,
                26.806328
              ],
              [
                63.193252,
                26.806256
              ],
              [
                63.193096,
                26.806359
              ],
              [
                63.192915,
                26.806333
              ],
              [
                63.192888,
                26.806453
              ],
              [
                63.192403,
                26.806787
              ],
              [
                63.192402,
                26.806985
              ],
              [
                63.192282,
                26.807229
              ],
              [
                63.192676,
                26.807407
              ],
              [
                63.192788,
                26.80744
              ],
              [
                63.192921,
                26.80742
              ],
              [
                63.1933,
                26.807583
              ],
              [
                63.193173,
                26.807738
              ],
              [
                63.192967,
                26.80778
              ],
              [
                63.192874,
                26.807847
              ],
              [
                63.192697,
                26.808101
              ],
              [
                63.192733,
                26.808213
              ],
              [
                63.192708,
                26.808312
              ],
              [
                63.192655,
                26.808337
              ],
              [
                63.192657,
                26.808532
              ],
              [
                63.193038,
                26.808553
              ],
              [
                63.192971,
                26.808827
              ],
              [
                63.19274,
                26.808925
              ],
              [
                63.192582,
                26.809424
              ],
              [
                63.192918,
                26.809738
              ],
              [
                63.19287,
                26.8098
              ],
              [
                63.192963,
                26.809864
              ],
              [
                63.193749,
                26.809791
              ],
              [
                63.194097,
                26.809869
              ],
              [
                63.194223,
                26.810213
              ],
              [
                63.194349,
                26.810228
              ],
              [
                63.194653,
                26.810537
              ],
              [
                63.194744,
                26.810748
              ],
              [
                63.194708,
                26.810808
              ],
              [
                63.194739,
                26.81087
              ],
              [
                63.19494,
                26.81108
              ],
              [
                63.194807,
                26.811159
              ],
              [
                63.194692,
                26.811156
              ],
              [
                63.194701,
                26.811257
              ],
              [
                63.194627,
                26.811455
              ],
              [
                63.194635,
                26.811538
              ],
              [
                63.194805,
                26.811719
              ],
              [
                63.194685,
                26.811743
              ],
              [
                63.194166,
                26.812075
              ],
              [
                63.193905,
                26.812147
              ],
              [
                63.193692,
                26.812479
              ],
              [
                63.193436,
                26.812735
              ],
              [
                63.193401,
                26.812901
              ],
              [
                63.193431,
                26.813014
              ],
              [
                63.193499,
                26.813031
              ],
              [
                63.193679,
                26.813273
              ],
              [
                63.193449,
                26.814024
              ],
              [
                63.192779,
                26.815531
              ],
              [
                63.192471,
                26.816586
              ],
              [
                63.192253,
                26.81699
              ],
              [
                63.19206,
                26.817877
              ],
              [
                63.192219,
                26.818267
              ],
              [
                63.192158,
                26.818511
              ],
              [
                63.192241,
                26.818731
              ],
              [
                63.19219,
                26.818879
              ],
              [
                63.192192,
                26.819238
              ],
              [
                63.191891,
                26.819932
              ],
              [
                63.19194,
                26.820325
              ],
              [
                63.191808,
                26.820399
              ],
              [
                63.191807,
                26.820507
              ],
              [
                63.19163,
                26.820745
              ],
              [
                63.191574,
                26.821045
              ],
              [
                63.191292,
                26.821658
              ],
              [
                63.19112,
                26.821932
              ],
              [
                63.190796,
                26.822256
              ],
              [
                63.190925,
                26.822404
              ],
              [
                63.19167,
                26.822832
              ],
              [
                63.192003,
                26.822822
              ],
              [
                63.192269,
                26.822878
              ],
              [
                63.192499,
                26.822772
              ],
              [
                63.192792,
                26.82278
              ],
              [
                63.192973,
                26.822937
              ],
              [
                63.193601,
                26.823019
              ],
              [
                63.1935,
                26.823121
              ],
              [
                63.193506,
                26.82338
              ],
              [
                63.193692,
                26.823418
              ],
              [
                63.19369,
                26.823771
              ],
              [
                63.19385,
                26.823903
              ],
              [
                63.193746,
                26.82399
              ],
              [
                63.19351,
                26.823819
              ],
              [
                63.19272,
                26.823844
              ],
              [
                63.191231,
                26.823716
              ],
              [
                63.190251,
                26.823755
              ],
              [
                63.189974,
                26.82368
              ],
              [
                63.189574,
                26.823706
              ],
              [
                63.1890443,
                26.8258333
              ],
              [
                63.188645,
                26.8261463
              ],
              [
                63.1885004,
                26.8264543
              ],
              [
                63.1883907,
                26.8269577
              ],
              [
                63.1880698,
                26.8274663
              ],
              [
                63.1878771,
                26.8275049
              ],
              [
                63.1878803,
                26.8276143
              ],
              [
                63.1876748,
                26.8276965
              ],
              [
                63.186722,
                26.830243
              ],
              [
                63.187209,
                26.831196
              ],
              [
                63.187089,
                26.832018
              ],
              [
                63.186987,
                26.832161
              ],
              [
                63.186741,
                26.832825
              ],
              [
                63.186684,
                26.833241
              ],
              [
                63.186473,
                26.833663
              ],
              [
                63.186525,
                26.834024
              ],
              [
                63.186658,
                26.834159
              ],
              [
                63.186749,
                26.834516
              ],
              [
                63.186704,
                26.834678
              ],
              [
                63.186731,
                26.834823
              ],
              [
                63.186569,
                26.834969
              ],
              [
                63.186553,
                26.835329
              ],
              [
                63.186455,
                26.83552
              ],
              [
                63.186365,
                26.835589
              ],
              [
                63.186288,
                26.835965
              ],
              [
                63.186102,
                26.836259
              ],
              [
                63.186119,
                26.836328
              ],
              [
                63.186066,
                26.836396
              ],
              [
                63.186117,
                26.836503
              ],
              [
                63.185979,
                26.836726
              ],
              [
                63.186327,
                26.836781
              ],
              [
                63.186683,
                26.836666
              ],
              [
                63.186862,
                26.836556
              ],
              [
                63.18726,
                26.836601
              ],
              [
                63.187582,
                26.836777
              ],
              [
                63.187779,
                26.836795
              ],
              [
                63.187864,
                26.836873
              ],
              [
                63.188039,
                26.836934
              ],
              [
                63.188411,
                26.836937
              ],
              [
                63.188623,
                26.837041
              ],
              [
                63.188677,
                26.837003
              ],
              [
                63.188747,
                26.837022
              ],
              [
                63.188814,
                26.837132
              ],
              [
                63.188908,
                26.83715
              ],
              [
                63.188957,
                26.837307
              ],
              [
                63.189169,
                26.837394
              ],
              [
                63.189537,
                26.837453
              ],
              [
                63.189704,
                26.837432
              ],
              [
                63.18999,
                26.837562
              ],
              [
                63.190192,
                26.837499
              ],
              [
                63.190397,
                26.83757
              ],
              [
                63.190802,
                26.837496
              ],
              [
                63.19097,
                26.837581
              ],
              [
                63.191209,
                26.837507
              ],
              [
                63.191426,
                26.837648
              ],
              [
                63.191637,
                26.837687
              ],
              [
                63.191688,
                26.837748
              ],
              [
                63.191761,
                26.837741
              ],
              [
                63.191947,
                26.837825
              ],
              [
                63.192074,
                26.837734
              ],
              [
                63.192151,
                26.837731
              ],
              [
                63.192375,
                26.837483
              ],
              [
                63.19258,
                26.837405
              ],
              [
                63.192748,
                26.837508
              ],
              [
                63.193017,
                26.837539
              ],
              [
                63.193059,
                26.837607
              ],
              [
                63.193153,
                26.837607
              ],
              [
                63.193162,
                26.837706
              ],
              [
                63.193708,
                26.837783
              ],
              [
                63.193761,
                26.837844
              ],
              [
                63.194011,
                26.837773
              ],
              [
                63.194356,
                26.8379
              ],
              [
                63.194598,
                26.837926
              ],
              [
                63.194861,
                26.838134
              ],
              [
                63.195034,
                26.838187
              ],
              [
                63.195071,
                26.838083
              ],
              [
                63.195256,
                26.838162
              ],
              [
                63.195366,
                26.838162
              ],
              [
                63.19576,
                26.837997
              ],
              [
                63.195881,
                26.838038
              ],
              [
                63.195957,
                26.838131
              ],
              [
                63.19629,
                26.838201
              ],
              [
                63.196307,
                26.838293
              ],
              [
                63.197193,
                26.838633
              ],
              [
                63.197429,
                26.838456
              ],
              [
                63.197676,
                26.838419
              ],
              [
                63.198003,
                26.838288
              ],
              [
                63.198057,
                26.83838
              ],
              [
                63.198369,
                26.838557
              ],
              [
                63.198418,
                26.83868
              ],
              [
                63.19852,
                26.838678
              ],
              [
                63.19888,
                26.838803
              ],
              [
                63.199126,
                26.838758
              ],
              [
                63.19937,
                26.838487
              ],
              [
                63.199614,
                26.838577
              ],
              [
                63.199627,
                26.838743
              ],
              [
                63.199976,
                26.838743
              ],
              [
                63.200033,
                26.838601
              ],
              [
                63.200201,
                26.838482
              ],
              [
                63.200471,
                26.838462
              ],
              [
                63.200697,
                26.838359
              ],
              [
                63.200759,
                26.838441
              ],
              [
                63.200985,
                26.838522
              ],
              [
                63.20106,
                26.838653
              ],
              [
                63.201165,
                26.838635
              ],
              [
                63.201399,
                26.838694
              ],
              [
                63.201495,
                26.838822
              ],
              [
                63.201785,
                26.838953
              ],
              [
                63.202161,
                26.838892
              ],
              [
                63.20243,
                26.838534
              ],
              [
                63.202537,
                26.838469
              ],
              [
                63.202863,
                26.838478
              ],
              [
                63.202954,
                26.838522
              ],
              [
                63.203708,
                26.838365
              ],
              [
                63.204266,
                26.838306
              ],
              [
                63.204341,
                26.838484
              ],
              [
                63.204561,
                26.838736
              ],
              [
                63.204647,
                26.838907
              ],
              [
                63.204867,
                26.838989
              ],
              [
                63.204936,
                26.838917
              ],
              [
                63.205011,
                26.838962
              ],
              [
                63.205214,
                26.838849
              ],
              [
                63.205228,
                26.838769
              ],
              [
                63.20565,
                26.838543
              ],
              [
                63.206029,
                26.838481
              ],
              [
                63.206427,
                26.838475
              ],
              [
                63.206616,
                26.838414
              ],
              [
                63.207152,
                26.838573
              ],
              [
                63.207144,
                26.838536
              ],
              [
                63.207336,
                26.838485
              ],
              [
                63.20762,
                26.838463
              ],
              [
                63.208169,
                26.838578
              ],
              [
                63.208456,
                26.838537
              ],
              [
                63.208574,
                26.838608
              ],
              [
                63.208609,
                26.838571
              ],
              [
                63.208796,
                26.838567
              ],
              [
                63.208935,
                26.838634
              ],
              [
                63.209143,
                26.838634
              ],
              [
                63.209353,
                26.838756
              ],
              [
                63.209505,
                26.838927
              ],
              [
                63.209699,
                26.838899
              ],
              [
                63.209836,
                26.838943
              ],
              [
                63.209958,
                26.838904
              ],
              [
                63.210734,
                26.838919
              ],
              [
                63.210772,
                26.838848
              ],
              [
                63.210867,
                26.838886
              ],
              [
                63.211243,
                26.838837
              ],
              [
                63.211461,
                26.838891
              ],
              [
                63.211782,
                26.838823
              ],
              [
                63.211932,
                26.838857
              ],
              [
                63.212474,
                26.838811
              ],
              [
                63.213071,
                26.838924
              ],
              [
                63.213659,
                26.838849
              ],
              [
                63.213828,
                26.838896
              ],
              [
                63.214402,
                26.838581
              ],
              [
                63.21457,
                26.838565
              ],
              [
                63.214651,
                26.838665
              ],
              [
                63.214969,
                26.83874
              ],
              [
                63.215483,
                26.838784
              ],
              [
                63.216165,
                26.838911
              ],
              [
                63.216586,
                26.838901
              ],
              [
                63.21688,
                26.838949
              ],
              [
                63.217449,
                26.839159
              ],
              [
                63.218014,
                26.839179
              ],
              [
                63.218091,
                26.839246
              ],
              [
                63.21849,
                26.839323
              ],
              [
                63.218507,
                26.839372
              ],
              [
                63.218621,
                26.839396
              ],
              [
                63.218958,
                26.839357
              ],
              [
                63.219612,
                26.839496
              ],
              [
                63.219926,
                26.83945
              ],
              [
                63.22041,
                26.839502
              ],
              [
                63.220614,
                26.839612
              ],
              [
                63.221402,
                26.83971
              ],
              [
                63.221575,
                26.839716
              ],
              [
                63.221873,
                26.83964
              ],
              [
                63.22204,
                26.839694
              ],
              [
                63.222384,
                26.83971
              ],
              [
                63.222793,
                26.839832
              ],
              [
                63.223128,
                26.839811
              ],
              [
                63.223465,
                26.839901
              ],
              [
                63.223814,
                26.840148
              ],
              [
                63.224324,
                26.840085
              ],
              [
                63.224896,
                26.84024
              ],
              [
                63.225141,
                26.840219
              ],
              [
                63.225806,
                26.840357
              ],
              [
                63.226098,
                26.840265
              ],
              [
                63.226598,
                26.840258
              ],
              [
                63.226968,
                26.840112
              ],
              [
                63.227546,
                26.840192
              ],
              [
                63.227832,
                26.84013
              ],
              [
                63.228287,
                26.840233
              ],
              [
                63.228381,
                26.84015
              ],
              [
                63.228612,
                26.840209
              ],
              [
                63.228858,
                26.840164
              ],
              [
                63.229258,
                26.840169
              ],
              [
                63.229569,
                26.840067
              ],
              [
                63.22968,
                26.840104
              ],
              [
                63.229708,
                26.840162
              ],
              [
                63.229827,
                26.84018
              ],
              [
                63.22995,
                26.840188
              ],
              [
                63.23017,
                26.840091
              ],
              [
                63.230316,
                26.840092
              ],
              [
                63.230475,
                26.840191
              ],
              [
                63.230592,
                26.840114
              ],
              [
                63.230971,
                26.840078
              ],
              [
                63.231025,
                26.839984
              ],
              [
                63.231466,
                26.840123
              ],
              [
                63.231931,
                26.840155
              ],
              [
                63.232182,
                26.84035
              ],
              [
                63.232339,
                26.840403
              ],
              [
                63.232566,
                26.840398
              ],
              [
                63.232834,
                26.840226
              ],
              [
                63.23295,
                26.840214
              ],
              [
                63.233253,
                26.84035
              ],
              [
                63.233405,
                26.840358
              ],
              [
                63.233502,
                26.840463
              ],
              [
                63.233705,
                26.840496
              ],
              [
                63.233783,
                26.840552
              ],
              [
                63.234122,
                26.840592
              ],
              [
                63.234111,
                26.840499
              ],
              [
                63.234694,
                26.840417
              ],
              [
                63.234766,
                26.840374
              ],
              [
                63.234969,
                26.840407
              ],
              [
                63.235057,
                26.840348
              ],
              [
                63.235796,
                26.840237
              ],
              [
                63.236144,
                26.840377
              ],
              [
                63.236181,
                26.840477
              ],
              [
                63.236406,
                26.840511
              ],
              [
                63.236688,
                26.840491
              ],
              [
                63.236851,
                26.840652
              ],
              [
                63.237118,
                26.840704
              ],
              [
                63.237133,
                26.840758
              ],
              [
                63.237293,
                26.840821
              ],
              [
                63.23788,
                26.840843
              ],
              [
                63.238058,
                26.841093
              ],
              [
                63.238554,
                26.84124
              ],
              [
                63.238585,
                26.841341
              ],
              [
                63.238763,
                26.841407
              ],
              [
                63.238809,
                26.84149
              ],
              [
                63.238877,
                26.841491
              ],
              [
                63.238948,
                26.841575
              ],
              [
                63.239113,
                26.841638
              ],
              [
                63.239453,
                26.841603
              ],
              [
                63.239773,
                26.841795
              ],
              [
                63.240239,
                26.8417663
              ],
              [
                63.24091,
                26.841725
              ],
              [
                63.240977,
                26.841621
              ],
              [
                63.241281,
                26.84161
              ],
              [
                63.241304,
                26.841515
              ],
              [
                63.241612,
                26.841333
              ],
              [
                63.241712,
                26.841409
              ],
              [
                63.241733,
                26.841504
              ],
              [
                63.241818,
                26.841513
              ],
              [
                63.242141,
                26.841359
              ],
              [
                63.24265,
                26.84135
              ],
              [
                63.243184,
                26.841412
              ],
              [
                63.243255,
                26.841598
              ],
              [
                63.243228,
                26.841646
              ],
              [
                63.243329,
                26.84164
              ],
              [
                63.243373,
                26.8417
              ],
              [
                63.243878,
                26.841713
              ],
              [
                63.243791,
                26.841831
              ],
              [
                63.243625,
                26.842947
              ],
              [
                63.243311,
                26.843128
              ],
              [
                63.243293,
                26.843217
              ],
              [
                63.243318,
                26.843405
              ],
              [
                63.243281,
                26.843447
              ],
              [
                63.243388,
                26.843515
              ],
              [
                63.243376,
                26.843615
              ],
              [
                63.243463,
                26.843691
              ],
              [
                63.243481,
                26.84386
              ],
              [
                63.243524,
                26.843873
              ],
              [
                63.243483,
                26.844041
              ],
              [
                63.243414,
                26.844068
              ],
              [
                63.24341,
                26.844425
              ],
              [
                63.243318,
                26.844615
              ],
              [
                63.2435,
                26.844654
              ],
              [
                63.243531,
                26.844698
              ],
              [
                63.243522,
                26.844845
              ],
              [
                63.243595,
                26.844998
              ],
              [
                63.243624,
                26.845331
              ],
              [
                63.243718,
                26.845453
              ],
              [
                63.243858,
                26.845886
              ],
              [
                63.243822,
                26.846123
              ],
              [
                63.244047,
                26.846134
              ],
              [
                63.244107,
                26.84624
              ],
              [
                63.244074,
                26.84642
              ],
              [
                63.24417,
                26.846907
              ],
              [
                63.244112,
                26.846972
              ],
              [
                63.244116,
                26.847073
              ],
              [
                63.24488,
                26.847243
              ],
              [
                63.244933,
                26.847289
              ],
              [
                63.244887,
                26.847421
              ],
              [
                63.244993,
                26.847567
              ],
              [
                63.244994,
                26.847977
              ],
              [
                63.245136,
                26.848202
              ],
              [
                63.245136,
                26.848506
              ],
              [
                63.245245,
                26.848713
              ],
              [
                63.245218,
                26.848816
              ],
              [
                63.24528,
                26.848829
              ],
              [
                63.245454,
                26.849238
              ],
              [
                63.24537,
                26.849611
              ],
              [
                63.24597,
                26.849677
              ],
              [
                63.246019,
                26.84976
              ],
              [
                63.246266,
                26.849798
              ],
              [
                63.246334,
                26.849903
              ],
              [
                63.246437,
                26.850382
              ],
              [
                63.246396,
                26.850638
              ],
              [
                63.24642,
                26.850865
              ],
              [
                63.246323,
                26.850858
              ],
              [
                63.246196,
                26.850947
              ],
              [
                63.246039,
                26.850979
              ],
              [
                63.245622,
                26.851012
              ],
              [
                63.245485,
                26.85124
              ],
              [
                63.24514,
                26.851465
              ],
              [
                63.245709,
                26.851693
              ],
              [
                63.245841,
                26.8518
              ],
              [
                63.245985,
                26.851807
              ],
              [
                63.246081,
                26.851897
              ],
              [
                63.246142,
                26.852177
              ],
              [
                63.246083,
                26.852712
              ],
              [
                63.246176,
                26.852813
              ],
              [
                63.246129,
                26.852927
              ],
              [
                63.246198,
                26.853217
              ],
              [
                63.246142,
                26.853319
              ],
              [
                63.246208,
                26.853365
              ],
              [
                63.24625,
                26.853545
              ],
              [
                63.24589,
                26.853804
              ],
              [
                63.245831,
                26.853975
              ],
              [
                63.245713,
                26.854115
              ],
              [
                63.245235,
                26.854329
              ],
              [
                63.245077,
                26.854473
              ],
              [
                63.245146,
                26.854518
              ],
              [
                63.245253,
                26.854801
              ],
              [
                63.245107,
                26.855047
              ],
              [
                63.245,
                26.855397
              ],
              [
                63.245033,
                26.855607
              ],
              [
                63.244998,
                26.855675
              ],
              [
                63.245081,
                26.855775
              ],
              [
                63.245474,
                26.855888
              ],
              [
                63.24542,
                26.856255
              ],
              [
                63.245442,
                26.856745
              ],
              [
                63.245546,
                26.85693
              ],
              [
                63.245945,
                26.857386
              ],
              [
                63.245958,
                26.857506
              ],
              [
                63.245854,
                26.857843
              ],
              [
                63.245816,
                26.858634
              ],
              [
                63.245988,
                26.859287
              ],
              [
                63.246168,
                26.860573
              ],
              [
                63.245992,
                26.860894
              ],
              [
                63.24635,
                26.861752
              ],
              [
                63.246275,
                26.862193
              ],
              [
                63.246659,
                26.862193
              ],
              [
                63.2472781,
                26.8623434
              ],
              [
                63.247293,
                26.862347
              ],
              [
                63.247282,
                26.862556
              ],
              [
                63.247137,
                26.862822
              ],
              [
                63.24708,
                26.863144
              ],
              [
                63.246903,
                26.863418
              ],
              [
                63.246706,
                26.863927
              ],
              [
                63.247372,
                26.863941
              ],
              [
                63.247807,
                26.864011
              ],
              [
                63.247852,
                26.864061
              ],
              [
                63.247841,
                26.864325
              ],
              [
                63.248032,
                26.864453
              ],
              [
                63.248153,
                26.864638
              ],
              [
                63.248626,
                26.864809
              ],
              [
                63.248478,
                26.865071
              ],
              [
                63.248525,
                26.865405
              ],
              [
                63.248405,
                26.865683
              ],
              [
                63.248413,
                26.86578
              ],
              [
                63.248531,
                26.865893
              ],
              [
                63.24853,
                26.866334
              ],
              [
                63.248662,
                26.866709
              ],
              [
                63.248836,
                26.866939
              ],
              [
                63.249327,
                26.86706
              ],
              [
                63.24937,
                26.867131
              ],
              [
                63.249299,
                26.867234
              ],
              [
                63.249492,
                26.867712
              ],
              [
                63.248919,
                26.867961
              ],
              [
                63.248924,
                26.868054
              ],
              [
                63.248505,
                26.868107
              ],
              [
                63.247927,
                26.868271
              ],
              [
                63.247938,
                26.868526
              ],
              [
                63.247874,
                26.868936
              ],
              [
                63.24791,
                26.869003
              ],
              [
                63.247732,
                26.868994
              ],
              [
                63.247749,
                26.869088
              ],
              [
                63.247184,
                26.869384
              ],
              [
                63.247129,
                26.869534
              ],
              [
                63.246954,
                26.869668
              ],
              [
                63.246949,
                26.869803
              ],
              [
                63.247125,
                26.870262
              ],
              [
                63.246662,
                26.870398
              ],
              [
                63.246301,
                26.870594
              ],
              [
                63.245996,
                26.870571
              ],
              [
                63.245838,
                26.87125
              ],
              [
                63.245278,
                26.871296
              ],
              [
                63.244819,
                26.871279
              ],
              [
                63.244314,
                26.871393
              ],
              [
                63.244225,
                26.871502
              ],
              [
                63.244101,
                26.871528
              ],
              [
                63.243918,
                26.871671
              ],
              [
                63.243896,
                26.871828
              ],
              [
                63.243672,
                26.872012
              ],
              [
                63.243697,
                26.872213
              ],
              [
                63.243286,
                26.872421
              ],
              [
                63.243172,
                26.872523
              ],
              [
                63.24316,
                26.873045
              ],
              [
                63.243244,
                26.873105
              ],
              [
                63.243239,
                26.873179
              ],
              [
                63.243086,
                26.873294
              ],
              [
                63.243148,
                26.873408
              ],
              [
                63.24306,
                26.873719
              ],
              [
                63.243068,
                26.873998
              ],
              [
                63.243154,
                26.874357
              ],
              [
                63.243068,
                26.874387
              ],
              [
                63.242798,
                26.874343
              ],
              [
                63.242351,
                26.874354
              ],
              [
                63.24214,
                26.874494
              ],
              [
                63.24203,
                26.874518
              ],
              [
                63.242065,
                26.874566
              ],
              [
                63.242041,
                26.874685
              ],
              [
                63.242313,
                26.87468
              ],
              [
                63.242426,
                26.874803
              ],
              [
                63.242333,
                26.874978
              ],
              [
                63.2424,
                26.875462
              ],
              [
                63.242766,
                26.875522
              ],
              [
                63.242812,
                26.875968
              ],
              [
                63.242733,
                26.876244
              ],
              [
                63.242951,
                26.876874
              ],
              [
                63.2429,
                26.876982
              ],
              [
                63.242948,
                26.877464
              ],
              [
                63.24282,
                26.87747
              ],
              [
                63.242785,
                26.877513
              ],
              [
                63.242492,
                26.877589
              ],
              [
                63.241229,
                26.87742
              ],
              [
                63.241043,
                26.877449
              ],
              [
                63.24077,
                26.877389
              ],
              [
                63.240644,
                26.877408
              ],
              [
                63.240092,
                26.877344
              ],
              [
                63.239861,
                26.877384
              ],
              [
                63.239548,
                26.877539
              ],
              [
                63.239557,
                26.877625
              ],
              [
                63.239309,
                26.877709
              ],
              [
                63.239304,
                26.877816
              ],
              [
                63.239227,
                26.877905
              ],
              [
                63.239155,
                26.87819
              ],
              [
                63.239159,
                26.878483
              ],
              [
                63.238799,
                26.878466
              ],
              [
                63.238791,
                26.878512
              ],
              [
                63.238819,
                26.878803
              ],
              [
                63.238942,
                26.879073
              ],
              [
                63.239232,
                26.879111
              ],
              [
                63.239215,
                26.879709
              ],
              [
                63.239131,
                26.879765
              ],
              [
                63.238711,
                26.879741
              ],
              [
                63.238526,
                26.879645
              ],
              [
                63.238269,
                26.879704
              ],
              [
                63.238157,
                26.879659
              ],
              [
                63.237862,
                26.87967
              ],
              [
                63.2375,
                26.879745
              ],
              [
                63.237412,
                26.879812
              ],
              [
                63.237472,
                26.880087
              ],
              [
                63.237051,
                26.880393
              ],
              [
                63.237013,
                26.880547
              ],
              [
                63.237146,
                26.880777
              ],
              [
                63.237207,
                26.881028
              ],
              [
                63.237115,
                26.881049
              ],
              [
                63.23711,
                26.881185
              ],
              [
                63.236996,
                26.881215
              ],
              [
                63.237155,
                26.881567
              ],
              [
                63.237167,
                26.881697
              ],
              [
                63.237314,
                26.881934
              ],
              [
                63.23735,
                26.882201
              ],
              [
                63.237282,
                26.882433
              ],
              [
                63.237374,
                26.882444
              ],
              [
                63.237464,
                26.882384
              ],
              [
                63.237865,
                26.882448
              ],
              [
                63.238036,
                26.882409
              ],
              [
                63.238267,
                26.882535
              ],
              [
                63.238429,
                26.882523
              ],
              [
                63.238586,
                26.882634
              ],
              [
                63.238805,
                26.882589
              ],
              [
                63.239214,
                26.882701
              ],
              [
                63.239153,
                26.882911
              ],
              [
                63.239219,
                26.882941
              ],
              [
                63.239053,
                26.883004
              ],
              [
                63.239015,
                26.883205
              ],
              [
                63.239073,
                26.883418
              ],
              [
                63.239226,
                26.883436
              ],
              [
                63.23917,
                26.883638
              ],
              [
                63.239182,
                26.884023
              ],
              [
                63.238947,
                26.884055
              ],
              [
                63.238904,
                26.884229
              ],
              [
                63.238823,
                26.884242
              ],
              [
                63.238835,
                26.884513
              ],
              [
                63.238889,
                26.884504
              ],
              [
                63.238908,
                26.884563
              ],
              [
                63.238816,
                26.884872
              ],
              [
                63.238675,
                26.88508
              ],
              [
                63.238793,
                26.885097
              ],
              [
                63.238942,
                26.885274
              ],
              [
                63.238931,
                26.885639
              ],
              [
                63.23899,
                26.885697
              ],
              [
                63.239053,
                26.885932
              ],
              [
                63.238874,
                26.88602
              ],
              [
                63.238853,
                26.88611
              ],
              [
                63.238774,
                26.886118
              ],
              [
                63.238687,
                26.886289
              ],
              [
                63.23878,
                26.88635
              ],
              [
                63.23909,
                26.886394
              ],
              [
                63.239122,
                26.886456
              ],
              [
                63.239078,
                26.886681
              ],
              [
                63.239323,
                26.886699
              ],
              [
                63.239343,
                26.886792
              ],
              [
                63.239619,
                26.886618
              ],
              [
                63.239766,
                26.886642
              ],
              [
                63.239915,
                26.886785
              ],
              [
                63.240177,
                26.886852
              ],
              [
                63.2405,
                26.887044
              ],
              [
                63.240774,
                26.886981
              ],
              [
                63.240949,
                26.88706
              ],
              [
                63.241186,
                26.886981
              ],
              [
                63.241467,
                26.88706
              ],
              [
                63.241298,
                26.887268
              ],
              [
                63.24108,
                26.887378
              ],
              [
                63.241069,
                26.887471
              ],
              [
                63.24085,
                26.887604
              ],
              [
                63.240879,
                26.887654
              ],
              [
                63.240841,
                26.887723
              ],
              [
                63.241004,
                26.887848
              ],
              [
                63.241001,
                26.887947
              ],
              [
                63.241083,
                26.88797
              ],
              [
                63.241078,
                26.888163
              ],
              [
                63.241308,
                26.88838
              ],
              [
                63.240909,
                26.888487
              ],
              [
                63.240943,
                26.888687
              ],
              [
                63.240868,
                26.888801
              ],
              [
                63.240916,
                26.888891
              ],
              [
                63.240866,
                26.888934
              ],
              [
                63.240874,
                26.889028
              ],
              [
                63.240629,
                26.88907
              ],
              [
                63.240408,
                26.889009
              ],
              [
                63.240303,
                26.889227
              ],
              [
                63.240685,
                26.88959
              ],
              [
                63.240826,
                26.889611
              ],
              [
                63.240812,
                26.889763
              ],
              [
                63.240871,
                26.88985
              ],
              [
                63.240545,
                26.88989
              ],
              [
                63.240493,
                26.889924
              ],
              [
                63.240507,
                26.890016
              ],
              [
                63.240659,
                26.890119
              ],
              [
                63.24067,
                26.890216
              ],
              [
                63.240956,
                26.890463
              ],
              [
                63.241195,
                26.890799
              ],
              [
                63.241271,
                26.890991
              ],
              [
                63.241553,
                26.891224
              ],
              [
                63.241605,
                26.891248
              ],
              [
                63.241659,
                26.891213
              ],
              [
                63.241858,
                26.891301
              ],
              [
                63.241843,
                26.891364
              ],
              [
                63.242029,
                26.891433
              ],
              [
                63.242064,
                26.891539
              ],
              [
                63.242073,
                26.891654
              ],
              [
                63.242007,
                26.89172
              ],
              [
                63.241582,
                26.891717
              ],
              [
                63.241374,
                26.891771
              ],
              [
                63.241411,
                26.891861
              ],
              [
                63.241381,
                26.892107
              ],
              [
                63.241233,
                26.892514
              ],
              [
                63.241115,
                26.892628
              ],
              [
                63.240941,
                26.892642
              ],
              [
                63.240713,
                26.89298
              ],
              [
                63.240537,
                26.893025
              ],
              [
                63.240525,
                26.893082
              ],
              [
                63.240939,
                26.893136
              ],
              [
                63.241364,
                26.893284
              ],
              [
                63.241258,
                26.893398
              ],
              [
                63.240976,
                26.893384
              ],
              [
                63.240927,
                26.893442
              ],
              [
                63.240684,
                26.893423
              ],
              [
                63.240713,
                26.893629
              ],
              [
                63.240843,
                26.893827
              ],
              [
                63.241015,
                26.893863
              ],
              [
                63.241034,
                26.893938
              ],
              [
                63.240559,
                26.894281
              ],
              [
                63.240467,
                26.894302
              ],
              [
                63.24024,
                26.894642
              ],
              [
                63.240043,
                26.894673
              ],
              [
                63.23997,
                26.894766
              ],
              [
                63.240377,
                26.895047
              ],
              [
                63.240285,
                26.895094
              ],
              [
                63.240327,
                26.895219
              ],
              [
                63.240523,
                26.895294
              ],
              [
                63.240633,
                26.895388
              ],
              [
                63.240611,
                26.89576
              ],
              [
                63.240511,
                26.895889
              ],
              [
                63.240401,
                26.895923
              ],
              [
                63.240465,
                26.896063
              ],
              [
                63.240119,
                26.896483
              ],
              [
                63.240007,
                26.896512
              ],
              [
                63.239835,
                26.896721
              ],
              [
                63.23984,
                26.896829
              ],
              [
                63.239668,
                26.896879
              ],
              [
                63.2396,
                26.897184
              ],
              [
                63.239332,
                26.897264
              ],
              [
                63.239261,
                26.897338
              ],
              [
                63.239168,
                26.897983
              ],
              [
                63.23979,
                26.898326
              ],
              [
                63.239999,
                26.898336
              ],
              [
                63.240198,
                26.898469
              ],
              [
                63.240575,
                26.898578
              ],
              [
                63.240717,
                26.898736
              ],
              [
                63.240932,
                26.898813
              ],
              [
                63.240927,
                26.899019
              ],
              [
                63.241099,
                26.899229
              ],
              [
                63.241319,
                26.899272
              ],
              [
                63.241457,
                26.899409
              ],
              [
                63.241561,
                26.899407
              ],
              [
                63.242184,
                26.899649
              ],
              [
                63.242385,
                26.899996
              ],
              [
                63.242469,
                26.900717
              ],
              [
                63.242374,
                26.900883
              ],
              [
                63.242875,
                26.900909
              ],
              [
                63.243221,
                26.901061
              ],
              [
                63.243288,
                26.901013
              ],
              [
                63.244052,
                26.901077
              ],
              [
                63.24423,
                26.901013
              ],
              [
                63.244383,
                26.901047
              ],
              [
                63.244692,
                26.90103
              ],
              [
                63.244864,
                26.901152
              ],
              [
                63.244907,
                26.901238
              ],
              [
                63.245557,
                26.901352
              ],
              [
                63.245803,
                26.901485
              ],
              [
                63.246462,
                26.901499
              ],
              [
                63.24678,
                26.901577
              ],
              [
                63.247105,
                26.901706
              ],
              [
                63.247251,
                26.901884
              ],
              [
                63.247382,
                26.901903
              ],
              [
                63.247536,
                26.902069
              ],
              [
                63.247672,
                26.902098
              ],
              [
                63.247833,
                26.902241
              ],
              [
                63.248095,
                26.902337
              ],
              [
                63.248222,
                26.90251
              ],
              [
                63.248355,
                26.902524
              ],
              [
                63.248363,
                26.90259
              ],
              [
                63.248499,
                26.90253
              ],
              [
                63.248707,
                26.902534
              ],
              [
                63.249191,
                26.902695
              ],
              [
                63.249385,
                26.902688
              ],
              [
                63.24967,
                26.902894
              ],
              [
                63.250452,
                26.902942
              ],
              [
                63.250551,
                26.902914
              ],
              [
                63.250747,
                26.902759
              ],
              [
                63.250904,
                26.902797
              ],
              [
                63.251095,
                26.902746
              ],
              [
                63.251281,
                26.902473
              ],
              [
                63.251566,
                26.902505
              ],
              [
                63.251641,
                26.902552
              ],
              [
                63.251639,
                26.902773
              ],
              [
                63.251914,
                26.903087
              ],
              [
                63.252271,
                26.903234
              ],
              [
                63.252366,
                26.903376
              ],
              [
                63.252657,
                26.903604
              ],
              [
                63.252856,
                26.903562
              ],
              [
                63.252985,
                26.903483
              ],
              [
                63.253311,
                26.903519
              ],
              [
                63.2527998,
                26.9470489
              ],
              [
                63.2510944,
                27.0921506
              ],
              [
                63.2556733,
                27.0915404
              ],
              [
                63.2588761,
                27.0922359
              ],
              [
                63.2629076,
                27.0941578
              ],
              [
                63.2633756,
                27.0951994
              ],
              [
                63.2635762,
                27.1006249
              ],
              [
                63.2657881,
                27.1055586
              ],
              [
                63.2648366,
                27.1074977
              ],
              [
                63.2654181,
                27.1087246
              ],
              [
                63.2669575,
                27.1096041
              ],
              [
                63.2700298,
                27.1101291
              ],
              [
                63.2728256,
                27.110613
              ],
              [
                63.2758855,
                27.112961
              ],
              [
                63.2763325,
                27.1147515
              ],
              [
                63.2758056,
                27.1159709
              ],
              [
                63.2756313,
                27.1167852
              ],
              [
                63.2761988,
                27.1178147
              ],
              [
                63.2794691,
                27.1199709
              ],
              [
                63.2841524,
                27.1211058
              ],
              [
                63.2847116,
                27.1192542
              ],
              [
                63.2855679,
                27.1183396
              ],
              [
                63.2952262,
                27.1151784
              ],
              [
                63.2972273,
                27.1156049
              ],
              [
                63.2988389,
                27.1176472
              ],
              [
                63.2988644,
                27.1200922
              ],
              [
                63.2996675,
                27.1218036
              ],
              [
                63.3015727,
                27.1259876
              ],
              [
                63.3048623,
                27.1288069
              ],
              [
                63.3071253,
                27.1296461
              ],
              [
                63.3092171,
                27.1293532
              ],
              [
                63.3138294,
                27.1274123
              ],
              [
                63.3200179,
                27.1264612
              ],
              [
                63.3228578,
                27.1240207
              ],
              [
                63.3272365,
                27.120529
              ],
              [
                63.3304752,
                27.1191454
              ],
              [
                63.3332704,
                27.1184003
              ],
              [
                63.332056,
                27.120917
              ],
              [
                63.283296,
                27.208663
              ],
              [
                63.283116,
                27.208824
              ],
              [
                63.282898,
                27.208921
              ],
              [
                63.28278,
                27.209079
              ],
              [
                63.282772,
                27.209182
              ],
              [
                63.282886,
                27.209324
              ],
              [
                63.28281,
                27.209499
              ],
              [
                63.282847,
                27.209678
              ],
              [
                63.282701,
                27.209795
              ],
              [
                63.28233,
                27.209881
              ],
              [
                63.282265,
                27.21019
              ],
              [
                63.282451,
                27.210743
              ],
              [
                63.28241,
                27.210833
              ],
              [
                63.282254,
                27.210851
              ],
              [
                63.282104,
                27.211013
              ],
              [
                63.282271,
                27.211719
              ],
              [
                63.282352,
                27.211772
              ],
              [
                63.282495,
                27.212091
              ],
              [
                63.282588,
                27.212183
              ],
              [
                63.282539,
                27.212436
              ],
              [
                63.282489,
                27.212477
              ],
              [
                63.282475,
                27.212631
              ],
              [
                63.282525,
                27.21277
              ],
              [
                63.282279,
                27.213058
              ],
              [
                63.281982,
                27.213289
              ],
              [
                63.281796,
                27.213607
              ],
              [
                63.281777,
                27.213732
              ],
              [
                63.281458,
                27.213738
              ],
              [
                63.281338,
                27.213648
              ],
              [
                63.28014,
                27.213823
              ],
              [
                63.280119,
                27.214266
              ],
              [
                63.279993,
                27.214433
              ],
              [
                63.279522,
                27.214714
              ],
              [
                63.27959,
                27.215139
              ],
              [
                63.279488,
                27.215207
              ],
              [
                63.279388,
                27.215362
              ],
              [
                63.279323,
                27.215548
              ],
              [
                63.279258,
                27.215605
              ],
              [
                63.279221,
                27.215817
              ],
              [
                63.278885,
                27.215934
              ],
              [
                63.278787,
                27.215811
              ],
              [
                63.278511,
                27.215809
              ],
              [
                63.278275,
                27.21588
              ],
              [
                63.278082,
                27.216202
              ],
              [
                63.277932,
                27.216272
              ],
              [
                63.277881,
                27.216352
              ],
              [
                63.277681,
                27.216404
              ],
              [
                63.277552,
                27.21653
              ],
              [
                63.277392,
                27.216514
              ],
              [
                63.277301,
                27.216554
              ],
              [
                63.277369,
                27.216768
              ],
              [
                63.277354,
                27.216947
              ],
              [
                63.277206,
                27.217106
              ],
              [
                63.276967,
                27.21725
              ],
              [
                63.276908,
                27.217344
              ],
              [
                63.27691,
                27.217489
              ],
              [
                63.276822,
                27.217752
              ],
              [
                63.277034,
                27.217915
              ],
              [
                63.276901,
                27.218159
              ],
              [
                63.276624,
                27.218201
              ],
              [
                63.276459,
                27.218331
              ],
              [
                63.276346,
                27.218312
              ],
              [
                63.276224,
                27.218393
              ],
              [
                63.276062,
                27.218431
              ],
              [
                63.276037,
                27.21848
              ],
              [
                63.275781,
                27.218455
              ],
              [
                63.2756,
                27.21849
              ],
              [
                63.275131,
                27.218705
              ],
              [
                63.274923,
                27.218888
              ],
              [
                63.274775,
                27.218892
              ],
              [
                63.274131,
                27.219242
              ],
              [
                63.273906,
                27.219252
              ],
              [
                63.273857,
                27.219296
              ],
              [
                63.273639,
                27.219335
              ],
              [
                63.273552,
                27.219406
              ],
              [
                63.273217,
                27.219393
              ],
              [
                63.272885,
                27.219452
              ],
              [
                63.272631,
                27.219628
              ],
              [
                63.272485,
                27.219795
              ],
              [
                63.271957,
                27.219647
              ],
              [
                63.271835,
                27.219655
              ],
              [
                63.271641,
                27.219743
              ],
              [
                63.271477,
                27.22
              ],
              [
                63.271142,
                27.220059
              ],
              [
                63.270919,
                27.220156
              ],
              [
                63.270836,
                27.220135
              ],
              [
                63.270486,
                27.219566
              ],
              [
                63.270292,
                27.219582
              ],
              [
                63.269853,
                27.219719
              ],
              [
                63.269604,
                27.219752
              ],
              [
                63.269194,
                27.219918
              ],
              [
                63.269022,
                27.219885
              ],
              [
                63.268671,
                27.220008
              ],
              [
                63.268229,
                27.220057
              ],
              [
                63.268138,
                27.220112
              ],
              [
                63.268074,
                27.220273
              ],
              [
                63.267754,
                27.220399
              ],
              [
                63.267672,
                27.220459
              ],
              [
                63.267649,
                27.220561
              ],
              [
                63.267525,
                27.220617
              ],
              [
                63.267418,
                27.220651
              ],
              [
                63.267161,
                27.220578
              ],
              [
                63.266822,
                27.22067
              ],
              [
                63.26663,
                27.220859
              ],
              [
                63.266138,
                27.221142
              ],
              [
                63.266125,
                27.221198
              ],
              [
                63.266004,
                27.221282
              ],
              [
                63.265974,
                27.221414
              ],
              [
                63.26585,
                27.221533
              ],
              [
                63.265865,
                27.221593
              ],
              [
                63.265984,
                27.22162
              ],
              [
                63.266225,
                27.222084
              ],
              [
                63.266439,
                27.222357
              ],
              [
                63.266849,
                27.22275
              ],
              [
                63.267168,
                27.222889
              ],
              [
                63.267162,
                27.223048
              ],
              [
                63.266917,
                27.223188
              ],
              [
                63.266751,
                27.223406
              ],
              [
                63.266775,
                27.223471
              ],
              [
                63.266599,
                27.223607
              ],
              [
                63.266005,
                27.223811
              ],
              [
                63.265763,
                27.223827
              ],
              [
                63.265507,
                27.223969
              ],
              [
                63.265214,
                27.22402
              ],
              [
                63.264994,
                27.223824
              ],
              [
                63.264587,
                27.223733
              ],
              [
                63.263876,
                27.223945
              ],
              [
                63.263835,
                27.2239
              ],
              [
                63.26367,
                27.223869
              ],
              [
                63.263505,
                27.223955
              ],
              [
                63.263037,
                27.224022
              ],
              [
                63.262781,
                27.223921
              ],
              [
                63.26264,
                27.22391
              ],
              [
                63.26252,
                27.224013
              ],
              [
                63.262154,
                27.223845
              ],
              [
                63.261901,
                27.223876
              ],
              [
                63.261837,
                27.223951
              ],
              [
                63.261649,
                27.223928
              ],
              [
                63.261503,
                27.22385
              ],
              [
                63.261306,
                27.223869
              ],
              [
                63.260892,
                27.223988
              ],
              [
                63.260621,
                27.224294
              ],
              [
                63.260437,
                27.224229
              ],
              [
                63.260378,
                27.224307
              ],
              [
                63.260159,
                27.224369
              ],
              [
                63.260046,
                27.224259
              ],
              [
                63.259799,
                27.224345
              ],
              [
                63.259383,
                27.224414
              ],
              [
                63.25926,
                27.224533
              ],
              [
                63.25911,
                27.224499
              ],
              [
                63.258976,
                27.22438
              ],
              [
                63.258215,
                27.224772
              ],
              [
                63.258353,
                27.225118
              ],
              [
                63.258177,
                27.225127
              ],
              [
                63.25802,
                27.225189
              ],
              [
                63.257903,
                27.225304
              ],
              [
                63.257479,
                27.225308
              ],
              [
                63.257026,
                27.225435
              ],
              [
                63.256975,
                27.225426
              ],
              [
                63.256954,
                27.225342
              ],
              [
                63.256687,
                27.225331
              ],
              [
                63.256062,
                27.225561
              ],
              [
                63.255783,
                27.225534
              ],
              [
                63.255425,
                27.225626
              ],
              [
                63.254866,
                27.225912
              ],
              [
                63.254535,
                27.226021
              ],
              [
                63.254301,
                27.226055
              ],
              [
                63.25391,
                27.226027
              ],
              [
                63.253745,
                27.226066
              ],
              [
                63.253546,
                27.226032
              ],
              [
                63.253393,
                27.226062
              ],
              [
                63.253312,
                27.226157
              ],
              [
                63.25307,
                27.226129
              ],
              [
                63.25282,
                27.226219
              ],
              [
                63.252847,
                27.226249
              ],
              [
                63.252592,
                27.226425
              ],
              [
                63.2525,
                27.226402
              ],
              [
                63.252133,
                27.226575
              ],
              [
                63.25194,
                27.226562
              ],
              [
                63.251883,
                27.226618
              ],
              [
                63.251861,
                27.226874
              ],
              [
                63.251754,
                27.226939
              ],
              [
                63.251767,
                27.226994
              ],
              [
                63.250908,
                27.2272
              ],
              [
                63.25075,
                27.227281
              ],
              [
                63.250368,
                27.227334
              ],
              [
                63.250017,
                27.227302
              ],
              [
                63.249938,
                27.227378
              ],
              [
                63.249258,
                27.227354
              ],
              [
                63.249366,
                27.22719
              ],
              [
                63.249276,
                27.227189
              ],
              [
                63.249401,
                27.227
              ],
              [
                63.24948,
                27.226717
              ],
              [
                63.248977,
                27.226853
              ],
              [
                63.248908,
                27.226816
              ],
              [
                63.248757,
                27.226855
              ],
              [
                63.248575,
                27.226961
              ],
              [
                63.248186,
                27.226971
              ],
              [
                63.247951,
                27.227093
              ],
              [
                63.24733,
                27.227205
              ],
              [
                63.247048,
                27.227194
              ],
              [
                63.247003,
                27.227105
              ],
              [
                63.246405,
                27.227024
              ],
              [
                63.246333,
                27.227076
              ],
              [
                63.246152,
                27.227039
              ],
              [
                63.245749,
                27.22713
              ],
              [
                63.24542,
                27.22711
              ],
              [
                63.245079,
                27.227
              ],
              [
                63.244999,
                27.226858
              ],
              [
                63.244886,
                27.226823
              ],
              [
                63.244462,
                27.226825
              ],
              [
                63.243679,
                27.226947
              ],
              [
                63.243674,
                27.227046
              ],
              [
                63.243429,
                27.227245
              ],
              [
                63.242805,
                27.227273
              ],
              [
                63.242611,
                27.227453
              ],
              [
                63.242281,
                27.227401
              ],
              [
                63.241953,
                27.227566
              ],
              [
                63.241329,
                27.227424
              ],
              [
                63.24061,
                27.227577
              ],
              [
                63.239841,
                27.227485
              ],
              [
                63.239423,
                27.227574
              ],
              [
                63.239246,
                27.227549
              ],
              [
                63.239034,
                27.227612
              ],
              [
                63.238945,
                27.227585
              ],
              [
                63.238638,
                27.227652
              ],
              [
                63.238541,
                27.227715
              ],
              [
                63.238468,
                27.227704
              ],
              [
                63.238345,
                27.227587
              ],
              [
                63.238422,
                27.22719
              ],
              [
                63.238331,
                27.227063
              ],
              [
                63.238391,
                27.226915
              ],
              [
                63.238357,
                27.226837
              ],
              [
                63.237955,
                27.226584
              ],
              [
                63.237968,
                27.226471
              ],
              [
                63.238171,
                27.226192
              ],
              [
                63.238137,
                27.226012
              ],
              [
                63.238186,
                27.225848
              ],
              [
                63.238121,
                27.225643
              ],
              [
                63.237746,
                27.225531
              ],
              [
                63.237176,
                27.225595
              ],
              [
                63.236863,
                27.225578
              ],
              [
                63.236832,
                27.22553
              ],
              [
                63.236357,
                27.22551
              ],
              [
                63.23596,
                27.225547
              ],
              [
                63.235506,
                27.225715
              ],
              [
                63.23511,
                27.225758
              ],
              [
                63.234924,
                27.225731
              ],
              [
                63.234724,
                27.225808
              ],
              [
                63.234591,
                27.225648
              ],
              [
                63.234612,
                27.225524
              ],
              [
                63.234441,
                27.225315
              ],
              [
                63.234167,
                27.225324
              ],
              [
                63.234108,
                27.225371
              ],
              [
                63.233748,
                27.225394
              ],
              [
                63.233659,
                27.22544
              ],
              [
                63.23361,
                27.225604
              ],
              [
                63.233475,
                27.225615
              ],
              [
                63.23333,
                27.225558
              ],
              [
                63.233185,
                27.225587
              ],
              [
                63.233176,
                27.225733
              ],
              [
                63.232884,
                27.225816
              ],
              [
                63.232605,
                27.22588
              ],
              [
                63.23235,
                27.225845
              ],
              [
                63.232311,
                27.225897
              ],
              [
                63.232063,
                27.22592
              ],
              [
                63.232156,
                27.225738
              ],
              [
                63.232279,
                27.225648
              ],
              [
                63.232141,
                27.225362
              ],
              [
                63.232167,
                27.225316
              ],
              [
                63.23178,
                27.224973
              ],
              [
                63.231673,
                27.224902
              ],
              [
                63.231311,
                27.224797
              ],
              [
                63.231128,
                27.224602
              ],
              [
                63.23113,
                27.22476
              ],
              [
                63.230984,
                27.224921
              ],
              [
                63.230777,
                27.225018
              ],
              [
                63.230352,
                27.225082
              ],
              [
                63.229813,
                27.225387
              ],
              [
                63.22871,
                27.225528
              ],
              [
                63.227843,
                27.225698
              ],
              [
                63.227186,
                27.225754
              ],
              [
                63.225433,
                27.225303
              ],
              [
                63.224699,
                27.225621
              ],
              [
                63.224551,
                27.225839
              ],
              [
                63.222507,
                27.227398
              ],
              [
                63.222371,
                27.227768
              ],
              [
                63.221502,
                27.228337
              ],
              [
                63.221109,
                27.22836
              ],
              [
                63.220916,
                27.228455
              ],
              [
                63.22068,
                27.228902
              ],
              [
                63.219901,
                27.230001
              ],
              [
                63.219527,
                27.230611
              ],
              [
                63.218796,
                27.231363
              ],
              [
                63.218526,
                27.231886
              ],
              [
                63.218192,
                27.232115
              ],
              [
                63.217947,
                27.232211
              ],
              [
                63.21776,
                27.232437
              ],
              [
                63.217491,
                27.232657
              ],
              [
                63.215603,
                27.233421
              ],
              [
                63.215103,
                27.233961
              ],
              [
                63.214537,
                27.234202
              ],
              [
                63.214087,
                27.234612
              ],
              [
                63.21362,
                27.234656
              ],
              [
                63.213067,
                27.235011
              ],
              [
                63.212252,
                27.23589
              ],
              [
                63.211309,
                27.236447
              ],
              [
                63.210884,
                27.237111
              ],
              [
                63.210662,
                27.237568
              ],
              [
                63.210384,
                27.237935
              ],
              [
                63.210129,
                27.238546
              ],
              [
                63.210048,
                27.238613
              ],
              [
                63.209791,
                27.239048
              ],
              [
                63.209723,
                27.239254
              ],
              [
                63.209662,
                27.239941
              ],
              [
                63.20931,
                27.240477
              ],
              [
                63.209142,
                27.240958
              ],
              [
                63.209196,
                27.24149
              ],
              [
                63.209116,
                27.241682
              ],
              [
                63.208763,
                27.24206
              ],
              [
                63.20859,
                27.242432
              ],
              [
                63.208198,
                27.243632
              ],
              [
                63.207902,
                27.244213
              ],
              [
                63.207047,
                27.245006
              ],
              [
                63.206268,
                27.245354
              ],
              [
                63.20549,
                27.246214
              ],
              [
                63.205095,
                27.246758
              ],
              [
                63.20438,
                27.247044
              ],
              [
                63.203975,
                27.247564
              ],
              [
                63.203938,
                27.247881
              ],
              [
                63.203781,
                27.248136
              ],
              [
                63.203407,
                27.248461
              ],
              [
                63.203293,
                27.248465
              ],
              [
                63.202958,
                27.248874
              ],
              [
                63.202985,
                27.24903
              ],
              [
                63.203149,
                27.249137
              ],
              [
                63.203192,
                27.249232
              ],
              [
                63.203562,
                27.2494
              ],
              [
                63.203562,
                27.249491
              ],
              [
                63.203772,
                27.24957
              ],
              [
                63.203945,
                27.249564
              ],
              [
                63.203921,
                27.249676
              ],
              [
                63.204199,
                27.250016
              ],
              [
                63.204313,
                27.250356
              ],
              [
                63.204244,
                27.250543
              ],
              [
                63.204381,
                27.250822
              ],
              [
                63.20417,
                27.250968
              ],
              [
                63.204172,
                27.251018
              ],
              [
                63.203988,
                27.25112
              ],
              [
                63.203988,
                27.251164
              ],
              [
                63.20375,
                27.251271
              ],
              [
                63.203743,
                27.251335
              ],
              [
                63.203588,
                27.251401
              ],
              [
                63.203506,
                27.251537
              ],
              [
                63.203231,
                27.251704
              ],
              [
                63.203251,
                27.252069
              ],
              [
                63.203165,
                27.252118
              ],
              [
                63.203164,
                27.252203
              ],
              [
                63.203008,
                27.252309
              ],
              [
                63.202845,
                27.252613
              ],
              [
                63.202653,
                27.252726
              ],
              [
                63.202596,
                27.252829
              ],
              [
                63.202459,
                27.252802
              ],
              [
                63.202374,
                27.252882
              ],
              [
                63.202226,
                27.252914
              ],
              [
                63.202136,
                27.253093
              ],
              [
                63.202025,
                27.253187
              ],
              [
                63.201991,
                27.253351
              ],
              [
                63.201898,
                27.253398
              ],
              [
                63.20177,
                27.253559
              ],
              [
                63.201709,
                27.253791
              ],
              [
                63.201534,
                27.25411
              ],
              [
                63.20135,
                27.25424
              ],
              [
                63.201291,
                27.254334
              ],
              [
                63.201267,
                27.25455
              ],
              [
                63.201148,
                27.254687
              ],
              [
                63.201137,
                27.254809
              ],
              [
                63.200937,
                27.255053
              ],
              [
                63.200689,
                27.255168
              ],
              [
                63.200675,
                27.255442
              ],
              [
                63.200445,
                27.255718
              ],
              [
                63.200415,
                27.256017
              ],
              [
                63.200083,
                27.256259
              ],
              [
                63.199967,
                27.256663
              ],
              [
                63.199778,
                27.256801
              ],
              [
                63.199441,
                27.257173
              ],
              [
                63.199398,
                27.257283
              ],
              [
                63.199401,
                27.257585
              ],
              [
                63.199252,
                27.257794
              ],
              [
                63.199201,
                27.258189
              ],
              [
                63.199151,
                27.258227
              ],
              [
                63.199221,
                27.258286
              ],
              [
                63.199265,
                27.258476
              ],
              [
                63.199067,
                27.2589
              ],
              [
                63.198822,
                27.259172
              ],
              [
                63.198716,
                27.259436
              ],
              [
                63.198149,
                27.259345
              ],
              [
                63.197798,
                27.259357
              ],
              [
                63.197711,
                27.259141
              ],
              [
                63.19751,
                27.258962
              ],
              [
                63.197445,
                27.258912
              ],
              [
                63.197337,
                27.258914
              ],
              [
                63.197023,
                27.258594
              ],
              [
                63.196592,
                27.258373
              ],
              [
                63.196024,
                27.258715
              ],
              [
                63.195866,
                27.258768
              ],
              [
                63.195624,
                27.258834
              ],
              [
                63.195525,
                27.258809
              ],
              [
                63.195306,
                27.25889
              ],
              [
                63.195061,
                27.258863
              ],
              [
                63.194959,
                27.259081
              ],
              [
                63.194175,
                27.25932
              ],
              [
                63.194086,
                27.259398
              ],
              [
                63.194079,
                27.259563
              ],
              [
                63.194037,
                27.259606
              ],
              [
                63.193781,
                27.259673
              ],
              [
                63.193608,
                27.259665
              ],
              [
                63.193472,
                27.259568
              ],
              [
                63.193023,
                27.259488
              ],
              [
                63.192835,
                27.259496
              ],
              [
                63.192597,
                27.25959
              ],
              [
                63.192539,
                27.259357
              ],
              [
                63.192419,
                27.259355
              ],
              [
                63.192191,
                27.259139
              ],
              [
                63.19189,
                27.259268
              ],
              [
                63.191784,
                27.259228
              ],
              [
                63.19156,
                27.259244
              ],
              [
                63.191493,
                27.259216
              ],
              [
                63.191473,
                27.259105
              ],
              [
                63.191183,
                27.258987
              ],
              [
                63.190615,
                27.259044
              ],
              [
                63.190463,
                27.259214
              ],
              [
                63.190308,
                27.259279
              ],
              [
                63.19018,
                27.259276
              ],
              [
                63.190161,
                27.259412
              ],
              [
                63.189919,
                27.259457
              ],
              [
                63.189894,
                27.259598
              ],
              [
                63.189715,
                27.259751
              ],
              [
                63.189635,
                27.260014
              ],
              [
                63.189541,
                27.260026
              ],
              [
                63.189471,
                27.25991
              ],
              [
                63.189433,
                27.260015
              ],
              [
                63.189337,
                27.260034
              ],
              [
                63.189144,
                27.259945
              ],
              [
                63.189079,
                27.26012
              ],
              [
                63.188858,
                27.260284
              ],
              [
                63.188653,
                27.260285
              ],
              [
                63.188379,
                27.26052
              ],
              [
                63.188328,
                27.26046
              ],
              [
                63.18813,
                27.260401
              ],
              [
                63.187933,
                27.260239
              ],
              [
                63.187836,
                27.260255
              ],
              [
                63.187776,
                27.260162
              ],
              [
                63.187634,
                27.260145
              ],
              [
                63.187632,
                27.260076
              ],
              [
                63.187341,
                27.260034
              ],
              [
                63.187222,
                27.259943
              ],
              [
                63.187237,
                27.259854
              ],
              [
                63.187055,
                27.259719
              ],
              [
                63.187007,
                27.259496
              ],
              [
                63.186768,
                27.259359
              ],
              [
                63.1867,
                27.259372
              ],
              [
                63.186582,
                27.259151
              ],
              [
                63.18625,
                27.259273
              ],
              [
                63.185772,
                27.258862
              ],
              [
                63.18554,
                27.258815
              ],
              [
                63.185439,
                27.258841
              ],
              [
                63.185325,
                27.258761
              ],
              [
                63.18482,
                27.258934
              ],
              [
                63.184688,
                27.258946
              ],
              [
                63.184543,
                27.258886
              ],
              [
                63.183907,
                27.259074
              ],
              [
                63.183585,
                27.258756
              ],
              [
                63.183279,
                27.258632
              ],
              [
                63.18305,
                27.258702
              ],
              [
                63.182924,
                27.258663
              ],
              [
                63.182712,
                27.258346
              ],
              [
                63.182622,
                27.2583
              ],
              [
                63.182505,
                27.258142
              ],
              [
                63.182262,
                27.258094
              ],
              [
                63.182038,
                27.257944
              ],
              [
                63.181841,
                27.257916
              ],
              [
                63.181755,
                27.257796
              ],
              [
                63.18166,
                27.257834
              ],
              [
                63.181492,
                27.257759
              ],
              [
                63.181395,
                27.257819
              ],
              [
                63.181342,
                27.257937
              ],
              [
                63.180969,
                27.258042
              ],
              [
                63.180871,
                27.258144
              ],
              [
                63.18077,
                27.258081
              ],
              [
                63.180587,
                27.258126
              ],
              [
                63.180375,
                27.258114
              ],
              [
                63.180189,
                27.257995
              ],
              [
                63.180147,
                27.257917
              ],
              [
                63.179762,
                27.257989
              ],
              [
                63.179653,
                27.257941
              ],
              [
                63.179524,
                27.257991
              ],
              [
                63.179395,
                27.257893
              ],
              [
                63.179228,
                27.257897
              ],
              [
                63.179112,
                27.257713
              ],
              [
                63.178998,
                27.257631
              ],
              [
                63.17883,
                27.257629
              ],
              [
                63.178493,
                27.25746
              ],
              [
                63.178155,
                27.257405
              ],
              [
                63.17787,
                27.257489
              ],
              [
                63.177675,
                27.257455
              ],
              [
                63.177119,
                27.257544
              ],
              [
                63.176982,
                27.257685
              ],
              [
                63.17694,
                27.257862
              ],
              [
                63.176834,
                27.257902
              ],
              [
                63.176766,
                27.258036
              ],
              [
                63.176402,
                27.258116
              ],
              [
                63.176178,
                27.25831
              ],
              [
                63.175906,
                27.258436
              ],
              [
                63.17582,
                27.258341
              ],
              [
                63.175732,
                27.25832
              ],
              [
                63.175606,
                27.258158
              ],
              [
                63.175307,
                27.258156
              ],
              [
                63.175058,
                27.257963
              ],
              [
                63.174815,
                27.25763
              ],
              [
                63.174089,
                27.257165
              ],
              [
                63.173942,
                27.257023
              ],
              [
                63.17393,
                27.256901
              ],
              [
                63.173791,
                27.256824
              ],
              [
                63.173748,
                27.25674
              ],
              [
                63.173603,
                27.256679
              ],
              [
                63.17356,
                27.256459
              ],
              [
                63.173475,
                27.256374
              ],
              [
                63.173391,
                27.256171
              ],
              [
                63.173178,
                27.256032
              ],
              [
                63.17307,
                27.255761
              ],
              [
                63.172961,
                27.255744
              ],
              [
                63.17294,
                27.255675
              ],
              [
                63.17275,
                27.25557
              ],
              [
                63.172636,
                27.255411
              ],
              [
                63.17258,
                27.255228
              ],
              [
                63.172343,
                27.255056
              ],
              [
                63.172308,
                27.254688
              ],
              [
                63.172368,
                27.254536
              ],
              [
                63.172073,
                27.254461
              ],
              [
                63.171956,
                27.254499
              ],
              [
                63.171506,
                27.254476
              ],
              [
                63.171095,
                27.254534
              ],
              [
                63.170896,
                27.254481
              ],
              [
                63.170467,
                27.254604
              ],
              [
                63.170238,
                27.254613
              ],
              [
                63.169916,
                27.254429
              ],
              [
                63.169705,
                27.254406
              ],
              [
                63.169469,
                27.254221
              ],
              [
                63.169283,
                27.254222
              ],
              [
                63.169062,
                27.254084
              ],
              [
                63.168844,
                27.254032
              ],
              [
                63.168384,
                27.253798
              ],
              [
                63.168153,
                27.253757
              ],
              [
                63.167908,
                27.253567
              ],
              [
                63.167761,
                27.253574
              ],
              [
                63.167415,
                27.253381
              ],
              [
                63.16723,
                27.253389
              ],
              [
                63.166992,
                27.253194
              ],
              [
                63.166668,
                27.253124
              ],
              [
                63.166509,
                27.253006
              ],
              [
                63.166372,
                27.253118
              ],
              [
                63.166096,
                27.253058
              ],
              [
                63.16576,
                27.253086
              ],
              [
                63.164979,
                27.25281
              ],
              [
                63.164872,
                27.252666
              ],
              [
                63.164548,
                27.252653
              ],
              [
                63.164499,
                27.252561
              ],
              [
                63.164182,
                27.252572
              ],
              [
                63.163898,
                27.252647
              ],
              [
                63.163788,
                27.252579
              ],
              [
                63.163589,
                27.252593
              ],
              [
                63.16354,
                27.252453
              ],
              [
                63.163402,
                27.252363
              ],
              [
                63.163378,
                27.252266
              ],
              [
                63.163229,
                27.252117
              ],
              [
                63.163137,
                27.251757
              ],
              [
                63.163164,
                27.251654
              ],
              [
                63.163117,
                27.251332
              ],
              [
                63.163032,
                27.251213
              ],
              [
                63.162914,
                27.251217
              ],
              [
                63.162921,
                27.251098
              ],
              [
                63.162827,
                27.251091
              ],
              [
                63.16283,
                27.250985
              ],
              [
                63.162711,
                27.250939
              ],
              [
                63.162737,
                27.250851
              ],
              [
                63.162643,
                27.250803
              ],
              [
                63.162626,
                27.250717
              ],
              [
                63.162714,
                27.250545
              ],
              [
                63.162666,
                27.250427
              ],
              [
                63.162432,
                27.250403
              ],
              [
                63.162428,
                27.250308
              ],
              [
                63.161539,
                27.249882
              ],
              [
                63.161542,
                27.249837
              ],
              [
                63.161275,
                27.249673
              ],
              [
                63.161225,
                27.249594
              ],
              [
                63.16057,
                27.249329
              ],
              [
                63.160214,
                27.249068
              ],
              [
                63.16008,
                27.248827
              ],
              [
                63.159782,
                27.248587
              ],
              [
                63.159332,
                27.248564
              ],
              [
                63.158832,
                27.248621
              ],
              [
                63.158473,
                27.248424
              ],
              [
                63.158236,
                27.248385
              ],
              [
                63.158176,
                27.248292
              ],
              [
                63.15807,
                27.248303
              ],
              [
                63.158041,
                27.248229
              ],
              [
                63.15766,
                27.248212
              ],
              [
                63.157562,
                27.248164
              ],
              [
                63.15745,
                27.248297
              ],
              [
                63.157386,
                27.248491
              ],
              [
                63.157306,
                27.248351
              ],
              [
                63.156819,
                27.248326
              ],
              [
                63.156588,
                27.248209
              ],
              [
                63.156537,
                27.24826
              ],
              [
                63.156294,
                27.248149
              ],
              [
                63.156143,
                27.248128
              ],
              [
                63.156056,
                27.248154
              ],
              [
                63.156041,
                27.248214
              ],
              [
                63.155842,
                27.248345
              ],
              [
                63.155439,
                27.248497
              ],
              [
                63.155199,
                27.248642
              ],
              [
                63.155049,
                27.248774
              ],
              [
                63.154989,
                27.248922
              ],
              [
                63.154868,
                27.248888
              ],
              [
                63.154816,
                27.248797
              ],
              [
                63.154461,
                27.248717
              ],
              [
                63.154429,
                27.24859
              ],
              [
                63.154245,
                27.248464
              ],
              [
                63.153833,
                27.248488
              ],
              [
                63.153429,
                27.248363
              ],
              [
                63.153192,
                27.248159
              ],
              [
                63.152863,
                27.248112
              ],
              [
                63.152598,
                27.247884
              ],
              [
                63.152485,
                27.247881
              ],
              [
                63.152283,
                27.247667
              ],
              [
                63.152184,
                27.247686
              ],
              [
                63.151931,
                27.247555
              ],
              [
                63.151936,
                27.247439
              ],
              [
                63.151759,
                27.247312
              ],
              [
                63.151691,
                27.247189
              ],
              [
                63.151603,
                27.247196
              ],
              [
                63.151274,
                27.24707
              ],
              [
                63.151052,
                27.246869
              ],
              [
                63.150983,
                27.246543
              ],
              [
                63.150735,
                27.246474
              ],
              [
                63.150569,
                27.246481
              ],
              [
                63.150234,
                27.246185
              ],
              [
                63.150026,
                27.246127
              ],
              [
                63.149933,
                27.246053
              ],
              [
                63.149743,
                27.246042
              ],
              [
                63.149823,
                27.24597
              ],
              [
                63.149763,
                27.24588
              ],
              [
                63.149814,
                27.245784
              ],
              [
                63.149729,
                27.245439
              ],
              [
                63.149452,
                27.245287
              ],
              [
                63.149444,
                27.245206
              ],
              [
                63.149304,
                27.245109
              ],
              [
                63.149208,
                27.245099
              ],
              [
                63.149039,
                27.244913
              ],
              [
                63.148742,
                27.244736
              ],
              [
                63.14852,
                27.244459
              ],
              [
                63.148505,
                27.244354
              ],
              [
                63.148233,
                27.243902
              ],
              [
                63.147714,
                27.243839
              ],
              [
                63.14715,
                27.243581
              ],
              [
                63.146905,
                27.2436
              ],
              [
                63.146859,
                27.24352
              ],
              [
                63.146739,
                27.243487
              ],
              [
                63.146494,
                27.243312
              ],
              [
                63.146255,
                27.24328
              ],
              [
                63.146001,
                27.243355
              ],
              [
                63.145365,
                27.243003
              ],
              [
                63.145005,
                27.242616
              ],
              [
                63.144653,
                27.242644
              ],
              [
                63.144482,
                27.242703
              ],
              [
                63.144071,
                27.242986
              ],
              [
                63.144051,
                27.24306
              ],
              [
                63.143777,
                27.243203
              ],
              [
                63.143572,
                27.243173
              ],
              [
                63.143313,
                27.24329
              ],
              [
                63.143286,
                27.243346
              ],
              [
                63.143139,
                27.24334
              ],
              [
                63.142983,
                27.243402
              ],
              [
                63.142764,
                27.243664
              ],
              [
                63.14217,
                27.243812
              ],
              [
                63.14174,
                27.243804
              ],
              [
                63.141425,
                27.243967
              ],
              [
                63.141034,
                27.243908
              ],
              [
                63.140855,
                27.244
              ],
              [
                63.140611,
                27.244009
              ],
              [
                63.140475,
                27.244093
              ],
              [
                63.140161,
                27.244104
              ],
              [
                63.139935,
                27.244202
              ],
              [
                63.139833,
                27.244165
              ],
              [
                63.139664,
                27.244191
              ],
              [
                63.139495,
                27.244053
              ],
              [
                63.139209,
                27.244131
              ],
              [
                63.139013,
                27.244246
              ],
              [
                63.138604,
                27.244354
              ],
              [
                63.13848,
                27.24455
              ],
              [
                63.138394,
                27.244595
              ],
              [
                63.138256,
                27.244594
              ],
              [
                63.138161,
                27.244663
              ],
              [
                63.1378,
                27.244743
              ],
              [
                63.137218,
                27.244349
              ],
              [
                63.137227,
                27.244265
              ],
              [
                63.137092,
                27.244142
              ],
              [
                63.137058,
                27.244022
              ],
              [
                63.136868,
                27.244005
              ],
              [
                63.136383,
                27.243687
              ],
              [
                63.136457,
                27.243533
              ],
              [
                63.136222,
                27.243023
              ],
              [
                63.136255,
                27.242763
              ],
              [
                63.136319,
                27.242614
              ],
              [
                63.136306,
                27.242489
              ],
              [
                63.13637,
                27.242337
              ],
              [
                63.136443,
                27.2423
              ],
              [
                63.136455,
                27.242123
              ],
              [
                63.13665,
                27.241977
              ],
              [
                63.136378,
                27.241964
              ],
              [
                63.13627,
                27.241842
              ],
              [
                63.136154,
                27.241798
              ],
              [
                63.136055,
                27.241652
              ],
              [
                63.135678,
                27.24144
              ],
              [
                63.135543,
                27.241181
              ],
              [
                63.13533,
                27.241073
              ],
              [
                63.13531,
                27.240992
              ],
              [
                63.135148,
                27.240944
              ],
              [
                63.135074,
                27.240974
              ],
              [
                63.134658,
                27.240935
              ],
              [
                63.134582,
                27.24087
              ],
              [
                63.134026,
                27.240947
              ],
              [
                63.133852,
                27.240772
              ],
              [
                63.133831,
                27.240684
              ],
              [
                63.133389,
                27.240707
              ],
              [
                63.133231,
                27.240643
              ],
              [
                63.133334,
                27.24094
              ],
              [
                63.133329,
                27.2411
              ],
              [
                63.133171,
                27.24135
              ],
              [
                63.132902,
                27.241561
              ],
              [
                63.132469,
                27.241528
              ],
              [
                63.132408,
                27.24169
              ],
              [
                63.131549,
                27.241899
              ],
              [
                63.131354,
                27.241819
              ],
              [
                63.131201,
                27.241862
              ],
              [
                63.130598,
                27.241809
              ],
              [
                63.130342,
                27.241862
              ],
              [
                63.130116,
                27.241836
              ],
              [
                63.129992,
                27.241937
              ],
              [
                63.129672,
                27.242047
              ],
              [
                63.129343,
                27.241788
              ],
              [
                63.129169,
                27.241736
              ],
              [
                63.129094,
                27.241655
              ],
              [
                63.128792,
                27.241521
              ],
              [
                63.128736,
                27.241433
              ],
              [
                63.128614,
                27.241375
              ],
              [
                63.12844,
                27.241126
              ],
              [
                63.128206,
                27.241159
              ],
              [
                63.128121,
                27.241103
              ],
              [
                63.127998,
                27.241146
              ],
              [
                63.127877,
                27.241036
              ],
              [
                63.127623,
                27.241092
              ],
              [
                63.127458,
                27.241013
              ],
              [
                63.127361,
                27.241016
              ],
              [
                63.126886,
                27.241223
              ],
              [
                63.126678,
                27.241344
              ],
              [
                63.126639,
                27.241415
              ],
              [
                63.126464,
                27.241229
              ],
              [
                63.126323,
                27.241247
              ],
              [
                63.126248,
                27.241125
              ],
              [
                63.126116,
                27.24104
              ],
              [
                63.125875,
                27.240912
              ],
              [
                63.125505,
                27.240804
              ],
              [
                63.125251,
                27.240606
              ],
              [
                63.125002,
                27.240565
              ],
              [
                63.124645,
                27.240327
              ],
              [
                63.124378,
                27.240259
              ],
              [
                63.124006,
                27.240281
              ],
              [
                63.124003,
                27.240208
              ],
              [
                63.123799,
                27.239924
              ],
              [
                63.123708,
                27.239615
              ],
              [
                63.123615,
                27.239605
              ],
              [
                63.123555,
                27.239543
              ],
              [
                63.123358,
                27.239528
              ],
              [
                63.123315,
                27.239432
              ],
              [
                63.123407,
                27.239261
              ],
              [
                63.123416,
                27.238935
              ],
              [
                63.123499,
                27.238925
              ],
              [
                63.12351,
                27.238727
              ],
              [
                63.123576,
                27.238571
              ],
              [
                63.123497,
                27.238494
              ],
              [
                63.123471,
                27.238359
              ],
              [
                63.123521,
                27.238318
              ],
              [
                63.12346,
                27.238254
              ],
              [
                63.123436,
                27.238112
              ],
              [
                63.123167,
                27.237866
              ],
              [
                63.122946,
                27.237862
              ],
              [
                63.122445,
                27.237633
              ],
              [
                63.122483,
                27.237559
              ],
              [
                63.122453,
                27.237498
              ],
              [
                63.122219,
                27.237414
              ],
              [
                63.122069,
                27.237303
              ],
              [
                63.121963,
                27.236905
              ],
              [
                63.121111,
                27.236945
              ],
              [
                63.121047,
                27.237005
              ],
              [
                63.120945,
                27.237015
              ],
              [
                63.120575,
                27.237011
              ],
              [
                63.120326,
                27.237165
              ],
              [
                63.120281,
                27.237288
              ],
              [
                63.120195,
                27.237257
              ],
              [
                63.119579,
                27.237314
              ],
              [
                63.119547,
                27.237365
              ],
              [
                63.119391,
                27.237383
              ],
              [
                63.119287,
                27.237508
              ],
              [
                63.119164,
                27.237538
              ],
              [
                63.118636,
                27.237499
              ],
              [
                63.11861,
                27.237409
              ],
              [
                63.118508,
                27.237403
              ],
              [
                63.117947,
                27.237564
              ],
              [
                63.11778,
                27.237688
              ],
              [
                63.11741,
                27.237446
              ],
              [
                63.117348,
                27.237376
              ],
              [
                63.117382,
                27.237303
              ],
              [
                63.117167,
                27.237138
              ],
              [
                63.117171,
                27.237052
              ],
              [
                63.117071,
                27.236935
              ],
              [
                63.117138,
                27.236827
              ],
              [
                63.117162,
                27.23665
              ],
              [
                63.117086,
                27.236465
              ],
              [
                63.117115,
                27.236266
              ],
              [
                63.117074,
                27.236191
              ],
              [
                63.116934,
                27.236155
              ],
              [
                63.116803,
                27.236212
              ],
              [
                63.116741,
                27.236082
              ],
              [
                63.116641,
                27.236387
              ],
              [
                63.116407,
                27.236496
              ],
              [
                63.116092,
                27.23658
              ],
              [
                63.115977,
                27.236539
              ],
              [
                63.115713,
                27.2366
              ],
              [
                63.115406,
                27.236565
              ],
              [
                63.115181,
                27.236682
              ],
              [
                63.115116,
                27.236647
              ],
              [
                63.114735,
                27.236766
              ],
              [
                63.114507,
                27.236674
              ],
              [
                63.114346,
                27.236715
              ],
              [
                63.114123,
                27.236661
              ],
              [
                63.113776,
                27.236417
              ],
              [
                63.113584,
                27.236503
              ],
              [
                63.113513,
                27.236424
              ],
              [
                63.113381,
                27.236463
              ],
              [
                63.113314,
                27.236603
              ],
              [
                63.113102,
                27.236362
              ],
              [
                63.112965,
                27.23629
              ],
              [
                63.112755,
                27.236316
              ],
              [
                63.11261,
                27.236229
              ],
              [
                63.112554,
                27.236291
              ],
              [
                63.112508,
                27.236497
              ],
              [
                63.112305,
                27.236639
              ],
              [
                63.112284,
                27.236735
              ],
              [
                63.112178,
                27.236759
              ],
              [
                63.112114,
                27.236908
              ],
              [
                63.111993,
                27.236947
              ],
              [
                63.111961,
                27.236998
              ],
              [
                63.111993,
                27.237052
              ],
              [
                63.111821,
                27.237216
              ],
              [
                63.111661,
                27.23719
              ],
              [
                63.11144,
                27.23723
              ],
              [
                63.111237,
                27.237346
              ],
              [
                63.110924,
                27.237617
              ],
              [
                63.110831,
                27.23786
              ],
              [
                63.11067,
                27.237936
              ],
              [
                63.110461,
                27.237949
              ],
              [
                63.110439,
                27.238055
              ],
              [
                63.110271,
                27.238189
              ],
              [
                63.110159,
                27.238192
              ],
              [
                63.109401,
                27.238521
              ],
              [
                63.109031,
                27.238502
              ],
              [
                63.108856,
                27.238596
              ],
              [
                63.108655,
                27.238566
              ],
              [
                63.108428,
                27.238359
              ],
              [
                63.108243,
                27.238364
              ],
              [
                63.108109,
                27.238307
              ],
              [
                63.107983,
                27.238307
              ],
              [
                63.107749,
                27.238403
              ],
              [
                63.107458,
                27.238374
              ],
              [
                63.107394,
                27.23846
              ],
              [
                63.107005,
                27.238638
              ],
              [
                63.106683,
                27.238726
              ],
              [
                63.106309,
                27.23866
              ],
              [
                63.106072,
                27.238849
              ],
              [
                63.105852,
                27.238473
              ],
              [
                63.105458,
                27.238115
              ],
              [
                63.105074,
                27.237679
              ],
              [
                63.104615,
                27.237556
              ],
              [
                63.104184,
                27.237294
              ],
              [
                63.104058,
                27.237131
              ],
              [
                63.103526,
                27.237048
              ],
              [
                63.103235,
                27.236898
              ],
              [
                63.103154,
                27.236797
              ],
              [
                63.102882,
                27.23672
              ],
              [
                63.102739,
                27.236732
              ],
              [
                63.102621,
                27.23666
              ],
              [
                63.101614,
                27.236647
              ],
              [
                63.101363,
                27.236795
              ],
              [
                63.101211,
                27.236831
              ],
              [
                63.10088,
                27.237089
              ],
              [
                63.10081,
                27.237078
              ],
              [
                63.100623,
                27.236895
              ],
              [
                63.100319,
                27.23684
              ],
              [
                63.099875,
                27.236857
              ],
              [
                63.099636,
                27.236977
              ],
              [
                63.099387,
                27.236994
              ],
              [
                63.099246,
                27.236971
              ],
              [
                63.09907,
                27.236862
              ],
              [
                63.098781,
                27.236916
              ],
              [
                63.098548,
                27.237165
              ],
              [
                63.09842,
                27.237218
              ],
              [
                63.098321,
                27.23712
              ],
              [
                63.098238,
                27.237133
              ],
              [
                63.098016,
                27.237021
              ],
              [
                63.097767,
                27.237054
              ],
              [
                63.097666,
                27.236978
              ],
              [
                63.097684,
                27.236914
              ],
              [
                63.097614,
                27.236874
              ],
              [
                63.097597,
                27.236789
              ],
              [
                63.097455,
                27.236727
              ],
              [
                63.097276,
                27.236759
              ],
              [
                63.097098,
                27.23675
              ],
              [
                63.097003,
                27.236695
              ],
              [
                63.096555,
                27.236723
              ],
              [
                63.096469,
                27.236679
              ],
              [
                63.09624,
                27.236702
              ],
              [
                63.095534,
                27.23691
              ],
              [
                63.095348,
                27.237168
              ],
              [
                63.095152,
                27.237207
              ],
              [
                63.095076,
                27.237183
              ],
              [
                63.095034,
                27.237242
              ],
              [
                63.094875,
                27.237264
              ],
              [
                63.094534,
                27.237077
              ],
              [
                63.094321,
                27.237061
              ],
              [
                63.093984,
                27.23674
              ],
              [
                63.093532,
                27.236812
              ],
              [
                63.093351,
                27.236683
              ],
              [
                63.093206,
                27.236654
              ],
              [
                63.092653,
                27.236667
              ],
              [
                63.09255,
                27.236716
              ],
              [
                63.092301,
                27.236647
              ],
              [
                63.092088,
                27.236326
              ],
              [
                63.092007,
                27.236269
              ],
              [
                63.091761,
                27.236228
              ],
              [
                63.091719,
                27.236148
              ],
              [
                63.091523,
                27.23605
              ],
              [
                63.091501,
                27.23599
              ],
              [
                63.091419,
                27.235978
              ],
              [
                63.091026,
                27.235623
              ],
              [
                63.090611,
                27.23544
              ],
              [
                63.090281,
                27.235416
              ],
              [
                63.090256,
                27.235481
              ],
              [
                63.090126,
                27.235469
              ],
              [
                63.090031,
                27.235522
              ],
              [
                63.089586,
                27.235444
              ],
              [
                63.08941,
                27.235666
              ],
              [
                63.089393,
                27.23593
              ],
              [
                63.089428,
                27.23631
              ],
              [
                63.089533,
                27.236604
              ],
              [
                63.089432,
                27.236767
              ],
              [
                63.089557,
                27.23706
              ],
              [
                63.089519,
                27.237147
              ],
              [
                63.089272,
                27.237208
              ],
              [
                63.089187,
                27.237481
              ],
              [
                63.089082,
                27.23754
              ],
              [
                63.089066,
                27.237686
              ],
              [
                63.08887,
                27.237845
              ],
              [
                63.088955,
                27.238082
              ],
              [
                63.088849,
                27.238122
              ],
              [
                63.08886,
                27.238181
              ],
              [
                63.088688,
                27.238405
              ],
              [
                63.088603,
                27.238618
              ],
              [
                63.088682,
                27.238984
              ],
              [
                63.088766,
                27.239126
              ],
              [
                63.088655,
                27.239313
              ],
              [
                63.088496,
                27.239379
              ],
              [
                63.088363,
                27.23937
              ],
              [
                63.088157,
                27.239261
              ],
              [
                63.088085,
                27.239269
              ],
              [
                63.087892,
                27.23911
              ],
              [
                63.087565,
                27.239082
              ],
              [
                63.087351,
                27.239152
              ],
              [
                63.087299,
                27.239108
              ],
              [
                63.086955,
                27.23915
              ],
              [
                63.086855,
                27.239275
              ],
              [
                63.08691,
                27.239527
              ],
              [
                63.086988,
                27.23963
              ],
              [
                63.086962,
                27.239736
              ],
              [
                63.087015,
                27.23977
              ],
              [
                63.087064,
                27.239939
              ],
              [
                63.087186,
                27.240042
              ],
              [
                63.087408,
                27.240379
              ],
              [
                63.087581,
                27.24046
              ],
              [
                63.087724,
                27.240781
              ],
              [
                63.087775,
                27.240809
              ],
              [
                63.087656,
                27.241144
              ],
              [
                63.087407,
                27.241386
              ],
              [
                63.087552,
                27.241523
              ],
              [
                63.087635,
                27.241735
              ],
              [
                63.087779,
                27.241745
              ],
              [
                63.087764,
                27.241805
              ],
              [
                63.087548,
                27.241898
              ],
              [
                63.087382,
                27.242055
              ],
              [
                63.08738,
                27.242242
              ],
              [
                63.087447,
                27.242363
              ],
              [
                63.087456,
                27.242504
              ],
              [
                63.087252,
                27.242617
              ],
              [
                63.087213,
                27.242745
              ],
              [
                63.087246,
                27.242894
              ],
              [
                63.087102,
                27.242992
              ],
              [
                63.087234,
                27.243538
              ],
              [
                63.087114,
                27.243777
              ],
              [
                63.086922,
                27.243999
              ],
              [
                63.086889,
                27.244152
              ],
              [
                63.086944,
                27.244252
              ],
              [
                63.086937,
                27.244422
              ],
              [
                63.086857,
                27.244701
              ],
              [
                63.086594,
                27.244921
              ],
              [
                63.08613,
                27.244989
              ],
              [
                63.085884,
                27.244929
              ],
              [
                63.08542,
                27.244715
              ],
              [
                63.085178,
                27.244759
              ],
              [
                63.085009,
                27.24471
              ],
              [
                63.0847,
                27.24444
              ],
              [
                63.084472,
                27.244348
              ],
              [
                63.084236,
                27.244061
              ],
              [
                63.084069,
                27.244002
              ],
              [
                63.083555,
                27.244007
              ],
              [
                63.083402,
                27.243884
              ],
              [
                63.083271,
                27.243885
              ],
              [
                63.083128,
                27.243728
              ],
              [
                63.082976,
                27.243746
              ],
              [
                63.082237,
                27.24349
              ],
              [
                63.082184,
                27.24344
              ],
              [
                63.081667,
                27.243494
              ],
              [
                63.08139,
                27.243472
              ],
              [
                63.08121,
                27.243364
              ],
              [
                63.081055,
                27.243369
              ],
              [
                63.080961,
                27.243308
              ],
              [
                63.080791,
                27.243284
              ],
              [
                63.080587,
                27.243425
              ],
              [
                63.080568,
                27.243531
              ],
              [
                63.079954,
                27.243657
              ],
              [
                63.079384,
                27.243448
              ],
              [
                63.079179,
                27.243237
              ],
              [
                63.079041,
                27.243268
              ],
              [
                63.07897,
                27.243205
              ],
              [
                63.078464,
                27.243168
              ],
              [
                63.078326,
                27.243049
              ],
              [
                63.07817,
                27.242717
              ],
              [
                63.0779,
                27.241808
              ],
              [
                63.077733,
                27.241479
              ],
              [
                63.077713,
                27.241232
              ],
              [
                63.077778,
                27.241149
              ],
              [
                63.07768,
                27.241054
              ],
              [
                63.076136,
                27.240784
              ],
              [
                63.075852,
                27.240497
              ],
              [
                63.075287,
                27.240233
              ],
              [
                63.074889,
                27.240251
              ],
              [
                63.074661,
                27.240146
              ],
              [
                63.074313,
                27.240109
              ],
              [
                63.07355,
                27.240163
              ],
              [
                63.073311,
                27.239981
              ],
              [
                63.073062,
                27.239881
              ],
              [
                63.072737,
                27.239665
              ],
              [
                63.072742,
                27.239581
              ],
              [
                63.072285,
                27.239334
              ],
              [
                63.072017,
                27.239063
              ],
              [
                63.071645,
                27.238964
              ],
              [
                63.071612,
                27.238844
              ],
              [
                63.07133,
                27.238943
              ],
              [
                63.071238,
                27.238932
              ],
              [
                63.071044,
                27.239053
              ],
              [
                63.070604,
                27.238828
              ],
              [
                63.07025,
                27.238783
              ],
              [
                63.069977,
                27.23884
              ],
              [
                63.069529,
                27.239184
              ],
              [
                63.06942,
                27.239396
              ],
              [
                63.069341,
                27.239485
              ],
              [
                63.069278,
                27.239484
              ],
              [
                63.068704,
                27.239139
              ],
              [
                63.068484,
                27.2389
              ],
              [
                63.068293,
                27.238791
              ],
              [
                63.068131,
                27.238439
              ],
              [
                63.067476,
                27.237973
              ],
              [
                63.067342,
                27.23778
              ],
              [
                63.06714,
                27.237645
              ],
              [
                63.067055,
                27.237614
              ],
              [
                63.066868,
                27.237689
              ],
              [
                63.06677,
                27.237838
              ],
              [
                63.066559,
                27.238009
              ],
              [
                63.066389,
                27.237957
              ],
              [
                63.066244,
                27.238046
              ],
              [
                63.065789,
                27.23782
              ],
              [
                63.065589,
                27.237783
              ],
              [
                63.06533,
                27.237805
              ],
              [
                63.065016,
                27.237686
              ],
              [
                63.064718,
                27.237744
              ],
              [
                63.064541,
                27.237709
              ],
              [
                63.064515,
                27.237647
              ],
              [
                63.064266,
                27.237652
              ],
              [
                63.064143,
                27.237501
              ],
              [
                63.063593,
                27.237374
              ],
              [
                63.063524,
                27.237339
              ],
              [
                63.063437,
                27.237182
              ],
              [
                63.063335,
                27.237176
              ],
              [
                63.062851,
                27.236909
              ],
              [
                63.062277,
                27.236717
              ],
              [
                63.062231,
                27.236561
              ],
              [
                63.062258,
                27.236339
              ],
              [
                63.062094,
                27.2362
              ],
              [
                63.061663,
                27.236075
              ],
              [
                63.06157,
                27.235788
              ],
              [
                63.061399,
                27.235774
              ],
              [
                63.060971,
                27.235613
              ],
              [
                63.060637,
                27.23538
              ],
              [
                63.060341,
                27.235301
              ],
              [
                63.059969,
                27.234822
              ],
              [
                63.059873,
                27.234764
              ],
              [
                63.05971,
                27.234768
              ],
              [
                63.05949,
                27.234709
              ],
              [
                63.059322,
                27.234815
              ],
              [
                63.05907,
                27.234864
              ],
              [
                63.058819,
                27.235253
              ],
              [
                63.058284,
                27.23558
              ],
              [
                63.057699,
                27.235552
              ],
              [
                63.057436,
                27.235457
              ],
              [
                63.057558,
                27.235255
              ],
              [
                63.057233,
                27.234998
              ],
              [
                63.057095,
                27.234815
              ],
              [
                63.056475,
                27.23454
              ],
              [
                63.056021,
                27.234397
              ],
              [
                63.05581,
                27.234238
              ],
              [
                63.055345,
                27.234043
              ],
              [
                63.055242,
                27.23393
              ],
              [
                63.054946,
                27.234061
              ],
              [
                63.054541,
                27.233889
              ],
              [
                63.053949,
                27.234012
              ],
              [
                63.053396,
                27.233917
              ],
              [
                63.05328,
                27.233857
              ],
              [
                63.053221,
                27.23377
              ],
              [
                63.052835,
                27.233626
              ],
              [
                63.052587,
                27.233649
              ],
              [
                63.052538,
                27.233605
              ],
              [
                63.05203,
                27.233676
              ],
              [
                63.051823,
                27.233777
              ],
              [
                63.051323,
                27.233776
              ],
              [
                63.05125,
                27.23372
              ],
              [
                63.051088,
                27.233714
              ],
              [
                63.051031,
                27.233757
              ],
              [
                63.050937,
                27.233721
              ],
              [
                63.050765,
                27.233736
              ],
              [
                63.050498,
                27.233909
              ],
              [
                63.049922,
                27.233841
              ],
              [
                63.049818,
                27.233858
              ],
              [
                63.049613,
                27.234009
              ],
              [
                63.04919,
                27.233959
              ],
              [
                63.048809,
                27.234093
              ],
              [
                63.048646,
                27.234236
              ],
              [
                63.048258,
                27.234417
              ],
              [
                63.048109,
                27.234446
              ],
              [
                63.047974,
                27.234396
              ],
              [
                63.047638,
                27.234456
              ],
              [
                63.047315,
                27.234433
              ],
              [
                63.047002,
                27.234482
              ],
              [
                63.046871,
                27.234841
              ],
              [
                63.046712,
                27.235028
              ],
              [
                63.046383,
                27.235282
              ],
              [
                63.046269,
                27.23547
              ],
              [
                63.046059,
                27.235632
              ],
              [
                63.046005,
                27.235747
              ],
              [
                63.04578,
                27.235845
              ],
              [
                63.045817,
                27.235876
              ],
              [
                63.045773,
                27.235923
              ],
              [
                63.045832,
                27.236267
              ],
              [
                63.045784,
                27.236359
              ],
              [
                63.04554,
                27.236429
              ],
              [
                63.044822,
                27.236347
              ],
              [
                63.044657,
                27.236373
              ],
              [
                63.044349,
                27.236519
              ],
              [
                63.043581,
                27.236275
              ],
              [
                63.043247,
                27.23636
              ],
              [
                63.042996,
                27.236355
              ],
              [
                63.042886,
                27.236395
              ],
              [
                63.042686,
                27.236641
              ],
              [
                63.042484,
                27.236671
              ],
              [
                63.042323,
                27.236636
              ],
              [
                63.042067,
                27.236721
              ],
              [
                63.041968,
                27.236788
              ],
              [
                63.042061,
                27.236843
              ],
              [
                63.041993,
                27.236992
              ],
              [
                63.041594,
                27.237159
              ],
              [
                63.041424,
                27.23712
              ],
              [
                63.040552,
                27.23729
              ],
              [
                63.040146,
                27.236931
              ],
              [
                63.040059,
                27.236774
              ],
              [
                63.039643,
                27.236617
              ],
              [
                63.039585,
                27.236486
              ],
              [
                63.039104,
                27.236249
              ],
              [
                63.038871,
                27.235895
              ],
              [
                63.038818,
                27.235651
              ],
              [
                63.038891,
                27.235491
              ],
              [
                63.038348,
                27.23541
              ],
              [
                63.03807,
                27.234842
              ],
              [
                63.037865,
                27.234571
              ],
              [
                63.037646,
                27.234363
              ],
              [
                63.037455,
                27.234317
              ],
              [
                63.037284,
                27.234183
              ],
              [
                63.037259,
                27.234038
              ],
              [
                63.03733,
                27.233932
              ],
              [
                63.03731,
                27.233851
              ],
              [
                63.037179,
                27.233638
              ],
              [
                63.03706,
                27.233261
              ],
              [
                63.03681,
                27.233142
              ],
              [
                63.03671,
                27.232479
              ],
              [
                63.036269,
                27.23246
              ],
              [
                63.036056,
                27.232581
              ],
              [
                63.035924,
                27.232607
              ],
              [
                63.035636,
                27.232514
              ],
              [
                63.035571,
                27.232444
              ],
              [
                63.035445,
                27.23245
              ],
              [
                63.035217,
                27.232571
              ],
              [
                63.034935,
                27.232499
              ],
              [
                63.034695,
                27.232374
              ],
              [
                63.034287,
                27.2324
              ],
              [
                63.033894,
                27.23209
              ],
              [
                63.033494,
                27.232016
              ],
              [
                63.033387,
                27.231941
              ],
              [
                63.033277,
                27.23195
              ],
              [
                63.033166,
                27.231803
              ],
              [
                63.033198,
                27.231435
              ],
              [
                63.033037,
                27.231403
              ],
              [
                63.032969,
                27.231309
              ],
              [
                63.032844,
                27.231285
              ],
              [
                63.032753,
                27.2311
              ],
              [
                63.032383,
                27.230883
              ],
              [
                63.03242,
                27.230809
              ],
              [
                63.032356,
                27.230673
              ],
              [
                63.03225,
                27.230617
              ],
              [
                63.032201,
                27.230449
              ],
              [
                63.032068,
                27.230364
              ],
              [
                63.032071,
                27.230303
              ],
              [
                63.031931,
                27.230235
              ],
              [
                63.031889,
                27.230139
              ],
              [
                63.031823,
                27.230129
              ],
              [
                63.031679,
                27.22991
              ],
              [
                63.031264,
                27.22993
              ],
              [
                63.031154,
                27.229869
              ],
              [
                63.030984,
                27.229953
              ],
              [
                63.030888,
                27.23036
              ],
              [
                63.030684,
                27.230276
              ],
              [
                63.03009,
                27.23018
              ],
              [
                63.029544,
                27.230315
              ],
              [
                63.029424,
                27.230596
              ],
              [
                63.029342,
                27.230643
              ],
              [
                63.02928,
                27.230782
              ],
              [
                63.028866,
                27.230755
              ],
              [
                63.028595,
                27.230593
              ],
              [
                63.028485,
                27.230465
              ],
              [
                63.02816,
                27.230449
              ],
              [
                63.028009,
                27.230533
              ],
              [
                63.027618,
                27.230536
              ],
              [
                63.027533,
                27.230524
              ],
              [
                63.02733,
                27.230307
              ],
              [
                63.026749,
                27.230328
              ],
              [
                63.026576,
                27.230184
              ],
              [
                63.02653,
                27.230088
              ],
              [
                63.026439,
                27.230084
              ],
              [
                63.026353,
                27.230021
              ],
              [
                63.026276,
                27.229875
              ],
              [
                63.02603,
                27.229846
              ],
              [
                63.025931,
                27.22978
              ],
              [
                63.02585,
                27.229828
              ],
              [
                63.02566,
                27.229814
              ],
              [
                63.025073,
                27.229646
              ],
              [
                63.024876,
                27.229526
              ],
              [
                63.024693,
                27.229663
              ],
              [
                63.0243,
                27.229778
              ],
              [
                63.024222,
                27.229854
              ],
              [
                63.024105,
                27.229833
              ],
              [
                63.023788,
                27.22991
              ],
              [
                63.023417,
                27.22978
              ],
              [
                63.023307,
                27.229792
              ],
              [
                63.023115,
                27.229674
              ],
              [
                63.02297,
                27.229709
              ],
              [
                63.022823,
                27.229687
              ],
              [
                63.022626,
                27.229598
              ],
              [
                63.022525,
                27.229494
              ],
              [
                63.02253,
                27.229436
              ],
              [
                63.022277,
                27.229155
              ],
              [
                63.022182,
                27.228923
              ],
              [
                63.021986,
                27.228809
              ],
              [
                63.021918,
                27.228667
              ],
              [
                63.021947,
                27.228527
              ],
              [
                63.021777,
                27.228218
              ],
              [
                63.021563,
                27.228075
              ],
              [
                63.021602,
                27.227979
              ],
              [
                63.021551,
                27.227909
              ],
              [
                63.021564,
                27.227567
              ],
              [
                63.021376,
                27.227547
              ],
              [
                63.021316,
                27.227457
              ],
              [
                63.020904,
                27.227147
              ],
              [
                63.020798,
                27.226809
              ],
              [
                63.020677,
                27.226667
              ],
              [
                63.020619,
                27.226314
              ],
              [
                63.020238,
                27.226188
              ],
              [
                63.02022,
                27.226087
              ],
              [
                63.019823,
                27.225688
              ],
              [
                63.019731,
                27.225481
              ],
              [
                63.019193,
                27.225161
              ],
              [
                63.019051,
                27.225192
              ],
              [
                63.018879,
                27.22513
              ],
              [
                63.018119,
                27.224726
              ],
              [
                63.017745,
                27.224587
              ],
              [
                63.017621,
                27.224462
              ],
              [
                63.017396,
                27.22435
              ],
              [
                63.016751,
                27.22446
              ],
              [
                63.016631,
                27.224531
              ],
              [
                63.01661,
                27.224628
              ],
              [
                63.015993,
                27.224488
              ],
              [
                63.015652,
                27.224469
              ],
              [
                63.015089,
                27.224274
              ],
              [
                63.015005,
                27.224278
              ],
              [
                63.014683,
                27.224138
              ],
              [
                63.014441,
                27.223899
              ],
              [
                63.014343,
                27.223896
              ],
              [
                63.014301,
                27.223831
              ],
              [
                63.014199,
                27.223826
              ],
              [
                63.014068,
                27.223718
              ],
              [
                63.013167,
                27.223456
              ],
              [
                63.012857,
                27.223422
              ],
              [
                63.012657,
                27.223143
              ],
              [
                63.012434,
                27.223073
              ],
              [
                63.012169,
                27.223147
              ],
              [
                63.012122,
                27.223229
              ],
              [
                63.011551,
                27.223315
              ],
              [
                63.011249,
                27.223438
              ],
              [
                63.011029,
                27.223906
              ],
              [
                63.010912,
                27.223932
              ],
              [
                63.010685,
                27.223933
              ],
              [
                63.010063,
                27.223803
              ],
              [
                63.009579,
                27.223806
              ],
              [
                63.009463,
                27.223743
              ],
              [
                63.009324,
                27.223754
              ],
              [
                63.009249,
                27.223709
              ],
              [
                63.008898,
                27.223771
              ],
              [
                63.00846,
                27.223704
              ],
              [
                63.008328,
                27.223619
              ],
              [
                63.008187,
                27.223656
              ],
              [
                63.00811,
                27.223992
              ],
              [
                63.007917,
                27.223953
              ],
              [
                63.007729,
                27.223825
              ],
              [
                63.007646,
                27.223682
              ],
              [
                63.007565,
                27.223657
              ],
              [
                63.007147,
                27.223612
              ],
              [
                63.006935,
                27.223631
              ],
              [
                63.006857,
                27.223573
              ],
              [
                63.006443,
                27.223451
              ],
              [
                63.006259,
                27.223462
              ],
              [
                63.006269,
                27.223364
              ],
              [
                63.006167,
                27.223086
              ],
              [
                63.006192,
                27.22292
              ],
              [
                63.00601,
                27.22241
              ],
              [
                63.005939,
                27.222366
              ],
              [
                63.00593,
                27.222277
              ],
              [
                63.005665,
                27.221828
              ],
              [
                63.005431,
                27.221639
              ],
              [
                63.005258,
                27.221334
              ],
              [
                63.005225,
                27.221153
              ],
              [
                63.004787,
                27.221343
              ],
              [
                63.004714,
                27.221332
              ],
              [
                63.004209,
                27.221237
              ],
              [
                63.004158,
                27.22118
              ],
              [
                63.004081,
                27.221186
              ],
              [
                63.003992,
                27.221114
              ],
              [
                63.00399,
                27.22106
              ],
              [
                63.003821,
                27.221011
              ],
              [
                63.00356,
                27.221011
              ],
              [
                63.003417,
                27.22096
              ],
              [
                63.003407,
                27.220908
              ],
              [
                63.002915,
                27.220756
              ],
              [
                63.002788,
                27.22043
              ],
              [
                63.002308,
                27.220323
              ],
              [
                63.00227,
                27.220216
              ],
              [
                63.002021,
                27.220128
              ],
              [
                63.001665,
                27.219867
              ],
              [
                63.001665,
                27.219823
              ],
              [
                63.001474,
                27.219759
              ],
              [
                63.001248,
                27.219615
              ],
              [
                63.001243,
                27.219562
              ],
              [
                63.001174,
                27.21957
              ],
              [
                63.001084,
                27.219311
              ],
              [
                63.000956,
                27.219323
              ],
              [
                63.000729,
                27.219187
              ],
              [
                63.000397,
                27.218798
              ],
              [
                63.000235,
                27.218851
              ],
              [
                63.000054,
                27.219039
              ],
              [
                62.999901,
                27.219069
              ],
              [
                62.999884,
                27.219181
              ],
              [
                62.999566,
                27.21924
              ],
              [
                62.999426,
                27.219337
              ],
              [
                62.999254,
                27.219367
              ],
              [
                62.998639,
                27.219204
              ],
              [
                62.998403,
                27.219051
              ],
              [
                62.997812,
                27.21898
              ],
              [
                62.997484,
                27.218851
              ],
              [
                62.997346,
                27.218907
              ],
              [
                62.996942,
                27.218904
              ],
              [
                62.996811,
                27.218602
              ],
              [
                62.996591,
                27.218323
              ],
              [
                62.996568,
                27.21812
              ],
              [
                62.996374,
                27.218097
              ],
              [
                62.996135,
                27.217979
              ],
              [
                62.996054,
                27.21797
              ],
              [
                62.995985,
                27.21803
              ],
              [
                62.995922,
                27.217965
              ],
              [
                62.99577,
                27.217964
              ],
              [
                62.99535,
                27.217766
              ],
              [
                62.995231,
                27.217558
              ],
              [
                62.995062,
                27.217381
              ],
              [
                62.994747,
                27.217203
              ],
              [
                62.994558,
                27.217158
              ],
              [
                62.994389,
                27.216981
              ],
              [
                62.994306,
                27.216727
              ],
              [
                62.994358,
                27.216662
              ],
              [
                62.994244,
                27.216547
              ],
              [
                62.993998,
                27.216441
              ],
              [
                62.993566,
                27.216057
              ],
              [
                62.993547,
                27.215944
              ],
              [
                62.993357,
                27.215755
              ],
              [
                62.993183,
                27.215804
              ],
              [
                62.993176,
                27.215918
              ],
              [
                62.993043,
                27.216006
              ],
              [
                62.992836,
                27.216035
              ],
              [
                62.992725,
                27.216207
              ],
              [
                62.992491,
                27.216286
              ],
              [
                62.992372,
                27.216476
              ],
              [
                62.992144,
                27.216598
              ],
              [
                62.991533,
                27.216579
              ],
              [
                62.991083,
                27.216667
              ],
              [
                62.990994,
                27.2167
              ],
              [
                62.99079,
                27.21697
              ],
              [
                62.990672,
                27.217055
              ],
              [
                62.990473,
                27.217097
              ],
              [
                62.990436,
                27.217181
              ],
              [
                62.990289,
                27.217237
              ],
              [
                62.989918,
                27.217229
              ],
              [
                62.989732,
                27.217325
              ],
              [
                62.989564,
                27.217356
              ],
              [
                62.989334,
                27.217334
              ],
              [
                62.989269,
                27.217179
              ],
              [
                62.989153,
                27.217173
              ],
              [
                62.989101,
                27.217013
              ],
              [
                62.988969,
                27.216946
              ],
              [
                62.988866,
                27.216965
              ],
              [
                62.988817,
                27.216892
              ],
              [
                62.988593,
                27.216886
              ],
              [
                62.988502,
                27.216793
              ],
              [
                62.988371,
                27.216779
              ],
              [
                62.988402,
                27.216745
              ],
              [
                62.988371,
                27.216717
              ],
              [
                62.988245,
                27.216713
              ],
              [
                62.988052,
                27.2166
              ],
              [
                62.987745,
                27.216618
              ],
              [
                62.987644,
                27.216569
              ],
              [
                62.987392,
                27.216601
              ],
              [
                62.987359,
                27.216516
              ],
              [
                62.987177,
                27.216362
              ],
              [
                62.986753,
                27.216237
              ],
              [
                62.986505,
                27.216413
              ],
              [
                62.986405,
                27.216399
              ],
              [
                62.986243,
                27.216487
              ],
              [
                62.986042,
                27.216523
              ],
              [
                62.985803,
                27.216863
              ],
              [
                62.985729,
                27.217213
              ],
              [
                62.985537,
                27.217244
              ],
              [
                62.985359,
                27.217459
              ],
              [
                62.984984,
                27.217595
              ],
              [
                62.984812,
                27.217748
              ],
              [
                62.984647,
                27.218146
              ],
              [
                62.984472,
                27.218202
              ],
              [
                62.984216,
                27.21813
              ],
              [
                62.984178,
                27.218167
              ],
              [
                62.984074,
                27.218149
              ],
              [
                62.983885,
                27.218031
              ],
              [
                62.983714,
                27.217995
              ],
              [
                62.983601,
                27.218023
              ],
              [
                62.983543,
                27.21799
              ],
              [
                62.983543,
                27.217917
              ],
              [
                62.983398,
                27.217912
              ],
              [
                62.983309,
                27.217857
              ],
              [
                62.982942,
                27.217921
              ],
              [
                62.982738,
                27.217901
              ],
              [
                62.982388,
                27.217778
              ],
              [
                62.982236,
                27.217787
              ],
              [
                62.981857,
                27.217554
              ],
              [
                62.981516,
                27.217541
              ],
              [
                62.981126,
                27.217389
              ],
              [
                62.980335,
                27.217219
              ],
              [
                62.980136,
                27.217231
              ],
              [
                62.980125,
                27.21713
              ],
              [
                62.979679,
                27.216957
              ],
              [
                62.979336,
                27.216744
              ],
              [
                62.979265,
                27.216764
              ],
              [
                62.978809,
                27.216578
              ],
              [
                62.978753,
                27.216446
              ],
              [
                62.978405,
                27.216242
              ],
              [
                62.978237,
                27.21625
              ],
              [
                62.977461,
                27.21598
              ],
              [
                62.977371,
                27.215903
              ],
              [
                62.977257,
                27.215886
              ],
              [
                62.976965,
                27.216008
              ],
              [
                62.97665,
                27.216072
              ],
              [
                62.976143,
                27.216267
              ],
              [
                62.975943,
                27.216424
              ],
              [
                62.975646,
                27.216388
              ],
              [
                62.975177,
                27.216453
              ],
              [
                62.974938,
                27.21644
              ],
              [
                62.974762,
                27.216491
              ],
              [
                62.974721,
                27.216548
              ],
              [
                62.974208,
                27.216409
              ],
              [
                62.974123,
                27.216428
              ],
              [
                62.973895,
                27.216372
              ],
              [
                62.973794,
                27.21644
              ],
              [
                62.973577,
                27.216368
              ],
              [
                62.973348,
                27.216375
              ],
              [
                62.973208,
                27.216249
              ],
              [
                62.973005,
                27.216235
              ],
              [
                62.972718,
                27.215959
              ],
              [
                62.972723,
                27.21585
              ],
              [
                62.972463,
                27.215556
              ],
              [
                62.97229,
                27.215513
              ],
              [
                62.972059,
                27.215295
              ],
              [
                62.971777,
                27.215141
              ],
              [
                62.971623,
                27.214959
              ],
              [
                62.971312,
                27.214875
              ],
              [
                62.971201,
                27.214795
              ],
              [
                62.971165,
                27.214703
              ],
              [
                62.971056,
                27.214696
              ],
              [
                62.970995,
                27.214584
              ],
              [
                62.970859,
                27.214479
              ],
              [
                62.970847,
                27.214407
              ],
              [
                62.970531,
                27.214273
              ],
              [
                62.970508,
                27.214113
              ],
              [
                62.970307,
                27.214072
              ],
              [
                62.970161,
                27.21412
              ],
              [
                62.970016,
                27.213974
              ],
              [
                62.96994,
                27.213973
              ],
              [
                62.9699,
                27.213876
              ],
              [
                62.96982,
                27.213869
              ],
              [
                62.969675,
                27.213715
              ],
              [
                62.969676,
                27.213666
              ],
              [
                62.96958,
                27.213584
              ],
              [
                62.969596,
                27.213508
              ],
              [
                62.969453,
                27.213479
              ],
              [
                62.96948,
                27.213151
              ],
              [
                62.969566,
                27.213127
              ],
              [
                62.969629,
                27.212901
              ],
              [
                62.969679,
                27.212882
              ],
              [
                62.969604,
                27.212747
              ],
              [
                62.969386,
                27.212561
              ],
              [
                62.969398,
                27.212427
              ],
              [
                62.969338,
                27.212451
              ],
              [
                62.969384,
                27.212229
              ],
              [
                62.969253,
                27.212207
              ],
              [
                62.969279,
                27.212154
              ],
              [
                62.969436,
                27.212098
              ],
              [
                62.969419,
                27.211986
              ],
              [
                62.969323,
                27.211946
              ],
              [
                62.969325,
                27.211796
              ],
              [
                62.969196,
                27.211672
              ],
              [
                62.968883,
                27.21154
              ],
              [
                62.968827,
                27.211438
              ],
              [
                62.96883,
                27.211203
              ],
              [
                62.968586,
                27.210782
              ],
              [
                62.968558,
                27.21054
              ],
              [
                62.968312,
                27.210024
              ],
              [
                62.968271,
                27.2098
              ],
              [
                62.968161,
                27.209791
              ],
              [
                62.968177,
                27.209587
              ],
              [
                62.968113,
                27.209409
              ],
              [
                62.968112,
                27.209182
              ],
              [
                62.967927,
                27.208874
              ],
              [
                62.967734,
                27.208865
              ],
              [
                62.967509,
                27.20865
              ],
              [
                62.967243,
                27.208644
              ],
              [
                62.967061,
                27.208717
              ],
              [
                62.966917,
                27.208716
              ],
              [
                62.966592,
                27.208854
              ],
              [
                62.966432,
                27.209036
              ],
              [
                62.966242,
                27.209094
              ],
              [
                62.966037,
                27.209284
              ],
              [
                62.965743,
                27.209292
              ],
              [
                62.965665,
                27.20923
              ],
              [
                62.96567,
                27.209173
              ],
              [
                62.965558,
                27.209144
              ],
              [
                62.965427,
                27.209176
              ],
              [
                62.964667,
                27.209023
              ],
              [
                62.964461,
                27.208844
              ],
              [
                62.964158,
                27.208731
              ],
              [
                62.963621,
                27.208752
              ],
              [
                62.963431,
                27.208692
              ],
              [
                62.96335,
                27.208755
              ],
              [
                62.963353,
                27.208823
              ],
              [
                62.963066,
                27.208698
              ],
              [
                62.962746,
                27.208644
              ],
              [
                62.962229,
                27.208435
              ],
              [
                62.96206,
                27.208279
              ],
              [
                62.961602,
                27.208064
              ],
              [
                62.961205,
                27.207908
              ],
              [
                62.960827,
                27.207849
              ],
              [
                62.960773,
                27.207756
              ],
              [
                62.960455,
                27.207591
              ],
              [
                62.960351,
                27.207478
              ],
              [
                62.960276,
                27.207202
              ],
              [
                62.960162,
                27.207004
              ],
              [
                62.960103,
                27.206673
              ],
              [
                62.959789,
                27.206158
              ],
              [
                62.959685,
                27.206214
              ],
              [
                62.959534,
                27.206154
              ],
              [
                62.959018,
                27.206133
              ],
              [
                62.958736,
                27.205869
              ],
              [
                62.958679,
                27.205883
              ],
              [
                62.95864,
                27.20583
              ],
              [
                62.958565,
                27.205867
              ],
              [
                62.958129,
                27.205776
              ],
              [
                62.958045,
                27.205956
              ],
              [
                62.957838,
                27.205979
              ],
              [
                62.957759,
                27.205909
              ],
              [
                62.957681,
                27.205924
              ],
              [
                62.957536,
                27.205867
              ],
              [
                62.957256,
                27.20563
              ],
              [
                62.957057,
                27.205601
              ],
              [
                62.956904,
                27.205669
              ],
              [
                62.956709,
                27.205633
              ],
              [
                62.956553,
                27.205735
              ],
              [
                62.956473,
                27.205847
              ],
              [
                62.95639,
                27.205891
              ],
              [
                62.956282,
                27.205878
              ],
              [
                62.956016,
                27.206025
              ],
              [
                62.955806,
                27.20596
              ],
              [
                62.955608,
                27.205953
              ],
              [
                62.955394,
                27.206051
              ],
              [
                62.955068,
                27.20608
              ],
              [
                62.954749,
                27.206201
              ],
              [
                62.954511,
                27.206211
              ],
              [
                62.954405,
                27.20615
              ],
              [
                62.954409,
                27.206202
              ],
              [
                62.954316,
                27.206229
              ],
              [
                62.95361,
                27.206146
              ],
              [
                62.953527,
                27.20615
              ],
              [
                62.953535,
                27.206195
              ],
              [
                62.953454,
                27.206238
              ],
              [
                62.953303,
                27.206231
              ],
              [
                62.952845,
                27.205824
              ],
              [
                62.952814,
                27.205685
              ],
              [
                62.952665,
                27.205645
              ],
              [
                62.952693,
                27.205599
              ],
              [
                62.952549,
                27.205489
              ],
              [
                62.952089,
                27.205452
              ],
              [
                62.951841,
                27.205388
              ],
              [
                62.951133,
                27.205094
              ],
              [
                62.950934,
                27.205053
              ],
              [
                62.950781,
                27.204921
              ],
              [
                62.950652,
                27.20497
              ],
              [
                62.950602,
                27.20487
              ],
              [
                62.950544,
                27.204869
              ],
              [
                62.950483,
                27.204792
              ],
              [
                62.950398,
                27.204788
              ],
              [
                62.950247,
                27.204664
              ],
              [
                62.949844,
                27.204502
              ],
              [
                62.949793,
                27.204303
              ],
              [
                62.949705,
                27.204211
              ],
              [
                62.949365,
                27.204108
              ],
              [
                62.949321,
                27.204034
              ],
              [
                62.949147,
                27.203976
              ],
              [
                62.949101,
                27.203872
              ],
              [
                62.948599,
                27.203585
              ],
              [
                62.948532,
                27.203386
              ],
              [
                62.948424,
                27.20333
              ],
              [
                62.948359,
                27.203205
              ],
              [
                62.948198,
                27.203078
              ],
              [
                62.948117,
                27.202919
              ],
              [
                62.947844,
                27.202872
              ],
              [
                62.947737,
                27.202616
              ],
              [
                62.947566,
                27.202465
              ],
              [
                62.947332,
                27.202137
              ],
              [
                62.947272,
                27.202116
              ],
              [
                62.947152,
                27.201895
              ],
              [
                62.946869,
                27.201977
              ],
              [
                62.946804,
                27.202064
              ],
              [
                62.946678,
                27.202096
              ],
              [
                62.946468,
                27.202384
              ],
              [
                62.946472,
                27.202435
              ],
              [
                62.946334,
                27.202462
              ],
              [
                62.946234,
                27.202555
              ],
              [
                62.946159,
                27.202438
              ],
              [
                62.94582,
                27.202584
              ],
              [
                62.945746,
                27.202582
              ],
              [
                62.945654,
                27.202506
              ],
              [
                62.945538,
                27.20271
              ],
              [
                62.945211,
                27.202848
              ],
              [
                62.944985,
                27.203103
              ],
              [
                62.944987,
                27.203219
              ],
              [
                62.94488,
                27.203327
              ],
              [
                62.944692,
                27.203255
              ],
              [
                62.944428,
                27.203255
              ],
              [
                62.944211,
                27.203077
              ],
              [
                62.9439,
                27.203114
              ],
              [
                62.943855,
                27.203173
              ],
              [
                62.943446,
                27.20313
              ],
              [
                62.943377,
                27.203147
              ],
              [
                62.943315,
                27.203281
              ],
              [
                62.942916,
                27.203351
              ],
              [
                62.942543,
                27.203527
              ],
              [
                62.94243,
                27.203528
              ],
              [
                62.942389,
                27.203435
              ],
              [
                62.942178,
                27.203343
              ],
              [
                62.941891,
                27.203369
              ],
              [
                62.941842,
                27.203328
              ],
              [
                62.941633,
                27.203364
              ],
              [
                62.941609,
                27.203525
              ],
              [
                62.941459,
                27.203574
              ],
              [
                62.941208,
                27.203759
              ],
              [
                62.940117,
                27.203612
              ],
              [
                62.939863,
                27.203658
              ],
              [
                62.939641,
                27.203541
              ],
              [
                62.939322,
                27.203521
              ],
              [
                62.939102,
                27.203402
              ],
              [
                62.938612,
                27.203336
              ],
              [
                62.938424,
                27.203254
              ],
              [
                62.938312,
                27.202935
              ],
              [
                62.938215,
                27.202794
              ],
              [
                62.938048,
                27.202742
              ],
              [
                62.93804,
                27.202678
              ],
              [
                62.937988,
                27.202678
              ],
              [
                62.937837,
                27.202445
              ],
              [
                62.937731,
                27.202387
              ],
              [
                62.937671,
                27.202249
              ],
              [
                62.937588,
                27.202188
              ],
              [
                62.937567,
                27.202035
              ],
              [
                62.937482,
                27.202001
              ],
              [
                62.937427,
                27.201743
              ],
              [
                62.937346,
                27.2017
              ],
              [
                62.937342,
                27.201639
              ],
              [
                62.937255,
                27.201615
              ],
              [
                62.937223,
                27.201484
              ],
              [
                62.937162,
                27.201501
              ],
              [
                62.936974,
                27.20144
              ],
              [
                62.936677,
                27.201511
              ],
              [
                62.936652,
                27.201439
              ],
              [
                62.936478,
                27.201448
              ],
              [
                62.936378,
                27.201522
              ],
              [
                62.936002,
                27.201557
              ],
              [
                62.935996,
                27.201629
              ],
              [
                62.935944,
                27.201652
              ],
              [
                62.935904,
                27.201457
              ],
              [
                62.935479,
                27.201529
              ],
              [
                62.935344,
                27.201503
              ],
              [
                62.93534,
                27.20156
              ],
              [
                62.93512,
                27.201638
              ],
              [
                62.93502,
                27.201741
              ],
              [
                62.934589,
                27.201652
              ],
              [
                62.93445,
                27.201576
              ],
              [
                62.934435,
                27.201524
              ],
              [
                62.934335,
                27.201531
              ],
              [
                62.934216,
                27.201461
              ],
              [
                62.933724,
                27.201528
              ],
              [
                62.933276,
                27.2017
              ],
              [
                62.933153,
                27.201829
              ],
              [
                62.932991,
                27.201863
              ],
              [
                62.932965,
                27.202329
              ],
              [
                62.932862,
                27.202496
              ],
              [
                62.932492,
                27.20275
              ],
              [
                62.932092,
                27.202669
              ],
              [
                62.93178,
                27.202742
              ],
              [
                62.931702,
                27.202699
              ],
              [
                62.931477,
                27.20271
              ],
              [
                62.930939,
                27.203009
              ],
              [
                62.930579,
                27.202995
              ],
              [
                62.930421,
                27.203074
              ],
              [
                62.930403,
                27.203162
              ],
              [
                62.930218,
                27.203112
              ],
              [
                62.930093,
                27.203136
              ],
              [
                62.929983,
                27.202965
              ],
              [
                62.929878,
                27.202943
              ],
              [
                62.929777,
                27.202797
              ],
              [
                62.929781,
                27.202704
              ],
              [
                62.929636,
                27.202658
              ],
              [
                62.929272,
                27.202736
              ],
              [
                62.929211,
                27.202808
              ],
              [
                62.929257,
                27.203027
              ],
              [
                62.929184,
                27.2032
              ],
              [
                62.929073,
                27.203273
              ],
              [
                62.929069,
                27.203353
              ],
              [
                62.928871,
                27.203358
              ],
              [
                62.92875,
                27.203579
              ],
              [
                62.928645,
                27.203623
              ],
              [
                62.928548,
                27.20375
              ],
              [
                62.928405,
                27.203767
              ],
              [
                62.928414,
                27.203804
              ],
              [
                62.928292,
                27.203904
              ],
              [
                62.928329,
                27.203983
              ],
              [
                62.928296,
                27.204177
              ],
              [
                62.928234,
                27.204181
              ],
              [
                62.927964,
                27.204429
              ],
              [
                62.927732,
                27.204488
              ],
              [
                62.927761,
                27.204532
              ],
              [
                62.927599,
                27.204597
              ],
              [
                62.927564,
                27.204679
              ],
              [
                62.927588,
                27.204918
              ],
              [
                62.927536,
                27.204982
              ],
              [
                62.927641,
                27.20522
              ],
              [
                62.92724,
                27.205254
              ],
              [
                62.927078,
                27.205317
              ],
              [
                62.926811,
                27.205253
              ],
              [
                62.926708,
                27.205122
              ],
              [
                62.926622,
                27.205178
              ],
              [
                62.926567,
                27.205122
              ],
              [
                62.926347,
                27.205146
              ],
              [
                62.926229,
                27.205326
              ],
              [
                62.926011,
                27.205496
              ],
              [
                62.925796,
                27.205507
              ],
              [
                62.925499,
                27.205601
              ],
              [
                62.925103,
                27.205511
              ],
              [
                62.924732,
                27.205709
              ],
              [
                62.92447,
                27.206029
              ],
              [
                62.924275,
                27.206088
              ],
              [
                62.924147,
                27.206046
              ],
              [
                62.923689,
                27.206222
              ],
              [
                62.923584,
                27.20623
              ],
              [
                62.923105,
                27.206095
              ],
              [
                62.922814,
                27.205963
              ],
              [
                62.922376,
                27.206004
              ],
              [
                62.922309,
                27.205964
              ],
              [
                62.922169,
                27.206005
              ],
              [
                62.921933,
                27.205969
              ],
              [
                62.921697,
                27.205742
              ],
              [
                62.921524,
                27.205676
              ],
              [
                62.921308,
                27.205705
              ],
              [
                62.92122,
                27.205893
              ],
              [
                62.921128,
                27.205967
              ],
              [
                62.920915,
                27.205994
              ],
              [
                62.920764,
                27.206073
              ],
              [
                62.920477,
                27.206046
              ],
              [
                62.920451,
                27.206174
              ],
              [
                62.920319,
                27.206169
              ],
              [
                62.920308,
                27.206232
              ],
              [
                62.919846,
                27.206549
              ],
              [
                62.919711,
                27.206762
              ],
              [
                62.919737,
                27.20689
              ],
              [
                62.919166,
                27.207124
              ],
              [
                62.919103,
                27.207329
              ],
              [
                62.918882,
                27.207486
              ],
              [
                62.918703,
                27.207538
              ],
              [
                62.918616,
                27.20763
              ],
              [
                62.918608,
                27.207758
              ],
              [
                62.918409,
                27.207846
              ],
              [
                62.918234,
                27.208053
              ],
              [
                62.918085,
                27.208063
              ],
              [
                62.918004,
                27.208137
              ],
              [
                62.91766,
                27.208202
              ],
              [
                62.917594,
                27.208112
              ],
              [
                62.917494,
                27.208141
              ],
              [
                62.917413,
                27.20807
              ],
              [
                62.917242,
                27.208046
              ],
              [
                62.916989,
                27.208092
              ],
              [
                62.916926,
                27.207993
              ],
              [
                62.916864,
                27.208017
              ],
              [
                62.916668,
                27.207976
              ],
              [
                62.916102,
                27.208277
              ],
              [
                62.915582,
                27.208787
              ],
              [
                62.91528,
                27.20872
              ],
              [
                62.915179,
                27.208735
              ],
              [
                62.915013,
                27.20869
              ],
              [
                62.914931,
                27.20861
              ],
              [
                62.914801,
                27.208625
              ],
              [
                62.914662,
                27.208569
              ],
              [
                62.914293,
                27.208603
              ],
              [
                62.914237,
                27.208565
              ],
              [
                62.913883,
                27.208576
              ],
              [
                62.913846,
                27.208768
              ],
              [
                62.913651,
                27.20883
              ],
              [
                62.913582,
                27.208897
              ],
              [
                62.913583,
                27.208969
              ],
              [
                62.913286,
                27.209094
              ],
              [
                62.913105,
                27.209093
              ],
              [
                62.912973,
                27.209174
              ],
              [
                62.912965,
                27.209238
              ],
              [
                62.9128,
                27.209387
              ],
              [
                62.912607,
                27.2095
              ],
              [
                62.912452,
                27.209721
              ],
              [
                62.912198,
                27.209841
              ],
              [
                62.912101,
                27.209937
              ],
              [
                62.91207,
                27.210045
              ],
              [
                62.912152,
                27.210145
              ],
              [
                62.912141,
                27.210241
              ],
              [
                62.91227,
                27.210384
              ],
              [
                62.912214,
                27.210518
              ],
              [
                62.911833,
                27.210729
              ],
              [
                62.91186,
                27.21095
              ],
              [
                62.911733,
                27.211316
              ],
              [
                62.911791,
                27.211545
              ],
              [
                62.911665,
                27.211654
              ],
              [
                62.911633,
                27.21192
              ],
              [
                62.911377,
                27.212116
              ],
              [
                62.911299,
                27.212279
              ],
              [
                62.911491,
                27.212702
              ],
              [
                62.911746,
                27.212928
              ],
              [
                62.911563,
                27.21318
              ],
              [
                62.911556,
                27.21342
              ],
              [
                62.911205,
                27.213601
              ],
              [
                62.911111,
                27.213774
              ],
              [
                62.910629,
                27.21412
              ],
              [
                62.910663,
                27.21442
              ],
              [
                62.910769,
                27.214498
              ],
              [
                62.910971,
                27.214478
              ],
              [
                62.910989,
                27.214543
              ],
              [
                62.910818,
                27.21468
              ],
              [
                62.910685,
                27.214726
              ],
              [
                62.91062,
                27.214833
              ],
              [
                62.91075,
                27.214915
              ],
              [
                62.910619,
                27.214928
              ],
              [
                62.910492,
                27.214998
              ],
              [
                62.910293,
                27.214984
              ],
              [
                62.910074,
                27.215249
              ],
              [
                62.909838,
                27.21532
              ],
              [
                62.909626,
                27.215536
              ],
              [
                62.909517,
                27.215518
              ],
              [
                62.909425,
                27.215121
              ],
              [
                62.909333,
                27.215096
              ],
              [
                62.909265,
                27.21499
              ],
              [
                62.909115,
                27.214934
              ],
              [
                62.90864,
                27.215048
              ],
              [
                62.908524,
                27.214992
              ],
              [
                62.908313,
                27.215116
              ],
              [
                62.907952,
                27.215211
              ],
              [
                62.907697,
                27.215199
              ],
              [
                62.907637,
                27.215136
              ],
              [
                62.907423,
                27.215149
              ],
              [
                62.907096,
                27.215324
              ],
              [
                62.906539,
                27.215293
              ],
              [
                62.90649,
                27.215209
              ],
              [
                62.906031,
                27.215325
              ],
              [
                62.905822,
                27.215298
              ],
              [
                62.905596,
                27.215413
              ],
              [
                62.90555,
                27.215491
              ],
              [
                62.905522,
                27.215454
              ],
              [
                62.905462,
                27.21554
              ],
              [
                62.905105,
                27.215656
              ],
              [
                62.905056,
                27.215581
              ],
              [
                62.905056,
                27.215345
              ],
              [
                62.904924,
                27.215211
              ],
              [
                62.90466,
                27.215074
              ],
              [
                62.904252,
                27.214946
              ],
              [
                62.903911,
                27.214948
              ],
              [
                62.903643,
                27.215039
              ],
              [
                62.903347,
                27.214858
              ],
              [
                62.902813,
                27.214792
              ],
              [
                62.902733,
                27.214821
              ],
              [
                62.902514,
                27.214641
              ],
              [
                62.902061,
                27.214554
              ],
              [
                62.902005,
                27.2145
              ],
              [
                62.901797,
                27.214538
              ],
              [
                62.90169,
                27.214604
              ],
              [
                62.90155,
                27.214565
              ],
              [
                62.901299,
                27.21461
              ],
              [
                62.901217,
                27.214519
              ],
              [
                62.901142,
                27.214169
              ],
              [
                62.90094,
                27.21404
              ],
              [
                62.900949,
                27.213959
              ],
              [
                62.90102,
                27.213894
              ],
              [
                62.90101,
                27.213813
              ],
              [
                62.90095,
                27.21381
              ],
              [
                62.900805,
                27.213677
              ],
              [
                62.900726,
                27.213428
              ],
              [
                62.900492,
                27.213428
              ],
              [
                62.900014,
                27.213269
              ],
              [
                62.89984,
                27.213276
              ],
              [
                62.8997,
                27.213486
              ],
              [
                62.899569,
                27.213466
              ],
              [
                62.899469,
                27.213397
              ],
              [
                62.898933,
                27.213349
              ],
              [
                62.89854,
                27.213263
              ],
              [
                62.898497,
                27.213215
              ],
              [
                62.898044,
                27.21314
              ],
              [
                62.897834,
                27.21317
              ],
              [
                62.897817,
                27.213314
              ],
              [
                62.897723,
                27.213402
              ],
              [
                62.897638,
                27.213299
              ],
              [
                62.897295,
                27.213268
              ],
              [
                62.896931,
                27.213335
              ],
              [
                62.896751,
                27.213294
              ],
              [
                62.896752,
                27.213349
              ],
              [
                62.896659,
                27.213379
              ],
              [
                62.896593,
                27.213333
              ],
              [
                62.89638,
                27.213363
              ],
              [
                62.896076,
                27.213306
              ],
              [
                62.895958,
                27.213254
              ],
              [
                62.895967,
                27.213204
              ],
              [
                62.895397,
                27.213141
              ],
              [
                62.895249,
                27.213214
              ],
              [
                62.894996,
                27.213175
              ],
              [
                62.89468,
                27.213201
              ],
              [
                62.894402,
                27.213153
              ],
              [
                62.894363,
                27.213007
              ],
              [
                62.894227,
                27.212824
              ],
              [
                62.893863,
                27.212693
              ],
              [
                62.89376,
                27.212779
              ],
              [
                62.893745,
                27.212887
              ],
              [
                62.893665,
                27.212892
              ],
              [
                62.893556,
                27.212971
              ],
              [
                62.893283,
                27.213011
              ],
              [
                62.893227,
                27.213117
              ],
              [
                62.893148,
                27.213125
              ],
              [
                62.893057,
                27.213352
              ],
              [
                62.892324,
                27.213176
              ],
              [
                62.892261,
                27.213186
              ],
              [
                62.89225,
                27.213278
              ],
              [
                62.891922,
                27.213189
              ],
              [
                62.891737,
                27.213202
              ],
              [
                62.891437,
                27.213112
              ],
              [
                62.890948,
                27.213105
              ],
              [
                62.890759,
                27.213296
              ],
              [
                62.890746,
                27.213339
              ],
              [
                62.890789,
                27.213354
              ],
              [
                62.890389,
                27.213507
              ],
              [
                62.890394,
                27.213655
              ],
              [
                62.890342,
                27.213734
              ],
              [
                62.890213,
                27.213795
              ],
              [
                62.890036,
                27.214038
              ],
              [
                62.890005,
                27.214155
              ],
              [
                62.889873,
                27.214133
              ],
              [
                62.889773,
                27.214291
              ],
              [
                62.889536,
                27.214383
              ],
              [
                62.889416,
                27.214567
              ],
              [
                62.88928,
                27.214675
              ],
              [
                62.889197,
                27.214967
              ],
              [
                62.889255,
                27.215099
              ],
              [
                62.889182,
                27.21524
              ],
              [
                62.889196,
                27.215318
              ],
              [
                62.888822,
                27.215373
              ],
              [
                62.888663,
                27.215464
              ],
              [
                62.888522,
                27.21568
              ],
              [
                62.888552,
                27.215803
              ],
              [
                62.888471,
                27.216018
              ],
              [
                62.888504,
                27.216155
              ],
              [
                62.888397,
                27.216232
              ],
              [
                62.888314,
                27.216427
              ],
              [
                62.888192,
                27.216432
              ],
              [
                62.888068,
                27.216558
              ],
              [
                62.887924,
                27.216622
              ],
              [
                62.887526,
                27.216708
              ],
              [
                62.887314,
                27.216669
              ],
              [
                62.887142,
                27.216575
              ],
              [
                62.886578,
                27.216475
              ],
              [
                62.886276,
                27.216848
              ],
              [
                62.885989,
                27.216949
              ],
              [
                62.885909,
                27.217027
              ],
              [
                62.885892,
                27.217228
              ],
              [
                62.88574,
                27.217182
              ],
              [
                62.885461,
                27.217177
              ],
              [
                62.885402,
                27.217095
              ],
              [
                62.885328,
                27.217083
              ],
              [
                62.885311,
                27.217014
              ],
              [
                62.885194,
                27.217008
              ],
              [
                62.885207,
                27.216963
              ],
              [
                62.884884,
                27.216896
              ],
              [
                62.884443,
                27.216879
              ],
              [
                62.884115,
                27.216931
              ],
              [
                62.883939,
                27.217017
              ],
              [
                62.883666,
                27.217432
              ],
              [
                62.883435,
                27.21757
              ],
              [
                62.883016,
                27.218023
              ],
              [
                62.882811,
                27.218074
              ],
              [
                62.882599,
                27.218203
              ],
              [
                62.882545,
                27.21839
              ],
              [
                62.882354,
                27.218497
              ],
              [
                62.882367,
                27.218607
              ],
              [
                62.882315,
                27.21867
              ],
              [
                62.882081,
                27.21873
              ],
              [
                62.881924,
                27.218849
              ],
              [
                62.88187,
                27.219037
              ],
              [
                62.881799,
                27.219112
              ],
              [
                62.882055,
                27.219229
              ],
              [
                62.882126,
                27.219355
              ],
              [
                62.882198,
                27.21974
              ],
              [
                62.882085,
                27.22008
              ],
              [
                62.882021,
                27.22014
              ],
              [
                62.882063,
                27.220162
              ],
              [
                62.882041,
                27.220277
              ],
              [
                62.881946,
                27.220316
              ],
              [
                62.882099,
                27.220502
              ],
              [
                62.882311,
                27.220601
              ],
              [
                62.882466,
                27.220765
              ],
              [
                62.882472,
                27.220851
              ],
              [
                62.882606,
                27.22096
              ],
              [
                62.882516,
                27.221056
              ],
              [
                62.88253,
                27.221198
              ],
              [
                62.882542,
                27.221289
              ],
              [
                62.882618,
                27.22129
              ],
              [
                62.88261,
                27.221342
              ],
              [
                62.882678,
                27.221376
              ],
              [
                62.882657,
                27.22142
              ],
              [
                62.882293,
                27.221535
              ],
              [
                62.882211,
                27.221501
              ],
              [
                62.882051,
                27.221563
              ],
              [
                62.882014,
                27.221532
              ],
              [
                62.88143,
                27.221576
              ],
              [
                62.880972,
                27.221662
              ],
              [
                62.880771,
                27.221631
              ],
              [
                62.880706,
                27.221698
              ],
              [
                62.880621,
                27.221682
              ],
              [
                62.880546,
                27.22172
              ],
              [
                62.880475,
                27.221913
              ],
              [
                62.880261,
                27.222099
              ],
              [
                62.880128,
                27.222284
              ],
              [
                62.880174,
                27.222537
              ],
              [
                62.879757,
                27.22265
              ],
              [
                62.879713,
                27.222878
              ],
              [
                62.879652,
                27.222888
              ],
              [
                62.879566,
                27.223041
              ],
              [
                62.879422,
                27.223103
              ],
              [
                62.87944,
                27.223255
              ],
              [
                62.879329,
                27.22351
              ],
              [
                62.879368,
                27.223538
              ],
              [
                62.879358,
                27.223895
              ],
              [
                62.87912,
                27.223894
              ],
              [
                62.878789,
                27.224096
              ],
              [
                62.878469,
                27.224203
              ],
              [
                62.878325,
                27.224148
              ],
              [
                62.878253,
                27.224067
              ],
              [
                62.878168,
                27.224085
              ],
              [
                62.878102,
                27.224039
              ],
              [
                62.877686,
                27.224473
              ],
              [
                62.877635,
                27.22464
              ],
              [
                62.877663,
                27.224947
              ],
              [
                62.877516,
                27.225184
              ],
              [
                62.877638,
                27.225457
              ],
              [
                62.877749,
                27.225505
              ],
              [
                62.877792,
                27.225595
              ],
              [
                62.877756,
                27.225822
              ],
              [
                62.87763,
                27.226035
              ],
              [
                62.877692,
                27.226128
              ],
              [
                62.877642,
                27.226142
              ],
              [
                62.877641,
                27.226231
              ],
              [
                62.877487,
                27.226318
              ],
              [
                62.877297,
                27.226292
              ],
              [
                62.877124,
                27.226377
              ],
              [
                62.87707,
                27.226523
              ],
              [
                62.876971,
                27.22661
              ],
              [
                62.876997,
                27.226706
              ],
              [
                62.876801,
                27.226771
              ],
              [
                62.876734,
                27.227004
              ],
              [
                62.876609,
                27.227072
              ],
              [
                62.876582,
                27.227141
              ],
              [
                62.876474,
                27.22714
              ],
              [
                62.876438,
                27.227046
              ],
              [
                62.876115,
                27.226966
              ],
              [
                62.875914,
                27.227033
              ],
              [
                62.875657,
                27.227225
              ],
              [
                62.875728,
                27.227485
              ],
              [
                62.875447,
                27.227581
              ],
              [
                62.875338,
                27.2277
              ],
              [
                62.875343,
                27.227818
              ],
              [
                62.875024,
                27.227919
              ],
              [
                62.874942,
                27.228035
              ],
              [
                62.874639,
                27.22821
              ],
              [
                62.874354,
                27.22823
              ],
              [
                62.874285,
                27.22811
              ],
              [
                62.873776,
                27.228441
              ],
              [
                62.873709,
                27.228629
              ],
              [
                62.873439,
                27.228732
              ],
              [
                62.873169,
                27.228774
              ],
              [
                62.873027,
                27.228859
              ],
              [
                62.872937,
                27.228824
              ],
              [
                62.872808,
                27.228669
              ],
              [
                62.872716,
                27.228475
              ],
              [
                62.872753,
                27.228272
              ],
              [
                62.872632,
                27.228074
              ],
              [
                62.872484,
                27.227951
              ],
              [
                62.87238,
                27.227753
              ],
              [
                62.872217,
                27.227695
              ],
              [
                62.871941,
                27.227399
              ],
              [
                62.871808,
                27.227146
              ],
              [
                62.87183,
                27.227084
              ],
              [
                62.871743,
                27.22677
              ],
              [
                62.871675,
                27.226749
              ],
              [
                62.871449,
                27.226886
              ],
              [
                62.8713,
                27.226673
              ],
              [
                62.871105,
                27.226635
              ],
              [
                62.87108,
                27.226511
              ],
              [
                62.870977,
                27.226543
              ],
              [
                62.870868,
                27.226489
              ],
              [
                62.870763,
                27.226511
              ],
              [
                62.87066,
                27.226434
              ],
              [
                62.870382,
                27.226472
              ],
              [
                62.870259,
                27.226387
              ],
              [
                62.869947,
                27.226414
              ],
              [
                62.869835,
                27.226386
              ],
              [
                62.869651,
                27.226243
              ],
              [
                62.869458,
                27.226261
              ],
              [
                62.869386,
                27.22617
              ],
              [
                62.869337,
                27.226185
              ],
              [
                62.869204,
                27.226068
              ],
              [
                62.869073,
                27.226035
              ],
              [
                62.869017,
                27.226089
              ],
              [
                62.86862,
                27.226191
              ],
              [
                62.868438,
                27.226145
              ],
              [
                62.868014,
                27.226144
              ],
              [
                62.867984,
                27.226086
              ],
              [
                62.867843,
                27.226076
              ],
              [
                62.867718,
                27.225984
              ],
              [
                62.86766,
                27.225995
              ],
              [
                62.867642,
                27.225894
              ],
              [
                62.867592,
                27.225884
              ],
              [
                62.867526,
                27.225751
              ],
              [
                62.867475,
                27.225766
              ],
              [
                62.867433,
                27.225678
              ],
              [
                62.867089,
                27.225516
              ],
              [
                62.867052,
                27.22556
              ],
              [
                62.866992,
                27.225505
              ],
              [
                62.866889,
                27.225517
              ],
              [
                62.866817,
                27.225333
              ],
              [
                62.866752,
                27.225326
              ],
              [
                62.866767,
                27.225266
              ],
              [
                62.866646,
                27.225235
              ],
              [
                62.866578,
                27.225089
              ],
              [
                62.866342,
                27.224961
              ],
              [
                62.865635,
                27.224934
              ],
              [
                62.865584,
                27.224805
              ],
              [
                62.865731,
                27.224646
              ],
              [
                62.86555,
                27.224604
              ],
              [
                62.865575,
                27.224542
              ],
              [
                62.865528,
                27.224511
              ],
              [
                62.865574,
                27.224361
              ],
              [
                62.865725,
                27.224163
              ],
              [
                62.865802,
                27.223875
              ],
              [
                62.865816,
                27.2235
              ],
              [
                62.865878,
                27.223472
              ],
              [
                62.865749,
                27.223273
              ],
              [
                62.865422,
                27.223113
              ],
              [
                62.865243,
                27.22297
              ],
              [
                62.865017,
                27.222924
              ],
              [
                62.864869,
                27.22269
              ],
              [
                62.86485,
                27.222619
              ],
              [
                62.864896,
                27.222559
              ],
              [
                62.864794,
                27.222459
              ],
              [
                62.864649,
                27.222448
              ],
              [
                62.864615,
                27.222361
              ],
              [
                62.864474,
                27.222396
              ],
              [
                62.864563,
                27.222264
              ],
              [
                62.864519,
                27.222163
              ],
              [
                62.864546,
                27.222113
              ],
              [
                62.864383,
                27.222014
              ],
              [
                62.864372,
                27.221833
              ],
              [
                62.864106,
                27.221395
              ],
              [
                62.863998,
                27.221399
              ],
              [
                62.863852,
                27.221292
              ],
              [
                62.863004,
                27.221133
              ],
              [
                62.862994,
                27.221047
              ],
              [
                62.862533,
                27.220977
              ],
              [
                62.862535,
                27.220897
              ],
              [
                62.862485,
                27.220873
              ],
              [
                62.862436,
                27.220732
              ],
              [
                62.862259,
                27.220708
              ],
              [
                62.862045,
                27.220742
              ],
              [
                62.861966,
                27.220728
              ],
              [
                62.861911,
                27.220662
              ],
              [
                62.861793,
                27.220674
              ],
              [
                62.861781,
                27.220615
              ],
              [
                62.861533,
                27.2206
              ],
              [
                62.861452,
                27.220479
              ],
              [
                62.861355,
                27.220425
              ],
              [
                62.861331,
                27.220311
              ],
              [
                62.861103,
                27.220284
              ],
              [
                62.861087,
                27.220204
              ],
              [
                62.860846,
                27.220233
              ],
              [
                62.860623,
                27.220146
              ],
              [
                62.860445,
                27.22013
              ],
              [
                62.860307,
                27.220168
              ],
              [
                62.859976,
                27.220039
              ],
              [
                62.859748,
                27.220006
              ],
              [
                62.859797,
                27.219894
              ],
              [
                62.859756,
                27.219753
              ],
              [
                62.859788,
                27.219566
              ],
              [
                62.859858,
                27.219528
              ],
              [
                62.85973,
                27.219495
              ],
              [
                62.859141,
                27.219422
              ],
              [
                62.858944,
                27.219346
              ],
              [
                62.858667,
                27.219308
              ],
              [
                62.858423,
                27.21937
              ],
              [
                62.85803,
                27.219389
              ],
              [
                62.857817,
                27.219491
              ],
              [
                62.85776,
                27.219595
              ],
              [
                62.85752,
                27.219603
              ],
              [
                62.85742,
                27.219648
              ],
              [
                62.857156,
                27.21961
              ],
              [
                62.856903,
                27.219643
              ],
              [
                62.856947,
                27.219596
              ],
              [
                62.856476,
                27.219374
              ],
              [
                62.856311,
                27.219209
              ],
              [
                62.85603,
                27.219103
              ],
              [
                62.856004,
                27.218991
              ],
              [
                62.85588,
                27.218922
              ],
              [
                62.855808,
                27.218799
              ],
              [
                62.855751,
                27.218798
              ],
              [
                62.855641,
                27.21867
              ],
              [
                62.855571,
                27.218348
              ],
              [
                62.855387,
                27.218216
              ],
              [
                62.855411,
                27.218131
              ],
              [
                62.855362,
                27.218079
              ],
              [
                62.855368,
                27.21797
              ],
              [
                62.85542,
                27.217889
              ],
              [
                62.855343,
                27.217784
              ],
              [
                62.855269,
                27.217783
              ],
              [
                62.855183,
                27.217655
              ],
              [
                62.8551,
                27.217646
              ],
              [
                62.854966,
                27.217429
              ],
              [
                62.854908,
                27.217427
              ],
              [
                62.854885,
                27.217327
              ],
              [
                62.854936,
                27.217278
              ],
              [
                62.854795,
                27.217202
              ],
              [
                62.85455,
                27.216813
              ],
              [
                62.85445,
                27.216824
              ],
              [
                62.854273,
                27.216732
              ],
              [
                62.854288,
                27.216673
              ],
              [
                62.854239,
                27.216641
              ],
              [
                62.85412,
                27.216651
              ],
              [
                62.854038,
                27.216593
              ],
              [
                62.853423,
                27.216692
              ],
              [
                62.85325,
                27.216595
              ],
              [
                62.853223,
                27.216534
              ],
              [
                62.852957,
                27.216444
              ],
              [
                62.852469,
                27.216507
              ],
              [
                62.852438,
                27.216445
              ],
              [
                62.852373,
                27.216435
              ],
              [
                62.85208,
                27.216455
              ],
              [
                62.85203,
                27.216289
              ],
              [
                62.851761,
                27.216163
              ],
              [
                62.851698,
                27.216177
              ],
              [
                62.85167,
                27.216102
              ],
              [
                62.851586,
                27.216114
              ],
              [
                62.851504,
                27.21601
              ],
              [
                62.851329,
                27.216028
              ],
              [
                62.851177,
                27.215997
              ],
              [
                62.851141,
                27.215945
              ],
              [
                62.851034,
                27.215948
              ],
              [
                62.850829,
                27.21603
              ],
              [
                62.850606,
                27.21599
              ],
              [
                62.8505,
                27.216061
              ],
              [
                62.850262,
                27.216104
              ],
              [
                62.850162,
                27.216284
              ],
              [
                62.85001,
                27.216319
              ],
              [
                62.849707,
                27.21653
              ],
              [
                62.849175,
                27.216809
              ],
              [
                62.849075,
                27.216754
              ],
              [
                62.848861,
                27.216762
              ],
              [
                62.848812,
                27.21672
              ],
              [
                62.848701,
                27.21674
              ],
              [
                62.848627,
                27.216705
              ],
              [
                62.848421,
                27.216871
              ],
              [
                62.848173,
                27.216801
              ],
              [
                62.848027,
                27.216841
              ],
              [
                62.847959,
                27.2168
              ],
              [
                62.847857,
                27.216834
              ],
              [
                62.847487,
                27.216805
              ],
              [
                62.847107,
                27.217002
              ],
              [
                62.846629,
                27.217076
              ],
              [
                62.846546,
                27.217026
              ],
              [
                62.846475,
                27.217059
              ],
              [
                62.846441,
                27.216957
              ],
              [
                62.84631,
                27.216949
              ],
              [
                62.845953,
                27.216756
              ],
              [
                62.845701,
                27.216936
              ],
              [
                62.84564,
                27.21711
              ],
              [
                62.845315,
                27.217206
              ],
              [
                62.845258,
                27.21731
              ],
              [
                62.845278,
                27.217633
              ],
              [
                62.845179,
                27.217703
              ],
              [
                62.845048,
                27.217648
              ],
              [
                62.844816,
                27.217737
              ],
              [
                62.844723,
                27.217833
              ],
              [
                62.844608,
                27.217826
              ],
              [
                62.844436,
                27.218124
              ],
              [
                62.844187,
                27.218164
              ],
              [
                62.844137,
                27.218273
              ],
              [
                62.843453,
                27.218375
              ],
              [
                62.843408,
                27.2184
              ],
              [
                62.843409,
                27.218571
              ],
              [
                62.843174,
                27.218489
              ],
              [
                62.843058,
                27.218355
              ],
              [
                62.843076,
                27.218318
              ],
              [
                62.842842,
                27.218186
              ],
              [
                62.842719,
                27.218244
              ],
              [
                62.842341,
                27.218274
              ],
              [
                62.842164,
                27.218213
              ],
              [
                62.841961,
                27.218356
              ],
              [
                62.841888,
                27.218328
              ],
              [
                62.841834,
                27.218355
              ],
              [
                62.841676,
                27.218268
              ],
              [
                62.841578,
                27.218276
              ],
              [
                62.841536,
                27.218162
              ],
              [
                62.841434,
                27.218144
              ],
              [
                62.841354,
                27.218071
              ],
              [
                62.841179,
                27.218032
              ],
              [
                62.840908,
                27.218067
              ],
              [
                62.840808,
                27.218034
              ],
              [
                62.840597,
                27.218055
              ],
              [
                62.840657,
                27.218196
              ],
              [
                62.840631,
                27.218465
              ],
              [
                62.84047,
                27.218454
              ],
              [
                62.840407,
                27.218668
              ],
              [
                62.840029,
                27.218449
              ],
              [
                62.84008,
                27.218318
              ],
              [
                62.839966,
                27.21817
              ],
              [
                62.839959,
                27.217939
              ],
              [
                62.839442,
                27.217734
              ],
              [
                62.839318,
                27.217722
              ],
              [
                62.839325,
                27.217628
              ],
              [
                62.839151,
                27.21764
              ],
              [
                62.839041,
                27.217309
              ],
              [
                62.83856,
                27.217122
              ],
              [
                62.838216,
                27.216923
              ],
              [
                62.838154,
                27.216953
              ],
              [
                62.838121,
                27.217057
              ],
              [
                62.837989,
                27.217067
              ],
              [
                62.837949,
                27.217241
              ],
              [
                62.837739,
                27.217435
              ],
              [
                62.837377,
                27.217364
              ],
              [
                62.837077,
                27.217429
              ],
              [
                62.836912,
                27.2174
              ],
              [
                62.836731,
                27.217436
              ],
              [
                62.836645,
                27.217508
              ],
              [
                62.836501,
                27.217768
              ],
              [
                62.836388,
                27.217812
              ],
              [
                62.836285,
                27.217757
              ],
              [
                62.836002,
                27.217716
              ],
              [
                62.83482,
                27.217193
              ],
              [
                62.834716,
                27.217199
              ],
              [
                62.834534,
                27.217029
              ],
              [
                62.834267,
                27.217047
              ],
              [
                62.833949,
                27.217158
              ],
              [
                62.833706,
                27.217043
              ],
              [
                62.833521,
                27.217364
              ],
              [
                62.833364,
                27.217528
              ],
              [
                62.833251,
                27.217415
              ],
              [
                62.833116,
                27.217369
              ],
              [
                62.833038,
                27.217484
              ],
              [
                62.832731,
                27.217565
              ],
              [
                62.832644,
                27.217633
              ],
              [
                62.832668,
                27.217791
              ],
              [
                62.832633,
                27.217822
              ],
              [
                62.832268,
                27.217735
              ],
              [
                62.832185,
                27.217752
              ],
              [
                62.832163,
                27.217802
              ],
              [
                62.832096,
                27.217755
              ],
              [
                62.831605,
                27.217814
              ],
              [
                62.831488,
                27.218145
              ],
              [
                62.831501,
                27.21838
              ],
              [
                62.831311,
                27.218634
              ],
              [
                62.831053,
                27.218767
              ],
              [
                62.830508,
                27.218802
              ],
              [
                62.830273,
                27.21893
              ],
              [
                62.829586,
                27.218576
              ],
              [
                62.829489,
                27.218656
              ],
              [
                62.829435,
                27.21865
              ],
              [
                62.829351,
                27.21854
              ],
              [
                62.829052,
                27.218422
              ],
              [
                62.828796,
                27.218416
              ],
              [
                62.828739,
                27.218635
              ],
              [
                62.828783,
                27.218754
              ],
              [
                62.828697,
                27.218756
              ],
              [
                62.828624,
                27.219005
              ],
              [
                62.828229,
                27.218917
              ],
              [
                62.828078,
                27.21899
              ],
              [
                62.827284,
                27.219184
              ],
              [
                62.827062,
                27.219104
              ],
              [
                62.827033,
                27.219048
              ],
              [
                62.826477,
                27.219045
              ],
              [
                62.826292,
                27.219008
              ],
              [
                62.826022,
                27.219115
              ],
              [
                62.825713,
                27.219167
              ],
              [
                62.825527,
                27.219326
              ],
              [
                62.825488,
                27.219316
              ],
              [
                62.825503,
                27.219235
              ],
              [
                62.825118,
                27.219388
              ],
              [
                62.825081,
                27.219346
              ],
              [
                62.824988,
                27.219394
              ],
              [
                62.824865,
                27.219378
              ],
              [
                62.824835,
                27.219563
              ],
              [
                62.824711,
                27.219685
              ],
              [
                62.824618,
                27.219637
              ],
              [
                62.824508,
                27.219648
              ],
              [
                62.824543,
                27.219608
              ],
              [
                62.824503,
                27.219583
              ],
              [
                62.824133,
                27.219465
              ],
              [
                62.824127,
                27.219373
              ],
              [
                62.824024,
                27.21935
              ],
              [
                62.823983,
                27.219253
              ],
              [
                62.823777,
                27.219263
              ],
              [
                62.823708,
                27.219183
              ],
              [
                62.823568,
                27.219213
              ],
              [
                62.823607,
                27.219109
              ],
              [
                62.823562,
                27.219044
              ],
              [
                62.823339,
                27.218958
              ],
              [
                62.823325,
                27.218885
              ],
              [
                62.823068,
                27.21889
              ],
              [
                62.822616,
                27.218703
              ],
              [
                62.822517,
                27.218598
              ],
              [
                62.822134,
                27.218524
              ],
              [
                62.821877,
                27.218349
              ],
              [
                62.821754,
                27.218411
              ],
              [
                62.821409,
                27.218373
              ],
              [
                62.821313,
                27.218438
              ],
              [
                62.821108,
                27.218471
              ],
              [
                62.820731,
                27.218458
              ],
              [
                62.820704,
                27.218555
              ],
              [
                62.820559,
                27.218665
              ],
              [
                62.820482,
                27.218853
              ],
              [
                62.820521,
                27.21901
              ],
              [
                62.820296,
                27.219137
              ],
              [
                62.820322,
                27.219202
              ],
              [
                62.82028,
                27.21937
              ],
              [
                62.82008,
                27.219715
              ],
              [
                62.819565,
                27.219598
              ],
              [
                62.819501,
                27.219641
              ],
              [
                62.819356,
                27.219574
              ],
              [
                62.819295,
                27.219624
              ],
              [
                62.819035,
                27.219595
              ],
              [
                62.81895,
                27.219704
              ],
              [
                62.818693,
                27.219765
              ],
              [
                62.818569,
                27.220039
              ],
              [
                62.818362,
                27.220169
              ],
              [
                62.818024,
                27.220218
              ],
              [
                62.817944,
                27.220295
              ],
              [
                62.817736,
                27.220349
              ],
              [
                62.817698,
                27.22051
              ],
              [
                62.817532,
                27.220577
              ],
              [
                62.817422,
                27.220826
              ],
              [
                62.817175,
                27.220819
              ],
              [
                62.816901,
                27.220908
              ],
              [
                62.816668,
                27.221135
              ],
              [
                62.816682,
                27.221215
              ],
              [
                62.816605,
                27.221314
              ],
              [
                62.816429,
                27.221371
              ],
              [
                62.816199,
                27.221345
              ],
              [
                62.816024,
                27.221427
              ],
              [
                62.815935,
                27.221555
              ],
              [
                62.815766,
                27.221464
              ],
              [
                62.815753,
                27.221551
              ],
              [
                62.815656,
                27.22154
              ],
              [
                62.815392,
                27.221639
              ],
              [
                62.815079,
                27.221865
              ],
              [
                62.815049,
                27.222206
              ],
              [
                62.81496,
                27.222221
              ],
              [
                62.814807,
                27.222342
              ],
              [
                62.814695,
                27.222335
              ],
              [
                62.814363,
                27.222424
              ],
              [
                62.813845,
                27.222436
              ],
              [
                62.813405,
                27.222615
              ],
              [
                62.81346,
                27.222704
              ],
              [
                62.813402,
                27.222746
              ],
              [
                62.813159,
                27.222777
              ],
              [
                62.813004,
                27.222901
              ],
              [
                62.812778,
                27.222882
              ],
              [
                62.812598,
                27.223099
              ],
              [
                62.812076,
                27.223107
              ],
              [
                62.812026,
                27.223116
              ],
              [
                62.812027,
                27.223188
              ],
              [
                62.811844,
                27.223151
              ],
              [
                62.811744,
                27.22324
              ],
              [
                62.811715,
                27.223397
              ],
              [
                62.811622,
                27.223436
              ],
              [
                62.811459,
                27.223618
              ],
              [
                62.811264,
                27.223717
              ],
              [
                62.811258,
                27.223757
              ],
              [
                62.811383,
                27.223742
              ],
              [
                62.811203,
                27.223891
              ],
              [
                62.811015,
                27.22391
              ],
              [
                62.810723,
                27.224169
              ],
              [
                62.81069,
                27.224254
              ],
              [
                62.810727,
                27.224364
              ],
              [
                62.810974,
                27.224842
              ],
              [
                62.810369,
                27.225245
              ],
              [
                62.8100993,
                27.22505
              ],
              [
                62.7949457,
                27.22922
              ],
              [
                62.7769609,
                27.2320374
              ],
              [
                62.7621907,
                27.2317962
              ],
              [
                62.7509045,
                27.2307477
              ],
              [
                62.7402308,
                27.2311868
              ],
              [
                62.7250966,
                27.2316448
              ],
              [
                62.7103852,
                27.2314269
              ],
              [
                62.7083097,
                27.2314433
              ],
              [
                62.701148,
                27.2315
              ],
              [
                62.6943097,
                27.2319314
              ],
              [
                62.6864609,
                27.2342935
              ],
              [
                62.6721525,
                27.2410089
              ],
              [
                62.6623708,
                27.2471651
              ],
              [
                62.6589568,
                27.248305
              ],
              [
                62.6515959,
                27.2558506
              ],
              [
                62.6404379,
                27.2647011
              ],
              [
                62.6246451,
                27.273551
              ],
              [
                62.6026011,
                27.2811227
              ],
              [
                62.5858009,
                27.2897436
              ],
              [
                62.5760094,
                27.2953927
              ],
              [
                62.5604061,
                27.3124439
              ],
              [
                62.5016047,
                27.3533267
              ],
              [
                62.4769719,
                27.3814987
              ],
              [
                62.5116626,
                27.4308368
              ],
              [
                62.5228497,
                27.4534466
              ],
              [
                62.5446509,
                27.4823853
              ],
              [
                62.5532498,
                27.5012549
              ],
              [
                62.5520362,
                27.5181761
              ],
              [
                62.552761,
                27.5324754
              ],
              [
                62.5607748,
                27.5506956
              ],
              [
                62.5652896,
                27.5606486
              ],
              [
                62.5682275,
                27.5671118
              ],
              [
                62.5703464,
                27.5724252
              ],
              [
                62.533836,
                27.5904582
              ],
              [
                62.4830243,
                27.6211862
              ],
              [
                62.4267193,
                27.659508
              ],
              [
                62.3917004,
                27.6841364
              ],
              [
                62.3618313,
                27.7063276
              ],
              [
                62.3233792,
                27.7297299
              ],
              [
                62.3014065,
                27.7467466
              ],
              [
                62.2804638,
                27.7637606
              ],
              [
                62.2440716,
                27.7886692
              ],
              [
                62.211456,
                27.8093207
              ],
              [
                62.1894833,
                27.823896
              ],
              [
                62.1451947,
                27.8348261
              ],
              [
                62.1012494,
                27.8478801
              ],
              [
                62.0706936,
                27.8578972
              ],
              [
                62.0483837,
                27.8843819
              ],
              [
                62.0513999,
                27.8928902
              ],
              [
                62.0518441,
                27.8981089
              ],
              [
                62.052653,
                27.9072759
              ],
              [
                62.0528247,
                27.9167322
              ],
              [
                62.0600543,
                27.9167494
              ],
              [
                62.0671916,
                27.9173511
              ],
              [
                62.0698525,
                27.918582
              ],
              [
                62.0738363,
                27.9254479
              ],
              [
                62.07892,
                27.9386733
              ],
              [
                62.083485,
                27.9568627
              ],
              [
                62.0889316,
                27.9703203
              ],
              [
                62.0915079,
                27.9778405
              ],
              [
                62.0925525,
                27.9824188
              ],
              [
                62.1038334,
                27.9843684
              ],
              [
                62.1190485,
                27.9859123
              ],
              [
                62.1270639,
                27.9894857
              ],
              [
                62.131282,
                27.9941078
              ],
              [
                62.130767,
                28.0011082
              ],
              [
                62.1301256,
                28.0201471
              ],
              [
                62.1298203,
                28.0400202
              ],
              [
                62.1384265,
                28.061788
              ],
              [
                62.1215056,
                28.0651642
              ],
              [
                62.0676988,
                28.0698485
              ],
              [
                62.0515075,
                28.0719362
              ],
              [
                62.0413414,
                28.0755475
              ],
              [
                62.0262012,
                28.081
              ],
              [
                62.0005623,
                28.0899664
              ],
              [
                61.9795011,
                28.1021117
              ],
              [
                61.9625145,
                28.1083193
              ],
              [
                61.9439997,
                28.1087735
              ],
              [
                61.9361662,
                28.1069328
              ],
              [
                61.9214996,
                28.108536
              ],
              [
                61.8808972,
                28.1236875
              ],
              [
                61.8675359,
                28.128476
              ],
              [
                61.8327708,
                28.1357326
              ],
              [
                61.79613,
                28.1400044
              ],
              [
                61.7883918,
                28.1402745
              ],
              [
                61.759229,
                28.1265905
              ],
              [
                61.7171605,
                28.1070844
              ],
              [
                61.6842545,
                28.0809644
              ],
              [
                61.6491184,
                28.0496053
              ],
              [
                61.6272362,
                27.9992961
              ],
              [
                61.6091433,
                27.9728711
              ],
              [
                61.605643,
                27.9625614
              ],
              [
                61.6107991,
                27.9491358
              ],
              [
                61.6296989,
                27.9306342
              ],
              [
                61.6286421,
                27.9224287
              ],
              [
                61.6212707,
                27.9113178
              ],
              [
                61.6016609,
                27.9098524
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555071,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سرباز",
          "name:en": "Sarbaz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278763",
          "wikipedia": "en:Sarbaz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.7579935,
                26.5019325
              ],
              [
                60.7696611,
                26.5006939
              ],
              [
                60.7706165,
                26.5006298
              ],
              [
                60.7748921,
                26.4994168
              ],
              [
                60.7761311,
                26.4986519
              ],
              [
                60.7761954,
                26.4970004
              ],
              [
                60.7786846,
                26.494888
              ],
              [
                60.7798862,
                26.4941198
              ],
              [
                60.7829761,
                26.4907782
              ],
              [
                60.7856369,
                26.4881664
              ],
              [
                60.7897996,
                26.4854392
              ],
              [
                60.7910442,
                26.4847094
              ],
              [
                60.7948851,
                26.4850935
              ],
              [
                60.8007001,
                26.4867068
              ],
              [
                60.8056354,
                26.4877823
              ],
              [
                60.8101415,
                26.4878207
              ],
              [
                60.8158493,
                26.4868604
              ],
              [
                60.8260199,
                26.4827891
              ],
              [
                60.8288097,
                26.4794085
              ],
              [
                60.8294105,
                26.4772573
              ],
              [
                60.8303117,
                26.4726091
              ],
              [
                60.8313298,
                26.4690526
              ],
              [
                60.8343091,
                26.4662202
              ],
              [
                60.8367837,
                26.4651378
              ],
              [
                60.8428749,
                26.4571605
              ],
              [
                60.8470916,
                26.4382989
              ],
              [
                60.8495807,
                26.4333802
              ],
              [
                60.8569876,
                26.424397
              ],
              [
                60.8589116,
                26.4159636
              ],
              [
                60.8591079,
                26.4115121
              ],
              [
                60.8587849,
                26.4026875
              ],
              [
                60.8614381,
                26.3967496
              ],
              [
                60.8677477,
                26.3905378
              ],
              [
                60.8963021,
                26.3934135
              ],
              [
                60.9195146,
                26.3983631
              ],
              [
                60.9472607,
                26.4025562
              ],
              [
                60.9693414,
                26.3998472
              ],
              [
                60.9258461,
                26.3330957
              ],
              [
                60.9347399,
                26.3233721
              ],
              [
                60.9366798,
                26.3211544
              ],
              [
                60.9377931,
                26.3192061
              ],
              [
                60.9541863,
                26.295872
              ],
              [
                60.9561262,
                26.2919846
              ],
              [
                60.956959,
                26.2911496
              ],
              [
                60.964459,
                26.2797569
              ],
              [
                60.9652926,
                26.2792093
              ],
              [
                60.9747389,
                26.2650338
              ],
              [
                60.9755724,
                26.2636512
              ],
              [
                60.9758521,
                26.2630946
              ],
              [
                60.9805718,
                26.2589292
              ],
              [
                61.0809426,
                26.2850023
              ],
              [
                61.0878185,
                26.2823694
              ],
              [
                61.1157113,
                26.2815095
              ],
              [
                61.1266186,
                26.2787388
              ],
              [
                61.1501409,
                26.2726647
              ],
              [
                61.1674407,
                26.2710099
              ],
              [
                61.1947997,
                26.2648524
              ],
              [
                61.196103,
                26.2708337
              ],
              [
                61.1939152,
                26.2792087
              ],
              [
                61.1941957,
                26.279487
              ],
              [
                61.1961355,
                26.2914273
              ],
              [
                61.1961355,
                26.3003155
              ],
              [
                61.1964153,
                26.3011504
              ],
              [
                61.1966949,
                26.3030986
              ],
              [
                61.196695,
                26.3039246
              ],
              [
                61.196695,
                26.3050379
              ],
              [
                61.1964153,
                26.3053162
              ],
              [
                61.1828096,
                26.4210491
              ],
              [
                61.264915,
                26.4555113
              ],
              [
                61.2964208,
                26.5322648
              ],
              [
                61.2975341,
                26.5322648
              ],
              [
                61.2986411,
                26.5325432
              ],
              [
                61.299474,
                26.5328216
              ],
              [
                61.3000341,
                26.5325433
              ],
              [
                61.3017013,
                26.5325432
              ],
              [
                61.301974,
                26.5322648
              ],
              [
                61.3044741,
                26.5322648
              ],
              [
                61.3047545,
                26.5319864
              ],
              [
                61.3075343,
                26.5319863
              ],
              [
                61.3075343,
                26.5317079
              ],
              [
                61.3342003,
                26.5317079
              ],
              [
                61.337534,
                26.5314293
              ],
              [
                61.3822811,
                26.5219387
              ],
              [
                61.4454984,
                26.5128731
              ],
              [
                61.4951539,
                26.5026254
              ],
              [
                61.5224866,
                26.4937977
              ],
              [
                61.5514103,
                26.490919
              ],
              [
                61.5634344,
                26.496386
              ],
              [
                61.5670393,
                26.508983
              ],
              [
                61.5581129,
                26.5206571
              ],
              [
                61.5919302,
                26.5198891
              ],
              [
                61.609783,
                26.516817
              ],
              [
                61.6286658,
                26.5151274
              ],
              [
                61.6547583,
                26.5186603
              ],
              [
                61.6669462,
                26.5200427
              ],
              [
                61.6767309,
                26.522193
              ],
              [
                61.7110632,
                26.5238826
              ],
              [
                61.7299966,
                26.5242145
              ],
              [
                61.7670248,
                26.5341729
              ],
              [
                61.7759512,
                26.5542901
              ],
              [
                61.7587851,
                26.5673414
              ],
              [
                61.7090612,
                26.5619258
              ],
              [
                61.6849065,
                26.5567387
              ],
              [
                61.668153,
                26.5562269
              ],
              [
                61.659824,
                26.549257
              ],
              [
                61.6499959,
                26.5531235
              ],
              [
                61.636943,
                26.5614989
              ],
              [
                61.626214,
                26.5616633
              ],
              [
                61.611788,
                26.5604578
              ],
              [
                61.5992864,
                26.5682548
              ],
              [
                61.5855259,
                26.5756074
              ],
              [
                61.6028088,
                26.604137
              ],
              [
                61.6121968,
                26.6255553
              ],
              [
                61.6121206,
                26.6416321
              ],
              [
                61.6160503,
                26.6582203
              ],
              [
                61.6126875,
                26.6825099
              ],
              [
                61.5779291,
                26.7137979
              ],
              [
                61.5498869,
                26.7161157
              ],
              [
                61.5310875,
                26.7609734
              ],
              [
                61.513379,
                26.7675732
              ],
              [
                61.5267761,
                26.7830943
              ],
              [
                61.5034467,
                26.7955151
              ],
              [
                61.5077773,
                26.8498497
              ],
              [
                61.5077778,
                26.8498498
              ],
              [
                61.5477734,
                26.8554692
              ],
              [
                61.6215658,
                26.851008
              ],
              [
                61.6215644,
                26.8510085
              ],
              [
                61.621563,
                26.851009
              ],
              [
                61.592544,
                26.861987
              ],
              [
                61.5853245,
                26.8658784
              ],
              [
                61.5772641,
                26.874488
              ],
              [
                61.5772641,
                26.8747666
              ],
              [
                61.576711,
                26.8756023
              ],
              [
                61.5547647,
                26.9094934
              ],
              [
                61.5542115,
                26.909772
              ],
              [
                61.5497646,
                26.9178248
              ],
              [
                61.5478184,
                26.9208806
              ],
              [
                61.5478185,
                26.9214379
              ],
              [
                61.5469848,
                26.9219951
              ],
              [
                61.5417114,
                26.9297695
              ],
              [
                61.5303182,
                26.9422718
              ],
              [
                61.5297651,
                26.9425503
              ],
              [
                61.5294855,
                26.9431076
              ],
              [
                61.5243389,
                26.9470295
              ],
              [
                61.5158544,
                26.9464398
              ],
              [
                61.4950419,
                26.9494283
              ],
              [
                61.4846479,
                26.9534026
              ],
              [
                61.4690037,
                26.956387
              ],
              [
                61.4572182,
                26.9568069
              ],
              [
                61.4442259,
                26.9559784
              ],
              [
                61.4356436,
                26.9548686
              ],
              [
                61.4250905,
                26.9568619
              ],
              [
                61.4119905,
                26.9593463
              ],
              [
                61.4031703,
                26.959904
              ],
              [
                61.3967673,
                26.9583227
              ],
              [
                61.3877974,
                26.9522696
              ],
              [
                61.3780362,
                26.9502372
              ],
              [
                61.3706866,
                26.9506999
              ],
              [
                61.3644706,
                26.9522981
              ],
              [
                61.3613751,
                26.959323
              ],
              [
                61.3582085,
                26.9642057
              ],
              [
                61.3508038,
                26.9659292
              ],
              [
                61.34126,
                26.9678303
              ],
              [
                61.334778,
                26.9717102
              ],
              [
                61.3273308,
                26.97565
              ],
              [
                61.3126025,
                26.9856889
              ],
              [
                61.2973887,
                26.9957563
              ],
              [
                61.280571,
                26.9976707
              ],
              [
                61.2554843,
                26.9992265
              ],
              [
                61.2385986,
                27.0002706
              ],
              [
                61.2210641,
                26.9991812
              ],
              [
                61.2049774,
                26.9980002
              ],
              [
                61.1860624,
                26.9978588
              ],
              [
                61.173003,
                26.9982246
              ],
              [
                61.1643186,
                26.9987558
              ],
              [
                61.1541866,
                26.9993747
              ],
              [
                61.1469494,
                26.9998163
              ],
              [
                61.1347234,
                26.9983902
              ],
              [
                61.1197722,
                26.9986837
              ],
              [
                61.1020087,
                26.9993374
              ],
              [
                61.0953807,
                27.001373
              ],
              [
                61.0930898,
                27.0042326
              ],
              [
                61.0912995,
                27.0143003
              ],
              [
                61.0925996,
                27.0207954
              ],
              [
                61.0965681,
                27.028336
              ],
              [
                61.1038432,
                27.0355919
              ],
              [
                61.1111378,
                27.0403716
              ],
              [
                61.1181156,
                27.0486143
              ],
              [
                61.113005,
                27.0517484
              ],
              [
                61.0909942,
                27.0481827
              ],
              [
                61.0589056,
                27.0358747
              ],
              [
                61.0338271,
                27.0252987
              ],
              [
                61.0127362,
                27.0150716
              ],
              [
                60.9934798,
                27.0062328
              ],
              [
                60.9872407,
                27.0031588
              ],
              [
                60.973262,
                27.0070872
              ],
              [
                60.9587476,
                27.0056129
              ],
              [
                60.9351553,
                27.0043487
              ],
              [
                60.9107659,
                27.0017759
              ],
              [
                60.8935129,
                27.0019084
              ],
              [
                60.8865244,
                27.008438
              ],
              [
                60.8782457,
                27.0124691
              ],
              [
                60.8671561,
                27.0289447
              ],
              [
                60.8569068,
                27.0286321
              ],
              [
                60.8459183,
                27.0114936
              ],
              [
                60.8368867,
                27.0030079
              ],
              [
                60.8067625,
                27.0034667
              ],
              [
                60.7873134,
                27.0039893
              ],
              [
                60.7761222,
                27.0026128
              ],
              [
                60.770075,
                26.9995811
              ],
              [
                60.7611988,
                26.9879562
              ],
              [
                60.7866302,
                26.9628942
              ],
              [
                60.7958074,
                26.9525718
              ],
              [
                60.8441199,
                26.9022183
              ],
              [
                60.8735947,
                26.8743627
              ],
              [
                60.894931,
                26.855374
              ],
              [
                60.9243097,
                26.8351843
              ],
              [
                60.9372098,
                26.8201447
              ],
              [
                60.9267434,
                26.7918
              ],
              [
                60.8743568,
                26.7714877
              ],
              [
                60.8412995,
                26.7586372
              ],
              [
                60.8438941,
                26.7518927
              ],
              [
                60.8502747,
                26.7437314
              ],
              [
                60.8539581,
                26.7424678
              ],
              [
                60.8609104,
                26.7382903
              ],
              [
                60.8646917,
                26.7344181
              ],
              [
                60.866661,
                26.7325029
              ],
              [
                60.8701505,
                26.7269885
              ],
              [
                60.8737226,
                26.723682
              ],
              [
                60.8885441,
                26.7142316
              ],
              [
                60.8934865,
                26.7087833
              ],
              [
                60.8962726,
                26.7043664
              ],
              [
                60.9001145,
                26.6988479
              ],
              [
                60.8941268,
                26.6900271
              ],
              [
                60.8822822,
                26.6848124
              ],
              [
                60.8728408,
                26.6815914
              ],
              [
                60.8705209,
                26.6775538
              ],
              [
                60.8693217,
                26.6731551
              ],
              [
                60.8726085,
                26.6624236
              ],
              [
                60.8753521,
                26.6489295
              ],
              [
                60.8760249,
                26.6345877
              ],
              [
                60.875759,
                26.6218334
              ],
              [
                60.8743857,
                26.6157716
              ],
              [
                60.8673475,
                26.6057188
              ],
              [
                60.855846,
                26.5966631
              ],
              [
                60.8412937,
                26.5891842
              ],
              [
                60.8274036,
                26.5738147
              ],
              [
                60.8206557,
                26.5635796
              ],
              [
                60.8098323,
                26.557252
              ],
              [
                60.7947349,
                26.5523706
              ],
              [
                60.7832336,
                26.5405846
              ],
              [
                60.7798433,
                26.540335
              ],
              [
                60.7770324,
                26.5392984
              ],
              [
                60.7737279,
                26.5383193
              ],
              [
                60.7706165,
                26.536534
              ],
              [
                60.7680416,
                26.5346335
              ],
              [
                60.7662606,
                26.5321378
              ],
              [
                60.7614325,
                26.5294502
              ],
              [
                60.7594585,
                26.5296804
              ],
              [
                60.756948,
                26.5305444
              ],
              [
                60.7559609,
                26.5302756
              ],
              [
                60.7530641,
                26.53041
              ],
              [
                60.7503604,
                26.5297189
              ],
              [
                60.7438159,
                26.5268583
              ],
              [
                60.7404899,
                26.5240744
              ],
              [
                60.7381296,
                26.5199657
              ],
              [
                60.7381296,
                26.5171241
              ],
              [
                60.7400178,
                26.5148969
              ],
              [
                60.7423138,
                26.513092
              ],
              [
                60.7476783,
                26.5102502
              ],
              [
                60.7502745,
                26.5082917
              ],
              [
                60.7527208,
                26.5070243
              ],
              [
                60.7569296,
                26.503199
              ],
              [
                60.7579935,
                26.5019325
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555091,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سیب و سوران",
          "name:en": "Sib and Suran County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q733479"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                61.2248022,
                27.9528487
              ],
              [
                61.2105495,
                27.948026
              ],
              [
                61.2064647,
                27.9408819
              ],
              [
                61.2005219,
                27.9245109
              ],
              [
                61.1971515,
                27.9009011
              ],
              [
                61.2025438,
                27.8660813
              ],
              [
                61.2139362,
                27.8327636
              ],
              [
                61.2158244,
                27.8291791
              ],
              [
                61.2290381,
                27.787606
              ],
              [
                61.2338944,
                27.7548351
              ],
              [
                61.2531718,
                27.7077718
              ],
              [
                61.2648086,
                27.6777893
              ],
              [
                61.2714384,
                27.6652854
              ],
              [
                61.2860698,
                27.6397328
              ],
              [
                61.297531,
                27.6189045
              ],
              [
                61.3215575,
                27.5903991
              ],
              [
                61.3380473,
                27.5645013
              ],
              [
                61.3436832,
                27.5500099
              ],
              [
                61.3514122,
                27.5454335
              ],
              [
                61.3656233,
                27.5366091
              ],
              [
                61.3763907,
                27.5295597
              ],
              [
                61.3903998,
                27.5177109
              ],
              [
                61.4097975,
                27.4986791
              ],
              [
                61.4202688,
                27.4765982
              ],
              [
                61.4299655,
                27.4550439
              ],
              [
                61.4373667,
                27.4430118
              ],
              [
                61.449108,
                27.4237381
              ],
              [
                61.4568791,
                27.4126682
              ],
              [
                61.4662539,
                27.3992431
              ],
              [
                61.4829873,
                27.3806151
              ],
              [
                61.4972199,
                27.3629669
              ],
              [
                61.5044152,
                27.3582147
              ],
              [
                61.5137385,
                27.350957
              ],
              [
                61.5195751,
                27.347412
              ],
              [
                61.521792,
                27.3475026
              ],
              [
                61.5362904,
                27.3491798
              ],
              [
                61.5539334,
                27.3527778
              ],
              [
                61.5726106,
                27.3560978
              ],
              [
                61.5837891,
                27.3589998
              ],
              [
                61.5921638,
                27.3655297
              ],
              [
                61.6025732,
                27.372987
              ],
              [
                61.6156672,
                27.3888168
              ],
              [
                61.6336505,
                27.396421
              ],
              [
                61.655217,
                27.4018573
              ],
              [
                61.6801842,
                27.4060757
              ],
              [
                61.6831793,
                27.3984679
              ],
              [
                61.6870967,
                27.3887482
              ],
              [
                61.6932963,
                27.3765692
              ],
              [
                61.7010475,
                27.3628358
              ],
              [
                61.7088495,
                27.3488511
              ],
              [
                61.7174039,
                27.3350913
              ],
              [
                61.7210197,
                27.3284652
              ],
              [
                61.7271995,
                27.319391
              ],
              [
                61.7485713,
                27.2929265
              ],
              [
                61.7537658,
                27.2881351
              ],
              [
                61.7681722,
                27.2793617
              ],
              [
                61.7967222,
                27.2613441
              ],
              [
                61.8121718,
                27.2474571
              ],
              [
                61.8210535,
                27.2206442
              ],
              [
                61.8202403,
                27.1915994
              ],
              [
                61.8206039,
                27.1699367
              ],
              [
                61.8207219,
                27.1613509
              ],
              [
                61.8235885,
                27.1566723
              ],
              [
                61.8280234,
                27.1552911
              ],
              [
                61.8323421,
                27.1548586
              ],
              [
                61.8426417,
                27.1569969
              ],
              [
                61.8632411,
                27.160968
              ],
              [
                61.8787765,
                27.1636408
              ],
              [
                61.8826388,
                27.1640226
              ],
              [
                61.8948822,
                27.163295
              ],
              [
                61.9071559,
                27.15095
              ],
              [
                61.9258645,
                27.1449498
              ],
              [
                61.9339461,
                27.142131
              ],
              [
                61.9369928,
                27.1410608
              ],
              [
                61.945354,
                27.1328772
              ],
              [
                61.9460566,
                27.1271509
              ],
              [
                61.938773,
                27.122389
              ],
              [
                61.9292891,
                27.1174172
              ],
              [
                61.9048019,
                27.1046782
              ],
              [
                61.8918057,
                27.0978638
              ],
              [
                61.8879779,
                27.0952295
              ],
              [
                61.882734,
                27.0900242
              ],
              [
                61.8750658,
                27.0832997
              ],
              [
                61.8247807,
                27.0569954
              ],
              [
                61.8181078,
                27.0483834
              ],
              [
                61.8181078,
                27.0478261
              ],
              [
                61.8175547,
                27.04699
              ],
              [
                61.8150545,
                27.0378298
              ],
              [
                61.810888,
                27.0097655
              ],
              [
                61.8111677,
                27.004498
              ],
              [
                61.810888,
                27.0039317
              ],
              [
                61.810888,
                26.9994912
              ],
              [
                61.8120012,
                26.9961654
              ],
              [
                61.8131076,
                26.9928305
              ],
              [
                61.8156074,
                26.9364377
              ],
              [
                61.8156074,
                26.9331032
              ],
              [
                61.8167205,
                26.9036597
              ],
              [
                61.8239471,
                26.876716
              ],
              [
                61.82728,
                26.8700476
              ],
              [
                61.82728,
                26.8692119
              ],
              [
                61.828387,
                26.8667135
              ],
              [
                61.828387,
                26.8653295
              ],
              [
                61.8286667,
                26.8647724
              ],
              [
                61.8286667,
                26.8608811
              ],
              [
                61.8326778,
                26.8367322
              ],
              [
                61.8509257,
                26.8390339
              ],
              [
                61.8890889,
                26.8185621
              ],
              [
                61.9198213,
                26.8284219
              ],
              [
                61.9617704,
                26.8136375
              ],
              [
                61.9911238,
                26.8071593
              ],
              [
                62.0005424,
                26.7811497
              ],
              [
                62.0286188,
                26.7598284
              ],
              [
                62.0501842,
                26.703304
              ],
              [
                62.068343,
                26.6930195
              ],
              [
                62.086097,
                26.6859924
              ],
              [
                62.1073807,
                26.6801065
              ],
              [
                62.1239276,
                26.6805605
              ],
              [
                62.1382431,
                26.678301
              ],
              [
                62.1430284,
                26.6768869
              ],
              [
                62.157794,
                26.6700881
              ],
              [
                62.173143,
                26.66848
              ],
              [
                62.1986455,
                26.6687126
              ],
              [
                62.2493327,
                26.6625378
              ],
              [
                62.2900319,
                26.6446427
              ],
              [
                62.34516,
                26.6090475
              ],
              [
                62.3522701,
                26.6008106
              ],
              [
                62.3573156,
                26.594965
              ],
              [
                62.3766678,
                26.5726549
              ],
              [
                62.3937531,
                26.5540005
              ],
              [
                62.4037953,
                26.5423574
              ],
              [
                62.4111376,
                26.5370971
              ],
              [
                62.4112419,
                26.5351691
              ],
              [
                62.412006,
                26.534894
              ],
              [
                62.413105,
                26.53434
              ],
              [
                62.414185,
                26.534044
              ],
              [
                62.415779,
                26.533717
              ],
              [
                62.417279,
                26.533572
              ],
              [
                62.4180889,
                26.5333262
              ],
              [
                62.4189169,
                26.5330852
              ],
              [
                62.4198632,
                26.5327758
              ],
              [
                62.4203312,
                26.5328138
              ],
              [
                62.4211762,
                26.5331578
              ],
              [
                62.4215092,
                26.5333488
              ],
              [
                62.421694,
                26.533971
              ],
              [
                62.42176,
                26.534205
              ],
              [
                62.42276,
                26.538055
              ],
              [
                62.422825,
                26.538592
              ],
              [
                62.422761,
                26.539188
              ],
              [
                62.422524,
                26.539861
              ],
              [
                62.422235,
                26.5402
              ],
              [
                62.421837,
                26.540454
              ],
              [
                62.420602,
                26.540627
              ],
              [
                62.420286,
                26.540783
              ],
              [
                62.420286,
                26.54102
              ],
              [
                62.420706,
                26.541435
              ],
              [
                62.421142,
                26.541642
              ],
              [
                62.421706,
                26.542156
              ],
              [
                62.422091,
                26.542595
              ],
              [
                62.422444,
                26.543074
              ],
              [
                62.42283,
                26.544079
              ],
              [
                62.423348,
                26.545995
              ],
              [
                62.423467,
                26.546897
              ],
              [
                62.423288,
                26.547822
              ],
              [
                62.42332,
                26.548057
              ],
              [
                62.423199,
                26.549858
              ],
              [
                62.423236,
                26.550249
              ],
              [
                62.423661,
                26.550926
              ],
              [
                62.424549,
                26.55175
              ],
              [
                62.42561,
                26.552564
              ],
              [
                62.426834,
                26.553379
              ],
              [
                62.42791,
                26.553667
              ],
              [
                62.428511,
                26.55409
              ],
              [
                62.42876,
                26.554203
              ],
              [
                62.430889,
                26.556787
              ],
              [
                62.432853,
                26.559063
              ],
              [
                62.433651,
                26.559498
              ],
              [
                62.43516,
                26.560083
              ],
              [
                62.436275,
                26.560249
              ],
              [
                62.437612,
                26.560302
              ],
              [
                62.439885,
                26.560209
              ],
              [
                62.440403,
                26.560376
              ],
              [
                62.440691,
                26.560932
              ],
              [
                62.44062,
                26.561692
              ],
              [
                62.440231,
                26.562935
              ],
              [
                62.43999,
                26.564125
              ],
              [
                62.440021,
                26.564819
              ],
              [
                62.440704,
                26.565295
              ],
              [
                62.441469,
                26.565634
              ],
              [
                62.445165,
                26.566895
              ],
              [
                62.446431,
                26.567232
              ],
              [
                62.447453,
                26.56737
              ],
              [
                62.448218,
                26.567407
              ],
              [
                62.448941,
                26.567362
              ],
              [
                62.450807,
                26.56704
              ],
              [
                62.451428,
                26.566867
              ],
              [
                62.452407,
                26.566394
              ],
              [
                62.453196,
                26.565375
              ],
              [
                62.454482,
                26.564361
              ],
              [
                62.455611,
                26.563801
              ],
              [
                62.456765,
                26.563333
              ],
              [
                62.457967,
                26.562968
              ],
              [
                62.458445,
                26.562863
              ],
              [
                62.459556,
                26.562954
              ],
              [
                62.460777,
                26.562892
              ],
              [
                62.461389,
                26.56271
              ],
              [
                62.46231,
                26.563004
              ],
              [
                62.463482,
                26.56361
              ],
              [
                62.4673,
                26.565243
              ],
              [
                62.468829,
                26.565787
              ],
              [
                62.469863,
                26.56562
              ],
              [
                62.472348,
                26.567038
              ],
              [
                62.473732,
                26.567501
              ],
              [
                62.475074,
                26.56822
              ],
              [
                62.475855,
                26.568508
              ],
              [
                62.477278,
                26.568525
              ],
              [
                62.479068,
                26.567977
              ],
              [
                62.479593,
                26.567717
              ],
              [
                62.480883,
                26.567343
              ],
              [
                62.483961,
                26.566998
              ],
              [
                62.484838,
                26.567049
              ],
              [
                62.486549,
                26.567359
              ],
              [
                62.488527,
                26.567939
              ],
              [
                62.489493,
                26.568283
              ],
              [
                62.492853,
                26.568944
              ],
              [
                62.493996,
                26.569406
              ],
              [
                62.495839,
                26.571163
              ],
              [
                62.496684,
                26.570968
              ],
              [
                62.497594,
                26.570963
              ],
              [
                62.499105,
                26.571403
              ],
              [
                62.500479,
                26.571916
              ],
              [
                62.50167,
                26.572255
              ],
              [
                62.502788,
                26.572401
              ],
              [
                62.503563,
                26.572693
              ],
              [
                62.504296,
                26.572709
              ],
              [
                62.504879,
                26.572833
              ],
              [
                62.505576,
                26.573234
              ],
              [
                62.50592,
                26.5736
              ],
              [
                62.506011,
                26.574049
              ],
              [
                62.506046,
                26.575113
              ],
              [
                62.506558,
                26.575969
              ],
              [
                62.507147,
                26.577245
              ],
              [
                62.508263,
                26.577677
              ],
              [
                62.509327,
                26.577862
              ],
              [
                62.510476,
                26.577943
              ],
              [
                62.512024,
                26.57773
              ],
              [
                62.514761,
                26.576997
              ],
              [
                62.515578,
                26.57652
              ],
              [
                62.516305,
                26.576258
              ],
              [
                62.5169577,
                26.5757508
              ],
              [
                62.5174113,
                26.5763444
              ],
              [
                62.5085696,
                26.5850721
              ],
              [
                62.485658,
                26.5842732
              ],
              [
                62.4716532,
                26.5913145
              ],
              [
                62.4456474,
                26.622981
              ],
              [
                62.4286577,
                26.6281795
              ],
              [
                62.4270363,
                26.6286756
              ],
              [
                62.3985721,
                26.6416785
              ],
              [
                62.3592414,
                26.6544207
              ],
              [
                62.3196964,
                26.6857604
              ],
              [
                62.3057847,
                26.705252
              ],
              [
                62.2863701,
                26.7212705
              ],
              [
                62.240836,
                26.7492432
              ],
              [
                62.2546528,
                26.8047826
              ],
              [
                62.3109678,
                26.8272835
              ],
              [
                62.3635843,
                26.8292419
              ],
              [
                62.3659176,
                26.8297594
              ],
              [
                62.3701503,
                26.8469794
              ],
              [
                62.3705417,
                26.850472
              ],
              [
                62.3906034,
                26.8642055
              ],
              [
                62.4098868,
                26.8780026
              ],
              [
                62.4360751,
                26.8830336
              ],
              [
                62.4750809,
                26.8874452
              ],
              [
                62.493017,
                26.916146
              ],
              [
                62.4955221,
                26.9536135
              ],
              [
                62.4812177,
                26.9682813
              ],
              [
                62.4086883,
                26.9603692
              ],
              [
                62.4000423,
                26.9705293
              ],
              [
                62.4007756,
                26.9766897
              ],
              [
                62.4251777,
                26.9820781
              ],
              [
                62.4349166,
                26.9964613
              ],
              [
                62.4351493,
                27.0217678
              ],
              [
                62.4353099,
                27.0605821
              ],
              [
                62.3409762,
                27.0650271
              ],
              [
                62.2692272,
                27.0559427
              ],
              [
                62.267606,
                27.113688
              ],
              [
                62.2812238,
                27.1523612
              ],
              [
                62.2951811,
                27.1912726
              ],
              [
                62.3045503,
                27.217927
              ],
              [
                62.3128947,
                27.222961
              ],
              [
                62.317959,
                27.2319298
              ],
              [
                62.317222,
                27.2396638
              ],
              [
                62.3159544,
                27.2453605
              ],
              [
                62.3139495,
                27.2487914
              ],
              [
                62.3127955,
                27.2499476
              ],
              [
                62.3091315,
                27.2531036
              ],
              [
                62.3034667,
                27.2570713
              ],
              [
                62.293422,
                27.2604105
              ],
              [
                62.2832499,
                27.2630103
              ],
              [
                62.2763071,
                27.2637703
              ],
              [
                62.2628258,
                27.2659417
              ],
              [
                62.2480574,
                27.2694513
              ],
              [
                62.2367083,
                27.2751703
              ],
              [
                62.2312543,
                27.2773972
              ],
              [
                62.2242886,
                27.2801434
              ],
              [
                62.1903493,
                27.2911651
              ],
              [
                62.1734129,
                27.2965367
              ],
              [
                62.1534034,
                27.3022717
              ],
              [
                62.1440517,
                27.3050217
              ],
              [
                62.1399616,
                27.306392
              ],
              [
                62.1322651,
                27.3085896
              ],
              [
                62.1247904,
                27.3122813
              ],
              [
                62.1203436,
                27.3158876
              ],
              [
                62.1157454,
                27.3230092
              ],
              [
                62.1108308,
                27.3327908
              ],
              [
                62.1108626,
                27.3514907
              ],
              [
                62.1100043,
                27.3668892
              ],
              [
                62.100071,
                27.4242214
              ],
              [
                62.099844,
                27.4359766
              ],
              [
                62.0949248,
                27.4567205
              ],
              [
                62.0941916,
                27.4668365
              ],
              [
                62.0928589,
                27.4734104
              ],
              [
                62.0824527,
                27.4834513
              ],
              [
                62.0701789,
                27.4938825
              ],
              [
                62.0553143,
                27.5022465
              ],
              [
                62.0382979,
                27.509264
              ],
              [
                62.0313658,
                27.5128695
              ],
              [
                62.0202913,
                27.5170594
              ],
              [
                62.016259,
                27.516179
              ],
              [
                62.0109314,
                27.5174881
              ],
              [
                61.9792842,
                27.5151227
              ],
              [
                61.968212,
                27.5210601
              ],
              [
                61.9494749,
                27.5389135
              ],
              [
                61.9457332,
                27.5438179
              ],
              [
                61.9319914,
                27.5674824
              ],
              [
                61.9072929,
                27.5898937
              ],
              [
                61.9009082,
                27.5969752
              ],
              [
                61.8911681,
                27.6050604
              ],
              [
                61.8827221,
                27.6147102
              ],
              [
                61.8727921,
                27.6263051
              ],
              [
                61.8608627,
                27.6437703
              ],
              [
                61.8422767,
                27.6727797
              ],
              [
                61.8071816,
                27.7231373
              ],
              [
                61.7794972,
                27.762845
              ],
              [
                61.7750573,
                27.7697835
              ],
              [
                61.7528313,
                27.8095078
              ],
              [
                61.7481316,
                27.822316
              ],
              [
                61.6933582,
                27.8532728
              ],
              [
                61.6876482,
                27.8574733
              ],
              [
                61.6799737,
                27.8606219
              ],
              [
                61.6597289,
                27.8638155
              ],
              [
                61.6416211,
                27.8711693
              ],
              [
                61.6214987,
                27.8873232
              ],
              [
                61.6136772,
                27.8969386
              ],
              [
                61.6016609,
                27.9098524
              ],
              [
                61.5815447,
                27.9223032
              ],
              [
                61.5722309,
                27.9309921
              ],
              [
                61.5637867,
                27.9441863
              ],
              [
                61.5492725,
                27.9504355
              ],
              [
                61.5369718,
                27.9570999
              ],
              [
                61.5270599,
                27.9618003
              ],
              [
                61.5186081,
                27.9657116
              ],
              [
                61.5093055,
                27.969502
              ],
              [
                61.5029799,
                27.97261
              ],
              [
                61.5009836,
                27.9732769
              ],
              [
                61.4941295,
                27.9731667
              ],
              [
                61.4875487,
                27.9732426
              ],
              [
                61.4841903,
                27.973118
              ],
              [
                61.4758148,
                27.9725387
              ],
              [
                61.4663626,
                27.9724296
              ],
              [
                61.4575897,
                27.9726326
              ],
              [
                61.4537297,
                27.9727842
              ],
              [
                61.4486276,
                27.9731118
              ],
              [
                61.4348707,
                27.974201
              ],
              [
                61.4314043,
                27.9741739
              ],
              [
                61.4253371,
                27.9736741
              ],
              [
                61.419702,
                27.9732193
              ],
              [
                61.4132743,
                27.971955
              ],
              [
                61.3994178,
                27.9704877
              ],
              [
                61.3949708,
                27.9710455
              ],
              [
                61.3686788,
                27.9719553
              ],
              [
                61.3615574,
                27.9720067
              ],
              [
                61.3551586,
                27.9719065
              ],
              [
                61.3484061,
                27.9713515
              ],
              [
                61.3430638,
                27.9707478
              ],
              [
                61.3334297,
                27.9696594
              ],
              [
                61.3240219,
                27.9689989
              ],
              [
                61.3164494,
                27.9685776
              ],
              [
                61.3094395,
                27.9688023
              ],
              [
                61.3044395,
                27.9688022
              ],
              [
                61.2995616,
                27.9685993
              ],
              [
                61.2932691,
                27.9677139
              ],
              [
                61.2718521,
                27.9640238
              ],
              [
                61.2699737,
                27.9615077
              ],
              [
                61.2694452,
                27.9581875
              ],
              [
                61.2671347,
                27.9515362
              ],
              [
                61.2671999,
                27.9449644
              ],
              [
                61.2601665,
                27.9355539
              ],
              [
                61.238838,
                27.9350692
              ],
              [
                61.2248022,
                27.9528487
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555140,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فنوج",
          "name:en": "Fanuj County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5434421",
          "wikipedia": "en:Fanuj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.9904926,
                26.7586629
              ],
              [
                58.9904926,
                26.7583844
              ],
              [
                58.9924324,
                26.7514388
              ],
              [
                58.9929926,
                26.7506122
              ],
              [
                58.9935458,
                26.7489409
              ],
              [
                58.9963259,
                26.7342145
              ],
              [
                58.9965988,
                26.7303241
              ],
              [
                58.9965988,
                26.7231094
              ],
              [
                58.9960457,
                26.7147717
              ],
              [
                58.9957657,
                26.7142236
              ],
              [
                58.9960457,
                26.7114384
              ],
              [
                58.9979922,
                26.6853299
              ],
              [
                59.0029922,
                26.6747737
              ],
              [
                59.0160451,
                26.6625466
              ],
              [
                59.0174318,
                26.6597707
              ],
              [
                59.0177119,
                26.6561592
              ],
              [
                59.0174318,
                26.6514428
              ],
              [
                59.0149318,
                26.6367189
              ],
              [
                59.0118786,
                26.6306013
              ],
              [
                59.002432,
                26.6186537
              ],
              [
                59.0010456,
                26.6158779
              ],
              [
                58.9990986,
                26.6042091
              ],
              [
                58.9996588,
                26.596439
              ],
              [
                59.000492,
                26.5942202
              ],
              [
                59.002992,
                26.5869892
              ],
              [
                59.0043787,
                26.5853274
              ],
              [
                59.0263248,
                26.5680991
              ],
              [
                59.0285447,
                26.5664375
              ],
              [
                59.0349382,
                26.5614343
              ],
              [
                59.0349382,
                26.5611559
              ],
              [
                59.0352112,
                26.5608774
              ],
              [
                59.0358609,
                26.5609586
              ],
              [
                59.0374383,
                26.5611559
              ],
              [
                59.0377113,
                26.5614343
              ],
              [
                59.0382715,
                26.5614343
              ],
              [
                59.0438247,
                26.5642099
              ],
              [
                59.0518775,
                26.5667158
              ],
              [
                59.0588242,
                26.5680991
              ],
              [
                59.060491,
                26.5680991
              ],
              [
                59.0627109,
                26.568656
              ],
              [
                59.0643773,
                26.568656
              ],
              [
                59.0660508,
                26.5689344
              ],
              [
                59.0685508,
                26.5689345
              ],
              [
                59.0727173,
                26.5694913
              ],
              [
                59.0777174,
                26.5694913
              ],
              [
                59.0882703,
                26.5669942
              ],
              [
                59.0996568,
                26.562548
              ],
              [
                59.1296632,
                26.5486616
              ],
              [
                59.1413298,
                26.5425449
              ],
              [
                59.1432762,
                26.541988
              ],
              [
                59.1441095,
                26.5414401
              ],
              [
                59.1482763,
                26.5394911
              ],
              [
                59.1641094,
                26.5339314
              ],
              [
                59.1716091,
                26.5317128
              ],
              [
                59.173549,
                26.5314344
              ],
              [
                59.1777155,
                26.5303207
              ],
              [
                59.2049416,
                26.5242131
              ],
              [
                59.2063285,
                26.5242131
              ],
              [
                59.2071616,
                26.5239347
              ],
              [
                59.208555,
                26.5239346
              ],
              [
                59.2093886,
                26.5236562
              ],
              [
                59.2110551,
                26.5236562
              ],
              [
                59.2118883,
                26.5233778
              ],
              [
                59.2135551,
                26.5233778
              ],
              [
                59.2146618,
                26.5230994
              ],
              [
                59.2235549,
                26.5230993
              ],
              [
                59.2243881,
                26.5233778
              ],
              [
                59.2255014,
                26.5233778
              ],
              [
                59.2260549,
                26.5236562
              ],
              [
                59.2293882,
                26.5236562
              ],
              [
                59.2296682,
                26.5239346
              ],
              [
                59.2330015,
                26.5239346
              ],
              [
                59.2335546,
                26.5236562
              ],
              [
                59.2357746,
                26.5236562
              ],
              [
                59.2360548,
                26.5233777
              ],
              [
                59.237168,
                26.5233777
              ],
              [
                59.2388348,
                26.5236562
              ],
              [
                59.2393879,
                26.5236562
              ],
              [
                59.2463346,
                26.5250483
              ],
              [
                59.2482744,
                26.5250483
              ],
              [
                59.263554,
                26.5275451
              ],
              [
                59.3124466,
                26.5458769
              ],
              [
                59.347173,
                26.5603289
              ],
              [
                59.3480063,
                26.5603289
              ],
              [
                59.3485594,
                26.5600505
              ],
              [
                59.3491129,
                26.5597721
              ],
              [
                59.3588397,
                26.5564396
              ],
              [
                59.3607795,
                26.5561611
              ],
              [
                59.3724528,
                26.5533767
              ],
              [
                59.4166183,
                26.5392121
              ],
              [
                59.4474512,
                26.5269879
              ],
              [
                59.4921773,
                26.5092134
              ],
              [
                59.5010638,
                26.5050461
              ],
              [
                59.5035634,
                26.5042109
              ],
              [
                59.5049567,
                26.5033756
              ],
              [
                59.5099569,
                26.5011572
              ],
              [
                59.5135635,
                26.4994867
              ],
              [
                59.5316231,
                26.4864372
              ],
              [
                59.5319033,
                26.4861588
              ],
              [
                59.5324565,
                26.4858803
              ],
              [
                59.5341232,
                26.4844883
              ],
              [
                59.5535692,
                26.4680982
              ],
              [
                59.5749554,
                26.4528222
              ],
              [
                59.5763489,
                26.4522654
              ],
              [
                59.5977351,
                26.437816
              ],
              [
                59.6219014,
                26.4183742
              ],
              [
                59.6460745,
                26.3961583
              ],
              [
                59.6471811,
                26.3944882
              ],
              [
                59.6529441,
                26.3879219
              ],
              [
                59.6532941,
                26.3881037
              ],
              [
                59.6535742,
                26.3883731
              ],
              [
                59.6538476,
                26.3886515
              ],
              [
                59.6544074,
                26.3886515
              ],
              [
                59.6546808,
                26.3889299
              ],
              [
                59.6577406,
                26.3889299
              ],
              [
                59.6582942,
                26.3892082
              ],
              [
                59.6594074,
                26.3889299
              ],
              [
                59.663574,
                26.3889299
              ],
              [
                59.6641274,
                26.3886515
              ],
              [
                59.6657939,
                26.3886515
              ],
              [
                59.6666271,
                26.3883731
              ],
              [
                59.6721874,
                26.3883731
              ],
              [
                59.6730206,
                26.3886514
              ],
              [
                59.6896869,
                26.3886514
              ],
              [
                59.6902404,
                26.388373
              ],
              [
                59.7019066,
                26.3883731
              ],
              [
                59.7102399,
                26.3872685
              ],
              [
                59.7127399,
                26.3872685
              ],
              [
                59.7544125,
                26.3819886
              ],
              [
                59.7552457,
                26.3817103
              ],
              [
                59.7569126,
                26.3817102
              ],
              [
                59.7602459,
                26.3811535
              ],
              [
                59.761079,
                26.3811535
              ],
              [
                59.7613524,
                26.3808751
              ],
              [
                59.7619122,
                26.3808752
              ],
              [
                59.7624658,
                26.3817102
              ],
              [
                59.7627459,
                26.383102
              ],
              [
                59.7663522,
                26.393096
              ],
              [
                59.7660791,
                26.3958708
              ],
              [
                59.7644123,
                26.4003156
              ],
              [
                59.7596857,
                26.408101
              ],
              [
                59.744966,
                26.4219928
              ],
              [
                59.7424664,
                26.4244893
              ],
              [
                59.7296865,
                26.4369896
              ],
              [
                59.7291329,
                26.4380942
              ],
              [
                59.7285732,
                26.4442097
              ],
              [
                59.7335729,
                26.4508822
              ],
              [
                59.7413527,
                26.4555968
              ],
              [
                59.7519127,
                26.4594854
              ],
              [
                59.7682993,
                26.470325
              ],
              [
                59.7702458,
                26.4717081
              ],
              [
                59.7719126,
                26.4722649
              ],
              [
                59.7724658,
                26.4728216
              ],
              [
                59.7907989,
                26.4797637
              ],
              [
                59.8864248,
                26.488387
              ],
              [
                59.8874418,
                26.4925345
              ],
              [
                59.8877408,
                26.4948625
              ],
              [
                59.8834365,
                26.4996742
              ],
              [
                59.8792557,
                26.5020026
              ],
              [
                59.8754024,
                26.5039136
              ],
              [
                59.8722266,
                26.5109799
              ],
              [
                59.8708533,
                26.5176619
              ],
              [
                59.8600386,
                26.5354015
              ],
              [
                59.856777,
                26.5487621
              ],
              [
                59.8579786,
                26.5608927
              ],
              [
                59.8703184,
                26.5692768
              ],
              [
                59.8779344,
                26.5706806
              ],
              [
                59.8833417,
                26.5734825
              ],
              [
                59.8899936,
                26.5787407
              ],
              [
                59.8886823,
                26.6581782
              ],
              [
                59.8889529,
                26.6677765
              ],
              [
                59.8931071,
                26.6869104
              ],
              [
                59.8948182,
                26.7052498
              ],
              [
                59.8987687,
                26.7126115
              ],
              [
                59.9817049,
                26.7332492
              ],
              [
                59.9787704,
                26.7399556
              ],
              [
                59.9708899,
                26.7501668
              ],
              [
                59.9712307,
                26.7572616
              ],
              [
                59.9702975,
                26.7667046
              ],
              [
                59.96999,
                26.7704447
              ],
              [
                59.9699042,
                26.777019
              ],
              [
                59.9700736,
                26.7876058
              ],
              [
                59.9692904,
                26.7981684
              ],
              [
                59.9691187,
                26.806113
              ],
              [
                59.969977,
                26.8167174
              ],
              [
                59.9717543,
                26.8345899
              ],
              [
                59.9737667,
                26.8473023
              ],
              [
                59.9808409,
                26.8631766
              ],
              [
                59.98567,
                26.8686616
              ],
              [
                59.9913324,
                26.8787705
              ],
              [
                59.9987139,
                26.8913619
              ],
              [
                60.0009873,
                26.8962341
              ],
              [
                60.0095288,
                26.9080459
              ],
              [
                60.0321374,
                26.9352962
              ],
              [
                60.0258635,
                26.9359974
              ],
              [
                60.0174521,
                26.9404354
              ],
              [
                60.0141905,
                26.9447203
              ],
              [
                60.0059508,
                26.9539015
              ],
              [
                59.998741,
                26.9586448
              ],
              [
                59.988613,
                26.9592569
              ],
              [
                59.9819182,
                26.963082
              ],
              [
                59.9793352,
                26.9695909
              ],
              [
                59.9757805,
                26.9824054
              ],
              [
                59.967444,
                26.9847
              ],
              [
                59.9576458,
                26.9814604
              ],
              [
                59.9458514,
                26.9776359
              ],
              [
                59.9373948,
                26.9776088
              ],
              [
                59.9284553,
                26.9821708
              ],
              [
                59.923527,
                26.991502
              ],
              [
                59.9236605,
                27.0011111
              ],
              [
                59.9142834,
                27.0077497
              ],
              [
                59.9032973,
                27.0034671
              ],
              [
                59.8939225,
                27.0036978
              ],
              [
                59.8799511,
                27.0092791
              ],
              [
                59.8651883,
                27.0230428
              ],
              [
                59.8514553,
                27.0380279
              ],
              [
                59.8489863,
                27.0460387
              ],
              [
                59.8493569,
                27.0482194
              ],
              [
                59.8461127,
                27.0626609
              ],
              [
                59.8430159,
                27.074139
              ],
              [
                59.8422696,
                27.0754293
              ],
              [
                59.840821,
                27.0763961
              ],
              [
                59.8394901,
                27.0759352
              ],
              [
                59.8168082,
                27.0544278
              ],
              [
                59.8033577,
                27.042044
              ],
              [
                59.7927604,
                27.0319756
              ],
              [
                59.7840529,
                27.0235209
              ],
              [
                59.7780925,
                27.0183487
              ],
              [
                59.7705801,
                27.0113055
              ],
              [
                59.763409,
                27.0042518
              ],
              [
                59.7570216,
                26.9974558
              ],
              [
                59.746836,
                26.9863909
              ],
              [
                59.7312926,
                26.9695078
              ],
              [
                59.7176426,
                26.9643406
              ],
              [
                59.7080279,
                26.9572849
              ],
              [
                59.6890366,
                26.9345941
              ],
              [
                59.6768759,
                26.930641
              ],
              [
                59.6460913,
                26.9285544
              ],
              [
                59.6070097,
                26.9260495
              ],
              [
                59.569928,
                26.9324637
              ],
              [
                59.5527237,
                26.9319174
              ],
              [
                59.5446153,
                26.9311564
              ],
              [
                59.5347401,
                26.9301054
              ],
              [
                59.5241832,
                26.93286
              ],
              [
                59.5169133,
                26.9350318
              ],
              [
                59.510671,
                26.9304561
              ],
              [
                59.5086222,
                26.9274802
              ],
              [
                59.5051057,
                26.9223529
              ],
              [
                59.5030242,
                26.9181371
              ],
              [
                59.5002808,
                26.9139675
              ],
              [
                59.4954524,
                26.9066132
              ],
              [
                59.4895315,
                26.9015036
              ],
              [
                59.4845785,
                26.8993447
              ],
              [
                59.4814117,
                26.8996558
              ],
              [
                59.4754759,
                26.9007208
              ],
              [
                59.4660131,
                26.9026543
              ],
              [
                59.4505182,
                26.906022
              ],
              [
                59.4435642,
                26.9031996
              ],
              [
                59.4384958,
                26.9014507
              ],
              [
                59.4354605,
                26.900936
              ],
              [
                59.4262546,
                26.8995294
              ],
              [
                59.4169666,
                26.8993823
              ],
              [
                59.4050792,
                26.8989441
              ],
              [
                59.3874773,
                26.9000133
              ],
              [
                59.3700517,
                26.9009466
              ],
              [
                59.3529181,
                26.9021085
              ],
              [
                59.3400555,
                26.9007433
              ],
              [
                59.3299119,
                26.8996273
              ],
              [
                59.3172025,
                26.8979226
              ],
              [
                59.3123199,
                26.8964839
              ],
              [
                59.3017746,
                26.8908613
              ],
              [
                59.2938015,
                26.8867827
              ],
              [
                59.2875383,
                26.883748
              ],
              [
                59.2810628,
                26.8808175
              ],
              [
                59.278382,
                26.8787781
              ],
              [
                59.2418888,
                26.8711683
              ],
              [
                59.1911391,
                26.8520914
              ],
              [
                59.1274372,
                26.8281047
              ],
              [
                59.1257704,
                26.8272779
              ],
              [
                59.0827181,
                26.805882
              ],
              [
                59.0163255,
                26.7711614
              ],
              [
                59.0149321,
                26.7703258
              ],
              [
                59.0115988,
                26.768942
              ],
              [
                58.9913563,
                26.7590837
              ],
              [
                58.9904926,
                26.7586629
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555154,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قصرقند",
          "name:en": "Qasr-e-Ghand County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q15729684"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.4049331,
                26.1702697
              ],
              [
                60.3920965,
                26.1650626
              ],
              [
                60.3814601,
                26.1594441
              ],
              [
                60.3710746,
                26.1525104
              ],
              [
                60.3636932,
                26.1461156
              ],
              [
                60.3615474,
                26.1424173
              ],
              [
                60.3610258,
                26.1380775
              ],
              [
                60.364294,
                26.1283933
              ],
              [
                60.363931,
                26.1225341
              ],
              [
                60.3652683,
                26.1044807
              ],
              [
                60.3636019,
                26.1011511
              ],
              [
                60.3630483,
                26.100864
              ],
              [
                60.3627682,
                26.1000383
              ],
              [
                60.3324888,
                26.0761484
              ],
              [
                60.3308223,
                26.0747574
              ],
              [
                60.3283222,
                26.0708717
              ],
              [
                60.3280421,
                26.0697589
              ],
              [
                60.3283222,
                26.0655949
              ],
              [
                60.3294355,
                26.0630912
              ],
              [
                60.3319356,
                26.0564234
              ],
              [
                60.335332,
                26.025229
              ],
              [
                60.3167557,
                25.9921027
              ],
              [
                60.3322755,
                25.9388553
              ],
              [
                60.3657525,
                25.9086451
              ],
              [
                60.4618829,
                25.8573705
              ],
              [
                60.5243676,
                25.8159639
              ],
              [
                60.5445268,
                25.7382838
              ],
              [
                60.5447958,
                25.7232097
              ],
              [
                60.5451391,
                25.7119197
              ],
              [
                60.5477141,
                25.7054236
              ],
              [
                60.5540655,
                25.6992366
              ],
              [
                60.559902,
                25.697071
              ],
              [
                60.5652235,
                25.6956788
              ],
              [
                60.5834196,
                25.6969163
              ],
              [
                60.5971525,
                25.69011
              ],
              [
                60.6194685,
                25.6768057
              ],
              [
                60.6259917,
                25.6750264
              ],
              [
                60.6316566,
                25.6724736
              ],
              [
                60.6356048,
                25.6689151
              ],
              [
                60.6375789,
                25.665898
              ],
              [
                60.6402396,
                25.6652791
              ],
              [
                60.6436729,
                25.6656659
              ],
              [
                60.6479644,
                25.6681415
              ],
              [
                60.6509685,
                25.6686057
              ],
              [
                60.6546592,
                25.6665943
              ],
              [
                60.6599807,
                25.6605599
              ],
              [
                60.663237,
                25.6586244
              ],
              [
                60.6680379,
                25.6620303
              ],
              [
                60.6759366,
                25.672181
              ],
              [
                60.6801663,
                25.680448
              ],
              [
                60.6848036,
                25.6843976
              ],
              [
                60.6904701,
                25.6869762
              ],
              [
                60.6960147,
                25.6916534
              ],
              [
                60.7034038,
                25.6995517
              ],
              [
                60.7028784,
                25.7013028
              ],
              [
                60.7038571,
                25.7049704
              ],
              [
                60.7090603,
                25.7124541
              ],
              [
                60.7142903,
                25.7251112
              ],
              [
                60.7179571,
                25.7312139
              ],
              [
                60.7315334,
                25.745691
              ],
              [
                60.7398908,
                25.755697
              ],
              [
                60.7505923,
                25.7639582
              ],
              [
                60.7693454,
                25.7629485
              ],
              [
                60.7805565,
                25.7645089
              ],
              [
                60.7941117,
                25.7766242
              ],
              [
                60.8070555,
                25.7841497
              ],
              [
                60.8206107,
                25.7857098
              ],
              [
                60.8317199,
                25.7850674
              ],
              [
                60.8381408,
                25.7833237
              ],
              [
                60.844498,
                25.7786209
              ],
              [
                60.8591926,
                25.7732891
              ],
              [
                60.8784648,
                25.7765143
              ],
              [
                60.8868581,
                25.777083
              ],
              [
                60.8935338,
                25.7762111
              ],
              [
                60.8980183,
                25.7779549
              ],
              [
                60.9032162,
                25.7796986
              ],
              [
                60.912236,
                25.7802493
              ],
              [
                60.9205424,
                25.7792397
              ],
              [
                60.9374657,
                25.7751557
              ],
              [
                60.9537863,
                25.7665136
              ],
              [
                60.9742066,
                25.7519439
              ],
              [
                60.9791777,
                25.7499684
              ],
              [
                60.9902234,
                25.7424169
              ],
              [
                60.9996676,
                25.7378329
              ],
              [
                61.0314812,
                25.7377958
              ],
              [
                61.0437115,
                25.7371532
              ],
              [
                61.0616607,
                25.7390496
              ],
              [
                61.1753057,
                25.8056964
              ],
              [
                61.1766923,
                25.8054096
              ],
              [
                61.1950254,
                25.8015296
              ],
              [
                61.197252,
                25.8015296
              ],
              [
                61.1986388,
                25.8012518
              ],
              [
                61.2036389,
                25.8012518
              ],
              [
                61.2047521,
                25.8009739
              ],
              [
                61.2064186,
                25.8009739
              ],
              [
                61.2069717,
                25.8006962
              ],
              [
                61.2089186,
                25.8006962
              ],
              [
                61.2097523,
                25.8004185
              ],
              [
                61.2108585,
                25.8004185
              ],
              [
                61.2116921,
                25.8001406
              ],
              [
                61.2141921,
                25.8001407
              ],
              [
                61.215032,
                25.7998629
              ],
              [
                61.2172515,
                25.7998629
              ],
              [
                61.2180852,
                25.7995851
              ],
              [
                61.2214188,
                25.799585
              ],
              [
                61.2225321,
                25.7993072
              ],
              [
                61.2241985,
                25.7993072
              ],
              [
                61.2253048,
                25.7990295
              ],
              [
                61.2278048,
                25.7990295
              ],
              [
                61.2289182,
                25.7987517
              ],
              [
                61.2314182,
                25.7987517
              ],
              [
                61.2325315,
                25.7984739
              ],
              [
                61.2529908,
                25.7817285
              ],
              [
                61.2724067,
                25.7838153
              ],
              [
                61.2855583,
                25.7916739
              ],
              [
                61.3010912,
                25.7982885
              ],
              [
                61.3026087,
                25.8180678
              ],
              [
                61.3022524,
                25.9108581
              ],
              [
                61.3022524,
                25.9111451
              ],
              [
                61.2539911,
                25.9257714
              ],
              [
                61.2472461,
                25.9305866
              ],
              [
                61.2444734,
                25.9394776
              ],
              [
                61.244193,
                25.9400339
              ],
              [
                61.2439134,
                25.9722529
              ],
              [
                61.2441931,
                25.9728092
              ],
              [
                61.2444735,
                25.9744781
              ],
              [
                61.244747,
                25.976147
              ],
              [
                61.2450267,
                25.9775288
              ],
              [
                61.2453065,
                25.9800321
              ],
              [
                61.2455798,
                25.9814228
              ],
              [
                61.2461401,
                25.9850299
              ],
              [
                61.2464135,
                25.9922529
              ],
              [
                61.2433603,
                25.9991979
              ],
              [
                61.2433604,
                26.0064211
              ],
              [
                61.24364,
                26.0066992
              ],
              [
                61.2450269,
                26.0164172
              ],
              [
                61.2450268,
                26.0217024
              ],
              [
                61.2453066,
                26.0219716
              ],
              [
                61.2464136,
                26.0278043
              ],
              [
                61.2466934,
                26.0283606
              ],
              [
                61.2469738,
                26.0300296
              ],
              [
                61.2480801,
                26.0344805
              ],
              [
                61.2483597,
                26.0353061
              ],
              [
                61.2486403,
                26.0361406
              ],
              [
                61.2491934,
                26.0386442
              ],
              [
                61.2494738,
                26.0394788
              ],
              [
                61.250027,
                26.0422606
              ],
              [
                61.250027,
                26.0430862
              ],
              [
                61.2575265,
                26.0828139
              ],
              [
                61.2575265,
                26.090864
              ],
              [
                61.257807,
                26.0916986
              ],
              [
                61.2583601,
                26.0955936
              ],
              [
                61.2583602,
                26.1003142
              ],
              [
                61.2580867,
                26.1016963
              ],
              [
                61.2580867,
                26.1019745
              ],
              [
                61.2580866,
                26.1022527
              ],
              [
                61.2580867,
                26.1025399
              ],
              [
                61.257807,
                26.1075388
              ],
              [
                61.2569734,
                26.1125378
              ],
              [
                61.2564203,
                26.1147546
              ],
              [
                61.2519734,
                26.1255873
              ],
              [
                61.2508601,
                26.1283696
              ],
              [
                61.2111346,
                26.1972581
              ],
              [
                61.2111347,
                26.1975364
              ],
              [
                61.2103937,
                26.1997673
              ],
              [
                61.2100284,
                26.2008666
              ],
              [
                61.2075286,
                26.2397624
              ],
              [
                61.2072481,
                26.244206
              ],
              [
                61.2069684,
                26.2464234
              ],
              [
                61.2061348,
                26.2497539
              ],
              [
                61.1991948,
                26.2580937
              ],
              [
                61.1950284,
                26.2600418
              ],
              [
                61.1941956,
                26.2603111
              ],
              [
                61.1947997,
                26.2648524
              ],
              [
                61.1674407,
                26.2710099
              ],
              [
                61.1501409,
                26.2726647
              ],
              [
                61.1266186,
                26.2787388
              ],
              [
                61.1157113,
                26.2815095
              ],
              [
                61.0878185,
                26.2823694
              ],
              [
                61.0809426,
                26.2850023
              ],
              [
                60.9805718,
                26.2589292
              ],
              [
                60.9758521,
                26.2630946
              ],
              [
                60.9755724,
                26.2636512
              ],
              [
                60.9747389,
                26.2650338
              ],
              [
                60.9652926,
                26.2792093
              ],
              [
                60.964459,
                26.2797569
              ],
              [
                60.956959,
                26.2911496
              ],
              [
                60.9561262,
                26.2919846
              ],
              [
                60.9541863,
                26.295872
              ],
              [
                60.9377931,
                26.3192061
              ],
              [
                60.9366798,
                26.3211544
              ],
              [
                60.9347399,
                26.3233721
              ],
              [
                60.9258461,
                26.3330957
              ],
              [
                60.9693414,
                26.3998472
              ],
              [
                60.9472607,
                26.4025562
              ],
              [
                60.9195146,
                26.3983631
              ],
              [
                60.8963021,
                26.3934135
              ],
              [
                60.8677477,
                26.3905378
              ],
              [
                60.8614381,
                26.3967496
              ],
              [
                60.8587849,
                26.4026875
              ],
              [
                60.8591079,
                26.4115121
              ],
              [
                60.8589116,
                26.4159636
              ],
              [
                60.8569876,
                26.424397
              ],
              [
                60.8495807,
                26.4333802
              ],
              [
                60.8470916,
                26.4382989
              ],
              [
                60.8428749,
                26.4571605
              ],
              [
                60.8367837,
                26.4651378
              ],
              [
                60.8343091,
                26.4662202
              ],
              [
                60.8313298,
                26.4690526
              ],
              [
                60.8303117,
                26.4726091
              ],
              [
                60.8294105,
                26.4772573
              ],
              [
                60.8288097,
                26.4794085
              ],
              [
                60.8260199,
                26.4827891
              ],
              [
                60.8158493,
                26.4868604
              ],
              [
                60.8101415,
                26.4878207
              ],
              [
                60.8056354,
                26.4877823
              ],
              [
                60.8007001,
                26.4867068
              ],
              [
                60.7948851,
                26.4850935
              ],
              [
                60.7910442,
                26.4847094
              ],
              [
                60.7897996,
                26.4854392
              ],
              [
                60.7856369,
                26.4881664
              ],
              [
                60.7829761,
                26.4907782
              ],
              [
                60.7798862,
                26.4941198
              ],
              [
                60.7786846,
                26.494888
              ],
              [
                60.7761954,
                26.4970004
              ],
              [
                60.7761311,
                26.4986519
              ],
              [
                60.7748921,
                26.4994168
              ],
              [
                60.7706165,
                26.5006298
              ],
              [
                60.7696611,
                26.5006939
              ],
              [
                60.7579935,
                26.5019325
              ],
              [
                60.7554906,
                26.501375
              ],
              [
                60.7523863,
                26.5005985
              ],
              [
                60.7505344,
                26.5015401
              ],
              [
                60.7483752,
                26.5017225
              ],
              [
                60.7447803,
                26.5021641
              ],
              [
                60.7392367,
                26.5023082
              ],
              [
                60.7323139,
                26.5025482
              ],
              [
                60.7254143,
                26.5030482
              ],
              [
                60.7191327,
                26.5035955
              ],
              [
                60.7133464,
                26.504402
              ],
              [
                60.708963,
                26.5049782
              ],
              [
                60.7033936,
                26.5065142
              ],
              [
                60.6994742,
                26.5076
              ],
              [
                60.6948489,
                26.509021
              ],
              [
                60.6896211,
                26.5108646
              ],
              [
                60.6853821,
                26.5122574
              ],
              [
                60.6800338,
                26.5129104
              ],
              [
                60.6765832,
                26.5137168
              ],
              [
                60.6735387,
                26.5145426
              ],
              [
                60.6699155,
                26.5155026
              ],
              [
                60.6670172,
                26.5165107
              ],
              [
                60.6636954,
                26.5161266
              ],
              [
                60.6592693,
                26.5151102
              ],
              [
                60.6557708,
                26.5134685
              ],
              [
                60.6543433,
                26.5123837
              ],
              [
                60.6532231,
                26.5101832
              ],
              [
                60.6525213,
                26.5070818
              ],
              [
                60.6523696,
                26.5048535
              ],
              [
                60.6531197,
                26.5018193
              ],
              [
                60.6532327,
                26.4997831
              ],
              [
                60.6540457,
                26.4976028
              ],
              [
                60.6560039,
                26.4964987
              ],
              [
                60.6584278,
                26.4938383
              ],
              [
                60.6611987,
                26.4908709
              ],
              [
                60.6626754,
                26.4894594
              ],
              [
                60.6646626,
                26.4863968
              ],
              [
                60.6660138,
                26.4828919
              ],
              [
                60.6665287,
                26.4795598
              ],
              [
                60.658846,
                26.464544
              ],
              [
                60.6571493,
                26.4598763
              ],
              [
                60.657258,
                26.4576117
              ],
              [
                60.6620645,
                26.4480399
              ],
              [
                60.667007,
                26.4397624
              ],
              [
                60.6725471,
                26.4319043
              ],
              [
                60.6771717,
                26.423298
              ],
              [
                60.6785697,
                26.4186284
              ],
              [
                60.6796347,
                26.4126717
              ],
              [
                60.6784772,
                26.4080529
              ],
              [
                60.6714504,
                26.3927176
              ],
              [
                60.6686816,
                26.3867497
              ],
              [
                60.6617183,
                26.3758352
              ],
              [
                60.6561613,
                26.3655913
              ],
              [
                60.6533503,
                26.3617269
              ],
              [
                60.6489212,
                26.3579254
              ],
              [
                60.6429814,
                26.3549365
              ],
              [
                60.6389575,
                26.3537571
              ],
              [
                60.6333972,
                26.3532765
              ],
              [
                60.5797256,
                26.3580933
              ],
              [
                60.5752787,
                26.3575366
              ],
              [
                60.5727786,
                26.3575367
              ],
              [
                60.5722192,
                26.3572583
              ],
              [
                60.5697188,
                26.3572583
              ],
              [
                60.5691657,
                26.3569799
              ],
              [
                60.5441661,
                26.3525445
              ],
              [
                60.5433328,
                26.3519878
              ],
              [
                60.5422195,
                26.3517005
              ],
              [
                60.5311064,
                26.3461517
              ],
              [
                60.528333,
                26.3450382
              ],
              [
                60.5183332,
                26.3417072
              ],
              [
                60.5172198,
                26.3417072
              ],
              [
                60.5013868,
                26.3383761
              ],
              [
                60.4899937,
                26.3383762
              ],
              [
                60.4897202,
                26.3380979
              ],
              [
                60.4858272,
                26.3380978
              ],
              [
                60.4855537,
                26.3378195
              ],
              [
                60.4841603,
                26.3378195
              ],
              [
                60.4838873,
                26.3375412
              ],
              [
                60.4822205,
                26.3375411
              ],
              [
                60.4813873,
                26.3372628
              ],
              [
                60.4799938,
                26.3372629
              ],
              [
                60.4791603,
                26.3369846
              ],
              [
                60.4777739,
                26.3369845
              ],
              [
                60.4769407,
                26.3367062
              ],
              [
                60.4755539,
                26.3367062
              ],
              [
                60.4663874,
                26.3342102
              ],
              [
                60.4652741,
                26.3342102
              ],
              [
                60.4619408,
                26.3333752
              ],
              [
                60.4605473,
                26.3333752
              ],
              [
                60.4597141,
                26.3330968
              ],
              [
                60.4580474,
                26.3330969
              ],
              [
                60.4577743,
                26.3328185
              ],
              [
                60.4555473,
                26.3328186
              ],
              [
                60.454161,
                26.3322619
              ],
              [
                60.4522141,
                26.3317052
              ],
              [
                60.451941,
                26.3311485
              ],
              [
                60.4488808,
                26.3275392
              ],
              [
                60.4474945,
                26.3242083
              ],
              [
                60.447286,
                26.3132143
              ],
              [
                60.4615711,
                26.2808091
              ],
              [
                60.44122,
                26.2404796
              ],
              [
                60.4133278,
                26.1817045
              ],
              [
                60.4049331,
                26.1702697
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555174,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کنارک",
          "name:en": "Konarak County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2643224",
          "wikipedia": "en:Konarak County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.5956901,
                25.5049894
              ],
              [
                59.5957021,
                25.501035
              ],
              [
                59.5966258,
                25.4905997
              ],
              [
                59.5964576,
                25.4809207
              ],
              [
                59.5976433,
                25.475917
              ],
              [
                59.6013115,
                25.4698596
              ],
              [
                59.6042297,
                25.4659316
              ],
              [
                59.6120622,
                25.4571481
              ],
              [
                59.6179639,
                25.4497502
              ],
              [
                59.6228271,
                25.441597
              ],
              [
                59.6279181,
                25.4339035
              ],
              [
                59.6316193,
                25.427463
              ],
              [
                59.6334326,
                25.4220429
              ],
              [
                59.6366035,
                25.4182958
              ],
              [
                59.6431445,
                25.4148266
              ],
              [
                59.6509667,
                25.4115959
              ],
              [
                59.6631155,
                25.4144966
              ],
              [
                59.6872268,
                25.4160074
              ],
              [
                59.7069431,
                25.4183975
              ],
              [
                59.7160792,
                25.416046
              ],
              [
                59.7226992,
                25.4110521
              ],
              [
                59.7302577,
                25.4021784
              ],
              [
                59.6708527,
                25.1832546
              ],
              [
                60.0326439,
                25.1402345
              ],
              [
                60.1703289,
                25.1239543
              ],
              [
                60.2594613,
                25.1104875
              ],
              [
                60.3603641,
                25.0952406
              ],
              [
                60.3881286,
                25.0867423
              ],
              [
                60.4193982,
                25.0794386
              ],
              [
                60.4515016,
                25.0763731
              ],
              [
                60.5236134,
                25.0742948
              ],
              [
                60.5323649,
                25.2849915
              ],
              [
                60.5350651,
                25.3527926
              ],
              [
                60.5747358,
                25.4326319
              ],
              [
                60.5780736,
                25.4389198
              ],
              [
                60.5823428,
                25.4517113
              ],
              [
                60.5828298,
                25.4576069
              ],
              [
                60.5823886,
                25.4679516
              ],
              [
                60.5818074,
                25.4768525
              ],
              [
                60.5809594,
                25.4801005
              ],
              [
                60.5798915,
                25.4855629
              ],
              [
                60.5809206,
                25.4891031
              ],
              [
                60.5874555,
                25.4958943
              ],
              [
                60.5964392,
                25.5002004
              ],
              [
                60.6081848,
                25.5035459
              ],
              [
                60.6180711,
                25.5097733
              ],
              [
                60.6260042,
                25.518013
              ],
              [
                60.6279447,
                25.5215153
              ],
              [
                60.6305644,
                25.5265936
              ],
              [
                60.6306976,
                25.530159
              ],
              [
                60.6312435,
                25.5388506
              ],
              [
                60.6322138,
                25.5432277
              ],
              [
                60.6360948,
                25.5468169
              ],
              [
                60.6402669,
                25.549268
              ],
              [
                60.6436628,
                25.5530321
              ],
              [
                60.6456033,
                25.5564459
              ],
              [
                60.6455766,
                25.557943
              ],
              [
                60.6504546,
                25.5643235
              ],
              [
                60.6538505,
                25.567562
              ],
              [
                60.663553,
                25.5718506
              ],
              [
                60.6739347,
                25.5711504
              ],
              [
                60.6799478,
                25.5713258
              ],
              [
                60.6858259,
                25.5734263
              ],
              [
                60.6922872,
                25.5716885
              ],
              [
                60.6970536,
                25.5721932
              ],
              [
                60.7013929,
                25.5757015
              ],
              [
                60.7066485,
                25.5777221
              ],
              [
                60.7147405,
                25.5785096
              ],
              [
                60.7195366,
                25.5776269
              ],
              [
                60.7268811,
                25.5740866
              ],
              [
                60.7322529,
                25.5742616
              ],
              [
                60.7426287,
                25.5776269
              ],
              [
                60.7484502,
                25.5785895
              ],
              [
                60.7502937,
                25.5771893
              ],
              [
                60.7553267,
                25.57763
              ],
              [
                60.7598021,
                25.5800773
              ],
              [
                60.7650631,
                25.5849155
              ],
              [
                60.7598669,
                25.5886986
              ],
              [
                60.753682,
                25.5920726
              ],
              [
                60.7468213,
                25.5970632
              ],
              [
                60.7412157,
                25.6034053
              ],
              [
                60.7274567,
                25.620132
              ],
              [
                60.7148187,
                25.6292296
              ],
              [
                60.693008,
                25.6422774
              ],
              [
                60.6818988,
                25.6515571
              ],
              [
                60.6774144,
                25.6537621
              ],
              [
                60.6722165,
                25.6546808
              ],
              [
                60.663237,
                25.6586244
              ],
              [
                60.6599807,
                25.6605599
              ],
              [
                60.6546592,
                25.6665943
              ],
              [
                60.6509685,
                25.6686057
              ],
              [
                60.6479644,
                25.6681415
              ],
              [
                60.6436729,
                25.6656659
              ],
              [
                60.6402396,
                25.6652791
              ],
              [
                60.6375789,
                25.665898
              ],
              [
                60.6356048,
                25.6689151
              ],
              [
                60.6316566,
                25.6724736
              ],
              [
                60.6259917,
                25.6750264
              ],
              [
                60.6194685,
                25.6768057
              ],
              [
                60.5971525,
                25.69011
              ],
              [
                60.5834196,
                25.6969163
              ],
              [
                60.5652235,
                25.6956788
              ],
              [
                60.559902,
                25.697071
              ],
              [
                60.5540655,
                25.6992366
              ],
              [
                60.5477141,
                25.7054236
              ],
              [
                60.5451391,
                25.7119197
              ],
              [
                60.5447958,
                25.7232097
              ],
              [
                60.5445268,
                25.7382838
              ],
              [
                60.5132102,
                25.7429259
              ],
              [
                60.504198,
                25.7445494
              ],
              [
                60.5003356,
                25.7455545
              ],
              [
                60.4964732,
                25.7436217
              ],
              [
                60.4921817,
                25.7429259
              ],
              [
                60.4840278,
                25.7440082
              ],
              [
                60.4577636,
                25.7448587
              ],
              [
                60.4287522,
                25.7476423
              ],
              [
                60.3585433,
                25.7451679
              ],
              [
                60.3135674,
                25.7451685
              ],
              [
                60.3033542,
                25.7430805
              ],
              [
                60.2979468,
                25.744936
              ],
              [
                60.2951144,
                25.7492653
              ],
              [
                60.2508258,
                25.7631799
              ],
              [
                60.2458476,
                25.7624842
              ],
              [
                60.2406676,
                25.7634453
              ],
              [
                60.2368354,
                25.7623296
              ],
              [
                60.2311706,
                25.7566866
              ],
              [
                60.2260207,
                25.7480284
              ],
              [
                60.2247333,
                25.7443175
              ],
              [
                60.2208709,
                25.7388283
              ],
              [
                60.2110004,
                25.7301687
              ],
              [
                60.2023315,
                25.725684
              ],
              [
                60.1866828,
                25.7190044
              ],
              [
                60.171089,
                25.7157863
              ],
              [
                60.13916,
                25.7119197
              ],
              [
                60.1151274,
                25.7111464
              ],
              [
                60.0981324,
                25.7119202
              ],
              [
                60.0844,
                25.7157863
              ],
              [
                60.0598524,
                25.7278491
              ],
              [
                60.0473211,
                25.7380552
              ],
              [
                60.0335882,
                25.7413024
              ],
              [
                60.0092123,
                25.7533626
              ],
              [
                59.9989126,
                25.7541357
              ],
              [
                59.9850081,
                25.7563002
              ],
              [
                59.9717897,
                25.7637215
              ],
              [
                59.9637221,
                25.7649579
              ],
              [
                59.9518774,
                25.7666584
              ],
              [
                59.9395178,
                25.7651125
              ],
              [
                59.9299048,
                25.7657308
              ],
              [
                59.9177168,
                25.7595469
              ],
              [
                59.8940275,
                25.7600107
              ],
              [
                59.8835562,
                25.7641849
              ],
              [
                59.868965,
                25.7644941
              ],
              [
                59.8464773,
                25.766813
              ],
              [
                59.825363,
                25.7646487
              ],
              [
                59.8133467,
                25.7658854
              ],
              [
                59.8007726,
                25.7694729
              ],
              [
                59.795494,
                25.7597787
              ],
              [
                59.790249,
                25.7533187
              ],
              [
                59.7870826,
                25.7500384
              ],
              [
                59.7684573,
                25.7446267
              ],
              [
                59.7641462,
                25.7423099
              ],
              [
                59.7617197,
                25.7410703
              ],
              [
                59.7599143,
                25.7398316
              ],
              [
                59.7558965,
                25.7366886
              ],
              [
                59.7548579,
                25.735459
              ],
              [
                59.750905,
                25.7306326
              ],
              [
                59.7488021,
                25.7288155
              ],
              [
                59.7451114,
                25.7268438
              ],
              [
                59.7418772,
                25.7260974
              ],
              [
                59.7350298,
                25.7246893
              ],
              [
                59.7294869,
                25.7246105
              ],
              [
                59.721582,
                25.7243011
              ],
              [
                59.7118876,
                25.7230566
              ],
              [
                59.7088871,
                25.7230952
              ],
              [
                59.7044932,
                25.7239696
              ],
              [
                59.6998449,
                25.7238256
              ],
              [
                59.6927547,
                25.7251427
              ],
              [
                59.6906496,
                25.7251748
              ],
              [
                59.6871746,
                25.7243128
              ],
              [
                59.68482,
                25.7239177
              ],
              [
                59.6808457,
                25.7223783
              ],
              [
                59.6755671,
                25.7198652
              ],
              [
                59.6736574,
                25.718686
              ],
              [
                59.6710395,
                25.7164048
              ],
              [
                59.669834,
                25.7130787
              ],
              [
                59.6687221,
                25.7098317
              ],
              [
                59.666748,
                25.7010926
              ],
              [
                59.6655035,
                25.6986177
              ],
              [
                59.6642264,
                25.6946302
              ],
              [
                59.6632596,
                25.690008
              ],
              [
                59.6597631,
                25.6819951
              ],
              [
                59.6528647,
                25.671624
              ],
              [
                59.6510403,
                25.6654822
              ],
              [
                59.6492833,
                25.659607
              ],
              [
                59.6476507,
                25.6561113
              ],
              [
                59.6438312,
                25.6513143
              ],
              [
                59.6404526,
                25.648216
              ],
              [
                59.6341259,
                25.6439174
              ],
              [
                59.6325336,
                25.6428307
              ],
              [
                59.6304664,
                25.6372227
              ],
              [
                59.6290346,
                25.6307399
              ],
              [
                59.6271379,
                25.6265917
              ],
              [
                59.6254634,
                25.6244246
              ],
              [
                59.6217629,
                25.6218497
              ],
              [
                59.6143754,
                25.6180254
              ],
              [
                59.6080513,
                25.6147569
              ],
              [
                59.6061134,
                25.6119563
              ],
              [
                59.6057246,
                25.6084857
              ],
              [
                59.6065914,
                25.6053369
              ],
              [
                59.610262,
                25.6029374
              ],
              [
                59.6145271,
                25.6030606
              ],
              [
                59.6165964,
                25.6021354
              ],
              [
                59.6158428,
                25.6000559
              ],
              [
                59.6103572,
                25.5940069
              ],
              [
                59.6082973,
                25.5939682
              ],
              [
                59.6040487,
                25.5955163
              ],
              [
                59.5986414,
                25.5980708
              ],
              [
                59.5946202,
                25.6006611
              ],
              [
                59.5933198,
                25.6017862
              ],
              [
                59.5916032,
                25.6022506
              ],
              [
                59.5904874,
                25.6019023
              ],
              [
                59.5894575,
                25.6010896
              ],
              [
                59.5868825,
                25.5981869
              ],
              [
                59.5837497,
                25.5962517
              ],
              [
                59.5813036,
                25.5940456
              ],
              [
                59.5817756,
                25.5912201
              ],
              [
                59.5829773,
                25.5883946
              ],
              [
                59.584594,
                25.5877866
              ],
              [
                59.5882618,
                25.5879943
              ],
              [
                59.5901012,
                25.5883559
              ],
              [
                59.5915616,
                25.5884711
              ],
              [
                59.5921849,
                25.5875405
              ],
              [
                59.5928709,
                25.5842251
              ],
              [
                59.5935434,
                25.5760175
              ],
              [
                59.595899,
                25.569353
              ],
              [
                59.5987062,
                25.5638072
              ],
              [
                59.6031448,
                25.5580994
              ],
              [
                59.605627,
                25.5495824
              ],
              [
                59.6111157,
                25.5395236
              ],
              [
                59.6148219,
                25.5355145
              ],
              [
                59.6163644,
                25.5318831
              ],
              [
                59.6173942,
                25.524101
              ],
              [
                59.616143,
                25.5202187
              ],
              [
                59.6147561,
                25.5167874
              ],
              [
                59.6115493,
                25.5140902
              ],
              [
                59.6084212,
                25.5130057
              ],
              [
                59.6038341,
                25.5117705
              ],
              [
                59.5993088,
                25.5090513
              ],
              [
                59.5956901,
                25.5049894
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555221,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مهرستان",
          "name:en": "Mehrestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1074463",
          "wikipedia": "en:Mehrestan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                61.0368201,
                27.4349991
              ],
              [
                61.0427508,
                27.4207036
              ],
              [
                61.0532409,
                27.4041094
              ],
              [
                61.0596083,
                27.3929549
              ],
              [
                61.0705319,
                27.3805384
              ],
              [
                61.0791009,
                27.3690356
              ],
              [
                61.0946272,
                27.3504234
              ],
              [
                61.1076735,
                27.3309053
              ],
              [
                61.1229513,
                27.3177896
              ],
              [
                61.1436396,
                27.3039473
              ],
              [
                61.151139,
                27.2989471
              ],
              [
                61.1553062,
                27.2961681
              ],
              [
                61.156139,
                27.2958894
              ],
              [
                61.1811385,
                27.2786678
              ],
              [
                61.1900316,
                27.2711678
              ],
              [
                61.1916989,
                27.2703315
              ],
              [
                61.2165868,
                27.2559997
              ],
              [
                61.2225666,
                27.2552507
              ],
              [
                61.2340162,
                27.2512724
              ],
              [
                61.2389944,
                27.2489833
              ],
              [
                61.2425993,
                27.2416577
              ],
              [
                61.2380825,
                27.2323174
              ],
              [
                61.2361439,
                27.2261697
              ],
              [
                61.2364174,
                27.2250546
              ],
              [
                61.2295813,
                27.2022674
              ],
              [
                61.2250505,
                27.1981475
              ],
              [
                61.2183213,
                27.1987626
              ],
              [
                61.2037377,
                27.1809754
              ],
              [
                61.1796479,
                27.1714449
              ],
              [
                61.1899054,
                27.1599546
              ],
              [
                61.1929684,
                27.1508856
              ],
              [
                61.197909,
                27.1431522
              ],
              [
                61.1947058,
                27.1352298
              ],
              [
                61.200199,
                27.1280495
              ],
              [
                61.2005106,
                27.1089665
              ],
              [
                61.199684,
                27.0938223
              ],
              [
                61.1916024,
                27.0978095
              ],
              [
                61.1840628,
                27.1002407
              ],
              [
                61.175823,
                27.0906129
              ],
              [
                61.1670444,
                27.0958958
              ],
              [
                61.1476706,
                27.0956561
              ],
              [
                61.1423491,
                27.0898488
              ],
              [
                61.1334489,
                27.0850326
              ],
              [
                61.1369969,
                27.0823321
              ],
              [
                61.1381271,
                27.0772709
              ],
              [
                61.1434001,
                27.0724875
              ],
              [
                61.1428604,
                27.0634782
              ],
              [
                61.1248309,
                27.0543967
              ],
              [
                61.1181156,
                27.0486143
              ],
              [
                61.1111378,
                27.0403716
              ],
              [
                61.1038432,
                27.0355919
              ],
              [
                61.0965681,
                27.028336
              ],
              [
                61.0925996,
                27.0207954
              ],
              [
                61.0912995,
                27.0143003
              ],
              [
                61.0930898,
                27.0042326
              ],
              [
                61.0953807,
                27.001373
              ],
              [
                61.1020087,
                26.9993374
              ],
              [
                61.1197722,
                26.9986837
              ],
              [
                61.1347234,
                26.9983902
              ],
              [
                61.1469494,
                26.9998163
              ],
              [
                61.1541866,
                26.9993747
              ],
              [
                61.1643186,
                26.9987558
              ],
              [
                61.173003,
                26.9982246
              ],
              [
                61.1860624,
                26.9978588
              ],
              [
                61.2049774,
                26.9980002
              ],
              [
                61.2210641,
                26.9991812
              ],
              [
                61.2385986,
                27.0002706
              ],
              [
                61.2554843,
                26.9992265
              ],
              [
                61.280571,
                26.9976707
              ],
              [
                61.2973887,
                26.9957563
              ],
              [
                61.3126025,
                26.9856889
              ],
              [
                61.3273308,
                26.97565
              ],
              [
                61.334778,
                26.9717102
              ],
              [
                61.34126,
                26.9678303
              ],
              [
                61.3508038,
                26.9659292
              ],
              [
                61.3582085,
                26.9642057
              ],
              [
                61.3613751,
                26.959323
              ],
              [
                61.3644706,
                26.9522981
              ],
              [
                61.3706866,
                26.9506999
              ],
              [
                61.3780362,
                26.9502372
              ],
              [
                61.3877974,
                26.9522696
              ],
              [
                61.3967673,
                26.9583227
              ],
              [
                61.4031703,
                26.959904
              ],
              [
                61.4119905,
                26.9593463
              ],
              [
                61.4250905,
                26.9568619
              ],
              [
                61.4356436,
                26.9548686
              ],
              [
                61.4442259,
                26.9559784
              ],
              [
                61.4572182,
                26.9568069
              ],
              [
                61.4690037,
                26.956387
              ],
              [
                61.4846479,
                26.9534026
              ],
              [
                61.4950419,
                26.9494283
              ],
              [
                61.5158544,
                26.9464398
              ],
              [
                61.5243389,
                26.9470295
              ],
              [
                61.5294855,
                26.9431076
              ],
              [
                61.5297651,
                26.9425503
              ],
              [
                61.5303182,
                26.9422718
              ],
              [
                61.5417114,
                26.9297695
              ],
              [
                61.5469848,
                26.9219951
              ],
              [
                61.5478185,
                26.9214379
              ],
              [
                61.5478184,
                26.9208806
              ],
              [
                61.5497646,
                26.9178248
              ],
              [
                61.5542115,
                26.909772
              ],
              [
                61.5547647,
                26.9094934
              ],
              [
                61.576711,
                26.8756023
              ],
              [
                61.5772641,
                26.8747666
              ],
              [
                61.5772641,
                26.874488
              ],
              [
                61.5853245,
                26.8658784
              ],
              [
                61.592544,
                26.861987
              ],
              [
                61.621563,
                26.851009
              ],
              [
                61.6215644,
                26.8510085
              ],
              [
                61.6215658,
                26.851008
              ],
              [
                61.5477734,
                26.8554692
              ],
              [
                61.5077778,
                26.8498498
              ],
              [
                61.5077773,
                26.8498497
              ],
              [
                61.5034467,
                26.7955151
              ],
              [
                61.5267761,
                26.7830943
              ],
              [
                61.513379,
                26.7675732
              ],
              [
                61.5310875,
                26.7609734
              ],
              [
                61.5498869,
                26.7161157
              ],
              [
                61.5779291,
                26.7137979
              ],
              [
                61.6126875,
                26.6825099
              ],
              [
                61.6160503,
                26.6582203
              ],
              [
                61.6121206,
                26.6416321
              ],
              [
                61.6121968,
                26.6255553
              ],
              [
                61.6028088,
                26.604137
              ],
              [
                61.5855259,
                26.5756074
              ],
              [
                61.5992864,
                26.5682548
              ],
              [
                61.611788,
                26.5604578
              ],
              [
                61.626214,
                26.5616633
              ],
              [
                61.636943,
                26.5614989
              ],
              [
                61.6499959,
                26.5531235
              ],
              [
                61.659824,
                26.549257
              ],
              [
                61.668153,
                26.5562269
              ],
              [
                61.6849065,
                26.5567387
              ],
              [
                61.7090612,
                26.5619258
              ],
              [
                61.7587851,
                26.5673414
              ],
              [
                61.7759512,
                26.5542901
              ],
              [
                61.7670248,
                26.5341729
              ],
              [
                61.7299966,
                26.5242145
              ],
              [
                61.7319629,
                26.5117279
              ],
              [
                61.7361397,
                26.5044688
              ],
              [
                61.7483827,
                26.5009672
              ],
              [
                61.7643156,
                26.4988331
              ],
              [
                61.7785986,
                26.4984188
              ],
              [
                61.7843977,
                26.4964213
              ],
              [
                61.793653,
                26.5000996
              ],
              [
                61.806969,
                26.5024322
              ],
              [
                61.810883,
                26.5064658
              ],
              [
                61.818639,
                26.5064863
              ],
              [
                61.8252843,
                26.5146349
              ],
              [
                61.835086,
                26.5177383
              ],
              [
                61.8429958,
                26.5123757
              ],
              [
                61.8502958,
                26.5140308
              ],
              [
                61.863654,
                26.5238767
              ],
              [
                61.8788995,
                26.5206998
              ],
              [
                61.8902634,
                26.5210061
              ],
              [
                61.904392,
                26.5259543
              ],
              [
                61.9041496,
                26.5157736
              ],
              [
                61.9110459,
                26.512608
              ],
              [
                61.9104198,
                26.5051351
              ],
              [
                61.9116286,
                26.4910907
              ],
              [
                61.9333526,
                26.4890703
              ],
              [
                61.9435665,
                26.4899859
              ],
              [
                61.946725,
                26.4849402
              ],
              [
                61.9574033,
                26.4842081
              ],
              [
                61.9731874,
                26.4874283
              ],
              [
                61.9900662,
                26.4894967
              ],
              [
                62.0043883,
                26.4965735
              ],
              [
                62.0157502,
                26.4968688
              ],
              [
                62.031096,
                26.5033345
              ],
              [
                62.0434651,
                26.501409
              ],
              [
                62.060258,
                26.495414
              ],
              [
                62.0869978,
                26.4940999
              ],
              [
                62.1014605,
                26.4957822
              ],
              [
                62.1117245,
                26.4902349
              ],
              [
                62.123088,
                26.4926649
              ],
              [
                62.1302953,
                26.4862558
              ],
              [
                62.1410684,
                26.4865776
              ],
              [
                62.1498987,
                26.4907627
              ],
              [
                62.157865,
                26.4945381
              ],
              [
                62.1806437,
                26.5026153
              ],
              [
                62.2028801,
                26.5112641
              ],
              [
                62.2342941,
                26.5207794
              ],
              [
                62.2359863,
                26.5212919
              ],
              [
                62.2484537,
                26.5225588
              ],
              [
                62.2637702,
                26.5134147
              ],
              [
                62.2767735,
                26.5119559
              ],
              [
                62.2968638,
                26.5164399
              ],
              [
                62.308373,
                26.5183063
              ],
              [
                62.3095655,
                26.5176589
              ],
              [
                62.311023,
                26.516539
              ],
              [
                62.312261,
                26.51861
              ],
              [
                62.314217,
                26.519898
              ],
              [
                62.319102,
                26.520998
              ],
              [
                62.32274,
                26.52099
              ],
              [
                62.328443,
                26.520227
              ],
              [
                62.330521,
                26.520647
              ],
              [
                62.335595,
                26.522677
              ],
              [
                62.337731,
                26.524174
              ],
              [
                62.345272,
                26.526755
              ],
              [
                62.349126,
                26.527994
              ],
              [
                62.353272,
                26.529062
              ],
              [
                62.356796,
                26.530514
              ],
              [
                62.357025,
                26.530637
              ],
              [
                62.357958,
                26.531404
              ],
              [
                62.360062,
                26.533653
              ],
              [
                62.361364,
                26.534868
              ],
              [
                62.3634,
                26.536268
              ],
              [
                62.36503,
                26.537282
              ],
              [
                62.366782,
                26.537821
              ],
              [
                62.367759,
                26.538244
              ],
              [
                62.36926,
                26.538974
              ],
              [
                62.370225,
                26.539378
              ],
              [
                62.371392,
                26.539414
              ],
              [
                62.371772,
                26.539487
              ],
              [
                62.372402,
                26.539457
              ],
              [
                62.37335,
                26.539514
              ],
              [
                62.374445,
                26.539382
              ],
              [
                62.374767,
                26.539382
              ],
              [
                62.37541,
                26.539284
              ],
              [
                62.378635,
                26.538281
              ],
              [
                62.379806,
                26.537572
              ],
              [
                62.381406,
                26.536374
              ],
              [
                62.383007,
                26.535311
              ],
              [
                62.385214,
                26.533565
              ],
              [
                62.386146,
                26.533156
              ],
              [
                62.387944,
                26.532752
              ],
              [
                62.388766,
                26.532448
              ],
              [
                62.389793,
                26.532202
              ],
              [
                62.39026,
                26.532132
              ],
              [
                62.390638,
                26.532135
              ],
              [
                62.391412,
                26.532225
              ],
              [
                62.392471,
                26.532571
              ],
              [
                62.393463,
                26.532807
              ],
              [
                62.395674,
                26.533704
              ],
              [
                62.396336,
                26.53411
              ],
              [
                62.397049,
                26.534828
              ],
              [
                62.397537,
                26.535466
              ],
              [
                62.397874,
                26.536731
              ],
              [
                62.398267,
                26.537244
              ],
              [
                62.398423,
                26.537388
              ],
              [
                62.399114,
                26.537722
              ],
              [
                62.400095,
                26.537945
              ],
              [
                62.401227,
                26.53788
              ],
              [
                62.403715,
                26.53746
              ],
              [
                62.404411,
                26.53727
              ],
              [
                62.405144,
                26.536823
              ],
              [
                62.405781,
                26.536732
              ],
              [
                62.40651,
                26.536702
              ],
              [
                62.40739,
                26.536823
              ],
              [
                62.408031,
                26.536784
              ],
              [
                62.408534,
                26.53662
              ],
              [
                62.408806,
                26.536485
              ],
              [
                62.409707,
                26.53592
              ],
              [
                62.410823,
                26.53532
              ],
              [
                62.4112419,
                26.5351691
              ],
              [
                62.4111376,
                26.5370971
              ],
              [
                62.4037953,
                26.5423574
              ],
              [
                62.3937531,
                26.5540005
              ],
              [
                62.3766678,
                26.5726549
              ],
              [
                62.3573156,
                26.594965
              ],
              [
                62.3522701,
                26.6008106
              ],
              [
                62.34516,
                26.6090475
              ],
              [
                62.2900319,
                26.6446427
              ],
              [
                62.2493327,
                26.6625378
              ],
              [
                62.1986455,
                26.6687126
              ],
              [
                62.173143,
                26.66848
              ],
              [
                62.157794,
                26.6700881
              ],
              [
                62.1430284,
                26.6768869
              ],
              [
                62.1382431,
                26.678301
              ],
              [
                62.1239276,
                26.6805605
              ],
              [
                62.1073807,
                26.6801065
              ],
              [
                62.086097,
                26.6859924
              ],
              [
                62.068343,
                26.6930195
              ],
              [
                62.0501842,
                26.703304
              ],
              [
                62.0286188,
                26.7598284
              ],
              [
                62.0005424,
                26.7811497
              ],
              [
                61.9911238,
                26.8071593
              ],
              [
                61.9617704,
                26.8136375
              ],
              [
                61.9198213,
                26.8284219
              ],
              [
                61.8890889,
                26.8185621
              ],
              [
                61.8509257,
                26.8390339
              ],
              [
                61.8326778,
                26.8367322
              ],
              [
                61.8286667,
                26.8608811
              ],
              [
                61.8286667,
                26.8647724
              ],
              [
                61.828387,
                26.8653295
              ],
              [
                61.828387,
                26.8667135
              ],
              [
                61.82728,
                26.8692119
              ],
              [
                61.82728,
                26.8700476
              ],
              [
                61.8239471,
                26.876716
              ],
              [
                61.8167205,
                26.9036597
              ],
              [
                61.8156074,
                26.9331032
              ],
              [
                61.8156074,
                26.9364377
              ],
              [
                61.8131076,
                26.9928305
              ],
              [
                61.8120012,
                26.9961654
              ],
              [
                61.810888,
                26.9994912
              ],
              [
                61.810888,
                27.0039317
              ],
              [
                61.8111677,
                27.004498
              ],
              [
                61.810888,
                27.0097655
              ],
              [
                61.8150545,
                27.0378298
              ],
              [
                61.8175547,
                27.04699
              ],
              [
                61.8181078,
                27.0478261
              ],
              [
                61.8181078,
                27.0483834
              ],
              [
                61.8247807,
                27.0569954
              ],
              [
                61.8750658,
                27.0832997
              ],
              [
                61.882734,
                27.0900242
              ],
              [
                61.8879779,
                27.0952295
              ],
              [
                61.8918057,
                27.0978638
              ],
              [
                61.9048019,
                27.1046782
              ],
              [
                61.9292891,
                27.1174172
              ],
              [
                61.938773,
                27.122389
              ],
              [
                61.9460566,
                27.1271509
              ],
              [
                61.945354,
                27.1328772
              ],
              [
                61.9369928,
                27.1410608
              ],
              [
                61.9339461,
                27.142131
              ],
              [
                61.9258645,
                27.1449498
              ],
              [
                61.9071559,
                27.15095
              ],
              [
                61.8948822,
                27.163295
              ],
              [
                61.8826388,
                27.1640226
              ],
              [
                61.8787765,
                27.1636408
              ],
              [
                61.8632411,
                27.160968
              ],
              [
                61.8426417,
                27.1569969
              ],
              [
                61.8323421,
                27.1548586
              ],
              [
                61.8280234,
                27.1552911
              ],
              [
                61.8235885,
                27.1566723
              ],
              [
                61.8207219,
                27.1613509
              ],
              [
                61.8206039,
                27.1699367
              ],
              [
                61.8202403,
                27.1915994
              ],
              [
                61.8210535,
                27.2206442
              ],
              [
                61.8121718,
                27.2474571
              ],
              [
                61.7967222,
                27.2613441
              ],
              [
                61.7681722,
                27.2793617
              ],
              [
                61.7537658,
                27.2881351
              ],
              [
                61.7485713,
                27.2929265
              ],
              [
                61.7271995,
                27.319391
              ],
              [
                61.7210197,
                27.3284652
              ],
              [
                61.7174039,
                27.3350913
              ],
              [
                61.7088495,
                27.3488511
              ],
              [
                61.7010475,
                27.3628358
              ],
              [
                61.6932963,
                27.3765692
              ],
              [
                61.6870967,
                27.3887482
              ],
              [
                61.6831793,
                27.3984679
              ],
              [
                61.6801842,
                27.4060757
              ],
              [
                61.655217,
                27.4018573
              ],
              [
                61.6336505,
                27.396421
              ],
              [
                61.6156672,
                27.3888168
              ],
              [
                61.6025732,
                27.372987
              ],
              [
                61.5921638,
                27.3655297
              ],
              [
                61.5837891,
                27.3589998
              ],
              [
                61.5726106,
                27.3560978
              ],
              [
                61.5539334,
                27.3527778
              ],
              [
                61.5362904,
                27.3491798
              ],
              [
                61.521792,
                27.3475026
              ],
              [
                61.5195751,
                27.347412
              ],
              [
                61.5137385,
                27.350957
              ],
              [
                61.5044152,
                27.3582147
              ],
              [
                61.4972199,
                27.3629669
              ],
              [
                61.4829873,
                27.3806151
              ],
              [
                61.4662539,
                27.3992431
              ],
              [
                61.4568791,
                27.4126682
              ],
              [
                61.449108,
                27.4237381
              ],
              [
                61.4373667,
                27.4430118
              ],
              [
                61.4299655,
                27.4550439
              ],
              [
                61.4202688,
                27.4765982
              ],
              [
                61.4097975,
                27.4986791
              ],
              [
                61.3903998,
                27.5177109
              ],
              [
                61.3763907,
                27.5295597
              ],
              [
                61.3656233,
                27.5366091
              ],
              [
                61.3514122,
                27.5454335
              ],
              [
                61.3436832,
                27.5500099
              ],
              [
                61.3469694,
                27.5371199
              ],
              [
                61.3469694,
                27.5273017
              ],
              [
                61.3435362,
                27.5204512
              ],
              [
                61.3268703,
                27.5119274
              ],
              [
                61.3121824,
                27.507827
              ],
              [
                61.2952331,
                27.506048
              ],
              [
                61.2355612,
                27.5035516
              ],
              [
                61.2067061,
                27.4810156
              ],
              [
                61.1907576,
                27.4804055
              ],
              [
                61.1516792,
                27.4639609
              ],
              [
                61.0873843,
                27.4504002
              ],
              [
                61.0624443,
                27.4374356
              ],
              [
                61.0368201,
                27.4349991
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555228,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میرجاوه",
          "name:en": "Mirjaveh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q10878105",
          "wikipedia": "en:Mirjaveh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.7074553,
                29.020101
              ],
              [
                60.7145251,
                28.9903758
              ],
              [
                60.7229367,
                28.9499583
              ],
              [
                60.7295497,
                28.9177559
              ],
              [
                60.7198374,
                28.9117596
              ],
              [
                60.7212198,
                28.8642281
              ],
              [
                60.7360266,
                28.8646703
              ],
              [
                60.7460074,
                28.8599432
              ],
              [
                60.7676123,
                28.8663239
              ],
              [
                60.7917237,
                28.8441288
              ],
              [
                60.8119002,
                28.8007672
              ],
              [
                60.8416894,
                28.8353724
              ],
              [
                60.8558552,
                28.8000847
              ],
              [
                60.8561286,
                28.7984177
              ],
              [
                60.8611286,
                28.7870369
              ],
              [
                60.8658552,
                28.7828649
              ],
              [
                60.8664085,
                28.7828649
              ],
              [
                60.8665487,
                28.7825855
              ],
              [
                60.8669616,
                28.7823062
              ],
              [
                60.867242,
                28.7820359
              ],
              [
                60.8675217,
                28.7809185
              ],
              [
                60.8680748,
                28.7806482
              ],
              [
                60.8694616,
                28.7778639
              ],
              [
                60.869742,
                28.7775845
              ],
              [
                60.8711288,
                28.7764763
              ],
              [
                60.8711288,
                28.7761968
              ],
              [
                60.8791882,
                28.7617528
              ],
              [
                60.8808547,
                28.7600858
              ],
              [
                60.8825219,
                28.7567519
              ],
              [
                60.8825219,
                28.7345321
              ],
              [
                60.8828015,
                28.7289818
              ],
              [
                60.8864077,
                28.7067537
              ],
              [
                60.892521,
                28.6867516
              ],
              [
                60.910301,
                28.6764804
              ],
              [
                60.9111347,
                28.6759218
              ],
              [
                60.9114073,
                28.6759218
              ],
              [
                60.9205809,
                28.6695249
              ],
              [
                60.9214145,
                28.6689753
              ],
              [
                60.9294669,
                28.6631371
              ],
              [
                60.9453,
                28.6514696
              ],
              [
                60.9511337,
                28.6484245
              ],
              [
                60.9621752,
                28.6443019
              ],
              [
                60.9972462,
                28.6311984
              ],
              [
                61.1048466,
                28.6111133
              ],
              [
                61.1236106,
                28.5997349
              ],
              [
                61.1328753,
                28.5958896
              ],
              [
                61.1386433,
                28.5953654
              ],
              [
                61.1401621,
                28.5951393
              ],
              [
                61.146571,
                28.5957233
              ],
              [
                61.1469768,
                28.5975851
              ],
              [
                61.1478104,
                28.5978554
              ],
              [
                61.1678099,
                28.597585
              ],
              [
                61.1689233,
                28.5973058
              ],
              [
                61.1714234,
                28.5973057
              ],
              [
                61.1828094,
                28.5973057
              ],
              [
                61.1867033,
                28.597585
              ],
              [
                61.1942035,
                28.597585
              ],
              [
                61.1997558,
                28.5978552
              ],
              [
                61.2019761,
                28.5981346
              ],
              [
                61.2050363,
                28.5981345
              ],
              [
                61.2069762,
                28.5984138
              ],
              [
                61.209756,
                28.5984138
              ],
              [
                61.2114225,
                28.598693
              ],
              [
                61.2133694,
                28.598693
              ],
              [
                61.2142029,
                28.5989723
              ],
              [
                61.2178163,
                28.5989723
              ],
              [
                61.2186492,
                28.5992515
              ],
              [
                61.220589,
                28.5992515
              ],
              [
                61.2222562,
                28.5995308
              ],
              [
                61.2258688,
                28.5995308
              ],
              [
                61.227536,
                28.5998101
              ],
              [
                61.2308689,
                28.5998101
              ],
              [
                61.2317026,
                28.6000894
              ],
              [
                61.2344822,
                28.6000893
              ],
              [
                61.2461488,
                28.6023055
              ],
              [
                61.2555951,
                28.6050802
              ],
              [
                61.2742017,
                28.6150802
              ],
              [
                61.3061477,
                28.6481442
              ],
              [
                61.3083751,
                28.649811
              ],
              [
                61.3094813,
                28.6511984
              ],
              [
                61.310315,
                28.651748
              ],
              [
                61.3150417,
                28.6553608
              ],
              [
                61.3189277,
                28.658415
              ],
              [
                61.3222613,
                28.6617485
              ],
              [
                61.3230941,
                28.6628657
              ],
              [
                61.3257853,
                28.669224
              ],
              [
                61.3292076,
                28.6773082
              ],
              [
                61.3297615,
                28.6792543
              ],
              [
                61.3489276,
                28.7081401
              ],
              [
                61.3600411,
                28.7186999
              ],
              [
                61.3872674,
                28.7384233
              ],
              [
                61.3936534,
                28.7403605
              ],
              [
                61.3942073,
                28.7406398
              ],
              [
                61.3981005,
                28.7406398
              ],
              [
                61.4014333,
                28.7278631
              ],
              [
                61.4017066,
                28.7131405
              ],
              [
                61.3992066,
                28.7014725
              ],
              [
                61.3989338,
                28.7009138
              ],
              [
                61.3983737,
                28.6950844
              ],
              [
                61.3983737,
                28.6923093
              ],
              [
                61.4042066,
                28.6798037
              ],
              [
                61.4275459,
                28.6503602
              ],
              [
                61.4319858,
                28.6467474
              ],
              [
                61.4811584,
                28.6145302
              ],
              [
                61.4828248,
                28.6136923
              ],
              [
                61.5003251,
                28.6011967
              ],
              [
                61.5201332,
                28.5819525
              ],
              [
                61.5686594,
                28.5637852
              ],
              [
                61.5791912,
                28.56118
              ],
              [
                61.5781036,
                28.5606392
              ],
              [
                61.5769967,
                28.5603599
              ],
              [
                61.5745803,
                28.558039
              ],
              [
                61.5730432,
                28.5565625
              ],
              [
                61.5739753,
                28.5532238
              ],
              [
                61.5785115,
                28.5518147
              ],
              [
                61.7503735,
                28.532957
              ],
              [
                61.8634291,
                28.5100541
              ],
              [
                61.8791839,
                28.5053737
              ],
              [
                61.9687025,
                28.4383844
              ],
              [
                61.9842049,
                28.437987
              ],
              [
                61.9941736,
                28.4382032
              ],
              [
                62.002244,
                28.4435913
              ],
              [
                62.009463,
                28.4442909
              ],
              [
                62.0144872,
                28.4515433
              ],
              [
                62.0314497,
                28.4760251
              ],
              [
                62.0379519,
                28.4787491
              ],
              [
                62.0480459,
                28.4919075
              ],
              [
                62.0559548,
                28.5075105
              ],
              [
                62.0564037,
                28.5085945
              ],
              [
                62.053927,
                28.508701
              ],
              [
                62.051237,
                28.509218
              ],
              [
                62.04778,
                28.510038
              ],
              [
                62.045738,
                28.509891
              ],
              [
                62.043906,
                28.510134
              ],
              [
                62.041238,
                28.511889
              ],
              [
                62.039443,
                28.513304
              ],
              [
                62.037666,
                28.514558
              ],
              [
                62.036393,
                28.515545
              ],
              [
                62.035275,
                28.516521
              ],
              [
                62.034614,
                28.517482
              ],
              [
                62.033993,
                28.518496
              ],
              [
                62.033382,
                28.518967
              ],
              [
                62.028099,
                28.521185
              ],
              [
                62.026827,
                28.521906
              ],
              [
                62.021964,
                28.524955
              ],
              [
                62.021144,
                28.525361
              ],
              [
                62.020265,
                28.525713
              ],
              [
                62.018954,
                28.526154
              ],
              [
                62.018101,
                28.526619
              ],
              [
                62.017284,
                28.527122
              ],
              [
                62.016437,
                28.527571
              ],
              [
                62.015386,
                28.528282
              ],
              [
                62.014443,
                28.528674
              ],
              [
                62.013299,
                28.52928
              ],
              [
                62.012857,
                28.529737
              ],
              [
                62.012412,
                28.53007
              ],
              [
                62.011689,
                28.530741
              ],
              [
                62.010775,
                28.531446
              ],
              [
                62.009789,
                28.532056
              ],
              [
                62.007879,
                28.533411
              ],
              [
                62.005117,
                28.534734
              ],
              [
                62.003177,
                28.535511
              ],
              [
                62.001558,
                28.535894
              ],
              [
                61.998214,
                28.536813
              ],
              [
                61.996343,
                28.537391
              ],
              [
                61.994272,
                28.538124
              ],
              [
                61.992297,
                28.539012
              ],
              [
                61.988238,
                28.541265
              ],
              [
                61.986971,
                28.541671
              ],
              [
                61.985809,
                28.5419
              ],
              [
                61.982435,
                28.542321
              ],
              [
                61.98109,
                28.542259
              ],
              [
                61.979988,
                28.542338
              ],
              [
                61.978902,
                28.542576
              ],
              [
                61.977627,
                28.542627
              ],
              [
                61.975447,
                28.5421
              ],
              [
                61.973303,
                28.54152
              ],
              [
                61.972447,
                28.54098
              ],
              [
                61.97151,
                28.539838
              ],
              [
                61.970588,
                28.539347
              ],
              [
                61.970155,
                28.5393
              ],
              [
                61.968803,
                28.539386
              ],
              [
                61.966893,
                28.539584
              ],
              [
                61.965243,
                28.539843
              ],
              [
                61.963961,
                28.539926
              ],
              [
                61.963024,
                28.539914
              ],
              [
                61.962536,
                28.540038
              ],
              [
                61.961846,
                28.540314
              ],
              [
                61.960431,
                28.540974
              ],
              [
                61.959285,
                28.54123
              ],
              [
                61.959129,
                28.541559
              ],
              [
                61.958786,
                28.543118
              ],
              [
                61.958172,
                28.544276
              ],
              [
                61.957947,
                28.544475
              ],
              [
                61.957727,
                28.54458
              ],
              [
                61.956531,
                28.544868
              ],
              [
                61.954762,
                28.545593
              ],
              [
                61.954391,
                28.545817
              ],
              [
                61.953731,
                28.546006
              ],
              [
                61.952666,
                28.546634
              ],
              [
                61.952368,
                28.546867
              ],
              [
                61.950786,
                28.547503
              ],
              [
                61.950043,
                28.548012
              ],
              [
                61.949215,
                28.548248
              ],
              [
                61.948695,
                28.548533
              ],
              [
                61.947721,
                28.548741
              ],
              [
                61.946331,
                28.549174
              ],
              [
                61.942525,
                28.55129
              ],
              [
                61.942133,
                28.551466
              ],
              [
                61.941409,
                28.551906
              ],
              [
                61.940136,
                28.552395
              ],
              [
                61.938638,
                28.552686
              ],
              [
                61.937142,
                28.553065
              ],
              [
                61.934974,
                28.553502
              ],
              [
                61.934219,
                28.553735
              ],
              [
                61.933721,
                28.553821
              ],
              [
                61.931711,
                28.554671
              ],
              [
                61.930031,
                28.554984
              ],
              [
                61.929755,
                28.555078
              ],
              [
                61.928243,
                28.555805
              ],
              [
                61.927682,
                28.556146
              ],
              [
                61.927028,
                28.556637
              ],
              [
                61.925235,
                28.557425
              ],
              [
                61.924611,
                28.557786
              ],
              [
                61.924066,
                28.558025
              ],
              [
                61.923146,
                28.558293
              ],
              [
                61.922392,
                28.559012
              ],
              [
                61.920795,
                28.559876
              ],
              [
                61.92053,
                28.559954
              ],
              [
                61.91925,
                28.560042
              ],
              [
                61.917929,
                28.560425
              ],
              [
                61.916891,
                28.560924
              ],
              [
                61.916473,
                28.561009
              ],
              [
                61.916111,
                28.561002
              ],
              [
                61.915362,
                28.56114
              ],
              [
                61.914099,
                28.561549
              ],
              [
                61.913599,
                28.561827
              ],
              [
                61.913082,
                28.562136
              ],
              [
                61.911776,
                28.563062
              ],
              [
                61.911354,
                28.563288
              ],
              [
                61.910018,
                28.564377
              ],
              [
                61.908863,
                28.565632
              ],
              [
                61.90818,
                28.566256
              ],
              [
                61.906142,
                28.568356
              ],
              [
                61.90529,
                28.569044
              ],
              [
                61.904465,
                28.570327
              ],
              [
                61.903545,
                28.571593
              ],
              [
                61.902994,
                28.572179
              ],
              [
                61.902107,
                28.57289
              ],
              [
                61.898557,
                28.574599
              ],
              [
                61.897912,
                28.574996
              ],
              [
                61.897227,
                28.575251
              ],
              [
                61.896315,
                28.576139
              ],
              [
                61.89547,
                28.576853
              ],
              [
                61.894999,
                28.577431
              ],
              [
                61.894093,
                28.577935
              ],
              [
                61.893449,
                28.578756
              ],
              [
                61.89181,
                28.579994
              ],
              [
                61.89169,
                28.580285
              ],
              [
                61.891551,
                28.581144
              ],
              [
                61.891423,
                28.581467
              ],
              [
                61.890657,
                28.58232
              ],
              [
                61.89026,
                28.582885
              ],
              [
                61.889783,
                28.583906
              ],
              [
                61.889506,
                28.584705
              ],
              [
                61.88926,
                28.585563
              ],
              [
                61.889282,
                28.586435
              ],
              [
                61.889215,
                28.587303
              ],
              [
                61.888864,
                28.588336
              ],
              [
                61.888667,
                28.588653
              ],
              [
                61.888658,
                28.588896
              ],
              [
                61.888745,
                28.58914
              ],
              [
                61.888744,
                28.58953
              ],
              [
                61.888636,
                28.58986
              ],
              [
                61.888543,
                28.589951
              ],
              [
                61.888392,
                28.590615
              ],
              [
                61.888359,
                28.59091
              ],
              [
                61.888387,
                28.591323
              ],
              [
                61.88804,
                28.5918
              ],
              [
                61.888071,
                28.592027
              ],
              [
                61.888188,
                28.592331
              ],
              [
                61.887924,
                28.593108
              ],
              [
                61.88761,
                28.593338
              ],
              [
                61.887338,
                28.593429
              ],
              [
                61.88707,
                28.593339
              ],
              [
                61.886688,
                28.59333
              ],
              [
                61.886606,
                28.593478
              ],
              [
                61.886329,
                28.593607
              ],
              [
                61.886322,
                28.593772
              ],
              [
                61.886174,
                28.593941
              ],
              [
                61.885987,
                28.593992
              ],
              [
                61.885975,
                28.594088
              ],
              [
                61.885872,
                28.594146
              ],
              [
                61.885846,
                28.594212
              ],
              [
                61.885677,
                28.594348
              ],
              [
                61.885326,
                28.594424
              ],
              [
                61.885303,
                28.594561
              ],
              [
                61.885059,
                28.594666
              ],
              [
                61.884978,
                28.594817
              ],
              [
                61.884862,
                28.59488
              ],
              [
                61.884878,
                28.595055
              ],
              [
                61.884783,
                28.595004
              ],
              [
                61.884739,
                28.595048
              ],
              [
                61.884748,
                28.595212
              ],
              [
                61.884687,
                28.595221
              ],
              [
                61.884616,
                28.595316
              ],
              [
                61.884636,
                28.595478
              ],
              [
                61.884341,
                28.59544
              ],
              [
                61.884274,
                28.595365
              ],
              [
                61.884117,
                28.595344
              ],
              [
                61.883982,
                28.595199
              ],
              [
                61.883875,
                28.595524
              ],
              [
                61.883824,
                28.595533
              ],
              [
                61.883717,
                28.595758
              ],
              [
                61.883821,
                28.595922
              ],
              [
                61.883559,
                28.596108
              ],
              [
                61.883492,
                28.596262
              ],
              [
                61.88323,
                28.596202
              ],
              [
                61.883038,
                28.596206
              ],
              [
                61.882181,
                28.596624
              ],
              [
                61.881934,
                28.596857
              ],
              [
                61.881558,
                28.596942
              ],
              [
                61.881071,
                28.59769
              ],
              [
                61.880735,
                28.598087
              ],
              [
                61.880448,
                28.598327
              ],
              [
                61.879879,
                28.598625
              ],
              [
                61.879461,
                28.598955
              ],
              [
                61.87944,
                28.599039
              ],
              [
                61.879032,
                28.599278
              ],
              [
                61.87882,
                28.599353
              ],
              [
                61.878555,
                28.599632
              ],
              [
                61.878373,
                28.599965
              ],
              [
                61.878147,
                28.600116
              ],
              [
                61.877715,
                28.60021
              ],
              [
                61.877499,
                28.600344
              ],
              [
                61.877409,
                28.600545
              ],
              [
                61.877009,
                28.600844
              ],
              [
                61.876852,
                28.601083
              ],
              [
                61.876285,
                28.601114
              ],
              [
                61.87622,
                28.601041
              ],
              [
                61.876097,
                28.601019
              ],
              [
                61.87592,
                28.601053
              ],
              [
                61.875715,
                28.601305
              ],
              [
                61.874448,
                28.601929
              ],
              [
                61.874116,
                28.602325
              ],
              [
                61.873862,
                28.602546
              ],
              [
                61.873741,
                28.602735
              ],
              [
                61.873447,
                28.602989
              ],
              [
                61.873313,
                28.603267
              ],
              [
                61.872859,
                28.603714
              ],
              [
                61.872602,
                28.60404
              ],
              [
                61.872365,
                28.604129
              ],
              [
                61.871984,
                28.604507
              ],
              [
                61.87102,
                28.60487
              ],
              [
                61.870757,
                28.60482
              ],
              [
                61.870301,
                28.604912
              ],
              [
                61.869859,
                28.604891
              ],
              [
                61.869405,
                28.605019
              ],
              [
                61.869134,
                28.605244
              ],
              [
                61.868933,
                28.60551
              ],
              [
                61.868716,
                28.605656
              ],
              [
                61.868349,
                28.606314
              ],
              [
                61.868183,
                28.6065
              ],
              [
                61.868016,
                28.606563
              ],
              [
                61.86735,
                28.606453
              ],
              [
                61.86689,
                28.606426
              ],
              [
                61.866529,
                28.606531
              ],
              [
                61.866282,
                28.60675
              ],
              [
                61.865865,
                28.606924
              ],
              [
                61.865552,
                28.607215
              ],
              [
                61.865415,
                28.60726
              ],
              [
                61.865087,
                28.607805
              ],
              [
                61.864964,
                28.607927
              ],
              [
                61.86475,
                28.60846
              ],
              [
                61.864538,
                28.608728
              ],
              [
                61.864499,
                28.609015
              ],
              [
                61.864261,
                28.609362
              ],
              [
                61.864208,
                28.609676
              ],
              [
                61.864038,
                28.609844
              ],
              [
                61.863917,
                28.610046
              ],
              [
                61.863835,
                28.610393
              ],
              [
                61.863656,
                28.610759
              ],
              [
                61.863538,
                28.611466
              ],
              [
                61.863093,
                28.612071
              ],
              [
                61.862739,
                28.612435
              ],
              [
                61.862289,
                28.612759
              ],
              [
                61.862245,
                28.612951
              ],
              [
                61.861998,
                28.613288
              ],
              [
                61.861622,
                28.613502
              ],
              [
                61.861468,
                28.613707
              ],
              [
                61.860801,
                28.614291
              ],
              [
                61.860636,
                28.614655
              ],
              [
                61.860411,
                28.614836
              ],
              [
                61.85818,
                28.617651
              ],
              [
                61.857844,
                28.617975
              ],
              [
                61.857248,
                28.618321
              ],
              [
                61.856735,
                28.618725
              ],
              [
                61.855896,
                28.619173
              ],
              [
                61.855497,
                28.619291
              ],
              [
                61.854818,
                28.619681
              ],
              [
                61.85328,
                28.620404
              ],
              [
                61.852476,
                28.621048
              ],
              [
                61.851794,
                28.621421
              ],
              [
                61.851531,
                28.621542
              ],
              [
                61.851283,
                28.621499
              ],
              [
                61.850752,
                28.621538
              ],
              [
                61.8503,
                28.621868
              ],
              [
                61.849848,
                28.621889
              ],
              [
                61.849477,
                28.621964
              ],
              [
                61.849305,
                28.622225
              ],
              [
                61.848964,
                28.622181
              ],
              [
                61.848161,
                28.621822
              ],
              [
                61.847151,
                28.621
              ],
              [
                61.846716,
                28.620849
              ],
              [
                61.846379,
                28.620933
              ],
              [
                61.845932,
                28.621225
              ],
              [
                61.845456,
                28.621465
              ],
              [
                61.844892,
                28.621992
              ],
              [
                61.842851,
                28.62312
              ],
              [
                61.84253,
                28.623088
              ],
              [
                61.841788,
                28.622784
              ],
              [
                61.84114,
                28.62307
              ],
              [
                61.840173,
                28.623314
              ],
              [
                61.839248,
                28.62384
              ],
              [
                61.838505,
                28.624172
              ],
              [
                61.838241,
                28.624322
              ],
              [
                61.8378,
                28.624696
              ],
              [
                61.836924,
                28.625106
              ],
              [
                61.836279,
                28.625477
              ],
              [
                61.835902,
                28.625745
              ],
              [
                61.834495,
                28.627148
              ],
              [
                61.833286,
                28.628247
              ],
              [
                61.831688,
                28.62936
              ],
              [
                61.830792,
                28.630251
              ],
              [
                61.830022,
                28.631124
              ],
              [
                61.828974,
                28.632657
              ],
              [
                61.828787,
                28.632792
              ],
              [
                61.82733,
                28.635435
              ],
              [
                61.825693,
                28.637794
              ],
              [
                61.82522,
                28.638443
              ],
              [
                61.823894,
                28.639571
              ],
              [
                61.823506,
                28.640124
              ],
              [
                61.823077,
                28.641293
              ],
              [
                61.822548,
                28.641659
              ],
              [
                61.821372,
                28.642108
              ],
              [
                61.82086,
                28.642207
              ],
              [
                61.820293,
                28.642531
              ],
              [
                61.818675,
                28.642833
              ],
              [
                61.817496,
                28.64338
              ],
              [
                61.815809,
                28.643934
              ],
              [
                61.813445,
                28.645429
              ],
              [
                61.812306,
                28.646367
              ],
              [
                61.811721,
                28.646952
              ],
              [
                61.81086,
                28.647567
              ],
              [
                61.810131,
                28.648321
              ],
              [
                61.809063,
                28.649074
              ],
              [
                61.808613,
                28.649707
              ],
              [
                61.807329,
                28.651795
              ],
              [
                61.80527,
                28.654843
              ],
              [
                61.804762,
                28.656278
              ],
              [
                61.804051,
                28.657783
              ],
              [
                61.803214,
                28.658718
              ],
              [
                61.802114,
                28.659814
              ],
              [
                61.801463,
                28.660639
              ],
              [
                61.801515,
                28.661218
              ],
              [
                61.798956,
                28.663657
              ],
              [
                61.796609,
                28.667074
              ],
              [
                61.795008,
                28.668316
              ],
              [
                61.794351,
                28.669087
              ],
              [
                61.793628,
                28.670742
              ],
              [
                61.793157,
                28.672016
              ],
              [
                61.792685,
                28.672617
              ],
              [
                61.791767,
                28.674291
              ],
              [
                61.791069,
                28.675622
              ],
              [
                61.790565,
                28.676767
              ],
              [
                61.790036,
                28.677416
              ],
              [
                61.7893,
                28.678061
              ],
              [
                61.788763,
                28.67876
              ],
              [
                61.788079,
                28.679929
              ],
              [
                61.787305,
                28.681035
              ],
              [
                61.78578,
                28.682643
              ],
              [
                61.783705,
                28.684358
              ],
              [
                61.782683,
                28.68585
              ],
              [
                61.781369,
                28.68702
              ],
              [
                61.78019,
                28.688872
              ],
              [
                61.779412,
                28.689353
              ],
              [
                61.778491,
                28.689795
              ],
              [
                61.776531,
                28.691547
              ],
              [
                61.774763,
                28.693575
              ],
              [
                61.772445,
                28.696026
              ],
              [
                61.771064,
                28.697677
              ],
              [
                61.770147,
                28.698878
              ],
              [
                61.768948,
                28.70075
              ],
              [
                61.767206,
                28.703089
              ],
              [
                61.7661061,
                28.7040119
              ],
              [
                61.765827,
                28.704246
              ],
              [
                61.765175,
                28.70511
              ],
              [
                61.763441,
                28.706287
              ],
              [
                61.761007,
                28.707492
              ],
              [
                61.760283,
                28.707791
              ],
              [
                61.75965,
                28.708146
              ],
              [
                61.758105,
                28.709357
              ],
              [
                61.757276,
                28.710495
              ],
              [
                61.756893,
                28.710756
              ],
              [
                61.756349,
                28.711453
              ],
              [
                61.755515,
                28.713246
              ],
              [
                61.754998,
                28.714139
              ],
              [
                61.75364,
                28.715636
              ],
              [
                61.7527704,
                28.7167938
              ],
              [
                61.7517497,
                28.7178175
              ],
              [
                61.749652,
                28.7195711
              ],
              [
                61.7479363,
                28.720991
              ],
              [
                61.7424884,
                28.724903
              ],
              [
                61.742123,
                28.7252422
              ],
              [
                61.7374667,
                28.7290271
              ],
              [
                61.7341531,
                28.7321689
              ],
              [
                61.7336487,
                28.7340023
              ],
              [
                61.7335667,
                28.7340676
              ],
              [
                61.7318849,
                28.7348933
              ],
              [
                61.7295108,
                28.7358961
              ],
              [
                61.7262666,
                28.7379935
              ],
              [
                61.7207324,
                28.7446806
              ],
              [
                61.7200695,
                28.7451587
              ],
              [
                61.7184759,
                28.7460235
              ],
              [
                61.7139104,
                28.749407
              ],
              [
                61.7118696,
                28.7509963
              ],
              [
                61.7093986,
                28.7529206
              ],
              [
                61.7091479,
                28.753129
              ],
              [
                61.7086035,
                28.7534952
              ],
              [
                61.7075275,
                28.7540924
              ],
              [
                61.7062871,
                28.7545423
              ],
              [
                61.7005668,
                28.7563702
              ],
              [
                61.6983321,
                28.7571763
              ],
              [
                61.693713,
                28.7605039
              ],
              [
                61.6923444,
                28.7614131
              ],
              [
                61.68579,
                28.7658934
              ],
              [
                61.6804332,
                28.7702517
              ],
              [
                61.6764129,
                28.7737288
              ],
              [
                61.662893,
                28.783828
              ],
              [
                61.6621274,
                28.7846584
              ],
              [
                61.6509537,
                28.7969023
              ],
              [
                61.6455716,
                28.8029274
              ],
              [
                61.6415842,
                28.8084473
              ],
              [
                61.6375978,
                28.8142299
              ],
              [
                61.636148,
                28.817046
              ],
              [
                61.6153858,
                28.8431877
              ],
              [
                61.6138381,
                28.847499
              ],
              [
                61.615819,
                28.852576
              ],
              [
                61.61075,
                28.859087
              ],
              [
                61.609372,
                28.861627
              ],
              [
                61.607915,
                28.864482
              ],
              [
                61.606351,
                28.86635
              ],
              [
                61.605341,
                28.867765
              ],
              [
                61.603861,
                28.870003
              ],
              [
                61.602083,
                28.872999
              ],
              [
                61.598882,
                28.87921
              ],
              [
                61.59857,
                28.879684
              ],
              [
                61.598002,
                28.88073
              ],
              [
                61.59462,
                28.887653
              ],
              [
                61.593198,
                28.890455
              ],
              [
                61.592543,
                28.89107
              ],
              [
                61.592181,
                28.891471
              ],
              [
                61.591953,
                28.891831
              ],
              [
                61.590967,
                28.894047
              ],
              [
                61.590309,
                28.895082
              ],
              [
                61.590033,
                28.895632
              ],
              [
                61.589641,
                28.896929
              ],
              [
                61.589478,
                28.897266
              ],
              [
                61.589262,
                28.897537
              ],
              [
                61.588797,
                28.897967
              ],
              [
                61.588317,
                28.898616
              ],
              [
                61.588003,
                28.899259
              ],
              [
                61.587813,
                28.899904
              ],
              [
                61.587627,
                28.901171
              ],
              [
                61.587425,
                28.901905
              ],
              [
                61.586846,
                28.903317
              ],
              [
                61.586253,
                28.904154
              ],
              [
                61.585928,
                28.904456
              ],
              [
                61.584988,
                28.904899
              ],
              [
                61.58476,
                28.90509
              ],
              [
                61.584584,
                28.905541
              ],
              [
                61.584534,
                28.906324
              ],
              [
                61.584421,
                28.906938
              ],
              [
                61.584211,
                28.907638
              ],
              [
                61.582117,
                28.90932
              ],
              [
                61.581416,
                28.909821
              ],
              [
                61.580724,
                28.910216
              ],
              [
                61.578897,
                28.911682
              ],
              [
                61.578014,
                28.912605
              ],
              [
                61.576976,
                28.914044
              ],
              [
                61.576158,
                28.915369
              ],
              [
                61.576034,
                28.915793
              ],
              [
                61.575985,
                28.916291
              ],
              [
                61.576096,
                28.917157
              ],
              [
                61.57606,
                28.919999
              ],
              [
                61.575979,
                28.92027
              ],
              [
                61.575756,
                28.920629
              ],
              [
                61.57509,
                28.921485
              ],
              [
                61.57471,
                28.921889
              ],
              [
                61.574418,
                28.922313
              ],
              [
                61.574176,
                28.922873
              ],
              [
                61.5714601,
                28.9274676
              ],
              [
                61.5709301,
                28.9304703
              ],
              [
                61.5709265,
                28.9325419
              ],
              [
                61.5693702,
                28.9356331
              ],
              [
                61.5606536,
                28.9546755
              ],
              [
                61.5536745,
                28.9702967
              ],
              [
                61.5531117,
                28.9710569
              ],
              [
                61.5515914,
                28.9730375
              ],
              [
                61.5516383,
                28.9732923
              ],
              [
                61.5520719,
                28.9739591
              ],
              [
                61.5519256,
                28.9742903
              ],
              [
                61.5512606,
                28.9756588
              ],
              [
                61.5505646,
                28.9770337
              ],
              [
                61.5501197,
                28.9778695
              ],
              [
                61.546843,
                28.9825705
              ],
              [
                61.5434936,
                28.9872967
              ],
              [
                61.5418131,
                28.9902658
              ],
              [
                61.5414125,
                28.9907662
              ],
              [
                61.5406778,
                28.9914271
              ],
              [
                61.5290709,
                28.9972294
              ],
              [
                61.517492,
                29.0030316
              ],
              [
                61.5142225,
                29.0056427
              ],
              [
                61.5111827,
                29.0081322
              ],
              [
                61.5076666,
                29.010965
              ],
              [
                61.504853,
                29.0132665
              ],
              [
                61.5017419,
                29.0157868
              ],
              [
                61.4991182,
                29.0179676
              ],
              [
                61.4978259,
                29.0189283
              ],
              [
                61.4960022,
                29.0192957
              ],
              [
                61.4820053,
                29.0227309
              ],
              [
                61.4787878,
                29.0236923
              ],
              [
                61.4794068,
                29.0257525
              ],
              [
                61.491773,
                29.041135
              ],
              [
                61.491818,
                29.041459
              ],
              [
                61.491948,
                29.041585
              ],
              [
                61.491929,
                29.041688
              ],
              [
                61.492125,
                29.041829
              ],
              [
                61.492144,
                29.042024
              ],
              [
                61.492261,
                29.042061
              ],
              [
                61.492356,
                29.042246
              ],
              [
                61.492347,
                29.04235
              ],
              [
                61.492227,
                29.042514
              ],
              [
                61.492194,
                29.042736
              ],
              [
                61.492271,
                29.043148
              ],
              [
                61.492355,
                29.043247
              ],
              [
                61.492461,
                29.043279
              ],
              [
                61.492442,
                29.043354
              ],
              [
                61.492532,
                29.043612
              ],
              [
                61.492355,
                29.043661
              ],
              [
                61.492318,
                29.043792
              ],
              [
                61.492356,
                29.043832
              ],
              [
                61.492703,
                29.04392
              ],
              [
                61.49291,
                29.044094
              ],
              [
                61.493479,
                29.043825
              ],
              [
                61.493837,
                29.04374
              ],
              [
                61.493905,
                29.043787
              ],
              [
                61.494164,
                29.043767
              ],
              [
                61.494197,
                29.043683
              ],
              [
                61.494353,
                29.043647
              ],
              [
                61.494495,
                29.043527
              ],
              [
                61.494576,
                29.043542
              ],
              [
                61.49472,
                29.043458
              ],
              [
                61.494949,
                29.043518
              ],
              [
                61.495028,
                29.043469
              ],
              [
                61.49524,
                29.043485
              ],
              [
                61.495479,
                29.04341
              ],
              [
                61.495507,
                29.043463
              ],
              [
                61.495657,
                29.043477
              ],
              [
                61.495857,
                29.043622
              ],
              [
                61.495839,
                29.043714
              ],
              [
                61.495912,
                29.043802
              ],
              [
                61.496124,
                29.04387
              ],
              [
                61.496313,
                29.043838
              ],
              [
                61.496371,
                29.043885
              ],
              [
                61.496582,
                29.043912
              ],
              [
                61.496722,
                29.043998
              ],
              [
                61.496791,
                29.044001
              ],
              [
                61.496853,
                29.0439
              ],
              [
                61.496951,
                29.044013
              ],
              [
                61.497297,
                29.044184
              ],
              [
                61.497491,
                29.044383
              ],
              [
                61.497442,
                29.0445
              ],
              [
                61.497522,
                29.044641
              ],
              [
                61.49775,
                29.044787
              ],
              [
                61.498045,
                29.0448
              ],
              [
                61.498307,
                29.044699
              ],
              [
                61.49855,
                29.0447
              ],
              [
                61.498761,
                29.04478
              ],
              [
                61.499011,
                29.044808
              ],
              [
                61.499277,
                29.044667
              ],
              [
                61.499365,
                29.044679
              ],
              [
                61.499479,
                29.044486
              ],
              [
                61.49987,
                29.044478
              ],
              [
                61.500041,
                29.044532
              ],
              [
                61.500165,
                29.044637
              ],
              [
                61.500264,
                29.044593
              ],
              [
                61.500759,
                29.044584
              ],
              [
                61.501281,
                29.044481
              ],
              [
                61.501554,
                29.044349
              ],
              [
                61.501652,
                29.044242
              ],
              [
                61.5023,
                29.044401
              ],
              [
                61.502568,
                29.044303
              ],
              [
                61.50281,
                29.044278
              ],
              [
                61.503047,
                29.04433
              ],
              [
                61.503183,
                29.044303
              ],
              [
                61.503316,
                29.044178
              ],
              [
                61.5034,
                29.044164
              ],
              [
                61.503399,
                29.044004
              ],
              [
                61.503578,
                29.043955
              ],
              [
                61.503707,
                29.043833
              ],
              [
                61.504006,
                29.043915
              ],
              [
                61.504343,
                29.043688
              ],
              [
                61.504431,
                29.043652
              ],
              [
                61.50452,
                29.043673
              ],
              [
                61.504559,
                29.043434
              ],
              [
                61.504984,
                29.043264
              ],
              [
                61.505247,
                29.043016
              ],
              [
                61.505914,
                29.043113
              ],
              [
                61.506005,
                29.043247
              ],
              [
                61.506158,
                29.0432
              ],
              [
                61.50626,
                29.043271
              ],
              [
                61.50635,
                29.043002
              ],
              [
                61.506571,
                29.043083
              ],
              [
                61.506753,
                29.043091
              ],
              [
                61.506836,
                29.043044
              ],
              [
                61.506906,
                29.043155
              ],
              [
                61.506907,
                29.043264
              ],
              [
                61.506835,
                29.043389
              ],
              [
                61.506917,
                29.043588
              ],
              [
                61.506835,
                29.043855
              ],
              [
                61.507092,
                29.044044
              ],
              [
                61.507145,
                29.044135
              ],
              [
                61.507217,
                29.044124
              ],
              [
                61.507278,
                29.044195
              ],
              [
                61.507138,
                29.044402
              ],
              [
                61.506985,
                29.044517
              ],
              [
                61.506993,
                29.044623
              ],
              [
                61.506828,
                29.044752
              ],
              [
                61.506859,
                29.044895
              ],
              [
                61.506923,
                29.044918
              ],
              [
                61.507065,
                29.045116
              ],
              [
                61.507058,
                29.045322
              ],
              [
                61.507266,
                29.045176
              ],
              [
                61.507437,
                29.045114
              ],
              [
                61.507625,
                29.045102
              ],
              [
                61.507734,
                29.045141
              ],
              [
                61.507873,
                29.045541
              ],
              [
                61.507749,
                29.046035
              ],
              [
                61.507859,
                29.046374
              ],
              [
                61.507809,
                29.046412
              ],
              [
                61.507763,
                29.046727
              ],
              [
                61.507947,
                29.046906
              ],
              [
                61.508335,
                29.047149
              ],
              [
                61.508372,
                29.047263
              ],
              [
                61.508624,
                29.047304
              ],
              [
                61.508691,
                29.047426
              ],
              [
                61.508919,
                29.047298
              ],
              [
                61.50902,
                29.04732
              ],
              [
                61.509124,
                29.047429
              ],
              [
                61.509308,
                29.047431
              ],
              [
                61.509361,
                29.047468
              ],
              [
                61.509591,
                29.047778
              ],
              [
                61.509604,
                29.04791
              ],
              [
                61.509593,
                29.047989
              ],
              [
                61.5094,
                29.048115
              ],
              [
                61.50992,
                29.048005
              ],
              [
                61.510054,
                29.048045
              ],
              [
                61.510319,
                29.04796
              ],
              [
                61.510541,
                29.047808
              ],
              [
                61.510684,
                29.04778
              ],
              [
                61.510784,
                29.047887
              ],
              [
                61.511008,
                29.048
              ],
              [
                61.511095,
                29.048245
              ],
              [
                61.511348,
                29.048443
              ],
              [
                61.511472,
                29.04848
              ],
              [
                61.511324,
                29.048942
              ],
              [
                61.511183,
                29.04914
              ],
              [
                61.511226,
                29.04935
              ],
              [
                61.510918,
                29.049424
              ],
              [
                61.510908,
                29.04955
              ],
              [
                61.510628,
                29.049694
              ],
              [
                61.510301,
                29.050095
              ],
              [
                61.509953,
                29.050252
              ],
              [
                61.509772,
                29.050977
              ],
              [
                61.509673,
                29.051057
              ],
              [
                61.509669,
                29.051182
              ],
              [
                61.509108,
                29.051576
              ],
              [
                61.508908,
                29.051859
              ],
              [
                61.508892,
                29.052035
              ],
              [
                61.5087,
                29.05212
              ],
              [
                61.508635,
                29.052378
              ],
              [
                61.508657,
                29.052705
              ],
              [
                61.508498,
                29.05291
              ],
              [
                61.508409,
                29.052941
              ],
              [
                61.507827,
                29.052849
              ],
              [
                61.507723,
                29.052884
              ],
              [
                61.507564,
                29.052752
              ],
              [
                61.50747,
                29.052752
              ],
              [
                61.507372,
                29.052677
              ],
              [
                61.507191,
                29.052743
              ],
              [
                61.506936,
                29.052769
              ],
              [
                61.506822,
                29.052733
              ],
              [
                61.506528,
                29.052987
              ],
              [
                61.506399,
                29.05307
              ],
              [
                61.506226,
                29.053104
              ],
              [
                61.506029,
                29.053281
              ],
              [
                61.505668,
                29.053499
              ],
              [
                61.505552,
                29.053431
              ],
              [
                61.505319,
                29.053625
              ],
              [
                61.5051,
                29.053908
              ],
              [
                61.505086,
                29.054005
              ],
              [
                61.505002,
                29.054032
              ],
              [
                61.504903,
                29.054173
              ],
              [
                61.504911,
                29.05426
              ],
              [
                61.504852,
                29.054297
              ],
              [
                61.504871,
                29.054389
              ],
              [
                61.504548,
                29.054911
              ],
              [
                61.504523,
                29.055029
              ],
              [
                61.504374,
                29.055055
              ],
              [
                61.504287,
                29.055161
              ],
              [
                61.504095,
                29.055201
              ],
              [
                61.504066,
                29.05529
              ],
              [
                61.503966,
                29.055337
              ],
              [
                61.503963,
                29.055481
              ],
              [
                61.503854,
                29.055469
              ],
              [
                61.503631,
                29.055822
              ],
              [
                61.503742,
                29.055985
              ],
              [
                61.50369,
                29.05618
              ],
              [
                61.503712,
                29.0567
              ],
              [
                61.503882,
                29.057058
              ],
              [
                61.503789,
                29.057225
              ],
              [
                61.503724,
                29.057202
              ],
              [
                61.503661,
                29.057639
              ],
              [
                61.503835,
                29.05761
              ],
              [
                61.504272,
                29.057359
              ],
              [
                61.504481,
                29.057309
              ],
              [
                61.504717,
                29.057527
              ],
              [
                61.505055,
                29.057563
              ],
              [
                61.505321,
                29.057684
              ],
              [
                61.505412,
                29.057831
              ],
              [
                61.505577,
                29.05784
              ],
              [
                61.505782,
                29.058009
              ],
              [
                61.506025,
                29.058022
              ],
              [
                61.506084,
                29.057955
              ],
              [
                61.50632,
                29.058019
              ],
              [
                61.506422,
                29.057966
              ],
              [
                61.506785,
                29.05862
              ],
              [
                61.506921,
                29.058601
              ],
              [
                61.507096,
                29.058748
              ],
              [
                61.507214,
                29.059224
              ],
              [
                61.507165,
                29.059358
              ],
              [
                61.507606,
                29.059949
              ],
              [
                61.507688,
                29.060228
              ],
              [
                61.507417,
                29.060728
              ],
              [
                61.507182,
                29.061034
              ],
              [
                61.50732,
                29.061117
              ],
              [
                61.507332,
                29.061319
              ],
              [
                61.50738,
                29.06135
              ],
              [
                61.507259,
                29.061686
              ],
              [
                61.507147,
                29.061854
              ],
              [
                61.506911,
                29.061983
              ],
              [
                61.506853,
                29.062003
              ],
              [
                61.506728,
                29.061945
              ],
              [
                61.506435,
                29.062099
              ],
              [
                61.506317,
                29.062291
              ],
              [
                61.505838,
                29.062727
              ],
              [
                61.50577,
                29.062961
              ],
              [
                61.505662,
                29.063005
              ],
              [
                61.505666,
                29.063098
              ],
              [
                61.505783,
                29.063196
              ],
              [
                61.505712,
                29.06356
              ],
              [
                61.505642,
                29.063667
              ],
              [
                61.505264,
                29.063852
              ],
              [
                61.505148,
                29.064002
              ],
              [
                61.504724,
                29.06432
              ],
              [
                61.504845,
                29.064398
              ],
              [
                61.504666,
                29.064839
              ],
              [
                61.504707,
                29.064982
              ],
              [
                61.504651,
                29.065115
              ],
              [
                61.504673,
                29.065372
              ],
              [
                61.504601,
                29.065626
              ],
              [
                61.504377,
                29.065822
              ],
              [
                61.504205,
                29.065853
              ],
              [
                61.504179,
                29.06598
              ],
              [
                61.503727,
                29.0664
              ],
              [
                61.503731,
                29.066479
              ],
              [
                61.50361,
                29.066533
              ],
              [
                61.503535,
                29.066672
              ],
              [
                61.503087,
                29.066761
              ],
              [
                61.503025,
                29.066619
              ],
              [
                61.502769,
                29.066459
              ],
              [
                61.502653,
                29.066262
              ],
              [
                61.502353,
                29.066294
              ],
              [
                61.502203,
                29.066185
              ],
              [
                61.501727,
                29.066285
              ],
              [
                61.501308,
                29.066211
              ],
              [
                61.501217,
                29.066168
              ],
              [
                61.501206,
                29.066109
              ],
              [
                61.501026,
                29.066073
              ],
              [
                61.500818,
                29.066137
              ],
              [
                61.500627,
                29.066326
              ],
              [
                61.500477,
                29.066284
              ],
              [
                61.500589,
                29.066504
              ],
              [
                61.50048,
                29.066735
              ],
              [
                61.500558,
                29.06685
              ],
              [
                61.500756,
                29.066951
              ],
              [
                61.500728,
                29.066976
              ],
              [
                61.500646,
                29.066959
              ],
              [
                61.500031,
                29.067282
              ],
              [
                61.499948,
                29.067287
              ],
              [
                61.499772,
                29.067404
              ],
              [
                61.49966,
                29.067586
              ],
              [
                61.499471,
                29.067745
              ],
              [
                61.499138,
                29.067935
              ],
              [
                61.499082,
                29.068009
              ],
              [
                61.498749,
                29.06815
              ],
              [
                61.49798,
                29.068674
              ],
              [
                61.49768,
                29.06881
              ],
              [
                61.497315,
                29.068841
              ],
              [
                61.497177,
                29.068926
              ],
              [
                61.497181,
                29.069044
              ],
              [
                61.497045,
                29.069217
              ],
              [
                61.496792,
                29.069209
              ],
              [
                61.49666,
                29.069141
              ],
              [
                61.496446,
                29.068988
              ],
              [
                61.496368,
                29.068857
              ],
              [
                61.49609,
                29.068992
              ],
              [
                61.495903,
                29.069145
              ],
              [
                61.495206,
                29.069037
              ],
              [
                61.495077,
                29.069082
              ],
              [
                61.494937,
                29.069057
              ],
              [
                61.494674,
                29.069153
              ],
              [
                61.494573,
                29.069377
              ],
              [
                61.494339,
                29.069641
              ],
              [
                61.494265,
                29.069879
              ],
              [
                61.494157,
                29.069908
              ],
              [
                61.494116,
                29.070228
              ],
              [
                61.493972,
                29.070546
              ],
              [
                61.493897,
                29.07058
              ],
              [
                61.493639,
                29.070479
              ],
              [
                61.493644,
                29.070591
              ],
              [
                61.493455,
                29.070874
              ],
              [
                61.493411,
                29.071169
              ],
              [
                61.493338,
                29.071189
              ],
              [
                61.493191,
                29.07134
              ],
              [
                61.49297,
                29.071298
              ],
              [
                61.492374,
                29.071584
              ],
              [
                61.492334,
                29.071666
              ],
              [
                61.49191,
                29.072017
              ],
              [
                61.491598,
                29.072181
              ],
              [
                61.491406,
                29.072147
              ],
              [
                61.490952,
                29.072248
              ],
              [
                61.490705,
                29.07201
              ],
              [
                61.490549,
                29.072008
              ],
              [
                61.490178,
                29.071872
              ],
              [
                61.490007,
                29.071925
              ],
              [
                61.489857,
                29.071841
              ],
              [
                61.489582,
                29.07189
              ],
              [
                61.489047,
                29.071745
              ],
              [
                61.48888,
                29.07185
              ],
              [
                61.488881,
                29.07175
              ],
              [
                61.488773,
                29.071702
              ],
              [
                61.488724,
                29.071563
              ],
              [
                61.488548,
                29.071606
              ],
              [
                61.488557,
                29.071514
              ],
              [
                61.488388,
                29.071384
              ],
              [
                61.488333,
                29.071268
              ],
              [
                61.488174,
                29.071228
              ],
              [
                61.487767,
                29.071565
              ],
              [
                61.487658,
                29.071768
              ],
              [
                61.487403,
                29.071885
              ],
              [
                61.487248,
                29.07204
              ],
              [
                61.486292,
                29.072471
              ],
              [
                61.486136,
                29.072507
              ],
              [
                61.485876,
                29.072473
              ],
              [
                61.485778,
                29.072545
              ],
              [
                61.485585,
                29.07271
              ],
              [
                61.485538,
                29.072851
              ],
              [
                61.485439,
                29.072929
              ],
              [
                61.485465,
                29.073153
              ],
              [
                61.485418,
                29.073269
              ],
              [
                61.485355,
                29.073265
              ],
              [
                61.485033,
                29.073434
              ],
              [
                61.484909,
                29.073436
              ],
              [
                61.484894,
                29.073541
              ],
              [
                61.484364,
                29.074349
              ],
              [
                61.484213,
                29.074417
              ],
              [
                61.484012,
                29.074677
              ],
              [
                61.484067,
                29.074882
              ],
              [
                61.483972,
                29.075005
              ],
              [
                61.484033,
                29.075321
              ],
              [
                61.483804,
                29.075402
              ],
              [
                61.483691,
                29.07559
              ],
              [
                61.483294,
                29.075853
              ],
              [
                61.482982,
                29.075912
              ],
              [
                61.48295,
                29.075957
              ],
              [
                61.482529,
                29.076106
              ],
              [
                61.482355,
                29.076094
              ],
              [
                61.482307,
                29.076255
              ],
              [
                61.48188,
                29.076411
              ],
              [
                61.481834,
                29.076547
              ],
              [
                61.481687,
                29.076661
              ],
              [
                61.481478,
                29.076686
              ],
              [
                61.481288,
                29.077057
              ],
              [
                61.480752,
                29.07732
              ],
              [
                61.480653,
                29.077323
              ],
              [
                61.480628,
                29.077606
              ],
              [
                61.480389,
                29.078161
              ],
              [
                61.480156,
                29.078433
              ],
              [
                61.480118,
                29.078556
              ],
              [
                61.480146,
                29.078647
              ],
              [
                61.479863,
                29.078932
              ],
              [
                61.480103,
                29.079102
              ],
              [
                61.480229,
                29.079135
              ],
              [
                61.480448,
                29.07937
              ],
              [
                61.480575,
                29.079433
              ],
              [
                61.480707,
                29.079661
              ],
              [
                61.480738,
                29.079878
              ],
              [
                61.48116,
                29.080095
              ],
              [
                61.481386,
                29.080494
              ],
              [
                61.481641,
                29.080466
              ],
              [
                61.48189,
                29.080676
              ],
              [
                61.481987,
                29.08069
              ],
              [
                61.482279,
                29.08104
              ],
              [
                61.48246,
                29.081054
              ],
              [
                61.482553,
                29.081143
              ],
              [
                61.482404,
                29.081324
              ],
              [
                61.482316,
                29.081631
              ],
              [
                61.482234,
                29.081675
              ],
              [
                61.482178,
                29.081821
              ],
              [
                61.48193,
                29.081961
              ],
              [
                61.481825,
                29.082238
              ],
              [
                61.481764,
                29.0826
              ],
              [
                61.481571,
                29.082986
              ],
              [
                61.481554,
                29.08311
              ],
              [
                61.481273,
                29.083516
              ],
              [
                61.481236,
                29.083854
              ],
              [
                61.481101,
                29.084068
              ],
              [
                61.480894,
                29.084109
              ],
              [
                61.480718,
                29.084257
              ],
              [
                61.480759,
                29.084348
              ],
              [
                61.480343,
                29.084571
              ],
              [
                61.480297,
                29.08482
              ],
              [
                61.480326,
                29.084927
              ],
              [
                61.480159,
                29.085175
              ],
              [
                61.479942,
                29.085372
              ],
              [
                61.479914,
                29.085496
              ],
              [
                61.479669,
                29.085655
              ],
              [
                61.479336,
                29.085693
              ],
              [
                61.47923,
                29.085808
              ],
              [
                61.478943,
                29.085865
              ],
              [
                61.478991,
                29.08596
              ],
              [
                61.478889,
                29.08603
              ],
              [
                61.478652,
                29.086027
              ],
              [
                61.478454,
                29.086143
              ],
              [
                61.478424,
                29.086226
              ],
              [
                61.478215,
                29.08643
              ],
              [
                61.477906,
                29.086604
              ],
              [
                61.477623,
                29.086693
              ],
              [
                61.477553,
                29.086996
              ],
              [
                61.477299,
                29.087204
              ],
              [
                61.477171,
                29.087436
              ],
              [
                61.476917,
                29.08758
              ],
              [
                61.476817,
                29.087564
              ],
              [
                61.476339,
                29.087749
              ],
              [
                61.47625,
                29.088111
              ],
              [
                61.476277,
                29.088266
              ],
              [
                61.476146,
                29.088377
              ],
              [
                61.476117,
                29.088501
              ],
              [
                61.475966,
                29.088688
              ],
              [
                61.475893,
                29.088631
              ],
              [
                61.475646,
                29.088638
              ],
              [
                61.475317,
                29.088767
              ],
              [
                61.47502,
                29.088721
              ],
              [
                61.475051,
                29.088786
              ],
              [
                61.47493,
                29.089006
              ],
              [
                61.474918,
                29.089124
              ],
              [
                61.474756,
                29.089288
              ],
              [
                61.474606,
                29.089312
              ],
              [
                61.474452,
                29.089522
              ],
              [
                61.474053,
                29.089659
              ],
              [
                61.473639,
                29.089914
              ],
              [
                61.473562,
                29.089891
              ],
              [
                61.473529,
                29.089925
              ],
              [
                61.47321,
                29.089952
              ],
              [
                61.473027,
                29.089812
              ],
              [
                61.472942,
                29.089834
              ],
              [
                61.472917,
                29.089781
              ],
              [
                61.472717,
                29.089699
              ],
              [
                61.472591,
                29.089796
              ],
              [
                61.47258,
                29.089853
              ],
              [
                61.472342,
                29.089911
              ],
              [
                61.472263,
                29.090045
              ],
              [
                61.471929,
                29.090282
              ],
              [
                61.471754,
                29.090331
              ],
              [
                61.471608,
                29.090734
              ],
              [
                61.471443,
                29.090872
              ],
              [
                61.471341,
                29.091096
              ],
              [
                61.471401,
                29.091189
              ],
              [
                61.471454,
                29.091614
              ],
              [
                61.471392,
                29.091769
              ],
              [
                61.471616,
                29.091797
              ],
              [
                61.471557,
                29.091963
              ],
              [
                61.471594,
                29.092066
              ],
              [
                61.471766,
                29.092214
              ],
              [
                61.471885,
                29.092163
              ],
              [
                61.47196,
                29.092192
              ],
              [
                61.472191,
                29.092146
              ],
              [
                61.47233,
                29.092207
              ],
              [
                61.472589,
                29.0922
              ],
              [
                61.473208,
                29.092392
              ],
              [
                61.473261,
                29.092564
              ],
              [
                61.473564,
                29.092763
              ],
              [
                61.473597,
                29.092949
              ],
              [
                61.473853,
                29.09329
              ],
              [
                61.474224,
                29.092974
              ],
              [
                61.474408,
                29.093429
              ],
              [
                61.47467,
                29.093614
              ],
              [
                61.475379,
                29.093976
              ],
              [
                61.475513,
                29.094274
              ],
              [
                61.475918,
                29.094459
              ],
              [
                61.476009,
                29.094551
              ],
              [
                61.476038,
                29.0947
              ],
              [
                61.476178,
                29.094739
              ],
              [
                61.476355,
                29.09493
              ],
              [
                61.476448,
                29.095137
              ],
              [
                61.476704,
                29.095269
              ],
              [
                61.476699,
                29.09543
              ],
              [
                61.476528,
                29.095623
              ],
              [
                61.476205,
                29.096167
              ],
              [
                61.475968,
                29.096363
              ],
              [
                61.475918,
                29.09656
              ],
              [
                61.475822,
                29.09656
              ],
              [
                61.475522,
                29.096787
              ],
              [
                61.475264,
                29.097017
              ],
              [
                61.475075,
                29.097344
              ],
              [
                61.474985,
                29.097345
              ],
              [
                61.474873,
                29.097469
              ],
              [
                61.474794,
                29.097686
              ],
              [
                61.475017,
                29.097965
              ],
              [
                61.475252,
                29.098141
              ],
              [
                61.475509,
                29.098474
              ],
              [
                61.475895,
                29.098695
              ],
              [
                61.475992,
                29.098814
              ],
              [
                61.476153,
                29.09881
              ],
              [
                61.476633,
                29.099035
              ],
              [
                61.47679,
                29.099161
              ],
              [
                61.476985,
                29.099142
              ],
              [
                61.47697,
                29.09907
              ],
              [
                61.477079,
                29.098952
              ],
              [
                61.477619,
                29.098975
              ],
              [
                61.47795,
                29.098866
              ],
              [
                61.478015,
                29.098894
              ],
              [
                61.478214,
                29.09929
              ],
              [
                61.47823,
                29.099422
              ],
              [
                61.478361,
                29.099567
              ],
              [
                61.478455,
                29.099904
              ],
              [
                61.478835,
                29.099975
              ],
              [
                61.479305,
                29.09986
              ],
              [
                61.479342,
                29.099938
              ],
              [
                61.479733,
                29.10028
              ],
              [
                61.479916,
                29.100539
              ],
              [
                61.480228,
                29.100761
              ],
              [
                61.480108,
                29.101119
              ],
              [
                61.480008,
                29.101152
              ],
              [
                61.479626,
                29.101503
              ],
              [
                61.479617,
                29.101593
              ],
              [
                61.479522,
                29.101717
              ],
              [
                61.479473,
                29.101704
              ],
              [
                61.479236,
                29.101933
              ],
              [
                61.479105,
                29.101995
              ],
              [
                61.479011,
                29.102146
              ],
              [
                61.478642,
                29.102472
              ],
              [
                61.478203,
                29.102636
              ],
              [
                61.478065,
                29.102851
              ],
              [
                61.478064,
                29.102961
              ],
              [
                61.477941,
                29.103069
              ],
              [
                61.477947,
                29.103175
              ],
              [
                61.477873,
                29.103164
              ],
              [
                61.477838,
                29.103312
              ],
              [
                61.477341,
                29.103843
              ],
              [
                61.476504,
                29.104331
              ],
              [
                61.476255,
                29.104377
              ],
              [
                61.476122,
                29.104459
              ],
              [
                61.476094,
                29.10442
              ],
              [
                61.476004,
                29.104432
              ],
              [
                61.475752,
                29.104576
              ],
              [
                61.475629,
                29.104721
              ],
              [
                61.475918,
                29.104874
              ],
              [
                61.475874,
                29.105208
              ],
              [
                61.475748,
                29.105461
              ],
              [
                61.47518,
                29.105927
              ],
              [
                61.475239,
                29.105992
              ],
              [
                61.475244,
                29.10622
              ],
              [
                61.475124,
                29.106365
              ],
              [
                61.474978,
                29.10638
              ],
              [
                61.474753,
                29.10654
              ],
              [
                61.474549,
                29.106545
              ],
              [
                61.474299,
                29.106809
              ],
              [
                61.47416,
                29.106839
              ],
              [
                61.47406,
                29.106928
              ],
              [
                61.474005,
                29.106878
              ],
              [
                61.473686,
                29.107178
              ],
              [
                61.473456,
                29.107262
              ],
              [
                61.473693,
                29.107375
              ],
              [
                61.474029,
                29.107651
              ],
              [
                61.474139,
                29.107701
              ],
              [
                61.474412,
                29.107702
              ],
              [
                61.474717,
                29.107846
              ],
              [
                61.474926,
                29.10789
              ],
              [
                61.474941,
                29.108003
              ],
              [
                61.475399,
                29.108188
              ],
              [
                61.475507,
                29.108291
              ],
              [
                61.475443,
                29.108551
              ],
              [
                61.475862,
                29.108549
              ],
              [
                61.475963,
                29.108749
              ],
              [
                61.476449,
                29.109053
              ],
              [
                61.476501,
                29.109307
              ],
              [
                61.476602,
                29.109389
              ],
              [
                61.476867,
                29.109395
              ],
              [
                61.476995,
                29.109499
              ],
              [
                61.477165,
                29.109523
              ],
              [
                61.477348,
                29.109738
              ],
              [
                61.477287,
                29.109847
              ],
              [
                61.477318,
                29.109887
              ],
              [
                61.476911,
                29.110312
              ],
              [
                61.476826,
                29.110732
              ],
              [
                61.476551,
                29.111009
              ],
              [
                61.476089,
                29.111337
              ],
              [
                61.475926,
                29.111588
              ],
              [
                61.475628,
                29.111743
              ],
              [
                61.475595,
                29.111865
              ],
              [
                61.475529,
                29.1119
              ],
              [
                61.475517,
                29.111994
              ],
              [
                61.475391,
                29.112151
              ],
              [
                61.475182,
                29.112214
              ],
              [
                61.474792,
                29.112647
              ],
              [
                61.474684,
                29.112842
              ],
              [
                61.474616,
                29.112869
              ],
              [
                61.474525,
                29.113097
              ],
              [
                61.47459,
                29.113172
              ],
              [
                61.47447,
                29.113295
              ],
              [
                61.474417,
                29.113396
              ],
              [
                61.474455,
                29.113452
              ],
              [
                61.474373,
                29.113562
              ],
              [
                61.474372,
                29.113816
              ],
              [
                61.474307,
                29.113895
              ],
              [
                61.474311,
                29.114015
              ],
              [
                61.474432,
                29.114102
              ],
              [
                61.474459,
                29.114188
              ],
              [
                61.474642,
                29.114306
              ],
              [
                61.474853,
                29.114264
              ],
              [
                61.4749,
                29.114304
              ],
              [
                61.474941,
                29.114784
              ],
              [
                61.475078,
                29.114967
              ],
              [
                61.475203,
                29.114969
              ],
              [
                61.475171,
                29.115067
              ],
              [
                61.475525,
                29.115413
              ],
              [
                61.475603,
                29.115828
              ],
              [
                61.475892,
                29.116192
              ],
              [
                61.475841,
                29.116508
              ],
              [
                61.47588,
                29.116589
              ],
              [
                61.475685,
                29.116867
              ],
              [
                61.475342,
                29.117117
              ],
              [
                61.475359,
                29.117626
              ],
              [
                61.475017,
                29.117793
              ],
              [
                61.474388,
                29.117995
              ],
              [
                61.474199,
                29.118423
              ],
              [
                61.474318,
                29.118439
              ],
              [
                61.474608,
                29.118726
              ],
              [
                61.474708,
                29.118935
              ],
              [
                61.474872,
                29.118947
              ],
              [
                61.475005,
                29.119149
              ],
              [
                61.47535,
                29.119329
              ],
              [
                61.475768,
                29.119671
              ],
              [
                61.476211,
                29.119782
              ],
              [
                61.476213,
                29.119828
              ],
              [
                61.476124,
                29.120042
              ],
              [
                61.476209,
                29.120146
              ],
              [
                61.476133,
                29.120244
              ],
              [
                61.476062,
                29.120233
              ],
              [
                61.476129,
                29.120372
              ],
              [
                61.475829,
                29.120767
              ],
              [
                61.475808,
                29.121206
              ],
              [
                61.475668,
                29.121586
              ],
              [
                61.475619,
                29.121674
              ],
              [
                61.47516,
                29.122043
              ],
              [
                61.474903,
                29.122399
              ],
              [
                61.474769,
                29.122501
              ],
              [
                61.474617,
                29.122752
              ],
              [
                61.474539,
                29.123219
              ],
              [
                61.47438,
                29.123348
              ],
              [
                61.474371,
                29.123403
              ],
              [
                61.473996,
                29.12348
              ],
              [
                61.473995,
                29.123245
              ],
              [
                61.473675,
                29.12314
              ],
              [
                61.473386,
                29.1233
              ],
              [
                61.473395,
                29.12343
              ],
              [
                61.47334,
                29.123559
              ],
              [
                61.473225,
                29.123607
              ],
              [
                61.473054,
                29.123411
              ],
              [
                61.472865,
                29.123544
              ],
              [
                61.472849,
                29.123637
              ],
              [
                61.472952,
                29.123672
              ],
              [
                61.472796,
                29.123866
              ],
              [
                61.472544,
                29.124005
              ],
              [
                61.471691,
                29.123597
              ],
              [
                61.471271,
                29.122851
              ],
              [
                61.47114,
                29.122782
              ],
              [
                61.471367,
                29.122485
              ],
              [
                61.471306,
                29.12234
              ],
              [
                61.471023,
                29.12206
              ],
              [
                61.47081,
                29.122068
              ],
              [
                61.47082,
                29.121982
              ],
              [
                61.470489,
                29.121947
              ],
              [
                61.470152,
                29.121705
              ],
              [
                61.469763,
                29.121545
              ],
              [
                61.469545,
                29.12172
              ],
              [
                61.469304,
                29.121776
              ],
              [
                61.468944,
                29.122062
              ],
              [
                61.468785,
                29.122088
              ],
              [
                61.468291,
                29.121748
              ],
              [
                61.467882,
                29.121813
              ],
              [
                61.467174,
                29.121717
              ],
              [
                61.46649,
                29.121825
              ],
              [
                61.465944,
                29.122249
              ],
              [
                61.465571,
                29.122415
              ],
              [
                61.465445,
                29.122538
              ],
              [
                61.465416,
                29.122656
              ],
              [
                61.465206,
                29.12272
              ],
              [
                61.465119,
                29.122793
              ],
              [
                61.464915,
                29.122791
              ],
              [
                61.464928,
                29.12287
              ],
              [
                61.464818,
                29.122942
              ],
              [
                61.464786,
                29.123032
              ],
              [
                61.464543,
                29.123061
              ],
              [
                61.464167,
                29.123472
              ],
              [
                61.464006,
                29.123543
              ],
              [
                61.463335,
                29.124023
              ],
              [
                61.463067,
                29.124031
              ],
              [
                61.46287,
                29.124216
              ],
              [
                61.462521,
                29.12431
              ],
              [
                61.46221,
                29.12427
              ],
              [
                61.462067,
                29.124405
              ],
              [
                61.461977,
                29.124423
              ],
              [
                61.461971,
                29.124491
              ],
              [
                61.461782,
                29.12454
              ],
              [
                61.461569,
                29.124523
              ],
              [
                61.461423,
                29.124566
              ],
              [
                61.461365,
                29.124493
              ],
              [
                61.461253,
                29.124516
              ],
              [
                61.461114,
                29.124706
              ],
              [
                61.460857,
                29.124549
              ],
              [
                61.46075,
                29.12455
              ],
              [
                61.460638,
                29.124679
              ],
              [
                61.460503,
                29.12474
              ],
              [
                61.460472,
                29.124875
              ],
              [
                61.460379,
                29.124988
              ],
              [
                61.460254,
                29.125052
              ],
              [
                61.46019,
                29.125177
              ],
              [
                61.459852,
                29.125171
              ],
              [
                61.459726,
                29.125017
              ],
              [
                61.459699,
                29.124877
              ],
              [
                61.459226,
                29.124729
              ],
              [
                61.459205,
                29.12433
              ],
              [
                61.458998,
                29.124046
              ],
              [
                61.458435,
                29.123659
              ],
              [
                61.457923,
                29.123508
              ],
              [
                61.457857,
                29.123378
              ],
              [
                61.457541,
                29.123634
              ],
              [
                61.457561,
                29.123742
              ],
              [
                61.457525,
                29.123777
              ],
              [
                61.457152,
                29.123966
              ],
              [
                61.457081,
                29.124181
              ],
              [
                61.457113,
                29.124279
              ],
              [
                61.45685,
                29.124249
              ],
              [
                61.456874,
                29.124441
              ],
              [
                61.456582,
                29.124888
              ],
              [
                61.456522,
                29.125286
              ],
              [
                61.455905,
                29.125896
              ],
              [
                61.455618,
                29.126048
              ],
              [
                61.455335,
                29.126294
              ],
              [
                61.455192,
                29.12658
              ],
              [
                61.454426,
                29.127482
              ],
              [
                61.454263,
                29.127632
              ],
              [
                61.454018,
                29.127748
              ],
              [
                61.454015,
                29.127866
              ],
              [
                61.45391,
                29.127906
              ],
              [
                61.453847,
                29.128025
              ],
              [
                61.453493,
                29.128123
              ],
              [
                61.453416,
                29.12829
              ],
              [
                61.453142,
                29.128338
              ],
              [
                61.452716,
                29.128543
              ],
              [
                61.452539,
                29.128556
              ],
              [
                61.452352,
                29.129019
              ],
              [
                61.452187,
                29.129177
              ],
              [
                61.451651,
                29.129964
              ],
              [
                61.451554,
                29.130022
              ],
              [
                61.451337,
                29.130292
              ],
              [
                61.451235,
                29.130553
              ],
              [
                61.451084,
                29.130692
              ],
              [
                61.450892,
                29.131052
              ],
              [
                61.450778,
                29.131092
              ],
              [
                61.450815,
                29.131208
              ],
              [
                61.450713,
                29.131376
              ],
              [
                61.450851,
                29.131512
              ],
              [
                61.450538,
                29.131702
              ],
              [
                61.450304,
                29.131771
              ],
              [
                61.45018,
                29.131874
              ],
              [
                61.449963,
                29.131883
              ],
              [
                61.449581,
                29.131808
              ],
              [
                61.44939,
                29.1317
              ],
              [
                61.449009,
                29.13129
              ],
              [
                61.448727,
                29.131091
              ],
              [
                61.448595,
                29.131162
              ],
              [
                61.448453,
                29.131151
              ],
              [
                61.447919,
                29.131531
              ],
              [
                61.447763,
                29.131422
              ],
              [
                61.44763,
                29.13125
              ],
              [
                61.44758,
                29.131279
              ],
              [
                61.447288,
                29.13116
              ],
              [
                61.447085,
                29.131001
              ],
              [
                61.446883,
                29.130977
              ],
              [
                61.446723,
                29.131157
              ],
              [
                61.446644,
                29.131341
              ],
              [
                61.446472,
                29.131406
              ],
              [
                61.446371,
                29.131381
              ],
              [
                61.446205,
                29.13143
              ],
              [
                61.446092,
                29.131369
              ],
              [
                61.445738,
                29.131399
              ],
              [
                61.445315,
                29.131183
              ],
              [
                61.445054,
                29.131126
              ],
              [
                61.444887,
                29.131195
              ],
              [
                61.444746,
                29.13115
              ],
              [
                61.444566,
                29.131178
              ],
              [
                61.444002,
                29.131522
              ],
              [
                61.443823,
                29.131411
              ],
              [
                61.4437,
                29.131427
              ],
              [
                61.443562,
                29.131382
              ],
              [
                61.443476,
                29.131287
              ],
              [
                61.443282,
                29.131364
              ],
              [
                61.443002,
                29.131319
              ],
              [
                61.442699,
                29.131141
              ],
              [
                61.442487,
                29.131233
              ],
              [
                61.442331,
                29.131393
              ],
              [
                61.442247,
                29.131317
              ],
              [
                61.441975,
                29.131228
              ],
              [
                61.441745,
                29.131038
              ],
              [
                61.441624,
                29.131048
              ],
              [
                61.441647,
                29.130948
              ],
              [
                61.441522,
                29.130889
              ],
              [
                61.441241,
                29.13093
              ],
              [
                61.440679,
                29.130548
              ],
              [
                61.440504,
                29.130533
              ],
              [
                61.440371,
                29.130637
              ],
              [
                61.43999,
                29.130634
              ],
              [
                61.43949,
                29.130532
              ],
              [
                61.439235,
                29.130397
              ],
              [
                61.438776,
                29.130359
              ],
              [
                61.438619,
                29.130497
              ],
              [
                61.438501,
                29.130217
              ],
              [
                61.438321,
                29.13013
              ],
              [
                61.438296,
                29.129866
              ],
              [
                61.437877,
                29.129366
              ],
              [
                61.438501,
                29.129114
              ],
              [
                61.438707,
                29.128939
              ],
              [
                61.438774,
                29.128824
              ],
              [
                61.438926,
                29.128772
              ],
              [
                61.438888,
                29.128455
              ],
              [
                61.438746,
                29.128365
              ],
              [
                61.438673,
                29.128379
              ],
              [
                61.438523,
                29.128544
              ],
              [
                61.438454,
                29.128546
              ],
              [
                61.437988,
                29.128274
              ],
              [
                61.437777,
                29.128215
              ],
              [
                61.437253,
                29.127775
              ],
              [
                61.436795,
                29.127927
              ],
              [
                61.436486,
                29.12796
              ],
              [
                61.436294,
                29.127769
              ],
              [
                61.435794,
                29.127694
              ],
              [
                61.435233,
                29.127732
              ],
              [
                61.434982,
                29.128062
              ],
              [
                61.43481,
                29.128163
              ],
              [
                61.434356,
                29.128331
              ],
              [
                61.434076,
                29.128297
              ],
              [
                61.433946,
                29.128418
              ],
              [
                61.433781,
                29.128445
              ],
              [
                61.433704,
                29.128124
              ],
              [
                61.433438,
                29.127678
              ],
              [
                61.433248,
                29.127626
              ],
              [
                61.433181,
                29.127454
              ],
              [
                61.43278,
                29.127422
              ],
              [
                61.432811,
                29.127287
              ],
              [
                61.432661,
                29.127216
              ],
              [
                61.432494,
                29.127232
              ],
              [
                61.43237,
                29.127167
              ],
              [
                61.432201,
                29.127321
              ],
              [
                61.432093,
                29.127266
              ],
              [
                61.431857,
                29.127433
              ],
              [
                61.43167,
                29.127484
              ],
              [
                61.431471,
                29.127672
              ],
              [
                61.431416,
                29.127638
              ],
              [
                61.43126,
                29.127692
              ],
              [
                61.43098,
                29.128005
              ],
              [
                61.430912,
                29.128181
              ],
              [
                61.430869,
                29.128161
              ],
              [
                61.430536,
                29.128331
              ],
              [
                61.430449,
                29.128563
              ],
              [
                61.430415,
                29.128539
              ],
              [
                61.430283,
                29.128585
              ],
              [
                61.430188,
                29.128716
              ],
              [
                61.430113,
                29.128666
              ],
              [
                61.429981,
                29.128726
              ],
              [
                61.429411,
                29.128794
              ],
              [
                61.429164,
                29.128941
              ],
              [
                61.428961,
                29.12881
              ],
              [
                61.428817,
                29.128631
              ],
              [
                61.428614,
                29.128565
              ],
              [
                61.428626,
                29.128484
              ],
              [
                61.428462,
                29.128396
              ],
              [
                61.428416,
                29.12819
              ],
              [
                61.428307,
                29.12799
              ],
              [
                61.427906,
                29.127943
              ],
              [
                61.427642,
                29.128071
              ],
              [
                61.427226,
                29.12845
              ],
              [
                61.427011,
                29.12849
              ],
              [
                61.42653,
                29.128812
              ],
              [
                61.426444,
                29.12923
              ],
              [
                61.426295,
                29.12927
              ],
              [
                61.426133,
                29.129453
              ],
              [
                61.425888,
                29.12953
              ],
              [
                61.425669,
                29.129764
              ],
              [
                61.42558,
                29.129776
              ],
              [
                61.425582,
                29.129837
              ],
              [
                61.425366,
                29.129981
              ],
              [
                61.425298,
                29.130117
              ],
              [
                61.424794,
                29.13062
              ],
              [
                61.424889,
                29.130856
              ],
              [
                61.424767,
                29.131102
              ],
              [
                61.42501,
                29.131241
              ],
              [
                61.425128,
                29.1314
              ],
              [
                61.425033,
                29.131469
              ],
              [
                61.425272,
                29.131657
              ],
              [
                61.425663,
                29.131857
              ],
              [
                61.425715,
                29.131931
              ],
              [
                61.425701,
                29.1322
              ],
              [
                61.42586,
                29.132309
              ],
              [
                61.425848,
                29.132389
              ],
              [
                61.426437,
                29.132716
              ],
              [
                61.426369,
                29.132866
              ],
              [
                61.426395,
                29.132937
              ],
              [
                61.426278,
                29.133097
              ],
              [
                61.426576,
                29.133385
              ],
              [
                61.426516,
                29.133742
              ],
              [
                61.426418,
                29.133859
              ],
              [
                61.426253,
                29.13394
              ],
              [
                61.426008,
                29.134433
              ],
              [
                61.425906,
                29.13454
              ],
              [
                61.425816,
                29.13449
              ],
              [
                61.425739,
                29.134596
              ],
              [
                61.425584,
                29.134688
              ],
              [
                61.42541,
                29.134706
              ],
              [
                61.425346,
                29.134937
              ],
              [
                61.425065,
                29.135152
              ],
              [
                61.424955,
                29.135404
              ],
              [
                61.424249,
                29.135118
              ],
              [
                61.424035,
                29.135104
              ],
              [
                61.423779,
                29.135236
              ],
              [
                61.42353,
                29.135268
              ],
              [
                61.423485,
                29.135479
              ],
              [
                61.423143,
                29.135611
              ],
              [
                61.422832,
                29.135437
              ],
              [
                61.42209,
                29.134861
              ],
              [
                61.421586,
                29.13498
              ],
              [
                61.421384,
                29.13518
              ],
              [
                61.421022,
                29.1354
              ],
              [
                61.420823,
                29.135652
              ],
              [
                61.420823,
                29.136022
              ],
              [
                61.420752,
                29.136097
              ],
              [
                61.420775,
                29.13618
              ],
              [
                61.420629,
                29.136349
              ],
              [
                61.420609,
                29.136515
              ],
              [
                61.420523,
                29.136566
              ],
              [
                61.420523,
                29.136725
              ],
              [
                61.420163,
                29.137166
              ],
              [
                61.420129,
                29.137445
              ],
              [
                61.420241,
                29.137608
              ],
              [
                61.420216,
                29.137725
              ],
              [
                61.420128,
                29.137731
              ],
              [
                61.420032,
                29.137845
              ],
              [
                61.419745,
                29.137958
              ],
              [
                61.419657,
                29.13804
              ],
              [
                61.419636,
                29.138254
              ],
              [
                61.419561,
                29.138336
              ],
              [
                61.419635,
                29.138433
              ],
              [
                61.419374,
                29.138734
              ],
              [
                61.419428,
                29.138984
              ],
              [
                61.419387,
                29.139073
              ],
              [
                61.419412,
                29.139351
              ],
              [
                61.419543,
                29.139502
              ],
              [
                61.419493,
                29.139674
              ],
              [
                61.419258,
                29.139819
              ],
              [
                61.419249,
                29.139913
              ],
              [
                61.419149,
                29.140011
              ],
              [
                61.419325,
                29.140517
              ],
              [
                61.419065,
                29.140622
              ],
              [
                61.419046,
                29.140793
              ],
              [
                61.418854,
                29.140985
              ],
              [
                61.418687,
                29.140867
              ],
              [
                61.418467,
                29.140813
              ],
              [
                61.418404,
                29.140906
              ],
              [
                61.418272,
                29.140977
              ],
              [
                61.418064,
                29.140926
              ],
              [
                61.417966,
                29.140982
              ],
              [
                61.417746,
                29.141003
              ],
              [
                61.417488,
                29.141236
              ],
              [
                61.417288,
                29.141301
              ],
              [
                61.417092,
                29.141303
              ],
              [
                61.416778,
                29.141511
              ],
              [
                61.416756,
                29.141949
              ],
              [
                61.416818,
                29.141965
              ],
              [
                61.416749,
                29.142024
              ],
              [
                61.416749,
                29.142234
              ],
              [
                61.416783,
                29.142233
              ],
              [
                61.416864,
                29.14246
              ],
              [
                61.41681,
                29.142594
              ],
              [
                61.416608,
                29.142701
              ],
              [
                61.41672,
                29.142971
              ],
              [
                61.416958,
                29.143192
              ],
              [
                61.416759,
                29.143461
              ],
              [
                61.416698,
                29.143706
              ],
              [
                61.416931,
                29.143845
              ],
              [
                61.417008,
                29.143956
              ],
              [
                61.416936,
                29.144023
              ],
              [
                61.41687,
                29.144263
              ],
              [
                61.416726,
                29.14451
              ],
              [
                61.416772,
                29.1447
              ],
              [
                61.416648,
                29.144789
              ],
              [
                61.416666,
                29.14485
              ],
              [
                61.416491,
                29.144887
              ],
              [
                61.416486,
                29.145221
              ],
              [
                61.416652,
                29.145396
              ],
              [
                61.416636,
                29.145584
              ],
              [
                61.4163,
                29.145687
              ],
              [
                61.416255,
                29.145738
              ],
              [
                61.416201,
                29.146
              ],
              [
                61.416081,
                29.146198
              ],
              [
                61.416065,
                29.146383
              ],
              [
                61.416262,
                29.146675
              ],
              [
                61.416363,
                29.14675
              ],
              [
                61.416459,
                29.146756
              ],
              [
                61.415886,
                29.147273
              ],
              [
                61.415897,
                29.147399
              ],
              [
                61.415748,
                29.147544
              ],
              [
                61.415777,
                29.147661
              ],
              [
                61.415676,
                29.147814
              ],
              [
                61.415587,
                29.148185
              ],
              [
                61.415454,
                29.148396
              ],
              [
                61.415518,
                29.14858
              ],
              [
                61.415622,
                29.14865
              ],
              [
                61.415511,
                29.148818
              ],
              [
                61.41552,
                29.148898
              ],
              [
                61.415273,
                29.149065
              ],
              [
                61.415281,
                29.149545
              ],
              [
                61.415081,
                29.149977
              ],
              [
                61.414834,
                29.150244
              ],
              [
                61.414834,
                29.150507
              ],
              [
                61.414645,
                29.15059
              ],
              [
                61.414586,
                29.150748
              ],
              [
                61.414546,
                29.150917
              ],
              [
                61.414591,
                29.151049
              ],
              [
                61.414559,
                29.151234
              ],
              [
                61.414597,
                29.151417
              ],
              [
                61.414821,
                29.151821
              ],
              [
                61.414732,
                29.151979
              ],
              [
                61.414759,
                29.152197
              ],
              [
                61.414637,
                29.152322
              ],
              [
                61.414356,
                29.152445
              ],
              [
                61.414313,
                29.152661
              ],
              [
                61.414342,
                29.152806
              ],
              [
                61.414271,
                29.15296
              ],
              [
                61.414032,
                29.153176
              ],
              [
                61.413968,
                29.153334
              ],
              [
                61.414061,
                29.153484
              ],
              [
                61.413981,
                29.153679
              ],
              [
                61.41407,
                29.153785
              ],
              [
                61.413454,
                29.154226
              ],
              [
                61.413273,
                29.154318
              ],
              [
                61.412976,
                29.154348
              ],
              [
                61.412949,
                29.154499
              ],
              [
                61.412849,
                29.154609
              ],
              [
                61.412878,
                29.15476
              ],
              [
                61.412784,
                29.154818
              ],
              [
                61.412674,
                29.15512
              ],
              [
                61.412689,
                29.155447
              ],
              [
                61.412743,
                29.155621
              ],
              [
                61.41285,
                29.15575
              ],
              [
                61.412666,
                29.155933
              ],
              [
                61.412613,
                29.156106
              ],
              [
                61.412668,
                29.156232
              ],
              [
                61.412601,
                29.156327
              ],
              [
                61.41252,
                29.156668
              ],
              [
                61.41217,
                29.156976
              ],
              [
                61.412221,
                29.157023
              ],
              [
                61.412208,
                29.157152
              ],
              [
                61.412127,
                29.157297
              ],
              [
                61.412752,
                29.157552
              ],
              [
                61.412761,
                29.157903
              ],
              [
                61.41261,
                29.158118
              ],
              [
                61.412617,
                29.158307
              ],
              [
                61.412444,
                29.158403
              ],
              [
                61.412479,
                29.15876
              ],
              [
                61.412406,
                29.15896
              ],
              [
                61.412684,
                29.159588
              ],
              [
                61.412448,
                29.159921
              ],
              [
                61.412476,
                29.160038
              ],
              [
                61.412283,
                29.160211
              ],
              [
                61.412774,
                29.160433
              ],
              [
                61.412931,
                29.160716
              ],
              [
                61.413182,
                29.160996
              ],
              [
                61.41299,
                29.161645
              ],
              [
                61.412967,
                29.161891
              ],
              [
                61.413242,
                29.16221
              ],
              [
                61.413394,
                29.162322
              ],
              [
                61.413056,
                29.163078
              ],
              [
                61.412995,
                29.163353
              ],
              [
                61.413139,
                29.163448
              ],
              [
                61.413008,
                29.16372
              ],
              [
                61.412817,
                29.163769
              ],
              [
                61.412752,
                29.163871
              ],
              [
                61.412811,
                29.164196
              ],
              [
                61.41287,
                29.164201
              ],
              [
                61.412887,
                29.164405
              ],
              [
                61.41311,
                29.164512
              ],
              [
                61.413811,
                29.164502
              ],
              [
                61.413876,
                29.164562
              ],
              [
                61.414072,
                29.164585
              ],
              [
                61.414411,
                29.164744
              ],
              [
                61.414563,
                29.164862
              ],
              [
                61.414613,
                29.164698
              ],
              [
                61.414877,
                29.164426
              ],
              [
                61.415134,
                29.164045
              ],
              [
                61.415496,
                29.163626
              ],
              [
                61.415556,
                29.163429
              ],
              [
                61.416213,
                29.162946
              ],
              [
                61.416325,
                29.162935
              ],
              [
                61.416888,
                29.162588
              ],
              [
                61.417211,
                29.162138
              ],
              [
                61.417579,
                29.162217
              ],
              [
                61.417999,
                29.162408
              ],
              [
                61.418145,
                29.162407
              ],
              [
                61.418398,
                29.162273
              ],
              [
                61.41847,
                29.162444
              ],
              [
                61.418569,
                29.162458
              ],
              [
                61.418746,
                29.162669
              ],
              [
                61.419083,
                29.162855
              ],
              [
                61.419497,
                29.162997
              ],
              [
                61.419761,
                29.16346
              ],
              [
                61.420175,
                29.163675
              ],
              [
                61.420348,
                29.163686
              ],
              [
                61.420515,
                29.163752
              ],
              [
                61.420639,
                29.163892
              ],
              [
                61.420906,
                29.164029
              ],
              [
                61.420783,
                29.164306
              ],
              [
                61.420764,
                29.164545
              ],
              [
                61.420689,
                29.164655
              ],
              [
                61.420618,
                29.165016
              ],
              [
                61.420417,
                29.165157
              ],
              [
                61.420392,
                29.165711
              ],
              [
                61.420201,
                29.165944
              ],
              [
                61.419987,
                29.166502
              ],
              [
                61.419826,
                29.16668
              ],
              [
                61.419754,
                29.166851
              ],
              [
                61.419533,
                29.16704
              ],
              [
                61.419528,
                29.167204
              ],
              [
                61.419225,
                29.167471
              ],
              [
                61.419058,
                29.1677
              ],
              [
                61.418704,
                29.167837
              ],
              [
                61.418648,
                29.168078
              ],
              [
                61.418435,
                29.168299
              ],
              [
                61.418353,
                29.168484
              ],
              [
                61.418131,
                29.168539
              ],
              [
                61.417778,
                29.169073
              ],
              [
                61.417675,
                29.169251
              ],
              [
                61.417667,
                29.169512
              ],
              [
                61.417454,
                29.169491
              ],
              [
                61.417279,
                29.169553
              ],
              [
                61.41709,
                29.16977
              ],
              [
                61.417012,
                29.170077
              ],
              [
                61.416709,
                29.170215
              ],
              [
                61.416695,
                29.170341
              ],
              [
                61.416568,
                29.1705
              ],
              [
                61.416982,
                29.170748
              ],
              [
                61.416828,
                29.17083
              ],
              [
                61.416531,
                29.171528
              ],
              [
                61.416622,
                29.171907
              ],
              [
                61.416477,
                29.171964
              ],
              [
                61.416309,
                29.172238
              ],
              [
                61.416206,
                29.172286
              ],
              [
                61.41614,
                29.172462
              ],
              [
                61.416096,
                29.172829
              ],
              [
                61.416221,
                29.173219
              ],
              [
                61.416318,
                29.173352
              ],
              [
                61.416211,
                29.173363
              ],
              [
                61.416071,
                29.173469
              ],
              [
                61.415685,
                29.173387
              ],
              [
                61.415445,
                29.173417
              ],
              [
                61.415241,
                29.173362
              ],
              [
                61.415036,
                29.173196
              ],
              [
                61.414677,
                29.173334
              ],
              [
                61.414619,
                29.173278
              ],
              [
                61.4145,
                29.173285
              ],
              [
                61.414488,
                29.173422
              ],
              [
                61.414339,
                29.173434
              ],
              [
                61.414285,
                29.173339
              ],
              [
                61.414028,
                29.173345
              ],
              [
                61.413999,
                29.173499
              ],
              [
                61.413858,
                29.173547
              ],
              [
                61.413867,
                29.173623
              ],
              [
                61.413548,
                29.174151
              ],
              [
                61.41353,
                29.174446
              ],
              [
                61.41339,
                29.174681
              ],
              [
                61.413176,
                29.174712
              ],
              [
                61.413157,
                29.174817
              ],
              [
                61.412824,
                29.174776
              ],
              [
                61.412833,
                29.175026
              ],
              [
                61.412716,
                29.175094
              ],
              [
                61.412662,
                29.175262
              ],
              [
                61.412681,
                29.175421
              ],
              [
                61.412863,
                29.175833
              ],
              [
                61.412897,
                29.176134
              ],
              [
                61.412862,
                29.176304
              ],
              [
                61.412948,
                29.176449
              ],
              [
                61.413029,
                29.176758
              ],
              [
                61.413212,
                29.17689
              ],
              [
                61.413299,
                29.177276
              ],
              [
                61.413431,
                29.177507
              ],
              [
                61.413375,
                29.177748
              ],
              [
                61.4134,
                29.178012
              ],
              [
                61.413982,
                29.178373
              ],
              [
                61.41401,
                29.178491
              ],
              [
                61.413849,
                29.178835
              ],
              [
                61.413972,
                29.178838
              ],
              [
                61.413934,
                29.178965
              ],
              [
                61.41397,
                29.179115
              ],
              [
                61.4139,
                29.179269
              ],
              [
                61.414866,
                29.180042
              ],
              [
                61.414927,
                29.180164
              ],
              [
                61.415162,
                29.180297
              ],
              [
                61.415323,
                29.18031
              ],
              [
                61.415513,
                29.180491
              ],
              [
                61.415833,
                29.180506
              ],
              [
                61.416119,
                29.180455
              ],
              [
                61.416584,
                29.180514
              ],
              [
                61.416762,
                29.180546
              ],
              [
                61.416915,
                29.180678
              ],
              [
                61.417096,
                29.180458
              ],
              [
                61.417435,
                29.180254
              ],
              [
                61.417993,
                29.179703
              ],
              [
                61.418298,
                29.180024
              ],
              [
                61.418458,
                29.180267
              ],
              [
                61.418542,
                29.180933
              ],
              [
                61.418598,
                29.181006
              ],
              [
                61.418946,
                29.181101
              ],
              [
                61.41889,
                29.181196
              ],
              [
                61.41899,
                29.181268
              ],
              [
                61.418949,
                29.181416
              ],
              [
                61.418979,
                29.181486
              ],
              [
                61.419268,
                29.181521
              ],
              [
                61.419651,
                29.181432
              ],
              [
                61.419526,
                29.181596
              ],
              [
                61.419462,
                29.181805
              ],
              [
                61.419531,
                29.181903
              ],
              [
                61.419926,
                29.181993
              ],
              [
                61.42016,
                29.182205
              ],
              [
                61.420233,
                29.182218
              ],
              [
                61.420356,
                29.182438
              ],
              [
                61.42075,
                29.182786
              ],
              [
                61.421234,
                29.183334
              ],
              [
                61.421259,
                29.183402
              ],
              [
                61.421121,
                29.183511
              ],
              [
                61.421103,
                29.183579
              ],
              [
                61.42051,
                29.183928
              ],
              [
                61.420484,
                29.18413
              ],
              [
                61.420356,
                29.184238
              ],
              [
                61.420423,
                29.184587
              ],
              [
                61.420292,
                29.184722
              ],
              [
                61.420275,
                29.184809
              ],
              [
                61.420352,
                29.185102
              ],
              [
                61.420623,
                29.185385
              ],
              [
                61.420397,
                29.185631
              ],
              [
                61.420169,
                29.185748
              ],
              [
                61.420098,
                29.185871
              ],
              [
                61.420262,
                29.186151
              ],
              [
                61.420217,
                29.186227
              ],
              [
                61.420283,
                29.186421
              ],
              [
                61.420516,
                29.186706
              ],
              [
                61.42048,
                29.186819
              ],
              [
                61.420519,
                29.186929
              ],
              [
                61.420449,
                29.187032
              ],
              [
                61.420381,
                29.187017
              ],
              [
                61.420216,
                29.187213
              ],
              [
                61.420108,
                29.187459
              ],
              [
                61.420347,
                29.187742
              ],
              [
                61.42024,
                29.187875
              ],
              [
                61.420278,
                29.188164
              ],
              [
                61.420406,
                29.188436
              ],
              [
                61.42057,
                29.188552
              ],
              [
                61.420585,
                29.188607
              ],
              [
                61.420311,
                29.188724
              ],
              [
                61.420268,
                29.188952
              ],
              [
                61.420383,
                29.189045
              ],
              [
                61.420351,
                29.189122
              ],
              [
                61.420148,
                29.189338
              ],
              [
                61.420131,
                29.189504
              ],
              [
                61.419991,
                29.189739
              ],
              [
                61.419633,
                29.190015
              ],
              [
                61.419606,
                29.190264
              ],
              [
                61.419702,
                29.190336
              ],
              [
                61.41972,
                29.190532
              ],
              [
                61.419807,
                29.190663
              ],
              [
                61.4197,
                29.190951
              ],
              [
                61.419709,
                29.191095
              ],
              [
                61.420056,
                29.191248
              ],
              [
                61.420217,
                29.191412
              ],
              [
                61.420221,
                29.191469
              ],
              [
                61.420329,
                29.191522
              ],
              [
                61.420859,
                29.191551
              ],
              [
                61.421462,
                29.191426
              ],
              [
                61.42169,
                29.191503
              ],
              [
                61.421754,
                29.191566
              ],
              [
                61.421963,
                29.191558
              ],
              [
                61.422342,
                29.191812
              ],
              [
                61.422534,
                29.191847
              ],
              [
                61.422767,
                29.191812
              ],
              [
                61.42302,
                29.191678
              ],
              [
                61.423184,
                29.191517
              ],
              [
                61.4238,
                29.191966
              ],
              [
                61.424218,
                29.192203
              ],
              [
                61.424454,
                29.192577
              ],
              [
                61.42456,
                29.192877
              ],
              [
                61.424189,
                29.193004
              ],
              [
                61.423912,
                29.192801
              ],
              [
                61.423755,
                29.19281
              ],
              [
                61.423533,
                29.192994
              ],
              [
                61.423304,
                29.193274
              ],
              [
                61.42342,
                29.193342
              ],
              [
                61.423499,
                29.193561
              ],
              [
                61.423457,
                29.193889
              ],
              [
                61.423403,
                29.193975
              ],
              [
                61.423485,
                29.194158
              ],
              [
                61.423674,
                29.194214
              ],
              [
                61.423981,
                29.194759
              ],
              [
                61.423927,
                29.194844
              ],
              [
                61.423494,
                29.195175
              ],
              [
                61.423384,
                29.195348
              ],
              [
                61.422974,
                29.195648
              ],
              [
                61.422966,
                29.195745
              ],
              [
                61.423062,
                29.195859
              ],
              [
                61.422734,
                29.196256
              ],
              [
                61.423275,
                29.196423
              ],
              [
                61.423504,
                29.196742
              ],
              [
                61.423584,
                29.19676
              ],
              [
                61.423786,
                29.196966
              ],
              [
                61.424135,
                29.197071
              ],
              [
                61.42441,
                29.197319
              ],
              [
                61.424766,
                29.197506
              ],
              [
                61.424948,
                29.197324
              ],
              [
                61.425179,
                29.197281
              ],
              [
                61.425282,
                29.197409
              ],
              [
                61.42544,
                29.197452
              ],
              [
                61.425599,
                29.197436
              ],
              [
                61.425672,
                29.197508
              ],
              [
                61.425562,
                29.197679
              ],
              [
                61.425849,
                29.19795
              ],
              [
                61.426247,
                29.197944
              ],
              [
                61.426506,
                29.198148
              ],
              [
                61.426562,
                29.198259
              ],
              [
                61.426501,
                29.198269
              ],
              [
                61.426484,
                29.198388
              ],
              [
                61.426626,
                29.198481
              ],
              [
                61.426763,
                29.19882
              ],
              [
                61.426963,
                29.198836
              ],
              [
                61.427096,
                29.198911
              ],
              [
                61.42746,
                29.198895
              ],
              [
                61.427855,
                29.198985
              ],
              [
                61.427939,
                29.198884
              ],
              [
                61.428005,
                29.198871
              ],
              [
                61.428199,
                29.19862
              ],
              [
                61.428515,
                29.198563
              ],
              [
                61.428681,
                29.198463
              ],
              [
                61.429093,
                29.198438
              ],
              [
                61.429641,
                29.198105
              ],
              [
                61.429825,
                29.197923
              ],
              [
                61.43012,
                29.19833
              ],
              [
                61.430255,
                29.198877
              ],
              [
                61.430218,
                29.199095
              ],
              [
                61.429889,
                29.199451
              ],
              [
                61.429656,
                29.199814
              ],
              [
                61.429225,
                29.199826
              ],
              [
                61.429001,
                29.200019
              ],
              [
                61.428798,
                29.200095
              ],
              [
                61.428608,
                29.200318
              ],
              [
                61.428252,
                29.200579
              ],
              [
                61.428045,
                29.201064
              ],
              [
                61.427793,
                29.201358
              ],
              [
                61.427559,
                29.20115
              ],
              [
                61.427142,
                29.201189
              ],
              [
                61.426952,
                29.201089
              ],
              [
                61.426828,
                29.201143
              ],
              [
                61.426464,
                29.201577
              ],
              [
                61.42636,
                29.201602
              ],
              [
                61.426389,
                29.201695
              ],
              [
                61.426277,
                29.201856
              ],
              [
                61.426064,
                29.201964
              ],
              [
                61.426026,
                29.202162
              ],
              [
                61.425556,
                29.202915
              ],
              [
                61.425486,
                29.202967
              ],
              [
                61.425347,
                29.202865
              ],
              [
                61.425064,
                29.202825
              ],
              [
                61.424859,
                29.202972
              ],
              [
                61.424585,
                29.202915
              ],
              [
                61.424416,
                29.203241
              ],
              [
                61.424004,
                29.203792
              ],
              [
                61.423707,
                29.203877
              ],
              [
                61.423515,
                29.203767
              ],
              [
                61.423518,
                29.203707
              ],
              [
                61.423293,
                29.203587
              ],
              [
                61.423087,
                29.203522
              ],
              [
                61.42305,
                29.203566
              ],
              [
                61.422948,
                29.203557
              ],
              [
                61.422688,
                29.203251
              ],
              [
                61.422553,
                29.203193
              ],
              [
                61.422341,
                29.203184
              ],
              [
                61.421992,
                29.203596
              ],
              [
                61.421654,
                29.203909
              ],
              [
                61.421318,
                29.204015
              ],
              [
                61.421095,
                29.204036
              ],
              [
                61.421019,
                29.204113
              ],
              [
                61.420935,
                29.204371
              ],
              [
                61.420762,
                29.20455
              ],
              [
                61.420788,
                29.204657
              ],
              [
                61.420713,
                29.204874
              ],
              [
                61.420746,
                29.204979
              ],
              [
                61.420499,
                29.205431
              ],
              [
                61.42027,
                29.205348
              ],
              [
                61.420055,
                29.205379
              ],
              [
                61.41979,
                29.205723
              ],
              [
                61.419308,
                29.205936
              ],
              [
                61.418447,
                29.205703
              ],
              [
                61.418076,
                29.205927
              ],
              [
                61.417614,
                29.205431
              ],
              [
                61.417308,
                29.205687
              ],
              [
                61.41696,
                29.205823
              ],
              [
                61.416838,
                29.205842
              ],
              [
                61.416432,
                29.205788
              ],
              [
                61.415757,
                29.205932
              ],
              [
                61.415733,
                29.206178
              ],
              [
                61.415531,
                29.206313
              ],
              [
                61.415598,
                29.206457
              ],
              [
                61.415577,
                29.206584
              ],
              [
                61.415439,
                29.206746
              ],
              [
                61.414954,
                29.206853
              ],
              [
                61.414807,
                29.20691
              ],
              [
                61.414703,
                29.207048
              ],
              [
                61.414525,
                29.207072
              ],
              [
                61.414259,
                29.207416
              ],
              [
                61.413937,
                29.207649
              ],
              [
                61.413679,
                29.20794
              ],
              [
                61.413462,
                29.208002
              ],
              [
                61.413315,
                29.20797
              ],
              [
                61.413085,
                29.208004
              ],
              [
                61.41302,
                29.208051
              ],
              [
                61.412584,
                29.20775
              ],
              [
                61.412366,
                29.207651
              ],
              [
                61.411904,
                29.207916
              ],
              [
                61.411726,
                29.208141
              ],
              [
                61.411658,
                29.208541
              ],
              [
                61.411613,
                29.208618
              ],
              [
                61.411516,
                29.208623
              ],
              [
                61.411388,
                29.208805
              ],
              [
                61.411484,
                29.208951
              ],
              [
                61.411424,
                29.208966
              ],
              [
                61.411383,
                29.209215
              ],
              [
                61.41116,
                29.209368
              ],
              [
                61.410798,
                29.209487
              ],
              [
                61.410623,
                29.20964
              ],
              [
                61.410623,
                29.209693
              ],
              [
                61.410433,
                29.209798
              ],
              [
                61.410367,
                29.209909
              ],
              [
                61.41042,
                29.210142
              ],
              [
                61.410368,
                29.210253
              ],
              [
                61.410093,
                29.210193
              ],
              [
                61.409926,
                29.209973
              ],
              [
                61.409711,
                29.20987
              ],
              [
                61.409467,
                29.209885
              ],
              [
                61.409163,
                29.210096
              ],
              [
                61.409164,
                29.210203
              ],
              [
                61.409066,
                29.210217
              ],
              [
                61.408764,
                29.210411
              ],
              [
                61.408527,
                29.210614
              ],
              [
                61.408281,
                29.210909
              ],
              [
                61.408085,
                29.210988
              ],
              [
                61.407805,
                29.21125
              ],
              [
                61.407564,
                29.211326
              ],
              [
                61.407436,
                29.21148
              ],
              [
                61.407419,
                29.211674
              ],
              [
                61.407287,
                29.211739
              ],
              [
                61.40707,
                29.212092
              ],
              [
                61.40692,
                29.21246
              ],
              [
                61.406898,
                29.212658
              ],
              [
                61.406713,
                29.212911
              ],
              [
                61.406335,
                29.213196
              ],
              [
                61.406183,
                29.213348
              ],
              [
                61.406145,
                29.213455
              ],
              [
                61.405945,
                29.213589
              ],
              [
                61.406027,
                29.213955
              ],
              [
                61.40592,
                29.214087
              ],
              [
                61.405721,
                29.214149
              ],
              [
                61.405584,
                29.214314
              ],
              [
                61.405326,
                29.214443
              ],
              [
                61.405377,
                29.214632
              ],
              [
                61.405314,
                29.215021
              ],
              [
                61.405024,
                29.215154
              ],
              [
                61.404803,
                29.215319
              ],
              [
                61.404691,
                29.215283
              ],
              [
                61.404601,
                29.215329
              ],
              [
                61.404487,
                29.215288
              ],
              [
                61.404394,
                29.215359
              ],
              [
                61.404305,
                29.215553
              ],
              [
                61.40409,
                29.215549
              ],
              [
                61.403845,
                29.215656
              ],
              [
                61.403663,
                29.215659
              ],
              [
                61.403525,
                29.215595
              ],
              [
                61.403558,
                29.215494
              ],
              [
                61.403468,
                29.215487
              ],
              [
                61.403318,
                29.215389
              ],
              [
                61.403052,
                29.21555
              ],
              [
                61.402939,
                29.215447
              ],
              [
                61.402927,
                29.215306
              ],
              [
                61.402636,
                29.215239
              ],
              [
                61.402362,
                29.215379
              ],
              [
                61.402351,
                29.215437
              ],
              [
                61.402209,
                29.215556
              ],
              [
                61.402047,
                29.215602
              ],
              [
                61.401712,
                29.215898
              ],
              [
                61.401546,
                29.215887
              ],
              [
                61.401411,
                29.21572
              ],
              [
                61.400925,
                29.215738
              ],
              [
                61.400817,
                29.215685
              ],
              [
                61.400619,
                29.215843
              ],
              [
                61.400522,
                29.216106
              ],
              [
                61.400449,
                29.216115
              ],
              [
                61.400309,
                29.21632
              ],
              [
                61.400108,
                29.21636
              ],
              [
                61.399858,
                29.216185
              ],
              [
                61.399353,
                29.215942
              ],
              [
                61.399313,
                29.21598
              ],
              [
                61.399227,
                29.215944
              ],
              [
                61.398989,
                29.216053
              ],
              [
                61.398847,
                29.216225
              ],
              [
                61.398876,
                29.216446
              ],
              [
                61.398647,
                29.216674
              ],
              [
                61.398503,
                29.216753
              ],
              [
                61.398262,
                29.217011
              ],
              [
                61.39823,
                29.217111
              ],
              [
                61.397839,
                29.217422
              ],
              [
                61.397672,
                29.217803
              ],
              [
                61.397722,
                29.21806
              ],
              [
                61.397538,
                29.218162
              ],
              [
                61.397438,
                29.218293
              ],
              [
                61.397264,
                29.218671
              ],
              [
                61.396907,
                29.218808
              ],
              [
                61.396811,
                29.218932
              ],
              [
                61.396798,
                29.219035
              ],
              [
                61.397288,
                29.219342
              ],
              [
                61.397461,
                29.219568
              ],
              [
                61.397392,
                29.219621
              ],
              [
                61.397282,
                29.21987
              ],
              [
                61.397002,
                29.220077
              ],
              [
                61.397041,
                29.220131
              ],
              [
                61.396788,
                29.220247
              ],
              [
                61.396793,
                29.22036
              ],
              [
                61.396601,
                29.220622
              ],
              [
                61.396317,
                29.220803
              ],
              [
                61.396124,
                29.221035
              ],
              [
                61.39602,
                29.221022
              ],
              [
                61.395779,
                29.221131
              ],
              [
                61.395555,
                29.221104
              ],
              [
                61.395464,
                29.221302
              ],
              [
                61.395599,
                29.221402
              ],
              [
                61.395481,
                29.221725
              ],
              [
                61.395393,
                29.221778
              ],
              [
                61.395221,
                29.222056
              ],
              [
                61.394937,
                29.222132
              ],
              [
                61.394918,
                29.22221
              ],
              [
                61.394778,
                29.222346
              ],
              [
                61.394448,
                29.222533
              ],
              [
                61.393884,
                29.223135
              ],
              [
                61.39356,
                29.223368
              ],
              [
                61.393365,
                29.22359
              ],
              [
                61.393221,
                29.223555
              ],
              [
                61.39311,
                29.223684
              ],
              [
                61.392781,
                29.223728
              ],
              [
                61.392752,
                29.223858
              ],
              [
                61.392702,
                29.223871
              ],
              [
                61.392712,
                29.223941
              ],
              [
                61.391649,
                29.224309
              ],
              [
                61.391471,
                29.224275
              ],
              [
                61.391219,
                29.224314
              ],
              [
                61.391053,
                29.224291
              ],
              [
                61.390997,
                29.224361
              ],
              [
                61.390841,
                29.224405
              ],
              [
                61.390777,
                29.22452
              ],
              [
                61.39066,
                29.224544
              ],
              [
                61.390306,
                29.224786
              ],
              [
                61.390233,
                29.224875
              ],
              [
                61.389894,
                29.225011
              ],
              [
                61.390014,
                29.225184
              ],
              [
                61.390089,
                29.225454
              ],
              [
                61.390072,
                29.225724
              ],
              [
                61.389887,
                29.225819
              ],
              [
                61.389887,
                29.225938
              ],
              [
                61.389765,
                29.226084
              ],
              [
                61.389534,
                29.226116
              ],
              [
                61.389297,
                29.226282
              ],
              [
                61.389276,
                29.226394
              ],
              [
                61.389182,
                29.226498
              ],
              [
                61.389211,
                29.226578
              ],
              [
                61.389054,
                29.226792
              ],
              [
                61.388805,
                29.226853
              ],
              [
                61.388723,
                29.226958
              ],
              [
                61.388634,
                29.226903
              ],
              [
                61.388164,
                29.226913
              ],
              [
                61.387844,
                29.227126
              ],
              [
                61.387622,
                29.227198
              ],
              [
                61.387444,
                29.227349
              ],
              [
                61.387385,
                29.227444
              ],
              [
                61.387416,
                29.227599
              ],
              [
                61.387358,
                29.227671
              ],
              [
                61.38744,
                29.227777
              ],
              [
                61.387316,
                29.227912
              ],
              [
                61.387084,
                29.228545
              ],
              [
                61.386998,
                29.228634
              ],
              [
                61.386773,
                29.229139
              ],
              [
                61.386754,
                29.229347
              ],
              [
                61.386645,
                29.229391
              ],
              [
                61.38649,
                29.229267
              ],
              [
                61.38599,
                29.229155
              ],
              [
                61.385843,
                29.229328
              ],
              [
                61.38566,
                29.229431
              ],
              [
                61.385484,
                29.229405
              ],
              [
                61.384883,
                29.229862
              ],
              [
                61.38496,
                29.229941
              ],
              [
                61.384799,
                29.230023
              ],
              [
                61.384586,
                29.230331
              ],
              [
                61.384277,
                29.230276
              ],
              [
                61.38402,
                29.230648
              ],
              [
                61.383753,
                29.230634
              ],
              [
                61.383316,
                29.230859
              ],
              [
                61.383051,
                29.231095
              ],
              [
                61.383049,
                29.231477
              ],
              [
                61.382911,
                29.231632
              ],
              [
                61.382776,
                29.231761
              ],
              [
                61.382381,
                29.23192
              ],
              [
                61.382262,
                29.231921
              ],
              [
                61.382423,
                29.232017
              ],
              [
                61.382552,
                29.232185
              ],
              [
                61.382557,
                29.232339
              ],
              [
                61.382414,
                29.232633
              ],
              [
                61.382142,
                29.232759
              ],
              [
                61.382098,
                29.232967
              ],
              [
                61.381868,
                29.23324
              ],
              [
                61.381949,
                29.233811
              ],
              [
                61.381664,
                29.23399
              ],
              [
                61.381521,
                29.234284
              ],
              [
                61.381333,
                29.234471
              ],
              [
                61.381171,
                29.234503
              ],
              [
                61.381085,
                29.234669
              ],
              [
                61.38119,
                29.234793
              ],
              [
                61.38089,
                29.234802
              ],
              [
                61.380413,
                29.235041
              ],
              [
                61.379991,
                29.235385
              ],
              [
                61.37995,
                29.235526
              ],
              [
                61.379762,
                29.235663
              ],
              [
                61.379782,
                29.235789
              ],
              [
                61.3797,
                29.235883
              ],
              [
                61.379554,
                29.235939
              ],
              [
                61.379516,
                29.235978
              ],
              [
                61.379557,
                29.236013
              ],
              [
                61.379124,
                29.236121
              ],
              [
                61.37905,
                29.23618
              ],
              [
                61.378878,
                29.236198
              ],
              [
                61.378637,
                29.236351
              ],
              [
                61.378578,
                29.236495
              ],
              [
                61.378407,
                29.236546
              ],
              [
                61.378469,
                29.236722
              ],
              [
                61.378435,
                29.237097
              ],
              [
                61.377853,
                29.237516
              ],
              [
                61.377791,
                29.237651
              ],
              [
                61.377643,
                29.237678
              ],
              [
                61.37763,
                29.237836
              ],
              [
                61.377409,
                29.238367
              ],
              [
                61.377086,
                29.238348
              ],
              [
                61.376969,
                29.238213
              ],
              [
                61.37687,
                29.238183
              ],
              [
                61.376697,
                29.238279
              ],
              [
                61.376638,
                29.23837
              ],
              [
                61.376199,
                29.238435
              ],
              [
                61.375949,
                29.238545
              ],
              [
                61.375866,
                29.238778
              ],
              [
                61.375764,
                29.238803
              ],
              [
                61.375761,
                29.23892
              ],
              [
                61.375597,
                29.238986
              ],
              [
                61.375529,
                29.239282
              ],
              [
                61.375357,
                29.239543
              ],
              [
                61.375111,
                29.239669
              ],
              [
                61.374907,
                29.239856
              ],
              [
                61.37503,
                29.239898
              ],
              [
                61.37511,
                29.240007
              ],
              [
                61.375008,
                29.240183
              ],
              [
                61.374773,
                29.240384
              ],
              [
                61.374804,
                29.240644
              ],
              [
                61.374665,
                29.240694
              ],
              [
                61.374508,
                29.24093
              ],
              [
                61.374605,
                29.241648
              ],
              [
                61.37456,
                29.2418
              ],
              [
                61.374289,
                29.241954
              ],
              [
                61.374093,
                29.242214
              ],
              [
                61.37416,
                29.242334
              ],
              [
                61.374043,
                29.242424
              ],
              [
                61.373956,
                29.242581
              ],
              [
                61.373979,
                29.242763
              ],
              [
                61.373767,
                29.242791
              ],
              [
                61.372966,
                29.243313
              ],
              [
                61.372883,
                29.243595
              ],
              [
                61.372752,
                29.243732
              ],
              [
                61.372683,
                29.24389
              ],
              [
                61.372295,
                29.244133
              ],
              [
                61.372372,
                29.24461
              ],
              [
                61.372313,
                29.244705
              ],
              [
                61.372373,
                29.244876
              ],
              [
                61.372238,
                29.244892
              ],
              [
                61.372123,
                29.245042
              ],
              [
                61.372133,
                29.245162
              ],
              [
                61.372662,
                29.24524
              ],
              [
                61.372781,
                29.245366
              ],
              [
                61.372911,
                29.245384
              ],
              [
                61.373036,
                29.245537
              ],
              [
                61.373531,
                29.245843
              ],
              [
                61.373666,
                29.246088
              ],
              [
                61.373648,
                29.246224
              ],
              [
                61.373813,
                29.246413
              ],
              [
                61.373878,
                29.246578
              ],
              [
                61.374187,
                29.247026
              ],
              [
                61.374324,
                29.247071
              ],
              [
                61.374565,
                29.247677
              ],
              [
                61.374712,
                29.247637
              ],
              [
                61.375471,
                29.247752
              ],
              [
                61.375252,
                29.2481
              ],
              [
                61.375073,
                29.248141
              ],
              [
                61.374893,
                29.248332
              ],
              [
                61.374717,
                29.248389
              ],
              [
                61.374463,
                29.249032
              ],
              [
                61.374192,
                29.249213
              ],
              [
                61.374006,
                29.249228
              ],
              [
                61.373807,
                29.249395
              ],
              [
                61.373572,
                29.249491
              ],
              [
                61.373494,
                29.249717
              ],
              [
                61.37312,
                29.250334
              ],
              [
                61.373156,
                29.250532
              ],
              [
                61.373241,
                29.250676
              ],
              [
                61.373191,
                29.250785
              ],
              [
                61.373232,
                29.250982
              ],
              [
                61.373171,
                29.251066
              ],
              [
                61.372827,
                29.251284
              ],
              [
                61.372612,
                29.251332
              ],
              [
                61.3725,
                29.251498
              ],
              [
                61.37222,
                29.251432
              ],
              [
                61.371057,
                29.251518
              ],
              [
                61.370718,
                29.251419
              ],
              [
                61.370553,
                29.251463
              ],
              [
                61.370267,
                29.251348
              ],
              [
                61.370039,
                29.251083
              ],
              [
                61.370099,
                29.250833
              ],
              [
                61.369629,
                29.250765
              ],
              [
                61.368763,
                29.251169
              ],
              [
                61.368932,
                29.251479
              ],
              [
                61.368548,
                29.251506
              ],
              [
                61.368297,
                29.251616
              ],
              [
                61.367947,
                29.251625
              ],
              [
                61.367779,
                29.251713
              ],
              [
                61.367642,
                29.251979
              ],
              [
                61.367483,
                29.251971
              ],
              [
                61.367172,
                29.252144
              ],
              [
                61.367015,
                29.252294
              ],
              [
                61.366934,
                29.252468
              ],
              [
                61.366763,
                29.252513
              ],
              [
                61.366744,
                29.252799
              ],
              [
                61.366833,
                29.252986
              ],
              [
                61.366717,
                29.253081
              ],
              [
                61.366541,
                29.253393
              ],
              [
                61.366329,
                29.25343
              ],
              [
                61.366217,
                29.253513
              ],
              [
                61.366214,
                29.25384
              ],
              [
                61.366086,
                29.25391
              ],
              [
                61.365689,
                29.254509
              ],
              [
                61.365698,
                29.254807
              ],
              [
                61.365847,
                29.254907
              ],
              [
                61.365839,
                29.255175
              ],
              [
                61.36588,
                29.255214
              ],
              [
                61.366094,
                29.255096
              ],
              [
                61.366181,
                29.255116
              ],
              [
                61.366482,
                29.255006
              ],
              [
                61.366608,
                29.255059
              ],
              [
                61.366814,
                29.255367
              ],
              [
                61.367082,
                29.255641
              ],
              [
                61.367234,
                29.255721
              ],
              [
                61.36741,
                29.255642
              ],
              [
                61.367491,
                29.256047
              ],
              [
                61.367329,
                29.256093
              ],
              [
                61.367199,
                29.256243
              ],
              [
                61.366935,
                29.256337
              ],
              [
                61.366817,
                29.256527
              ],
              [
                61.366617,
                29.256572
              ],
              [
                61.366474,
                29.256514
              ],
              [
                61.365343,
                29.256985
              ],
              [
                61.364969,
                29.257455
              ],
              [
                61.364777,
                29.257573
              ],
              [
                61.364722,
                29.257792
              ],
              [
                61.364473,
                29.257958
              ],
              [
                61.36435,
                29.258342
              ],
              [
                61.36446,
                29.258822
              ],
              [
                61.364738,
                29.259063
              ],
              [
                61.364586,
                29.259226
              ],
              [
                61.364227,
                29.259383
              ],
              [
                61.363832,
                29.259456
              ],
              [
                61.363722,
                29.259328
              ],
              [
                61.3636,
                29.259388
              ],
              [
                61.363393,
                29.259332
              ],
              [
                61.363063,
                29.259425
              ],
              [
                61.362624,
                29.259246
              ],
              [
                61.362241,
                29.259333
              ],
              [
                61.36197,
                29.259487
              ],
              [
                61.361775,
                29.259697
              ],
              [
                61.3619,
                29.26011
              ],
              [
                61.362068,
                29.260209
              ],
              [
                61.362063,
                29.260449
              ],
              [
                61.361913,
                29.260506
              ],
              [
                61.361831,
                29.260611
              ],
              [
                61.361859,
                29.260832
              ],
              [
                61.361608,
                29.261054
              ],
              [
                61.361505,
                29.261271
              ],
              [
                61.361186,
                29.261542
              ],
              [
                61.361119,
                29.261888
              ],
              [
                61.361232,
                29.261965
              ],
              [
                61.36125,
                29.262094
              ],
              [
                61.361397,
                29.262231
              ],
              [
                61.36157,
                29.262549
              ],
              [
                61.361515,
                29.262801
              ],
              [
                61.361522,
                29.26322
              ],
              [
                61.361299,
                29.263447
              ],
              [
                61.361393,
                29.263733
              ],
              [
                61.361298,
                29.263885
              ],
              [
                61.361358,
                29.264084
              ],
              [
                61.361033,
                29.264409
              ],
              [
                61.360978,
                29.26499
              ],
              [
                61.360911,
                29.265103
              ],
              [
                61.360545,
                29.265286
              ],
              [
                61.360348,
                29.265477
              ],
              [
                61.360419,
                29.265585
              ],
              [
                61.360423,
                29.26577
              ],
              [
                61.360333,
                29.265816
              ],
              [
                61.359961,
                29.266283
              ],
              [
                61.360213,
                29.266388
              ],
              [
                61.36032,
                29.266755
              ],
              [
                61.36021,
                29.267068
              ],
              [
                61.360348,
                29.26733
              ],
              [
                61.360119,
                29.267464
              ],
              [
                61.360165,
                29.267541
              ],
              [
                61.360144,
                29.267675
              ],
              [
                61.360051,
                29.267758
              ],
              [
                61.360123,
                29.267916
              ],
              [
                61.360621,
                29.268318
              ],
              [
                61.360819,
                29.268567
              ],
              [
                61.36097,
                29.26888
              ],
              [
                61.361154,
                29.268966
              ],
              [
                61.361259,
                29.269244
              ],
              [
                61.360843,
                29.269293
              ],
              [
                61.360858,
                29.269595
              ],
              [
                61.360934,
                29.26974
              ],
              [
                61.36089,
                29.269967
              ],
              [
                61.361058,
                29.270658
              ],
              [
                61.360994,
                29.270914
              ],
              [
                61.361055,
                29.271093
              ],
              [
                61.361014,
                29.271328
              ],
              [
                61.360858,
                29.271802
              ],
              [
                61.36091,
                29.272163
              ],
              [
                61.360997,
                29.27234
              ],
              [
                61.360321,
                29.272789
              ],
              [
                61.360292,
                29.27287
              ],
              [
                61.360453,
                29.27317
              ],
              [
                61.360439,
                29.273381
              ],
              [
                61.360567,
                29.273563
              ],
              [
                61.360549,
                29.273827
              ],
              [
                61.360354,
                29.27401
              ],
              [
                61.360089,
                29.27399
              ],
              [
                61.360078,
                29.274067
              ],
              [
                61.359981,
                29.274161
              ],
              [
                61.359838,
                29.274129
              ],
              [
                61.359402,
                29.27416
              ],
              [
                61.359314,
                29.274238
              ],
              [
                61.359037,
                29.274188
              ],
              [
                61.359039,
                29.274354
              ],
              [
                61.358916,
                29.274467
              ],
              [
                61.358571,
                29.274607
              ],
              [
                61.358322,
                29.274828
              ],
              [
                61.358121,
                29.274879
              ],
              [
                61.357755,
                29.274747
              ],
              [
                61.357602,
                29.274816
              ],
              [
                61.35744,
                29.274665
              ],
              [
                61.357291,
                29.274623
              ],
              [
                61.357108,
                29.274648
              ],
              [
                61.356945,
                29.274442
              ],
              [
                61.356687,
                29.274443
              ],
              [
                61.356464,
                29.274354
              ],
              [
                61.356281,
                29.274352
              ],
              [
                61.3559,
                29.274809
              ],
              [
                61.355628,
                29.274332
              ],
              [
                61.355511,
                29.274287
              ],
              [
                61.355417,
                29.274362
              ],
              [
                61.354837,
                29.274554
              ],
              [
                61.354481,
                29.274564
              ],
              [
                61.354131,
                29.274966
              ],
              [
                61.353901,
                29.275019
              ],
              [
                61.353629,
                29.275184
              ],
              [
                61.353602,
                29.275386
              ],
              [
                61.3534,
                29.27567
              ],
              [
                61.353047,
                29.275851
              ],
              [
                61.352909,
                29.275983
              ],
              [
                61.353043,
                29.276228
              ],
              [
                61.352999,
                29.276304
              ],
              [
                61.353026,
                29.27642
              ],
              [
                61.353277,
                29.276492
              ],
              [
                61.353521,
                29.276643
              ],
              [
                61.353492,
                29.276837
              ],
              [
                61.353604,
                29.276909
              ],
              [
                61.353777,
                29.277208
              ],
              [
                61.353789,
                29.277288
              ],
              [
                61.353593,
                29.277676
              ],
              [
                61.35358,
                29.278011
              ],
              [
                61.353945,
                29.278376
              ],
              [
                61.353889,
                29.278565
              ],
              [
                61.354308,
                29.27923
              ],
              [
                61.354707,
                29.2794
              ],
              [
                61.354727,
                29.27964
              ],
              [
                61.354846,
                29.279821
              ],
              [
                61.354886,
                29.280062
              ],
              [
                61.354849,
                29.280225
              ],
              [
                61.354748,
                29.28033
              ],
              [
                61.354654,
                29.280293
              ],
              [
                61.354067,
                29.280402
              ],
              [
                61.353843,
                29.280518
              ],
              [
                61.353762,
                29.280678
              ],
              [
                61.353838,
                29.280813
              ],
              [
                61.353962,
                29.281298
              ],
              [
                61.354187,
                29.281503
              ],
              [
                61.354205,
                29.281809
              ],
              [
                61.354375,
                29.282152
              ],
              [
                61.354427,
                29.282474
              ],
              [
                61.354612,
                29.282578
              ],
              [
                61.35458,
                29.28277
              ],
              [
                61.35444,
                29.283
              ],
              [
                61.354515,
                29.283168
              ],
              [
                61.354374,
                29.283642
              ],
              [
                61.354151,
                29.283705
              ],
              [
                61.353665,
                29.283985
              ],
              [
                61.353595,
                29.284118
              ],
              [
                61.353195,
                29.284026
              ],
              [
                61.352956,
                29.284023
              ],
              [
                61.352901,
                29.284084
              ],
              [
                61.35265,
                29.284139
              ],
              [
                61.352601,
                29.284199
              ],
              [
                61.352212,
                29.284176
              ],
              [
                61.351983,
                29.284427
              ],
              [
                61.351844,
                29.284833
              ],
              [
                61.351668,
                29.284965
              ],
              [
                61.351712,
                29.285086
              ],
              [
                61.35143,
                29.285138
              ],
              [
                61.350787,
                29.2854
              ],
              [
                61.350975,
                29.285734
              ],
              [
                61.351545,
                29.286313
              ],
              [
                61.351628,
                29.28659
              ],
              [
                61.35149,
                29.286788
              ],
              [
                61.351729,
                29.287662
              ],
              [
                61.352003,
                29.287674
              ],
              [
                61.352121,
                29.287723
              ],
              [
                61.352101,
                29.287926
              ],
              [
                61.352241,
                29.288196
              ],
              [
                61.352335,
                29.288245
              ],
              [
                61.352194,
                29.288523
              ],
              [
                61.352263,
                29.288731
              ],
              [
                61.352629,
                29.288891
              ],
              [
                61.352738,
                29.288819
              ],
              [
                61.352932,
                29.288997
              ],
              [
                61.353093,
                29.289037
              ],
              [
                61.353409,
                29.289252
              ],
              [
                61.353992,
                29.289319
              ],
              [
                61.354377,
                29.289326
              ],
              [
                61.354784,
                29.288756
              ],
              [
                61.35475,
                29.288678
              ],
              [
                61.354886,
                29.28867
              ],
              [
                61.35498,
                29.288752
              ],
              [
                61.355476,
                29.288823
              ],
              [
                61.356437,
                29.289405
              ],
              [
                61.356602,
                29.29025
              ],
              [
                61.356838,
                29.290364
              ],
              [
                61.357211,
                29.290426
              ],
              [
                61.357462,
                29.290551
              ],
              [
                61.357617,
                29.290698
              ],
              [
                61.357962,
                29.290876
              ],
              [
                61.358247,
                29.291118
              ],
              [
                61.359382,
                29.290948
              ],
              [
                61.359474,
                29.291
              ],
              [
                61.359794,
                29.290901
              ],
              [
                61.360189,
                29.290851
              ],
              [
                61.360332,
                29.290785
              ],
              [
                61.360436,
                29.290643
              ],
              [
                61.36048,
                29.290665
              ],
              [
                61.360824,
                29.290575
              ],
              [
                61.361498,
                29.290593
              ],
              [
                61.361809,
                29.290698
              ],
              [
                61.362326,
                29.290529
              ],
              [
                61.362677,
                29.290584
              ],
              [
                61.362939,
                29.290524
              ],
              [
                61.363073,
                29.290572
              ],
              [
                61.363217,
                29.290674
              ],
              [
                61.363522,
                29.291065
              ],
              [
                61.363642,
                29.291113
              ],
              [
                61.363886,
                29.291331
              ],
              [
                61.364077,
                29.29172
              ],
              [
                61.364495,
                29.291911
              ],
              [
                61.364636,
                29.292094
              ],
              [
                61.364701,
                29.292452
              ],
              [
                61.36466,
                29.292662
              ],
              [
                61.36479,
                29.292877
              ],
              [
                61.364741,
                29.292959
              ],
              [
                61.364906,
                29.293043
              ],
              [
                61.364984,
                29.293235
              ],
              [
                61.364997,
                29.293357
              ],
              [
                61.364864,
                29.293536
              ],
              [
                61.364931,
                29.293594
              ],
              [
                61.364923,
                29.293729
              ],
              [
                61.365195,
                29.293828
              ],
              [
                61.365336,
                29.293927
              ],
              [
                61.365403,
                29.294061
              ],
              [
                61.365503,
                29.294046
              ],
              [
                61.365612,
                29.294105
              ],
              [
                61.365604,
                29.294176
              ],
              [
                61.365692,
                29.294242
              ],
              [
                61.365752,
                29.294424
              ],
              [
                61.365954,
                29.294494
              ],
              [
                61.366263,
                29.294782
              ],
              [
                61.366844,
                29.295077
              ],
              [
                61.366834,
                29.295129
              ],
              [
                61.366965,
                29.295344
              ],
              [
                61.367445,
                29.295299
              ],
              [
                61.3676,
                29.295368
              ],
              [
                61.367809,
                29.295553
              ],
              [
                61.367746,
                29.29566
              ],
              [
                61.367918,
                29.295825
              ],
              [
                61.368117,
                29.296129
              ],
              [
                61.368151,
                29.296294
              ],
              [
                61.368297,
                29.296432
              ],
              [
                61.368513,
                29.296544
              ],
              [
                61.368537,
                29.296694
              ],
              [
                61.36862,
                29.296755
              ],
              [
                61.369014,
                29.296899
              ],
              [
                61.369808,
                29.296902
              ],
              [
                61.370053,
                29.297081
              ],
              [
                61.370346,
                29.29747
              ],
              [
                61.370156,
                29.297807
              ],
              [
                61.369993,
                29.297966
              ],
              [
                61.370033,
                29.298108
              ],
              [
                61.370001,
                29.298314
              ],
              [
                61.370063,
                29.298573
              ],
              [
                61.370025,
                29.298885
              ],
              [
                61.369529,
                29.299388
              ],
              [
                61.369529,
                29.299543
              ],
              [
                61.369387,
                29.299843
              ],
              [
                61.369242,
                29.299921
              ],
              [
                61.368956,
                29.300354
              ],
              [
                61.368814,
                29.300444
              ],
              [
                61.368501,
                29.300528
              ],
              [
                61.368113,
                29.300513
              ],
              [
                61.368273,
                29.300647
              ],
              [
                61.368212,
                29.301412
              ],
              [
                61.368102,
                29.301739
              ],
              [
                61.36763,
                29.302447
              ],
              [
                61.367081,
                29.303121
              ],
              [
                61.367065,
                29.30329
              ],
              [
                61.366982,
                29.30339
              ],
              [
                61.366582,
                29.30364
              ],
              [
                61.366334,
                29.303967
              ],
              [
                61.366148,
                29.304032
              ],
              [
                61.365972,
                29.304338
              ],
              [
                61.365919,
                29.304769
              ],
              [
                61.366031,
                29.305002
              ],
              [
                61.366035,
                29.305123
              ],
              [
                61.366173,
                29.305223
              ],
              [
                61.36616,
                29.305326
              ],
              [
                61.366568,
                29.3054
              ],
              [
                61.366705,
                29.3055
              ],
              [
                61.366879,
                29.305515
              ],
              [
                61.366974,
                29.305674
              ],
              [
                61.366948,
                29.305829
              ],
              [
                61.36688,
                29.305886
              ],
              [
                61.366815,
                29.30627
              ],
              [
                61.366998,
                29.306533
              ],
              [
                61.366926,
                29.30678
              ],
              [
                61.367003,
                29.306842
              ],
              [
                61.366804,
                29.307375
              ],
              [
                61.366779,
                29.307635
              ],
              [
                61.366622,
                29.307688
              ],
              [
                61.366515,
                29.307637
              ],
              [
                61.366055,
                29.307872
              ],
              [
                61.365979,
                29.308159
              ],
              [
                61.365901,
                29.308279
              ],
              [
                61.365496,
                29.308559
              ],
              [
                61.365423,
                29.308961
              ],
              [
                61.365325,
                29.309075
              ],
              [
                61.36521,
                29.309358
              ],
              [
                61.36505,
                29.309556
              ],
              [
                61.365075,
                29.309684
              ],
              [
                61.364909,
                29.309938
              ],
              [
                61.364636,
                29.310109
              ],
              [
                61.364817,
                29.310522
              ],
              [
                61.36515,
                29.310717
              ],
              [
                61.365126,
                29.311012
              ],
              [
                61.365212,
                29.311298
              ],
              [
                61.365305,
                29.311338
              ],
              [
                61.365389,
                29.311292
              ],
              [
                61.365514,
                29.311497
              ],
              [
                61.365597,
                29.311527
              ],
              [
                61.365598,
                29.311603
              ],
              [
                61.365743,
                29.311669
              ],
              [
                61.365876,
                29.311665
              ],
              [
                61.365842,
                29.311801
              ],
              [
                61.365941,
                29.31196
              ],
              [
                61.365884,
                29.312025
              ],
              [
                61.365942,
                29.312195
              ],
              [
                61.366427,
                29.312245
              ],
              [
                61.366545,
                29.312295
              ],
              [
                61.366548,
                29.312341
              ],
              [
                61.366713,
                29.312367
              ],
              [
                61.366769,
                29.312507
              ],
              [
                61.366711,
                29.312636
              ],
              [
                61.366859,
                29.312856
              ],
              [
                61.367002,
                29.31295
              ],
              [
                61.36703,
                29.313057
              ],
              [
                61.36749,
                29.313377
              ],
              [
                61.367177,
                29.313828
              ],
              [
                61.367403,
                29.313849
              ],
              [
                61.367635,
                29.313989
              ],
              [
                61.367944,
                29.314365
              ],
              [
                61.367822,
                29.314546
              ],
              [
                61.367877,
                29.314657
              ],
              [
                61.367824,
                29.314773
              ],
              [
                61.367873,
                29.31499
              ],
              [
                61.367979,
                29.315045
              ],
              [
                61.368011,
                29.31512
              ],
              [
                61.367923,
                29.315254
              ],
              [
                61.367951,
                29.315393
              ],
              [
                61.367849,
                29.31547
              ],
              [
                61.367846,
                29.315656
              ],
              [
                61.367651,
                29.315807
              ],
              [
                61.367665,
                29.31587
              ],
              [
                61.367444,
                29.31609
              ],
              [
                61.367291,
                29.31617
              ],
              [
                61.366927,
                29.316494
              ],
              [
                61.367198,
                29.316528
              ],
              [
                61.367328,
                29.316615
              ],
              [
                61.367538,
                29.316571
              ],
              [
                61.367663,
                29.316634
              ],
              [
                61.367808,
                29.316794
              ],
              [
                61.366917,
                29.317728
              ],
              [
                61.366699,
                29.318124
              ],
              [
                61.366701,
                29.318211
              ],
              [
                61.366544,
                29.318419
              ],
              [
                61.366552,
                29.318488
              ],
              [
                61.366404,
                29.318618
              ],
              [
                61.366417,
                29.318681
              ],
              [
                61.366218,
                29.318972
              ],
              [
                61.366645,
                29.319098
              ],
              [
                61.366918,
                29.319247
              ],
              [
                61.367005,
                29.319361
              ],
              [
                61.367048,
                29.319531
              ],
              [
                61.367013,
                29.319665
              ],
              [
                61.367359,
                29.320167
              ],
              [
                61.367454,
                29.320179
              ],
              [
                61.36748,
                29.320125
              ],
              [
                61.367607,
                29.320093
              ],
              [
                61.367802,
                29.320255
              ],
              [
                61.368035,
                29.320526
              ],
              [
                61.3681,
                29.320758
              ],
              [
                61.368197,
                29.320885
              ],
              [
                61.368326,
                29.32086
              ],
              [
                61.368498,
                29.320623
              ],
              [
                61.368501,
                29.32052
              ],
              [
                61.368694,
                29.320334
              ],
              [
                61.368863,
                29.320306
              ],
              [
                61.368891,
                29.320259
              ],
              [
                61.368979,
                29.320278
              ],
              [
                61.369011,
                29.320188
              ],
              [
                61.369329,
                29.319825
              ],
              [
                61.369491,
                29.319836
              ],
              [
                61.369624,
                29.319925
              ],
              [
                61.369742,
                29.319787
              ],
              [
                61.369855,
                29.319803
              ],
              [
                61.370222,
                29.320039
              ],
              [
                61.37028,
                29.32
              ],
              [
                61.370392,
                29.320015
              ],
              [
                61.370717,
                29.320214
              ],
              [
                61.370888,
                29.320229
              ],
              [
                61.371053,
                29.320309
              ],
              [
                61.371103,
                29.320284
              ],
              [
                61.371324,
                29.320412
              ],
              [
                61.371451,
                29.320406
              ],
              [
                61.371572,
                29.32047
              ],
              [
                61.371711,
                29.320652
              ],
              [
                61.372156,
                29.321058
              ],
              [
                61.371989,
                29.321236
              ],
              [
                61.372079,
                29.321318
              ],
              [
                61.371653,
                29.32185
              ],
              [
                61.371661,
                29.321907
              ],
              [
                61.371215,
                29.322294
              ],
              [
                61.371206,
                29.322487
              ],
              [
                61.371083,
                29.322743
              ],
              [
                61.370969,
                29.322783
              ],
              [
                61.370729,
                29.32298
              ],
              [
                61.370299,
                29.32319
              ],
              [
                61.37018,
                29.323441
              ],
              [
                61.370186,
                29.323489
              ],
              [
                61.370369,
                29.323611
              ],
              [
                61.370463,
                29.323906
              ],
              [
                61.370567,
                29.324024
              ],
              [
                61.370167,
                29.324581
              ],
              [
                61.370237,
                29.324721
              ],
              [
                61.369999,
                29.325022
              ],
              [
                61.370037,
                29.325076
              ],
              [
                61.369948,
                29.325194
              ],
              [
                61.370116,
                29.325263
              ],
              [
                61.370179,
                29.325363
              ],
              [
                61.370367,
                29.325436
              ],
              [
                61.370424,
                29.325625
              ],
              [
                61.370659,
                29.325767
              ],
              [
                61.370748,
                29.325925
              ],
              [
                61.37047,
                29.326213
              ],
              [
                61.370229,
                29.326559
              ],
              [
                61.370355,
                29.326742
              ],
              [
                61.370537,
                29.326884
              ],
              [
                61.370638,
                29.327175
              ],
              [
                61.370279,
                29.327703
              ],
              [
                61.370313,
                29.327787
              ],
              [
                61.369946,
                29.328029
              ],
              [
                61.369809,
                29.328075
              ],
              [
                61.369737,
                29.328518
              ],
              [
                61.369783,
                29.328675
              ],
              [
                61.369592,
                29.328823
              ],
              [
                61.369417,
                29.329058
              ],
              [
                61.369411,
                29.329291
              ],
              [
                61.369506,
                29.329566
              ],
              [
                61.369622,
                29.329714
              ],
              [
                61.369737,
                29.329728
              ],
              [
                61.369705,
                29.329793
              ],
              [
                61.3698,
                29.329874
              ],
              [
                61.36959,
                29.330123
              ],
              [
                61.369627,
                29.330141
              ],
              [
                61.369645,
                29.330367
              ],
              [
                61.369453,
                29.330728
              ],
              [
                61.369414,
                29.330917
              ],
              [
                61.369522,
                29.331223
              ],
              [
                61.369479,
                29.331613
              ],
              [
                61.369386,
                29.331869
              ],
              [
                61.369434,
                29.331952
              ],
              [
                61.369663,
                29.332063
              ],
              [
                61.370036,
                29.332478
              ],
              [
                61.370074,
                29.332774
              ],
              [
                61.370011,
                29.3333
              ],
              [
                61.369907,
                29.333521
              ],
              [
                61.369758,
                29.333656
              ],
              [
                61.369873,
                29.33376
              ],
              [
                61.370096,
                29.333677
              ],
              [
                61.370274,
                29.333742
              ],
              [
                61.370293,
                29.334041
              ],
              [
                61.369986,
                29.33422
              ],
              [
                61.369864,
                29.334364
              ],
              [
                61.369905,
                29.334764
              ],
              [
                61.370264,
                29.334768
              ],
              [
                61.370566,
                29.334971
              ],
              [
                61.370668,
                29.335092
              ],
              [
                61.370666,
                29.3352
              ],
              [
                61.370797,
                29.335404
              ],
              [
                61.370797,
                29.335567
              ],
              [
                61.370892,
                29.335681
              ],
              [
                61.370743,
                29.335901
              ],
              [
                61.371005,
                29.336546
              ],
              [
                61.371183,
                29.336403
              ],
              [
                61.371559,
                29.336304
              ],
              [
                61.371748,
                29.336195
              ],
              [
                61.371845,
                29.33624
              ],
              [
                61.371871,
                29.336335
              ],
              [
                61.372177,
                29.336526
              ],
              [
                61.372059,
                29.33665
              ],
              [
                61.372111,
                29.336879
              ],
              [
                61.37184,
                29.337111
              ],
              [
                61.371678,
                29.337354
              ],
              [
                61.37137,
                29.337667
              ],
              [
                61.371604,
                29.337882
              ],
              [
                61.371892,
                29.337967
              ],
              [
                61.371968,
                29.338074
              ],
              [
                61.372324,
                29.338113
              ],
              [
                61.372411,
                29.338336
              ],
              [
                61.372551,
                29.338413
              ],
              [
                61.372526,
                29.338452
              ],
              [
                61.372727,
                29.338609
              ],
              [
                61.373051,
                29.339275
              ],
              [
                61.372796,
                29.339472
              ],
              [
                61.37264,
                29.339532
              ],
              [
                61.372313,
                29.339881
              ],
              [
                61.372195,
                29.339902
              ],
              [
                61.371966,
                29.340669
              ],
              [
                61.371836,
                29.340765
              ],
              [
                61.371948,
                29.340998
              ],
              [
                61.371881,
                29.341033
              ],
              [
                61.371849,
                29.341157
              ],
              [
                61.371767,
                29.341143
              ],
              [
                61.371698,
                29.341194
              ],
              [
                61.371618,
                29.341337
              ],
              [
                61.371409,
                29.341386
              ],
              [
                61.371342,
                29.341526
              ],
              [
                61.371235,
                29.341569
              ],
              [
                61.371089,
                29.341752
              ],
              [
                61.370969,
                29.341774
              ],
              [
                61.370883,
                29.341869
              ],
              [
                61.370878,
                29.342186
              ],
              [
                61.370691,
                29.342364
              ],
              [
                61.370775,
                29.342468
              ],
              [
                61.370669,
                29.342525
              ],
              [
                61.370665,
                29.34258
              ],
              [
                61.37055,
                29.342623
              ],
              [
                61.370567,
                29.342729
              ],
              [
                61.370387,
                29.342841
              ],
              [
                61.370374,
                29.342914
              ],
              [
                61.370022,
                29.34316
              ],
              [
                61.370001,
                29.343269
              ],
              [
                61.369798,
                29.343552
              ],
              [
                61.369767,
                29.343727
              ],
              [
                61.36971,
                29.343689
              ],
              [
                61.369592,
                29.343884
              ],
              [
                61.369417,
                29.344036
              ],
              [
                61.369466,
                29.344124
              ],
              [
                61.369399,
                29.344079
              ],
              [
                61.369323,
                29.344135
              ],
              [
                61.369235,
                29.344268
              ],
              [
                61.369055,
                29.344357
              ],
              [
                61.368804,
                29.344637
              ],
              [
                61.368877,
                29.344918
              ],
              [
                61.368814,
                29.34497
              ],
              [
                61.3688,
                29.345119
              ],
              [
                61.368771,
                29.345093
              ],
              [
                61.368705,
                29.345131
              ],
              [
                61.368558,
                29.345265
              ],
              [
                61.368461,
                29.345465
              ],
              [
                61.368474,
                29.345531
              ],
              [
                61.368367,
                29.345526
              ],
              [
                61.368274,
                29.345652
              ],
              [
                61.368165,
                29.345874
              ],
              [
                61.36816,
                29.345992
              ],
              [
                61.367985,
                29.346056
              ],
              [
                61.367761,
                29.346262
              ],
              [
                61.367544,
                29.346638
              ],
              [
                61.367509,
                29.346933
              ],
              [
                61.367296,
                29.346932
              ],
              [
                61.367161,
                29.347208
              ],
              [
                61.367077,
                29.347229
              ],
              [
                61.367051,
                29.347376
              ],
              [
                61.366813,
                29.347502
              ],
              [
                61.366747,
                29.347857
              ],
              [
                61.366413,
                29.347977
              ],
              [
                61.366043,
                29.348369
              ],
              [
                61.366018,
                29.348472
              ],
              [
                61.365905,
                29.348421
              ],
              [
                61.36579,
                29.348874
              ],
              [
                61.365687,
                29.348889
              ],
              [
                61.365434,
                29.349042
              ],
              [
                61.365435,
                29.349257
              ],
              [
                61.365243,
                29.349432
              ],
              [
                61.365286,
                29.349546
              ],
              [
                61.365031,
                29.349807
              ],
              [
                61.364765,
                29.349889
              ],
              [
                61.364786,
                29.350066
              ],
              [
                61.36494,
                29.350451
              ],
              [
                61.365252,
                29.350472
              ],
              [
                61.365443,
                29.350615
              ],
              [
                61.365374,
                29.35079
              ],
              [
                61.36447,
                29.351889
              ],
              [
                61.364443,
                29.351988
              ],
              [
                61.364507,
                29.352068
              ],
              [
                61.364507,
                29.352161
              ],
              [
                61.364106,
                29.352607
              ],
              [
                61.364293,
                29.352991
              ],
              [
                61.364542,
                29.352907
              ],
              [
                61.364647,
                29.353018
              ],
              [
                61.364563,
                29.353157
              ],
              [
                61.364559,
                29.35328
              ],
              [
                61.364369,
                29.353396
              ],
              [
                61.364298,
                29.353498
              ],
              [
                61.364296,
                29.353802
              ],
              [
                61.364362,
                29.353982
              ],
              [
                61.364647,
                29.35404
              ],
              [
                61.364613,
                29.354375
              ],
              [
                61.364921,
                29.354495
              ],
              [
                61.364981,
                29.354577
              ],
              [
                61.364901,
                29.354792
              ],
              [
                61.364737,
                29.35504
              ],
              [
                61.364287,
                29.355403
              ],
              [
                61.364237,
                29.35552
              ],
              [
                61.364261,
                29.355711
              ],
              [
                61.363774,
                29.356013
              ],
              [
                61.363259,
                29.356703
              ],
              [
                61.362841,
                29.356874
              ],
              [
                61.362104,
                29.358037
              ],
              [
                61.361877,
                29.35821
              ],
              [
                61.361787,
                29.358394
              ],
              [
                61.361671,
                29.358515
              ],
              [
                61.361473,
                29.358622
              ],
              [
                61.361256,
                29.358881
              ],
              [
                61.361023,
                29.358937
              ],
              [
                61.36189,
                29.359332
              ],
              [
                61.361996,
                29.359399
              ],
              [
                61.362113,
                29.35961
              ],
              [
                61.362408,
                29.359395
              ],
              [
                61.362674,
                29.359616
              ],
              [
                61.362821,
                29.3599
              ],
              [
                61.363221,
                29.359938
              ],
              [
                61.36329,
                29.359807
              ],
              [
                61.363593,
                29.359669
              ],
              [
                61.363783,
                29.35967
              ],
              [
                61.36415,
                29.359196
              ],
              [
                61.364407,
                29.359008
              ],
              [
                61.364535,
                29.358846
              ],
              [
                61.365183,
                29.359167
              ],
              [
                61.365237,
                29.359391
              ],
              [
                61.36519,
                29.359567
              ],
              [
                61.365567,
                29.360157
              ],
              [
                61.365988,
                29.360191
              ],
              [
                61.366127,
                29.360672
              ],
              [
                61.366672,
                29.361312
              ],
              [
                61.367054,
                29.361667
              ],
              [
                61.367087,
                29.361802
              ],
              [
                61.366945,
                29.36184
              ],
              [
                61.366915,
                29.361948
              ],
              [
                61.366744,
                29.362051
              ],
              [
                61.366542,
                29.362301
              ],
              [
                61.366132,
                29.362251
              ],
              [
                61.366066,
                29.362323
              ],
              [
                61.365993,
                29.362557
              ],
              [
                61.365874,
                29.362688
              ],
              [
                61.365557,
                29.36281
              ],
              [
                61.365417,
                29.36295
              ],
              [
                61.36522,
                29.363014
              ],
              [
                61.36516,
                29.363089
              ],
              [
                61.364756,
                29.36313
              ],
              [
                61.364505,
                29.363317
              ],
              [
                61.364268,
                29.363423
              ],
              [
                61.364189,
                29.363561
              ],
              [
                61.364299,
                29.363764
              ],
              [
                61.364224,
                29.364101
              ],
              [
                61.364277,
                29.364321
              ],
              [
                61.364377,
                29.364389
              ],
              [
                61.364466,
                29.36464
              ],
              [
                61.364389,
                29.364602
              ],
              [
                61.364177,
                29.364717
              ],
              [
                61.363927,
                29.365026
              ],
              [
                61.3639,
                29.36531
              ],
              [
                61.36357,
                29.365586
              ],
              [
                61.363512,
                29.365695
              ],
              [
                61.363579,
                29.366064
              ],
              [
                61.363415,
                29.366243
              ],
              [
                61.363321,
                29.366247
              ],
              [
                61.3633,
                29.366368
              ],
              [
                61.362927,
                29.366633
              ],
              [
                61.36284,
                29.366802
              ],
              [
                61.362755,
                29.366868
              ],
              [
                61.362746,
                29.366972
              ],
              [
                61.362612,
                29.36716
              ],
              [
                61.362647,
                29.367374
              ],
              [
                61.362503,
                29.367378
              ],
              [
                61.362371,
                29.367668
              ],
              [
                61.361823,
                29.367968
              ],
              [
                61.361796,
                29.36811
              ],
              [
                61.361707,
                29.368113
              ],
              [
                61.36156,
                29.368411
              ],
              [
                61.361282,
                29.36853
              ],
              [
                61.361214,
                29.368621
              ],
              [
                61.36122,
                29.368738
              ],
              [
                61.361089,
                29.368866
              ],
              [
                61.361159,
                29.369366
              ],
              [
                61.361259,
                29.369596
              ],
              [
                61.361348,
                29.369641
              ],
              [
                61.36146,
                29.369829
              ],
              [
                61.361604,
                29.370403
              ],
              [
                61.361873,
                29.370936
              ],
              [
                61.361693,
                29.371167
              ],
              [
                61.361767,
                29.371287
              ],
              [
                61.361632,
                29.371668
              ],
              [
                61.36168,
                29.371913
              ],
              [
                61.361532,
                29.372402
              ],
              [
                61.361157,
                29.37291
              ],
              [
                61.361213,
                29.373026
              ],
              [
                61.361155,
                29.373064
              ],
              [
                61.361179,
                29.37314
              ],
              [
                61.361051,
                29.373166
              ],
              [
                61.360862,
                29.373088
              ],
              [
                61.360636,
                29.373067
              ],
              [
                61.360338,
                29.373155
              ],
              [
                61.360203,
                29.373153
              ],
              [
                61.360127,
                29.373219
              ],
              [
                61.36014,
                29.373667
              ],
              [
                61.360228,
                29.373803
              ],
              [
                61.360111,
                29.373978
              ],
              [
                61.35987,
                29.374183
              ],
              [
                61.359846,
                29.37426
              ],
              [
                61.359665,
                29.374331
              ],
              [
                61.359548,
                29.374484
              ],
              [
                61.359594,
                29.374929
              ],
              [
                61.359376,
                29.375369
              ],
              [
                61.359075,
                29.375607
              ],
              [
                61.359073,
                29.375725
              ],
              [
                61.35897,
                29.375784
              ],
              [
                61.358985,
                29.375847
              ],
              [
                61.359056,
                29.375831
              ],
              [
                61.359171,
                29.375947
              ],
              [
                61.359326,
                29.376242
              ],
              [
                61.359438,
                29.37622
              ],
              [
                61.359518,
                29.376343
              ],
              [
                61.359621,
                29.376364
              ],
              [
                61.35982,
                29.376716
              ],
              [
                61.359999,
                29.376915
              ],
              [
                61.359979,
                29.377049
              ],
              [
                61.359871,
                29.377227
              ],
              [
                61.359978,
                29.377484
              ],
              [
                61.359875,
                29.377549
              ],
              [
                61.359882,
                29.37767
              ],
              [
                61.359927,
                29.377974
              ],
              [
                61.360069,
                29.378134
              ],
              [
                61.360123,
                29.378458
              ],
              [
                61.359646,
                29.37866
              ],
              [
                61.359506,
                29.378825
              ],
              [
                61.359225,
                29.379006
              ],
              [
                61.359165,
                29.379113
              ],
              [
                61.358922,
                29.379081
              ],
              [
                61.358691,
                29.379271
              ],
              [
                61.358594,
                29.379214
              ],
              [
                61.358488,
                29.379287
              ],
              [
                61.358395,
                29.379261
              ],
              [
                61.358241,
                29.379292
              ],
              [
                61.357957,
                29.37946
              ],
              [
                61.357733,
                29.37939
              ],
              [
                61.357478,
                29.379433
              ],
              [
                61.357309,
                29.379569
              ],
              [
                61.357247,
                29.379692
              ],
              [
                61.357005,
                29.379701
              ],
              [
                61.356854,
                29.379885
              ],
              [
                61.356593,
                29.379985
              ],
              [
                61.356502,
                29.380096
              ],
              [
                61.356145,
                29.380192
              ],
              [
                61.356051,
                29.380299
              ],
              [
                61.355923,
                29.380652
              ],
              [
                61.355758,
                29.380846
              ],
              [
                61.355774,
                29.381087
              ],
              [
                61.355848,
                29.381212
              ],
              [
                61.355772,
                29.381244
              ],
              [
                61.355768,
                29.381343
              ],
              [
                61.355662,
                29.381459
              ],
              [
                61.355419,
                29.381471
              ],
              [
                61.355061,
                29.381703
              ],
              [
                61.355014,
                29.381879
              ],
              [
                61.355062,
                29.382055
              ],
              [
                61.354965,
                29.38228
              ],
              [
                61.355039,
                29.382297
              ],
              [
                61.35504,
                29.382431
              ],
              [
                61.354813,
                29.382716
              ],
              [
                61.354796,
                29.383306
              ],
              [
                61.354677,
                29.383349
              ],
              [
                61.354581,
                29.383532
              ],
              [
                61.354121,
                29.384034
              ],
              [
                61.354162,
                29.384065
              ],
              [
                61.354152,
                29.384256
              ],
              [
                61.354094,
                29.38433
              ],
              [
                61.354085,
                29.384489
              ],
              [
                61.354161,
                29.384594
              ],
              [
                61.354017,
                29.384671
              ],
              [
                61.353975,
                29.384763
              ],
              [
                61.353691,
                29.384836
              ],
              [
                61.353487,
                29.385072
              ],
              [
                61.353244,
                29.385177
              ],
              [
                61.353224,
                29.38545
              ],
              [
                61.353132,
                29.38551
              ],
              [
                61.352934,
                29.38593
              ],
              [
                61.352766,
                29.386044
              ],
              [
                61.352744,
                29.386154
              ],
              [
                61.35251,
                29.386247
              ],
              [
                61.352083,
                29.386669
              ],
              [
                61.351981,
                29.386665
              ],
              [
                61.351755,
                29.386807
              ],
              [
                61.351651,
                29.386999
              ],
              [
                61.351539,
                29.387036
              ],
              [
                61.351357,
                29.387197
              ],
              [
                61.351234,
                29.387229
              ],
              [
                61.351035,
                29.38754
              ],
              [
                61.350918,
                29.387546
              ],
              [
                61.350765,
                29.38764
              ],
              [
                61.3504,
                29.388255
              ],
              [
                61.350286,
                29.388118
              ],
              [
                61.350278,
                29.387956
              ],
              [
                61.349814,
                29.387901
              ],
              [
                61.349609,
                29.387815
              ],
              [
                61.349266,
                29.387864
              ],
              [
                61.348628,
                29.387677
              ],
              [
                61.348275,
                29.387684
              ],
              [
                61.348033,
                29.387517
              ],
              [
                61.347955,
                29.387028
              ],
              [
                61.347901,
                29.38697
              ],
              [
                61.348134,
                29.386601
              ],
              [
                61.348194,
                29.386548
              ],
              [
                61.348322,
                29.386581
              ],
              [
                61.348477,
                29.386448
              ],
              [
                61.348319,
                29.386196
              ],
              [
                61.348347,
                29.385686
              ],
              [
                61.348603,
                29.385486
              ],
              [
                61.349057,
                29.385533
              ],
              [
                61.349053,
                29.385377
              ],
              [
                61.349246,
                29.385148
              ],
              [
                61.349116,
                29.385059
              ],
              [
                61.349125,
                29.385016
              ],
              [
                61.35024,
                29.3842
              ],
              [
                61.350359,
                29.384071
              ],
              [
                61.350371,
                29.383932
              ],
              [
                61.350605,
                29.383812
              ],
              [
                61.350632,
                29.38368
              ],
              [
                61.350724,
                29.383576
              ],
              [
                61.350911,
                29.383458
              ],
              [
                61.351147,
                29.383211
              ],
              [
                61.351157,
                29.383133
              ],
              [
                61.35096,
                29.382989
              ],
              [
                61.3506,
                29.383109
              ],
              [
                61.35019,
                29.3823
              ],
              [
                61.350164,
                29.381924
              ],
              [
                61.349957,
                29.381679
              ],
              [
                61.349654,
                29.381666
              ],
              [
                61.349568,
                29.381622
              ],
              [
                61.349405,
                29.381419
              ],
              [
                61.349062,
                29.381436
              ],
              [
                61.348482,
                29.381695
              ],
              [
                61.348301,
                29.381656
              ],
              [
                61.34819,
                29.381692
              ],
              [
                61.348171,
                29.381787
              ],
              [
                61.34796,
                29.381735
              ],
              [
                61.347072,
                29.381926
              ],
              [
                61.346601,
                29.381839
              ],
              [
                61.346193,
                29.381969
              ],
              [
                61.346134,
                29.382034
              ],
              [
                61.346169,
                29.382321
              ],
              [
                61.346031,
                29.382446
              ],
              [
                61.346017,
                29.382535
              ],
              [
                61.345926,
                29.382589
              ],
              [
                61.345385,
                29.382687
              ],
              [
                61.345116,
                29.382581
              ],
              [
                61.344991,
                29.382608
              ],
              [
                61.344873,
                29.382524
              ],
              [
                61.344839,
                29.382485
              ],
              [
                61.344867,
                29.382286
              ],
              [
                61.344736,
                29.381977
              ],
              [
                61.344648,
                29.381877
              ],
              [
                61.344545,
                29.381858
              ],
              [
                61.344255,
                29.38207
              ],
              [
                61.344036,
                29.382111
              ],
              [
                61.343794,
                29.382083
              ],
              [
                61.343613,
                29.382166
              ],
              [
                61.343362,
                29.382484
              ],
              [
                61.343428,
                29.382699
              ],
              [
                61.343254,
                29.382975
              ],
              [
                61.343214,
                29.383519
              ],
              [
                61.343112,
                29.383661
              ],
              [
                61.342913,
                29.383811
              ],
              [
                61.342492,
                29.383816
              ],
              [
                61.342284,
                29.383904
              ],
              [
                61.342134,
                29.384198
              ],
              [
                61.342037,
                29.384281
              ],
              [
                61.341774,
                29.384272
              ],
              [
                61.341761,
                29.384179
              ],
              [
                61.341531,
                29.384039
              ],
              [
                61.341584,
                29.383887
              ],
              [
                61.341555,
                29.383834
              ],
              [
                61.340612,
                29.383239
              ],
              [
                61.340597,
                29.383061
              ],
              [
                61.340472,
                29.382939
              ],
              [
                61.340009,
                29.382664
              ],
              [
                61.339546,
                29.382457
              ],
              [
                61.339433,
                29.382201
              ],
              [
                61.339514,
                29.381999
              ],
              [
                61.339949,
                29.381556
              ],
              [
                61.339905,
                29.381374
              ],
              [
                61.339733,
                29.381237
              ],
              [
                61.338991,
                29.380875
              ],
              [
                61.338514,
                29.380496
              ],
              [
                61.337617,
                29.379999
              ],
              [
                61.336651,
                29.379633
              ],
              [
                61.334966,
                29.379508
              ],
              [
                61.334094,
                29.379554
              ],
              [
                61.333649,
                29.379991
              ],
              [
                61.333124,
                29.380317
              ],
              [
                61.332904,
                29.380681
              ],
              [
                61.332589,
                29.380946
              ],
              [
                61.332039,
                29.381825
              ],
              [
                61.331541,
                29.382231
              ],
              [
                61.331018,
                29.382812
              ],
              [
                61.330437,
                29.383346
              ],
              [
                61.329864,
                29.383787
              ],
              [
                61.329342,
                29.384277
              ],
              [
                61.327044,
                29.386193
              ],
              [
                61.325699,
                29.386741
              ],
              [
                61.324618,
                29.387531
              ],
              [
                61.323683,
                29.388129
              ],
              [
                61.323372,
                29.38823
              ],
              [
                61.322657,
                29.388338
              ],
              [
                61.322278,
                29.38845
              ],
              [
                61.3217201,
                29.3888221
              ],
              [
                61.321114,
                29.3882669
              ],
              [
                61.2615384,
                29.4036646
              ],
              [
                61.237109,
                29.3914848
              ],
              [
                61.2279434,
                29.3864063
              ],
              [
                61.2117064,
                29.3774138
              ],
              [
                61.1897074,
                29.3581751
              ],
              [
                61.179757,
                29.3495115
              ],
              [
                61.1436679,
                29.3179048
              ],
              [
                61.1269536,
                29.2871745
              ],
              [
                61.1058802,
                29.248028
              ],
              [
                61.1088158,
                29.1972425
              ],
              [
                61.1118405,
                29.1538845
              ],
              [
                61.1124951,
                29.1527668
              ],
              [
                61.1014753,
                29.1372019
              ],
              [
                61.0493103,
                29.1360415
              ],
              [
                60.9784925,
                29.134184
              ],
              [
                60.9351651,
                29.1582869
              ],
              [
                60.9012142,
                29.1645958
              ],
              [
                60.8602097,
                29.1784659
              ],
              [
                60.8474254,
                29.1751317
              ],
              [
                60.8334302,
                29.1509454
              ],
              [
                60.83582,
                29.139699
              ],
              [
                60.8266627,
                29.1123614
              ],
              [
                60.8211707,
                29.0909021
              ],
              [
                60.8157612,
                29.0742473
              ],
              [
                60.8082195,
                29.0588914
              ],
              [
                60.7950846,
                29.049858
              ],
              [
                60.7755867,
                29.041765
              ],
              [
                60.7560894,
                29.0334614
              ],
              [
                60.7369816,
                29.0284211
              ],
              [
                60.7074553,
                29.020101
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555246,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نیک شهر",
          "name:en": "Nikshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292877",
          "wikipedia": "en:Nik Shahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.7971223,
                26.4449954
              ],
              [
                58.7971288,
                26.4449823
              ],
              [
                58.7974023,
                26.4444295
              ],
              [
                58.8807599,
                26.3542345
              ],
              [
                58.8712689,
                26.3269608
              ],
              [
                58.8527295,
                26.3091121
              ],
              [
                58.8238903,
                26.2823339
              ],
              [
                58.8173672,
                26.2429249
              ],
              [
                58.8523861,
                26.2318386
              ],
              [
                58.9380595,
                26.2292993
              ],
              [
                58.9377861,
                26.2279077
              ],
              [
                58.9377861,
                26.2270727
              ],
              [
                59.0092034,
                26.2080916
              ],
              [
                59.0098777,
                26.2075154
              ],
              [
                59.0101578,
                26.2072463
              ],
              [
                59.0104378,
                26.2064117
              ],
              [
                59.0134911,
                26.2025171
              ],
              [
                59.0212708,
                26.195024
              ],
              [
                59.0209907,
                26.1925205
              ],
              [
                59.0207177,
                26.1905732
              ],
              [
                59.0204376,
                26.190304
              ],
              [
                59.0158078,
                26.167148
              ],
              [
                59.0228238,
                26.1507603
              ],
              [
                59.0225504,
                26.1488218
              ],
              [
                59.0239371,
                26.141041
              ],
              [
                59.0244902,
                26.1402065
              ],
              [
                59.0140911,
                26.1249258
              ],
              [
                59.0079113,
                26.1033464
              ],
              [
                59.0158078,
                26.0953302
              ],
              [
                59.0120312,
                26.0882385
              ],
              [
                58.9996716,
                26.08423
              ],
              [
                58.9928685,
                26.076231
              ],
              [
                58.9967549,
                26.06984
              ],
              [
                58.9970349,
                26.0690051
              ],
              [
                59.0171417,
                26.0614667
              ],
              [
                59.0761548,
                25.9905973
              ],
              [
                59.0865786,
                25.9857487
              ],
              [
                59.0947658,
                25.9843437
              ],
              [
                59.1073601,
                25.9818747
              ],
              [
                59.1337748,
                25.9773881
              ],
              [
                59.1456699,
                25.9771818
              ],
              [
                59.150648,
                25.9762558
              ],
              [
                59.1647243,
                25.976796
              ],
              [
                59.171934,
                25.9769503
              ],
              [
                59.1815471,
                25.977799
              ],
              [
                59.1915464,
                25.9797279
              ],
              [
                59.1992611,
                25.9797244
              ],
              [
                59.2192495,
                25.9789157
              ],
              [
                59.2295576,
                25.9781279
              ],
              [
                59.2388178,
                25.9796155
              ],
              [
                59.2527308,
                25.9828487
              ],
              [
                59.2576812,
                25.9823656
              ],
              [
                59.2618397,
                25.9806987
              ],
              [
                59.2718002,
                25.9799414
              ],
              [
                59.2870416,
                25.9788126
              ],
              [
                59.3066607,
                25.9766825
              ],
              [
                59.3320801,
                25.9741972
              ],
              [
                59.3673832,
                25.9716115
              ],
              [
                59.397878,
                25.9672707
              ],
              [
                59.4734573,
                25.9570415
              ],
              [
                59.5020524,
                25.9585892
              ],
              [
                59.5082985,
                25.958282
              ],
              [
                59.5168995,
                25.9558977
              ],
              [
                59.5293557,
                25.9525793
              ],
              [
                59.5418394,
                25.9493846
              ],
              [
                59.546585,
                25.945851
              ],
              [
                59.5541884,
                25.9429127
              ],
              [
                59.5713042,
                25.9345822
              ],
              [
                59.5847797,
                25.9264773
              ],
              [
                59.5950751,
                25.9232684
              ],
              [
                59.6060113,
                25.9210554
              ],
              [
                59.6171219,
                25.9193771
              ],
              [
                59.6198843,
                25.9162104
              ],
              [
                59.6225556,
                25.9063032
              ],
              [
                59.6238325,
                25.8995342
              ],
              [
                59.6274374,
                25.8945927
              ],
              [
                59.6325459,
                25.8917923
              ],
              [
                59.6406553,
                25.8919674
              ],
              [
                59.6511267,
                25.8932028
              ],
              [
                59.6591948,
                25.8910408
              ],
              [
                59.6674345,
                25.8879521
              ],
              [
                59.6736143,
                25.8828557
              ],
              [
                59.6801375,
                25.8697274
              ],
              [
                59.6746443,
                25.8409945
              ],
              [
                59.6803091,
                25.8320334
              ],
              [
                59.696102,
                25.8244623
              ],
              [
                59.7168725,
                25.8032919
              ],
              [
                59.7252844,
                25.783817
              ],
              [
                59.7357557,
                25.7705232
              ],
              [
                59.7424505,
                25.7644941
              ],
              [
                59.7524069,
                25.7590831
              ],
              [
                59.7666548,
                25.7685135
              ],
              [
                59.7774695,
                25.7709869
              ],
              [
                59.7901724,
                25.7729966
              ],
              [
                59.8007726,
                25.7694729
              ],
              [
                59.8133467,
                25.7658854
              ],
              [
                59.825363,
                25.7646487
              ],
              [
                59.8464773,
                25.766813
              ],
              [
                59.868965,
                25.7644941
              ],
              [
                59.8835562,
                25.7641849
              ],
              [
                59.8940275,
                25.7600107
              ],
              [
                59.9177168,
                25.7595469
              ],
              [
                59.9299048,
                25.7657308
              ],
              [
                59.9395178,
                25.7651125
              ],
              [
                59.9518774,
                25.7666584
              ],
              [
                59.9637221,
                25.7649579
              ],
              [
                59.9717897,
                25.7637215
              ],
              [
                59.9850081,
                25.7563002
              ],
              [
                59.9989126,
                25.7541357
              ],
              [
                60.0092123,
                25.7533626
              ],
              [
                60.0335882,
                25.7413024
              ],
              [
                60.0473211,
                25.7380552
              ],
              [
                60.0598524,
                25.7278491
              ],
              [
                60.0844,
                25.7157863
              ],
              [
                60.0981324,
                25.7119202
              ],
              [
                60.1151274,
                25.7111464
              ],
              [
                60.13916,
                25.7119197
              ],
              [
                60.171089,
                25.7157863
              ],
              [
                60.1866828,
                25.7190044
              ],
              [
                60.2023315,
                25.725684
              ],
              [
                60.2110004,
                25.7301687
              ],
              [
                60.2208709,
                25.7388283
              ],
              [
                60.2247333,
                25.7443175
              ],
              [
                60.2260207,
                25.7480284
              ],
              [
                60.2311706,
                25.7566866
              ],
              [
                60.2368354,
                25.7623296
              ],
              [
                60.2406676,
                25.7634453
              ],
              [
                60.2458476,
                25.7624842
              ],
              [
                60.2508258,
                25.7631799
              ],
              [
                60.2951144,
                25.7492653
              ],
              [
                60.2979468,
                25.744936
              ],
              [
                60.3033542,
                25.7430805
              ],
              [
                60.3135674,
                25.7451685
              ],
              [
                60.3585433,
                25.7451679
              ],
              [
                60.4287522,
                25.7476423
              ],
              [
                60.4577636,
                25.7448587
              ],
              [
                60.4840278,
                25.7440082
              ],
              [
                60.4921817,
                25.7429259
              ],
              [
                60.4964732,
                25.7436217
              ],
              [
                60.5003356,
                25.7455545
              ],
              [
                60.504198,
                25.7445494
              ],
              [
                60.5132102,
                25.7429259
              ],
              [
                60.5445268,
                25.7382838
              ],
              [
                60.5243676,
                25.8159639
              ],
              [
                60.4618829,
                25.8573705
              ],
              [
                60.3657525,
                25.9086451
              ],
              [
                60.3322755,
                25.9388553
              ],
              [
                60.3167557,
                25.9921027
              ],
              [
                60.335332,
                26.025229
              ],
              [
                60.3319356,
                26.0564234
              ],
              [
                60.3294355,
                26.0630912
              ],
              [
                60.3283222,
                26.0655949
              ],
              [
                60.3280421,
                26.0697589
              ],
              [
                60.3283222,
                26.0708717
              ],
              [
                60.3308223,
                26.0747574
              ],
              [
                60.3324888,
                26.0761484
              ],
              [
                60.3627682,
                26.1000383
              ],
              [
                60.3630483,
                26.100864
              ],
              [
                60.3636019,
                26.1011511
              ],
              [
                60.3652683,
                26.1044807
              ],
              [
                60.363931,
                26.1225341
              ],
              [
                60.364294,
                26.1283933
              ],
              [
                60.3610258,
                26.1380775
              ],
              [
                60.3615474,
                26.1424173
              ],
              [
                60.3636932,
                26.1461156
              ],
              [
                60.3710746,
                26.1525104
              ],
              [
                60.3814601,
                26.1594441
              ],
              [
                60.3920965,
                26.1650626
              ],
              [
                60.4049331,
                26.1702697
              ],
              [
                60.4133278,
                26.1817045
              ],
              [
                60.44122,
                26.2404796
              ],
              [
                60.4615711,
                26.2808091
              ],
              [
                60.447286,
                26.3132143
              ],
              [
                60.4474945,
                26.3242083
              ],
              [
                60.4488808,
                26.3275392
              ],
              [
                60.451941,
                26.3311485
              ],
              [
                60.4522141,
                26.3317052
              ],
              [
                60.454161,
                26.3322619
              ],
              [
                60.4555473,
                26.3328186
              ],
              [
                60.4577743,
                26.3328185
              ],
              [
                60.4580474,
                26.3330969
              ],
              [
                60.4597141,
                26.3330968
              ],
              [
                60.4605473,
                26.3333752
              ],
              [
                60.4619408,
                26.3333752
              ],
              [
                60.4652741,
                26.3342102
              ],
              [
                60.4663874,
                26.3342102
              ],
              [
                60.4755539,
                26.3367062
              ],
              [
                60.4769407,
                26.3367062
              ],
              [
                60.4777739,
                26.3369845
              ],
              [
                60.4791603,
                26.3369846
              ],
              [
                60.4799938,
                26.3372629
              ],
              [
                60.4813873,
                26.3372628
              ],
              [
                60.4822205,
                26.3375411
              ],
              [
                60.4838873,
                26.3375412
              ],
              [
                60.4841603,
                26.3378195
              ],
              [
                60.4855537,
                26.3378195
              ],
              [
                60.4858272,
                26.3380978
              ],
              [
                60.4897202,
                26.3380979
              ],
              [
                60.4899937,
                26.3383762
              ],
              [
                60.5013868,
                26.3383761
              ],
              [
                60.5172198,
                26.3417072
              ],
              [
                60.5183332,
                26.3417072
              ],
              [
                60.528333,
                26.3450382
              ],
              [
                60.5311064,
                26.3461517
              ],
              [
                60.5422195,
                26.3517005
              ],
              [
                60.5433328,
                26.3519878
              ],
              [
                60.5441661,
                26.3525445
              ],
              [
                60.5691657,
                26.3569799
              ],
              [
                60.5697188,
                26.3572583
              ],
              [
                60.5722192,
                26.3572583
              ],
              [
                60.5727786,
                26.3575367
              ],
              [
                60.5752787,
                26.3575366
              ],
              [
                60.5797256,
                26.3580933
              ],
              [
                60.6333972,
                26.3532765
              ],
              [
                60.6389575,
                26.3537571
              ],
              [
                60.6429814,
                26.3549365
              ],
              [
                60.6489212,
                26.3579254
              ],
              [
                60.6533503,
                26.3617269
              ],
              [
                60.6561613,
                26.3655913
              ],
              [
                60.6617183,
                26.3758352
              ],
              [
                60.6686816,
                26.3867497
              ],
              [
                60.6714504,
                26.3927176
              ],
              [
                60.6784772,
                26.4080529
              ],
              [
                60.6796347,
                26.4126717
              ],
              [
                60.6785697,
                26.4186284
              ],
              [
                60.6771717,
                26.423298
              ],
              [
                60.6725471,
                26.4319043
              ],
              [
                60.667007,
                26.4397624
              ],
              [
                60.6620645,
                26.4480399
              ],
              [
                60.657258,
                26.4576117
              ],
              [
                60.6571493,
                26.4598763
              ],
              [
                60.658846,
                26.464544
              ],
              [
                60.6665287,
                26.4795598
              ],
              [
                60.6660138,
                26.4828919
              ],
              [
                60.6646626,
                26.4863968
              ],
              [
                60.6626754,
                26.4894594
              ],
              [
                60.6611987,
                26.4908709
              ],
              [
                60.6584278,
                26.4938383
              ],
              [
                60.6560039,
                26.4964987
              ],
              [
                60.6540457,
                26.4976028
              ],
              [
                60.6532327,
                26.4997831
              ],
              [
                60.6531197,
                26.5018193
              ],
              [
                60.6523696,
                26.5048535
              ],
              [
                60.6525213,
                26.5070818
              ],
              [
                60.6532231,
                26.5101832
              ],
              [
                60.6543433,
                26.5123837
              ],
              [
                60.6557708,
                26.5134685
              ],
              [
                60.6592693,
                26.5151102
              ],
              [
                60.6636954,
                26.5161266
              ],
              [
                60.6670172,
                26.5165107
              ],
              [
                60.6699155,
                26.5155026
              ],
              [
                60.6735387,
                26.5145426
              ],
              [
                60.6765832,
                26.5137168
              ],
              [
                60.6800338,
                26.5129104
              ],
              [
                60.6853821,
                26.5122574
              ],
              [
                60.6896211,
                26.5108646
              ],
              [
                60.6948489,
                26.509021
              ],
              [
                60.6994742,
                26.5076
              ],
              [
                60.7033936,
                26.5065142
              ],
              [
                60.708963,
                26.5049782
              ],
              [
                60.7133464,
                26.504402
              ],
              [
                60.7191327,
                26.5035955
              ],
              [
                60.7254143,
                26.5030482
              ],
              [
                60.7323139,
                26.5025482
              ],
              [
                60.7392367,
                26.5023082
              ],
              [
                60.7447803,
                26.5021641
              ],
              [
                60.7483752,
                26.5017225
              ],
              [
                60.7505344,
                26.5015401
              ],
              [
                60.7523863,
                26.5005985
              ],
              [
                60.7554906,
                26.501375
              ],
              [
                60.7579935,
                26.5019325
              ],
              [
                60.7569296,
                26.503199
              ],
              [
                60.7527208,
                26.5070243
              ],
              [
                60.7502745,
                26.5082917
              ],
              [
                60.7476783,
                26.5102502
              ],
              [
                60.7423138,
                26.513092
              ],
              [
                60.7400178,
                26.5148969
              ],
              [
                60.7381296,
                26.5171241
              ],
              [
                60.7381296,
                26.5199657
              ],
              [
                60.7404899,
                26.5240744
              ],
              [
                60.7438159,
                26.5268583
              ],
              [
                60.7503604,
                26.5297189
              ],
              [
                60.7530641,
                26.53041
              ],
              [
                60.7559609,
                26.5302756
              ],
              [
                60.756948,
                26.5305444
              ],
              [
                60.7594585,
                26.5296804
              ],
              [
                60.7614325,
                26.5294502
              ],
              [
                60.7662606,
                26.5321378
              ],
              [
                60.7680416,
                26.5346335
              ],
              [
                60.7706165,
                26.536534
              ],
              [
                60.7737279,
                26.5383193
              ],
              [
                60.7770324,
                26.5392984
              ],
              [
                60.7798433,
                26.540335
              ],
              [
                60.7832336,
                26.5405846
              ],
              [
                60.7947349,
                26.5523706
              ],
              [
                60.8098323,
                26.557252
              ],
              [
                60.8206557,
                26.5635796
              ],
              [
                60.8274036,
                26.5738147
              ],
              [
                60.8412937,
                26.5891842
              ],
              [
                60.855846,
                26.5966631
              ],
              [
                60.8673475,
                26.6057188
              ],
              [
                60.8743857,
                26.6157716
              ],
              [
                60.875759,
                26.6218334
              ],
              [
                60.8760249,
                26.6345877
              ],
              [
                60.8753521,
                26.6489295
              ],
              [
                60.8726085,
                26.6624236
              ],
              [
                60.8693217,
                26.6731551
              ],
              [
                60.8705209,
                26.6775538
              ],
              [
                60.8728408,
                26.6815914
              ],
              [
                60.8822822,
                26.6848124
              ],
              [
                60.8941268,
                26.6900271
              ],
              [
                60.9001145,
                26.6988479
              ],
              [
                60.8962726,
                26.7043664
              ],
              [
                60.8934865,
                26.7087833
              ],
              [
                60.8885441,
                26.7142316
              ],
              [
                60.8737226,
                26.723682
              ],
              [
                60.8701505,
                26.7269885
              ],
              [
                60.866661,
                26.7325029
              ],
              [
                60.8646917,
                26.7344181
              ],
              [
                60.8609104,
                26.7382903
              ],
              [
                60.8539581,
                26.7424678
              ],
              [
                60.8502747,
                26.7437314
              ],
              [
                60.8438941,
                26.7518927
              ],
              [
                60.8412995,
                26.7586372
              ],
              [
                60.8206612,
                26.7819051
              ],
              [
                60.8051733,
                26.7944953
              ],
              [
                60.7949443,
                26.8030001
              ],
              [
                60.7506176,
                26.8202412
              ],
              [
                60.7384297,
                26.8364788
              ],
              [
                60.7198391,
                26.8705317
              ],
              [
                60.7098995,
                26.9048107
              ],
              [
                60.68263,
                26.9298577
              ],
              [
                60.6507009,
                26.9555388
              ],
              [
                60.6318281,
                26.962776
              ],
              [
                60.6071089,
                26.9676719
              ],
              [
                60.593376,
                26.9448733
              ],
              [
                60.5849646,
                26.9350792
              ],
              [
                60.5741487,
                26.9260506
              ],
              [
                60.5597298,
                26.9190094
              ],
              [
                60.5408642,
                26.9182323
              ],
              [
                60.5094117,
                26.9196989
              ],
              [
                60.4872485,
                26.9304585
              ],
              [
                60.4678926,
                26.9644722
              ],
              [
                60.4652309,
                26.9603278
              ],
              [
                60.4624731,
                26.9406782
              ],
              [
                60.4599434,
                26.9262016
              ],
              [
                60.4592227,
                26.9180904
              ],
              [
                60.4583376,
                26.9059646
              ],
              [
                60.4521352,
                26.9000205
              ],
              [
                60.4492894,
                26.8956598
              ],
              [
                60.4519911,
                26.8897993
              ],
              [
                60.4544642,
                26.8871902
              ],
              [
                60.458564,
                26.8828667
              ],
              [
                60.457261,
                26.8773057
              ],
              [
                60.4564659,
                26.8726544
              ],
              [
                60.4543834,
                26.8680205
              ],
              [
                60.4530574,
                26.8614972
              ],
              [
                60.45205,
                26.8556351
              ],
              [
                60.4510611,
                26.84898
              ],
              [
                60.4497957,
                26.8401398
              ],
              [
                60.4468732,
                26.8293147
              ],
              [
                60.4464869,
                26.822357
              ],
              [
                60.4458002,
                26.8131066
              ],
              [
                60.4466381,
                26.8065157
              ],
              [
                60.4483773,
                26.8022506
              ],
              [
                60.4533687,
                26.7887324
              ],
              [
                60.453222,
                26.7817905
              ],
              [
                60.4451088,
                26.7648021
              ],
              [
                60.4457473,
                26.7623951
              ],
              [
                60.4556178,
                26.7537349
              ],
              [
                60.455532,
                26.7501326
              ],
              [
                60.4509735,
                26.7436579
              ],
              [
                60.4430865,
                26.7428511
              ],
              [
                60.4295253,
                26.7441541
              ],
              [
                60.4213693,
                26.7409329
              ],
              [
                60.4116881,
                26.7355737
              ],
              [
                60.3917263,
                26.7221815
              ],
              [
                60.3848874,
                26.7173275
              ],
              [
                60.3718662,
                26.7049349
              ],
              [
                60.3435619,
                26.6823604
              ],
              [
                60.3318282,
                26.6729453
              ],
              [
                60.3197493,
                26.6647075
              ],
              [
                60.3146183,
                26.6534413
              ],
              [
                60.304563,
                26.6304163
              ],
              [
                60.3031038,
                26.619495
              ],
              [
                60.3014359,
                26.6066359
              ],
              [
                60.3006739,
                26.6020483
              ],
              [
                60.3016205,
                26.5973177
              ],
              [
                60.3038925,
                26.5837951
              ],
              [
                60.3127006,
                26.5633797
              ],
              [
                60.3135229,
                26.5466882
              ],
              [
                60.3126645,
                26.5405546
              ],
              [
                60.3112308,
                26.5300924
              ],
              [
                60.3097232,
                26.5225299
              ],
              [
                60.3054863,
                26.5181423
              ],
              [
                60.3050154,
                26.5176143
              ],
              [
                60.303877,
                26.5155593
              ],
              [
                60.3041356,
                26.5137829
              ],
              [
                60.3050336,
                26.5126494
              ],
              [
                60.3060969,
                26.5122654
              ],
              [
                60.3156869,
                26.5073011
              ],
              [
                60.3201679,
                26.5047856
              ],
              [
                60.321958,
                26.5024349
              ],
              [
                60.3234275,
                26.50008
              ],
              [
                60.3240141,
                26.4979773
              ],
              [
                60.3254708,
                26.4967864
              ],
              [
                60.3297875,
                26.4957113
              ],
              [
                60.3314599,
                26.4944343
              ],
              [
                60.331888,
                26.4932816
              ],
              [
                60.3318106,
                26.4920335
              ],
              [
                60.3306912,
                26.4909774
              ],
              [
                60.3171729,
                26.4897028
              ],
              [
                60.279373,
                26.4908435
              ],
              [
                60.2746867,
                26.4912392
              ],
              [
                60.2578069,
                26.4905842
              ],
              [
                60.2508258,
                26.4910855
              ],
              [
                60.2455901,
                26.4926987
              ],
              [
                60.2426719,
                26.4923146
              ],
              [
                60.2292039,
                26.4936764
              ],
              [
                60.2070846,
                26.4907093
              ],
              [
                60.1760306,
                26.4892014
              ],
              [
                60.1528376,
                26.4892978
              ],
              [
                60.1467913,
                26.4893268
              ],
              [
                60.1259717,
                26.493475
              ],
              [
                60.0904246,
                26.4913141
              ],
              [
                60.0757312,
                26.4926219
              ],
              [
                60.0716496,
                26.4923318
              ],
              [
                60.0579437,
                26.4944539
              ],
              [
                60.0434874,
                26.4958365
              ],
              [
                60.0316471,
                26.4967486
              ],
              [
                60.0292969,
                26.4960402
              ],
              [
                60.026443,
                26.4962514
              ],
              [
                60.024147,
                26.4954257
              ],
              [
                60.020682,
                26.4953839
              ],
              [
                60.0156339,
                26.4943578
              ],
              [
                60.0131539,
                26.4932344
              ],
              [
                60.0035476,
                26.4869373
              ],
              [
                60.000801,
                26.4836339
              ],
              [
                59.9910163,
                26.4718024
              ],
              [
                59.9888705,
                26.4657326
              ],
              [
                59.9904155,
                26.4592782
              ],
              [
                59.9883556,
                26.4552824
              ],
              [
                59.9820899,
                26.4501338
              ],
              [
                59.9769401,
                26.4472137
              ],
              [
                59.9711894,
                26.4469831
              ],
              [
                59.967842,
                26.4487506
              ],
              [
                59.9629497,
                26.4497496
              ],
              [
                59.9553107,
                26.4519781
              ],
              [
                59.9496459,
                26.4542835
              ],
              [
                59.9388835,
                26.4596508
              ],
              [
                59.9300445,
                26.4646746
              ],
              [
                59.9216651,
                26.4751061
              ],
              [
                59.9165153,
                26.4794085
              ],
              [
                59.9105129,
                26.4821246
              ],
              [
                59.9026965,
                26.4860922
              ],
              [
                59.8948001,
                26.4891651
              ],
              [
                59.8901652,
                26.4899333
              ],
              [
                59.8864248,
                26.488387
              ],
              [
                59.7907989,
                26.4797637
              ],
              [
                59.7724658,
                26.4728216
              ],
              [
                59.7719126,
                26.4722649
              ],
              [
                59.7702458,
                26.4717081
              ],
              [
                59.7682993,
                26.470325
              ],
              [
                59.7519127,
                26.4594854
              ],
              [
                59.7413527,
                26.4555968
              ],
              [
                59.7335729,
                26.4508822
              ],
              [
                59.7285732,
                26.4442097
              ],
              [
                59.7291329,
                26.4380942
              ],
              [
                59.7296865,
                26.4369896
              ],
              [
                59.7424664,
                26.4244893
              ],
              [
                59.744966,
                26.4219928
              ],
              [
                59.7596857,
                26.408101
              ],
              [
                59.7644123,
                26.4003156
              ],
              [
                59.7660791,
                26.3958708
              ],
              [
                59.7663522,
                26.393096
              ],
              [
                59.7627459,
                26.383102
              ],
              [
                59.7624658,
                26.3817102
              ],
              [
                59.7619122,
                26.3808752
              ],
              [
                59.7613524,
                26.3808751
              ],
              [
                59.761079,
                26.3811535
              ],
              [
                59.7602459,
                26.3811535
              ],
              [
                59.7569126,
                26.3817102
              ],
              [
                59.7552457,
                26.3817103
              ],
              [
                59.7544125,
                26.3819886
              ],
              [
                59.7127399,
                26.3872685
              ],
              [
                59.7102399,
                26.3872685
              ],
              [
                59.7019066,
                26.3883731
              ],
              [
                59.6902404,
                26.388373
              ],
              [
                59.6896869,
                26.3886514
              ],
              [
                59.6730206,
                26.3886514
              ],
              [
                59.6721874,
                26.3883731
              ],
              [
                59.6666271,
                26.3883731
              ],
              [
                59.6657939,
                26.3886515
              ],
              [
                59.6641274,
                26.3886515
              ],
              [
                59.663574,
                26.3889299
              ],
              [
                59.6594074,
                26.3889299
              ],
              [
                59.6582942,
                26.3892082
              ],
              [
                59.6577406,
                26.3889299
              ],
              [
                59.6546808,
                26.3889299
              ],
              [
                59.6544074,
                26.3886515
              ],
              [
                59.6538476,
                26.3886515
              ],
              [
                59.6535742,
                26.3883731
              ],
              [
                59.6532941,
                26.3881037
              ],
              [
                59.6529441,
                26.3879219
              ],
              [
                59.6471811,
                26.3944882
              ],
              [
                59.6460745,
                26.3961583
              ],
              [
                59.6219014,
                26.4183742
              ],
              [
                59.5977351,
                26.437816
              ],
              [
                59.5763489,
                26.4522654
              ],
              [
                59.5749554,
                26.4528222
              ],
              [
                59.5535692,
                26.4680982
              ],
              [
                59.5341232,
                26.4844883
              ],
              [
                59.5324565,
                26.4858803
              ],
              [
                59.5319033,
                26.4861588
              ],
              [
                59.5316231,
                26.4864372
              ],
              [
                59.5135635,
                26.4994867
              ],
              [
                59.5099569,
                26.5011572
              ],
              [
                59.5049567,
                26.5033756
              ],
              [
                59.5035634,
                26.5042109
              ],
              [
                59.5010638,
                26.5050461
              ],
              [
                59.4921773,
                26.5092134
              ],
              [
                59.4474512,
                26.5269879
              ],
              [
                59.4166183,
                26.5392121
              ],
              [
                59.3724528,
                26.5533767
              ],
              [
                59.3607795,
                26.5561611
              ],
              [
                59.3588397,
                26.5564396
              ],
              [
                59.3491129,
                26.5597721
              ],
              [
                59.3485594,
                26.5600505
              ],
              [
                59.3480063,
                26.5603289
              ],
              [
                59.347173,
                26.5603289
              ],
              [
                59.3124466,
                26.5458769
              ],
              [
                59.263554,
                26.5275451
              ],
              [
                59.2482744,
                26.5250483
              ],
              [
                59.2463346,
                26.5250483
              ],
              [
                59.2393879,
                26.5236562
              ],
              [
                59.2388348,
                26.5236562
              ],
              [
                59.237168,
                26.5233777
              ],
              [
                59.2360548,
                26.5233777
              ],
              [
                59.2357746,
                26.5236562
              ],
              [
                59.2335546,
                26.5236562
              ],
              [
                59.2330015,
                26.5239346
              ],
              [
                59.2296682,
                26.5239346
              ],
              [
                59.2293882,
                26.5236562
              ],
              [
                59.2260549,
                26.5236562
              ],
              [
                59.2255014,
                26.5233778
              ],
              [
                59.2243881,
                26.5233778
              ],
              [
                59.2235549,
                26.5230993
              ],
              [
                59.2146618,
                26.5230994
              ],
              [
                59.2135551,
                26.5233778
              ],
              [
                59.2118883,
                26.5233778
              ],
              [
                59.2110551,
                26.5236562
              ],
              [
                59.2093886,
                26.5236562
              ],
              [
                59.208555,
                26.5239346
              ],
              [
                59.2071616,
                26.5239347
              ],
              [
                59.2063285,
                26.5242131
              ],
              [
                59.2049416,
                26.5242131
              ],
              [
                59.1777155,
                26.5303207
              ],
              [
                59.173549,
                26.5314344
              ],
              [
                59.1716091,
                26.5317128
              ],
              [
                59.1641094,
                26.5339314
              ],
              [
                59.1482763,
                26.5394911
              ],
              [
                59.1441095,
                26.5414401
              ],
              [
                59.1432762,
                26.541988
              ],
              [
                59.1413298,
                26.5425449
              ],
              [
                59.1296632,
                26.5486616
              ],
              [
                59.0996568,
                26.562548
              ],
              [
                59.0882703,
                26.5669942
              ],
              [
                59.0777174,
                26.5694913
              ],
              [
                59.0727173,
                26.5694913
              ],
              [
                59.0685508,
                26.5689345
              ],
              [
                59.0660508,
                26.5689344
              ],
              [
                59.0643773,
                26.568656
              ],
              [
                59.0627109,
                26.568656
              ],
              [
                59.060491,
                26.5680991
              ],
              [
                59.0588242,
                26.5680991
              ],
              [
                59.0518775,
                26.5667158
              ],
              [
                59.0438247,
                26.5642099
              ],
              [
                59.0382715,
                26.5614343
              ],
              [
                59.0377113,
                26.5614343
              ],
              [
                59.0374383,
                26.5611559
              ],
              [
                59.0358609,
                26.5609586
              ],
              [
                59.0352112,
                26.5608774
              ],
              [
                59.0374382,
                26.5506019
              ],
              [
                59.0374382,
                26.5475481
              ],
              [
                59.0354913,
                26.5436589
              ],
              [
                59.0332713,
                26.5411619
              ],
              [
                59.0321581,
                26.5405961
              ],
              [
                59.031878,
                26.5400482
              ],
              [
                59.0277115,
                26.5381081
              ],
              [
                59.0135448,
                26.5342191
              ],
              [
                59.0060451,
                26.5281025
              ],
              [
                59.0063252,
                26.5264319
              ],
              [
                59.0090982,
                26.5233782
              ],
              [
                59.0093783,
                26.5206029
              ],
              [
                59.0090982,
                26.5189323
              ],
              [
                59.0085451,
                26.5178276
              ],
              [
                59.008265,
                26.5175491
              ],
              [
                59.008265,
                26.5172707
              ],
              [
                59.0077118,
                26.5169923
              ],
              [
                59.0071584,
                26.5153218
              ],
              [
                59.0074318,
                26.5150434
              ],
              [
                59.0077119,
                26.5133817
              ],
              [
                59.0077119,
                26.5105975
              ],
              [
                59.0021586,
                26.5014366
              ],
              [
                59.0003551,
                26.5003229
              ],
              [
                58.9996586,
                26.5003229
              ],
              [
                58.9990984,
                26.5000445
              ],
              [
                58.9979918,
                26.5000445
              ],
              [
                58.9955186,
                26.4994936
              ],
              [
                58.9954921,
                26.4994877
              ],
              [
                58.987748,
                26.50124
              ],
              [
                58.9868787,
                26.5014367
              ],
              [
                58.9849321,
                26.5014367
              ],
              [
                58.9835455,
                26.5017151
              ],
              [
                58.9816348,
                26.5017151
              ],
              [
                58.9815989,
                26.5017151
              ],
              [
                58.9715992,
                26.5039335
              ],
              [
                58.9693096,
                26.5048506
              ],
              [
                58.968819,
                26.5050472
              ],
              [
                58.9683987,
                26.5050472
              ],
              [
                58.9679857,
                26.5050472
              ],
              [
                58.9643791,
                26.5064393
              ],
              [
                58.9579856,
                26.5081008
              ],
              [
                58.9560458,
                26.508936
              ],
              [
                58.9411329,
                26.5134641
              ],
              [
                58.9404861,
                26.5136604
              ],
              [
                58.9392367,
                26.5136603
              ],
              [
                58.9390994,
                26.5136603
              ],
              [
                58.937575,
                26.5140415
              ],
              [
                58.9368728,
                26.5142171
              ],
              [
                58.9310395,
                26.514765
              ],
              [
                58.9285188,
                26.514765
              ],
              [
                58.9279863,
                26.514765
              ],
              [
                58.9278229,
                26.5148473
              ],
              [
                58.9274331,
                26.5150435
              ],
              [
                58.9257664,
                26.5150435
              ],
              [
                58.9247541,
                26.5148412
              ],
              [
                58.924373,
                26.5147651
              ],
              [
                58.9242096,
                26.5148473
              ],
              [
                58.9238198,
                26.5150435
              ],
              [
                58.9224331,
                26.5150435
              ],
              [
                58.9207667,
                26.5147651
              ],
              [
                58.9049266,
                26.5128251
              ],
              [
                58.897987,
                26.5086577
              ],
              [
                58.8902068,
                26.5011584
              ],
              [
                58.8793738,
                26.4944855
              ],
              [
                58.8782605,
                26.494216
              ],
              [
                58.8574273,
                26.4850464
              ],
              [
                58.8557608,
                26.4850464
              ],
              [
                58.8552077,
                26.484768
              ],
              [
                58.8065689,
                26.4461005
              ],
              [
                58.8054556,
                26.4461005
              ],
              [
                58.8032356,
                26.4455435
              ],
              [
                58.7976824,
                26.4449954
              ],
              [
                58.7971223,
                26.4449954
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555247,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نیمروز",
          "name:en": "Nimruz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q63413193",
          "wikipedia": "en:Nimruz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.9249455,
                30.7568219
              ],
              [
                59.9302258,
                30.7570926
              ],
              [
                59.9307789,
                30.7573724
              ],
              [
                59.9354989,
                30.7573724
              ],
              [
                59.9357789,
                30.7576522
              ],
              [
                59.936332,
                30.7576522
              ],
              [
                59.9371653,
                30.7576522
              ],
              [
                59.9600881,
                30.7576521
              ],
              [
                59.9606416,
                30.757932
              ],
              [
                59.9673081,
                30.757932
              ],
              [
                59.9675882,
                30.7582118
              ],
              [
                59.9784212,
                30.7582118
              ],
              [
                59.9789744,
                30.757932
              ],
              [
                59.9873077,
                30.757932
              ],
              [
                59.9878678,
                30.7576521
              ],
              [
                59.9917542,
                30.7576521
              ],
              [
                59.9923077,
                30.7573723
              ],
              [
                59.9959211,
                30.7573723
              ],
              [
                60.0039741,
                30.7559824
              ],
              [
                60.0109206,
                30.7568217
              ],
              [
                60.012034,
                30.7570925
              ],
              [
                60.0134207,
                30.7570924
              ],
              [
                60.0142538,
                30.7573722
              ],
              [
                60.0175871,
                30.7573722
              ],
              [
                60.0178673,
                30.757652
              ],
              [
                60.0184207,
                30.7576521
              ],
              [
                60.0187008,
                30.7579319
              ],
              [
                60.0239806,
                30.759042
              ],
              [
                60.0259205,
                30.759042
              ],
              [
                60.0264807,
                30.7593219
              ],
              [
                60.0403668,
                30.7618129
              ],
              [
                60.0414802,
                30.7620928
              ],
              [
                60.0417536,
                30.7623726
              ],
              [
                60.0434201,
                30.7623725
              ],
              [
                60.0437001,
                30.7626523
              ],
              [
                60.0448135,
                30.7626524
              ],
              [
                60.0450869,
                30.7623726
              ],
              [
                60.0459201,
                30.7623726
              ],
              [
                60.0462002,
                30.7626523
              ],
              [
                60.0481472,
                30.7626523
              ],
              [
                60.0487002,
                30.7623726
              ],
              [
                60.0495335,
                30.7623726
              ],
              [
                60.0503667,
                30.7620928
              ],
              [
                60.0667599,
                30.7465412
              ],
              [
                60.0673135,
                30.7451513
              ],
              [
                60.0698131,
                30.7420915
              ],
              [
                60.0711998,
                30.740151
              ],
              [
                60.087593,
                30.7268111
              ],
              [
                60.0887063,
                30.7265403
              ],
              [
                60.0989791,
                30.7218199
              ],
              [
                60.0998127,
                30.7218199
              ],
              [
                60.1000928,
                30.7215401
              ],
              [
                60.1020394,
                30.7215401
              ],
              [
                60.1028726,
                30.7212604
              ],
              [
                60.1039793,
                30.7212603
              ],
              [
                60.1053727,
                30.7207007
              ],
              [
                60.1225925,
                30.71765
              ],
              [
                60.124259,
                30.7170904
              ],
              [
                60.1248125,
                30.7170905
              ],
              [
                60.1320388,
                30.7151499
              ],
              [
                60.1331525,
                30.7151499
              ],
              [
                60.1489851,
                30.7118193
              ],
              [
                60.150652,
                30.7118194
              ],
              [
                60.150925,
                30.7115396
              ],
              [
                60.1517586,
                30.7115396
              ],
              [
                60.1523188,
                30.7112599
              ],
              [
                60.1534251,
                30.7112598
              ],
              [
                60.1542587,
                30.71098
              ],
              [
                60.1692652,
                30.7087597
              ],
              [
                60.1712051,
                30.7087597
              ],
              [
                60.1717649,
                30.7084799
              ],
              [
                60.1728715,
                30.7084799
              ],
              [
                60.1734317,
                30.7082001
              ],
              [
                60.1742649,
                30.7082001
              ],
              [
                60.1745384,
                30.7079204
              ],
              [
                60.1912046,
                30.7048696
              ],
              [
                60.1942645,
                30.7045899
              ],
              [
                60.1953711,
                30.7043101
              ],
              [
                60.2262107,
                30.6968189
              ],
              [
                60.2464904,
                30.6887591
              ],
              [
                60.247324,
                30.688759
              ],
              [
                60.2481572,
                30.6881995
              ],
              [
                60.2664904,
                30.6826487
              ],
              [
                60.2695435,
                30.6815386
              ],
              [
                60.2945432,
                30.672089
              ],
              [
                60.3076028,
                30.6645889
              ],
              [
                60.3339892,
                30.6509788
              ],
              [
                60.3378825,
                30.649309
              ],
              [
                60.3587153,
                30.6390292
              ],
              [
                60.3659354,
                30.6340293
              ],
              [
                60.3973281,
                30.61347
              ],
              [
                60.399548,
                30.6118094
              ],
              [
                60.4001083,
                30.6118094
              ],
              [
                60.4362209,
                30.5845808
              ],
              [
                60.4439941,
                30.5781912
              ],
              [
                60.4464937,
                30.5762507
              ],
              [
                60.4842732,
                30.5323542
              ],
              [
                60.4851064,
                30.5312443
              ],
              [
                60.4853865,
                30.5306937
              ],
              [
                60.5200129,
                30.4867963
              ],
              [
                60.5216793,
                30.4848472
              ],
              [
                60.5216793,
                30.4845673
              ],
              [
                60.5222328,
                30.4842967
              ],
              [
                60.5462832,
                30.4373872
              ],
              [
                60.5573935,
                30.414065
              ],
              [
                60.5620826,
                30.407345
              ],
              [
                60.5683341,
                30.414882
              ],
              [
                60.5855713,
                30.4343692
              ],
              [
                60.5883447,
                30.4403956
              ],
              [
                60.5905714,
                30.4423447
              ],
              [
                60.609178,
                30.4545719
              ],
              [
                60.6379552,
                30.4755804
              ],
              [
                60.6441843,
                30.4801273
              ],
              [
                60.6458507,
                30.4809574
              ],
              [
                60.6464038,
                30.481517
              ],
              [
                60.6477906,
                30.4820674
              ],
              [
                60.6594642,
                30.4845671
              ],
              [
                60.6625175,
                30.4851266
              ],
              [
                60.669184,
                30.4859567
              ],
              [
                60.6730707,
                30.4859566
              ],
              [
                60.6744638,
                30.4862365
              ],
              [
                60.6766841,
                30.4859568
              ],
              [
                60.67807,
                30.4862365
              ],
              [
                60.7014103,
                30.4862364
              ],
              [
                60.7019635,
                30.4859566
              ],
              [
                60.7083495,
                30.4859566
              ],
              [
                60.7094636,
                30.4862363
              ],
              [
                60.7158496,
                30.4862364
              ],
              [
                60.7169629,
                30.4865161
              ],
              [
                60.7189098,
                30.4862364
              ],
              [
                60.7308561,
                30.4862363
              ],
              [
                60.7430759,
                30.4870665
              ],
              [
                60.7444627,
                30.4873462
              ],
              [
                60.7477963,
                30.4873462
              ],
              [
                60.7483557,
                30.4876259
              ],
              [
                60.7525229,
                30.4876259
              ],
              [
                60.7536292,
                30.4879057
              ],
              [
                60.7569621,
                30.4879056
              ],
              [
                60.7594622,
                30.4881764
              ],
              [
                60.7641888,
                30.4890156
              ],
              [
                60.7686357,
                30.4895661
              ],
              [
                60.7691889,
                30.4898458
              ],
              [
                60.772242,
                30.4898458
              ],
              [
                60.7728023,
                30.4901255
              ],
              [
                60.7744686,
                30.4901255
              ],
              [
                60.7758554,
                30.4904052
              ],
              [
                60.7819689,
                30.4904053
              ],
              [
                60.7891885,
                30.4909557
              ],
              [
                60.7897424,
                30.4912355
              ],
              [
                60.7922416,
                30.4912355
              ],
              [
                60.793355,
                30.4915152
              ],
              [
                60.7947417,
                30.4915152
              ],
              [
                60.7983551,
                30.4923454
              ],
              [
                60.7991887,
                30.4923454
              ],
              [
                60.7997418,
                30.4926251
              ],
              [
                60.8005754,
                30.4926251
              ],
              [
                60.8011356,
                30.4929049
              ],
              [
                60.8019684,
                30.4929048
              ],
              [
                60.8389145,
                30.5081824
              ],
              [
                60.8511342,
                30.5134615
              ],
              [
                60.851875,
                30.513736
              ],
              [
                60.8586344,
                30.5162409
              ],
              [
                60.863361,
                30.5179014
              ],
              [
                60.8919741,
                30.5284595
              ],
              [
                60.8928077,
                30.5284595
              ],
              [
                60.8936406,
                30.52901
              ],
              [
                60.9358601,
                30.5412378
              ],
              [
                60.954473,
                30.5445677
              ],
              [
                60.9553066,
                30.5448474
              ],
              [
                60.9566995,
                30.5448474
              ],
              [
                60.9586395,
                30.5454069
              ],
              [
                60.9597536,
                30.5454069
              ],
              [
                60.9605864,
                30.5456776
              ],
              [
                60.9633669,
                30.5462371
              ],
              [
                60.9658662,
                30.5465079
              ],
              [
                60.9925331,
                30.5570662
              ],
              [
                60.9933659,
                30.5576257
              ],
              [
                60.9939191,
                30.5576258
              ],
              [
                61.0169789,
                30.5792933
              ],
              [
                61.0175321,
                30.5804033
              ],
              [
                61.0377895,
                30.5995857
              ],
              [
                61.0383653,
                30.6001309
              ],
              [
                61.0419787,
                30.6031811
              ],
              [
                61.0725388,
                30.633188
              ],
              [
                61.1022582,
                30.6726265
              ],
              [
                61.1042051,
                30.6754062
              ],
              [
                61.1108716,
                30.6845755
              ],
              [
                61.1117045,
                30.6854059
              ],
              [
                61.111985,
                30.6862361
              ],
              [
                61.1128177,
                30.6870754
              ],
              [
                61.1219845,
                30.7087356
              ],
              [
                61.1222578,
                30.7115153
              ],
              [
                61.1225384,
                30.7134647
              ],
              [
                61.1228181,
                30.7148546
              ],
              [
                61.1230915,
                30.7159646
              ],
              [
                61.1230915,
                30.7267949
              ],
              [
                61.1228181,
                30.7284646
              ],
              [
                61.1230916,
                30.7323454
              ],
              [
                61.122258,
                30.7651253
              ],
              [
                61.1221768,
                30.7704128
              ],
              [
                61.1219847,
                30.7829054
              ],
              [
                61.1208714,
                30.7923551
              ],
              [
                61.1197582,
                30.7973552
              ],
              [
                61.1197581,
                30.7979057
              ],
              [
                61.1197582,
                30.7984653
              ],
              [
                61.1200386,
                30.7984654
              ],
              [
                61.1205918,
                30.8006856
              ],
              [
                61.1208715,
                30.8087455
              ],
              [
                61.1197583,
                30.8456875
              ],
              [
                61.1192052,
                30.8548487
              ],
              [
                61.1189255,
                30.8570781
              ],
              [
                61.1172584,
                30.8843
              ],
              [
                61.118092,
                30.891241
              ],
              [
                61.118092,
                30.8948514
              ],
              [
                61.1183718,
                30.8959706
              ],
              [
                61.118092,
                30.9023519
              ],
              [
                61.1185823,
                30.9064828
              ],
              [
                61.1186523,
                30.9070726
              ],
              [
                61.1189258,
                30.9298544
              ],
              [
                61.1186523,
                30.9309646
              ],
              [
                61.1180922,
                30.9334649
              ],
              [
                61.1175391,
                30.9426354
              ],
              [
                61.1172586,
                30.9456862
              ],
              [
                61.0828129,
                30.9998621
              ],
              [
                61.0830933,
                31.000151
              ],
              [
                61.0833731,
                31.0012432
              ],
              [
                61.0855926,
                31.0012432
              ],
              [
                61.0861465,
                31.0012432
              ],
              [
                61.0883732,
                31.0012431
              ],
              [
                61.0886458,
                31.001523
              ],
              [
                61.0958725,
                31.001523
              ],
              [
                61.096146,
                31.0018028
              ],
              [
                61.100593,
                31.0018028
              ],
              [
                61.1078196,
                31.0023534
              ],
              [
                61.1083727,
                31.0026332
              ],
              [
                61.1133729,
                31.0026332
              ],
              [
                61.1142057,
                31.002913
              ],
              [
                61.1200394,
                31.0029129
              ],
              [
                61.1211527,
                31.0031928
              ],
              [
                61.122259,
                31.0031928
              ],
              [
                61.1230925,
                31.002913
              ],
              [
                61.1389256,
                31.002913
              ],
              [
                61.1394858,
                31.0026331
              ],
              [
                61.142539,
                31.0026332
              ],
              [
                61.1458719,
                31.0023533
              ],
              [
                61.1462997,
                31.0023533
              ],
              [
                61.1514322,
                31.0023532
              ],
              [
                61.1522657,
                31.0026331
              ],
              [
                61.1614315,
                31.002633
              ],
              [
                61.1619855,
                31.0023532
              ],
              [
                61.1724899,
                31.0023537
              ],
              [
                61.1836516,
                31.0023532
              ],
              [
                61.1843398,
                31.0025842
              ],
              [
                61.1844851,
                31.002633
              ],
              [
                61.1908781,
                31.0026329
              ],
              [
                61.1911516,
                31.0023532
              ],
              [
                61.1917118,
                31.002633
              ],
              [
                61.1930978,
                31.002633
              ],
              [
                61.1939313,
                31.0023531
              ],
              [
                61.2058777,
                31.0023531
              ],
              [
                61.2072644,
                31.002633
              ],
              [
                61.2139309,
                31.0026329
              ],
              [
                61.2142114,
                31.0029128
              ],
              [
                61.2149036,
                31.0029128
              ],
              [
                61.2154884,
                31.0029128
              ],
              [
                61.2189311,
                31.0029127
              ],
              [
                61.2217107,
                31.0029127
              ],
              [
                61.2240469,
                31.0029128
              ],
              [
                61.2370512,
                31.0029128
              ],
              [
                61.2392111,
                31.0029126
              ],
              [
                61.240044,
                31.0031925
              ],
              [
                61.2472636,
                31.0031925
              ],
              [
                61.2486573,
                31.0034723
              ],
              [
                61.2592107,
                31.0034722
              ],
              [
                61.2603241,
                31.0031925
              ],
              [
                61.268657,
                31.0031924
              ],
              [
                61.2694906,
                31.0029126
              ],
              [
                61.2753235,
                31.0029126
              ],
              [
                61.2758766,
                31.0026328
              ],
              [
                61.290323,
                31.0026327
              ],
              [
                61.2908769,
                31.0026327
              ],
              [
                61.2936566,
                31.0026327
              ],
              [
                61.2944903,
                31.0023528
              ],
              [
                61.2958832,
                31.0023529
              ],
              [
                61.2992169,
                31.0023529
              ],
              [
                61.3247697,
                31.0023528
              ],
              [
                61.3253229,
                31.0026326
              ],
              [
                61.325883,
                31.0023528
              ],
              [
                61.3344965,
                31.0023528
              ],
              [
                61.3356027,
                31.0026325
              ],
              [
                61.3394958,
                31.0026326
              ],
              [
                61.3406028,
                31.0023528
              ],
              [
                61.3478295,
                31.0023528
              ],
              [
                61.3508827,
                31.002082
              ],
              [
                61.351996,
                31.0018021
              ],
              [
                61.3550492,
                31.0018021
              ],
              [
                61.3553289,
                31.0020819
              ],
              [
                61.3700487,
                31.0023526
              ],
              [
                61.3717151,
                31.0020818
              ],
              [
                61.3736621,
                31.0020819
              ],
              [
                61.3803286,
                31.0023527
              ],
              [
                61.3811622,
                31.0026325
              ],
              [
                61.3836622,
                31.0026325
              ],
              [
                61.3839419,
                31.0029122
              ],
              [
                61.3906085,
                31.0029123
              ],
              [
                61.4000484,
                31.0048529
              ],
              [
                61.4167814,
                31.0018212
              ],
              [
                61.4303279,
                30.994301
              ],
              [
                61.432828,
                30.9931907
              ],
              [
                61.4406078,
                30.9876304
              ],
              [
                61.4414414,
                30.9876305
              ],
              [
                61.4419945,
                30.9873507
              ],
              [
                61.446168,
                30.9873506
              ],
              [
                61.4464407,
                30.9876305
              ],
              [
                61.4475547,
                30.9876304
              ],
              [
                61.4478345,
                30.9879102
              ],
              [
                61.4495009,
                30.9879103
              ],
              [
                61.4500541,
                30.9881901
              ],
              [
                61.453108,
                30.9881901
              ],
              [
                61.4553346,
                30.9881901
              ],
              [
                61.4556072,
                30.9879102
              ],
              [
                61.4564409,
                30.9879102
              ],
              [
                61.4567206,
                30.9876305
              ],
              [
                61.4575542,
                30.9876304
              ],
              [
                61.4817465,
                30.9898468
              ],
              [
                61.477603,
                30.9941881
              ],
              [
                61.4752054,
                30.9980298
              ],
              [
                61.4749458,
                31.0032745
              ],
              [
                61.4761104,
                31.0060584
              ],
              [
                61.4737939,
                31.0112001
              ],
              [
                61.4709325,
                31.0149033
              ],
              [
                61.4657163,
                31.0257607
              ],
              [
                61.46945,
                31.0270478
              ],
              [
                61.4726746,
                31.028131
              ],
              [
                61.4723759,
                31.0317287
              ],
              [
                61.4721778,
                31.0334844
              ],
              [
                61.4714053,
                31.0391921
              ],
              [
                61.4692634,
                31.0423377
              ],
              [
                61.4656734,
                31.0465367
              ],
              [
                61.46533,
                31.0508752
              ],
              [
                61.4669654,
                31.0527996
              ],
              [
                61.4767455,
                31.0483015
              ],
              [
                61.4801787,
                31.0494781
              ],
              [
                61.4799213,
                31.0516288
              ],
              [
                61.4867341,
                31.0572446
              ],
              [
                61.4868686,
                31.0575493
              ],
              [
                61.4877319,
                31.0596802
              ],
              [
                61.4899635,
                31.0602132
              ],
              [
                61.4914669,
                31.0597038
              ],
              [
                61.4982676,
                31.0596802
              ],
              [
                61.5056062,
                31.058081
              ],
              [
                61.5129447,
                31.0585589
              ],
              [
                61.5170645,
                31.0567391
              ],
              [
                61.5198769,
                31.0555903
              ],
              [
                61.5218613,
                31.0542429
              ],
              [
                61.5222788,
                31.0545195
              ],
              [
                61.5238934,
                31.0544598
              ],
              [
                61.5254813,
                31.0551721
              ],
              [
                61.5276861,
                31.0555811
              ],
              [
                61.5289306,
                31.0564818
              ],
              [
                61.5273562,
                31.0622702
              ],
              [
                61.5266561,
                31.0674919
              ],
              [
                61.5251711,
                31.0738844
              ],
              [
                61.5241593,
                31.0791567
              ],
              [
                61.5218848,
                31.0837146
              ],
              [
                61.5174869,
                31.0922978
              ],
              [
                61.5133241,
                31.1061558
              ],
              [
                61.512949,
                31.1146172
              ],
              [
                61.5129714,
                31.1231065
              ],
              [
                61.5185992,
                31.1291584
              ],
              [
                61.5231208,
                31.1335043
              ],
              [
                61.5272358,
                31.1372879
              ],
              [
                61.5338325,
                31.1422776
              ],
              [
                61.5411682,
                31.1466765
              ],
              [
                61.5491204,
                31.1512652
              ],
              [
                61.5544223,
                31.1537642
              ],
              [
                61.5594943,
                31.1569421
              ],
              [
                61.5708824,
                31.164284
              ],
              [
                61.5675356,
                31.1702514
              ],
              [
                61.5769251,
                31.1748619
              ],
              [
                61.5139477,
                31.2468094
              ],
              [
                61.5125546,
                31.2479198
              ],
              [
                61.500335,
                31.2676356
              ],
              [
                61.4922817,
                31.2759679
              ],
              [
                61.4839488,
                31.288471
              ],
              [
                61.4831152,
                31.2895813
              ],
              [
                61.4725549,
                31.3120869
              ],
              [
                61.4703354,
                31.3184784
              ],
              [
                61.4695018,
                31.3390252
              ],
              [
                61.4692221,
                31.3426453
              ],
              [
                61.468669,
                31.347087
              ],
              [
                61.4683885,
                31.3479174
              ],
              [
                61.4681089,
                31.3495876
              ],
              [
                61.4650557,
                31.3595903
              ],
              [
                61.4642221,
                31.3612513
              ],
              [
                61.4639424,
                31.3626416
              ],
              [
                61.4625556,
                31.3654221
              ],
              [
                61.459776,
                31.3740346
              ],
              [
                61.4572761,
                31.3984818
              ],
              [
                61.4570026,
                31.4012534
              ],
              [
                61.456169,
                31.4048645
              ],
              [
                61.4515282,
                31.4094941
              ],
              [
                61.3187061,
                31.4265614
              ],
              [
                61.1788319,
                31.4448429
              ],
              [
                61.1741498,
                31.4454548
              ],
              [
                61.1562255,
                31.4485621
              ],
              [
                61.0419254,
                31.4625939
              ],
              [
                60.9095276,
                31.4797524
              ],
              [
                60.856057,
                31.4865192
              ],
              [
                60.8569713,
                31.4834814
              ],
              [
                60.8569713,
                31.4832016
              ],
              [
                60.857251,
                31.482371
              ],
              [
                60.8575314,
                31.4787598
              ],
              [
                60.8572509,
                31.4784799
              ],
              [
                60.8490729,
                31.4752663
              ],
              [
                60.8492917,
                31.4659502
              ],
              [
                60.8487315,
                31.4640001
              ],
              [
                60.8487315,
                31.4626188
              ],
              [
                60.8473216,
                31.4569733
              ],
              [
                60.8448447,
                31.4470544
              ],
              [
                60.8428745,
                31.4431502
              ],
              [
                60.8376092,
                31.4327152
              ],
              [
                60.8344247,
                31.4264036
              ],
              [
                60.833302,
                31.4241783
              ],
              [
                60.835075,
                31.4151866
              ],
              [
                60.8282086,
                31.4028799
              ],
              [
                60.8187669,
                31.3968452
              ],
              [
                60.809875,
                31.3886187
              ],
              [
                60.7942193,
                31.355983
              ],
              [
                60.7859795,
                31.323141
              ],
              [
                60.7214869,
                31.3021398
              ],
              [
                60.6782323,
                31.2981783
              ],
              [
                60.6730741,
                31.295724
              ],
              [
                60.6678272,
                31.2932275
              ],
              [
                60.6527707,
                31.2662266
              ],
              [
                60.6674774,
                31.2399715
              ],
              [
                60.670199,
                31.2294182
              ],
              [
                60.6686469,
                31.2286792
              ],
              [
                60.6683665,
                31.2283991
              ],
              [
                60.668093,
                31.2278481
              ],
              [
                60.6673588,
                31.2270231
              ],
              [
                60.6664625,
                31.2260158
              ],
              [
                60.6658663,
                31.2253458
              ],
              [
                60.6507107,
                31.2227845
              ],
              [
                60.5820674,
                31.2253437
              ],
              [
                60.5815072,
                31.2250636
              ],
              [
                60.5804009,
                31.2250636
              ],
              [
                60.5801208,
                31.2250636
              ],
              [
                60.5798408,
                31.2247837
              ],
              [
                60.5773407,
                31.2245128
              ],
              [
                60.5745676,
                31.2236819
              ],
              [
                60.5731742,
                31.2236819
              ],
              [
                60.5383549,
                31.212708
              ],
              [
                60.536688,
                31.211877
              ],
              [
                60.5358548,
                31.211877
              ],
              [
                60.5137617,
                31.1989811
              ],
              [
                60.5123683,
                31.1989812
              ],
              [
                60.5118152,
                31.1987011
              ],
              [
                60.4293403,
                31.2173942
              ],
              [
                60.4240601,
                31.2162835
              ],
              [
                60.4218406,
                31.2160037
              ],
              [
                60.3910005,
                31.2104505
              ],
              [
                60.3706173,
                31.2154854
              ],
              [
                60.3581709,
                31.2119562
              ],
              [
                60.3457543,
                31.1988749
              ],
              [
                60.3415877,
                31.196654
              ],
              [
                60.3252407,
                31.1672787
              ],
              [
                60.2926251,
                31.1628721
              ],
              [
                60.2849246,
                31.1482848
              ],
              [
                60.282978,
                31.1466149
              ],
              [
                60.282425,
                31.146335
              ],
              [
                60.282425,
                31.1460551
              ],
              [
                60.2630993,
                31.1493572
              ],
              [
                60.2324756,
                31.1260691
              ],
              [
                60.2313623,
                31.1227381
              ],
              [
                60.2431185,
                31.1042775
              ],
              [
                60.2481186,
                31.0937156
              ],
              [
                60.2511718,
                31.0892741
              ],
              [
                60.265995,
                31.0664983
              ],
              [
                60.2701614,
                31.0534359
              ],
              [
                60.2693019,
                31.0467605
              ],
              [
                60.2584685,
                31.0375919
              ],
              [
                60.2556887,
                31.0356517
              ],
              [
                60.2543019,
                31.0348124
              ],
              [
                60.2348555,
                31.0281526
              ],
              [
                60.2276287,
                31.023433
              ],
              [
                60.2063254,
                31.0246128
              ],
              [
                60.1708122,
                31.0100716
              ],
              [
                60.1694259,
                31.0100717
              ],
              [
                60.1669259,
                31.0092419
              ],
              [
                60.1622059,
                31.009242
              ],
              [
                60.1588659,
                31.009242
              ],
              [
                60.1563659,
                31.0092419
              ],
              [
                60.154699,
                31.0095215
              ],
              [
                60.154146,
                31.009242
              ],
              [
                60.1510928,
                31.009242
              ],
              [
                60.1502596,
                31.0089624
              ],
              [
                60.1408129,
                31.0089624
              ],
              [
                60.1402594,
                31.0086828
              ],
              [
                60.138866,
                31.0086828
              ],
              [
                60.1380328,
                31.0084032
              ],
              [
                60.1329694,
                31.0040276
              ],
              [
                60.128803,
                31.0040277
              ],
              [
                60.1282498,
                31.003748
              ],
              [
                60.1257498,
                31.003748
              ],
              [
                60.1249166,
                31.0040277
              ],
              [
                60.1246365,
                31.003748
              ],
              [
                60.1238033,
                31.0040277
              ],
              [
                60.1082432,
                31.0040277
              ],
              [
                60.1076901,
                31.003748
              ],
              [
                60.1022001,
                31.0073029
              ],
              [
                60.0947004,
                31.0075736
              ],
              [
                60.0922003,
                31.007303
              ],
              [
                60.0866471,
                31.007303
              ],
              [
                60.0855338,
                31.0070235
              ],
              [
                60.0772004,
                31.0070235
              ],
              [
                60.076087,
                31.0067439
              ],
              [
                60.0699737,
                31.0067439
              ],
              [
                60.0697007,
                31.0070236
              ],
              [
                60.0616407,
                31.0070236
              ],
              [
                60.0599739,
                31.006744
              ],
              [
                60.0588673,
                31.0070235
              ],
              [
                60.0449206,
                31.0091659
              ],
              [
                60.0418604,
                31.0094364
              ],
              [
                60.040194,
                31.0094364
              ],
              [
                60.0396405,
                31.009716
              ],
              [
                60.0357541,
                31.0097161
              ],
              [
                60.035474,
                31.0099955
              ],
              [
                60.0190807,
                31.0099956
              ],
              [
                60.0121411,
                31.0086067
              ],
              [
                59.9839779,
                30.973194
              ],
              [
                59.962039,
                30.9192671
              ],
              [
                59.9562057,
                30.9145465
              ],
              [
                59.9556455,
                30.9134363
              ],
              [
                59.9428725,
                30.8967652
              ],
              [
                59.9414792,
                30.8945448
              ],
              [
                59.9414792,
                30.894265
              ],
              [
                59.9409257,
                30.8937144
              ],
              [
                59.9378724,
                30.8856632
              ],
              [
                59.9370393,
                30.8837136
              ],
              [
                59.9370392,
                30.8828832
              ],
              [
                59.936479,
                30.881764
              ],
              [
                59.9339794,
                30.8648223
              ],
              [
                59.9339794,
                30.8592714
              ],
              [
                59.9334258,
                30.8551014
              ],
              [
                59.9334258,
                30.8439907
              ],
              [
                59.9320394,
                30.8326002
              ],
              [
                59.9320393,
                30.8245402
              ],
              [
                59.9314792,
                30.8198197
              ],
              [
                59.9314792,
                30.8187096
              ],
              [
                59.9314791,
                30.8148195
              ],
              [
                59.9312056,
                30.8112093
              ],
              [
                59.9309257,
                30.810379
              ],
              [
                59.9312057,
                30.8067686
              ],
              [
                59.9306454,
                30.7939884
              ],
              [
                59.9304988,
                30.7793233
              ],
              [
                59.9302258,
                30.7770938
              ],
              [
                59.9299457,
                30.7751534
              ],
              [
                59.9296656,
                30.7726531
              ],
              [
                59.9293922,
                30.7707125
              ],
              [
                59.9291124,
                30.7690428
              ],
              [
                59.9288324,
                30.7673731
              ],
              [
                59.9285589,
                30.7662627
              ],
              [
                59.9279987,
                30.7646021
              ],
              [
                59.9277257,
                30.7623728
              ],
              [
                59.9274457,
                30.7612625
              ],
              [
                59.9249455,
                30.7568219
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555248,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هامون",
          "name:en": "Hamun County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q61357100",
          "wikipedia": "en:Hamun County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.5620826,
                30.407345
              ],
              [
                60.5677358,
                30.4001773
              ],
              [
                60.5805472,
                30.3845469
              ],
              [
                60.5941807,
                30.3669144
              ],
              [
                60.607263,
                30.3493665
              ],
              [
                60.6231012,
                30.3274955
              ],
              [
                60.6354331,
                30.2995376
              ],
              [
                60.6422077,
                30.2893519
              ],
              [
                60.6525979,
                30.2810691
              ],
              [
                60.6538407,
                30.2800783
              ],
              [
                60.6682197,
                30.2734331
              ],
              [
                60.675488,
                30.2713699
              ],
              [
                60.6834935,
                30.2673531
              ],
              [
                60.6949785,
                30.259201
              ],
              [
                60.7080665,
                30.2473203
              ],
              [
                60.7151214,
                30.2406495
              ],
              [
                60.7276432,
                30.2358466
              ],
              [
                60.7469226,
                30.2299613
              ],
              [
                60.7596693,
                30.2219487
              ],
              [
                60.7625057,
                30.21904
              ],
              [
                60.7768329,
                30.2043468
              ],
              [
                60.7833546,
                30.2001211
              ],
              [
                60.7905608,
                30.196874
              ],
              [
                60.8020755,
                30.1923918
              ],
              [
                60.81645,
                30.18468
              ],
              [
                60.828123,
                30.1765184
              ],
              [
                60.8372211,
                30.1682078
              ],
              [
                60.8440579,
                30.1599423
              ],
              [
                60.848509,
                30.1511314
              ],
              [
                60.8557852,
                30.1419936
              ],
              [
                60.8622485,
                30.1373174
              ],
              [
                60.8734517,
                30.1330691
              ],
              [
                60.8823058,
                30.1316586
              ],
              [
                60.9032238,
                30.1306021
              ],
              [
                60.9264222,
                30.1319121
              ],
              [
                60.982777,
                30.1439151
              ],
              [
                61.0086873,
                30.1506146
              ],
              [
                61.0251336,
                30.1531651
              ],
              [
                61.0381507,
                30.1508422
              ],
              [
                61.0447467,
                30.145271
              ],
              [
                61.0457527,
                30.1435789
              ],
              [
                61.0502769,
                30.1359687
              ],
              [
                61.0561105,
                30.1258111
              ],
              [
                61.0666421,
                30.1155351
              ],
              [
                61.078658,
                30.1077621
              ],
              [
                61.0887242,
                30.1028543
              ],
              [
                61.094819,
                30.0955321
              ],
              [
                61.1034666,
                30.1047319
              ],
              [
                61.1736538,
                30.1792752
              ],
              [
                61.243373,
                30.2532657
              ],
              [
                61.293325,
                30.30608
              ],
              [
                61.3431915,
                30.3587755
              ],
              [
                61.4028358,
                30.422452
              ],
              [
                61.461496,
                30.4850372
              ],
              [
                61.5117145,
                30.538584
              ],
              [
                61.528695,
                30.5559617
              ],
              [
                61.5412334,
                30.5678785
              ],
              [
                61.5932492,
                30.6219804
              ],
              [
                61.5854242,
                30.6254087
              ],
              [
                61.5767958,
                30.6336172
              ],
              [
                61.570908,
                30.6342986
              ],
              [
                61.5622024,
                30.6344596
              ],
              [
                61.5584842,
                30.6346924
              ],
              [
                61.5522069,
                30.6357052
              ],
              [
                61.5467797,
                30.6381244
              ],
              [
                61.5417448,
                30.6418375
              ],
              [
                61.5344213,
                30.6501071
              ],
              [
                61.5302187,
                30.6555108
              ],
              [
                61.5280637,
                30.6582816
              ],
              [
                61.5244821,
                30.664242
              ],
              [
                61.5225558,
                30.6694477
              ],
              [
                61.521588,
                30.6757973
              ],
              [
                61.5209896,
                30.6858354
              ],
              [
                61.5197743,
                30.6947057
              ],
              [
                61.5206121,
                30.7012436
              ],
              [
                61.518604,
                30.7094389
              ],
              [
                61.5164443,
                30.7185161
              ],
              [
                61.5142542,
                30.7239566
              ],
              [
                61.507442,
                30.7339123
              ],
              [
                61.4997655,
                30.7405201
              ],
              [
                61.4979347,
                30.7434986
              ],
              [
                61.4917634,
                30.7486583
              ],
              [
                61.4915374,
                30.7538133
              ],
              [
                61.4901506,
                30.7580834
              ],
              [
                61.4899545,
                30.7677904
              ],
              [
                61.4929271,
                30.7798307
              ],
              [
                61.4940114,
                30.7862003
              ],
              [
                61.4938778,
                30.7965561
              ],
              [
                61.4911435,
                30.8051372
              ],
              [
                61.4889856,
                30.8150763
              ],
              [
                61.4899545,
                30.8176484
              ],
              [
                61.4898357,
                30.8234213
              ],
              [
                61.4903115,
                30.8312652
              ],
              [
                61.4918998,
                30.8375837
              ],
              [
                61.4948235,
                30.8463592
              ],
              [
                61.496162,
                30.8510702
              ],
              [
                61.4970957,
                30.8577383
              ],
              [
                61.4965035,
                30.8610565
              ],
              [
                61.4968849,
                30.8665255
              ],
              [
                61.4938582,
                30.877293
              ],
              [
                61.4905734,
                30.8909398
              ],
              [
                61.4901811,
                30.896429
              ],
              [
                61.490884,
                30.9167848
              ],
              [
                61.4898265,
                30.9324782
              ],
              [
                61.4895819,
                30.9491747
              ],
              [
                61.4889915,
                30.9587719
              ],
              [
                61.4881225,
                30.9660039
              ],
              [
                61.4859032,
                30.9783474
              ],
              [
                61.48368,
                30.9853548
              ],
              [
                61.4817465,
                30.9898468
              ],
              [
                61.4575542,
                30.9876304
              ],
              [
                61.4567206,
                30.9876305
              ],
              [
                61.4564409,
                30.9879102
              ],
              [
                61.4556072,
                30.9879102
              ],
              [
                61.4553346,
                30.9881901
              ],
              [
                61.453108,
                30.9881901
              ],
              [
                61.4500541,
                30.9881901
              ],
              [
                61.4495009,
                30.9879103
              ],
              [
                61.4478345,
                30.9879102
              ],
              [
                61.4475547,
                30.9876304
              ],
              [
                61.4464407,
                30.9876305
              ],
              [
                61.446168,
                30.9873506
              ],
              [
                61.4419945,
                30.9873507
              ],
              [
                61.4414414,
                30.9876305
              ],
              [
                61.4406078,
                30.9876304
              ],
              [
                61.432828,
                30.9931907
              ],
              [
                61.4303279,
                30.994301
              ],
              [
                61.4167814,
                31.0018212
              ],
              [
                61.4000484,
                31.0048529
              ],
              [
                61.3906085,
                31.0029123
              ],
              [
                61.3839419,
                31.0029122
              ],
              [
                61.3836622,
                31.0026325
              ],
              [
                61.3811622,
                31.0026325
              ],
              [
                61.3803286,
                31.0023527
              ],
              [
                61.3736621,
                31.0020819
              ],
              [
                61.3717151,
                31.0020818
              ],
              [
                61.3700487,
                31.0023526
              ],
              [
                61.3553289,
                31.0020819
              ],
              [
                61.3550492,
                31.0018021
              ],
              [
                61.351996,
                31.0018021
              ],
              [
                61.3508827,
                31.002082
              ],
              [
                61.3478295,
                31.0023528
              ],
              [
                61.3406028,
                31.0023528
              ],
              [
                61.3394958,
                31.0026326
              ],
              [
                61.3356027,
                31.0026325
              ],
              [
                61.3344965,
                31.0023528
              ],
              [
                61.325883,
                31.0023528
              ],
              [
                61.3253229,
                31.0026326
              ],
              [
                61.3247697,
                31.0023528
              ],
              [
                61.2992169,
                31.0023529
              ],
              [
                61.2958832,
                31.0023529
              ],
              [
                61.2944903,
                31.0023528
              ],
              [
                61.2936566,
                31.0026327
              ],
              [
                61.2908769,
                31.0026327
              ],
              [
                61.290323,
                31.0026327
              ],
              [
                61.2758766,
                31.0026328
              ],
              [
                61.2753235,
                31.0029126
              ],
              [
                61.2694906,
                31.0029126
              ],
              [
                61.268657,
                31.0031924
              ],
              [
                61.2603241,
                31.0031925
              ],
              [
                61.2592107,
                31.0034722
              ],
              [
                61.2486573,
                31.0034723
              ],
              [
                61.2472636,
                31.0031925
              ],
              [
                61.240044,
                31.0031925
              ],
              [
                61.2392111,
                31.0029126
              ],
              [
                61.2370512,
                31.0029128
              ],
              [
                61.2240469,
                31.0029128
              ],
              [
                61.2217107,
                31.0029127
              ],
              [
                61.2189311,
                31.0029127
              ],
              [
                61.2154884,
                31.0029128
              ],
              [
                61.2149036,
                31.0029128
              ],
              [
                61.2142114,
                31.0029128
              ],
              [
                61.2139309,
                31.0026329
              ],
              [
                61.2072644,
                31.002633
              ],
              [
                61.2058777,
                31.0023531
              ],
              [
                61.1939313,
                31.0023531
              ],
              [
                61.1930978,
                31.002633
              ],
              [
                61.1917118,
                31.002633
              ],
              [
                61.1911516,
                31.0023532
              ],
              [
                61.1908781,
                31.0026329
              ],
              [
                61.1844851,
                31.002633
              ],
              [
                61.1843398,
                31.0025842
              ],
              [
                61.1836516,
                31.0023532
              ],
              [
                61.1724899,
                31.0023537
              ],
              [
                61.1619855,
                31.0023532
              ],
              [
                61.1614315,
                31.002633
              ],
              [
                61.1522657,
                31.0026331
              ],
              [
                61.1514322,
                31.0023532
              ],
              [
                61.1462997,
                31.0023533
              ],
              [
                61.1458719,
                31.0023533
              ],
              [
                61.142539,
                31.0026332
              ],
              [
                61.1394858,
                31.0026331
              ],
              [
                61.1389256,
                31.002913
              ],
              [
                61.1230925,
                31.002913
              ],
              [
                61.122259,
                31.0031928
              ],
              [
                61.1211527,
                31.0031928
              ],
              [
                61.1200394,
                31.0029129
              ],
              [
                61.1142057,
                31.002913
              ],
              [
                61.1133729,
                31.0026332
              ],
              [
                61.1083727,
                31.0026332
              ],
              [
                61.1078196,
                31.0023534
              ],
              [
                61.100593,
                31.0018028
              ],
              [
                61.096146,
                31.0018028
              ],
              [
                61.0958725,
                31.001523
              ],
              [
                61.0886458,
                31.001523
              ],
              [
                61.0883732,
                31.0012431
              ],
              [
                61.0861465,
                31.0012432
              ],
              [
                61.0855926,
                31.0012432
              ],
              [
                61.0833731,
                31.0012432
              ],
              [
                61.0830933,
                31.000151
              ],
              [
                61.0828129,
                30.9998621
              ],
              [
                61.1172586,
                30.9456862
              ],
              [
                61.1175391,
                30.9426354
              ],
              [
                61.1180922,
                30.9334649
              ],
              [
                61.1186523,
                30.9309646
              ],
              [
                61.1189258,
                30.9298544
              ],
              [
                61.1186523,
                30.9070726
              ],
              [
                61.1185823,
                30.9064828
              ],
              [
                61.118092,
                30.9023519
              ],
              [
                61.1183718,
                30.8959706
              ],
              [
                61.118092,
                30.8948514
              ],
              [
                61.118092,
                30.891241
              ],
              [
                61.1172584,
                30.8843
              ],
              [
                61.1189255,
                30.8570781
              ],
              [
                61.1192052,
                30.8548487
              ],
              [
                61.1197583,
                30.8456875
              ],
              [
                61.1208715,
                30.8087455
              ],
              [
                61.1205918,
                30.8006856
              ],
              [
                61.1200386,
                30.7984654
              ],
              [
                61.1197582,
                30.7984653
              ],
              [
                61.1197581,
                30.7979057
              ],
              [
                61.1197582,
                30.7973552
              ],
              [
                61.1208714,
                30.7923551
              ],
              [
                61.1219847,
                30.7829054
              ],
              [
                61.1221768,
                30.7704128
              ],
              [
                61.122258,
                30.7651253
              ],
              [
                61.1230916,
                30.7323454
              ],
              [
                61.1228181,
                30.7284646
              ],
              [
                61.1230915,
                30.7267949
              ],
              [
                61.1230915,
                30.7159646
              ],
              [
                61.1228181,
                30.7148546
              ],
              [
                61.1225384,
                30.7134647
              ],
              [
                61.1222578,
                30.7115153
              ],
              [
                61.1219845,
                30.7087356
              ],
              [
                61.1128177,
                30.6870754
              ],
              [
                61.111985,
                30.6862361
              ],
              [
                61.1117045,
                30.6854059
              ],
              [
                61.1108716,
                30.6845755
              ],
              [
                61.1042051,
                30.6754062
              ],
              [
                61.1022582,
                30.6726265
              ],
              [
                61.0725388,
                30.633188
              ],
              [
                61.0419787,
                30.6031811
              ],
              [
                61.0383653,
                30.6001309
              ],
              [
                61.0377895,
                30.5995857
              ],
              [
                61.0175321,
                30.5804033
              ],
              [
                61.0169789,
                30.5792933
              ],
              [
                60.9939191,
                30.5576258
              ],
              [
                60.9933659,
                30.5576257
              ],
              [
                60.9925331,
                30.5570662
              ],
              [
                60.9658662,
                30.5465079
              ],
              [
                60.9633669,
                30.5462371
              ],
              [
                60.9605864,
                30.5456776
              ],
              [
                60.9597536,
                30.5454069
              ],
              [
                60.9586395,
                30.5454069
              ],
              [
                60.9566995,
                30.5448474
              ],
              [
                60.9553066,
                30.5448474
              ],
              [
                60.954473,
                30.5445677
              ],
              [
                60.9358601,
                30.5412378
              ],
              [
                60.8936406,
                30.52901
              ],
              [
                60.8928077,
                30.5284595
              ],
              [
                60.8919741,
                30.5284595
              ],
              [
                60.863361,
                30.5179014
              ],
              [
                60.8586344,
                30.5162409
              ],
              [
                60.851875,
                30.513736
              ],
              [
                60.8511342,
                30.5134615
              ],
              [
                60.8389145,
                30.5081824
              ],
              [
                60.8019684,
                30.4929048
              ],
              [
                60.8011356,
                30.4929049
              ],
              [
                60.8005754,
                30.4926251
              ],
              [
                60.7997418,
                30.4926251
              ],
              [
                60.7991887,
                30.4923454
              ],
              [
                60.7983551,
                30.4923454
              ],
              [
                60.7947417,
                30.4915152
              ],
              [
                60.793355,
                30.4915152
              ],
              [
                60.7922416,
                30.4912355
              ],
              [
                60.7897424,
                30.4912355
              ],
              [
                60.7891885,
                30.4909557
              ],
              [
                60.7819689,
                30.4904053
              ],
              [
                60.7758554,
                30.4904052
              ],
              [
                60.7744686,
                30.4901255
              ],
              [
                60.7728023,
                30.4901255
              ],
              [
                60.772242,
                30.4898458
              ],
              [
                60.7691889,
                30.4898458
              ],
              [
                60.7686357,
                30.4895661
              ],
              [
                60.7641888,
                30.4890156
              ],
              [
                60.7594622,
                30.4881764
              ],
              [
                60.7569621,
                30.4879056
              ],
              [
                60.7536292,
                30.4879057
              ],
              [
                60.7525229,
                30.4876259
              ],
              [
                60.7483557,
                30.4876259
              ],
              [
                60.7477963,
                30.4873462
              ],
              [
                60.7444627,
                30.4873462
              ],
              [
                60.7430759,
                30.4870665
              ],
              [
                60.7308561,
                30.4862363
              ],
              [
                60.7189098,
                30.4862364
              ],
              [
                60.7169629,
                30.4865161
              ],
              [
                60.7158496,
                30.4862364
              ],
              [
                60.7094636,
                30.4862363
              ],
              [
                60.7083495,
                30.4859566
              ],
              [
                60.7019635,
                30.4859566
              ],
              [
                60.7014103,
                30.4862364
              ],
              [
                60.67807,
                30.4862365
              ],
              [
                60.6766841,
                30.4859568
              ],
              [
                60.6744638,
                30.4862365
              ],
              [
                60.6730707,
                30.4859566
              ],
              [
                60.669184,
                30.4859567
              ],
              [
                60.6625175,
                30.4851266
              ],
              [
                60.6594642,
                30.4845671
              ],
              [
                60.6477906,
                30.4820674
              ],
              [
                60.6464038,
                30.481517
              ],
              [
                60.6458507,
                30.4809574
              ],
              [
                60.6441843,
                30.4801273
              ],
              [
                60.6379552,
                30.4755804
              ],
              [
                60.609178,
                30.4545719
              ],
              [
                60.5905714,
                30.4423447
              ],
              [
                60.5883447,
                30.4403956
              ],
              [
                60.5855713,
                30.4343692
              ],
              [
                60.5683341,
                30.414882
              ],
              [
                60.5620826,
                30.407345
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555256,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هیرمند",
          "name:en": "Hirmand County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q259162",
          "wikipedia": "en:Hirmand County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                61.4515282,
                31.4094941
              ],
              [
                61.456169,
                31.4048645
              ],
              [
                61.4570026,
                31.4012534
              ],
              [
                61.4572761,
                31.3984818
              ],
              [
                61.459776,
                31.3740346
              ],
              [
                61.4625556,
                31.3654221
              ],
              [
                61.4639424,
                31.3626416
              ],
              [
                61.4642221,
                31.3612513
              ],
              [
                61.4650557,
                31.3595903
              ],
              [
                61.4681089,
                31.3495876
              ],
              [
                61.4683885,
                31.3479174
              ],
              [
                61.468669,
                31.347087
              ],
              [
                61.4692221,
                31.3426453
              ],
              [
                61.4695018,
                31.3390252
              ],
              [
                61.4703354,
                31.3184784
              ],
              [
                61.4725549,
                31.3120869
              ],
              [
                61.4831152,
                31.2895813
              ],
              [
                61.4839488,
                31.288471
              ],
              [
                61.4922817,
                31.2759679
              ],
              [
                61.500335,
                31.2676356
              ],
              [
                61.5125546,
                31.2479198
              ],
              [
                61.5139477,
                31.2468094
              ],
              [
                61.5769251,
                31.1748619
              ],
              [
                61.5891786,
                31.163336
              ],
              [
                61.5913066,
                31.1544986
              ],
              [
                61.5886153,
                31.144696
              ],
              [
                61.5910083,
                31.1386325
              ],
              [
                61.594749,
                31.1325352
              ],
              [
                61.6021347,
                31.1339817
              ],
              [
                61.6082059,
                31.1321066
              ],
              [
                61.6108347,
                31.1296421
              ],
              [
                61.6067037,
                31.1243914
              ],
              [
                61.6214291,
                31.1005356
              ],
              [
                61.6336174,
                31.086342
              ],
              [
                61.6445533,
                31.0703692
              ],
              [
                61.647442,
                31.06561
              ],
              [
                61.648172,
                31.0641126
              ],
              [
                61.6510049,
                31.0594238
              ],
              [
                61.656124,
                31.0513393
              ],
              [
                61.6630812,
                31.0392243
              ],
              [
                61.6728313,
                31.0219584
              ],
              [
                61.6730054,
                31.0209805
              ],
              [
                61.6750484,
                31.0160335
              ],
              [
                61.6774842,
                31.013083
              ],
              [
                61.6822046,
                31.0092216
              ],
              [
                61.6868521,
                31.0061012
              ],
              [
                61.6918262,
                31.0038672
              ],
              [
                61.6999003,
                31.0024187
              ],
              [
                61.7079118,
                31.0017212
              ],
              [
                61.7154226,
                31.0015066
              ],
              [
                61.7227769,
                31.0006214
              ],
              [
                61.7303081,
                30.9839323
              ],
              [
                61.7321538,
                30.9798417
              ],
              [
                61.7400831,
                30.9723706
              ],
              [
                61.7498471,
                30.9599731
              ],
              [
                61.7597989,
                30.9532101
              ],
              [
                61.7647435,
                30.9466077
              ],
              [
                61.7676606,
                30.9435095
              ],
              [
                61.7715278,
                30.9403423
              ],
              [
                61.7769079,
                30.9371148
              ],
              [
                61.7837609,
                30.9340048
              ],
              [
                61.7868065,
                30.9369917
              ],
              [
                61.7881053,
                30.9404275
              ],
              [
                61.7902842,
                30.9436405
              ],
              [
                61.799139,
                30.9478104
              ],
              [
                61.8034354,
                30.952223
              ],
              [
                61.8078474,
                30.956564
              ],
              [
                61.809505,
                30.9563753
              ],
              [
                61.8113427,
                30.9585909
              ],
              [
                61.8130348,
                30.9599055
              ],
              [
                61.8140287,
                30.9613055
              ],
              [
                61.8150003,
                30.9645106
              ],
              [
                61.8207311,
                30.9677182
              ],
              [
                61.8215389,
                30.9678114
              ],
              [
                61.8281506,
                30.9753099
              ],
              [
                61.8289684,
                30.9772786
              ],
              [
                61.8276012,
                30.9785716
              ],
              [
                61.8267494,
                30.9797493
              ],
              [
                61.826773,
                30.9808964
              ],
              [
                61.826944,
                30.983333
              ],
              [
                61.8270718,
                30.9864408
              ],
              [
                61.8240717,
                30.9975173
              ],
              [
                61.8238446,
                31.0008681
              ],
              [
                61.8247366,
                31.0051498
              ],
              [
                61.8275529,
                31.0072666
              ],
              [
                61.8282461,
                31.0088634
              ],
              [
                61.8272496,
                31.0136538
              ],
              [
                61.8282461,
                31.0151391
              ],
              [
                61.8324056,
                31.0163273
              ],
              [
                61.8329688,
                31.0177755
              ],
              [
                61.8329255,
                31.0204861
              ],
              [
                61.8303259,
                31.0234936
              ],
              [
                61.829373,
                31.0255369
              ],
              [
                61.8286794,
                31.0268352
              ],
              [
                61.8282895,
                31.0280233
              ],
              [
                61.8279429,
                31.0291743
              ],
              [
                61.8281162,
                31.0305109
              ],
              [
                61.8280295,
                31.0324786
              ],
              [
                61.8297626,
                31.0339265
              ],
              [
                61.8307158,
                31.0346319
              ],
              [
                61.8332721,
                31.0348175
              ],
              [
                61.834052,
                31.0344834
              ],
              [
                61.8347886,
                31.0343349
              ],
              [
                61.8354818,
                31.0349289
              ],
              [
                61.8386508,
                31.0352223
              ],
              [
                61.8390347,
                31.036451
              ],
              [
                61.8379515,
                31.0364139
              ],
              [
                61.8374749,
                31.040052
              ],
              [
                61.8355685,
                31.0420566
              ],
              [
                61.8352218,
                31.0425392
              ],
              [
                61.8348319,
                31.0435415
              ],
              [
                61.8340953,
                31.043987
              ],
              [
                61.8338354,
                31.0446923
              ],
              [
                61.8307158,
                31.0463998
              ],
              [
                61.8292427,
                31.0476248
              ],
              [
                61.8275962,
                31.0522276
              ],
              [
                61.8273796,
                31.0537123
              ],
              [
                61.8283761,
                31.0543433
              ],
              [
                61.8293727,
                31.0558651
              ],
              [
                61.8288527,
                31.0588345
              ],
              [
                61.8293293,
                31.0603191
              ],
              [
                61.8288527,
                31.0619893
              ],
              [
                61.8284195,
                31.0630656
              ],
              [
                61.8278129,
                31.0637336
              ],
              [
                61.8280295,
                31.0644017
              ],
              [
                61.8275529,
                31.0651439
              ],
              [
                61.8276829,
                31.065812
              ],
              [
                61.827163,
                31.0682985
              ],
              [
                61.8275096,
                31.0694119
              ],
              [
                61.826643,
                31.0717499
              ],
              [
                61.8265997,
                31.0744218
              ],
              [
                61.8276396,
                31.0764628
              ],
              [
                61.829026,
                31.0787265
              ],
              [
                61.829546,
                31.0804334
              ],
              [
                61.8309324,
                31.0822517
              ],
              [
                61.8312791,
                31.0857025
              ],
              [
                61.8315824,
                31.0884854
              ],
              [
                61.8303692,
                31.0918618
              ],
              [
                61.8282461,
                31.0937911
              ],
              [
                61.8258198,
                31.0951268
              ],
              [
                61.8208372,
                31.1002467
              ],
              [
                61.819364,
                31.1010258
              ],
              [
                61.8184542,
                31.1021388
              ],
              [
                61.8162878,
                31.1041792
              ],
              [
                61.8145114,
                31.1074067
              ],
              [
                61.8136882,
                31.1094841
              ],
              [
                61.8111752,
                31.1138984
              ],
              [
                61.8113485,
                31.1158644
              ],
              [
                61.812605,
                31.1175336
              ],
              [
                61.8123017,
                31.1209832
              ],
              [
                61.8112185,
                31.1235054
              ],
              [
                61.8099187,
                31.1277336
              ],
              [
                61.8090521,
                31.1303669
              ],
              [
                61.8097454,
                31.1318133
              ],
              [
                61.8074924,
                31.1363378
              ],
              [
                61.8055426,
                31.1383404
              ],
              [
                61.8067125,
                31.140788
              ],
              [
                61.8072324,
                31.1427905
              ],
              [
                61.8064525,
                31.1439771
              ],
              [
                61.8060626,
                31.1450525
              ],
              [
                61.8034196,
                31.1452009
              ],
              [
                61.8030296,
                31.1464987
              ],
              [
                61.8035062,
                31.1482786
              ],
              [
                61.8023364,
                31.1504664
              ],
              [
                61.8027697,
                31.1530249
              ],
              [
                61.8043295,
                31.1539148
              ],
              [
                61.8038095,
                31.1547676
              ],
              [
                61.8048494,
                31.1577338
              ],
              [
                61.8063658,
                31.1598101
              ],
              [
                61.8059326,
                31.160255
              ],
              [
                61.8047627,
                31.1611448
              ],
              [
                61.8045894,
                31.1630357
              ],
              [
                61.8045461,
                31.1657792
              ],
              [
                61.8035929,
                31.1678182
              ],
              [
                61.8019898,
                31.1685968
              ],
              [
                61.8012532,
                31.1694124
              ],
              [
                61.8003867,
                31.1700797
              ],
              [
                61.7993901,
                31.1727489
              ],
              [
                61.797917,
                31.1737868
              ],
              [
                61.7983936,
                31.1743429
              ],
              [
                61.7981337,
                31.1751955
              ],
              [
                61.7971371,
                31.1755662
              ],
              [
                61.7968772,
                31.1764559
              ],
              [
                61.7960539,
                31.1776792
              ],
              [
                61.7964439,
                31.1796809
              ],
              [
                61.7952741,
                31.1809413
              ],
              [
                61.7953174,
                31.1819792
              ],
              [
                61.7944508,
                31.1822016
              ],
              [
                61.793411,
                31.1841661
              ],
              [
                61.7921978,
                31.1850928
              ],
              [
                61.7921112,
                31.1859453
              ],
              [
                61.7918079,
                31.1868349
              ],
              [
                61.7918079,
                31.187428
              ],
              [
                61.7893382,
                31.1894295
              ],
              [
                61.7889049,
                31.1907638
              ],
              [
                61.7889916,
                31.1920981
              ],
              [
                61.7879084,
                31.1945072
              ],
              [
                61.785872,
                31.1959156
              ],
              [
                61.7850488,
                31.1960638
              ],
              [
                61.7845289,
                31.1965456
              ],
              [
                61.7827525,
                31.1968421
              ],
              [
                61.7827091,
                31.1983246
              ],
              [
                61.7812793,
                31.1999553
              ],
              [
                61.7791563,
                31.2001406
              ],
              [
                61.7785064,
                31.2007706
              ],
              [
                61.7778565,
                31.20103
              ],
              [
                61.7773263,
                31.2018654
              ],
              [
                61.7763102,
                31.2028123
              ],
              [
                61.7743605,
                31.2047024
              ],
              [
                61.7723241,
                31.2056659
              ],
              [
                61.7716308,
                31.2062588
              ],
              [
                61.7715009,
                31.2075929
              ],
              [
                61.772584,
                31.2097052
              ],
              [
                61.7742305,
                31.2110763
              ],
              [
                61.7743171,
                31.2131514
              ],
              [
                61.7758336,
                31.2130773
              ],
              [
                61.7768518,
                31.2139204
              ],
              [
                61.7742169,
                31.2284074
              ],
              [
                61.770859,
                31.2450557
              ],
              [
                61.7699058,
                31.2508516
              ],
              [
                61.7741193,
                31.2654263
              ],
              [
                61.7783849,
                31.3022694
              ],
              [
                61.770556,
                31.311667
              ],
              [
                61.7204513,
                31.3619052
              ],
              [
                61.7066673,
                31.375896
              ],
              [
                61.6986172,
                31.3769348
              ],
              [
                61.6062448,
                31.3888541
              ],
              [
                61.5714213,
                31.3942331
              ],
              [
                61.4515282,
                31.4094941
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555275,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چابهار",
          "name:en": "Chabahar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278148",
          "wikipedia": "en:Chabahar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.5236134,
                25.0742948
              ],
              [
                60.5765756,
                25.0727683
              ],
              [
                60.9558293,
                24.9721656
              ],
              [
                60.9426132,
                25.2238437
              ],
              [
                60.9707995,
                25.234538
              ],
              [
                60.9958642,
                25.2436581
              ],
              [
                61.0002649,
                25.245555
              ],
              [
                61.0020899,
                25.2448674
              ],
              [
                61.0086286,
                25.2483918
              ],
              [
                61.0134684,
                25.2537144
              ],
              [
                61.0149304,
                25.2545181
              ],
              [
                61.0188075,
                25.2593796
              ],
              [
                61.0223868,
                25.263407
              ],
              [
                61.0254771,
                25.2686566
              ],
              [
                61.0264911,
                25.278146
              ],
              [
                61.0254717,
                25.2815675
              ],
              [
                61.0233716,
                25.2813233
              ],
              [
                61.0177441,
                25.278121
              ],
              [
                61.013378,
                25.2766734
              ],
              [
                61.0093999,
                25.2766734
              ],
              [
                61.0069258,
                25.2779894
              ],
              [
                61.0059555,
                25.2802267
              ],
              [
                61.0068288,
                25.2825516
              ],
              [
                61.0102246,
                25.2854905
              ],
              [
                61.0169679,
                25.2928596
              ],
              [
                61.0221591,
                25.2980837
              ],
              [
                61.0246329,
                25.3015001
              ],
              [
                61.0272618,
                25.3040047
              ],
              [
                61.0323464,
                25.3057543
              ],
              [
                61.0360819,
                25.3077279
              ],
              [
                61.0436499,
                25.307991
              ],
              [
                61.0469002,
                25.3074648
              ],
              [
                61.0492774,
                25.3083419
              ],
              [
                61.0502476,
                25.3096137
              ],
              [
                61.0509802,
                25.3125218
              ],
              [
                61.0485459,
                25.3191059
              ],
              [
                61.0392694,
                25.3291335
              ],
              [
                61.0354179,
                25.3357688
              ],
              [
                61.0331226,
                25.3432466
              ],
              [
                61.0329771,
                25.3463156
              ],
              [
                61.0337048,
                25.3499545
              ],
              [
                61.0354998,
                25.3542947
              ],
              [
                61.0457359,
                25.3705582
              ],
              [
                61.0452508,
                25.3726622
              ],
              [
                61.0436984,
                25.3746785
              ],
              [
                61.0416123,
                25.375862
              ],
              [
                61.0401529,
                25.3755107
              ],
              [
                60.9922993,
                25.3678495
              ],
              [
                60.9868884,
                25.3683935
              ],
              [
                60.9824083,
                25.3697537
              ],
              [
                60.9776488,
                25.37289
              ],
              [
                60.972529,
                25.3777089
              ],
              [
                60.9695256,
                25.3843167
              ],
              [
                60.9654883,
                25.3984262
              ],
              [
                60.9632858,
                25.4113695
              ],
              [
                60.9632744,
                25.4191023
              ],
              [
                60.9654883,
                25.4291906
              ],
              [
                60.9724169,
                25.440741
              ],
              [
                60.9759497,
                25.447836
              ],
              [
                60.9759975,
                25.4532383
              ],
              [
                60.9748334,
                25.4625073
              ],
              [
                60.9751984,
                25.4671295
              ],
              [
                60.9785421,
                25.4738564
              ],
              [
                60.9782847,
                25.482855
              ],
              [
                60.9738989,
                25.4918403
              ],
              [
                60.9700304,
                25.5033169
              ],
              [
                60.9672299,
                25.5013132
              ],
              [
                60.9635639,
                25.5028621
              ],
              [
                60.9584998,
                25.5041016
              ],
              [
                60.9560966,
                25.5042565
              ],
              [
                60.9494018,
                25.5051861
              ],
              [
                60.9386729,
                25.5072002
              ],
              [
                60.9274903,
                25.510855
              ],
              [
                60.9270429,
                25.5135908
              ],
              [
                60.9277296,
                25.5159921
              ],
              [
                60.9291887,
                25.5181222
              ],
              [
                60.9360122,
                25.5228471
              ],
              [
                60.9381151,
                25.5250545
              ],
              [
                60.9398746,
                25.5286561
              ],
              [
                60.9458693,
                25.5300375
              ],
              [
                60.9656416,
                25.5308652
              ],
              [
                60.9724192,
                25.5307273
              ],
              [
                60.9818467,
                25.5321987
              ],
              [
                60.999605,
                25.5345852
              ],
              [
                61.0070858,
                25.5363346
              ],
              [
                61.0356988,
                25.545782
              ],
              [
                61.0595921,
                25.554943
              ],
              [
                61.062925,
                25.5557766
              ],
              [
                61.0808547,
                25.5458559
              ],
              [
                61.0825211,
                25.5458559
              ],
              [
                61.0836282,
                25.5461338
              ],
              [
                61.0841884,
                25.5458559
              ],
              [
                61.0852946,
                25.5461338
              ],
              [
                61.0858548,
                25.5458559
              ],
              [
                61.0908548,
                25.5458558
              ],
              [
                61.091408,
                25.545578
              ],
              [
                61.0958542,
                25.5455779
              ],
              [
                61.0969612,
                25.5458559
              ],
              [
                61.097794,
                25.5455779
              ],
              [
                61.0989081,
                25.5458559
              ],
              [
                61.1078012,
                25.5458558
              ],
              [
                61.1091881,
                25.5461337
              ],
              [
                61.1116873,
                25.5461337
              ],
              [
                61.1158545,
                25.5466895
              ],
              [
                61.1183537,
                25.5466895
              ],
              [
                61.120021,
                25.5469674
              ],
              [
                61.1222405,
                25.5469674
              ],
              [
                61.1236343,
                25.5472453
              ],
              [
                61.1258539,
                25.5472453
              ],
              [
                61.1275203,
                25.5475232
              ],
              [
                61.1347407,
                25.5475232
              ],
              [
                61.1364072,
                25.5478011
              ],
              [
                61.1405736,
                25.5478011
              ],
              [
                61.1414073,
                25.5480791
              ],
              [
                61.1486339,
                25.548079
              ],
              [
                61.1497473,
                25.5478011
              ],
              [
                61.1514137,
                25.5478011
              ],
              [
                61.1544668,
                25.5472452
              ],
              [
                61.1561332,
                25.5472453
              ],
              [
                61.1572465,
                25.5469673
              ],
              [
                61.1586333,
                25.5469674
              ],
              [
                61.1597466,
                25.5466894
              ],
              [
                61.1622466,
                25.5466894
              ],
              [
                61.1658529,
                25.5461336
              ],
              [
                61.1702999,
                25.5452998
              ],
              [
                61.1739132,
                25.5450219
              ],
              [
                61.1753,
                25.5450219
              ],
              [
                61.1766867,
                25.544744
              ],
              [
                61.1786329,
                25.5447441
              ],
              [
                61.2233593,
                25.5255775
              ],
              [
                61.2255789,
                25.5255775
              ],
              [
                61.226139,
                25.5252996
              ],
              [
                61.2275258,
                25.5252996
              ],
              [
                61.2275258,
                25.5250217
              ],
              [
                61.2280789,
                25.5250217
              ],
              [
                61.228639,
                25.5247438
              ],
              [
                61.2294718,
                25.5247438
              ],
              [
                61.2297453,
                25.5244659
              ],
              [
                61.2308586,
                25.5244658
              ],
              [
                61.2314117,
                25.524188
              ],
              [
                61.2319719,
                25.5239101
              ],
              [
                61.2319719,
                25.5247437
              ],
              [
                61.2322453,
                25.5250216
              ],
              [
                61.2364118,
                25.541409
              ],
              [
                61.2489121,
                25.5616876
              ],
              [
                61.2641914,
                25.5739072
              ],
              [
                61.2650249,
                25.574194
              ],
              [
                61.2716915,
                25.5808553
              ],
              [
                61.2722516,
                25.581967
              ],
              [
                61.2728048,
                25.5825229
              ],
              [
                61.2780846,
                25.5961327
              ],
              [
                61.2786386,
                25.6003018
              ],
              [
                61.2797519,
                25.6075283
              ],
              [
                61.280305,
                25.6100298
              ],
              [
                61.2822519,
                25.619749
              ],
              [
                61.282252,
                25.6228066
              ],
              [
                61.2808582,
                25.6364175
              ],
              [
                61.2805848,
                25.6377984
              ],
              [
                61.2808582,
                25.6511317
              ],
              [
                61.2811388,
                25.6516877
              ],
              [
                61.2814184,
                25.6555792
              ],
              [
                61.2814184,
                25.6572471
              ],
              [
                61.2814185,
                25.6600268
              ],
              [
                61.2816919,
                25.6608607
              ],
              [
                61.2819716,
                25.6630845
              ],
              [
                61.2822521,
                25.6647434
              ],
              [
                61.2819717,
                25.6678012
              ],
              [
                61.2803052,
                25.6744637
              ],
              [
                61.2797521,
                25.6814133
              ],
              [
                61.274192,
                25.7139209
              ],
              [
                61.2736388,
                25.7144679
              ],
              [
                61.2722521,
                25.719194
              ],
              [
                61.3010912,
                25.7982885
              ],
              [
                61.2855583,
                25.7916739
              ],
              [
                61.2724067,
                25.7838153
              ],
              [
                61.2529908,
                25.7817285
              ],
              [
                61.2325315,
                25.7984739
              ],
              [
                61.2314182,
                25.7987517
              ],
              [
                61.2289182,
                25.7987517
              ],
              [
                61.2278048,
                25.7990295
              ],
              [
                61.2253048,
                25.7990295
              ],
              [
                61.2241985,
                25.7993072
              ],
              [
                61.2225321,
                25.7993072
              ],
              [
                61.2214188,
                25.799585
              ],
              [
                61.2180852,
                25.7995851
              ],
              [
                61.2172515,
                25.7998629
              ],
              [
                61.215032,
                25.7998629
              ],
              [
                61.2141921,
                25.8001407
              ],
              [
                61.2116921,
                25.8001406
              ],
              [
                61.2108585,
                25.8004185
              ],
              [
                61.2097523,
                25.8004185
              ],
              [
                61.2089186,
                25.8006962
              ],
              [
                61.2069717,
                25.8006962
              ],
              [
                61.2064186,
                25.8009739
              ],
              [
                61.2047521,
                25.8009739
              ],
              [
                61.2036389,
                25.8012518
              ],
              [
                61.1986388,
                25.8012518
              ],
              [
                61.197252,
                25.8015296
              ],
              [
                61.1950254,
                25.8015296
              ],
              [
                61.1766923,
                25.8054096
              ],
              [
                61.1753057,
                25.8056964
              ],
              [
                61.0616607,
                25.7390496
              ],
              [
                61.0437115,
                25.7371532
              ],
              [
                61.0314812,
                25.7377958
              ],
              [
                60.9996676,
                25.7378329
              ],
              [
                60.9902234,
                25.7424169
              ],
              [
                60.9791777,
                25.7499684
              ],
              [
                60.9742066,
                25.7519439
              ],
              [
                60.9537863,
                25.7665136
              ],
              [
                60.9374657,
                25.7751557
              ],
              [
                60.9205424,
                25.7792397
              ],
              [
                60.912236,
                25.7802493
              ],
              [
                60.9032162,
                25.7796986
              ],
              [
                60.8980183,
                25.7779549
              ],
              [
                60.8935338,
                25.7762111
              ],
              [
                60.8868581,
                25.777083
              ],
              [
                60.8784648,
                25.7765143
              ],
              [
                60.8591926,
                25.7732891
              ],
              [
                60.844498,
                25.7786209
              ],
              [
                60.8381408,
                25.7833237
              ],
              [
                60.8317199,
                25.7850674
              ],
              [
                60.8206107,
                25.7857098
              ],
              [
                60.8070555,
                25.7841497
              ],
              [
                60.7941117,
                25.7766242
              ],
              [
                60.7805565,
                25.7645089
              ],
              [
                60.7693454,
                25.7629485
              ],
              [
                60.7505923,
                25.7639582
              ],
              [
                60.7398908,
                25.755697
              ],
              [
                60.7315334,
                25.745691
              ],
              [
                60.7179571,
                25.7312139
              ],
              [
                60.7142903,
                25.7251112
              ],
              [
                60.7090603,
                25.7124541
              ],
              [
                60.7038571,
                25.7049704
              ],
              [
                60.7028784,
                25.7013028
              ],
              [
                60.7034038,
                25.6995517
              ],
              [
                60.6960147,
                25.6916534
              ],
              [
                60.6904701,
                25.6869762
              ],
              [
                60.6848036,
                25.6843976
              ],
              [
                60.6801663,
                25.680448
              ],
              [
                60.6759366,
                25.672181
              ],
              [
                60.6680379,
                25.6620303
              ],
              [
                60.663237,
                25.6586244
              ],
              [
                60.6722165,
                25.6546808
              ],
              [
                60.6774144,
                25.6537621
              ],
              [
                60.6818988,
                25.6515571
              ],
              [
                60.693008,
                25.6422774
              ],
              [
                60.7148187,
                25.6292296
              ],
              [
                60.7274567,
                25.620132
              ],
              [
                60.7412157,
                25.6034053
              ],
              [
                60.7468213,
                25.5970632
              ],
              [
                60.753682,
                25.5920726
              ],
              [
                60.7598669,
                25.5886986
              ],
              [
                60.7650631,
                25.5849155
              ],
              [
                60.7598021,
                25.5800773
              ],
              [
                60.7553267,
                25.57763
              ],
              [
                60.7502937,
                25.5771893
              ],
              [
                60.7484502,
                25.5785895
              ],
              [
                60.7426287,
                25.5776269
              ],
              [
                60.7322529,
                25.5742616
              ],
              [
                60.7268811,
                25.5740866
              ],
              [
                60.7195366,
                25.5776269
              ],
              [
                60.7147405,
                25.5785096
              ],
              [
                60.7066485,
                25.5777221
              ],
              [
                60.7013929,
                25.5757015
              ],
              [
                60.6970536,
                25.5721932
              ],
              [
                60.6922872,
                25.5716885
              ],
              [
                60.6858259,
                25.5734263
              ],
              [
                60.6799478,
                25.5713258
              ],
              [
                60.6739347,
                25.5711504
              ],
              [
                60.663553,
                25.5718506
              ],
              [
                60.6538505,
                25.567562
              ],
              [
                60.6504546,
                25.5643235
              ],
              [
                60.6455766,
                25.557943
              ],
              [
                60.6456033,
                25.5564459
              ],
              [
                60.6436628,
                25.5530321
              ],
              [
                60.6402669,
                25.549268
              ],
              [
                60.6360948,
                25.5468169
              ],
              [
                60.6322138,
                25.5432277
              ],
              [
                60.6312435,
                25.5388506
              ],
              [
                60.6306976,
                25.530159
              ],
              [
                60.6305644,
                25.5265936
              ],
              [
                60.6279447,
                25.5215153
              ],
              [
                60.6260042,
                25.518013
              ],
              [
                60.6180711,
                25.5097733
              ],
              [
                60.6081848,
                25.5035459
              ],
              [
                60.5964392,
                25.5002004
              ],
              [
                60.5874555,
                25.4958943
              ],
              [
                60.5809206,
                25.4891031
              ],
              [
                60.5798915,
                25.4855629
              ],
              [
                60.5809594,
                25.4801005
              ],
              [
                60.5818074,
                25.4768525
              ],
              [
                60.5823886,
                25.4679516
              ],
              [
                60.5828298,
                25.4576069
              ],
              [
                60.5823428,
                25.4517113
              ],
              [
                60.5780736,
                25.4389198
              ],
              [
                60.5747358,
                25.4326319
              ],
              [
                60.5350651,
                25.3527926
              ],
              [
                60.5323649,
                25.2849915
              ],
              [
                60.5236134,
                25.0742948
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555429,
        "tags": {
          "admin_level": "5",
          "alt_name": "شهرستان جالق",
          "boundary": "administrative",
          "name": "شهرستان گلشن",
          "name:ar": "ناحية جالق",
          "name:en": "Golshan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q105916280"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                62.0483837,
                27.8843819
              ],
              [
                62.0706936,
                27.8578972
              ],
              [
                62.1012494,
                27.8478801
              ],
              [
                62.1451947,
                27.8348261
              ],
              [
                62.1894833,
                27.823896
              ],
              [
                62.211456,
                27.8093207
              ],
              [
                62.2440716,
                27.7886692
              ],
              [
                62.2804638,
                27.7637606
              ],
              [
                62.3014065,
                27.7467466
              ],
              [
                62.3233792,
                27.7297299
              ],
              [
                62.3618313,
                27.7063276
              ],
              [
                62.3917004,
                27.6841364
              ],
              [
                62.4267193,
                27.659508
              ],
              [
                62.4830243,
                27.6211862
              ],
              [
                62.533836,
                27.5904582
              ],
              [
                62.5703464,
                27.5724252
              ],
              [
                62.5682275,
                27.5671118
              ],
              [
                62.5652896,
                27.5606486
              ],
              [
                62.5607748,
                27.5506956
              ],
              [
                62.552761,
                27.5324754
              ],
              [
                62.5520362,
                27.5181761
              ],
              [
                62.5532498,
                27.5012549
              ],
              [
                62.5446509,
                27.4823853
              ],
              [
                62.5228497,
                27.4534466
              ],
              [
                62.5116626,
                27.4308368
              ],
              [
                62.4769719,
                27.3814987
              ],
              [
                62.5016047,
                27.3533267
              ],
              [
                62.5604061,
                27.3124439
              ],
              [
                62.5760094,
                27.2953927
              ],
              [
                62.5858009,
                27.2897436
              ],
              [
                62.6026011,
                27.2811227
              ],
              [
                62.6246451,
                27.273551
              ],
              [
                62.6404379,
                27.2647011
              ],
              [
                62.6515959,
                27.2558506
              ],
              [
                62.6589568,
                27.248305
              ],
              [
                62.6623708,
                27.2471651
              ],
              [
                62.6721525,
                27.2410089
              ],
              [
                62.6864609,
                27.2342935
              ],
              [
                62.6943097,
                27.2319314
              ],
              [
                62.701148,
                27.2315
              ],
              [
                62.7083097,
                27.2314433
              ],
              [
                62.7103852,
                27.2314269
              ],
              [
                62.7250966,
                27.2316448
              ],
              [
                62.7402308,
                27.2311868
              ],
              [
                62.7509045,
                27.2307477
              ],
              [
                62.7621907,
                27.2317962
              ],
              [
                62.7769609,
                27.2320374
              ],
              [
                62.7949457,
                27.22922
              ],
              [
                62.8100993,
                27.22505
              ],
              [
                62.810369,
                27.225245
              ],
              [
                62.810288,
                27.225382
              ],
              [
                62.810086,
                27.225484
              ],
              [
                62.810094,
                27.225529
              ],
              [
                62.810006,
                27.225548
              ],
              [
                62.809919,
                27.225682
              ],
              [
                62.810009,
                27.225953
              ],
              [
                62.810112,
                27.225963
              ],
              [
                62.809955,
                27.226126
              ],
              [
                62.810014,
                27.226306
              ],
              [
                62.809874,
                27.226351
              ],
              [
                62.809782,
                27.226574
              ],
              [
                62.809646,
                27.226658
              ],
              [
                62.809617,
                27.226859
              ],
              [
                62.809747,
                27.227028
              ],
              [
                62.809602,
                27.227195
              ],
              [
                62.809703,
                27.227298
              ],
              [
                62.809667,
                27.227428
              ],
              [
                62.809385,
                27.227557
              ],
              [
                62.80863,
                27.228375
              ],
              [
                62.808507,
                27.228423
              ],
              [
                62.808214,
                27.228443
              ],
              [
                62.808184,
                27.228506
              ],
              [
                62.808103,
                27.228497
              ],
              [
                62.808055,
                27.22864
              ],
              [
                62.807974,
                27.228719
              ],
              [
                62.80764,
                27.228932
              ],
              [
                62.807574,
                27.229178
              ],
              [
                62.807615,
                27.229186
              ],
              [
                62.807632,
                27.229346
              ],
              [
                62.807707,
                27.229463
              ],
              [
                62.807924,
                27.229612
              ],
              [
                62.807765,
                27.229811
              ],
              [
                62.807682,
                27.229838
              ],
              [
                62.807657,
                27.229901
              ],
              [
                62.807557,
                27.229922
              ],
              [
                62.807524,
                27.229982
              ],
              [
                62.807562,
                27.23009
              ],
              [
                62.807652,
                27.230168
              ],
              [
                62.807502,
                27.2302
              ],
              [
                62.807361,
                27.230307
              ],
              [
                62.807143,
                27.230243
              ],
              [
                62.807046,
                27.230321
              ],
              [
                62.806905,
                27.230317
              ],
              [
                62.806805,
                27.230562
              ],
              [
                62.806725,
                27.230513
              ],
              [
                62.806569,
                27.230567
              ],
              [
                62.806519,
                27.230634
              ],
              [
                62.805635,
                27.23049
              ],
              [
                62.805537,
                27.230501
              ],
              [
                62.80545,
                27.230589
              ],
              [
                62.805141,
                27.230738
              ],
              [
                62.804982,
                27.231091
              ],
              [
                62.805065,
                27.231133
              ],
              [
                62.805082,
                27.231328
              ],
              [
                62.805165,
                27.231423
              ],
              [
                62.805192,
                27.23176
              ],
              [
                62.805001,
                27.232033
              ],
              [
                62.805035,
                27.232121
              ],
              [
                62.804941,
                27.232357
              ],
              [
                62.804805,
                27.232508
              ],
              [
                62.804697,
                27.232483
              ],
              [
                62.804528,
                27.232536
              ],
              [
                62.804529,
                27.23261
              ],
              [
                62.804698,
                27.232747
              ],
              [
                62.804336,
                27.232786
              ],
              [
                62.804312,
                27.23285
              ],
              [
                62.80413,
                27.232895
              ],
              [
                62.80405,
                27.23299
              ],
              [
                62.803713,
                27.233041
              ],
              [
                62.803628,
                27.233004
              ],
              [
                62.803453,
                27.23302
              ],
              [
                62.803237,
                27.233112
              ],
              [
                62.803213,
                27.23321
              ],
              [
                62.803308,
                27.233313
              ],
              [
                62.803307,
                27.233408
              ],
              [
                62.803477,
                27.233561
              ],
              [
                62.803415,
                27.233664
              ],
              [
                62.803433,
                27.233975
              ],
              [
                62.80353,
                27.23413
              ],
              [
                62.803612,
                27.234133
              ],
              [
                62.803676,
                27.234259
              ],
              [
                62.803756,
                27.234295
              ],
              [
                62.803761,
                27.234428
              ],
              [
                62.803405,
                27.234458
              ],
              [
                62.80331,
                27.234558
              ],
              [
                62.803035,
                27.234641
              ],
              [
                62.803002,
                27.234691
              ],
              [
                62.802766,
                27.234785
              ],
              [
                62.802703,
                27.234879
              ],
              [
                62.802393,
                27.23497
              ],
              [
                62.80215,
                27.234923
              ],
              [
                62.802053,
                27.234954
              ],
              [
                62.801853,
                27.235089
              ],
              [
                62.801819,
                27.235247
              ],
              [
                62.801638,
                27.235397
              ],
              [
                62.801357,
                27.235396
              ],
              [
                62.801197,
                27.235322
              ],
              [
                62.800908,
                27.235392
              ],
              [
                62.800921,
                27.235168
              ],
              [
                62.800977,
                27.235104
              ],
              [
                62.800903,
                27.234934
              ],
              [
                62.800632,
                27.23488
              ],
              [
                62.800542,
                27.23479
              ],
              [
                62.800381,
                27.23473
              ],
              [
                62.800155,
                27.234509
              ],
              [
                62.799975,
                27.234517
              ],
              [
                62.79995,
                27.234466
              ],
              [
                62.799783,
                27.234464
              ],
              [
                62.799543,
                27.234392
              ],
              [
                62.799461,
                27.234525
              ],
              [
                62.799146,
                27.234539
              ],
              [
                62.799008,
                27.234705
              ],
              [
                62.798872,
                27.234774
              ],
              [
                62.79913,
                27.234985
              ],
              [
                62.799126,
                27.235259
              ],
              [
                62.799026,
                27.235673
              ],
              [
                62.799241,
                27.23576
              ],
              [
                62.799597,
                27.236039
              ],
              [
                62.799726,
                27.236208
              ],
              [
                62.800097,
                27.236509
              ],
              [
                62.800082,
                27.236557
              ],
              [
                62.800302,
                27.236639
              ],
              [
                62.80035,
                27.236708
              ],
              [
                62.800352,
                27.236862
              ],
              [
                62.800509,
                27.236948
              ],
              [
                62.800519,
                27.237148
              ],
              [
                62.800395,
                27.237247
              ],
              [
                62.800446,
                27.237341
              ],
              [
                62.800451,
                27.237538
              ],
              [
                62.800591,
                27.23762
              ],
              [
                62.800413,
                27.23795
              ],
              [
                62.80007,
                27.237832
              ],
              [
                62.800006,
                27.237772
              ],
              [
                62.799958,
                27.237837
              ],
              [
                62.799744,
                27.23777
              ],
              [
                62.799545,
                27.237783
              ],
              [
                62.799508,
                27.237827
              ],
              [
                62.79961,
                27.237935
              ],
              [
                62.799635,
                27.238175
              ],
              [
                62.799439,
                27.238326
              ],
              [
                62.799467,
                27.238436
              ],
              [
                62.799608,
                27.238596
              ],
              [
                62.799564,
                27.238823
              ],
              [
                62.799498,
                27.238922
              ],
              [
                62.799124,
                27.239058
              ],
              [
                62.799142,
                27.2391
              ],
              [
                62.799032,
                27.23917
              ],
              [
                62.7988,
                27.239245
              ],
              [
                62.798749,
                27.239298
              ],
              [
                62.798812,
                27.239488
              ],
              [
                62.798684,
                27.239693
              ],
              [
                62.798546,
                27.239711
              ],
              [
                62.798199,
                27.239892
              ],
              [
                62.798121,
                27.239894
              ],
              [
                62.797925,
                27.239711
              ],
              [
                62.797611,
                27.239776
              ],
              [
                62.79754,
                27.239876
              ],
              [
                62.797611,
                27.239955
              ],
              [
                62.797561,
                27.240076
              ],
              [
                62.79761,
                27.240149
              ],
              [
                62.797271,
                27.24032
              ],
              [
                62.797243,
                27.240389
              ],
              [
                62.797149,
                27.240419
              ],
              [
                62.797063,
                27.240586
              ],
              [
                62.796741,
                27.240832
              ],
              [
                62.796364,
                27.240738
              ],
              [
                62.796249,
                27.240787
              ],
              [
                62.796053,
                27.240648
              ],
              [
                62.79599,
                27.240681
              ],
              [
                62.795957,
                27.240609
              ],
              [
                62.795832,
                27.240616
              ],
              [
                62.795894,
                27.2408
              ],
              [
                62.7958,
                27.240894
              ],
              [
                62.795812,
                27.240933
              ],
              [
                62.796234,
                27.241168
              ],
              [
                62.796471,
                27.241741
              ],
              [
                62.796588,
                27.241865
              ],
              [
                62.796357,
                27.24208
              ],
              [
                62.796338,
                27.242188
              ],
              [
                62.796251,
                27.242256
              ],
              [
                62.796269,
                27.242312
              ],
              [
                62.796174,
                27.242334
              ],
              [
                62.796198,
                27.242624
              ],
              [
                62.796261,
                27.242647
              ],
              [
                62.795975,
                27.242973
              ],
              [
                62.795927,
                27.243227
              ],
              [
                62.795856,
                27.243294
              ],
              [
                62.79591,
                27.243467
              ],
              [
                62.79576,
                27.243706
              ],
              [
                62.79538,
                27.243954
              ],
              [
                62.795407,
                27.244192
              ],
              [
                62.795157,
                27.244472
              ],
              [
                62.79495,
                27.244481
              ],
              [
                62.794764,
                27.24456
              ],
              [
                62.794702,
                27.244607
              ],
              [
                62.794605,
                27.244846
              ],
              [
                62.794489,
                27.244878
              ],
              [
                62.793987,
                27.24489
              ],
              [
                62.793641,
                27.244954
              ],
              [
                62.79361,
                27.244867
              ],
              [
                62.793514,
                27.244842
              ],
              [
                62.79352,
                27.244777
              ],
              [
                62.793431,
                27.244732
              ],
              [
                62.793102,
                27.244769
              ],
              [
                62.793023,
                27.244821
              ],
              [
                62.79306,
                27.24488
              ],
              [
                62.792937,
                27.244971
              ],
              [
                62.792714,
                27.245264
              ],
              [
                62.792717,
                27.245334
              ],
              [
                62.792604,
                27.245368
              ],
              [
                62.792576,
                27.245437
              ],
              [
                62.792528,
                27.245415
              ],
              [
                62.792342,
                27.245487
              ],
              [
                62.792234,
                27.245631
              ],
              [
                62.791747,
                27.245608
              ],
              [
                62.791667,
                27.245658
              ],
              [
                62.791545,
                27.245613
              ],
              [
                62.791026,
                27.245688
              ],
              [
                62.790752,
                27.245754
              ],
              [
                62.790633,
                27.245896
              ],
              [
                62.790459,
                27.245941
              ],
              [
                62.790301,
                27.245872
              ],
              [
                62.789494,
                27.245802
              ],
              [
                62.789408,
                27.245882
              ],
              [
                62.789082,
                27.245987
              ],
              [
                62.788811,
                27.245964
              ],
              [
                62.788687,
                27.246074
              ],
              [
                62.788636,
                27.24619
              ],
              [
                62.788113,
                27.246598
              ],
              [
                62.788153,
                27.246712
              ],
              [
                62.788004,
                27.246915
              ],
              [
                62.787995,
                27.247069
              ],
              [
                62.787864,
                27.247104
              ],
              [
                62.787718,
                27.247076
              ],
              [
                62.787588,
                27.24763
              ],
              [
                62.787339,
                27.248004
              ],
              [
                62.78729,
                27.2482
              ],
              [
                62.786641,
                27.248786
              ],
              [
                62.786434,
                27.248854
              ],
              [
                62.786307,
                27.248997
              ],
              [
                62.7863,
                27.249369
              ],
              [
                62.786432,
                27.249651
              ],
              [
                62.786385,
                27.249742
              ],
              [
                62.786417,
                27.249823
              ],
              [
                62.786365,
                27.249925
              ],
              [
                62.786375,
                27.250055
              ],
              [
                62.78633,
                27.250043
              ],
              [
                62.786291,
                27.25074
              ],
              [
                62.786065,
                27.250772
              ],
              [
                62.785783,
                27.250929
              ],
              [
                62.785758,
                27.251001
              ],
              [
                62.78562,
                27.25105
              ],
              [
                62.785386,
                27.251345
              ],
              [
                62.785297,
                27.251381
              ],
              [
                62.785151,
                27.251676
              ],
              [
                62.784953,
                27.251773
              ],
              [
                62.784838,
                27.251957
              ],
              [
                62.784676,
                27.251996
              ],
              [
                62.784665,
                27.252317
              ],
              [
                62.784482,
                27.252558
              ],
              [
                62.784484,
                27.252677
              ],
              [
                62.784315,
                27.253174
              ],
              [
                62.783963,
                27.253147
              ],
              [
                62.783914,
                27.25326
              ],
              [
                62.783728,
                27.253322
              ],
              [
                62.783002,
                27.253212
              ],
              [
                62.782884,
                27.253261
              ],
              [
                62.782898,
                27.253309
              ],
              [
                62.782599,
                27.253358
              ],
              [
                62.782267,
                27.253288
              ],
              [
                62.78212,
                27.2533
              ],
              [
                62.781437,
                27.253029
              ],
              [
                62.781008,
                27.253143
              ],
              [
                62.780787,
                27.253139
              ],
              [
                62.780607,
                27.253081
              ],
              [
                62.780527,
                27.252886
              ],
              [
                62.780434,
                27.252918
              ],
              [
                62.780183,
                27.252903
              ],
              [
                62.780254,
                27.253092
              ],
              [
                62.77981,
                27.253198
              ],
              [
                62.779488,
                27.253094
              ],
              [
                62.779488,
                27.252938
              ],
              [
                62.77909,
                27.252935
              ],
              [
                62.778786,
                27.252842
              ],
              [
                62.77869,
                27.252744
              ],
              [
                62.778292,
                27.252721
              ],
              [
                62.778212,
                27.25273
              ],
              [
                62.778163,
                27.252978
              ],
              [
                62.778,
                27.253237
              ],
              [
                62.777806,
                27.253206
              ],
              [
                62.777759,
                27.253254
              ],
              [
                62.777529,
                27.25318
              ],
              [
                62.777317,
                27.253253
              ],
              [
                62.776993,
                27.253186
              ],
              [
                62.77679,
                27.253208
              ],
              [
                62.776645,
                27.253083
              ],
              [
                62.775572,
                27.252896
              ],
              [
                62.775662,
                27.253155
              ],
              [
                62.775614,
                27.253679
              ],
              [
                62.77566,
                27.253895
              ],
              [
                62.775539,
                27.254084
              ],
              [
                62.775236,
                27.254308
              ],
              [
                62.775284,
                27.254388
              ],
              [
                62.77526,
                27.254479
              ],
              [
                62.775326,
                27.25451
              ],
              [
                62.775601,
                27.255129
              ],
              [
                62.775583,
                27.255569
              ],
              [
                62.775786,
                27.2556
              ],
              [
                62.776172,
                27.255563
              ],
              [
                62.776202,
                27.256082
              ],
              [
                62.776018,
                27.256285
              ],
              [
                62.776169,
                27.256345
              ],
              [
                62.776161,
                27.256658
              ],
              [
                62.776483,
                27.256982
              ],
              [
                62.776692,
                27.257097
              ],
              [
                62.776705,
                27.257175
              ],
              [
                62.776826,
                27.257276
              ],
              [
                62.776615,
                27.257509
              ],
              [
                62.776544,
                27.257656
              ],
              [
                62.776634,
                27.257804
              ],
              [
                62.776567,
                27.257829
              ],
              [
                62.776564,
                27.257984
              ],
              [
                62.776304,
                27.258066
              ],
              [
                62.776143,
                27.258175
              ],
              [
                62.774933,
                27.258325
              ],
              [
                62.774976,
                27.25865
              ],
              [
                62.775181,
                27.258996
              ],
              [
                62.775253,
                27.259302
              ],
              [
                62.775166,
                27.25938
              ],
              [
                62.775235,
                27.259595
              ],
              [
                62.775186,
                27.259788
              ],
              [
                62.775284,
                27.259802
              ],
              [
                62.775278,
                27.26001
              ],
              [
                62.775375,
                27.260076
              ],
              [
                62.775419,
                27.26023
              ],
              [
                62.775583,
                27.26029
              ],
              [
                62.77559,
                27.260364
              ],
              [
                62.775878,
                27.260324
              ],
              [
                62.776179,
                27.260416
              ],
              [
                62.776478,
                27.260353
              ],
              [
                62.776623,
                27.260244
              ],
              [
                62.777019,
                27.260249
              ],
              [
                62.777266,
                27.260112
              ],
              [
                62.778015,
                27.260049
              ],
              [
                62.778195,
                27.259966
              ],
              [
                62.77873,
                27.260036
              ],
              [
                62.778922,
                27.259835
              ],
              [
                62.779015,
                27.259817
              ],
              [
                62.77906,
                27.259759
              ],
              [
                62.779474,
                27.259741
              ],
              [
                62.779589,
                27.25968
              ],
              [
                62.77975,
                27.259672
              ],
              [
                62.779779,
                27.259615
              ],
              [
                62.780636,
                27.2596
              ],
              [
                62.780828,
                27.259522
              ],
              [
                62.781304,
                27.259484
              ],
              [
                62.781363,
                27.259634
              ],
              [
                62.781606,
                27.259627
              ],
              [
                62.781748,
                27.25967
              ],
              [
                62.782212,
                27.259619
              ],
              [
                62.782694,
                27.259708
              ],
              [
                62.78274,
                27.259645
              ],
              [
                62.782853,
                27.259634
              ],
              [
                62.782827,
                27.259761
              ],
              [
                62.783198,
                27.25986
              ],
              [
                62.783246,
                27.260073
              ],
              [
                62.783515,
                27.259839
              ],
              [
                62.783853,
                27.259802
              ],
              [
                62.783981,
                27.259726
              ],
              [
                62.784124,
                27.25971
              ],
              [
                62.784301,
                27.259567
              ],
              [
                62.784565,
                27.259604
              ],
              [
                62.78454,
                27.259701
              ],
              [
                62.784572,
                27.259712
              ],
              [
                62.784836,
                27.259728
              ],
              [
                62.784968,
                27.259682
              ],
              [
                62.784993,
                27.259743
              ],
              [
                62.785094,
                27.259724
              ],
              [
                62.785193,
                27.259889
              ],
              [
                62.785522,
                27.259899
              ],
              [
                62.785632,
                27.259763
              ],
              [
                62.786161,
                27.25964
              ],
              [
                62.786622,
                27.259652
              ],
              [
                62.786742,
                27.259749
              ],
              [
                62.787067,
                27.259877
              ],
              [
                62.787345,
                27.259759
              ],
              [
                62.787501,
                27.259742
              ],
              [
                62.787612,
                27.259762
              ],
              [
                62.787581,
                27.259832
              ],
              [
                62.787679,
                27.259924
              ],
              [
                62.787844,
                27.259934
              ],
              [
                62.788283,
                27.260111
              ],
              [
                62.788702,
                27.260079
              ],
              [
                62.788772,
                27.26014
              ],
              [
                62.788871,
                27.260078
              ],
              [
                62.78907,
                27.260162
              ],
              [
                62.789232,
                27.260156
              ],
              [
                62.78928,
                27.260118
              ],
              [
                62.789614,
                27.260337
              ],
              [
                62.789809,
                27.260338
              ],
              [
                62.790124,
                27.260536
              ],
              [
                62.790239,
                27.260578
              ],
              [
                62.790353,
                27.26056
              ],
              [
                62.79025,
                27.260736
              ],
              [
                62.790474,
                27.260735
              ],
              [
                62.790642,
                27.260825
              ],
              [
                62.790962,
                27.260863
              ],
              [
                62.791142,
                27.261148
              ],
              [
                62.791422,
                27.26126
              ],
              [
                62.791808,
                27.26128
              ],
              [
                62.792092,
                27.261367
              ],
              [
                62.792496,
                27.261395
              ],
              [
                62.793328,
                27.261304
              ],
              [
                62.793634,
                27.261195
              ],
              [
                62.793963,
                27.261195
              ],
              [
                62.79407,
                27.261226
              ],
              [
                62.794167,
                27.261426
              ],
              [
                62.794344,
                27.261473
              ],
              [
                62.794517,
                27.261512
              ],
              [
                62.794775,
                27.261482
              ],
              [
                62.795178,
                27.261515
              ],
              [
                62.795327,
                27.261588
              ],
              [
                62.795472,
                27.261567
              ],
              [
                62.795558,
                27.261621
              ],
              [
                62.795622,
                27.261745
              ],
              [
                62.796102,
                27.261728
              ],
              [
                62.796236,
                27.261804
              ],
              [
                62.796799,
                27.261835
              ],
              [
                62.796973,
                27.261901
              ],
              [
                62.797049,
                27.261978
              ],
              [
                62.797257,
                27.261947
              ],
              [
                62.797338,
                27.261866
              ],
              [
                62.797601,
                27.261911
              ],
              [
                62.797679,
                27.261883
              ],
              [
                62.797967,
                27.261922
              ],
              [
                62.798175,
                27.261876
              ],
              [
                62.798291,
                27.261912
              ],
              [
                62.798409,
                27.261886
              ],
              [
                62.79856,
                27.261769
              ],
              [
                62.798934,
                27.26178
              ],
              [
                62.799186,
                27.261852
              ],
              [
                62.799483,
                27.262066
              ],
              [
                62.799704,
                27.262039
              ],
              [
                62.800045,
                27.262127
              ],
              [
                62.800112,
                27.262164
              ],
              [
                62.800087,
                27.262234
              ],
              [
                62.800407,
                27.26233
              ],
              [
                62.800578,
                27.262522
              ],
              [
                62.800866,
                27.262594
              ],
              [
                62.800943,
                27.262561
              ],
              [
                62.801209,
                27.26263
              ],
              [
                62.801484,
                27.262625
              ],
              [
                62.801985,
                27.262838
              ],
              [
                62.80227,
                27.262872
              ],
              [
                62.802553,
                27.262967
              ],
              [
                62.802959,
                27.262973
              ],
              [
                62.803808,
                27.263134
              ],
              [
                62.804119,
                27.263125
              ],
              [
                62.804207,
                27.263197
              ],
              [
                62.804956,
                27.263191
              ],
              [
                62.805043,
                27.263136
              ],
              [
                62.805568,
                27.263059
              ],
              [
                62.805844,
                27.26317
              ],
              [
                62.805978,
                27.263171
              ],
              [
                62.806455,
                27.262995
              ],
              [
                62.806688,
                27.263042
              ],
              [
                62.806895,
                27.263116
              ],
              [
                62.806896,
                27.263167
              ],
              [
                62.807103,
                27.263328
              ],
              [
                62.807142,
                27.263516
              ],
              [
                62.807393,
                27.263565
              ],
              [
                62.807543,
                27.26367
              ],
              [
                62.807648,
                27.263672
              ],
              [
                62.807693,
                27.263856
              ],
              [
                62.808287,
                27.263985
              ],
              [
                62.808199,
                27.264035
              ],
              [
                62.808679,
                27.264142
              ],
              [
                62.80882,
                27.264235
              ],
              [
                62.808998,
                27.264669
              ],
              [
                62.808947,
                27.265612
              ],
              [
                62.808886,
                27.265704
              ],
              [
                62.808838,
                27.265957
              ],
              [
                62.808627,
                27.266025
              ],
              [
                62.808606,
                27.266089
              ],
              [
                62.808479,
                27.266147
              ],
              [
                62.808475,
                27.266419
              ],
              [
                62.808281,
                27.266531
              ],
              [
                62.808265,
                27.266662
              ],
              [
                62.808126,
                27.266732
              ],
              [
                62.808445,
                27.267193
              ],
              [
                62.808874,
                27.267361
              ],
              [
                62.808979,
                27.2675
              ],
              [
                62.809155,
                27.267585
              ],
              [
                62.809231,
                27.26768
              ],
              [
                62.809185,
                27.26776
              ],
              [
                62.809294,
                27.267899
              ],
              [
                62.809242,
                27.267952
              ],
              [
                62.80943,
                27.26811
              ],
              [
                62.809458,
                27.268363
              ],
              [
                62.809659,
                27.268525
              ],
              [
                62.809618,
                27.26858
              ],
              [
                62.809673,
                27.268616
              ],
              [
                62.809458,
                27.268682
              ],
              [
                62.809376,
                27.268807
              ],
              [
                62.809133,
                27.268894
              ],
              [
                62.809001,
                27.269037
              ],
              [
                62.808968,
                27.269281
              ],
              [
                62.808742,
                27.269651
              ],
              [
                62.808924,
                27.269763
              ],
              [
                62.808813,
                27.269813
              ],
              [
                62.80885,
                27.27014
              ],
              [
                62.8086,
                27.270193
              ],
              [
                62.808528,
                27.270407
              ],
              [
                62.808835,
                27.271001
              ],
              [
                62.809418,
                27.271361
              ],
              [
                62.809347,
                27.271487
              ],
              [
                62.809115,
                27.271681
              ],
              [
                62.809104,
                27.271773
              ],
              [
                62.809177,
                27.271928
              ],
              [
                62.809124,
                27.272025
              ],
              [
                62.809262,
                27.272133
              ],
              [
                62.809352,
                27.2723
              ],
              [
                62.809312,
                27.272698
              ],
              [
                62.809698,
                27.272724
              ],
              [
                62.810009,
                27.273002
              ],
              [
                62.81022,
                27.273074
              ],
              [
                62.810516,
                27.273286
              ],
              [
                62.811036,
                27.273774
              ],
              [
                62.811104,
                27.273879
              ],
              [
                62.811071,
                27.273907
              ],
              [
                62.811126,
                27.274324
              ],
              [
                62.811199,
                27.274373
              ],
              [
                62.811129,
                27.274623
              ],
              [
                62.81117,
                27.274765
              ],
              [
                62.811303,
                27.27484
              ],
              [
                62.811606,
                27.274916
              ],
              [
                62.811895,
                27.274918
              ],
              [
                62.812205,
                27.275068
              ],
              [
                62.813024,
                27.275145
              ],
              [
                62.81307,
                27.275218
              ],
              [
                62.813684,
                27.275176
              ],
              [
                62.813964,
                27.275197
              ],
              [
                62.814186,
                27.275236
              ],
              [
                62.814317,
                27.275411
              ],
              [
                62.814522,
                27.275375
              ],
              [
                62.814308,
                27.275662
              ],
              [
                62.81424,
                27.275694
              ],
              [
                62.814165,
                27.276126
              ],
              [
                62.813993,
                27.276328
              ],
              [
                62.814059,
                27.276546
              ],
              [
                62.814029,
                27.276678
              ],
              [
                62.814713,
                27.276638
              ],
              [
                62.814777,
                27.276847
              ],
              [
                62.814894,
                27.276916
              ],
              [
                62.814862,
                27.27695
              ],
              [
                62.814928,
                27.277118
              ],
              [
                62.81492,
                27.277313
              ],
              [
                62.814754,
                27.277679
              ],
              [
                62.814776,
                27.277743
              ],
              [
                62.814852,
                27.277757
              ],
              [
                62.814729,
                27.27794
              ],
              [
                62.81463,
                27.277993
              ],
              [
                62.814635,
                27.278138
              ],
              [
                62.814781,
                27.278313
              ],
              [
                62.815502,
                27.278569
              ],
              [
                62.815843,
                27.27856
              ],
              [
                62.815969,
                27.278515
              ],
              [
                62.816105,
                27.27857
              ],
              [
                62.816264,
                27.278449
              ],
              [
                62.816633,
                27.278301
              ],
              [
                62.817037,
                27.278224
              ],
              [
                62.817163,
                27.278618
              ],
              [
                62.81707,
                27.27882
              ],
              [
                62.817166,
                27.278954
              ],
              [
                62.817133,
                27.279179
              ],
              [
                62.817264,
                27.279276
              ],
              [
                62.81728,
                27.279373
              ],
              [
                62.817157,
                27.279705
              ],
              [
                62.817072,
                27.279802
              ],
              [
                62.81707,
                27.279946
              ],
              [
                62.816952,
                27.280012
              ],
              [
                62.81682,
                27.280187
              ],
              [
                62.816687,
                27.280584
              ],
              [
                62.816606,
                27.280668
              ],
              [
                62.816383,
                27.280751
              ],
              [
                62.816023,
                27.280801
              ],
              [
                62.815964,
                27.280943
              ],
              [
                62.815747,
                27.281019
              ],
              [
                62.815683,
                27.281084
              ],
              [
                62.815709,
                27.28127
              ],
              [
                62.815618,
                27.281524
              ],
              [
                62.815354,
                27.281827
              ],
              [
                62.815233,
                27.281882
              ],
              [
                62.81517,
                27.282056
              ],
              [
                62.81504,
                27.282178
              ],
              [
                62.814252,
                27.282384
              ],
              [
                62.814095,
                27.282467
              ],
              [
                62.814011,
                27.282589
              ],
              [
                62.813988,
                27.282902
              ],
              [
                62.813915,
                27.283035
              ],
              [
                62.813957,
                27.28312
              ],
              [
                62.813706,
                27.283203
              ],
              [
                62.813606,
                27.2833
              ],
              [
                62.813607,
                27.283533
              ],
              [
                62.813507,
                27.283643
              ],
              [
                62.813471,
                27.283843
              ],
              [
                62.813473,
                27.284442
              ],
              [
                62.813516,
                27.284746
              ],
              [
                62.813597,
                27.284799
              ],
              [
                62.813592,
                27.284994
              ],
              [
                62.813682,
                27.285401
              ],
              [
                62.813669,
                27.285622
              ],
              [
                62.813798,
                27.285906
              ],
              [
                62.814052,
                27.28593
              ],
              [
                62.813958,
                27.286113
              ],
              [
                62.813976,
                27.286187
              ],
              [
                62.814128,
                27.286327
              ],
              [
                62.814273,
                27.286983
              ],
              [
                62.814448,
                27.287021
              ],
              [
                62.814833,
                27.287672
              ],
              [
                62.815386,
                27.287538
              ],
              [
                62.815473,
                27.287463
              ],
              [
                62.815641,
                27.287427
              ],
              [
                62.816178,
                27.288111
              ],
              [
                62.816455,
                27.287999
              ],
              [
                62.816611,
                27.288201
              ],
              [
                62.816763,
                27.288262
              ],
              [
                62.817104,
                27.288135
              ],
              [
                62.817387,
                27.288309
              ],
              [
                62.818092,
                27.288496
              ],
              [
                62.818109,
                27.28857
              ],
              [
                62.818222,
                27.288636
              ],
              [
                62.818147,
                27.288729
              ],
              [
                62.818142,
                27.288907
              ],
              [
                62.81797,
                27.288928
              ],
              [
                62.817878,
                27.289026
              ],
              [
                62.817915,
                27.289122
              ],
              [
                62.817681,
                27.289292
              ],
              [
                62.817487,
                27.289369
              ],
              [
                62.817541,
                27.289827
              ],
              [
                62.817476,
                27.289921
              ],
              [
                62.817281,
                27.290023
              ],
              [
                62.816995,
                27.290449
              ],
              [
                62.816785,
                27.29058
              ],
              [
                62.816731,
                27.290702
              ],
              [
                62.816814,
                27.290902
              ],
              [
                62.816993,
                27.291061
              ],
              [
                62.817152,
                27.291096
              ],
              [
                62.817526,
                27.291303
              ],
              [
                62.817569,
                27.291588
              ],
              [
                62.817452,
                27.291738
              ],
              [
                62.817567,
                27.291947
              ],
              [
                62.817466,
                27.292026
              ],
              [
                62.817663,
                27.292244
              ],
              [
                62.817403,
                27.292397
              ],
              [
                62.817324,
                27.292387
              ],
              [
                62.81712,
                27.292469
              ],
              [
                62.817084,
                27.292573
              ],
              [
                62.816963,
                27.292658
              ],
              [
                62.816699,
                27.292762
              ],
              [
                62.816622,
                27.292848
              ],
              [
                62.816741,
                27.292938
              ],
              [
                62.816789,
                27.293141
              ],
              [
                62.816675,
                27.293269
              ],
              [
                62.816855,
                27.293391
              ],
              [
                62.81692,
                27.293512
              ],
              [
                62.817098,
                27.293656
              ],
              [
                62.817047,
                27.293803
              ],
              [
                62.817226,
                27.293891
              ],
              [
                62.817169,
                27.293999
              ],
              [
                62.817202,
                27.294201
              ],
              [
                62.817631,
                27.294304
              ],
              [
                62.817934,
                27.29429
              ],
              [
                62.818012,
                27.29439
              ],
              [
                62.818125,
                27.294409
              ],
              [
                62.818507,
                27.294302
              ],
              [
                62.818699,
                27.294486
              ],
              [
                62.818948,
                27.294561
              ],
              [
                62.819,
                27.294751
              ],
              [
                62.81937,
                27.294915
              ],
              [
                62.820464,
                27.294656
              ],
              [
                62.820685,
                27.294761
              ],
              [
                62.820729,
                27.294899
              ],
              [
                62.820847,
                27.294879
              ],
              [
                62.820981,
                27.295016
              ],
              [
                62.821078,
                27.295207
              ],
              [
                62.821116,
                27.295659
              ],
              [
                62.821259,
                27.295669
              ],
              [
                62.821386,
                27.295595
              ],
              [
                62.821766,
                27.295644
              ],
              [
                62.821889,
                27.29583
              ],
              [
                62.822257,
                27.295844
              ],
              [
                62.822185,
                27.295967
              ],
              [
                62.822386,
                27.296677
              ],
              [
                62.822529,
                27.2969
              ],
              [
                62.822585,
                27.297214
              ],
              [
                62.822712,
                27.297321
              ],
              [
                62.822812,
                27.297317
              ],
              [
                62.822933,
                27.297388
              ],
              [
                62.823101,
                27.297899
              ],
              [
                62.823059,
                27.298072
              ],
              [
                62.823786,
                27.298155
              ],
              [
                62.82381,
                27.298197
              ],
              [
                62.824083,
                27.298282
              ],
              [
                62.824135,
                27.298382
              ],
              [
                62.824265,
                27.298426
              ],
              [
                62.824451,
                27.298602
              ],
              [
                62.824446,
                27.298719
              ],
              [
                62.824626,
                27.298825
              ],
              [
                62.824803,
                27.299191
              ],
              [
                62.824594,
                27.299237
              ],
              [
                62.824591,
                27.299315
              ],
              [
                62.824462,
                27.299396
              ],
              [
                62.824394,
                27.299518
              ],
              [
                62.824008,
                27.299579
              ],
              [
                62.823744,
                27.299942
              ],
              [
                62.8236,
                27.300325
              ],
              [
                62.823408,
                27.300489
              ],
              [
                62.823491,
                27.300595
              ],
              [
                62.82336,
                27.300652
              ],
              [
                62.823335,
                27.300747
              ],
              [
                62.823405,
                27.300886
              ],
              [
                62.823117,
                27.300951
              ],
              [
                62.822849,
                27.300933
              ],
              [
                62.822682,
                27.301002
              ],
              [
                62.822514,
                27.301253
              ],
              [
                62.822324,
                27.301367
              ],
              [
                62.822361,
                27.301566
              ],
              [
                62.821693,
                27.301737
              ],
              [
                62.821845,
                27.302485
              ],
              [
                62.822264,
                27.303248
              ],
              [
                62.822247,
                27.303526
              ],
              [
                62.822174,
                27.303596
              ],
              [
                62.822439,
                27.303682
              ],
              [
                62.822538,
                27.303795
              ],
              [
                62.822601,
                27.304182
              ],
              [
                62.82285,
                27.304472
              ],
              [
                62.822793,
                27.304792
              ],
              [
                62.823132,
                27.304868
              ],
              [
                62.82336,
                27.304977
              ],
              [
                62.823418,
                27.305162
              ],
              [
                62.823505,
                27.305258
              ],
              [
                62.823754,
                27.305306
              ],
              [
                62.823872,
                27.305404
              ],
              [
                62.823929,
                27.305571
              ],
              [
                62.82388,
                27.305848
              ],
              [
                62.824355,
                27.305936
              ],
              [
                62.82507,
                27.306667
              ],
              [
                62.825205,
                27.306872
              ],
              [
                62.825166,
                27.30712
              ],
              [
                62.82464,
                27.307657
              ],
              [
                62.824659,
                27.3078
              ],
              [
                62.825369,
                27.308251
              ],
              [
                62.825465,
                27.308701
              ],
              [
                62.82581,
                27.308926
              ],
              [
                62.825991,
                27.309156
              ],
              [
                62.826224,
                27.309636
              ],
              [
                62.826318,
                27.309987
              ],
              [
                62.82601,
                27.310042
              ],
              [
                62.825939,
                27.310015
              ],
              [
                62.825516,
                27.310105
              ],
              [
                62.825283,
                27.310234
              ],
              [
                62.824989,
                27.310209
              ],
              [
                62.824849,
                27.310367
              ],
              [
                62.824379,
                27.310544
              ],
              [
                62.824245,
                27.310847
              ],
              [
                62.824047,
                27.310987
              ],
              [
                62.823857,
                27.310977
              ],
              [
                62.823645,
                27.31107
              ],
              [
                62.823338,
                27.31107
              ],
              [
                62.822854,
                27.311237
              ],
              [
                62.822292,
                27.311194
              ],
              [
                62.821948,
                27.311281
              ],
              [
                62.821557,
                27.311231
              ],
              [
                62.821369,
                27.311442
              ],
              [
                62.821026,
                27.311545
              ],
              [
                62.820314,
                27.311465
              ],
              [
                62.820095,
                27.311485
              ],
              [
                62.819901,
                27.311397
              ],
              [
                62.819424,
                27.311394
              ],
              [
                62.819341,
                27.311457
              ],
              [
                62.819324,
                27.311566
              ],
              [
                62.819151,
                27.311677
              ],
              [
                62.818878,
                27.311679
              ],
              [
                62.8186,
                27.311754
              ],
              [
                62.818353,
                27.311764
              ],
              [
                62.818147,
                27.311915
              ],
              [
                62.818012,
                27.311876
              ],
              [
                62.817794,
                27.311948
              ],
              [
                62.817667,
                27.312141
              ],
              [
                62.817582,
                27.312544
              ],
              [
                62.81746,
                27.312808
              ],
              [
                62.817114,
                27.313083
              ],
              [
                62.817317,
                27.313119
              ],
              [
                62.817281,
                27.313132
              ],
              [
                62.817514,
                27.313659
              ],
              [
                62.817511,
                27.313859
              ],
              [
                62.817451,
                27.313989
              ],
              [
                62.817628,
                27.314033
              ],
              [
                62.817569,
                27.314166
              ],
              [
                62.817586,
                27.314238
              ],
              [
                62.817728,
                27.314348
              ],
              [
                62.818049,
                27.314365
              ],
              [
                62.818089,
                27.31441
              ],
              [
                62.817968,
                27.314526
              ],
              [
                62.81815,
                27.314667
              ],
              [
                62.818144,
                27.314734
              ],
              [
                62.81799,
                27.315016
              ],
              [
                62.818038,
                27.315258
              ],
              [
                62.817984,
                27.315354
              ],
              [
                62.817897,
                27.315396
              ],
              [
                62.817694,
                27.315363
              ],
              [
                62.817739,
                27.315523
              ],
              [
                62.817822,
                27.315597
              ],
              [
                62.817669,
                27.315639
              ],
              [
                62.817809,
                27.315834
              ],
              [
                62.817696,
                27.316074
              ],
              [
                62.817521,
                27.31611
              ],
              [
                62.817525,
                27.316156
              ],
              [
                62.817328,
                27.316241
              ],
              [
                62.81734,
                27.316369
              ],
              [
                62.817286,
                27.316505
              ],
              [
                62.816998,
                27.3166
              ],
              [
                62.816496,
                27.316643
              ],
              [
                62.816363,
                27.316615
              ],
              [
                62.816092,
                27.31666
              ],
              [
                62.815986,
                27.316656
              ],
              [
                62.815863,
                27.316576
              ],
              [
                62.815317,
                27.316509
              ],
              [
                62.814847,
                27.316642
              ],
              [
                62.814529,
                27.316565
              ],
              [
                62.814187,
                27.316571
              ],
              [
                62.814156,
                27.316652
              ],
              [
                62.813788,
                27.316894
              ],
              [
                62.813478,
                27.316834
              ],
              [
                62.813226,
                27.316854
              ],
              [
                62.813138,
                27.316815
              ],
              [
                62.812734,
                27.316938
              ],
              [
                62.812612,
                27.316849
              ],
              [
                62.812095,
                27.316829
              ],
              [
                62.811603,
                27.317085
              ],
              [
                62.811378,
                27.317156
              ],
              [
                62.811344,
                27.3173
              ],
              [
                62.811161,
                27.317276
              ],
              [
                62.811239,
                27.317514
              ],
              [
                62.811171,
                27.317651
              ],
              [
                62.811035,
                27.317746
              ],
              [
                62.810928,
                27.318088
              ],
              [
                62.810795,
                27.318135
              ],
              [
                62.810681,
                27.318341
              ],
              [
                62.810535,
                27.318394
              ],
              [
                62.810465,
                27.318541
              ],
              [
                62.810408,
                27.318558
              ],
              [
                62.810412,
                27.318623
              ],
              [
                62.810291,
                27.318674
              ],
              [
                62.810334,
                27.318903
              ],
              [
                62.810274,
                27.319011
              ],
              [
                62.810325,
                27.319108
              ],
              [
                62.810301,
                27.319159
              ],
              [
                62.810037,
                27.319379
              ],
              [
                62.809685,
                27.319517
              ],
              [
                62.809648,
                27.319763
              ],
              [
                62.809281,
                27.320239
              ],
              [
                62.809156,
                27.320291
              ],
              [
                62.808848,
                27.320284
              ],
              [
                62.808683,
                27.32033
              ],
              [
                62.80883,
                27.320343
              ],
              [
                62.80913,
                27.320553
              ],
              [
                62.809091,
                27.320762
              ],
              [
                62.809009,
                27.320827
              ],
              [
                62.808992,
                27.320905
              ],
              [
                62.808923,
                27.320934
              ],
              [
                62.80895,
                27.321028
              ],
              [
                62.80969,
                27.321273
              ],
              [
                62.809928,
                27.321582
              ],
              [
                62.809889,
                27.321676
              ],
              [
                62.810075,
                27.3217
              ],
              [
                62.810127,
                27.321839
              ],
              [
                62.809984,
                27.321872
              ],
              [
                62.809922,
                27.322641
              ],
              [
                62.809789,
                27.322731
              ],
              [
                62.809594,
                27.3231
              ],
              [
                62.809169,
                27.32341
              ],
              [
                62.809056,
                27.323705
              ],
              [
                62.809137,
                27.32386
              ],
              [
                62.80908,
                27.323908
              ],
              [
                62.809034,
                27.324193
              ],
              [
                62.808695,
                27.324558
              ],
              [
                62.808749,
                27.32465
              ],
              [
                62.808586,
                27.324883
              ],
              [
                62.808481,
                27.324822
              ],
              [
                62.808318,
                27.324819
              ],
              [
                62.808044,
                27.324877
              ],
              [
                62.808003,
                27.324707
              ],
              [
                62.807723,
                27.324683
              ],
              [
                62.807521,
                27.324606
              ],
              [
                62.807035,
                27.324642
              ],
              [
                62.806907,
                27.324558
              ],
              [
                62.806806,
                27.324394
              ],
              [
                62.806648,
                27.32434
              ],
              [
                62.806623,
                27.324146
              ],
              [
                62.806476,
                27.324028
              ],
              [
                62.805967,
                27.324056
              ],
              [
                62.805824,
                27.324238
              ],
              [
                62.80587,
                27.324279
              ],
              [
                62.805828,
                27.324374
              ],
              [
                62.805403,
                27.324612
              ],
              [
                62.805371,
                27.324702
              ],
              [
                62.805235,
                27.324811
              ],
              [
                62.805312,
                27.324949
              ],
              [
                62.805446,
                27.324924
              ],
              [
                62.805531,
                27.324976
              ],
              [
                62.805546,
                27.325069
              ],
              [
                62.805149,
                27.325197
              ],
              [
                62.805143,
                27.325307
              ],
              [
                62.80491,
                27.325354
              ],
              [
                62.804751,
                27.32534
              ],
              [
                62.804356,
                27.325567
              ],
              [
                62.804269,
                27.32567
              ],
              [
                62.80343,
                27.326118
              ],
              [
                62.803284,
                27.3263
              ],
              [
                62.803323,
                27.326554
              ],
              [
                62.803108,
                27.326616
              ],
              [
                62.80292,
                27.326956
              ],
              [
                62.803176,
                27.327087
              ],
              [
                62.803149,
                27.327201
              ],
              [
                62.803323,
                27.327221
              ],
              [
                62.803368,
                27.327287
              ],
              [
                62.803777,
                27.327262
              ],
              [
                62.804134,
                27.327384
              ],
              [
                62.804116,
                27.327515
              ],
              [
                62.804205,
                27.327495
              ],
              [
                62.804275,
                27.327547
              ],
              [
                62.804904,
                27.327543
              ],
              [
                62.806166,
                27.327395
              ],
              [
                62.806055,
                27.327533
              ],
              [
                62.806204,
                27.327552
              ],
              [
                62.806192,
                27.327635
              ],
              [
                62.806721,
                27.327591
              ],
              [
                62.806936,
                27.32764
              ],
              [
                62.806805,
                27.327786
              ],
              [
                62.80731,
                27.327715
              ],
              [
                62.807605,
                27.327858
              ],
              [
                62.808165,
                27.328311
              ],
              [
                62.808211,
                27.328678
              ],
              [
                62.808206,
                27.328849
              ],
              [
                62.80806,
                27.329048
              ],
              [
                62.807891,
                27.329527
              ],
              [
                62.807931,
                27.329926
              ],
              [
                62.807831,
                27.329944
              ],
              [
                62.807669,
                27.330065
              ],
              [
                62.807766,
                27.330183
              ],
              [
                62.807657,
                27.330325
              ],
              [
                62.807522,
                27.330363
              ],
              [
                62.807347,
                27.33052
              ],
              [
                62.807057,
                27.330677
              ],
              [
                62.806983,
                27.330815
              ],
              [
                62.806816,
                27.330884
              ],
              [
                62.806756,
                27.330995
              ],
              [
                62.806305,
                27.331213
              ],
              [
                62.806364,
                27.33128
              ],
              [
                62.80634,
                27.331328
              ],
              [
                62.806134,
                27.331236
              ],
              [
                62.805808,
                27.331217
              ],
              [
                62.805714,
                27.331142
              ],
              [
                62.805485,
                27.331073
              ],
              [
                62.805354,
                27.330962
              ],
              [
                62.805254,
                27.330984
              ],
              [
                62.805197,
                27.331052
              ],
              [
                62.805051,
                27.331073
              ],
              [
                62.805021,
                27.33116
              ],
              [
                62.804847,
                27.331183
              ],
              [
                62.804576,
                27.331315
              ],
              [
                62.804389,
                27.331434
              ],
              [
                62.804439,
                27.331552
              ],
              [
                62.804343,
                27.33166
              ],
              [
                62.804421,
                27.331714
              ],
              [
                62.804539,
                27.33171
              ],
              [
                62.804463,
                27.331771
              ],
              [
                62.804494,
                27.331821
              ],
              [
                62.804376,
                27.331827
              ],
              [
                62.804372,
                27.331912
              ],
              [
                62.804496,
                27.332007
              ],
              [
                62.804467,
                27.332096
              ],
              [
                62.804582,
                27.332111
              ],
              [
                62.80451,
                27.332228
              ],
              [
                62.804615,
                27.332394
              ],
              [
                62.804608,
                27.33247
              ],
              [
                62.803743,
                27.332438
              ],
              [
                62.803722,
                27.332516
              ],
              [
                62.803598,
                27.332524
              ],
              [
                62.803293,
                27.332454
              ],
              [
                62.803138,
                27.332605
              ],
              [
                62.802786,
                27.332606
              ],
              [
                62.802723,
                27.332807
              ],
              [
                62.802756,
                27.332916
              ],
              [
                62.80301,
                27.332967
              ],
              [
                62.80304,
                27.333073
              ],
              [
                62.803003,
                27.333099
              ],
              [
                62.802576,
                27.333139
              ],
              [
                62.801666,
                27.333336
              ],
              [
                62.801291,
                27.333335
              ],
              [
                62.801144,
                27.333382
              ],
              [
                62.800487,
                27.333422
              ],
              [
                62.799906,
                27.333374
              ],
              [
                62.799753,
                27.333325
              ],
              [
                62.79942,
                27.333332
              ],
              [
                62.79915,
                27.333246
              ],
              [
                62.799125,
                27.333307
              ],
              [
                62.798894,
                27.333461
              ],
              [
                62.798341,
                27.33332
              ],
              [
                62.797745,
                27.333291
              ],
              [
                62.797681,
                27.333223
              ],
              [
                62.797542,
                27.333227
              ],
              [
                62.797189,
                27.333347
              ],
              [
                62.797072,
                27.333294
              ],
              [
                62.796971,
                27.333326
              ],
              [
                62.796529,
                27.333316
              ],
              [
                62.796648,
                27.333375
              ],
              [
                62.796594,
                27.333434
              ],
              [
                62.796675,
                27.333469
              ],
              [
                62.796602,
                27.333511
              ],
              [
                62.796581,
                27.333604
              ],
              [
                62.796772,
                27.33372
              ],
              [
                62.796767,
                27.333777
              ],
              [
                62.796693,
                27.33381
              ],
              [
                62.796703,
                27.33391
              ],
              [
                62.796757,
                27.333987
              ],
              [
                62.79687,
                27.333991
              ],
              [
                62.796902,
                27.33414
              ],
              [
                62.796844,
                27.334269
              ],
              [
                62.796465,
                27.334725
              ],
              [
                62.795996,
                27.335229
              ],
              [
                62.796066,
                27.33534
              ],
              [
                62.796424,
                27.335642
              ],
              [
                62.796344,
                27.335787
              ],
              [
                62.796346,
                27.335986
              ],
              [
                62.796471,
                27.336074
              ],
              [
                62.796216,
                27.336606
              ],
              [
                62.796443,
                27.336653
              ],
              [
                62.796511,
                27.33674
              ],
              [
                62.796456,
                27.336812
              ],
              [
                62.796272,
                27.336897
              ],
              [
                62.796198,
                27.336994
              ],
              [
                62.795757,
                27.337016
              ],
              [
                62.795667,
                27.337079
              ],
              [
                62.794989,
                27.337226
              ],
              [
                62.794772,
                27.337205
              ],
              [
                62.794283,
                27.337285
              ],
              [
                62.794217,
                27.337235
              ],
              [
                62.794057,
                27.337231
              ],
              [
                62.793786,
                27.337301
              ],
              [
                62.79368,
                27.337296
              ],
              [
                62.793542,
                27.337201
              ],
              [
                62.793445,
                27.337201
              ],
              [
                62.793392,
                27.337295
              ],
              [
                62.792933,
                27.337441
              ],
              [
                62.792808,
                27.337548
              ],
              [
                62.792719,
                27.337552
              ],
              [
                62.792826,
                27.33765
              ],
              [
                62.792763,
                27.337718
              ],
              [
                62.79238,
                27.337787
              ],
              [
                62.792319,
                27.337876
              ],
              [
                62.792241,
                27.3379
              ],
              [
                62.792236,
                27.337997
              ],
              [
                62.792097,
                27.338002
              ],
              [
                62.792106,
                27.338159
              ],
              [
                62.79195,
                27.338287
              ],
              [
                62.791748,
                27.338183
              ],
              [
                62.791767,
                27.338291
              ],
              [
                62.791705,
                27.338515
              ],
              [
                62.791308,
                27.338595
              ],
              [
                62.791328,
                27.338783
              ],
              [
                62.791617,
                27.338872
              ],
              [
                62.791746,
                27.33899
              ],
              [
                62.791793,
                27.339155
              ],
              [
                62.791888,
                27.339218
              ],
              [
                62.792199,
                27.339178
              ],
              [
                62.792383,
                27.339313
              ],
              [
                62.792727,
                27.339292
              ],
              [
                62.792736,
                27.339399
              ],
              [
                62.792959,
                27.339667
              ],
              [
                62.79297,
                27.339755
              ],
              [
                62.793163,
                27.339926
              ],
              [
                62.793112,
                27.33997
              ],
              [
                62.793201,
                27.340006
              ],
              [
                62.793213,
                27.340075
              ],
              [
                62.793075,
                27.340185
              ],
              [
                62.793118,
                27.34032
              ],
              [
                62.793248,
                27.340289
              ],
              [
                62.793287,
                27.340378
              ],
              [
                62.793386,
                27.340415
              ],
              [
                62.793642,
                27.340416
              ],
              [
                62.79373,
                27.340614
              ],
              [
                62.793975,
                27.340599
              ],
              [
                62.79422,
                27.340791
              ],
              [
                62.794334,
                27.340829
              ],
              [
                62.794281,
                27.340938
              ],
              [
                62.794304,
                27.341076
              ],
              [
                62.794265,
                27.341186
              ],
              [
                62.794184,
                27.341338
              ],
              [
                62.794063,
                27.34142
              ],
              [
                62.794121,
                27.341539
              ],
              [
                62.793895,
                27.34156
              ],
              [
                62.793716,
                27.34164
              ],
              [
                62.793467,
                27.341902
              ],
              [
                62.793239,
                27.342047
              ],
              [
                62.792881,
                27.342503
              ],
              [
                62.792209,
                27.342748
              ],
              [
                62.792348,
                27.342815
              ],
              [
                62.792242,
                27.342928
              ],
              [
                62.792353,
                27.342941
              ],
              [
                62.792349,
                27.342969
              ],
              [
                62.792257,
                27.343005
              ],
              [
                62.792301,
                27.343155
              ],
              [
                62.792105,
                27.343286
              ],
              [
                62.792081,
                27.343405
              ],
              [
                62.792629,
                27.343512
              ],
              [
                62.792776,
                27.343435
              ],
              [
                62.792951,
                27.343486
              ],
              [
                62.79307,
                27.343414
              ],
              [
                62.793157,
                27.343447
              ],
              [
                62.793389,
                27.343406
              ],
              [
                62.793514,
                27.343432
              ],
              [
                62.794156,
                27.34333
              ],
              [
                62.794224,
                27.344167
              ],
              [
                62.794487,
                27.344568
              ],
              [
                62.794612,
                27.344665
              ],
              [
                62.794561,
                27.344737
              ],
              [
                62.794732,
                27.345055
              ],
              [
                62.794602,
                27.345101
              ],
              [
                62.794474,
                27.345256
              ],
              [
                62.794177,
                27.345324
              ],
              [
                62.794269,
                27.34563
              ],
              [
                62.794468,
                27.345589
              ],
              [
                62.794904,
                27.345631
              ],
              [
                62.795009,
                27.345735
              ],
              [
                62.795553,
                27.345927
              ],
              [
                62.795511,
                27.346097
              ],
              [
                62.796142,
                27.346083
              ],
              [
                62.796175,
                27.346679
              ],
              [
                62.796305,
                27.346753
              ],
              [
                62.796448,
                27.347223
              ],
              [
                62.796827,
                27.347418
              ],
              [
                62.797645,
                27.347434
              ],
              [
                62.79779,
                27.347497
              ],
              [
                62.797751,
                27.347765
              ],
              [
                62.797795,
                27.347872
              ],
              [
                62.797774,
                27.348083
              ],
              [
                62.798025,
                27.348744
              ],
              [
                62.797782,
                27.348827
              ],
              [
                62.797427,
                27.34876
              ],
              [
                62.797353,
                27.349094
              ],
              [
                62.797388,
                27.349699
              ],
              [
                62.797355,
                27.349857
              ],
              [
                62.796942,
                27.350056
              ],
              [
                62.796776,
                27.350087
              ],
              [
                62.796576,
                27.350228
              ],
              [
                62.796256,
                27.350319
              ],
              [
                62.796282,
                27.35047
              ],
              [
                62.796172,
                27.350565
              ],
              [
                62.796336,
                27.350723
              ],
              [
                62.796189,
                27.35077
              ],
              [
                62.796167,
                27.350929
              ],
              [
                62.795964,
                27.351001
              ],
              [
                62.795941,
                27.351232
              ],
              [
                62.796041,
                27.351347
              ],
              [
                62.795808,
                27.35144
              ],
              [
                62.795859,
                27.351549
              ],
              [
                62.795822,
                27.351587
              ],
              [
                62.795313,
                27.351792
              ],
              [
                62.795241,
                27.351982
              ],
              [
                62.794697,
                27.352237
              ],
              [
                62.794659,
                27.352316
              ],
              [
                62.794695,
                27.352526
              ],
              [
                62.794482,
                27.352715
              ],
              [
                62.794525,
                27.352788
              ],
              [
                62.794652,
                27.352807
              ],
              [
                62.794605,
                27.352925
              ],
              [
                62.794681,
                27.352941
              ],
              [
                62.794686,
                27.353108
              ],
              [
                62.794806,
                27.353116
              ],
              [
                62.794736,
                27.353154
              ],
              [
                62.794752,
                27.353192
              ],
              [
                62.79486,
                27.35319
              ],
              [
                62.794943,
                27.353261
              ],
              [
                62.795089,
                27.353258
              ],
              [
                62.795026,
                27.353382
              ],
              [
                62.795151,
                27.353439
              ],
              [
                62.795343,
                27.353428
              ],
              [
                62.795778,
                27.35351
              ],
              [
                62.795708,
                27.353681
              ],
              [
                62.795723,
                27.353772
              ],
              [
                62.795559,
                27.353855
              ],
              [
                62.795458,
                27.354048
              ],
              [
                62.795515,
                27.354239
              ],
              [
                62.795688,
                27.3543
              ],
              [
                62.795798,
                27.354465
              ],
              [
                62.795492,
                27.354796
              ],
              [
                62.795388,
                27.354782
              ],
              [
                62.795115,
                27.35501
              ],
              [
                62.795293,
                27.355547
              ],
              [
                62.795293,
                27.355727
              ],
              [
                62.79554,
                27.355823
              ],
              [
                62.795702,
                27.356044
              ],
              [
                62.79599,
                27.356176
              ],
              [
                62.796171,
                27.356608
              ],
              [
                62.796365,
                27.356757
              ],
              [
                62.796376,
                27.357382
              ],
              [
                62.796257,
                27.357466
              ],
              [
                62.796243,
                27.357779
              ],
              [
                62.796095,
                27.358164
              ],
              [
                62.795973,
                27.358254
              ],
              [
                62.795936,
                27.358429
              ],
              [
                62.79585,
                27.358519
              ],
              [
                62.795973,
                27.358687
              ],
              [
                62.795986,
                27.358874
              ],
              [
                62.795941,
                27.358926
              ],
              [
                62.79557,
                27.359061
              ],
              [
                62.795055,
                27.359518
              ],
              [
                62.795044,
                27.35989
              ],
              [
                62.795111,
                27.360004
              ],
              [
                62.795321,
                27.36011
              ],
              [
                62.795705,
                27.36068
              ],
              [
                62.795697,
                27.360843
              ],
              [
                62.795455,
                27.361078
              ],
              [
                62.795476,
                27.361149
              ],
              [
                62.795603,
                27.361227
              ],
              [
                62.79613,
                27.361097
              ],
              [
                62.79684,
                27.361245
              ],
              [
                62.797052,
                27.361242
              ],
              [
                62.797321,
                27.361458
              ],
              [
                62.797822,
                27.361593
              ],
              [
                62.798016,
                27.361606
              ],
              [
                62.798208,
                27.361551
              ],
              [
                62.798753,
                27.361659
              ],
              [
                62.79889,
                27.361792
              ],
              [
                62.799359,
                27.361796
              ],
              [
                62.799328,
                27.361845
              ],
              [
                62.799404,
                27.362377
              ],
              [
                62.799375,
                27.362498
              ],
              [
                62.799436,
                27.362734
              ],
              [
                62.799544,
                27.362912
              ],
              [
                62.799631,
                27.362943
              ],
              [
                62.799697,
                27.363228
              ],
              [
                62.799685,
                27.363476
              ],
              [
                62.799727,
                27.363514
              ],
              [
                62.799654,
                27.363556
              ],
              [
                62.799637,
                27.363662
              ],
              [
                62.799534,
                27.363759
              ],
              [
                62.799419,
                27.364131
              ],
              [
                62.799226,
                27.364344
              ],
              [
                62.799111,
                27.364807
              ],
              [
                62.799193,
                27.364878
              ],
              [
                62.79926,
                27.365033
              ],
              [
                62.799455,
                27.365049
              ],
              [
                62.799797,
                27.365316
              ],
              [
                62.800135,
                27.365327
              ],
              [
                62.800369,
                27.365149
              ],
              [
                62.801029,
                27.365246
              ],
              [
                62.801149,
                27.365417
              ],
              [
                62.801218,
                27.365379
              ],
              [
                62.801256,
                27.36524
              ],
              [
                62.801428,
                27.365263
              ],
              [
                62.801749,
                27.364998
              ],
              [
                62.802105,
                27.36479
              ],
              [
                62.802309,
                27.364547
              ],
              [
                62.802385,
                27.364548
              ],
              [
                62.8085015,
                27.3761957
              ],
              [
                62.8484229,
                27.4629391
              ],
              [
                62.8386602,
                27.6131746
              ],
              [
                62.8296412,
                27.7517824
              ],
              [
                62.8289545,
                27.7644629
              ],
              [
                62.7886885,
                27.9164568
              ],
              [
                62.7748219,
                27.9729331
              ],
              [
                62.7661744,
                28.0061405
              ],
              [
                62.7627557,
                28.007468
              ],
              [
                62.7627411,
                28.016797
              ],
              [
                62.7617618,
                28.0256579
              ],
              [
                62.7630223,
                28.0319505
              ],
              [
                62.7640785,
                28.0349488
              ],
              [
                62.7634274,
                28.0355626
              ],
              [
                62.7644,
                28.0467999
              ],
              [
                62.7840067,
                28.1656224
              ],
              [
                62.7432629,
                28.1625194
              ],
              [
                62.7230069,
                28.1579792
              ],
              [
                62.7019234,
                28.1572357
              ],
              [
                62.6371762,
                28.1549522
              ],
              [
                62.6104178,
                28.1460054
              ],
              [
                62.5800712,
                28.1235714
              ],
              [
                62.5510748,
                28.0996762
              ],
              [
                62.5176128,
                28.092256
              ],
              [
                62.5011977,
                28.0800958
              ],
              [
                62.4751674,
                28.0663126
              ],
              [
                62.4397218,
                28.0457101
              ],
              [
                62.3674133,
                28.0326468
              ],
              [
                62.3316244,
                28.0277981
              ],
              [
                62.2759029,
                28.0202731
              ],
              [
                62.2650989,
                28.0250413
              ],
              [
                62.2420243,
                28.0299459
              ],
              [
                62.2172939,
                28.0419898
              ],
              [
                62.1904648,
                28.0504219
              ],
              [
                62.1660183,
                28.0565123
              ],
              [
                62.1384265,
                28.061788
              ],
              [
                62.1298203,
                28.0400202
              ],
              [
                62.1301256,
                28.0201471
              ],
              [
                62.130767,
                28.0011082
              ],
              [
                62.131282,
                27.9941078
              ],
              [
                62.1270639,
                27.9894857
              ],
              [
                62.1190485,
                27.9859123
              ],
              [
                62.1038334,
                27.9843684
              ],
              [
                62.0925525,
                27.9824188
              ],
              [
                62.0915079,
                27.9778405
              ],
              [
                62.0889316,
                27.9703203
              ],
              [
                62.083485,
                27.9568627
              ],
              [
                62.07892,
                27.9386733
              ],
              [
                62.0738363,
                27.9254479
              ],
              [
                62.0698525,
                27.918582
              ],
              [
                62.0671916,
                27.9173511
              ],
              [
                62.0600543,
                27.9167494
              ],
              [
                62.0528247,
                27.9167322
              ],
              [
                62.052653,
                27.9072759
              ],
              [
                62.0518441,
                27.8981089
              ],
              [
                62.0513999,
                27.8928902
              ],
              [
                62.0483837,
                27.8843819
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555550,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زرآباد",
          "name:en": "Zarabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q109672842"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.0761548,
                25.9905973
              ],
              [
                59.0629429,
                25.9898172
              ],
              [
                59.0519113,
                25.989059
              ],
              [
                59.0389425,
                25.984685
              ],
              [
                59.0236051,
                25.9749856
              ],
              [
                59.0165078,
                25.9658544
              ],
              [
                59.0020024,
                25.9465741
              ],
              [
                58.9984263,
                25.9419313
              ],
              [
                58.9995968,
                25.9377711
              ],
              [
                59.0037834,
                25.9204774
              ],
              [
                59.0270591,
                25.9203993
              ],
              [
                59.0373115,
                25.9140783
              ],
              [
                59.0480356,
                25.9074309
              ],
              [
                59.0619377,
                25.8985135
              ],
              [
                59.0687139,
                25.8968842
              ],
              [
                59.0696329,
                25.8950698
              ],
              [
                59.0717585,
                25.8926682
              ],
              [
                59.0732783,
                25.8920119
              ],
              [
                59.0744166,
                25.8907072
              ],
              [
                59.07516,
                25.8891489
              ],
              [
                59.0771579,
                25.8888789
              ],
              [
                59.0796244,
                25.8846932
              ],
              [
                59.0803743,
                25.8825462
              ],
              [
                59.0804827,
                25.8806697
              ],
              [
                59.0798772,
                25.8787394
              ],
              [
                59.0800761,
                25.8737417
              ],
              [
                59.0803062,
                25.8630387
              ],
              [
                59.0797935,
                25.8609299
              ],
              [
                59.0795968,
                25.8591298
              ],
              [
                59.0799536,
                25.8561418
              ],
              [
                59.0806738,
                25.8539944
              ],
              [
                59.0820694,
                25.8522721
              ],
              [
                59.094287,
                25.841553
              ],
              [
                59.0954255,
                25.8399529
              ],
              [
                59.0979266,
                25.8377499
              ],
              [
                59.0994121,
                25.8368527
              ],
              [
                59.1029692,
                25.8365429
              ],
              [
                59.1055226,
                25.8361276
              ],
              [
                59.1092348,
                25.8345923
              ],
              [
                59.1103506,
                25.8340515
              ],
              [
                59.1117132,
                25.8332886
              ],
              [
                59.1127766,
                25.8316574
              ],
              [
                59.1132903,
                25.8301598
              ],
              [
                59.1135798,
                25.8283297
              ],
              [
                59.1152074,
                25.8269102
              ],
              [
                59.1173672,
                25.8259493
              ],
              [
                59.120779,
                25.8249064
              ],
              [
                59.1229892,
                25.8244621
              ],
              [
                59.1253889,
                25.8232983
              ],
              [
                59.1289544,
                25.8215262
              ],
              [
                59.1332391,
                25.8195511
              ],
              [
                59.1406917,
                25.8134909
              ],
              [
                59.1462706,
                25.8076186
              ],
              [
                59.1319644,
                25.8067884
              ],
              [
                59.1370165,
                25.7995248
              ],
              [
                59.1413352,
                25.7940185
              ],
              [
                59.157801,
                25.7739415
              ],
              [
                59.1682309,
                25.7614647
              ],
              [
                59.1922065,
                25.7401151
              ],
              [
                59.2054938,
                25.7285449
              ],
              [
                59.2148563,
                25.704146
              ],
              [
                59.212993,
                25.7011465
              ],
              [
                59.2118864,
                25.6972546
              ],
              [
                59.2114768,
                25.6930796
              ],
              [
                59.2135342,
                25.6861947
              ],
              [
                59.2173512,
                25.6721304
              ],
              [
                59.2195189,
                25.6651134
              ],
              [
                59.2246821,
                25.6589755
              ],
              [
                59.2250633,
                25.6579294
              ],
              [
                59.2291061,
                25.6519704
              ],
              [
                59.2352194,
                25.6391929
              ],
              [
                59.2354994,
                25.6386369
              ],
              [
                59.2357725,
                25.6367001
              ],
              [
                59.2354995,
                25.6341986
              ],
              [
                59.2352194,
                25.6322528
              ],
              [
                59.2349393,
                25.6314189
              ],
              [
                59.2343858,
                25.6291952
              ],
              [
                59.2202195,
                25.5922553
              ],
              [
                59.2199394,
                25.5905877
              ],
              [
                59.2193862,
                25.5897539
              ],
              [
                59.214106,
                25.5753105
              ],
              [
                59.214106,
                25.5747456
              ],
              [
                59.213826,
                25.5741987
              ],
              [
                59.2116059,
                25.5636377
              ],
              [
                59.2113263,
                25.5622481
              ],
              [
                59.2110528,
                25.5603027
              ],
              [
                59.2107727,
                25.5580794
              ],
              [
                59.2104926,
                25.5578014
              ],
              [
                59.2107727,
                25.5547533
              ],
              [
                59.2141059,
                25.5208578
              ],
              [
                59.2146594,
                25.51253
              ],
              [
                59.2146594,
                25.5047492
              ],
              [
                59.2146593,
                25.5041934
              ],
              [
                59.2149391,
                25.5008587
              ],
              [
                59.214939,
                25.4997473
              ],
              [
                59.2160527,
                25.4903082
              ],
              [
                59.2179907,
                25.4676514
              ],
              [
                59.2190376,
                25.4581693
              ],
              [
                59.2211109,
                25.4393893
              ],
              [
                59.2187761,
                25.1994033
              ],
              [
                59.3884626,
                25.197502
              ],
              [
                59.5677381,
                25.1954933
              ],
              [
                59.6708527,
                25.1832546
              ],
              [
                59.7302577,
                25.4021784
              ],
              [
                59.7226992,
                25.4110521
              ],
              [
                59.7160792,
                25.416046
              ],
              [
                59.7069431,
                25.4183975
              ],
              [
                59.6872268,
                25.4160074
              ],
              [
                59.6631155,
                25.4144966
              ],
              [
                59.6509667,
                25.4115959
              ],
              [
                59.6431445,
                25.4148266
              ],
              [
                59.6366035,
                25.4182958
              ],
              [
                59.6334326,
                25.4220429
              ],
              [
                59.6316193,
                25.427463
              ],
              [
                59.6279181,
                25.4339035
              ],
              [
                59.6228271,
                25.441597
              ],
              [
                59.6179639,
                25.4497502
              ],
              [
                59.6120622,
                25.4571481
              ],
              [
                59.6042297,
                25.4659316
              ],
              [
                59.6013115,
                25.4698596
              ],
              [
                59.5976433,
                25.475917
              ],
              [
                59.5964576,
                25.4809207
              ],
              [
                59.5966258,
                25.4905997
              ],
              [
                59.5957021,
                25.501035
              ],
              [
                59.5956901,
                25.5049894
              ],
              [
                59.5993088,
                25.5090513
              ],
              [
                59.6038341,
                25.5117705
              ],
              [
                59.6084212,
                25.5130057
              ],
              [
                59.6115493,
                25.5140902
              ],
              [
                59.6147561,
                25.5167874
              ],
              [
                59.616143,
                25.5202187
              ],
              [
                59.6173942,
                25.524101
              ],
              [
                59.6163644,
                25.5318831
              ],
              [
                59.6148219,
                25.5355145
              ],
              [
                59.6111157,
                25.5395236
              ],
              [
                59.605627,
                25.5495824
              ],
              [
                59.6031448,
                25.5580994
              ],
              [
                59.5987062,
                25.5638072
              ],
              [
                59.595899,
                25.569353
              ],
              [
                59.5935434,
                25.5760175
              ],
              [
                59.5928709,
                25.5842251
              ],
              [
                59.5921849,
                25.5875405
              ],
              [
                59.5915616,
                25.5884711
              ],
              [
                59.5901012,
                25.5883559
              ],
              [
                59.5882618,
                25.5879943
              ],
              [
                59.584594,
                25.5877866
              ],
              [
                59.5829773,
                25.5883946
              ],
              [
                59.5817756,
                25.5912201
              ],
              [
                59.5813036,
                25.5940456
              ],
              [
                59.5837497,
                25.5962517
              ],
              [
                59.5868825,
                25.5981869
              ],
              [
                59.5894575,
                25.6010896
              ],
              [
                59.5904874,
                25.6019023
              ],
              [
                59.5916032,
                25.6022506
              ],
              [
                59.5933198,
                25.6017862
              ],
              [
                59.5946202,
                25.6006611
              ],
              [
                59.5986414,
                25.5980708
              ],
              [
                59.6040487,
                25.5955163
              ],
              [
                59.6082973,
                25.5939682
              ],
              [
                59.6103572,
                25.5940069
              ],
              [
                59.6158428,
                25.6000559
              ],
              [
                59.6165964,
                25.6021354
              ],
              [
                59.6145271,
                25.6030606
              ],
              [
                59.610262,
                25.6029374
              ],
              [
                59.6065914,
                25.6053369
              ],
              [
                59.6057246,
                25.6084857
              ],
              [
                59.6061134,
                25.6119563
              ],
              [
                59.6080513,
                25.6147569
              ],
              [
                59.6143754,
                25.6180254
              ],
              [
                59.6217629,
                25.6218497
              ],
              [
                59.6254634,
                25.6244246
              ],
              [
                59.6271379,
                25.6265917
              ],
              [
                59.6290346,
                25.6307399
              ],
              [
                59.6304664,
                25.6372227
              ],
              [
                59.6325336,
                25.6428307
              ],
              [
                59.6341259,
                25.6439174
              ],
              [
                59.6404526,
                25.648216
              ],
              [
                59.6438312,
                25.6513143
              ],
              [
                59.6476507,
                25.6561113
              ],
              [
                59.6492833,
                25.659607
              ],
              [
                59.6510403,
                25.6654822
              ],
              [
                59.6528647,
                25.671624
              ],
              [
                59.6597631,
                25.6819951
              ],
              [
                59.6632596,
                25.690008
              ],
              [
                59.6642264,
                25.6946302
              ],
              [
                59.6655035,
                25.6986177
              ],
              [
                59.666748,
                25.7010926
              ],
              [
                59.6687221,
                25.7098317
              ],
              [
                59.669834,
                25.7130787
              ],
              [
                59.6710395,
                25.7164048
              ],
              [
                59.6736574,
                25.718686
              ],
              [
                59.6755671,
                25.7198652
              ],
              [
                59.6808457,
                25.7223783
              ],
              [
                59.68482,
                25.7239177
              ],
              [
                59.6871746,
                25.7243128
              ],
              [
                59.6906496,
                25.7251748
              ],
              [
                59.6927547,
                25.7251427
              ],
              [
                59.6998449,
                25.7238256
              ],
              [
                59.7044932,
                25.7239696
              ],
              [
                59.7088871,
                25.7230952
              ],
              [
                59.7118876,
                25.7230566
              ],
              [
                59.721582,
                25.7243011
              ],
              [
                59.7294869,
                25.7246105
              ],
              [
                59.7350298,
                25.7246893
              ],
              [
                59.7418772,
                25.7260974
              ],
              [
                59.7451114,
                25.7268438
              ],
              [
                59.7488021,
                25.7288155
              ],
              [
                59.750905,
                25.7306326
              ],
              [
                59.7548579,
                25.735459
              ],
              [
                59.7558965,
                25.7366886
              ],
              [
                59.7599143,
                25.7398316
              ],
              [
                59.7617197,
                25.7410703
              ],
              [
                59.7641462,
                25.7423099
              ],
              [
                59.7684573,
                25.7446267
              ],
              [
                59.7870826,
                25.7500384
              ],
              [
                59.790249,
                25.7533187
              ],
              [
                59.795494,
                25.7597787
              ],
              [
                59.8007726,
                25.7694729
              ],
              [
                59.7901724,
                25.7729966
              ],
              [
                59.7774695,
                25.7709869
              ],
              [
                59.7666548,
                25.7685135
              ],
              [
                59.7524069,
                25.7590831
              ],
              [
                59.7424505,
                25.7644941
              ],
              [
                59.7357557,
                25.7705232
              ],
              [
                59.7252844,
                25.783817
              ],
              [
                59.7168725,
                25.8032919
              ],
              [
                59.696102,
                25.8244623
              ],
              [
                59.6803091,
                25.8320334
              ],
              [
                59.6746443,
                25.8409945
              ],
              [
                59.6801375,
                25.8697274
              ],
              [
                59.6736143,
                25.8828557
              ],
              [
                59.6674345,
                25.8879521
              ],
              [
                59.6591948,
                25.8910408
              ],
              [
                59.6511267,
                25.8932028
              ],
              [
                59.6406553,
                25.8919674
              ],
              [
                59.6325459,
                25.8917923
              ],
              [
                59.6274374,
                25.8945927
              ],
              [
                59.6238325,
                25.8995342
              ],
              [
                59.6225556,
                25.9063032
              ],
              [
                59.6198843,
                25.9162104
              ],
              [
                59.6171219,
                25.9193771
              ],
              [
                59.6060113,
                25.9210554
              ],
              [
                59.5950751,
                25.9232684
              ],
              [
                59.5847797,
                25.9264773
              ],
              [
                59.5713042,
                25.9345822
              ],
              [
                59.5541884,
                25.9429127
              ],
              [
                59.546585,
                25.945851
              ],
              [
                59.5418394,
                25.9493846
              ],
              [
                59.5293557,
                25.9525793
              ],
              [
                59.5168995,
                25.9558977
              ],
              [
                59.5082985,
                25.958282
              ],
              [
                59.5020524,
                25.9585892
              ],
              [
                59.4734573,
                25.9570415
              ],
              [
                59.397878,
                25.9672707
              ],
              [
                59.3673832,
                25.9716115
              ],
              [
                59.3320801,
                25.9741972
              ],
              [
                59.3066607,
                25.9766825
              ],
              [
                59.2870416,
                25.9788126
              ],
              [
                59.2718002,
                25.9799414
              ],
              [
                59.2618397,
                25.9806987
              ],
              [
                59.2576812,
                25.9823656
              ],
              [
                59.2527308,
                25.9828487
              ],
              [
                59.2388178,
                25.9796155
              ],
              [
                59.2295576,
                25.9781279
              ],
              [
                59.2192495,
                25.9789157
              ],
              [
                59.1992611,
                25.9797244
              ],
              [
                59.1915464,
                25.9797279
              ],
              [
                59.1815471,
                25.977799
              ],
              [
                59.171934,
                25.9769503
              ],
              [
                59.1647243,
                25.976796
              ],
              [
                59.150648,
                25.9762558
              ],
              [
                59.1456699,
                25.9771818
              ],
              [
                59.1337748,
                25.9773881
              ],
              [
                59.1073601,
                25.9818747
              ],
              [
                59.0947658,
                25.9843437
              ],
              [
                59.0865786,
                25.9857487
              ],
              [
                59.0761548,
                25.9905973
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555762,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لاشار",
          "name:en": "Lashar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q109670507"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.8864248,
                26.488387
              ],
              [
                59.8901652,
                26.4899333
              ],
              [
                59.8948001,
                26.4891651
              ],
              [
                59.9026965,
                26.4860922
              ],
              [
                59.9105129,
                26.4821246
              ],
              [
                59.9165153,
                26.4794085
              ],
              [
                59.9216651,
                26.4751061
              ],
              [
                59.9300445,
                26.4646746
              ],
              [
                59.9388835,
                26.4596508
              ],
              [
                59.9496459,
                26.4542835
              ],
              [
                59.9553107,
                26.4519781
              ],
              [
                59.9629497,
                26.4497496
              ],
              [
                59.967842,
                26.4487506
              ],
              [
                59.9711894,
                26.4469831
              ],
              [
                59.9769401,
                26.4472137
              ],
              [
                59.9820899,
                26.4501338
              ],
              [
                59.9883556,
                26.4552824
              ],
              [
                59.9904155,
                26.4592782
              ],
              [
                59.9888705,
                26.4657326
              ],
              [
                59.9910163,
                26.4718024
              ],
              [
                60.000801,
                26.4836339
              ],
              [
                60.0035476,
                26.4869373
              ],
              [
                60.0131539,
                26.4932344
              ],
              [
                60.0156339,
                26.4943578
              ],
              [
                60.020682,
                26.4953839
              ],
              [
                60.024147,
                26.4954257
              ],
              [
                60.026443,
                26.4962514
              ],
              [
                60.0292969,
                26.4960402
              ],
              [
                60.0316471,
                26.4967486
              ],
              [
                60.0434874,
                26.4958365
              ],
              [
                60.0579437,
                26.4944539
              ],
              [
                60.0716496,
                26.4923318
              ],
              [
                60.0757312,
                26.4926219
              ],
              [
                60.0904246,
                26.4913141
              ],
              [
                60.1259717,
                26.493475
              ],
              [
                60.1467913,
                26.4893268
              ],
              [
                60.1528376,
                26.4892978
              ],
              [
                60.1760306,
                26.4892014
              ],
              [
                60.2070846,
                26.4907093
              ],
              [
                60.2292039,
                26.4936764
              ],
              [
                60.2426719,
                26.4923146
              ],
              [
                60.2455901,
                26.4926987
              ],
              [
                60.2508258,
                26.4910855
              ],
              [
                60.2578069,
                26.4905842
              ],
              [
                60.2746867,
                26.4912392
              ],
              [
                60.279373,
                26.4908435
              ],
              [
                60.3171729,
                26.4897028
              ],
              [
                60.3306912,
                26.4909774
              ],
              [
                60.3318106,
                26.4920335
              ],
              [
                60.331888,
                26.4932816
              ],
              [
                60.3314599,
                26.4944343
              ],
              [
                60.3297875,
                26.4957113
              ],
              [
                60.3254708,
                26.4967864
              ],
              [
                60.3240141,
                26.4979773
              ],
              [
                60.3234275,
                26.50008
              ],
              [
                60.321958,
                26.5024349
              ],
              [
                60.3201679,
                26.5047856
              ],
              [
                60.3156869,
                26.5073011
              ],
              [
                60.3060969,
                26.5122654
              ],
              [
                60.3050336,
                26.5126494
              ],
              [
                60.3041356,
                26.5137829
              ],
              [
                60.303877,
                26.5155593
              ],
              [
                60.3050154,
                26.5176143
              ],
              [
                60.3054863,
                26.5181423
              ],
              [
                60.3097232,
                26.5225299
              ],
              [
                60.3112308,
                26.5300924
              ],
              [
                60.3126645,
                26.5405546
              ],
              [
                60.3135229,
                26.5466882
              ],
              [
                60.3127006,
                26.5633797
              ],
              [
                60.3038925,
                26.5837951
              ],
              [
                60.3016205,
                26.5973177
              ],
              [
                60.3006739,
                26.6020483
              ],
              [
                60.3014359,
                26.6066359
              ],
              [
                60.3031038,
                26.619495
              ],
              [
                60.304563,
                26.6304163
              ],
              [
                60.3146183,
                26.6534413
              ],
              [
                60.3197493,
                26.6647075
              ],
              [
                60.3318282,
                26.6729453
              ],
              [
                60.3435619,
                26.6823604
              ],
              [
                60.3718662,
                26.7049349
              ],
              [
                60.3848874,
                26.7173275
              ],
              [
                60.3917263,
                26.7221815
              ],
              [
                60.4116881,
                26.7355737
              ],
              [
                60.4213693,
                26.7409329
              ],
              [
                60.4295253,
                26.7441541
              ],
              [
                60.4430865,
                26.7428511
              ],
              [
                60.4509735,
                26.7436579
              ],
              [
                60.455532,
                26.7501326
              ],
              [
                60.4556178,
                26.7537349
              ],
              [
                60.4457473,
                26.7623951
              ],
              [
                60.4451088,
                26.7648021
              ],
              [
                60.453222,
                26.7817905
              ],
              [
                60.4533687,
                26.7887324
              ],
              [
                60.4483773,
                26.8022506
              ],
              [
                60.4466381,
                26.8065157
              ],
              [
                60.4458002,
                26.8131066
              ],
              [
                60.4464869,
                26.822357
              ],
              [
                60.4468732,
                26.8293147
              ],
              [
                60.4497957,
                26.8401398
              ],
              [
                60.4510611,
                26.84898
              ],
              [
                60.45205,
                26.8556351
              ],
              [
                60.4530574,
                26.8614972
              ],
              [
                60.4543834,
                26.8680205
              ],
              [
                60.4564659,
                26.8726544
              ],
              [
                60.457261,
                26.8773057
              ],
              [
                60.458564,
                26.8828667
              ],
              [
                60.4544642,
                26.8871902
              ],
              [
                60.4519911,
                26.8897993
              ],
              [
                60.4492894,
                26.8956598
              ],
              [
                60.4521352,
                26.9000205
              ],
              [
                60.4583376,
                26.9059646
              ],
              [
                60.4592227,
                26.9180904
              ],
              [
                60.4599434,
                26.9262016
              ],
              [
                60.4624731,
                26.9406782
              ],
              [
                60.4652309,
                26.9603278
              ],
              [
                60.4678926,
                26.9644722
              ],
              [
                60.4629987,
                26.9657599
              ],
              [
                60.4577623,
                26.9653015
              ],
              [
                60.4520981,
                26.9678253
              ],
              [
                60.4457809,
                26.9707057
              ],
              [
                60.4391377,
                26.9749012
              ],
              [
                60.435103,
                26.9780761
              ],
              [
                60.4268639,
                26.9842711
              ],
              [
                60.4190969,
                26.9883625
              ],
              [
                60.4140323,
                26.9905046
              ],
              [
                60.4028137,
                26.9964458
              ],
              [
                60.3957747,
                27.000003
              ],
              [
                60.3886737,
                27.0026664
              ],
              [
                60.3791084,
                27.0067304
              ],
              [
                60.375671,
                27.0081069
              ],
              [
                60.3706976,
                27.0098003
              ],
              [
                60.3611375,
                27.0125977
              ],
              [
                60.3558367,
                27.0131344
              ],
              [
                60.3537236,
                27.0132684
              ],
              [
                60.3383665,
                27.0123641
              ],
              [
                60.330118,
                27.0120944
              ],
              [
                60.3106652,
                27.0114959
              ],
              [
                60.2944524,
                27.0110371
              ],
              [
                60.2787479,
                27.0097863
              ],
              [
                60.2632047,
                27.0092511
              ],
              [
                60.2518621,
                27.0089724
              ],
              [
                60.2497304,
                27.0095842
              ],
              [
                60.2379737,
                27.0080056
              ],
              [
                60.2247407,
                27.0062792
              ],
              [
                60.2231632,
                27.0066616
              ],
              [
                60.2163625,
                27.0070257
              ],
              [
                60.2096459,
                27.0074081
              ],
              [
                60.202938,
                27.0077632
              ],
              [
                60.1968196,
                27.0073044
              ],
              [
                60.189933,
                27.0069713
              ],
              [
                60.1834191,
                27.0061574
              ],
              [
                60.1769211,
                27.0056713
              ],
              [
                60.1581066,
                27.0058834
              ],
              [
                60.1525941,
                27.0061128
              ],
              [
                60.1431245,
                27.0051984
              ],
              [
                60.1320983,
                27.0042424
              ],
              [
                60.1258396,
                27.0030299
              ],
              [
                60.1206107,
                27.0019321
              ],
              [
                60.1139657,
                27.0005284
              ],
              [
                60.1092288,
                26.999701
              ],
              [
                60.1043885,
                26.9957733
              ],
              [
                60.0996048,
                26.9919383
              ],
              [
                60.0955326,
                26.9884694
              ],
              [
                60.0918108,
                26.9854866
              ],
              [
                60.0873997,
                26.9817024
              ],
              [
                60.0831583,
                26.9782221
              ],
              [
                60.0775163,
                26.9737584
              ],
              [
                60.0740472,
                26.9709281
              ],
              [
                60.0698505,
                26.967688
              ],
              [
                60.067565,
                26.9656395
              ],
              [
                60.065444,
                26.963585
              ],
              [
                60.0621241,
                26.9602572
              ],
              [
                60.0569135,
                26.955066
              ],
              [
                60.0502084,
                26.9491607
              ],
              [
                60.0477741,
                26.9470294
              ],
              [
                60.0463469,
                26.9456522
              ],
              [
                60.0427468,
                26.9428322
              ],
              [
                60.0384578,
                26.9393125
              ],
              [
                60.0350623,
                26.9368074
              ],
              [
                60.0321374,
                26.9352962
              ],
              [
                60.0095288,
                26.9080459
              ],
              [
                60.0009873,
                26.8962341
              ],
              [
                59.9987139,
                26.8913619
              ],
              [
                59.9913324,
                26.8787705
              ],
              [
                59.98567,
                26.8686616
              ],
              [
                59.9808409,
                26.8631766
              ],
              [
                59.9737667,
                26.8473023
              ],
              [
                59.9717543,
                26.8345899
              ],
              [
                59.969977,
                26.8167174
              ],
              [
                59.9691187,
                26.806113
              ],
              [
                59.9692904,
                26.7981684
              ],
              [
                59.9700736,
                26.7876058
              ],
              [
                59.9699042,
                26.777019
              ],
              [
                59.96999,
                26.7704447
              ],
              [
                59.9702975,
                26.7667046
              ],
              [
                59.9712307,
                26.7572616
              ],
              [
                59.9708899,
                26.7501668
              ],
              [
                59.9787704,
                26.7399556
              ],
              [
                59.9817049,
                26.7332492
              ],
              [
                59.8987687,
                26.7126115
              ],
              [
                59.8948182,
                26.7052498
              ],
              [
                59.8931071,
                26.6869104
              ],
              [
                59.8889529,
                26.6677765
              ],
              [
                59.8886823,
                26.6581782
              ],
              [
                59.8899936,
                26.5787407
              ],
              [
                59.8833417,
                26.5734825
              ],
              [
                59.8779344,
                26.5706806
              ],
              [
                59.8703184,
                26.5692768
              ],
              [
                59.8579786,
                26.5608927
              ],
              [
                59.856777,
                26.5487621
              ],
              [
                59.8600386,
                26.5354015
              ],
              [
                59.8708533,
                26.5176619
              ],
              [
                59.8722266,
                26.5109799
              ],
              [
                59.8754024,
                26.5039136
              ],
              [
                59.8792557,
                26.5020026
              ],
              [
                59.8834365,
                26.4996742
              ],
              [
                59.8877408,
                26.4948625
              ],
              [
                59.8874418,
                26.4925345
              ],
              [
                59.8864248,
                26.488387
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6556259,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "loc_name": "شهرستان تپتان",
          "loc_name:en": "Taptan County",
          "name": "شهرستان تفتان",
          "name:en": "Taftan County",
          "place": "county",
          "population": "44176",
          "type": "boundary",
          "wikidata": "Q79654547"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.1470461,
                28.2924798
              ],
              [
                60.1718527,
                28.2587186
              ],
              [
                60.1909452,
                28.235728
              ],
              [
                60.2057644,
                28.2148699
              ],
              [
                60.220184,
                28.1909674
              ],
              [
                60.2280944,
                28.1718312
              ],
              [
                60.232914,
                28.1574427
              ],
              [
                60.2406975,
                28.1405731
              ],
              [
                60.2450751,
                28.1406485
              ],
              [
                60.2503964,
                28.1419354
              ],
              [
                60.2595805,
                28.1452652
              ],
              [
                60.2655026,
                28.1485197
              ],
              [
                60.2775189,
                28.1543468
              ],
              [
                60.2939984,
                28.1570711
              ],
              [
                60.3071307,
                28.1477627
              ],
              [
                60.306077,
                28.1297972
              ],
              [
                60.3012328,
                28.0981313
              ],
              [
                60.3066627,
                28.082879
              ],
              [
                60.3107579,
                28.0695507
              ],
              [
                60.3160401,
                28.0542977
              ],
              [
                60.3196785,
                28.0448038
              ],
              [
                60.323319,
                28.0342658
              ],
              [
                60.3317187,
                28.0082255
              ],
              [
                60.3367195,
                28.0033034
              ],
              [
                60.3412078,
                27.9987048
              ],
              [
                60.3445282,
                27.9892727
              ],
              [
                60.3481532,
                27.9748221
              ],
              [
                60.353125,
                27.9614304
              ],
              [
                60.3624915,
                27.950663
              ],
              [
                60.3730361,
                27.9399397
              ],
              [
                60.3792318,
                27.9248976
              ],
              [
                60.3842386,
                27.9059608
              ],
              [
                60.394678,
                27.8905979
              ],
              [
                60.4105996,
                27.8695736
              ],
              [
                60.4497515,
                27.8110394
              ],
              [
                60.4583941,
                27.803728
              ],
              [
                60.463171,
                27.7998304
              ],
              [
                60.4670357,
                27.7962358
              ],
              [
                60.4708957,
                27.8003619
              ],
              [
                60.4836157,
                27.8082302
              ],
              [
                60.4986972,
                27.8145829
              ],
              [
                60.5179901,
                27.8190186
              ],
              [
                60.5538422,
                27.838575
              ],
              [
                60.5676087,
                27.8580503
              ],
              [
                60.5721221,
                27.873763
              ],
              [
                60.5571628,
                27.9154832
              ],
              [
                60.5244305,
                27.9770504
              ],
              [
                60.5189841,
                27.9946595
              ],
              [
                60.5154018,
                28.0021661
              ],
              [
                60.5195376,
                28.0086858
              ],
              [
                60.5193023,
                28.023204
              ],
              [
                60.5224174,
                28.0429814
              ],
              [
                60.5277775,
                28.06666
              ],
              [
                60.5384169,
                28.0928408
              ],
              [
                60.5535069,
                28.1161667
              ],
              [
                60.5592098,
                28.1261113
              ],
              [
                60.547838,
                28.1580041
              ],
              [
                60.5463145,
                28.1612773
              ],
              [
                60.548845,
                28.177409
              ],
              [
                60.5504347,
                28.1828329
              ],
              [
                60.5511182,
                28.1867373
              ],
              [
                60.5522249,
                28.1875747
              ],
              [
                60.5543325,
                28.208022
              ],
              [
                60.5562135,
                28.2360942
              ],
              [
                60.5575418,
                28.2402034
              ],
              [
                60.5923383,
                28.2404257
              ],
              [
                60.6293972,
                28.2402685
              ],
              [
                60.6582447,
                28.2404219
              ],
              [
                60.6735186,
                28.2403371
              ],
              [
                60.6913661,
                28.2403694
              ],
              [
                60.7107649,
                28.2402785
              ],
              [
                60.7214432,
                28.2406333
              ],
              [
                60.7445973,
                28.241465
              ],
              [
                60.7502352,
                28.2362009
              ],
              [
                60.762315,
                28.2436867
              ],
              [
                60.7816886,
                28.2517718
              ],
              [
                60.8099187,
                28.2585757
              ],
              [
                60.8385748,
                28.2582733
              ],
              [
                60.8599873,
                28.2563144
              ],
              [
                60.8821203,
                28.2515224
              ],
              [
                60.8959417,
                28.2434266
              ],
              [
                60.9090744,
                28.2368247
              ],
              [
                60.9157216,
                28.2330205
              ],
              [
                60.9214476,
                28.2293718
              ],
              [
                60.9273559,
                28.2257416
              ],
              [
                60.9209228,
                28.2506548
              ],
              [
                60.916786,
                28.2965214
              ],
              [
                60.9181593,
                28.3199469
              ],
              [
                60.9309984,
                28.3441802
              ],
              [
                60.9368922,
                28.3516031
              ],
              [
                60.9474238,
                28.3666336
              ],
              [
                60.9640849,
                28.3811642
              ],
              [
                60.9823516,
                28.3906488
              ],
              [
                60.9942584,
                28.3967139
              ],
              [
                61.0095744,
                28.4080912
              ],
              [
                61.015959,
                28.4129228
              ],
              [
                61.0337412,
                28.4209675
              ],
              [
                61.0403095,
                28.4235616
              ],
              [
                61.0635375,
                28.4306743
              ],
              [
                61.0815862,
                28.4288164
              ],
              [
                61.1096765,
                28.425554
              ],
              [
                61.1103632,
                28.4556435
              ],
              [
                61.1096136,
                28.4687503
              ],
              [
                61.1078603,
                28.4846067
              ],
              [
                61.1049269,
                28.4932859
              ],
              [
                61.1041545,
                28.506486
              ],
              [
                61.1050986,
                28.5156121
              ],
              [
                61.1087034,
                28.5337109
              ],
              [
                61.112821,
                28.5434162
              ],
              [
                61.1215478,
                28.5606405
              ],
              [
                61.1238097,
                28.5722359
              ],
              [
                61.1278012,
                28.5841457
              ],
              [
                61.1295344,
                28.5887074
              ],
              [
                61.1315673,
                28.5930594
              ],
              [
                61.1328753,
                28.5958896
              ],
              [
                61.1236106,
                28.5997349
              ],
              [
                61.1048466,
                28.6111133
              ],
              [
                60.9972462,
                28.6311984
              ],
              [
                60.9621752,
                28.6443019
              ],
              [
                60.9511337,
                28.6484245
              ],
              [
                60.9453,
                28.6514696
              ],
              [
                60.9294669,
                28.6631371
              ],
              [
                60.9214145,
                28.6689753
              ],
              [
                60.9205809,
                28.6695249
              ],
              [
                60.9114073,
                28.6759218
              ],
              [
                60.9111347,
                28.6759218
              ],
              [
                60.910301,
                28.6764804
              ],
              [
                60.892521,
                28.6867516
              ],
              [
                60.8864077,
                28.7067537
              ],
              [
                60.8828015,
                28.7289818
              ],
              [
                60.8825219,
                28.7345321
              ],
              [
                60.8825219,
                28.7567519
              ],
              [
                60.8808547,
                28.7600858
              ],
              [
                60.8791882,
                28.7617528
              ],
              [
                60.8711288,
                28.7761968
              ],
              [
                60.8711288,
                28.7764763
              ],
              [
                60.869742,
                28.7775845
              ],
              [
                60.8694616,
                28.7778639
              ],
              [
                60.8680748,
                28.7806482
              ],
              [
                60.8675217,
                28.7809185
              ],
              [
                60.867242,
                28.7820359
              ],
              [
                60.8669616,
                28.7823062
              ],
              [
                60.8665487,
                28.7825855
              ],
              [
                60.8664085,
                28.7828649
              ],
              [
                60.8658552,
                28.7828649
              ],
              [
                60.8611286,
                28.7870369
              ],
              [
                60.8561286,
                28.7984177
              ],
              [
                60.8558552,
                28.8000847
              ],
              [
                60.8416894,
                28.8353724
              ],
              [
                60.8119002,
                28.8007672
              ],
              [
                60.7917237,
                28.8441288
              ],
              [
                60.7676123,
                28.8663239
              ],
              [
                60.7460074,
                28.8599432
              ],
              [
                60.7360266,
                28.8646703
              ],
              [
                60.7212198,
                28.8642281
              ],
              [
                60.7051275,
                28.8592581
              ],
              [
                60.6867892,
                28.8540271
              ],
              [
                60.6407545,
                28.8541463
              ],
              [
                60.598746,
                28.8531672
              ],
              [
                60.5945776,
                28.8511393
              ],
              [
                60.5884809,
                28.845337
              ],
              [
                60.5832024,
                28.8252611
              ],
              [
                60.5772445,
                28.7845689
              ],
              [
                60.5711958,
                28.7614844
              ],
              [
                60.5677272,
                28.7485807
              ],
              [
                60.5447959,
                28.7313132
              ],
              [
                60.5320071,
                28.7185176
              ],
              [
                60.5231907,
                28.7028616
              ],
              [
                60.5049704,
                28.6681481
              ],
              [
                60.4982438,
                28.6630928
              ],
              [
                60.4902739,
                28.6620873
              ],
              [
                60.4769894,
                28.6618222
              ],
              [
                60.4476353,
                28.6542905
              ],
              [
                60.446777,
                28.6481142
              ],
              [
                60.4388807,
                28.6443478
              ],
              [
                60.4206394,
                28.6432465
              ],
              [
                60.4054068,
                28.6393762
              ],
              [
                60.385874,
                28.6293419
              ],
              [
                60.3844641,
                28.6166242
              ],
              [
                60.3806875,
                28.6036638
              ],
              [
                60.3751944,
                28.603061
              ],
              [
                60.3595519,
                28.605356
              ],
              [
                60.3539084,
                28.612254
              ],
              [
                60.3410338,
                28.6104456
              ],
              [
                60.335884,
                28.5998206
              ],
              [
                60.3320216,
                28.5981627
              ],
              [
                60.329275,
                28.5963541
              ],
              [
                60.3290176,
                28.5940179
              ],
              [
                60.33185,
                28.5914555
              ],
              [
                60.3340521,
                28.5888911
              ],
              [
                60.3345106,
                28.5638687
              ],
              [
                60.3348144,
                28.5366142
              ],
              [
                60.3194044,
                28.5199862
              ],
              [
                60.3126602,
                28.5157053
              ],
              [
                60.2973095,
                28.5093885
              ],
              [
                60.2838705,
                28.5064106
              ],
              [
                60.2637861,
                28.503997
              ],
              [
                60.2493666,
                28.5023376
              ],
              [
                60.242258,
                28.500757
              ],
              [
                60.2326297,
                28.4989432
              ],
              [
                60.2229298,
                28.4945819
              ],
              [
                60.2077387,
                28.4890615
              ],
              [
                60.1820753,
                28.4756328
              ],
              [
                60.1618193,
                28.4542037
              ],
              [
                60.1491163,
                28.4350346
              ],
              [
                60.1457057,
                28.4234121
              ],
              [
                60.140874,
                28.4112397
              ],
              [
                60.1360701,
                28.3836985
              ],
              [
                60.1360555,
                28.3553289
              ],
              [
                60.1363988,
                28.3397512
              ],
              [
                60.1372186,
                28.3311556
              ],
              [
                60.1388272,
                28.3194348
              ],
              [
                60.142152,
                28.3050188
              ],
              [
                60.1441708,
                28.2976817
              ],
              [
                60.1470461,
                28.2924798
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11147665,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بمپور",
          "name:en": "Bampour County",
          "type": "boundary",
          "wikidata": "Q4853535",
          "wikipedia": "en:Bampur County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                59.840821,
                27.0763961
              ],
              [
                59.8422696,
                27.0754293
              ],
              [
                59.8430159,
                27.074139
              ],
              [
                59.8461127,
                27.0626609
              ],
              [
                59.8493569,
                27.0482194
              ],
              [
                59.8489863,
                27.0460387
              ],
              [
                59.8514553,
                27.0380279
              ],
              [
                59.8651883,
                27.0230428
              ],
              [
                59.8799511,
                27.0092791
              ],
              [
                59.8939225,
                27.0036978
              ],
              [
                59.9032973,
                27.0034671
              ],
              [
                59.9142834,
                27.0077497
              ],
              [
                59.9236605,
                27.0011111
              ],
              [
                59.923527,
                26.991502
              ],
              [
                59.9284553,
                26.9821708
              ],
              [
                59.9373948,
                26.9776088
              ],
              [
                59.9458514,
                26.9776359
              ],
              [
                59.9576458,
                26.9814604
              ],
              [
                59.967444,
                26.9847
              ],
              [
                59.9757805,
                26.9824054
              ],
              [
                59.9793352,
                26.9695909
              ],
              [
                59.9819182,
                26.963082
              ],
              [
                59.988613,
                26.9592569
              ],
              [
                59.998741,
                26.9586448
              ],
              [
                60.0059508,
                26.9539015
              ],
              [
                60.0141905,
                26.9447203
              ],
              [
                60.0174521,
                26.9404354
              ],
              [
                60.0258635,
                26.9359974
              ],
              [
                60.0321374,
                26.9352962
              ],
              [
                60.0350623,
                26.9368074
              ],
              [
                60.0384578,
                26.9393125
              ],
              [
                60.0427468,
                26.9428322
              ],
              [
                60.0463469,
                26.9456522
              ],
              [
                60.0477741,
                26.9470294
              ],
              [
                60.0502084,
                26.9491607
              ],
              [
                60.0569135,
                26.955066
              ],
              [
                60.0621241,
                26.9602572
              ],
              [
                60.065444,
                26.963585
              ],
              [
                60.067565,
                26.9656395
              ],
              [
                60.0698505,
                26.967688
              ],
              [
                60.0740472,
                26.9709281
              ],
              [
                60.0775163,
                26.9737584
              ],
              [
                60.0831583,
                26.9782221
              ],
              [
                60.0873997,
                26.9817024
              ],
              [
                60.0918108,
                26.9854866
              ],
              [
                60.0955326,
                26.9884694
              ],
              [
                60.0996048,
                26.9919383
              ],
              [
                60.1043885,
                26.9957733
              ],
              [
                60.1092288,
                26.999701
              ],
              [
                60.1139657,
                27.0005284
              ],
              [
                60.1206107,
                27.0019321
              ],
              [
                60.1258396,
                27.0030299
              ],
              [
                60.1320983,
                27.0042424
              ],
              [
                60.1431245,
                27.0051984
              ],
              [
                60.1525941,
                27.0061128
              ],
              [
                60.1581066,
                27.0058834
              ],
              [
                60.1769211,
                27.0056713
              ],
              [
                60.1834191,
                27.0061574
              ],
              [
                60.189933,
                27.0069713
              ],
              [
                60.1968196,
                27.0073044
              ],
              [
                60.202938,
                27.0077632
              ],
              [
                60.2096459,
                27.0074081
              ],
              [
                60.2163625,
                27.0070257
              ],
              [
                60.2231632,
                27.0066616
              ],
              [
                60.2247407,
                27.0062792
              ],
              [
                60.2379737,
                27.0080056
              ],
              [
                60.2497304,
                27.0095842
              ],
              [
                60.2518621,
                27.0089724
              ],
              [
                60.2632047,
                27.0092511
              ],
              [
                60.2787479,
                27.0097863
              ],
              [
                60.2944524,
                27.0110371
              ],
              [
                60.3106652,
                27.0114959
              ],
              [
                60.330118,
                27.0120944
              ],
              [
                60.3383665,
                27.0123641
              ],
              [
                60.3537236,
                27.0132684
              ],
              [
                60.3558367,
                27.0131344
              ],
              [
                60.3611375,
                27.0125977
              ],
              [
                60.3706976,
                27.0098003
              ],
              [
                60.375671,
                27.0081069
              ],
              [
                60.3791084,
                27.0067304
              ],
              [
                60.3886737,
                27.0026664
              ],
              [
                60.3957747,
                27.000003
              ],
              [
                60.4028137,
                26.9964458
              ],
              [
                60.4140323,
                26.9905046
              ],
              [
                60.4190969,
                26.9883625
              ],
              [
                60.4268639,
                26.9842711
              ],
              [
                60.435103,
                26.9780761
              ],
              [
                60.4391377,
                26.9749012
              ],
              [
                60.4457809,
                26.9707057
              ],
              [
                60.4520981,
                26.9678253
              ],
              [
                60.4577623,
                26.9653015
              ],
              [
                60.4629987,
                26.9657599
              ],
              [
                60.4678926,
                26.9644722
              ],
              [
                60.4872485,
                26.9304585
              ],
              [
                60.5094117,
                26.9196989
              ],
              [
                60.5408642,
                26.9182323
              ],
              [
                60.5597298,
                26.9190094
              ],
              [
                60.5741487,
                26.9260506
              ],
              [
                60.5849646,
                26.9350792
              ],
              [
                60.593376,
                26.9448733
              ],
              [
                60.6071089,
                26.9676719
              ],
              [
                60.577185,
                26.9880312
              ],
              [
                60.5313815,
                27.0197724
              ],
              [
                60.5217932,
                27.0282418
              ],
              [
                60.5219505,
                27.0379413
              ],
              [
                60.5263254,
                27.0484359
              ],
              [
                60.5307268,
                27.06962
              ],
              [
                60.5367277,
                27.0867922
              ],
              [
                60.5365319,
                27.0967343
              ],
              [
                60.5398176,
                27.1046722
              ],
              [
                60.5480574,
                27.108034
              ],
              [
                60.5566405,
                27.1072699
              ],
              [
                60.5629919,
                27.111854
              ],
              [
                60.5623053,
                27.1172018
              ],
              [
                60.5564688,
                27.1251467
              ],
              [
                60.565198,
                27.1390004
              ],
              [
                60.5739029,
                27.1529751
              ],
              [
                60.5801581,
                27.1665427
              ],
              [
                60.5837646,
                27.1745938
              ],
              [
                60.5792998,
                27.1804397
              ],
              [
                60.5775213,
                27.1872891
              ],
              [
                60.5763815,
                27.1947931
              ],
              [
                60.5799246,
                27.1958141
              ],
              [
                60.579536,
                27.2043442
              ],
              [
                60.5758665,
                27.2056332
              ],
              [
                60.576555,
                27.2209196
              ],
              [
                60.5779284,
                27.2316308
              ],
              [
                60.5789696,
                27.2437131
              ],
              [
                60.5784801,
                27.2628672
              ],
              [
                60.5746649,
                27.2930792
              ],
              [
                60.5743184,
                27.3138967
              ],
              [
                60.5716351,
                27.3261963
              ],
              [
                60.5701331,
                27.3329117
              ],
              [
                60.5687777,
                27.3394752
              ],
              [
                60.5645928,
                27.3646824
              ],
              [
                60.5560812,
                27.3993414
              ],
              [
                60.5521279,
                27.4068614
              ],
              [
                60.5479311,
                27.4173008
              ],
              [
                60.5311438,
                27.4024589
              ],
              [
                60.5080567,
                27.384901
              ],
              [
                60.4991815,
                27.3810175
              ],
              [
                60.4764724,
                27.3589293
              ],
              [
                60.4444319,
                27.3345492
              ],
              [
                60.4197394,
                27.3458958
              ],
              [
                60.3990553,
                27.3531679
              ],
              [
                60.3750227,
                27.3583517
              ],
              [
                60.3511239,
                27.3659532
              ],
              [
                60.2992807,
                27.3841564
              ],
              [
                60.2802656,
                27.3934122
              ],
              [
                60.2704214,
                27.3947184
              ],
              [
                60.2445101,
                27.4033689
              ],
              [
                60.2343927,
                27.4063411
              ],
              [
                60.2213327,
                27.4098456
              ],
              [
                60.2109145,
                27.4071284
              ],
              [
                60.1765892,
                27.3900458
              ],
              [
                60.1653478,
                27.3848895
              ],
              [
                60.1564161,
                27.3806471
              ],
              [
                60.1514997,
                27.3784147
              ],
              [
                60.1288807,
                27.3690732
              ],
              [
                60.1056298,
                27.362605
              ],
              [
                60.0875567,
                27.354267
              ],
              [
                60.0543438,
                27.3425778
              ],
              [
                60.0484607,
                27.3375764
              ],
              [
                60.0398575,
                27.3315381
              ],
              [
                60.0313406,
                27.3216959
              ],
              [
                60.0236408,
                27.3091894
              ],
              [
                60.0198431,
                27.301153
              ],
              [
                60.0144145,
                27.2896583
              ],
              [
                60.0064959,
                27.2776587
              ],
              [
                60.0022743,
                27.2709718
              ],
              [
                60.0000286,
                27.2674476
              ],
              [
                59.9983689,
                27.2657341
              ],
              [
                59.9882005,
                27.2585775
              ],
              [
                59.9832057,
                27.2560794
              ],
              [
                59.9716176,
                27.2499399
              ],
              [
                59.967885,
                27.246217
              ],
              [
                59.9661877,
                27.242917
              ],
              [
                59.9656083,
                27.2400437
              ],
              [
                59.9674129,
                27.2377657
              ],
              [
                59.973936,
                27.2340263
              ],
              [
                60.0077533,
                27.2241048
              ],
              [
                60.0186538,
                27.2142587
              ],
              [
                60.015993,
                27.2007476
              ],
              [
                60.0002002,
                27.1967779
              ],
              [
                59.9985694,
                27.1974649
              ],
              [
                59.98003,
                27.1974649
              ],
              [
                59.969387,
                27.2006712
              ],
              [
                59.9638785,
                27.2004606
              ],
              [
                59.9567547,
                27.1965175
              ],
              [
                59.9499267,
                27.1942427
              ],
              [
                59.9411981,
                27.1923534
              ],
              [
                59.9256563,
                27.1921018
              ],
              [
                59.9249437,
                27.1923272
              ],
              [
                59.9055289,
                27.1688334
              ],
              [
                59.8866881,
                27.144545
              ],
              [
                59.8797967,
                27.1340761
              ],
              [
                59.8711601,
                27.1205259
              ],
              [
                59.87005,
                27.1174961
              ],
              [
                59.8681519,
                27.1134203
              ],
              [
                59.8645234,
                27.1081675
              ],
              [
                59.8613377,
                27.1031197
              ],
              [
                59.8470315,
                27.0840534
              ],
              [
                59.840821,
                27.0763961
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 12225017,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان راسک",
          "name:fr": "Comté de Rask",
          "type": "boundary",
          "wikidata": "Q85972355",
          "wikipedia": "fa:شهرستان راسک (ایران)"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                61.1828096,
                26.4210491
              ],
              [
                61.1964153,
                26.3053162
              ],
              [
                61.196695,
                26.3050379
              ],
              [
                61.196695,
                26.3039246
              ],
              [
                61.1966949,
                26.3030986
              ],
              [
                61.1964153,
                26.3011504
              ],
              [
                61.1961355,
                26.3003155
              ],
              [
                61.1961355,
                26.2914273
              ],
              [
                61.1941957,
                26.279487
              ],
              [
                61.1939152,
                26.2792087
              ],
              [
                61.196103,
                26.2708337
              ],
              [
                61.1947997,
                26.2648524
              ],
              [
                61.1941956,
                26.2603111
              ],
              [
                61.1950284,
                26.2600418
              ],
              [
                61.1991948,
                26.2580937
              ],
              [
                61.2061348,
                26.2497539
              ],
              [
                61.2069684,
                26.2464234
              ],
              [
                61.2072481,
                26.244206
              ],
              [
                61.2075286,
                26.2397624
              ],
              [
                61.2100284,
                26.2008666
              ],
              [
                61.2103937,
                26.1997673
              ],
              [
                61.2111347,
                26.1975364
              ],
              [
                61.2111346,
                26.1972581
              ],
              [
                61.2508601,
                26.1283696
              ],
              [
                61.2519734,
                26.1255873
              ],
              [
                61.2564203,
                26.1147546
              ],
              [
                61.2569734,
                26.1125378
              ],
              [
                61.257807,
                26.1075388
              ],
              [
                61.2580867,
                26.1025399
              ],
              [
                61.2580866,
                26.1022527
              ],
              [
                61.2580867,
                26.1019745
              ],
              [
                61.2580867,
                26.1016963
              ],
              [
                61.2583602,
                26.1003142
              ],
              [
                61.2583601,
                26.0955936
              ],
              [
                61.257807,
                26.0916986
              ],
              [
                61.2575265,
                26.090864
              ],
              [
                61.2575265,
                26.0828139
              ],
              [
                61.250027,
                26.0430862
              ],
              [
                61.250027,
                26.0422606
              ],
              [
                61.2494738,
                26.0394788
              ],
              [
                61.2491934,
                26.0386442
              ],
              [
                61.2486403,
                26.0361406
              ],
              [
                61.2483597,
                26.0353061
              ],
              [
                61.2480801,
                26.0344805
              ],
              [
                61.2469738,
                26.0300296
              ],
              [
                61.2466934,
                26.0283606
              ],
              [
                61.2464136,
                26.0278043
              ],
              [
                61.2453066,
                26.0219716
              ],
              [
                61.2450268,
                26.0217024
              ],
              [
                61.2450269,
                26.0164172
              ],
              [
                61.24364,
                26.0066992
              ],
              [
                61.2433604,
                26.0064211
              ],
              [
                61.2433603,
                25.9991979
              ],
              [
                61.2464135,
                25.9922529
              ],
              [
                61.2461401,
                25.9850299
              ],
              [
                61.2455798,
                25.9814228
              ],
              [
                61.2453065,
                25.9800321
              ],
              [
                61.2450267,
                25.9775288
              ],
              [
                61.244747,
                25.976147
              ],
              [
                61.2444735,
                25.9744781
              ],
              [
                61.2441931,
                25.9728092
              ],
              [
                61.2439134,
                25.9722529
              ],
              [
                61.244193,
                25.9400339
              ],
              [
                61.2444734,
                25.9394776
              ],
              [
                61.2472461,
                25.9305866
              ],
              [
                61.2539911,
                25.9257714
              ],
              [
                61.3022524,
                25.9111451
              ],
              [
                61.3030853,
                25.9111451
              ],
              [
                61.3036392,
                25.910858
              ],
              [
                61.4025875,
                25.9605144
              ],
              [
                61.5510976,
                25.9592746
              ],
              [
                61.6268672,
                25.950909
              ],
              [
                61.6600464,
                25.8830825
              ],
              [
                61.6630996,
                25.8797454
              ],
              [
                61.7053251,
                25.8350275
              ],
              [
                61.7244918,
                25.8214202
              ],
              [
                61.7256051,
                25.8211332
              ],
              [
                61.727545,
                25.8200298
              ],
              [
                61.7517179,
                25.8114188
              ],
              [
                61.7536578,
                25.8111408
              ],
              [
                61.7553242,
                25.8105847
              ],
              [
                61.7564375,
                25.8105847
              ],
              [
                61.7622713,
                25.8097504
              ],
              [
                61.7683839,
                25.8097505
              ],
              [
                61.770051,
                25.8094724
              ],
              [
                61.7708839,
                25.8097505
              ],
              [
                61.7819903,
                25.8097504
              ],
              [
                61.7869974,
                25.8103065
              ],
              [
                61.7897701,
                25.8103065
              ],
              [
                61.8031032,
                25.8119658
              ],
              [
                61.8058836,
                25.8119658
              ],
              [
                61.8067165,
                25.8122528
              ],
              [
                61.8256098,
                25.8150244
              ],
              [
                61.8406092,
                25.8200295
              ],
              [
                61.841996,
                25.8200295
              ],
              [
                61.841996,
                25.8203076
              ],
              [
                61.8436632,
                25.8203076
              ],
              [
                61.8450492,
                25.8208637
              ],
              [
                61.8484221,
                25.8222423
              ],
              [
                61.848895,
                25.822397
              ],
              [
                61.848867,
                25.82259
              ],
              [
                61.848463,
                25.822813
              ],
              [
                61.848233,
                25.823
              ],
              [
                61.848028,
                25.822979
              ],
              [
                61.847926,
                25.823058
              ],
              [
                61.847798,
                25.823039
              ],
              [
                61.84759,
                25.82316
              ],
              [
                61.846935,
                25.823342
              ],
              [
                61.846524,
                25.823399
              ],
              [
                61.84642,
                25.823379
              ],
              [
                61.84632,
                25.82357
              ],
              [
                61.846065,
                25.823649
              ],
              [
                61.845693,
                25.823683
              ],
              [
                61.845138,
                25.823861
              ],
              [
                61.844642,
                25.823841
              ],
              [
                61.84428,
                25.823929
              ],
              [
                61.844164,
                25.824332
              ],
              [
                61.844195,
                25.824443
              ],
              [
                61.844141,
                25.824455
              ],
              [
                61.843582,
                25.824483
              ],
              [
                61.843422,
                25.824588
              ],
              [
                61.842487,
                25.824661
              ],
              [
                61.84218,
                25.82479
              ],
              [
                61.84205,
                25.824772
              ],
              [
                61.841957,
                25.824651
              ],
              [
                61.84176,
                25.824654
              ],
              [
                61.841396,
                25.824752
              ],
              [
                61.841221,
                25.824857
              ],
              [
                61.841111,
                25.824861
              ],
              [
                61.840878,
                25.825002
              ],
              [
                61.840203,
                25.825163
              ],
              [
                61.839823,
                25.825166
              ],
              [
                61.839746,
                25.825235
              ],
              [
                61.839617,
                25.825245
              ],
              [
                61.839117,
                25.824713
              ],
              [
                61.838888,
                25.824756
              ],
              [
                61.838852,
                25.824907
              ],
              [
                61.838888,
                25.824916
              ],
              [
                61.838794,
                25.825091
              ],
              [
                61.838327,
                25.825369
              ],
              [
                61.838369,
                25.825461
              ],
              [
                61.838063,
                25.825744
              ],
              [
                61.838201,
                25.826224
              ],
              [
                61.838304,
                25.82644
              ],
              [
                61.838406,
                25.82653
              ],
              [
                61.838367,
                25.826623
              ],
              [
                61.83832,
                25.826634
              ],
              [
                61.838401,
                25.826812
              ],
              [
                61.838343,
                25.826952
              ],
              [
                61.83841,
                25.827225
              ],
              [
                61.838339,
                25.827405
              ],
              [
                61.838423,
                25.82758
              ],
              [
                61.838423,
                25.82774
              ],
              [
                61.838717,
                25.828234
              ],
              [
                61.838936,
                25.828865
              ],
              [
                61.838539,
                25.828982
              ],
              [
                61.838457,
                25.829055
              ],
              [
                61.838172,
                25.829097
              ],
              [
                61.838164,
                25.829316
              ],
              [
                61.838228,
                25.829358
              ],
              [
                61.838216,
                25.829444
              ],
              [
                61.838299,
                25.829554
              ],
              [
                61.838191,
                25.829629
              ],
              [
                61.838059,
                25.829834
              ],
              [
                61.837965,
                25.829853
              ],
              [
                61.837917,
                25.829996
              ],
              [
                61.838256,
                25.830111
              ],
              [
                61.839036,
                25.830231
              ],
              [
                61.839375,
                25.830349
              ],
              [
                61.839562,
                25.830334
              ],
              [
                61.839935,
                25.830411
              ],
              [
                61.840102,
                25.830555
              ],
              [
                61.840166,
                25.830773
              ],
              [
                61.840597,
                25.830865
              ],
              [
                61.841338,
                25.830834
              ],
              [
                61.841395,
                25.830868
              ],
              [
                61.841376,
                25.831006
              ],
              [
                61.841701,
                25.831056
              ],
              [
                61.84174,
                25.831105
              ],
              [
                61.842015,
                25.831067
              ],
              [
                61.841989,
                25.831807
              ],
              [
                61.842064,
                25.832016
              ],
              [
                61.842089,
                25.832331
              ],
              [
                61.841885,
                25.832567
              ],
              [
                61.841917,
                25.832691
              ],
              [
                61.841749,
                25.832949
              ],
              [
                61.841757,
                25.833098
              ],
              [
                61.841583,
                25.833396
              ],
              [
                61.841627,
                25.83352
              ],
              [
                61.840952,
                25.833483
              ],
              [
                61.840892,
                25.833647
              ],
              [
                61.841023,
                25.833795
              ],
              [
                61.841658,
                25.833941
              ],
              [
                61.841795,
                25.834229
              ],
              [
                61.841721,
                25.834231
              ],
              [
                61.841771,
                25.834505
              ],
              [
                61.841745,
                25.834748
              ],
              [
                61.841922,
                25.834747
              ],
              [
                61.842039,
                25.835034
              ],
              [
                61.842115,
                25.835034
              ],
              [
                61.842178,
                25.835109
              ],
              [
                61.842134,
                25.835175
              ],
              [
                61.842454,
                25.835287
              ],
              [
                61.842582,
                25.835266
              ],
              [
                61.842764,
                25.835565
              ],
              [
                61.842845,
                25.835574
              ],
              [
                61.842844,
                25.835611
              ],
              [
                61.843123,
                25.835779
              ],
              [
                61.843254,
                25.835769
              ],
              [
                61.843437,
                25.835878
              ],
              [
                61.843429,
                25.836125
              ],
              [
                61.843613,
                25.836495
              ],
              [
                61.84359,
                25.836616
              ],
              [
                61.842082,
                25.836635
              ],
              [
                61.841071,
                25.836724
              ],
              [
                61.840196,
                25.836704
              ],
              [
                61.839885,
                25.836758
              ],
              [
                61.840071,
                25.836843
              ],
              [
                61.840195,
                25.837057
              ],
              [
                61.840464,
                25.837139
              ],
              [
                61.840566,
                25.83732
              ],
              [
                61.841422,
                25.837437
              ],
              [
                61.841824,
                25.837423
              ],
              [
                61.842254,
                25.837509
              ],
              [
                61.842857,
                25.837564
              ],
              [
                61.842858,
                25.837757
              ],
              [
                61.842794,
                25.837894
              ],
              [
                61.84312,
                25.838137
              ],
              [
                61.843087,
                25.838259
              ],
              [
                61.843124,
                25.838435
              ],
              [
                61.843226,
                25.838514
              ],
              [
                61.843035,
                25.838811
              ],
              [
                61.843115,
                25.838877
              ],
              [
                61.843086,
                25.839184
              ],
              [
                61.843044,
                25.839215
              ],
              [
                61.843138,
                25.839362
              ],
              [
                61.843023,
                25.839668
              ],
              [
                61.842825,
                25.839699
              ],
              [
                61.842586,
                25.83951
              ],
              [
                61.842425,
                25.839465
              ],
              [
                61.842408,
                25.839407
              ],
              [
                61.84232,
                25.839407
              ],
              [
                61.84227,
                25.839323
              ],
              [
                61.842213,
                25.839331
              ],
              [
                61.842137,
                25.83944
              ],
              [
                61.841719,
                25.839403
              ],
              [
                61.841652,
                25.839339
              ],
              [
                61.841538,
                25.839376
              ],
              [
                61.841472,
                25.839348
              ],
              [
                61.841327,
                25.839207
              ],
              [
                61.841125,
                25.839239
              ],
              [
                61.841102,
                25.839192
              ],
              [
                61.841023,
                25.839204
              ],
              [
                61.840896,
                25.839136
              ],
              [
                61.840777,
                25.839162
              ],
              [
                61.8406,
                25.839312
              ],
              [
                61.840448,
                25.839369
              ],
              [
                61.840035,
                25.839177
              ],
              [
                61.839962,
                25.839067
              ],
              [
                61.839702,
                25.838968
              ],
              [
                61.839582,
                25.838859
              ],
              [
                61.839089,
                25.838954
              ],
              [
                61.838811,
                25.838831
              ],
              [
                61.838689,
                25.838845
              ],
              [
                61.838415,
                25.838962
              ],
              [
                61.838219,
                25.838925
              ],
              [
                61.83777,
                25.838989
              ],
              [
                61.837612,
                25.839113
              ],
              [
                61.837239,
                25.839059
              ],
              [
                61.836997,
                25.838965
              ],
              [
                61.836848,
                25.839004
              ],
              [
                61.836563,
                25.838955
              ],
              [
                61.836171,
                25.839134
              ],
              [
                61.836008,
                25.839115
              ],
              [
                61.835946,
                25.839047
              ],
              [
                61.835858,
                25.83923
              ],
              [
                61.835955,
                25.839277
              ],
              [
                61.835999,
                25.839439
              ],
              [
                61.835945,
                25.839525
              ],
              [
                61.835858,
                25.839552
              ],
              [
                61.835436,
                25.839502
              ],
              [
                61.83532,
                25.839753
              ],
              [
                61.835061,
                25.839813
              ],
              [
                61.835162,
                25.83992
              ],
              [
                61.834935,
                25.839991
              ],
              [
                61.834835,
                25.839923
              ],
              [
                61.834526,
                25.839941
              ],
              [
                61.83433,
                25.840313
              ],
              [
                61.834151,
                25.840537
              ],
              [
                61.834084,
                25.840732
              ],
              [
                61.834124,
                25.840799
              ],
              [
                61.834008,
                25.84086
              ],
              [
                61.833968,
                25.841013
              ],
              [
                61.834022,
                25.841182
              ],
              [
                61.833927,
                25.841215
              ],
              [
                61.833886,
                25.841181
              ],
              [
                61.833775,
                25.841191
              ],
              [
                61.833417,
                25.841439
              ],
              [
                61.833009,
                25.8415
              ],
              [
                61.832854,
                25.841732
              ],
              [
                61.832659,
                25.841885
              ],
              [
                61.832635,
                25.842024
              ],
              [
                61.832554,
                25.842089
              ],
              [
                61.832341,
                25.842097
              ],
              [
                61.831925,
                25.842339
              ],
              [
                61.831456,
                25.842224
              ],
              [
                61.831291,
                25.842121
              ],
              [
                61.830956,
                25.842019
              ],
              [
                61.830895,
                25.841928
              ],
              [
                61.830449,
                25.841908
              ],
              [
                61.830102,
                25.841968
              ],
              [
                61.830035,
                25.841859
              ],
              [
                61.829928,
                25.841795
              ],
              [
                61.829676,
                25.841773
              ],
              [
                61.829522,
                25.84165
              ],
              [
                61.828793,
                25.841676
              ],
              [
                61.828078,
                25.841347
              ],
              [
                61.827572,
                25.841543
              ],
              [
                61.827511,
                25.841609
              ],
              [
                61.826783,
                25.841325
              ],
              [
                61.826212,
                25.841228
              ],
              [
                61.826034,
                25.841102
              ],
              [
                61.824968,
                25.840674
              ],
              [
                61.824906,
                25.840588
              ],
              [
                61.824302,
                25.840545
              ],
              [
                61.824237,
                25.840045
              ],
              [
                61.8243,
                25.839978
              ],
              [
                61.824101,
                25.839884
              ],
              [
                61.82398,
                25.839863
              ],
              [
                61.823846,
                25.839966
              ],
              [
                61.823725,
                25.839935
              ],
              [
                61.82355,
                25.839987
              ],
              [
                61.823367,
                25.840101
              ],
              [
                61.823172,
                25.840159
              ],
              [
                61.823199,
                25.84066
              ],
              [
                61.822965,
                25.840975
              ],
              [
                61.822473,
                25.841318
              ],
              [
                61.82248,
                25.841692
              ],
              [
                61.822413,
                25.841702
              ],
              [
                61.822412,
                25.841841
              ],
              [
                61.822298,
                25.842008
              ],
              [
                61.822329,
                25.842053
              ],
              [
                61.822152,
                25.842329
              ],
              [
                61.822076,
                25.842852
              ],
              [
                61.822357,
                25.842978
              ],
              [
                61.822345,
                25.843031
              ],
              [
                61.822269,
                25.843137
              ],
              [
                61.821968,
                25.843284
              ],
              [
                61.821753,
                25.84326
              ],
              [
                61.821562,
                25.843621
              ],
              [
                61.821585,
                25.843772
              ],
              [
                61.821634,
                25.84378
              ],
              [
                61.821594,
                25.843875
              ],
              [
                61.821679,
                25.844045
              ],
              [
                61.821537,
                25.844207
              ],
              [
                61.821397,
                25.844156
              ],
              [
                61.821356,
                25.844182
              ],
              [
                61.821293,
                25.844312
              ],
              [
                61.821359,
                25.844539
              ],
              [
                61.821279,
                25.844766
              ],
              [
                61.821351,
                25.845152
              ],
              [
                61.821349,
                25.84601
              ],
              [
                61.821098,
                25.846275
              ],
              [
                61.820989,
                25.846501
              ],
              [
                61.820958,
                25.846641
              ],
              [
                61.821008,
                25.846873
              ],
              [
                61.82094,
                25.847097
              ],
              [
                61.820969,
                25.8472
              ],
              [
                61.820927,
                25.847261
              ],
              [
                61.820928,
                25.847537
              ],
              [
                61.820747,
                25.848045
              ],
              [
                61.820734,
                25.848411
              ],
              [
                61.820661,
                25.848644
              ],
              [
                61.820479,
                25.848929
              ],
              [
                61.820502,
                25.849016
              ],
              [
                61.820408,
                25.849211
              ],
              [
                61.820531,
                25.849252
              ],
              [
                61.820597,
                25.849333
              ],
              [
                61.820785,
                25.849368
              ],
              [
                61.821018,
                25.849498
              ],
              [
                61.821125,
                25.849365
              ],
              [
                61.821314,
                25.849267
              ],
              [
                61.821483,
                25.849271
              ],
              [
                61.821776,
                25.849341
              ],
              [
                61.822412,
                25.849362
              ],
              [
                61.822722,
                25.849515
              ],
              [
                61.823029,
                25.849562
              ],
              [
                61.823235,
                25.849671
              ],
              [
                61.823345,
                25.849811
              ],
              [
                61.823423,
                25.849809
              ],
              [
                61.823423,
                25.849851
              ],
              [
                61.823588,
                25.849847
              ],
              [
                61.823988,
                25.849935
              ],
              [
                61.82437,
                25.849818
              ],
              [
                61.824421,
                25.849894
              ],
              [
                61.824432,
                25.850066
              ],
              [
                61.824712,
                25.850364
              ],
              [
                61.824794,
                25.850377
              ],
              [
                61.824831,
                25.850503
              ],
              [
                61.825541,
                25.850816
              ],
              [
                61.825642,
                25.850951
              ],
              [
                61.825843,
                25.850977
              ],
              [
                61.825844,
                25.851095
              ],
              [
                61.825907,
                25.851089
              ],
              [
                61.826087,
                25.851209
              ],
              [
                61.82605,
                25.851262
              ],
              [
                61.826061,
                25.851532
              ],
              [
                61.825983,
                25.851703
              ],
              [
                61.825792,
                25.8519
              ],
              [
                61.825796,
                25.851989
              ],
              [
                61.825709,
                25.852005
              ],
              [
                61.825708,
                25.852098
              ],
              [
                61.825915,
                25.85223
              ],
              [
                61.825936,
                25.852298
              ],
              [
                61.82603,
                25.85236
              ],
              [
                61.826144,
                25.852377
              ],
              [
                61.826291,
                25.852284
              ],
              [
                61.826402,
                25.852569
              ],
              [
                61.82664,
                25.852566
              ],
              [
                61.826802,
                25.852507
              ],
              [
                61.82702,
                25.852614
              ],
              [
                61.827038,
                25.852564
              ],
              [
                61.827111,
                25.852574
              ],
              [
                61.827149,
                25.852514
              ],
              [
                61.827459,
                25.852438
              ],
              [
                61.827688,
                25.852466
              ],
              [
                61.827947,
                25.852401
              ],
              [
                61.827969,
                25.852432
              ],
              [
                61.828411,
                25.852374
              ],
              [
                61.828467,
                25.852007
              ],
              [
                61.828857,
                25.852025
              ],
              [
                61.829234,
                25.852245
              ],
              [
                61.829546,
                25.852344
              ],
              [
                61.829777,
                25.852359
              ],
              [
                61.830074,
                25.852468
              ],
              [
                61.830257,
                25.852616
              ],
              [
                61.83062,
                25.852585
              ],
              [
                61.830732,
                25.852704
              ],
              [
                61.83069,
                25.85286
              ],
              [
                61.830721,
                25.85291
              ],
              [
                61.830662,
                25.853004
              ],
              [
                61.830692,
                25.85308
              ],
              [
                61.830628,
                25.853099
              ],
              [
                61.830682,
                25.85314
              ],
              [
                61.830657,
                25.853242
              ],
              [
                61.830707,
                25.853381
              ],
              [
                61.830612,
                25.853533
              ],
              [
                61.830652,
                25.853669
              ],
              [
                61.831261,
                25.853889
              ],
              [
                61.831358,
                25.854036
              ],
              [
                61.831475,
                25.853958
              ],
              [
                61.831635,
                25.853929
              ],
              [
                61.831774,
                25.854034
              ],
              [
                61.83202,
                25.854097
              ],
              [
                61.832041,
                25.854654
              ],
              [
                61.832099,
                25.85468
              ],
              [
                61.832058,
                25.854727
              ],
              [
                61.832198,
                25.854973
              ],
              [
                61.831834,
                25.85528
              ],
              [
                61.831574,
                25.855713
              ],
              [
                61.831391,
                25.855924
              ],
              [
                61.831471,
                25.856077
              ],
              [
                61.831522,
                25.856091
              ],
              [
                61.831517,
                25.856206
              ],
              [
                61.831479,
                25.85622
              ],
              [
                61.83144,
                25.856402
              ],
              [
                61.831321,
                25.856491
              ],
              [
                61.831305,
                25.856654
              ],
              [
                61.831058,
                25.856696
              ],
              [
                61.830924,
                25.856639
              ],
              [
                61.830498,
                25.856643
              ],
              [
                61.830373,
                25.856438
              ],
              [
                61.830287,
                25.856398
              ],
              [
                61.830127,
                25.856337
              ],
              [
                61.829882,
                25.856374
              ],
              [
                61.829951,
                25.856644
              ],
              [
                61.829923,
                25.856693
              ],
              [
                61.830007,
                25.856852
              ],
              [
                61.829951,
                25.856941
              ],
              [
                61.830061,
                25.857102
              ],
              [
                61.830087,
                25.857245
              ],
              [
                61.82987,
                25.857535
              ],
              [
                61.829622,
                25.857582
              ],
              [
                61.829764,
                25.857767
              ],
              [
                61.829807,
                25.857977
              ],
              [
                61.829856,
                25.857996
              ],
              [
                61.829908,
                25.858135
              ],
              [
                61.830313,
                25.858355
              ],
              [
                61.83035,
                25.858501
              ],
              [
                61.830505,
                25.858552
              ],
              [
                61.830572,
                25.858635
              ],
              [
                61.830666,
                25.858911
              ],
              [
                61.830728,
                25.858962
              ],
              [
                61.830693,
                25.859151
              ],
              [
                61.830634,
                25.859201
              ],
              [
                61.830726,
                25.859271
              ],
              [
                61.830708,
                25.85933
              ],
              [
                61.830997,
                25.859394
              ],
              [
                61.831034,
                25.859528
              ],
              [
                61.83122,
                25.859488
              ],
              [
                61.831407,
                25.859874
              ],
              [
                61.831231,
                25.860006
              ],
              [
                61.831216,
                25.860423
              ],
              [
                61.831134,
                25.86041
              ],
              [
                61.831155,
                25.860476
              ],
              [
                61.830986,
                25.860451
              ],
              [
                61.830987,
                25.860573
              ],
              [
                61.831038,
                25.860569
              ],
              [
                61.831068,
                25.860684
              ],
              [
                61.831495,
                25.86077
              ],
              [
                61.831574,
                25.860851
              ],
              [
                61.831322,
                25.861112
              ],
              [
                61.831333,
                25.861159
              ],
              [
                61.831121,
                25.861308
              ],
              [
                61.830809,
                25.861346
              ],
              [
                61.830838,
                25.861572
              ],
              [
                61.830968,
                25.8616
              ],
              [
                61.830971,
                25.861655
              ],
              [
                61.831082,
                25.861663
              ],
              [
                61.831185,
                25.861746
              ],
              [
                61.831197,
                25.861837
              ],
              [
                61.831053,
                25.861877
              ],
              [
                61.831076,
                25.861993
              ],
              [
                61.830994,
                25.862295
              ],
              [
                61.831043,
                25.862356
              ],
              [
                61.830995,
                25.86255
              ],
              [
                61.831104,
                25.862633
              ],
              [
                61.83114,
                25.86283
              ],
              [
                61.831521,
                25.862855
              ],
              [
                61.832033,
                25.86282
              ],
              [
                61.831979,
                25.862977
              ],
              [
                61.831957,
                25.863509
              ],
              [
                61.831988,
                25.86368
              ],
              [
                61.832065,
                25.863777
              ],
              [
                61.8319826,
                25.8638147
              ],
              [
                61.831864,
                25.863869
              ],
              [
                61.831903,
                25.86401
              ],
              [
                61.832077,
                25.8641
              ],
              [
                61.832145,
                25.864264
              ],
              [
                61.832088,
                25.864459
              ],
              [
                61.832103,
                25.864586
              ],
              [
                61.83216,
                25.864701
              ],
              [
                61.832178,
                25.864925
              ],
              [
                61.8323,
                25.865191
              ],
              [
                61.83224,
                25.865355
              ],
              [
                61.832516,
                25.865375
              ],
              [
                61.832992,
                25.86528
              ],
              [
                61.834603,
                25.86514
              ],
              [
                61.834604,
                25.865316
              ],
              [
                61.834704,
                25.865572
              ],
              [
                61.83472,
                25.865782
              ],
              [
                61.835168,
                25.865883
              ],
              [
                61.83559,
                25.86591
              ],
              [
                61.835565,
                25.86604
              ],
              [
                61.835686,
                25.866324
              ],
              [
                61.835637,
                25.866512
              ],
              [
                61.835804,
                25.866756
              ],
              [
                61.835806,
                25.866853
              ],
              [
                61.835959,
                25.866872
              ],
              [
                61.836843,
                25.866728
              ],
              [
                61.837555,
                25.86667
              ],
              [
                61.837834,
                25.866726
              ],
              [
                61.838534,
                25.866679
              ],
              [
                61.838752,
                25.866622
              ],
              [
                61.838945,
                25.866643
              ],
              [
                61.839591,
                25.866518
              ],
              [
                61.839918,
                25.866543
              ],
              [
                61.841004,
                25.866482
              ],
              [
                61.841587,
                25.86636
              ],
              [
                61.841881,
                25.866144
              ],
              [
                61.84276,
                25.866145
              ],
              [
                61.843375,
                25.866011
              ],
              [
                61.84355,
                25.866086
              ],
              [
                61.843555,
                25.866336
              ],
              [
                61.843479,
                25.866619
              ],
              [
                61.843607,
                25.866976
              ],
              [
                61.843549,
                25.867148
              ],
              [
                61.843568,
                25.867228
              ],
              [
                61.843208,
                25.86733
              ],
              [
                61.843082,
                25.867427
              ],
              [
                61.842635,
                25.8676
              ],
              [
                61.842622,
                25.867648
              ],
              [
                61.842388,
                25.867765
              ],
              [
                61.842281,
                25.8679
              ],
              [
                61.842308,
                25.868159
              ],
              [
                61.842485,
                25.868345
              ],
              [
                61.842771,
                25.868447
              ],
              [
                61.842821,
                25.868702
              ],
              [
                61.84291,
                25.868784
              ],
              [
                61.842676,
                25.868983
              ],
              [
                61.842415,
                25.86909
              ],
              [
                61.842322,
                25.869181
              ],
              [
                61.842026,
                25.869244
              ],
              [
                61.841514,
                25.869266
              ],
              [
                61.841575,
                25.869619
              ],
              [
                61.841772,
                25.869681
              ],
              [
                61.841866,
                25.869808
              ],
              [
                61.841895,
                25.870224
              ],
              [
                61.841829,
                25.870487
              ],
              [
                61.841851,
                25.87058
              ],
              [
                61.841948,
                25.870637
              ],
              [
                61.841901,
                25.870789
              ],
              [
                61.842009,
                25.870997
              ],
              [
                61.841995,
                25.871231
              ],
              [
                61.841843,
                25.871254
              ],
              [
                61.841652,
                25.871659
              ],
              [
                61.84168,
                25.871839
              ],
              [
                61.840912,
                25.871889
              ],
              [
                61.840731,
                25.871833
              ],
              [
                61.840361,
                25.871853
              ],
              [
                61.840241,
                25.871805
              ],
              [
                61.839971,
                25.871789
              ],
              [
                61.839046,
                25.871783
              ],
              [
                61.83887,
                25.87187
              ],
              [
                61.838743,
                25.872106
              ],
              [
                61.838775,
                25.872555
              ],
              [
                61.838891,
                25.872984
              ],
              [
                61.839023,
                25.87321
              ],
              [
                61.839369,
                25.873566
              ],
              [
                61.839722,
                25.874119
              ],
              [
                61.839935,
                25.874352
              ],
              [
                61.840005,
                25.87464
              ],
              [
                61.840058,
                25.874686
              ],
              [
                61.840173,
                25.874596
              ],
              [
                61.840274,
                25.874587
              ],
              [
                61.840306,
                25.874702
              ],
              [
                61.840227,
                25.874888
              ],
              [
                61.840274,
                25.875077
              ],
              [
                61.84119,
                25.875112
              ],
              [
                61.841783,
                25.875201
              ],
              [
                61.842067,
                25.875294
              ],
              [
                61.842077,
                25.875649
              ],
              [
                61.841942,
                25.875724
              ],
              [
                61.841992,
                25.875961
              ],
              [
                61.841853,
                25.876227
              ],
              [
                61.841843,
                25.876456
              ],
              [
                61.84197,
                25.877036
              ],
              [
                61.84219,
                25.877674
              ],
              [
                61.842866,
                25.877821
              ],
              [
                61.843375,
                25.877865
              ],
              [
                61.843816,
                25.877832
              ],
              [
                61.843918,
                25.877763
              ],
              [
                61.844233,
                25.87778
              ],
              [
                61.844454,
                25.877713
              ],
              [
                61.844811,
                25.8777
              ],
              [
                61.844961,
                25.877747
              ],
              [
                61.845441,
                25.877712
              ],
              [
                61.84566,
                25.877761
              ],
              [
                61.845985,
                25.877717
              ],
              [
                61.846345,
                25.877824
              ],
              [
                61.846656,
                25.877759
              ],
              [
                61.846695,
                25.877821
              ],
              [
                61.847038,
                25.877894
              ],
              [
                61.847105,
                25.877966
              ],
              [
                61.847239,
                25.87797
              ],
              [
                61.847221,
                25.878019
              ],
              [
                61.847274,
                25.878037
              ],
              [
                61.847459,
                25.878046
              ],
              [
                61.847611,
                25.878125
              ],
              [
                61.847927,
                25.878124
              ],
              [
                61.848081,
                25.878254
              ],
              [
                61.848589,
                25.878381
              ],
              [
                61.848947,
                25.878391
              ],
              [
                61.849251,
                25.879093
              ],
              [
                61.849947,
                25.8792
              ],
              [
                61.850508,
                25.879131
              ],
              [
                61.851137,
                25.879162
              ],
              [
                61.851296,
                25.879292
              ],
              [
                61.851543,
                25.879252
              ],
              [
                61.851662,
                25.879296
              ],
              [
                61.851977,
                25.87929
              ],
              [
                61.85235,
                25.879344
              ],
              [
                61.852941,
                25.87953
              ],
              [
                61.853103,
                25.879459
              ],
              [
                61.853363,
                25.87958
              ],
              [
                61.853379,
                25.879776
              ],
              [
                61.85358,
                25.879559
              ],
              [
                61.85381,
                25.87955
              ],
              [
                61.853907,
                25.87919
              ],
              [
                61.854343,
                25.879177
              ],
              [
                61.854437,
                25.879114
              ],
              [
                61.854375,
                25.879018
              ],
              [
                61.854394,
                25.878973
              ],
              [
                61.854553,
                25.878875
              ],
              [
                61.854659,
                25.878884
              ],
              [
                61.854967,
                25.879019
              ],
              [
                61.85516,
                25.879021
              ],
              [
                61.855715,
                25.879218
              ],
              [
                61.855963,
                25.879225
              ],
              [
                61.856382,
                25.879368
              ],
              [
                61.856569,
                25.879367
              ],
              [
                61.856725,
                25.879297
              ],
              [
                61.856764,
                25.879397
              ],
              [
                61.85707,
                25.879523
              ],
              [
                61.857163,
                25.87952
              ],
              [
                61.857364,
                25.879743
              ],
              [
                61.857517,
                25.879804
              ],
              [
                61.857591,
                25.879935
              ],
              [
                61.857565,
                25.880301
              ],
              [
                61.857872,
                25.880473
              ],
              [
                61.858113,
                25.880472
              ],
              [
                61.858331,
                25.880558
              ],
              [
                61.858433,
                25.880697
              ],
              [
                61.858541,
                25.880506
              ],
              [
                61.858618,
                25.880437
              ],
              [
                61.858742,
                25.880419
              ],
              [
                61.859002,
                25.880535
              ],
              [
                61.859107,
                25.880627
              ],
              [
                61.859336,
                25.880614
              ],
              [
                61.859702,
                25.880678
              ],
              [
                61.859837,
                25.88077
              ],
              [
                61.860155,
                25.880862
              ],
              [
                61.860205,
                25.880931
              ],
              [
                61.860642,
                25.880983
              ],
              [
                61.860703,
                25.88104
              ],
              [
                61.860907,
                25.880983
              ],
              [
                61.860863,
                25.881041
              ],
              [
                61.8611,
                25.881082
              ],
              [
                61.861556,
                25.881343
              ],
              [
                61.861738,
                25.881338
              ],
              [
                61.861749,
                25.881429
              ],
              [
                61.862064,
                25.881465
              ],
              [
                61.862165,
                25.881414
              ],
              [
                61.86279,
                25.881655
              ],
              [
                61.863029,
                25.881542
              ],
              [
                61.863488,
                25.88152
              ],
              [
                61.86365,
                25.881454
              ],
              [
                61.863783,
                25.881389
              ],
              [
                61.863968,
                25.88117
              ],
              [
                61.864238,
                25.881061
              ],
              [
                61.864417,
                25.880501
              ],
              [
                61.864382,
                25.880354
              ],
              [
                61.864424,
                25.880198
              ],
              [
                61.864611,
                25.880216
              ],
              [
                61.865439,
                25.880128
              ],
              [
                61.865617,
                25.88017
              ],
              [
                61.865825,
                25.880114
              ],
              [
                61.866066,
                25.880173
              ],
              [
                61.866545,
                25.880175
              ],
              [
                61.866968,
                25.880271
              ],
              [
                61.867197,
                25.880258
              ],
              [
                61.867641,
                25.880382
              ],
              [
                61.867833,
                25.880362
              ],
              [
                61.868127,
                25.880522
              ],
              [
                61.868283,
                25.880494
              ],
              [
                61.868282,
                25.88055
              ],
              [
                61.868546,
                25.880456
              ],
              [
                61.868809,
                25.880525
              ],
              [
                61.869165,
                25.880508
              ],
              [
                61.86948,
                25.880609
              ],
              [
                61.869597,
                25.880727
              ],
              [
                61.869577,
                25.880809
              ],
              [
                61.869758,
                25.88093
              ],
              [
                61.869933,
                25.881168
              ],
              [
                61.870112,
                25.881173
              ],
              [
                61.870498,
                25.881052
              ],
              [
                61.871112,
                25.880956
              ],
              [
                61.871506,
                25.880974
              ],
              [
                61.871949,
                25.881159
              ],
              [
                61.872049,
                25.881122
              ],
              [
                61.872436,
                25.88115
              ],
              [
                61.872718,
                25.881072
              ],
              [
                61.872935,
                25.881195
              ],
              [
                61.873212,
                25.881095
              ],
              [
                61.873429,
                25.881158
              ],
              [
                61.873661,
                25.881158
              ],
              [
                61.874554,
                25.881114
              ],
              [
                61.874676,
                25.881069
              ],
              [
                61.874784,
                25.880938
              ],
              [
                61.874862,
                25.880414
              ],
              [
                61.874759,
                25.880103
              ],
              [
                61.874788,
                25.879996
              ],
              [
                61.875417,
                25.879837
              ],
              [
                61.875721,
                25.87981
              ],
              [
                61.875918,
                25.879682
              ],
              [
                61.876264,
                25.879643
              ],
              [
                61.876584,
                25.879668
              ],
              [
                61.876694,
                25.879739
              ],
              [
                61.877056,
                25.879794
              ],
              [
                61.877384,
                25.879897
              ],
              [
                61.877438,
                25.879873
              ],
              [
                61.877529,
                25.879945
              ],
              [
                61.877654,
                25.879862
              ],
              [
                61.878332,
                25.880078
              ],
              [
                61.878572,
                25.880039
              ],
              [
                61.878899,
                25.879695
              ],
              [
                61.879149,
                25.879659
              ],
              [
                61.879456,
                25.87984
              ],
              [
                61.879644,
                25.880175
              ],
              [
                61.879748,
                25.880258
              ],
              [
                61.880263,
                25.880433
              ],
              [
                61.880301,
                25.880551
              ],
              [
                61.880407,
                25.880495
              ],
              [
                61.881123,
                25.880639
              ],
              [
                61.881165,
                25.88071
              ],
              [
                61.881383,
                25.88075
              ],
              [
                61.881421,
                25.880932
              ],
              [
                61.881629,
                25.880992
              ],
              [
                61.881768,
                25.881096
              ],
              [
                61.881861,
                25.881089
              ],
              [
                61.8823,
                25.881241
              ],
              [
                61.882655,
                25.881269
              ],
              [
                61.882814,
                25.881223
              ],
              [
                61.882907,
                25.88128
              ],
              [
                61.88317,
                25.881297
              ],
              [
                61.883332,
                25.881185
              ],
              [
                61.883745,
                25.881287
              ],
              [
                61.884346,
                25.881576
              ],
              [
                61.884519,
                25.881614
              ],
              [
                61.884613,
                25.881782
              ],
              [
                61.884787,
                25.881866
              ],
              [
                61.885551,
                25.882126
              ],
              [
                61.885696,
                25.882276
              ],
              [
                61.885747,
                25.882409
              ],
              [
                61.88602,
                25.882384
              ],
              [
                61.886852,
                25.882558
              ],
              [
                61.887075,
                25.882555
              ],
              [
                61.887416,
                25.882627
              ],
              [
                61.887586,
                25.882611
              ],
              [
                61.887678,
                25.882557
              ],
              [
                61.887899,
                25.882564
              ],
              [
                61.888052,
                25.882451
              ],
              [
                61.88813,
                25.882299
              ],
              [
                61.888119,
                25.881916
              ],
              [
                61.888515,
                25.881993
              ],
              [
                61.888665,
                25.881888
              ],
              [
                61.888947,
                25.88222
              ],
              [
                61.889089,
                25.882291
              ],
              [
                61.889251,
                25.882304
              ],
              [
                61.889355,
                25.882262
              ],
              [
                61.889445,
                25.882302
              ],
              [
                61.889619,
                25.882474
              ],
              [
                61.889737,
                25.882517
              ],
              [
                61.889873,
                25.882765
              ],
              [
                61.890066,
                25.882928
              ],
              [
                61.890354,
                25.882928
              ],
              [
                61.890429,
                25.882993
              ],
              [
                61.890539,
                25.882964
              ],
              [
                61.890722,
                25.883199
              ],
              [
                61.890657,
                25.883303
              ],
              [
                61.890728,
                25.88335
              ],
              [
                61.89069,
                25.883421
              ],
              [
                61.89075,
                25.88353
              ],
              [
                61.890675,
                25.883802
              ],
              [
                61.89055,
                25.883884
              ],
              [
                61.890398,
                25.883893
              ],
              [
                61.8903,
                25.883961
              ],
              [
                61.890161,
                25.883986
              ],
              [
                61.890053,
                25.884098
              ],
              [
                61.889827,
                25.884152
              ],
              [
                61.889433,
                25.88455
              ],
              [
                61.889122,
                25.884748
              ],
              [
                61.88899,
                25.884924
              ],
              [
                61.889008,
                25.885106
              ],
              [
                61.888952,
                25.885166
              ],
              [
                61.889184,
                25.885706
              ],
              [
                61.88934,
                25.885835
              ],
              [
                61.889235,
                25.8859
              ],
              [
                61.889346,
                25.885926
              ],
              [
                61.88917,
                25.886257
              ],
              [
                61.889478,
                25.886465
              ],
              [
                61.889563,
                25.886823
              ],
              [
                61.889709,
                25.887083
              ],
              [
                61.88966,
                25.887147
              ],
              [
                61.889713,
                25.88729
              ],
              [
                61.889851,
                25.887348
              ],
              [
                61.890157,
                25.887607
              ],
              [
                61.890263,
                25.887616
              ],
              [
                61.890291,
                25.887819
              ],
              [
                61.890255,
                25.887899
              ],
              [
                61.890208,
                25.887907
              ],
              [
                61.890254,
                25.888019
              ],
              [
                61.890245,
                25.888339
              ],
              [
                61.890625,
                25.888409
              ],
              [
                61.890708,
                25.888547
              ],
              [
                61.890644,
                25.888595
              ],
              [
                61.89078,
                25.888686
              ],
              [
                61.890808,
                25.888783
              ],
              [
                61.890883,
                25.888723
              ],
              [
                61.891131,
                25.888716
              ],
              [
                61.891267,
                25.888788
              ],
              [
                61.891361,
                25.888785
              ],
              [
                61.891458,
                25.889114
              ],
              [
                61.891521,
                25.889102
              ],
              [
                61.891634,
                25.889175
              ],
              [
                61.891496,
                25.889439
              ],
              [
                61.891535,
                25.889773
              ],
              [
                61.891496,
                25.890029
              ],
              [
                61.891294,
                25.890102
              ],
              [
                61.891158,
                25.890556
              ],
              [
                61.891011,
                25.890568
              ],
              [
                61.891013,
                25.890701
              ],
              [
                61.89053,
                25.890594
              ],
              [
                61.890418,
                25.890794
              ],
              [
                61.890469,
                25.891159
              ],
              [
                61.890206,
                25.891122
              ],
              [
                61.889887,
                25.89099
              ],
              [
                61.889743,
                25.890993
              ],
              [
                61.88972,
                25.890919
              ],
              [
                61.889599,
                25.890931
              ],
              [
                61.889535,
                25.890873
              ],
              [
                61.889302,
                25.890897
              ],
              [
                61.888957,
                25.891037
              ],
              [
                61.888799,
                25.891
              ],
              [
                61.888568,
                25.891056
              ],
              [
                61.888379,
                25.891034
              ],
              [
                61.888306,
                25.890913
              ],
              [
                61.888242,
                25.890874
              ],
              [
                61.888125,
                25.890886
              ],
              [
                61.888024,
                25.890756
              ],
              [
                61.887833,
                25.890832
              ],
              [
                61.88744,
                25.890745
              ],
              [
                61.887354,
                25.890761
              ],
              [
                61.887262,
                25.890708
              ],
              [
                61.887036,
                25.890721
              ],
              [
                61.886929,
                25.890777
              ],
              [
                61.886721,
                25.890676
              ],
              [
                61.886053,
                25.890606
              ],
              [
                61.884917,
                25.890874
              ],
              [
                61.884842,
                25.89079
              ],
              [
                61.884553,
                25.890727
              ],
              [
                61.884491,
                25.890673
              ],
              [
                61.884084,
                25.89076
              ],
              [
                61.884027,
                25.890835
              ],
              [
                61.883783,
                25.890837
              ],
              [
                61.883588,
                25.890895
              ],
              [
                61.883379,
                25.890895
              ],
              [
                61.883309,
                25.890852
              ],
              [
                61.882982,
                25.890878
              ],
              [
                61.882529,
                25.890775
              ],
              [
                61.88222,
                25.890941
              ],
              [
                61.881678,
                25.891006
              ],
              [
                61.881483,
                25.890957
              ],
              [
                61.880972,
                25.891072
              ],
              [
                61.880819,
                25.891067
              ],
              [
                61.88041,
                25.890865
              ],
              [
                61.880284,
                25.890874
              ],
              [
                61.880171,
                25.890936
              ],
              [
                61.879976,
                25.890947
              ],
              [
                61.879773,
                25.891109
              ],
              [
                61.879216,
                25.891112
              ],
              [
                61.878858,
                25.89131
              ],
              [
                61.87858,
                25.891388
              ],
              [
                61.878431,
                25.891363
              ],
              [
                61.878387,
                25.891427
              ],
              [
                61.878088,
                25.891499
              ],
              [
                61.878029,
                25.891561
              ],
              [
                61.877542,
                25.891778
              ],
              [
                61.877479,
                25.891928
              ],
              [
                61.877208,
                25.892074
              ],
              [
                61.876871,
                25.892213
              ],
              [
                61.876519,
                25.89223
              ],
              [
                61.876401,
                25.893007
              ],
              [
                61.876172,
                25.893141
              ],
              [
                61.875823,
                25.893148
              ],
              [
                61.875764,
                25.89346
              ],
              [
                61.875703,
                25.893498
              ],
              [
                61.875697,
                25.893638
              ],
              [
                61.875778,
                25.893833
              ],
              [
                61.875601,
                25.89392
              ],
              [
                61.875558,
                25.894197
              ],
              [
                61.875508,
                25.894257
              ],
              [
                61.875662,
                25.894493
              ],
              [
                61.874959,
                25.894525
              ],
              [
                61.874641,
                25.894267
              ],
              [
                61.874024,
                25.894057
              ],
              [
                61.873857,
                25.893901
              ],
              [
                61.873348,
                25.894175
              ],
              [
                61.873018,
                25.894097
              ],
              [
                61.872926,
                25.894152
              ],
              [
                61.872237,
                25.894296
              ],
              [
                61.872183,
                25.894567
              ],
              [
                61.872274,
                25.894779
              ],
              [
                61.871772,
                25.894921
              ],
              [
                61.871651,
                25.894888
              ],
              [
                61.87156,
                25.895026
              ],
              [
                61.870257,
                25.898252
              ],
              [
                61.869016,
                25.899663
              ],
              [
                61.868088,
                25.904018
              ],
              [
                61.868002,
                25.905076
              ],
              [
                61.867921,
                25.905451
              ],
              [
                61.867598,
                25.905601
              ],
              [
                61.867318,
                25.905635
              ],
              [
                61.866969,
                25.905617
              ],
              [
                61.866614,
                25.905674
              ],
              [
                61.866397,
                25.905612
              ],
              [
                61.865888,
                25.905629
              ],
              [
                61.865527,
                25.905585
              ],
              [
                61.8654,
                25.905632
              ],
              [
                61.865165,
                25.906338
              ],
              [
                61.865024,
                25.906425
              ],
              [
                61.864951,
                25.906696
              ],
              [
                61.865153,
                25.907246
              ],
              [
                61.865202,
                25.907545
              ],
              [
                61.865282,
                25.907675
              ],
              [
                61.865091,
                25.907818
              ],
              [
                61.865042,
                25.907911
              ],
              [
                61.8651,
                25.907952
              ],
              [
                61.865061,
                25.908202
              ],
              [
                61.864965,
                25.908262
              ],
              [
                61.864914,
                25.908365
              ],
              [
                61.864939,
                25.908566
              ],
              [
                61.865082,
                25.908679
              ],
              [
                61.865061,
                25.908851
              ],
              [
                61.865097,
                25.908938
              ],
              [
                61.865049,
                25.908975
              ],
              [
                61.865093,
                25.909079
              ],
              [
                61.86502,
                25.909387
              ],
              [
                61.864415,
                25.909403
              ],
              [
                61.864016,
                25.90932
              ],
              [
                61.863805,
                25.909359
              ],
              [
                61.863048,
                25.909283
              ],
              [
                61.862874,
                25.909357
              ],
              [
                61.862839,
                25.909252
              ],
              [
                61.862275,
                25.90926
              ],
              [
                61.862027,
                25.909186
              ],
              [
                61.861854,
                25.909223
              ],
              [
                61.861721,
                25.909094
              ],
              [
                61.86146,
                25.909064
              ],
              [
                61.861413,
                25.90897
              ],
              [
                61.861098,
                25.909053
              ],
              [
                61.860684,
                25.909047
              ],
              [
                61.860222,
                25.908942
              ],
              [
                61.859957,
                25.908955
              ],
              [
                61.85961,
                25.90889
              ],
              [
                61.859126,
                25.908696
              ],
              [
                61.859019,
                25.908749
              ],
              [
                61.858838,
                25.908713
              ],
              [
                61.858718,
                25.909142
              ],
              [
                61.858403,
                25.909776
              ],
              [
                61.858413,
                25.909858
              ],
              [
                61.85825,
                25.909916
              ],
              [
                61.858249,
                25.91001
              ],
              [
                61.858326,
                25.910003
              ],
              [
                61.858293,
                25.910035
              ],
              [
                61.858372,
                25.910099
              ],
              [
                61.858334,
                25.910237
              ],
              [
                61.858449,
                25.910318
              ],
              [
                61.85827,
                25.910525
              ],
              [
                61.85833,
                25.910752
              ],
              [
                61.858658,
                25.910797
              ],
              [
                61.858768,
                25.910875
              ],
              [
                61.858743,
                25.910912
              ],
              [
                61.858793,
                25.910977
              ],
              [
                61.858705,
                25.910989
              ],
              [
                61.858725,
                25.911051
              ],
              [
                61.858523,
                25.911108
              ],
              [
                61.858476,
                25.911308
              ],
              [
                61.858369,
                25.911282
              ],
              [
                61.858162,
                25.911358
              ],
              [
                61.858066,
                25.911315
              ],
              [
                61.857963,
                25.911367
              ],
              [
                61.857748,
                25.911646
              ],
              [
                61.857583,
                25.911635
              ],
              [
                61.857167,
                25.911718
              ],
              [
                61.857237,
                25.911846
              ],
              [
                61.857316,
                25.912269
              ],
              [
                61.857537,
                25.912504
              ],
              [
                61.857161,
                25.912672
              ],
              [
                61.857133,
                25.912832
              ],
              [
                61.857191,
                25.912933
              ],
              [
                61.857069,
                25.912923
              ],
              [
                61.856918,
                25.91319
              ],
              [
                61.856911,
                25.913612
              ],
              [
                61.85672,
                25.91369
              ],
              [
                61.856671,
                25.914334
              ],
              [
                61.85684,
                25.914788
              ],
              [
                61.856158,
                25.914823
              ],
              [
                61.855677,
                25.914914
              ],
              [
                61.8553,
                25.915116
              ],
              [
                61.855068,
                25.915029
              ],
              [
                61.854989,
                25.915044
              ],
              [
                61.854848,
                25.914954
              ],
              [
                61.854477,
                25.91493
              ],
              [
                61.854372,
                25.914773
              ],
              [
                61.854158,
                25.914682
              ],
              [
                61.853571,
                25.914695
              ],
              [
                61.853438,
                25.914739
              ],
              [
                61.853323,
                25.914956
              ],
              [
                61.853138,
                25.914982
              ],
              [
                61.85304,
                25.914935
              ],
              [
                61.852903,
                25.914727
              ],
              [
                61.852422,
                25.914664
              ],
              [
                61.851974,
                25.914674
              ],
              [
                61.851671,
                25.914553
              ],
              [
                61.851533,
                25.914421
              ],
              [
                61.851198,
                25.9144
              ],
              [
                61.851141,
                25.914168
              ],
              [
                61.851023,
                25.914059
              ],
              [
                61.850387,
                25.914203
              ],
              [
                61.849835,
                25.914554
              ],
              [
                61.849564,
                25.914797
              ],
              [
                61.849356,
                25.914752
              ],
              [
                61.849297,
                25.914805
              ],
              [
                61.848755,
                25.914665
              ],
              [
                61.848732,
                25.91459
              ],
              [
                61.848588,
                25.91457
              ],
              [
                61.84846,
                25.914482
              ],
              [
                61.84835,
                25.914246
              ],
              [
                61.848256,
                25.914156
              ],
              [
                61.84794,
                25.914136
              ],
              [
                61.847865,
                25.914066
              ],
              [
                61.847779,
                25.914106
              ],
              [
                61.847498,
                25.914056
              ],
              [
                61.847216,
                25.9141
              ],
              [
                61.846957,
                25.914
              ],
              [
                61.846494,
                25.913914
              ],
              [
                61.845749,
                25.91398
              ],
              [
                61.845611,
                25.913945
              ],
              [
                61.845233,
                25.914068
              ],
              [
                61.845019,
                25.913959
              ],
              [
                61.844539,
                25.914054
              ],
              [
                61.844013,
                25.914097
              ],
              [
                61.843874,
                25.913904
              ],
              [
                61.84371,
                25.91386
              ],
              [
                61.843594,
                25.913658
              ],
              [
                61.843449,
                25.913204
              ],
              [
                61.843195,
                25.913168
              ],
              [
                61.842515,
                25.913132
              ],
              [
                61.841698,
                25.913259
              ],
              [
                61.841309,
                25.913257
              ],
              [
                61.841163,
                25.913285
              ],
              [
                61.840895,
                25.913447
              ],
              [
                61.840731,
                25.913422
              ],
              [
                61.84066,
                25.913464
              ],
              [
                61.840335,
                25.913371
              ],
              [
                61.840112,
                25.91346
              ],
              [
                61.839688,
                25.913255
              ],
              [
                61.839354,
                25.91328
              ],
              [
                61.838972,
                25.913208
              ],
              [
                61.838783,
                25.91322
              ],
              [
                61.838535,
                25.91315
              ],
              [
                61.838311,
                25.91323
              ],
              [
                61.837779,
                25.913115
              ],
              [
                61.837075,
                25.913178
              ],
              [
                61.836996,
                25.912992
              ],
              [
                61.836785,
                25.912719
              ],
              [
                61.836749,
                25.912492
              ],
              [
                61.836502,
                25.912011
              ],
              [
                61.836519,
                25.911629
              ],
              [
                61.836489,
                25.91149
              ],
              [
                61.836387,
                25.911388
              ],
              [
                61.836256,
                25.911478
              ],
              [
                61.836193,
                25.911457
              ],
              [
                61.836126,
                25.911498
              ],
              [
                61.835339,
                25.911473
              ],
              [
                61.83508,
                25.911415
              ],
              [
                61.83492,
                25.911487
              ],
              [
                61.834691,
                25.911432
              ],
              [
                61.834503,
                25.911328
              ],
              [
                61.834281,
                25.911421
              ],
              [
                61.833758,
                25.911323
              ],
              [
                61.833135,
                25.911343
              ],
              [
                61.832665,
                25.911282
              ],
              [
                61.832446,
                25.911347
              ],
              [
                61.832335,
                25.911307
              ],
              [
                61.832101,
                25.911309
              ],
              [
                61.831706,
                25.911402
              ],
              [
                61.825024,
                25.960406
              ],
              [
                61.825001,
                25.960903
              ],
              [
                61.825075,
                25.960991
              ],
              [
                61.825098,
                25.961221
              ],
              [
                61.825,
                25.961272
              ],
              [
                61.8249,
                25.961431
              ],
              [
                61.824692,
                25.961503
              ],
              [
                61.824222,
                25.961461
              ],
              [
                61.82411,
                25.961742
              ],
              [
                61.823961,
                25.961835
              ],
              [
                61.823623,
                25.961749
              ],
              [
                61.823524,
                25.961656
              ],
              [
                61.823496,
                25.961465
              ],
              [
                61.823559,
                25.961369
              ],
              [
                61.82297,
                25.961471
              ],
              [
                61.822862,
                25.961305
              ],
              [
                61.822548,
                25.961196
              ],
              [
                61.822213,
                25.961278
              ],
              [
                61.821888,
                25.961245
              ],
              [
                61.821541,
                25.961647
              ],
              [
                61.821633,
                25.961826
              ],
              [
                61.822187,
                25.961936
              ],
              [
                61.822291,
                25.962398
              ],
              [
                61.822442,
                25.962762
              ],
              [
                61.822351,
                25.963017
              ],
              [
                61.822241,
                25.963094
              ],
              [
                61.82249,
                25.963448
              ],
              [
                61.822189,
                25.963982
              ],
              [
                61.822238,
                25.964122
              ],
              [
                61.821692,
                25.964337
              ],
              [
                61.821582,
                25.964419
              ],
              [
                61.821832,
                25.964811
              ],
              [
                61.821972,
                25.964835
              ],
              [
                61.822214,
                25.964981
              ],
              [
                61.822362,
                25.965019
              ],
              [
                61.822441,
                25.965793
              ],
              [
                61.821627,
                25.965914
              ],
              [
                61.821476,
                25.966531
              ],
              [
                61.821404,
                25.966629
              ],
              [
                61.821089,
                25.966712
              ],
              [
                61.820921,
                25.966925
              ],
              [
                61.820655,
                25.966919
              ],
              [
                61.820126,
                25.967029
              ],
              [
                61.819942,
                25.966984
              ],
              [
                61.819668,
                25.966998
              ],
              [
                61.81948,
                25.967071
              ],
              [
                61.819001,
                25.967115
              ],
              [
                61.818646,
                25.967093
              ],
              [
                61.818525,
                25.967167
              ],
              [
                61.818359,
                25.967194
              ],
              [
                61.818472,
                25.967243
              ],
              [
                61.818631,
                25.967404
              ],
              [
                61.818653,
                25.967493
              ],
              [
                61.818948,
                25.967741
              ],
              [
                61.819402,
                25.967908
              ],
              [
                61.819585,
                25.968069
              ],
              [
                61.819543,
                25.968311
              ],
              [
                61.819367,
                25.968372
              ],
              [
                61.819358,
                25.968495
              ],
              [
                61.819238,
                25.968611
              ],
              [
                61.819102,
                25.968604
              ],
              [
                61.819061,
                25.968649
              ],
              [
                61.819101,
                25.968777
              ],
              [
                61.818921,
                25.968998
              ],
              [
                61.818968,
                25.96919
              ],
              [
                61.819244,
                25.96926
              ],
              [
                61.81931,
                25.96949
              ],
              [
                61.819459,
                25.969494
              ],
              [
                61.819522,
                25.969613
              ],
              [
                61.819773,
                25.969622
              ],
              [
                61.820256,
                25.969554
              ],
              [
                61.820362,
                25.969988
              ],
              [
                61.820557,
                25.969983
              ],
              [
                61.820555,
                25.969895
              ],
              [
                61.821075,
                25.969746
              ],
              [
                61.821255,
                25.969856
              ],
              [
                61.821579,
                25.969889
              ],
              [
                61.821644,
                25.970171
              ],
              [
                61.82185,
                25.970389
              ],
              [
                61.821561,
                25.970518
              ],
              [
                61.82136,
                25.970738
              ],
              [
                61.821083,
                25.970935
              ],
              [
                61.820473,
                25.971106
              ],
              [
                61.820257,
                25.971105
              ],
              [
                61.820177,
                25.971171
              ],
              [
                61.81986,
                25.971208
              ],
              [
                61.819902,
                25.97134
              ],
              [
                61.819822,
                25.971897
              ],
              [
                61.819607,
                25.971937
              ],
              [
                61.819546,
                25.972019
              ],
              [
                61.819636,
                25.972175
              ],
              [
                61.819549,
                25.972308
              ],
              [
                61.819424,
                25.972248
              ],
              [
                61.819335,
                25.972274
              ],
              [
                61.819329,
                25.972387
              ],
              [
                61.819394,
                25.972496
              ],
              [
                61.819459,
                25.97282
              ],
              [
                61.81929,
                25.972955
              ],
              [
                61.819489,
                25.973198
              ],
              [
                61.819585,
                25.973394
              ],
              [
                61.819541,
                25.973468
              ],
              [
                61.819628,
                25.973512
              ],
              [
                61.819694,
                25.973719
              ],
              [
                61.819838,
                25.973683
              ],
              [
                61.820009,
                25.973893
              ],
              [
                61.820302,
                25.973913
              ],
              [
                61.820552,
                25.97374
              ],
              [
                61.820672,
                25.97374
              ],
              [
                61.820802,
                25.973823
              ],
              [
                61.821124,
                25.973786
              ],
              [
                61.821202,
                25.973673
              ],
              [
                61.821339,
                25.973722
              ],
              [
                61.821465,
                25.973712
              ],
              [
                61.821778,
                25.973854
              ],
              [
                61.821803,
                25.973933
              ],
              [
                61.821999,
                25.97405
              ],
              [
                61.822066,
                25.974225
              ],
              [
                61.822544,
                25.974139
              ],
              [
                61.822674,
                25.974222
              ],
              [
                61.822679,
                25.974417
              ],
              [
                61.822763,
                25.974486
              ],
              [
                61.82293,
                25.974464
              ],
              [
                61.8231,
                25.974651
              ],
              [
                61.823186,
                25.974649
              ],
              [
                61.823391,
                25.97476
              ],
              [
                61.823427,
                25.974869
              ],
              [
                61.823505,
                25.974892
              ],
              [
                61.823614,
                25.975161
              ],
              [
                61.823548,
                25.975384
              ],
              [
                61.823557,
                25.975597
              ],
              [
                61.824008,
                25.975479
              ],
              [
                61.824212,
                25.975627
              ],
              [
                61.824415,
                25.975575
              ],
              [
                61.824776,
                25.975717
              ],
              [
                61.82497,
                25.975569
              ],
              [
                61.825167,
                25.975592
              ],
              [
                61.825276,
                25.975702
              ],
              [
                61.825347,
                25.975698
              ],
              [
                61.825428,
                25.975758
              ],
              [
                61.825573,
                25.975665
              ],
              [
                61.825749,
                25.975678
              ],
              [
                61.825874,
                25.97558
              ],
              [
                61.826201,
                25.975584
              ],
              [
                61.826279,
                25.975709
              ],
              [
                61.82641,
                25.975731
              ],
              [
                61.826963,
                25.975506
              ],
              [
                61.827312,
                25.975519
              ],
              [
                61.827598,
                25.976138
              ],
              [
                61.82799,
                25.976078
              ],
              [
                61.828048,
                25.976198
              ],
              [
                61.82789,
                25.976237
              ],
              [
                61.827975,
                25.976268
              ],
              [
                61.827953,
                25.976393
              ],
              [
                61.82804,
                25.976419
              ],
              [
                61.827973,
                25.976478
              ],
              [
                61.82805,
                25.976515
              ],
              [
                61.828068,
                25.97661
              ],
              [
                61.828137,
                25.97662
              ],
              [
                61.82811,
                25.976704
              ],
              [
                61.828366,
                25.97681
              ],
              [
                61.828398,
                25.97686
              ],
              [
                61.828371,
                25.977085
              ],
              [
                61.828302,
                25.977117
              ],
              [
                61.828359,
                25.977171
              ],
              [
                61.828374,
                25.977309
              ],
              [
                61.828192,
                25.977432
              ],
              [
                61.828296,
                25.977599
              ],
              [
                61.828268,
                25.977777
              ],
              [
                61.828316,
                25.977838
              ],
              [
                61.828064,
                25.978002
              ],
              [
                61.827708,
                25.977999
              ],
              [
                61.827686,
                25.977948
              ],
              [
                61.827606,
                25.977953
              ],
              [
                61.827385,
                25.978009
              ],
              [
                61.827157,
                25.978155
              ],
              [
                61.827134,
                25.978239
              ],
              [
                61.8272,
                25.97845
              ],
              [
                61.827333,
                25.978603
              ],
              [
                61.827423,
                25.978558
              ],
              [
                61.827497,
                25.978702
              ],
              [
                61.827463,
                25.978779
              ],
              [
                61.827648,
                25.978753
              ],
              [
                61.827739,
                25.978946
              ],
              [
                61.827497,
                25.979095
              ],
              [
                61.827482,
                25.979191
              ],
              [
                61.827433,
                25.979205
              ],
              [
                61.827463,
                25.979447
              ],
              [
                61.827789,
                25.979404
              ],
              [
                61.827756,
                25.979663
              ],
              [
                61.827804,
                25.979761
              ],
              [
                61.827768,
                25.97981
              ],
              [
                61.827824,
                25.979939
              ],
              [
                61.827917,
                25.979968
              ],
              [
                61.828033,
                25.98011
              ],
              [
                61.828209,
                25.980124
              ],
              [
                61.828235,
                25.980189
              ],
              [
                61.828298,
                25.980135
              ],
              [
                61.828626,
                25.980101
              ],
              [
                61.828698,
                25.980181
              ],
              [
                61.828796,
                25.980209
              ],
              [
                61.828817,
                25.980294
              ],
              [
                61.829072,
                25.980278
              ],
              [
                61.82927,
                25.980461
              ],
              [
                61.829374,
                25.980418
              ],
              [
                61.829606,
                25.980598
              ],
              [
                61.829557,
                25.980752
              ],
              [
                61.829725,
                25.98087
              ],
              [
                61.829452,
                25.980912
              ],
              [
                61.828903,
                25.981137
              ],
              [
                61.829018,
                25.981312
              ],
              [
                61.829082,
                25.981533
              ],
              [
                61.829707,
                25.981481
              ],
              [
                61.829727,
                25.981621
              ],
              [
                61.829947,
                25.981739
              ],
              [
                61.830085,
                25.981732
              ],
              [
                61.830241,
                25.981842
              ],
              [
                61.830339,
                25.982244
              ],
              [
                61.830243,
                25.982435
              ],
              [
                61.830054,
                25.982508
              ],
              [
                61.830082,
                25.982858
              ],
              [
                61.831258,
                25.982645
              ],
              [
                61.831323,
                25.982502
              ],
              [
                61.831664,
                25.982424
              ],
              [
                61.832006,
                25.982256
              ],
              [
                61.83263,
                25.982101
              ],
              [
                61.833051,
                25.982134
              ],
              [
                61.833468,
                25.982056
              ],
              [
                61.833605,
                25.982146
              ],
              [
                61.83357,
                25.9822
              ],
              [
                61.83364,
                25.982448
              ],
              [
                61.833928,
                25.982623
              ],
              [
                61.833904,
                25.982879
              ],
              [
                61.833952,
                25.982936
              ],
              [
                61.833959,
                25.983495
              ],
              [
                61.833928,
                25.983585
              ],
              [
                61.833843,
                25.983629
              ],
              [
                61.833817,
                25.983895
              ],
              [
                61.833976,
                25.983898
              ],
              [
                61.834006,
                25.983981
              ],
              [
                61.834128,
                25.983949
              ],
              [
                61.834038,
                25.984054
              ],
              [
                61.834092,
                25.98439
              ],
              [
                61.834015,
                25.984489
              ],
              [
                61.834221,
                25.984585
              ],
              [
                61.834162,
                25.984694
              ],
              [
                61.834241,
                25.984782
              ],
              [
                61.834203,
                25.984845
              ],
              [
                61.834275,
                25.984846
              ],
              [
                61.834266,
                25.984946
              ],
              [
                61.834182,
                25.984994
              ],
              [
                61.833868,
                25.985021
              ],
              [
                61.833896,
                25.985254
              ],
              [
                61.833855,
                25.98542
              ],
              [
                61.833586,
                25.985536
              ],
              [
                61.833618,
                25.985432
              ],
              [
                61.833492,
                25.985367
              ],
              [
                61.833379,
                25.985375
              ],
              [
                61.833191,
                25.985587
              ],
              [
                61.832431,
                25.985577
              ],
              [
                61.832089,
                25.985627
              ],
              [
                61.83184,
                25.985941
              ],
              [
                61.831833,
                25.986129
              ],
              [
                61.831679,
                25.986186
              ],
              [
                61.831682,
                25.986255
              ],
              [
                61.831302,
                25.98635
              ],
              [
                61.831203,
                25.986453
              ],
              [
                61.830818,
                25.986507
              ],
              [
                61.830676,
                25.986692
              ],
              [
                61.830717,
                25.986741
              ],
              [
                61.830665,
                25.9869
              ],
              [
                61.830428,
                25.987127
              ],
              [
                61.830495,
                25.987184
              ],
              [
                61.830467,
                25.987405
              ],
              [
                61.830609,
                25.987611
              ],
              [
                61.830914,
                25.987586
              ],
              [
                61.830904,
                25.987682
              ],
              [
                61.831012,
                25.987769
              ],
              [
                61.831076,
                25.987912
              ],
              [
                61.830934,
                25.988059
              ],
              [
                61.830956,
                25.988186
              ],
              [
                61.83122,
                25.988383
              ],
              [
                61.83133,
                25.988381
              ],
              [
                61.831848,
                25.988578
              ],
              [
                61.831752,
                25.988755
              ],
              [
                61.83206,
                25.988818
              ],
              [
                61.83222,
                25.988905
              ],
              [
                61.832298,
                25.989203
              ],
              [
                61.832471,
                25.989184
              ],
              [
                61.832633,
                25.989397
              ],
              [
                61.832849,
                25.989398
              ],
              [
                61.833045,
                25.989492
              ],
              [
                61.833085,
                25.989596
              ],
              [
                61.832758,
                25.989728
              ],
              [
                61.832656,
                25.989803
              ],
              [
                61.832673,
                25.989852
              ],
              [
                61.832512,
                25.989901
              ],
              [
                61.832516,
                25.989993
              ],
              [
                61.832447,
                25.990044
              ],
              [
                61.83223,
                25.99008
              ],
              [
                61.832049,
                25.990222
              ],
              [
                61.832112,
                25.990345
              ],
              [
                61.83209,
                25.990527
              ],
              [
                61.832498,
                25.990492
              ],
              [
                61.832922,
                25.990538
              ],
              [
                61.833282,
                25.990521
              ],
              [
                61.833518,
                25.99072
              ],
              [
                61.833498,
                25.990854
              ],
              [
                61.833726,
                25.991021
              ],
              [
                61.833698,
                25.991139
              ],
              [
                61.833621,
                25.991317
              ],
              [
                61.833347,
                25.991429
              ],
              [
                61.833371,
                25.991588
              ],
              [
                61.833196,
                25.991677
              ],
              [
                61.833058,
                25.991914
              ],
              [
                61.832971,
                25.991874
              ],
              [
                61.832503,
                25.991883
              ],
              [
                61.832426,
                25.991841
              ],
              [
                61.832169,
                25.991885
              ],
              [
                61.832209,
                25.991794
              ],
              [
                61.832125,
                25.991688
              ],
              [
                61.831956,
                25.991682
              ],
              [
                61.831921,
                25.99146
              ],
              [
                61.83163,
                25.991487
              ],
              [
                61.831641,
                25.991611
              ],
              [
                61.83142,
                25.991746
              ],
              [
                61.831247,
                25.991606
              ],
              [
                61.831019,
                25.991616
              ],
              [
                61.830653,
                25.991709
              ],
              [
                61.830584,
                25.991815
              ],
              [
                61.830467,
                25.991888
              ],
              [
                61.830405,
                25.992204
              ],
              [
                61.830445,
                25.992855
              ],
              [
                61.830601,
                25.992886
              ],
              [
                61.830633,
                25.992974
              ],
              [
                61.830708,
                25.992969
              ],
              [
                61.830707,
                25.993062
              ],
              [
                61.830767,
                25.993112
              ],
              [
                61.831071,
                25.993064
              ],
              [
                61.831116,
                25.993186
              ],
              [
                61.831031,
                25.993211
              ],
              [
                61.831071,
                25.993316
              ],
              [
                61.830971,
                25.993437
              ],
              [
                61.830985,
                25.993612
              ],
              [
                61.831151,
                25.993604
              ],
              [
                61.831237,
                25.993663
              ],
              [
                61.831655,
                25.993607
              ],
              [
                61.831815,
                25.993633
              ],
              [
                61.831918,
                25.993721
              ],
              [
                61.831973,
                25.993632
              ],
              [
                61.832038,
                25.993624
              ],
              [
                61.832154,
                25.993803
              ],
              [
                61.832007,
                25.993929
              ],
              [
                61.832128,
                25.994069
              ],
              [
                61.832142,
                25.994342
              ],
              [
                61.832252,
                25.994359
              ],
              [
                61.832359,
                25.994521
              ],
              [
                61.83205,
                25.994808
              ],
              [
                61.8318,
                25.994944
              ],
              [
                61.831759,
                25.995068
              ],
              [
                61.831552,
                25.995182
              ],
              [
                61.831746,
                25.995267
              ],
              [
                61.831812,
                25.995479
              ],
              [
                61.83192,
                25.995608
              ],
              [
                61.832139,
                25.995604
              ],
              [
                61.832445,
                25.995831
              ],
              [
                61.832312,
                25.995875
              ],
              [
                61.832226,
                25.995975
              ],
              [
                61.832282,
                25.996011
              ],
              [
                61.832289,
                25.996117
              ],
              [
                61.832115,
                25.996188
              ],
              [
                61.832581,
                25.996329
              ],
              [
                61.83276,
                25.996514
              ],
              [
                61.832998,
                25.996507
              ],
              [
                61.833128,
                25.996567
              ],
              [
                61.833271,
                25.996484
              ],
              [
                61.833335,
                25.996551
              ],
              [
                61.833705,
                25.996654
              ],
              [
                61.834387,
                25.996619
              ],
              [
                61.834666,
                25.996543
              ],
              [
                61.834955,
                25.99653
              ],
              [
                61.835101,
                25.996479
              ],
              [
                61.83511,
                25.996398
              ],
              [
                61.835276,
                25.996311
              ],
              [
                61.835374,
                25.996516
              ],
              [
                61.835519,
                25.996578
              ],
              [
                61.835574,
                25.996806
              ],
              [
                61.835529,
                25.99709
              ],
              [
                61.835597,
                25.997072
              ],
              [
                61.835837,
                25.997233
              ],
              [
                61.835761,
                25.997588
              ],
              [
                61.835581,
                25.997771
              ],
              [
                61.835456,
                25.99779
              ],
              [
                61.835627,
                25.997952
              ],
              [
                61.835958,
                25.998079
              ],
              [
                61.836192,
                25.998424
              ],
              [
                61.836022,
                25.99855
              ],
              [
                61.835586,
                25.998678
              ],
              [
                61.835613,
                25.998888
              ],
              [
                61.835509,
                25.999025
              ],
              [
                61.835539,
                25.999116
              ],
              [
                61.835645,
                25.999172
              ],
              [
                61.835624,
                25.999235
              ],
              [
                61.835696,
                25.999311
              ],
              [
                61.83565,
                25.9994
              ],
              [
                61.835715,
                25.999447
              ],
              [
                61.835773,
                25.999622
              ],
              [
                61.835867,
                25.999634
              ],
              [
                61.835823,
                25.99983
              ],
              [
                61.835872,
                26.000015
              ],
              [
                61.835764,
                26.00007
              ],
              [
                61.835813,
                26.000319
              ],
              [
                61.83575,
                26.000499
              ],
              [
                61.835767,
                26.000904
              ],
              [
                61.835869,
                26.000959
              ],
              [
                61.836002,
                26.000898
              ],
              [
                61.836324,
                26.000883
              ],
              [
                61.836408,
                26.001068
              ],
              [
                61.836633,
                26.001113
              ],
              [
                61.83674,
                26.001106
              ],
              [
                61.836971,
                26.000871
              ],
              [
                61.837141,
                26.000915
              ],
              [
                61.837114,
                26.001045
              ],
              [
                61.837237,
                26.001235
              ],
              [
                61.837724,
                26.001443
              ],
              [
                61.837525,
                26.001778
              ],
              [
                61.837554,
                26.002064
              ],
              [
                61.837723,
                26.00211
              ],
              [
                61.83791,
                26.00235
              ],
              [
                61.838019,
                26.00231
              ],
              [
                61.838426,
                26.002384
              ],
              [
                61.838521,
                26.002509
              ],
              [
                61.8385,
                26.002627
              ],
              [
                61.838195,
                26.003027
              ],
              [
                61.838143,
                26.003182
              ],
              [
                61.838153,
                26.003362
              ],
              [
                61.838189,
                26.0034
              ],
              [
                61.838231,
                26.003382
              ],
              [
                61.83833,
                26.0036
              ],
              [
                61.838137,
                26.003809
              ],
              [
                61.837936,
                26.003939
              ],
              [
                61.837886,
                26.004091
              ],
              [
                61.837916,
                26.004149
              ],
              [
                61.838059,
                26.00416
              ],
              [
                61.838037,
                26.004243
              ],
              [
                61.837978,
                26.004263
              ],
              [
                61.838045,
                26.004348
              ],
              [
                61.838466,
                26.004299
              ],
              [
                61.838533,
                26.004407
              ],
              [
                61.838728,
                26.004562
              ],
              [
                61.838723,
                26.004773
              ],
              [
                61.838471,
                26.004888
              ],
              [
                61.838472,
                26.004979
              ],
              [
                61.838497,
                26.005119
              ],
              [
                61.838635,
                26.005174
              ],
              [
                61.838744,
                26.005278
              ],
              [
                61.838711,
                26.005374
              ],
              [
                61.838754,
                26.005438
              ],
              [
                61.838661,
                26.005635
              ],
              [
                61.838686,
                26.005794
              ],
              [
                61.838651,
                26.005895
              ],
              [
                61.838955,
                26.005975
              ],
              [
                61.838935,
                26.006085
              ],
              [
                61.83883,
                26.006206
              ],
              [
                61.838772,
                26.006393
              ],
              [
                61.838333,
                26.006397
              ],
              [
                61.838259,
                26.006637
              ],
              [
                61.83774,
                26.006701
              ],
              [
                61.837451,
                26.006677
              ],
              [
                61.83734,
                26.006766
              ],
              [
                61.837293,
                26.007113
              ],
              [
                61.837664,
                26.007302
              ],
              [
                61.837466,
                26.007568
              ],
              [
                61.837463,
                26.007787
              ],
              [
                61.837568,
                26.007907
              ],
              [
                61.837599,
                26.008066
              ],
              [
                61.837677,
                26.008176
              ],
              [
                61.837222,
                26.008209
              ],
              [
                61.83719,
                26.008284
              ],
              [
                61.836575,
                26.00835
              ],
              [
                61.836405,
                26.008446
              ],
              [
                61.836614,
                26.00873
              ],
              [
                61.836526,
                26.008824
              ],
              [
                61.836231,
                26.00892
              ],
              [
                61.836149,
                26.009008
              ],
              [
                61.836266,
                26.009217
              ],
              [
                61.836295,
                26.009424
              ],
              [
                61.836423,
                26.009547
              ],
              [
                61.836677,
                26.009667
              ],
              [
                61.836981,
                26.009584
              ],
              [
                61.83719,
                26.009645
              ],
              [
                61.837353,
                26.009543
              ],
              [
                61.837317,
                26.009487
              ],
              [
                61.837377,
                26.009396
              ],
              [
                61.837563,
                26.009348
              ],
              [
                61.837815,
                26.009418
              ],
              [
                61.838049,
                26.009564
              ],
              [
                61.838169,
                26.009565
              ],
              [
                61.838278,
                26.009657
              ],
              [
                61.838518,
                26.009592
              ],
              [
                61.83869,
                26.009714
              ],
              [
                61.838847,
                26.009593
              ],
              [
                61.839176,
                26.009611
              ],
              [
                61.839567,
                26.0098
              ],
              [
                61.839585,
                26.009933
              ],
              [
                61.839811,
                26.010157
              ],
              [
                61.839773,
                26.010277
              ],
              [
                61.839887,
                26.010454
              ],
              [
                61.839895,
                26.010693
              ],
              [
                61.840086,
                26.010742
              ],
              [
                61.840291,
                26.010897
              ],
              [
                61.840926,
                26.010896
              ],
              [
                61.841256,
                26.010714
              ],
              [
                61.84168,
                26.010748
              ],
              [
                61.842094,
                26.010881
              ],
              [
                61.84222,
                26.011025
              ],
              [
                61.842725,
                26.011258
              ],
              [
                61.843812,
                26.011376
              ],
              [
                61.844261,
                26.011507
              ],
              [
                61.844286,
                26.011786
              ],
              [
                61.84423,
                26.011876
              ],
              [
                61.844296,
                26.012045
              ],
              [
                61.844286,
                26.012151
              ],
              [
                61.844433,
                26.012364
              ],
              [
                61.844532,
                26.012855
              ],
              [
                61.844365,
                26.012841
              ],
              [
                61.844321,
                26.013038
              ],
              [
                61.844173,
                26.013228
              ],
              [
                61.844333,
                26.013259
              ],
              [
                61.84464,
                26.013239
              ],
              [
                61.844588,
                26.013551
              ],
              [
                61.844649,
                26.013723
              ],
              [
                61.8444,
                26.013719
              ],
              [
                61.844374,
                26.013874
              ],
              [
                61.844467,
                26.013905
              ],
              [
                61.844385,
                26.014023
              ],
              [
                61.844454,
                26.014339
              ],
              [
                61.844344,
                26.014551
              ],
              [
                61.844216,
                26.014618
              ],
              [
                61.844319,
                26.014762
              ],
              [
                61.844096,
                26.014823
              ],
              [
                61.843806,
                26.014829
              ],
              [
                61.843753,
                26.014893
              ],
              [
                61.843728,
                26.015106
              ],
              [
                61.843553,
                26.015226
              ],
              [
                61.843544,
                26.015334
              ],
              [
                61.843801,
                26.015469
              ],
              [
                61.844048,
                26.015859
              ],
              [
                61.844213,
                26.016231
              ],
              [
                61.844195,
                26.016404
              ],
              [
                61.844243,
                26.016539
              ],
              [
                61.844463,
                26.016699
              ],
              [
                61.844525,
                26.016856
              ],
              [
                61.844973,
                26.01705
              ],
              [
                61.845143,
                26.017172
              ],
              [
                61.845176,
                26.017604
              ],
              [
                61.845268,
                26.017618
              ],
              [
                61.845366,
                26.017833
              ],
              [
                61.845774,
                26.018043
              ],
              [
                61.846007,
                26.018096
              ],
              [
                61.846175,
                26.018455
              ],
              [
                61.846411,
                26.018672
              ],
              [
                61.846399,
                26.018903
              ],
              [
                61.846292,
                26.018905
              ],
              [
                61.84621,
                26.01897
              ],
              [
                61.846083,
                26.018963
              ],
              [
                61.845953,
                26.018891
              ],
              [
                61.845952,
                26.0188
              ],
              [
                61.845612,
                26.018715
              ],
              [
                61.845535,
                26.018878
              ],
              [
                61.845395,
                26.018886
              ],
              [
                61.845227,
                26.018989
              ],
              [
                61.845121,
                26.018998
              ],
              [
                61.84499,
                26.019129
              ],
              [
                61.844526,
                26.019118
              ],
              [
                61.844335,
                26.019221
              ],
              [
                61.844196,
                26.019136
              ],
              [
                61.843907,
                26.019081
              ],
              [
                61.843386,
                26.019117
              ],
              [
                61.843343,
                26.019088
              ],
              [
                61.843216,
                26.019158
              ],
              [
                61.842794,
                26.01926
              ],
              [
                61.842612,
                26.019409
              ],
              [
                61.842632,
                26.019473
              ],
              [
                61.842862,
                26.019638
              ],
              [
                61.842721,
                26.0197
              ],
              [
                61.842677,
                26.019983
              ],
              [
                61.842518,
                26.020066
              ],
              [
                61.842563,
                26.020298
              ],
              [
                61.842684,
                26.020478
              ],
              [
                61.842653,
                26.020616
              ],
              [
                61.842689,
                26.020784
              ],
              [
                61.842622,
                26.020937
              ],
              [
                61.842381,
                26.021096
              ],
              [
                61.841694,
                26.021047
              ],
              [
                61.840999,
                26.021099
              ],
              [
                61.841032,
                26.021298
              ],
              [
                61.841301,
                26.021841
              ],
              [
                61.841283,
                26.022243
              ],
              [
                61.841347,
                26.022305
              ],
              [
                61.8414,
                26.022541
              ],
              [
                61.840631,
                26.022721
              ],
              [
                61.840626,
                26.022857
              ],
              [
                61.840489,
                26.022966
              ],
              [
                61.840485,
                26.023094
              ],
              [
                61.8406,
                26.023151
              ],
              [
                61.840778,
                26.023458
              ],
              [
                61.840863,
                26.023545
              ],
              [
                61.841014,
                26.023592
              ],
              [
                61.84089,
                26.02376
              ],
              [
                61.840884,
                26.023904
              ],
              [
                61.840701,
                26.024092
              ],
              [
                61.840652,
                26.024344
              ],
              [
                61.840535,
                26.024448
              ],
              [
                61.840372,
                26.024716
              ],
              [
                61.840413,
                26.02479
              ],
              [
                61.840419,
                26.025072
              ],
              [
                61.840265,
                26.02499
              ],
              [
                61.840067,
                26.024965
              ],
              [
                61.839839,
                26.025141
              ],
              [
                61.839544,
                26.025176
              ],
              [
                61.83926,
                26.025101
              ],
              [
                61.839071,
                26.024934
              ],
              [
                61.838779,
                26.024978
              ],
              [
                61.838311,
                26.024902
              ],
              [
                61.837876,
                26.024942
              ],
              [
                61.837539,
                26.024904
              ],
              [
                61.837046,
                26.024914
              ],
              [
                61.836721,
                26.025099
              ],
              [
                61.836295,
                26.024994
              ],
              [
                61.835949,
                26.025082
              ],
              [
                61.835599,
                26.025104
              ],
              [
                61.83554,
                26.025231
              ],
              [
                61.835241,
                26.025333
              ],
              [
                61.835298,
                26.025644
              ],
              [
                61.8354,
                26.025826
              ],
              [
                61.835374,
                26.025966
              ],
              [
                61.835303,
                26.026152
              ],
              [
                61.835001,
                26.026305
              ],
              [
                61.835098,
                26.026472
              ],
              [
                61.835301,
                26.026639
              ],
              [
                61.835356,
                26.026916
              ],
              [
                61.834785,
                26.027087
              ],
              [
                61.83467,
                26.027173
              ],
              [
                61.833933,
                26.027162
              ],
              [
                61.833303,
                26.027267
              ],
              [
                61.833193,
                26.027207
              ],
              [
                61.832899,
                26.027246
              ],
              [
                61.832635,
                26.02718
              ],
              [
                61.832491,
                26.027222
              ],
              [
                61.832056,
                26.027233
              ],
              [
                61.831696,
                26.027356
              ],
              [
                61.831486,
                26.027519
              ],
              [
                61.831252,
                26.027561
              ],
              [
                61.831111,
                26.027517
              ],
              [
                61.831028,
                26.027539
              ],
              [
                61.830937,
                26.028223
              ],
              [
                61.831022,
                26.028289
              ],
              [
                61.831069,
                26.028511
              ],
              [
                61.831009,
                26.028565
              ],
              [
                61.831053,
                26.028605
              ],
              [
                61.830977,
                26.028779
              ],
              [
                61.830795,
                26.02879
              ],
              [
                61.830746,
                26.028829
              ],
              [
                61.830682,
                26.029167
              ],
              [
                61.830505,
                26.029346
              ],
              [
                61.830436,
                26.029521
              ],
              [
                61.830392,
                26.029556
              ],
              [
                61.830055,
                26.029518
              ],
              [
                61.829952,
                26.029687
              ],
              [
                61.830035,
                26.029834
              ],
              [
                61.830139,
                26.029894
              ],
              [
                61.83005,
                26.030013
              ],
              [
                61.830137,
                26.030344
              ],
              [
                61.830099,
                26.030437
              ],
              [
                61.830114,
                26.03065
              ],
              [
                61.829097,
                26.030896
              ],
              [
                61.828775,
                26.031115
              ],
              [
                61.828691,
                26.031244
              ],
              [
                61.828804,
                26.031239
              ],
              [
                61.829078,
                26.031415
              ],
              [
                61.829303,
                26.031488
              ],
              [
                61.829337,
                26.031804
              ],
              [
                61.830692,
                26.031657
              ],
              [
                61.831504,
                26.031395
              ],
              [
                61.831748,
                26.031413
              ],
              [
                61.832317,
                26.031315
              ],
              [
                61.832434,
                26.031398
              ],
              [
                61.832547,
                26.031718
              ],
              [
                61.832793,
                26.031787
              ],
              [
                61.833212,
                26.031702
              ],
              [
                61.833564,
                26.031794
              ],
              [
                61.833879,
                26.031771
              ],
              [
                61.83394,
                26.031857
              ],
              [
                61.83414,
                26.031923
              ],
              [
                61.834463,
                26.03221
              ],
              [
                61.834505,
                26.032355
              ],
              [
                61.834668,
                26.032384
              ],
              [
                61.835044,
                26.032188
              ],
              [
                61.835805,
                26.032131
              ],
              [
                61.836072,
                26.032196
              ],
              [
                61.836108,
                26.032298
              ],
              [
                61.836181,
                26.032341
              ],
              [
                61.836631,
                26.032282
              ],
              [
                61.837521,
                26.032327
              ],
              [
                61.837466,
                26.032484
              ],
              [
                61.83746,
                26.032721
              ],
              [
                61.837706,
                26.032827
              ],
              [
                61.837694,
                26.033017
              ],
              [
                61.837765,
                26.033127
              ],
              [
                61.837753,
                26.033306
              ],
              [
                61.837932,
                26.033392
              ],
              [
                61.838622,
                26.033461
              ],
              [
                61.839005,
                26.033708
              ],
              [
                61.839054,
                26.033981
              ],
              [
                61.839021,
                26.034126
              ],
              [
                61.83905,
                26.03446
              ],
              [
                61.839173,
                26.034916
              ],
              [
                61.839149,
                26.035116
              ],
              [
                61.83933,
                26.035209
              ],
              [
                61.839675,
                26.035287
              ],
              [
                61.839816,
                26.035455
              ],
              [
                61.84005,
                26.035569
              ],
              [
                61.840087,
                26.035722
              ],
              [
                61.840048,
                26.035788
              ],
              [
                61.840141,
                26.035961
              ],
              [
                61.84047,
                26.035842
              ],
              [
                61.840859,
                26.03563
              ],
              [
                61.840981,
                26.035592
              ],
              [
                61.841148,
                26.03561
              ],
              [
                61.841156,
                26.035751
              ],
              [
                61.840975,
                26.035869
              ],
              [
                61.840954,
                26.036349
              ],
              [
                61.840892,
                26.036395
              ],
              [
                61.840914,
                26.036479
              ],
              [
                61.840849,
                26.0367
              ],
              [
                61.840684,
                26.036949
              ],
              [
                61.84074,
                26.037115
              ],
              [
                61.840859,
                26.037241
              ],
              [
                61.840941,
                26.037567
              ],
              [
                61.841038,
                26.037641
              ],
              [
                61.84104,
                26.037773
              ],
              [
                61.84096,
                26.037883
              ],
              [
                61.840988,
                26.038034
              ],
              [
                61.840889,
                26.038275
              ],
              [
                61.840287,
                26.03845
              ],
              [
                61.840305,
                26.038599
              ],
              [
                61.840407,
                26.038747
              ],
              [
                61.840471,
                26.039095
              ],
              [
                61.840384,
                26.039368
              ],
              [
                61.840144,
                26.039474
              ],
              [
                61.840075,
                26.039561
              ],
              [
                61.840042,
                26.039716
              ],
              [
                61.840092,
                26.039804
              ],
              [
                61.840085,
                26.040011
              ],
              [
                61.840015,
                26.040038
              ],
              [
                61.840052,
                26.040109
              ],
              [
                61.839987,
                26.040278
              ],
              [
                61.839585,
                26.040363
              ],
              [
                61.83965,
                26.0409
              ],
              [
                61.839517,
                26.040889
              ],
              [
                61.839375,
                26.040941
              ],
              [
                61.839281,
                26.040978
              ],
              [
                61.839216,
                26.041064
              ],
              [
                61.83855,
                26.041021
              ],
              [
                61.838275,
                26.040942
              ],
              [
                61.838148,
                26.041108
              ],
              [
                61.837988,
                26.041172
              ],
              [
                61.837911,
                26.041372
              ],
              [
                61.837766,
                26.041391
              ],
              [
                61.837573,
                26.041587
              ],
              [
                61.837501,
                26.041604
              ],
              [
                61.837483,
                26.041662
              ],
              [
                61.837527,
                26.041716
              ],
              [
                61.83738,
                26.041909
              ],
              [
                61.837107,
                26.041957
              ],
              [
                61.836844,
                26.042157
              ],
              [
                61.836453,
                26.042192
              ],
              [
                61.836183,
                26.042141
              ],
              [
                61.835873,
                26.042409
              ],
              [
                61.83532,
                26.042434
              ],
              [
                61.835511,
                26.043229
              ],
              [
                61.835842,
                26.043432
              ],
              [
                61.836266,
                26.043421
              ],
              [
                61.836375,
                26.043474
              ],
              [
                61.836267,
                26.043657
              ],
              [
                61.836315,
                26.043772
              ],
              [
                61.836126,
                26.043795
              ],
              [
                61.836147,
                26.043884
              ],
              [
                61.836045,
                26.04397
              ],
              [
                61.836015,
                26.044078
              ],
              [
                61.835929,
                26.044121
              ],
              [
                61.835599,
                26.044144
              ],
              [
                61.835468,
                26.044272
              ],
              [
                61.835493,
                26.044311
              ],
              [
                61.834509,
                26.04438
              ],
              [
                61.834423,
                26.044545
              ],
              [
                61.834456,
                26.044585
              ],
              [
                61.834393,
                26.044746
              ],
              [
                61.834202,
                26.04484
              ],
              [
                61.834011,
                26.044876
              ],
              [
                61.834112,
                26.045077
              ],
              [
                61.834062,
                26.045134
              ],
              [
                61.834182,
                26.045166
              ],
              [
                61.834258,
                26.04532
              ],
              [
                61.834494,
                26.045308
              ],
              [
                61.834617,
                26.045353
              ],
              [
                61.834885,
                26.045228
              ],
              [
                61.835315,
                26.04527
              ],
              [
                61.835495,
                26.045642
              ],
              [
                61.835642,
                26.04564
              ],
              [
                61.835926,
                26.045808
              ],
              [
                61.835953,
                26.046013
              ],
              [
                61.836376,
                26.046016
              ],
              [
                61.83713,
                26.045924
              ],
              [
                61.837204,
                26.046092
              ],
              [
                61.837563,
                26.045974
              ],
              [
                61.83755,
                26.046282
              ],
              [
                61.837433,
                26.046307
              ],
              [
                61.83729,
                26.046632
              ],
              [
                61.83714,
                26.046732
              ],
              [
                61.837105,
                26.046874
              ],
              [
                61.836983,
                26.046876
              ],
              [
                61.836864,
                26.046796
              ],
              [
                61.836512,
                26.046827
              ],
              [
                61.836327,
                26.046883
              ],
              [
                61.836302,
                26.047023
              ],
              [
                61.836331,
                26.04709
              ],
              [
                61.836773,
                26.047098
              ],
              [
                61.836827,
                26.047282
              ],
              [
                61.836973,
                26.047308
              ],
              [
                61.836943,
                26.047441
              ],
              [
                61.837085,
                26.047891
              ],
              [
                61.837364,
                26.048153
              ],
              [
                61.837441,
                26.04847
              ],
              [
                61.837581,
                26.048756
              ],
              [
                61.837767,
                26.049038
              ],
              [
                61.83798,
                26.049096
              ],
              [
                61.838079,
                26.049078
              ],
              [
                61.838214,
                26.04956
              ],
              [
                61.838133,
                26.049641
              ],
              [
                61.838195,
                26.049943
              ],
              [
                61.838175,
                26.050171
              ],
              [
                61.838296,
                26.050294
              ],
              [
                61.838314,
                26.050353
              ],
              [
                61.838248,
                26.050382
              ],
              [
                61.838311,
                26.050575
              ],
              [
                61.83816,
                26.050686
              ],
              [
                61.838027,
                26.050908
              ],
              [
                61.837899,
                26.050916
              ],
              [
                61.838118,
                26.051453
              ],
              [
                61.838068,
                26.05189
              ],
              [
                61.838123,
                26.051967
              ],
              [
                61.838123,
                26.052167
              ],
              [
                61.838079,
                26.052259
              ],
              [
                61.837989,
                26.052272
              ],
              [
                61.83774,
                26.052448
              ],
              [
                61.837609,
                26.052464
              ],
              [
                61.837442,
                26.05275
              ],
              [
                61.837316,
                26.052906
              ],
              [
                61.837219,
                26.052955
              ],
              [
                61.83701,
                26.053278
              ],
              [
                61.836761,
                26.053409
              ],
              [
                61.836521,
                26.053404
              ],
              [
                61.836357,
                26.053497
              ],
              [
                61.836062,
                26.053518
              ],
              [
                61.836044,
                26.053483
              ],
              [
                61.835857,
                26.053456
              ],
              [
                61.835776,
                26.053587
              ],
              [
                61.835671,
                26.053614
              ],
              [
                61.835592,
                26.053726
              ],
              [
                61.83548,
                26.053717
              ],
              [
                61.835354,
                26.053832
              ],
              [
                61.835503,
                26.054017
              ],
              [
                61.835711,
                26.054603
              ],
              [
                61.835724,
                26.05491
              ],
              [
                61.83551,
                26.055107
              ],
              [
                61.835405,
                26.055269
              ],
              [
                61.835523,
                26.055603
              ],
              [
                61.835621,
                26.05563
              ],
              [
                61.835644,
                26.055805
              ],
              [
                61.835268,
                26.056178
              ],
              [
                61.835247,
                26.056257
              ],
              [
                61.8352,
                26.05629
              ],
              [
                61.835095,
                26.05625
              ],
              [
                61.834963,
                26.056308
              ],
              [
                61.834784,
                26.056536
              ],
              [
                61.834664,
                26.056605
              ],
              [
                61.834454,
                26.057106
              ],
              [
                61.834195,
                26.05714
              ],
              [
                61.833938,
                26.057374
              ],
              [
                61.833767,
                26.057407
              ],
              [
                61.833576,
                26.057534
              ],
              [
                61.833158,
                26.057679
              ],
              [
                61.833071,
                26.057822
              ],
              [
                61.833074,
                26.057899
              ],
              [
                61.832981,
                26.057949
              ],
              [
                61.832964,
                26.05802
              ],
              [
                61.832916,
                26.059023
              ],
              [
                61.832838,
                26.059377
              ],
              [
                61.83293,
                26.059389
              ],
              [
                61.833014,
                26.059528
              ],
              [
                61.833176,
                26.059664
              ],
              [
                61.833539,
                26.05972
              ],
              [
                61.833802,
                26.059835
              ],
              [
                61.833969,
                26.059967
              ],
              [
                61.834206,
                26.059994
              ],
              [
                61.834307,
                26.059963
              ],
              [
                61.834643,
                26.060051
              ],
              [
                61.834579,
                26.060235
              ],
              [
                61.834688,
                26.060413
              ],
              [
                61.834678,
                26.060521
              ],
              [
                61.834513,
                26.060633
              ],
              [
                61.834473,
                26.060725
              ],
              [
                61.834594,
                26.060973
              ],
              [
                61.83474,
                26.06099
              ],
              [
                61.834798,
                26.061056
              ],
              [
                61.834971,
                26.061117
              ],
              [
                61.834917,
                26.061237
              ],
              [
                61.835013,
                26.061254
              ],
              [
                61.834999,
                26.061301
              ],
              [
                61.835113,
                26.061311
              ],
              [
                61.835203,
                26.061415
              ],
              [
                61.835242,
                26.061677
              ],
              [
                61.83507,
                26.06184
              ],
              [
                61.834832,
                26.062302
              ],
              [
                61.834836,
                26.062452
              ],
              [
                61.834749,
                26.062537
              ],
              [
                61.834726,
                26.062794
              ],
              [
                61.834637,
                26.062794
              ],
              [
                61.83459,
                26.06285
              ],
              [
                61.834374,
                26.06324
              ],
              [
                61.834541,
                26.063414
              ],
              [
                61.834505,
                26.063491
              ],
              [
                61.83456,
                26.063732
              ],
              [
                61.834616,
                26.063754
              ],
              [
                61.834614,
                26.063872
              ],
              [
                61.834725,
                26.063966
              ],
              [
                61.834915,
                26.064008
              ],
              [
                61.834953,
                26.064237
              ],
              [
                61.83517,
                26.064359
              ],
              [
                61.83528,
                26.064373
              ],
              [
                61.835473,
                26.064211
              ],
              [
                61.835537,
                26.064206
              ],
              [
                61.835557,
                26.064147
              ],
              [
                61.835652,
                26.064138
              ],
              [
                61.835872,
                26.063968
              ],
              [
                61.836254,
                26.063976
              ],
              [
                61.836407,
                26.064085
              ],
              [
                61.836718,
                26.064058
              ],
              [
                61.83692,
                26.06383
              ],
              [
                61.837241,
                26.063702
              ],
              [
                61.83748,
                26.063929
              ],
              [
                61.83759,
                26.063943
              ],
              [
                61.838081,
                26.06423
              ],
              [
                61.838506,
                26.064018
              ],
              [
                61.838798,
                26.06413
              ],
              [
                61.839282,
                26.064167
              ],
              [
                61.839958,
                26.064585
              ],
              [
                61.840157,
                26.064604
              ],
              [
                61.840587,
                26.064747
              ],
              [
                61.840872,
                26.064897
              ],
              [
                61.841136,
                26.064916
              ],
              [
                61.841388,
                26.065158
              ],
              [
                61.846593,
                26.0956644
              ],
              [
                61.854211,
                26.140299
              ],
              [
                61.86017,
                26.17597
              ],
              [
                61.893165,
                26.233464
              ],
              [
                61.889278,
                26.251972
              ],
              [
                61.8903099,
                26.2521098
              ],
              [
                61.8909771,
                26.2529107
              ],
              [
                61.8912843,
                26.2532241
              ],
              [
                61.8916535,
                26.2531954
              ],
              [
                61.8919705,
                26.2531848
              ],
              [
                61.892231,
                26.253308
              ],
              [
                61.892949,
                26.253245
              ],
              [
                61.89335,
                26.253491
              ],
              [
                61.893571,
                26.253538
              ],
              [
                61.893728,
                26.253472
              ],
              [
                61.89391,
                26.253262
              ],
              [
                61.893938,
                26.253157
              ],
              [
                61.894072,
                26.253137
              ],
              [
                61.894261,
                26.253254
              ],
              [
                61.894356,
                26.253247
              ],
              [
                61.894452,
                26.253335
              ],
              [
                61.894813,
                26.253399
              ],
              [
                61.894795,
                26.253475
              ],
              [
                61.894947,
                26.253546
              ],
              [
                61.894972,
                26.25456
              ],
              [
                61.894778,
                26.255339
              ],
              [
                61.894632,
                26.255493
              ],
              [
                61.894527,
                26.255742
              ],
              [
                61.894563,
                26.256092
              ],
              [
                61.89445,
                26.256247
              ],
              [
                61.894401,
                26.256494
              ],
              [
                61.894405,
                26.256891
              ],
              [
                61.894462,
                26.257079
              ],
              [
                61.894863,
                26.257507
              ],
              [
                61.895169,
                26.257614
              ],
              [
                61.895398,
                26.257593
              ],
              [
                61.895466,
                26.257622
              ],
              [
                61.895609,
                26.257853
              ],
              [
                61.895611,
                26.258067
              ],
              [
                61.895767,
                26.258292
              ],
              [
                61.89591,
                26.25835
              ],
              [
                61.895877,
                26.258491
              ],
              [
                61.895909,
                26.258592
              ],
              [
                61.896003,
                26.258685
              ],
              [
                61.896059,
                26.258913
              ],
              [
                61.896151,
                26.259019
              ],
              [
                61.896165,
                26.259126
              ],
              [
                61.896078,
                26.259208
              ],
              [
                61.8961,
                26.259343
              ],
              [
                61.89619,
                26.259487
              ],
              [
                61.896335,
                26.259555
              ],
              [
                61.896565,
                26.259969
              ],
              [
                61.896586,
                26.260212
              ],
              [
                61.896509,
                26.260285
              ],
              [
                61.896429,
                26.26048
              ],
              [
                61.896464,
                26.260583
              ],
              [
                61.8973825,
                26.262188
              ],
              [
                61.898921,
                26.262489
              ],
              [
                61.8989484,
                26.2618541
              ],
              [
                61.8993047,
                26.2618349
              ],
              [
                61.899516,
                26.262496
              ],
              [
                61.899529,
                26.2626
              ],
              [
                61.899448,
                26.262619
              ],
              [
                61.899447,
                26.262697
              ],
              [
                61.899555,
                26.26274
              ],
              [
                61.900289,
                26.263364
              ],
              [
                61.900356,
                26.263335
              ],
              [
                61.900461,
                26.263396
              ],
              [
                61.900522,
                26.263386
              ],
              [
                61.900893,
                26.263194
              ],
              [
                61.900907,
                26.263153
              ],
              [
                61.901122,
                26.263115
              ],
              [
                61.901155,
                26.263071
              ],
              [
                61.901218,
                26.263175
              ],
              [
                61.901359,
                26.263089
              ],
              [
                61.9015,
                26.263078
              ],
              [
                61.901538,
                26.263128
              ],
              [
                61.901599,
                26.263115
              ],
              [
                61.901643,
                26.263186
              ],
              [
                61.901867,
                26.263228
              ],
              [
                61.902015,
                26.263183
              ],
              [
                61.90206,
                26.263132
              ],
              [
                61.9024311,
                26.2627598
              ],
              [
                61.902733,
                26.262584
              ],
              [
                61.902852,
                26.262522
              ],
              [
                61.902953,
                26.262472
              ],
              [
                61.903649,
                26.262505
              ],
              [
                61.904061,
                26.2623
              ],
              [
                61.904165,
                26.262059
              ],
              [
                61.904337,
                26.26185
              ],
              [
                61.904803,
                26.261638
              ],
              [
                61.905054,
                26.261707
              ],
              [
                61.905172,
                26.261658
              ],
              [
                61.905118,
                26.261589
              ],
              [
                61.905141,
                26.261432
              ],
              [
                61.905308,
                26.261236
              ],
              [
                61.905353,
                26.261217
              ],
              [
                61.905505,
                26.261285
              ],
              [
                61.905702,
                26.261249
              ],
              [
                61.905828,
                26.261306
              ],
              [
                61.906252,
                26.26119
              ],
              [
                61.906454,
                26.261303
              ],
              [
                61.906551,
                26.261291
              ],
              [
                61.906674,
                26.261201
              ],
              [
                61.906711,
                26.260643
              ],
              [
                61.906827,
                26.26049
              ],
              [
                61.90692,
                26.260147
              ],
              [
                61.907028,
                26.259998
              ],
              [
                61.906953,
                26.259771
              ],
              [
                61.90708,
                26.259693
              ],
              [
                61.907172,
                26.25951
              ],
              [
                61.90731,
                26.259497
              ],
              [
                61.907441,
                26.259542
              ],
              [
                61.907609,
                26.259501
              ],
              [
                61.90799,
                26.259556
              ],
              [
                61.908275,
                26.25975
              ],
              [
                61.908616,
                26.259586
              ],
              [
                61.908818,
                26.259393
              ],
              [
                61.908799,
                26.259202
              ],
              [
                61.908839,
                26.259131
              ],
              [
                61.909135,
                26.258807
              ],
              [
                61.909133,
                26.258535
              ],
              [
                61.90958,
                26.258369
              ],
              [
                61.909655,
                26.258169
              ],
              [
                61.90997,
                26.257913
              ],
              [
                61.910039,
                26.257796
              ],
              [
                61.910006,
                26.257596
              ],
              [
                61.910241,
                26.257323
              ],
              [
                61.910307,
                26.257172
              ],
              [
                61.910488,
                26.257043
              ],
              [
                61.910476,
                26.256891
              ],
              [
                61.910553,
                26.256728
              ],
              [
                61.910527,
                26.256436
              ],
              [
                61.91058,
                26.256308
              ],
              [
                61.910706,
                26.256248
              ],
              [
                61.910745,
                26.256047
              ],
              [
                61.910721,
                26.255862
              ],
              [
                61.91081,
                26.255819
              ],
              [
                61.910796,
                26.255572
              ],
              [
                61.910872,
                26.25532
              ],
              [
                61.910966,
                26.255138
              ],
              [
                61.911211,
                26.255074
              ],
              [
                61.911301,
                26.254811
              ],
              [
                61.911631,
                26.254796
              ],
              [
                61.911823,
                26.255246
              ],
              [
                61.911895,
                26.255242
              ],
              [
                61.912145,
                26.255361
              ],
              [
                61.91233,
                26.255588
              ],
              [
                61.912416,
                26.255791
              ],
              [
                61.912848,
                26.255858
              ],
              [
                61.912966,
                26.255821
              ],
              [
                61.913035,
                26.255894
              ],
              [
                61.913203,
                26.255866
              ],
              [
                61.913246,
                26.255847
              ],
              [
                61.913344,
                26.255585
              ],
              [
                61.913499,
                26.255508
              ],
              [
                61.91357,
                26.255309
              ],
              [
                61.913629,
                26.25526
              ],
              [
                61.913944,
                26.255126
              ],
              [
                61.914043,
                26.255163
              ],
              [
                61.914304,
                26.255088
              ],
              [
                61.914342,
                26.254975
              ],
              [
                61.914632,
                26.254639
              ],
              [
                61.914654,
                26.254575
              ],
              [
                61.914609,
                26.254516
              ],
              [
                61.914657,
                26.254394
              ],
              [
                61.91489,
                26.254434
              ],
              [
                61.915259,
                26.254312
              ],
              [
                61.915315,
                26.253824
              ],
              [
                61.91538,
                26.253863
              ],
              [
                61.915794,
                26.253836
              ],
              [
                61.916193,
                26.253958
              ],
              [
                61.916365,
                26.253895
              ],
              [
                61.916569,
                26.253726
              ],
              [
                61.916668,
                26.253766
              ],
              [
                61.91674,
                26.253861
              ],
              [
                61.916903,
                26.253833
              ],
              [
                61.917105,
                26.253862
              ],
              [
                61.917421,
                26.253761
              ],
              [
                61.917626,
                26.253824
              ],
              [
                61.917809,
                26.254067
              ],
              [
                61.91815,
                26.254135
              ],
              [
                61.918281,
                26.254363
              ],
              [
                61.918405,
                26.254388
              ],
              [
                61.918538,
                26.254495
              ],
              [
                61.918615,
                26.25449
              ],
              [
                61.918622,
                26.254369
              ],
              [
                61.91875,
                26.254133
              ],
              [
                61.918939,
                26.254154
              ],
              [
                61.919064,
                26.254099
              ],
              [
                61.919096,
                26.253968
              ],
              [
                61.919409,
                26.253994
              ],
              [
                61.919678,
                26.254109
              ],
              [
                61.919795,
                26.25428
              ],
              [
                61.919944,
                26.25434
              ],
              [
                61.920709,
                26.254479
              ],
              [
                61.920703,
                26.254731
              ],
              [
                61.920823,
                26.254746
              ],
              [
                61.921142,
                26.254966
              ],
              [
                61.921168,
                26.255171
              ],
              [
                61.921583,
                26.255334
              ],
              [
                61.921663,
                26.255447
              ],
              [
                61.921781,
                26.255441
              ],
              [
                61.92189,
                26.255508
              ],
              [
                61.922085,
                26.255509
              ],
              [
                61.922156,
                26.255619
              ],
              [
                61.92213,
                26.255682
              ],
              [
                61.922261,
                26.255713
              ],
              [
                61.922652,
                26.255624
              ],
              [
                61.92277,
                26.255555
              ],
              [
                61.922987,
                26.255586
              ],
              [
                61.923002,
                26.255687
              ],
              [
                61.923209,
                26.255605
              ],
              [
                61.923354,
                26.255651
              ],
              [
                61.923588,
                26.255598
              ],
              [
                61.923671,
                26.255447
              ],
              [
                61.923863,
                26.255429
              ],
              [
                61.924067,
                26.255311
              ],
              [
                61.924136,
                26.255482
              ],
              [
                61.924253,
                26.255516
              ],
              [
                61.924272,
                26.255619
              ],
              [
                61.924559,
                26.255961
              ],
              [
                61.924823,
                26.256062
              ],
              [
                61.924972,
                26.256179
              ],
              [
                61.925122,
                26.256199
              ],
              [
                61.925216,
                26.256167
              ],
              [
                61.9256,
                26.255912
              ],
              [
                61.925746,
                26.256012
              ],
              [
                61.925879,
                26.255988
              ],
              [
                61.925921,
                26.255937
              ],
              [
                61.92616,
                26.255956
              ],
              [
                61.926218,
                26.255869
              ],
              [
                61.926517,
                26.255793
              ],
              [
                61.926607,
                26.255807
              ],
              [
                61.928451,
                26.257087
              ],
              [
                61.928791,
                26.25706
              ],
              [
                61.928825,
                26.257116
              ],
              [
                61.929041,
                26.257097
              ],
              [
                61.929408,
                26.256843
              ],
              [
                61.929525,
                26.256847
              ],
              [
                61.92962,
                26.256636
              ],
              [
                61.930218,
                26.256614
              ],
              [
                61.930315,
                26.256517
              ],
              [
                61.930614,
                26.256367
              ],
              [
                61.930722,
                26.256387
              ],
              [
                61.930973,
                26.256299
              ],
              [
                61.931262,
                26.256564
              ],
              [
                61.93133,
                26.256742
              ],
              [
                61.931502,
                26.256859
              ],
              [
                61.931868,
                26.257009
              ],
              [
                61.932028,
                26.257176
              ],
              [
                61.932135,
                26.257194
              ],
              [
                61.932194,
                26.257387
              ],
              [
                61.932298,
                26.257458
              ],
              [
                61.932212,
                26.257617
              ],
              [
                61.932337,
                26.257829
              ],
              [
                61.93232,
                26.258104
              ],
              [
                61.932564,
                26.25804
              ],
              [
                61.932647,
                26.258092
              ],
              [
                61.932792,
                26.258073
              ],
              [
                61.932812,
                26.258111
              ],
              [
                61.93287,
                26.258099
              ],
              [
                61.933115,
                26.258197
              ],
              [
                61.933332,
                26.258138
              ],
              [
                61.933387,
                26.258062
              ],
              [
                61.933546,
                26.258045
              ],
              [
                61.933679,
                26.25796
              ],
              [
                61.93377,
                26.258022
              ],
              [
                61.93394,
                26.25793
              ],
              [
                61.934051,
                26.258004
              ],
              [
                61.934316,
                26.257998
              ],
              [
                61.9344,
                26.258056
              ],
              [
                61.93467,
                26.257941
              ],
              [
                61.935058,
                26.258069
              ],
              [
                61.93517,
                26.257979
              ],
              [
                61.935413,
                26.257995
              ],
              [
                61.935468,
                26.258061
              ],
              [
                61.9357,
                26.258004
              ],
              [
                61.935963,
                26.258078
              ],
              [
                61.93616,
                26.258
              ],
              [
                61.936234,
                26.25815
              ],
              [
                61.936226,
                26.258373
              ],
              [
                61.936131,
                26.25852
              ],
              [
                61.936122,
                26.258646
              ],
              [
                61.936313,
                26.258665
              ],
              [
                61.936271,
                26.25873
              ],
              [
                61.936289,
                26.258818
              ],
              [
                61.936343,
                26.258811
              ],
              [
                61.936566,
                26.259475
              ],
              [
                61.936692,
                26.25948
              ],
              [
                61.936879,
                26.259624
              ],
              [
                61.937207,
                26.259602
              ],
              [
                61.937307,
                26.259679
              ],
              [
                61.937447,
                26.259706
              ],
              [
                61.937688,
                26.259896
              ],
              [
                61.938048,
                26.259925
              ],
              [
                61.938195,
                26.25998
              ],
              [
                61.938366,
                26.259968
              ],
              [
                61.938428,
                26.260015
              ],
              [
                61.938769,
                26.259983
              ],
              [
                61.938935,
                26.260057
              ],
              [
                61.939084,
                26.260296
              ],
              [
                61.939362,
                26.260342
              ],
              [
                61.93954,
                26.260495
              ],
              [
                61.939778,
                26.260558
              ],
              [
                61.939905,
                26.260523
              ],
              [
                61.940329,
                26.260596
              ],
              [
                61.940346,
                26.26064
              ],
              [
                61.940455,
                26.260675
              ],
              [
                61.940606,
                26.260682
              ],
              [
                61.940763,
                26.260782
              ],
              [
                61.940789,
                26.261044
              ],
              [
                61.94093,
                26.2612
              ],
              [
                61.941006,
                26.261217
              ],
              [
                61.941056,
                26.261396
              ],
              [
                61.941402,
                26.261351
              ],
              [
                61.941458,
                26.261568
              ],
              [
                61.941656,
                26.261603
              ],
              [
                61.941788,
                26.261696
              ],
              [
                61.941927,
                26.261705
              ],
              [
                61.94192,
                26.261754
              ],
              [
                61.942044,
                26.261814
              ],
              [
                61.942087,
                26.261959
              ],
              [
                61.942253,
                26.262078
              ],
              [
                61.942303,
                26.262322
              ],
              [
                61.942462,
                26.262623
              ],
              [
                61.942703,
                26.262866
              ],
              [
                61.942837,
                26.262954
              ],
              [
                61.942916,
                26.262918
              ],
              [
                61.943023,
                26.262968
              ],
              [
                61.943109,
                26.262946
              ],
              [
                61.943287,
                26.262992
              ],
              [
                61.94342,
                26.263097
              ],
              [
                61.943633,
                26.263106
              ],
              [
                61.943589,
                26.263172
              ],
              [
                61.943617,
                26.263226
              ],
              [
                61.943921,
                26.263464
              ],
              [
                61.944029,
                26.26336
              ],
              [
                61.944248,
                26.263403
              ],
              [
                61.945125,
                26.26311
              ],
              [
                61.94542,
                26.263125
              ],
              [
                61.945449,
                26.263159
              ],
              [
                61.945546,
                26.263097
              ],
              [
                61.945646,
                26.263097
              ],
              [
                61.945766,
                26.263003
              ],
              [
                61.94602,
                26.262968
              ],
              [
                61.946289,
                26.262809
              ],
              [
                61.946481,
                26.262768
              ],
              [
                61.946632,
                26.26267
              ],
              [
                61.946592,
                26.262568
              ],
              [
                61.946974,
                26.262545
              ],
              [
                61.947019,
                26.262579
              ],
              [
                61.947024,
                26.262715
              ],
              [
                61.947179,
                26.262918
              ],
              [
                61.947304,
                26.262897
              ],
              [
                61.947504,
                26.262971
              ],
              [
                61.947622,
                26.263192
              ],
              [
                61.947567,
                26.263298
              ],
              [
                61.94772,
                26.263334
              ],
              [
                61.947751,
                26.263442
              ],
              [
                61.947874,
                26.263435
              ],
              [
                61.947984,
                26.263515
              ],
              [
                61.948049,
                26.263735
              ],
              [
                61.948043,
                26.263966
              ],
              [
                61.948207,
                26.264085
              ],
              [
                61.948424,
                26.264131
              ],
              [
                61.94852,
                26.264457
              ],
              [
                61.948567,
                26.26449
              ],
              [
                61.948825,
                26.264575
              ],
              [
                61.948936,
                26.264542
              ],
              [
                61.949205,
                26.264234
              ],
              [
                61.949411,
                26.264172
              ],
              [
                61.949519,
                26.264088
              ],
              [
                61.949717,
                26.264063
              ],
              [
                61.949806,
                26.264
              ],
              [
                61.950063,
                26.26404
              ],
              [
                61.950358,
                26.263917
              ],
              [
                61.950543,
                26.263912
              ],
              [
                61.950738,
                26.263831
              ],
              [
                61.951465,
                26.264164
              ],
              [
                61.951599,
                26.264274
              ],
              [
                61.952236,
                26.264334
              ],
              [
                61.952189,
                26.264792
              ],
              [
                61.952282,
                26.264905
              ],
              [
                61.952328,
                26.265115
              ],
              [
                61.952421,
                26.265181
              ],
              [
                61.952562,
                26.265404
              ],
              [
                61.952672,
                26.265467
              ],
              [
                61.953098,
                26.265408
              ],
              [
                61.953729,
                26.265502
              ],
              [
                61.953911,
                26.265412
              ],
              [
                61.954005,
                26.265271
              ],
              [
                61.954078,
                26.265299
              ],
              [
                61.954468,
                26.2652
              ],
              [
                61.954785,
                26.265225
              ],
              [
                61.955025,
                26.265069
              ],
              [
                61.955248,
                26.264832
              ],
              [
                61.955467,
                26.264745
              ],
              [
                61.955673,
                26.264591
              ],
              [
                61.955826,
                26.264573
              ],
              [
                61.955929,
                26.264507
              ],
              [
                61.956042,
                26.264305
              ],
              [
                61.956119,
                26.264312
              ],
              [
                61.956604,
                26.264131
              ],
              [
                61.956974,
                26.263881
              ],
              [
                61.957034,
                26.263812
              ],
              [
                61.956987,
                26.263634
              ],
              [
                61.957074,
                26.263637
              ],
              [
                61.957062,
                26.26353
              ],
              [
                61.957157,
                26.263234
              ],
              [
                61.957377,
                26.263047
              ],
              [
                61.957379,
                26.262949
              ],
              [
                61.957517,
                26.262677
              ],
              [
                61.957722,
                26.262486
              ],
              [
                61.958035,
                26.262435
              ],
              [
                61.958082,
                26.262313
              ],
              [
                61.958065,
                26.261931
              ],
              [
                61.957999,
                26.261944
              ],
              [
                61.958008,
                26.26184
              ],
              [
                61.957875,
                26.261817
              ],
              [
                61.957964,
                26.261629
              ],
              [
                61.957941,
                26.261402
              ],
              [
                61.957878,
                26.261405
              ],
              [
                61.957917,
                26.26128
              ],
              [
                61.957711,
                26.261148
              ],
              [
                61.957693,
                26.261036
              ],
              [
                61.95777,
                26.260961
              ],
              [
                61.957794,
                26.260777
              ],
              [
                61.958435,
                26.260121
              ],
              [
                61.958549,
                26.260237
              ],
              [
                61.958676,
                26.260224
              ],
              [
                61.958718,
                26.260288
              ],
              [
                61.958889,
                26.26033
              ],
              [
                61.959041,
                26.260307
              ],
              [
                61.959092,
                26.260436
              ],
              [
                61.959243,
                26.260558
              ],
              [
                61.959356,
                26.260527
              ],
              [
                61.959415,
                26.260573
              ],
              [
                61.959406,
                26.260846
              ],
              [
                61.959474,
                26.260817
              ],
              [
                61.959696,
                26.260884
              ],
              [
                61.960092,
                26.260884
              ],
              [
                61.960173,
                26.260725
              ],
              [
                61.960342,
                26.260596
              ],
              [
                61.960658,
                26.260522
              ],
              [
                61.961143,
                26.260217
              ],
              [
                61.961094,
                26.260584
              ],
              [
                61.961185,
                26.260747
              ],
              [
                61.961208,
                26.260922
              ],
              [
                61.961323,
                26.260841
              ],
              [
                61.96138,
                26.260909
              ],
              [
                61.96137,
                26.261118
              ],
              [
                61.961524,
                26.261209
              ],
              [
                61.961532,
                26.261344
              ],
              [
                61.961611,
                26.261401
              ],
              [
                61.961543,
                26.261758
              ],
              [
                61.961623,
                26.261842
              ],
              [
                61.961633,
                26.261932
              ],
              [
                61.961575,
                26.262053
              ],
              [
                61.961651,
                26.262045
              ],
              [
                61.961471,
                26.262281
              ],
              [
                61.961467,
                26.262479
              ],
              [
                61.961675,
                26.262489
              ],
              [
                61.962078,
                26.262694
              ],
              [
                61.962214,
                26.262684
              ],
              [
                61.96254,
                26.262797
              ],
              [
                61.96278,
                26.263314
              ],
              [
                61.96296,
                26.263355
              ],
              [
                61.962962,
                26.263576
              ],
              [
                61.962773,
                26.263916
              ],
              [
                61.962789,
                26.26403
              ],
              [
                61.962877,
                26.264092
              ],
              [
                61.962821,
                26.264153
              ],
              [
                61.962862,
                26.264277
              ],
              [
                61.962823,
                26.264382
              ],
              [
                61.963263,
                26.264647
              ],
              [
                61.963206,
                26.2648
              ],
              [
                61.963245,
                26.264897
              ],
              [
                61.963378,
                26.265055
              ],
              [
                61.963573,
                26.26507
              ],
              [
                61.9636,
                26.265216
              ],
              [
                61.963701,
                26.265273
              ],
              [
                61.963718,
                26.265414
              ],
              [
                61.963802,
                26.265544
              ],
              [
                61.963861,
                26.26562
              ],
              [
                61.963942,
                26.265603
              ],
              [
                61.964022,
                26.265938
              ],
              [
                61.963977,
                26.266067
              ],
              [
                61.963988,
                26.266289
              ],
              [
                61.9642,
                26.266261
              ],
              [
                61.964389,
                26.266402
              ],
              [
                61.964724,
                26.266486
              ],
              [
                61.964717,
                26.266652
              ],
              [
                61.964915,
                26.266632
              ],
              [
                61.964896,
                26.266793
              ],
              [
                61.965,
                26.266876
              ],
              [
                61.965117,
                26.266857
              ],
              [
                61.965242,
                26.266909
              ],
              [
                61.965258,
                26.266981
              ],
              [
                61.965615,
                26.267183
              ],
              [
                61.965892,
                26.267127
              ],
              [
                61.966007,
                26.267188
              ],
              [
                61.966271,
                26.267114
              ],
              [
                61.966372,
                26.267216
              ],
              [
                61.966329,
                26.26723
              ],
              [
                61.966312,
                26.26759
              ],
              [
                61.966442,
                26.267695
              ],
              [
                61.966811,
                26.267623
              ],
              [
                61.966931,
                26.267756
              ],
              [
                61.967127,
                26.267813
              ],
              [
                61.967214,
                26.267923
              ],
              [
                61.96743,
                26.267903
              ],
              [
                61.9675,
                26.268031
              ],
              [
                61.967601,
                26.268058
              ],
              [
                61.967596,
                26.268112
              ],
              [
                61.967802,
                26.268182
              ],
              [
                61.96788,
                26.268301
              ],
              [
                61.967979,
                26.268338
              ],
              [
                61.967953,
                26.268612
              ],
              [
                61.967867,
                26.268837
              ],
              [
                61.967854,
                26.269071
              ],
              [
                61.967919,
                26.26912
              ],
              [
                61.967895,
                26.26926
              ],
              [
                61.967971,
                26.269214
              ],
              [
                61.96805,
                26.269248
              ],
              [
                61.968241,
                26.269386
              ],
              [
                61.968285,
                26.26949
              ],
              [
                61.968406,
                26.269562
              ],
              [
                61.968429,
                26.269627
              ],
              [
                61.968532,
                26.269567
              ],
              [
                61.968529,
                26.269607
              ],
              [
                61.968751,
                26.269599
              ],
              [
                61.968952,
                26.269519
              ],
              [
                61.969459,
                26.2697
              ],
              [
                61.969514,
                26.269763
              ],
              [
                61.969649,
                26.269781
              ],
              [
                61.96978,
                26.269899
              ],
              [
                61.969899,
                26.269897
              ],
              [
                61.970125,
                26.269999
              ],
              [
                61.970238,
                26.269998
              ],
              [
                61.970426,
                26.269898
              ],
              [
                61.970859,
                26.269914
              ],
              [
                61.971076,
                26.26997
              ],
              [
                61.971146,
                26.269939
              ],
              [
                61.971361,
                26.270032
              ],
              [
                61.971545,
                26.270024
              ],
              [
                61.971696,
                26.269849
              ],
              [
                61.971773,
                26.270302
              ],
              [
                61.971743,
                26.270381
              ],
              [
                61.971879,
                26.270518
              ],
              [
                61.971888,
                26.270615
              ],
              [
                61.971881,
                26.270751
              ],
              [
                61.97175,
                26.270937
              ],
              [
                61.971746,
                26.271008
              ],
              [
                61.971916,
                26.271158
              ],
              [
                61.97196,
                26.271359
              ],
              [
                61.97197,
                26.271645
              ],
              [
                61.971859,
                26.271974
              ],
              [
                61.971864,
                26.272215
              ],
              [
                61.972002,
                26.27213
              ],
              [
                61.972046,
                26.27235
              ],
              [
                61.97212,
                26.272388
              ],
              [
                61.972166,
                26.272353
              ],
              [
                61.972207,
                26.272415
              ],
              [
                61.97229,
                26.272435
              ],
              [
                61.972477,
                26.27245
              ],
              [
                61.972565,
                26.272651
              ],
              [
                61.972784,
                26.272776
              ],
              [
                61.97278,
                26.272869
              ],
              [
                61.973404,
                26.273029
              ],
              [
                61.973407,
                26.273108
              ],
              [
                61.97354,
                26.273241
              ],
              [
                61.973601,
                26.273191
              ],
              [
                61.973853,
                26.273137
              ],
              [
                61.974138,
                26.273219
              ],
              [
                61.974266,
                26.273208
              ],
              [
                61.974376,
                26.273238
              ],
              [
                61.974396,
                26.273294
              ],
              [
                61.974735,
                26.273362
              ],
              [
                61.975123,
                26.27368
              ],
              [
                61.975215,
                26.273704
              ],
              [
                61.97567,
                26.273596
              ],
              [
                61.97589,
                26.273689
              ],
              [
                61.975937,
                26.273804
              ],
              [
                61.976259,
                26.273838
              ],
              [
                61.976331,
                26.273913
              ],
              [
                61.976675,
                26.273891
              ],
              [
                61.976849,
                26.27394
              ],
              [
                61.976911,
                26.274032
              ],
              [
                61.976964,
                26.274009
              ],
              [
                61.977059,
                26.27409
              ],
              [
                61.977239,
                26.274118
              ],
              [
                61.977273,
                26.274198
              ],
              [
                61.977713,
                26.274311
              ],
              [
                61.977725,
                26.274401
              ],
              [
                61.977824,
                26.27447
              ],
              [
                61.977938,
                26.27445
              ],
              [
                61.978103,
                26.27469
              ],
              [
                61.978169,
                26.274722
              ],
              [
                61.978157,
                26.274804
              ],
              [
                61.978334,
                26.274823
              ],
              [
                61.978356,
                26.274896
              ],
              [
                61.978539,
                26.274976
              ],
              [
                61.97888,
                26.274842
              ],
              [
                61.978944,
                26.274759
              ],
              [
                61.979011,
                26.27477
              ],
              [
                61.979122,
                26.274611
              ],
              [
                61.97927,
                26.274608
              ],
              [
                61.979288,
                26.274567
              ],
              [
                61.979372,
                26.274603
              ],
              [
                61.979435,
                26.274557
              ],
              [
                61.979601,
                26.274633
              ],
              [
                61.979968,
                26.274668
              ],
              [
                61.980269,
                26.274568
              ],
              [
                61.980368,
                26.274577
              ],
              [
                61.980601,
                26.27465
              ],
              [
                61.980725,
                26.274881
              ],
              [
                61.980956,
                26.274969
              ],
              [
                61.981,
                26.275234
              ],
              [
                61.981042,
                26.275238
              ],
              [
                61.981104,
                26.275368
              ],
              [
                61.981219,
                26.27581
              ],
              [
                61.981142,
                26.275948
              ],
              [
                61.981151,
                26.276058
              ],
              [
                61.981069,
                26.276137
              ],
              [
                61.981085,
                26.276199
              ],
              [
                61.981224,
                26.276233
              ],
              [
                61.981219,
                26.276289
              ],
              [
                61.981116,
                26.276638
              ],
              [
                61.981017,
                26.276651
              ],
              [
                61.981353,
                26.276812
              ],
              [
                61.981421,
                26.27701
              ],
              [
                61.981385,
                26.277232
              ],
              [
                61.981609,
                26.277219
              ],
              [
                61.981884,
                26.277285
              ],
              [
                61.98206,
                26.277197
              ],
              [
                61.982286,
                26.277308
              ],
              [
                61.98242,
                26.277301
              ],
              [
                61.982457,
                26.277401
              ],
              [
                61.982643,
                26.277455
              ],
              [
                61.982711,
                26.277546
              ],
              [
                61.982931,
                26.277611
              ],
              [
                61.983033,
                26.277792
              ],
              [
                61.982981,
                26.277975
              ],
              [
                61.983146,
                26.278223
              ],
              [
                61.983319,
                26.278686
              ],
              [
                61.983298,
                26.279097
              ],
              [
                61.983181,
                26.279208
              ],
              [
                61.983138,
                26.279501
              ],
              [
                61.983336,
                26.279869
              ],
              [
                61.983236,
                26.280047
              ],
              [
                61.983184,
                26.28003
              ],
              [
                61.983107,
                26.280157
              ],
              [
                61.982994,
                26.280203
              ],
              [
                61.98279,
                26.280551
              ],
              [
                61.982784,
                26.280619
              ],
              [
                61.982881,
                26.280707
              ],
              [
                61.982873,
                26.280993
              ],
              [
                61.982942,
                26.281173
              ],
              [
                61.983084,
                26.281209
              ],
              [
                61.983161,
                26.281176
              ],
              [
                61.98332,
                26.281201
              ],
              [
                61.983519,
                26.281143
              ],
              [
                61.983532,
                26.281193
              ],
              [
                61.983694,
                26.281165
              ],
              [
                61.983859,
                26.281214
              ],
              [
                61.983959,
                26.281323
              ],
              [
                61.98422,
                26.281365
              ],
              [
                61.984316,
                26.281467
              ],
              [
                61.984503,
                26.281497
              ],
              [
                61.984628,
                26.281419
              ],
              [
                61.985007,
                26.281407
              ],
              [
                61.98528,
                26.281549
              ],
              [
                61.985338,
                26.281432
              ],
              [
                61.985424,
                26.281402
              ],
              [
                61.985674,
                26.281381
              ],
              [
                61.985805,
                26.281302
              ],
              [
                61.986077,
                26.281292
              ],
              [
                61.986192,
                26.281221
              ],
              [
                61.986392,
                26.281265
              ],
              [
                61.986451,
                26.281174
              ],
              [
                61.986976,
                26.281359
              ],
              [
                61.987287,
                26.281403
              ],
              [
                61.987651,
                26.281214
              ],
              [
                61.987917,
                26.280831
              ],
              [
                61.988103,
                26.280948
              ],
              [
                61.988397,
                26.281023
              ],
              [
                61.988741,
                26.280909
              ],
              [
                61.988768,
                26.280833
              ],
              [
                61.988877,
                26.280759
              ],
              [
                61.989181,
                26.28063
              ],
              [
                61.989631,
                26.280815
              ],
              [
                61.989621,
                26.280945
              ],
              [
                61.989764,
                26.281227
              ],
              [
                61.989934,
                26.2812
              ],
              [
                61.990045,
                26.281073
              ],
              [
                61.990156,
                26.281023
              ],
              [
                61.990255,
                26.281115
              ],
              [
                61.99039,
                26.281112
              ],
              [
                61.990555,
                26.281241
              ],
              [
                61.990918,
                26.281265
              ],
              [
                61.991328,
                26.281421
              ],
              [
                61.991418,
                26.281554
              ],
              [
                61.991603,
                26.281659
              ],
              [
                61.991835,
                26.281667
              ],
              [
                61.991964,
                26.281798
              ],
              [
                61.992165,
                26.281826
              ],
              [
                61.992215,
                26.281881
              ],
              [
                61.992529,
                26.281892
              ],
              [
                61.992655,
                26.281951
              ],
              [
                61.993155,
                26.282019
              ],
              [
                61.993316,
                26.282146
              ],
              [
                61.993393,
                26.28238
              ],
              [
                61.993566,
                26.282509
              ],
              [
                61.993725,
                26.282462
              ],
              [
                61.993961,
                26.282559
              ],
              [
                61.994355,
                26.282539
              ],
              [
                61.994456,
                26.282478
              ],
              [
                61.994993,
                26.282479
              ],
              [
                61.995123,
                26.282273
              ],
              [
                61.995385,
                26.28213
              ],
              [
                61.995584,
                26.282085
              ],
              [
                61.995707,
                26.281836
              ],
              [
                61.995783,
                26.281785
              ],
              [
                61.995811,
                26.281426
              ],
              [
                61.996059,
                26.281121
              ],
              [
                61.996164,
                26.28106
              ],
              [
                61.996091,
                26.280885
              ],
              [
                61.996211,
                26.280771
              ],
              [
                61.996332,
                26.280722
              ],
              [
                61.996509,
                26.280766
              ],
              [
                61.996688,
                26.280879
              ],
              [
                61.996801,
                26.280866
              ],
              [
                61.996962,
                26.280779
              ],
              [
                61.996954,
                26.280706
              ],
              [
                61.99709,
                26.280548
              ],
              [
                61.997223,
                26.280631
              ],
              [
                61.997447,
                26.281004
              ],
              [
                61.997558,
                26.281365
              ],
              [
                61.9977,
                26.281526
              ],
              [
                61.997718,
                26.281767
              ],
              [
                61.998102,
                26.282516
              ],
              [
                61.998231,
                26.28265
              ],
              [
                61.998347,
                26.282626
              ],
              [
                61.998299,
                26.28276
              ],
              [
                61.998456,
                26.282704
              ],
              [
                61.998696,
                26.282984
              ],
              [
                61.99912,
                26.282938
              ],
              [
                61.999254,
                26.283074
              ],
              [
                61.999576,
                26.283138
              ],
              [
                61.999632,
                26.283216
              ],
              [
                61.999874,
                26.28329
              ],
              [
                61.99988,
                26.283336
              ],
              [
                62.000272,
                26.28336
              ],
              [
                62.00044,
                26.283507
              ],
              [
                62.000614,
                26.283819
              ],
              [
                62.00059,
                26.283982
              ],
              [
                62.000712,
                26.28433
              ],
              [
                62.000644,
                26.284486
              ],
              [
                62.000733,
                26.28454
              ],
              [
                62.000715,
                26.284635
              ],
              [
                62.000832,
                26.284597
              ],
              [
                62.001036,
                26.28462
              ],
              [
                62.001143,
                26.285413
              ],
              [
                62.001343,
                26.285497
              ],
              [
                62.001382,
                26.285611
              ],
              [
                62.001432,
                26.285594
              ],
              [
                62.001643,
                26.285777
              ],
              [
                62.001714,
                26.285774
              ],
              [
                62.001864,
                26.285904
              ],
              [
                62.001894,
                26.286014
              ],
              [
                62.002005,
                26.28608
              ],
              [
                62.00198,
                26.286153
              ],
              [
                62.002082,
                26.286381
              ],
              [
                62.002085,
                26.286517
              ],
              [
                62.002169,
                26.286634
              ],
              [
                62.002182,
                26.286845
              ],
              [
                62.002319,
                26.286861
              ],
              [
                62.002572,
                26.286977
              ],
              [
                62.002751,
                26.286993
              ],
              [
                62.002904,
                26.287093
              ],
              [
                62.002795,
                26.28739
              ],
              [
                62.002874,
                26.287688
              ],
              [
                62.002982,
                26.287749
              ],
              [
                62.003027,
                26.288056
              ],
              [
                62.003013,
                26.288129
              ],
              [
                62.002914,
                26.288208
              ],
              [
                62.00285,
                26.288648
              ],
              [
                62.002891,
                26.288726
              ],
              [
                62.003129,
                26.288781
              ],
              [
                62.003147,
                26.288825
              ],
              [
                62.003237,
                26.288761
              ],
              [
                62.003305,
                26.288908
              ],
              [
                62.00344,
                26.28897
              ],
              [
                62.003513,
                26.28895
              ],
              [
                62.003514,
                26.289053
              ],
              [
                62.003631,
                26.289208
              ],
              [
                62.003821,
                26.289291
              ],
              [
                62.003782,
                26.289374
              ],
              [
                62.003829,
                26.289399
              ],
              [
                62.003828,
                26.289547
              ],
              [
                62.003938,
                26.289714
              ],
              [
                62.003966,
                26.289884
              ],
              [
                62.004021,
                26.28988
              ],
              [
                62.00403,
                26.289947
              ],
              [
                62.004153,
                26.290006
              ],
              [
                62.00426,
                26.290204
              ],
              [
                62.004081,
                26.290616
              ],
              [
                62.004068,
                26.290831
              ],
              [
                62.004104,
                26.29089
              ],
              [
                62.004029,
                26.290944
              ],
              [
                62.004201,
                26.291175
              ],
              [
                62.004285,
                26.291177
              ],
              [
                62.004133,
                26.291399
              ],
              [
                62.004145,
                26.29191
              ],
              [
                62.004231,
                26.291896
              ],
              [
                62.004687,
                26.292126
              ],
              [
                62.004984,
                26.292139
              ],
              [
                62.005239,
                26.292217
              ],
              [
                62.005373,
                26.292483
              ],
              [
                62.005609,
                26.292627
              ],
              [
                62.005699,
                26.292893
              ],
              [
                62.005757,
                26.292916
              ],
              [
                62.005765,
                26.292994
              ],
              [
                62.005685,
                26.293049
              ],
              [
                62.005742,
                26.293137
              ],
              [
                62.005789,
                26.293105
              ],
              [
                62.005798,
                26.293161
              ],
              [
                62.005883,
                26.293144
              ],
              [
                62.0058,
                26.293294
              ],
              [
                62.005822,
                26.293329
              ],
              [
                62.005682,
                26.293453
              ],
              [
                62.005567,
                26.293734
              ],
              [
                62.005616,
                26.293797
              ],
              [
                62.005527,
                26.293949
              ],
              [
                62.005733,
                26.294176
              ],
              [
                62.005797,
                26.294179
              ],
              [
                62.005848,
                26.29428
              ],
              [
                62.005972,
                26.294317
              ],
              [
                62.005967,
                26.294391
              ],
              [
                62.006112,
                26.294572
              ],
              [
                62.006181,
                26.294599
              ],
              [
                62.006192,
                26.294692
              ],
              [
                62.006237,
                26.294693
              ],
              [
                62.006307,
                26.294826
              ],
              [
                62.006426,
                26.29491
              ],
              [
                62.006448,
                26.295002
              ],
              [
                62.006657,
                26.295169
              ],
              [
                62.00667,
                26.29526
              ],
              [
                62.007124,
                26.295285
              ],
              [
                62.007813,
                26.295582
              ],
              [
                62.008377,
                26.295677
              ],
              [
                62.008711,
                26.295891
              ],
              [
                62.008971,
                26.295927
              ],
              [
                62.009047,
                26.295974
              ],
              [
                62.009148,
                26.295944
              ],
              [
                62.009249,
                26.296055
              ],
              [
                62.009552,
                26.296152
              ],
              [
                62.009664,
                26.296259
              ],
              [
                62.009817,
                26.296323
              ],
              [
                62.00988,
                26.296409
              ],
              [
                62.009986,
                26.296416
              ],
              [
                62.01005,
                26.296492
              ],
              [
                62.010126,
                26.296471
              ],
              [
                62.010124,
                26.296589
              ],
              [
                62.010361,
                26.296765
              ],
              [
                62.010512,
                26.296969
              ],
              [
                62.010677,
                26.296906
              ],
              [
                62.010743,
                26.29701
              ],
              [
                62.010614,
                26.297225
              ],
              [
                62.010587,
                26.297653
              ],
              [
                62.010483,
                26.297709
              ],
              [
                62.010516,
                26.297889
              ],
              [
                62.010362,
                26.298141
              ],
              [
                62.010354,
                26.298312
              ],
              [
                62.01018,
                26.298486
              ],
              [
                62.009712,
                26.298728
              ],
              [
                62.009762,
                26.298837
              ],
              [
                62.009674,
                26.298969
              ],
              [
                62.009745,
                26.298968
              ],
              [
                62.009894,
                26.299161
              ],
              [
                62.009983,
                26.29948
              ],
              [
                62.009934,
                26.299611
              ],
              [
                62.009957,
                26.299664
              ],
              [
                62.009987,
                26.299722
              ],
              [
                62.010109,
                26.299775
              ],
              [
                62.01006,
                26.299852
              ],
              [
                62.010105,
                26.299923
              ],
              [
                62.010332,
                26.300107
              ],
              [
                62.010398,
                26.300085
              ],
              [
                62.010353,
                26.300166
              ],
              [
                62.010397,
                26.300221
              ],
              [
                62.010696,
                26.300158
              ],
              [
                62.0107,
                26.300258
              ],
              [
                62.010771,
                26.30023
              ],
              [
                62.010796,
                26.300289
              ],
              [
                62.011086,
                26.300063
              ],
              [
                62.011346,
                26.300333
              ],
              [
                62.011433,
                26.300294
              ],
              [
                62.011555,
                26.300309
              ],
              [
                62.011574,
                26.300273
              ],
              [
                62.011694,
                26.300374
              ],
              [
                62.011851,
                26.300347
              ],
              [
                62.011893,
                26.300414
              ],
              [
                62.012093,
                26.300405
              ],
              [
                62.012134,
                26.300513
              ],
              [
                62.012078,
                26.300528
              ],
              [
                62.012097,
                26.30059
              ],
              [
                62.012186,
                26.300603
              ],
              [
                62.012236,
                26.300559
              ],
              [
                62.012453,
                26.300632
              ],
              [
                62.012615,
                26.300747
              ],
              [
                62.012728,
                26.30093
              ],
              [
                62.012726,
                26.301059
              ],
              [
                62.012906,
                26.301119
              ],
              [
                62.012934,
                26.301207
              ],
              [
                62.013162,
                26.301286
              ],
              [
                62.01332,
                26.30144
              ],
              [
                62.01332,
                26.30168
              ],
              [
                62.013395,
                26.301766
              ],
              [
                62.013314,
                26.301913
              ],
              [
                62.013326,
                26.301982
              ],
              [
                62.013526,
                26.302181
              ],
              [
                62.013516,
                26.302355
              ],
              [
                62.013453,
                26.302423
              ],
              [
                62.013527,
                26.302572
              ],
              [
                62.013523,
                26.302668
              ],
              [
                62.013727,
                26.302869
              ],
              [
                62.013797,
                26.303015
              ],
              [
                62.013927,
                26.303065
              ],
              [
                62.013968,
                26.303022
              ],
              [
                62.014126,
                26.303064
              ],
              [
                62.014145,
                26.302974
              ],
              [
                62.014315,
                26.302964
              ],
              [
                62.014631,
                26.302483
              ],
              [
                62.014787,
                26.302571
              ],
              [
                62.014899,
                26.302514
              ],
              [
                62.01505,
                26.302552
              ],
              [
                62.015186,
                26.30245
              ],
              [
                62.015539,
                26.302711
              ],
              [
                62.015617,
                26.30273
              ],
              [
                62.015737,
                26.302675
              ],
              [
                62.015732,
                26.302807
              ],
              [
                62.015836,
                26.302904
              ],
              [
                62.015863,
                26.303028
              ],
              [
                62.015982,
                26.303142
              ],
              [
                62.016126,
                26.303203
              ],
              [
                62.016382,
                26.303567
              ],
              [
                62.016476,
                26.303617
              ],
              [
                62.016517,
                26.303697
              ],
              [
                62.016661,
                26.303728
              ],
              [
                62.016674,
                26.303805
              ],
              [
                62.016757,
                26.303859
              ],
              [
                62.016922,
                26.303741
              ],
              [
                62.017547,
                26.30373
              ],
              [
                62.017696,
                26.303661
              ],
              [
                62.017795,
                26.303697
              ],
              [
                62.018213,
                26.303635
              ],
              [
                62.018292,
                26.303668
              ],
              [
                62.018392,
                26.30354
              ],
              [
                62.018701,
                26.303357
              ],
              [
                62.018799,
                26.303387
              ],
              [
                62.01889,
                26.303268
              ],
              [
                62.018945,
                26.303371
              ],
              [
                62.019005,
                26.303361
              ],
              [
                62.019002,
                26.303416
              ],
              [
                62.019122,
                26.30338
              ],
              [
                62.019269,
                26.303426
              ],
              [
                62.019398,
                26.303588
              ],
              [
                62.019769,
                26.303417
              ],
              [
                62.019876,
                26.303475
              ],
              [
                62.020182,
                26.303402
              ],
              [
                62.020299,
                26.303517
              ],
              [
                62.020527,
                26.303375
              ],
              [
                62.020767,
                26.303345
              ],
              [
                62.020851,
                26.303293
              ],
              [
                62.021114,
                26.30305
              ],
              [
                62.0212,
                26.302883
              ],
              [
                62.021346,
                26.302831
              ],
              [
                62.021346,
                26.302872
              ],
              [
                62.021573,
                26.302905
              ],
              [
                62.02158,
                26.302852
              ],
              [
                62.021768,
                26.302815
              ],
              [
                62.021902,
                26.303066
              ],
              [
                62.02187,
                26.303151
              ],
              [
                62.02195,
                26.303178
              ],
              [
                62.022006,
                26.303409
              ],
              [
                62.022072,
                26.303455
              ],
              [
                62.02215,
                26.303849
              ],
              [
                62.022291,
                26.303949
              ],
              [
                62.022175,
                26.304129
              ],
              [
                62.022069,
                26.304136
              ],
              [
                62.022188,
                26.304397
              ],
              [
                62.022325,
                26.304568
              ],
              [
                62.022276,
                26.304656
              ],
              [
                62.022045,
                26.304757
              ],
              [
                62.022051,
                26.304922
              ],
              [
                62.021935,
                26.305048
              ],
              [
                62.021964,
                26.305087
              ],
              [
                62.021911,
                26.305101
              ],
              [
                62.021991,
                26.305225
              ],
              [
                62.021957,
                26.305416
              ],
              [
                62.02204,
                26.305484
              ],
              [
                62.022013,
                26.305524
              ],
              [
                62.022109,
                26.30568
              ],
              [
                62.022087,
                26.305954
              ],
              [
                62.02214,
                26.305962
              ],
              [
                62.022185,
                26.306115
              ],
              [
                62.022092,
                26.306212
              ],
              [
                62.022027,
                26.306199
              ],
              [
                62.021838,
                26.306648
              ],
              [
                62.021694,
                26.306683
              ],
              [
                62.021658,
                26.306984
              ],
              [
                62.021527,
                26.307069
              ],
              [
                62.021416,
                26.307256
              ],
              [
                62.021299,
                26.307309
              ],
              [
                62.02128,
                26.307427
              ],
              [
                62.021074,
                26.307551
              ],
              [
                62.021064,
                26.307793
              ],
              [
                62.021159,
                26.308042
              ],
              [
                62.021372,
                26.308217
              ],
              [
                62.021412,
                26.30821
              ],
              [
                62.021394,
                26.308568
              ],
              [
                62.021648,
                26.308605
              ],
              [
                62.02179,
                26.308671
              ],
              [
                62.021827,
                26.308733
              ],
              [
                62.022045,
                26.308708
              ],
              [
                62.021964,
                26.308828
              ],
              [
                62.022028,
                26.308891
              ],
              [
                62.022009,
                26.30893
              ],
              [
                62.022051,
                26.308914
              ],
              [
                62.021999,
                26.309144
              ],
              [
                62.022035,
                26.309187
              ],
              [
                62.021984,
                26.309256
              ],
              [
                62.02214,
                26.30932
              ],
              [
                62.022243,
                26.30945
              ],
              [
                62.02241,
                26.309441
              ],
              [
                62.022533,
                26.309582
              ],
              [
                62.022771,
                26.309586
              ],
              [
                62.022897,
                26.309685
              ],
              [
                62.023018,
                26.309657
              ],
              [
                62.023185,
                26.309812
              ],
              [
                62.023476,
                26.309837
              ],
              [
                62.023626,
                26.309968
              ],
              [
                62.023792,
                26.309978
              ],
              [
                62.023795,
                26.310062
              ],
              [
                62.024072,
                26.310177
              ],
              [
                62.024202,
                26.310158
              ],
              [
                62.024259,
                26.310244
              ],
              [
                62.024327,
                26.310255
              ],
              [
                62.024251,
                26.310568
              ],
              [
                62.024061,
                26.310763
              ],
              [
                62.02395,
                26.311134
              ],
              [
                62.024106,
                26.311141
              ],
              [
                62.024282,
                26.311294
              ],
              [
                62.024306,
                26.311364
              ],
              [
                62.024196,
                26.311543
              ],
              [
                62.024277,
                26.311563
              ],
              [
                62.024557,
                26.311844
              ],
              [
                62.024795,
                26.311662
              ],
              [
                62.024819,
                26.311718
              ],
              [
                62.024877,
                26.31167
              ],
              [
                62.025283,
                26.311635
              ],
              [
                62.025607,
                26.311789
              ],
              [
                62.025588,
                26.311925
              ],
              [
                62.025648,
                26.31197
              ],
              [
                62.025729,
                26.31197
              ],
              [
                62.025957,
                26.312121
              ],
              [
                62.026075,
                26.312131
              ],
              [
                62.026304,
                26.312379
              ],
              [
                62.026408,
                26.312406
              ],
              [
                62.026418,
                26.312522
              ],
              [
                62.02651,
                26.312522
              ],
              [
                62.026533,
                26.312573
              ],
              [
                62.026828,
                26.312661
              ],
              [
                62.026936,
                26.312552
              ],
              [
                62.027061,
                26.31254
              ],
              [
                62.027066,
                26.312506
              ],
              [
                62.027146,
                26.312523
              ],
              [
                62.027155,
                26.312453
              ],
              [
                62.027446,
                26.312492
              ],
              [
                62.02749,
                26.312463
              ],
              [
                62.027623,
                26.312539
              ],
              [
                62.027794,
                26.312478
              ],
              [
                62.02785,
                26.31252
              ],
              [
                62.027882,
                26.312485
              ],
              [
                62.027947,
                26.312542
              ],
              [
                62.028154,
                26.312538
              ],
              [
                62.028305,
                26.312712
              ],
              [
                62.028383,
                26.312701
              ],
              [
                62.028477,
                26.312587
              ],
              [
                62.028562,
                26.312586
              ],
              [
                62.028588,
                26.312633
              ],
              [
                62.028575,
                26.31296
              ],
              [
                62.028719,
                26.3133
              ],
              [
                62.028778,
                26.313587
              ],
              [
                62.028759,
                26.313722
              ],
              [
                62.028601,
                26.313873
              ],
              [
                62.028629,
                26.313948
              ],
              [
                62.028448,
                26.314046
              ],
              [
                62.028249,
                26.314282
              ],
              [
                62.028234,
                26.314432
              ],
              [
                62.028322,
                26.314581
              ],
              [
                62.028068,
                26.31491
              ],
              [
                62.028097,
                26.315028
              ],
              [
                62.027902,
                26.315175
              ],
              [
                62.027973,
                26.315172
              ],
              [
                62.028004,
                26.315232
              ],
              [
                62.027946,
                26.31546
              ],
              [
                62.027971,
                26.315702
              ],
              [
                62.028187,
                26.315698
              ],
              [
                62.028241,
                26.316102
              ],
              [
                62.028483,
                26.316304
              ],
              [
                62.028497,
                26.316436
              ],
              [
                62.028431,
                26.316518
              ],
              [
                62.028276,
                26.316571
              ],
              [
                62.028175,
                26.316793
              ],
              [
                62.02807,
                26.316884
              ],
              [
                62.028252,
                26.31729
              ],
              [
                62.028366,
                26.317394
              ],
              [
                62.028446,
                26.317392
              ],
              [
                62.028492,
                26.31748
              ],
              [
                62.028444,
                26.317575
              ],
              [
                62.028494,
                26.317627
              ],
              [
                62.028383,
                26.317708
              ],
              [
                62.028339,
                26.317849
              ],
              [
                62.02812,
                26.317978
              ],
              [
                62.028052,
                26.318159
              ],
              [
                62.027963,
                26.318231
              ],
              [
                62.027888,
                26.318506
              ],
              [
                62.027929,
                26.31878
              ],
              [
                62.027774,
                26.319041
              ],
              [
                62.02765,
                26.319141
              ],
              [
                62.027509,
                26.319481
              ],
              [
                62.027365,
                26.319519
              ],
              [
                62.02716,
                26.319687
              ],
              [
                62.027183,
                26.319735
              ],
              [
                62.027139,
                26.319767
              ],
              [
                62.026958,
                26.319824
              ],
              [
                62.026736,
                26.319829
              ],
              [
                62.026663,
                26.31989
              ],
              [
                62.02654,
                26.320036
              ],
              [
                62.02649,
                26.320288
              ],
              [
                62.026347,
                26.320369
              ],
              [
                62.026389,
                26.320471
              ],
              [
                62.026096,
                26.320916
              ],
              [
                62.026453,
                26.321266
              ],
              [
                62.026745,
                26.321271
              ],
              [
                62.027083,
                26.321475
              ],
              [
                62.027151,
                26.321627
              ],
              [
                62.027138,
                26.321826
              ],
              [
                62.027211,
                26.32189
              ],
              [
                62.027286,
                26.321867
              ],
              [
                62.027384,
                26.321908
              ],
              [
                62.027667,
                26.32212
              ],
              [
                62.027951,
                26.322223
              ],
              [
                62.028109,
                26.322224
              ],
              [
                62.028118,
                26.322334
              ],
              [
                62.028186,
                26.322402
              ],
              [
                62.028267,
                26.322628
              ],
              [
                62.028273,
                26.32286
              ],
              [
                62.028458,
                26.323063
              ],
              [
                62.028418,
                26.323152
              ],
              [
                62.028276,
                26.323211
              ],
              [
                62.027883,
                26.323539
              ],
              [
                62.027898,
                26.32361
              ],
              [
                62.027802,
                26.323828
              ],
              [
                62.028134,
                26.324417
              ],
              [
                62.028157,
                26.324695
              ],
              [
                62.028217,
                26.324726
              ],
              [
                62.028249,
                26.324819
              ],
              [
                62.028166,
                26.324846
              ],
              [
                62.028119,
                26.325029
              ],
              [
                62.027954,
                26.325062
              ],
              [
                62.027785,
                26.325177
              ],
              [
                62.027567,
                26.325465
              ],
              [
                62.027428,
                26.325494
              ],
              [
                62.027176,
                26.32547
              ],
              [
                62.026707,
                26.325682
              ],
              [
                62.026414,
                26.325909
              ],
              [
                62.026403,
                26.32608
              ],
              [
                62.026809,
                26.326159
              ],
              [
                62.026822,
                26.326234
              ],
              [
                62.027097,
                26.3266
              ],
              [
                62.02705,
                26.326796
              ],
              [
                62.027101,
                26.327143
              ],
              [
                62.027234,
                26.327181
              ],
              [
                62.027497,
                26.327385
              ],
              [
                62.027905,
                26.32783
              ],
              [
                62.027979,
                26.327843
              ],
              [
                62.027945,
                26.327892
              ],
              [
                62.028224,
                26.328179
              ],
              [
                62.028542,
                26.328068
              ],
              [
                62.028763,
                26.328116
              ],
              [
                62.02883,
                26.328192
              ],
              [
                62.029183,
                26.328357
              ],
              [
                62.029412,
                26.328398
              ],
              [
                62.029403,
                26.328563
              ],
              [
                62.030002,
                26.329029
              ],
              [
                62.029793,
                26.329773
              ],
              [
                62.02974,
                26.330203
              ],
              [
                62.02982,
                26.330299
              ],
              [
                62.029813,
                26.330546
              ],
              [
                62.029857,
                26.33065
              ],
              [
                62.029815,
                26.330982
              ],
              [
                62.029748,
                26.331143
              ],
              [
                62.02979,
                26.331284
              ],
              [
                62.029602,
                26.331501
              ],
              [
                62.02957,
                26.331602
              ],
              [
                62.029598,
                26.331745
              ],
              [
                62.02944,
                26.332079
              ],
              [
                62.02943,
                26.332264
              ],
              [
                62.029288,
                26.332394
              ],
              [
                62.029243,
                26.332683
              ],
              [
                62.02928,
                26.332786
              ],
              [
                62.02949,
                26.33295
              ],
              [
                62.029563,
                26.33308
              ],
              [
                62.029572,
                26.333426
              ],
              [
                62.029791,
                26.333616
              ],
              [
                62.030346,
                26.333709
              ],
              [
                62.0308,
                26.333843
              ],
              [
                62.031459,
                26.333676
              ],
              [
                62.031741,
                26.333424
              ],
              [
                62.031855,
                26.333678
              ],
              [
                62.032052,
                26.33382
              ],
              [
                62.032327,
                26.333744
              ],
              [
                62.032444,
                26.333872
              ],
              [
                62.032553,
                26.333884
              ],
              [
                62.032612,
                26.333838
              ],
              [
                62.032649,
                26.333928
              ],
              [
                62.032959,
                26.334175
              ],
              [
                62.033147,
                26.334122
              ],
              [
                62.033239,
                26.334138
              ],
              [
                62.033312,
                26.334235
              ],
              [
                62.033318,
                26.334419
              ],
              [
                62.033364,
                26.334491
              ],
              [
                62.033713,
                26.334364
              ],
              [
                62.033788,
                26.334415
              ],
              [
                62.033853,
                26.334378
              ],
              [
                62.034256,
                26.334372
              ],
              [
                62.034766,
                26.333951
              ],
              [
                62.034891,
                26.334028
              ],
              [
                62.035084,
                26.334043
              ],
              [
                62.035199,
                26.334135
              ],
              [
                62.03532,
                26.334159
              ],
              [
                62.035657,
                26.333907
              ],
              [
                62.035773,
                26.333909
              ],
              [
                62.035762,
                26.333785
              ],
              [
                62.035932,
                26.333608
              ],
              [
                62.035898,
                26.333567
              ],
              [
                62.036201,
                26.333387
              ],
              [
                62.036482,
                26.333312
              ],
              [
                62.036696,
                26.333199
              ],
              [
                62.036907,
                26.332936
              ],
              [
                62.037263,
                26.332904
              ],
              [
                62.037365,
                26.332847
              ],
              [
                62.03746,
                26.332867
              ],
              [
                62.037654,
                26.332772
              ],
              [
                62.037807,
                26.332768
              ],
              [
                62.03785,
                26.332717
              ],
              [
                62.038875,
                26.332854
              ],
              [
                62.039081,
                26.33294
              ],
              [
                62.039118,
                26.333047
              ],
              [
                62.039334,
                26.333141
              ],
              [
                62.039512,
                26.333043
              ],
              [
                62.039769,
                26.333083
              ],
              [
                62.039752,
                26.332984
              ],
              [
                62.039955,
                26.33292
              ],
              [
                62.040478,
                26.333016
              ],
              [
                62.040724,
                26.333021
              ],
              [
                62.040814,
                26.333196
              ],
              [
                62.041093,
                26.333245
              ],
              [
                62.041334,
                26.333363
              ],
              [
                62.041494,
                26.333366
              ],
              [
                62.041811,
                26.333529
              ],
              [
                62.042049,
                26.333493
              ],
              [
                62.042106,
                26.333567
              ],
              [
                62.042106,
                26.333676
              ],
              [
                62.042628,
                26.333828
              ],
              [
                62.043058,
                26.333752
              ],
              [
                62.043295,
                26.333771
              ],
              [
                62.043274,
                26.333821
              ],
              [
                62.043386,
                26.333842
              ],
              [
                62.043546,
                26.333729
              ],
              [
                62.043734,
                26.333781
              ],
              [
                62.044648,
                26.333603
              ],
              [
                62.04463,
                26.333518
              ],
              [
                62.044836,
                26.333391
              ],
              [
                62.044853,
                26.333263
              ],
              [
                62.044919,
                26.333208
              ],
              [
                62.044878,
                26.333183
              ],
              [
                62.044909,
                26.333092
              ],
              [
                62.044804,
                26.333046
              ],
              [
                62.044842,
                26.333001
              ],
              [
                62.044632,
                26.332837
              ],
              [
                62.044531,
                26.332654
              ],
              [
                62.044709,
                26.33261
              ],
              [
                62.044756,
                26.332533
              ],
              [
                62.045273,
                26.332483
              ],
              [
                62.045379,
                26.332394
              ],
              [
                62.045703,
                26.332409
              ],
              [
                62.045776,
                26.332269
              ],
              [
                62.045883,
                26.332202
              ],
              [
                62.046104,
                26.332311
              ],
              [
                62.046581,
                26.332398
              ],
              [
                62.046991,
                26.332399
              ],
              [
                62.047451,
                26.33247
              ],
              [
                62.047607,
                26.332456
              ],
              [
                62.048085,
                26.332254
              ],
              [
                62.048016,
                26.331828
              ],
              [
                62.048038,
                26.331771
              ],
              [
                62.048123,
                26.331745
              ],
              [
                62.048114,
                26.331697
              ],
              [
                62.04825,
                26.331685
              ],
              [
                62.048152,
                26.331524
              ],
              [
                62.048094,
                26.331504
              ],
              [
                62.048119,
                26.331407
              ],
              [
                62.048074,
                26.331352
              ],
              [
                62.048485,
                26.331332
              ],
              [
                62.048723,
                26.331176
              ],
              [
                62.048706,
                26.331138
              ],
              [
                62.048829,
                26.331052
              ],
              [
                62.048901,
                26.330923
              ],
              [
                62.049186,
                26.330935
              ],
              [
                62.04921,
                26.330821
              ],
              [
                62.04937,
                26.330783
              ],
              [
                62.049388,
                26.33056
              ],
              [
                62.049676,
                26.330523
              ],
              [
                62.049811,
                26.330546
              ],
              [
                62.049861,
                26.330466
              ],
              [
                62.049911,
                26.330481
              ],
              [
                62.04995,
                26.330438
              ],
              [
                62.049902,
                26.330402
              ],
              [
                62.050146,
                26.330258
              ],
              [
                62.050119,
                26.330082
              ],
              [
                62.050399,
                26.329903
              ],
              [
                62.050313,
                26.329585
              ],
              [
                62.050434,
                26.329434
              ],
              [
                62.050398,
                26.329375
              ],
              [
                62.050468,
                26.329323
              ],
              [
                62.050495,
                26.329199
              ],
              [
                62.050892,
                26.329354
              ],
              [
                62.050893,
                26.329315
              ],
              [
                62.051112,
                26.329234
              ],
              [
                62.051368,
                26.329211
              ],
              [
                62.051601,
                26.329207
              ],
              [
                62.051743,
                26.32928
              ],
              [
                62.051819,
                26.329199
              ],
              [
                62.051991,
                26.329311
              ],
              [
                62.052016,
                26.329258
              ],
              [
                62.052142,
                26.329235
              ],
              [
                62.052221,
                26.329106
              ],
              [
                62.052388,
                26.329004
              ],
              [
                62.052531,
                26.329073
              ],
              [
                62.052777,
                26.328938
              ],
              [
                62.052866,
                26.329028
              ],
              [
                62.053123,
                26.329095
              ],
              [
                62.05321,
                26.329184
              ],
              [
                62.053282,
                26.329195
              ],
              [
                62.05352,
                26.329135
              ],
              [
                62.05354,
                26.329074
              ],
              [
                62.053723,
                26.329033
              ],
              [
                62.053745,
                26.328995
              ],
              [
                62.053921,
                26.329054
              ],
              [
                62.054066,
                26.328995
              ],
              [
                62.054433,
                26.329142
              ],
              [
                62.054676,
                26.329005
              ],
              [
                62.054774,
                26.329047
              ],
              [
                62.055044,
                26.329014
              ],
              [
                62.055468,
                26.329046
              ],
              [
                62.055569,
                26.329026
              ],
              [
                62.055629,
                26.328854
              ],
              [
                62.055899,
                26.328749
              ],
              [
                62.055944,
                26.328692
              ],
              [
                62.056364,
                26.32872
              ],
              [
                62.056418,
                26.328766
              ],
              [
                62.056576,
                26.328567
              ],
              [
                62.056871,
                26.328715
              ],
              [
                62.057022,
                26.328634
              ],
              [
                62.05724,
                26.328638
              ],
              [
                62.057523,
                26.328502
              ],
              [
                62.057645,
                26.328519
              ],
              [
                62.057836,
                26.328383
              ],
              [
                62.058496,
                26.328313
              ],
              [
                62.05892,
                26.328137
              ],
              [
                62.059141,
                26.327857
              ],
              [
                62.059342,
                26.327942
              ],
              [
                62.059346,
                26.328022
              ],
              [
                62.059458,
                26.328086
              ],
              [
                62.059606,
                26.328077
              ],
              [
                62.05962,
                26.328029
              ],
              [
                62.059675,
                26.328022
              ],
              [
                62.060115,
                26.328287
              ],
              [
                62.060298,
                26.328151
              ],
              [
                62.060706,
                26.32809
              ],
              [
                62.061093,
                26.327803
              ],
              [
                62.06117,
                26.327799
              ],
              [
                62.061164,
                26.327349
              ],
              [
                62.061275,
                26.327278
              ],
              [
                62.061297,
                26.327156
              ],
              [
                62.061258,
                26.327135
              ],
              [
                62.061266,
                26.327028
              ],
              [
                62.061112,
                26.326825
              ],
              [
                62.06138,
                26.326755
              ],
              [
                62.06153,
                26.326659
              ],
              [
                62.061617,
                26.326669
              ],
              [
                62.061672,
                26.32658
              ],
              [
                62.062058,
                26.326653
              ],
              [
                62.062197,
                26.326548
              ],
              [
                62.06221,
                26.326635
              ],
              [
                62.062435,
                26.326674
              ],
              [
                62.062614,
                26.326488
              ],
              [
                62.06264,
                26.326532
              ],
              [
                62.062971,
                26.326506
              ],
              [
                62.062968,
                26.326428
              ],
              [
                62.063023,
                26.326401
              ],
              [
                62.063084,
                26.326482
              ],
              [
                62.063175,
                26.326483
              ],
              [
                62.063167,
                26.326531
              ],
              [
                62.063217,
                26.326558
              ],
              [
                62.063304,
                26.326538
              ],
              [
                62.063303,
                26.326574
              ],
              [
                62.063501,
                26.32662
              ],
              [
                62.063635,
                26.326583
              ],
              [
                62.06366,
                26.326653
              ],
              [
                62.063758,
                26.326652
              ],
              [
                62.063846,
                26.326748
              ],
              [
                62.063985,
                26.326774
              ],
              [
                62.06404,
                26.326919
              ],
              [
                62.06413,
                26.326988
              ],
              [
                62.064152,
                26.327124
              ],
              [
                62.064402,
                26.327062
              ],
              [
                62.06477,
                26.327117
              ],
              [
                62.064874,
                26.327221
              ],
              [
                62.065038,
                26.327249
              ],
              [
                62.065206,
                26.32719
              ],
              [
                62.065314,
                26.32731
              ],
              [
                62.065423,
                26.327328
              ],
              [
                62.065572,
                26.327272
              ],
              [
                62.065615,
                26.327318
              ],
              [
                62.065749,
                26.327271
              ],
              [
                62.065896,
                26.327282
              ],
              [
                62.065901,
                26.327242
              ],
              [
                62.066081,
                26.327194
              ],
              [
                62.066055,
                26.326955
              ],
              [
                62.066207,
                26.326859
              ],
              [
                62.06629,
                26.326726
              ],
              [
                62.066993,
                26.326899
              ],
              [
                62.067131,
                26.326851
              ],
              [
                62.067335,
                26.326637
              ],
              [
                62.067358,
                26.326466
              ],
              [
                62.067432,
                26.32641
              ],
              [
                62.067621,
                26.326501
              ],
              [
                62.067739,
                26.326465
              ],
              [
                62.068345,
                26.326482
              ],
              [
                62.068405,
                26.326622
              ],
              [
                62.068703,
                26.326613
              ],
              [
                62.068789,
                26.326694
              ],
              [
                62.068891,
                26.326696
              ],
              [
                62.068916,
                26.326632
              ],
              [
                62.069087,
                26.326557
              ],
              [
                62.069364,
                26.326547
              ],
              [
                62.069793,
                26.326816
              ],
              [
                62.070059,
                26.32678
              ],
              [
                62.070363,
                26.326855
              ],
              [
                62.070693,
                26.3268
              ],
              [
                62.070791,
                26.326824
              ],
              [
                62.071117,
                26.326737
              ],
              [
                62.071148,
                26.326672
              ],
              [
                62.070957,
                26.32645
              ],
              [
                62.071039,
                26.32627
              ],
              [
                62.071078,
                26.325993
              ],
              [
                62.071205,
                26.325981
              ],
              [
                62.071142,
                26.325911
              ],
              [
                62.071106,
                26.325736
              ],
              [
                62.071208,
                26.325705
              ],
              [
                62.071431,
                26.325505
              ],
              [
                62.071619,
                26.325451
              ],
              [
                62.071891,
                26.32546
              ],
              [
                62.07193,
                26.325419
              ],
              [
                62.072373,
                26.325359
              ],
              [
                62.072529,
                26.325415
              ],
              [
                62.072557,
                26.325469
              ],
              [
                62.072746,
                26.325476
              ],
              [
                62.072817,
                26.32541
              ],
              [
                62.073019,
                26.325348
              ],
              [
                62.073236,
                26.325308
              ],
              [
                62.073366,
                26.325341
              ],
              [
                62.073675,
                26.325196
              ],
              [
                62.073846,
                26.325026
              ],
              [
                62.073917,
                26.324831
              ],
              [
                62.074044,
                26.324799
              ],
              [
                62.074261,
                26.324659
              ],
              [
                62.07421,
                26.324517
              ],
              [
                62.074146,
                26.324471
              ],
              [
                62.074151,
                26.324159
              ],
              [
                62.074007,
                26.324112
              ],
              [
                62.073973,
                26.323855
              ],
              [
                62.073855,
                26.323722
              ],
              [
                62.073936,
                26.323645
              ],
              [
                62.074075,
                26.323652
              ],
              [
                62.074215,
                26.323558
              ],
              [
                62.074314,
                26.323561
              ],
              [
                62.074317,
                26.323601
              ],
              [
                62.074666,
                26.323513
              ],
              [
                62.074837,
                26.32334
              ],
              [
                62.074912,
                26.32316
              ],
              [
                62.075071,
                26.323058
              ],
              [
                62.075021,
                26.322978
              ],
              [
                62.075093,
                26.322939
              ],
              [
                62.075161,
                26.32278
              ],
              [
                62.075339,
                26.322665
              ],
              [
                62.075461,
                26.3227
              ],
              [
                62.07553,
                26.322664
              ],
              [
                62.07549,
                26.322433
              ],
              [
                62.075556,
                26.322422
              ],
              [
                62.075537,
                26.322196
              ],
              [
                62.07563,
                26.322131
              ],
              [
                62.07584,
                26.321711
              ],
              [
                62.076012,
                26.321737
              ],
              [
                62.076168,
                26.321684
              ],
              [
                62.076474,
                26.321368
              ],
              [
                62.076945,
                26.321205
              ],
              [
                62.076938,
                26.321162
              ],
              [
                62.077246,
                26.320879
              ],
              [
                62.077522,
                26.320764
              ],
              [
                62.077586,
                26.320675
              ],
              [
                62.077965,
                26.320739
              ],
              [
                62.078332,
                26.320646
              ],
              [
                62.078453,
                26.320516
              ],
              [
                62.078545,
                26.320501
              ],
              [
                62.078437,
                26.320431
              ],
              [
                62.078476,
                26.320417
              ],
              [
                62.078491,
                26.32025
              ],
              [
                62.078542,
                26.320239
              ],
              [
                62.078643,
                26.320059
              ],
              [
                62.078629,
                26.320006
              ],
              [
                62.078841,
                26.319845
              ],
              [
                62.079098,
                26.319895
              ],
              [
                62.079123,
                26.319817
              ],
              [
                62.079201,
                26.319832
              ],
              [
                62.0792,
                26.319761
              ],
              [
                62.079304,
                26.319801
              ],
              [
                62.079437,
                26.31977
              ],
              [
                62.079479,
                26.31981
              ],
              [
                62.079643,
                26.319771
              ],
              [
                62.079793,
                26.31964
              ],
              [
                62.079888,
                26.319638
              ],
              [
                62.080227,
                26.319488
              ],
              [
                62.080267,
                26.319386
              ],
              [
                62.080585,
                26.319175
              ],
              [
                62.080646,
                26.319017
              ],
              [
                62.080935,
                26.319004
              ],
              [
                62.080974,
                26.31891
              ],
              [
                62.081433,
                26.318692
              ],
              [
                62.081756,
                26.318829
              ],
              [
                62.081791,
                26.318935
              ],
              [
                62.082168,
                26.319033
              ],
              [
                62.082371,
                26.318994
              ],
              [
                62.08247,
                26.319054
              ],
              [
                62.08264,
                26.318974
              ],
              [
                62.082668,
                26.319034
              ],
              [
                62.082809,
                26.319068
              ],
              [
                62.083209,
                26.318922
              ],
              [
                62.083273,
                26.318944
              ],
              [
                62.083369,
                26.318877
              ],
              [
                62.083471,
                26.318922
              ],
              [
                62.083564,
                26.31883
              ],
              [
                62.083827,
                26.318713
              ],
              [
                62.083807,
                26.318591
              ],
              [
                62.083853,
                26.318572
              ],
              [
                62.083854,
                26.318465
              ],
              [
                62.084098,
                26.318285
              ],
              [
                62.084066,
                26.31822
              ],
              [
                62.084228,
                26.318184
              ],
              [
                62.084471,
                26.318335
              ],
              [
                62.084919,
                26.318855
              ],
              [
                62.085181,
                26.318861
              ],
              [
                62.085378,
                26.318569
              ],
              [
                62.085281,
                26.318508
              ],
              [
                62.085308,
                26.318162
              ],
              [
                62.085224,
                26.317991
              ],
              [
                62.085419,
                26.317835
              ],
              [
                62.085397,
                26.317744
              ],
              [
                62.085476,
                26.317684
              ],
              [
                62.085473,
                26.317627
              ],
              [
                62.085596,
                26.317577
              ],
              [
                62.085628,
                26.317601
              ],
              [
                62.085608,
                26.317506
              ],
              [
                62.085723,
                26.317408
              ],
              [
                62.085823,
                26.317124
              ],
              [
                62.085795,
                26.316842
              ],
              [
                62.08575,
                26.316855
              ],
              [
                62.085664,
                26.316784
              ],
              [
                62.085653,
                26.316707
              ],
              [
                62.085752,
                26.316671
              ],
              [
                62.085972,
                26.316752
              ],
              [
                62.086414,
                26.316539
              ],
              [
                62.086569,
                26.316486
              ],
              [
                62.086693,
                26.316495
              ],
              [
                62.086657,
                26.316373
              ],
              [
                62.086788,
                26.316231
              ],
              [
                62.086944,
                26.316074
              ],
              [
                62.087361,
                26.315925
              ],
              [
                62.087495,
                26.315747
              ],
              [
                62.087492,
                26.315633
              ],
              [
                62.087645,
                26.315585
              ],
              [
                62.08777,
                26.315627
              ],
              [
                62.088324,
                26.315649
              ],
              [
                62.088585,
                26.315753
              ],
              [
                62.088915,
                26.315281
              ],
              [
                62.088819,
                26.314933
              ],
              [
                62.089214,
                26.314805
              ],
              [
                62.089427,
                26.31487
              ],
              [
                62.089989,
                26.314705
              ],
              [
                62.090263,
                26.314572
              ],
              [
                62.090349,
                26.314473
              ],
              [
                62.09029,
                26.314033
              ],
              [
                62.09036,
                26.313928
              ],
              [
                62.090387,
                26.313746
              ],
              [
                62.090556,
                26.313647
              ],
              [
                62.090596,
                26.313542
              ],
              [
                62.090924,
                26.313422
              ],
              [
                62.090976,
                26.313347
              ],
              [
                62.091121,
                26.313315
              ],
              [
                62.091234,
                26.313026
              ],
              [
                62.091407,
                26.31285
              ],
              [
                62.091394,
                26.312426
              ],
              [
                62.091337,
                26.312397
              ],
              [
                62.0913,
                26.312267
              ],
              [
                62.091511,
                26.312237
              ],
              [
                62.091701,
                26.312293
              ],
              [
                62.091925,
                26.312283
              ],
              [
                62.092088,
                26.312154
              ],
              [
                62.092143,
                26.31194
              ],
              [
                62.092284,
                26.311753
              ],
              [
                62.092372,
                26.311719
              ],
              [
                62.092373,
                26.311626
              ],
              [
                62.092498,
                26.311491
              ],
              [
                62.092567,
                26.311479
              ],
              [
                62.092573,
                26.31141
              ],
              [
                62.09264,
                26.311361
              ],
              [
                62.092717,
                26.31111
              ],
              [
                62.093059,
                26.31093
              ],
              [
                62.093142,
                26.310736
              ],
              [
                62.093442,
                26.310484
              ],
              [
                62.093476,
                26.310254
              ],
              [
                62.093564,
                26.310166
              ],
              [
                62.093561,
                26.309959
              ],
              [
                62.093631,
                26.309871
              ],
              [
                62.093603,
                26.309794
              ],
              [
                62.093688,
                26.309708
              ],
              [
                62.093703,
                26.309597
              ],
              [
                62.094176,
                26.3091
              ],
              [
                62.094343,
                26.309075
              ],
              [
                62.094344,
                26.308539
              ],
              [
                62.094606,
                26.308455
              ],
              [
                62.095005,
                26.308129
              ],
              [
                62.095064,
                26.30772
              ],
              [
                62.095308,
                26.307655
              ],
              [
                62.095511,
                26.307646
              ],
              [
                62.095586,
                26.30769
              ],
              [
                62.096052,
                26.307632
              ],
              [
                62.096405,
                26.307488
              ],
              [
                62.096516,
                26.307352
              ],
              [
                62.096539,
                26.307182
              ],
              [
                62.096652,
                26.307196
              ],
              [
                62.096687,
                26.307152
              ],
              [
                62.096982,
                26.307116
              ],
              [
                62.097778,
                26.30674
              ],
              [
                62.09766,
                26.306675
              ],
              [
                62.097596,
                26.306151
              ],
              [
                62.097547,
                26.306047
              ],
              [
                62.097488,
                26.306052
              ],
              [
                62.097428,
                26.30598
              ],
              [
                62.097459,
                26.305931
              ],
              [
                62.097406,
                26.305781
              ],
              [
                62.097185,
                26.305706
              ],
              [
                62.096912,
                26.305386
              ],
              [
                62.09692,
                26.30533
              ],
              [
                62.097043,
                26.305266
              ],
              [
                62.096988,
                26.305245
              ],
              [
                62.096991,
                26.305007
              ],
              [
                62.09707,
                26.304794
              ],
              [
                62.097192,
                26.304627
              ],
              [
                62.097347,
                26.304644
              ],
              [
                62.097292,
                26.304553
              ],
              [
                62.097304,
                26.304389
              ],
              [
                62.097332,
                26.304325
              ],
              [
                62.097398,
                26.304314
              ],
              [
                62.09732,
                26.304198
              ],
              [
                62.097272,
                26.304196
              ],
              [
                62.097272,
                26.304127
              ],
              [
                62.097414,
                26.304013
              ],
              [
                62.097793,
                26.303898
              ],
              [
                62.097933,
                26.30376
              ],
              [
                62.097894,
                26.303701
              ],
              [
                62.097949,
                26.303531
              ],
              [
                62.097888,
                26.303232
              ],
              [
                62.097803,
                26.303192
              ],
              [
                62.097742,
                26.302716
              ],
              [
                62.097591,
                26.302512
              ],
              [
                62.097397,
                26.302604
              ],
              [
                62.097296,
                26.30255
              ],
              [
                62.097236,
                26.302244
              ],
              [
                62.097169,
                26.302151
              ],
              [
                62.096951,
                26.302106
              ],
              [
                62.096972,
                26.302036
              ],
              [
                62.096637,
                26.30183
              ],
              [
                62.096583,
                26.301719
              ],
              [
                62.096483,
                26.30167
              ],
              [
                62.096458,
                26.301554
              ],
              [
                62.096387,
                26.301555
              ],
              [
                62.096376,
                26.301421
              ],
              [
                62.09622,
                26.301431
              ],
              [
                62.096175,
                26.301334
              ],
              [
                62.09582,
                26.301322
              ],
              [
                62.095854,
                26.30112
              ],
              [
                62.09576,
                26.30107
              ],
              [
                62.095671,
                26.300905
              ],
              [
                62.095578,
                26.300833
              ],
              [
                62.095577,
                26.300577
              ],
              [
                62.095524,
                26.300552
              ],
              [
                62.095569,
                26.30043
              ],
              [
                62.095531,
                26.300087
              ],
              [
                62.09566,
                26.300131
              ],
              [
                62.096086,
                26.299984
              ],
              [
                62.096211,
                26.299903
              ],
              [
                62.096253,
                26.29971
              ],
              [
                62.096387,
                26.299671
              ],
              [
                62.096415,
                26.299607
              ],
              [
                62.096565,
                26.299582
              ],
              [
                62.096479,
                26.299487
              ],
              [
                62.096562,
                26.29932
              ],
              [
                62.096549,
                26.299235
              ],
              [
                62.096688,
                26.299075
              ],
              [
                62.096925,
                26.298932
              ],
              [
                62.096874,
                26.298891
              ],
              [
                62.096901,
                26.298821
              ],
              [
                62.096728,
                26.298708
              ],
              [
                62.096736,
                26.298635
              ],
              [
                62.096638,
                26.298483
              ],
              [
                62.096282,
                26.29846
              ],
              [
                62.095957,
                26.298356
              ],
              [
                62.095971,
                26.298146
              ],
              [
                62.095858,
                26.298061
              ],
              [
                62.095668,
                26.298006
              ],
              [
                62.095645,
                26.29796
              ],
              [
                62.095469,
                26.297968
              ],
              [
                62.09528,
                26.297835
              ],
              [
                62.095267,
                26.297772
              ],
              [
                62.095047,
                26.297691
              ],
              [
                62.095226,
                26.29764
              ],
              [
                62.095244,
                26.297375
              ],
              [
                62.095381,
                26.297431
              ],
              [
                62.09549,
                26.297396
              ],
              [
                62.095534,
                26.297326
              ],
              [
                62.095743,
                26.297278
              ],
              [
                62.095863,
                26.297102
              ],
              [
                62.095806,
                26.296972
              ],
              [
                62.095839,
                26.296836
              ],
              [
                62.095951,
                26.296719
              ],
              [
                62.095897,
                26.296703
              ],
              [
                62.095848,
                26.296602
              ],
              [
                62.095889,
                26.296543
              ],
              [
                62.095726,
                26.296311
              ],
              [
                62.09599,
                26.296043
              ],
              [
                62.09613,
                26.296031
              ],
              [
                62.096146,
                26.295899
              ],
              [
                62.096337,
                26.295753
              ],
              [
                62.096527,
                26.29568
              ],
              [
                62.096585,
                26.295591
              ],
              [
                62.096801,
                26.295626
              ],
              [
                62.096874,
                26.295581
              ],
              [
                62.097101,
                26.295557
              ],
              [
                62.097534,
                26.295375
              ],
              [
                62.097663,
                26.295196
              ],
              [
                62.098025,
                26.295141
              ],
              [
                62.098278,
                26.294946
              ],
              [
                62.098302,
                26.294821
              ],
              [
                62.09826,
                26.294752
              ],
              [
                62.097971,
                26.294557
              ],
              [
                62.098004,
                26.294486
              ],
              [
                62.097954,
                26.294295
              ],
              [
                62.097735,
                26.294064
              ],
              [
                62.097815,
                26.293868
              ],
              [
                62.097591,
                26.293711
              ],
              [
                62.097503,
                26.293715
              ],
              [
                62.097285,
                26.293601
              ],
              [
                62.097186,
                26.293096
              ],
              [
                62.097233,
                26.292971
              ],
              [
                62.097344,
                26.292865
              ],
              [
                62.097422,
                26.292647
              ],
              [
                62.097267,
                26.292548
              ],
              [
                62.097297,
                26.292439
              ],
              [
                62.097081,
                26.292164
              ],
              [
                62.097044,
                26.291965
              ],
              [
                62.096849,
                26.291929
              ],
              [
                62.096816,
                26.29179
              ],
              [
                62.0964,
                26.291499
              ],
              [
                62.096455,
                26.291353
              ],
              [
                62.096716,
                26.291253
              ],
              [
                62.096976,
                26.290999
              ],
              [
                62.097139,
                26.290895
              ],
              [
                62.097484,
                26.290828
              ],
              [
                62.097625,
                26.290743
              ],
              [
                62.097672,
                26.29076
              ],
              [
                62.097725,
                26.290685
              ],
              [
                62.097859,
                26.290638
              ],
              [
                62.097925,
                26.290513
              ],
              [
                62.097943,
                26.290425
              ],
              [
                62.097766,
                26.29028
              ],
              [
                62.097722,
                26.290143
              ],
              [
                62.097523,
                26.289881
              ],
              [
                62.097689,
                26.289741
              ],
              [
                62.097753,
                26.289621
              ],
              [
                62.097669,
                26.289575
              ],
              [
                62.097633,
                26.289467
              ],
              [
                62.09739,
                26.289218
              ],
              [
                62.097371,
                26.288948
              ],
              [
                62.097278,
                26.288913
              ],
              [
                62.097228,
                26.288815
              ],
              [
                62.097252,
                26.288506
              ],
              [
                62.097175,
                26.288413
              ],
              [
                62.097308,
                26.288269
              ],
              [
                62.09731,
                26.28821
              ],
              [
                62.097657,
                26.287984
              ],
              [
                62.097703,
                26.287885
              ],
              [
                62.097668,
                26.287664
              ],
              [
                62.097755,
                26.287573
              ],
              [
                62.097821,
                26.287393
              ],
              [
                62.097899,
                26.287342
              ],
              [
                62.098019,
                26.287059
              ],
              [
                62.098341,
                26.286815
              ],
              [
                62.098196,
                26.286675
              ],
              [
                62.097972,
                26.286573
              ],
              [
                62.097897,
                26.286314
              ],
              [
                62.098018,
                26.2862
              ],
              [
                62.09834,
                26.286057
              ],
              [
                62.098364,
                26.285867
              ],
              [
                62.098288,
                26.285776
              ],
              [
                62.098548,
                26.285745
              ],
              [
                62.098773,
                26.285653
              ],
              [
                62.099264,
                26.285552
              ],
              [
                62.099439,
                26.285474
              ],
              [
                62.099538,
                26.285337
              ],
              [
                62.099627,
                26.285347
              ],
              [
                62.099778,
                26.28528
              ],
              [
                62.099749,
                26.28524
              ],
              [
                62.099847,
                26.284969
              ],
              [
                62.099844,
                26.284743
              ],
              [
                62.099982,
                26.284608
              ],
              [
                62.099978,
                26.284446
              ],
              [
                62.09992,
                26.284327
              ],
              [
                62.100255,
                26.284266
              ],
              [
                62.100374,
                26.284134
              ],
              [
                62.100541,
                26.284077
              ],
              [
                62.100762,
                26.283803
              ],
              [
                62.100835,
                26.283813
              ],
              [
                62.100907,
                26.283765
              ],
              [
                62.101038,
                26.283837
              ],
              [
                62.101187,
                26.283821
              ],
              [
                62.101284,
                26.283895
              ],
              [
                62.101459,
                26.283797
              ],
              [
                62.101534,
                26.283555
              ],
              [
                62.101697,
                26.283483
              ],
              [
                62.101893,
                26.283472
              ],
              [
                62.102006,
                26.283292
              ],
              [
                62.102265,
                26.283226
              ],
              [
                62.102423,
                26.283268
              ],
              [
                62.102542,
                26.283399
              ],
              [
                62.102775,
                26.283381
              ],
              [
                62.103013,
                26.283266
              ],
              [
                62.103184,
                26.283234
              ],
              [
                62.10363,
                26.283285
              ],
              [
                62.103744,
                26.283133
              ],
              [
                62.103894,
                26.283063
              ],
              [
                62.104053,
                26.282846
              ],
              [
                62.104197,
                26.282736
              ],
              [
                62.104223,
                26.282622
              ],
              [
                62.104365,
                26.282434
              ],
              [
                62.10436,
                26.28236
              ],
              [
                62.104491,
                26.282237
              ],
              [
                62.104762,
                26.282252
              ],
              [
                62.105003,
                26.282092
              ],
              [
                62.105091,
                26.282077
              ],
              [
                62.105299,
                26.282109
              ],
              [
                62.105593,
                26.281926
              ],
              [
                62.105901,
                26.281894
              ],
              [
                62.106035,
                26.281959
              ],
              [
                62.106198,
                26.281914
              ],
              [
                62.10623,
                26.282002
              ],
              [
                62.106491,
                26.282093
              ],
              [
                62.106585,
                26.282187
              ],
              [
                62.106903,
                26.282324
              ],
              [
                62.107016,
                26.282288
              ],
              [
                62.107007,
                26.282216
              ],
              [
                62.107087,
                26.282164
              ],
              [
                62.107272,
                26.282161
              ],
              [
                62.107373,
                26.28227
              ],
              [
                62.10783,
                26.282203
              ],
              [
                62.108411,
                26.282031
              ],
              [
                62.108683,
                26.282142
              ],
              [
                62.108695,
                26.282211
              ],
              [
                62.108941,
                26.282456
              ],
              [
                62.109531,
                26.282591
              ],
              [
                62.109708,
                26.282818
              ],
              [
                62.110039,
                26.282686
              ],
              [
                62.110134,
                26.282768
              ],
              [
                62.110386,
                26.282718
              ],
              [
                62.110528,
                26.282781
              ],
              [
                62.110641,
                26.28277
              ],
              [
                62.11075,
                26.282637
              ],
              [
                62.11094,
                26.282608
              ],
              [
                62.111328,
                26.282369
              ],
              [
                62.111418,
                26.282295
              ],
              [
                62.111472,
                26.282145
              ],
              [
                62.111627,
                26.282028
              ],
              [
                62.111859,
                26.281929
              ],
              [
                62.111869,
                26.281881
              ],
              [
                62.112015,
                26.281865
              ],
              [
                62.112114,
                26.281806
              ],
              [
                62.112275,
                26.281524
              ],
              [
                62.112504,
                26.281528
              ],
              [
                62.112834,
                26.281323
              ],
              [
                62.113326,
                26.280881
              ],
              [
                62.113352,
                26.280807
              ],
              [
                62.11341,
                26.28084
              ],
              [
                62.11371,
                26.280715
              ],
              [
                62.113827,
                26.280712
              ],
              [
                62.113858,
                26.280525
              ],
              [
                62.113628,
                26.280194
              ],
              [
                62.11362,
                26.280005
              ],
              [
                62.113933,
                26.279863
              ],
              [
                62.114031,
                26.279758
              ],
              [
                62.114144,
                26.279796
              ],
              [
                62.114148,
                26.279756
              ],
              [
                62.114405,
                26.279658
              ],
              [
                62.114542,
                26.27948
              ],
              [
                62.114734,
                26.279363
              ],
              [
                62.114713,
                26.27932
              ],
              [
                62.114875,
                26.279334
              ],
              [
                62.11496,
                26.279134
              ],
              [
                62.115106,
                26.278978
              ],
              [
                62.115303,
                26.278995
              ],
              [
                62.115623,
                26.278901
              ],
              [
                62.115614,
                26.278838
              ],
              [
                62.115714,
                26.278686
              ],
              [
                62.116013,
                26.278703
              ],
              [
                62.116065,
                26.278652
              ],
              [
                62.116421,
                26.278622
              ],
              [
                62.116478,
                26.278526
              ],
              [
                62.116622,
                26.278449
              ],
              [
                62.116635,
                26.278269
              ],
              [
                62.116706,
                26.278219
              ],
              [
                62.116814,
                26.278215
              ],
              [
                62.116963,
                26.278384
              ],
              [
                62.117075,
                26.278385
              ],
              [
                62.117198,
                26.278507
              ],
              [
                62.117297,
                26.278499
              ],
              [
                62.117424,
                26.278566
              ],
              [
                62.117689,
                26.278484
              ],
              [
                62.117859,
                26.278529
              ],
              [
                62.117942,
                26.278492
              ],
              [
                62.118107,
                26.278518
              ],
              [
                62.118205,
                26.278464
              ],
              [
                62.118352,
                26.278216
              ],
              [
                62.118449,
                26.278162
              ],
              [
                62.118627,
                26.277939
              ],
              [
                62.118749,
                26.277971
              ],
              [
                62.118791,
                26.277924
              ],
              [
                62.118872,
                26.277927
              ],
              [
                62.119178,
                26.27761
              ],
              [
                62.119356,
                26.277289
              ],
              [
                62.119722,
                26.277022
              ],
              [
                62.119911,
                26.277021
              ],
              [
                62.120168,
                26.276773
              ],
              [
                62.120768,
                26.276924
              ],
              [
                62.121057,
                26.27718
              ],
              [
                62.121288,
                26.277136
              ],
              [
                62.121301,
                26.277183
              ],
              [
                62.12192,
                26.277429
              ],
              [
                62.121969,
                26.277291
              ],
              [
                62.122168,
                26.27719
              ],
              [
                62.122288,
                26.277043
              ],
              [
                62.122571,
                26.27704
              ],
              [
                62.122977,
                26.276903
              ],
              [
                62.12373,
                26.276805
              ],
              [
                62.124112,
                26.276375
              ],
              [
                62.124214,
                26.276314
              ],
              [
                62.124236,
                26.276087
              ],
              [
                62.124302,
                26.275951
              ],
              [
                62.124463,
                26.275812
              ],
              [
                62.124404,
                26.275761
              ],
              [
                62.124592,
                26.27546
              ],
              [
                62.12455,
                26.275333
              ],
              [
                62.124758,
                26.275235
              ],
              [
                62.124862,
                26.275106
              ],
              [
                62.125019,
                26.27505
              ],
              [
                62.124999,
                26.275012
              ],
              [
                62.125076,
                26.274942
              ],
              [
                62.125088,
                26.274847
              ],
              [
                62.125195,
                26.274764
              ],
              [
                62.125158,
                26.274172
              ],
              [
                62.125388,
                26.273986
              ],
              [
                62.125928,
                26.273994
              ],
              [
                62.126293,
                26.273879
              ],
              [
                62.12648,
                26.273711
              ],
              [
                62.126691,
                26.273739
              ],
              [
                62.126895,
                26.273664
              ],
              [
                62.127231,
                26.273791
              ],
              [
                62.127421,
                26.273775
              ],
              [
                62.127744,
                26.27359
              ],
              [
                62.127857,
                26.273451
              ],
              [
                62.128209,
                26.273445
              ],
              [
                62.128431,
                26.273511
              ],
              [
                62.128872,
                26.273391
              ],
              [
                62.129226,
                26.273556
              ],
              [
                62.129487,
                26.273622
              ],
              [
                62.12964,
                26.273725
              ],
              [
                62.130465,
                26.273857
              ],
              [
                62.130788,
                26.273798
              ],
              [
                62.131181,
                26.274082
              ],
              [
                62.131906,
                26.273663
              ],
              [
                62.132006,
                26.273532
              ],
              [
                62.132417,
                26.273455
              ],
              [
                62.132631,
                26.273466
              ],
              [
                62.132734,
                26.273377
              ],
              [
                62.132725,
                26.273308
              ],
              [
                62.132905,
                26.273081
              ],
              [
                62.13307,
                26.273073
              ],
              [
                62.133319,
                26.27299
              ],
              [
                62.133828,
                26.273047
              ],
              [
                62.134118,
                26.27289
              ],
              [
                62.134412,
                26.272843
              ],
              [
                62.134401,
                26.272627
              ],
              [
                62.134608,
                26.272401
              ],
              [
                62.134532,
                26.272255
              ],
              [
                62.134554,
                26.272162
              ],
              [
                62.134699,
                26.272034
              ],
              [
                62.13489,
                26.272013
              ],
              [
                62.135135,
                26.271696
              ],
              [
                62.13522,
                26.271693
              ],
              [
                62.135418,
                26.271796
              ],
              [
                62.135428,
                26.271841
              ],
              [
                62.135844,
                26.27208
              ],
              [
                62.135842,
                26.27214
              ],
              [
                62.135974,
                26.272157
              ],
              [
                62.136179,
                26.272101
              ],
              [
                62.136217,
                26.271988
              ],
              [
                62.136493,
                26.271874
              ],
              [
                62.136695,
                26.271957
              ],
              [
                62.136846,
                26.271957
              ],
              [
                62.137041,
                26.272186
              ],
              [
                62.137427,
                26.272226
              ],
              [
                62.13783,
                26.272109
              ],
              [
                62.137958,
                26.271968
              ],
              [
                62.138017,
                26.271969
              ],
              [
                62.13812,
                26.272061
              ],
              [
                62.138389,
                26.272095
              ],
              [
                62.138937,
                26.272003
              ],
              [
                62.139224,
                26.272051
              ],
              [
                62.139372,
                26.271691
              ],
              [
                62.139379,
                26.271722
              ],
              [
                62.139486,
                26.27165
              ],
              [
                62.139494,
                26.271591
              ],
              [
                62.139696,
                26.271536
              ],
              [
                62.139736,
                26.271403
              ],
              [
                62.139918,
                26.271362
              ],
              [
                62.139952,
                26.271122
              ],
              [
                62.140182,
                26.271157
              ],
              [
                62.140281,
                26.271091
              ],
              [
                62.140385,
                26.27109
              ],
              [
                62.140393,
                26.271141
              ],
              [
                62.140702,
                26.271081
              ],
              [
                62.140825,
                26.271102
              ],
              [
                62.140982,
                26.271059
              ],
              [
                62.141212,
                26.2709
              ],
              [
                62.141679,
                26.270913
              ],
              [
                62.14183,
                26.271035
              ],
              [
                62.142038,
                26.271077
              ],
              [
                62.142169,
                26.271158
              ],
              [
                62.142385,
                26.271046
              ],
              [
                62.143019,
                26.270951
              ],
              [
                62.143203,
                26.270825
              ],
              [
                62.143548,
                26.270797
              ],
              [
                62.14398,
                26.270842
              ],
              [
                62.14419,
                26.270674
              ],
              [
                62.144438,
                26.270597
              ],
              [
                62.144499,
                26.270256
              ],
              [
                62.144625,
                26.270039
              ],
              [
                62.144624,
                26.269938
              ],
              [
                62.144463,
                26.269825
              ],
              [
                62.144334,
                26.269653
              ],
              [
                62.144392,
                26.269619
              ],
              [
                62.144396,
                26.269528
              ],
              [
                62.144567,
                26.26948
              ],
              [
                62.144801,
                26.269223
              ],
              [
                62.144866,
                26.269212
              ],
              [
                62.144928,
                26.269098
              ],
              [
                62.145031,
                26.269105
              ],
              [
                62.145243,
                26.268969
              ],
              [
                62.14542,
                26.268964
              ],
              [
                62.145579,
                26.269082
              ],
              [
                62.145718,
                26.269064
              ],
              [
                62.14578,
                26.269106
              ],
              [
                62.146033,
                26.269053
              ],
              [
                62.14614,
                26.269106
              ],
              [
                62.146419,
                26.269037
              ],
              [
                62.146587,
                26.269083
              ],
              [
                62.146591,
                26.269173
              ],
              [
                62.146699,
                26.269245
              ],
              [
                62.146997,
                26.269192
              ],
              [
                62.147471,
                26.269353
              ],
              [
                62.147904,
                26.269084
              ],
              [
                62.148226,
                26.26899
              ],
              [
                62.148319,
                26.268996
              ],
              [
                62.148423,
                26.269121
              ],
              [
                62.148741,
                26.269174
              ],
              [
                62.148793,
                26.26928
              ],
              [
                62.1491,
                26.269393
              ],
              [
                62.14922,
                26.269386
              ],
              [
                62.14938,
                26.269272
              ],
              [
                62.149471,
                26.269336
              ],
              [
                62.149749,
                26.269276
              ],
              [
                62.149883,
                26.269317
              ],
              [
                62.150047,
                26.269221
              ],
              [
                62.150098,
                26.269281
              ],
              [
                62.150299,
                26.269217
              ],
              [
                62.150412,
                26.269133
              ],
              [
                62.150645,
                26.269307
              ],
              [
                62.150646,
                26.26938
              ],
              [
                62.150717,
                26.269462
              ],
              [
                62.150918,
                26.269567
              ],
              [
                62.150989,
                26.269662
              ],
              [
                62.151138,
                26.269708
              ],
              [
                62.1511,
                26.269793
              ],
              [
                62.15123,
                26.269818
              ],
              [
                62.151152,
                26.269913
              ],
              [
                62.151313,
                26.270036
              ],
              [
                62.151288,
                26.270144
              ],
              [
                62.151335,
                26.27032
              ],
              [
                62.15132,
                26.270502
              ],
              [
                62.151251,
                26.270566
              ],
              [
                62.151436,
                26.270641
              ],
              [
                62.151733,
                26.270597
              ],
              [
                62.15174,
                26.270642
              ],
              [
                62.151814,
                26.270655
              ],
              [
                62.152469,
                26.270704
              ],
              [
                62.152707,
                26.2708
              ],
              [
                62.152938,
                26.270767
              ],
              [
                62.153105,
                26.270797
              ],
              [
                62.153403,
                26.270594
              ],
              [
                62.153452,
                26.27046
              ],
              [
                62.153675,
                26.270224
              ],
              [
                62.153748,
                26.27025
              ],
              [
                62.154,
                26.270164
              ],
              [
                62.154072,
                26.270193
              ],
              [
                62.154374,
                26.269981
              ],
              [
                62.154593,
                26.27
              ],
              [
                62.154823,
                26.269939
              ],
              [
                62.155426,
                26.270046
              ],
              [
                62.155501,
                26.269788
              ],
              [
                62.155734,
                26.269765
              ],
              [
                62.155717,
                26.269686
              ],
              [
                62.155799,
                26.269665
              ],
              [
                62.155778,
                26.269499
              ],
              [
                62.156293,
                26.269336
              ],
              [
                62.156322,
                26.269179
              ],
              [
                62.156451,
                26.269113
              ],
              [
                62.156618,
                26.26873
              ],
              [
                62.156739,
                26.268713
              ],
              [
                62.156894,
                26.268548
              ],
              [
                62.157,
                26.268514
              ],
              [
                62.157054,
                26.268557
              ],
              [
                62.15715,
                26.268508
              ],
              [
                62.157327,
                26.268306
              ],
              [
                62.157747,
                26.268059
              ],
              [
                62.157844,
                26.268032
              ],
              [
                62.158002,
                26.268046
              ],
              [
                62.158007,
                26.268081
              ],
              [
                62.158077,
                26.26805
              ],
              [
                62.158522,
                26.26814
              ],
              [
                62.158904,
                26.268122
              ],
              [
                62.159034,
                26.268155
              ],
              [
                62.159027,
                26.268263
              ],
              [
                62.159235,
                26.268277
              ],
              [
                62.1593,
                26.268329
              ],
              [
                62.159433,
                26.268299
              ],
              [
                62.159628,
                26.268365
              ],
              [
                62.159854,
                26.268144
              ],
              [
                62.160053,
                26.268086
              ],
              [
                62.160286,
                26.267895
              ],
              [
                62.160397,
                26.267901
              ],
              [
                62.160697,
                26.267774
              ],
              [
                62.160737,
                26.267669
              ],
              [
                62.160894,
                26.267596
              ],
              [
                62.161047,
                26.267641
              ],
              [
                62.161161,
                26.267764
              ],
              [
                62.161212,
                26.267917
              ],
              [
                62.161397,
                26.268038
              ],
              [
                62.162113,
                26.267737
              ],
              [
                62.162456,
                26.267776
              ],
              [
                62.162621,
                26.267667
              ],
              [
                62.162742,
                26.267646
              ],
              [
                62.162849,
                26.267683
              ],
              [
                62.162888,
                26.267506
              ],
              [
                62.163006,
                26.267443
              ],
              [
                62.163197,
                26.267454
              ],
              [
                62.163423,
                26.267307
              ],
              [
                62.163527,
                26.267363
              ],
              [
                62.163657,
                26.267311
              ],
              [
                62.163969,
                26.267351
              ],
              [
                62.164129,
                26.267184
              ],
              [
                62.164312,
                26.267076
              ],
              [
                62.164828,
                26.267109
              ],
              [
                62.164871,
                26.266949
              ],
              [
                62.164968,
                26.266818
              ],
              [
                62.165252,
                26.266693
              ],
              [
                62.165672,
                26.26675
              ],
              [
                62.165958,
                26.266898
              ],
              [
                62.165983,
                26.266984
              ],
              [
                62.165919,
                26.267154
              ],
              [
                62.166012,
                26.267446
              ],
              [
                62.166334,
                26.267785
              ],
              [
                62.166555,
                26.267783
              ],
              [
                62.166674,
                26.26793
              ],
              [
                62.166894,
                26.267769
              ],
              [
                62.167265,
                26.267717
              ],
              [
                62.167471,
                26.267811
              ],
              [
                62.16755,
                26.267773
              ],
              [
                62.167617,
                26.267794
              ],
              [
                62.167621,
                26.267865
              ],
              [
                62.167741,
                26.267852
              ],
              [
                62.167837,
                26.268003
              ],
              [
                62.168077,
                26.268049
              ],
              [
                62.168258,
                26.267904
              ],
              [
                62.168714,
                26.267674
              ],
              [
                62.169066,
                26.267764
              ],
              [
                62.169192,
                26.267699
              ],
              [
                62.169426,
                26.267717
              ],
              [
                62.169523,
                26.267654
              ],
              [
                62.169912,
                26.267569
              ],
              [
                62.171167,
                26.267656
              ],
              [
                62.17167,
                26.267492
              ],
              [
                62.171744,
                26.267394
              ],
              [
                62.171907,
                26.267441
              ],
              [
                62.171985,
                26.267632
              ],
              [
                62.172327,
                26.267812
              ],
              [
                62.172381,
                26.267912
              ],
              [
                62.172591,
                26.267953
              ],
              [
                62.172735,
                26.268068
              ],
              [
                62.172865,
                26.268059
              ],
              [
                62.17324,
                26.268187
              ],
              [
                62.173425,
                26.26832
              ],
              [
                62.173638,
                26.268363
              ],
              [
                62.173668,
                26.268322
              ],
              [
                62.173795,
                26.268344
              ],
              [
                62.173905,
                26.268407
              ],
              [
                62.17407,
                26.268314
              ],
              [
                62.174448,
                26.267935
              ],
              [
                62.174655,
                26.267977
              ],
              [
                62.174844,
                26.267937
              ],
              [
                62.174959,
                26.267999
              ],
              [
                62.175267,
                26.267996
              ],
              [
                62.175296,
                26.267841
              ],
              [
                62.175444,
                26.267685
              ],
              [
                62.175397,
                26.267439
              ],
              [
                62.175473,
                26.267267
              ],
              [
                62.175436,
                26.267151
              ],
              [
                62.175464,
                26.267086
              ],
              [
                62.175513,
                26.267009
              ],
              [
                62.175882,
                26.266769
              ],
              [
                62.175907,
                26.266675
              ],
              [
                62.176001,
                26.266601
              ],
              [
                62.176004,
                26.266461
              ],
              [
                62.176166,
                26.266393
              ],
              [
                62.176325,
                26.266246
              ],
              [
                62.176338,
                26.26614
              ],
              [
                62.176573,
                26.266173
              ],
              [
                62.176662,
                26.266243
              ],
              [
                62.17726,
                26.266226
              ],
              [
                62.177548,
                26.265912
              ],
              [
                62.177647,
                26.265898
              ],
              [
                62.17774,
                26.26594
              ],
              [
                62.17784,
                26.265865
              ],
              [
                62.177887,
                26.265683
              ],
              [
                62.17808,
                26.265538
              ],
              [
                62.178306,
                26.265614
              ],
              [
                62.17833,
                26.265706
              ],
              [
                62.178456,
                26.26578
              ],
              [
                62.178502,
                26.265936
              ],
              [
                62.178617,
                26.265941
              ],
              [
                62.178772,
                26.266049
              ],
              [
                62.179004,
                26.266108
              ],
              [
                62.179113,
                26.266076
              ],
              [
                62.179331,
                26.265809
              ],
              [
                62.17949,
                26.26573
              ],
              [
                62.179583,
                26.265731
              ],
              [
                62.179694,
                26.2658
              ],
              [
                62.179998,
                26.265811
              ],
              [
                62.1801,
                26.265725
              ],
              [
                62.180302,
                26.265664
              ],
              [
                62.180511,
                26.265721
              ],
              [
                62.180631,
                26.265679
              ],
              [
                62.180923,
                26.265684
              ],
              [
                62.18119,
                26.265895
              ],
              [
                62.18124,
                26.265892
              ],
              [
                62.181395,
                26.265628
              ],
              [
                62.181542,
                26.265505
              ],
              [
                62.181977,
                26.265415
              ],
              [
                62.182121,
                26.265538
              ],
              [
                62.182363,
                26.266016
              ],
              [
                62.182384,
                26.266141
              ],
              [
                62.182648,
                26.266118
              ],
              [
                62.182713,
                26.266167
              ],
              [
                62.18274,
                26.266277
              ],
              [
                62.182857,
                26.266279
              ],
              [
                62.183027,
                26.2664
              ],
              [
                62.183407,
                26.26626
              ],
              [
                62.183701,
                26.266319
              ],
              [
                62.183994,
                26.266305
              ],
              [
                62.18425,
                26.266502
              ],
              [
                62.184592,
                26.266548
              ],
              [
                62.184972,
                26.266412
              ],
              [
                62.185398,
                26.26617
              ],
              [
                62.185939,
                26.266136
              ],
              [
                62.186035,
                26.266166
              ],
              [
                62.186312,
                26.266021
              ],
              [
                62.186433,
                26.266069
              ],
              [
                62.18706,
                26.265744
              ],
              [
                62.187305,
                26.265538
              ],
              [
                62.187662,
                26.265557
              ],
              [
                62.187722,
                26.265639
              ],
              [
                62.187894,
                26.265687
              ],
              [
                62.188197,
                26.26595
              ],
              [
                62.188516,
                26.265945
              ],
              [
                62.188558,
                26.266055
              ],
              [
                62.188625,
                26.266033
              ],
              [
                62.188647,
                26.266122
              ],
              [
                62.188839,
                26.266166
              ],
              [
                62.188955,
                26.26631
              ],
              [
                62.189109,
                26.26636
              ],
              [
                62.189287,
                26.266625
              ],
              [
                62.189667,
                26.266913
              ],
              [
                62.190167,
                26.267077
              ],
              [
                62.190207,
                26.267002
              ],
              [
                62.190312,
                26.267003
              ],
              [
                62.19051,
                26.267076
              ],
              [
                62.190541,
                26.267134
              ],
              [
                62.190951,
                26.266998
              ],
              [
                62.191033,
                26.267028
              ],
              [
                62.19118,
                26.26688
              ],
              [
                62.191256,
                26.266873
              ],
              [
                62.191413,
                26.26674
              ],
              [
                62.191718,
                26.26686
              ],
              [
                62.191981,
                26.266875
              ],
              [
                62.192135,
                26.266989
              ],
              [
                62.192386,
                26.267015
              ],
              [
                62.192635,
                26.267169
              ],
              [
                62.192895,
                26.267057
              ],
              [
                62.193114,
                26.266894
              ],
              [
                62.193342,
                26.266937
              ],
              [
                62.193567,
                26.267079
              ],
              [
                62.193743,
                26.267019
              ],
              [
                62.193889,
                26.267074
              ],
              [
                62.194181,
                26.266983
              ],
              [
                62.194421,
                26.266959
              ],
              [
                62.194915,
                26.267192
              ],
              [
                62.195068,
                26.267182
              ],
              [
                62.195194,
                26.267278
              ],
              [
                62.195561,
                26.26723
              ],
              [
                62.195759,
                26.267057
              ],
              [
                62.195864,
                26.267085
              ],
              [
                62.19607,
                26.267042
              ],
              [
                62.196175,
                26.26726
              ],
              [
                62.196321,
                26.267328
              ],
              [
                62.196384,
                26.267563
              ],
              [
                62.196625,
                26.267694
              ],
              [
                62.196851,
                26.268043
              ],
              [
                62.197322,
                26.268117
              ],
              [
                62.19769,
                26.268117
              ],
              [
                62.197746,
                26.268332
              ],
              [
                62.197572,
                26.268959
              ],
              [
                62.197734,
                26.269388
              ],
              [
                62.19803,
                26.269428
              ],
              [
                62.19829,
                26.269673
              ],
              [
                62.198545,
                26.269619
              ],
              [
                62.198664,
                26.269687
              ],
              [
                62.199351,
                26.26986
              ],
              [
                62.199418,
                26.269671
              ],
              [
                62.199544,
                26.269657
              ],
              [
                62.199778,
                26.269525
              ],
              [
                62.199955,
                26.269276
              ],
              [
                62.200121,
                26.269202
              ],
              [
                62.200285,
                26.269021
              ],
              [
                62.200493,
                26.269054
              ],
              [
                62.200626,
                26.269009
              ],
              [
                62.200736,
                26.269073
              ],
              [
                62.200845,
                26.269049
              ],
              [
                62.201043,
                26.269149
              ],
              [
                62.201162,
                26.26905
              ],
              [
                62.201685,
                26.268988
              ],
              [
                62.201953,
                26.268462
              ],
              [
                62.202038,
                26.268401
              ],
              [
                62.202199,
                26.268054
              ],
              [
                62.202298,
                26.267969
              ],
              [
                62.202453,
                26.267926
              ],
              [
                62.202649,
                26.268057
              ],
              [
                62.203167,
                26.268139
              ],
              [
                62.20367,
                26.268373
              ],
              [
                62.203968,
                26.268382
              ],
              [
                62.20419,
                26.268205
              ],
              [
                62.204743,
                26.26815
              ],
              [
                62.204823,
                26.26809
              ],
              [
                62.20513,
                26.268002
              ],
              [
                62.205233,
                26.267884
              ],
              [
                62.205527,
                26.267708
              ],
              [
                62.205937,
                26.267775
              ],
              [
                62.206028,
                26.267839
              ],
              [
                62.206122,
                26.267812
              ],
              [
                62.206254,
                26.267667
              ],
              [
                62.206452,
                26.267559
              ],
              [
                62.206988,
                26.267365
              ],
              [
                62.20716,
                26.267219
              ],
              [
                62.207177,
                26.267132
              ],
              [
                62.207691,
                26.267044
              ],
              [
                62.208229,
                26.267057
              ],
              [
                62.208274,
                26.267189
              ],
              [
                62.208459,
                26.267269
              ],
              [
                62.20844,
                26.267308
              ],
              [
                62.208899,
                26.267337
              ],
              [
                62.209062,
                26.267399
              ],
              [
                62.209453,
                26.267833
              ],
              [
                62.209598,
                26.268117
              ],
              [
                62.209785,
                26.26823
              ],
              [
                62.209944,
                26.268506
              ],
              [
                62.210079,
                26.268633
              ],
              [
                62.210335,
                26.268738
              ],
              [
                62.210471,
                26.268854
              ],
              [
                62.210601,
                26.268777
              ],
              [
                62.210762,
                26.268774
              ],
              [
                62.211072,
                26.268643
              ],
              [
                62.211142,
                26.268552
              ],
              [
                62.211527,
                26.268309
              ],
              [
                62.21193,
                26.26827
              ],
              [
                62.21197,
                26.268205
              ],
              [
                62.212166,
                26.268106
              ],
              [
                62.212608,
                26.268054
              ],
              [
                62.212765,
                26.267959
              ],
              [
                62.212905,
                26.267941
              ],
              [
                62.213019,
                26.267677
              ],
              [
                62.213228,
                26.267646
              ],
              [
                62.213361,
                26.267559
              ],
              [
                62.21367,
                26.267823
              ],
              [
                62.21401,
                26.267927
              ],
              [
                62.214611,
                26.268028
              ],
              [
                62.215011,
                26.267929
              ],
              [
                62.214965,
                26.268183
              ],
              [
                62.214942,
                26.269591
              ],
              [
                62.215219,
                26.271521
              ],
              [
                62.215618,
                26.273131
              ],
              [
                62.216204,
                26.274305
              ],
              [
                62.216653,
                26.274884
              ],
              [
                62.217353,
                26.275459
              ],
              [
                62.218226,
                26.276333
              ],
              [
                62.219418,
                26.277076
              ],
              [
                62.220532,
                26.277685
              ],
              [
                62.221435,
                26.278313
              ],
              [
                62.221962,
                26.278753
              ],
              [
                62.222302,
                26.27916
              ],
              [
                62.2228745,
                26.2801091
              ],
              [
                62.223746,
                26.281554
              ],
              [
                62.224223,
                26.28256
              ],
              [
                62.224455,
                26.283652
              ],
              [
                62.224466,
                26.284197
              ],
              [
                62.224225,
                26.285068
              ],
              [
                62.223853,
                26.285863
              ],
              [
                62.223258,
                26.286674
              ],
              [
                62.222567,
                26.287376
              ],
              [
                62.219682,
                26.289494
              ],
              [
                62.218674,
                26.290004
              ],
              [
                62.218009,
                26.290248
              ],
              [
                62.21785,
                26.290537
              ],
              [
                62.217612,
                26.291628
              ],
              [
                62.218254,
                26.292332
              ],
              [
                62.219312,
                26.293726
              ],
              [
                62.220861,
                26.295561
              ],
              [
                62.222111,
                26.296791
              ],
              [
                62.223234,
                26.297551
              ],
              [
                62.224524,
                26.29825
              ],
              [
                62.225883,
                26.299102
              ],
              [
                62.226998,
                26.299983
              ],
              [
                62.227659,
                26.301095
              ],
              [
                62.227978,
                26.30256
              ],
              [
                62.227887,
                26.303679
              ],
              [
                62.227466,
                26.306198
              ],
              [
                62.227714,
                26.307664
              ],
              [
                62.228394,
                26.308805
              ],
              [
                62.229063,
                26.309621
              ],
              [
                62.230354,
                26.310822
              ],
              [
                62.232714,
                26.312749
              ],
              [
                62.233776,
                26.314001
              ],
              [
                62.234399,
                26.316692
              ],
              [
                62.234434,
                26.318719
              ],
              [
                62.234262,
                26.31936
              ],
              [
                62.233539,
                26.32027
              ],
              [
                62.233105,
                26.320584
              ],
              [
                62.232078,
                26.321807
              ],
              [
                62.229531,
                26.324348
              ],
              [
                62.228087,
                26.326068
              ],
              [
                62.227549,
                26.327504
              ],
              [
                62.227744,
                26.328946
              ],
              [
                62.228244,
                26.329538
              ],
              [
                62.228826,
                26.330063
              ],
              [
                62.22978,
                26.330819
              ],
              [
                62.231424,
                26.331327
              ],
              [
                62.232594,
                26.331204
              ],
              [
                62.234424,
                26.330533
              ],
              [
                62.238604,
                26.327027
              ],
              [
                62.242289,
                26.322129
              ],
              [
                62.243442,
                26.321321
              ],
              [
                62.246298,
                26.320749
              ],
              [
                62.248494,
                26.320114
              ],
              [
                62.250085,
                26.319833
              ],
              [
                62.25211,
                26.319894
              ],
              [
                62.254221,
                26.320738
              ],
              [
                62.255773,
                26.322365
              ],
              [
                62.257638,
                26.322956
              ],
              [
                62.265627,
                26.324125
              ],
              [
                62.267582,
                26.324634
              ],
              [
                62.269246,
                26.325456
              ],
              [
                62.26997,
                26.325595
              ],
              [
                62.271207,
                26.326598
              ],
              [
                62.271944,
                26.328003
              ],
              [
                62.272133,
                26.330626
              ],
              [
                62.271923,
                26.332465
              ],
              [
                62.270684,
                26.333866
              ],
              [
                62.269284,
                26.334858
              ],
              [
                62.268182,
                26.335515
              ],
              [
                62.264565,
                26.336773
              ],
              [
                62.261741,
                26.337657
              ],
              [
                62.259473,
                26.338183
              ],
              [
                62.257467,
                26.338261
              ],
              [
                62.255717,
                26.338744
              ],
              [
                62.25446,
                26.339351
              ],
              [
                62.252185,
                26.340611
              ],
              [
                62.25116,
                26.342063
              ],
              [
                62.250561,
                26.343569
              ],
              [
                62.250452,
                26.344801
              ],
              [
                62.25036,
                26.345122
              ],
              [
                62.250133,
                26.346581
              ],
              [
                62.25148,
                26.353423
              ],
              [
                62.252812,
                26.3588
              ],
              [
                62.253075,
                26.359691
              ],
              [
                62.254049,
                26.361625
              ],
              [
                62.25459,
                26.362948
              ],
              [
                62.254806,
                26.363123
              ],
              [
                62.255006,
                26.363378
              ],
              [
                62.255494,
                26.364207
              ],
              [
                62.255708,
                26.364444
              ],
              [
                62.255989,
                26.365202
              ],
              [
                62.257099,
                26.366524
              ],
              [
                62.259616,
                26.368336
              ],
              [
                62.260758,
                26.369267
              ],
              [
                62.261734,
                26.369959
              ],
              [
                62.262945,
                26.370746
              ],
              [
                62.263717,
                26.371161
              ],
              [
                62.265895,
                26.371929
              ],
              [
                62.268453,
                26.372393
              ],
              [
                62.270088,
                26.37278
              ],
              [
                62.271457,
                26.373261
              ],
              [
                62.27374,
                26.374206
              ],
              [
                62.274934,
                26.374643
              ],
              [
                62.276664,
                26.375166
              ],
              [
                62.277669,
                26.375667
              ],
              [
                62.278439,
                26.376157
              ],
              [
                62.279904,
                26.377201
              ],
              [
                62.28268,
                26.378488
              ],
              [
                62.283469,
                26.378953
              ],
              [
                62.283921,
                26.379275
              ],
              [
                62.284351,
                26.379707
              ],
              [
                62.284695,
                26.380344
              ],
              [
                62.28457,
                26.381284
              ],
              [
                62.284054,
                26.382502
              ],
              [
                62.283581,
                26.383429
              ],
              [
                62.282253,
                26.384719
              ],
              [
                62.281828,
                26.38522
              ],
              [
                62.280816,
                26.386028
              ],
              [
                62.280501,
                26.3867
              ],
              [
                62.280187,
                26.387862
              ],
              [
                62.28017,
                26.388082
              ],
              [
                62.280075,
                26.388299
              ],
              [
                62.278484,
                26.39098
              ],
              [
                62.276723,
                26.393459
              ],
              [
                62.275764,
                26.394691
              ],
              [
                62.275089,
                26.395704
              ],
              [
                62.274117,
                26.396743
              ],
              [
                62.273348,
                26.397467
              ],
              [
                62.272509,
                26.398383
              ],
              [
                62.271339,
                26.400089
              ],
              [
                62.270402,
                26.401154
              ],
              [
                62.269869,
                26.401921
              ],
              [
                62.26975,
                26.402459
              ],
              [
                62.269749,
                26.403767
              ],
              [
                62.269597,
                26.404105
              ],
              [
                62.269048,
                26.404395
              ],
              [
                62.268282,
                26.404538
              ],
              [
                62.267085,
                26.404593
              ],
              [
                62.266263,
                26.404487
              ],
              [
                62.265806,
                26.404498
              ],
              [
                62.264991,
                26.404797
              ],
              [
                62.264007,
                26.4053
              ],
              [
                62.262891,
                26.406126
              ],
              [
                62.261393,
                26.40705
              ],
              [
                62.259498,
                26.408339
              ],
              [
                62.259323,
                26.408838
              ],
              [
                62.259388,
                26.409613
              ],
              [
                62.259642,
                26.410487
              ],
              [
                62.259865,
                26.410902
              ],
              [
                62.260484,
                26.411571
              ],
              [
                62.260649,
                26.41226
              ],
              [
                62.260836,
                26.413689
              ],
              [
                62.260759,
                26.414204
              ],
              [
                62.261006,
                26.416308
              ],
              [
                62.261293,
                26.417277
              ],
              [
                62.261418,
                26.419207
              ],
              [
                62.261536,
                26.422126
              ],
              [
                62.2615,
                26.422448
              ],
              [
                62.261554,
                26.423067
              ],
              [
                62.261741,
                26.423451
              ],
              [
                62.263305,
                26.424431
              ],
              [
                62.263868,
                26.425009
              ],
              [
                62.264343,
                26.426129
              ],
              [
                62.264432,
                26.426531
              ],
              [
                62.264281,
                26.427032
              ],
              [
                62.263801,
                26.427526
              ],
              [
                62.263283,
                26.427685
              ],
              [
                62.263061,
                26.427813
              ],
              [
                62.262876,
                26.428135
              ],
              [
                62.262675,
                26.428676
              ],
              [
                62.262687,
                26.431439
              ],
              [
                62.262555,
                26.432137
              ],
              [
                62.262725,
                26.432952
              ],
              [
                62.262768,
                26.43371
              ],
              [
                62.263098,
                26.434876
              ],
              [
                62.263364,
                26.436044
              ],
              [
                62.263388,
                26.436367
              ],
              [
                62.263655,
                26.436658
              ],
              [
                62.26448,
                26.437903
              ],
              [
                62.264718,
                26.438521
              ],
              [
                62.264992,
                26.438653
              ],
              [
                62.265063,
                26.439459
              ],
              [
                62.264952,
                26.44019
              ],
              [
                62.264638,
                26.44111
              ],
              [
                62.264266,
                26.441823
              ],
              [
                62.263961,
                26.44214
              ],
              [
                62.263431,
                26.442385
              ],
              [
                62.262256,
                26.442672
              ],
              [
                62.260937,
                26.442822
              ],
              [
                62.260108,
                26.44306
              ],
              [
                62.259134,
                26.443772
              ],
              [
                62.2587,
                26.444391
              ],
              [
                62.258507,
                26.444941
              ],
              [
                62.258022,
                26.445147
              ],
              [
                62.257764,
                26.445703
              ],
              [
                62.257767,
                26.446225
              ],
              [
                62.257893,
                26.446631
              ],
              [
                62.258316,
                26.4469
              ],
              [
                62.259036,
                26.447113
              ],
              [
                62.260281,
                26.447351
              ],
              [
                62.261631,
                26.447424
              ],
              [
                62.264094,
                26.447461
              ],
              [
                62.26499,
                26.447391
              ],
              [
                62.266165,
                26.447129
              ],
              [
                62.26955,
                26.446195
              ],
              [
                62.271113,
                26.445238
              ],
              [
                62.271623,
                26.445013
              ],
              [
                62.272456,
                26.444151
              ],
              [
                62.273125,
                26.443191
              ],
              [
                62.27403,
                26.442549
              ],
              [
                62.275664,
                26.441749
              ],
              [
                62.278107,
                26.440408
              ],
              [
                62.279206,
                26.44026
              ],
              [
                62.280269,
                26.439976
              ],
              [
                62.282089,
                26.439882
              ],
              [
                62.283409,
                26.439712
              ],
              [
                62.284365,
                26.439673
              ],
              [
                62.284882,
                26.439747
              ],
              [
                62.285381,
                26.439951
              ],
              [
                62.28612,
                26.440329
              ],
              [
                62.286175,
                26.440552
              ],
              [
                62.286192,
                26.441272
              ],
              [
                62.285982,
                26.443439
              ],
              [
                62.286209,
                26.444028
              ],
              [
                62.286821,
                26.446302
              ],
              [
                62.286955,
                26.446584
              ],
              [
                62.287915,
                26.447879
              ],
              [
                62.288256,
                26.448831
              ],
              [
                62.288263,
                26.44925
              ],
              [
                62.28816,
                26.449467
              ],
              [
                62.288201,
                26.44968
              ],
              [
                62.288535,
                26.449914
              ],
              [
                62.289052,
                26.450022
              ],
              [
                62.290957,
                26.449978
              ],
              [
                62.292075,
                26.450078
              ],
              [
                62.294207,
                26.450367
              ],
              [
                62.294497,
                26.450293
              ],
              [
                62.294937,
                26.450342
              ],
              [
                62.295278,
                26.450451
              ],
              [
                62.295699,
                26.450802
              ],
              [
                62.296396,
                26.452052
              ],
              [
                62.297893,
                26.45418
              ],
              [
                62.298456,
                26.455212
              ],
              [
                62.298199,
                26.456876
              ],
              [
                62.298201,
                26.457578
              ],
              [
                62.297952,
                26.458145
              ],
              [
                62.297825,
                26.459365
              ],
              [
                62.297573,
                26.460548
              ],
              [
                62.297299,
                26.461396
              ],
              [
                62.297452,
                26.461832
              ],
              [
                62.298337,
                26.462059
              ],
              [
                62.299449,
                26.462183
              ],
              [
                62.299995,
                26.462328
              ],
              [
                62.300904,
                26.462377
              ],
              [
                62.301744,
                26.462204
              ],
              [
                62.30273,
                26.462118
              ],
              [
                62.303926,
                26.46191
              ],
              [
                62.305518,
                26.461837
              ],
              [
                62.305962,
                26.461966
              ],
              [
                62.306568,
                26.462389
              ],
              [
                62.306943,
                26.462772
              ],
              [
                62.307104,
                26.463173
              ],
              [
                62.307066,
                26.464121
              ],
              [
                62.306583,
                26.464615
              ],
              [
                62.30566,
                26.465427
              ],
              [
                62.304948,
                26.466166
              ],
              [
                62.30434,
                26.467254
              ],
              [
                62.304411,
                26.467789
              ],
              [
                62.304602,
                26.468449
              ],
              [
                62.304921,
                26.468978
              ],
              [
                62.305176,
                26.469257
              ],
              [
                62.305717,
                26.469516
              ],
              [
                62.306497,
                26.469734
              ],
              [
                62.309345,
                26.47032
              ],
              [
                62.30965,
                26.470453
              ],
              [
                62.310844,
                26.471173
              ],
              [
                62.311165,
                26.471557
              ],
              [
                62.311553,
                26.471876
              ],
              [
                62.312921,
                26.472457
              ],
              [
                62.313823,
                26.472918
              ],
              [
                62.314159,
                26.473443
              ],
              [
                62.31419,
                26.47403
              ],
              [
                62.314081,
                26.474988
              ],
              [
                62.31339,
                26.476585
              ],
              [
                62.312954,
                26.477134
              ],
              [
                62.311692,
                26.477777
              ],
              [
                62.311102,
                26.478171
              ],
              [
                62.310758,
                26.47877
              ],
              [
                62.310592,
                26.479912
              ],
              [
                62.31083,
                26.480826
              ],
              [
                62.311174,
                26.481404
              ],
              [
                62.311592,
                26.481874
              ],
              [
                62.312067,
                26.48218
              ],
              [
                62.312685,
                26.48245
              ],
              [
                62.314161,
                26.482763
              ],
              [
                62.314767,
                26.482992
              ],
              [
                62.314983,
                26.483307
              ],
              [
                62.315162,
                26.483753
              ],
              [
                62.315223,
                26.484468
              ],
              [
                62.315003,
                26.485137
              ],
              [
                62.31491,
                26.485762
              ],
              [
                62.314922,
                26.486499
              ],
              [
                62.314784,
                26.486896
              ],
              [
                62.314534,
                26.487048
              ],
              [
                62.313883,
                26.487179
              ],
              [
                62.313149,
                26.487081
              ],
              [
                62.311783,
                26.486635
              ],
              [
                62.310185,
                26.486213
              ],
              [
                62.308705,
                26.486122
              ],
              [
                62.307577,
                26.485986
              ],
              [
                62.305813,
                26.485427
              ],
              [
                62.305572,
                26.48548
              ],
              [
                62.305001,
                26.486242
              ],
              [
                62.305097,
                26.486847
              ],
              [
                62.305399,
                26.487229
              ],
              [
                62.305455,
                26.48747
              ],
              [
                62.305413,
                26.487603
              ],
              [
                62.30367,
                26.488573
              ],
              [
                62.302742,
                26.488998
              ],
              [
                62.300436,
                26.489221
              ],
              [
                62.299849,
                26.489383
              ],
              [
                62.299474,
                26.489653
              ],
              [
                62.299141,
                26.490789
              ],
              [
                62.299099,
                26.492051
              ],
              [
                62.299309,
                26.4933
              ],
              [
                62.300092,
                26.496394
              ],
              [
                62.300084,
                26.496779
              ],
              [
                62.299939,
                26.497544
              ],
              [
                62.299894,
                26.498121
              ],
              [
                62.3015678,
                26.5001541
              ],
              [
                62.301752,
                26.503532
              ],
              [
                62.303304,
                26.508287
              ],
              [
                62.308438,
                26.513877
              ],
              [
                62.311023,
                26.516539
              ],
              [
                62.3095655,
                26.5176589
              ],
              [
                62.308373,
                26.5183063
              ],
              [
                62.2968638,
                26.5164399
              ],
              [
                62.2767735,
                26.5119559
              ],
              [
                62.2637702,
                26.5134147
              ],
              [
                62.2484537,
                26.5225588
              ],
              [
                62.2359863,
                26.5212919
              ],
              [
                62.2342941,
                26.5207794
              ],
              [
                62.2028801,
                26.5112641
              ],
              [
                62.1806437,
                26.5026153
              ],
              [
                62.157865,
                26.4945381
              ],
              [
                62.1498987,
                26.4907627
              ],
              [
                62.1410684,
                26.4865776
              ],
              [
                62.1302953,
                26.4862558
              ],
              [
                62.123088,
                26.4926649
              ],
              [
                62.1117245,
                26.4902349
              ],
              [
                62.1014605,
                26.4957822
              ],
              [
                62.0869978,
                26.4940999
              ],
              [
                62.060258,
                26.495414
              ],
              [
                62.0434651,
                26.501409
              ],
              [
                62.031096,
                26.5033345
              ],
              [
                62.0157502,
                26.4968688
              ],
              [
                62.0043883,
                26.4965735
              ],
              [
                61.9900662,
                26.4894967
              ],
              [
                61.9731874,
                26.4874283
              ],
              [
                61.9574033,
                26.4842081
              ],
              [
                61.946725,
                26.4849402
              ],
              [
                61.9435665,
                26.4899859
              ],
              [
                61.9333526,
                26.4890703
              ],
              [
                61.9116286,
                26.4910907
              ],
              [
                61.9104198,
                26.5051351
              ],
              [
                61.9110459,
                26.512608
              ],
              [
                61.9041496,
                26.5157736
              ],
              [
                61.904392,
                26.5259543
              ],
              [
                61.8902634,
                26.5210061
              ],
              [
                61.8788995,
                26.5206998
              ],
              [
                61.863654,
                26.5238767
              ],
              [
                61.8502958,
                26.5140308
              ],
              [
                61.8429958,
                26.5123757
              ],
              [
                61.835086,
                26.5177383
              ],
              [
                61.8252843,
                26.5146349
              ],
              [
                61.818639,
                26.5064863
              ],
              [
                61.810883,
                26.5064658
              ],
              [
                61.806969,
                26.5024322
              ],
              [
                61.793653,
                26.5000996
              ],
              [
                61.7843977,
                26.4964213
              ],
              [
                61.7785986,
                26.4984188
              ],
              [
                61.7643156,
                26.4988331
              ],
              [
                61.7483827,
                26.5009672
              ],
              [
                61.7361397,
                26.5044688
              ],
              [
                61.7319629,
                26.5117279
              ],
              [
                61.7299966,
                26.5242145
              ],
              [
                61.7110632,
                26.5238826
              ],
              [
                61.6767309,
                26.522193
              ],
              [
                61.6669462,
                26.5200427
              ],
              [
                61.6547583,
                26.5186603
              ],
              [
                61.6286658,
                26.5151274
              ],
              [
                61.609783,
                26.516817
              ],
              [
                61.5919302,
                26.5198891
              ],
              [
                61.5581129,
                26.5206571
              ],
              [
                61.5670393,
                26.508983
              ],
              [
                61.5634344,
                26.496386
              ],
              [
                61.5514103,
                26.490919
              ],
              [
                61.5224866,
                26.4937977
              ],
              [
                61.4951539,
                26.5026254
              ],
              [
                61.4454984,
                26.5128731
              ],
              [
                61.3822811,
                26.5219387
              ],
              [
                61.337534,
                26.5314293
              ],
              [
                61.3342003,
                26.5317079
              ],
              [
                61.3075343,
                26.5317079
              ],
              [
                61.3075343,
                26.5319863
              ],
              [
                61.3047545,
                26.5319864
              ],
              [
                61.3044741,
                26.5322648
              ],
              [
                61.301974,
                26.5322648
              ],
              [
                61.3017013,
                26.5325432
              ],
              [
                61.3000341,
                26.5325433
              ],
              [
                61.299474,
                26.5328216
              ],
              [
                61.2986411,
                26.5325432
              ],
              [
                61.2975341,
                26.5322648
              ],
              [
                61.2964208,
                26.5322648
              ],
              [
                61.264915,
                26.4555113
              ],
              [
                61.1828096,
                26.4210491
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 12225357,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دشتیاری",
          "type": "boundary",
          "wikidata": "Q5226763",
          "wikipedia": "en:Dashtiari County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                60.9274903,
                25.510855
              ],
              [
                60.9386729,
                25.5072002
              ],
              [
                60.9494018,
                25.5051861
              ],
              [
                60.9560966,
                25.5042565
              ],
              [
                60.9584998,
                25.5041016
              ],
              [
                60.9635639,
                25.5028621
              ],
              [
                60.9672299,
                25.5013132
              ],
              [
                60.9700304,
                25.5033169
              ],
              [
                60.9738989,
                25.4918403
              ],
              [
                60.9782847,
                25.482855
              ],
              [
                60.9785421,
                25.4738564
              ],
              [
                60.9751984,
                25.4671295
              ],
              [
                60.9748334,
                25.4625073
              ],
              [
                60.9759975,
                25.4532383
              ],
              [
                60.9759497,
                25.447836
              ],
              [
                60.9724169,
                25.440741
              ],
              [
                60.9654883,
                25.4291906
              ],
              [
                60.9632744,
                25.4191023
              ],
              [
                60.9632858,
                25.4113695
              ],
              [
                60.9654883,
                25.3984262
              ],
              [
                60.9695256,
                25.3843167
              ],
              [
                60.972529,
                25.3777089
              ],
              [
                60.9776488,
                25.37289
              ],
              [
                60.9824083,
                25.3697537
              ],
              [
                60.9868884,
                25.3683935
              ],
              [
                60.9922993,
                25.3678495
              ],
              [
                61.0401529,
                25.3755107
              ],
              [
                61.0416123,
                25.375862
              ],
              [
                61.0436984,
                25.3746785
              ],
              [
                61.0452508,
                25.3726622
              ],
              [
                61.0457359,
                25.3705582
              ],
              [
                61.0354998,
                25.3542947
              ],
              [
                61.0337048,
                25.3499545
              ],
              [
                61.0329771,
                25.3463156
              ],
              [
                61.0331226,
                25.3432466
              ],
              [
                61.0354179,
                25.3357688
              ],
              [
                61.0392694,
                25.3291335
              ],
              [
                61.0485459,
                25.3191059
              ],
              [
                61.0509802,
                25.3125218
              ],
              [
                61.0502476,
                25.3096137
              ],
              [
                61.0492774,
                25.3083419
              ],
              [
                61.0469002,
                25.3074648
              ],
              [
                61.0436499,
                25.307991
              ],
              [
                61.0360819,
                25.3077279
              ],
              [
                61.0323464,
                25.3057543
              ],
              [
                61.0272618,
                25.3040047
              ],
              [
                61.0246329,
                25.3015001
              ],
              [
                61.0221591,
                25.2980837
              ],
              [
                61.0169679,
                25.2928596
              ],
              [
                61.0102246,
                25.2854905
              ],
              [
                61.0068288,
                25.2825516
              ],
              [
                61.0059555,
                25.2802267
              ],
              [
                61.0069258,
                25.2779894
              ],
              [
                61.0093999,
                25.2766734
              ],
              [
                61.013378,
                25.2766734
              ],
              [
                61.0177441,
                25.278121
              ],
              [
                61.0233716,
                25.2813233
              ],
              [
                61.0254717,
                25.2815675
              ],
              [
                61.0264911,
                25.278146
              ],
              [
                61.0254771,
                25.2686566
              ],
              [
                61.0223868,
                25.263407
              ],
              [
                61.0188075,
                25.2593796
              ],
              [
                61.0149304,
                25.2545181
              ],
              [
                61.0134684,
                25.2537144
              ],
              [
                61.0086286,
                25.2483918
              ],
              [
                61.0020899,
                25.2448674
              ],
              [
                61.0002649,
                25.245555
              ],
              [
                60.9958642,
                25.2436581
              ],
              [
                60.9707995,
                25.234538
              ],
              [
                60.9426132,
                25.2238437
              ],
              [
                60.9558293,
                24.9721656
              ],
              [
                61.116039,
                24.9296429
              ],
              [
                61.3546759,
                24.8662768
              ],
              [
                61.3973042,
                24.85891
              ],
              [
                61.5820528,
                24.8353084
              ],
              [
                61.582221,
                24.8388312
              ],
              [
                61.5831369,
                24.8580138
              ],
              [
                61.5840257,
                24.8766295
              ],
              [
                61.5880961,
                24.9618819
              ],
              [
                61.5896408,
                24.9942356
              ],
              [
                61.5916305,
                25.0359092
              ],
              [
                61.5916667,
                25.0366667
              ],
              [
                61.6173713,
                25.1754455
              ],
              [
                61.6178362,
                25.176862
              ],
              [
                61.6295361,
                25.2092545
              ],
              [
                61.6316303,
                25.2203045
              ],
              [
                61.6333298,
                25.2281157
              ],
              [
                61.6349777,
                25.2346532
              ],
              [
                61.6373038,
                25.2435115
              ],
              [
                61.6392864,
                25.2524158
              ],
              [
                61.6403851,
                25.2592004
              ],
              [
                61.6401956,
                25.2686058
              ],
              [
                61.6412177,
                25.2745819
              ],
              [
                61.6429407,
                25.2822358
              ],
              [
                61.6448423,
                25.289239
              ],
              [
                61.6459883,
                25.2921799
              ],
              [
                61.648397,
                25.2967767
              ],
              [
                61.6495947,
                25.301537
              ],
              [
                61.6505818,
                25.3058125
              ],
              [
                61.6512062,
                25.3103982
              ],
              [
                61.6519143,
                25.3145881
              ],
              [
                61.65244,
                25.322081
              ],
              [
                61.6532897,
                25.3277328
              ],
              [
                61.6533219,
                25.3306362
              ],
              [
                61.6536738,
                25.3305878
              ],
              [
                61.6541083,
                25.332726
              ],
              [
                61.6501784,
                25.3331517
              ],
              [
                61.6514551,
                25.3418303
              ],
              [
                61.6523542,
                25.3481735
              ],
              [
                61.6532962,
                25.3558001
              ],
              [
                61.6541073,
                25.363017
              ],
              [
                61.654722,
                25.369444
              ],
              [
                61.6552933,
                25.3762854
              ],
              [
                61.6561938,
                25.3762161
              ],
              [
                61.6564891,
                25.3782388
              ],
              [
                61.6552156,
                25.3784771
              ],
              [
                61.655556,
                25.383333
              ],
              [
                61.6558155,
                25.3864507
              ],
              [
                61.6558035,
                25.393377
              ],
              [
                61.6558861,
                25.3983801
              ],
              [
                61.6559805,
                25.40363
              ],
              [
                61.656739,
                25.4078738
              ],
              [
                61.6582797,
                25.4138114
              ],
              [
                61.6598279,
                25.4196489
              ],
              [
                61.6605832,
                25.4226354
              ],
              [
                61.6608997,
                25.4249978
              ],
              [
                61.6606197,
                25.4315353
              ],
              [
                61.6604673,
                25.4388949
              ],
              [
                61.6605725,
                25.44331
              ],
              [
                61.6613256,
                25.4433129
              ],
              [
                61.6614619,
                25.4446508
              ],
              [
                61.6613342,
                25.4454452
              ],
              [
                61.6610038,
                25.4461873
              ],
              [
                61.6610413,
                25.4471736
              ],
              [
                61.6610713,
                25.4524282
              ],
              [
                61.6611422,
                25.4553877
              ],
              [
                61.6613342,
                25.4610711
              ],
              [
                61.6615552,
                25.4652935
              ],
              [
                61.661744,
                25.4680861
              ],
              [
                61.6621569,
                25.4739234
              ],
              [
                61.6628395,
                25.4797788
              ],
              [
                61.6636988,
                25.4866648
              ],
              [
                61.6641602,
                25.4893552
              ],
              [
                61.6654358,
                25.491449
              ],
              [
                61.6664583,
                25.5025642
              ],
              [
                61.6665699,
                25.5088796
              ],
              [
                61.6668274,
                25.5142061
              ],
              [
                61.6671256,
                25.5211812
              ],
              [
                61.6670784,
                25.5277648
              ],
              [
                61.6749572,
                25.6257472
              ],
              [
                61.6754623,
                25.6320263
              ],
              [
                61.676523,
                25.64521
              ],
              [
                61.676361,
                25.645247
              ],
              [
                61.676121,
                25.645501
              ],
              [
                61.675831,
                25.645623
              ],
              [
                61.67584,
                25.645789
              ],
              [
                61.675881,
                25.645817
              ],
              [
                61.675812,
                25.64588
              ],
              [
                61.675779,
                25.645999
              ],
              [
                61.675853,
                25.646056
              ],
              [
                61.675848,
                25.646271
              ],
              [
                61.675977,
                25.646307
              ],
              [
                61.675979,
                25.646455
              ],
              [
                61.67589,
                25.64647
              ],
              [
                61.675845,
                25.64658
              ],
              [
                61.675679,
                25.646538
              ],
              [
                61.675751,
                25.646641
              ],
              [
                61.675547,
                25.646852
              ],
              [
                61.675657,
                25.646883
              ],
              [
                61.675643,
                25.646931
              ],
              [
                61.675353,
                25.647049
              ],
              [
                61.67517,
                25.647043
              ],
              [
                61.675117,
                25.646969
              ],
              [
                61.674958,
                25.647004
              ],
              [
                61.674883,
                25.647175
              ],
              [
                61.674565,
                25.646977
              ],
              [
                61.674508,
                25.646988
              ],
              [
                61.674444,
                25.647065
              ],
              [
                61.674493,
                25.647131
              ],
              [
                61.674259,
                25.647224
              ],
              [
                61.67428,
                25.647166
              ],
              [
                61.674227,
                25.647081
              ],
              [
                61.674133,
                25.647142
              ],
              [
                61.674043,
                25.647066
              ],
              [
                61.673928,
                25.647126
              ],
              [
                61.673751,
                25.647033
              ],
              [
                61.673559,
                25.647097
              ],
              [
                61.67343,
                25.646996
              ],
              [
                61.673345,
                25.647022
              ],
              [
                61.673289,
                25.646957
              ],
              [
                61.672792,
                25.646891
              ],
              [
                61.672642,
                25.647321
              ],
              [
                61.672334,
                25.647707
              ],
              [
                61.672325,
                25.647835
              ],
              [
                61.672451,
                25.647904
              ],
              [
                61.672744,
                25.648246
              ],
              [
                61.672997,
                25.648294
              ],
              [
                61.673083,
                25.648373
              ],
              [
                61.673277,
                25.648294
              ],
              [
                61.673873,
                25.64873
              ],
              [
                61.67395,
                25.648916
              ],
              [
                61.674002,
                25.648954
              ],
              [
                61.674092,
                25.648931
              ],
              [
                61.674136,
                25.649104
              ],
              [
                61.674066,
                25.649376
              ],
              [
                61.674127,
                25.649558
              ],
              [
                61.674061,
                25.649784
              ],
              [
                61.674259,
                25.649941
              ],
              [
                61.674639,
                25.650104
              ],
              [
                61.675044,
                25.649987
              ],
              [
                61.675153,
                25.649975
              ],
              [
                61.675107,
                25.650074
              ],
              [
                61.675158,
                25.650097
              ],
              [
                61.675333,
                25.650069
              ],
              [
                61.675372,
                25.650016
              ],
              [
                61.675517,
                25.65009
              ],
              [
                61.675875,
                25.650153
              ],
              [
                61.676032,
                25.650266
              ],
              [
                61.676211,
                25.6503
              ],
              [
                61.676349,
                25.65041
              ],
              [
                61.676523,
                25.650442
              ],
              [
                61.676624,
                25.650529
              ],
              [
                61.676849,
                25.651059
              ],
              [
                61.677034,
                25.65105
              ],
              [
                61.677304,
                25.651206
              ],
              [
                61.67732,
                25.651257
              ],
              [
                61.677496,
                25.651284
              ],
              [
                61.677609,
                25.65135
              ],
              [
                61.678058,
                25.651675
              ],
              [
                61.678082,
                25.651734
              ],
              [
                61.678044,
                25.651768
              ],
              [
                61.678133,
                25.651862
              ],
              [
                61.678356,
                25.651818
              ],
              [
                61.678458,
                25.651958
              ],
              [
                61.678724,
                25.652141
              ],
              [
                61.678772,
                25.652265
              ],
              [
                61.678917,
                25.652258
              ],
              [
                61.678997,
                25.65239
              ],
              [
                61.679261,
                25.652451
              ],
              [
                61.679277,
                25.652525
              ],
              [
                61.679569,
                25.652799
              ],
              [
                61.679531,
                25.652854
              ],
              [
                61.679553,
                25.652922
              ],
              [
                61.679479,
                25.652972
              ],
              [
                61.679502,
                25.65311
              ],
              [
                61.679385,
                25.653091
              ],
              [
                61.679322,
                25.653297
              ],
              [
                61.679072,
                25.6537
              ],
              [
                61.678994,
                25.653994
              ],
              [
                61.678765,
                25.654123
              ],
              [
                61.678599,
                25.654349
              ],
              [
                61.678579,
                25.654663
              ],
              [
                61.678637,
                25.65492
              ],
              [
                61.67863,
                25.655272
              ],
              [
                61.678693,
                25.655495
              ],
              [
                61.678649,
                25.655524
              ],
              [
                61.678784,
                25.655943
              ],
              [
                61.678744,
                25.656206
              ],
              [
                61.67878,
                25.656276
              ],
              [
                61.678728,
                25.656382
              ],
              [
                61.678844,
                25.656828
              ],
              [
                61.678808,
                25.657118
              ],
              [
                61.678839,
                25.657177
              ],
              [
                61.678665,
                25.657493
              ],
              [
                61.678695,
                25.65778
              ],
              [
                61.678654,
                25.658006
              ],
              [
                61.678688,
                25.658009
              ],
              [
                61.67867,
                25.658052
              ],
              [
                61.678726,
                25.658091
              ],
              [
                61.678771,
                25.658254
              ],
              [
                61.678685,
                25.658256
              ],
              [
                61.678721,
                25.658335
              ],
              [
                61.679202,
                25.658353
              ],
              [
                61.679295,
                25.658485
              ],
              [
                61.67953,
                25.6585
              ],
              [
                61.679493,
                25.658926
              ],
              [
                61.679541,
                25.65905
              ],
              [
                61.679513,
                25.659095
              ],
              [
                61.679597,
                25.659256
              ],
              [
                61.679528,
                25.659366
              ],
              [
                61.679566,
                25.659443
              ],
              [
                61.679977,
                25.659765
              ],
              [
                61.679916,
                25.659989
              ],
              [
                61.680018,
                25.660241
              ],
              [
                61.680111,
                25.660294
              ],
              [
                61.680113,
                25.660403
              ],
              [
                61.680165,
                25.660445
              ],
              [
                61.680115,
                25.660527
              ],
              [
                61.680137,
                25.660589
              ],
              [
                61.680314,
                25.660702
              ],
              [
                61.680403,
                25.660872
              ],
              [
                61.680477,
                25.660919
              ],
              [
                61.680675,
                25.66098
              ],
              [
                61.680814,
                25.660937
              ],
              [
                61.681203,
                25.660996
              ],
              [
                61.681282,
                25.661043
              ],
              [
                61.681344,
                25.661004
              ],
              [
                61.681488,
                25.661004
              ],
              [
                61.681588,
                25.661054
              ],
              [
                61.681658,
                25.661032
              ],
              [
                61.68171,
                25.661146
              ],
              [
                61.682015,
                25.661327
              ],
              [
                61.682583,
                25.661435
              ],
              [
                61.682803,
                25.661695
              ],
              [
                61.683008,
                25.661697
              ],
              [
                61.683061,
                25.661618
              ],
              [
                61.683162,
                25.661598
              ],
              [
                61.683243,
                25.661623
              ],
              [
                61.683369,
                25.661508
              ],
              [
                61.68357,
                25.661695
              ],
              [
                61.683639,
                25.661653
              ],
              [
                61.683804,
                25.661724
              ],
              [
                61.683817,
                25.661801
              ],
              [
                61.68407,
                25.661761
              ],
              [
                61.684312,
                25.66187
              ],
              [
                61.684373,
                25.661952
              ],
              [
                61.684534,
                25.661935
              ],
              [
                61.684546,
                25.661901
              ],
              [
                61.684655,
                25.661958
              ],
              [
                61.684768,
                25.661943
              ],
              [
                61.684996,
                25.662216
              ],
              [
                61.685156,
                25.662209
              ],
              [
                61.685151,
                25.662433
              ],
              [
                61.685296,
                25.662463
              ],
              [
                61.685538,
                25.662595
              ],
              [
                61.685803,
                25.662548
              ],
              [
                61.686139,
                25.662675
              ],
              [
                61.686052,
                25.662793
              ],
              [
                61.686051,
                25.662913
              ],
              [
                61.686248,
                25.663044
              ],
              [
                61.686399,
                25.663449
              ],
              [
                61.686273,
                25.663471
              ],
              [
                61.686045,
                25.663694
              ],
              [
                61.686057,
                25.663745
              ],
              [
                61.685963,
                25.663843
              ],
              [
                61.685973,
                25.66392
              ],
              [
                61.685914,
                25.66394
              ],
              [
                61.685889,
                25.664079
              ],
              [
                61.685805,
                25.664096
              ],
              [
                61.685937,
                25.664254
              ],
              [
                61.686113,
                25.664197
              ],
              [
                61.686134,
                25.664254
              ],
              [
                61.686296,
                25.664302
              ],
              [
                61.68681,
                25.664277
              ],
              [
                61.686954,
                25.664363
              ],
              [
                61.687128,
                25.664363
              ],
              [
                61.68736,
                25.664517
              ],
              [
                61.687347,
                25.664619
              ],
              [
                61.687554,
                25.66463
              ],
              [
                61.687675,
                25.664731
              ],
              [
                61.687875,
                25.66472
              ],
              [
                61.687992,
                25.664778
              ],
              [
                61.688525,
                25.664826
              ],
              [
                61.688654,
                25.664885
              ],
              [
                61.688777,
                25.66487
              ],
              [
                61.689099,
                25.664976
              ],
              [
                61.689342,
                25.665136
              ],
              [
                61.689455,
                25.665121
              ],
              [
                61.689659,
                25.665243
              ],
              [
                61.689843,
                25.66516
              ],
              [
                61.689912,
                25.665222
              ],
              [
                61.689867,
                25.665292
              ],
              [
                61.689959,
                25.665295
              ],
              [
                61.690018,
                25.665444
              ],
              [
                61.690099,
                25.665444
              ],
              [
                61.690132,
                25.665547
              ],
              [
                61.690209,
                25.665543
              ],
              [
                61.690183,
                25.665573
              ],
              [
                61.690306,
                25.665649
              ],
              [
                61.690508,
                25.665491
              ],
              [
                61.690771,
                25.665403
              ],
              [
                61.691341,
                25.665364
              ],
              [
                61.692268,
                25.665503
              ],
              [
                61.692419,
                25.66543
              ],
              [
                61.69271,
                25.665458
              ],
              [
                61.692788,
                25.665591
              ],
              [
                61.692917,
                25.665612
              ],
              [
                61.69284,
                25.665674
              ],
              [
                61.692848,
                25.665743
              ],
              [
                61.692941,
                25.665743
              ],
              [
                61.69295,
                25.665838
              ],
              [
                61.693115,
                25.665851
              ],
              [
                61.693443,
                25.666088
              ],
              [
                61.693628,
                25.666137
              ],
              [
                61.693717,
                25.666115
              ],
              [
                61.693819,
                25.666232
              ],
              [
                61.694224,
                25.666337
              ],
              [
                61.694689,
                25.666632
              ],
              [
                61.69469,
                25.666713
              ],
              [
                61.694788,
                25.666849
              ],
              [
                61.695183,
                25.66694
              ],
              [
                61.695338,
                25.667059
              ],
              [
                61.695336,
                25.667103
              ],
              [
                61.695588,
                25.667191
              ],
              [
                61.695525,
                25.667307
              ],
              [
                61.695563,
                25.667328
              ],
              [
                61.695595,
                25.667559
              ],
              [
                61.695681,
                25.667674
              ],
              [
                61.695628,
                25.667706
              ],
              [
                61.695681,
                25.667866
              ],
              [
                61.695732,
                25.667897
              ],
              [
                61.695951,
                25.667861
              ],
              [
                61.69629,
                25.667996
              ],
              [
                61.696103,
                25.668302
              ],
              [
                61.696085,
                25.668479
              ],
              [
                61.696126,
                25.668551
              ],
              [
                61.695895,
                25.668926
              ],
              [
                61.695579,
                25.66889
              ],
              [
                61.695816,
                25.66932
              ],
              [
                61.695763,
                25.669552
              ],
              [
                61.695464,
                25.669618
              ],
              [
                61.694883,
                25.669906
              ],
              [
                61.694773,
                25.670046
              ],
              [
                61.694777,
                25.67011
              ],
              [
                61.694675,
                25.670151
              ],
              [
                61.694693,
                25.670185
              ],
              [
                61.694633,
                25.670232
              ],
              [
                61.694627,
                25.67034
              ],
              [
                61.694525,
                25.670539
              ],
              [
                61.69456,
                25.670988
              ],
              [
                61.694352,
                25.67134
              ],
              [
                61.694405,
                25.671442
              ],
              [
                61.694315,
                25.671625
              ],
              [
                61.694208,
                25.671713
              ],
              [
                61.694144,
                25.672346
              ],
              [
                61.693813,
                25.672585
              ],
              [
                61.69308,
                25.672602
              ],
              [
                61.692967,
                25.672663
              ],
              [
                61.692714,
                25.672949
              ],
              [
                61.692749,
                25.673082
              ],
              [
                61.692691,
                25.67325
              ],
              [
                61.692502,
                25.673332
              ],
              [
                61.692409,
                25.673606
              ],
              [
                61.692447,
                25.673741
              ],
              [
                61.692518,
                25.673809
              ],
              [
                61.692488,
                25.673864
              ],
              [
                61.692535,
                25.673927
              ],
              [
                61.6925341,
                25.6741163
              ],
              [
                61.692534,
                25.674148
              ],
              [
                61.692509,
                25.674229
              ],
              [
                61.692396,
                25.674211
              ],
              [
                61.692413,
                25.674297
              ],
              [
                61.692371,
                25.674357
              ],
              [
                61.692737,
                25.674567
              ],
              [
                61.692835,
                25.674768
              ],
              [
                61.692621,
                25.674796
              ],
              [
                61.692632,
                25.674897
              ],
              [
                61.692453,
                25.675427
              ],
              [
                61.692335,
                25.675417
              ],
              [
                61.692306,
                25.675457
              ],
              [
                61.692365,
                25.675498
              ],
              [
                61.692236,
                25.675618
              ],
              [
                61.692074,
                25.675607
              ],
              [
                61.691984,
                25.675743
              ],
              [
                61.691865,
                25.675778
              ],
              [
                61.691837,
                25.675711
              ],
              [
                61.691715,
                25.675695
              ],
              [
                61.691672,
                25.675749
              ],
              [
                61.691502,
                25.675723
              ],
              [
                61.691365,
                25.675789
              ],
              [
                61.691359,
                25.675908
              ],
              [
                61.691194,
                25.676049
              ],
              [
                61.691163,
                25.676128
              ],
              [
                61.691241,
                25.676156
              ],
              [
                61.691301,
                25.67629
              ],
              [
                61.6913413,
                25.6762875
              ],
              [
                61.691383,
                25.676285
              ],
              [
                61.691418,
                25.676325
              ],
              [
                61.691516,
                25.67657
              ],
              [
                61.691565,
                25.676599
              ],
              [
                61.691594,
                25.676737
              ],
              [
                61.691541,
                25.676907
              ],
              [
                61.691444,
                25.677093
              ],
              [
                61.691299,
                25.677056
              ],
              [
                61.691249,
                25.677259
              ],
              [
                61.691346,
                25.6773
              ],
              [
                61.691404,
                25.677411
              ],
              [
                61.691404,
                25.677722
              ],
              [
                61.691596,
                25.677816
              ],
              [
                61.69163,
                25.677887
              ],
              [
                61.691592,
                25.677954
              ],
              [
                61.691736,
                25.678044
              ],
              [
                61.691688,
                25.678166
              ],
              [
                61.691618,
                25.678216
              ],
              [
                61.691894,
                25.678342
              ],
              [
                61.69217,
                25.678312
              ],
              [
                61.692322,
                25.678415
              ],
              [
                61.692458,
                25.678438
              ],
              [
                61.692764,
                25.678368
              ],
              [
                61.692879,
                25.678578
              ],
              [
                61.692857,
                25.678795
              ],
              [
                61.692739,
                25.678876
              ],
              [
                61.692609,
                25.67914
              ],
              [
                61.692495,
                25.679239
              ],
              [
                61.692449,
                25.679228
              ],
              [
                61.692471,
                25.679292
              ],
              [
                61.69241,
                25.679321
              ],
              [
                61.692468,
                25.679388
              ],
              [
                61.692467,
                25.679485
              ],
              [
                61.692575,
                25.679552
              ],
              [
                61.692519,
                25.67965
              ],
              [
                61.692595,
                25.679706
              ],
              [
                61.692581,
                25.67979
              ],
              [
                61.692432,
                25.679916
              ],
              [
                61.692429,
                25.680093
              ],
              [
                61.692366,
                25.680136
              ],
              [
                61.692378,
                25.68018
              ],
              [
                61.692458,
                25.680155
              ],
              [
                61.692633,
                25.680303
              ],
              [
                61.692716,
                25.680312
              ],
              [
                61.692824,
                25.680444
              ],
              [
                61.692942,
                25.680428
              ],
              [
                61.693049,
                25.680502
              ],
              [
                61.693025,
                25.680564
              ],
              [
                61.693097,
                25.680672
              ],
              [
                61.693238,
                25.680633
              ],
              [
                61.693337,
                25.680739
              ],
              [
                61.693389,
                25.680697
              ],
              [
                61.693603,
                25.680706
              ],
              [
                61.693592,
                25.680657
              ],
              [
                61.693798,
                25.680656
              ],
              [
                61.693939,
                25.680754
              ],
              [
                61.694101,
                25.680719
              ],
              [
                61.694118,
                25.680762
              ],
              [
                61.694161,
                25.680752
              ],
              [
                61.694194,
                25.680865
              ],
              [
                61.694341,
                25.680856
              ],
              [
                61.694551,
                25.680714
              ],
              [
                61.694768,
                25.680834
              ],
              [
                61.694795,
                25.680897
              ],
              [
                61.695026,
                25.680893
              ],
              [
                61.695388,
                25.680707
              ],
              [
                61.69547,
                25.680621
              ],
              [
                61.69595,
                25.680609
              ],
              [
                61.696015,
                25.680811
              ],
              [
                61.695954,
                25.680852
              ],
              [
                61.696017,
                25.680943
              ],
              [
                61.696006,
                25.681151
              ],
              [
                61.696063,
                25.681283
              ],
              [
                61.696003,
                25.681395
              ],
              [
                61.696084,
                25.681465
              ],
              [
                61.696143,
                25.681737
              ],
              [
                61.696036,
                25.68197
              ],
              [
                61.696025,
                25.682155
              ],
              [
                61.696084,
                25.682372
              ],
              [
                61.696245,
                25.682495
              ],
              [
                61.696178,
                25.683049
              ],
              [
                61.695967,
                25.683188
              ],
              [
                61.695912,
                25.683416
              ],
              [
                61.695586,
                25.683638
              ],
              [
                61.695795,
                25.684007
              ],
              [
                61.695931,
                25.684062
              ],
              [
                61.696044,
                25.684307
              ],
              [
                61.696037,
                25.684387
              ],
              [
                61.696153,
                25.684444
              ],
              [
                61.696164,
                25.684783
              ],
              [
                61.696071,
                25.685022
              ],
              [
                61.695882,
                25.685245
              ],
              [
                61.695654,
                25.685322
              ],
              [
                61.695537,
                25.685566
              ],
              [
                61.695443,
                25.685587
              ],
              [
                61.695503,
                25.68565
              ],
              [
                61.69542,
                25.685709
              ],
              [
                61.69505,
                25.685815
              ],
              [
                61.694877,
                25.685786
              ],
              [
                61.694645,
                25.685822
              ],
              [
                61.694607,
                25.685789
              ],
              [
                61.694537,
                25.685891
              ],
              [
                61.694464,
                25.685872
              ],
              [
                61.694324,
                25.685957
              ],
              [
                61.69426,
                25.686244
              ],
              [
                61.69413,
                25.686281
              ],
              [
                61.693903,
                25.686497
              ],
              [
                61.693833,
                25.686509
              ],
              [
                61.69386,
                25.686801
              ],
              [
                61.693722,
                25.687018
              ],
              [
                61.693667,
                25.687264
              ],
              [
                61.693554,
                25.687347
              ],
              [
                61.693572,
                25.687406
              ],
              [
                61.693487,
                25.687567
              ],
              [
                61.693494,
                25.687622
              ],
              [
                61.693775,
                25.687756
              ],
              [
                61.693893,
                25.687754
              ],
              [
                61.693959,
                25.687856
              ],
              [
                61.694036,
                25.687884
              ],
              [
                61.694221,
                25.68846
              ],
              [
                61.69417,
                25.688615
              ],
              [
                61.694191,
                25.688764
              ],
              [
                61.694271,
                25.688873
              ],
              [
                61.694279,
                25.689144
              ],
              [
                61.694395,
                25.689525
              ],
              [
                61.694398,
                25.68981
              ],
              [
                61.694487,
                25.690058
              ],
              [
                61.694538,
                25.690509
              ],
              [
                61.694536,
                25.690795
              ],
              [
                61.694426,
                25.690853
              ],
              [
                61.694406,
                25.690943
              ],
              [
                61.694487,
                25.691126
              ],
              [
                61.694479,
                25.691225
              ],
              [
                61.694319,
                25.691408
              ],
              [
                61.694354,
                25.691444
              ],
              [
                61.694256,
                25.69206
              ],
              [
                61.694297,
                25.692122
              ],
              [
                61.694103,
                25.692066
              ],
              [
                61.693953,
                25.692087
              ],
              [
                61.693891,
                25.691966
              ],
              [
                61.693817,
                25.691942
              ],
              [
                61.693733,
                25.69204
              ],
              [
                61.693331,
                25.692129
              ],
              [
                61.693284,
                25.692207
              ],
              [
                61.69304,
                25.692372
              ],
              [
                61.692585,
                25.69254
              ],
              [
                61.692385,
                25.692594
              ],
              [
                61.69232,
                25.692573
              ],
              [
                61.692036,
                25.692748
              ],
              [
                61.691795,
                25.692976
              ],
              [
                61.69167,
                25.693007
              ],
              [
                61.691445,
                25.693185
              ],
              [
                61.691424,
                25.693249
              ],
              [
                61.691342,
                25.693289
              ],
              [
                61.691367,
                25.693464
              ],
              [
                61.69149,
                25.693528
              ],
              [
                61.691691,
                25.693423
              ],
              [
                61.691759,
                25.693446
              ],
              [
                61.691957,
                25.693205
              ],
              [
                61.69222,
                25.693017
              ],
              [
                61.692331,
                25.693058
              ],
              [
                61.692564,
                25.693038
              ],
              [
                61.692589,
                25.692994
              ],
              [
                61.692609,
                25.693084
              ],
              [
                61.692954,
                25.693125
              ],
              [
                61.692958,
                25.693243
              ],
              [
                61.693016,
                25.693321
              ],
              [
                61.693242,
                25.693493
              ],
              [
                61.6936,
                25.693604
              ],
              [
                61.693932,
                25.693632
              ],
              [
                61.694181,
                25.693818
              ],
              [
                61.694436,
                25.693511
              ],
              [
                61.694586,
                25.693506
              ],
              [
                61.694677,
                25.693562
              ],
              [
                61.694815,
                25.693482
              ],
              [
                61.69487,
                25.69311
              ],
              [
                61.695102,
                25.69297
              ],
              [
                61.695142,
                25.692891
              ],
              [
                61.695405,
                25.69268
              ],
              [
                61.69552,
                25.692674
              ],
              [
                61.695527,
                25.692617
              ],
              [
                61.695963,
                25.692343
              ],
              [
                61.696021,
                25.692219
              ],
              [
                61.69675,
                25.691936
              ],
              [
                61.697157,
                25.691904
              ],
              [
                61.697357,
                25.691768
              ],
              [
                61.697583,
                25.691684
              ],
              [
                61.697907,
                25.691611
              ],
              [
                61.69799,
                25.691631
              ],
              [
                61.698136,
                25.69155
              ],
              [
                61.698609,
                25.691418
              ],
              [
                61.698742,
                25.691358
              ],
              [
                61.698962,
                25.691057
              ],
              [
                61.69911,
                25.690996
              ],
              [
                61.69944,
                25.690936
              ],
              [
                61.699699,
                25.690944
              ],
              [
                61.699735,
                25.690991
              ],
              [
                61.699899,
                25.690977
              ],
              [
                61.699954,
                25.690944
              ],
              [
                61.699879,
                25.690915
              ],
              [
                61.699976,
                25.690905
              ],
              [
                61.700092,
                25.691006
              ],
              [
                61.700336,
                25.690889
              ],
              [
                61.700658,
                25.690637
              ],
              [
                61.70088,
                25.690578
              ],
              [
                61.70109,
                25.690606
              ],
              [
                61.701264,
                25.690728
              ],
              [
                61.701465,
                25.69071
              ],
              [
                61.701692,
                25.690858
              ],
              [
                61.701988,
                25.690882
              ],
              [
                61.702241,
                25.690971
              ],
              [
                61.702363,
                25.690933
              ],
              [
                61.703042,
                25.690928
              ],
              [
                61.703531,
                25.690967
              ],
              [
                61.703985,
                25.690902
              ],
              [
                61.704032,
                25.691065
              ],
              [
                61.703817,
                25.691367
              ],
              [
                61.703861,
                25.691541
              ],
              [
                61.70402,
                25.691573
              ],
              [
                61.704795,
                25.69202
              ],
              [
                61.704894,
                25.692121
              ],
              [
                61.704897,
                25.692218
              ],
              [
                61.704988,
                25.692283
              ],
              [
                61.704969,
                25.692368
              ],
              [
                61.705136,
                25.692424
              ],
              [
                61.705351,
                25.692637
              ],
              [
                61.705536,
                25.692744
              ],
              [
                61.705603,
                25.692714
              ],
              [
                61.705678,
                25.692754
              ],
              [
                61.705975,
                25.693067
              ],
              [
                61.706136,
                25.693131
              ],
              [
                61.706345,
                25.693498
              ],
              [
                61.706372,
                25.693821
              ],
              [
                61.706137,
                25.694068
              ],
              [
                61.706188,
                25.69424
              ],
              [
                61.706138,
                25.694321
              ],
              [
                61.706241,
                25.6947
              ],
              [
                61.706218,
                25.694764
              ],
              [
                61.706165,
                25.694774
              ],
              [
                61.706139,
                25.694887
              ],
              [
                61.706163,
                25.695124
              ],
              [
                61.706123,
                25.695185
              ],
              [
                61.706201,
                25.695259
              ],
              [
                61.706122,
                25.695405
              ],
              [
                61.706218,
                25.695481
              ],
              [
                61.70625,
                25.695578
              ],
              [
                61.705988,
                25.696053
              ],
              [
                61.70597,
                25.696421
              ],
              [
                61.705688,
                25.696481
              ],
              [
                61.705385,
                25.696706
              ],
              [
                61.705279,
                25.696718
              ],
              [
                61.70509,
                25.696834
              ],
              [
                61.705252,
                25.697298
              ],
              [
                61.705249,
                25.697697
              ],
              [
                61.70521,
                25.697795
              ],
              [
                61.70533,
                25.697799
              ],
              [
                61.705446,
                25.697877
              ],
              [
                61.70567,
                25.698141
              ],
              [
                61.70585,
                25.698261
              ],
              [
                61.706033,
                25.698488
              ],
              [
                61.706016,
                25.698612
              ],
              [
                61.706111,
                25.698642
              ],
              [
                61.706305,
                25.698842
              ],
              [
                61.706291,
                25.698907
              ],
              [
                61.706545,
                25.699192
              ],
              [
                61.706547,
                25.699255
              ],
              [
                61.706682,
                25.699396
              ],
              [
                61.706696,
                25.699514
              ],
              [
                61.706853,
                25.699733
              ],
              [
                61.707054,
                25.699918
              ],
              [
                61.707305,
                25.69999
              ],
              [
                61.707545,
                25.700259
              ],
              [
                61.707665,
                25.700219
              ],
              [
                61.707802,
                25.700393
              ],
              [
                61.707906,
                25.700312
              ],
              [
                61.70806,
                25.700438
              ],
              [
                61.708066,
                25.700688
              ],
              [
                61.708242,
                25.700673
              ],
              [
                61.708291,
                25.700757
              ],
              [
                61.708381,
                25.700788
              ],
              [
                61.708437,
                25.700936
              ],
              [
                61.708468,
                25.700891
              ],
              [
                61.7086,
                25.700919
              ],
              [
                61.708726,
                25.700873
              ],
              [
                61.708976,
                25.700983
              ],
              [
                61.709484,
                25.70085
              ],
              [
                61.70957,
                25.700907
              ],
              [
                61.709582,
                25.70096
              ],
              [
                61.7095,
                25.701093
              ],
              [
                61.709455,
                25.701544
              ],
              [
                61.709591,
                25.701618
              ],
              [
                61.709566,
                25.701708
              ],
              [
                61.709612,
                25.70179
              ],
              [
                61.709822,
                25.701847
              ],
              [
                61.710227,
                25.701785
              ],
              [
                61.710323,
                25.701729
              ],
              [
                61.710459,
                25.701468
              ],
              [
                61.710674,
                25.701672
              ],
              [
                61.711029,
                25.701408
              ],
              [
                61.711075,
                25.701458
              ],
              [
                61.711024,
                25.701499
              ],
              [
                61.711054,
                25.701598
              ],
              [
                61.710962,
                25.702067
              ],
              [
                61.710696,
                25.702536
              ],
              [
                61.710667,
                25.70291
              ],
              [
                61.711102,
                25.703636
              ],
              [
                61.711632,
                25.703811
              ],
              [
                61.711696,
                25.70396
              ],
              [
                61.711799,
                25.703993
              ],
              [
                61.711952,
                25.703943
              ],
              [
                61.712138,
                25.70397
              ],
              [
                61.712227,
                25.70405
              ],
              [
                61.712298,
                25.703984
              ],
              [
                61.712369,
                25.703997
              ],
              [
                61.712487,
                25.704524
              ],
              [
                61.712864,
                25.704704
              ],
              [
                61.712879,
                25.704771
              ],
              [
                61.712994,
                25.704856
              ],
              [
                61.71305,
                25.705321
              ],
              [
                61.712987,
                25.705388
              ],
              [
                61.713287,
                25.705528
              ],
              [
                61.713243,
                25.705684
              ],
              [
                61.713386,
                25.705703
              ],
              [
                61.713414,
                25.705768
              ],
              [
                61.713347,
                25.705866
              ],
              [
                61.713429,
                25.706162
              ],
              [
                61.713525,
                25.706375
              ],
              [
                61.713605,
                25.70644
              ],
              [
                61.713702,
                25.706713
              ],
              [
                61.713632,
                25.706918
              ],
              [
                61.713635,
                25.707159
              ],
              [
                61.713565,
                25.707315
              ],
              [
                61.714063,
                25.708035
              ],
              [
                61.714154,
                25.70788
              ],
              [
                61.714513,
                25.707817
              ],
              [
                61.714628,
                25.708011
              ],
              [
                61.715038,
                25.708171
              ],
              [
                61.715535,
                25.708451
              ],
              [
                61.715866,
                25.708555
              ],
              [
                61.716066,
                25.708555
              ],
              [
                61.716267,
                25.708661
              ],
              [
                61.716945,
                25.708868
              ],
              [
                61.71711,
                25.708999
              ],
              [
                61.717271,
                25.709026
              ],
              [
                61.717333,
                25.709224
              ],
              [
                61.717387,
                25.70925
              ],
              [
                61.717493,
                25.709219
              ],
              [
                61.717548,
                25.709314
              ],
              [
                61.717764,
                25.709288
              ],
              [
                61.717955,
                25.709366
              ],
              [
                61.718129,
                25.709328
              ],
              [
                61.718263,
                25.709196
              ],
              [
                61.718607,
                25.709154
              ],
              [
                61.718699,
                25.709224
              ],
              [
                61.719063,
                25.709158
              ],
              [
                61.71918,
                25.709198
              ],
              [
                61.719218,
                25.709265
              ],
              [
                61.719512,
                25.709177
              ],
              [
                61.719921,
                25.709179
              ],
              [
                61.719884,
                25.70913
              ],
              [
                61.719972,
                25.709156
              ],
              [
                61.719985,
                25.70921
              ],
              [
                61.720242,
                25.709132
              ],
              [
                61.720831,
                25.709047
              ],
              [
                61.721008,
                25.709171
              ],
              [
                61.721151,
                25.709206
              ],
              [
                61.721254,
                25.709183
              ],
              [
                61.721434,
                25.709407
              ],
              [
                61.72183,
                25.709462
              ],
              [
                61.722277,
                25.709777
              ],
              [
                61.722456,
                25.709811
              ],
              [
                61.722682,
                25.709783
              ],
              [
                61.722883,
                25.709857
              ],
              [
                61.723124,
                25.709871
              ],
              [
                61.723277,
                25.709804
              ],
              [
                61.723432,
                25.709833
              ],
              [
                61.723389,
                25.709855
              ],
              [
                61.723404,
                25.709911
              ],
              [
                61.723495,
                25.709904
              ],
              [
                61.723571,
                25.710078
              ],
              [
                61.723701,
                25.710227
              ],
              [
                61.723842,
                25.710286
              ],
              [
                61.723841,
                25.710347
              ],
              [
                61.723921,
                25.71035
              ],
              [
                61.723845,
                25.71045
              ],
              [
                61.723769,
                25.710717
              ],
              [
                61.723809,
                25.710754
              ],
              [
                61.723755,
                25.710853
              ],
              [
                61.723817,
                25.710976
              ],
              [
                61.723853,
                25.710976
              ],
              [
                61.723912,
                25.710846
              ],
              [
                61.72415,
                25.710835
              ],
              [
                61.724253,
                25.711023
              ],
              [
                61.724395,
                25.711073
              ],
              [
                61.72477,
                25.711037
              ],
              [
                61.72484,
                25.711098
              ],
              [
                61.72544,
                25.711074
              ],
              [
                61.725805,
                25.711202
              ],
              [
                61.726143,
                25.711182
              ],
              [
                61.726108,
                25.711141
              ],
              [
                61.72616,
                25.711092
              ],
              [
                61.726362,
                25.711038
              ],
              [
                61.726322,
                25.71126
              ],
              [
                61.726367,
                25.711365
              ],
              [
                61.726247,
                25.711518
              ],
              [
                61.726338,
                25.711689
              ],
              [
                61.726534,
                25.711793
              ],
              [
                61.726648,
                25.711799
              ],
              [
                61.726605,
                25.711848
              ],
              [
                61.726695,
                25.711915
              ],
              [
                61.726889,
                25.711956
              ],
              [
                61.727184,
                25.71196
              ],
              [
                61.72769,
                25.711885
              ],
              [
                61.727578,
                25.712083
              ],
              [
                61.727609,
                25.712171
              ],
              [
                61.727515,
                25.712295
              ],
              [
                61.72764,
                25.712402
              ],
              [
                61.727834,
                25.712457
              ],
              [
                61.728018,
                25.712938
              ],
              [
                61.728215,
                25.712892
              ],
              [
                61.728399,
                25.712904
              ],
              [
                61.728362,
                25.713218
              ],
              [
                61.728403,
                25.713283
              ],
              [
                61.728346,
                25.713366
              ],
              [
                61.728637,
                25.713406
              ],
              [
                61.729033,
                25.713332
              ],
              [
                61.729264,
                25.713544
              ],
              [
                61.729431,
                25.713611
              ],
              [
                61.729377,
                25.713829
              ],
              [
                61.729623,
                25.714095
              ],
              [
                61.729629,
                25.714369
              ],
              [
                61.729737,
                25.714502
              ],
              [
                61.7297,
                25.714727
              ],
              [
                61.729927,
                25.714954
              ],
              [
                61.729971,
                25.715111
              ],
              [
                61.729959,
                25.715232
              ],
              [
                61.729899,
                25.715252
              ],
              [
                61.729925,
                25.715337
              ],
              [
                61.730037,
                25.715477
              ],
              [
                61.730386,
                25.715748
              ],
              [
                61.730524,
                25.715932
              ],
              [
                61.729918,
                25.716138
              ],
              [
                61.729911,
                25.716205
              ],
              [
                61.729535,
                25.716346
              ],
              [
                61.729158,
                25.716364
              ],
              [
                61.728902,
                25.716524
              ],
              [
                61.728871,
                25.716555
              ],
              [
                61.728908,
                25.716854
              ],
              [
                61.729017,
                25.717048
              ],
              [
                61.729004,
                25.717156
              ],
              [
                61.729066,
                25.717189
              ],
              [
                61.72893,
                25.717288
              ],
              [
                61.728947,
                25.717414
              ],
              [
                61.728915,
                25.717432
              ],
              [
                61.728655,
                25.717522
              ],
              [
                61.728503,
                25.717462
              ],
              [
                61.728182,
                25.717573
              ],
              [
                61.727643,
                25.717638
              ],
              [
                61.7274,
                25.717713
              ],
              [
                61.727303,
                25.717881
              ],
              [
                61.727243,
                25.717894
              ],
              [
                61.727178,
                25.7179
              ],
              [
                61.727082,
                25.717819
              ],
              [
                61.727121,
                25.717812
              ],
              [
                61.727105,
                25.717765
              ],
              [
                61.727025,
                25.71773
              ],
              [
                61.726607,
                25.717724
              ],
              [
                61.726494,
                25.717775
              ],
              [
                61.726411,
                25.717902
              ],
              [
                61.726487,
                25.717919
              ],
              [
                61.726423,
                25.718062
              ],
              [
                61.726483,
                25.718119
              ],
              [
                61.726438,
                25.718277
              ],
              [
                61.726483,
                25.718391
              ],
              [
                61.726724,
                25.718518
              ],
              [
                61.726933,
                25.718504
              ],
              [
                61.726899,
                25.718674
              ],
              [
                61.727154,
                25.71899
              ],
              [
                61.727146,
                25.719086
              ],
              [
                61.72724,
                25.719149
              ],
              [
                61.727177,
                25.719413
              ],
              [
                61.726612,
                25.719436
              ],
              [
                61.726534,
                25.719396
              ],
              [
                61.726315,
                25.71939
              ],
              [
                61.726155,
                25.719559
              ],
              [
                61.726073,
                25.719817
              ],
              [
                61.726003,
                25.719813
              ],
              [
                61.726004,
                25.719935
              ],
              [
                61.725947,
                25.719933
              ],
              [
                61.725885,
                25.720017
              ],
              [
                61.726096,
                25.72008
              ],
              [
                61.727182,
                25.72021
              ],
              [
                61.727202,
                25.720347
              ],
              [
                61.727509,
                25.720647
              ],
              [
                61.727489,
                25.720986
              ],
              [
                61.727531,
                25.721338
              ],
              [
                61.727707,
                25.72148
              ],
              [
                61.727638,
                25.721535
              ],
              [
                61.727691,
                25.721596
              ],
              [
                61.72768,
                25.721811
              ],
              [
                61.72772,
                25.721872
              ],
              [
                61.727841,
                25.721879
              ],
              [
                61.727906,
                25.722067
              ],
              [
                61.727952,
                25.722523
              ],
              [
                61.727895,
                25.722566
              ],
              [
                61.728272,
                25.722776
              ],
              [
                61.728509,
                25.722828
              ],
              [
                61.728646,
                25.722933
              ],
              [
                61.728643,
                25.723065
              ],
              [
                61.728481,
                25.723375
              ],
              [
                61.728509,
                25.723605
              ],
              [
                61.728341,
                25.723815
              ],
              [
                61.728321,
                25.723926
              ],
              [
                61.72812,
                25.724028
              ],
              [
                61.728047,
                25.724139
              ],
              [
                61.72816,
                25.724253
              ],
              [
                61.728152,
                25.724416
              ],
              [
                61.728094,
                25.724485
              ],
              [
                61.728217,
                25.724846
              ],
              [
                61.727754,
                25.725049
              ],
              [
                61.727673,
                25.725031
              ],
              [
                61.727644,
                25.725181
              ],
              [
                61.72759,
                25.7252
              ],
              [
                61.72751,
                25.725393
              ],
              [
                61.727288,
                25.725624
              ],
              [
                61.727063,
                25.725669
              ],
              [
                61.726719,
                25.725877
              ],
              [
                61.726347,
                25.726002
              ],
              [
                61.725615,
                25.726065
              ],
              [
                61.725228,
                25.726201
              ],
              [
                61.725016,
                25.726192
              ],
              [
                61.725023,
                25.726315
              ],
              [
                61.725122,
                25.726511
              ],
              [
                61.725115,
                25.726611
              ],
              [
                61.725284,
                25.726724
              ],
              [
                61.725297,
                25.726811
              ],
              [
                61.72543,
                25.726823
              ],
              [
                61.725533,
                25.726936
              ],
              [
                61.725627,
                25.726924
              ],
              [
                61.725677,
                25.727014
              ],
              [
                61.725646,
                25.727024
              ],
              [
                61.725746,
                25.727079
              ],
              [
                61.725632,
                25.727498
              ],
              [
                61.725671,
                25.727545
              ],
              [
                61.725915,
                25.727584
              ],
              [
                61.72638,
                25.727518
              ],
              [
                61.726463,
                25.727696
              ],
              [
                61.726617,
                25.727699
              ],
              [
                61.726811,
                25.727829
              ],
              [
                61.726949,
                25.728332
              ],
              [
                61.727218,
                25.728369
              ],
              [
                61.727405,
                25.728468
              ],
              [
                61.727863,
                25.728514
              ],
              [
                61.727957,
                25.728633
              ],
              [
                61.728684,
                25.728704
              ],
              [
                61.728562,
                25.728815
              ],
              [
                61.728686,
                25.728842
              ],
              [
                61.728641,
                25.728899
              ],
              [
                61.728448,
                25.72894
              ],
              [
                61.728457,
                25.729021
              ],
              [
                61.728355,
                25.729121
              ],
              [
                61.728356,
                25.729156
              ],
              [
                61.728416,
                25.729141
              ],
              [
                61.728728,
                25.72925
              ],
              [
                61.728704,
                25.729538
              ],
              [
                61.728612,
                25.729596
              ],
              [
                61.728567,
                25.729808
              ],
              [
                61.728564,
                25.729987
              ],
              [
                61.72861,
                25.730078
              ],
              [
                61.728752,
                25.730214
              ],
              [
                61.729012,
                25.730342
              ],
              [
                61.729055,
                25.730571
              ],
              [
                61.729219,
                25.730735
              ],
              [
                61.729325,
                25.730981
              ],
              [
                61.729457,
                25.731139
              ],
              [
                61.729755,
                25.731288
              ],
              [
                61.729907,
                25.731237
              ],
              [
                61.730087,
                25.731104
              ],
              [
                61.730309,
                25.731157
              ],
              [
                61.730427,
                25.731582
              ],
              [
                61.730472,
                25.731609
              ],
              [
                61.730486,
                25.73178
              ],
              [
                61.730391,
                25.731865
              ],
              [
                61.730527,
                25.731932
              ],
              [
                61.730774,
                25.732353
              ],
              [
                61.73099,
                25.73247
              ],
              [
                61.731096,
                25.732451
              ],
              [
                61.731253,
                25.732501
              ],
              [
                61.731225,
                25.732635
              ],
              [
                61.731256,
                25.732676
              ],
              [
                61.731631,
                25.73295
              ],
              [
                61.731785,
                25.732984
              ],
              [
                61.732073,
                25.733208
              ],
              [
                61.732422,
                25.733193
              ],
              [
                61.732727,
                25.73312
              ],
              [
                61.732975,
                25.733243
              ],
              [
                61.733063,
                25.733572
              ],
              [
                61.733062,
                25.733854
              ],
              [
                61.733368,
                25.734023
              ],
              [
                61.733173,
                25.734163
              ],
              [
                61.733085,
                25.734171
              ],
              [
                61.732971,
                25.734098
              ],
              [
                61.73283,
                25.734169
              ],
              [
                61.732837,
                25.734234
              ],
              [
                61.733314,
                25.735114
              ],
              [
                61.733231,
                25.735248
              ],
              [
                61.733114,
                25.735295
              ],
              [
                61.732917,
                25.735547
              ],
              [
                61.732793,
                25.735616
              ],
              [
                61.73277,
                25.735695
              ],
              [
                61.732597,
                25.735803
              ],
              [
                61.732601,
                25.735864
              ],
              [
                61.732513,
                25.735928
              ],
              [
                61.732377,
                25.73622
              ],
              [
                61.732393,
                25.736264
              ],
              [
                61.732286,
                25.736407
              ],
              [
                61.732307,
                25.736443
              ],
              [
                61.732231,
                25.736576
              ],
              [
                61.732147,
                25.736598
              ],
              [
                61.732159,
                25.736641
              ],
              [
                61.732074,
                25.736747
              ],
              [
                61.732117,
                25.736852
              ],
              [
                61.732217,
                25.736888
              ],
              [
                61.732265,
                25.736972
              ],
              [
                61.732384,
                25.736936
              ],
              [
                61.732543,
                25.737123
              ],
              [
                61.732299,
                25.737653
              ],
              [
                61.732383,
                25.737709
              ],
              [
                61.732666,
                25.737739
              ],
              [
                61.732729,
                25.737812
              ],
              [
                61.73285,
                25.737846
              ],
              [
                61.732911,
                25.73792
              ],
              [
                61.732924,
                25.738063
              ],
              [
                61.732953,
                25.738046
              ],
              [
                61.733181,
                25.738461
              ],
              [
                61.733184,
                25.738716
              ],
              [
                61.732914,
                25.738797
              ],
              [
                61.732937,
                25.738894
              ],
              [
                61.733005,
                25.73891
              ],
              [
                61.732953,
                25.73917
              ],
              [
                61.733031,
                25.739227
              ],
              [
                61.733057,
                25.739351
              ],
              [
                61.733037,
                25.739615
              ],
              [
                61.733396,
                25.739718
              ],
              [
                61.733538,
                25.739888
              ],
              [
                61.733591,
                25.739852
              ],
              [
                61.733704,
                25.739917
              ],
              [
                61.734151,
                25.739986
              ],
              [
                61.734199,
                25.740078
              ],
              [
                61.734159,
                25.740151
              ],
              [
                61.734424,
                25.740351
              ],
              [
                61.734632,
                25.740358
              ],
              [
                61.734703,
                25.74054
              ],
              [
                61.734635,
                25.740597
              ],
              [
                61.73493,
                25.740789
              ],
              [
                61.735241,
                25.740732
              ],
              [
                61.735558,
                25.740788
              ],
              [
                61.735989,
                25.740738
              ],
              [
                61.736041,
                25.740797
              ],
              [
                61.736238,
                25.741452
              ],
              [
                61.736104,
                25.741579
              ],
              [
                61.736299,
                25.741603
              ],
              [
                61.736329,
                25.74172
              ],
              [
                61.73651,
                25.74172
              ],
              [
                61.736912,
                25.741558
              ],
              [
                61.73752,
                25.741462
              ],
              [
                61.738262,
                25.74105
              ],
              [
                61.738537,
                25.741055
              ],
              [
                61.738961,
                25.740945
              ],
              [
                61.739425,
                25.740647
              ],
              [
                61.739436,
                25.740507
              ],
              [
                61.739569,
                25.740204
              ],
              [
                61.739955,
                25.740139
              ],
              [
                61.740151,
                25.739984
              ],
              [
                61.740202,
                25.739884
              ],
              [
                61.740464,
                25.739802
              ],
              [
                61.740663,
                25.739486
              ],
              [
                61.740858,
                25.739294
              ],
              [
                61.740888,
                25.739031
              ],
              [
                61.74106,
                25.738651
              ],
              [
                61.741665,
                25.738122
              ],
              [
                61.741567,
                25.737719
              ],
              [
                61.741619,
                25.737623
              ],
              [
                61.741602,
                25.737462
              ],
              [
                61.741669,
                25.737347
              ],
              [
                61.742133,
                25.737342
              ],
              [
                61.74236,
                25.737164
              ],
              [
                61.742593,
                25.737099
              ],
              [
                61.7426,
                25.737011
              ],
              [
                61.742827,
                25.737021
              ],
              [
                61.743258,
                25.736755
              ],
              [
                61.743314,
                25.736644
              ],
              [
                61.743524,
                25.736623
              ],
              [
                61.743622,
                25.736528
              ],
              [
                61.743642,
                25.736443
              ],
              [
                61.743988,
                25.736149
              ],
              [
                61.74397,
                25.736106
              ],
              [
                61.744019,
                25.736085
              ],
              [
                61.743991,
                25.735893
              ],
              [
                61.744049,
                25.735799
              ],
              [
                61.74399,
                25.735692
              ],
              [
                61.744199,
                25.735669
              ],
              [
                61.744204,
                25.735555
              ],
              [
                61.744337,
                25.735504
              ],
              [
                61.744394,
                25.735332
              ],
              [
                61.744527,
                25.73532
              ],
              [
                61.744557,
                25.735033
              ],
              [
                61.744461,
                25.734921
              ],
              [
                61.744458,
                25.734851
              ],
              [
                61.744541,
                25.734813
              ],
              [
                61.744564,
                25.73453
              ],
              [
                61.744665,
                25.734491
              ],
              [
                61.744649,
                25.734445
              ],
              [
                61.744868,
                25.734202
              ],
              [
                61.745013,
                25.733906
              ],
              [
                61.745459,
                25.733685
              ],
              [
                61.745594,
                25.73356
              ],
              [
                61.74567,
                25.733404
              ],
              [
                61.745841,
                25.733359
              ],
              [
                61.746151,
                25.733145
              ],
              [
                61.74638,
                25.733119
              ],
              [
                61.746553,
                25.733041
              ],
              [
                61.74662,
                25.733074
              ],
              [
                61.747177,
                25.733084
              ],
              [
                61.747533,
                25.733189
              ],
              [
                61.747587,
                25.73318
              ],
              [
                61.747588,
                25.733137
              ],
              [
                61.747748,
                25.733123
              ],
              [
                61.74777,
                25.733185
              ],
              [
                61.747821,
                25.733195
              ],
              [
                61.747902,
                25.733159
              ],
              [
                61.748101,
                25.733171
              ],
              [
                61.748097,
                25.73323
              ],
              [
                61.748183,
                25.733225
              ],
              [
                61.748288,
                25.733136
              ],
              [
                61.748339,
                25.73319
              ],
              [
                61.748438,
                25.733201
              ],
              [
                61.748692,
                25.732931
              ],
              [
                61.748759,
                25.732933
              ],
              [
                61.74883,
                25.732867
              ],
              [
                61.749006,
                25.73292
              ],
              [
                61.749143,
                25.732905
              ],
              [
                61.749502,
                25.732626
              ],
              [
                61.749553,
                25.732645
              ],
              [
                61.749626,
                25.73259
              ],
              [
                61.749819,
                25.73257
              ],
              [
                61.749968,
                25.732607
              ],
              [
                61.750143,
                25.73255
              ],
              [
                61.750446,
                25.732579
              ],
              [
                61.750685,
                25.73267
              ],
              [
                61.750777,
                25.732549
              ],
              [
                61.751025,
                25.732432
              ],
              [
                61.751469,
                25.73234
              ],
              [
                61.751666,
                25.732209
              ],
              [
                61.751861,
                25.732235
              ],
              [
                61.75196,
                25.732199
              ],
              [
                61.751998,
                25.73223
              ],
              [
                61.752097,
                25.732175
              ],
              [
                61.752316,
                25.73215
              ],
              [
                61.752336,
                25.732189
              ],
              [
                61.752426,
                25.732182
              ],
              [
                61.752443,
                25.732231
              ],
              [
                61.752534,
                25.732206
              ],
              [
                61.752884,
                25.732261
              ],
              [
                61.7534,
                25.732217
              ],
              [
                61.753536,
                25.732249
              ],
              [
                61.753695,
                25.732038
              ],
              [
                61.75385,
                25.731954
              ],
              [
                61.754404,
                25.731941
              ],
              [
                61.75463,
                25.731859
              ],
              [
                61.754755,
                25.731912
              ],
              [
                61.755065,
                25.731754
              ],
              [
                61.755575,
                25.731729
              ],
              [
                61.756044,
                25.731572
              ],
              [
                61.75621,
                25.73158
              ],
              [
                61.756337,
                25.731511
              ],
              [
                61.756674,
                25.731578
              ],
              [
                61.757073,
                25.731512
              ],
              [
                61.75716,
                25.7316
              ],
              [
                61.757289,
                25.731624
              ],
              [
                61.757788,
                25.731662
              ],
              [
                61.758105,
                25.73163
              ],
              [
                61.758213,
                25.731667
              ],
              [
                61.758376,
                25.731577
              ],
              [
                61.758708,
                25.731542
              ],
              [
                61.758705,
                25.731508
              ],
              [
                61.758889,
                25.731431
              ],
              [
                61.759162,
                25.731462
              ],
              [
                61.759346,
                25.73157
              ],
              [
                61.759462,
                25.731564
              ],
              [
                61.759884,
                25.731705
              ],
              [
                61.760106,
                25.731718
              ],
              [
                61.760518,
                25.731896
              ],
              [
                61.760685,
                25.732061
              ],
              [
                61.761009,
                25.731995
              ],
              [
                61.761073,
                25.732026
              ],
              [
                61.761168,
                25.731987
              ],
              [
                61.761295,
                25.732017
              ],
              [
                61.76144,
                25.731991
              ],
              [
                61.76168,
                25.732162
              ],
              [
                61.761876,
                25.732174
              ],
              [
                61.761883,
                25.732225
              ],
              [
                61.762126,
                25.732299
              ],
              [
                61.762075,
                25.732322
              ],
              [
                61.762073,
                25.732379
              ],
              [
                61.762229,
                25.732488
              ],
              [
                61.762391,
                25.732494
              ],
              [
                61.76269,
                25.732638
              ],
              [
                61.762696,
                25.732443
              ],
              [
                61.76276,
                25.732431
              ],
              [
                61.762775,
                25.732302
              ],
              [
                61.763149,
                25.732325
              ],
              [
                61.763143,
                25.732214
              ],
              [
                61.763282,
                25.732133
              ],
              [
                61.763551,
                25.732231
              ],
              [
                61.76374,
                25.732045
              ],
              [
                61.763739,
                25.731967
              ],
              [
                61.763879,
                25.732018
              ],
              [
                61.764012,
                25.73191
              ],
              [
                61.764225,
                25.731903
              ],
              [
                61.764289,
                25.731934
              ],
              [
                61.764294,
                25.732045
              ],
              [
                61.764376,
                25.732122
              ],
              [
                61.764579,
                25.732211
              ],
              [
                61.764567,
                25.732117
              ],
              [
                61.764649,
                25.732053
              ],
              [
                61.76468,
                25.731958
              ],
              [
                61.764996,
                25.731823
              ],
              [
                61.76519,
                25.731822
              ],
              [
                61.765195,
                25.731778
              ],
              [
                61.765262,
                25.73179
              ],
              [
                61.765332,
                25.731729
              ],
              [
                61.765519,
                25.73174
              ],
              [
                61.76594,
                25.731621
              ],
              [
                61.766254,
                25.731697
              ],
              [
                61.766414,
                25.731678
              ],
              [
                61.766471,
                25.731738
              ],
              [
                61.766632,
                25.731736
              ],
              [
                61.766793,
                25.731618
              ],
              [
                61.767369,
                25.731657
              ],
              [
                61.767392,
                25.7317
              ],
              [
                61.76749,
                25.731648
              ],
              [
                61.767847,
                25.731676
              ],
              [
                61.767902,
                25.731563
              ],
              [
                61.768047,
                25.731528
              ],
              [
                61.768073,
                25.731474
              ],
              [
                61.76827,
                25.731498
              ],
              [
                61.7685,
                25.731446
              ],
              [
                61.76872,
                25.731215
              ],
              [
                61.769078,
                25.731302
              ],
              [
                61.769373,
                25.73131
              ],
              [
                61.769617,
                25.731413
              ],
              [
                61.769854,
                25.731423
              ],
              [
                61.770097,
                25.731511
              ],
              [
                61.770558,
                25.73158
              ],
              [
                61.77091,
                25.73137
              ],
              [
                61.771153,
                25.731414
              ],
              [
                61.771403,
                25.7314
              ],
              [
                61.771459,
                25.731238
              ],
              [
                61.771909,
                25.731006
              ],
              [
                61.771914,
                25.731049
              ],
              [
                61.771991,
                25.731043
              ],
              [
                61.772022,
                25.731096
              ],
              [
                61.772246,
                25.731073
              ],
              [
                61.77228,
                25.73114
              ],
              [
                61.772382,
                25.731131
              ],
              [
                61.772524,
                25.73119
              ],
              [
                61.772727,
                25.73115
              ],
              [
                61.772811,
                25.731074
              ],
              [
                61.773027,
                25.730991
              ],
              [
                61.773153,
                25.730985
              ],
              [
                61.773416,
                25.73107
              ],
              [
                61.773729,
                25.731056
              ],
              [
                61.773723,
                25.730723
              ],
              [
                61.773778,
                25.730589
              ],
              [
                61.773686,
                25.730411
              ],
              [
                61.773724,
                25.730347
              ],
              [
                61.773608,
                25.730253
              ],
              [
                61.773678,
                25.73002
              ],
              [
                61.773859,
                25.729885
              ],
              [
                61.773836,
                25.729622
              ],
              [
                61.773714,
                25.72942
              ],
              [
                61.773669,
                25.729421
              ],
              [
                61.773682,
                25.729271
              ],
              [
                61.773444,
                25.729433
              ],
              [
                61.773319,
                25.729448
              ],
              [
                61.773248,
                25.729371
              ],
              [
                61.773094,
                25.729316
              ],
              [
                61.773021,
                25.729332
              ],
              [
                61.772991,
                25.729278
              ],
              [
                61.7729,
                25.729285
              ],
              [
                61.772916,
                25.729198
              ],
              [
                61.772761,
                25.729037
              ],
              [
                61.772769,
                25.728987
              ],
              [
                61.772693,
                25.729012
              ],
              [
                61.772326,
                25.728884
              ],
              [
                61.772291,
                25.728787
              ],
              [
                61.772323,
                25.728749
              ],
              [
                61.772192,
                25.728627
              ],
              [
                61.771989,
                25.728568
              ],
              [
                61.771882,
                25.728592
              ],
              [
                61.771797,
                25.728534
              ],
              [
                61.771396,
                25.728439
              ],
              [
                61.771553,
                25.728333
              ],
              [
                61.771528,
                25.7283
              ],
              [
                61.771382,
                25.728268
              ],
              [
                61.771224,
                25.728302
              ],
              [
                61.771155,
                25.728237
              ],
              [
                61.771032,
                25.728233
              ],
              [
                61.770698,
                25.728304
              ],
              [
                61.770681,
                25.728243
              ],
              [
                61.770492,
                25.72823
              ],
              [
                61.770594,
                25.728111
              ],
              [
                61.770622,
                25.727872
              ],
              [
                61.770912,
                25.727656
              ],
              [
                61.771571,
                25.727505
              ],
              [
                61.771805,
                25.727566
              ],
              [
                61.772003,
                25.727536
              ],
              [
                61.772346,
                25.727607
              ],
              [
                61.772644,
                25.72759
              ],
              [
                61.772745,
                25.72744
              ],
              [
                61.772881,
                25.727367
              ],
              [
                61.772965,
                25.727369
              ],
              [
                61.773344,
                25.727187
              ],
              [
                61.773479,
                25.727163
              ],
              [
                61.773517,
                25.727095
              ],
              [
                61.773608,
                25.727135
              ],
              [
                61.773752,
                25.727094
              ],
              [
                61.773809,
                25.726945
              ],
              [
                61.773944,
                25.726867
              ],
              [
                61.774052,
                25.726837
              ],
              [
                61.77443,
                25.726871
              ],
              [
                61.774653,
                25.72673
              ],
              [
                61.774827,
                25.72669
              ],
              [
                61.77486,
                25.726633
              ],
              [
                61.774646,
                25.726504
              ],
              [
                61.774415,
                25.726489
              ],
              [
                61.774467,
                25.726363
              ],
              [
                61.774431,
                25.726033
              ],
              [
                61.774929,
                25.725542
              ],
              [
                61.774983,
                25.725378
              ],
              [
                61.774907,
                25.725187
              ],
              [
                61.774991,
                25.725073
              ],
              [
                61.775195,
                25.72504
              ],
              [
                61.775195,
                25.724868
              ],
              [
                61.775336,
                25.724564
              ],
              [
                61.775346,
                25.72441
              ],
              [
                61.775532,
                25.724234
              ],
              [
                61.775778,
                25.724106
              ],
              [
                61.775966,
                25.72409
              ],
              [
                61.776181,
                25.724115
              ],
              [
                61.776415,
                25.724207
              ],
              [
                61.776522,
                25.724195
              ],
              [
                61.776703,
                25.724105
              ],
              [
                61.776765,
                25.723967
              ],
              [
                61.77704,
                25.723844
              ],
              [
                61.777427,
                25.723979
              ],
              [
                61.7776,
                25.723942
              ],
              [
                61.777702,
                25.72383
              ],
              [
                61.778032,
                25.723713
              ],
              [
                61.77837,
                25.723651
              ],
              [
                61.778577,
                25.723509
              ],
              [
                61.778595,
                25.723278
              ],
              [
                61.778665,
                25.723167
              ],
              [
                61.778612,
                25.723027
              ],
              [
                61.778822,
                25.722865
              ],
              [
                61.778796,
                25.722731
              ],
              [
                61.779281,
                25.722589
              ],
              [
                61.779518,
                25.722442
              ],
              [
                61.779685,
                25.722394
              ],
              [
                61.779788,
                25.722275
              ],
              [
                61.779953,
                25.722227
              ],
              [
                61.779976,
                25.722171
              ],
              [
                61.780204,
                25.722021
              ],
              [
                61.780278,
                25.72186
              ],
              [
                61.780398,
                25.721838
              ],
              [
                61.780604,
                25.721603
              ],
              [
                61.780677,
                25.721578
              ],
              [
                61.780684,
                25.721521
              ],
              [
                61.780882,
                25.721472
              ],
              [
                61.780981,
                25.721325
              ],
              [
                61.781226,
                25.721108
              ],
              [
                61.781467,
                25.721066
              ],
              [
                61.781553,
                25.721006
              ],
              [
                61.781628,
                25.721065
              ],
              [
                61.782232,
                25.721003
              ],
              [
                61.782387,
                25.721046
              ],
              [
                61.782541,
                25.721179
              ],
              [
                61.7827,
                25.721169
              ],
              [
                61.782761,
                25.721243
              ],
              [
                61.782979,
                25.721289
              ],
              [
                61.783264,
                25.721002
              ],
              [
                61.783568,
                25.720915
              ],
              [
                61.783644,
                25.720813
              ],
              [
                61.783902,
                25.720791
              ],
              [
                61.784335,
                25.720599
              ],
              [
                61.784545,
                25.720407
              ],
              [
                61.784671,
                25.720366
              ],
              [
                61.784898,
                25.720188
              ],
              [
                61.785058,
                25.719991
              ],
              [
                61.785555,
                25.719896
              ],
              [
                61.785743,
                25.71975
              ],
              [
                61.786133,
                25.719625
              ],
              [
                61.786268,
                25.719514
              ],
              [
                61.786395,
                25.719501
              ],
              [
                61.786466,
                25.719388
              ],
              [
                61.786713,
                25.719396
              ],
              [
                61.787027,
                25.719275
              ],
              [
                61.787036,
                25.719355
              ],
              [
                61.787262,
                25.719264
              ],
              [
                61.787386,
                25.719279
              ],
              [
                61.787367,
                25.719353
              ],
              [
                61.787458,
                25.71936
              ],
              [
                61.787646,
                25.719287
              ],
              [
                61.78844,
                25.719363
              ],
              [
                61.788702,
                25.719335
              ],
              [
                61.788805,
                25.719392
              ],
              [
                61.788963,
                25.7194
              ],
              [
                61.789492,
                25.719283
              ],
              [
                61.78951,
                25.719237
              ],
              [
                61.789791,
                25.719216
              ],
              [
                61.790808,
                25.71901
              ],
              [
                61.791098,
                25.719046
              ],
              [
                61.791222,
                25.718998
              ],
              [
                61.791412,
                25.719
              ],
              [
                61.791684,
                25.718908
              ],
              [
                61.79181,
                25.718946
              ],
              [
                61.792071,
                25.718816
              ],
              [
                61.792405,
                25.718822
              ],
              [
                61.792731,
                25.71896
              ],
              [
                61.792844,
                25.718951
              ],
              [
                61.792982,
                25.71903
              ],
              [
                61.793311,
                25.719035
              ],
              [
                61.793446,
                25.719077
              ],
              [
                61.793606,
                25.718997
              ],
              [
                61.793831,
                25.719021
              ],
              [
                61.794003,
                25.718979
              ],
              [
                61.794032,
                25.718908
              ],
              [
                61.794354,
                25.718886
              ],
              [
                61.79451,
                25.718659
              ],
              [
                61.794483,
                25.718357
              ],
              [
                61.794617,
                25.718329
              ],
              [
                61.794574,
                25.718221
              ],
              [
                61.794636,
                25.718081
              ],
              [
                61.795041,
                25.718054
              ],
              [
                61.795439,
                25.717963
              ],
              [
                61.796125,
                25.718036
              ],
              [
                61.796725,
                25.718001
              ],
              [
                61.797262,
                25.718035
              ],
              [
                61.797537,
                25.717965
              ],
              [
                61.798234,
                25.717887
              ],
              [
                61.798361,
                25.717907
              ],
              [
                61.798331,
                25.718236
              ],
              [
                61.798422,
                25.718459
              ],
              [
                61.798368,
                25.718558
              ],
              [
                61.798424,
                25.718707
              ],
              [
                61.798327,
                25.718806
              ],
              [
                61.798355,
                25.718947
              ],
              [
                61.798656,
                25.718924
              ],
              [
                61.79895,
                25.719241
              ],
              [
                61.799128,
                25.719868
              ],
              [
                61.799196,
                25.719877
              ],
              [
                61.799229,
                25.719961
              ],
              [
                61.799202,
                25.720144
              ],
              [
                61.799269,
                25.720219
              ],
              [
                61.799409,
                25.720154
              ],
              [
                61.799567,
                25.720314
              ],
              [
                61.799754,
                25.72034
              ],
              [
                61.79985,
                25.720433
              ],
              [
                61.799845,
                25.720539
              ],
              [
                61.799668,
                25.720648
              ],
              [
                61.799729,
                25.720701
              ],
              [
                61.79981,
                25.721111
              ],
              [
                61.79961,
                25.721292
              ],
              [
                61.799524,
                25.721539
              ],
              [
                61.799587,
                25.721565
              ],
              [
                61.799601,
                25.721626
              ],
              [
                61.799936,
                25.721769
              ],
              [
                61.799868,
                25.721983
              ],
              [
                61.799983,
                25.722125
              ],
              [
                61.80009,
                25.722072
              ],
              [
                61.800388,
                25.722226
              ],
              [
                61.800485,
                25.722228
              ],
              [
                61.80067,
                25.72209
              ],
              [
                61.80083,
                25.72215
              ],
              [
                61.800922,
                25.72228
              ],
              [
                61.801035,
                25.722281
              ],
              [
                61.80118,
                25.722237
              ],
              [
                61.80137,
                25.722053
              ],
              [
                61.801604,
                25.72204
              ],
              [
                61.801989,
                25.721882
              ],
              [
                61.802046,
                25.721995
              ],
              [
                61.802227,
                25.722061
              ],
              [
                61.802542,
                25.722019
              ],
              [
                61.802607,
                25.721935
              ],
              [
                61.802838,
                25.721984
              ],
              [
                61.803516,
                25.721923
              ],
              [
                61.803948,
                25.722095
              ],
              [
                61.803997,
                25.722185
              ],
              [
                61.804103,
                25.722236
              ],
              [
                61.804421,
                25.722185
              ],
              [
                61.804726,
                25.722244
              ],
              [
                61.804939,
                25.722345
              ],
              [
                61.805125,
                25.722344
              ],
              [
                61.805097,
                25.722748
              ],
              [
                61.805158,
                25.72292
              ],
              [
                61.805237,
                25.72293
              ],
              [
                61.805231,
                25.723004
              ],
              [
                61.805022,
                25.723064
              ],
              [
                61.804993,
                25.723283
              ],
              [
                61.805054,
                25.723359
              ],
              [
                61.805212,
                25.723392
              ],
              [
                61.805194,
                25.723477
              ],
              [
                61.805317,
                25.723477
              ],
              [
                61.805281,
                25.723619
              ],
              [
                61.80517,
                25.72369
              ],
              [
                61.805223,
                25.723753
              ],
              [
                61.805368,
                25.723761
              ],
              [
                61.805255,
                25.723903
              ],
              [
                61.805118,
                25.723917
              ],
              [
                61.804953,
                25.724052
              ],
              [
                61.805053,
                25.724173
              ],
              [
                61.805013,
                25.724339
              ],
              [
                61.804907,
                25.724391
              ],
              [
                61.805079,
                25.724501
              ],
              [
                61.805127,
                25.724598
              ],
              [
                61.805392,
                25.724596
              ],
              [
                61.805472,
                25.724652
              ],
              [
                61.805671,
                25.724982
              ],
              [
                61.805746,
                25.725235
              ],
              [
                61.805874,
                25.725236
              ],
              [
                61.805977,
                25.725391
              ],
              [
                61.806121,
                25.725493
              ],
              [
                61.806142,
                25.72558
              ],
              [
                61.806246,
                25.725632
              ],
              [
                61.80631,
                25.725919
              ],
              [
                61.806464,
                25.72618
              ],
              [
                61.806511,
                25.726315
              ],
              [
                61.806462,
                25.726434
              ],
              [
                61.806357,
                25.72664
              ],
              [
                61.806126,
                25.726909
              ],
              [
                61.806136,
                25.727008
              ],
              [
                61.80621,
                25.727095
              ],
              [
                61.806055,
                25.727306
              ],
              [
                61.805884,
                25.727425
              ],
              [
                61.805849,
                25.727527
              ],
              [
                61.806084,
                25.727833
              ],
              [
                61.806208,
                25.728177
              ],
              [
                61.806142,
                25.728297
              ],
              [
                61.806179,
                25.728401
              ],
              [
                61.806076,
                25.728606
              ],
              [
                61.806345,
                25.728683
              ],
              [
                61.806413,
                25.728746
              ],
              [
                61.806486,
                25.728914
              ],
              [
                61.806541,
                25.728932
              ],
              [
                61.806541,
                25.729148
              ],
              [
                61.806711,
                25.729404
              ],
              [
                61.806572,
                25.729403
              ],
              [
                61.806553,
                25.729463
              ],
              [
                61.806482,
                25.729487
              ],
              [
                61.806385,
                25.729708
              ],
              [
                61.806112,
                25.729763
              ],
              [
                61.806168,
                25.729857
              ],
              [
                61.806117,
                25.729969
              ],
              [
                61.80608,
                25.730008
              ],
              [
                61.805882,
                25.730001
              ],
              [
                61.805734,
                25.73022
              ],
              [
                61.805636,
                25.730436
              ],
              [
                61.805667,
                25.730806
              ],
              [
                61.805561,
                25.730968
              ],
              [
                61.805533,
                25.731121
              ],
              [
                61.80562,
                25.731216
              ],
              [
                61.805395,
                25.731389
              ],
              [
                61.805443,
                25.731665
              ],
              [
                61.805419,
                25.731805
              ],
              [
                61.80563,
                25.73192
              ],
              [
                61.806145,
                25.731792
              ],
              [
                61.806191,
                25.731873
              ],
              [
                61.806464,
                25.73201
              ],
              [
                61.806828,
                25.731906
              ],
              [
                61.806858,
                25.731837
              ],
              [
                61.807327,
                25.731766
              ],
              [
                61.807539,
                25.731855
              ],
              [
                61.80747,
                25.732151
              ],
              [
                61.807598,
                25.732368
              ],
              [
                61.808077,
                25.732384
              ],
              [
                61.808159,
                25.732351
              ],
              [
                61.80819,
                25.732268
              ],
              [
                61.808411,
                25.732196
              ],
              [
                61.808546,
                25.732421
              ],
              [
                61.808485,
                25.73261
              ],
              [
                61.80877,
                25.732801
              ],
              [
                61.808842,
                25.733018
              ],
              [
                61.80894,
                25.733057
              ],
              [
                61.808958,
                25.733186
              ],
              [
                61.808896,
                25.73337
              ],
              [
                61.808667,
                25.733504
              ],
              [
                61.808692,
                25.733589
              ],
              [
                61.808653,
                25.733676
              ],
              [
                61.808749,
                25.733802
              ],
              [
                61.808694,
                25.733936
              ],
              [
                61.808723,
                25.73406
              ],
              [
                61.80866,
                25.734127
              ],
              [
                61.808704,
                25.734274
              ],
              [
                61.808825,
                25.734419
              ],
              [
                61.808845,
                25.734592
              ],
              [
                61.808805,
                25.734714
              ],
              [
                61.80895,
                25.734963
              ],
              [
                61.808691,
                25.735034
              ],
              [
                61.808457,
                25.735008
              ],
              [
                61.808256,
                25.735109
              ],
              [
                61.808111,
                25.735101
              ],
              [
                61.807957,
                25.735033
              ],
              [
                61.807522,
                25.735116
              ],
              [
                61.807436,
                25.735221
              ],
              [
                61.807373,
                25.735814
              ],
              [
                61.807245,
                25.735909
              ],
              [
                61.807037,
                25.736516
              ],
              [
                61.807191,
                25.736575
              ],
              [
                61.807466,
                25.736942
              ],
              [
                61.807474,
                25.737032
              ],
              [
                61.807547,
                25.736993
              ],
              [
                61.80765,
                25.737006
              ],
              [
                61.807979,
                25.737133
              ],
              [
                61.807956,
                25.737287
              ],
              [
                61.808049,
                25.73728
              ],
              [
                61.808354,
                25.737414
              ],
              [
                61.808649,
                25.737737
              ],
              [
                61.808635,
                25.737828
              ],
              [
                61.808565,
                25.73789
              ],
              [
                61.808829,
                25.73798
              ],
              [
                61.809152,
                25.738181
              ],
              [
                61.809354,
                25.738173
              ],
              [
                61.809429,
                25.73823
              ],
              [
                61.809681,
                25.738249
              ],
              [
                61.810249,
                25.738512
              ],
              [
                61.81038,
                25.738407
              ],
              [
                61.810587,
                25.738342
              ],
              [
                61.810606,
                25.738245
              ],
              [
                61.810676,
                25.738186
              ],
              [
                61.810969,
                25.738137
              ],
              [
                61.811427,
                25.738161
              ],
              [
                61.811925,
                25.738317
              ],
              [
                61.812134,
                25.738325
              ],
              [
                61.812145,
                25.738382
              ],
              [
                61.812369,
                25.738518
              ],
              [
                61.812564,
                25.738533
              ],
              [
                61.812764,
                25.738406
              ],
              [
                61.813535,
                25.738392
              ],
              [
                61.813853,
                25.738014
              ],
              [
                61.814065,
                25.738066
              ],
              [
                61.81421,
                25.738043
              ],
              [
                61.814344,
                25.738101
              ],
              [
                61.81463,
                25.738091
              ],
              [
                61.81485,
                25.738258
              ],
              [
                61.814924,
                25.73843
              ],
              [
                61.814891,
                25.738528
              ],
              [
                61.815135,
                25.738729
              ],
              [
                61.815152,
                25.738859
              ],
              [
                61.815402,
                25.738843
              ],
              [
                61.815566,
                25.738922
              ],
              [
                61.815789,
                25.738841
              ],
              [
                61.816181,
                25.738896
              ],
              [
                61.816349,
                25.738807
              ],
              [
                61.816701,
                25.738814
              ],
              [
                61.816982,
                25.73898
              ],
              [
                61.817112,
                25.739219
              ],
              [
                61.817378,
                25.739381
              ],
              [
                61.818191,
                25.739263
              ],
              [
                61.818347,
                25.739395
              ],
              [
                61.81844,
                25.739388
              ],
              [
                61.81855,
                25.739477
              ],
              [
                61.818713,
                25.739497
              ],
              [
                61.818875,
                25.739436
              ],
              [
                61.818951,
                25.739357
              ],
              [
                61.819055,
                25.739341
              ],
              [
                61.819494,
                25.73935
              ],
              [
                61.819736,
                25.739455
              ],
              [
                61.819948,
                25.73938
              ],
              [
                61.820139,
                25.739398
              ],
              [
                61.820309,
                25.739471
              ],
              [
                61.820617,
                25.7394
              ],
              [
                61.82102,
                25.739439
              ],
              [
                61.821186,
                25.739387
              ],
              [
                61.821452,
                25.739417
              ],
              [
                61.82176,
                25.739335
              ],
              [
                61.821891,
                25.739426
              ],
              [
                61.822247,
                25.739441
              ],
              [
                61.822311,
                25.739528
              ],
              [
                61.822745,
                25.739646
              ],
              [
                61.823004,
                25.739629
              ],
              [
                61.823296,
                25.739523
              ],
              [
                61.823772,
                25.740255
              ],
              [
                61.823967,
                25.740456
              ],
              [
                61.82431,
                25.740536
              ],
              [
                61.824543,
                25.740724
              ],
              [
                61.824705,
                25.740773
              ],
              [
                61.82471,
                25.740911
              ],
              [
                61.824811,
                25.741038
              ],
              [
                61.82483,
                25.741314
              ],
              [
                61.824987,
                25.741397
              ],
              [
                61.825062,
                25.74155
              ],
              [
                61.825391,
                25.74178
              ],
              [
                61.82562,
                25.741787
              ],
              [
                61.825611,
                25.742065
              ],
              [
                61.825685,
                25.742247
              ],
              [
                61.825801,
                25.742461
              ],
              [
                61.825967,
                25.742568
              ],
              [
                61.826022,
                25.742739
              ],
              [
                61.826102,
                25.74271
              ],
              [
                61.826243,
                25.742854
              ],
              [
                61.826457,
                25.742906
              ],
              [
                61.826787,
                25.742862
              ],
              [
                61.827323,
                25.743285
              ],
              [
                61.827669,
                25.743433
              ],
              [
                61.828174,
                25.743482
              ],
              [
                61.828391,
                25.74358
              ],
              [
                61.828684,
                25.743564
              ],
              [
                61.828785,
                25.743515
              ],
              [
                61.82901,
                25.74359
              ],
              [
                61.840067,
                25.74484
              ],
              [
                61.84325,
                25.760278
              ],
              [
                61.837583,
                25.762889
              ],
              [
                61.842071,
                25.781864
              ],
              [
                61.841903,
                25.781763
              ],
              [
                61.841368,
                25.781775
              ],
              [
                61.841197,
                25.781815
              ],
              [
                61.841065,
                25.781746
              ],
              [
                61.840907,
                25.781726
              ],
              [
                61.840691,
                25.781751
              ],
              [
                61.840375,
                25.781583
              ],
              [
                61.840291,
                25.781581
              ],
              [
                61.840139,
                25.781606
              ],
              [
                61.839987,
                25.781736
              ],
              [
                61.840011,
                25.781764
              ],
              [
                61.839781,
                25.781805
              ],
              [
                61.839603,
                25.781888
              ],
              [
                61.83933,
                25.782108
              ],
              [
                61.839136,
                25.782157
              ],
              [
                61.838946,
                25.782017
              ],
              [
                61.838838,
                25.782053
              ],
              [
                61.838687,
                25.782207
              ],
              [
                61.838212,
                25.782455
              ],
              [
                61.837705,
                25.782845
              ],
              [
                61.837716,
                25.782889
              ],
              [
                61.837496,
                25.783107
              ],
              [
                61.837479,
                25.783254
              ],
              [
                61.837324,
                25.78333
              ],
              [
                61.837376,
                25.783488
              ],
              [
                61.837273,
                25.783636
              ],
              [
                61.837361,
                25.783739
              ],
              [
                61.837305,
                25.783763
              ],
              [
                61.837327,
                25.783898
              ],
              [
                61.837171,
                25.784
              ],
              [
                61.837211,
                25.784169
              ],
              [
                61.83705,
                25.78429
              ],
              [
                61.837109,
                25.784426
              ],
              [
                61.83708,
                25.784473
              ],
              [
                61.837143,
                25.784765
              ],
              [
                61.837071,
                25.784864
              ],
              [
                61.837144,
                25.785002
              ],
              [
                61.83696,
                25.785174
              ],
              [
                61.83676,
                25.785216
              ],
              [
                61.836735,
                25.785265
              ],
              [
                61.836374,
                25.785439
              ],
              [
                61.836332,
                25.785636
              ],
              [
                61.836402,
                25.785684
              ],
              [
                61.836381,
                25.785876
              ],
              [
                61.836271,
                25.786039
              ],
              [
                61.836261,
                25.786152
              ],
              [
                61.836389,
                25.786389
              ],
              [
                61.836368,
                25.786448
              ],
              [
                61.836294,
                25.786478
              ],
              [
                61.836328,
                25.786729
              ],
              [
                61.836813,
                25.786976
              ],
              [
                61.83722,
                25.786993
              ],
              [
                61.837379,
                25.787053
              ],
              [
                61.837553,
                25.787045
              ],
              [
                61.837887,
                25.787124
              ],
              [
                61.837997,
                25.787526
              ],
              [
                61.837963,
                25.78778
              ],
              [
                61.837836,
                25.787961
              ],
              [
                61.837999,
                25.788078
              ],
              [
                61.83823,
                25.788159
              ],
              [
                61.838254,
                25.788217
              ],
              [
                61.838556,
                25.788286
              ],
              [
                61.839011,
                25.788267
              ],
              [
                61.839003,
                25.788746
              ],
              [
                61.839104,
                25.788754
              ],
              [
                61.839164,
                25.788863
              ],
              [
                61.839107,
                25.788915
              ],
              [
                61.839122,
                25.788966
              ],
              [
                61.838819,
                25.789041
              ],
              [
                61.838749,
                25.789121
              ],
              [
                61.838756,
                25.789182
              ],
              [
                61.838875,
                25.789226
              ],
              [
                61.838826,
                25.789397
              ],
              [
                61.83871,
                25.78951
              ],
              [
                61.838758,
                25.789736
              ],
              [
                61.83886,
                25.789792
              ],
              [
                61.83888,
                25.789876
              ],
              [
                61.838811,
                25.790176
              ],
              [
                61.838846,
                25.790304
              ],
              [
                61.838761,
                25.790479
              ],
              [
                61.83885,
                25.79051
              ],
              [
                61.838873,
                25.790587
              ],
              [
                61.838418,
                25.79056
              ],
              [
                61.838144,
                25.790676
              ],
              [
                61.837793,
                25.790641
              ],
              [
                61.837565,
                25.790668
              ],
              [
                61.837408,
                25.790817
              ],
              [
                61.836985,
                25.791013
              ],
              [
                61.836866,
                25.791114
              ],
              [
                61.836657,
                25.791077
              ],
              [
                61.836411,
                25.790889
              ],
              [
                61.836302,
                25.790911
              ],
              [
                61.836232,
                25.791311
              ],
              [
                61.836024,
                25.791487
              ],
              [
                61.835973,
                25.791753
              ],
              [
                61.836015,
                25.791783
              ],
              [
                61.835962,
                25.791841
              ],
              [
                61.835966,
                25.791899
              ],
              [
                61.836045,
                25.791942
              ],
              [
                61.835963,
                25.791992
              ],
              [
                61.83595,
                25.792103
              ],
              [
                61.835792,
                25.792155
              ],
              [
                61.835734,
                25.792202
              ],
              [
                61.835781,
                25.792235
              ],
              [
                61.835604,
                25.792328
              ],
              [
                61.835673,
                25.792471
              ],
              [
                61.835785,
                25.792501
              ],
              [
                61.835828,
                25.7926
              ],
              [
                61.835943,
                25.792637
              ],
              [
                61.835998,
                25.792713
              ],
              [
                61.835988,
                25.792764
              ],
              [
                61.835866,
                25.792823
              ],
              [
                61.835788,
                25.793203
              ],
              [
                61.836084,
                25.793273
              ],
              [
                61.836182,
                25.793411
              ],
              [
                61.836301,
                25.793401
              ],
              [
                61.836367,
                25.793438
              ],
              [
                61.836394,
                25.793542
              ],
              [
                61.836475,
                25.793606
              ],
              [
                61.83636,
                25.793622
              ],
              [
                61.836326,
                25.793652
              ],
              [
                61.836408,
                25.793706
              ],
              [
                61.836281,
                25.793736
              ],
              [
                61.836404,
                25.794046
              ],
              [
                61.836567,
                25.794193
              ],
              [
                61.836649,
                25.794122
              ],
              [
                61.836735,
                25.794139
              ],
              [
                61.836769,
                25.794319
              ],
              [
                61.836875,
                25.794388
              ],
              [
                61.836847,
                25.794448
              ],
              [
                61.836924,
                25.794439
              ],
              [
                61.83704,
                25.794534
              ],
              [
                61.836961,
                25.79463
              ],
              [
                61.836844,
                25.794632
              ],
              [
                61.83671,
                25.79461
              ],
              [
                61.836663,
                25.794535
              ],
              [
                61.836601,
                25.794564
              ],
              [
                61.836451,
                25.794505
              ],
              [
                61.836513,
                25.794622
              ],
              [
                61.836468,
                25.794651
              ],
              [
                61.836483,
                25.794725
              ],
              [
                61.836366,
                25.794746
              ],
              [
                61.836361,
                25.79483
              ],
              [
                61.836483,
                25.79491
              ],
              [
                61.836591,
                25.795037
              ],
              [
                61.836587,
                25.795121
              ],
              [
                61.836682,
                25.795192
              ],
              [
                61.836641,
                25.795269
              ],
              [
                61.836584,
                25.79527
              ],
              [
                61.836376,
                25.79543
              ],
              [
                61.836514,
                25.795544
              ],
              [
                61.836257,
                25.795586
              ],
              [
                61.836177,
                25.79608
              ],
              [
                61.835963,
                25.796587
              ],
              [
                61.836108,
                25.796741
              ],
              [
                61.836042,
                25.796774
              ],
              [
                61.836084,
                25.796818
              ],
              [
                61.836215,
                25.796806
              ],
              [
                61.836229,
                25.796854
              ],
              [
                61.836156,
                25.796923
              ],
              [
                61.836225,
                25.797047
              ],
              [
                61.83618,
                25.797192
              ],
              [
                61.836313,
                25.797421
              ],
              [
                61.836516,
                25.797561
              ],
              [
                61.836717,
                25.797636
              ],
              [
                61.836807,
                25.79762
              ],
              [
                61.8368,
                25.797726
              ],
              [
                61.836889,
                25.79777
              ],
              [
                61.836574,
                25.79794
              ],
              [
                61.836583,
                25.79801
              ],
              [
                61.83648,
                25.798168
              ],
              [
                61.836394,
                25.79819
              ],
              [
                61.836312,
                25.798325
              ],
              [
                61.836384,
                25.79838
              ],
              [
                61.836235,
                25.798511
              ],
              [
                61.836337,
                25.798546
              ],
              [
                61.836392,
                25.798663
              ],
              [
                61.836739,
                25.798743
              ],
              [
                61.837032,
                25.799335
              ],
              [
                61.837079,
                25.799345
              ],
              [
                61.837146,
                25.799504
              ],
              [
                61.837129,
                25.79957
              ],
              [
                61.837304,
                25.799631
              ],
              [
                61.837367,
                25.799708
              ],
              [
                61.837629,
                25.799731
              ],
              [
                61.83788,
                25.799679
              ],
              [
                61.837908,
                25.799609
              ],
              [
                61.838045,
                25.799582
              ],
              [
                61.838076,
                25.799537
              ],
              [
                61.838652,
                25.799424
              ],
              [
                61.838878,
                25.799266
              ],
              [
                61.838946,
                25.799126
              ],
              [
                61.839258,
                25.799017
              ],
              [
                61.839335,
                25.798952
              ],
              [
                61.839621,
                25.798931
              ],
              [
                61.839679,
                25.79902
              ],
              [
                61.839869,
                25.799051
              ],
              [
                61.840254,
                25.799021
              ],
              [
                61.840412,
                25.798898
              ],
              [
                61.840816,
                25.798863
              ],
              [
                61.841025,
                25.798777
              ],
              [
                61.841244,
                25.798781
              ],
              [
                61.841278,
                25.79872
              ],
              [
                61.841757,
                25.798502
              ],
              [
                61.8418,
                25.798494
              ],
              [
                61.84182,
                25.798569
              ],
              [
                61.84196,
                25.79866
              ],
              [
                61.842088,
                25.798669
              ],
              [
                61.842344,
                25.798563
              ],
              [
                61.842568,
                25.798572
              ],
              [
                61.842941,
                25.798364
              ],
              [
                61.843086,
                25.798498
              ],
              [
                61.843101,
                25.798667
              ],
              [
                61.843335,
                25.798804
              ],
              [
                61.843349,
                25.798871
              ],
              [
                61.843489,
                25.798962
              ],
              [
                61.843625,
                25.798963
              ],
              [
                61.843706,
                25.79912
              ],
              [
                61.843912,
                25.799238
              ],
              [
                61.843946,
                25.799353
              ],
              [
                61.844098,
                25.799515
              ],
              [
                61.844219,
                25.799575
              ],
              [
                61.844247,
                25.799811
              ],
              [
                61.844301,
                25.799859
              ],
              [
                61.844324,
                25.800082
              ],
              [
                61.844367,
                25.800107
              ],
              [
                61.844338,
                25.800154
              ],
              [
                61.844424,
                25.800194
              ],
              [
                61.844439,
                25.800268
              ],
              [
                61.844707,
                25.800401
              ],
              [
                61.844817,
                25.800407
              ],
              [
                61.844814,
                25.800655
              ],
              [
                61.84492,
                25.800843
              ],
              [
                61.844933,
                25.800979
              ],
              [
                61.844773,
                25.801182
              ],
              [
                61.844816,
                25.801225
              ],
              [
                61.844787,
                25.801428
              ],
              [
                61.844688,
                25.801675
              ],
              [
                61.844657,
                25.801975
              ],
              [
                61.844688,
                25.802178
              ],
              [
                61.844972,
                25.802261
              ],
              [
                61.845079,
                25.802455
              ],
              [
                61.845108,
                25.802735
              ],
              [
                61.845223,
                25.802866
              ],
              [
                61.84559,
                25.803113
              ],
              [
                61.845814,
                25.803123
              ],
              [
                61.845966,
                25.803252
              ],
              [
                61.846209,
                25.80334
              ],
              [
                61.846596,
                25.803602
              ],
              [
                61.84681,
                25.803965
              ],
              [
                61.846831,
                25.804149
              ],
              [
                61.846759,
                25.804313
              ],
              [
                61.846793,
                25.80449
              ],
              [
                61.846861,
                25.804515
              ],
              [
                61.84689,
                25.804616
              ],
              [
                61.847192,
                25.804903
              ],
              [
                61.847176,
                25.805063
              ],
              [
                61.846902,
                25.805219
              ],
              [
                61.8468,
                25.805416
              ],
              [
                61.846668,
                25.805546
              ],
              [
                61.846788,
                25.805585
              ],
              [
                61.846818,
                25.805848
              ],
              [
                61.846902,
                25.806065
              ],
              [
                61.84681,
                25.806346
              ],
              [
                61.846849,
                25.806448
              ],
              [
                61.846811,
                25.806485
              ],
              [
                61.846815,
                25.806619
              ],
              [
                61.846733,
                25.806647
              ],
              [
                61.846929,
                25.807213
              ],
              [
                61.846869,
                25.80739
              ],
              [
                61.846789,
                25.807553
              ],
              [
                61.846608,
                25.80765
              ],
              [
                61.846491,
                25.807771
              ],
              [
                61.846336,
                25.807857
              ],
              [
                61.846137,
                25.807871
              ],
              [
                61.846316,
                25.808002
              ],
              [
                61.84639,
                25.808204
              ],
              [
                61.846378,
                25.808278
              ],
              [
                61.846231,
                25.808374
              ],
              [
                61.846265,
                25.808581
              ],
              [
                61.846512,
                25.808521
              ],
              [
                61.846547,
                25.808575
              ],
              [
                61.846829,
                25.808587
              ],
              [
                61.84684,
                25.808647
              ],
              [
                61.846757,
                25.808729
              ],
              [
                61.84675,
                25.808807
              ],
              [
                61.846599,
                25.808857
              ],
              [
                61.84665,
                25.808915
              ],
              [
                61.8466,
                25.808987
              ],
              [
                61.846686,
                25.80912
              ],
              [
                61.846613,
                25.809177
              ],
              [
                61.846699,
                25.809438
              ],
              [
                61.846913,
                25.809735
              ],
              [
                61.846649,
                25.80978
              ],
              [
                61.846545,
                25.809933
              ],
              [
                61.846596,
                25.810379
              ],
              [
                61.846666,
                25.810572
              ],
              [
                61.846798,
                25.810732
              ],
              [
                61.84679,
                25.810889
              ],
              [
                61.846668,
                25.810936
              ],
              [
                61.846516,
                25.81116
              ],
              [
                61.846437,
                25.811165
              ],
              [
                61.846427,
                25.81125
              ],
              [
                61.846111,
                25.811449
              ],
              [
                61.845961,
                25.811492
              ],
              [
                61.845863,
                25.811662
              ],
              [
                61.845873,
                25.811881
              ],
              [
                61.845759,
                25.811952
              ],
              [
                61.845912,
                25.812133
              ],
              [
                61.845859,
                25.812187
              ],
              [
                61.845925,
                25.812344
              ],
              [
                61.845886,
                25.812419
              ],
              [
                61.845759,
                25.812467
              ],
              [
                61.845704,
                25.812588
              ],
              [
                61.845793,
                25.812797
              ],
              [
                61.846067,
                25.813017
              ],
              [
                61.846138,
                25.813192
              ],
              [
                61.846075,
                25.813342
              ],
              [
                61.84589,
                25.813352
              ],
              [
                61.845906,
                25.813412
              ],
              [
                61.845808,
                25.813561
              ],
              [
                61.84578,
                25.813713
              ],
              [
                61.845909,
                25.813852
              ],
              [
                61.846096,
                25.813946
              ],
              [
                61.846134,
                25.814291
              ],
              [
                61.846319,
                25.814386
              ],
              [
                61.846258,
                25.814408
              ],
              [
                61.846251,
                25.814486
              ],
              [
                61.846383,
                25.814502
              ],
              [
                61.846522,
                25.81485
              ],
              [
                61.846703,
                25.815112
              ],
              [
                61.846724,
                25.815264
              ],
              [
                61.847332,
                25.815175
              ],
              [
                61.847797,
                25.815277
              ],
              [
                61.848113,
                25.815242
              ],
              [
                61.848266,
                25.815161
              ],
              [
                61.84849,
                25.8152
              ],
              [
                61.84883,
                25.815345
              ],
              [
                61.849085,
                25.81535
              ],
              [
                61.849423,
                25.815441
              ],
              [
                61.84955,
                25.815531
              ],
              [
                61.849873,
                25.815541
              ],
              [
                61.849988,
                25.815631
              ],
              [
                61.85002,
                25.815725
              ],
              [
                61.850305,
                25.815929
              ],
              [
                61.850403,
                25.816143
              ],
              [
                61.851069,
                25.81633
              ],
              [
                61.851426,
                25.816329
              ],
              [
                61.851539,
                25.816431
              ],
              [
                61.851304,
                25.816626
              ],
              [
                61.851198,
                25.817077
              ],
              [
                61.851104,
                25.817086
              ],
              [
                61.850997,
                25.817166
              ],
              [
                61.85099,
                25.817251
              ],
              [
                61.850863,
                25.817359
              ],
              [
                61.8506,
                25.817439
              ],
              [
                61.850442,
                25.817643
              ],
              [
                61.85055,
                25.818092
              ],
              [
                61.850537,
                25.818236
              ],
              [
                61.850051,
                25.818539
              ],
              [
                61.849755,
                25.81881
              ],
              [
                61.849299,
                25.818977
              ],
              [
                61.849036,
                25.818983
              ],
              [
                61.849011,
                25.819098
              ],
              [
                61.84894,
                25.819162
              ],
              [
                61.849067,
                25.819302
              ],
              [
                61.849097,
                25.819419
              ],
              [
                61.849035,
                25.819416
              ],
              [
                61.848948,
                25.819541
              ],
              [
                61.849392,
                25.819635
              ],
              [
                61.84935,
                25.819851
              ],
              [
                61.849188,
                25.81991
              ],
              [
                61.849137,
                25.820151
              ],
              [
                61.849065,
                25.820243
              ],
              [
                61.848797,
                25.820259
              ],
              [
                61.848778,
                25.820429
              ],
              [
                61.848558,
                25.820728
              ],
              [
                61.848388,
                25.820865
              ],
              [
                61.84835,
                25.820967
              ],
              [
                61.848396,
                25.821212
              ],
              [
                61.848534,
                25.821275
              ],
              [
                61.848451,
                25.821447
              ],
              [
                61.848539,
                25.821506
              ],
              [
                61.848552,
                25.821675
              ],
              [
                61.848771,
                25.821787
              ],
              [
                61.848764,
                25.821978
              ],
              [
                61.848895,
                25.822397
              ],
              [
                61.8484221,
                25.8222423
              ],
              [
                61.8450492,
                25.8208637
              ],
              [
                61.8436632,
                25.8203076
              ],
              [
                61.841996,
                25.8203076
              ],
              [
                61.841996,
                25.8200295
              ],
              [
                61.8406092,
                25.8200295
              ],
              [
                61.8256098,
                25.8150244
              ],
              [
                61.8067165,
                25.8122528
              ],
              [
                61.8058836,
                25.8119658
              ],
              [
                61.8031032,
                25.8119658
              ],
              [
                61.7897701,
                25.8103065
              ],
              [
                61.7869974,
                25.8103065
              ],
              [
                61.7819903,
                25.8097504
              ],
              [
                61.7708839,
                25.8097505
              ],
              [
                61.770051,
                25.8094724
              ],
              [
                61.7683839,
                25.8097505
              ],
              [
                61.7622713,
                25.8097504
              ],
              [
                61.7564375,
                25.8105847
              ],
              [
                61.7553242,
                25.8105847
              ],
              [
                61.7536578,
                25.8111408
              ],
              [
                61.7517179,
                25.8114188
              ],
              [
                61.727545,
                25.8200298
              ],
              [
                61.7256051,
                25.8211332
              ],
              [
                61.7244918,
                25.8214202
              ],
              [
                61.7053251,
                25.8350275
              ],
              [
                61.6630996,
                25.8797454
              ],
              [
                61.6600464,
                25.8830825
              ],
              [
                61.6268672,
                25.950909
              ],
              [
                61.5510976,
                25.9592746
              ],
              [
                61.4025875,
                25.9605144
              ],
              [
                61.3036392,
                25.910858
              ],
              [
                61.3030853,
                25.9111451
              ],
              [
                61.3022524,
                25.9111451
              ],
              [
                61.3022524,
                25.9108581
              ],
              [
                61.3026087,
                25.8180678
              ],
              [
                61.3010912,
                25.7982885
              ],
              [
                61.2722521,
                25.719194
              ],
              [
                61.2736388,
                25.7144679
              ],
              [
                61.274192,
                25.7139209
              ],
              [
                61.2797521,
                25.6814133
              ],
              [
                61.2803052,
                25.6744637
              ],
              [
                61.2819717,
                25.6678012
              ],
              [
                61.2822521,
                25.6647434
              ],
              [
                61.2819716,
                25.6630845
              ],
              [
                61.2816919,
                25.6608607
              ],
              [
                61.2814185,
                25.6600268
              ],
              [
                61.2814184,
                25.6572471
              ],
              [
                61.2814184,
                25.6555792
              ],
              [
                61.2811388,
                25.6516877
              ],
              [
                61.2808582,
                25.6511317
              ],
              [
                61.2805848,
                25.6377984
              ],
              [
                61.2808582,
                25.6364175
              ],
              [
                61.282252,
                25.6228066
              ],
              [
                61.2822519,
                25.619749
              ],
              [
                61.280305,
                25.6100298
              ],
              [
                61.2797519,
                25.6075283
              ],
              [
                61.2786386,
                25.6003018
              ],
              [
                61.2780846,
                25.5961327
              ],
              [
                61.2728048,
                25.5825229
              ],
              [
                61.2722516,
                25.581967
              ],
              [
                61.2716915,
                25.5808553
              ],
              [
                61.2650249,
                25.574194
              ],
              [
                61.2641914,
                25.5739072
              ],
              [
                61.2489121,
                25.5616876
              ],
              [
                61.2364118,
                25.541409
              ],
              [
                61.2322453,
                25.5250216
              ],
              [
                61.2319719,
                25.5247437
              ],
              [
                61.2319719,
                25.5239101
              ],
              [
                61.2314117,
                25.524188
              ],
              [
                61.2308586,
                25.5244658
              ],
              [
                61.2297453,
                25.5244659
              ],
              [
                61.2294718,
                25.5247438
              ],
              [
                61.228639,
                25.5247438
              ],
              [
                61.2280789,
                25.5250217
              ],
              [
                61.2275258,
                25.5250217
              ],
              [
                61.2275258,
                25.5252996
              ],
              [
                61.226139,
                25.5252996
              ],
              [
                61.2255789,
                25.5255775
              ],
              [
                61.2233593,
                25.5255775
              ],
              [
                61.1786329,
                25.5447441
              ],
              [
                61.1766867,
                25.544744
              ],
              [
                61.1753,
                25.5450219
              ],
              [
                61.1739132,
                25.5450219
              ],
              [
                61.1702999,
                25.5452998
              ],
              [
                61.1658529,
                25.5461336
              ],
              [
                61.1622466,
                25.5466894
              ],
              [
                61.1597466,
                25.5466894
              ],
              [
                61.1586333,
                25.5469674
              ],
              [
                61.1572465,
                25.5469673
              ],
              [
                61.1561332,
                25.5472453
              ],
              [
                61.1544668,
                25.5472452
              ],
              [
                61.1514137,
                25.5478011
              ],
              [
                61.1497473,
                25.5478011
              ],
              [
                61.1486339,
                25.548079
              ],
              [
                61.1414073,
                25.5480791
              ],
              [
                61.1405736,
                25.5478011
              ],
              [
                61.1364072,
                25.5478011
              ],
              [
                61.1347407,
                25.5475232
              ],
              [
                61.1275203,
                25.5475232
              ],
              [
                61.1258539,
                25.5472453
              ],
              [
                61.1236343,
                25.5472453
              ],
              [
                61.1222405,
                25.5469674
              ],
              [
                61.120021,
                25.5469674
              ],
              [
                61.1183537,
                25.5466895
              ],
              [
                61.1158545,
                25.5466895
              ],
              [
                61.1116873,
                25.5461337
              ],
              [
                61.1091881,
                25.5461337
              ],
              [
                61.1078012,
                25.5458558
              ],
              [
                61.0989081,
                25.5458559
              ],
              [
                61.097794,
                25.5455779
              ],
              [
                61.0969612,
                25.5458559
              ],
              [
                61.0958542,
                25.5455779
              ],
              [
                61.091408,
                25.545578
              ],
              [
                61.0908548,
                25.5458558
              ],
              [
                61.0858548,
                25.5458559
              ],
              [
                61.0852946,
                25.5461338
              ],
              [
                61.0841884,
                25.5458559
              ],
              [
                61.0836282,
                25.5461338
              ],
              [
                61.0825211,
                25.5458559
              ],
              [
                61.0808547,
                25.5458559
              ],
              [
                61.062925,
                25.5557766
              ],
              [
                61.0595921,
                25.554943
              ],
              [
                61.0356988,
                25.545782
              ],
              [
                61.0070858,
                25.5363346
              ],
              [
                60.999605,
                25.5345852
              ],
              [
                60.9818467,
                25.5321987
              ],
              [
                60.9724192,
                25.5307273
              ],
              [
                60.9656416,
                25.5308652
              ],
              [
                60.9458693,
                25.5300375
              ],
              [
                60.9398746,
                25.5286561
              ],
              [
                60.9381151,
                25.5250545
              ],
              [
                60.9360122,
                25.5228471
              ],
              [
                60.9291887,
                25.5181222
              ],
              [
                60.9277296,
                25.5159921
              ],
              [
                60.9270429,
                25.5135908
              ],
              [
                60.9274903,
                25.510855
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2524703157
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.402519,
          25.5961564
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2524703085
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.6398773,
          26.575768
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820309205
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.1725848,
          26.8384487
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 291618503
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.6469115,
          25.2935488
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3796781468
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.7419235,
          26.2394578
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 347026180
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.3987716,
          26.2368044
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 602635564
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.4554816,
          27.1941781
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 347029888
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.6882515,
          27.2069903
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 848539468
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.6746528,
          27.1310393
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820309260
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.9997051,
          27.2871579
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820309219
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          62.3390963,
          27.3651673
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2269726759
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          62.7097131,
          27.6033419
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 602526664
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.2137052,
          28.2203911
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2524703138
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.7597704,
          28.5400131
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 26604766
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          60.8503017,
          29.4928874
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 297684178
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.4540744,
          29.0149246
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32678220
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          61.4948211,
          31.0277779
        ]
      }
    }
  ]
},
"فارس.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554853,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آباده",
          "name:en": "Abadeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270325",
          "wikipedia": "en:Abadeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8585137,
                30.8004145
              ],
              [
                51.8613485,
                30.7986021
              ],
              [
                51.8635138,
                30.798474
              ],
              [
                51.8640704,
                30.7987537
              ],
              [
                51.8687937,
                30.7995841
              ],
              [
                51.8724035,
                30.7995841
              ],
              [
                51.88018,
                30.7984739
              ],
              [
                51.8826834,
                30.798474
              ],
              [
                51.9160162,
                30.7890333
              ],
              [
                51.9171263,
                30.7890332
              ],
              [
                51.9251829,
                30.7873636
              ],
              [
                51.9565723,
                30.784304
              ],
              [
                51.9807421,
                30.7831939
              ],
              [
                51.9896319,
                30.7831939
              ],
              [
                51.9904653,
                30.7834737
              ],
              [
                51.9921319,
                30.7834736
              ],
              [
                51.9937986,
                30.7837534
              ],
              [
                51.9976885,
                30.7837534
              ],
              [
                51.9985219,
                30.7840332
              ],
              [
                52.0174115,
                30.784304
              ],
              [
                52.0174115,
                30.7845838
              ],
              [
                52.0187981,
                30.7845838
              ],
              [
                52.0246314,
                30.7865242
              ],
              [
                52.0246314,
                30.7862445
              ],
              [
                52.0257446,
                30.7865243
              ],
              [
                52.0276881,
                30.7865243
              ],
              [
                52.0312979,
                30.7870838
              ],
              [
                52.035188,
                30.7870839
              ],
              [
                52.046021,
                30.7884738
              ],
              [
                52.0765807,
                30.7973639
              ],
              [
                52.0840805,
                30.799855
              ],
              [
                52.0863005,
                30.8009742
              ],
              [
                52.0974138,
                30.8040249
              ],
              [
                52.0990804,
                30.8048642
              ],
              [
                52.1193601,
                30.8120847
              ],
              [
                52.12797,
                30.8176444
              ],
              [
                52.1290833,
                30.8179152
              ],
              [
                52.1429698,
                30.8243053
              ],
              [
                52.1443597,
                30.8251357
              ],
              [
                52.1449164,
                30.8251357
              ],
              [
                52.145193,
                30.8254155
              ],
              [
                52.1457496,
                30.8254156
              ],
              [
                52.1463029,
                30.8256954
              ],
              [
                52.1401931,
                30.835416
              ],
              [
                52.140193,
                30.8356958
              ],
              [
                52.1340832,
                30.8470863
              ],
              [
                52.1288032,
                30.8556969
              ],
              [
                52.1246365,
                30.8681976
              ],
              [
                52.1243599,
                30.869028
              ],
              [
                52.1240799,
                30.8709776
              ],
              [
                52.12686,
                30.8837582
              ],
              [
                52.1329699,
                30.8937499
              ],
              [
                52.1338031,
                30.8948601
              ],
              [
                52.2163086,
                30.9856994
              ],
              [
                52.2176952,
                30.9865299
              ],
              [
                52.2257517,
                30.9993112
              ],
              [
                52.2335316,
                31.0118129
              ],
              [
                52.2507547,
                31.0359769
              ],
              [
                52.2554745,
                31.0456985
              ],
              [
                52.2654778,
                31.0629212
              ],
              [
                52.2707543,
                31.0759828
              ],
              [
                52.2729778,
                31.0829244
              ],
              [
                52.2732543,
                31.0859755
              ],
              [
                52.2729778,
                31.0862553
              ],
              [
                52.2735308,
                31.086815
              ],
              [
                52.2740875,
                31.0865351
              ],
              [
                52.2743642,
                31.0862553
              ],
              [
                52.2746444,
                31.0859755
              ],
              [
                52.2910342,
                31.0748727
              ],
              [
                52.2921441,
                31.0745928
              ],
              [
                52.3246469,
                31.0568103
              ],
              [
                52.3368701,
                31.0518095
              ],
              [
                52.4027059,
                31.0234752
              ],
              [
                52.4074257,
                31.0212547
              ],
              [
                52.4190956,
                31.0170844
              ],
              [
                52.4593751,
                31.0090329
              ],
              [
                52.4621516,
                31.0090329
              ],
              [
                52.4627084,
                31.008753
              ],
              [
                52.4649283,
                31.008753
              ],
              [
                52.4657616,
                31.0084823
              ],
              [
                52.4671516,
                31.0084823
              ],
              [
                52.467985,
                31.0082024
              ],
              [
                52.4702083,
                31.0082024
              ],
              [
                52.4707649,
                31.0079226
              ],
              [
                52.4757649,
                31.0079226
              ],
              [
                52.4765982,
                31.0076428
              ],
              [
                52.4829847,
                31.0076428
              ],
              [
                52.4835414,
                31.007363
              ],
              [
                52.486598,
                31.007363
              ],
              [
                52.4899313,
                31.0070922
              ],
              [
                52.4940979,
                31.0070922
              ],
              [
                52.4999311,
                31.0076428
              ],
              [
                52.5110444,
                31.0068124
              ],
              [
                52.5171543,
                31.0068124
              ],
              [
                52.5188209,
                31.007363
              ],
              [
                52.5202109,
                31.007363
              ],
              [
                52.5224309,
                31.0079227
              ],
              [
                52.5266009,
                31.0079227
              ],
              [
                52.5268775,
                31.0076428
              ],
              [
                52.5341007,
                31.0076429
              ],
              [
                52.534934,
                31.007363
              ],
              [
                52.536044,
                31.007363
              ],
              [
                52.5366006,
                31.0070922
              ],
              [
                52.5385439,
                31.0070922
              ],
              [
                52.5393772,
                31.0068124
              ],
              [
                52.5410439,
                31.0068124
              ],
              [
                52.5418772,
                31.0065326
              ],
              [
                52.5443772,
                31.0065326
              ],
              [
                52.5452105,
                31.0062528
              ],
              [
                52.5496571,
                31.0062528
              ],
              [
                52.5504905,
                31.0065326
              ],
              [
                52.5541003,
                31.0065326
              ],
              [
                52.5543771,
                31.0068124
              ],
              [
                52.5549337,
                31.0068124
              ],
              [
                52.5554904,
                31.0070922
              ],
              [
                52.5602102,
                31.0084823
              ],
              [
                52.560767,
                31.0082024
              ],
              [
                52.5621567,
                31.0082025
              ],
              [
                52.5668803,
                31.0082025
              ],
              [
                52.5679902,
                31.0084823
              ],
              [
                52.5746568,
                31.0087531
              ],
              [
                52.5757666,
                31.0084823
              ],
              [
                52.5899366,
                31.0084823
              ],
              [
                52.5907699,
                31.0082025
              ],
              [
                52.5916032,
                31.0084823
              ],
              [
                52.5921565,
                31.0082025
              ],
              [
                52.602993,
                31.0082025
              ],
              [
                52.6035463,
                31.0082025
              ],
              [
                52.6063263,
                31.0082025
              ],
              [
                52.6074363,
                31.0084823
              ],
              [
                52.6102129,
                31.0084823
              ],
              [
                52.6127129,
                31.009033
              ],
              [
                52.6266027,
                31.009033
              ],
              [
                52.6279927,
                31.0093128
              ],
              [
                52.6313259,
                31.0093128
              ],
              [
                52.6318827,
                31.0095926
              ],
              [
                52.6493824,
                31.0095926
              ],
              [
                52.6507723,
                31.0098725
              ],
              [
                52.6549389,
                31.0098724
              ],
              [
                52.6563256,
                31.0101432
              ],
              [
                52.6616056,
                31.0101432
              ],
              [
                52.6632722,
                31.0104231
              ],
              [
                52.6654954,
                31.010423
              ],
              [
                52.6696621,
                31.0109736
              ],
              [
                52.676052,
                31.0109737
              ],
              [
                52.6916051,
                31.0132032
              ],
              [
                52.6927185,
                31.0137539
              ],
              [
                52.6941085,
                31.0137538
              ],
              [
                52.6946617,
                31.0140336
              ],
              [
                52.6960518,
                31.0143134
              ],
              [
                52.6977184,
                31.0143135
              ],
              [
                52.6996616,
                31.0148641
              ],
              [
                52.7007749,
                31.0148641
              ],
              [
                52.7129947,
                31.0176443
              ],
              [
                52.7163314,
                31.0184747
              ],
              [
                52.7385545,
                31.0254251
              ],
              [
                52.7452175,
                31.0288809
              ],
              [
                52.7757018,
                31.0463018
              ],
              [
                52.7913675,
                31.0361296
              ],
              [
                52.8165815,
                31.0210732
              ],
              [
                52.825953,
                31.0136056
              ],
              [
                52.8409849,
                31.0058811
              ],
              [
                52.8446114,
                31.0007064
              ],
              [
                52.8467946,
                30.9973751
              ],
              [
                52.8495342,
                30.9909697
              ],
              [
                52.8507597,
                30.9894568
              ],
              [
                52.8578191,
                30.9850378
              ],
              [
                52.8657827,
                30.9768089
              ],
              [
                52.8723253,
                30.9720044
              ],
              [
                52.8732826,
                30.9629175
              ],
              [
                52.8735592,
                30.9598666
              ],
              [
                52.8741159,
                30.9551458
              ],
              [
                52.8738359,
                30.9540357
              ],
              [
                52.8735592,
                30.9509758
              ],
              [
                52.8735592,
                30.9490261
              ],
              [
                52.8732827,
                30.9473653
              ],
              [
                52.8724493,
                30.9390251
              ],
              [
                52.8705026,
                30.9326436
              ],
              [
                52.8616127,
                30.9143116
              ],
              [
                52.8538362,
                30.9018105
              ],
              [
                52.8463363,
                30.8762491
              ],
              [
                52.8466129,
                30.8745793
              ],
              [
                52.8477264,
                30.8704184
              ],
              [
                52.849113,
                30.8679183
              ],
              [
                52.8496696,
                30.8665282
              ],
              [
                52.8510597,
                30.8648675
              ],
              [
                52.8555029,
                30.8565277
              ],
              [
                52.8624461,
                30.8456966
              ],
              [
                52.8627261,
                30.8445865
              ],
              [
                52.8683504,
                30.8348658
              ],
              [
                52.8716161,
                30.8348658
              ],
              [
                52.8802259,
                30.8323658
              ],
              [
                52.8893924,
                30.829306
              ],
              [
                52.8946723,
                30.8270856
              ],
              [
                52.916062,
                30.8195854
              ],
              [
                52.9310619,
                30.8165258
              ],
              [
                52.9341185,
                30.8156953
              ],
              [
                52.9363383,
                30.8154156
              ],
              [
                52.9663413,
                30.8056951
              ],
              [
                53.0124539,
                30.7945846
              ],
              [
                53.0452335,
                30.7848642
              ],
              [
                53.0644,
                30.7776348
              ],
              [
                53.0646799,
                30.777364
              ],
              [
                53.0652333,
                30.7770842
              ],
              [
                53.0660666,
                30.7768044
              ],
              [
                53.0668999,
                30.7762449
              ],
              [
                53.0685665,
                30.7762449
              ],
              [
                53.06968,
                30.7768044
              ],
              [
                53.0719032,
                30.7768044
              ],
              [
                53.0849563,
                30.7751437
              ],
              [
                53.0857896,
                30.774864
              ],
              [
                53.0888462,
                30.7748639
              ],
              [
                53.0896796,
                30.7745841
              ],
              [
                53.0946796,
                30.7745841
              ],
              [
                53.0949595,
                30.7743044
              ],
              [
                53.0985694,
                30.7743044
              ],
              [
                53.1141259,
                30.7784741
              ],
              [
                53.1149592,
                30.7784741
              ],
              [
                53.1182926,
                30.7798641
              ],
              [
                53.1191258,
                30.7798641
              ],
              [
                53.1238491,
                30.7818046
              ],
              [
                53.1252358,
                30.7818045
              ],
              [
                53.1330157,
                30.785135
              ],
              [
                53.1335723,
                30.7856946
              ],
              [
                53.1391255,
                30.7890339
              ],
              [
                53.1685718,
                30.8109751
              ],
              [
                53.2146844,
                30.8554175
              ],
              [
                53.2155177,
                30.8559772
              ],
              [
                53.2246877,
                30.8693084
              ],
              [
                53.242464,
                30.8904199
              ],
              [
                53.2432973,
                30.8920807
              ],
              [
                53.24368,
                30.8929811
              ],
              [
                53.2430207,
                30.8934797
              ],
              [
                53.2419108,
                30.8937505
              ],
              [
                53.2416308,
                30.8940303
              ],
              [
                53.2407974,
                30.8940303
              ],
              [
                53.2388541,
                30.8948607
              ],
              [
                53.2374641,
                30.8948607
              ],
              [
                53.2269076,
                30.8984801
              ],
              [
                53.225521,
                30.8987509
              ],
              [
                53.2213509,
                30.9007005
              ],
              [
                53.2180176,
                30.9018107
              ],
              [
                53.1474621,
                30.9345843
              ],
              [
                53.1452387,
                30.9354238
              ],
              [
                53.1432921,
                30.9365339
              ],
              [
                53.1427388,
                30.9370845
              ],
              [
                53.1421821,
                30.9373644
              ],
              [
                53.1380154,
                30.9387544
              ],
              [
                53.1371822,
                30.9387544
              ],
              [
                53.1230157,
                30.9462552
              ],
              [
                53.1188491,
                30.9487554
              ],
              [
                53.096626,
                30.9615365
              ],
              [
                53.0957928,
                30.9623669
              ],
              [
                53.081623,
                30.9698677
              ],
              [
                53.0515984,
                30.9863858
              ],
              [
                53.0428962,
                30.9887139
              ],
              [
                53.0333233,
                30.9911316
              ],
              [
                53.0236277,
                30.9933287
              ],
              [
                53.0093356,
                30.9943121
              ],
              [
                52.9965368,
                30.9954015
              ],
              [
                52.9848195,
                30.9969758
              ],
              [
                52.9746639,
                30.9984489
              ],
              [
                52.9534334,
                31.0044968
              ],
              [
                52.9428597,
                31.0120171
              ],
              [
                52.9286069,
                31.0307187
              ],
              [
                52.9254627,
                31.0575953
              ],
              [
                52.924592,
                31.0720322
              ],
              [
                52.9248571,
                31.0872694
              ],
              [
                52.9160618,
                31.1118105
              ],
              [
                52.9118953,
                31.1212617
              ],
              [
                52.8993921,
                31.1362644
              ],
              [
                52.8955055,
                31.1401459
              ],
              [
                52.8952254,
                31.1404257
              ],
              [
                52.8949488,
                31.1405657
              ],
              [
                52.8941155,
                31.1415361
              ],
              [
                52.8927254,
                31.1429262
              ],
              [
                52.8891155,
                31.1459773
              ],
              [
                52.8882822,
                31.1462572
              ],
              [
                52.8877256,
                31.1470967
              ],
              [
                52.8766158,
                31.1540384
              ],
              [
                52.8613359,
                31.1584797
              ],
              [
                52.8568927,
                31.1604295
              ],
              [
                52.855226,
                31.1609802
              ],
              [
                52.8393896,
                31.1718126
              ],
              [
                52.8335564,
                31.1790434
              ],
              [
                52.831613,
                31.1865358
              ],
              [
                52.831613,
                31.191257
              ],
              [
                52.8335564,
                31.1956984
              ],
              [
                52.8502261,
                31.2137618
              ],
              [
                52.8505028,
                31.2143124
              ],
              [
                52.8688358,
                31.2237639
              ],
              [
                52.8755023,
                31.2262645
              ],
              [
                52.8780023,
                31.2268151
              ],
              [
                52.9063386,
                31.2309767
              ],
              [
                52.907172,
                31.2312657
              ],
              [
                52.9085619,
                31.2312656
              ],
              [
                52.9124486,
                31.2320961
              ],
              [
                52.9180051,
                31.2326468
              ],
              [
                52.924395,
                31.2337572
              ],
              [
                52.9288383,
                31.2345968
              ],
              [
                52.9457847,
                31.240988
              ],
              [
                52.9555079,
                31.2507104
              ],
              [
                52.9716178,
                31.2770885
              ],
              [
                52.9746743,
                31.2954323
              ],
              [
                52.9766176,
                31.3032049
              ],
              [
                52.9774509,
                31.3076555
              ],
              [
                52.9777309,
                31.3082063
              ],
              [
                52.9777309,
                31.3087569
              ],
              [
                52.9777309,
                31.3107068
              ],
              [
                52.9780075,
                31.3118172
              ],
              [
                52.9782876,
                31.3226504
              ],
              [
                52.9777308,
                31.3254308
              ],
              [
                52.968841,
                31.3618213
              ],
              [
                52.9682843,
                31.3626518
              ],
              [
                52.9680077,
                31.3643219
              ],
              [
                52.9655077,
                31.3695941
              ],
              [
                52.9627312,
                31.3745955
              ],
              [
                52.9516179,
                31.3884892
              ],
              [
                52.9507846,
                31.3898795
              ],
              [
                52.9346715,
                31.4048746
              ],
              [
                52.9068952,
                31.4226505
              ],
              [
                52.9041152,
                31.4237609
              ],
              [
                52.8896721,
                31.4282117
              ],
              [
                52.8885588,
                31.4282117
              ],
              [
                52.8880055,
                31.4284825
              ],
              [
                52.8874058,
                31.4286341
              ],
              [
                52.8657824,
                31.4368243
              ],
              [
                52.864669,
                31.4370951
              ],
              [
                52.8485593,
                31.4476488
              ],
              [
                52.8457793,
                31.4504294
              ],
              [
                52.8182797,
                31.4795988
              ],
              [
                52.8057766,
                31.4871011
              ],
              [
                52.8016099,
                31.4915429
              ],
              [
                52.8004999,
                31.4932131
              ],
              [
                52.8007765,
                31.4943236
              ],
              [
                52.8010566,
                31.4948743
              ],
              [
                52.8005,
                31.4948743
              ],
              [
                52.7993899,
                31.4951542
              ],
              [
                52.7991099,
                31.4948743
              ],
              [
                52.7977234,
                31.4948743
              ],
              [
                52.79661,
                31.4946035
              ],
              [
                52.7946667,
                31.4946035
              ],
              [
                52.793,
                31.4948743
              ],
              [
                52.7871668,
                31.4948743
              ],
              [
                52.7863335,
                31.4951542
              ],
              [
                52.7843868,
                31.4951542
              ],
              [
                52.7824435,
                31.4954341
              ],
              [
                52.7793869,
                31.495434
              ],
              [
                52.7774436,
                31.4957049
              ],
              [
                52.7621638,
                31.4957049
              ],
              [
                52.7610538,
                31.4959938
              ],
              [
                52.754944,
                31.4962646
              ],
              [
                52.7329975,
                31.4984855
              ],
              [
                52.7304976,
                31.4990452
              ],
              [
                52.7291076,
                31.4990453
              ],
              [
                52.6907715,
                31.5029364
              ],
              [
                52.6866048,
                31.5029364
              ],
              [
                52.6602152,
                31.5048773
              ],
              [
                52.6563253,
                31.5048773
              ],
              [
                52.6260491,
                31.5079379
              ],
              [
                52.6232691,
                31.5079379
              ],
              [
                52.6185491,
                31.5084886
              ],
              [
                52.6154926,
                31.5084886
              ],
              [
                52.6138259,
                31.5087685
              ],
              [
                52.6107693,
                31.5087685
              ],
              [
                52.5963228,
                31.509879
              ],
              [
                52.5866029,
                31.5104297
              ],
              [
                52.5846562,
                31.5104296
              ],
              [
                52.5824364,
                31.5107095
              ],
              [
                52.5796563,
                31.5107095
              ],
              [
                52.5785464,
                31.5109894
              ],
              [
                52.574933,
                31.5109894
              ],
              [
                52.5738231,
                31.5112692
              ],
              [
                52.5596566,
                31.5123797
              ],
              [
                52.4996541,
                31.5229336
              ],
              [
                52.4971541,
                31.5234933
              ],
              [
                52.4965975,
                31.5234933
              ],
              [
                52.4329851,
                31.5426601
              ],
              [
                52.4302051,
                31.542931
              ],
              [
                52.4129819,
                31.5454318
              ],
              [
                52.4107585,
                31.5454318
              ],
              [
                52.4077054,
                31.5459915
              ],
              [
                52.3999255,
                31.5468221
              ],
              [
                52.3977055,
                31.5473728
              ],
              [
                52.3935389,
                31.5482125
              ],
              [
                52.3810357,
                31.5515438
              ],
              [
                52.3729792,
                31.5546045
              ],
              [
                52.345203,
                31.5718213
              ],
              [
                52.3449228,
                31.5721012
              ],
              [
                52.3446462,
                31.5723811
              ],
              [
                52.2474209,
                31.6615455
              ],
              [
                52.2446408,
                31.662656
              ],
              [
                52.2407508,
                31.6637665
              ],
              [
                52.2393643,
                31.6637665
              ],
              [
                52.2374175,
                31.6643262
              ],
              [
                52.2226977,
                31.6665473
              ],
              [
                52.2207512,
                31.6665472
              ],
              [
                52.2199178,
                31.6668272
              ],
              [
                52.2188079,
                31.6668272
              ],
              [
                52.2176945,
                31.667107
              ],
              [
                52.2154746,
                31.667107
              ],
              [
                52.2149179,
                31.6673779
              ],
              [
                52.2140845,
                31.6673779
              ],
              [
                52.213808,
                31.6676578
              ],
              [
                52.2126946,
                31.6676578
              ],
              [
                52.2121413,
                31.6679376
              ],
              [
                52.211028,
                31.6679377
              ],
              [
                52.2088081,
                31.6684884
              ],
              [
                52.2071414,
                31.6684884
              ],
              [
                52.2065848,
                31.6687682
              ],
              [
                52.2051947,
                31.6687683
              ],
              [
                52.2046413,
                31.6690481
              ],
              [
                52.2032233,
                31.6692013
              ],
              [
                52.2020993,
                31.6696399
              ],
              [
                52.2013047,
                31.669328
              ],
              [
                52.2007514,
                31.669328
              ],
              [
                52.1943615,
                31.6682175
              ],
              [
                52.1926948,
                31.6682175
              ],
              [
                52.1918616,
                31.6679376
              ],
              [
                52.1904715,
                31.6679376
              ],
              [
                52.1863049,
                31.6673778
              ],
              [
                52.1463021,
                31.6615454
              ],
              [
                52.1449156,
                31.6609947
              ],
              [
                52.1440822,
                31.6609947
              ],
              [
                52.1426924,
                31.6604349
              ],
              [
                52.1340824,
                31.6579341
              ],
              [
                52.1304691,
                31.6565526
              ],
              [
                52.0782466,
                31.6207096
              ],
              [
                52.0726898,
                31.6171074
              ],
              [
                52.0463004,
                31.59571
              ],
              [
                52.0104641,
                31.5504331
              ],
              [
                52.0096309,
                31.5484921
              ],
              [
                52.0079642,
                31.5459912
              ],
              [
                52.0029644,
                31.5362679
              ],
              [
                51.9987977,
                31.525434
              ],
              [
                51.9882412,
                31.5023762
              ],
              [
                51.9837981,
                31.4943231
              ],
              [
                51.9804646,
                31.4890417
              ],
              [
                51.9387953,
                31.4159873
              ],
              [
                51.9379619,
                31.4154276
              ],
              [
                51.937682,
                31.414597
              ],
              [
                51.9365721,
                31.4134866
              ],
              [
                51.936572,
                31.412656
              ],
              [
                51.9365721,
                31.4123762
              ],
              [
                51.9365721,
                31.4120964
              ],
              [
                51.9362954,
                31.4040434
              ],
              [
                51.9365721,
                31.4029331
              ],
              [
                51.9374053,
                31.3970921
              ],
              [
                51.9382387,
                31.3948713
              ],
              [
                51.9418521,
                31.3765358
              ],
              [
                51.9443519,
                31.3548783
              ],
              [
                51.9451854,
                31.3523777
              ],
              [
                51.9454619,
                31.3501479
              ],
              [
                51.947962,
                31.3409848
              ],
              [
                51.9487952,
                31.3359835
              ],
              [
                51.9535186,
                31.316538
              ],
              [
                51.9535186,
                31.314868
              ],
              [
                51.9551852,
                31.3062557
              ],
              [
                51.9554618,
                31.3040439
              ],
              [
                51.9557386,
                31.3023738
              ],
              [
                51.9562952,
                31.3009836
              ],
              [
                51.9546286,
                31.294872
              ],
              [
                51.9546286,
                31.2929311
              ],
              [
                51.954352,
                31.2909812
              ],
              [
                51.9546286,
                31.2904215
              ],
              [
                51.9546286,
                31.2882097
              ],
              [
                51.9635184,
                31.2437588
              ],
              [
                51.9635185,
                31.241818
              ],
              [
                51.9640751,
                31.2379273
              ],
              [
                51.9646285,
                31.2343163
              ],
              [
                51.9651851,
                31.2309762
              ],
              [
                51.9654619,
                31.2284847
              ],
              [
                51.9657418,
                31.2259842
              ],
              [
                51.9660186,
                31.2245939
              ],
              [
                51.966295,
                31.2220934
              ],
              [
                51.9665752,
                31.2204234
              ],
              [
                51.9682418,
                31.2140321
              ],
              [
                51.9685184,
                31.2134814
              ],
              [
                51.9685184,
                31.2132016
              ],
              [
                51.9685184,
                31.2129218
              ],
              [
                51.9682418,
                31.2112607
              ],
              [
                51.9685184,
                31.2109809
              ],
              [
                51.9679618,
                31.1943167
              ],
              [
                51.956852,
                31.1509777
              ],
              [
                51.9410189,
                31.1129202
              ],
              [
                51.9401857,
                31.11181
              ],
              [
                51.9249058,
                31.0829242
              ],
              [
                51.9218493,
                31.0770929
              ],
              [
                51.9024062,
                31.0345865
              ],
              [
                51.9021263,
                31.0343067
              ],
              [
                51.9012929,
                31.0332055
              ],
              [
                51.9010164,
                31.0329256
              ],
              [
                51.8985163,
                31.0273653
              ],
              [
                51.8976831,
                31.0212543
              ],
              [
                51.897403,
                31.0123632
              ],
              [
                51.8965697,
                31.0001234
              ],
              [
                51.8979597,
                30.9918101
              ],
              [
                51.8979597,
                30.9909706
              ],
              [
                51.8976831,
                30.9906999
              ],
              [
                51.8976831,
                30.9901493
              ],
              [
                51.8976831,
                30.9895896
              ],
              [
                51.8976831,
                30.9893098
              ],
              [
                51.8954596,
                30.9854194
              ],
              [
                51.894903,
                30.9840294
              ],
              [
                51.87296,
                30.9445846
              ],
              [
                51.8724034,
                30.9443138
              ],
              [
                51.8715702,
                30.9426439
              ],
              [
                51.8560136,
                30.9265323
              ],
              [
                51.8499038,
                30.9195822
              ],
              [
                51.8415673,
                30.9065305
              ],
              [
                51.8412905,
                30.905971
              ],
              [
                51.8371241,
                30.8984793
              ],
              [
                51.8354575,
                30.8934789
              ],
              [
                51.8326808,
                30.8826388
              ],
              [
                51.8324007,
                30.8759777
              ],
              [
                51.8415674,
                30.8459668
              ],
              [
                51.8424005,
                30.8440353
              ],
              [
                51.8426807,
                30.8423565
              ],
              [
                51.8562905,
                30.8131946
              ],
              [
                51.8585138,
                30.8026347
              ],
              [
                51.8585137,
                30.8004145
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554876,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ارسنجان",
          "name:en": "Arsanjan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270481",
          "wikipedia": "en:Arsanjan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.1253804,
                29.7698426
              ],
              [
                53.1249596,
                29.7690038
              ],
              [
                53.1249596,
                29.7687332
              ],
              [
                53.1238495,
                29.7623385
              ],
              [
                53.1255162,
                29.7551141
              ],
              [
                53.1269029,
                29.7478897
              ],
              [
                53.1285729,
                29.7426134
              ],
              [
                53.1288495,
                29.7423429
              ],
              [
                53.1382928,
                29.7134548
              ],
              [
                53.1382927,
                29.7123364
              ],
              [
                53.1385727,
                29.710677
              ],
              [
                53.1382927,
                29.7084493
              ],
              [
                53.1385727,
                29.705951
              ],
              [
                53.1388493,
                29.7042825
              ],
              [
                53.139126,
                29.7040029
              ],
              [
                53.1371827,
                29.692062
              ],
              [
                53.1371827,
                29.6890046
              ],
              [
                53.1380161,
                29.6884454
              ],
              [
                53.1421826,
                29.6865064
              ],
              [
                53.1430159,
                29.6865064
              ],
              [
                53.1455159,
                29.6851176
              ],
              [
                53.1480159,
                29.6842879
              ],
              [
                53.178572,
                29.6712288
              ],
              [
                53.185242,
                29.6692808
              ],
              [
                53.2144083,
                29.6601179
              ],
              [
                53.2263548,
                29.6573402
              ],
              [
                53.2299647,
                29.6565015
              ],
              [
                53.2380213,
                29.6551127
              ],
              [
                53.2591309,
                29.6520643
              ],
              [
                53.2616342,
                29.6520644
              ],
              [
                53.2619109,
                29.6517757
              ],
              [
                53.2735773,
                29.6515052
              ],
              [
                53.2744107,
                29.6512257
              ],
              [
                53.2749673,
                29.6512257
              ],
              [
                53.2755207,
                29.6512257
              ],
              [
                53.2769106,
                29.6512256
              ],
              [
                53.2810772,
                29.6506664
              ],
              [
                53.3146901,
                29.6495572
              ],
              [
                53.3266366,
                29.6495573
              ],
              [
                53.3277467,
                29.6498368
              ],
              [
                53.3310798,
                29.6498368
              ],
              [
                53.3327465,
                29.6501164
              ],
              [
                53.3702493,
                29.6501164
              ],
              [
                53.3710827,
                29.650396
              ],
              [
                53.3741393,
                29.6503959
              ],
              [
                53.3749726,
                29.6506665
              ],
              [
                53.3786217,
                29.6506666
              ],
              [
                53.3808058,
                29.6506665
              ],
              [
                53.3816392,
                29.6509461
              ],
              [
                53.3855257,
                29.6509461
              ],
              [
                53.3869157,
                29.6512257
              ],
              [
                53.3905257,
                29.6512257
              ],
              [
                53.3916389,
                29.6515052
              ],
              [
                53.3988623,
                29.6515053
              ],
              [
                53.4013622,
                29.6515053
              ],
              [
                53.4019154,
                29.6512256
              ],
              [
                53.4049721,
                29.6512256
              ],
              [
                53.4055287,
                29.6509461
              ],
              [
                53.4119187,
                29.6509461
              ],
              [
                53.412472,
                29.6506665
              ],
              [
                53.4136772,
                29.6504858
              ],
              [
                53.4305283,
                29.6723381
              ],
              [
                53.4538647,
                29.6890047
              ],
              [
                53.4544181,
                29.6892843
              ],
              [
                53.4550919,
                29.6897864
              ],
              [
                53.4566414,
                29.6909528
              ],
              [
                53.4566413,
                29.691503
              ],
              [
                53.4580313,
                29.6928918
              ],
              [
                53.4594179,
                29.693451
              ],
              [
                53.4599746,
                29.6940011
              ],
              [
                53.4710878,
                29.6984475
              ],
              [
                53.4719211,
                29.6984474
              ],
              [
                53.4746977,
                29.6995567
              ],
              [
                53.4891442,
                29.7031733
              ],
              [
                53.4902541,
                29.7031733
              ],
              [
                53.5058106,
                29.70734
              ],
              [
                53.5133105,
                29.7101178
              ],
              [
                53.5402567,
                29.7231773
              ],
              [
                53.5408101,
                29.7237275
              ],
              [
                53.5427567,
                29.731502
              ],
              [
                53.5433134,
                29.7326112
              ],
              [
                53.54359,
                29.7342799
              ],
              [
                53.5477566,
                29.7412336
              ],
              [
                53.5555332,
                29.7509473
              ],
              [
                53.5605332,
                29.7609497
              ],
              [
                53.5663697,
                29.7759488
              ],
              [
                53.5663814,
                29.7760962
              ],
              [
                53.566923,
                29.7828938
              ],
              [
                53.566923,
                29.7840032
              ],
              [
                53.5647031,
                29.7901185
              ],
              [
                53.5549799,
                29.8087259
              ],
              [
                53.5541465,
                29.8095647
              ],
              [
                53.5483133,
                29.8259535
              ],
              [
                53.5480333,
                29.8270629
              ],
              [
                53.5521998,
                29.8390052
              ],
              [
                53.5688696,
                29.850677
              ],
              [
                53.5872027,
                29.8559537
              ],
              [
                53.5877594,
                29.8562333
              ],
              [
                53.5952593,
                29.8581726
              ],
              [
                53.6283154,
                29.8740119
              ],
              [
                53.6305387,
                29.8748417
              ],
              [
                53.6330387,
                29.8765104
              ],
              [
                53.6508151,
                29.8851248
              ],
              [
                53.6655382,
                29.8903925
              ],
              [
                53.6910736,
                29.8929115
              ],
              [
                53.7093771,
                29.8940661
              ],
              [
                53.7209987,
                29.8935643
              ],
              [
                53.7339107,
                29.8938541
              ],
              [
                53.7367671,
                29.8924104
              ],
              [
                53.7379073,
                29.8956478
              ],
              [
                53.737049,
                29.9013772
              ],
              [
                53.7356757,
                29.9062134
              ],
              [
                53.7347316,
                29.9099334
              ],
              [
                53.7316815,
                29.9160933
              ],
              [
                53.7274341,
                29.9249011
              ],
              [
                53.7264042,
                29.9395365
              ],
              [
                53.7242666,
                29.9472681
              ],
              [
                53.7157451,
                29.9567
              ],
              [
                53.7048344,
                29.9650674
              ],
              [
                53.6869518,
                29.9746327
              ],
              [
                53.6684981,
                29.9820474
              ],
              [
                53.6540274,
                29.9873914
              ],
              [
                53.6392453,
                29.9923556
              ],
              [
                53.6310479,
                29.9987234
              ],
              [
                53.6212448,
                30.003137
              ],
              [
                53.6113972,
                30.0086885
              ],
              [
                53.5997109,
                30.016326
              ],
              [
                53.5876765,
                30.0219293
              ],
              [
                53.5801652,
                30.0257736
              ],
              [
                53.5477064,
                30.0377431
              ],
              [
                53.5385901,
                30.0398485
              ],
              [
                53.5372001,
                30.0403988
              ],
              [
                53.530666,
                30.0418105
              ],
              [
                53.5301849,
                30.03582
              ],
              [
                53.5283824,
                30.0317406
              ],
              [
                53.5319616,
                30.023938
              ],
              [
                53.5340473,
                30.0179407
              ],
              [
                53.5431882,
                30.0071714
              ],
              [
                53.5485441,
                29.9973375
              ],
              [
                53.5494453,
                29.9932566
              ],
              [
                53.5497285,
                29.9860754
              ],
              [
                53.5481578,
                29.981191
              ],
              [
                53.5451709,
                29.9761502
              ],
              [
                53.5360901,
                29.9684561
              ],
              [
                53.5108105,
                29.9523451
              ],
              [
                53.4896975,
                29.9417819
              ],
              [
                53.4824741,
                29.9387329
              ],
              [
                53.480531,
                29.9381736
              ],
              [
                53.4596979,
                29.9345655
              ],
              [
                53.4527513,
                29.9345654
              ],
              [
                53.4510847,
                29.9348451
              ],
              [
                53.448028,
                29.9348451
              ],
              [
                53.4399749,
                29.935675
              ],
              [
                53.4374749,
                29.9356749
              ],
              [
                53.433585,
                29.9362342
              ],
              [
                53.4311041,
                29.9351631
              ],
              [
                53.4216744,
                29.9332224
              ],
              [
                53.4097783,
                29.9300314
              ],
              [
                53.404268,
                29.9300314
              ],
              [
                53.3967234,
                29.9274875
              ],
              [
                53.3901831,
                29.9260816
              ],
              [
                53.3841836,
                29.9288933
              ],
              [
                53.3817117,
                29.9314373
              ],
              [
                53.3767678,
                29.9380646
              ],
              [
                53.3742959,
                29.9394703
              ],
              [
                53.3621938,
                29.9420586
              ],
              [
                53.3530785,
                29.9445129
              ],
              [
                53.3106954,
                29.9566722
              ],
              [
                53.3057773,
                29.9618478
              ],
              [
                53.2941644,
                29.9767484
              ],
              [
                53.2879846,
                29.9872757
              ],
              [
                53.2823197,
                29.9968875
              ],
              [
                53.2753932,
                30.0035996
              ],
              [
                53.2707583,
                30.0055619
              ],
              [
                53.2543303,
                30.0071451
              ],
              [
                53.2414815,
                30.0077471
              ],
              [
                53.2368981,
                30.0076356
              ],
              [
                53.2220666,
                30.0038449
              ],
              [
                53.2120759,
                29.9986938
              ],
              [
                53.2062308,
                29.9938323
              ],
              [
                53.1905238,
                29.9854692
              ],
              [
                53.1825133,
                29.9790327
              ],
              [
                53.1719054,
                29.9642884
              ],
              [
                53.1713521,
                29.9628992
              ],
              [
                53.1613489,
                29.9465086
              ],
              [
                53.1491292,
                29.9365048
              ],
              [
                53.1380159,
                29.9323463
              ],
              [
                53.1380159,
                29.931787
              ],
              [
                53.1382926,
                29.9312278
              ],
              [
                53.153849,
                29.9001163
              ],
              [
                53.1841286,
                29.8726227
              ],
              [
                53.1949618,
                29.867346
              ],
              [
                53.221908,
                29.8562332
              ],
              [
                53.2266314,
                29.8526163
              ],
              [
                53.2285747,
                29.8506769
              ],
              [
                53.2324645,
                29.8462301
              ],
              [
                53.2377411,
                29.8378957
              ],
              [
                53.2380212,
                29.8367863
              ],
              [
                53.2382978,
                29.8365066
              ],
              [
                53.2382979,
                29.836227
              ],
              [
                53.2380212,
                29.8359565
              ],
              [
                53.2380212,
                29.8353972
              ],
              [
                53.2299646,
                29.823455
              ],
              [
                53.227188,
                29.8206679
              ],
              [
                53.2260746,
                29.8201177
              ],
              [
                53.208575,
                29.8103944
              ],
              [
                53.2077417,
                29.8103944
              ],
              [
                53.2038517,
                29.809285
              ],
              [
                53.2027418,
                29.809285
              ],
              [
                53.2021851,
                29.8090054
              ],
              [
                53.201075,
                29.8090054
              ],
              [
                53.200795,
                29.8087258
              ],
              [
                53.1999617,
                29.8087258
              ],
              [
                53.1974617,
                29.8078959
              ],
              [
                53.1963518,
                29.807896
              ],
              [
                53.1921852,
                29.8070661
              ],
              [
                53.1882952,
                29.8070662
              ],
              [
                53.1877419,
                29.8067865
              ],
              [
                53.185242,
                29.8067865
              ],
              [
                53.1841286,
                29.8067866
              ],
              [
                53.1832953,
                29.8070661
              ],
              [
                53.1771855,
                29.8070662
              ],
              [
                53.176072,
                29.8067866
              ],
              [
                53.1721855,
                29.8067865
              ],
              [
                53.1713522,
                29.806507
              ],
              [
                53.1688522,
                29.806507
              ],
              [
                53.1682956,
                29.8062273
              ],
              [
                53.1671856,
                29.8062273
              ],
              [
                53.1596823,
                29.8048383
              ],
              [
                53.1582957,
                29.8042881
              ],
              [
                53.1574624,
                29.8042881
              ],
              [
                53.1516292,
                29.8023399
              ],
              [
                53.1402394,
                29.7951152
              ],
              [
                53.1396826,
                29.7942854
              ],
              [
                53.1307927,
                29.7845623
              ],
              [
                53.127736,
                29.7759487
              ],
              [
                53.1277361,
                29.7756691
              ],
              [
                53.1271828,
                29.7745597
              ],
              [
                53.1271828,
                29.77373
              ],
              [
                53.1266262,
                29.7729002
              ],
              [
                53.1263495,
                29.7720614
              ],
              [
                53.1253804,
                29.7698426
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554879,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان استهبان",
          "name:en": "Estahban County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270597",
          "wikipedia": "en:Estahban County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.5733129,
                29.5134495
              ],
              [
                53.5733129,
                29.5128904
              ],
              [
                53.573313,
                29.5126109
              ],
              [
                53.577203,
                29.5090039
              ],
              [
                53.5774795,
                29.5081653
              ],
              [
                53.5783129,
                29.5073357
              ],
              [
                53.5785895,
                29.5064971
              ],
              [
                53.5794228,
                29.5056675
              ],
              [
                53.5844262,
                29.4976151
              ],
              [
                53.5871796,
                29.4909718
              ],
              [
                53.5891461,
                29.4862263
              ],
              [
                53.5897027,
                29.48289
              ],
              [
                53.5899793,
                29.4815014
              ],
              [
                53.5891461,
                29.4573356
              ],
              [
                53.5883127,
                29.4534403
              ],
              [
                53.5822029,
                29.4362182
              ],
              [
                53.5813696,
                29.4337205
              ],
              [
                53.5780363,
                29.4259481
              ],
              [
                53.5785896,
                29.4253891
              ],
              [
                53.5841462,
                29.4226119
              ],
              [
                53.5883127,
                29.4215029
              ],
              [
                53.5919261,
                29.4195552
              ],
              [
                53.5952594,
                29.4167781
              ],
              [
                53.6133157,
                29.4098354
              ],
              [
                53.613869,
                29.4092763
              ],
              [
                53.6155357,
                29.4087173
              ],
              [
                53.6408152,
                29.3926139
              ],
              [
                53.6735949,
                29.3617782
              ],
              [
                53.6741515,
                29.3606693
              ],
              [
                53.6772081,
                29.3526089
              ],
              [
                53.6780414,
                29.3492729
              ],
              [
                53.6783181,
                29.3489934
              ],
              [
                53.6783181,
                29.3484434
              ],
              [
                53.6783181,
                29.3481639
              ],
              [
                53.6780415,
                29.3442781
              ],
              [
                53.6788748,
                29.3373267
              ],
              [
                53.6791515,
                29.3359383
              ],
              [
                53.6788747,
                29.3239922
              ],
              [
                53.6741515,
                29.3053837
              ],
              [
                53.6735949,
                29.3045543
              ],
              [
                53.6713715,
                29.2987212
              ],
              [
                53.6399821,
                29.2514985
              ],
              [
                53.6385954,
                29.2503896
              ],
              [
                53.6185923,
                29.2320529
              ],
              [
                53.6149824,
                29.2287173
              ],
              [
                53.6013693,
                29.2192697
              ],
              [
                53.5872028,
                29.2117692
              ],
              [
                53.5855362,
                29.209822
              ],
              [
                53.5869262,
                29.2087132
              ],
              [
                53.6027592,
                29.1964892
              ],
              [
                53.623039,
                29.1701034
              ],
              [
                53.6249823,
                29.1676064
              ],
              [
                53.6252589,
                29.1670475
              ],
              [
                53.6263723,
                29.1659388
              ],
              [
                53.6413721,
                29.1501005
              ],
              [
                53.6733182,
                29.1362186
              ],
              [
                53.6747048,
                29.1362186
              ],
              [
                53.6752614,
                29.1359392
              ],
              [
                53.6766515,
                29.1359392
              ],
              [
                53.6772082,
                29.1356597
              ],
              [
                53.6880413,
                29.1356597
              ],
              [
                53.6891513,
                29.1356597
              ],
              [
                53.6905413,
                29.1353803
              ],
              [
                53.6991512,
                29.1339921
              ],
              [
                53.7010978,
                29.1339921
              ],
              [
                53.7019312,
                29.1337127
              ],
              [
                53.7085977,
                29.1337127
              ],
              [
                53.709431,
                29.1334332
              ],
              [
                53.7130409,
                29.1331628
              ],
              [
                53.749987,
                29.1267718
              ],
              [
                53.7586003,
                29.1248247
              ],
              [
                53.7947131,
                29.1145487
              ],
              [
                53.8088795,
                29.1034346
              ],
              [
                53.8111029,
                29.1014876
              ],
              [
                53.816656,
                29.0973232
              ],
              [
                53.8177694,
                29.096494
              ],
              [
                53.8186028,
                29.0959351
              ],
              [
                53.8188794,
                29.0953762
              ],
              [
                53.8355458,
                29.0856594
              ],
              [
                53.8499922,
                29.0823243
              ],
              [
                53.8516588,
                29.0823243
              ],
              [
                53.8527688,
                29.0820448
              ],
              [
                53.8541588,
                29.0820449
              ],
              [
                53.8572155,
                29.0814951
              ],
              [
                53.8605488,
                29.081495
              ],
              [
                53.8619354,
                29.0812156
              ],
              [
                53.8641586,
                29.0812156
              ],
              [
                53.8774917,
                29.0789892
              ],
              [
                53.8852717,
                29.0784394
              ],
              [
                53.9080513,
                29.074825
              ],
              [
                53.9122179,
                29.0739957
              ],
              [
                53.9544407,
                29.0637112
              ],
              [
                53.9616639,
                29.0626026
              ],
              [
                53.9636071,
                29.0626025
              ],
              [
                53.9641638,
                29.0623232
              ],
              [
                53.9688871,
                29.0614939
              ],
              [
                53.9705538,
                29.0614939
              ],
              [
                53.9708304,
                29.0612145
              ],
              [
                53.9722205,
                29.0612145
              ],
              [
                53.9744403,
                29.060935
              ],
              [
                53.9749601,
                29.0608046
              ],
              [
                53.9755537,
                29.0606557
              ],
              [
                53.9763871,
                29.0606557
              ],
              [
                53.977497,
                29.0603852
              ],
              [
                53.9811103,
                29.0603853
              ],
              [
                53.982777,
                29.0601058
              ],
              [
                54.0002767,
                29.0603852
              ],
              [
                54.0013866,
                29.0606556
              ],
              [
                54.0022199,
                29.0606556
              ],
              [
                54.0025,
                29.060935
              ],
              [
                54.0030532,
                29.060935
              ],
              [
                54.0033333,
                29.0612145
              ],
              [
                54.0047199,
                29.0612145
              ],
              [
                54.0058332,
                29.0617734
              ],
              [
                54.0066666,
                29.0617733
              ],
              [
                54.0066666,
                29.0620527
              ],
              [
                54.0083332,
                29.0620527
              ],
              [
                54.0191663,
                29.0645495
              ],
              [
                54.0216663,
                29.0645495
              ],
              [
                54.0224997,
                29.0648289
              ],
              [
                54.0247229,
                29.0648289
              ],
              [
                54.0258329,
                29.0651083
              ],
              [
                54.0294429,
                29.0651083
              ],
              [
                54.0327761,
                29.0656582
              ],
              [
                54.0352795,
                29.0656582
              ],
              [
                54.0477792,
                29.0678845
              ],
              [
                54.0502792,
                29.0678845
              ],
              [
                54.0513892,
                29.0681639
              ],
              [
                54.0580557,
                29.0687137
              ],
              [
                54.0650024,
                29.0687138
              ],
              [
                54.0750022,
                29.0664964
              ],
              [
                54.0777788,
                29.0656581
              ],
              [
                54.0816688,
                29.06427
              ],
              [
                54.090002,
                29.0626025
              ],
              [
                54.0925019,
                29.0626026
              ],
              [
                54.0930586,
                29.0623231
              ],
              [
                54.0969486,
                29.0623232
              ],
              [
                54.103335,
                29.0637112
              ],
              [
                54.1191716,
                29.0701018
              ],
              [
                54.1236148,
                29.0701018
              ],
              [
                54.125558,
                29.069552
              ],
              [
                54.1266714,
                29.069552
              ],
              [
                54.1411145,
                29.0639906
              ],
              [
                54.1522277,
                29.0537153
              ],
              [
                54.1536176,
                29.051489
              ],
              [
                54.1552843,
                29.0484334
              ],
              [
                54.1641708,
                29.0248277
              ],
              [
                54.1647275,
                29.0242689
              ],
              [
                54.1669508,
                29.019546
              ],
              [
                54.1672274,
                29.0187168
              ],
              [
                54.1674142,
                29.0178786
              ],
              [
                54.1675075,
                29.0175992
              ],
              [
                54.1677841,
                29.0131557
              ],
              [
                54.1722274,
                28.9989874
              ],
              [
                54.1663941,
                28.9923268
              ],
              [
                54.1655608,
                28.9876041
              ],
              [
                54.1652842,
                28.9853779
              ],
              [
                54.1650041,
                28.9845398
              ],
              [
                54.1647274,
                28.982602
              ],
              [
                54.1644508,
                28.9820433
              ],
              [
                54.1647274,
                28.9778794
              ],
              [
                54.1641708,
                28.974824
              ],
              [
                54.1638941,
                28.9739858
              ],
              [
                54.1636175,
                28.9723185
              ],
              [
                54.1633374,
                28.9720391
              ],
              [
                54.1666742,
                28.9537166
              ],
              [
                54.1680607,
                28.9509317
              ],
              [
                54.1680608,
                28.9506524
              ],
              [
                54.168894,
                28.9492644
              ],
              [
                54.1880639,
                28.932871
              ],
              [
                54.1922304,
                28.9306539
              ],
              [
                54.2277865,
                28.9053749
              ],
              [
                54.2283432,
                28.9048252
              ],
              [
                54.259176,
                28.8731575
              ],
              [
                54.2591761,
                28.8706522
              ],
              [
                54.2605661,
                28.8698231
              ],
              [
                54.2611227,
                28.8698231
              ],
              [
                54.2613993,
                28.8695438
              ],
              [
                54.2622327,
                28.8695438
              ],
              [
                54.2627893,
                28.8692644
              ],
              [
                54.2638993,
                28.8692644
              ],
              [
                54.2641759,
                28.868985
              ],
              [
                54.2683426,
                28.868985
              ],
              [
                54.2686226,
                28.8687147
              ],
              [
                54.2694559,
                28.8687147
              ],
              [
                54.2697326,
                28.8684353
              ],
              [
                54.2761224,
                28.8684353
              ],
              [
                54.276399,
                28.8681559
              ],
              [
                54.2797324,
                28.8681559
              ],
              [
                54.2802891,
                28.8678766
              ],
              [
                54.2825123,
                28.8678766
              ],
              [
                54.282789,
                28.8675972
              ],
              [
                54.284179,
                28.8675973
              ],
              [
                54.2847323,
                28.8673178
              ],
              [
                54.2863989,
                28.8673179
              ],
              [
                54.2869556,
                28.8670386
              ],
              [
                54.2877889,
                28.8670386
              ],
              [
                54.2883456,
                28.8667592
              ],
              [
                54.2900122,
                28.8667591
              ],
              [
                54.3186251,
                28.8609377
              ],
              [
                54.327235,
                28.8587118
              ],
              [
                54.328345,
                28.8581531
              ],
              [
                54.3289017,
                28.8581531
              ],
              [
                54.3294584,
                28.8578737
              ],
              [
                54.338465,
                28.8533711
              ],
              [
                54.3589045,
                28.8431489
              ],
              [
                54.3602911,
                28.8428696
              ],
              [
                54.3761276,
                28.8353811
              ],
              [
                54.3811275,
                28.8317676
              ],
              [
                54.3814042,
                28.8314882
              ],
              [
                54.394184,
                28.8478799
              ],
              [
                54.4000172,
                28.8548188
              ],
              [
                54.4008506,
                28.8562066
              ],
              [
                54.4008506,
                28.856486
              ],
              [
                54.4069604,
                28.865101
              ],
              [
                54.4075171,
                28.8653803
              ],
              [
                54.4077938,
                28.8662094
              ],
              [
                54.4083504,
                28.8664888
              ],
              [
                54.4083505,
                28.8670385
              ],
              [
                54.4177936,
                28.875933
              ],
              [
                54.4330734,
                28.8845392
              ],
              [
                54.43363,
                28.8845393
              ],
              [
                54.4341833,
                28.885098
              ],
              [
                54.4405733,
                28.8875943
              ],
              [
                54.4414066,
                28.8878736
              ],
              [
                54.4550198,
                28.8945424
              ],
              [
                54.4800194,
                28.9170455
              ],
              [
                54.480296,
                28.9175952
              ],
              [
                54.4808526,
                28.9178745
              ],
              [
                54.481686,
                28.9184334
              ],
              [
                54.481686,
                28.918992
              ],
              [
                54.4686295,
                28.9403782
              ],
              [
                54.4683529,
                28.9414957
              ],
              [
                54.4680728,
                28.9417661
              ],
              [
                54.4680728,
                28.9420455
              ],
              [
                54.4664062,
                28.9495438
              ],
              [
                54.4655729,
                28.9531577
              ],
              [
                54.4650196,
                28.9542663
              ],
              [
                54.4641863,
                28.9587095
              ],
              [
                54.4622396,
                28.9642703
              ],
              [
                54.4591864,
                28.9806552
              ],
              [
                54.4589064,
                28.9831517
              ],
              [
                54.4591864,
                28.9837106
              ],
              [
                54.4586297,
                28.9853779
              ],
              [
                54.4636296,
                28.9998255
              ],
              [
                54.4547397,
                29.0139849
              ],
              [
                54.4544631,
                29.0148232
              ],
              [
                54.4541865,
                29.0151025
              ],
              [
                54.4533531,
                29.0164905
              ],
              [
                54.4447399,
                29.0351027
              ],
              [
                54.4444633,
                29.0364908
              ],
              [
                54.44363,
                29.0381582
              ],
              [
                54.4433499,
                29.0395462
              ],
              [
                54.4405733,
                29.0453779
              ],
              [
                54.4289068,
                29.0589881
              ],
              [
                54.4280735,
                29.0592675
              ],
              [
                54.4272403,
                29.0601058
              ],
              [
                54.4186269,
                29.0645494
              ],
              [
                54.393904,
                29.072878
              ],
              [
                54.390294,
                29.0737162
              ],
              [
                54.3847375,
                29.0745455
              ],
              [
                54.3833474,
                29.0745455
              ],
              [
                54.375571,
                29.0762131
              ],
              [
                54.3716811,
                29.076213
              ],
              [
                54.370291,
                29.0759336
              ],
              [
                54.3677911,
                29.0759336
              ],
              [
                54.3641812,
                29.0753837
              ],
              [
                54.3597379,
                29.0753837
              ],
              [
                54.3589046,
                29.0751043
              ],
              [
                54.3555713,
                29.0751043
              ],
              [
                54.3547346,
                29.074825
              ],
              [
                54.353348,
                29.0748249
              ],
              [
                54.3525146,
                29.0745455
              ],
              [
                54.3477914,
                29.0745454
              ],
              [
                54.3439014,
                29.0742751
              ],
              [
                54.3392777,
                29.0751405
              ],
              [
                54.3261251,
                29.0776011
              ],
              [
                54.3155686,
                29.0806568
              ],
              [
                54.3144552,
                29.081495
              ],
              [
                54.2975121,
                29.088715
              ],
              [
                54.297232,
                29.0889945
              ],
              [
                54.2958455,
                29.0895442
              ],
              [
                54.2955655,
                29.0898237
              ],
              [
                54.2780658,
                29.093988
              ],
              [
                54.2772324,
                29.0942675
              ],
              [
                54.2758425,
                29.0942675
              ],
              [
                54.2733425,
                29.0948264
              ],
              [
                54.2719559,
                29.0948264
              ],
              [
                54.2661226,
                29.0962145
              ],
              [
                54.264176,
                29.0962144
              ],
              [
                54.263066,
                29.0964939
              ],
              [
                54.2608427,
                29.0964939
              ],
              [
                54.2594527,
                29.0967734
              ],
              [
                54.2572328,
                29.0967734
              ],
              [
                54.2558428,
                29.0970438
              ],
              [
                54.2536195,
                29.0970437
              ],
              [
                54.2519528,
                29.0973232
              ],
              [
                54.2408431,
                29.0973232
              ],
              [
                54.2397297,
                29.0976026
              ],
              [
                54.2327864,
                29.0976026
              ],
              [
                54.2297298,
                29.0976026
              ],
              [
                54.2291765,
                29.0976026
              ],
              [
                54.2288965,
                29.0973231
              ],
              [
                54.2202867,
                29.1026053
              ],
              [
                54.1869505,
                29.147883
              ],
              [
                54.1852839,
                29.1495507
              ],
              [
                54.1844505,
                29.1509389
              ],
              [
                54.1827838,
                29.1526065
              ],
              [
                54.1819506,
                29.1539947
              ],
              [
                54.176674,
                29.1592681
              ],
              [
                54.1747274,
                29.1603768
              ],
              [
                54.1672275,
                29.1626035
              ],
              [
                54.1655608,
                29.1626034
              ],
              [
                54.1647275,
                29.1628829
              ],
              [
                54.1588942,
                29.1634418
              ],
              [
                54.1552843,
                29.1637122
              ],
              [
                54.1547276,
                29.1639916
              ],
              [
                54.151671,
                29.1639917
              ],
              [
                54.1502844,
                29.1642712
              ],
              [
                54.1488944,
                29.1639916
              ],
              [
                54.1469477,
                29.1639917
              ],
              [
                54.1455611,
                29.1637122
              ],
              [
                54.1436144,
                29.1637122
              ],
              [
                54.1400045,
                29.1631623
              ],
              [
                54.1386146,
                29.1631624
              ],
              [
                54.1380613,
                29.1628828
              ],
              [
                54.1350046,
                29.1628829
              ],
              [
                54.1338947,
                29.1626035
              ],
              [
                54.130838,
                29.1626035
              ],
              [
                54.1297281,
                29.162324
              ],
              [
                54.128058,
                29.1626034
              ],
              [
                54.1263914,
                29.1626035
              ],
              [
                54.1236148,
                29.1631623
              ],
              [
                54.1225048,
                29.1631624
              ],
              [
                54.1205581,
                29.1637122
              ],
              [
                54.0942858,
                29.1822236
              ],
              [
                54.0678589,
                29.1939163
              ],
              [
                54.0635965,
                29.1952138
              ],
              [
                54.055124,
                29.1974465
              ],
              [
                54.0486318,
                29.1992447
              ],
              [
                54.0399961,
                29.2011522
              ],
              [
                54.0329221,
                29.2037154
              ],
              [
                54.0325885,
                29.2119495
              ],
              [
                54.032456,
                29.2211366
              ],
              [
                54.0325227,
                29.2288828
              ],
              [
                54.0331868,
                29.2403563
              ],
              [
                54.0340359,
                29.2493592
              ],
              [
                54.032531,
                29.2582556
              ],
              [
                54.030551,
                29.2695562
              ],
              [
                54.0280595,
                29.2809623
              ],
              [
                54.0262762,
                29.2888307
              ],
              [
                54.0225246,
                29.2983172
              ],
              [
                54.0184177,
                29.3146966
              ],
              [
                54.0166913,
                29.3204234
              ],
              [
                54.0146553,
                29.3265398
              ],
              [
                54.0003907,
                29.3247813
              ],
              [
                53.995934,
                29.3203581
              ],
              [
                53.9933387,
                29.3166136
              ],
              [
                53.9863868,
                29.3126054
              ],
              [
                53.9835222,
                29.3118908
              ],
              [
                53.9780905,
                29.3105355
              ],
              [
                53.9730537,
                29.3092786
              ],
              [
                53.9722204,
                29.3089991
              ],
              [
                53.9688871,
                29.3087196
              ],
              [
                53.9663872,
                29.3087195
              ],
              [
                53.9655539,
                29.3084401
              ],
              [
                53.9630538,
                29.3084401
              ],
              [
                53.9622205,
                29.3087195
              ],
              [
                53.9588839,
                29.3087196
              ],
              [
                53.9580506,
                29.308999
              ],
              [
                53.956664,
                29.3089991
              ],
              [
                53.9555507,
                29.3092785
              ],
              [
                53.9538839,
                29.3092785
              ],
              [
                53.9491641,
                29.3103874
              ],
              [
                53.880825,
                29.3426101
              ],
              [
                53.8741586,
                29.3445576
              ],
              [
                53.8686053,
                29.3462255
              ],
              [
                53.8467738,
                29.3511742
              ],
              [
                53.7999897,
                29.3617782
              ],
              [
                53.7983229,
                29.3620487
              ],
              [
                53.7599869,
                29.3762223
              ],
              [
                53.7394305,
                29.3878894
              ],
              [
                53.7366539,
                29.3898279
              ],
              [
                53.7291541,
                29.3965
              ],
              [
                53.727764,
                29.3984385
              ],
              [
                53.7249875,
                29.4012247
              ],
              [
                53.7088743,
                29.4228914
              ],
              [
                53.7074843,
                29.424271
              ],
              [
                53.703041,
                29.4309434
              ],
              [
                53.6988744,
                29.4359477
              ],
              [
                53.6977646,
                29.4376068
              ],
              [
                53.6938745,
                29.4415021
              ],
              [
                53.6866513,
                29.4515017
              ],
              [
                53.685818,
                29.4531698
              ],
              [
                53.662485,
                29.4798332
              ],
              [
                53.6483151,
                29.4901127
              ],
              [
                53.6472052,
                29.4912218
              ],
              [
                53.6463991,
                29.4920243
              ],
              [
                53.645262,
                29.4926105
              ],
              [
                53.6074825,
                29.5098335
              ],
              [
                53.6066492,
                29.5103926
              ],
              [
                53.5902594,
                29.5139996
              ],
              [
                53.5888694,
                29.5139996
              ],
              [
                53.5883127,
                29.5142791
              ],
              [
                53.5869262,
                29.5142791
              ],
              [
                53.5858128,
                29.5145586
              ],
              [
                53.5799795,
                29.5145587
              ],
              [
                53.5755363,
                29.5137201
              ],
              [
                53.5741463,
                29.51372
              ],
              [
                53.5733129,
                29.5134495
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554889,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اقلید",
          "name:en": "Eqlid County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270488",
          "wikipedia": "en:Eqlid County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8112459,
                30.7142277
              ],
              [
                51.7978906,
                30.6933624
              ],
              [
                51.8065451,
                30.6901832
              ],
              [
                51.8168878,
                30.6853959
              ],
              [
                51.8262022,
                30.6809457
              ],
              [
                51.8343133,
                30.6773803
              ],
              [
                51.8422507,
                30.6715815
              ],
              [
                51.8426388,
                30.6642396
              ],
              [
                51.8466815,
                30.6589459
              ],
              [
                51.8489216,
                30.6532311
              ],
              [
                51.8521241,
                30.6459665
              ],
              [
                51.8535141,
                30.6442969
              ],
              [
                51.854904,
                30.6431869
              ],
              [
                51.8629573,
                30.6315269
              ],
              [
                51.8643472,
                30.6265182
              ],
              [
                51.8693472,
                30.6159684
              ],
              [
                51.8699039,
                30.6156887
              ],
              [
                51.8704605,
                30.6148583
              ],
              [
                51.8804604,
                30.6087487
              ],
              [
                51.8871269,
                30.6009695
              ],
              [
                51.8874036,
                30.5998595
              ],
              [
                51.8882369,
                30.5981899
              ],
              [
                51.8882369,
                30.5934701
              ],
              [
                51.8879603,
                30.5931903
              ],
              [
                51.8879603,
                30.59236
              ],
              [
                51.8879604,
                30.5920803
              ],
              [
                51.8879603,
                30.5906905
              ],
              [
                51.8899035,
                30.5906905
              ],
              [
                51.8899036,
                30.5904108
              ],
              [
                51.8907369,
                30.590131
              ],
              [
                51.91074,
                30.5779119
              ],
              [
                51.9124066,
                30.5773523
              ],
              [
                51.9140732,
                30.5773523
              ],
              [
                51.9143499,
                30.5776321
              ],
              [
                51.9151833,
                30.5776321
              ],
              [
                51.9160165,
                30.5779118
              ],
              [
                51.9196265,
                30.5779119
              ],
              [
                51.9210164,
                30.5781917
              ],
              [
                51.9287964,
                30.5787421
              ],
              [
                51.9332397,
                30.5787422
              ],
              [
                51.9337963,
                30.5784624
              ],
              [
                51.9476861,
                30.5748616
              ],
              [
                51.9532392,
                30.5718024
              ],
              [
                51.9554625,
                30.569853
              ],
              [
                51.9574059,
                30.5679128
              ],
              [
                51.9585193,
                30.5668028
              ],
              [
                51.9679624,
                30.5595743
              ],
              [
                51.9691129,
                30.5585215
              ],
              [
                51.9707425,
                30.5581936
              ],
              [
                51.9726857,
                30.5579139
              ],
              [
                51.977129,
                30.5565241
              ],
              [
                51.9804656,
                30.5565241
              ],
              [
                51.9837991,
                30.5570746
              ],
              [
                51.9874088,
                30.5570745
              ],
              [
                51.9962986,
                30.5579138
              ],
              [
                52.0079653,
                30.5612439
              ],
              [
                52.0182451,
                30.5670736
              ],
              [
                52.0185218,
                30.5676332
              ],
              [
                52.023245,
                30.5709632
              ],
              [
                52.0318547,
                30.5818015
              ],
              [
                52.0329647,
                30.5840215
              ],
              [
                52.0349115,
                30.5931904
              ],
              [
                52.0351881,
                30.5937499
              ],
              [
                52.0354681,
                30.5943004
              ],
              [
                52.0374115,
                30.608469
              ],
              [
                52.0393547,
                30.6120789
              ],
              [
                52.0410213,
                30.6126384
              ],
              [
                52.0443545,
                30.6148585
              ],
              [
                52.0465778,
                30.6140192
              ],
              [
                52.0493545,
                30.6156888
              ],
              [
                52.0532446,
                30.6212479
              ],
              [
                52.0538012,
                30.6231883
              ],
              [
                52.0554679,
                30.6240276
              ],
              [
                52.0560245,
                30.6240275
              ],
              [
                52.0563011,
                30.6240275
              ],
              [
                52.0582444,
                30.623468
              ],
              [
                52.0621344,
                30.6215277
              ],
              [
                52.0957474,
                30.5918007
              ],
              [
                52.096304,
                30.5906906
              ],
              [
                52.0971372,
                30.5898514
              ],
              [
                52.1226936,
                30.5493047
              ],
              [
                52.1238035,
                30.5481857
              ],
              [
                52.1338034,
                30.530408
              ],
              [
                52.1346368,
                30.5295777
              ],
              [
                52.1390833,
                30.5231886
              ],
              [
                52.1390834,
                30.5229088
              ],
              [
                52.1390834,
                30.5226291
              ],
              [
                52.1400398,
                30.5213344
              ],
              [
                52.1404698,
                30.5206889
              ],
              [
                52.1563065,
                30.4923533
              ],
              [
                52.1635265,
                30.4837445
              ],
              [
                52.1674164,
                30.4798551
              ],
              [
                52.2179757,
                30.4462414
              ],
              [
                52.2226989,
                30.4431823
              ],
              [
                52.2367502,
                30.4353222
              ],
              [
                52.2668649,
                30.4184665
              ],
              [
                52.2676983,
                30.4181869
              ],
              [
                52.268255,
                30.4181869
              ],
              [
                52.2688116,
                30.4179071
              ],
              [
                52.2685315,
                30.4176274
              ],
              [
                52.2707549,
                30.4162468
              ],
              [
                52.2729783,
                30.4151278
              ],
              [
                52.2732549,
                30.4148571
              ],
              [
                52.2785348,
                30.4120779
              ],
              [
                52.2882546,
                30.4054095
              ],
              [
                52.3202009,
                30.3904035
              ],
              [
                52.3710368,
                30.3756863
              ],
              [
                52.3913166,
                30.3670782
              ],
              [
                52.3965932,
                30.36429
              ],
              [
                52.4374292,
                30.3537418
              ],
              [
                52.4890984,
                30.3287386
              ],
              [
                52.4910417,
                30.3279085
              ],
              [
                52.4913218,
                30.3276289
              ],
              [
                52.4952083,
                30.3256799
              ],
              [
                52.4999317,
                30.3240196
              ],
              [
                52.504655,
                30.3195713
              ],
              [
                52.5199314,
                30.3004065
              ],
              [
                52.5385444,
                30.2815217
              ],
              [
                52.5399345,
                30.2806826
              ],
              [
                52.542711,
                30.2773531
              ],
              [
                52.5429911,
                30.2770734
              ],
              [
                52.5429911,
                30.2767937
              ],
              [
                52.5452111,
                30.2748539
              ],
              [
                52.5463244,
                30.2742944
              ],
              [
                52.5521578,
                30.268177
              ],
              [
                52.5538243,
                30.2665168
              ],
              [
                52.5538244,
                30.2662372
              ],
              [
                52.5671573,
                30.2559603
              ],
              [
                52.5704906,
                30.2548505
              ],
              [
                52.5746573,
                30.2543001
              ],
              [
                52.5754906,
                30.2540205
              ],
              [
                52.5771573,
                30.2540205
              ],
              [
                52.5774339,
                30.2537407
              ],
              [
                52.5838238,
                30.2537407
              ],
              [
                52.5899371,
                30.2545709
              ],
              [
                52.6102134,
                30.2651274
              ],
              [
                52.6216033,
                30.2709561
              ],
              [
                52.6274365,
                30.2751246
              ],
              [
                52.6304931,
                30.2773532
              ],
              [
                52.6349364,
                30.2815217
              ],
              [
                52.6454928,
                30.2865113
              ],
              [
                52.6493828,
                30.2873504
              ],
              [
                52.6646627,
                30.2879009
              ],
              [
                52.6729958,
                30.2876301
              ],
              [
                52.6741058,
                30.2873505
              ],
              [
                52.6768859,
                30.2873504
              ],
              [
                52.6779958,
                30.2870708
              ],
              [
                52.679939,
                30.2870707
              ],
              [
                52.6916055,
                30.2843007
              ],
              [
                52.6929955,
                30.2843008
              ],
              [
                52.7029954,
                30.281242
              ],
              [
                52.7204985,
                30.2670673
              ],
              [
                52.724385,
                30.2634673
              ],
              [
                52.7379983,
                30.2540205
              ],
              [
                52.7388316,
                30.2531814
              ],
              [
                52.7632779,
                30.2417949
              ],
              [
                52.7641113,
                30.2412446
              ],
              [
                52.7716111,
                30.2392957
              ],
              [
                52.7732777,
                30.2392957
              ],
              [
                52.7793876,
                30.2381859
              ],
              [
                52.7810542,
                30.238186
              ],
              [
                52.7821677,
                30.2379063
              ],
              [
                52.7832776,
                30.2379062
              ],
              [
                52.7838344,
                30.2376265
              ],
              [
                52.7868875,
                30.2376265
              ],
              [
                52.7877208,
                30.2373559
              ],
              [
                52.7882776,
                30.2376266
              ],
              [
                52.7905009,
                30.2373559
              ],
              [
                52.7927241,
                30.2367965
              ],
              [
                52.7946674,
                30.2367965
              ],
              [
                52.7963341,
                30.2365167
              ],
              [
                52.7968909,
                30.2365168
              ],
              [
                52.8024439,
                30.2359664
              ],
              [
                52.8071673,
                30.236237
              ],
              [
                52.8080006,
                30.2365168
              ],
              [
                52.809114,
                30.2365168
              ],
              [
                52.8093906,
                30.2367964
              ],
              [
                52.8113338,
                30.2367965
              ],
              [
                52.8116139,
                30.2370762
              ],
              [
                52.8124472,
                30.2370762
              ],
              [
                52.8155005,
                30.2384656
              ],
              [
                52.8166139,
                30.2387363
              ],
              [
                52.8577266,
                30.2662372
              ],
              [
                52.8607798,
                30.2687366
              ],
              [
                52.8774496,
                30.2834617
              ],
              [
                52.8960593,
                30.3048549
              ],
              [
                52.9007826,
                30.3162419
              ],
              [
                52.9013392,
                30.3170721
              ],
              [
                52.9021725,
                30.320961
              ],
              [
                52.9030058,
                30.3234604
              ],
              [
                52.9032824,
                30.3301284
              ],
              [
                52.8999492,
                30.3356866
              ],
              [
                52.8993926,
                30.3362461
              ],
              [
                52.8988392,
                30.3376356
              ],
              [
                52.8977259,
                30.3398554
              ],
              [
                52.8910592,
                30.3462437
              ],
              [
                52.8893926,
                30.3473536
              ],
              [
                52.8871727,
                30.349853
              ],
              [
                52.8674496,
                30.3684589
              ],
              [
                52.8527265,
                30.3890141
              ],
              [
                52.8524465,
                30.3901331
              ],
              [
                52.8205003,
                30.4426322
              ],
              [
                52.8202237,
                30.4431826
              ],
              [
                52.8232802,
                30.4462418
              ],
              [
                52.8266135,
                30.4473516
              ],
              [
                52.8324468,
                30.450131
              ],
              [
                52.8332802,
                30.450131
              ],
              [
                52.8349467,
                30.4512409
              ],
              [
                52.8360567,
                30.4515207
              ],
              [
                52.8721695,
                30.4817957
              ],
              [
                52.885226,
                30.4968026
              ],
              [
                52.8952257,
                30.5118006
              ],
              [
                52.8980057,
                30.5159697
              ],
              [
                52.907729,
                30.5331879
              ],
              [
                52.9077291,
                30.534018
              ],
              [
                52.9113389,
                30.541797
              ],
              [
                52.9149488,
                30.5520757
              ],
              [
                52.9155055,
                30.5618039
              ],
              [
                52.9152288,
                30.5623544
              ],
              [
                52.9138389,
                30.5670742
              ],
              [
                52.9030057,
                30.5704131
              ],
              [
                52.9027291,
                30.5706929
              ],
              [
                52.9018924,
                30.5706929
              ],
              [
                52.8991261,
                30.5742646
              ],
              [
                52.898841,
                30.5765929
              ],
              [
                52.8989919,
                30.5777504
              ],
              [
                52.8970191,
                30.5792521
              ],
              [
                52.8965088,
                30.5816314
              ],
              [
                52.9012832,
                30.5993651
              ],
              [
                52.9089746,
                30.6183331
              ],
              [
                52.8992488,
                30.6414048
              ],
              [
                52.8696694,
                30.6776354
              ],
              [
                52.8793927,
                30.6904149
              ],
              [
                52.8916159,
                30.7140245
              ],
              [
                52.8924492,
                30.7156941
              ],
              [
                52.8930058,
                30.7181941
              ],
              [
                52.8955057,
                30.7381939
              ],
              [
                52.8952256,
                30.7395838
              ],
              [
                52.8946724,
                30.7459737
              ],
              [
                52.8945431,
                30.7467402
              ],
              [
                52.8944234,
                30.7474501
              ],
              [
                52.8943923,
                30.7476343
              ],
              [
                52.8941158,
                30.7501435
              ],
              [
                52.893839,
                30.7593041
              ],
              [
                52.893559,
                30.7651345
              ],
              [
                52.8932824,
                30.7701345
              ],
              [
                52.8930057,
                30.7731942
              ],
              [
                52.8927256,
                30.7762448
              ],
              [
                52.8924491,
                30.7793045
              ],
              [
                52.8863393,
                30.804305
              ],
              [
                52.868836,
                30.8337557
              ],
              [
                52.8688361,
                30.8340264
              ],
              [
                52.8683504,
                30.8348658
              ],
              [
                52.8627261,
                30.8445865
              ],
              [
                52.8624461,
                30.8456966
              ],
              [
                52.8555029,
                30.8565277
              ],
              [
                52.8510597,
                30.8648675
              ],
              [
                52.8496696,
                30.8665282
              ],
              [
                52.849113,
                30.8679183
              ],
              [
                52.8477264,
                30.8704184
              ],
              [
                52.8466129,
                30.8745793
              ],
              [
                52.8463363,
                30.8762491
              ],
              [
                52.8538362,
                30.9018105
              ],
              [
                52.8616127,
                30.9143116
              ],
              [
                52.8705026,
                30.9326436
              ],
              [
                52.8724493,
                30.9390251
              ],
              [
                52.8732827,
                30.9473653
              ],
              [
                52.8735592,
                30.9490261
              ],
              [
                52.8735592,
                30.9509758
              ],
              [
                52.8738359,
                30.9540357
              ],
              [
                52.8741159,
                30.9551458
              ],
              [
                52.8735592,
                30.9598666
              ],
              [
                52.8732826,
                30.9629175
              ],
              [
                52.8723253,
                30.9720044
              ],
              [
                52.8657827,
                30.9768089
              ],
              [
                52.8578191,
                30.9850378
              ],
              [
                52.8507597,
                30.9894568
              ],
              [
                52.8495342,
                30.9909697
              ],
              [
                52.8467946,
                30.9973751
              ],
              [
                52.8446114,
                31.0007064
              ],
              [
                52.8409849,
                31.0058811
              ],
              [
                52.825953,
                31.0136056
              ],
              [
                52.8165815,
                31.0210732
              ],
              [
                52.7913675,
                31.0361296
              ],
              [
                52.7757018,
                31.0463018
              ],
              [
                52.7452175,
                31.0288809
              ],
              [
                52.7385545,
                31.0254251
              ],
              [
                52.7163314,
                31.0184747
              ],
              [
                52.7129947,
                31.0176443
              ],
              [
                52.7007749,
                31.0148641
              ],
              [
                52.6996616,
                31.0148641
              ],
              [
                52.6977184,
                31.0143135
              ],
              [
                52.6960518,
                31.0143134
              ],
              [
                52.6946617,
                31.0140336
              ],
              [
                52.6941085,
                31.0137538
              ],
              [
                52.6927185,
                31.0137539
              ],
              [
                52.6916051,
                31.0132032
              ],
              [
                52.676052,
                31.0109737
              ],
              [
                52.6696621,
                31.0109736
              ],
              [
                52.6654954,
                31.010423
              ],
              [
                52.6632722,
                31.0104231
              ],
              [
                52.6616056,
                31.0101432
              ],
              [
                52.6563256,
                31.0101432
              ],
              [
                52.6549389,
                31.0098724
              ],
              [
                52.6507723,
                31.0098725
              ],
              [
                52.6493824,
                31.0095926
              ],
              [
                52.6318827,
                31.0095926
              ],
              [
                52.6313259,
                31.0093128
              ],
              [
                52.6279927,
                31.0093128
              ],
              [
                52.6266027,
                31.009033
              ],
              [
                52.6127129,
                31.009033
              ],
              [
                52.6102129,
                31.0084823
              ],
              [
                52.6074363,
                31.0084823
              ],
              [
                52.6063263,
                31.0082025
              ],
              [
                52.6035463,
                31.0082025
              ],
              [
                52.602993,
                31.0082025
              ],
              [
                52.5921565,
                31.0082025
              ],
              [
                52.5916032,
                31.0084823
              ],
              [
                52.5907699,
                31.0082025
              ],
              [
                52.5899366,
                31.0084823
              ],
              [
                52.5757666,
                31.0084823
              ],
              [
                52.5746568,
                31.0087531
              ],
              [
                52.5679902,
                31.0084823
              ],
              [
                52.5668803,
                31.0082025
              ],
              [
                52.5621567,
                31.0082025
              ],
              [
                52.560767,
                31.0082024
              ],
              [
                52.5602102,
                31.0084823
              ],
              [
                52.5554904,
                31.0070922
              ],
              [
                52.5549337,
                31.0068124
              ],
              [
                52.5543771,
                31.0068124
              ],
              [
                52.5541003,
                31.0065326
              ],
              [
                52.5504905,
                31.0065326
              ],
              [
                52.5496571,
                31.0062528
              ],
              [
                52.5452105,
                31.0062528
              ],
              [
                52.5443772,
                31.0065326
              ],
              [
                52.5418772,
                31.0065326
              ],
              [
                52.5410439,
                31.0068124
              ],
              [
                52.5393772,
                31.0068124
              ],
              [
                52.5385439,
                31.0070922
              ],
              [
                52.5366006,
                31.0070922
              ],
              [
                52.536044,
                31.007363
              ],
              [
                52.534934,
                31.007363
              ],
              [
                52.5341007,
                31.0076429
              ],
              [
                52.5268775,
                31.0076428
              ],
              [
                52.5266009,
                31.0079227
              ],
              [
                52.5224309,
                31.0079227
              ],
              [
                52.5202109,
                31.007363
              ],
              [
                52.5188209,
                31.007363
              ],
              [
                52.5171543,
                31.0068124
              ],
              [
                52.5110444,
                31.0068124
              ],
              [
                52.4999311,
                31.0076428
              ],
              [
                52.4940979,
                31.0070922
              ],
              [
                52.4899313,
                31.0070922
              ],
              [
                52.486598,
                31.007363
              ],
              [
                52.4835414,
                31.007363
              ],
              [
                52.4829847,
                31.0076428
              ],
              [
                52.4765982,
                31.0076428
              ],
              [
                52.4757649,
                31.0079226
              ],
              [
                52.4707649,
                31.0079226
              ],
              [
                52.4702083,
                31.0082024
              ],
              [
                52.467985,
                31.0082024
              ],
              [
                52.4671516,
                31.0084823
              ],
              [
                52.4657616,
                31.0084823
              ],
              [
                52.4649283,
                31.008753
              ],
              [
                52.4627084,
                31.008753
              ],
              [
                52.4621516,
                31.0090329
              ],
              [
                52.4593751,
                31.0090329
              ],
              [
                52.4190956,
                31.0170844
              ],
              [
                52.4074257,
                31.0212547
              ],
              [
                52.4027059,
                31.0234752
              ],
              [
                52.3368701,
                31.0518095
              ],
              [
                52.3246469,
                31.0568103
              ],
              [
                52.2921441,
                31.0745928
              ],
              [
                52.2910342,
                31.0748727
              ],
              [
                52.2746444,
                31.0859755
              ],
              [
                52.2743642,
                31.0862553
              ],
              [
                52.2740875,
                31.0865351
              ],
              [
                52.2735308,
                31.086815
              ],
              [
                52.2729778,
                31.0862553
              ],
              [
                52.2732543,
                31.0859755
              ],
              [
                52.2729778,
                31.0829244
              ],
              [
                52.2707543,
                31.0759828
              ],
              [
                52.2654778,
                31.0629212
              ],
              [
                52.2554745,
                31.0456985
              ],
              [
                52.2507547,
                31.0359769
              ],
              [
                52.2335316,
                31.0118129
              ],
              [
                52.2257517,
                30.9993112
              ],
              [
                52.2176952,
                30.9865299
              ],
              [
                52.2163086,
                30.9856994
              ],
              [
                52.1338031,
                30.8948601
              ],
              [
                52.1329699,
                30.8937499
              ],
              [
                52.12686,
                30.8837582
              ],
              [
                52.1240799,
                30.8709776
              ],
              [
                52.1243599,
                30.869028
              ],
              [
                52.1246365,
                30.8681976
              ],
              [
                52.1288032,
                30.8556969
              ],
              [
                52.1340832,
                30.8470863
              ],
              [
                52.140193,
                30.8356958
              ],
              [
                52.1401931,
                30.835416
              ],
              [
                52.1463029,
                30.8256954
              ],
              [
                52.1457496,
                30.8254156
              ],
              [
                52.145193,
                30.8254155
              ],
              [
                52.1449164,
                30.8251357
              ],
              [
                52.1443597,
                30.8251357
              ],
              [
                52.1429698,
                30.8243053
              ],
              [
                52.1290833,
                30.8179152
              ],
              [
                52.12797,
                30.8176444
              ],
              [
                52.1193601,
                30.8120847
              ],
              [
                52.0990804,
                30.8048642
              ],
              [
                52.0974138,
                30.8040249
              ],
              [
                52.0863005,
                30.8009742
              ],
              [
                52.0840805,
                30.799855
              ],
              [
                52.0765807,
                30.7973639
              ],
              [
                52.046021,
                30.7884738
              ],
              [
                52.035188,
                30.7870839
              ],
              [
                52.0312979,
                30.7870838
              ],
              [
                52.0276881,
                30.7865243
              ],
              [
                52.0257446,
                30.7865243
              ],
              [
                52.0246314,
                30.7862445
              ],
              [
                52.0246314,
                30.7865242
              ],
              [
                52.0187981,
                30.7845838
              ],
              [
                52.0174115,
                30.7845838
              ],
              [
                52.0174115,
                30.784304
              ],
              [
                51.9985219,
                30.7840332
              ],
              [
                51.9976885,
                30.7837534
              ],
              [
                51.9937986,
                30.7837534
              ],
              [
                51.9921319,
                30.7834736
              ],
              [
                51.9904653,
                30.7834737
              ],
              [
                51.9896319,
                30.7831939
              ],
              [
                51.9807421,
                30.7831939
              ],
              [
                51.9565723,
                30.784304
              ],
              [
                51.9251829,
                30.7873636
              ],
              [
                51.9171263,
                30.7890332
              ],
              [
                51.9160162,
                30.7890333
              ],
              [
                51.8826834,
                30.798474
              ],
              [
                51.88018,
                30.7984739
              ],
              [
                51.8724035,
                30.7995841
              ],
              [
                51.8687937,
                30.7995841
              ],
              [
                51.8640704,
                30.7987537
              ],
              [
                51.8635138,
                30.798474
              ],
              [
                51.8613485,
                30.7986021
              ],
              [
                51.8585137,
                30.8004145
              ],
              [
                51.8579571,
                30.8004144
              ],
              [
                51.8576804,
                30.7998548
              ],
              [
                51.8574039,
                30.799584
              ],
              [
                51.8549038,
                30.7951345
              ],
              [
                51.8465706,
                30.7690329
              ],
              [
                51.8335142,
                30.7420832
              ],
              [
                51.8326809,
                30.7404135
              ],
              [
                51.827401,
                30.7334731
              ],
              [
                51.8164769,
                30.7162497
              ],
              [
                51.8112459,
                30.7142277
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554951,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بوانات",
          "name:en": "Bavanat County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270553",
          "wikipedia": "en:Bavanat County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.2749671,
                30.6043003
              ],
              [
                53.2755203,
                30.60347
              ],
              [
                53.276077,
                30.6031903
              ],
              [
                53.2805236,
                30.5965211
              ],
              [
                53.2852435,
                30.5906913
              ],
              [
                53.2960768,
                30.5806922
              ],
              [
                53.3388595,
                30.5498558
              ],
              [
                53.364969,
                30.5373572
              ],
              [
                53.3671924,
                30.5365269
              ],
              [
                53.3699689,
                30.5354169
              ],
              [
                53.3733023,
                30.535417
              ],
              [
                53.3735822,
                30.5351372
              ],
              [
                53.374139,
                30.5351372
              ],
              [
                53.3755256,
                30.5345777
              ],
              [
                53.3760822,
                30.5340182
              ],
              [
                53.3758057,
                30.533188
              ],
              [
                53.3758057,
                30.5324507
              ],
              [
                53.3758056,
                30.532078
              ],
              [
                53.3758057,
                30.5265191
              ],
              [
                53.3749724,
                30.5215198
              ],
              [
                53.373859,
                30.5118007
              ],
              [
                53.3702491,
                30.4990226
              ],
              [
                53.3691356,
                30.4881848
              ],
              [
                53.3693566,
                30.4865423
              ],
              [
                53.3785681,
                30.4786508
              ],
              [
                53.4168388,
                30.4603166
              ],
              [
                53.427569,
                30.4524289
              ],
              [
                53.4199914,
                30.4444541
              ],
              [
                53.4123724,
                30.4430943
              ],
              [
                53.3834151,
                30.4389813
              ],
              [
                53.3727919,
                30.430988
              ],
              [
                53.3613592,
                30.4108496
              ],
              [
                53.3613592,
                30.4101293
              ],
              [
                53.3591358,
                30.3648497
              ],
              [
                53.3594159,
                30.3581905
              ],
              [
                53.3596925,
                30.3545723
              ],
              [
                53.3599691,
                30.350963
              ],
              [
                53.3602493,
                30.3487433
              ],
              [
                53.3605258,
                30.3459642
              ],
              [
                53.3608026,
                30.3420751
              ],
              [
                53.3610825,
                30.341245
              ],
              [
                53.3608026,
                30.3204107
              ],
              [
                53.3610826,
                30.3184618
              ],
              [
                53.3610826,
                30.3168015
              ],
              [
                53.3613592,
                30.3126329
              ],
              [
                53.3610826,
                30.3120735
              ],
              [
                53.3610826,
                30.3101245
              ],
              [
                53.3633025,
                30.3109637
              ],
              [
                53.3749724,
                30.3109637
              ],
              [
                53.3758057,
                30.3106839
              ],
              [
                53.3783057,
                30.3106839
              ],
              [
                53.379139,
                30.3104042
              ],
              [
                53.3805255,
                30.3104043
              ],
              [
                53.3813589,
                30.3101246
              ],
              [
                53.3838588,
                30.3098539
              ],
              [
                53.3866389,
                30.3098538
              ],
              [
                53.3874722,
                30.3095741
              ],
              [
                53.3894155,
                30.3095741
              ],
              [
                53.3902488,
                30.3092944
              ],
              [
                53.4035818,
                30.3092944
              ],
              [
                53.4044152,
                30.3095741
              ],
              [
                53.4063619,
                30.3095741
              ],
              [
                53.4302515,
                30.3151322
              ],
              [
                53.4313616,
                30.3156826
              ],
              [
                53.4321948,
                30.3156827
              ],
              [
                53.4413613,
                30.3181821
              ],
              [
                53.445808,
                30.3198513
              ],
              [
                53.4491412,
                30.3204108
              ],
              [
                53.465251,
                30.3248501
              ],
              [
                53.4663643,
                30.3248501
              ],
              [
                53.4666411,
                30.3251298
              ],
              [
                53.4671977,
                30.3251297
              ],
              [
                53.4674743,
                30.3254095
              ],
              [
                53.4774743,
                30.3284593
              ],
              [
                53.5119204,
                30.3448543
              ],
              [
                53.5144203,
                30.3462439
              ],
              [
                53.5305334,
                30.3537422
              ],
              [
                53.5474799,
                30.3570717
              ],
              [
                53.5496997,
                30.3570717
              ],
              [
                53.5508131,
                30.3573515
              ],
              [
                53.5566464,
                30.3573515
              ],
              [
                53.5577564,
                30.3570718
              ],
              [
                53.5713695,
                30.3559619
              ],
              [
                53.580536,
                30.3534625
              ],
              [
                53.581926,
                30.3534625
              ],
              [
                53.5835927,
                30.352912
              ],
              [
                53.5847027,
                30.352912
              ],
              [
                53.5852593,
                30.3526323
              ],
              [
                53.609149,
                30.3487434
              ],
              [
                53.6158155,
                30.3476335
              ],
              [
                53.6249762,
                30.3467381
              ],
              [
                53.642649,
                30.3448287
              ],
              [
                53.6511441,
                30.3429078
              ],
              [
                53.6687171,
                30.3359256
              ],
              [
                53.6646042,
                30.3267612
              ],
              [
                53.6637121,
                30.3222267
              ],
              [
                53.6629897,
                30.3148891
              ],
              [
                53.6633522,
                30.3061488
              ],
              [
                53.6651789,
                30.2945397
              ],
              [
                53.669441,
                30.2805934
              ],
              [
                53.6773437,
                30.2664644
              ],
              [
                53.684287,
                30.2546858
              ],
              [
                53.6941337,
                30.2432007
              ],
              [
                53.7004743,
                30.2321859
              ],
              [
                53.7051868,
                30.227829
              ],
              [
                53.7141759,
                30.2178057
              ],
              [
                53.72789,
                30.2045625
              ],
              [
                53.7428855,
                30.1939536
              ],
              [
                53.7584803,
                30.1877485
              ],
              [
                53.7722181,
                30.1852542
              ],
              [
                53.7879863,
                30.1847071
              ],
              [
                53.80939,
                30.1797294
              ],
              [
                53.8214206,
                30.1732536
              ],
              [
                53.8359448,
                30.1625621
              ],
              [
                53.8452823,
                30.1563209
              ],
              [
                53.8599703,
                30.1448986
              ],
              [
                53.8807668,
                30.1266644
              ],
              [
                53.887582,
                30.1217065
              ],
              [
                53.8897142,
                30.1339738
              ],
              [
                53.8700802,
                30.1662898
              ],
              [
                53.8705105,
                30.1714395
              ],
              [
                53.9041767,
                30.162404
              ],
              [
                53.9049742,
                30.1698955
              ],
              [
                53.9051768,
                30.1891218
              ],
              [
                53.9133622,
                30.1993398
              ],
              [
                53.9143696,
                30.2027922
              ],
              [
                53.9004017,
                30.2026288
              ],
              [
                53.8893127,
                30.2009269
              ],
              [
                53.8811442,
                30.2146892
              ],
              [
                53.8796138,
                30.2252551
              ],
              [
                53.8997304,
                30.2229837
              ],
              [
                53.9040435,
                30.2238568
              ],
              [
                53.8984813,
                30.2316934
              ],
              [
                53.8998698,
                30.2341542
              ],
              [
                53.9051055,
                30.2382326
              ],
              [
                53.9190915,
                30.2225017
              ],
              [
                53.9219181,
                30.2382399
              ],
              [
                53.9231997,
                30.2471378
              ],
              [
                53.9296345,
                30.2706281
              ],
              [
                53.9330787,
                30.2834454
              ],
              [
                53.936558,
                30.2981132
              ],
              [
                53.9364331,
                30.3160072
              ],
              [
                53.9361941,
                30.331721
              ],
              [
                53.9361912,
                30.3474819
              ],
              [
                53.9365988,
                30.3784839
              ],
              [
                53.9340739,
                30.3872274
              ],
              [
                53.92004,
                30.4118182
              ],
              [
                53.914306,
                30.4323899
              ],
              [
                53.9264741,
                30.4868042
              ],
              [
                53.9215849,
                30.4989762
              ],
              [
                53.9099119,
                30.5266315
              ],
              [
                53.9018668,
                30.5437705
              ],
              [
                53.8968836,
                30.5583246
              ],
              [
                53.887482,
                30.5820481
              ],
              [
                53.8778076,
                30.6040636
              ],
              [
                53.8733531,
                30.6117635
              ],
              [
                53.8616004,
                30.6299459
              ],
              [
                53.8476964,
                30.6446677
              ],
              [
                53.836819,
                30.6525237
              ],
              [
                53.8315486,
                30.6563726
              ],
              [
                53.8071723,
                30.669507
              ],
              [
                53.7838764,
                30.6751358
              ],
              [
                53.7397104,
                30.6876354
              ],
              [
                53.734987,
                30.6890253
              ],
              [
                53.7144308,
                30.6934655
              ],
              [
                53.6638714,
                30.7048641
              ],
              [
                53.6613714,
                30.7051349
              ],
              [
                53.6591515,
                30.7056945
              ],
              [
                53.6577615,
                30.7056945
              ],
              [
                53.6533149,
                30.7068046
              ],
              [
                53.6499816,
                30.7073641
              ],
              [
                53.6330386,
                30.7093045
              ],
              [
                53.6297053,
                30.7093045
              ],
              [
                53.6116488,
                30.7115247
              ],
              [
                53.6083156,
                30.7115247
              ],
              [
                53.6060922,
                30.7118045
              ],
              [
                53.5994257,
                30.7118045
              ],
              [
                53.597479,
                30.7120842
              ],
              [
                53.5922025,
                30.7120843
              ],
              [
                53.5649796,
                30.7145842
              ],
              [
                53.5630362,
                30.7145842
              ],
              [
                53.5619228,
                30.714864
              ],
              [
                53.5533131,
                30.7154145
              ],
              [
                53.5291433,
                30.7179145
              ],
              [
                53.506367,
                30.7226346
              ],
              [
                53.5049771,
                30.7226347
              ],
              [
                53.4969205,
                30.7251346
              ],
              [
                53.4924773,
                30.7259739
              ],
              [
                53.4921972,
                30.7262537
              ],
              [
                53.4905305,
                30.7265336
              ],
              [
                53.4710875,
                30.7315245
              ],
              [
                53.4605311,
                30.7368042
              ],
              [
                53.4585844,
                30.7373638
              ],
              [
                53.4494178,
                30.7462446
              ],
              [
                53.4494178,
                30.7465244
              ],
              [
                53.4487552,
                30.7471871
              ],
              [
                53.4471946,
                30.7462447
              ],
              [
                53.4471945,
                30.7459739
              ],
              [
                53.4302514,
                30.7359739
              ],
              [
                53.3391361,
                30.6709752
              ],
              [
                53.3366361,
                30.6679157
              ],
              [
                53.3346894,
                30.6648654
              ],
              [
                53.3280229,
                30.6537467
              ],
              [
                53.3138564,
                30.639298
              ],
              [
                53.2730203,
                30.6070799
              ],
              [
                53.2732735,
                30.6063452
              ],
              [
                53.2749671,
                30.6043003
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554979,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جهرم",
          "place": "county",
          "population": "200000",
          "type": "boundary",
          "wikidata": "Q1270517",
          "wikipedia": "en:Jahrom County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.7593889,
                28.7578777
              ],
              [
                52.7593888,
                28.7570397
              ],
              [
                52.7599455,
                28.7562107
              ],
              [
                52.767722,
                28.7401
              ],
              [
                52.7685553,
                28.7392621
              ],
              [
                52.7693886,
                28.7375951
              ],
              [
                52.7738353,
                28.7314861
              ],
              [
                52.8118914,
                28.7092671
              ],
              [
                52.8299478,
                28.6934275
              ],
              [
                52.842171,
                28.685652
              ],
              [
                52.8488375,
                28.6817597
              ],
              [
                52.9107833,
                28.6398112
              ],
              [
                52.9291196,
                28.6309279
              ],
              [
                52.9302296,
                28.6306487
              ],
              [
                52.9313396,
                28.6303694
              ],
              [
                52.9316197,
                28.6300992
              ],
              [
                52.9330062,
                28.6298199
              ],
              [
                52.9346729,
                28.628982
              ],
              [
                52.9357863,
                28.6287028
              ],
              [
                52.9427295,
                28.6256486
              ],
              [
                52.9516194,
                28.621198
              ],
              [
                52.9571759,
                28.6198197
              ],
              [
                52.9616191,
                28.6164773
              ],
              [
                52.9621757,
                28.6159277
              ],
              [
                52.9635659,
                28.6150899
              ],
              [
                52.9638424,
                28.6148196
              ],
              [
                52.9874554,
                28.604261
              ],
              [
                53.0221783,
                28.592036
              ],
              [
                53.0232882,
                28.5920359
              ],
              [
                53.0241216,
                28.5917567
              ],
              [
                53.027735,
                28.5912071
              ],
              [
                53.0305115,
                28.59009
              ],
              [
                53.0313448,
                28.59009
              ],
              [
                53.0316214,
                28.5898107
              ],
              [
                53.0324547,
                28.5898107
              ],
              [
                53.0335681,
                28.5892612
              ],
              [
                53.034678,
                28.5892612
              ],
              [
                53.0355115,
                28.5887027
              ],
              [
                53.0366248,
                28.5887027
              ],
              [
                53.0369014,
                28.5884234
              ],
              [
                53.0432913,
                28.585928
              ],
              [
                53.0441246,
                28.5859279
              ],
              [
                53.0446778,
                28.5856486
              ],
              [
                53.0466246,
                28.5850901
              ],
              [
                53.0471778,
                28.5850901
              ],
              [
                53.0474579,
                28.5848109
              ],
              [
                53.0630143,
                28.5800902
              ],
              [
                53.0855139,
                28.5714779
              ],
              [
                53.1024604,
                28.5628658
              ],
              [
                53.1196834,
                28.5462091
              ],
              [
                53.1203462,
                28.5454502
              ],
              [
                53.1216267,
                28.543984
              ],
              [
                53.1221834,
                28.542867
              ],
              [
                53.1230168,
                28.5420382
              ],
              [
                53.1232934,
                28.5412005
              ],
              [
                53.12607,
                28.5375972
              ],
              [
                53.1296833,
                28.5306427
              ],
              [
                53.1296833,
                28.5303635
              ],
              [
                53.1303228,
                28.5297373
              ],
              [
                53.1303438,
                28.5297178
              ],
              [
                53.1649628,
                28.4975923
              ],
              [
                53.1716294,
                28.4884224
              ],
              [
                53.1760726,
                28.48454
              ],
              [
                53.2044089,
                28.4545359
              ],
              [
                53.213852,
                28.4495367
              ],
              [
                53.2182987,
                28.4478614
              ],
              [
                53.2205187,
                28.4464742
              ],
              [
                53.2305218,
                28.4423129
              ],
              [
                53.2316318,
                28.4414842
              ],
              [
                53.2321885,
                28.4409258
              ],
              [
                53.2349651,
                28.4395386
              ],
              [
                53.2357984,
                28.4395386
              ],
              [
                53.2691346,
                28.427307
              ],
              [
                53.2708013,
                28.4270367
              ],
              [
                53.286911,
                28.4234249
              ],
              [
                53.2888576,
                28.4234249
              ],
              [
                53.2899676,
                28.4231457
              ],
              [
                53.2924675,
                28.4231457
              ],
              [
                53.3016341,
                28.422308
              ],
              [
                53.3191371,
                28.4198131
              ],
              [
                53.3213571,
                28.4198131
              ],
              [
                53.3266371,
                28.4189754
              ],
              [
                53.3285803,
                28.4189754
              ],
              [
                53.3296902,
                28.4186962
              ],
              [
                53.3633031,
                28.4153636
              ],
              [
                53.3663598,
                28.4153637
              ],
              [
                53.3874728,
                28.4120311
              ],
              [
                53.393306,
                28.4109233
              ],
              [
                53.3946959,
                28.4103649
              ],
              [
                53.3955292,
                28.4103648
              ],
              [
                53.4019158,
                28.4089777
              ],
              [
                53.4030292,
                28.4084193
              ],
              [
                53.4052491,
                28.4081401
              ],
              [
                53.4152523,
                28.4056453
              ],
              [
                53.4194189,
                28.4042581
              ],
              [
                53.4655315,
                28.3953684
              ],
              [
                53.4671982,
                28.3953684
              ],
              [
                53.4677514,
                28.3950893
              ],
              [
                53.4691415,
                28.3950892
              ],
              [
                53.478588,
                28.3939814
              ],
              [
                53.481088,
                28.3939814
              ],
              [
                53.4827546,
                28.3937022
              ],
              [
                53.4874779,
                28.3937022
              ],
              [
                53.4888645,
                28.3934231
              ],
              [
                53.4927544,
                28.393423
              ],
              [
                53.4944211,
                28.3931438
              ],
              [
                53.4971976,
                28.3931438
              ],
              [
                53.516644,
                28.3895321
              ],
              [
                53.5177541,
                28.3889737
              ],
              [
                53.5185873,
                28.3886945
              ],
              [
                53.5222007,
                28.383975
              ],
              [
                53.5235873,
                28.381201
              ],
              [
                53.5213674,
                28.3706453
              ],
              [
                53.5085875,
                28.3475891
              ],
              [
                53.5024776,
                28.3389791
              ],
              [
                53.4958111,
                28.3292527
              ],
              [
                53.4955311,
                28.3275865
              ],
              [
                53.4949778,
                28.3264788
              ],
              [
                53.4941444,
                28.3248127
              ],
              [
                53.4921978,
                28.3203638
              ],
              [
                53.4921978,
                28.3195352
              ],
              [
                53.4916445,
                28.3189768
              ],
              [
                53.4916446,
                28.3184184
              ],
              [
                53.4896978,
                28.3136993
              ],
              [
                53.4894212,
                28.3056482
              ],
              [
                53.4896978,
                28.3039732
              ],
              [
                53.4913645,
                28.3014786
              ],
              [
                53.4915882,
                28.3013663
              ],
              [
                53.4919212,
                28.3011993
              ],
              [
                53.4927545,
                28.3011994
              ],
              [
                53.4958111,
                28.3003618
              ],
              [
                53.4969211,
                28.3003618
              ],
              [
                53.4971977,
                28.3000827
              ],
              [
                53.4991444,
                28.3000827
              ],
              [
                53.4996977,
                28.2998035
              ],
              [
                53.5106629,
                28.3067552
              ],
              [
                53.5324747,
                28.3050634
              ],
              [
                53.5481677,
                28.3037788
              ],
              [
                53.5624056,
                28.301495
              ],
              [
                53.5783424,
                28.2979955
              ],
              [
                53.579339,
                28.3025711
              ],
              [
                53.5798841,
                28.3090963
              ],
              [
                53.5845931,
                28.3119395
              ],
              [
                53.5937117,
                28.3240269
              ],
              [
                53.6063302,
                28.3363424
              ],
              [
                53.6156843,
                28.3471442
              ],
              [
                53.615341,
                28.3534893
              ],
              [
                53.6434935,
                28.3401944
              ],
              [
                53.658943,
                28.3315821
              ],
              [
                53.6718176,
                28.3291645
              ],
              [
                53.6819456,
                28.3246314
              ],
              [
                53.7015149,
                28.3204004
              ],
              [
                53.7254706,
                28.3151247
              ],
              [
                53.7523598,
                28.3225658
              ],
              [
                53.7651646,
                28.3288894
              ],
              [
                53.7791492,
                28.3323647
              ],
              [
                53.7954986,
                28.3361192
              ],
              [
                53.8020228,
                28.3380036
              ],
              [
                53.8168716,
                28.3449535
              ],
              [
                53.8300454,
                28.3536194
              ],
              [
                53.8393691,
                28.3541894
              ],
              [
                53.8536886,
                28.3541139
              ],
              [
                53.8598154,
                28.3586094
              ],
              [
                53.8658809,
                28.360287
              ],
              [
                53.8828754,
                28.3583232
              ],
              [
                53.8911708,
                28.3537162
              ],
              [
                53.9011573,
                28.347824
              ],
              [
                53.9103437,
                28.3436295
              ],
              [
                53.9432277,
                28.3423453
              ],
              [
                53.9566748,
                28.3430941
              ],
              [
                53.9687096,
                28.3424166
              ],
              [
                53.9782778,
                28.3423411
              ],
              [
                53.9937033,
                28.3434732
              ],
              [
                53.9977168,
                28.3438959
              ],
              [
                54.000635,
                28.3459356
              ],
              [
                54.0147586,
                28.3378207
              ],
              [
                54.0117477,
                28.3465468
              ],
              [
                54.0119827,
                28.3511087
              ],
              [
                54.0059137,
                28.3648849
              ],
              [
                54.0205564,
                28.3759232
              ],
              [
                54.0174997,
                28.3806426
              ],
              [
                54.016943,
                28.381201
              ],
              [
                54.0116664,
                28.405366
              ],
              [
                54.0113865,
                28.40787
              ],
              [
                54.0113865,
                28.4089778
              ],
              [
                54.0111098,
                28.4167508
              ],
              [
                54.0094431,
                28.4334229
              ],
              [
                54.0099999,
                28.4375933
              ],
              [
                54.0102765,
                28.4428715
              ],
              [
                54.0105531,
                28.4459249
              ],
              [
                54.0108332,
                28.4506447
              ],
              [
                54.0111097,
                28.4589857
              ],
              [
                54.0108332,
                28.459535
              ],
              [
                54.0111098,
                28.4603638
              ],
              [
                54.0122197,
                28.467867
              ],
              [
                54.0124998,
                28.4698126
              ],
              [
                54.0124998,
                28.4703621
              ],
              [
                54.0124998,
                28.4709206
              ],
              [
                54.0155564,
                28.4828647
              ],
              [
                54.0158331,
                28.4834232
              ],
              [
                54.0161097,
                28.4853689
              ],
              [
                54.0163898,
                28.4870353
              ],
              [
                54.0166664,
                28.4887017
              ],
              [
                54.0205563,
                28.5000876
              ],
              [
                54.0216663,
                28.5042583
              ],
              [
                54.020833,
                28.5042582
              ],
              [
                54.0202763,
                28.5045375
              ],
              [
                54.019443,
                28.5045375
              ],
              [
                54.0180564,
                28.505087
              ],
              [
                54.017223,
                28.505087
              ],
              [
                54.0166664,
                28.5053662
              ],
              [
                54.0158331,
                28.5053663
              ],
              [
                54.0141664,
                28.506204
              ],
              [
                54.0133331,
                28.506204
              ],
              [
                54.0127764,
                28.5064742
              ],
              [
                54.0119431,
                28.5064743
              ],
              [
                54.0113864,
                28.5067535
              ],
              [
                54.0105531,
                28.5067534
              ],
              [
                54.0091665,
                28.507312
              ],
              [
                54.0077765,
                28.507312
              ],
              [
                54.0077765,
                28.5075912
              ],
              [
                54.0030532,
                28.5075912
              ],
              [
                54.0002767,
                28.5084289
              ],
              [
                53.9586073,
                28.5150949
              ],
              [
                53.9572172,
                28.5150948
              ],
              [
                53.9411075,
                28.5189774
              ],
              [
                53.8966616,
                28.5314807
              ],
              [
                53.894995,
                28.5323184
              ],
              [
                53.8902716,
                28.5339849
              ],
              [
                53.8483257,
                28.5548123
              ],
              [
                53.8233226,
                28.5731447
              ],
              [
                53.8049896,
                28.5995404
              ],
              [
                53.803323,
                28.6025946
              ],
              [
                53.802213,
                28.6042612
              ],
              [
                53.7985997,
                28.6125945
              ],
              [
                53.7983231,
                28.6139819
              ],
              [
                53.7780433,
                28.6475955
              ],
              [
                53.7544337,
                28.670651
              ],
              [
                53.7494304,
                28.6737052
              ],
              [
                53.7483955,
                28.6743498
              ],
              [
                53.7194309,
                28.690932
              ],
              [
                53.7138743,
                28.6942567
              ],
              [
                53.7133194,
                28.6948152
              ],
              [
                53.711931,
                28.6959234
              ],
              [
                53.6938746,
                28.7050956
              ],
              [
                53.6927613,
                28.7056542
              ],
              [
                53.6897081,
                28.7087087
              ],
              [
                53.6794282,
                28.7209264
              ],
              [
                53.6777615,
                28.7237105
              ],
              [
                53.6760949,
                28.7264857
              ],
              [
                53.6758183,
                28.727594
              ],
              [
                53.668595,
                28.7378747
              ],
              [
                53.6683184,
                28.738983
              ],
              [
                53.6460953,
                28.7625905
              ],
              [
                53.6349822,
                28.7750973
              ],
              [
                53.6349821,
                28.775647
              ],
              [
                53.6324823,
                28.7781519
              ],
              [
                53.629149,
                28.7825943
              ],
              [
                53.6274823,
                28.7842613
              ],
              [
                53.625539,
                28.7870456
              ],
              [
                53.6253287,
                28.7873588
              ],
              [
                53.6247057,
                28.7889829
              ],
              [
                53.6247057,
                28.7892622
              ],
              [
                53.6247057,
                28.7895416
              ],
              [
                53.624149,
                28.7903707
              ],
              [
                53.6235923,
                28.7925963
              ],
              [
                53.6233157,
                28.7937047
              ],
              [
                53.622759,
                28.794822
              ],
              [
                53.6208157,
                28.7987057
              ],
              [
                53.6166492,
                28.8050946
              ],
              [
                53.6133565,
                28.806396
              ],
              [
                53.6060926,
                28.8092666
              ],
              [
                53.6052594,
                28.8092667
              ],
              [
                53.6041494,
                28.8098164
              ],
              [
                53.6033161,
                28.8098163
              ],
              [
                53.601926,
                28.8103751
              ],
              [
                53.6016494,
                28.8106544
              ],
              [
                53.6010927,
                28.8106543
              ],
              [
                53.5869263,
                28.8262077
              ],
              [
                53.5841462,
                28.8292625
              ],
              [
                53.5755365,
                28.8387063
              ],
              [
                53.5744231,
                28.8395444
              ],
              [
                53.5738697,
                28.8406527
              ],
              [
                53.5577566,
                28.8545394
              ],
              [
                53.5217697,
                28.8982826
              ],
              [
                53.5210872,
                28.8975974
              ],
              [
                53.5183106,
                28.8937044
              ],
              [
                53.4916444,
                28.8667591
              ],
              [
                53.4246953,
                28.810375
              ],
              [
                53.422472,
                28.8081582
              ],
              [
                53.4216388,
                28.8075996
              ],
              [
                53.4198208,
                28.8056123
              ],
              [
                53.4008057,
                28.7848199
              ],
              [
                53.4008058,
                28.7845407
              ],
              [
                53.4005292,
                28.7842612
              ],
              [
                53.400249,
                28.7837026
              ],
              [
                53.3999724,
                28.7828735
              ],
              [
                53.3991391,
                28.7820446
              ],
              [
                53.3877493,
                28.76815
              ],
              [
                53.3602497,
                28.7384333
              ],
              [
                53.3380268,
                28.7031494
              ],
              [
                53.3321901,
                28.6867604
              ],
              [
                53.3313568,
                28.6848142
              ],
              [
                53.3285802,
                28.6759306
              ],
              [
                53.3283036,
                28.6762099
              ],
              [
                53.2819109,
                28.6889858
              ],
              [
                53.2810775,
                28.6895444
              ],
              [
                53.279691,
                28.6900939
              ],
              [
                53.2788542,
                28.690094
              ],
              [
                53.278301,
                28.6906527
              ],
              [
                53.271911,
                28.6934277
              ],
              [
                53.2710777,
                28.6934276
              ],
              [
                53.2705211,
                28.6939863
              ],
              [
                53.2691344,
                28.6945359
              ],
              [
                53.2683012,
                28.6945359
              ],
              [
                53.2669111,
                28.6950944
              ],
              [
                53.2655212,
                28.6950944
              ],
              [
                53.2588546,
                28.6973109
              ],
              [
                53.2577446,
                28.6998157
              ],
              [
                53.2024621,
                28.7484259
              ],
              [
                53.2005188,
                28.7509307
              ],
              [
                53.1999621,
                28.7514803
              ],
              [
                53.1955189,
                28.7567605
              ],
              [
                53.1813525,
                28.7717632
              ],
              [
                53.1735726,
                28.7778725
              ],
              [
                53.1724626,
                28.7789898
              ],
              [
                53.1716293,
                28.7792691
              ],
              [
                53.1705192,
                28.7803776
              ],
              [
                53.1635727,
                28.7845405
              ],
              [
                53.1574627,
                28.7873249
              ],
              [
                53.1560728,
                28.7881539
              ],
              [
                53.1316265,
                28.7964889
              ],
              [
                53.1166267,
                28.8034274
              ],
              [
                53.1162202,
                28.8037508
              ],
              [
                53.0935704,
                28.821765
              ],
              [
                53.0919037,
                28.8228733
              ],
              [
                53.0763473,
                28.8351016
              ],
              [
                53.0688475,
                28.840932
              ],
              [
                53.0602342,
                28.846483
              ],
              [
                53.0530144,
                28.8498173
              ],
              [
                53.0405112,
                28.8537102
              ],
              [
                53.0394012,
                28.85426
              ],
              [
                53.0366247,
                28.8548187
              ],
              [
                53.0341246,
                28.8556477
              ],
              [
                52.9821753,
                28.8642628
              ],
              [
                52.9807888,
                28.8642628
              ],
              [
                52.9757855,
                28.8653801
              ],
              [
                52.9724522,
                28.8659299
              ],
              [
                52.9671757,
                28.8664886
              ],
              [
                52.9627324,
                28.8664887
              ],
              [
                52.960509,
                28.8662093
              ],
              [
                52.9430093,
                28.8662093
              ],
              [
                52.9410627,
                28.8659299
              ],
              [
                52.9385627,
                28.8659299
              ],
              [
                52.9277295,
                28.8645421
              ],
              [
                52.9268963,
                28.8645421
              ],
              [
                52.9257863,
                28.8645421
              ],
              [
                52.9255063,
                28.8634337
              ],
              [
                52.9252296,
                28.8606581
              ],
              [
                52.9255063,
                28.8598201
              ],
              [
                52.9252296,
                28.8592613
              ],
              [
                52.9230062,
                28.8439869
              ],
              [
                52.922453,
                28.8384268
              ],
              [
                52.9218964,
                28.8373184
              ],
              [
                52.9185631,
                28.8228733
              ],
              [
                52.9177298,
                28.8167637
              ],
              [
                52.9174497,
                28.8095458
              ],
              [
                52.9174497,
                28.8089872
              ],
              [
                52.917173,
                28.8084284
              ],
              [
                52.9160631,
                28.8073201
              ],
              [
                52.915783,
                28.8070408
              ],
              [
                52.9152297,
                28.8070407
              ],
              [
                52.9005067,
                28.8020396
              ],
              [
                52.900147,
                28.8019556
              ],
              [
                52.8482809,
                28.7898208
              ],
              [
                52.8374477,
                28.7867661
              ],
              [
                52.8360577,
                28.7867661
              ],
              [
                52.8113347,
                28.7792691
              ],
              [
                52.8071681,
                28.777593
              ],
              [
                52.8043915,
                28.7770434
              ],
              [
                52.8027249,
                28.7762054
              ],
              [
                52.7768886,
                28.7662036
              ],
              [
                52.7763353,
                28.7656539
              ],
              [
                52.7652221,
                28.7612026
              ],
              [
                52.7643887,
                28.7612025
              ],
              [
                52.7616122,
                28.759815
              ],
              [
                52.7593889,
                28.7578777
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554990,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خرامه",
          "name:ar": "مقاطعة خرامه",
          "name:en": "Kharameh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4814729",
          "wikipedia": "en:Kharameh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.9643989,
                29.4248299
              ],
              [
                52.964952,
                29.4240003
              ],
              [
                52.967452,
                29.4215027
              ],
              [
                52.9680087,
                29.4203846
              ],
              [
                52.9685654,
                29.4201142
              ],
              [
                52.973842,
                29.4148304
              ],
              [
                53.0238445,
                29.3901072
              ],
              [
                53.040791,
                29.3728861
              ],
              [
                53.0424576,
                29.3714976
              ],
              [
                53.0471775,
                29.3695501
              ],
              [
                53.0480108,
                29.3695501
              ],
              [
                53.0544007,
                29.3681706
              ],
              [
                53.0610673,
                29.3681706
              ],
              [
                53.0721806,
                29.3701091
              ],
              [
                53.0738471,
                29.3701091
              ],
              [
                53.0744038,
                29.3703886
              ],
              [
                53.0824569,
                29.3714976
              ],
              [
                53.0844037,
                29.3723361
              ],
              [
                53.1016268,
                29.3781696
              ],
              [
                53.1066267,
                29.3781696
              ],
              [
                53.1069034,
                29.3778901
              ],
              [
                53.1096833,
                29.3778901
              ],
              [
                53.1105166,
                29.3776105
              ],
              [
                53.1119033,
                29.3776106
              ],
              [
                53.1127365,
                29.3773311
              ],
              [
                53.1141265,
                29.3773311
              ],
              [
                53.1171832,
                29.3765016
              ],
              [
                53.1185698,
                29.3765016
              ],
              [
                53.1188499,
                29.3762222
              ],
              [
                53.1202364,
                29.3762221
              ],
              [
                53.1205164,
                29.3759426
              ],
              [
                53.1216264,
                29.3759426
              ],
              [
                53.1221831,
                29.3756631
              ],
              [
                53.1235697,
                29.3756631
              ],
              [
                53.1241264,
                29.3753836
              ],
              [
                53.1255164,
                29.375104
              ],
              [
                53.1285731,
                29.373995
              ],
              [
                53.131073,
                29.3739951
              ],
              [
                53.1313496,
                29.3737156
              ],
              [
                53.1319063,
                29.3737156
              ],
              [
                53.1330163,
                29.3734451
              ],
              [
                53.133573,
                29.3731656
              ],
              [
                53.1357928,
                29.3720566
              ],
              [
                53.1366261,
                29.3717771
              ],
              [
                53.145516,
                29.3681706
              ],
              [
                53.1471827,
                29.3678821
              ],
              [
                53.1799621,
                29.3581626
              ],
              [
                53.1841288,
                29.3581627
              ],
              [
                53.1860755,
                29.3578832
              ],
              [
                53.1919087,
                29.3578832
              ],
              [
                53.1932954,
                29.3576037
              ],
              [
                53.1966286,
                29.3576037
              ],
              [
                53.1971853,
                29.3573332
              ],
              [
                53.1985753,
                29.3573331
              ],
              [
                53.2127417,
                29.3528883
              ],
              [
                53.2180183,
                29.3498318
              ],
              [
                53.2224649,
                29.3470549
              ],
              [
                53.2241315,
                29.3462254
              ],
              [
                53.2310748,
                29.3412215
              ],
              [
                53.2502446,
                29.3328817
              ],
              [
                53.2510779,
                29.3328818
              ],
              [
                53.2513545,
                29.3326114
              ],
              [
                53.2524644,
                29.3326113
              ],
              [
                53.2527445,
                29.3323319
              ],
              [
                53.2532977,
                29.3323318
              ],
              [
                53.2569111,
                29.3312229
              ],
              [
                53.2580211,
                29.3312229
              ],
              [
                53.2585778,
                29.3309434
              ],
              [
                53.2613543,
                29.3309434
              ],
              [
                53.2616344,
                29.3312229
              ],
              [
                53.2627443,
                29.3312229
              ],
              [
                53.2830241,
                29.3439985
              ],
              [
                53.2871906,
                29.3464959
              ],
              [
                53.3002471,
                29.3523293
              ],
              [
                53.3196901,
                29.3567743
              ],
              [
                53.3210801,
                29.3567742
              ],
              [
                53.3213567,
                29.3570537
              ],
              [
                53.3238568,
                29.3570537
              ],
              [
                53.3244134,
                29.3573333
              ],
              [
                53.32747,
                29.3576037
              ],
              [
                53.3416365,
                29.3562152
              ],
              [
                53.3419131,
                29.3567742
              ],
              [
                53.3441364,
                29.3576037
              ],
              [
                53.3446931,
                29.3578832
              ],
              [
                53.3474436,
                29.358495
              ],
              [
                53.352193,
                29.3595512
              ],
              [
                53.3533029,
                29.3595512
              ],
              [
                53.3585829,
                29.3612192
              ],
              [
                53.3591362,
                29.3612192
              ],
              [
                53.3594163,
                29.3614987
              ],
              [
                53.3605262,
                29.3614987
              ],
              [
                53.3616362,
                29.3620487
              ],
              [
                53.3627495,
                29.3620487
              ],
              [
                53.4271952,
                29.3806672
              ],
              [
                53.4319184,
                29.3820558
              ],
              [
                53.4746978,
                29.3923344
              ],
              [
                53.5010873,
                29.3973385
              ],
              [
                53.5021973,
                29.3973385
              ],
              [
                53.5460901,
                29.4126035
              ],
              [
                53.5527567,
                29.4142716
              ],
              [
                53.5699797,
                29.4223324
              ],
              [
                53.577203,
                29.4256595
              ],
              [
                53.5777563,
                29.4256596
              ],
              [
                53.5780363,
                29.4259481
              ],
              [
                53.5813696,
                29.4337205
              ],
              [
                53.5822029,
                29.4362182
              ],
              [
                53.5883127,
                29.4534403
              ],
              [
                53.5891461,
                29.4573356
              ],
              [
                53.5899793,
                29.4815014
              ],
              [
                53.5897027,
                29.48289
              ],
              [
                53.5891461,
                29.4862263
              ],
              [
                53.5871796,
                29.4909718
              ],
              [
                53.5844262,
                29.4976151
              ],
              [
                53.5794228,
                29.5056675
              ],
              [
                53.5785895,
                29.5064971
              ],
              [
                53.5783129,
                29.5073357
              ],
              [
                53.5774795,
                29.5081653
              ],
              [
                53.577203,
                29.5090039
              ],
              [
                53.573313,
                29.5126109
              ],
              [
                53.5733129,
                29.5128904
              ],
              [
                53.5733129,
                29.5134495
              ],
              [
                53.5716463,
                29.5128904
              ],
              [
                53.5710896,
                29.5134495
              ],
              [
                53.5685896,
                29.5139996
              ],
              [
                53.5677563,
                29.5139996
              ],
              [
                53.5672031,
                29.5142791
              ],
              [
                53.5658131,
                29.5142791
              ],
              [
                53.5652564,
                29.5145586
              ],
              [
                53.5635898,
                29.5145587
              ],
              [
                53.5630365,
                29.5148381
              ],
              [
                53.5613664,
                29.5148382
              ],
              [
                53.5463667,
                29.5176156
              ],
              [
                53.5444234,
                29.5176155
              ],
              [
                53.5430334,
                29.5178861
              ],
              [
                53.5410902,
                29.5178861
              ],
              [
                53.5397001,
                29.5181657
              ],
              [
                53.5377569,
                29.5181656
              ],
              [
                53.5344235,
                29.5187247
              ],
              [
                53.5330335,
                29.5187247
              ],
              [
                53.4980307,
                29.5287252
              ],
              [
                53.4969208,
                29.5290046
              ],
              [
                53.4966441,
                29.5292752
              ],
              [
                53.4944208,
                29.5298342
              ],
              [
                53.4941197,
                29.5300128
              ],
              [
                53.4560847,
                29.5595564
              ],
              [
                53.4541893,
                29.5618743
              ],
              [
                53.4510848,
                29.5656705
              ],
              [
                53.4463614,
                29.5723347
              ],
              [
                53.4363197,
                29.5908509
              ],
              [
                53.4233052,
                29.6148367
              ],
              [
                53.4174719,
                29.6301136
              ],
              [
                53.4144187,
                29.6431722
              ],
              [
                53.4146954,
                29.6462295
              ],
              [
                53.4144186,
                29.6467796
              ],
              [
                53.4146953,
                29.6498368
              ],
              [
                53.4146953,
                29.6501164
              ],
              [
                53.4141386,
                29.650396
              ],
              [
                53.4136772,
                29.6504858
              ],
              [
                53.412472,
                29.6506665
              ],
              [
                53.4119187,
                29.6509461
              ],
              [
                53.4055287,
                29.6509461
              ],
              [
                53.4049721,
                29.6512256
              ],
              [
                53.4019154,
                29.6512256
              ],
              [
                53.4013622,
                29.6515053
              ],
              [
                53.3988623,
                29.6515053
              ],
              [
                53.3916389,
                29.6515052
              ],
              [
                53.3905257,
                29.6512257
              ],
              [
                53.3869157,
                29.6512257
              ],
              [
                53.3855257,
                29.6509461
              ],
              [
                53.3816392,
                29.6509461
              ],
              [
                53.3808058,
                29.6506665
              ],
              [
                53.3786217,
                29.6506666
              ],
              [
                53.3749726,
                29.6506665
              ],
              [
                53.3741393,
                29.6503959
              ],
              [
                53.3710827,
                29.650396
              ],
              [
                53.3702493,
                29.6501164
              ],
              [
                53.3327465,
                29.6501164
              ],
              [
                53.3310798,
                29.6498368
              ],
              [
                53.3277467,
                29.6498368
              ],
              [
                53.3266366,
                29.6495573
              ],
              [
                53.3146901,
                29.6495572
              ],
              [
                53.2810772,
                29.6506664
              ],
              [
                53.2769106,
                29.6512256
              ],
              [
                53.2755207,
                29.6512257
              ],
              [
                53.2749673,
                29.6512257
              ],
              [
                53.2744107,
                29.6512257
              ],
              [
                53.2735773,
                29.6515052
              ],
              [
                53.2619109,
                29.6517757
              ],
              [
                53.2616342,
                29.6520644
              ],
              [
                53.2591309,
                29.6520643
              ],
              [
                53.2380213,
                29.6551127
              ],
              [
                53.2299647,
                29.6565015
              ],
              [
                53.2263548,
                29.6573402
              ],
              [
                53.2144083,
                29.6601179
              ],
              [
                53.185242,
                29.6692808
              ],
              [
                53.178572,
                29.6712288
              ],
              [
                53.1480159,
                29.6842879
              ],
              [
                53.1455159,
                29.6851176
              ],
              [
                53.1430159,
                29.6865064
              ],
              [
                53.1421826,
                29.6865064
              ],
              [
                53.1380161,
                29.6884454
              ],
              [
                53.1371827,
                29.6890046
              ],
              [
                53.136626,
                29.6892842
              ],
              [
                53.1360728,
                29.6895548
              ],
              [
                53.1021798,
                29.7028936
              ],
              [
                53.0994033,
                29.7042826
              ],
              [
                53.0977366,
                29.7051122
              ],
              [
                53.09718,
                29.7040029
              ],
              [
                53.0969033,
                29.7034437
              ],
              [
                53.09496,
                29.7015047
              ],
              [
                53.0899567,
                29.6978881
              ],
              [
                53.052734,
                29.650946
              ],
              [
                53.051344,
                29.6462293
              ],
              [
                53.0510674,
                29.6431721
              ],
              [
                53.051344,
                29.6423334
              ],
              [
                53.051344,
                29.6403944
              ],
              [
                53.051624,
                29.6381669
              ],
              [
                53.0519007,
                29.6362279
              ],
              [
                53.0521773,
                29.6356688
              ],
              [
                53.0521773,
                29.6340004
              ],
              [
                53.052734,
                29.6298339
              ],
              [
                53.0530141,
                29.6251174
              ],
              [
                53.0532906,
                29.6245582
              ],
              [
                53.0530141,
                29.6114998
              ],
              [
                53.0535673,
                29.6037262
              ],
              [
                53.0532907,
                29.6023374
              ],
              [
                53.0519007,
                29.5884496
              ],
              [
                53.0505108,
                29.5728936
              ],
              [
                53.0507908,
                29.572055
              ],
              [
                53.0505108,
                29.5712253
              ],
              [
                53.0507907,
                29.5709458
              ],
              [
                53.0480107,
                29.5676092
              ],
              [
                53.049124,
                29.5665001
              ],
              [
                53.0292441,
                29.5620627
              ],
              [
                53.0499882,
                29.5383551
              ],
              [
                53.0511736,
                29.5211671
              ],
              [
                53.0745782,
                29.5107888
              ],
              [
                53.07522,
                29.504292
              ],
              [
                53.0694797,
                29.4999185
              ],
              [
                53.0496774,
                29.49344
              ],
              [
                53.0466241,
                29.4926104
              ],
              [
                53.0455107,
                29.4926104
              ],
              [
                53.0452342,
                29.4923308
              ],
              [
                53.0444009,
                29.4923309
              ],
              [
                53.0441242,
                29.4920513
              ],
              [
                53.0413442,
                29.4915012
              ],
              [
                53.0227346,
                29.485108
              ],
              [
                53.0143979,
                29.4815012
              ],
              [
                53.0135646,
                29.4815011
              ],
              [
                53.0127313,
                29.4809421
              ],
              [
                53.0110646,
                29.4803921
              ],
              [
                53.0099546,
                29.480392
              ],
              [
                53.0085647,
                29.479833
              ],
              [
                53.007178,
                29.4798329
              ],
              [
                53.0041215,
                29.4790033
              ],
              [
                53.0030115,
                29.4790034
              ],
              [
                52.9988449,
                29.4776148
              ],
              [
                52.9977315,
                29.4776148
              ],
              [
                52.994675,
                29.4767762
              ],
              [
                52.9930083,
                29.4767761
              ],
              [
                52.9927315,
                29.4764966
              ],
              [
                52.9907883,
                29.4764967
              ],
              [
                52.9905083,
                29.4762261
              ],
              [
                52.989675,
                29.4762261
              ],
              [
                52.9891217,
                29.4756671
              ],
              [
                52.9824551,
                29.4673353
              ],
              [
                52.9752319,
                29.4456676
              ],
              [
                52.973842,
                29.4395542
              ],
              [
                52.9732853,
                29.4390042
              ],
              [
                52.9710653,
                29.4320522
              ],
              [
                52.9705087,
                29.4312228
              ],
              [
                52.9693987,
                29.4281661
              ],
              [
                52.9682853,
                29.4264979
              ],
              [
                52.9663421,
                29.4251094
              ],
              [
                52.9657853,
                29.4248298
              ],
              [
                52.9643989,
                29.4248299
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554992,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خرم بید",
          "name:en": "Khorambid County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270545",
          "wikipedia": "en:Khorrambid County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.8202237,
                30.4431826
              ],
              [
                52.8205003,
                30.4426322
              ],
              [
                52.8524465,
                30.3901331
              ],
              [
                52.8527265,
                30.3890141
              ],
              [
                52.8674496,
                30.3684589
              ],
              [
                52.8871727,
                30.349853
              ],
              [
                52.8893926,
                30.3473536
              ],
              [
                52.8910592,
                30.3462437
              ],
              [
                52.8977259,
                30.3398554
              ],
              [
                52.8988392,
                30.3376356
              ],
              [
                52.9030058,
                30.3390161
              ],
              [
                52.9043959,
                30.3390162
              ],
              [
                52.9046726,
                30.3392959
              ],
              [
                52.9068958,
                30.3392959
              ],
              [
                52.9077291,
                30.3395755
              ],
              [
                52.908839,
                30.3395756
              ],
              [
                52.9096725,
                30.3398553
              ],
              [
                52.9118957,
                30.3398553
              ],
              [
                52.9141157,
                30.3404057
              ],
              [
                52.9166156,
                30.3404057
              ],
              [
                52.9193956,
                30.3409652
              ],
              [
                52.9205055,
                30.3409651
              ],
              [
                52.9213389,
                30.3412449
              ],
              [
                52.9249522,
                30.3412449
              ],
              [
                52.9266188,
                30.3415156
              ],
              [
                52.9327287,
                30.3415156
              ],
              [
                52.9341188,
                30.3417953
              ],
              [
                52.9449519,
                30.3417953
              ],
              [
                52.9466185,
                30.3415156
              ],
              [
                52.9496751,
                30.3415156
              ],
              [
                52.9518951,
                30.3417953
              ],
              [
                52.9605084,
                30.3417954
              ],
              [
                52.9696749,
                30.3426344
              ],
              [
                53.0013444,
                30.347913
              ],
              [
                53.0074542,
                30.3490139
              ],
              [
                53.008011,
                30.3492936
              ],
              [
                53.0116208,
                30.3492936
              ],
              [
                53.0130109,
                30.3495733
              ],
              [
                53.0135641,
                30.3495733
              ],
              [
                53.0138443,
                30.3479131
              ],
              [
                53.0141209,
                30.3479131
              ],
              [
                53.0146776,
                30.3479131
              ],
              [
                53.0155108,
                30.3476334
              ],
              [
                53.0157876,
                30.3476334
              ],
              [
                53.0166209,
                30.3476334
              ],
              [
                53.0171775,
                30.3476334
              ],
              [
                53.0174542,
                30.3473536
              ],
              [
                53.0177342,
                30.3473536
              ],
              [
                53.0182875,
                30.3473536
              ],
              [
                53.0185675,
                30.3473536
              ],
              [
                53.0191209,
                30.3473536
              ],
              [
                53.0196775,
                30.3473536
              ],
              [
                53.0199541,
                30.3473536
              ],
              [
                53.0210675,
                30.3473536
              ],
              [
                53.0219008,
                30.3473536
              ],
              [
                53.0224541,
                30.3473536
              ],
              [
                53.0232874,
                30.3476334
              ],
              [
                53.023844,
                30.3476333
              ],
              [
                53.0246774,
                30.3476334
              ],
              [
                53.0260674,
                30.3476334
              ],
              [
                53.0266207,
                30.3476334
              ],
              [
                53.027734,
                30.347913
              ],
              [
                53.0291206,
                30.347913
              ],
              [
                53.0299539,
                30.347913
              ],
              [
                53.0316205,
                30.3479131
              ],
              [
                53.0335672,
                30.3479131
              ],
              [
                53.0346773,
                30.3479131
              ],
              [
                53.036624,
                30.3481838
              ],
              [
                53.039124,
                30.3481837
              ],
              [
                53.0402339,
                30.3484634
              ],
              [
                53.0430104,
                30.3484635
              ],
              [
                53.0455103,
                30.3487432
              ],
              [
                53.0469004,
                30.3490139
              ],
              [
                53.049677,
                30.3490139
              ],
              [
                53.052177,
                30.3492936
              ],
              [
                53.0532903,
                30.3492936
              ],
              [
                53.0557904,
                30.3495733
              ],
              [
                53.0580137,
                30.3495734
              ],
              [
                53.0591236,
                30.3495733
              ],
              [
                53.0610668,
                30.3495733
              ],
              [
                53.0632902,
                30.3495734
              ],
              [
                53.0646801,
                30.3495734
              ],
              [
                53.0669,
                30.3495734
              ],
              [
                53.0680135,
                30.3495733
              ],
              [
                53.0705134,
                30.3495733
              ],
              [
                53.07329,
                30.3498531
              ],
              [
                53.07607,
                30.3498531
              ],
              [
                53.0774567,
                30.3498531
              ],
              [
                53.0802366,
                30.3498531
              ],
              [
                53.0816232,
                30.3498531
              ],
              [
                53.0844033,
                30.3501328
              ],
              [
                53.0871798,
                30.3501328
              ],
              [
                53.0882898,
                30.3501328
              ],
              [
                53.0910698,
                30.3501328
              ],
              [
                53.0932931,
                30.3498531
              ],
              [
                53.0946797,
                30.3498531
              ],
              [
                53.0966264,
                30.3498531
              ],
              [
                53.0988463,
                30.3495733
              ],
              [
                53.0999597,
                30.3495733
              ],
              [
                53.1019029,
                30.3495734
              ],
              [
                53.1035697,
                30.3492936
              ],
              [
                53.1046795,
                30.3492936
              ],
              [
                53.1063462,
                30.3490139
              ],
              [
                53.1080128,
                30.3490139
              ],
              [
                53.1088462,
                30.3490139
              ],
              [
                53.1107928,
                30.3490139
              ],
              [
                53.1124595,
                30.3490139
              ],
              [
                53.1135694,
                30.3490139
              ],
              [
                53.1155162,
                30.3487432
              ],
              [
                53.1174593,
                30.3487432
              ],
              [
                53.1185694,
                30.3484635
              ],
              [
                53.1207927,
                30.3484635
              ],
              [
                53.123016,
                30.347913
              ],
              [
                53.1244026,
                30.3479131
              ],
              [
                53.1269026,
                30.3473537
              ],
              [
                53.129406,
                30.3470739
              ],
              [
                53.1305158,
                30.3467942
              ],
              [
                53.1330159,
                30.3465145
              ],
              [
                53.1344059,
                30.3465145
              ],
              [
                53.1366257,
                30.3462438
              ],
              [
                53.1388491,
                30.345964
              ],
              [
                53.1399591,
                30.3459641
              ],
              [
                53.1421824,
                30.3456844
              ],
              [
                53.143849,
                30.3456843
              ],
              [
                53.144959,
                30.3454046
              ],
              [
                53.1466256,
                30.3454046
              ],
              [
                53.1480156,
                30.3454046
              ],
              [
                53.1488489,
                30.3454046
              ],
              [
                53.1499623,
                30.3454047
              ],
              [
                53.1510722,
                30.3454046
              ],
              [
                53.1516289,
                30.3454046
              ],
              [
                53.1527389,
                30.3454046
              ],
              [
                53.1538489,
                30.3454046
              ],
              [
                53.1544055,
                30.3454046
              ],
              [
                53.1557956,
                30.3454047
              ],
              [
                53.1571822,
                30.3454047
              ],
              [
                53.1580155,
                30.3454047
              ],
              [
                53.1594055,
                30.3454046
              ],
              [
                53.161072,
                30.3454047
              ],
              [
                53.1669053,
                30.3451249
              ],
              [
                53.168852,
                30.3448542
              ],
              [
                53.1707953,
                30.3445745
              ],
              [
                53.1719052,
                30.3442948
              ],
              [
                53.173852,
                30.3440151
              ],
              [
                53.1749618,
                30.3440151
              ],
              [
                53.1771852,
                30.3437354
              ],
              [
                53.1794051,
                30.3434647
              ],
              [
                53.1805185,
                30.343185
              ],
              [
                53.1827384,
                30.3429053
              ],
              [
                53.1849617,
                30.3426346
              ],
              [
                53.1857951,
                30.3426346
              ],
              [
                53.1877417,
                30.3423548
              ],
              [
                53.1891284,
                30.3423548
              ],
              [
                53.1896851,
                30.3423548
              ],
              [
                53.190795,
                30.3420751
              ],
              [
                53.1913517,
                30.3420751
              ],
              [
                53.1919084,
                30.3420751
              ],
              [
                53.1924616,
                30.3420751
              ],
              [
                53.201245,
                30.3404638
              ],
              [
                53.2031171,
                30.3256005
              ],
              [
                53.2029369,
                30.3104635
              ],
              [
                53.200774,
                30.283918
              ],
              [
                53.1847579,
                30.2454655
              ],
              [
                53.2045076,
                30.24224
              ],
              [
                53.2167385,
                30.2422845
              ],
              [
                53.2168157,
                30.2340536
              ],
              [
                53.2170409,
                30.2218995
              ],
              [
                53.2261046,
                30.2208538
              ],
              [
                53.3127553,
                30.2152947
              ],
              [
                53.30719,
                30.2342883
              ],
              [
                53.2969101,
                30.265687
              ],
              [
                53.2960768,
                30.2698465
              ],
              [
                53.2913569,
                30.2837416
              ],
              [
                53.2913569,
                30.2845717
              ],
              [
                53.2908002,
                30.2856905
              ],
              [
                53.2905236,
                30.2873507
              ],
              [
                53.2888569,
                30.2904095
              ],
              [
                53.2885769,
                30.2906801
              ],
              [
                53.2883003,
                30.2920697
              ],
              [
                53.2891336,
                30.2951284
              ],
              [
                53.2891336,
                30.2954081
              ],
              [
                53.2894102,
                30.2962382
              ],
              [
                53.2977434,
                30.2990172
              ],
              [
                53.3171899,
                30.3009572
              ],
              [
                53.3180231,
                30.3012369
              ],
              [
                53.3196898,
                30.3012369
              ],
              [
                53.3205232,
                30.3015167
              ],
              [
                53.3221897,
                30.3015166
              ],
              [
                53.3324696,
                30.304016
              ],
              [
                53.356916,
                30.3079048
              ],
              [
                53.3599692,
                30.3092944
              ],
              [
                53.3602493,
                30.3095741
              ],
              [
                53.3610826,
                30.3101245
              ],
              [
                53.3610826,
                30.3120735
              ],
              [
                53.3613592,
                30.3126329
              ],
              [
                53.3610826,
                30.3168015
              ],
              [
                53.3610826,
                30.3184618
              ],
              [
                53.3608026,
                30.3204107
              ],
              [
                53.3610825,
                30.341245
              ],
              [
                53.3608026,
                30.3420751
              ],
              [
                53.3605258,
                30.3459642
              ],
              [
                53.3602493,
                30.3487433
              ],
              [
                53.3599691,
                30.350963
              ],
              [
                53.3596925,
                30.3545723
              ],
              [
                53.3594159,
                30.3581905
              ],
              [
                53.3591358,
                30.3648497
              ],
              [
                53.3613592,
                30.4101293
              ],
              [
                53.3613592,
                30.4108496
              ],
              [
                53.3727919,
                30.430988
              ],
              [
                53.3834151,
                30.4389813
              ],
              [
                53.4123724,
                30.4430943
              ],
              [
                53.4199914,
                30.4444541
              ],
              [
                53.427569,
                30.4524289
              ],
              [
                53.4168388,
                30.4603166
              ],
              [
                53.3785681,
                30.4786508
              ],
              [
                53.3693566,
                30.4865423
              ],
              [
                53.3691356,
                30.4881848
              ],
              [
                53.3702491,
                30.4990226
              ],
              [
                53.373859,
                30.5118007
              ],
              [
                53.3749724,
                30.5215198
              ],
              [
                53.3758057,
                30.5265191
              ],
              [
                53.3758056,
                30.532078
              ],
              [
                53.3758057,
                30.5324507
              ],
              [
                53.3758057,
                30.533188
              ],
              [
                53.3760822,
                30.5340182
              ],
              [
                53.3755256,
                30.5345777
              ],
              [
                53.374139,
                30.5351372
              ],
              [
                53.3735822,
                30.5351372
              ],
              [
                53.3733023,
                30.535417
              ],
              [
                53.3699689,
                30.5354169
              ],
              [
                53.3671924,
                30.5365269
              ],
              [
                53.364969,
                30.5373572
              ],
              [
                53.3388595,
                30.5498558
              ],
              [
                53.2960768,
                30.5806922
              ],
              [
                53.2852435,
                30.5906913
              ],
              [
                53.2805236,
                30.5965211
              ],
              [
                53.276077,
                30.6031903
              ],
              [
                53.2755203,
                30.60347
              ],
              [
                53.2749671,
                30.6043003
              ],
              [
                53.2732735,
                30.6063452
              ],
              [
                53.2730203,
                30.6070799
              ],
              [
                53.3138564,
                30.639298
              ],
              [
                53.3280229,
                30.6537467
              ],
              [
                53.3346894,
                30.6648654
              ],
              [
                53.3366361,
                30.6679157
              ],
              [
                53.3391361,
                30.6709752
              ],
              [
                53.4302514,
                30.7359739
              ],
              [
                53.4471945,
                30.7459739
              ],
              [
                53.4471946,
                30.7462447
              ],
              [
                53.4487552,
                30.7471871
              ],
              [
                53.4444179,
                30.7515245
              ],
              [
                53.4433079,
                30.7540245
              ],
              [
                53.4327514,
                30.7662448
              ],
              [
                53.4246948,
                30.7773641
              ],
              [
                53.3955286,
                30.8120852
              ],
              [
                53.3880253,
                30.8173652
              ],
              [
                53.3833054,
                30.8206957
              ],
              [
                53.3774721,
                30.8254161
              ],
              [
                53.3635824,
                30.8331963
              ],
              [
                53.2994133,
                30.8637484
              ],
              [
                53.2858002,
                30.8701387
              ],
              [
                53.2799669,
                30.8723591
              ],
              [
                53.2774669,
                30.8731985
              ],
              [
                53.2746868,
                30.8745795
              ],
              [
                53.2735769,
                30.8751391
              ],
              [
                53.2730203,
                30.8754189
              ],
              [
                53.2724669,
                30.8756987
              ],
              [
                53.2638537,
                30.880699
              ],
              [
                53.2624671,
                30.882089
              ],
              [
                53.2530205,
                30.8881995
              ],
              [
                53.247744,
                30.8909795
              ],
              [
                53.2460774,
                30.8915301
              ],
              [
                53.2441307,
                30.8926403
              ],
              [
                53.24368,
                30.8929811
              ],
              [
                53.2432973,
                30.8920807
              ],
              [
                53.242464,
                30.8904199
              ],
              [
                53.2246877,
                30.8693084
              ],
              [
                53.2155177,
                30.8559772
              ],
              [
                53.2146844,
                30.8554175
              ],
              [
                53.1685718,
                30.8109751
              ],
              [
                53.1391255,
                30.7890339
              ],
              [
                53.1335723,
                30.7856946
              ],
              [
                53.1330157,
                30.785135
              ],
              [
                53.1252358,
                30.7818045
              ],
              [
                53.1238491,
                30.7818046
              ],
              [
                53.1191258,
                30.7798641
              ],
              [
                53.1182926,
                30.7798641
              ],
              [
                53.1149592,
                30.7784741
              ],
              [
                53.1141259,
                30.7784741
              ],
              [
                53.0985694,
                30.7743044
              ],
              [
                53.0949595,
                30.7743044
              ],
              [
                53.0946796,
                30.7745841
              ],
              [
                53.0896796,
                30.7745841
              ],
              [
                53.0888462,
                30.7748639
              ],
              [
                53.0857896,
                30.774864
              ],
              [
                53.0849563,
                30.7751437
              ],
              [
                53.0719032,
                30.7768044
              ],
              [
                53.06968,
                30.7768044
              ],
              [
                53.0685665,
                30.7762449
              ],
              [
                53.0668999,
                30.7762449
              ],
              [
                53.0660666,
                30.7768044
              ],
              [
                53.0652333,
                30.7770842
              ],
              [
                53.0646799,
                30.777364
              ],
              [
                53.0644,
                30.7776348
              ],
              [
                53.0452335,
                30.7848642
              ],
              [
                53.0124539,
                30.7945846
              ],
              [
                52.9663413,
                30.8056951
              ],
              [
                52.9363383,
                30.8154156
              ],
              [
                52.9341185,
                30.8156953
              ],
              [
                52.9310619,
                30.8165258
              ],
              [
                52.916062,
                30.8195854
              ],
              [
                52.8946723,
                30.8270856
              ],
              [
                52.8893924,
                30.829306
              ],
              [
                52.8802259,
                30.8323658
              ],
              [
                52.8716161,
                30.8348658
              ],
              [
                52.8683504,
                30.8348658
              ],
              [
                52.8688361,
                30.8340264
              ],
              [
                52.868836,
                30.8337557
              ],
              [
                52.8863393,
                30.804305
              ],
              [
                52.8924491,
                30.7793045
              ],
              [
                52.8927256,
                30.7762448
              ],
              [
                52.8930057,
                30.7731942
              ],
              [
                52.8932824,
                30.7701345
              ],
              [
                52.893559,
                30.7651345
              ],
              [
                52.893839,
                30.7593041
              ],
              [
                52.8941158,
                30.7501435
              ],
              [
                52.8943923,
                30.7476343
              ],
              [
                52.8944234,
                30.7474501
              ],
              [
                52.8945431,
                30.7467402
              ],
              [
                52.8946724,
                30.7459737
              ],
              [
                52.8952256,
                30.7395838
              ],
              [
                52.8955057,
                30.7381939
              ],
              [
                52.8930058,
                30.7181941
              ],
              [
                52.8924492,
                30.7156941
              ],
              [
                52.8916159,
                30.7140245
              ],
              [
                52.8793927,
                30.6904149
              ],
              [
                52.8696694,
                30.6776354
              ],
              [
                52.8992488,
                30.6414048
              ],
              [
                52.9089746,
                30.6183331
              ],
              [
                52.9012832,
                30.5993651
              ],
              [
                52.8965088,
                30.5816314
              ],
              [
                52.8970191,
                30.5792521
              ],
              [
                52.8989919,
                30.5777504
              ],
              [
                52.898841,
                30.5765929
              ],
              [
                52.8991261,
                30.5742646
              ],
              [
                52.9018924,
                30.5706929
              ],
              [
                52.9027291,
                30.5706929
              ],
              [
                52.9030057,
                30.5704131
              ],
              [
                52.9138389,
                30.5670742
              ],
              [
                52.9152288,
                30.5623544
              ],
              [
                52.9155055,
                30.5618039
              ],
              [
                52.9149488,
                30.5520757
              ],
              [
                52.9113389,
                30.541797
              ],
              [
                52.9077291,
                30.534018
              ],
              [
                52.907729,
                30.5331879
              ],
              [
                52.8980057,
                30.5159697
              ],
              [
                52.8952257,
                30.5118006
              ],
              [
                52.885226,
                30.4968026
              ],
              [
                52.8721695,
                30.4817957
              ],
              [
                52.8360567,
                30.4515207
              ],
              [
                52.8349467,
                30.4512409
              ],
              [
                52.8332802,
                30.450131
              ],
              [
                52.8324468,
                30.450131
              ],
              [
                52.8266135,
                30.4473516
              ],
              [
                52.8232802,
                30.4462418
              ],
              [
                52.8202237,
                30.4431826
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555000,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خنج",
          "name:en": "Khonj County",
          "name:uk": "Хондж",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2422264",
          "wikipedia": "en:Khonj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.3977082,
                28.0300842
              ],
              [
                52.3985416,
                28.0298051
              ],
              [
                52.4021514,
                28.0278606
              ],
              [
                52.4327076,
                28.0084154
              ],
              [
                52.4352076,
                28.0056337
              ],
              [
                52.4354877,
                28.0050846
              ],
              [
                52.4432643,
                27.9984139
              ],
              [
                52.4677105,
                27.9850818
              ],
              [
                52.4727105,
                27.9817511
              ],
              [
                52.474377,
                27.981193
              ],
              [
                52.4868769,
                27.9734153
              ],
              [
                52.4882668,
                27.9731363
              ],
              [
                52.4974591,
                27.9678249
              ],
              [
                52.5132665,
                27.9586884
              ],
              [
                52.5182664,
                27.9553578
              ],
              [
                52.5471593,
                27.9392451
              ],
              [
                52.547436,
                27.938696
              ],
              [
                52.5507693,
                27.9364636
              ],
              [
                52.5985485,
                27.9078576
              ],
              [
                52.6016052,
                27.9064625
              ],
              [
                52.6018818,
                27.9061925
              ],
              [
                52.605215,
                27.9056344
              ],
              [
                52.6099384,
                27.9042484
              ],
              [
                52.6255647,
                27.8964812
              ],
              [
                52.6471611,
                27.8881366
              ],
              [
                52.6479944,
                27.8884067
              ],
              [
                52.6538276,
                27.8884066
              ],
              [
                52.6543844,
                27.8886857
              ],
              [
                52.6679975,
                27.8886857
              ],
              [
                52.6696641,
                27.8884066
              ],
              [
                52.6666633,
                27.8941893
              ],
              [
                52.6717643,
                27.8987652
              ],
              [
                52.6765625,
                27.9024821
              ],
              [
                52.6805715,
                27.9069438
              ],
              [
                52.6813729,
                27.9092527
              ],
              [
                52.7071925,
                27.8903649
              ],
              [
                52.714064,
                27.8854582
              ],
              [
                52.7339457,
                27.8735261
              ],
              [
                52.7484455,
                27.8654092
              ],
              [
                52.7579444,
                27.8618985
              ],
              [
                52.7707466,
                27.8560061
              ],
              [
                52.7829606,
                27.8523833
              ],
              [
                52.8040917,
                27.8492205
              ],
              [
                52.8257291,
                27.8431437
              ],
              [
                52.8442403,
                27.8336906
              ],
              [
                52.8487098,
                27.8297435
              ],
              [
                52.8596711,
                27.8164667
              ],
              [
                52.8776052,
                27.8016935
              ],
              [
                52.8861133,
                27.7955755
              ],
              [
                52.8944215,
                27.7911295
              ],
              [
                52.9080545,
                27.7825299
              ],
              [
                52.9254837,
                27.7744928
              ],
              [
                52.9369267,
                27.769488
              ],
              [
                52.9598377,
                27.7617413
              ],
              [
                52.9723304,
                27.7578215
              ],
              [
                52.9824418,
                27.7564342
              ],
              [
                52.9916225,
                27.7553598
              ],
              [
                52.9955257,
                27.7548252
              ],
              [
                52.9995932,
                27.7546222
              ],
              [
                53.0099555,
                27.7509142
              ],
              [
                53.0138455,
                27.7492404
              ],
              [
                53.0318704,
                27.7454192
              ],
              [
                53.0563091,
                27.7385443
              ],
              [
                53.0735463,
                27.7340164
              ],
              [
                53.0826602,
                27.731643
              ],
              [
                53.0938338,
                27.7288181
              ],
              [
                53.1037216,
                27.7266283
              ],
              [
                53.1266103,
                27.7218995
              ],
              [
                53.1504821,
                27.7156737
              ],
              [
                53.1722177,
                27.7103744
              ],
              [
                53.1952386,
                27.7051193
              ],
              [
                53.2163142,
                27.6972083
              ],
              [
                53.2426638,
                27.6872573
              ],
              [
                53.2490157,
                27.6840602
              ],
              [
                53.2559643,
                27.6817741
              ],
              [
                53.2724373,
                27.6705354
              ],
              [
                53.2770471,
                27.6662533
              ],
              [
                53.2791871,
                27.6627224
              ],
              [
                53.2858454,
                27.6660677
              ],
              [
                53.2925894,
                27.6694383
              ],
              [
                53.301876,
                27.6752914
              ],
              [
                53.3143329,
                27.6834522
              ],
              [
                53.325308,
                27.6915059
              ],
              [
                53.3382794,
                27.6978744
              ],
              [
                53.3487308,
                27.7055364
              ],
              [
                53.3622709,
                27.7141859
              ],
              [
                53.3667692,
                27.7143628
              ],
              [
                53.3729605,
                27.7133821
              ],
              [
                53.3829027,
                27.7103046
              ],
              [
                53.3976508,
                27.7048522
              ],
              [
                53.4132842,
                27.6996587
              ],
              [
                53.4222116,
                27.6970899
              ],
              [
                53.4293106,
                27.695738
              ],
              [
                53.4348981,
                27.696726
              ],
              [
                53.4438244,
                27.6968099
              ],
              [
                53.4535091,
                27.695797
              ],
              [
                53.463629,
                27.6946571
              ],
              [
                53.466495,
                27.7036435
              ],
              [
                53.46774,
                27.7082537
              ],
              [
                53.4732913,
                27.736567
              ],
              [
                53.4853468,
                27.7652235
              ],
              [
                53.4973584,
                27.7939645
              ],
              [
                53.5013248,
                27.8031601
              ],
              [
                53.5113253,
                27.8006078
              ],
              [
                53.5274774,
                27.7961902
              ],
              [
                53.5560903,
                27.7856337
              ],
              [
                53.571067,
                27.7810028
              ],
              [
                53.6261567,
                27.8330746
              ],
              [
                53.689223,
                27.8377094
              ],
              [
                53.6946809,
                27.8528613
              ],
              [
                53.7288742,
                27.8714676
              ],
              [
                53.7124844,
                27.8775791
              ],
              [
                53.6805417,
                27.8920253
              ],
              [
                53.6749851,
                27.8945275
              ],
              [
                53.6149826,
                27.9328544
              ],
              [
                53.6124393,
                27.9361274
              ],
              [
                53.6116494,
                27.9381382
              ],
              [
                53.5983129,
                27.9481389
              ],
              [
                53.5780366,
                27.9561863
              ],
              [
                53.5733133,
                27.9575816
              ],
              [
                53.5730366,
                27.9578606
              ],
              [
                53.5691468,
                27.9592469
              ],
              [
                53.5680368,
                27.9595261
              ],
              [
                53.5672034,
                27.9595259
              ],
              [
                53.5663701,
                27.9600841
              ],
              [
                53.5588667,
                27.9620284
              ],
              [
                53.5580334,
                27.9625775
              ],
              [
                53.5569235,
                27.9625775
              ],
              [
                53.5388671,
                27.9678525
              ],
              [
                53.5217212,
                27.9751727
              ],
              [
                53.5180341,
                27.9767464
              ],
              [
                53.5160875,
                27.9773045
              ],
              [
                53.4910879,
                27.9889711
              ],
              [
                53.4796981,
                27.9984143
              ],
              [
                53.4796981,
                27.9986934
              ],
              [
                53.4791414,
                27.9998007
              ],
              [
                53.4766414,
                27.9998007
              ],
              [
                53.4738648,
                28.0028614
              ],
              [
                53.4735882,
                28.0034105
              ],
              [
                53.4699749,
                28.0086949
              ],
              [
                53.4696983,
                28.0095231
              ],
              [
                53.4694215,
                28.0103602
              ],
              [
                53.4691415,
                28.0111885
              ],
              [
                53.4685883,
                28.0148074
              ],
              [
                53.4691415,
                28.0250792
              ],
              [
                53.4696983,
                28.0303548
              ],
              [
                53.4721982,
                28.0467485
              ],
              [
                53.4724748,
                28.0478649
              ],
              [
                53.4721982,
                28.0484141
              ],
              [
                53.4724748,
                28.0520242
              ],
              [
                53.4724442,
                28.0521159
              ],
              [
                53.4721982,
                28.0528525
              ],
              [
                53.4724748,
                28.054527
              ],
              [
                53.4721982,
                28.054806
              ],
              [
                53.4719216,
                28.0684185
              ],
              [
                53.4716415,
                28.0706332
              ],
              [
                53.4677516,
                28.0798074
              ],
              [
                53.4421953,
                28.1036931
              ],
              [
                53.4413619,
                28.1039721
              ],
              [
                53.4405286,
                28.1048005
              ],
              [
                53.4396953,
                28.1050796
              ],
              [
                53.4063626,
                28.1236989
              ],
              [
                53.4055293,
                28.1245273
              ],
              [
                53.4038626,
                28.1253646
              ],
              [
                53.4030292,
                28.126193
              ],
              [
                53.3816396,
                28.1370335
              ],
              [
                53.3619166,
                28.1445247
              ],
              [
                53.3516366,
                28.1492517
              ],
              [
                53.3508034,
                28.1495309
              ],
              [
                53.336637,
                28.1581387
              ],
              [
                53.3363603,
                28.1586969
              ],
              [
                53.3324704,
                28.1606328
              ],
              [
                53.3166338,
                28.1670258
              ],
              [
                53.3155239,
                28.1678632
              ],
              [
                53.2969108,
                28.1759129
              ],
              [
                53.2616348,
                28.1959206
              ],
              [
                53.2613547,
                28.1961998
              ],
              [
                53.2366318,
                28.2095266
              ],
              [
                53.2352418,
                28.2100848
              ],
              [
                53.2277419,
                28.2167483
              ],
              [
                53.2155187,
                28.236478
              ],
              [
                53.215242,
                28.2373064
              ],
              [
                53.2032955,
                28.2623047
              ],
              [
                53.2030189,
                28.2636914
              ],
              [
                53.201909,
                28.2686984
              ],
              [
                53.201629,
                28.2698061
              ],
              [
                53.2016289,
                28.2773075
              ],
              [
                53.1999623,
                28.2770284
              ],
              [
                53.1935758,
                28.2770283
              ],
              [
                53.1924625,
                28.2773075
              ],
              [
                53.1871859,
                28.2773075
              ],
              [
                53.1857959,
                28.2775867
              ],
              [
                53.1799626,
                28.2775867
              ],
              [
                53.1782959,
                28.2773075
              ],
              [
                53.1760726,
                28.2773075
              ],
              [
                53.1488497,
                28.273138
              ],
              [
                53.1466265,
                28.273138
              ],
              [
                53.1464411,
                28.2730445
              ],
              [
                53.1460732,
                28.2728588
              ],
              [
                53.1444065,
                28.2728589
              ],
              [
                53.1421832,
                28.2725887
              ],
              [
                53.1416265,
                28.2723096
              ],
              [
                53.13885,
                28.2717511
              ],
              [
                53.1260702,
                28.2667532
              ],
              [
                53.1255168,
                28.2661949
              ],
              [
                53.1110704,
                28.2564783
              ],
              [
                53.0791243,
                28.2275901
              ],
              [
                53.069401,
                28.2228625
              ],
              [
                53.0657911,
                28.2217459
              ],
              [
                53.0549579,
                28.218144
              ],
              [
                53.053848,
                28.218144
              ],
              [
                53.0482914,
                28.2167483
              ],
              [
                53.0466248,
                28.2164692
              ],
              [
                53.0457915,
                28.216199
              ],
              [
                53.0380115,
                28.2161989
              ],
              [
                53.0355175,
                28.2147026
              ],
              [
                53.0352349,
                28.2145331
              ],
              [
                53.0344016,
                28.2145332
              ],
              [
                53.034125,
                28.210364
              ],
              [
                53.0457914,
                28.1848001
              ],
              [
                53.0471779,
                28.1792534
              ],
              [
                53.0502347,
                28.163415
              ],
              [
                53.054958,
                28.1503591
              ],
              [
                53.0546814,
                28.15008
              ],
              [
                53.0541246,
                28.1445246
              ],
              [
                53.0530148,
                28.1423096
              ],
              [
                53.052178,
                28.1417514
              ],
              [
                53.0441249,
                28.1339721
              ],
              [
                53.0432916,
                28.1325855
              ],
              [
                53.0427348,
                28.1303616
              ],
              [
                53.047178,
                28.1248063
              ],
              [
                53.0474581,
                28.1236989
              ],
              [
                53.0480114,
                28.1234197
              ],
              [
                53.0480115,
                28.1228615
              ],
              [
                53.0488447,
                28.1214659
              ],
              [
                53.0502347,
                28.1173062
              ],
              [
                53.0482914,
                28.1050795
              ],
              [
                53.0421781,
                28.0909172
              ],
              [
                53.0399582,
                28.0898009
              ],
              [
                53.0355116,
                28.090359
              ],
              [
                53.0316216,
                28.0864696
              ],
              [
                53.0313451,
                28.0853532
              ],
              [
                53.031345,
                28.0820221
              ],
              [
                53.0316216,
                28.0800863
              ],
              [
                53.0319017,
                28.0778536
              ],
              [
                53.0321784,
                28.0759179
              ],
              [
                53.0324549,
                28.0753597
              ],
              [
                53.0324549,
                28.0706331
              ],
              [
                53.0319018,
                28.0689675
              ],
              [
                53.031345,
                28.0684184
              ],
              [
                53.0313451,
                28.0681393
              ],
              [
                53.0302351,
                28.0678601
              ],
              [
                53.0294018,
                28.0670229
              ],
              [
                53.0285684,
                28.0667528
              ],
              [
                53.0280118,
                28.0661946
              ],
              [
                52.9993988,
                28.0492512
              ],
              [
                52.9885657,
                28.0459112
              ],
              [
                52.9866224,
                28.045632
              ],
              [
                52.9793992,
                28.0436965
              ],
              [
                52.9638427,
                28.0411937
              ],
              [
                52.9591195,
                28.0411937
              ],
              [
                52.9035638,
                28.0514658
              ],
              [
                52.9010604,
                28.0523031
              ],
              [
                52.8913406,
                28.0542477
              ],
              [
                52.8832839,
                28.0564714
              ],
              [
                52.841058,
                28.0698047
              ],
              [
                52.838558,
                28.0709211
              ],
              [
                52.8321715,
                28.0731358
              ],
              [
                52.7874455,
                28.0964721
              ],
              [
                52.7841122,
                28.0989661
              ],
              [
                52.7816122,
                28.1003617
              ],
              [
                52.7735557,
                28.1064659
              ],
              [
                52.7146665,
                28.1395273
              ],
              [
                52.6757738,
                28.1598042
              ],
              [
                52.6685506,
                28.1631447
              ],
              [
                52.6677173,
                28.163694
              ],
              [
                52.6385511,
                28.1789741
              ],
              [
                52.6302179,
                28.1867449
              ],
              [
                52.6279945,
                28.1881406
              ],
              [
                52.6271613,
                28.1884197
              ],
              [
                52.6049383,
                28.2020255
              ],
              [
                52.5854919,
                28.2111922
              ],
              [
                52.583272,
                28.2125879
              ],
              [
                52.5352127,
                28.2314709
              ],
              [
                52.5140996,
                28.2364777
              ],
              [
                52.4999331,
                28.2378644
              ],
              [
                52.4827102,
                28.2445282
              ],
              [
                52.4746536,
                28.2470316
              ],
              [
                52.4599305,
                28.2528668
              ],
              [
                52.4577104,
                28.254803
              ],
              [
                52.4549305,
                28.2559196
              ],
              [
                52.4502106,
                28.2559196
              ],
              [
                52.4449306,
                28.2536953
              ],
              [
                52.444374,
                28.2520294
              ],
              [
                52.444374,
                28.2509217
              ],
              [
                52.4440974,
                28.2503634
              ],
              [
                52.4435407,
                28.24786
              ],
              [
                52.4424308,
                28.2273107
              ],
              [
                52.4427074,
                28.2217456
              ],
              [
                52.4429874,
                28.2173063
              ],
              [
                52.4432641,
                28.2142447
              ],
              [
                52.4435408,
                28.2123087
              ],
              [
                52.4518773,
                28.1620281
              ],
              [
                52.4524306,
                28.1606325
              ],
              [
                52.4565973,
                28.1431377
              ],
              [
                52.4568773,
                28.1406436
              ],
              [
                52.4571539,
                28.1389689
              ],
              [
                52.4574305,
                28.1348001
              ],
              [
                52.4577105,
                28.1342509
              ],
              [
                52.4577106,
                28.1311896
              ],
              [
                52.4574305,
                28.1264717
              ],
              [
                52.4571539,
                28.1250851
              ],
              [
                52.4565973,
                28.1178552
              ],
              [
                52.4568773,
                28.1167478
              ],
              [
                52.4565973,
                28.1156404
              ],
              [
                52.4552106,
                28.1064657
              ],
              [
                52.4543773,
                28.1039718
              ],
              [
                52.4499307,
                28.0842455
              ],
              [
                52.4449308,
                28.0745221
              ],
              [
                52.4443741,
                28.0742521
              ],
              [
                52.4407642,
                28.0695254
              ],
              [
                52.4118747,
                28.0442454
              ],
              [
                52.4099279,
                28.043138
              ],
              [
                52.4096514,
                28.0425799
              ],
              [
                52.4090946,
                28.0425799
              ],
              [
                52.4007615,
                28.0339734
              ],
              [
                52.3990949,
                28.0331361
              ],
              [
                52.3977083,
                28.0311915
              ],
              [
                52.3977082,
                28.0300842
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555008,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان داراب",
          "name:ar": "مقاطعة داراب",
          "name:en": "Darab County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270527",
          "wikipedia": "en:Darab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.1016684,
                28.6450909
              ],
              [
                54.1022251,
                28.645091
              ],
              [
                54.1272246,
                28.6367573
              ],
              [
                54.1425045,
                28.6295408
              ],
              [
                54.1433378,
                28.6295408
              ],
              [
                54.1483377,
                28.6273156
              ],
              [
                54.1497276,
                28.6270362
              ],
              [
                54.150561,
                28.626757
              ],
              [
                54.151671,
                28.6267569
              ],
              [
                54.1538942,
                28.6259281
              ],
              [
                54.1555609,
                28.6259281
              ],
              [
                54.1558376,
                28.6256488
              ],
              [
                54.1566709,
                28.6256488
              ],
              [
                54.1880638,
                28.617036
              ],
              [
                54.1891738,
                28.617036
              ],
              [
                54.1894504,
                28.6167568
              ],
              [
                54.1905637,
                28.6164774
              ],
              [
                54.1919503,
                28.6164775
              ],
              [
                54.2086201,
                28.6106486
              ],
              [
                54.2088968,
                28.6103693
              ],
              [
                54.2094535,
                28.6103693
              ],
              [
                54.2183399,
                28.6075945
              ],
              [
                54.2194533,
                28.6075945
              ],
              [
                54.2200065,
                28.6073152
              ],
              [
                54.2213965,
                28.6073153
              ],
              [
                54.2216731,
                28.607036
              ],
              [
                54.2225065,
                28.607036
              ],
              [
                54.2227866,
                28.6067567
              ],
              [
                54.2241766,
                28.6067567
              ],
              [
                54.2244532,
                28.6064775
              ],
              [
                54.2272298,
                28.6064774
              ],
              [
                54.2275099,
                28.6061981
              ],
              [
                54.2322298,
                28.6053693
              ],
              [
                54.2336197,
                28.6048197
              ],
              [
                54.2344531,
                28.6048197
              ],
              [
                54.2380629,
                28.6034234
              ],
              [
                54.240843,
                28.6025945
              ],
              [
                54.2688992,
                28.5892613
              ],
              [
                54.2697325,
                28.5884235
              ],
              [
                54.2713991,
                28.5875947
              ],
              [
                54.2716758,
                28.5870361
              ],
              [
                54.2730658,
                28.5862074
              ],
              [
                54.282789,
                28.5784238
              ],
              [
                54.2838989,
                28.577586
              ],
              [
                54.3089019,
                28.566199
              ],
              [
                54.3294583,
                28.5595327
              ],
              [
                54.3305682,
                28.5587039
              ],
              [
                54.3373806,
                28.5558856
              ],
              [
                54.3386247,
                28.5553708
              ],
              [
                54.3400148,
                28.5548123
              ],
              [
                54.340568,
                28.5548122
              ],
              [
                54.346958,
                28.5528664
              ],
              [
                54.3519579,
                28.5523169
              ],
              [
                54.3547344,
                28.552317
              ],
              [
                54.3555712,
                28.5520376
              ],
              [
                54.3577911,
                28.5520376
              ],
              [
                54.3586244,
                28.5517584
              ],
              [
                54.3619577,
                28.5517584
              ],
              [
                54.3639045,
                28.552317
              ],
              [
                54.365291,
                28.5523169
              ],
              [
                54.365571,
                28.5525962
              ],
              [
                54.3764042,
                28.5553708
              ],
              [
                54.3830708,
                28.5589832
              ],
              [
                54.3905706,
                28.569262
              ],
              [
                54.3911274,
                28.5695412
              ],
              [
                54.3911274,
                28.5698115
              ],
              [
                54.3930706,
                28.5725952
              ],
              [
                54.3952939,
                28.5762076
              ],
              [
                54.4000172,
                28.5809282
              ],
              [
                54.4011271,
                28.5814777
              ],
              [
                54.4019605,
                28.5823156
              ],
              [
                54.4130736,
                28.5887028
              ],
              [
                54.4164069,
                28.5898109
              ],
              [
                54.4177935,
                28.5898109
              ],
              [
                54.4180736,
                28.5900901
              ],
              [
                54.4214069,
                28.5900902
              ],
              [
                54.4219602,
                28.5903694
              ],
              [
                54.4233502,
                28.5903694
              ],
              [
                54.4236268,
                28.5906487
              ],
              [
                54.4244601,
                28.5906487
              ],
              [
                54.4247401,
                28.590928
              ],
              [
                54.4252935,
                28.590928
              ],
              [
                54.4264068,
                28.5914865
              ],
              [
                54.4272401,
                28.5917567
              ],
              [
                54.4575197,
                28.607036
              ],
              [
                54.4622395,
                28.6100937
              ],
              [
                54.4627963,
                28.6103693
              ],
              [
                54.4633529,
                28.6103693
              ],
              [
                54.4636295,
                28.6106485
              ],
              [
                54.4686295,
                28.6120359
              ],
              [
                54.4700194,
                28.6120359
              ],
              [
                54.4708528,
                28.6123153
              ],
              [
                54.4739094,
                28.6123152
              ],
              [
                54.4741861,
                28.6120359
              ],
              [
                54.4794627,
                28.612036
              ],
              [
                54.480576,
                28.6117566
              ],
              [
                54.4830759,
                28.6117567
              ],
              [
                54.4839092,
                28.6114774
              ],
              [
                54.4855759,
                28.6114775
              ],
              [
                54.4916858,
                28.6095405
              ],
              [
                54.4927992,
                28.6095404
              ],
              [
                54.4933525,
                28.6092611
              ],
              [
                54.4944657,
                28.6092612
              ],
              [
                54.495019,
                28.6089819
              ],
              [
                54.4961324,
                28.6089818
              ],
              [
                54.4977991,
                28.6084324
              ],
              [
                54.4991856,
                28.6084323
              ],
              [
                54.4994657,
                28.6081531
              ],
              [
                54.5008522,
                28.6081531
              ],
              [
                54.501409,
                28.6078738
              ],
              [
                54.5022422,
                28.6078738
              ],
              [
                54.5064089,
                28.607036
              ],
              [
                54.5089088,
                28.6070359
              ],
              [
                54.5097422,
                28.6067566
              ],
              [
                54.5108555,
                28.6067567
              ],
              [
                54.5139087,
                28.6059278
              ],
              [
                54.5202986,
                28.6039819
              ],
              [
                54.5208553,
                28.6039819
              ],
              [
                54.5211321,
                28.6037026
              ],
              [
                54.5216887,
                28.6037026
              ],
              [
                54.5219653,
                28.6034233
              ],
              [
                54.5227987,
                28.6034233
              ],
              [
                54.5230753,
                28.603153
              ],
              [
                54.5239086,
                28.603153
              ],
              [
                54.5241886,
                28.6028738
              ],
              [
                54.524742,
                28.6028738
              ],
              [
                54.5255786,
                28.6025945
              ],
              [
                54.5255786,
                28.6023152
              ],
              [
                54.5264119,
                28.602036
              ],
              [
                54.5275219,
                28.6017567
              ],
              [
                54.5350218,
                28.5975945
              ],
              [
                54.5787959,
                28.5733051
              ],
              [
                54.5805777,
                28.5723158
              ],
              [
                54.582801,
                28.57037
              ],
              [
                54.584191,
                28.5692619
              ],
              [
                54.6098864,
                28.5407869
              ],
              [
                54.610304,
                28.5403718
              ],
              [
                54.6105807,
                28.5400925
              ],
              [
                54.6139139,
                28.5367595
              ],
              [
                54.6194704,
                28.526481
              ],
              [
                54.6264137,
                28.516482
              ],
              [
                54.6353035,
                28.5089784
              ],
              [
                54.6403034,
                28.5064742
              ],
              [
                54.6408601,
                28.5062039
              ],
              [
                54.6658597,
                28.491485
              ],
              [
                54.6661399,
                28.4909266
              ],
              [
                54.6811396,
                28.4795318
              ],
              [
                54.6814161,
                28.4792526
              ],
              [
                54.6822495,
                28.4784239
              ],
              [
                54.6828061,
                28.4784238
              ],
              [
                54.6836394,
                28.4775952
              ],
              [
                54.6853061,
                28.4767574
              ],
              [
                54.6855828,
                28.4764782
              ],
              [
                54.6861394,
                28.4759288
              ],
              [
                54.6978059,
                28.4678669
              ],
              [
                54.728362,
                28.4431506
              ],
              [
                54.7289188,
                28.4425921
              ],
              [
                54.7436418,
                28.4323149
              ],
              [
                54.776698,
                28.4056452
              ],
              [
                54.7789212,
                28.4045283
              ],
              [
                54.7797546,
                28.4039789
              ],
              [
                54.7830878,
                28.4025918
              ],
              [
                54.7839212,
                28.4025919
              ],
              [
                54.7841978,
                28.4023126
              ],
              [
                54.7922543,
                28.400088
              ],
              [
                54.7933678,
                28.4000879
              ],
              [
                54.7947544,
                28.3995295
              ],
              [
                54.7975344,
                28.3995295
              ],
              [
                54.7980876,
                28.3992593
              ],
              [
                54.8064209,
                28.3992593
              ],
              [
                54.8075342,
                28.3989801
              ],
              [
                54.8092009,
                28.3989801
              ],
              [
                54.8169773,
                28.3973139
              ],
              [
                54.821424,
                28.3973139
              ],
              [
                54.8217007,
                28.3970346
              ],
              [
                54.8247573,
                28.3970346
              ],
              [
                54.8253106,
                28.3967554
              ],
              [
                54.826424,
                28.3967554
              ],
              [
                54.8272572,
                28.3964762
              ],
              [
                54.8303139,
                28.3964763
              ],
              [
                54.8311473,
                28.396197
              ],
              [
                54.8342004,
                28.3959268
              ],
              [
                54.8380904,
                28.3959269
              ],
              [
                54.8392004,
                28.3956476
              ],
              [
                54.8419804,
                28.3956476
              ],
              [
                54.8430903,
                28.3956476
              ],
              [
                54.8458669,
                28.3956476
              ],
              [
                54.8469803,
                28.3953684
              ],
              [
                54.8483702,
                28.3953684
              ],
              [
                54.8492036,
                28.3950892
              ],
              [
                54.8519802,
                28.3950892
              ],
              [
                54.8522569,
                28.39481
              ],
              [
                54.8533702,
                28.3948099
              ],
              [
                54.8542035,
                28.3945308
              ],
              [
                54.8558701,
                28.3945308
              ],
              [
                54.8564234,
                28.3942605
              ],
              [
                54.8583701,
                28.3942605
              ],
              [
                54.8589234,
                28.3939814
              ],
              [
                54.8603134,
                28.3939813
              ],
              [
                54.8608701,
                28.3937021
              ],
              [
                54.8625368,
                28.3937021
              ],
              [
                54.8872596,
                28.3873073
              ],
              [
                54.8972595,
                28.3831463
              ],
              [
                54.8975361,
                28.3828671
              ],
              [
                54.9089675,
                28.3776692
              ],
              [
                54.9086494,
                28.3764814
              ],
              [
                54.906426,
                28.364809
              ],
              [
                54.9061493,
                28.3614766
              ],
              [
                54.9058728,
                28.360639
              ],
              [
                54.8964261,
                28.3267579
              ],
              [
                54.8911496,
                28.3134201
              ],
              [
                54.8908695,
                28.3120332
              ],
              [
                54.884203,
                28.2898072
              ],
              [
                54.8839263,
                28.2881411
              ],
              [
                54.8836463,
                28.2864751
              ],
              [
                54.8833696,
                28.2861959
              ],
              [
                54.8833697,
                28.2842507
              ],
              [
                54.883093,
                28.2839715
              ],
              [
                54.883093,
                28.2834222
              ],
              [
                54.8825363,
                28.2806395
              ],
              [
                54.8822597,
                28.2803604
              ],
              [
                54.8819796,
                28.2784242
              ],
              [
                54.8811463,
                28.2736963
              ],
              [
                54.8719798,
                28.2359196
              ],
              [
                54.8717031,
                28.2336954
              ],
              [
                54.8714265,
                28.2317504
              ],
              [
                54.8711465,
                28.2295262
              ],
              [
                54.8708698,
                28.2286976
              ],
              [
                54.8708698,
                28.2267526
              ],
              [
                54.8705931,
                28.2261944
              ],
              [
                54.8705931,
                28.2250867
              ],
              [
                54.8705931,
                28.2245284
              ],
              [
                54.8705932,
                28.2239702
              ],
              [
                54.8705931,
                28.2170274
              ],
              [
                54.8703132,
                28.2134166
              ],
              [
                54.8700365,
                28.2098057
              ],
              [
                54.8697598,
                28.2064739
              ],
              [
                54.8694798,
                28.2031422
              ],
              [
                54.8692032,
                28.1978565
              ],
              [
                54.8689265,
                28.1970281
              ],
              [
                54.8692032,
                28.1961998
              ],
              [
                54.8700365,
                28.18453
              ],
              [
                54.8717031,
                28.1545281
              ],
              [
                54.8717031,
                28.1525832
              ],
              [
                54.8719798,
                28.1520249
              ],
              [
                54.8722598,
                28.1495308
              ],
              [
                54.8728131,
                28.1478651
              ],
              [
                54.8736463,
                28.1436962
              ],
              [
                54.876703,
                28.1217541
              ],
              [
                54.8775363,
                28.118972
              ],
              [
                54.8819795,
                28.0898008
              ],
              [
                54.881703,
                28.0895218
              ],
              [
                54.881703,
                28.0881352
              ],
              [
                54.881703,
                28.0853532
              ],
              [
                54.8814263,
                28.081752
              ],
              [
                54.8812863,
                28.0814729
              ],
              [
                54.8822596,
                28.0814729
              ],
              [
                54.8825362,
                28.0817519
              ],
              [
                54.8944827,
                28.081752
              ],
              [
                54.8980927,
                28.0820221
              ],
              [
                54.8983693,
                28.0823012
              ],
              [
                54.901426,
                28.0823012
              ],
              [
                54.9017026,
                28.0825802
              ],
              [
                54.9044826,
                28.0825802
              ],
              [
                54.9053159,
                28.0828594
              ],
              [
                54.9075392,
                28.0828593
              ],
              [
                54.9144825,
                28.0845249
              ],
              [
                54.9158724,
                28.0845249
              ],
              [
                54.9164258,
                28.0848041
              ],
              [
                54.917539,
                28.084804
              ],
              [
                54.9183723,
                28.0850831
              ],
              [
                54.920039,
                28.0850831
              ],
              [
                54.9208722,
                28.0853532
              ],
              [
                54.922539,
                28.0856413
              ],
              [
                54.9236489,
                28.0856413
              ],
              [
                54.9242057,
                28.0859204
              ],
              [
                54.9261488,
                28.0859204
              ],
              [
                54.9267056,
                28.0861905
              ],
              [
                54.9292056,
                28.0861905
              ],
              [
                54.9300389,
                28.0864696
              ],
              [
                54.9325388,
                28.0864696
              ],
              [
                54.9333722,
                28.0867487
              ],
              [
                54.9378154,
                28.0867487
              ],
              [
                54.9389287,
                28.0870278
              ],
              [
                54.9461519,
                28.0870278
              ],
              [
                54.9472619,
                28.0867487
              ],
              [
                54.9505952,
                28.0867487
              ],
              [
                54.9736515,
                28.0839757
              ],
              [
                55.0033743,
                28.0770253
              ],
              [
                55.0044877,
                28.0770253
              ],
              [
                55.0125408,
                28.0745224
              ],
              [
                55.0130975,
                28.0745224
              ],
              [
                55.0192108,
                28.0725867
              ],
              [
                55.0200442,
                28.0720286
              ],
              [
                55.0325439,
                28.0689675
              ],
              [
                55.0344872,
                28.0689675
              ],
              [
                55.0367105,
                28.0684183
              ],
              [
                55.0386538,
                28.0684183
              ],
              [
                55.0397671,
                28.0681392
              ],
              [
                55.047267,
                28.0681392
              ],
              [
                55.0508769,
                28.0689675
              ],
              [
                55.0517103,
                28.0689675
              ],
              [
                55.051987,
                28.0692466
              ],
              [
                55.0528202,
                28.0692466
              ],
              [
                55.0672667,
                28.076188
              ],
              [
                55.0797665,
                28.084804
              ],
              [
                55.0808798,
                28.0853531
              ],
              [
                55.0814332,
                28.0859204
              ],
              [
                55.0819899,
                28.0861905
              ],
              [
                55.0883798,
                28.0889724
              ],
              [
                55.1161593,
                28.0964722
              ],
              [
                55.1172693,
                28.0964722
              ],
              [
                55.1175459,
                28.0967513
              ],
              [
                55.117826,
                28.0964722
              ],
              [
                55.1183792,
                28.0967513
              ],
              [
                55.1264359,
                28.0967513
              ],
              [
                55.1275457,
                28.0964722
              ],
              [
                55.1306024,
                28.0964722
              ],
              [
                55.131159,
                28.0961932
              ],
              [
                55.1339356,
                28.0961931
              ],
              [
                55.1353256,
                28.095914
              ],
              [
                55.1381022,
                28.095914
              ],
              [
                55.1392156,
                28.0956349
              ],
              [
                55.1422689,
                28.0956349
              ],
              [
                55.1428256,
                28.0953557
              ],
              [
                55.1442155,
                28.0953557
              ],
              [
                55.1556054,
                28.0925827
              ],
              [
                55.1567153,
                28.0925827
              ],
              [
                55.1614386,
                28.0911872
              ],
              [
                55.1625486,
                28.0909171
              ],
              [
                55.1714384,
                28.0884142
              ],
              [
                55.1731051,
                28.0884142
              ],
              [
                55.1739383,
                28.0881351
              ],
              [
                55.1831049,
                28.0881351
              ],
              [
                55.1842149,
                28.0884142
              ],
              [
                55.1856049,
                28.0884142
              ],
              [
                55.1867182,
                28.0886933
              ],
              [
                55.1881048,
                28.0886933
              ],
              [
                55.1892181,
                28.0889724
              ],
              [
                55.2047746,
                28.0889724
              ],
              [
                55.2058845,
                28.0886933
              ],
              [
                55.2075512,
                28.0886933
              ],
              [
                55.2086612,
                28.0884142
              ],
              [
                55.2100511,
                28.0884142
              ],
              [
                55.2194943,
                28.0859203
              ],
              [
                55.2208843,
                28.0859204
              ],
              [
                55.2219943,
                28.0853531
              ],
              [
                55.2231076,
                28.0853531
              ],
              [
                55.2258842,
                28.0845248
              ],
              [
                55.2489405,
                28.0753595
              ],
              [
                55.2492205,
                28.0750805
              ],
              [
                55.2506072,
                28.0742522
              ],
              [
                55.2717202,
                28.0623052
              ],
              [
                55.2731102,
                28.061747
              ],
              [
                55.2736635,
                28.0611978
              ],
              [
                55.2750535,
                28.0609098
              ],
              [
                55.2761634,
                28.0600815
              ],
              [
                55.3144995,
                28.0442456
              ],
              [
                55.3150562,
                28.0442455
              ],
              [
                55.3153328,
                28.0439665
              ],
              [
                55.3167228,
                28.0436963
              ],
              [
                55.3167228,
                28.0434082
              ],
              [
                55.3697786,
                28.0311917
              ],
              [
                55.3728353,
                28.0306425
              ],
              [
                55.3726688,
                28.0320794
              ],
              [
                55.3737787,
                28.0320795
              ],
              [
                55.3793353,
                28.030405
              ],
              [
                55.3798887,
                28.030405
              ],
              [
                55.3818353,
                28.0297743
              ],
              [
                55.3851686,
                28.0392992
              ],
              [
                55.3854451,
                28.0401365
              ],
              [
                55.3857252,
                28.0417929
              ],
              [
                55.3860019,
                28.0431882
              ],
              [
                55.3862785,
                28.0445746
              ],
              [
                55.3865586,
                28.045682
              ],
              [
                55.3995892,
                28.078342
              ],
              [
                55.4096079,
                28.0826122
              ],
              [
                55.4087746,
                28.0931643
              ],
              [
                55.4084946,
                28.0953882
              ],
              [
                55.4166876,
                28.1119859
              ],
              [
                55.4169677,
                28.112256
              ],
              [
                55.4172443,
                28.1147599
              ],
              [
                55.4175209,
                28.1183718
              ],
              [
                55.4175208,
                28.1194887
              ],
              [
                55.4178009,
                28.1197588
              ],
              [
                55.4180776,
                28.1225419
              ],
              [
                55.4183542,
                28.1247666
              ],
              [
                55.4186343,
                28.1261537
              ],
              [
                55.4075814,
                28.1577671
              ],
              [
                55.4078579,
                28.163602
              ],
              [
                55.408138,
                28.1663754
              ],
              [
                55.4086914,
                28.169707
              ],
              [
                55.4089713,
                28.1719313
              ],
              [
                55.4092481,
                28.1749929
              ],
              [
                55.4095246,
                28.1777662
              ],
              [
                55.4120246,
                28.1899858
              ],
              [
                55.4188911,
                28.2135891
              ],
              [
                55.4189847,
                28.2136825
              ],
              [
                55.4200043,
                28.2152549
              ],
              [
                55.420281,
                28.2160923
              ],
              [
                55.4052081,
                28.2505536
              ],
              [
                55.4054881,
                28.2511119
              ],
              [
                55.4057648,
                28.2541644
              ],
              [
                55.4063214,
                28.2580545
              ],
              [
                55.4074315,
                28.2624938
              ],
              [
                55.4077081,
                28.2644478
              ],
              [
                55.404505,
                28.2678696
              ],
              [
                55.4047815,
                28.2698058
              ],
              [
                55.4050582,
                28.2723093
              ],
              [
                55.4053383,
                28.2745336
              ],
              [
                55.4056149,
                28.2761996
              ],
              [
                55.4058915,
                28.2792524
              ],
              [
                55.4056149,
                28.2825845
              ],
              [
                55.4058916,
                28.2831428
              ],
              [
                55.4056149,
                28.2856464
              ],
              [
                55.4058916,
                28.2864749
              ],
              [
                55.4064482,
                28.2961919
              ],
              [
                55.4075582,
                28.3017574
              ],
              [
                55.4078383,
                28.3036936
              ],
              [
                55.4083915,
                28.3064764
              ],
              [
                55.4083915,
                28.3073049
              ],
              [
                55.4083915,
                28.3078633
              ],
              [
                55.4086716,
                28.3081425
              ],
              [
                55.4083916,
                28.3086918
              ],
              [
                55.4086716,
                28.308971
              ],
              [
                55.4083915,
                28.3098085
              ],
              [
                55.4086716,
                28.3100877
              ],
              [
                55.4083915,
                28.3125823
              ],
              [
                55.4083915,
                28.3142484
              ],
              [
                55.4081148,
                28.3153652
              ],
              [
                55.4083915,
                28.3156443
              ],
              [
                55.4081148,
                28.3175896
              ],
              [
                55.4078383,
                28.318139
              ],
              [
                55.4081148,
                28.3186973
              ],
              [
                55.4047817,
                28.3520288
              ],
              [
                55.4050583,
                28.3542533
              ],
              [
                55.4067249,
                28.3603686
              ],
              [
                55.407005,
                28.362305
              ],
              [
                55.4070051,
                28.380363
              ],
              [
                55.4064482,
                28.3861993
              ],
              [
                55.4061716,
                28.3878656
              ],
              [
                55.4064482,
                28.3881447
              ],
              [
                55.406725,
                28.3925941
              ],
              [
                55.407005,
                28.3948097
              ],
              [
                55.4072816,
                28.3970344
              ],
              [
                55.4078383,
                28.4184168
              ],
              [
                55.4083916,
                28.4203623
              ],
              [
                55.4086717,
                28.4234246
              ],
              [
                55.4089483,
                28.4253702
              ],
              [
                55.4078933,
                28.4329923
              ],
              [
                55.4079734,
                28.4403444
              ],
              [
                55.4084966,
                28.4567477
              ],
              [
                55.4109,
                28.459721
              ],
              [
                55.4150999,
                28.4623823
              ],
              [
                55.4188764,
                28.4656572
              ],
              [
                55.4272431,
                28.4721142
              ],
              [
                55.4346963,
                28.4794844
              ],
              [
                55.4454192,
                28.4870358
              ],
              [
                55.447091,
                28.5125824
              ],
              [
                55.4503494,
                28.519271
              ],
              [
                55.4509443,
                28.5224757
              ],
              [
                55.4555208,
                28.5357712
              ],
              [
                55.4550727,
                28.5396106
              ],
              [
                55.452376,
                28.5455311
              ],
              [
                55.4468744,
                28.5540597
              ],
              [
                55.4292614,
                28.5810506
              ],
              [
                55.4122921,
                28.602609
              ],
              [
                55.3953348,
                28.6226288
              ],
              [
                55.3864085,
                28.6331452
              ],
              [
                55.3580471,
                28.6571526
              ],
              [
                55.3192517,
                28.6866727
              ],
              [
                55.2766796,
                28.7077533
              ],
              [
                55.2533242,
                28.7136208
              ],
              [
                55.2399443,
                28.7223566
              ],
              [
                55.2258681,
                28.7252168
              ],
              [
                55.2131651,
                28.7268727
              ],
              [
                55.1912895,
                28.7246411
              ],
              [
                55.1353259,
                28.7192683
              ],
              [
                55.1350494,
                28.718989
              ],
              [
                55.132826,
                28.718989
              ],
              [
                55.1317162,
                28.7187097
              ],
              [
                55.1311594,
                28.7187097
              ],
              [
                55.1281027,
                28.7187097
              ],
              [
                55.1272695,
                28.7184304
              ],
              [
                55.1208795,
                28.7184303
              ],
              [
                55.1197695,
                28.718151
              ],
              [
                55.1142129,
                28.7181511
              ],
              [
                55.113103,
                28.7178717
              ],
              [
                55.1122696,
                28.7181511
              ],
              [
                55.111713,
                28.7178717
              ],
              [
                55.0961566,
                28.7178717
              ],
              [
                55.09588,
                28.718151
              ],
              [
                55.0939367,
                28.718151
              ],
              [
                55.0836568,
                28.7203766
              ],
              [
                55.0828235,
                28.7203766
              ],
              [
                55.0825468,
                28.7206559
              ],
              [
                55.0814335,
                28.7206559
              ],
              [
                55.0756003,
                28.7223228
              ],
              [
                55.0606005,
                28.7289904
              ],
              [
                55.0599515,
                28.7297262
              ],
              [
                55.0597672,
                28.7300987
              ],
              [
                55.0589338,
                28.7314862
              ],
              [
                55.0356009,
                28.7437043
              ],
              [
                55.0347642,
                28.7439836
              ],
              [
                55.0078213,
                28.7598151
              ],
              [
                55.006708,
                28.7600944
              ],
              [
                54.9783751,
                28.7792691
              ],
              [
                54.9775418,
                28.7798188
              ],
              [
                54.9753185,
                28.7820445
              ],
              [
                54.9408722,
                28.8089872
              ],
              [
                54.9258725,
                28.8242611
              ],
              [
                54.925596,
                28.8250992
              ],
              [
                54.9247626,
                28.8256579
              ],
              [
                54.9236492,
                28.8273159
              ],
              [
                54.923096,
                28.8275953
              ],
              [
                54.9153161,
                28.8378772
              ],
              [
                54.8897598,
                28.8776001
              ],
              [
                54.8892031,
                28.8781498
              ],
              [
                54.88226,
                28.8862063
              ],
              [
                54.8497571,
                28.9120436
              ],
              [
                54.8494804,
                28.912323
              ],
              [
                54.8119776,
                28.9309332
              ],
              [
                54.8114244,
                28.9309332
              ],
              [
                54.8108677,
                28.9314919
              ],
              [
                54.8100344,
                28.931492
              ],
              [
                54.79223,
                28.9384008
              ],
              [
                54.7728116,
                28.9367641
              ],
              [
                54.7714216,
                28.9367642
              ],
              [
                54.7703082,
                28.9364937
              ],
              [
                54.7689216,
                28.9364937
              ],
              [
                54.7680883,
                28.9362144
              ],
              [
                54.7650317,
                28.9362144
              ],
              [
                54.7622551,
                28.9356557
              ],
              [
                54.7614218,
                28.9356556
              ],
              [
                54.7608651,
                28.9353762
              ],
              [
                54.7594751,
                28.9353762
              ],
              [
                54.7580886,
                28.9348175
              ],
              [
                54.7572552,
                28.9348175
              ],
              [
                54.743642,
                28.9287162
              ],
              [
                54.7430853,
                28.9281574
              ],
              [
                54.7422519,
                28.927878
              ],
              [
                54.7355854,
                28.9203799
              ],
              [
                54.7200291,
                28.9073213
              ],
              [
                54.7197524,
                28.907042
              ],
              [
                54.7103059,
                28.90177
              ],
              [
                54.7097525,
                28.9012113
              ],
              [
                54.7025293,
                28.8989852
              ],
              [
                54.7014194,
                28.8989853
              ],
              [
                54.700586,
                28.8987149
              ],
              [
                54.6989194,
                28.8987149
              ],
              [
                54.6980861,
                28.8984356
              ],
              [
                54.6928061,
                28.8984356
              ],
              [
                54.6919728,
                28.8981561
              ],
              [
                54.6905827,
                28.8981562
              ],
              [
                54.6897495,
                28.8978769
              ],
              [
                54.6880828,
                28.8978768
              ],
              [
                54.6872495,
                28.8975974
              ],
              [
                54.6800298,
                28.8975974
              ],
              [
                54.6797497,
                28.8978768
              ],
              [
                54.6733597,
                28.8978768
              ],
              [
                54.6728064,
                28.8975975
              ],
              [
                54.6669732,
                28.8975975
              ],
              [
                54.6658599,
                28.8973181
              ],
              [
                54.6550267,
                28.8973181
              ],
              [
                54.6528034,
                28.8973181
              ],
              [
                54.6466935,
                28.8973181
              ],
              [
                54.6453035,
                28.8975975
              ],
              [
                54.6355803,
                28.8975974
              ],
              [
                54.6341937,
                28.8973181
              ],
              [
                54.6314137,
                28.8973181
              ],
              [
                54.6305803,
                28.8970387
              ],
              [
                54.6289138,
                28.8970387
              ],
              [
                54.6283605,
                28.8967593
              ],
              [
                54.6244705,
                28.8967593
              ],
              [
                54.6228038,
                28.896489
              ],
              [
                54.6219705,
                28.8962096
              ],
              [
                54.6208606,
                28.8962096
              ],
              [
                54.6203039,
                28.8959302
              ],
              [
                54.6175239,
                28.8959302
              ],
              [
                54.6119707,
                28.8948218
              ],
              [
                54.6105807,
                28.8948218
              ],
              [
                54.610024,
                28.8945424
              ],
              [
                54.6039141,
                28.8945424
              ],
              [
                54.6033574,
                28.8948218
              ],
              [
                54.5997476,
                28.8948218
              ],
              [
                54.5994675,
                28.8951012
              ],
              [
                54.596691,
                28.8951012
              ],
              [
                54.590301,
                28.8959302
              ],
              [
                54.5894677,
                28.8962096
              ],
              [
                54.587801,
                28.8962097
              ],
              [
                54.5861344,
                28.8962096
              ],
              [
                54.5803011,
                28.8967594
              ],
              [
                54.5794678,
                28.8970387
              ],
              [
                54.5764112,
                28.8970387
              ],
              [
                54.5755779,
                28.8973181
              ],
              [
                54.5741913,
                28.8973181
              ],
              [
                54.5736346,
                28.8975974
              ],
              [
                54.5725246,
                28.8975974
              ],
              [
                54.5719679,
                28.8978769
              ],
              [
                54.570858,
                28.8978769
              ],
              [
                54.5703013,
                28.8981562
              ],
              [
                54.5691914,
                28.8981562
              ],
              [
                54.5675247,
                28.898715
              ],
              [
                54.5603014,
                28.8989853
              ],
              [
                54.5600214,
                28.8992647
              ],
              [
                54.5578015,
                28.8992646
              ],
              [
                54.5575215,
                28.8995441
              ],
              [
                54.5564115,
                28.899544
              ],
              [
                54.5558549,
                28.8998235
              ],
              [
                54.5480784,
                28.8998234
              ],
              [
                54.547245,
                28.8995441
              ],
              [
                54.5358552,
                28.899544
              ],
              [
                54.5350218,
                28.8998234
              ],
              [
                54.5327986,
                28.8998234
              ],
              [
                54.5319652,
                28.9000938
              ],
              [
                54.5294654,
                28.9000938
              ],
              [
                54.528912,
                28.9003732
              ],
              [
                54.5280787,
                28.9003732
              ],
              [
                54.5272453,
                28.9006525
              ],
              [
                54.5164088,
                28.9020403
              ],
              [
                54.5155755,
                28.9023198
              ],
              [
                54.5144654,
                28.9023197
              ],
              [
                54.5130755,
                28.9028785
              ],
              [
                54.5119655,
                28.9028785
              ],
              [
                54.5114089,
                28.9031489
              ],
              [
                54.5105755,
                28.9031488
              ],
              [
                54.5100223,
                28.9034282
              ],
              [
                54.506409,
                28.9034282
              ],
              [
                54.5055756,
                28.9037076
              ],
              [
                54.5047423,
                28.9037076
              ],
              [
                54.489466,
                28.9100971
              ],
              [
                54.4827959,
                28.9170454
              ],
              [
                54.4825194,
                28.9175952
              ],
              [
                54.481686,
                28.9184334
              ],
              [
                54.4808526,
                28.9178745
              ],
              [
                54.480296,
                28.9175952
              ],
              [
                54.4800194,
                28.9170455
              ],
              [
                54.4550198,
                28.8945424
              ],
              [
                54.4414066,
                28.8878736
              ],
              [
                54.4405733,
                28.8875943
              ],
              [
                54.4341833,
                28.885098
              ],
              [
                54.43363,
                28.8845393
              ],
              [
                54.4330734,
                28.8845392
              ],
              [
                54.4177936,
                28.875933
              ],
              [
                54.4083505,
                28.8670385
              ],
              [
                54.4083504,
                28.8664888
              ],
              [
                54.4077938,
                28.8662094
              ],
              [
                54.4075171,
                28.8653803
              ],
              [
                54.4069604,
                28.865101
              ],
              [
                54.4008506,
                28.856486
              ],
              [
                54.4008506,
                28.8562066
              ],
              [
                54.4000172,
                28.8548188
              ],
              [
                54.394184,
                28.8478799
              ],
              [
                54.3814042,
                28.8314882
              ],
              [
                54.3811275,
                28.8317676
              ],
              [
                54.3761276,
                28.8353811
              ],
              [
                54.3602911,
                28.8428696
              ],
              [
                54.3589045,
                28.8431489
              ],
              [
                54.338465,
                28.8533711
              ],
              [
                54.3294584,
                28.8578737
              ],
              [
                54.3289017,
                28.8581531
              ],
              [
                54.328345,
                28.8581531
              ],
              [
                54.327235,
                28.8587118
              ],
              [
                54.3186251,
                28.8609377
              ],
              [
                54.2900122,
                28.8667591
              ],
              [
                54.2883456,
                28.8667592
              ],
              [
                54.2877889,
                28.8670386
              ],
              [
                54.2869556,
                28.8670386
              ],
              [
                54.2863989,
                28.8673179
              ],
              [
                54.2847323,
                28.8673178
              ],
              [
                54.284179,
                28.8675973
              ],
              [
                54.282789,
                28.8675972
              ],
              [
                54.2825123,
                28.8678766
              ],
              [
                54.2802891,
                28.8678766
              ],
              [
                54.2797324,
                28.8681559
              ],
              [
                54.276399,
                28.8681559
              ],
              [
                54.2761224,
                28.8684353
              ],
              [
                54.2697326,
                28.8684353
              ],
              [
                54.2694559,
                28.8687147
              ],
              [
                54.2686226,
                28.8687147
              ],
              [
                54.2683426,
                28.868985
              ],
              [
                54.2641759,
                28.868985
              ],
              [
                54.2638993,
                28.8692644
              ],
              [
                54.2627893,
                28.8692644
              ],
              [
                54.2622327,
                28.8695438
              ],
              [
                54.2613993,
                28.8695438
              ],
              [
                54.2611227,
                28.8698231
              ],
              [
                54.2605661,
                28.8698231
              ],
              [
                54.2591761,
                28.8706522
              ],
              [
                54.259176,
                28.8731575
              ],
              [
                54.2588994,
                28.8725987
              ],
              [
                54.2361196,
                28.8445457
              ],
              [
                54.2327864,
                28.8414909
              ],
              [
                54.2319531,
                28.8406528
              ],
              [
                54.21723,
                28.82482
              ],
              [
                54.21723,
                28.8245406
              ],
              [
                54.2172299,
                28.8239819
              ],
              [
                54.2169534,
                28.8237025
              ],
              [
                54.2155633,
                28.8214858
              ],
              [
                54.2025571,
                28.8068503
              ],
              [
                54.1780605,
                28.7792693
              ],
              [
                54.1772272,
                28.7787106
              ],
              [
                54.1602842,
                28.7617616
              ],
              [
                54.1594509,
                28.7614822
              ],
              [
                54.1308381,
                28.7284319
              ],
              [
                54.1302813,
                28.7273237
              ],
              [
                54.1300046,
                28.726765
              ],
              [
                54.1272247,
                28.7225933
              ],
              [
                54.1197248,
                28.7028702
              ],
              [
                54.1200048,
                28.7025909
              ],
              [
                54.1197248,
                28.701762
              ],
              [
                54.1188915,
                28.7003744
              ],
              [
                54.1161149,
                28.6906527
              ],
              [
                54.1158383,
                28.6892651
              ],
              [
                54.1155582,
                28.6870397
              ],
              [
                54.1152816,
                28.6853729
              ],
              [
                54.1150049,
                28.6839855
              ],
              [
                54.108615,
                28.6625963
              ],
              [
                54.108335,
                28.6611999
              ],
              [
                54.1063916,
                28.6573168
              ],
              [
                54.1063917,
                28.6570375
              ],
              [
                54.106115,
                28.6562086
              ],
              [
                54.1055583,
                28.6531454
              ],
              [
                54.1052817,
                28.6517579
              ],
              [
                54.1050016,
                28.6514786
              ],
              [
                54.1025017,
                28.6464783
              ],
              [
                54.1019484,
                28.6462081
              ],
              [
                54.1019484,
                28.6459288
              ],
              [
                54.1016684,
                28.6450909
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555041,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رستم",
          "name:en": "Rostam County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2571571",
          "wikipedia": "en:Rostam County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.1355668,
                30.5955365
              ],
              [
                51.1395795,
                30.5929829
              ],
              [
                51.143761,
                30.5876396
              ],
              [
                51.1432043,
                30.5806907
              ],
              [
                51.1429277,
                30.5640225
              ],
              [
                51.1623708,
                30.5476344
              ],
              [
                51.1640373,
                30.5462446
              ],
              [
                51.1684839,
                30.5401353
              ],
              [
                51.1687606,
                30.5398554
              ],
              [
                51.1790405,
                30.5306869
              ],
              [
                51.1848737,
                30.5129092
              ],
              [
                51.1870971,
                30.5048508
              ],
              [
                51.2012635,
                30.4776344
              ],
              [
                51.2026501,
                30.4762448
              ],
              [
                51.203207,
                30.474855
              ],
              [
                51.2045969,
                30.4734654
              ],
              [
                51.2143201,
                30.4615178
              ],
              [
                51.2184868,
                30.4559682
              ],
              [
                51.2195967,
                30.4542988
              ],
              [
                51.22043,
                30.4537393
              ],
              [
                51.255433,
                30.4159662
              ],
              [
                51.255433,
                30.4156864
              ],
              [
                51.2892932,
                30.3890871
              ],
              [
                51.2861818,
                30.3803872
              ],
              [
                51.283049,
                30.3760555
              ],
              [
                51.2799377,
                30.3759999
              ],
              [
                51.2732643,
                30.3758889
              ],
              [
                51.2693161,
                30.3745189
              ],
              [
                51.2636809,
                30.3734588
              ],
              [
                51.2564925,
                30.3699413
              ],
              [
                51.2506346,
                30.3638318
              ],
              [
                51.2467078,
                30.3564813
              ],
              [
                51.2459997,
                30.3511856
              ],
              [
                51.243575,
                30.3478525
              ],
              [
                51.2426094,
                30.3441305
              ],
              [
                51.2409188,
                30.3415125
              ],
              [
                51.2382994,
                30.3362339
              ],
              [
                51.2379776,
                30.3248808
              ],
              [
                51.240016,
                30.3231397
              ],
              [
                51.2412391,
                30.3218246
              ],
              [
                51.2804852,
                30.2978538
              ],
              [
                51.2793265,
                30.2957602
              ],
              [
                51.2784253,
                30.2915544
              ],
              [
                51.2720995,
                30.2890186
              ],
              [
                51.2707094,
                30.2823507
              ],
              [
                51.2690428,
                30.2795718
              ],
              [
                51.2679328,
                30.2790123
              ],
              [
                51.2676563,
                30.2787416
              ],
              [
                51.265433,
                30.2773521
              ],
              [
                51.265433,
                30.2770724
              ],
              [
                51.2648763,
                30.2770725
              ],
              [
                51.2645995,
                30.2767927
              ],
              [
                51.2637664,
                30.2767927
              ],
              [
                51.2637663,
                30.276513
              ],
              [
                51.2634896,
                30.2762333
              ],
              [
                51.2632097,
                30.2759626
              ],
              [
                51.2634896,
                30.275683
              ],
              [
                51.2662662,
                30.2712347
              ],
              [
                51.2712661,
                30.2679053
              ],
              [
                51.2723761,
                30.2679053
              ],
              [
                51.2729328,
                30.2676256
              ],
              [
                51.2754328,
                30.2676256
              ],
              [
                51.2759894,
                30.2679053
              ],
              [
                51.2787661,
                30.2679054
              ],
              [
                51.2809893,
                30.2667866
              ],
              [
                51.281546,
                30.2656857
              ],
              [
                51.2812661,
                30.262627
              ],
              [
                51.281546,
                30.2620767
              ],
              [
                51.2834894,
                30.2576285
              ],
              [
                51.284046,
                30.2576286
              ],
              [
                51.284046,
                30.2573488
              ],
              [
                51.2845993,
                30.2573488
              ],
              [
                51.2854326,
                30.2570691
              ],
              [
                51.2865461,
                30.2570692
              ],
              [
                51.2884894,
                30.2573488
              ],
              [
                51.2968225,
                30.2604075
              ],
              [
                51.2990457,
                30.2604075
              ],
              [
                51.3032124,
                30.2592977
              ],
              [
                51.3040458,
                30.2592977
              ],
              [
                51.3051556,
                30.2587383
              ],
              [
                51.3168256,
                30.2565188
              ],
              [
                51.3237688,
                30.2537397
              ],
              [
                51.3243255,
                30.2531804
              ],
              [
                51.3293254,
                30.2501307
              ],
              [
                51.338492,
                30.2398541
              ],
              [
                51.3501584,
                30.2337368
              ],
              [
                51.3512684,
                30.2337368
              ],
              [
                51.3521016,
                30.2334571
              ],
              [
                51.3557149,
                30.2334571
              ],
              [
                51.3615483,
                30.2356856
              ],
              [
                51.3751614,
                30.2420736
              ],
              [
                51.3754379,
                30.2417939
              ],
              [
                51.3759948,
                30.241794
              ],
              [
                51.3764074,
                30.2415143
              ],
              [
                51.376828,
                30.2412436
              ],
              [
                51.3768281,
                30.2409639
              ],
              [
                51.3834946,
                30.2328977
              ],
              [
                51.3868458,
                30.2267578
              ],
              [
                51.388019,
                30.2277775
              ],
              [
                51.3894425,
                30.2286272
              ],
              [
                51.3897644,
                30.2296283
              ],
              [
                51.3933264,
                30.2307036
              ],
              [
                51.3944207,
                30.2313896
              ],
              [
                51.3975535,
                30.2333918
              ],
              [
                51.3992916,
                30.2343559
              ],
              [
                51.4015661,
                30.2342261
              ],
              [
                51.4036904,
                30.2349306
              ],
              [
                51.4051496,
                30.2356721
              ],
              [
                51.4070164,
                30.2376928
              ],
              [
                51.4078961,
                30.2378411
              ],
              [
                51.4115225,
                30.2381933
              ],
              [
                51.4146124,
                30.2379523
              ],
              [
                51.4162217,
                30.2371737
              ],
              [
                51.4202558,
                30.2343373
              ],
              [
                51.4237748,
                30.2332435
              ],
              [
                51.4275943,
                30.2321312
              ],
              [
                51.4309417,
                30.232298
              ],
              [
                51.4318644,
                30.2317789
              ],
              [
                51.4325296,
                30.2305924
              ],
              [
                51.4351259,
                30.229925
              ],
              [
                51.4375936,
                30.2296098
              ],
              [
                51.4395891,
                30.2293688
              ],
              [
                51.4418851,
                30.2303699
              ],
              [
                51.4434515,
                30.2303699
              ],
              [
                51.4461337,
                30.2309817
              ],
              [
                51.4492665,
                30.2316491
              ],
              [
                51.4526354,
                30.2330025
              ],
              [
                51.4562832,
                30.2361541
              ],
              [
                51.457635,
                30.2379338
              ],
              [
                51.4587079,
                30.2394168
              ],
              [
                51.4608966,
                30.2405291
              ],
              [
                51.4636646,
                30.2407701
              ],
              [
                51.4664112,
                30.2413633
              ],
              [
                51.470574,
                30.2404688
              ],
              [
                51.4753805,
                30.2378365
              ],
              [
                51.4776336,
                30.2344254
              ],
              [
                51.482998,
                30.2297535
              ],
              [
                51.4848863,
                30.2275472
              ],
              [
                51.4851867,
                30.2259713
              ],
              [
                51.4858733,
                30.2240431
              ],
              [
                51.4921604,
                30.2201494
              ],
              [
                51.496924,
                30.2150504
              ],
              [
                51.4985119,
                30.2133259
              ],
              [
                51.4998208,
                30.2117312
              ],
              [
                51.5018164,
                30.2111749
              ],
              [
                51.5042196,
                30.2108782
              ],
              [
                51.5064512,
                30.2064092
              ],
              [
                51.5088545,
                30.2014578
              ],
              [
                51.512674,
                30.1972851
              ],
              [
                51.5155707,
                30.1927412
              ],
              [
                51.5216433,
                30.1882343
              ],
              [
                51.5249263,
                30.1848586
              ],
              [
                51.5256559,
                30.1844134
              ],
              [
                51.5268356,
                30.1836952
              ],
              [
                51.5280718,
                30.1865027
              ],
              [
                51.5298313,
                30.1875599
              ],
              [
                51.5328139,
                30.1925305
              ],
              [
                51.546976,
                30.2060316
              ],
              [
                51.5540785,
                30.2143252
              ],
              [
                51.5657515,
                30.216439
              ],
              [
                51.5777678,
                30.2225392
              ],
              [
                51.5849561,
                30.2297143
              ],
              [
                51.5900415,
                30.2365182
              ],
              [
                51.5907226,
                30.241533
              ],
              [
                51.5910015,
                30.243743
              ],
              [
                51.5911756,
                30.2450736
              ],
              [
                51.592159,
                30.2512718
              ],
              [
                51.5921375,
                30.2557759
              ],
              [
                51.5896699,
                30.2641533
              ],
              [
                51.5819022,
                30.280072
              ],
              [
                51.5740916,
                30.2986746
              ],
              [
                51.5725038,
                30.3033803
              ],
              [
                51.5706584,
                30.3099567
              ],
              [
                51.5702293,
                30.3125316
              ],
              [
                51.5706155,
                30.3202188
              ],
              [
                51.572139,
                30.3322578
              ],
              [
                51.5727487,
                30.3339814
              ],
              [
                51.5736285,
                30.3405928
              ],
              [
                51.5728989,
                30.3475926
              ],
              [
                51.5703026,
                30.354592
              ],
              [
                51.5648952,
                30.3635534
              ],
              [
                51.5608397,
                30.3701628
              ],
              [
                51.5557917,
                30.3767835
              ],
              [
                51.5540965,
                30.3795047
              ],
              [
                51.5498479,
                30.3854096
              ],
              [
                51.543475,
                30.3930171
              ],
              [
                51.5392693,
                30.3966818
              ],
              [
                51.5304502,
                30.402049
              ],
              [
                51.5246137,
                30.4099142
              ],
              [
                51.520923,
                30.4170016
              ],
              [
                51.5207942,
                30.4192591
              ],
              [
                51.5211375,
                30.4256798
              ],
              [
                51.5215557,
                30.4340227
              ],
              [
                51.5215556,
                30.4343024
              ],
              [
                51.522109,
                30.4356831
              ],
              [
                51.5212756,
                30.4356831
              ],
              [
                51.502666,
                30.4420719
              ],
              [
                51.5007194,
                30.4431818
              ],
              [
                51.4840528,
                30.45124
              ],
              [
                51.4832195,
                30.4512399
              ],
              [
                51.4682197,
                30.4559684
              ],
              [
                51.467663,
                30.4598274
              ],
              [
                51.464866,
                30.4629125
              ],
              [
                51.4593549,
                30.4649426
              ],
              [
                51.4501538,
                30.4654471
              ],
              [
                51.4463387,
                30.4626566
              ],
              [
                51.440253,
                30.462215
              ],
              [
                51.431802,
                30.463489
              ],
              [
                51.4275818,
                30.4654865
              ],
              [
                51.4211654,
                30.4667634
              ],
              [
                51.4164595,
                30.4672032
              ],
              [
                51.4117075,
                30.4680539
              ],
              [
                51.4022925,
                30.4672563
              ],
              [
                51.3952792,
                30.4670921
              ],
              [
                51.3917743,
                30.4683986
              ],
              [
                51.3828524,
                30.4751034
              ],
              [
                51.3781109,
                30.4807086
              ],
              [
                51.373954,
                30.4851538
              ],
              [
                51.3680746,
                30.4927904
              ],
              [
                51.3626243,
                30.4988179
              ],
              [
                51.3581397,
                30.5031627
              ],
              [
                51.3547923,
                30.5062317
              ],
              [
                51.353891,
                30.5121474
              ],
              [
                51.3590409,
                30.5212238
              ],
              [
                51.3646413,
                30.5283031
              ],
              [
                51.368375,
                30.5344393
              ],
              [
                51.3718511,
                30.5468954
              ],
              [
                51.3717867,
                30.5519217
              ],
              [
                51.3720501,
                30.5547574
              ],
              [
                51.3662994,
                30.5605039
              ],
              [
                51.3622505,
                30.563534
              ],
              [
                51.358403,
                30.5657512
              ],
              [
                51.3421166,
                30.5693355
              ],
              [
                51.3307115,
                30.5731916
              ],
              [
                51.3298783,
                30.5734713
              ],
              [
                51.3015453,
                30.59069
              ],
              [
                51.296822,
                30.5940291
              ],
              [
                51.2518194,
                30.6165183
              ],
              [
                51.2376529,
                30.6306871
              ],
              [
                51.2359863,
                30.6329162
              ],
              [
                51.2279297,
                30.6423561
              ],
              [
                51.225153,
                30.6448559
              ],
              [
                51.2189854,
                30.6487353
              ],
              [
                51.2163891,
                30.6524642
              ],
              [
                51.2105311,
                30.6604384
              ],
              [
                51.2039222,
                30.6679505
              ],
              [
                51.1992574,
                30.6737515
              ],
              [
                51.1934294,
                30.6736349
              ],
              [
                51.1888862,
                30.6661198
              ],
              [
                51.1877061,
                30.6605826
              ],
              [
                51.184466,
                30.656208
              ],
              [
                51.1805821,
                30.6529407
              ],
              [
                51.1773736,
                30.6498557
              ],
              [
                51.1770937,
                30.6493051
              ],
              [
                51.1618173,
                30.6287467
              ],
              [
                51.1595819,
                30.6261167
              ],
              [
                51.1532304,
                30.6179181
              ],
              [
                51.1427766,
                30.6082802
              ],
              [
                51.1369616,
                30.5986025
              ],
              [
                51.1355668,
                30.5955365
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555059,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زرین دشت",
          "name:en": "Zarindasht County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1272887"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.0124998,
                28.4703621
              ],
              [
                54.0124998,
                28.4698126
              ],
              [
                54.0122197,
                28.467867
              ],
              [
                54.0111098,
                28.4603638
              ],
              [
                54.0108332,
                28.459535
              ],
              [
                54.0111097,
                28.4589857
              ],
              [
                54.0108332,
                28.4506447
              ],
              [
                54.0105531,
                28.4459249
              ],
              [
                54.0102765,
                28.4428715
              ],
              [
                54.0099999,
                28.4375933
              ],
              [
                54.0094431,
                28.4334229
              ],
              [
                54.0111098,
                28.4167508
              ],
              [
                54.0113865,
                28.4089778
              ],
              [
                54.0113865,
                28.40787
              ],
              [
                54.0116664,
                28.405366
              ],
              [
                54.016943,
                28.381201
              ],
              [
                54.0174997,
                28.3806426
              ],
              [
                54.0205564,
                28.3759232
              ],
              [
                54.0059137,
                28.3648849
              ],
              [
                54.0119827,
                28.3511087
              ],
              [
                54.0117477,
                28.3465468
              ],
              [
                54.0147586,
                28.3378207
              ],
              [
                54.0321349,
                28.3250091
              ],
              [
                54.0458414,
                28.3113858
              ],
              [
                54.0631959,
                28.2980325
              ],
              [
                54.0826172,
                28.2817428
              ],
              [
                54.0943626,
                28.274345
              ],
              [
                54.1215704,
                28.2587275
              ],
              [
                54.1318701,
                28.2544937
              ],
              [
                54.1550043,
                28.2500847
              ],
              [
                54.1566708,
                28.2489771
              ],
              [
                54.1577842,
                28.2486979
              ],
              [
                54.1583375,
                28.2481396
              ],
              [
                54.1616707,
                28.2467528
              ],
              [
                54.1627841,
                28.2461945
              ],
              [
                54.1636175,
                28.2459154
              ],
              [
                54.1641707,
                28.245366
              ],
              [
                54.1694507,
                28.2425835
              ],
              [
                54.1697273,
                28.2420251
              ],
              [
                54.1780605,
                28.2328671
              ],
              [
                54.1783406,
                28.2325879
              ],
              [
                54.1786172,
                28.2320296
              ],
              [
                54.1811171,
                28.2248077
              ],
              [
                54.1819505,
                28.2239702
              ],
              [
                54.1972303,
                28.18842
              ],
              [
                54.2000069,
                28.1764713
              ],
              [
                54.2002835,
                28.1742473
              ],
              [
                54.2002835,
                28.1706455
              ],
              [
                54.2005635,
                28.1698081
              ],
              [
                54.2083401,
                28.1409142
              ],
              [
                54.21334,
                28.1311901
              ],
              [
                54.2227865,
                28.1200885
              ],
              [
                54.2230631,
                28.1198004
              ],
              [
                54.2236198,
                28.1195213
              ],
              [
                54.2252865,
                28.1181347
              ],
              [
                54.2255632,
                28.1178556
              ],
              [
                54.2855655,
                28.0750808
              ],
              [
                54.2863988,
                28.0748016
              ],
              [
                54.2953396,
                28.0687653
              ],
              [
                54.3283448,
                28.0464695
              ],
              [
                54.3297348,
                28.0450831
              ],
              [
                54.3355213,
                28.0415674
              ],
              [
                54.3452913,
                28.0356302
              ],
              [
                54.3461246,
                28.0350811
              ],
              [
                54.3493195,
                28.033276
              ],
              [
                54.3500146,
                28.0328574
              ],
              [
                54.3505678,
                28.0325784
              ],
              [
                54.3639044,
                28.024242
              ],
              [
                54.3650143,
                28.0231348
              ],
              [
                54.3661243,
                28.0225766
              ],
              [
                54.3939039,
                28.0003588
              ],
              [
                54.3947371,
                27.9998007
              ],
              [
                54.4100169,
                27.9914647
              ],
              [
                54.4216834,
                27.9828587
              ],
              [
                54.4280733,
                27.979249
              ],
              [
                54.4505729,
                27.9725785
              ],
              [
                54.4511297,
                27.9725785
              ],
              [
                54.4541862,
                27.9720205
              ],
              [
                54.4555729,
                27.9720205
              ],
              [
                54.4580728,
                27.9714623
              ],
              [
                54.4608527,
                27.9714623
              ],
              [
                54.4758525,
                27.9695269
              ],
              [
                54.4789092,
                27.9695269
              ],
              [
                54.4794624,
                27.9692479
              ],
              [
                54.4816859,
                27.9692478
              ],
              [
                54.4822425,
                27.9689688
              ],
              [
                54.4847425,
                27.9689688
              ],
              [
                54.511132,
                27.9636848
              ],
              [
                54.5250218,
                27.9636848
              ],
              [
                54.5364116,
                27.9609122
              ],
              [
                54.537245,
                27.9609122
              ],
              [
                54.5375216,
                27.9606421
              ],
              [
                54.5383549,
                27.959805
              ],
              [
                54.5391883,
                27.9598049
              ],
              [
                54.539745,
                27.959526
              ],
              [
                54.5486348,
                27.9595259
              ],
              [
                54.549188,
                27.9592469
              ],
              [
                54.5508547,
                27.9592469
              ],
              [
                54.5547446,
                27.9581307
              ],
              [
                54.5566879,
                27.9578606
              ],
              [
                54.5589112,
                27.9573026
              ],
              [
                54.5761342,
                27.954521
              ],
              [
                54.5875241,
                27.954521
              ],
              [
                54.5886341,
                27.9548001
              ],
              [
                54.590024,
                27.9548001
              ],
              [
                54.5908574,
                27.9550791
              ],
              [
                54.5922475,
                27.9550791
              ],
              [
                54.5930807,
                27.9553582
              ],
              [
                54.5955807,
                27.9553582
              ],
              [
                54.5961339,
                27.9556372
              ],
              [
                54.5997473,
                27.9556372
              ],
              [
                54.6005806,
                27.9559163
              ],
              [
                54.6028039,
                27.9559162
              ],
              [
                54.6094705,
                27.9567444
              ],
              [
                54.6116903,
                27.9573025
              ],
              [
                54.6130804,
                27.9573025
              ],
              [
                54.6280801,
                27.9609122
              ],
              [
                54.6286368,
                27.9611912
              ],
              [
                54.6305802,
                27.9611912
              ],
              [
                54.6311368,
                27.9614703
              ],
              [
                54.6328035,
                27.9614703
              ],
              [
                54.6333601,
                27.9617494
              ],
              [
                54.63447,
                27.9617494
              ],
              [
                54.6380799,
                27.9620284
              ],
              [
                54.63947,
                27.9622985
              ],
              [
                54.64086,
                27.9622984
              ],
              [
                54.6419699,
                27.9625775
              ],
              [
                54.6450266,
                27.9625775
              ],
              [
                54.6541931,
                27.9636847
              ],
              [
                54.6553031,
                27.9639728
              ],
              [
                54.6583596,
                27.9639728
              ],
              [
                54.6914158,
                27.9678526
              ],
              [
                54.6925292,
                27.9681316
              ],
              [
                54.6947491,
                27.9681316
              ],
              [
                54.6955858,
                27.9684107
              ],
              [
                54.7005857,
                27.9684106
              ],
              [
                54.7016958,
                27.9686897
              ],
              [
                54.7030857,
                27.9684107
              ],
              [
                54.7044722,
                27.9686897
              ],
              [
                54.7055856,
                27.9684106
              ],
              [
                54.7066955,
                27.9686897
              ],
              [
                54.7094722,
                27.9686897
              ],
              [
                54.7105855,
                27.9689688
              ],
              [
                54.7119722,
                27.9689687
              ],
              [
                54.7130856,
                27.9692478
              ],
              [
                54.7164188,
                27.9692478
              ],
              [
                54.7175288,
                27.9695269
              ],
              [
                54.7191954,
                27.9695269
              ],
              [
                54.7216954,
                27.970076
              ],
              [
                54.7225287,
                27.970076
              ],
              [
                54.7264186,
                27.970355
              ],
              [
                54.7275285,
                27.9706341
              ],
              [
                54.7319753,
                27.9706341
              ],
              [
                54.7330852,
                27.9709132
              ],
              [
                54.7441984,
                27.9709131
              ],
              [
                54.7480849,
                27.9714622
              ],
              [
                54.748365,
                27.9717503
              ],
              [
                54.7605881,
                27.9720204
              ],
              [
                54.7614214,
                27.9717503
              ],
              [
                54.762808,
                27.9717503
              ],
              [
                54.7650313,
                27.9709132
              ],
              [
                54.7694746,
                27.9698058
              ],
              [
                54.7697546,
                27.9695268
              ],
              [
                54.770588,
                27.9695269
              ],
              [
                54.7708646,
                27.9692478
              ],
              [
                54.7728112,
                27.9692478
              ],
              [
                54.7733645,
                27.9689687
              ],
              [
                54.7766978,
                27.9689687
              ],
              [
                54.7775312,
                27.9686896
              ],
              [
                54.7819778,
                27.9686897
              ],
              [
                54.782531,
                27.9689688
              ],
              [
                54.7841977,
                27.9689687
              ],
              [
                54.7844778,
                27.9686897
              ],
              [
                54.7858643,
                27.9689687
              ],
              [
                54.7861443,
                27.9686896
              ],
              [
                54.7866977,
                27.9689687
              ],
              [
                54.7886443,
                27.9689687
              ],
              [
                54.789201,
                27.9686897
              ],
              [
                54.7905876,
                27.9686897
              ],
              [
                54.7955876,
                27.9675824
              ],
              [
                54.7961442,
                27.9673034
              ],
              [
                54.7980875,
                27.9673034
              ],
              [
                54.7983675,
                27.9670243
              ],
              [
                54.8058675,
                27.9670244
              ],
              [
                54.806144,
                27.9673034
              ],
              [
                54.8119772,
                27.9673034
              ],
              [
                54.812534,
                27.9675824
              ],
              [
                54.8142006,
                27.9675824
              ],
              [
                54.8233671,
                27.970634
              ],
              [
                54.8236437,
                27.9709131
              ],
              [
                54.8244771,
                27.9709131
              ],
              [
                54.8408668,
                27.9775835
              ],
              [
                54.8425335,
                27.9778536
              ],
              [
                54.881703,
                27.9856312
              ],
              [
                54.8869828,
                27.9873056
              ],
              [
                54.9047592,
                27.9956325
              ],
              [
                54.9052759,
                27.996031
              ],
              [
                54.9058725,
                27.9964697
              ],
              [
                54.9069808,
                28.0001009
              ],
              [
                54.9042074,
                28.0095182
              ],
              [
                54.9042059,
                28.009523
              ],
              [
                54.8983692,
                28.0286892
              ],
              [
                54.8978161,
                28.0298055
              ],
              [
                54.8975359,
                28.0311919
              ],
              [
                54.8972593,
                28.0314709
              ],
              [
                54.8969827,
                28.0323082
              ],
              [
                54.8814263,
                28.0800863
              ],
              [
                54.8814263,
                28.0803564
              ],
              [
                54.8814263,
                28.0809147
              ],
              [
                54.8811462,
                28.0811938
              ],
              [
                54.8812863,
                28.0814729
              ],
              [
                54.8814263,
                28.081752
              ],
              [
                54.881703,
                28.0853532
              ],
              [
                54.881703,
                28.0881352
              ],
              [
                54.881703,
                28.0895218
              ],
              [
                54.8819795,
                28.0898008
              ],
              [
                54.8775363,
                28.118972
              ],
              [
                54.876703,
                28.1217541
              ],
              [
                54.8736463,
                28.1436962
              ],
              [
                54.8728131,
                28.1478651
              ],
              [
                54.8722598,
                28.1495308
              ],
              [
                54.8719798,
                28.1520249
              ],
              [
                54.8717031,
                28.1525832
              ],
              [
                54.8717031,
                28.1545281
              ],
              [
                54.8700365,
                28.18453
              ],
              [
                54.8692032,
                28.1961998
              ],
              [
                54.8689265,
                28.1970281
              ],
              [
                54.8692032,
                28.1978565
              ],
              [
                54.8694798,
                28.2031422
              ],
              [
                54.8697598,
                28.2064739
              ],
              [
                54.8700365,
                28.2098057
              ],
              [
                54.8703132,
                28.2134166
              ],
              [
                54.8705931,
                28.2170274
              ],
              [
                54.8705932,
                28.2239702
              ],
              [
                54.8705931,
                28.2245284
              ],
              [
                54.8705931,
                28.2250867
              ],
              [
                54.8705931,
                28.2261944
              ],
              [
                54.8708698,
                28.2267526
              ],
              [
                54.8708698,
                28.2286976
              ],
              [
                54.8711465,
                28.2295262
              ],
              [
                54.8714265,
                28.2317504
              ],
              [
                54.8717031,
                28.2336954
              ],
              [
                54.8719798,
                28.2359196
              ],
              [
                54.8811463,
                28.2736963
              ],
              [
                54.8819796,
                28.2784242
              ],
              [
                54.8822597,
                28.2803604
              ],
              [
                54.8825363,
                28.2806395
              ],
              [
                54.883093,
                28.2834222
              ],
              [
                54.883093,
                28.2839715
              ],
              [
                54.8833697,
                28.2842507
              ],
              [
                54.8833696,
                28.2861959
              ],
              [
                54.8836463,
                28.2864751
              ],
              [
                54.8839263,
                28.2881411
              ],
              [
                54.884203,
                28.2898072
              ],
              [
                54.8908695,
                28.3120332
              ],
              [
                54.8911496,
                28.3134201
              ],
              [
                54.8964261,
                28.3267579
              ],
              [
                54.9058728,
                28.360639
              ],
              [
                54.9061493,
                28.3614766
              ],
              [
                54.906426,
                28.364809
              ],
              [
                54.9086494,
                28.3764814
              ],
              [
                54.9089675,
                28.3776692
              ],
              [
                54.8975361,
                28.3828671
              ],
              [
                54.8972595,
                28.3831463
              ],
              [
                54.8872596,
                28.3873073
              ],
              [
                54.8625368,
                28.3937021
              ],
              [
                54.8608701,
                28.3937021
              ],
              [
                54.8603134,
                28.3939813
              ],
              [
                54.8589234,
                28.3939814
              ],
              [
                54.8583701,
                28.3942605
              ],
              [
                54.8564234,
                28.3942605
              ],
              [
                54.8558701,
                28.3945308
              ],
              [
                54.8542035,
                28.3945308
              ],
              [
                54.8533702,
                28.3948099
              ],
              [
                54.8522569,
                28.39481
              ],
              [
                54.8519802,
                28.3950892
              ],
              [
                54.8492036,
                28.3950892
              ],
              [
                54.8483702,
                28.3953684
              ],
              [
                54.8469803,
                28.3953684
              ],
              [
                54.8458669,
                28.3956476
              ],
              [
                54.8430903,
                28.3956476
              ],
              [
                54.8419804,
                28.3956476
              ],
              [
                54.8392004,
                28.3956476
              ],
              [
                54.8380904,
                28.3959269
              ],
              [
                54.8342004,
                28.3959268
              ],
              [
                54.8311473,
                28.396197
              ],
              [
                54.8303139,
                28.3964763
              ],
              [
                54.8272572,
                28.3964762
              ],
              [
                54.826424,
                28.3967554
              ],
              [
                54.8253106,
                28.3967554
              ],
              [
                54.8247573,
                28.3970346
              ],
              [
                54.8217007,
                28.3970346
              ],
              [
                54.821424,
                28.3973139
              ],
              [
                54.8169773,
                28.3973139
              ],
              [
                54.8092009,
                28.3989801
              ],
              [
                54.8075342,
                28.3989801
              ],
              [
                54.8064209,
                28.3992593
              ],
              [
                54.7980876,
                28.3992593
              ],
              [
                54.7975344,
                28.3995295
              ],
              [
                54.7947544,
                28.3995295
              ],
              [
                54.7933678,
                28.4000879
              ],
              [
                54.7922543,
                28.400088
              ],
              [
                54.7841978,
                28.4023126
              ],
              [
                54.7839212,
                28.4025919
              ],
              [
                54.7830878,
                28.4025918
              ],
              [
                54.7797546,
                28.4039789
              ],
              [
                54.7789212,
                28.4045283
              ],
              [
                54.776698,
                28.4056452
              ],
              [
                54.7436418,
                28.4323149
              ],
              [
                54.7289188,
                28.4425921
              ],
              [
                54.728362,
                28.4431506
              ],
              [
                54.6978059,
                28.4678669
              ],
              [
                54.6861394,
                28.4759288
              ],
              [
                54.6855828,
                28.4764782
              ],
              [
                54.6853061,
                28.4767574
              ],
              [
                54.6836394,
                28.4775952
              ],
              [
                54.6828061,
                28.4784238
              ],
              [
                54.6822495,
                28.4784239
              ],
              [
                54.6814161,
                28.4792526
              ],
              [
                54.6811396,
                28.4795318
              ],
              [
                54.6661399,
                28.4909266
              ],
              [
                54.6658597,
                28.491485
              ],
              [
                54.6408601,
                28.5062039
              ],
              [
                54.6403034,
                28.5064742
              ],
              [
                54.6353035,
                28.5089784
              ],
              [
                54.6264137,
                28.516482
              ],
              [
                54.6194704,
                28.526481
              ],
              [
                54.6139139,
                28.5367595
              ],
              [
                54.6105807,
                28.5400925
              ],
              [
                54.610304,
                28.5403718
              ],
              [
                54.6098864,
                28.5407869
              ],
              [
                54.584191,
                28.5692619
              ],
              [
                54.582801,
                28.57037
              ],
              [
                54.5805777,
                28.5723158
              ],
              [
                54.5787959,
                28.5733051
              ],
              [
                54.5350218,
                28.5975945
              ],
              [
                54.5275219,
                28.6017567
              ],
              [
                54.5264119,
                28.602036
              ],
              [
                54.5255786,
                28.6023152
              ],
              [
                54.5255786,
                28.6025945
              ],
              [
                54.524742,
                28.6028738
              ],
              [
                54.5241886,
                28.6028738
              ],
              [
                54.5239086,
                28.603153
              ],
              [
                54.5230753,
                28.603153
              ],
              [
                54.5227987,
                28.6034233
              ],
              [
                54.5219653,
                28.6034233
              ],
              [
                54.5216887,
                28.6037026
              ],
              [
                54.5211321,
                28.6037026
              ],
              [
                54.5208553,
                28.6039819
              ],
              [
                54.5202986,
                28.6039819
              ],
              [
                54.5139087,
                28.6059278
              ],
              [
                54.5108555,
                28.6067567
              ],
              [
                54.5097422,
                28.6067566
              ],
              [
                54.5089088,
                28.6070359
              ],
              [
                54.5064089,
                28.607036
              ],
              [
                54.5022422,
                28.6078738
              ],
              [
                54.501409,
                28.6078738
              ],
              [
                54.5008522,
                28.6081531
              ],
              [
                54.4994657,
                28.6081531
              ],
              [
                54.4991856,
                28.6084323
              ],
              [
                54.4977991,
                28.6084324
              ],
              [
                54.4961324,
                28.6089818
              ],
              [
                54.495019,
                28.6089819
              ],
              [
                54.4944657,
                28.6092612
              ],
              [
                54.4933525,
                28.6092611
              ],
              [
                54.4927992,
                28.6095404
              ],
              [
                54.4916858,
                28.6095405
              ],
              [
                54.4855759,
                28.6114775
              ],
              [
                54.4839092,
                28.6114774
              ],
              [
                54.4830759,
                28.6117567
              ],
              [
                54.480576,
                28.6117566
              ],
              [
                54.4794627,
                28.612036
              ],
              [
                54.4741861,
                28.6120359
              ],
              [
                54.4739094,
                28.6123152
              ],
              [
                54.4708528,
                28.6123153
              ],
              [
                54.4700194,
                28.6120359
              ],
              [
                54.4686295,
                28.6120359
              ],
              [
                54.4636295,
                28.6106485
              ],
              [
                54.4633529,
                28.6103693
              ],
              [
                54.4627963,
                28.6103693
              ],
              [
                54.4622395,
                28.6100937
              ],
              [
                54.4575197,
                28.607036
              ],
              [
                54.4272401,
                28.5917567
              ],
              [
                54.4264068,
                28.5914865
              ],
              [
                54.4252935,
                28.590928
              ],
              [
                54.4247401,
                28.590928
              ],
              [
                54.4244601,
                28.5906487
              ],
              [
                54.4236268,
                28.5906487
              ],
              [
                54.4233502,
                28.5903694
              ],
              [
                54.4219602,
                28.5903694
              ],
              [
                54.4214069,
                28.5900902
              ],
              [
                54.4180736,
                28.5900901
              ],
              [
                54.4177935,
                28.5898109
              ],
              [
                54.4164069,
                28.5898109
              ],
              [
                54.4130736,
                28.5887028
              ],
              [
                54.4019605,
                28.5823156
              ],
              [
                54.4011271,
                28.5814777
              ],
              [
                54.4000172,
                28.5809282
              ],
              [
                54.3952939,
                28.5762076
              ],
              [
                54.3930706,
                28.5725952
              ],
              [
                54.3911274,
                28.5698115
              ],
              [
                54.3911274,
                28.5695412
              ],
              [
                54.3905706,
                28.569262
              ],
              [
                54.3830708,
                28.5589832
              ],
              [
                54.3764042,
                28.5553708
              ],
              [
                54.365571,
                28.5525962
              ],
              [
                54.365291,
                28.5523169
              ],
              [
                54.3639045,
                28.552317
              ],
              [
                54.3619577,
                28.5517584
              ],
              [
                54.3586244,
                28.5517584
              ],
              [
                54.3577911,
                28.5520376
              ],
              [
                54.3555712,
                28.5520376
              ],
              [
                54.3547344,
                28.552317
              ],
              [
                54.3519579,
                28.5523169
              ],
              [
                54.346958,
                28.5528664
              ],
              [
                54.340568,
                28.5548122
              ],
              [
                54.3400148,
                28.5548123
              ],
              [
                54.3386247,
                28.5553708
              ],
              [
                54.3373806,
                28.5558856
              ],
              [
                54.3305682,
                28.5587039
              ],
              [
                54.3294583,
                28.5595327
              ],
              [
                54.3089019,
                28.566199
              ],
              [
                54.2838989,
                28.577586
              ],
              [
                54.282789,
                28.5784238
              ],
              [
                54.2730658,
                28.5862074
              ],
              [
                54.2716758,
                28.5870361
              ],
              [
                54.2713991,
                28.5875947
              ],
              [
                54.2697325,
                28.5884235
              ],
              [
                54.2688992,
                28.5892613
              ],
              [
                54.240843,
                28.6025945
              ],
              [
                54.2380629,
                28.6034234
              ],
              [
                54.2344531,
                28.6048197
              ],
              [
                54.2336197,
                28.6048197
              ],
              [
                54.2322298,
                28.6053693
              ],
              [
                54.2275099,
                28.6061981
              ],
              [
                54.2272298,
                28.6064774
              ],
              [
                54.2244532,
                28.6064775
              ],
              [
                54.2241766,
                28.6067567
              ],
              [
                54.2227866,
                28.6067567
              ],
              [
                54.2225065,
                28.607036
              ],
              [
                54.2216731,
                28.607036
              ],
              [
                54.2213965,
                28.6073153
              ],
              [
                54.2200065,
                28.6073152
              ],
              [
                54.2194533,
                28.6075945
              ],
              [
                54.2183399,
                28.6075945
              ],
              [
                54.2094535,
                28.6103693
              ],
              [
                54.2088968,
                28.6103693
              ],
              [
                54.2086201,
                28.6106486
              ],
              [
                54.1919503,
                28.6164775
              ],
              [
                54.1905637,
                28.6164774
              ],
              [
                54.1894504,
                28.6167568
              ],
              [
                54.1891738,
                28.617036
              ],
              [
                54.1880638,
                28.617036
              ],
              [
                54.1566709,
                28.6256488
              ],
              [
                54.1558376,
                28.6256488
              ],
              [
                54.1555609,
                28.6259281
              ],
              [
                54.1538942,
                28.6259281
              ],
              [
                54.151671,
                28.6267569
              ],
              [
                54.150561,
                28.626757
              ],
              [
                54.1497276,
                28.6270362
              ],
              [
                54.1483377,
                28.6273156
              ],
              [
                54.1433378,
                28.6295408
              ],
              [
                54.1425045,
                28.6295408
              ],
              [
                54.1272246,
                28.6367573
              ],
              [
                54.1022251,
                28.645091
              ],
              [
                54.1016684,
                28.6450909
              ],
              [
                54.1002818,
                28.6437035
              ],
              [
                54.0969485,
                28.6342617
              ],
              [
                54.0966685,
                28.6331445
              ],
              [
                54.0861119,
                28.5923153
              ],
              [
                54.086112,
                28.5914865
              ],
              [
                54.0858353,
                28.5906487
              ],
              [
                54.0822254,
                28.5778653
              ],
              [
                54.0727788,
                28.5570374
              ],
              [
                54.0577791,
                28.5445337
              ],
              [
                54.0566691,
                28.5437049
              ],
              [
                54.0477792,
                28.536201
              ],
              [
                54.045556,
                28.5348137
              ],
              [
                54.0266662,
                28.5134284
              ],
              [
                54.0233329,
                28.5059247
              ],
              [
                54.021943,
                28.505087
              ],
              [
                54.0216663,
                28.5042583
              ],
              [
                54.0205563,
                28.5000876
              ],
              [
                54.0166664,
                28.4887017
              ],
              [
                54.0163898,
                28.4870353
              ],
              [
                54.0161097,
                28.4853689
              ],
              [
                54.0158331,
                28.4834232
              ],
              [
                54.0155564,
                28.4828647
              ],
              [
                54.0124998,
                28.4709206
              ],
              [
                54.0124998,
                28.4703621
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555078,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سروستان",
          "name:en": "Sarvestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q768252",
          "wikipedia": "en:Sarvestan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.7331623,
                29.3951846
              ],
              [
                52.7383659,
                29.3904808
              ],
              [
                52.7413,
                29.3872938
              ],
              [
                52.7450707,
                29.3840927
              ],
              [
                52.7514553,
                29.3767527
              ],
              [
                52.7623557,
                29.3673657
              ],
              [
                52.7705526,
                29.355509
              ],
              [
                52.7760458,
                29.3459329
              ],
              [
                52.7817829,
                29.3392531
              ],
              [
                52.7842902,
                29.3342577
              ],
              [
                52.786864,
                29.3301346
              ],
              [
                52.7915802,
                29.3237051
              ],
              [
                52.8227243,
                29.2784361
              ],
              [
                52.8321709,
                29.267879
              ],
              [
                52.8330042,
                29.2670496
              ],
              [
                52.8349475,
                29.2651023
              ],
              [
                52.8355041,
                29.2645523
              ],
              [
                52.8360574,
                29.2637139
              ],
              [
                52.8368907,
                29.262605
              ],
              [
                52.8516139,
                29.2456654
              ],
              [
                52.8674503,
                29.2342703
              ],
              [
                52.8682836,
                29.2342704
              ],
              [
                52.8685602,
                29.2339999
              ],
              [
                52.8691169,
                29.2339999
              ],
              [
                52.8696703,
                29.2337204
              ],
              [
                52.8705035,
                29.2337204
              ],
              [
                52.8710602,
                29.2334409
              ],
              [
                52.8721701,
                29.233441
              ],
              [
                52.8738368,
                29.232882
              ],
              [
                52.8749502,
                29.232882
              ],
              [
                52.8805033,
                29.2306644
              ],
              [
                52.8885599,
                29.2231639
              ],
              [
                52.8891166,
                29.222046
              ],
              [
                52.8941165,
                29.2167723
              ],
              [
                52.8960598,
                29.2148341
              ],
              [
                52.9093963,
                29.2014922
              ],
              [
                52.9099497,
                29.2014922
              ],
              [
                52.913563,
                29.1989951
              ],
              [
                52.9141163,
                29.1984362
              ],
              [
                52.915371,
                29.1980182
              ],
              [
                52.9163395,
                29.1973274
              ],
              [
                52.9302293,
                29.1923242
              ],
              [
                52.9441192,
                29.1856624
              ],
              [
                52.9449525,
                29.1856624
              ],
              [
                52.9452291,
                29.1853829
              ],
              [
                52.9460625,
                29.1853829
              ],
              [
                52.9463425,
                29.1851035
              ],
              [
                52.9468957,
                29.1851035
              ],
              [
                52.9491191,
                29.1842741
              ],
              [
                52.950229,
                29.1842742
              ],
              [
                52.9505091,
                29.1839947
              ],
              [
                52.9510623,
                29.1839947
              ],
              [
                52.9513424,
                29.1837152
              ],
              [
                52.9557857,
                29.1828768
              ],
              [
                52.9574523,
                29.1828769
              ],
              [
                52.9580089,
                29.1826064
              ],
              [
                52.9593989,
                29.1826064
              ],
              [
                52.9596756,
                29.182327
              ],
              [
                52.9607856,
                29.182327
              ],
              [
                52.9624522,
                29.1820475
              ],
              [
                52.9632855,
                29.1812183
              ],
              [
                52.9635656,
                29.1809387
              ],
              [
                52.9730087,
                29.1745474
              ],
              [
                52.9735654,
                29.1737181
              ],
              [
                53.0113449,
                29.1442681
              ],
              [
                53.0263446,
                29.1317744
              ],
              [
                53.0274545,
                29.1306567
              ],
              [
                53.0280113,
                29.1303862
              ],
              [
                53.0282879,
                29.1298274
              ],
              [
                53.0360677,
                29.1217688
              ],
              [
                53.0363444,
                29.1217688
              ],
              [
                53.0374578,
                29.1220482
              ],
              [
                53.043011,
                29.1220482
              ],
              [
                53.0438443,
                29.1223277
              ],
              [
                53.0466243,
                29.1223277
              ],
              [
                53.0466243,
                29.1220483
              ],
              [
                53.0474576,
                29.1220483
              ],
              [
                53.0477343,
                29.1217688
              ],
              [
                53.0505109,
                29.1206601
              ],
              [
                53.0505109,
                29.1203807
              ],
              [
                53.0519009,
                29.1203807
              ],
              [
                53.0521775,
                29.1201012
              ],
              [
                53.0544008,
                29.1201012
              ],
              [
                53.0549575,
                29.1198308
              ],
              [
                53.0557909,
                29.1198308
              ],
              [
                53.0560674,
                29.1195514
              ],
              [
                53.0596809,
                29.1181542
              ],
              [
                53.0613474,
                29.1170455
              ],
              [
                53.0760706,
                29.1126015
              ],
              [
                53.0777372,
                29.1114929
              ],
              [
                53.087457,
                29.1064901
              ],
              [
                53.088847,
                29.1053814
              ],
              [
                53.0905137,
                29.1045522
              ],
              [
                53.1369064,
                29.0748248
              ],
              [
                53.1430162,
                29.0692724
              ],
              [
                53.1480161,
                29.0662169
              ],
              [
                53.156906,
                29.0603851
              ],
              [
                53.1680192,
                29.054265
              ],
              [
                53.1702391,
                29.0526065
              ],
              [
                53.181629,
                29.0464864
              ],
              [
                53.1824623,
                29.0456572
              ],
              [
                53.1902422,
                29.0417635
              ],
              [
                53.1905189,
                29.0417635
              ],
              [
                53.1910755,
                29.0414931
              ],
              [
                53.1913521,
                29.0412136
              ],
              [
                53.2105186,
                29.0295415
              ],
              [
                53.2116319,
                29.0292711
              ],
              [
                53.2313549,
                29.0212133
              ],
              [
                53.2324649,
                29.0212133
              ],
              [
                53.2344082,
                29.0206545
              ],
              [
                53.2366315,
                29.0206546
              ],
              [
                53.2374649,
                29.0203841
              ],
              [
                53.2391314,
                29.0203841
              ],
              [
                53.2399648,
                29.0201047
              ],
              [
                53.2452448,
                29.0201047
              ],
              [
                53.248578,
                29.0195459
              ],
              [
                53.2516312,
                29.0195459
              ],
              [
                53.2527446,
                29.0192665
              ],
              [
                53.2549645,
                29.0192665
              ],
              [
                53.2557979,
                29.0189871
              ],
              [
                53.2569112,
                29.0189872
              ],
              [
                53.2574645,
                29.0187167
              ],
              [
                53.2588544,
                29.0187167
              ],
              [
                53.2591311,
                29.0184373
              ],
              [
                53.2635777,
                29.0184373
              ],
              [
                53.2638544,
                29.0187167
              ],
              [
                53.2649677,
                29.0187167
              ],
              [
                53.2674678,
                29.0187167
              ],
              [
                53.268021,
                29.0184373
              ],
              [
                53.2701754,
                29.0180882
              ],
              [
                53.270801,
                29.0178785
              ],
              [
                53.2716343,
                29.017599
              ],
              [
                53.2727442,
                29.017599
              ],
              [
                53.2735775,
                29.0173196
              ],
              [
                53.2774675,
                29.0173197
              ],
              [
                53.2835774,
                29.0181579
              ],
              [
                53.3038572,
                29.0181579
              ],
              [
                53.304967,
                29.0184373
              ],
              [
                53.3071904,
                29.0184373
              ],
              [
                53.3094137,
                29.0187167
              ],
              [
                53.3146904,
                29.0187167
              ],
              [
                53.3155237,
                29.0189871
              ],
              [
                53.320947,
                29.018749
              ],
              [
                53.3344133,
                29.0181579
              ],
              [
                53.3438599,
                29.0181579
              ],
              [
                53.3535796,
                29.0189871
              ],
              [
                53.3858059,
                29.0178786
              ],
              [
                53.3955291,
                29.0170493
              ],
              [
                53.3996958,
                29.0170493
              ],
              [
                53.4021957,
                29.01677
              ],
              [
                53.4060822,
                29.0167699
              ],
              [
                53.4088623,
                29.0164905
              ],
              [
                53.4127522,
                29.0164906
              ],
              [
                53.4221953,
                29.0156523
              ],
              [
                53.4369185,
                29.0151025
              ],
              [
                53.4383085,
                29.0151025
              ],
              [
                53.4388617,
                29.0151025
              ],
              [
                53.4396951,
                29.0148231
              ],
              [
                53.4466417,
                29.0145527
              ],
              [
                53.4474751,
                29.0148231
              ],
              [
                53.4494183,
                29.0148231
              ],
              [
                53.4496984,
                29.0151025
              ],
              [
                53.4533082,
                29.0151025
              ],
              [
                53.4540715,
                29.0153213
              ],
              [
                53.457445,
                29.0165562
              ],
              [
                53.468588,
                29.0264861
              ],
              [
                53.4688647,
                29.0273243
              ],
              [
                53.4691413,
                29.0276037
              ],
              [
                53.4694151,
                29.0278741
              ],
              [
                53.4699746,
                29.0284329
              ],
              [
                53.4699747,
                29.0287123
              ],
              [
                53.4705313,
                29.029821
              ],
              [
                53.4702547,
                29.0301003
              ],
              [
                53.4696981,
                29.0334352
              ],
              [
                53.4680313,
                29.0375994
              ],
              [
                53.4677513,
                29.0378787
              ],
              [
                53.4655313,
                29.0406549
              ],
              [
                53.3938624,
                29.1187131
              ],
              [
                53.3880259,
                29.1259334
              ],
              [
                53.3846925,
                29.130107
              ],
              [
                53.3808059,
                29.1351008
              ],
              [
                53.3580263,
                29.1706623
              ],
              [
                53.3510797,
                29.1787212
              ],
              [
                53.3438598,
                29.1881596
              ],
              [
                53.3433032,
                29.1903862
              ],
              [
                53.3430265,
                29.1917744
              ],
              [
                53.3427465,
                29.1931627
              ],
              [
                53.3424699,
                29.1976069
              ],
              [
                53.3421932,
                29.200104
              ],
              [
                53.3421932,
                29.2137163
              ],
              [
                53.3419132,
                29.2151047
              ],
              [
                53.3441365,
                29.263714
              ],
              [
                53.3438598,
                29.2662204
              ],
              [
                53.3435798,
                29.2734416
              ],
              [
                53.3433031,
                29.2828898
              ],
              [
                53.3430264,
                29.2990006
              ],
              [
                53.3427464,
                29.3064926
              ],
              [
                53.3424698,
                29.3095489
              ],
              [
                53.3421931,
                29.3131642
              ],
              [
                53.3419131,
                29.3231628
              ],
              [
                53.3416364,
                29.3331703
              ],
              [
                53.3413599,
                29.3370471
              ],
              [
                53.3416365,
                29.3414921
              ],
              [
                53.3416365,
                29.3562152
              ],
              [
                53.32747,
                29.3576037
              ],
              [
                53.3244134,
                29.3573333
              ],
              [
                53.3238568,
                29.3570537
              ],
              [
                53.3213567,
                29.3570537
              ],
              [
                53.3210801,
                29.3567742
              ],
              [
                53.3196901,
                29.3567743
              ],
              [
                53.3002471,
                29.3523293
              ],
              [
                53.2871906,
                29.3464959
              ],
              [
                53.2830241,
                29.3439985
              ],
              [
                53.2627443,
                29.3312229
              ],
              [
                53.2616344,
                29.3312229
              ],
              [
                53.2613543,
                29.3309434
              ],
              [
                53.2585778,
                29.3309434
              ],
              [
                53.2580211,
                29.3312229
              ],
              [
                53.2569111,
                29.3312229
              ],
              [
                53.2532977,
                29.3323318
              ],
              [
                53.2527445,
                29.3323319
              ],
              [
                53.2524644,
                29.3326113
              ],
              [
                53.2513545,
                29.3326114
              ],
              [
                53.2510779,
                29.3328818
              ],
              [
                53.2502446,
                29.3328817
              ],
              [
                53.2310748,
                29.3412215
              ],
              [
                53.2241315,
                29.3462254
              ],
              [
                53.2224649,
                29.3470549
              ],
              [
                53.2180183,
                29.3498318
              ],
              [
                53.2127417,
                29.3528883
              ],
              [
                53.1985753,
                29.3573331
              ],
              [
                53.1971853,
                29.3573332
              ],
              [
                53.1966286,
                29.3576037
              ],
              [
                53.1932954,
                29.3576037
              ],
              [
                53.1919087,
                29.3578832
              ],
              [
                53.1860755,
                29.3578832
              ],
              [
                53.1841288,
                29.3581627
              ],
              [
                53.1799621,
                29.3581626
              ],
              [
                53.1471827,
                29.3678821
              ],
              [
                53.145516,
                29.3681706
              ],
              [
                53.1366261,
                29.3717771
              ],
              [
                53.1357928,
                29.3720566
              ],
              [
                53.133573,
                29.3731656
              ],
              [
                53.1330163,
                29.3734451
              ],
              [
                53.1319063,
                29.3737156
              ],
              [
                53.1313496,
                29.3737156
              ],
              [
                53.131073,
                29.3739951
              ],
              [
                53.1285731,
                29.373995
              ],
              [
                53.1255164,
                29.375104
              ],
              [
                53.1241264,
                29.3753836
              ],
              [
                53.1235697,
                29.3756631
              ],
              [
                53.1221831,
                29.3756631
              ],
              [
                53.1216264,
                29.3759426
              ],
              [
                53.1205164,
                29.3759426
              ],
              [
                53.1202364,
                29.3762221
              ],
              [
                53.1188499,
                29.3762222
              ],
              [
                53.1185698,
                29.3765016
              ],
              [
                53.1171832,
                29.3765016
              ],
              [
                53.1141265,
                29.3773311
              ],
              [
                53.1127365,
                29.3773311
              ],
              [
                53.1119033,
                29.3776106
              ],
              [
                53.1105166,
                29.3776105
              ],
              [
                53.1096833,
                29.3778901
              ],
              [
                53.1069034,
                29.3778901
              ],
              [
                53.1066267,
                29.3781696
              ],
              [
                53.1016268,
                29.3781696
              ],
              [
                53.0844037,
                29.3723361
              ],
              [
                53.0824569,
                29.3714976
              ],
              [
                53.0744038,
                29.3703886
              ],
              [
                53.0738471,
                29.3701091
              ],
              [
                53.0721806,
                29.3701091
              ],
              [
                53.0610673,
                29.3681706
              ],
              [
                53.0544007,
                29.3681706
              ],
              [
                53.0480108,
                29.3695501
              ],
              [
                53.0471775,
                29.3695501
              ],
              [
                53.0424576,
                29.3714976
              ],
              [
                53.040791,
                29.3728861
              ],
              [
                53.0238445,
                29.3901072
              ],
              [
                52.973842,
                29.4148304
              ],
              [
                52.9685654,
                29.4201142
              ],
              [
                52.9680087,
                29.4203846
              ],
              [
                52.967452,
                29.4215027
              ],
              [
                52.964952,
                29.4240003
              ],
              [
                52.9643989,
                29.4248299
              ],
              [
                52.9635655,
                29.4248298
              ],
              [
                52.9630087,
                29.4245594
              ],
              [
                52.9613421,
                29.4245594
              ],
              [
                52.9607854,
                29.4242708
              ],
              [
                52.9596754,
                29.4242708
              ],
              [
                52.9510622,
                29.4223322
              ],
              [
                52.9496757,
                29.4223322
              ],
              [
                52.9313392,
                29.4192755
              ],
              [
                52.9293959,
                29.4192756
              ],
              [
                52.9260627,
                29.4184461
              ],
              [
                52.9246727,
                29.4184461
              ],
              [
                52.9238393,
                29.4181666
              ],
              [
                52.9202295,
                29.4181665
              ],
              [
                52.9193961,
                29.417887
              ],
              [
                52.9171727,
                29.417887
              ],
              [
                52.9163394,
                29.4176075
              ],
              [
                52.9152295,
                29.4176075
              ],
              [
                52.9143962,
                29.417328
              ],
              [
                52.9071729,
                29.4164985
              ],
              [
                52.8988397,
                29.4164985
              ],
              [
                52.8985597,
                29.4162189
              ],
              [
                52.8960598,
                29.4162189
              ],
              [
                52.8949498,
                29.4159394
              ],
              [
                52.8941165,
                29.4159394
              ],
              [
                52.8938397,
                29.4156599
              ],
              [
                52.8916165,
                29.4156599
              ],
              [
                52.8910598,
                29.4159394
              ],
              [
                52.8891165,
                29.4159394
              ],
              [
                52.8885598,
                29.4162189
              ],
              [
                52.8877265,
                29.416219
              ],
              [
                52.8705466,
                29.423702
              ],
              [
                52.8705035,
                29.4237208
              ],
              [
                52.8466138,
                29.4395542
              ],
              [
                52.8449471,
                29.4403927
              ],
              [
                52.8296708,
                29.4467766
              ],
              [
                52.8288374,
                29.4467766
              ],
              [
                52.8280041,
                29.4473357
              ],
              [
                52.8199475,
                29.4495538
              ],
              [
                52.8185576,
                29.4495538
              ],
              [
                52.8177243,
                29.4498333
              ],
              [
                52.8166143,
                29.4498333
              ],
              [
                52.8149477,
                29.4501128
              ],
              [
                52.8141143,
                29.4498333
              ],
              [
                52.8135553,
                29.4498333
              ],
              [
                52.8124476,
                29.4495538
              ],
              [
                52.7732782,
                29.4428903
              ],
              [
                52.7688316,
                29.4403927
              ],
              [
                52.7686397,
                29.4400051
              ],
              [
                52.7685548,
                29.4398336
              ],
              [
                52.7668884,
                29.439004
              ],
              [
                52.7666117,
                29.438445
              ],
              [
                52.7654983,
                29.4378861
              ],
              [
                52.7641117,
                29.4364975
              ],
              [
                52.7613317,
                29.4342793
              ],
              [
                52.747442,
                29.418446
              ],
              [
                52.7460553,
                29.4156598
              ],
              [
                52.7454987,
                29.4153893
              ],
              [
                52.7407753,
                29.4062195
              ],
              [
                52.7435899,
                29.4049449
              ],
              [
                52.7367195,
                29.3976955
              ],
              [
                52.7331623,
                29.3951846
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555096,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سپیدان",
          "name:en": "Sepidan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1020632",
          "wikipedia": "en:Sepidan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.7508455,
                30.3608145
              ],
              [
                51.8020438,
                30.3097134
              ],
              [
                51.8109336,
                30.3036021
              ],
              [
                51.8117671,
                30.3030423
              ],
              [
                51.813157,
                30.3019321
              ],
              [
                51.866493,
                30.2638656
              ],
              [
                51.8892727,
                30.2449635
              ],
              [
                51.9276054,
                30.2121789
              ],
              [
                51.9362187,
                30.2035587
              ],
              [
                51.9373287,
                30.2021686
              ],
              [
                51.9531619,
                30.1841068
              ],
              [
                51.9573318,
                30.1777162
              ],
              [
                51.9609416,
                30.170766
              ],
              [
                51.9612185,
                30.1693759
              ],
              [
                51.9739983,
                30.133804
              ],
              [
                51.9741198,
                30.1298968
              ],
              [
                51.8990705,
                30.17096
              ],
              [
                51.8968506,
                30.1679015
              ],
              [
                51.8968506,
                30.1676219
              ],
              [
                51.8799041,
                30.1595741
              ],
              [
                51.8790707,
                30.1606839
              ],
              [
                51.8768475,
                30.1606839
              ],
              [
                51.8757374,
                30.1604042
              ],
              [
                51.8743476,
                30.1604042
              ],
              [
                51.8735142,
                30.1606838
              ],
              [
                51.870461,
                30.1606838
              ],
              [
                51.8699044,
                30.1604042
              ],
              [
                51.867961,
                30.1604042
              ],
              [
                51.8424013,
                30.1545669
              ],
              [
                51.8387915,
                30.1542962
              ],
              [
                51.8340681,
                30.1542962
              ],
              [
                51.8324015,
                30.1540166
              ],
              [
                51.8285149,
                30.1540165
              ],
              [
                51.8182351,
                30.1526271
              ],
              [
                51.8121252,
                30.1526272
              ],
              [
                51.8112917,
                30.1529068
              ],
              [
                51.8076786,
                30.1529068
              ],
              [
                51.8062886,
                30.1531865
              ],
              [
                51.8021218,
                30.1531865
              ],
              [
                51.8012886,
                30.1529068
              ],
              [
                51.7990687,
                30.1529068
              ],
              [
                51.7982353,
                30.1526271
              ],
              [
                51.7962887,
                30.1526272
              ],
              [
                51.7851788,
                30.1498484
              ],
              [
                51.7849904,
                30.1496601
              ],
              [
                51.7848989,
                30.1495686
              ],
              [
                51.7782322,
                30.1448502
              ],
              [
                51.7768457,
                30.1448502
              ],
              [
                51.7762416,
                30.1445227
              ],
              [
                51.7760125,
                30.1442908
              ],
              [
                51.7750385,
                30.1433196
              ],
              [
                51.7746224,
                30.1429015
              ],
              [
                51.7721223,
                30.1404024
              ],
              [
                51.7721224,
                30.139843
              ],
              [
                51.7715657,
                30.1392926
              ],
              [
                51.7682324,
                30.1326255
              ],
              [
                51.7679559,
                30.1312361
              ],
              [
                51.7673992,
                30.1231796
              ],
              [
                51.7676757,
                30.1204009
              ],
              [
                51.7685092,
                30.1167922
              ],
              [
                51.7712774,
                30.1125335
              ],
              [
                51.7726792,
                30.1112348
              ],
              [
                51.7729558,
                30.1109551
              ],
              [
                51.779899,
                30.1056774
              ],
              [
                51.7893455,
                30.1003997
              ],
              [
                51.7896221,
                30.1001201
              ],
              [
                51.8249016,
                30.0837368
              ],
              [
                51.8262917,
                30.0834572
              ],
              [
                51.8268484,
                30.0828978
              ],
              [
                51.8287916,
                30.0823475
              ],
              [
                51.8290684,
                30.0820678
              ],
              [
                51.8299015,
                30.0820678
              ],
              [
                51.831015,
                30.0815085
              ],
              [
                51.8340682,
                30.0809582
              ],
              [
                51.8343484,
                30.0806786
              ],
              [
                51.8354583,
                30.0806785
              ],
              [
                51.849348,
                30.0767903
              ],
              [
                51.850458,
                30.0767903
              ],
              [
                51.8512913,
                30.0765106
              ],
              [
                51.8521247,
                30.0765106
              ],
              [
                51.8529578,
                30.07624
              ],
              [
                51.8549046,
                30.0762399
              ],
              [
                51.855738,
                30.0759603
              ],
              [
                51.8612912,
                30.0759603
              ],
              [
                51.8682378,
                30.0773496
              ],
              [
                51.8710144,
                30.0776203
              ],
              [
                51.871571,
                30.0778999
              ],
              [
                51.8718476,
                30.0776203
              ],
              [
                51.8815709,
                30.0806786
              ],
              [
                51.8821275,
                30.0806786
              ],
              [
                51.882404,
                30.0809583
              ],
              [
                51.8837942,
                30.0809583
              ],
              [
                51.8907375,
                30.0828979
              ],
              [
                51.8918508,
                30.0828979
              ],
              [
                51.8937939,
                30.0834572
              ],
              [
                51.8946274,
                30.0834572
              ],
              [
                51.8951841,
                30.0837369
              ],
              [
                51.9029606,
                30.0837369
              ],
              [
                51.9032406,
                30.0834572
              ],
              [
                51.9046272,
                30.0834572
              ],
              [
                51.9087938,
                30.0820679
              ],
              [
                51.9101837,
                30.0815085
              ],
              [
                51.9221304,
                30.0748417
              ],
              [
                51.9279636,
                30.0692844
              ],
              [
                51.9296302,
                30.0681748
              ],
              [
                51.9462967,
                30.0492931
              ],
              [
                51.9474067,
                30.0487337
              ],
              [
                51.9504632,
                30.0456845
              ],
              [
                51.9514497,
                30.0442532
              ],
              [
                51.9661335,
                30.0327245
              ],
              [
                51.983343,
                30.0290876
              ],
              [
                51.9977826,
                30.0285428
              ],
              [
                52.0354134,
                30.0393664
              ],
              [
                52.0369818,
                30.0357413
              ],
              [
                52.0404632,
                30.0276939
              ],
              [
                52.0505875,
                30.0042829
              ],
              [
                52.0244927,
                30.0022887
              ],
              [
                52.023799,
                29.9998481
              ],
              [
                52.0137989,
                29.9923427
              ],
              [
                52.0135224,
                29.9906738
              ],
              [
                52.013799,
                29.9901235
              ],
              [
                52.0157456,
                29.9851169
              ],
              [
                52.0174123,
                29.984287
              ],
              [
                52.0240788,
                29.9826182
              ],
              [
                52.0276888,
                29.9826181
              ],
              [
                52.0293555,
                29.9820678
              ],
              [
                52.0307456,
                29.9820679
              ],
              [
                52.0332454,
                29.9815086
              ],
              [
                52.0351888,
                29.9815086
              ],
              [
                52.0363021,
                29.9812289
              ],
              [
                52.0374121,
                29.9812289
              ],
              [
                52.0376887,
                29.9815085
              ],
              [
                52.038522,
                29.9815085
              ],
              [
                52.038802,
                29.9812289
              ],
              [
                52.0399119,
                29.9812289
              ],
              [
                52.0410219,
                29.9806786
              ],
              [
                52.0418553,
                29.9806787
              ],
              [
                52.0813014,
                29.9545635
              ],
              [
                52.0815814,
                29.9542929
              ],
              [
                52.1265808,
                29.9262299
              ],
              [
                52.1294968,
                29.9234113
              ],
              [
                52.1413039,
                29.9373432
              ],
              [
                52.148527,
                29.9415107
              ],
              [
                52.1488071,
                29.94207
              ],
              [
                52.1510271,
                29.9423406
              ],
              [
                52.1521405,
                29.9428999
              ],
              [
                52.1532503,
                29.9428999
              ],
              [
                52.1543603,
                29.9434501
              ],
              [
                52.154917,
                29.9434501
              ],
              [
                52.1551936,
                29.9437298
              ],
              [
                52.156307,
                29.9437298
              ],
              [
                52.1565836,
                29.9440094
              ],
              [
                52.1576936,
                29.9440094
              ],
              [
                52.1638068,
                29.9456782
              ],
              [
                52.1649168,
                29.9456782
              ],
              [
                52.1654734,
                29.9459578
              ],
              [
                52.16825,
                29.9459579
              ],
              [
                52.1688069,
                29.9462285
              ],
              [
                52.1715833,
                29.9459579
              ],
              [
                52.1913065,
                29.9373432
              ],
              [
                52.1926964,
                29.9359541
              ],
              [
                52.1946398,
                29.9342852
              ],
              [
                52.2004729,
                29.9298381
              ],
              [
                52.2032531,
                29.9281784
              ],
              [
                52.2126961,
                29.9256797
              ],
              [
                52.2135294,
                29.9256797
              ],
              [
                52.214643,
                29.9251204
              ],
              [
                52.2243661,
                29.923172
              ],
              [
                52.2260327,
                29.923172
              ],
              [
                52.2332524,
                29.9217829
              ],
              [
                52.2379758,
                29.9217828
              ],
              [
                52.2385324,
                29.9215123
              ],
              [
                52.2393658,
                29.9217828
              ],
              [
                52.2482557,
                29.9215122
              ],
              [
                52.249089,
                29.9212326
              ],
              [
                52.2499223,
                29.9215122
              ],
              [
                52.2507556,
                29.9212326
              ],
              [
                52.255199,
                29.9212326
              ],
              [
                52.2557556,
                29.920953
              ],
              [
                52.2563089,
                29.9212326
              ],
              [
                52.2568656,
                29.9212326
              ],
              [
                52.2568656,
                29.9209529
              ],
              [
                52.2579755,
                29.920953
              ],
              [
                52.2596421,
                29.9209529
              ],
              [
                52.2607554,
                29.9212326
              ],
              [
                52.2635321,
                29.9212326
              ],
              [
                52.268532,
                29.9217829
              ],
              [
                52.268812,
                29.9220625
              ],
              [
                52.2771452,
                29.9220625
              ],
              [
                52.2782553,
                29.9223421
              ],
              [
                52.2813119,
                29.9223422
              ],
              [
                52.3046447,
                29.9245612
              ],
              [
                52.3049248,
                29.9248408
              ],
              [
                52.3057583,
                29.9248408
              ],
              [
                52.3140914,
                29.9281784
              ],
              [
                52.3152013,
                29.9290083
              ],
              [
                52.3160345,
                29.9290083
              ],
              [
                52.316868,
                29.9295676
              ],
              [
                52.3182578,
                29.9298382
              ],
              [
                52.3204813,
                29.9281784
              ],
              [
                52.3213146,
                29.9276191
              ],
              [
                52.3213146,
                29.9281784
              ],
              [
                52.3210345,
                29.928449
              ],
              [
                52.3210345,
                29.9287287
              ],
              [
                52.3204814,
                29.9295676
              ],
              [
                52.3013114,
                29.9473471
              ],
              [
                52.3004783,
                29.9476178
              ],
              [
                52.2996448,
                29.9484567
              ],
              [
                52.2968682,
                29.9498458
              ],
              [
                52.2963115,
                29.9503961
              ],
              [
                52.2863117,
                29.9542931
              ],
              [
                52.2857551,
                29.954293
              ],
              [
                52.2852018,
                29.9548433
              ],
              [
                52.2821451,
                29.9556732
              ],
              [
                52.2779786,
                29.9576217
              ],
              [
                52.277422,
                29.9579013
              ],
              [
                52.2685319,
                29.9628988
              ],
              [
                52.2293659,
                29.9945619
              ],
              [
                52.226866,
                29.999289
              ],
              [
                52.2224194,
                30.008734
              ],
              [
                52.2029729,
                30.0290135
              ],
              [
                52.1765833,
                30.0592889
              ],
              [
                52.1757499,
                30.0603985
              ],
              [
                52.1729733,
                30.0634568
              ],
              [
                52.1676968,
                30.069014
              ],
              [
                52.1654733,
                30.0740119
              ],
              [
                52.1668634,
                30.083737
              ],
              [
                52.2082528,
                30.1220703
              ],
              [
                52.2138093,
                30.1253993
              ],
              [
                52.2146427,
                30.1262383
              ],
              [
                52.2151958,
                30.126509
              ],
              [
                52.215476,
                30.1267887
              ],
              [
                52.2163094,
                30.1267887
              ],
              [
                52.2210292,
                30.1301268
              ],
              [
                52.2213093,
                30.1304065
              ],
              [
                52.228809,
                30.1365143
              ],
              [
                52.229919,
                30.1370646
              ],
              [
                52.2338091,
                30.1412327
              ],
              [
                52.2363089,
                30.1465106
              ],
              [
                52.2368656,
                30.1548469
              ],
              [
                52.2363089,
                30.156516
              ],
              [
                52.2307524,
                30.1731797
              ],
              [
                52.2196426,
                30.1929022
              ],
              [
                52.2194323,
                30.1935321
              ],
              [
                52.2165859,
                30.1945713
              ],
              [
                52.2160293,
                30.194851
              ],
              [
                52.2132526,
                30.1954014
              ],
              [
                52.212696,
                30.195681
              ],
              [
                52.2110294,
                30.195681
              ],
              [
                52.2063094,
                30.1976299
              ],
              [
                52.2054762,
                30.1976298
              ],
              [
                52.1838063,
                30.2070672
              ],
              [
                52.1796397,
                30.208186
              ],
              [
                52.1671398,
                30.2140144
              ],
              [
                52.1613067,
                30.2184624
              ],
              [
                52.1607501,
                30.2187421
              ],
              [
                52.1585266,
                30.2204023
              ],
              [
                52.1535266,
                30.2231812
              ],
              [
                52.1501934,
                30.2254007
              ],
              [
                52.1440835,
                30.2303991
              ],
              [
                52.1432503,
                30.2306789
              ],
              [
                52.1424169,
                30.2317886
              ],
              [
                52.141027,
                30.2326277
              ],
              [
                52.1218607,
                30.2540202
              ],
              [
                52.1179706,
                30.2598488
              ],
              [
                52.1171373,
                30.2606879
              ],
              [
                52.1088041,
                30.2917984
              ],
              [
                52.1085241,
                30.2948481
              ],
              [
                52.1096373,
                30.3059643
              ],
              [
                52.110194,
                30.3073539
              ],
              [
                52.1104708,
                30.3084637
              ],
              [
                52.1107473,
                30.3087435
              ],
              [
                52.1254704,
                30.3192913
              ],
              [
                52.1282504,
                30.3212403
              ],
              [
                52.1357503,
                30.3290181
              ],
              [
                52.1407502,
                30.348463
              ],
              [
                52.1410269,
                30.3623498
              ],
              [
                52.1407501,
                30.3629092
              ],
              [
                52.1404701,
                30.3654087
              ],
              [
                52.1382503,
                30.3787451
              ],
              [
                52.1363035,
                30.3845742
              ],
              [
                52.1357503,
                30.3851247
              ],
              [
                52.1351936,
                30.386794
              ],
              [
                52.1238037,
                30.4031896
              ],
              [
                52.1238038,
                30.4034603
              ],
              [
                52.1235271,
                30.4037401
              ],
              [
                52.1221371,
                30.4045701
              ],
              [
                52.122137,
                30.4048499
              ],
              [
                52.1215804,
                30.4048499
              ],
              [
                52.1213036,
                30.4051296
              ],
              [
                52.1210271,
                30.4054093
              ],
              [
                52.1182471,
                30.406799
              ],
              [
                52.0563012,
                30.4601288
              ],
              [
                52.0546346,
                30.4612388
              ],
              [
                52.0524114,
                30.4634677
              ],
              [
                52.0507447,
                30.4645776
              ],
              [
                52.0404681,
                30.4748558
              ],
              [
                52.0401882,
                30.4751355
              ],
              [
                52.0401883,
                30.4754153
              ],
              [
                52.0399115,
                30.475686
              ],
              [
                52.0396349,
                30.4762455
              ],
              [
                52.0312981,
                30.4876337
              ],
              [
                52.030465,
                30.4884639
              ],
              [
                52.0228307,
                30.4962651
              ],
              [
                52.0304013,
                30.5060342
              ],
              [
                52.0390251,
                30.5171591
              ],
              [
                52.0455959,
                30.5256335
              ],
              [
                52.0482063,
                30.5289995
              ],
              [
                52.0427253,
                30.5353365
              ],
              [
                52.034997,
                30.5364243
              ],
              [
                52.0255771,
                30.5347557
              ],
              [
                52.0146581,
                30.5376094
              ],
              [
                52.0034347,
                30.5383349
              ],
              [
                51.9866942,
                30.5427932
              ],
              [
                51.9737957,
                30.5545748
              ],
              [
                51.9724091,
                30.5554141
              ],
              [
                51.9718523,
                30.5562443
              ],
              [
                51.9712957,
                30.5565241
              ],
              [
                51.9691129,
                30.5585215
              ],
              [
                51.9679624,
                30.5595743
              ],
              [
                51.9585193,
                30.5668028
              ],
              [
                51.9574059,
                30.5679128
              ],
              [
                51.9554625,
                30.569853
              ],
              [
                51.9532392,
                30.5718024
              ],
              [
                51.9476861,
                30.5748616
              ],
              [
                51.9337963,
                30.5784624
              ],
              [
                51.9332397,
                30.5787422
              ],
              [
                51.9287964,
                30.5787421
              ],
              [
                51.9210164,
                30.5781917
              ],
              [
                51.9196265,
                30.5779119
              ],
              [
                51.9160165,
                30.5779118
              ],
              [
                51.9151833,
                30.5776321
              ],
              [
                51.9143499,
                30.5776321
              ],
              [
                51.9140732,
                30.5773523
              ],
              [
                51.9124066,
                30.5773523
              ],
              [
                51.91074,
                30.5779119
              ],
              [
                51.8907369,
                30.590131
              ],
              [
                51.8899036,
                30.5904108
              ],
              [
                51.8899035,
                30.5906905
              ],
              [
                51.8879603,
                30.5906905
              ],
              [
                51.8876835,
                30.590131
              ],
              [
                51.8846271,
                30.5843012
              ],
              [
                51.8779605,
                30.5754121
              ],
              [
                51.8557375,
                30.5540243
              ],
              [
                51.8482375,
                30.5412459
              ],
              [
                51.8454576,
                30.5379069
              ],
              [
                51.8440675,
                30.5354161
              ],
              [
                51.8343479,
                30.5212481
              ],
              [
                51.8343478,
                30.5209685
              ],
              [
                51.8343478,
                30.5206887
              ],
              [
                51.8340678,
                30.5201382
              ],
              [
                51.8335144,
                30.519299
              ],
              [
                51.8335144,
                30.5184598
              ],
              [
                51.8329578,
                30.5173588
              ],
              [
                51.8318478,
                30.5120796
              ],
              [
                51.8312912,
                30.5054108
              ],
              [
                51.8315677,
                30.5012417
              ],
              [
                51.8318478,
                30.4984623
              ],
              [
                51.8321243,
                30.4968019
              ],
              [
                51.8324011,
                30.4948527
              ],
              [
                51.8326812,
                30.4937428
              ],
              [
                51.8335145,
                30.4912432
              ],
              [
                51.8335145,
                30.4901332
              ],
              [
                51.8390677,
                30.4773553
              ],
              [
                51.8396244,
                30.4770755
              ],
              [
                51.8399009,
                30.4762453
              ],
              [
                51.8410144,
                30.4751354
              ],
              [
                51.8410145,
                30.4745759
              ],
              [
                51.8415677,
                30.4740164
              ],
              [
                51.8432344,
                30.4695767
              ],
              [
                51.8429576,
                30.4656874
              ],
              [
                51.8418477,
                30.4626283
              ],
              [
                51.8374012,
                30.4537399
              ],
              [
                51.8315678,
                30.4456817
              ],
              [
                51.8312912,
                30.4445717
              ],
              [
                51.8262914,
                30.4368023
              ],
              [
                51.8262914,
                30.4365226
              ],
              [
                51.8257346,
                30.435963
              ],
              [
                51.8249013,
                30.4354036
              ],
              [
                51.7968452,
                30.4109586
              ],
              [
                51.7815653,
                30.3990205
              ],
              [
                51.7757918,
                30.3949112
              ],
              [
                51.7737579,
                30.3904977
              ],
              [
                51.7726422,
                30.387072
              ],
              [
                51.772579,
                30.385835
              ],
              [
                51.7724275,
                30.3828716
              ],
              [
                51.7752812,
                30.3793719
              ],
              [
                51.7843151,
                30.3769109
              ],
              [
                51.7854308,
                30.3746525
              ],
              [
                51.7829418,
                30.3715793
              ],
              [
                51.7721037,
                30.3664878
              ],
              [
                51.7669772,
                30.3649515
              ],
              [
                51.7618273,
                30.362878
              ],
              [
                51.7508455,
                30.3608145
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555113,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شیراز",
          "name:ar": "مقاطعة شيراز",
          "name:en": "Shiraz County",
          "name:sk": "Širáz",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2422280",
          "wikipedia": "en:Shiraz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8051789,
                29.8423417
              ],
              [
                51.8065689,
                29.8417825
              ],
              [
                51.8146254,
                29.8376153
              ],
              [
                51.8324019,
                29.8226154
              ],
              [
                51.832682,
                29.8217855
              ],
              [
                51.8340685,
                29.8198373
              ],
              [
                51.8418484,
                29.8067858
              ],
              [
                51.8440684,
                29.804558
              ],
              [
                51.8446249,
                29.803178
              ],
              [
                51.8454584,
                29.8006795
              ],
              [
                51.8457384,
                29.7990019
              ],
              [
                51.846015,
                29.796783
              ],
              [
                51.8462916,
                29.7934458
              ],
              [
                51.8465717,
                29.7923364
              ],
              [
                51.8460151,
                29.7867804
              ],
              [
                51.8454584,
                29.7701125
              ],
              [
                51.8457386,
                29.7670549
              ],
              [
                51.8460151,
                29.7651158
              ],
              [
                51.8487917,
                29.752615
              ],
              [
                51.8518484,
                29.7456703
              ],
              [
                51.8529582,
                29.7431719
              ],
              [
                51.8612915,
                29.7281732
              ],
              [
                51.8629582,
                29.726225
              ],
              [
                51.8637949,
                29.7245564
              ],
              [
                51.8713822,
                29.7132325
              ],
              [
                51.8718164,
                29.7125845
              ],
              [
                51.8742874,
                29.7088962
              ],
              [
                51.8829613,
                29.6959484
              ],
              [
                51.884628,
                29.6940003
              ],
              [
                51.9276839,
                29.6520637
              ],
              [
                51.9299074,
                29.6503952
              ],
              [
                51.9357404,
                29.6431715
              ],
              [
                51.9390738,
                29.6362273
              ],
              [
                51.9393538,
                29.6351181
              ],
              [
                51.9396306,
                29.6309516
              ],
              [
                51.9393539,
                29.6303925
              ],
              [
                51.9396305,
                29.6301129
              ],
              [
                51.9376838,
                29.6253873
              ],
              [
                51.9357404,
                29.6209502
              ],
              [
                51.9349073,
                29.6170544
              ],
              [
                51.9343506,
                29.6153951
              ],
              [
                51.9343506,
                29.6151155
              ],
              [
                51.9318506,
                29.6095602
              ],
              [
                51.931574,
                29.6076123
              ],
              [
                51.931574,
                29.6073328
              ],
              [
                51.9312973,
                29.6070623
              ],
              [
                51.9310172,
                29.6056645
              ],
              [
                51.930464,
                29.6040051
              ],
              [
                51.9287974,
                29.5931654
              ],
              [
                51.9285174,
                29.5898377
              ],
              [
                51.9187552,
                29.5952525
              ],
              [
                51.921831,
                29.5878866
              ],
              [
                51.925603,
                29.5790705
              ],
              [
                51.9286608,
                29.5689994
              ],
              [
                51.9311794,
                29.5632863
              ],
              [
                51.93845,
                29.5493154
              ],
              [
                51.9523578,
                29.538285
              ],
              [
                51.9598719,
                29.5337043
              ],
              [
                51.9657262,
                29.5305178
              ],
              [
                51.9732722,
                29.5265333
              ],
              [
                51.9827244,
                29.5211782
              ],
              [
                52.0001306,
                29.5120664
              ],
              [
                52.0211767,
                29.5044535
              ],
              [
                52.0262792,
                29.5026881
              ],
              [
                52.0268404,
                29.5016473
              ],
              [
                52.0359278,
                29.4995089
              ],
              [
                52.0396184,
                29.4986125
              ],
              [
                52.0427248,
                29.491091
              ],
              [
                52.0490033,
                29.4778968
              ],
              [
                52.0593165,
                29.4613469
              ],
              [
                52.0694944,
                29.4463714
              ],
              [
                52.0774594,
                29.4356756
              ],
              [
                52.0834618,
                29.4263632
              ],
              [
                52.0861158,
                29.422543
              ],
              [
                52.090963,
                29.4134796
              ],
              [
                52.093525,
                29.4070486
              ],
              [
                52.0940818,
                29.4037215
              ],
              [
                52.0943584,
                29.4012239
              ],
              [
                52.0946385,
                29.3995559
              ],
              [
                52.0954717,
                29.3937223
              ],
              [
                52.0957484,
                29.3903862
              ],
              [
                52.096025,
                29.3889976
              ],
              [
                52.0957484,
                29.3853912
              ],
              [
                52.0929719,
                29.3662225
              ],
              [
                52.0917631,
                29.3587976
              ],
              [
                52.0903718,
                29.3513319
              ],
              [
                52.0896344,
                29.3476737
              ],
              [
                52.0889672,
                29.3433972
              ],
              [
                52.0881724,
                29.3385253
              ],
              [
                52.0869706,
                29.3287677
              ],
              [
                52.0879385,
                29.3105412
              ],
              [
                52.0882928,
                29.3026092
              ],
              [
                52.0895362,
                29.2984315
              ],
              [
                52.0960592,
                29.2869725
              ],
              [
                52.1157112,
                29.2593578
              ],
              [
                52.1248661,
                29.239187
              ],
              [
                52.1316719,
                29.2240962
              ],
              [
                52.1397845,
                29.2098992
              ],
              [
                52.1427574,
                29.2019737
              ],
              [
                52.1444076,
                29.2019363
              ],
              [
                52.1486957,
                29.2023498
              ],
              [
                52.1547889,
                29.2032863
              ],
              [
                52.160474,
                29.2042213
              ],
              [
                52.1635974,
                29.2046522
              ],
              [
                52.1687652,
                29.2057931
              ],
              [
                52.1724994,
                29.2075154
              ],
              [
                52.1752739,
                29.208917
              ],
              [
                52.178663,
                29.210751
              ],
              [
                52.181493,
                29.2125445
              ],
              [
                52.1828401,
                29.2134443
              ],
              [
                52.1854019,
                29.2218115
              ],
              [
                52.1950057,
                29.2300675
              ],
              [
                52.2085193,
                29.2303268
              ],
              [
                52.2147131,
                29.2336463
              ],
              [
                52.222402,
                29.2365425
              ],
              [
                52.2299187,
                29.2384496
              ],
              [
                52.2361213,
                29.2399647
              ],
              [
                52.2416587,
                29.2408461
              ],
              [
                52.2443222,
                29.2413157
              ],
              [
                52.2495571,
                29.2414868
              ],
              [
                52.2552829,
                29.2417864
              ],
              [
                52.2600177,
                29.241841
              ],
              [
                52.2751788,
                29.2365694
              ],
              [
                52.28346,
                29.2324918
              ],
              [
                52.2992792,
                29.2205396
              ],
              [
                52.3093809,
                29.2120568
              ],
              [
                52.3183123,
                29.2040319
              ],
              [
                52.3247438,
                29.1996519
              ],
              [
                52.3292148,
                29.19738
              ],
              [
                52.3307091,
                29.1965897
              ],
              [
                52.3408728,
                29.196009
              ],
              [
                52.3510211,
                29.1949052
              ],
              [
                52.3575045,
                29.1934594
              ],
              [
                52.371312,
                29.1922793
              ],
              [
                52.381878,
                29.1925092
              ],
              [
                52.3885196,
                29.1928313
              ],
              [
                52.4044431,
                29.1940604
              ],
              [
                52.4105786,
                29.1961525
              ],
              [
                52.416093,
                29.1969051
              ],
              [
                52.4247837,
                29.2075032
              ],
              [
                52.4331234,
                29.2191055
              ],
              [
                52.4375997,
                29.2282031
              ],
              [
                52.4423165,
                29.2380002
              ],
              [
                52.4448583,
                29.2469671
              ],
              [
                52.4490739,
                29.2591525
              ],
              [
                52.4515403,
                29.2632967
              ],
              [
                52.4538673,
                29.2672579
              ],
              [
                52.4573327,
                29.2744546
              ],
              [
                52.4598408,
                29.2786704
              ],
              [
                52.4675494,
                29.2939312
              ],
              [
                52.4717851,
                29.2989018
              ],
              [
                52.4819767,
                29.3200998
              ],
              [
                52.4884543,
                29.3309111
              ],
              [
                52.492036,
                29.3384417
              ],
              [
                52.4941438,
                29.347967
              ],
              [
                52.4963856,
                29.3531529
              ],
              [
                52.498598,
                29.3619799
              ],
              [
                52.4979972,
                29.3672161
              ],
              [
                52.4976539,
                29.3722276
              ],
              [
                52.4967097,
                29.378286
              ],
              [
                52.4956798,
                29.3848676
              ],
              [
                52.4957656,
                29.3902521
              ],
              [
                52.4956798,
                29.3955617
              ],
              [
                52.4959695,
                29.4015812
              ],
              [
                52.4964523,
                29.4049835
              ],
              [
                52.4967704,
                29.4072128
              ],
              [
                52.4984089,
                29.4066823
              ],
              [
                52.5073586,
                29.4011013
              ],
              [
                52.5144316,
                29.3981508
              ],
              [
                52.5182533,
                29.3952812
              ],
              [
                52.5284569,
                29.3883001
              ],
              [
                52.5336345,
                29.3836548
              ],
              [
                52.5367107,
                29.3820735
              ],
              [
                52.5435309,
                29.3785108
              ],
              [
                52.5488967,
                29.3763192
              ],
              [
                52.554855,
                29.3747879
              ],
              [
                52.5623791,
                29.3719264
              ],
              [
                52.5743007,
                29.3652712
              ],
              [
                52.5872611,
                29.3594365
              ],
              [
                52.6043655,
                29.3546051
              ],
              [
                52.6138235,
                29.3530825
              ],
              [
                52.6224535,
                29.3530729
              ],
              [
                52.6343281,
                29.3531852
              ],
              [
                52.6444097,
                29.3548597
              ],
              [
                52.6466289,
                29.355043
              ],
              [
                52.6505329,
                29.3554855
              ],
              [
                52.6515688,
                29.3555313
              ],
              [
                52.6531661,
                29.3560831
              ],
              [
                52.6569979,
                29.3574286
              ],
              [
                52.6599963,
                29.3584441
              ],
              [
                52.6630985,
                29.3597158
              ],
              [
                52.6677966,
                29.3621141
              ],
              [
                52.6756681,
                29.3642086
              ],
              [
                52.6784565,
                29.3654605
              ],
              [
                52.6925697,
                29.3715194
              ],
              [
                52.6967112,
                29.3742815
              ],
              [
                52.7095678,
                29.3807096
              ],
              [
                52.7164944,
                29.3847419
              ],
              [
                52.7240225,
                29.3879362
              ],
              [
                52.7331623,
                29.3951846
              ],
              [
                52.7367195,
                29.3976955
              ],
              [
                52.7435899,
                29.4049449
              ],
              [
                52.7407753,
                29.4062195
              ],
              [
                52.7454987,
                29.4153893
              ],
              [
                52.7460553,
                29.4156598
              ],
              [
                52.747442,
                29.418446
              ],
              [
                52.7613317,
                29.4342793
              ],
              [
                52.7641117,
                29.4364975
              ],
              [
                52.7654983,
                29.4378861
              ],
              [
                52.7666117,
                29.438445
              ],
              [
                52.7668884,
                29.439004
              ],
              [
                52.7685548,
                29.4398336
              ],
              [
                52.7686397,
                29.4400051
              ],
              [
                52.7688316,
                29.4403927
              ],
              [
                52.7732782,
                29.4428903
              ],
              [
                52.8124476,
                29.4495538
              ],
              [
                52.8135553,
                29.4498333
              ],
              [
                52.8141143,
                29.4498333
              ],
              [
                52.8149477,
                29.4501128
              ],
              [
                52.8166143,
                29.4498333
              ],
              [
                52.8177243,
                29.4498333
              ],
              [
                52.8185576,
                29.4495538
              ],
              [
                52.8199475,
                29.4495538
              ],
              [
                52.8280041,
                29.4473357
              ],
              [
                52.8288374,
                29.4467766
              ],
              [
                52.8296708,
                29.4467766
              ],
              [
                52.8449471,
                29.4403927
              ],
              [
                52.8466138,
                29.4395542
              ],
              [
                52.8705035,
                29.4237208
              ],
              [
                52.8705466,
                29.423702
              ],
              [
                52.8877265,
                29.416219
              ],
              [
                52.8885598,
                29.4162189
              ],
              [
                52.8891165,
                29.4159394
              ],
              [
                52.8910598,
                29.4159394
              ],
              [
                52.8916165,
                29.4156599
              ],
              [
                52.8938397,
                29.4156599
              ],
              [
                52.8941165,
                29.4159394
              ],
              [
                52.8949498,
                29.4159394
              ],
              [
                52.8960598,
                29.4162189
              ],
              [
                52.8985597,
                29.4162189
              ],
              [
                52.8988397,
                29.4164985
              ],
              [
                52.9071729,
                29.4164985
              ],
              [
                52.9143962,
                29.417328
              ],
              [
                52.9152295,
                29.4176075
              ],
              [
                52.9163394,
                29.4176075
              ],
              [
                52.9171727,
                29.417887
              ],
              [
                52.9193961,
                29.417887
              ],
              [
                52.9202295,
                29.4181665
              ],
              [
                52.9238393,
                29.4181666
              ],
              [
                52.9246727,
                29.4184461
              ],
              [
                52.9260627,
                29.4184461
              ],
              [
                52.9293959,
                29.4192756
              ],
              [
                52.9313392,
                29.4192755
              ],
              [
                52.9496757,
                29.4223322
              ],
              [
                52.9510622,
                29.4223322
              ],
              [
                52.9596754,
                29.4242708
              ],
              [
                52.9607854,
                29.4242708
              ],
              [
                52.9613421,
                29.4245594
              ],
              [
                52.9630087,
                29.4245594
              ],
              [
                52.9635655,
                29.4248298
              ],
              [
                52.9643989,
                29.4248299
              ],
              [
                52.9657853,
                29.4248298
              ],
              [
                52.9663421,
                29.4251094
              ],
              [
                52.9682853,
                29.4264979
              ],
              [
                52.9693987,
                29.4281661
              ],
              [
                52.9705087,
                29.4312228
              ],
              [
                52.9710653,
                29.4320522
              ],
              [
                52.9732853,
                29.4390042
              ],
              [
                52.973842,
                29.4395542
              ],
              [
                52.9752319,
                29.4456676
              ],
              [
                52.9824551,
                29.4673353
              ],
              [
                52.9891217,
                29.4756671
              ],
              [
                52.989675,
                29.4762261
              ],
              [
                52.9905083,
                29.4762261
              ],
              [
                52.9907883,
                29.4764967
              ],
              [
                52.9927315,
                29.4764966
              ],
              [
                52.9930083,
                29.4767761
              ],
              [
                52.994675,
                29.4767762
              ],
              [
                52.9977315,
                29.4776148
              ],
              [
                52.9988449,
                29.4776148
              ],
              [
                53.0030115,
                29.4790034
              ],
              [
                53.0041215,
                29.4790033
              ],
              [
                53.007178,
                29.4798329
              ],
              [
                53.0085647,
                29.479833
              ],
              [
                53.0099546,
                29.480392
              ],
              [
                53.0110646,
                29.4803921
              ],
              [
                53.0127313,
                29.4809421
              ],
              [
                53.0135646,
                29.4815011
              ],
              [
                53.0143979,
                29.4815012
              ],
              [
                53.0227346,
                29.485108
              ],
              [
                53.0413442,
                29.4915012
              ],
              [
                53.0441242,
                29.4920513
              ],
              [
                53.0444009,
                29.4923309
              ],
              [
                53.0452342,
                29.4923308
              ],
              [
                53.0455107,
                29.4926104
              ],
              [
                53.0466241,
                29.4926104
              ],
              [
                53.0496774,
                29.49344
              ],
              [
                53.0694797,
                29.4999185
              ],
              [
                53.07522,
                29.504292
              ],
              [
                53.0745782,
                29.5107888
              ],
              [
                53.0511736,
                29.5211671
              ],
              [
                53.0499882,
                29.5383551
              ],
              [
                53.0292441,
                29.5620627
              ],
              [
                53.049124,
                29.5665001
              ],
              [
                53.0480107,
                29.5676092
              ],
              [
                53.0471774,
                29.5678888
              ],
              [
                53.0469008,
                29.5684479
              ],
              [
                53.0463441,
                29.5687275
              ],
              [
                53.0207878,
                29.5814967
              ],
              [
                53.0202345,
                29.5814967
              ],
              [
                53.0171779,
                29.5826149
              ],
              [
                52.9496755,
                29.617055
              ],
              [
                52.9383051,
                29.6196204
              ],
              [
                52.9074494,
                29.6312227
              ],
              [
                52.9041161,
                29.6320614
              ],
              [
                52.8857831,
                29.63483
              ],
              [
                52.8838399,
                29.6353892
              ],
              [
                52.8830065,
                29.6353891
              ],
              [
                52.8827265,
                29.6356687
              ],
              [
                52.8816166,
                29.6356687
              ],
              [
                52.8466137,
                29.6481683
              ],
              [
                52.824114,
                29.6562218
              ],
              [
                52.8202241,
                29.6573401
              ],
              [
                52.8127241,
                29.6595586
              ],
              [
                52.7880012,
                29.6620567
              ],
              [
                52.779388,
                29.6609474
              ],
              [
                52.7777213,
                29.6609474
              ],
              [
                52.7682782,
                29.6587288
              ],
              [
                52.7660549,
                29.6587289
              ],
              [
                52.7649449,
                29.6584493
              ],
              [
                52.7560551,
                29.6584493
              ],
              [
                52.7552218,
                29.6587289
              ],
              [
                52.7532784,
                29.6587289
              ],
              [
                52.7527218,
                29.6590084
              ],
              [
                52.751055,
                29.6590084
              ],
              [
                52.7229989,
                29.6667824
              ],
              [
                52.7218855,
                29.667062
              ],
              [
                52.7207755,
                29.6673415
              ],
              [
                52.7188324,
                29.6673416
              ],
              [
                52.7149423,
                29.6681713
              ],
              [
                52.7143856,
                29.6681712
              ],
              [
                52.7110524,
                29.669001
              ],
              [
                52.6777195,
                29.6745565
              ],
              [
                52.6766061,
                29.6742859
              ],
              [
                52.6749396,
                29.674286
              ],
              [
                52.6718829,
                29.6737267
              ],
              [
                52.669663,
                29.6737267
              ],
              [
                52.6649397,
                29.672888
              ],
              [
                52.6627163,
                29.672888
              ],
              [
                52.6518833,
                29.6715082
              ],
              [
                52.6516066,
                29.6712286
              ],
              [
                52.6460499,
                29.6712286
              ],
              [
                52.6416067,
                29.6717787
              ],
              [
                52.63994,
                29.6723379
              ],
              [
                52.6388268,
                29.6723379
              ],
              [
                52.627717,
                29.6762249
              ],
              [
                52.6274209,
                29.6765204
              ],
              [
                52.6263269,
                29.6781729
              ],
              [
                52.6191036,
                29.7048415
              ],
              [
                52.6171604,
                29.7106767
              ],
              [
                52.616047,
                29.7148345
              ],
              [
                52.6081586,
                29.7315687
              ],
              [
                52.6060346,
                29.7342992
              ],
              [
                52.596324,
                29.7567825
              ],
              [
                52.5699343,
                29.8009506
              ],
              [
                52.5671577,
                29.8037287
              ],
              [
                52.565491,
                29.8078957
              ],
              [
                52.5646578,
                29.8106737
              ],
              [
                52.5624345,
                29.8134518
              ],
              [
                52.5624344,
                29.8137315
              ],
              [
                52.5621578,
                29.8162299
              ],
              [
                52.5613244,
                29.8162299
              ],
              [
                52.5606281,
                29.8162299
              ],
              [
                52.5604912,
                29.8162299
              ],
              [
                52.549658,
                29.817619
              ],
              [
                52.5435447,
                29.817619
              ],
              [
                52.5421547,
                29.8173393
              ],
              [
                52.5339133,
                29.8173393
              ],
              [
                52.5338215,
                29.8173393
              ],
              [
                52.5329882,
                29.8176189
              ],
              [
                52.5313216,
                29.8176189
              ],
              [
                52.5275923,
                29.8184238
              ],
              [
                52.527435,
                29.8184578
              ],
              [
                52.5238216,
                29.8187283
              ],
              [
                52.5235662,
                29.818805
              ],
              [
                52.5154078,
                29.8212533
              ],
              [
                52.5043753,
                29.8245641
              ],
              [
                52.5040986,
                29.8251144
              ],
              [
                52.5039671,
                29.8251582
              ],
              [
                52.499932,
                29.8265034
              ],
              [
                52.4996241,
                29.8266538
              ],
              [
                52.4885422,
                29.8320686
              ],
              [
                52.4865989,
                29.8326188
              ],
              [
                52.4849323,
                29.8334486
              ],
              [
                52.4840989,
                29.8334486
              ],
              [
                52.480634,
                29.8346787
              ],
              [
                52.4754857,
                29.8365064
              ],
              [
                52.4746826,
                29.8369219
              ],
              [
                52.4627008,
                29.8431203
              ],
              [
                52.450302,
                29.8495341
              ],
              [
                52.4432628,
                29.8531752
              ],
              [
                52.4413195,
                29.8545642
              ],
              [
                52.4410396,
                29.8548438
              ],
              [
                52.4402063,
                29.8551234
              ],
              [
                52.4396529,
                29.8556737
              ],
              [
                52.4331864,
                29.8584767
              ],
              [
                52.3880881,
                29.8780227
              ],
              [
                52.3813171,
                29.880957
              ],
              [
                52.3796504,
                29.8820664
              ],
              [
                52.3618707,
                29.8953983
              ],
              [
                52.3507575,
                29.9051222
              ],
              [
                52.3504808,
                29.9054019
              ],
              [
                52.349924,
                29.9062317
              ],
              [
                52.3499241,
                29.9065113
              ],
              [
                52.3496475,
                29.906782
              ],
              [
                52.3449242,
                29.9123385
              ],
              [
                52.3293679,
                29.9220625
              ],
              [
                52.3279812,
                29.9234516
              ],
              [
                52.3279804,
                29.9234521
              ],
              [
                52.3213146,
                29.9276191
              ],
              [
                52.3204813,
                29.9281784
              ],
              [
                52.3182578,
                29.9298382
              ],
              [
                52.316868,
                29.9295676
              ],
              [
                52.3160345,
                29.9290083
              ],
              [
                52.3152013,
                29.9290083
              ],
              [
                52.3140914,
                29.9281784
              ],
              [
                52.3057583,
                29.9248408
              ],
              [
                52.3049248,
                29.9248408
              ],
              [
                52.3046447,
                29.9245612
              ],
              [
                52.2813119,
                29.9223422
              ],
              [
                52.2782553,
                29.9223421
              ],
              [
                52.2771452,
                29.9220625
              ],
              [
                52.268812,
                29.9220625
              ],
              [
                52.268532,
                29.9217829
              ],
              [
                52.2635321,
                29.9212326
              ],
              [
                52.2607554,
                29.9212326
              ],
              [
                52.2596421,
                29.9209529
              ],
              [
                52.2579755,
                29.920953
              ],
              [
                52.2568656,
                29.9209529
              ],
              [
                52.2568656,
                29.9212326
              ],
              [
                52.2563089,
                29.9212326
              ],
              [
                52.2557556,
                29.920953
              ],
              [
                52.255199,
                29.9212326
              ],
              [
                52.2507556,
                29.9212326
              ],
              [
                52.2499223,
                29.9215122
              ],
              [
                52.249089,
                29.9212326
              ],
              [
                52.2482557,
                29.9215122
              ],
              [
                52.2393658,
                29.9217828
              ],
              [
                52.2385324,
                29.9215123
              ],
              [
                52.2379758,
                29.9217828
              ],
              [
                52.2332524,
                29.9217829
              ],
              [
                52.2260327,
                29.923172
              ],
              [
                52.2243661,
                29.923172
              ],
              [
                52.214643,
                29.9251204
              ],
              [
                52.2135294,
                29.9256797
              ],
              [
                52.2126961,
                29.9256797
              ],
              [
                52.2032531,
                29.9281784
              ],
              [
                52.2004729,
                29.9298381
              ],
              [
                52.1946398,
                29.9342852
              ],
              [
                52.1926964,
                29.9359541
              ],
              [
                52.1913065,
                29.9373432
              ],
              [
                52.1715833,
                29.9459579
              ],
              [
                52.1688069,
                29.9462285
              ],
              [
                52.16825,
                29.9459579
              ],
              [
                52.1654734,
                29.9459578
              ],
              [
                52.1649168,
                29.9456782
              ],
              [
                52.1638068,
                29.9456782
              ],
              [
                52.1576936,
                29.9440094
              ],
              [
                52.1565836,
                29.9440094
              ],
              [
                52.156307,
                29.9437298
              ],
              [
                52.1551936,
                29.9437298
              ],
              [
                52.154917,
                29.9434501
              ],
              [
                52.1543603,
                29.9434501
              ],
              [
                52.1532503,
                29.9428999
              ],
              [
                52.1521405,
                29.9428999
              ],
              [
                52.1510271,
                29.9423406
              ],
              [
                52.1488071,
                29.94207
              ],
              [
                52.148527,
                29.9415107
              ],
              [
                52.1413039,
                29.9373432
              ],
              [
                52.1294968,
                29.9234113
              ],
              [
                52.1274139,
                29.9209529
              ],
              [
                52.1265808,
                29.9181746
              ],
              [
                52.1115812,
                29.8870635
              ],
              [
                52.1104711,
                29.8851241
              ],
              [
                52.1104711,
                29.8848355
              ],
              [
                52.1096377,
                29.8834553
              ],
              [
                52.0991589,
                29.8717048
              ],
              [
                52.0988045,
                29.8712331
              ],
              [
                52.0982478,
                29.8709534
              ],
              [
                52.0885246,
                29.8626188
              ],
              [
                52.0643584,
                29.8506763
              ],
              [
                52.0618586,
                29.8498465
              ],
              [
                52.0499121,
                29.8445608
              ],
              [
                52.0443554,
                29.8412325
              ],
              [
                52.0415787,
                29.8401141
              ],
              [
                52.0363022,
                29.8378951
              ],
              [
                52.0354688,
                29.8378951
              ],
              [
                52.028799,
                29.8359558
              ],
              [
                52.0276889,
                29.8359559
              ],
              [
                52.0260223,
                29.8353966
              ],
              [
                52.0249123,
                29.8353966
              ],
              [
                52.0235223,
                29.8348374
              ],
              [
                52.0168558,
                29.8342871
              ],
              [
                52.0160226,
                29.8345668
              ],
              [
                52.0151891,
                29.8342872
              ],
              [
                52.006576,
                29.8342872
              ],
              [
                52.0060225,
                29.8340075
              ],
              [
                52.0029661,
                29.8340076
              ],
              [
                52.0021327,
                29.8337279
              ],
              [
                52.000022,
                29.8337279
              ],
              [
                51.9996326,
                29.8334483
              ],
              [
                51.9985229,
                29.8334483
              ],
              [
                51.997966,
                29.8334483
              ],
              [
                51.9976894,
                29.8331777
              ],
              [
                51.9971328,
                29.8331777
              ],
              [
                51.9954662,
                29.8331776
              ],
              [
                51.9943529,
                29.8328981
              ],
              [
                51.9929661,
                29.8331777
              ],
              [
                51.9851863,
                29.8337279
              ],
              [
                51.9779665,
                29.8337279
              ],
              [
                51.9768531,
                29.8334482
              ],
              [
                51.9668531,
                29.8334483
              ],
              [
                51.9662965,
                29.8337278
              ],
              [
                51.9649099,
                29.8337279
              ],
              [
                51.9643533,
                29.8340075
              ],
              [
                51.9632433,
                29.8340075
              ],
              [
                51.9618532,
                29.8345668
              ],
              [
                51.9582434,
                29.8351169
              ],
              [
                51.9562967,
                29.8359558
              ],
              [
                51.9468535,
                29.8390045
              ],
              [
                51.9465734,
                29.8392841
              ],
              [
                51.9440734,
                29.8401139
              ],
              [
                51.889071,
                29.8659561
              ],
              [
                51.8857378,
                29.8673452
              ],
              [
                51.8612914,
                29.8745613
              ],
              [
                51.860738,
                29.8751205
              ],
              [
                51.8504582,
                29.8801177
              ],
              [
                51.8496247,
                29.8809566
              ],
              [
                51.8479581,
                29.8817864
              ],
              [
                51.838515,
                29.8898415
              ],
              [
                51.8301818,
                29.8920695
              ],
              [
                51.8276818,
                29.8920694
              ],
              [
                51.8246253,
                29.8915102
              ],
              [
                51.8154587,
                29.8862243
              ],
              [
                51.813512,
                29.8831755
              ],
              [
                51.8074022,
                29.8528951
              ],
              [
                51.8076789,
                29.8526154
              ],
              [
                51.8071256,
                29.851506
              ],
              [
                51.8060121,
                29.8440104
              ],
              [
                51.8054555,
                29.8431716
              ],
              [
                51.8051789,
                29.8423417
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555130,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فراشبند",
          "name:en": "Farashband County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q384610",
          "wikipedia": "en:Farashband County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.8146704,
                29.0238477
              ],
              [
                51.8648306,
                28.9759208
              ],
              [
                51.8768487,
                28.9617639
              ],
              [
                51.887962,
                28.9473169
              ],
              [
                51.8882386,
                28.945929
              ],
              [
                51.8887952,
                28.9450998
              ],
              [
                51.8951852,
                28.9264894
              ],
              [
                51.8951852,
                28.9253719
              ],
              [
                51.8960186,
                28.923155
              ],
              [
                51.8962952,
                28.9225961
              ],
              [
                51.8962952,
                28.9223168
              ],
              [
                51.906575,
                28.8959295
              ],
              [
                51.9235182,
                28.8645415
              ],
              [
                51.9321314,
                28.8520425
              ],
              [
                51.9432412,
                28.8392643
              ],
              [
                51.9443545,
                28.8381469
              ],
              [
                51.9590776,
                28.8234315
              ],
              [
                51.9604644,
                28.8212057
              ],
              [
                51.9709425,
                28.7897765
              ],
              [
                51.9743541,
                28.7795388
              ],
              [
                51.9788007,
                28.7570392
              ],
              [
                51.9807442,
                28.7456499
              ],
              [
                51.9807441,
                28.7445416
              ],
              [
                51.9810206,
                28.7439831
              ],
              [
                51.9926871,
                28.6975896
              ],
              [
                51.9929672,
                28.69704
              ],
              [
                51.9929672,
                28.6920395
              ],
              [
                51.9929672,
                28.6917601
              ],
              [
                51.993244,
                28.6912015
              ],
              [
                51.9932439,
                28.6909312
              ],
              [
                51.993244,
                28.6903727
              ],
              [
                51.9935205,
                28.6889851
              ],
              [
                51.9974104,
                28.6759299
              ],
              [
                51.9990771,
                28.6714792
              ],
              [
                51.9993572,
                28.6698123
              ],
              [
                52.0010239,
                28.6659291
              ],
              [
                52.0010239,
                28.6651003
              ],
              [
                52.0071337,
                28.6464776
              ],
              [
                52.0074105,
                28.6459281
              ],
              [
                52.009357,
                28.6392611
              ],
              [
                52.009357,
                28.6389818
              ],
              [
                52.0096338,
                28.6381439
              ],
              [
                52.0101904,
                28.6370358
              ],
              [
                52.010467,
                28.6362069
              ],
              [
                52.0107438,
                28.6350987
              ],
              [
                52.0113004,
                28.6348195
              ],
              [
                52.0135237,
                28.6309275
              ],
              [
                52.0199137,
                28.6056479
              ],
              [
                52.0201902,
                28.6031524
              ],
              [
                52.0207469,
                28.6014767
              ],
              [
                52.0210236,
                28.5989812
              ],
              [
                52.0354701,
                28.5411999
              ],
              [
                52.0360234,
                28.5312007
              ],
              [
                52.0363035,
                28.5292549
              ],
              [
                52.03658,
                28.528147
              ],
              [
                52.0374134,
                28.5214809
              ],
              [
                52.03797,
                28.5173101
              ],
              [
                52.0438035,
                28.4867553
              ],
              [
                52.04797,
                28.4609215
              ],
              [
                52.0485233,
                28.4575888
              ],
              [
                52.04908,
                28.4539769
              ],
              [
                52.0496366,
                28.4500856
              ],
              [
                52.0501899,
                28.4464737
              ],
              [
                52.0510231,
                28.4417539
              ],
              [
                52.0513032,
                28.4409252
              ],
              [
                52.0540799,
                28.4298104
              ],
              [
                52.0540799,
                28.4295311
              ],
              [
                52.0540799,
                28.4284232
              ],
              [
                52.0558232,
                28.4230686
              ],
              [
                52.0560266,
                28.4225867
              ],
              [
                52.0590798,
                28.4159215
              ],
              [
                52.0808427,
                28.3638461
              ],
              [
                52.0971393,
                28.324812
              ],
              [
                52.1040826,
                28.3106458
              ],
              [
                52.1060258,
                28.3064761
              ],
              [
                52.1113058,
                28.2973083
              ],
              [
                52.1121392,
                28.2950839
              ],
              [
                52.1126959,
                28.2945346
              ],
              [
                52.1229722,
                28.2623041
              ],
              [
                52.1232489,
                28.2598096
              ],
              [
                52.1235291,
                28.258702
              ],
              [
                52.1218625,
                28.2289763
              ],
              [
                52.1215824,
                28.2239696
              ],
              [
                52.1213057,
                28.2203587
              ],
              [
                52.1215824,
                28.2134161
              ],
              [
                52.1218624,
                28.2111919
              ],
              [
                52.1254724,
                28.1995309
              ],
              [
                52.1413055,
                28.1748048
              ],
              [
                52.1413055,
                28.1745258
              ],
              [
                52.1414772,
                28.1741821
              ],
              [
                52.1435287,
                28.1700776
              ],
              [
                52.1582518,
                28.1456406
              ],
              [
                52.1590853,
                28.1448032
              ],
              [
                52.1601953,
                28.1436958
              ],
              [
                52.1707517,
                28.130082
              ],
              [
                52.1790848,
                28.1234193
              ],
              [
                52.199088,
                28.1114715
              ],
              [
                52.2174211,
                28.0953554
              ],
              [
                52.2204775,
                28.0917541
              ],
              [
                52.2207542,
                28.0911869
              ],
              [
                52.2299207,
                28.0798068
              ],
              [
                52.233254,
                28.0734146
              ],
              [
                52.2340874,
                28.0725865
              ],
              [
                52.2652003,
                28.0442452
              ],
              [
                52.2785369,
                28.0373042
              ],
              [
                52.2835367,
                28.0350806
              ],
              [
                52.2940899,
                28.0303542
              ],
              [
                52.2954799,
                28.0300841
              ],
              [
                52.3015932,
                28.0284187
              ],
              [
                52.3027031,
                28.0284187
              ],
              [
                52.3043697,
                28.0278605
              ],
              [
                52.3054797,
                28.0278606
              ],
              [
                52.3093696,
                28.0270233
              ],
              [
                52.3107597,
                28.0270233
              ],
              [
                52.3332592,
                28.0231342
              ],
              [
                52.3352024,
                28.0231343
              ],
              [
                52.3393726,
                28.022306
              ],
              [
                52.3632622,
                28.0150771
              ],
              [
                52.3977082,
                28.0300842
              ],
              [
                52.3977083,
                28.0311915
              ],
              [
                52.3990949,
                28.0331361
              ],
              [
                52.4007615,
                28.0339734
              ],
              [
                52.4090946,
                28.0425799
              ],
              [
                52.4096514,
                28.0425799
              ],
              [
                52.4099279,
                28.043138
              ],
              [
                52.4118747,
                28.0442454
              ],
              [
                52.4407642,
                28.0695254
              ],
              [
                52.4443741,
                28.0742521
              ],
              [
                52.4449308,
                28.0745221
              ],
              [
                52.4499307,
                28.0842455
              ],
              [
                52.4543773,
                28.1039718
              ],
              [
                52.4552106,
                28.1064657
              ],
              [
                52.4565973,
                28.1156404
              ],
              [
                52.4568773,
                28.1167478
              ],
              [
                52.4565973,
                28.1178552
              ],
              [
                52.4571539,
                28.1250851
              ],
              [
                52.4574305,
                28.1264717
              ],
              [
                52.4577106,
                28.1311896
              ],
              [
                52.4577105,
                28.1342509
              ],
              [
                52.4574305,
                28.1348001
              ],
              [
                52.4571539,
                28.1389689
              ],
              [
                52.4568773,
                28.1406436
              ],
              [
                52.4565973,
                28.1431377
              ],
              [
                52.4524306,
                28.1606325
              ],
              [
                52.4518773,
                28.1620281
              ],
              [
                52.4435408,
                28.2123087
              ],
              [
                52.4432641,
                28.2142447
              ],
              [
                52.4429874,
                28.2173063
              ],
              [
                52.4427074,
                28.2217456
              ],
              [
                52.4424308,
                28.2273107
              ],
              [
                52.4435407,
                28.24786
              ],
              [
                52.4440974,
                28.2503634
              ],
              [
                52.444374,
                28.2509217
              ],
              [
                52.444374,
                28.2520294
              ],
              [
                52.4404874,
                28.253137
              ],
              [
                52.440764,
                28.2539745
              ],
              [
                52.4404874,
                28.2542536
              ],
              [
                52.4410407,
                28.2573064
              ],
              [
                52.4452073,
                28.2725884
              ],
              [
                52.4463206,
                28.2778655
              ],
              [
                52.4529872,
                28.2925805
              ],
              [
                52.4535439,
                28.2942556
              ],
              [
                52.4538205,
                28.2948049
              ],
              [
                52.4549902,
                28.2972924
              ],
              [
                52.4793767,
                28.3564779
              ],
              [
                52.49049,
                28.3742565
              ],
              [
                52.4999331,
                28.3881447
              ],
              [
                52.5007664,
                28.393981
              ],
              [
                52.5040996,
                28.408419
              ],
              [
                52.5046563,
                28.4100852
              ],
              [
                52.504933,
                28.4128684
              ],
              [
                52.5052096,
                28.413697
              ],
              [
                52.5057663,
                28.4170296
              ],
              [
                52.506323,
                28.4209206
              ],
              [
                52.5124328,
                28.4392591
              ],
              [
                52.5235461,
                28.4714787
              ],
              [
                52.5327125,
                28.5017537
              ],
              [
                52.5354891,
                28.524535
              ],
              [
                52.5357691,
                28.528985
              ],
              [
                52.5354891,
                28.5298137
              ],
              [
                52.5354891,
                28.531201
              ],
              [
                52.535489,
                28.532318
              ],
              [
                52.5346557,
                28.5362006
              ],
              [
                52.5327125,
                28.5487042
              ],
              [
                52.5177126,
                28.586207
              ],
              [
                52.5174326,
                28.5884232
              ],
              [
                52.5168794,
                28.5898105
              ],
              [
                52.5165993,
                28.5920357
              ],
              [
                52.5160461,
                28.5937023
              ],
              [
                52.5154894,
                28.5975942
              ],
              [
                52.5152127,
                28.5998194
              ],
              [
                52.5149326,
                28.606477
              ],
              [
                52.5154893,
                28.6128734
              ],
              [
                52.517156,
                28.6192609
              ],
              [
                52.5202126,
                28.6253691
              ],
              [
                52.5252125,
                28.6375947
              ],
              [
                52.5257692,
                28.639811
              ],
              [
                52.5271557,
                28.664542
              ],
              [
                52.5274358,
                28.6662088
              ],
              [
                52.5271558,
                28.6678666
              ],
              [
                52.5268791,
                28.6742635
              ],
              [
                52.5266025,
                28.6762096
              ],
              [
                52.5263224,
                28.680372
              ],
              [
                52.5260459,
                28.6834264
              ],
              [
                52.5288224,
                28.7087083
              ],
              [
                52.5285457,
                28.7098166
              ],
              [
                52.5283613,
                28.7106545
              ],
              [
                52.5274358,
                28.7128709
              ],
              [
                52.5271557,
                28.7134296
              ],
              [
                52.5271557,
                28.7137089
              ],
              [
                52.5238225,
                28.7181509
              ],
              [
                52.5235459,
                28.7189888
              ],
              [
                52.5057661,
                28.731486
              ],
              [
                52.4999329,
                28.7362074
              ],
              [
                52.4852098,
                28.7398206
              ],
              [
                52.4524301,
                28.7470379
              ],
              [
                52.4510436,
                28.7470379
              ],
              [
                52.4477069,
                28.7478669
              ],
              [
                52.4285405,
                28.753985
              ],
              [
                52.4160407,
                28.7614817
              ],
              [
                52.4132641,
                28.7631487
              ],
              [
                52.4129841,
                28.7634281
              ],
              [
                52.4118742,
                28.7637074
              ],
              [
                52.4113175,
                28.7639868
              ],
              [
                52.4107607,
                28.764257
              ],
              [
                52.4057608,
                28.7659329
              ],
              [
                52.3840946,
                28.7825938
              ],
              [
                52.3807613,
                28.7859278
              ],
              [
                52.3749281,
                28.7917579
              ],
              [
                52.3711942,
                28.7959098
              ],
              [
                52.3699281,
                28.7973176
              ],
              [
                52.3649282,
                28.8037064
              ],
              [
                52.3613149,
                28.8106539
              ],
              [
                52.3582616,
                28.8259369
              ],
              [
                52.3532262,
                28.8395767
              ],
              [
                52.3496483,
                28.8492672
              ],
              [
                52.3357585,
                28.8648212
              ],
              [
                52.3268686,
                28.8700929
              ],
              [
                52.3249254,
                28.8709311
              ],
              [
                52.3232588,
                28.8720485
              ],
              [
                52.3002024,
                28.9056537
              ],
              [
                52.291036,
                28.9189916
              ],
              [
                52.2688129,
                28.944271
              ],
              [
                52.2551997,
                28.9628818
              ],
              [
                52.2488098,
                28.9695421
              ],
              [
                52.2379765,
                28.9823221
              ],
              [
                52.2365867,
                28.9845392
              ],
              [
                52.2296434,
                28.9914881
              ],
              [
                52.2263101,
                28.9959314
              ],
              [
                52.2232534,
                28.9992662
              ],
              [
                52.2227001,
                29.0003747
              ],
              [
                52.2171436,
                29.0053769
              ],
              [
                52.2024204,
                29.0170487
              ],
              [
                52.2015873,
                29.0173192
              ],
              [
                52.1965873,
                29.0223214
              ],
              [
                52.1940873,
                29.0256563
              ],
              [
                52.1885308,
                29.0356609
              ],
              [
                52.1885307,
                29.037049
              ],
              [
                52.1882539,
                29.0375988
              ],
              [
                52.1893639,
                29.0470448
              ],
              [
                52.1938072,
                29.0567702
              ],
              [
                52.1940872,
                29.0584377
              ],
              [
                52.1954738,
                29.0612139
              ],
              [
                52.1956244,
                29.0616436
              ],
              [
                52.1954737,
                29.0620521
              ],
              [
                52.1951973,
                29.0623225
              ],
              [
                52.1929739,
                29.0637106
              ],
              [
                52.1924206,
                29.0642695
              ],
              [
                52.1657509,
                29.0981609
              ],
              [
                52.1649175,
                29.0989901
              ],
              [
                52.161861,
                29.1048311
              ],
              [
                52.1590844,
                29.1089955
              ],
              [
                52.156861,
                29.1117718
              ],
              [
                52.1415847,
                29.1289886
              ],
              [
                52.1168616,
                29.1628822
              ],
              [
                52.1160284,
                29.1648293
              ],
              [
                52.1149151,
                29.1664879
              ],
              [
                52.114915,
                29.1667765
              ],
              [
                52.1140817,
                29.1670469
              ],
              [
                52.1135283,
                29.1673263
              ],
              [
                52.112695,
                29.1673264
              ],
              [
                52.0560259,
                29.1784412
              ],
              [
                52.0221331,
                29.1856619
              ],
              [
                52.0207464,
                29.1856619
              ],
              [
                52.0174131,
                29.1862117
              ],
              [
                52.0149133,
                29.1862117
              ],
              [
                52.0096332,
                29.1864912
              ],
              [
                52.0082432,
                29.1864911
              ],
              [
                52.0076898,
                29.1867707
              ],
              [
                52.0032432,
                29.1867707
              ],
              [
                52.0018567,
                29.1870501
              ],
              [
                52.0013001,
                29.1867706
              ],
              [
                51.9999408,
                29.1870501
              ],
              [
                51.9890769,
                29.1870501
              ],
              [
                51.9882436,
                29.1867707
              ],
              [
                51.9843535,
                29.1867707
              ],
              [
                51.9832436,
                29.1864911
              ],
              [
                51.9813003,
                29.1864911
              ],
              [
                51.9799103,
                29.1862117
              ],
              [
                51.9704638,
                29.1853824
              ],
              [
                51.9621306,
                29.1839941
              ],
              [
                51.9607439,
                29.1834443
              ],
              [
                51.9596306,
                29.1834442
              ],
              [
                51.9287979,
                29.1742674
              ],
              [
                51.9251845,
                29.1726087
              ],
              [
                51.9235179,
                29.1717703
              ],
              [
                51.923241,
                29.1714909
              ],
              [
                51.9226845,
                29.1714909
              ],
              [
                51.898795,
                29.153435
              ],
              [
                51.8985182,
                29.1531555
              ],
              [
                51.8960183,
                29.1517673
              ],
              [
                51.8957382,
                29.1514879
              ],
              [
                51.8532389,
                29.122327
              ],
              [
                51.8365691,
                29.1067689
              ],
              [
                51.8354594,
                29.1051013
              ],
              [
                51.8285409,
                29.1021971
              ],
              [
                51.8250243,
                29.098801
              ],
              [
                51.817156,
                29.0906805
              ],
              [
                51.8140504,
                29.0874596
              ],
              [
                51.8093656,
                29.0797703
              ],
              [
                51.80462,
                29.0720075
              ],
              [
                51.8013607,
                29.0653872
              ],
              [
                51.7987117,
                29.0606513
              ],
              [
                51.7949032,
                29.0473239
              ],
              [
                51.7946233,
                29.046765
              ],
              [
                51.79304,
                29.0421466
              ],
              [
                51.8146704,
                29.0238477
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555138,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فسا",
          "name:en": "Fasa County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q548013",
          "wikipedia": "en:Fasa County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.3416365,
                29.3562152
              ],
              [
                53.3416365,
                29.3414921
              ],
              [
                53.3413599,
                29.3370471
              ],
              [
                53.3416364,
                29.3331703
              ],
              [
                53.3419131,
                29.3231628
              ],
              [
                53.3421931,
                29.3131642
              ],
              [
                53.3424698,
                29.3095489
              ],
              [
                53.3427464,
                29.3064926
              ],
              [
                53.3430264,
                29.2990006
              ],
              [
                53.3433031,
                29.2828898
              ],
              [
                53.3435798,
                29.2734416
              ],
              [
                53.3438598,
                29.2662204
              ],
              [
                53.3441365,
                29.263714
              ],
              [
                53.3419132,
                29.2151047
              ],
              [
                53.3421932,
                29.2137163
              ],
              [
                53.3421932,
                29.200104
              ],
              [
                53.3424699,
                29.1976069
              ],
              [
                53.3427465,
                29.1931627
              ],
              [
                53.3430265,
                29.1917744
              ],
              [
                53.3433032,
                29.1903862
              ],
              [
                53.3438598,
                29.1881596
              ],
              [
                53.3510797,
                29.1787212
              ],
              [
                53.3580263,
                29.1706623
              ],
              [
                53.3808059,
                29.1351008
              ],
              [
                53.3846925,
                29.130107
              ],
              [
                53.3880259,
                29.1259334
              ],
              [
                53.3938624,
                29.1187131
              ],
              [
                53.4655313,
                29.0406549
              ],
              [
                53.4677513,
                29.0378787
              ],
              [
                53.4680313,
                29.0375994
              ],
              [
                53.4696981,
                29.0334352
              ],
              [
                53.4702547,
                29.0301003
              ],
              [
                53.4705313,
                29.029821
              ],
              [
                53.4699747,
                29.0287123
              ],
              [
                53.4699746,
                29.0284329
              ],
              [
                53.4694151,
                29.0278741
              ],
              [
                53.4691413,
                29.0276037
              ],
              [
                53.4688647,
                29.0273243
              ],
              [
                53.468588,
                29.0264861
              ],
              [
                53.457445,
                29.0165562
              ],
              [
                53.4540715,
                29.0153213
              ],
              [
                53.4543718,
                29.0126059
              ],
              [
                53.4555316,
                29.0109385
              ],
              [
                53.463308,
                29.0000328
              ],
              [
                53.4674747,
                28.9953821
              ],
              [
                53.4730313,
                28.9834312
              ],
              [
                53.473588,
                28.979826
              ],
              [
                53.4716413,
                28.9623235
              ],
              [
                53.4719213,
                28.959827
              ],
              [
                53.4766412,
                28.9467679
              ],
              [
                53.4771978,
                28.9462092
              ],
              [
                53.4771978,
                28.9456594
              ],
              [
                53.4833077,
                28.9334297
              ],
              [
                53.4863644,
                28.9289866
              ],
              [
                53.4899778,
                28.9242642
              ],
              [
                53.5213672,
                28.898715
              ],
              [
                53.5216439,
                28.8984356
              ],
              [
                53.5217697,
                28.8982826
              ],
              [
                53.5577566,
                28.8545394
              ],
              [
                53.5738697,
                28.8406527
              ],
              [
                53.5744231,
                28.8395444
              ],
              [
                53.5755365,
                28.8387063
              ],
              [
                53.5841462,
                28.8292625
              ],
              [
                53.5869263,
                28.8262077
              ],
              [
                53.6010927,
                28.8106543
              ],
              [
                53.6016494,
                28.8106544
              ],
              [
                53.601926,
                28.8103751
              ],
              [
                53.6033161,
                28.8098163
              ],
              [
                53.6041494,
                28.8098164
              ],
              [
                53.6052594,
                28.8092667
              ],
              [
                53.6060926,
                28.8092666
              ],
              [
                53.6133565,
                28.806396
              ],
              [
                53.6166492,
                28.8050946
              ],
              [
                53.6208157,
                28.7987057
              ],
              [
                53.622759,
                28.794822
              ],
              [
                53.6233157,
                28.7937047
              ],
              [
                53.6235923,
                28.7925963
              ],
              [
                53.624149,
                28.7903707
              ],
              [
                53.6247057,
                28.7895416
              ],
              [
                53.6247057,
                28.7892622
              ],
              [
                53.6247057,
                28.7889829
              ],
              [
                53.6253287,
                28.7873588
              ],
              [
                53.625539,
                28.7870456
              ],
              [
                53.6274823,
                28.7842613
              ],
              [
                53.629149,
                28.7825943
              ],
              [
                53.6324823,
                28.7781519
              ],
              [
                53.6349821,
                28.775647
              ],
              [
                53.6349822,
                28.7750973
              ],
              [
                53.6460953,
                28.7625905
              ],
              [
                53.6683184,
                28.738983
              ],
              [
                53.668595,
                28.7378747
              ],
              [
                53.6758183,
                28.727594
              ],
              [
                53.6760949,
                28.7264857
              ],
              [
                53.6777615,
                28.7237105
              ],
              [
                53.6794282,
                28.7209264
              ],
              [
                53.6897081,
                28.7087087
              ],
              [
                53.6927613,
                28.7056542
              ],
              [
                53.6938746,
                28.7050956
              ],
              [
                53.711931,
                28.6959234
              ],
              [
                53.7133194,
                28.6948152
              ],
              [
                53.7138743,
                28.6942567
              ],
              [
                53.7194309,
                28.690932
              ],
              [
                53.7483955,
                28.6743498
              ],
              [
                53.7494304,
                28.6737052
              ],
              [
                53.7544337,
                28.670651
              ],
              [
                53.7780433,
                28.6475955
              ],
              [
                53.7983231,
                28.6139819
              ],
              [
                53.7985997,
                28.6125945
              ],
              [
                53.802213,
                28.6042612
              ],
              [
                53.803323,
                28.6025946
              ],
              [
                53.8049896,
                28.5995404
              ],
              [
                53.8233226,
                28.5731447
              ],
              [
                53.8483257,
                28.5548123
              ],
              [
                53.8902716,
                28.5339849
              ],
              [
                53.894995,
                28.5323184
              ],
              [
                53.8966616,
                28.5314807
              ],
              [
                53.9411075,
                28.5189774
              ],
              [
                53.9572172,
                28.5150948
              ],
              [
                53.9586073,
                28.5150949
              ],
              [
                54.0002767,
                28.5084289
              ],
              [
                54.0030532,
                28.5075912
              ],
              [
                54.0077765,
                28.5075912
              ],
              [
                54.0077765,
                28.507312
              ],
              [
                54.0091665,
                28.507312
              ],
              [
                54.0105531,
                28.5067534
              ],
              [
                54.0113864,
                28.5067535
              ],
              [
                54.0119431,
                28.5064743
              ],
              [
                54.0127764,
                28.5064742
              ],
              [
                54.0133331,
                28.506204
              ],
              [
                54.0141664,
                28.506204
              ],
              [
                54.0158331,
                28.5053663
              ],
              [
                54.0166664,
                28.5053662
              ],
              [
                54.017223,
                28.505087
              ],
              [
                54.0180564,
                28.505087
              ],
              [
                54.019443,
                28.5045375
              ],
              [
                54.0202763,
                28.5045375
              ],
              [
                54.020833,
                28.5042582
              ],
              [
                54.0216663,
                28.5042583
              ],
              [
                54.021943,
                28.505087
              ],
              [
                54.0233329,
                28.5059247
              ],
              [
                54.0266662,
                28.5134284
              ],
              [
                54.045556,
                28.5348137
              ],
              [
                54.0477792,
                28.536201
              ],
              [
                54.0566691,
                28.5437049
              ],
              [
                54.0577791,
                28.5445337
              ],
              [
                54.0727788,
                28.5570374
              ],
              [
                54.0822254,
                28.5778653
              ],
              [
                54.0858353,
                28.5906487
              ],
              [
                54.086112,
                28.5914865
              ],
              [
                54.0861119,
                28.5923153
              ],
              [
                54.0966685,
                28.6331445
              ],
              [
                54.0969485,
                28.6342617
              ],
              [
                54.1002818,
                28.6437035
              ],
              [
                54.1016684,
                28.6450909
              ],
              [
                54.1019484,
                28.6459288
              ],
              [
                54.1019484,
                28.6462081
              ],
              [
                54.1025017,
                28.6464783
              ],
              [
                54.1050016,
                28.6514786
              ],
              [
                54.1052817,
                28.6517579
              ],
              [
                54.1055583,
                28.6531454
              ],
              [
                54.106115,
                28.6562086
              ],
              [
                54.1063917,
                28.6570375
              ],
              [
                54.1063916,
                28.6573168
              ],
              [
                54.108335,
                28.6611999
              ],
              [
                54.108615,
                28.6625963
              ],
              [
                54.1150049,
                28.6839855
              ],
              [
                54.1152816,
                28.6853729
              ],
              [
                54.1155582,
                28.6870397
              ],
              [
                54.1158383,
                28.6892651
              ],
              [
                54.1161149,
                28.6906527
              ],
              [
                54.1188915,
                28.7003744
              ],
              [
                54.1197248,
                28.701762
              ],
              [
                54.1200048,
                28.7025909
              ],
              [
                54.1197248,
                28.7028702
              ],
              [
                54.1272247,
                28.7225933
              ],
              [
                54.1300046,
                28.726765
              ],
              [
                54.1302813,
                28.7273237
              ],
              [
                54.1308381,
                28.7284319
              ],
              [
                54.1594509,
                28.7614822
              ],
              [
                54.1602842,
                28.7617616
              ],
              [
                54.1772272,
                28.7787106
              ],
              [
                54.1780605,
                28.7792693
              ],
              [
                54.2025571,
                28.8068503
              ],
              [
                54.2155633,
                28.8214858
              ],
              [
                54.2169534,
                28.8237025
              ],
              [
                54.2172299,
                28.8239819
              ],
              [
                54.21723,
                28.8245406
              ],
              [
                54.21723,
                28.82482
              ],
              [
                54.2319531,
                28.8406528
              ],
              [
                54.2327864,
                28.8414909
              ],
              [
                54.2361196,
                28.8445457
              ],
              [
                54.2588994,
                28.8725987
              ],
              [
                54.259176,
                28.8731575
              ],
              [
                54.2283432,
                28.9048252
              ],
              [
                54.2277865,
                28.9053749
              ],
              [
                54.1922304,
                28.9306539
              ],
              [
                54.1880639,
                28.932871
              ],
              [
                54.168894,
                28.9492644
              ],
              [
                54.1680608,
                28.9506524
              ],
              [
                54.1680607,
                28.9509317
              ],
              [
                54.1666742,
                28.9537166
              ],
              [
                54.1633374,
                28.9720391
              ],
              [
                54.1636175,
                28.9723185
              ],
              [
                54.1638941,
                28.9739858
              ],
              [
                54.1641708,
                28.974824
              ],
              [
                54.1647274,
                28.9778794
              ],
              [
                54.1644508,
                28.9820433
              ],
              [
                54.1647274,
                28.982602
              ],
              [
                54.1650041,
                28.9845398
              ],
              [
                54.1652842,
                28.9853779
              ],
              [
                54.1655608,
                28.9876041
              ],
              [
                54.1663941,
                28.9923268
              ],
              [
                54.1722274,
                28.9989874
              ],
              [
                54.1677841,
                29.0131557
              ],
              [
                54.1675075,
                29.0175992
              ],
              [
                54.1674142,
                29.0178786
              ],
              [
                54.1672274,
                29.0187168
              ],
              [
                54.1669508,
                29.019546
              ],
              [
                54.1647275,
                29.0242689
              ],
              [
                54.1641708,
                29.0248277
              ],
              [
                54.1552843,
                29.0484334
              ],
              [
                54.1536176,
                29.051489
              ],
              [
                54.1522277,
                29.0537153
              ],
              [
                54.1411145,
                29.0639906
              ],
              [
                54.1266714,
                29.069552
              ],
              [
                54.125558,
                29.069552
              ],
              [
                54.1236148,
                29.0701018
              ],
              [
                54.1191716,
                29.0701018
              ],
              [
                54.103335,
                29.0637112
              ],
              [
                54.0969486,
                29.0623232
              ],
              [
                54.0930586,
                29.0623231
              ],
              [
                54.0925019,
                29.0626026
              ],
              [
                54.090002,
                29.0626025
              ],
              [
                54.0816688,
                29.06427
              ],
              [
                54.0777788,
                29.0656581
              ],
              [
                54.0750022,
                29.0664964
              ],
              [
                54.0650024,
                29.0687138
              ],
              [
                54.0580557,
                29.0687137
              ],
              [
                54.0513892,
                29.0681639
              ],
              [
                54.0502792,
                29.0678845
              ],
              [
                54.0477792,
                29.0678845
              ],
              [
                54.0352795,
                29.0656582
              ],
              [
                54.0327761,
                29.0656582
              ],
              [
                54.0294429,
                29.0651083
              ],
              [
                54.0258329,
                29.0651083
              ],
              [
                54.0247229,
                29.0648289
              ],
              [
                54.0224997,
                29.0648289
              ],
              [
                54.0216663,
                29.0645495
              ],
              [
                54.0191663,
                29.0645495
              ],
              [
                54.0083332,
                29.0620527
              ],
              [
                54.0066666,
                29.0620527
              ],
              [
                54.0066666,
                29.0617733
              ],
              [
                54.0058332,
                29.0617734
              ],
              [
                54.0047199,
                29.0612145
              ],
              [
                54.0033333,
                29.0612145
              ],
              [
                54.0030532,
                29.060935
              ],
              [
                54.0025,
                29.060935
              ],
              [
                54.0022199,
                29.0606556
              ],
              [
                54.0013866,
                29.0606556
              ],
              [
                54.0002767,
                29.0603852
              ],
              [
                53.982777,
                29.0601058
              ],
              [
                53.9811103,
                29.0603853
              ],
              [
                53.977497,
                29.0603852
              ],
              [
                53.9763871,
                29.0606557
              ],
              [
                53.9755537,
                29.0606557
              ],
              [
                53.9749601,
                29.0608046
              ],
              [
                53.9744403,
                29.060935
              ],
              [
                53.9722205,
                29.0612145
              ],
              [
                53.9708304,
                29.0612145
              ],
              [
                53.9705538,
                29.0614939
              ],
              [
                53.9688871,
                29.0614939
              ],
              [
                53.9641638,
                29.0623232
              ],
              [
                53.9636071,
                29.0626025
              ],
              [
                53.9616639,
                29.0626026
              ],
              [
                53.9544407,
                29.0637112
              ],
              [
                53.9122179,
                29.0739957
              ],
              [
                53.9080513,
                29.074825
              ],
              [
                53.8852717,
                29.0784394
              ],
              [
                53.8774917,
                29.0789892
              ],
              [
                53.8641586,
                29.0812156
              ],
              [
                53.8619354,
                29.0812156
              ],
              [
                53.8605488,
                29.081495
              ],
              [
                53.8572155,
                29.0814951
              ],
              [
                53.8541588,
                29.0820449
              ],
              [
                53.8527688,
                29.0820448
              ],
              [
                53.8516588,
                29.0823243
              ],
              [
                53.8499922,
                29.0823243
              ],
              [
                53.8355458,
                29.0856594
              ],
              [
                53.8188794,
                29.0953762
              ],
              [
                53.8186028,
                29.0959351
              ],
              [
                53.8177694,
                29.096494
              ],
              [
                53.816656,
                29.0973232
              ],
              [
                53.8111029,
                29.1014876
              ],
              [
                53.8088795,
                29.1034346
              ],
              [
                53.7947131,
                29.1145487
              ],
              [
                53.7586003,
                29.1248247
              ],
              [
                53.749987,
                29.1267718
              ],
              [
                53.7130409,
                29.1331628
              ],
              [
                53.709431,
                29.1334332
              ],
              [
                53.7085977,
                29.1337127
              ],
              [
                53.7019312,
                29.1337127
              ],
              [
                53.7010978,
                29.1339921
              ],
              [
                53.6991512,
                29.1339921
              ],
              [
                53.6905413,
                29.1353803
              ],
              [
                53.6891513,
                29.1356597
              ],
              [
                53.6880413,
                29.1356597
              ],
              [
                53.6772082,
                29.1356597
              ],
              [
                53.6766515,
                29.1359392
              ],
              [
                53.6752614,
                29.1359392
              ],
              [
                53.6747048,
                29.1362186
              ],
              [
                53.6733182,
                29.1362186
              ],
              [
                53.6413721,
                29.1501005
              ],
              [
                53.6263723,
                29.1659388
              ],
              [
                53.6252589,
                29.1670475
              ],
              [
                53.6249823,
                29.1676064
              ],
              [
                53.623039,
                29.1701034
              ],
              [
                53.6027592,
                29.1964892
              ],
              [
                53.5869262,
                29.2087132
              ],
              [
                53.5855362,
                29.209822
              ],
              [
                53.5872028,
                29.2117692
              ],
              [
                53.6013693,
                29.2192697
              ],
              [
                53.6149824,
                29.2287173
              ],
              [
                53.6185923,
                29.2320529
              ],
              [
                53.6385954,
                29.2503896
              ],
              [
                53.6399821,
                29.2514985
              ],
              [
                53.6713715,
                29.2987212
              ],
              [
                53.6735949,
                29.3045543
              ],
              [
                53.6741515,
                29.3053837
              ],
              [
                53.6788747,
                29.3239922
              ],
              [
                53.6791515,
                29.3359383
              ],
              [
                53.6788748,
                29.3373267
              ],
              [
                53.6780415,
                29.3442781
              ],
              [
                53.6783181,
                29.3481639
              ],
              [
                53.6783181,
                29.3484434
              ],
              [
                53.6783181,
                29.3489934
              ],
              [
                53.6780414,
                29.3492729
              ],
              [
                53.6772081,
                29.3526089
              ],
              [
                53.6741515,
                29.3606693
              ],
              [
                53.6735949,
                29.3617782
              ],
              [
                53.6408152,
                29.3926139
              ],
              [
                53.6155357,
                29.4087173
              ],
              [
                53.613869,
                29.4092763
              ],
              [
                53.6133157,
                29.4098354
              ],
              [
                53.5952594,
                29.4167781
              ],
              [
                53.5919261,
                29.4195552
              ],
              [
                53.5883127,
                29.4215029
              ],
              [
                53.5841462,
                29.4226119
              ],
              [
                53.5785896,
                29.4253891
              ],
              [
                53.5780363,
                29.4259481
              ],
              [
                53.5777563,
                29.4256596
              ],
              [
                53.577203,
                29.4256595
              ],
              [
                53.5699797,
                29.4223324
              ],
              [
                53.5527567,
                29.4142716
              ],
              [
                53.5460901,
                29.4126035
              ],
              [
                53.5021973,
                29.3973385
              ],
              [
                53.5010873,
                29.3973385
              ],
              [
                53.4746978,
                29.3923344
              ],
              [
                53.4319184,
                29.3820558
              ],
              [
                53.4271952,
                29.3806672
              ],
              [
                53.3627495,
                29.3620487
              ],
              [
                53.3616362,
                29.3620487
              ],
              [
                53.3605262,
                29.3614987
              ],
              [
                53.3594163,
                29.3614987
              ],
              [
                53.3591362,
                29.3612192
              ],
              [
                53.3585829,
                29.3612192
              ],
              [
                53.3533029,
                29.3595512
              ],
              [
                53.352193,
                29.3595512
              ],
              [
                53.3474436,
                29.358495
              ],
              [
                53.3446931,
                29.3578832
              ],
              [
                53.3441364,
                29.3576037
              ],
              [
                53.3419131,
                29.3567742
              ],
              [
                53.3416365,
                29.3562152
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555143,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فیروز آباد",
          "name:en": "Firuzabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270536",
          "wikipedia": "en:Firuzabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.114915,
                29.1667765
              ],
              [
                52.1149151,
                29.1664879
              ],
              [
                52.1160284,
                29.1648293
              ],
              [
                52.1168616,
                29.1628822
              ],
              [
                52.1415847,
                29.1289886
              ],
              [
                52.156861,
                29.1117718
              ],
              [
                52.1590844,
                29.1089955
              ],
              [
                52.161861,
                29.1048311
              ],
              [
                52.1649175,
                29.0989901
              ],
              [
                52.1657509,
                29.0981609
              ],
              [
                52.1924206,
                29.0642695
              ],
              [
                52.1929739,
                29.0637106
              ],
              [
                52.1951973,
                29.0623225
              ],
              [
                52.1954737,
                29.0620521
              ],
              [
                52.1956244,
                29.0616436
              ],
              [
                52.1954738,
                29.0612139
              ],
              [
                52.1940872,
                29.0584377
              ],
              [
                52.1938072,
                29.0567702
              ],
              [
                52.1893639,
                29.0470448
              ],
              [
                52.1882539,
                29.0375988
              ],
              [
                52.1885307,
                29.037049
              ],
              [
                52.1885308,
                29.0356609
              ],
              [
                52.1940873,
                29.0256563
              ],
              [
                52.1965873,
                29.0223214
              ],
              [
                52.2015873,
                29.0173192
              ],
              [
                52.2024204,
                29.0170487
              ],
              [
                52.2171436,
                29.0053769
              ],
              [
                52.2227001,
                29.0003747
              ],
              [
                52.2232534,
                28.9992662
              ],
              [
                52.2263101,
                28.9959314
              ],
              [
                52.2296434,
                28.9914881
              ],
              [
                52.2365867,
                28.9845392
              ],
              [
                52.2379765,
                28.9823221
              ],
              [
                52.2488098,
                28.9695421
              ],
              [
                52.2551997,
                28.9628818
              ],
              [
                52.2688129,
                28.944271
              ],
              [
                52.291036,
                28.9189916
              ],
              [
                52.3002024,
                28.9056537
              ],
              [
                52.3232588,
                28.8720485
              ],
              [
                52.3249254,
                28.8709311
              ],
              [
                52.3268686,
                28.8700929
              ],
              [
                52.3357585,
                28.8648212
              ],
              [
                52.3496483,
                28.8492672
              ],
              [
                52.3532262,
                28.8395767
              ],
              [
                52.3582616,
                28.8259369
              ],
              [
                52.3613149,
                28.8106539
              ],
              [
                52.3649282,
                28.8037064
              ],
              [
                52.3699281,
                28.7973176
              ],
              [
                52.3711942,
                28.7959098
              ],
              [
                52.3749281,
                28.7917579
              ],
              [
                52.3807613,
                28.7859278
              ],
              [
                52.3840946,
                28.7825938
              ],
              [
                52.4057608,
                28.7659329
              ],
              [
                52.4107607,
                28.764257
              ],
              [
                52.4113175,
                28.7639868
              ],
              [
                52.4118742,
                28.7637074
              ],
              [
                52.4129841,
                28.7634281
              ],
              [
                52.4132641,
                28.7631487
              ],
              [
                52.4160407,
                28.7614817
              ],
              [
                52.4285405,
                28.753985
              ],
              [
                52.4477069,
                28.7478669
              ],
              [
                52.4510436,
                28.7470379
              ],
              [
                52.4524301,
                28.7470379
              ],
              [
                52.4852098,
                28.7398206
              ],
              [
                52.4999329,
                28.7362074
              ],
              [
                52.5057661,
                28.731486
              ],
              [
                52.5235459,
                28.7189888
              ],
              [
                52.5238225,
                28.7181509
              ],
              [
                52.5271557,
                28.7137089
              ],
              [
                52.5271557,
                28.7134296
              ],
              [
                52.5274358,
                28.7128709
              ],
              [
                52.5283613,
                28.7106545
              ],
              [
                52.5285457,
                28.7098166
              ],
              [
                52.5288224,
                28.7087083
              ],
              [
                52.5260459,
                28.6834264
              ],
              [
                52.5263224,
                28.680372
              ],
              [
                52.5266025,
                28.6762096
              ],
              [
                52.5268791,
                28.6742635
              ],
              [
                52.5271558,
                28.6678666
              ],
              [
                52.5274358,
                28.6662088
              ],
              [
                52.5271557,
                28.664542
              ],
              [
                52.5257692,
                28.639811
              ],
              [
                52.5252125,
                28.6375947
              ],
              [
                52.5202126,
                28.6253691
              ],
              [
                52.517156,
                28.6192609
              ],
              [
                52.5154893,
                28.6128734
              ],
              [
                52.5149326,
                28.606477
              ],
              [
                52.5152127,
                28.5998194
              ],
              [
                52.5154894,
                28.5975942
              ],
              [
                52.5160461,
                28.5937023
              ],
              [
                52.5165993,
                28.5920357
              ],
              [
                52.5168794,
                28.5898105
              ],
              [
                52.5174326,
                28.5884232
              ],
              [
                52.5177126,
                28.586207
              ],
              [
                52.5327125,
                28.5487042
              ],
              [
                52.5346557,
                28.5362006
              ],
              [
                52.535489,
                28.532318
              ],
              [
                52.5354891,
                28.531201
              ],
              [
                52.5385456,
                28.5287057
              ],
              [
                52.5396556,
                28.5284265
              ],
              [
                52.5513255,
                28.5253727
              ],
              [
                52.5721585,
                28.5220307
              ],
              [
                52.6029947,
                28.515653
              ],
              [
                52.608548,
                28.5139775
              ],
              [
                52.6124379,
                28.5131488
              ],
              [
                52.6663305,
                28.4964751
              ],
              [
                52.671607,
                28.4950879
              ],
              [
                52.7057766,
                28.4817564
              ],
              [
                52.7268861,
                28.4711995
              ],
              [
                52.7274429,
                28.470641
              ],
              [
                52.7346661,
                28.4681459
              ],
              [
                52.7357893,
                28.4675624
              ],
              [
                52.7368895,
                28.4675875
              ],
              [
                52.7568891,
                28.4889807
              ],
              [
                52.7579991,
                28.4900886
              ],
              [
                52.7685555,
                28.5112032
              ],
              [
                52.7693889,
                28.5150946
              ],
              [
                52.7696655,
                28.5159234
              ],
              [
                52.7696655,
                28.5250936
              ],
              [
                52.7710554,
                28.5339847
              ],
              [
                52.7771687,
                28.5584244
              ],
              [
                52.777722,
                28.5611991
              ],
              [
                52.7785553,
                28.5700905
              ],
              [
                52.7793886,
                28.5737029
              ],
              [
                52.7796688,
                28.5778649
              ],
              [
                52.7796687,
                28.5867566
              ],
              [
                52.7799452,
                28.588144
              ],
              [
                52.7804068,
                28.5888828
              ],
              [
                52.7813354,
                28.5903692
              ],
              [
                52.7910585,
                28.5928646
              ],
              [
                52.7924451,
                28.5925943
              ],
              [
                52.7930017,
                28.5923151
              ],
              [
                52.7938351,
                28.592315
              ],
              [
                52.8102248,
                28.5856486
              ],
              [
                52.8110581,
                28.58509
              ],
              [
                52.8130014,
                28.5845405
              ],
              [
                52.8146681,
                28.5837027
              ],
              [
                52.8385577,
                28.5762074
              ],
              [
                52.868284,
                28.5634242
              ],
              [
                52.8702273,
                28.5628657
              ],
              [
                52.8710605,
                28.5623161
              ],
              [
                52.8730039,
                28.5617576
              ],
              [
                52.8743939,
                28.5609288
              ],
              [
                52.8780038,
                28.5592622
              ],
              [
                52.8821705,
                28.5581452
              ],
              [
                52.8849504,
                28.5581452
              ],
              [
                52.8857837,
                28.5584245
              ],
              [
                52.886617,
                28.5584245
              ],
              [
                52.9241198,
                28.5898107
              ],
              [
                52.9502294,
                28.6045402
              ],
              [
                52.9613425,
                28.6120358
              ],
              [
                52.9613425,
                28.6125943
              ],
              [
                52.9635659,
                28.6150899
              ],
              [
                52.9621757,
                28.6159277
              ],
              [
                52.9616191,
                28.6164773
              ],
              [
                52.9571759,
                28.6198197
              ],
              [
                52.9516194,
                28.621198
              ],
              [
                52.9427295,
                28.6256486
              ],
              [
                52.9357863,
                28.6287028
              ],
              [
                52.9346729,
                28.628982
              ],
              [
                52.9330062,
                28.6298199
              ],
              [
                52.9316197,
                28.6300992
              ],
              [
                52.9313396,
                28.6303694
              ],
              [
                52.9302296,
                28.6306487
              ],
              [
                52.9291196,
                28.6309279
              ],
              [
                52.9107833,
                28.6398112
              ],
              [
                52.8488375,
                28.6817597
              ],
              [
                52.842171,
                28.685652
              ],
              [
                52.8299478,
                28.6934275
              ],
              [
                52.8118914,
                28.7092671
              ],
              [
                52.7738353,
                28.7314861
              ],
              [
                52.7693886,
                28.7375951
              ],
              [
                52.7685553,
                28.7392621
              ],
              [
                52.767722,
                28.7401
              ],
              [
                52.7599455,
                28.7562107
              ],
              [
                52.7593888,
                28.7570397
              ],
              [
                52.7593889,
                28.7578777
              ],
              [
                52.7616122,
                28.759815
              ],
              [
                52.7643887,
                28.7612025
              ],
              [
                52.7652221,
                28.7612026
              ],
              [
                52.7763353,
                28.7656539
              ],
              [
                52.7768886,
                28.7662036
              ],
              [
                52.8027249,
                28.7762054
              ],
              [
                52.8043915,
                28.7770434
              ],
              [
                52.8071681,
                28.777593
              ],
              [
                52.8113347,
                28.7792691
              ],
              [
                52.8360577,
                28.7867661
              ],
              [
                52.8374477,
                28.7867661
              ],
              [
                52.8482809,
                28.7898208
              ],
              [
                52.900147,
                28.8019556
              ],
              [
                52.9005067,
                28.8020396
              ],
              [
                52.9152297,
                28.8070407
              ],
              [
                52.915783,
                28.8070408
              ],
              [
                52.9160631,
                28.8073201
              ],
              [
                52.917173,
                28.8084284
              ],
              [
                52.9174497,
                28.8089872
              ],
              [
                52.9174497,
                28.8095458
              ],
              [
                52.9177298,
                28.8167637
              ],
              [
                52.9185631,
                28.8228733
              ],
              [
                52.9218964,
                28.8373184
              ],
              [
                52.922453,
                28.8384268
              ],
              [
                52.9230062,
                28.8439869
              ],
              [
                52.9252296,
                28.8592613
              ],
              [
                52.9255063,
                28.8598201
              ],
              [
                52.9252296,
                28.8606581
              ],
              [
                52.9255063,
                28.8634337
              ],
              [
                52.9257863,
                28.8645421
              ],
              [
                52.9257863,
                28.8656505
              ],
              [
                52.9260629,
                28.867597
              ],
              [
                52.9260629,
                28.8678764
              ],
              [
                52.9268963,
                28.8756535
              ],
              [
                52.9266195,
                28.8759328
              ],
              [
                52.9285629,
                28.8812047
              ],
              [
                52.9291196,
                28.8853772
              ],
              [
                52.9282862,
                28.8900994
              ],
              [
                52.9277296,
                28.8912079
              ],
              [
                52.9277295,
                28.8920459
              ],
              [
                52.9274529,
                28.8925957
              ],
              [
                52.9268962,
                28.8978767
              ],
              [
                52.9241196,
                28.9034281
              ],
              [
                52.9124497,
                28.919821
              ],
              [
                52.9093965,
                28.9228761
              ],
              [
                52.8980067,
                28.9298246
              ],
              [
                52.8971734,
                28.9303743
              ],
              [
                52.8938401,
                28.9312124
              ],
              [
                52.8935599,
                28.9314919
              ],
              [
                52.8927267,
                28.9314918
              ],
              [
                52.8913401,
                28.9320416
              ],
              [
                52.8908185,
                28.9322165
              ],
              [
                52.8899502,
                28.9326003
              ],
              [
                52.8807836,
                28.9348174
              ],
              [
                52.8802269,
                28.9350967
              ],
              [
                52.8788369,
                28.9350968
              ],
              [
                52.877727,
                28.9353761
              ],
              [
                52.8696704,
                28.9353761
              ],
              [
                52.8691171,
                28.9350967
              ],
              [
                52.8677271,
                28.9350968
              ],
              [
                52.8635605,
                28.9339882
              ],
              [
                52.8630039,
                28.9339882
              ],
              [
                52.8610605,
                28.9334294
              ],
              [
                52.8607805,
                28.93315
              ],
              [
                52.8599472,
                28.93315
              ],
              [
                52.8596705,
                28.9328707
              ],
              [
                52.8582805,
                28.9328707
              ],
              [
                52.854394,
                28.9339882
              ],
              [
                52.8538373,
                28.9339882
              ],
              [
                52.8535606,
                28.9342675
              ],
              [
                52.8527274,
                28.9342676
              ],
              [
                52.8502273,
                28.9353761
              ],
              [
                52.8282811,
                28.9489938
              ],
              [
                52.8207811,
                28.955654
              ],
              [
                52.8193911,
                28.9573213
              ],
              [
                52.8091147,
                28.9767615
              ],
              [
                52.8068913,
                28.982043
              ],
              [
                52.8063347,
                28.9845395
              ],
              [
                52.8049446,
                28.9903797
              ],
              [
                52.8043914,
                28.9995458
              ],
              [
                52.8016113,
                29.0023219
              ],
              [
                52.800778,
                29.0026012
              ],
              [
                52.7996681,
                29.0037099
              ],
              [
                52.7993914,
                29.0042686
              ],
              [
                52.7991114,
                29.0051068
              ],
              [
                52.7988348,
                29.0053773
              ],
              [
                52.7988347,
                29.0056566
              ],
              [
                52.7980014,
                29.007324
              ],
              [
                52.7977249,
                29.0084327
              ],
              [
                52.7918915,
                29.0184371
              ],
              [
                52.7913349,
                29.0195457
              ],
              [
                52.782445,
                29.0276035
              ],
              [
                52.7780018,
                29.0328762
              ],
              [
                52.7671652,
                29.0437101
              ],
              [
                52.7671652,
                29.0439896
              ],
              [
                52.766612,
                29.044269
              ],
              [
                52.766612,
                29.0453776
              ],
              [
                52.7660552,
                29.0464863
              ],
              [
                52.7629986,
                29.0520475
              ],
              [
                52.7624453,
                29.0531561
              ],
              [
                52.7621653,
                29.0534356
              ],
              [
                52.7618887,
                29.0542648
              ],
              [
                52.7399422,
                29.0784392
              ],
              [
                52.7174426,
                29.0939878
              ],
              [
                52.7071627,
                29.1042636
              ],
              [
                52.6846632,
                29.1189923
              ],
              [
                52.6827198,
                29.1195512
              ],
              [
                52.6824399,
                29.1198306
              ],
              [
                52.6810532,
                29.1212188
              ],
              [
                52.6810532,
                29.1214892
              ],
              [
                52.6815669,
                29.122706
              ],
              [
                52.675529,
                29.1270863
              ],
              [
                52.6702808,
                29.1321174
              ],
              [
                52.6666116,
                29.1362876
              ],
              [
                52.661569,
                29.1425662
              ],
              [
                52.656033,
                29.1457896
              ],
              [
                52.6504456,
                29.1495494
              ],
              [
                52.641609,
                29.153228
              ],
              [
                52.6294339,
                29.1541414
              ],
              [
                52.6224175,
                29.1553906
              ],
              [
                52.6194644,
                29.1564698
              ],
              [
                52.5939577,
                29.1638007
              ],
              [
                52.5902645,
                29.1649438
              ],
              [
                52.5635482,
                29.1789914
              ],
              [
                52.5624349,
                29.1798298
              ],
              [
                52.5596583,
                29.181218
              ],
              [
                52.5088223,
                29.2162132
              ],
              [
                52.5049323,
                29.2212165
              ],
              [
                52.4999325,
                29.2256608
              ],
              [
                52.4929893,
                29.2303847
              ],
              [
                52.4924325,
                29.2306642
              ],
              [
                52.4612884,
                29.2555765
              ],
              [
                52.455391,
                29.257475
              ],
              [
                52.4490739,
                29.2591525
              ],
              [
                52.4448583,
                29.2469671
              ],
              [
                52.4423165,
                29.2380002
              ],
              [
                52.4375997,
                29.2282031
              ],
              [
                52.4331234,
                29.2191055
              ],
              [
                52.4247837,
                29.2075032
              ],
              [
                52.416093,
                29.1969051
              ],
              [
                52.4105786,
                29.1961525
              ],
              [
                52.4044431,
                29.1940604
              ],
              [
                52.3885196,
                29.1928313
              ],
              [
                52.381878,
                29.1925092
              ],
              [
                52.371312,
                29.1922793
              ],
              [
                52.3575045,
                29.1934594
              ],
              [
                52.3510211,
                29.1949052
              ],
              [
                52.3408728,
                29.196009
              ],
              [
                52.3307091,
                29.1965897
              ],
              [
                52.3292148,
                29.19738
              ],
              [
                52.3247438,
                29.1996519
              ],
              [
                52.3183123,
                29.2040319
              ],
              [
                52.3093809,
                29.2120568
              ],
              [
                52.2992792,
                29.2205396
              ],
              [
                52.28346,
                29.2324918
              ],
              [
                52.2751788,
                29.2365694
              ],
              [
                52.2600177,
                29.241841
              ],
              [
                52.2552829,
                29.2417864
              ],
              [
                52.2495571,
                29.2414868
              ],
              [
                52.2443222,
                29.2413157
              ],
              [
                52.2416587,
                29.2408461
              ],
              [
                52.2361213,
                29.2399647
              ],
              [
                52.2299187,
                29.2384496
              ],
              [
                52.222402,
                29.2365425
              ],
              [
                52.2147131,
                29.2336463
              ],
              [
                52.2085193,
                29.2303268
              ],
              [
                52.1950057,
                29.2300675
              ],
              [
                52.1854019,
                29.2218115
              ],
              [
                52.1828401,
                29.2134443
              ],
              [
                52.181493,
                29.2125445
              ],
              [
                52.178663,
                29.210751
              ],
              [
                52.1752739,
                29.208917
              ],
              [
                52.1724994,
                29.2075154
              ],
              [
                52.1687652,
                29.2057931
              ],
              [
                52.1635974,
                29.2046522
              ],
              [
                52.160474,
                29.2042213
              ],
              [
                52.1547889,
                29.2032863
              ],
              [
                52.1486957,
                29.2023498
              ],
              [
                52.1444076,
                29.2019363
              ],
              [
                52.1427574,
                29.2019737
              ],
              [
                52.1307514,
                29.1812177
              ],
              [
                52.117695,
                29.1667765
              ],
              [
                52.1168615,
                29.1662176
              ],
              [
                52.1160284,
                29.166488
              ],
              [
                52.114915,
                29.1667765
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555158,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قیر و کارزین",
          "name:en": "Qir and Karzin County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270561",
          "wikipedia": "en:Qir and Karzin County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.444374,
                28.2520294
              ],
              [
                52.4449306,
                28.2536953
              ],
              [
                52.4502106,
                28.2559196
              ],
              [
                52.4549305,
                28.2559196
              ],
              [
                52.4577104,
                28.254803
              ],
              [
                52.4599305,
                28.2528668
              ],
              [
                52.4746536,
                28.2470316
              ],
              [
                52.4827102,
                28.2445282
              ],
              [
                52.4999331,
                28.2378644
              ],
              [
                52.5140996,
                28.2364777
              ],
              [
                52.5352127,
                28.2314709
              ],
              [
                52.583272,
                28.2125879
              ],
              [
                52.5854919,
                28.2111922
              ],
              [
                52.6049383,
                28.2020255
              ],
              [
                52.6271613,
                28.1884197
              ],
              [
                52.6279945,
                28.1881406
              ],
              [
                52.6302179,
                28.1867449
              ],
              [
                52.6385511,
                28.1789741
              ],
              [
                52.6677173,
                28.163694
              ],
              [
                52.6685506,
                28.1631447
              ],
              [
                52.6757738,
                28.1598042
              ],
              [
                52.7146665,
                28.1395273
              ],
              [
                52.7735557,
                28.1064659
              ],
              [
                52.7816122,
                28.1003617
              ],
              [
                52.7841122,
                28.0989661
              ],
              [
                52.7874455,
                28.0964721
              ],
              [
                52.8321715,
                28.0731358
              ],
              [
                52.838558,
                28.0709211
              ],
              [
                52.841058,
                28.0698047
              ],
              [
                52.8832839,
                28.0564714
              ],
              [
                52.8913406,
                28.0542477
              ],
              [
                52.9010604,
                28.0523031
              ],
              [
                52.9035638,
                28.0514658
              ],
              [
                52.9591195,
                28.0411937
              ],
              [
                52.9638427,
                28.0411937
              ],
              [
                52.9793992,
                28.0436965
              ],
              [
                52.9866224,
                28.045632
              ],
              [
                52.9885657,
                28.0459112
              ],
              [
                52.9993988,
                28.0492512
              ],
              [
                53.0280118,
                28.0661946
              ],
              [
                53.0285684,
                28.0667528
              ],
              [
                53.0294018,
                28.0670229
              ],
              [
                53.0302351,
                28.0678601
              ],
              [
                53.0313451,
                28.0681393
              ],
              [
                53.031345,
                28.0684184
              ],
              [
                53.0319018,
                28.0689675
              ],
              [
                53.0324549,
                28.0706331
              ],
              [
                53.0324549,
                28.0753597
              ],
              [
                53.0321784,
                28.0759179
              ],
              [
                53.0319017,
                28.0778536
              ],
              [
                53.0316216,
                28.0800863
              ],
              [
                53.031345,
                28.0820221
              ],
              [
                53.0313451,
                28.0853532
              ],
              [
                53.0316216,
                28.0864696
              ],
              [
                53.0355116,
                28.090359
              ],
              [
                53.0399582,
                28.0898009
              ],
              [
                53.0421781,
                28.0909172
              ],
              [
                53.0482914,
                28.1050795
              ],
              [
                53.0502347,
                28.1173062
              ],
              [
                53.0488447,
                28.1214659
              ],
              [
                53.0480115,
                28.1228615
              ],
              [
                53.0480114,
                28.1234197
              ],
              [
                53.0474581,
                28.1236989
              ],
              [
                53.047178,
                28.1248063
              ],
              [
                53.0427348,
                28.1303616
              ],
              [
                53.0432916,
                28.1325855
              ],
              [
                53.0441249,
                28.1339721
              ],
              [
                53.052178,
                28.1417514
              ],
              [
                53.0530148,
                28.1423096
              ],
              [
                53.0541246,
                28.1445246
              ],
              [
                53.0546814,
                28.15008
              ],
              [
                53.054958,
                28.1503591
              ],
              [
                53.0502347,
                28.163415
              ],
              [
                53.0471779,
                28.1792534
              ],
              [
                53.0457914,
                28.1848001
              ],
              [
                53.034125,
                28.210364
              ],
              [
                53.0344016,
                28.2145332
              ],
              [
                53.0352349,
                28.2145331
              ],
              [
                53.0355175,
                28.2147026
              ],
              [
                53.0380115,
                28.2161989
              ],
              [
                53.0457915,
                28.216199
              ],
              [
                53.0466248,
                28.2164692
              ],
              [
                53.0482914,
                28.2167483
              ],
              [
                53.053848,
                28.218144
              ],
              [
                53.0549579,
                28.218144
              ],
              [
                53.0657911,
                28.2217459
              ],
              [
                53.069401,
                28.2228625
              ],
              [
                53.0791243,
                28.2275901
              ],
              [
                53.1110704,
                28.2564783
              ],
              [
                53.1255168,
                28.2661949
              ],
              [
                53.1260702,
                28.2667532
              ],
              [
                53.13885,
                28.2717511
              ],
              [
                53.1416265,
                28.2723096
              ],
              [
                53.1421832,
                28.2725887
              ],
              [
                53.1444065,
                28.2728589
              ],
              [
                53.1460732,
                28.2728588
              ],
              [
                53.1464411,
                28.2730445
              ],
              [
                53.1466265,
                28.273138
              ],
              [
                53.1488497,
                28.273138
              ],
              [
                53.1760726,
                28.2773075
              ],
              [
                53.1782959,
                28.2773075
              ],
              [
                53.1799626,
                28.2775867
              ],
              [
                53.1857959,
                28.2775867
              ],
              [
                53.1871859,
                28.2773075
              ],
              [
                53.1924625,
                28.2773075
              ],
              [
                53.1935758,
                28.2770283
              ],
              [
                53.1999623,
                28.2770284
              ],
              [
                53.2016289,
                28.2773075
              ],
              [
                53.2030189,
                28.2773076
              ],
              [
                53.2035756,
                28.2770283
              ],
              [
                53.2055189,
                28.2770284
              ],
              [
                53.2057989,
                28.2767492
              ],
              [
                53.2116322,
                28.2767491
              ],
              [
                53.2121854,
                28.2770284
              ],
              [
                53.2124655,
                28.2767492
              ],
              [
                53.2224654,
                28.2767493
              ],
              [
                53.224132,
                28.2770283
              ],
              [
                53.2271886,
                28.2770284
              ],
              [
                53.2502449,
                28.2798111
              ],
              [
                53.2546881,
                28.2800812
              ],
              [
                53.2555214,
                28.2803604
              ],
              [
                53.2588547,
                28.2803604
              ],
              [
                53.2596881,
                28.2806396
              ],
              [
                53.2633013,
                28.2806396
              ],
              [
                53.2641347,
                28.2809188
              ],
              [
                53.2710779,
                28.2809187
              ],
              [
                53.2727445,
                28.2811979
              ],
              [
                53.2785778,
                28.2811979
              ],
              [
                53.2794111,
                28.2814771
              ],
              [
                53.283301,
                28.281477
              ],
              [
                53.2866343,
                28.2820354
              ],
              [
                53.2905243,
                28.2823056
              ],
              [
                53.3083006,
                28.287862
              ],
              [
                53.3144138,
                28.2900864
              ],
              [
                53.3158005,
                28.2909239
              ],
              [
                53.3208038,
                28.2925809
              ],
              [
                53.3333036,
                28.2970297
              ],
              [
                53.3596932,
                28.303694
              ],
              [
                53.3766396,
                28.3064767
              ],
              [
                53.3958059,
                28.3073053
              ],
              [
                53.3983059,
                28.3075844
              ],
              [
                53.4058059,
                28.3075844
              ],
              [
                53.4083057,
                28.3073052
              ],
              [
                53.4152523,
                28.3073052
              ],
              [
                53.4477518,
                28.3017577
              ],
              [
                53.4660849,
                28.3017577
              ],
              [
                53.4685883,
                28.3014785
              ],
              [
                53.470808,
                28.3014785
              ],
              [
                53.4735881,
                28.3009201
              ],
              [
                53.4766414,
                28.3009202
              ],
              [
                53.478308,
                28.300641
              ],
              [
                53.4830313,
                28.300641
              ],
              [
                53.4846979,
                28.3003619
              ],
              [
                53.4871978,
                28.300641
              ],
              [
                53.4908112,
                28.300641
              ],
              [
                53.4913645,
                28.3009202
              ],
              [
                53.4915882,
                28.3013663
              ],
              [
                53.4913645,
                28.3014786
              ],
              [
                53.4896978,
                28.3039732
              ],
              [
                53.4894212,
                28.3056482
              ],
              [
                53.4896978,
                28.3136993
              ],
              [
                53.4916446,
                28.3184184
              ],
              [
                53.4916445,
                28.3189768
              ],
              [
                53.4921978,
                28.3195352
              ],
              [
                53.4921978,
                28.3203638
              ],
              [
                53.4941444,
                28.3248127
              ],
              [
                53.4949778,
                28.3264788
              ],
              [
                53.4955311,
                28.3275865
              ],
              [
                53.4958111,
                28.3292527
              ],
              [
                53.5024776,
                28.3389791
              ],
              [
                53.5085875,
                28.3475891
              ],
              [
                53.5213674,
                28.3706453
              ],
              [
                53.5235873,
                28.381201
              ],
              [
                53.5222007,
                28.383975
              ],
              [
                53.5185873,
                28.3886945
              ],
              [
                53.5177541,
                28.3889737
              ],
              [
                53.516644,
                28.3895321
              ],
              [
                53.4971976,
                28.3931438
              ],
              [
                53.4944211,
                28.3931438
              ],
              [
                53.4927544,
                28.393423
              ],
              [
                53.4888645,
                28.3934231
              ],
              [
                53.4874779,
                28.3937022
              ],
              [
                53.4827546,
                28.3937022
              ],
              [
                53.481088,
                28.3939814
              ],
              [
                53.478588,
                28.3939814
              ],
              [
                53.4691415,
                28.3950892
              ],
              [
                53.4677514,
                28.3950893
              ],
              [
                53.4671982,
                28.3953684
              ],
              [
                53.4655315,
                28.3953684
              ],
              [
                53.4194189,
                28.4042581
              ],
              [
                53.4152523,
                28.4056453
              ],
              [
                53.4052491,
                28.4081401
              ],
              [
                53.4030292,
                28.4084193
              ],
              [
                53.4019158,
                28.4089777
              ],
              [
                53.3955292,
                28.4103648
              ],
              [
                53.3946959,
                28.4103649
              ],
              [
                53.393306,
                28.4109233
              ],
              [
                53.3874728,
                28.4120311
              ],
              [
                53.3663598,
                28.4153637
              ],
              [
                53.3633031,
                28.4153636
              ],
              [
                53.3296902,
                28.4186962
              ],
              [
                53.3285803,
                28.4189754
              ],
              [
                53.3266371,
                28.4189754
              ],
              [
                53.3213571,
                28.4198131
              ],
              [
                53.3191371,
                28.4198131
              ],
              [
                53.3016341,
                28.422308
              ],
              [
                53.2924675,
                28.4231457
              ],
              [
                53.2899676,
                28.4231457
              ],
              [
                53.2888576,
                28.4234249
              ],
              [
                53.286911,
                28.4234249
              ],
              [
                53.2708013,
                28.4270367
              ],
              [
                53.2691346,
                28.427307
              ],
              [
                53.2357984,
                28.4395386
              ],
              [
                53.2349651,
                28.4395386
              ],
              [
                53.2321885,
                28.4409258
              ],
              [
                53.2316318,
                28.4414842
              ],
              [
                53.2305218,
                28.4423129
              ],
              [
                53.2205187,
                28.4464742
              ],
              [
                53.2182987,
                28.4478614
              ],
              [
                53.213852,
                28.4495367
              ],
              [
                53.2044089,
                28.4545359
              ],
              [
                53.1760726,
                28.48454
              ],
              [
                53.1716294,
                28.4884224
              ],
              [
                53.1649628,
                28.4975923
              ],
              [
                53.1303438,
                28.5297178
              ],
              [
                53.1303228,
                28.5297373
              ],
              [
                53.1296833,
                28.5303635
              ],
              [
                53.1296833,
                28.5306427
              ],
              [
                53.12607,
                28.5375972
              ],
              [
                53.1232934,
                28.5412005
              ],
              [
                53.1230168,
                28.5420382
              ],
              [
                53.1221834,
                28.542867
              ],
              [
                53.1216267,
                28.543984
              ],
              [
                53.1203462,
                28.5454502
              ],
              [
                53.1196834,
                28.5462091
              ],
              [
                53.1024604,
                28.5628658
              ],
              [
                53.0855139,
                28.5714779
              ],
              [
                53.0630143,
                28.5800902
              ],
              [
                53.0474579,
                28.5848109
              ],
              [
                53.0471778,
                28.5850901
              ],
              [
                53.0466246,
                28.5850901
              ],
              [
                53.0446778,
                28.5856486
              ],
              [
                53.0441246,
                28.5859279
              ],
              [
                53.0432913,
                28.585928
              ],
              [
                53.0369014,
                28.5884234
              ],
              [
                53.0366248,
                28.5887027
              ],
              [
                53.0355115,
                28.5887027
              ],
              [
                53.034678,
                28.5892612
              ],
              [
                53.0335681,
                28.5892612
              ],
              [
                53.0324547,
                28.5898107
              ],
              [
                53.0316214,
                28.5898107
              ],
              [
                53.0313448,
                28.59009
              ],
              [
                53.0305115,
                28.59009
              ],
              [
                53.027735,
                28.5912071
              ],
              [
                53.0241216,
                28.5917567
              ],
              [
                53.0232882,
                28.5920359
              ],
              [
                53.0221783,
                28.592036
              ],
              [
                52.9874554,
                28.604261
              ],
              [
                52.9638424,
                28.6148196
              ],
              [
                52.9635659,
                28.6150899
              ],
              [
                52.9613425,
                28.6125943
              ],
              [
                52.9613425,
                28.6120358
              ],
              [
                52.9502294,
                28.6045402
              ],
              [
                52.9241198,
                28.5898107
              ],
              [
                52.886617,
                28.5584245
              ],
              [
                52.8857837,
                28.5584245
              ],
              [
                52.8849504,
                28.5581452
              ],
              [
                52.8821705,
                28.5581452
              ],
              [
                52.8780038,
                28.5592622
              ],
              [
                52.8743939,
                28.5609288
              ],
              [
                52.8730039,
                28.5617576
              ],
              [
                52.8710605,
                28.5623161
              ],
              [
                52.8702273,
                28.5628657
              ],
              [
                52.868284,
                28.5634242
              ],
              [
                52.8385577,
                28.5762074
              ],
              [
                52.8146681,
                28.5837027
              ],
              [
                52.8130014,
                28.5845405
              ],
              [
                52.8110581,
                28.58509
              ],
              [
                52.8102248,
                28.5856486
              ],
              [
                52.7938351,
                28.592315
              ],
              [
                52.7930017,
                28.5923151
              ],
              [
                52.7924451,
                28.5925943
              ],
              [
                52.7910585,
                28.5928646
              ],
              [
                52.7813354,
                28.5903692
              ],
              [
                52.7804068,
                28.5888828
              ],
              [
                52.7799452,
                28.588144
              ],
              [
                52.7796687,
                28.5867566
              ],
              [
                52.7796688,
                28.5778649
              ],
              [
                52.7793886,
                28.5737029
              ],
              [
                52.7785553,
                28.5700905
              ],
              [
                52.777722,
                28.5611991
              ],
              [
                52.7771687,
                28.5584244
              ],
              [
                52.7710554,
                28.5339847
              ],
              [
                52.7696655,
                28.5250936
              ],
              [
                52.7696655,
                28.5159234
              ],
              [
                52.7693889,
                28.5150946
              ],
              [
                52.7685555,
                28.5112032
              ],
              [
                52.7579991,
                28.4900886
              ],
              [
                52.7568891,
                28.4889807
              ],
              [
                52.7368895,
                28.4675875
              ],
              [
                52.7357893,
                28.4675624
              ],
              [
                52.7346661,
                28.4681459
              ],
              [
                52.7274429,
                28.470641
              ],
              [
                52.7268861,
                28.4711995
              ],
              [
                52.7057766,
                28.4817564
              ],
              [
                52.671607,
                28.4950879
              ],
              [
                52.6663305,
                28.4964751
              ],
              [
                52.6124379,
                28.5131488
              ],
              [
                52.608548,
                28.5139775
              ],
              [
                52.6029947,
                28.515653
              ],
              [
                52.5721585,
                28.5220307
              ],
              [
                52.5513255,
                28.5253727
              ],
              [
                52.5396556,
                28.5284265
              ],
              [
                52.5385456,
                28.5287057
              ],
              [
                52.5354891,
                28.531201
              ],
              [
                52.5354891,
                28.5298137
              ],
              [
                52.5357691,
                28.528985
              ],
              [
                52.5354891,
                28.524535
              ],
              [
                52.5327125,
                28.5017537
              ],
              [
                52.5235461,
                28.4714787
              ],
              [
                52.5124328,
                28.4392591
              ],
              [
                52.506323,
                28.4209206
              ],
              [
                52.5057663,
                28.4170296
              ],
              [
                52.5052096,
                28.413697
              ],
              [
                52.504933,
                28.4128684
              ],
              [
                52.5046563,
                28.4100852
              ],
              [
                52.5040996,
                28.408419
              ],
              [
                52.5007664,
                28.393981
              ],
              [
                52.4999331,
                28.3881447
              ],
              [
                52.49049,
                28.3742565
              ],
              [
                52.4793767,
                28.3564779
              ],
              [
                52.4549902,
                28.2972924
              ],
              [
                52.4538205,
                28.2948049
              ],
              [
                52.4535439,
                28.2942556
              ],
              [
                52.4529872,
                28.2925805
              ],
              [
                52.4463206,
                28.2778655
              ],
              [
                52.4452073,
                28.2725884
              ],
              [
                52.4410407,
                28.2573064
              ],
              [
                52.4404874,
                28.2542536
              ],
              [
                52.440764,
                28.2539745
              ],
              [
                52.4404874,
                28.253137
              ],
              [
                52.444374,
                28.2520294
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555160,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کازرون",
          "name:ar": "مقاطعة كازرون",
          "name:en": "Kazerun County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270579",
          "wikipedia": "en:Kazerun County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.2724124,
                29.6011977
              ],
              [
                51.273085,
                29.5994327
              ],
              [
                51.2773769,
                29.5881688
              ],
              [
                51.277657,
                29.5876097
              ],
              [
                51.277657,
                29.5873392
              ],
              [
                51.2782137,
                29.5840025
              ],
              [
                51.2784904,
                29.5826138
              ],
              [
                51.2973801,
                29.5306625
              ],
              [
                51.2979369,
                29.5301125
              ],
              [
                51.3029369,
                29.5198325
              ],
              [
                51.3043233,
                29.5178848
              ],
              [
                51.3209933,
                29.4976138
              ],
              [
                51.3265465,
                29.4931682
              ],
              [
                51.3273797,
                29.4928887
              ],
              [
                51.3276597,
                29.4926092
              ],
              [
                51.329603,
                29.4915
              ],
              [
                51.3298797,
                29.490941
              ],
              [
                51.3304364,
                29.490941
              ],
              [
                51.3307129,
                29.490391
              ],
              [
                51.3519992,
                29.4734668
              ],
              [
                51.364606,
                29.4634389
              ],
              [
                51.365716,
                29.4634388
              ],
              [
                51.3668258,
                29.463998
              ],
              [
                51.3676592,
                29.4639979
              ],
              [
                51.3687724,
                29.464557
              ],
              [
                51.375439,
                29.4715001
              ],
              [
                51.3759958,
                29.4715001
              ],
              [
                51.3768291,
                29.4717796
              ],
              [
                51.379329,
                29.4717796
              ],
              [
                51.3815488,
                29.470941
              ],
              [
                51.3826624,
                29.4690024
              ],
              [
                51.3851622,
                29.4642775
              ],
              [
                51.3898822,
                29.4615002
              ],
              [
                51.3915489,
                29.4615003
              ],
              [
                51.3948854,
                29.4637185
              ],
              [
                51.3959954,
                29.4637184
              ],
              [
                51.396272,
                29.4639979
              ],
              [
                51.3973855,
                29.463998
              ],
              [
                51.3979386,
                29.4642775
              ],
              [
                51.4004387,
                29.4642775
              ],
              [
                51.4009953,
                29.4639979
              ],
              [
                51.4012721,
                29.4642775
              ],
              [
                51.4018287,
                29.463998
              ],
              [
                51.4040519,
                29.463998
              ],
              [
                51.4068286,
                29.4628889
              ],
              [
                51.4079385,
                29.4620503
              ],
              [
                51.4087719,
                29.4617798
              ],
              [
                51.4123851,
                29.4626093
              ],
              [
                51.4226617,
                29.4734388
              ],
              [
                51.4276615,
                29.475107
              ],
              [
                51.4334982,
                29.4737183
              ],
              [
                51.4359983,
                29.4737184
              ],
              [
                51.4362748,
                29.4739979
              ],
              [
                51.4373848,
                29.4737184
              ],
              [
                51.4379415,
                29.4739979
              ],
              [
                51.4421081,
                29.4739979
              ],
              [
                51.4443314,
                29.4706616
              ],
              [
                51.4440514,
                29.4695525
              ],
              [
                51.4443315,
                29.4690025
              ],
              [
                51.4459981,
                29.4664957
              ],
              [
                51.4471081,
                29.4656661
              ],
              [
                51.4482214,
                29.4656662
              ],
              [
                51.4498879,
                29.4662252
              ],
              [
                51.4515546,
                29.4664957
              ],
              [
                51.4521079,
                29.4662252
              ],
              [
                51.4529411,
                29.4662252
              ],
              [
                51.4543313,
                29.4656662
              ],
              [
                51.4573879,
                29.4620503
              ],
              [
                51.4584979,
                29.4615003
              ],
              [
                51.4593311,
                29.4615003
              ],
              [
                51.4598878,
                29.4617798
              ],
              [
                51.464331,
                29.4617798
              ],
              [
                51.4657211,
                29.4617799
              ],
              [
                51.4662745,
                29.4617798
              ],
              [
                51.4698878,
                29.4626094
              ],
              [
                51.4746109,
                29.4626094
              ],
              [
                51.4746108,
                29.462889
              ],
              [
                51.4776642,
                29.4615003
              ],
              [
                51.4787775,
                29.4615004
              ],
              [
                51.4793309,
                29.4617798
              ],
              [
                51.4812775,
                29.4617798
              ],
              [
                51.4823873,
                29.4626094
              ],
              [
                51.484054,
                29.4626094
              ],
              [
                51.4846109,
                29.4623299
              ],
              [
                51.4859974,
                29.4612208
              ],
              [
                51.4857206,
                29.4601117
              ],
              [
                51.4832208,
                29.4559458
              ],
              [
                51.4832208,
                29.4548278
              ],
              [
                51.4832209,
                29.4545573
              ],
              [
                51.4834974,
                29.4537187
              ],
              [
                51.4846109,
                29.4506619
              ],
              [
                51.4885008,
                29.4487233
              ],
              [
                51.4896108,
                29.4487234
              ],
              [
                51.4898873,
                29.4484439
              ],
              [
                51.490444,
                29.4487233
              ],
              [
                51.5023871,
                29.4526097
              ],
              [
                51.5037772,
                29.4526096
              ],
              [
                51.5043339,
                29.4528891
              ],
              [
                51.5051671,
                29.4528891
              ],
              [
                51.5054438,
                29.4531687
              ],
              [
                51.5073904,
                29.4531687
              ],
              [
                51.5076671,
                29.4528892
              ],
              [
                51.5085004,
                29.4528891
              ],
              [
                51.5118337,
                29.4512211
              ],
              [
                51.5171103,
                29.4462258
              ],
              [
                51.5173904,
                29.4451076
              ],
              [
                51.5176669,
                29.4423304
              ],
              [
                51.5179435,
                29.4420509
              ],
              [
                51.5179435,
                29.4409418
              ],
              [
                51.5193335,
                29.4398328
              ],
              [
                51.5210002,
                29.4390032
              ],
              [
                51.5221101,
                29.4390032
              ],
              [
                51.5226669,
                29.4387237
              ],
              [
                51.5237768,
                29.4387237
              ],
              [
                51.5240569,
                29.4384442
              ],
              [
                51.52989,
                29.4384442
              ],
              [
                51.5304468,
                29.4381647
              ],
              [
                51.5315568,
                29.4381647
              ],
              [
                51.53989,
                29.4339989
              ],
              [
                51.5515564,
                29.425388
              ],
              [
                51.5523899,
                29.4242699
              ],
              [
                51.5526697,
                29.4217723
              ],
              [
                51.5529465,
                29.4212223
              ],
              [
                51.5518365,
                29.4142705
              ],
              [
                51.5535031,
                29.4117729
              ],
              [
                51.5546131,
                29.4109433
              ],
              [
                51.5557232,
                29.4101048
              ],
              [
                51.557113,
                29.4098343
              ],
              [
                51.559613,
                29.4089957
              ],
              [
                51.5601697,
                29.4084458
              ],
              [
                51.5662796,
                29.4051097
              ],
              [
                51.5665597,
                29.4045506
              ],
              [
                51.567113,
                29.4042711
              ],
              [
                51.5687796,
                29.4006645
              ],
              [
                51.5696128,
                29.4006645
              ],
              [
                51.5698929,
                29.400385
              ],
              [
                51.5718361,
                29.400385
              ],
              [
                51.5743362,
                29.3959399
              ],
              [
                51.5746128,
                29.3956694
              ],
              [
                51.5746128,
                29.3951104
              ],
              [
                51.5771129,
                29.3934424
              ],
              [
                51.5776694,
                29.3937219
              ],
              [
                51.5793361,
                29.3937219
              ],
              [
                51.5796126,
                29.3934424
              ],
              [
                51.5810028,
                29.3934424
              ],
              [
                51.5810026,
                29.3931629
              ],
              [
                51.5826694,
                29.3931629
              ],
              [
                51.5860026,
                29.3920538
              ],
              [
                51.5865592,
                29.3914949
              ],
              [
                51.587116,
                29.3914949
              ],
              [
                51.5871159,
                29.3912154
              ],
              [
                51.5885026,
                29.3889973
              ],
              [
                51.5901693,
                29.3856613
              ],
              [
                51.5921288,
                29.3834844
              ],
              [
                51.5926692,
                29.3828842
              ],
              [
                51.5926692,
                29.3826047
              ],
              [
                51.6207289,
                29.3173286
              ],
              [
                51.6218389,
                29.3137222
              ],
              [
                51.6221155,
                29.3126042
              ],
              [
                51.6326721,
                29.2923281
              ],
              [
                51.6335053,
                29.2914987
              ],
              [
                51.6337821,
                29.2906602
              ],
              [
                51.6348954,
                29.2895514
              ],
              [
                51.635172,
                29.2887219
              ],
              [
                51.6629516,
                29.250659
              ],
              [
                51.6654517,
                29.247044
              ],
              [
                51.6660082,
                29.2459351
              ],
              [
                51.6668417,
                29.2451057
              ],
              [
                51.6740614,
                29.2342696
              ],
              [
                51.6760081,
                29.2323223
              ],
              [
                51.6765648,
                29.2312135
              ],
              [
                51.677118,
                29.230943
              ],
              [
                51.6812797,
                29.2302746
              ],
              [
                51.7045783,
                29.2076905
              ],
              [
                51.7052436,
                29.2034832
              ],
              [
                51.7117194,
                29.1962733
              ],
              [
                51.718923,
                29.1890381
              ],
              [
                51.7216608,
                29.1865195
              ],
              [
                51.7267236,
                29.1820903
              ],
              [
                51.7365288,
                29.1730751
              ],
              [
                51.7425094,
                29.1675985
              ],
              [
                51.7559354,
                29.1532336
              ],
              [
                51.7677718,
                29.1417916
              ],
              [
                51.7806936,
                29.1272821
              ],
              [
                51.7908628,
                29.1178485
              ],
              [
                51.8016333,
                29.1065415
              ],
              [
                51.8078013,
                29.1003362
              ],
              [
                51.8117356,
                29.0962112
              ],
              [
                51.817156,
                29.0906805
              ],
              [
                51.8250243,
                29.098801
              ],
              [
                51.8285409,
                29.1021971
              ],
              [
                51.8354594,
                29.1051013
              ],
              [
                51.8365691,
                29.1067689
              ],
              [
                51.8532389,
                29.122327
              ],
              [
                51.8957382,
                29.1514879
              ],
              [
                51.8960183,
                29.1517673
              ],
              [
                51.8985182,
                29.1531555
              ],
              [
                51.898795,
                29.153435
              ],
              [
                51.9226845,
                29.1714909
              ],
              [
                51.923241,
                29.1714909
              ],
              [
                51.9235179,
                29.1717703
              ],
              [
                51.9251845,
                29.1726087
              ],
              [
                51.9287979,
                29.1742674
              ],
              [
                51.9596306,
                29.1834442
              ],
              [
                51.9607439,
                29.1834443
              ],
              [
                51.9621306,
                29.1839941
              ],
              [
                51.9704638,
                29.1853824
              ],
              [
                51.9799103,
                29.1862117
              ],
              [
                51.9813003,
                29.1864911
              ],
              [
                51.9832436,
                29.1864911
              ],
              [
                51.9843535,
                29.1867707
              ],
              [
                51.9882436,
                29.1867707
              ],
              [
                51.9890769,
                29.1870501
              ],
              [
                51.9999408,
                29.1870501
              ],
              [
                52.0013001,
                29.1867706
              ],
              [
                52.0018567,
                29.1870501
              ],
              [
                52.0032432,
                29.1867707
              ],
              [
                52.0076898,
                29.1867707
              ],
              [
                52.0082432,
                29.1864911
              ],
              [
                52.0096332,
                29.1864912
              ],
              [
                52.0149133,
                29.1862117
              ],
              [
                52.0174131,
                29.1862117
              ],
              [
                52.0207464,
                29.1856619
              ],
              [
                52.0221331,
                29.1856619
              ],
              [
                52.0560259,
                29.1784412
              ],
              [
                52.112695,
                29.1673264
              ],
              [
                52.1135283,
                29.1673263
              ],
              [
                52.1140817,
                29.1670469
              ],
              [
                52.114915,
                29.1667765
              ],
              [
                52.1160284,
                29.166488
              ],
              [
                52.1168615,
                29.1662176
              ],
              [
                52.117695,
                29.1667765
              ],
              [
                52.1307514,
                29.1812177
              ],
              [
                52.1427574,
                29.2019737
              ],
              [
                52.1397845,
                29.2098992
              ],
              [
                52.1316719,
                29.2240962
              ],
              [
                52.1248661,
                29.239187
              ],
              [
                52.1157112,
                29.2593578
              ],
              [
                52.0960592,
                29.2869725
              ],
              [
                52.0895362,
                29.2984315
              ],
              [
                52.0882928,
                29.3026092
              ],
              [
                52.0879385,
                29.3105412
              ],
              [
                52.0869706,
                29.3287677
              ],
              [
                52.0881724,
                29.3385253
              ],
              [
                52.0889672,
                29.3433972
              ],
              [
                52.0896344,
                29.3476737
              ],
              [
                52.0903718,
                29.3513319
              ],
              [
                52.0917631,
                29.3587976
              ],
              [
                52.0929719,
                29.3662225
              ],
              [
                52.0957484,
                29.3853912
              ],
              [
                52.096025,
                29.3889976
              ],
              [
                52.0957484,
                29.3903862
              ],
              [
                52.0954717,
                29.3937223
              ],
              [
                52.0946385,
                29.3995559
              ],
              [
                52.0943584,
                29.4012239
              ],
              [
                52.0940818,
                29.4037215
              ],
              [
                52.093525,
                29.4070486
              ],
              [
                52.090963,
                29.4134796
              ],
              [
                52.0861158,
                29.422543
              ],
              [
                52.0834618,
                29.4263632
              ],
              [
                52.0774594,
                29.4356756
              ],
              [
                52.0694944,
                29.4463714
              ],
              [
                52.0593165,
                29.4613469
              ],
              [
                52.0490033,
                29.4778968
              ],
              [
                52.0427248,
                29.491091
              ],
              [
                52.0396184,
                29.4986125
              ],
              [
                52.0359278,
                29.4995089
              ],
              [
                52.0268404,
                29.5016473
              ],
              [
                52.0262792,
                29.5026881
              ],
              [
                52.0211767,
                29.5044535
              ],
              [
                52.0001306,
                29.5120664
              ],
              [
                51.9827244,
                29.5211782
              ],
              [
                51.9732722,
                29.5265333
              ],
              [
                51.9657262,
                29.5305178
              ],
              [
                51.9598719,
                29.5337043
              ],
              [
                51.9523578,
                29.538285
              ],
              [
                51.93845,
                29.5493154
              ],
              [
                51.9311794,
                29.5632863
              ],
              [
                51.9286608,
                29.5689994
              ],
              [
                51.925603,
                29.5790705
              ],
              [
                51.921831,
                29.5878866
              ],
              [
                51.9187552,
                29.5952525
              ],
              [
                51.9285174,
                29.5898377
              ],
              [
                51.9287974,
                29.5931654
              ],
              [
                51.930464,
                29.6040051
              ],
              [
                51.9310172,
                29.6056645
              ],
              [
                51.927964,
                29.6065031
              ],
              [
                51.9274073,
                29.6067737
              ],
              [
                51.9265741,
                29.6067737
              ],
              [
                51.9132408,
                29.6098308
              ],
              [
                51.8626815,
                29.626785
              ],
              [
                51.8465719,
                29.6348294
              ],
              [
                51.8404586,
                29.6390048
              ],
              [
                51.8335154,
                29.645949
              ],
              [
                51.832402,
                29.6476084
              ],
              [
                51.817959,
                29.6640041
              ],
              [
                51.8035209,
                29.6753297
              ],
              [
                51.7559822,
                29.6490365
              ],
              [
                51.7515666,
                29.6545527
              ],
              [
                51.7476767,
                29.6609468
              ],
              [
                51.7424,
                29.6678911
              ],
              [
                51.7412867,
                29.6690003
              ],
              [
                51.7376767,
                29.6726169
              ],
              [
                51.73712,
                29.6731669
              ],
              [
                51.7354584,
                29.6745558
              ],
              [
                51.7354534,
                29.6745559
              ],
              [
                51.7349001,
                29.675115
              ],
              [
                51.7340668,
                29.6753946
              ],
              [
                51.7337868,
                29.6756651
              ],
              [
                51.7332335,
                29.6762243
              ],
              [
                51.7329535,
                29.6765038
              ],
              [
                51.7326768,
                29.6767744
              ],
              [
                51.7321201,
                29.677063
              ],
              [
                51.7318436,
                29.6773336
              ],
              [
                51.7315635,
                29.6776132
              ],
              [
                51.7310102,
                29.6778928
              ],
              [
                51.7310101,
                29.6781723
              ],
              [
                51.7304535,
                29.6787315
              ],
              [
                51.7298969,
                29.6792816
              ],
              [
                51.72962,
                29.6795612
              ],
              [
                51.7290635,
                29.6803909
              ],
              [
                51.7282303,
                29.6809501
              ],
              [
                51.7279535,
                29.6815092
              ],
              [
                51.7271202,
                29.6820593
              ],
              [
                51.7262869,
                29.6828891
              ],
              [
                51.7260103,
                29.6831687
              ],
              [
                51.7251769,
                29.6837279
              ],
              [
                51.7246202,
                29.684287
              ],
              [
                51.7243436,
                29.6845576
              ],
              [
                51.7237869,
                29.6851167
              ],
              [
                51.7232303,
                29.6853963
              ],
              [
                51.7229535,
                29.6856669
              ],
              [
                51.722677,
                29.6859464
              ],
              [
                51.7221204,
                29.6865056
              ],
              [
                51.7218436,
                29.6867761
              ],
              [
                51.7212869,
                29.6873354
              ],
              [
                51.7210103,
                29.6876149
              ],
              [
                51.720177,
                29.688174
              ],
              [
                51.7196203,
                29.6887243
              ],
              [
                51.7190636,
                29.6890038
              ],
              [
                51.7182304,
                29.689554
              ],
              [
                51.7176771,
                29.6903927
              ],
              [
                51.7171205,
                29.6906723
              ],
              [
                51.716287,
                29.6912225
              ],
              [
                51.7154538,
                29.6920612
              ],
              [
                51.715177,
                29.6923317
              ],
              [
                51.7143439,
                29.6928909
              ],
              [
                51.7135104,
                29.6934501
              ],
              [
                51.7132303,
                29.6934501
              ],
              [
                51.7123971,
                29.6940002
              ],
              [
                51.7118405,
                29.6945594
              ],
              [
                51.7115637,
                29.694839
              ],
              [
                51.7107304,
                29.6951095
              ],
              [
                51.709897,
                29.6956687
              ],
              [
                51.7096205,
                29.6959483
              ],
              [
                51.7087871,
                29.6965074
              ],
              [
                51.7079539,
                29.6970576
              ],
              [
                51.7073972,
                29.6973371
              ],
              [
                51.7068406,
                29.6978873
              ],
              [
                51.7062872,
                29.6981759
              ],
              [
                51.7054538,
                29.6987261
              ],
              [
                51.7046206,
                29.6992852
              ],
              [
                51.7037872,
                29.6998354
              ],
              [
                51.7035073,
                29.7001149
              ],
              [
                51.7026739,
                29.7003946
              ],
              [
                51.7023973,
                29.7006652
              ],
              [
                51.7018404,
                29.7012243
              ],
              [
                51.7012874,
                29.7017834
              ],
              [
                51.7010072,
                29.7020631
              ],
              [
                51.7001738,
                29.7023337
              ],
              [
                51.6996207,
                29.7028928
              ],
              [
                51.6993406,
                29.7031724
              ],
              [
                51.6987873,
                29.7037316
              ],
              [
                51.6982306,
                29.7042816
              ],
              [
                51.697674,
                29.7045612
              ],
              [
                51.6971207,
                29.7051114
              ],
              [
                51.6962874,
                29.7056706
              ],
              [
                51.6960074,
                29.7059502
              ],
              [
                51.6954541,
                29.7067799
              ],
              [
                51.6946208,
                29.7073391
              ],
              [
                51.6943407,
                29.7076187
              ],
              [
                51.6935073,
                29.7084485
              ],
              [
                51.6929507,
                29.7090076
              ],
              [
                51.6923973,
                29.7092782
              ],
              [
                51.6915641,
                29.7101169
              ],
              [
                51.6910075,
                29.7106762
              ],
              [
                51.6904508,
                29.7112262
              ],
              [
                51.6898975,
                29.7117854
              ],
              [
                51.6893408,
                29.7123356
              ],
              [
                51.6885074,
                29.7128947
              ],
              [
                51.6879508,
                29.7137245
              ],
              [
                51.6873975,
                29.7140041
              ],
              [
                51.6868408,
                29.7148338
              ],
              [
                51.6860076,
                29.715393
              ],
              [
                51.6857308,
                29.7159431
              ],
              [
                51.6848976,
                29.7165023
              ],
              [
                51.6840641,
                29.7173411
              ],
              [
                51.683784,
                29.7176116
              ],
              [
                51.6829509,
                29.7184504
              ],
              [
                51.6821174,
                29.7190006
              ],
              [
                51.6818409,
                29.7195598
              ],
              [
                51.6790642,
                29.7220581
              ],
              [
                51.6785076,
                29.7226172
              ],
              [
                51.677951,
                29.7228878
              ],
              [
                51.6773976,
                29.7237265
              ],
              [
                51.6765642,
                29.7242857
              ],
              [
                51.6762843,
                29.7248359
              ],
              [
                51.675731,
                29.7253951
              ],
              [
                51.6748976,
                29.7262248
              ],
              [
                51.6746176,
                29.7265044
              ],
              [
                51.6737843,
                29.7270636
              ],
              [
                51.6732276,
                29.7278933
              ],
              [
                51.6726743,
                29.728173
              ],
              [
                51.6721177,
                29.7287231
              ],
              [
                51.6712843,
                29.7295619
              ],
              [
                51.6710076,
                29.7298324
              ],
              [
                51.670451,
                29.7303916
              ],
              [
                51.6698944,
                29.7309508
              ],
              [
                51.6696178,
                29.7312303
              ],
              [
                51.6690609,
                29.7317805
              ],
              [
                51.6687844,
                29.7320602
              ],
              [
                51.6682277,
                29.7323398
              ],
              [
                51.6679509,
                29.7328899
              ],
              [
                51.6676743,
                29.7331695
              ],
              [
                51.6671178,
                29.7334491
              ],
              [
                51.6668412,
                29.7337287
              ],
              [
                51.6665611,
                29.7340083
              ],
              [
                51.6662843,
                29.7345585
              ],
              [
                51.6657277,
                29.734838
              ],
              [
                51.6654511,
                29.7351176
              ],
              [
                51.6651746,
                29.7356678
              ],
              [
                51.6646176,
                29.736227
              ],
              [
                51.6643411,
                29.7365066
              ],
              [
                51.6640611,
                29.7367771
              ],
              [
                51.6637844,
                29.7373363
              ],
              [
                51.663508,
                29.737616
              ],
              [
                51.6632279,
                29.7381752
              ],
              [
                51.6626745,
                29.7384457
              ],
              [
                51.6626745,
                29.7387253
              ],
              [
                51.6621179,
                29.7390049
              ],
              [
                51.6618411,
                29.7395641
              ],
              [
                51.6618411,
                29.7398346
              ],
              [
                51.6612844,
                29.7401142
              ],
              [
                51.6610078,
                29.7406734
              ],
              [
                51.6610078,
                29.7409439
              ],
              [
                51.6607278,
                29.7415032
              ],
              [
                51.6604512,
                29.7417828
              ],
              [
                51.6601745,
                29.7420624
              ],
              [
                51.6598945,
                29.7426126
              ],
              [
                51.6598945,
                29.7431717
              ],
              [
                51.6596178,
                29.7431718
              ],
              [
                51.6593412,
                29.7437219
              ],
              [
                51.6590611,
                29.744281
              ],
              [
                51.6590611,
                29.7445607
              ],
              [
                51.6587846,
                29.7448402
              ],
              [
                51.6585078,
                29.7451108
              ],
              [
                51.6585078,
                29.7451153
              ],
              [
                51.6585077,
                29.7456701
              ],
              [
                51.6582279,
                29.7459496
              ],
              [
                51.6582279,
                29.7462293
              ],
              [
                51.6579511,
                29.7465088
              ],
              [
                51.6576746,
                29.7476182
              ],
              [
                51.6573945,
                29.7487275
              ],
              [
                51.6571179,
                29.7495573
              ],
              [
                51.6565613,
                29.7509463
              ],
              [
                51.6560044,
                29.7523352
              ],
              [
                51.6554513,
                29.7528945
              ],
              [
                51.6548944,
                29.7542834
              ],
              [
                51.6546179,
                29.7553928
              ],
              [
                51.6543377,
                29.7556724
              ],
              [
                51.6540612,
                29.7565022
              ],
              [
                51.6537847,
                29.7570614
              ],
              [
                51.6537846,
                29.7573409
              ],
              [
                51.6535046,
                29.7581707
              ],
              [
                51.6535046,
                29.7587299
              ],
              [
                51.6532277,
                29.7592801
              ],
              [
                51.6532278,
                29.7601189
              ],
              [
                51.6529513,
                29.7612282
              ],
              [
                51.6529513,
                29.7617785
              ],
              [
                51.6526711,
                29.7628878
              ],
              [
                51.652118,
                29.7640062
              ],
              [
                51.652118,
                29.764836
              ],
              [
                51.6515612,
                29.7659453
              ],
              [
                51.6510046,
                29.7673434
              ],
              [
                51.6507279,
                29.7678936
              ],
              [
                51.6504514,
                29.7692825
              ],
              [
                51.6498946,
                29.7703919
              ],
              [
                51.649618,
                29.7709511
              ],
              [
                51.6490613,
                29.7717809
              ],
              [
                51.6490613,
                29.7723401
              ],
              [
                51.6485047,
                29.7734495
              ],
              [
                51.6479513,
                29.7742793
              ],
              [
                51.6476712,
                29.7748385
              ],
              [
                51.6471179,
                29.7756682
              ],
              [
                51.6465613,
                29.776507
              ],
              [
                51.6462847,
                29.7770663
              ],
              [
                51.6457281,
                29.7781757
              ],
              [
                51.6451714,
                29.7790054
              ],
              [
                51.6448946,
                29.7795647
              ],
              [
                51.644618,
                29.780674
              ],
              [
                51.6440613,
                29.7817834
              ],
              [
                51.6437847,
                29.7823336
              ],
              [
                51.643228,
                29.7834521
              ],
              [
                51.6426714,
                29.7845615
              ],
              [
                51.6423947,
                29.784841
              ],
              [
                51.642118,
                29.7859505
              ],
              [
                51.6415613,
                29.7867802
              ],
              [
                51.6412848,
                29.7873394
              ],
              [
                51.6410047,
                29.7881783
              ],
              [
                51.6404514,
                29.7887284
              ],
              [
                51.6404514,
                29.7892876
              ],
              [
                51.6398948,
                29.7901174
              ],
              [
                51.6396181,
                29.7909472
              ],
              [
                51.6393381,
                29.7912269
              ],
              [
                51.6390615,
                29.7920657
              ],
              [
                51.6387848,
                29.7928955
              ],
              [
                51.6385046,
                29.7931752
              ],
              [
                51.6382281,
                29.7940048
              ],
              [
                51.6379515,
                29.7945641
              ],
              [
                51.6376714,
                29.7953938
              ],
              [
                51.6373948,
                29.7962327
              ],
              [
                51.6371181,
                29.7965032
              ],
              [
                51.636838,
                29.7973421
              ],
              [
                51.6364822,
                29.7976441
              ],
              [
                51.6355488,
                29.7981986
              ],
              [
                51.6220733,
                29.8062047
              ],
              [
                51.5993825,
                29.8178713
              ],
              [
                51.5805581,
                29.8096068
              ],
              [
                51.5657133,
                29.805936
              ],
              [
                51.536451,
                29.7958048
              ],
              [
                51.5387982,
                29.7879222
              ],
              [
                51.538352,
                29.785371
              ],
              [
                51.5374064,
                29.779964
              ],
              [
                51.5333815,
                29.7705531
              ],
              [
                51.5291514,
                29.7672251
              ],
              [
                51.5284211,
                29.7598182
              ],
              [
                51.5195376,
                29.7551178
              ],
              [
                51.5026994,
                29.7371355
              ],
              [
                51.4760969,
                29.7429171
              ],
              [
                51.4736937,
                29.7548401
              ],
              [
                51.463394,
                29.7639305
              ],
              [
                51.4568709,
                29.7803208
              ],
              [
                51.4472578,
                29.7837476
              ],
              [
                51.4393631,
                29.7900809
              ],
              [
                51.4337744,
                29.7859503
              ],
              [
                51.4323845,
                29.7853911
              ],
              [
                51.4251611,
                29.7817833
              ],
              [
                51.418218,
                29.779835
              ],
              [
                51.4148848,
                29.7792849
              ],
              [
                51.4126613,
                29.7792848
              ],
              [
                51.4121082,
                29.7790052
              ],
              [
                51.4093281,
                29.7790052
              ],
              [
                51.4090515,
                29.7787256
              ],
              [
                51.4079382,
                29.778455
              ],
              [
                51.4065514,
                29.7778959
              ],
              [
                51.4065514,
                29.7776163
              ],
              [
                51.4059949,
                29.7776162
              ],
              [
                51.4059948,
                29.7773366
              ],
              [
                51.4034949,
                29.7762273
              ],
              [
                51.4032181,
                29.7759477
              ],
              [
                51.4018283,
                29.7751179
              ],
              [
                51.4012717,
                29.774279
              ],
              [
                51.4009949,
                29.7734492
              ],
              [
                51.3990517,
                29.7709509
              ],
              [
                51.3934951,
                29.7595594
              ],
              [
                51.3932184,
                29.7570611
              ],
              [
                51.388495,
                29.7501162
              ],
              [
                51.3873818,
                29.7492865
              ],
              [
                51.3604389,
                29.7295616
              ],
              [
                51.3596058,
                29.7295616
              ],
              [
                51.357659,
                29.7287228
              ],
              [
                51.3568257,
                29.7284522
              ],
              [
                51.3557157,
                29.7284522
              ],
              [
                51.3551994,
                29.728279
              ],
              [
                51.3548825,
                29.7281727
              ],
              [
                51.3521024,
                29.7276135
              ],
              [
                51.3493258,
                29.7276135
              ],
              [
                51.348216,
                29.7276134
              ],
              [
                51.3471025,
                29.727893
              ],
              [
                51.345716,
                29.7281727
              ],
              [
                51.3437692,
                29.7290024
              ],
              [
                51.3426593,
                29.729282
              ],
              [
                51.3404359,
                29.729282
              ],
              [
                51.338216,
                29.7273338
              ],
              [
                51.3329361,
                29.7256654
              ],
              [
                51.3248796,
                29.724556
              ],
              [
                51.3151564,
                29.7240058
              ],
              [
                51.314323,
                29.7242854
              ],
              [
                51.312103,
                29.724556
              ],
              [
                51.3112698,
                29.724556
              ],
              [
                51.3093231,
                29.7248356
              ],
              [
                51.3057132,
                29.7251151
              ],
              [
                51.3007131,
                29.7248356
              ],
              [
                51.2982133,
                29.7237262
              ],
              [
                51.2976566,
                29.7228875
              ],
              [
                51.2943234,
                29.7176113
              ],
              [
                51.2929333,
                29.703172
              ],
              [
                51.2907133,
                29.6981755
              ],
              [
                51.2873801,
                29.6948386
              ],
              [
                51.2880716,
                29.6941233
              ],
              [
                51.2970999,
                29.6865052
              ],
              [
                51.2973798,
                29.6856665
              ],
              [
                51.2979367,
                29.6851163
              ],
              [
                51.2979367,
                29.6845571
              ],
              [
                51.2993233,
                29.6790017
              ],
              [
                51.2996034,
                29.6784425
              ],
              [
                51.2965467,
                29.6584482
              ],
              [
                51.2873802,
                29.6448303
              ],
              [
                51.2848803,
                29.641782
              ],
              [
                51.2740436,
                29.6259458
              ],
              [
                51.2704338,
                29.6148353
              ],
              [
                51.2698771,
                29.6098303
              ],
              [
                51.2701572,
                29.6081709
              ],
              [
                51.2704337,
                29.6073322
              ],
              [
                51.2707103,
                29.6056639
              ],
              [
                51.2724124,
                29.6011977
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555179,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوار",
          "name:en": "Kavar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q6379115",
          "wikipedia": "en:Kavar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.4490739,
                29.2591525
              ],
              [
                52.455391,
                29.257475
              ],
              [
                52.4612884,
                29.2555765
              ],
              [
                52.4924325,
                29.2306642
              ],
              [
                52.4929893,
                29.2303847
              ],
              [
                52.4999325,
                29.2256608
              ],
              [
                52.5049323,
                29.2212165
              ],
              [
                52.5088223,
                29.2162132
              ],
              [
                52.5596583,
                29.181218
              ],
              [
                52.5624349,
                29.1798298
              ],
              [
                52.5635482,
                29.1789914
              ],
              [
                52.5902645,
                29.1649438
              ],
              [
                52.5939577,
                29.1638007
              ],
              [
                52.6194644,
                29.1564698
              ],
              [
                52.6224175,
                29.1553906
              ],
              [
                52.6294339,
                29.1541414
              ],
              [
                52.641609,
                29.153228
              ],
              [
                52.6504456,
                29.1495494
              ],
              [
                52.656033,
                29.1457896
              ],
              [
                52.661569,
                29.1425662
              ],
              [
                52.6666116,
                29.1362876
              ],
              [
                52.6702808,
                29.1321174
              ],
              [
                52.675529,
                29.1270863
              ],
              [
                52.6815669,
                29.122706
              ],
              [
                52.6810532,
                29.1214892
              ],
              [
                52.6810532,
                29.1212188
              ],
              [
                52.6824399,
                29.1198306
              ],
              [
                52.6827198,
                29.1195512
              ],
              [
                52.6846632,
                29.1189923
              ],
              [
                52.7071627,
                29.1042636
              ],
              [
                52.7174426,
                29.0939878
              ],
              [
                52.7399422,
                29.0784392
              ],
              [
                52.7618887,
                29.0542648
              ],
              [
                52.7621653,
                29.0534356
              ],
              [
                52.7624453,
                29.0531561
              ],
              [
                52.7629986,
                29.0520475
              ],
              [
                52.7660552,
                29.0464863
              ],
              [
                52.766612,
                29.0453776
              ],
              [
                52.766612,
                29.044269
              ],
              [
                52.7671652,
                29.0439896
              ],
              [
                52.7679985,
                29.0439896
              ],
              [
                52.7688318,
                29.044269
              ],
              [
                52.7716118,
                29.044269
              ],
              [
                52.7727218,
                29.0439896
              ],
              [
                52.7741119,
                29.0439895
              ],
              [
                52.783835,
                29.0414929
              ],
              [
                52.7852216,
                29.0414929
              ],
              [
                52.7857783,
                29.0412135
              ],
              [
                52.7871683,
                29.0412134
              ],
              [
                52.7907782,
                29.0403753
              ],
              [
                52.7921682,
                29.0403753
              ],
              [
                52.7927248,
                29.0400959
              ],
              [
                52.7941115,
                29.0400959
              ],
              [
                52.7971681,
                29.0395461
              ],
              [
                52.8016113,
                29.039546
              ],
              [
                52.806058,
                29.0403752
              ],
              [
                52.8199477,
                29.0470451
              ],
              [
                52.8207811,
                29.0470451
              ],
              [
                52.8218911,
                29.0476039
              ],
              [
                52.8230011,
                29.047604
              ],
              [
                52.8235577,
                29.0478834
              ],
              [
                52.824391,
                29.0478833
              ],
              [
                52.8357808,
                29.052327
              ],
              [
                52.8366142,
                29.052327
              ],
              [
                52.845224,
                29.055662
              ],
              [
                52.8460608,
                29.0556619
              ],
              [
                52.8488373,
                29.0573294
              ],
              [
                52.8513373,
                29.0581587
              ],
              [
                52.8538373,
                29.0598261
              ],
              [
                52.8555039,
                29.060385
              ],
              [
                52.8560606,
                29.0609349
              ],
              [
                52.8668937,
                29.0662168
              ],
              [
                52.8677271,
                29.067046
              ],
              [
                52.9002265,
                29.0898235
              ],
              [
                52.9271728,
                29.1114928
              ],
              [
                52.9316194,
                29.114828
              ],
              [
                52.9324528,
                29.1150984
              ],
              [
                52.9349527,
                29.116766
              ],
              [
                52.9532858,
                29.1245451
              ],
              [
                52.954119,
                29.1245451
              ],
              [
                52.9543956,
                29.1248245
              ],
              [
                52.9552289,
                29.1248246
              ],
              [
                52.9630089,
                29.1264922
              ],
              [
                52.9649522,
                29.1264922
              ],
              [
                52.9660656,
                29.1267716
              ],
              [
                52.9732854,
                29.1267716
              ],
              [
                52.9743988,
                29.1264922
              ],
              [
                52.9766187,
                29.1264922
              ],
              [
                52.996065,
                29.1234364
              ],
              [
                52.9982884,
                29.122607
              ],
              [
                53.0066217,
                29.12066
              ],
              [
                53.0093981,
                29.12066
              ],
              [
                53.0105116,
                29.1203806
              ],
              [
                53.0110648,
                29.12066
              ],
              [
                53.0116215,
                29.1203806
              ],
              [
                53.0124547,
                29.1203806
              ],
              [
                53.0130116,
                29.1201012
              ],
              [
                53.0169014,
                29.1198308
              ],
              [
                53.0182882,
                29.1198307
              ],
              [
                53.0188447,
                29.1195514
              ],
              [
                53.0194014,
                29.1198308
              ],
              [
                53.021068,
                29.1198308
              ],
              [
                53.0216214,
                29.1195513
              ],
              [
                53.0227348,
                29.1195514
              ],
              [
                53.023288,
                29.1198308
              ],
              [
                53.0266213,
                29.1201012
              ],
              [
                53.0316211,
                29.1201012
              ],
              [
                53.0319012,
                29.1203807
              ],
              [
                53.0335678,
                29.1203806
              ],
              [
                53.0360677,
                29.1217688
              ],
              [
                53.0282879,
                29.1298274
              ],
              [
                53.0280113,
                29.1303862
              ],
              [
                53.0274545,
                29.1306567
              ],
              [
                53.0263446,
                29.1317744
              ],
              [
                53.0113449,
                29.1442681
              ],
              [
                52.9735654,
                29.1737181
              ],
              [
                52.9730087,
                29.1745474
              ],
              [
                52.9635656,
                29.1809387
              ],
              [
                52.9632855,
                29.1812183
              ],
              [
                52.9624522,
                29.1820475
              ],
              [
                52.9607856,
                29.182327
              ],
              [
                52.9596756,
                29.182327
              ],
              [
                52.9593989,
                29.1826064
              ],
              [
                52.9580089,
                29.1826064
              ],
              [
                52.9574523,
                29.1828769
              ],
              [
                52.9557857,
                29.1828768
              ],
              [
                52.9513424,
                29.1837152
              ],
              [
                52.9510623,
                29.1839947
              ],
              [
                52.9505091,
                29.1839947
              ],
              [
                52.950229,
                29.1842742
              ],
              [
                52.9491191,
                29.1842741
              ],
              [
                52.9468957,
                29.1851035
              ],
              [
                52.9463425,
                29.1851035
              ],
              [
                52.9460625,
                29.1853829
              ],
              [
                52.9452291,
                29.1853829
              ],
              [
                52.9449525,
                29.1856624
              ],
              [
                52.9441192,
                29.1856624
              ],
              [
                52.9302293,
                29.1923242
              ],
              [
                52.9163395,
                29.1973274
              ],
              [
                52.915371,
                29.1980182
              ],
              [
                52.9141163,
                29.1984362
              ],
              [
                52.913563,
                29.1989951
              ],
              [
                52.9099497,
                29.2014922
              ],
              [
                52.9093963,
                29.2014922
              ],
              [
                52.8960598,
                29.2148341
              ],
              [
                52.8941165,
                29.2167723
              ],
              [
                52.8891166,
                29.222046
              ],
              [
                52.8885599,
                29.2231639
              ],
              [
                52.8805033,
                29.2306644
              ],
              [
                52.8749502,
                29.232882
              ],
              [
                52.8738368,
                29.232882
              ],
              [
                52.8721701,
                29.233441
              ],
              [
                52.8710602,
                29.2334409
              ],
              [
                52.8705035,
                29.2337204
              ],
              [
                52.8696703,
                29.2337204
              ],
              [
                52.8691169,
                29.2339999
              ],
              [
                52.8685602,
                29.2339999
              ],
              [
                52.8682836,
                29.2342704
              ],
              [
                52.8674503,
                29.2342703
              ],
              [
                52.8516139,
                29.2456654
              ],
              [
                52.8368907,
                29.262605
              ],
              [
                52.8360574,
                29.2637139
              ],
              [
                52.8355041,
                29.2645523
              ],
              [
                52.8349475,
                29.2651023
              ],
              [
                52.8330042,
                29.2670496
              ],
              [
                52.8321709,
                29.267879
              ],
              [
                52.8227243,
                29.2784361
              ],
              [
                52.7915802,
                29.3237051
              ],
              [
                52.786864,
                29.3301346
              ],
              [
                52.7842902,
                29.3342577
              ],
              [
                52.7817829,
                29.3392531
              ],
              [
                52.7760458,
                29.3459329
              ],
              [
                52.7705526,
                29.355509
              ],
              [
                52.7623557,
                29.3673657
              ],
              [
                52.7514553,
                29.3767527
              ],
              [
                52.7450707,
                29.3840927
              ],
              [
                52.7413,
                29.3872938
              ],
              [
                52.7383659,
                29.3904808
              ],
              [
                52.7331623,
                29.3951846
              ],
              [
                52.7240225,
                29.3879362
              ],
              [
                52.7164944,
                29.3847419
              ],
              [
                52.7095678,
                29.3807096
              ],
              [
                52.6967112,
                29.3742815
              ],
              [
                52.6925697,
                29.3715194
              ],
              [
                52.6784565,
                29.3654605
              ],
              [
                52.6756681,
                29.3642086
              ],
              [
                52.6677966,
                29.3621141
              ],
              [
                52.6630985,
                29.3597158
              ],
              [
                52.6599963,
                29.3584441
              ],
              [
                52.6569979,
                29.3574286
              ],
              [
                52.6531661,
                29.3560831
              ],
              [
                52.6515688,
                29.3555313
              ],
              [
                52.6505329,
                29.3554855
              ],
              [
                52.6466289,
                29.355043
              ],
              [
                52.6444097,
                29.3548597
              ],
              [
                52.6343281,
                29.3531852
              ],
              [
                52.6224535,
                29.3530729
              ],
              [
                52.6138235,
                29.3530825
              ],
              [
                52.6043655,
                29.3546051
              ],
              [
                52.5872611,
                29.3594365
              ],
              [
                52.5743007,
                29.3652712
              ],
              [
                52.5623791,
                29.3719264
              ],
              [
                52.554855,
                29.3747879
              ],
              [
                52.5488967,
                29.3763192
              ],
              [
                52.5435309,
                29.3785108
              ],
              [
                52.5367107,
                29.3820735
              ],
              [
                52.5336345,
                29.3836548
              ],
              [
                52.5284569,
                29.3883001
              ],
              [
                52.5182533,
                29.3952812
              ],
              [
                52.5144316,
                29.3981508
              ],
              [
                52.5073586,
                29.4011013
              ],
              [
                52.4984089,
                29.4066823
              ],
              [
                52.4967704,
                29.4072128
              ],
              [
                52.4964523,
                29.4049835
              ],
              [
                52.4959695,
                29.4015812
              ],
              [
                52.4956798,
                29.3955617
              ],
              [
                52.4957656,
                29.3902521
              ],
              [
                52.4956798,
                29.3848676
              ],
              [
                52.4967097,
                29.378286
              ],
              [
                52.4976539,
                29.3722276
              ],
              [
                52.4979972,
                29.3672161
              ],
              [
                52.498598,
                29.3619799
              ],
              [
                52.4963856,
                29.3531529
              ],
              [
                52.4941438,
                29.347967
              ],
              [
                52.492036,
                29.3384417
              ],
              [
                52.4884543,
                29.3309111
              ],
              [
                52.4819767,
                29.3200998
              ],
              [
                52.4717851,
                29.2989018
              ],
              [
                52.4675494,
                29.2939312
              ],
              [
                52.4598408,
                29.2786704
              ],
              [
                52.4573327,
                29.2744546
              ],
              [
                52.4538673,
                29.2672579
              ],
              [
                52.4515403,
                29.2632967
              ],
              [
                52.4490739,
                29.2591525
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555185,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لارستان",
          "name:en": "Larestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1264566"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.3538359,
                27.5244206
              ],
              [
                53.3604653,
                27.5252181
              ],
              [
                53.3701359,
                27.5244676
              ],
              [
                53.3778656,
                27.522219
              ],
              [
                53.3842779,
                27.5208998
              ],
              [
                53.3987397,
                27.5205092
              ],
              [
                53.4162997,
                27.5192332
              ],
              [
                53.4375836,
                27.5195237
              ],
              [
                53.4474837,
                27.5203072
              ],
              [
                53.4588718,
                27.520984
              ],
              [
                53.4675598,
                27.5222364
              ],
              [
                53.4687955,
                27.5184164
              ],
              [
                53.4687923,
                27.5149206
              ],
              [
                53.468145,
                27.5115122
              ],
              [
                53.4671579,
                27.5089907
              ],
              [
                53.4664641,
                27.5059883
              ],
              [
                53.4687183,
                27.498894
              ],
              [
                53.46951,
                27.4940453
              ],
              [
                53.4712314,
                27.4880198
              ],
              [
                53.4711456,
                27.4768265
              ],
              [
                53.4710168,
                27.4750751
              ],
              [
                53.4706735,
                27.4652132
              ],
              [
                53.4700211,
                27.4610494
              ],
              [
                53.4686287,
                27.4542039
              ],
              [
                53.467369,
                27.4504759
              ],
              [
                53.4650087,
                27.4459438
              ],
              [
                53.4613888,
                27.4431886
              ],
              [
                53.4568976,
                27.4385932
              ],
              [
                53.4538077,
                27.4328799
              ],
              [
                53.4518336,
                27.4262522
              ],
              [
                53.4485721,
                27.4174907
              ],
              [
                53.4437656,
                27.4094905
              ],
              [
                53.43544,
                27.3988988
              ],
              [
                53.4299922,
                27.3932068
              ],
              [
                53.4275961,
                27.3919238
              ],
              [
                53.4173555,
                27.374427
              ],
              [
                53.4160775,
                27.3712298
              ],
              [
                53.4207143,
                27.3681894
              ],
              [
                53.4408089,
                27.3589613
              ],
              [
                53.4411382,
                27.3587373
              ],
              [
                53.4424754,
                27.3575672
              ],
              [
                53.4427521,
                27.3570096
              ],
              [
                53.4444188,
                27.3559033
              ],
              [
                53.4444188,
                27.3556245
              ],
              [
                53.4460855,
                27.3545093
              ],
              [
                53.4524753,
                27.3511815
              ],
              [
                53.453032,
                27.3506239
              ],
              [
                53.4824748,
                27.3403441
              ],
              [
                53.5385906,
                27.3253428
              ],
              [
                53.539424,
                27.3247852
              ],
              [
                53.5619236,
                27.3181211
              ],
              [
                53.5672036,
                27.3164573
              ],
              [
                53.5802566,
                27.3114571
              ],
              [
                53.58109,
                27.3114571
              ],
              [
                53.5866465,
                27.3092358
              ],
              [
                53.6044263,
                27.3058993
              ],
              [
                53.6058163,
                27.3058992
              ],
              [
                53.6066496,
                27.3056204
              ],
              [
                53.6085928,
                27.3056205
              ],
              [
                53.6102595,
                27.3053416
              ],
              [
                53.6172027,
                27.3053417
              ],
              [
                53.6188692,
                27.3056205
              ],
              [
                53.6227592,
                27.3056204
              ],
              [
                53.623316,
                27.3058993
              ],
              [
                53.6330391,
                27.3058992
              ],
              [
                53.6338725,
                27.306178
              ],
              [
                53.6369257,
                27.306178
              ],
              [
                53.6413723,
                27.3067356
              ],
              [
                53.6441489,
                27.3067356
              ],
              [
                53.6449823,
                27.3070144
              ],
              [
                53.6466489,
                27.3070144
              ],
              [
                53.6480389,
                27.3072932
              ],
              [
                53.6502622,
                27.3072932
              ],
              [
                53.6533155,
                27.3078418
              ],
              [
                53.6549821,
                27.3078418
              ],
              [
                53.656372,
                27.3081205
              ],
              [
                53.6583188,
                27.3081206
              ],
              [
                53.6694285,
                27.3097843
              ],
              [
                53.6702619,
                27.3100631
              ],
              [
                53.6719285,
                27.3100631
              ],
              [
                53.6794284,
                27.3117358
              ],
              [
                53.6802616,
                27.3117358
              ],
              [
                53.6822084,
                27.3125723
              ],
              [
                53.6827617,
                27.3125722
              ],
              [
                53.6833183,
                27.312842
              ],
              [
                53.683875,
                27.3131209
              ],
              [
                53.6847084,
                27.3133996
              ],
              [
                53.6858183,
                27.3139572
              ],
              [
                53.6863749,
                27.3139572
              ],
              [
                53.6866516,
                27.314236
              ],
              [
                53.6874849,
                27.314236
              ],
              [
                53.6877616,
                27.3145148
              ],
              [
                53.6883183,
                27.3145148
              ],
              [
                53.6885948,
                27.3147936
              ],
              [
                53.6899849,
                27.3150633
              ],
              [
                53.6988748,
                27.3181211
              ],
              [
                53.6994314,
                27.3186787
              ],
              [
                53.7169311,
                27.3253429
              ],
              [
                53.7197077,
                27.3267368
              ],
              [
                53.7485973,
                27.3372863
              ],
              [
                53.7797101,
                27.3431231
              ],
              [
                53.7813768,
                27.3431232
              ],
              [
                53.7822101,
                27.3434019
              ],
              [
                53.7830434,
                27.343402
              ],
              [
                53.7833234,
                27.3436808
              ],
              [
                53.7872099,
                27.3442295
              ],
              [
                53.7877667,
                27.3445083
              ],
              [
                53.78888,
                27.3445082
              ],
              [
                53.7894333,
                27.344796
              ],
              [
                53.7905467,
                27.344796
              ],
              [
                53.7913799,
                27.3450659
              ],
              [
                53.7935999,
                27.3450658
              ],
              [
                53.7947132,
                27.3453447
              ],
              [
                53.8033231,
                27.3453446
              ],
              [
                53.8047131,
                27.3456234
              ],
              [
                53.8080464,
                27.3456235
              ],
              [
                53.808603,
                27.3459022
              ],
              [
                53.8247128,
                27.3459023
              ],
              [
                53.8252695,
                27.3456234
              ],
              [
                53.8286027,
                27.3456235
              ],
              [
                53.8291593,
                27.3453447
              ],
              [
                53.8316593,
                27.3453447
              ],
              [
                53.8341593,
                27.344796
              ],
              [
                53.8361026,
                27.344796
              ],
              [
                53.8372126,
                27.3445082
              ],
              [
                53.8377692,
                27.3445083
              ],
              [
                53.8416592,
                27.3445083
              ],
              [
                53.847769,
                27.3445082
              ],
              [
                53.8497158,
                27.3442294
              ],
              [
                53.852769,
                27.3442294
              ],
              [
                53.8672154,
                27.3425655
              ],
              [
                53.8719387,
                27.3425656
              ],
              [
                53.8727721,
                27.3422868
              ],
              [
                53.8758252,
                27.3422868
              ],
              [
                53.8819385,
                27.3414593
              ],
              [
                53.8844385,
                27.3414593
              ],
              [
                53.8861051,
                27.3411805
              ],
              [
                53.8913817,
                27.3411805
              ],
              [
                53.8924951,
                27.3414594
              ],
              [
                53.8972149,
                27.3414594
              ],
              [
                53.8983283,
                27.3417381
              ],
              [
                53.9033282,
                27.3417382
              ],
              [
                53.9047182,
                27.342008
              ],
              [
                53.9088847,
                27.342008
              ],
              [
                53.9105514,
                27.3422869
              ],
              [
                53.911938,
                27.3422868
              ],
              [
                53.9127713,
                27.3425656
              ],
              [
                53.9163846,
                27.3425656
              ],
              [
                53.9266611,
                27.3436808
              ],
              [
                53.9599973,
                27.3450659
              ],
              [
                53.960554,
                27.3453446
              ],
              [
                53.9619405,
                27.3453446
              ],
              [
                53.9630539,
                27.3456234
              ],
              [
                53.9647205,
                27.3456234
              ],
              [
                53.9652739,
                27.3453447
              ],
              [
                53.97166,
                27.3393096
              ],
              [
                53.9770269,
                27.341536
              ],
              [
                53.9773965,
                27.3417234
              ],
              [
                53.9781369,
                27.3423726
              ],
              [
                53.9781369,
                27.3426425
              ],
              [
                53.9956366,
                27.348759
              ],
              [
                53.9959166,
                27.3490378
              ],
              [
                54.0048001,
                27.3521264
              ],
              [
                54.0123063,
                27.3523659
              ],
              [
                54.0157912,
                27.3534385
              ],
              [
                54.0341517,
                27.3588473
              ],
              [
                54.0444943,
                27.3610961
              ],
              [
                54.0795132,
                27.3623158
              ],
              [
                54.1268914,
                27.3809141
              ],
              [
                54.1811364,
                27.4113959
              ],
              [
                54.1956645,
                27.4272149
              ],
              [
                54.2124109,
                27.4373194
              ],
              [
                54.2132442,
                27.4373194
              ],
              [
                54.2146308,
                27.4378772
              ],
              [
                54.2168541,
                27.438147
              ],
              [
                54.2224107,
                27.4395413
              ],
              [
                54.2343573,
                27.4417633
              ],
              [
                54.2365771,
                27.4417633
              ],
              [
                54.2472487,
                27.4433288
              ],
              [
                54.2688817,
                27.4465022
              ],
              [
                54.2876896,
                27.4492569
              ],
              [
                54.288523,
                27.4495449
              ],
              [
                54.293803,
                27.4495449
              ],
              [
                54.3054694,
                27.4478806
              ],
              [
                54.3065794,
                27.4481505
              ],
              [
                54.3107494,
                27.4481504
              ],
              [
                54.3193592,
                27.449257
              ],
              [
                54.3210258,
                27.4492569
              ],
              [
                54.3221358,
                27.4495449
              ],
              [
                54.3229691,
                27.449257
              ],
              [
                54.3235258,
                27.4489871
              ],
              [
                54.3243591,
                27.4489871
              ],
              [
                54.3249158,
                27.4487082
              ],
              [
                54.327969,
                27.4487083
              ],
              [
                54.3282491,
                27.4489871
              ],
              [
                54.3288057,
                27.4489871
              ],
              [
                54.3290824,
                27.4487082
              ],
              [
                54.3296391,
                27.4487083
              ],
              [
                54.3299157,
                27.4489871
              ],
              [
                54.3335256,
                27.4489871
              ],
              [
                54.3338058,
                27.4487083
              ],
              [
                54.3363056,
                27.4487083
              ],
              [
                54.3371389,
                27.4484294
              ],
              [
                54.3396389,
                27.4484294
              ],
              [
                54.3401922,
                27.4481504
              ],
              [
                54.3471388,
                27.4481504
              ],
              [
                54.3488055,
                27.4478806
              ],
              [
                54.349082,
                27.4475928
              ],
              [
                54.350472,
                27.4475927
              ],
              [
                54.3646385,
                27.4439853
              ],
              [
                54.3660284,
                27.4439853
              ],
              [
                54.3671384,
                27.4437065
              ],
              [
                54.3710284,
                27.4437065
              ],
              [
                54.3735283,
                27.4431487
              ],
              [
                54.3776949,
                27.4431487
              ],
              [
                54.3788048,
                27.4428788
              ],
              [
                54.3804715,
                27.4428788
              ],
              [
                54.3857515,
                27.4437065
              ],
              [
                54.3876948,
                27.4437064
              ],
              [
                54.3904747,
                27.4442641
              ],
              [
                54.3921414,
                27.4442642
              ],
              [
                54.5016386,
                27.4523156
              ],
              [
                54.5019187,
                27.4525945
              ],
              [
                54.5038619,
                27.4525945
              ],
              [
                54.5046953,
                27.4528734
              ],
              [
                54.5080285,
                27.4528734
              ],
              [
                54.5085853,
                27.4531523
              ],
              [
                54.5169184,
                27.4531523
              ],
              [
                54.5183085,
                27.4534311
              ],
              [
                54.5230283,
                27.4534311
              ],
              [
                54.5238616,
                27.45371
              ],
              [
                54.5344181,
                27.4537101
              ],
              [
                54.5349748,
                27.4534312
              ],
              [
                54.5376131,
                27.4534312
              ],
              [
                54.5880807,
                27.4656199
              ],
              [
                54.5897473,
                27.4658989
              ],
              [
                54.5961337,
                27.4658988
              ],
              [
                54.5978004,
                27.4661867
              ],
              [
                54.6039137,
                27.4661867
              ],
              [
                54.608357,
                27.4664566
              ],
              [
                54.6100236,
                27.4667355
              ],
              [
                54.611137,
                27.4667354
              ],
              [
                54.6166902,
                27.4670143
              ],
              [
                54.6180801,
                27.4672931
              ],
              [
                54.6219701,
                27.4672931
              ],
              [
                54.6233601,
                27.467572
              ],
              [
                54.62836,
                27.467572
              ],
              [
                54.6289134,
                27.4678509
              ],
              [
                54.6411365,
                27.4678509
              ],
              [
                54.6416932,
                27.467572
              ],
              [
                54.6464165,
                27.4675719
              ],
              [
                54.6469697,
                27.4672931
              ],
              [
                54.6511363,
                27.4672931
              ],
              [
                54.6544696,
                27.4667354
              ],
              [
                54.6569696,
                27.4667354
              ],
              [
                54.7187798,
                27.4741618
              ],
              [
                54.8744794,
                27.4422863
              ],
              [
                54.8780928,
                27.4422863
              ],
              [
                54.8789261,
                27.4420164
              ],
              [
                54.8806227,
                27.4316564
              ],
              [
                54.8822894,
                27.4313775
              ],
              [
                54.8850693,
                27.4313776
              ],
              [
                54.8909027,
                27.4305409
              ],
              [
                54.8934025,
                27.4305409
              ],
              [
                54.9206254,
                27.4274913
              ],
              [
                54.924792,
                27.4274913
              ],
              [
                54.9256253,
                27.4272124
              ],
              [
                54.9295153,
                27.4272125
              ],
              [
                54.945625,
                27.4255482
              ],
              [
                54.9525716,
                27.4255482
              ],
              [
                54.9810784,
                27.4266336
              ],
              [
                55.0222162,
                27.4246509
              ],
              [
                55.0266594,
                27.4246509
              ],
              [
                55.028326,
                27.424372
              ],
              [
                55.0327727,
                27.424372
              ],
              [
                55.0372159,
                27.4238234
              ],
              [
                55.0399924,
                27.4238232
              ],
              [
                55.0408257,
                27.4235443
              ],
              [
                55.0430491,
                27.4234981
              ],
              [
                55.1310954,
                27.4166623
              ],
              [
                55.1319287,
                27.4169323
              ],
              [
                55.1335953,
                27.4169322
              ],
              [
                55.1338719,
                27.4172201
              ],
              [
                55.1349852,
                27.4172201
              ],
              [
                55.1377618,
                27.4183265
              ],
              [
                55.138042,
                27.4186055
              ],
              [
                55.1383185,
                27.4188843
              ],
              [
                55.1408185,
                27.4194331
              ],
              [
                55.1433185,
                27.4205486
              ],
              [
                55.1438752,
                27.4205486
              ],
              [
                55.1438752,
                27.4208274
              ],
              [
                55.1447084,
                27.4208275
              ],
              [
                55.1463751,
                27.421664
              ],
              [
                55.1463751,
                27.421934
              ],
              [
                55.2063603,
                27.4214877
              ],
              [
                55.2291899,
                27.4170963
              ],
              [
                55.2389097,
                27.4220999
              ],
              [
                55.2433564,
                27.4243228
              ],
              [
                55.2749627,
                27.4595399
              ],
              [
                55.2871494,
                27.485323
              ],
              [
                55.2874294,
                27.4858808
              ],
              [
                55.2879827,
                27.4858809
              ],
              [
                55.2937961,
                27.5073666
              ],
              [
                55.2940682,
                27.5076412
              ],
              [
                55.319129,
                27.5401708
              ],
              [
                55.3210723,
                27.542951
              ],
              [
                55.323409,
                27.5569743
              ],
              [
                55.3267423,
                27.5600332
              ],
              [
                55.3314457,
                27.5717377
              ],
              [
                55.3368892,
                27.5786966
              ],
              [
                55.3396026,
                27.5901494
              ],
              [
                55.3437959,
                27.6017514
              ],
              [
                55.3446292,
                27.6025882
              ],
              [
                55.3521958,
                27.6232063
              ],
              [
                55.3527526,
                27.6234854
              ],
              [
                55.3749756,
                27.6395876
              ],
              [
                55.3964919,
                27.677847
              ],
              [
                55.3970485,
                27.6786745
              ],
              [
                55.3998251,
                27.6811752
              ],
              [
                55.4017718,
                27.6836757
              ],
              [
                55.4034385,
                27.6864552
              ],
              [
                55.4039917,
                27.686734
              ],
              [
                55.4410808,
                27.6993526
              ],
              [
                55.4658936,
                27.7056319
              ],
              [
                55.4675601,
                27.7095192
              ],
              [
                55.4824364,
                27.7126103
              ],
              [
                55.4916031,
                27.7231662
              ],
              [
                55.4924362,
                27.7234453
              ],
              [
                55.4985497,
                27.7298348
              ],
              [
                55.5021596,
                27.7320487
              ],
              [
                55.500063,
                27.7423018
              ],
              [
                55.5050565,
                27.7511006
              ],
              [
                55.5128364,
                27.7560948
              ],
              [
                55.5136697,
                27.7560948
              ],
              [
                55.5164463,
                27.7577596
              ],
              [
                55.5172796,
                27.7583175
              ],
              [
                55.535336,
                27.7722116
              ],
              [
                55.5408528,
                27.7735688
              ],
              [
                55.5414094,
                27.7743968
              ],
              [
                55.5419628,
                27.7746757
              ],
              [
                55.5419628,
                27.7749549
              ],
              [
                55.5430762,
                27.7766383
              ],
              [
                55.561859,
                27.7881352
              ],
              [
                55.5663022,
                27.7945249
              ],
              [
                55.5676922,
                27.7967479
              ],
              [
                55.5679689,
                27.7984128
              ],
              [
                55.5682455,
                27.7992408
              ],
              [
                55.5795118,
                27.8036866
              ],
              [
                55.6567379,
                27.8254141
              ],
              [
                55.7271191,
                27.8193414
              ],
              [
                55.7329556,
                27.8290575
              ],
              [
                55.7295224,
                27.8421122
              ],
              [
                55.7138143,
                27.85603
              ],
              [
                55.7135377,
                27.8568666
              ],
              [
                55.7163643,
                27.8618203
              ],
              [
                55.715958,
                27.8630573
              ],
              [
                55.715811,
                27.8632055
              ],
              [
                55.7104811,
                27.8704681
              ],
              [
                55.7102044,
                27.8707469
              ],
              [
                55.7102045,
                27.8710258
              ],
              [
                55.6986233,
                27.8782321
              ],
              [
                55.6937247,
                27.9040506
              ],
              [
                55.676994,
                27.9067553
              ],
              [
                55.6778216,
                27.9360845
              ],
              [
                55.6772648,
                27.9363635
              ],
              [
                55.6767116,
                27.937191
              ],
              [
                55.6852337,
                27.9449767
              ],
              [
                55.6887477,
                27.9568424
              ],
              [
                55.6840244,
                27.9646142
              ],
              [
                55.6812479,
                27.967106
              ],
              [
                55.6790245,
                27.9693369
              ],
              [
                55.6252026,
                27.9818086
              ],
              [
                55.6246459,
                27.9820876
              ],
              [
                55.6246459,
                27.9823664
              ],
              [
                55.5791467,
                27.9950083
              ],
              [
                55.5241023,
                27.9904218
              ],
              [
                55.4805131,
                27.9811548
              ],
              [
                55.4652368,
                27.98921
              ],
              [
                55.4624568,
                27.9908661
              ],
              [
                55.427734,
                28.0069857
              ],
              [
                55.402188,
                28.0090513
              ],
              [
                55.397188,
                28.0109955
              ],
              [
                55.3949647,
                28.0129396
              ],
              [
                55.3815553,
                28.0270741
              ],
              [
                55.3818353,
                28.0292978
              ],
              [
                55.3818353,
                28.0297743
              ],
              [
                55.3798887,
                28.030405
              ],
              [
                55.3793353,
                28.030405
              ],
              [
                55.3737787,
                28.0320795
              ],
              [
                55.3726688,
                28.0320794
              ],
              [
                55.3728353,
                28.0306425
              ],
              [
                55.3697786,
                28.0311917
              ],
              [
                55.3167228,
                28.0434082
              ],
              [
                55.3167228,
                28.0436963
              ],
              [
                55.3153328,
                28.0439665
              ],
              [
                55.3150562,
                28.0442455
              ],
              [
                55.3144995,
                28.0442456
              ],
              [
                55.2761634,
                28.0600815
              ],
              [
                55.2750535,
                28.0609098
              ],
              [
                55.2736635,
                28.0611978
              ],
              [
                55.2731102,
                28.061747
              ],
              [
                55.2717202,
                28.0623052
              ],
              [
                55.2506072,
                28.0742522
              ],
              [
                55.2492205,
                28.0750805
              ],
              [
                55.2489405,
                28.0753595
              ],
              [
                55.2258842,
                28.0845248
              ],
              [
                55.2231076,
                28.0853531
              ],
              [
                55.2219943,
                28.0853531
              ],
              [
                55.2208843,
                28.0859204
              ],
              [
                55.2194943,
                28.0859203
              ],
              [
                55.2100511,
                28.0884142
              ],
              [
                55.2086612,
                28.0884142
              ],
              [
                55.2075512,
                28.0886933
              ],
              [
                55.2058845,
                28.0886933
              ],
              [
                55.2047746,
                28.0889724
              ],
              [
                55.1892181,
                28.0889724
              ],
              [
                55.1881048,
                28.0886933
              ],
              [
                55.1867182,
                28.0886933
              ],
              [
                55.1856049,
                28.0884142
              ],
              [
                55.1842149,
                28.0884142
              ],
              [
                55.1831049,
                28.0881351
              ],
              [
                55.1739383,
                28.0881351
              ],
              [
                55.1731051,
                28.0884142
              ],
              [
                55.1714384,
                28.0884142
              ],
              [
                55.1625486,
                28.0909171
              ],
              [
                55.1614386,
                28.0911872
              ],
              [
                55.1567153,
                28.0925827
              ],
              [
                55.1556054,
                28.0925827
              ],
              [
                55.1442155,
                28.0953557
              ],
              [
                55.1428256,
                28.0953557
              ],
              [
                55.1422689,
                28.0956349
              ],
              [
                55.1392156,
                28.0956349
              ],
              [
                55.1381022,
                28.095914
              ],
              [
                55.1353256,
                28.095914
              ],
              [
                55.1339356,
                28.0961931
              ],
              [
                55.131159,
                28.0961932
              ],
              [
                55.1306024,
                28.0964722
              ],
              [
                55.1275457,
                28.0964722
              ],
              [
                55.1264359,
                28.0967513
              ],
              [
                55.1183792,
                28.0967513
              ],
              [
                55.117826,
                28.0964722
              ],
              [
                55.1175459,
                28.0967513
              ],
              [
                55.1172693,
                28.0964722
              ],
              [
                55.1161593,
                28.0964722
              ],
              [
                55.0883798,
                28.0889724
              ],
              [
                55.0819899,
                28.0861905
              ],
              [
                55.0814332,
                28.0859204
              ],
              [
                55.0808798,
                28.0853531
              ],
              [
                55.0797665,
                28.084804
              ],
              [
                55.0672667,
                28.076188
              ],
              [
                55.0528202,
                28.0692466
              ],
              [
                55.051987,
                28.0692466
              ],
              [
                55.0517103,
                28.0689675
              ],
              [
                55.0508769,
                28.0689675
              ],
              [
                55.047267,
                28.0681392
              ],
              [
                55.0397671,
                28.0681392
              ],
              [
                55.0386538,
                28.0684183
              ],
              [
                55.0367105,
                28.0684183
              ],
              [
                55.0344872,
                28.0689675
              ],
              [
                55.0325439,
                28.0689675
              ],
              [
                55.0200442,
                28.0720286
              ],
              [
                55.0192108,
                28.0725867
              ],
              [
                55.0130975,
                28.0745224
              ],
              [
                55.0125408,
                28.0745224
              ],
              [
                55.0044877,
                28.0770253
              ],
              [
                55.0033743,
                28.0770253
              ],
              [
                54.9736515,
                28.0839757
              ],
              [
                54.9505952,
                28.0867487
              ],
              [
                54.9472619,
                28.0867487
              ],
              [
                54.9461519,
                28.0870278
              ],
              [
                54.9389287,
                28.0870278
              ],
              [
                54.9378154,
                28.0867487
              ],
              [
                54.9333722,
                28.0867487
              ],
              [
                54.9325388,
                28.0864696
              ],
              [
                54.9300389,
                28.0864696
              ],
              [
                54.9292056,
                28.0861905
              ],
              [
                54.9267056,
                28.0861905
              ],
              [
                54.9261488,
                28.0859204
              ],
              [
                54.9242057,
                28.0859204
              ],
              [
                54.9236489,
                28.0856413
              ],
              [
                54.922539,
                28.0856413
              ],
              [
                54.9208722,
                28.0853532
              ],
              [
                54.920039,
                28.0850831
              ],
              [
                54.9183723,
                28.0850831
              ],
              [
                54.917539,
                28.084804
              ],
              [
                54.9164258,
                28.0848041
              ],
              [
                54.9158724,
                28.0845249
              ],
              [
                54.9144825,
                28.0845249
              ],
              [
                54.9075392,
                28.0828593
              ],
              [
                54.9053159,
                28.0828594
              ],
              [
                54.9044826,
                28.0825802
              ],
              [
                54.9017026,
                28.0825802
              ],
              [
                54.901426,
                28.0823012
              ],
              [
                54.8983693,
                28.0823012
              ],
              [
                54.8980927,
                28.0820221
              ],
              [
                54.8944827,
                28.081752
              ],
              [
                54.8825362,
                28.0817519
              ],
              [
                54.8822596,
                28.0814729
              ],
              [
                54.8812863,
                28.0814729
              ],
              [
                54.8811462,
                28.0811938
              ],
              [
                54.8814263,
                28.0809147
              ],
              [
                54.8814263,
                28.0803564
              ],
              [
                54.8814263,
                28.0800863
              ],
              [
                54.8969827,
                28.0323082
              ],
              [
                54.8972593,
                28.0314709
              ],
              [
                54.8975359,
                28.0311919
              ],
              [
                54.8978161,
                28.0298055
              ],
              [
                54.8983692,
                28.0286892
              ],
              [
                54.9042059,
                28.009523
              ],
              [
                54.9042074,
                28.0095182
              ],
              [
                54.9069808,
                28.0001009
              ],
              [
                54.9058725,
                27.9964697
              ],
              [
                54.9052759,
                27.996031
              ],
              [
                54.9047592,
                27.9956325
              ],
              [
                54.8869828,
                27.9873056
              ],
              [
                54.881703,
                27.9856312
              ],
              [
                54.8425335,
                27.9778536
              ],
              [
                54.8408668,
                27.9775835
              ],
              [
                54.8244771,
                27.9709131
              ],
              [
                54.8236437,
                27.9709131
              ],
              [
                54.8233671,
                27.970634
              ],
              [
                54.8142006,
                27.9675824
              ],
              [
                54.812534,
                27.9675824
              ],
              [
                54.8119772,
                27.9673034
              ],
              [
                54.806144,
                27.9673034
              ],
              [
                54.8058675,
                27.9670244
              ],
              [
                54.7983675,
                27.9670243
              ],
              [
                54.7980875,
                27.9673034
              ],
              [
                54.7961442,
                27.9673034
              ],
              [
                54.7955876,
                27.9675824
              ],
              [
                54.7905876,
                27.9686897
              ],
              [
                54.789201,
                27.9686897
              ],
              [
                54.7886443,
                27.9689687
              ],
              [
                54.7866977,
                27.9689687
              ],
              [
                54.7861443,
                27.9686896
              ],
              [
                54.7858643,
                27.9689687
              ],
              [
                54.7844778,
                27.9686897
              ],
              [
                54.7841977,
                27.9689687
              ],
              [
                54.782531,
                27.9689688
              ],
              [
                54.7819778,
                27.9686897
              ],
              [
                54.7775312,
                27.9686896
              ],
              [
                54.7766978,
                27.9689687
              ],
              [
                54.7733645,
                27.9689687
              ],
              [
                54.7728112,
                27.9692478
              ],
              [
                54.7708646,
                27.9692478
              ],
              [
                54.770588,
                27.9695269
              ],
              [
                54.7697546,
                27.9695268
              ],
              [
                54.7694746,
                27.9698058
              ],
              [
                54.7650313,
                27.9709132
              ],
              [
                54.762808,
                27.9717503
              ],
              [
                54.7614214,
                27.9717503
              ],
              [
                54.7605881,
                27.9720204
              ],
              [
                54.748365,
                27.9717503
              ],
              [
                54.7480849,
                27.9714622
              ],
              [
                54.7441984,
                27.9709131
              ],
              [
                54.7330852,
                27.9709132
              ],
              [
                54.7319753,
                27.9706341
              ],
              [
                54.7275285,
                27.9706341
              ],
              [
                54.7264186,
                27.970355
              ],
              [
                54.7225287,
                27.970076
              ],
              [
                54.7216954,
                27.970076
              ],
              [
                54.7191954,
                27.9695269
              ],
              [
                54.7175288,
                27.9695269
              ],
              [
                54.7164188,
                27.9692478
              ],
              [
                54.7130856,
                27.9692478
              ],
              [
                54.7119722,
                27.9689687
              ],
              [
                54.7105855,
                27.9689688
              ],
              [
                54.7094722,
                27.9686897
              ],
              [
                54.7066955,
                27.9686897
              ],
              [
                54.7055856,
                27.9684106
              ],
              [
                54.7044722,
                27.9686897
              ],
              [
                54.7030857,
                27.9684107
              ],
              [
                54.7016958,
                27.9686897
              ],
              [
                54.7005857,
                27.9684106
              ],
              [
                54.6955858,
                27.9684107
              ],
              [
                54.6947491,
                27.9681316
              ],
              [
                54.6925292,
                27.9681316
              ],
              [
                54.6914158,
                27.9678526
              ],
              [
                54.6583596,
                27.9639728
              ],
              [
                54.6553031,
                27.9639728
              ],
              [
                54.6541931,
                27.9636847
              ],
              [
                54.6450266,
                27.9625775
              ],
              [
                54.6419699,
                27.9625775
              ],
              [
                54.64086,
                27.9622984
              ],
              [
                54.63947,
                27.9622985
              ],
              [
                54.6380799,
                27.9620284
              ],
              [
                54.63447,
                27.9617494
              ],
              [
                54.6333601,
                27.9617494
              ],
              [
                54.6328035,
                27.9614703
              ],
              [
                54.6311368,
                27.9614703
              ],
              [
                54.6305802,
                27.9611912
              ],
              [
                54.6286368,
                27.9611912
              ],
              [
                54.6280801,
                27.9609122
              ],
              [
                54.6130804,
                27.9573025
              ],
              [
                54.6116903,
                27.9573025
              ],
              [
                54.6094705,
                27.9567444
              ],
              [
                54.6028039,
                27.9559162
              ],
              [
                54.6005806,
                27.9559163
              ],
              [
                54.5997473,
                27.9556372
              ],
              [
                54.5961339,
                27.9556372
              ],
              [
                54.5955807,
                27.9553582
              ],
              [
                54.5930807,
                27.9553582
              ],
              [
                54.5922475,
                27.9550791
              ],
              [
                54.5908574,
                27.9550791
              ],
              [
                54.590024,
                27.9548001
              ],
              [
                54.5886341,
                27.9548001
              ],
              [
                54.5875241,
                27.954521
              ],
              [
                54.5761342,
                27.954521
              ],
              [
                54.5589112,
                27.9573026
              ],
              [
                54.5566879,
                27.9578606
              ],
              [
                54.5547446,
                27.9581307
              ],
              [
                54.5508547,
                27.9592469
              ],
              [
                54.549188,
                27.9592469
              ],
              [
                54.5486348,
                27.9595259
              ],
              [
                54.539745,
                27.959526
              ],
              [
                54.5391883,
                27.9598049
              ],
              [
                54.5383549,
                27.959805
              ],
              [
                54.5375216,
                27.9606421
              ],
              [
                54.537245,
                27.9609122
              ],
              [
                54.5364116,
                27.9609122
              ],
              [
                54.5250218,
                27.9636848
              ],
              [
                54.511132,
                27.9636848
              ],
              [
                54.4847425,
                27.9689688
              ],
              [
                54.4822425,
                27.9689688
              ],
              [
                54.4816859,
                27.9692478
              ],
              [
                54.4794624,
                27.9692479
              ],
              [
                54.4789092,
                27.9695269
              ],
              [
                54.4758525,
                27.9695269
              ],
              [
                54.4608527,
                27.9714623
              ],
              [
                54.4580728,
                27.9714623
              ],
              [
                54.4555729,
                27.9720205
              ],
              [
                54.4541862,
                27.9720205
              ],
              [
                54.4511297,
                27.9725785
              ],
              [
                54.4505729,
                27.9725785
              ],
              [
                54.4280733,
                27.979249
              ],
              [
                54.4216834,
                27.9828587
              ],
              [
                54.4100169,
                27.9914647
              ],
              [
                54.3947371,
                27.9998007
              ],
              [
                54.3939039,
                28.0003588
              ],
              [
                54.3661243,
                28.0225766
              ],
              [
                54.3650143,
                28.0231348
              ],
              [
                54.3639044,
                28.024242
              ],
              [
                54.3505678,
                28.0325784
              ],
              [
                54.3500146,
                28.0328574
              ],
              [
                54.3493195,
                28.033276
              ],
              [
                54.3461246,
                28.0350811
              ],
              [
                54.3452913,
                28.0356302
              ],
              [
                54.3355213,
                28.0415674
              ],
              [
                54.3297348,
                28.0450831
              ],
              [
                54.3283448,
                28.0464695
              ],
              [
                54.2953396,
                28.0687653
              ],
              [
                54.2863988,
                28.0748016
              ],
              [
                54.2855655,
                28.0750808
              ],
              [
                54.2255632,
                28.1178556
              ],
              [
                54.2252865,
                28.1181347
              ],
              [
                54.2247298,
                28.1181348
              ],
              [
                54.2241765,
                28.1181348
              ],
              [
                54.2238965,
                28.1184138
              ],
              [
                54.2230631,
                28.1184139
              ],
              [
                54.2227865,
                28.118693
              ],
              [
                54.2200065,
                28.118693
              ],
              [
                54.2197299,
                28.1189721
              ],
              [
                54.2180632,
                28.1189721
              ],
              [
                54.2175066,
                28.118693
              ],
              [
                54.2016735,
                28.118693
              ],
              [
                54.2013969,
                28.1189721
              ],
              [
                54.1997302,
                28.1189721
              ],
              [
                54.1988969,
                28.1192512
              ],
              [
                54.1972303,
                28.1192512
              ],
              [
                54.1894504,
                28.1211959
              ],
              [
                54.1694506,
                28.1250856
              ],
              [
                54.1675074,
                28.1250856
              ],
              [
                54.1666741,
                28.1253647
              ],
              [
                54.1655607,
                28.1253647
              ],
              [
                54.1641707,
                28.1253647
              ],
              [
                54.163894,
                28.1256348
              ],
              [
                54.1608374,
                28.1256348
              ],
              [
                54.1602842,
                28.1259139
              ],
              [
                54.1575042,
                28.1259139
              ],
              [
                54.1569509,
                28.126193
              ],
              [
                54.1525043,
                28.1261931
              ],
              [
                54.151951,
                28.1259139
              ],
              [
                54.1463944,
                28.1259139
              ],
              [
                54.1447277,
                28.1264722
              ],
              [
                54.1433378,
                28.1264722
              ],
              [
                54.1430611,
                28.1267512
              ],
              [
                54.1425044,
                28.1267512
              ],
              [
                54.1377811,
                28.1281379
              ],
              [
                54.130838,
                28.1281378
              ],
              [
                54.1302813,
                28.1278588
              ],
              [
                54.128338,
                28.1278587
              ],
              [
                54.1194481,
                28.1234199
              ],
              [
                54.1147248,
                28.1170273
              ],
              [
                54.1141716,
                28.1159199
              ],
              [
                54.1041683,
                28.1084109
              ],
              [
                54.103335,
                28.108411
              ],
              [
                54.1030584,
                28.1081408
              ],
              [
                54.1013918,
                28.1081408
              ],
              [
                54.1011151,
                28.108411
              ],
              [
                54.099725,
                28.108411
              ],
              [
                54.0983351,
                28.1089692
              ],
              [
                54.0972252,
                28.1089692
              ],
              [
                54.0969484,
                28.1092482
              ],
              [
                54.0963918,
                28.1092483
              ],
              [
                54.086112,
                28.1134169
              ],
              [
                54.0852786,
                28.113417
              ],
              [
                54.0847253,
                28.113696
              ],
              [
                54.0772254,
                28.113696
              ],
              [
                54.0697222,
                28.1153617
              ],
              [
                54.0677789,
                28.1153617
              ],
              [
                54.0672222,
                28.1156408
              ],
              [
                54.0650023,
                28.1156408
              ],
              [
                54.0644457,
                28.1159198
              ],
              [
                54.0566691,
                28.1170273
              ],
              [
                54.0538891,
                28.1178557
              ],
              [
                54.0524991,
                28.1181348
              ],
              [
                54.0513892,
                28.1181348
              ],
              [
                54.0474992,
                28.1189721
              ],
              [
                54.0461126,
                28.1189721
              ],
              [
                54.0387998,
                28.1209169
              ],
              [
                54.0387127,
                28.1220838
              ],
              [
                54.0333986,
                28.1931744
              ],
              [
                53.975075,
                28.1931848
              ],
              [
                53.9284731,
                28.1885158
              ],
              [
                53.903454,
                28.1865711
              ],
              [
                53.891655,
                28.1862628
              ],
              [
                53.8841646,
                28.1716642
              ],
              [
                53.8707731,
                28.1649407
              ],
              [
                53.8534353,
                28.1702373
              ],
              [
                53.8395421,
                28.1708675
              ],
              [
                53.809995,
                28.1730903
              ],
              [
                53.7605665,
                28.1755336
              ],
              [
                53.7490652,
                28.175685
              ],
              [
                53.7166106,
                28.1781209
              ],
              [
                53.689828,
                28.1835106
              ],
              [
                53.6626123,
                28.189763
              ],
              [
                53.6630956,
                28.1658384
              ],
              [
                53.6572559,
                28.1499929
              ],
              [
                53.6501582,
                28.141012
              ],
              [
                53.6297149,
                28.1337975
              ],
              [
                53.6131094,
                28.1278571
              ],
              [
                53.5834604,
                28.1200243
              ],
              [
                53.6088222,
                28.0985738
              ],
              [
                53.6229419,
                28.0797077
              ],
              [
                53.6322076,
                28.061784
              ],
              [
                53.6397169,
                28.0404708
              ],
              [
                53.6441413,
                28.0211399
              ],
              [
                53.6492654,
                28.0205717
              ],
              [
                53.6594357,
                28.0198054
              ],
              [
                53.6704393,
                28.0188961
              ],
              [
                53.6841516,
                28.0156357
              ],
              [
                53.6880415,
                28.0156358
              ],
              [
                53.6897082,
                28.0153566
              ],
              [
                53.693318,
                28.0153567
              ],
              [
                53.6949847,
                28.0150776
              ],
              [
                53.697208,
                28.0150776
              ],
              [
                53.6985981,
                28.0148075
              ],
              [
                53.7030412,
                28.0148075
              ],
              [
                53.7044313,
                28.0145284
              ],
              [
                53.7066513,
                28.0145284
              ],
              [
                53.7083178,
                28.0142494
              ],
              [
                53.7102645,
                28.0142493
              ],
              [
                53.7119312,
                28.0139703
              ],
              [
                53.7152644,
                28.0139702
              ],
              [
                53.7160977,
                28.0136912
              ],
              [
                53.7172077,
                28.0136912
              ],
              [
                53.7185976,
                28.0134121
              ],
              [
                53.7222076,
                28.0134121
              ],
              [
                53.7233209,
                28.013133
              ],
              [
                53.7249875,
                28.013133
              ],
              [
                53.7260976,
                28.012854
              ],
              [
                53.7319308,
                28.0123048
              ],
              [
                53.7330442,
                28.012584
              ],
              [
                53.7422106,
                28.012854
              ],
              [
                53.743044,
                28.0125839
              ],
              [
                53.7466539,
                28.012584
              ],
              [
                53.7469305,
                28.0123048
              ],
              [
                53.7477639,
                28.0125839
              ],
              [
                53.7516538,
                28.0125839
              ],
              [
                53.7524872,
                28.0125839
              ],
              [
                53.7538772,
                28.012584
              ],
              [
                53.7547104,
                28.0123049
              ],
              [
                53.7580437,
                28.0123048
              ],
              [
                53.7588771,
                28.0120257
              ],
              [
                53.760267,
                28.0120258
              ],
              [
                53.7613771,
                28.0117467
              ],
              [
                53.762767,
                28.0117467
              ],
              [
                53.7636003,
                28.0114676
              ],
              [
                53.7672102,
                28.0114676
              ],
              [
                53.7674869,
                28.0111885
              ],
              [
                53.8014166,
                28.0067014
              ],
              [
                53.8052663,
                28.0061923
              ],
              [
                53.8074897,
                28.0061922
              ],
              [
                53.8097129,
                28.0056341
              ],
              [
                53.8111029,
                28.0056342
              ],
              [
                53.8119363,
                28.0053551
              ],
              [
                53.8186028,
                28.0045269
              ],
              [
                53.8274927,
                28.0045269
              ],
              [
                53.828326,
                28.0042478
              ],
              [
                53.8319358,
                28.0042478
              ],
              [
                53.8330459,
                28.0042478
              ],
              [
                53.8336026,
                28.0045269
              ],
              [
                53.8408258,
                28.0045269
              ],
              [
                53.8416591,
                28.0048059
              ],
              [
                53.8486023,
                28.004806
              ],
              [
                53.8497157,
                28.005085
              ],
              [
                53.8513823,
                28.005085
              ],
              [
                53.8541589,
                28.0056341
              ],
              [
                53.8558255,
                28.0056341
              ],
              [
                53.8583255,
                28.0061923
              ],
              [
                53.8605489,
                28.0061923
              ],
              [
                53.860644,
                28.0062403
              ],
              [
                53.861102,
                28.0064713
              ],
              [
                53.8624922,
                28.0064713
              ],
              [
                53.8636021,
                28.0067504
              ],
              [
                53.865272,
                28.0067504
              ],
              [
                53.867492,
                28.0073086
              ],
              [
                53.8691586,
                28.0073086
              ],
              [
                53.870272,
                28.0075786
              ],
              [
                53.8722152,
                28.0075786
              ],
              [
                53.8819385,
                28.009244
              ],
              [
                53.8836052,
                28.009244
              ],
              [
                53.8855484,
                28.0098022
              ],
              [
                53.8880484,
                28.0098022
              ],
              [
                53.8883284,
                28.0100813
              ],
              [
                53.8905483,
                28.0100813
              ],
              [
                53.8916617,
                28.0103603
              ],
              [
                53.8930483,
                28.0103603
              ],
              [
                53.8938817,
                28.0106304
              ],
              [
                53.8952716,
                28.0106304
              ],
              [
                53.9019382,
                28.0123049
              ],
              [
                53.9033282,
                28.0123048
              ],
              [
                53.9036048,
                28.012584
              ],
              [
                53.9049948,
                28.0125839
              ],
              [
                53.9052714,
                28.012854
              ],
              [
                53.9061047,
                28.012854
              ],
              [
                53.9069381,
                28.0131331
              ],
              [
                53.9074948,
                28.0131331
              ],
              [
                53.9077714,
                28.0134122
              ],
              [
                53.9111046,
                28.0134121
              ],
              [
                53.9113847,
                28.013133
              ],
              [
                53.911938,
                28.0131331
              ],
              [
                53.9150935,
                28.0137415
              ],
              [
                53.915828,
                28.0136912
              ],
              [
                53.9161045,
                28.0139703
              ],
              [
                53.9172179,
                28.0139703
              ],
              [
                53.9174946,
                28.0142493
              ],
              [
                53.9208279,
                28.0142494
              ],
              [
                53.9211079,
                28.0139704
              ],
              [
                53.9241612,
                28.0139703
              ],
              [
                53.9247178,
                28.0136912
              ],
              [
                53.9274944,
                28.0136912
              ],
              [
                53.9277744,
                28.0134122
              ],
              [
                53.9322177,
                28.0134121
              ],
              [
                53.9327744,
                28.0131331
              ],
              [
                53.9336077,
                28.0131331
              ],
              [
                53.9338843,
                28.012854
              ],
              [
                53.9422175,
                28.0103604
              ],
              [
                53.9555506,
                27.9981353
              ],
              [
                53.9558307,
                27.9978562
              ],
              [
                53.9624972,
                27.9936882
              ],
              [
                53.9661071,
                27.9903575
              ],
              [
                53.9872202,
                27.9798072
              ],
              [
                53.9883301,
                27.9798071
              ],
              [
                53.9888867,
                27.9795281
              ],
              [
                53.9899968,
                27.9795281
              ],
              [
                53.9902768,
                27.9792489
              ],
              [
                53.9998721,
                27.9733219
              ],
              [
                54.0111098,
                27.9667454
              ],
              [
                54.0203796,
                27.961096
              ],
              [
                54.0402794,
                27.9489671
              ],
              [
                54.0427793,
                27.9478509
              ],
              [
                54.043056,
                27.9475808
              ],
              [
                54.0436126,
                27.9475808
              ],
              [
                54.0480559,
                27.9456365
              ],
              [
                54.0488892,
                27.9456365
              ],
              [
                54.0530558,
                27.9448084
              ],
              [
                54.0547224,
                27.9448083
              ],
              [
                54.0550025,
                27.9445203
              ],
              [
                54.0561124,
                27.9445203
              ],
              [
                54.0566691,
                27.9442503
              ],
              [
                54.0577791,
                27.9442503
              ],
              [
                54.0580557,
                27.9439712
              ],
              [
                54.0591691,
                27.9439712
              ],
              [
                54.0594457,
                27.9436922
              ],
              [
                54.060279,
                27.9436921
              ],
              [
                54.0608357,
                27.9434131
              ],
              [
                54.0619456,
                27.9434131
              ],
              [
                54.0622223,
                27.9431341
              ],
              [
                54.0630557,
                27.9431341
              ],
              [
                54.0636123,
                27.9428551
              ],
              [
                54.0652789,
                27.942855
              ],
              [
                54.0658356,
                27.9425759
              ],
              [
                54.0666689,
                27.942576
              ],
              [
                54.0672222,
                27.9422969
              ],
              [
                54.0827786,
                27.9384083
              ],
              [
                54.0836119,
                27.9378592
              ],
              [
                54.0922252,
                27.9345287
              ],
              [
                54.100835,
                27.9295239
              ],
              [
                54.1038916,
                27.9278586
              ],
              [
                54.1550042,
                27.8975789
              ],
              [
                54.1572275,
                27.8964717
              ],
              [
                54.1750073,
                27.8875789
              ],
              [
                54.1750072,
                27.8872999
              ],
              [
                54.1752839,
                27.8870208
              ],
              [
                54.1755605,
                27.8864628
              ],
              [
                54.1763938,
                27.8811884
              ],
              [
                54.1761172,
                27.8759049
              ],
              [
                54.1752839,
                27.8689654
              ],
              [
                54.1755605,
                27.8667423
              ],
              [
                54.1758405,
                27.8584079
              ],
              [
                54.1755605,
                27.8578588
              ],
              [
                54.1758406,
                27.8573008
              ],
              [
                54.1761172,
                27.8495244
              ],
              [
                54.1744506,
                27.834242
              ],
              [
                54.1738938,
                27.8314609
              ],
              [
                54.1736173,
                27.8300749
              ],
              [
                54.1725073,
                27.8236849
              ],
              [
                54.1722272,
                27.8211918
              ],
              [
                54.1719506,
                27.8189599
              ],
              [
                54.1591707,
                27.7872986
              ],
              [
                54.158728,
                27.7864055
              ],
              [
                54.1587279,
                27.7864053
              ],
              [
                54.1587279,
                27.7864052
              ],
              [
                54.158728,
                27.7864052
              ],
              [
                54.1587315,
                27.7864041
              ],
              [
                54.1761811,
                27.7811643
              ],
              [
                54.2410103,
                27.7616699
              ],
              [
                54.2444528,
                27.7606335
              ],
              [
                54.2441758,
                27.7592476
              ],
              [
                54.2441757,
                27.7592474
              ],
              [
                54.2441756,
                27.7592464
              ],
              [
                54.2441755,
                27.7592463
              ],
              [
                54.2436191,
                27.7564668
              ],
              [
                54.2436191,
                27.7564667
              ],
              [
                54.2433424,
                27.7548018
              ],
              [
                54.2407204,
                27.7448356
              ],
              [
                54.2407201,
                27.7448342
              ],
              [
                54.2391758,
                27.7389636
              ],
              [
                54.2391758,
                27.7389634
              ],
              [
                54.2386253,
                27.7367465
              ],
              [
                54.2386189,
                27.7367156
              ],
              [
                54.238476,
                27.7360216
              ],
              [
                54.2384759,
                27.7360214
              ],
              [
                54.2383429,
                27.7353551
              ],
              [
                54.2380625,
                27.7342481
              ],
              [
                54.2377858,
                27.7325742
              ],
              [
                54.2330695,
                27.7189615
              ],
              [
                54.2325168,
                27.7184124
              ],
              [
                54.2313771,
                27.7154639
              ],
              [
                54.2311196,
                27.7147928
              ],
              [
                54.231103,
                27.7147764
              ],
              [
                54.2311028,
                27.7147762
              ],
              [
                54.2311021,
                27.7147755
              ],
              [
                54.2311018,
                27.7147753
              ],
              [
                54.2311011,
                27.7147746
              ],
              [
                54.230563,
                27.7142439
              ],
              [
                54.2303671,
                27.7138153
              ],
              [
                54.2274654,
                27.7074519
              ],
              [
                54.2274648,
                27.7074506
              ],
              [
                54.2262113,
                27.7047043
              ],
              [
                54.2261272,
                27.7045192
              ],
              [
                54.2258431,
                27.7034097
              ],
              [
                54.2250171,
                27.701189
              ],
              [
                54.2248342,
                27.7004944
              ],
              [
                54.2247294,
                27.70008
              ],
              [
                54.2226959,
                27.694791
              ],
              [
                54.2191732,
                27.6856288
              ],
              [
                54.2174761,
                27.6827136
              ],
              [
                54.2172298,
                27.6822905
              ],
              [
                54.2103019,
                27.6651028
              ],
              [
                54.2102182,
                27.6649399
              ],
              [
                54.2100138,
                27.6645181
              ],
              [
                54.2055634,
                27.6511842
              ],
              [
                54.2033458,
                27.6464595
              ],
              [
                54.2033458,
                27.6456317
              ],
              [
                54.2004662,
                27.6385609
              ],
              [
                54.2004661,
                27.6385607
              ],
              [
                54.1972341,
                27.6306238
              ],
              [
                54.1970555,
                27.6295871
              ],
              [
                54.1970471,
                27.6295385
              ],
              [
                54.1970378,
                27.6294831
              ],
              [
                54.1969498,
                27.62896
              ],
              [
                54.1969355,
                27.6289314
              ],
              [
                54.1961165,
                27.6272952
              ],
              [
                54.1911235,
                27.6089611
              ],
              [
                54.1905879,
                27.6068077
              ],
              [
                54.1869609,
                27.5946737
              ],
              [
                54.185007,
                27.5881303
              ],
              [
                54.1848901,
                27.5880095
              ],
              [
                54.1847339,
                27.5878505
              ],
              [
                54.1844949,
                27.5871505
              ],
              [
                54.1844504,
                27.5870147
              ],
              [
                54.1840874,
                27.586649
              ],
              [
                54.1836177,
                27.5861874
              ],
              [
                54.1836176,
                27.5861873
              ],
              [
                54.1836172,
                27.5861869
              ],
              [
                54.1836169,
                27.5861869
              ],
              [
                54.1829392,
                27.5861869
              ],
              [
                54.1816737,
                27.5861869
              ],
              [
                54.1808463,
                27.586458
              ],
              [
                54.1786171,
                27.5864568
              ],
              [
                54.1777838,
                27.5867357
              ],
              [
                54.1761172,
                27.5867358
              ],
              [
                54.1750073,
                27.5870147
              ],
              [
                54.1736172,
                27.5870146
              ],
              [
                54.1433378,
                27.5939604
              ],
              [
                54.1397287,
                27.5950773
              ],
              [
                54.096675,
                27.6072939
              ],
              [
                54.0955639,
                27.6072942
              ],
              [
                54.0955625,
                27.6072942
              ],
              [
                54.0955589,
                27.6072942
              ],
              [
                54.0955585,
                27.6072942
              ],
              [
                54.0797301,
                27.6095179
              ],
              [
                54.0755588,
                27.6106232
              ],
              [
                54.0744455,
                27.6106232
              ],
              [
                54.0652789,
                27.6131335
              ],
              [
                54.064169,
                27.6131335
              ],
              [
                54.0524997,
                27.6167412
              ],
              [
                54.0441659,
                27.6203494
              ],
              [
                54.0411127,
                27.6220139
              ],
              [
                54.040556,
                27.6220139
              ],
              [
                54.0397292,
                27.6225718
              ],
              [
                54.0297271,
                27.6253527
              ],
              [
                54.0283385,
                27.6253527
              ],
              [
                54.0261146,
                27.625902
              ],
              [
                54.0241729,
                27.625902
              ],
              [
                54.0235187,
                27.6261245
              ],
              [
                54.0233375,
                27.6261881
              ],
              [
                54.0233348,
                27.6261881
              ],
              [
                54.0233342,
                27.6261881
              ],
              [
                54.023334,
                27.6261881
              ],
              [
                54.0233327,
                27.6261881
              ],
              [
                54.0127822,
                27.6261881
              ],
              [
                54.0102698,
                27.6257757
              ],
              [
                54.0102659,
                27.625775
              ],
              [
                54.0068745,
                27.6252182
              ],
              [
                54.0068743,
                27.6252182
              ],
              [
                54.0068734,
                27.625218
              ],
              [
                54.006549,
                27.6251648
              ],
              [
                54.0065486,
                27.6251647
              ],
              [
                54.0062322,
                27.6251127
              ],
              [
                53.9998656,
                27.6240671
              ],
              [
                53.9955697,
                27.6245161
              ],
              [
                53.9938918,
                27.6245173
              ],
              [
                53.9930602,
                27.6247957
              ],
              [
                53.9919501,
                27.6247957
              ],
              [
                53.9919461,
                27.6247941
              ],
              [
                53.9919457,
                27.6247939
              ],
              [
                53.9919456,
                27.6247939
              ],
              [
                53.9830581,
                27.621187
              ],
              [
                53.9821688,
                27.6188711
              ],
              [
                53.9816695,
                27.6175707
              ],
              [
                53.9816689,
                27.6175701
              ],
              [
                53.9788924,
                27.6147898
              ],
              [
                53.9744001,
                27.6132936
              ],
              [
                53.9743965,
                27.6132924
              ],
              [
                53.9688871,
                27.61146
              ],
              [
                53.9683304,
                27.6114599
              ],
              [
                53.9677738,
                27.6111778
              ],
              [
                53.9677737,
                27.6111778
              ],
              [
                53.9677734,
                27.6111776
              ],
              [
                53.9672218,
                27.6109028
              ],
              [
                53.9672217,
                27.6109028
              ],
              [
                53.9672214,
                27.6109026
              ],
              [
                53.9672205,
                27.6109021
              ],
              [
                53.9663906,
                27.6109021
              ],
              [
                53.9663904,
                27.610902
              ],
              [
                53.9663903,
                27.6109019
              ],
              [
                53.9658347,
                27.6106241
              ],
              [
                53.9658325,
                27.6106241
              ],
              [
                53.9658323,
                27.6106241
              ],
              [
                53.9658322,
                27.6106241
              ],
              [
                53.9647246,
                27.6106241
              ],
              [
                53.9647229,
                27.6106233
              ],
              [
                53.9647226,
                27.6106231
              ],
              [
                53.9647225,
                27.6106231
              ],
              [
                53.9639297,
                27.6102333
              ],
              [
                53.9639255,
                27.6102313
              ],
              [
                53.9636134,
                27.6100774
              ],
              [
                53.9636075,
                27.6100745
              ],
              [
                53.9635065,
                27.6100509
              ],
              [
                53.9618546,
                27.6096666
              ],
              [
                53.9618502,
                27.6096656
              ],
              [
                53.9397231,
                27.604513
              ],
              [
                53.9374942,
                27.6036863
              ],
              [
                53.9130514,
                27.5992417
              ],
              [
                53.9112888,
                27.5992071
              ],
              [
                53.8842327,
                27.598673
              ],
              [
                53.8842277,
                27.5986729
              ],
              [
                53.8288308,
                27.5975598
              ],
              [
                53.8288288,
                27.5975598
              ],
              [
                53.8155462,
                27.5972893
              ],
              [
                53.7818023,
                27.5774832
              ],
              [
                53.7817982,
                27.5774838
              ],
              [
                53.7817981,
                27.5774838
              ],
              [
                53.781798,
                27.5774838
              ],
              [
                53.6984947,
                27.5887211
              ],
              [
                53.6984946,
                27.5887211
              ],
              [
                53.6984944,
                27.5887211
              ],
              [
                53.6984906,
                27.5887216
              ],
              [
                53.6318735,
                27.5584916
              ],
              [
                53.6978779,
                27.5301876
              ],
              [
                53.6978783,
                27.5301863
              ],
              [
                53.7005175,
                27.5219698
              ],
              [
                53.7256742,
                27.4434149
              ],
              [
                53.7266534,
                27.4403553
              ],
              [
                53.7266535,
                27.4403552
              ],
              [
                53.7266543,
                27.4403525
              ],
              [
                53.7266541,
                27.4403525
              ],
              [
                53.7266528,
                27.4403525
              ],
              [
                53.7260305,
                27.4403523
              ],
              [
                53.7260304,
                27.4403523
              ],
              [
                53.7260256,
                27.4403523
              ],
              [
                53.7260254,
                27.4403523
              ],
              [
                53.725826,
                27.4403524
              ],
              [
                53.725825,
                27.4403524
              ],
              [
                53.725821,
                27.4403524
              ],
              [
                53.7237909,
                27.440798
              ],
              [
                53.7233228,
                27.4409008
              ],
              [
                53.7228017,
                27.4410422
              ],
              [
                53.7199787,
                27.4418093
              ],
              [
                53.7199745,
                27.4418104
              ],
              [
                53.7064324,
                27.4480082
              ],
              [
                53.6893261,
                27.4528583
              ],
              [
                53.6782562,
                27.4559455
              ],
              [
                53.6541455,
                27.4721041
              ],
              [
                53.6332432,
                27.4870443
              ],
              [
                53.6162278,
                27.4982029
              ],
              [
                53.6065005,
                27.5012676
              ],
              [
                53.6010932,
                27.5094134
              ],
              [
                53.5943984,
                27.5148182
              ],
              [
                53.5759448,
                27.5311072
              ],
              [
                53.5757732,
                27.5285194
              ],
              [
                53.5732841,
                27.5256271
              ],
              [
                53.5660743,
                27.5257793
              ],
              [
                53.5605812,
                27.5279105
              ],
              [
                53.5584783,
                27.5300036
              ],
              [
                53.5499381,
                27.5301178
              ],
              [
                53.5430717,
                27.5306506
              ],
              [
                53.5338878,
                27.5308789
              ],
              [
                53.5235023,
                27.5342277
              ],
              [
                53.510456,
                27.5370437
              ],
              [
                53.5095333,
                27.540849
              ],
              [
                53.5095564,
                27.5441748
              ],
              [
                53.5085566,
                27.5459209
              ],
              [
                53.5077094,
                27.5598735
              ],
              [
                53.4998988,
                27.5609388
              ],
              [
                53.4939948,
                27.5636165
              ],
              [
                53.4734713,
                27.5729182
              ],
              [
                53.4681844,
                27.5748624
              ],
              [
                53.4630722,
                27.5763314
              ],
              [
                53.4590005,
                27.5760417
              ],
              [
                53.4504175,
                27.5770307
              ],
              [
                53.4429111,
                27.5781704
              ],
              [
                53.4329509,
                27.5780197
              ],
              [
                53.4272484,
                27.5806243
              ],
              [
                53.3900254,
                27.5911731
              ],
              [
                53.3714103,
                27.5935768
              ],
              [
                53.3654967,
                27.5941518
              ],
              [
                53.3621692,
                27.5905006
              ],
              [
                53.3612823,
                27.5818236
              ],
              [
                53.3622693,
                27.5706019
              ],
              [
                53.3661317,
                27.5616996
              ],
              [
                53.3672475,
                27.5587321
              ],
              [
                53.3656948,
                27.5561036
              ],
              [
                53.3642005,
                27.5493724
              ],
              [
                53.3598231,
                27.5368154
              ],
              [
                53.3538359,
                27.5244206
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555187,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لامرد",
          "name:en": "Lamerd County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270499",
          "wikipedia": "en:Lamerd County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.6255647,
                27.8964812
              ],
              [
                52.6141956,
                27.8807826
              ],
              [
                52.6283299,
                27.874756
              ],
              [
                52.651382,
                27.8648509
              ],
              [
                52.6511759,
                27.8599212
              ],
              [
                52.6511451,
                27.8479013
              ],
              [
                52.6512728,
                27.8312891
              ],
              [
                52.6507387,
                27.8189595
              ],
              [
                52.6507994,
                27.8111167
              ],
              [
                52.6504943,
                27.8025798
              ],
              [
                52.6506028,
                27.7898744
              ],
              [
                52.6500628,
                27.7796482
              ],
              [
                52.649902,
                27.7695154
              ],
              [
                52.6631355,
                27.7695703
              ],
              [
                52.6802539,
                27.7671452
              ],
              [
                52.686123,
                27.7659441
              ],
              [
                52.6913574,
                27.7627543
              ],
              [
                52.6981114,
                27.7604945
              ],
              [
                52.7114026,
                27.7535545
              ],
              [
                52.7190971,
                27.7499366
              ],
              [
                52.7479996,
                27.7297934
              ],
              [
                52.7784934,
                27.706417
              ],
              [
                52.7922248,
                27.6958403
              ],
              [
                52.8030395,
                27.6881644
              ],
              [
                52.8088934,
                27.6830588
              ],
              [
                52.8247101,
                27.670586
              ],
              [
                52.8336557,
                27.6643269
              ],
              [
                52.8383982,
                27.6608348
              ],
              [
                52.8448014,
                27.6559078
              ],
              [
                52.8735045,
                27.6331084
              ],
              [
                52.8845755,
                27.6254062
              ],
              [
                52.8872553,
                27.6235394
              ],
              [
                52.8972344,
                27.6166061
              ],
              [
                52.903706,
                27.6121903
              ],
              [
                52.9079522,
                27.6091822
              ],
              [
                52.9105321,
                27.6076569
              ],
              [
                52.9173306,
                27.6027384
              ],
              [
                52.9218681,
                27.5999277
              ],
              [
                52.9422374,
                27.5879181
              ],
              [
                52.9727704,
                27.5717414
              ],
              [
                52.987691,
                27.566923
              ],
              [
                52.9952792,
                27.5637141
              ],
              [
                53.0004901,
                27.5594146
              ],
              [
                53.0134105,
                27.5609387
              ],
              [
                53.0354735,
                27.5497806
              ],
              [
                53.0551222,
                27.5399931
              ],
              [
                53.0767667,
                27.5292197
              ],
              [
                53.087268,
                27.5231283
              ],
              [
                53.0937342,
                27.5186104
              ],
              [
                53.1171722,
                27.5034513
              ],
              [
                53.1247671,
                27.4987062
              ],
              [
                53.1397175,
                27.4968656
              ],
              [
                53.2013777,
                27.4904471
              ],
              [
                53.1881409,
                27.4819189
              ],
              [
                53.1795412,
                27.4738987
              ],
              [
                53.1736665,
                27.4643547
              ],
              [
                53.1715526,
                27.45484
              ],
              [
                53.1695177,
                27.4472244
              ],
              [
                53.1703014,
                27.4415864
              ],
              [
                53.1710528,
                27.4390845
              ],
              [
                53.1691896,
                27.4278878
              ],
              [
                53.1661438,
                27.4222759
              ],
              [
                53.1592038,
                27.4165432
              ],
              [
                53.1526863,
                27.4134802
              ],
              [
                53.146745,
                27.412313
              ],
              [
                53.1400751,
                27.4120342
              ],
              [
                53.1326294,
                27.4133311
              ],
              [
                53.1269762,
                27.4163131
              ],
              [
                53.1212539,
                27.4183337
              ],
              [
                53.1110072,
                27.4230401
              ],
              [
                53.101486,
                27.427372
              ],
              [
                53.0969237,
                27.430366
              ],
              [
                53.0912589,
                27.4328799
              ],
              [
                53.0802083,
                27.4391229
              ],
              [
                53.0754268,
                27.4347305
              ],
              [
                53.0715568,
                27.4299333
              ],
              [
                53.0685336,
                27.4240931
              ],
              [
                53.0660038,
                27.4188376
              ],
              [
                53.0643511,
                27.4153763
              ],
              [
                53.0632567,
                27.4137573
              ],
              [
                53.0617332,
                27.4086523
              ],
              [
                53.0561328,
                27.400118
              ],
              [
                53.048644,
                27.3915831
              ],
              [
                53.0450606,
                27.3882299
              ],
              [
                53.0415201,
                27.3844384
              ],
              [
                53.0320573,
                27.3764548
              ],
              [
                53.0280447,
                27.3719388
              ],
              [
                53.0215001,
                27.3627347
              ],
              [
                53.019247,
                27.3569794
              ],
              [
                53.0161786,
                27.3456585
              ],
              [
                53.0146336,
                27.3414652
              ],
              [
                53.0124866,
                27.3362573
              ],
              [
                53.0141884,
                27.3353133
              ],
              [
                53.0161142,
                27.3308671
              ],
              [
                53.0186482,
                27.3243704
              ],
              [
                53.0373722,
                27.3150031
              ],
              [
                53.0393314,
                27.3144342
              ],
              [
                53.0435371,
                27.3106211
              ],
              [
                53.0571841,
                27.3064265
              ],
              [
                53.0732345,
                27.3039859
              ],
              [
                53.0835353,
                27.2984124
              ],
              [
                53.1088982,
                27.2850877
              ],
              [
                53.1128706,
                27.2837146
              ],
              [
                53.134122,
                27.2781929
              ],
              [
                53.1377792,
                27.2774415
              ],
              [
                53.1434717,
                27.2771015
              ],
              [
                53.1542191,
                27.2666585
              ],
              [
                53.1688986,
                27.2662566
              ],
              [
                53.1723295,
                27.2648688
              ],
              [
                53.1822076,
                27.2618262
              ],
              [
                53.2020665,
                27.2571377
              ],
              [
                53.2296889,
                27.2397845
              ],
              [
                53.2692817,
                27.2356958
              ],
              [
                53.2703917,
                27.2348596
              ],
              [
                53.2765015,
                27.2320813
              ],
              [
                53.308067,
                27.2225785
              ],
              [
                53.3362504,
                27.2081122
              ],
              [
                53.3376371,
                27.2078424
              ],
              [
                53.346267,
                27.1986785
              ],
              [
                53.3499703,
                27.1920103
              ],
              [
                53.3502469,
                27.1917316
              ],
              [
                53.3513603,
                27.1917315
              ],
              [
                53.3519136,
                27.1914528
              ],
              [
                53.3527469,
                27.1914529
              ],
              [
                53.353027,
                27.1911741
              ],
              [
                53.3535802,
                27.1911741
              ],
              [
                53.3538603,
                27.1908954
              ],
              [
                53.3541369,
                27.1906166
              ],
              [
                53.3546936,
                27.1903469
              ],
              [
                53.3569169,
                27.1864535
              ],
              [
                53.3627502,
                27.1708983
              ],
              [
                53.3744167,
                27.1481148
              ],
              [
                53.3752499,
                27.1472876
              ],
              [
                53.3843865,
                27.1308377
              ],
              [
                53.4103772,
                27.1245357
              ],
              [
                53.4096961,
                27.1139499
              ],
              [
                53.4105294,
                27.11395
              ],
              [
                53.415527,
                27.1065061
              ],
              [
                53.4464976,
                27.1064833
              ],
              [
                53.4466228,
                27.1064573
              ],
              [
                53.4466515,
                27.1064513
              ],
              [
                53.4468315,
                27.1064139
              ],
              [
                53.4480288,
                27.1061732
              ],
              [
                53.4496989,
                27.1061732
              ],
              [
                53.4736582,
                27.1060919
              ],
              [
                53.4753249,
                27.1060919
              ],
              [
                53.4775482,
                27.1055345
              ],
              [
                53.4789347,
                27.1055345
              ],
              [
                53.4797681,
                27.1052558
              ],
              [
                53.4811581,
                27.1052558
              ],
              [
                53.4819913,
                27.1049861
              ],
              [
                53.4831047,
                27.1049861
              ],
              [
                53.483658,
                27.1046984
              ],
              [
                53.4844914,
                27.1046984
              ],
              [
                53.4964379,
                27.1027566
              ],
              [
                53.5014378,
                27.1027566
              ],
              [
                53.5044944,
                27.1027566
              ],
              [
                53.5056044,
                27.1027566
              ],
              [
                53.506161,
                27.1030353
              ],
              [
                53.5069944,
                27.1030353
              ],
              [
                53.5072711,
                27.103314
              ],
              [
                53.5081043,
                27.103314
              ],
              [
                53.5089376,
                27.1041411
              ],
              [
                53.511161,
                27.1049861
              ],
              [
                53.5117143,
                27.1055345
              ],
              [
                53.5122709,
                27.1055345
              ],
              [
                53.5369373,
                27.0918148
              ],
              [
                53.5372174,
                27.0920938
              ],
              [
                53.537494,
                27.0918149
              ],
              [
                53.5809927,
                27.1398997
              ],
              [
                53.5811326,
                27.1397596
              ],
              [
                53.5814098,
                27.1394821
              ],
              [
                53.5816864,
                27.1392032
              ],
              [
                53.5816865,
                27.1389245
              ],
              [
                53.5822431,
                27.1380976
              ],
              [
                53.6040793,
                27.1259521
              ],
              [
                53.626026,
                27.1142885
              ],
              [
                53.6426924,
                27.1081759
              ],
              [
                53.6776953,
                27.0981805
              ],
              [
                53.6826952,
                27.0962298
              ],
              [
                53.6832485,
                27.0959513
              ],
              [
                53.6846385,
                27.0956815
              ],
              [
                53.7515874,
                27.0687429
              ],
              [
                53.8097297,
                27.0680153
              ],
              [
                53.8102829,
                27.0685726
              ],
              [
                53.8436289,
                27.0714554
              ],
              [
                53.8444622,
                27.0720127
              ],
              [
                53.871845,
                27.085262
              ],
              [
                53.8732351,
                27.0858104
              ],
              [
                53.8737918,
                27.0863678
              ],
              [
                53.9069381,
                27.1114507
              ],
              [
                53.9111047,
                27.1131139
              ],
              [
                53.9130514,
                27.1136713
              ],
              [
                53.9188846,
                27.1159009
              ],
              [
                53.9333276,
                27.1236778
              ],
              [
                53.934161,
                27.1245049
              ],
              [
                53.9640676,
                27.1455798
              ],
              [
                53.9497369,
                27.1660849
              ],
              [
                53.8915663,
                27.2222546
              ],
              [
                53.8823999,
                27.2375434
              ],
              [
                53.8815665,
                27.2386592
              ],
              [
                53.8954919,
                27.2839262
              ],
              [
                53.9658306,
                27.3353436
              ],
              [
                53.97166,
                27.3393096
              ],
              [
                53.9652739,
                27.3453447
              ],
              [
                53.9647205,
                27.3456234
              ],
              [
                53.9630539,
                27.3456234
              ],
              [
                53.9619405,
                27.3453446
              ],
              [
                53.960554,
                27.3453446
              ],
              [
                53.9599973,
                27.3450659
              ],
              [
                53.9266611,
                27.3436808
              ],
              [
                53.9163846,
                27.3425656
              ],
              [
                53.9127713,
                27.3425656
              ],
              [
                53.911938,
                27.3422868
              ],
              [
                53.9105514,
                27.3422869
              ],
              [
                53.9088847,
                27.342008
              ],
              [
                53.9047182,
                27.342008
              ],
              [
                53.9033282,
                27.3417382
              ],
              [
                53.8983283,
                27.3417381
              ],
              [
                53.8972149,
                27.3414594
              ],
              [
                53.8924951,
                27.3414594
              ],
              [
                53.8913817,
                27.3411805
              ],
              [
                53.8861051,
                27.3411805
              ],
              [
                53.8844385,
                27.3414593
              ],
              [
                53.8819385,
                27.3414593
              ],
              [
                53.8758252,
                27.3422868
              ],
              [
                53.8727721,
                27.3422868
              ],
              [
                53.8719387,
                27.3425656
              ],
              [
                53.8672154,
                27.3425655
              ],
              [
                53.852769,
                27.3442294
              ],
              [
                53.8497158,
                27.3442294
              ],
              [
                53.847769,
                27.3445082
              ],
              [
                53.8416592,
                27.3445083
              ],
              [
                53.8377692,
                27.3445083
              ],
              [
                53.8372126,
                27.3445082
              ],
              [
                53.8361026,
                27.344796
              ],
              [
                53.8341593,
                27.344796
              ],
              [
                53.8316593,
                27.3453447
              ],
              [
                53.8291593,
                27.3453447
              ],
              [
                53.8286027,
                27.3456235
              ],
              [
                53.8252695,
                27.3456234
              ],
              [
                53.8247128,
                27.3459023
              ],
              [
                53.808603,
                27.3459022
              ],
              [
                53.8080464,
                27.3456235
              ],
              [
                53.8047131,
                27.3456234
              ],
              [
                53.8033231,
                27.3453446
              ],
              [
                53.7947132,
                27.3453447
              ],
              [
                53.7935999,
                27.3450658
              ],
              [
                53.7913799,
                27.3450659
              ],
              [
                53.7905467,
                27.344796
              ],
              [
                53.7894333,
                27.344796
              ],
              [
                53.78888,
                27.3445082
              ],
              [
                53.7877667,
                27.3445083
              ],
              [
                53.7872099,
                27.3442295
              ],
              [
                53.7833234,
                27.3436808
              ],
              [
                53.7830434,
                27.343402
              ],
              [
                53.7822101,
                27.3434019
              ],
              [
                53.7813768,
                27.3431232
              ],
              [
                53.7797101,
                27.3431231
              ],
              [
                53.7485973,
                27.3372863
              ],
              [
                53.7197077,
                27.3267368
              ],
              [
                53.7169311,
                27.3253429
              ],
              [
                53.6994314,
                27.3186787
              ],
              [
                53.6988748,
                27.3181211
              ],
              [
                53.6899849,
                27.3150633
              ],
              [
                53.6885948,
                27.3147936
              ],
              [
                53.6883183,
                27.3145148
              ],
              [
                53.6877616,
                27.3145148
              ],
              [
                53.6874849,
                27.314236
              ],
              [
                53.6866516,
                27.314236
              ],
              [
                53.6863749,
                27.3139572
              ],
              [
                53.6858183,
                27.3139572
              ],
              [
                53.6847084,
                27.3133996
              ],
              [
                53.683875,
                27.3131209
              ],
              [
                53.6833183,
                27.312842
              ],
              [
                53.6827617,
                27.3125722
              ],
              [
                53.6822084,
                27.3125723
              ],
              [
                53.6802616,
                27.3117358
              ],
              [
                53.6794284,
                27.3117358
              ],
              [
                53.6719285,
                27.3100631
              ],
              [
                53.6702619,
                27.3100631
              ],
              [
                53.6694285,
                27.3097843
              ],
              [
                53.6583188,
                27.3081206
              ],
              [
                53.656372,
                27.3081205
              ],
              [
                53.6549821,
                27.3078418
              ],
              [
                53.6533155,
                27.3078418
              ],
              [
                53.6502622,
                27.3072932
              ],
              [
                53.6480389,
                27.3072932
              ],
              [
                53.6466489,
                27.3070144
              ],
              [
                53.6449823,
                27.3070144
              ],
              [
                53.6441489,
                27.3067356
              ],
              [
                53.6413723,
                27.3067356
              ],
              [
                53.6369257,
                27.306178
              ],
              [
                53.6338725,
                27.306178
              ],
              [
                53.6330391,
                27.3058992
              ],
              [
                53.623316,
                27.3058993
              ],
              [
                53.6227592,
                27.3056204
              ],
              [
                53.6188692,
                27.3056205
              ],
              [
                53.6172027,
                27.3053417
              ],
              [
                53.6102595,
                27.3053416
              ],
              [
                53.6085928,
                27.3056205
              ],
              [
                53.6066496,
                27.3056204
              ],
              [
                53.6058163,
                27.3058992
              ],
              [
                53.6044263,
                27.3058993
              ],
              [
                53.5866465,
                27.3092358
              ],
              [
                53.58109,
                27.3114571
              ],
              [
                53.5802566,
                27.3114571
              ],
              [
                53.5672036,
                27.3164573
              ],
              [
                53.5619236,
                27.3181211
              ],
              [
                53.539424,
                27.3247852
              ],
              [
                53.5385906,
                27.3253428
              ],
              [
                53.4824748,
                27.3403441
              ],
              [
                53.453032,
                27.3506239
              ],
              [
                53.4524753,
                27.3511815
              ],
              [
                53.4460855,
                27.3545093
              ],
              [
                53.4444188,
                27.3556245
              ],
              [
                53.4444188,
                27.3559033
              ],
              [
                53.4427521,
                27.3570096
              ],
              [
                53.4424754,
                27.3575672
              ],
              [
                53.4411382,
                27.3587373
              ],
              [
                53.4408089,
                27.3589613
              ],
              [
                53.4207143,
                27.3681894
              ],
              [
                53.4160775,
                27.3712298
              ],
              [
                53.4173555,
                27.374427
              ],
              [
                53.4275961,
                27.3919238
              ],
              [
                53.4299922,
                27.3932068
              ],
              [
                53.43544,
                27.3988988
              ],
              [
                53.4437656,
                27.4094905
              ],
              [
                53.4485721,
                27.4174907
              ],
              [
                53.4518336,
                27.4262522
              ],
              [
                53.4538077,
                27.4328799
              ],
              [
                53.4568976,
                27.4385932
              ],
              [
                53.4613888,
                27.4431886
              ],
              [
                53.4650087,
                27.4459438
              ],
              [
                53.467369,
                27.4504759
              ],
              [
                53.4686287,
                27.4542039
              ],
              [
                53.4700211,
                27.4610494
              ],
              [
                53.4706735,
                27.4652132
              ],
              [
                53.4710168,
                27.4750751
              ],
              [
                53.4711456,
                27.4768265
              ],
              [
                53.4712314,
                27.4880198
              ],
              [
                53.46951,
                27.4940453
              ],
              [
                53.4687183,
                27.498894
              ],
              [
                53.4664641,
                27.5059883
              ],
              [
                53.4671579,
                27.5089907
              ],
              [
                53.468145,
                27.5115122
              ],
              [
                53.4687923,
                27.5149206
              ],
              [
                53.4687955,
                27.5184164
              ],
              [
                53.4675598,
                27.5222364
              ],
              [
                53.4588718,
                27.520984
              ],
              [
                53.4474837,
                27.5203072
              ],
              [
                53.4375836,
                27.5195237
              ],
              [
                53.4162997,
                27.5192332
              ],
              [
                53.3987397,
                27.5205092
              ],
              [
                53.3842779,
                27.5208998
              ],
              [
                53.3778656,
                27.522219
              ],
              [
                53.3701359,
                27.5244676
              ],
              [
                53.3604653,
                27.5252181
              ],
              [
                53.3538359,
                27.5244206
              ],
              [
                53.3598231,
                27.5368154
              ],
              [
                53.3642005,
                27.5493724
              ],
              [
                53.3656948,
                27.5561036
              ],
              [
                53.3572482,
                27.5591126
              ],
              [
                53.3433436,
                27.5656563
              ],
              [
                53.3324432,
                27.573493
              ],
              [
                53.319826,
                27.5875672
              ],
              [
                53.3097838,
                27.597304
              ],
              [
                53.2921444,
                27.6128879
              ],
              [
                53.282172,
                27.6202147
              ],
              [
                53.2751839,
                27.6274346
              ],
              [
                53.2635834,
                27.6278536
              ],
              [
                53.2544231,
                27.6288666
              ],
              [
                53.2427802,
                27.6287799
              ],
              [
                53.2261517,
                27.6285626
              ],
              [
                53.2078161,
                27.6290102
              ],
              [
                53.2009445,
                27.6301255
              ],
              [
                53.1908225,
                27.6297791
              ],
              [
                53.1857622,
                27.6289512
              ],
              [
                53.1825845,
                27.6275316
              ],
              [
                53.1766073,
                27.6243376
              ],
              [
                53.1667041,
                27.6179158
              ],
              [
                53.1579377,
                27.6159302
              ],
              [
                53.152512,
                27.6161157
              ],
              [
                53.1372218,
                27.6177118
              ],
              [
                53.1340241,
                27.6190375
              ],
              [
                53.1300973,
                27.6206155
              ],
              [
                53.1243467,
                27.6227069
              ],
              [
                53.1209564,
                27.6249503
              ],
              [
                53.118596,
                27.6274978
              ],
              [
                53.1212997,
                27.629627
              ],
              [
                53.1232738,
                27.6312619
              ],
              [
                53.1273078,
                27.6344556
              ],
              [
                53.1326722,
                27.6372691
              ],
              [
                53.136835,
                27.6406527
              ],
              [
                53.1404399,
                27.6418693
              ],
              [
                53.152542,
                27.6494724
              ],
              [
                53.1572627,
                27.6539581
              ],
              [
                53.1653308,
                27.6633088
              ],
              [
                53.1689357,
                27.6693902
              ],
              [
                53.1792416,
                27.6828171
              ],
              [
                53.1952386,
                27.7051193
              ],
              [
                53.1722177,
                27.7103744
              ],
              [
                53.1504821,
                27.7156737
              ],
              [
                53.1266103,
                27.7218995
              ],
              [
                53.1037216,
                27.7266283
              ],
              [
                53.0938338,
                27.7288181
              ],
              [
                53.0826602,
                27.731643
              ],
              [
                53.0735463,
                27.7340164
              ],
              [
                53.0563091,
                27.7385443
              ],
              [
                53.0318704,
                27.7454192
              ],
              [
                53.0138455,
                27.7492404
              ],
              [
                53.0099555,
                27.7509142
              ],
              [
                52.9995932,
                27.7546222
              ],
              [
                52.9955257,
                27.7548252
              ],
              [
                52.9916225,
                27.7553598
              ],
              [
                52.9824418,
                27.7564342
              ],
              [
                52.9723304,
                27.7578215
              ],
              [
                52.9598377,
                27.7617413
              ],
              [
                52.9369267,
                27.769488
              ],
              [
                52.9254837,
                27.7744928
              ],
              [
                52.9080545,
                27.7825299
              ],
              [
                52.8944215,
                27.7911295
              ],
              [
                52.8861133,
                27.7955755
              ],
              [
                52.8776052,
                27.8016935
              ],
              [
                52.8596711,
                27.8164667
              ],
              [
                52.8487098,
                27.8297435
              ],
              [
                52.8442403,
                27.8336906
              ],
              [
                52.8257291,
                27.8431437
              ],
              [
                52.8040917,
                27.8492205
              ],
              [
                52.7829606,
                27.8523833
              ],
              [
                52.7707466,
                27.8560061
              ],
              [
                52.7579444,
                27.8618985
              ],
              [
                52.7484455,
                27.8654092
              ],
              [
                52.7339457,
                27.8735261
              ],
              [
                52.714064,
                27.8854582
              ],
              [
                52.7071925,
                27.8903649
              ],
              [
                52.6813729,
                27.9092527
              ],
              [
                52.6805715,
                27.9069438
              ],
              [
                52.6765625,
                27.9024821
              ],
              [
                52.6717643,
                27.8987652
              ],
              [
                52.6666633,
                27.8941893
              ],
              [
                52.6696641,
                27.8884066
              ],
              [
                52.6679975,
                27.8886857
              ],
              [
                52.6543844,
                27.8886857
              ],
              [
                52.6538276,
                27.8884066
              ],
              [
                52.6479944,
                27.8884067
              ],
              [
                52.6471611,
                27.8881366
              ],
              [
                52.6255647,
                27.8964812
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555205,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مرودشت",
          "name:ar": "مقاطعة مرودشت",
          "name:en": "Marvdasht County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q764511",
          "wikipedia": "en:Marvdasht County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.9691129,
                30.5585215
              ],
              [
                51.9712957,
                30.5565241
              ],
              [
                51.9718523,
                30.5562443
              ],
              [
                51.9724091,
                30.5554141
              ],
              [
                51.9737957,
                30.5545748
              ],
              [
                51.9866942,
                30.5427932
              ],
              [
                52.0034347,
                30.5383349
              ],
              [
                52.0146581,
                30.5376094
              ],
              [
                52.0255771,
                30.5347557
              ],
              [
                52.034997,
                30.5364243
              ],
              [
                52.0427253,
                30.5353365
              ],
              [
                52.0482063,
                30.5289995
              ],
              [
                52.0455959,
                30.5256335
              ],
              [
                52.0390251,
                30.5171591
              ],
              [
                52.0304013,
                30.5060342
              ],
              [
                52.0228307,
                30.4962651
              ],
              [
                52.030465,
                30.4884639
              ],
              [
                52.0312981,
                30.4876337
              ],
              [
                52.0396349,
                30.4762455
              ],
              [
                52.0399115,
                30.475686
              ],
              [
                52.0401883,
                30.4754153
              ],
              [
                52.0401882,
                30.4751355
              ],
              [
                52.0404681,
                30.4748558
              ],
              [
                52.0507447,
                30.4645776
              ],
              [
                52.0524114,
                30.4634677
              ],
              [
                52.0546346,
                30.4612388
              ],
              [
                52.0563012,
                30.4601288
              ],
              [
                52.1182471,
                30.406799
              ],
              [
                52.1210271,
                30.4054093
              ],
              [
                52.1213036,
                30.4051296
              ],
              [
                52.1215804,
                30.4048499
              ],
              [
                52.122137,
                30.4048499
              ],
              [
                52.1221371,
                30.4045701
              ],
              [
                52.1235271,
                30.4037401
              ],
              [
                52.1238038,
                30.4034603
              ],
              [
                52.1238037,
                30.4031896
              ],
              [
                52.1351936,
                30.386794
              ],
              [
                52.1357503,
                30.3851247
              ],
              [
                52.1363035,
                30.3845742
              ],
              [
                52.1382503,
                30.3787451
              ],
              [
                52.1404701,
                30.3654087
              ],
              [
                52.1407501,
                30.3629092
              ],
              [
                52.1410269,
                30.3623498
              ],
              [
                52.1407502,
                30.348463
              ],
              [
                52.1357503,
                30.3290181
              ],
              [
                52.1282504,
                30.3212403
              ],
              [
                52.1254704,
                30.3192913
              ],
              [
                52.1107473,
                30.3087435
              ],
              [
                52.1104708,
                30.3084637
              ],
              [
                52.110194,
                30.3073539
              ],
              [
                52.1096373,
                30.3059643
              ],
              [
                52.1085241,
                30.2948481
              ],
              [
                52.1088041,
                30.2917984
              ],
              [
                52.1171373,
                30.2606879
              ],
              [
                52.1179706,
                30.2598488
              ],
              [
                52.1218607,
                30.2540202
              ],
              [
                52.141027,
                30.2326277
              ],
              [
                52.1424169,
                30.2317886
              ],
              [
                52.1432503,
                30.2306789
              ],
              [
                52.1440835,
                30.2303991
              ],
              [
                52.1501934,
                30.2254007
              ],
              [
                52.1535266,
                30.2231812
              ],
              [
                52.1585266,
                30.2204023
              ],
              [
                52.1607501,
                30.2187421
              ],
              [
                52.1613067,
                30.2184624
              ],
              [
                52.1671398,
                30.2140144
              ],
              [
                52.1796397,
                30.208186
              ],
              [
                52.1838063,
                30.2070672
              ],
              [
                52.2054762,
                30.1976298
              ],
              [
                52.2063094,
                30.1976299
              ],
              [
                52.2110294,
                30.195681
              ],
              [
                52.212696,
                30.195681
              ],
              [
                52.2132526,
                30.1954014
              ],
              [
                52.2160293,
                30.194851
              ],
              [
                52.2165859,
                30.1945713
              ],
              [
                52.2194323,
                30.1935321
              ],
              [
                52.2201957,
                30.1934616
              ],
              [
                52.2349189,
                30.1890137
              ],
              [
                52.2432555,
                30.1848544
              ],
              [
                52.2646452,
                30.1709602
              ],
              [
                52.2688118,
                30.1687318
              ],
              [
                52.305758,
                30.1523478
              ],
              [
                52.3065913,
                30.1523478
              ],
              [
                52.3074247,
                30.1517885
              ],
              [
                52.3143678,
                30.1501284
              ],
              [
                52.3168678,
                30.1501284
              ],
              [
                52.3174244,
                30.1498487
              ],
              [
                52.3185344,
                30.1498488
              ],
              [
                52.3204812,
                30.1495691
              ],
              [
                52.325481,
                30.1492894
              ],
              [
                52.3285343,
                30.148739
              ],
              [
                52.3321475,
                30.148739
              ],
              [
                52.3332575,
                30.1484593
              ],
              [
                52.3349242,
                30.1484594
              ],
              [
                52.3360375,
                30.1487391
              ],
              [
                52.3379808,
                30.1487391
              ],
              [
                52.350204,
                30.1509584
              ],
              [
                52.3563139,
                30.1545673
              ],
              [
                52.3702037,
                30.1715197
              ],
              [
                52.3752035,
                30.1737392
              ],
              [
                52.3765936,
                30.1740099
              ],
              [
                52.3788169,
                30.1740099
              ],
              [
                52.3788169,
                30.1742895
              ],
              [
                52.3813169,
                30.1742895
              ],
              [
                52.3818702,
                30.1742895
              ],
              [
                52.3828435,
                30.1742895
              ],
              [
                52.3828744,
                30.1742896
              ],
              [
                52.3835368,
                30.1742895
              ],
              [
                52.3846501,
                30.1740098
              ],
              [
                52.3971499,
                30.1731798
              ],
              [
                52.4110398,
                30.1704101
              ],
              [
                52.4127064,
                30.17041
              ],
              [
                52.4363194,
                30.1656825
              ],
              [
                52.4393726,
                30.1642931
              ],
              [
                52.4413193,
                30.1637428
              ],
              [
                52.4590958,
                30.1556771
              ],
              [
                52.4827087,
                30.1415125
              ],
              [
                52.4838187,
                30.1404028
              ],
              [
                52.4857654,
                30.1387338
              ],
              [
                52.4935418,
                30.130957
              ],
              [
                52.4999319,
                30.1276279
              ],
              [
                52.5010417,
                30.1273482
              ],
              [
                52.5015984,
                30.1273482
              ],
              [
                52.5018751,
                30.1270685
              ],
              [
                52.5029884,
                30.1270685
              ],
              [
                52.5032651,
                30.1267889
              ],
              [
                52.5038218,
                30.1267888
              ],
              [
                52.5043751,
                30.1262385
              ],
              [
                52.5049317,
                30.1262385
              ],
              [
                52.5052084,
                30.1259588
              ],
              [
                52.5056876,
                30.1251677
              ],
              [
                52.5068784,
                30.1245694
              ],
              [
                52.511045,
                30.1212405
              ],
              [
                52.5435445,
                30.087346
              ],
              [
                52.5435445,
                30.0867866
              ],
              [
                52.5460446,
                30.0812294
              ],
              [
                52.5463245,
                30.080679
              ],
              [
                52.5454912,
                30.0734618
              ],
              [
                52.5441012,
                30.0720635
              ],
              [
                52.5332681,
                30.0673452
              ],
              [
                52.5324347,
                30.0673452
              ],
              [
                52.5316014,
                30.0670656
              ],
              [
                52.5304881,
                30.0670656
              ],
              [
                52.5296548,
                30.0667859
              ],
              [
                52.5243783,
                30.0667859
              ],
              [
                52.5232648,
                30.0670655
              ],
              [
                52.5199315,
                30.0670656
              ],
              [
                52.5190982,
                30.0673452
              ],
              [
                52.515765,
                30.0673452
              ],
              [
                52.5149315,
                30.0676249
              ],
              [
                52.5127117,
                30.0676249
              ],
              [
                52.512155,
                30.0673452
              ],
              [
                52.510765,
                30.0673453
              ],
              [
                52.4999318,
                30.0637366
              ],
              [
                52.4943753,
                30.0595688
              ],
              [
                52.4904887,
                30.054571
              ],
              [
                52.489932,
                30.0534613
              ],
              [
                52.489932,
                30.0531726
              ],
              [
                52.4890987,
                30.0529019
              ],
              [
                52.488542,
                30.0523426
              ],
              [
                52.4879887,
                30.052072
              ],
              [
                52.4848731,
                30.0462553
              ],
              [
                52.4838187,
                30.0442866
              ],
              [
                52.4832655,
                30.0387385
              ],
              [
                52.4824322,
                30.0370696
              ],
              [
                52.4821521,
                30.0356803
              ],
              [
                52.4815988,
                30.035121
              ],
              [
                52.4785422,
                30.027895
              ],
              [
                52.4790989,
                30.0251255
              ],
              [
                52.4793755,
                30.0242866
              ],
              [
                52.4790989,
                30.0190091
              ],
              [
                52.4832655,
                30.0023472
              ],
              [
                52.4832655,
                29.9990095
              ],
              [
                52.4835422,
                29.9981795
              ],
              [
                52.4838187,
                29.9959603
              ],
              [
                52.4842354,
                29.9955382
              ],
              [
                52.4849322,
                29.9948418
              ],
              [
                52.4849321,
                29.9945621
              ],
              [
                52.4999319,
                29.9751221
              ],
              [
                52.5124317,
                29.9628989
              ],
              [
                52.5129885,
                29.9626193
              ],
              [
                52.5135451,
                29.9617894
              ],
              [
                52.5304881,
                29.9420702
              ],
              [
                52.5304882,
                29.9409516
              ],
              [
                52.5343781,
                29.9370637
              ],
              [
                52.5352114,
                29.9367842
              ],
              [
                52.5360447,
                29.9359542
              ],
              [
                52.5379881,
                29.9348448
              ],
              [
                52.5407681,
                29.9306772
              ],
              [
                52.5424348,
                29.9287288
              ],
              [
                52.5424347,
                29.9281786
              ],
              [
                52.5427113,
                29.9278989
              ],
              [
                52.543268,
                29.9276193
              ],
              [
                52.543268,
                29.9273487
              ],
              [
                52.545768,
                29.9251206
              ],
              [
                52.5482679,
                29.9215124
              ],
              [
                52.5566011,
                29.9134571
              ],
              [
                52.5571578,
                29.9123387
              ],
              [
                52.5735476,
                29.8903922
              ],
              [
                52.5985472,
                29.8701238
              ],
              [
                52.5993805,
                29.8695646
              ],
              [
                52.6010471,
                29.8687348
              ],
              [
                52.6013273,
                29.8684551
              ],
              [
                52.6082704,
                29.8642879
              ],
              [
                52.6224369,
                29.8559534
              ],
              [
                52.6641064,
                29.8392846
              ],
              [
                52.6713295,
                29.8373453
              ],
              [
                52.6741061,
                29.8373453
              ],
              [
                52.6749394,
                29.8370656
              ],
              [
                52.6838294,
                29.8370657
              ],
              [
                52.6849393,
                29.8373453
              ],
              [
                52.6896626,
                29.8373453
              ],
              [
                52.6949426,
                29.8373453
              ],
              [
                52.6999424,
                29.8376159
              ],
              [
                52.7243854,
                29.8362269
              ],
              [
                52.7360553,
                29.8359563
              ],
              [
                52.7363319,
                29.8356766
              ],
              [
                52.7402219,
                29.8356766
              ],
              [
                52.7410552,
                29.835397
              ],
              [
                52.7435551,
                29.8353971
              ],
              [
                52.7438317,
                29.8351174
              ],
              [
                52.7449418,
                29.8351174
              ],
              [
                52.7460551,
                29.835397
              ],
              [
                52.7463317,
                29.8351174
              ],
              [
                52.748275,
                29.8351174
              ],
              [
                52.7488317,
                29.8351174
              ],
              [
                52.7491083,
                29.8348378
              ],
              [
                52.7502217,
                29.8345672
              ],
              [
                52.7552216,
                29.8334487
              ],
              [
                52.7621649,
                29.8328985
              ],
              [
                52.7629981,
                29.8328986
              ],
              [
                52.7635548,
                29.8328985
              ],
              [
                52.7641115,
                29.8326189
              ],
              [
                52.7649448,
                29.832619
              ],
              [
                52.7668881,
                29.8323394
              ],
              [
                52.7682782,
                29.8320687
              ],
              [
                52.8063342,
                29.8206677
              ],
              [
                52.8071674,
                29.8203972
              ],
              [
                52.8082809,
                29.8198379
              ],
              [
                52.8093908,
                29.8195674
              ],
              [
                52.8105008,
                29.8192878
              ],
              [
                52.8121674,
                29.8192877
              ],
              [
                52.8124475,
                29.8190081
              ],
              [
                52.8143908,
                29.8190081
              ],
              [
                52.8146673,
                29.8187285
              ],
              [
                52.8152242,
                29.8187285
              ],
              [
                52.843837,
                29.8128927
              ],
              [
                52.8443903,
                29.8126222
              ],
              [
                52.8452235,
                29.8126221
              ],
              [
                52.8455037,
                29.8123335
              ],
              [
                52.8468937,
                29.8123335
              ],
              [
                52.847447,
                29.8120629
              ],
              [
                52.8482803,
                29.812063
              ],
              [
                52.848837,
                29.8117833
              ],
              [
                52.8502269,
                29.8117833
              ],
              [
                52.8891163,
                29.8017805
              ],
              [
                52.9232858,
                29.7887292
              ],
              [
                52.9238392,
                29.7881791
              ],
              [
                52.9424522,
                29.779836
              ],
              [
                52.9466188,
                29.7778969
              ],
              [
                52.9563736,
                29.7733912
              ],
              [
                53.0349575,
                29.7345593
              ],
              [
                53.0591239,
                29.7256665
              ],
              [
                53.0596805,
                29.7251163
              ],
              [
                53.0624571,
                29.724007
              ],
              [
                53.0630138,
                29.7234478
              ],
              [
                53.0844036,
                29.7128956
              ],
              [
                53.0852369,
                29.7120568
              ],
              [
                53.0960699,
                29.7062216
              ],
              [
                53.0969033,
                29.7053919
              ],
              [
                53.0977366,
                29.7051122
              ],
              [
                53.0994033,
                29.7042826
              ],
              [
                53.1021798,
                29.7028936
              ],
              [
                53.1360728,
                29.6895548
              ],
              [
                53.136626,
                29.6892842
              ],
              [
                53.1371827,
                29.6890046
              ],
              [
                53.1371827,
                29.692062
              ],
              [
                53.139126,
                29.7040029
              ],
              [
                53.1388493,
                29.7042825
              ],
              [
                53.1385727,
                29.705951
              ],
              [
                53.1382927,
                29.7084493
              ],
              [
                53.1385727,
                29.710677
              ],
              [
                53.1382927,
                29.7123364
              ],
              [
                53.1382928,
                29.7134548
              ],
              [
                53.1288495,
                29.7423429
              ],
              [
                53.1285729,
                29.7426134
              ],
              [
                53.1269029,
                29.7478897
              ],
              [
                53.1255162,
                29.7551141
              ],
              [
                53.1238495,
                29.7623385
              ],
              [
                53.1249596,
                29.7687332
              ],
              [
                53.1249596,
                29.7690038
              ],
              [
                53.1253804,
                29.7698426
              ],
              [
                53.1263495,
                29.7720614
              ],
              [
                53.1266262,
                29.7729002
              ],
              [
                53.1271828,
                29.77373
              ],
              [
                53.1271828,
                29.7745597
              ],
              [
                53.1277361,
                29.7756691
              ],
              [
                53.127736,
                29.7759487
              ],
              [
                53.1307927,
                29.7845623
              ],
              [
                53.1396826,
                29.7942854
              ],
              [
                53.1402394,
                29.7951152
              ],
              [
                53.1516292,
                29.8023399
              ],
              [
                53.1574624,
                29.8042881
              ],
              [
                53.1582957,
                29.8042881
              ],
              [
                53.1596823,
                29.8048383
              ],
              [
                53.1671856,
                29.8062273
              ],
              [
                53.1682956,
                29.8062273
              ],
              [
                53.1688522,
                29.806507
              ],
              [
                53.1713522,
                29.806507
              ],
              [
                53.1721855,
                29.8067865
              ],
              [
                53.176072,
                29.8067866
              ],
              [
                53.1771855,
                29.8070662
              ],
              [
                53.1832953,
                29.8070661
              ],
              [
                53.1841286,
                29.8067866
              ],
              [
                53.185242,
                29.8067865
              ],
              [
                53.1877419,
                29.8067865
              ],
              [
                53.1882952,
                29.8070662
              ],
              [
                53.1921852,
                29.8070661
              ],
              [
                53.1963518,
                29.807896
              ],
              [
                53.1974617,
                29.8078959
              ],
              [
                53.1999617,
                29.8087258
              ],
              [
                53.200795,
                29.8087258
              ],
              [
                53.201075,
                29.8090054
              ],
              [
                53.2021851,
                29.8090054
              ],
              [
                53.2027418,
                29.809285
              ],
              [
                53.2038517,
                29.809285
              ],
              [
                53.2077417,
                29.8103944
              ],
              [
                53.208575,
                29.8103944
              ],
              [
                53.2260746,
                29.8201177
              ],
              [
                53.227188,
                29.8206679
              ],
              [
                53.2299646,
                29.823455
              ],
              [
                53.2380212,
                29.8353972
              ],
              [
                53.2380212,
                29.8359565
              ],
              [
                53.2382979,
                29.836227
              ],
              [
                53.2382978,
                29.8365066
              ],
              [
                53.2380212,
                29.8367863
              ],
              [
                53.2377411,
                29.8378957
              ],
              [
                53.2324645,
                29.8462301
              ],
              [
                53.2285747,
                29.8506769
              ],
              [
                53.2266314,
                29.8526163
              ],
              [
                53.221908,
                29.8562332
              ],
              [
                53.1949618,
                29.867346
              ],
              [
                53.1841286,
                29.8726227
              ],
              [
                53.153849,
                29.9001163
              ],
              [
                53.1382926,
                29.9312278
              ],
              [
                53.1380159,
                29.931787
              ],
              [
                53.1380159,
                29.9323463
              ],
              [
                53.1349592,
                29.9328965
              ],
              [
                53.1346826,
                29.9332198
              ],
              [
                53.1341259,
                29.9342857
              ],
              [
                53.1332926,
                29.9367844
              ],
              [
                53.1332926,
                29.937064
              ],
              [
                53.1324593,
                29.9384532
              ],
              [
                53.1324593,
                29.9387328
              ],
              [
                53.1257927,
                29.9562329
              ],
              [
                53.1194028,
                29.9665075
              ],
              [
                53.1010697,
                29.9845672
              ],
              [
                53.0996798,
                29.9851175
              ],
              [
                53.0991265,
                29.9856768
              ],
              [
                53.0963464,
                29.9867864
              ],
              [
                53.0957932,
                29.9873456
              ],
              [
                53.09218,
                29.9887348
              ],
              [
                53.0905133,
                29.9890055
              ],
              [
                53.0785701,
                29.9954014
              ],
              [
                53.0646803,
                30.0000652
              ],
              [
                53.0605137,
                30.0015086
              ],
              [
                53.0213442,
                30.0234569
              ],
              [
                53.016901,
                30.0256761
              ],
              [
                53.014121,
                30.027345
              ],
              [
                53.0082877,
                30.0317924
              ],
              [
                52.9813415,
                30.0548418
              ],
              [
                52.969675,
                30.0648465
              ],
              [
                52.9338389,
                30.1023491
              ],
              [
                52.9279836,
                30.1082674
              ],
              [
                52.9236916,
                30.1110817
              ],
              [
                52.9198773,
                30.1142611
              ],
              [
                52.915889,
                30.1258897
              ],
              [
                52.9169256,
                30.1384533
              ],
              [
                52.9230056,
                30.1442915
              ],
              [
                52.9227291,
                30.1454012
              ],
              [
                52.9224524,
                30.1487393
              ],
              [
                52.921339,
                30.1556772
              ],
              [
                52.9185624,
                30.1617942
              ],
              [
                52.9160624,
                30.1656827
              ],
              [
                52.9057825,
                30.1759589
              ],
              [
                52.8716111,
                30.2005434
              ],
              [
                52.8675267,
                30.2033604
              ],
              [
                52.8664195,
                30.2044286
              ],
              [
                52.8652264,
                30.2051278
              ],
              [
                52.8624464,
                30.2079067
              ],
              [
                52.8621699,
                30.2081864
              ],
              [
                52.8610599,
                30.2081863
              ],
              [
                52.8605031,
                30.2079067
              ],
              [
                52.8568933,
                30.2079067
              ],
              [
                52.8563366,
                30.2081863
              ],
              [
                52.8549466,
                30.2081863
              ],
              [
                52.8516133,
                30.2090164
              ],
              [
                52.8513366,
                30.2092961
              ],
              [
                52.8505033,
                30.209296
              ],
              [
                52.8085572,
                30.2331784
              ],
              [
                52.8046673,
                30.2351272
              ],
              [
                52.8024439,
                30.2359664
              ],
              [
                52.7968909,
                30.2365168
              ],
              [
                52.7963341,
                30.2365167
              ],
              [
                52.7946674,
                30.2367965
              ],
              [
                52.7927241,
                30.2367965
              ],
              [
                52.7905009,
                30.2373559
              ],
              [
                52.7882776,
                30.2376266
              ],
              [
                52.7877208,
                30.2373559
              ],
              [
                52.7868875,
                30.2376265
              ],
              [
                52.7838344,
                30.2376265
              ],
              [
                52.7832776,
                30.2379062
              ],
              [
                52.7821677,
                30.2379063
              ],
              [
                52.7810542,
                30.238186
              ],
              [
                52.7793876,
                30.2381859
              ],
              [
                52.7732777,
                30.2392957
              ],
              [
                52.7716111,
                30.2392957
              ],
              [
                52.7641113,
                30.2412446
              ],
              [
                52.7632779,
                30.2417949
              ],
              [
                52.7388316,
                30.2531814
              ],
              [
                52.7379983,
                30.2540205
              ],
              [
                52.724385,
                30.2634673
              ],
              [
                52.7204985,
                30.2670673
              ],
              [
                52.7029954,
                30.281242
              ],
              [
                52.6929955,
                30.2843008
              ],
              [
                52.6916055,
                30.2843007
              ],
              [
                52.679939,
                30.2870707
              ],
              [
                52.6779958,
                30.2870708
              ],
              [
                52.6768859,
                30.2873504
              ],
              [
                52.6741058,
                30.2873505
              ],
              [
                52.6729958,
                30.2876301
              ],
              [
                52.6646627,
                30.2879009
              ],
              [
                52.6493828,
                30.2873504
              ],
              [
                52.6454928,
                30.2865113
              ],
              [
                52.6349364,
                30.2815217
              ],
              [
                52.6304931,
                30.2773532
              ],
              [
                52.6274365,
                30.2751246
              ],
              [
                52.6216033,
                30.2709561
              ],
              [
                52.6102134,
                30.2651274
              ],
              [
                52.5899371,
                30.2545709
              ],
              [
                52.5838238,
                30.2537407
              ],
              [
                52.5774339,
                30.2537407
              ],
              [
                52.5771573,
                30.2540205
              ],
              [
                52.5754906,
                30.2540205
              ],
              [
                52.5746573,
                30.2543001
              ],
              [
                52.5704906,
                30.2548505
              ],
              [
                52.5671573,
                30.2559603
              ],
              [
                52.5538244,
                30.2662372
              ],
              [
                52.5538243,
                30.2665168
              ],
              [
                52.5521578,
                30.268177
              ],
              [
                52.5463244,
                30.2742944
              ],
              [
                52.5452111,
                30.2748539
              ],
              [
                52.5429911,
                30.2767937
              ],
              [
                52.5429911,
                30.2770734
              ],
              [
                52.542711,
                30.2773531
              ],
              [
                52.5399345,
                30.2806826
              ],
              [
                52.5385444,
                30.2815217
              ],
              [
                52.5199314,
                30.3004065
              ],
              [
                52.504655,
                30.3195713
              ],
              [
                52.4999317,
                30.3240196
              ],
              [
                52.4952083,
                30.3256799
              ],
              [
                52.4913218,
                30.3276289
              ],
              [
                52.4910417,
                30.3279085
              ],
              [
                52.4890984,
                30.3287386
              ],
              [
                52.4374292,
                30.3537418
              ],
              [
                52.3965932,
                30.36429
              ],
              [
                52.3913166,
                30.3670782
              ],
              [
                52.3710368,
                30.3756863
              ],
              [
                52.3202009,
                30.3904035
              ],
              [
                52.2882546,
                30.4054095
              ],
              [
                52.2785348,
                30.4120779
              ],
              [
                52.2732549,
                30.4148571
              ],
              [
                52.2729783,
                30.4151278
              ],
              [
                52.2707549,
                30.4162468
              ],
              [
                52.2685315,
                30.4176274
              ],
              [
                52.2688116,
                30.4179071
              ],
              [
                52.268255,
                30.4181869
              ],
              [
                52.2676983,
                30.4181869
              ],
              [
                52.2668649,
                30.4184665
              ],
              [
                52.2367502,
                30.4353222
              ],
              [
                52.2226989,
                30.4431823
              ],
              [
                52.2179757,
                30.4462414
              ],
              [
                52.1674164,
                30.4798551
              ],
              [
                52.1635265,
                30.4837445
              ],
              [
                52.1563065,
                30.4923533
              ],
              [
                52.1404698,
                30.5206889
              ],
              [
                52.1400398,
                30.5213344
              ],
              [
                52.1390834,
                30.5226291
              ],
              [
                52.1390834,
                30.5229088
              ],
              [
                52.1390833,
                30.5231886
              ],
              [
                52.1346368,
                30.5295777
              ],
              [
                52.1338034,
                30.530408
              ],
              [
                52.1238035,
                30.5481857
              ],
              [
                52.1226936,
                30.5493047
              ],
              [
                52.0971372,
                30.5898514
              ],
              [
                52.096304,
                30.5906906
              ],
              [
                52.0957474,
                30.5918007
              ],
              [
                52.0621344,
                30.6215277
              ],
              [
                52.0582444,
                30.623468
              ],
              [
                52.0563011,
                30.6240275
              ],
              [
                52.0560245,
                30.6240275
              ],
              [
                52.0554679,
                30.6240276
              ],
              [
                52.0538012,
                30.6231883
              ],
              [
                52.0532446,
                30.6212479
              ],
              [
                52.0493545,
                30.6156888
              ],
              [
                52.0465778,
                30.6140192
              ],
              [
                52.0443545,
                30.6148585
              ],
              [
                52.0410213,
                30.6126384
              ],
              [
                52.0393547,
                30.6120789
              ],
              [
                52.0374115,
                30.608469
              ],
              [
                52.0354681,
                30.5943004
              ],
              [
                52.0351881,
                30.5937499
              ],
              [
                52.0349115,
                30.5931904
              ],
              [
                52.0329647,
                30.5840215
              ],
              [
                52.0318547,
                30.5818015
              ],
              [
                52.023245,
                30.5709632
              ],
              [
                52.0185218,
                30.5676332
              ],
              [
                52.0182451,
                30.5670736
              ],
              [
                52.0079653,
                30.5612439
              ],
              [
                51.9962986,
                30.5579138
              ],
              [
                51.9874088,
                30.5570745
              ],
              [
                51.9837991,
                30.5570746
              ],
              [
                51.9804656,
                30.5565241
              ],
              [
                51.977129,
                30.5565241
              ],
              [
                51.9726857,
                30.5579139
              ],
              [
                51.9707425,
                30.5581936
              ],
              [
                51.9691129,
                30.5585215
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555214,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ممسنی",
          "name:en": "Mamasani County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270510",
          "wikipedia": "en:Mamasani County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.6031831,
                29.9437282
              ],
              [
                50.6045699,
                29.9437282
              ],
              [
                50.605403,
                29.9440079
              ],
              [
                50.6084598,
                29.9440079
              ],
              [
                50.6090164,
                29.9437282
              ],
              [
                50.6112364,
                29.9437283
              ],
              [
                50.611793,
                29.9434486
              ],
              [
                50.6142931,
                29.9434486
              ],
              [
                50.6248495,
                29.94012
              ],
              [
                50.6259593,
                29.94012
              ],
              [
                50.6267929,
                29.9398404
              ],
              [
                50.6279063,
                29.9398404
              ],
              [
                50.6287395,
                29.9395608
              ],
              [
                50.6306829,
                29.9392902
              ],
              [
                50.6342927,
                29.9392902
              ],
              [
                50.642349,
                29.9373417
              ],
              [
                50.6456824,
                29.9354023
              ],
              [
                50.6481823,
                29.9328946
              ],
              [
                50.6548489,
                29.9237298
              ],
              [
                50.6573525,
                29.9190031
              ],
              [
                50.6581858,
                29.9173433
              ],
              [
                50.6601292,
                29.9151152
              ],
              [
                50.6604057,
                29.9148446
              ],
              [
                50.6801288,
                29.8976157
              ],
              [
                50.696242,
                29.8876123
              ],
              [
                50.7134649,
                29.8734507
              ],
              [
                50.7137415,
                29.873171
              ],
              [
                50.7126317,
                29.8662255
              ],
              [
                50.7087418,
                29.8648364
              ],
              [
                50.7062417,
                29.8648365
              ],
              [
                50.7056851,
                29.8653957
              ],
              [
                50.7045749,
                29.8659549
              ],
              [
                50.7034651,
                29.8665051
              ],
              [
                50.7034651,
                29.8667848
              ],
              [
                50.700685,
                29.8667848
              ],
              [
                50.6954087,
                29.8615081
              ],
              [
                50.6945752,
                29.8615081
              ],
              [
                50.6940185,
                29.8612284
              ],
              [
                50.689852,
                29.8623379
              ],
              [
                50.6873519,
                29.8592801
              ],
              [
                50.6851284,
                29.8592801
              ],
              [
                50.6837422,
                29.8606692
              ],
              [
                50.6848518,
                29.8645658
              ],
              [
                50.6842952,
                29.8651161
              ],
              [
                50.6837421,
                29.865116
              ],
              [
                50.682909,
                29.8656753
              ],
              [
                50.6815187,
                29.8640066
              ],
              [
                50.680962,
                29.8617877
              ],
              [
                50.6804088,
                29.8606692
              ],
              [
                50.6798522,
                29.8609488
              ],
              [
                50.6790186,
                29.8617876
              ],
              [
                50.6759623,
                29.8631767
              ],
              [
                50.6751287,
                29.8628971
              ],
              [
                50.6742955,
                29.8606691
              ],
              [
                50.6745756,
                29.8584502
              ],
              [
                50.6748521,
                29.8573408
              ],
              [
                50.6751287,
                29.8565109
              ],
              [
                50.6754088,
                29.8562313
              ],
              [
                50.6740189,
                29.8548422
              ],
              [
                50.6731857,
                29.8548422
              ],
              [
                50.6729056,
                29.8545626
              ],
              [
                50.672072,
                29.8545626
              ],
              [
                50.6715189,
                29.8548422
              ],
              [
                50.6695723,
                29.8548422
              ],
              [
                50.6690188,
                29.8542829
              ],
              [
                50.6704055,
                29.8523437
              ],
              [
                50.6709623,
                29.8503953
              ],
              [
                50.6706857,
                29.8484561
              ],
              [
                50.6690189,
                29.8470671
              ],
              [
                50.6681856,
                29.8473376
              ],
              [
                50.6656856,
                29.847067
              ],
              [
                50.6654055,
                29.8459485
              ],
              [
                50.6659622,
                29.8456779
              ],
              [
                50.6670723,
                29.8445595
              ],
              [
                50.6681856,
                29.8440093
              ],
              [
                50.667629,
                29.8415017
              ],
              [
                50.6670723,
                29.8412311
              ],
              [
                50.6648523,
                29.8415017
              ],
              [
                50.6645723,
                29.8398421
              ],
              [
                50.6651289,
                29.8392828
              ],
              [
                50.6659622,
                29.8392828
              ],
              [
                50.6665192,
                29.8387236
              ],
              [
                50.6656856,
                29.8381734
              ],
              [
                50.6642957,
                29.8381734
              ],
              [
                50.6634624,
                29.8387235
              ],
              [
                50.6626289,
                29.8387236
              ],
              [
                50.6620722,
                29.8390032
              ],
              [
                50.661239,
                29.8390032
              ],
              [
                50.6604059,
                29.8373435
              ],
              [
                50.6606859,
                29.8370639
              ],
              [
                50.6606859,
                29.8362251
              ],
              [
                50.6601292,
                29.8356749
              ],
              [
                50.6565191,
                29.8356749
              ],
              [
                50.6559624,
                29.8353952
              ],
              [
                50.654296,
                29.8353953
              ],
              [
                50.6515158,
                29.8345655
              ],
              [
                50.6445727,
                29.8287296
              ],
              [
                50.644016,
                29.827061
              ],
              [
                50.6440161,
                29.8253923
              ],
              [
                50.6448493,
                29.822064
              ],
              [
                50.6476295,
                29.817058
              ],
              [
                50.6656856,
                29.8056752
              ],
              [
                50.6684622,
                29.8048364
              ],
              [
                50.7037418,
                29.7915055
              ],
              [
                50.7304081,
                29.7873385
              ],
              [
                50.7323549,
                29.7865087
              ],
              [
                50.7456879,
                29.7834511
              ],
              [
                50.7484645,
                29.7831715
              ],
              [
                50.7512444,
                29.7831715
              ],
              [
                50.7526345,
                29.7828919
              ],
              [
                50.7654109,
                29.7817825
              ],
              [
                50.7737441,
                29.7817825
              ],
              [
                50.7751342,
                29.7820621
              ],
              [
                50.7790241,
                29.7820621
              ],
              [
                50.7804109,
                29.7817826
              ],
              [
                50.7829107,
                29.7817826
              ],
              [
                50.787914,
                29.7812234
              ],
              [
                50.7912473,
                29.7806732
              ],
              [
                50.7981904,
                29.7806732
              ],
              [
                50.7987471,
                29.7803936
              ],
              [
                50.8001338,
                29.7803936
              ],
              [
                50.8006905,
                29.780114
              ],
              [
                50.8018005,
                29.780114
              ],
              [
                50.8154136,
                29.7753968
              ],
              [
                50.8184704,
                29.7756674
              ],
              [
                50.8195803,
                29.7753969
              ],
              [
                50.8201369,
                29.7756675
              ],
              [
                50.82069,
                29.7753968
              ],
              [
                50.8226368,
                29.775947
              ],
              [
                50.8256935,
                29.7759471
              ],
              [
                50.8262468,
                29.7756675
              ],
              [
                50.8268299,
                29.7754366
              ],
              [
                50.8276367,
                29.7751173
              ],
              [
                50.83458,
                29.7737282
              ],
              [
                50.8365267,
                29.7737283
              ],
              [
                50.8373599,
                29.7734487
              ],
              [
                50.8443032,
                29.7734487
              ],
              [
                50.8476364,
                29.7740079
              ],
              [
                50.852083,
                29.7742785
              ],
              [
                50.8579163,
                29.7742785
              ],
              [
                50.8590263,
                29.7745581
              ],
              [
                50.872916,
                29.7745581
              ],
              [
                50.9273619,
                29.7801141
              ],
              [
                50.9301418,
                29.7801141
              ],
              [
                50.9318085,
                29.7803937
              ],
              [
                50.9345851,
                29.7803937
              ],
              [
                50.9362517,
                29.7806733
              ],
              [
                50.9451417,
                29.7806734
              ],
              [
                50.9476415,
                29.780953
              ],
              [
                50.9618081,
                29.7817827
              ],
              [
                50.9673646,
                29.7817827
              ],
              [
                50.9684745,
                29.7820623
              ],
              [
                50.9712547,
                29.7820624
              ],
              [
                50.9998675,
                29.7828922
              ],
              [
                51.0173673,
                29.7778954
              ],
              [
                51.0179239,
                29.7778954
              ],
              [
                51.0182006,
                29.7776158
              ],
              [
                51.0190339,
                29.7776159
              ],
              [
                51.0195905,
                29.7773362
              ],
              [
                51.0226439,
                29.776777
              ],
              [
                51.0257004,
                29.7765065
              ],
              [
                51.0315337,
                29.7765065
              ],
              [
                51.0318103,
                29.7762269
              ],
              [
                51.0332004,
                29.7762268
              ],
              [
                51.033757,
                29.7759473
              ],
              [
                51.0345904,
                29.7759472
              ],
              [
                51.034867,
                29.7756676
              ],
              [
                51.0376469,
                29.7748379
              ],
              [
                51.0382003,
                29.7745583
              ],
              [
                51.0387569,
                29.7745583
              ],
              [
                51.0395904,
                29.7745583
              ],
              [
                51.0398668,
                29.7742787
              ],
              [
                51.0512567,
                29.7709506
              ],
              [
                51.0901496,
                29.7509457
              ],
              [
                51.0937595,
                29.7498364
              ],
              [
                51.1137592,
                29.7409435
              ],
              [
                51.1623719,
                29.7176111
              ],
              [
                51.1654284,
                29.7165018
              ],
              [
                51.1726518,
                29.7142832
              ],
              [
                51.1743184,
                29.7142832
              ],
              [
                51.1773749,
                29.713724
              ],
              [
                51.1895982,
                29.7126147
              ],
              [
                51.1984847,
                29.7126147
              ],
              [
                51.1998748,
                29.7123351
              ],
              [
                51.2037647,
                29.7123352
              ],
              [
                51.2051545,
                29.7120555
              ],
              [
                51.2120978,
                29.7115053
              ],
              [
                51.2159877,
                29.7115054
              ],
              [
                51.2168212,
                29.7112258
              ],
              [
                51.2234876,
                29.7112258
              ],
              [
                51.2240444,
                29.7109462
              ],
              [
                51.2268209,
                29.7109462
              ],
              [
                51.2279309,
                29.7112258
              ],
              [
                51.2340441,
                29.7112259
              ],
              [
                51.2345975,
                29.7109463
              ],
              [
                51.2409874,
                29.7106757
              ],
              [
                51.2437673,
                29.7103961
              ],
              [
                51.2446008,
                29.7103961
              ],
              [
                51.2451538,
                29.7101165
              ],
              [
                51.2468206,
                29.7101165
              ],
              [
                51.2473773,
                29.7098369
              ],
              [
                51.2487673,
                29.7098369
              ],
              [
                51.2490441,
                29.7095574
              ],
              [
                51.2504339,
                29.7095573
              ],
              [
                51.2507107,
                29.7092777
              ],
              [
                51.262377,
                29.7073387
              ],
              [
                51.2782135,
                29.7006648
              ],
              [
                51.2865468,
                29.6953978
              ],
              [
                51.2868234,
                29.6951092
              ],
              [
                51.2873801,
                29.6948386
              ],
              [
                51.2907133,
                29.6981755
              ],
              [
                51.2929333,
                29.703172
              ],
              [
                51.2943234,
                29.7176113
              ],
              [
                51.2976566,
                29.7228875
              ],
              [
                51.2982133,
                29.7237262
              ],
              [
                51.3007131,
                29.7248356
              ],
              [
                51.3057132,
                29.7251151
              ],
              [
                51.3093231,
                29.7248356
              ],
              [
                51.3112698,
                29.724556
              ],
              [
                51.312103,
                29.724556
              ],
              [
                51.314323,
                29.7242854
              ],
              [
                51.3151564,
                29.7240058
              ],
              [
                51.3248796,
                29.724556
              ],
              [
                51.3329361,
                29.7256654
              ],
              [
                51.338216,
                29.7273338
              ],
              [
                51.3404359,
                29.729282
              ],
              [
                51.3426593,
                29.729282
              ],
              [
                51.3437692,
                29.7290024
              ],
              [
                51.345716,
                29.7281727
              ],
              [
                51.3471025,
                29.727893
              ],
              [
                51.348216,
                29.7276134
              ],
              [
                51.3493258,
                29.7276135
              ],
              [
                51.3521024,
                29.7276135
              ],
              [
                51.3548825,
                29.7281727
              ],
              [
                51.3551994,
                29.728279
              ],
              [
                51.3557157,
                29.7284522
              ],
              [
                51.3568257,
                29.7284522
              ],
              [
                51.357659,
                29.7287228
              ],
              [
                51.3596058,
                29.7295616
              ],
              [
                51.3604389,
                29.7295616
              ],
              [
                51.3873818,
                29.7492865
              ],
              [
                51.388495,
                29.7501162
              ],
              [
                51.3932184,
                29.7570611
              ],
              [
                51.3934951,
                29.7595594
              ],
              [
                51.3990517,
                29.7709509
              ],
              [
                51.4009949,
                29.7734492
              ],
              [
                51.4012717,
                29.774279
              ],
              [
                51.4018283,
                29.7751179
              ],
              [
                51.4032181,
                29.7759477
              ],
              [
                51.4034949,
                29.7762273
              ],
              [
                51.4059948,
                29.7773366
              ],
              [
                51.4059949,
                29.7776162
              ],
              [
                51.4065514,
                29.7776163
              ],
              [
                51.4065514,
                29.7778959
              ],
              [
                51.4079382,
                29.778455
              ],
              [
                51.4090515,
                29.7787256
              ],
              [
                51.4093281,
                29.7790052
              ],
              [
                51.4121082,
                29.7790052
              ],
              [
                51.4126613,
                29.7792848
              ],
              [
                51.4148848,
                29.7792849
              ],
              [
                51.418218,
                29.779835
              ],
              [
                51.4251611,
                29.7817833
              ],
              [
                51.4323845,
                29.7853911
              ],
              [
                51.4337744,
                29.7859503
              ],
              [
                51.4393631,
                29.7900809
              ],
              [
                51.4721106,
                29.8142809
              ],
              [
                51.4732205,
                29.8159494
              ],
              [
                51.4737772,
                29.8167793
              ],
              [
                51.4740538,
                29.8170589
              ],
              [
                51.4746104,
                29.8170589
              ],
              [
                51.4748873,
                29.8173386
              ],
              [
                51.4879437,
                29.8295603
              ],
              [
                51.4964116,
                29.8410491
              ],
              [
                51.5121099,
                29.8623387
              ],
              [
                51.51239,
                29.8631776
              ],
              [
                51.5134998,
                29.8642871
              ],
              [
                51.5209997,
                29.8765094
              ],
              [
                51.5212762,
                29.876789
              ],
              [
                51.5234997,
                29.8790079
              ],
              [
                51.5296129,
                29.8865127
              ],
              [
                51.5298895,
                29.8873426
              ],
              [
                51.5485027,
                29.9023433
              ],
              [
                51.5507224,
                29.9037324
              ],
              [
                51.5548891,
                29.9067814
              ],
              [
                51.5590558,
                29.9087297
              ],
              [
                51.5601691,
                29.9095596
              ],
              [
                51.5679456,
                29.9109488
              ],
              [
                51.5687791,
                29.9112284
              ],
              [
                51.5760021,
                29.9106782
              ],
              [
                51.5765588,
                29.9103986
              ],
              [
                51.5798922,
                29.9103985
              ],
              [
                51.5807255,
                29.9101189
              ],
              [
                51.5976684,
                29.910119
              ],
              [
                51.5987819,
                29.9103985
              ],
              [
                51.6029484,
                29.9103986
              ],
              [
                51.6073916,
                29.9109488
              ],
              [
                51.6073917,
                29.9112285
              ],
              [
                51.6087817,
                29.9112284
              ],
              [
                51.6096151,
                29.9115081
              ],
              [
                51.6107249,
                29.9115081
              ],
              [
                51.612115,
                29.9120674
              ],
              [
                51.6132249,
                29.9120673
              ],
              [
                51.6140583,
                29.912338
              ],
              [
                51.614615,
                29.912338
              ],
              [
                51.6148916,
                29.9126176
              ],
              [
                51.6160049,
                29.9126175
              ],
              [
                51.6165582,
                29.9128972
              ],
              [
                51.6179482,
                29.9128972
              ],
              [
                51.6235048,
                29.9142864
              ],
              [
                51.6243383,
                29.9142863
              ],
              [
                51.6248949,
                29.914566
              ],
              [
                51.6273948,
                29.914566
              ],
              [
                51.6279481,
                29.9142863
              ],
              [
                51.6296147,
                29.9142864
              ],
              [
                51.632948,
                29.9134565
              ],
              [
                51.6376713,
                29.9103986
              ],
              [
                51.6379514,
                29.9098393
              ],
              [
                51.6387846,
                29.9095596
              ],
              [
                51.639618,
                29.9087298
              ],
              [
                51.6479511,
                29.9051217
              ],
              [
                51.6485045,
                29.9051217
              ],
              [
                51.6487844,
                29.9048421
              ],
              [
                51.6518378,
                29.9048421
              ],
              [
                51.6523944,
                29.9045624
              ],
              [
                51.6551711,
                29.9045624
              ],
              [
                51.6623942,
                29.9081706
              ],
              [
                51.6632276,
                29.9087299
              ],
              [
                51.6660075,
                29.9095597
              ],
              [
                51.6662841,
                29.9098394
              ],
              [
                51.6682275,
                29.9098394
              ],
              [
                51.6843406,
                29.9070701
              ],
              [
                51.6846173,
                29.9067814
              ],
              [
                51.6857306,
                29.9067815
              ],
              [
                51.6898973,
                29.9054014
              ],
              [
                51.6996205,
                29.9012339
              ],
              [
                51.699897,
                29.9009543
              ],
              [
                51.7015637,
                29.8995652
              ],
              [
                51.7018403,
                29.8992855
              ],
              [
                51.7129512,
                29.88818
              ],
              [
                51.7187869,
                29.8823456
              ],
              [
                51.7193435,
                29.8812271
              ],
              [
                51.7201768,
                29.8803972
              ],
              [
                51.72073,
                29.8801176
              ],
              [
                51.7212867,
                29.8790082
              ],
              [
                51.7346199,
                29.8665062
              ],
              [
                51.7387865,
                29.8640077
              ],
              [
                51.7404531,
                29.8631779
              ],
              [
                51.7635094,
                29.8534543
              ],
              [
                51.7637895,
                29.8531747
              ],
              [
                51.7648994,
                29.8531747
              ],
              [
                51.7887891,
                29.8445606
              ],
              [
                51.7940691,
                29.8440104
              ],
              [
                51.7949024,
                29.8437308
              ],
              [
                51.7957358,
                29.8437308
              ],
              [
                51.7960123,
                29.8434511
              ],
              [
                51.796569,
                29.8434512
              ],
              [
                51.7968458,
                29.8431716
              ],
              [
                51.7982356,
                29.8431716
              ],
              [
                51.8010122,
                29.8420621
              ],
              [
                51.8015691,
                29.8420622
              ],
              [
                51.8018456,
                29.8417825
              ],
              [
                51.8032357,
                29.8417826
              ],
              [
                51.8035123,
                29.8420621
              ],
              [
                51.8046223,
                29.8420621
              ],
              [
                51.8051789,
                29.8423417
              ],
              [
                51.8054555,
                29.8431716
              ],
              [
                51.8060121,
                29.8440104
              ],
              [
                51.8071256,
                29.851506
              ],
              [
                51.8076789,
                29.8526154
              ],
              [
                51.8074022,
                29.8528951
              ],
              [
                51.813512,
                29.8831755
              ],
              [
                51.8154587,
                29.8862243
              ],
              [
                51.8246253,
                29.8915102
              ],
              [
                51.8276818,
                29.8920694
              ],
              [
                51.8301818,
                29.8920695
              ],
              [
                51.838515,
                29.8898415
              ],
              [
                51.8479581,
                29.8817864
              ],
              [
                51.8496247,
                29.8809566
              ],
              [
                51.8504582,
                29.8801177
              ],
              [
                51.860738,
                29.8751205
              ],
              [
                51.8612914,
                29.8745613
              ],
              [
                51.8857378,
                29.8673452
              ],
              [
                51.889071,
                29.8659561
              ],
              [
                51.9440734,
                29.8401139
              ],
              [
                51.9465734,
                29.8392841
              ],
              [
                51.9468535,
                29.8390045
              ],
              [
                51.9562967,
                29.8359558
              ],
              [
                51.9582434,
                29.8351169
              ],
              [
                51.9618532,
                29.8345668
              ],
              [
                51.9632433,
                29.8340075
              ],
              [
                51.9643533,
                29.8340075
              ],
              [
                51.9649099,
                29.8337279
              ],
              [
                51.9662965,
                29.8337278
              ],
              [
                51.9668531,
                29.8334483
              ],
              [
                51.9768531,
                29.8334482
              ],
              [
                51.9779665,
                29.8337279
              ],
              [
                51.9851863,
                29.8337279
              ],
              [
                51.9929661,
                29.8331777
              ],
              [
                51.9943529,
                29.8328981
              ],
              [
                51.9954662,
                29.8331776
              ],
              [
                51.9971328,
                29.8331777
              ],
              [
                51.9976894,
                29.8331777
              ],
              [
                51.997966,
                29.8334483
              ],
              [
                51.9985229,
                29.8334483
              ],
              [
                51.9996326,
                29.8334483
              ],
              [
                52.000022,
                29.8337279
              ],
              [
                52.0021327,
                29.8337279
              ],
              [
                52.0029661,
                29.8340076
              ],
              [
                52.0060225,
                29.8340075
              ],
              [
                52.006576,
                29.8342872
              ],
              [
                52.0151891,
                29.8342872
              ],
              [
                52.0160226,
                29.8345668
              ],
              [
                52.0168558,
                29.8342871
              ],
              [
                52.0235223,
                29.8348374
              ],
              [
                52.0249123,
                29.8353966
              ],
              [
                52.0260223,
                29.8353966
              ],
              [
                52.0276889,
                29.8359559
              ],
              [
                52.028799,
                29.8359558
              ],
              [
                52.0354688,
                29.8378951
              ],
              [
                52.0363022,
                29.8378951
              ],
              [
                52.0415787,
                29.8401141
              ],
              [
                52.0443554,
                29.8412325
              ],
              [
                52.0499121,
                29.8445608
              ],
              [
                52.0618586,
                29.8498465
              ],
              [
                52.0643584,
                29.8506763
              ],
              [
                52.0885246,
                29.8626188
              ],
              [
                52.0982478,
                29.8709534
              ],
              [
                52.0988045,
                29.8712331
              ],
              [
                52.0991589,
                29.8717048
              ],
              [
                52.1096377,
                29.8834553
              ],
              [
                52.1104711,
                29.8848355
              ],
              [
                52.1104711,
                29.8851241
              ],
              [
                52.1115812,
                29.8870635
              ],
              [
                52.1265808,
                29.9181746
              ],
              [
                52.1274139,
                29.9209529
              ],
              [
                52.1294968,
                29.9234113
              ],
              [
                52.1265808,
                29.9262299
              ],
              [
                52.0815814,
                29.9542929
              ],
              [
                52.0813014,
                29.9545635
              ],
              [
                52.0418553,
                29.9806787
              ],
              [
                52.0410219,
                29.9806786
              ],
              [
                52.0399119,
                29.9812289
              ],
              [
                52.038802,
                29.9812289
              ],
              [
                52.038522,
                29.9815085
              ],
              [
                52.0376887,
                29.9815085
              ],
              [
                52.0374121,
                29.9812289
              ],
              [
                52.0363021,
                29.9812289
              ],
              [
                52.0351888,
                29.9815086
              ],
              [
                52.0332454,
                29.9815086
              ],
              [
                52.0307456,
                29.9820679
              ],
              [
                52.0293555,
                29.9820678
              ],
              [
                52.0276888,
                29.9826181
              ],
              [
                52.0240788,
                29.9826182
              ],
              [
                52.0174123,
                29.984287
              ],
              [
                52.0157456,
                29.9851169
              ],
              [
                52.013799,
                29.9901235
              ],
              [
                52.0135224,
                29.9906738
              ],
              [
                52.0137989,
                29.9923427
              ],
              [
                52.023799,
                29.9998481
              ],
              [
                52.0244927,
                30.0022887
              ],
              [
                52.0505875,
                30.0042829
              ],
              [
                52.0404632,
                30.0276939
              ],
              [
                52.0369818,
                30.0357413
              ],
              [
                52.0354134,
                30.0393664
              ],
              [
                51.9977826,
                30.0285428
              ],
              [
                51.983343,
                30.0290876
              ],
              [
                51.9661335,
                30.0327245
              ],
              [
                51.9514497,
                30.0442532
              ],
              [
                51.9504632,
                30.0456845
              ],
              [
                51.9474067,
                30.0487337
              ],
              [
                51.9462967,
                30.0492931
              ],
              [
                51.9296302,
                30.0681748
              ],
              [
                51.9279636,
                30.0692844
              ],
              [
                51.9221304,
                30.0748417
              ],
              [
                51.9101837,
                30.0815085
              ],
              [
                51.9087938,
                30.0820679
              ],
              [
                51.9046272,
                30.0834572
              ],
              [
                51.9032406,
                30.0834572
              ],
              [
                51.9029606,
                30.0837369
              ],
              [
                51.8951841,
                30.0837369
              ],
              [
                51.8946274,
                30.0834572
              ],
              [
                51.8937939,
                30.0834572
              ],
              [
                51.8918508,
                30.0828979
              ],
              [
                51.8907375,
                30.0828979
              ],
              [
                51.8837942,
                30.0809583
              ],
              [
                51.882404,
                30.0809583
              ],
              [
                51.8821275,
                30.0806786
              ],
              [
                51.8815709,
                30.0806786
              ],
              [
                51.8718476,
                30.0776203
              ],
              [
                51.871571,
                30.0778999
              ],
              [
                51.8710144,
                30.0776203
              ],
              [
                51.8682378,
                30.0773496
              ],
              [
                51.8612912,
                30.0759603
              ],
              [
                51.855738,
                30.0759603
              ],
              [
                51.8549046,
                30.0762399
              ],
              [
                51.8529578,
                30.07624
              ],
              [
                51.8521247,
                30.0765106
              ],
              [
                51.8512913,
                30.0765106
              ],
              [
                51.850458,
                30.0767903
              ],
              [
                51.849348,
                30.0767903
              ],
              [
                51.8354583,
                30.0806785
              ],
              [
                51.8343484,
                30.0806786
              ],
              [
                51.8340682,
                30.0809582
              ],
              [
                51.831015,
                30.0815085
              ],
              [
                51.8299015,
                30.0820678
              ],
              [
                51.8290684,
                30.0820678
              ],
              [
                51.8287916,
                30.0823475
              ],
              [
                51.8268484,
                30.0828978
              ],
              [
                51.8262917,
                30.0834572
              ],
              [
                51.8249016,
                30.0837368
              ],
              [
                51.7896221,
                30.1001201
              ],
              [
                51.7893455,
                30.1003997
              ],
              [
                51.779899,
                30.1056774
              ],
              [
                51.7729558,
                30.1109551
              ],
              [
                51.7726792,
                30.1112348
              ],
              [
                51.7712774,
                30.1125335
              ],
              [
                51.7685092,
                30.1167922
              ],
              [
                51.7676757,
                30.1204009
              ],
              [
                51.7673992,
                30.1231796
              ],
              [
                51.7679559,
                30.1312361
              ],
              [
                51.7682324,
                30.1326255
              ],
              [
                51.7715657,
                30.1392926
              ],
              [
                51.7721224,
                30.139843
              ],
              [
                51.7721223,
                30.1404024
              ],
              [
                51.7746224,
                30.1429015
              ],
              [
                51.7750385,
                30.1433196
              ],
              [
                51.7760125,
                30.1442908
              ],
              [
                51.7762416,
                30.1445227
              ],
              [
                51.7768457,
                30.1448502
              ],
              [
                51.7782322,
                30.1448502
              ],
              [
                51.7848989,
                30.1495686
              ],
              [
                51.7849904,
                30.1496601
              ],
              [
                51.7851788,
                30.1498484
              ],
              [
                51.7962887,
                30.1526272
              ],
              [
                51.7982353,
                30.1526271
              ],
              [
                51.7990687,
                30.1529068
              ],
              [
                51.8012886,
                30.1529068
              ],
              [
                51.8021218,
                30.1531865
              ],
              [
                51.8062886,
                30.1531865
              ],
              [
                51.8076786,
                30.1529068
              ],
              [
                51.8112917,
                30.1529068
              ],
              [
                51.8121252,
                30.1526272
              ],
              [
                51.8182351,
                30.1526271
              ],
              [
                51.8285149,
                30.1540165
              ],
              [
                51.8324015,
                30.1540166
              ],
              [
                51.8340681,
                30.1542962
              ],
              [
                51.8387915,
                30.1542962
              ],
              [
                51.8424013,
                30.1545669
              ],
              [
                51.867961,
                30.1604042
              ],
              [
                51.8699044,
                30.1604042
              ],
              [
                51.870461,
                30.1606838
              ],
              [
                51.8735142,
                30.1606838
              ],
              [
                51.8743476,
                30.1604042
              ],
              [
                51.8757374,
                30.1604042
              ],
              [
                51.8768475,
                30.1606839
              ],
              [
                51.8790707,
                30.1606839
              ],
              [
                51.8799041,
                30.1595741
              ],
              [
                51.8968506,
                30.1676219
              ],
              [
                51.8968506,
                30.1679015
              ],
              [
                51.8990705,
                30.17096
              ],
              [
                51.9741198,
                30.1298968
              ],
              [
                51.9739983,
                30.133804
              ],
              [
                51.9612185,
                30.1693759
              ],
              [
                51.9609416,
                30.170766
              ],
              [
                51.9573318,
                30.1777162
              ],
              [
                51.9531619,
                30.1841068
              ],
              [
                51.9373287,
                30.2021686
              ],
              [
                51.9362187,
                30.2035587
              ],
              [
                51.9276054,
                30.2121789
              ],
              [
                51.8892727,
                30.2449635
              ],
              [
                51.866493,
                30.2638656
              ],
              [
                51.813157,
                30.3019321
              ],
              [
                51.8117671,
                30.3030423
              ],
              [
                51.8109336,
                30.3036021
              ],
              [
                51.8020438,
                30.3097134
              ],
              [
                51.7508455,
                30.3608145
              ],
              [
                51.6590604,
                30.4159666
              ],
              [
                51.6579503,
                30.4162463
              ],
              [
                51.6576738,
                30.4165261
              ],
              [
                51.6521173,
                30.418466
              ],
              [
                51.6487838,
                30.4184662
              ],
              [
                51.6465605,
                30.4187458
              ],
              [
                51.6454505,
                30.4192963
              ],
              [
                51.6396174,
                30.4217957
              ],
              [
                51.6337808,
                30.4267948
              ],
              [
                51.6332274,
                30.4279139
              ],
              [
                51.6321141,
                30.4290147
              ],
              [
                51.6282275,
                30.4376323
              ],
              [
                51.6273941,
                30.4401318
              ],
              [
                51.6273942,
                30.4404026
              ],
              [
                51.6260042,
                30.440962
              ],
              [
                51.6251709,
                30.4412418
              ],
              [
                51.6193375,
                30.4437414
              ],
              [
                51.6112812,
                30.4437413
              ],
              [
                51.6040578,
                30.4412418
              ],
              [
                51.5837814,
                30.4234651
              ],
              [
                51.5790582,
                30.4223552
              ],
              [
                51.5762782,
                30.4223552
              ],
              [
                51.5746115,
                30.4223552
              ],
              [
                51.5607218,
                30.4265151
              ],
              [
                51.5487786,
                30.4317939
              ],
              [
                51.5348889,
                30.4348529
              ],
              [
                51.5329455,
                30.4348529
              ],
              [
                51.5326654,
                30.4351327
              ],
              [
                51.5290555,
                30.4356831
              ],
              [
                51.528499,
                30.4354034
              ],
              [
                51.5279457,
                30.4356832
              ],
              [
                51.5271124,
                30.4356831
              ],
              [
                51.526279,
                30.4354034
              ],
              [
                51.523499,
                30.4354033
              ],
              [
                51.5229424,
                30.4356831
              ],
              [
                51.522109,
                30.4356831
              ],
              [
                51.5215556,
                30.4343024
              ],
              [
                51.5215557,
                30.4340227
              ],
              [
                51.5211375,
                30.4256798
              ],
              [
                51.5207942,
                30.4192591
              ],
              [
                51.520923,
                30.4170016
              ],
              [
                51.5246137,
                30.4099142
              ],
              [
                51.5304502,
                30.402049
              ],
              [
                51.5392693,
                30.3966818
              ],
              [
                51.543475,
                30.3930171
              ],
              [
                51.5498479,
                30.3854096
              ],
              [
                51.5540965,
                30.3795047
              ],
              [
                51.5557917,
                30.3767835
              ],
              [
                51.5608397,
                30.3701628
              ],
              [
                51.5648952,
                30.3635534
              ],
              [
                51.5703026,
                30.354592
              ],
              [
                51.5728989,
                30.3475926
              ],
              [
                51.5736285,
                30.3405928
              ],
              [
                51.5727487,
                30.3339814
              ],
              [
                51.572139,
                30.3322578
              ],
              [
                51.5706155,
                30.3202188
              ],
              [
                51.5702293,
                30.3125316
              ],
              [
                51.5706584,
                30.3099567
              ],
              [
                51.5725038,
                30.3033803
              ],
              [
                51.5740916,
                30.2986746
              ],
              [
                51.5819022,
                30.280072
              ],
              [
                51.5896699,
                30.2641533
              ],
              [
                51.5921375,
                30.2557759
              ],
              [
                51.592159,
                30.2512718
              ],
              [
                51.5911756,
                30.2450736
              ],
              [
                51.5910015,
                30.243743
              ],
              [
                51.5907226,
                30.241533
              ],
              [
                51.5900415,
                30.2365182
              ],
              [
                51.5849561,
                30.2297143
              ],
              [
                51.5777678,
                30.2225392
              ],
              [
                51.5657515,
                30.216439
              ],
              [
                51.5540785,
                30.2143252
              ],
              [
                51.546976,
                30.2060316
              ],
              [
                51.5328139,
                30.1925305
              ],
              [
                51.5298313,
                30.1875599
              ],
              [
                51.5280718,
                30.1865027
              ],
              [
                51.5268356,
                30.1836952
              ],
              [
                51.5256559,
                30.1844134
              ],
              [
                51.5249263,
                30.1848586
              ],
              [
                51.5216433,
                30.1882343
              ],
              [
                51.5155707,
                30.1927412
              ],
              [
                51.512674,
                30.1972851
              ],
              [
                51.5088545,
                30.2014578
              ],
              [
                51.5064512,
                30.2064092
              ],
              [
                51.5042196,
                30.2108782
              ],
              [
                51.5018164,
                30.2111749
              ],
              [
                51.4998208,
                30.2117312
              ],
              [
                51.4985119,
                30.2133259
              ],
              [
                51.496924,
                30.2150504
              ],
              [
                51.4921604,
                30.2201494
              ],
              [
                51.4858733,
                30.2240431
              ],
              [
                51.4851867,
                30.2259713
              ],
              [
                51.4848863,
                30.2275472
              ],
              [
                51.482998,
                30.2297535
              ],
              [
                51.4776336,
                30.2344254
              ],
              [
                51.4753805,
                30.2378365
              ],
              [
                51.470574,
                30.2404688
              ],
              [
                51.4664112,
                30.2413633
              ],
              [
                51.4636646,
                30.2407701
              ],
              [
                51.4608966,
                30.2405291
              ],
              [
                51.4587079,
                30.2394168
              ],
              [
                51.457635,
                30.2379338
              ],
              [
                51.4562832,
                30.2361541
              ],
              [
                51.4526354,
                30.2330025
              ],
              [
                51.4492665,
                30.2316491
              ],
              [
                51.4461337,
                30.2309817
              ],
              [
                51.4434515,
                30.2303699
              ],
              [
                51.4418851,
                30.2303699
              ],
              [
                51.4395891,
                30.2293688
              ],
              [
                51.4375936,
                30.2296098
              ],
              [
                51.4351259,
                30.229925
              ],
              [
                51.4325296,
                30.2305924
              ],
              [
                51.4318644,
                30.2317789
              ],
              [
                51.4309417,
                30.232298
              ],
              [
                51.4275943,
                30.2321312
              ],
              [
                51.4237748,
                30.2332435
              ],
              [
                51.4202558,
                30.2343373
              ],
              [
                51.4162217,
                30.2371737
              ],
              [
                51.4146124,
                30.2379523
              ],
              [
                51.4115225,
                30.2381933
              ],
              [
                51.4078961,
                30.2378411
              ],
              [
                51.4070164,
                30.2376928
              ],
              [
                51.4051496,
                30.2356721
              ],
              [
                51.4036904,
                30.2349306
              ],
              [
                51.4015661,
                30.2342261
              ],
              [
                51.3992916,
                30.2343559
              ],
              [
                51.3975535,
                30.2333918
              ],
              [
                51.3944207,
                30.2313896
              ],
              [
                51.3933264,
                30.2307036
              ],
              [
                51.3897644,
                30.2296283
              ],
              [
                51.3894425,
                30.2286272
              ],
              [
                51.388019,
                30.2277775
              ],
              [
                51.3868458,
                30.2267578
              ],
              [
                51.3834946,
                30.2328977
              ],
              [
                51.3768281,
                30.2409639
              ],
              [
                51.376828,
                30.2412436
              ],
              [
                51.3764074,
                30.2415143
              ],
              [
                51.3759948,
                30.241794
              ],
              [
                51.3754379,
                30.2417939
              ],
              [
                51.3751614,
                30.2420736
              ],
              [
                51.3615483,
                30.2356856
              ],
              [
                51.3557149,
                30.2334571
              ],
              [
                51.3521016,
                30.2334571
              ],
              [
                51.3512684,
                30.2337368
              ],
              [
                51.3501584,
                30.2337368
              ],
              [
                51.338492,
                30.2398541
              ],
              [
                51.3293254,
                30.2501307
              ],
              [
                51.3243255,
                30.2531804
              ],
              [
                51.3237688,
                30.2537397
              ],
              [
                51.3168256,
                30.2565188
              ],
              [
                51.3051556,
                30.2587383
              ],
              [
                51.3040458,
                30.2592977
              ],
              [
                51.3032124,
                30.2592977
              ],
              [
                51.2990457,
                30.2604075
              ],
              [
                51.2968225,
                30.2604075
              ],
              [
                51.2884894,
                30.2573488
              ],
              [
                51.2865461,
                30.2570692
              ],
              [
                51.2854326,
                30.2570691
              ],
              [
                51.2845993,
                30.2573488
              ],
              [
                51.284046,
                30.2573488
              ],
              [
                51.284046,
                30.2576286
              ],
              [
                51.2834894,
                30.2576285
              ],
              [
                51.281546,
                30.2620767
              ],
              [
                51.2812661,
                30.262627
              ],
              [
                51.281546,
                30.2656857
              ],
              [
                51.2809893,
                30.2667866
              ],
              [
                51.2787661,
                30.2679054
              ],
              [
                51.2759894,
                30.2679053
              ],
              [
                51.2754328,
                30.2676256
              ],
              [
                51.2729328,
                30.2676256
              ],
              [
                51.2723761,
                30.2679053
              ],
              [
                51.2712661,
                30.2679053
              ],
              [
                51.2662662,
                30.2712347
              ],
              [
                51.2634896,
                30.275683
              ],
              [
                51.2632097,
                30.2759626
              ],
              [
                51.2629329,
                30.2756829
              ],
              [
                51.2490432,
                30.2640165
              ],
              [
                51.2387633,
                30.2567984
              ],
              [
                51.2379299,
                30.2520705
              ],
              [
                51.2354301,
                30.250681
              ],
              [
                51.2345967,
                30.250681
              ],
              [
                51.2326535,
                30.249851
              ],
              [
                51.2315435,
                30.249851
              ],
              [
                51.2312634,
                30.2495712
              ],
              [
                51.23043,
                30.2495712
              ],
              [
                51.2301535,
                30.2492915
              ],
              [
                51.2276536,
                30.2490208
              ],
              [
                51.2251536,
                30.2481818
              ],
              [
                51.2184871,
                30.2417937
              ],
              [
                51.2148736,
                30.240684
              ],
              [
                51.2129303,
                30.240684
              ],
              [
                51.2123736,
                30.2404042
              ],
              [
                51.2115405,
                30.2404043
              ],
              [
                51.2115404,
                30.2401246
              ],
              [
                51.2109871,
                30.2398539
              ],
              [
                51.210707,
                30.2392945
              ],
              [
                51.2101539,
                30.2390148
              ],
              [
                51.2082071,
                30.2367953
              ],
              [
                51.2076539,
                30.2367952
              ],
              [
                51.2073737,
                30.2365156
              ],
              [
                51.2062638,
                30.2365156
              ],
              [
                51.2059872,
                30.2362359
              ],
              [
                51.1968173,
                30.2354058
              ],
              [
                51.1948739,
                30.2323472
              ],
              [
                51.1945973,
                30.2309577
              ],
              [
                51.1945974,
                30.230678
              ],
              [
                51.1929307,
                30.2273487
              ],
              [
                51.1923741,
                30.227069
              ],
              [
                51.1912641,
                30.2259593
              ],
              [
                51.189874,
                30.2190119
              ],
              [
                51.1862643,
                30.2156827
              ],
              [
                51.1840409,
                30.2109549
              ],
              [
                51.1836495,
                30.2105155
              ],
              [
                51.1832076,
                30.2098453
              ],
              [
                51.1832077,
                30.2092948
              ],
              [
                51.1820942,
                30.2079054
              ],
              [
                51.1779276,
                30.2062363
              ],
              [
                51.1693178,
                30.2120647
              ],
              [
                51.1626512,
                30.2090151
              ],
              [
                51.1593178,
                30.2090152
              ],
              [
                51.1584846,
                30.2092948
              ],
              [
                51.1551514,
                30.2095655
              ],
              [
                51.1545946,
                30.2087355
              ],
              [
                51.1537613,
                30.2084558
              ],
              [
                51.1532046,
                30.2081851
              ],
              [
                51.1523712,
                30.2079054
              ],
              [
                51.1518181,
                30.2079054
              ],
              [
                51.1509846,
                30.2076257
              ],
              [
                51.1487614,
                30.2076257
              ],
              [
                51.1470948,
                30.2106843
              ],
              [
                51.1473713,
                30.2126241
              ],
              [
                51.1482616,
                30.2140891
              ],
              [
                51.1423714,
                30.2156827
              ],
              [
                51.1320951,
                30.2092948
              ],
              [
                51.1304283,
                30.207346
              ],
              [
                51.131815,
                30.2067957
              ],
              [
                51.1334816,
                30.2067956
              ],
              [
                51.1340383,
                30.2065159
              ],
              [
                51.1351482,
                30.2065159
              ],
              [
                51.1354284,
                30.2067957
              ],
              [
                51.137095,
                30.2067956
              ],
              [
                51.138205,
                30.2062362
              ],
              [
                51.138205,
                30.2056858
              ],
              [
                51.1373716,
                30.2040168
              ],
              [
                51.1368149,
                30.2040168
              ],
              [
                51.1365382,
                30.203737
              ],
              [
                51.1348715,
                30.2031867
              ],
              [
                51.1343149,
                30.2026273
              ],
              [
                51.1345949,
                30.2020679
              ],
              [
                51.134595,
                30.2012379
              ],
              [
                51.1337617,
                30.2006785
              ],
              [
                51.1309816,
                30.1992891
              ],
              [
                51.129315,
                30.199289
              ],
              [
                51.1270917,
                30.2009582
              ],
              [
                51.1215385,
                30.2009582
              ],
              [
                51.1209819,
                30.2006785
              ],
              [
                51.1201484,
                30.2006784
              ],
              [
                51.1182052,
                30.1990093
              ],
              [
                51.1090387,
                30.1881826
              ],
              [
                51.1079253,
                30.1881826
              ],
              [
                51.1076488,
                30.1879029
              ],
              [
                51.1065353,
                30.1876232
              ],
              [
                51.1045921,
                30.1876232
              ],
              [
                51.1040355,
                30.1890127
              ],
              [
                51.1034821,
                30.1901224
              ],
              [
                51.1040354,
                30.1970695
              ],
              [
                51.1004254,
                30.1995686
              ],
              [
                51.0957022,
                30.1973492
              ],
              [
                51.0962589,
                30.1962394
              ],
              [
                51.0965355,
                30.1951297
              ],
              [
                51.0945923,
                30.1909525
              ],
              [
                51.0920922,
                30.1909524
              ],
              [
                51.090149,
                30.1915118
              ],
              [
                51.0884789,
                30.1934606
              ],
              [
                51.0873689,
                30.19402
              ],
              [
                51.0868122,
                30.1978996
              ],
              [
                51.085979,
                30.1998483
              ],
              [
                51.0851456,
                30.1995687
              ],
              [
                51.0820924,
                30.1990093
              ],
              [
                51.0801457,
                30.1990093
              ],
              [
                51.0765359,
                30.200128
              ],
              [
                51.0754259,
                30.2003987
              ],
              [
                51.0662558,
                30.2003987
              ],
              [
                51.0634794,
                30.1984589
              ],
              [
                51.0629225,
                30.1973492
              ],
              [
                51.0623694,
                30.1962394
              ],
              [
                51.062646,
                30.1959598
              ],
              [
                51.0623694,
                30.1954003
              ],
              [
                51.0612559,
                30.1915118
              ],
              [
                51.0576461,
                30.1898427
              ],
              [
                51.0570894,
                30.1901223
              ],
              [
                51.0559795,
                30.1901224
              ],
              [
                51.0557029,
                30.190402
              ],
              [
                51.0532028,
                30.189572
              ],
              [
                51.0529227,
                30.1870728
              ],
              [
                51.0526462,
                30.1865134
              ],
              [
                51.0529228,
                30.1848534
              ],
              [
                51.0532029,
                30.1845736
              ],
              [
                51.0529227,
                30.1840144
              ],
              [
                51.0523695,
                30.1817948
              ],
              [
                51.050423,
                30.1806761
              ],
              [
                51.0501462,
                30.1809557
              ],
              [
                51.0462562,
                30.1809558
              ],
              [
                51.0448661,
                30.1823452
              ],
              [
                51.044313,
                30.1823452
              ],
              [
                51.044313,
                30.1826248
              ],
              [
                51.042923,
                30.1826249
              ],
              [
                51.0426464,
                30.1823452
              ],
              [
                51.041813,
                30.1823451
              ],
              [
                51.0418131,
                30.1820655
              ],
              [
                51.0381997,
                30.1795664
              ],
              [
                51.034313,
                30.1792957
              ],
              [
                51.0326431,
                30.1809557
              ],
              [
                51.0320897,
                30.1809557
              ],
              [
                51.0309765,
                30.1773469
              ],
              [
                51.0304232,
                30.1770672
              ],
              [
                51.0281998,
                30.1770672
              ],
              [
                51.0279233,
                30.1773469
              ],
              [
                51.0270899,
                30.1773469
              ],
              [
                51.0259766,
                30.178186
              ],
              [
                51.0248666,
                30.1817948
              ],
              [
                51.0245899,
                30.1826249
              ],
              [
                51.0234765,
                30.1840143
              ],
              [
                51.0201433,
                30.1823452
              ],
              [
                51.0165335,
                30.1795663
              ],
              [
                51.0154234,
                30.1792956
              ],
              [
                51.01431,
                30.1792957
              ],
              [
                51.0140334,
                30.179016
              ],
              [
                51.0134768,
                30.179016
              ],
              [
                51.0132002,
                30.1787363
              ],
              [
                50.9998532,
                30.1734583
              ],
              [
                50.9987536,
                30.1734583
              ],
              [
                50.9987536,
                30.173738
              ],
              [
                50.9962536,
                30.1762372
              ],
              [
                50.994867,
                30.1767965
              ],
              [
                50.9915304,
                30.1767965
              ],
              [
                50.9903616,
                30.1763437
              ],
              [
                50.989587,
                30.176237
              ],
              [
                50.9806972,
                30.1670707
              ],
              [
                50.9606975,
                30.1579042
              ],
              [
                50.9579209,
                30.1567855
              ],
              [
                50.9559742,
                30.1559554
              ],
              [
                50.9398645,
                30.1420616
              ],
              [
                50.9393078,
                30.1417909
              ],
              [
                50.9390314,
                30.1412316
              ],
              [
                50.9373611,
                30.1401218
              ],
              [
                50.9373611,
                30.1398422
              ],
              [
                50.9370846,
                30.1395716
              ],
              [
                50.9354179,
                30.1359537
              ],
              [
                50.9248614,
                30.1151223
              ],
              [
                50.9245848,
                30.1126233
              ],
              [
                50.9218082,
                30.1012288
              ],
              [
                50.9215281,
                30.0937319
              ],
              [
                50.9218082,
                30.0923426
              ],
              [
                50.9220848,
                30.0904029
              ],
              [
                50.9223616,
                30.0898435
              ],
              [
                50.9223616,
                30.0890136
              ],
              [
                50.9226416,
                30.0848456
              ],
              [
                50.9229182,
                30.0840066
              ],
              [
                50.919585,
                30.0662342
              ],
              [
                50.9159717,
                30.0584487
              ],
              [
                50.9045853,
                30.0373388
              ],
              [
                50.9031953,
                30.03484
              ],
              [
                50.897362,
                30.0248444
              ],
              [
                50.8881954,
                30.014849
              ],
              [
                50.8870821,
                30.0145604
              ],
              [
                50.8745823,
                30.0095626
              ],
              [
                50.8668058,
                30.0056746
              ],
              [
                50.8665257,
                30.0051243
              ],
              [
                50.8626393,
                29.9987284
              ],
              [
                50.8648545,
                29.9818216
              ],
              [
                50.864859,
                29.9817871
              ],
              [
                50.8648591,
                29.9812278
              ],
              [
                50.8604158,
                29.9737315
              ],
              [
                50.8465261,
                29.9656759
              ],
              [
                50.8365264,
                29.9631771
              ],
              [
                50.8354129,
                29.9634568
              ],
              [
                50.8337462,
                29.9634567
              ],
              [
                50.8234698,
                29.964846
              ],
              [
                50.8162465,
                29.967065
              ],
              [
                50.8073567,
                29.9715123
              ],
              [
                50.7951336,
                29.9776194
              ],
              [
                50.7837438,
                29.9840151
              ],
              [
                50.7829103,
                29.9842858
              ],
              [
                50.7612441,
                29.9920618
              ],
              [
                50.7598541,
                29.9920618
              ],
              [
                50.7593007,
                29.9923414
              ],
              [
                50.7581874,
                29.9923414
              ],
              [
                50.7568009,
                29.9926211
              ],
              [
                50.7543008,
                29.992621
              ],
              [
                50.7342977,
                29.9909522
              ],
              [
                50.7329111,
                29.9912318
              ],
              [
                50.7220746,
                29.9934509
              ],
              [
                50.7170748,
                29.9948402
              ],
              [
                50.7137412,
                29.9948402
              ],
              [
                50.7126315,
                29.9951198
              ],
              [
                50.7098513,
                29.9951198
              ],
              [
                50.7090181,
                29.9953995
              ],
              [
                50.7037415,
                29.9956701
              ],
              [
                50.697075,
                29.9956701
              ],
              [
                50.6954085,
                29.9959588
              ],
              [
                50.686795,
                29.9959588
              ],
              [
                50.6865185,
                29.9956701
              ],
              [
                50.6837419,
                29.9945605
              ],
              [
                50.6834618,
                29.9940102
              ],
              [
                50.6787419,
                29.9898425
              ],
              [
                50.6781852,
                29.9892832
              ],
              [
                50.6670721,
                29.9767893
              ],
              [
                50.6609622,
                29.9792881
              ],
              [
                50.660129,
                29.9801179
              ],
              [
                50.6559622,
                29.9778989
              ],
              [
                50.6545723,
                29.9767893
              ],
              [
                50.6515156,
                29.9773396
              ],
              [
                50.6498491,
                29.9773395
              ],
              [
                50.6479057,
                29.9778989
              ],
              [
                50.6459624,
                29.9787288
              ],
              [
                50.6429056,
                29.9770599
              ],
              [
                50.637906,
                29.971512
              ],
              [
                50.6365157,
                29.9709528
              ],
              [
                50.635959,
                29.9712325
              ],
              [
                50.6337395,
                29.9712324
              ],
              [
                50.6304058,
                29.9704025
              ],
              [
                50.6273495,
                29.9659552
              ],
              [
                50.6259592,
                29.9645661
              ],
              [
                50.6254062,
                29.9648456
              ],
              [
                50.6245729,
                29.9648457
              ],
              [
                50.6242928,
                29.9651254
              ],
              [
                50.6234592,
                29.9648457
              ],
              [
                50.6229062,
                29.9642864
              ],
              [
                50.622626,
                29.9640067
              ],
              [
                50.6220728,
                29.9631769
              ],
              [
                50.6223495,
                29.962338
              ],
              [
                50.622626,
                29.9620674
              ],
              [
                50.6223495,
                29.9606781
              ],
              [
                50.6217928,
                29.9603984
              ],
              [
                50.6215162,
                29.9598392
              ],
              [
                50.6201259,
                29.9598392
              ],
              [
                50.6187396,
                29.9603984
              ],
              [
                50.6173493,
                29.9603985
              ],
              [
                50.6167927,
                29.9601188
              ],
              [
                50.6159594,
                29.9601188
              ],
              [
                50.6151262,
                29.9573404
              ],
              [
                50.614293,
                29.9576201
              ],
              [
                50.6126263,
                29.9573404
              ],
              [
                50.6112364,
                29.954562
              ],
              [
                50.609293,
                29.952343
              ],
              [
                50.6031831,
                29.9437282
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555219,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مهر",
          "name:en": "Mohr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270570",
          "wikipedia": "en:Mohr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.3632622,
                28.0150771
              ],
              [
                52.3640954,
                28.014807
              ],
              [
                52.3646488,
                28.014807
              ],
              [
                52.3685388,
                28.0123043
              ],
              [
                52.3760385,
                28.0059127
              ],
              [
                52.3774286,
                28.0042473
              ],
              [
                52.3782619,
                28.0036892
              ],
              [
                52.3802053,
                28.0014746
              ],
              [
                52.3821519,
                27.998693
              ],
              [
                52.3875574,
                27.993546
              ],
              [
                52.3879852,
                27.9931387
              ],
              [
                52.3893717,
                27.9892497
              ],
              [
                52.3896518,
                27.9881334
              ],
              [
                52.3899284,
                27.9873053
              ],
              [
                52.390205,
                27.9856309
              ],
              [
                52.3904851,
                27.9839746
              ],
              [
                52.3910383,
                27.9809139
              ],
              [
                52.3913184,
                27.9792485
              ],
              [
                52.391595,
                27.9775832
              ],
              [
                52.3918717,
                27.9753597
              ],
              [
                52.3932617,
                27.9684102
              ],
              [
                52.4015949,
                27.9484086
              ],
              [
                52.4027083,
                27.9473013
              ],
              [
                52.4029849,
                27.9470223
              ],
              [
                52.4067187,
                27.940786
              ],
              [
                52.4071515,
                27.9403521
              ],
              [
                52.4271512,
                27.9122951
              ],
              [
                52.4363211,
                27.8956342
              ],
              [
                52.4365978,
                27.8950762
              ],
              [
                52.4415976,
                27.8859133
              ],
              [
                52.442431,
                27.8850763
              ],
              [
                52.4429876,
                27.8839692
              ],
              [
                52.4496543,
                27.8720252
              ],
              [
                52.4499309,
                27.8717462
              ],
              [
                52.4552109,
                27.8561842
              ],
              [
                52.4552108,
                27.8550773
              ],
              [
                52.4579875,
                27.8470219
              ],
              [
                52.4582641,
                27.8464638
              ],
              [
                52.4585441,
                27.8461849
              ],
              [
                52.4640974,
                27.8373016
              ],
              [
                52.486877,
                27.8095185
              ],
              [
                52.5010434,
                27.7872983
              ],
              [
                52.5016001,
                27.7864703
              ],
              [
                52.5016002,
                27.7861823
              ],
              [
                52.5066001,
                27.7756349
              ],
              [
                52.5082667,
                27.7625769
              ],
              [
                52.5085467,
                27.7572943
              ],
              [
                52.5088233,
                27.7520208
              ],
              [
                52.5093801,
                27.7475752
              ],
              [
                52.5096273,
                27.7465781
              ],
              [
                52.5099334,
                27.7439667
              ],
              [
                52.51049,
                27.7420138
              ],
              [
                52.5135467,
                27.732574
              ],
              [
                52.5266032,
                27.7072966
              ],
              [
                52.5271564,
                27.7064597
              ],
              [
                52.5271564,
                27.7059019
              ],
              [
                52.5277132,
                27.7053529
              ],
              [
                52.5277132,
                27.704795
              ],
              [
                52.5407697,
                27.6689638
              ],
              [
                52.5407696,
                27.667848
              ],
              [
                52.5410462,
                27.6670202
              ],
              [
                52.541603,
                27.6661834
              ],
              [
                52.541603,
                27.6659045
              ],
              [
                52.541603,
                27.6656255
              ],
              [
                52.5418795,
                27.6653555
              ],
              [
                52.5418795,
                27.6650767
              ],
              [
                52.5427129,
                27.6631241
              ],
              [
                52.5485461,
                27.6536852
              ],
              [
                52.5507694,
                27.6495192
              ],
              [
                52.5507695,
                27.6492403
              ],
              [
                52.5510461,
                27.6489614
              ],
              [
                52.5510461,
                27.6486824
              ],
              [
                52.5632693,
                27.6245148
              ],
              [
                52.5635492,
                27.6242449
              ],
              [
                52.5974387,
                27.5864565
              ],
              [
                52.601882,
                27.5817421
              ],
              [
                52.6027152,
                27.5806265
              ],
              [
                52.613358,
                27.5719474
              ],
              [
                52.6238284,
                27.5634067
              ],
              [
                52.6291049,
                27.5611844
              ],
              [
                52.6299382,
                27.5611845
              ],
              [
                52.6318849,
                27.5606266
              ],
              [
                52.6329949,
                27.5606266
              ],
              [
                52.6335516,
                27.5603478
              ],
              [
                52.6346616,
                27.5603478
              ],
              [
                52.6354949,
                27.5600689
              ],
              [
                52.6366048,
                27.5600688
              ],
              [
                52.6371615,
                27.55979
              ],
              [
                52.6404947,
                27.55979
              ],
              [
                52.6407748,
                27.5595111
              ],
              [
                52.647718,
                27.5575678
              ],
              [
                52.6602178,
                27.551738
              ],
              [
                52.6668843,
                27.5484093
              ],
              [
                52.6854974,
                27.5386842
              ],
              [
                52.687164,
                27.5372898
              ],
              [
                52.6874407,
                27.5372898
              ],
              [
                52.6877207,
                27.5370109
              ],
              [
                52.6879974,
                27.536741
              ],
              [
                52.7368899,
                27.510904
              ],
              [
                52.73689,
                27.5106251
              ],
              [
                52.7391098,
                27.5097975
              ],
              [
                52.7423467,
                27.5084734
              ],
              [
                52.7452231,
                27.5072966
              ],
              [
                52.7460565,
                27.5072967
              ],
              [
                52.7546663,
                27.5028527
              ],
              [
                52.7549464,
                27.502295
              ],
              [
                52.7579997,
                27.500064
              ],
              [
                52.7680169,
                27.4903309
              ],
              [
                52.768556,
                27.4895119
              ],
              [
                52.7746694,
                27.483125
              ],
              [
                52.7757793,
                27.4809031
              ],
              [
                52.7888358,
                27.4678506
              ],
              [
                52.7988356,
                27.4614549
              ],
              [
                52.8007789,
                27.4600696
              ],
              [
                52.8088355,
                27.4539619
              ],
              [
                52.8088355,
                27.453683
              ],
              [
                52.8173123,
                27.4485982
              ],
              [
                52.828282,
                27.4420163
              ],
              [
                52.8701614,
                27.419808
              ],
              [
                52.8823067,
                27.4071859
              ],
              [
                52.889471,
                27.4008801
              ],
              [
                52.8981399,
                27.3910497
              ],
              [
                52.9054355,
                27.382133
              ],
              [
                52.9126668,
                27.374435
              ],
              [
                52.9134056,
                27.3734652
              ],
              [
                52.9184983,
                27.3722457
              ],
              [
                52.926642,
                27.3693946
              ],
              [
                52.9607105,
                27.3580848
              ],
              [
                52.9763834,
                27.3526672
              ],
              [
                52.9762941,
                27.352272
              ],
              [
                52.9884767,
                27.3476597
              ],
              [
                52.9991626,
                27.343295
              ],
              [
                53.0048275,
                27.3403406
              ],
              [
                53.0124866,
                27.3362573
              ],
              [
                53.0146336,
                27.3414652
              ],
              [
                53.0161786,
                27.3456585
              ],
              [
                53.019247,
                27.3569794
              ],
              [
                53.0215001,
                27.3627347
              ],
              [
                53.0280447,
                27.3719388
              ],
              [
                53.0320573,
                27.3764548
              ],
              [
                53.0415201,
                27.3844384
              ],
              [
                53.0450606,
                27.3882299
              ],
              [
                53.048644,
                27.3915831
              ],
              [
                53.0561328,
                27.400118
              ],
              [
                53.0617332,
                27.4086523
              ],
              [
                53.0632567,
                27.4137573
              ],
              [
                53.0643511,
                27.4153763
              ],
              [
                53.0660038,
                27.4188376
              ],
              [
                53.0685336,
                27.4240931
              ],
              [
                53.0715568,
                27.4299333
              ],
              [
                53.0754268,
                27.4347305
              ],
              [
                53.0802083,
                27.4391229
              ],
              [
                53.0912589,
                27.4328799
              ],
              [
                53.0969237,
                27.430366
              ],
              [
                53.101486,
                27.427372
              ],
              [
                53.1110072,
                27.4230401
              ],
              [
                53.1212539,
                27.4183337
              ],
              [
                53.1269762,
                27.4163131
              ],
              [
                53.1326294,
                27.4133311
              ],
              [
                53.1400751,
                27.4120342
              ],
              [
                53.146745,
                27.412313
              ],
              [
                53.1526863,
                27.4134802
              ],
              [
                53.1592038,
                27.4165432
              ],
              [
                53.1661438,
                27.4222759
              ],
              [
                53.1691896,
                27.4278878
              ],
              [
                53.1710528,
                27.4390845
              ],
              [
                53.1703014,
                27.4415864
              ],
              [
                53.1695177,
                27.4472244
              ],
              [
                53.1715526,
                27.45484
              ],
              [
                53.1736665,
                27.4643547
              ],
              [
                53.1795412,
                27.4738987
              ],
              [
                53.1881409,
                27.4819189
              ],
              [
                53.2013777,
                27.4904471
              ],
              [
                53.1397175,
                27.4968656
              ],
              [
                53.1247671,
                27.4987062
              ],
              [
                53.1171722,
                27.5034513
              ],
              [
                53.0937342,
                27.5186104
              ],
              [
                53.087268,
                27.5231283
              ],
              [
                53.0767667,
                27.5292197
              ],
              [
                53.0551222,
                27.5399931
              ],
              [
                53.0354735,
                27.5497806
              ],
              [
                53.0134105,
                27.5609387
              ],
              [
                53.0004901,
                27.5594146
              ],
              [
                52.9952792,
                27.5637141
              ],
              [
                52.987691,
                27.566923
              ],
              [
                52.9727704,
                27.5717414
              ],
              [
                52.9422374,
                27.5879181
              ],
              [
                52.9218681,
                27.5999277
              ],
              [
                52.9173306,
                27.6027384
              ],
              [
                52.9105321,
                27.6076569
              ],
              [
                52.9079522,
                27.6091822
              ],
              [
                52.903706,
                27.6121903
              ],
              [
                52.8972344,
                27.6166061
              ],
              [
                52.8872553,
                27.6235394
              ],
              [
                52.8845755,
                27.6254062
              ],
              [
                52.8735045,
                27.6331084
              ],
              [
                52.8448014,
                27.6559078
              ],
              [
                52.8383982,
                27.6608348
              ],
              [
                52.8336557,
                27.6643269
              ],
              [
                52.8247101,
                27.670586
              ],
              [
                52.8088934,
                27.6830588
              ],
              [
                52.8030395,
                27.6881644
              ],
              [
                52.7922248,
                27.6958403
              ],
              [
                52.7784934,
                27.706417
              ],
              [
                52.7479996,
                27.7297934
              ],
              [
                52.7190971,
                27.7499366
              ],
              [
                52.7114026,
                27.7535545
              ],
              [
                52.6981114,
                27.7604945
              ],
              [
                52.6913574,
                27.7627543
              ],
              [
                52.686123,
                27.7659441
              ],
              [
                52.6802539,
                27.7671452
              ],
              [
                52.6631355,
                27.7695703
              ],
              [
                52.649902,
                27.7695154
              ],
              [
                52.6500628,
                27.7796482
              ],
              [
                52.6506028,
                27.7898744
              ],
              [
                52.6504943,
                27.8025798
              ],
              [
                52.6507994,
                27.8111167
              ],
              [
                52.6507387,
                27.8189595
              ],
              [
                52.6512728,
                27.8312891
              ],
              [
                52.6511451,
                27.8479013
              ],
              [
                52.6511759,
                27.8599212
              ],
              [
                52.651382,
                27.8648509
              ],
              [
                52.6283299,
                27.874756
              ],
              [
                52.6141956,
                27.8807826
              ],
              [
                52.6255647,
                27.8964812
              ],
              [
                52.6099384,
                27.9042484
              ],
              [
                52.605215,
                27.9056344
              ],
              [
                52.6018818,
                27.9061925
              ],
              [
                52.6016052,
                27.9064625
              ],
              [
                52.5985485,
                27.9078576
              ],
              [
                52.5507693,
                27.9364636
              ],
              [
                52.547436,
                27.938696
              ],
              [
                52.5471593,
                27.9392451
              ],
              [
                52.5182664,
                27.9553578
              ],
              [
                52.5132665,
                27.9586884
              ],
              [
                52.4974591,
                27.9678249
              ],
              [
                52.4882668,
                27.9731363
              ],
              [
                52.4868769,
                27.9734153
              ],
              [
                52.474377,
                27.981193
              ],
              [
                52.4727105,
                27.9817511
              ],
              [
                52.4677105,
                27.9850818
              ],
              [
                52.4432643,
                27.9984139
              ],
              [
                52.4354877,
                28.0050846
              ],
              [
                52.4352076,
                28.0056337
              ],
              [
                52.4327076,
                28.0084154
              ],
              [
                52.4021514,
                28.0278606
              ],
              [
                52.3985416,
                28.0298051
              ],
              [
                52.3977082,
                28.0300842
              ],
              [
                52.3632622,
                28.0150771
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555243,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نی ریز",
          "name:ar": "مقاطعة نيريز",
          "name:en": "Neyriz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270588",
          "wikipedia": "en:Neyriz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.0146553,
                29.3265398
              ],
              [
                54.0166913,
                29.3204234
              ],
              [
                54.0184177,
                29.3146966
              ],
              [
                54.0225246,
                29.2983172
              ],
              [
                54.0262762,
                29.2888307
              ],
              [
                54.0280595,
                29.2809623
              ],
              [
                54.030551,
                29.2695562
              ],
              [
                54.032531,
                29.2582556
              ],
              [
                54.0340359,
                29.2493592
              ],
              [
                54.0331868,
                29.2403563
              ],
              [
                54.0325227,
                29.2288828
              ],
              [
                54.032456,
                29.2211366
              ],
              [
                54.0325885,
                29.2119495
              ],
              [
                54.0329221,
                29.2037154
              ],
              [
                54.0399961,
                29.2011522
              ],
              [
                54.0486318,
                29.1992447
              ],
              [
                54.055124,
                29.1974465
              ],
              [
                54.0635965,
                29.1952138
              ],
              [
                54.0678589,
                29.1939163
              ],
              [
                54.0942858,
                29.1822236
              ],
              [
                54.1205581,
                29.1637122
              ],
              [
                54.1225048,
                29.1631624
              ],
              [
                54.1236148,
                29.1631623
              ],
              [
                54.1263914,
                29.1626035
              ],
              [
                54.128058,
                29.1626034
              ],
              [
                54.1297281,
                29.162324
              ],
              [
                54.130838,
                29.1626035
              ],
              [
                54.1338947,
                29.1626035
              ],
              [
                54.1350046,
                29.1628829
              ],
              [
                54.1380613,
                29.1628828
              ],
              [
                54.1386146,
                29.1631624
              ],
              [
                54.1400045,
                29.1631623
              ],
              [
                54.1436144,
                29.1637122
              ],
              [
                54.1455611,
                29.1637122
              ],
              [
                54.1469477,
                29.1639917
              ],
              [
                54.1488944,
                29.1639916
              ],
              [
                54.1502844,
                29.1642712
              ],
              [
                54.151671,
                29.1639917
              ],
              [
                54.1547276,
                29.1639916
              ],
              [
                54.1552843,
                29.1637122
              ],
              [
                54.1588942,
                29.1634418
              ],
              [
                54.1647275,
                29.1628829
              ],
              [
                54.1655608,
                29.1626034
              ],
              [
                54.1672275,
                29.1626035
              ],
              [
                54.1747274,
                29.1603768
              ],
              [
                54.176674,
                29.1592681
              ],
              [
                54.1819506,
                29.1539947
              ],
              [
                54.1827838,
                29.1526065
              ],
              [
                54.1844505,
                29.1509389
              ],
              [
                54.1852839,
                29.1495507
              ],
              [
                54.1869505,
                29.147883
              ],
              [
                54.2202867,
                29.1026053
              ],
              [
                54.2288965,
                29.0973231
              ],
              [
                54.2291765,
                29.0976026
              ],
              [
                54.2297298,
                29.0976026
              ],
              [
                54.2327864,
                29.0976026
              ],
              [
                54.2397297,
                29.0976026
              ],
              [
                54.2408431,
                29.0973232
              ],
              [
                54.2519528,
                29.0973232
              ],
              [
                54.2536195,
                29.0970437
              ],
              [
                54.2558428,
                29.0970438
              ],
              [
                54.2572328,
                29.0967734
              ],
              [
                54.2594527,
                29.0967734
              ],
              [
                54.2608427,
                29.0964939
              ],
              [
                54.263066,
                29.0964939
              ],
              [
                54.264176,
                29.0962144
              ],
              [
                54.2661226,
                29.0962145
              ],
              [
                54.2719559,
                29.0948264
              ],
              [
                54.2733425,
                29.0948264
              ],
              [
                54.2758425,
                29.0942675
              ],
              [
                54.2772324,
                29.0942675
              ],
              [
                54.2780658,
                29.093988
              ],
              [
                54.2955655,
                29.0898237
              ],
              [
                54.2958455,
                29.0895442
              ],
              [
                54.297232,
                29.0889945
              ],
              [
                54.2975121,
                29.088715
              ],
              [
                54.3144552,
                29.081495
              ],
              [
                54.3155686,
                29.0806568
              ],
              [
                54.3261251,
                29.0776011
              ],
              [
                54.3392777,
                29.0751405
              ],
              [
                54.3439014,
                29.0742751
              ],
              [
                54.3477914,
                29.0745454
              ],
              [
                54.3525146,
                29.0745455
              ],
              [
                54.353348,
                29.0748249
              ],
              [
                54.3547346,
                29.074825
              ],
              [
                54.3555713,
                29.0751043
              ],
              [
                54.3589046,
                29.0751043
              ],
              [
                54.3597379,
                29.0753837
              ],
              [
                54.3641812,
                29.0753837
              ],
              [
                54.3677911,
                29.0759336
              ],
              [
                54.370291,
                29.0759336
              ],
              [
                54.3716811,
                29.076213
              ],
              [
                54.375571,
                29.0762131
              ],
              [
                54.3833474,
                29.0745455
              ],
              [
                54.3847375,
                29.0745455
              ],
              [
                54.390294,
                29.0737162
              ],
              [
                54.393904,
                29.072878
              ],
              [
                54.4186269,
                29.0645494
              ],
              [
                54.4272403,
                29.0601058
              ],
              [
                54.4280735,
                29.0592675
              ],
              [
                54.4289068,
                29.0589881
              ],
              [
                54.4405733,
                29.0453779
              ],
              [
                54.4433499,
                29.0395462
              ],
              [
                54.44363,
                29.0381582
              ],
              [
                54.4444633,
                29.0364908
              ],
              [
                54.4447399,
                29.0351027
              ],
              [
                54.4533531,
                29.0164905
              ],
              [
                54.4541865,
                29.0151025
              ],
              [
                54.4544631,
                29.0148232
              ],
              [
                54.4547397,
                29.0139849
              ],
              [
                54.4636296,
                28.9998255
              ],
              [
                54.4586297,
                28.9853779
              ],
              [
                54.4591864,
                28.9837106
              ],
              [
                54.4589064,
                28.9831517
              ],
              [
                54.4591864,
                28.9806552
              ],
              [
                54.4622396,
                28.9642703
              ],
              [
                54.4641863,
                28.9587095
              ],
              [
                54.4650196,
                28.9542663
              ],
              [
                54.4655729,
                28.9531577
              ],
              [
                54.4664062,
                28.9495438
              ],
              [
                54.4680728,
                28.9420455
              ],
              [
                54.4680728,
                28.9417661
              ],
              [
                54.4683529,
                28.9414957
              ],
              [
                54.4686295,
                28.9403782
              ],
              [
                54.481686,
                28.918992
              ],
              [
                54.481686,
                28.9184334
              ],
              [
                54.4825194,
                28.9175952
              ],
              [
                54.4827959,
                28.9170454
              ],
              [
                54.489466,
                28.9100971
              ],
              [
                54.5047423,
                28.9037076
              ],
              [
                54.5055756,
                28.9037076
              ],
              [
                54.506409,
                28.9034282
              ],
              [
                54.5100223,
                28.9034282
              ],
              [
                54.5105755,
                28.9031488
              ],
              [
                54.5114089,
                28.9031489
              ],
              [
                54.5119655,
                28.9028785
              ],
              [
                54.5130755,
                28.9028785
              ],
              [
                54.5144654,
                28.9023197
              ],
              [
                54.5155755,
                28.9023198
              ],
              [
                54.5164088,
                28.9020403
              ],
              [
                54.5272453,
                28.9006525
              ],
              [
                54.5280787,
                28.9003732
              ],
              [
                54.528912,
                28.9003732
              ],
              [
                54.5294654,
                28.9000938
              ],
              [
                54.5319652,
                28.9000938
              ],
              [
                54.5327986,
                28.8998234
              ],
              [
                54.5350218,
                28.8998234
              ],
              [
                54.5358552,
                28.899544
              ],
              [
                54.547245,
                28.8995441
              ],
              [
                54.5480784,
                28.8998234
              ],
              [
                54.5558549,
                28.8998235
              ],
              [
                54.5564115,
                28.899544
              ],
              [
                54.5575215,
                28.8995441
              ],
              [
                54.5578015,
                28.8992646
              ],
              [
                54.5600214,
                28.8992647
              ],
              [
                54.5603014,
                28.8989853
              ],
              [
                54.5675247,
                28.898715
              ],
              [
                54.5691914,
                28.8981562
              ],
              [
                54.5703013,
                28.8981562
              ],
              [
                54.570858,
                28.8978769
              ],
              [
                54.5719679,
                28.8978769
              ],
              [
                54.5725246,
                28.8975974
              ],
              [
                54.5736346,
                28.8975974
              ],
              [
                54.5741913,
                28.8973181
              ],
              [
                54.5755779,
                28.8973181
              ],
              [
                54.5764112,
                28.8970387
              ],
              [
                54.5794678,
                28.8970387
              ],
              [
                54.5803011,
                28.8967594
              ],
              [
                54.5861344,
                28.8962096
              ],
              [
                54.587801,
                28.8962097
              ],
              [
                54.5894677,
                28.8962096
              ],
              [
                54.590301,
                28.8959302
              ],
              [
                54.596691,
                28.8951012
              ],
              [
                54.5994675,
                28.8951012
              ],
              [
                54.5997476,
                28.8948218
              ],
              [
                54.6033574,
                28.8948218
              ],
              [
                54.6039141,
                28.8945424
              ],
              [
                54.610024,
                28.8945424
              ],
              [
                54.6105807,
                28.8948218
              ],
              [
                54.6119707,
                28.8948218
              ],
              [
                54.6175239,
                28.8959302
              ],
              [
                54.6203039,
                28.8959302
              ],
              [
                54.6208606,
                28.8962096
              ],
              [
                54.6219705,
                28.8962096
              ],
              [
                54.6228038,
                28.896489
              ],
              [
                54.6244705,
                28.8967593
              ],
              [
                54.6283605,
                28.8967593
              ],
              [
                54.6289138,
                28.8970387
              ],
              [
                54.6305803,
                28.8970387
              ],
              [
                54.6314137,
                28.8973181
              ],
              [
                54.6341937,
                28.8973181
              ],
              [
                54.6355803,
                28.8975974
              ],
              [
                54.6453035,
                28.8975975
              ],
              [
                54.6466935,
                28.8973181
              ],
              [
                54.6528034,
                28.8973181
              ],
              [
                54.6550267,
                28.8973181
              ],
              [
                54.6658599,
                28.8973181
              ],
              [
                54.6669732,
                28.8975975
              ],
              [
                54.6728064,
                28.8975975
              ],
              [
                54.6733597,
                28.8978768
              ],
              [
                54.6797497,
                28.8978768
              ],
              [
                54.6800298,
                28.8975974
              ],
              [
                54.6872495,
                28.8975974
              ],
              [
                54.6880828,
                28.8978768
              ],
              [
                54.6897495,
                28.8978769
              ],
              [
                54.6905827,
                28.8981562
              ],
              [
                54.6919728,
                28.8981561
              ],
              [
                54.6928061,
                28.8984356
              ],
              [
                54.6980861,
                28.8984356
              ],
              [
                54.6989194,
                28.8987149
              ],
              [
                54.700586,
                28.8987149
              ],
              [
                54.7014194,
                28.8989853
              ],
              [
                54.7025293,
                28.8989852
              ],
              [
                54.7097525,
                28.9012113
              ],
              [
                54.7103059,
                28.90177
              ],
              [
                54.7197524,
                28.907042
              ],
              [
                54.7200291,
                28.9073213
              ],
              [
                54.7355854,
                28.9203799
              ],
              [
                54.7422519,
                28.927878
              ],
              [
                54.7430853,
                28.9281574
              ],
              [
                54.743642,
                28.9287162
              ],
              [
                54.7572552,
                28.9348175
              ],
              [
                54.7580886,
                28.9348175
              ],
              [
                54.7594751,
                28.9353762
              ],
              [
                54.7608651,
                28.9353762
              ],
              [
                54.7614218,
                28.9356556
              ],
              [
                54.7622551,
                28.9356557
              ],
              [
                54.7650317,
                28.9362144
              ],
              [
                54.7680883,
                28.9362144
              ],
              [
                54.7689216,
                28.9364937
              ],
              [
                54.7703082,
                28.9364937
              ],
              [
                54.7714216,
                28.9367642
              ],
              [
                54.7728116,
                28.9367641
              ],
              [
                54.79223,
                28.9384008
              ],
              [
                54.8100344,
                28.931492
              ],
              [
                54.8108677,
                28.9314919
              ],
              [
                54.8114244,
                28.9309332
              ],
              [
                54.8119776,
                28.9309332
              ],
              [
                54.8494804,
                28.912323
              ],
              [
                54.8497571,
                28.9120436
              ],
              [
                54.88226,
                28.8862063
              ],
              [
                54.8892031,
                28.8781498
              ],
              [
                54.8897598,
                28.8776001
              ],
              [
                54.9153161,
                28.8378772
              ],
              [
                54.923096,
                28.8275953
              ],
              [
                54.9236492,
                28.8273159
              ],
              [
                54.9247626,
                28.8256579
              ],
              [
                54.925596,
                28.8250992
              ],
              [
                54.9258725,
                28.8242611
              ],
              [
                54.9408722,
                28.8089872
              ],
              [
                54.9753185,
                28.7820445
              ],
              [
                54.9775418,
                28.7798188
              ],
              [
                54.9783751,
                28.7792691
              ],
              [
                55.006708,
                28.7600944
              ],
              [
                55.0078213,
                28.7598151
              ],
              [
                55.0347642,
                28.7439836
              ],
              [
                55.0356009,
                28.7437043
              ],
              [
                55.0589338,
                28.7314862
              ],
              [
                55.0597672,
                28.7300987
              ],
              [
                55.0599515,
                28.7297262
              ],
              [
                55.0606005,
                28.7289904
              ],
              [
                55.0756003,
                28.7223228
              ],
              [
                55.0814335,
                28.7206559
              ],
              [
                55.0825468,
                28.7206559
              ],
              [
                55.0828235,
                28.7203766
              ],
              [
                55.0836568,
                28.7203766
              ],
              [
                55.0939367,
                28.718151
              ],
              [
                55.09588,
                28.718151
              ],
              [
                55.0961566,
                28.7178717
              ],
              [
                55.111713,
                28.7178717
              ],
              [
                55.1122696,
                28.7181511
              ],
              [
                55.113103,
                28.7178717
              ],
              [
                55.1142129,
                28.7181511
              ],
              [
                55.1197695,
                28.718151
              ],
              [
                55.1208795,
                28.7184303
              ],
              [
                55.1272695,
                28.7184304
              ],
              [
                55.1281027,
                28.7187097
              ],
              [
                55.1311594,
                28.7187097
              ],
              [
                55.1317162,
                28.7187097
              ],
              [
                55.132826,
                28.718989
              ],
              [
                55.1350494,
                28.718989
              ],
              [
                55.1353259,
                28.7192683
              ],
              [
                55.1912895,
                28.7246411
              ],
              [
                55.2131651,
                28.7268727
              ],
              [
                55.2258681,
                28.7252168
              ],
              [
                55.2399443,
                28.7223566
              ],
              [
                55.2533242,
                28.7136208
              ],
              [
                55.268696,
                28.7510634
              ],
              [
                55.269751,
                28.7762127
              ],
              [
                55.2685743,
                28.7992988
              ],
              [
                55.263167,
                28.8116059
              ],
              [
                55.2576489,
                28.8192325
              ],
              [
                55.2493759,
                28.8285316
              ],
              [
                55.2241509,
                28.8470801
              ],
              [
                55.2006338,
                28.8939814
              ],
              [
                55.2121421,
                28.9030492
              ],
              [
                55.1953121,
                28.9117145
              ],
              [
                55.1758286,
                28.9170488
              ],
              [
                55.1668164,
                28.921857
              ],
              [
                55.2262114,
                28.9348528
              ],
              [
                55.2268123,
                28.9371813
              ],
              [
                55.2258679,
                28.9410123
              ],
              [
                55.2218341,
                28.9430401
              ],
              [
                55.2167701,
                28.9438663
              ],
              [
                55.2134227,
                28.9391343
              ],
              [
                55.2088737,
                28.9394347
              ],
              [
                55.196514,
                28.954306
              ],
              [
                55.1933383,
                28.9541558
              ],
              [
                55.1875877,
                28.9609148
              ],
              [
                55.184841,
                28.962567
              ],
              [
                55.175743,
                28.9594129
              ],
              [
                55.1637266,
                28.9626421
              ],
              [
                55.1649284,
                28.9678987
              ],
              [
                55.1641558,
                28.9700013
              ],
              [
                55.1307677,
                28.9892228
              ],
              [
                55.119352,
                28.9988324
              ],
              [
                55.1102542,
                28.983742
              ],
              [
                55.1056193,
                28.9859193
              ],
              [
                55.1035594,
                28.992451
              ],
              [
                55.1110267,
                29.0044623
              ],
              [
                55.1101683,
                29.0058886
              ],
              [
                55.0959205,
                28.999733
              ],
              [
                55.0942039,
                29.0026607
              ],
              [
                55.0917148,
                29.0035615
              ],
              [
                55.0850199,
                29.0025106
              ],
              [
                55.0847624,
                29.0084408
              ],
              [
                55.0808569,
                29.0142582
              ],
              [
                55.0701713,
                29.0104298
              ],
              [
                55.0353238,
                29.0276178
              ],
              [
                55.034294,
                29.0396623
              ],
              [
                55.031719,
                29.039212
              ],
              [
                55.0246809,
                29.0722247
              ],
              [
                55.0251775,
                29.0828973
              ],
              [
                55.026461,
                29.1047736
              ],
              [
                55.024879,
                29.1300821
              ],
              [
                55.0249168,
                29.1888802
              ],
              [
                55.0296555,
                29.2498797
              ],
              [
                55.0266016,
                29.2713064
              ],
              [
                55.0175101,
                29.3079453
              ],
              [
                55.0000122,
                29.35422
              ],
              [
                54.9879497,
                29.3699764
              ],
              [
                54.9856486,
                29.3830906
              ],
              [
                54.9794491,
                29.3968289
              ],
              [
                54.9748991,
                29.3963843
              ],
              [
                54.9290231,
                29.4516123
              ],
              [
                54.9178065,
                29.4650212
              ],
              [
                54.9043134,
                29.4788513
              ],
              [
                54.8854205,
                29.5041587
              ],
              [
                54.8713788,
                29.52631
              ],
              [
                54.8584626,
                29.5399842
              ],
              [
                54.846073,
                29.5540532
              ],
              [
                54.8308511,
                29.5704318
              ],
              [
                54.8046432,
                29.5905904
              ],
              [
                54.7773172,
                29.6022072
              ],
              [
                54.7518648,
                29.6092421
              ],
              [
                54.7350874,
                29.6128698
              ],
              [
                54.7208626,
                29.6131683
              ],
              [
                54.719196,
                29.6125524
              ],
              [
                54.7033308,
                29.6127149
              ],
              [
                54.6681402,
                29.6052527
              ],
              [
                54.6339164,
                29.595708
              ],
              [
                54.6056053,
                29.6069479
              ],
              [
                54.5882766,
                29.6134398
              ],
              [
                54.543912,
                29.6284452
              ],
              [
                54.5406336,
                29.6297135
              ],
              [
                54.5272033,
                29.6311068
              ],
              [
                54.5021241,
                29.6331958
              ],
              [
                54.4905619,
                29.6348183
              ],
              [
                54.4846097,
                29.6336246
              ],
              [
                54.472114,
                29.6253711
              ],
              [
                54.4626785,
                29.6211084
              ],
              [
                54.4555078,
                29.6213831
              ],
              [
                54.4397878,
                29.6221538
              ],
              [
                54.4284373,
                29.6232011
              ],
              [
                54.4189739,
                29.6228999
              ],
              [
                54.4092227,
                29.6220172
              ],
              [
                54.4028906,
                29.6230322
              ],
              [
                54.3969716,
                29.6215878
              ],
              [
                54.3878564,
                29.620688
              ],
              [
                54.3709727,
                29.6223295
              ],
              [
                54.3529901,
                29.6244224
              ],
              [
                54.3273741,
                29.6195547
              ],
              [
                54.3158394,
                29.6159731
              ],
              [
                54.3039795,
                29.6121323
              ],
              [
                54.2937439,
                29.6089704
              ],
              [
                54.2835443,
                29.6050154
              ],
              [
                54.2740141,
                29.6014783
              ],
              [
                54.2659377,
                29.6004018
              ],
              [
                54.2460051,
                29.6082384
              ],
              [
                54.2439688,
                29.6005811
              ],
              [
                54.2442141,
                29.5938795
              ],
              [
                54.2439688,
                29.5903156
              ],
              [
                54.2450597,
                29.5783185
              ],
              [
                54.2516762,
                29.5317821
              ],
              [
                54.2533428,
                29.5139996
              ],
              [
                54.272449,
                29.433442
              ],
              [
                54.2483607,
                29.4275867
              ],
              [
                54.2174431,
                29.4200868
              ],
              [
                54.209205,
                29.4181256
              ],
              [
                54.1871556,
                29.408776
              ],
              [
                54.175115,
                29.4076244
              ],
              [
                54.1621969,
                29.4020647
              ],
              [
                54.1473142,
                29.3946198
              ],
              [
                54.1302813,
                29.3823845
              ],
              [
                54.1214381,
                29.3763915
              ],
              [
                54.10791,
                29.3682138
              ],
              [
                54.0968627,
                29.3619411
              ],
              [
                54.0799221,
                29.3521271
              ],
              [
                54.070899,
                29.3467932
              ],
              [
                54.0571545,
                29.3409817
              ],
              [
                54.044563,
                29.3349677
              ],
              [
                54.0334865,
                29.331828
              ],
              [
                54.0291662,
                29.3303845
              ],
              [
                54.0229768,
                29.3283735
              ],
              [
                54.0146553,
                29.3265398
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555262,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پاسارگاد",
          "name:en": "Pasargad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2422327",
          "wikipedia": "en:Pasargad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.8024439,
                30.2359664
              ],
              [
                52.8046673,
                30.2351272
              ],
              [
                52.8085572,
                30.2331784
              ],
              [
                52.8505033,
                30.209296
              ],
              [
                52.8513366,
                30.2092961
              ],
              [
                52.8516133,
                30.2090164
              ],
              [
                52.8549466,
                30.2081863
              ],
              [
                52.8563366,
                30.2081863
              ],
              [
                52.8568933,
                30.2079067
              ],
              [
                52.8605031,
                30.2079067
              ],
              [
                52.8610599,
                30.2081863
              ],
              [
                52.8621699,
                30.2081864
              ],
              [
                52.8624464,
                30.2079067
              ],
              [
                52.8652264,
                30.2051278
              ],
              [
                52.8664195,
                30.2044286
              ],
              [
                52.8675267,
                30.2033604
              ],
              [
                52.8716111,
                30.2005434
              ],
              [
                52.9057825,
                30.1759589
              ],
              [
                52.9160624,
                30.1656827
              ],
              [
                52.9185624,
                30.1617942
              ],
              [
                52.921339,
                30.1556772
              ],
              [
                52.9224524,
                30.1487393
              ],
              [
                52.9227291,
                30.1454012
              ],
              [
                52.9230056,
                30.1442915
              ],
              [
                52.9169256,
                30.1384533
              ],
              [
                52.915889,
                30.1258897
              ],
              [
                52.9198773,
                30.1142611
              ],
              [
                52.9236916,
                30.1110817
              ],
              [
                52.9279836,
                30.1082674
              ],
              [
                52.9338389,
                30.1023491
              ],
              [
                52.969675,
                30.0648465
              ],
              [
                52.9813415,
                30.0548418
              ],
              [
                53.0082877,
                30.0317924
              ],
              [
                53.014121,
                30.027345
              ],
              [
                53.016901,
                30.0256761
              ],
              [
                53.0213442,
                30.0234569
              ],
              [
                53.0605137,
                30.0015086
              ],
              [
                53.0646803,
                30.0000652
              ],
              [
                53.0785701,
                29.9954014
              ],
              [
                53.0905133,
                29.9890055
              ],
              [
                53.09218,
                29.9887348
              ],
              [
                53.0957932,
                29.9873456
              ],
              [
                53.0963464,
                29.9867864
              ],
              [
                53.0991265,
                29.9856768
              ],
              [
                53.0996798,
                29.9851175
              ],
              [
                53.1010697,
                29.9845672
              ],
              [
                53.1194028,
                29.9665075
              ],
              [
                53.1257927,
                29.9562329
              ],
              [
                53.1324593,
                29.9387328
              ],
              [
                53.1324593,
                29.9384532
              ],
              [
                53.1332926,
                29.937064
              ],
              [
                53.1332926,
                29.9367844
              ],
              [
                53.1341259,
                29.9342857
              ],
              [
                53.1346826,
                29.9332198
              ],
              [
                53.1349592,
                29.9328965
              ],
              [
                53.1380159,
                29.9323463
              ],
              [
                53.1491292,
                29.9365048
              ],
              [
                53.1613489,
                29.9465086
              ],
              [
                53.1713521,
                29.9628992
              ],
              [
                53.1719054,
                29.9642884
              ],
              [
                53.1825133,
                29.9790327
              ],
              [
                53.1905238,
                29.9854692
              ],
              [
                53.2062308,
                29.9938323
              ],
              [
                53.2120759,
                29.9986938
              ],
              [
                53.2220666,
                30.0038449
              ],
              [
                53.2368981,
                30.0076356
              ],
              [
                53.2414815,
                30.0077471
              ],
              [
                53.2543303,
                30.0071451
              ],
              [
                53.2707583,
                30.0055619
              ],
              [
                53.2753932,
                30.0035996
              ],
              [
                53.2823197,
                29.9968875
              ],
              [
                53.2879846,
                29.9872757
              ],
              [
                53.2941644,
                29.9767484
              ],
              [
                53.3057773,
                29.9618478
              ],
              [
                53.3106954,
                29.9566722
              ],
              [
                53.3530785,
                29.9445129
              ],
              [
                53.3621938,
                29.9420586
              ],
              [
                53.3742959,
                29.9394703
              ],
              [
                53.3767678,
                29.9380646
              ],
              [
                53.3817117,
                29.9314373
              ],
              [
                53.3841836,
                29.9288933
              ],
              [
                53.3901831,
                29.9260816
              ],
              [
                53.3967234,
                29.9274875
              ],
              [
                53.404268,
                29.9300314
              ],
              [
                53.4097783,
                29.9300314
              ],
              [
                53.4216744,
                29.9332224
              ],
              [
                53.4311041,
                29.9351631
              ],
              [
                53.433585,
                29.9362342
              ],
              [
                53.4374749,
                29.9356749
              ],
              [
                53.4399749,
                29.935675
              ],
              [
                53.448028,
                29.9348451
              ],
              [
                53.4510847,
                29.9348451
              ],
              [
                53.4527513,
                29.9345654
              ],
              [
                53.4596979,
                29.9345655
              ],
              [
                53.480531,
                29.9381736
              ],
              [
                53.4824741,
                29.9387329
              ],
              [
                53.4896975,
                29.9417819
              ],
              [
                53.5108105,
                29.9523451
              ],
              [
                53.5360901,
                29.9684561
              ],
              [
                53.5451709,
                29.9761502
              ],
              [
                53.5481578,
                29.981191
              ],
              [
                53.5497285,
                29.9860754
              ],
              [
                53.5494453,
                29.9932566
              ],
              [
                53.5485441,
                29.9973375
              ],
              [
                53.5431882,
                30.0071714
              ],
              [
                53.5340473,
                30.0179407
              ],
              [
                53.5319616,
                30.023938
              ],
              [
                53.5283824,
                30.0317406
              ],
              [
                53.5301849,
                30.03582
              ],
              [
                53.530666,
                30.0418105
              ],
              [
                53.5052539,
                30.0470655
              ],
              [
                53.5041439,
                30.0470655
              ],
              [
                53.5021972,
                30.0465152
              ],
              [
                53.5010872,
                30.0465153
              ],
              [
                53.4863641,
                30.0420678
              ],
              [
                53.4780309,
                30.0381795
              ],
              [
                53.4777543,
                30.0378999
              ],
              [
                53.4752543,
                30.03707
              ],
              [
                53.4746976,
                30.0367903
              ],
              [
                53.4735877,
                30.0367903
              ],
              [
                53.473031,
                30.0365106
              ],
              [
                53.471921,
                30.0365107
              ],
              [
                53.4713644,
                30.03624
              ],
              [
                53.469141,
                30.03624
              ],
              [
                53.467751,
                30.0359604
              ],
              [
                53.4599745,
                30.0359603
              ],
              [
                53.4499747,
                30.0392892
              ],
              [
                53.4435848,
                30.0431773
              ],
              [
                53.4419182,
                30.0440163
              ],
              [
                53.4255283,
                30.0584505
              ],
              [
                53.4077486,
                30.0828987
              ],
              [
                53.4055286,
                30.085957
              ],
              [
                53.3966388,
                30.0981813
              ],
              [
                53.3915558,
                30.103142
              ],
              [
                53.3849723,
                30.1095666
              ],
              [
                53.3519127,
                30.1331856
              ],
              [
                53.3513594,
                30.1340157
              ],
              [
                53.3508028,
                30.1340157
              ],
              [
                53.339693,
                30.1454013
              ],
              [
                53.3388595,
                30.144012
              ],
              [
                53.3380264,
                30.1437413
              ],
              [
                53.3374697,
                30.1434616
              ],
              [
                53.3366363,
                30.1459607
              ],
              [
                53.3341364,
                30.1487395
              ],
              [
                53.3335796,
                30.1506792
              ],
              [
                53.331913,
                30.154297
              ],
              [
                53.3216366,
                30.1842955
              ],
              [
                53.3205232,
                30.1887345
              ],
              [
                53.3153221,
                30.2071685
              ],
              [
                53.3127553,
                30.2152947
              ],
              [
                53.2261046,
                30.2208538
              ],
              [
                53.2170409,
                30.2218995
              ],
              [
                53.2168157,
                30.2340536
              ],
              [
                53.2167385,
                30.2422845
              ],
              [
                53.2045076,
                30.24224
              ],
              [
                53.1847579,
                30.2454655
              ],
              [
                53.200774,
                30.283918
              ],
              [
                53.2029369,
                30.3104635
              ],
              [
                53.2031171,
                30.3256005
              ],
              [
                53.201245,
                30.3404638
              ],
              [
                53.1924616,
                30.3420751
              ],
              [
                53.1919084,
                30.3420751
              ],
              [
                53.1913517,
                30.3420751
              ],
              [
                53.190795,
                30.3420751
              ],
              [
                53.1896851,
                30.3423548
              ],
              [
                53.1891284,
                30.3423548
              ],
              [
                53.1877417,
                30.3423548
              ],
              [
                53.1857951,
                30.3426346
              ],
              [
                53.1849617,
                30.3426346
              ],
              [
                53.1827384,
                30.3429053
              ],
              [
                53.1805185,
                30.343185
              ],
              [
                53.1794051,
                30.3434647
              ],
              [
                53.1771852,
                30.3437354
              ],
              [
                53.1749618,
                30.3440151
              ],
              [
                53.173852,
                30.3440151
              ],
              [
                53.1719052,
                30.3442948
              ],
              [
                53.1707953,
                30.3445745
              ],
              [
                53.168852,
                30.3448542
              ],
              [
                53.1669053,
                30.3451249
              ],
              [
                53.161072,
                30.3454047
              ],
              [
                53.1594055,
                30.3454046
              ],
              [
                53.1580155,
                30.3454047
              ],
              [
                53.1571822,
                30.3454047
              ],
              [
                53.1557956,
                30.3454047
              ],
              [
                53.1544055,
                30.3454046
              ],
              [
                53.1538489,
                30.3454046
              ],
              [
                53.1527389,
                30.3454046
              ],
              [
                53.1516289,
                30.3454046
              ],
              [
                53.1510722,
                30.3454046
              ],
              [
                53.1499623,
                30.3454047
              ],
              [
                53.1488489,
                30.3454046
              ],
              [
                53.1480156,
                30.3454046
              ],
              [
                53.1466256,
                30.3454046
              ],
              [
                53.144959,
                30.3454046
              ],
              [
                53.143849,
                30.3456843
              ],
              [
                53.1421824,
                30.3456844
              ],
              [
                53.1399591,
                30.3459641
              ],
              [
                53.1388491,
                30.345964
              ],
              [
                53.1366257,
                30.3462438
              ],
              [
                53.1344059,
                30.3465145
              ],
              [
                53.1330159,
                30.3465145
              ],
              [
                53.1305158,
                30.3467942
              ],
              [
                53.129406,
                30.3470739
              ],
              [
                53.1269026,
                30.3473537
              ],
              [
                53.1244026,
                30.3479131
              ],
              [
                53.123016,
                30.347913
              ],
              [
                53.1207927,
                30.3484635
              ],
              [
                53.1185694,
                30.3484635
              ],
              [
                53.1174593,
                30.3487432
              ],
              [
                53.1155162,
                30.3487432
              ],
              [
                53.1135694,
                30.3490139
              ],
              [
                53.1124595,
                30.3490139
              ],
              [
                53.1107928,
                30.3490139
              ],
              [
                53.1088462,
                30.3490139
              ],
              [
                53.1080128,
                30.3490139
              ],
              [
                53.1063462,
                30.3490139
              ],
              [
                53.1046795,
                30.3492936
              ],
              [
                53.1035697,
                30.3492936
              ],
              [
                53.1019029,
                30.3495734
              ],
              [
                53.0999597,
                30.3495733
              ],
              [
                53.0988463,
                30.3495733
              ],
              [
                53.0966264,
                30.3498531
              ],
              [
                53.0946797,
                30.3498531
              ],
              [
                53.0932931,
                30.3498531
              ],
              [
                53.0910698,
                30.3501328
              ],
              [
                53.0882898,
                30.3501328
              ],
              [
                53.0871798,
                30.3501328
              ],
              [
                53.0844033,
                30.3501328
              ],
              [
                53.0816232,
                30.3498531
              ],
              [
                53.0802366,
                30.3498531
              ],
              [
                53.0774567,
                30.3498531
              ],
              [
                53.07607,
                30.3498531
              ],
              [
                53.07329,
                30.3498531
              ],
              [
                53.0705134,
                30.3495733
              ],
              [
                53.0680135,
                30.3495733
              ],
              [
                53.0669,
                30.3495734
              ],
              [
                53.0646801,
                30.3495734
              ],
              [
                53.0632902,
                30.3495734
              ],
              [
                53.0610668,
                30.3495733
              ],
              [
                53.0591236,
                30.3495733
              ],
              [
                53.0580137,
                30.3495734
              ],
              [
                53.0557904,
                30.3495733
              ],
              [
                53.0532903,
                30.3492936
              ],
              [
                53.052177,
                30.3492936
              ],
              [
                53.049677,
                30.3490139
              ],
              [
                53.0469004,
                30.3490139
              ],
              [
                53.0455103,
                30.3487432
              ],
              [
                53.0430104,
                30.3484635
              ],
              [
                53.0402339,
                30.3484634
              ],
              [
                53.039124,
                30.3481837
              ],
              [
                53.036624,
                30.3481838
              ],
              [
                53.0346773,
                30.3479131
              ],
              [
                53.0335672,
                30.3479131
              ],
              [
                53.0316205,
                30.3479131
              ],
              [
                53.0299539,
                30.347913
              ],
              [
                53.0291206,
                30.347913
              ],
              [
                53.027734,
                30.347913
              ],
              [
                53.0266207,
                30.3476334
              ],
              [
                53.0260674,
                30.3476334
              ],
              [
                53.0246774,
                30.3476334
              ],
              [
                53.023844,
                30.3476333
              ],
              [
                53.0232874,
                30.3476334
              ],
              [
                53.0224541,
                30.3473536
              ],
              [
                53.0219008,
                30.3473536
              ],
              [
                53.0210675,
                30.3473536
              ],
              [
                53.0199541,
                30.3473536
              ],
              [
                53.0196775,
                30.3473536
              ],
              [
                53.0191209,
                30.3473536
              ],
              [
                53.0185675,
                30.3473536
              ],
              [
                53.0182875,
                30.3473536
              ],
              [
                53.0177342,
                30.3473536
              ],
              [
                53.0174542,
                30.3473536
              ],
              [
                53.0171775,
                30.3476334
              ],
              [
                53.0166209,
                30.3476334
              ],
              [
                53.0157876,
                30.3476334
              ],
              [
                53.0155108,
                30.3476334
              ],
              [
                53.0146776,
                30.3479131
              ],
              [
                53.0141209,
                30.3479131
              ],
              [
                53.0138443,
                30.3479131
              ],
              [
                53.0135641,
                30.3495733
              ],
              [
                53.0130109,
                30.3495733
              ],
              [
                53.0116208,
                30.3492936
              ],
              [
                53.008011,
                30.3492936
              ],
              [
                53.0074542,
                30.3490139
              ],
              [
                53.0013444,
                30.347913
              ],
              [
                52.9696749,
                30.3426344
              ],
              [
                52.9605084,
                30.3417954
              ],
              [
                52.9518951,
                30.3417953
              ],
              [
                52.9496751,
                30.3415156
              ],
              [
                52.9466185,
                30.3415156
              ],
              [
                52.9449519,
                30.3417953
              ],
              [
                52.9341188,
                30.3417953
              ],
              [
                52.9327287,
                30.3415156
              ],
              [
                52.9266188,
                30.3415156
              ],
              [
                52.9249522,
                30.3412449
              ],
              [
                52.9213389,
                30.3412449
              ],
              [
                52.9205055,
                30.3409651
              ],
              [
                52.9193956,
                30.3409652
              ],
              [
                52.9166156,
                30.3404057
              ],
              [
                52.9141157,
                30.3404057
              ],
              [
                52.9118957,
                30.3398553
              ],
              [
                52.9096725,
                30.3398553
              ],
              [
                52.908839,
                30.3395756
              ],
              [
                52.9077291,
                30.3395755
              ],
              [
                52.9068958,
                30.3392959
              ],
              [
                52.9046726,
                30.3392959
              ],
              [
                52.9043959,
                30.3390162
              ],
              [
                52.9030058,
                30.3390161
              ],
              [
                52.8988392,
                30.3376356
              ],
              [
                52.8993926,
                30.3362461
              ],
              [
                52.8999492,
                30.3356866
              ],
              [
                52.9032824,
                30.3301284
              ],
              [
                52.9030058,
                30.3234604
              ],
              [
                52.9021725,
                30.320961
              ],
              [
                52.9013392,
                30.3170721
              ],
              [
                52.9007826,
                30.3162419
              ],
              [
                52.8960593,
                30.3048549
              ],
              [
                52.8774496,
                30.2834617
              ],
              [
                52.8607798,
                30.2687366
              ],
              [
                52.8577266,
                30.2662372
              ],
              [
                52.8166139,
                30.2387363
              ],
              [
                52.8155005,
                30.2384656
              ],
              [
                52.8124472,
                30.2370762
              ],
              [
                52.8116139,
                30.2370762
              ],
              [
                52.8113338,
                30.2367965
              ],
              [
                52.8093906,
                30.2367964
              ],
              [
                52.809114,
                30.2365168
              ],
              [
                52.8080006,
                30.2365168
              ],
              [
                52.8071673,
                30.236237
              ],
              [
                52.8024439,
                30.2359664
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555282,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گراش",
          "name:en": "Gerash County",
          "name:uk": "Ґераш",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q3924577",
          "wikipedia": "en:Gerash County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.1372218,
                27.6177118
              ],
              [
                53.152512,
                27.6161157
              ],
              [
                53.1579377,
                27.6159302
              ],
              [
                53.1667041,
                27.6179158
              ],
              [
                53.1766073,
                27.6243376
              ],
              [
                53.1825845,
                27.6275316
              ],
              [
                53.1857622,
                27.6289512
              ],
              [
                53.1908225,
                27.6297791
              ],
              [
                53.2009445,
                27.6301255
              ],
              [
                53.2078161,
                27.6290102
              ],
              [
                53.2261517,
                27.6285626
              ],
              [
                53.2427802,
                27.6287799
              ],
              [
                53.2544231,
                27.6288666
              ],
              [
                53.2635834,
                27.6278536
              ],
              [
                53.2751839,
                27.6274346
              ],
              [
                53.282172,
                27.6202147
              ],
              [
                53.2921444,
                27.6128879
              ],
              [
                53.3097838,
                27.597304
              ],
              [
                53.319826,
                27.5875672
              ],
              [
                53.3324432,
                27.573493
              ],
              [
                53.3433436,
                27.5656563
              ],
              [
                53.3572482,
                27.5591126
              ],
              [
                53.3656948,
                27.5561036
              ],
              [
                53.3672475,
                27.5587321
              ],
              [
                53.3661317,
                27.5616996
              ],
              [
                53.3622693,
                27.5706019
              ],
              [
                53.3612823,
                27.5818236
              ],
              [
                53.3621692,
                27.5905006
              ],
              [
                53.3654967,
                27.5941518
              ],
              [
                53.3714103,
                27.5935768
              ],
              [
                53.3900254,
                27.5911731
              ],
              [
                53.4272484,
                27.5806243
              ],
              [
                53.4329509,
                27.5780197
              ],
              [
                53.4429111,
                27.5781704
              ],
              [
                53.4504175,
                27.5770307
              ],
              [
                53.4590005,
                27.5760417
              ],
              [
                53.4630722,
                27.5763314
              ],
              [
                53.4681844,
                27.5748624
              ],
              [
                53.4734713,
                27.5729182
              ],
              [
                53.4939948,
                27.5636165
              ],
              [
                53.4998988,
                27.5609388
              ],
              [
                53.5077094,
                27.5598735
              ],
              [
                53.5085566,
                27.5459209
              ],
              [
                53.5095564,
                27.5441748
              ],
              [
                53.5095333,
                27.540849
              ],
              [
                53.510456,
                27.5370437
              ],
              [
                53.5235023,
                27.5342277
              ],
              [
                53.5338878,
                27.5308789
              ],
              [
                53.5430717,
                27.5306506
              ],
              [
                53.5499381,
                27.5301178
              ],
              [
                53.5584783,
                27.5300036
              ],
              [
                53.5605812,
                27.5279105
              ],
              [
                53.5660743,
                27.5257793
              ],
              [
                53.5732841,
                27.5256271
              ],
              [
                53.5757732,
                27.5285194
              ],
              [
                53.5759448,
                27.5311072
              ],
              [
                53.5943984,
                27.5148182
              ],
              [
                53.6010932,
                27.5094134
              ],
              [
                53.6065005,
                27.5012676
              ],
              [
                53.6162278,
                27.4982029
              ],
              [
                53.6332432,
                27.4870443
              ],
              [
                53.6541455,
                27.4721041
              ],
              [
                53.6782562,
                27.4559455
              ],
              [
                53.6893261,
                27.4528583
              ],
              [
                53.7064324,
                27.4480082
              ],
              [
                53.7199745,
                27.4418104
              ],
              [
                53.7199787,
                27.4418093
              ],
              [
                53.7228017,
                27.4410422
              ],
              [
                53.7233228,
                27.4409008
              ],
              [
                53.7237909,
                27.440798
              ],
              [
                53.725821,
                27.4403524
              ],
              [
                53.725825,
                27.4403524
              ],
              [
                53.725826,
                27.4403524
              ],
              [
                53.7260254,
                27.4403523
              ],
              [
                53.7260256,
                27.4403523
              ],
              [
                53.7260304,
                27.4403523
              ],
              [
                53.7260305,
                27.4403523
              ],
              [
                53.7266528,
                27.4403525
              ],
              [
                53.7266541,
                27.4403525
              ],
              [
                53.7266543,
                27.4403525
              ],
              [
                53.7266535,
                27.4403552
              ],
              [
                53.7266534,
                27.4403553
              ],
              [
                53.7256742,
                27.4434149
              ],
              [
                53.7005175,
                27.5219698
              ],
              [
                53.6978783,
                27.5301863
              ],
              [
                53.6978779,
                27.5301876
              ],
              [
                53.6318735,
                27.5584916
              ],
              [
                53.6984906,
                27.5887216
              ],
              [
                53.6984944,
                27.5887211
              ],
              [
                53.6984946,
                27.5887211
              ],
              [
                53.6984947,
                27.5887211
              ],
              [
                53.781798,
                27.5774838
              ],
              [
                53.7817981,
                27.5774838
              ],
              [
                53.7817982,
                27.5774838
              ],
              [
                53.7818023,
                27.5774832
              ],
              [
                53.8155462,
                27.5972893
              ],
              [
                53.8288288,
                27.5975598
              ],
              [
                53.8288308,
                27.5975598
              ],
              [
                53.8842277,
                27.5986729
              ],
              [
                53.8842327,
                27.598673
              ],
              [
                53.9112888,
                27.5992071
              ],
              [
                53.9130514,
                27.5992417
              ],
              [
                53.9374942,
                27.6036863
              ],
              [
                53.9397231,
                27.604513
              ],
              [
                53.9618502,
                27.6096656
              ],
              [
                53.9618546,
                27.6096666
              ],
              [
                53.9635065,
                27.6100509
              ],
              [
                53.9636075,
                27.6100745
              ],
              [
                53.9636134,
                27.6100774
              ],
              [
                53.9639255,
                27.6102313
              ],
              [
                53.9639297,
                27.6102333
              ],
              [
                53.9647225,
                27.6106231
              ],
              [
                53.9647226,
                27.6106231
              ],
              [
                53.9647229,
                27.6106233
              ],
              [
                53.9647246,
                27.6106241
              ],
              [
                53.9658322,
                27.6106241
              ],
              [
                53.9658323,
                27.6106241
              ],
              [
                53.9658325,
                27.6106241
              ],
              [
                53.9658347,
                27.6106241
              ],
              [
                53.9663903,
                27.6109019
              ],
              [
                53.9663904,
                27.610902
              ],
              [
                53.9663906,
                27.6109021
              ],
              [
                53.9672205,
                27.6109021
              ],
              [
                53.9672214,
                27.6109026
              ],
              [
                53.9672217,
                27.6109028
              ],
              [
                53.9672218,
                27.6109028
              ],
              [
                53.9677734,
                27.6111776
              ],
              [
                53.9677737,
                27.6111778
              ],
              [
                53.9677738,
                27.6111778
              ],
              [
                53.9683304,
                27.6114599
              ],
              [
                53.9688871,
                27.61146
              ],
              [
                53.9743965,
                27.6132924
              ],
              [
                53.9744001,
                27.6132936
              ],
              [
                53.9788924,
                27.6147898
              ],
              [
                53.9816689,
                27.6175701
              ],
              [
                53.9816695,
                27.6175707
              ],
              [
                53.9821688,
                27.6188711
              ],
              [
                53.9830581,
                27.621187
              ],
              [
                53.9919456,
                27.6247939
              ],
              [
                53.9919457,
                27.6247939
              ],
              [
                53.9919461,
                27.6247941
              ],
              [
                53.9919501,
                27.6247957
              ],
              [
                53.9930602,
                27.6247957
              ],
              [
                53.9938918,
                27.6245173
              ],
              [
                53.9955697,
                27.6245161
              ],
              [
                53.9998656,
                27.6240671
              ],
              [
                54.0062322,
                27.6251127
              ],
              [
                54.0065486,
                27.6251647
              ],
              [
                54.006549,
                27.6251648
              ],
              [
                54.0068734,
                27.625218
              ],
              [
                54.0068743,
                27.6252182
              ],
              [
                54.0068745,
                27.6252182
              ],
              [
                54.0102659,
                27.625775
              ],
              [
                54.0102698,
                27.6257757
              ],
              [
                54.0127822,
                27.6261881
              ],
              [
                54.0233327,
                27.6261881
              ],
              [
                54.023334,
                27.6261881
              ],
              [
                54.0233342,
                27.6261881
              ],
              [
                54.0233348,
                27.6261881
              ],
              [
                54.0233375,
                27.6261881
              ],
              [
                54.0235187,
                27.6261245
              ],
              [
                54.0241729,
                27.625902
              ],
              [
                54.0261146,
                27.625902
              ],
              [
                54.0283385,
                27.6253527
              ],
              [
                54.0297271,
                27.6253527
              ],
              [
                54.0397292,
                27.6225718
              ],
              [
                54.040556,
                27.6220139
              ],
              [
                54.0411127,
                27.6220139
              ],
              [
                54.0441659,
                27.6203494
              ],
              [
                54.0524997,
                27.6167412
              ],
              [
                54.064169,
                27.6131335
              ],
              [
                54.0652789,
                27.6131335
              ],
              [
                54.0744455,
                27.6106232
              ],
              [
                54.0755588,
                27.6106232
              ],
              [
                54.0797301,
                27.6095179
              ],
              [
                54.0955585,
                27.6072942
              ],
              [
                54.0955589,
                27.6072942
              ],
              [
                54.0955625,
                27.6072942
              ],
              [
                54.0955639,
                27.6072942
              ],
              [
                54.096675,
                27.6072939
              ],
              [
                54.1397287,
                27.5950773
              ],
              [
                54.1433378,
                27.5939604
              ],
              [
                54.1736172,
                27.5870146
              ],
              [
                54.1750073,
                27.5870147
              ],
              [
                54.1761172,
                27.5867358
              ],
              [
                54.1777838,
                27.5867357
              ],
              [
                54.1786171,
                27.5864568
              ],
              [
                54.1808463,
                27.586458
              ],
              [
                54.1816737,
                27.5861869
              ],
              [
                54.1829392,
                27.5861869
              ],
              [
                54.1836169,
                27.5861869
              ],
              [
                54.1836172,
                27.5861869
              ],
              [
                54.1836176,
                27.5861873
              ],
              [
                54.1836177,
                27.5861874
              ],
              [
                54.1840874,
                27.586649
              ],
              [
                54.1844504,
                27.5870147
              ],
              [
                54.1844949,
                27.5871505
              ],
              [
                54.1847339,
                27.5878505
              ],
              [
                54.1848901,
                27.5880095
              ],
              [
                54.185007,
                27.5881303
              ],
              [
                54.1869609,
                27.5946737
              ],
              [
                54.1905879,
                27.6068077
              ],
              [
                54.1911235,
                27.6089611
              ],
              [
                54.1961165,
                27.6272952
              ],
              [
                54.1969355,
                27.6289314
              ],
              [
                54.1969498,
                27.62896
              ],
              [
                54.1970378,
                27.6294831
              ],
              [
                54.1970471,
                27.6295385
              ],
              [
                54.1970555,
                27.6295871
              ],
              [
                54.1972341,
                27.6306238
              ],
              [
                54.2004661,
                27.6385607
              ],
              [
                54.2004662,
                27.6385609
              ],
              [
                54.2033458,
                27.6456317
              ],
              [
                54.2033458,
                27.6464595
              ],
              [
                54.2055634,
                27.6511842
              ],
              [
                54.2100138,
                27.6645181
              ],
              [
                54.2102182,
                27.6649399
              ],
              [
                54.2103019,
                27.6651028
              ],
              [
                54.2172298,
                27.6822905
              ],
              [
                54.2174761,
                27.6827136
              ],
              [
                54.2191732,
                27.6856288
              ],
              [
                54.2226959,
                27.694791
              ],
              [
                54.2247294,
                27.70008
              ],
              [
                54.2248342,
                27.7004944
              ],
              [
                54.2250171,
                27.701189
              ],
              [
                54.2258431,
                27.7034097
              ],
              [
                54.2261272,
                27.7045192
              ],
              [
                54.2262113,
                27.7047043
              ],
              [
                54.2274648,
                27.7074506
              ],
              [
                54.2274654,
                27.7074519
              ],
              [
                54.2303671,
                27.7138153
              ],
              [
                54.230563,
                27.7142439
              ],
              [
                54.2311011,
                27.7147746
              ],
              [
                54.2311018,
                27.7147753
              ],
              [
                54.2311021,
                27.7147755
              ],
              [
                54.2311028,
                27.7147762
              ],
              [
                54.231103,
                27.7147764
              ],
              [
                54.2311196,
                27.7147928
              ],
              [
                54.2313771,
                27.7154639
              ],
              [
                54.2325168,
                27.7184124
              ],
              [
                54.2330695,
                27.7189615
              ],
              [
                54.2377858,
                27.7325742
              ],
              [
                54.2380625,
                27.7342481
              ],
              [
                54.2383429,
                27.7353551
              ],
              [
                54.2384759,
                27.7360214
              ],
              [
                54.238476,
                27.7360216
              ],
              [
                54.2386189,
                27.7367156
              ],
              [
                54.2386253,
                27.7367465
              ],
              [
                54.2391758,
                27.7389634
              ],
              [
                54.2391758,
                27.7389636
              ],
              [
                54.2407201,
                27.7448342
              ],
              [
                54.2407204,
                27.7448356
              ],
              [
                54.2433424,
                27.7548018
              ],
              [
                54.2436191,
                27.7564667
              ],
              [
                54.2436191,
                27.7564668
              ],
              [
                54.2441755,
                27.7592463
              ],
              [
                54.2441756,
                27.7592464
              ],
              [
                54.2441757,
                27.7592474
              ],
              [
                54.2441758,
                27.7592476
              ],
              [
                54.2444528,
                27.7606335
              ],
              [
                54.2410103,
                27.7616699
              ],
              [
                54.1761811,
                27.7811643
              ],
              [
                54.1587315,
                27.7864041
              ],
              [
                54.158728,
                27.7864052
              ],
              [
                54.1587279,
                27.7864052
              ],
              [
                54.1587277,
                27.786405
              ],
              [
                54.1587229,
                27.786399
              ],
              [
                54.1587228,
                27.7863988
              ],
              [
                54.1585553,
                27.7861876
              ],
              [
                54.1585552,
                27.7861875
              ],
              [
                54.1585546,
                27.7861866
              ],
              [
                54.1585544,
                27.7861865
              ],
              [
                54.1583374,
                27.7859127
              ],
              [
                54.1583374,
                27.7856339
              ],
              [
                54.1583374,
                27.7856338
              ],
              [
                54.1583373,
                27.7856336
              ],
              [
                54.1583271,
                27.7856233
              ],
              [
                54.158327,
                27.7856233
              ],
              [
                54.1580607,
                27.7853546
              ],
              [
                54.1577838,
                27.7847969
              ],
              [
                54.1566704,
                27.7834107
              ],
              [
                54.154724,
                27.7785406
              ],
              [
                54.154724,
                27.7785404
              ],
              [
                54.1547237,
                27.7785397
              ],
              [
                54.1538993,
                27.7764643
              ],
              [
                54.1537691,
                27.7761161
              ],
              [
                54.1524364,
                27.7726189
              ],
              [
                54.1516904,
                27.7706821
              ],
              [
                54.1516705,
                27.7706315
              ],
              [
                54.1516385,
                27.7705669
              ],
              [
                54.1508437,
                27.7689684
              ],
              [
                54.1508431,
                27.7689678
              ],
              [
                54.1505653,
                27.7686899
              ],
              [
                54.1488982,
                27.7650812
              ],
              [
                54.1483451,
                27.7611826
              ],
              [
                54.134452,
                27.7228563
              ],
              [
                54.1336204,
                27.7220209
              ],
              [
                54.1330672,
                27.7209147
              ],
              [
                54.1326145,
                27.7206094
              ],
              [
                54.1326136,
                27.7206088
              ],
              [
                54.1322356,
                27.7203539
              ],
              [
                54.1319539,
                27.719798
              ],
              [
                54.1319533,
                27.719797
              ],
              [
                54.1319532,
                27.7197969
              ],
              [
                54.1291713,
                27.7181314
              ],
              [
                54.1227814,
                27.7134071
              ],
              [
                54.1186197,
                27.7117443
              ],
              [
                54.1186196,
                27.7117443
              ],
              [
                54.1186192,
                27.7117441
              ],
              [
                54.1186147,
                27.7117423
              ],
              [
                54.1177815,
                27.7117423
              ],
              [
                54.1172955,
                27.7116203
              ],
              [
                54.1172702,
                27.711614
              ],
              [
                54.1172695,
                27.7116138
              ],
              [
                54.1172486,
                27.7116086
              ],
              [
                54.117248,
                27.7116084
              ],
              [
                54.117207,
                27.7115981
              ],
              [
                54.1164311,
                27.711402
              ],
              [
                54.1155654,
                27.7111834
              ],
              [
                54.1133382,
                27.7111844
              ],
              [
                54.1122248,
                27.7109054
              ],
              [
                54.1108383,
                27.7109054
              ],
              [
                54.1100052,
                27.7106266
              ],
              [
                54.1100051,
                27.7106266
              ],
              [
                54.1100049,
                27.7106265
              ],
              [
                54.1100047,
                27.7106265
              ],
              [
                54.1100045,
                27.7106265
              ],
              [
                54.109989,
                27.7106265
              ],
              [
                54.1072304,
                27.7106265
              ],
              [
                54.1072303,
                27.7106265
              ],
              [
                54.1072301,
                27.7106265
              ],
              [
                54.1072251,
                27.7106265
              ],
              [
                54.1063919,
                27.7103566
              ],
              [
                54.1063918,
                27.7103566
              ],
              [
                54.1063916,
                27.7103565
              ],
              [
                54.1056293,
                27.7104448
              ],
              [
                54.1017003,
                27.7109
              ],
              [
                54.1016954,
                27.7109006
              ],
              [
                54.1009565,
                27.7109857
              ],
              [
                54.100956,
                27.7109858
              ],
              [
                54.0727788,
                27.7142439
              ],
              [
                54.06812,
                27.7153507
              ],
              [
                54.0680334,
                27.715373
              ],
              [
                54.0673547,
                27.7156297
              ],
              [
                54.0673505,
                27.7156313
              ],
              [
                54.060209,
                27.7183318
              ],
              [
                54.0600023,
                27.7184103
              ],
              [
                54.0599889,
                27.7184122
              ],
              [
                54.0597174,
                27.7184515
              ],
              [
                54.0590371,
                27.7185498
              ],
              [
                54.0590063,
                27.7185543
              ],
              [
                54.0580557,
                27.7186892
              ],
              [
                54.0544501,
                27.719797
              ],
              [
                54.051122,
                27.7197961
              ],
              [
                54.0511193,
                27.7197961
              ],
              [
                54.0511191,
                27.7197961
              ],
              [
                54.051119,
                27.7197961
              ],
              [
                54.051114,
                27.7197961
              ],
              [
                54.0511125,
                27.7197961
              ],
              [
                54.0508376,
                27.7195185
              ],
              [
                54.0508338,
                27.7195185
              ],
              [
                54.0508336,
                27.7195185
              ],
              [
                54.0508335,
                27.7195185
              ],
              [
                54.0480832,
                27.7195171
              ],
              [
                54.0477847,
                27.7195171
              ],
              [
                54.0477844,
                27.7195171
              ],
              [
                54.0477843,
                27.7195171
              ],
              [
                54.047784,
                27.7195171
              ],
              [
                54.0477793,
                27.7195171
              ],
              [
                54.0477791,
                27.719517
              ],
              [
                54.047779,
                27.7195168
              ],
              [
                54.0477729,
                27.7195108
              ],
              [
                54.0477625,
                27.7195004
              ],
              [
                54.0477623,
                27.7195002
              ],
              [
                54.0475012,
                27.7192402
              ],
              [
                54.0475009,
                27.7192398
              ],
              [
                54.0474992,
                27.7192382
              ],
              [
                54.047499,
                27.7192382
              ],
              [
                54.0474988,
                27.7192382
              ],
              [
                54.0474984,
                27.7192382
              ],
              [
                54.0474981,
                27.7192382
              ],
              [
                54.0474977,
                27.7192382
              ],
              [
                54.0474971,
                27.7192382
              ],
              [
                54.0469489,
                27.7192382
              ],
              [
                54.0469486,
                27.7192382
              ],
              [
                54.0469485,
                27.7192382
              ],
              [
                54.0469482,
                27.7192382
              ],
              [
                54.046946,
                27.7192382
              ],
              [
                54.0469459,
                27.7192382
              ],
              [
                54.0469458,
                27.7192381
              ],
              [
                54.0466656,
                27.7189591
              ],
              [
                54.0466655,
                27.7189591
              ],
              [
                54.0466647,
                27.7189589
              ],
              [
                54.046664,
                27.7189587
              ],
              [
                54.0466582,
                27.7189573
              ],
              [
                54.0456034,
                27.7187009
              ],
              [
                54.0455629,
                27.718691
              ],
              [
                54.0455623,
                27.7186909
              ],
              [
                54.045562,
                27.7186908
              ],
              [
                54.0455559,
                27.7186893
              ],
              [
                54.044727,
                27.717852
              ],
              [
                54.0447265,
                27.7178515
              ],
              [
                54.0447215,
                27.717849
              ],
              [
                54.0436126,
                27.7172944
              ],
              [
                54.04042,
                27.7152129
              ],
              [
                54.0372268,
                27.7131289
              ],
              [
                54.036167,
                27.7127745
              ],
              [
                54.0359431,
                27.7126997
              ],
              [
                54.0358551,
                27.7126703
              ],
              [
                54.0358547,
                27.7126701
              ],
              [
                54.0347228,
                27.7122912
              ],
              [
                54.0336094,
                27.7122912
              ],
              [
                54.0307918,
                27.7115567
              ],
              [
                54.0273968,
                27.7106685
              ],
              [
                54.0273875,
                27.7106661
              ],
              [
                54.0273853,
                27.7106655
              ],
              [
                54.0273304,
                27.7106511
              ],
              [
                54.0244431,
                27.7097986
              ],
              [
                54.024443,
                27.7097986
              ],
              [
                54.024198,
                27.7097986
              ],
              [
                54.0241887,
                27.7097986
              ],
              [
                54.0233327,
                27.7097985
              ],
              [
                54.0233326,
                27.7097985
              ],
              [
                54.0231435,
                27.7097037
              ],
              [
                54.0227777,
                27.7095203
              ],
              [
                54.0227775,
                27.7095202
              ],
              [
                54.0227773,
                27.7095202
              ],
              [
                54.0227772,
                27.7095202
              ],
              [
                54.0227762,
                27.7095197
              ],
              [
                54.0227761,
                27.7095196
              ],
              [
                54.0227758,
                27.7095195
              ],
              [
                54.0219426,
                27.7095195
              ],
              [
                54.0177812,
                27.7084141
              ],
              [
                54.017781,
                27.708414
              ],
              [
                54.0177808,
                27.708414
              ],
              [
                54.0177806,
                27.7084139
              ],
              [
                54.017776,
                27.7084127
              ],
              [
                54.01667,
                27.7084127
              ],
              [
                54.0166698,
                27.7084127
              ],
              [
                54.0166696,
                27.7084127
              ],
              [
                54.0166693,
                27.7084127
              ],
              [
                54.0166664,
                27.7084127
              ],
              [
                54.016666,
                27.7084127
              ],
              [
                54.0162866,
                27.7082816
              ],
              [
                54.0162767,
                27.7082782
              ],
              [
                54.0158331,
                27.7081249
              ],
              [
                53.9997866,
                27.7083541
              ],
              [
                53.9855536,
                27.7111844
              ],
              [
                53.9849968,
                27.7114634
              ],
              [
                53.9794436,
                27.7114633
              ],
              [
                53.978887,
                27.7117423
              ],
              [
                53.9744404,
                27.7117423
              ],
              [
                53.9644405,
                27.7128491
              ],
              [
                53.9586073,
                27.713965
              ],
              [
                53.9547173,
                27.7145228
              ],
              [
                53.9324944,
                27.7184103
              ],
              [
                53.9311077,
                27.7184103
              ],
              [
                53.9302744,
                27.7186893
              ],
              [
                53.9286078,
                27.7186893
              ],
              [
                53.9127713,
                27.7220188
              ],
              [
                53.911938,
                27.7220188
              ],
              [
                53.9108281,
                27.7225767
              ],
              [
                53.8863817,
                27.7284079
              ],
              [
                53.8849952,
                27.7284079
              ],
              [
                53.8833251,
                27.7289659
              ],
              [
                53.8819384,
                27.7289658
              ],
              [
                53.8658254,
                27.7331323
              ],
              [
                53.8644388,
                27.7334023
              ],
              [
                53.8624921,
                27.7342482
              ],
              [
                53.8483257,
                27.7389637
              ],
              [
                53.8222127,
                27.7520212
              ],
              [
                53.8208228,
                27.7525792
              ],
              [
                53.8024897,
                27.7670229
              ],
              [
                53.7883233,
                27.7756354
              ],
              [
                53.7866566,
                27.7756353
              ],
              [
                53.7858233,
                27.7753564
              ],
              [
                53.78471,
                27.7753563
              ],
              [
                53.7797101,
                27.7734125
              ],
              [
                53.7755435,
                27.7714686
              ],
              [
                53.7699869,
                27.7689667
              ],
              [
                53.7688768,
                27.7681299
              ],
              [
                53.767767,
                27.7678509
              ],
              [
                53.7669337,
                27.7673019
              ],
              [
                53.7180411,
                27.7553599
              ],
              [
                53.716931,
                27.7553599
              ],
              [
                53.7066426,
                27.75253
              ],
              [
                53.7027646,
                27.7514633
              ],
              [
                53.700818,
                27.7511844
              ],
              [
                53.698318,
                27.7503564
              ],
              [
                53.6972081,
                27.7497985
              ],
              [
                53.681375,
                27.7467387
              ],
              [
                53.6752617,
                27.7467387
              ],
              [
                53.6738716,
                27.7470177
              ],
              [
                53.6724851,
                27.7470177
              ],
              [
                53.6522054,
                27.7514633
              ],
              [
                53.6441489,
                27.754244
              ],
              [
                53.6385957,
                27.7564668
              ],
              [
                53.6058162,
                27.7706316
              ],
              [
                53.593593,
                27.7747983
              ],
              [
                53.5830365,
                27.7773002
              ],
              [
                53.571067,
                27.7810028
              ],
              [
                53.5560903,
                27.7856337
              ],
              [
                53.5274774,
                27.7961902
              ],
              [
                53.5113253,
                27.8006078
              ],
              [
                53.5013248,
                27.8031601
              ],
              [
                53.4973584,
                27.7939645
              ],
              [
                53.4853468,
                27.7652235
              ],
              [
                53.4732913,
                27.736567
              ],
              [
                53.46774,
                27.7082537
              ],
              [
                53.466495,
                27.7036435
              ],
              [
                53.463629,
                27.6946571
              ],
              [
                53.4535091,
                27.695797
              ],
              [
                53.4438244,
                27.6968099
              ],
              [
                53.4348981,
                27.696726
              ],
              [
                53.4293106,
                27.695738
              ],
              [
                53.4222116,
                27.6970899
              ],
              [
                53.4132842,
                27.6996587
              ],
              [
                53.3976508,
                27.7048522
              ],
              [
                53.3829027,
                27.7103046
              ],
              [
                53.3729605,
                27.7133821
              ],
              [
                53.3667692,
                27.7143628
              ],
              [
                53.3622709,
                27.7141859
              ],
              [
                53.3487308,
                27.7055364
              ],
              [
                53.3382794,
                27.6978744
              ],
              [
                53.325308,
                27.6915059
              ],
              [
                53.3143329,
                27.6834522
              ],
              [
                53.301876,
                27.6752914
              ],
              [
                53.2925894,
                27.6694383
              ],
              [
                53.2858454,
                27.6660677
              ],
              [
                53.2791871,
                27.6627224
              ],
              [
                53.2770471,
                27.6662533
              ],
              [
                53.2724373,
                27.6705354
              ],
              [
                53.2559643,
                27.6817741
              ],
              [
                53.2490157,
                27.6840602
              ],
              [
                53.2426638,
                27.6872573
              ],
              [
                53.2163142,
                27.6972083
              ],
              [
                53.1952386,
                27.7051193
              ],
              [
                53.1792416,
                27.6828171
              ],
              [
                53.1689357,
                27.6693902
              ],
              [
                53.1653308,
                27.6633088
              ],
              [
                53.1572627,
                27.6539581
              ],
              [
                53.152542,
                27.6494724
              ],
              [
                53.1404399,
                27.6418693
              ],
              [
                53.136835,
                27.6406527
              ],
              [
                53.1326722,
                27.6372691
              ],
              [
                53.1273078,
                27.6344556
              ],
              [
                53.1232738,
                27.6312619
              ],
              [
                53.1212997,
                27.629627
              ],
              [
                53.118596,
                27.6274978
              ],
              [
                53.1209564,
                27.6249503
              ],
              [
                53.1243467,
                27.6227069
              ],
              [
                53.1300973,
                27.6206155
              ],
              [
                53.1340241,
                27.6190375
              ],
              [
                53.1372218,
                27.6177118
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555350,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اوز",
          "name:en": "Evaz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4814832"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.4791414,
                27.9998007
              ],
              [
                53.4796981,
                27.9986934
              ],
              [
                53.4796981,
                27.9984143
              ],
              [
                53.4910879,
                27.9889711
              ],
              [
                53.5160875,
                27.9773045
              ],
              [
                53.5180341,
                27.9767464
              ],
              [
                53.5217212,
                27.9751727
              ],
              [
                53.5388671,
                27.9678525
              ],
              [
                53.5569235,
                27.9625775
              ],
              [
                53.5580334,
                27.9625775
              ],
              [
                53.5588667,
                27.9620284
              ],
              [
                53.5663701,
                27.9600841
              ],
              [
                53.5672034,
                27.9595259
              ],
              [
                53.5680368,
                27.9595261
              ],
              [
                53.5691468,
                27.9592469
              ],
              [
                53.5730366,
                27.9578606
              ],
              [
                53.5733133,
                27.9575816
              ],
              [
                53.5780366,
                27.9561863
              ],
              [
                53.5983129,
                27.9481389
              ],
              [
                53.6116494,
                27.9381382
              ],
              [
                53.6124393,
                27.9361274
              ],
              [
                53.6149826,
                27.9328544
              ],
              [
                53.6749851,
                27.8945275
              ],
              [
                53.6805417,
                27.8920253
              ],
              [
                53.7124844,
                27.8775791
              ],
              [
                53.7288742,
                27.8714676
              ],
              [
                53.6946809,
                27.8528613
              ],
              [
                53.689223,
                27.8377094
              ],
              [
                53.6261567,
                27.8330746
              ],
              [
                53.571067,
                27.7810028
              ],
              [
                53.5830365,
                27.7773002
              ],
              [
                53.593593,
                27.7747983
              ],
              [
                53.6058162,
                27.7706316
              ],
              [
                53.6385957,
                27.7564668
              ],
              [
                53.6441489,
                27.754244
              ],
              [
                53.6522054,
                27.7514633
              ],
              [
                53.6724851,
                27.7470177
              ],
              [
                53.6738716,
                27.7470177
              ],
              [
                53.6752617,
                27.7467387
              ],
              [
                53.681375,
                27.7467387
              ],
              [
                53.6972081,
                27.7497985
              ],
              [
                53.698318,
                27.7503564
              ],
              [
                53.700818,
                27.7511844
              ],
              [
                53.7027646,
                27.7514633
              ],
              [
                53.7066426,
                27.75253
              ],
              [
                53.716931,
                27.7553599
              ],
              [
                53.7180411,
                27.7553599
              ],
              [
                53.7669337,
                27.7673019
              ],
              [
                53.767767,
                27.7678509
              ],
              [
                53.7688768,
                27.7681299
              ],
              [
                53.7699869,
                27.7689667
              ],
              [
                53.7755435,
                27.7714686
              ],
              [
                53.7797101,
                27.7734125
              ],
              [
                53.78471,
                27.7753563
              ],
              [
                53.7858233,
                27.7753564
              ],
              [
                53.7866566,
                27.7756353
              ],
              [
                53.7883233,
                27.7756354
              ],
              [
                53.8024897,
                27.7670229
              ],
              [
                53.8208228,
                27.7525792
              ],
              [
                53.8222127,
                27.7520212
              ],
              [
                53.8483257,
                27.7389637
              ],
              [
                53.8624921,
                27.7342482
              ],
              [
                53.8644388,
                27.7334023
              ],
              [
                53.8658254,
                27.7331323
              ],
              [
                53.8819384,
                27.7289658
              ],
              [
                53.8833251,
                27.7289659
              ],
              [
                53.8849952,
                27.7284079
              ],
              [
                53.8863817,
                27.7284079
              ],
              [
                53.9108281,
                27.7225767
              ],
              [
                53.911938,
                27.7220188
              ],
              [
                53.9127713,
                27.7220188
              ],
              [
                53.9286078,
                27.7186893
              ],
              [
                53.9302744,
                27.7186893
              ],
              [
                53.9311077,
                27.7184103
              ],
              [
                53.9324944,
                27.7184103
              ],
              [
                53.9547173,
                27.7145228
              ],
              [
                53.9586073,
                27.713965
              ],
              [
                53.9644405,
                27.7128491
              ],
              [
                53.9744404,
                27.7117423
              ],
              [
                53.978887,
                27.7117423
              ],
              [
                53.9794436,
                27.7114633
              ],
              [
                53.9849968,
                27.7114634
              ],
              [
                53.9855536,
                27.7111844
              ],
              [
                53.9997866,
                27.7083541
              ],
              [
                54.0158331,
                27.7081249
              ],
              [
                54.0162767,
                27.7082782
              ],
              [
                54.0162866,
                27.7082816
              ],
              [
                54.016666,
                27.7084127
              ],
              [
                54.0166664,
                27.7084127
              ],
              [
                54.0166693,
                27.7084127
              ],
              [
                54.0166696,
                27.7084127
              ],
              [
                54.0166698,
                27.7084127
              ],
              [
                54.01667,
                27.7084127
              ],
              [
                54.017776,
                27.7084127
              ],
              [
                54.0177806,
                27.7084139
              ],
              [
                54.0177808,
                27.708414
              ],
              [
                54.017781,
                27.708414
              ],
              [
                54.0177812,
                27.7084141
              ],
              [
                54.0219426,
                27.7095195
              ],
              [
                54.0227758,
                27.7095195
              ],
              [
                54.0227761,
                27.7095196
              ],
              [
                54.0227762,
                27.7095197
              ],
              [
                54.0227772,
                27.7095202
              ],
              [
                54.0227773,
                27.7095202
              ],
              [
                54.0227775,
                27.7095202
              ],
              [
                54.0227777,
                27.7095203
              ],
              [
                54.0231435,
                27.7097037
              ],
              [
                54.0233326,
                27.7097985
              ],
              [
                54.0233327,
                27.7097985
              ],
              [
                54.0241887,
                27.7097986
              ],
              [
                54.024198,
                27.7097986
              ],
              [
                54.024443,
                27.7097986
              ],
              [
                54.0244431,
                27.7097986
              ],
              [
                54.0273304,
                27.7106511
              ],
              [
                54.0273853,
                27.7106655
              ],
              [
                54.0273875,
                27.7106661
              ],
              [
                54.0273968,
                27.7106685
              ],
              [
                54.0307918,
                27.7115567
              ],
              [
                54.0336094,
                27.7122912
              ],
              [
                54.0347228,
                27.7122912
              ],
              [
                54.0358547,
                27.7126701
              ],
              [
                54.0358551,
                27.7126703
              ],
              [
                54.0359431,
                27.7126997
              ],
              [
                54.036167,
                27.7127745
              ],
              [
                54.0372268,
                27.7131289
              ],
              [
                54.04042,
                27.7152129
              ],
              [
                54.0436126,
                27.7172944
              ],
              [
                54.0447215,
                27.717849
              ],
              [
                54.0447265,
                27.7178515
              ],
              [
                54.044727,
                27.717852
              ],
              [
                54.0455559,
                27.7186893
              ],
              [
                54.045562,
                27.7186908
              ],
              [
                54.0455623,
                27.7186909
              ],
              [
                54.0455629,
                27.718691
              ],
              [
                54.0456034,
                27.7187009
              ],
              [
                54.0466582,
                27.7189573
              ],
              [
                54.046664,
                27.7189587
              ],
              [
                54.0466647,
                27.7189589
              ],
              [
                54.0466655,
                27.7189591
              ],
              [
                54.0466656,
                27.7189591
              ],
              [
                54.0469458,
                27.7192381
              ],
              [
                54.0469459,
                27.7192382
              ],
              [
                54.046946,
                27.7192382
              ],
              [
                54.0469482,
                27.7192382
              ],
              [
                54.0469485,
                27.7192382
              ],
              [
                54.0469486,
                27.7192382
              ],
              [
                54.0469489,
                27.7192382
              ],
              [
                54.0474971,
                27.7192382
              ],
              [
                54.0474977,
                27.7192382
              ],
              [
                54.0474981,
                27.7192382
              ],
              [
                54.0474984,
                27.7192382
              ],
              [
                54.0474988,
                27.7192382
              ],
              [
                54.047499,
                27.7192382
              ],
              [
                54.0474992,
                27.7192382
              ],
              [
                54.0475009,
                27.7192398
              ],
              [
                54.0475012,
                27.7192402
              ],
              [
                54.0477623,
                27.7195002
              ],
              [
                54.0477625,
                27.7195004
              ],
              [
                54.0477729,
                27.7195108
              ],
              [
                54.047779,
                27.7195168
              ],
              [
                54.0477791,
                27.719517
              ],
              [
                54.0477793,
                27.7195171
              ],
              [
                54.047784,
                27.7195171
              ],
              [
                54.0477843,
                27.7195171
              ],
              [
                54.0477844,
                27.7195171
              ],
              [
                54.0477847,
                27.7195171
              ],
              [
                54.0480832,
                27.7195171
              ],
              [
                54.0508335,
                27.7195185
              ],
              [
                54.0508336,
                27.7195185
              ],
              [
                54.0508338,
                27.7195185
              ],
              [
                54.0508376,
                27.7195185
              ],
              [
                54.0511125,
                27.7197961
              ],
              [
                54.051114,
                27.7197961
              ],
              [
                54.051119,
                27.7197961
              ],
              [
                54.0511191,
                27.7197961
              ],
              [
                54.0511193,
                27.7197961
              ],
              [
                54.051122,
                27.7197961
              ],
              [
                54.0544501,
                27.719797
              ],
              [
                54.0580557,
                27.7186892
              ],
              [
                54.0590063,
                27.7185543
              ],
              [
                54.0590371,
                27.7185498
              ],
              [
                54.0597174,
                27.7184515
              ],
              [
                54.0599889,
                27.7184122
              ],
              [
                54.0600023,
                27.7184103
              ],
              [
                54.060209,
                27.7183318
              ],
              [
                54.0673505,
                27.7156313
              ],
              [
                54.0673547,
                27.7156297
              ],
              [
                54.0680334,
                27.715373
              ],
              [
                54.06812,
                27.7153507
              ],
              [
                54.0727788,
                27.7142439
              ],
              [
                54.100956,
                27.7109858
              ],
              [
                54.1009565,
                27.7109857
              ],
              [
                54.1016954,
                27.7109006
              ],
              [
                54.1017003,
                27.7109
              ],
              [
                54.1056293,
                27.7104448
              ],
              [
                54.1063916,
                27.7103565
              ],
              [
                54.1063918,
                27.7103566
              ],
              [
                54.1063919,
                27.7103566
              ],
              [
                54.1072251,
                27.7106265
              ],
              [
                54.1072301,
                27.7106265
              ],
              [
                54.1072303,
                27.7106265
              ],
              [
                54.1072304,
                27.7106265
              ],
              [
                54.109989,
                27.7106265
              ],
              [
                54.1100045,
                27.7106265
              ],
              [
                54.1100047,
                27.7106265
              ],
              [
                54.1100049,
                27.7106265
              ],
              [
                54.1100051,
                27.7106266
              ],
              [
                54.1100052,
                27.7106266
              ],
              [
                54.1108383,
                27.7109054
              ],
              [
                54.1122248,
                27.7109054
              ],
              [
                54.1133382,
                27.7111844
              ],
              [
                54.1155654,
                27.7111834
              ],
              [
                54.1164311,
                27.711402
              ],
              [
                54.117207,
                27.7115981
              ],
              [
                54.117248,
                27.7116084
              ],
              [
                54.1172486,
                27.7116086
              ],
              [
                54.1172695,
                27.7116138
              ],
              [
                54.1172702,
                27.711614
              ],
              [
                54.1172955,
                27.7116203
              ],
              [
                54.1177815,
                27.7117423
              ],
              [
                54.1186147,
                27.7117423
              ],
              [
                54.1186192,
                27.7117441
              ],
              [
                54.1186196,
                27.7117443
              ],
              [
                54.1186197,
                27.7117443
              ],
              [
                54.1227814,
                27.7134071
              ],
              [
                54.1291713,
                27.7181314
              ],
              [
                54.1319532,
                27.7197969
              ],
              [
                54.1319533,
                27.719797
              ],
              [
                54.1319539,
                27.719798
              ],
              [
                54.1322356,
                27.7203539
              ],
              [
                54.1326136,
                27.7206088
              ],
              [
                54.1326145,
                27.7206094
              ],
              [
                54.1330672,
                27.7209147
              ],
              [
                54.1336204,
                27.7220209
              ],
              [
                54.134452,
                27.7228563
              ],
              [
                54.1483451,
                27.7611826
              ],
              [
                54.1488982,
                27.7650812
              ],
              [
                54.1505653,
                27.7686899
              ],
              [
                54.1508431,
                27.7689678
              ],
              [
                54.1508437,
                27.7689684
              ],
              [
                54.1516385,
                27.7705669
              ],
              [
                54.1516705,
                27.7706315
              ],
              [
                54.1516904,
                27.7706821
              ],
              [
                54.1524364,
                27.7726189
              ],
              [
                54.1537691,
                27.7761161
              ],
              [
                54.1538993,
                27.7764643
              ],
              [
                54.1547237,
                27.7785397
              ],
              [
                54.154724,
                27.7785404
              ],
              [
                54.154724,
                27.7785406
              ],
              [
                54.1566704,
                27.7834107
              ],
              [
                54.1577838,
                27.7847969
              ],
              [
                54.1580607,
                27.7853546
              ],
              [
                54.158327,
                27.7856233
              ],
              [
                54.1583271,
                27.7856233
              ],
              [
                54.1583373,
                27.7856336
              ],
              [
                54.1583374,
                27.7856338
              ],
              [
                54.1583374,
                27.7856339
              ],
              [
                54.1583374,
                27.7859127
              ],
              [
                54.1585544,
                27.7861865
              ],
              [
                54.1585546,
                27.7861866
              ],
              [
                54.1585552,
                27.7861875
              ],
              [
                54.1585553,
                27.7861876
              ],
              [
                54.1587228,
                27.7863988
              ],
              [
                54.1587229,
                27.786399
              ],
              [
                54.1587277,
                27.786405
              ],
              [
                54.1587279,
                27.7864052
              ],
              [
                54.1587279,
                27.7864053
              ],
              [
                54.158728,
                27.7864055
              ],
              [
                54.1591707,
                27.7872986
              ],
              [
                54.1719506,
                27.8189599
              ],
              [
                54.1722272,
                27.8211918
              ],
              [
                54.1725073,
                27.8236849
              ],
              [
                54.1736173,
                27.8300749
              ],
              [
                54.1738938,
                27.8314609
              ],
              [
                54.1744506,
                27.834242
              ],
              [
                54.1761172,
                27.8495244
              ],
              [
                54.1758406,
                27.8573008
              ],
              [
                54.1755605,
                27.8578588
              ],
              [
                54.1758405,
                27.8584079
              ],
              [
                54.1755605,
                27.8667423
              ],
              [
                54.1752839,
                27.8689654
              ],
              [
                54.1761172,
                27.8759049
              ],
              [
                54.1763938,
                27.8811884
              ],
              [
                54.1755605,
                27.8864628
              ],
              [
                54.1752839,
                27.8870208
              ],
              [
                54.1750072,
                27.8872999
              ],
              [
                54.1750073,
                27.8875789
              ],
              [
                54.1572275,
                27.8964717
              ],
              [
                54.1550042,
                27.8975789
              ],
              [
                54.1038916,
                27.9278586
              ],
              [
                54.100835,
                27.9295239
              ],
              [
                54.0922252,
                27.9345287
              ],
              [
                54.0836119,
                27.9378592
              ],
              [
                54.0827786,
                27.9384083
              ],
              [
                54.0672222,
                27.9422969
              ],
              [
                54.0666689,
                27.942576
              ],
              [
                54.0658356,
                27.9425759
              ],
              [
                54.0652789,
                27.942855
              ],
              [
                54.0636123,
                27.9428551
              ],
              [
                54.0630557,
                27.9431341
              ],
              [
                54.0622223,
                27.9431341
              ],
              [
                54.0619456,
                27.9434131
              ],
              [
                54.0608357,
                27.9434131
              ],
              [
                54.060279,
                27.9436921
              ],
              [
                54.0594457,
                27.9436922
              ],
              [
                54.0591691,
                27.9439712
              ],
              [
                54.0580557,
                27.9439712
              ],
              [
                54.0577791,
                27.9442503
              ],
              [
                54.0566691,
                27.9442503
              ],
              [
                54.0561124,
                27.9445203
              ],
              [
                54.0550025,
                27.9445203
              ],
              [
                54.0547224,
                27.9448083
              ],
              [
                54.0530558,
                27.9448084
              ],
              [
                54.0488892,
                27.9456365
              ],
              [
                54.0480559,
                27.9456365
              ],
              [
                54.0436126,
                27.9475808
              ],
              [
                54.043056,
                27.9475808
              ],
              [
                54.0427793,
                27.9478509
              ],
              [
                54.0402794,
                27.9489671
              ],
              [
                54.0203796,
                27.961096
              ],
              [
                54.0111098,
                27.9667454
              ],
              [
                53.9998721,
                27.9733219
              ],
              [
                53.9902768,
                27.9792489
              ],
              [
                53.9899968,
                27.9795281
              ],
              [
                53.9888867,
                27.9795281
              ],
              [
                53.9883301,
                27.9798071
              ],
              [
                53.9872202,
                27.9798072
              ],
              [
                53.9661071,
                27.9903575
              ],
              [
                53.9624972,
                27.9936882
              ],
              [
                53.9558307,
                27.9978562
              ],
              [
                53.9555506,
                27.9981353
              ],
              [
                53.9422175,
                28.0103604
              ],
              [
                53.9338843,
                28.012854
              ],
              [
                53.9336077,
                28.0131331
              ],
              [
                53.9327744,
                28.0131331
              ],
              [
                53.9322177,
                28.0134121
              ],
              [
                53.9277744,
                28.0134122
              ],
              [
                53.9274944,
                28.0136912
              ],
              [
                53.9247178,
                28.0136912
              ],
              [
                53.9241612,
                28.0139703
              ],
              [
                53.9211079,
                28.0139704
              ],
              [
                53.9208279,
                28.0142494
              ],
              [
                53.9174946,
                28.0142493
              ],
              [
                53.9172179,
                28.0139703
              ],
              [
                53.9161045,
                28.0139703
              ],
              [
                53.915828,
                28.0136912
              ],
              [
                53.9150935,
                28.0137415
              ],
              [
                53.911938,
                28.0131331
              ],
              [
                53.9113847,
                28.013133
              ],
              [
                53.9111046,
                28.0134121
              ],
              [
                53.9077714,
                28.0134122
              ],
              [
                53.9074948,
                28.0131331
              ],
              [
                53.9069381,
                28.0131331
              ],
              [
                53.9061047,
                28.012854
              ],
              [
                53.9052714,
                28.012854
              ],
              [
                53.9049948,
                28.0125839
              ],
              [
                53.9036048,
                28.012584
              ],
              [
                53.9033282,
                28.0123048
              ],
              [
                53.9019382,
                28.0123049
              ],
              [
                53.8952716,
                28.0106304
              ],
              [
                53.8938817,
                28.0106304
              ],
              [
                53.8930483,
                28.0103603
              ],
              [
                53.8916617,
                28.0103603
              ],
              [
                53.8905483,
                28.0100813
              ],
              [
                53.8883284,
                28.0100813
              ],
              [
                53.8880484,
                28.0098022
              ],
              [
                53.8855484,
                28.0098022
              ],
              [
                53.8836052,
                28.009244
              ],
              [
                53.8819385,
                28.009244
              ],
              [
                53.8722152,
                28.0075786
              ],
              [
                53.870272,
                28.0075786
              ],
              [
                53.8691586,
                28.0073086
              ],
              [
                53.867492,
                28.0073086
              ],
              [
                53.865272,
                28.0067504
              ],
              [
                53.8636021,
                28.0067504
              ],
              [
                53.8624922,
                28.0064713
              ],
              [
                53.861102,
                28.0064713
              ],
              [
                53.860644,
                28.0062403
              ],
              [
                53.8605489,
                28.0061923
              ],
              [
                53.8583255,
                28.0061923
              ],
              [
                53.8558255,
                28.0056341
              ],
              [
                53.8541589,
                28.0056341
              ],
              [
                53.8513823,
                28.005085
              ],
              [
                53.8497157,
                28.005085
              ],
              [
                53.8486023,
                28.004806
              ],
              [
                53.8416591,
                28.0048059
              ],
              [
                53.8408258,
                28.0045269
              ],
              [
                53.8336026,
                28.0045269
              ],
              [
                53.8330459,
                28.0042478
              ],
              [
                53.8319358,
                28.0042478
              ],
              [
                53.828326,
                28.0042478
              ],
              [
                53.8274927,
                28.0045269
              ],
              [
                53.8186028,
                28.0045269
              ],
              [
                53.8119363,
                28.0053551
              ],
              [
                53.8111029,
                28.0056342
              ],
              [
                53.8097129,
                28.0056341
              ],
              [
                53.8074897,
                28.0061922
              ],
              [
                53.8052663,
                28.0061923
              ],
              [
                53.8014166,
                28.0067014
              ],
              [
                53.7674869,
                28.0111885
              ],
              [
                53.7672102,
                28.0114676
              ],
              [
                53.7636003,
                28.0114676
              ],
              [
                53.762767,
                28.0117467
              ],
              [
                53.7613771,
                28.0117467
              ],
              [
                53.760267,
                28.0120258
              ],
              [
                53.7588771,
                28.0120257
              ],
              [
                53.7580437,
                28.0123048
              ],
              [
                53.7547104,
                28.0123049
              ],
              [
                53.7538772,
                28.012584
              ],
              [
                53.7524872,
                28.0125839
              ],
              [
                53.7516538,
                28.0125839
              ],
              [
                53.7477639,
                28.0125839
              ],
              [
                53.7469305,
                28.0123048
              ],
              [
                53.7466539,
                28.012584
              ],
              [
                53.743044,
                28.0125839
              ],
              [
                53.7422106,
                28.012854
              ],
              [
                53.7330442,
                28.012584
              ],
              [
                53.7319308,
                28.0123048
              ],
              [
                53.7260976,
                28.012854
              ],
              [
                53.7249875,
                28.013133
              ],
              [
                53.7233209,
                28.013133
              ],
              [
                53.7222076,
                28.0134121
              ],
              [
                53.7185976,
                28.0134121
              ],
              [
                53.7172077,
                28.0136912
              ],
              [
                53.7160977,
                28.0136912
              ],
              [
                53.7152644,
                28.0139702
              ],
              [
                53.7119312,
                28.0139703
              ],
              [
                53.7102645,
                28.0142493
              ],
              [
                53.7083178,
                28.0142494
              ],
              [
                53.7066513,
                28.0145284
              ],
              [
                53.7044313,
                28.0145284
              ],
              [
                53.7030412,
                28.0148075
              ],
              [
                53.6985981,
                28.0148075
              ],
              [
                53.697208,
                28.0150776
              ],
              [
                53.6949847,
                28.0150776
              ],
              [
                53.693318,
                28.0153567
              ],
              [
                53.6897082,
                28.0153566
              ],
              [
                53.6880415,
                28.0156358
              ],
              [
                53.6841516,
                28.0156357
              ],
              [
                53.6704393,
                28.0188961
              ],
              [
                53.6594357,
                28.0198054
              ],
              [
                53.6492654,
                28.0205717
              ],
              [
                53.6441413,
                28.0211399
              ],
              [
                53.6361236,
                28.0216323
              ],
              [
                53.6321999,
                28.0218975
              ],
              [
                53.6189641,
                28.022366
              ],
              [
                53.6108602,
                28.0235404
              ],
              [
                53.5933456,
                28.0253488
              ],
              [
                53.581438,
                28.027099
              ],
              [
                53.5741853,
                28.0268717
              ],
              [
                53.5667742,
                28.0286527
              ],
              [
                53.5606538,
                28.0269772
              ],
              [
                53.5553248,
                28.0235931
              ],
              [
                53.5493845,
                28.0202971
              ],
              [
                53.5274773,
                28.0103603
              ],
              [
                53.5188674,
                28.0075786
              ],
              [
                53.5080343,
                28.0020242
              ],
              [
                53.5074777,
                28.0017451
              ],
              [
                53.4969211,
                27.9992515
              ],
              [
                53.4955312,
                27.9995216
              ],
              [
                53.4949778,
                27.9998006
              ],
              [
                53.4941445,
                27.9998007
              ],
              [
                53.4933112,
                28.0001787
              ],
              [
                53.4916446,
                28.0003588
              ],
              [
                53.4910879,
                28.0006378
              ],
              [
                53.4849747,
                28.0006378
              ],
              [
                53.480808,
                27.9998006
              ],
              [
                53.4791414,
                27.9998007
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555409,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بیضا",
          "name:en": "Beyza County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4814090"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.2151958,
                30.126509
              ],
              [
                52.2146427,
                30.1262383
              ],
              [
                52.2138093,
                30.1253993
              ],
              [
                52.2082528,
                30.1220703
              ],
              [
                52.1668634,
                30.083737
              ],
              [
                52.1654733,
                30.0740119
              ],
              [
                52.1676968,
                30.069014
              ],
              [
                52.1729733,
                30.0634568
              ],
              [
                52.1757499,
                30.0603985
              ],
              [
                52.1765833,
                30.0592889
              ],
              [
                52.2029729,
                30.0290135
              ],
              [
                52.2224194,
                30.008734
              ],
              [
                52.226866,
                29.999289
              ],
              [
                52.2293659,
                29.9945619
              ],
              [
                52.2685319,
                29.9628988
              ],
              [
                52.277422,
                29.9579013
              ],
              [
                52.2779786,
                29.9576217
              ],
              [
                52.2821451,
                29.9556732
              ],
              [
                52.2852018,
                29.9548433
              ],
              [
                52.2857551,
                29.954293
              ],
              [
                52.2863117,
                29.9542931
              ],
              [
                52.2963115,
                29.9503961
              ],
              [
                52.2968682,
                29.9498458
              ],
              [
                52.2996448,
                29.9484567
              ],
              [
                52.3004783,
                29.9476178
              ],
              [
                52.3013114,
                29.9473471
              ],
              [
                52.3204814,
                29.9295676
              ],
              [
                52.3210345,
                29.9287287
              ],
              [
                52.3210345,
                29.928449
              ],
              [
                52.3213146,
                29.9281784
              ],
              [
                52.3213146,
                29.9276191
              ],
              [
                52.3279804,
                29.9234521
              ],
              [
                52.3279812,
                29.9234516
              ],
              [
                52.3293679,
                29.9220625
              ],
              [
                52.3449242,
                29.9123385
              ],
              [
                52.3496475,
                29.906782
              ],
              [
                52.3499241,
                29.9065113
              ],
              [
                52.349924,
                29.9062317
              ],
              [
                52.3504808,
                29.9054019
              ],
              [
                52.3507575,
                29.9051222
              ],
              [
                52.3618707,
                29.8953983
              ],
              [
                52.3796504,
                29.8820664
              ],
              [
                52.3813171,
                29.880957
              ],
              [
                52.3880881,
                29.8780227
              ],
              [
                52.4331864,
                29.8584767
              ],
              [
                52.4396529,
                29.8556737
              ],
              [
                52.4402063,
                29.8551234
              ],
              [
                52.4410396,
                29.8548438
              ],
              [
                52.4413195,
                29.8545642
              ],
              [
                52.4432628,
                29.8531752
              ],
              [
                52.450302,
                29.8495341
              ],
              [
                52.4627008,
                29.8431203
              ],
              [
                52.4746826,
                29.8369219
              ],
              [
                52.4754857,
                29.8365064
              ],
              [
                52.480634,
                29.8346787
              ],
              [
                52.4840989,
                29.8334486
              ],
              [
                52.4849323,
                29.8334486
              ],
              [
                52.4865989,
                29.8326188
              ],
              [
                52.4885422,
                29.8320686
              ],
              [
                52.4996241,
                29.8266538
              ],
              [
                52.499932,
                29.8265034
              ],
              [
                52.5039671,
                29.8251582
              ],
              [
                52.5040986,
                29.8251144
              ],
              [
                52.5043753,
                29.8245641
              ],
              [
                52.5154078,
                29.8212533
              ],
              [
                52.5235662,
                29.818805
              ],
              [
                52.5238216,
                29.8187283
              ],
              [
                52.527435,
                29.8184578
              ],
              [
                52.5275923,
                29.8184238
              ],
              [
                52.5313216,
                29.8176189
              ],
              [
                52.5329882,
                29.8176189
              ],
              [
                52.5338215,
                29.8173393
              ],
              [
                52.5339133,
                29.8173393
              ],
              [
                52.5421547,
                29.8173393
              ],
              [
                52.5435447,
                29.817619
              ],
              [
                52.549658,
                29.817619
              ],
              [
                52.5604912,
                29.8162299
              ],
              [
                52.5606281,
                29.8162299
              ],
              [
                52.5613244,
                29.8162299
              ],
              [
                52.5621578,
                29.8162299
              ],
              [
                52.5632678,
                29.8162299
              ],
              [
                52.5788242,
                29.8237253
              ],
              [
                52.5960473,
                29.8359562
              ],
              [
                52.6004939,
                29.8448408
              ],
              [
                52.6013273,
                29.8520567
              ],
              [
                52.6010472,
                29.8528956
              ],
              [
                52.6002138,
                29.859841
              ],
              [
                52.5996572,
                29.867066
              ],
              [
                52.5988239,
                29.8692849
              ],
              [
                52.5988239,
                29.8695646
              ],
              [
                52.5985472,
                29.8701238
              ],
              [
                52.5735476,
                29.8903922
              ],
              [
                52.5571578,
                29.9123387
              ],
              [
                52.5566011,
                29.9134571
              ],
              [
                52.5482679,
                29.9215124
              ],
              [
                52.545768,
                29.9251206
              ],
              [
                52.543268,
                29.9273487
              ],
              [
                52.543268,
                29.9276193
              ],
              [
                52.5427113,
                29.9278989
              ],
              [
                52.5424347,
                29.9281786
              ],
              [
                52.5424348,
                29.9287288
              ],
              [
                52.5407681,
                29.9306772
              ],
              [
                52.5379881,
                29.9348448
              ],
              [
                52.5360447,
                29.9359542
              ],
              [
                52.5352114,
                29.9367842
              ],
              [
                52.5343781,
                29.9370637
              ],
              [
                52.5304882,
                29.9409516
              ],
              [
                52.5304881,
                29.9420702
              ],
              [
                52.5135451,
                29.9617894
              ],
              [
                52.5129885,
                29.9626193
              ],
              [
                52.5124317,
                29.9628989
              ],
              [
                52.4999319,
                29.9751221
              ],
              [
                52.4849321,
                29.9945621
              ],
              [
                52.4849322,
                29.9948418
              ],
              [
                52.4842354,
                29.9955382
              ],
              [
                52.4838187,
                29.9959603
              ],
              [
                52.4835422,
                29.9981795
              ],
              [
                52.4832655,
                29.9990095
              ],
              [
                52.4832655,
                30.0023472
              ],
              [
                52.4790989,
                30.0190091
              ],
              [
                52.4793755,
                30.0242866
              ],
              [
                52.4790989,
                30.0251255
              ],
              [
                52.4785422,
                30.027895
              ],
              [
                52.4815988,
                30.035121
              ],
              [
                52.4821521,
                30.0356803
              ],
              [
                52.4824322,
                30.0370696
              ],
              [
                52.4832655,
                30.0387385
              ],
              [
                52.4838187,
                30.0442866
              ],
              [
                52.4848731,
                30.0462553
              ],
              [
                52.4879887,
                30.052072
              ],
              [
                52.488542,
                30.0523426
              ],
              [
                52.4890987,
                30.0529019
              ],
              [
                52.489932,
                30.0531726
              ],
              [
                52.489932,
                30.0534613
              ],
              [
                52.4904887,
                30.054571
              ],
              [
                52.4943753,
                30.0595688
              ],
              [
                52.4999318,
                30.0637366
              ],
              [
                52.510765,
                30.0673453
              ],
              [
                52.512155,
                30.0673452
              ],
              [
                52.5127117,
                30.0676249
              ],
              [
                52.5149315,
                30.0676249
              ],
              [
                52.515765,
                30.0673452
              ],
              [
                52.5190982,
                30.0673452
              ],
              [
                52.5199315,
                30.0670656
              ],
              [
                52.5232648,
                30.0670655
              ],
              [
                52.5243783,
                30.0667859
              ],
              [
                52.5296548,
                30.0667859
              ],
              [
                52.5304881,
                30.0670656
              ],
              [
                52.5316014,
                30.0670656
              ],
              [
                52.5324347,
                30.0673452
              ],
              [
                52.5332681,
                30.0673452
              ],
              [
                52.5441012,
                30.0720635
              ],
              [
                52.5454912,
                30.0734618
              ],
              [
                52.5463245,
                30.080679
              ],
              [
                52.5460446,
                30.0812294
              ],
              [
                52.5435445,
                30.0867866
              ],
              [
                52.5435445,
                30.087346
              ],
              [
                52.511045,
                30.1212405
              ],
              [
                52.5068784,
                30.1245694
              ],
              [
                52.5056876,
                30.1251677
              ],
              [
                52.5052084,
                30.1259588
              ],
              [
                52.5049317,
                30.1262385
              ],
              [
                52.5043751,
                30.1262385
              ],
              [
                52.5038218,
                30.1267888
              ],
              [
                52.5032651,
                30.1267889
              ],
              [
                52.5029884,
                30.1270685
              ],
              [
                52.5018751,
                30.1270685
              ],
              [
                52.5015984,
                30.1273482
              ],
              [
                52.5010417,
                30.1273482
              ],
              [
                52.4999319,
                30.1276279
              ],
              [
                52.4935418,
                30.130957
              ],
              [
                52.4857654,
                30.1387338
              ],
              [
                52.4838187,
                30.1404028
              ],
              [
                52.4827087,
                30.1415125
              ],
              [
                52.4590958,
                30.1556771
              ],
              [
                52.4413193,
                30.1637428
              ],
              [
                52.4393726,
                30.1642931
              ],
              [
                52.4363194,
                30.1656825
              ],
              [
                52.4127064,
                30.17041
              ],
              [
                52.4110398,
                30.1704101
              ],
              [
                52.3971499,
                30.1731798
              ],
              [
                52.3846501,
                30.1740098
              ],
              [
                52.3835368,
                30.1742895
              ],
              [
                52.3828744,
                30.1742896
              ],
              [
                52.3828435,
                30.1742895
              ],
              [
                52.3818702,
                30.1742895
              ],
              [
                52.3813169,
                30.1742895
              ],
              [
                52.3788169,
                30.1742895
              ],
              [
                52.3788169,
                30.1740099
              ],
              [
                52.3765936,
                30.1740099
              ],
              [
                52.3752035,
                30.1737392
              ],
              [
                52.3702037,
                30.1715197
              ],
              [
                52.3563139,
                30.1545673
              ],
              [
                52.350204,
                30.1509584
              ],
              [
                52.3379808,
                30.1487391
              ],
              [
                52.3360375,
                30.1487391
              ],
              [
                52.3349242,
                30.1484594
              ],
              [
                52.3332575,
                30.1484593
              ],
              [
                52.3321475,
                30.148739
              ],
              [
                52.3285343,
                30.148739
              ],
              [
                52.325481,
                30.1492894
              ],
              [
                52.3204812,
                30.1495691
              ],
              [
                52.3185344,
                30.1498488
              ],
              [
                52.3174244,
                30.1498487
              ],
              [
                52.3168678,
                30.1501284
              ],
              [
                52.3143678,
                30.1501284
              ],
              [
                52.3074247,
                30.1517885
              ],
              [
                52.3065913,
                30.1523478
              ],
              [
                52.305758,
                30.1523478
              ],
              [
                52.2688118,
                30.1687318
              ],
              [
                52.2646452,
                30.1709602
              ],
              [
                52.2432555,
                30.1848544
              ],
              [
                52.2349189,
                30.1890137
              ],
              [
                52.2201957,
                30.1934616
              ],
              [
                52.2194323,
                30.1935321
              ],
              [
                52.2196426,
                30.1929022
              ],
              [
                52.2307524,
                30.1731797
              ],
              [
                52.2363089,
                30.156516
              ],
              [
                52.2368656,
                30.1548469
              ],
              [
                52.2363089,
                30.1465106
              ],
              [
                52.2338091,
                30.1412327
              ],
              [
                52.229919,
                30.1370646
              ],
              [
                52.228809,
                30.1365143
              ],
              [
                52.2213093,
                30.1304065
              ],
              [
                52.2210292,
                30.1301268
              ],
              [
                52.2163094,
                30.1267887
              ],
              [
                52.215476,
                30.1267887
              ],
              [
                52.2151958,
                30.126509
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555485,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خفر",
          "name:en": "Khafr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q371283"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.7671652,
                29.0439896
              ],
              [
                52.7671652,
                29.0437101
              ],
              [
                52.7780018,
                29.0328762
              ],
              [
                52.782445,
                29.0276035
              ],
              [
                52.7913349,
                29.0195457
              ],
              [
                52.7918915,
                29.0184371
              ],
              [
                52.7977249,
                29.0084327
              ],
              [
                52.7980014,
                29.007324
              ],
              [
                52.7988347,
                29.0056566
              ],
              [
                52.7988348,
                29.0053773
              ],
              [
                52.7991114,
                29.0051068
              ],
              [
                52.7993914,
                29.0042686
              ],
              [
                52.7996681,
                29.0037099
              ],
              [
                52.800778,
                29.0026012
              ],
              [
                52.8016113,
                29.0023219
              ],
              [
                52.8043914,
                28.9995458
              ],
              [
                52.8049446,
                28.9903797
              ],
              [
                52.8063347,
                28.9845395
              ],
              [
                52.8068913,
                28.982043
              ],
              [
                52.8091147,
                28.9767615
              ],
              [
                52.8193911,
                28.9573213
              ],
              [
                52.8207811,
                28.955654
              ],
              [
                52.8282811,
                28.9489938
              ],
              [
                52.8502273,
                28.9353761
              ],
              [
                52.8527274,
                28.9342676
              ],
              [
                52.8535606,
                28.9342675
              ],
              [
                52.8538373,
                28.9339882
              ],
              [
                52.854394,
                28.9339882
              ],
              [
                52.8582805,
                28.9328707
              ],
              [
                52.8596705,
                28.9328707
              ],
              [
                52.8599472,
                28.93315
              ],
              [
                52.8607805,
                28.93315
              ],
              [
                52.8610605,
                28.9334294
              ],
              [
                52.8630039,
                28.9339882
              ],
              [
                52.8635605,
                28.9339882
              ],
              [
                52.8677271,
                28.9350968
              ],
              [
                52.8691171,
                28.9350967
              ],
              [
                52.8696704,
                28.9353761
              ],
              [
                52.877727,
                28.9353761
              ],
              [
                52.8788369,
                28.9350968
              ],
              [
                52.8802269,
                28.9350967
              ],
              [
                52.8807836,
                28.9348174
              ],
              [
                52.8899502,
                28.9326003
              ],
              [
                52.8908185,
                28.9322165
              ],
              [
                52.8913401,
                28.9320416
              ],
              [
                52.8927267,
                28.9314918
              ],
              [
                52.8935599,
                28.9314919
              ],
              [
                52.8938401,
                28.9312124
              ],
              [
                52.8971734,
                28.9303743
              ],
              [
                52.8980067,
                28.9298246
              ],
              [
                52.9093965,
                28.9228761
              ],
              [
                52.9124497,
                28.919821
              ],
              [
                52.9241196,
                28.9034281
              ],
              [
                52.9268962,
                28.8978767
              ],
              [
                52.9274529,
                28.8925957
              ],
              [
                52.9277295,
                28.8920459
              ],
              [
                52.9277296,
                28.8912079
              ],
              [
                52.9282862,
                28.8900994
              ],
              [
                52.9291196,
                28.8853772
              ],
              [
                52.9285629,
                28.8812047
              ],
              [
                52.9266195,
                28.8759328
              ],
              [
                52.9268963,
                28.8756535
              ],
              [
                52.9260629,
                28.8678764
              ],
              [
                52.9260629,
                28.867597
              ],
              [
                52.9257863,
                28.8656505
              ],
              [
                52.9257863,
                28.8645421
              ],
              [
                52.9268963,
                28.8645421
              ],
              [
                52.9277295,
                28.8645421
              ],
              [
                52.9385627,
                28.8659299
              ],
              [
                52.9410627,
                28.8659299
              ],
              [
                52.9430093,
                28.8662093
              ],
              [
                52.960509,
                28.8662093
              ],
              [
                52.9627324,
                28.8664887
              ],
              [
                52.9671757,
                28.8664886
              ],
              [
                52.9724522,
                28.8659299
              ],
              [
                52.9757855,
                28.8653801
              ],
              [
                52.9807888,
                28.8642628
              ],
              [
                52.9821753,
                28.8642628
              ],
              [
                53.0341246,
                28.8556477
              ],
              [
                53.0366247,
                28.8548187
              ],
              [
                53.0394012,
                28.85426
              ],
              [
                53.0405112,
                28.8537102
              ],
              [
                53.0530144,
                28.8498173
              ],
              [
                53.0602342,
                28.846483
              ],
              [
                53.0688475,
                28.840932
              ],
              [
                53.0763473,
                28.8351016
              ],
              [
                53.0919037,
                28.8228733
              ],
              [
                53.0935704,
                28.821765
              ],
              [
                53.1162202,
                28.8037508
              ],
              [
                53.1166267,
                28.8034274
              ],
              [
                53.1316265,
                28.7964889
              ],
              [
                53.1560728,
                28.7881539
              ],
              [
                53.1574627,
                28.7873249
              ],
              [
                53.1635727,
                28.7845405
              ],
              [
                53.1705192,
                28.7803776
              ],
              [
                53.1716293,
                28.7792691
              ],
              [
                53.1724626,
                28.7789898
              ],
              [
                53.1735726,
                28.7778725
              ],
              [
                53.1813525,
                28.7717632
              ],
              [
                53.1955189,
                28.7567605
              ],
              [
                53.1999621,
                28.7514803
              ],
              [
                53.2005188,
                28.7509307
              ],
              [
                53.2024621,
                28.7484259
              ],
              [
                53.2577446,
                28.6998157
              ],
              [
                53.2588546,
                28.6973109
              ],
              [
                53.2655212,
                28.6950944
              ],
              [
                53.2669111,
                28.6950944
              ],
              [
                53.2683012,
                28.6945359
              ],
              [
                53.2691344,
                28.6945359
              ],
              [
                53.2705211,
                28.6939863
              ],
              [
                53.2710777,
                28.6934276
              ],
              [
                53.271911,
                28.6934277
              ],
              [
                53.278301,
                28.6906527
              ],
              [
                53.2788542,
                28.690094
              ],
              [
                53.279691,
                28.6900939
              ],
              [
                53.2810775,
                28.6895444
              ],
              [
                53.2819109,
                28.6889858
              ],
              [
                53.3283036,
                28.6762099
              ],
              [
                53.3285802,
                28.6759306
              ],
              [
                53.3313568,
                28.6848142
              ],
              [
                53.3321901,
                28.6867604
              ],
              [
                53.3380268,
                28.7031494
              ],
              [
                53.3602497,
                28.7384333
              ],
              [
                53.3877493,
                28.76815
              ],
              [
                53.3991391,
                28.7820446
              ],
              [
                53.3999724,
                28.7828735
              ],
              [
                53.400249,
                28.7837026
              ],
              [
                53.4005292,
                28.7842612
              ],
              [
                53.4008058,
                28.7845407
              ],
              [
                53.4008057,
                28.7848199
              ],
              [
                53.4198208,
                28.8056123
              ],
              [
                53.4216388,
                28.8075996
              ],
              [
                53.422472,
                28.8081582
              ],
              [
                53.4246953,
                28.810375
              ],
              [
                53.4916444,
                28.8667591
              ],
              [
                53.5183106,
                28.8937044
              ],
              [
                53.5210872,
                28.8975974
              ],
              [
                53.5217697,
                28.8982826
              ],
              [
                53.5216439,
                28.8984356
              ],
              [
                53.5213672,
                28.898715
              ],
              [
                53.4899778,
                28.9242642
              ],
              [
                53.4863644,
                28.9289866
              ],
              [
                53.4833077,
                28.9334297
              ],
              [
                53.4771978,
                28.9456594
              ],
              [
                53.4771978,
                28.9462092
              ],
              [
                53.4766412,
                28.9467679
              ],
              [
                53.4719213,
                28.959827
              ],
              [
                53.4716413,
                28.9623235
              ],
              [
                53.473588,
                28.979826
              ],
              [
                53.4730313,
                28.9834312
              ],
              [
                53.4674747,
                28.9953821
              ],
              [
                53.463308,
                29.0000328
              ],
              [
                53.4555316,
                29.0109385
              ],
              [
                53.4543718,
                29.0126059
              ],
              [
                53.4540715,
                29.0153213
              ],
              [
                53.4533082,
                29.0151025
              ],
              [
                53.4496984,
                29.0151025
              ],
              [
                53.4494183,
                29.0148231
              ],
              [
                53.4474751,
                29.0148231
              ],
              [
                53.4466417,
                29.0145527
              ],
              [
                53.4396951,
                29.0148231
              ],
              [
                53.4388617,
                29.0151025
              ],
              [
                53.4383085,
                29.0151025
              ],
              [
                53.4369185,
                29.0151025
              ],
              [
                53.4221953,
                29.0156523
              ],
              [
                53.4127522,
                29.0164906
              ],
              [
                53.4088623,
                29.0164905
              ],
              [
                53.4060822,
                29.0167699
              ],
              [
                53.4021957,
                29.01677
              ],
              [
                53.3996958,
                29.0170493
              ],
              [
                53.3955291,
                29.0170493
              ],
              [
                53.3858059,
                29.0178786
              ],
              [
                53.3535796,
                29.0189871
              ],
              [
                53.3438599,
                29.0181579
              ],
              [
                53.3344133,
                29.0181579
              ],
              [
                53.320947,
                29.018749
              ],
              [
                53.3155237,
                29.0189871
              ],
              [
                53.3146904,
                29.0187167
              ],
              [
                53.3094137,
                29.0187167
              ],
              [
                53.3071904,
                29.0184373
              ],
              [
                53.304967,
                29.0184373
              ],
              [
                53.3038572,
                29.0181579
              ],
              [
                53.2835774,
                29.0181579
              ],
              [
                53.2774675,
                29.0173197
              ],
              [
                53.2735775,
                29.0173196
              ],
              [
                53.2727442,
                29.017599
              ],
              [
                53.2716343,
                29.017599
              ],
              [
                53.270801,
                29.0178785
              ],
              [
                53.2701754,
                29.0180882
              ],
              [
                53.268021,
                29.0184373
              ],
              [
                53.2674678,
                29.0187167
              ],
              [
                53.2649677,
                29.0187167
              ],
              [
                53.2638544,
                29.0187167
              ],
              [
                53.2635777,
                29.0184373
              ],
              [
                53.2591311,
                29.0184373
              ],
              [
                53.2588544,
                29.0187167
              ],
              [
                53.2574645,
                29.0187167
              ],
              [
                53.2569112,
                29.0189872
              ],
              [
                53.2557979,
                29.0189871
              ],
              [
                53.2549645,
                29.0192665
              ],
              [
                53.2527446,
                29.0192665
              ],
              [
                53.2516312,
                29.0195459
              ],
              [
                53.248578,
                29.0195459
              ],
              [
                53.2452448,
                29.0201047
              ],
              [
                53.2399648,
                29.0201047
              ],
              [
                53.2391314,
                29.0203841
              ],
              [
                53.2374649,
                29.0203841
              ],
              [
                53.2366315,
                29.0206546
              ],
              [
                53.2344082,
                29.0206545
              ],
              [
                53.2324649,
                29.0212133
              ],
              [
                53.2313549,
                29.0212133
              ],
              [
                53.2116319,
                29.0292711
              ],
              [
                53.2105186,
                29.0295415
              ],
              [
                53.1913521,
                29.0412136
              ],
              [
                53.1910755,
                29.0414931
              ],
              [
                53.1905189,
                29.0417635
              ],
              [
                53.1902422,
                29.0417635
              ],
              [
                53.1824623,
                29.0456572
              ],
              [
                53.181629,
                29.0464864
              ],
              [
                53.1702391,
                29.0526065
              ],
              [
                53.1680192,
                29.054265
              ],
              [
                53.156906,
                29.0603851
              ],
              [
                53.1480161,
                29.0662169
              ],
              [
                53.1430162,
                29.0692724
              ],
              [
                53.1369064,
                29.0748248
              ],
              [
                53.0905137,
                29.1045522
              ],
              [
                53.088847,
                29.1053814
              ],
              [
                53.087457,
                29.1064901
              ],
              [
                53.0777372,
                29.1114929
              ],
              [
                53.0760706,
                29.1126015
              ],
              [
                53.0613474,
                29.1170455
              ],
              [
                53.0596809,
                29.1181542
              ],
              [
                53.0560674,
                29.1195514
              ],
              [
                53.0557909,
                29.1198308
              ],
              [
                53.0549575,
                29.1198308
              ],
              [
                53.0544008,
                29.1201012
              ],
              [
                53.0521775,
                29.1201012
              ],
              [
                53.0519009,
                29.1203807
              ],
              [
                53.0505109,
                29.1203807
              ],
              [
                53.0505109,
                29.1206601
              ],
              [
                53.0477343,
                29.1217688
              ],
              [
                53.0474576,
                29.1220483
              ],
              [
                53.0466243,
                29.1220483
              ],
              [
                53.0466243,
                29.1223277
              ],
              [
                53.0438443,
                29.1223277
              ],
              [
                53.043011,
                29.1220482
              ],
              [
                53.0374578,
                29.1220482
              ],
              [
                53.0363444,
                29.1217688
              ],
              [
                53.0360677,
                29.1217688
              ],
              [
                53.0335678,
                29.1203806
              ],
              [
                53.0319012,
                29.1203807
              ],
              [
                53.0316211,
                29.1201012
              ],
              [
                53.0266213,
                29.1201012
              ],
              [
                53.023288,
                29.1198308
              ],
              [
                53.0227348,
                29.1195514
              ],
              [
                53.0216214,
                29.1195513
              ],
              [
                53.021068,
                29.1198308
              ],
              [
                53.0194014,
                29.1198308
              ],
              [
                53.0188447,
                29.1195514
              ],
              [
                53.0182882,
                29.1198307
              ],
              [
                53.0169014,
                29.1198308
              ],
              [
                53.0130116,
                29.1201012
              ],
              [
                53.0124547,
                29.1203806
              ],
              [
                53.0116215,
                29.1203806
              ],
              [
                53.0110648,
                29.12066
              ],
              [
                53.0105116,
                29.1203806
              ],
              [
                53.0093981,
                29.12066
              ],
              [
                53.0066217,
                29.12066
              ],
              [
                52.9982884,
                29.122607
              ],
              [
                52.996065,
                29.1234364
              ],
              [
                52.9766187,
                29.1264922
              ],
              [
                52.9743988,
                29.1264922
              ],
              [
                52.9732854,
                29.1267716
              ],
              [
                52.9660656,
                29.1267716
              ],
              [
                52.9649522,
                29.1264922
              ],
              [
                52.9630089,
                29.1264922
              ],
              [
                52.9552289,
                29.1248246
              ],
              [
                52.9543956,
                29.1248245
              ],
              [
                52.954119,
                29.1245451
              ],
              [
                52.9532858,
                29.1245451
              ],
              [
                52.9349527,
                29.116766
              ],
              [
                52.9324528,
                29.1150984
              ],
              [
                52.9316194,
                29.114828
              ],
              [
                52.9271728,
                29.1114928
              ],
              [
                52.9002265,
                29.0898235
              ],
              [
                52.8677271,
                29.067046
              ],
              [
                52.8668937,
                29.0662168
              ],
              [
                52.8560606,
                29.0609349
              ],
              [
                52.8555039,
                29.060385
              ],
              [
                52.8538373,
                29.0598261
              ],
              [
                52.8513373,
                29.0581587
              ],
              [
                52.8488373,
                29.0573294
              ],
              [
                52.8460608,
                29.0556619
              ],
              [
                52.845224,
                29.055662
              ],
              [
                52.8366142,
                29.052327
              ],
              [
                52.8357808,
                29.052327
              ],
              [
                52.824391,
                29.0478833
              ],
              [
                52.8235577,
                29.0478834
              ],
              [
                52.8230011,
                29.047604
              ],
              [
                52.8218911,
                29.0476039
              ],
              [
                52.8207811,
                29.0470451
              ],
              [
                52.8199477,
                29.0470451
              ],
              [
                52.806058,
                29.0403752
              ],
              [
                52.8016113,
                29.039546
              ],
              [
                52.7971681,
                29.0395461
              ],
              [
                52.7941115,
                29.0400959
              ],
              [
                52.7927248,
                29.0400959
              ],
              [
                52.7921682,
                29.0403753
              ],
              [
                52.7907782,
                29.0403753
              ],
              [
                52.7871683,
                29.0412134
              ],
              [
                52.7857783,
                29.0412135
              ],
              [
                52.7852216,
                29.0414929
              ],
              [
                52.783835,
                29.0414929
              ],
              [
                52.7741119,
                29.0439895
              ],
              [
                52.7727218,
                29.0439896
              ],
              [
                52.7716118,
                29.044269
              ],
              [
                52.7688318,
                29.044269
              ],
              [
                52.7679985,
                29.0439896
              ],
              [
                52.7671652,
                29.0439896
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555551,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زرقان",
          "name:en": "Zarghan County",
          "place": "county",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.5621578,
                29.8162299
              ],
              [
                52.5624344,
                29.8137315
              ],
              [
                52.5624345,
                29.8134518
              ],
              [
                52.5646578,
                29.8106737
              ],
              [
                52.565491,
                29.8078957
              ],
              [
                52.5671577,
                29.8037287
              ],
              [
                52.5699343,
                29.8009506
              ],
              [
                52.596324,
                29.7567825
              ],
              [
                52.6060346,
                29.7342992
              ],
              [
                52.6081586,
                29.7315687
              ],
              [
                52.616047,
                29.7148345
              ],
              [
                52.6171604,
                29.7106767
              ],
              [
                52.6191036,
                29.7048415
              ],
              [
                52.6263269,
                29.6781729
              ],
              [
                52.6274209,
                29.6765204
              ],
              [
                52.627717,
                29.6762249
              ],
              [
                52.6388268,
                29.6723379
              ],
              [
                52.63994,
                29.6723379
              ],
              [
                52.6416067,
                29.6717787
              ],
              [
                52.6460499,
                29.6712286
              ],
              [
                52.6516066,
                29.6712286
              ],
              [
                52.6518833,
                29.6715082
              ],
              [
                52.6627163,
                29.672888
              ],
              [
                52.6649397,
                29.672888
              ],
              [
                52.669663,
                29.6737267
              ],
              [
                52.6718829,
                29.6737267
              ],
              [
                52.6749396,
                29.674286
              ],
              [
                52.6766061,
                29.6742859
              ],
              [
                52.6777195,
                29.6745565
              ],
              [
                52.7110524,
                29.669001
              ],
              [
                52.7143856,
                29.6681712
              ],
              [
                52.7149423,
                29.6681713
              ],
              [
                52.7188324,
                29.6673416
              ],
              [
                52.7207755,
                29.6673415
              ],
              [
                52.7218855,
                29.667062
              ],
              [
                52.7229989,
                29.6667824
              ],
              [
                52.751055,
                29.6590084
              ],
              [
                52.7527218,
                29.6590084
              ],
              [
                52.7532784,
                29.6587289
              ],
              [
                52.7552218,
                29.6587289
              ],
              [
                52.7560551,
                29.6584493
              ],
              [
                52.7649449,
                29.6584493
              ],
              [
                52.7660549,
                29.6587289
              ],
              [
                52.7682782,
                29.6587288
              ],
              [
                52.7777213,
                29.6609474
              ],
              [
                52.779388,
                29.6609474
              ],
              [
                52.7880012,
                29.6620567
              ],
              [
                52.8127241,
                29.6595586
              ],
              [
                52.8202241,
                29.6573401
              ],
              [
                52.824114,
                29.6562218
              ],
              [
                52.8466137,
                29.6481683
              ],
              [
                52.8816166,
                29.6356687
              ],
              [
                52.8827265,
                29.6356687
              ],
              [
                52.8830065,
                29.6353891
              ],
              [
                52.8838399,
                29.6353892
              ],
              [
                52.8857831,
                29.63483
              ],
              [
                52.9041161,
                29.6320614
              ],
              [
                52.9074494,
                29.6312227
              ],
              [
                52.9383051,
                29.6196204
              ],
              [
                52.9496755,
                29.617055
              ],
              [
                53.0171779,
                29.5826149
              ],
              [
                53.0202345,
                29.5814967
              ],
              [
                53.0207878,
                29.5814967
              ],
              [
                53.0463441,
                29.5687275
              ],
              [
                53.0469008,
                29.5684479
              ],
              [
                53.0471774,
                29.5678888
              ],
              [
                53.0480107,
                29.5676092
              ],
              [
                53.0507907,
                29.5709458
              ],
              [
                53.0505108,
                29.5712253
              ],
              [
                53.0507908,
                29.572055
              ],
              [
                53.0505108,
                29.5728936
              ],
              [
                53.0519007,
                29.5884496
              ],
              [
                53.0532907,
                29.6023374
              ],
              [
                53.0535673,
                29.6037262
              ],
              [
                53.0530141,
                29.6114998
              ],
              [
                53.0532906,
                29.6245582
              ],
              [
                53.0530141,
                29.6251174
              ],
              [
                53.052734,
                29.6298339
              ],
              [
                53.0521773,
                29.6340004
              ],
              [
                53.0521773,
                29.6356688
              ],
              [
                53.0519007,
                29.6362279
              ],
              [
                53.051624,
                29.6381669
              ],
              [
                53.051344,
                29.6403944
              ],
              [
                53.051344,
                29.6423334
              ],
              [
                53.0510674,
                29.6431721
              ],
              [
                53.051344,
                29.6462293
              ],
              [
                53.052734,
                29.650946
              ],
              [
                53.0899567,
                29.6978881
              ],
              [
                53.09496,
                29.7015047
              ],
              [
                53.0969033,
                29.7034437
              ],
              [
                53.09718,
                29.7040029
              ],
              [
                53.0977366,
                29.7051122
              ],
              [
                53.0969033,
                29.7053919
              ],
              [
                53.0960699,
                29.7062216
              ],
              [
                53.0852369,
                29.7120568
              ],
              [
                53.0844036,
                29.7128956
              ],
              [
                53.0630138,
                29.7234478
              ],
              [
                53.0624571,
                29.724007
              ],
              [
                53.0596805,
                29.7251163
              ],
              [
                53.0591239,
                29.7256665
              ],
              [
                53.0349575,
                29.7345593
              ],
              [
                52.9563736,
                29.7733912
              ],
              [
                52.9466188,
                29.7778969
              ],
              [
                52.9424522,
                29.779836
              ],
              [
                52.9238392,
                29.7881791
              ],
              [
                52.9232858,
                29.7887292
              ],
              [
                52.8891163,
                29.8017805
              ],
              [
                52.8502269,
                29.8117833
              ],
              [
                52.848837,
                29.8117833
              ],
              [
                52.8482803,
                29.812063
              ],
              [
                52.847447,
                29.8120629
              ],
              [
                52.8468937,
                29.8123335
              ],
              [
                52.8455037,
                29.8123335
              ],
              [
                52.8452235,
                29.8126221
              ],
              [
                52.8443903,
                29.8126222
              ],
              [
                52.843837,
                29.8128927
              ],
              [
                52.8152242,
                29.8187285
              ],
              [
                52.8146673,
                29.8187285
              ],
              [
                52.8143908,
                29.8190081
              ],
              [
                52.8124475,
                29.8190081
              ],
              [
                52.8121674,
                29.8192877
              ],
              [
                52.8105008,
                29.8192878
              ],
              [
                52.8093908,
                29.8195674
              ],
              [
                52.8082809,
                29.8198379
              ],
              [
                52.8071674,
                29.8203972
              ],
              [
                52.8063342,
                29.8206677
              ],
              [
                52.7682782,
                29.8320687
              ],
              [
                52.7668881,
                29.8323394
              ],
              [
                52.7649448,
                29.832619
              ],
              [
                52.7641115,
                29.8326189
              ],
              [
                52.7635548,
                29.8328985
              ],
              [
                52.7629981,
                29.8328986
              ],
              [
                52.7621649,
                29.8328985
              ],
              [
                52.7552216,
                29.8334487
              ],
              [
                52.7502217,
                29.8345672
              ],
              [
                52.7491083,
                29.8348378
              ],
              [
                52.7488317,
                29.8351174
              ],
              [
                52.748275,
                29.8351174
              ],
              [
                52.7463317,
                29.8351174
              ],
              [
                52.7460551,
                29.835397
              ],
              [
                52.7449418,
                29.8351174
              ],
              [
                52.7438317,
                29.8351174
              ],
              [
                52.7435551,
                29.8353971
              ],
              [
                52.7410552,
                29.835397
              ],
              [
                52.7402219,
                29.8356766
              ],
              [
                52.7363319,
                29.8356766
              ],
              [
                52.7360553,
                29.8359563
              ],
              [
                52.7243854,
                29.8362269
              ],
              [
                52.6999424,
                29.8376159
              ],
              [
                52.6949426,
                29.8373453
              ],
              [
                52.6896626,
                29.8373453
              ],
              [
                52.6849393,
                29.8373453
              ],
              [
                52.6838294,
                29.8370657
              ],
              [
                52.6749394,
                29.8370656
              ],
              [
                52.6741061,
                29.8373453
              ],
              [
                52.6713295,
                29.8373453
              ],
              [
                52.6641064,
                29.8392846
              ],
              [
                52.6224369,
                29.8559534
              ],
              [
                52.6082704,
                29.8642879
              ],
              [
                52.6013273,
                29.8684551
              ],
              [
                52.6010471,
                29.8687348
              ],
              [
                52.5993805,
                29.8695646
              ],
              [
                52.5985472,
                29.8701238
              ],
              [
                52.5988239,
                29.8695646
              ],
              [
                52.5988239,
                29.8692849
              ],
              [
                52.5996572,
                29.867066
              ],
              [
                52.6002138,
                29.859841
              ],
              [
                52.6010472,
                29.8528956
              ],
              [
                52.6013273,
                29.8520567
              ],
              [
                52.6004939,
                29.8448408
              ],
              [
                52.5960473,
                29.8359562
              ],
              [
                52.5788242,
                29.8237253
              ],
              [
                52.5632678,
                29.8162299
              ],
              [
                52.5621578,
                29.8162299
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11164344,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوه‌چنار",
          "name:en": "Kooh Chenar County",
          "place": "county",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.4393631,
                29.7900809
              ],
              [
                51.4472578,
                29.7837476
              ],
              [
                51.4568709,
                29.7803208
              ],
              [
                51.463394,
                29.7639305
              ],
              [
                51.4736937,
                29.7548401
              ],
              [
                51.4760969,
                29.7429171
              ],
              [
                51.5026994,
                29.7371355
              ],
              [
                51.5195376,
                29.7551178
              ],
              [
                51.5284211,
                29.7598182
              ],
              [
                51.5291514,
                29.7672251
              ],
              [
                51.5333815,
                29.7705531
              ],
              [
                51.5374064,
                29.779964
              ],
              [
                51.538352,
                29.785371
              ],
              [
                51.5387982,
                29.7879222
              ],
              [
                51.536451,
                29.7958048
              ],
              [
                51.5657133,
                29.805936
              ],
              [
                51.5805581,
                29.8096068
              ],
              [
                51.5993825,
                29.8178713
              ],
              [
                51.6220733,
                29.8062047
              ],
              [
                51.6355488,
                29.7981986
              ],
              [
                51.6364822,
                29.7976441
              ],
              [
                51.636838,
                29.7973421
              ],
              [
                51.6371181,
                29.7965032
              ],
              [
                51.6373948,
                29.7962327
              ],
              [
                51.6376714,
                29.7953938
              ],
              [
                51.6379515,
                29.7945641
              ],
              [
                51.6382281,
                29.7940048
              ],
              [
                51.6385046,
                29.7931752
              ],
              [
                51.6387848,
                29.7928955
              ],
              [
                51.6390615,
                29.7920657
              ],
              [
                51.6393381,
                29.7912269
              ],
              [
                51.6396181,
                29.7909472
              ],
              [
                51.6398948,
                29.7901174
              ],
              [
                51.6404514,
                29.7892876
              ],
              [
                51.6404514,
                29.7887284
              ],
              [
                51.6410047,
                29.7881783
              ],
              [
                51.6412848,
                29.7873394
              ],
              [
                51.6415613,
                29.7867802
              ],
              [
                51.642118,
                29.7859505
              ],
              [
                51.6423947,
                29.784841
              ],
              [
                51.6426714,
                29.7845615
              ],
              [
                51.643228,
                29.7834521
              ],
              [
                51.6437847,
                29.7823336
              ],
              [
                51.6440613,
                29.7817834
              ],
              [
                51.644618,
                29.780674
              ],
              [
                51.6448946,
                29.7795647
              ],
              [
                51.6451714,
                29.7790054
              ],
              [
                51.6457281,
                29.7781757
              ],
              [
                51.6462847,
                29.7770663
              ],
              [
                51.6465613,
                29.776507
              ],
              [
                51.6471179,
                29.7756682
              ],
              [
                51.6476712,
                29.7748385
              ],
              [
                51.6479513,
                29.7742793
              ],
              [
                51.6485047,
                29.7734495
              ],
              [
                51.6490613,
                29.7723401
              ],
              [
                51.6490613,
                29.7717809
              ],
              [
                51.649618,
                29.7709511
              ],
              [
                51.6498946,
                29.7703919
              ],
              [
                51.6504514,
                29.7692825
              ],
              [
                51.6507279,
                29.7678936
              ],
              [
                51.6510046,
                29.7673434
              ],
              [
                51.6515612,
                29.7659453
              ],
              [
                51.652118,
                29.764836
              ],
              [
                51.652118,
                29.7640062
              ],
              [
                51.6526711,
                29.7628878
              ],
              [
                51.6529513,
                29.7617785
              ],
              [
                51.6529513,
                29.7612282
              ],
              [
                51.6532278,
                29.7601189
              ],
              [
                51.6532277,
                29.7592801
              ],
              [
                51.6535046,
                29.7587299
              ],
              [
                51.6535046,
                29.7581707
              ],
              [
                51.6537846,
                29.7573409
              ],
              [
                51.6537847,
                29.7570614
              ],
              [
                51.6540612,
                29.7565022
              ],
              [
                51.6543377,
                29.7556724
              ],
              [
                51.6546179,
                29.7553928
              ],
              [
                51.6548944,
                29.7542834
              ],
              [
                51.6554513,
                29.7528945
              ],
              [
                51.6560044,
                29.7523352
              ],
              [
                51.6565613,
                29.7509463
              ],
              [
                51.6571179,
                29.7495573
              ],
              [
                51.6573945,
                29.7487275
              ],
              [
                51.6576746,
                29.7476182
              ],
              [
                51.6579511,
                29.7465088
              ],
              [
                51.6582279,
                29.7462293
              ],
              [
                51.6582279,
                29.7459496
              ],
              [
                51.6585077,
                29.7456701
              ],
              [
                51.6585078,
                29.7451153
              ],
              [
                51.6585078,
                29.7451108
              ],
              [
                51.6587846,
                29.7448402
              ],
              [
                51.6590611,
                29.7445607
              ],
              [
                51.6590611,
                29.744281
              ],
              [
                51.6593412,
                29.7437219
              ],
              [
                51.6596178,
                29.7431718
              ],
              [
                51.6598945,
                29.7431717
              ],
              [
                51.6598945,
                29.7426126
              ],
              [
                51.6601745,
                29.7420624
              ],
              [
                51.6604512,
                29.7417828
              ],
              [
                51.6607278,
                29.7415032
              ],
              [
                51.6610078,
                29.7409439
              ],
              [
                51.6610078,
                29.7406734
              ],
              [
                51.6612844,
                29.7401142
              ],
              [
                51.6618411,
                29.7398346
              ],
              [
                51.6618411,
                29.7395641
              ],
              [
                51.6621179,
                29.7390049
              ],
              [
                51.6626745,
                29.7387253
              ],
              [
                51.6626745,
                29.7384457
              ],
              [
                51.6632279,
                29.7381752
              ],
              [
                51.663508,
                29.737616
              ],
              [
                51.6637844,
                29.7373363
              ],
              [
                51.6640611,
                29.7367771
              ],
              [
                51.6643411,
                29.7365066
              ],
              [
                51.6646176,
                29.736227
              ],
              [
                51.6651746,
                29.7356678
              ],
              [
                51.6654511,
                29.7351176
              ],
              [
                51.6657277,
                29.734838
              ],
              [
                51.6662843,
                29.7345585
              ],
              [
                51.6665611,
                29.7340083
              ],
              [
                51.6668412,
                29.7337287
              ],
              [
                51.6671178,
                29.7334491
              ],
              [
                51.6676743,
                29.7331695
              ],
              [
                51.6679509,
                29.7328899
              ],
              [
                51.6682277,
                29.7323398
              ],
              [
                51.6687844,
                29.7320602
              ],
              [
                51.6690609,
                29.7317805
              ],
              [
                51.6696178,
                29.7312303
              ],
              [
                51.6698944,
                29.7309508
              ],
              [
                51.670451,
                29.7303916
              ],
              [
                51.6710076,
                29.7298324
              ],
              [
                51.6712843,
                29.7295619
              ],
              [
                51.6721177,
                29.7287231
              ],
              [
                51.6726743,
                29.728173
              ],
              [
                51.6732276,
                29.7278933
              ],
              [
                51.6737843,
                29.7270636
              ],
              [
                51.6746176,
                29.7265044
              ],
              [
                51.6748976,
                29.7262248
              ],
              [
                51.675731,
                29.7253951
              ],
              [
                51.6762843,
                29.7248359
              ],
              [
                51.6765642,
                29.7242857
              ],
              [
                51.6773976,
                29.7237265
              ],
              [
                51.677951,
                29.7228878
              ],
              [
                51.6785076,
                29.7226172
              ],
              [
                51.6790642,
                29.7220581
              ],
              [
                51.6818409,
                29.7195598
              ],
              [
                51.6821174,
                29.7190006
              ],
              [
                51.6829509,
                29.7184504
              ],
              [
                51.683784,
                29.7176116
              ],
              [
                51.6840641,
                29.7173411
              ],
              [
                51.6848976,
                29.7165023
              ],
              [
                51.6857308,
                29.7159431
              ],
              [
                51.6860076,
                29.715393
              ],
              [
                51.6868408,
                29.7148338
              ],
              [
                51.6873975,
                29.7140041
              ],
              [
                51.6879508,
                29.7137245
              ],
              [
                51.6885074,
                29.7128947
              ],
              [
                51.6893408,
                29.7123356
              ],
              [
                51.6898975,
                29.7117854
              ],
              [
                51.6904508,
                29.7112262
              ],
              [
                51.6910075,
                29.7106762
              ],
              [
                51.6915641,
                29.7101169
              ],
              [
                51.6923973,
                29.7092782
              ],
              [
                51.6929507,
                29.7090076
              ],
              [
                51.6935073,
                29.7084485
              ],
              [
                51.6943407,
                29.7076187
              ],
              [
                51.6946208,
                29.7073391
              ],
              [
                51.6954541,
                29.7067799
              ],
              [
                51.6960074,
                29.7059502
              ],
              [
                51.6962874,
                29.7056706
              ],
              [
                51.6971207,
                29.7051114
              ],
              [
                51.697674,
                29.7045612
              ],
              [
                51.6982306,
                29.7042816
              ],
              [
                51.6987873,
                29.7037316
              ],
              [
                51.6993406,
                29.7031724
              ],
              [
                51.6996207,
                29.7028928
              ],
              [
                51.7001738,
                29.7023337
              ],
              [
                51.7010072,
                29.7020631
              ],
              [
                51.7012874,
                29.7017834
              ],
              [
                51.7018404,
                29.7012243
              ],
              [
                51.7023973,
                29.7006652
              ],
              [
                51.7026739,
                29.7003946
              ],
              [
                51.7035073,
                29.7001149
              ],
              [
                51.7037872,
                29.6998354
              ],
              [
                51.7046206,
                29.6992852
              ],
              [
                51.7054538,
                29.6987261
              ],
              [
                51.7062872,
                29.6981759
              ],
              [
                51.7068406,
                29.6978873
              ],
              [
                51.7073972,
                29.6973371
              ],
              [
                51.7079539,
                29.6970576
              ],
              [
                51.7087871,
                29.6965074
              ],
              [
                51.7096205,
                29.6959483
              ],
              [
                51.709897,
                29.6956687
              ],
              [
                51.7107304,
                29.6951095
              ],
              [
                51.7115637,
                29.694839
              ],
              [
                51.7118405,
                29.6945594
              ],
              [
                51.7123971,
                29.6940002
              ],
              [
                51.7132303,
                29.6934501
              ],
              [
                51.7135104,
                29.6934501
              ],
              [
                51.7143439,
                29.6928909
              ],
              [
                51.715177,
                29.6923317
              ],
              [
                51.7154538,
                29.6920612
              ],
              [
                51.716287,
                29.6912225
              ],
              [
                51.7171205,
                29.6906723
              ],
              [
                51.7176771,
                29.6903927
              ],
              [
                51.7182304,
                29.689554
              ],
              [
                51.7190636,
                29.6890038
              ],
              [
                51.7196203,
                29.6887243
              ],
              [
                51.720177,
                29.688174
              ],
              [
                51.7210103,
                29.6876149
              ],
              [
                51.7212869,
                29.6873354
              ],
              [
                51.7218436,
                29.6867761
              ],
              [
                51.7221204,
                29.6865056
              ],
              [
                51.722677,
                29.6859464
              ],
              [
                51.7229535,
                29.6856669
              ],
              [
                51.7232303,
                29.6853963
              ],
              [
                51.7237869,
                29.6851167
              ],
              [
                51.7243436,
                29.6845576
              ],
              [
                51.7246202,
                29.684287
              ],
              [
                51.7251769,
                29.6837279
              ],
              [
                51.7260103,
                29.6831687
              ],
              [
                51.7262869,
                29.6828891
              ],
              [
                51.7271202,
                29.6820593
              ],
              [
                51.7279535,
                29.6815092
              ],
              [
                51.7282303,
                29.6809501
              ],
              [
                51.7290635,
                29.6803909
              ],
              [
                51.72962,
                29.6795612
              ],
              [
                51.7298969,
                29.6792816
              ],
              [
                51.7304535,
                29.6787315
              ],
              [
                51.7310101,
                29.6781723
              ],
              [
                51.7310102,
                29.6778928
              ],
              [
                51.7315635,
                29.6776132
              ],
              [
                51.7318436,
                29.6773336
              ],
              [
                51.7321201,
                29.677063
              ],
              [
                51.7326768,
                29.6767744
              ],
              [
                51.7329535,
                29.6765038
              ],
              [
                51.7332335,
                29.6762243
              ],
              [
                51.7337868,
                29.6756651
              ],
              [
                51.7340668,
                29.6753946
              ],
              [
                51.7349001,
                29.675115
              ],
              [
                51.7354534,
                29.6745559
              ],
              [
                51.7354584,
                29.6745558
              ],
              [
                51.73712,
                29.6731669
              ],
              [
                51.7376767,
                29.6726169
              ],
              [
                51.7412867,
                29.6690003
              ],
              [
                51.7424,
                29.6678911
              ],
              [
                51.7476767,
                29.6609468
              ],
              [
                51.7515666,
                29.6545527
              ],
              [
                51.7559822,
                29.6490365
              ],
              [
                51.8035209,
                29.6753297
              ],
              [
                51.817959,
                29.6640041
              ],
              [
                51.832402,
                29.6476084
              ],
              [
                51.8335154,
                29.645949
              ],
              [
                51.8404586,
                29.6390048
              ],
              [
                51.8465719,
                29.6348294
              ],
              [
                51.8626815,
                29.626785
              ],
              [
                51.9132408,
                29.6098308
              ],
              [
                51.9265741,
                29.6067737
              ],
              [
                51.9274073,
                29.6067737
              ],
              [
                51.927964,
                29.6065031
              ],
              [
                51.9310172,
                29.6056645
              ],
              [
                51.9312973,
                29.6070623
              ],
              [
                51.931574,
                29.6073328
              ],
              [
                51.931574,
                29.6076123
              ],
              [
                51.9318506,
                29.6095602
              ],
              [
                51.9343506,
                29.6151155
              ],
              [
                51.9343506,
                29.6153951
              ],
              [
                51.9349073,
                29.6170544
              ],
              [
                51.9357404,
                29.6209502
              ],
              [
                51.9376838,
                29.6253873
              ],
              [
                51.9396305,
                29.6301129
              ],
              [
                51.9393539,
                29.6303925
              ],
              [
                51.9396306,
                29.6309516
              ],
              [
                51.9393538,
                29.6351181
              ],
              [
                51.9390738,
                29.6362273
              ],
              [
                51.9357404,
                29.6431715
              ],
              [
                51.9299074,
                29.6503952
              ],
              [
                51.9276839,
                29.6520637
              ],
              [
                51.884628,
                29.6940003
              ],
              [
                51.8829613,
                29.6959484
              ],
              [
                51.8742874,
                29.7088962
              ],
              [
                51.8718164,
                29.7125845
              ],
              [
                51.8713822,
                29.7132325
              ],
              [
                51.8637949,
                29.7245564
              ],
              [
                51.8629582,
                29.726225
              ],
              [
                51.8612915,
                29.7281732
              ],
              [
                51.8529582,
                29.7431719
              ],
              [
                51.8518484,
                29.7456703
              ],
              [
                51.8487917,
                29.752615
              ],
              [
                51.8460151,
                29.7651158
              ],
              [
                51.8457386,
                29.7670549
              ],
              [
                51.8454584,
                29.7701125
              ],
              [
                51.8460151,
                29.7867804
              ],
              [
                51.8465717,
                29.7923364
              ],
              [
                51.8462916,
                29.7934458
              ],
              [
                51.846015,
                29.796783
              ],
              [
                51.8457384,
                29.7990019
              ],
              [
                51.8454584,
                29.8006795
              ],
              [
                51.8446249,
                29.803178
              ],
              [
                51.8440684,
                29.804558
              ],
              [
                51.8418484,
                29.8067858
              ],
              [
                51.8340685,
                29.8198373
              ],
              [
                51.832682,
                29.8217855
              ],
              [
                51.8324019,
                29.8226154
              ],
              [
                51.8146254,
                29.8376153
              ],
              [
                51.8065689,
                29.8417825
              ],
              [
                51.8051789,
                29.8423417
              ],
              [
                51.8046223,
                29.8420621
              ],
              [
                51.8035123,
                29.8420621
              ],
              [
                51.8032357,
                29.8417826
              ],
              [
                51.8018456,
                29.8417825
              ],
              [
                51.8015691,
                29.8420622
              ],
              [
                51.8010122,
                29.8420621
              ],
              [
                51.7982356,
                29.8431716
              ],
              [
                51.7968458,
                29.8431716
              ],
              [
                51.796569,
                29.8434512
              ],
              [
                51.7960123,
                29.8434511
              ],
              [
                51.7957358,
                29.8437308
              ],
              [
                51.7949024,
                29.8437308
              ],
              [
                51.7940691,
                29.8440104
              ],
              [
                51.7887891,
                29.8445606
              ],
              [
                51.7648994,
                29.8531747
              ],
              [
                51.7637895,
                29.8531747
              ],
              [
                51.7635094,
                29.8534543
              ],
              [
                51.7404531,
                29.8631779
              ],
              [
                51.7387865,
                29.8640077
              ],
              [
                51.7346199,
                29.8665062
              ],
              [
                51.7212867,
                29.8790082
              ],
              [
                51.72073,
                29.8801176
              ],
              [
                51.7201768,
                29.8803972
              ],
              [
                51.7193435,
                29.8812271
              ],
              [
                51.7187869,
                29.8823456
              ],
              [
                51.7129512,
                29.88818
              ],
              [
                51.7018403,
                29.8992855
              ],
              [
                51.7015637,
                29.8995652
              ],
              [
                51.699897,
                29.9009543
              ],
              [
                51.6996205,
                29.9012339
              ],
              [
                51.6898973,
                29.9054014
              ],
              [
                51.6857306,
                29.9067815
              ],
              [
                51.6846173,
                29.9067814
              ],
              [
                51.6843406,
                29.9070701
              ],
              [
                51.6682275,
                29.9098394
              ],
              [
                51.6662841,
                29.9098394
              ],
              [
                51.6660075,
                29.9095597
              ],
              [
                51.6632276,
                29.9087299
              ],
              [
                51.6623942,
                29.9081706
              ],
              [
                51.6551711,
                29.9045624
              ],
              [
                51.6523944,
                29.9045624
              ],
              [
                51.6518378,
                29.9048421
              ],
              [
                51.6487844,
                29.9048421
              ],
              [
                51.6485045,
                29.9051217
              ],
              [
                51.6479511,
                29.9051217
              ],
              [
                51.639618,
                29.9087298
              ],
              [
                51.6387846,
                29.9095596
              ],
              [
                51.6379514,
                29.9098393
              ],
              [
                51.6376713,
                29.9103986
              ],
              [
                51.632948,
                29.9134565
              ],
              [
                51.6296147,
                29.9142864
              ],
              [
                51.6279481,
                29.9142863
              ],
              [
                51.6273948,
                29.914566
              ],
              [
                51.6248949,
                29.914566
              ],
              [
                51.6243383,
                29.9142863
              ],
              [
                51.6235048,
                29.9142864
              ],
              [
                51.6179482,
                29.9128972
              ],
              [
                51.6165582,
                29.9128972
              ],
              [
                51.6160049,
                29.9126175
              ],
              [
                51.6148916,
                29.9126176
              ],
              [
                51.614615,
                29.912338
              ],
              [
                51.6140583,
                29.912338
              ],
              [
                51.6132249,
                29.9120673
              ],
              [
                51.612115,
                29.9120674
              ],
              [
                51.6107249,
                29.9115081
              ],
              [
                51.6096151,
                29.9115081
              ],
              [
                51.6087817,
                29.9112284
              ],
              [
                51.6073917,
                29.9112285
              ],
              [
                51.6073916,
                29.9109488
              ],
              [
                51.6029484,
                29.9103986
              ],
              [
                51.5987819,
                29.9103985
              ],
              [
                51.5976684,
                29.910119
              ],
              [
                51.5807255,
                29.9101189
              ],
              [
                51.5798922,
                29.9103985
              ],
              [
                51.5765588,
                29.9103986
              ],
              [
                51.5760021,
                29.9106782
              ],
              [
                51.5687791,
                29.9112284
              ],
              [
                51.5679456,
                29.9109488
              ],
              [
                51.5601691,
                29.9095596
              ],
              [
                51.5590558,
                29.9087297
              ],
              [
                51.5548891,
                29.9067814
              ],
              [
                51.5507224,
                29.9037324
              ],
              [
                51.5485027,
                29.9023433
              ],
              [
                51.5298895,
                29.8873426
              ],
              [
                51.5296129,
                29.8865127
              ],
              [
                51.5234997,
                29.8790079
              ],
              [
                51.5212762,
                29.876789
              ],
              [
                51.5209997,
                29.8765094
              ],
              [
                51.5134998,
                29.8642871
              ],
              [
                51.51239,
                29.8631776
              ],
              [
                51.5121099,
                29.8623387
              ],
              [
                51.4964116,
                29.8410491
              ],
              [
                51.4879437,
                29.8295603
              ],
              [
                51.4748873,
                29.8173386
              ],
              [
                51.4746104,
                29.8170589
              ],
              [
                51.4740538,
                29.8170589
              ],
              [
                51.4737772,
                29.8167793
              ],
              [
                51.4732205,
                29.8159494
              ],
              [
                51.4721106,
                29.8142809
              ],
              [
                51.4393631,
                29.7900809
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11166543,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سرچهان",
          "name:en": "Sar Chahan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4814692"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.3127553,
                30.2152947
              ],
              [
                53.3153221,
                30.2071685
              ],
              [
                53.3205232,
                30.1887345
              ],
              [
                53.3216366,
                30.1842955
              ],
              [
                53.331913,
                30.154297
              ],
              [
                53.3335796,
                30.1506792
              ],
              [
                53.3341364,
                30.1487395
              ],
              [
                53.3366363,
                30.1459607
              ],
              [
                53.3374697,
                30.1434616
              ],
              [
                53.3380264,
                30.1437413
              ],
              [
                53.3388595,
                30.144012
              ],
              [
                53.339693,
                30.1454013
              ],
              [
                53.3508028,
                30.1340157
              ],
              [
                53.3513594,
                30.1340157
              ],
              [
                53.3519127,
                30.1331856
              ],
              [
                53.3849723,
                30.1095666
              ],
              [
                53.3915558,
                30.103142
              ],
              [
                53.3966388,
                30.0981813
              ],
              [
                53.4055286,
                30.085957
              ],
              [
                53.4077486,
                30.0828987
              ],
              [
                53.4255283,
                30.0584505
              ],
              [
                53.4419182,
                30.0440163
              ],
              [
                53.4435848,
                30.0431773
              ],
              [
                53.4499747,
                30.0392892
              ],
              [
                53.4599745,
                30.0359603
              ],
              [
                53.467751,
                30.0359604
              ],
              [
                53.469141,
                30.03624
              ],
              [
                53.4713644,
                30.03624
              ],
              [
                53.471921,
                30.0365107
              ],
              [
                53.473031,
                30.0365106
              ],
              [
                53.4735877,
                30.0367903
              ],
              [
                53.4746976,
                30.0367903
              ],
              [
                53.4752543,
                30.03707
              ],
              [
                53.4777543,
                30.0378999
              ],
              [
                53.4780309,
                30.0381795
              ],
              [
                53.4863641,
                30.0420678
              ],
              [
                53.5010872,
                30.0465153
              ],
              [
                53.5021972,
                30.0465152
              ],
              [
                53.5041439,
                30.0470655
              ],
              [
                53.5052539,
                30.0470655
              ],
              [
                53.530666,
                30.0418105
              ],
              [
                53.5372001,
                30.0403988
              ],
              [
                53.5385901,
                30.0398485
              ],
              [
                53.5477064,
                30.0377431
              ],
              [
                53.5801652,
                30.0257736
              ],
              [
                53.5876765,
                30.0219293
              ],
              [
                53.5997109,
                30.016326
              ],
              [
                53.6113972,
                30.0086885
              ],
              [
                53.6212448,
                30.003137
              ],
              [
                53.6310479,
                29.9987234
              ],
              [
                53.6392453,
                29.9923556
              ],
              [
                53.6540274,
                29.9873914
              ],
              [
                53.6684981,
                29.9820474
              ],
              [
                53.6869518,
                29.9746327
              ],
              [
                53.7048344,
                29.9650674
              ],
              [
                53.7157451,
                29.9567
              ],
              [
                53.7242666,
                29.9472681
              ],
              [
                53.7264042,
                29.9395365
              ],
              [
                53.7274341,
                29.9249011
              ],
              [
                53.7316815,
                29.9160933
              ],
              [
                53.7347316,
                29.9099334
              ],
              [
                53.7356757,
                29.9062134
              ],
              [
                53.737049,
                29.9013772
              ],
              [
                53.7379073,
                29.8956478
              ],
              [
                53.7367671,
                29.8924104
              ],
              [
                53.7445163,
                29.8886531
              ],
              [
                53.7509536,
                29.8858253
              ],
              [
                53.7564468,
                29.8844113
              ],
              [
                53.7656306,
                29.8830718
              ],
              [
                53.7751217,
                29.8844661
              ],
              [
                53.7965513,
                29.8878034
              ],
              [
                53.8010635,
                29.8880872
              ],
              [
                53.8200047,
                29.8899246
              ],
              [
                53.8394515,
                29.8917532
              ],
              [
                53.8473415,
                29.8922249
              ],
              [
                53.853098,
                29.8925508
              ],
              [
                53.8613538,
                29.8889064
              ],
              [
                53.8743083,
                29.8819834
              ],
              [
                53.8911151,
                29.8719083
              ],
              [
                53.9023421,
                29.8647398
              ],
              [
                53.9123523,
                29.8565241
              ],
              [
                53.9166497,
                29.8529992
              ],
              [
                53.9221619,
                29.8523002
              ],
              [
                53.9511196,
                29.8301415
              ],
              [
                53.9662114,
                29.8182174
              ],
              [
                53.9764599,
                29.8113558
              ],
              [
                53.9918888,
                29.8052122
              ],
              [
                53.9991759,
                29.804082
              ],
              [
                54.0085733,
                29.80268
              ],
              [
                54.016849,
                29.8006129
              ],
              [
                54.0388324,
                29.8016556
              ],
              [
                54.0702157,
                29.7969816
              ],
              [
                54.0901493,
                29.791482
              ],
              [
                54.0973444,
                29.7886407
              ],
              [
                54.0987015,
                29.8006565
              ],
              [
                54.1001558,
                29.8113433
              ],
              [
                54.1013663,
                29.8222895
              ],
              [
                54.101486,
                29.8287312
              ],
              [
                54.1024833,
                29.8348695
              ],
              [
                54.1037169,
                29.8496405
              ],
              [
                54.1040365,
                29.8581378
              ],
              [
                54.1043594,
                29.8608835
              ],
              [
                54.1045849,
                29.8629692
              ],
              [
                54.1054996,
                29.8695594
              ],
              [
                54.1060958,
                29.8730033
              ],
              [
                54.1059241,
                29.8771914
              ],
              [
                54.1071509,
                29.882402
              ],
              [
                54.1101383,
                29.8915995
              ],
              [
                54.1124332,
                29.8982025
              ],
              [
                54.1139672,
                29.9071302
              ],
              [
                54.113414,
                29.9172419
              ],
              [
                54.1156097,
                29.9343663
              ],
              [
                54.1161247,
                29.951374
              ],
              [
                54.117498,
                29.968807
              ],
              [
                54.1092165,
                29.976676
              ],
              [
                54.0958028,
                29.9823305
              ],
              [
                54.077711,
                29.988319
              ],
              [
                54.0574955,
                29.9940403
              ],
              [
                54.0463829,
                29.9966819
              ],
              [
                54.0432188,
                29.9967304
              ],
              [
                54.0362389,
                29.9971728
              ],
              [
                54.0238242,
                30.002674
              ],
              [
                53.9999096,
                30.0154584
              ],
              [
                53.9919484,
                30.0222
              ],
              [
                53.9802302,
                30.0317616
              ],
              [
                53.9744523,
                30.035201
              ],
              [
                53.9687204,
                30.0377689
              ],
              [
                53.9564966,
                30.0433455
              ],
              [
                53.9390569,
                30.0529789
              ],
              [
                53.930383,
                30.0591873
              ],
              [
                53.9298696,
                30.0621121
              ],
              [
                53.9250386,
                30.0652301
              ],
              [
                53.9222901,
                30.0695784
              ],
              [
                53.9160828,
                30.0767538
              ],
              [
                53.9043049,
                30.0889645
              ],
              [
                53.8970842,
                30.0969855
              ],
              [
                53.8930309,
                30.1060752
              ],
              [
                53.887582,
                30.1217065
              ],
              [
                53.8807668,
                30.1266644
              ],
              [
                53.8599703,
                30.1448986
              ],
              [
                53.8452823,
                30.1563209
              ],
              [
                53.8359448,
                30.1625621
              ],
              [
                53.8214206,
                30.1732536
              ],
              [
                53.80939,
                30.1797294
              ],
              [
                53.7879863,
                30.1847071
              ],
              [
                53.7722181,
                30.1852542
              ],
              [
                53.7584803,
                30.1877485
              ],
              [
                53.7428855,
                30.1939536
              ],
              [
                53.72789,
                30.2045625
              ],
              [
                53.7141759,
                30.2178057
              ],
              [
                53.7051868,
                30.227829
              ],
              [
                53.7004743,
                30.2321859
              ],
              [
                53.6941337,
                30.2432007
              ],
              [
                53.684287,
                30.2546858
              ],
              [
                53.6773437,
                30.2664644
              ],
              [
                53.669441,
                30.2805934
              ],
              [
                53.6651789,
                30.2945397
              ],
              [
                53.6633522,
                30.3061488
              ],
              [
                53.6629897,
                30.3148891
              ],
              [
                53.6637121,
                30.3222267
              ],
              [
                53.6646042,
                30.3267612
              ],
              [
                53.6687171,
                30.3359256
              ],
              [
                53.6511441,
                30.3429078
              ],
              [
                53.642649,
                30.3448287
              ],
              [
                53.6249762,
                30.3467381
              ],
              [
                53.6158155,
                30.3476335
              ],
              [
                53.609149,
                30.3487434
              ],
              [
                53.5852593,
                30.3526323
              ],
              [
                53.5847027,
                30.352912
              ],
              [
                53.5835927,
                30.352912
              ],
              [
                53.581926,
                30.3534625
              ],
              [
                53.580536,
                30.3534625
              ],
              [
                53.5713695,
                30.3559619
              ],
              [
                53.5577564,
                30.3570718
              ],
              [
                53.5566464,
                30.3573515
              ],
              [
                53.5508131,
                30.3573515
              ],
              [
                53.5496997,
                30.3570717
              ],
              [
                53.5474799,
                30.3570717
              ],
              [
                53.5305334,
                30.3537422
              ],
              [
                53.5144203,
                30.3462439
              ],
              [
                53.5119204,
                30.3448543
              ],
              [
                53.4774743,
                30.3284593
              ],
              [
                53.4674743,
                30.3254095
              ],
              [
                53.4671977,
                30.3251297
              ],
              [
                53.4666411,
                30.3251298
              ],
              [
                53.4663643,
                30.3248501
              ],
              [
                53.465251,
                30.3248501
              ],
              [
                53.4491412,
                30.3204108
              ],
              [
                53.445808,
                30.3198513
              ],
              [
                53.4413613,
                30.3181821
              ],
              [
                53.4321948,
                30.3156827
              ],
              [
                53.4313616,
                30.3156826
              ],
              [
                53.4302515,
                30.3151322
              ],
              [
                53.4063619,
                30.3095741
              ],
              [
                53.4044152,
                30.3095741
              ],
              [
                53.4035818,
                30.3092944
              ],
              [
                53.3902488,
                30.3092944
              ],
              [
                53.3894155,
                30.3095741
              ],
              [
                53.3874722,
                30.3095741
              ],
              [
                53.3866389,
                30.3098538
              ],
              [
                53.3838588,
                30.3098539
              ],
              [
                53.3813589,
                30.3101246
              ],
              [
                53.3805255,
                30.3104043
              ],
              [
                53.379139,
                30.3104042
              ],
              [
                53.3783057,
                30.3106839
              ],
              [
                53.3758057,
                30.3106839
              ],
              [
                53.3749724,
                30.3109637
              ],
              [
                53.3633025,
                30.3109637
              ],
              [
                53.3610826,
                30.3101245
              ],
              [
                53.3602493,
                30.3095741
              ],
              [
                53.3599692,
                30.3092944
              ],
              [
                53.356916,
                30.3079048
              ],
              [
                53.3324696,
                30.304016
              ],
              [
                53.3221897,
                30.3015166
              ],
              [
                53.3205232,
                30.3015167
              ],
              [
                53.3196898,
                30.3012369
              ],
              [
                53.3180231,
                30.3012369
              ],
              [
                53.3171899,
                30.3009572
              ],
              [
                53.2977434,
                30.2990172
              ],
              [
                53.2894102,
                30.2962382
              ],
              [
                53.2891336,
                30.2954081
              ],
              [
                53.2891336,
                30.2951284
              ],
              [
                53.2883003,
                30.2920697
              ],
              [
                53.2885769,
                30.2906801
              ],
              [
                53.2888569,
                30.2904095
              ],
              [
                53.2905236,
                30.2873507
              ],
              [
                53.2908002,
                30.2856905
              ],
              [
                53.2913569,
                30.2845717
              ],
              [
                53.2913569,
                30.2837416
              ],
              [
                53.2960768,
                30.2698465
              ],
              [
                53.2969101,
                30.265687
              ],
              [
                53.30719,
                30.2342883
              ],
              [
                53.3127553,
                30.2152947
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 11166656,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بختگان",
          "name:en": "Bakhtegan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4663216"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.4136772,
                29.6504858
              ],
              [
                53.4141386,
                29.650396
              ],
              [
                53.4146953,
                29.6501164
              ],
              [
                53.4146953,
                29.6498368
              ],
              [
                53.4144186,
                29.6467796
              ],
              [
                53.4146954,
                29.6462295
              ],
              [
                53.4144187,
                29.6431722
              ],
              [
                53.4174719,
                29.6301136
              ],
              [
                53.4233052,
                29.6148367
              ],
              [
                53.4363197,
                29.5908509
              ],
              [
                53.4463614,
                29.5723347
              ],
              [
                53.4510848,
                29.5656705
              ],
              [
                53.4541893,
                29.5618743
              ],
              [
                53.4560847,
                29.5595564
              ],
              [
                53.4941197,
                29.5300128
              ],
              [
                53.4944208,
                29.5298342
              ],
              [
                53.4966441,
                29.5292752
              ],
              [
                53.4969208,
                29.5290046
              ],
              [
                53.4980307,
                29.5287252
              ],
              [
                53.5330335,
                29.5187247
              ],
              [
                53.5344235,
                29.5187247
              ],
              [
                53.5377569,
                29.5181656
              ],
              [
                53.5397001,
                29.5181657
              ],
              [
                53.5410902,
                29.5178861
              ],
              [
                53.5430334,
                29.5178861
              ],
              [
                53.5444234,
                29.5176155
              ],
              [
                53.5463667,
                29.5176156
              ],
              [
                53.5613664,
                29.5148382
              ],
              [
                53.5630365,
                29.5148381
              ],
              [
                53.5635898,
                29.5145587
              ],
              [
                53.5652564,
                29.5145586
              ],
              [
                53.5658131,
                29.5142791
              ],
              [
                53.5672031,
                29.5142791
              ],
              [
                53.5677563,
                29.5139996
              ],
              [
                53.5685896,
                29.5139996
              ],
              [
                53.5710896,
                29.5134495
              ],
              [
                53.5716463,
                29.5128904
              ],
              [
                53.5733129,
                29.5134495
              ],
              [
                53.5741463,
                29.51372
              ],
              [
                53.5755363,
                29.5137201
              ],
              [
                53.5799795,
                29.5145587
              ],
              [
                53.5858128,
                29.5145586
              ],
              [
                53.5869262,
                29.5142791
              ],
              [
                53.5883127,
                29.5142791
              ],
              [
                53.5888694,
                29.5139996
              ],
              [
                53.5902594,
                29.5139996
              ],
              [
                53.6066492,
                29.5103926
              ],
              [
                53.6074825,
                29.5098335
              ],
              [
                53.645262,
                29.4926105
              ],
              [
                53.6463991,
                29.4920243
              ],
              [
                53.6472052,
                29.4912218
              ],
              [
                53.6483151,
                29.4901127
              ],
              [
                53.662485,
                29.4798332
              ],
              [
                53.685818,
                29.4531698
              ],
              [
                53.6866513,
                29.4515017
              ],
              [
                53.6938745,
                29.4415021
              ],
              [
                53.6977646,
                29.4376068
              ],
              [
                53.6988744,
                29.4359477
              ],
              [
                53.703041,
                29.4309434
              ],
              [
                53.7074843,
                29.424271
              ],
              [
                53.7088743,
                29.4228914
              ],
              [
                53.7249875,
                29.4012247
              ],
              [
                53.727764,
                29.3984385
              ],
              [
                53.7291541,
                29.3965
              ],
              [
                53.7366539,
                29.3898279
              ],
              [
                53.7394305,
                29.3878894
              ],
              [
                53.7599869,
                29.3762223
              ],
              [
                53.7983229,
                29.3620487
              ],
              [
                53.7999897,
                29.3617782
              ],
              [
                53.8467738,
                29.3511742
              ],
              [
                53.8686053,
                29.3462255
              ],
              [
                53.8741586,
                29.3445576
              ],
              [
                53.880825,
                29.3426101
              ],
              [
                53.9491641,
                29.3103874
              ],
              [
                53.9538839,
                29.3092785
              ],
              [
                53.9555507,
                29.3092785
              ],
              [
                53.956664,
                29.3089991
              ],
              [
                53.9580506,
                29.308999
              ],
              [
                53.9588839,
                29.3087196
              ],
              [
                53.9622205,
                29.3087195
              ],
              [
                53.9630538,
                29.3084401
              ],
              [
                53.9655539,
                29.3084401
              ],
              [
                53.9663872,
                29.3087195
              ],
              [
                53.9688871,
                29.3087196
              ],
              [
                53.9722204,
                29.3089991
              ],
              [
                53.9730537,
                29.3092786
              ],
              [
                53.9780905,
                29.3105355
              ],
              [
                53.9835222,
                29.3118908
              ],
              [
                53.9863868,
                29.3126054
              ],
              [
                53.9933387,
                29.3166136
              ],
              [
                53.995934,
                29.3203581
              ],
              [
                54.0003907,
                29.3247813
              ],
              [
                54.0146553,
                29.3265398
              ],
              [
                54.0229768,
                29.3283735
              ],
              [
                54.0291662,
                29.3303845
              ],
              [
                54.0334865,
                29.331828
              ],
              [
                54.044563,
                29.3349677
              ],
              [
                54.0571545,
                29.3409817
              ],
              [
                54.070899,
                29.3467932
              ],
              [
                54.0799221,
                29.3521271
              ],
              [
                54.0968627,
                29.3619411
              ],
              [
                54.10791,
                29.3682138
              ],
              [
                54.1214381,
                29.3763915
              ],
              [
                54.1302813,
                29.3823845
              ],
              [
                54.1473142,
                29.3946198
              ],
              [
                54.1621969,
                29.4020647
              ],
              [
                54.175115,
                29.4076244
              ],
              [
                54.1871556,
                29.408776
              ],
              [
                54.209205,
                29.4181256
              ],
              [
                54.2174431,
                29.4200868
              ],
              [
                54.2483607,
                29.4275867
              ],
              [
                54.272449,
                29.433442
              ],
              [
                54.2533428,
                29.5139996
              ],
              [
                54.2516762,
                29.5317821
              ],
              [
                54.2450597,
                29.5783185
              ],
              [
                54.2439688,
                29.5903156
              ],
              [
                54.2442141,
                29.5938795
              ],
              [
                54.2439688,
                29.6005811
              ],
              [
                54.2460051,
                29.6082384
              ],
              [
                54.2341804,
                29.6149907
              ],
              [
                54.2303717,
                29.6177581
              ],
              [
                54.2261053,
                29.6200708
              ],
              [
                54.2186654,
                29.6240518
              ],
              [
                54.2144918,
                29.6272022
              ],
              [
                54.2069984,
                29.6318744
              ],
              [
                54.1902006,
                29.6562768
              ],
              [
                54.1848791,
                29.6674269
              ],
              [
                54.1814709,
                29.6749774
              ],
              [
                54.178047,
                29.6916319
              ],
              [
                54.1714857,
                29.7095774
              ],
              [
                54.1658542,
                29.7229972
              ],
              [
                54.1560744,
                29.7390418
              ],
              [
                54.1442297,
                29.7532008
              ],
              [
                54.1341017,
                29.7630364
              ],
              [
                54.1294668,
                29.7692949
              ],
              [
                54.1176222,
                29.7788309
              ],
              [
                54.1054342,
                29.7856844
              ],
              [
                54.0973444,
                29.7886407
              ],
              [
                54.0901493,
                29.791482
              ],
              [
                54.0702157,
                29.7969816
              ],
              [
                54.0388324,
                29.8016556
              ],
              [
                54.016849,
                29.8006129
              ],
              [
                54.0085733,
                29.80268
              ],
              [
                53.9991759,
                29.804082
              ],
              [
                53.9918888,
                29.8052122
              ],
              [
                53.9764599,
                29.8113558
              ],
              [
                53.9662114,
                29.8182174
              ],
              [
                53.9511196,
                29.8301415
              ],
              [
                53.9221619,
                29.8523002
              ],
              [
                53.9166497,
                29.8529992
              ],
              [
                53.9123523,
                29.8565241
              ],
              [
                53.9023421,
                29.8647398
              ],
              [
                53.8911151,
                29.8719083
              ],
              [
                53.8743083,
                29.8819834
              ],
              [
                53.8613538,
                29.8889064
              ],
              [
                53.853098,
                29.8925508
              ],
              [
                53.8473415,
                29.8922249
              ],
              [
                53.8394515,
                29.8917532
              ],
              [
                53.8200047,
                29.8899246
              ],
              [
                53.8010635,
                29.8880872
              ],
              [
                53.7965513,
                29.8878034
              ],
              [
                53.7751217,
                29.8844661
              ],
              [
                53.7656306,
                29.8830718
              ],
              [
                53.7564468,
                29.8844113
              ],
              [
                53.7509536,
                29.8858253
              ],
              [
                53.7445163,
                29.8886531
              ],
              [
                53.7367671,
                29.8924104
              ],
              [
                53.7339107,
                29.8938541
              ],
              [
                53.7209987,
                29.8935643
              ],
              [
                53.7093771,
                29.8940661
              ],
              [
                53.6910736,
                29.8929115
              ],
              [
                53.6655382,
                29.8903925
              ],
              [
                53.6508151,
                29.8851248
              ],
              [
                53.6330387,
                29.8765104
              ],
              [
                53.6305387,
                29.8748417
              ],
              [
                53.6283154,
                29.8740119
              ],
              [
                53.5952593,
                29.8581726
              ],
              [
                53.5877594,
                29.8562333
              ],
              [
                53.5872027,
                29.8559537
              ],
              [
                53.5688696,
                29.850677
              ],
              [
                53.5521998,
                29.8390052
              ],
              [
                53.5480333,
                29.8270629
              ],
              [
                53.5483133,
                29.8259535
              ],
              [
                53.5541465,
                29.8095647
              ],
              [
                53.5549799,
                29.8087259
              ],
              [
                53.5647031,
                29.7901185
              ],
              [
                53.566923,
                29.7840032
              ],
              [
                53.566923,
                29.7828938
              ],
              [
                53.5663814,
                29.7760962
              ],
              [
                53.5663697,
                29.7759488
              ],
              [
                53.5605332,
                29.7609497
              ],
              [
                53.5555332,
                29.7509473
              ],
              [
                53.5477566,
                29.7412336
              ],
              [
                53.54359,
                29.7342799
              ],
              [
                53.5433134,
                29.7326112
              ],
              [
                53.5427567,
                29.731502
              ],
              [
                53.5408101,
                29.7237275
              ],
              [
                53.5402567,
                29.7231773
              ],
              [
                53.5133105,
                29.7101178
              ],
              [
                53.5058106,
                29.70734
              ],
              [
                53.4902541,
                29.7031733
              ],
              [
                53.4891442,
                29.7031733
              ],
              [
                53.4746977,
                29.6995567
              ],
              [
                53.4719211,
                29.6984474
              ],
              [
                53.4710878,
                29.6984475
              ],
              [
                53.4599746,
                29.6940011
              ],
              [
                53.4594179,
                29.693451
              ],
              [
                53.4580313,
                29.6928918
              ],
              [
                53.4566413,
                29.691503
              ],
              [
                53.4566414,
                29.6909528
              ],
              [
                53.4550919,
                29.6897864
              ],
              [
                53.4544181,
                29.6892843
              ],
              [
                53.4538647,
                29.6890047
              ],
              [
                53.4305283,
                29.6723381
              ],
              [
                53.4136772,
                29.6504858
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 16512852,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جویم",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.2016289,
                28.2773075
              ],
              [
                53.201629,
                28.2698061
              ],
              [
                53.201909,
                28.2686984
              ],
              [
                53.2030189,
                28.2636914
              ],
              [
                53.2032955,
                28.2623047
              ],
              [
                53.215242,
                28.2373064
              ],
              [
                53.2155187,
                28.236478
              ],
              [
                53.2277419,
                28.2167483
              ],
              [
                53.2352418,
                28.2100848
              ],
              [
                53.2366318,
                28.2095266
              ],
              [
                53.2613547,
                28.1961998
              ],
              [
                53.2616348,
                28.1959206
              ],
              [
                53.2969108,
                28.1759129
              ],
              [
                53.3155239,
                28.1678632
              ],
              [
                53.3166338,
                28.1670258
              ],
              [
                53.3324704,
                28.1606328
              ],
              [
                53.3363603,
                28.1586969
              ],
              [
                53.336637,
                28.1581387
              ],
              [
                53.3508034,
                28.1495309
              ],
              [
                53.3516366,
                28.1492517
              ],
              [
                53.3619166,
                28.1445247
              ],
              [
                53.3816396,
                28.1370335
              ],
              [
                53.4030292,
                28.126193
              ],
              [
                53.4038626,
                28.1253646
              ],
              [
                53.4055293,
                28.1245273
              ],
              [
                53.4063626,
                28.1236989
              ],
              [
                53.4396953,
                28.1050796
              ],
              [
                53.4405286,
                28.1048005
              ],
              [
                53.4413619,
                28.1039721
              ],
              [
                53.4421953,
                28.1036931
              ],
              [
                53.4677516,
                28.0798074
              ],
              [
                53.4716415,
                28.0706332
              ],
              [
                53.4719216,
                28.0684185
              ],
              [
                53.4721982,
                28.054806
              ],
              [
                53.4724748,
                28.054527
              ],
              [
                53.4721982,
                28.0528525
              ],
              [
                53.4724442,
                28.0521159
              ],
              [
                53.4724748,
                28.0520242
              ],
              [
                53.4721982,
                28.0484141
              ],
              [
                53.4724748,
                28.0478649
              ],
              [
                53.4721982,
                28.0467485
              ],
              [
                53.4696983,
                28.0303548
              ],
              [
                53.4691415,
                28.0250792
              ],
              [
                53.4685883,
                28.0148074
              ],
              [
                53.4691415,
                28.0111885
              ],
              [
                53.4694215,
                28.0103602
              ],
              [
                53.4696983,
                28.0095231
              ],
              [
                53.4699749,
                28.0086949
              ],
              [
                53.4735882,
                28.0034105
              ],
              [
                53.4738648,
                28.0028614
              ],
              [
                53.4766414,
                27.9998007
              ],
              [
                53.4791414,
                27.9998007
              ],
              [
                53.480808,
                27.9998006
              ],
              [
                53.4849747,
                28.0006378
              ],
              [
                53.4910879,
                28.0006378
              ],
              [
                53.4916446,
                28.0003588
              ],
              [
                53.4933112,
                28.0001787
              ],
              [
                53.4941445,
                27.9998007
              ],
              [
                53.4949778,
                27.9998006
              ],
              [
                53.4955312,
                27.9995216
              ],
              [
                53.4969211,
                27.9992515
              ],
              [
                53.5074777,
                28.0017451
              ],
              [
                53.5080343,
                28.0020242
              ],
              [
                53.5188674,
                28.0075786
              ],
              [
                53.5274773,
                28.0103603
              ],
              [
                53.5493845,
                28.0202971
              ],
              [
                53.5553248,
                28.0235931
              ],
              [
                53.5606538,
                28.0269772
              ],
              [
                53.5667742,
                28.0286527
              ],
              [
                53.5741853,
                28.0268717
              ],
              [
                53.581438,
                28.027099
              ],
              [
                53.5933456,
                28.0253488
              ],
              [
                53.6108602,
                28.0235404
              ],
              [
                53.6189641,
                28.022366
              ],
              [
                53.6321999,
                28.0218975
              ],
              [
                53.6361236,
                28.0216323
              ],
              [
                53.6441413,
                28.0211399
              ],
              [
                53.6397169,
                28.0404708
              ],
              [
                53.6322076,
                28.061784
              ],
              [
                53.6229419,
                28.0797077
              ],
              [
                53.6088222,
                28.0985738
              ],
              [
                53.5834604,
                28.1200243
              ],
              [
                53.6131094,
                28.1278571
              ],
              [
                53.6297149,
                28.1337975
              ],
              [
                53.6501582,
                28.141012
              ],
              [
                53.6572559,
                28.1499929
              ],
              [
                53.6630956,
                28.1658384
              ],
              [
                53.6626123,
                28.189763
              ],
              [
                53.689828,
                28.1835106
              ],
              [
                53.7166106,
                28.1781209
              ],
              [
                53.7490652,
                28.175685
              ],
              [
                53.7605665,
                28.1755336
              ],
              [
                53.809995,
                28.1730903
              ],
              [
                53.8395421,
                28.1708675
              ],
              [
                53.8534353,
                28.1702373
              ],
              [
                53.8707731,
                28.1649407
              ],
              [
                53.8841646,
                28.1716642
              ],
              [
                53.891655,
                28.1862628
              ],
              [
                53.903454,
                28.1865711
              ],
              [
                53.9284731,
                28.1885158
              ],
              [
                53.975075,
                28.1931848
              ],
              [
                54.0333986,
                28.1931744
              ],
              [
                54.0387127,
                28.1220838
              ],
              [
                54.0387998,
                28.1209169
              ],
              [
                54.0461126,
                28.1189721
              ],
              [
                54.0474992,
                28.1189721
              ],
              [
                54.0513892,
                28.1181348
              ],
              [
                54.0524991,
                28.1181348
              ],
              [
                54.0538891,
                28.1178557
              ],
              [
                54.0566691,
                28.1170273
              ],
              [
                54.0644457,
                28.1159198
              ],
              [
                54.0650023,
                28.1156408
              ],
              [
                54.0672222,
                28.1156408
              ],
              [
                54.0677789,
                28.1153617
              ],
              [
                54.0697222,
                28.1153617
              ],
              [
                54.0772254,
                28.113696
              ],
              [
                54.0847253,
                28.113696
              ],
              [
                54.0852786,
                28.113417
              ],
              [
                54.086112,
                28.1134169
              ],
              [
                54.0963918,
                28.1092483
              ],
              [
                54.0969484,
                28.1092482
              ],
              [
                54.0972252,
                28.1089692
              ],
              [
                54.0983351,
                28.1089692
              ],
              [
                54.099725,
                28.108411
              ],
              [
                54.1011151,
                28.108411
              ],
              [
                54.1013918,
                28.1081408
              ],
              [
                54.1030584,
                28.1081408
              ],
              [
                54.103335,
                28.108411
              ],
              [
                54.1041683,
                28.1084109
              ],
              [
                54.1141716,
                28.1159199
              ],
              [
                54.1147248,
                28.1170273
              ],
              [
                54.1194481,
                28.1234199
              ],
              [
                54.128338,
                28.1278587
              ],
              [
                54.1302813,
                28.1278588
              ],
              [
                54.130838,
                28.1281378
              ],
              [
                54.1377811,
                28.1281379
              ],
              [
                54.1425044,
                28.1267512
              ],
              [
                54.1430611,
                28.1267512
              ],
              [
                54.1433378,
                28.1264722
              ],
              [
                54.1447277,
                28.1264722
              ],
              [
                54.1463944,
                28.1259139
              ],
              [
                54.151951,
                28.1259139
              ],
              [
                54.1525043,
                28.1261931
              ],
              [
                54.1569509,
                28.126193
              ],
              [
                54.1575042,
                28.1259139
              ],
              [
                54.1602842,
                28.1259139
              ],
              [
                54.1608374,
                28.1256348
              ],
              [
                54.163894,
                28.1256348
              ],
              [
                54.1641707,
                28.1253647
              ],
              [
                54.1655607,
                28.1253647
              ],
              [
                54.1666741,
                28.1253647
              ],
              [
                54.1675074,
                28.1250856
              ],
              [
                54.1694506,
                28.1250856
              ],
              [
                54.1894504,
                28.1211959
              ],
              [
                54.1972303,
                28.1192512
              ],
              [
                54.1988969,
                28.1192512
              ],
              [
                54.1997302,
                28.1189721
              ],
              [
                54.2013969,
                28.1189721
              ],
              [
                54.2016735,
                28.118693
              ],
              [
                54.2175066,
                28.118693
              ],
              [
                54.2180632,
                28.1189721
              ],
              [
                54.2197299,
                28.1189721
              ],
              [
                54.2200065,
                28.118693
              ],
              [
                54.2227865,
                28.118693
              ],
              [
                54.2230631,
                28.1184139
              ],
              [
                54.2238965,
                28.1184138
              ],
              [
                54.2241765,
                28.1181348
              ],
              [
                54.2247298,
                28.1181348
              ],
              [
                54.2252865,
                28.1181347
              ],
              [
                54.2236198,
                28.1195213
              ],
              [
                54.2230631,
                28.1198004
              ],
              [
                54.2227865,
                28.1200885
              ],
              [
                54.21334,
                28.1311901
              ],
              [
                54.2083401,
                28.1409142
              ],
              [
                54.2005635,
                28.1698081
              ],
              [
                54.2002835,
                28.1706455
              ],
              [
                54.2002835,
                28.1742473
              ],
              [
                54.2000069,
                28.1764713
              ],
              [
                54.1972303,
                28.18842
              ],
              [
                54.1819505,
                28.2239702
              ],
              [
                54.1811171,
                28.2248077
              ],
              [
                54.1786172,
                28.2320296
              ],
              [
                54.1783406,
                28.2325879
              ],
              [
                54.1780605,
                28.2328671
              ],
              [
                54.1697273,
                28.2420251
              ],
              [
                54.1694507,
                28.2425835
              ],
              [
                54.1641707,
                28.245366
              ],
              [
                54.1636175,
                28.2459154
              ],
              [
                54.1627841,
                28.2461945
              ],
              [
                54.1616707,
                28.2467528
              ],
              [
                54.1583375,
                28.2481396
              ],
              [
                54.1577842,
                28.2486979
              ],
              [
                54.1566708,
                28.2489771
              ],
              [
                54.1550043,
                28.2500847
              ],
              [
                54.1318701,
                28.2544937
              ],
              [
                54.1215704,
                28.2587275
              ],
              [
                54.0943626,
                28.274345
              ],
              [
                54.0826172,
                28.2817428
              ],
              [
                54.0631959,
                28.2980325
              ],
              [
                54.0458414,
                28.3113858
              ],
              [
                54.0321349,
                28.3250091
              ],
              [
                54.0147586,
                28.3378207
              ],
              [
                54.000635,
                28.3459356
              ],
              [
                53.9977168,
                28.3438959
              ],
              [
                53.9937033,
                28.3434732
              ],
              [
                53.9782778,
                28.3423411
              ],
              [
                53.9687096,
                28.3424166
              ],
              [
                53.9566748,
                28.3430941
              ],
              [
                53.9432277,
                28.3423453
              ],
              [
                53.9103437,
                28.3436295
              ],
              [
                53.9011573,
                28.347824
              ],
              [
                53.8911708,
                28.3537162
              ],
              [
                53.8828754,
                28.3583232
              ],
              [
                53.8658809,
                28.360287
              ],
              [
                53.8598154,
                28.3586094
              ],
              [
                53.8536886,
                28.3541139
              ],
              [
                53.8393691,
                28.3541894
              ],
              [
                53.8300454,
                28.3536194
              ],
              [
                53.8168716,
                28.3449535
              ],
              [
                53.8020228,
                28.3380036
              ],
              [
                53.7954986,
                28.3361192
              ],
              [
                53.7791492,
                28.3323647
              ],
              [
                53.7651646,
                28.3288894
              ],
              [
                53.7523598,
                28.3225658
              ],
              [
                53.7254706,
                28.3151247
              ],
              [
                53.7015149,
                28.3204004
              ],
              [
                53.6819456,
                28.3246314
              ],
              [
                53.6718176,
                28.3291645
              ],
              [
                53.658943,
                28.3315821
              ],
              [
                53.6434935,
                28.3401944
              ],
              [
                53.615341,
                28.3534893
              ],
              [
                53.6156843,
                28.3471442
              ],
              [
                53.6063302,
                28.3363424
              ],
              [
                53.5937117,
                28.3240269
              ],
              [
                53.5845931,
                28.3119395
              ],
              [
                53.5798841,
                28.3090963
              ],
              [
                53.579339,
                28.3025711
              ],
              [
                53.5783424,
                28.2979955
              ],
              [
                53.5624056,
                28.301495
              ],
              [
                53.5481677,
                28.3037788
              ],
              [
                53.5324747,
                28.3050634
              ],
              [
                53.5106629,
                28.3067552
              ],
              [
                53.4996977,
                28.2998035
              ],
              [
                53.4991444,
                28.3000827
              ],
              [
                53.4971977,
                28.3000827
              ],
              [
                53.4969211,
                28.3003618
              ],
              [
                53.4958111,
                28.3003618
              ],
              [
                53.4927545,
                28.3011994
              ],
              [
                53.4919212,
                28.3011993
              ],
              [
                53.4915882,
                28.3013663
              ],
              [
                53.4913645,
                28.3009202
              ],
              [
                53.4908112,
                28.300641
              ],
              [
                53.4871978,
                28.300641
              ],
              [
                53.4846979,
                28.3003619
              ],
              [
                53.4830313,
                28.300641
              ],
              [
                53.478308,
                28.300641
              ],
              [
                53.4766414,
                28.3009202
              ],
              [
                53.4735881,
                28.3009201
              ],
              [
                53.470808,
                28.3014785
              ],
              [
                53.4685883,
                28.3014785
              ],
              [
                53.4660849,
                28.3017577
              ],
              [
                53.4477518,
                28.3017577
              ],
              [
                53.4152523,
                28.3073052
              ],
              [
                53.4083057,
                28.3073052
              ],
              [
                53.4058059,
                28.3075844
              ],
              [
                53.3983059,
                28.3075844
              ],
              [
                53.3958059,
                28.3073053
              ],
              [
                53.3766396,
                28.3064767
              ],
              [
                53.3596932,
                28.303694
              ],
              [
                53.3333036,
                28.2970297
              ],
              [
                53.3208038,
                28.2925809
              ],
              [
                53.3158005,
                28.2909239
              ],
              [
                53.3144138,
                28.2900864
              ],
              [
                53.3083006,
                28.287862
              ],
              [
                53.2905243,
                28.2823056
              ],
              [
                53.2866343,
                28.2820354
              ],
              [
                53.283301,
                28.281477
              ],
              [
                53.2794111,
                28.2814771
              ],
              [
                53.2785778,
                28.2811979
              ],
              [
                53.2727445,
                28.2811979
              ],
              [
                53.2710779,
                28.2809187
              ],
              [
                53.2641347,
                28.2809188
              ],
              [
                53.2633013,
                28.2806396
              ],
              [
                53.2596881,
                28.2806396
              ],
              [
                53.2588547,
                28.2803604
              ],
              [
                53.2555214,
                28.2803604
              ],
              [
                53.2546881,
                28.2800812
              ],
              [
                53.2502449,
                28.2798111
              ],
              [
                53.2271886,
                28.2770284
              ],
              [
                53.224132,
                28.2770283
              ],
              [
                53.2224654,
                28.2767493
              ],
              [
                53.2124655,
                28.2767492
              ],
              [
                53.2121854,
                28.2770284
              ],
              [
                53.2116322,
                28.2767491
              ],
              [
                53.2057989,
                28.2767492
              ],
              [
                53.2055189,
                28.2770284
              ],
              [
                53.2035756,
                28.2770283
              ],
              [
                53.2030189,
                28.2773076
              ],
              [
                53.2016289,
                28.2773075
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249309689
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.1816105,
          27.333426
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3237995503
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.8821254,
          27.5514645
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 794158462
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.4367822,
          27.8899259
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 818944615
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.6520826,
          29.6203251
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 818961986
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.0946443,
          28.8553783
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 791723493
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.5727236,
          28.845604
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 844608112
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.0357558,
          28.482802
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3246081415
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.5593366,
          28.4961762
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 248779500
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.6510677,
          28.9366395
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4967309507
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.6926076,
          29.2003014
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 26082452
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.5378041,
          29.6060218
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 248772356
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.7215709,
          29.774274
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4415618631
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.2127701,
          28.9670095
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 248776568
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.22157,
          29.2721889
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2505386489
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.3122486,
          29.498294
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 806633638
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5819119,
          29.8510025
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 806623086
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5229633,
          30.1154071
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 806612685
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          51.5241743,
          30.2443946
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4684400082
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.3584413,
          30.008388
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3223170363
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.8062895,
          29.8762905
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 814909332
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.1358118,
          30.0797928
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 814918848
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.3089761,
          29.914968
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3916130109
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.6228281,
          30.4738825
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5372917552
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.688496,
          30.8925778
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249308233
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          52.6490454,
          31.1627056
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 344629434
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.1378384,
          27.6701538
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 344628216
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.3229561,
          27.6619203
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249307870
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.0051497,
          27.7625325
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 1164234734
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.4206696,
          28.3590721
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 248783208
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.548149,
          28.753194
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 248777720
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.0405113,
          29.1252321
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 248708371
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.3267782,
          29.1972504
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 814924038
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.7268534,
          29.8078337
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3912523667
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.7165328,
          30.0327056
        ]
      }
    }
  ]
},
"قزوین.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554855,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آبیک",
          "name:en": "Abyek County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289732",
          "wikipedia": "en:Abyek County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.068368,
                36.0500779
              ],
              [
                50.0897037,
                36.0190109
              ],
              [
                50.1026103,
                36.0002042
              ],
              [
                50.1193043,
                35.9997268
              ],
              [
                50.1264813,
                35.9902576
              ],
              [
                50.153151,
                35.973314
              ],
              [
                50.1539842,
                35.9733141
              ],
              [
                50.1539842,
                35.9730347
              ],
              [
                50.1706506,
                35.9610929
              ],
              [
                50.1712073,
                35.9605341
              ],
              [
                50.1792606,
                35.9533149
              ],
              [
                50.208987,
                35.9383176
              ],
              [
                50.2250968,
                35.9269251
              ],
              [
                50.2256535,
                35.9263754
              ],
              [
                50.2451,
                35.9094217
              ],
              [
                50.2564866,
                35.8971997
              ],
              [
                50.2567668,
                35.8966499
              ],
              [
                50.2573198,
                35.8963705
              ],
              [
                50.2576,
                35.8958117
              ],
              [
                50.264543,
                35.8891508
              ],
              [
                50.2650997,
                35.8888714
              ],
              [
                50.2981559,
                35.8608122
              ],
              [
                50.3034361,
                35.8541421
              ],
              [
                50.3037127,
                35.8538717
              ],
              [
                50.3045459,
                35.852754
              ],
              [
                50.3150997,
                35.8424813
              ],
              [
                50.3151028,
                35.8424783
              ],
              [
                50.3281589,
                35.8533129
              ],
              [
                50.3309356,
                35.8569274
              ],
              [
                50.3313526,
                35.8573375
              ],
              [
                50.3317692,
                35.8577567
              ],
              [
                50.3320457,
                35.8583155
              ],
              [
                50.3339922,
                35.8610917
              ],
              [
                50.3342688,
                35.8613712
              ],
              [
                50.3989946,
                35.9522066
              ],
              [
                50.4014946,
                35.9619224
              ],
              [
                50.4045337,
                35.9708545
              ],
              [
                50.4059381,
                35.9749817
              ],
              [
                50.4067713,
                35.9777576
              ],
              [
                50.4072636,
                35.981417
              ],
              [
                50.4084996,
                35.9865218
              ],
              [
                50.4088858,
                35.9916262
              ],
              [
                50.4096583,
                35.9952512
              ],
              [
                50.4115895,
                35.9976261
              ],
              [
                50.4141129,
                36.0016466
              ],
              [
                50.4156767,
                36.0029763
              ],
              [
                50.4193073,
                36.0034763
              ],
              [
                50.4220882,
                36.0036846
              ],
              [
                50.4232985,
                36.0044761
              ],
              [
                50.4254614,
                36.0048094
              ],
              [
                50.4280878,
                36.0044553
              ],
              [
                50.4294268,
                36.0044553
              ],
              [
                50.431358,
                36.0044553
              ],
              [
                50.4324137,
                36.0045595
              ],
              [
                50.4337526,
                36.0052677
              ],
              [
                50.4362503,
                36.007059
              ],
              [
                50.4387737,
                36.0074756
              ],
              [
                50.4429193,
                36.0095586
              ],
              [
                50.44655,
                36.0107458
              ],
              [
                50.4510046,
                36.0100168
              ],
              [
                50.4539915,
                36.0099335
              ],
              [
                50.4576445,
                36.00964
              ],
              [
                50.4643217,
                36.0092894
              ],
              [
                50.4683901,
                36.0082687
              ],
              [
                50.4781233,
                36.0039153
              ],
              [
                50.4837881,
                36.0016447
              ],
              [
                50.4891182,
                36.0001032
              ],
              [
                50.4930321,
                35.9996449
              ],
              [
                50.4953495,
                35.9998116
              ],
              [
                50.4973064,
                36.0009156
              ],
              [
                50.4983879,
                36.0021863
              ],
              [
                50.5007053,
                36.0046443
              ],
              [
                50.50413,
                36.008477
              ],
              [
                50.5080953,
                36.0120596
              ],
              [
                50.5108763,
                36.0146423
              ],
              [
                50.5146614,
                36.0167667
              ],
              [
                50.5235191,
                36.020807
              ],
              [
                50.5282312,
                36.0222024
              ],
              [
                50.534308,
                36.0215151
              ],
              [
                50.5451999,
                36.0199115
              ],
              [
                50.5469766,
                36.0195366
              ],
              [
                50.551251,
                36.0258468
              ],
              [
                50.5531307,
                36.029137
              ],
              [
                50.5526672,
                36.0346759
              ],
              [
                50.5570961,
                36.037591
              ],
              [
                50.5604279,
                36.0420636
              ],
              [
                50.6026155,
                36.0974818
              ],
              [
                50.6620785,
                36.0990479
              ],
              [
                50.6736287,
                36.1053388
              ],
              [
                50.6748139,
                36.1061732
              ],
              [
                50.675683,
                36.1074734
              ],
              [
                50.673666,
                36.112362
              ],
              [
                50.6687736,
                36.118429
              ],
              [
                50.6462184,
                36.1304475
              ],
              [
                50.6178974,
                36.1439311
              ],
              [
                50.6125784,
                36.1469832
              ],
              [
                50.6052589,
                36.1511478
              ],
              [
                50.5797243,
                36.1623744
              ],
              [
                50.5703684,
                36.1677103
              ],
              [
                50.5661725,
                36.1702798
              ],
              [
                50.561434,
                36.17264
              ],
              [
                50.5576509,
                36.1750412
              ],
              [
                50.5513366,
                36.1786013
              ],
              [
                50.5465912,
                36.1813861
              ],
              [
                50.5408833,
                36.1845985
              ],
              [
                50.5378597,
                36.1870277
              ],
              [
                50.5305862,
                36.1937243
              ],
              [
                50.5265521,
                36.1984689
              ],
              [
                50.523076,
                36.2008931
              ],
              [
                50.5206728,
                36.2012394
              ],
              [
                50.5171966,
                36.202313
              ],
              [
                50.5110644,
                36.2076359
              ],
              [
                50.504322,
                36.2131168
              ],
              [
                50.5003737,
                36.2166485
              ],
              [
                50.496683,
                36.2184143
              ],
              [
                50.4914903,
                36.221184
              ],
              [
                50.4887008,
                36.2225343
              ],
              [
                50.4811048,
                36.2262387
              ],
              [
                50.4777353,
                36.2271836
              ],
              [
                50.4722214,
                36.2287311
              ],
              [
                50.4676844,
                36.2299937
              ],
              [
                50.4634451,
                36.2311718
              ],
              [
                50.459926,
                36.2322276
              ],
              [
                50.4546298,
                36.2337188
              ],
              [
                50.4506349,
                36.2348237
              ],
              [
                50.4439864,
                36.2364441
              ],
              [
                50.4345845,
                36.238666
              ],
              [
                50.4332141,
                36.2393804
              ],
              [
                50.434606,
                36.2410716
              ],
              [
                50.4383182,
                36.2436502
              ],
              [
                50.4342093,
                36.2460411
              ],
              [
                50.4308939,
                36.248115
              ],
              [
                50.4287909,
                36.2503647
              ],
              [
                50.4314447,
                36.254092
              ],
              [
                50.4322241,
                36.2637917
              ],
              [
                50.4305739,
                36.2688319
              ],
              [
                50.429372,
                36.2689705
              ],
              [
                50.4267659,
                36.2717426
              ],
              [
                50.4213353,
                36.2742717
              ],
              [
                50.419006,
                36.2903623
              ],
              [
                50.4239844,
                36.293406
              ],
              [
                50.4322241,
                36.2938211
              ],
              [
                50.4411505,
                36.2985251
              ],
              [
                50.4471586,
                36.2981101
              ],
              [
                50.4578015,
                36.302399
              ],
              [
                50.4588316,
                36.308624
              ],
              [
                50.4629515,
                36.3170617
              ],
              [
                50.4713629,
                36.320243
              ],
              [
                50.47544,
                36.3208998
              ],
              [
                50.4806536,
                36.3209392
              ],
              [
                50.4743135,
                36.3285237
              ],
              [
                50.4679297,
                36.3357322
              ],
              [
                50.4564284,
                36.3296475
              ],
              [
                50.447821,
                36.3261118
              ],
              [
                50.4406355,
                36.3275731
              ],
              [
                50.4370306,
                36.3311687
              ],
              [
                50.4337674,
                36.3288936
              ],
              [
                50.4263106,
                36.3304152
              ],
              [
                50.420648,
                36.3328042
              ],
              [
                50.412998,
                36.3290943
              ],
              [
                50.4047583,
                36.3284029
              ],
              [
                50.4002951,
                36.3185832
              ],
              [
                50.3946303,
                36.3173384
              ],
              [
                50.3824423,
                36.3207962
              ],
              [
                50.3754042,
                36.3188598
              ],
              [
                50.3493117,
                36.3059956
              ],
              [
                50.3370926,
                36.2966961
              ],
              [
                50.330298,
                36.2851041
              ],
              [
                50.3220175,
                36.2791538
              ],
              [
                50.3173796,
                36.273038
              ],
              [
                50.3129194,
                36.2680823
              ],
              [
                50.3055355,
                36.2633647
              ],
              [
                50.290235,
                36.255301
              ],
              [
                50.283737,
                36.2482881
              ],
              [
                50.2790402,
                36.247196
              ],
              [
                50.2669032,
                36.234375
              ],
              [
                50.2505615,
                36.2175775
              ],
              [
                50.2446031,
                36.2100405
              ],
              [
                50.2436025,
                36.2056282
              ],
              [
                50.2449965,
                36.1971076
              ],
              [
                50.2394402,
                36.1896064
              ],
              [
                50.2365243,
                36.1837534
              ],
              [
                50.2259116,
                36.1761806
              ],
              [
                50.2257418,
                36.1659534
              ],
              [
                50.2250346,
                36.1572585
              ],
              [
                50.2248573,
                36.1504201
              ],
              [
                50.2254503,
                36.1462705
              ],
              [
                50.2254152,
                36.1404741
              ],
              [
                50.2241308,
                36.1379809
              ],
              [
                50.2202266,
                36.13893
              ],
              [
                50.2136647,
                36.1425267
              ],
              [
                50.2041239,
                36.1476217
              ],
              [
                50.1921758,
                36.1552836
              ],
              [
                50.1853479,
                36.1605452
              ],
              [
                50.1809856,
                36.1641154
              ],
              [
                50.174818,
                36.1701005
              ],
              [
                50.1722431,
                36.171798
              ],
              [
                50.1697111,
                36.1720752
              ],
              [
                50.1663999,
                36.1720335
              ],
              [
                50.1641192,
                36.1692151
              ],
              [
                50.1408366,
                36.1612856
              ],
              [
                50.1334047,
                36.1590829
              ],
              [
                50.1126765,
                36.1507667
              ],
              [
                50.1051161,
                36.1458812
              ],
              [
                50.1041209,
                36.143744
              ],
              [
                50.1254653,
                36.1414792
              ],
              [
                50.1295423,
                36.139573
              ],
              [
                50.13717,
                36.1374732
              ],
              [
                50.1443052,
                36.1363844
              ],
              [
                50.1465405,
                36.1357145
              ],
              [
                50.1566756,
                36.1333579
              ],
              [
                50.1403163,
                36.1184985
              ],
              [
                50.1013362,
                36.1156938
              ],
              [
                50.1024474,
                36.105547
              ],
              [
                50.1028236,
                36.102111
              ],
              [
                50.0971564,
                36.097219
              ],
              [
                50.0948544,
                36.0816546
              ],
              [
                50.0891715,
                36.0822082
              ],
              [
                50.0735772,
                36.087863
              ],
              [
                50.068375,
                36.0894164
              ],
              [
                50.0628564,
                36.0878592
              ],
              [
                50.0604466,
                36.0828893
              ],
              [
                50.0647983,
                36.070881
              ],
              [
                50.0729424,
                36.0612343
              ],
              [
                50.071676,
                36.0559931
              ],
              [
                50.068368,
                36.0500779
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554866,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آوج",
          "name:en": "Avaj County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4827449",
          "wikipedia": "en:Avaj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.7363237,
                35.7239575
              ],
              [
                48.7366945,
                35.7241437
              ],
              [
                48.7369711,
                35.7244142
              ],
              [
                48.7419713,
                35.7271908
              ],
              [
                48.7486414,
                35.7294174
              ],
              [
                48.7525278,
                35.7310852
              ],
              [
                48.7583611,
                35.7321941
              ],
              [
                48.7589177,
                35.7324735
              ],
              [
                48.7605841,
                35.7324735
              ],
              [
                48.7608611,
                35.7327529
              ],
              [
                48.762251,
                35.732753
              ],
              [
                48.7628076,
                35.7330324
              ],
              [
                48.7655843,
                35.7330324
              ],
              [
                48.7680843,
                35.733303
              ],
              [
                48.7691976,
                35.7335824
              ],
              [
                48.7719742,
                35.7335824
              ],
              [
                48.773084,
                35.7338618
              ],
              [
                48.7750309,
                35.7338618
              ],
              [
                48.7797506,
                35.7335824
              ],
              [
                48.7908641,
                35.7305263
              ],
              [
                48.8016972,
                35.7213582
              ],
              [
                48.8189203,
                35.71164
              ],
              [
                48.8417,
                35.7055279
              ],
              [
                48.8425337,
                35.7055279
              ],
              [
                48.8430867,
                35.7052484
              ],
              [
                48.8439235,
                35.7052484
              ],
              [
                48.8514232,
                35.7038691
              ],
              [
                48.8594766,
                35.7024718
              ],
              [
                48.8614231,
                35.7024718
              ],
              [
                48.8678131,
                35.7013629
              ],
              [
                48.8703132,
                35.701363
              ],
              [
                48.87198,
                35.7010835
              ],
              [
                48.8741996,
                35.7010835
              ],
              [
                48.882813,
                35.6996952
              ],
              [
                48.8830896,
                35.6994158
              ],
              [
                48.8839229,
                35.6994157
              ],
              [
                48.8905894,
                35.6960801
              ],
              [
                48.8917031,
                35.6955302
              ],
              [
                48.8933696,
                35.6938624
              ],
              [
                48.930036,
                35.6708103
              ],
              [
                48.9308693,
                35.6705309
              ],
              [
                48.9311492,
                35.6703902
              ],
              [
                48.9319825,
                35.6699718
              ],
              [
                48.9330922,
                35.6699718
              ],
              [
                48.9439257,
                35.6644184
              ],
              [
                48.9464258,
                35.6633095
              ],
              [
                48.9467059,
                35.6630299
              ],
              [
                48.9475391,
                35.66303
              ],
              [
                48.9886517,
                35.6435836
              ],
              [
                49.006985,
                35.6380628
              ],
              [
                49.0092085,
                35.6358361
              ],
              [
                49.0122617,
                35.63278
              ],
              [
                49.0153184,
                35.6314007
              ],
              [
                49.0189317,
                35.6305624
              ],
              [
                49.0208747,
                35.6305624
              ],
              [
                49.0219849,
                35.6302828
              ],
              [
                49.0278182,
                35.6311122
              ],
              [
                49.0283749,
                35.6314008
              ],
              [
                49.0303179,
                35.6314007
              ],
              [
                49.0475413,
                35.6277993
              ],
              [
                49.0603213,
                35.6161344
              ],
              [
                49.0606774,
                35.6161077
              ],
              [
                49.0606157,
                35.6155408
              ],
              [
                49.0609149,
                35.6146335
              ],
              [
                49.0621084,
                35.6119197
              ],
              [
                49.071711,
                35.6058575
              ],
              [
                49.0731009,
                35.6047486
              ],
              [
                49.0783777,
                35.6008632
              ],
              [
                49.0794877,
                35.6008632
              ],
              [
                49.0814343,
                35.6003043
              ],
              [
                49.0819875,
                35.6000248
              ],
              [
                49.0825441,
                35.6000248
              ],
              [
                49.0828211,
                35.5997454
              ],
              [
                49.0842109,
                35.5997454
              ],
              [
                49.0911576,
                35.5874687
              ],
              [
                49.0922673,
                35.5874687
              ],
              [
                49.118704,
                35.5668887
              ],
              [
                49.1231507,
                35.5643909
              ],
              [
                49.125094,
                35.5627228
              ],
              [
                49.1259273,
                35.5624523
              ],
              [
                49.1298172,
                35.5582775
              ],
              [
                49.1337036,
                35.5493869
              ],
              [
                49.1325473,
                35.5308008
              ],
              [
                49.1322707,
                35.5299713
              ],
              [
                49.1325472,
                35.5296918
              ],
              [
                49.1342137,
                35.5224694
              ],
              [
                49.1347704,
                35.5219194
              ],
              [
                49.1353239,
                35.5208014
              ],
              [
                49.1453273,
                35.5138585
              ],
              [
                49.150327,
                35.5088632
              ],
              [
                49.1519938,
                35.5044089
              ],
              [
                49.1522704,
                35.5030293
              ],
              [
                49.152547,
                35.5019112
              ],
              [
                49.1600468,
                35.4938591
              ],
              [
                49.1603269,
                35.4935796
              ],
              [
                49.1608804,
                35.4933001
              ],
              [
                49.1686603,
                35.4910728
              ],
              [
                49.1689368,
                35.4908024
              ],
              [
                49.1756034,
                35.4910729
              ],
              [
                49.1775503,
                35.4908025
              ],
              [
                49.1781034,
                35.4905229
              ],
              [
                49.1797699,
                35.4905229
              ],
              [
                49.1828265,
                35.4899729
              ],
              [
                49.1942167,
                35.4866366
              ],
              [
                49.1950499,
                35.4866366
              ],
              [
                49.1961596,
                35.4860775
              ],
              [
                49.1969932,
                35.4860775
              ],
              [
                49.2047732,
                35.4824707
              ],
              [
                49.2056063,
                35.4819117
              ],
              [
                49.2069967,
                35.4816412
              ],
              [
                49.2078299,
                35.4810822
              ],
              [
                49.2108831,
                35.4810821
              ],
              [
                49.2228297,
                35.4780254
              ],
              [
                49.2456092,
                35.4727504
              ],
              [
                49.2461627,
                35.4724708
              ],
              [
                49.2522762,
                35.4724709
              ],
              [
                49.2569957,
                35.4727504
              ],
              [
                49.2592192,
                35.4727505
              ],
              [
                49.2594993,
                35.4730209
              ],
              [
                49.2600525,
                35.4727505
              ],
              [
                49.2656092,
                35.473021
              ],
              [
                49.266719,
                35.4727505
              ],
              [
                49.2672757,
                35.473021
              ],
              [
                49.2692191,
                35.4727504
              ],
              [
                49.2789423,
                35.4685755
              ],
              [
                49.2800556,
                35.4685755
              ],
              [
                49.2808888,
                35.4680255
              ],
              [
                49.281999,
                35.4680255
              ],
              [
                49.283942,
                35.4674664
              ],
              [
                49.2867222,
                35.4674664
              ],
              [
                49.2872753,
                35.4671869
              ],
              [
                49.2900555,
                35.4671869
              ],
              [
                49.290609,
                35.4669074
              ],
              [
                49.2922754,
                35.4669073
              ],
              [
                49.2978322,
                35.4646892
              ],
              [
                49.2986654,
                35.4646892
              ],
              [
                49.2992221,
                35.4641391
              ],
              [
                49.3086652,
                35.4608027
              ],
              [
                49.3097785,
                35.4605232
              ],
              [
                49.311722,
                35.4596937
              ],
              [
                49.3326718,
                35.4547573
              ],
              [
                49.3468381,
                35.4478147
              ],
              [
                49.3518382,
                35.4467057
              ],
              [
                49.3732811,
                35.4498031
              ],
              [
                49.3755045,
                35.4495327
              ],
              [
                49.3760611,
                35.4492532
              ],
              [
                49.3782811,
                35.4486943
              ],
              [
                49.3913663,
                35.4449189
              ],
              [
                49.3913663,
                35.4452074
              ],
              [
                49.3926077,
                35.4453284
              ],
              [
                49.3941429,
                35.4454779
              ],
              [
                49.3946995,
                35.4457574
              ],
              [
                49.3960863,
                35.4457575
              ],
              [
                49.3985864,
                35.4452075
              ],
              [
                49.3988664,
                35.4449188
              ],
              [
                49.3999762,
                35.4449189
              ],
              [
                49.4008095,
                35.4443689
              ],
              [
                49.4016431,
                35.444369
              ],
              [
                49.4083096,
                35.4404832
              ],
              [
                49.4159888,
                35.4182933
              ],
              [
                49.4571875,
                35.4072409
              ],
              [
                49.4727961,
                35.3935198
              ],
              [
                49.472796,
                35.393249
              ],
              [
                49.4892882,
                35.3905895
              ],
              [
                49.4948869,
                35.3907057
              ],
              [
                49.5136615,
                35.3917167
              ],
              [
                49.516501,
                35.3952118
              ],
              [
                49.537807,
                35.3910238
              ],
              [
                49.5427042,
                35.4027091
              ],
              [
                49.5508994,
                35.4035785
              ],
              [
                49.5581226,
                35.4052467
              ],
              [
                49.5592324,
                35.4052468
              ],
              [
                49.5675688,
                35.4080242
              ],
              [
                49.5678458,
                35.4083038
              ],
              [
                49.5686791,
                35.4083037
              ],
              [
                49.5720123,
                35.4102425
              ],
              [
                49.5778456,
                35.4171861
              ],
              [
                49.5797921,
                35.4194135
              ],
              [
                49.5859021,
                35.4235796
              ],
              [
                49.5925685,
                35.4257979
              ],
              [
                49.5959018,
                35.426907
              ],
              [
                49.5986819,
                35.4280252
              ],
              [
                49.5995152,
                35.4280252
              ],
              [
                49.6075685,
                35.4335799
              ],
              [
                49.6161815,
                35.4460781
              ],
              [
                49.6222914,
                35.4485759
              ],
              [
                49.6228485,
                35.4488555
              ],
              [
                49.6284048,
                35.4496941
              ],
              [
                49.6300716,
                35.449694
              ],
              [
                49.6303481,
                35.4499645
              ],
              [
                49.6336814,
                35.4502442
              ],
              [
                49.6364617,
                35.4502442
              ],
              [
                49.6375714,
                35.4505236
              ],
              [
                49.6403479,
                35.4505237
              ],
              [
                49.6414613,
                35.4508032
              ],
              [
                49.6439614,
                35.4508032
              ],
              [
                49.6445145,
                35.4510828
              ],
              [
                49.6478478,
                35.4510828
              ],
              [
                49.6542377,
                35.449135
              ],
              [
                49.6684045,
                35.4452395
              ],
              [
                49.6717378,
                35.4452396
              ],
              [
                49.6750745,
                35.4457986
              ],
              [
                49.6756277,
                35.4460782
              ],
              [
                49.6764609,
                35.4460782
              ],
              [
                49.6770176,
                35.4463577
              ],
              [
                49.678961,
                35.4463577
              ],
              [
                49.6789609,
                35.4466373
              ],
              [
                49.6811845,
                35.4469079
              ],
              [
                49.681461,
                35.4471964
              ],
              [
                49.6822942,
                35.4471963
              ],
              [
                49.6842407,
                35.4488555
              ],
              [
                49.6842407,
                35.449135
              ],
              [
                49.6847943,
                35.4496941
              ],
              [
                49.6856275,
                35.4519124
              ],
              [
                49.6847943,
                35.4577466
              ],
              [
                49.6842407,
                35.4596943
              ],
              [
                49.6839606,
                35.4608034
              ],
              [
                49.6922941,
                35.4696943
              ],
              [
                49.692574,
                35.4702444
              ],
              [
                49.6931307,
                35.471083
              ],
              [
                49.6942408,
                35.4774671
              ],
              [
                49.6936838,
                35.4810829
              ],
              [
                49.6925741,
                35.4838602
              ],
              [
                49.6895237,
                35.5035802
              ],
              [
                49.6856337,
                35.5094053
              ],
              [
                49.6842438,
                35.5113529
              ],
              [
                49.6842438,
                35.5116324
              ],
              [
                49.6814672,
                35.5177457
              ],
              [
                49.6820238,
                35.5230206
              ],
              [
                49.6856336,
                35.5288544
              ],
              [
                49.6911904,
                35.5316315
              ],
              [
                49.6934138,
                35.5321906
              ],
              [
                49.6945237,
                35.5321906
              ],
              [
                49.6956335,
                35.5327496
              ],
              [
                49.6975804,
                35.5330201
              ],
              [
                49.6978569,
                35.5332996
              ],
              [
                49.6989671,
                35.5332996
              ],
              [
                49.6992469,
                35.5335791
              ],
              [
                49.7042469,
                35.5335792
              ],
              [
                49.7048036,
                35.5332996
              ],
              [
                49.7073037,
                35.5332996
              ],
              [
                49.7081368,
                35.5330201
              ],
              [
                49.7095236,
                35.5330201
              ],
              [
                49.7095235,
                35.5335791
              ],
              [
                49.6875737,
                35.5552456
              ],
              [
                49.6875737,
                35.5627472
              ],
              [
                49.6872941,
                35.5630267
              ],
              [
                49.6870171,
                35.5646947
              ],
              [
                49.6867405,
                35.5674718
              ],
              [
                49.6831272,
                35.5780208
              ],
              [
                49.6828506,
                35.5796978
              ],
              [
                49.682574,
                35.5819158
              ],
              [
                49.6822939,
                35.5830338
              ],
              [
                49.6820173,
                35.5844133
              ],
              [
                49.6828505,
                35.5905263
              ],
              [
                49.6861838,
                35.5969187
              ],
              [
                49.6886838,
                35.6096943
              ],
              [
                49.6884073,
                35.6110828
              ],
              [
                49.6875735,
                35.6135892
              ],
              [
                49.6861838,
                35.6183045
              ],
              [
                49.6856271,
                35.6188635
              ],
              [
                49.6856271,
                35.6194225
              ],
              [
                49.681184,
                35.6244172
              ],
              [
                49.6670173,
                35.6310799
              ],
              [
                49.6650708,
                35.6321979
              ],
              [
                49.6614606,
                35.6330273
              ],
              [
                49.6603507,
                35.6330273
              ],
              [
                49.6597941,
                35.6333067
              ],
              [
                49.6589608,
                35.6335772
              ],
              [
                49.6584042,
                35.6335772
              ],
              [
                49.6578507,
                35.6338657
              ],
              [
                49.6542373,
                35.6338657
              ],
              [
                49.6531276,
                35.6338658
              ],
              [
                49.6470141,
                35.6338657
              ],
              [
                49.6464609,
                35.6335772
              ],
              [
                49.6461809,
                35.6338657
              ],
              [
                49.6420143,
                35.6338657
              ],
              [
                49.6417374,
                35.6335772
              ],
              [
                49.6350709,
                35.6333067
              ],
              [
                49.6322911,
                35.6335772
              ],
              [
                49.6303478,
                35.6341362
              ],
              [
                49.6236812,
                35.6377515
              ],
              [
                49.6189577,
                35.6435846
              ],
              [
                49.6189577,
                35.6441346
              ],
              [
                49.6184045,
                35.6446935
              ],
              [
                49.6178479,
                35.6463614
              ],
              [
                49.6178479,
                35.6469204
              ],
              [
                49.6153478,
                35.6560892
              ],
              [
                49.6150676,
                35.6563597
              ],
              [
                49.6147911,
                35.6580276
              ],
              [
                49.6145146,
                35.659416
              ],
              [
                49.6142344,
                35.6613633
              ],
              [
                49.6139579,
                35.6638606
              ],
              [
                49.6136813,
                35.665258
              ],
              [
                49.6134012,
                35.6669169
              ],
              [
                49.6131246,
                35.6683052
              ],
              [
                49.6128477,
                35.6694231
              ],
              [
                49.612568,
                35.671082
              ],
              [
                49.612291,
                35.6721909
              ],
              [
                49.6120144,
                35.6730293
              ],
              [
                49.6117343,
                35.6738587
              ],
              [
                49.6114577,
                35.6746971
              ],
              [
                49.6111813,
                35.675806
              ],
              [
                49.6109011,
                35.6769149
              ],
              [
                49.6103479,
                35.6785827
              ],
              [
                49.6086811,
                35.6813595
              ],
              [
                49.608401,
                35.681089
              ],
              [
                49.5995146,
                35.676915
              ],
              [
                49.597568,
                35.6766444
              ],
              [
                49.5964579,
                35.6760855
              ],
              [
                49.5956247,
                35.6760855
              ],
              [
                49.5945114,
                35.6755356
              ],
              [
                49.5936781,
                35.6755355
              ],
              [
                49.5850682,
                35.6730293
              ],
              [
                49.5839584,
                35.6730292
              ],
              [
                49.5761782,
                35.6716409
              ],
              [
                49.5689549,
                35.6716409
              ],
              [
                49.5678451,
                35.6719203
              ],
              [
                49.5647885,
                35.6721907
              ],
              [
                49.5514554,
                35.6719203
              ],
              [
                49.5511784,
                35.6721907
              ],
              [
                49.5361754,
                35.6721907
              ],
              [
                49.5356222,
                35.6724792
              ],
              [
                49.5342319,
                35.6724792
              ],
              [
                49.5331222,
                35.6721908
              ],
              [
                49.5147855,
                35.6710818
              ],
              [
                49.5133991,
                35.6713613
              ],
              [
                49.5111755,
                35.6710818
              ],
              [
                49.4997859,
                35.6780327
              ],
              [
                49.4970093,
                35.678862
              ],
              [
                49.495896,
                35.6797005
              ],
              [
                49.4947858,
                35.6855334
              ],
              [
                49.4953424,
                35.69719
              ],
              [
                49.4950623,
                35.697749
              ],
              [
                49.4947858,
                35.7002552
              ],
              [
                49.4950623,
                35.701914
              ],
              [
                49.4947857,
                35.7027524
              ],
              [
                49.4922856,
                35.713868
              ],
              [
                49.4920091,
                35.7141384
              ],
              [
                49.4903426,
                35.7166446
              ],
              [
                49.483396,
                35.7224773
              ],
              [
                49.4683961,
                35.7299776
              ],
              [
                49.4678395,
                35.7299777
              ],
              [
                49.4672862,
                35.7305276
              ],
              [
                49.4606161,
                35.7321954
              ],
              [
                49.459783,
                35.7324748
              ],
              [
                49.4578396,
                35.7324748
              ],
              [
                49.4572829,
                35.7321953
              ],
              [
                49.4522828,
                35.7321953
              ],
              [
                49.4517297,
                35.7324748
              ],
              [
                49.4497827,
                35.7324748
              ],
              [
                49.4492296,
                35.7327542
              ],
              [
                49.447283,
                35.7327543
              ],
              [
                49.4470061,
                35.7330337
              ],
              [
                49.4464495,
                35.7330337
              ],
              [
                49.4433931,
                35.7338631
              ],
              [
                49.4428396,
                35.733863
              ],
              [
                49.4425595,
                35.7341425
              ],
              [
                49.4417263,
                35.7341425
              ],
              [
                49.4411732,
                35.734422
              ],
              [
                49.4403395,
                35.7344219
              ],
              [
                49.4370063,
                35.7360897
              ],
              [
                49.4364496,
                35.7360897
              ],
              [
                49.435893,
                35.7366396
              ],
              [
                49.4247834,
                35.7391367
              ],
              [
                49.4242267,
                35.7394161
              ],
              [
                49.4228364,
                35.7394161
              ],
              [
                49.420893,
                35.739975
              ],
              [
                49.4175598,
                35.739975
              ],
              [
                49.4172832,
                35.7402545
              ],
              [
                49.4145035,
                35.7402545
              ],
              [
                49.4136698,
                35.7405339
              ],
              [
                49.4067267,
                35.7405339
              ],
              [
                49.4047802,
                35.739975
              ],
              [
                49.4033935,
                35.739975
              ],
              [
                49.4031134,
                35.7396956
              ],
              [
                49.3989469,
                35.7396956
              ],
              [
                49.3970035,
                35.7402544
              ],
              [
                49.3961703,
                35.7408044
              ],
              [
                49.3958936,
                35.7413633
              ],
              [
                49.3933936,
                35.7446987
              ],
              [
                49.3922803,
                35.7458075
              ],
              [
                49.3661672,
                35.7666403
              ],
              [
                49.3653336,
                35.7669198
              ],
              [
                49.3647805,
                35.7674787
              ],
              [
                49.3497774,
                35.7721932
              ],
              [
                49.3489438,
                35.7724817
              ],
              [
                49.3431108,
                35.7727521
              ],
              [
                49.3417241,
                35.7730316
              ],
              [
                49.3403342,
                35.7730316
              ],
              [
                49.3397775,
                35.7733111
              ],
              [
                49.3350576,
                35.773311
              ],
              [
                49.3158876,
                35.7744198
              ],
              [
                49.3150543,
                35.7746993
              ],
              [
                49.310611,
                35.7746993
              ],
              [
                49.309221,
                35.7749697
              ],
              [
                49.302278,
                35.778305
              ],
              [
                49.2825547,
                35.792755
              ],
              [
                49.2817216,
                35.795252
              ],
              [
                49.2814415,
                35.7958108
              ],
              [
                49.2811645,
                35.7977579
              ],
              [
                49.280888,
                35.7980284
              ],
              [
                49.2806079,
                35.7991371
              ],
              [
                49.2803313,
                35.8008047
              ],
              [
                49.2800547,
                35.802202
              ],
              [
                49.2789415,
                35.8058077
              ],
              [
                49.2783879,
                35.8069254
              ],
              [
                49.2781082,
                35.8077547
              ],
              [
                49.2503283,
                35.8352565
              ],
              [
                49.2478282,
                35.8383122
              ],
              [
                49.2467184,
                35.8388621
              ],
              [
                49.2411616,
                35.8483085
              ],
              [
                49.2358849,
                35.8527523
              ],
              [
                49.2114387,
                35.8633073
              ],
              [
                49.2081054,
                35.864425
              ],
              [
                49.2064386,
                35.8646954
              ],
              [
                49.2053288,
                35.8652543
              ],
              [
                49.2050486,
                35.8655337
              ],
              [
                49.2042155,
                35.8655337
              ],
              [
                49.1681025,
                35.8869228
              ],
              [
                49.1664358,
                35.8880314
              ],
              [
                49.155046,
                35.8935926
              ],
              [
                49.1514361,
                35.8944219
              ],
              [
                49.1456028,
                35.8983066
              ],
              [
                49.1431028,
                35.9069232
              ],
              [
                49.1433793,
                35.9099788
              ],
              [
                49.143936,
                35.9105375
              ],
              [
                49.1442125,
                35.9113667
              ],
              [
                49.1442125,
                35.9116462
              ],
              [
                49.1442125,
                35.9119256
              ],
              [
                49.1444894,
                35.9124844
              ],
              [
                49.1450461,
                35.9152514
              ],
              [
                49.1458793,
                35.9171983
              ],
              [
                49.1456028,
                35.9174777
              ],
              [
                49.151159,
                35.9288703
              ],
              [
                49.1517126,
                35.9299788
              ],
              [
                49.1506025,
                35.9296995
              ],
              [
                49.1475458,
                35.9296995
              ],
              [
                49.1464359,
                35.9299788
              ],
              [
                49.1411561,
                35.9299789
              ],
              [
                49.1406026,
                35.9302582
              ],
              [
                49.1378224,
                35.9302582
              ],
              [
                49.1375459,
                35.9305376
              ],
              [
                49.1358794,
                35.9305377
              ],
              [
                49.1353228,
                35.9308171
              ],
              [
                49.1314361,
                35.9313669
              ],
              [
                49.1247664,
                35.9313668
              ],
              [
                49.1244894,
                35.9316463
              ],
              [
                49.1233795,
                35.9316463
              ],
              [
                49.1230995,
                35.9319257
              ],
              [
                49.1217128,
                35.9319256
              ],
              [
                49.1208796,
                35.932205
              ],
              [
                49.1186564,
                35.9324755
              ],
              [
                49.098146,
                35.931374
              ],
              [
                49.093146,
                35.9255432
              ],
              [
                49.093423,
                35.9235965
              ],
              [
                49.0970363,
                35.916657
              ],
              [
                49.0978696,
                35.9163777
              ],
              [
                49.085423,
                35.8913526
              ],
              [
                49.0854238,
                35.8913505
              ],
              [
                49.0862743,
                35.8890786
              ],
              [
                49.085423,
                35.8782902
              ],
              [
                49.0851465,
                35.8774608
              ],
              [
                49.0839388,
                35.8760101
              ],
              [
                49.0823698,
                35.8741252
              ],
              [
                49.0807034,
                35.8732959
              ],
              [
                49.07959,
                35.872187
              ],
              [
                49.0673668,
                35.8663544
              ],
              [
                49.0665336,
                35.8663543
              ],
              [
                49.06598,
                35.866066
              ],
              [
                49.0645902,
                35.8657955
              ],
              [
                49.0623667,
                35.8657955
              ],
              [
                49.0615335,
                35.865516
              ],
              [
                49.0579236,
                35.8655161
              ],
              [
                49.0570905,
                35.8657954
              ],
              [
                49.0540338,
                35.8657954
              ],
              [
                49.0415338,
                35.8702397
              ],
              [
                49.0362536,
                35.8746841
              ],
              [
                49.0357004,
                35.8749545
              ],
              [
                49.0357005,
                35.875243
              ],
              [
                49.0307004,
                35.881905
              ],
              [
                49.0078174,
                35.9044263
              ],
              [
                48.9919843,
                35.9102579
              ],
              [
                48.9867044,
                35.9113665
              ],
              [
                48.9839278,
                35.9113665
              ],
              [
                48.9825379,
                35.9116458
              ],
              [
                48.9809245,
                35.9188716
              ],
              [
                48.978981,
                35.9188716
              ],
              [
                48.9748145,
                35.9197097
              ],
              [
                48.9609248,
                35.9238735
              ],
              [
                48.9603682,
                35.9241529
              ],
              [
                48.9600912,
                35.9244323
              ],
              [
                48.9417549,
                35.936653
              ],
              [
                48.9115106,
                35.957416
              ],
              [
                48.9008541,
                35.9714417
              ],
              [
                48.8864978,
                35.9704722
              ],
              [
                48.8676456,
                35.9603298
              ],
              [
                48.8563827,
                35.9447618
              ],
              [
                48.8450036,
                35.9344009
              ],
              [
                48.8275331,
                35.9144217
              ],
              [
                48.7872534,
                35.8872014
              ],
              [
                48.7844737,
                35.8841459
              ],
              [
                48.7816971,
                35.8794228
              ],
              [
                48.7803068,
                35.8766376
              ],
              [
                48.7747505,
                35.8449726
              ],
              [
                48.771974,
                35.8391406
              ],
              [
                48.7714173,
                35.8388611
              ],
              [
                48.7594741,
                35.827756
              ],
              [
                48.7583608,
                35.8266472
              ],
              [
                48.7583608,
                35.8263678
              ],
              [
                48.7578073,
                35.8260884
              ],
              [
                48.756694,
                35.8249707
              ],
              [
                48.7564174,
                35.8247002
              ],
              [
                48.756379,
                35.8245463
              ],
              [
                48.7561408,
                35.8235915
              ],
              [
                48.7564174,
                35.8233031
              ],
              [
                48.7528076,
                35.8060861
              ],
              [
                48.7486411,
                35.799695
              ],
              [
                48.7383609,
                35.7821982
              ],
              [
                48.7361378,
                35.7788628
              ],
              [
                48.7361379,
                35.7783039
              ],
              [
                48.7255814,
                35.7602479
              ],
              [
                48.7247478,
                35.7569124
              ],
              [
                48.7244712,
                35.7513594
              ],
              [
                48.7247478,
                35.7494213
              ],
              [
                48.7308612,
                35.7335823
              ],
              [
                48.7328047,
                35.7299764
              ],
              [
                48.7363237,
                35.7239575
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554890,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان البرز",
          "name:en": "Alborz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610748",
          "wikipedia": "en:Alborz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.0194689,
                36.1398072
              ],
              [
                50.0247914,
                36.1273735
              ],
              [
                50.0307536,
                36.1134404
              ],
              [
                50.0316641,
                36.1113125
              ],
              [
                50.0355192,
                36.1023004
              ],
              [
                50.0366903,
                36.0955751
              ],
              [
                50.0398662,
                36.0952996
              ],
              [
                50.0407667,
                36.0916712
              ],
              [
                50.0425644,
                36.0851401
              ],
              [
                50.0477568,
                36.0753091
              ],
              [
                50.0494098,
                36.0721791
              ],
              [
                50.0472416,
                36.0627473
              ],
              [
                50.0514652,
                36.0529298
              ],
              [
                50.0580068,
                36.0459371
              ],
              [
                50.064021,
                36.0462732
              ],
              [
                50.068368,
                36.0500779
              ],
              [
                50.071676,
                36.0559931
              ],
              [
                50.0729424,
                36.0612343
              ],
              [
                50.0647983,
                36.070881
              ],
              [
                50.0604466,
                36.0828893
              ],
              [
                50.0628564,
                36.0878592
              ],
              [
                50.068375,
                36.0894164
              ],
              [
                50.0735772,
                36.087863
              ],
              [
                50.0891715,
                36.0822082
              ],
              [
                50.0948544,
                36.0816546
              ],
              [
                50.0971564,
                36.097219
              ],
              [
                50.1028236,
                36.102111
              ],
              [
                50.1024474,
                36.105547
              ],
              [
                50.1013362,
                36.1156938
              ],
              [
                50.1403163,
                36.1184985
              ],
              [
                50.1566756,
                36.1333579
              ],
              [
                50.1465405,
                36.1357145
              ],
              [
                50.1443052,
                36.1363844
              ],
              [
                50.13717,
                36.1374732
              ],
              [
                50.1295423,
                36.139573
              ],
              [
                50.1254653,
                36.1414792
              ],
              [
                50.1041209,
                36.143744
              ],
              [
                50.1051161,
                36.1458812
              ],
              [
                50.1126765,
                36.1507667
              ],
              [
                50.1334047,
                36.1590829
              ],
              [
                50.1408366,
                36.1612856
              ],
              [
                50.1641192,
                36.1692151
              ],
              [
                50.1663999,
                36.1720335
              ],
              [
                50.1697111,
                36.1720752
              ],
              [
                50.1722431,
                36.171798
              ],
              [
                50.174818,
                36.1701005
              ],
              [
                50.1809856,
                36.1641154
              ],
              [
                50.1853479,
                36.1605452
              ],
              [
                50.1921758,
                36.1552836
              ],
              [
                50.2041239,
                36.1476217
              ],
              [
                50.2136647,
                36.1425267
              ],
              [
                50.2202266,
                36.13893
              ],
              [
                50.2241308,
                36.1379809
              ],
              [
                50.2254152,
                36.1404741
              ],
              [
                50.2254503,
                36.1462705
              ],
              [
                50.2248573,
                36.1504201
              ],
              [
                50.2250346,
                36.1572585
              ],
              [
                50.2257418,
                36.1659534
              ],
              [
                50.2259116,
                36.1761806
              ],
              [
                50.2365243,
                36.1837534
              ],
              [
                50.2394402,
                36.1896064
              ],
              [
                50.2449965,
                36.1971076
              ],
              [
                50.2436025,
                36.2056282
              ],
              [
                50.2446031,
                36.2100405
              ],
              [
                50.2505615,
                36.2175775
              ],
              [
                50.2669032,
                36.234375
              ],
              [
                50.2790402,
                36.247196
              ],
              [
                50.283737,
                36.2482881
              ],
              [
                50.290235,
                36.255301
              ],
              [
                50.3055355,
                36.2633647
              ],
              [
                50.3129194,
                36.2680823
              ],
              [
                50.3173796,
                36.273038
              ],
              [
                50.3220175,
                36.2791538
              ],
              [
                50.330298,
                36.2851041
              ],
              [
                50.3370926,
                36.2966961
              ],
              [
                50.3493117,
                36.3059956
              ],
              [
                50.3754042,
                36.3188598
              ],
              [
                50.3824423,
                36.3207962
              ],
              [
                50.3946303,
                36.3173384
              ],
              [
                50.4002951,
                36.3185832
              ],
              [
                50.4047583,
                36.3284029
              ],
              [
                50.412998,
                36.3290943
              ],
              [
                50.420648,
                36.3328042
              ],
              [
                50.4080198,
                36.3412634
              ],
              [
                50.3991458,
                36.3505357
              ],
              [
                50.4263753,
                36.3721887
              ],
              [
                50.4240434,
                36.3772626
              ],
              [
                50.4171984,
                36.3817226
              ],
              [
                50.4126338,
                36.3823304
              ],
              [
                50.4076012,
                36.3868399
              ],
              [
                50.4034249,
                36.3837927
              ],
              [
                50.3981562,
                36.3740995
              ],
              [
                50.3875161,
                36.3681759
              ],
              [
                50.3812365,
                36.3755514
              ],
              [
                50.3743437,
                36.3790635
              ],
              [
                50.3681342,
                36.3767485
              ],
              [
                50.3616188,
                36.3794412
              ],
              [
                50.3520554,
                36.36963
              ],
              [
                50.347273,
                36.368272
              ],
              [
                50.3365606,
                36.3501075
              ],
              [
                50.3298733,
                36.3486834
              ],
              [
                50.330298,
                36.3465347
              ],
              [
                50.315301,
                36.3503838
              ],
              [
                50.2993684,
                36.3490535
              ],
              [
                50.2916201,
                36.3402163
              ],
              [
                50.2905438,
                36.3251858
              ],
              [
                50.2804308,
                36.3086576
              ],
              [
                50.2583352,
                36.2924604
              ],
              [
                50.2489691,
                36.290607
              ],
              [
                50.2455522,
                36.2942003
              ],
              [
                50.2450305,
                36.2976562
              ],
              [
                50.2443094,
                36.3024328
              ],
              [
                50.2363265,
                36.3042135
              ],
              [
                50.2219787,
                36.3060415
              ],
              [
                50.2091193,
                36.2930841
              ],
              [
                50.2074162,
                36.2930445
              ],
              [
                50.2050072,
                36.28777
              ],
              [
                50.1955743,
                36.2755806
              ],
              [
                50.1870825,
                36.2659303
              ],
              [
                50.1813622,
                36.2620908
              ],
              [
                50.1739865,
                36.2615008
              ],
              [
                50.1711686,
                36.261973
              ],
              [
                50.1574151,
                36.2572284
              ],
              [
                50.1536114,
                36.2511318
              ],
              [
                50.1486053,
                36.2465781
              ],
              [
                50.1491639,
                36.2452654
              ],
              [
                50.1515006,
                36.2443281
              ],
              [
                50.1554368,
                36.2460709
              ],
              [
                50.1554025,
                36.2333992
              ],
              [
                50.1549628,
                36.2313868
              ],
              [
                50.1545855,
                36.2286808
              ],
              [
                50.1540342,
                36.2224155
              ],
              [
                50.1519895,
                36.2229371
              ],
              [
                50.1492291,
                36.2236411
              ],
              [
                50.1266905,
                36.2293874
              ],
              [
                50.1231602,
                36.2302753
              ],
              [
                50.1192477,
                36.2312839
              ],
              [
                50.1175929,
                36.2317055
              ],
              [
                50.1127931,
                36.2316655
              ],
              [
                50.1042845,
                36.2307842
              ],
              [
                50.0793338,
                36.238176
              ],
              [
                50.0691845,
                36.2242215
              ],
              [
                50.0510106,
                36.2223243
              ],
              [
                50.0480765,
                36.2224601
              ],
              [
                50.0401491,
                36.222827
              ],
              [
                50.0018125,
                36.2245938
              ],
              [
                50.0032062,
                36.1995081
              ],
              [
                50.0046365,
                36.1737457
              ],
              [
                50.0082443,
                36.1646894
              ],
              [
                50.0148953,
                36.1504883
              ],
              [
                50.0194689,
                36.1398072
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554949,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بوئین زهرا",
          "name:en": "Buin Zahra County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291828",
          "wikipedia": "en:Buin Zahra County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.6086811,
                35.6813595
              ],
              [
                49.6103479,
                35.6785827
              ],
              [
                49.6109011,
                35.6769149
              ],
              [
                49.6111813,
                35.675806
              ],
              [
                49.6114577,
                35.6746971
              ],
              [
                49.6117343,
                35.6738587
              ],
              [
                49.6120144,
                35.6730293
              ],
              [
                49.612291,
                35.6721909
              ],
              [
                49.612568,
                35.671082
              ],
              [
                49.6128477,
                35.6694231
              ],
              [
                49.6131246,
                35.6683052
              ],
              [
                49.6134012,
                35.6669169
              ],
              [
                49.6136813,
                35.665258
              ],
              [
                49.6139579,
                35.6638606
              ],
              [
                49.6142344,
                35.6613633
              ],
              [
                49.6145146,
                35.659416
              ],
              [
                49.6147911,
                35.6580276
              ],
              [
                49.6150676,
                35.6563597
              ],
              [
                49.6153478,
                35.6560892
              ],
              [
                49.6178479,
                35.6469204
              ],
              [
                49.6178479,
                35.6463614
              ],
              [
                49.6184045,
                35.6446935
              ],
              [
                49.6189577,
                35.6441346
              ],
              [
                49.6189577,
                35.6435846
              ],
              [
                49.6236812,
                35.6377515
              ],
              [
                49.6303478,
                35.6341362
              ],
              [
                49.6322911,
                35.6335772
              ],
              [
                49.6350709,
                35.6333067
              ],
              [
                49.6417374,
                35.6335772
              ],
              [
                49.6420143,
                35.6338657
              ],
              [
                49.6461809,
                35.6338657
              ],
              [
                49.6464609,
                35.6335772
              ],
              [
                49.6470141,
                35.6338657
              ],
              [
                49.6531276,
                35.6338658
              ],
              [
                49.6542373,
                35.6338657
              ],
              [
                49.6578507,
                35.6338657
              ],
              [
                49.6584042,
                35.6335772
              ],
              [
                49.6589608,
                35.6335772
              ],
              [
                49.6597941,
                35.6333067
              ],
              [
                49.6603507,
                35.6330273
              ],
              [
                49.6614606,
                35.6330273
              ],
              [
                49.6650708,
                35.6321979
              ],
              [
                49.6670173,
                35.6310799
              ],
              [
                49.681184,
                35.6244172
              ],
              [
                49.6856271,
                35.6194225
              ],
              [
                49.6856271,
                35.6188635
              ],
              [
                49.6861838,
                35.6183045
              ],
              [
                49.6875735,
                35.6135892
              ],
              [
                49.6884073,
                35.6110828
              ],
              [
                49.6886838,
                35.6096943
              ],
              [
                49.6861838,
                35.5969187
              ],
              [
                49.6828505,
                35.5905263
              ],
              [
                49.6820173,
                35.5844133
              ],
              [
                49.6822939,
                35.5830338
              ],
              [
                49.682574,
                35.5819158
              ],
              [
                49.6828506,
                35.5796978
              ],
              [
                49.6831272,
                35.5780208
              ],
              [
                49.6867405,
                35.5674718
              ],
              [
                49.6870171,
                35.5646947
              ],
              [
                49.6872941,
                35.5630267
              ],
              [
                49.6875737,
                35.5627472
              ],
              [
                49.6875737,
                35.5552456
              ],
              [
                49.7095235,
                35.5335791
              ],
              [
                49.7095236,
                35.5330201
              ],
              [
                49.7100802,
                35.5332996
              ],
              [
                49.7106369,
                35.5335791
              ],
              [
                49.71119,
                35.5335791
              ],
              [
                49.7114702,
                35.5332996
              ],
              [
                49.7128569,
                35.5332996
              ],
              [
                49.7153568,
                35.5332996
              ],
              [
                49.7156366,
                35.5335792
              ],
              [
                49.7170233,
                35.5335792
              ],
              [
                49.7173035,
                35.5338586
              ],
              [
                49.7236935,
                35.5338587
              ],
              [
                49.72397,
                35.5341381
              ],
              [
                49.7245266,
                35.5338587
              ],
              [
                49.7259133,
                35.5338587
              ],
              [
                49.7395265,
                35.5280249
              ],
              [
                49.7400797,
                35.5274658
              ],
              [
                49.7445263,
                35.5257978
              ],
              [
                49.754803,
                35.5241388
              ],
              [
                49.7617497,
                35.5235797
              ],
              [
                49.7625829,
                35.5233003
              ],
              [
                49.7636927,
                35.5233002
              ],
              [
                49.7645264,
                35.5230208
              ],
              [
                49.7684162,
                35.5230207
              ],
              [
                49.7781395,
                35.5221911
              ],
              [
                49.7814728,
                35.5213616
              ],
              [
                49.7814488,
                35.512829
              ],
              [
                49.8006299,
                35.5081479
              ],
              [
                49.8051985,
                35.5137983
              ],
              [
                49.8176168,
                35.5206887
              ],
              [
                49.8399051,
                35.5296681
              ],
              [
                49.8599052,
                35.5388295
              ],
              [
                49.8711917,
                35.5466352
              ],
              [
                49.8725816,
                35.5469147
              ],
              [
                49.8803583,
                35.5469146
              ],
              [
                49.8906383,
                35.5449761
              ],
              [
                49.9023048,
                35.540522
              ],
              [
                49.9034182,
                35.5399719
              ],
              [
                49.9039714,
                35.5396924
              ],
              [
                49.9042514,
                35.539413
              ],
              [
                49.904528,
                35.5385834
              ],
              [
                49.9192514,
                35.5221913
              ],
              [
                49.9211944,
                35.5208027
              ],
              [
                49.9253613,
                35.5191345
              ],
              [
                49.9723072,
                35.5060874
              ],
              [
                49.9817539,
                35.5044103
              ],
              [
                49.9839774,
                35.5044103
              ],
              [
                49.9881439,
                35.5038602
              ],
              [
                49.990644,
                35.5038603
              ],
              [
                49.9923104,
                35.5035807
              ],
              [
                50.0042535,
                35.5035807
              ],
              [
                50.0053669,
                35.5038602
              ],
              [
                50.0092537,
                35.5038602
              ],
              [
                50.0103671,
                35.5041398
              ],
              [
                50.0137003,
                35.5041398
              ],
              [
                50.0148101,
                35.5044102
              ],
              [
                50.0198102,
                35.5044103
              ],
              [
                50.0209235,
                35.5044103
              ],
              [
                50.0214765,
                35.5046898
              ],
              [
                50.0242567,
                35.5046898
              ],
              [
                50.0253666,
                35.5049694
              ],
              [
                50.0292568,
                35.5049694
              ],
              [
                50.02981,
                35.5052488
              ],
              [
                50.0353668,
                35.505249
              ],
              [
                50.0359234,
                35.5055284
              ],
              [
                50.0431466,
                35.5055284
              ],
              [
                50.0550899,
                35.506358
              ],
              [
                50.068703,
                35.5077466
              ],
              [
                50.1017591,
                35.51386
              ],
              [
                50.1264823,
                35.5171872
              ],
              [
                50.127039,
                35.5174668
              ],
              [
                50.1295386,
                35.5174668
              ],
              [
                50.1306489,
                35.5177463
              ],
              [
                50.1342622,
                35.5180258
              ],
              [
                50.1356486,
                35.5180258
              ],
              [
                50.1364821,
                35.5183054
              ],
              [
                50.1462053,
                35.5183053
              ],
              [
                50.1467621,
                35.5185849
              ],
              [
                50.1500954,
                35.5185848
              ],
              [
                50.1778749,
                35.5221916
              ],
              [
                50.2019068,
                35.5271473
              ],
              [
                50.2027175,
                35.5340377
              ],
              [
                50.2032222,
                35.535874
              ],
              [
                50.2090306,
                35.5707473
              ],
              [
                50.2059774,
                35.5732452
              ],
              [
                50.1678749,
                35.5963603
              ],
              [
                50.1648181,
                35.6027528
              ],
              [
                50.1645415,
                35.6033117
              ],
              [
                50.1631517,
                35.6105336
              ],
              [
                50.1631547,
                35.6105736
              ],
              [
                50.1634282,
                35.6141399
              ],
              [
                50.1650946,
                35.6191346
              ],
              [
                50.168708,
                35.6241385
              ],
              [
                50.1792614,
                35.6285833
              ],
              [
                50.1834313,
                35.6294218
              ],
              [
                50.1937077,
                35.6310807
              ],
              [
                50.1939843,
                35.6313692
              ],
              [
                50.2000977,
                35.6313692
              ],
              [
                50.2034309,
                35.6316396
              ],
              [
                50.2045412,
                35.6319191
              ],
              [
                50.2053744,
                35.6319192
              ],
              [
                50.2056544,
                35.6321987
              ],
              [
                50.2078744,
                35.6321986
              ],
              [
                50.2098209,
                35.632469
              ],
              [
                50.2106542,
                35.6327486
              ],
              [
                50.212321,
                35.6327487
              ],
              [
                50.2128741,
                35.6330281
              ],
              [
                50.2139875,
                35.6330282
              ],
              [
                50.2264873,
                35.6363639
              ],
              [
                50.2273209,
                35.6363639
              ],
              [
                50.2384305,
                35.6410792
              ],
              [
                50.2403774,
                35.6427562
              ],
              [
                50.2417673,
                35.644424
              ],
              [
                50.2437107,
                35.6477508
              ],
              [
                50.2445439,
                35.6741391
              ],
              [
                50.2445387,
                35.6741496
              ],
              [
                50.2442673,
                35.6746981
              ],
              [
                50.2437106,
                35.6816399
              ],
              [
                50.243712,
                35.6816555
              ],
              [
                50.2439872,
                35.6846961
              ],
              [
                50.2439795,
                35.6847194
              ],
              [
                50.2437106,
                35.6855345
              ],
              [
                50.2434336,
                35.6891406
              ],
              [
                50.2434347,
                35.689158
              ],
              [
                50.2434336,
                35.6985886
              ],
              [
                50.2437105,
                35.7163664
              ],
              [
                50.2459336,
                35.7277522
              ],
              [
                50.252063,
                35.7535238
              ],
              [
                50.2531496,
                35.7793684
              ],
              [
                50.2627943,
                35.7837027
              ],
              [
                50.2761837,
                35.7791072
              ],
              [
                50.2857968,
                35.7841206
              ],
              [
                50.2847668,
                35.8013865
              ],
              [
                50.2918249,
                35.819517
              ],
              [
                50.2970462,
                35.8224764
              ],
              [
                50.3151029,
                35.8421989
              ],
              [
                50.3151028,
                35.8424783
              ],
              [
                50.3150997,
                35.8424813
              ],
              [
                50.3045459,
                35.852754
              ],
              [
                50.3037127,
                35.8538717
              ],
              [
                50.3034361,
                35.8541421
              ],
              [
                50.2981559,
                35.8608122
              ],
              [
                50.2650997,
                35.8888714
              ],
              [
                50.264543,
                35.8891508
              ],
              [
                50.2576,
                35.8958117
              ],
              [
                50.2573198,
                35.8963705
              ],
              [
                50.2567668,
                35.8966499
              ],
              [
                50.2564866,
                35.8971997
              ],
              [
                50.2451,
                35.9094217
              ],
              [
                50.2256535,
                35.9263754
              ],
              [
                50.2250968,
                35.9269251
              ],
              [
                50.208987,
                35.9383176
              ],
              [
                50.1792606,
                35.9533149
              ],
              [
                50.1712073,
                35.9605341
              ],
              [
                50.1706506,
                35.9610929
              ],
              [
                50.1539842,
                35.9730347
              ],
              [
                50.1539842,
                35.9733141
              ],
              [
                50.153151,
                35.973314
              ],
              [
                50.1264813,
                35.9902576
              ],
              [
                50.1193043,
                35.9997268
              ],
              [
                50.1026103,
                36.0002042
              ],
              [
                50.0897037,
                36.0190109
              ],
              [
                50.068368,
                36.0500779
              ],
              [
                50.064021,
                36.0462732
              ],
              [
                50.0580068,
                36.0459371
              ],
              [
                50.0514652,
                36.0529298
              ],
              [
                50.0472416,
                36.0627473
              ],
              [
                50.0494098,
                36.0721791
              ],
              [
                50.0477568,
                36.0753091
              ],
              [
                50.0425644,
                36.0851401
              ],
              [
                50.0407667,
                36.0916712
              ],
              [
                50.0398662,
                36.0952996
              ],
              [
                50.0366903,
                36.0955751
              ],
              [
                50.0235632,
                36.097206
              ],
              [
                50.0158561,
                36.0981629
              ],
              [
                49.981871,
                36.1108134
              ],
              [
                49.9643961,
                36.1173132
              ],
              [
                49.9508804,
                36.1273814
              ],
              [
                49.9386227,
                36.1365092
              ],
              [
                49.9300112,
                36.1429199
              ],
              [
                49.9248132,
                36.143202
              ],
              [
                49.9064498,
                36.1517983
              ],
              [
                49.8965311,
                36.1579716
              ],
              [
                49.8783823,
                36.1660449
              ],
              [
                49.8638817,
                36.17207
              ],
              [
                49.8591204,
                36.1790925
              ],
              [
                49.8581338,
                36.1785974
              ],
              [
                49.8368373,
                36.16548
              ],
              [
                49.819346,
                36.1588104
              ],
              [
                49.7992644,
                36.156554
              ],
              [
                49.7924494,
                36.1582614
              ],
              [
                49.7901568,
                36.1565799
              ],
              [
                49.7894782,
                36.1462729
              ],
              [
                49.7873669,
                36.1424708
              ],
              [
                49.7840257,
                36.1364532
              ],
              [
                49.77347,
                36.1281245
              ],
              [
                49.7720215,
                36.1272086
              ],
              [
                49.767277,
                36.1245119
              ],
              [
                49.7644167,
                36.1228861
              ],
              [
                49.7597985,
                36.1202611
              ],
              [
                49.7600751,
                36.1191527
              ],
              [
                49.7603517,
                36.1188734
              ],
              [
                49.766185,
                36.1091502
              ],
              [
                49.7720215,
                36.1013735
              ],
              [
                49.7742415,
                36.0985981
              ],
              [
                49.7778755,
                36.0942641
              ],
              [
                49.7814647,
                36.0899832
              ],
              [
                49.7965763,
                36.0827589
              ],
              [
                49.8036001,
                36.0724124
              ],
              [
                49.7863918,
                36.0591473
              ],
              [
                49.7978268,
                36.0481906
              ],
              [
                49.8009113,
                36.03749
              ],
              [
                49.7995215,
                36.0349846
              ],
              [
                49.7906315,
                36.018042
              ],
              [
                49.7911881,
                36.0169244
              ],
              [
                49.7917448,
                36.0163747
              ],
              [
                49.8059115,
                36.0102644
              ],
              [
                49.8067447,
                36.0102645
              ],
              [
                49.8311913,
                35.9994317
              ],
              [
                49.8234384,
                35.9856096
              ],
              [
                49.8183222,
                35.971244
              ],
              [
                49.818135,
                35.9708171
              ],
              [
                49.8178548,
                35.9666532
              ],
              [
                49.8181349,
                35.9641477
              ],
              [
                49.818135,
                35.9633095
              ],
              [
                49.8178549,
                35.960813
              ],
              [
                49.818135,
                35.9588752
              ],
              [
                49.8184116,
                35.9580371
              ],
              [
                49.818688,
                35.9577577
              ],
              [
                49.8186881,
                35.9571989
              ],
              [
                49.8214683,
                35.9474831
              ],
              [
                49.8217448,
                35.9469243
              ],
              [
                49.8192448,
                35.9366406
              ],
              [
                49.818135,
                35.9355409
              ],
              [
                49.8173013,
                35.9355409
              ],
              [
                49.8164682,
                35.9352526
              ],
              [
                49.8125783,
                35.9335942
              ],
              [
                49.8111884,
                35.9338646
              ],
              [
                49.809245,
                35.9338646
              ],
              [
                49.7964649,
                35.9385873
              ],
              [
                49.7947985,
                35.9385874
              ],
              [
                49.7945215,
                35.9388667
              ],
              [
                49.7931317,
                35.9388667
              ],
              [
                49.7928551,
                35.9391462
              ],
              [
                49.7906316,
                35.9391461
              ],
              [
                49.7906316,
                35.9388667
              ],
              [
                49.7900786,
                35.9388668
              ],
              [
                49.7853554,
                35.9363702
              ],
              [
                49.7778552,
                35.9302593
              ],
              [
                49.7772985,
                35.9297005
              ],
              [
                49.7486856,
                35.9091506
              ],
              [
                49.748409,
                35.9091506
              ],
              [
                49.7481289,
                35.9088712
              ],
              [
                49.7459089,
                35.9074741
              ],
              [
                49.7453523,
                35.9066449
              ],
              [
                49.7303527,
                35.8966491
              ],
              [
                49.729239,
                35.8963696
              ],
              [
                49.7108239,
                35.8923633
              ],
              [
                49.6942289,
                35.8952647
              ],
              [
                49.6786833,
                35.8755305
              ],
              [
                49.6722934,
                35.8644258
              ],
              [
                49.6720168,
                35.8630377
              ],
              [
                49.6720168,
                35.8604556
              ],
              [
                49.6675611,
                35.8517166
              ],
              [
                49.6665814,
                35.8453079
              ],
              [
                49.6644073,
                35.8367323
              ],
              [
                49.6588447,
                35.8307002
              ],
              [
                49.658459,
                35.812671
              ],
              [
                49.6584579,
                35.8126219
              ],
              [
                49.6512149,
                35.8012167
              ],
              [
                49.6375706,
                35.7852557
              ],
              [
                49.637294,
                35.7846968
              ],
              [
                49.6336807,
                35.7788645
              ],
              [
                49.633124,
                35.776088
              ],
              [
                49.6325709,
                35.7708145
              ],
              [
                49.632571,
                35.7638643
              ],
              [
                49.6334042,
                35.7538671
              ],
              [
                49.6336807,
                35.7499818
              ],
              [
                49.6339573,
                35.7466463
              ],
              [
                49.6342374,
                35.745249
              ],
              [
                49.6356242,
                35.7371988
              ],
              [
                49.6359043,
                35.7363605
              ],
              [
                49.6359042,
                35.7349722
              ],
              [
                49.6359043,
                35.732475
              ],
              [
                49.6361808,
                35.7319251
              ],
              [
                49.6359043,
                35.7313662
              ],
              [
                49.6361808,
                35.7291486
              ],
              [
                49.636461,
                35.7283102
              ],
              [
                49.6361808,
                35.7224776
              ],
              [
                49.630071,
                35.703582
              ],
              [
                49.6197911,
                35.6899781
              ],
              [
                49.6111812,
                35.6827569
              ],
              [
                49.6100679,
                35.6821979
              ],
              [
                49.6095144,
                35.6819184
              ],
              [
                49.6092347,
                35.6816389
              ],
              [
                49.6086811,
                35.6813595
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554959,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تاکستان",
          "name:en": "Takestan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291817",
          "wikipedia": "en:Takestan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.1444894,
                35.9124844
              ],
              [
                49.1442125,
                35.9119256
              ],
              [
                49.1442125,
                35.9116462
              ],
              [
                49.1442125,
                35.9113667
              ],
              [
                49.143936,
                35.9105375
              ],
              [
                49.1433793,
                35.9099788
              ],
              [
                49.1431028,
                35.9069232
              ],
              [
                49.1456028,
                35.8983066
              ],
              [
                49.1514361,
                35.8944219
              ],
              [
                49.155046,
                35.8935926
              ],
              [
                49.1664358,
                35.8880314
              ],
              [
                49.1681025,
                35.8869228
              ],
              [
                49.2042155,
                35.8655337
              ],
              [
                49.2050486,
                35.8655337
              ],
              [
                49.2053288,
                35.8652543
              ],
              [
                49.2064386,
                35.8646954
              ],
              [
                49.2081054,
                35.864425
              ],
              [
                49.2114387,
                35.8633073
              ],
              [
                49.2358849,
                35.8527523
              ],
              [
                49.2411616,
                35.8483085
              ],
              [
                49.2467184,
                35.8388621
              ],
              [
                49.2478282,
                35.8383122
              ],
              [
                49.2503283,
                35.8352565
              ],
              [
                49.2781082,
                35.8077547
              ],
              [
                49.2783879,
                35.8069254
              ],
              [
                49.2789415,
                35.8058077
              ],
              [
                49.2800547,
                35.802202
              ],
              [
                49.2803313,
                35.8008047
              ],
              [
                49.2806079,
                35.7991371
              ],
              [
                49.280888,
                35.7980284
              ],
              [
                49.2811645,
                35.7977579
              ],
              [
                49.2814415,
                35.7958108
              ],
              [
                49.2817216,
                35.795252
              ],
              [
                49.2825547,
                35.792755
              ],
              [
                49.302278,
                35.778305
              ],
              [
                49.309221,
                35.7749697
              ],
              [
                49.310611,
                35.7746993
              ],
              [
                49.3150543,
                35.7746993
              ],
              [
                49.3158876,
                35.7744198
              ],
              [
                49.3350576,
                35.773311
              ],
              [
                49.3397775,
                35.7733111
              ],
              [
                49.3403342,
                35.7730316
              ],
              [
                49.3417241,
                35.7730316
              ],
              [
                49.3431108,
                35.7727521
              ],
              [
                49.3489438,
                35.7724817
              ],
              [
                49.3497774,
                35.7721932
              ],
              [
                49.3647805,
                35.7674787
              ],
              [
                49.3653336,
                35.7669198
              ],
              [
                49.3661672,
                35.7666403
              ],
              [
                49.3922803,
                35.7458075
              ],
              [
                49.3933936,
                35.7446987
              ],
              [
                49.3958936,
                35.7413633
              ],
              [
                49.3961703,
                35.7408044
              ],
              [
                49.3970035,
                35.7402544
              ],
              [
                49.3989469,
                35.7396956
              ],
              [
                49.4031134,
                35.7396956
              ],
              [
                49.4033935,
                35.739975
              ],
              [
                49.4047802,
                35.739975
              ],
              [
                49.4067267,
                35.7405339
              ],
              [
                49.4136698,
                35.7405339
              ],
              [
                49.4145035,
                35.7402545
              ],
              [
                49.4172832,
                35.7402545
              ],
              [
                49.4175598,
                35.739975
              ],
              [
                49.420893,
                35.739975
              ],
              [
                49.4228364,
                35.7394161
              ],
              [
                49.4242267,
                35.7394161
              ],
              [
                49.4247834,
                35.7391367
              ],
              [
                49.435893,
                35.7366396
              ],
              [
                49.4364496,
                35.7360897
              ],
              [
                49.4370063,
                35.7360897
              ],
              [
                49.4403395,
                35.7344219
              ],
              [
                49.4411732,
                35.734422
              ],
              [
                49.4417263,
                35.7341425
              ],
              [
                49.4425595,
                35.7341425
              ],
              [
                49.4428396,
                35.733863
              ],
              [
                49.4433931,
                35.7338631
              ],
              [
                49.4464495,
                35.7330337
              ],
              [
                49.4470061,
                35.7330337
              ],
              [
                49.447283,
                35.7327543
              ],
              [
                49.4492296,
                35.7327542
              ],
              [
                49.4497827,
                35.7324748
              ],
              [
                49.4517297,
                35.7324748
              ],
              [
                49.4522828,
                35.7321953
              ],
              [
                49.4572829,
                35.7321953
              ],
              [
                49.4578396,
                35.7324748
              ],
              [
                49.459783,
                35.7324748
              ],
              [
                49.4606161,
                35.7321954
              ],
              [
                49.4672862,
                35.7305276
              ],
              [
                49.4678395,
                35.7299777
              ],
              [
                49.4683961,
                35.7299776
              ],
              [
                49.483396,
                35.7224773
              ],
              [
                49.4903426,
                35.7166446
              ],
              [
                49.4920091,
                35.7141384
              ],
              [
                49.4922856,
                35.713868
              ],
              [
                49.4947857,
                35.7027524
              ],
              [
                49.4950623,
                35.701914
              ],
              [
                49.4947858,
                35.7002552
              ],
              [
                49.4950623,
                35.697749
              ],
              [
                49.4953424,
                35.69719
              ],
              [
                49.4947858,
                35.6855334
              ],
              [
                49.495896,
                35.6797005
              ],
              [
                49.4970093,
                35.678862
              ],
              [
                49.4997859,
                35.6780327
              ],
              [
                49.5111755,
                35.6710818
              ],
              [
                49.5133991,
                35.6713613
              ],
              [
                49.5147855,
                35.6710818
              ],
              [
                49.5331222,
                35.6721908
              ],
              [
                49.5342319,
                35.6724792
              ],
              [
                49.5356222,
                35.6724792
              ],
              [
                49.5361754,
                35.6721907
              ],
              [
                49.5511784,
                35.6721907
              ],
              [
                49.5514554,
                35.6719203
              ],
              [
                49.5647885,
                35.6721907
              ],
              [
                49.5678451,
                35.6719203
              ],
              [
                49.5689549,
                35.6716409
              ],
              [
                49.5761782,
                35.6716409
              ],
              [
                49.5839584,
                35.6730292
              ],
              [
                49.5850682,
                35.6730293
              ],
              [
                49.5936781,
                35.6755355
              ],
              [
                49.5945114,
                35.6755356
              ],
              [
                49.5956247,
                35.6760855
              ],
              [
                49.5964579,
                35.6760855
              ],
              [
                49.597568,
                35.6766444
              ],
              [
                49.5995146,
                35.676915
              ],
              [
                49.608401,
                35.681089
              ],
              [
                49.6086811,
                35.6813595
              ],
              [
                49.6092347,
                35.6816389
              ],
              [
                49.6095144,
                35.6819184
              ],
              [
                49.6100679,
                35.6821979
              ],
              [
                49.6111812,
                35.6827569
              ],
              [
                49.6197911,
                35.6899781
              ],
              [
                49.630071,
                35.703582
              ],
              [
                49.6361808,
                35.7224776
              ],
              [
                49.636461,
                35.7283102
              ],
              [
                49.6361808,
                35.7291486
              ],
              [
                49.6359043,
                35.7313662
              ],
              [
                49.6361808,
                35.7319251
              ],
              [
                49.6359043,
                35.732475
              ],
              [
                49.6359042,
                35.7349722
              ],
              [
                49.6359043,
                35.7363605
              ],
              [
                49.6356242,
                35.7371988
              ],
              [
                49.6342374,
                35.745249
              ],
              [
                49.6339573,
                35.7466463
              ],
              [
                49.6336807,
                35.7499818
              ],
              [
                49.6334042,
                35.7538671
              ],
              [
                49.632571,
                35.7638643
              ],
              [
                49.6325709,
                35.7708145
              ],
              [
                49.633124,
                35.776088
              ],
              [
                49.6336807,
                35.7788645
              ],
              [
                49.637294,
                35.7846968
              ],
              [
                49.6375706,
                35.7852557
              ],
              [
                49.6512149,
                35.8012167
              ],
              [
                49.6584579,
                35.8126219
              ],
              [
                49.658459,
                35.812671
              ],
              [
                49.6588447,
                35.8307002
              ],
              [
                49.6644073,
                35.8367323
              ],
              [
                49.6665814,
                35.8453079
              ],
              [
                49.6675611,
                35.8517166
              ],
              [
                49.6720168,
                35.8604556
              ],
              [
                49.6720168,
                35.8630377
              ],
              [
                49.6722934,
                35.8644258
              ],
              [
                49.6786833,
                35.8755305
              ],
              [
                49.6942289,
                35.8952647
              ],
              [
                49.7108239,
                35.8923633
              ],
              [
                49.729239,
                35.8963696
              ],
              [
                49.7303527,
                35.8966491
              ],
              [
                49.7453523,
                35.9066449
              ],
              [
                49.7459089,
                35.9074741
              ],
              [
                49.7481289,
                35.9088712
              ],
              [
                49.748409,
                35.9091506
              ],
              [
                49.7486856,
                35.9091506
              ],
              [
                49.7772985,
                35.9297005
              ],
              [
                49.7778552,
                35.9302593
              ],
              [
                49.7853554,
                35.9363702
              ],
              [
                49.7900786,
                35.9388668
              ],
              [
                49.7906316,
                35.9388667
              ],
              [
                49.7906316,
                35.9391461
              ],
              [
                49.7928551,
                35.9391462
              ],
              [
                49.7931317,
                35.9388667
              ],
              [
                49.7945215,
                35.9388667
              ],
              [
                49.7947985,
                35.9385874
              ],
              [
                49.7964649,
                35.9385873
              ],
              [
                49.809245,
                35.9338646
              ],
              [
                49.8111884,
                35.9338646
              ],
              [
                49.8125783,
                35.9335942
              ],
              [
                49.8164682,
                35.9352526
              ],
              [
                49.8173013,
                35.9355409
              ],
              [
                49.818135,
                35.9355409
              ],
              [
                49.8192448,
                35.9366406
              ],
              [
                49.8217448,
                35.9469243
              ],
              [
                49.8214683,
                35.9474831
              ],
              [
                49.8186881,
                35.9571989
              ],
              [
                49.818688,
                35.9577577
              ],
              [
                49.8184116,
                35.9580371
              ],
              [
                49.818135,
                35.9588752
              ],
              [
                49.8178549,
                35.960813
              ],
              [
                49.818135,
                35.9633095
              ],
              [
                49.8181349,
                35.9641477
              ],
              [
                49.8178548,
                35.9666532
              ],
              [
                49.818135,
                35.9708171
              ],
              [
                49.8183222,
                35.971244
              ],
              [
                49.8234384,
                35.9856096
              ],
              [
                49.8311913,
                35.9994317
              ],
              [
                49.8067447,
                36.0102645
              ],
              [
                49.8059115,
                36.0102644
              ],
              [
                49.7917448,
                36.0163747
              ],
              [
                49.7911881,
                36.0169244
              ],
              [
                49.7906315,
                36.018042
              ],
              [
                49.7995215,
                36.0349846
              ],
              [
                49.8009113,
                36.03749
              ],
              [
                49.7978268,
                36.0481906
              ],
              [
                49.7863918,
                36.0591473
              ],
              [
                49.8036001,
                36.0724124
              ],
              [
                49.7965763,
                36.0827589
              ],
              [
                49.7814647,
                36.0899832
              ],
              [
                49.7778755,
                36.0942641
              ],
              [
                49.7742415,
                36.0985981
              ],
              [
                49.7720215,
                36.1013735
              ],
              [
                49.766185,
                36.1091502
              ],
              [
                49.7603517,
                36.1188734
              ],
              [
                49.7600751,
                36.1191527
              ],
              [
                49.7597985,
                36.1202611
              ],
              [
                49.7644167,
                36.1228861
              ],
              [
                49.767277,
                36.1245119
              ],
              [
                49.7720215,
                36.1272086
              ],
              [
                49.77347,
                36.1281245
              ],
              [
                49.7840257,
                36.1364532
              ],
              [
                49.7873669,
                36.1424708
              ],
              [
                49.7894782,
                36.1462729
              ],
              [
                49.7901568,
                36.1565799
              ],
              [
                49.7924494,
                36.1582614
              ],
              [
                49.7992644,
                36.156554
              ],
              [
                49.819346,
                36.1588104
              ],
              [
                49.8368373,
                36.16548
              ],
              [
                49.8581338,
                36.1785974
              ],
              [
                49.8591204,
                36.1790925
              ],
              [
                49.8720235,
                36.1888784
              ],
              [
                49.872857,
                36.1891487
              ],
              [
                49.8834135,
                36.2019344
              ],
              [
                49.8845268,
                36.2069351
              ],
              [
                49.8811934,
                36.2124854
              ],
              [
                49.8809134,
                36.2133234
              ],
              [
                49.8803568,
                36.2177654
              ],
              [
                49.8809135,
                36.2249915
              ],
              [
                49.8831369,
                36.2285955
              ],
              [
                49.8834135,
                36.229992
              ],
              [
                49.8825802,
                36.2313796
              ],
              [
                49.87897,
                36.2333257
              ],
              [
                49.87508,
                36.2333258
              ],
              [
                49.8745233,
                36.2330464
              ],
              [
                49.8739703,
                36.2330464
              ],
              [
                49.8731371,
                36.2327671
              ],
              [
                49.8656369,
                36.2313796
              ],
              [
                49.8650802,
                36.2311003
              ],
              [
                49.8631369,
                36.2311002
              ],
              [
                49.8623036,
                36.2308209
              ],
              [
                49.8617469,
                36.2311003
              ],
              [
                49.8611904,
                36.2308209
              ],
              [
                49.8561902,
                36.2308208
              ],
              [
                49.8559136,
                36.2311002
              ],
              [
                49.8525804,
                36.2311002
              ],
              [
                49.8520237,
                36.2313795
              ],
              [
                49.8486904,
                36.2313796
              ],
              [
                49.8311909,
                36.2374883
              ],
              [
                49.8275774,
                36.2416599
              ],
              [
                49.8270239,
                36.2422094
              ],
              [
                49.8248008,
                36.2452638
              ],
              [
                49.8242442,
                36.2455431
              ],
              [
                49.8203539,
                36.2547061
              ],
              [
                49.8195206,
                36.2594361
              ],
              [
                49.8198007,
                36.2624904
              ],
              [
                49.8195206,
                36.263049
              ],
              [
                49.8203538,
                36.2677611
              ],
              [
                49.8209108,
                36.2688783
              ],
              [
                49.8211874,
                36.2738786
              ],
              [
                49.8214675,
                36.276104
              ],
              [
                49.8220206,
                36.2777617
              ],
              [
                49.8225773,
                36.2785996
              ],
              [
                49.8225773,
                36.2788788
              ],
              [
                49.8229291,
                36.2797351
              ],
              [
                49.8050777,
                36.2810952
              ],
              [
                49.804244,
                36.2813744
              ],
              [
                49.7736879,
                36.2783202
              ],
              [
                49.7509082,
                36.2758246
              ],
              [
                49.745908,
                36.2758245
              ],
              [
                49.7411848,
                36.2766534
              ],
              [
                49.7381282,
                36.2774912
              ],
              [
                49.7303518,
                36.2813743
              ],
              [
                49.7245185,
                36.2861043
              ],
              [
                49.7239618,
                36.2863836
              ],
              [
                49.7184051,
                36.2986003
              ],
              [
                49.716185,
                36.3008255
              ],
              [
                49.7156284,
                36.3008256
              ],
              [
                49.7150718,
                36.3013841
              ],
              [
                49.7145186,
                36.3013841
              ],
              [
                49.7139616,
                36.3016543
              ],
              [
                49.7131284,
                36.3016543
              ],
              [
                49.7125717,
                36.3019337
              ],
              [
                49.7120185,
                36.3019336
              ],
              [
                49.7117384,
                36.3022129
              ],
              [
                49.7111818,
                36.3019337
              ],
              [
                49.7097951,
                36.3019337
              ],
              [
                49.7089619,
                36.3016544
              ],
              [
                49.707572,
                36.3016544
              ],
              [
                49.7003488,
                36.2999876
              ],
              [
                49.6989621,
                36.2999876
              ],
              [
                49.6978487,
                36.2997083
              ],
              [
                49.6961819,
                36.2997083
              ],
              [
                49.6803488,
                36.2960956
              ],
              [
                49.6786823,
                36.2960956
              ],
              [
                49.6778487,
                36.2958253
              ],
              [
                49.6714591,
                36.295546
              ],
              [
                49.6667356,
                36.295546
              ],
              [
                49.6656258,
                36.2958253
              ],
              [
                49.6625691,
                36.2958253
              ],
              [
                49.6597925,
                36.2960955
              ],
              [
                49.6589592,
                36.2963749
              ],
              [
                49.6581256,
                36.2963749
              ],
              [
                49.6575689,
                36.2966542
              ],
              [
                49.6564591,
                36.2966541
              ],
              [
                49.6556259,
                36.2969334
              ],
              [
                49.655349,
                36.2966541
              ],
              [
                49.6414593,
                36.3041498
              ],
              [
                49.6061795,
                36.3105463
              ],
              [
                49.6042331,
                36.3105463
              ],
              [
                49.5892331,
                36.3158256
              ],
              [
                49.5875666,
                36.3163751
              ],
              [
                49.5806231,
                36.3194383
              ],
              [
                49.5745101,
                36.3224923
              ],
              [
                49.539787,
                36.3530503
              ],
              [
                49.5275636,
                36.359996
              ],
              [
                49.5228405,
                36.3608247
              ],
              [
                49.5156173,
                36.3608247
              ],
              [
                49.5145071,
                36.361104
              ],
              [
                49.5139505,
                36.3608247
              ],
              [
                49.5128407,
                36.361104
              ],
              [
                49.5114505,
                36.3608247
              ],
              [
                49.5083972,
                36.3608247
              ],
              [
                49.5078407,
                36.3605454
              ],
              [
                49.5067308,
                36.3605455
              ],
              [
                49.4997841,
                36.3594373
              ],
              [
                49.4925609,
                36.3558249
              ],
              [
                49.487841,
                36.3483206
              ],
              [
                49.4881175,
                36.3458252
              ],
              [
                49.4883941,
                36.3455459
              ],
              [
                49.4931177,
                36.3338794
              ],
              [
                49.4933943,
                36.333321
              ],
              [
                49.4928411,
                36.3299876
              ],
              [
                49.4928411,
                36.3294291
              ],
              [
                49.4925611,
                36.3288796
              ],
              [
                49.4864511,
                36.3252669
              ],
              [
                49.4856176,
                36.3252669
              ],
              [
                49.4842277,
                36.3247083
              ],
              [
                49.4800612,
                36.3247084
              ],
              [
                49.4797846,
                36.3249876
              ],
              [
                49.476451,
                36.3249876
              ],
              [
                49.4739513,
                36.3255461
              ],
              [
                49.4636714,
                36.3255462
              ],
              [
                49.4625612,
                36.3252669
              ],
              [
                49.4611713,
                36.3255461
              ],
              [
                49.4606147,
                36.3252669
              ],
              [
                49.4578381,
                36.3252668
              ],
              [
                49.4570049,
                36.3249876
              ],
              [
                49.4453382,
                36.3249876
              ],
              [
                49.4154036,
                36.3240319
              ],
              [
                49.4175583,
                36.3086
              ],
              [
                49.4167251,
                36.3077621
              ],
              [
                49.4177498,
                36.2902789
              ],
              [
                49.4091223,
                36.2738951
              ],
              [
                49.4036687,
                36.2480471
              ],
              [
                49.4005726,
                36.2206729
              ],
              [
                49.4142804,
                36.2116728
              ],
              [
                49.4231153,
                36.2077634
              ],
              [
                49.4264486,
                36.2038709
              ],
              [
                49.4317254,
                36.1974916
              ],
              [
                49.4317253,
                36.1972123
              ],
              [
                49.4317253,
                36.196933
              ],
              [
                49.4328386,
                36.1955453
              ],
              [
                49.4331153,
                36.1944371
              ],
              [
                49.4333917,
                36.1941488
              ],
              [
                49.4336719,
                36.1930405
              ],
              [
                49.432382,
                36.1716536
              ],
              [
                49.4246021,
                36.1580472
              ],
              [
                49.4168254,
                36.1449903
              ],
              [
                49.4143254,
                36.134988
              ],
              [
                49.4146024,
                36.1333209
              ],
              [
                49.4148821,
                36.1316539
              ],
              [
                49.415159,
                36.1308158
              ],
              [
                49.4151591,
                36.1263733
              ],
              [
                49.4157156,
                36.1238771
              ],
              [
                49.4157157,
                36.1235977
              ],
              [
                49.416549,
                36.1211017
              ],
              [
                49.4165489,
                36.1149919
              ],
              [
                49.4184924,
                36.1002673
              ],
              [
                49.4193257,
                36.0944278
              ],
              [
                49.4196022,
                36.0938781
              ],
              [
                49.4162689,
                36.072205
              ],
              [
                49.4068258,
                36.0541541
              ],
              [
                49.3978359,
                36.0463661
              ],
              [
                49.3931127,
                36.0405444
              ],
              [
                49.3477271,
                36.0215108
              ],
              [
                49.3477271,
                36.0206728
              ],
              [
                49.3477271,
                36.0203934
              ],
              [
                49.3468935,
                36.0190057
              ],
              [
                49.3388406,
                36.0131753
              ],
              [
                49.3431102,
                35.9988722
              ],
              [
                49.3361667,
                35.9966461
              ],
              [
                49.3131553,
                35.9597019
              ],
              [
                49.3053786,
                35.9574753
              ],
              [
                49.3039887,
                35.9574753
              ],
              [
                49.3031555,
                35.9571959
              ],
              [
                49.3017656,
                35.9571959
              ],
              [
                49.3006554,
                35.9569164
              ],
              [
                49.2625511,
                35.9719247
              ],
              [
                49.2592179,
                35.9719247
              ],
              [
                49.2583847,
                35.9722041
              ],
              [
                49.2458848,
                35.9749799
              ],
              [
                49.2110478,
                35.9726679
              ],
              [
                49.1861585,
                35.958036
              ],
              [
                49.1817156,
                35.9555395
              ],
              [
                49.1808823,
                35.9555394
              ],
              [
                49.1739357,
                35.9516459
              ],
              [
                49.163659,
                35.9394244
              ],
              [
                49.1636589,
                35.9391451
              ],
              [
                49.1525458,
                35.9324755
              ],
              [
                49.1517127,
                35.9305377
              ],
              [
                49.1517126,
                35.9299788
              ],
              [
                49.151159,
                35.9288703
              ],
              [
                49.1456028,
                35.9174777
              ],
              [
                49.1458793,
                35.9171983
              ],
              [
                49.1450461,
                35.9152514
              ],
              [
                49.1444894,
                35.9124844
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555151,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قزوین",
          "name:en": "Qazvin County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291731",
          "wikipedia": "en:Qazvin County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.9717891,
                36.5558654
              ],
              [
                48.977481,
                36.5401706
              ],
              [
                48.9943885,
                36.5252257
              ],
              [
                49.0148162,
                36.5137753
              ],
              [
                49.0288066,
                36.5080495
              ],
              [
                49.0441703,
                36.5053589
              ],
              [
                49.0583324,
                36.4972176
              ],
              [
                49.0633964,
                36.4923186
              ],
              [
                49.0681144,
                36.4891203
              ],
              [
                49.0814319,
                36.4716585
              ],
              [
                49.092542,
                36.4511034
              ],
              [
                49.0950416,
                36.4474913
              ],
              [
                49.0955983,
                36.4463834
              ],
              [
                49.1042083,
                36.4377721
              ],
              [
                49.1050414,
                36.4374927
              ],
              [
                49.1053216,
                36.4369343
              ],
              [
                49.105875,
                36.4366551
              ],
              [
                49.109765,
                36.4336014
              ],
              [
                49.1192117,
                36.42971
              ],
              [
                49.120045,
                36.4294398
              ],
              [
                49.1205981,
                36.4294398
              ],
              [
                49.138168,
                36.4192065
              ],
              [
                49.1403911,
                36.419765
              ],
              [
                49.1426145,
                36.419765
              ],
              [
                49.1440009,
                36.4194858
              ],
              [
                49.1473346,
                36.4194858
              ],
              [
                49.1487245,
                36.419765
              ],
              [
                49.1492811,
                36.4194858
              ],
              [
                49.1509475,
                36.419765
              ],
              [
                49.153171,
                36.4197651
              ],
              [
                49.2015212,
                36.4076573
              ],
              [
                49.2356038,
                36.3992007
              ],
              [
                49.26644,
                36.3930475
              ],
              [
                49.2669967,
                36.3927682
              ],
              [
                49.2729622,
                36.390203
              ],
              [
                49.3065477,
                36.394258
              ],
              [
                49.3369993,
                36.3894352
              ],
              [
                49.3408892,
                36.388048
              ],
              [
                49.3444992,
                36.3852644
              ],
              [
                49.3461655,
                36.3797152
              ],
              [
                49.376897,
                36.34579
              ],
              [
                49.4154036,
                36.3240319
              ],
              [
                49.4453382,
                36.3249876
              ],
              [
                49.4570049,
                36.3249876
              ],
              [
                49.4578381,
                36.3252668
              ],
              [
                49.4606147,
                36.3252669
              ],
              [
                49.4611713,
                36.3255461
              ],
              [
                49.4625612,
                36.3252669
              ],
              [
                49.4636714,
                36.3255462
              ],
              [
                49.4739513,
                36.3255461
              ],
              [
                49.476451,
                36.3249876
              ],
              [
                49.4797846,
                36.3249876
              ],
              [
                49.4800612,
                36.3247084
              ],
              [
                49.4842277,
                36.3247083
              ],
              [
                49.4856176,
                36.3252669
              ],
              [
                49.4864511,
                36.3252669
              ],
              [
                49.4925611,
                36.3288796
              ],
              [
                49.4928411,
                36.3294291
              ],
              [
                49.4928411,
                36.3299876
              ],
              [
                49.4933943,
                36.333321
              ],
              [
                49.4931177,
                36.3338794
              ],
              [
                49.4883941,
                36.3455459
              ],
              [
                49.4881175,
                36.3458252
              ],
              [
                49.487841,
                36.3483206
              ],
              [
                49.4925609,
                36.3558249
              ],
              [
                49.4997841,
                36.3594373
              ],
              [
                49.5067308,
                36.3605455
              ],
              [
                49.5078407,
                36.3605454
              ],
              [
                49.5083972,
                36.3608247
              ],
              [
                49.5114505,
                36.3608247
              ],
              [
                49.5128407,
                36.361104
              ],
              [
                49.5139505,
                36.3608247
              ],
              [
                49.5145071,
                36.361104
              ],
              [
                49.5156173,
                36.3608247
              ],
              [
                49.5228405,
                36.3608247
              ],
              [
                49.5275636,
                36.359996
              ],
              [
                49.539787,
                36.3530503
              ],
              [
                49.5745101,
                36.3224923
              ],
              [
                49.5806231,
                36.3194383
              ],
              [
                49.5875666,
                36.3163751
              ],
              [
                49.5892331,
                36.3158256
              ],
              [
                49.6042331,
                36.3105463
              ],
              [
                49.6061795,
                36.3105463
              ],
              [
                49.6414593,
                36.3041498
              ],
              [
                49.655349,
                36.2966541
              ],
              [
                49.6556259,
                36.2969334
              ],
              [
                49.6564591,
                36.2966541
              ],
              [
                49.6575689,
                36.2966542
              ],
              [
                49.6581256,
                36.2963749
              ],
              [
                49.6589592,
                36.2963749
              ],
              [
                49.6597925,
                36.2960955
              ],
              [
                49.6625691,
                36.2958253
              ],
              [
                49.6656258,
                36.2958253
              ],
              [
                49.6667356,
                36.295546
              ],
              [
                49.6714591,
                36.295546
              ],
              [
                49.6778487,
                36.2958253
              ],
              [
                49.6786823,
                36.2960956
              ],
              [
                49.6803488,
                36.2960956
              ],
              [
                49.6961819,
                36.2997083
              ],
              [
                49.6978487,
                36.2997083
              ],
              [
                49.6989621,
                36.2999876
              ],
              [
                49.7003488,
                36.2999876
              ],
              [
                49.707572,
                36.3016544
              ],
              [
                49.7089619,
                36.3016544
              ],
              [
                49.7097951,
                36.3019337
              ],
              [
                49.7111818,
                36.3019337
              ],
              [
                49.7117384,
                36.3022129
              ],
              [
                49.7120185,
                36.3019336
              ],
              [
                49.7125717,
                36.3019337
              ],
              [
                49.7131284,
                36.3016543
              ],
              [
                49.7139616,
                36.3016543
              ],
              [
                49.7145186,
                36.3013841
              ],
              [
                49.7150718,
                36.3013841
              ],
              [
                49.7156284,
                36.3008256
              ],
              [
                49.716185,
                36.3008255
              ],
              [
                49.7184051,
                36.2986003
              ],
              [
                49.7239618,
                36.2863836
              ],
              [
                49.7245185,
                36.2861043
              ],
              [
                49.7303518,
                36.2813743
              ],
              [
                49.7381282,
                36.2774912
              ],
              [
                49.7411848,
                36.2766534
              ],
              [
                49.745908,
                36.2758245
              ],
              [
                49.7509082,
                36.2758246
              ],
              [
                49.7736879,
                36.2783202
              ],
              [
                49.804244,
                36.2813744
              ],
              [
                49.8050777,
                36.2810952
              ],
              [
                49.8229291,
                36.2797351
              ],
              [
                49.8225773,
                36.2788788
              ],
              [
                49.8225773,
                36.2785996
              ],
              [
                49.8220206,
                36.2777617
              ],
              [
                49.8214675,
                36.276104
              ],
              [
                49.8211874,
                36.2738786
              ],
              [
                49.8209108,
                36.2688783
              ],
              [
                49.8203538,
                36.2677611
              ],
              [
                49.8195206,
                36.263049
              ],
              [
                49.8198007,
                36.2624904
              ],
              [
                49.8195206,
                36.2594361
              ],
              [
                49.8203539,
                36.2547061
              ],
              [
                49.8242442,
                36.2455431
              ],
              [
                49.8248008,
                36.2452638
              ],
              [
                49.8270239,
                36.2422094
              ],
              [
                49.8275774,
                36.2416599
              ],
              [
                49.8311909,
                36.2374883
              ],
              [
                49.8486904,
                36.2313796
              ],
              [
                49.8520237,
                36.2313795
              ],
              [
                49.8525804,
                36.2311002
              ],
              [
                49.8559136,
                36.2311002
              ],
              [
                49.8561902,
                36.2308208
              ],
              [
                49.8611904,
                36.2308209
              ],
              [
                49.8617469,
                36.2311003
              ],
              [
                49.8623036,
                36.2308209
              ],
              [
                49.8631369,
                36.2311002
              ],
              [
                49.8650802,
                36.2311003
              ],
              [
                49.8656369,
                36.2313796
              ],
              [
                49.8731371,
                36.2327671
              ],
              [
                49.8739703,
                36.2330464
              ],
              [
                49.8745233,
                36.2330464
              ],
              [
                49.87508,
                36.2333258
              ],
              [
                49.87897,
                36.2333257
              ],
              [
                49.8825802,
                36.2313796
              ],
              [
                49.8834135,
                36.229992
              ],
              [
                49.8831369,
                36.2285955
              ],
              [
                49.8809135,
                36.2249915
              ],
              [
                49.8803568,
                36.2177654
              ],
              [
                49.8809134,
                36.2133234
              ],
              [
                49.8811934,
                36.2124854
              ],
              [
                49.8845268,
                36.2069351
              ],
              [
                49.8834135,
                36.2019344
              ],
              [
                49.872857,
                36.1891487
              ],
              [
                49.8720235,
                36.1888784
              ],
              [
                49.8591204,
                36.1790925
              ],
              [
                49.8638817,
                36.17207
              ],
              [
                49.8783823,
                36.1660449
              ],
              [
                49.8965311,
                36.1579716
              ],
              [
                49.9064498,
                36.1517983
              ],
              [
                49.9248132,
                36.143202
              ],
              [
                49.9300112,
                36.1429199
              ],
              [
                49.9386227,
                36.1365092
              ],
              [
                49.9508804,
                36.1273814
              ],
              [
                49.9643961,
                36.1173132
              ],
              [
                49.981871,
                36.1108134
              ],
              [
                50.0158561,
                36.0981629
              ],
              [
                50.0235632,
                36.097206
              ],
              [
                50.0366903,
                36.0955751
              ],
              [
                50.0355192,
                36.1023004
              ],
              [
                50.0316641,
                36.1113125
              ],
              [
                50.0307536,
                36.1134404
              ],
              [
                50.0247914,
                36.1273735
              ],
              [
                50.0194689,
                36.1398072
              ],
              [
                50.0148953,
                36.1504883
              ],
              [
                50.0082443,
                36.1646894
              ],
              [
                50.0046365,
                36.1737457
              ],
              [
                50.0032062,
                36.1995081
              ],
              [
                50.0018125,
                36.2245938
              ],
              [
                50.0401491,
                36.222827
              ],
              [
                50.0480765,
                36.2224601
              ],
              [
                50.0510106,
                36.2223243
              ],
              [
                50.0691845,
                36.2242215
              ],
              [
                50.0793338,
                36.238176
              ],
              [
                50.1042845,
                36.2307842
              ],
              [
                50.1127931,
                36.2316655
              ],
              [
                50.1175929,
                36.2317055
              ],
              [
                50.1192477,
                36.2312839
              ],
              [
                50.1231602,
                36.2302753
              ],
              [
                50.1266905,
                36.2293874
              ],
              [
                50.1492291,
                36.2236411
              ],
              [
                50.1519895,
                36.2229371
              ],
              [
                50.1540342,
                36.2224155
              ],
              [
                50.1545855,
                36.2286808
              ],
              [
                50.1549628,
                36.2313868
              ],
              [
                50.1554025,
                36.2333992
              ],
              [
                50.1554368,
                36.2460709
              ],
              [
                50.1515006,
                36.2443281
              ],
              [
                50.1491639,
                36.2452654
              ],
              [
                50.1486053,
                36.2465781
              ],
              [
                50.1536114,
                36.2511318
              ],
              [
                50.1574151,
                36.2572284
              ],
              [
                50.1711686,
                36.261973
              ],
              [
                50.1739865,
                36.2615008
              ],
              [
                50.1813622,
                36.2620908
              ],
              [
                50.1870825,
                36.2659303
              ],
              [
                50.1955743,
                36.2755806
              ],
              [
                50.2050072,
                36.28777
              ],
              [
                50.2074162,
                36.2930445
              ],
              [
                50.2091193,
                36.2930841
              ],
              [
                50.2219787,
                36.3060415
              ],
              [
                50.2363265,
                36.3042135
              ],
              [
                50.2443094,
                36.3024328
              ],
              [
                50.2450305,
                36.2976562
              ],
              [
                50.2455522,
                36.2942003
              ],
              [
                50.2489691,
                36.290607
              ],
              [
                50.2583352,
                36.2924604
              ],
              [
                50.2804308,
                36.3086576
              ],
              [
                50.2905438,
                36.3251858
              ],
              [
                50.2916201,
                36.3402163
              ],
              [
                50.2993684,
                36.3490535
              ],
              [
                50.315301,
                36.3503838
              ],
              [
                50.330298,
                36.3465347
              ],
              [
                50.3298733,
                36.3486834
              ],
              [
                50.3365606,
                36.3501075
              ],
              [
                50.347273,
                36.368272
              ],
              [
                50.3520554,
                36.36963
              ],
              [
                50.3616188,
                36.3794412
              ],
              [
                50.3681342,
                36.3767485
              ],
              [
                50.3743437,
                36.3790635
              ],
              [
                50.3812365,
                36.3755514
              ],
              [
                50.3875161,
                36.3681759
              ],
              [
                50.3981562,
                36.3740995
              ],
              [
                50.4034249,
                36.3837927
              ],
              [
                50.4076012,
                36.3868399
              ],
              [
                50.4126338,
                36.3823304
              ],
              [
                50.4171984,
                36.3817226
              ],
              [
                50.4240434,
                36.3772626
              ],
              [
                50.4263753,
                36.3721887
              ],
              [
                50.3991458,
                36.3505357
              ],
              [
                50.4080198,
                36.3412634
              ],
              [
                50.420648,
                36.3328042
              ],
              [
                50.4263106,
                36.3304152
              ],
              [
                50.4337674,
                36.3288936
              ],
              [
                50.4370306,
                36.3311687
              ],
              [
                50.4406355,
                36.3275731
              ],
              [
                50.447821,
                36.3261118
              ],
              [
                50.4564284,
                36.3296475
              ],
              [
                50.4679297,
                36.3357322
              ],
              [
                50.4743135,
                36.3285237
              ],
              [
                50.4806536,
                36.3209392
              ],
              [
                50.4842588,
                36.3205371
              ],
              [
                50.4894019,
                36.3193932
              ],
              [
                50.4926383,
                36.3185316
              ],
              [
                50.4967689,
                36.3196205
              ],
              [
                50.5001262,
                36.3199527
              ],
              [
                50.5022401,
                36.3190137
              ],
              [
                50.5040352,
                36.3163166
              ],
              [
                50.504837,
                36.3134999
              ],
              [
                50.5061674,
                36.3108717
              ],
              [
                50.5157068,
                36.3069268
              ],
              [
                50.5179745,
                36.3047488
              ],
              [
                50.5223035,
                36.3019491
              ],
              [
                50.5237197,
                36.3000469
              ],
              [
                50.5280971,
                36.2962076
              ],
              [
                50.5298043,
                36.2949701
              ],
              [
                50.5310583,
                36.294582
              ],
              [
                50.5326032,
                36.2976257
              ],
              [
                50.5333328,
                36.300289
              ],
              [
                50.5408001,
                36.3018108
              ],
              [
                50.5456924,
                36.3029867
              ],
              [
                50.549941,
                36.3058918
              ],
              [
                50.5515047,
                36.3092496
              ],
              [
                50.5529451,
                36.3100763
              ],
              [
                50.5565071,
                36.3105605
              ],
              [
                50.5604124,
                36.3093501
              ],
              [
                50.5646734,
                36.3075771
              ],
              [
                50.571848,
                36.3061936
              ],
              [
                50.5790805,
                36.3047505
              ],
              [
                50.5910968,
                36.3011537
              ],
              [
                50.5976199,
                36.3010845
              ],
              [
                50.5993365,
                36.3017762
              ],
              [
                50.6076621,
                36.2970032
              ],
              [
                50.6121253,
                36.296519
              ],
              [
                50.6210517,
                36.2931984
              ],
              [
                50.6253432,
                36.2893935
              ],
              [
                50.6281719,
                36.2870544
              ],
              [
                50.6379603,
                36.2876639
              ],
              [
                50.6414365,
                36.2907425
              ],
              [
                50.6487643,
                36.2907875
              ],
              [
                50.6537532,
                36.2887708
              ],
              [
                50.6567144,
                36.2877676
              ],
              [
                50.6592464,
                36.2859342
              ],
              [
                50.6606074,
                36.2885485
              ],
              [
                50.6647395,
                36.2932676
              ],
              [
                50.6685161,
                36.2939594
              ],
              [
                50.6723785,
                36.2967957
              ],
              [
                50.67667,
                36.2967265
              ],
              [
                50.6824206,
                36.3017762
              ],
              [
                50.6897163,
                36.3064797
              ],
              [
                50.6923341,
                36.3170617
              ],
              [
                50.6956385,
                36.3180645
              ],
              [
                50.697484,
                36.3201045
              ],
              [
                50.6995868,
                36.3221446
              ],
              [
                50.7027626,
                36.3217643
              ],
              [
                50.7048124,
                36.3203741
              ],
              [
                50.7074403,
                36.3186868
              ],
              [
                50.7084103,
                36.3160146
              ],
              [
                50.7141351,
                36.3155401
              ],
              [
                50.7192359,
                36.3147004
              ],
              [
                50.7218599,
                36.3135345
              ],
              [
                50.7261085,
                36.3134999
              ],
              [
                50.7271814,
                36.3144682
              ],
              [
                50.7273101,
                36.3173728
              ],
              [
                50.7300996,
                36.3192747
              ],
              [
                50.7377715,
                36.3191497
              ],
              [
                50.7423435,
                36.3186021
              ],
              [
                50.74512,
                36.3186021
              ],
              [
                50.7503584,
                36.3161852
              ],
              [
                50.7531451,
                36.3161626
              ],
              [
                50.7586383,
                36.3127737
              ],
              [
                50.7592641,
                36.3074533
              ],
              [
                50.7621574,
                36.3062031
              ],
              [
                50.7824992,
                36.3047505
              ],
              [
                50.7945682,
                36.3028732
              ],
              [
                50.7964305,
                36.3028244
              ],
              [
                50.8075568,
                36.3024958
              ],
              [
                50.8159561,
                36.3025563
              ],
              [
                50.8162469,
                36.3030255
              ],
              [
                50.8169549,
                36.303981
              ],
              [
                50.8186769,
                36.3050185
              ],
              [
                50.8213055,
                36.305788
              ],
              [
                50.8236766,
                36.3062895
              ],
              [
                50.8257472,
                36.3061771
              ],
              [
                50.8276033,
                36.3065488
              ],
              [
                50.8289552,
                36.3070503
              ],
              [
                50.8303499,
                36.3081656
              ],
              [
                50.8320451,
                36.3098169
              ],
              [
                50.8366477,
                36.312255
              ],
              [
                50.8391368,
                36.3131887
              ],
              [
                50.8405745,
                36.313059
              ],
              [
                50.842334,
                36.3134739
              ],
              [
                50.8440614,
                36.3142088
              ],
              [
                50.845617,
                36.3142174
              ],
              [
                50.8469045,
                36.3141656
              ],
              [
                50.8485782,
                36.314131
              ],
              [
                50.849533,
                36.3142953
              ],
              [
                50.8506811,
                36.3154537
              ],
              [
                50.8516252,
                36.3165948
              ],
              [
                50.8520973,
                36.3178742
              ],
              [
                50.8528268,
                36.3192314
              ],
              [
                50.8531057,
                36.3205454
              ],
              [
                50.8529019,
                36.3213493
              ],
              [
                50.8524835,
                36.3221359
              ],
              [
                50.8519256,
                36.3225422
              ],
              [
                50.8512068,
                36.3232424
              ],
              [
                50.8491146,
                36.3242278
              ],
              [
                50.8472264,
                36.3259047
              ],
              [
                50.846647,
                36.326661
              ],
              [
                50.8462285,
                36.3273115
              ],
              [
                50.8464807,
                36.3276248
              ],
              [
                50.8470547,
                36.3280786
              ],
              [
                50.8475697,
                36.3283595
              ],
              [
                50.8481491,
                36.3287053
              ],
              [
                50.8489215,
                36.329911
              ],
              [
                50.8496028,
                36.330516
              ],
              [
                50.8501768,
                36.3311945
              ],
              [
                50.8507937,
                36.3317002
              ],
              [
                50.8513221,
                36.3318363
              ],
              [
                50.8523172,
                36.3317628
              ],
              [
                50.8527866,
                36.3316958
              ],
              [
                50.8533579,
                36.3315122
              ],
              [
                50.8538782,
                36.3315057
              ],
              [
                50.8558953,
                36.3317564
              ],
              [
                50.8568394,
                36.3317131
              ],
              [
                50.861839,
                36.3319206
              ],
              [
                50.8626008,
                36.3321194
              ],
              [
                50.8634376,
                36.3335368
              ],
              [
                50.8637273,
                36.3339258
              ],
              [
                50.8646607,
                36.3343147
              ],
              [
                50.8654654,
                36.3343752
              ],
              [
                50.8690381,
                36.3350061
              ],
              [
                50.8706528,
                36.3356154
              ],
              [
                50.8715164,
                36.3358617
              ],
              [
                50.8720958,
                36.3362247
              ],
              [
                50.8740699,
                36.338515
              ],
              [
                50.8750892,
                36.3395607
              ],
              [
                50.8756578,
                36.3406324
              ],
              [
                50.878458,
                36.3432423
              ],
              [
                50.8791446,
                36.3449101
              ],
              [
                50.8804536,
                36.3468113
              ],
              [
                50.8817839,
                36.3481248
              ],
              [
                50.8820575,
                36.3491747
              ],
              [
                50.8820468,
                36.3495938
              ],
              [
                50.881445,
                36.3508941
              ],
              [
                50.8720834,
                36.3615428
              ],
              [
                50.8656045,
                36.3704312
              ],
              [
                50.8547514,
                36.3771124
              ],
              [
                50.8311191,
                36.3911392
              ],
              [
                50.8287619,
                36.3900586
              ],
              [
                50.8203785,
                36.3934856
              ],
              [
                50.8136557,
                36.3957241
              ],
              [
                50.8106282,
                36.4010029
              ],
              [
                50.8057593,
                36.4069156
              ],
              [
                50.804719,
                36.4096702
              ],
              [
                50.8015212,
                36.411306
              ],
              [
                50.7981295,
                36.4151083
              ],
              [
                50.7915118,
                36.4198904
              ],
              [
                50.786835,
                36.4237807
              ],
              [
                50.7824752,
                36.4283524
              ],
              [
                50.7738884,
                36.4334392
              ],
              [
                50.7674983,
                36.4381657
              ],
              [
                50.7613743,
                36.445002
              ],
              [
                50.7545416,
                36.4517144
              ],
              [
                50.7481323,
                36.4592034
              ],
              [
                50.7334899,
                36.4620896
              ],
              [
                50.7219669,
                36.4635276
              ],
              [
                50.7142203,
                36.4644059
              ],
              [
                50.7024192,
                36.4703727
              ],
              [
                50.6844433,
                36.4772949
              ],
              [
                50.6762353,
                36.4810718
              ],
              [
                50.6759374,
                36.4812957
              ],
              [
                50.670639,
                36.4852786
              ],
              [
                50.6612343,
                36.4926325
              ],
              [
                50.6536018,
                36.4980256
              ],
              [
                50.6490325,
                36.4990115
              ],
              [
                50.6591605,
                36.5081875
              ],
              [
                50.6560351,
                36.5144651
              ],
              [
                50.6511783,
                36.5163967
              ],
              [
                50.6478309,
                36.5197077
              ],
              [
                50.6441402,
                36.521846
              ],
              [
                50.6403636,
                36.5241221
              ],
              [
                50.634613,
                36.5262603
              ],
              [
                50.6321239,
                36.5254326
              ],
              [
                50.6286906,
                36.5232944
              ],
              [
                50.6269059,
                36.5243953
              ],
              [
                50.6227877,
                36.5240617
              ],
              [
                50.6185626,
                36.5232945
              ],
              [
                50.6127638,
                36.5264866
              ],
              [
                50.6094646,
                36.527019
              ],
              [
                50.606886,
                36.5271249
              ],
              [
                50.6042742,
                36.5259868
              ],
              [
                50.6025443,
                36.5256938
              ],
              [
                50.5990502,
                36.5256595
              ],
              [
                50.597425,
                36.5261053
              ],
              [
                50.5949592,
                36.5270534
              ],
              [
                50.5935001,
                36.5284329
              ],
              [
                50.5894153,
                36.5305294
              ],
              [
                50.5879211,
                36.5305364
              ],
              [
                50.5858612,
                36.5308123
              ],
              [
                50.5840587,
                36.5311571
              ],
              [
                50.5787372,
                36.530433
              ],
              [
                50.5775141,
                36.5313296
              ],
              [
                50.5770635,
                36.5318985
              ],
              [
                50.5766772,
                36.53264
              ],
              [
                50.5753469,
                36.5339503
              ],
              [
                50.5752826,
                36.5348296
              ],
              [
                50.5743813,
                36.5355365
              ],
              [
                50.5731368,
                36.5365019
              ],
              [
                50.5712872,
                36.5372907
              ],
              [
                50.5466003,
                36.5419683
              ],
              [
                50.5380756,
                36.5412979
              ],
              [
                50.5173046,
                36.5435539
              ],
              [
                50.5086608,
                36.5463533
              ],
              [
                50.4999585,
                36.5497882
              ],
              [
                50.4867401,
                36.5595789
              ],
              [
                50.4808975,
                36.5658775
              ],
              [
                50.4751394,
                36.5674258
              ],
              [
                50.4660412,
                36.5653578
              ],
              [
                50.455656,
                36.5616349
              ],
              [
                50.4518794,
                36.5617039
              ],
              [
                50.4479312,
                36.5632206
              ],
              [
                50.4420089,
                36.5642546
              ],
              [
                50.4369195,
                36.5650352
              ],
              [
                50.424156,
                36.5740433
              ],
              [
                50.4114531,
                36.5761112
              ],
              [
                50.40699,
                36.579902
              ],
              [
                50.4076765,
                36.5825901
              ],
              [
                50.4048442,
                36.5870009
              ],
              [
                50.3968619,
                36.5929277
              ],
              [
                50.3960036,
                36.5938925
              ],
              [
                50.3933429,
                36.5938235
              ],
              [
                50.3901414,
                36.5952063
              ],
              [
                50.3847598,
                36.5955463
              ],
              [
                50.380125,
                36.5966488
              ],
              [
                50.3752326,
                36.5966488
              ],
              [
                50.3686236,
                36.5967867
              ],
              [
                50.3661346,
                36.5982337
              ],
              [
                50.3605556,
                36.5992674
              ],
              [
                50.3538608,
                36.6016791
              ],
              [
                50.3456615,
                36.6060523
              ],
              [
                50.3490543,
                36.609396
              ],
              [
                50.3519725,
                36.6139432
              ],
              [
                50.352745,
                36.6183522
              ],
              [
                50.3542041,
                36.6220722
              ],
              [
                50.3547191,
                36.6230366
              ],
              [
                50.3551482,
                36.6282718
              ],
              [
                50.3489684,
                36.6297183
              ],
              [
                50.3417801,
                36.6325767
              ],
              [
                50.3389262,
                36.6354351
              ],
              [
                50.3369951,
                36.6364853
              ],
              [
                50.3342888,
                36.6376263
              ],
              [
                50.3321456,
                36.6387582
              ],
              [
                50.3293132,
                36.6389476
              ],
              [
                50.3272641,
                36.6395903
              ],
              [
                50.3252539,
                36.6429379
              ],
              [
                50.323411,
                36.6448662
              ],
              [
                50.3211716,
                36.6463619
              ],
              [
                50.3178977,
                36.650586
              ],
              [
                50.314207,
                36.6528584
              ],
              [
                50.313177,
                36.6551307
              ],
              [
                50.3106879,
                36.6587801
              ],
              [
                50.3069972,
                36.6607768
              ],
              [
                50.2994441,
                36.6667667
              ],
              [
                50.2898311,
                36.6673863
              ],
              [
                50.2861404,
                36.6711727
              ],
              [
                50.2798747,
                36.6731692
              ],
              [
                50.2735232,
                36.6772995
              ],
              [
                50.2703475,
                36.6808101
              ],
              [
                50.2668353,
                36.6833764
              ],
              [
                50.2657446,
                36.6843132
              ],
              [
                50.2613353,
                36.681464
              ],
              [
                50.2506516,
                36.6722207
              ],
              [
                50.2464852,
                36.6741658
              ],
              [
                50.2417651,
                36.6761109
              ],
              [
                50.2320418,
                36.6786142
              ],
              [
                50.230375,
                36.6786143
              ],
              [
                50.2275953,
                36.6791725
              ],
              [
                50.2248187,
                36.6791725
              ],
              [
                50.223985,
                36.6794517
              ],
              [
                50.2214853,
                36.6797219
              ],
              [
                50.2012056,
                36.6780559
              ],
              [
                50.166149,
                36.6780568
              ],
              [
                50.1538753,
                36.6743394
              ],
              [
                50.142288,
                36.6723432
              ],
              [
                50.1309756,
                36.6719329
              ],
              [
                50.1253055,
                36.6737765
              ],
              [
                50.1121317,
                36.677318
              ],
              [
                50.1006602,
                36.6779879
              ],
              [
                50.0951671,
                36.6797776
              ],
              [
                50.085554,
                36.6806036
              ],
              [
                50.0805759,
                36.6792269
              ],
              [
                50.0781546,
                36.679457
              ],
              [
                50.0673288,
                36.6752866
              ],
              [
                50.0628051,
                36.6719981
              ],
              [
                50.0664135,
                36.6342644
              ],
              [
                50.0619415,
                36.6146658
              ],
              [
                50.0580516,
                36.6124317
              ],
              [
                50.0524948,
                36.609657
              ],
              [
                50.0519417,
                36.6090985
              ],
              [
                50.04626,
                36.6130272
              ],
              [
                50.0440067,
                36.6136233
              ],
              [
                50.0395429,
                36.6124079
              ],
              [
                50.0381755,
                36.6083625
              ],
              [
                50.033884,
                36.6062956
              ],
              [
                50.028305,
                36.6066401
              ],
              [
                50.0197219,
                36.6082247
              ],
              [
                50.0134563,
                36.6085692
              ],
              [
                50.001011,
                36.6153071
              ],
              [
                49.9919986,
                36.61787
              ],
              [
                49.9733733,
                36.6157344
              ],
              [
                49.9618718,
                36.6179391
              ],
              [
                49.9550914,
                36.6195234
              ],
              [
                49.9500703,
                36.6201089
              ],
              [
                49.9449634,
                36.6187655
              ],
              [
                49.9409294,
                36.6192133
              ],
              [
                49.9389123,
                36.6188344
              ],
              [
                49.9289131,
                36.625172
              ],
              [
                49.9261665,
                36.6257231
              ],
              [
                49.923377,
                36.6270663
              ],
              [
                49.918828,
                36.6267563
              ],
              [
                49.9177122,
                36.6259642
              ],
              [
                49.917283,
                36.6244143
              ],
              [
                49.9153089,
                36.6234499
              ],
              [
                49.9121868,
                36.6221621
              ],
              [
                49.9094081,
                36.6206083
              ],
              [
                49.9087214,
                36.6199194
              ],
              [
                49.9083568,
                36.6190047
              ],
              [
                49.9082708,
                36.6174911
              ],
              [
                49.9096656,
                36.6162855
              ],
              [
                49.9107384,
                36.6137536
              ],
              [
                49.9122405,
                36.6119968
              ],
              [
                49.9131202,
                36.609396
              ],
              [
                49.9124335,
                36.607932
              ],
              [
                49.9105668,
                36.6072257
              ],
              [
                49.9094295,
                36.6069846
              ],
              [
                49.9089359,
                36.606485
              ],
              [
                49.9085498,
                36.6059165
              ],
              [
                49.9085712,
                36.6036256
              ],
              [
                49.9090218,
                36.6023681
              ],
              [
                49.9089789,
                36.6011622
              ],
              [
                49.9086571,
                36.5999908
              ],
              [
                49.9079919,
                36.5987333
              ],
              [
                49.9073694,
                36.5979582
              ],
              [
                49.9062753,
                36.5977513
              ],
              [
                49.9050521,
                36.5972001
              ],
              [
                49.9035071,
                36.5959597
              ],
              [
                49.9033999,
                36.5949949
              ],
              [
                49.9036788,
                36.594237
              ],
              [
                49.9041939,
                36.5933928
              ],
              [
                49.9060177,
                36.5921524
              ],
              [
                49.9062967,
                36.5912048
              ],
              [
                49.9051164,
                36.5898783
              ],
              [
                49.8979282,
                36.5859671
              ],
              [
                49.893894,
                36.5842098
              ],
              [
                49.8918771,
                36.5804534
              ],
              [
                49.8905897,
                36.5779032
              ],
              [
                49.8901175,
                36.5744569
              ],
              [
                49.8895789,
                36.5647416
              ],
              [
                49.8827361,
                36.55674
              ],
              [
                49.8795604,
                36.5548095
              ],
              [
                49.8770713,
                36.5546027
              ],
              [
                49.871149,
                36.5561195
              ],
              [
                49.8672866,
                36.5559816
              ],
              [
                49.8647117,
                36.5549474
              ],
              [
                49.8615622,
                36.5527982
              ],
              [
                49.8295211,
                36.5503968
              ],
              [
                49.8116683,
                36.5530858
              ],
              [
                49.8077201,
                36.5562574
              ],
              [
                49.8045444,
                36.5577742
              ],
              [
                49.8020553,
                36.5561195
              ],
              [
                49.7987079,
                36.5553611
              ],
              [
                49.7939014,
                36.5556369
              ],
              [
                49.7889488,
                36.5566251
              ],
              [
                49.7853183,
                36.5570847
              ],
              [
                49.7811126,
                36.5581189
              ],
              [
                49.7731303,
                36.5610145
              ],
              [
                49.7687026,
                36.5641354
              ],
              [
                49.7642646,
                36.5665516
              ],
              [
                49.7583062,
                36.5683384
              ],
              [
                49.750462,
                36.5692346
              ],
              [
                49.7491388,
                36.5680661
              ],
              [
                49.7454598,
                36.5637231
              ],
              [
                49.7428763,
                36.559735
              ],
              [
                49.7374334,
                36.5571151
              ],
              [
                49.7326182,
                36.5587394
              ],
              [
                49.7301292,
                36.5618418
              ],
              [
                49.7267818,
                36.5718375
              ],
              [
                49.7220611,
                36.5775586
              ],
              [
                49.7198295,
                36.5825901
              ],
              [
                49.7042941,
                36.5866563
              ],
              [
                49.6954536,
                36.5927898
              ],
              [
                49.6841241,
                36.5969795
              ],
              [
                49.6760745,
                36.5997877
              ],
              [
                49.6700864,
                36.6028334
              ],
              [
                49.6311786,
                36.6024991
              ],
              [
                49.6250647,
                36.601377
              ],
              [
                49.6220247,
                36.6028964
              ],
              [
                49.62192,
                36.6014251
              ],
              [
                49.6190293,
                36.5996625
              ],
              [
                49.6156005,
                36.6013407
              ],
              [
                49.6156993,
                36.6000178
              ],
              [
                49.6133652,
                36.5983985
              ],
              [
                49.6088603,
                36.5989188
              ],
              [
                49.606286,
                36.6001176
              ],
              [
                49.6054729,
                36.5989274
              ],
              [
                49.6003948,
                36.5973071
              ],
              [
                49.5959806,
                36.5985437
              ],
              [
                49.5938943,
                36.5977811
              ],
              [
                49.5903019,
                36.5975781
              ],
              [
                49.5848346,
                36.6002482
              ],
              [
                49.582331,
                36.6019827
              ],
              [
                49.5807739,
                36.6027823
              ],
              [
                49.5782559,
                36.6034214
              ],
              [
                49.5753892,
                36.6034213
              ],
              [
                49.5733968,
                36.604348
              ],
              [
                49.5698693,
                36.6042744
              ],
              [
                49.5660461,
                36.6051949
              ],
              [
                49.5611107,
                36.6041792
              ],
              [
                49.5570928,
                36.6059535
              ],
              [
                49.5531195,
                36.6066597
              ],
              [
                49.5433962,
                36.6047234
              ],
              [
                49.5333964,
                36.6047235
              ],
              [
                49.5331197,
                36.6044443
              ],
              [
                49.5242298,
                36.6044442
              ],
              [
                49.52312,
                36.604165
              ],
              [
                49.5208965,
                36.6041651
              ],
              [
                49.5186734,
                36.6036066
              ],
              [
                49.5156166,
                36.6036066
              ],
              [
                49.5153401,
                36.6033275
              ],
              [
                49.5147831,
                36.6036067
              ],
              [
                49.5139499,
                36.6036067
              ],
              [
                49.5131166,
                36.6033275
              ],
              [
                49.5125635,
                36.6036066
              ],
              [
                49.5120065,
                36.6033275
              ],
              [
                49.5092302,
                36.6033275
              ],
              [
                49.4997836,
                36.6008328
              ],
              [
                49.493117,
                36.6036066
              ],
              [
                49.4853403,
                36.6074971
              ],
              [
                49.484227,
                36.6080555
              ],
              [
                49.4789502,
                36.6108293
              ],
              [
                49.4750603,
                36.6130538
              ],
              [
                49.4731262,
                36.636923
              ],
              [
                49.4772934,
                36.6398774
              ],
              [
                49.4780445,
                36.6401872
              ],
              [
                49.4790744,
                36.6411515
              ],
              [
                49.4802332,
                36.6421328
              ],
              [
                49.4799971,
                36.6430453
              ],
              [
                49.479065,
                36.6430738
              ],
              [
                49.4774007,
                36.6441128
              ],
              [
                49.4750833,
                36.6449047
              ],
              [
                49.472524,
                36.6449663
              ],
              [
                49.4712638,
                36.6458688
              ],
              [
                49.4697818,
                36.6479365
              ],
              [
                49.4669264,
                36.649399
              ],
              [
                49.4657119,
                36.6495323
              ],
              [
                49.464333,
                36.6499639
              ],
              [
                49.462808,
                36.6503054
              ],
              [
                49.4608001,
                36.6507347
              ],
              [
                49.4577737,
                36.6516337
              ],
              [
                49.4525931,
                36.658955
              ],
              [
                49.4487522,
                36.6622868
              ],
              [
                49.4475895,
                36.6620989
              ],
              [
                49.4466246,
                36.6626258
              ],
              [
                49.4414362,
                36.6614954
              ],
              [
                49.4380947,
                36.6625316
              ],
              [
                49.4233522,
                36.6831764
              ],
              [
                49.4178431,
                36.6827727
              ],
              [
                49.4143024,
                36.6842459
              ],
              [
                49.4088969,
                36.6867629
              ],
              [
                49.4019774,
                36.6912978
              ],
              [
                49.3935211,
                36.6961411
              ],
              [
                49.3870137,
                36.7011122
              ],
              [
                49.3792987,
                36.7107355
              ],
              [
                49.3729831,
                36.7191383
              ],
              [
                49.3677225,
                36.7257603
              ],
              [
                49.3610896,
                36.7327297
              ],
              [
                49.3421144,
                36.7421042
              ],
              [
                49.3321021,
                36.7487899
              ],
              [
                49.3277165,
                36.7583896
              ],
              [
                49.3211792,
                36.7737582
              ],
              [
                49.3194293,
                36.7779425
              ],
              [
                49.3018153,
                36.7989611
              ],
              [
                49.2948302,
                36.8065297
              ],
              [
                49.2862068,
                36.8119117
              ],
              [
                49.2758416,
                36.8151799
              ],
              [
                49.26733,
                36.8125833
              ],
              [
                49.2371898,
                36.7891701
              ],
              [
                49.2258041,
                36.7829726
              ],
              [
                49.2087653,
                36.7790003
              ],
              [
                49.192995,
                36.7714758
              ],
              [
                49.1834839,
                36.769005
              ],
              [
                49.1772993,
                36.7685972
              ],
              [
                49.1749472,
                36.7700707
              ],
              [
                49.1712707,
                36.7723737
              ],
              [
                49.166473,
                36.775486
              ],
              [
                49.157837,
                36.7780093
              ],
              [
                49.1538301,
                36.7783325
              ],
              [
                49.148246,
                36.7789104
              ],
              [
                49.1383159,
                36.7791745
              ],
              [
                49.1328093,
                36.7795253
              ],
              [
                49.1253571,
                36.7770862
              ],
              [
                49.1235109,
                36.7745358
              ],
              [
                49.1179787,
                36.7711937
              ],
              [
                49.1090241,
                36.7631163
              ],
              [
                49.1074016,
                36.7616524
              ],
              [
                49.1014726,
                36.7506841
              ],
              [
                49.0993761,
                36.7480551
              ],
              [
                49.0977787,
                36.7444468
              ],
              [
                49.0943518,
                36.7386594
              ],
              [
                49.0875042,
                36.7265086
              ],
              [
                49.0853884,
                36.7234202
              ],
              [
                49.0818379,
                36.7201542
              ],
              [
                49.0794553,
                36.7176155
              ],
              [
                49.0760992,
                36.7123053
              ],
              [
                49.0749411,
                36.7095408
              ],
              [
                49.0737758,
                36.7054519
              ],
              [
                49.0728278,
                36.7012539
              ],
              [
                49.0737272,
                36.6962685
              ],
              [
                49.0747826,
                36.6904169
              ],
              [
                49.0716909,
                36.688649
              ],
              [
                49.0706317,
                36.6842745
              ],
              [
                49.0609606,
                36.682277
              ],
              [
                49.0491207,
                36.6757847
              ],
              [
                49.0359132,
                36.6758816
              ],
              [
                49.0325217,
                36.675142
              ],
              [
                49.0265026,
                36.6732976
              ],
              [
                49.0141472,
                36.6670238
              ],
              [
                49.010489,
                36.6623144
              ],
              [
                49.0079434,
                36.6573224
              ],
              [
                49.0089609,
                36.6536589
              ],
              [
                49.0122024,
                36.6515042
              ],
              [
                49.0121098,
                36.649015
              ],
              [
                49.0104427,
                36.6454112
              ],
              [
                49.0119374,
                36.6397611
              ],
              [
                49.0033696,
                36.6347619
              ],
              [
                49.003973,
                36.6303089
              ],
              [
                49.0038339,
                36.6267846
              ],
              [
                49.0028716,
                36.6235801
              ],
              [
                49.001095,
                36.6210996
              ],
              [
                49.0036484,
                36.6157139
              ],
              [
                49.0033577,
                36.6105157
              ],
              [
                48.9896509,
                36.5848636
              ],
              [
                48.9812231,
                36.5741542
              ],
              [
                48.9717891,
                36.5558654
              ]
            ]
          ]
        ]
      }
    }
  ]
},
"قم.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555156,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قم",
          "name:en": "Qom County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1264575",
          "wikipedia": "en:Qom County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.0864811,
                34.5823911
              ],
              [
                50.0887046,
                34.5788339
              ],
              [
                50.0912047,
                34.5724543
              ],
              [
                50.0987045,
                34.564667
              ],
              [
                50.1000943,
                34.5632774
              ],
              [
                50.1025944,
                34.5607869
              ],
              [
                50.1045378,
                34.5579987
              ],
              [
                50.1051137,
                34.557358
              ],
              [
                50.1100946,
                34.5496699
              ],
              [
                50.1125942,
                34.5452213
              ],
              [
                50.1175943,
                34.5382821
              ],
              [
                50.118151,
                34.5368926
              ],
              [
                50.1442641,
                34.5180059
              ],
              [
                50.1484306,
                34.5163366
              ],
              [
                50.1570406,
                34.5091175
              ],
              [
                50.1589871,
                34.5035588
              ],
              [
                50.1575972,
                34.490781
              ],
              [
                50.1498209,
                34.4835528
              ],
              [
                50.147874,
                34.4805027
              ],
              [
                50.1467643,
                34.4780031
              ],
              [
                50.1459306,
                34.4763337
              ],
              [
                50.1462075,
                34.4760539
              ],
              [
                50.1464877,
                34.4752237
              ],
              [
                50.1481542,
                34.4732836
              ],
              [
                50.1595407,
                34.4685549
              ],
              [
                50.1637072,
                34.4677248
              ],
              [
                50.1653772,
                34.4677248
              ],
              [
                50.1753769,
                34.4657846
              ],
              [
                50.177877,
                34.4657847
              ],
              [
                50.1784305,
                34.4655049
              ],
              [
                50.1856538,
                34.4655048
              ],
              [
                50.1887105,
                34.4649454
              ],
              [
                50.1906535,
                34.4649453
              ],
              [
                50.1912101,
                34.4646656
              ],
              [
                50.1931534,
                34.4646657
              ],
              [
                50.1937102,
                34.4643859
              ],
              [
                50.1951004,
                34.4643859
              ],
              [
                50.2134333,
                34.4604966
              ],
              [
                50.2148235,
                34.4604965
              ],
              [
                50.2156568,
                34.4602168
              ],
              [
                50.2217666,
                34.4591159
              ],
              [
                50.2281566,
                34.457997
              ],
              [
                50.2384329,
                34.4549467
              ],
              [
                50.2395462,
                34.4549468
              ],
              [
                50.2398229,
                34.454667
              ],
              [
                50.2406565,
                34.454667
              ],
              [
                50.2414896,
                34.4543873
              ],
              [
                50.2437132,
                34.4543873
              ],
              [
                50.2439897,
                34.4541075
              ],
              [
                50.2470465,
                34.4538369
              ],
              [
                50.2512129,
                34.4538369
              ],
              [
                50.2520461,
                34.4535571
              ],
              [
                50.2542697,
                34.4535571
              ],
              [
                50.2545461,
                34.4532773
              ],
              [
                50.259826,
                34.4532774
              ],
              [
                50.2603795,
                34.4529976
              ],
              [
                50.2662128,
                34.4524471
              ],
              [
                50.2664926,
                34.4527268
              ],
              [
                50.2698261,
                34.4529976
              ],
              [
                50.2712126,
                34.4524471
              ],
              [
                50.2751025,
                34.444939
              ],
              [
                50.2762127,
                34.4443886
              ],
              [
                50.2770459,
                34.4435583
              ],
              [
                50.2809358,
                34.4421686
              ],
              [
                50.2814925,
                34.4416092
              ],
              [
                50.2889926,
                34.4382792
              ],
              [
                50.2898258,
                34.4382792
              ],
              [
                50.2903826,
                34.4379994
              ],
              [
                50.2912157,
                34.4379995
              ],
              [
                50.2917689,
                34.4377198
              ],
              [
                50.300939,
                34.4363299
              ],
              [
                50.3042722,
                34.4360502
              ],
              [
                50.3051055,
                34.4360503
              ],
              [
                50.3053825,
                34.43633
              ],
              [
                50.3070488,
                34.43633
              ],
              [
                50.3076055,
                34.4366098
              ],
              [
                50.3084387,
                34.4366098
              ],
              [
                50.3095489,
                34.4371693
              ],
              [
                50.3106587,
                34.4371692
              ],
              [
                50.311772,
                34.4377198
              ],
              [
                50.3126056,
                34.4377198
              ],
              [
                50.3292719,
                34.4421687
              ],
              [
                50.3314955,
                34.4424394
              ],
              [
                50.3351052,
                34.4421688
              ],
              [
                50.3373284,
                34.439669
              ],
              [
                50.3376054,
                34.4379995
              ],
              [
                50.337885,
                34.4371693
              ],
              [
                50.3370518,
                34.4274411
              ],
              [
                50.3362187,
                34.4241112
              ],
              [
                50.3353854,
                34.4213317
              ],
              [
                50.3314956,
                34.4080028
              ],
              [
                50.3317721,
                34.4068837
              ],
              [
                50.3348287,
                34.4013338
              ],
              [
                50.3353854,
                34.4010541
              ],
              [
                50.335662,
                34.4005035
              ],
              [
                50.3362187,
                34.4002238
              ],
              [
                50.3403852,
                34.3957747
              ],
              [
                50.3492716,
                34.3882754
              ],
              [
                50.3495518,
                34.3879957
              ],
              [
                50.3531617,
                34.3821658
              ],
              [
                50.352885,
                34.3816063
              ],
              [
                50.352605,
                34.3804964
              ],
              [
                50.3523285,
                34.3777168
              ],
              [
                50.3531617,
                34.3743867
              ],
              [
                50.3528851,
                34.374107
              ],
              [
                50.3601083,
                34.3493886
              ],
              [
                50.3601083,
                34.3488291
              ],
              [
                50.3614951,
                34.3468888
              ],
              [
                50.36219,
                34.3461939
              ],
              [
                50.3626084,
                34.3460586
              ],
              [
                50.3659417,
                34.3427193
              ],
              [
                50.3701081,
                34.3346602
              ],
              [
                50.380385,
                34.3263305
              ],
              [
                50.380385,
                34.3260506
              ],
              [
                50.3809416,
                34.3249407
              ],
              [
                50.3809416,
                34.3241103
              ],
              [
                50.3812182,
                34.3238305
              ],
              [
                50.3817749,
                34.3238305
              ],
              [
                50.3823315,
                34.323271
              ],
              [
                50.3831647,
                34.3230002
              ],
              [
                50.3962212,
                34.3135513
              ],
              [
                50.4145545,
                34.2924421
              ],
              [
                50.4151111,
                34.2910522
              ],
              [
                50.4176112,
                34.2871625
              ],
              [
                50.4189979,
                34.2849423
              ],
              [
                50.4192781,
                34.2843917
              ],
              [
                50.4245543,
                34.2774425
              ],
              [
                50.4348342,
                34.2491037
              ],
              [
                50.4353878,
                34.2466037
              ],
              [
                50.4356679,
                34.2460532
              ],
              [
                50.4351108,
                34.2371633
              ],
              [
                50.4323343,
                34.2252139
              ],
              [
                50.4317777,
                34.2246633
              ],
              [
                50.4287213,
                34.2154936
              ],
              [
                50.4284443,
                34.211324
              ],
              [
                50.4323343,
                34.2068835
              ],
              [
                50.4387212,
                34.2029935
              ],
              [
                50.4415009,
                34.2016036
              ],
              [
                50.4420545,
                34.2010531
              ],
              [
                50.4651107,
                34.1907731
              ],
              [
                50.4667807,
                34.1907731
              ],
              [
                50.4676139,
                34.1904934
              ],
              [
                50.472334,
                34.1904934
              ],
              [
                50.4731672,
                34.1907732
              ],
              [
                50.474834,
                34.1907731
              ],
              [
                50.4770571,
                34.1902136
              ],
              [
                50.4784474,
                34.1902135
              ],
              [
                50.4792806,
                34.1899337
              ],
              [
                50.4815005,
                34.189663
              ],
              [
                50.4940036,
                34.1907732
              ],
              [
                50.494557,
                34.1904934
              ],
              [
                50.4953903,
                34.1904934
              ],
              [
                50.4962236,
                34.1902136
              ],
              [
                50.4990037,
                34.1902136
              ],
              [
                50.4998369,
                34.1899338
              ],
              [
                50.5056702,
                34.1899338
              ],
              [
                50.50928,
                34.1899339
              ],
              [
                50.5170602,
                34.1899339
              ],
              [
                50.5317832,
                34.1943834
              ],
              [
                50.5340032,
                34.1954936
              ],
              [
                50.5351165,
                34.1954935
              ],
              [
                50.5545594,
                34.2029937
              ],
              [
                50.5639676,
                34.2043168
              ],
              [
                50.5755453,
                34.2114958
              ],
              [
                50.583887,
                34.2152801
              ],
              [
                50.5916305,
                34.2194898
              ],
              [
                50.6023523,
                34.2240108
              ],
              [
                50.6174772,
                34.2280177
              ],
              [
                50.640294,
                34.2330941
              ],
              [
                50.6585597,
                34.2367831
              ],
              [
                50.6771645,
                34.2377102
              ],
              [
                50.6927487,
                34.2353366
              ],
              [
                50.7050142,
                34.2334916
              ],
              [
                50.7131241,
                34.2313587
              ],
              [
                50.7188437,
                34.2282232
              ],
              [
                50.7248633,
                34.2264236
              ],
              [
                50.7360823,
                34.2248623
              ],
              [
                50.7502237,
                34.222883
              ],
              [
                50.7596978,
                34.2180179
              ],
              [
                50.7742082,
                34.213951
              ],
              [
                50.7762434,
                34.2276189
              ],
              [
                50.778494,
                34.2400948
              ],
              [
                50.7788648,
                34.2496514
              ],
              [
                50.7817185,
                34.2679788
              ],
              [
                50.7858517,
                34.2813775
              ],
              [
                50.7798953,
                34.2975157
              ],
              [
                50.7783918,
                34.3126005
              ],
              [
                50.7729656,
                34.3298688
              ],
              [
                50.7690756,
                34.346058
              ],
              [
                50.7661056,
                34.3530736
              ],
              [
                50.7556342,
                34.3646938
              ],
              [
                50.7436812,
                34.3729387
              ],
              [
                50.7309058,
                34.3880958
              ],
              [
                50.7272243,
                34.3938081
              ],
              [
                50.7249927,
                34.405281
              ],
              [
                50.7297188,
                34.4338645
              ],
              [
                50.7380252,
                34.4517883
              ],
              [
                50.7477183,
                34.4649228
              ],
              [
                50.7558271,
                34.4710522
              ],
              [
                50.7685212,
                34.4810482
              ],
              [
                50.7900922,
                34.5021711
              ],
              [
                50.7922256,
                34.5046027
              ],
              [
                50.7929083,
                34.5220561
              ],
              [
                50.79346,
                34.5278177
              ],
              [
                50.7992162,
                34.5285346
              ],
              [
                50.8070203,
                34.5297627
              ],
              [
                50.8120184,
                34.531677
              ],
              [
                50.8240753,
                34.5372029
              ],
              [
                50.8367021,
                34.5431438
              ],
              [
                50.8430155,
                34.5462676
              ],
              [
                50.8462287,
                34.5479923
              ],
              [
                50.8492472,
                34.5503676
              ],
              [
                50.8470403,
                34.5515907
              ],
              [
                50.8426306,
                34.554005
              ],
              [
                50.8400634,
                34.5556965
              ],
              [
                50.8378333,
                34.5571658
              ],
              [
                50.8358994,
                34.558701
              ],
              [
                50.8315237,
                34.5621745
              ],
              [
                50.8304483,
                34.5630986
              ],
              [
                50.8300527,
                34.5634386
              ],
              [
                50.8319479,
                34.5650815
              ],
              [
                50.8470079,
                34.5794356
              ],
              [
                50.8585436,
                34.5736265
              ],
              [
                50.8698107,
                34.5693868
              ],
              [
                50.8878523,
                34.5608062
              ],
              [
                50.9324156,
                34.5321603
              ],
              [
                50.9423375,
                34.5268289
              ],
              [
                50.9561725,
                34.5261946
              ],
              [
                50.9640311,
                34.5250151
              ],
              [
                50.9684954,
                34.5237412
              ],
              [
                50.9717987,
                34.5191598
              ],
              [
                50.9743045,
                34.5115987
              ],
              [
                50.9730874,
                34.5017459
              ],
              [
                50.9763238,
                34.4990765
              ],
              [
                51.0005635,
                34.4792014
              ],
              [
                51.0059032,
                34.4790934
              ],
              [
                51.018362,
                34.4707598
              ],
              [
                51.0314376,
                34.4594562
              ],
              [
                51.0535525,
                34.4463439
              ],
              [
                51.06964,
                34.4387453
              ],
              [
                51.0870603,
                34.4301516
              ],
              [
                51.0984201,
                34.4217243
              ],
              [
                51.1062723,
                34.4166048
              ],
              [
                51.115727,
                34.4170262
              ],
              [
                51.1201422,
                34.4285521
              ],
              [
                51.1229187,
                34.4302216
              ],
              [
                51.1273654,
                34.4327213
              ],
              [
                51.1431986,
                34.4377208
              ],
              [
                51.1459752,
                34.438551
              ],
              [
                51.1473651,
                34.4391105
              ],
              [
                51.1773681,
                34.4443897
              ],
              [
                51.1793115,
                34.4443896
              ],
              [
                51.1807015,
                34.4446694
              ],
              [
                51.188758,
                34.4446694
              ],
              [
                51.1959778,
                34.4449402
              ],
              [
                51.1973679,
                34.4452199
              ],
              [
                51.2020912,
                34.44522
              ],
              [
                51.209591,
                34.4454997
              ],
              [
                51.2309809,
                34.4463299
              ],
              [
                51.2315375,
                34.4466097
              ],
              [
                51.2568138,
                34.4460592
              ],
              [
                51.2865402,
                34.4438393
              ],
              [
                51.2920933,
                34.4430001
              ],
              [
                51.2945933,
                34.443
              ],
              [
                51.29626,
                34.4427203
              ],
              [
                51.3001499,
                34.4427203
              ],
              [
                51.3068164,
                34.4421699
              ],
              [
                51.3101499,
                34.4416104
              ],
              [
                51.3110491,
                34.4416104
              ],
              [
                51.3115398,
                34.4416104
              ],
              [
                51.3120964,
                34.4413397
              ],
              [
                51.3220964,
                34.4416104
              ],
              [
                51.3235613,
                34.4410598
              ],
              [
                51.3259785,
                34.4410284
              ],
              [
                51.3625594,
                34.445794
              ],
              [
                51.379599,
                34.4479996
              ],
              [
                51.3907088,
                34.4502285
              ],
              [
                51.4054319,
                34.4527282
              ],
              [
                51.4123786,
                34.4541089
              ],
              [
                51.4321016,
                34.4571681
              ],
              [
                51.4387682,
                34.4585579
              ],
              [
                51.5018274,
                34.4682858
              ],
              [
                51.5054374,
                34.4682859
              ],
              [
                51.5062134,
                34.4683496
              ],
              [
                51.5154373,
                34.469107
              ],
              [
                51.5726632,
                34.4760556
              ],
              [
                51.5832197,
                34.477725
              ],
              [
                51.6046094,
                34.4821739
              ],
              [
                51.6062761,
                34.4821738
              ],
              [
                51.6284991,
                34.4866137
              ],
              [
                51.6293326,
                34.4866136
              ],
              [
                51.6304425,
                34.4871731
              ],
              [
                51.6318324,
                34.4874529
              ],
              [
                51.6326658,
                34.4874529
              ],
              [
                51.6337758,
                34.4880034
              ],
              [
                51.6682221,
                34.4927229
              ],
              [
                51.6790586,
                34.4938329
              ],
              [
                51.6810018,
                34.4941126
              ],
              [
                51.6837784,
                34.4941126
              ],
              [
                51.6948917,
                34.4952225
              ],
              [
                51.7076681,
                34.4971718
              ],
              [
                51.710448,
                34.4974514
              ],
              [
                51.7129481,
                34.498002
              ],
              [
                51.7143382,
                34.4980019
              ],
              [
                51.716838,
                34.4985614
              ],
              [
                51.8007816,
                34.510984
              ],
              [
                51.8098967,
                34.5094458
              ],
              [
                51.82851,
                34.5055009
              ],
              [
                51.8321199,
                34.5055008
              ],
              [
                51.8341678,
                34.5059559
              ],
              [
                51.8337865,
                34.5068905
              ],
              [
                51.8335099,
                34.5071703
              ],
              [
                51.8337865,
                34.5082802
              ],
              [
                51.8348966,
                34.5099496
              ],
              [
                51.8351766,
                34.5105
              ],
              [
                51.8360101,
                34.5121695
              ],
              [
                51.83712,
                34.5163384
              ],
              [
                51.8387866,
                34.5230069
              ],
              [
                51.839545,
                34.5237742
              ],
              [
                51.8407554,
                34.5329227
              ],
              [
                51.8412099,
                34.5548442
              ],
              [
                51.8403823,
                34.5680611
              ],
              [
                51.8503768,
                34.5678171
              ],
              [
                51.8557255,
                34.5736958
              ],
              [
                51.8619819,
                34.5833108
              ],
              [
                51.8848992,
                34.6291226
              ],
              [
                51.8885126,
                34.635511
              ],
              [
                51.9135122,
                34.6955133
              ],
              [
                51.9143454,
                34.6969028
              ],
              [
                51.9157355,
                34.7010622
              ],
              [
                51.9176787,
                34.704951
              ],
              [
                51.9279585,
                34.7335616
              ],
              [
                51.9329584,
                34.7521748
              ],
              [
                51.9343568,
                34.7593378
              ],
              [
                51.9376784,
                34.7763456
              ],
              [
                51.9379583,
                34.776896
              ],
              [
                51.9390683,
                34.7846731
              ],
              [
                51.9401818,
                34.7955087
              ],
              [
                51.9487915,
                34.8257865
              ],
              [
                51.9504581,
                34.8343934
              ],
              [
                51.9590713,
                34.8580124
              ],
              [
                51.9649046,
                34.8652387
              ],
              [
                51.962958,
                34.8677287
              ],
              [
                51.9524014,
                34.8738453
              ],
              [
                51.9521246,
                34.8743957
              ],
              [
                51.9354584,
                34.8830113
              ],
              [
                51.9351782,
                34.8832909
              ],
              [
                51.9073521,
                34.8951647
              ],
              [
                51.8487359,
                34.9251713
              ],
              [
                51.8290129,
                34.9348878
              ],
              [
                51.8098465,
                34.946282
              ],
              [
                51.7758234,
                34.9626219
              ],
              [
                51.7747135,
                34.9631722
              ],
              [
                51.7327673,
                34.9909414
              ],
              [
                51.7308239,
                34.9923488
              ],
              [
                51.7219341,
                34.9959575
              ],
              [
                51.7183207,
                34.9970671
              ],
              [
                51.7069308,
                34.9998458
              ],
              [
                51.6922112,
                35.0026244
              ],
              [
                51.6894311,
                35.0029041
              ],
              [
                51.6863744,
                35.0031838
              ],
              [
                51.6833688,
                35.0031775
              ],
              [
                51.6794313,
                35.0029041
              ],
              [
                51.674988,
                35.0026244
              ],
              [
                51.650445,
                35.008287
              ],
              [
                51.6459982,
                35.0080164
              ],
              [
                51.6421116,
                35.0077368
              ],
              [
                51.6384983,
                35.0077368
              ],
              [
                51.6365551,
                35.0077368
              ],
              [
                51.6321085,
                35.0080164
              ],
              [
                51.6193319,
                35.0099559
              ],
              [
                51.614332,
                35.0110744
              ],
              [
                51.5993289,
                35.0177316
              ],
              [
                51.5874823,
                35.0254863
              ],
              [
                51.5473918,
                35.0641688
              ],
              [
                51.5408083,
                35.070961
              ],
              [
                51.5359071,
                35.0750509
              ],
              [
                51.5297971,
                35.0775504
              ],
              [
                51.5229589,
                35.0792221
              ],
              [
                51.5157356,
                35.080332
              ],
              [
                51.4754534,
                35.0876352
              ],
              [
                51.4480369,
                35.0929204
              ],
              [
                51.4464176,
                35.0932326
              ],
              [
                51.4442626,
                35.0934499
              ],
              [
                51.4405978,
                35.0938196
              ],
              [
                51.4404723,
                35.0937979
              ],
              [
                51.398988,
                35.1047632
              ],
              [
                51.3620884,
                35.1057775
              ],
              [
                51.328259,
                35.1222607
              ],
              [
                51.3196491,
                35.1247599
              ],
              [
                51.3107592,
                35.1267086
              ],
              [
                51.2687771,
                35.1449482
              ],
              [
                51.2459973,
                35.1505134
              ],
              [
                51.2217869,
                35.1587667
              ],
              [
                51.2209536,
                35.1590464
              ],
              [
                51.2190068,
                35.1590464
              ],
              [
                51.1837272,
                35.1662716
              ],
              [
                51.1776174,
                35.1668309
              ],
              [
                51.158404,
                35.173526
              ],
              [
                51.146254,
                35.1802358
              ],
              [
                51.1451407,
                35.1805155
              ],
              [
                51.1406974,
                35.1805155
              ],
              [
                51.1398642,
                35.1802358
              ],
              [
                51.1320876,
                35.1802358
              ],
              [
                51.1227321,
                35.1845114
              ],
              [
                51.1174221,
                35.187487
              ],
              [
                51.1117675,
                35.1913417
              ],
              [
                51.1037144,
                35.1927298
              ],
              [
                51.0981577,
                35.1927298
              ],
              [
                51.096211,
                35.1927298
              ],
              [
                51.0903361,
                35.1960954
              ],
              [
                51.0878363,
                35.1960953
              ],
              [
                51.0872797,
                35.1963748
              ],
              [
                51.0828364,
                35.1963747
              ],
              [
                51.082003,
                35.1966542
              ],
              [
                51.0721996,
                35.2005718
              ],
              [
                51.0719231,
                35.2008512
              ],
              [
                51.0710896,
                35.2008511
              ],
              [
                51.0708131,
                35.2005717
              ],
              [
                51.0691464,
                35.2005717
              ],
              [
                51.0680331,
                35.2008512
              ],
              [
                51.0603947,
                35.2037967
              ],
              [
                51.0592847,
                35.2040762
              ],
              [
                51.0590081,
                35.2037967
              ],
              [
                51.0520531,
                35.2061812
              ],
              [
                51.0489966,
                35.2061812
              ],
              [
                51.0375902,
                35.2106694
              ],
              [
                51.0364768,
                35.2109488
              ],
              [
                51.0331435,
                35.2109489
              ],
              [
                51.0320335,
                35.2112281
              ],
              [
                51.0273102,
                35.2114985
              ],
              [
                51.0195337,
                35.2131658
              ],
              [
                51.0181436,
                35.2131658
              ],
              [
                51.0145337,
                35.2142741
              ],
              [
                51.0134203,
                35.2142742
              ],
              [
                50.993821,
                35.2151123
              ],
              [
                50.992711,
                35.2151123
              ],
              [
                50.983541,
                35.2184467
              ],
              [
                50.9498385,
                35.2181248
              ],
              [
                50.9110829,
                35.2174937
              ],
              [
                50.9077495,
                35.2186113
              ],
              [
                50.8712169,
                35.2137184
              ],
              [
                50.8431728,
                35.2145523
              ],
              [
                50.8470742,
                35.1708012
              ],
              [
                50.8334612,
                35.1644063
              ],
              [
                50.8326277,
                35.1644063
              ],
              [
                50.8317945,
                35.1638471
              ],
              [
                50.8231812,
                35.1607984
              ],
              [
                50.8204046,
                35.1596891
              ],
              [
                50.8195714,
                35.1591299
              ],
              [
                50.8165147,
                35.1580205
              ],
              [
                50.8159613,
                35.1574612
              ],
              [
                50.8065149,
                35.1524643
              ],
              [
                50.7720685,
                35.1141302
              ],
              [
                50.7706819,
                35.1116317
              ],
              [
                50.7704018,
                35.1107929
              ],
              [
                50.7673454,
                35.1057958
              ],
              [
                50.7584589,
                35.0971817
              ],
              [
                50.7570688,
                35.0969112
              ],
              [
                50.7567922,
                35.0966225
              ],
              [
                50.7540122,
                35.0952424
              ],
              [
                50.7537355,
                35.0946831
              ],
              [
                50.7512355,
                35.0930145
              ],
              [
                50.7195659,
                35.0705181
              ],
              [
                50.7003995,
                35.0477418
              ],
              [
                50.6970663,
                35.044684
              ],
              [
                50.6959565,
                35.0441247
              ],
              [
                50.6956764,
                35.0435744
              ],
              [
                50.6715099,
                35.0319019
              ],
              [
                50.66512,
                35.0299625
              ],
              [
                50.654287,
                35.0193994
              ],
              [
                50.6537302,
                35.0182898
              ],
              [
                50.6517869,
                35.0138427
              ],
              [
                50.6512302,
                35.0102344
              ],
              [
                50.6506736,
                35.008286
              ],
              [
                50.6498404,
                34.9996803
              ],
              [
                50.6534538,
                34.9944031
              ],
              [
                50.65873,
                34.9885666
              ],
              [
                50.6603969,
                34.9877367
              ],
              [
                50.6806767,
                34.9710662
              ],
              [
                50.6809532,
                34.9705159
              ],
              [
                50.6820665,
                34.9694063
              ],
              [
                50.6823435,
                34.9685675
              ],
              [
                50.6845665,
                34.9663482
              ],
              [
                50.6845666,
                34.965789
              ],
              [
                50.6851197,
                34.9652386
              ],
              [
                50.6923434,
                34.9518966
              ],
              [
                50.6934567,
                34.9485678
              ],
              [
                50.6934567,
                34.9357939
              ],
              [
                50.6942899,
                34.9324561
              ],
              [
                50.6942898,
                34.9318968
              ],
              [
                50.6942899,
                34.9316261
              ],
              [
                50.6945665,
                34.9310668
              ],
              [
                50.6945664,
                34.9299572
              ],
              [
                50.6962334,
                34.9238408
              ],
              [
                50.6981764,
                34.9130063
              ],
              [
                50.6984564,
                34.9110666
              ],
              [
                50.6998432,
                34.9052388
              ],
              [
                50.7001233,
                34.9041202
              ],
              [
                50.7006765,
                34.9016213
              ],
              [
                50.7009565,
                34.8999613
              ],
              [
                50.701233,
                34.8980127
              ],
              [
                50.70151,
                34.8963437
              ],
              [
                50.7017898,
                34.8941244
              ],
              [
                50.7020667,
                34.8938449
              ],
              [
                50.7020667,
                34.8907865
              ],
              [
                50.7037331,
                34.8899566
              ],
              [
                50.7042898,
                34.8899565
              ],
              [
                50.7095665,
                34.8882876
              ],
              [
                50.7106763,
                34.8882876
              ],
              [
                50.7109564,
                34.8880079
              ],
              [
                50.720123,
                34.886348
              ],
              [
                50.7234562,
                34.8849497
              ],
              [
                50.7265129,
                34.883849
              ],
              [
                50.7278995,
                34.883849
              ],
              [
                50.7281795,
                34.8835694
              ],
              [
                50.729013,
                34.8835694
              ],
              [
                50.7306796,
                34.8827303
              ],
              [
                50.7315128,
                34.8827304
              ],
              [
                50.7317896,
                34.8824507
              ],
              [
                50.7384562,
                34.8794015
              ],
              [
                50.7390128,
                34.8791217
              ],
              [
                50.7573458,
                34.8705062
              ],
              [
                50.7706824,
                34.8632889
              ],
              [
                50.7709589,
                34.8627295
              ],
              [
                50.7715159,
                34.8624589
              ],
              [
                50.7729024,
                34.8616289
              ],
              [
                50.7787357,
                34.8566218
              ],
              [
                50.7790156,
                34.8557828
              ],
              [
                50.7812356,
                34.8510646
              ],
              [
                50.7815157,
                34.8502345
              ],
              [
                50.7817922,
                34.8496751
              ],
              [
                50.7817922,
                34.8488452
              ],
              [
                50.7840156,
                34.8449568
              ],
              [
                50.7854023,
                34.8413481
              ],
              [
                50.7876255,
                34.8374507
              ],
              [
                50.7879057,
                34.8369003
              ],
              [
                50.7879057,
                34.8360703
              ],
              [
                50.7884588,
                34.8349516
              ],
              [
                50.7892923,
                34.8271748
              ],
              [
                50.7895724,
                34.8269041
              ],
              [
                50.7895723,
                34.8257854
              ],
              [
                50.791239,
                34.8207872
              ],
              [
                50.7915156,
                34.8199572
              ],
              [
                50.7915155,
                34.8193978
              ],
              [
                50.7915156,
                34.8135607
              ],
              [
                50.7917923,
                34.8127306
              ],
              [
                50.7920722,
                34.812451
              ],
              [
                50.7976254,
                34.8027342
              ],
              [
                50.7987388,
                34.8016155
              ],
              [
                50.8015154,
                34.8002261
              ],
              [
                50.8079054,
                34.7991255
              ],
              [
                50.8098488,
                34.7991255
              ],
              [
                50.8104054,
                34.7988458
              ],
              [
                50.8126287,
                34.7988457
              ],
              [
                50.8129053,
                34.798566
              ],
              [
                50.8134622,
                34.7985661
              ],
              [
                50.8137387,
                34.7982864
              ],
              [
                50.8154054,
                34.7977361
              ],
              [
                50.815962,
                34.7971767
              ],
              [
                50.8176286,
                34.7963467
              ],
              [
                50.8206818,
                34.7918988
              ],
              [
                50.8215153,
                34.7893996
              ],
              [
                50.8212387,
                34.7852314
              ],
              [
                50.8212387,
                34.7813427
              ],
              [
                50.8215152,
                34.7796738
              ],
              [
                50.8217954,
                34.7788436
              ],
              [
                50.8242952,
                34.7724559
              ],
              [
                50.8242953,
                34.7720636
              ],
              [
                50.8248486,
                34.7713372
              ],
              [
                50.8248485,
                34.7710665
              ],
              [
                50.8248485,
                34.7705071
              ],
              [
                50.824572,
                34.7682877
              ],
              [
                50.818182,
                34.7610608
              ],
              [
                50.8137388,
                34.759121
              ],
              [
                50.8129054,
                34.759121
              ],
              [
                50.8117954,
                34.7585617
              ],
              [
                50.8109622,
                34.7585617
              ],
              [
                50.8054056,
                34.7566218
              ],
              [
                50.804292,
                34.7566218
              ],
              [
                50.8034589,
                34.7563421
              ],
              [
                50.7995723,
                34.7563422
              ],
              [
                50.7990157,
                34.7566218
              ],
              [
                50.7956824,
                34.7568924
              ],
              [
                50.7815158,
                34.7563421
              ],
              [
                50.7804026,
                34.7566218
              ],
              [
                50.7737357,
                34.7568924
              ],
              [
                50.772626,
                34.7566218
              ],
              [
                50.7706827,
                34.7566217
              ],
              [
                50.7692926,
                34.756342
              ],
              [
                50.7642927,
                34.7563421
              ],
              [
                50.7606793,
                34.7568924
              ],
              [
                50.7587361,
                34.7568924
              ],
              [
                50.7520696,
                34.756342
              ],
              [
                50.7484562,
                34.7560624
              ],
              [
                50.7476227,
                34.756342
              ],
              [
                50.7462363,
                34.7563421
              ],
              [
                50.7448464,
                34.7566217
              ],
              [
                50.7398462,
                34.7571721
              ],
              [
                50.7370697,
                34.7571721
              ],
              [
                50.7356797,
                34.7574518
              ],
              [
                50.7320698,
                34.7574517
              ],
              [
                50.7309564,
                34.7577314
              ],
              [
                50.7237332,
                34.7588412
              ],
              [
                50.7217898,
                34.7588412
              ],
              [
                50.7203999,
                34.7591209
              ],
              [
                50.7165134,
                34.7591208
              ],
              [
                50.7156799,
                34.7588412
              ],
              [
                50.7140132,
                34.7588412
              ],
              [
                50.7117901,
                34.7582818
              ],
              [
                50.7101234,
                34.7582818
              ],
              [
                50.7078999,
                34.7577315
              ],
              [
                50.6909534,
                34.7585615
              ],
              [
                50.6834536,
                34.7585615
              ],
              [
                50.6817868,
                34.7582817
              ],
              [
                50.6792871,
                34.7582818
              ],
              [
                50.6776203,
                34.7580021
              ],
              [
                50.6731772,
                34.7577314
              ],
              [
                50.6728972,
                34.758002
              ],
              [
                50.6662307,
                34.7577314
              ],
              [
                50.654564,
                34.7580021
              ],
              [
                50.6517874,
                34.7580021
              ],
              [
                50.6506741,
                34.7582817
              ],
              [
                50.6467873,
                34.7582817
              ],
              [
                50.6462306,
                34.7585614
              ],
              [
                50.6426208,
                34.7585614
              ],
              [
                50.6420641,
                34.7582817
              ],
              [
                50.6417876,
                34.7585614
              ],
              [
                50.6409544,
                34.7582817
              ],
              [
                50.6395641,
                34.7582817
              ],
              [
                50.6356742,
                34.7563419
              ],
              [
                50.6242845,
                34.7430069
              ],
              [
                50.6181746,
                34.7263423
              ],
              [
                50.617618,
                34.7232836
              ],
              [
                50.6162277,
                34.7157858
              ],
              [
                50.615118,
                34.6941225
              ],
              [
                50.6123972,
                34.6856659
              ],
              [
                50.6073504,
                34.6764974
              ],
              [
                50.6030503,
                34.6639605
              ],
              [
                50.6032305,
                34.6601059
              ],
              [
                50.6034623,
                34.6565264
              ],
              [
                50.605033,
                34.6541118
              ],
              [
                50.6083289,
                34.6522478
              ],
              [
                50.6110804,
                34.6519736
              ],
              [
                50.6128047,
                34.646534
              ],
              [
                50.6122897,
                34.6392043
              ],
              [
                50.6072171,
                34.634035
              ],
              [
                50.6009514,
                34.631332
              ],
              [
                50.5790052,
                34.6266128
              ],
              [
                50.5478921,
                34.6263421
              ],
              [
                50.5470589,
                34.6266128
              ],
              [
                50.5456721,
                34.6266128
              ],
              [
                50.545392,
                34.6268924
              ],
              [
                50.5440057,
                34.6268925
              ],
              [
                50.5401157,
                34.6277316
              ],
              [
                50.534559,
                34.6285617
              ],
              [
                50.530116,
                34.6293919
              ],
              [
                50.528169,
                34.6293919
              ],
              [
                50.521779,
                34.6299513
              ],
              [
                50.5145594,
                34.6299513
              ],
              [
                50.5023361,
                34.6310612
              ],
              [
                50.4917797,
                34.6310611
              ],
              [
                50.4903898,
                34.6313318
              ],
              [
                50.4873362,
                34.6313317
              ],
              [
                50.4781665,
                34.633001
              ],
              [
                50.476223,
                34.633001
              ],
              [
                50.4734464,
                34.6335604
              ],
              [
                50.4706663,
                34.6335605
              ],
              [
                50.4701131,
                34.6338402
              ],
              [
                50.4601098,
                34.6338402
              ],
              [
                50.4598332,
                34.6335605
              ],
              [
                50.459,
                34.6335605
              ],
              [
                50.4584433,
                34.6332807
              ],
              [
                50.4578899,
                34.6335604
              ],
              [
                50.4573332,
                34.6335604
              ],
              [
                50.4570566,
                34.6332807
              ],
              [
                50.4565,
                34.6335604
              ],
              [
                50.4551101,
                34.6335604
              ],
              [
                50.4548335,
                34.6338402
              ],
              [
                50.4542764,
                34.6338402
              ],
              [
                50.4537234,
                34.6341199
              ],
              [
                50.4226106,
                34.6413383
              ],
              [
                50.4209437,
                34.6413383
              ],
              [
                50.4145538,
                34.6427278
              ],
              [
                50.4128873,
                34.6427279
              ],
              [
                50.4123307,
                34.6430075
              ],
              [
                50.4095541,
                34.6430076
              ],
              [
                50.409274,
                34.6432873
              ],
              [
                50.4059408,
                34.6432872
              ],
              [
                50.4053873,
                34.6430076
              ],
              [
                50.4045539,
                34.6432873
              ],
              [
                50.4042739,
                34.6430075
              ],
              [
                50.4003875,
                34.6430076
              ],
              [
                50.4001075,
                34.6427278
              ],
              [
                50.3992742,
                34.6427278
              ],
              [
                50.3987206,
                34.6427278
              ],
              [
                50.395664,
                34.6427278
              ],
              [
                50.3917956,
                34.6430229
              ],
              [
                50.3906111,
                34.6427475
              ],
              [
                50.3787175,
                34.6427278
              ],
              [
                50.3706611,
                34.6427278
              ],
              [
                50.3698279,
                34.6424481
              ],
              [
                50.3676078,
                34.6424481
              ],
              [
                50.3634411,
                34.6418976
              ],
              [
                50.3626078,
                34.6416179
              ],
              [
                50.3614945,
                34.6416179
              ],
              [
                50.3606613,
                34.6413382
              ],
              [
                50.3592745,
                34.6413382
              ],
              [
                50.3276048,
                34.6335603
              ],
              [
                50.3106583,
                34.6305014
              ],
              [
                50.3001054,
                34.6291209
              ],
              [
                50.2989921,
                34.6288412
              ],
              [
                50.2973252,
                34.6288411
              ],
              [
                50.2959354,
                34.6285615
              ],
              [
                50.2953818,
                34.6285614
              ],
              [
                50.2906587,
                34.6282817
              ],
              [
                50.2717689,
                34.6263417
              ],
              [
                50.2689922,
                34.6257822
              ],
              [
                50.2642691,
                34.6257822
              ],
              [
                50.2626023,
                34.6255025
              ],
              [
                50.2556557,
                34.6255026
              ],
              [
                50.2545459,
                34.6252228
              ],
              [
                50.2448226,
                34.6252228
              ],
              [
                50.2428792,
                34.6249431
              ],
              [
                50.2295462,
                34.6249431
              ],
              [
                50.2281562,
                34.6246724
              ],
              [
                50.2220464,
                34.6249431
              ],
              [
                50.2214898,
                34.6252228
              ],
              [
                50.2184329,
                34.6252227
              ],
              [
                50.2175997,
                34.6255025
              ],
              [
                50.2159329,
                34.6255025
              ],
              [
                50.1739867,
                34.6341195
              ],
              [
                50.172597,
                34.6341195
              ],
              [
                50.1717636,
                34.6343902
              ],
              [
                50.1106511,
                34.6324501
              ],
              [
                50.1092482,
                34.6323985
              ],
              [
                50.1081511,
                34.6238331
              ],
              [
                50.1014845,
                34.6116156
              ],
              [
                50.1014846,
                34.6110562
              ],
              [
                50.0864812,
                34.5860616
              ],
              [
                50.0862046,
                34.5835621
              ],
              [
                50.0864671,
                34.5830887
              ],
              [
                50.0864811,
                34.5823911
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555439,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جعفرآباد",
          "name:en": "Jafarabad County",
          "name:fa": "شهرستان جعفرآباد",
          "place": "district",
          "source": "https://dotic.ir/news/9158",
          "type": "boundary",
          "wikidata": "Q109554931",
          "wikipedia": "fa:شهرستان جعفرآباد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.1092482,
                34.6323985
              ],
              [
                50.1106511,
                34.6324501
              ],
              [
                50.1717636,
                34.6343902
              ],
              [
                50.172597,
                34.6341195
              ],
              [
                50.1739867,
                34.6341195
              ],
              [
                50.2159329,
                34.6255025
              ],
              [
                50.2175997,
                34.6255025
              ],
              [
                50.2184329,
                34.6252227
              ],
              [
                50.2214898,
                34.6252228
              ],
              [
                50.2220464,
                34.6249431
              ],
              [
                50.2281562,
                34.6246724
              ],
              [
                50.2295462,
                34.6249431
              ],
              [
                50.2428792,
                34.6249431
              ],
              [
                50.2448226,
                34.6252228
              ],
              [
                50.2545459,
                34.6252228
              ],
              [
                50.2556557,
                34.6255026
              ],
              [
                50.2626023,
                34.6255025
              ],
              [
                50.2642691,
                34.6257822
              ],
              [
                50.2689922,
                34.6257822
              ],
              [
                50.2717689,
                34.6263417
              ],
              [
                50.2906587,
                34.6282817
              ],
              [
                50.2953818,
                34.6285614
              ],
              [
                50.2959354,
                34.6285615
              ],
              [
                50.2973252,
                34.6288411
              ],
              [
                50.2989921,
                34.6288412
              ],
              [
                50.3001054,
                34.6291209
              ],
              [
                50.3106583,
                34.6305014
              ],
              [
                50.3276048,
                34.6335603
              ],
              [
                50.3592745,
                34.6413382
              ],
              [
                50.3606613,
                34.6413382
              ],
              [
                50.3614945,
                34.6416179
              ],
              [
                50.3626078,
                34.6416179
              ],
              [
                50.3634411,
                34.6418976
              ],
              [
                50.3676078,
                34.6424481
              ],
              [
                50.3698279,
                34.6424481
              ],
              [
                50.3706611,
                34.6427278
              ],
              [
                50.3787175,
                34.6427278
              ],
              [
                50.3906111,
                34.6427475
              ],
              [
                50.3917956,
                34.6430229
              ],
              [
                50.395664,
                34.6427278
              ],
              [
                50.3987206,
                34.6427278
              ],
              [
                50.3992742,
                34.6427278
              ],
              [
                50.4001075,
                34.6427278
              ],
              [
                50.4003875,
                34.6430076
              ],
              [
                50.4042739,
                34.6430075
              ],
              [
                50.4045539,
                34.6432873
              ],
              [
                50.4053873,
                34.6430076
              ],
              [
                50.4059408,
                34.6432872
              ],
              [
                50.409274,
                34.6432873
              ],
              [
                50.4095541,
                34.6430076
              ],
              [
                50.4123307,
                34.6430075
              ],
              [
                50.4128873,
                34.6427279
              ],
              [
                50.4145538,
                34.6427278
              ],
              [
                50.4209437,
                34.6413383
              ],
              [
                50.4226106,
                34.6413383
              ],
              [
                50.4537234,
                34.6341199
              ],
              [
                50.4542764,
                34.6338402
              ],
              [
                50.4548335,
                34.6338402
              ],
              [
                50.4551101,
                34.6335604
              ],
              [
                50.4565,
                34.6335604
              ],
              [
                50.4570566,
                34.6332807
              ],
              [
                50.4573332,
                34.6335604
              ],
              [
                50.4578899,
                34.6335604
              ],
              [
                50.4584433,
                34.6332807
              ],
              [
                50.459,
                34.6335605
              ],
              [
                50.4598332,
                34.6335605
              ],
              [
                50.4601098,
                34.6338402
              ],
              [
                50.4701131,
                34.6338402
              ],
              [
                50.4706663,
                34.6335605
              ],
              [
                50.4734464,
                34.6335604
              ],
              [
                50.476223,
                34.633001
              ],
              [
                50.4781665,
                34.633001
              ],
              [
                50.4873362,
                34.6313317
              ],
              [
                50.4903898,
                34.6313318
              ],
              [
                50.4917797,
                34.6310611
              ],
              [
                50.5023361,
                34.6310612
              ],
              [
                50.5145594,
                34.6299513
              ],
              [
                50.521779,
                34.6299513
              ],
              [
                50.528169,
                34.6293919
              ],
              [
                50.530116,
                34.6293919
              ],
              [
                50.534559,
                34.6285617
              ],
              [
                50.5401157,
                34.6277316
              ],
              [
                50.5440057,
                34.6268925
              ],
              [
                50.545392,
                34.6268924
              ],
              [
                50.5456721,
                34.6266128
              ],
              [
                50.5470589,
                34.6266128
              ],
              [
                50.5478921,
                34.6263421
              ],
              [
                50.5790052,
                34.6266128
              ],
              [
                50.6009514,
                34.631332
              ],
              [
                50.6072171,
                34.634035
              ],
              [
                50.6122897,
                34.6392043
              ],
              [
                50.6128047,
                34.646534
              ],
              [
                50.6110804,
                34.6519736
              ],
              [
                50.6083289,
                34.6522478
              ],
              [
                50.605033,
                34.6541118
              ],
              [
                50.6034623,
                34.6565264
              ],
              [
                50.6032305,
                34.6601059
              ],
              [
                50.6030503,
                34.6639605
              ],
              [
                50.6073504,
                34.6764974
              ],
              [
                50.6123972,
                34.6856659
              ],
              [
                50.615118,
                34.6941225
              ],
              [
                50.6162277,
                34.7157858
              ],
              [
                50.617618,
                34.7232836
              ],
              [
                50.6181746,
                34.7263423
              ],
              [
                50.6242845,
                34.7430069
              ],
              [
                50.6356742,
                34.7563419
              ],
              [
                50.6395641,
                34.7582817
              ],
              [
                50.6409544,
                34.7582817
              ],
              [
                50.6417876,
                34.7585614
              ],
              [
                50.6420641,
                34.7582817
              ],
              [
                50.6426208,
                34.7585614
              ],
              [
                50.6462306,
                34.7585614
              ],
              [
                50.6467873,
                34.7582817
              ],
              [
                50.6506741,
                34.7582817
              ],
              [
                50.6517874,
                34.7580021
              ],
              [
                50.654564,
                34.7580021
              ],
              [
                50.6662307,
                34.7577314
              ],
              [
                50.6728972,
                34.758002
              ],
              [
                50.6731772,
                34.7577314
              ],
              [
                50.6776203,
                34.7580021
              ],
              [
                50.6792871,
                34.7582818
              ],
              [
                50.6817868,
                34.7582817
              ],
              [
                50.6834536,
                34.7585615
              ],
              [
                50.6909534,
                34.7585615
              ],
              [
                50.7078999,
                34.7577315
              ],
              [
                50.7101234,
                34.7582818
              ],
              [
                50.7117901,
                34.7582818
              ],
              [
                50.7140132,
                34.7588412
              ],
              [
                50.7156799,
                34.7588412
              ],
              [
                50.7165134,
                34.7591208
              ],
              [
                50.7203999,
                34.7591209
              ],
              [
                50.7217898,
                34.7588412
              ],
              [
                50.7237332,
                34.7588412
              ],
              [
                50.7309564,
                34.7577314
              ],
              [
                50.7320698,
                34.7574517
              ],
              [
                50.7356797,
                34.7574518
              ],
              [
                50.7370697,
                34.7571721
              ],
              [
                50.7398462,
                34.7571721
              ],
              [
                50.7448464,
                34.7566217
              ],
              [
                50.7462363,
                34.7563421
              ],
              [
                50.7476227,
                34.756342
              ],
              [
                50.7484562,
                34.7560624
              ],
              [
                50.7520696,
                34.756342
              ],
              [
                50.7587361,
                34.7568924
              ],
              [
                50.7606793,
                34.7568924
              ],
              [
                50.7642927,
                34.7563421
              ],
              [
                50.7692926,
                34.756342
              ],
              [
                50.7706827,
                34.7566217
              ],
              [
                50.772626,
                34.7566218
              ],
              [
                50.7737357,
                34.7568924
              ],
              [
                50.7804026,
                34.7566218
              ],
              [
                50.7815158,
                34.7563421
              ],
              [
                50.7956824,
                34.7568924
              ],
              [
                50.7990157,
                34.7566218
              ],
              [
                50.7995723,
                34.7563422
              ],
              [
                50.8034589,
                34.7563421
              ],
              [
                50.804292,
                34.7566218
              ],
              [
                50.8054056,
                34.7566218
              ],
              [
                50.8109622,
                34.7585617
              ],
              [
                50.8117954,
                34.7585617
              ],
              [
                50.8129054,
                34.759121
              ],
              [
                50.8137388,
                34.759121
              ],
              [
                50.818182,
                34.7610608
              ],
              [
                50.824572,
                34.7682877
              ],
              [
                50.8248485,
                34.7705071
              ],
              [
                50.8248485,
                34.7710665
              ],
              [
                50.8248486,
                34.7713372
              ],
              [
                50.8242953,
                34.7720636
              ],
              [
                50.8242952,
                34.7724559
              ],
              [
                50.8217954,
                34.7788436
              ],
              [
                50.8215152,
                34.7796738
              ],
              [
                50.8212387,
                34.7813427
              ],
              [
                50.8212387,
                34.7852314
              ],
              [
                50.8215153,
                34.7893996
              ],
              [
                50.8206818,
                34.7918988
              ],
              [
                50.8176286,
                34.7963467
              ],
              [
                50.815962,
                34.7971767
              ],
              [
                50.8154054,
                34.7977361
              ],
              [
                50.8137387,
                34.7982864
              ],
              [
                50.8134622,
                34.7985661
              ],
              [
                50.8129053,
                34.798566
              ],
              [
                50.8126287,
                34.7988457
              ],
              [
                50.8104054,
                34.7988458
              ],
              [
                50.8098488,
                34.7991255
              ],
              [
                50.8079054,
                34.7991255
              ],
              [
                50.8015154,
                34.8002261
              ],
              [
                50.7987388,
                34.8016155
              ],
              [
                50.7976254,
                34.8027342
              ],
              [
                50.7920722,
                34.812451
              ],
              [
                50.7917923,
                34.8127306
              ],
              [
                50.7915156,
                34.8135607
              ],
              [
                50.7915155,
                34.8193978
              ],
              [
                50.7915156,
                34.8199572
              ],
              [
                50.791239,
                34.8207872
              ],
              [
                50.7895723,
                34.8257854
              ],
              [
                50.7895724,
                34.8269041
              ],
              [
                50.7892923,
                34.8271748
              ],
              [
                50.7884588,
                34.8349516
              ],
              [
                50.7879057,
                34.8360703
              ],
              [
                50.7879057,
                34.8369003
              ],
              [
                50.7876255,
                34.8374507
              ],
              [
                50.7854023,
                34.8413481
              ],
              [
                50.7840156,
                34.8449568
              ],
              [
                50.7817922,
                34.8488452
              ],
              [
                50.7817922,
                34.8496751
              ],
              [
                50.7815157,
                34.8502345
              ],
              [
                50.7812356,
                34.8510646
              ],
              [
                50.7790156,
                34.8557828
              ],
              [
                50.7787357,
                34.8566218
              ],
              [
                50.7729024,
                34.8616289
              ],
              [
                50.7715159,
                34.8624589
              ],
              [
                50.7709589,
                34.8627295
              ],
              [
                50.7706824,
                34.8632889
              ],
              [
                50.7573458,
                34.8705062
              ],
              [
                50.7390128,
                34.8791217
              ],
              [
                50.7384562,
                34.8794015
              ],
              [
                50.7317896,
                34.8824507
              ],
              [
                50.7315128,
                34.8827304
              ],
              [
                50.7306796,
                34.8827303
              ],
              [
                50.729013,
                34.8835694
              ],
              [
                50.7281795,
                34.8835694
              ],
              [
                50.7278995,
                34.883849
              ],
              [
                50.7265129,
                34.883849
              ],
              [
                50.7234562,
                34.8849497
              ],
              [
                50.720123,
                34.886348
              ],
              [
                50.7109564,
                34.8880079
              ],
              [
                50.7106763,
                34.8882876
              ],
              [
                50.7095665,
                34.8882876
              ],
              [
                50.7042898,
                34.8899565
              ],
              [
                50.7037331,
                34.8899566
              ],
              [
                50.7020667,
                34.8907865
              ],
              [
                50.7020667,
                34.8899566
              ],
              [
                50.7023433,
                34.8896769
              ],
              [
                50.7023433,
                34.8882877
              ],
              [
                50.7023432,
                34.8857886
              ],
              [
                50.7026234,
                34.88301
              ],
              [
                50.7029,
                34.881341
              ],
              [
                50.7031765,
                34.8799607
              ],
              [
                50.7040097,
                34.8771821
              ],
              [
                50.7042898,
                34.8769024
              ],
              [
                50.7040097,
                34.8766227
              ],
              [
                50.7048433,
                34.8735644
              ],
              [
                50.7045664,
                34.8727344
              ],
              [
                50.7048433,
                34.8713451
              ],
              [
                50.705123,
                34.8682868
              ],
              [
                50.7040097,
                34.8682868
              ],
              [
                50.7034565,
                34.8682868
              ],
              [
                50.7028999,
                34.8680071
              ],
              [
                50.6995667,
                34.8680071
              ],
              [
                50.6895669,
                34.8685665
              ],
              [
                50.6762337,
                34.8685665
              ],
              [
                50.6756767,
                34.8682868
              ],
              [
                50.6720634,
                34.8682868
              ],
              [
                50.6715102,
                34.8685664
              ],
              [
                50.6651202,
                34.8685665
              ],
              [
                50.6642871,
                34.8688461
              ],
              [
                50.6620635,
                34.8688461
              ],
              [
                50.6615104,
                34.8691258
              ],
              [
                50.6601205,
                34.8691257
              ],
              [
                50.659287,
                34.8694054
              ],
              [
                50.6565102,
                34.8696761
              ],
              [
                50.653454,
                34.8696761
              ],
              [
                50.6523403,
                34.8699557
              ],
              [
                50.6506739,
                34.8699558
              ],
              [
                50.6498406,
                34.8702354
              ],
              [
                50.6212311,
                34.8677274
              ],
              [
                50.6028944,
                34.864678
              ],
              [
                50.600951,
                34.8638389
              ],
              [
                50.5998412,
                34.863839
              ],
              [
                50.5981712,
                34.8627294
              ],
              [
                50.5923379,
                34.86051
              ],
              [
                50.5859515,
                34.8582906
              ],
              [
                50.5848381,
                34.8582907
              ],
              [
                50.5845612,
                34.858011
              ],
              [
                50.583728,
                34.858011
              ],
              [
                50.5834513,
                34.8577313
              ],
              [
                50.5826182,
                34.8577313
              ],
              [
                50.5823381,
                34.8574607
              ],
              [
                50.5809515,
                34.857181
              ],
              [
                50.5801181,
                34.8569013
              ],
              [
                50.5765048,
                34.8555119
              ],
              [
                50.5751149,
                34.855512
              ],
              [
                50.5742814,
                34.8552323
              ],
              [
                50.5728949,
                34.8552322
              ],
              [
                50.5720618,
                34.8549526
              ],
              [
                50.5698382,
                34.8549526
              ],
              [
                50.5692816,
                34.8552323
              ],
              [
                50.5617814,
                34.8552322
              ],
              [
                50.5615049,
                34.8555119
              ],
              [
                50.5545583,
                34.8577312
              ],
              [
                50.5473386,
                34.8571809
              ],
              [
                50.5465054,
                34.8574606
              ],
              [
                50.5462252,
                34.8571809
              ],
              [
                50.5445584,
                34.8571809
              ],
              [
                50.5442818,
                34.8574607
              ],
              [
                50.5434486,
                34.8571809
              ],
              [
                50.542892,
                34.8574606
              ],
              [
                50.5420584,
                34.8574606
              ],
              [
                50.5362254,
                34.8596709
              ],
              [
                50.5303921,
                34.8621789
              ],
              [
                50.5226123,
                34.8649576
              ],
              [
                50.5206688,
                34.8649575
              ],
              [
                50.5201122,
                34.8652373
              ],
              [
                50.5184453,
                34.8652373
              ],
              [
                50.5178922,
                34.8655169
              ],
              [
                50.5165024,
                34.8657875
              ],
              [
                50.5087256,
                34.8652372
              ],
              [
                50.501779,
                34.8638389
              ],
              [
                50.4948359,
                34.8618993
              ],
              [
                50.4915026,
                34.8605099
              ],
              [
                50.4903893,
                34.8605099
              ],
              [
                50.4901123,
                34.8602302
              ],
              [
                50.4892791,
                34.8602302
              ],
              [
                50.4881694,
                34.8596708
              ],
              [
                50.4817794,
                34.8566215
              ],
              [
                50.4681662,
                34.844397
              ],
              [
                50.4642763,
                34.8413477
              ],
              [
                50.458443,
                34.8363496
              ],
              [
                50.4551111,
                34.8319907
              ],
              [
                50.451223,
                34.8269037
              ],
              [
                50.4509428,
                34.8243956
              ],
              [
                50.4506663,
                34.8205072
              ],
              [
                50.451223,
                34.8180081
              ],
              [
                50.4501097,
                34.8107905
              ],
              [
                50.4487234,
                34.8035638
              ],
              [
                50.4406666,
                34.7777334
              ],
              [
                50.4398334,
                34.7752343
              ],
              [
                50.4340001,
                34.7574514
              ],
              [
                50.4284433,
                34.7541222
              ],
              [
                50.4181635,
                34.7560619
              ],
              [
                50.4176103,
                34.7557822
              ],
              [
                50.4156638,
                34.7549522
              ],
              [
                50.4153868,
                34.7546724
              ],
              [
                50.4092738,
                34.7519027
              ],
              [
                50.4067737,
                34.7519026
              ],
              [
                50.4059405,
                34.7516229
              ],
              [
                50.4014971,
                34.7516229
              ],
              [
                50.4012205,
                34.7519026
              ],
              [
                50.3948305,
                34.7527326
              ],
              [
                50.3709409,
                34.7585611
              ],
              [
                50.368994,
                34.758561
              ],
              [
                50.3684409,
                34.7588407
              ],
              [
                50.367051,
                34.7588407
              ],
              [
                50.366494,
                34.7591204
              ],
              [
                50.3617743,
                34.7591204
              ],
              [
                50.3587176,
                34.7588407
              ],
              [
                50.3484378,
                34.7588407
              ],
              [
                50.3478846,
                34.7591204
              ],
              [
                50.3412177,
                34.7599505
              ],
              [
                50.3278814,
                34.7680074
              ],
              [
                50.3137147,
                34.7799527
              ],
              [
                50.3120483,
                34.7813422
              ],
              [
                50.2954101,
                34.7998847
              ],
              [
                50.2788544,
                34.808439
              ],
              [
                50.275986,
                34.8097799
              ],
              [
                50.2721849,
                34.8116225
              ],
              [
                50.2684341,
                34.8138197
              ],
              [
                50.2462121,
                34.8141193
              ],
              [
                50.2456555,
                34.8138396
              ],
              [
                50.2426022,
                34.8130096
              ],
              [
                50.2292657,
                34.8132802
              ],
              [
                50.2287125,
                34.8130095
              ],
              [
                50.2178759,
                34.814399
              ],
              [
                50.2148227,
                34.814399
              ],
              [
                50.2139891,
                34.8146786
              ],
              [
                50.1853765,
                34.818567
              ],
              [
                50.1828764,
                34.8193971
              ],
              [
                50.1823197,
                34.8193971
              ],
              [
                50.174263,
                34.8213458
              ],
              [
                50.1730065,
                34.8213116
              ],
              [
                50.1701204,
                34.8210637
              ],
              [
                50.1673968,
                34.8203045
              ],
              [
                50.1620492,
                34.8175437
              ],
              [
                50.1598201,
                34.8143989
              ],
              [
                50.15954,
                34.8135599
              ],
              [
                50.1314836,
                34.7746745
              ],
              [
                50.1220405,
                34.7555112
              ],
              [
                50.1214839,
                34.7510631
              ],
              [
                50.1203741,
                34.7466151
              ],
              [
                50.1203741,
                34.7452257
              ],
              [
                50.1200941,
                34.7441159
              ],
              [
                50.1198171,
                34.7435566
              ],
              [
                50.1195405,
                34.7402272
              ],
              [
                50.119817,
                34.7393971
              ],
              [
                50.1195405,
                34.7388377
              ],
              [
                50.1198171,
                34.7346783
              ],
              [
                50.120094,
                34.7338393
              ],
              [
                50.1206506,
                34.7330093
              ],
              [
                50.1231507,
                34.7249521
              ],
              [
                50.1248172,
                34.7193943
              ],
              [
                50.1245406,
                34.7157852
              ],
              [
                50.1217605,
                34.7102273
              ],
              [
                50.1131506,
                34.698561
              ],
              [
                50.1128741,
                34.6971714
              ],
              [
                50.1134275,
                34.6955113
              ],
              [
                50.1134276,
                34.6952316
              ],
              [
                50.1145409,
                34.6932827
              ],
              [
                50.1139842,
                34.6905037
              ],
              [
                50.1134276,
                34.6899533
              ],
              [
                50.1114842,
                34.6863352
              ],
              [
                50.1081509,
                34.6843952
              ],
              [
                50.1031508,
                34.6755077
              ],
              [
                50.1020375,
                34.6693903
              ],
              [
                50.1023176,
                34.6655013
              ],
              [
                50.1025941,
                34.6643916
              ],
              [
                50.1075943,
                34.6566138
              ],
              [
                50.1096736,
                34.6543289
              ],
              [
                50.1100944,
                34.6538347
              ],
              [
                50.1103741,
                34.6524542
              ],
              [
                50.1106511,
                34.650785
              ],
              [
                50.1109276,
                34.6466163
              ],
              [
                50.1112077,
                34.6463366
              ],
              [
                50.1109277,
                34.6455065
              ],
              [
                50.1092482,
                34.6323985
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6556257,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کهک",
          "name:en": "Kahak County",
          "name:fa": "شهرستان کهک",
          "place": "district",
          "source": "https://dotic.ir/news/9158",
          "type": "boundary",
          "wikipedia": "fa:شهرستان کهک"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.7436812,
                34.3729387
              ],
              [
                50.7556342,
                34.3646938
              ],
              [
                50.7661056,
                34.3530736
              ],
              [
                50.7690756,
                34.346058
              ],
              [
                50.7729656,
                34.3298688
              ],
              [
                50.7783918,
                34.3126005
              ],
              [
                50.7798953,
                34.2975157
              ],
              [
                50.7858517,
                34.2813775
              ],
              [
                50.7817185,
                34.2679788
              ],
              [
                50.7788648,
                34.2496514
              ],
              [
                50.778494,
                34.2400948
              ],
              [
                50.7762434,
                34.2276189
              ],
              [
                50.7742082,
                34.213951
              ],
              [
                50.7840512,
                34.2102926
              ],
              [
                50.7954305,
                34.2050602
              ],
              [
                50.8053588,
                34.2000239
              ],
              [
                50.8098532,
                34.1976995
              ],
              [
                50.815958,
                34.1943017
              ],
              [
                50.8234922,
                34.1898817
              ],
              [
                50.8305247,
                34.1875703
              ],
              [
                50.8501991,
                34.1847255
              ],
              [
                50.8565365,
                34.1838649
              ],
              [
                50.8708035,
                34.1796179
              ],
              [
                50.8811641,
                34.1751681
              ],
              [
                50.8920005,
                34.171589
              ],
              [
                50.8989754,
                34.168421
              ],
              [
                50.9034518,
                34.1657966
              ],
              [
                50.9113343,
                34.1631755
              ],
              [
                50.9177588,
                34.1618173
              ],
              [
                50.9282821,
                34.1593659
              ],
              [
                50.9342602,
                34.1582668
              ],
              [
                50.9380035,
                34.1581799
              ],
              [
                50.9466677,
                34.1590376
              ],
              [
                50.9532061,
                34.1599682
              ],
              [
                50.9587955,
                34.1618893
              ],
              [
                50.9642886,
                34.164517
              ],
              [
                50.9695243,
                34.1692041
              ],
              [
                50.9756183,
                34.1747431
              ],
              [
                50.9794215,
                34.1831032
              ],
              [
                50.9777382,
                34.1892289
              ],
              [
                50.9811114,
                34.2010837
              ],
              [
                50.9892958,
                34.212482
              ],
              [
                50.9946889,
                34.2204261
              ],
              [
                50.9979731,
                34.2280736
              ],
              [
                50.9979,
                34.2355141
              ],
              [
                50.9982299,
                34.2456367
              ],
              [
                51.0044814,
                34.253266
              ],
              [
                51.0094788,
                34.2579192
              ],
              [
                51.0202293,
                34.2694202
              ],
              [
                51.0274739,
                34.2801981
              ],
              [
                51.0314507,
                34.2870175
              ],
              [
                51.0351831,
                34.2941833
              ],
              [
                51.0363014,
                34.2999669
              ],
              [
                51.0360248,
                34.3047654
              ],
              [
                51.0331248,
                34.312532
              ],
              [
                51.029005,
                34.3160767
              ],
              [
                51.0190486,
                34.3228819
              ],
              [
                51.0134177,
                34.3283861
              ],
              [
                51.0123538,
                34.3325927
              ],
              [
                51.0115962,
                34.3383592
              ],
              [
                51.012336,
                34.3438541
              ],
              [
                51.0147809,
                34.3540495
              ],
              [
                51.0184792,
                34.3610443
              ],
              [
                51.0221892,
                34.369401
              ],
              [
                51.0306581,
                34.3800919
              ],
              [
                51.0397978,
                34.3874424
              ],
              [
                51.0467418,
                34.3913004
              ],
              [
                51.0599847,
                34.3958991
              ],
              [
                51.0690321,
                34.3987266
              ],
              [
                51.0778578,
                34.4052138
              ],
              [
                51.0847949,
                34.4119374
              ],
              [
                51.086769,
                34.4159026
              ],
              [
                51.0900306,
                34.417602
              ],
              [
                51.1062723,
                34.4166048
              ],
              [
                51.0984201,
                34.4217243
              ],
              [
                51.0870603,
                34.4301516
              ],
              [
                51.06964,
                34.4387453
              ],
              [
                51.0535525,
                34.4463439
              ],
              [
                51.0314376,
                34.4594562
              ],
              [
                51.018362,
                34.4707598
              ],
              [
                51.0059032,
                34.4790934
              ],
              [
                51.0005635,
                34.4792014
              ],
              [
                50.9763238,
                34.4990765
              ],
              [
                50.9730874,
                34.5017459
              ],
              [
                50.9743045,
                34.5115987
              ],
              [
                50.9717987,
                34.5191598
              ],
              [
                50.9684954,
                34.5237412
              ],
              [
                50.9640311,
                34.5250151
              ],
              [
                50.9561725,
                34.5261946
              ],
              [
                50.9423375,
                34.5268289
              ],
              [
                50.9324156,
                34.5321603
              ],
              [
                50.8878523,
                34.5608062
              ],
              [
                50.8698107,
                34.5693868
              ],
              [
                50.8585436,
                34.5736265
              ],
              [
                50.8470079,
                34.5794356
              ],
              [
                50.8319479,
                34.5650815
              ],
              [
                50.8300527,
                34.5634386
              ],
              [
                50.8304483,
                34.5630986
              ],
              [
                50.8315237,
                34.5621745
              ],
              [
                50.8358994,
                34.558701
              ],
              [
                50.8378333,
                34.5571658
              ],
              [
                50.8400634,
                34.5556965
              ],
              [
                50.8426306,
                34.554005
              ],
              [
                50.8470403,
                34.5515907
              ],
              [
                50.8492472,
                34.5503676
              ],
              [
                50.8462287,
                34.5479923
              ],
              [
                50.8430155,
                34.5462676
              ],
              [
                50.8367021,
                34.5431438
              ],
              [
                50.8240753,
                34.5372029
              ],
              [
                50.8120184,
                34.531677
              ],
              [
                50.8070203,
                34.5297627
              ],
              [
                50.7992162,
                34.5285346
              ],
              [
                50.79346,
                34.5278177
              ],
              [
                50.7929083,
                34.5220561
              ],
              [
                50.7922256,
                34.5046027
              ],
              [
                50.7900922,
                34.5021711
              ],
              [
                50.7685212,
                34.4810482
              ],
              [
                50.7558271,
                34.4710522
              ],
              [
                50.7477183,
                34.4649228
              ],
              [
                50.7380252,
                34.4517883
              ],
              [
                50.7297188,
                34.4338645
              ],
              [
                50.7249927,
                34.405281
              ],
              [
                50.7272243,
                34.3938081
              ],
              [
                50.7309058,
                34.3880958
              ],
              [
                50.7436812,
                34.3729387
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821045215
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.8648024,
          34.3930163
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2514311576
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.5164348,
          34.7747682
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 9678440938
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.8801184,
          34.6422939
        ]
      }
    }
  ]
},
"کردستان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 5134018,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سقز",
          "name:ar": "مقاطعة سقز",
          "name:en": "Saqqez County",
          "name:fa": "شهرستان سقز",
          "name:glk": "شهرستان سقز",
          "name:pnb": "شہرستان سقز",
          "name:ps": "سقز ولسوالي",
          "name:ur": "شہرستان سقز",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q349004",
          "wikipedia": "fa:شهرستان سقز"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.8469772,
                36.13836
              ],
              [
                45.847578,
                36.1364884
              ],
              [
                45.8510183,
                36.1344172
              ],
              [
                45.8973796,
                36.1067111
              ],
              [
                45.91774,
                36.0946907
              ],
              [
                45.9317771,
                36.0861567
              ],
              [
                45.9551612,
                36.0728394
              ],
              [
                45.9849823,
                36.0666518
              ],
              [
                46.0001906,
                36.0631014
              ],
              [
                46.0137127,
                36.0608643
              ],
              [
                46.0166476,
                36.0479616
              ],
              [
                46.0195049,
                36.0353231
              ],
              [
                46.0215648,
                36.0255315
              ],
              [
                46.023011,
                36.0187585
              ],
              [
                46.0238926,
                36.0125091
              ],
              [
                46.0776686,
                36.0172631
              ],
              [
                46.0866984,
                36.017678
              ],
              [
                46.1078905,
                36.0193928
              ],
              [
                46.1782557,
                36.01081
              ],
              [
                46.1734319,
                35.9856712
              ],
              [
                46.1714171,
                35.9699488
              ],
              [
                46.1664083,
                35.9586059
              ],
              [
                46.157073,
                35.9366389
              ],
              [
                46.1467439,
                35.9175062
              ],
              [
                46.127723,
                35.8825217
              ],
              [
                46.1209266,
                35.8606356
              ],
              [
                46.135796,
                35.84334
              ],
              [
                46.136861,
                35.843475
              ],
              [
                46.137288,
                35.843527
              ],
              [
                46.137693,
                35.842625
              ],
              [
                46.137922,
                35.841739
              ],
              [
                46.138259,
                35.840695
              ],
              [
                46.138464,
                35.840069
              ],
              [
                46.138512,
                35.839677
              ],
              [
                46.138364,
                35.839326
              ],
              [
                46.137808,
                35.839049
              ],
              [
                46.13748,
                35.838888
              ],
              [
                46.137035,
                35.838653
              ],
              [
                46.136731,
                35.838419
              ],
              [
                46.136334,
                35.837978
              ],
              [
                46.136045,
                35.83738
              ],
              [
                46.13587,
                35.836834
              ],
              [
                46.135729,
                35.836459
              ],
              [
                46.135543,
                35.835986
              ],
              [
                46.135392,
                35.835309
              ],
              [
                46.135215,
                35.835009
              ],
              [
                46.135078,
                35.834213
              ],
              [
                46.135259,
                35.833532
              ],
              [
                46.135457,
                35.83293
              ],
              [
                46.135526,
                35.832581
              ],
              [
                46.135596,
                35.832232
              ],
              [
                46.136167,
                35.831643
              ],
              [
                46.136511,
                35.831007
              ],
              [
                46.136633,
                35.830604
              ],
              [
                46.136647,
                35.83017
              ],
              [
                46.13681,
                35.829585
              ],
              [
                46.137043,
                35.828849
              ],
              [
                46.137171,
                35.828468
              ],
              [
                46.137564,
                35.827825
              ],
              [
                46.137661,
                35.827168
              ],
              [
                46.137597,
                35.826793
              ],
              [
                46.137528,
                35.826267
              ],
              [
                46.137255,
                35.82562
              ],
              [
                46.136982,
                35.82516
              ],
              [
                46.137592,
                35.824448
              ],
              [
                46.137902,
                35.823899
              ],
              [
                46.138085,
                35.823461
              ],
              [
                46.138269,
                35.823034
              ],
              [
                46.138574,
                35.822521
              ],
              [
                46.139063,
                35.821922
              ],
              [
                46.139532,
                35.821463
              ],
              [
                46.139911,
                35.821109
              ],
              [
                46.140273,
                35.820279
              ],
              [
                46.140563,
                35.81987
              ],
              [
                46.141098,
                35.819538
              ],
              [
                46.1417,
                35.819161
              ],
              [
                46.142379,
                35.818785
              ],
              [
                46.142983,
                35.818305
              ],
              [
                46.143701,
                35.818048
              ],
              [
                46.1443,
                35.817945
              ],
              [
                46.145273,
                35.817467
              ],
              [
                46.145831,
                35.816949
              ],
              [
                46.146134,
                35.816481
              ],
              [
                46.146387,
                35.815793
              ],
              [
                46.146631,
                35.815174
              ],
              [
                46.14709,
                35.814899
              ],
              [
                46.147761,
                35.814376
              ],
              [
                46.148449,
                35.814043
              ],
              [
                46.148864,
                35.813854
              ],
              [
                46.149211,
                35.813015
              ],
              [
                46.14945,
                35.812546
              ],
              [
                46.149688,
                35.811848
              ],
              [
                46.150085,
                35.810831
              ],
              [
                46.150441,
                35.810378
              ],
              [
                46.151323,
                35.809947
              ],
              [
                46.151726,
                35.809703
              ],
              [
                46.152289,
                35.80915
              ],
              [
                46.152783,
                35.808517
              ],
              [
                46.153214,
                35.808052
              ],
              [
                46.153653,
                35.807632
              ],
              [
                46.153867,
                35.806996
              ],
              [
                46.154032,
                35.806594
              ],
              [
                46.154937,
                35.806035
              ],
              [
                46.155403,
                35.805679
              ],
              [
                46.156062,
                35.805328
              ],
              [
                46.156735,
                35.805214
              ],
              [
                46.157269,
                35.805042
              ],
              [
                46.157812,
                35.804572
              ],
              [
                46.158364,
                35.804203
              ],
              [
                46.158846,
                35.80397
              ],
              [
                46.15948,
                35.803737
              ],
              [
                46.160566,
                35.803423
              ],
              [
                46.161377,
                35.803072
              ],
              [
                46.162148,
                35.802886
              ],
              [
                46.16289,
                35.802625
              ],
              [
                46.163414,
                35.802295
              ],
              [
                46.164058,
                35.801878
              ],
              [
                46.164648,
                35.801503
              ],
              [
                46.165404,
                35.801194
              ],
              [
                46.165807,
                35.801008
              ],
              [
                46.166208,
                35.800639
              ],
              [
                46.166581,
                35.80032
              ],
              [
                46.16736,
                35.80011
              ],
              [
                46.167906,
                35.799993
              ],
              [
                46.168714,
                35.80003
              ],
              [
                46.16921,
                35.800034
              ],
              [
                46.169972,
                35.799975
              ],
              [
                46.170468,
                35.799922
              ],
              [
                46.17091,
                35.799855
              ],
              [
                46.171615,
                35.799999
              ],
              [
                46.171991,
                35.800204
              ],
              [
                46.172512,
                35.800318
              ],
              [
                46.173055,
                35.800361
              ],
              [
                46.173909,
                35.800664
              ],
              [
                46.174506,
                35.800835
              ],
              [
                46.175068,
                35.801023
              ],
              [
                46.17526,
                35.801598
              ],
              [
                46.175454,
                35.801899
              ],
              [
                46.175559,
                35.802373
              ],
              [
                46.175554,
                35.802864
              ],
              [
                46.175482,
                35.803456
              ],
              [
                46.175354,
                35.803795
              ],
              [
                46.175261,
                35.804174
              ],
              [
                46.175396,
                35.804552
              ],
              [
                46.175648,
                35.804947
              ],
              [
                46.176009,
                35.805542
              ],
              [
                46.176404,
                35.80612
              ],
              [
                46.176856,
                35.806723
              ],
              [
                46.177202,
                35.807081
              ],
              [
                46.177742,
                35.807512
              ],
              [
                46.178243,
                35.807823
              ],
              [
                46.178663,
                35.808056
              ],
              [
                46.178926,
                35.80838
              ],
              [
                46.179085,
                35.808641
              ],
              [
                46.179552,
                35.809197
              ],
              [
                46.180028,
                35.809398
              ],
              [
                46.180731,
                35.80953
              ],
              [
                46.181573,
                35.809664
              ],
              [
                46.182045,
                35.8099
              ],
              [
                46.182334,
                35.810403
              ],
              [
                46.182599,
                35.810796
              ],
              [
                46.182808,
                35.811163
              ],
              [
                46.182997,
                35.811613
              ],
              [
                46.183139,
                35.811968
              ],
              [
                46.183144,
                35.81199
              ],
              [
                46.183454,
                35.812296
              ],
              [
                46.183814,
                35.812492
              ],
              [
                46.184598,
                35.812361
              ],
              [
                46.184949,
                35.812228
              ],
              [
                46.185311,
                35.811854
              ],
              [
                46.185682,
                35.811296
              ],
              [
                46.186088,
                35.810664
              ],
              [
                46.186665,
                35.810177
              ],
              [
                46.187388,
                35.809657
              ],
              [
                46.18824,
                35.809265
              ],
              [
                46.188766,
                35.80906
              ],
              [
                46.189297,
                35.809048
              ],
              [
                46.189867,
                35.809098
              ],
              [
                46.190425,
                35.808922
              ],
              [
                46.190931,
                35.808571
              ],
              [
                46.191223,
                35.808173
              ],
              [
                46.19144,
                35.807776
              ],
              [
                46.19187,
                35.807482
              ],
              [
                46.192464,
                35.807415
              ],
              [
                46.19289,
                35.807327
              ],
              [
                46.193265,
                35.806962
              ],
              [
                46.193585,
                35.806572
              ],
              [
                46.193747,
                35.806217
              ],
              [
                46.193679,
                35.805737
              ],
              [
                46.193677,
                35.805213
              ],
              [
                46.193758,
                35.804893
              ],
              [
                46.194127,
                35.80421
              ],
              [
                46.19424,
                35.803748
              ],
              [
                46.194346,
                35.803253
              ],
              [
                46.194381,
                35.802895
              ],
              [
                46.194644,
                35.802422
              ],
              [
                46.194988,
                35.80197
              ],
              [
                46.195104,
                35.80152
              ],
              [
                46.195089,
                35.801168
              ],
              [
                46.195165,
                35.800826
              ],
              [
                46.19503,
                35.800442
              ],
              [
                46.195866,
                35.800834
              ],
              [
                46.196583,
                35.800633
              ],
              [
                46.197053,
                35.800346
              ],
              [
                46.19844,
                35.800248
              ],
              [
                46.199003,
                35.800322
              ],
              [
                46.199978,
                35.800197
              ],
              [
                46.200813,
                35.800241
              ],
              [
                46.201651,
                35.800068
              ],
              [
                46.20244,
                35.799788
              ],
              [
                46.202956,
                35.799539
              ],
              [
                46.203376,
                35.799201
              ],
              [
                46.204276,
                35.798848
              ],
              [
                46.204775,
                35.798578
              ],
              [
                46.205411,
                35.798185
              ],
              [
                46.206099,
                35.797909
              ],
              [
                46.20646,
                35.797535
              ],
              [
                46.206782,
                35.797213
              ],
              [
                46.207502,
                35.796909
              ],
              [
                46.207967,
                35.796485
              ],
              [
                46.208387,
                35.796148
              ],
              [
                46.209105,
                35.795606
              ],
              [
                46.209906,
                35.795267
              ],
              [
                46.210766,
                35.794851
              ],
              [
                46.211505,
                35.794864
              ],
              [
                46.212274,
                35.794952
              ],
              [
                46.21264,
                35.795113
              ],
              [
                46.213067,
                35.795379
              ],
              [
                46.213435,
                35.795665
              ],
              [
                46.21389,
                35.796051
              ],
              [
                46.214211,
                35.796698
              ],
              [
                46.21442,
                35.797065
              ],
              [
                46.214547,
                35.797353
              ],
              [
                46.215267,
                35.798133
              ],
              [
                46.215613,
                35.798433
              ],
              [
                46.215996,
                35.798785
              ],
              [
                46.216411,
                35.798939
              ],
              [
                46.216794,
                35.799006
              ],
              [
                46.217344,
                35.79931
              ],
              [
                46.21798,
                35.799601
              ],
              [
                46.218628,
                35.799889
              ],
              [
                46.21922,
                35.800381
              ],
              [
                46.21953,
                35.800516
              ],
              [
                46.220001,
                35.800638
              ],
              [
                46.221134,
                35.800648
              ],
              [
                46.221731,
                35.800762
              ],
              [
                46.22217,
                35.801311
              ],
              [
                46.222654,
                35.801716
              ],
              [
                46.223034,
                35.802057
              ],
              [
                46.223263,
                35.802455
              ],
              [
                46.223437,
                35.802953
              ],
              [
                46.223554,
                35.803254
              ],
              [
                46.223594,
                35.803602
              ],
              [
                46.224053,
                35.804068
              ],
              [
                46.224556,
                35.804447
              ],
              [
                46.224865,
                35.80481
              ],
              [
                46.224961,
                35.80524
              ],
              [
                46.225231,
                35.805541
              ],
              [
                46.225604,
                35.805849
              ],
              [
                46.225943,
                35.806173
              ],
              [
                46.226083,
                35.806403
              ],
              [
                46.226409,
                35.806672
              ],
              [
                46.226728,
                35.807137
              ],
              [
                46.226895,
                35.807544
              ],
              [
                46.227344,
                35.807966
              ],
              [
                46.227821,
                35.808281
              ],
              [
                46.228285,
                35.808712
              ],
              [
                46.228636,
                35.808978
              ],
              [
                46.229009,
                35.809343
              ],
              [
                46.22939,
                35.80957
              ],
              [
                46.229699,
                35.809876
              ],
              [
                46.229819,
                35.810188
              ],
              [
                46.229883,
                35.810475
              ],
              [
                46.230158,
                35.811026
              ],
              [
                46.230408,
                35.81158
              ],
              [
                46.230476,
                35.812288
              ],
              [
                46.230737,
                35.812716
              ],
              [
                46.231147,
                35.812904
              ],
              [
                46.231479,
                35.812854
              ],
              [
                46.231914,
                35.812753
              ],
              [
                46.232444,
                35.812855
              ],
              [
                46.233257,
                35.813027
              ],
              [
                46.23393,
                35.813256
              ],
              [
                46.234541,
                35.813835
              ],
              [
                46.235042,
                35.81426
              ],
              [
                46.235356,
                35.814589
              ],
              [
                46.235877,
                35.814475
              ],
              [
                46.236282,
                35.814299
              ],
              [
                46.236769,
                35.814089
              ],
              [
                46.23717,
                35.814005
              ],
              [
                46.237995,
                35.814062
              ],
              [
                46.238602,
                35.814163
              ],
              [
                46.239061,
                35.814059
              ],
              [
                46.239324,
                35.8137
              ],
              [
                46.239454,
                35.813372
              ],
              [
                46.239585,
                35.812931
              ],
              [
                46.239556,
                35.812457
              ],
              [
                46.239782,
                35.812103
              ],
              [
                46.240197,
                35.811914
              ],
              [
                46.240794,
                35.811687
              ],
              [
                46.241495,
                35.81158
              ],
              [
                46.241969,
                35.811314
              ],
              [
                46.242605,
                35.811035
              ],
              [
                46.243217,
                35.81076
              ],
              [
                46.244384,
                35.810411
              ],
              [
                46.245074,
                35.810375
              ],
              [
                46.245664,
                35.810513
              ],
              [
                46.246047,
                35.810409
              ],
              [
                46.246239,
                35.810129
              ],
              [
                46.246436,
                35.809814
              ],
              [
                46.24708,
                35.809511
              ],
              [
                46.247993,
                35.809338
              ],
              [
                46.248384,
                35.809324
              ],
              [
                46.248507,
                35.809704
              ],
              [
                46.248747,
                35.810044
              ],
              [
                46.249115,
                35.81033
              ],
              [
                46.249555,
                35.81065
              ],
              [
                46.249806,
                35.81092
              ],
              [
                46.250041,
                35.811238
              ],
              [
                46.250301,
                35.811608
              ],
              [
                46.250556,
                35.8119
              ],
              [
                46.250999,
                35.812061
              ],
              [
                46.251416,
                35.812111
              ],
              [
                46.25204,
                35.812176
              ],
              [
                46.252495,
                35.812277
              ],
              [
                46.253185,
                35.812298
              ],
              [
                46.253698,
                35.812436
              ],
              [
                46.25412,
                35.812566
              ],
              [
                46.254528,
                35.812572
              ],
              [
                46.255312,
                35.812327
              ],
              [
                46.255963,
                35.812285
              ],
              [
                46.256762,
                35.81205
              ],
              [
                46.257396,
                35.811874
              ],
              [
                46.257931,
                35.811826
              ],
              [
                46.2587,
                35.81163
              ],
              [
                46.259054,
                35.811337
              ],
              [
                46.259712,
                35.811441
              ],
              [
                46.260321,
                35.811554
              ],
              [
                46.26096,
                35.811628
              ],
              [
                46.261267,
                35.811809
              ],
              [
                46.26135,
                35.812184
              ],
              [
                46.26151,
                35.812388
              ],
              [
                46.261903,
                35.812442
              ],
              [
                46.262392,
                35.812527
              ],
              [
                46.26276,
                35.812813
              ],
              [
                46.26317,
                35.813115
              ],
              [
                46.263406,
                35.813319
              ],
              [
                46.263813,
                35.813667
              ],
              [
                46.264427,
                35.814143
              ],
              [
                46.264702,
                35.814295
              ],
              [
                46.265049,
                35.814425
              ],
              [
                46.265624,
                35.814554
              ],
              [
                46.265962,
                35.814651
              ],
              [
                46.266458,
                35.814769
              ],
              [
                46.267041,
                35.814703
              ],
              [
                46.267363,
                35.814609
              ],
              [
                46.267775,
                35.814466
              ],
              [
                46.268392,
                35.814327
              ],
              [
                46.269213,
                35.814133
              ],
              [
                46.269854,
                35.814218
              ],
              [
                46.270284,
                35.814324
              ],
              [
                46.270465,
                35.814454
              ],
              [
                46.270964,
                35.814642
              ],
              [
                46.271357,
                35.814981
              ],
              [
                46.271848,
                35.815533
              ],
              [
                46.272425,
                35.815901
              ],
              [
                46.27298,
                35.816113
              ],
              [
                46.273238,
                35.81653
              ],
              [
                46.273498,
                35.816901
              ],
              [
                46.273773,
                35.817224
              ],
              [
                46.27418,
                35.817287
              ],
              [
                46.274839,
                35.817107
              ],
              [
                46.275367,
                35.817083
              ],
              [
                46.275775,
                35.817147
              ],
              [
                46.276222,
                35.817387
              ],
              [
                46.277045,
                35.817717
              ],
              [
                46.277776,
                35.818096
              ],
              [
                46.2784,
                35.818389
              ],
              [
                46.279083,
                35.818604
              ],
              [
                46.279584,
                35.818744
              ],
              [
                46.279869,
                35.818883
              ],
              [
                46.280635,
                35.819473
              ],
              [
                46.280966,
                35.819765
              ],
              [
                46.281155,
                35.820044
              ],
              [
                46.281376,
                35.820694
              ],
              [
                46.281646,
                35.82128
              ],
              [
                46.281995,
                35.821819
              ],
              [
                46.282191,
                35.822075
              ],
              [
                46.282552,
                35.822156
              ],
              [
                46.282992,
                35.822135
              ],
              [
                46.283372,
                35.822362
              ],
              [
                46.28377,
                35.822666
              ],
              [
                46.283957,
                35.822934
              ],
              [
                46.284054,
                35.823318
              ],
              [
                46.284062,
                35.823807
              ],
              [
                46.284283,
                35.824172
              ],
              [
                46.284717,
                35.824642
              ],
              [
                46.285242,
                35.825121
              ],
              [
                46.285488,
                35.825311
              ],
              [
                46.285942,
                35.825698
              ],
              [
                46.286637,
                35.826139
              ],
              [
                46.287242,
                35.826344
              ],
              [
                46.288234,
                35.826295
              ],
              [
                46.288863,
                35.826496
              ],
              [
                46.289553,
                35.826915
              ],
              [
                46.289843,
                35.827247
              ],
              [
                46.290075,
                35.827725
              ],
              [
                46.289979,
                35.82815
              ],
              [
                46.289851,
                35.828887
              ],
              [
                46.289949,
                35.829157
              ],
              [
                46.290094,
                35.829637
              ],
              [
                46.290099,
                35.830058
              ],
              [
                46.289934,
                35.830345
              ],
              [
                46.289614,
                35.830621
              ],
              [
                46.289069,
                35.831024
              ],
              [
                46.288956,
                35.831257
              ],
              [
                46.289096,
                35.831544
              ],
              [
                46.289334,
                35.832157
              ],
              [
                46.289154,
                35.83272
              ],
              [
                46.289019,
                35.833368
              ],
              [
                46.289156,
                35.833757
              ],
              [
                46.28943,
                35.834422
              ],
              [
                46.2894,
                35.834974
              ],
              [
                46.290039,
                35.834762
              ],
              [
                46.290541,
                35.834675
              ],
              [
                46.290951,
                35.834635
              ],
              [
                46.291253,
                35.834623
              ],
              [
                46.291757,
                35.834718
              ],
              [
                46.292235,
                35.834873
              ],
              [
                46.292972,
                35.835046
              ],
              [
                46.293321,
                35.835186
              ],
              [
                46.294119,
                35.835635
              ],
              [
                46.294615,
                35.835867
              ],
              [
                46.295094,
                35.835851
              ],
              [
                46.295598,
                35.835603
              ],
              [
                46.29633,
                35.835298
              ],
              [
                46.29707,
                35.835026
              ],
              [
                46.297954,
                35.834721
              ],
              [
                46.298264,
                35.834742
              ],
              [
                46.299079,
                35.834698
              ],
              [
                46.299276,
                35.83444
              ],
              [
                46.299257,
                35.833953
              ],
              [
                46.299198,
                35.833403
              ],
              [
                46.299228,
                35.832909
              ],
              [
                46.298982,
                35.832716
              ],
              [
                46.299168,
                35.831988
              ],
              [
                46.299484,
                35.83142
              ],
              [
                46.299784,
                35.830749
              ],
              [
                46.299785,
                35.829954
              ],
              [
                46.299823,
                35.829654
              ],
              [
                46.300415,
                35.829533
              ],
              [
                46.300762,
                35.829137
              ],
              [
                46.300871,
                35.828871
              ],
              [
                46.300917,
                35.828225
              ],
              [
                46.301239,
                35.827991
              ],
              [
                46.302473,
                35.827333
              ],
              [
                46.302865,
                35.826987
              ],
              [
                46.303349,
                35.826708
              ],
              [
                46.303921,
                35.826541
              ],
              [
                46.304543,
                35.826595
              ],
              [
                46.305093,
                35.826728
              ],
              [
                46.305442,
                35.826755
              ],
              [
                46.306041,
                35.826538
              ],
              [
                46.306113,
                35.826345
              ],
              [
                46.30625,
                35.826107
              ],
              [
                46.306589,
                35.825919
              ],
              [
                46.306956,
                35.825852
              ],
              [
                46.307299,
                35.82597
              ],
              [
                46.307616,
                35.826196
              ],
              [
                46.307778,
                35.826353
              ],
              [
                46.308038,
                35.826382
              ],
              [
                46.308365,
                35.826059
              ],
              [
                46.308498,
                35.825708
              ],
              [
                46.308658,
                35.825456
              ],
              [
                46.309046,
                35.825032
              ],
              [
                46.309423,
                35.824496
              ],
              [
                46.309782,
                35.824111
              ],
              [
                46.310175,
                35.823766
              ],
              [
                46.310512,
                35.823567
              ],
              [
                46.310882,
                35.823408
              ],
              [
                46.311133,
                35.822994
              ],
              [
                46.31131,
                35.822648
              ],
              [
                46.311662,
                35.822457
              ],
              [
                46.311952,
                35.822447
              ],
              [
                46.312338,
                35.822355
              ],
              [
                46.312615,
                35.821834
              ],
              [
                46.312969,
                35.821597
              ],
              [
                46.313139,
                35.821218
              ],
              [
                46.313392,
                35.820872
              ],
              [
                46.313805,
                35.820501
              ],
              [
                46.314154,
                35.820186
              ],
              [
                46.31438,
                35.819833
              ],
              [
                46.314557,
                35.819601
              ],
              [
                46.315051,
                35.81948
              ],
              [
                46.315624,
                35.819484
              ],
              [
                46.316289,
                35.819508
              ],
              [
                46.316987,
                35.819504
              ],
              [
                46.317503,
                35.81954
              ],
              [
                46.317942,
                35.819576
              ],
              [
                46.318279,
                35.819319
              ],
              [
                46.318699,
                35.819153
              ],
              [
                46.319269,
                35.819032
              ],
              [
                46.319697,
                35.818955
              ],
              [
                46.320146,
                35.81875
              ],
              [
                46.320535,
                35.818554
              ],
              [
                46.320918,
                35.818394
              ],
              [
                46.321232,
                35.818437
              ],
              [
                46.321768,
                35.818333
              ],
              [
                46.322225,
                35.818388
              ],
              [
                46.322721,
                35.81845
              ],
              [
                46.323183,
                35.818357
              ],
              [
                46.323706,
                35.818311
              ],
              [
                46.32433,
                35.818205
              ],
              [
                46.324851,
                35.818205
              ],
              [
                46.32521,
                35.818333
              ],
              [
                46.325735,
                35.818413
              ],
              [
                46.326396,
                35.818529
              ],
              [
                46.327008,
                35.818652
              ],
              [
                46.327472,
                35.818798
              ],
              [
                46.328007,
                35.819036
              ],
              [
                46.328457,
                35.819116
              ],
              [
                46.328867,
                35.819133
              ],
              [
                46.329523,
                35.819113
              ],
              [
                46.329869,
                35.818958
              ],
              [
                46.330437,
                35.818826
              ],
              [
                46.330933,
                35.818659
              ],
              [
                46.331437,
                35.818754
              ],
              [
                46.331901,
                35.818842
              ],
              [
                46.332746,
                35.818873
              ],
              [
                46.333448,
                35.819177
              ],
              [
                46.334102,
                35.819374
              ],
              [
                46.334381,
                35.819605
              ],
              [
                46.334721,
                35.819872
              ],
              [
                46.335327,
                35.820145
              ],
              [
                46.335663,
                35.820287
              ],
              [
                46.336251,
                35.820073
              ],
              [
                46.337,
                35.819902
              ],
              [
                46.337575,
                35.819746
              ],
              [
                46.338425,
                35.819799
              ],
              [
                46.338992,
                35.819838
              ],
              [
                46.339444,
                35.819929
              ],
              [
                46.340244,
                35.819902
              ],
              [
                46.340366,
                35.81947
              ],
              [
                46.340374,
                35.819064
              ],
              [
                46.340514,
                35.818693
              ],
              [
                46.340554,
                35.818418
              ],
              [
                46.340369,
                35.817919
              ],
              [
                46.340121,
                35.817432
              ],
              [
                46.340011,
                35.816879
              ],
              [
                46.340035,
                35.816301
              ],
              [
                46.340054,
                35.815717
              ],
              [
                46.340324,
                35.815177
              ],
              [
                46.340563,
                35.81459
              ],
              [
                46.340729,
                35.814016
              ],
              [
                46.340834,
                35.813299
              ],
              [
                46.341068,
                35.812402
              ],
              [
                46.341262,
                35.811755
              ],
              [
                46.341207,
                35.8111
              ],
              [
                46.341243,
                35.810658
              ],
              [
                46.341559,
                35.810273
              ],
              [
                46.341827,
                35.809686
              ],
              [
                46.341927,
                35.80953
              ],
              [
                46.342535,
                35.809129
              ],
              [
                46.343213,
                35.808513
              ],
              [
                46.343758,
                35.807851
              ],
              [
                46.34407,
                35.807252
              ],
              [
                46.344359,
                35.806127
              ],
              [
                46.344525,
                35.805565
              ],
              [
                46.34444,
                35.804862
              ],
              [
                46.344243,
                35.804435
              ],
              [
                46.343769,
                35.804142
              ],
              [
                46.344477,
                35.803335
              ],
              [
                46.344994,
                35.802558
              ],
              [
                46.345574,
                35.801797
              ],
              [
                46.345923,
                35.801026
              ],
              [
                46.34598,
                35.800368
              ],
              [
                46.3459,
                35.799947
              ],
              [
                46.345561,
                35.799452
              ],
              [
                46.3452,
                35.799028
              ],
              [
                46.345005,
                35.798914
              ],
              [
                46.344771,
                35.798836
              ],
              [
                46.344631,
                35.798749
              ],
              [
                46.344594,
                35.798417
              ],
              [
                46.344424,
                35.798052
              ],
              [
                46.344277,
                35.797789
              ],
              [
                46.344302,
                35.797272
              ],
              [
                46.344189,
                35.796708
              ],
              [
                46.344408,
                35.796151
              ],
              [
                46.34447,
                35.795515
              ],
              [
                46.344372,
                35.795131
              ],
              [
                46.344497,
                35.794724
              ],
              [
                46.344827,
                35.793979
              ],
              [
                46.345218,
                35.793452
              ],
              [
                46.345754,
                35.792721
              ],
              [
                46.345936,
                35.792169
              ],
              [
                46.346148,
                35.791578
              ],
              [
                46.346025,
                35.791255
              ],
              [
                46.345561,
                35.790767
              ],
              [
                46.345463,
                35.790269
              ],
              [
                46.345554,
                35.789594
              ],
              [
                46.345699,
                35.789218
              ],
              [
                46.345968,
                35.788767
              ],
              [
                46.346292,
                35.788342
              ],
              [
                46.346386,
                35.787906
              ],
              [
                46.346823,
                35.787418
              ],
              [
                46.347062,
                35.787119
              ],
              [
                46.346927,
                35.786855
              ],
              [
                46.346652,
                35.786589
              ],
              [
                46.346293,
                35.786233
              ],
              [
                46.345974,
                35.78594
              ],
              [
                46.34564,
                35.785751
              ],
              [
                46.345124,
                35.785602
              ],
              [
                46.344857,
                35.785483
              ],
              [
                46.344668,
                35.78509
              ],
              [
                46.344295,
                35.784554
              ],
              [
                46.344022,
                35.784242
              ],
              [
                46.343781,
                35.784017
              ],
              [
                46.343273,
                35.783957
              ],
              [
                46.342841,
                35.783898
              ],
              [
                46.341959,
                35.783302
              ],
              [
                46.341473,
                35.783
              ],
              [
                46.341095,
                35.782727
              ],
              [
                46.340633,
                35.782535
              ],
              [
                46.340226,
                35.78213
              ],
              [
                46.3409865,
                35.7821953
              ],
              [
                46.3414426,
                35.7821924
              ],
              [
                46.371715,
                35.7826818
              ],
              [
                46.3974445,
                35.7943653
              ],
              [
                46.4019535,
                35.7961607
              ],
              [
                46.4093652,
                35.8000879
              ],
              [
                46.4186094,
                35.803118
              ],
              [
                46.4255662,
                35.8065841
              ],
              [
                46.4483104,
                35.8216755
              ],
              [
                46.4663278,
                35.8309222
              ],
              [
                46.4709379,
                35.835314
              ],
              [
                46.4808311,
                35.8415116
              ],
              [
                46.4847801,
                35.8419302
              ],
              [
                46.4924104,
                35.844429
              ],
              [
                46.4986269,
                35.845773
              ],
              [
                46.5100185,
                35.849172
              ],
              [
                46.5184417,
                35.8527507
              ],
              [
                46.5172914,
                35.8665425
              ],
              [
                46.5168857,
                35.8769499
              ],
              [
                46.5178728,
                35.8917272
              ],
              [
                46.5247392,
                35.8980893
              ],
              [
                46.527915,
                35.9037209
              ],
              [
                46.5340948,
                35.9081355
              ],
              [
                46.5404462,
                35.9117504
              ],
              [
                46.5540504,
                35.917381
              ],
              [
                46.5556383,
                35.9224899
              ],
              [
                46.5529346,
                35.9274942
              ],
              [
                46.5555524,
                35.931143
              ],
              [
                46.5558099,
                35.9322897
              ],
              [
                46.5634059,
                35.939274
              ],
              [
                46.5689891,
                35.9432904
              ],
              [
                46.5736198,
                35.9504614
              ],
              [
                46.5750739,
                35.9595982
              ],
              [
                46.574456,
                35.965837
              ],
              [
                46.5754602,
                35.9733189
              ],
              [
                46.5783982,
                35.9815548
              ],
              [
                46.5794253,
                35.9874524
              ],
              [
                46.5817832,
                35.9944966
              ],
              [
                46.5985747,
                35.9932405
              ],
              [
                46.6239337,
                35.9890715
              ],
              [
                46.6364189,
                35.9867285
              ],
              [
                46.6405729,
                35.9865043
              ],
              [
                46.6502332,
                35.9857421
              ],
              [
                46.6565949,
                35.9849781
              ],
              [
                46.6593946,
                35.9845251
              ],
              [
                46.6747508,
                35.9840396
              ],
              [
                46.69177,
                35.9825464
              ],
              [
                46.6960305,
                35.9861264
              ],
              [
                46.6975006,
                35.9880319
              ],
              [
                46.7008035,
                35.9931724
              ],
              [
                46.7145975,
                35.9962279
              ],
              [
                46.7291852,
                35.998517
              ],
              [
                46.7429075,
                36.0020575
              ],
              [
                46.7375661,
                36.0249691
              ],
              [
                46.7405019,
                36.0232691
              ],
              [
                46.7458535,
                36.0208051
              ],
              [
                46.7492421,
                36.0174723
              ],
              [
                46.75704,
                36.0186633
              ],
              [
                46.7661078,
                36.0232724
              ],
              [
                46.7699703,
                36.0295852
              ],
              [
                46.7720318,
                36.0371626
              ],
              [
                46.7740349,
                36.0433727
              ],
              [
                46.7786798,
                36.0565011
              ],
              [
                46.7943656,
                36.0694093
              ],
              [
                46.8111101,
                36.0859377
              ],
              [
                46.8209538,
                36.0951723
              ],
              [
                46.8258333,
                36.0994599
              ],
              [
                46.8332576,
                36.1054971
              ],
              [
                46.8421766,
                36.1134358
              ],
              [
                46.8466228,
                36.1320316
              ],
              [
                46.8465329,
                36.1408182
              ],
              [
                46.8467568,
                36.1496734
              ],
              [
                46.8499014,
                36.1601764
              ],
              [
                46.8523979,
                36.1739113
              ],
              [
                46.8527891,
                36.1783667
              ],
              [
                46.8538961,
                36.1831849
              ],
              [
                46.8548403,
                36.1918227
              ],
              [
                46.8560847,
                36.201693
              ],
              [
                46.8457184,
                36.2085244
              ],
              [
                46.8325046,
                36.2157812
              ],
              [
                46.8229608,
                36.2209746
              ],
              [
                46.7926392,
                36.2252937
              ],
              [
                46.7809433,
                36.2273684
              ],
              [
                46.766365,
                36.2292725
              ],
              [
                46.7718095,
                36.2497104
              ],
              [
                46.7758792,
                36.2662622
              ],
              [
                46.7879506,
                36.2809909
              ],
              [
                46.7993533,
                36.2935702
              ],
              [
                46.8099408,
                36.3012174
              ],
              [
                46.820211,
                36.3124773
              ],
              [
                46.8207681,
                36.3127565
              ],
              [
                46.8232682,
                36.3144323
              ],
              [
                46.8316011,
                36.319153
              ],
              [
                46.8783763,
                36.3465331
              ],
              [
                46.8896565,
                36.3592963
              ],
              [
                46.8905838,
                36.3676668
              ],
              [
                46.8868512,
                36.3778213
              ],
              [
                46.8777542,
                36.3835732
              ],
              [
                46.8659267,
                36.3941974
              ],
              [
                46.849373,
                36.4184417
              ],
              [
                46.8308939,
                36.4378144
              ],
              [
                46.8297806,
                36.4378144
              ],
              [
                46.8295041,
                36.4380936
              ],
              [
                46.8283939,
                36.4383638
              ],
              [
                46.8278368,
                36.4383637
              ],
              [
                46.8275602,
                36.438643
              ],
              [
                46.827004,
                36.438643
              ],
              [
                46.8237425,
                36.439815
              ],
              [
                46.8205238,
                36.4379507
              ],
              [
                46.8184124,
                36.4357962
              ],
              [
                46.8170992,
                36.4352991
              ],
              [
                46.816919,
                36.4346569
              ],
              [
                46.8157345,
                36.4336418
              ],
              [
                46.8151938,
                36.4326059
              ],
              [
                46.8135201,
                36.4317358
              ],
              [
                46.8124643,
                36.4318809
              ],
              [
                46.8092714,
                36.4293948
              ],
              [
                46.8080355,
                36.4290219
              ],
              [
                46.8069859,
                36.4286404
              ],
              [
                46.8065577,
                36.4284946
              ],
              [
                46.804227,
                36.4263742
              ],
              [
                46.8008565,
                36.4269802
              ],
              [
                46.7954921,
                36.4269111
              ],
              [
                46.7941618,
                36.4259097
              ],
              [
                46.7860078,
                36.4222149
              ],
              [
                46.7784547,
                36.4196249
              ],
              [
                46.768198,
                36.4178291
              ],
              [
                46.7578125,
                36.418727
              ],
              [
                46.7463541,
                36.4163787
              ],
              [
                46.7324066,
                36.4128905
              ],
              [
                46.7254972,
                36.4102657
              ],
              [
                46.7074298,
                36.4039451
              ],
              [
                46.6862296,
                36.4037379
              ],
              [
                46.6707801,
                36.4014581
              ],
              [
                46.6523265,
                36.4009746
              ],
              [
                46.6383361,
                36.4006982
              ],
              [
                46.6316628,
                36.3990574
              ],
              [
                46.6292166,
                36.3984184
              ],
              [
                46.6255045,
                36.3989538
              ],
              [
                46.6223287,
                36.3980902
              ],
              [
                46.6203117,
                36.3967948
              ],
              [
                46.6154193,
                36.3967948
              ],
              [
                46.6025447,
                36.3959658
              ],
              [
                46.5916013,
                36.3972094
              ],
              [
                46.5772247,
                36.3986947
              ],
              [
                46.5530204,
                36.4019762
              ],
              [
                46.5491151,
                36.404325
              ],
              [
                46.5462827,
                36.402149
              ],
              [
                46.5422916,
                36.4006291
              ],
              [
                46.540854,
                36.4003355
              ],
              [
                46.5397596,
                36.4003182
              ],
              [
                46.5377211,
                36.4002837
              ],
              [
                46.5356183,
                36.4006118
              ],
              [
                46.5334081,
                36.4014236
              ],
              [
                46.5320777,
                36.4022871
              ],
              [
                46.5306615,
                36.4041178
              ],
              [
                46.5296745,
                36.4056721
              ],
              [
                46.5288162,
                36.4069155
              ],
              [
                46.5283012,
                36.408228
              ],
              [
                46.5268971,
                36.4096782
              ],
              [
                46.5258168,
                36.4100229
              ],
              [
                46.524148,
                36.4105467
              ],
              [
                46.5221948,
                36.4112512
              ],
              [
                46.5198636,
                36.4123689
              ],
              [
                46.5173618,
                36.4135326
              ],
              [
                46.5152109,
                36.4146723
              ],
              [
                46.5094112,
                36.4166903
              ],
              [
                46.5075573,
                36.41703
              ],
              [
                46.5033908,
                36.4175384
              ],
              [
                46.5027143,
                36.4181368
              ],
              [
                46.4997915,
                36.4188045
              ],
              [
                46.4960501,
                36.4196476
              ],
              [
                46.4911575,
                36.4204591
              ],
              [
                46.4850494,
                36.4208014
              ],
              [
                46.478838,
                36.4211122
              ],
              [
                46.4724163,
                36.4208961
              ],
              [
                46.4645519,
                36.4201018
              ],
              [
                46.4583339,
                36.4187693
              ],
              [
                46.4548198,
                36.4176815
              ],
              [
                46.4515819,
                36.4159346
              ],
              [
                46.4446103,
                36.4110449
              ],
              [
                46.4399151,
                36.4052562
              ],
              [
                46.4380825,
                36.4017879
              ],
              [
                46.4344024,
                36.3934441
              ],
              [
                46.4304203,
                36.3849525
              ],
              [
                46.4275826,
                36.3799342
              ],
              [
                46.4226436,
                36.3718157
              ],
              [
                46.4173218,
                36.3653885
              ],
              [
                46.4117002,
                36.3603427
              ],
              [
                46.4088678,
                36.359686
              ],
              [
                46.4036747,
                36.3617944
              ],
              [
                46.3955211,
                36.3654574
              ],
              [
                46.3845563,
                36.3686997
              ],
              [
                46.378551,
                36.3703583
              ],
              [
                46.3737947,
                36.3715995
              ],
              [
                46.3679424,
                36.372397
              ],
              [
                46.357313,
                36.3730531
              ],
              [
                46.3480358,
                36.3725642
              ],
              [
                46.3326501,
                36.3724031
              ],
              [
                46.3262106,
                36.3732678
              ],
              [
                46.3194175,
                36.3742036
              ],
              [
                46.3090896,
                36.3763078
              ],
              [
                46.303339,
                36.3785882
              ],
              [
                46.299634,
                36.3808164
              ],
              [
                46.2968158,
                36.3827343
              ],
              [
                46.2933436,
                36.3860813
              ],
              [
                46.2896718,
                36.3887665
              ],
              [
                46.2807226,
                36.3935822
              ],
              [
                46.2750148,
                36.3965185
              ],
              [
                46.2691783,
                36.3988674
              ],
              [
                46.260638,
                36.4028563
              ],
              [
                46.2537717,
                36.4052231
              ],
              [
                46.2449312,
                36.408746
              ],
              [
                46.2337732,
                36.4158606
              ],
              [
                46.2248039,
                36.4201774
              ],
              [
                46.2157058,
                36.4249429
              ],
              [
                46.2082386,
                36.4280851
              ],
              [
                46.2036895,
                36.4283614
              ],
              [
                46.2001276,
                36.4293627
              ],
              [
                46.1972382,
                36.4312573
              ],
              [
                46.1949777,
                36.4357504
              ],
              [
                46.1918017,
                36.4397556
              ],
              [
                46.1864834,
                36.4457147
              ],
              [
                46.1857711,
                36.447005
              ],
              [
                46.1843843,
                36.4470049
              ],
              [
                46.1802147,
                36.4481131
              ],
              [
                46.1785482,
                36.4481131
              ],
              [
                46.176881,
                36.4486715
              ],
              [
                46.1757716,
                36.4486715
              ],
              [
                46.1614553,
                36.4550265
              ],
              [
                46.1608982,
                36.4550264
              ],
              [
                46.1538272,
                36.459454
              ],
              [
                46.1193097,
                36.4534077
              ],
              [
                46.1038682,
                36.4442091
              ],
              [
                46.0711666,
                36.4381329
              ],
              [
                46.0657873,
                36.4242993
              ],
              [
                46.0399243,
                36.4218352
              ],
              [
                46.0282295,
                36.4316484
              ],
              [
                46.0154534,
                36.4277659
              ],
              [
                46.0085455,
                36.4336523
              ],
              [
                46.0031032,
                36.4328156
              ],
              [
                45.999349,
                36.4313014
              ],
              [
                45.9951639,
                36.4301569
              ],
              [
                45.9916505,
                36.4285528
              ],
              [
                45.988323,
                36.4241959
              ],
              [
                45.9859508,
                36.4210071
              ],
              [
                45.9826755,
                36.4123725
              ],
              [
                45.9813019,
                36.3995931
              ],
              [
                45.9820747,
                36.3956549
              ],
              [
                45.976839,
                36.3924768
              ],
              [
                45.9716031,
                36.3914406
              ],
              [
                45.9667968,
                36.393375
              ],
              [
                45.9622478,
                36.392615
              ],
              [
                45.9602737,
                36.3912331
              ],
              [
                45.9553472,
                36.3860518
              ],
              [
                45.9549464,
                36.380721
              ],
              [
                45.9601878,
                36.372576
              ],
              [
                45.9622559,
                36.3551123
              ],
              [
                45.9692,
                36.3449967
              ],
              [
                45.9732338,
                36.3337964
              ],
              [
                45.9808992,
                36.3278738
              ],
              [
                45.9810446,
                36.307379
              ],
              [
                45.9830188,
                36.2993552
              ],
              [
                45.988512,
                36.2871104
              ],
              [
                45.9895849,
                36.2774931
              ],
              [
                45.9859371,
                36.2742755
              ],
              [
                45.9796559,
                36.269017
              ],
              [
                45.976766,
                36.2647723
              ],
              [
                45.9614169,
                36.2572119
              ],
              [
                45.9539221,
                36.2525796
              ],
              [
                45.9389876,
                36.2481497
              ],
              [
                45.9182165,
                36.2361046
              ],
              [
                45.883365,
                36.2077042
              ],
              [
                45.8501945,
                36.1958325
              ],
              [
                45.845046,
                36.145222
              ],
              [
                45.8457326,
                36.1447368
              ],
              [
                45.8453893,
                36.1428308
              ],
              [
                45.8463764,
                36.1406474
              ],
              [
                45.8474063,
                36.1395037
              ],
              [
                45.8469772,
                36.13836
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 5143134,
        "tags": {
          "admin_level": "5",
          "alt_name": "Baneh County;بانه",
          "boundary": "administrative",
          "name": "شهرستان بانه",
          "name:az": "Banə şəhristanı",
          "name:en": "Baneh County",
          "name:ku": "Bane (şaristan)",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282065",
          "wikipedia": "en:Baneh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.557841,
                35.9950418
              ],
              [
                45.5580631,
                35.9949551
              ],
              [
                45.5583254,
                35.9948187
              ],
              [
                45.5588848,
                35.9948207
              ],
              [
                45.5590612,
                35.9947813
              ],
              [
                45.5593049,
                35.9946488
              ],
              [
                45.5594686,
                35.9946164
              ],
              [
                45.5596294,
                35.9945514
              ],
              [
                45.5597751,
                35.9946179
              ],
              [
                45.5599101,
                35.9946754
              ],
              [
                45.560028,
                35.9947172
              ],
              [
                45.5601738,
                35.9946952
              ],
              [
                45.5602583,
                35.9946617
              ],
              [
                45.56034,
                35.9945097
              ],
              [
                45.5604565,
                35.994213
              ],
              [
                45.5605826,
                35.9938492
              ],
              [
                45.5606812,
                35.9936221
              ],
              [
                45.5608421,
                35.9934347
              ],
              [
                45.5609835,
                35.9931932
              ],
              [
                45.5610806,
                35.992912
              ],
              [
                45.5611405,
                35.9925888
              ],
              [
                45.561277,
                35.9921963
              ],
              [
                45.5615943,
                35.9917079
              ],
              [
                45.561678,
                35.9914281
              ],
              [
                45.5616105,
                35.9911775
              ],
              [
                45.5616407,
                35.9905612
              ],
              [
                45.5617315,
                35.9902218
              ],
              [
                45.5619973,
                35.9898742
              ],
              [
                45.5627366,
                35.9896298
              ],
              [
                45.5630839,
                35.9896258
              ],
              [
                45.5635596,
                35.9897071
              ],
              [
                45.563815,
                35.9897988
              ],
              [
                45.5640621,
                35.9897829
              ],
              [
                45.564081,
                35.9897725
              ],
              [
                45.5642149,
                35.989699
              ],
              [
                45.5643774,
                35.9895687
              ],
              [
                45.564723,
                35.9893616
              ],
              [
                45.5652795,
                35.9891196
              ],
              [
                45.5654718,
                35.9890336
              ],
              [
                45.5656376,
                35.9890104
              ],
              [
                45.5658393,
                35.9888629
              ],
              [
                45.5659729,
                35.9886864
              ],
              [
                45.566123,
                35.988437
              ],
              [
                45.5663945,
                35.988161
              ],
              [
                45.5665795,
                35.9879866
              ],
              [
                45.5667006,
                35.9877867
              ],
              [
                45.5668709,
                35.9876597
              ],
              [
                45.5670157,
                35.9875266
              ],
              [
                45.567603,
                35.9873604
              ],
              [
                45.5679179,
                35.9871617
              ],
              [
                45.5683148,
                35.9867309
              ],
              [
                45.5684311,
                35.9864936
              ],
              [
                45.5685424,
                35.9862258
              ],
              [
                45.5685777,
                35.985956
              ],
              [
                45.5685789,
                35.9857481
              ],
              [
                45.5685795,
                35.9854585
              ],
              [
                45.5688341,
                35.9848904
              ],
              [
                45.568948,
                35.9847675
              ],
              [
                45.5692467,
                35.9846729
              ],
              [
                45.5705124,
                35.9844922
              ],
              [
                45.5710168,
                35.9843552
              ],
              [
                45.5716173,
                35.9840978
              ],
              [
                45.572267,
                35.9838138
              ],
              [
                45.5728574,
                35.9834945
              ],
              [
                45.5733166,
                35.9832553
              ],
              [
                45.573624,
                35.9831423
              ],
              [
                45.5739642,
                35.9829365
              ],
              [
                45.5741156,
                35.9828
              ],
              [
                45.5742815,
                35.9825826
              ],
              [
                45.5743235,
                35.9823081
              ],
              [
                45.5744469,
                35.9820117
              ],
              [
                45.5746932,
                35.981649
              ],
              [
                45.5751561,
                35.9810948
              ],
              [
                45.5757583,
                35.9803483
              ],
              [
                45.5759875,
                35.9794179
              ],
              [
                45.5761022,
                35.9792388
              ],
              [
                45.5761063,
                35.9789271
              ],
              [
                45.5760366,
                35.9786635
              ],
              [
                45.5760919,
                35.9784853
              ],
              [
                45.5760161,
                35.978254
              ],
              [
                45.5755704,
                35.9778973
              ],
              [
                45.5751984,
                35.9774809
              ],
              [
                45.574949,
                35.9773009
              ],
              [
                45.5748552,
                35.9770545
              ],
              [
                45.5745529,
                35.9765883
              ],
              [
                45.5743897,
                35.9761924
              ],
              [
                45.5744314,
                35.9757301
              ],
              [
                45.5745304,
                35.9753308
              ],
              [
                45.574777,
                35.9748851
              ],
              [
                45.5751008,
                35.9748433
              ],
              [
                45.575361,
                35.9748754
              ],
              [
                45.5757492,
                35.9750407
              ],
              [
                45.5760622,
                35.9752394
              ],
              [
                45.5763969,
                35.9753305
              ],
              [
                45.5769775,
                35.9754282
              ],
              [
                45.5780794,
                35.9752116
              ],
              [
                45.5790136,
                35.9746198
              ],
              [
                45.5799871,
                35.9738288
              ],
              [
                45.5804689,
                35.9734153
              ],
              [
                45.5809113,
                35.972898
              ],
              [
                45.5813538,
                35.9724037
              ],
              [
                45.5818753,
                35.9716859
              ],
              [
                45.5822685,
                35.9712874
              ],
              [
                45.582618,
                35.9710523
              ],
              [
                45.5833524,
                35.9707293
              ],
              [
                45.5839349,
                35.9705419
              ],
              [
                45.5844136,
                35.9705001
              ],
              [
                45.5847566,
                35.9707148
              ],
              [
                45.5850206,
                35.9709215
              ],
              [
                45.5851631,
                35.971316
              ],
              [
                45.5850787,
                35.9715427
              ],
              [
                45.5850874,
                35.9719803
              ],
              [
                45.5852529,
                35.9722164
              ],
              [
                45.5856234,
                35.9724732
              ],
              [
                45.5860217,
                35.9724777
              ],
              [
                45.5863047,
                35.9724919
              ],
              [
                45.586568,
                35.972562
              ],
              [
                45.5867923,
                35.9725151
              ],
              [
                45.5868757,
                35.9726609
              ],
              [
                45.5869339,
                35.9727688
              ],
              [
                45.5870307,
                35.9729208
              ],
              [
                45.5869423,
                35.9731348
              ],
              [
                45.5868046,
                35.9733008
              ],
              [
                45.5866378,
                35.9735451
              ],
              [
                45.586541,
                35.9737462
              ],
              [
                45.5865446,
                35.9739167
              ],
              [
                45.5864927,
                35.974162
              ],
              [
                45.5863494,
                35.9745169
              ],
              [
                45.5862306,
                35.9745957
              ],
              [
                45.5860029,
                35.9746894
              ],
              [
                45.5856166,
                35.9748209
              ],
              [
                45.5851399,
                35.9751239
              ],
              [
                45.5848817,
                35.9753462
              ],
              [
                45.5847912,
                35.9756163
              ],
              [
                45.5847385,
                35.9761487
              ],
              [
                45.5847845,
                35.976693
              ],
              [
                45.5849588,
                35.9772133
              ],
              [
                45.5855254,
                35.9774007
              ],
              [
                45.5858876,
                35.9774385
              ],
              [
                45.5865163,
                35.9774843
              ],
              [
                45.5867021,
                35.9775157
              ],
              [
                45.5868184,
                35.9775125
              ],
              [
                45.5869182,
                35.9775636
              ],
              [
                45.5871066,
                35.9775683
              ],
              [
                45.5871699,
                35.9775449
              ],
              [
                45.587225,
                35.9774827
              ],
              [
                45.5873281,
                35.9774157
              ],
              [
                45.5877313,
                35.9773906
              ],
              [
                45.5882595,
                35.9774077
              ],
              [
                45.5885848,
                35.9774522
              ],
              [
                45.588974,
                35.9774934
              ],
              [
                45.5893685,
                35.9774671
              ],
              [
                45.5896024,
                35.9773194
              ],
              [
                45.5897556,
                35.9772098
              ],
              [
                45.5899728,
                35.9772428
              ],
              [
                45.59019,
                35.9772235
              ],
              [
                45.5904594,
                35.9770935
              ],
              [
                45.5906644,
                35.9768334
              ],
              [
                45.5908165,
                35.976521
              ],
              [
                45.5908162,
                35.9760882
              ],
              [
                45.5908239,
                35.975662
              ],
              [
                45.5909434,
                35.9755786
              ],
              [
                45.5909831,
                35.9754751
              ],
              [
                45.5911115,
                35.9752672
              ],
              [
                45.5911475,
                35.9751128
              ],
              [
                45.5912077,
                35.9748316
              ],
              [
                45.5913369,
                35.9746061
              ],
              [
                45.5914594,
                35.974261
              ],
              [
                45.5916251,
                35.9740722
              ],
              [
                45.5918687,
                35.9739192
              ],
              [
                45.5921915,
                35.9738362
              ],
              [
                45.5924581,
                35.9737402
              ],
              [
                45.5927813,
                35.9736358
              ],
              [
                45.5929871,
                35.9736162
              ],
              [
                45.5932508,
                35.973769
              ],
              [
                45.5934309,
                35.9739983
              ],
              [
                45.5937983,
                35.9740935
              ],
              [
                45.5941187,
                35.9741638
              ],
              [
                45.5943908,
                35.9741496
              ],
              [
                45.5946475,
                35.9740572
              ],
              [
                45.5948562,
                35.9739199
              ],
              [
                45.5949848,
                35.9737962
              ],
              [
                45.5952902,
                35.9736138
              ],
              [
                45.5954268,
                35.9734445
              ],
              [
                45.595487,
                35.9732916
              ],
              [
                45.5957061,
                35.9731435
              ],
              [
                45.5959814,
                35.9728328
              ],
              [
                45.5960282,
                35.972643
              ],
              [
                45.595927,
                35.9723822
              ],
              [
                45.5958202,
                35.9719461
              ],
              [
                45.5957386,
                35.9714807
              ],
              [
                45.5955611,
                35.9710757
              ],
              [
                45.5954319,
                35.9703908
              ],
              [
                45.5953871,
                35.9700371
              ],
              [
                45.5954583,
                35.9697958
              ],
              [
                45.5955703,
                35.9697272
              ],
              [
                45.5957385,
                35.9696976
              ],
              [
                45.5958821,
                35.9696125
              ],
              [
                45.5959699,
                35.9694788
              ],
              [
                45.5960621,
                35.9693697
              ],
              [
                45.5960639,
                35.9691947
              ],
              [
                45.5958889,
                35.9689417
              ],
              [
                45.5956241,
                35.968778
              ],
              [
                45.5953067,
                35.9685172
              ],
              [
                45.5950054,
                35.9681913
              ],
              [
                45.5944751,
                35.967841
              ],
              [
                45.5943225,
                35.9676859
              ],
              [
                45.5941219,
                35.9673433
              ],
              [
                45.5941883,
                35.9671833
              ],
              [
                45.5941692,
                35.9668203
              ],
              [
                45.5942079,
                35.9664989
              ],
              [
                45.5944322,
                35.9662797
              ],
              [
                45.5945323,
                35.966079
              ],
              [
                45.5946146,
                35.9657281
              ],
              [
                45.5947048,
                35.9653447
              ],
              [
                45.5948689,
                35.9651047
              ],
              [
                45.5950073,
                35.9650074
              ],
              [
                45.5952662,
                35.9649427
              ],
              [
                45.5956438,
                35.9647845
              ],
              [
                45.5958487,
                35.9647541
              ],
              [
                45.595915,
                35.9646576
              ],
              [
                45.5959843,
                35.9645118
              ],
              [
                45.5965601,
                35.9643074
              ],
              [
                45.5971482,
                35.9639599
              ],
              [
                45.5973498,
                35.9638523
              ],
              [
                45.5976195,
                35.9635708
              ],
              [
                45.5977905,
                35.9633845
              ],
              [
                45.5980821,
                35.9630095
              ],
              [
                45.5983045,
                35.9627894
              ],
              [
                45.5986395,
                35.9625368
              ],
              [
                45.5991767,
                35.9615777
              ],
              [
                45.5992966,
                35.9613715
              ],
              [
                45.5994851,
                35.9614017
              ],
              [
                45.5997241,
                35.9611663
              ],
              [
                45.6000446,
                35.9608697
              ],
              [
                45.6001159,
                35.9606902
              ],
              [
                45.6004074,
                35.960257
              ],
              [
                45.6006818,
                35.9599948
              ],
              [
                45.6009758,
                35.9597498
              ],
              [
                45.6011469,
                35.9596631
              ],
              [
                45.601732,
                35.9595407
              ],
              [
                45.602209,
                35.9594415
              ],
              [
                45.6029929,
                35.9588103
              ],
              [
                45.603401,
                35.9584265
              ],
              [
                45.6039859,
                35.9580426
              ],
              [
                45.6044077,
                35.9579592
              ],
              [
                45.6049468,
                35.9580053
              ],
              [
                45.6053573,
                35.9580449
              ],
              [
                45.6060309,
                35.9582806
              ],
              [
                45.6062141,
                35.9582821
              ],
              [
                45.6064135,
                35.9582331
              ],
              [
                45.6066177,
                35.9582639
              ],
              [
                45.6067496,
                35.9583533
              ],
              [
                45.6067946,
                35.9584765
              ],
              [
                45.6068044,
                35.9586189
              ],
              [
                45.6067517,
                35.9589492
              ],
              [
                45.606638,
                35.9593195
              ],
              [
                45.6066127,
                35.9595337
              ],
              [
                45.6066505,
                35.9596496
              ],
              [
                45.6067342,
                35.9597645
              ],
              [
                45.6069176,
                35.9599356
              ],
              [
                45.6078344,
                35.9607342
              ],
              [
                45.6079847,
                35.9606974
              ],
              [
                45.60836,
                35.9609665
              ],
              [
                45.6085503,
                35.9609304
              ],
              [
                45.6086856,
                35.9607482
              ],
              [
                45.6088636,
                35.9606287
              ],
              [
                45.6091999,
                35.9602816
              ],
              [
                45.6095253,
                35.9587171
              ],
              [
                45.6102374,
                35.95747
              ],
              [
                45.6127621,
                35.9571213
              ],
              [
                45.6146636,
                35.9570003
              ],
              [
                45.6164205,
                35.9569283
              ],
              [
                45.6177465,
                35.9555433
              ],
              [
                45.6182658,
                35.9555566
              ],
              [
                45.6194661,
                35.9564762
              ],
              [
                45.6199847,
                35.9565077
              ],
              [
                45.6207868,
                35.9581806
              ],
              [
                45.6217719,
                35.958659
              ],
              [
                45.6229582,
                35.9577835
              ],
              [
                45.622925,
                35.957687
              ],
              [
                45.622743,
                35.957488
              ],
              [
                45.622959,
                35.956954
              ],
              [
                45.623441,
                35.956235
              ],
              [
                45.623377,
                35.955983
              ],
              [
                45.623223,
                35.955768
              ],
              [
                45.622895,
                35.955633
              ],
              [
                45.6226853,
                35.9554311
              ],
              [
                45.62268,
                35.954757
              ],
              [
                45.622872,
                35.954568
              ],
              [
                45.623415,
                35.953688
              ],
              [
                45.624108,
                35.952811
              ],
              [
                45.624519,
                35.952507
              ],
              [
                45.624819,
                35.952172
              ],
              [
                45.624966,
                35.951554
              ],
              [
                45.625302,
                35.951111
              ],
              [
                45.625897,
                35.950642
              ],
              [
                45.626162,
                35.950318
              ],
              [
                45.626117,
                35.949453
              ],
              [
                45.625839,
                35.949024
              ],
              [
                45.625734,
                35.948622
              ],
              [
                45.625924,
                35.948109
              ],
              [
                45.626288,
                35.947707
              ],
              [
                45.626598,
                35.947258
              ],
              [
                45.626739,
                35.946881
              ],
              [
                45.627081,
                35.946679
              ],
              [
                45.627528,
                35.946553
              ],
              [
                45.627932,
                35.946485
              ],
              [
                45.628424,
                35.946503
              ],
              [
                45.628883,
                35.946354
              ],
              [
                45.629592,
                35.945843
              ],
              [
                45.630026,
                35.945664
              ],
              [
                45.631175,
                35.945426
              ],
              [
                45.63161,
                35.945409
              ],
              [
                45.632175,
                35.945023
              ],
              [
                45.632677,
                35.944822
              ],
              [
                45.633384,
                35.944781
              ],
              [
                45.634182,
                35.944893
              ],
              [
                45.635016,
                35.945084
              ],
              [
                45.635374,
                35.9449
              ],
              [
                45.636076,
                35.944436
              ],
              [
                45.636615,
                35.944256
              ],
              [
                45.636921,
                35.94398
              ],
              [
                45.637358,
                35.943784
              ],
              [
                45.637753,
                35.943785
              ],
              [
                45.638371,
                35.94395
              ],
              [
                45.639396,
                35.944326
              ],
              [
                45.639842,
                35.944385
              ],
              [
                45.641363,
                35.942418
              ],
              [
                45.641618,
                35.941704
              ],
              [
                45.642389,
                35.94087
              ],
              [
                45.643035,
                35.940515
              ],
              [
                45.643434,
                35.939889
              ],
              [
                45.644699,
                35.938736
              ],
              [
                45.645712,
                35.938421
              ],
              [
                45.646005,
                35.938137
              ],
              [
                45.646253,
                35.937715
              ],
              [
                45.646457,
                35.93721
              ],
              [
                45.646971,
                35.936654
              ],
              [
                45.647531,
                35.935922
              ],
              [
                45.647699,
                35.935368
              ],
              [
                45.64811,
                35.935008
              ],
              [
                45.648795,
                35.934714
              ],
              [
                45.649393,
                35.934524
              ],
              [
                45.649848,
                35.934571
              ],
              [
                45.650234,
                35.934797
              ],
              [
                45.650574,
                35.935255
              ],
              [
                45.651016,
                35.935617
              ],
              [
                45.65187,
                35.935787
              ],
              [
                45.653106,
                35.935854
              ],
              [
                45.654793,
                35.934378
              ],
              [
                45.655117,
                35.933972
              ],
              [
                45.655564,
                35.933063
              ],
              [
                45.655886,
                35.93276
              ],
              [
                45.656221,
                35.932624
              ],
              [
                45.656658,
                35.932357
              ],
              [
                45.657145,
                35.931974
              ],
              [
                45.658931,
                35.930787
              ],
              [
                45.65925,
                35.930501
              ],
              [
                45.659478,
                35.930129
              ],
              [
                45.659845,
                35.929958
              ],
              [
                45.660285,
                35.929838
              ],
              [
                45.660703,
                35.929598
              ],
              [
                45.661441,
                35.929291
              ],
              [
                45.661967,
                35.929162
              ],
              [
                45.66257,
                35.928952
              ],
              [
                45.662986,
                35.9284
              ],
              [
                45.663409,
                35.92796
              ],
              [
                45.665625,
                35.926916
              ],
              [
                45.666691,
                35.925676
              ],
              [
                45.667114,
                35.925264
              ],
              [
                45.667471,
                35.924813
              ],
              [
                45.667602,
                35.924474
              ],
              [
                45.667988,
                35.924012
              ],
              [
                45.668078,
                35.923441
              ],
              [
                45.668063,
                35.923076
              ],
              [
                45.667882,
                35.92284
              ],
              [
                45.668547,
                35.922133
              ],
              [
                45.669233,
                35.921603
              ],
              [
                45.669957,
                35.920908
              ],
              [
                45.669965,
                35.919819
              ],
              [
                45.670142,
                35.91916
              ],
              [
                45.6700265,
                35.9171839
              ],
              [
                45.669977,
                35.916337
              ],
              [
                45.670531,
                35.916239
              ],
              [
                45.670829,
                35.916032
              ],
              [
                45.670699,
                35.915577
              ],
              [
                45.670394,
                35.91518
              ],
              [
                45.670301,
                35.914805
              ],
              [
                45.670619,
                35.913386
              ],
              [
                45.671262,
                35.912722
              ],
              [
                45.671612,
                35.911774
              ],
              [
                45.671999,
                35.911289
              ],
              [
                45.67223,
                35.911113
              ],
              [
                45.673201,
                35.910558
              ],
              [
                45.674613,
                35.909831
              ],
              [
                45.67477,
                35.909635
              ],
              [
                45.674878,
                35.908597
              ],
              [
                45.674992,
                35.90813
              ],
              [
                45.675041,
                35.907136
              ],
              [
                45.674987,
                35.906466
              ],
              [
                45.675099,
                35.906129
              ],
              [
                45.675688,
                35.905503
              ],
              [
                45.675899,
                35.905104
              ],
              [
                45.676186,
                35.90434
              ],
              [
                45.676412,
                35.903966
              ],
              [
                45.676555,
                35.903502
              ],
              [
                45.677038,
                35.902614
              ],
              [
                45.677705,
                35.902114
              ],
              [
                45.67834,
                35.901755
              ],
              [
                45.679248,
                35.901377
              ],
              [
                45.679975,
                35.899312
              ],
              [
                45.680528,
                35.897988
              ],
              [
                45.680761,
                35.897862
              ],
              [
                45.68165,
                35.897803
              ],
              [
                45.682639,
                35.897863
              ],
              [
                45.68323,
                35.898169
              ],
              [
                45.683724,
                35.898326
              ],
              [
                45.684304,
                35.89868
              ],
              [
                45.685741,
                35.898853
              ],
              [
                45.686462,
                35.899082
              ],
              [
                45.687104,
                35.899474
              ],
              [
                45.68757,
                35.899373
              ],
              [
                45.688032,
                35.899102
              ],
              [
                45.689283,
                35.899188
              ],
              [
                45.689622,
                35.899374
              ],
              [
                45.690267,
                35.89993
              ],
              [
                45.691154,
                35.90008
              ],
              [
                45.692885,
                35.899746
              ],
              [
                45.69396,
                35.899126
              ],
              [
                45.694639,
                35.897929
              ],
              [
                45.695103,
                35.897406
              ],
              [
                45.695702,
                35.897303
              ],
              [
                45.696159,
                35.897061
              ],
              [
                45.69647,
                35.896702
              ],
              [
                45.69664,
                35.896338
              ],
              [
                45.697095,
                35.895606
              ],
              [
                45.697275,
                35.89515
              ],
              [
                45.697367,
                35.894711
              ],
              [
                45.697036,
                35.894206
              ],
              [
                45.696439,
                35.893788
              ],
              [
                45.696068,
                35.893351
              ],
              [
                45.695506,
                35.892413
              ],
              [
                45.695463,
                35.89212
              ],
              [
                45.695593,
                35.89165
              ],
              [
                45.695467,
                35.891085
              ],
              [
                45.69543,
                35.890511
              ],
              [
                45.695493,
                35.890221
              ],
              [
                45.696112,
                35.889541
              ],
              [
                45.696219,
                35.888766
              ],
              [
                45.695954,
                35.88794
              ],
              [
                45.696007,
                35.88744
              ],
              [
                45.696682,
                35.886577
              ],
              [
                45.696731,
                35.885715
              ],
              [
                45.697595,
                35.885563
              ],
              [
                45.698132,
                35.885359
              ],
              [
                45.698585,
                35.88532
              ],
              [
                45.699292,
                35.885364
              ],
              [
                45.699965,
                35.885323
              ],
              [
                45.700504,
                35.885171
              ],
              [
                45.701282,
                35.885133
              ],
              [
                45.701969,
                35.884968
              ],
              [
                45.70298,
                35.88485
              ],
              [
                45.703499,
                35.884883
              ],
              [
                45.704018,
                35.885179
              ],
              [
                45.704604,
                35.88529
              ],
              [
                45.70493,
                35.885253
              ],
              [
                45.705346,
                35.884942
              ],
              [
                45.706212,
                35.883666
              ],
              [
                45.706585,
                35.883499
              ],
              [
                45.707509,
                35.883397
              ],
              [
                45.708714,
                35.882918
              ],
              [
                45.709309,
                35.882627
              ],
              [
                45.709988,
                35.882125
              ],
              [
                45.710393,
                35.881598
              ],
              [
                45.710721,
                35.881394
              ],
              [
                45.71109,
                35.881039
              ],
              [
                45.711531,
                35.880822
              ],
              [
                45.711986,
                35.880527
              ],
              [
                45.712201,
                35.880246
              ],
              [
                45.712725,
                35.879818
              ],
              [
                45.714555,
                35.877934
              ],
              [
                45.714739,
                35.877538
              ],
              [
                45.71489,
                35.877012
              ],
              [
                45.71475,
                35.876487
              ],
              [
                45.714699,
                35.875856
              ],
              [
                45.71485,
                35.87542
              ],
              [
                45.715224,
                35.874952
              ],
              [
                45.715696,
                35.874503
              ],
              [
                45.716501,
                35.873954
              ],
              [
                45.717376,
                35.872926
              ],
              [
                45.717438,
                35.872507
              ],
              [
                45.717461,
                35.872201
              ],
              [
                45.717223,
                35.871784
              ],
              [
                45.716729,
                35.871408
              ],
              [
                45.716257,
                35.870152
              ],
              [
                45.715992,
                35.869808
              ],
              [
                45.715868,
                35.869251
              ],
              [
                45.71591,
                35.868843
              ],
              [
                45.715806,
                35.868538
              ],
              [
                45.715432,
                35.868395
              ],
              [
                45.715507,
                35.867672
              ],
              [
                45.717003,
                35.866363
              ],
              [
                45.717555,
                35.866046
              ],
              [
                45.717666,
                35.865731
              ],
              [
                45.716899,
                35.864006
              ],
              [
                45.716446,
                35.86326
              ],
              [
                45.716289,
                35.86267
              ],
              [
                45.716445,
                35.862294
              ],
              [
                45.717055,
                35.861578
              ],
              [
                45.718231,
                35.861339
              ],
              [
                45.71912,
                35.861107
              ],
              [
                45.719918,
                35.861013
              ],
              [
                45.72075,
                35.861003
              ],
              [
                45.722825,
                35.861224
              ],
              [
                45.723118,
                35.861148
              ],
              [
                45.723368,
                35.860913
              ],
              [
                45.723562,
                35.859896
              ],
              [
                45.724134,
                35.858992
              ],
              [
                45.724592,
                35.8581
              ],
              [
                45.724414,
                35.857167
              ],
              [
                45.724435,
                35.856763
              ],
              [
                45.724664,
                35.85614
              ],
              [
                45.724918,
                35.855656
              ],
              [
                45.724735,
                35.855275
              ],
              [
                45.724639,
                35.854825
              ],
              [
                45.724634,
                35.854237
              ],
              [
                45.724896,
                35.853827
              ],
              [
                45.72528,
                35.853613
              ],
              [
                45.72525,
                35.853369
              ],
              [
                45.725036,
                35.852956
              ],
              [
                45.725225,
                35.852446
              ],
              [
                45.726015,
                35.851921
              ],
              [
                45.72642,
                35.851569
              ],
              [
                45.72661,
                35.850706
              ],
              [
                45.727207,
                35.849937
              ],
              [
                45.727545,
                35.849417
              ],
              [
                45.727973,
                35.848376
              ],
              [
                45.728407,
                35.847796
              ],
              [
                45.728757,
                35.84743
              ],
              [
                45.730062,
                35.846689
              ],
              [
                45.730676,
                35.846272
              ],
              [
                45.731247,
                35.845962
              ],
              [
                45.732181,
                35.845657
              ],
              [
                45.733241,
                35.84507
              ],
              [
                45.733995,
                35.844825
              ],
              [
                45.734334,
                35.844602
              ],
              [
                45.734394,
                35.844301
              ],
              [
                45.734345,
                35.84398
              ],
              [
                45.734455,
                35.843603
              ],
              [
                45.734695,
                35.84321
              ],
              [
                45.735092,
                35.842976
              ],
              [
                45.735773,
                35.84243
              ],
              [
                45.736933,
                35.842055
              ],
              [
                45.737331,
                35.841821
              ],
              [
                45.737446,
                35.841534
              ],
              [
                45.737341,
                35.841125
              ],
              [
                45.737744,
                35.839957
              ],
              [
                45.738062,
                35.839622
              ],
              [
                45.738612,
                35.839201
              ],
              [
                45.738803,
                35.838891
              ],
              [
                45.738808,
                35.838651
              ],
              [
                45.738614,
                35.837813
              ],
              [
                45.738744,
                35.837177
              ],
              [
                45.73875,
                35.836721
              ],
              [
                45.738353,
                35.836006
              ],
              [
                45.738234,
                35.835508
              ],
              [
                45.738565,
                35.835147
              ],
              [
                45.738939,
                35.834867
              ],
              [
                45.739914,
                35.834785
              ],
              [
                45.740029,
                35.834606
              ],
              [
                45.739917,
                35.834355
              ],
              [
                45.739664,
                35.834041
              ],
              [
                45.739274,
                35.833712
              ],
              [
                45.739173,
                35.83317
              ],
              [
                45.738944,
                35.83276
              ],
              [
                45.738848,
                35.831903
              ],
              [
                45.738897,
                35.830614
              ],
              [
                45.738604,
                35.83034
              ],
              [
                45.738416,
                35.82989
              ],
              [
                45.738471,
                35.82774
              ],
              [
                45.739771,
                35.82742
              ],
              [
                45.740926,
                35.827245
              ],
              [
                45.7417,
                35.827144
              ],
              [
                45.743259,
                35.827047
              ],
              [
                45.743748,
                35.827067
              ],
              [
                45.744822,
                35.826825
              ],
              [
                45.745185,
                35.826688
              ],
              [
                45.74613,
                35.826496
              ],
              [
                45.746581,
                35.826161
              ],
              [
                45.747013,
                35.825977
              ],
              [
                45.747877,
                35.825388
              ],
              [
                45.748156,
                35.824987
              ],
              [
                45.748661,
                35.824442
              ],
              [
                45.749126,
                35.823641
              ],
              [
                45.749528,
                35.822762
              ],
              [
                45.750085,
                35.822034
              ],
              [
                45.750546,
                35.820928
              ],
              [
                45.75072,
                35.820374
              ],
              [
                45.751583,
                35.818976
              ],
              [
                45.751917,
                35.818514
              ],
              [
                45.75278,
                35.818032
              ],
              [
                45.753119,
                35.817628
              ],
              [
                45.753504,
                35.816983
              ],
              [
                45.753934,
                35.816023
              ],
              [
                45.754512,
                35.815514
              ],
              [
                45.754966,
                35.815005
              ],
              [
                45.755099,
                35.814781
              ],
              [
                45.755639,
                35.813552
              ],
              [
                45.755835,
                35.812895
              ],
              [
                45.755646,
                35.811891
              ],
              [
                45.755438,
                35.811114
              ],
              [
                45.755357,
                35.810535
              ],
              [
                45.755358,
                35.809915
              ],
              [
                45.755497,
                35.808723
              ],
              [
                45.755606,
                35.808487
              ],
              [
                45.756061,
                35.808093
              ],
              [
                45.756661,
                35.807332
              ],
              [
                45.75687,
                35.806978
              ],
              [
                45.757639,
                35.806786
              ],
              [
                45.758913,
                35.806555
              ],
              [
                45.760201,
                35.806378
              ],
              [
                45.760588,
                35.805923
              ],
              [
                45.760927,
                35.804858
              ],
              [
                45.761858,
                35.803628
              ],
              [
                45.762048,
                35.803244
              ],
              [
                45.762318,
                35.802663
              ],
              [
                45.762805,
                35.801246
              ],
              [
                45.762865,
                35.800508
              ],
              [
                45.763041,
                35.799961
              ],
              [
                45.763235,
                35.799626
              ],
              [
                45.763701,
                35.799014
              ],
              [
                45.7641584,
                35.7991035
              ],
              [
                45.7670094,
                35.8015681
              ],
              [
                45.7701371,
                35.8056657
              ],
              [
                45.771725,
                35.8088656
              ],
              [
                45.7730723,
                35.813314
              ],
              [
                45.780287,
                35.81056
              ],
              [
                45.791769,
                35.812532
              ],
              [
                45.791901,
                35.812167
              ],
              [
                45.791901,
                35.812165
              ],
              [
                45.791902,
                35.812165
              ],
              [
                45.792381,
                35.812254
              ],
              [
                45.792541,
                35.812398
              ],
              [
                45.792737,
                35.81245
              ],
              [
                45.793047,
                35.812568
              ],
              [
                45.793401,
                35.812655
              ],
              [
                45.793853,
                35.812539
              ],
              [
                45.794287,
                35.812438
              ],
              [
                45.794568,
                35.812428
              ],
              [
                45.794955,
                35.812452
              ],
              [
                45.795202,
                35.812507
              ],
              [
                45.795525,
                35.812721
              ],
              [
                45.795813,
                35.812904
              ],
              [
                45.795983,
                35.813181
              ],
              [
                45.796113,
                35.813366
              ],
              [
                45.796324,
                35.813441
              ],
              [
                45.796452,
                35.813623
              ],
              [
                45.796623,
                35.813845
              ],
              [
                45.796954,
                35.814091
              ],
              [
                45.797397,
                35.814219
              ],
              [
                45.797579,
                35.814374
              ],
              [
                45.797863,
                35.814595
              ],
              [
                45.798124,
                35.814738
              ],
              [
                45.79834,
                35.814737
              ],
              [
                45.79844,
                35.814854
              ],
              [
                45.79862,
                35.815092
              ],
              [
                45.798605,
                35.815367
              ],
              [
                45.79851,
                35.815617
              ],
              [
                45.798132,
                35.816029
              ],
              [
                45.798145,
                35.816407
              ],
              [
                45.798314,
                35.816754
              ],
              [
                45.798398,
                35.817125
              ],
              [
                45.798501,
                35.817452
              ],
              [
                45.79865,
                35.817803
              ],
              [
                45.798626,
                35.818155
              ],
              [
                45.798598,
                35.818532
              ],
              [
                45.798583,
                35.818882
              ],
              [
                45.798749,
                35.819106
              ],
              [
                45.798849,
                35.819317
              ],
              [
                45.798901,
                35.819538
              ],
              [
                45.799075,
                35.819827
              ],
              [
                45.799185,
                35.820111
              ],
              [
                45.799329,
                35.820331
              ],
              [
                45.799555,
                35.820658
              ],
              [
                45.799606,
                35.820987
              ],
              [
                45.799645,
                35.821343
              ],
              [
                45.799556,
                35.821724
              ],
              [
                45.799359,
                35.822051
              ],
              [
                45.79907,
                35.822487
              ],
              [
                45.799163,
                35.82289
              ],
              [
                45.799144,
                35.823299
              ],
              [
                45.79912,
                35.823799
              ],
              [
                45.799261,
                35.824118
              ],
              [
                45.799528,
                35.824446
              ],
              [
                45.799525,
                35.824728
              ],
              [
                45.799627,
                35.825129
              ],
              [
                45.799826,
                35.825619
              ],
              [
                45.800144,
                35.826383
              ],
              [
                45.80038,
                35.827039
              ],
              [
                45.800704,
                35.826984
              ],
              [
                45.8011,
                35.826783
              ],
              [
                45.801816,
                35.826363
              ],
              [
                45.802305,
                35.826161
              ],
              [
                45.802714,
                35.825858
              ],
              [
                45.803056,
                35.82561
              ],
              [
                45.803866,
                35.825121
              ],
              [
                45.80428,
                35.824875
              ],
              [
                45.804739,
                35.82453
              ],
              [
                45.805284,
                35.82416
              ],
              [
                45.805798,
                35.823903
              ],
              [
                45.806396,
                35.823539
              ],
              [
                45.807024,
                35.823466
              ],
              [
                45.807394,
                35.823427
              ],
              [
                45.807957,
                35.823491
              ],
              [
                45.808384,
                35.823507
              ],
              [
                45.8092,
                35.82348
              ],
              [
                45.80959,
                35.823586
              ],
              [
                45.810231,
                35.823196
              ],
              [
                45.810896,
                35.822885
              ],
              [
                45.811542,
                35.822619
              ],
              [
                45.812128,
                35.822142
              ],
              [
                45.812779,
                35.821602
              ],
              [
                45.813252,
                35.821344
              ],
              [
                45.813595,
                35.82117
              ],
              [
                45.814035,
                35.820944
              ],
              [
                45.814629,
                35.820639
              ],
              [
                45.815898,
                35.820284
              ],
              [
                45.816538,
                35.820069
              ],
              [
                45.817296,
                35.819764
              ],
              [
                45.81762,
                35.819486
              ],
              [
                45.818001,
                35.819049
              ],
              [
                45.818576,
                35.818714
              ],
              [
                45.819274,
                35.818305
              ],
              [
                45.81985,
                35.817937
              ],
              [
                45.820545,
                35.817661
              ],
              [
                45.821357,
                35.817255
              ],
              [
                45.822397,
                35.816888
              ],
              [
                45.823048,
                35.816678
              ],
              [
                45.823409,
                35.816534
              ],
              [
                45.823639,
                35.816216
              ],
              [
                45.823873,
                35.815766
              ],
              [
                45.824381,
                35.815486
              ],
              [
                45.824962,
                35.8151
              ],
              [
                45.82541,
                35.814896
              ],
              [
                45.826206,
                35.81445
              ],
              [
                45.827017,
                35.813943
              ],
              [
                45.827562,
                35.813571
              ],
              [
                45.828142,
                35.813027
              ],
              [
                45.828479,
                35.812513
              ],
              [
                45.829163,
                35.811791
              ],
              [
                45.829417,
                35.811419
              ],
              [
                45.829902,
                35.810934
              ],
              [
                45.830873,
                35.809891
              ],
              [
                45.831285,
                35.809702
              ],
              [
                45.832152,
                35.80983
              ],
              [
                45.832823,
                35.809864
              ],
              [
                45.833385,
                35.81006
              ],
              [
                45.833883,
                35.810161
              ],
              [
                45.834444,
                35.810233
              ],
              [
                45.834908,
                35.810398
              ],
              [
                45.835579,
                35.810813
              ],
              [
                45.836,
                35.811351
              ],
              [
                45.836439,
                35.811803
              ],
              [
                45.837103,
                35.812269
              ],
              [
                45.837631,
                35.812679
              ],
              [
                45.838336,
                35.812996
              ],
              [
                45.839039,
                35.813379
              ],
              [
                45.839865,
                35.813623
              ],
              [
                45.840683,
                35.813876
              ],
              [
                45.841407,
                35.813958
              ],
              [
                45.841405,
                35.81395
              ],
              [
                45.842039,
                35.814074
              ],
              [
                45.84248,
                35.814111
              ],
              [
                45.842918,
                35.814174
              ],
              [
                45.84354,
                35.814176
              ],
              [
                45.844261,
                35.813977
              ],
              [
                45.844791,
                35.813856
              ],
              [
                45.845246,
                35.813908
              ],
              [
                45.845604,
                35.814086
              ],
              [
                45.846095,
                35.814353
              ],
              [
                45.846442,
                35.814683
              ],
              [
                45.847159,
                35.814931
              ],
              [
                45.847912,
                35.815239
              ],
              [
                45.848621,
                35.815497
              ],
              [
                45.849232,
                35.815683
              ],
              [
                45.850033,
                35.816023
              ],
              [
                45.850746,
                35.816487
              ],
              [
                45.851345,
                35.816783
              ],
              [
                45.852072,
                35.817071
              ],
              [
                45.852417,
                35.817393
              ],
              [
                45.853224,
                35.81764
              ],
              [
                45.853957,
                35.818026
              ],
              [
                45.854684,
                35.818272
              ],
              [
                45.855327,
                35.818428
              ],
              [
                45.856012,
                35.818401
              ],
              [
                45.856534,
                35.818249
              ],
              [
                45.856986,
                35.818251
              ],
              [
                45.857375,
                35.818166
              ],
              [
                45.857953,
                35.818077
              ],
              [
                45.858501,
                35.818177
              ],
              [
                45.859157,
                35.81823
              ],
              [
                45.859729,
                35.818308
              ],
              [
                45.860197,
                35.818407
              ],
              [
                45.861004,
                35.818654
              ],
              [
                45.861444,
                35.818841
              ],
              [
                45.861812,
                35.818868
              ],
              [
                45.862402,
                35.818669
              ],
              [
                45.862824,
                35.818404
              ],
              [
                45.863627,
                35.817866
              ],
              [
                45.864251,
                35.817222
              ],
              [
                45.864812,
                35.816913
              ],
              [
                45.865282,
                35.816829
              ],
              [
                45.866706,
                35.816252
              ],
              [
                45.867674,
                35.815929
              ],
              [
                45.868671,
                35.815714
              ],
              [
                45.869133,
                35.815464
              ],
              [
                45.869686,
                35.815082
              ],
              [
                45.870262,
                35.81468
              ],
              [
                45.870816,
                35.814317
              ],
              [
                45.871392,
                35.813859
              ],
              [
                45.872014,
                35.8134
              ],
              [
                45.87222,
                35.813096
              ],
              [
                45.872839,
                35.81241
              ],
              [
                45.873554,
                35.811894
              ],
              [
                45.87388,
                35.811614
              ],
              [
                45.874114,
                35.81132
              ],
              [
                45.8744,
                35.811338
              ],
              [
                45.874868,
                35.811362
              ],
              [
                45.875358,
                35.811473
              ],
              [
                45.875917,
                35.811578
              ],
              [
                45.876395,
                35.811832
              ],
              [
                45.876772,
                35.812123
              ],
              [
                45.877195,
                35.812131
              ],
              [
                45.877859,
                35.812174
              ],
              [
                45.878564,
                35.812417
              ],
              [
                45.879193,
                35.812633
              ],
              [
                45.87944,
                35.812733
              ],
              [
                45.879776,
                35.813023
              ],
              [
                45.879976,
                35.813365
              ],
              [
                45.879955,
                35.813783
              ],
              [
                45.87979,
                35.814113
              ],
              [
                45.879596,
                35.814673
              ],
              [
                45.879594,
                35.815128
              ],
              [
                45.87969,
                35.815648
              ],
              [
                45.879826,
                35.816168
              ],
              [
                45.879885,
                35.816545
              ],
              [
                45.880106,
                35.816932
              ],
              [
                45.880192,
                35.817147
              ],
              [
                45.880255,
                35.81754
              ],
              [
                45.880281,
                35.817718
              ],
              [
                45.880432,
                35.817911
              ],
              [
                45.88076,
                35.818129
              ],
              [
                45.881102,
                35.818285
              ],
              [
                45.881334,
                35.818521
              ],
              [
                45.881411,
                35.818779
              ],
              [
                45.881331,
                35.819084
              ],
              [
                45.881349,
                35.819346
              ],
              [
                45.881352,
                35.819743
              ],
              [
                45.88136,
                35.820155
              ],
              [
                45.881461,
                35.82035
              ],
              [
                45.881526,
                35.820561
              ],
              [
                45.881544,
                35.820897
              ],
              [
                45.881613,
                35.821124
              ],
              [
                45.881799,
                35.821336
              ],
              [
                45.881886,
                35.821592
              ],
              [
                45.881814,
                35.821813
              ],
              [
                45.881718,
                35.822063
              ],
              [
                45.881744,
                35.822315
              ],
              [
                45.88186,
                35.822566
              ],
              [
                45.88183,
                35.822911
              ],
              [
                45.881889,
                35.823139
              ],
              [
                45.882051,
                35.823488
              ],
              [
                45.882121,
                35.823872
              ],
              [
                45.882051,
                35.824142
              ],
              [
                45.881861,
                35.824412
              ],
              [
                45.881911,
                35.824716
              ],
              [
                45.881881,
                35.824987
              ],
              [
                45.881853,
                35.825266
              ],
              [
                45.881679,
                35.825557
              ],
              [
                45.881594,
                35.825731
              ],
              [
                45.881659,
                35.825941
              ],
              [
                45.881759,
                35.82617
              ],
              [
                45.881769,
                35.826591
              ],
              [
                45.881733,
                35.826838
              ],
              [
                45.881833,
                35.827298
              ],
              [
                45.881954,
                35.827837
              ],
              [
                45.881935,
                35.828148
              ],
              [
                45.881978,
                35.828545
              ],
              [
                45.882194,
                35.829214
              ],
              [
                45.882226,
                35.829721
              ],
              [
                45.882067,
                35.83015
              ],
              [
                45.881905,
                35.83043
              ],
              [
                45.881711,
                35.830675
              ],
              [
                45.882179,
                35.830767
              ],
              [
                45.88259,
                35.830884
              ],
              [
                45.883117,
                35.831136
              ],
              [
                45.883691,
                35.831412
              ],
              [
                45.8842,
                35.831553
              ],
              [
                45.884828,
                35.831653
              ],
              [
                45.885341,
                35.83185
              ],
              [
                45.885664,
                35.83182
              ],
              [
                45.886018,
                35.831676
              ],
              [
                45.88672,
                35.831637
              ],
              [
                45.887245,
                35.831766
              ],
              [
                45.88773,
                35.83201
              ],
              [
                45.888034,
                35.832365
              ],
              [
                45.888145,
                35.83279
              ],
              [
                45.888276,
                35.833369
              ],
              [
                45.888423,
                35.833853
              ],
              [
                45.888872,
                35.834576
              ],
              [
                45.889092,
                35.835146
              ],
              [
                45.88933,
                35.835521
              ],
              [
                45.88978,
                35.835516
              ],
              [
                45.890716,
                35.835448
              ],
              [
                45.891478,
                35.835373
              ],
              [
                45.891989,
                35.835405
              ],
              [
                45.89238,
                35.835519
              ],
              [
                45.893038,
                35.835696
              ],
              [
                45.893671,
                35.835778
              ],
              [
                45.894012,
                35.835778
              ],
              [
                45.894512,
                35.836193
              ],
              [
                45.895008,
                35.836824
              ],
              [
                45.895664,
                35.837415
              ],
              [
                45.896036,
                35.837649
              ],
              [
                45.896501,
                35.83769
              ],
              [
                45.896827,
                35.837622
              ],
              [
                45.897175,
                35.837516
              ],
              [
                45.897932,
                35.837186
              ],
              [
                45.898427,
                35.836931
              ],
              [
                45.899089,
                35.836797
              ],
              [
                45.9,
                35.836502
              ],
              [
                45.900559,
                35.836339
              ],
              [
                45.901061,
                35.836397
              ],
              [
                45.9015,
                35.836485
              ],
              [
                45.90177,
                35.836539
              ],
              [
                45.902145,
                35.836917
              ],
              [
                45.902542,
                35.837054
              ],
              [
                45.903043,
                35.837089
              ],
              [
                45.903602,
                35.837099
              ],
              [
                45.904045,
                35.83695
              ],
              [
                45.904788,
                35.836663
              ],
              [
                45.905441,
                35.836456
              ],
              [
                45.90605,
                35.836523
              ],
              [
                45.906343,
                35.836437
              ],
              [
                45.906485,
                35.836152
              ],
              [
                45.906742,
                35.835774
              ],
              [
                45.907095,
                35.835511
              ],
              [
                45.907497,
                35.835324
              ],
              [
                45.908067,
                35.835241
              ],
              [
                45.908816,
                35.834995
              ],
              [
                45.90955,
                35.83483
              ],
              [
                45.910171,
                35.834634
              ],
              [
                45.910744,
                35.83414
              ],
              [
                45.911269,
                35.833884
              ],
              [
                45.911934,
                35.833782
              ],
              [
                45.912358,
                35.833658
              ],
              [
                45.912744,
                35.833156
              ],
              [
                45.91332,
                35.832596
              ],
              [
                45.914021,
                35.832553
              ],
              [
                45.914883,
                35.832707
              ],
              [
                45.91545,
                35.832877
              ],
              [
                45.915998,
                35.832927
              ],
              [
                45.916025,
                35.832929
              ],
              [
                45.916377,
                35.83276
              ],
              [
                45.916786,
                35.832733
              ],
              [
                45.917189,
                35.832813
              ],
              [
                45.917746,
                35.83272
              ],
              [
                45.918597,
                35.832404
              ],
              [
                45.919771,
                35.831908
              ],
              [
                45.920407,
                35.831788
              ],
              [
                45.921268,
                35.831648
              ],
              [
                45.921739,
                35.831605
              ],
              [
                45.92204,
                35.831567
              ],
              [
                45.922368,
                35.831593
              ],
              [
                45.922972,
                35.831698
              ],
              [
                45.923571,
                35.831783
              ],
              [
                45.924022,
                35.831612
              ],
              [
                45.9248,
                35.831418
              ],
              [
                45.924972,
                35.831347
              ],
              [
                45.925496,
                35.831049
              ],
              [
                45.926085,
                35.831
              ],
              [
                45.926428,
                35.830837
              ],
              [
                45.926969,
                35.830603
              ],
              [
                45.927879,
                35.830383
              ],
              [
                45.928193,
                35.830259
              ],
              [
                45.928973,
                35.829882
              ],
              [
                45.929272,
                35.829762
              ],
              [
                45.93006,
                35.829417
              ],
              [
                45.930307,
                35.829289
              ],
              [
                45.93069,
                35.829044
              ],
              [
                45.931308,
                35.828666
              ],
              [
                45.932005,
                35.828339
              ],
              [
                45.932248,
                35.828097
              ],
              [
                45.932344,
                35.82785
              ],
              [
                45.932387,
                35.827573
              ],
              [
                45.932417,
                35.827054
              ],
              [
                45.932339,
                35.826258
              ],
              [
                45.932379,
                35.826084
              ],
              [
                45.93276,
                35.82572
              ],
              [
                45.933114,
                35.825443
              ],
              [
                45.933394,
                35.825132
              ],
              [
                45.933539,
                35.824863
              ],
              [
                45.93417,
                35.824321
              ],
              [
                45.934583,
                35.824116
              ],
              [
                45.935183,
                35.824031
              ],
              [
                45.935854,
                35.824048
              ],
              [
                45.936148,
                35.82402
              ],
              [
                45.936574,
                35.823886
              ],
              [
                45.937388,
                35.82366
              ],
              [
                45.938274,
                35.823615
              ],
              [
                45.938791,
                35.823484
              ],
              [
                45.939586,
                35.82351
              ],
              [
                45.940173,
                35.823759
              ],
              [
                45.940909,
                35.824136
              ],
              [
                45.941035,
                35.824447
              ],
              [
                45.941132,
                35.8248
              ],
              [
                45.941601,
                35.824903
              ],
              [
                45.942041,
                35.825052
              ],
              [
                45.942722,
                35.825469
              ],
              [
                45.943018,
                35.825664
              ],
              [
                45.943557,
                35.825616
              ],
              [
                45.944113,
                35.825552
              ],
              [
                45.944431,
                35.82537
              ],
              [
                45.944703,
                35.825316
              ],
              [
                45.945358,
                35.825482
              ],
              [
                45.946092,
                35.825619
              ],
              [
                45.946377,
                35.825753
              ],
              [
                45.946856,
                35.8258
              ],
              [
                45.947273,
                35.8259
              ],
              [
                45.947811,
                35.826093
              ],
              [
                45.948035,
                35.826128
              ],
              [
                45.948368,
                35.825942
              ],
              [
                45.948808,
                35.825765
              ],
              [
                45.949097,
                35.825335
              ],
              [
                45.949414,
                35.824896
              ],
              [
                45.950017,
                35.824074
              ],
              [
                45.950304,
                35.823563
              ],
              [
                45.950447,
                35.823477
              ],
              [
                45.950814,
                35.823363
              ],
              [
                45.951142,
                35.823257
              ],
              [
                45.951591,
                35.823111
              ],
              [
                45.951869,
                35.823082
              ],
              [
                45.952341,
                35.823047
              ],
              [
                45.952592,
                35.823068
              ],
              [
                45.952945,
                35.823152
              ],
              [
                45.953173,
                35.823177
              ],
              [
                45.953518,
                35.823118
              ],
              [
                45.953861,
                35.822989
              ],
              [
                45.954188,
                35.822837
              ],
              [
                45.954344,
                35.822803
              ],
              [
                45.954629,
                35.822838
              ],
              [
                45.955184,
                35.822948
              ],
              [
                45.955474,
                35.823057
              ],
              [
                45.955589,
                35.823191
              ],
              [
                45.955575,
                35.823749
              ],
              [
                45.955933,
                35.824353
              ],
              [
                45.956233,
                35.824791
              ],
              [
                45.956394,
                35.825194
              ],
              [
                45.956566,
                35.825699
              ],
              [
                45.956704,
                35.826495
              ],
              [
                45.956829,
                35.827071
              ],
              [
                45.956844,
                35.827453
              ],
              [
                45.956778,
                35.828025
              ],
              [
                45.956735,
                35.828493
              ],
              [
                45.956741,
                35.828711
              ],
              [
                45.956595,
                35.829034
              ],
              [
                45.956362,
                35.829402
              ],
              [
                45.956352,
                35.829419
              ],
              [
                45.956364,
                35.829973
              ],
              [
                45.956302,
                35.830772
              ],
              [
                45.956278,
                35.831791
              ],
              [
                45.95624,
                35.832663
              ],
              [
                45.956216,
                35.833492
              ],
              [
                45.956186,
                35.834168
              ],
              [
                45.956185,
                35.834181
              ],
              [
                45.956291,
                35.834375
              ],
              [
                45.956385,
                35.834812
              ],
              [
                45.956375,
                35.835117
              ],
              [
                45.956466,
                35.835388
              ],
              [
                45.956665,
                35.835652
              ],
              [
                45.956904,
                35.83582
              ],
              [
                45.957136,
                35.835994
              ],
              [
                45.95743,
                35.836143
              ],
              [
                45.957682,
                35.836147
              ],
              [
                45.957999,
                35.83611
              ],
              [
                45.958402,
                35.835944
              ],
              [
                45.958652,
                35.835961
              ],
              [
                45.958987,
                35.83609
              ],
              [
                45.959293,
                35.836282
              ],
              [
                45.959511,
                35.8365
              ],
              [
                45.959594,
                35.836707
              ],
              [
                45.960135,
                35.837086
              ],
              [
                45.960472,
                35.837243
              ],
              [
                45.960817,
                35.837374
              ],
              [
                45.960859,
                35.83761
              ],
              [
                45.960942,
                35.837946
              ],
              [
                45.961106,
                35.838327
              ],
              [
                45.961362,
                35.838633
              ],
              [
                45.961675,
                35.83887
              ],
              [
                45.962239,
                35.839281
              ],
              [
                45.962628,
                35.83985
              ],
              [
                45.962634,
                35.840408
              ],
              [
                45.962781,
                35.840875
              ],
              [
                45.962904,
                35.841232
              ],
              [
                45.963195,
                35.841692
              ],
              [
                45.963531,
                35.842247
              ],
              [
                45.963729,
                35.84314
              ],
              [
                45.964013,
                35.843593
              ],
              [
                45.964361,
                35.843579
              ],
              [
                45.965023,
                35.843523
              ],
              [
                45.96555,
                35.843333
              ],
              [
                45.96583,
                35.843175
              ],
              [
                45.966061,
                35.842911
              ],
              [
                45.966369,
                35.842837
              ],
              [
                45.966654,
                35.842661
              ],
              [
                45.966937,
                35.84263
              ],
              [
                45.96738,
                35.842564
              ],
              [
                45.967381,
                35.842564
              ],
              [
                45.968191,
                35.842189
              ],
              [
                45.968616,
                35.842052
              ],
              [
                45.969102,
                35.841953
              ],
              [
                45.96937,
                35.841788
              ],
              [
                45.969583,
                35.841395
              ],
              [
                45.969837,
                35.840869
              ],
              [
                45.970228,
                35.840274
              ],
              [
                45.970655,
                35.83995
              ],
              [
                45.97076,
                35.839661
              ],
              [
                45.97079,
                35.839237
              ],
              [
                45.970695,
                35.838875
              ],
              [
                45.970485,
                35.838552
              ],
              [
                45.970443,
                35.838237
              ],
              [
                45.970481,
                35.837902
              ],
              [
                45.970718,
                35.837715
              ],
              [
                45.971155,
                35.837526
              ],
              [
                45.9713,
                35.837237
              ],
              [
                45.971427,
                35.837013
              ],
              [
                45.971669,
                35.836883
              ],
              [
                45.97196,
                35.836788
              ],
              [
                45.972343,
                35.83668
              ],
              [
                45.972701,
                35.836742
              ],
              [
                45.972925,
                35.836698
              ],
              [
                45.97333,
                35.83654
              ],
              [
                45.973639,
                35.836496
              ],
              [
                45.973831,
                35.836537
              ],
              [
                45.974102,
                35.836558
              ],
              [
                45.974201,
                35.836439
              ],
              [
                45.974094,
                35.836183
              ],
              [
                45.973996,
                35.835846
              ],
              [
                45.974012,
                35.835446
              ],
              [
                45.974047,
                35.835041
              ],
              [
                45.974138,
                35.834874
              ],
              [
                45.974359,
                35.834703
              ],
              [
                45.974587,
                35.834691
              ],
              [
                45.974823,
                35.83469
              ],
              [
                45.975151,
                35.834775
              ],
              [
                45.97545,
                35.834882
              ],
              [
                45.975603,
                35.834893
              ],
              [
                45.975884,
                35.834971
              ],
              [
                45.976131,
                35.835034
              ],
              [
                45.976428,
                35.835017
              ],
              [
                45.97658,
                35.834792
              ],
              [
                45.976765,
                35.834598
              ],
              [
                45.976851,
                35.834428
              ],
              [
                45.977182,
                35.834239
              ],
              [
                45.977625,
                35.834168
              ],
              [
                45.97802,
                35.834045
              ],
              [
                45.978349,
                35.834076
              ],
              [
                45.978762,
                35.83443
              ],
              [
                45.979063,
                35.834602
              ],
              [
                45.979416,
                35.834877
              ],
              [
                45.979701,
                35.835065
              ],
              [
                45.97996,
                35.83525
              ],
              [
                45.980202,
                35.83543
              ],
              [
                45.980586,
                35.835611
              ],
              [
                45.980881,
                35.83576
              ],
              [
                45.981168,
                35.836035
              ],
              [
                45.981258,
                35.836208
              ],
              [
                45.981477,
                35.836467
              ],
              [
                45.981615,
                35.836726
              ],
              [
                45.981791,
                35.836844
              ],
              [
                45.982103,
                35.836961
              ],
              [
                45.982306,
                35.837107
              ],
              [
                45.982442,
                35.837416
              ],
              [
                45.982594,
                35.837635
              ],
              [
                45.982836,
                35.837943
              ],
              [
                45.983062,
                35.838118
              ],
              [
                45.983354,
                35.838313
              ],
              [
                45.983678,
                35.838556
              ],
              [
                45.98411,
                35.83879
              ],
              [
                45.984646,
                35.838958
              ],
              [
                45.985132,
                35.839169
              ],
              [
                45.985411,
                35.839391
              ],
              [
                45.985546,
                35.839502
              ],
              [
                45.985899,
                35.839739
              ],
              [
                45.986225,
                35.839999
              ],
              [
                45.986239,
                35.84001
              ],
              [
                45.986248,
                35.840004
              ],
              [
                45.986914,
                35.839462
              ],
              [
                45.987358,
                35.839126
              ],
              [
                45.987947,
                35.838628
              ],
              [
                45.988478,
                35.838279
              ],
              [
                45.989022,
                35.837869
              ],
              [
                45.989801,
                35.837797
              ],
              [
                45.990545,
                35.837742
              ],
              [
                45.991063,
                35.837769
              ],
              [
                45.991521,
                35.837442
              ],
              [
                45.992225,
                35.837125
              ],
              [
                45.992579,
                35.836849
              ],
              [
                45.993091,
                35.836597
              ],
              [
                45.993954,
                35.836372
              ],
              [
                45.994454,
                35.836249
              ],
              [
                45.994819,
                35.836345
              ],
              [
                45.995247,
                35.83656
              ],
              [
                45.995568,
                35.836628
              ],
              [
                45.996118,
                35.836498
              ],
              [
                45.996496,
                35.836277
              ],
              [
                45.997127,
                35.836041
              ],
              [
                45.99774,
                35.835784
              ],
              [
                45.998293,
                35.835607
              ],
              [
                45.998696,
                35.83551
              ],
              [
                45.99932,
                35.835555
              ],
              [
                45.999737,
                35.835469
              ],
              [
                45.999878,
                35.835155
              ],
              [
                46.000213,
                35.834789
              ],
              [
                46.000587,
                35.834487
              ],
              [
                46.000917,
                35.834157
              ],
              [
                46.001422,
                35.83387
              ],
              [
                46.00181,
                35.833765
              ],
              [
                46.002459,
                35.833934
              ],
              [
                46.002831,
                35.834064
              ],
              [
                46.003311,
                35.834155
              ],
              [
                46.003721,
                35.834279
              ],
              [
                46.004352,
                35.834486
              ],
              [
                46.004807,
                35.834709
              ],
              [
                46.005101,
                35.834956
              ],
              [
                46.005395,
                35.835331
              ],
              [
                46.005452,
                35.835673
              ],
              [
                46.005495,
                35.836133
              ],
              [
                46.005254,
                35.83652
              ],
              [
                46.005462,
                35.836721
              ],
              [
                46.00586,
                35.836789
              ],
              [
                46.006392,
                35.836697
              ],
              [
                46.006681,
                35.836734
              ],
              [
                46.007475,
                35.836987
              ],
              [
                46.008022,
                35.837032
              ],
              [
                46.008732,
                35.837181
              ],
              [
                46.009602,
                35.837305
              ],
              [
                46.010574,
                35.837426
              ],
              [
                46.011399,
                35.83751
              ],
              [
                46.012173,
                35.837602
              ],
              [
                46.012829,
                35.837806
              ],
              [
                46.013305,
                35.838002
              ],
              [
                46.013906,
                35.837934
              ],
              [
                46.014174,
                35.838056
              ],
              [
                46.014308,
                35.838211
              ],
              [
                46.014458,
                35.838445
              ],
              [
                46.015064,
                35.838586
              ],
              [
                46.015849,
                35.838607
              ],
              [
                46.01624,
                35.838454
              ],
              [
                46.016423,
                35.838029
              ],
              [
                46.016429,
                35.837748
              ],
              [
                46.016555,
                35.837426
              ],
              [
                46.01691,
                35.83722
              ],
              [
                46.017462,
                35.836658
              ],
              [
                46.017801,
                35.836314
              ],
              [
                46.018256,
                35.836035
              ],
              [
                46.018698,
                35.836003
              ],
              [
                46.019159,
                35.836189
              ],
              [
                46.019691,
                35.836412
              ],
              [
                46.020152,
                35.836412
              ],
              [
                46.020747,
                35.836065
              ],
              [
                46.021257,
                35.835742
              ],
              [
                46.021835,
                35.835374
              ],
              [
                46.022588,
                35.835108
              ],
              [
                46.02312,
                35.834957
              ],
              [
                46.023886,
                35.834817
              ],
              [
                46.024303,
                35.834602
              ],
              [
                46.024647,
                35.834468
              ],
              [
                46.024842,
                35.834671
              ],
              [
                46.024967,
                35.834967
              ],
              [
                46.024986,
                35.835373
              ],
              [
                46.024723,
                35.835716
              ],
              [
                46.024624,
                35.836046
              ],
              [
                46.024598,
                35.836424
              ],
              [
                46.024798,
                35.83665
              ],
              [
                46.025128,
                35.83695
              ],
              [
                46.025512,
                35.837137
              ],
              [
                46.026001,
                35.837459
              ],
              [
                46.027397,
                35.8379
              ],
              [
                46.02801,
                35.838017
              ],
              [
                46.028662,
                35.838011
              ],
              [
                46.029285,
                35.838114
              ],
              [
                46.029735,
                35.838373
              ],
              [
                46.030072,
                35.838707
              ],
              [
                46.030704,
                35.838727
              ],
              [
                46.031259,
                35.838561
              ],
              [
                46.031728,
                35.83835
              ],
              [
                46.03222,
                35.838251
              ],
              [
                46.032615,
                35.838366
              ],
              [
                46.032801,
                35.838653
              ],
              [
                46.033078,
                35.839066
              ],
              [
                46.033679,
                35.839313
              ],
              [
                46.034029,
                35.839586
              ],
              [
                46.034398,
                35.83995
              ],
              [
                46.034936,
                35.840324
              ],
              [
                46.035648,
                35.84074
              ],
              [
                46.036218,
                35.840957
              ],
              [
                46.036806,
                35.841078
              ],
              [
                46.037227,
                35.841259
              ],
              [
                46.037738,
                35.841566
              ],
              [
                46.038161,
                35.841945
              ],
              [
                46.038457,
                35.84239
              ],
              [
                46.038632,
                35.842994
              ],
              [
                46.039008,
                35.843392
              ],
              [
                46.039362,
                35.843688
              ],
              [
                46.039713,
                35.843961
              ],
              [
                46.039927,
                35.844197
              ],
              [
                46.040152,
                35.844793
              ],
              [
                46.04041,
                35.845057
              ],
              [
                46.041348,
                35.845008
              ],
              [
                46.041948,
                35.845185
              ],
              [
                46.042342,
                35.845358
              ],
              [
                46.042814,
                35.845286
              ],
              [
                46.043134,
                35.845098
              ],
              [
                46.043747,
                35.8449
              ],
              [
                46.044261,
                35.844973
              ],
              [
                46.04462,
                35.845163
              ],
              [
                46.044984,
                35.845505
              ],
              [
                46.045488,
                35.845778
              ],
              [
                46.045678,
                35.846018
              ],
              [
                46.045659,
                35.846301
              ],
              [
                46.045511,
                35.84658
              ],
              [
                46.045695,
                35.847042
              ],
              [
                46.045966,
                35.847363
              ],
              [
                46.04623,
                35.847906
              ],
              [
                46.046341,
                35.848262
              ],
              [
                46.046829,
                35.848643
              ],
              [
                46.047053,
                35.849111
              ],
              [
                46.047113,
                35.849405
              ],
              [
                46.047141,
                35.849856
              ],
              [
                46.047253,
                35.849967
              ],
              [
                46.047738,
                35.85008
              ],
              [
                46.048101,
                35.850422
              ],
              [
                46.048535,
                35.850787
              ],
              [
                46.048767,
                35.850985
              ],
              [
                46.049223,
                35.851336
              ],
              [
                46.049545,
                35.851532
              ],
              [
                46.050039,
                35.851787
              ],
              [
                46.050566,
                35.852111
              ],
              [
                46.050832,
                35.852457
              ],
              [
                46.051097,
                35.852764
              ],
              [
                46.0516,
                35.853088
              ],
              [
                46.051863,
                35.85324
              ],
              [
                46.052292,
                35.853353
              ],
              [
                46.052938,
                35.853695
              ],
              [
                46.053396,
                35.854194
              ],
              [
                46.054018,
                35.854498
              ],
              [
                46.054658,
                35.854745
              ],
              [
                46.055328,
                35.854815
              ],
              [
                46.055805,
                35.854965
              ],
              [
                46.056173,
                35.855203
              ],
              [
                46.056849,
                35.855439
              ],
              [
                46.057487,
                35.85568
              ],
              [
                46.058257,
                35.855936
              ],
              [
                46.059,
                35.85594
              ],
              [
                46.059484,
                35.856112
              ],
              [
                46.059785,
                35.856206
              ],
              [
                46.060317,
                35.856241
              ],
              [
                46.061349,
                35.856154
              ],
              [
                46.062358,
                35.856141
              ],
              [
                46.063296,
                35.855777
              ],
              [
                46.063723,
                35.855735
              ],
              [
                46.064062,
                35.855893
              ],
              [
                46.06441,
                35.856027
              ],
              [
                46.065313,
                35.856123
              ],
              [
                46.065886,
                35.856421
              ],
              [
                46.066273,
                35.856747
              ],
              [
                46.066533,
                35.856894
              ],
              [
                46.066865,
                35.856949
              ],
              [
                46.067599,
                35.857094
              ],
              [
                46.068247,
                35.857135
              ],
              [
                46.068782,
                35.857369
              ],
              [
                46.069074,
                35.857546
              ],
              [
                46.069664,
                35.857363
              ],
              [
                46.070034,
                35.857354
              ],
              [
                46.070367,
                35.857291
              ],
              [
                46.071297,
                35.857266
              ],
              [
                46.07173,
                35.857317
              ],
              [
                46.072521,
                35.85743
              ],
              [
                46.07302,
                35.857553
              ],
              [
                46.073752,
                35.857815
              ],
              [
                46.074674,
                35.858001
              ],
              [
                46.075732,
                35.858039
              ],
              [
                46.076759,
                35.858116
              ],
              [
                46.077444,
                35.85821
              ],
              [
                46.078196,
                35.858376
              ],
              [
                46.078562,
                35.85843
              ],
              [
                46.078898,
                35.858427
              ],
              [
                46.079274,
                35.85827
              ],
              [
                46.079449,
                35.858274
              ],
              [
                46.079596,
                35.858244
              ],
              [
                46.079714,
                35.85826
              ],
              [
                46.079716,
                35.85826
              ],
              [
                46.079846,
                35.858088
              ],
              [
                46.07997,
                35.857961
              ],
              [
                46.080194,
                35.857937
              ],
              [
                46.08039,
                35.857912
              ],
              [
                46.080543,
                35.857791
              ],
              [
                46.080714,
                35.857561
              ],
              [
                46.080964,
                35.857376
              ],
              [
                46.081172,
                35.857204
              ],
              [
                46.081395,
                35.85711
              ],
              [
                46.0818053,
                35.8566511
              ],
              [
                46.0821591,
                35.8563228
              ],
              [
                46.0823649,
                35.8561438
              ],
              [
                46.0828197,
                35.8563592
              ],
              [
                46.0832251,
                35.8564524
              ],
              [
                46.0836482,
                35.8567094
              ],
              [
                46.0838771,
                35.8570368
              ],
              [
                46.08435,
                35.8571928
              ],
              [
                46.08479,
                35.857485
              ],
              [
                46.085068,
                35.857339
              ],
              [
                46.085307,
                35.857366
              ],
              [
                46.085742,
                35.857402
              ],
              [
                46.086448,
                35.857276
              ],
              [
                46.087009,
                35.857333
              ],
              [
                46.087487,
                35.857506
              ],
              [
                46.088007,
                35.857575
              ],
              [
                46.088497,
                35.857594
              ],
              [
                46.088831,
                35.857748
              ],
              [
                46.089078,
                35.857673
              ],
              [
                46.089262,
                35.857641
              ],
              [
                46.08951,
                35.857656
              ],
              [
                46.089817,
                35.857718
              ],
              [
                46.089933,
                35.857725
              ],
              [
                46.090129,
                35.857788
              ],
              [
                46.090241,
                35.857856
              ],
              [
                46.090552,
                35.85784
              ],
              [
                46.090799,
                35.85779
              ],
              [
                46.091051,
                35.857758
              ],
              [
                46.091524,
                35.857638
              ],
              [
                46.091685,
                35.857614
              ],
              [
                46.092176,
                35.857566
              ],
              [
                46.092614,
                35.857486
              ],
              [
                46.092919,
                35.857351
              ],
              [
                46.093279,
                35.857067
              ],
              [
                46.093439,
                35.856784
              ],
              [
                46.093598,
                35.856427
              ],
              [
                46.093885,
                35.856128
              ],
              [
                46.094298,
                35.855739
              ],
              [
                46.094675,
                35.85535
              ],
              [
                46.095018,
                35.855154
              ],
              [
                46.095415,
                35.854899
              ],
              [
                46.095924,
                35.854616
              ],
              [
                46.095962,
                35.854569
              ],
              [
                46.096007,
                35.854362
              ],
              [
                46.096068,
                35.854268
              ],
              [
                46.096124,
                35.854213
              ],
              [
                46.096323,
                35.854117
              ],
              [
                46.096567,
                35.853985
              ],
              [
                46.096952,
                35.853738
              ],
              [
                46.097365,
                35.853269
              ],
              [
                46.097689,
                35.853034
              ],
              [
                46.098201,
                35.852767
              ],
              [
                46.098798,
                35.852544
              ],
              [
                46.099051,
                35.85243
              ],
              [
                46.099217,
                35.852269
              ],
              [
                46.099452,
                35.852074
              ],
              [
                46.099975,
                35.85182
              ],
              [
                46.100183,
                35.851613
              ],
              [
                46.100501,
                35.851178
              ],
              [
                46.100739,
                35.850961
              ],
              [
                46.101139,
                35.850351
              ],
              [
                46.101427,
                35.850068
              ],
              [
                46.101448,
                35.849703
              ],
              [
                46.101723,
                35.849417
              ],
              [
                46.101549,
                35.849099
              ],
              [
                46.101546,
                35.848737
              ],
              [
                46.101746,
                35.848462
              ],
              [
                46.102389,
                35.848417
              ],
              [
                46.102722,
                35.848448
              ],
              [
                46.103246,
                35.848502
              ],
              [
                46.104049,
                35.848392
              ],
              [
                46.104853,
                35.848158
              ],
              [
                46.10558,
                35.848048
              ],
              [
                46.106161,
                35.848415
              ],
              [
                46.106666,
                35.848723
              ],
              [
                46.107183,
                35.848714
              ],
              [
                46.108346,
                35.847767
              ],
              [
                46.109109,
                35.847237
              ],
              [
                46.109671,
                35.84676
              ],
              [
                46.110422,
                35.846769
              ],
              [
                46.110881,
                35.846728
              ],
              [
                46.111555,
                35.846579
              ],
              [
                46.112301,
                35.846372
              ],
              [
                46.112812,
                35.846306
              ],
              [
                46.113226,
                35.846231
              ],
              [
                46.113455,
                35.84591
              ],
              [
                46.114161,
                35.845855
              ],
              [
                46.114657,
                35.845681
              ],
              [
                46.115205,
                35.845574
              ],
              [
                46.115853,
                35.845551
              ],
              [
                46.116605,
                35.845594
              ],
              [
                46.117121,
                35.845673
              ],
              [
                46.117824,
                35.845765
              ],
              [
                46.11838,
                35.845698
              ],
              [
                46.118986,
                35.84581
              ],
              [
                46.119633,
                35.845997
              ],
              [
                46.120385,
                35.846011
              ],
              [
                46.120765,
                35.845994
              ],
              [
                46.121243,
                35.845857
              ],
              [
                46.121742,
                35.845694
              ],
              [
                46.122291,
                35.845185
              ],
              [
                46.123007,
                35.84521
              ],
              [
                46.123421,
                35.845199
              ],
              [
                46.123775,
                35.845303
              ],
              [
                46.124224,
                35.84534
              ],
              [
                46.124824,
                35.845108
              ],
              [
                46.125209,
                35.844927
              ],
              [
                46.125625,
                35.844578
              ],
              [
                46.126522,
                35.844301
              ],
              [
                46.127031,
                35.843909
              ],
              [
                46.127749,
                35.843753
              ],
              [
                46.128531,
                35.843319
              ],
              [
                46.129369,
                35.843191
              ],
              [
                46.129877,
                35.843138
              ],
              [
                46.130455,
                35.843242
              ],
              [
                46.131138,
                35.843512
              ],
              [
                46.1325,
                35.843503
              ],
              [
                46.133168,
                35.843483
              ],
              [
                46.134037,
                35.843473
              ],
              [
                46.13472,
                35.843398
              ],
              [
                46.135796,
                35.84334
              ],
              [
                46.1209266,
                35.8606356
              ],
              [
                46.127723,
                35.8825217
              ],
              [
                46.1467439,
                35.9175062
              ],
              [
                46.157073,
                35.9366389
              ],
              [
                46.1664083,
                35.9586059
              ],
              [
                46.1714171,
                35.9699488
              ],
              [
                46.1734319,
                35.9856712
              ],
              [
                46.1782557,
                36.01081
              ],
              [
                46.1078905,
                36.0193928
              ],
              [
                46.0866984,
                36.017678
              ],
              [
                46.0776686,
                36.0172631
              ],
              [
                46.0238926,
                36.0125091
              ],
              [
                46.023011,
                36.0187585
              ],
              [
                46.0215648,
                36.0255315
              ],
              [
                46.0195049,
                36.0353231
              ],
              [
                46.0166476,
                36.0479616
              ],
              [
                46.0137127,
                36.0608643
              ],
              [
                46.0001906,
                36.0631014
              ],
              [
                45.9849823,
                36.0666518
              ],
              [
                45.9551612,
                36.0728394
              ],
              [
                45.9317771,
                36.0861567
              ],
              [
                45.91774,
                36.0946907
              ],
              [
                45.8973796,
                36.1067111
              ],
              [
                45.8510183,
                36.1344172
              ],
              [
                45.847578,
                36.1364884
              ],
              [
                45.8469772,
                36.13836
              ],
              [
                45.8474063,
                36.1395037
              ],
              [
                45.8463764,
                36.1406474
              ],
              [
                45.8453893,
                36.1428308
              ],
              [
                45.8457326,
                36.1447368
              ],
              [
                45.845046,
                36.145222
              ],
              [
                45.8501945,
                36.1958325
              ],
              [
                45.8381156,
                36.195407
              ],
              [
                45.8261438,
                36.1949364
              ],
              [
                45.8234167,
                36.1949617
              ],
              [
                45.811141,
                36.194788
              ],
              [
                45.7922373,
                36.1945398
              ],
              [
                45.7792843,
                36.1943675
              ],
              [
                45.7680276,
                36.1942525
              ],
              [
                45.7665739,
                36.1948144
              ],
              [
                45.7487693,
                36.1995873
              ],
              [
                45.7438775,
                36.1986664
              ],
              [
                45.7381998,
                36.2003359
              ],
              [
                45.7348414,
                36.2013748
              ],
              [
                45.7135445,
                36.2075346
              ],
              [
                45.7089219,
                36.2078557
              ],
              [
                45.7066011,
                36.2081998
              ],
              [
                45.7040262,
                36.2078535
              ],
              [
                45.6999492,
                36.2060529
              ],
              [
                45.6982112,
                36.2048322
              ],
              [
                45.6972146,
                36.2045459
              ],
              [
                45.6949944,
                36.2023647
              ],
              [
                45.6914305,
                36.1995771
              ],
              [
                45.6903362,
                36.1978456
              ],
              [
                45.6896494,
                36.195837
              ],
              [
                45.6895852,
                36.1941399
              ],
              [
                45.6898856,
                36.1923562
              ],
              [
                45.6909798,
                36.1886157
              ],
              [
                45.7016517,
                36.1787456
              ],
              [
                45.6977893,
                36.176442
              ],
              [
                45.6912719,
                36.1744202
              ],
              [
                45.6814077,
                36.17137
              ],
              [
                45.6781709,
                36.1705366
              ],
              [
                45.6705093,
                36.168784
              ],
              [
                45.6639976,
                36.1652472
              ],
              [
                45.6586506,
                36.1593008
              ],
              [
                45.6581068,
                36.1582859
              ],
              [
                45.655119,
                36.1545163
              ],
              [
                45.6542015,
                36.1528804
              ],
              [
                45.6533923,
                36.1509283
              ],
              [
                45.6529599,
                36.1488409
              ],
              [
                45.6516695,
                36.1384986
              ],
              [
                45.6500882,
                36.1301873
              ],
              [
                45.6496095,
                36.1258127
              ],
              [
                45.6505107,
                36.120197
              ],
              [
                45.6542014,
                36.1132634
              ],
              [
                45.6553387,
                36.1108192
              ],
              [
                45.6560683,
                36.1084269
              ],
              [
                45.656476,
                36.1061385
              ],
              [
                45.6563902,
                36.1039888
              ],
              [
                45.6545877,
                36.1011282
              ],
              [
                45.6516266,
                36.099013
              ],
              [
                45.6480002,
                36.09747
              ],
              [
                45.6448972,
                36.0954111
              ],
              [
                45.6427002,
                36.0937075
              ],
              [
                45.639739,
                36.0907251
              ],
              [
                45.6287096,
                36.0837891
              ],
              [
                45.6259632,
                36.0826098
              ],
              [
                45.6208992,
                36.0823323
              ],
              [
                45.6191396,
                36.0827832
              ],
              [
                45.617423,
                36.0826098
              ],
              [
                45.6152935,
                36.0834225
              ],
              [
                45.6089294,
                36.0842202
              ],
              [
                45.6009882,
                36.0863679
              ],
              [
                45.5967378,
                36.087812
              ],
              [
                45.591448,
                36.0887951
              ],
              [
                45.590043,
                36.0884016
              ],
              [
                45.5895845,
                36.0876506
              ],
              [
                45.5896568,
                36.0836502
              ],
              [
                45.5888846,
                36.0796674
              ],
              [
                45.5877685,
                36.0781702
              ],
              [
                45.5856227,
                36.077095
              ],
              [
                45.5807304,
                36.0762972
              ],
              [
                45.5752372,
                36.0760198
              ],
              [
                45.5716753,
                36.0747017
              ],
              [
                45.569229,
                36.0721349
              ],
              [
                45.5675554,
                36.0688048
              ],
              [
                45.5670833,
                36.0651971
              ],
              [
                45.5671267,
                36.0638128
              ],
              [
                45.567255,
                36.0597157
              ],
              [
                45.568639,
                36.054156
              ],
              [
                45.5697343,
                36.0524425
              ],
              [
                45.5745075,
                36.050244
              ],
              [
                45.5787992,
                36.0490643
              ],
              [
                45.5836911,
                36.0459493
              ],
              [
                45.5870575,
                36.043935
              ],
              [
                45.5879349,
                36.0419883
              ],
              [
                45.5861326,
                36.039145
              ],
              [
                45.5817114,
                36.0331631
              ],
              [
                45.572375,
                36.0235879
              ],
              [
                45.568199,
                36.0185593
              ],
              [
                45.5576542,
                36.0127509
              ],
              [
                45.5582105,
                36.0069199
              ],
              [
                45.5584871,
                36.004694
              ],
              [
                45.5587676,
                36.0044146
              ],
              [
                45.5584872,
                35.9999714
              ],
              [
                45.557841,
                35.9950418
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554955,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بیجار",
          "name:en": "Bijar County",
          "name:ku": "Bîcar (şaristan)",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282103",
          "wikipedia": "en:Bijar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.083322,
                36.2679466
              ],
              [
                47.080965,
                36.2519566
              ],
              [
                47.0825424,
                36.2482815
              ],
              [
                47.0895549,
                36.244472
              ],
              [
                47.0914149,
                36.242864
              ],
              [
                47.105603,
                36.2373045
              ],
              [
                47.1147822,
                36.2359661
              ],
              [
                47.1231958,
                36.2354306
              ],
              [
                47.1304667,
                36.2328691
              ],
              [
                47.13212,
                36.2311891
              ],
              [
                47.1422481,
                36.2292505
              ],
              [
                47.1489429,
                36.2275195
              ],
              [
                47.1563243,
                36.2253039
              ],
              [
                47.1592425,
                36.2223266
              ],
              [
                47.1644782,
                36.2200415
              ],
              [
                47.1731471,
                36.2177564
              ],
              [
                47.1764274,
                36.2151852
              ],
              [
                47.1782111,
                36.2104852
              ],
              [
                47.1815585,
                36.2065377
              ],
              [
                47.1943222,
                36.1910115
              ],
              [
                47.2009833,
                36.1862989
              ],
              [
                47.2091984,
                36.1826966
              ],
              [
                47.2195688,
                36.1781073
              ],
              [
                47.2235123,
                36.1757658
              ],
              [
                47.2296456,
                36.170702
              ],
              [
                47.2348833,
                36.1655741
              ],
              [
                47.246549,
                36.1587883
              ],
              [
                47.2511172,
                36.1569606
              ],
              [
                47.2577976,
                36.1534888
              ],
              [
                47.2621235,
                36.1504192
              ],
              [
                47.2987476,
                36.1342714
              ],
              [
                47.3325528,
                36.1242803
              ],
              [
                47.3442869,
                36.1218537
              ],
              [
                47.3635363,
                36.1147648
              ],
              [
                47.3930833,
                36.1124045
              ],
              [
                47.4088472,
                36.1084667
              ],
              [
                47.4205305,
                36.105049
              ],
              [
                47.4357898,
                36.1029642
              ],
              [
                47.4433984,
                36.1019247
              ],
              [
                47.4468341,
                36.0948399
              ],
              [
                47.4500369,
                36.0884363
              ],
              [
                47.4525098,
                36.0820745
              ],
              [
                47.4558573,
                36.063964
              ],
              [
                47.4627023,
                36.0484624
              ],
              [
                47.4610844,
                36.0480992
              ],
              [
                47.4538135,
                36.0435819
              ],
              [
                47.4457883,
                36.039036
              ],
              [
                47.4294133,
                36.0301187
              ],
              [
                47.4131565,
                36.0199707
              ],
              [
                47.3895234,
                36.0041386
              ],
              [
                47.3821787,
                35.9993519
              ],
              [
                47.3738557,
                35.9941439
              ],
              [
                47.3687726,
                35.990045
              ],
              [
                47.3596801,
                35.9848363
              ],
              [
                47.3379143,
                35.9749763
              ],
              [
                47.3091145,
                35.9716464
              ],
              [
                47.2990013,
                35.9679657
              ],
              [
                47.2890793,
                35.9627579
              ],
              [
                47.2968629,
                35.9317918
              ],
              [
                47.2985843,
                35.9247708
              ],
              [
                47.30262,
                35.9089015
              ],
              [
                47.2925174,
                35.9019852
              ],
              [
                47.2669004,
                35.8850949
              ],
              [
                47.2598394,
                35.878987
              ],
              [
                47.2538997,
                35.8737709
              ],
              [
                47.2518415,
                35.8740119
              ],
              [
                47.2489725,
                35.873073
              ],
              [
                47.227882,
                35.8707419
              ],
              [
                47.2232102,
                35.8713
              ],
              [
                47.2091122,
                35.8692385
              ],
              [
                47.195827,
                35.8672255
              ],
              [
                47.1949998,
                35.8491425
              ],
              [
                47.1941669,
                35.83531
              ],
              [
                47.1937505,
                35.8172652
              ],
              [
                47.1716734,
                35.8110854
              ],
              [
                47.1552498,
                35.804755
              ],
              [
                47.1319484,
                35.7969309
              ],
              [
                47.1242103,
                35.7857392
              ],
              [
                47.1299951,
                35.7777621
              ],
              [
                47.1367733,
                35.7673897
              ],
              [
                47.1447866,
                35.7495432
              ],
              [
                47.1491362,
                35.7489817
              ],
              [
                47.154951,
                35.7466517
              ],
              [
                47.1647373,
                35.7392752
              ],
              [
                47.1818319,
                35.7283771
              ],
              [
                47.1996956,
                35.7173007
              ],
              [
                47.1906566,
                35.7083289
              ],
              [
                47.1865957,
                35.7024202
              ],
              [
                47.1815069,
                35.6963092
              ],
              [
                47.1701217,
                35.6867875
              ],
              [
                47.1572864,
                35.6814576
              ],
              [
                47.1450469,
                35.673734
              ],
              [
                47.1561526,
                35.6611319
              ],
              [
                47.1765803,
                35.6559713
              ],
              [
                47.1979951,
                35.6520309
              ],
              [
                47.226824,
                35.6507129
              ],
              [
                47.2448912,
                35.648836
              ],
              [
                47.2680883,
                35.6534353
              ],
              [
                47.2909171,
                35.6561769
              ],
              [
                47.299387,
                35.6546531
              ],
              [
                47.3055012,
                35.653998
              ],
              [
                47.3118807,
                35.6527935
              ],
              [
                47.3240672,
                35.6386909
              ],
              [
                47.3332475,
                35.6337512
              ],
              [
                47.3518122,
                35.632624
              ],
              [
                47.3702729,
                35.6313148
              ],
              [
                47.3784959,
                35.6308495
              ],
              [
                47.383518,
                35.630547
              ],
              [
                47.3912934,
                35.6299558
              ],
              [
                47.3898382,
                35.6246102
              ],
              [
                47.3888606,
                35.6197133
              ],
              [
                47.3863327,
                35.6102233
              ],
              [
                47.3834152,
                35.599701
              ],
              [
                47.3798736,
                35.586687
              ],
              [
                47.4121589,
                35.5852311
              ],
              [
                47.4451558,
                35.5838477
              ],
              [
                47.4674828,
                35.5829259
              ],
              [
                47.4843573,
                35.5748153
              ],
              [
                47.4990766,
                35.5681605
              ],
              [
                47.5033614,
                35.5667854
              ],
              [
                47.5073469,
                35.5648156
              ],
              [
                47.5106616,
                35.5570735
              ],
              [
                47.5113139,
                35.5546756
              ],
              [
                47.5144921,
                35.5403402
              ],
              [
                47.5189589,
                35.5199322
              ],
              [
                47.5341311,
                35.5075412
              ],
              [
                47.547283,
                35.5005091
              ],
              [
                47.5527763,
                35.4951284
              ],
              [
                47.5566742,
                35.4804275
              ],
              [
                47.5573682,
                35.4815704
              ],
              [
                47.5869387,
                35.4761545
              ],
              [
                47.5998228,
                35.473692
              ],
              [
                47.613721,
                35.4711023
              ],
              [
                47.6271827,
                35.4685203
              ],
              [
                47.6403453,
                35.4661182
              ],
              [
                47.6669112,
                35.4606533
              ],
              [
                47.7214641,
                35.4746987
              ],
              [
                47.747427,
                35.5063217
              ],
              [
                47.7280888,
                35.5456641
              ],
              [
                47.7236845,
                35.5545452
              ],
              [
                47.725755,
                35.5594829
              ],
              [
                47.7323243,
                35.5723355
              ],
              [
                47.7348905,
                35.5829494
              ],
              [
                47.743012,
                35.5826918
              ],
              [
                47.754695,
                35.578979
              ],
              [
                47.7624738,
                35.5779524
              ],
              [
                47.7700263,
                35.5773045
              ],
              [
                47.7781319,
                35.5771031
              ],
              [
                47.795552,
                35.5762229
              ],
              [
                47.8105292,
                35.5754145
              ],
              [
                47.8275142,
                35.5748944
              ],
              [
                47.8369893,
                35.5734734
              ],
              [
                47.8523763,
                35.5719486
              ],
              [
                47.8591186,
                35.5708818
              ],
              [
                47.8687553,
                35.5693421
              ],
              [
                47.8851708,
                35.5661705
              ],
              [
                47.8880482,
                35.5722231
              ],
              [
                47.8938596,
                35.5775297
              ],
              [
                47.9036017,
                35.5799649
              ],
              [
                47.9490412,
                35.5867208
              ],
              [
                47.9532077,
                35.5869913
              ],
              [
                47.9537612,
                35.5872707
              ],
              [
                47.9554277,
                35.5872707
              ],
              [
                47.976264,
                35.5953297
              ],
              [
                47.9794081,
                35.6122227
              ],
              [
                47.9869399,
                35.6271019
              ],
              [
                47.9864504,
                35.6351744
              ],
              [
                48.0064066,
                35.6435558
              ],
              [
                48.0303077,
                35.6485706
              ],
              [
                48.0438242,
                35.6513603
              ],
              [
                48.0456963,
                35.652243
              ],
              [
                48.0490296,
                35.652793
              ],
              [
                48.0643514,
                35.6522853
              ],
              [
                48.085184,
                35.6462768
              ],
              [
                48.09732,
                35.6444182
              ],
              [
                48.1008052,
                35.6475323
              ],
              [
                48.106665,
                35.6510625
              ],
              [
                48.1217479,
                35.6597371
              ],
              [
                48.1355292,
                35.6681734
              ],
              [
                48.173654,
                35.6701644
              ],
              [
                48.175298,
                35.6694665
              ],
              [
                48.1839975,
                35.6728606
              ],
              [
                48.1965552,
                35.6765947
              ],
              [
                48.2096005,
                35.679811
              ],
              [
                48.2195404,
                35.6838154
              ],
              [
                48.2293555,
                35.6867601
              ],
              [
                48.2419109,
                35.6918793
              ],
              [
                48.2406663,
                35.6934826
              ],
              [
                48.2576416,
                35.6943377
              ],
              [
                48.2649998,
                35.696915
              ],
              [
                48.2706979,
                35.6960481
              ],
              [
                48.2772784,
                35.6931287
              ],
              [
                48.2826376,
                35.6918096
              ],
              [
                48.2858379,
                35.6894397
              ],
              [
                48.2901766,
                35.6861535
              ],
              [
                48.2817249,
                35.695222
              ],
              [
                48.2799138,
                35.6969894
              ],
              [
                48.2779578,
                35.6990005
              ],
              [
                48.2704315,
                35.707128
              ],
              [
                48.2524032,
                35.7196275
              ],
              [
                48.249434,
                35.723168
              ],
              [
                48.2415847,
                35.725919
              ],
              [
                48.2350039,
                35.7283075
              ],
              [
                48.2280604,
                35.7299535
              ],
              [
                48.220004,
                35.7305252
              ],
              [
                48.2100006,
                35.7294262
              ],
              [
                48.2012943,
                35.7292838
              ],
              [
                48.1911277,
                35.7372279
              ],
              [
                48.1850644,
                35.7441817
              ],
              [
                48.1604523,
                35.7663192
              ],
              [
                48.1465344,
                35.779117
              ],
              [
                48.1417255,
                35.7821427
              ],
              [
                48.1325648,
                35.7887638
              ],
              [
                48.1147119,
                35.7988264
              ],
              [
                48.100518,
                35.8062978
              ],
              [
                48.0917,
                35.8132946
              ],
              [
                48.0787466,
                35.8126628
              ],
              [
                48.0732267,
                35.8141399
              ],
              [
                48.0450991,
                35.8136412
              ],
              [
                48.0384911,
                35.8264395
              ],
              [
                48.0348974,
                35.833974
              ],
              [
                48.0313825,
                35.8387804
              ],
              [
                48.027939,
                35.8489995
              ],
              [
                48.0246578,
                35.8640675
              ],
              [
                48.0226296,
                35.8741134
              ],
              [
                48.0173567,
                35.8888396
              ],
              [
                48.0139401,
                35.8992142
              ],
              [
                48.0101385,
                35.9113748
              ],
              [
                48.0065729,
                35.9226428
              ],
              [
                48.0021391,
                35.9302797
              ],
              [
                47.9943839,
                35.9305875
              ],
              [
                47.9881538,
                35.9313978
              ],
              [
                47.9740332,
                35.9243667
              ],
              [
                47.9507819,
                35.9083679
              ],
              [
                47.9422535,
                35.9021973
              ],
              [
                47.9300876,
                35.8932206
              ],
              [
                47.913491,
                35.8838841
              ],
              [
                47.9059304,
                35.881636
              ],
              [
                47.9013347,
                35.8830003
              ],
              [
                47.8955133,
                35.8796541
              ],
              [
                47.8892937,
                35.887184
              ],
              [
                47.8835701,
                35.89367
              ],
              [
                47.870693,
                35.9076837
              ],
              [
                47.8664121,
                35.9127809
              ],
              [
                47.8543852,
                35.9282588
              ],
              [
                47.8666387,
                35.9322449
              ],
              [
                47.8677327,
                35.9391239
              ],
              [
                47.8780035,
                35.9420623
              ],
              [
                47.8881283,
                35.9453899
              ],
              [
                47.8939034,
                35.9483138
              ],
              [
                47.9141534,
                35.9544193
              ],
              [
                47.9144334,
                35.9546987
              ],
              [
                47.9158203,
                35.9546988
              ],
              [
                47.9160999,
                35.9549782
              ],
              [
                47.9177667,
                35.9549781
              ],
              [
                47.9199902,
                35.9555369
              ],
              [
                47.9213766,
                35.955537
              ],
              [
                47.9249899,
                35.9558073
              ],
              [
                47.9258232,
                35.9560867
              ],
              [
                47.9266567,
                35.9558073
              ],
              [
                47.9274899,
                35.9560867
              ],
              [
                47.9310999,
                35.9560868
              ],
              [
                47.9316566,
                35.9563661
              ],
              [
                47.9341566,
                35.9563662
              ],
              [
                47.9344331,
                35.9566456
              ],
              [
                47.9352663,
                35.9566456
              ],
              [
                47.9358234,
                35.956925
              ],
              [
                47.9369331,
                35.956925
              ],
              [
                47.9380464,
                35.9574747
              ],
              [
                47.9391566,
                35.9574747
              ],
              [
                47.9574895,
                35.963306
              ],
              [
                47.9620169,
                35.9648082
              ],
              [
                47.9719327,
                35.9706714
              ],
              [
                47.9736897,
                35.9796735
              ],
              [
                47.9720915,
                35.983315
              ],
              [
                47.9663085,
                35.9879381
              ],
              [
                47.9544829,
                35.9938686
              ],
              [
                47.9474698,
                35.9963685
              ],
              [
                47.9263982,
                35.9978261
              ],
              [
                47.902193,
                35.9968965
              ],
              [
                47.8922366,
                35.9953688
              ],
              [
                47.8851985,
                35.9948827
              ],
              [
                47.8772163,
                35.9966188
              ],
              [
                47.8715943,
                35.9981812
              ],
              [
                47.8737635,
                36.0015048
              ],
              [
                47.8780669,
                36.0069949
              ],
              [
                47.8826236,
                36.015088
              ],
              [
                47.8885459,
                36.0211278
              ],
              [
                47.9013347,
                36.0313318
              ],
              [
                47.9072921,
                36.0339977
              ],
              [
                47.9146233,
                36.0330238
              ],
              [
                47.9215048,
                36.032026
              ],
              [
                47.9313831,
                36.0331749
              ],
              [
                47.936611,
                36.0348024
              ],
              [
                47.9431341,
                36.0389667
              ],
              [
                47.9455727,
                36.0405353
              ],
              [
                47.9503546,
                36.0453968
              ],
              [
                47.9534911,
                36.0483259
              ],
              [
                47.961116,
                36.0606759
              ],
              [
                47.9640768,
                36.0674173
              ],
              [
                47.956309,
                36.0775809
              ],
              [
                47.9479837,
                36.0795229
              ],
              [
                47.9404306,
                36.0803553
              ],
              [
                47.937299,
                36.0815716
              ],
              [
                47.9318918,
                36.082269
              ],
              [
                47.9409079,
                36.0904008
              ],
              [
                47.9445129,
                36.093172
              ],
              [
                47.9507105,
                36.0985882
              ],
              [
                47.9585749,
                36.1055342
              ],
              [
                47.9715439,
                36.1171465
              ],
              [
                47.9845046,
                36.1275459
              ],
              [
                48.0033052,
                36.148272
              ],
              [
                47.9769353,
                36.1638705
              ],
              [
                47.976102,
                36.1658168
              ],
              [
                47.9761021,
                36.1663755
              ],
              [
                47.9758255,
                36.1666458
              ],
              [
                47.9752688,
                36.1683128
              ],
              [
                47.9749887,
                36.169421
              ],
              [
                47.9747122,
                36.171097
              ],
              [
                47.9744352,
                36.1738723
              ],
              [
                47.9744352,
                36.1760979
              ],
              [
                47.9744352,
                36.1791525
              ],
              [
                47.9738785,
                36.1816485
              ],
              [
                47.9738785,
                36.1852616
              ],
              [
                47.9736019,
                36.1855409
              ],
              [
                47.9733218,
                36.1885955
              ],
              [
                47.9821519,
                36.1980384
              ],
              [
                47.9760418,
                36.2069315
              ],
              [
                47.9424357,
                36.2127732
              ],
              [
                47.9455457,
                36.2485939
              ],
              [
                47.9416553,
                36.2569279
              ],
              [
                47.9416552,
                36.2610994
              ],
              [
                47.9419323,
                36.2635951
              ],
              [
                47.9422119,
                36.2649825
              ],
              [
                47.9430455,
                36.2660997
              ],
              [
                47.943322,
                36.2666493
              ],
              [
                47.9458221,
                36.2685954
              ],
              [
                47.9544317,
                36.2735957
              ],
              [
                47.956102,
                36.2755418
              ],
              [
                47.9563786,
                36.2813709
              ],
              [
                47.956102,
                36.2816503
              ],
              [
                47.9413786,
                36.3102638
              ],
              [
                47.9410984,
                36.310543
              ],
              [
                47.9385987,
                36.31248
              ],
              [
                47.9347084,
                36.3147053
              ],
              [
                47.9341553,
                36.3152638
              ],
              [
                47.9202655,
                36.3202638
              ],
              [
                47.9197089,
                36.3202638
              ],
              [
                47.9194323,
                36.3205431
              ],
              [
                47.9185988,
                36.3205431
              ],
              [
                47.8997088,
                36.3308133
              ],
              [
                47.8994323,
                36.3311016
              ],
              [
                47.8985955,
                36.3311017
              ],
              [
                47.8980424,
                36.3313808
              ],
              [
                47.8933192,
                36.3313809
              ],
              [
                47.8927622,
                36.3313809
              ],
              [
                47.8916524,
                36.3316512
              ],
              [
                47.8908192,
                36.3316511
              ],
              [
                47.8885956,
                36.3316512
              ],
              [
                47.8874859,
                36.3313809
              ],
              [
                47.8863758,
                36.3313809
              ],
              [
                47.8849859,
                36.3313809
              ],
              [
                47.8849858,
                36.3311016
              ],
              [
                47.8835959,
                36.3311015
              ],
              [
                47.8758192,
                36.3291556
              ],
              [
                47.8747059,
                36.3291556
              ],
              [
                47.8741528,
                36.3288763
              ],
              [
                47.8708195,
                36.3288763
              ],
              [
                47.8674859,
                36.3294258
              ],
              [
                47.8669293,
                36.3297052
              ],
              [
                47.866096,
                36.3297052
              ],
              [
                47.8483163,
                36.3388762
              ],
              [
                47.8435962,
                36.3399842
              ],
              [
                47.8422064,
                36.3399842
              ],
              [
                47.8410931,
                36.3402635
              ],
              [
                47.8402595,
                36.3402635
              ],
              [
                47.8399829,
                36.3405428
              ],
              [
                47.838593,
                36.3405427
              ],
              [
                47.8383165,
                36.3408221
              ],
              [
                47.8355399,
                36.340822
              ],
              [
                47.8352597,
                36.3411013
              ],
              [
                47.833873,
                36.3411013
              ],
              [
                47.8333164,
                36.3413806
              ],
              [
                47.8322065,
                36.3413806
              ],
              [
                47.8319264,
                36.3416599
              ],
              [
                47.8297064,
                36.3416599
              ],
              [
                47.8283166,
                36.3419301
              ],
              [
                47.8277595,
                36.3422094
              ],
              [
                47.8269264,
                36.3422094
              ],
              [
                47.81665,
                36.3466597
              ],
              [
                47.8155366,
                36.3472092
              ],
              [
                47.80026,
                36.3627671
              ],
              [
                47.7963702,
                36.3655418
              ],
              [
                47.7919267,
                36.3674877
              ],
              [
                47.7877602,
                36.3694335
              ],
              [
                47.7822034,
                36.3719379
              ],
              [
                47.7710903,
                36.3735953
              ],
              [
                47.7685903,
                36.3741539
              ],
              [
                47.7674805,
                36.3741539
              ],
              [
                47.7666472,
                36.3744331
              ],
              [
                47.7652569,
                36.3744331
              ],
              [
                47.7644237,
                36.3747124
              ],
              [
                47.7599803,
                36.3747124
              ],
              [
                47.7533137,
                36.3752619
              ],
              [
                47.7524806,
                36.3755412
              ],
              [
                47.7513671,
                36.3755411
              ],
              [
                47.7505339,
                36.3758204
              ],
              [
                47.7488672,
                36.3758204
              ],
              [
                47.748314,
                36.3760996
              ],
              [
                47.7463671,
                36.3760997
              ],
              [
                47.7283108,
                36.3794328
              ],
              [
                47.726644,
                36.3794328
              ],
              [
                47.7255342,
                36.379712
              ],
              [
                47.724701,
                36.379712
              ],
              [
                47.7241444,
                36.3799913
              ],
              [
                47.7152543,
                36.3799912
              ],
              [
                47.7147007,
                36.3802705
              ],
              [
                47.7141441,
                36.3802705
              ],
              [
                47.7113675,
                36.3802705
              ],
              [
                47.7110877,
                36.3802705
              ],
              [
                47.7099776,
                36.3802705
              ],
              [
                47.709421,
                36.3799913
              ],
              [
                47.7069209,
                36.3799912
              ],
              [
                47.7002543,
                36.3788832
              ],
              [
                47.6991446,
                36.3783246
              ],
              [
                47.6944211,
                36.3777662
              ],
              [
                47.6935878,
                36.3774868
              ],
              [
                47.6769214,
                36.3780363
              ],
              [
                47.6758081,
                36.3783246
              ],
              [
                47.6741413,
                36.3783245
              ],
              [
                47.6710846,
                36.3788831
              ],
              [
                47.6699748,
                36.3788831
              ],
              [
                47.6655314,
                36.3797118
              ],
              [
                47.6596985,
                36.3805406
              ],
              [
                47.6410184,
                36.3910621
              ],
              [
                47.6404652,
                36.3913414
              ],
              [
                47.6393519,
                36.3913414
              ],
              [
                47.6385183,
                36.3916205
              ],
              [
                47.6374085,
                36.3916205
              ],
              [
                47.6212217,
                36.4060346
              ],
              [
                47.6209416,
                36.4063139
              ],
              [
                47.6203885,
                36.4063138
              ],
              [
                47.6195549,
                36.406593
              ],
              [
                47.6192751,
                36.4068722
              ],
              [
                47.5969204,
                36.4305233
              ],
              [
                47.5963672,
                36.4307935
              ],
              [
                47.595534,
                36.4305233
              ],
              [
                47.589144,
                36.4305233
              ],
              [
                47.5479697,
                36.4389613
              ],
              [
                47.5116402,
                36.4146039
              ],
              [
                47.5183364,
                36.3963641
              ],
              [
                47.5183364,
                36.3960848
              ],
              [
                47.5131808,
                36.3911143
              ],
              [
                47.5131549,
                36.3910319
              ],
              [
                47.5253102,
                36.3635224
              ],
              [
                47.4920079,
                36.3360089
              ],
              [
                47.465057,
                36.3187216
              ],
              [
                47.4568176,
                36.3196205
              ],
              [
                47.4460885,
                36.3214188
              ],
              [
                47.4302101,
                36.3235623
              ],
              [
                47.4263476,
                36.324807
              ],
              [
                47.4091815,
                36.3263975
              ],
              [
                47.3973741,
                36.3296076
              ],
              [
                47.3889736,
                36.3290032
              ],
              [
                47.3757934,
                36.3217643
              ],
              [
                47.370766,
                36.3174458
              ],
              [
                47.3658983,
                36.3120193
              ],
              [
                47.3614668,
                36.3058531
              ],
              [
                47.3549153,
                36.2963912
              ],
              [
                47.3472976,
                36.2878023
              ],
              [
                47.3395729,
                36.278185
              ],
              [
                47.3291015,
                36.2687051
              ],
              [
                47.3248099,
                36.2668367
              ],
              [
                47.3117647,
                36.259455
              ],
              [
                47.2933101,
                36.2556942
              ],
              [
                47.2486369,
                36.2520486
              ],
              [
                47.2266196,
                36.2514029
              ],
              [
                47.2112691,
                36.2503705
              ],
              [
                47.1872937,
                36.2502378
              ],
              [
                47.1503798,
                36.2513417
              ],
              [
                47.1310618,
                36.250538
              ],
              [
                47.1160697,
                36.2507799
              ],
              [
                47.1038818,
                36.252095
              ],
              [
                47.0952987,
                36.2558326
              ],
              [
                47.0892905,
                36.2606081
              ],
              [
                47.083322,
                36.2679466
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555026,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دهگلان",
          "name:en": "Dehgolan County",
          "name:ku": "Dehgolan",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2725456",
          "wikipedia": "en:Dehgolan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.1122876,
                35.2148887
              ],
              [
                47.1183145,
                35.2086002
              ],
              [
                47.1250516,
                35.1978603
              ],
              [
                47.1302037,
                35.1864139
              ],
              [
                47.1345159,
                35.1773088
              ],
              [
                47.1361575,
                35.1689395
              ],
              [
                47.1389567,
                35.1619928
              ],
              [
                47.1399309,
                35.1557643
              ],
              [
                47.1408637,
                35.1435273
              ],
              [
                47.1631504,
                35.1417408
              ],
              [
                47.1836481,
                35.1395658
              ],
              [
                47.2040319,
                35.1359409
              ],
              [
                47.2130116,
                35.1336867
              ],
              [
                47.2255922,
                35.1301465
              ],
              [
                47.2406447,
                35.1218578
              ],
              [
                47.2529866,
                35.1158141
              ],
              [
                47.2657118,
                35.1098926
              ],
              [
                47.2792345,
                35.1015976
              ],
              [
                47.2877064,
                35.0973048
              ],
              [
                47.3025796,
                35.0883127
              ],
              [
                47.3113059,
                35.0825641
              ],
              [
                47.3151205,
                35.0799146
              ],
              [
                47.3139733,
                35.0688887
              ],
              [
                47.3125005,
                35.0638629
              ],
              [
                47.3127624,
                35.0627842
              ],
              [
                47.3147667,
                35.0515707
              ],
              [
                47.3161148,
                35.048871
              ],
              [
                47.3161599,
                35.0485213
              ],
              [
                47.3249995,
                35.0378082
              ],
              [
                47.3261234,
                35.0357252
              ],
              [
                47.3280926,
                35.0307208
              ],
              [
                47.3286601,
                35.0262821
              ],
              [
                47.3289306,
                35.0259959
              ],
              [
                47.3275196,
                35.0216244
              ],
              [
                47.3217618,
                35.0172279
              ],
              [
                47.3232846,
                35.017171
              ],
              [
                47.3235745,
                35.0168807
              ],
              [
                47.3291268,
                35.0169121
              ],
              [
                47.3293807,
                35.0171679
              ],
              [
                47.3310545,
                35.0171456
              ],
              [
                47.3313443,
                35.0174831
              ],
              [
                47.3333229,
                35.0174616
              ],
              [
                47.3376751,
                35.018235
              ],
              [
                47.3451204,
                35.0182721
              ],
              [
                47.3469148,
                35.0182483
              ],
              [
                47.3491724,
                35.018192
              ],
              [
                47.3494766,
                35.0179218
              ],
              [
                47.3550574,
                35.0180366
              ],
              [
                47.3600191,
                35.0224775
              ],
              [
                47.3616803,
                35.0286096
              ],
              [
                47.3613554,
                35.0288884
              ],
              [
                47.3611225,
                35.0298943
              ],
              [
                47.3599822,
                35.032876
              ],
              [
                47.3585111,
                35.0367294
              ],
              [
                47.356081,
                35.0427322
              ],
              [
                47.356102,
                35.045794
              ],
              [
                47.35722,
                35.0474502
              ],
              [
                47.3608429,
                35.0527717
              ],
              [
                47.3632763,
                35.0535498
              ],
              [
                47.3652929,
                35.0535888
              ],
              [
                47.3657125,
                35.0538538
              ],
              [
                47.371857,
                35.0538958
              ],
              [
                47.3763143,
                35.0546714
              ],
              [
                47.3763468,
                35.0549607
              ],
              [
                47.3846981,
                35.0574139
              ],
              [
                47.3855304,
                35.0574358
              ],
              [
                47.3872245,
                35.0583513
              ],
              [
                47.3901409,
                35.0590346
              ],
              [
                47.392917,
                35.0597163
              ],
              [
                47.396038,
                35.0604986
              ],
              [
                47.399424,
                35.0612889
              ],
              [
                47.3997634,
                35.061691
              ],
              [
                47.4029975,
                35.0616365
              ],
              [
                47.4046504,
                35.0616286
              ],
              [
                47.4089891,
                35.0610662
              ],
              [
                47.4091763,
                35.06082
              ],
              [
                47.4097927,
                35.0607578
              ],
              [
                47.4100044,
                35.0605119
              ],
              [
                47.4108638,
                35.0605213
              ],
              [
                47.4202721,
                35.0561035
              ],
              [
                47.420581,
                35.056306
              ],
              [
                47.4246721,
                35.0530799
              ],
              [
                47.4252047,
                35.052776
              ],
              [
                47.4257373,
                35.0525998
              ],
              [
                47.426991,
                35.052207
              ],
              [
                47.4292075,
                35.0521714
              ],
              [
                47.4296625,
                35.0518523
              ],
              [
                47.434173,
                35.0518713
              ],
              [
                47.4345097,
                35.0516291
              ],
              [
                47.4416925,
                35.0515702
              ],
              [
                47.4491238,
                35.0507775
              ],
              [
                47.4495099,
                35.0504902
              ],
              [
                47.451384,
                35.0504702
              ],
              [
                47.4517373,
                35.0502176
              ],
              [
                47.457162,
                35.0501318
              ],
              [
                47.4667776,
                35.0505234
              ],
              [
                47.4672476,
                35.0508007
              ],
              [
                47.4693599,
                35.050844
              ],
              [
                47.4708396,
                35.0511043
              ],
              [
                47.4728566,
                35.0525827
              ],
              [
                47.4753793,
                35.0544726
              ],
              [
                47.4847791,
                35.0613824
              ],
              [
                47.4872276,
                35.0632418
              ],
              [
                47.4978056,
                35.0661775
              ],
              [
                47.5051247,
                35.0682052
              ],
              [
                47.5150911,
                35.0793804
              ],
              [
                47.5184447,
                35.0817857
              ],
              [
                47.5234869,
                35.0890563
              ],
              [
                47.5234411,
                35.0917216
              ],
              [
                47.5231611,
                35.1017269
              ],
              [
                47.5232084,
                35.103036
              ],
              [
                47.5185707,
                35.1126646
              ],
              [
                47.515661,
                35.1175979
              ],
              [
                47.5133014,
                35.1214769
              ],
              [
                47.5125641,
                35.1225319
              ],
              [
                47.5109116,
                35.1244065
              ],
              [
                47.510693,
                35.1246693
              ],
              [
                47.510524,
                35.1247413
              ],
              [
                47.510479,
                35.1250202
              ],
              [
                47.5104219,
                35.1256421
              ],
              [
                47.5079189,
                35.1310104
              ],
              [
                47.5077648,
                35.1315688
              ],
              [
                47.5053292,
                35.1354755
              ],
              [
                47.5044692,
                35.1361698
              ],
              [
                47.4941404,
                35.1457421
              ],
              [
                47.4917676,
                35.1479133
              ],
              [
                47.4893143,
                35.1496944
              ],
              [
                47.480932,
                35.1546129
              ],
              [
                47.4774669,
                35.1550691
              ],
              [
                47.4742767,
                35.1558328
              ],
              [
                47.466848,
                35.1590813
              ],
              [
                47.456027,
                35.1617049
              ],
              [
                47.4240135,
                35.1781269
              ],
              [
                47.4226055,
                35.1773628
              ],
              [
                47.418691,
                35.1784849
              ],
              [
                47.4192617,
                35.1825587
              ],
              [
                47.4196387,
                35.1854033
              ],
              [
                47.4202613,
                35.1873984
              ],
              [
                47.42113,
                35.1926348
              ],
              [
                47.4175312,
                35.2012529
              ],
              [
                47.4175134,
                35.2147768
              ],
              [
                47.4481899,
                35.210255
              ],
              [
                47.4544541,
                35.2096297
              ],
              [
                47.4591248,
                35.2089382
              ],
              [
                47.4669107,
                35.2066756
              ],
              [
                47.4695812,
                35.2052476
              ],
              [
                47.4791379,
                35.2060699
              ],
              [
                47.4864972,
                35.2066621
              ],
              [
                47.4978049,
                35.2080119
              ],
              [
                47.4966119,
                35.2116517
              ],
              [
                47.4963307,
                35.2161188
              ],
              [
                47.4969861,
                35.2194295
              ],
              [
                47.4974524,
                35.2206952
              ],
              [
                47.4979232,
                35.2217019
              ],
              [
                47.4981711,
                35.2219817
              ],
              [
                47.5002751,
                35.2258398
              ],
              [
                47.5041517,
                35.2321094
              ],
              [
                47.5098096,
                35.2414319
              ],
              [
                47.5145775,
                35.2494014
              ],
              [
                47.5149696,
                35.2503645
              ],
              [
                47.5158723,
                35.2511945
              ],
              [
                47.5208124,
                35.2554168
              ],
              [
                47.5252182,
                35.2605261
              ],
              [
                47.5271432,
                35.2633153
              ],
              [
                47.5285695,
                35.2660739
              ],
              [
                47.53054,
                35.2757744
              ],
              [
                47.5308445,
                35.2761488
              ],
              [
                47.5308204,
                35.2828608
              ],
              [
                47.5311563,
                35.284484
              ],
              [
                47.5323492,
                35.2867618
              ],
              [
                47.5355804,
                35.2929063
              ],
              [
                47.5366429,
                35.2949241
              ],
              [
                47.5374953,
                35.2966245
              ],
              [
                47.5387866,
                35.2982738
              ],
              [
                47.5431981,
                35.3026537
              ],
              [
                47.5472277,
                35.3066543
              ],
              [
                47.5524957,
                35.3138798
              ],
              [
                47.5570188,
                35.3316096
              ],
              [
                47.5583306,
                35.3365942
              ],
              [
                47.5597225,
                35.3393999
              ],
              [
                47.5596851,
                35.3399318
              ],
              [
                47.5662188,
                35.3456121
              ],
              [
                47.574016,
                35.3523648
              ],
              [
                47.5750235,
                35.3529552
              ],
              [
                47.5822114,
                35.3598643
              ],
              [
                47.5880726,
                35.3650227
              ],
              [
                47.6075461,
                35.3794162
              ],
              [
                47.6052062,
                35.3987954
              ],
              [
                47.5625851,
                35.4118872
              ],
              [
                47.5590509,
                35.4536076
              ],
              [
                47.5581467,
                35.4628339
              ],
              [
                47.5566742,
                35.4804275
              ],
              [
                47.5527763,
                35.4951284
              ],
              [
                47.547283,
                35.5005091
              ],
              [
                47.5341311,
                35.5075412
              ],
              [
                47.5189589,
                35.5199322
              ],
              [
                47.5144921,
                35.5403402
              ],
              [
                47.5113139,
                35.5546756
              ],
              [
                47.5106616,
                35.5570735
              ],
              [
                47.5073469,
                35.5648156
              ],
              [
                47.5033614,
                35.5667854
              ],
              [
                47.4990766,
                35.5681605
              ],
              [
                47.4843573,
                35.5748153
              ],
              [
                47.4674828,
                35.5829259
              ],
              [
                47.4451558,
                35.5838477
              ],
              [
                47.4121589,
                35.5852311
              ],
              [
                47.3798736,
                35.586687
              ],
              [
                47.3834152,
                35.599701
              ],
              [
                47.3863327,
                35.6102233
              ],
              [
                47.3888606,
                35.6197133
              ],
              [
                47.3898382,
                35.6246102
              ],
              [
                47.3912934,
                35.6299558
              ],
              [
                47.383518,
                35.630547
              ],
              [
                47.3784959,
                35.6308495
              ],
              [
                47.3702729,
                35.6313148
              ],
              [
                47.3518122,
                35.632624
              ],
              [
                47.3332475,
                35.6337512
              ],
              [
                47.3240672,
                35.6386909
              ],
              [
                47.3173936,
                35.6127421
              ],
              [
                47.3077075,
                35.5918493
              ],
              [
                47.2897597,
                35.5811779
              ],
              [
                47.2834617,
                35.5708755
              ],
              [
                47.2773633,
                35.562238
              ],
              [
                47.2684606,
                35.5496413
              ],
              [
                47.2599181,
                35.5375808
              ],
              [
                47.2536394,
                35.5258219
              ],
              [
                47.2440832,
                35.5155331
              ],
              [
                47.2382917,
                35.5086679
              ],
              [
                47.2332326,
                35.502544
              ],
              [
                47.232749,
                35.5016271
              ],
              [
                47.2306751,
                35.4998391
              ],
              [
                47.2288176,
                35.497412
              ],
              [
                47.216263,
                35.4878657
              ],
              [
                47.2110489,
                35.481994
              ],
              [
                47.2071627,
                35.4776069
              ],
              [
                47.2025325,
                35.4728023
              ],
              [
                47.1973307,
                35.4673781
              ],
              [
                47.1922353,
                35.4621649
              ],
              [
                47.1862033,
                35.4609226
              ],
              [
                47.1729295,
                35.4576034
              ],
              [
                47.1600782,
                35.4544257
              ],
              [
                47.1588509,
                35.4498314
              ],
              [
                47.1577311,
                35.4457934
              ],
              [
                47.1543974,
                35.4349635
              ],
              [
                47.1530081,
                35.4239479
              ],
              [
                47.1502543,
                35.4130177
              ],
              [
                47.1473914,
                35.4036452
              ],
              [
                47.152199,
                35.3902512
              ],
              [
                47.1359643,
                35.3837441
              ],
              [
                47.1272611,
                35.3769231
              ],
              [
                47.1206528,
                35.3723707
              ],
              [
                47.1133604,
                35.3624715
              ],
              [
                47.1173661,
                35.3606771
              ],
              [
                47.129447,
                35.3549533
              ],
              [
                47.1364047,
                35.3502392
              ],
              [
                47.1432061,
                35.3464589
              ],
              [
                47.1550906,
                35.3389724
              ],
              [
                47.1631101,
                35.3330694
              ],
              [
                47.1592462,
                35.3280465
              ],
              [
                47.151496,
                35.322253
              ],
              [
                47.1465514,
                35.3038184
              ],
              [
                47.1532381,
                35.2955019
              ],
              [
                47.1607684,
                35.2872591
              ],
              [
                47.1693006,
                35.2773655
              ],
              [
                47.1680478,
                35.2759933
              ],
              [
                47.1699427,
                35.2741035
              ],
              [
                47.1672849,
                35.2714381
              ],
              [
                47.166152,
                35.2703905
              ],
              [
                47.1648549,
                35.2671965
              ],
              [
                47.1509454,
                35.2494532
              ],
              [
                47.1391582,
                35.2324399
              ],
              [
                47.1265167,
                35.2260889
              ],
              [
                47.1122876,
                35.2148887
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555030,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دیواندره",
          "name:en": "Divandarreh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282087",
          "wikipedia": "en:Divandarreh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.5184417,
                35.8527507
              ],
              [
                46.5222737,
                35.8440038
              ],
              [
                46.5286455,
                35.8282982
              ],
              [
                46.5481923,
                35.8006979
              ],
              [
                46.5610056,
                35.7816326
              ],
              [
                46.5684482,
                35.7700766
              ],
              [
                46.5635136,
                35.6889049
              ],
              [
                46.6234245,
                35.6805307
              ],
              [
                46.62676,
                35.667094
              ],
              [
                46.6322928,
                35.6450616
              ],
              [
                46.6431668,
                35.6386447
              ],
              [
                46.6646245,
                35.6313979
              ],
              [
                46.6811974,
                35.6273904
              ],
              [
                46.6863189,
                35.6152416
              ],
              [
                46.6892983,
                35.6076496
              ],
              [
                46.6921137,
                35.6002332
              ],
              [
                46.6969875,
                35.5895656
              ],
              [
                46.7003034,
                35.5866669
              ],
              [
                46.7088007,
                35.5902879
              ],
              [
                46.725083,
                35.596911
              ],
              [
                46.7379706,
                35.6026337
              ],
              [
                46.7420933,
                35.6045166
              ],
              [
                46.7571952,
                35.6108603
              ],
              [
                46.7668678,
                35.6153616
              ],
              [
                46.7753771,
                35.6175579
              ],
              [
                46.7852913,
                35.6201951
              ],
              [
                46.7908869,
                35.6183811
              ],
              [
                46.7956497,
                35.6176229
              ],
              [
                46.8249847,
                35.6138266
              ],
              [
                46.8540417,
                35.6156889
              ],
              [
                46.8660886,
                35.6207542
              ],
              [
                46.8772028,
                35.6223237
              ],
              [
                46.8895339,
                35.6287733
              ],
              [
                46.8972529,
                35.6328055
              ],
              [
                46.9042985,
                35.6366032
              ],
              [
                46.9104597,
                35.6390894
              ],
              [
                46.9105052,
                35.6620384
              ],
              [
                46.910076,
                35.6736136
              ],
              [
                46.9089877,
                35.6854393
              ],
              [
                46.9172859,
                35.6819452
              ],
              [
                46.9262123,
                35.6797491
              ],
              [
                46.9328041,
                35.6804613
              ],
              [
                46.94319,
                35.6812901
              ],
              [
                46.9472006,
                35.6817503
              ],
              [
                46.959422,
                35.6823943
              ],
              [
                46.9644084,
                35.682454
              ],
              [
                46.9839407,
                35.6823402
              ],
              [
                46.9898986,
                35.6830956
              ],
              [
                46.9968916,
                35.6830218
              ],
              [
                46.9997301,
                35.6838247
              ],
              [
                47.0030074,
                35.6841739
              ],
              [
                47.0085583,
                35.6852486
              ],
              [
                47.0164903,
                35.6869223
              ],
              [
                47.0246001,
                35.6908114
              ],
              [
                47.0310063,
                35.6940205
              ],
              [
                47.0433479,
                35.6984712
              ],
              [
                47.0734759,
                35.7085795
              ],
              [
                47.0835654,
                35.712191
              ],
              [
                47.0963705,
                35.7137269
              ],
              [
                47.1135806,
                35.7157859
              ],
              [
                47.1137866,
                35.7012616
              ],
              [
                47.1331064,
                35.6867091
              ],
              [
                47.1450469,
                35.673734
              ],
              [
                47.1572864,
                35.6814576
              ],
              [
                47.1701217,
                35.6867875
              ],
              [
                47.1815069,
                35.6963092
              ],
              [
                47.1865957,
                35.7024202
              ],
              [
                47.1906566,
                35.7083289
              ],
              [
                47.1996956,
                35.7173007
              ],
              [
                47.1818319,
                35.7283771
              ],
              [
                47.1647373,
                35.7392752
              ],
              [
                47.154951,
                35.7466517
              ],
              [
                47.1491362,
                35.7489817
              ],
              [
                47.1447866,
                35.7495432
              ],
              [
                47.1367733,
                35.7673897
              ],
              [
                47.1299951,
                35.7777621
              ],
              [
                47.1242103,
                35.7857392
              ],
              [
                47.1319484,
                35.7969309
              ],
              [
                47.1552498,
                35.804755
              ],
              [
                47.1716734,
                35.8110854
              ],
              [
                47.1937505,
                35.8172652
              ],
              [
                47.1941669,
                35.83531
              ],
              [
                47.1949998,
                35.8491425
              ],
              [
                47.195827,
                35.8672255
              ],
              [
                47.2091122,
                35.8692385
              ],
              [
                47.2232102,
                35.8713
              ],
              [
                47.227882,
                35.8707419
              ],
              [
                47.2489725,
                35.873073
              ],
              [
                47.2518415,
                35.8740119
              ],
              [
                47.2538997,
                35.8737709
              ],
              [
                47.2598394,
                35.878987
              ],
              [
                47.2669004,
                35.8850949
              ],
              [
                47.2925174,
                35.9019852
              ],
              [
                47.30262,
                35.9089015
              ],
              [
                47.2985843,
                35.9247708
              ],
              [
                47.2968629,
                35.9317918
              ],
              [
                47.2890793,
                35.9627579
              ],
              [
                47.2990013,
                35.9679657
              ],
              [
                47.3091145,
                35.9716464
              ],
              [
                47.3379143,
                35.9749763
              ],
              [
                47.3596801,
                35.9848363
              ],
              [
                47.3687726,
                35.990045
              ],
              [
                47.3738557,
                35.9941439
              ],
              [
                47.3821787,
                35.9993519
              ],
              [
                47.3895234,
                36.0041386
              ],
              [
                47.4131565,
                36.0199707
              ],
              [
                47.4294133,
                36.0301187
              ],
              [
                47.4457883,
                36.039036
              ],
              [
                47.4538135,
                36.0435819
              ],
              [
                47.4610844,
                36.0480992
              ],
              [
                47.4627023,
                36.0484624
              ],
              [
                47.4558573,
                36.063964
              ],
              [
                47.4525098,
                36.0820745
              ],
              [
                47.4500369,
                36.0884363
              ],
              [
                47.4468341,
                36.0948399
              ],
              [
                47.4433984,
                36.1019247
              ],
              [
                47.4357898,
                36.1029642
              ],
              [
                47.4205305,
                36.105049
              ],
              [
                47.4088472,
                36.1084667
              ],
              [
                47.3930833,
                36.1124045
              ],
              [
                47.3635363,
                36.1147648
              ],
              [
                47.3442869,
                36.1218537
              ],
              [
                47.3325528,
                36.1242803
              ],
              [
                47.2987476,
                36.1342714
              ],
              [
                47.2621235,
                36.1504192
              ],
              [
                47.2577976,
                36.1534888
              ],
              [
                47.2511172,
                36.1569606
              ],
              [
                47.246549,
                36.1587883
              ],
              [
                47.2348833,
                36.1655741
              ],
              [
                47.2296456,
                36.170702
              ],
              [
                47.2235123,
                36.1757658
              ],
              [
                47.2195688,
                36.1781073
              ],
              [
                47.2091984,
                36.1826966
              ],
              [
                47.2009833,
                36.1862989
              ],
              [
                47.1943222,
                36.1910115
              ],
              [
                47.1815585,
                36.2065377
              ],
              [
                47.1782111,
                36.2104852
              ],
              [
                47.1764274,
                36.2151852
              ],
              [
                47.1731471,
                36.2177564
              ],
              [
                47.1644782,
                36.2200415
              ],
              [
                47.1592425,
                36.2223266
              ],
              [
                47.1563243,
                36.2253039
              ],
              [
                47.1489429,
                36.2275195
              ],
              [
                47.1422481,
                36.2292505
              ],
              [
                47.13212,
                36.2311891
              ],
              [
                47.1304667,
                36.2328691
              ],
              [
                47.1231958,
                36.2354306
              ],
              [
                47.1147822,
                36.2359661
              ],
              [
                47.105603,
                36.2373045
              ],
              [
                47.0914149,
                36.242864
              ],
              [
                47.0895549,
                36.244472
              ],
              [
                47.0825424,
                36.2482815
              ],
              [
                47.080965,
                36.2519566
              ],
              [
                47.083322,
                36.2679466
              ],
              [
                47.0789257,
                36.2708602
              ],
              [
                47.0720386,
                36.2718191
              ],
              [
                47.0680904,
                36.274241
              ],
              [
                47.0656596,
                36.2765801
              ],
              [
                47.0621741,
                36.28151
              ],
              [
                47.0455019,
                36.2952612
              ],
              [
                47.0435558,
                36.2963694
              ],
              [
                47.0427221,
                36.2972072
              ],
              [
                47.042169,
                36.2972073
              ],
              [
                47.042169,
                36.2974865
              ],
              [
                47.031336,
                36.30582
              ],
              [
                47.0310556,
                36.3060993
              ],
              [
                46.9736602,
                36.3355973
              ],
              [
                46.9615744,
                36.337115
              ],
              [
                46.942005,
                36.3386361
              ],
              [
                46.9202883,
                36.3401852
              ],
              [
                46.905102,
                36.3419882
              ],
              [
                46.8975447,
                36.3452732
              ],
              [
                46.8934544,
                36.3495927
              ],
              [
                46.8896565,
                36.3592963
              ],
              [
                46.8783763,
                36.3465331
              ],
              [
                46.8316011,
                36.319153
              ],
              [
                46.8232682,
                36.3144323
              ],
              [
                46.8207681,
                36.3127565
              ],
              [
                46.820211,
                36.3124773
              ],
              [
                46.8099408,
                36.3012174
              ],
              [
                46.7993533,
                36.2935702
              ],
              [
                46.7879506,
                36.2809909
              ],
              [
                46.7758792,
                36.2662622
              ],
              [
                46.7718095,
                36.2497104
              ],
              [
                46.766365,
                36.2292725
              ],
              [
                46.7809433,
                36.2273684
              ],
              [
                46.7926392,
                36.2252937
              ],
              [
                46.8229608,
                36.2209746
              ],
              [
                46.8325046,
                36.2157812
              ],
              [
                46.8457184,
                36.2085244
              ],
              [
                46.8560847,
                36.201693
              ],
              [
                46.8548403,
                36.1918227
              ],
              [
                46.8538961,
                36.1831849
              ],
              [
                46.8527891,
                36.1783667
              ],
              [
                46.8523979,
                36.1739113
              ],
              [
                46.8499014,
                36.1601764
              ],
              [
                46.8467568,
                36.1496734
              ],
              [
                46.8465329,
                36.1408182
              ],
              [
                46.8466228,
                36.1320316
              ],
              [
                46.8421766,
                36.1134358
              ],
              [
                46.8332576,
                36.1054971
              ],
              [
                46.8258333,
                36.0994599
              ],
              [
                46.8209538,
                36.0951723
              ],
              [
                46.8111101,
                36.0859377
              ],
              [
                46.7943656,
                36.0694093
              ],
              [
                46.7786798,
                36.0565011
              ],
              [
                46.7740349,
                36.0433727
              ],
              [
                46.7720318,
                36.0371626
              ],
              [
                46.7699703,
                36.0295852
              ],
              [
                46.7661078,
                36.0232724
              ],
              [
                46.75704,
                36.0186633
              ],
              [
                46.7492421,
                36.0174723
              ],
              [
                46.7458535,
                36.0208051
              ],
              [
                46.7405019,
                36.0232691
              ],
              [
                46.7375661,
                36.0249691
              ],
              [
                46.7429075,
                36.0020575
              ],
              [
                46.7291852,
                35.998517
              ],
              [
                46.7145975,
                35.9962279
              ],
              [
                46.7008035,
                35.9931724
              ],
              [
                46.6975006,
                35.9880319
              ],
              [
                46.6960305,
                35.9861264
              ],
              [
                46.69177,
                35.9825464
              ],
              [
                46.6747508,
                35.9840396
              ],
              [
                46.6593946,
                35.9845251
              ],
              [
                46.6565949,
                35.9849781
              ],
              [
                46.6502332,
                35.9857421
              ],
              [
                46.6405729,
                35.9865043
              ],
              [
                46.6364189,
                35.9867285
              ],
              [
                46.6239337,
                35.9890715
              ],
              [
                46.5985747,
                35.9932405
              ],
              [
                46.5817832,
                35.9944966
              ],
              [
                46.5794253,
                35.9874524
              ],
              [
                46.5783982,
                35.9815548
              ],
              [
                46.5754602,
                35.9733189
              ],
              [
                46.574456,
                35.965837
              ],
              [
                46.5750739,
                35.9595982
              ],
              [
                46.5736198,
                35.9504614
              ],
              [
                46.5689891,
                35.9432904
              ],
              [
                46.5634059,
                35.939274
              ],
              [
                46.5558099,
                35.9322897
              ],
              [
                46.5555524,
                35.931143
              ],
              [
                46.5529346,
                35.9274942
              ],
              [
                46.5556383,
                35.9224899
              ],
              [
                46.5540504,
                35.917381
              ],
              [
                46.5404462,
                35.9117504
              ],
              [
                46.5340948,
                35.9081355
              ],
              [
                46.527915,
                35.9037209
              ],
              [
                46.5247392,
                35.8980893
              ],
              [
                46.5178728,
                35.8917272
              ],
              [
                46.5168857,
                35.8769499
              ],
              [
                46.5172914,
                35.8665425
              ],
              [
                46.5184417,
                35.8527507
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555077,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سروآباد",
          "name:ckb": "شارستانی سەوڵاوا",
          "name:en": "Sarvabad County",
          "name:ku": "Sewllawa",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282046",
          "wikipedia": "en:Sarvabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.0736106,
                35.3644429
              ],
              [
                46.074075,
                35.364137
              ],
              [
                46.07543,
                35.363781
              ],
              [
                46.076513,
                35.363715
              ],
              [
                46.077611,
                35.363607
              ],
              [
                46.078716,
                35.363438
              ],
              [
                46.080276,
                35.362288
              ],
              [
                46.080671,
                35.362111
              ],
              [
                46.081569,
                35.361429
              ],
              [
                46.083249,
                35.361083
              ],
              [
                46.083507,
                35.361201
              ],
              [
                46.084675,
                35.360951
              ],
              [
                46.08563,
                35.361076
              ],
              [
                46.086178,
                35.360997
              ],
              [
                46.086912,
                35.361111
              ],
              [
                46.087913,
                35.360501
              ],
              [
                46.089023,
                35.36007
              ],
              [
                46.090452,
                35.359695
              ],
              [
                46.091371,
                35.359655
              ],
              [
                46.092125,
                35.359532
              ],
              [
                46.092388,
                35.359322
              ],
              [
                46.092718,
                35.359279
              ],
              [
                46.093164,
                35.358822
              ],
              [
                46.093221,
                35.358681
              ],
              [
                46.093495,
                35.358452
              ],
              [
                46.093689,
                35.358289
              ],
              [
                46.093504,
                35.358272
              ],
              [
                46.092182,
                35.357783
              ],
              [
                46.092199,
                35.357292
              ],
              [
                46.092491,
                35.355824
              ],
              [
                46.092897,
                35.354356
              ],
              [
                46.092936,
                35.352967
              ],
              [
                46.093246,
                35.35286
              ],
              [
                46.09349,
                35.352013
              ],
              [
                46.093287,
                35.351186
              ],
              [
                46.093211,
                35.350097
              ],
              [
                46.09498,
                35.349474
              ],
              [
                46.09589,
                35.349282
              ],
              [
                46.096375,
                35.349041
              ],
              [
                46.096822,
                35.348529
              ],
              [
                46.09759,
                35.348046
              ],
              [
                46.0979,
                35.347719
              ],
              [
                46.098341,
                35.347228
              ],
              [
                46.099167,
                35.346684
              ],
              [
                46.099291,
                35.346183
              ],
              [
                46.100353,
                35.346171
              ],
              [
                46.101329,
                35.345987
              ],
              [
                46.102122,
                35.345777
              ],
              [
                46.102701,
                35.345608
              ],
              [
                46.103377,
                35.34538
              ],
              [
                46.104507,
                35.344709
              ],
              [
                46.105157,
                35.344298
              ],
              [
                46.105938,
                35.343772
              ],
              [
                46.106555,
                35.343288
              ],
              [
                46.107397,
                35.342661
              ],
              [
                46.107805,
                35.342326
              ],
              [
                46.108163,
                35.341989
              ],
              [
                46.108983,
                35.341467
              ],
              [
                46.109582,
                35.341055
              ],
              [
                46.110075,
                35.340753
              ],
              [
                46.110522,
                35.340151
              ],
              [
                46.110934,
                35.339785
              ],
              [
                46.111539,
                35.339482
              ],
              [
                46.113467,
                35.338501
              ],
              [
                46.114849,
                35.338015
              ],
              [
                46.115674,
                35.337637
              ],
              [
                46.116496,
                35.337349
              ],
              [
                46.117072,
                35.33745
              ],
              [
                46.117457,
                35.337557
              ],
              [
                46.118331,
                35.337551
              ],
              [
                46.119365,
                35.337333
              ],
              [
                46.120484,
                35.337079
              ],
              [
                46.121349,
                35.337335
              ],
              [
                46.122373,
                35.33718
              ],
              [
                46.123303,
                35.336641
              ],
              [
                46.124158,
                35.336226
              ],
              [
                46.125814,
                35.335448
              ],
              [
                46.127443,
                35.334474
              ],
              [
                46.127784,
                35.333836
              ],
              [
                46.127174,
                35.332637
              ],
              [
                46.126653,
                35.331171
              ],
              [
                46.126413,
                35.32973
              ],
              [
                46.126332,
                35.329053
              ],
              [
                46.126274,
                35.328652
              ],
              [
                46.126335,
                35.328038
              ],
              [
                46.126587,
                35.327619
              ],
              [
                46.126968,
                35.327465
              ],
              [
                46.128704,
                35.326682
              ],
              [
                46.12918,
                35.32633
              ],
              [
                46.129668,
                35.325875
              ],
              [
                46.130073,
                35.325416
              ],
              [
                46.130471,
                35.325029
              ],
              [
                46.130566,
                35.324539
              ],
              [
                46.130849,
                35.324083
              ],
              [
                46.131336,
                35.323578
              ],
              [
                46.131679,
                35.323141
              ],
              [
                46.132044,
                35.322881
              ],
              [
                46.132606,
                35.322472
              ],
              [
                46.133099,
                35.322132
              ],
              [
                46.133383,
                35.321972
              ],
              [
                46.133616,
                35.321656
              ],
              [
                46.134601,
                35.320864
              ],
              [
                46.135618,
                35.320439
              ],
              [
                46.136845,
                35.319683
              ],
              [
                46.137694,
                35.318792
              ],
              [
                46.138919,
                35.318129
              ],
              [
                46.139853,
                35.317648
              ],
              [
                46.14089,
                35.316897
              ],
              [
                46.14179,
                35.315892
              ],
              [
                46.142767,
                35.31507
              ],
              [
                46.14375,
                35.314319
              ],
              [
                46.144336,
                35.313718
              ],
              [
                46.144975,
                35.31321
              ],
              [
                46.145457,
                35.312972
              ],
              [
                46.145984,
                35.311706
              ],
              [
                46.146043,
                35.311175
              ],
              [
                46.146417,
                35.310593
              ],
              [
                46.147046,
                35.309349
              ],
              [
                46.147487,
                35.307466
              ],
              [
                46.14763,
                35.306742
              ],
              [
                46.147877,
                35.305498
              ],
              [
                46.148885,
                35.304691
              ],
              [
                46.149343,
                35.303719
              ],
              [
                46.149848,
                35.302769
              ],
              [
                46.149783,
                35.302283
              ],
              [
                46.149916,
                35.30182
              ],
              [
                46.15006,
                35.301398
              ],
              [
                46.150805,
                35.300828
              ],
              [
                46.151344,
                35.299903
              ],
              [
                46.151443,
                35.299468
              ],
              [
                46.151511,
                35.298665
              ],
              [
                46.151692,
                35.297632
              ],
              [
                46.151194,
                35.29701
              ],
              [
                46.150946,
                35.296403
              ],
              [
                46.150854,
                35.295318
              ],
              [
                46.150956,
                35.294394
              ],
              [
                46.150651,
                35.29358
              ],
              [
                46.15134,
                35.292605
              ],
              [
                46.151604,
                35.291972
              ],
              [
                46.152228,
                35.291457
              ],
              [
                46.153198,
                35.290511
              ],
              [
                46.153502,
                35.289725
              ],
              [
                46.154677,
                35.288875
              ],
              [
                46.155263,
                35.288024
              ],
              [
                46.156568,
                35.286805
              ],
              [
                46.157333,
                35.285806
              ],
              [
                46.158107,
                35.285043
              ],
              [
                46.158684,
                35.284506
              ],
              [
                46.1614576,
                35.2842472
              ],
              [
                46.1641871,
                35.282881
              ],
              [
                46.164805,
                35.2815568
              ],
              [
                46.1666075,
                35.2806319
              ],
              [
                46.1695171,
                35.2792866
              ],
              [
                46.1711651,
                35.2783827
              ],
              [
                46.1731993,
                35.2775209
              ],
              [
                46.1741262,
                35.2772686
              ],
              [
                46.1764952,
                35.2754608
              ],
              [
                46.1793791,
                35.2740734
              ],
              [
                46.1837604,
                35.2707791
              ],
              [
                46.1904847,
                35.2624003
              ],
              [
                46.1935746,
                35.2584686
              ],
              [
                46.1961496,
                35.2560926
              ],
              [
                46.1997287,
                35.2549152
              ],
              [
                46.2024839,
                35.2505625
              ],
              [
                46.2029473,
                35.2482494
              ],
              [
                46.2038486,
                35.2462938
              ],
              [
                46.2049077,
                35.2448438
              ],
              [
                46.2106755,
                35.2440867
              ],
              [
                46.2138942,
                35.2422361
              ],
              [
                46.2182973,
                35.239397
              ],
              [
                46.219971,
                35.2372729
              ],
              [
                46.2230094,
                35.2335713
              ],
              [
                46.2258161,
                35.230732
              ],
              [
                46.2295754,
                35.2282921
              ],
              [
                46.2334636,
                35.2256839
              ],
              [
                46.2376058,
                35.223895
              ],
              [
                46.2368882,
                35.2209931
              ],
              [
                46.2379182,
                35.2187003
              ],
              [
                46.2401584,
                35.2175222
              ],
              [
                46.2484872,
                35.2153506
              ],
              [
                46.2502124,
                35.2146563
              ],
              [
                46.2537658,
                35.2111852
              ],
              [
                46.255697,
                35.2094811
              ],
              [
                46.2608726,
                35.2082188
              ],
              [
                46.2648637,
                35.2071037
              ],
              [
                46.2673356,
                35.206178
              ],
              [
                46.2719705,
                35.2026854
              ],
              [
                46.2737818,
                35.2014143
              ],
              [
                46.2765281,
                35.1994872
              ],
              [
                46.2817037,
                35.1974673
              ],
              [
                46.2839181,
                35.1956787
              ],
              [
                46.287935,
                35.1935955
              ],
              [
                46.2924153,
                35.1916386
              ],
              [
                46.29584,
                35.1893028
              ],
              [
                46.301891,
                35.1861041
              ],
              [
                46.3069894,
                35.1849677
              ],
              [
                46.3093068,
                35.184189
              ],
              [
                46.3143536,
                35.1811374
              ],
              [
                46.3168513,
                35.1801483
              ],
              [
                46.3224389,
                35.1785488
              ],
              [
                46.3264558,
                35.1774543
              ],
              [
                46.3297774,
                35.17596
              ],
              [
                46.3358285,
                35.1737921
              ],
              [
                46.3394591,
                35.1725293
              ],
              [
                46.3412873,
                35.1723819
              ],
              [
                46.3437277,
                35.1708058
              ],
              [
                46.3451954,
                35.1703006
              ],
              [
                46.3471781,
                35.1697954
              ],
              [
                46.3495735,
                35.168391
              ],
              [
                46.3498145,
                35.1686178
              ],
              [
                46.3505506,
                35.1690125
              ],
              [
                46.3538056,
                35.1707577
              ],
              [
                46.3630324,
                35.1666181
              ],
              [
                46.3653927,
                35.166583
              ],
              [
                46.3670235,
                35.164864
              ],
              [
                46.3736754,
                35.1610047
              ],
              [
                46.3734955,
                35.1593802
              ],
              [
                46.3732123,
                35.1569172
              ],
              [
                46.3740105,
                35.1553593
              ],
              [
                46.3756842,
                35.1538646
              ],
              [
                46.3788513,
                35.152054
              ],
              [
                46.3835892,
                35.1499276
              ],
              [
                46.3863959,
                35.1483065
              ],
              [
                46.3883528,
                35.1460957
              ],
              [
                46.3898463,
                35.1436533
              ],
              [
                46.3956141,
                35.140495
              ],
              [
                46.3988585,
                35.139779
              ],
              [
                46.4025406,
                35.1383472
              ],
              [
                46.4057078,
                35.1364942
              ],
              [
                46.4077227,
                35.1340285
              ],
              [
                46.4105036,
                35.1303012
              ],
              [
                46.4116881,
                35.1277951
              ],
              [
                46.412615,
                35.1264262
              ],
              [
                46.4150355,
                35.1244045
              ],
              [
                46.4216015,
                35.1233093
              ],
              [
                46.4271118,
                35.1222352
              ],
              [
                46.429764,
                35.1207399
              ],
              [
                46.4325192,
                35.1178965
              ],
              [
                46.4340126,
                35.1137472
              ],
              [
                46.4368193,
                35.1112617
              ],
              [
                46.4419176,
                35.1075544
              ],
              [
                46.4442865,
                35.1058903
              ],
              [
                46.447222,
                35.1044368
              ],
              [
                46.4483601,
                35.1015193
              ],
              [
                46.4486155,
                35.0972758
              ],
              [
                46.4496197,
                35.0935889
              ],
              [
                46.450315,
                35.0910396
              ],
              [
                46.4498321,
                35.087708
              ],
              [
                46.4503471,
                35.0857274
              ],
              [
                46.4507076,
                35.0845896
              ],
              [
                46.4501154,
                35.0808389
              ],
              [
                46.4487764,
                35.0788582
              ],
              [
                46.4479267,
                35.0771724
              ],
              [
                46.4485962,
                35.07104
              ],
              [
                46.4480554,
                35.0695016
              ],
              [
                46.4496776,
                35.06849
              ],
              [
                46.4535915,
                35.0677102
              ],
              [
                46.4567072,
                35.0671623
              ],
              [
                46.460621,
                35.0658135
              ],
              [
                46.463299,
                35.0657081
              ],
              [
                46.4691955,
                35.0629682
              ],
              [
                46.4723884,
                35.0627364
              ],
              [
                46.4757101,
                35.0615139
              ],
              [
                46.4788515,
                35.0602282
              ],
              [
                46.4828169,
                35.057973
              ],
              [
                46.4869137,
                35.0557191
              ],
              [
                46.4889117,
                35.0539041
              ],
              [
                46.4914093,
                35.0524285
              ],
              [
                46.493804,
                35.0510584
              ],
              [
                46.5000611,
                35.0473273
              ],
              [
                46.5040522,
                35.0462522
              ],
              [
                46.5073996,
                35.0448608
              ],
              [
                46.5112877,
                35.0444814
              ],
              [
                46.5197077,
                35.0415721
              ],
              [
                46.5253468,
                35.0411294
              ],
              [
                46.527587,
                35.0428792
              ],
              [
                46.5292092,
                35.0453668
              ],
              [
                46.5324536,
                35.0511638
              ],
              [
                46.5342045,
                35.0548315
              ],
              [
                46.5371224,
                35.0599834
              ],
              [
                46.5404956,
                35.0638825
              ],
              [
                46.542195,
                35.068477
              ],
              [
                46.5430962,
                35.0711745
              ],
              [
                46.5441446,
                35.0755999
              ],
              [
                46.5470962,
                35.0750906
              ],
              [
                46.5484544,
                35.0748125
              ],
              [
                46.5498359,
                35.0740525
              ],
              [
                46.5497037,
                35.0721723
              ],
              [
                46.550317,
                35.0719622
              ],
              [
                46.5537259,
                35.0722139
              ],
              [
                46.5551566,
                35.0718919
              ],
              [
                46.5564346,
                35.072532
              ],
              [
                46.5572804,
                35.0735965
              ],
              [
                46.5589354,
                35.0741546
              ],
              [
                46.5602447,
                35.0742569
              ],
              [
                46.5695842,
                35.0746713
              ],
              [
                46.576146,
                35.0761394
              ],
              [
                46.5784183,
                35.0774213
              ],
              [
                46.5801926,
                35.0770484
              ],
              [
                46.5807994,
                35.0770738
              ],
              [
                46.5812756,
                35.0767014
              ],
              [
                46.5816366,
                35.0759518
              ],
              [
                46.5844711,
                35.0735331
              ],
              [
                46.5852891,
                35.0731891
              ],
              [
                46.585989,
                35.0734866
              ],
              [
                46.5862602,
                35.0747686
              ],
              [
                46.586877,
                35.0749347
              ],
              [
                46.5915826,
                35.0739284
              ],
              [
                46.5932241,
                35.0725428
              ],
              [
                46.5966853,
                35.0729643
              ],
              [
                46.5979922,
                35.0745436
              ],
              [
                46.600962,
                35.0722104
              ],
              [
                46.602178,
                35.0710838
              ],
              [
                46.6027525,
                35.0710959
              ],
              [
                46.6035645,
                35.0722104
              ],
              [
                46.6046513,
                35.073812
              ],
              [
                46.6060439,
                35.0745891
              ],
              [
                46.6071071,
                35.0748841
              ],
              [
                46.6083152,
                35.0750852
              ],
              [
                46.6095919,
                35.0756068
              ],
              [
                46.6116379,
                35.0759527
              ],
              [
                46.6130369,
                35.0756472
              ],
              [
                46.6138877,
                35.0762688
              ],
              [
                46.6145604,
                35.076829
              ],
              [
                46.6155636,
                35.077988
              ],
              [
                46.6160636,
                35.0798283
              ],
              [
                46.6163137,
                35.0805085
              ],
              [
                46.6173424,
                35.0814657
              ],
              [
                46.6184454,
                35.0808757
              ],
              [
                46.6194036,
                35.0802275
              ],
              [
                46.6218003,
                35.0792541
              ],
              [
                46.6235244,
                35.0784744
              ],
              [
                46.6244492,
                35.0780407
              ],
              [
                46.6250232,
                35.0780301
              ],
              [
                46.6253086,
                35.079089
              ],
              [
                46.6250093,
                35.0803524
              ],
              [
                46.6242529,
                35.0811216
              ],
              [
                46.6245801,
                35.0824482
              ],
              [
                46.6288577,
                35.0839802
              ],
              [
                46.6302074,
                35.0849407
              ],
              [
                46.632057,
                35.0858502
              ],
              [
                46.6335065,
                35.0871654
              ],
              [
                46.6355396,
                35.0875508
              ],
              [
                46.6369301,
                35.0867949
              ],
              [
                46.6375997,
                35.0862679
              ],
              [
                46.6385544,
                35.085694
              ],
              [
                46.6398977,
                35.0866026
              ],
              [
                46.6411444,
                35.0867352
              ],
              [
                46.6425691,
                35.085514
              ],
              [
                46.6450432,
                35.0842243
              ],
              [
                46.6470411,
                35.0827561
              ],
              [
                46.6487577,
                35.0817728
              ],
              [
                46.6487577,
                35.0807894
              ],
              [
                46.6482444,
                35.0799696
              ],
              [
                46.6509893,
                35.0791037
              ],
              [
                46.6520193,
                35.0788227
              ],
              [
                46.6532209,
                35.0775584
              ],
              [
                46.6547659,
                35.0757321
              ],
              [
                46.6562884,
                35.0780508
              ],
              [
                46.6576016,
                35.0797155
              ],
              [
                46.6583999,
                35.0833609
              ],
              [
                46.6593526,
                35.0863108
              ],
              [
                46.6624167,
                35.0902297
              ],
              [
                46.6658156,
                35.0949702
              ],
              [
                46.6666911,
                35.0971402
              ],
              [
                46.6698583,
                35.0998157
              ],
              [
                46.6752496,
                35.102821
              ],
              [
                46.6677674,
                35.1140801
              ],
              [
                46.6654157,
                35.118329
              ],
              [
                46.6630393,
                35.1233031
              ],
              [
                46.6584698,
                35.1285686
              ],
              [
                46.6535572,
                35.1363432
              ],
              [
                46.6587242,
                35.1500503
              ],
              [
                46.6615737,
                35.1560856
              ],
              [
                46.663713,
                35.1602778
              ],
              [
                46.6664511,
                35.1657579
              ],
              [
                46.6672704,
                35.1702054
              ],
              [
                46.6660513,
                35.1763883
              ],
              [
                46.6650835,
                35.1824399
              ],
              [
                46.6646887,
                35.1892583
              ],
              [
                46.6553418,
                35.1969459
              ],
              [
                46.6445786,
                35.2055304
              ],
              [
                46.6380297,
                35.2108111
              ],
              [
                46.6308971,
                35.2122487
              ],
              [
                46.6245457,
                35.2134057
              ],
              [
                46.6163575,
                35.214633
              ],
              [
                46.6100832,
                35.2159793
              ],
              [
                46.6010881,
                35.2188753
              ],
              [
                46.5924708,
                35.2199551
              ],
              [
                46.5794245,
                35.2163019
              ],
              [
                46.5694338,
                35.2156988
              ],
              [
                46.5563103,
                35.2147101
              ],
              [
                46.5469805,
                35.2141631
              ],
              [
                46.5371359,
                35.2143804
              ],
              [
                46.530587,
                35.2144575
              ],
              [
                46.5212372,
                35.2147316
              ],
              [
                46.5162447,
                35.2152639
              ],
              [
                46.5116079,
                35.2159106
              ],
              [
                46.5087943,
                35.2163688
              ],
              [
                46.5058135,
                35.2174354
              ],
              [
                46.5008353,
                35.2216426
              ],
              [
                46.478919,
                35.2438681
              ],
              [
                46.4735631,
                35.2498683
              ],
              [
                46.4665937,
                35.258244
              ],
              [
                46.4594136,
                35.2646184
              ],
              [
                46.4550878,
                35.2734691
              ],
              [
                46.4491226,
                35.2890377
              ],
              [
                46.4464005,
                35.2979591
              ],
              [
                46.44129,
                35.3097485
              ],
              [
                46.4357625,
                35.3236436
              ],
              [
                46.4358312,
                35.327502
              ],
              [
                46.4346552,
                35.3375081
              ],
              [
                46.4344249,
                35.3405161
              ],
              [
                46.4317368,
                35.3456675
              ],
              [
                46.4087897,
                35.3571344
              ],
              [
                46.3648722,
                35.3794293
              ],
              [
                46.3432513,
                35.3925886
              ],
              [
                46.3241883,
                35.4047973
              ],
              [
                46.2956664,
                35.4089267
              ],
              [
                46.2923448,
                35.4096192
              ],
              [
                46.2893836,
                35.4107735
              ],
              [
                46.286989,
                35.4125782
              ],
              [
                46.2836846,
                35.4143028
              ],
              [
                46.2803706,
                35.4141084
              ],
              [
                46.2724914,
                35.4147379
              ],
              [
                46.2699422,
                35.4144231
              ],
              [
                46.2660541,
                35.413164
              ],
              [
                46.2636337,
                35.4119678
              ],
              [
                46.2587957,
                35.4108139
              ],
              [
                46.2526931,
                35.4123668
              ],
              [
                46.2453546,
                35.4115064
              ],
              [
                46.2388401,
                35.412136
              ],
              [
                46.2346429,
                35.4109188
              ],
              [
                46.2297248,
                35.410688
              ],
              [
                46.225296,
                35.409114
              ],
              [
                46.2208929,
                35.4089881
              ],
              [
                46.2165413,
                35.4086313
              ],
              [
                46.2093057,
                35.405924
              ],
              [
                46.2037954,
                35.4052524
              ],
              [
                46.200036,
                35.4047067
              ],
              [
                46.1928038,
                35.4026807
              ],
              [
                46.187448,
                35.4009807
              ],
              [
                46.1808047,
                35.3961951
              ],
              [
                46.1787705,
                35.3923329
              ],
              [
                46.1764273,
                35.3899189
              ],
              [
                46.1750626,
                35.387169
              ],
              [
                46.1737236,
                35.3845449
              ],
              [
                46.1726421,
                35.3835582
              ],
              [
                46.1706337,
                35.3816478
              ],
              [
                46.1690373,
                35.3814589
              ],
              [
                46.1660761,
                35.3829914
              ],
              [
                46.1640162,
                35.384083
              ],
              [
                46.1622137,
                35.3859934
              ],
              [
                46.1579909,
                35.38973
              ],
              [
                46.1561627,
                35.3923958
              ],
              [
                46.1511931,
                35.3953345
              ],
              [
                46.1470217,
                35.396321
              ],
              [
                46.1334114,
                35.3983346
              ],
              [
                46.1293841,
                35.3997113
              ],
              [
                46.1233647,
                35.4026763
              ],
              [
                46.1212427,
                35.4051118
              ],
              [
                46.1154832,
                35.4092415
              ],
              [
                46.1105464,
                35.4124179
              ],
              [
                46.1041251,
                35.3992521
              ],
              [
                46.0965034,
                35.3874134
              ],
              [
                46.0943405,
                35.3815774
              ],
              [
                46.0879547,
                35.375447
              ],
              [
                46.0777065,
                35.3697361
              ],
              [
                46.0739984,
                35.3647763
              ],
              [
                46.0736106,
                35.3644429
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555087,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سنندج",
          "name:en": "Sanandaj County",
          "name:ku": "Sine",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282150",
          "wikipedia": "en:Sanandaj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.4317368,
                35.3456675
              ],
              [
                46.4344249,
                35.3405161
              ],
              [
                46.4346552,
                35.3375081
              ],
              [
                46.4358312,
                35.327502
              ],
              [
                46.4357625,
                35.3236436
              ],
              [
                46.44129,
                35.3097485
              ],
              [
                46.4464005,
                35.2979591
              ],
              [
                46.4491226,
                35.2890377
              ],
              [
                46.4550878,
                35.2734691
              ],
              [
                46.4594136,
                35.2646184
              ],
              [
                46.4665937,
                35.258244
              ],
              [
                46.4735631,
                35.2498683
              ],
              [
                46.478919,
                35.2438681
              ],
              [
                46.5008353,
                35.2216426
              ],
              [
                46.5058135,
                35.2174354
              ],
              [
                46.5087943,
                35.2163688
              ],
              [
                46.5116079,
                35.2159106
              ],
              [
                46.5162447,
                35.2152639
              ],
              [
                46.5212372,
                35.2147316
              ],
              [
                46.530587,
                35.2144575
              ],
              [
                46.5371359,
                35.2143804
              ],
              [
                46.5469805,
                35.2141631
              ],
              [
                46.5563103,
                35.2147101
              ],
              [
                46.5694338,
                35.2156988
              ],
              [
                46.5794245,
                35.2163019
              ],
              [
                46.5924708,
                35.2199551
              ],
              [
                46.6010881,
                35.2188753
              ],
              [
                46.6100832,
                35.2159793
              ],
              [
                46.6163575,
                35.214633
              ],
              [
                46.6245457,
                35.2134057
              ],
              [
                46.6308971,
                35.2122487
              ],
              [
                46.6380297,
                35.2108111
              ],
              [
                46.6445786,
                35.2055304
              ],
              [
                46.6553418,
                35.1969459
              ],
              [
                46.6646887,
                35.1892583
              ],
              [
                46.6650835,
                35.1824399
              ],
              [
                46.6660513,
                35.1763883
              ],
              [
                46.6672704,
                35.1702054
              ],
              [
                46.6664511,
                35.1657579
              ],
              [
                46.663713,
                35.1602778
              ],
              [
                46.6615737,
                35.1560856
              ],
              [
                46.6587242,
                35.1500503
              ],
              [
                46.6535572,
                35.1363432
              ],
              [
                46.6584698,
                35.1285686
              ],
              [
                46.6630393,
                35.1233031
              ],
              [
                46.6654157,
                35.118329
              ],
              [
                46.6677674,
                35.1140801
              ],
              [
                46.6752496,
                35.102821
              ],
              [
                46.6818757,
                35.0996259
              ],
              [
                46.6863389,
                35.0972804
              ],
              [
                46.6957373,
                35.0932986
              ],
              [
                46.7021918,
                35.0943029
              ],
              [
                46.7036337,
                35.093123
              ],
              [
                46.7059512,
                35.0896045
              ],
              [
                46.7081694,
                35.0863344
              ],
              [
                46.7108731,
                35.0853651
              ],
              [
                46.713036,
                35.0851544
              ],
              [
                46.7157623,
                35.0841289
              ],
              [
                46.7186785,
                35.0804421
              ],
              [
                46.7198372,
                35.0788827
              ],
              [
                46.7222319,
                35.0769019
              ],
              [
                46.726635,
                35.0745418
              ],
              [
                46.735364,
                35.0709381
              ],
              [
                46.7400761,
                35.0698212
              ],
              [
                46.7465907,
                35.069484
              ],
              [
                46.7489081,
                35.067503
              ],
              [
                46.756104,
                35.0650749
              ],
              [
                46.7580867,
                35.0635574
              ],
              [
                46.7607389,
                35.0621032
              ],
              [
                46.7631593,
                35.0616816
              ],
              [
                46.7680516,
                35.0591102
              ],
              [
                46.7697768,
                35.0578667
              ],
              [
                46.7707811,
                35.0570236
              ],
              [
                46.7759566,
                35.0547261
              ],
              [
                46.7801023,
                35.0515221
              ],
              [
                46.7827544,
                35.0497303
              ],
              [
                46.7857413,
                35.0480018
              ],
              [
                46.7893499,
                35.0424918
              ],
              [
                46.7889637,
                35.0398355
              ],
              [
                46.7898134,
                35.0355978
              ],
              [
                46.7912811,
                35.0340376
              ],
              [
                46.7969202,
                35.0292093
              ],
              [
                46.7980531,
                35.0278388
              ],
              [
                46.8001131,
                35.0255826
              ],
              [
                46.8024632,
                35.0223324
              ],
              [
                46.8064028,
                35.0202237
              ],
              [
                46.8122736,
                35.017398
              ],
              [
                46.8174235,
                35.0163857
              ],
              [
                46.8208739,
                35.0167232
              ],
              [
                46.8214338,
                35.0175259
              ],
              [
                46.8226182,
                35.0194238
              ],
              [
                46.8227985,
                35.0213639
              ],
              [
                46.8232105,
                35.0254546
              ],
              [
                46.8231847,
                35.0269728
              ],
              [
                46.821717,
                35.0300091
              ],
              [
                46.8218715,
                35.0308314
              ],
              [
                46.823365,
                35.0360813
              ],
              [
                46.8242147,
                35.0382106
              ],
              [
                46.8246782,
                35.0401291
              ],
              [
                46.8257081,
                35.0426379
              ],
              [
                46.8263706,
                35.0438253
              ],
              [
                46.8401667,
                35.0230172
              ],
              [
                46.8517799,
                35.040812
              ],
              [
                46.8754976,
                35.0732456
              ],
              [
                46.9089602,
                35.0694936
              ],
              [
                46.9270557,
                35.0532661
              ],
              [
                46.9410395,
                35.0536145
              ],
              [
                46.9418953,
                35.0499637
              ],
              [
                46.9550425,
                35.0479596
              ],
              [
                46.9769573,
                35.0441843
              ],
              [
                46.9817384,
                35.0511408
              ],
              [
                46.9919348,
                35.0556027
              ],
              [
                47.0059531,
                35.0598959
              ],
              [
                47.0200905,
                35.0584907
              ],
              [
                47.0354195,
                35.0574692
              ],
              [
                47.0462986,
                35.0565706
              ],
              [
                47.046897,
                35.0565339
              ],
              [
                47.04985,
                35.0697192
              ],
              [
                47.0526936,
                35.0833059
              ],
              [
                47.0699533,
                35.0854715
              ],
              [
                47.0862767,
                35.0881223
              ],
              [
                47.0977963,
                35.0908252
              ],
              [
                47.1162291,
                35.0987311
              ],
              [
                47.1257336,
                35.1040938
              ],
              [
                47.1380868,
                35.1132182
              ],
              [
                47.1417723,
                35.1215869
              ],
              [
                47.1417748,
                35.129286
              ],
              [
                47.1408637,
                35.1435273
              ],
              [
                47.1399309,
                35.1557643
              ],
              [
                47.1389567,
                35.1619928
              ],
              [
                47.1361575,
                35.1689395
              ],
              [
                47.1345159,
                35.1773088
              ],
              [
                47.1302037,
                35.1864139
              ],
              [
                47.1250516,
                35.1978603
              ],
              [
                47.1183145,
                35.2086002
              ],
              [
                47.1122876,
                35.2148887
              ],
              [
                47.1265167,
                35.2260889
              ],
              [
                47.1391582,
                35.2324399
              ],
              [
                47.1509454,
                35.2494532
              ],
              [
                47.1648549,
                35.2671965
              ],
              [
                47.166152,
                35.2703905
              ],
              [
                47.1672849,
                35.2714381
              ],
              [
                47.1699427,
                35.2741035
              ],
              [
                47.1680478,
                35.2759933
              ],
              [
                47.1693006,
                35.2773655
              ],
              [
                47.1607684,
                35.2872591
              ],
              [
                47.1532381,
                35.2955019
              ],
              [
                47.1465514,
                35.3038184
              ],
              [
                47.151496,
                35.322253
              ],
              [
                47.1592462,
                35.3280465
              ],
              [
                47.1631101,
                35.3330694
              ],
              [
                47.1550906,
                35.3389724
              ],
              [
                47.1432061,
                35.3464589
              ],
              [
                47.1364047,
                35.3502392
              ],
              [
                47.129447,
                35.3549533
              ],
              [
                47.1173661,
                35.3606771
              ],
              [
                47.1133604,
                35.3624715
              ],
              [
                47.1206528,
                35.3723707
              ],
              [
                47.1272611,
                35.3769231
              ],
              [
                47.1359643,
                35.3837441
              ],
              [
                47.152199,
                35.3902512
              ],
              [
                47.1473914,
                35.4036452
              ],
              [
                47.1502543,
                35.4130177
              ],
              [
                47.1530081,
                35.4239479
              ],
              [
                47.1543974,
                35.4349635
              ],
              [
                47.1577311,
                35.4457934
              ],
              [
                47.1588509,
                35.4498314
              ],
              [
                47.1600782,
                35.4544257
              ],
              [
                47.1729295,
                35.4576034
              ],
              [
                47.1862033,
                35.4609226
              ],
              [
                47.1922353,
                35.4621649
              ],
              [
                47.1973307,
                35.4673781
              ],
              [
                47.2025325,
                35.4728023
              ],
              [
                47.2071627,
                35.4776069
              ],
              [
                47.2110489,
                35.481994
              ],
              [
                47.216263,
                35.4878657
              ],
              [
                47.2288176,
                35.497412
              ],
              [
                47.2306751,
                35.4998391
              ],
              [
                47.232749,
                35.5016271
              ],
              [
                47.2332326,
                35.502544
              ],
              [
                47.2382917,
                35.5086679
              ],
              [
                47.2440832,
                35.5155331
              ],
              [
                47.2536394,
                35.5258219
              ],
              [
                47.2599181,
                35.5375808
              ],
              [
                47.2684606,
                35.5496413
              ],
              [
                47.2773633,
                35.562238
              ],
              [
                47.2834617,
                35.5708755
              ],
              [
                47.2897597,
                35.5811779
              ],
              [
                47.3077075,
                35.5918493
              ],
              [
                47.3173936,
                35.6127421
              ],
              [
                47.3240672,
                35.6386909
              ],
              [
                47.3118807,
                35.6527935
              ],
              [
                47.3055012,
                35.653998
              ],
              [
                47.299387,
                35.6546531
              ],
              [
                47.2909171,
                35.6561769
              ],
              [
                47.2680883,
                35.6534353
              ],
              [
                47.2448912,
                35.648836
              ],
              [
                47.226824,
                35.6507129
              ],
              [
                47.1979951,
                35.6520309
              ],
              [
                47.1765803,
                35.6559713
              ],
              [
                47.1561526,
                35.6611319
              ],
              [
                47.1450469,
                35.673734
              ],
              [
                47.1331064,
                35.6867091
              ],
              [
                47.1137866,
                35.7012616
              ],
              [
                47.1135806,
                35.7157859
              ],
              [
                47.0963705,
                35.7137269
              ],
              [
                47.0835654,
                35.712191
              ],
              [
                47.0734759,
                35.7085795
              ],
              [
                47.0433479,
                35.6984712
              ],
              [
                47.0310063,
                35.6940205
              ],
              [
                47.0246001,
                35.6908114
              ],
              [
                47.0164903,
                35.6869223
              ],
              [
                47.0085583,
                35.6852486
              ],
              [
                47.0030074,
                35.6841739
              ],
              [
                46.9997301,
                35.6838247
              ],
              [
                46.9968916,
                35.6830218
              ],
              [
                46.9898986,
                35.6830956
              ],
              [
                46.9839407,
                35.6823402
              ],
              [
                46.9644084,
                35.682454
              ],
              [
                46.959422,
                35.6823943
              ],
              [
                46.9472006,
                35.6817503
              ],
              [
                46.94319,
                35.6812901
              ],
              [
                46.9328041,
                35.6804613
              ],
              [
                46.9262123,
                35.6797491
              ],
              [
                46.9172859,
                35.6819452
              ],
              [
                46.9089877,
                35.6854393
              ],
              [
                46.910076,
                35.6736136
              ],
              [
                46.9105052,
                35.6620384
              ],
              [
                46.9104597,
                35.6390894
              ],
              [
                46.9042985,
                35.6366032
              ],
              [
                46.8972529,
                35.6328055
              ],
              [
                46.8895339,
                35.6287733
              ],
              [
                46.8772028,
                35.6223237
              ],
              [
                46.8660886,
                35.6207542
              ],
              [
                46.8540417,
                35.6156889
              ],
              [
                46.8249847,
                35.6138266
              ],
              [
                46.7956497,
                35.6176229
              ],
              [
                46.7908869,
                35.6183811
              ],
              [
                46.7852913,
                35.6201951
              ],
              [
                46.7753771,
                35.6175579
              ],
              [
                46.7668678,
                35.6153616
              ],
              [
                46.7571952,
                35.6108603
              ],
              [
                46.7420933,
                35.6045166
              ],
              [
                46.7379706,
                35.6026337
              ],
              [
                46.725083,
                35.596911
              ],
              [
                46.7088007,
                35.5902879
              ],
              [
                46.7003034,
                35.5866669
              ],
              [
                46.7234443,
                35.5676288
              ],
              [
                46.7344306,
                35.5581331
              ],
              [
                46.7325503,
                35.5564997
              ],
              [
                46.7346925,
                35.5542367
              ],
              [
                46.7155048,
                35.5482391
              ],
              [
                46.7039661,
                35.5427221
              ],
              [
                46.6765349,
                35.5290042
              ],
              [
                46.6597038,
                35.5064122
              ],
              [
                46.6436424,
                35.4935381
              ],
              [
                46.6340874,
                35.4892258
              ],
              [
                46.6194284,
                35.4834012
              ],
              [
                46.613016,
                35.4819898
              ],
              [
                46.6052055,
                35.4756993
              ],
              [
                46.5994977,
                35.4452184
              ],
              [
                46.5399179,
                35.418492
              ],
              [
                46.5345442,
                35.4072435
              ],
              [
                46.5312781,
                35.4005279
              ],
              [
                46.5294263,
                35.3937053
              ],
              [
                46.5261047,
                35.384952
              ],
              [
                46.5247272,
                35.3813205
              ],
              [
                46.5222387,
                35.3764453
              ],
              [
                46.518574,
                35.3673951
              ],
              [
                46.5133312,
                35.3557063
              ],
              [
                46.4997899,
                35.3596267
              ],
              [
                46.4863661,
                35.3592206
              ],
              [
                46.4788645,
                35.3603336
              ],
              [
                46.4492033,
                35.364589
              ],
              [
                46.4423283,
                35.3645471
              ],
              [
                46.4361227,
                35.3596053
              ],
              [
                46.4317368,
                35.3456675
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555149,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قروه",
          "name:en": "Ghorveh County",
          "name:ku": "Qurwe",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282057"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.4175134,
                35.2147768
              ],
              [
                47.4175312,
                35.2012529
              ],
              [
                47.42113,
                35.1926348
              ],
              [
                47.4202613,
                35.1873984
              ],
              [
                47.4196387,
                35.1854033
              ],
              [
                47.4192617,
                35.1825587
              ],
              [
                47.418691,
                35.1784849
              ],
              [
                47.4226055,
                35.1773628
              ],
              [
                47.4240135,
                35.1781269
              ],
              [
                47.456027,
                35.1617049
              ],
              [
                47.466848,
                35.1590813
              ],
              [
                47.4742767,
                35.1558328
              ],
              [
                47.4774669,
                35.1550691
              ],
              [
                47.480932,
                35.1546129
              ],
              [
                47.4893143,
                35.1496944
              ],
              [
                47.4917676,
                35.1479133
              ],
              [
                47.4941404,
                35.1457421
              ],
              [
                47.5044692,
                35.1361698
              ],
              [
                47.5053292,
                35.1354755
              ],
              [
                47.5077648,
                35.1315688
              ],
              [
                47.5079189,
                35.1310104
              ],
              [
                47.5104219,
                35.1256421
              ],
              [
                47.510479,
                35.1250202
              ],
              [
                47.510524,
                35.1247413
              ],
              [
                47.510693,
                35.1246693
              ],
              [
                47.5109116,
                35.1244065
              ],
              [
                47.5125641,
                35.1225319
              ],
              [
                47.5133014,
                35.1214769
              ],
              [
                47.515661,
                35.1175979
              ],
              [
                47.5185707,
                35.1126646
              ],
              [
                47.5232084,
                35.103036
              ],
              [
                47.5231611,
                35.1017269
              ],
              [
                47.5234411,
                35.0917216
              ],
              [
                47.5234869,
                35.0890563
              ],
              [
                47.5184447,
                35.0817857
              ],
              [
                47.5150911,
                35.0793804
              ],
              [
                47.5051247,
                35.0682052
              ],
              [
                47.5236793,
                35.0637669
              ],
              [
                47.5373016,
                35.0639228
              ],
              [
                47.5432825,
                35.0673527
              ],
              [
                47.5485236,
                35.069453
              ],
              [
                47.5598124,
                35.0710519
              ],
              [
                47.5658435,
                35.0708654
              ],
              [
                47.5685706,
                35.0715242
              ],
              [
                47.5758299,
                35.0714453
              ],
              [
                47.5805981,
                35.0717827
              ],
              [
                47.5835656,
                35.0720255
              ],
              [
                47.5868096,
                35.0724283
              ],
              [
                47.5927645,
                35.0728805
              ],
              [
                47.6012522,
                35.0724866
              ],
              [
                47.6068405,
                35.0717782
              ],
              [
                47.6099675,
                35.0716298
              ],
              [
                47.6120635,
                35.0716071
              ],
              [
                47.6148154,
                35.071688
              ],
              [
                47.6187599,
                35.0714568
              ],
              [
                47.6204343,
                35.0711604
              ],
              [
                47.624536,
                35.0706644
              ],
              [
                47.631536,
                35.0702348
              ],
              [
                47.6382091,
                35.0703052
              ],
              [
                47.6471333,
                35.0668953
              ],
              [
                47.6545634,
                35.065645
              ],
              [
                47.6629571,
                35.0649778
              ],
              [
                47.6657855,
                35.0647184
              ],
              [
                47.6666248,
                35.0645663
              ],
              [
                47.6745879,
                35.0632576
              ],
              [
                47.6827871,
                35.0605787
              ],
              [
                47.6909124,
                35.0579526
              ],
              [
                47.6914726,
                35.0577012
              ],
              [
                47.7014774,
                35.057709
              ],
              [
                47.7023027,
                35.0580228
              ],
              [
                47.7044974,
                35.0580174
              ],
              [
                47.707848,
                35.0585577
              ],
              [
                47.7087165,
                35.0588855
              ],
              [
                47.7097548,
                35.0588353
              ],
              [
                47.7114923,
                35.0594205
              ],
              [
                47.7209811,
                35.0624692
              ],
              [
                47.7227645,
                35.06246
              ],
              [
                47.7236017,
                35.0627673
              ],
              [
                47.725582,
                35.0627369
              ],
              [
                47.7261522,
                35.0624638
              ],
              [
                47.7272307,
                35.0624615
              ],
              [
                47.7275647,
                35.0621909
              ],
              [
                47.7286935,
                35.062194
              ],
              [
                47.7301146,
                35.061439
              ],
              [
                47.7311069,
                35.0605149
              ],
              [
                47.7331741,
                35.0562333
              ],
              [
                47.736844,
                35.0518469
              ],
              [
                47.7457091,
                35.0473936
              ],
              [
                47.7537781,
                35.0460016
              ],
              [
                47.7541762,
                35.0459434
              ],
              [
                47.7624092,
                35.0447168
              ],
              [
                47.7657599,
                35.0436287
              ],
              [
                47.7683729,
                35.0414994
              ],
              [
                47.7717957,
                35.0386575
              ],
              [
                47.7769607,
                35.0343965
              ],
              [
                47.7777883,
                35.0329462
              ],
              [
                47.7899933,
                35.0222065
              ],
              [
                47.7901863,
                35.0218899
              ],
              [
                47.7910904,
                35.0219162
              ],
              [
                47.8030414,
                35.0149562
              ],
              [
                47.8038746,
                35.0138376
              ],
              [
                47.8041512,
                35.0130078
              ],
              [
                47.8055414,
                35.0116186
              ],
              [
                47.8105412,
                35.0021739
              ],
              [
                47.8108212,
                35.001344
              ],
              [
                47.8110978,
                35.0003247
              ],
              [
                47.8113745,
                34.9993955
              ],
              [
                47.8113744,
                34.9988453
              ],
              [
                47.8094314,
                34.9977267
              ],
              [
                47.8060982,
                34.9888412
              ],
              [
                47.8052645,
                34.9849533
              ],
              [
                47.8052646,
                34.980515
              ],
              [
                47.813598,
                34.9696809
              ],
              [
                47.8144312,
                34.968012
              ],
              [
                47.8322113,
                34.945225
              ],
              [
                47.8399878,
                34.938838
              ],
              [
                47.858601,
                34.9332901
              ],
              [
                47.8599874,
                34.9327307
              ],
              [
                47.8605444,
                34.9327308
              ],
              [
                47.8608209,
                34.9324511
              ],
              [
                47.8613776,
                34.9324511
              ],
              [
                47.8616577,
                34.9321714
              ],
              [
                47.8624909,
                34.9321714
              ],
              [
                47.8627675,
                34.9318918
              ],
              [
                47.8805472,
                34.9271737
              ],
              [
                47.8833238,
                34.9271737
              ],
              [
                47.8836008,
                34.926894
              ],
              [
                47.8899907,
                34.9268941
              ],
              [
                47.8911005,
                34.9271738
              ],
              [
                47.8941572,
                34.9271737
              ],
              [
                47.8952669,
                34.9274534
              ],
              [
                47.8969338,
                34.9274534
              ],
              [
                47.8980471,
                34.9277331
              ],
              [
                47.899437,
                34.9277331
              ],
              [
                47.9002707,
                34.9280127
              ],
              [
                47.9183268,
                34.9335608
              ],
              [
                47.919437,
                34.9335608
              ],
              [
                47.9223534,
                34.9345351
              ],
              [
                47.9219366,
                34.9352298
              ],
              [
                47.9219367,
                34.9357891
              ],
              [
                47.9216601,
                34.9360687
              ],
              [
                47.92138,
                34.9371694
              ],
              [
                47.9199937,
                34.9407868
              ],
              [
                47.9197136,
                34.9430059
              ],
              [
                47.9199937,
                34.9449455
              ],
              [
                47.9227703,
                34.9518918
              ],
              [
                47.9527696,
                34.9705112
              ],
              [
                47.9558263,
                34.9705112
              ],
              [
                47.9561064,
                34.9702315
              ],
              [
                47.9572162,
                34.9702315
              ],
              [
                47.9719396,
                34.9646746
              ],
              [
                47.9999871,
                34.9612717
              ],
              [
                48.0055524,
                34.9707819
              ],
              [
                48.0180522,
                34.9782874
              ],
              [
                48.0322185,
                34.9832849
              ],
              [
                48.0327751,
                34.9835646
              ],
              [
                48.0333319,
                34.9835646
              ],
              [
                48.040832,
                34.9860633
              ],
              [
                48.043052,
                34.9860633
              ],
              [
                48.0436085,
                34.9857837
              ],
              [
                48.0441653,
                34.9857837
              ],
              [
                48.0444418,
                34.9855041
              ],
              [
                48.045275,
                34.9855041
              ],
              [
                48.0477751,
                34.9843945
              ],
              [
                48.0491649,
                34.983285
              ],
              [
                48.058055,
                34.9749497
              ],
              [
                48.058055,
                34.9743994
              ],
              [
                48.0636083,
                34.9685629
              ],
              [
                48.0730549,
                34.9618964
              ],
              [
                48.0741647,
                34.9618964
              ],
              [
                48.0744448,
                34.9616167
              ],
              [
                48.0797215,
                34.9616167
              ],
              [
                48.0799981,
                34.9613371
              ],
              [
                48.081388,
                34.9613371
              ],
              [
                48.0816648,
                34.9616168
              ],
              [
                48.0858314,
                34.9616168
              ],
              [
                48.0861114,
                34.9618965
              ],
              [
                48.0874978,
                34.9621761
              ],
              [
                48.0886116,
                34.9621761
              ],
              [
                48.1033345,
                34.9710617
              ],
              [
                48.1058345,
                34.9721804
              ],
              [
                48.1091678,
                34.9730104
              ],
              [
                48.1105576,
                34.9730104
              ],
              [
                48.1116679,
                34.97329
              ],
              [
                48.1144445,
                34.97329
              ],
              [
                48.1147245,
                34.9730103
              ],
              [
                48.1161108,
                34.9730104
              ],
              [
                48.1213911,
                34.9716211
              ],
              [
                48.1286143,
                34.9705115
              ],
              [
                48.1291673,
                34.9702319
              ],
              [
                48.1311143,
                34.9702319
              ],
              [
                48.1352808,
                34.9688427
              ],
              [
                48.1363906,
                34.9688426
              ],
              [
                48.1372242,
                34.968563
              ],
              [
                48.138614,
                34.9685631
              ],
              [
                48.1391673,
                34.9685631
              ],
              [
                48.1438907,
                34.9707822
              ],
              [
                48.1441674,
                34.9710619
              ],
              [
                48.1502807,
                34.977178
              ],
              [
                48.1513906,
                34.9816163
              ],
              [
                48.1563906,
                34.988842
              ],
              [
                48.1727804,
                34.9960677
              ],
              [
                48.173337,
                34.9960678
              ],
              [
                48.1758366,
                34.9988461
              ],
              [
                48.1758367,
                35.0021747
              ],
              [
                48.1766702,
                35.0080111
              ],
              [
                48.1772269,
                35.0116194
              ],
              [
                48.1780601,
                35.0146774
              ],
              [
                48.1855597,
                35.0560724
              ],
              [
                48.1861163,
                35.0582914
              ],
              [
                48.1863934,
                35.0588417
              ],
              [
                48.1872265,
                35.06079
              ],
              [
                48.1875031,
                35.0655076
              ],
              [
                48.1875031,
                35.0668968
              ],
              [
                48.1908363,
                35.0793988
              ],
              [
                48.1922262,
                35.0927395
              ],
              [
                48.1919496,
                35.0932897
              ],
              [
                48.1916694,
                35.0952381
              ],
              [
                48.1913929,
                35.096068
              ],
              [
                48.1888928,
                35.101065
              ],
              [
                48.1886163,
                35.1021745
              ],
              [
                48.1850029,
                35.1063417
              ],
              [
                48.1830599,
                35.1069009
              ],
              [
                48.1822263,
                35.1069009
              ],
              [
                48.1794465,
                35.106901
              ],
              [
                48.1727799,
                35.106901
              ],
              [
                48.1722265,
                35.1071805
              ],
              [
                48.1677798,
                35.1071805
              ],
              [
                48.1672268,
                35.1074601
              ],
              [
                48.1661135,
                35.1074601
              ],
              [
                48.1605567,
                35.1091198
              ],
              [
                48.15528,
                35.113296
              ],
              [
                48.1547234,
                35.1144055
              ],
              [
                48.1536135,
                35.115515
              ],
              [
                48.1525034,
                35.1180134
              ],
              [
                48.1563902,
                35.1263478
              ],
              [
                48.15778,
                35.1288462
              ],
              [
                48.1591699,
                35.1313448
              ],
              [
                48.1597234,
                35.1335636
              ],
              [
                48.1783363,
                35.1532897
              ],
              [
                48.1808363,
                35.1599552
              ],
              [
                48.1813929,
                35.1610646
              ],
              [
                48.1812528,
                35.1637073
              ],
              [
                48.1811128,
                35.1652316
              ],
              [
                48.1777796,
                35.1699579
              ],
              [
                48.1775372,
                35.1707979
              ],
              [
                48.1758361,
                35.1727359
              ],
              [
                48.1613897,
                35.1844071
              ],
              [
                48.1544464,
                35.2038526
              ],
              [
                48.1506136,
                35.2098726
              ],
              [
                48.1490576,
                35.2116498
              ],
              [
                48.139723,
                35.2221796
              ],
              [
                48.1269467,
                35.2285741
              ],
              [
                48.1225,
                35.2285741
              ],
              [
                48.1216669,
                35.2288537
              ],
              [
                48.1197234,
                35.2288537
              ],
              [
                48.1094435,
                35.2269055
              ],
              [
                48.1088904,
                35.226626
              ],
              [
                48.1050005,
                35.2266259
              ],
              [
                48.0988871,
                35.2271761
              ],
              [
                48.0980538,
                35.2271761
              ],
              [
                48.0972203,
                35.227176
              ],
              [
                48.096387,
                35.2277353
              ],
              [
                48.0961104,
                35.2280148
              ],
              [
                48.0958339,
                35.2282944
              ],
              [
                48.0963869,
                35.2305131
              ],
              [
                48.096387,
                35.2307927
              ],
              [
                48.0980537,
                35.2424633
              ],
              [
                48.0922203,
                35.2591302
              ],
              [
                48.0919438,
                35.2610693
              ],
              [
                48.0897204,
                35.2694025
              ],
              [
                48.0894437,
                35.2696822
              ],
              [
                48.0874968,
                35.2727395
              ],
              [
                48.0717073,
                35.291857
              ],
              [
                48.0639713,
                35.3014993
              ],
              [
                48.0637644,
                35.3019368
              ],
              [
                48.0568396,
                35.3166275
              ],
              [
                48.055256,
                35.3199001
              ],
              [
                48.0552784,
                35.3204408
              ],
              [
                48.0547159,
                35.3222471
              ],
              [
                48.0465236,
                35.3366308
              ],
              [
                48.0344691,
                35.3579606
              ],
              [
                48.0339083,
                35.3596764
              ],
              [
                48.0341885,
                35.3615733
              ],
              [
                48.0341478,
                35.3628644
              ],
              [
                48.0267081,
                35.3707768
              ],
              [
                48.023591,
                35.3721644
              ],
              [
                48.0233978,
                35.3724469
              ],
              [
                48.0224515,
                35.3724601
              ],
              [
                48.0219343,
                35.3727596
              ],
              [
                48.0209008,
                35.3727196
              ],
              [
                48.0203744,
                35.3729977
              ],
              [
                48.0138771,
                35.3730239
              ],
              [
                48.0136249,
                35.3727871
              ],
              [
                48.0114255,
                35.372695
              ],
              [
                48.0111462,
                35.3724503
              ],
              [
                48.0094141,
                35.3724486
              ],
              [
                48.0063889,
                35.3718899
              ],
              [
                48.006114,
                35.3716197
              ],
              [
                48.0035665,
                35.3715979
              ],
              [
                48.0021924,
                35.3713434
              ],
              [
                47.9999305,
                35.3691808
              ],
              [
                47.9974921,
                35.3680307
              ],
              [
                47.9855786,
                35.3705494
              ],
              [
                47.9852116,
                35.3707884
              ],
              [
                47.98478,
                35.3707754
              ],
              [
                47.9845319,
                35.3710847
              ],
              [
                47.982954,
                35.3710341
              ],
              [
                47.9805196,
                35.3716773
              ],
              [
                47.9802669,
                35.3718967
              ],
              [
                47.9786343,
                35.3721011
              ],
              [
                47.9768647,
                35.3725322
              ],
              [
                47.9634036,
                35.3758051
              ],
              [
                47.9629014,
                35.3760204
              ],
              [
                47.9622,
                35.3760806
              ],
              [
                47.9605446,
                35.376615
              ],
              [
                47.954468,
                35.3794286
              ],
              [
                47.9446874,
                35.3897206
              ],
              [
                47.9414672,
                35.3948612
              ],
              [
                47.9405738,
                35.3960637
              ],
              [
                47.9389714,
                35.3996633
              ],
              [
                47.9366179,
                35.4050941
              ],
              [
                47.9327526,
                35.4172661
              ],
              [
                47.9294172,
                35.426621
              ],
              [
                47.9274927,
                35.4319791
              ],
              [
                47.9214704,
                35.4401868
              ],
              [
                47.9192454,
                35.4432204
              ],
              [
                47.9170234,
                35.4461009
              ],
              [
                47.9158527,
                35.4477699
              ],
              [
                47.9152361,
                35.4480602
              ],
              [
                47.9150042,
                35.4485338
              ],
              [
                47.9088678,
                35.4535664
              ],
              [
                47.9053066,
                35.4577055
              ],
              [
                47.902856,
                35.462245
              ],
              [
                47.9019263,
                35.4638378
              ],
              [
                47.9020276,
                35.4645399
              ],
              [
                47.9016929,
                35.4647273
              ],
              [
                47.8959432,
                35.4849721
              ],
              [
                47.8939184,
                35.4933252
              ],
              [
                47.8875867,
                35.5063575
              ],
              [
                47.8872237,
                35.5065394
              ],
              [
                47.8861471,
                35.5083135
              ],
              [
                47.8861164,
                35.5089453
              ],
              [
                47.8855375,
                35.510383
              ],
              [
                47.8855726,
                35.5137052
              ],
              [
                47.8856144,
                35.5169117
              ],
              [
                47.8851092,
                35.5174392
              ],
              [
                47.8835232,
                35.522066
              ],
              [
                47.8829201,
                35.5226892
              ],
              [
                47.8815442,
                35.5255306
              ],
              [
                47.8802673,
                35.5273133
              ],
              [
                47.8797743,
                35.5284477
              ],
              [
                47.8781507,
                35.5332846
              ],
              [
                47.8778965,
                35.5352344
              ],
              [
                47.8784626,
                35.5410001
              ],
              [
                47.8808889,
                35.5457386
              ],
              [
                47.8823817,
                35.5486643
              ],
              [
                47.8826164,
                35.5491834
              ],
              [
                47.8805647,
                35.5611842
              ],
              [
                47.8851708,
                35.5661705
              ],
              [
                47.8687553,
                35.5693421
              ],
              [
                47.8591186,
                35.5708818
              ],
              [
                47.8523763,
                35.5719486
              ],
              [
                47.8369893,
                35.5734734
              ],
              [
                47.8275142,
                35.5748944
              ],
              [
                47.8105292,
                35.5754145
              ],
              [
                47.795552,
                35.5762229
              ],
              [
                47.7781319,
                35.5771031
              ],
              [
                47.7700263,
                35.5773045
              ],
              [
                47.7624738,
                35.5779524
              ],
              [
                47.754695,
                35.578979
              ],
              [
                47.743012,
                35.5826918
              ],
              [
                47.7348905,
                35.5829494
              ],
              [
                47.7323243,
                35.5723355
              ],
              [
                47.725755,
                35.5594829
              ],
              [
                47.7236845,
                35.5545452
              ],
              [
                47.7280888,
                35.5456641
              ],
              [
                47.747427,
                35.5063217
              ],
              [
                47.7214641,
                35.4746987
              ],
              [
                47.6669112,
                35.4606533
              ],
              [
                47.6403453,
                35.4661182
              ],
              [
                47.6271827,
                35.4685203
              ],
              [
                47.613721,
                35.4711023
              ],
              [
                47.5998228,
                35.473692
              ],
              [
                47.5869387,
                35.4761545
              ],
              [
                47.5573682,
                35.4815704
              ],
              [
                47.5566742,
                35.4804275
              ],
              [
                47.5581467,
                35.4628339
              ],
              [
                47.5590509,
                35.4536076
              ],
              [
                47.5625851,
                35.4118872
              ],
              [
                47.6052062,
                35.3987954
              ],
              [
                47.6075461,
                35.3794162
              ],
              [
                47.5880726,
                35.3650227
              ],
              [
                47.5822114,
                35.3598643
              ],
              [
                47.5750235,
                35.3529552
              ],
              [
                47.574016,
                35.3523648
              ],
              [
                47.5662188,
                35.3456121
              ],
              [
                47.5596851,
                35.3399318
              ],
              [
                47.5597225,
                35.3393999
              ],
              [
                47.5583306,
                35.3365942
              ],
              [
                47.5570188,
                35.3316096
              ],
              [
                47.5524957,
                35.3138798
              ],
              [
                47.5472277,
                35.3066543
              ],
              [
                47.5431981,
                35.3026537
              ],
              [
                47.5387866,
                35.2982738
              ],
              [
                47.5374953,
                35.2966245
              ],
              [
                47.5366429,
                35.2949241
              ],
              [
                47.5355804,
                35.2929063
              ],
              [
                47.5323492,
                35.2867618
              ],
              [
                47.5311563,
                35.284484
              ],
              [
                47.5308204,
                35.2828608
              ],
              [
                47.5308445,
                35.2761488
              ],
              [
                47.53054,
                35.2757744
              ],
              [
                47.5285695,
                35.2660739
              ],
              [
                47.5271432,
                35.2633153
              ],
              [
                47.5252182,
                35.2605261
              ],
              [
                47.5208124,
                35.2554168
              ],
              [
                47.5158723,
                35.2511945
              ],
              [
                47.5149696,
                35.2503645
              ],
              [
                47.5145775,
                35.2494014
              ],
              [
                47.5098096,
                35.2414319
              ],
              [
                47.5041517,
                35.2321094
              ],
              [
                47.5002751,
                35.2258398
              ],
              [
                47.4981711,
                35.2219817
              ],
              [
                47.4979232,
                35.2217019
              ],
              [
                47.4974524,
                35.2206952
              ],
              [
                47.4969861,
                35.2194295
              ],
              [
                47.4963307,
                35.2161188
              ],
              [
                47.4966119,
                35.2116517
              ],
              [
                47.4978049,
                35.2080119
              ],
              [
                47.4864972,
                35.2066621
              ],
              [
                47.4791379,
                35.2060699
              ],
              [
                47.4695812,
                35.2052476
              ],
              [
                47.4669107,
                35.2066756
              ],
              [
                47.4591248,
                35.2089382
              ],
              [
                47.4544541,
                35.2096297
              ],
              [
                47.4481899,
                35.210255
              ],
              [
                47.4175134,
                35.2147768
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555163,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کامیاران",
          "name:en": "Kamyaran County",
          "name:ku": "Kamyaran",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282070",
          "wikipedia": "en:Kamyaran County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.5253468,
                35.0411294
              ],
              [
                46.524016,
                35.0350051
              ],
              [
                46.5264879,
                35.0295864
              ],
              [
                46.529655,
                35.0264237
              ],
              [
                46.5320755,
                35.0203718
              ],
              [
                46.5326162,
                35.0081192
              ],
              [
                46.5315347,
                34.9994295
              ],
              [
                46.5305563,
                34.992321
              ],
              [
                46.53128,
                34.9872983
              ],
              [
                46.5348445,
                34.9836719
              ],
              [
                46.5416391,
                34.9752628
              ],
              [
                46.548171,
                34.9673858
              ],
              [
                46.5551662,
                34.9620752
              ],
              [
                46.5544366,
                34.9575029
              ],
              [
                46.5524196,
                34.9546539
              ],
              [
                46.5495014,
                34.9518048
              ],
              [
                46.5468255,
                34.9508431
              ],
              [
                46.5427247,
                34.9519705
              ],
              [
                46.5396085,
                34.9469968
              ],
              [
                46.5391555,
                34.9449356
              ],
              [
                46.5367324,
                34.9432113
              ],
              [
                46.5321421,
                34.9405481
              ],
              [
                46.5286315,
                34.9345182
              ],
              [
                46.5290598,
                34.9328682
              ],
              [
                46.5292195,
                34.9317859
              ],
              [
                46.531906,
                34.9299231
              ],
              [
                46.5347904,
                34.9287532
              ],
              [
                46.5374395,
                34.9285728
              ],
              [
                46.5415461,
                34.9264755
              ],
              [
                46.5452956,
                34.9220415
              ],
              [
                46.5477599,
                34.9199799
              ],
              [
                46.5468406,
                34.9181707
              ],
              [
                46.5440346,
                34.9146662
              ],
              [
                46.5431499,
                34.9122587
              ],
              [
                46.5431499,
                34.9101472
              ],
              [
                46.5448665,
                34.9074725
              ],
              [
                46.5462398,
                34.9060647
              ],
              [
                46.5495013,
                34.9015949
              ],
              [
                46.5506387,
                34.8999758
              ],
              [
                46.5529775,
                34.897864
              ],
              [
                46.5561103,
                34.8956465
              ],
              [
                46.5611958,
                34.8937985
              ],
              [
                46.5623545,
                34.8928657
              ],
              [
                46.563878,
                34.8921617
              ],
              [
                46.5664744,
                34.8919681
              ],
              [
                46.5679121,
                34.8920737
              ],
              [
                46.5691781,
                34.8914577
              ],
              [
                46.5701651,
                34.890824
              ],
              [
                46.5708518,
                34.8898736
              ],
              [
                46.5731263,
                34.88968
              ],
              [
                46.5802502,
                34.8888352
              ],
              [
                46.5842199,
                34.8881839
              ],
              [
                46.5865389,
                34.8873241
              ],
              [
                46.5891981,
                34.8878671
              ],
              [
                46.5915155,
                34.8877615
              ],
              [
                46.5950775,
                34.8853325
              ],
              [
                46.5978241,
                34.88403
              ],
              [
                46.601901,
                34.8804391
              ],
              [
                46.6088104,
                34.8756862
              ],
              [
                46.611307,
                34.8745316
              ],
              [
                46.6133021,
                34.8725809
              ],
              [
                46.6170798,
                34.870475
              ],
              [
                46.6227475,
                34.8668511
              ],
              [
                46.6286674,
                34.8615275
              ],
              [
                46.6324938,
                34.8611519
              ],
              [
                46.6347312,
                34.8634331
              ],
              [
                46.6369199,
                34.864419
              ],
              [
                46.6394519,
                34.8659684
              ],
              [
                46.6427993,
                34.8693838
              ],
              [
                46.6446018,
                34.8693838
              ],
              [
                46.6516828,
                34.8660388
              ],
              [
                46.6583347,
                34.8635387
              ],
              [
                46.6598367,
                34.8624471
              ],
              [
                46.6626691,
                34.8612499
              ],
              [
                46.666789,
                34.8588201
              ],
              [
                46.6694068,
                34.8587497
              ],
              [
                46.6715526,
                34.8597709
              ],
              [
                46.6758871,
                34.8585032
              ],
              [
                46.6815948,
                34.8580806
              ],
              [
                46.6935682,
                34.8502273
              ],
              [
                46.7037204,
                34.8430064
              ],
              [
                46.7136526,
                34.8365614
              ],
              [
                46.7179685,
                34.8329954
              ],
              [
                46.7186972,
                34.8282178
              ],
              [
                46.7232755,
                34.8230268
              ],
              [
                46.7244939,
                34.8207874
              ],
              [
                46.7294164,
                34.8119864
              ],
              [
                46.7250318,
                34.8075361
              ],
              [
                46.729243,
                34.8002393
              ],
              [
                46.7325782,
                34.7922374
              ],
              [
                46.7384147,
                34.7821572
              ],
              [
                46.7440795,
                34.7687268
              ],
              [
                46.7467832,
                34.7630156
              ],
              [
                46.7545938,
                34.7567046
              ],
              [
                46.7601728,
                34.7532139
              ],
              [
                46.7627477,
                34.7530376
              ],
              [
                46.7592113,
                34.7497603
              ],
              [
                46.7718337,
                34.7442334
              ],
              [
                46.7872969,
                34.7369983
              ],
              [
                46.7879819,
                34.7365695
              ],
              [
                46.8134737,
                34.7427057
              ],
              [
                46.8240737,
                34.7457737
              ],
              [
                46.8350263,
                34.7497122
              ],
              [
                46.846242,
                34.7508053
              ],
              [
                46.8545436,
                34.7535665
              ],
              [
                46.8593869,
                34.7555045
              ],
              [
                46.8695424,
                34.7595406
              ],
              [
                46.8760409,
                34.7609395
              ],
              [
                46.8807989,
                34.7613978
              ],
              [
                46.8825377,
                34.7628057
              ],
              [
                46.8920458,
                34.7657144
              ],
              [
                46.9006733,
                34.7647073
              ],
              [
                46.9036182,
                34.7636315
              ],
              [
                46.9096899,
                34.7614819
              ],
              [
                46.9153496,
                34.7592081
              ],
              [
                46.9215258,
                34.7566486
              ],
              [
                46.9268807,
                34.7545217
              ],
              [
                46.9333015,
                34.7546801
              ],
              [
                46.9420588,
                34.757378
              ],
              [
                46.9436283,
                34.7598415
              ],
              [
                46.9440381,
                34.7640098
              ],
              [
                46.9439765,
                34.7661362
              ],
              [
                46.948591,
                34.7694309
              ],
              [
                46.9613492,
                34.766137
              ],
              [
                46.9699352,
                34.7644071
              ],
              [
                46.9775399,
                34.7645426
              ],
              [
                46.991447,
                34.7656532
              ],
              [
                46.9998194,
                34.7627932
              ],
              [
                47.0035211,
                34.7606258
              ],
              [
                47.0071727,
                34.7575501
              ],
              [
                47.0111285,
                34.7557118
              ],
              [
                47.0144676,
                34.7550511
              ],
              [
                47.0164697,
                34.7540265
              ],
              [
                47.0200124,
                34.7533135
              ],
              [
                47.0262448,
                34.7537631
              ],
              [
                47.0296746,
                34.752086
              ],
              [
                47.0363545,
                34.7500933
              ],
              [
                47.0371055,
                34.7495996
              ],
              [
                47.042986,
                34.7476042
              ],
              [
                47.0504093,
                34.7500051
              ],
              [
                47.0515251,
                34.7507809
              ],
              [
                47.0541644,
                34.7539896
              ],
              [
                47.0548939,
                34.755065
              ],
              [
                47.0549369,
                34.7560522
              ],
              [
                47.05307,
                34.7583264
              ],
              [
                47.0502591,
                34.7594722
              ],
              [
                47.0480275,
                34.7601069
              ],
              [
                47.0448518,
                34.7610412
              ],
              [
                47.0431566,
                34.7618168
              ],
              [
                47.0431995,
                34.7626629
              ],
              [
                47.0446372,
                34.7641084
              ],
              [
                47.045648,
                34.7658906
              ],
              [
                47.0451307,
                34.7679512
              ],
              [
                47.0456944,
                34.769548
              ],
              [
                47.046682,
                34.7710163
              ],
              [
                47.0489747,
                34.774962
              ],
              [
                47.0524263,
                34.7769403
              ],
              [
                47.0559006,
                34.7780289
              ],
              [
                47.0598805,
                34.7790464
              ],
              [
                47.0623797,
                34.7804562
              ],
              [
                47.0633268,
                34.7817165
              ],
              [
                47.0635628,
                34.7828445
              ],
              [
                47.0627208,
                34.7841688
              ],
              [
                47.0604647,
                34.7866327
              ],
              [
                47.059483,
                34.789542
              ],
              [
                47.0581939,
                34.7913042
              ],
              [
                47.0636734,
                34.7935037
              ],
              [
                47.0660778,
                34.7944048
              ],
              [
                47.0688021,
                34.7950582
              ],
              [
                47.0709073,
                34.7954652
              ],
              [
                47.0750212,
                34.7957707
              ],
              [
                47.0794351,
                34.795971
              ],
              [
                47.0847201,
                34.7965897
              ],
              [
                47.0878598,
                34.7969269
              ],
              [
                47.0911502,
                34.7972975
              ],
              [
                47.0942154,
                34.7981785
              ],
              [
                47.0976922,
                34.7990573
              ],
              [
                47.1004057,
                34.8010829
              ],
              [
                47.1053706,
                34.7990287
              ],
              [
                47.110435,
                34.7989284
              ],
              [
                47.1126957,
                34.7979418
              ],
              [
                47.1140243,
                34.7966004
              ],
              [
                47.1169516,
                34.7950976
              ],
              [
                47.119521,
                34.7946258
              ],
              [
                47.1215272,
                34.7952005
              ],
              [
                47.1236596,
                34.7959226
              ],
              [
                47.1259326,
                34.7966248
              ],
              [
                47.1288631,
                34.7968412
              ],
              [
                47.1318948,
                34.7979817
              ],
              [
                47.1324874,
                34.7982923
              ],
              [
                47.1336222,
                34.7988628
              ],
              [
                47.1366906,
                34.7987923
              ],
              [
                47.1395311,
                34.7994244
              ],
              [
                47.1405759,
                34.7998757
              ],
              [
                47.1404028,
                34.8012238
              ],
              [
                47.139008,
                34.8033734
              ],
              [
                47.13727,
                34.8045891
              ],
              [
                47.1361542,
                34.8059282
              ],
              [
                47.134459,
                34.8056815
              ],
              [
                47.1319914,
                34.8061748
              ],
              [
                47.1299958,
                34.8068972
              ],
              [
                47.128365,
                34.8088704
              ],
              [
                47.1280432,
                34.8108965
              ],
              [
                47.1272063,
                34.8115307
              ],
              [
                47.1245241,
                34.8140852
              ],
              [
                47.1236872,
                34.8160759
              ],
              [
                47.1241593,
                34.818137
              ],
              [
                47.1237945,
                34.8198457
              ],
              [
                47.1212625,
                34.821026
              ],
              [
                47.1189022,
                34.8226114
              ],
              [
                47.1166277,
                34.8237035
              ],
              [
                47.1161341,
                34.8236859
              ],
              [
                47.1115422,
                34.8207794
              ],
              [
                47.1092891,
                34.820709
              ],
              [
                47.1018218,
                34.8226114
              ],
              [
                47.0991611,
                34.8228933
              ],
              [
                47.0945262,
                34.8293754
              ],
              [
                47.0885181,
                34.8411404
              ],
              [
                47.0835828,
                34.8514599
              ],
              [
                47.0800209,
                34.8605104
              ],
              [
                47.0758151,
                34.8677641
              ],
              [
                47.0720815,
                34.8766368
              ],
              [
                47.0710676,
                34.8834557
              ],
              [
                47.072095,
                34.883975
              ],
              [
                47.0719635,
                34.8847252
              ],
              [
                47.0701932,
                34.8872863
              ],
              [
                47.068895,
                34.889328
              ],
              [
                47.0690668,
                34.8902696
              ],
              [
                47.0697962,
                34.8910793
              ],
              [
                47.0702898,
                34.8917041
              ],
              [
                47.0710408,
                34.8921881
              ],
              [
                47.07574,
                34.8937193
              ],
              [
                47.0766734,
                34.8933937
              ],
              [
                47.0790874,
                34.8933057
              ],
              [
                47.0799887,
                34.8933057
              ],
              [
                47.0807933,
                34.8934641
              ],
              [
                47.0841407,
                34.8943793
              ],
              [
                47.0907497,
                34.8919857
              ],
              [
                47.0969295,
                34.8919857
              ],
              [
                47.0988177,
                34.8927601
              ],
              [
                47.1009635,
                34.8951537
              ],
              [
                47.1029376,
                34.8963505
              ],
              [
                47.1060815,
                34.898268
              ],
              [
                47.1078132,
                34.8991303
              ],
              [
                47.1088638,
                34.9006595
              ],
              [
                47.1097571,
                34.9025513
              ],
              [
                47.1105148,
                34.9041772
              ],
              [
                47.1112842,
                34.9047755
              ],
              [
                47.1150491,
                34.9036335
              ],
              [
                47.1227675,
                34.9000084
              ],
              [
                47.127144,
                34.8984968
              ],
              [
                47.1311042,
                34.8972297
              ],
              [
                47.1392755,
                34.8978152
              ],
              [
                47.1410635,
                34.8983783
              ],
              [
                47.1420259,
                34.8992916
              ],
              [
                47.1457141,
                34.9017202
              ],
              [
                47.1479607,
                34.9024888
              ],
              [
                47.1502232,
                34.9030168
              ],
              [
                47.157242,
                34.9028455
              ],
              [
                47.1592493,
                34.9024536
              ],
              [
                47.1613449,
                34.9019823
              ],
              [
                47.1632109,
                34.9016322
              ],
              [
                47.1647866,
                34.9014406
              ],
              [
                47.1670292,
                34.9012274
              ],
              [
                47.170483,
                34.8999761
              ],
              [
                47.1718308,
                34.9002753
              ],
              [
                47.1719334,
                34.9015581
              ],
              [
                47.1728099,
                34.9033707
              ],
              [
                47.1737831,
                34.9044802
              ],
              [
                47.1739626,
                34.9060471
              ],
              [
                47.1739626,
                34.90793
              ],
              [
                47.1744776,
                34.908757
              ],
              [
                47.1746063,
                34.9102175
              ],
              [
                47.1760654,
                34.912857
              ],
              [
                47.1743917,
                34.9173262
              ],
              [
                47.17422,
                34.9186634
              ],
              [
                47.1750354,
                34.9193671
              ],
              [
                47.1762371,
                34.9205284
              ],
              [
                47.17662,
                34.9221744
              ],
              [
                47.1762468,
                34.9236923
              ],
              [
                47.1769573,
                34.9249905
              ],
              [
                47.1775334,
                34.9263302
              ],
              [
                47.1772352,
                34.9279093
              ],
              [
                47.1771694,
                34.9313601
              ],
              [
                47.1782814,
                34.9320283
              ],
              [
                47.1801563,
                34.9328334
              ],
              [
                47.1804131,
                34.9339783
              ],
              [
                47.1799563,
                34.9348205
              ],
              [
                47.1775532,
                34.9363354
              ],
              [
                47.1745039,
                34.9383935
              ],
              [
                47.174124,
                34.9431625
              ],
              [
                47.1734611,
                34.947055
              ],
              [
                47.1718882,
                34.9520607
              ],
              [
                47.171291,
                34.9531052
              ],
              [
                47.1706863,
                34.9573719
              ],
              [
                47.1688987,
                34.9612057
              ],
              [
                47.1738871,
                34.9633172
              ],
              [
                47.1817954,
                34.9642208
              ],
              [
                47.1858856,
                34.9628334
              ],
              [
                47.1859477,
                34.9583262
              ],
              [
                47.1858411,
                34.9528746
              ],
              [
                47.1865368,
                34.9434503
              ],
              [
                47.1869052,
                34.9379677
              ],
              [
                47.1900036,
                34.9325922
              ],
              [
                47.1955571,
                34.9309896
              ],
              [
                47.2014989,
                34.9344199
              ],
              [
                47.2052246,
                34.9361773
              ],
              [
                47.2080775,
                34.9378149
              ],
              [
                47.2115023,
                34.9396456
              ],
              [
                47.2137988,
                34.9407365
              ],
              [
                47.2172892,
                34.9426187
              ],
              [
                47.2209647,
                34.9448121
              ],
              [
                47.2221486,
                34.9480131
              ],
              [
                47.2269803,
                34.9498311
              ],
              [
                47.228673,
                34.9501459
              ],
              [
                47.2344138,
                34.9524019
              ],
              [
                47.2363632,
                34.9529384
              ],
              [
                47.2386599,
                34.9534994
              ],
              [
                47.2409749,
                34.9544428
              ],
              [
                47.2425579,
                34.9544228
              ],
              [
                47.2421827,
                34.9518832
              ],
              [
                47.2426739,
                34.9480859
              ],
              [
                47.2437185,
                34.9408529
              ],
              [
                47.2458457,
                34.9299935
              ],
              [
                47.2515534,
                34.9284806
              ],
              [
                47.2606086,
                34.9244342
              ],
              [
                47.2742557,
                34.9241527
              ],
              [
                47.2924518,
                34.9296417
              ],
              [
                47.2954988,
                34.9308379
              ],
              [
                47.2987174,
                34.9335822
              ],
              [
                47.3041247,
                34.9344266
              ],
              [
                47.312622,
                34.937804
              ],
              [
                47.3177718,
                34.938578
              ],
              [
                47.3206042,
                34.9402667
              ],
              [
                47.3235225,
                34.9456842
              ],
              [
                47.3299117,
                34.955792
              ],
              [
                47.3293931,
                34.9573188
              ],
              [
                47.3276565,
                34.957723
              ],
              [
                47.3251874,
                34.9580443
              ],
              [
                47.3209626,
                34.9578281
              ],
              [
                47.3199087,
                34.9592558
              ],
              [
                47.3208743,
                34.9615451
              ],
              [
                47.3224925,
                34.9627787
              ],
              [
                47.310525,
                34.9662384
              ],
              [
                47.3090172,
                34.9692497
              ],
              [
                47.304292,
                34.9763921
              ],
              [
                47.2944478,
                34.9798005
              ],
              [
                47.2903295,
                34.9871304
              ],
              [
                47.2951591,
                34.9920756
              ],
              [
                47.2981632,
                34.9989149
              ],
              [
                47.3023276,
                35.0016452
              ],
              [
                47.3080982,
                35.0032391
              ],
              [
                47.3080798,
                35.003873
              ],
              [
                47.3081532,
                35.0047052
              ],
              [
                47.3082916,
                35.0062991
              ],
              [
                47.3119306,
                35.0105577
              ],
              [
                47.3159031,
                35.015225
              ],
              [
                47.3172841,
                35.0160468
              ],
              [
                47.3204654,
                35.016869
              ],
              [
                47.3207706,
                35.0171825
              ],
              [
                47.3217618,
                35.0172279
              ],
              [
                47.3275196,
                35.0216244
              ],
              [
                47.3289306,
                35.0259959
              ],
              [
                47.3286601,
                35.0262821
              ],
              [
                47.3280926,
                35.0307208
              ],
              [
                47.3261234,
                35.0357252
              ],
              [
                47.3249995,
                35.0378082
              ],
              [
                47.3161599,
                35.0485213
              ],
              [
                47.3161148,
                35.048871
              ],
              [
                47.3147667,
                35.0515707
              ],
              [
                47.3127624,
                35.0627842
              ],
              [
                47.3125005,
                35.0638629
              ],
              [
                47.3139733,
                35.0688887
              ],
              [
                47.3151205,
                35.0799146
              ],
              [
                47.3113059,
                35.0825641
              ],
              [
                47.3025796,
                35.0883127
              ],
              [
                47.2877064,
                35.0973048
              ],
              [
                47.2792345,
                35.1015976
              ],
              [
                47.2657118,
                35.1098926
              ],
              [
                47.2529866,
                35.1158141
              ],
              [
                47.2406447,
                35.1218578
              ],
              [
                47.2255922,
                35.1301465
              ],
              [
                47.2130116,
                35.1336867
              ],
              [
                47.2040319,
                35.1359409
              ],
              [
                47.1836481,
                35.1395658
              ],
              [
                47.1631504,
                35.1417408
              ],
              [
                47.1408637,
                35.1435273
              ],
              [
                47.1417748,
                35.129286
              ],
              [
                47.1417723,
                35.1215869
              ],
              [
                47.1380868,
                35.1132182
              ],
              [
                47.1257336,
                35.1040938
              ],
              [
                47.1162291,
                35.0987311
              ],
              [
                47.0977963,
                35.0908252
              ],
              [
                47.0862767,
                35.0881223
              ],
              [
                47.0699533,
                35.0854715
              ],
              [
                47.0526936,
                35.0833059
              ],
              [
                47.04985,
                35.0697192
              ],
              [
                47.046897,
                35.0565339
              ],
              [
                47.0462986,
                35.0565706
              ],
              [
                47.0354195,
                35.0574692
              ],
              [
                47.0200905,
                35.0584907
              ],
              [
                47.0059531,
                35.0598959
              ],
              [
                46.9919348,
                35.0556027
              ],
              [
                46.9817384,
                35.0511408
              ],
              [
                46.9769573,
                35.0441843
              ],
              [
                46.9550425,
                35.0479596
              ],
              [
                46.9418953,
                35.0499637
              ],
              [
                46.9410395,
                35.0536145
              ],
              [
                46.9270557,
                35.0532661
              ],
              [
                46.9089602,
                35.0694936
              ],
              [
                46.8754976,
                35.0732456
              ],
              [
                46.8517799,
                35.040812
              ],
              [
                46.8401667,
                35.0230172
              ],
              [
                46.8263706,
                35.0438253
              ],
              [
                46.8257081,
                35.0426379
              ],
              [
                46.8246782,
                35.0401291
              ],
              [
                46.8242147,
                35.0382106
              ],
              [
                46.823365,
                35.0360813
              ],
              [
                46.8218715,
                35.0308314
              ],
              [
                46.821717,
                35.0300091
              ],
              [
                46.8231847,
                35.0269728
              ],
              [
                46.8232105,
                35.0254546
              ],
              [
                46.8227985,
                35.0213639
              ],
              [
                46.8226182,
                35.0194238
              ],
              [
                46.8214338,
                35.0175259
              ],
              [
                46.8208739,
                35.0167232
              ],
              [
                46.8174235,
                35.0163857
              ],
              [
                46.8122736,
                35.017398
              ],
              [
                46.8064028,
                35.0202237
              ],
              [
                46.8024632,
                35.0223324
              ],
              [
                46.8001131,
                35.0255826
              ],
              [
                46.7980531,
                35.0278388
              ],
              [
                46.7969202,
                35.0292093
              ],
              [
                46.7912811,
                35.0340376
              ],
              [
                46.7898134,
                35.0355978
              ],
              [
                46.7889637,
                35.0398355
              ],
              [
                46.7893499,
                35.0424918
              ],
              [
                46.7857413,
                35.0480018
              ],
              [
                46.7827544,
                35.0497303
              ],
              [
                46.7801023,
                35.0515221
              ],
              [
                46.7759566,
                35.0547261
              ],
              [
                46.7707811,
                35.0570236
              ],
              [
                46.7697768,
                35.0578667
              ],
              [
                46.7680516,
                35.0591102
              ],
              [
                46.7631593,
                35.0616816
              ],
              [
                46.7607389,
                35.0621032
              ],
              [
                46.7580867,
                35.0635574
              ],
              [
                46.756104,
                35.0650749
              ],
              [
                46.7489081,
                35.067503
              ],
              [
                46.7465907,
                35.069484
              ],
              [
                46.7400761,
                35.0698212
              ],
              [
                46.735364,
                35.0709381
              ],
              [
                46.726635,
                35.0745418
              ],
              [
                46.7222319,
                35.0769019
              ],
              [
                46.7198372,
                35.0788827
              ],
              [
                46.7186785,
                35.0804421
              ],
              [
                46.7157623,
                35.0841289
              ],
              [
                46.713036,
                35.0851544
              ],
              [
                46.7108731,
                35.0853651
              ],
              [
                46.7081694,
                35.0863344
              ],
              [
                46.7059512,
                35.0896045
              ],
              [
                46.7036337,
                35.093123
              ],
              [
                46.7021918,
                35.0943029
              ],
              [
                46.6957373,
                35.0932986
              ],
              [
                46.6863389,
                35.0972804
              ],
              [
                46.6818757,
                35.0996259
              ],
              [
                46.6752496,
                35.102821
              ],
              [
                46.6698583,
                35.0998157
              ],
              [
                46.6666911,
                35.0971402
              ],
              [
                46.6658156,
                35.0949702
              ],
              [
                46.6624167,
                35.0902297
              ],
              [
                46.6593526,
                35.0863108
              ],
              [
                46.6583999,
                35.0833609
              ],
              [
                46.6576016,
                35.0797155
              ],
              [
                46.6562884,
                35.0780508
              ],
              [
                46.6547659,
                35.0757321
              ],
              [
                46.6532209,
                35.0775584
              ],
              [
                46.6520193,
                35.0788227
              ],
              [
                46.6509893,
                35.0791037
              ],
              [
                46.6482444,
                35.0799696
              ],
              [
                46.6487577,
                35.0807894
              ],
              [
                46.6487577,
                35.0817728
              ],
              [
                46.6470411,
                35.0827561
              ],
              [
                46.6450432,
                35.0842243
              ],
              [
                46.6425691,
                35.085514
              ],
              [
                46.6411444,
                35.0867352
              ],
              [
                46.6398977,
                35.0866026
              ],
              [
                46.6385544,
                35.085694
              ],
              [
                46.6375997,
                35.0862679
              ],
              [
                46.6369301,
                35.0867949
              ],
              [
                46.6355396,
                35.0875508
              ],
              [
                46.6335065,
                35.0871654
              ],
              [
                46.632057,
                35.0858502
              ],
              [
                46.6302074,
                35.0849407
              ],
              [
                46.6288577,
                35.0839802
              ],
              [
                46.6245801,
                35.0824482
              ],
              [
                46.6242529,
                35.0811216
              ],
              [
                46.6250093,
                35.0803524
              ],
              [
                46.6253086,
                35.079089
              ],
              [
                46.6250232,
                35.0780301
              ],
              [
                46.6244492,
                35.0780407
              ],
              [
                46.6235244,
                35.0784744
              ],
              [
                46.6218003,
                35.0792541
              ],
              [
                46.6194036,
                35.0802275
              ],
              [
                46.6184454,
                35.0808757
              ],
              [
                46.6173424,
                35.0814657
              ],
              [
                46.6163137,
                35.0805085
              ],
              [
                46.6160636,
                35.0798283
              ],
              [
                46.6155636,
                35.077988
              ],
              [
                46.6145604,
                35.076829
              ],
              [
                46.6138877,
                35.0762688
              ],
              [
                46.6130369,
                35.0756472
              ],
              [
                46.6116379,
                35.0759527
              ],
              [
                46.6095919,
                35.0756068
              ],
              [
                46.6083152,
                35.0750852
              ],
              [
                46.6071071,
                35.0748841
              ],
              [
                46.6060439,
                35.0745891
              ],
              [
                46.6046513,
                35.073812
              ],
              [
                46.6035645,
                35.0722104
              ],
              [
                46.6027525,
                35.0710959
              ],
              [
                46.602178,
                35.0710838
              ],
              [
                46.600962,
                35.0722104
              ],
              [
                46.5979922,
                35.0745436
              ],
              [
                46.5966853,
                35.0729643
              ],
              [
                46.5932241,
                35.0725428
              ],
              [
                46.5915826,
                35.0739284
              ],
              [
                46.586877,
                35.0749347
              ],
              [
                46.5862602,
                35.0747686
              ],
              [
                46.585989,
                35.0734866
              ],
              [
                46.5852891,
                35.0731891
              ],
              [
                46.5844711,
                35.0735331
              ],
              [
                46.5816366,
                35.0759518
              ],
              [
                46.5812756,
                35.0767014
              ],
              [
                46.5807994,
                35.0770738
              ],
              [
                46.5801926,
                35.0770484
              ],
              [
                46.5784183,
                35.0774213
              ],
              [
                46.576146,
                35.0761394
              ],
              [
                46.5695842,
                35.0746713
              ],
              [
                46.5602447,
                35.0742569
              ],
              [
                46.5589354,
                35.0741546
              ],
              [
                46.5572804,
                35.0735965
              ],
              [
                46.5564346,
                35.072532
              ],
              [
                46.5551566,
                35.0718919
              ],
              [
                46.5537259,
                35.0722139
              ],
              [
                46.550317,
                35.0719622
              ],
              [
                46.5497037,
                35.0721723
              ],
              [
                46.5498359,
                35.0740525
              ],
              [
                46.5484544,
                35.0748125
              ],
              [
                46.5470962,
                35.0750906
              ],
              [
                46.5441446,
                35.0755999
              ],
              [
                46.5430962,
                35.0711745
              ],
              [
                46.542195,
                35.068477
              ],
              [
                46.5404956,
                35.0638825
              ],
              [
                46.5371224,
                35.0599834
              ],
              [
                46.5342045,
                35.0548315
              ],
              [
                46.5324536,
                35.0511638
              ],
              [
                46.5292092,
                35.0453668
              ],
              [
                46.527587,
                35.0428792
              ],
              [
                46.5253468,
                35.0411294
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555206,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مریوان",
          "name:en": "Marivan County",
          "name:ku": "Merîwan",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282128",
          "wikipedia": "en:Marivan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.972104,
                35.581178
              ],
              [
                45.9719744,
                35.5803201
              ],
              [
                45.9714263,
                35.5800596
              ],
              [
                45.9718897,
                35.578936
              ],
              [
                45.9730136,
                35.5782517
              ],
              [
                45.9733035,
                35.5773753
              ],
              [
                45.9740791,
                35.5772156
              ],
              [
                45.9743554,
                35.5769297
              ],
              [
                45.9746985,
                35.5766661
              ],
              [
                45.9755826,
                35.5763843
              ],
              [
                45.976164,
                35.576256
              ],
              [
                45.976262,
                35.575649
              ],
              [
                45.9758939,
                35.574734
              ],
              [
                45.976798,
                35.573793
              ],
              [
                45.977089,
                35.573324
              ],
              [
                45.977631,
                35.572809
              ],
              [
                45.977946,
                35.572281
              ],
              [
                45.977987,
                35.571707
              ],
              [
                45.978575,
                35.57127
              ],
              [
                45.978824,
                35.570896
              ],
              [
                45.978974,
                35.570181
              ],
              [
                45.979251,
                35.569552
              ],
              [
                45.979598,
                35.568887
              ],
              [
                45.979971,
                35.568382
              ],
              [
                45.979966,
                35.567728
              ],
              [
                45.980258,
                35.566899
              ],
              [
                45.980378,
                35.565907
              ],
              [
                45.980508,
                35.565108
              ],
              [
                45.980843,
                35.564609
              ],
              [
                45.981184,
                35.564023
              ],
              [
                45.981508,
                35.563428
              ],
              [
                45.982094,
                35.562719
              ],
              [
                45.982553,
                35.562393
              ],
              [
                45.982689,
                35.561888
              ],
              [
                45.982785,
                35.56127
              ],
              [
                45.984273,
                35.560535
              ],
              [
                45.985392,
                35.560218
              ],
              [
                45.986115,
                35.559844
              ],
              [
                45.986659,
                35.559546
              ],
              [
                45.987919,
                35.559006
              ],
              [
                45.988612,
                35.556936
              ],
              [
                45.98937,
                35.555442
              ],
              [
                45.990001,
                35.554387
              ],
              [
                45.990998,
                35.553165
              ],
              [
                45.991513,
                35.552382
              ],
              [
                45.99283,
                35.551646
              ],
              [
                45.993488,
                35.551328
              ],
              [
                45.994404,
                35.551419
              ],
              [
                45.995066,
                35.550617
              ],
              [
                45.995697,
                35.549644
              ],
              [
                45.995809,
                35.549371
              ],
              [
                45.996298,
                35.549231
              ],
              [
                45.996729,
                35.549045
              ],
              [
                45.996865,
                35.548949
              ],
              [
                45.997014,
                35.548724
              ],
              [
                45.997429,
                35.548219
              ],
              [
                45.997658,
                35.548087
              ],
              [
                45.99879,
                35.547889
              ],
              [
                45.999073,
                35.547829
              ],
              [
                45.998929,
                35.547664
              ],
              [
                45.998717,
                35.547028
              ],
              [
                45.998439,
                35.546654
              ],
              [
                45.998182,
                35.546364
              ],
              [
                45.99787,
                35.544699
              ],
              [
                45.9976,
                35.543778
              ],
              [
                45.997581,
                35.54375
              ],
              [
                45.997557,
                35.54371
              ],
              [
                45.997384,
                35.543328
              ],
              [
                45.997193,
                35.5431
              ],
              [
                45.997163,
                35.542931
              ],
              [
                45.99718,
                35.542793
              ],
              [
                45.996999,
                35.542634
              ],
              [
                45.997028,
                35.542402
              ],
              [
                45.997063,
                35.534222
              ],
              [
                45.997344,
                35.534256
              ],
              [
                45.99799,
                35.534435
              ],
              [
                45.998574,
                35.534218
              ],
              [
                45.999243,
                35.534082
              ],
              [
                45.999994,
                35.534202
              ],
              [
                46.000665,
                35.5339
              ],
              [
                46.000925,
                35.533433
              ],
              [
                46.001175,
                35.532881
              ],
              [
                46.001577,
                35.532397
              ],
              [
                46.001855,
                35.531994
              ],
              [
                46.002374,
                35.531449
              ],
              [
                46.002567,
                35.531267
              ],
              [
                46.00276,
                35.530687
              ],
              [
                46.003135,
                35.530325
              ],
              [
                46.003668,
                35.530272
              ],
              [
                46.004166,
                35.530227
              ],
              [
                46.004463,
                35.529889
              ],
              [
                46.004975,
                35.529763
              ],
              [
                46.00544,
                35.529549
              ],
              [
                46.005751,
                35.529354
              ],
              [
                46.00628,
                35.529244
              ],
              [
                46.006797,
                35.529088
              ],
              [
                46.007662,
                35.528915
              ],
              [
                46.007987,
                35.528815
              ],
              [
                46.008447,
                35.528718
              ],
              [
                46.008896,
                35.528449
              ],
              [
                46.009541,
                35.528142
              ],
              [
                46.009862,
                35.527673
              ],
              [
                46.010154,
                35.52754
              ],
              [
                46.010476,
                35.527033
              ],
              [
                46.010458,
                35.526482
              ],
              [
                46.011255,
                35.52606
              ],
              [
                46.01182,
                35.525593
              ],
              [
                46.012709,
                35.525377
              ],
              [
                46.012991,
                35.525032
              ],
              [
                46.013611,
                35.524721
              ],
              [
                46.014026,
                35.524419
              ],
              [
                46.014141,
                35.524038
              ],
              [
                46.014548,
                35.523708
              ],
              [
                46.014885,
                35.523295
              ],
              [
                46.015204,
                35.522952
              ],
              [
                46.015923,
                35.52269
              ],
              [
                46.016245,
                35.522183
              ],
              [
                46.016565,
                35.521665
              ],
              [
                46.017423,
                35.52129
              ],
              [
                46.017979,
                35.520747
              ],
              [
                46.017991,
                35.520698
              ],
              [
                46.017739,
                35.520616
              ],
              [
                46.01741,
                35.520549
              ],
              [
                46.017141,
                35.520493
              ],
              [
                46.016924,
                35.520454
              ],
              [
                46.016585,
                35.520407
              ],
              [
                46.016362,
                35.52038
              ],
              [
                46.01613,
                35.52032
              ],
              [
                46.015623,
                35.520172
              ],
              [
                46.015329,
                35.520075
              ],
              [
                46.015045,
                35.519999
              ],
              [
                46.014691,
                35.519961
              ],
              [
                46.014403,
                35.519967
              ],
              [
                46.014171,
                35.519978
              ],
              [
                46.014028,
                35.519884
              ],
              [
                46.013941,
                35.519777
              ],
              [
                46.013782,
                35.519589
              ],
              [
                46.013624,
                35.519433
              ],
              [
                46.01344,
                35.519307
              ],
              [
                46.013115,
                35.51914
              ],
              [
                46.013161,
                35.519152
              ],
              [
                46.012897,
                35.519039
              ],
              [
                46.012856,
                35.519002
              ],
              [
                46.012638,
                35.518921
              ],
              [
                46.012496,
                35.518889
              ],
              [
                46.012322,
                35.518717
              ],
              [
                46.012159,
                35.51862
              ],
              [
                46.011988,
                35.518646
              ],
              [
                46.011524,
                35.518724
              ],
              [
                46.011257,
                35.518755
              ],
              [
                46.010874,
                35.518804
              ],
              [
                46.010617,
                35.51886
              ],
              [
                46.010465,
                35.518857
              ],
              [
                46.010409,
                35.518837
              ],
              [
                46.010324,
                35.518829
              ],
              [
                46.010152,
                35.518859
              ],
              [
                46.009879,
                35.518829
              ],
              [
                46.009706,
                35.518719
              ],
              [
                46.009609,
                35.518612
              ],
              [
                46.009492,
                35.518555
              ],
              [
                46.0094,
                35.518453
              ],
              [
                46.009263,
                35.518359
              ],
              [
                46.009146,
                35.518315
              ],
              [
                46.008994,
                35.518279
              ],
              [
                46.008827,
                35.518243
              ],
              [
                46.008715,
                35.518153
              ],
              [
                46.008563,
                35.518121
              ],
              [
                46.00837,
                35.518086
              ],
              [
                46.008264,
                35.518058
              ],
              [
                46.008077,
                35.518084
              ],
              [
                46.007916,
                35.518098
              ],
              [
                46.00777,
                35.518103
              ],
              [
                46.007633,
                35.518092
              ],
              [
                46.007558,
                35.518134
              ],
              [
                46.007502,
                35.518134
              ],
              [
                46.007341,
                35.518177
              ],
              [
                46.007257,
                35.518269
              ],
              [
                46.007111,
                35.518315
              ],
              [
                46.006949,
                35.518317
              ],
              [
                46.006817,
                35.518214
              ],
              [
                46.006694,
                35.518067
              ],
              [
                46.006571,
                35.517952
              ],
              [
                46.00647,
                35.517932
              ],
              [
                46.006358,
                35.51788
              ],
              [
                46.006277,
                35.51786
              ],
              [
                46.006236,
                35.517802
              ],
              [
                46.006138,
                35.51765
              ],
              [
                46.006071,
                35.517552
              ],
              [
                46.005994,
                35.517491
              ],
              [
                46.005983,
                35.517459
              ],
              [
                46.005974,
                35.517433
              ],
              [
                46.005892,
                35.517368
              ],
              [
                46.005784,
                35.517224
              ],
              [
                46.005687,
                35.51715
              ],
              [
                46.005561,
                35.517106
              ],
              [
                46.005348,
                35.517095
              ],
              [
                46.00509,
                35.517065
              ],
              [
                46.004908,
                35.517029
              ],
              [
                46.004811,
                35.516943
              ],
              [
                46.004659,
                35.51687
              ],
              [
                46.004597,
                35.516771
              ],
              [
                46.00449,
                35.516723
              ],
              [
                46.004349,
                35.516703
              ],
              [
                46.004252,
                35.516626
              ],
              [
                46.004201,
                35.516618
              ],
              [
                46.004121,
                35.516635
              ],
              [
                46.003954,
                35.516649
              ],
              [
                46.003828,
                35.516654
              ],
              [
                46.003692,
                35.516639
              ],
              [
                46.00353,
                35.516628
              ],
              [
                46.003338,
                35.516666
              ],
              [
                46.003147,
                35.516734
              ],
              [
                46.002905,
                35.516761
              ],
              [
                46.002658,
                35.516804
              ],
              [
                46.002427,
                35.51688
              ],
              [
                46.002175,
                35.516895
              ],
              [
                46.002009,
                35.517004
              ],
              [
                46.001824,
                35.51715
              ],
              [
                46.001694,
                35.517221
              ],
              [
                46.001472,
                35.517272
              ],
              [
                46.001206,
                35.517402
              ],
              [
                46.000935,
                35.517462
              ],
              [
                46.000788,
                35.517497
              ],
              [
                46.000673,
                35.51751
              ],
              [
                46.000497,
                35.517582
              ],
              [
                46.000265,
                35.517608
              ],
              [
                46.000103,
                35.517593
              ],
              [
                46.000022,
                35.51761
              ],
              [
                45.999906,
                35.517615
              ],
              [
                45.999736,
                35.517708
              ],
              [
                45.999609,
                35.517713
              ],
              [
                45.999494,
                35.517772
              ],
              [
                45.999374,
                35.517864
              ],
              [
                45.999248,
                35.517865
              ],
              [
                45.999168,
                35.517939
              ],
              [
                45.998996,
                35.517941
              ],
              [
                45.998932,
                35.518053
              ],
              [
                45.998806,
                35.518071
              ],
              [
                45.99872,
                35.518009
              ],
              [
                45.998635,
                35.518105
              ],
              [
                45.998586,
                35.51825
              ],
              [
                45.998563,
                35.518452
              ],
              [
                45.998656,
                35.518588
              ],
              [
                45.998591,
                35.518638
              ],
              [
                45.998465,
                35.51866
              ],
              [
                45.998373,
                35.518582
              ],
              [
                45.998261,
                35.518508
              ],
              [
                45.9981,
                35.518535
              ],
              [
                45.997832,
                35.51852
              ],
              [
                45.997867,
                35.518541
              ],
              [
                45.997761,
                35.518533
              ],
              [
                45.997707,
                35.518608
              ],
              [
                45.997641,
                35.518625
              ],
              [
                45.997489,
                35.518589
              ],
              [
                45.997412,
                35.518458
              ],
              [
                45.99734,
                35.51833
              ],
              [
                45.997213,
                35.518269
              ],
              [
                45.997097,
                35.518262
              ],
              [
                45.997021,
                35.518312
              ],
              [
                45.996846,
                35.518446
              ],
              [
                45.996701,
                35.518542
              ],
              [
                45.99653,
                35.518597
              ],
              [
                45.996348,
                35.518549
              ],
              [
                45.99607,
                35.518551
              ],
              [
                45.995878,
                35.518528
              ],
              [
                45.995675,
                35.518489
              ],
              [
                45.995513,
                35.518403
              ],
              [
                45.99535,
                35.518351
              ],
              [
                45.995163,
                35.51829
              ],
              [
                45.995086,
                35.518233
              ],
              [
                45.99492,
                35.518234
              ],
              [
                45.994797,
                35.518283
              ],
              [
                45.994677,
                35.518324
              ],
              [
                45.994476,
                35.518354
              ],
              [
                45.994274,
                35.518406
              ],
              [
                45.994133,
                35.518493
              ],
              [
                45.994034,
                35.518545
              ],
              [
                45.993819,
                35.518566
              ],
              [
                45.993779,
                35.518611
              ],
              [
                45.993711,
                35.51871
              ],
              [
                45.993599,
                35.518804
              ],
              [
                45.993503,
                35.51893
              ],
              [
                45.993397,
                35.519067
              ],
              [
                45.993278,
                35.519226
              ],
              [
                45.993092,
                35.519391
              ],
              [
                45.992937,
                35.519453
              ],
              [
                45.992784,
                35.519464
              ],
              [
                45.992783,
                35.519462
              ],
              [
                45.985425,
                35.496023
              ],
              [
                45.986117,
                35.495283
              ],
              [
                45.986481,
                35.49517
              ],
              [
                45.986987,
                35.495087
              ],
              [
                45.987627,
                35.494552
              ],
              [
                45.987781,
                35.493955
              ],
              [
                45.987959,
                35.492729
              ],
              [
                45.988027,
                35.491721
              ],
              [
                45.988126,
                35.490784
              ],
              [
                45.988496,
                35.489796
              ],
              [
                45.988629,
                35.489224
              ],
              [
                45.988892,
                35.488804
              ],
              [
                45.989618,
                35.488285
              ],
              [
                45.990105,
                35.48779
              ],
              [
                45.990455,
                35.487506
              ],
              [
                45.990695,
                35.486816
              ],
              [
                45.990563,
                35.486381
              ],
              [
                45.990602,
                35.48598
              ],
              [
                45.990884,
                35.485523
              ],
              [
                45.991039,
                35.485045
              ],
              [
                45.991331,
                35.484575
              ],
              [
                45.991781,
                35.484032
              ],
              [
                45.992226,
                35.483807
              ],
              [
                45.992351,
                35.483149
              ],
              [
                45.992587,
                35.482613
              ],
              [
                45.99301,
                35.48213
              ],
              [
                45.993257,
                35.48181
              ],
              [
                45.994297,
                35.481255
              ],
              [
                45.994441,
                35.4809
              ],
              [
                45.994669,
                35.480333
              ],
              [
                45.994636,
                35.479858
              ],
              [
                45.994546,
                35.479087
              ],
              [
                45.99474,
                35.478548
              ],
              [
                45.995132,
                35.477764
              ],
              [
                45.995275,
                35.477234
              ],
              [
                45.995312,
                35.476713
              ],
              [
                45.995654,
                35.475719
              ],
              [
                45.995925,
                35.47533
              ],
              [
                45.99624,
                35.475184
              ],
              [
                45.996685,
                35.474904
              ],
              [
                45.996935,
                35.474595
              ],
              [
                45.997384,
                35.474445
              ],
              [
                45.998075,
                35.474065
              ],
              [
                45.998202,
                35.473691
              ],
              [
                45.998412,
                35.473105
              ],
              [
                45.998639,
                35.472254
              ],
              [
                45.998604,
                35.471658
              ],
              [
                45.999059,
                35.471136
              ],
              [
                45.99944,
                35.470365
              ],
              [
                45.999507,
                35.470134
              ],
              [
                46.000013,
                35.469547
              ],
              [
                46.000319,
                35.46925
              ],
              [
                46.000709,
                35.468849
              ],
              [
                46.001041,
                35.468492
              ],
              [
                46.00184,
                35.468113
              ],
              [
                46.002453,
                35.467463
              ],
              [
                46.002591,
                35.466409
              ],
              [
                46.002881,
                35.465874
              ],
              [
                46.00318,
                35.465041
              ],
              [
                46.003488,
                35.46447
              ],
              [
                46.003729,
                35.464009
              ],
              [
                46.003665,
                35.463573
              ],
              [
                46.003973,
                35.462892
              ],
              [
                46.003941,
                35.461506
              ],
              [
                46.004167,
                35.460329
              ],
              [
                46.004566,
                35.458782
              ],
              [
                46.00563,
                35.457467
              ],
              [
                46.006831,
                35.456107
              ],
              [
                46.008183,
                35.454837
              ],
              [
                46.009469,
                35.452784
              ],
              [
                46.009634,
                35.452337
              ],
              [
                46.009784,
                35.451929
              ],
              [
                46.010691,
                35.450862
              ],
              [
                46.011251,
                35.45008
              ],
              [
                46.011684,
                35.448566
              ],
              [
                46.012126,
                35.446991
              ],
              [
                46.013144,
                35.445963
              ],
              [
                46.013313,
                35.445036
              ],
              [
                46.01371,
                35.444026
              ],
              [
                46.015944,
                35.442411
              ],
              [
                46.016685,
                35.441197
              ],
              [
                46.017814,
                35.440207
              ],
              [
                46.019453,
                35.439977
              ],
              [
                46.020224,
                35.439593
              ],
              [
                46.021503,
                35.438694
              ],
              [
                46.02182,
                35.437938
              ],
              [
                46.023084,
                35.436804
              ],
              [
                46.024352,
                35.436227
              ],
              [
                46.025003,
                35.435228
              ],
              [
                46.026104,
                35.434046
              ],
              [
                46.02613,
                35.433325
              ],
              [
                46.026905,
                35.431508
              ],
              [
                46.027988,
                35.429354
              ],
              [
                46.028011,
                35.428534
              ],
              [
                46.028772,
                35.426938
              ],
              [
                46.029261,
                35.425354
              ],
              [
                46.029687,
                35.423543
              ],
              [
                46.029443,
                35.422269
              ],
              [
                46.029552,
                35.421421
              ],
              [
                46.030701,
                35.42005
              ],
              [
                46.031524,
                35.41886
              ],
              [
                46.032267,
                35.417924
              ],
              [
                46.032944,
                35.417021
              ],
              [
                46.033593,
                35.41656
              ],
              [
                46.034367,
                35.415558
              ],
              [
                46.034718,
                35.414378
              ],
              [
                46.035166,
                35.4131
              ],
              [
                46.03633,
                35.411965
              ],
              [
                46.037266,
                35.410913
              ],
              [
                46.0378,
                35.410037
              ],
              [
                46.038265,
                35.408636
              ],
              [
                46.038492,
                35.407738
              ],
              [
                46.03867,
                35.40675
              ],
              [
                46.038331,
                35.405342
              ],
              [
                46.039772,
                35.404393
              ],
              [
                46.040354,
                35.404144
              ],
              [
                46.041232,
                35.403879
              ],
              [
                46.042307,
                35.403238
              ],
              [
                46.043641,
                35.401812
              ],
              [
                46.044224,
                35.400747
              ],
              [
                46.044906,
                35.399684
              ],
              [
                46.04575,
                35.398569
              ],
              [
                46.04646,
                35.398236
              ],
              [
                46.04761,
                35.397323
              ],
              [
                46.048275,
                35.395924
              ],
              [
                46.048587,
                35.395149
              ],
              [
                46.049192,
                35.394259
              ],
              [
                46.049243,
                35.393175
              ],
              [
                46.05037,
                35.392087
              ],
              [
                46.050893,
                35.390716
              ],
              [
                46.050945,
                35.389274
              ],
              [
                46.050838,
                35.387981
              ],
              [
                46.051615,
                35.387258
              ],
              [
                46.052517,
                35.386172
              ],
              [
                46.054737,
                35.385414
              ],
              [
                46.056513,
                35.384681
              ],
              [
                46.058501,
                35.383629
              ],
              [
                46.05927,
                35.382787
              ],
              [
                46.060189,
                35.3814
              ],
              [
                46.061303,
                35.380812
              ],
              [
                46.062742,
                35.379943
              ],
              [
                46.06355,
                35.379154
              ],
              [
                46.064449,
                35.378328
              ],
              [
                46.064217,
                35.377397
              ],
              [
                46.063997,
                35.376603
              ],
              [
                46.064474,
                35.373888
              ],
              [
                46.065856,
                35.373089
              ],
              [
                46.066337,
                35.372382
              ],
              [
                46.066836,
                35.37183
              ],
              [
                46.0674,
                35.371246
              ],
              [
                46.067937,
                35.371105
              ],
              [
                46.06857,
                35.370587
              ],
              [
                46.068312,
                35.369741
              ],
              [
                46.067782,
                35.369185
              ],
              [
                46.067567,
                35.368768
              ],
              [
                46.068605,
                35.368174
              ],
              [
                46.069577,
                35.367613
              ],
              [
                46.070533,
                35.366994
              ],
              [
                46.071579,
                35.366339
              ],
              [
                46.072401,
                35.365507
              ],
              [
                46.073313,
                35.364639
              ],
              [
                46.0736106,
                35.3644429
              ],
              [
                46.0739984,
                35.3647763
              ],
              [
                46.0777065,
                35.3697361
              ],
              [
                46.0879547,
                35.375447
              ],
              [
                46.0943405,
                35.3815774
              ],
              [
                46.0965034,
                35.3874134
              ],
              [
                46.1041251,
                35.3992521
              ],
              [
                46.1105464,
                35.4124179
              ],
              [
                46.1154832,
                35.4092415
              ],
              [
                46.1212427,
                35.4051118
              ],
              [
                46.1233647,
                35.4026763
              ],
              [
                46.1293841,
                35.3997113
              ],
              [
                46.1334114,
                35.3983346
              ],
              [
                46.1470217,
                35.396321
              ],
              [
                46.1511931,
                35.3953345
              ],
              [
                46.1561627,
                35.3923958
              ],
              [
                46.1579909,
                35.38973
              ],
              [
                46.1622137,
                35.3859934
              ],
              [
                46.1640162,
                35.384083
              ],
              [
                46.1660761,
                35.3829914
              ],
              [
                46.1690373,
                35.3814589
              ],
              [
                46.1706337,
                35.3816478
              ],
              [
                46.1726421,
                35.3835582
              ],
              [
                46.1737236,
                35.3845449
              ],
              [
                46.1750626,
                35.387169
              ],
              [
                46.1764273,
                35.3899189
              ],
              [
                46.1787705,
                35.3923329
              ],
              [
                46.1808047,
                35.3961951
              ],
              [
                46.187448,
                35.4009807
              ],
              [
                46.1928038,
                35.4026807
              ],
              [
                46.200036,
                35.4047067
              ],
              [
                46.2037954,
                35.4052524
              ],
              [
                46.2093057,
                35.405924
              ],
              [
                46.2165413,
                35.4086313
              ],
              [
                46.2208929,
                35.4089881
              ],
              [
                46.225296,
                35.409114
              ],
              [
                46.2297248,
                35.410688
              ],
              [
                46.2346429,
                35.4109188
              ],
              [
                46.2388401,
                35.412136
              ],
              [
                46.2453546,
                35.4115064
              ],
              [
                46.2526931,
                35.4123668
              ],
              [
                46.2587957,
                35.4108139
              ],
              [
                46.2636337,
                35.4119678
              ],
              [
                46.2660541,
                35.413164
              ],
              [
                46.2699422,
                35.4144231
              ],
              [
                46.2724914,
                35.4147379
              ],
              [
                46.2803706,
                35.4141084
              ],
              [
                46.2836846,
                35.4143028
              ],
              [
                46.286989,
                35.4125782
              ],
              [
                46.2893836,
                35.4107735
              ],
              [
                46.2923448,
                35.4096192
              ],
              [
                46.2956664,
                35.4089267
              ],
              [
                46.3241883,
                35.4047973
              ],
              [
                46.3432513,
                35.3925886
              ],
              [
                46.3648722,
                35.3794293
              ],
              [
                46.4087897,
                35.3571344
              ],
              [
                46.4317368,
                35.3456675
              ],
              [
                46.4361227,
                35.3596053
              ],
              [
                46.4423283,
                35.3645471
              ],
              [
                46.4492033,
                35.364589
              ],
              [
                46.4788645,
                35.3603336
              ],
              [
                46.4863661,
                35.3592206
              ],
              [
                46.4997899,
                35.3596267
              ],
              [
                46.5133312,
                35.3557063
              ],
              [
                46.518574,
                35.3673951
              ],
              [
                46.5222387,
                35.3764453
              ],
              [
                46.5247272,
                35.3813205
              ],
              [
                46.5261047,
                35.384952
              ],
              [
                46.5294263,
                35.3937053
              ],
              [
                46.5312781,
                35.4005279
              ],
              [
                46.5345442,
                35.4072435
              ],
              [
                46.5399179,
                35.418492
              ],
              [
                46.5994977,
                35.4452184
              ],
              [
                46.6052055,
                35.4756993
              ],
              [
                46.613016,
                35.4819898
              ],
              [
                46.6194284,
                35.4834012
              ],
              [
                46.6340874,
                35.4892258
              ],
              [
                46.6436424,
                35.4935381
              ],
              [
                46.6597038,
                35.5064122
              ],
              [
                46.6765349,
                35.5290042
              ],
              [
                46.7039661,
                35.5427221
              ],
              [
                46.7155048,
                35.5482391
              ],
              [
                46.7346925,
                35.5542367
              ],
              [
                46.7325503,
                35.5564997
              ],
              [
                46.7344306,
                35.5581331
              ],
              [
                46.7234443,
                35.5676288
              ],
              [
                46.7003034,
                35.5866669
              ],
              [
                46.6969875,
                35.5895656
              ],
              [
                46.6921137,
                35.6002332
              ],
              [
                46.6892983,
                35.6076496
              ],
              [
                46.6863189,
                35.6152416
              ],
              [
                46.6811974,
                35.6273904
              ],
              [
                46.6646245,
                35.6313979
              ],
              [
                46.6431668,
                35.6386447
              ],
              [
                46.6322928,
                35.6450616
              ],
              [
                46.62676,
                35.667094
              ],
              [
                46.6234245,
                35.6805307
              ],
              [
                46.5635136,
                35.6889049
              ],
              [
                46.5684482,
                35.7700766
              ],
              [
                46.5610056,
                35.7816326
              ],
              [
                46.5481923,
                35.8006979
              ],
              [
                46.5286455,
                35.8282982
              ],
              [
                46.5222737,
                35.8440038
              ],
              [
                46.5184417,
                35.8527507
              ],
              [
                46.5100185,
                35.849172
              ],
              [
                46.4986269,
                35.845773
              ],
              [
                46.4924104,
                35.844429
              ],
              [
                46.4847801,
                35.8419302
              ],
              [
                46.4808311,
                35.8415116
              ],
              [
                46.4709379,
                35.835314
              ],
              [
                46.4663278,
                35.8309222
              ],
              [
                46.4483104,
                35.8216755
              ],
              [
                46.4255662,
                35.8065841
              ],
              [
                46.4186094,
                35.803118
              ],
              [
                46.4093652,
                35.8000879
              ],
              [
                46.4019535,
                35.7961607
              ],
              [
                46.3974445,
                35.7943653
              ],
              [
                46.371715,
                35.7826818
              ],
              [
                46.3414426,
                35.7821924
              ],
              [
                46.3409865,
                35.7821953
              ],
              [
                46.340226,
                35.78213
              ],
              [
                46.339658,
                35.781806
              ],
              [
                46.339359,
                35.781601
              ],
              [
                46.338838,
                35.781088
              ],
              [
                46.338504,
                35.780785
              ],
              [
                46.338013,
                35.780518
              ],
              [
                46.337544,
                35.78035
              ],
              [
                46.337114,
                35.780187
              ],
              [
                46.336849,
                35.780022
              ],
              [
                46.336899,
                35.779388
              ],
              [
                46.337226,
                35.778746
              ],
              [
                46.337889,
                35.778018
              ],
              [
                46.33815,
                35.777477
              ],
              [
                46.338212,
                35.776897
              ],
              [
                46.33833,
                35.776287
              ],
              [
                46.338652,
                35.775565
              ],
              [
                46.338887,
                35.77508
              ],
              [
                46.339309,
                35.77405
              ],
              [
                46.339147,
                35.77345
              ],
              [
                46.338202,
                35.772853
              ],
              [
                46.337541,
                35.772167
              ],
              [
                46.336822,
                35.771615
              ],
              [
                46.336265,
                35.770709
              ],
              [
                46.335874,
                35.77038
              ],
              [
                46.334865,
                35.769782
              ],
              [
                46.334436,
                35.769277
              ],
              [
                46.334084,
                35.768898
              ],
              [
                46.333839,
                35.768536
              ],
              [
                46.333884,
                35.768221
              ],
              [
                46.333862,
                35.767894
              ],
              [
                46.333935,
                35.767484
              ],
              [
                46.334027,
                35.766866
              ],
              [
                46.334101,
                35.766285
              ],
              [
                46.334303,
                35.765479
              ],
              [
                46.334288,
                35.765185
              ],
              [
                46.334018,
                35.764827
              ],
              [
                46.333817,
                35.764493
              ],
              [
                46.333468,
                35.763954
              ],
              [
                46.333321,
                35.763349
              ],
              [
                46.333103,
                35.763166
              ],
              [
                46.33243,
                35.763052
              ],
              [
                46.331789,
                35.763024
              ],
              [
                46.331425,
                35.762988
              ],
              [
                46.330723,
                35.762742
              ],
              [
                46.330229,
                35.762691
              ],
              [
                46.329691,
                35.762557
              ],
              [
                46.329222,
                35.762446
              ],
              [
                46.328483,
                35.762148
              ],
              [
                46.327773,
                35.762096
              ],
              [
                46.327314,
                35.761801
              ],
              [
                46.326979,
                35.761707
              ],
              [
                46.326218,
                35.761786
              ],
              [
                46.325648,
                35.762021
              ],
              [
                46.324889,
                35.762261
              ],
              [
                46.32457,
                35.762478
              ],
              [
                46.3241,
                35.762843
              ],
              [
                46.323975,
                35.762891
              ],
              [
                46.323778,
                35.762872
              ],
              [
                46.323387,
                35.762649
              ],
              [
                46.322879,
                35.762533
              ],
              [
                46.322499,
                35.762135
              ],
              [
                46.322196,
                35.761748
              ],
              [
                46.321855,
                35.761412
              ],
              [
                46.321534,
                35.761222
              ],
              [
                46.321254,
                35.761048
              ],
              [
                46.32051,
                35.760956
              ],
              [
                46.320087,
                35.760884
              ],
              [
                46.319718,
                35.760997
              ],
              [
                46.319726,
                35.761258
              ],
              [
                46.319033,
                35.761454
              ],
              [
                46.318406,
                35.761493
              ],
              [
                46.31793,
                35.761519
              ],
              [
                46.317136,
                35.761606
              ],
              [
                46.316662,
                35.761701
              ],
              [
                46.316151,
                35.761915
              ],
              [
                46.315409,
                35.762063
              ],
              [
                46.314557,
                35.762226
              ],
              [
                46.313989,
                35.762415
              ],
              [
                46.313684,
                35.762597
              ],
              [
                46.313194,
                35.762751
              ],
              [
                46.313016,
                35.762753
              ],
              [
                46.312853,
                35.762541
              ],
              [
                46.312643,
                35.762301
              ],
              [
                46.31226,
                35.762006
              ],
              [
                46.311747,
                35.761583
              ],
              [
                46.311472,
                35.761374
              ],
              [
                46.310833,
                35.761414
              ],
              [
                46.310204,
                35.761498
              ],
              [
                46.3097,
                35.761518
              ],
              [
                46.309111,
                35.761607
              ],
              [
                46.30858,
                35.76162
              ],
              [
                46.308,
                35.761925
              ],
              [
                46.307312,
                35.762086
              ],
              [
                46.306516,
                35.762105
              ],
              [
                46.305853,
                35.761978
              ],
              [
                46.30577,
                35.761717
              ],
              [
                46.305603,
                35.76148
              ],
              [
                46.30521,
                35.76097
              ],
              [
                46.304741,
                35.760346
              ],
              [
                46.304395,
                35.759704
              ],
              [
                46.304105,
                35.759372
              ],
              [
                46.303914,
                35.759024
              ],
              [
                46.303797,
                35.758666
              ],
              [
                46.303924,
                35.758271
              ],
              [
                46.304328,
                35.75797
              ],
              [
                46.304551,
                35.757662
              ],
              [
                46.304576,
                35.757374
              ],
              [
                46.304387,
                35.757095
              ],
              [
                46.303935,
                35.756776
              ],
              [
                46.303606,
                35.756382
              ],
              [
                46.303395,
                35.75606
              ],
              [
                46.303206,
                35.755781
              ],
              [
                46.303401,
                35.755341
              ],
              [
                46.303619,
                35.754727
              ],
              [
                46.303806,
                35.754311
              ],
              [
                46.303821,
                35.753978
              ],
              [
                46.303625,
                35.753723
              ],
              [
                46.303348,
                35.753446
              ],
              [
                46.302795,
                35.752846
              ],
              [
                46.302584,
                35.752525
              ],
              [
                46.302179,
                35.752359
              ],
              [
                46.301759,
                35.75224
              ],
              [
                46.301135,
                35.752005
              ],
              [
                46.300386,
                35.751435
              ],
              [
                46.299586,
                35.750861
              ],
              [
                46.299028,
                35.750468
              ],
              [
                46.298586,
                35.75025
              ],
              [
                46.297714,
                35.750041
              ],
              [
                46.297184,
                35.749939
              ],
              [
                46.296732,
                35.74962
              ],
              [
                46.296307,
                35.749309
              ],
              [
                46.295479,
                35.749127
              ],
              [
                46.294757,
                35.748735
              ],
              [
                46.294305,
                35.748474
              ],
              [
                46.293851,
                35.748201
              ],
              [
                46.293291,
                35.747853
              ],
              [
                46.292788,
                35.747417
              ],
              [
                46.292346,
                35.747085
              ],
              [
                46.291901,
                35.746742
              ],
              [
                46.291398,
                35.746648
              ],
              [
                46.290899,
                35.746576
              ],
              [
                46.290268,
                35.746535
              ],
              [
                46.289293,
                35.746546
              ],
              [
                46.288733,
                35.746484
              ],
              [
                46.288524,
                35.746173
              ],
              [
                46.288274,
                35.745904
              ],
              [
                46.287711,
                35.745716
              ],
              [
                46.287053,
                35.745554
              ],
              [
                46.286599,
                35.745452
              ],
              [
                46.285884,
                35.745207
              ],
              [
                46.285427,
                35.745151
              ],
              [
                46.284803,
                35.745144
              ],
              [
                46.284204,
                35.744961
              ],
              [
                46.283793,
                35.744887
              ],
              [
                46.283489,
                35.744831
              ],
              [
                46.283013,
                35.744174
              ],
              [
                46.282519,
                35.743611
              ],
              [
                46.282136,
                35.743088
              ],
              [
                46.281638,
                35.742445
              ],
              [
                46.281601,
                35.742052
              ],
              [
                46.281513,
                35.741541
              ],
              [
                46.281435,
                35.741017
              ],
              [
                46.281467,
                35.740534
              ],
              [
                46.281082,
                35.740114
              ],
              [
                46.280856,
                35.73967
              ],
              [
                46.28082,
                35.73939
              ],
              [
                46.281422,
                35.738729
              ],
              [
                46.2818,
                35.738375
              ],
              [
                46.282176,
                35.738067
              ],
              [
                46.282262,
                35.737655
              ],
              [
                46.282707,
                35.737143
              ],
              [
                46.282744,
                35.736738
              ],
              [
                46.282713,
                35.73631
              ],
              [
                46.282862,
                35.735839
              ],
              [
                46.283032,
                35.735803
              ],
              [
                46.28343,
                35.73581
              ],
              [
                46.283745,
                35.735697
              ],
              [
                46.284108,
                35.735583
              ],
              [
                46.284318,
                35.735337
              ],
              [
                46.284925,
                35.735099
              ],
              [
                46.2853,
                35.73455
              ],
              [
                46.285701,
                35.733815
              ],
              [
                46.285469,
                35.733726
              ],
              [
                46.285213,
                35.73373
              ],
              [
                46.284657,
                35.733632
              ],
              [
                46.284198,
                35.733565
              ],
              [
                46.28326,
                35.733571
              ],
              [
                46.282415,
                35.733369
              ],
              [
                46.28151,
                35.733095
              ],
              [
                46.281238,
                35.732982
              ],
              [
                46.28089,
                35.732735
              ],
              [
                46.280215,
                35.732309
              ],
              [
                46.279675,
                35.731944
              ],
              [
                46.279234,
                35.731515
              ],
              [
                46.278758,
                35.73097
              ],
              [
                46.278534,
                35.73058
              ],
              [
                46.277931,
                35.729954
              ],
              [
                46.277799,
                35.729531
              ],
              [
                46.277535,
                35.729187
              ],
              [
                46.277041,
                35.728866
              ],
              [
                46.276381,
                35.728708
              ],
              [
                46.275683,
                35.728727
              ],
              [
                46.275201,
                35.728594
              ],
              [
                46.27433,
                35.728493
              ],
              [
                46.273646,
                35.728333
              ],
              [
                46.27261,
                35.727887
              ],
              [
                46.272118,
                35.727766
              ],
              [
                46.271503,
                35.727773
              ],
              [
                46.270873,
                35.727952
              ],
              [
                46.270128,
                35.728429
              ],
              [
                46.269193,
                35.728942
              ],
              [
                46.268513,
                35.729179
              ],
              [
                46.267973,
                35.729255
              ],
              [
                46.26717,
                35.729248
              ],
              [
                46.266123,
                35.729185
              ],
              [
                46.265089,
                35.729061
              ],
              [
                46.263694,
                35.728987
              ],
              [
                46.262499,
                35.728865
              ],
              [
                46.262069,
                35.728745
              ],
              [
                46.261089,
                35.728142
              ],
              [
                46.260631,
                35.727946
              ],
              [
                46.260046,
                35.727537
              ],
              [
                46.259515,
                35.727402
              ],
              [
                46.258892,
                35.727369
              ],
              [
                46.258307,
                35.727211
              ],
              [
                46.258095,
                35.72701
              ],
              [
                46.257746,
                35.726799
              ],
              [
                46.257289,
                35.726733
              ],
              [
                46.256738,
                35.726691
              ],
              [
                46.256246,
                35.72669
              ],
              [
                46.255816,
                35.726701
              ],
              [
                46.25526,
                35.726438
              ],
              [
                46.254767,
                35.726187
              ],
              [
                46.25428,
                35.725965
              ],
              [
                46.253902,
                35.725607
              ],
              [
                46.253469,
                35.725157
              ],
              [
                46.252844,
                35.724734
              ],
              [
                46.2527,
                35.724313
              ],
              [
                46.252492,
                35.724132
              ],
              [
                46.251982,
                35.723853
              ],
              [
                46.251799,
                35.723384
              ],
              [
                46.251454,
                35.722985
              ],
              [
                46.25097,
                35.722748
              ],
              [
                46.250558,
                35.722591
              ],
              [
                46.250537,
                35.722176
              ],
              [
                46.25042,
                35.721924
              ],
              [
                46.24989,
                35.721471
              ],
              [
                46.249443,
                35.721203
              ],
              [
                46.248845,
                35.720856
              ],
              [
                46.247981,
                35.720276
              ],
              [
                46.247244,
                35.719658
              ],
              [
                46.246417,
                35.719274
              ],
              [
                46.245879,
                35.718918
              ],
              [
                46.245178,
                35.718737
              ],
              [
                46.244445,
                35.718519
              ],
              [
                46.243997,
                35.718302
              ],
              [
                46.243683,
                35.718085
              ],
              [
                46.243359,
                35.71788
              ],
              [
                46.242674,
                35.717716
              ],
              [
                46.242036,
                35.717415
              ],
              [
                46.241309,
                35.717037
              ],
              [
                46.240691,
                35.716964
              ],
              [
                46.239872,
                35.716999
              ],
              [
                46.238785,
                35.716732
              ],
              [
                46.237319,
                35.716417
              ],
              [
                46.23651,
                35.716191
              ],
              [
                46.234944,
                35.71568
              ],
              [
                46.233992,
                35.715283
              ],
              [
                46.233493,
                35.715073
              ],
              [
                46.233374,
                35.71534
              ],
              [
                46.232993,
                35.716036
              ],
              [
                46.232491,
                35.716523
              ],
              [
                46.2324088,
                35.7165801
              ],
              [
                46.231821,
                35.716989
              ],
              [
                46.231002,
                35.717251
              ],
              [
                46.229934,
                35.717185
              ],
              [
                46.229285,
                35.717124
              ],
              [
                46.228126,
                35.716993
              ],
              [
                46.227347,
                35.716918
              ],
              [
                46.22679,
                35.71698
              ],
              [
                46.226104,
                35.717038
              ],
              [
                46.22519,
                35.717098
              ],
              [
                46.22437,
                35.717348
              ],
              [
                46.223898,
                35.717568
              ],
              [
                46.223202,
                35.718038
              ],
              [
                46.222495,
                35.718169
              ],
              [
                46.221527,
                35.718271
              ],
              [
                46.220986,
                35.718581
              ],
              [
                46.220401,
                35.718977
              ],
              [
                46.219529,
                35.719395
              ],
              [
                46.218703,
                35.719623
              ],
              [
                46.21776,
                35.719721
              ],
              [
                46.216657,
                35.719843
              ],
              [
                46.21658,
                35.720534
              ],
              [
                46.216386,
                35.721251
              ],
              [
                46.216295,
                35.721609
              ],
              [
                46.216152,
                35.722407
              ],
              [
                46.215818,
                35.723281
              ],
              [
                46.215004,
                35.723217
              ],
              [
                46.214315,
                35.723234
              ],
              [
                46.213595,
                35.72295
              ],
              [
                46.21276,
                35.722968
              ],
              [
                46.211838,
                35.723234
              ],
              [
                46.211059,
                35.723353
              ],
              [
                46.210242,
                35.723595
              ],
              [
                46.209301,
                35.723824
              ],
              [
                46.208433,
                35.723728
              ],
              [
                46.207603,
                35.723509
              ],
              [
                46.206495,
                35.723495
              ],
              [
                46.20587,
                35.723789
              ],
              [
                46.2051,
                35.723699
              ],
              [
                46.204111,
                35.723669
              ],
              [
                46.203246,
                35.723524
              ],
              [
                46.20234,
                35.723029
              ],
              [
                46.201485,
                35.722744
              ],
              [
                46.200513,
                35.722544
              ],
              [
                46.19956,
                35.722322
              ],
              [
                46.198851,
                35.721514
              ],
              [
                46.198377,
                35.721255
              ],
              [
                46.197637,
                35.721062
              ],
              [
                46.196996,
                35.721014
              ],
              [
                46.196387,
                35.721
              ],
              [
                46.195795,
                35.720954
              ],
              [
                46.195295,
                35.720423
              ],
              [
                46.194857,
                35.719961
              ],
              [
                46.194365,
                35.719281
              ],
              [
                46.1939,
                35.718222
              ],
              [
                46.193711,
                35.71747
              ],
              [
                46.193271,
                35.717068
              ],
              [
                46.192936,
                35.716701
              ],
              [
                46.192714,
                35.716032
              ],
              [
                46.192171,
                35.715595
              ],
              [
                46.19197,
                35.71517
              ],
              [
                46.191336,
                35.714834
              ],
              [
                46.190861,
                35.714693
              ],
              [
                46.190289,
                35.714428
              ],
              [
                46.189671,
                35.714307
              ],
              [
                46.188775,
                35.714383
              ],
              [
                46.188011,
                35.71439
              ],
              [
                46.187127,
                35.71408
              ],
              [
                46.18632,
                35.713985
              ],
              [
                46.185489,
                35.713894
              ],
              [
                46.184856,
                35.713686
              ],
              [
                46.184236,
                35.713359
              ],
              [
                46.183565,
                35.713019
              ],
              [
                46.182605,
                35.712886
              ],
              [
                46.181874,
                35.712742
              ],
              [
                46.1813,
                35.712723
              ],
              [
                46.180515,
                35.712684
              ],
              [
                46.179573,
                35.712648
              ],
              [
                46.179345,
                35.712463
              ],
              [
                46.179112,
                35.711805
              ],
              [
                46.178881,
                35.711414
              ],
              [
                46.178493,
                35.711093
              ],
              [
                46.177972,
                35.710772
              ],
              [
                46.1775,
                35.710457
              ],
              [
                46.176912,
                35.710248
              ],
              [
                46.176499,
                35.710014
              ],
              [
                46.17614,
                35.709469
              ],
              [
                46.175899,
                35.709018
              ],
              [
                46.175509,
                35.708641
              ],
              [
                46.1749,
                35.708174
              ],
              [
                46.174447,
                35.707764
              ],
              [
                46.173871,
                35.707282
              ],
              [
                46.173408,
                35.70643
              ],
              [
                46.173173,
                35.704975
              ],
              [
                46.173082,
                35.704229
              ],
              [
                46.173291,
                35.703786
              ],
              [
                46.173413,
                35.703335
              ],
              [
                46.173397,
                35.70247
              ],
              [
                46.173874,
                35.701901
              ],
              [
                46.174036,
                35.701534
              ],
              [
                46.174243,
                35.700756
              ],
              [
                46.174366,
                35.700315
              ],
              [
                46.174227,
                35.699832
              ],
              [
                46.173726,
                35.699162
              ],
              [
                46.173227,
                35.698769
              ],
              [
                46.172603,
                35.698481
              ],
              [
                46.171638,
                35.698192
              ],
              [
                46.170627,
                35.697268
              ],
              [
                46.170084,
                35.696634
              ],
              [
                46.1697,
                35.695879
              ],
              [
                46.169376,
                35.695382
              ],
              [
                46.168961,
                35.694977
              ],
              [
                46.168347,
                35.694225
              ],
              [
                46.167985,
                35.693654
              ],
              [
                46.167624,
                35.693084
              ],
              [
                46.167506,
                35.692519
              ],
              [
                46.167549,
                35.691192
              ],
              [
                46.167472,
                35.690257
              ],
              [
                46.167013,
                35.689946
              ],
              [
                46.166379,
                35.689611
              ],
              [
                46.165718,
                35.68919
              ],
              [
                46.165081,
                35.688964
              ],
              [
                46.163791,
                35.688931
              ],
              [
                46.162737,
                35.688846
              ],
              [
                46.161742,
                35.688784
              ],
              [
                46.160924,
                35.688839
              ],
              [
                46.159492,
                35.688877
              ],
              [
                46.159087,
                35.689143
              ],
              [
                46.157808,
                35.689704
              ],
              [
                46.157462,
                35.689994
              ],
              [
                46.15622,
                35.691055
              ],
              [
                46.156105,
                35.691271
              ],
              [
                46.155106,
                35.691801
              ],
              [
                46.153819,
                35.692256
              ],
              [
                46.152363,
                35.692784
              ],
              [
                46.151645,
                35.692904
              ],
              [
                46.15112,
                35.692888
              ],
              [
                46.150222,
                35.693151
              ],
              [
                46.148946,
                35.693408
              ],
              [
                46.147802,
                35.693784
              ],
              [
                46.147066,
                35.694004
              ],
              [
                46.146113,
                35.694364
              ],
              [
                46.145234,
                35.694664
              ],
              [
                46.144086,
                35.695149
              ],
              [
                46.143488,
                35.695458
              ],
              [
                46.143003,
                35.695851
              ],
              [
                46.142108,
                35.696715
              ],
              [
                46.141569,
                35.697342
              ],
              [
                46.140902,
                35.697671
              ],
              [
                46.140387,
                35.697773
              ],
              [
                46.139734,
                35.697597
              ],
              [
                46.138908,
                35.696944
              ],
              [
                46.137955,
                35.696455
              ],
              [
                46.137275,
                35.69587
              ],
              [
                46.136448,
                35.695867
              ],
              [
                46.135559,
                35.696071
              ],
              [
                46.134912,
                35.695862
              ],
              [
                46.133244,
                35.695735
              ],
              [
                46.132158,
                35.695435
              ],
              [
                46.131439,
                35.695185
              ],
              [
                46.130644,
                35.695285
              ],
              [
                46.129813,
                35.69545
              ],
              [
                46.128856,
                35.695594
              ],
              [
                46.127895,
                35.695717
              ],
              [
                46.127444,
                35.69577
              ],
              [
                46.126565,
                35.695617
              ],
              [
                46.125917,
                35.69553
              ],
              [
                46.125506,
                35.695212
              ],
              [
                46.125144,
                35.694839
              ],
              [
                46.124998,
                35.694248
              ],
              [
                46.124781,
                35.693805
              ],
              [
                46.124424,
                35.693323
              ],
              [
                46.123941,
                35.692947
              ],
              [
                46.123705,
                35.692398
              ],
              [
                46.123501,
                35.691894
              ],
              [
                46.123143,
                35.691487
              ],
              [
                46.1226,
                35.691207
              ],
              [
                46.122165,
                35.690909
              ],
              [
                46.121512,
                35.690686
              ],
              [
                46.12062,
                35.690507
              ],
              [
                46.119806,
                35.690245
              ],
              [
                46.11872,
                35.689847
              ],
              [
                46.117939,
                35.689357
              ],
              [
                46.116735,
                35.688697
              ],
              [
                46.115534,
                35.688184
              ],
              [
                46.113704,
                35.687877
              ],
              [
                46.112769,
                35.687751
              ],
              [
                46.111593,
                35.687826
              ],
              [
                46.11,
                35.688137
              ],
              [
                46.108664,
                35.688139
              ],
              [
                46.106717,
                35.688109
              ],
              [
                46.10617,
                35.68794
              ],
              [
                46.105556,
                35.687866
              ],
              [
                46.10511,
                35.687901
              ],
              [
                46.10405,
                35.688009
              ],
              [
                46.10265,
                35.688056
              ],
              [
                46.101857,
                35.687842
              ],
              [
                46.101044,
                35.687718
              ],
              [
                46.100057,
                35.688151
              ],
              [
                46.099377,
                35.688285
              ],
              [
                46.098695,
                35.688469
              ],
              [
                46.098397,
                35.689151
              ],
              [
                46.09824,
                35.689675
              ],
              [
                46.098265,
                35.690194
              ],
              [
                46.098312,
                35.691035
              ],
              [
                46.098242,
                35.691696
              ],
              [
                46.097896,
                35.692443
              ],
              [
                46.097282,
                35.692864
              ],
              [
                46.096563,
                35.693096
              ],
              [
                46.095871,
                35.69327
              ],
              [
                46.094939,
                35.693399
              ],
              [
                46.094106,
                35.693356
              ],
              [
                46.093391,
                35.693357
              ],
              [
                46.092658,
                35.693448
              ],
              [
                46.091812,
                35.693161
              ],
              [
                46.090866,
                35.692741
              ],
              [
                46.090239,
                35.692759
              ],
              [
                46.089186,
                35.693189
              ],
              [
                46.088649,
                35.693647
              ],
              [
                46.088041,
                35.693878
              ],
              [
                46.087207,
                35.694072
              ],
              [
                46.086522,
                35.694153
              ],
              [
                46.085708,
                35.694216
              ],
              [
                46.085061,
                35.694166
              ],
              [
                46.084173,
                35.693999
              ],
              [
                46.083229,
                35.693824
              ],
              [
                46.08205,
                35.693692
              ],
              [
                46.081197,
                35.693554
              ],
              [
                46.080059,
                35.693258
              ],
              [
                46.079068,
                35.693218
              ],
              [
                46.078318,
                35.693223
              ],
              [
                46.077262,
                35.693339
              ],
              [
                46.076641,
                35.693268
              ],
              [
                46.076158,
                35.693157
              ],
              [
                46.074958,
                35.693038
              ],
              [
                46.073856,
                35.692924
              ],
              [
                46.072481,
                35.692661
              ],
              [
                46.071764,
                35.692534
              ],
              [
                46.070859,
                35.692197
              ],
              [
                46.069903,
                35.691787
              ],
              [
                46.069389,
                35.692006
              ],
              [
                46.068948,
                35.69246
              ],
              [
                46.068341,
                35.693055
              ],
              [
                46.06784,
                35.693272
              ],
              [
                46.06735,
                35.693487
              ],
              [
                46.067166,
                35.693896
              ],
              [
                46.067143,
                35.69444
              ],
              [
                46.0666,
                35.695057
              ],
              [
                46.066182,
                35.69529
              ],
              [
                46.065442,
                35.696033
              ],
              [
                46.064289,
                35.696684
              ],
              [
                46.063132,
                35.697915
              ],
              [
                46.062517,
                35.69933
              ],
              [
                46.061902,
                35.700594
              ],
              [
                46.061558,
                35.70117
              ],
              [
                46.061249,
                35.700885
              ],
              [
                46.060822,
                35.700693
              ],
              [
                46.060212,
                35.700433
              ],
              [
                46.059853,
                35.700369
              ],
              [
                46.059639,
                35.700242
              ],
              [
                46.059287,
                35.700118
              ],
              [
                46.058473,
                35.69993
              ],
              [
                46.057808,
                35.699761
              ],
              [
                46.056884,
                35.699781
              ],
              [
                46.056253,
                35.699715
              ],
              [
                46.055262,
                35.699764
              ],
              [
                46.054989,
                35.699762
              ],
              [
                46.054362,
                35.699598
              ],
              [
                46.053536,
                35.699564
              ],
              [
                46.052636,
                35.69958
              ],
              [
                46.051854,
                35.69988
              ],
              [
                46.051369,
                35.700084
              ],
              [
                46.050664,
                35.700078
              ],
              [
                46.050228,
                35.700138
              ],
              [
                46.049721,
                35.700302
              ],
              [
                46.048942,
                35.700763
              ],
              [
                46.048518,
                35.701151
              ],
              [
                46.048307,
                35.701815
              ],
              [
                46.04789,
                35.701971
              ],
              [
                46.047478,
                35.70221
              ],
              [
                46.047047,
                35.702299
              ],
              [
                46.046499,
                35.702556
              ],
              [
                46.046319,
                35.702832
              ],
              [
                46.046309,
                35.703143
              ],
              [
                46.046485,
                35.703862
              ],
              [
                46.046388,
                35.704219
              ],
              [
                46.046529,
                35.704559
              ],
              [
                46.046699,
                35.705126
              ],
              [
                46.046798,
                35.705432
              ],
              [
                46.046734,
                35.705957
              ],
              [
                46.046026,
                35.706438
              ],
              [
                46.045373,
                35.706568
              ],
              [
                46.044382,
                35.706645
              ],
              [
                46.043831,
                35.706648
              ],
              [
                46.043354,
                35.706684
              ],
              [
                46.042848,
                35.706729
              ],
              [
                46.042465,
                35.706728
              ],
              [
                46.042115,
                35.706255
              ],
              [
                46.041591,
                35.705584
              ],
              [
                46.041426,
                35.705282
              ],
              [
                46.041002,
                35.704864
              ],
              [
                46.040779,
                35.704723
              ],
              [
                46.040387,
                35.704314
              ],
              [
                46.040081,
                35.704061
              ],
              [
                46.039734,
                35.704109
              ],
              [
                46.03902,
                35.704267
              ],
              [
                46.038225,
                35.704411
              ],
              [
                46.037405,
                35.704854
              ],
              [
                46.036668,
                35.705133
              ],
              [
                46.036137,
                35.705206
              ],
              [
                46.035721,
                35.705278
              ],
              [
                46.035072,
                35.704708
              ],
              [
                46.034675,
                35.704035
              ],
              [
                46.034487,
                35.703466
              ],
              [
                46.03423,
                35.70268
              ],
              [
                46.033959,
                35.701941
              ],
              [
                46.033451,
                35.701681
              ],
              [
                46.033034,
                35.701448
              ],
              [
                46.032804,
                35.700821
              ],
              [
                46.032366,
                35.70066
              ],
              [
                46.032127,
                35.70056
              ],
              [
                46.031844,
                35.700511
              ],
              [
                46.031404,
                35.700375
              ],
              [
                46.031273,
                35.700147
              ],
              [
                46.031283,
                35.699777
              ],
              [
                46.031449,
                35.699311
              ],
              [
                46.031345,
                35.699006
              ],
              [
                46.031322,
                35.698714
              ],
              [
                46.03161,
                35.698369
              ],
              [
                46.031902,
                35.698019
              ],
              [
                46.03185,
                35.697495
              ],
              [
                46.031696,
                35.697182
              ],
              [
                46.031957,
                35.696703
              ],
              [
                46.032197,
                35.696065
              ],
              [
                46.032081,
                35.695673
              ],
              [
                46.032088,
                35.695318
              ],
              [
                46.03227,
                35.694934
              ],
              [
                46.032554,
                35.69427
              ],
              [
                46.032719,
                35.693677
              ],
              [
                46.032542,
                35.693283
              ],
              [
                46.032269,
                35.693104
              ],
              [
                46.031668,
                35.69271
              ],
              [
                46.031427,
                35.692448
              ],
              [
                46.030938,
                35.69228
              ],
              [
                46.030314,
                35.692071
              ],
              [
                46.029563,
                35.691806
              ],
              [
                46.028721,
                35.691838
              ],
              [
                46.028353,
                35.691938
              ],
              [
                46.02779,
                35.69206
              ],
              [
                46.027083,
                35.691922
              ],
              [
                46.026629,
                35.69196
              ],
              [
                46.026225,
                35.691878
              ],
              [
                46.026084,
                35.691184
              ],
              [
                46.025899,
                35.690811
              ],
              [
                46.025689,
                35.690461
              ],
              [
                46.025664,
                35.689948
              ],
              [
                46.025576,
                35.689636
              ],
              [
                46.025118,
                35.689202
              ],
              [
                46.025308,
                35.688734
              ],
              [
                46.025517,
                35.688449
              ],
              [
                46.025946,
                35.687903
              ],
              [
                46.026262,
                35.68752
              ],
              [
                46.026235,
                35.687056
              ],
              [
                46.02622,
                35.686832
              ],
              [
                46.025845,
                35.686151
              ],
              [
                46.025326,
                35.685805
              ],
              [
                46.024807,
                35.685724
              ],
              [
                46.024284,
                35.685599
              ],
              [
                46.023713,
                35.685565
              ],
              [
                46.023286,
                35.68555
              ],
              [
                46.022608,
                35.685526
              ],
              [
                46.022235,
                35.68539
              ],
              [
                46.022095,
                35.685208
              ],
              [
                46.022133,
                35.684888
              ],
              [
                46.021906,
                35.684634
              ],
              [
                46.021695,
                35.68452
              ],
              [
                46.021072,
                35.684857
              ],
              [
                46.020456,
                35.68508
              ],
              [
                46.020059,
                35.685213
              ],
              [
                46.019557,
                35.685396
              ],
              [
                46.018733,
                35.685696
              ],
              [
                46.018124,
                35.685712
              ],
              [
                46.017747,
                35.685621
              ],
              [
                46.017343,
                35.685421
              ],
              [
                46.016977,
                35.68523
              ],
              [
                46.016551,
                35.685043
              ],
              [
                46.016181,
                35.684922
              ],
              [
                46.015596,
                35.684846
              ],
              [
                46.015186,
                35.684681
              ],
              [
                46.014762,
                35.684592
              ],
              [
                46.014311,
                35.68461
              ],
              [
                46.013923,
                35.684373
              ],
              [
                46.013646,
                35.684018
              ],
              [
                46.013431,
                35.683649
              ],
              [
                46.013311,
                35.683115
              ],
              [
                46.013334,
                35.682693
              ],
              [
                46.013252,
                35.682198
              ],
              [
                46.013165,
                35.681709
              ],
              [
                46.012892,
                35.681348
              ],
              [
                46.012495,
                35.681004
              ],
              [
                46.012036,
                35.680659
              ],
              [
                46.011743,
                35.680375
              ],
              [
                46.011432,
                35.680069
              ],
              [
                46.011072,
                35.679907
              ],
              [
                46.010733,
                35.679851
              ],
              [
                46.010027,
                35.67951
              ],
              [
                46.009443,
                35.679138
              ],
              [
                46.009149,
                35.678707
              ],
              [
                46.009225,
                35.678249
              ],
              [
                46.009269,
                35.677864
              ],
              [
                46.009082,
                35.677423
              ],
              [
                46.008904,
                35.677083
              ],
              [
                46.008632,
                35.676845
              ],
              [
                46.008499,
                35.676578
              ],
              [
                46.008209,
                35.676407
              ],
              [
                46.008478,
                35.675848
              ],
              [
                46.008575,
                35.675338
              ],
              [
                46.008581,
                35.674924
              ],
              [
                46.008533,
                35.674385
              ],
              [
                46.008882,
                35.673894
              ],
              [
                46.009176,
                35.673583
              ],
              [
                46.009717,
                35.673292
              ],
              [
                46.010305,
                35.673054
              ],
              [
                46.01087,
                35.67273
              ],
              [
                46.011084,
                35.672651
              ],
              [
                46.011279,
                35.672177
              ],
              [
                46.011378,
                35.671887
              ],
              [
                46.01159,
                35.671494
              ],
              [
                46.011874,
                35.671106
              ],
              [
                46.012136,
                35.670843
              ],
              [
                46.012546,
                35.670684
              ],
              [
                46.012854,
                35.670558
              ],
              [
                46.013049,
                35.670201
              ],
              [
                46.013162,
                35.669925
              ],
              [
                46.013459,
                35.669594
              ],
              [
                46.013635,
                35.669387
              ],
              [
                46.014011,
                35.669055
              ],
              [
                46.014182,
                35.668732
              ],
              [
                46.014565,
                35.668261
              ],
              [
                46.014832,
                35.667604
              ],
              [
                46.015083,
                35.66723
              ],
              [
                46.015208,
                35.666829
              ],
              [
                46.015079,
                35.666464
              ],
              [
                46.014817,
                35.666126
              ],
              [
                46.014543,
                35.665765
              ],
              [
                46.014431,
                35.665422
              ],
              [
                46.014369,
                35.665175
              ],
              [
                46.014186,
                35.664718
              ],
              [
                46.014214,
                35.664527
              ],
              [
                46.01452,
                35.664367
              ],
              [
                46.01494,
                35.664255
              ],
              [
                46.015185,
                35.664206
              ],
              [
                46.01544,
                35.664028
              ],
              [
                46.015475,
                35.663783
              ],
              [
                46.015351,
                35.6635
              ],
              [
                46.014528,
                35.663047
              ],
              [
                46.014365,
                35.662917
              ],
              [
                46.014095,
                35.662301
              ],
              [
                46.013646,
                35.66161
              ],
              [
                46.013363,
                35.661084
              ],
              [
                46.013367,
                35.660326
              ],
              [
                46.013292,
                35.659928
              ],
              [
                46.013229,
                35.65955
              ],
              [
                46.012988,
                35.65899
              ],
              [
                46.012934,
                35.658826
              ],
              [
                46.012936,
                35.658477
              ],
              [
                46.012973,
                35.658312
              ],
              [
                46.013036,
                35.658142
              ],
              [
                46.013086,
                35.657988
              ],
              [
                46.01309,
                35.657829
              ],
              [
                46.013057,
                35.657755
              ],
              [
                46.012958,
                35.657687
              ],
              [
                46.012762,
                35.657546
              ],
              [
                46.012682,
                35.657409
              ],
              [
                46.012642,
                35.657276
              ],
              [
                46.012627,
                35.657133
              ],
              [
                46.012547,
                35.657002
              ],
              [
                46.0125,
                35.656854
              ],
              [
                46.012542,
                35.656626
              ],
              [
                46.01256,
                35.65644
              ],
              [
                46.012559,
                35.656177
              ],
              [
                46.012523,
                35.655976
              ],
              [
                46.012491,
                35.65574
              ],
              [
                46.012419,
                35.655385
              ],
              [
                46.012449,
                35.655054
              ],
              [
                46.012721,
                35.65432
              ],
              [
                46.01272,
                35.65432
              ],
              [
                46.012694,
                35.654305
              ],
              [
                46.012621,
                35.654282
              ],
              [
                46.012528,
                35.654256
              ],
              [
                46.012461,
                35.654235
              ],
              [
                46.01234,
                35.65419
              ],
              [
                46.012214,
                35.65412
              ],
              [
                46.012082,
                35.654019
              ],
              [
                46.01203,
                35.65399
              ],
              [
                46.01193,
                35.653979
              ],
              [
                46.011815,
                35.653972
              ],
              [
                46.011687,
                35.653964
              ],
              [
                46.01158,
                35.653944
              ],
              [
                46.01144,
                35.653924
              ],
              [
                46.011317,
                35.653921
              ],
              [
                46.011248,
                35.653923
              ],
              [
                46.011147,
                35.653934
              ],
              [
                46.011033,
                35.653931
              ],
              [
                46.010912,
                35.653914
              ],
              [
                46.010849,
                35.653898
              ],
              [
                46.010848,
                35.653898
              ],
              [
                46.010848,
                35.653894
              ],
              [
                46.010857,
                35.653828
              ],
              [
                46.010875,
                35.653782
              ],
              [
                46.010896,
                35.653754
              ],
              [
                46.010939,
                35.653758
              ],
              [
                46.010986,
                35.653771
              ],
              [
                46.011064,
                35.65378
              ],
              [
                46.011178,
                35.653781
              ],
              [
                46.011256,
                35.653757
              ],
              [
                46.011293,
                35.65372
              ],
              [
                46.011314,
                35.653689
              ],
              [
                46.011297,
                35.653651
              ],
              [
                46.011282,
                35.653604
              ],
              [
                46.01126,
                35.653529
              ],
              [
                46.011297,
                35.653497
              ],
              [
                46.0113,
                35.653448
              ],
              [
                46.011332,
                35.653395
              ],
              [
                46.011355,
                35.653342
              ],
              [
                46.011376,
                35.653273
              ],
              [
                46.01139,
                35.65322
              ],
              [
                46.011404,
                35.653182
              ],
              [
                46.011436,
                35.653155
              ],
              [
                46.011465,
                35.653131
              ],
              [
                46.011514,
                35.65311
              ],
              [
                46.01156,
                35.653079
              ],
              [
                46.011559,
                35.653042
              ],
              [
                46.011562,
                35.652999
              ],
              [
                46.011565,
                35.652942
              ],
              [
                46.011561,
                35.652889
              ],
              [
                46.011569,
                35.652846
              ],
              [
                46.011572,
                35.652811
              ],
              [
                46.011518,
                35.652718
              ],
              [
                46.011424,
                35.652619
              ],
              [
                46.011349,
                35.652495
              ],
              [
                46.01131,
                35.652379
              ],
              [
                46.011314,
                35.652307
              ],
              [
                46.011336,
                35.652242
              ],
              [
                46.011345,
                35.652178
              ],
              [
                46.011325,
                35.652121
              ],
              [
                46.011269,
                35.652069
              ],
              [
                46.011236,
                35.652016
              ],
              [
                46.01124,
                35.651948
              ],
              [
                46.011248,
                35.651892
              ],
              [
                46.011243,
                35.651839
              ],
              [
                46.011219,
                35.651775
              ],
              [
                46.011177,
                35.651711
              ],
              [
                46.011138,
                35.651632
              ],
              [
                46.011119,
                35.651579
              ],
              [
                46.011091,
                35.651556
              ],
              [
                46.011036,
                35.651553
              ],
              [
                46.011003,
                35.651531
              ],
              [
                46.010993,
                35.651482
              ],
              [
                46.010993,
                35.651429
              ],
              [
                46.010955,
                35.651376
              ],
              [
                46.010922,
                35.65132
              ],
              [
                46.01093,
                35.651252
              ],
              [
                46.010939,
                35.65121
              ],
              [
                46.01098,
                35.651149
              ],
              [
                46.010997,
                35.651089
              ],
              [
                46.010987,
                35.650979
              ],
              [
                46.010937,
                35.650922
              ],
              [
                46.010814,
                35.650824
              ],
              [
                46.010769,
                35.650711
              ],
              [
                46.010646,
                35.650564
              ],
              [
                46.010601,
                35.650451
              ],
              [
                46.010609,
                35.650366
              ],
              [
                46.010668,
                35.650273
              ],
              [
                46.010737,
                35.650237
              ],
              [
                46.010814,
                35.650166
              ],
              [
                46.010865,
                35.650059
              ],
              [
                46.01082,
                35.649932
              ],
              [
                46.010854,
                35.649882
              ],
              [
                46.010862,
                35.649818
              ],
              [
                46.010965,
                35.649718
              ],
              [
                46.010973,
                35.649626
              ],
              [
                46.010841,
                35.6495
              ],
              [
                46.010787,
                35.649401
              ],
              [
                46.010699,
                35.649253
              ],
              [
                46.010696,
                35.649048
              ],
              [
                46.010737,
                35.648877
              ],
              [
                46.010727,
                35.648729
              ],
              [
                46.010657,
                35.648666
              ],
              [
                46.010483,
                35.648667
              ],
              [
                46.010345,
                35.648767
              ],
              [
                46.010147,
                35.648889
              ],
              [
                46.009949,
                35.648962
              ],
              [
                46.00981,
                35.648977
              ],
              [
                46.009749,
                35.648949
              ],
              [
                46.009695,
                35.648801
              ],
              [
                46.009667,
                35.648624
              ],
              [
                46.009648,
                35.648497
              ],
              [
                46.009578,
                35.648469
              ],
              [
                46.009527,
                35.648533
              ],
              [
                46.009459,
                35.648619
              ],
              [
                46.009398,
                35.648612
              ],
              [
                46.00938,
                35.648542
              ],
              [
                46.009258,
                35.648522
              ],
              [
                46.00917,
                35.648444
              ],
              [
                46.00916,
                35.648317
              ],
              [
                46.009184,
                35.648161
              ],
              [
                46.009209,
                35.648069
              ],
              [
                46.009121,
                35.648006
              ],
              [
                46.009,
                35.648035
              ],
              [
                46.008844,
                35.648058
              ],
              [
                46.008679,
                35.648045
              ],
              [
                46.008626,
                35.647967
              ],
              [
                46.008643,
                35.647882
              ],
              [
                46.008468,
                35.647799
              ],
              [
                46.008381,
                35.647807
              ],
              [
                46.008226,
                35.647857
              ],
              [
                46.008105,
                35.647901
              ],
              [
                46.007939,
                35.647803
              ],
              [
                46.007894,
                35.647669
              ],
              [
                46.007659,
                35.647636
              ],
              [
                46.007467,
                35.647559
              ],
              [
                46.007326,
                35.647405
              ],
              [
                46.007273,
                35.64727
              ],
              [
                46.007263,
                35.647157
              ],
              [
                46.007219,
                35.647115
              ],
              [
                46.00714,
                35.647066
              ],
              [
                46.007061,
                35.646989
              ],
              [
                46.007068,
                35.646897
              ],
              [
                46.007101,
                35.646776
              ],
              [
                46.007074,
                35.646663
              ],
              [
                46.007022,
                35.646628
              ],
              [
                46.006743,
                35.646524
              ],
              [
                46.006638,
                35.646468
              ],
              [
                46.006455,
                35.646399
              ],
              [
                46.006333,
                35.646372
              ],
              [
                46.006263,
                35.646323
              ],
              [
                46.006262,
                35.646238
              ],
              [
                46.00633,
                35.646145
              ],
              [
                46.006425,
                35.64606
              ],
              [
                46.006519,
                35.645953
              ],
              [
                46.006535,
                35.645853
              ],
              [
                46.006559,
                35.645697
              ],
              [
                46.006488,
                35.645549
              ],
              [
                46.006374,
                35.645493
              ],
              [
                46.00626,
                35.64536
              ],
              [
                46.006086,
                35.645305
              ],
              [
                46.00593,
                35.645327
              ],
              [
                46.005834,
                35.645321
              ],
              [
                46.005711,
                35.645201
              ],
              [
                46.005642,
                35.645188
              ],
              [
                46.005529,
                35.645203
              ],
              [
                46.005408,
                35.645239
              ],
              [
                46.005286,
                35.645212
              ],
              [
                46.005285,
                35.645106
              ],
              [
                46.005318,
                35.645006
              ],
              [
                46.005342,
                35.644801
              ],
              [
                46.005393,
                35.64473
              ],
              [
                46.005409,
                35.644652
              ],
              [
                46.00533,
                35.644596
              ],
              [
                46.005243,
                35.644596
              ],
              [
                46.005149,
                35.64464
              ],
              [
                46.005115,
                35.644689
              ],
              [
                46.005184,
                35.644724
              ],
              [
                46.005176,
                35.64476
              ],
              [
                46.005064,
                35.644775
              ],
              [
                46.005038,
                35.644818
              ],
              [
                46.00503,
                35.644853
              ],
              [
                46.00497,
                35.644896
              ],
              [
                46.004822,
                35.644876
              ],
              [
                46.004778,
                35.644791
              ],
              [
                46.004665,
                35.644799
              ],
              [
                46.004612,
                35.644779
              ],
              [
                46.004568,
                35.644715
              ],
              [
                46.004602,
                35.644609
              ],
              [
                46.004618,
                35.644538
              ],
              [
                46.004565,
                35.644411
              ],
              [
                46.004528,
                35.644284
              ],
              [
                46.004415,
                35.644242
              ],
              [
                46.004268,
                35.64425
              ],
              [
                46.004182,
                35.644322
              ],
              [
                46.004087,
                35.644372
              ],
              [
                46.003983,
                35.644366
              ],
              [
                46.003877,
                35.644268
              ],
              [
                46.003771,
                35.644077
              ],
              [
                46.003744,
                35.644014
              ],
              [
                46.003821,
                35.64395
              ],
              [
                46.003803,
                35.643893
              ],
              [
                46.00369,
                35.643887
              ],
              [
                46.003689,
                35.643802
              ],
              [
                46.003515,
                35.643768
              ],
              [
                46.003411,
                35.64379
              ],
              [
                46.003335,
                35.643883
              ],
              [
                46.00324,
                35.64399
              ],
              [
                46.003154,
                35.644047
              ],
              [
                46.00305,
                35.644013
              ],
              [
                46.002962,
                35.643928
              ],
              [
                46.0029,
                35.643823
              ],
              [
                46.002873,
                35.643738
              ],
              [
                46.002803,
                35.643731
              ],
              [
                46.0027,
                35.643739
              ],
              [
                46.002587,
                35.643776
              ],
              [
                46.002562,
                35.643826
              ],
              [
                46.002588,
                35.643854
              ],
              [
                46.002545,
                35.643889
              ],
              [
                46.002468,
                35.643925
              ],
              [
                46.00233,
                35.644004
              ],
              [
                46.002183,
                35.644027
              ],
              [
                46.002045,
                35.644099
              ],
              [
                46.001968,
                35.644192
              ],
              [
                46.001908,
                35.644263
              ],
              [
                46.001752,
                35.644278
              ],
              [
                46.001647,
                35.644223
              ],
              [
                46.001576,
                35.644089
              ],
              [
                46.001583,
                35.643982
              ],
              [
                46.001626,
                35.643918
              ],
              [
                46.001582,
                35.643841
              ],
              [
                46.001433,
                35.643757
              ],
              [
                46.001311,
                35.643694
              ],
              [
                46.001284,
                35.643638
              ],
              [
                46.001283,
                35.643595
              ],
              [
                46.001231,
                35.643525
              ],
              [
                46.001221,
                35.643447
              ],
              [
                46.001237,
                35.643369
              ],
              [
                46.001263,
                35.643319
              ],
              [
                46.001358,
                35.643283
              ],
              [
                46.001462,
                35.643282
              ],
              [
                46.001505,
                35.643254
              ],
              [
                46.001496,
                35.643197
              ],
              [
                46.001434,
                35.643148
              ],
              [
                46.001425,
                35.643063
              ],
              [
                46.001406,
                35.642999
              ],
              [
                46.001319,
                35.642936
              ],
              [
                46.001153,
                35.642888
              ],
              [
                46.001013,
                35.642741
              ],
              [
                46.000952,
                35.642706
              ],
              [
                46.000665,
                35.642659
              ],
              [
                46.000429,
                35.642561
              ],
              [
                46.000385,
                35.642498
              ],
              [
                46.000393,
                35.642434
              ],
              [
                46.000486,
                35.642278
              ],
              [
                46.000529,
                35.642199
              ],
              [
                46.000511,
                35.642143
              ],
              [
                46.000416,
                35.642158
              ],
              [
                46.000346,
                35.642173
              ],
              [
                46.00025,
                35.642103
              ],
              [
                46.000111,
                35.642075
              ],
              [
                45.99992,
                35.642084
              ],
              [
                45.999824,
                35.642064
              ],
              [
                45.999761,
                35.64188
              ],
              [
                45.999743,
                35.641781
              ],
              [
                45.99982,
                35.641695
              ],
              [
                45.999879,
                35.641546
              ],
              [
                45.99986,
                35.641447
              ],
              [
                45.999764,
                35.641413
              ],
              [
                45.99959,
                35.641357
              ],
              [
                45.999398,
                35.641246
              ],
              [
                45.999379,
                35.64114
              ],
              [
                45.9993,
                35.641034
              ],
              [
                45.999116,
                35.640943
              ],
              [
                45.998968,
                35.640888
              ],
              [
                45.99875,
                35.640805
              ],
              [
                45.998595,
                35.640863
              ],
              [
                45.998371,
                35.640978
              ],
              [
                45.998214,
                35.640972
              ],
              [
                45.998039,
                35.640839
              ],
              [
                45.997856,
                35.640777
              ],
              [
                45.99769,
                35.640693
              ],
              [
                45.997533,
                35.64061
              ],
              [
                45.997436,
                35.640483
              ],
              [
                45.997382,
                35.64032
              ],
              [
                45.997337,
                35.640193
              ],
              [
                45.997267,
                35.640166
              ],
              [
                45.997205,
                35.640074
              ],
              [
                45.997136,
                35.640046
              ],
              [
                45.996954,
                35.640097
              ],
              [
                45.996825,
                35.640176
              ],
              [
                45.996748,
                35.640276
              ],
              [
                45.996567,
                35.640391
              ],
              [
                45.996395,
                35.640442
              ],
              [
                45.99623,
                35.640443
              ],
              [
                45.996073,
                35.640367
              ],
              [
                45.995933,
                35.640318
              ],
              [
                45.995838,
                35.640376
              ],
              [
                45.995656,
                35.64037
              ],
              [
                45.9955,
                35.640357
              ],
              [
                45.995327,
                35.640394
              ],
              [
                45.995136,
                35.640382
              ],
              [
                45.995041,
                35.640418
              ],
              [
                45.995086,
                35.640517
              ],
              [
                45.995104,
                35.640644
              ],
              [
                45.995044,
                35.64068
              ],
              [
                45.994932,
                35.640695
              ],
              [
                45.994749,
                35.640661
              ],
              [
                45.994435,
                35.640529
              ],
              [
                45.994269,
                35.640417
              ],
              [
                45.994163,
                35.640283
              ],
              [
                45.994152,
                35.640121
              ],
              [
                45.994159,
                35.639972
              ],
              [
                45.99414,
                35.639837
              ],
              [
                45.994026,
                35.639732
              ],
              [
                45.994007,
                35.639598
              ],
              [
                45.994067,
                35.639534
              ],
              [
                45.994108,
                35.639377
              ],
              [
                45.994125,
                35.639285
              ],
              [
                45.994037,
                35.639243
              ],
              [
                45.993951,
                35.639294
              ],
              [
                45.993812,
                35.639295
              ],
              [
                45.993759,
                35.639161
              ],
              [
                45.993792,
                35.63904
              ],
              [
                45.99393,
                35.638954
              ],
              [
                45.994041,
                35.638861
              ],
              [
                45.994118,
                35.638775
              ],
              [
                45.99417,
                35.638704
              ],
              [
                45.994151,
                35.638626
              ],
              [
                45.994176,
                35.638527
              ],
              [
                45.994253,
                35.638441
              ],
              [
                45.994312,
                35.638335
              ],
              [
                45.994284,
                35.638179
              ],
              [
                45.994195,
                35.637974
              ],
              [
                45.994272,
                35.63791
              ],
              [
                45.994384,
                35.637831
              ],
              [
                45.994513,
                35.637759
              ],
              [
                45.994634,
                35.637645
              ],
              [
                45.994692,
                35.637496
              ],
              [
                45.994682,
                35.637368
              ],
              [
                45.994551,
                35.63727
              ],
              [
                45.994454,
                35.637165
              ],
              [
                45.994426,
                35.636995
              ],
              [
                45.994285,
                35.636869
              ],
              [
                45.994163,
                35.636757
              ],
              [
                45.993986,
                35.636524
              ],
              [
                45.993855,
                35.636419
              ],
              [
                45.993819,
                35.636342
              ],
              [
                45.993853,
                35.636249
              ],
              [
                45.99392,
                35.636114
              ],
              [
                45.994014,
                35.635979
              ],
              [
                45.994135,
                35.635879
              ],
              [
                45.994246,
                35.635786
              ],
              [
                45.994314,
                35.635693
              ],
              [
                45.994261,
                35.635623
              ],
              [
                45.994183,
                35.635609
              ],
              [
                45.993992,
                35.635611
              ],
              [
                45.993767,
                35.635591
              ],
              [
                45.993609,
                35.635501
              ],
              [
                45.993556,
                35.635395
              ],
              [
                45.99359,
                35.635331
              ],
              [
                45.993659,
                35.635302
              ],
              [
                45.993745,
                35.635223
              ],
              [
                45.993805,
                35.635166
              ],
              [
                45.993804,
                35.635095
              ],
              [
                45.993734,
                35.635032
              ],
              [
                45.993586,
                35.635026
              ],
              [
                45.993466,
                35.635105
              ],
              [
                45.99338,
                35.635219
              ],
              [
                45.993294,
                35.635255
              ],
              [
                45.993129,
                35.635228
              ],
              [
                45.992954,
                35.635145
              ],
              [
                45.992876,
                35.635089
              ],
              [
                45.992892,
                35.635004
              ],
              [
                45.992943,
                35.634968
              ],
              [
                45.993056,
                35.634924
              ],
              [
                45.993228,
                35.634845
              ],
              [
                45.993367,
                35.634823
              ],
              [
                45.993392,
                35.634759
              ],
              [
                45.993365,
                35.634688
              ],
              [
                45.993295,
                35.634632
              ],
              [
                45.993165,
                35.634626
              ],
              [
                45.993034,
                35.634556
              ],
              [
                45.992997,
                35.634401
              ],
              [
                45.993171,
                35.634442
              ],
              [
                45.993258,
                35.634427
              ],
              [
                45.993292,
                35.634377
              ],
              [
                45.993317,
                35.634306
              ],
              [
                45.993342,
                35.634193
              ],
              [
                45.993289,
                35.634108
              ],
              [
                45.993279,
                35.634023
              ],
              [
                45.993347,
                35.633938
              ],
              [
                45.993415,
                35.633817
              ],
              [
                45.993465,
                35.633632
              ],
              [
                45.993687,
                35.63334
              ],
              [
                45.993875,
                35.63314
              ],
              [
                45.994038,
                35.632997
              ],
              [
                45.994323,
                35.632881
              ],
              [
                45.994738,
                35.632807
              ],
              [
                45.995189,
                35.632768
              ],
              [
                45.995475,
                35.632766
              ],
              [
                45.995804,
                35.632721
              ],
              [
                45.996254,
                35.632618
              ],
              [
                45.99641,
                35.632602
              ],
              [
                45.99654,
                35.632601
              ],
              [
                45.996756,
                35.632543
              ],
              [
                45.997033,
                35.632491
              ],
              [
                45.99732,
                35.63251
              ],
              [
                45.99752,
                35.632543
              ],
              [
                45.997642,
                35.632613
              ],
              [
                45.997764,
                35.63269
              ],
              [
                45.997938,
                35.632717
              ],
              [
                45.998147,
                35.632786
              ],
              [
                45.998391,
                35.632883
              ],
              [
                45.998532,
                35.632995
              ],
              [
                45.998837,
                35.633092
              ],
              [
                45.999088,
                35.633076
              ],
              [
                45.999157,
                35.633082
              ],
              [
                45.999228,
                35.633167
              ],
              [
                45.999307,
                35.633251
              ],
              [
                45.999577,
                35.633362
              ],
              [
                45.99983,
                35.633459
              ],
              [
                46.000491,
                35.633631
              ],
              [
                46.0007,
                35.633629
              ],
              [
                46.000935,
                35.633705
              ],
              [
                46.001021,
                35.633718
              ],
              [
                46.001213,
                35.633759
              ],
              [
                46.001526,
                35.63382
              ],
              [
                46.001725,
                35.633783
              ],
              [
                46.001942,
                35.63381
              ],
              [
                46.002228,
                35.633765
              ],
              [
                46.002306,
                35.633729
              ],
              [
                46.002426,
                35.633657
              ],
              [
                46.002747,
                35.633619
              ],
              [
                46.002971,
                35.633532
              ],
              [
                46.003186,
                35.633396
              ],
              [
                46.003427,
                35.633217
              ],
              [
                46.003738,
                35.63308
              ],
              [
                46.0041,
                35.632956
              ],
              [
                46.004463,
                35.632854
              ],
              [
                46.004766,
                35.632823
              ],
              [
                46.005035,
                35.6328
              ],
              [
                46.005329,
                35.632726
              ],
              [
                46.005623,
                35.632653
              ],
              [
                46.005969,
                35.632516
              ],
              [
                46.006201,
                35.632372
              ],
              [
                46.00633,
                35.6323
              ],
              [
                46.006503,
                35.63227
              ],
              [
                46.006745,
                35.632212
              ],
              [
                46.006893,
                35.632211
              ],
              [
                46.007023,
                35.632224
              ],
              [
                46.007128,
                35.632272
              ],
              [
                46.007163,
                35.632343
              ],
              [
                46.00727,
                35.632505
              ],
              [
                46.007383,
                35.632582
              ],
              [
                46.007567,
                35.632672
              ],
              [
                46.007731,
                35.632685
              ],
              [
                46.008009,
                35.63269
              ],
              [
                46.008209,
                35.632702
              ],
              [
                46.008426,
                35.6327
              ],
              [
                46.008702,
                35.632592
              ],
              [
                46.008918,
                35.632519
              ],
              [
                46.009108,
                35.632468
              ],
              [
                46.009273,
                35.632446
              ],
              [
                46.009368,
                35.632445
              ],
              [
                46.009533,
                35.632479
              ],
              [
                46.009663,
                35.632456
              ],
              [
                46.009749,
                35.632399
              ],
              [
                46.009661,
                35.632322
              ],
              [
                46.009652,
                35.63223
              ],
              [
                46.009694,
                35.632145
              ],
              [
                46.009684,
                35.632038
              ],
              [
                46.009709,
                35.631982
              ],
              [
                46.009908,
                35.631902
              ],
              [
                46.009993,
                35.631823
              ],
              [
                46.010053,
                35.631695
              ],
              [
                46.010095,
                35.63161
              ],
              [
                46.010181,
                35.631567
              ],
              [
                46.01031,
                35.631516
              ],
              [
                46.010422,
                35.631416
              ],
              [
                46.010453,
                35.631125
              ],
              [
                46.010477,
                35.630955
              ],
              [
                46.010657,
                35.630763
              ],
              [
                46.010794,
                35.630634
              ],
              [
                46.010896,
                35.63047
              ],
              [
                46.011008,
                35.630427
              ],
              [
                46.011128,
                35.630334
              ],
              [
                46.011179,
                35.630199
              ],
              [
                46.011151,
                35.630079
              ],
              [
                46.011072,
                35.629959
              ],
              [
                46.011175,
                35.629901
              ],
              [
                46.011304,
                35.629801
              ],
              [
                46.011406,
                35.629637
              ],
              [
                46.011429,
                35.629446
              ],
              [
                46.011436,
                35.629262
              ],
              [
                46.011286,
                35.629114
              ],
              [
                46.011129,
                35.628981
              ],
              [
                46.011145,
                35.628924
              ],
              [
                46.011145,
                35.628854
              ],
              [
                46.011178,
                35.628768
              ],
              [
                46.011299,
                35.628732
              ],
              [
                46.011506,
                35.628645
              ],
              [
                46.011618,
                35.628538
              ],
              [
                46.011773,
                35.628466
              ],
              [
                46.011885,
                35.628451
              ],
              [
                46.012015,
                35.628421
              ],
              [
                46.01223,
                35.62825
              ],
              [
                46.012272,
                35.6282
              ],
              [
                46.012367,
                35.628128
              ],
              [
                46.012513,
                35.628035
              ],
              [
                46.01266,
                35.627963
              ],
              [
                46.012764,
                35.627926
              ],
              [
                46.012867,
                35.627897
              ],
              [
                46.012945,
                35.627868
              ],
              [
                46.013005,
                35.627783
              ],
              [
                46.013004,
                35.627698
              ],
              [
                46.012977,
                35.627613
              ],
              [
                46.01294,
                35.627436
              ],
              [
                46.012903,
                35.627309
              ],
              [
                46.012816,
                35.627246
              ],
              [
                46.012754,
                35.62714
              ],
              [
                46.012752,
                35.627048
              ],
              [
                46.012803,
                35.626913
              ],
              [
                46.012827,
                35.626779
              ],
              [
                46.012817,
                35.626672
              ],
              [
                46.012869,
                35.626622
              ],
              [
                46.012851,
                35.62658
              ],
              [
                46.01285,
                35.626488
              ],
              [
                46.012857,
                35.626396
              ],
              [
                46.012882,
                35.626318
              ],
              [
                46.012889,
                35.626155
              ],
              [
                46.012913,
                35.626013
              ],
              [
                46.012929,
                35.625949
              ],
              [
                46.012929,
                35.625892
              ],
              [
                46.012962,
                35.625743
              ],
              [
                46.012942,
                35.625595
              ],
              [
                46.012889,
                35.625482
              ],
              [
                46.012905,
                35.625354
              ],
              [
                46.012947,
                35.625248
              ],
              [
                46.012918,
                35.625078
              ],
              [
                46.012839,
                35.624973
              ],
              [
                46.012776,
                35.624817
              ],
              [
                46.012707,
                35.624797
              ],
              [
                46.012619,
                35.624698
              ],
              [
                46.012514,
                35.624607
              ],
              [
                46.012459,
                35.624423
              ],
              [
                46.012414,
                35.624254
              ],
              [
                46.012369,
                35.624155
              ],
              [
                46.012253,
                35.623936
              ],
              [
                46.012181,
                35.62371
              ],
              [
                46.012152,
                35.623477
              ],
              [
                46.012177,
                35.623349
              ],
              [
                46.012254,
                35.623264
              ],
              [
                46.012383,
                35.62317
              ],
              [
                46.012399,
                35.623064
              ],
              [
                46.012292,
                35.622845
              ],
              [
                46.012228,
                35.622598
              ],
              [
                46.012225,
                35.622379
              ],
              [
                46.012267,
                35.62223
              ],
              [
                46.012326,
                35.622151
              ],
              [
                46.012481,
                35.622015
              ],
              [
                46.012618,
                35.621929
              ],
              [
                46.012669,
                35.621794
              ],
              [
                46.012684,
                35.621624
              ],
              [
                46.012682,
                35.621454
              ],
              [
                46.012671,
                35.621306
              ],
              [
                46.012712,
                35.621107
              ],
              [
                46.012772,
                35.621028
              ],
              [
                46.012832,
                35.62095
              ],
              [
                46.012909,
                35.620886
              ],
              [
                46.013064,
                35.620828
              ],
              [
                46.013212,
                35.620841
              ],
              [
                46.013334,
                35.620875
              ],
              [
                46.013498,
                35.620817
              ],
              [
                46.013637,
                35.620816
              ],
              [
                46.013741,
                35.620801
              ],
              [
                46.013896,
                35.620729
              ],
              [
                46.014024,
                35.620586
              ],
              [
                46.014074,
                35.620394
              ],
              [
                46.014246,
                35.620265
              ],
              [
                46.014348,
                35.620151
              ],
              [
                46.014424,
                35.619981
              ],
              [
                46.014588,
                35.619908
              ],
              [
                46.014717,
                35.619794
              ],
              [
                46.014775,
                35.619631
              ],
              [
                46.014835,
                35.619545
              ],
              [
                46.01493,
                35.619488
              ],
              [
                46.015033,
                35.619409
              ],
              [
                46.015177,
                35.619202
              ],
              [
                46.015269,
                35.618925
              ],
              [
                46.015328,
                35.618741
              ],
              [
                46.015377,
                35.618563
              ],
              [
                46.015437,
                35.618442
              ],
              [
                46.015487,
                35.618322
              ],
              [
                46.01559,
                35.618207
              ],
              [
                46.015744,
                35.618079
              ],
              [
                46.015752,
                35.617965
              ],
              [
                46.01575,
                35.617831
              ],
              [
                46.015748,
                35.617675
              ],
              [
                46.015651,
                35.617569
              ],
              [
                46.015649,
                35.617385
              ],
              [
                46.015656,
                35.617265
              ],
              [
                46.01569,
                35.617194
              ],
              [
                46.015784,
                35.617087
              ],
              [
                46.015913,
                35.617015
              ],
              [
                46.016025,
                35.616936
              ],
              [
                46.01611,
                35.616801
              ],
              [
                46.016178,
                35.61668
              ],
              [
                46.016167,
                35.616559
              ],
              [
                46.016184,
                35.616496
              ],
              [
                46.016262,
                35.616467
              ],
              [
                46.016426,
                35.616402
              ],
              [
                46.016598,
                35.616266
              ],
              [
                46.016725,
                35.616109
              ],
              [
                46.016784,
                35.615952
              ],
              [
                46.016876,
                35.615654
              ],
              [
                46.016925,
                35.615455
              ],
              [
                46.016906,
                35.615272
              ],
              [
                46.016826,
                35.615109
              ],
              [
                46.016685,
                35.614933
              ],
              [
                46.016605,
                35.614821
              ],
              [
                46.0164474,
                35.6146746
              ],
              [
                46.0161503,
                35.6145422
              ],
              [
                46.016085,
                35.614174
              ],
              [
                46.016067,
                35.614053
              ],
              [
                46.016194,
                35.613868
              ],
              [
                46.016235,
                35.613712
              ],
              [
                46.016251,
                35.613549
              ],
              [
                46.016328,
                35.613449
              ],
              [
                46.016439,
                35.613328
              ],
              [
                46.016568,
                35.613228
              ],
              [
                46.016635,
                35.613093
              ],
              [
                46.016659,
                35.612929
              ],
              [
                46.016622,
                35.612753
              ],
              [
                46.016655,
                35.612561
              ],
              [
                46.016756,
                35.612376
              ],
              [
                46.016875,
                35.61217
              ],
              [
                46.016968,
                35.612006
              ],
              [
                46.017132,
                35.611891
              ],
              [
                46.017244,
                35.611848
              ],
              [
                46.017278,
                35.61177
              ],
              [
                46.017319,
                35.611614
              ],
              [
                46.017387,
                35.611507
              ],
              [
                46.017489,
                35.611322
              ],
              [
                46.017409,
                35.611174
              ],
              [
                46.017312,
                35.611047
              ],
              [
                46.017311,
                35.610948
              ],
              [
                46.01731,
                35.610863
              ],
              [
                46.01736,
                35.610778
              ],
              [
                46.017403,
                35.610699
              ],
              [
                46.01749,
                35.610713
              ],
              [
                46.017524,
                35.610691
              ],
              [
                46.017515,
                35.610635
              ],
              [
                46.017522,
                35.61055
              ],
              [
                46.01746,
                35.610437
              ],
              [
                46.017519,
                35.610309
              ],
              [
                46.01764,
                35.61023
              ],
              [
                46.017674,
                35.610159
              ],
              [
                46.017724,
                35.610017
              ],
              [
                46.017739,
                35.609854
              ],
              [
                46.017807,
                35.609726
              ],
              [
                46.017883,
                35.609569
              ],
              [
                46.017908,
                35.60947
              ],
              [
                46.017863,
                35.609393
              ],
              [
                46.017879,
                35.609244
              ],
              [
                46.017852,
                35.609194
              ],
              [
                46.017765,
                35.60916
              ],
              [
                46.017626,
                35.609133
              ],
              [
                46.017452,
                35.609113
              ],
              [
                46.017148,
                35.60903
              ],
              [
                46.016973,
                35.608954
              ],
              [
                46.016754,
                35.608814
              ],
              [
                46.016666,
                35.608673
              ],
              [
                46.01655,
                35.608448
              ],
              [
                46.016488,
                35.608314
              ],
              [
                46.016417,
                35.608151
              ],
              [
                46.016258,
                35.607954
              ],
              [
                46.016065,
                35.607821
              ],
              [
                46.015891,
                35.607702
              ],
              [
                46.015855,
                35.607625
              ],
              [
                46.015897,
                35.607511
              ],
              [
                46.015939,
                35.607426
              ],
              [
                46.015991,
                35.607376
              ],
              [
                46.016102,
                35.60729
              ],
              [
                46.016136,
                35.607183
              ],
              [
                46.01623,
                35.607076
              ],
              [
                46.016236,
                35.606871
              ],
              [
                46.016129,
                35.606681
              ],
              [
                46.015997,
                35.60654
              ],
              [
                46.015831,
                35.606442
              ],
              [
                46.015744,
                35.606344
              ],
              [
                46.015829,
                35.606251
              ],
              [
                46.01595,
                35.606193
              ],
              [
                46.015922,
                35.606038
              ],
              [
                46.015849,
                35.605812
              ],
              [
                46.015665,
                35.605658
              ],
              [
                46.015353,
                35.605618
              ],
              [
                46.015179,
                35.605598
              ],
              [
                46.015055,
                35.605422
              ],
              [
                46.014924,
                35.605296
              ],
              [
                46.014861,
                35.60514
              ],
              [
                46.014833,
                35.604999
              ],
              [
                46.014762,
                35.604865
              ],
              [
                46.014691,
                35.604738
              ],
              [
                46.014698,
                35.604604
              ],
              [
                46.014567,
                35.604498
              ],
              [
                46.014495,
                35.604322
              ],
              [
                46.014527,
                35.604109
              ],
              [
                46.014448,
                35.603997
              ],
              [
                46.014281,
                35.603856
              ],
              [
                46.014184,
                35.603751
              ],
              [
                46.014182,
                35.603567
              ],
              [
                46.014041,
                35.603363
              ],
              [
                46.013882,
                35.603159
              ],
              [
                46.013786,
                35.603096
              ],
              [
                46.013706,
                35.602983
              ],
              [
                46.013636,
                35.602884
              ],
              [
                46.013556,
                35.602722
              ],
              [
                46.013468,
                35.602603
              ],
              [
                46.013328,
                35.602512
              ],
              [
                46.013239,
                35.602399
              ],
              [
                46.013273,
                35.602257
              ],
              [
                46.013323,
                35.602165
              ],
              [
                46.013286,
                35.601953
              ],
              [
                46.013284,
                35.601818
              ],
              [
                46.013239,
                35.601712
              ],
              [
                46.013185,
                35.60155
              ],
              [
                46.013096,
                35.60131
              ],
              [
                46.013102,
                35.601111
              ],
              [
                46.013109,
                35.60097
              ],
              [
                46.013151,
                35.600828
              ],
              [
                46.013235,
                35.6007
              ],
              [
                46.013339,
                35.600642
              ],
              [
                46.013398,
                35.6005
              ],
              [
                46.013352,
                35.600359
              ],
              [
                46.013307,
                35.600168
              ],
              [
                46.013296,
                35.600019
              ],
              [
                46.013199,
                35.599914
              ],
              [
                46.01319,
                35.599822
              ],
              [
                46.01311,
                35.599674
              ],
              [
                46.0131828,
                35.5995028
              ],
              [
                46.0131369,
                35.5990484
              ],
              [
                46.013082,
                35.598838
              ],
              [
                46.013107,
                35.598753
              ],
              [
                46.013026,
                35.598534
              ],
              [
                46.0131357,
                35.5983398
              ],
              [
                46.0131388,
                35.5981111
              ],
              [
                46.013125,
                35.597429
              ],
              [
                46.013315,
                35.597342
              ],
              [
                46.013338,
                35.597165
              ],
              [
                46.013215,
                35.597038
              ],
              [
                46.013384,
                35.596662
              ],
              [
                46.013556,
                35.596575
              ],
              [
                46.013711,
                35.596432
              ],
              [
                46.013848,
                35.596339
              ],
              [
                46.01395,
                35.596211
              ],
              [
                46.013992,
                35.596055
              ],
              [
                46.013981,
                35.595835
              ],
              [
                46.013971,
                35.59575
              ],
              [
                46.014186,
                35.595642
              ],
              [
                46.014168,
                35.595557
              ],
              [
                46.014011,
                35.595495
              ],
              [
                46.014027,
                35.595374
              ],
              [
                46.014112,
                35.595282
              ],
              [
                46.014085,
                35.595176
              ],
              [
                46.014023,
                35.595056
              ],
              [
                46.013868,
                35.594967
              ],
              [
                46.014045,
                35.594402
              ],
              [
                46.014144,
                35.594105
              ],
              [
                46.014285,
                35.593909
              ],
              [
                46.014427,
                35.59383
              ],
              [
                46.014569,
                35.593699
              ],
              [
                46.014662,
                35.593503
              ],
              [
                46.01482,
                35.593463
              ],
              [
                46.014915,
                35.593436
              ],
              [
                46.014977,
                35.593305
              ],
              [
                46.015072,
                35.593253
              ],
              [
                46.015199,
                35.593226
              ],
              [
                46.015262,
                35.593147
              ],
              [
                46.01534,
                35.593017
              ],
              [
                46.015403,
                35.592977
              ],
              [
                46.015594,
                35.592989
              ],
              [
                46.015657,
                35.592949
              ],
              [
                46.01572,
                35.592896
              ],
              [
                46.015783,
                35.592844
              ],
              [
                46.015782,
                35.592779
              ],
              [
                46.015766,
                35.592727
              ],
              [
                46.015797,
                35.592675
              ],
              [
                46.015924,
                35.592661
              ],
              [
                46.016004,
                35.592686
              ],
              [
                46.016051,
                35.592699
              ],
              [
                46.016067,
                35.592647
              ],
              [
                46.016065,
                35.592543
              ],
              [
                46.016144,
                35.592438
              ],
              [
                46.016316,
                35.592268
              ],
              [
                46.016491,
                35.59224
              ],
              [
                46.01657,
                35.592201
              ],
              [
                46.016569,
                35.592149
              ],
              [
                46.016585,
                35.592084
              ],
              [
                46.01668,
                35.59207
              ],
              [
                46.016823,
                35.59203
              ],
              [
                46.017044,
                35.591963
              ],
              [
                46.017552,
                35.591802
              ],
              [
                46.018185,
                35.591641
              ],
              [
                46.018678,
                35.591585
              ],
              [
                46.019059,
                35.59153
              ],
              [
                46.01925,
                35.591489
              ],
              [
                46.019281,
                35.591437
              ],
              [
                46.019279,
                35.591307
              ],
              [
                46.019231,
                35.591243
              ],
              [
                46.019243,
                35.590996
              ],
              [
                46.019367,
                35.590683
              ],
              [
                46.019476,
                35.590565
              ],
              [
                46.019777,
                35.590406
              ],
              [
                46.020012,
                35.59017
              ],
              [
                46.020091,
                35.590066
              ],
              [
                46.020376,
                35.589985
              ],
              [
                46.020786,
                35.589748
              ],
              [
                46.021118,
                35.589524
              ],
              [
                46.021528,
                35.589235
              ],
              [
                46.021638,
                35.58913
              ],
              [
                46.02178,
                35.589116
              ],
              [
                46.021891,
                35.589063
              ],
              [
                46.022063,
                35.588828
              ],
              [
                46.022424,
                35.588435
              ],
              [
                46.022738,
                35.58812
              ],
              [
                46.022972,
                35.587715
              ],
              [
                46.023143,
                35.587402
              ],
              [
                46.023237,
                35.587271
              ],
              [
                46.023381,
                35.586839
              ],
              [
                46.023419,
                35.586629
              ],
              [
                46.023511,
                35.586279
              ],
              [
                46.023575,
                35.586055
              ],
              [
                46.023669,
                35.585634
              ],
              [
                46.023753,
                35.58523
              ],
              [
                46.0241278,
                35.5848057
              ],
              [
                46.0244065,
                35.5844243
              ],
              [
                46.0245862,
                35.5838456
              ],
              [
                46.0250923,
                35.5831132
              ],
              [
                46.0253556,
                35.5825136
              ],
              [
                46.0259815,
                35.5818956
              ],
              [
                46.0266305,
                35.5818787
              ],
              [
                46.0269002,
                35.5818264
              ],
              [
                46.027483,
                35.581653
              ],
              [
                46.0280171,
                35.5809067
              ],
              [
                46.0283111,
                35.5803733
              ],
              [
                46.028656,
                35.580019
              ],
              [
                46.028619,
                35.57953
              ],
              [
                46.028807,
                35.579067
              ],
              [
                46.029088,
                35.578761
              ],
              [
                46.029878,
                35.578447
              ],
              [
                46.030008,
                35.578082
              ],
              [
                46.0298983,
                35.577581
              ],
              [
                46.029883,
                35.577008
              ],
              [
                46.0297543,
                35.5767227
              ],
              [
                46.0294706,
                35.576611
              ],
              [
                46.0289427,
                35.5763976
              ],
              [
                46.028674,
                35.5759635
              ],
              [
                46.028437,
                35.575339
              ],
              [
                46.02784,
                35.575024
              ],
              [
                46.027397,
                35.574875
              ],
              [
                46.026846,
                35.574464
              ],
              [
                46.026294,
                35.574404
              ],
              [
                46.0257,
                35.574322
              ],
              [
                46.025136,
                35.574263
              ],
              [
                46.024725,
                35.573962
              ],
              [
                46.024205,
                35.573798
              ],
              [
                46.023565,
                35.574036
              ],
              [
                46.023044,
                35.574134
              ],
              [
                46.02254,
                35.574025
              ],
              [
                46.02206,
                35.573961
              ],
              [
                46.021447,
                35.574475
              ],
              [
                46.020272,
                35.574668
              ],
              [
                46.019354,
                35.57456
              ],
              [
                46.01886,
                35.574401
              ],
              [
                46.018284,
                35.574519
              ],
              [
                46.018014,
                35.574862
              ],
              [
                46.01751,
                35.574976
              ],
              [
                46.016954,
                35.575033
              ],
              [
                46.016063,
                35.574405
              ],
              [
                46.015174,
                35.574359
              ],
              [
                46.014395,
                35.574487
              ],
              [
                46.013572,
                35.573797
              ],
              [
                46.013178,
                35.573648
              ],
              [
                46.012662,
                35.573717
              ],
              [
                46.012366,
                35.574055
              ],
              [
                46.01174,
                35.574212
              ],
              [
                46.010686,
                35.573877
              ],
              [
                46.009983,
                35.573935
              ],
              [
                46.0094,
                35.573974
              ],
              [
                46.008537,
                35.574179
              ],
              [
                46.007952,
                35.574473
              ],
              [
                46.007193,
                35.57444
              ],
              [
                46.006671,
                35.574613
              ],
              [
                46.006044,
                35.574795
              ],
              [
                46.005432,
                35.575607
              ],
              [
                46.004951,
                35.576002
              ],
              [
                46.004292,
                35.576474
              ],
              [
                46.004035,
                35.576969
              ],
              [
                46.003757,
                35.577435
              ],
              [
                46.003242,
                35.578011
              ],
              [
                46.002315,
                35.578565
              ],
              [
                46.001735,
                35.578302
              ],
              [
                46.000965,
                35.578064
              ],
              [
                46.000733,
                35.577562
              ],
              [
                46.000427,
                35.577073
              ],
              [
                45.999622,
                35.576754
              ],
              [
                45.998996,
                35.576881
              ],
              [
                45.998451,
                35.576863
              ],
              [
                45.997919,
                35.576733
              ],
              [
                45.997096,
                35.576395
              ],
              [
                45.996258,
                35.576519
              ],
              [
                45.995022,
                35.576999
              ],
              [
                45.994541,
                35.577547
              ],
              [
                45.993978,
                35.578088
              ],
              [
                45.993492,
                35.578669
              ],
              [
                45.992771,
                35.579785
              ],
              [
                45.992181,
                35.58032
              ],
              [
                45.991122,
                35.581139
              ],
              [
                45.990057,
                35.581828
              ],
              [
                45.989605,
                35.582076
              ],
              [
                45.988368,
                35.58187
              ],
              [
                45.987453,
                35.582105
              ],
              [
                45.986649,
                35.582364
              ],
              [
                45.986119,
                35.582615
              ],
              [
                45.98547,
                35.583282
              ],
              [
                45.985009,
                35.583596
              ],
              [
                45.984518,
                35.583895
              ],
              [
                45.983736,
                35.583823
              ],
              [
                45.982826,
                35.583501
              ],
              [
                45.981615,
                35.583661
              ],
              [
                45.980101,
                35.583823
              ],
              [
                45.976859,
                35.585386
              ],
              [
                45.976057,
                35.585655
              ],
              [
                45.975513,
                35.58532
              ],
              [
                45.974894,
                35.585163
              ],
              [
                45.974292,
                35.58497
              ],
              [
                45.97386,
                35.584821
              ],
              [
                45.973302,
                35.584696
              ],
              [
                45.973268,
                35.583982
              ],
              [
                45.973186,
                35.583605
              ],
              [
                45.973209,
                35.583273
              ],
              [
                45.973285,
                35.58279
              ],
              [
                45.972907,
                35.582228
              ],
              [
                45.972584,
                35.581623
              ],
              [
                45.972104,
                35.581178
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2246558376
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.3659551,
          35.3123202
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 819610937
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.1758889,
          35.5219063
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3519259993
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          45.816667,
          35.983333
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32663613
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          45.8843225,
          35.9946631
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3515355261
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.333333,
          36.166667
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32673030
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.2705227,
          36.2427456
        ]
      }
    }
  ]
},
"کرمان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554875,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ارزوئیه",
          "name:en": "Arzuiyeh County",
          "place": "county",
          "population": "38510",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q6513557",
          "wikipedia": "en:Arzuiyeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.0574179,
                28.3879817
              ],
              [
                56.0829838,
                28.3361334
              ],
              [
                56.0840938,
                28.3330715
              ],
              [
                56.084374,
                28.3316846
              ],
              [
                56.0849272,
                28.3305769
              ],
              [
                56.0941882,
                28.3006694
              ],
              [
                56.0943736,
                28.3003012
              ],
              [
                56.1522554,
                28.2634671
              ],
              [
                56.1579859,
                28.2291909
              ],
              [
                56.1582659,
                28.2286327
              ],
              [
                56.1582659,
                28.2283536
              ],
              [
                56.1585859,
                28.2280978
              ],
              [
                56.1624326,
                28.225022
              ],
              [
                56.1743757,
                28.2172423
              ],
              [
                56.235768,
                28.1883575
              ],
              [
                56.2399346,
                28.1861335
              ],
              [
                56.2574344,
                28.1794707
              ],
              [
                56.2704908,
                28.1750228
              ],
              [
                56.2931644,
                28.1674043
              ],
              [
                56.2935471,
                28.1672527
              ],
              [
                56.3197003,
                28.1603238
              ],
              [
                56.3249803,
                28.1586583
              ],
              [
                56.3272036,
                28.1578299
              ],
              [
                56.3280603,
                28.1576865
              ],
              [
                56.3288702,
                28.1575509
              ],
              [
                56.3294399,
                28.1574376
              ],
              [
                56.3763695,
                28.1480976
              ],
              [
                56.402971,
                28.1419367
              ],
              [
                56.4035276,
                28.1422158
              ],
              [
                56.4088043,
                28.1422158
              ],
              [
                56.4090808,
                28.1424948
              ],
              [
                56.4153075,
                28.1358344
              ],
              [
                56.4158641,
                28.1358345
              ],
              [
                56.4166974,
                28.1358344
              ],
              [
                56.4214207,
                28.1358345
              ],
              [
                56.4219773,
                28.1361136
              ],
              [
                56.4289207,
                28.1361135
              ],
              [
                56.4292733,
                28.1359367
              ],
              [
                56.4294772,
                28.1358345
              ],
              [
                56.4345487,
                28.1306398
              ],
              [
                56.4445487,
                28.1306398
              ],
              [
                56.445382,
                28.1309189
              ],
              [
                56.467605,
                28.1320263
              ],
              [
                56.4695516,
                28.1317472
              ],
              [
                56.4751048,
                28.1317472
              ],
              [
                56.4767715,
                28.1320263
              ],
              [
                56.4792715,
                28.1320263
              ],
              [
                56.4809381,
                28.1323054
              ],
              [
                56.4881612,
                28.1323054
              ],
              [
                56.489828,
                28.1325846
              ],
              [
                56.4942747,
                28.1328546
              ],
              [
                56.4989945,
                28.1328547
              ],
              [
                56.5006611,
                28.1331338
              ],
              [
                56.5051076,
                28.1331338
              ],
              [
                56.505941,
                28.1334218
              ],
              [
                56.5184409,
                28.1342502
              ],
              [
                56.5239975,
                28.1353576
              ],
              [
                56.5245508,
                28.1353576
              ],
              [
                56.5339973,
                28.1370324
              ],
              [
                56.5481637,
                28.1389681
              ],
              [
                56.5506637,
                28.1389682
              ],
              [
                56.551777,
                28.1392473
              ],
              [
                56.5617769,
                28.1392473
              ],
              [
                56.5628869,
                28.1395264
              ],
              [
                56.565667,
                28.1395264
              ],
              [
                56.5662201,
                28.1398055
              ],
              [
                56.57122,
                28.1398054
              ],
              [
                56.5717516,
                28.1396274
              ],
              [
                56.5720534,
                28.1395264
              ],
              [
                56.5724648,
                28.1395264
              ],
              [
                56.5748333,
                28.1395264
              ],
              [
                56.5755412,
                28.1393484
              ],
              [
                56.5759433,
                28.1392472
              ],
              [
                56.5761785,
                28.1392472
              ],
              [
                56.6214277,
                28.1565834
              ],
              [
                56.6266592,
                28.1565834
              ],
              [
                56.6269392,
                28.1568534
              ],
              [
                56.6831337,
                28.2301446
              ],
              [
                56.6842437,
                28.231252
              ],
              [
                56.6873004,
                28.235421
              ],
              [
                56.7012976,
                28.2640194
              ],
              [
                56.7109106,
                28.2690087
              ],
              [
                56.7743371,
                28.2794017
              ],
              [
                56.7784161,
                28.2814666
              ],
              [
                56.7807667,
                28.2801686
              ],
              [
                56.7925219,
                28.274196
              ],
              [
                56.7982542,
                28.2717545
              ],
              [
                56.8021203,
                28.2698647
              ],
              [
                56.8097154,
                28.2655557
              ],
              [
                56.8118786,
                28.2646289
              ],
              [
                56.8187706,
                28.2621044
              ],
              [
                56.8245136,
                28.260721
              ],
              [
                56.8287789,
                28.2605698
              ],
              [
                56.8348468,
                28.2608344
              ],
              [
                56.8408339,
                28.260064
              ],
              [
                56.8509879,
                28.2590432
              ],
              [
                56.8608333,
                28.2589378
              ],
              [
                56.8981506,
                28.2643585
              ],
              [
                56.9113761,
                28.2653659
              ],
              [
                56.9165727,
                28.2651846
              ],
              [
                56.9126054,
                28.2990957
              ],
              [
                56.9404789,
                28.309293
              ],
              [
                56.9529526,
                28.3317337
              ],
              [
                56.9577869,
                28.351114
              ],
              [
                56.9736885,
                28.4202939
              ],
              [
                56.9910781,
                28.4564694
              ],
              [
                57.0123846,
                28.5023308
              ],
              [
                57.0588633,
                28.5137378
              ],
              [
                57.0817992,
                28.4831422
              ],
              [
                57.0817992,
                28.4837006
              ],
              [
                57.0815227,
                28.4923121
              ],
              [
                57.0809661,
                28.5009236
              ],
              [
                57.0806893,
                28.5050852
              ],
              [
                57.0804093,
                28.5073102
              ],
              [
                57.0806893,
                28.5075894
              ],
              [
                57.0806893,
                28.5086974
              ],
              [
                57.0806893,
                28.5106432
              ],
              [
                57.0801326,
                28.5134267
              ],
              [
                57.0737427,
                28.5248129
              ],
              [
                57.072076,
                28.5270289
              ],
              [
                57.0717996,
                28.5278666
              ],
              [
                57.0601331,
                28.5389738
              ],
              [
                57.0529098,
                28.5425861
              ],
              [
                57.0001683,
                28.5425862
              ],
              [
                56.9762377,
                28.5337041
              ],
              [
                56.9754043,
                28.5334248
              ],
              [
                56.9712377,
                28.5317583
              ],
              [
                56.969851,
                28.5314791
              ],
              [
                56.9684612,
                28.5311998
              ],
              [
                56.9662377,
                28.530362
              ],
              [
                56.9520714,
                28.5267588
              ],
              [
                56.9456815,
                28.5253715
              ],
              [
                56.9340149,
                28.5231465
              ],
              [
                56.9165152,
                28.5195343
              ],
              [
                56.9154018,
                28.519255
              ],
              [
                56.9120685,
                28.5189758
              ],
              [
                56.9084588,
                28.5184263
              ],
              [
                56.9056821,
                28.518147
              ],
              [
                56.9072603,
                28.5157113
              ],
              [
                56.8936417,
                28.5139201
              ],
              [
                56.892701,
                28.5166163
              ],
              [
                56.8917582,
                28.5192524
              ],
              [
                56.8910335,
                28.5222681
              ],
              [
                56.8899676,
                28.5270822
              ],
              [
                56.8935975,
                28.5319875
              ],
              [
                56.8983008,
                28.5380712
              ],
              [
                56.9051981,
                28.5418999
              ],
              [
                56.9089738,
                28.5444379
              ],
              [
                56.9155576,
                28.5488039
              ],
              [
                56.9276066,
                28.5577643
              ],
              [
                56.9315739,
                28.565114
              ],
              [
                56.9308431,
                28.5718914
              ],
              [
                56.927586,
                28.5802855
              ],
              [
                56.9261269,
                28.5851627
              ],
              [
                56.9229404,
                28.597259
              ],
              [
                56.9208698,
                28.6058997
              ],
              [
                56.8979753,
                28.6093471
              ],
              [
                56.8917956,
                28.6114036
              ],
              [
                56.8890763,
                28.6141161
              ],
              [
                56.8793205,
                28.6179303
              ],
              [
                56.8668143,
                28.6181753
              ],
              [
                56.8627612,
                28.6166527
              ],
              [
                56.8604447,
                28.6159557
              ],
              [
                56.8582095,
                28.6155631
              ],
              [
                56.8540286,
                28.6156196
              ],
              [
                56.8457732,
                28.6168317
              ],
              [
                56.8406569,
                28.6176005
              ],
              [
                56.8320796,
                28.6188124
              ],
              [
                56.8229304,
                28.6219957
              ],
              [
                56.8205809,
                28.6225856
              ],
              [
                56.8189334,
                28.6228302
              ],
              [
                56.8174754,
                28.623414
              ],
              [
                56.8149315,
                28.6250578
              ],
              [
                56.812832,
                28.625743
              ],
              [
                56.8054776,
                28.630835
              ],
              [
                56.7929724,
                28.6306466
              ],
              [
                56.784219,
                28.6290867
              ],
              [
                56.781049,
                28.6282957
              ],
              [
                56.7749562,
                28.626698
              ],
              [
                56.7729451,
                28.626585
              ],
              [
                56.7667268,
                28.6265232
              ],
              [
                56.7575447,
                28.6321205
              ],
              [
                56.7490071,
                28.6391109
              ],
              [
                56.7395321,
                28.6432918
              ],
              [
                56.7333663,
                28.6459194
              ],
              [
                56.727968,
                28.6487066
              ],
              [
                56.7254169,
                28.6507216
              ],
              [
                56.7248839,
                28.6533391
              ],
              [
                56.7235976,
                28.6550748
              ],
              [
                56.7226581,
                28.6569955
              ],
              [
                56.7218631,
                28.6599172
              ],
              [
                56.7209439,
                28.6661683
              ],
              [
                56.719809,
                28.6736835
              ],
              [
                56.720436,
                28.6792936
              ],
              [
                56.7195587,
                28.6875232
              ],
              [
                56.7186716,
                28.6936021
              ],
              [
                56.718519,
                28.6988619
              ],
              [
                56.718885,
                28.7046992
              ],
              [
                56.7192473,
                28.7118189
              ],
              [
                56.7187945,
                28.7182263
              ],
              [
                56.7179946,
                28.7243778
              ],
              [
                56.7180581,
                28.7392849
              ],
              [
                56.7178659,
                28.7487579
              ],
              [
                56.7156477,
                28.7507389
              ],
              [
                56.7152163,
                28.7528813
              ],
              [
                56.7121671,
                28.759603
              ],
              [
                56.7115426,
                28.7632945
              ],
              [
                56.7079603,
                28.7701356
              ],
              [
                56.7044508,
                28.7757915
              ],
              [
                56.7021549,
                28.7796548
              ],
              [
                56.6999222,
                28.7831864
              ],
              [
                56.6964651,
                28.787524
              ],
              [
                56.6953505,
                28.7884779
              ],
              [
                56.6917874,
                28.791994
              ],
              [
                56.6885989,
                28.7943715
              ],
              [
                56.6840308,
                28.7968886
              ],
              [
                56.6798479,
                28.7996152
              ],
              [
                56.6743733,
                28.8008562
              ],
              [
                56.6721,
                28.8012537
              ],
              [
                56.6688537,
                28.8016609
              ],
              [
                56.6666053,
                28.8021188
              ],
              [
                56.659614,
                28.8034387
              ],
              [
                56.6549802,
                28.804
              ],
              [
                56.6504645,
                28.8045453
              ],
              [
                56.6484464,
                28.8048864
              ],
              [
                56.6466173,
                28.8049804
              ],
              [
                56.6448805,
                28.8052034
              ],
              [
                56.6431316,
                28.8054666
              ],
              [
                56.6412265,
                28.8056519
              ],
              [
                56.6390925,
                28.8059715
              ],
              [
                56.6362325,
                28.8062956
              ],
              [
                56.634088,
                28.8065562
              ],
              [
                56.6316809,
                28.8068919
              ],
              [
                56.6292813,
                28.8072276
              ],
              [
                56.6264009,
                28.8075662
              ],
              [
                56.6236125,
                28.807867
              ],
              [
                56.6103046,
                28.8096988
              ],
              [
                56.6031627,
                28.810698
              ],
              [
                56.5924646,
                28.8122774
              ],
              [
                56.575857,
                28.8071489
              ],
              [
                56.5650501,
                28.8041513
              ],
              [
                56.5495396,
                28.7993753
              ],
              [
                56.5431658,
                28.7981557
              ],
              [
                56.5385444,
                28.798983
              ],
              [
                56.5350504,
                28.799883
              ],
              [
                56.5272164,
                28.8005912
              ],
              [
                56.5046999,
                28.8045238
              ],
              [
                56.4883871,
                28.8047494
              ],
              [
                56.4806635,
                28.8048461
              ],
              [
                56.4772849,
                28.8039435
              ],
              [
                56.4719679,
                28.8039042
              ],
              [
                56.468493,
                28.8032864
              ],
              [
                56.4634665,
                28.802854
              ],
              [
                56.4621352,
                28.7983438
              ],
              [
                56.4616867,
                28.7952959
              ],
              [
                56.4498659,
                28.7819385
              ],
              [
                56.4462385,
                28.7782614
              ],
              [
                56.439353,
                28.7698767
              ],
              [
                56.4367003,
                28.7659333
              ],
              [
                56.4341063,
                28.7615267
              ],
              [
                56.431684,
                28.7572561
              ],
              [
                56.4306314,
                28.7526539
              ],
              [
                56.429239,
                28.7505685
              ],
              [
                56.4276082,
                28.7488361
              ],
              [
                56.4261689,
                28.7440572
              ],
              [
                56.4250539,
                28.7335179
              ],
              [
                56.4239822,
                28.7235061
              ],
              [
                56.4235339,
                28.7129896
              ],
              [
                56.4216176,
                28.7057937
              ],
              [
                56.4211549,
                28.6967387
              ],
              [
                56.4197625,
                28.6880486
              ],
              [
                56.4197625,
                28.6840264
              ],
              [
                56.418648,
                28.6729022
              ],
              [
                56.4181137,
                28.6659108
              ],
              [
                56.417365,
                28.6595619
              ],
              [
                56.4165328,
                28.6526299
              ],
              [
                56.41587,
                28.6485962
              ],
              [
                56.4149033,
                28.644728
              ],
              [
                56.414498,
                28.6407476
              ],
              [
                56.4138351,
                28.6366095
              ],
              [
                56.4121819,
                28.6321175
              ],
              [
                56.4087009,
                28.6212954
              ],
              [
                56.4058003,
                28.6144732
              ],
              [
                56.4012319,
                28.6052713
              ],
              [
                56.3988921,
                28.6013495
              ],
              [
                56.3962009,
                28.598129
              ],
              [
                56.3919943,
                28.5929324
              ],
              [
                56.3897413,
                28.5896389
              ],
              [
                56.3882177,
                28.5881827
              ],
              [
                56.3875815,
                28.5871022
              ],
              [
                56.3799906,
                28.5862552
              ],
              [
                56.3739947,
                28.5852779
              ],
              [
                56.3681628,
                28.585504
              ],
              [
                56.3616603,
                28.5842072
              ],
              [
                56.3560867,
                28.5827883
              ],
              [
                56.3461732,
                28.5819969
              ],
              [
                56.34171,
                28.5821853
              ],
              [
                56.3379335,
                28.5819215
              ],
              [
                56.3337707,
                28.5805648
              ],
              [
                56.3285856,
                28.5799232
              ],
              [
                56.3219144,
                28.5789278
              ],
              [
                56.3099339,
                28.5771189
              ],
              [
                56.3002827,
                28.575709
              ],
              [
                56.29448,
                28.5753482
              ],
              [
                56.2911623,
                28.5744967
              ],
              [
                56.287221,
                28.5744589
              ],
              [
                56.2753489,
                28.5733819
              ],
              [
                56.2661624,
                28.5719583
              ],
              [
                56.2616955,
                28.5710978
              ],
              [
                56.2574681,
                28.5706833
              ],
              [
                56.251449,
                28.5694019
              ],
              [
                56.2439542,
                28.5762548
              ],
              [
                56.2318551,
                28.577778
              ],
              [
                56.2205208,
                28.5761858
              ],
              [
                56.2202407,
                28.576465
              ],
              [
                56.214816,
                28.5664774
              ],
              [
                56.2139827,
                28.5667567
              ],
              [
                56.2117629,
                28.5667567
              ],
              [
                56.2109294,
                28.5664774
              ],
              [
                56.2098161,
                28.5664775
              ],
              [
                56.2089827,
                28.5661982
              ],
              [
                56.1789833,
                28.5631443
              ],
              [
                56.1575937,
                28.5578653
              ],
              [
                56.1537036,
                28.5570365
              ],
              [
                56.1528703,
                28.5567573
              ],
              [
                56.1514803,
                28.5567573
              ],
              [
                56.1481471,
                28.5559285
              ],
              [
                56.146757,
                28.5559285
              ],
              [
                56.0932211,
                28.5951122
              ],
              [
                56.0904411,
                28.5945541
              ],
              [
                56.089051,
                28.594554
              ],
              [
                56.0859978,
                28.5937258
              ],
              [
                56.0846078,
                28.5937258
              ],
              [
                56.081551,
                28.5928883
              ],
              [
                56.0801646,
                28.5928884
              ],
              [
                56.0793311,
                28.5926093
              ],
              [
                56.0773846,
                28.5926094
              ],
              [
                56.0765512,
                28.5923302
              ],
              [
                56.0642814,
                28.5876813
              ],
              [
                56.0615047,
                28.5876813
              ],
              [
                56.0613429,
                28.587518
              ],
              [
                56.0612282,
                28.5874023
              ],
              [
                56.0603948,
                28.5874023
              ],
              [
                56.0603948,
                28.5871231
              ],
              [
                56.0601146,
                28.5865649
              ],
              [
                56.0601147,
                28.5860157
              ],
              [
                56.0601146,
                28.5840709
              ],
              [
                56.0240933,
                28.5809042
              ],
              [
                55.9973141,
                28.5643212
              ],
              [
                55.9777447,
                28.5679395
              ],
              [
                55.9228131,
                28.5582903
              ],
              [
                55.9117025,
                28.5368429
              ],
              [
                55.9114258,
                28.5346184
              ],
              [
                55.9111459,
                28.5321148
              ],
              [
                55.9108692,
                28.5310071
              ],
              [
                55.9173199,
                28.5193831
              ],
              [
                55.9318118,
                28.5109291
              ],
              [
                55.9849545,
                28.513953
              ],
              [
                55.9932499,
                28.509232
              ],
              [
                55.9929732,
                28.5084036
              ],
              [
                55.9929732,
                28.5053421
              ],
              [
                55.99325,
                28.5020194
              ],
              [
                55.9935298,
                28.501182
              ],
              [
                55.9940832,
                28.4914661
              ],
              [
                55.9914033,
                28.4481069
              ],
              [
                55.9911267,
                28.4439365
              ],
              [
                55.9908468,
                28.4428285
              ],
              [
                56.0097627,
                28.4011495
              ],
              [
                56.0097627,
                28.3922599
              ],
              [
                56.0097628,
                28.3903234
              ],
              [
                56.0576979,
                28.3888102
              ],
              [
                56.057698,
                28.3885401
              ],
              [
                56.057558,
                28.3882609
              ],
              [
                56.0574179,
                28.3879817
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554894,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان انار",
          "name:ar": "مقاطعة أنار",
          "name:en": "Anar County",
          "place": "county",
          "population": "36897",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q4751607",
          "wikipedia": "en:Anar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.9480966,
                31.0290358
              ],
              [
                54.9482612,
                31.0284619
              ],
              [
                54.9486532,
                31.0270951
              ],
              [
                54.9480966,
                31.025705
              ],
              [
                54.9489298,
                31.016814
              ],
              [
                54.9497632,
                31.0000518
              ],
              [
                54.9469865,
                30.9945909
              ],
              [
                54.9458733,
                30.9923614
              ],
              [
                54.9436533,
                30.9837502
              ],
              [
                54.9444866,
                30.9701386
              ],
              [
                54.9455966,
                30.965147
              ],
              [
                54.9478199,
                30.9601465
              ],
              [
                54.9553199,
                30.9376442
              ],
              [
                54.9569864,
                30.9337539
              ],
              [
                54.9780961,
                30.8957
              ],
              [
                54.9917092,
                30.8784785
              ],
              [
                54.9928192,
                30.8779189
              ],
              [
                55.0008758,
                30.8706983
              ],
              [
                55.0072656,
                30.8651383
              ],
              [
                55.0094889,
                30.8631978
              ],
              [
                55.0150422,
                30.8590279
              ],
              [
                55.0708781,
                30.8273655
              ],
              [
                55.1017142,
                30.8034747
              ],
              [
                55.1042142,
                30.8009747
              ],
              [
                55.1114375,
                30.7951351
              ],
              [
                55.1128274,
                30.7934744
              ],
              [
                55.1225472,
                30.7848641
              ],
              [
                55.142827,
                30.7668042
              ],
              [
                55.1697733,
                30.7479142
              ],
              [
                55.1769966,
                30.7434737
              ],
              [
                55.2025528,
                30.7323546
              ],
              [
                55.2028295,
                30.7320838
              ],
              [
                55.2036628,
                30.731804
              ],
              [
                55.2042195,
                30.731804
              ],
              [
                55.2142194,
                30.7287535
              ],
              [
                55.2744983,
                30.6995842
              ],
              [
                55.2747785,
                30.6993044
              ],
              [
                55.2750551,
                30.6984742
              ],
              [
                55.2747785,
                30.6962451
              ],
              [
                55.2694985,
                30.6734749
              ],
              [
                55.2671714,
                30.6641641
              ],
              [
                55.2667218,
                30.6623653
              ],
              [
                55.2631119,
                30.6523567
              ],
              [
                55.2628319,
                30.6512466
              ],
              [
                55.2642219,
                30.6345869
              ],
              [
                55.2692217,
                30.6120793
              ],
              [
                55.2728316,
                30.6054101
              ],
              [
                55.2753316,
                30.6018003
              ],
              [
                55.2792217,
                30.5968007
              ],
              [
                55.3106111,
                30.5698535
              ],
              [
                55.3128344,
                30.5687435
              ],
              [
                55.3131111,
                30.5687435
              ],
              [
                55.3133911,
                30.5684728
              ],
              [
                55.3139445,
                30.568193
              ],
              [
                55.3156111,
                30.568193
              ],
              [
                55.3161678,
                30.5679133
              ],
              [
                55.3172777,
                30.5679133
              ],
              [
                55.3778368,
                30.5506857
              ],
              [
                55.3817269,
                30.5501353
              ],
              [
                55.3831169,
                30.5495758
              ],
              [
                55.3856167,
                30.549305
              ],
              [
                55.3870034,
                30.5487455
              ],
              [
                55.4217296,
                30.5392971
              ],
              [
                55.4236728,
                30.5390264
              ],
              [
                55.4239495,
                30.5387466
              ],
              [
                55.4247828,
                30.5387466
              ],
              [
                55.4260341,
                30.5383274
              ],
              [
                55.4278395,
                30.5404161
              ],
              [
                55.4278395,
                30.5406868
              ],
              [
                55.4292295,
                30.5426361
              ],
              [
                55.4292294,
                30.5429068
              ],
              [
                55.4311728,
                30.5462458
              ],
              [
                55.4333961,
                30.5490252
              ],
              [
                55.4339527,
                30.5501353
              ],
              [
                55.434506,
                30.5506857
              ],
              [
                55.4347861,
                30.551525
              ],
              [
                55.4406193,
                30.5576345
              ],
              [
                55.4411726,
                30.5584737
              ],
              [
                55.4422859,
                30.5590242
              ],
              [
                55.4486724,
                30.5654135
              ],
              [
                55.4964553,
                30.6081896
              ],
              [
                55.4967318,
                30.6087491
              ],
              [
                55.4992318,
                30.6101389
              ],
              [
                55.5000651,
                30.6106894
              ],
              [
                55.5747908,
                30.6526363
              ],
              [
                55.5753475,
                30.652916
              ],
              [
                55.5778474,
                30.652916
              ],
              [
                55.5781241,
                30.6526362
              ],
              [
                55.5803474,
                30.6526363
              ],
              [
                55.5809007,
                30.6526363
              ],
              [
                55.5828473,
                30.6523565
              ],
              [
                55.6214601,
                30.670695
              ],
              [
                55.6220168,
                30.670695
              ],
              [
                55.6228502,
                30.6715254
              ],
              [
                55.6342366,
                30.6770847
              ],
              [
                55.6350699,
                30.6773645
              ],
              [
                55.6667396,
                30.6929145
              ],
              [
                55.6672962,
                30.6929145
              ],
              [
                55.6678495,
                30.693465
              ],
              [
                55.6931291,
                30.7031941
              ],
              [
                55.6936857,
                30.7031941
              ],
              [
                55.6939625,
                30.7034738
              ],
              [
                55.6945192,
                30.7034738
              ],
              [
                55.6950723,
                30.7037536
              ],
              [
                55.6947957,
                30.7040244
              ],
              [
                55.6447931,
                30.7462442
              ],
              [
                55.6420166,
                30.7487532
              ],
              [
                55.5922905,
                30.7887538
              ],
              [
                55.590624,
                30.7901347
              ],
              [
                55.5781243,
                30.7995845
              ],
              [
                55.5781242,
                30.800135
              ],
              [
                55.5781243,
                30.8004148
              ],
              [
                55.5000652,
                30.8406963
              ],
              [
                55.4922888,
                30.8429166
              ],
              [
                55.4914554,
                30.8429166
              ],
              [
                55.4911754,
                30.8431964
              ],
              [
                55.4903422,
                30.8431964
              ],
              [
                55.4897889,
                30.8434762
              ],
              [
                55.4883988,
                30.8434762
              ],
              [
                55.4725657,
                30.8476461
              ],
              [
                55.4614525,
                30.8529172
              ],
              [
                55.4528427,
                30.8590276
              ],
              [
                55.4525626,
                30.8593074
              ],
              [
                55.4514527,
                30.8601378
              ],
              [
                55.4436727,
                30.8676473
              ],
              [
                55.431173,
                30.8868093
              ],
              [
                55.4303397,
                30.8881992
              ],
              [
                55.4233965,
                30.8984798
              ],
              [
                55.3795037,
                30.9493058
              ],
              [
                55.3522809,
                30.9907003
              ],
              [
                55.3517241,
                30.9915307
              ],
              [
                55.3517242,
                30.9987519
              ],
              [
                55.3511709,
                31.0040323
              ],
              [
                55.3508908,
                31.0054224
              ],
              [
                55.3400577,
                31.0215346
              ],
              [
                55.3358911,
                31.0273657
              ],
              [
                55.3339478,
                31.0295863
              ],
              [
                55.3178347,
                31.0473686
              ],
              [
                55.3095016,
                31.059031
              ],
              [
                55.3086682,
                31.0609808
              ],
              [
                55.3053349,
                31.0659815
              ],
              [
                55.2850552,
                31.088756
              ],
              [
                55.2733886,
                31.0993083
              ],
              [
                55.271722,
                31.1004186
              ],
              [
                55.2644989,
                31.1095898
              ],
              [
                55.264439,
                31.1097696
              ],
              [
                55.2642221,
                31.1104203
              ],
              [
                55.2639455,
                31.1101495
              ],
              [
                55.2594988,
                31.1081997
              ],
              [
                55.2106096,
                31.0912565
              ],
              [
                55.1889399,
                31.0851453
              ],
              [
                55.1847733,
                31.0843148
              ],
              [
                55.1336606,
                31.0723635
              ],
              [
                55.1089377,
                31.0701429
              ],
              [
                55.1019911,
                31.0693124
              ],
              [
                55.0978245,
                31.068473
              ],
              [
                55.0767149,
                31.0657017
              ],
              [
                55.0678249,
                31.0640319
              ],
              [
                55.057545,
                31.062371
              ],
              [
                55.0556018,
                31.0620912
              ],
              [
                55.0544919,
                31.0618113
              ],
              [
                55.0425452,
                31.0598706
              ],
              [
                55.0406021,
                31.0598706
              ],
              [
                55.0397686,
                31.0595908
              ],
              [
                55.0386553,
                31.0595908
              ],
              [
                55.0217122,
                31.05626
              ],
              [
                54.9653196,
                31.034867
              ],
              [
                54.9650431,
                31.0345871
              ],
              [
                54.9564298,
                31.0306967
              ],
              [
                54.9514298,
                31.0295864
              ],
              [
                54.9492066,
                31.0295865
              ],
              [
                54.9489366,
                31.0293134
              ],
              [
                54.9489299,
                31.0293066
              ],
              [
                54.9480966,
                31.0290358
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554909,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بافت",
          "name:en": "Baft County",
          "place": "county",
          "population": "84103",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1287748",
          "wikipedia": "en:Baft County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.0433048,
                28.7889229
              ],
              [
                56.048641,
                28.7571255
              ],
              [
                56.0617385,
                28.7360685
              ],
              [
                56.0603652,
                28.7298187
              ],
              [
                56.0598118,
                28.7231511
              ],
              [
                56.059532,
                28.7209256
              ],
              [
                56.0589786,
                28.7139878
              ],
              [
                56.0586985,
                28.7092666
              ],
              [
                56.058422,
                28.7042569
              ],
              [
                56.0660416,
                28.6967598
              ],
              [
                56.0657615,
                28.6928674
              ],
              [
                56.0654849,
                28.6917591
              ],
              [
                56.0654849,
                28.6817578
              ],
              [
                56.0652084,
                28.6698105
              ],
              [
                56.0623848,
                28.6423097
              ],
              [
                56.065478,
                28.6101414
              ],
              [
                56.0652012,
                28.6095922
              ],
              [
                56.065478,
                28.6087548
              ],
              [
                56.0606715,
                28.5921201
              ],
              [
                56.0603947,
                28.591841
              ],
              [
                56.0603948,
                28.5876813
              ],
              [
                56.0603948,
                28.5874023
              ],
              [
                56.0612282,
                28.5874023
              ],
              [
                56.0613429,
                28.587518
              ],
              [
                56.0615047,
                28.5876813
              ],
              [
                56.0642814,
                28.5876813
              ],
              [
                56.0765512,
                28.5923302
              ],
              [
                56.0773846,
                28.5926094
              ],
              [
                56.0793311,
                28.5926093
              ],
              [
                56.0801646,
                28.5928884
              ],
              [
                56.081551,
                28.5928883
              ],
              [
                56.0846078,
                28.5937258
              ],
              [
                56.0859978,
                28.5937258
              ],
              [
                56.089051,
                28.594554
              ],
              [
                56.0904411,
                28.5945541
              ],
              [
                56.0932211,
                28.5951122
              ],
              [
                56.146757,
                28.5559285
              ],
              [
                56.1481471,
                28.5559285
              ],
              [
                56.1514803,
                28.5567573
              ],
              [
                56.1528703,
                28.5567573
              ],
              [
                56.1537036,
                28.5570365
              ],
              [
                56.1575937,
                28.5578653
              ],
              [
                56.1789833,
                28.5631443
              ],
              [
                56.2089827,
                28.5661982
              ],
              [
                56.2098161,
                28.5664775
              ],
              [
                56.2109294,
                28.5664774
              ],
              [
                56.2117629,
                28.5667567
              ],
              [
                56.2139827,
                28.5667567
              ],
              [
                56.214816,
                28.5664774
              ],
              [
                56.2202407,
                28.576465
              ],
              [
                56.2205208,
                28.5761858
              ],
              [
                56.2318551,
                28.577778
              ],
              [
                56.2439542,
                28.5762548
              ],
              [
                56.251449,
                28.5694019
              ],
              [
                56.2574681,
                28.5706833
              ],
              [
                56.2616955,
                28.5710978
              ],
              [
                56.2661624,
                28.5719583
              ],
              [
                56.2753489,
                28.5733819
              ],
              [
                56.287221,
                28.5744589
              ],
              [
                56.2911623,
                28.5744967
              ],
              [
                56.29448,
                28.5753482
              ],
              [
                56.3002827,
                28.575709
              ],
              [
                56.3099339,
                28.5771189
              ],
              [
                56.3219144,
                28.5789278
              ],
              [
                56.3285856,
                28.5799232
              ],
              [
                56.3337707,
                28.5805648
              ],
              [
                56.3379335,
                28.5819215
              ],
              [
                56.34171,
                28.5821853
              ],
              [
                56.3461732,
                28.5819969
              ],
              [
                56.3560867,
                28.5827883
              ],
              [
                56.3616603,
                28.5842072
              ],
              [
                56.3681628,
                28.585504
              ],
              [
                56.3739947,
                28.5852779
              ],
              [
                56.3799906,
                28.5862552
              ],
              [
                56.3875815,
                28.5871022
              ],
              [
                56.3882177,
                28.5881827
              ],
              [
                56.3897413,
                28.5896389
              ],
              [
                56.3919943,
                28.5929324
              ],
              [
                56.3962009,
                28.598129
              ],
              [
                56.3988921,
                28.6013495
              ],
              [
                56.4012319,
                28.6052713
              ],
              [
                56.4058003,
                28.6144732
              ],
              [
                56.4087009,
                28.6212954
              ],
              [
                56.4121819,
                28.6321175
              ],
              [
                56.4138351,
                28.6366095
              ],
              [
                56.414498,
                28.6407476
              ],
              [
                56.4149033,
                28.644728
              ],
              [
                56.41587,
                28.6485962
              ],
              [
                56.4165328,
                28.6526299
              ],
              [
                56.417365,
                28.6595619
              ],
              [
                56.4181137,
                28.6659108
              ],
              [
                56.418648,
                28.6729022
              ],
              [
                56.4197625,
                28.6840264
              ],
              [
                56.4197625,
                28.6880486
              ],
              [
                56.4211549,
                28.6967387
              ],
              [
                56.4216176,
                28.7057937
              ],
              [
                56.4235339,
                28.7129896
              ],
              [
                56.4239822,
                28.7235061
              ],
              [
                56.4250539,
                28.7335179
              ],
              [
                56.4261689,
                28.7440572
              ],
              [
                56.4276082,
                28.7488361
              ],
              [
                56.429239,
                28.7505685
              ],
              [
                56.4306314,
                28.7526539
              ],
              [
                56.431684,
                28.7572561
              ],
              [
                56.4341063,
                28.7615267
              ],
              [
                56.4367003,
                28.7659333
              ],
              [
                56.439353,
                28.7698767
              ],
              [
                56.4462385,
                28.7782614
              ],
              [
                56.4498659,
                28.7819385
              ],
              [
                56.4616867,
                28.7952959
              ],
              [
                56.4621352,
                28.7983438
              ],
              [
                56.4634665,
                28.802854
              ],
              [
                56.468493,
                28.8032864
              ],
              [
                56.4719679,
                28.8039042
              ],
              [
                56.4772849,
                28.8039435
              ],
              [
                56.4806635,
                28.8048461
              ],
              [
                56.4883871,
                28.8047494
              ],
              [
                56.5046999,
                28.8045238
              ],
              [
                56.5272164,
                28.8005912
              ],
              [
                56.5350504,
                28.799883
              ],
              [
                56.5385444,
                28.798983
              ],
              [
                56.5431658,
                28.7981557
              ],
              [
                56.5495396,
                28.7993753
              ],
              [
                56.5650501,
                28.8041513
              ],
              [
                56.575857,
                28.8071489
              ],
              [
                56.5924646,
                28.8122774
              ],
              [
                56.6031627,
                28.810698
              ],
              [
                56.6103046,
                28.8096988
              ],
              [
                56.6236125,
                28.807867
              ],
              [
                56.6264009,
                28.8075662
              ],
              [
                56.6292813,
                28.8072276
              ],
              [
                56.6316809,
                28.8068919
              ],
              [
                56.634088,
                28.8065562
              ],
              [
                56.6362325,
                28.8062956
              ],
              [
                56.6390925,
                28.8059715
              ],
              [
                56.6412265,
                28.8056519
              ],
              [
                56.6431316,
                28.8054666
              ],
              [
                56.6448805,
                28.8052034
              ],
              [
                56.6466173,
                28.8049804
              ],
              [
                56.6484464,
                28.8048864
              ],
              [
                56.6504645,
                28.8045453
              ],
              [
                56.6549802,
                28.804
              ],
              [
                56.659614,
                28.8034387
              ],
              [
                56.6666053,
                28.8021188
              ],
              [
                56.6688537,
                28.8016609
              ],
              [
                56.6721,
                28.8012537
              ],
              [
                56.6743733,
                28.8008562
              ],
              [
                56.6798479,
                28.7996152
              ],
              [
                56.6840308,
                28.7968886
              ],
              [
                56.6885989,
                28.7943715
              ],
              [
                56.6917874,
                28.791994
              ],
              [
                56.6953505,
                28.7884779
              ],
              [
                56.6964651,
                28.787524
              ],
              [
                56.6999222,
                28.7831864
              ],
              [
                56.7021549,
                28.7796548
              ],
              [
                56.7044508,
                28.7757915
              ],
              [
                56.7079603,
                28.7701356
              ],
              [
                56.7115426,
                28.7632945
              ],
              [
                56.7121671,
                28.759603
              ],
              [
                56.7152163,
                28.7528813
              ],
              [
                56.7156477,
                28.7507389
              ],
              [
                56.7178659,
                28.7487579
              ],
              [
                56.7180581,
                28.7392849
              ],
              [
                56.7179946,
                28.7243778
              ],
              [
                56.7187945,
                28.7182263
              ],
              [
                56.7192473,
                28.7118189
              ],
              [
                56.718885,
                28.7046992
              ],
              [
                56.718519,
                28.6988619
              ],
              [
                56.7186716,
                28.6936021
              ],
              [
                56.7195587,
                28.6875232
              ],
              [
                56.720436,
                28.6792936
              ],
              [
                56.719809,
                28.6736835
              ],
              [
                56.7209439,
                28.6661683
              ],
              [
                56.7218631,
                28.6599172
              ],
              [
                56.7226581,
                28.6569955
              ],
              [
                56.7235976,
                28.6550748
              ],
              [
                56.7248839,
                28.6533391
              ],
              [
                56.7254169,
                28.6507216
              ],
              [
                56.727968,
                28.6487066
              ],
              [
                56.7333663,
                28.6459194
              ],
              [
                56.7395321,
                28.6432918
              ],
              [
                56.7490071,
                28.6391109
              ],
              [
                56.7575447,
                28.6321205
              ],
              [
                56.7667268,
                28.6265232
              ],
              [
                56.7729451,
                28.626585
              ],
              [
                56.7749562,
                28.626698
              ],
              [
                56.781049,
                28.6282957
              ],
              [
                56.784219,
                28.6290867
              ],
              [
                56.7929724,
                28.6306466
              ],
              [
                56.8054776,
                28.630835
              ],
              [
                56.812832,
                28.625743
              ],
              [
                56.8149315,
                28.6250578
              ],
              [
                56.8174754,
                28.623414
              ],
              [
                56.8189334,
                28.6228302
              ],
              [
                56.8205809,
                28.6225856
              ],
              [
                56.8229304,
                28.6219957
              ],
              [
                56.8320796,
                28.6188124
              ],
              [
                56.8406569,
                28.6176005
              ],
              [
                56.8457732,
                28.6168317
              ],
              [
                56.8540286,
                28.6156196
              ],
              [
                56.8582095,
                28.6155631
              ],
              [
                56.8604447,
                28.6159557
              ],
              [
                56.8627612,
                28.6166527
              ],
              [
                56.8668143,
                28.6181753
              ],
              [
                56.8793205,
                28.6179303
              ],
              [
                56.8890763,
                28.6141161
              ],
              [
                56.8917956,
                28.6114036
              ],
              [
                56.8979753,
                28.6093471
              ],
              [
                56.9208698,
                28.6058997
              ],
              [
                56.9387333,
                28.6198737
              ],
              [
                56.9444039,
                28.6263821
              ],
              [
                56.9477704,
                28.6320637
              ],
              [
                56.952857,
                28.6391648
              ],
              [
                56.9591195,
                28.6462769
              ],
              [
                56.9626993,
                28.6532579
              ],
              [
                56.9657893,
                28.6631777
              ],
              [
                56.9598482,
                28.6842473
              ],
              [
                56.9562218,
                28.7014799
              ],
              [
                56.9558785,
                28.7262559
              ],
              [
                56.9538784,
                28.7489096
              ],
              [
                56.9525737,
                28.7585106
              ],
              [
                56.9519955,
                28.7710691
              ],
              [
                56.9515855,
                28.7887525
              ],
              [
                56.9516229,
                28.7935188
              ],
              [
                56.9512185,
                28.7997657
              ],
              [
                56.9377476,
                28.811097
              ],
              [
                56.9293553,
                28.8210797
              ],
              [
                56.9223365,
                28.8292409
              ],
              [
                56.9143767,
                28.8448102
              ],
              [
                56.9139668,
                28.8498765
              ],
              [
                56.9114003,
                28.8899901
              ],
              [
                56.9103035,
                28.901426
              ],
              [
                56.9068938,
                28.9266717
              ],
              [
                56.9094802,
                28.9514142
              ],
              [
                56.9075728,
                28.9637426
              ],
              [
                56.9044112,
                28.9750066
              ],
              [
                56.9007627,
                28.9935839
              ],
              [
                56.8974545,
                29.0186731
              ],
              [
                56.8939222,
                29.0272277
              ],
              [
                56.8909013,
                29.0433272
              ],
              [
                56.8843764,
                29.0730866
              ],
              [
                56.8844038,
                29.0782322
              ],
              [
                56.8898677,
                29.090452
              ],
              [
                56.893812,
                29.0964367
              ],
              [
                56.8962153,
                29.1028536
              ],
              [
                56.8999726,
                29.1087875
              ],
              [
                56.9034309,
                29.1183728
              ],
              [
                56.9041156,
                29.1240481
              ],
              [
                56.9032319,
                29.1297725
              ],
              [
                56.8981259,
                29.1378789
              ],
              [
                56.8948644,
                29.1436106
              ],
              [
                56.8820179,
                29.165747
              ],
              [
                56.8777515,
                29.1748087
              ],
              [
                56.871414,
                29.1804918
              ],
              [
                56.8601037,
                29.185058
              ],
              [
                56.8460081,
                29.1929307
              ],
              [
                56.8173444,
                29.2017704
              ],
              [
                56.773567,
                29.2179538
              ],
              [
                56.7924363,
                29.2491126
              ],
              [
                56.797428,
                29.2552524
              ],
              [
                56.7958831,
                29.2598201
              ],
              [
                56.7927931,
                29.2608685
              ],
              [
                56.7830033,
                29.2603226
              ],
              [
                56.7684173,
                29.2601945
              ],
              [
                56.7583751,
                29.2613177
              ],
              [
                56.7503928,
                29.2650616
              ],
              [
                56.7497062,
                29.2685058
              ],
              [
                56.7522811,
                29.2702653
              ],
              [
                56.7600059,
                29.270752
              ],
              [
                56.7646542,
                29.2718299
              ],
              [
                56.7672586,
                29.2745329
              ],
              [
                56.7682457,
                29.2780142
              ],
              [
                56.768074,
                29.2801853
              ],
              [
                56.766012,
                29.2857008
              ],
              [
                56.7638459,
                29.2911231
              ],
              [
                56.7634358,
                29.2961826
              ],
              [
                56.7756718,
                29.3074518
              ],
              [
                56.7808466,
                29.3117308
              ],
              [
                56.7877382,
                29.3174264
              ],
              [
                56.790643,
                29.3216336
              ],
              [
                56.7845535,
                29.3287236
              ],
              [
                56.7808398,
                29.3340465
              ],
              [
                56.7737882,
                29.3406879
              ],
              [
                56.76997,
                29.3442307
              ],
              [
                56.7627686,
                29.3500838
              ],
              [
                56.7504787,
                29.3607082
              ],
              [
                56.7501353,
                29.3671413
              ],
              [
                56.7486021,
                29.373588
              ],
              [
                56.7483029,
                29.3818336
              ],
              [
                56.7469965,
                29.3871503
              ],
              [
                56.7499447,
                29.3905647
              ],
              [
                56.7463263,
                29.3962481
              ],
              [
                56.7425871,
                29.404273
              ],
              [
                56.7371521,
                29.4124726
              ],
              [
                56.731339,
                29.4198758
              ],
              [
                56.7203359,
                29.4286492
              ],
              [
                56.7076829,
                29.4348414
              ],
              [
                56.6844249,
                29.435145
              ],
              [
                56.6655838,
                29.4359639
              ],
              [
                56.6524441,
                29.4354282
              ],
              [
                56.6350155,
                29.4367102
              ],
              [
                56.609452,
                29.4376257
              ],
              [
                56.5801069,
                29.4558706
              ],
              [
                56.5772295,
                29.4583202
              ],
              [
                56.5725088,
                29.4610853
              ],
              [
                56.5687248,
                29.4640469
              ],
              [
                56.5589197,
                29.4731402
              ],
              [
                56.5544843,
                29.4778239
              ],
              [
                56.5489482,
                29.4860801
              ],
              [
                56.5470921,
                29.4954095
              ],
              [
                56.5518986,
                29.4962126
              ],
              [
                56.5506005,
                29.5006855
              ],
              [
                56.5481435,
                29.5070351
              ],
              [
                56.5421322,
                29.5163059
              ],
              [
                56.5327125,
                29.5304305
              ],
              [
                56.5276089,
                29.5362265
              ],
              [
                56.520019,
                29.5446173
              ],
              [
                56.5099811,
                29.550388
              ],
              [
                56.5003453,
                29.5600184
              ],
              [
                56.4844894,
                29.5662159
              ],
              [
                56.4767217,
                29.5693513
              ],
              [
                56.4670398,
                29.5720743
              ],
              [
                56.4634879,
                29.5724596
              ],
              [
                56.4591889,
                29.5731288
              ],
              [
                56.4525089,
                29.5734203
              ],
              [
                56.4472553,
                29.5733083
              ],
              [
                56.444337,
                29.5733646
              ],
              [
                56.4404255,
                29.5733653
              ],
              [
                56.4356414,
                29.5731699
              ],
              [
                56.4317812,
                29.5717701
              ],
              [
                56.4255383,
                29.5695124
              ],
              [
                56.4194392,
                29.5676691
              ],
              [
                56.4108778,
                29.5619336
              ],
              [
                56.4021861,
                29.5588411
              ],
              [
                56.3978086,
                29.5543997
              ],
              [
                56.3926172,
                29.5524593
              ],
              [
                56.3878153,
                29.5512255
              ],
              [
                56.3833725,
                29.5499132
              ],
              [
                56.379963,
                29.5487688
              ],
              [
                56.3757381,
                29.5472672
              ],
              [
                56.3648551,
                29.543597
              ],
              [
                56.3584851,
                29.5422154
              ],
              [
                56.352566,
                29.5419852
              ],
              [
                56.3478684,
                29.5408676
              ],
              [
                56.3440242,
                29.5397291
              ],
              [
                56.3413275,
                29.5401025
              ],
              [
                56.3344646,
                29.5401217
              ],
              [
                56.322714,
                29.5395244
              ],
              [
                56.3176559,
                29.5326734
              ],
              [
                56.3153941,
                29.5248318
              ],
              [
                56.3158291,
                29.5185026
              ],
              [
                56.321134,
                29.5127514
              ],
              [
                56.3190131,
                29.5093346
              ],
              [
                56.3164427,
                29.5073213
              ],
              [
                56.3113681,
                29.5036422
              ],
              [
                56.3076353,
                29.5005361
              ],
              [
                56.3069057,
                29.4988179
              ],
              [
                56.2996101,
                29.4946718
              ],
              [
                56.2861553,
                29.4854795
              ],
              [
                56.2763499,
                29.4738263
              ],
              [
                56.2702299,
                29.4613492
              ],
              [
                56.2705563,
                29.4496508
              ],
              [
                56.270213,
                29.4398967
              ],
              [
                56.2680244,
                29.4365703
              ],
              [
                56.2668314,
                29.4331957
              ],
              [
                56.2623595,
                29.4251703
              ],
              [
                56.2576285,
                29.4141999
              ],
              [
                56.2564711,
                29.4096201
              ],
              [
                56.2567475,
                29.4045581
              ],
              [
                56.2579822,
                29.4002727
              ],
              [
                56.2604968,
                29.3968528
              ],
              [
                56.2739053,
                29.3818352
              ],
              [
                56.2780061,
                29.3770944
              ],
              [
                56.2816714,
                29.3711056
              ],
              [
                56.2847033,
                29.3668943
              ],
              [
                56.2878408,
                29.3591671
              ],
              [
                56.2896265,
                29.342598
              ],
              [
                56.287874,
                29.3392183
              ],
              [
                56.2852573,
                29.3282873
              ],
              [
                56.2794875,
                29.3110729
              ],
              [
                56.2759665,
                29.2994253
              ],
              [
                56.2735524,
                29.2908779
              ],
              [
                56.2707008,
                29.2817988
              ],
              [
                56.2658976,
                29.2715818
              ],
              [
                56.2594018,
                29.2615909
              ],
              [
                56.2532087,
                29.252005
              ],
              [
                56.2499721,
                29.2475462
              ],
              [
                56.2467356,
                29.2409297
              ],
              [
                56.2404877,
                29.2328056
              ],
              [
                56.2244573,
                29.2168916
              ],
              [
                56.2090121,
                29.2045985
              ],
              [
                56.2037372,
                29.2019217
              ],
              [
                56.1969565,
                29.1969767
              ],
              [
                56.1833953,
                29.1888095
              ],
              [
                56.1746406,
                29.1818406
              ],
              [
                56.1676025,
                29.1765949
              ],
              [
                56.1620235,
                29.1737471
              ],
              [
                56.1532687,
                29.1681263
              ],
              [
                56.1512983,
                29.1657465
              ],
              [
                56.1366176,
                29.150962
              ],
              [
                56.1266344,
                29.137363
              ],
              [
                56.1073116,
                29.0926905
              ],
              [
                56.0959952,
                29.0695377
              ],
              [
                56.0599764,
                28.989974
              ],
              [
                56.0440428,
                28.9487098
              ],
              [
                56.0422894,
                28.9246366
              ],
              [
                56.0361096,
                28.837757
              ],
              [
                56.0433048,
                28.7889229
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554918,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بردسیر",
          "name:en": "Bardsir County",
          "place": "county",
          "population": "81983",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1286579",
          "wikipedia": "en:Bardsir County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.0170336,
                29.8373448
              ],
              [
                56.0178669,
                29.8373449
              ],
              [
                56.0198103,
                29.8376155
              ],
              [
                56.060923,
                29.8342871
              ],
              [
                56.0700896,
                29.834287
              ],
              [
                56.0703661,
                29.8340075
              ],
              [
                56.0714796,
                29.8342871
              ],
              [
                56.0745361,
                29.834287
              ],
              [
                56.0753694,
                29.8345667
              ],
              [
                56.1779019,
                29.7774901
              ],
              [
                56.2728766,
                29.811503
              ],
              [
                56.2745432,
                29.8090045
              ],
              [
                56.2748198,
                29.8084453
              ],
              [
                56.287043,
                29.7984516
              ],
              [
                56.290933,
                29.7970625
              ],
              [
                56.3220458,
                29.7809537
              ],
              [
                56.322879,
                29.7801149
              ],
              [
                56.3245456,
                29.779285
              ],
              [
                56.3562118,
                29.7570613
              ],
              [
                56.3567684,
                29.7567817
              ],
              [
                56.3603818,
                29.7526148
              ],
              [
                56.3606585,
                29.7523352
              ],
              [
                56.3609351,
                29.7512259
              ],
              [
                56.3609351,
                29.7509463
              ],
              [
                56.3612152,
                29.7498369
              ],
              [
                56.3626018,
                29.747059
              ],
              [
                56.3692683,
                29.7384457
              ],
              [
                56.3814915,
                29.7156726
              ],
              [
                56.3848248,
                29.7126151
              ],
              [
                56.4298273,
                29.6931704
              ],
              [
                56.4317707,
                29.6926202
              ],
              [
                56.4523304,
                29.6823388
              ],
              [
                56.4551071,
                29.6778926
              ],
              [
                56.4556637,
                29.6762242
              ],
              [
                56.4570502,
                29.6631652
              ],
              [
                56.4567737,
                29.6592782
              ],
              [
                56.4556637,
                29.6520634
              ],
              [
                56.4542736,
                29.6487266
              ],
              [
                56.4431605,
                29.6195612
              ],
              [
                56.4420505,
                29.616504
              ],
              [
                56.4351072,
                29.5928945
              ],
              [
                56.4348271,
                29.592615
              ],
              [
                56.4351072,
                29.5914967
              ],
              [
                56.4348271,
                29.5909466
              ],
              [
                56.4351072,
                29.58761
              ],
              [
                56.4348271,
                29.5873394
              ],
              [
                56.4351073,
                29.5862212
              ],
              [
                56.434827,
                29.5859416
              ],
              [
                56.4351072,
                29.5820549
              ],
              [
                56.4348271,
                29.5814958
              ],
              [
                56.4351072,
                29.5812253
              ],
              [
                56.4361564,
                29.5796133
              ],
              [
                56.4356414,
                29.5731699
              ],
              [
                56.4404255,
                29.5733653
              ],
              [
                56.444337,
                29.5733646
              ],
              [
                56.4472553,
                29.5733083
              ],
              [
                56.4525089,
                29.5734203
              ],
              [
                56.4591889,
                29.5731288
              ],
              [
                56.4634879,
                29.5724596
              ],
              [
                56.4670398,
                29.5720743
              ],
              [
                56.4767217,
                29.5693513
              ],
              [
                56.4844894,
                29.5662159
              ],
              [
                56.5003453,
                29.5600184
              ],
              [
                56.5099811,
                29.550388
              ],
              [
                56.520019,
                29.5446173
              ],
              [
                56.5276089,
                29.5362265
              ],
              [
                56.5327125,
                29.5304305
              ],
              [
                56.5421322,
                29.5163059
              ],
              [
                56.5481435,
                29.5070351
              ],
              [
                56.5506005,
                29.5006855
              ],
              [
                56.5518986,
                29.4962126
              ],
              [
                56.5470921,
                29.4954095
              ],
              [
                56.5489482,
                29.4860801
              ],
              [
                56.5544843,
                29.4778239
              ],
              [
                56.5589197,
                29.4731402
              ],
              [
                56.5687248,
                29.4640469
              ],
              [
                56.5725088,
                29.4610853
              ],
              [
                56.5772295,
                29.4583202
              ],
              [
                56.5801069,
                29.4558706
              ],
              [
                56.609452,
                29.4376257
              ],
              [
                56.6350155,
                29.4367102
              ],
              [
                56.6524441,
                29.4354282
              ],
              [
                56.6655838,
                29.4359639
              ],
              [
                56.6844249,
                29.435145
              ],
              [
                56.7076829,
                29.4348414
              ],
              [
                56.7203359,
                29.4286492
              ],
              [
                56.731339,
                29.4198758
              ],
              [
                56.7371521,
                29.4124726
              ],
              [
                56.7425871,
                29.404273
              ],
              [
                56.7463263,
                29.3962481
              ],
              [
                56.7499447,
                29.3905647
              ],
              [
                56.7469965,
                29.3871503
              ],
              [
                56.7530512,
                29.3879011
              ],
              [
                56.7569436,
                29.3880153
              ],
              [
                56.7664708,
                29.3893809
              ],
              [
                56.7868005,
                29.3973922
              ],
              [
                56.8005179,
                29.4036377
              ],
              [
                56.8048524,
                29.4054321
              ],
              [
                56.8142844,
                29.4103085
              ],
              [
                56.8294627,
                29.4173052
              ],
              [
                56.8436522,
                29.4282665
              ],
              [
                56.8585394,
                29.4407937
              ],
              [
                56.8816368,
                29.4653534
              ],
              [
                56.890685,
                29.4754875
              ],
              [
                56.8965097,
                29.4775213
              ],
              [
                56.9185351,
                29.4706879
              ],
              [
                56.9274495,
                29.4663166
              ],
              [
                56.9779978,
                29.4589737
              ],
              [
                57.0014816,
                29.4556854
              ],
              [
                57.0071016,
                29.45766
              ],
              [
                57.0273509,
                29.4552207
              ],
              [
                57.0364385,
                29.4546813
              ],
              [
                57.0513451,
                29.453554
              ],
              [
                57.0662443,
                29.4226102
              ],
              [
                57.0915239,
                29.417056
              ],
              [
                57.0926338,
                29.4164969
              ],
              [
                57.0937471,
                29.4164969
              ],
              [
                57.0940238,
                29.4162174
              ],
              [
                57.0948571,
                29.4162174
              ],
              [
                57.0954138,
                29.4159378
              ],
              [
                57.0970806,
                29.4159379
              ],
              [
                57.0976337,
                29.4156583
              ],
              [
                57.0987472,
                29.4156584
              ],
              [
                57.0993004,
                29.4153878
              ],
              [
                57.1095802,
                29.4139993
              ],
              [
                57.109857,
                29.4137198
              ],
              [
                57.1109669,
                29.4137197
              ],
              [
                57.1115236,
                29.4134402
              ],
              [
                57.1131902,
                29.4134402
              ],
              [
                57.1368031,
                29.4087156
              ],
              [
                57.1387465,
                29.4087156
              ],
              [
                57.1487463,
                29.4070475
              ],
              [
                57.1498596,
                29.4070475
              ],
              [
                57.151803,
                29.4064975
              ],
              [
                57.1545829,
                29.4064974
              ],
              [
                57.1601362,
                29.4059475
              ],
              [
                57.1643027,
                29.4053884
              ],
              [
                57.1651361,
                29.4051089
              ],
              [
                57.1665261,
                29.405109
              ],
              [
                57.1673594,
                29.4048294
              ],
              [
                57.1684727,
                29.4048294
              ],
              [
                57.1693061,
                29.4045499
              ],
              [
                57.1698594,
                29.4045499
              ],
              [
                57.1729159,
                29.4039908
              ],
              [
                57.2087521,
                29.4012228
              ],
              [
                57.2098621,
                29.4009342
              ],
              [
                57.2140288,
                29.4009342
              ],
              [
                57.2170852,
                29.4006637
              ],
              [
                57.2179187,
                29.4003842
              ],
              [
                57.2218052,
                29.4003842
              ],
              [
                57.2223619,
                29.4001047
              ],
              [
                57.2248618,
                29.4001047
              ],
              [
                57.2251418,
                29.4003842
              ],
              [
                57.2312517,
                29.4003842
              ],
              [
                57.2434749,
                29.4026022
              ],
              [
                57.2440316,
                29.4028908
              ],
              [
                57.244585,
                29.4031612
              ],
              [
                57.2448649,
                29.4031612
              ],
              [
                57.2451416,
                29.4031613
              ],
              [
                57.2504181,
                29.4039908
              ],
              [
                57.2509747,
                29.4042703
              ],
              [
                57.2531981,
                29.4042702
              ],
              [
                57.2540314,
                29.4045498
              ],
              [
                57.2665312,
                29.4084449
              ],
              [
                57.2668078,
                29.4089949
              ],
              [
                57.2693079,
                29.4103835
              ],
              [
                57.2726411,
                29.4151082
              ],
              [
                57.270698,
                29.4356662
              ],
              [
                57.2709745,
                29.4359457
              ],
              [
                57.2712546,
                29.4376047
              ],
              [
                57.2720878,
                29.4398319
              ],
              [
                57.2734744,
                29.4426091
              ],
              [
                57.2740313,
                29.4431591
              ],
              [
                57.2743078,
                29.4442772
              ],
              [
                57.2770877,
                29.447884
              ],
              [
                57.2829211,
                29.4509406
              ],
              [
                57.2837545,
                29.4509407
              ],
              [
                57.2851444,
                29.4514997
              ],
              [
                57.2890308,
                29.4514997
              ],
              [
                57.2895876,
                29.4512202
              ],
              [
                57.297924,
                29.4512202
              ],
              [
                57.3012572,
                29.4523293
              ],
              [
                57.3120907,
                29.4576041
              ],
              [
                57.312924,
                29.4578836
              ],
              [
                57.3134771,
                29.4584427
              ],
              [
                57.313477,
                29.4587222
              ],
              [
                57.3140306,
                29.4587223
              ],
              [
                57.3140306,
                29.4592723
              ],
              [
                57.3143107,
                29.4595518
              ],
              [
                57.3143107,
                29.4598313
              ],
              [
                57.3131974,
                29.4639972
              ],
              [
                57.3131974,
                29.4645562
              ],
              [
                57.3126439,
                29.4662244
              ],
              [
                57.2787544,
                29.497054
              ],
              [
                57.2768079,
                29.5003904
              ],
              [
                57.2754212,
                29.5028882
              ],
              [
                57.274588,
                29.5051064
              ],
              [
                57.2734745,
                29.513168
              ],
              [
                57.2737546,
                29.513718
              ],
              [
                57.274588,
                29.5176136
              ],
              [
                57.2845878,
                29.531221
              ],
              [
                57.2864339,
                29.5348056
              ],
              [
                57.2893111,
                29.5403918
              ],
              [
                57.2895878,
                29.5406624
              ],
              [
                57.2901444,
                29.5426102
              ],
              [
                57.2973644,
                29.574001
              ],
              [
                57.2973645,
                29.5814949
              ],
              [
                57.2968109,
                29.5853907
              ],
              [
                57.2965309,
                29.5876091
              ],
              [
                57.2951445,
                29.5973395
              ],
              [
                57.2923644,
                29.6084408
              ],
              [
                57.2879214,
                29.6173327
              ],
              [
                57.2873644,
                29.6176123
              ],
              [
                57.2854214,
                29.6214992
              ],
              [
                57.2798647,
                29.6290024
              ],
              [
                57.2773648,
                29.6312209
              ],
              [
                57.2751415,
                29.6334484
              ],
              [
                57.2306955,
                29.6662217
              ],
              [
                57.2293089,
                29.6673399
              ],
              [
                57.1762496,
                29.7040012
              ],
              [
                57.1734732,
                29.7067791
              ],
              [
                57.1298571,
                29.7537234
              ],
              [
                57.1287471,
                29.7548418
              ],
              [
                57.1279139,
                29.7551123
              ],
              [
                57.1276371,
                29.7556716
              ],
              [
                57.1265238,
                29.7562218
              ],
              [
                57.1248572,
                29.7578904
              ],
              [
                57.1173572,
                29.7740079
              ],
              [
                57.116524,
                29.7798345
              ],
              [
                57.1151375,
                29.7865089
              ],
              [
                57.1148575,
                29.7870591
              ],
              [
                57.1151374,
                29.7873387
              ],
              [
                57.1154141,
                29.7895574
              ],
              [
                57.1156906,
                29.7909465
              ],
              [
                57.1156907,
                29.7917853
              ],
              [
                57.1159708,
                29.7923355
              ],
              [
                57.1159707,
                29.7945633
              ],
              [
                57.1159707,
                29.797621
              ],
              [
                57.1162473,
                29.7981711
              ],
              [
                57.1162473,
                29.7990009
              ],
              [
                57.1159707,
                29.8034476
              ],
              [
                57.116524,
                29.8098335
              ],
              [
                57.1159708,
                29.8217847
              ],
              [
                57.1162474,
                29.8223439
              ],
              [
                57.1165241,
                29.8251129
              ],
              [
                57.1168042,
                29.826502
              ],
              [
                57.1170807,
                29.8303895
              ],
              [
                57.1173573,
                29.8320672
              ],
              [
                57.1176374,
                29.8337268
              ],
              [
                57.1179142,
                29.8351159
              ],
              [
                57.1181907,
                29.8365049
              ],
              [
                57.1184709,
                29.8387239
              ],
              [
                57.119304,
                29.8409518
              ],
              [
                57.1195808,
                29.8423408
              ],
              [
                57.1198573,
                29.8442801
              ],
              [
                57.1201375,
                29.8453896
              ],
              [
                57.120414,
                29.8487269
              ],
              [
                57.1209707,
                29.8545628
              ],
              [
                57.1187474,
                29.87484
              ],
              [
                57.1187474,
                29.8751196
              ],
              [
                57.1187474,
                29.8775485
              ],
              [
                57.1187474,
                29.8829263
              ],
              [
                57.1187475,
                29.8881718
              ],
              [
                57.1193041,
                29.8903908
              ],
              [
                57.1193042,
                29.9026223
              ],
              [
                57.118471,
                29.9120666
              ],
              [
                57.1194079,
                29.9132884
              ],
              [
                57.1194542,
                29.9256496
              ],
              [
                57.1175292,
                29.9380289
              ],
              [
                57.1148488,
                29.9552607
              ],
              [
                57.1138014,
                29.9604069
              ],
              [
                57.1118531,
                29.9782566
              ],
              [
                57.1074884,
                29.9894938
              ],
              [
                57.105614,
                29.9943187
              ],
              [
                57.1084405,
                29.9951507
              ],
              [
                57.1131002,
                30.0017747
              ],
              [
                57.1130492,
                30.0059109
              ],
              [
                57.1103424,
                30.0084105
              ],
              [
                57.1055966,
                30.0093592
              ],
              [
                57.0915779,
                30.0078509
              ],
              [
                57.0788187,
                30.0064767
              ],
              [
                57.0692621,
                30.0084201
              ],
              [
                57.0525367,
                30.009191
              ],
              [
                57.0446042,
                30.0095559
              ],
              [
                57.0345349,
                30.007562
              ],
              [
                57.0230242,
                30.0092391
              ],
              [
                57.0042373,
                30.0079722
              ],
              [
                56.997759,
                30.0050092
              ],
              [
                56.9610951,
                30.0088005
              ],
              [
                56.9559435,
                30.0077537
              ],
              [
                56.9529067,
                30.007064
              ],
              [
                56.9517969,
                30.0070641
              ],
              [
                56.9515166,
                30.0073437
              ],
              [
                56.9495735,
                30.0073437
              ],
              [
                56.949297,
                30.0076234
              ],
              [
                56.9476303,
                30.007894
              ],
              [
                56.9470735,
                30.0076233
              ],
              [
                56.9454069,
                30.0076234
              ],
              [
                56.9451302,
                30.0073437
              ],
              [
                56.9434636,
                30.0073437
              ],
              [
                56.9431836,
                30.0070641
              ],
              [
                56.9362405,
                30.007064
              ],
              [
                56.9356836,
                30.0073437
              ],
              [
                56.9295738,
                30.0073437
              ],
              [
                56.9284604,
                30.0076234
              ],
              [
                56.9259606,
                30.007894
              ],
              [
                56.9140173,
                30.007894
              ],
              [
                56.9137373,
                30.0081737
              ],
              [
                56.9123507,
                30.0081737
              ],
              [
                56.911794,
                30.0084533
              ],
              [
                56.9106841,
                30.0084534
              ],
              [
                56.9101274,
                30.008733
              ],
              [
                56.907904,
                30.0087329
              ],
              [
                56.9076274,
                30.0090126
              ],
              [
                56.9034609,
                30.0090127
              ],
              [
                56.9029041,
                30.0092923
              ],
              [
                56.8973476,
                30.0101223
              ],
              [
                56.8965144,
                30.0103929
              ],
              [
                56.8951275,
                30.0103929
              ],
              [
                56.8951276,
                30.0106815
              ],
              [
                56.8942944,
                30.011045
              ],
              [
                56.8937377,
                30.0112318
              ],
              [
                56.8915142,
                30.0120618
              ],
              [
                56.8898476,
                30.0120618
              ],
              [
                56.889571,
                30.0123414
              ],
              [
                56.8826243,
                30.0123414
              ],
              [
                56.8823479,
                30.0126211
              ],
              [
                56.8815145,
                30.0126212
              ],
              [
                56.8806813,
                30.0129008
              ],
              [
                56.8770712,
                30.0129008
              ],
              [
                56.8670715,
                30.0151199
              ],
              [
                56.8656814,
                30.01512
              ],
              [
                56.8648481,
                30.0153996
              ],
              [
                56.8590149,
                30.0153996
              ],
              [
                56.8429017,
                30.0187284
              ],
              [
                56.8415118,
                30.0187284
              ],
              [
                56.8340118,
                30.0201177
              ],
              [
                56.8323452,
                30.0201176
              ],
              [
                56.8312353,
                30.0203973
              ],
              [
                56.8273453,
                30.0203974
              ],
              [
                56.8267886,
                30.020677
              ],
              [
                56.8254019,
                30.020677
              ],
              [
                56.8229021,
                30.0209567
              ],
              [
                56.820402,
                30.0212273
              ],
              [
                56.8142888,
                30.0212273
              ],
              [
                56.8123454,
                30.0217866
              ],
              [
                56.8112357,
                30.0217866
              ],
              [
                56.8067889,
                30.0226256
              ],
              [
                56.8020656,
                30.0226256
              ],
              [
                56.8012324,
                30.0223459
              ],
              [
                56.8001223,
                30.0223459
              ],
              [
                56.7995657,
                30.0220663
              ],
              [
                56.7978991,
                30.0220663
              ],
              [
                56.7976223,
                30.0217866
              ],
              [
                56.7945658,
                30.0217866
              ],
              [
                56.7937324,
                30.0220663
              ],
              [
                56.7915124,
                30.0220663
              ],
              [
                56.7876225,
                30.0228963
              ],
              [
                56.7862327,
                30.0228962
              ],
              [
                56.7842892,
                30.0234556
              ],
              [
                56.7670663,
                30.0256748
              ],
              [
                56.7598429,
                30.0256748
              ],
              [
                56.7590097,
                30.0253952
              ],
              [
                56.7531764,
                30.0251245
              ],
              [
                56.7490097,
                30.0251245
              ],
              [
                56.7384533,
                30.0256748
              ],
              [
                56.7317867,
                30.0256749
              ],
              [
                56.7276201,
                30.0248449
              ],
              [
                56.7184537,
                30.0248449
              ],
              [
                56.7178969,
                30.0251245
              ],
              [
                56.7090071,
                30.0267935
              ],
              [
                56.707617,
                30.0267934
              ],
              [
                56.7070638,
                30.0267935
              ],
              [
                56.7045638,
                30.0270642
              ],
              [
                56.6990073,
                30.0270642
              ],
              [
                56.6978973,
                30.0273438
              ],
              [
                56.6965072,
                30.0273438
              ],
              [
                56.6953939,
                30.0276235
              ],
              [
                56.6901172,
                30.0276235
              ],
              [
                56.6895606,
                30.0273438
              ],
              [
                56.6870608,
                30.0273438
              ],
              [
                56.6865075,
                30.0270641
              ],
              [
                56.682894,
                30.0262342
              ],
              [
                56.6740042,
                30.0262342
              ],
              [
                56.6726175,
                30.0259546
              ],
              [
                56.6623376,
                30.0259546
              ],
              [
                56.660951,
                30.0256749
              ],
              [
                56.6567811,
                30.0256749
              ],
              [
                56.6556711,
                30.0253953
              ],
              [
                56.6515046,
                30.0251247
              ],
              [
                56.6465048,
                30.0251246
              ],
              [
                56.643448,
                30.0245653
              ],
              [
                56.6370581,
                30.0245653
              ],
              [
                56.6337249,
                30.0251246
              ],
              [
                56.6248383,
                30.0259546
              ],
              [
                56.620115,
                30.0262342
              ],
              [
                56.6162251,
                30.0267936
              ],
              [
                56.6126152,
                30.0267935
              ],
              [
                56.6112251,
                30.0270643
              ],
              [
                56.6090019,
                30.0270642
              ],
              [
                56.6076152,
                30.0273439
              ],
              [
                56.6020586,
                30.0273439
              ],
              [
                56.600392,
                30.0276235
              ],
              [
                56.5214997,
                30.0356795
              ],
              [
                56.5195532,
                30.0359592
              ],
              [
                56.5128865,
                30.0378987
              ],
              [
                56.5117767,
                30.0378988
              ],
              [
                56.5114999,
                30.0381784
              ],
              [
                56.4781638,
                30.0478944
              ],
              [
                56.4312179,
                30.0617874
              ],
              [
                56.4270512,
                30.0631766
              ],
              [
                56.4256612,
                30.0634563
              ],
              [
                56.4239947,
                30.0642953
              ],
              [
                56.4178848,
                30.0659552
              ],
              [
                56.4162182,
                30.0667853
              ],
              [
                56.3942717,
                30.0748414
              ],
              [
                56.3839918,
                30.0795687
              ],
              [
                56.3820486,
                30.0801191
              ],
              [
                56.3528789,
                30.0923433
              ],
              [
                56.3392691,
                30.0990103
              ],
              [
                56.334546,
                30.1015093
              ],
              [
                56.3317694,
                30.1028986
              ],
              [
                56.3303793,
                30.1040083
              ],
              [
                56.2903766,
                30.1276273
              ],
              [
                56.2648204,
                30.1467899
              ],
              [
                56.2639869,
                30.1476289
              ],
              [
                56.2484307,
                30.1617935
              ],
              [
                56.2478773,
                30.1615139
              ],
              [
                56.246764,
                30.1609544
              ],
              [
                56.2459306,
                30.1609544
              ],
              [
                56.2453772,
                30.1606838
              ],
              [
                56.2450973,
                30.160404
              ],
              [
                56.2125977,
                30.1462306
              ],
              [
                56.2039844,
                30.1440112
              ],
              [
                56.2039845,
                30.1445705
              ],
              [
                56.2042613,
                30.1479086
              ],
              [
                56.2045413,
                30.1481793
              ],
              [
                56.2037079,
                30.1540166
              ],
              [
                56.2012078,
                30.1595741
              ],
              [
                56.200928,
                30.1612341
              ],
              [
                56.198708,
                30.1751281
              ],
              [
                56.1953748,
                30.1929019
              ],
              [
                56.1948182,
                30.1942914
              ],
              [
                56.1942613,
                30.1959605
              ],
              [
                56.190928,
                30.1984597
              ],
              [
                56.1870417,
                30.1984597
              ],
              [
                56.1862049,
                30.1981799
              ],
              [
                56.1845383,
                30.1981799
              ],
              [
                56.1695384,
                30.1948508
              ],
              [
                56.1684284,
                30.1942914
              ],
              [
                56.1325922,
                30.1845744
              ],
              [
                56.1314824,
                30.1845744
              ],
              [
                56.1312056,
                30.1842948
              ],
              [
                56.1300923,
                30.1842948
              ],
              [
                56.1214824,
                30.1817956
              ],
              [
                56.1181492,
                30.1809565
              ],
              [
                56.1025427,
                30.1264215
              ],
              [
                56.1097525,
                30.0802354
              ],
              [
                56.0831187,
                30.0517637
              ],
              [
                56.0755458,
                30.0271876
              ],
              [
                56.0612145,
                30.0279822
              ],
              [
                56.0577391,
                30.0138146
              ],
              [
                56.035502,
                29.9975618
              ],
              [
                56.0297739,
                29.9751685
              ],
              [
                56.0308954,
                29.96283
              ],
              [
                56.0378668,
                29.9440092
              ],
              [
                56.0375902,
                29.9417811
              ],
              [
                56.0367568,
                29.9379024
              ],
              [
                56.0364767,
                29.9365041
              ],
              [
                56.0362002,
                29.9354037
              ],
              [
                56.0359235,
                29.9337348
              ],
              [
                56.0356435,
                29.9331755
              ],
              [
                56.0356435,
                29.9328959
              ],
              [
                56.0353667,
                29.9306769
              ],
              [
                56.0345335,
                29.9251203
              ],
              [
                56.0339769,
                29.9223419
              ],
              [
                56.0337001,
                29.9212324
              ],
              [
                56.0334202,
                29.9195636
              ],
              [
                56.0331434,
                29.9181744
              ],
              [
                56.0328668,
                29.9165057
              ],
              [
                56.0325867,
                29.914007
              ],
              [
                56.0323102,
                29.9112287
              ],
              [
                56.0320334,
                29.9092894
              ],
              [
                56.0317535,
                29.9067817
              ],
              [
                56.0314767,
                29.9051219
              ],
              [
                56.0312002,
                29.9048423
              ],
              [
                56.0309201,
                29.9037328
              ],
              [
                56.0307971,
                29.9034842
              ],
              [
                56.0306436,
                29.9026233
              ],
              [
                56.027867,
                29.8928995
              ],
              [
                56.0195337,
                29.8579013
              ],
              [
                56.0192537,
                29.8553937
              ],
              [
                56.0189769,
                29.853734
              ],
              [
                56.0187003,
                29.8528953
              ],
              [
                56.0184203,
                29.8503967
              ],
              [
                56.0181436,
                29.848728
              ],
              [
                56.017867,
                29.84512
              ],
              [
                56.017587,
                29.840114
              ],
              [
                56.0173103,
                29.8398433
              ],
              [
                56.0173103,
                29.8392842
              ],
              [
                56.0173103,
                29.8381747
              ],
              [
                56.0170337,
                29.8376155
              ],
              [
                56.0170336,
                29.8373448
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554934,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بم",
          "name:ar": "مقاطعة بم",
          "name:en": "Bam County",
          "place": "county",
          "population": "228241",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "sqkm": "17755",
          "type": "boundary",
          "wikidata": "Q1278741",
          "wikipedia": "fa:شهرستان بم"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.7012713,
                29.3578808
              ],
              [
                57.705991,
                29.347332
              ],
              [
                57.7212709,
                29.3295525
              ],
              [
                57.7426638,
                29.3014955
              ],
              [
                57.7443306,
                29.2987186
              ],
              [
                57.7451639,
                29.2967712
              ],
              [
                57.7562769,
                29.2726006
              ],
              [
                57.7609968,
                29.2578786
              ],
              [
                57.76405,
                29.2434363
              ],
              [
                57.7651633,
                29.2401006
              ],
              [
                57.7461999,
                29.2067171
              ],
              [
                57.7743523,
                29.1761458
              ],
              [
                57.7935784,
                29.1389684
              ],
              [
                57.8182977,
                29.129372
              ],
              [
                57.8432219,
                29.1395511
              ],
              [
                57.8360393,
                29.0730547
              ],
              [
                57.8364937,
                29.0393275
              ],
              [
                57.8330689,
                29.0282955
              ],
              [
                57.8316124,
                29.0168786
              ],
              [
                57.8332492,
                29.0155283
              ],
              [
                57.8383864,
                29.0137155
              ],
              [
                57.8427993,
                29.012931
              ],
              [
                57.8494713,
                29.013845
              ],
              [
                57.8660888,
                29.0158858
              ],
              [
                57.8729378,
                29.0144552
              ],
              [
                57.8784926,
                29.0107205
              ],
              [
                57.88381,
                29.0044149
              ],
              [
                57.8870066,
                28.9981504
              ],
              [
                57.8940844,
                28.996217
              ],
              [
                57.9021848,
                28.9980716
              ],
              [
                57.9290814,
                28.9973262
              ],
              [
                57.9400488,
                28.9977935
              ],
              [
                57.9524088,
                28.9963215
              ],
              [
                57.9637754,
                28.9863331
              ],
              [
                57.9782197,
                28.9785581
              ],
              [
                57.9864636,
                28.9721714
              ],
              [
                57.9967813,
                28.9591195
              ],
              [
                57.9990814,
                28.9471737
              ],
              [
                57.9998925,
                28.9258776
              ],
              [
                58.024369,
                28.9117292
              ],
              [
                58.0367925,
                28.8990354
              ],
              [
                58.0412604,
                28.8830356
              ],
              [
                58.0555003,
                28.8710398
              ],
              [
                58.0845209,
                28.8598319
              ],
              [
                58.1086747,
                28.8394653
              ],
              [
                58.1160651,
                28.8307806
              ],
              [
                58.1184084,
                28.8269907
              ],
              [
                58.1209319,
                28.8217794
              ],
              [
                58.1286828,
                28.815936
              ],
              [
                58.1401158,
                28.8112319
              ],
              [
                58.1487948,
                28.8078168
              ],
              [
                58.1538534,
                28.8041429
              ],
              [
                58.1686591,
                28.7962455
              ],
              [
                58.1866836,
                28.7833074
              ],
              [
                58.2030772,
                28.7665306
              ],
              [
                58.2125186,
                28.756373
              ],
              [
                58.2271314,
                28.7524913
              ],
              [
                58.2315425,
                28.7481822
              ],
              [
                58.2562923,
                28.7291306
              ],
              [
                58.2598969,
                28.7261954
              ],
              [
                58.2706259,
                28.7225071
              ],
              [
                58.2943152,
                28.7063981
              ],
              [
                58.3118244,
                28.6848655
              ],
              [
                58.3078764,
                28.6676963
              ],
              [
                58.2932852,
                28.6404308
              ],
              [
                58.2925986,
                28.6285281
              ],
              [
                58.3030699,
                28.6161721
              ],
              [
                58.3238409,
                28.5965802
              ],
              [
                58.3329391,
                28.5883655
              ],
              [
                58.3465861,
                28.5804518
              ],
              [
                58.3469747,
                28.5772742
              ],
              [
                58.3484743,
                28.5703516
              ],
              [
                58.352251,
                28.5674116
              ],
              [
                58.366413,
                28.5648487
              ],
              [
                58.3723353,
                28.5646979
              ],
              [
                58.3765411,
                28.5636425
              ],
              [
                58.3806181,
                28.5632279
              ],
              [
                58.3911665,
                28.5634722
              ],
              [
                58.3941364,
                28.5636425
              ],
              [
                58.4297131,
                28.5548223
              ],
              [
                58.4523561,
                28.5325207
              ],
              [
                58.457572,
                28.5253578
              ],
              [
                58.4610407,
                28.5131709
              ],
              [
                58.4612537,
                28.5086798
              ],
              [
                58.4600785,
                28.4999246
              ],
              [
                58.4610016,
                28.4987975
              ],
              [
                58.4679332,
                28.4973758
              ],
              [
                58.486362,
                28.4959745
              ],
              [
                58.4883791,
                28.496545
              ],
              [
                58.496725,
                28.4973847
              ],
              [
                58.4999656,
                28.4983397
              ],
              [
                58.5061454,
                28.5016964
              ],
              [
                58.5128511,
                28.50537
              ],
              [
                58.5212616,
                28.5077278
              ],
              [
                58.5346395,
                28.5098624
              ],
              [
                58.5380228,
                28.5096738
              ],
              [
                58.5395498,
                28.5119742
              ],
              [
                58.5431218,
                28.5130252
              ],
              [
                58.5506659,
                28.5132649
              ],
              [
                58.5536272,
                28.5180154
              ],
              [
                58.5634945,
                28.521749
              ],
              [
                58.5635447,
                28.5263396
              ],
              [
                58.5632228,
                28.5278291
              ],
              [
                58.5607337,
                28.5387629
              ],
              [
                58.5531096,
                28.5547099
              ],
              [
                58.5505569,
                28.6032688
              ],
              [
                58.552322,
                28.6240079
              ],
              [
                58.5522507,
                28.6337592
              ],
              [
                58.5580369,
                28.6488654
              ],
              [
                58.5646838,
                28.6611479
              ],
              [
                58.5681004,
                28.6817961
              ],
              [
                58.5851966,
                28.6939825
              ],
              [
                58.5849233,
                28.6967575
              ],
              [
                58.5846431,
                28.6970369
              ],
              [
                58.5857568,
                28.7003705
              ],
              [
                58.5865901,
                28.7045331
              ],
              [
                58.58659,
                28.7059206
              ],
              [
                58.5868631,
                28.7070379
              ],
              [
                58.5899234,
                28.734537
              ],
              [
                58.5904766,
                28.743151
              ],
              [
                58.5904765,
                28.7562072
              ],
              [
                58.5890902,
                28.7653709
              ],
              [
                58.5888101,
                28.7725884
              ],
              [
                58.5868633,
                28.7928718
              ],
              [
                58.5871434,
                28.804541
              ],
              [
                58.5932569,
                28.8437037
              ],
              [
                58.5935299,
                28.8442625
              ],
              [
                58.59381,
                28.8453709
              ],
              [
                58.5512922,
                28.8667749
              ],
              [
                58.5445486,
                28.8650032
              ],
              [
                58.5310434,
                28.8614549
              ],
              [
                58.5272597,
                28.8604608
              ],
              [
                58.5156364,
                28.8671971
              ],
              [
                58.512371,
                28.8690895
              ],
              [
                58.5088574,
                28.8711257
              ],
              [
                58.5056313,
                28.8826022
              ],
              [
                58.5020458,
                28.895356
              ],
              [
                58.5009437,
                28.8992758
              ],
              [
                58.4972843,
                28.9122902
              ],
              [
                58.4991502,
                28.9328621
              ],
              [
                58.4983941,
                28.9406043
              ],
              [
                58.4977491,
                28.9504823
              ],
              [
                58.4963052,
                28.9725942
              ],
              [
                58.5051755,
                29.0338579
              ],
              [
                58.5354715,
                29.0587139
              ],
              [
                58.5461985,
                29.0754644
              ],
              [
                58.5500194,
                29.205808
              ],
              [
                58.553839,
                29.3359433
              ],
              [
                58.5698815,
                29.4756231
              ],
              [
                58.526866,
                29.4567729
              ],
              [
                58.5263058,
                29.4562137
              ],
              [
                58.5060328,
                29.4470526
              ],
              [
                58.5051996,
                29.4470527
              ],
              [
                58.5046394,
                29.4467731
              ],
              [
                58.5001996,
                29.4464936
              ],
              [
                58.4993663,
                29.4459346
              ],
              [
                58.45908,
                29.4192721
              ],
              [
                58.4579734,
                29.4189926
              ],
              [
                58.443807,
                29.4117703
              ],
              [
                58.4424137,
                29.4106613
              ],
              [
                58.4418605,
                29.4106613
              ],
              [
                58.3846344,
                29.3731622
              ],
              [
                58.382968,
                29.3720532
              ],
              [
                58.3721346,
                29.3648312
              ],
              [
                58.3496349,
                29.3534348
              ],
              [
                58.3385219,
                29.3500989
              ],
              [
                58.323802,
                29.3437156
              ],
              [
                58.3210219,
                29.3426066
              ],
              [
                58.3079622,
                29.3389913
              ],
              [
                58.3074088,
                29.3389913
              ],
              [
                58.3065755,
                29.3389912
              ],
              [
                58.3057422,
                29.3389913
              ],
              [
                58.302129,
                29.3412182
              ],
              [
                58.2921292,
                29.3559414
              ],
              [
                58.260183,
                29.391213
              ],
              [
                58.257963,
                29.3934401
              ],
              [
                58.2568497,
                29.3942696
              ],
              [
                58.2112971,
                29.4281629
              ],
              [
                58.1779578,
                29.4551052
              ],
              [
                58.1754578,
                29.457603
              ],
              [
                58.1379584,
                29.5031666
              ],
              [
                58.1171256,
                29.5239968
              ],
              [
                58.1157318,
                29.5253855
              ],
              [
                58.0757328,
                29.5637196
              ],
              [
                58.0615665,
                29.5706634
              ],
              [
                58.0607329,
                29.5706633
              ],
              [
                58.0601798,
                29.5709429
              ],
              [
                58.0548996,
                29.5709429
              ],
              [
                58.0523999,
                29.5712224
              ],
              [
                58.0032272,
                29.5803848
              ],
              [
                58.0012873,
                29.5812234
              ],
              [
                57.9998939,
                29.5814939
              ],
              [
                57.9673945,
                29.5942816
              ],
              [
                57.9635077,
                29.5956613
              ],
              [
                57.8904491,
                29.622328
              ],
              [
                57.887949,
                29.6231667
              ],
              [
                57.8687827,
                29.6287221
              ],
              [
                57.8687826,
                29.6276128
              ],
              [
                57.8673893,
                29.6253853
              ],
              [
                57.8623892,
                29.6095583
              ],
              [
                57.8582227,
                29.5898358
              ],
              [
                57.8579496,
                29.5892767
              ],
              [
                57.8582227,
                29.58594
              ],
              [
                57.8579496,
                29.5853899
              ],
              [
                57.8579496,
                29.5748299
              ],
              [
                57.8579496,
                29.572891
              ],
              [
                57.8587827,
                29.5623311
              ],
              [
                57.8585027,
                29.5615015
              ],
              [
                57.8587828,
                29.5609424
              ],
              [
                57.8590559,
                29.5567762
              ],
              [
                57.8590558,
                29.5517804
              ],
              [
                57.859616,
                29.5501121
              ],
              [
                57.8598894,
                29.5417798
              ],
              [
                57.8596159,
                29.539832
              ],
              [
                57.8593359,
                29.5378842
              ],
              [
                57.8546091,
                29.5162241
              ],
              [
                57.8546092,
                29.5159446
              ],
              [
                57.8535025,
                29.5126081
              ],
              [
                57.8451695,
                29.499001
              ],
              [
                57.8446094,
                29.4973328
              ],
              [
                57.8437761,
                29.4965032
              ],
              [
                57.8435027,
                29.4956646
              ],
              [
                57.8426695,
                29.494826
              ],
              [
                57.8415561,
                29.4928873
              ],
              [
                57.7921103,
                29.4528876
              ],
              [
                57.7898903,
                29.4512196
              ],
              [
                57.7384975,
                29.4084443
              ],
              [
                57.7357174,
                29.4053877
              ],
              [
                57.7101645,
                29.3787172
              ],
              [
                57.7023847,
                29.3653822
              ],
              [
                57.7012714,
                29.3617757
              ],
              [
                57.7012714,
                29.3614962
              ],
              [
                57.7009912,
                29.3603872
              ],
              [
                57.7012713,
                29.3595488
              ],
              [
                57.7012713,
                29.3584397
              ],
              [
                57.7012713,
                29.3578808
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554983,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جیرفت",
          "name:en": "Jiroft County",
          "place": "county",
          "population": "308585",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1119016",
          "wikipedia": "en:Jiroft County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.8936417,
                28.5139201
              ],
              [
                56.9072603,
                28.5157113
              ],
              [
                56.9056821,
                28.518147
              ],
              [
                56.9084588,
                28.5184263
              ],
              [
                56.9120685,
                28.5189758
              ],
              [
                56.9154018,
                28.519255
              ],
              [
                56.9165152,
                28.5195343
              ],
              [
                56.9340149,
                28.5231465
              ],
              [
                56.9456815,
                28.5253715
              ],
              [
                56.9520714,
                28.5267588
              ],
              [
                56.9662377,
                28.530362
              ],
              [
                56.9684612,
                28.5311998
              ],
              [
                56.969851,
                28.5314791
              ],
              [
                56.9712377,
                28.5317583
              ],
              [
                56.9754043,
                28.5334248
              ],
              [
                56.9762377,
                28.5337041
              ],
              [
                57.0001683,
                28.5425862
              ],
              [
                57.0529098,
                28.5425861
              ],
              [
                57.0601331,
                28.5389738
              ],
              [
                57.0717996,
                28.5278666
              ],
              [
                57.072076,
                28.5270289
              ],
              [
                57.0737427,
                28.5248129
              ],
              [
                57.0801326,
                28.5134267
              ],
              [
                57.0806893,
                28.5106432
              ],
              [
                57.0806893,
                28.5086974
              ],
              [
                57.0806893,
                28.5075894
              ],
              [
                57.0804093,
                28.5073102
              ],
              [
                57.0806893,
                28.5050852
              ],
              [
                57.0809661,
                28.5009236
              ],
              [
                57.0815227,
                28.4923121
              ],
              [
                57.0817992,
                28.4837006
              ],
              [
                57.0817992,
                28.4831422
              ],
              [
                57.0826327,
                28.482863
              ],
              [
                57.0948557,
                28.4781429
              ],
              [
                57.099299,
                28.4750893
              ],
              [
                57.1004124,
                28.4748101
              ],
              [
                57.1323585,
                28.4545342
              ],
              [
                57.1702165,
                28.4284626
              ],
              [
                57.179308,
                28.4163527
              ],
              [
                57.2003693,
                28.4220334
              ],
              [
                57.204231,
                28.4214931
              ],
              [
                57.2241318,
                28.426636
              ],
              [
                57.2672074,
                28.4434454
              ],
              [
                57.2754388,
                28.4443005
              ],
              [
                57.281477,
                28.4408469
              ],
              [
                57.2927983,
                28.4311264
              ],
              [
                57.304673,
                28.4245022
              ],
              [
                57.3154461,
                28.411765
              ],
              [
                57.3389188,
                28.36429
              ],
              [
                57.3493337,
                28.3400365
              ],
              [
                57.3555268,
                28.3300872
              ],
              [
                57.3599223,
                28.3114656
              ],
              [
                57.3716004,
                28.281876
              ],
              [
                57.3744953,
                28.2661427
              ],
              [
                57.3791051,
                28.2604136
              ],
              [
                57.3860548,
                28.2526792
              ],
              [
                57.3967434,
                28.2483135
              ],
              [
                57.4010146,
                28.2403847
              ],
              [
                57.4048543,
                28.2329771
              ],
              [
                57.409044,
                28.2247836
              ],
              [
                57.4148914,
                28.214976
              ],
              [
                57.4192932,
                28.2077729
              ],
              [
                57.4243296,
                28.2005148
              ],
              [
                57.4291521,
                28.1943225
              ],
              [
                57.4340262,
                28.1880033
              ],
              [
                57.4374809,
                28.1835555
              ],
              [
                57.4416034,
                28.180309
              ],
              [
                57.4438209,
                28.1787953
              ],
              [
                57.4460285,
                28.1769652
              ],
              [
                57.4486267,
                28.1749556
              ],
              [
                57.4535417,
                28.1714941
              ],
              [
                57.4563526,
                28.1697681
              ],
              [
                57.4595565,
                28.1684458
              ],
              [
                57.4694042,
                28.1667244
              ],
              [
                57.4751679,
                28.1659675
              ],
              [
                57.4940229,
                28.1683117
              ],
              [
                57.5007455,
                28.1659662
              ],
              [
                57.5194696,
                28.1698485
              ],
              [
                57.533347,
                28.1719671
              ],
              [
                57.5409743,
                28.1724446
              ],
              [
                57.5499985,
                28.1709456
              ],
              [
                57.5618131,
                28.170973
              ],
              [
                57.5723889,
                28.1705401
              ],
              [
                57.6440617,
                28.1631248
              ],
              [
                57.6529883,
                28.1593411
              ],
              [
                57.6611324,
                28.1536194
              ],
              [
                57.6790994,
                28.1354144
              ],
              [
                57.7079106,
                28.1098987
              ],
              [
                57.7152156,
                28.1052979
              ],
              [
                57.7217513,
                28.103165
              ],
              [
                57.7268027,
                28.103708
              ],
              [
                57.7334975,
                28.106055
              ],
              [
                57.7415655,
                28.1137771
              ],
              [
                57.7534102,
                28.1280085
              ],
              [
                57.7595264,
                28.1406814
              ],
              [
                57.7759411,
                28.1697043
              ],
              [
                57.7905059,
                28.1913193
              ],
              [
                57.8214311,
                28.2248664
              ],
              [
                57.81435,
                28.2371788
              ],
              [
                57.8032779,
                28.2493524
              ],
              [
                57.7993297,
                28.2557033
              ],
              [
                57.7907466,
                28.2634146
              ],
              [
                57.7813052,
                28.2735442
              ],
              [
                57.782421,
                28.2772481
              ],
              [
                57.7923774,
                28.2836729
              ],
              [
                57.8014754,
                28.2908531
              ],
              [
                57.7988147,
                28.2935739
              ],
              [
                57.7766704,
                28.3015091
              ],
              [
                57.7742672,
                28.3108794
              ],
              [
                57.7714347,
                28.3139775
              ],
              [
                57.7689886,
                28.3152999
              ],
              [
                57.7677437,
                28.3203249
              ],
              [
                57.7680015,
                28.3268979
              ],
              [
                57.7676581,
                28.3416297
              ],
              [
                57.7691173,
                28.3546977
              ],
              [
                57.7689456,
                28.358852
              ],
              [
                57.7703194,
                28.3625763
              ],
              [
                57.771295,
                28.3651854
              ],
              [
                57.7729483,
                28.3681811
              ],
              [
                57.7754392,
                28.3723546
              ],
              [
                57.778385,
                28.3780456
              ],
              [
                57.779958,
                28.3807111
              ],
              [
                57.785232,
                28.3844346
              ],
              [
                57.7870879,
                28.3862954
              ],
              [
                57.7894163,
                28.3928728
              ],
              [
                57.7909566,
                28.3993612
              ],
              [
                57.7898883,
                28.4120496
              ],
              [
                57.789271,
                28.4245244
              ],
              [
                57.7904845,
                28.4287005
              ],
              [
                57.7919019,
                28.4337994
              ],
              [
                57.7935696,
                28.4426623
              ],
              [
                57.7936435,
                28.4492135
              ],
              [
                57.7918817,
                28.4521888
              ],
              [
                57.7892259,
                28.4564813
              ],
              [
                57.7835184,
                28.4684432
              ],
              [
                57.7911758,
                28.481442
              ],
              [
                57.7916049,
                28.4920034
              ],
              [
                57.7906608,
                28.4987924
              ],
              [
                57.7951669,
                28.5111811
              ],
              [
                57.8061747,
                28.5154234
              ],
              [
                57.8079128,
                28.5211174
              ],
              [
                57.810893,
                28.5257919
              ],
              [
                57.8158288,
                28.5397735
              ],
              [
                57.8182424,
                28.5412221
              ],
              [
                57.8195858,
                28.5423821
              ],
              [
                57.8213882,
                28.5432491
              ],
              [
                57.8255832,
                28.5464554
              ],
              [
                57.8334288,
                28.5503391
              ],
              [
                57.8369235,
                28.5510526
              ],
              [
                57.8416442,
                28.5482631
              ],
              [
                57.8416442,
                28.5378581
              ],
              [
                57.8497981,
                28.5361992
              ],
              [
                57.8580639,
                28.5308893
              ],
              [
                57.8644751,
                28.5329569
              ],
              [
                57.8850744,
                28.5332585
              ],
              [
                57.8953741,
                28.5364255
              ],
              [
                57.900524,
                28.5420052
              ],
              [
                57.9026008,
                28.5639743
              ],
              [
                57.9183768,
                28.5760802
              ],
              [
                57.9406172,
                28.5892974
              ],
              [
                57.9484336,
                28.5882648
              ],
              [
                57.9513621,
                28.5874581
              ],
              [
                57.9580587,
                28.5866979
              ],
              [
                57.9700695,
                28.5851594
              ],
              [
                57.9720781,
                28.5863871
              ],
              [
                57.9748725,
                28.5915655
              ],
              [
                57.9796219,
                28.5984234
              ],
              [
                57.9914255,
                28.606785
              ],
              [
                57.9959922,
                28.6109603
              ],
              [
                58.0000315,
                28.6221565
              ],
              [
                58.0376635,
                28.6489887
              ],
              [
                58.0465815,
                28.6539104
              ],
              [
                58.0599974,
                28.665437
              ],
              [
                58.0835149,
                28.682456
              ],
              [
                58.1025694,
                28.6942018
              ],
              [
                58.1238399,
                28.7049072
              ],
              [
                58.1282758,
                28.7074143
              ],
              [
                58.1303786,
                28.7101621
              ],
              [
                58.1332968,
                28.7188941
              ],
              [
                58.1354321,
                28.7270198
              ],
              [
                58.1406344,
                28.7316256
              ],
              [
                58.1477164,
                28.7354526
              ],
              [
                58.1556987,
                28.7391403
              ],
              [
                58.1756972,
                28.7433547
              ],
              [
                58.1847953,
                28.7460638
              ],
              [
                58.2023048,
                28.7479451
              ],
              [
                58.2116603,
                28.7472302
              ],
              [
                58.2184839,
                28.7478134
              ],
              [
                58.2201147,
                28.7485283
              ],
              [
                58.2271314,
                28.7524913
              ],
              [
                58.2125186,
                28.756373
              ],
              [
                58.2030772,
                28.7665306
              ],
              [
                58.1866836,
                28.7833074
              ],
              [
                58.1686591,
                28.7962455
              ],
              [
                58.1538534,
                28.8041429
              ],
              [
                58.1487948,
                28.8078168
              ],
              [
                58.1401158,
                28.8112319
              ],
              [
                58.1286828,
                28.815936
              ],
              [
                58.1209319,
                28.8217794
              ],
              [
                58.1184084,
                28.8269907
              ],
              [
                58.1160651,
                28.8307806
              ],
              [
                58.1086747,
                28.8394653
              ],
              [
                58.0845209,
                28.8598319
              ],
              [
                58.0555003,
                28.8710398
              ],
              [
                58.0412604,
                28.8830356
              ],
              [
                58.0367925,
                28.8990354
              ],
              [
                58.024369,
                28.9117292
              ],
              [
                57.9998925,
                28.9258776
              ],
              [
                57.9990814,
                28.9471737
              ],
              [
                57.9967813,
                28.9591195
              ],
              [
                57.9864636,
                28.9721714
              ],
              [
                57.9782197,
                28.9785581
              ],
              [
                57.9637754,
                28.9863331
              ],
              [
                57.9524088,
                28.9963215
              ],
              [
                57.9400488,
                28.9977935
              ],
              [
                57.9290814,
                28.9973262
              ],
              [
                57.9021848,
                28.9980716
              ],
              [
                57.8940844,
                28.996217
              ],
              [
                57.8870066,
                28.9981504
              ],
              [
                57.88381,
                29.0044149
              ],
              [
                57.8784926,
                29.0107205
              ],
              [
                57.8729378,
                29.0144552
              ],
              [
                57.8660888,
                29.0158858
              ],
              [
                57.8494713,
                29.013845
              ],
              [
                57.8427993,
                29.012931
              ],
              [
                57.8383864,
                29.0137155
              ],
              [
                57.8332492,
                29.0155283
              ],
              [
                57.8316124,
                29.0168786
              ],
              [
                57.8330689,
                29.0282955
              ],
              [
                57.8364937,
                29.0393275
              ],
              [
                57.8360393,
                29.0730547
              ],
              [
                57.8432219,
                29.1395511
              ],
              [
                57.8182977,
                29.129372
              ],
              [
                57.7935784,
                29.1389684
              ],
              [
                57.7743523,
                29.1761458
              ],
              [
                57.7461999,
                29.2067171
              ],
              [
                57.7651633,
                29.2401006
              ],
              [
                57.76405,
                29.2434363
              ],
              [
                57.7609968,
                29.2578786
              ],
              [
                57.7562769,
                29.2726006
              ],
              [
                57.7451639,
                29.2967712
              ],
              [
                57.7443306,
                29.2987186
              ],
              [
                57.7426638,
                29.3014955
              ],
              [
                57.7212709,
                29.3295525
              ],
              [
                57.705991,
                29.347332
              ],
              [
                57.7012713,
                29.3578808
              ],
              [
                57.6757186,
                29.3573308
              ],
              [
                57.6751584,
                29.3576013
              ],
              [
                57.6723853,
                29.3576013
              ],
              [
                57.6718252,
                29.3578808
              ],
              [
                57.6682184,
                29.3578808
              ],
              [
                57.6676583,
                29.3576013
              ],
              [
                57.6673786,
                29.3578808
              ],
              [
                57.6665449,
                29.3576013
              ],
              [
                57.6451586,
                29.3539949
              ],
              [
                57.6434922,
                29.3537154
              ],
              [
                57.6432121,
                29.3534359
              ],
              [
                57.6412723,
                29.3528859
              ],
              [
                57.6401589,
                29.3528859
              ],
              [
                57.6398788,
                29.3526065
              ],
              [
                57.6384921,
                29.3526064
              ],
              [
                57.638212,
                29.3523269
              ],
              [
                57.6376589,
                29.3523269
              ],
              [
                57.6371058,
                29.3520474
              ],
              [
                57.6365456,
                29.3520474
              ],
              [
                57.6290458,
                29.3492705
              ],
              [
                57.6237657,
                29.3442756
              ],
              [
                57.6154327,
                29.3298321
              ],
              [
                57.6087657,
                29.321213
              ],
              [
                57.6040461,
                29.3153888
              ],
              [
                57.6026594,
                29.3137209
              ],
              [
                57.601546,
                29.3123235
              ],
              [
                57.5690466,
                29.2834375
              ],
              [
                57.5626532,
                29.2803812
              ],
              [
                57.5532064,
                29.277325
              ],
              [
                57.5498732,
                29.2762162
              ],
              [
                57.5379335,
                29.2734394
              ],
              [
                57.5343202,
                29.2734394
              ],
              [
                57.5332068,
                29.2731599
              ],
              [
                57.5298737,
                29.27316
              ],
              [
                57.5293204,
                29.2734394
              ],
              [
                57.5109874,
                29.2756572
              ],
              [
                57.5098741,
                29.2762162
              ],
              [
                57.5090409,
                29.2762162
              ],
              [
                57.5084874,
                29.2764957
              ],
              [
                57.5079271,
                29.2764957
              ],
              [
                57.5065408,
                29.2773251
              ],
              [
                57.5057076,
                29.2773251
              ],
              [
                57.5009876,
                29.2801108
              ],
              [
                57.5001543,
                29.2803813
              ],
              [
                57.5001544,
                29.2806608
              ],
              [
                57.4876546,
                29.2870528
              ],
              [
                57.4712612,
                29.2976011
              ],
              [
                57.4526481,
                29.3064905
              ],
              [
                57.4423753,
                29.3095468
              ],
              [
                57.441262,
                29.3095468
              ],
              [
                57.4404284,
                29.3101058
              ],
              [
                57.430702,
                29.3126032
              ],
              [
                57.4276488,
                29.3128826
              ],
              [
                57.4270953,
                29.3131621
              ],
              [
                57.4262621,
                29.3131622
              ],
              [
                57.4254289,
                29.3134416
              ],
              [
                57.4243155,
                29.3134417
              ],
              [
                57.423482,
                29.3137211
              ],
              [
                57.4093157,
                29.315939
              ],
              [
                57.4068156,
                29.315939
              ],
              [
                57.4062626,
                29.3162185
              ],
              [
                57.4051492,
                29.3162185
              ],
              [
                57.4037554,
                29.316498
              ],
              [
                57.3732029,
                29.3201043
              ],
              [
                57.368483,
                29.3212133
              ],
              [
                57.3668165,
                29.3212133
              ],
              [
                57.3659762,
                29.3214927
              ],
              [
                57.3645895,
                29.3214928
              ],
              [
                57.3634763,
                29.3217722
              ],
              [
                57.3620895,
                29.3217722
              ],
              [
                57.3609761,
                29.3220517
              ],
              [
                57.3595898,
                29.3220517
              ],
              [
                57.3584765,
                29.3223312
              ],
              [
                57.3534764,
                29.3223312
              ],
              [
                57.3520897,
                29.3226107
              ],
              [
                57.3384765,
                29.3242787
              ],
              [
                57.3359765,
                29.3245492
              ],
              [
                57.3354234,
                29.3248286
              ],
              [
                57.3345901,
                29.3248287
              ],
              [
                57.2865306,
                29.3342773
              ],
              [
                57.2773643,
                29.3353774
              ],
              [
                57.2756977,
                29.3356658
              ],
              [
                57.275141,
                29.3359363
              ],
              [
                57.2729211,
                29.3359363
              ],
              [
                57.2726409,
                29.3362158
              ],
              [
                57.2712545,
                29.3362158
              ],
              [
                57.2709743,
                29.3364953
              ],
              [
                57.2698644,
                29.3364953
              ],
              [
                57.2695878,
                29.3367748
              ],
              [
                57.2687544,
                29.3367748
              ],
              [
                57.2684744,
                29.3370453
              ],
              [
                57.2679212,
                29.3370453
              ],
              [
                57.2679212,
                29.3364953
              ],
              [
                57.2676411,
                29.3362158
              ],
              [
                57.2676411,
                29.3359363
              ],
              [
                57.252918,
                29.3253877
              ],
              [
                57.2181951,
                29.3009372
              ],
              [
                57.2159717,
                29.2995487
              ],
              [
                57.206125,
                29.2932829
              ],
              [
                57.2060976,
                29.2932655
              ],
              [
                57.1984499,
                29.2883987
              ],
              [
                57.1981071,
                29.2881806
              ],
              [
                57.1976388,
                29.2878826
              ],
              [
                57.1965289,
                29.2876031
              ],
              [
                57.1954153,
                29.2867737
              ],
              [
                57.1868056,
                29.2831584
              ],
              [
                57.1823589,
                29.282329
              ],
              [
                57.1659691,
                29.2751077
              ],
              [
                57.1651358,
                29.2751077
              ],
              [
                57.1573593,
                29.2717721
              ],
              [
                57.1545827,
                29.2703836
              ],
              [
                57.1543027,
                29.2701042
              ],
              [
                57.1437462,
                29.2648302
              ],
              [
                57.1429127,
                29.2648302
              ],
              [
                57.1426363,
                29.2642712
              ],
              [
                57.1415262,
                29.2639918
              ],
              [
                57.131803,
                29.2537144
              ],
              [
                57.1287463,
                29.2423283
              ],
              [
                57.1284697,
                29.2359365
              ],
              [
                57.1281896,
                29.2351071
              ],
              [
                57.1284697,
                29.2328804
              ],
              [
                57.1284697,
                29.2316692
              ],
              [
                57.1284698,
                29.2295449
              ],
              [
                57.1284697,
                29.2253799
              ],
              [
                57.1281896,
                29.2231623
              ],
              [
                57.1273564,
                29.2192678
              ],
              [
                57.1282495,
                29.2131969
              ],
              [
                57.1287462,
                29.2098203
              ],
              [
                57.1295797,
                29.2017701
              ],
              [
                57.1293029,
                29.1773223
              ],
              [
                57.126803,
                29.1664869
              ],
              [
                57.1256897,
                29.16344
              ],
              [
                57.1134699,
                29.1328816
              ],
              [
                57.1079131,
                29.1053798
              ],
              [
                57.107633,
                29.1039916
              ],
              [
                57.1073565,
                29.1026035
              ],
              [
                57.1070799,
                29.1003771
              ],
              [
                57.1067998,
                29.0998183
              ],
              [
                57.1067997,
                29.0978803
              ],
              [
                57.1062465,
                29.0942657
              ],
              [
                57.1059663,
                29.0928775
              ],
              [
                57.1056898,
                29.0914895
              ],
              [
                57.1054132,
                29.0906602
              ],
              [
                57.1051332,
                29.0903808
              ],
              [
                57.1051332,
                29.0898219
              ],
              [
                57.1048565,
                29.0889927
              ],
              [
                57.1046966,
                29.0886697
              ],
              [
                57.1042997,
                29.0881544
              ],
              [
                57.1020799,
                29.0834402
              ],
              [
                57.1590176,
                28.905222
              ],
              [
                57.0921087,
                28.9314491
              ],
              [
                57.0368951,
                28.9301959
              ],
              [
                57.0000294,
                28.9356522
              ],
              [
                56.9300496,
                28.9313464
              ],
              [
                56.9068938,
                28.9266717
              ],
              [
                56.9103035,
                28.901426
              ],
              [
                56.9114003,
                28.8899901
              ],
              [
                56.9139668,
                28.8498765
              ],
              [
                56.9143767,
                28.8448102
              ],
              [
                56.9223365,
                28.8292409
              ],
              [
                56.9293553,
                28.8210797
              ],
              [
                56.9377476,
                28.811097
              ],
              [
                56.9512185,
                28.7997657
              ],
              [
                56.9516229,
                28.7935188
              ],
              [
                56.9515855,
                28.7887525
              ],
              [
                56.9519955,
                28.7710691
              ],
              [
                56.9525737,
                28.7585106
              ],
              [
                56.9538784,
                28.7489096
              ],
              [
                56.9558785,
                28.7262559
              ],
              [
                56.9562218,
                28.7014799
              ],
              [
                56.9598482,
                28.6842473
              ],
              [
                56.9657893,
                28.6631777
              ],
              [
                56.9626993,
                28.6532579
              ],
              [
                56.9591195,
                28.6462769
              ],
              [
                56.952857,
                28.6391648
              ],
              [
                56.9477704,
                28.6320637
              ],
              [
                56.9444039,
                28.6263821
              ],
              [
                56.9387333,
                28.6198737
              ],
              [
                56.9208698,
                28.6058997
              ],
              [
                56.9229404,
                28.597259
              ],
              [
                56.9261269,
                28.5851627
              ],
              [
                56.927586,
                28.5802855
              ],
              [
                56.9308431,
                28.5718914
              ],
              [
                56.9315739,
                28.565114
              ],
              [
                56.9276066,
                28.5577643
              ],
              [
                56.9155576,
                28.5488039
              ],
              [
                56.9089738,
                28.5444379
              ],
              [
                56.9051981,
                28.5418999
              ],
              [
                56.8983008,
                28.5380712
              ],
              [
                56.8935975,
                28.5319875
              ],
              [
                56.8899676,
                28.5270822
              ],
              [
                56.8910335,
                28.5222681
              ],
              [
                56.8917582,
                28.5192524
              ],
              [
                56.892701,
                28.5166163
              ],
              [
                56.8936417,
                28.5139201
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555032,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رابر",
          "name:en": "Rabor County",
          "place": "county",
          "population": "35362",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q2610716",
          "wikipedia": "en:Rabor County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.7469965,
                29.3871503
              ],
              [
                56.7483029,
                29.3818336
              ],
              [
                56.7486021,
                29.373588
              ],
              [
                56.7501353,
                29.3671413
              ],
              [
                56.7504787,
                29.3607082
              ],
              [
                56.7627686,
                29.3500838
              ],
              [
                56.76997,
                29.3442307
              ],
              [
                56.7737882,
                29.3406879
              ],
              [
                56.7808398,
                29.3340465
              ],
              [
                56.7845535,
                29.3287236
              ],
              [
                56.790643,
                29.3216336
              ],
              [
                56.7877382,
                29.3174264
              ],
              [
                56.7808466,
                29.3117308
              ],
              [
                56.7756718,
                29.3074518
              ],
              [
                56.7634358,
                29.2961826
              ],
              [
                56.7638459,
                29.2911231
              ],
              [
                56.766012,
                29.2857008
              ],
              [
                56.768074,
                29.2801853
              ],
              [
                56.7682457,
                29.2780142
              ],
              [
                56.7672586,
                29.2745329
              ],
              [
                56.7646542,
                29.2718299
              ],
              [
                56.7600059,
                29.270752
              ],
              [
                56.7522811,
                29.2702653
              ],
              [
                56.7497062,
                29.2685058
              ],
              [
                56.7503928,
                29.2650616
              ],
              [
                56.7583751,
                29.2613177
              ],
              [
                56.7684173,
                29.2601945
              ],
              [
                56.7830033,
                29.2603226
              ],
              [
                56.7927931,
                29.2608685
              ],
              [
                56.7958831,
                29.2598201
              ],
              [
                56.797428,
                29.2552524
              ],
              [
                56.7924363,
                29.2491126
              ],
              [
                56.773567,
                29.2179538
              ],
              [
                56.8173444,
                29.2017704
              ],
              [
                56.8460081,
                29.1929307
              ],
              [
                56.8601037,
                29.185058
              ],
              [
                56.871414,
                29.1804918
              ],
              [
                56.8777515,
                29.1748087
              ],
              [
                56.8820179,
                29.165747
              ],
              [
                56.8948644,
                29.1436106
              ],
              [
                56.8981259,
                29.1378789
              ],
              [
                56.9032319,
                29.1297725
              ],
              [
                56.9041156,
                29.1240481
              ],
              [
                56.9034309,
                29.1183728
              ],
              [
                56.8999726,
                29.1087875
              ],
              [
                56.8962153,
                29.1028536
              ],
              [
                56.893812,
                29.0964367
              ],
              [
                56.8898677,
                29.090452
              ],
              [
                56.8844038,
                29.0782322
              ],
              [
                56.8843764,
                29.0730866
              ],
              [
                56.8909013,
                29.0433272
              ],
              [
                56.8939222,
                29.0272277
              ],
              [
                56.8974545,
                29.0186731
              ],
              [
                56.9007627,
                28.9935839
              ],
              [
                56.9044112,
                28.9750066
              ],
              [
                56.9075728,
                28.9637426
              ],
              [
                56.9094802,
                28.9514142
              ],
              [
                56.9068938,
                28.9266717
              ],
              [
                56.9300496,
                28.9313464
              ],
              [
                57.0000294,
                28.9356522
              ],
              [
                57.0368951,
                28.9301959
              ],
              [
                57.0921087,
                28.9314491
              ],
              [
                57.1590176,
                28.905222
              ],
              [
                57.1020799,
                29.0834402
              ],
              [
                57.1042997,
                29.0881544
              ],
              [
                57.1046966,
                29.0886697
              ],
              [
                57.1048565,
                29.0889927
              ],
              [
                57.1051332,
                29.0898219
              ],
              [
                57.1051332,
                29.0903808
              ],
              [
                57.1054132,
                29.0906602
              ],
              [
                57.1056898,
                29.0914895
              ],
              [
                57.1059663,
                29.0928775
              ],
              [
                57.1062465,
                29.0942657
              ],
              [
                57.1067997,
                29.0978803
              ],
              [
                57.1067998,
                29.0998183
              ],
              [
                57.1070799,
                29.1003771
              ],
              [
                57.1073565,
                29.1026035
              ],
              [
                57.107633,
                29.1039916
              ],
              [
                57.1079131,
                29.1053798
              ],
              [
                57.1134699,
                29.1328816
              ],
              [
                57.1256897,
                29.16344
              ],
              [
                57.126803,
                29.1664869
              ],
              [
                57.1293029,
                29.1773223
              ],
              [
                57.1295797,
                29.2017701
              ],
              [
                57.1287462,
                29.2098203
              ],
              [
                57.1282495,
                29.2131969
              ],
              [
                57.1273564,
                29.2192678
              ],
              [
                57.1281896,
                29.2231623
              ],
              [
                57.1284697,
                29.2253799
              ],
              [
                57.1284698,
                29.2295449
              ],
              [
                57.1284697,
                29.2316692
              ],
              [
                57.1284697,
                29.2328804
              ],
              [
                57.1281896,
                29.2351071
              ],
              [
                57.1284697,
                29.2359365
              ],
              [
                57.1287463,
                29.2423283
              ],
              [
                57.131803,
                29.2537144
              ],
              [
                57.1415262,
                29.2639918
              ],
              [
                57.1426363,
                29.2642712
              ],
              [
                57.1429127,
                29.2648302
              ],
              [
                57.1437462,
                29.2648302
              ],
              [
                57.1543027,
                29.2701042
              ],
              [
                57.1545827,
                29.2703836
              ],
              [
                57.1573593,
                29.2717721
              ],
              [
                57.1651358,
                29.2751077
              ],
              [
                57.1659691,
                29.2751077
              ],
              [
                57.1823589,
                29.282329
              ],
              [
                57.1868056,
                29.2831584
              ],
              [
                57.1954153,
                29.2867737
              ],
              [
                57.1965289,
                29.2876031
              ],
              [
                57.1976388,
                29.2878826
              ],
              [
                57.1981071,
                29.2881806
              ],
              [
                57.1984499,
                29.2883987
              ],
              [
                57.2060976,
                29.2932655
              ],
              [
                57.206125,
                29.2932829
              ],
              [
                57.2159717,
                29.2995487
              ],
              [
                57.2181951,
                29.3009372
              ],
              [
                57.252918,
                29.3253877
              ],
              [
                57.2676411,
                29.3359363
              ],
              [
                57.2676411,
                29.3362158
              ],
              [
                57.2679212,
                29.3364953
              ],
              [
                57.2679212,
                29.3370453
              ],
              [
                57.2684744,
                29.3370453
              ],
              [
                57.2687544,
                29.3367748
              ],
              [
                57.270421,
                29.3389928
              ],
              [
                57.2712544,
                29.3412196
              ],
              [
                57.2648646,
                29.3576018
              ],
              [
                57.2648645,
                29.3578813
              ],
              [
                57.2523648,
                29.3884465
              ],
              [
                57.2451416,
                29.4026023
              ],
              [
                57.2451416,
                29.4031613
              ],
              [
                57.2448649,
                29.4031612
              ],
              [
                57.244585,
                29.4031612
              ],
              [
                57.2440316,
                29.4028908
              ],
              [
                57.2434749,
                29.4026022
              ],
              [
                57.2312517,
                29.4003842
              ],
              [
                57.2251418,
                29.4003842
              ],
              [
                57.2248618,
                29.4001047
              ],
              [
                57.2223619,
                29.4001047
              ],
              [
                57.2218052,
                29.4003842
              ],
              [
                57.2179187,
                29.4003842
              ],
              [
                57.2170852,
                29.4006637
              ],
              [
                57.2140288,
                29.4009342
              ],
              [
                57.2098621,
                29.4009342
              ],
              [
                57.2087521,
                29.4012228
              ],
              [
                57.1729159,
                29.4039908
              ],
              [
                57.1698594,
                29.4045499
              ],
              [
                57.1693061,
                29.4045499
              ],
              [
                57.1684727,
                29.4048294
              ],
              [
                57.1673594,
                29.4048294
              ],
              [
                57.1665261,
                29.405109
              ],
              [
                57.1651361,
                29.4051089
              ],
              [
                57.1643027,
                29.4053884
              ],
              [
                57.1601362,
                29.4059475
              ],
              [
                57.1545829,
                29.4064974
              ],
              [
                57.151803,
                29.4064975
              ],
              [
                57.1498596,
                29.4070475
              ],
              [
                57.1487463,
                29.4070475
              ],
              [
                57.1387465,
                29.4087156
              ],
              [
                57.1368031,
                29.4087156
              ],
              [
                57.1131902,
                29.4134402
              ],
              [
                57.1115236,
                29.4134402
              ],
              [
                57.1109669,
                29.4137197
              ],
              [
                57.109857,
                29.4137198
              ],
              [
                57.1095802,
                29.4139993
              ],
              [
                57.0993004,
                29.4153878
              ],
              [
                57.0987472,
                29.4156584
              ],
              [
                57.0976337,
                29.4156583
              ],
              [
                57.0970806,
                29.4159379
              ],
              [
                57.0954138,
                29.4159378
              ],
              [
                57.0948571,
                29.4162174
              ],
              [
                57.0940238,
                29.4162174
              ],
              [
                57.0937471,
                29.4164969
              ],
              [
                57.0926338,
                29.4164969
              ],
              [
                57.0915239,
                29.417056
              ],
              [
                57.0662443,
                29.4226102
              ],
              [
                57.0513451,
                29.453554
              ],
              [
                57.0364385,
                29.4546813
              ],
              [
                57.0273509,
                29.4552207
              ],
              [
                57.0071016,
                29.45766
              ],
              [
                57.0014816,
                29.4556854
              ],
              [
                56.9779978,
                29.4589737
              ],
              [
                56.9274495,
                29.4663166
              ],
              [
                56.9185351,
                29.4706879
              ],
              [
                56.8965097,
                29.4775213
              ],
              [
                56.890685,
                29.4754875
              ],
              [
                56.8816368,
                29.4653534
              ],
              [
                56.8585394,
                29.4407937
              ],
              [
                56.8436522,
                29.4282665
              ],
              [
                56.8294627,
                29.4173052
              ],
              [
                56.8142844,
                29.4103085
              ],
              [
                56.8048524,
                29.4054321
              ],
              [
                56.8005179,
                29.4036377
              ],
              [
                56.7868005,
                29.3973922
              ],
              [
                56.7664708,
                29.3893809
              ],
              [
                56.7569436,
                29.3880153
              ],
              [
                56.7530512,
                29.3879011
              ],
              [
                56.7469965,
                29.3871503
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555038,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان راور",
          "name:en": "Ravar County",
          "place": "county",
          "population": "43198",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1286316",
          "wikipedia": "en:Ravar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.4352572,
                31.651652
              ],
              [
                56.426991,
                31.6276117
              ],
              [
                56.424322,
                31.6202052
              ],
              [
                56.4229488,
                31.6126037
              ],
              [
                56.4202668,
                31.6073231
              ],
              [
                56.416942,
                31.5953848
              ],
              [
                56.4161778,
                31.5910291
              ],
              [
                56.4172743,
                31.5847245
              ],
              [
                56.4183678,
                31.5773249
              ],
              [
                56.4205994,
                31.5689348
              ],
              [
                56.4266394,
                31.5551339
              ],
              [
                56.4314473,
                31.5494777
              ],
              [
                56.4368237,
                31.544669
              ],
              [
                56.4444187,
                31.5385894
              ],
              [
                56.4523816,
                31.53082
              ],
              [
                56.4637745,
                31.5172094
              ],
              [
                56.4688194,
                31.5065963
              ],
              [
                56.473521,
                31.4983203
              ],
              [
                56.4747858,
                31.4883306
              ],
              [
                56.4739776,
                31.4772432
              ],
              [
                56.470716,
                31.4644316
              ],
              [
                56.4660559,
                31.4498987
              ],
              [
                56.463891,
                31.4427106
              ],
              [
                56.4591479,
                31.4355478
              ],
              [
                56.4561203,
                31.4258401
              ],
              [
                56.4461556,
                31.3933157
              ],
              [
                56.4422517,
                31.3813236
              ],
              [
                56.4407156,
                31.3715199
              ],
              [
                56.4377951,
                31.3644329
              ],
              [
                56.4396779,
                31.3562862
              ],
              [
                56.4378564,
                31.3460026
              ],
              [
                56.4374046,
                31.3367709
              ],
              [
                56.4283734,
                31.3170426
              ],
              [
                56.4291191,
                31.3067442
              ],
              [
                56.430106,
                31.2962619
              ],
              [
                56.430106,
                31.2959821
              ],
              [
                56.4314959,
                31.2873699
              ],
              [
                56.4416653,
                31.2623106
              ],
              [
                56.4819635,
                31.2717673
              ],
              [
                56.4845752,
                31.2651993
              ],
              [
                56.4901118,
                31.2593126
              ],
              [
                56.4948735,
                31.2561614
              ],
              [
                56.502857,
                31.2503783
              ],
              [
                56.5126417,
                31.2452417
              ],
              [
                56.5252414,
                31.2337531
              ],
              [
                56.537361,
                31.2257203
              ],
              [
                56.5469698,
                31.2166923
              ],
              [
                56.5564584,
                31.2088008
              ],
              [
                56.560235,
                31.2063782
              ],
              [
                56.5636682,
                31.2026708
              ],
              [
                56.5686035,
                31.2009823
              ],
              [
                56.5708779,
                31.198633
              ],
              [
                56.5800189,
                31.1919518
              ],
              [
                56.5921461,
                31.1777094
              ],
              [
                56.594696,
                31.1720521
              ],
              [
                56.5972709,
                31.1694817
              ],
              [
                56.6004266,
                31.1653408
              ],
              [
                56.6053383,
                31.1573404
              ],
              [
                56.6100923,
                31.1465305
              ],
              [
                56.6106264,
                31.1435836
              ],
              [
                56.6129779,
                31.1343708
              ],
              [
                56.6161536,
                31.1279055
              ],
              [
                56.6171657,
                31.1200866
              ],
              [
                56.6187238,
                31.1120139
              ],
              [
                56.6193412,
                31.1051183
              ],
              [
                56.6208971,
                31.0971151
              ],
              [
                56.6240501,
                31.0816066
              ],
              [
                56.6298007,
                31.069477
              ],
              [
                56.632204,
                31.0621249
              ],
              [
                56.6354655,
                31.056537
              ],
              [
                56.6398429,
                31.0486692
              ],
              [
                56.6453062,
                31.0450543
              ],
              [
                56.6463232,
                31.0432643
              ],
              [
                56.6491125,
                31.0407273
              ],
              [
                56.6595387,
                31.0350055
              ],
              [
                56.6703956,
                31.0312029
              ],
              [
                56.6754147,
                31.0293143
              ],
              [
                56.6902902,
                31.0249524
              ],
              [
                56.701684,
                31.0225611
              ],
              [
                56.7040014,
                31.0220095
              ],
              [
                56.7091512,
                31.0214578
              ],
              [
                56.7138129,
                31.0205411
              ],
              [
                56.7178636,
                31.0206883
              ],
              [
                56.721719,
                31.0200774
              ],
              [
                56.7257626,
                31.0198578
              ],
              [
                56.7289934,
                31.0191406
              ],
              [
                56.732379,
                31.0187137
              ],
              [
                56.735333,
                31.0180885
              ],
              [
                56.7393851,
                31.0170076
              ],
              [
                56.7420657,
                31.016522
              ],
              [
                56.7457876,
                31.0148853
              ],
              [
                56.7485951,
                31.0153227
              ],
              [
                56.7498779,
                31.0178535
              ],
              [
                56.761319,
                31.0136619
              ],
              [
                56.7659734,
                31.0119357
              ],
              [
                56.7787032,
                31.0070903
              ],
              [
                56.7900181,
                31.0036412
              ],
              [
                56.7962338,
                31.0012502
              ],
              [
                56.8004228,
                30.9998222
              ],
              [
                56.8046996,
                30.9979694
              ],
              [
                56.8109035,
                30.9951584
              ],
              [
                56.8145942,
                30.9945422
              ],
              [
                56.8171477,
                30.9927855
              ],
              [
                56.8195829,
                30.9913184
              ],
              [
                56.8418883,
                30.9828338
              ],
              [
                56.8445031,
                30.9805808
              ],
              [
                56.8498221,
                30.979874
              ],
              [
                56.8577102,
                30.9768795
              ],
              [
                56.8624877,
                30.9754015
              ],
              [
                56.8695951,
                30.9717102
              ],
              [
                56.8844604,
                30.9590631
              ],
              [
                56.8949317,
                30.9466234
              ],
              [
                56.9040463,
                30.9367061
              ],
              [
                56.9076454,
                30.9309725
              ],
              [
                56.9175052,
                30.9165848
              ],
              [
                56.9297377,
                30.8998503
              ],
              [
                56.9425751,
                30.8768113
              ],
              [
                56.9609646,
                30.8651369
              ],
              [
                56.960688,
                30.8648661
              ],
              [
                56.9606881,
                30.8634671
              ],
              [
                56.956798,
                30.856806
              ],
              [
                56.9562413,
                30.8556959
              ],
              [
                56.9492981,
                30.8473651
              ],
              [
                56.9156852,
                30.8237539
              ],
              [
                56.9137384,
                30.8223549
              ],
              [
                56.9134619,
                30.8218044
              ],
              [
                56.9126285,
                30.8215245
              ],
              [
                56.9115185,
                30.8204144
              ],
              [
                56.9004053,
                30.8151344
              ],
              [
                56.8945721,
                30.8143041
              ],
              [
                56.8840156,
                30.814304
              ],
              [
                56.8829056,
                30.8145839
              ],
              [
                56.881239,
                30.8145838
              ],
              [
                56.8806824,
                30.8148636
              ],
              [
                56.8776257,
                30.8154143
              ],
              [
                56.8737391,
                30.8173638
              ],
              [
                56.8729058,
                30.8173638
              ],
              [
                56.8717924,
                30.8179143
              ],
              [
                56.8706824,
                30.8179143
              ],
              [
                56.8690158,
                30.8184739
              ],
              [
                56.8598494,
                30.8204145
              ],
              [
                56.8584593,
                30.8204144
              ],
              [
                56.8570692,
                30.8209741
              ],
              [
                56.856236,
                30.820974
              ],
              [
                56.8551261,
                30.8215246
              ],
              [
                56.8520694,
                30.8226348
              ],
              [
                56.8517929,
                30.8229145
              ],
              [
                56.8512361,
                30.8229145
              ],
              [
                56.8509594,
                30.8231943
              ],
              [
                56.8504027,
                30.8231944
              ],
              [
                56.8454029,
                30.8254147
              ],
              [
                56.8423461,
                30.8254147
              ],
              [
                56.8420695,
                30.8256944
              ],
              [
                56.8376263,
                30.8256945
              ],
              [
                56.8373463,
                30.8254147
              ],
              [
                56.836513,
                30.8254147
              ],
              [
                56.8356796,
                30.8251348
              ],
              [
                56.8079,
                30.8198639
              ],
              [
                56.8076234,
                30.8195842
              ],
              [
                56.8067899,
                30.8195842
              ],
              [
                56.7967902,
                30.8148638
              ],
              [
                56.7967902,
                30.8140243
              ],
              [
                56.7981802,
                30.8126434
              ],
              [
                56.8109566,
                30.7920832
              ],
              [
                56.8190132,
                30.782083
              ],
              [
                56.8273463,
                30.771803
              ],
              [
                56.8281796,
                30.7706929
              ],
              [
                56.8370696,
                30.7595826
              ],
              [
                56.840126,
                30.7565321
              ],
              [
                56.8404028,
                30.7562523
              ],
              [
                56.8695725,
                30.7248624
              ],
              [
                56.8698491,
                30.722913
              ],
              [
                56.869849,
                30.7226332
              ],
              [
                56.8701256,
                30.7218028
              ],
              [
                56.8701256,
                30.7190231
              ],
              [
                56.8706822,
                30.7190231
              ],
              [
                56.8765156,
                30.7190231
              ],
              [
                56.8770723,
                30.7193029
              ],
              [
                56.8826255,
                30.7193028
              ],
              [
                56.8831821,
                30.7190231
              ],
              [
                56.8854054,
                30.7187524
              ],
              [
                56.8890154,
                30.7187523
              ],
              [
                56.8898487,
                30.7184726
              ],
              [
                56.8942954,
                30.7184725
              ],
              [
                56.8951286,
                30.7181928
              ],
              [
                56.9056852,
                30.7181927
              ],
              [
                56.9067953,
                30.717913
              ],
              [
                56.9081851,
                30.717913
              ],
              [
                56.9084618,
                30.7181928
              ],
              [
                56.9112385,
                30.7181927
              ],
              [
                56.9134618,
                30.7187523
              ],
              [
                56.923185,
                30.7204129
              ],
              [
                56.9240182,
                30.7206927
              ],
              [
                56.9248517,
                30.7206927
              ],
              [
                56.9254083,
                30.7209724
              ],
              [
                56.9281848,
                30.721523
              ],
              [
                56.9298515,
                30.721523
              ],
              [
                56.9301281,
                30.7218027
              ],
              [
                56.9348514,
                30.7218027
              ],
              [
                56.935128,
                30.721523
              ],
              [
                56.9356846,
                30.721523
              ],
              [
                56.9388649,
                30.7161568
              ],
              [
                56.9490179,
                30.6990234
              ],
              [
                56.9520745,
                30.6884731
              ],
              [
                56.9523511,
                30.6881934
              ],
              [
                56.9545744,
                30.6815239
              ],
              [
                56.9631876,
                30.6631942
              ],
              [
                56.9673543,
                30.6454153
              ],
              [
                56.9673543,
                30.6448557
              ],
              [
                56.9676308,
                30.6429064
              ],
              [
                56.9681874,
                30.6429063
              ],
              [
                56.9737407,
                30.6451355
              ],
              [
                56.9745742,
                30.6451355
              ],
              [
                56.974854,
                30.6454153
              ],
              [
                56.9942972,
                30.6554147
              ],
              [
                56.9951303,
                30.6554147
              ],
              [
                57.0001439,
                30.6570843
              ],
              [
                57.0012438,
                30.6576348
              ],
              [
                57.0018004,
                30.6576348
              ],
              [
                57.0026337,
                30.6581943
              ],
              [
                57.0398563,
                30.6818035
              ],
              [
                57.0440231,
                30.6829135
              ],
              [
                57.0462464,
                30.6829136
              ],
              [
                57.0498564,
                30.6834731
              ],
              [
                57.0534662,
                30.6851337
              ],
              [
                57.0542996,
                30.6856933
              ],
              [
                57.0548563,
                30.6826338
              ],
              [
                57.056523,
                30.6795834
              ],
              [
                57.0731893,
                30.6590245
              ],
              [
                57.0734693,
                30.658474
              ],
              [
                57.0754127,
                30.6565247
              ],
              [
                57.0926356,
                30.6401357
              ],
              [
                57.1226386,
                30.6159674
              ],
              [
                57.1245819,
                30.6137474
              ],
              [
                57.1626378,
                30.5634718
              ],
              [
                57.1629179,
                30.5626324
              ],
              [
                57.1643044,
                30.5626324
              ],
              [
                57.1651378,
                30.5629123
              ],
              [
                57.1676377,
                30.5640222
              ],
              [
                57.1684744,
                30.5640222
              ],
              [
                57.2145873,
                30.5854101
              ],
              [
                57.2168072,
                30.5865201
              ],
              [
                57.2176404,
                30.5867999
              ],
              [
                57.2181972,
                30.5873593
              ],
              [
                57.2795896,
                30.609298
              ],
              [
                57.2812563,
                30.6098575
              ],
              [
                57.3404256,
                30.6281865
              ],
              [
                57.3476452,
                30.6301359
              ],
              [
                57.3723714,
                30.6379152
              ],
              [
                57.3768184,
                30.6392959
              ],
              [
                57.4062648,
                30.6501347
              ],
              [
                57.4173712,
                30.6534648
              ],
              [
                57.4176509,
                30.6537446
              ],
              [
                57.4187646,
                30.6537447
              ],
              [
                57.4223709,
                30.6548547
              ],
              [
                57.4784833,
                30.6812434
              ],
              [
                57.4818236,
                30.6826333
              ],
              [
                57.5045963,
                30.6920825
              ],
              [
                57.511823,
                30.6965228
              ],
              [
                57.5332094,
                30.7079124
              ],
              [
                57.5334895,
                30.7084719
              ],
              [
                57.5459893,
                30.713192
              ],
              [
                57.5473761,
                30.7137426
              ],
              [
                57.547376,
                30.7145819
              ],
              [
                57.5484894,
                30.718192
              ],
              [
                57.5487695,
                30.7184718
              ],
              [
                57.5490425,
                30.7193021
              ],
              [
                57.5490425,
                30.7204122
              ],
              [
                57.5498757,
                30.7226324
              ],
              [
                57.5504359,
                30.7251323
              ],
              [
                57.5507093,
                30.7259717
              ],
              [
                57.5679359,
                30.7745819
              ],
              [
                57.5684891,
                30.7754123
              ],
              [
                57.581269,
                30.8043029
              ],
              [
                57.5854355,
                30.8143033
              ],
              [
                57.5857157,
                30.814583
              ],
              [
                57.5959955,
                30.8373638
              ],
              [
                57.5968287,
                30.838474
              ],
              [
                57.5971022,
                30.8393043
              ],
              [
                57.5979355,
                30.8406943
              ],
              [
                57.5984956,
                30.842355
              ],
              [
                57.5984956,
                30.8448642
              ],
              [
                57.6121017,
                30.873476
              ],
              [
                57.6123819,
                30.8737467
              ],
              [
                57.6240486,
                30.8979181
              ],
              [
                57.6246016,
                30.898198
              ],
              [
                57.6293287,
                30.9067997
              ],
              [
                57.6298819,
                30.9073594
              ],
              [
                57.6623814,
                30.9509735
              ],
              [
                57.6804411,
                30.9718061
              ],
              [
                57.7096073,
                31.0001939
              ],
              [
                57.7146075,
                31.00709
              ],
              [
                57.7390537,
                31.0395854
              ],
              [
                57.7526669,
                31.0629192
              ],
              [
                57.7535005,
                31.0640295
              ],
              [
                57.7568338,
                31.0745907
              ],
              [
                57.7571138,
                31.0784813
              ],
              [
                57.7568338,
                31.0795824
              ],
              [
                57.7571138,
                31.080422
              ],
              [
                57.7565537,
                31.0859734
              ],
              [
                57.7562802,
                31.0870837
              ],
              [
                57.7560005,
                31.0907034
              ],
              [
                57.755167,
                31.0979158
              ],
              [
                57.7554471,
                31.0987553
              ],
              [
                57.7546139,
                31.1154189
              ],
              [
                57.7543338,
                31.1193094
              ],
              [
                57.7457208,
                31.1859738
              ],
              [
                57.7446142,
                31.1976459
              ],
              [
                57.7446142,
                31.2101485
              ],
              [
                57.7437811,
                31.2251428
              ],
              [
                57.7418342,
                31.2387559
              ],
              [
                57.7421076,
                31.240426
              ],
              [
                57.7423873,
                31.242096
              ],
              [
                57.7426674,
                31.2440369
              ],
              [
                57.7426675,
                31.2459777
              ],
              [
                57.7429408,
                31.2462576
              ],
              [
                57.7429409,
                31.2468173
              ],
              [
                57.7423873,
                31.247368
              ],
              [
                57.7404408,
                31.2912592
              ],
              [
                57.7398877,
                31.2984812
              ],
              [
                57.7396077,
                31.3073732
              ],
              [
                57.7387745,
                31.3159855
              ],
              [
                57.7376678,
                31.3259791
              ],
              [
                57.7365546,
                31.3332012
              ],
              [
                57.736001,
                31.3384823
              ],
              [
                57.735721,
                31.3401525
              ],
              [
                57.7371078,
                31.3590383
              ],
              [
                57.7368348,
                31.3943187
              ],
              [
                57.7365547,
                31.3973701
              ],
              [
                57.7371078,
                31.4204273
              ],
              [
                57.7360012,
                31.4298704
              ],
              [
                57.7460208,
                31.4394362
              ],
              [
                57.7437144,
                31.466139
              ],
              [
                57.7483879,
                31.4991897
              ],
              [
                57.7470846,
                31.5273272
              ],
              [
                57.7478977,
                31.5391124
              ],
              [
                57.7476878,
                31.5503436
              ],
              [
                57.7458216,
                31.707815
              ],
              [
                57.7378368,
                31.720644
              ],
              [
                57.7260756,
                31.7388418
              ],
              [
                57.6941118,
                31.7543683
              ],
              [
                57.6808293,
                31.7597914
              ],
              [
                57.6590665,
                31.7681263
              ],
              [
                57.6227433,
                31.7815856
              ],
              [
                57.5965006,
                31.7857487
              ],
              [
                57.5865273,
                31.7897211
              ],
              [
                57.5546011,
                31.7947542
              ],
              [
                57.5454345,
                31.7969758
              ],
              [
                57.5295636,
                31.7988079
              ],
              [
                57.5231893,
                31.7982451
              ],
              [
                57.5031277,
                31.7964736
              ],
              [
                57.4866482,
                31.8058106
              ],
              [
                57.4359985,
                31.8175948
              ],
              [
                57.3874964,
                31.8306892
              ],
              [
                57.3555895,
                31.8394364
              ],
              [
                57.3300447,
                31.8464389
              ],
              [
                57.254562,
                31.867645
              ],
              [
                57.2380825,
                31.8746425
              ],
              [
                57.1521367,
                31.9016862
              ],
              [
                57.1129371,
                31.9127206
              ],
              [
                57.0756343,
                31.9245975
              ],
              [
                57.0599447,
                31.9269099
              ],
              [
                57.0350552,
                31.9346053
              ],
              [
                57.0168021,
                31.9360011
              ],
              [
                57.0059688,
                31.9384932
              ],
              [
                56.9742794,
                31.9410983
              ],
              [
                56.9339453,
                31.9489167
              ],
              [
                56.8968802,
                31.9543386
              ],
              [
                56.8724277,
                31.9569589
              ],
              [
                56.8632976,
                31.9552316
              ],
              [
                56.8482444,
                31.9546717
              ],
              [
                56.8336015,
                31.9528808
              ],
              [
                56.8146451,
                31.9514446
              ],
              [
                56.7744887,
                31.9481468
              ],
              [
                56.7225426,
                31.9439345
              ],
              [
                56.67484,
                31.9390533
              ],
              [
                56.6728968,
                31.9390534
              ],
              [
                56.6698401,
                31.9384935
              ],
              [
                56.6501171,
                31.9354418
              ],
              [
                56.6374646,
                31.9327657
              ],
              [
                56.6280467,
                31.9304423
              ],
              [
                56.6228941,
                31.9293726
              ],
              [
                56.6097769,
                31.92725
              ],
              [
                56.6023487,
                31.92502
              ],
              [
                56.5994972,
                31.9161222
              ],
              [
                56.5957012,
                31.905348
              ],
              [
                56.5923063,
                31.8956445
              ],
              [
                56.5888899,
                31.8784443
              ],
              [
                56.5877932,
                31.868941
              ],
              [
                56.5874115,
                31.8626855
              ],
              [
                56.5841499,
                31.8589685
              ],
              [
                56.5834884,
                31.8501584
              ],
              [
                56.5808908,
                31.8409051
              ],
              [
                56.5788976,
                31.8317329
              ],
              [
                56.57735,
                31.8214695
              ],
              [
                56.5758717,
                31.8088323
              ],
              [
                56.5765857,
                31.7981511
              ],
              [
                56.5747233,
                31.7912321
              ],
              [
                56.5746875,
                31.7799519
              ],
              [
                56.5739791,
                31.7628022
              ],
              [
                56.5734863,
                31.7479931
              ],
              [
                56.5776696,
                31.7418341
              ],
              [
                56.5770579,
                31.7376558
              ],
              [
                56.5767813,
                31.7373849
              ],
              [
                56.5767812,
                31.737105
              ],
              [
                56.5767812,
                31.7326539
              ],
              [
                56.5745257,
                31.7145876
              ],
              [
                56.5697538,
                31.6977379
              ],
              [
                56.5625667,
                31.6946365
              ],
              [
                56.5092944,
                31.6716453
              ],
              [
                56.4352572,
                31.651652
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555045,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رفسنجان",
          "name:en": "Rafsanjan County",
          "place": "county",
          "population": "311214",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1287811",
          "wikipedia": "en:Rafsanjan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.2642221,
                31.1104203
              ],
              [
                55.264439,
                31.1097696
              ],
              [
                55.2644989,
                31.1095898
              ],
              [
                55.271722,
                31.1004186
              ],
              [
                55.2733886,
                31.0993083
              ],
              [
                55.2850552,
                31.088756
              ],
              [
                55.3053349,
                31.0659815
              ],
              [
                55.3086682,
                31.0609808
              ],
              [
                55.3095016,
                31.059031
              ],
              [
                55.3178347,
                31.0473686
              ],
              [
                55.3339478,
                31.0295863
              ],
              [
                55.3358911,
                31.0273657
              ],
              [
                55.3400577,
                31.0215346
              ],
              [
                55.3508908,
                31.0054224
              ],
              [
                55.3511709,
                31.0040323
              ],
              [
                55.3517242,
                30.9987519
              ],
              [
                55.3517241,
                30.9915307
              ],
              [
                55.3522809,
                30.9907003
              ],
              [
                55.3795037,
                30.9493058
              ],
              [
                55.4233965,
                30.8984798
              ],
              [
                55.4303397,
                30.8881992
              ],
              [
                55.431173,
                30.8868093
              ],
              [
                55.4436727,
                30.8676473
              ],
              [
                55.4514527,
                30.8601378
              ],
              [
                55.4525626,
                30.8593074
              ],
              [
                55.4528427,
                30.8590276
              ],
              [
                55.4614525,
                30.8529172
              ],
              [
                55.4725657,
                30.8476461
              ],
              [
                55.4883988,
                30.8434762
              ],
              [
                55.4897889,
                30.8434762
              ],
              [
                55.4903422,
                30.8431964
              ],
              [
                55.4911754,
                30.8431964
              ],
              [
                55.4914554,
                30.8429166
              ],
              [
                55.4922888,
                30.8429166
              ],
              [
                55.5000652,
                30.8406963
              ],
              [
                55.5781243,
                30.8004148
              ],
              [
                55.5781242,
                30.800135
              ],
              [
                55.5781243,
                30.7995845
              ],
              [
                55.590624,
                30.7901347
              ],
              [
                55.5922905,
                30.7887538
              ],
              [
                55.6420166,
                30.7487532
              ],
              [
                55.6447931,
                30.7462442
              ],
              [
                55.6947957,
                30.7040244
              ],
              [
                55.6950723,
                30.7037536
              ],
              [
                55.6945192,
                30.7034738
              ],
              [
                55.6939625,
                30.7034738
              ],
              [
                55.6936857,
                30.7031941
              ],
              [
                55.6931291,
                30.7031941
              ],
              [
                55.6678495,
                30.693465
              ],
              [
                55.6672962,
                30.6929145
              ],
              [
                55.6667396,
                30.6929145
              ],
              [
                55.6350699,
                30.6773645
              ],
              [
                55.6342366,
                30.6770847
              ],
              [
                55.6228502,
                30.6715254
              ],
              [
                55.6220168,
                30.670695
              ],
              [
                55.6214601,
                30.670695
              ],
              [
                55.5828473,
                30.6523565
              ],
              [
                55.5809007,
                30.6526363
              ],
              [
                55.5803474,
                30.6526363
              ],
              [
                55.5781241,
                30.6526362
              ],
              [
                55.5778474,
                30.652916
              ],
              [
                55.5753475,
                30.652916
              ],
              [
                55.5747908,
                30.6526363
              ],
              [
                55.5000651,
                30.6106894
              ],
              [
                55.4992318,
                30.6101389
              ],
              [
                55.4967318,
                30.6087491
              ],
              [
                55.4964553,
                30.6081896
              ],
              [
                55.4486724,
                30.5654135
              ],
              [
                55.4422859,
                30.5590242
              ],
              [
                55.4411726,
                30.5584737
              ],
              [
                55.4406193,
                30.5576345
              ],
              [
                55.4347861,
                30.551525
              ],
              [
                55.434506,
                30.5506857
              ],
              [
                55.4339527,
                30.5501353
              ],
              [
                55.4333961,
                30.5490252
              ],
              [
                55.4311728,
                30.5462458
              ],
              [
                55.4292294,
                30.5429068
              ],
              [
                55.4292295,
                30.5426361
              ],
              [
                55.4278395,
                30.5406868
              ],
              [
                55.4278395,
                30.5404161
              ],
              [
                55.4260341,
                30.5383274
              ],
              [
                55.4272827,
                30.5381871
              ],
              [
                55.4289494,
                30.5376276
              ],
              [
                55.4325627,
                30.5373568
              ],
              [
                55.4372861,
                30.5365266
              ],
              [
                55.4389527,
                30.5365266
              ],
              [
                55.4489525,
                30.5348571
              ],
              [
                55.4511759,
                30.5348571
              ],
              [
                55.4561758,
                30.5342977
              ],
              [
                55.4647856,
                30.5342977
              ],
              [
                55.4656189,
                30.5340178
              ],
              [
                55.4681188,
                30.5340179
              ],
              [
                55.4689522,
                30.5337381
              ],
              [
                55.4767321,
                30.5326372
              ],
              [
                55.477842,
                30.5320776
              ],
              [
                55.4786754,
                30.5320777
              ],
              [
                55.4883987,
                30.5281882
              ],
              [
                55.4933985,
                30.5237484
              ],
              [
                55.4936751,
                30.5226294
              ],
              [
                55.4932035,
                30.5211315
              ],
              [
                55.4928419,
                30.5204094
              ],
              [
                55.4914552,
                30.5187399
              ],
              [
                55.4839519,
                30.5112409
              ],
              [
                55.4656188,
                30.4931928
              ],
              [
                55.4645089,
                30.4915234
              ],
              [
                55.3692269,
                30.3904036
              ],
              [
                55.3645037,
                30.3851249
              ],
              [
                55.3206142,
                30.3329074
              ],
              [
                55.3142243,
                30.32568
              ],
              [
                55.3139443,
                30.3254092
              ],
              [
                55.3147776,
                30.3248498
              ],
              [
                55.3239475,
                30.3195714
              ],
              [
                55.3267242,
                30.3187412
              ],
              [
                55.3278341,
                30.3187412
              ],
              [
                55.3306141,
                30.3181818
              ],
              [
                55.3431138,
                30.3181818
              ],
              [
                55.3453372,
                30.3184615
              ],
              [
                55.3483905,
                30.3184615
              ],
              [
                55.3503371,
                30.3187412
              ],
              [
                55.352557,
                30.3187411
              ],
              [
                55.3536704,
                30.3190209
              ],
              [
                55.3558936,
                30.3190209
              ],
              [
                55.3831167,
                30.3223504
              ],
              [
                55.3889499,
                30.3223503
              ],
              [
                55.3900598,
                30.3223504
              ],
              [
                55.3953398,
                30.3223504
              ],
              [
                55.3956165,
                30.3220707
              ],
              [
                55.3961731,
                30.3218
              ],
              [
                55.4003396,
                30.3206811
              ],
              [
                55.4072829,
                30.3192916
              ],
              [
                55.4100595,
                30.3190208
              ],
              [
                55.4131162,
                30.3190209
              ],
              [
                55.4145062,
                30.3187411
              ],
              [
                55.4186727,
                30.3187412
              ],
              [
                55.4383958,
                30.3165215
              ],
              [
                55.4442291,
                30.3151319
              ],
              [
                55.4917317,
                30.297077
              ],
              [
                55.5000649,
                30.294298
              ],
              [
                55.5386776,
                30.2962379
              ],
              [
                55.5400677,
                30.2962379
              ],
              [
                55.5411776,
                30.2965176
              ],
              [
                55.5425676,
                30.2965176
              ],
              [
                55.544791,
                30.297077
              ],
              [
                55.5464576,
                30.297077
              ],
              [
                55.5467342,
                30.2973566
              ],
              [
                55.5475675,
                30.2976274
              ],
              [
                55.5486774,
                30.2976274
              ],
              [
                55.5489576,
                30.2979071
              ],
              [
                55.5500676,
                30.2979071
              ],
              [
                55.5517342,
                30.2984665
              ],
              [
                55.5970135,
                30.3084639
              ],
              [
                55.5984035,
                30.3084639
              ],
              [
                55.6014602,
                30.309294
              ],
              [
                55.60257,
                30.309294
              ],
              [
                55.6028467,
                30.3095737
              ],
              [
                55.6036801,
                30.3095737
              ],
              [
                55.6067368,
                30.3104038
              ],
              [
                55.6086799,
                30.3109632
              ],
              [
                55.6097933,
                30.3109633
              ],
              [
                55.61007,
                30.311243
              ],
              [
                55.6211832,
                30.3131829
              ],
              [
                55.6231265,
                30.3131829
              ],
              [
                55.6236832,
                30.3134626
              ],
              [
                55.6245165,
                30.3134626
              ],
              [
                55.6525728,
                30.3215201
              ],
              [
                55.6536827,
                30.3215202
              ],
              [
                55.6553494,
                30.3220705
              ],
              [
                55.6564593,
                30.3220705
              ],
              [
                55.657016,
                30.3223502
              ],
              [
                55.6589628,
                30.3223502
              ],
              [
                55.6595158,
                30.32263
              ],
              [
                55.6631292,
                30.32263
              ],
              [
                55.664516,
                30.32263
              ],
              [
                55.6647959,
                30.3229097
              ],
              [
                55.6667392,
                30.3229097
              ],
              [
                55.6670158,
                30.3226299
              ],
              [
                55.6675725,
                30.3215202
              ],
              [
                55.6836857,
                30.2965175
              ],
              [
                55.6967422,
                30.274574
              ],
              [
                55.6986854,
                30.2717949
              ],
              [
                55.702852,
                30.2645768
              ],
              [
                55.7160469,
                30.2477677
              ],
              [
                55.7167417,
                30.2470729
              ],
              [
                55.7170185,
                30.2462428
              ],
              [
                55.7178516,
                30.2454038
              ],
              [
                55.7181317,
                30.245133
              ],
              [
                55.7572978,
                30.1951307
              ],
              [
                55.7611878,
                30.1912331
              ],
              [
                55.7628543,
                30.189573
              ],
              [
                55.7745208,
                30.1784577
              ],
              [
                55.7747946,
                30.178187
              ],
              [
                55.7750774,
                30.1779074
              ],
              [
                55.7753541,
                30.1773479
              ],
              [
                55.7756342,
                30.1770682
              ],
              [
                55.7781342,
                30.1729
              ],
              [
                55.8009102,
                30.1459602
              ],
              [
                55.8025771,
                30.1448505
              ],
              [
                55.8225801,
                30.124849
              ],
              [
                55.8247999,
                30.1226205
              ],
              [
                55.8323033,
                30.1154032
              ],
              [
                55.8328565,
                30.1140138
              ],
              [
                55.8331367,
                30.1087361
              ],
              [
                55.8314701,
                30.102899
              ],
              [
                55.8195236,
                30.094563
              ],
              [
                55.8095236,
                30.091234
              ],
              [
                55.8020238,
                30.0876254
              ],
              [
                55.7978571,
                30.0856768
              ],
              [
                55.7950771,
                30.0845671
              ],
              [
                55.7942436,
                30.0845672
              ],
              [
                55.7500744,
                30.070683
              ],
              [
                55.7420213,
                30.0670654
              ],
              [
                55.7295181,
                30.0640072
              ],
              [
                55.7192415,
                30.0609579
              ],
              [
                55.7161849,
                30.060119
              ],
              [
                55.6922953,
                30.0534612
              ],
              [
                55.6729459,
                30.0455899
              ],
              [
                55.6729377,
                30.0455856
              ],
              [
                55.6722956,
                30.0453961
              ],
              [
                55.6722956,
                30.0448459
              ],
              [
                55.6720154,
                30.0440159
              ],
              [
                55.6717389,
                30.0437362
              ],
              [
                55.6725722,
                30.0348412
              ],
              [
                55.6722956,
                30.0340113
              ],
              [
                55.6725721,
                30.0337317
              ],
              [
                55.6734056,
                30.0251255
              ],
              [
                55.6739621,
                30.0154007
              ],
              [
                55.6778521,
                29.9990094
              ],
              [
                55.6747956,
                29.9901237
              ],
              [
                55.6756288,
                29.9856764
              ],
              [
                55.6778521,
                29.9798489
              ],
              [
                55.6786854,
                29.9759519
              ],
              [
                55.680072,
                29.9567918
              ],
              [
                55.6797954,
                29.952065
              ],
              [
                55.6947951,
                29.9570624
              ],
              [
                55.6970184,
                29.9576217
              ],
              [
                55.6972951,
                29.9579014
              ],
              [
                55.6984085,
                29.9579013
              ],
              [
                55.7559109,
                29.9787303
              ],
              [
                55.7853155,
                29.9771356
              ],
              [
                55.8108899,
                29.969212
              ],
              [
                55.8562085,
                29.9626685
              ],
              [
                55.8980938,
                29.960289
              ],
              [
                55.9444424,
                29.9376806
              ],
              [
                55.980148,
                29.9245892
              ],
              [
                56.0084206,
                29.9109491
              ],
              [
                56.0142538,
                29.907341
              ],
              [
                56.0239768,
                29.9045627
              ],
              [
                56.0256436,
                29.9045627
              ],
              [
                56.0259202,
                29.9042831
              ],
              [
                56.0287001,
                29.9040125
              ],
              [
                56.0307971,
                29.9034842
              ],
              [
                56.0309201,
                29.9037328
              ],
              [
                56.0312002,
                29.9048423
              ],
              [
                56.0314767,
                29.9051219
              ],
              [
                56.0317535,
                29.9067817
              ],
              [
                56.0320334,
                29.9092894
              ],
              [
                56.0323102,
                29.9112287
              ],
              [
                56.0325867,
                29.914007
              ],
              [
                56.0328668,
                29.9165057
              ],
              [
                56.0331434,
                29.9181744
              ],
              [
                56.0334202,
                29.9195636
              ],
              [
                56.0337001,
                29.9212324
              ],
              [
                56.0339769,
                29.9223419
              ],
              [
                56.0345335,
                29.9251203
              ],
              [
                56.0353667,
                29.9306769
              ],
              [
                56.0356435,
                29.9328959
              ],
              [
                56.0356435,
                29.9331755
              ],
              [
                56.0359235,
                29.9337348
              ],
              [
                56.0362002,
                29.9354037
              ],
              [
                56.0364767,
                29.9365041
              ],
              [
                56.0367568,
                29.9379024
              ],
              [
                56.0375902,
                29.9417811
              ],
              [
                56.0378668,
                29.9440092
              ],
              [
                56.0308954,
                29.96283
              ],
              [
                56.0297739,
                29.9751685
              ],
              [
                56.035502,
                29.9975618
              ],
              [
                56.0577391,
                30.0138146
              ],
              [
                56.0612145,
                30.0279822
              ],
              [
                56.0755458,
                30.0271876
              ],
              [
                56.0831187,
                30.0517637
              ],
              [
                56.1097525,
                30.0802354
              ],
              [
                56.1025427,
                30.1264215
              ],
              [
                56.1181492,
                30.1809565
              ],
              [
                56.1214824,
                30.1817956
              ],
              [
                56.1300923,
                30.1842948
              ],
              [
                56.1312056,
                30.1842948
              ],
              [
                56.1314824,
                30.1845744
              ],
              [
                56.1325922,
                30.1845744
              ],
              [
                56.1684284,
                30.1942914
              ],
              [
                56.1695384,
                30.1948508
              ],
              [
                56.1845383,
                30.1981799
              ],
              [
                56.1862049,
                30.1981799
              ],
              [
                56.1870417,
                30.1984597
              ],
              [
                56.190928,
                30.1984597
              ],
              [
                56.1942613,
                30.1959605
              ],
              [
                56.1948182,
                30.1942914
              ],
              [
                56.1953748,
                30.1929019
              ],
              [
                56.198708,
                30.1751281
              ],
              [
                56.200928,
                30.1612341
              ],
              [
                56.2012078,
                30.1595741
              ],
              [
                56.2037079,
                30.1540166
              ],
              [
                56.2045413,
                30.1481793
              ],
              [
                56.2042613,
                30.1479086
              ],
              [
                56.2039845,
                30.1445705
              ],
              [
                56.2039844,
                30.1440112
              ],
              [
                56.2125977,
                30.1462306
              ],
              [
                56.2450973,
                30.160404
              ],
              [
                56.2453772,
                30.1606838
              ],
              [
                56.2459306,
                30.1609544
              ],
              [
                56.246764,
                30.1609544
              ],
              [
                56.2478773,
                30.1615139
              ],
              [
                56.2484307,
                30.1617935
              ],
              [
                56.2562105,
                30.1645722
              ],
              [
                56.2570439,
                30.1645723
              ],
              [
                56.2578771,
                30.1651226
              ],
              [
                56.2587105,
                30.1651226
              ],
              [
                56.28899,
                30.1776273
              ],
              [
                56.2931566,
                30.1792963
              ],
              [
                56.2953767,
                30.1806767
              ],
              [
                56.2959333,
                30.1809564
              ],
              [
                56.2962099,
                30.1812361
              ],
              [
                56.2967665,
                30.1812361
              ],
              [
                56.2973233,
                30.1817955
              ],
              [
                56.2978764,
                30.1817955
              ],
              [
                56.358159,
                30.2034579
              ],
              [
                56.3598257,
                30.2042969
              ],
              [
                56.366769,
                30.2062367
              ],
              [
                56.3714921,
                30.2073464
              ],
              [
                56.3837154,
                30.2109553
              ],
              [
                56.3845486,
                30.2109554
              ],
              [
                56.4378845,
                30.2323475
              ],
              [
                56.4806641,
                30.257349
              ],
              [
                56.4870538,
                30.2626273
              ],
              [
                56.491497,
                30.2659567
              ],
              [
                56.4976105,
                30.2709552
              ],
              [
                56.4992771,
                30.2717943
              ],
              [
                56.5245534,
                30.2929077
              ],
              [
                56.5640029,
                30.3323471
              ],
              [
                56.5717795,
                30.3437343
              ],
              [
                56.5720561,
                30.344014
              ],
              [
                56.5720562,
                30.3445734
              ],
              [
                56.5734461,
                30.3445734
              ],
              [
                56.5740028,
                30.3448531
              ],
              [
                56.5781693,
                30.3448531
              ],
              [
                56.5787226,
                30.3445734
              ],
              [
                56.5798359,
                30.3445734
              ],
              [
                56.5806693,
                30.3442937
              ],
              [
                56.5817793,
                30.3442937
              ],
              [
                56.5820559,
                30.344014
              ],
              [
                56.5828927,
                30.344014
              ],
              [
                56.5842792,
                30.3437343
              ],
              [
                56.6070588,
                30.3315169
              ],
              [
                56.6090023,
                30.3298476
              ],
              [
                56.6120588,
                30.3284581
              ],
              [
                56.6128921,
                30.3279077
              ],
              [
                56.6181686,
                30.3265181
              ],
              [
                56.6192822,
                30.3265181
              ],
              [
                56.6201154,
                30.3262384
              ],
              [
                56.6212253,
                30.3262384
              ],
              [
                56.621782,
                30.3259587
              ],
              [
                56.6226154,
                30.3259587
              ],
              [
                56.6228919,
                30.3256789
              ],
              [
                56.628172,
                30.325679
              ],
              [
                56.6290054,
                30.3254083
              ],
              [
                56.6298386,
                30.325679
              ],
              [
                56.6320586,
                30.3262384
              ],
              [
                56.6331719,
                30.3270685
              ],
              [
                56.6370584,
                30.3337365
              ],
              [
                56.6373385,
                30.3348464
              ],
              [
                56.6376151,
                30.3356856
              ],
              [
                56.6465051,
                30.3573502
              ],
              [
                56.6467817,
                30.35763
              ],
              [
                56.647895,
                30.3629085
              ],
              [
                56.6481718,
                30.3641587
              ],
              [
                56.6484484,
                30.365408
              ],
              [
                56.651551,
                30.3763793
              ],
              [
                56.6520618,
                30.378185
              ],
              [
                56.6728948,
                30.4404023
              ],
              [
                56.6740047,
                30.4443005
              ],
              [
                56.6759516,
                30.4501299
              ],
              [
                56.6776181,
                30.456239
              ],
              [
                56.6878945,
                30.4806846
              ],
              [
                56.6880944,
                30.4812833
              ],
              [
                56.6894901,
                30.4901624
              ],
              [
                56.691679,
                30.4957792
              ],
              [
                56.6921559,
                30.5012837
              ],
              [
                56.6908225,
                30.5000242
              ],
              [
                56.6626228,
                30.4783782
              ],
              [
                56.6579604,
                30.4684083
              ],
              [
                56.6530323,
                30.4618054
              ],
              [
                56.6480176,
                30.4575159
              ],
              [
                56.6427205,
                30.4529842
              ],
              [
                56.6310455,
                30.4494129
              ],
              [
                56.6163751,
                30.4449234
              ],
              [
                56.6083709,
                30.4424729
              ],
              [
                56.5962429,
                30.4423422
              ],
              [
                56.5797521,
                30.4443232
              ],
              [
                56.5706541,
                30.4484264
              ],
              [
                56.5658688,
                30.452112
              ],
              [
                56.5604093,
                30.4548657
              ],
              [
                56.5584517,
                30.4558529
              ],
              [
                56.5538733,
                30.4581618
              ],
              [
                56.5494063,
                30.4619085
              ],
              [
                56.5464659,
                30.471094
              ],
              [
                56.5462357,
                30.4763124
              ],
              [
                56.5477935,
                30.4801671
              ],
              [
                56.5499151,
                30.484659
              ],
              [
                56.5503899,
                30.4873535
              ],
              [
                56.5503899,
                30.501801
              ],
              [
                56.5501133,
                30.5084606
              ],
              [
                56.54789,
                30.5187391
              ],
              [
                56.5448334,
                30.5420757
              ],
              [
                56.5451134,
                30.5426352
              ],
              [
                56.5451134,
                30.5456855
              ],
              [
                56.5453901,
                30.546245
              ],
              [
                56.5456668,
                30.5487447
              ],
              [
                56.5459467,
                30.5523544
              ],
              [
                56.5465001,
                30.5565236
              ],
              [
                56.5456668,
                30.5801315
              ],
              [
                56.5451135,
                30.5843008
              ],
              [
                56.5428902,
                30.5945797
              ],
              [
                56.5415002,
                30.5973502
              ],
              [
                56.5406668,
                30.6015287
              ],
              [
                56.5406668,
                30.6023589
              ],
              [
                56.5345569,
                30.6218069
              ],
              [
                56.5223339,
                30.6445764
              ],
              [
                56.5215005,
                30.6451359
              ],
              [
                56.5215005,
                30.6442967
              ],
              [
                56.5212206,
                30.6437461
              ],
              [
                56.5206673,
                30.6434663
              ],
              [
                56.5201106,
                30.6426361
              ],
              [
                56.5192771,
                30.6420765
              ],
              [
                56.5190007,
                30.6412463
              ],
              [
                56.5167773,
                30.6390262
              ],
              [
                56.5156674,
                30.6373565
              ],
              [
                56.4984441,
                30.6167983
              ],
              [
                56.4737212,
                30.5823515
              ],
              [
                56.4717745,
                30.5798608
              ],
              [
                56.4506614,
                30.5545745
              ],
              [
                56.4451082,
                30.5520748
              ],
              [
                56.4442749,
                30.5520748
              ],
              [
                56.4312184,
                30.5490245
              ],
              [
                56.4298283,
                30.5490245
              ],
              [
                56.4289951,
                30.5487448
              ],
              [
                56.4273285,
                30.5487448
              ],
              [
                56.4270518,
                30.5490245
              ],
              [
                56.4256618,
                30.5490246
              ],
              [
                56.4242718,
                30.5490245
              ],
              [
                56.4237185,
                30.5493043
              ],
              [
                56.4223286,
                30.549575
              ],
              [
                56.3959388,
                30.5493043
              ],
              [
                56.3948288,
                30.5495751
              ],
              [
                56.3873257,
                30.5490246
              ],
              [
                56.383439,
                30.5490246
              ],
              [
                56.3826058,
                30.5487448
              ],
              [
                56.3801058,
                30.5487448
              ],
              [
                56.3789925,
                30.5484651
              ],
              [
                56.3701026,
                30.5484651
              ],
              [
                56.3698258,
                30.5481853
              ],
              [
                56.3670492,
                30.5481854
              ],
              [
                56.3662161,
                30.5481854
              ],
              [
                56.363716,
                30.5481853
              ],
              [
                56.3628827,
                30.5484651
              ],
              [
                56.3620493,
                30.5484651
              ],
              [
                56.3614927,
                30.5487448
              ],
              [
                56.3606594,
                30.5487449
              ],
              [
                56.3603828,
                30.5490246
              ],
              [
                56.3595496,
                30.5490246
              ],
              [
                56.3364897,
                30.5637433
              ],
              [
                56.297877,
                30.5904106
              ],
              [
                56.2956572,
                30.5923599
              ],
              [
                56.2931571,
                30.5948596
              ],
              [
                56.238988,
                30.6479158
              ],
              [
                56.2367645,
                30.6498562
              ],
              [
                56.2334313,
                30.6531954
              ],
              [
                56.1950952,
                30.6848639
              ],
              [
                56.1900953,
                30.687084
              ],
              [
                56.1889854,
                30.6873547
              ],
              [
                56.188152,
                30.6873547
              ],
              [
                56.1848187,
                30.688194
              ],
              [
                56.1812054,
                30.6881941
              ],
              [
                56.1803721,
                30.6879142
              ],
              [
                56.178429,
                30.6879143
              ],
              [
                56.1770388,
                30.6873547
              ],
              [
                56.1762055,
                30.6865244
              ],
              [
                56.1756523,
                30.6865245
              ],
              [
                56.1678723,
                30.6829144
              ],
              [
                56.1664822,
                30.6826347
              ],
              [
                56.1287028,
                30.6648646
              ],
              [
                56.1264829,
                30.6634747
              ],
              [
                56.1195362,
                30.6601356
              ],
              [
                56.1078698,
                30.6562458
              ],
              [
                56.0998131,
                30.6543055
              ],
              [
                56.0950933,
                30.6543055
              ],
              [
                56.0948133,
                30.6545853
              ],
              [
                56.0909233,
                30.6568054
              ],
              [
                56.0906468,
                30.6570852
              ],
              [
                56.09037,
                30.657356
              ],
              [
                56.0900899,
                30.6576358
              ],
              [
                56.0898134,
                30.6581953
              ],
              [
                56.0717571,
                30.6820842
              ],
              [
                56.0684237,
                30.6884739
              ],
              [
                56.0550907,
                30.7062443
              ],
              [
                56.0537007,
                30.7081937
              ],
              [
                56.053144,
                30.7087442
              ],
              [
                56.0528673,
                30.7095835
              ],
              [
                56.0356443,
                30.7426428
              ],
              [
                56.0350877,
                30.7454136
              ],
              [
                56.0350876,
                30.7456934
              ],
              [
                56.0348109,
                30.7465237
              ],
              [
                56.0348109,
                30.7470833
              ],
              [
                56.0325876,
                30.751253
              ],
              [
                56.028701,
                30.7565328
              ],
              [
                56.0284209,
                30.757643
              ],
              [
                56.0095313,
                30.7948638
              ],
              [
                56.008978,
                30.7979144
              ],
              [
                56.0086979,
                30.7984741
              ],
              [
                56.0070313,
                30.8015337
              ],
              [
                56.0067548,
                30.8018045
              ],
              [
                56.0067548,
                30.8023641
              ],
              [
                55.9964748,
                30.816805
              ],
              [
                55.9800885,
                30.8431961
              ],
              [
                55.9792553,
                30.844586
              ],
              [
                55.9736986,
                30.8531966
              ],
              [
                55.9731418,
                30.8537562
              ],
              [
                55.9728653,
                30.854027
              ],
              [
                55.9531423,
                30.8701381
              ],
              [
                55.9425856,
                30.8809782
              ],
              [
                55.9417525,
                30.8812581
              ],
              [
                55.9411958,
                30.8820884
              ],
              [
                55.9234193,
                30.8951399
              ],
              [
                55.9206393,
                30.8970805
              ],
              [
                55.8748033,
                30.9326432
              ],
              [
                55.8745268,
                30.9329139
              ],
              [
                55.8739708,
                30.9334741
              ],
              [
                55.8736934,
                30.9337534
              ],
              [
                55.8734168,
                30.9340333
              ],
              [
                55.8728602,
                30.934313
              ],
              [
                55.8673035,
                30.9387539
              ],
              [
                55.8653603,
                30.941534
              ],
              [
                55.8209141,
                30.9787492
              ],
              [
                55.8184143,
                30.980419
              ],
              [
                55.8139675,
                30.9837498
              ],
              [
                55.8103577,
                30.9859793
              ],
              [
                55.7961912,
                30.9993112
              ],
              [
                55.788688,
                31.0045827
              ],
              [
                55.7586884,
                31.0332056
              ],
              [
                55.7550786,
                31.037367
              ],
              [
                55.7281322,
                31.0676422
              ],
              [
                55.7170191,
                31.0801443
              ],
              [
                55.7006294,
                31.1031986
              ],
              [
                55.6961861,
                31.1084793
              ],
              [
                55.6831297,
                31.1254228
              ],
              [
                55.6228505,
                31.1770933
              ],
              [
                55.6192371,
                31.1812638
              ],
              [
                55.6153473,
                31.1857051
              ],
              [
                55.6061807,
                31.1993181
              ],
              [
                55.5822911,
                31.2298662
              ],
              [
                55.5817344,
                31.2309765
              ],
              [
                55.5816724,
                31.2310392
              ],
              [
                55.5811811,
                31.2315362
              ],
              [
                55.5803478,
                31.2309766
              ],
              [
                55.5056222,
                31.190986
              ],
              [
                55.5000655,
                31.1884855
              ],
              [
                55.494789,
                31.185976
              ],
              [
                55.4925657,
                31.1854254
              ],
              [
                55.4917323,
                31.1848657
              ],
              [
                55.4886758,
                31.1840352
              ],
              [
                55.4878424,
                31.1834846
              ],
              [
                55.4850659,
                31.1829248
              ],
              [
                55.4606195,
                31.1759831
              ],
              [
                55.4600628,
                31.1754233
              ],
              [
                55.4595095,
                31.1754234
              ],
              [
                55.4431198,
                31.1684815
              ],
              [
                55.4247832,
                31.1618105
              ],
              [
                55.4195067,
                31.1601496
              ],
              [
                55.399507,
                31.1518177
              ],
              [
                55.3767273,
                31.1445961
              ],
              [
                55.3661709,
                31.1420956
              ],
              [
                55.326168,
                31.1295933
              ],
              [
                55.325058,
                31.1295934
              ],
              [
                55.3150581,
                31.1270929
              ],
              [
                55.3128348,
                31.1262534
              ],
              [
                55.2892217,
                31.1179215
              ],
              [
                55.2881119,
                31.1179216
              ],
              [
                55.2878352,
                31.1176418
              ],
              [
                55.2778319,
                31.1151413
              ],
              [
                55.2769986,
                31.1148705
              ],
              [
                55.2764454,
                31.1145907
              ],
              [
                55.2761653,
                31.1143109
              ],
              [
                55.2753319,
                31.1143108
              ],
              [
                55.2751511,
                31.1141279
              ],
              [
                55.2750554,
                31.114031
              ],
              [
                55.2708887,
                31.1126499
              ],
              [
                55.2694988,
                31.1126499
              ],
              [
                55.2692599,
                31.1125291
              ],
              [
                55.2689456,
                31.11237
              ],
              [
                55.2678321,
                31.1123701
              ],
              [
                55.2675555,
                31.1120903
              ],
              [
                55.2669987,
                31.1120903
              ],
              [
                55.2667221,
                31.1118104
              ],
              [
                55.2656121,
                31.1112597
              ],
              [
                55.2647789,
                31.1107001
              ],
              [
                55.2642221,
                31.1104203
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555049,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رودبار جنوب",
          "name:en": "Rudbar-e Jonubi County",
          "place": "county",
          "population": "105992",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q2610470",
          "wikipedia": "en:Rudbar-e Jonubi County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.8214311,
                28.2248664
              ],
              [
                57.8282304,
                28.2150032
              ],
              [
                57.8525166,
                28.1882215
              ],
              [
                57.8578727,
                28.1847816
              ],
              [
                57.8555488,
                28.1816618
              ],
              [
                57.8528265,
                28.1796195
              ],
              [
                57.8528881,
                28.1770089
              ],
              [
                57.8522287,
                28.1750934
              ],
              [
                57.8607844,
                28.1566168
              ],
              [
                57.8649901,
                28.1498061
              ],
              [
                57.8648184,
                28.1461735
              ],
              [
                57.8538751,
                28.1441678
              ],
              [
                57.852212,
                28.1432124
              ],
              [
                57.8518902,
                28.1416135
              ],
              [
                57.8531883,
                28.1401756
              ],
              [
                57.8618572,
                28.1382456
              ],
              [
                57.8648186,
                28.137394
              ],
              [
                57.867136,
                28.1352747
              ],
              [
                57.8684018,
                28.1319444
              ],
              [
                57.8675848,
                28.1282533
              ],
              [
                57.8695016,
                28.1186099
              ],
              [
                57.8715348,
                28.1144015
              ],
              [
                57.8725432,
                28.1097964
              ],
              [
                57.8722,
                28.1051464
              ],
              [
                57.8692613,
                28.0827299
              ],
              [
                57.8666482,
                28.0707587
              ],
              [
                57.8637027,
                28.064634
              ],
              [
                57.8590865,
                28.0472213
              ],
              [
                57.84122,
                28.0272038
              ],
              [
                57.835121,
                28.0228941
              ],
              [
                57.8205298,
                28.0119829
              ],
              [
                57.8232763,
                28.0083456
              ],
              [
                57.8280787,
                28.0051596
              ],
              [
                57.8410416,
                27.9885639
              ],
              [
                57.8601479,
                27.9711659
              ],
              [
                57.8925594,
                27.954932
              ],
              [
                57.8715526,
                27.9395217
              ],
              [
                57.8718328,
                27.9389636
              ],
              [
                57.8737796,
                27.9367403
              ],
              [
                57.912392,
                27.8928506
              ],
              [
                57.9151654,
                27.8909064
              ],
              [
                57.9151654,
                27.8906274
              ],
              [
                57.919892,
                27.8850739
              ],
              [
                57.9198921,
                27.8847948
              ],
              [
                57.9204452,
                27.8845248
              ],
              [
                57.9212784,
                27.8834087
              ],
              [
                57.9218319,
                27.8828507
              ],
              [
                57.9251653,
                27.8803484
              ],
              [
                57.9265585,
                27.8784043
              ],
              [
                57.9315582,
                27.8731299
              ],
              [
                57.948778,
                27.8617441
              ],
              [
                57.9521113,
                27.860079
              ],
              [
                57.9837841,
                27.8481264
              ],
              [
                57.9840575,
                27.8475684
              ],
              [
                57.9871173,
                27.8453544
              ],
              [
                58.0029504,
                27.8225749
              ],
              [
                58.004057,
                27.8184079
              ],
              [
                58.0048903,
                27.815627
              ],
              [
                58.0054504,
                27.8111899
              ],
              [
                58.0060039,
                27.8042421
              ],
              [
                58.0068372,
                27.7931275
              ],
              [
                58.0104504,
                27.7795201
              ],
              [
                58.0118368,
                27.7761813
              ],
              [
                58.0210033,
                27.7617374
              ],
              [
                58.0510096,
                27.7336872
              ],
              [
                58.0554496,
                27.7311855
              ],
              [
                58.0576762,
                27.7300697
              ],
              [
                58.059616,
                27.7295207
              ],
              [
                58.0607294,
                27.7295207
              ],
              [
                58.0612829,
                27.7292418
              ],
              [
                58.0651763,
                27.7292418
              ],
              [
                58.0679493,
                27.7300696
              ],
              [
                58.0690628,
                27.7300697
              ],
              [
                58.0696158,
                27.7303486
              ],
              [
                58.0707291,
                27.7303486
              ],
              [
                58.0712827,
                27.7306276
              ],
              [
                58.072396,
                27.7306276
              ],
              [
                58.072676,
                27.7309065
              ],
              [
                58.0737827,
                27.7309066
              ],
              [
                58.0743425,
                27.7311855
              ],
              [
                58.0798957,
                27.7311855
              ],
              [
                58.0865622,
                27.7303486
              ],
              [
                58.1057285,
                27.7247963
              ],
              [
                58.1240686,
                27.7170123
              ],
              [
                58.1454546,
                27.7039553
              ],
              [
                58.1460081,
                27.7031275
              ],
              [
                58.1471214,
                27.7022906
              ],
              [
                58.1485081,
                27.7003469
              ],
              [
                58.1607344,
                27.6917354
              ],
              [
                58.1640678,
                27.6903497
              ],
              [
                58.1646209,
                27.6897918
              ],
              [
                58.1715675,
                27.6875692
              ],
              [
                58.1801809,
                27.6859046
              ],
              [
                58.1926807,
                27.6822872
              ],
              [
                58.1946206,
                27.6820173
              ],
              [
                58.1974003,
                27.6820172
              ],
              [
                58.1976804,
                27.6817383
              ],
              [
                58.1999004,
                27.6817383
              ],
              [
                58.2024004,
                27.6811804
              ],
              [
                58.2037938,
                27.6811803
              ],
              [
                58.2043469,
                27.6809015
              ],
              [
                58.2060137,
                27.6806315
              ],
              [
                58.2082338,
                27.6806315
              ],
              [
                58.2087938,
                27.6803436
              ],
              [
                58.2126802,
                27.6800737
              ],
              [
                58.2129603,
                27.6803435
              ],
              [
                58.2171269,
                27.6803435
              ],
              [
                58.2174003,
                27.6806315
              ],
              [
                58.2182335,
                27.6806315
              ],
              [
                58.2196269,
                27.6809014
              ],
              [
                58.2196269,
                27.6811804
              ],
              [
                58.2212937,
                27.6822871
              ],
              [
                58.2629597,
                27.6975663
              ],
              [
                58.2651793,
                27.6975663
              ],
              [
                58.2657394,
                27.6978452
              ],
              [
                58.2682395,
                27.6978452
              ],
              [
                58.2685129,
                27.6981241
              ],
              [
                58.2693461,
                27.6978452
              ],
              [
                58.2715727,
                27.6978451
              ],
              [
                58.2721258,
                27.6975662
              ],
              [
                58.2790725,
                27.6972962
              ],
              [
                58.279626,
                27.6970173
              ],
              [
                58.2804592,
                27.6970173
              ],
              [
                58.2807393,
                27.6967384
              ],
              [
                58.2824057,
                27.6964594
              ],
              [
                58.2904589,
                27.6945158
              ],
              [
                58.2968525,
                27.6909074
              ],
              [
                58.3212986,
                27.6734058
              ],
              [
                58.3332381,
                27.6634089
              ],
              [
                58.354078,
                27.6495161
              ],
              [
                58.3757443,
                27.6384039
              ],
              [
                58.3776843,
                27.6378461
              ],
              [
                58.3893574,
                27.6325644
              ],
              [
                58.3907441,
                27.6322944
              ],
              [
                58.3921306,
                27.6317366
              ],
              [
                58.3929641,
                27.6317366
              ],
              [
                58.4024103,
                27.6292353
              ],
              [
                58.4074104,
                27.6275708
              ],
              [
                58.421297,
                27.6239537
              ],
              [
                58.4324101,
                27.6222892
              ],
              [
                58.4343566,
                27.6222892
              ],
              [
                58.4399098,
                27.6214614
              ],
              [
                58.4421364,
                27.6214614
              ],
              [
                58.4557429,
                27.6175655
              ],
              [
                58.4724162,
                27.6081272
              ],
              [
                58.4835226,
                27.6000657
              ],
              [
                58.5001956,
                27.5889543
              ],
              [
                58.537975,
                27.5384018
              ],
              [
                58.5454748,
                27.5336788
              ],
              [
                58.5876942,
                27.5134013
              ],
              [
                58.595474,
                27.5106215
              ],
              [
                58.6118672,
                27.5061775
              ],
              [
                58.6129734,
                27.5061775
              ],
              [
                58.6138071,
                27.5058986
              ],
              [
                58.6143669,
                27.5058987
              ],
              [
                58.6149203,
                27.5058986
              ],
              [
                58.6335332,
                27.4997904
              ],
              [
                58.6340867,
                27.4992326
              ],
              [
                58.6649192,
                27.4881228
              ],
              [
                58.666586,
                27.487844
              ],
              [
                58.6679795,
                27.4872862
              ],
              [
                58.6757526,
                27.4850643
              ],
              [
                58.6765859,
                27.4845066
              ],
              [
                58.6846457,
                27.4822936
              ],
              [
                58.6868656,
                27.4820058
              ],
              [
                58.7226983,
                27.4756189
              ],
              [
                58.7257585,
                27.4756189
              ],
              [
                58.7274249,
                27.47534
              ],
              [
                58.7460381,
                27.4745123
              ],
              [
                58.7543714,
                27.4745123
              ],
              [
                58.7563114,
                27.4742335
              ],
              [
                58.7574247,
                27.4745124
              ],
              [
                58.7590911,
                27.4742335
              ],
              [
                58.761038,
                27.4742335
              ],
              [
                58.7618712,
                27.4745123
              ],
              [
                58.7638178,
                27.4742335
              ],
              [
                58.7657576,
                27.4745124
              ],
              [
                58.774091,
                27.4747822
              ],
              [
                58.7834505,
                27.4747824
              ],
              [
                58.789924,
                27.4747821
              ],
              [
                58.7924241,
                27.47507
              ],
              [
                58.8463165,
                27.4781194
              ],
              [
                58.8513165,
                27.4781193
              ],
              [
                58.8527099,
                27.4778405
              ],
              [
                58.8574295,
                27.4775706
              ],
              [
                58.8657628,
                27.4775706
              ],
              [
                58.866043,
                27.4772918
              ],
              [
                58.8746493,
                27.4772913
              ],
              [
                58.8746492,
                27.4781193
              ],
              [
                58.8749294,
                27.4786771
              ],
              [
                58.8752095,
                27.4797925
              ],
              [
                58.8754825,
                27.4811779
              ],
              [
                58.8788229,
                27.495346
              ],
              [
                58.879096,
                27.4972891
              ],
              [
                58.8860426,
                27.5145073
              ],
              [
                58.8904892,
                27.5328415
              ],
              [
                58.8904892,
                27.5336782
              ],
              [
                58.8904892,
                27.5339571
              ],
              [
                58.8910427,
                27.5347847
              ],
              [
                58.8922721,
                27.5383758
              ],
              [
                58.8971558,
                27.5542349
              ],
              [
                58.8985424,
                27.5589582
              ],
              [
                58.9010426,
                27.5764568
              ],
              [
                58.9010426,
                27.5945137
              ],
              [
                58.9007625,
                27.5986794
              ],
              [
                58.9010426,
                27.5995162
              ],
              [
                58.9007626,
                27.603124
              ],
              [
                58.9010426,
                27.6042397
              ],
              [
                58.9002095,
                27.6253475
              ],
              [
                58.9019541,
                27.6377946
              ],
              [
                58.9024291,
                27.6411833
              ],
              [
                58.9029893,
                27.6456281
              ],
              [
                58.9057628,
                27.6706244
              ],
              [
                58.9057628,
                27.6797935
              ],
              [
                58.9050376,
                27.7015338
              ],
              [
                58.9050365,
                27.7018484
              ],
              [
                58.9052094,
                27.7056278
              ],
              [
                58.9049293,
                27.7114589
              ],
              [
                58.9049293,
                27.7139605
              ],
              [
                58.9038231,
                27.7492361
              ],
              [
                58.9032629,
                27.759792
              ],
              [
                58.9029895,
                27.7617359
              ],
              [
                58.9032629,
                27.7689624
              ],
              [
                58.9029896,
                27.7847923
              ],
              [
                58.9024295,
                27.7953489
              ],
              [
                58.9027095,
                27.7975718
              ],
              [
                58.9024294,
                27.8003528
              ],
              [
                58.9027096,
                27.8025757
              ],
              [
                58.9021564,
                27.8189554
              ],
              [
                58.900763,
                27.8372976
              ],
              [
                58.8988233,
                27.848962
              ],
              [
                58.8974299,
                27.8545152
              ],
              [
                58.8952099,
                27.8675749
              ],
              [
                58.8935435,
                27.8756305
              ],
              [
                58.8918767,
                27.8811839
              ],
              [
                58.8904901,
                27.8981235
              ],
              [
                58.8907634,
                27.8989606
              ],
              [
                58.9002412,
                27.961406
              ],
              [
                58.9025446,
                27.9674952
              ],
              [
                58.9047288,
                27.9702735
              ],
              [
                58.9097296,
                27.9816713
              ],
              [
                58.9140843,
                27.99296
              ],
              [
                58.9170634,
                27.9987454
              ],
              [
                58.9197468,
                28.0014716
              ],
              [
                58.9240764,
                28.0075521
              ],
              [
                58.9273857,
                28.0180088
              ],
              [
                58.9283298,
                28.0216955
              ],
              [
                58.9295566,
                28.0314211
              ],
              [
                58.9304873,
                28.0378334
              ],
              [
                58.9325627,
                28.0456031
              ],
              [
                58.9347672,
                28.0540425
              ],
              [
                58.936339,
                28.0581839
              ],
              [
                58.9390263,
                28.0633086
              ],
              [
                58.9422858,
                28.0692869
              ],
              [
                58.94428,
                28.0740423
              ],
              [
                58.9485012,
                28.0780233
              ],
              [
                58.9602105,
                28.0917223
              ],
              [
                58.9378737,
                28.1063579
              ],
              [
                58.9168286,
                28.1210659
              ],
              [
                58.8930659,
                28.1390344
              ],
              [
                58.8845494,
                28.1438519
              ],
              [
                58.8663795,
                28.1509499
              ],
              [
                58.8579774,
                28.153391
              ],
              [
                58.8448018,
                28.157966
              ],
              [
                58.8313579,
                28.1630489
              ],
              [
                58.8184566,
                28.1664228
              ],
              [
                58.8017703,
                28.170914
              ],
              [
                58.7965329,
                28.171966
              ],
              [
                58.7819153,
                28.1743167
              ],
              [
                58.7643642,
                28.1805471
              ],
              [
                58.7427339,
                28.1864598
              ],
              [
                58.7226723,
                28.1912923
              ],
              [
                58.693979,
                28.1984727
              ],
              [
                58.6783613,
                28.2023115
              ],
              [
                58.6686405,
                28.2043304
              ],
              [
                58.6612512,
                28.2061458
              ],
              [
                58.643335,
                28.2104843
              ],
              [
                58.6054512,
                28.2198862
              ],
              [
                58.5910777,
                28.2239899
              ],
              [
                58.5756962,
                28.2279225
              ],
              [
                58.5614098,
                28.2298885
              ],
              [
                58.5430628,
                28.2300777
              ],
              [
                58.5283991,
                28.2314441
              ],
              [
                58.5224471,
                28.2321247
              ],
              [
                58.5179618,
                28.2334859
              ],
              [
                58.5136433,
                28.230569
              ],
              [
                58.5097228,
                28.2276197
              ],
              [
                58.5000652,
                28.2181377
              ],
              [
                58.4894006,
                28.1968312
              ],
              [
                58.4815338,
                28.1946936
              ],
              [
                58.4644853,
                28.1907092
              ],
              [
                58.4470127,
                28.1874042
              ],
              [
                58.413278,
                28.1800574
              ],
              [
                58.3997627,
                28.1751612
              ],
              [
                58.3921676,
                28.1726633
              ],
              [
                58.3769271,
                28.1685766
              ],
              [
                58.36539,
                28.1657427
              ],
              [
                58.3565287,
                28.164555
              ],
              [
                58.3414507,
                28.1611451
              ],
              [
                58.3261021,
                28.1548685
              ],
              [
                58.3151348,
                28.1524994
              ],
              [
                58.3026447,
                28.1499263
              ],
              [
                58.2955099,
                28.1478777
              ],
              [
                58.2866305,
                28.1454386
              ],
              [
                58.2809631,
                28.1432198
              ],
              [
                58.2718472,
                28.1395869
              ],
              [
                58.2650081,
                28.13734
              ],
              [
                58.2546724,
                28.1366967
              ],
              [
                58.250295,
                28.1367203
              ],
              [
                58.2449301,
                28.1382289
              ],
              [
                58.2373819,
                28.1383097
              ],
              [
                58.2319623,
                28.1388348
              ],
              [
                58.2182737,
                28.1395728
              ],
              [
                58.2147852,
                28.1405331
              ],
              [
                58.2050292,
                28.1418575
              ],
              [
                58.1850584,
                28.1443102
              ],
              [
                58.165329,
                28.1485531
              ],
              [
                58.146075,
                28.1527729
              ],
              [
                58.1233225,
                28.1574091
              ],
              [
                58.086406,
                28.1644316
              ],
              [
                58.0703673,
                28.1686651
              ],
              [
                58.0550234,
                28.1735398
              ],
              [
                58.0272033,
                28.1846666
              ],
              [
                58.0113911,
                28.1977799
              ],
              [
                58.0071529,
                28.2042682
              ],
              [
                58.0008618,
                28.2175706
              ],
              [
                57.9989545,
                28.2250556
              ],
              [
                57.998896,
                28.2335828
              ],
              [
                57.9974325,
                28.2381537
              ],
              [
                57.995041,
                28.2409243
              ],
              [
                57.9905751,
                28.243929
              ],
              [
                57.986625,
                28.2455186
              ],
              [
                57.9842113,
                28.2470362
              ],
              [
                57.9786728,
                28.2486673
              ],
              [
                57.9676909,
                28.2496412
              ],
              [
                57.9641337,
                28.2489751
              ],
              [
                57.9586292,
                28.2483274
              ],
              [
                57.9407086,
                28.2476145
              ],
              [
                57.9307996,
                28.2474922
              ],
              [
                57.9208958,
                28.2476635
              ],
              [
                57.9112189,
                28.2474834
              ],
              [
                57.8929642,
                28.2477803
              ],
              [
                57.8605774,
                28.2476491
              ],
              [
                57.8458499,
                28.246139
              ],
              [
                57.8437471,
                28.2453829
              ],
              [
                57.838198,
                28.2417773
              ],
              [
                57.8336889,
                28.2377617
              ],
              [
                57.8240569,
                28.2270426
              ],
              [
                57.8214311,
                28.2248664
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555052,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ریگان",
          "name:en": "Rigan County",
          "place": "county",
          "population": "88410",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q7333357",
          "wikipedia": "en:Rigan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.496725,
                28.4973847
              ],
              [
                58.4979056,
                28.4899667
              ],
              [
                58.4955023,
                28.4806122
              ],
              [
                58.4960173,
                28.476689
              ],
              [
                58.4954085,
                28.4556778
              ],
              [
                58.4962632,
                28.4239537
              ],
              [
                58.5036009,
                28.386054
              ],
              [
                58.544262,
                28.3609814
              ],
              [
                58.5467395,
                28.3329567
              ],
              [
                58.536545,
                28.3159801
              ],
              [
                58.5127282,
                28.2973906
              ],
              [
                58.4935845,
                28.2578759
              ],
              [
                58.5079136,
                28.2512785
              ],
              [
                58.5113934,
                28.2455735
              ],
              [
                58.5146158,
                28.2390456
              ],
              [
                58.5179618,
                28.2334859
              ],
              [
                58.5224471,
                28.2321247
              ],
              [
                58.5283991,
                28.2314441
              ],
              [
                58.5430628,
                28.2300777
              ],
              [
                58.5614098,
                28.2298885
              ],
              [
                58.5756962,
                28.2279225
              ],
              [
                58.5910777,
                28.2239899
              ],
              [
                58.6054512,
                28.2198862
              ],
              [
                58.643335,
                28.2104843
              ],
              [
                58.6612512,
                28.2061458
              ],
              [
                58.6686405,
                28.2043304
              ],
              [
                58.6783613,
                28.2023115
              ],
              [
                58.693979,
                28.1984727
              ],
              [
                58.7226723,
                28.1912923
              ],
              [
                58.7427339,
                28.1864598
              ],
              [
                58.7643642,
                28.1805471
              ],
              [
                58.7819153,
                28.1743167
              ],
              [
                58.7965329,
                28.171966
              ],
              [
                58.8017703,
                28.170914
              ],
              [
                58.8184566,
                28.1664228
              ],
              [
                58.8313579,
                28.1630489
              ],
              [
                58.8448018,
                28.157966
              ],
              [
                58.8579774,
                28.153391
              ],
              [
                58.8663795,
                28.1509499
              ],
              [
                58.8845494,
                28.1438519
              ],
              [
                58.8930659,
                28.1390344
              ],
              [
                58.9168286,
                28.1210659
              ],
              [
                58.9378737,
                28.1063579
              ],
              [
                58.9602105,
                28.0917223
              ],
              [
                58.9723105,
                28.085223
              ],
              [
                58.9796304,
                28.0812005
              ],
              [
                58.9823901,
                28.0788858
              ],
              [
                58.9895225,
                28.0735847
              ],
              [
                58.9998553,
                28.0658079
              ],
              [
                59.0027146,
                28.0641416
              ],
              [
                59.0100459,
                28.0602271
              ],
              [
                59.0212942,
                28.0535882
              ],
              [
                59.0658764,
                28.0285756
              ],
              [
                59.0872189,
                28.0189542
              ],
              [
                59.0940854,
                28.0077396
              ],
              [
                59.0930554,
                27.9865195
              ],
              [
                59.1098782,
                27.9452799
              ],
              [
                59.1572567,
                27.9067553
              ],
              [
                59.1946789,
                27.9091824
              ],
              [
                59.2434307,
                27.9328443
              ],
              [
                59.2454907,
                27.9543783
              ],
              [
                59.2732998,
                27.973179
              ],
              [
                59.3272015,
                28.0141048
              ],
              [
                59.332723,
                28.0152965
              ],
              [
                59.3556973,
                28.0162264
              ],
              [
                59.4363781,
                28.0141048
              ],
              [
                59.4725131,
                28.0144834
              ],
              [
                59.5123812,
                28.0133091
              ],
              [
                59.5487308,
                28.0134225
              ],
              [
                59.5813992,
                28.0135536
              ],
              [
                59.5748234,
                28.0139435
              ],
              [
                59.5677423,
                28.0151653
              ],
              [
                59.5637512,
                28.0153548
              ],
              [
                59.5523357,
                28.0164914
              ],
              [
                59.5457696,
                28.0174385
              ],
              [
                59.5504903,
                28.0246745
              ],
              [
                59.5519495,
                28.03441
              ],
              [
                59.5530653,
                28.0412282
              ],
              [
                59.5516491,
                28.0451674
              ],
              [
                59.5493316,
                28.0447129
              ],
              [
                59.5482158,
                28.0420994
              ],
              [
                59.5452976,
                28.0417964
              ],
              [
                59.5401477,
                28.0427054
              ],
              [
                59.5357724,
                28.0442869
              ],
              [
                59.5220382,
                28.0550237
              ],
              [
                59.4832945,
                28.0859233
              ],
              [
                59.4973983,
                28.0982945
              ],
              [
                59.506103,
                28.1205522
              ],
              [
                59.5139315,
                28.1392267
              ],
              [
                59.5227946,
                28.1584981
              ],
              [
                59.5650865,
                28.2039522
              ],
              [
                59.5779227,
                28.2259113
              ],
              [
                59.6050252,
                28.2680902
              ],
              [
                59.5964291,
                28.2957708
              ],
              [
                59.5310793,
                28.3116972
              ],
              [
                59.4783579,
                28.287017
              ],
              [
                59.4383044,
                28.3081032
              ],
              [
                59.4186717,
                28.3197897
              ],
              [
                59.415842,
                28.3448278
              ],
              [
                59.4433078,
                28.3977557
              ],
              [
                59.5559179,
                28.3835777
              ],
              [
                59.6371254,
                28.3995574
              ],
              [
                59.709973,
                28.4390211
              ],
              [
                59.7254961,
                28.4868834
              ],
              [
                59.6821137,
                28.5189455
              ],
              [
                59.5978032,
                28.5717089
              ],
              [
                59.585699,
                28.5801563
              ],
              [
                59.5644375,
                28.5950731
              ],
              [
                59.5314785,
                28.6246107
              ],
              [
                59.5153424,
                28.667094
              ],
              [
                59.511895,
                28.6913351
              ],
              [
                59.50801,
                28.7109369
              ],
              [
                59.5069348,
                28.7237471
              ],
              [
                59.5053182,
                28.7448984
              ],
              [
                59.4996122,
                28.8001384
              ],
              [
                59.4199441,
                28.7867463
              ],
              [
                59.3559428,
                28.7756557
              ],
              [
                59.2852626,
                28.7638283
              ],
              [
                59.1984891,
                28.7522873
              ],
              [
                59.1397658,
                28.7465938
              ],
              [
                59.0912136,
                28.7441691
              ],
              [
                59.0781489,
                28.7434796
              ],
              [
                59.056573,
                28.7429954
              ],
              [
                59.0408931,
                28.7411891
              ],
              [
                59.0272671,
                28.7406961
              ],
              [
                59.0247344,
                28.7444835
              ],
              [
                59.0211735,
                28.7482286
              ],
              [
                59.0128995,
                28.7537436
              ],
              [
                59.0046434,
                28.7491993
              ],
              [
                58.9932473,
                28.7572619
              ],
              [
                58.9823545,
                28.7630473
              ],
              [
                58.9766532,
                28.7658192
              ],
              [
                58.9695143,
                28.7695244
              ],
              [
                58.9649362,
                28.7720043
              ],
              [
                58.9571536,
                28.7760596
              ],
              [
                58.9499882,
                28.7808213
              ],
              [
                58.9358435,
                28.7848339
              ],
              [
                58.9152741,
                28.789402
              ],
              [
                58.9030858,
                28.7921069
              ],
              [
                58.9021588,
                28.7923126
              ],
              [
                58.9015994,
                28.7920319
              ],
              [
                58.9010455,
                28.7917538
              ],
              [
                58.8988255,
                28.7906456
              ],
              [
                58.8743793,
                28.7814815
              ],
              [
                58.8621525,
                28.7792649
              ],
              [
                58.8541074,
                28.7797956
              ],
              [
                58.8538191,
                28.7798146
              ],
              [
                58.8363196,
                28.7845363
              ],
              [
                58.8093735,
                28.7953764
              ],
              [
                58.7818737,
                28.8081541
              ],
              [
                58.7502076,
                28.8264829
              ],
              [
                58.7471479,
                28.828979
              ],
              [
                58.7443743,
                28.8317634
              ],
              [
                58.7379813,
                28.8364854
              ],
              [
                58.7338148,
                28.8403693
              ],
              [
                58.7152016,
                28.8578696
              ],
              [
                58.7151192,
                28.8579538
              ],
              [
                58.7149282,
                28.8581489
              ],
              [
                58.7140917,
                28.858149
              ],
              [
                58.7135348,
                28.8581489
              ],
              [
                58.7110414,
                28.8581489
              ],
              [
                58.7104817,
                28.8581489
              ],
              [
                58.7103149,
                28.8582332
              ],
              [
                58.7099285,
                28.8584283
              ],
              [
                58.7075124,
                28.8584284
              ],
              [
                58.7071484,
                28.8584284
              ],
              [
                58.706774,
                28.8585539
              ],
              [
                58.7063151,
                28.8587077
              ],
              [
                58.6899289,
                28.8600955
              ],
              [
                58.6849222,
                28.8600955
              ],
              [
                58.6827023,
                28.8603749
              ],
              [
                58.6646492,
                28.8603749
              ],
              [
                58.663816,
                28.8600956
              ],
              [
                58.6621492,
                28.8600955
              ],
              [
                58.6257563,
                28.8537065
              ],
              [
                58.6154764,
                28.8512012
              ],
              [
                58.6140897,
                28.8512013
              ],
              [
                58.59381,
                28.8453709
              ],
              [
                58.5935299,
                28.8442625
              ],
              [
                58.5932569,
                28.8437037
              ],
              [
                58.5871434,
                28.804541
              ],
              [
                58.5868633,
                28.7928718
              ],
              [
                58.5888101,
                28.7725884
              ],
              [
                58.5890902,
                28.7653709
              ],
              [
                58.5904765,
                28.7562072
              ],
              [
                58.5904766,
                28.743151
              ],
              [
                58.5899234,
                28.734537
              ],
              [
                58.5868631,
                28.7070379
              ],
              [
                58.58659,
                28.7059206
              ],
              [
                58.5865901,
                28.7045331
              ],
              [
                58.5857568,
                28.7003705
              ],
              [
                58.5846431,
                28.6970369
              ],
              [
                58.5849233,
                28.6967575
              ],
              [
                58.5851966,
                28.6939825
              ],
              [
                58.5681004,
                28.6817961
              ],
              [
                58.5646838,
                28.6611479
              ],
              [
                58.5580369,
                28.6488654
              ],
              [
                58.5522507,
                28.6337592
              ],
              [
                58.552322,
                28.6240079
              ],
              [
                58.5505569,
                28.6032688
              ],
              [
                58.5531096,
                28.5547099
              ],
              [
                58.5607337,
                28.5387629
              ],
              [
                58.5632228,
                28.5278291
              ],
              [
                58.5635447,
                28.5263396
              ],
              [
                58.5634945,
                28.521749
              ],
              [
                58.5536272,
                28.5180154
              ],
              [
                58.5506659,
                28.5132649
              ],
              [
                58.5431218,
                28.5130252
              ],
              [
                58.5395498,
                28.5119742
              ],
              [
                58.5380228,
                28.5096738
              ],
              [
                58.5346395,
                28.5098624
              ],
              [
                58.5212616,
                28.5077278
              ],
              [
                58.5128511,
                28.50537
              ],
              [
                58.5061454,
                28.5016964
              ],
              [
                58.4999656,
                28.4983397
              ],
              [
                58.496725,
                28.4973847
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555057,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زرند",
          "name:en": "Zarand County",
          "place": "county",
          "population": "138133",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1287784",
          "wikipedia": "en:Zarand County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.5811811,
                31.2315362
              ],
              [
                55.5816724,
                31.2310392
              ],
              [
                55.5817344,
                31.2309765
              ],
              [
                55.5822911,
                31.2298662
              ],
              [
                55.6061807,
                31.1993181
              ],
              [
                55.6153473,
                31.1857051
              ],
              [
                55.6192371,
                31.1812638
              ],
              [
                55.6228505,
                31.1770933
              ],
              [
                55.6831297,
                31.1254228
              ],
              [
                55.6961861,
                31.1084793
              ],
              [
                55.7006294,
                31.1031986
              ],
              [
                55.7170191,
                31.0801443
              ],
              [
                55.7281322,
                31.0676422
              ],
              [
                55.7550786,
                31.037367
              ],
              [
                55.7586884,
                31.0332056
              ],
              [
                55.788688,
                31.0045827
              ],
              [
                55.7961912,
                30.9993112
              ],
              [
                55.8103577,
                30.9859793
              ],
              [
                55.8139675,
                30.9837498
              ],
              [
                55.8184143,
                30.980419
              ],
              [
                55.8209141,
                30.9787492
              ],
              [
                55.8653603,
                30.941534
              ],
              [
                55.8673035,
                30.9387539
              ],
              [
                55.8728602,
                30.934313
              ],
              [
                55.8734168,
                30.9340333
              ],
              [
                55.8736934,
                30.9337534
              ],
              [
                55.8739708,
                30.9334741
              ],
              [
                55.8745268,
                30.9329139
              ],
              [
                55.8748033,
                30.9326432
              ],
              [
                55.9206393,
                30.8970805
              ],
              [
                55.9234193,
                30.8951399
              ],
              [
                55.9411958,
                30.8820884
              ],
              [
                55.9417525,
                30.8812581
              ],
              [
                55.9425856,
                30.8809782
              ],
              [
                55.9531423,
                30.8701381
              ],
              [
                55.9728653,
                30.854027
              ],
              [
                55.9731418,
                30.8537562
              ],
              [
                55.9736986,
                30.8531966
              ],
              [
                55.9792553,
                30.844586
              ],
              [
                55.9800885,
                30.8431961
              ],
              [
                55.9964748,
                30.816805
              ],
              [
                56.0067548,
                30.8023641
              ],
              [
                56.0067548,
                30.8018045
              ],
              [
                56.0070313,
                30.8015337
              ],
              [
                56.0086979,
                30.7984741
              ],
              [
                56.008978,
                30.7979144
              ],
              [
                56.0095313,
                30.7948638
              ],
              [
                56.0284209,
                30.757643
              ],
              [
                56.028701,
                30.7565328
              ],
              [
                56.0325876,
                30.751253
              ],
              [
                56.0348109,
                30.7470833
              ],
              [
                56.0348109,
                30.7465237
              ],
              [
                56.0350876,
                30.7456934
              ],
              [
                56.0350877,
                30.7454136
              ],
              [
                56.0356443,
                30.7426428
              ],
              [
                56.0528673,
                30.7095835
              ],
              [
                56.053144,
                30.7087442
              ],
              [
                56.0537007,
                30.7081937
              ],
              [
                56.0550907,
                30.7062443
              ],
              [
                56.0684237,
                30.6884739
              ],
              [
                56.0717571,
                30.6820842
              ],
              [
                56.0898134,
                30.6581953
              ],
              [
                56.0900899,
                30.6576358
              ],
              [
                56.09037,
                30.657356
              ],
              [
                56.0906468,
                30.6570852
              ],
              [
                56.0909233,
                30.6568054
              ],
              [
                56.0948133,
                30.6545853
              ],
              [
                56.0950933,
                30.6543055
              ],
              [
                56.0998131,
                30.6543055
              ],
              [
                56.1078698,
                30.6562458
              ],
              [
                56.1195362,
                30.6601356
              ],
              [
                56.1264829,
                30.6634747
              ],
              [
                56.1287028,
                30.6648646
              ],
              [
                56.1664822,
                30.6826347
              ],
              [
                56.1678723,
                30.6829144
              ],
              [
                56.1756523,
                30.6865245
              ],
              [
                56.1762055,
                30.6865244
              ],
              [
                56.1770388,
                30.6873547
              ],
              [
                56.178429,
                30.6879143
              ],
              [
                56.1803721,
                30.6879142
              ],
              [
                56.1812054,
                30.6881941
              ],
              [
                56.1848187,
                30.688194
              ],
              [
                56.188152,
                30.6873547
              ],
              [
                56.1889854,
                30.6873547
              ],
              [
                56.1900953,
                30.687084
              ],
              [
                56.1950952,
                30.6848639
              ],
              [
                56.2334313,
                30.6531954
              ],
              [
                56.2367645,
                30.6498562
              ],
              [
                56.238988,
                30.6479158
              ],
              [
                56.2931571,
                30.5948596
              ],
              [
                56.2956572,
                30.5923599
              ],
              [
                56.297877,
                30.5904106
              ],
              [
                56.3364897,
                30.5637433
              ],
              [
                56.3595496,
                30.5490246
              ],
              [
                56.3603828,
                30.5490246
              ],
              [
                56.3606594,
                30.5487449
              ],
              [
                56.3614927,
                30.5487448
              ],
              [
                56.3620493,
                30.5484651
              ],
              [
                56.3628827,
                30.5484651
              ],
              [
                56.363716,
                30.5481853
              ],
              [
                56.3662161,
                30.5481854
              ],
              [
                56.3670492,
                30.5481854
              ],
              [
                56.3698258,
                30.5481853
              ],
              [
                56.3701026,
                30.5484651
              ],
              [
                56.3789925,
                30.5484651
              ],
              [
                56.3801058,
                30.5487448
              ],
              [
                56.3826058,
                30.5487448
              ],
              [
                56.383439,
                30.5490246
              ],
              [
                56.3873257,
                30.5490246
              ],
              [
                56.3948288,
                30.5495751
              ],
              [
                56.3959388,
                30.5493043
              ],
              [
                56.4223286,
                30.549575
              ],
              [
                56.4237185,
                30.5493043
              ],
              [
                56.4242718,
                30.5490245
              ],
              [
                56.4256618,
                30.5490246
              ],
              [
                56.4270518,
                30.5490245
              ],
              [
                56.4273285,
                30.5487448
              ],
              [
                56.4289951,
                30.5487448
              ],
              [
                56.4298283,
                30.5490245
              ],
              [
                56.4312184,
                30.5490245
              ],
              [
                56.4442749,
                30.5520748
              ],
              [
                56.4451082,
                30.5520748
              ],
              [
                56.4506614,
                30.5545745
              ],
              [
                56.4717745,
                30.5798608
              ],
              [
                56.4737212,
                30.5823515
              ],
              [
                56.4984441,
                30.6167983
              ],
              [
                56.5156674,
                30.6373565
              ],
              [
                56.5167773,
                30.6390262
              ],
              [
                56.5190007,
                30.6412463
              ],
              [
                56.5192771,
                30.6420765
              ],
              [
                56.5201106,
                30.6426361
              ],
              [
                56.5206673,
                30.6434663
              ],
              [
                56.5212206,
                30.6437461
              ],
              [
                56.5215005,
                30.6442967
              ],
              [
                56.5215005,
                30.6451359
              ],
              [
                56.5401101,
                30.6651349
              ],
              [
                56.5403903,
                30.6659743
              ],
              [
                56.5465001,
                30.6723639
              ],
              [
                56.5467805,
                30.6726349
              ],
              [
                56.5470569,
                30.6729144
              ],
              [
                56.5473335,
                30.673474
              ],
              [
                56.5634466,
                30.6904139
              ],
              [
                56.5656701,
                30.6920834
              ],
              [
                56.5673367,
                30.6929138
              ],
              [
                56.5681699,
                30.6934643
              ],
              [
                56.5723367,
                30.6948542
              ],
              [
                56.5740033,
                30.6948542
              ],
              [
                56.587893,
                30.7012529
              ],
              [
                56.5923362,
                30.7015237
              ],
              [
                56.5934462,
                30.7018035
              ],
              [
                56.5967795,
                30.7018034
              ],
              [
                56.5976128,
                30.7015237
              ],
              [
                56.5984461,
                30.7015237
              ],
              [
                56.5990027,
                30.7018034
              ],
              [
                56.6006694,
                30.7018034
              ],
              [
                56.6028928,
                30.7012529
              ],
              [
                56.6037261,
                30.7012529
              ],
              [
                56.6040027,
                30.7009731
              ],
              [
                56.6048361,
                30.7009731
              ],
              [
                56.609836,
                30.6987439
              ],
              [
                56.615116,
                30.6940238
              ],
              [
                56.6167826,
                30.6920835
              ],
              [
                56.6267824,
                30.6851342
              ],
              [
                56.6278924,
                30.6845836
              ],
              [
                56.6417823,
                30.6701347
              ],
              [
                56.6456721,
                30.6609744
              ],
              [
                56.6495621,
                30.6551353
              ],
              [
                56.6503955,
                30.6551353
              ],
              [
                56.650672,
                30.6548556
              ],
              [
                56.651782,
                30.6548555
              ],
              [
                56.6520621,
                30.6551353
              ],
              [
                56.6531721,
                30.6556949
              ],
              [
                56.6812283,
                30.6670842
              ],
              [
                56.7006747,
                30.6745839
              ],
              [
                56.7012314,
                30.674584
              ],
              [
                56.7015079,
                30.6748637
              ],
              [
                56.7034514,
                30.6751344
              ],
              [
                56.7112312,
                30.676804
              ],
              [
                56.7120646,
                30.6769722
              ],
              [
                56.7126177,
                30.6770838
              ],
              [
                56.7134511,
                30.6773636
              ],
              [
                56.7259543,
                30.6670841
              ],
              [
                56.7390108,
                30.6606946
              ],
              [
                56.7409541,
                30.660135
              ],
              [
                56.7584539,
                30.6534656
              ],
              [
                56.7598437,
                30.6534656
              ],
              [
                56.7717869,
                30.6509657
              ],
              [
                56.7729002,
                30.6509657
              ],
              [
                56.7792902,
                30.6490254
              ],
              [
                56.78401,
                30.6490253
              ],
              [
                56.7884567,
                30.6495759
              ],
              [
                56.7892901,
                30.6498557
              ],
              [
                56.7904,
                30.6498557
              ],
              [
                56.7906801,
                30.6501354
              ],
              [
                56.7917901,
                30.6501354
              ],
              [
                56.7923467,
                30.6504151
              ],
              [
                56.7940133,
                30.6504152
              ],
              [
                56.8065132,
                30.6554149
              ],
              [
                56.8073464,
                30.6559745
              ],
              [
                56.8084564,
                30.6568048
              ],
              [
                56.810123,
                30.6590248
              ],
              [
                56.8329028,
                30.6723636
              ],
              [
                56.8406793,
                30.6781938
              ],
              [
                56.8409594,
                30.6790241
              ],
              [
                56.8417928,
                30.6798634
              ],
              [
                56.8420694,
                30.6806936
              ],
              [
                56.8454026,
                30.6840239
              ],
              [
                56.8454026,
                30.6843037
              ],
              [
                56.8459593,
                30.6843037
              ],
              [
                56.8462359,
                30.6845834
              ],
              [
                56.8467927,
                30.6848632
              ],
              [
                56.8476259,
                30.6856935
              ],
              [
                56.8484593,
                30.6859733
              ],
              [
                56.862349,
                30.6931933
              ],
              [
                56.8631825,
                30.693464
              ],
              [
                56.8662389,
                30.6968033
              ],
              [
                56.870959,
                30.7095828
              ],
              [
                56.8704056,
                30.717913
              ],
              [
                56.8701256,
                30.7184726
              ],
              [
                56.8701256,
                30.7190231
              ],
              [
                56.8701256,
                30.7218028
              ],
              [
                56.869849,
                30.7226332
              ],
              [
                56.8698491,
                30.722913
              ],
              [
                56.8695725,
                30.7248624
              ],
              [
                56.8404028,
                30.7562523
              ],
              [
                56.840126,
                30.7565321
              ],
              [
                56.8370696,
                30.7595826
              ],
              [
                56.8281796,
                30.7706929
              ],
              [
                56.8273463,
                30.771803
              ],
              [
                56.8190132,
                30.782083
              ],
              [
                56.8109566,
                30.7920832
              ],
              [
                56.7981802,
                30.8126434
              ],
              [
                56.7967902,
                30.8140243
              ],
              [
                56.7967902,
                30.8148638
              ],
              [
                56.8067899,
                30.8195842
              ],
              [
                56.8076234,
                30.8195842
              ],
              [
                56.8079,
                30.8198639
              ],
              [
                56.8356796,
                30.8251348
              ],
              [
                56.836513,
                30.8254147
              ],
              [
                56.8373463,
                30.8254147
              ],
              [
                56.8376263,
                30.8256945
              ],
              [
                56.8420695,
                30.8256944
              ],
              [
                56.8423461,
                30.8254147
              ],
              [
                56.8454029,
                30.8254147
              ],
              [
                56.8504027,
                30.8231944
              ],
              [
                56.8509594,
                30.8231943
              ],
              [
                56.8512361,
                30.8229145
              ],
              [
                56.8517929,
                30.8229145
              ],
              [
                56.8520694,
                30.8226348
              ],
              [
                56.8551261,
                30.8215246
              ],
              [
                56.856236,
                30.820974
              ],
              [
                56.8570692,
                30.8209741
              ],
              [
                56.8584593,
                30.8204144
              ],
              [
                56.8598494,
                30.8204145
              ],
              [
                56.8690158,
                30.8184739
              ],
              [
                56.8706824,
                30.8179143
              ],
              [
                56.8717924,
                30.8179143
              ],
              [
                56.8729058,
                30.8173638
              ],
              [
                56.8737391,
                30.8173638
              ],
              [
                56.8776257,
                30.8154143
              ],
              [
                56.8806824,
                30.8148636
              ],
              [
                56.881239,
                30.8145838
              ],
              [
                56.8829056,
                30.8145839
              ],
              [
                56.8840156,
                30.814304
              ],
              [
                56.8945721,
                30.8143041
              ],
              [
                56.9004053,
                30.8151344
              ],
              [
                56.9115185,
                30.8204144
              ],
              [
                56.9126285,
                30.8215245
              ],
              [
                56.9134619,
                30.8218044
              ],
              [
                56.9137384,
                30.8223549
              ],
              [
                56.9156852,
                30.8237539
              ],
              [
                56.9492981,
                30.8473651
              ],
              [
                56.9562413,
                30.8556959
              ],
              [
                56.956798,
                30.856806
              ],
              [
                56.9606881,
                30.8634671
              ],
              [
                56.960688,
                30.8648661
              ],
              [
                56.9609646,
                30.8651369
              ],
              [
                56.9425751,
                30.8768113
              ],
              [
                56.9297377,
                30.8998503
              ],
              [
                56.9175052,
                30.9165848
              ],
              [
                56.9076454,
                30.9309725
              ],
              [
                56.9040463,
                30.9367061
              ],
              [
                56.8949317,
                30.9466234
              ],
              [
                56.8844604,
                30.9590631
              ],
              [
                56.8695951,
                30.9717102
              ],
              [
                56.8624877,
                30.9754015
              ],
              [
                56.8577102,
                30.9768795
              ],
              [
                56.8498221,
                30.979874
              ],
              [
                56.8445031,
                30.9805808
              ],
              [
                56.8418883,
                30.9828338
              ],
              [
                56.8195829,
                30.9913184
              ],
              [
                56.8171477,
                30.9927855
              ],
              [
                56.8145942,
                30.9945422
              ],
              [
                56.8109035,
                30.9951584
              ],
              [
                56.8046996,
                30.9979694
              ],
              [
                56.8004228,
                30.9998222
              ],
              [
                56.7962338,
                31.0012502
              ],
              [
                56.7900181,
                31.0036412
              ],
              [
                56.7787032,
                31.0070903
              ],
              [
                56.7659734,
                31.0119357
              ],
              [
                56.761319,
                31.0136619
              ],
              [
                56.7498779,
                31.0178535
              ],
              [
                56.7485951,
                31.0153227
              ],
              [
                56.7457876,
                31.0148853
              ],
              [
                56.7420657,
                31.016522
              ],
              [
                56.7393851,
                31.0170076
              ],
              [
                56.735333,
                31.0180885
              ],
              [
                56.732379,
                31.0187137
              ],
              [
                56.7289934,
                31.0191406
              ],
              [
                56.7257626,
                31.0198578
              ],
              [
                56.721719,
                31.0200774
              ],
              [
                56.7178636,
                31.0206883
              ],
              [
                56.7138129,
                31.0205411
              ],
              [
                56.7091512,
                31.0214578
              ],
              [
                56.7040014,
                31.0220095
              ],
              [
                56.701684,
                31.0225611
              ],
              [
                56.6902902,
                31.0249524
              ],
              [
                56.6754147,
                31.0293143
              ],
              [
                56.6703956,
                31.0312029
              ],
              [
                56.6595387,
                31.0350055
              ],
              [
                56.6491125,
                31.0407273
              ],
              [
                56.6463232,
                31.0432643
              ],
              [
                56.6453062,
                31.0450543
              ],
              [
                56.6398429,
                31.0486692
              ],
              [
                56.6354655,
                31.056537
              ],
              [
                56.632204,
                31.0621249
              ],
              [
                56.6298007,
                31.069477
              ],
              [
                56.6240501,
                31.0816066
              ],
              [
                56.6208971,
                31.0971151
              ],
              [
                56.6193412,
                31.1051183
              ],
              [
                56.6187238,
                31.1120139
              ],
              [
                56.6171657,
                31.1200866
              ],
              [
                56.6161536,
                31.1279055
              ],
              [
                56.6129779,
                31.1343708
              ],
              [
                56.6106264,
                31.1435836
              ],
              [
                56.6100923,
                31.1465305
              ],
              [
                56.6053383,
                31.1573404
              ],
              [
                56.6004266,
                31.1653408
              ],
              [
                56.5972709,
                31.1694817
              ],
              [
                56.594696,
                31.1720521
              ],
              [
                56.5921461,
                31.1777094
              ],
              [
                56.5800189,
                31.1919518
              ],
              [
                56.5708779,
                31.198633
              ],
              [
                56.5686035,
                31.2009823
              ],
              [
                56.5636682,
                31.2026708
              ],
              [
                56.560235,
                31.2063782
              ],
              [
                56.5564584,
                31.2088008
              ],
              [
                56.5469698,
                31.2166923
              ],
              [
                56.5418097,
                31.2152851
              ],
              [
                56.5372858,
                31.2141612
              ],
              [
                56.5269195,
                31.2107143
              ],
              [
                56.5180802,
                31.2056628
              ],
              [
                56.5117096,
                31.2006706
              ],
              [
                56.5073252,
                31.1969499
              ],
              [
                56.5044689,
                31.1949724
              ],
              [
                56.5001286,
                31.1924904
              ],
              [
                56.4988231,
                31.190263
              ],
              [
                56.4959884,
                31.1865578
              ],
              [
                56.4925705,
                31.179488
              ],
              [
                56.4892959,
                31.1749528
              ],
              [
                56.4861582,
                31.1716077
              ],
              [
                56.4861886,
                31.1654174
              ],
              [
                56.4849272,
                31.157241
              ],
              [
                56.4819401,
                31.1364448
              ],
              [
                56.4861887,
                31.1224859
              ],
              [
                56.4872591,
                31.1174249
              ],
              [
                56.488472,
                31.1111353
              ],
              [
                56.4910352,
                31.0878525
              ],
              [
                56.4799855,
                31.0820922
              ],
              [
                56.4566197,
                31.0787931
              ],
              [
                56.4432321,
                31.0779356
              ],
              [
                56.4473406,
                31.0651128
              ],
              [
                56.4539852,
                31.0585067
              ],
              [
                56.4727773,
                31.0498094
              ],
              [
                56.4858765,
                31.0409741
              ],
              [
                56.5016661,
                31.0416571
              ],
              [
                56.5002821,
                31.0319021
              ],
              [
                56.5129851,
                31.0111597
              ],
              [
                56.5270795,
                30.9860865
              ],
              [
                56.5201091,
                30.9786394
              ],
              [
                56.5116977,
                30.9715747
              ],
              [
                56.505432,
                30.9648775
              ],
              [
                56.4945315,
                30.9515553
              ],
              [
                56.486034,
                30.9435318
              ],
              [
                56.4369391,
                30.9871753
              ],
              [
                56.4350508,
                31.010277
              ],
              [
                56.4101599,
                31.0092471
              ],
              [
                56.3897942,
                31.0055331
              ],
              [
                56.3761709,
                31.017633
              ],
              [
                56.3682745,
                31.0279305
              ],
              [
                56.3640176,
                31.0326108
              ],
              [
                56.3362072,
                31.0622243
              ],
              [
                56.3160722,
                31.0877712
              ],
              [
                56.2919536,
                31.1028
              ],
              [
                56.2517164,
                31.1283464
              ],
              [
                56.239044,
                31.1346237
              ],
              [
                56.2237649,
                31.1594933
              ],
              [
                56.2131052,
                31.1703274
              ],
              [
                56.1623499,
                31.2002685
              ],
              [
                56.1302801,
                31.2497695
              ],
              [
                56.1216243,
                31.2690721
              ],
              [
                56.1100938,
                31.2740366
              ],
              [
                56.1076412,
                31.2740365
              ],
              [
                56.1064806,
                31.2740366
              ],
              [
                56.1059272,
                31.2737657
              ],
              [
                56.101204,
                31.2743165
              ],
              [
                56.0967606,
                31.2743164
              ],
              [
                56.095094,
                31.2740366
              ],
              [
                56.0839807,
                31.2734859
              ],
              [
                56.0834241,
                31.2737658
              ],
              [
                56.0509246,
                31.2754269
              ],
              [
                56.0403682,
                31.2754269
              ],
              [
                56.0389781,
                31.275147
              ],
              [
                56.0359248,
                31.2751471
              ],
              [
                56.0350882,
                31.2754269
              ],
              [
                56.0300883,
                31.2754268
              ],
              [
                56.0284215,
                31.275147
              ],
              [
                55.9953654,
                31.2740367
              ],
              [
                55.9931422,
                31.2740367
              ],
              [
                55.9917556,
                31.2737659
              ],
              [
                55.9748089,
                31.2751471
              ],
              [
                55.970919,
                31.2751471
              ],
              [
                55.9703657,
                31.275427
              ],
              [
                55.9678658,
                31.2754269
              ],
              [
                55.9659191,
                31.2757067
              ],
              [
                55.9464761,
                31.2770881
              ],
              [
                55.9459194,
                31.2768171
              ],
              [
                55.9439762,
                31.277088
              ],
              [
                55.9431429,
                31.2768172
              ],
              [
                55.9417529,
                31.277088
              ],
              [
                55.9375862,
                31.277088
              ],
              [
                55.9359195,
                31.2773769
              ],
              [
                55.9159164,
                31.2776476
              ],
              [
                55.9153632,
                31.2779276
              ],
              [
                55.9036967,
                31.2779276
              ],
              [
                55.9020267,
                31.2776478
              ],
              [
                55.8875837,
                31.277088
              ],
              [
                55.8839703,
                31.277088
              ],
              [
                55.8803602,
                31.277088
              ],
              [
                55.8798036,
                31.2773769
              ],
              [
                55.8698038,
                31.2773769
              ],
              [
                55.8684173,
                31.2776477
              ],
              [
                55.8648039,
                31.2776478
              ],
              [
                55.8634138,
                31.2779276
              ],
              [
                55.861194,
                31.2779276
              ],
              [
                55.859804,
                31.2782075
              ],
              [
                55.8581372,
                31.2782074
              ],
              [
                55.8553607,
                31.2787582
              ],
              [
                55.8536942,
                31.2787581
              ],
              [
                55.8375809,
                31.2818185
              ],
              [
                55.8353577,
                31.2818184
              ],
              [
                55.8348043,
                31.2820983
              ],
              [
                55.8303578,
                31.2823691
              ],
              [
                55.8300811,
                31.2820983
              ],
              [
                55.828971,
                31.2823691
              ],
              [
                55.8100814,
                31.2812587
              ],
              [
                55.7945249,
                31.2812588
              ],
              [
                55.7923016,
                31.2812588
              ],
              [
                55.7917449,
                31.2815386
              ],
              [
                55.7864683,
                31.2815386
              ],
              [
                55.785635,
                31.2818185
              ],
              [
                55.7848016,
                31.2815386
              ],
              [
                55.7845216,
                31.2818185
              ],
              [
                55.7806351,
                31.2818185
              ],
              [
                55.7798017,
                31.2820983
              ],
              [
                55.7670218,
                31.2837594
              ],
              [
                55.764522,
                31.2837594
              ],
              [
                55.7642454,
                31.2840392
              ],
              [
                55.7622987,
                31.2840393
              ],
              [
                55.7620219,
                31.2843191
              ],
              [
                55.7609119,
                31.2843191
              ],
              [
                55.7605648,
                31.2844908
              ],
              [
                55.7597987,
                31.2848698
              ],
              [
                55.7595221,
                31.2845989
              ],
              [
                55.7589654,
                31.2840393
              ],
              [
                55.7564654,
                31.2829289
              ],
              [
                55.7556321,
                31.282649
              ],
              [
                55.7550788,
                31.2823692
              ],
              [
                55.7400756,
                31.2745965
              ],
              [
                55.7195192,
                31.2673747
              ],
              [
                55.7181326,
                31.2665441
              ],
              [
                55.6847964,
                31.2559821
              ],
              [
                55.6781298,
                31.2545919
              ],
              [
                55.6711832,
                31.2537614
              ],
              [
                55.6686832,
                31.2537614
              ],
              [
                55.6489601,
                31.2507102
              ],
              [
                55.6364604,
                31.2498707
              ],
              [
                55.6070141,
                31.245709
              ],
              [
                55.6009042,
                31.2437592
              ],
              [
                55.5811812,
                31.2318161
              ],
              [
                55.5811811,
                31.2315362
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555092,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سیرجان",
          "name:en": "Sirjan County",
          "place": "county",
          "population": "324103",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q945465",
          "wikipedia": "en:Sirjan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.9794491,
                29.3968289
              ],
              [
                54.9856486,
                29.3830906
              ],
              [
                54.9879497,
                29.3699764
              ],
              [
                55.0000122,
                29.35422
              ],
              [
                55.0175101,
                29.3079453
              ],
              [
                55.0266016,
                29.2713064
              ],
              [
                55.0296555,
                29.2498797
              ],
              [
                55.0249168,
                29.1888802
              ],
              [
                55.024879,
                29.1300821
              ],
              [
                55.026461,
                29.1047736
              ],
              [
                55.0251775,
                29.0828973
              ],
              [
                55.0246809,
                29.0722247
              ],
              [
                55.031719,
                29.039212
              ],
              [
                55.034294,
                29.0396623
              ],
              [
                55.0353238,
                29.0276178
              ],
              [
                55.0701713,
                29.0104298
              ],
              [
                55.0808569,
                29.0142582
              ],
              [
                55.0847624,
                29.0084408
              ],
              [
                55.0850199,
                29.0025106
              ],
              [
                55.0917148,
                29.0035615
              ],
              [
                55.0942039,
                29.0026607
              ],
              [
                55.0959205,
                28.999733
              ],
              [
                55.1101683,
                29.0058886
              ],
              [
                55.1110267,
                29.0044623
              ],
              [
                55.1035594,
                28.992451
              ],
              [
                55.1056193,
                28.9859193
              ],
              [
                55.1102542,
                28.983742
              ],
              [
                55.119352,
                28.9988324
              ],
              [
                55.1307677,
                28.9892228
              ],
              [
                55.1641558,
                28.9700013
              ],
              [
                55.1649284,
                28.9678987
              ],
              [
                55.1637266,
                28.9626421
              ],
              [
                55.175743,
                28.9594129
              ],
              [
                55.184841,
                28.962567
              ],
              [
                55.1875877,
                28.9609148
              ],
              [
                55.1933383,
                28.9541558
              ],
              [
                55.196514,
                28.954306
              ],
              [
                55.2088737,
                28.9394347
              ],
              [
                55.2134227,
                28.9391343
              ],
              [
                55.2167701,
                28.9438663
              ],
              [
                55.2218341,
                28.9430401
              ],
              [
                55.2258679,
                28.9410123
              ],
              [
                55.2268123,
                28.9371813
              ],
              [
                55.2262114,
                28.9348528
              ],
              [
                55.1668164,
                28.921857
              ],
              [
                55.1758286,
                28.9170488
              ],
              [
                55.1953121,
                28.9117145
              ],
              [
                55.2121421,
                28.9030492
              ],
              [
                55.2006338,
                28.8939814
              ],
              [
                55.2241509,
                28.8470801
              ],
              [
                55.2493759,
                28.8285316
              ],
              [
                55.2576489,
                28.8192325
              ],
              [
                55.263167,
                28.8116059
              ],
              [
                55.2685743,
                28.7992988
              ],
              [
                55.269751,
                28.7762127
              ],
              [
                55.268696,
                28.7510634
              ],
              [
                55.298679,
                28.7494706
              ],
              [
                55.5011195,
                28.7500734
              ],
              [
                55.5173538,
                28.7379407
              ],
              [
                55.529941,
                28.7287216
              ],
              [
                55.5437848,
                28.7200985
              ],
              [
                55.5716628,
                28.7044829
              ],
              [
                55.5960687,
                28.6923716
              ],
              [
                55.6151585,
                28.6860689
              ],
              [
                55.6353645,
                28.6809486
              ],
              [
                55.6553341,
                28.6716112
              ],
              [
                55.6970633,
                28.6630073
              ],
              [
                55.7326123,
                28.6592614
              ],
              [
                55.7477185,
                28.6601652
              ],
              [
                55.802221,
                28.6894585
              ],
              [
                55.8035945,
                28.6957828
              ],
              [
                55.8081435,
                28.7003753
              ],
              [
                55.8159541,
                28.7017305
              ],
              [
                55.8218764,
                28.6996978
              ],
              [
                55.8352658,
                28.7050432
              ],
              [
                55.9165925,
                28.7386404
              ],
              [
                55.919592,
                28.748515
              ],
              [
                55.9394645,
                28.7607371
              ],
              [
                55.9556007,
                28.7699915
              ],
              [
                55.9639476,
                28.7734311
              ],
              [
                56.0022923,
                28.787821
              ],
              [
                56.0202477,
                28.7907338
              ],
              [
                56.0433048,
                28.7889229
              ],
              [
                56.0361096,
                28.837757
              ],
              [
                56.0422894,
                28.9246366
              ],
              [
                56.0440428,
                28.9487098
              ],
              [
                56.0599764,
                28.989974
              ],
              [
                56.0959952,
                29.0695377
              ],
              [
                56.1073116,
                29.0926905
              ],
              [
                56.1266344,
                29.137363
              ],
              [
                56.1366176,
                29.150962
              ],
              [
                56.1512983,
                29.1657465
              ],
              [
                56.1532687,
                29.1681263
              ],
              [
                56.1620235,
                29.1737471
              ],
              [
                56.1676025,
                29.1765949
              ],
              [
                56.1746406,
                29.1818406
              ],
              [
                56.1833953,
                29.1888095
              ],
              [
                56.1969565,
                29.1969767
              ],
              [
                56.2037372,
                29.2019217
              ],
              [
                56.2090121,
                29.2045985
              ],
              [
                56.2244573,
                29.2168916
              ],
              [
                56.2404877,
                29.2328056
              ],
              [
                56.2467356,
                29.2409297
              ],
              [
                56.2499721,
                29.2475462
              ],
              [
                56.2532087,
                29.252005
              ],
              [
                56.2594018,
                29.2615909
              ],
              [
                56.2658976,
                29.2715818
              ],
              [
                56.2707008,
                29.2817988
              ],
              [
                56.2735524,
                29.2908779
              ],
              [
                56.2759665,
                29.2994253
              ],
              [
                56.2794875,
                29.3110729
              ],
              [
                56.2852573,
                29.3282873
              ],
              [
                56.287874,
                29.3392183
              ],
              [
                56.2896265,
                29.342598
              ],
              [
                56.2878408,
                29.3591671
              ],
              [
                56.2847033,
                29.3668943
              ],
              [
                56.2816714,
                29.3711056
              ],
              [
                56.2780061,
                29.3770944
              ],
              [
                56.2739053,
                29.3818352
              ],
              [
                56.2604968,
                29.3968528
              ],
              [
                56.2579822,
                29.4002727
              ],
              [
                56.2567475,
                29.4045581
              ],
              [
                56.2564711,
                29.4096201
              ],
              [
                56.2576285,
                29.4141999
              ],
              [
                56.2623595,
                29.4251703
              ],
              [
                56.2668314,
                29.4331957
              ],
              [
                56.2680244,
                29.4365703
              ],
              [
                56.270213,
                29.4398967
              ],
              [
                56.2705563,
                29.4496508
              ],
              [
                56.2702299,
                29.4613492
              ],
              [
                56.2763499,
                29.4738263
              ],
              [
                56.2861553,
                29.4854795
              ],
              [
                56.2996101,
                29.4946718
              ],
              [
                56.3069057,
                29.4988179
              ],
              [
                56.3076353,
                29.5005361
              ],
              [
                56.3113681,
                29.5036422
              ],
              [
                56.3164427,
                29.5073213
              ],
              [
                56.3190131,
                29.5093346
              ],
              [
                56.321134,
                29.5127514
              ],
              [
                56.3158291,
                29.5185026
              ],
              [
                56.3153941,
                29.5248318
              ],
              [
                56.3176559,
                29.5326734
              ],
              [
                56.322714,
                29.5395244
              ],
              [
                56.3344646,
                29.5401217
              ],
              [
                56.3413275,
                29.5401025
              ],
              [
                56.3440242,
                29.5397291
              ],
              [
                56.3478684,
                29.5408676
              ],
              [
                56.352566,
                29.5419852
              ],
              [
                56.3584851,
                29.5422154
              ],
              [
                56.3648551,
                29.543597
              ],
              [
                56.3757381,
                29.5472672
              ],
              [
                56.379963,
                29.5487688
              ],
              [
                56.3833725,
                29.5499132
              ],
              [
                56.3878153,
                29.5512255
              ],
              [
                56.3926172,
                29.5524593
              ],
              [
                56.3978086,
                29.5543997
              ],
              [
                56.4021861,
                29.5588411
              ],
              [
                56.4108778,
                29.5619336
              ],
              [
                56.4194392,
                29.5676691
              ],
              [
                56.4255383,
                29.5695124
              ],
              [
                56.4317812,
                29.5717701
              ],
              [
                56.4356414,
                29.5731699
              ],
              [
                56.4361564,
                29.5796133
              ],
              [
                56.4351072,
                29.5812253
              ],
              [
                56.4348271,
                29.5814958
              ],
              [
                56.4351072,
                29.5820549
              ],
              [
                56.434827,
                29.5859416
              ],
              [
                56.4351073,
                29.5862212
              ],
              [
                56.4348271,
                29.5873394
              ],
              [
                56.4351072,
                29.58761
              ],
              [
                56.4348271,
                29.5909466
              ],
              [
                56.4351072,
                29.5914967
              ],
              [
                56.4348271,
                29.592615
              ],
              [
                56.4351072,
                29.5928945
              ],
              [
                56.4420505,
                29.616504
              ],
              [
                56.4431605,
                29.6195612
              ],
              [
                56.4542736,
                29.6487266
              ],
              [
                56.4556637,
                29.6520634
              ],
              [
                56.4567737,
                29.6592782
              ],
              [
                56.4570502,
                29.6631652
              ],
              [
                56.4556637,
                29.6762242
              ],
              [
                56.4551071,
                29.6778926
              ],
              [
                56.4523304,
                29.6823388
              ],
              [
                56.4317707,
                29.6926202
              ],
              [
                56.4298273,
                29.6931704
              ],
              [
                56.3848248,
                29.7126151
              ],
              [
                56.3814915,
                29.7156726
              ],
              [
                56.3692683,
                29.7384457
              ],
              [
                56.3626018,
                29.747059
              ],
              [
                56.3612152,
                29.7498369
              ],
              [
                56.3609351,
                29.7509463
              ],
              [
                56.3609351,
                29.7512259
              ],
              [
                56.3606585,
                29.7523352
              ],
              [
                56.3603818,
                29.7526148
              ],
              [
                56.3567684,
                29.7567817
              ],
              [
                56.3562118,
                29.7570613
              ],
              [
                56.3245456,
                29.779285
              ],
              [
                56.322879,
                29.7801149
              ],
              [
                56.3220458,
                29.7809537
              ],
              [
                56.290933,
                29.7970625
              ],
              [
                56.287043,
                29.7984516
              ],
              [
                56.2748198,
                29.8084453
              ],
              [
                56.2745432,
                29.8090045
              ],
              [
                56.2728766,
                29.811503
              ],
              [
                56.1779019,
                29.7774901
              ],
              [
                56.0753694,
                29.8345667
              ],
              [
                56.0745361,
                29.834287
              ],
              [
                56.0714796,
                29.8342871
              ],
              [
                56.0703661,
                29.8340075
              ],
              [
                56.0700896,
                29.834287
              ],
              [
                56.060923,
                29.8342871
              ],
              [
                56.0198103,
                29.8376155
              ],
              [
                56.0178669,
                29.8373449
              ],
              [
                56.0170336,
                29.8373448
              ],
              [
                56.0170337,
                29.8376155
              ],
              [
                56.0173103,
                29.8381747
              ],
              [
                56.0173103,
                29.8392842
              ],
              [
                56.0173103,
                29.8398433
              ],
              [
                56.017587,
                29.840114
              ],
              [
                56.017867,
                29.84512
              ],
              [
                56.0181436,
                29.848728
              ],
              [
                56.0184203,
                29.8503967
              ],
              [
                56.0187003,
                29.8528953
              ],
              [
                56.0189769,
                29.853734
              ],
              [
                56.0192537,
                29.8553937
              ],
              [
                56.0195337,
                29.8579013
              ],
              [
                56.027867,
                29.8928995
              ],
              [
                56.0306436,
                29.9026233
              ],
              [
                56.0307971,
                29.9034842
              ],
              [
                56.0287001,
                29.9040125
              ],
              [
                56.0259202,
                29.9042831
              ],
              [
                56.0256436,
                29.9045627
              ],
              [
                56.0239768,
                29.9045627
              ],
              [
                56.0142538,
                29.907341
              ],
              [
                56.0084206,
                29.9109491
              ],
              [
                55.980148,
                29.9245892
              ],
              [
                55.9444424,
                29.9376806
              ],
              [
                55.8980938,
                29.960289
              ],
              [
                55.8562085,
                29.9626685
              ],
              [
                55.8108899,
                29.969212
              ],
              [
                55.7853155,
                29.9771356
              ],
              [
                55.7559109,
                29.9787303
              ],
              [
                55.6984085,
                29.9579013
              ],
              [
                55.6972951,
                29.9579014
              ],
              [
                55.6970184,
                29.9576217
              ],
              [
                55.6947951,
                29.9570624
              ],
              [
                55.6797954,
                29.952065
              ],
              [
                55.6795187,
                29.9520649
              ],
              [
                55.6792388,
                29.9517853
              ],
              [
                55.6678489,
                29.9462286
              ],
              [
                55.6645157,
                29.9451191
              ],
              [
                55.6639623,
                29.9445688
              ],
              [
                55.6475726,
                29.9387324
              ],
              [
                55.646459,
                29.9387324
              ],
              [
                55.6442394,
                29.9379026
              ],
              [
                55.6431258,
                29.9379026
              ],
              [
                55.6428492,
                29.937623
              ],
              [
                55.6422925,
                29.937623
              ],
              [
                55.6422926,
                29.9373433
              ],
              [
                55.6417392,
                29.9373433
              ],
              [
                55.6378494,
                29.9356745
              ],
              [
                55.6303494,
                29.9331758
              ],
              [
                55.6297928,
                29.9328961
              ],
              [
                55.629516,
                29.9326255
              ],
              [
                55.6289595,
                29.9323459
              ],
              [
                55.6289594,
                29.9320663
              ],
              [
                55.6270161,
                29.9312274
              ],
              [
                55.5895133,
                29.9101195
              ],
              [
                55.5447907,
                29.8737318
              ],
              [
                55.5328441,
                29.8631784
              ],
              [
                55.5300675,
                29.8609504
              ],
              [
                55.5120112,
                29.8442815
              ],
              [
                55.5120112,
                29.8440109
              ],
              [
                55.511731,
                29.8437313
              ],
              [
                55.5113433,
                29.8432271
              ],
              [
                55.5111779,
                29.8428925
              ],
              [
                55.5083978,
                29.8392845
              ],
              [
                55.5028411,
                29.8348376
              ],
              [
                55.5000645,
                29.8337282
              ],
              [
                55.4636751,
                29.8098349
              ],
              [
                55.4283957,
                29.7909479
              ],
              [
                55.4183957,
                29.7870605
              ],
              [
                55.4167291,
                29.7867809
              ],
              [
                55.4161725,
                29.7862307
              ],
              [
                55.3950594,
                29.7778967
              ],
              [
                55.3872829,
                29.7748392
              ],
              [
                55.3861695,
                29.7745595
              ],
              [
                55.3633932,
                29.7656755
              ],
              [
                55.3314471,
                29.7537249
              ],
              [
                55.3297803,
                29.7534543
              ],
              [
                55.2822777,
                29.7345592
              ],
              [
                55.2806111,
                29.7334499
              ],
              [
                55.2794976,
                29.7331703
              ],
              [
                55.2789445,
                29.732611
              ],
              [
                55.2756112,
                29.7312311
              ],
              [
                55.2617213,
                29.7253957
              ],
              [
                55.2611647,
                29.7253958
              ],
              [
                55.2606079,
                29.7248366
              ],
              [
                55.2600547,
                29.7242865
              ],
              [
                55.2597747,
                29.7237273
              ],
              [
                55.2589413,
                29.7228885
              ],
              [
                55.2581081,
                29.722618
              ],
              [
                55.2403317,
                29.7115065
              ],
              [
                55.2392183,
                29.7103972
              ],
              [
                55.238385,
                29.7101176
              ],
              [
                55.2584133,
                29.6724219
              ],
              [
                55.2317892,
                29.654867
              ],
              [
                55.1989551,
                29.6333928
              ],
              [
                55.1864553,
                29.6254203
              ],
              [
                55.1813586,
                29.6220952
              ],
              [
                55.1659622,
                29.5995584
              ],
              [
                55.1594058,
                29.5768641
              ],
              [
                55.1655856,
                29.554391
              ],
              [
                55.1688004,
                29.5252434
              ],
              [
                55.1626585,
                29.5071081
              ],
              [
                55.1458101,
                29.472112
              ],
              [
                55.1276538,
                29.4549178
              ],
              [
                55.0866766,
                29.4280284
              ],
              [
                54.9794491,
                29.3968289
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555105,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شهربابک",
          "name:en": "Shahr-e-Babak County",
          "place": "county",
          "population": "103975",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1287801",
          "wikipedia": "en:Shahr-e Babak County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.3976017,
                30.3429544
              ],
              [
                54.4156262,
                30.3287313
              ],
              [
                54.433479,
                30.3118387
              ],
              [
                54.4530484,
                30.2958324
              ],
              [
                54.4755288,
                30.2829881
              ],
              [
                54.480686,
                30.2787857
              ],
              [
                54.4899557,
                30.2764138
              ],
              [
                54.4987105,
                30.2778963
              ],
              [
                54.5227429,
                30.2679635
              ],
              [
                54.5301245,
                30.2587708
              ],
              [
                54.5284079,
                30.2458701
              ],
              [
                54.5302962,
                30.2377136
              ],
              [
                54.5332989,
                30.2346077
              ],
              [
                54.5332145,
                30.225663
              ],
              [
                54.5315887,
                30.2254789
              ],
              [
                54.5307254,
                30.2216952
              ],
              [
                54.5313262,
                30.2064161
              ],
              [
                54.5314807,
                30.1878518
              ],
              [
                54.5323716,
                30.1641326
              ],
              [
                54.5332108,
                30.1442119
              ],
              [
                54.53326,
                30.1233052
              ],
              [
                54.5341349,
                30.094792
              ],
              [
                54.5346499,
                30.0800877
              ],
              [
                54.5368625,
                30.0729961
              ],
              [
                54.539659,
                30.0623594
              ],
              [
                54.5392073,
                30.0555822
              ],
              [
                54.5421922,
                30.0414166
              ],
              [
                54.5488953,
                30.0142296
              ],
              [
                54.5473784,
                29.9997943
              ],
              [
                54.5519335,
                29.9720507
              ],
              [
                54.5473765,
                29.9431098
              ],
              [
                54.5454883,
                29.9246633
              ],
              [
                54.5422453,
                29.9109498
              ],
              [
                54.5445019,
                29.9087964
              ],
              [
                54.5488793,
                29.8954775
              ],
              [
                54.5541783,
                29.8834471
              ],
              [
                54.5611952,
                29.8656563
              ],
              [
                54.5635985,
                29.8538954
              ],
              [
                54.5672034,
                29.8461532
              ],
              [
                54.5663079,
                29.826573
              ],
              [
                54.5680618,
                29.8245241
              ],
              [
                54.567071,
                29.8189116
              ],
              [
                54.5690822,
                29.8032172
              ],
              [
                54.5738886,
                29.7671174
              ],
              [
                54.5740878,
                29.7617049
              ],
              [
                54.5745778,
                29.7508335
              ],
              [
                54.5751645,
                29.7385077
              ],
              [
                54.577072,
                29.7261426
              ],
              [
                54.5789962,
                29.7153165
              ],
              [
                54.5814411,
                29.7037414
              ],
              [
                54.5856576,
                29.6513378
              ],
              [
                54.5882766,
                29.6134398
              ],
              [
                54.6056053,
                29.6069479
              ],
              [
                54.6339164,
                29.595708
              ],
              [
                54.6681402,
                29.6052527
              ],
              [
                54.7033308,
                29.6127149
              ],
              [
                54.719196,
                29.6125524
              ],
              [
                54.7208626,
                29.6131683
              ],
              [
                54.7350874,
                29.6128698
              ],
              [
                54.7518648,
                29.6092421
              ],
              [
                54.7773172,
                29.6022072
              ],
              [
                54.8046432,
                29.5905904
              ],
              [
                54.8308511,
                29.5704318
              ],
              [
                54.846073,
                29.5540532
              ],
              [
                54.8584626,
                29.5399842
              ],
              [
                54.8713788,
                29.52631
              ],
              [
                54.8854205,
                29.5041587
              ],
              [
                54.9043134,
                29.4788513
              ],
              [
                54.9178065,
                29.4650212
              ],
              [
                54.9290231,
                29.4516123
              ],
              [
                54.9748991,
                29.3963843
              ],
              [
                54.9794491,
                29.3968289
              ],
              [
                55.0866766,
                29.4280284
              ],
              [
                55.1276538,
                29.4549178
              ],
              [
                55.1458101,
                29.472112
              ],
              [
                55.1626585,
                29.5071081
              ],
              [
                55.1688004,
                29.5252434
              ],
              [
                55.1655856,
                29.554391
              ],
              [
                55.1594058,
                29.5768641
              ],
              [
                55.1659622,
                29.5995584
              ],
              [
                55.1813586,
                29.6220952
              ],
              [
                55.1864553,
                29.6254203
              ],
              [
                55.1989551,
                29.6333928
              ],
              [
                55.2317892,
                29.654867
              ],
              [
                55.2584133,
                29.6724219
              ],
              [
                55.238385,
                29.7101176
              ],
              [
                55.2392183,
                29.7103972
              ],
              [
                55.2403317,
                29.7115065
              ],
              [
                55.2581081,
                29.722618
              ],
              [
                55.2589413,
                29.7228885
              ],
              [
                55.2597747,
                29.7237273
              ],
              [
                55.2600547,
                29.7242865
              ],
              [
                55.2606079,
                29.7248366
              ],
              [
                55.2611647,
                29.7253958
              ],
              [
                55.2617213,
                29.7253957
              ],
              [
                55.2756112,
                29.7312311
              ],
              [
                55.2789445,
                29.732611
              ],
              [
                55.2794976,
                29.7331703
              ],
              [
                55.2806111,
                29.7334499
              ],
              [
                55.2822777,
                29.7345592
              ],
              [
                55.3297803,
                29.7534543
              ],
              [
                55.3314471,
                29.7537249
              ],
              [
                55.3633932,
                29.7656755
              ],
              [
                55.3861695,
                29.7745595
              ],
              [
                55.3872829,
                29.7748392
              ],
              [
                55.3950594,
                29.7778967
              ],
              [
                55.4161725,
                29.7862307
              ],
              [
                55.4167291,
                29.7867809
              ],
              [
                55.4183957,
                29.7870605
              ],
              [
                55.4283957,
                29.7909479
              ],
              [
                55.4636751,
                29.8098349
              ],
              [
                55.5000645,
                29.8337282
              ],
              [
                55.5028411,
                29.8348376
              ],
              [
                55.5083978,
                29.8392845
              ],
              [
                55.5111779,
                29.8428925
              ],
              [
                55.5113433,
                29.8432271
              ],
              [
                55.511731,
                29.8437313
              ],
              [
                55.5120112,
                29.8440109
              ],
              [
                55.5120112,
                29.8442815
              ],
              [
                55.5300675,
                29.8609504
              ],
              [
                55.5328441,
                29.8631784
              ],
              [
                55.5447907,
                29.8737318
              ],
              [
                55.5895133,
                29.9101195
              ],
              [
                55.6270161,
                29.9312274
              ],
              [
                55.6289594,
                29.9320663
              ],
              [
                55.6289595,
                29.9323459
              ],
              [
                55.629516,
                29.9326255
              ],
              [
                55.6297928,
                29.9328961
              ],
              [
                55.6303494,
                29.9331758
              ],
              [
                55.6378494,
                29.9356745
              ],
              [
                55.6417392,
                29.9373433
              ],
              [
                55.6422926,
                29.9373433
              ],
              [
                55.6422925,
                29.937623
              ],
              [
                55.6428492,
                29.937623
              ],
              [
                55.6431258,
                29.9379026
              ],
              [
                55.6442394,
                29.9379026
              ],
              [
                55.646459,
                29.9387324
              ],
              [
                55.6475726,
                29.9387324
              ],
              [
                55.6639623,
                29.9445688
              ],
              [
                55.6645157,
                29.9451191
              ],
              [
                55.6678489,
                29.9462286
              ],
              [
                55.6792388,
                29.9517853
              ],
              [
                55.6795187,
                29.9520649
              ],
              [
                55.6797954,
                29.952065
              ],
              [
                55.680072,
                29.9567918
              ],
              [
                55.6786854,
                29.9759519
              ],
              [
                55.6778521,
                29.9798489
              ],
              [
                55.6756288,
                29.9856764
              ],
              [
                55.6747956,
                29.9901237
              ],
              [
                55.6778521,
                29.9990094
              ],
              [
                55.6739621,
                30.0154007
              ],
              [
                55.6734056,
                30.0251255
              ],
              [
                55.6725721,
                30.0337317
              ],
              [
                55.6722956,
                30.0340113
              ],
              [
                55.6725722,
                30.0348412
              ],
              [
                55.6717389,
                30.0437362
              ],
              [
                55.6720154,
                30.0440159
              ],
              [
                55.6722956,
                30.0448459
              ],
              [
                55.6722956,
                30.0453961
              ],
              [
                55.6729377,
                30.0455856
              ],
              [
                55.6729459,
                30.0455899
              ],
              [
                55.6922953,
                30.0534612
              ],
              [
                55.7161849,
                30.060119
              ],
              [
                55.7192415,
                30.0609579
              ],
              [
                55.7295181,
                30.0640072
              ],
              [
                55.7420213,
                30.0670654
              ],
              [
                55.7500744,
                30.070683
              ],
              [
                55.7942436,
                30.0845672
              ],
              [
                55.7950771,
                30.0845671
              ],
              [
                55.7978571,
                30.0856768
              ],
              [
                55.8020238,
                30.0876254
              ],
              [
                55.8095236,
                30.091234
              ],
              [
                55.8195236,
                30.094563
              ],
              [
                55.8314701,
                30.102899
              ],
              [
                55.8331367,
                30.1087361
              ],
              [
                55.8328565,
                30.1140138
              ],
              [
                55.8323033,
                30.1154032
              ],
              [
                55.8247999,
                30.1226205
              ],
              [
                55.8225801,
                30.124849
              ],
              [
                55.8025771,
                30.1448505
              ],
              [
                55.8009102,
                30.1459602
              ],
              [
                55.7781342,
                30.1729
              ],
              [
                55.7756342,
                30.1770682
              ],
              [
                55.7753541,
                30.1773479
              ],
              [
                55.7750774,
                30.1779074
              ],
              [
                55.7747946,
                30.178187
              ],
              [
                55.7745208,
                30.1784577
              ],
              [
                55.7628543,
                30.189573
              ],
              [
                55.7611878,
                30.1912331
              ],
              [
                55.7572978,
                30.1951307
              ],
              [
                55.7181317,
                30.245133
              ],
              [
                55.7178516,
                30.2454038
              ],
              [
                55.7170185,
                30.2462428
              ],
              [
                55.7167417,
                30.2470729
              ],
              [
                55.7160469,
                30.2477677
              ],
              [
                55.702852,
                30.2645768
              ],
              [
                55.6986854,
                30.2717949
              ],
              [
                55.6967422,
                30.274574
              ],
              [
                55.6836857,
                30.2965175
              ],
              [
                55.6675725,
                30.3215202
              ],
              [
                55.6670158,
                30.3226299
              ],
              [
                55.6667392,
                30.3229097
              ],
              [
                55.6647959,
                30.3229097
              ],
              [
                55.664516,
                30.32263
              ],
              [
                55.6631292,
                30.32263
              ],
              [
                55.6595158,
                30.32263
              ],
              [
                55.6589628,
                30.3223502
              ],
              [
                55.657016,
                30.3223502
              ],
              [
                55.6564593,
                30.3220705
              ],
              [
                55.6553494,
                30.3220705
              ],
              [
                55.6536827,
                30.3215202
              ],
              [
                55.6525728,
                30.3215201
              ],
              [
                55.6245165,
                30.3134626
              ],
              [
                55.6236832,
                30.3134626
              ],
              [
                55.6231265,
                30.3131829
              ],
              [
                55.6211832,
                30.3131829
              ],
              [
                55.61007,
                30.311243
              ],
              [
                55.6097933,
                30.3109633
              ],
              [
                55.6086799,
                30.3109632
              ],
              [
                55.6067368,
                30.3104038
              ],
              [
                55.6036801,
                30.3095737
              ],
              [
                55.6028467,
                30.3095737
              ],
              [
                55.60257,
                30.309294
              ],
              [
                55.6014602,
                30.309294
              ],
              [
                55.5984035,
                30.3084639
              ],
              [
                55.5970135,
                30.3084639
              ],
              [
                55.5517342,
                30.2984665
              ],
              [
                55.5500676,
                30.2979071
              ],
              [
                55.5489576,
                30.2979071
              ],
              [
                55.5486774,
                30.2976274
              ],
              [
                55.5475675,
                30.2976274
              ],
              [
                55.5467342,
                30.2973566
              ],
              [
                55.5464576,
                30.297077
              ],
              [
                55.544791,
                30.297077
              ],
              [
                55.5425676,
                30.2965176
              ],
              [
                55.5411776,
                30.2965176
              ],
              [
                55.5400677,
                30.2962379
              ],
              [
                55.5386776,
                30.2962379
              ],
              [
                55.5000649,
                30.294298
              ],
              [
                55.4917317,
                30.297077
              ],
              [
                55.4442291,
                30.3151319
              ],
              [
                55.4383958,
                30.3165215
              ],
              [
                55.4186727,
                30.3187412
              ],
              [
                55.4145062,
                30.3187411
              ],
              [
                55.4131162,
                30.3190209
              ],
              [
                55.4100595,
                30.3190208
              ],
              [
                55.4072829,
                30.3192916
              ],
              [
                55.4003396,
                30.3206811
              ],
              [
                55.3961731,
                30.3218
              ],
              [
                55.3956165,
                30.3220707
              ],
              [
                55.3953398,
                30.3223504
              ],
              [
                55.3900598,
                30.3223504
              ],
              [
                55.3889499,
                30.3223503
              ],
              [
                55.3831167,
                30.3223504
              ],
              [
                55.3558936,
                30.3190209
              ],
              [
                55.3536704,
                30.3190209
              ],
              [
                55.352557,
                30.3187411
              ],
              [
                55.3503371,
                30.3187412
              ],
              [
                55.3483905,
                30.3184615
              ],
              [
                55.3453372,
                30.3184615
              ],
              [
                55.3431138,
                30.3181818
              ],
              [
                55.3306141,
                30.3181818
              ],
              [
                55.3278341,
                30.3187412
              ],
              [
                55.3267242,
                30.3187412
              ],
              [
                55.3239475,
                30.3195714
              ],
              [
                55.3147776,
                30.3248498
              ],
              [
                55.3139443,
                30.3254092
              ],
              [
                55.3142243,
                30.32568
              ],
              [
                55.3206142,
                30.3329074
              ],
              [
                55.3645037,
                30.3851249
              ],
              [
                55.3692269,
                30.3904036
              ],
              [
                55.4645089,
                30.4915234
              ],
              [
                55.4656188,
                30.4931928
              ],
              [
                55.4839519,
                30.5112409
              ],
              [
                55.4914552,
                30.5187399
              ],
              [
                55.4928419,
                30.5204094
              ],
              [
                55.4932035,
                30.5211315
              ],
              [
                55.4936751,
                30.5226294
              ],
              [
                55.4933985,
                30.5237484
              ],
              [
                55.4883987,
                30.5281882
              ],
              [
                55.4786754,
                30.5320777
              ],
              [
                55.477842,
                30.5320776
              ],
              [
                55.4767321,
                30.5326372
              ],
              [
                55.4689522,
                30.5337381
              ],
              [
                55.4681188,
                30.5340179
              ],
              [
                55.4656189,
                30.5340178
              ],
              [
                55.4647856,
                30.5342977
              ],
              [
                55.4561758,
                30.5342977
              ],
              [
                55.4511759,
                30.5348571
              ],
              [
                55.4489525,
                30.5348571
              ],
              [
                55.4389527,
                30.5365266
              ],
              [
                55.4372861,
                30.5365266
              ],
              [
                55.4325627,
                30.5373568
              ],
              [
                55.4289494,
                30.5376276
              ],
              [
                55.4272827,
                30.5381871
              ],
              [
                55.4260341,
                30.5383274
              ],
              [
                55.4247828,
                30.5387466
              ],
              [
                55.4239495,
                30.5387466
              ],
              [
                55.4236728,
                30.5390264
              ],
              [
                55.4217296,
                30.5392971
              ],
              [
                55.3870034,
                30.5487455
              ],
              [
                55.3856167,
                30.549305
              ],
              [
                55.3831169,
                30.5495758
              ],
              [
                55.3817269,
                30.5501353
              ],
              [
                55.3778368,
                30.5506857
              ],
              [
                55.3172777,
                30.5679133
              ],
              [
                55.3161678,
                30.5679133
              ],
              [
                55.3156111,
                30.568193
              ],
              [
                55.3139445,
                30.568193
              ],
              [
                55.3133911,
                30.5684728
              ],
              [
                55.3131111,
                30.5687435
              ],
              [
                55.3128344,
                30.5687435
              ],
              [
                55.3106111,
                30.5698535
              ],
              [
                55.2792217,
                30.5968007
              ],
              [
                55.2753316,
                30.6018003
              ],
              [
                55.2728316,
                30.6054101
              ],
              [
                55.2692217,
                30.6120793
              ],
              [
                55.2642219,
                30.6345869
              ],
              [
                55.2628319,
                30.6512466
              ],
              [
                55.2631119,
                30.6523567
              ],
              [
                55.2667218,
                30.6623653
              ],
              [
                55.2671714,
                30.6641641
              ],
              [
                55.2694985,
                30.6734749
              ],
              [
                55.2747785,
                30.6962451
              ],
              [
                55.2750551,
                30.6984742
              ],
              [
                55.2747785,
                30.6993044
              ],
              [
                55.2744983,
                30.6995842
              ],
              [
                55.2142194,
                30.7287535
              ],
              [
                55.2042195,
                30.731804
              ],
              [
                55.2036628,
                30.731804
              ],
              [
                55.2028295,
                30.7320838
              ],
              [
                55.2025528,
                30.7323546
              ],
              [
                55.1769966,
                30.7434737
              ],
              [
                55.1697733,
                30.7479142
              ],
              [
                55.142827,
                30.7668042
              ],
              [
                55.1225472,
                30.7848641
              ],
              [
                55.1128274,
                30.7934744
              ],
              [
                55.1114375,
                30.7951351
              ],
              [
                55.1042142,
                30.8009747
              ],
              [
                55.1017142,
                30.8034747
              ],
              [
                55.0708781,
                30.8273655
              ],
              [
                55.0150422,
                30.8590279
              ],
              [
                55.0094889,
                30.8631978
              ],
              [
                55.0072656,
                30.8651383
              ],
              [
                55.0008758,
                30.8706983
              ],
              [
                54.9928192,
                30.8779189
              ],
              [
                54.9917092,
                30.8784785
              ],
              [
                54.9780961,
                30.8957
              ],
              [
                54.9569864,
                30.9337539
              ],
              [
                54.9553199,
                30.9376442
              ],
              [
                54.9478199,
                30.9601465
              ],
              [
                54.9455966,
                30.965147
              ],
              [
                54.9444866,
                30.9701386
              ],
              [
                54.9436533,
                30.9837502
              ],
              [
                54.9458733,
                30.9923614
              ],
              [
                54.9469865,
                30.9945909
              ],
              [
                54.9497632,
                31.0000518
              ],
              [
                54.9489298,
                31.016814
              ],
              [
                54.9480966,
                31.025705
              ],
              [
                54.9486532,
                31.0270951
              ],
              [
                54.9482612,
                31.0284619
              ],
              [
                54.9480966,
                31.0290358
              ],
              [
                54.9475399,
                31.028756
              ],
              [
                54.9464299,
                31.0281963
              ],
              [
                54.9433733,
                31.0276458
              ],
              [
                54.9397634,
                31.0276457
              ],
              [
                54.93865,
                31.027366
              ],
              [
                54.9350401,
                31.0270952
              ],
              [
                54.9271744,
                31.0270951
              ],
              [
                54.9267069,
                31.0270951
              ],
              [
                54.9263823,
                31.0272006
              ],
              [
                54.9258736,
                31.0273659
              ],
              [
                54.9247636,
                31.0273659
              ],
              [
                54.9153171,
                31.0284762
              ],
              [
                54.8865356,
                31.0333187
              ],
              [
                54.8855942,
                31.0334769
              ],
              [
                54.8379752,
                31.0426171
              ],
              [
                54.8378149,
                31.0426479
              ],
              [
                54.8055886,
                31.0479285
              ],
              [
                54.7939631,
                31.0495452
              ],
              [
                54.7936455,
                31.0495894
              ],
              [
                54.7844789,
                31.0512593
              ],
              [
                54.7191134,
                31.0655382
              ],
              [
                54.7183632,
                31.0657019
              ],
              [
                54.7163531,
                31.065702
              ],
              [
                54.7158632,
                31.065702
              ],
              [
                54.7155171,
                31.0658182
              ],
              [
                54.7150299,
                31.0659818
              ],
              [
                54.7116966,
                31.0659818
              ],
              [
                54.7111399,
                31.0657019
              ],
              [
                54.70892,
                31.0657019
              ],
              [
                54.6969735,
                31.0623712
              ],
              [
                54.6894736,
                31.0595909
              ],
              [
                54.684197,
                31.057921
              ],
              [
                54.6819737,
                31.0570905
              ],
              [
                54.6803071,
                31.0568107
              ],
              [
                54.6683606,
                31.0532001
              ],
              [
                54.6664173,
                31.0529203
              ],
              [
                54.655304,
                31.0504199
              ],
              [
                54.6539175,
                31.0504199
              ],
              [
                54.6530841,
                31.05014
              ],
              [
                54.6450276,
                31.0490298
              ],
              [
                54.6430842,
                31.0484791
              ],
              [
                54.6414176,
                31.0484792
              ],
              [
                54.6405842,
                31.0481993
              ],
              [
                54.6128047,
                31.0429187
              ],
              [
                54.5805784,
                31.0312565
              ],
              [
                54.5772452,
                31.0301462
              ],
              [
                54.5577978,
                31.0245661
              ],
              [
                54.5388087,
                31.0206682
              ],
              [
                54.5337229,
                31.019933
              ],
              [
                54.5267527,
                31.0183671
              ],
              [
                54.5268631,
                31.014286
              ],
              [
                54.5274639,
                31.0101665
              ],
              [
                54.5274639,
                31.0079228
              ],
              [
                54.5270813,
                31.0049979
              ],
              [
                54.5266284,
                31.0003865
              ],
              [
                54.5272733,
                30.9954896
              ],
              [
                54.5270384,
                30.9888376
              ],
              [
                54.5278908,
                30.9760685
              ],
              [
                54.5277,
                30.9598502
              ],
              [
                54.5286324,
                30.9415345
              ],
              [
                54.5306041,
                30.9325736
              ],
              [
                54.535319,
                30.9186348
              ],
              [
                54.5406921,
                30.8965921
              ],
              [
                54.5407257,
                30.8837669
              ],
              [
                54.5366477,
                30.8694464
              ],
              [
                54.539051,
                30.8518373
              ],
              [
                54.5439122,
                30.8312557
              ],
              [
                54.5439122,
                30.8290264
              ],
              [
                54.5445441,
                30.8046671
              ],
              [
                54.5468356,
                30.7964279
              ],
              [
                54.5478915,
                30.7852763
              ],
              [
                54.5507239,
                30.768463
              ],
              [
                54.5526413,
                30.7308434
              ],
              [
                54.5534705,
                30.7129137
              ],
              [
                54.5529555,
                30.7027299
              ],
              [
                54.5546722,
                30.6915117
              ],
              [
                54.5573329,
                30.6828757
              ],
              [
                54.5581107,
                30.6818697
              ],
              [
                54.557805,
                30.680772
              ],
              [
                54.5592212,
                30.6736115
              ],
              [
                54.5610666,
                30.6682962
              ],
              [
                54.5645818,
                30.6536253
              ],
              [
                54.5655785,
                30.6198588
              ],
              [
                54.5653019,
                30.6098594
              ],
              [
                54.5630785,
                30.5968009
              ],
              [
                54.5594686,
                30.5826324
              ],
              [
                54.5504621,
                30.5652224
              ],
              [
                54.5285794,
                30.5318068
              ],
              [
                54.4767376,
                30.482409
              ],
              [
                54.4463903,
                30.4554263
              ],
              [
                54.3703076,
                30.3933113
              ],
              [
                54.3778607,
                30.3799841
              ],
              [
                54.3806073,
                30.3687286
              ],
              [
                54.3976017,
                30.3429544
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555125,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان عنبرآباد",
          "name:en": "Anbarabad County",
          "place": "county",
          "population": "82438",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1286502",
          "wikipedia": "en:Anbarabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.7703194,
                28.3625763
              ],
              [
                57.7689456,
                28.358852
              ],
              [
                57.7691173,
                28.3546977
              ],
              [
                57.7676581,
                28.3416297
              ],
              [
                57.7680015,
                28.3268979
              ],
              [
                57.7677437,
                28.3203249
              ],
              [
                57.7689886,
                28.3152999
              ],
              [
                57.7714347,
                28.3139775
              ],
              [
                57.7742672,
                28.3108794
              ],
              [
                57.7766704,
                28.3015091
              ],
              [
                57.7988147,
                28.2935739
              ],
              [
                57.8014754,
                28.2908531
              ],
              [
                57.7923774,
                28.2836729
              ],
              [
                57.782421,
                28.2772481
              ],
              [
                57.7813052,
                28.2735442
              ],
              [
                57.7907466,
                28.2634146
              ],
              [
                57.7993297,
                28.2557033
              ],
              [
                57.8032779,
                28.2493524
              ],
              [
                57.81435,
                28.2371788
              ],
              [
                57.8214311,
                28.2248664
              ],
              [
                57.8240569,
                28.2270426
              ],
              [
                57.8336889,
                28.2377617
              ],
              [
                57.838198,
                28.2417773
              ],
              [
                57.8437471,
                28.2453829
              ],
              [
                57.8458499,
                28.246139
              ],
              [
                57.8605774,
                28.2476491
              ],
              [
                57.8929642,
                28.2477803
              ],
              [
                57.9112189,
                28.2474834
              ],
              [
                57.9208958,
                28.2476635
              ],
              [
                57.9307996,
                28.2474922
              ],
              [
                57.9407086,
                28.2476145
              ],
              [
                57.9586292,
                28.2483274
              ],
              [
                57.9641337,
                28.2489751
              ],
              [
                57.9676909,
                28.2496412
              ],
              [
                57.9786728,
                28.2486673
              ],
              [
                57.9842113,
                28.2470362
              ],
              [
                57.986625,
                28.2455186
              ],
              [
                57.9905751,
                28.243929
              ],
              [
                57.995041,
                28.2409243
              ],
              [
                57.9974325,
                28.2381537
              ],
              [
                57.998896,
                28.2335828
              ],
              [
                57.9989545,
                28.2250556
              ],
              [
                58.0008618,
                28.2175706
              ],
              [
                58.0071529,
                28.2042682
              ],
              [
                58.0113911,
                28.1977799
              ],
              [
                58.0272033,
                28.1846666
              ],
              [
                58.0550234,
                28.1735398
              ],
              [
                58.0703673,
                28.1686651
              ],
              [
                58.086406,
                28.1644316
              ],
              [
                58.1233225,
                28.1574091
              ],
              [
                58.146075,
                28.1527729
              ],
              [
                58.165329,
                28.1485531
              ],
              [
                58.1850584,
                28.1443102
              ],
              [
                58.2050292,
                28.1418575
              ],
              [
                58.2147852,
                28.1405331
              ],
              [
                58.2182737,
                28.1395728
              ],
              [
                58.2319623,
                28.1388348
              ],
              [
                58.2373819,
                28.1383097
              ],
              [
                58.2449301,
                28.1382289
              ],
              [
                58.250295,
                28.1367203
              ],
              [
                58.2546724,
                28.1366967
              ],
              [
                58.2650081,
                28.13734
              ],
              [
                58.2718472,
                28.1395869
              ],
              [
                58.2809631,
                28.1432198
              ],
              [
                58.2866305,
                28.1454386
              ],
              [
                58.2955099,
                28.1478777
              ],
              [
                58.3026447,
                28.1499263
              ],
              [
                58.3151348,
                28.1524994
              ],
              [
                58.3261021,
                28.1548685
              ],
              [
                58.3414507,
                28.1611451
              ],
              [
                58.3565287,
                28.164555
              ],
              [
                58.36539,
                28.1657427
              ],
              [
                58.3769271,
                28.1685766
              ],
              [
                58.3921676,
                28.1726633
              ],
              [
                58.3997627,
                28.1751612
              ],
              [
                58.413278,
                28.1800574
              ],
              [
                58.4470127,
                28.1874042
              ],
              [
                58.4644853,
                28.1907092
              ],
              [
                58.4815338,
                28.1946936
              ],
              [
                58.4894006,
                28.1968312
              ],
              [
                58.5000652,
                28.2181377
              ],
              [
                58.5097228,
                28.2276197
              ],
              [
                58.5136433,
                28.230569
              ],
              [
                58.5179618,
                28.2334859
              ],
              [
                58.5146158,
                28.2390456
              ],
              [
                58.5113934,
                28.2455735
              ],
              [
                58.5079136,
                28.2512785
              ],
              [
                58.4935845,
                28.2578759
              ],
              [
                58.5127282,
                28.2973906
              ],
              [
                58.536545,
                28.3159801
              ],
              [
                58.5467395,
                28.3329567
              ],
              [
                58.544262,
                28.3609814
              ],
              [
                58.5036009,
                28.386054
              ],
              [
                58.4962632,
                28.4239537
              ],
              [
                58.4954085,
                28.4556778
              ],
              [
                58.4960173,
                28.476689
              ],
              [
                58.4955023,
                28.4806122
              ],
              [
                58.4979056,
                28.4899667
              ],
              [
                58.496725,
                28.4973847
              ],
              [
                58.4883791,
                28.496545
              ],
              [
                58.486362,
                28.4959745
              ],
              [
                58.4679332,
                28.4973758
              ],
              [
                58.4610016,
                28.4987975
              ],
              [
                58.4600785,
                28.4999246
              ],
              [
                58.4612537,
                28.5086798
              ],
              [
                58.4610407,
                28.5131709
              ],
              [
                58.457572,
                28.5253578
              ],
              [
                58.4523561,
                28.5325207
              ],
              [
                58.4297131,
                28.5548223
              ],
              [
                58.3941364,
                28.5636425
              ],
              [
                58.3911665,
                28.5634722
              ],
              [
                58.3806181,
                28.5632279
              ],
              [
                58.3765411,
                28.5636425
              ],
              [
                58.3723353,
                28.5646979
              ],
              [
                58.366413,
                28.5648487
              ],
              [
                58.352251,
                28.5674116
              ],
              [
                58.3484743,
                28.5703516
              ],
              [
                58.3469747,
                28.5772742
              ],
              [
                58.3465861,
                28.5804518
              ],
              [
                58.3329391,
                28.5883655
              ],
              [
                58.3238409,
                28.5965802
              ],
              [
                58.3030699,
                28.6161721
              ],
              [
                58.2925986,
                28.6285281
              ],
              [
                58.2932852,
                28.6404308
              ],
              [
                58.3078764,
                28.6676963
              ],
              [
                58.3118244,
                28.6848655
              ],
              [
                58.2943152,
                28.7063981
              ],
              [
                58.2706259,
                28.7225071
              ],
              [
                58.2598969,
                28.7261954
              ],
              [
                58.2562923,
                28.7291306
              ],
              [
                58.2315425,
                28.7481822
              ],
              [
                58.2271314,
                28.7524913
              ],
              [
                58.2201147,
                28.7485283
              ],
              [
                58.2184839,
                28.7478134
              ],
              [
                58.2116603,
                28.7472302
              ],
              [
                58.2023048,
                28.7479451
              ],
              [
                58.1847953,
                28.7460638
              ],
              [
                58.1756972,
                28.7433547
              ],
              [
                58.1556987,
                28.7391403
              ],
              [
                58.1477164,
                28.7354526
              ],
              [
                58.1406344,
                28.7316256
              ],
              [
                58.1354321,
                28.7270198
              ],
              [
                58.1332968,
                28.7188941
              ],
              [
                58.1303786,
                28.7101621
              ],
              [
                58.1282758,
                28.7074143
              ],
              [
                58.1238399,
                28.7049072
              ],
              [
                58.1025694,
                28.6942018
              ],
              [
                58.0835149,
                28.682456
              ],
              [
                58.0599974,
                28.665437
              ],
              [
                58.0465815,
                28.6539104
              ],
              [
                58.0376635,
                28.6489887
              ],
              [
                58.0000315,
                28.6221565
              ],
              [
                57.9959922,
                28.6109603
              ],
              [
                57.9914255,
                28.606785
              ],
              [
                57.9796219,
                28.5984234
              ],
              [
                57.9748725,
                28.5915655
              ],
              [
                57.9720781,
                28.5863871
              ],
              [
                57.9700695,
                28.5851594
              ],
              [
                57.9580587,
                28.5866979
              ],
              [
                57.9513621,
                28.5874581
              ],
              [
                57.9484336,
                28.5882648
              ],
              [
                57.9406172,
                28.5892974
              ],
              [
                57.9183768,
                28.5760802
              ],
              [
                57.9026008,
                28.5639743
              ],
              [
                57.900524,
                28.5420052
              ],
              [
                57.8953741,
                28.5364255
              ],
              [
                57.8850744,
                28.5332585
              ],
              [
                57.8644751,
                28.5329569
              ],
              [
                57.8580639,
                28.5308893
              ],
              [
                57.8497981,
                28.5361992
              ],
              [
                57.8416442,
                28.5378581
              ],
              [
                57.8416442,
                28.5482631
              ],
              [
                57.8369235,
                28.5510526
              ],
              [
                57.8334288,
                28.5503391
              ],
              [
                57.8255832,
                28.5464554
              ],
              [
                57.8213882,
                28.5432491
              ],
              [
                57.8195858,
                28.5423821
              ],
              [
                57.8182424,
                28.5412221
              ],
              [
                57.8158288,
                28.5397735
              ],
              [
                57.810893,
                28.5257919
              ],
              [
                57.8079128,
                28.5211174
              ],
              [
                57.8061747,
                28.5154234
              ],
              [
                57.7951669,
                28.5111811
              ],
              [
                57.7906608,
                28.4987924
              ],
              [
                57.7916049,
                28.4920034
              ],
              [
                57.7911758,
                28.481442
              ],
              [
                57.7835184,
                28.4684432
              ],
              [
                57.7892259,
                28.4564813
              ],
              [
                57.7918817,
                28.4521888
              ],
              [
                57.7936435,
                28.4492135
              ],
              [
                57.7935696,
                28.4426623
              ],
              [
                57.7919019,
                28.4337994
              ],
              [
                57.7904845,
                28.4287005
              ],
              [
                57.789271,
                28.4245244
              ],
              [
                57.7898883,
                28.4120496
              ],
              [
                57.7909566,
                28.3993612
              ],
              [
                57.7894163,
                28.3928728
              ],
              [
                57.7870879,
                28.3862954
              ],
              [
                57.785232,
                28.3844346
              ],
              [
                57.779958,
                28.3807111
              ],
              [
                57.778385,
                28.3780456
              ],
              [
                57.7754392,
                28.3723546
              ],
              [
                57.7729483,
                28.3681811
              ],
              [
                57.771295,
                28.3651854
              ],
              [
                57.7703194,
                28.3625763
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555128,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فاریاب",
          "name:en": "Faryab County",
          "place": "county",
          "population": "34000",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q5246694",
          "wikipedia": "en:Faryab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.9165727,
                28.2651846
              ],
              [
                56.9609211,
                28.2781486
              ],
              [
                56.9692542,
                28.2781486
              ],
              [
                56.9698153,
                28.2779674
              ],
              [
                56.9778641,
                28.2753669
              ],
              [
                56.9851683,
                28.2696097
              ],
              [
                56.9884205,
                28.2548154
              ],
              [
                56.989254,
                28.2520427
              ],
              [
                56.9903672,
                28.2450933
              ],
              [
                56.9906437,
                28.2412046
              ],
              [
                57.0112432,
                28.19061
              ],
              [
                57.015493,
                28.1804887
              ],
              [
                57.0152165,
                28.1796602
              ],
              [
                57.0118798,
                28.1547005
              ],
              [
                57.0124366,
                28.148587
              ],
              [
                57.0124365,
                28.1483168
              ],
              [
                57.0127131,
                28.1474795
              ],
              [
                57.0127131,
                28.1408168
              ],
              [
                57.0159996,
                28.1286355
              ],
              [
                57.0165564,
                28.1055804
              ],
              [
                57.0276058,
                28.0464075
              ],
              [
                57.0273291,
                28.043075
              ],
              [
                57.0270526,
                28.0405711
              ],
              [
                57.0264959,
                28.0350142
              ],
              [
                57.0262191,
                28.0325103
              ],
              [
                57.0259393,
                28.0300154
              ],
              [
                57.0256625,
                28.0291779
              ],
              [
                57.0256625,
                28.0269533
              ],
              [
                57.0256624,
                28.0202886
              ],
              [
                57.0253859,
                28.0197302
              ],
              [
                57.0222111,
                27.9250553
              ],
              [
                57.1442107,
                27.9390861
              ],
              [
                57.1742245,
                27.9040247
              ],
              [
                57.1862099,
                27.8947272
              ],
              [
                57.2216031,
                27.8882464
              ],
              [
                57.2329327,
                27.9122163
              ],
              [
                57.2446057,
                27.9395173
              ],
              [
                57.271111,
                27.9814862
              ],
              [
                57.2722209,
                27.9806587
              ],
              [
                57.2738875,
                27.9801011
              ],
              [
                57.2738516,
                27.9802447
              ],
              [
                57.2730541,
                27.9834289
              ],
              [
                57.3593075,
                27.9861874
              ],
              [
                57.3759806,
                27.9997986
              ],
              [
                57.3818138,
                28.0025803
              ],
              [
                57.4015338,
                28.0070184
              ],
              [
                57.4023669,
                28.0073065
              ],
              [
                57.4029201,
                28.0073064
              ],
              [
                57.4043135,
                28.0078555
              ],
              [
                57.404867,
                28.0078555
              ],
              [
                57.4054267,
                28.0081346
              ],
              [
                57.4068135,
                28.0081346
              ],
              [
                57.4079268,
                28.0086927
              ],
              [
                57.4082003,
                28.0084137
              ],
              [
                57.4090335,
                28.0084137
              ],
              [
                57.4095936,
                28.0086928
              ],
              [
                57.4229267,
                28.0073064
              ],
              [
                57.4423731,
                28.0056319
              ],
              [
                57.4454263,
                28.005632
              ],
              [
                57.4501463,
                28.0050827
              ],
              [
                57.4662591,
                28.0050828
              ],
              [
                57.4701458,
                28.0053529
              ],
              [
                57.4732057,
                28.005911
              ],
              [
                57.4757057,
                28.005911
              ],
              [
                57.4795925,
                28.0064691
              ],
              [
                57.4907056,
                28.0081345
              ],
              [
                57.5095918,
                28.0117444
              ],
              [
                57.5248718,
                28.0159125
              ],
              [
                57.6193606,
                28.0668481
              ],
              [
                57.6391617,
                28.0760392
              ],
              [
                57.6666183,
                28.0901039
              ],
              [
                57.6914728,
                28.1017698
              ],
              [
                57.7079106,
                28.1098987
              ],
              [
                57.6790994,
                28.1354144
              ],
              [
                57.6611324,
                28.1536194
              ],
              [
                57.6529883,
                28.1593411
              ],
              [
                57.6440617,
                28.1631248
              ],
              [
                57.5723889,
                28.1705401
              ],
              [
                57.5618131,
                28.170973
              ],
              [
                57.5499985,
                28.1709456
              ],
              [
                57.5409743,
                28.1724446
              ],
              [
                57.533347,
                28.1719671
              ],
              [
                57.5194696,
                28.1698485
              ],
              [
                57.5007455,
                28.1659662
              ],
              [
                57.4940229,
                28.1683117
              ],
              [
                57.4751679,
                28.1659675
              ],
              [
                57.4694042,
                28.1667244
              ],
              [
                57.4595565,
                28.1684458
              ],
              [
                57.4563526,
                28.1697681
              ],
              [
                57.4535417,
                28.1714941
              ],
              [
                57.4486267,
                28.1749556
              ],
              [
                57.4460285,
                28.1769652
              ],
              [
                57.4438209,
                28.1787953
              ],
              [
                57.4416034,
                28.180309
              ],
              [
                57.4374809,
                28.1835555
              ],
              [
                57.4340262,
                28.1880033
              ],
              [
                57.4291521,
                28.1943225
              ],
              [
                57.4243296,
                28.2005148
              ],
              [
                57.4192932,
                28.2077729
              ],
              [
                57.4148914,
                28.214976
              ],
              [
                57.409044,
                28.2247836
              ],
              [
                57.4048543,
                28.2329771
              ],
              [
                57.4010146,
                28.2403847
              ],
              [
                57.3967434,
                28.2483135
              ],
              [
                57.3860548,
                28.2526792
              ],
              [
                57.3791051,
                28.2604136
              ],
              [
                57.3744953,
                28.2661427
              ],
              [
                57.3716004,
                28.281876
              ],
              [
                57.3599223,
                28.3114656
              ],
              [
                57.3555268,
                28.3300872
              ],
              [
                57.3493337,
                28.3400365
              ],
              [
                57.3389188,
                28.36429
              ],
              [
                57.3154461,
                28.411765
              ],
              [
                57.304673,
                28.4245022
              ],
              [
                57.2927983,
                28.4311264
              ],
              [
                57.281477,
                28.4408469
              ],
              [
                57.2754388,
                28.4443005
              ],
              [
                57.2672074,
                28.4434454
              ],
              [
                57.2241318,
                28.426636
              ],
              [
                57.204231,
                28.4214931
              ],
              [
                57.2003693,
                28.4220334
              ],
              [
                57.179308,
                28.4163527
              ],
              [
                57.1702165,
                28.4284626
              ],
              [
                57.1323585,
                28.4545342
              ],
              [
                57.1004124,
                28.4748101
              ],
              [
                57.099299,
                28.4750893
              ],
              [
                57.0948557,
                28.4781429
              ],
              [
                57.0826327,
                28.482863
              ],
              [
                57.0817992,
                28.4831422
              ],
              [
                57.0588633,
                28.5137378
              ],
              [
                57.0123846,
                28.5023308
              ],
              [
                56.9910781,
                28.4564694
              ],
              [
                56.9736885,
                28.4202939
              ],
              [
                56.9577869,
                28.351114
              ],
              [
                56.9529526,
                28.3317337
              ],
              [
                56.9404789,
                28.309293
              ],
              [
                56.9126054,
                28.2990957
              ],
              [
                56.9165727,
                28.2651846
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555141,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فهرج",
          "name:en": "Fahraj County",
          "place": "county",
          "population": "67096",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q2610751",
          "wikipedia": "en:Fahraj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.7140917,
                28.858149
              ],
              [
                58.7149282,
                28.8581489
              ],
              [
                58.7151192,
                28.8579538
              ],
              [
                58.7152016,
                28.8578696
              ],
              [
                58.7338148,
                28.8403693
              ],
              [
                58.7379813,
                28.8364854
              ],
              [
                58.7443743,
                28.8317634
              ],
              [
                58.7471479,
                28.828979
              ],
              [
                58.7502076,
                28.8264829
              ],
              [
                58.7818737,
                28.8081541
              ],
              [
                58.8093735,
                28.7953764
              ],
              [
                58.8363196,
                28.7845363
              ],
              [
                58.8538191,
                28.7798146
              ],
              [
                58.8541074,
                28.7797956
              ],
              [
                58.8621525,
                28.7792649
              ],
              [
                58.8743793,
                28.7814815
              ],
              [
                58.8988255,
                28.7906456
              ],
              [
                58.9010455,
                28.7917538
              ],
              [
                58.9015994,
                28.7920319
              ],
              [
                58.9021588,
                28.7923126
              ],
              [
                58.9030858,
                28.7921069
              ],
              [
                58.9152741,
                28.789402
              ],
              [
                58.9358435,
                28.7848339
              ],
              [
                58.9499882,
                28.7808213
              ],
              [
                58.9571536,
                28.7760596
              ],
              [
                58.9649362,
                28.7720043
              ],
              [
                58.9695143,
                28.7695244
              ],
              [
                58.9766532,
                28.7658192
              ],
              [
                58.9823545,
                28.7630473
              ],
              [
                58.9932473,
                28.7572619
              ],
              [
                59.0046434,
                28.7491993
              ],
              [
                59.0128995,
                28.7537436
              ],
              [
                59.0211735,
                28.7482286
              ],
              [
                59.0247344,
                28.7444835
              ],
              [
                59.0272671,
                28.7406961
              ],
              [
                59.0408931,
                28.7411891
              ],
              [
                59.056573,
                28.7429954
              ],
              [
                59.0781489,
                28.7434796
              ],
              [
                59.0912136,
                28.7441691
              ],
              [
                59.1397658,
                28.7465938
              ],
              [
                59.1984891,
                28.7522873
              ],
              [
                59.2852626,
                28.7638283
              ],
              [
                59.3559428,
                28.7756557
              ],
              [
                59.4199441,
                28.7867463
              ],
              [
                59.4996122,
                28.8001384
              ],
              [
                59.4986104,
                28.8403558
              ],
              [
                59.4985021,
                28.8706622
              ],
              [
                59.4989987,
                28.917061
              ],
              [
                59.5005165,
                28.9475915
              ],
              [
                59.4969032,
                28.96093
              ],
              [
                59.5055168,
                28.9998199
              ],
              [
                59.5082965,
                29.0042633
              ],
              [
                59.5294099,
                29.0328708
              ],
              [
                59.5360763,
                29.0425961
              ],
              [
                59.5374631,
                29.0450928
              ],
              [
                59.5374632,
                29.0453722
              ],
              [
                59.5641293,
                29.0692669
              ],
              [
                59.5649625,
                29.0709343
              ],
              [
                59.5655227,
                29.0714842
              ],
              [
                59.5655226,
                29.0720431
              ],
              [
                59.5660759,
                29.0723224
              ],
              [
                59.5707959,
                29.0820391
              ],
              [
                59.5694091,
                29.0884298
              ],
              [
                59.5694091,
                29.0906562
              ],
              [
                59.5696892,
                29.0909266
              ],
              [
                59.5694092,
                29.0923238
              ],
              [
                59.5527429,
                29.1206545
              ],
              [
                59.5513496,
                29.1234308
              ],
              [
                59.5282968,
                29.1609301
              ],
              [
                59.5136732,
                29.1929828
              ],
              [
                59.5107971,
                29.2031544
              ],
              [
                59.5094036,
                29.2070489
              ],
              [
                59.5088505,
                29.2092665
              ],
              [
                59.4944042,
                29.2445422
              ],
              [
                59.4919043,
                29.2534401
              ],
              [
                59.4846842,
                29.2762129
              ],
              [
                59.4838511,
                29.2801076
              ],
              [
                59.4807979,
                29.2981567
              ],
              [
                59.4741245,
                29.3284315
              ],
              [
                59.4735714,
                29.3295495
              ],
              [
                59.469958,
                29.3539918
              ],
              [
                59.4669049,
                29.3631612
              ],
              [
                59.4655181,
                29.3673267
              ],
              [
                59.464685,
                29.3706626
              ],
              [
                59.4635717,
                29.3742691
              ],
              [
                59.462185,
                29.3978831
              ],
              [
                59.461905,
                29.4006601
              ],
              [
                59.4624584,
                29.4048257
              ],
              [
                59.4627386,
                29.4142661
              ],
              [
                59.4632917,
                29.4181612
              ],
              [
                59.4632917,
                29.4337151
              ],
              [
                59.461905,
                29.4387194
              ],
              [
                59.4616249,
                29.4392693
              ],
              [
                59.4616249,
                29.4395489
              ],
              [
                59.4616249,
                29.4398284
              ],
              [
                59.4560721,
                29.4398284
              ],
              [
                59.4555186,
                29.4400989
              ],
              [
                59.4519053,
                29.4400989
              ],
              [
                59.451072,
                29.4403874
              ],
              [
                59.4018993,
                29.4537145
              ],
              [
                59.3988461,
                29.4548235
              ],
              [
                59.3674601,
                29.4648234
              ],
              [
                59.3557868,
                29.4695484
              ],
              [
                59.3519004,
                29.4706574
              ],
              [
                59.3149541,
                29.4845529
              ],
              [
                59.3094009,
                29.4870507
              ],
              [
                59.3055075,
                29.4887189
              ],
              [
                59.2541218,
                29.5117762
              ],
              [
                59.2396755,
                29.5173309
              ],
              [
                59.2177289,
                29.5267723
              ],
              [
                59.2143957,
                29.528161
              ],
              [
                59.2135625,
                29.5287201
              ],
              [
                59.2121691,
                29.5289997
              ],
              [
                59.1949493,
                29.5376114
              ],
              [
                59.1946693,
                29.5381615
              ],
              [
                59.1668899,
                29.556774
              ],
              [
                59.1543901,
                29.5662157
              ],
              [
                59.1396703,
                29.5751073
              ],
              [
                59.1357768,
                29.5776053
              ],
              [
                59.1032775,
                29.5976072
              ],
              [
                59.0996642,
                29.5989961
              ],
              [
                59.0988309,
                29.598996
              ],
              [
                59.0971641,
                29.5995551
              ],
              [
                59.0960579,
                29.5995552
              ],
              [
                59.0954977,
                29.5998347
              ],
              [
                59.0746645,
                29.603442
              ],
              [
                59.0718914,
                29.6040011
              ],
              [
                59.0716113,
                29.6042717
              ],
              [
                59.0693914,
                29.6042716
              ],
              [
                59.068278,
                29.6045513
              ],
              [
                59.0666117,
                29.6045513
              ],
              [
                59.065778,
                29.6048308
              ],
              [
                59.0643846,
                29.6048308
              ],
              [
                59.0635514,
                29.6051104
              ],
              [
                59.0591115,
                29.6051104
              ],
              [
                59.0582782,
                29.60539
              ],
              [
                59.0524449,
                29.6056605
              ],
              [
                59.0518847,
                29.60539
              ],
              [
                59.0499449,
                29.60539
              ],
              [
                59.0496652,
                29.6051104
              ],
              [
                59.0482785,
                29.6051104
              ],
              [
                59.0477183,
                29.6048309
              ],
              [
                59.0452183,
                29.6048309
              ],
              [
                59.0452183,
                29.6037217
              ],
              [
                59.0449452,
                29.6023329
              ],
              [
                59.0446651,
                29.6020533
              ],
              [
                59.0452182,
                29.5756666
              ],
              [
                59.046885,
                29.5467737
              ],
              [
                59.0477182,
                29.5442757
              ],
              [
                59.0477181,
                29.5439962
              ],
              [
                59.049385,
                29.5409392
              ],
              [
                59.0502182,
                29.5381618
              ],
              [
                59.0563316,
                29.5276112
              ],
              [
                59.0668915,
                29.5120561
              ],
              [
                59.0763311,
                29.4864921
              ],
              [
                59.0766112,
                29.4842739
              ],
              [
                59.0766111,
                29.4817761
              ],
              [
                59.0768912,
                29.4809375
              ],
              [
                59.0771643,
                29.4773306
              ],
              [
                59.0860577,
                29.4403881
              ],
              [
                59.0860576,
                29.4389996
              ],
              [
                59.0866108,
                29.4373314
              ],
              [
                59.0868909,
                29.4331567
              ],
              [
                59.0866108,
                29.4326067
              ],
              [
                59.0868908,
                29.42955
              ],
              [
                59.0866108,
                29.4278819
              ],
              [
                59.0841107,
                29.4203801
              ],
              [
                59.0785575,
                29.4092716
              ],
              [
                59.0774442,
                29.4076036
              ],
              [
                59.0749441,
                29.4037174
              ],
              [
                59.0546644,
                29.377047
              ],
              [
                59.0249379,
                29.3331657
              ],
              [
                59.0235516,
                29.3317683
              ],
              [
                59.0232715,
                29.3309388
              ],
              [
                59.0038317,
                29.3089944
              ],
              [
                59.0004984,
                29.3053792
              ],
              [
                58.9841051,
                29.2892683
              ],
              [
                58.9832719,
                29.2878799
              ],
              [
                58.9196592,
                29.2184358
              ],
              [
                58.9166061,
                29.2142619
              ],
              [
                58.9124329,
                29.2087088
              ],
              [
                58.8371536,
                29.1434346
              ],
              [
                58.8338205,
                29.1406583
              ],
              [
                58.8332673,
                29.1403789
              ],
              [
                58.8068742,
                29.1262087
              ],
              [
                58.8054874,
                29.1259292
              ],
              [
                58.7793745,
                29.1181501
              ],
              [
                58.777708,
                29.1181501
              ],
              [
                58.7765948,
                29.1178706
              ],
              [
                58.7490951,
                29.1145445
              ],
              [
                58.746595,
                29.1142651
              ],
              [
                58.7454817,
                29.1142651
              ],
              [
                58.7446484,
                29.1139857
              ],
              [
                58.7424285,
                29.1139857
              ],
              [
                58.7415953,
                29.1137063
              ],
              [
                58.7354819,
                29.1125976
              ],
              [
                58.7338154,
                29.1125976
              ],
              [
                58.7332619,
                29.1123181
              ],
              [
                58.7349287,
                29.11093
              ],
              [
                58.7449285,
                29.1026012
              ],
              [
                58.7618749,
                29.0831584
              ],
              [
                58.7635413,
                29.0812114
              ],
              [
                58.7768747,
                29.0634366
              ],
              [
                58.7906023,
                29.0509498
              ],
              [
                58.7900966,
                29.0472204
              ],
              [
                58.7882801,
                29.0413992
              ],
              [
                58.7878281,
                29.0368542
              ],
              [
                58.7857961,
                29.0310417
              ],
              [
                58.7844808,
                29.0265313
              ],
              [
                58.7827142,
                29.0216588
              ],
              [
                58.7811243,
                29.0160187
              ],
              [
                58.7796133,
                29.0118965
              ],
              [
                58.7780042,
                29.0058769
              ],
              [
                58.7772879,
                29.0003921
              ],
              [
                58.7768955,
                28.9969856
              ],
              [
                58.7766993,
                28.9931911
              ],
              [
                58.7790926,
                28.9892931
              ],
              [
                58.7816818,
                28.985007
              ],
              [
                58.7841532,
                28.9826267
              ],
              [
                58.7875072,
                28.9805912
              ],
              [
                58.7910473,
                28.9779778
              ],
              [
                58.7930573,
                28.9750455
              ],
              [
                58.7948809,
                28.972691
              ],
              [
                58.7982048,
                28.9700861
              ],
              [
                58.8006064,
                28.9663774
              ],
              [
                58.8036057,
                28.9616942
              ],
              [
                58.8062324,
                28.9581665
              ],
              [
                58.808473,
                28.9552646
              ],
              [
                58.8070504,
                28.9463633
              ],
              [
                58.8036989,
                28.9253895
              ],
              [
                58.8027748,
                28.9196056
              ],
              [
                58.8112666,
                28.9162828
              ],
              [
                58.808012,
                28.9063983
              ],
              [
                58.8031626,
                28.899091
              ],
              [
                58.8010168,
                28.8969024
              ],
              [
                58.8015354,
                28.8890689
              ],
              [
                58.7713211,
                28.8984314
              ],
              [
                58.7685409,
                28.8984314
              ],
              [
                58.7674277,
                28.898152
              ],
              [
                58.7621475,
                28.8981521
              ],
              [
                58.7585411,
                28.8975934
              ],
              [
                58.7524278,
                28.8953764
              ],
              [
                58.7518746,
                28.8948176
              ],
              [
                58.7396478,
                28.8873107
              ],
              [
                58.7368748,
                28.8845352
              ],
              [
                58.7338149,
                28.8817595
              ],
              [
                58.7207615,
                28.8678725
              ],
              [
                58.7204814,
                28.8670344
              ],
              [
                58.7199284,
                28.866755
              ],
              [
                58.7140917,
                28.858149
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555155,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قلعه گنج",
          "name:en": "Qaleh Ganj County",
          "place": "county",
          "population": "76495",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q498784",
          "wikipedia": "en:Qaleh Ganj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.7646882,
                27.5894594
              ],
              [
                57.7654616,
                27.5830723
              ],
              [
                57.7659155,
                27.5719796
              ],
              [
                57.7664079,
                27.5644088
              ],
              [
                57.7669932,
                27.5599802
              ],
              [
                57.7676345,
                27.5542012
              ],
              [
                57.7680015,
                27.5462523
              ],
              [
                57.7696093,
                27.5411707
              ],
              [
                57.7691801,
                27.5282673
              ],
              [
                57.7710683,
                27.5115944
              ],
              [
                57.7716918,
                27.5011152
              ],
              [
                57.7728688,
                27.4952204
              ],
              [
                57.7738284,
                27.4840887
              ],
              [
                57.7735574,
                27.472598
              ],
              [
                57.77721,
                27.4603747
              ],
              [
                57.778738,
                27.4490332
              ],
              [
                57.7829337,
                27.4346757
              ],
              [
                57.7857302,
                27.425789
              ],
              [
                57.786982,
                27.4205471
              ],
              [
                57.7881225,
                27.4155564
              ],
              [
                57.7887374,
                27.4110635
              ],
              [
                57.7883308,
                27.4053261
              ],
              [
                57.7959015,
                27.3483234
              ],
              [
                57.8128928,
                27.3475215
              ],
              [
                57.8329269,
                27.3464541
              ],
              [
                57.8527935,
                27.3469178
              ],
              [
                57.8777912,
                27.3477449
              ],
              [
                57.8970094,
                27.3454121
              ],
              [
                57.9192374,
                27.3426674
              ],
              [
                57.9422615,
                27.3399096
              ],
              [
                57.9606055,
                27.3353276
              ],
              [
                57.9709858,
                27.33174
              ],
              [
                57.9782008,
                27.3285415
              ],
              [
                57.9996543,
                27.3142441
              ],
              [
                57.9957103,
                27.2962826
              ],
              [
                57.9945658,
                27.2777765
              ],
              [
                58.0105742,
                27.2283052
              ],
              [
                58.0260974,
                27.1878184
              ],
              [
                58.0295053,
                27.1795931
              ],
              [
                58.0198285,
                27.1492836
              ],
              [
                58.0032662,
                27.1209383
              ],
              [
                57.9929329,
                27.1016045
              ],
              [
                57.969935,
                27.0583071
              ],
              [
                57.9473898,
                27.0253341
              ],
              [
                57.9435034,
                27.0217295
              ],
              [
                57.9398043,
                27.0159879
              ],
              [
                57.9309344,
                27.0047981
              ],
              [
                57.925261,
                26.9985364
              ],
              [
                57.9173205,
                26.9887824
              ],
              [
                57.9012472,
                26.9735902
              ],
              [
                57.8892397,
                26.9642096
              ],
              [
                57.8756177,
                26.954423
              ],
              [
                57.8639789,
                26.9453072
              ],
              [
                57.8522735,
                26.9342066
              ],
              [
                57.8931723,
                26.9224626
              ],
              [
                57.9062772,
                26.9242228
              ],
              [
                57.9076635,
                26.9239442
              ],
              [
                57.9096104,
                26.9239441
              ],
              [
                57.9101735,
                26.9237558
              ],
              [
                57.9104437,
                26.9236655
              ],
              [
                57.9108088,
                26.9236655
              ],
              [
                57.9140571,
                26.9236655
              ],
              [
                57.9732968,
                26.8849937
              ],
              [
                57.9738499,
                26.8847151
              ],
              [
                57.9763499,
                26.8819379
              ],
              [
                58.0019097,
                26.8585979
              ],
              [
                58.0046828,
                26.8569353
              ],
              [
                58.005516,
                26.8560995
              ],
              [
                58.0280155,
                26.8436076
              ],
              [
                58.0327426,
                26.8416575
              ],
              [
                58.034129,
                26.8408217
              ],
              [
                58.0399622,
                26.838602
              ],
              [
                58.0444088,
                26.8374875
              ],
              [
                58.0445787,
                26.8374876
              ],
              [
                58.0457956,
                26.8374876
              ],
              [
                58.049962,
                26.8372089
              ],
              [
                58.0541285,
                26.8372089
              ],
              [
                58.0543194,
                26.8370191
              ],
              [
                58.0544086,
                26.8369304
              ],
              [
                58.0551448,
                26.8369303
              ],
              [
                58.055522,
                26.8369303
              ],
              [
                58.0562282,
                26.8367405
              ],
              [
                58.0627419,
                26.8349893
              ],
              [
                58.0694084,
                26.8310979
              ],
              [
                58.116354,
                26.791378
              ],
              [
                58.1202475,
                26.78888
              ],
              [
                58.1235807,
                26.7858157
              ],
              [
                58.1235807,
                26.7855372
              ],
              [
                58.1241342,
                26.7855372
              ],
              [
                58.1263542,
                26.783039
              ],
              [
                58.1369141,
                26.7755447
              ],
              [
                58.1385806,
                26.7749877
              ],
              [
                58.138937,
                26.7749877
              ],
              [
                58.1394139,
                26.7749877
              ],
              [
                58.1396008,
                26.7747972
              ],
              [
                58.1911465,
                26.7546641
              ],
              [
                58.1936466,
                26.7543856
              ],
              [
                58.1944799,
                26.7543856
              ],
              [
                58.1948591,
                26.7541945
              ],
              [
                58.1950329,
                26.7541069
              ],
              [
                58.1955799,
                26.7541069
              ],
              [
                58.1961462,
                26.7541069
              ],
              [
                58.1965258,
                26.7539159
              ],
              [
                58.1966997,
                26.7538284
              ],
              [
                58.1972464,
                26.7538284
              ],
              [
                58.197813,
                26.7538283
              ],
              [
                58.1981922,
                26.7536373
              ],
              [
                58.1983662,
                26.7535497
              ],
              [
                58.198913,
                26.7535497
              ],
              [
                58.1994795,
                26.7535497
              ],
              [
                58.2000512,
                26.7533587
              ],
              [
                58.200313,
                26.7532712
              ],
              [
                58.2006676,
                26.7532712
              ],
              [
                58.2014193,
                26.7532711
              ],
              [
                58.2018035,
                26.75308
              ],
              [
                58.2019795,
                26.7529925
              ],
              [
                58.2025214,
                26.7529925
              ],
              [
                58.2041995,
                26.7529924
              ],
              [
                58.2047709,
                26.7528014
              ],
              [
                58.2050327,
                26.7527139
              ],
              [
                58.2053872,
                26.7527139
              ],
              [
                58.2075328,
                26.752714
              ],
              [
                58.2081043,
                26.7525229
              ],
              [
                58.2083659,
                26.7524353
              ],
              [
                58.2087206,
                26.7524353
              ],
              [
                58.2094797,
                26.7524352
              ],
              [
                58.2100513,
                26.7522442
              ],
              [
                58.2103129,
                26.7521567
              ],
              [
                58.2106673,
                26.7521567
              ],
              [
                58.2122594,
                26.7521568
              ],
              [
                58.2128312,
                26.7519656
              ],
              [
                58.213093,
                26.751878
              ],
              [
                58.2134473,
                26.751878
              ],
              [
                58.2141992,
                26.7518781
              ],
              [
                58.2145837,
                26.7516869
              ],
              [
                58.2147595,
                26.7515996
              ],
              [
                58.2153012,
                26.7515996
              ],
              [
                58.2169794,
                26.7515995
              ],
              [
                58.224199,
                26.7502155
              ],
              [
                58.2248295,
                26.7500809
              ],
              [
                58.252812,
                26.7441044
              ],
              [
                58.252842,
                26.7441044
              ],
              [
                58.2536453,
                26.7441043
              ],
              [
                58.2540302,
                26.7439129
              ],
              [
                58.2542054,
                26.7438258
              ],
              [
                58.2547463,
                26.7438258
              ],
              [
                58.2555921,
                26.7438258
              ],
              [
                58.2603117,
                26.74299
              ],
              [
                58.286145,
                26.7385505
              ],
              [
                58.2865604,
                26.7384466
              ],
              [
                58.2872582,
                26.738272
              ],
              [
                58.2874179,
                26.738272
              ],
              [
                58.2892047,
                26.738272
              ],
              [
                58.2922579,
                26.7377148
              ],
              [
                58.2936514,
                26.7377148
              ],
              [
                58.2945503,
                26.737523
              ],
              [
                58.3067047,
                26.7349289
              ],
              [
                58.3067316,
                26.7349289
              ],
              [
                58.308091,
                26.7349288
              ],
              [
                58.308665,
                26.734737
              ],
              [
                58.3089243,
                26.7346503
              ],
              [
                58.3092759,
                26.7346503
              ],
              [
                58.3103181,
                26.7346503
              ],
              [
                58.3105061,
                26.7344583
              ],
              [
                58.310591,
                26.7343716
              ],
              [
                58.3113287,
                26.7343716
              ],
              [
                58.3122579,
                26.7343716
              ],
              [
                58.3129238,
                26.7341797
              ],
              [
                58.3247573,
                26.7307681
              ],
              [
                58.3269843,
                26.7299323
              ],
              [
                58.4591998,
                26.6525887
              ],
              [
                58.4861603,
                26.688811
              ],
              [
                58.486994,
                26.6882538
              ],
              [
                58.4969936,
                26.6807506
              ],
              [
                58.4978269,
                26.6801935
              ],
              [
                58.5001937,
                26.6858879
              ],
              [
                58.5138911,
                26.6686058
              ],
              [
                58.535193,
                26.6417146
              ],
              [
                58.5949285,
                26.6094943
              ],
              [
                58.6138147,
                26.5947723
              ],
              [
                58.6451978,
                26.5586596
              ],
              [
                58.6543643,
                26.5544919
              ],
              [
                58.690477,
                26.5367166
              ],
              [
                58.7929557,
                26.445822
              ],
              [
                58.7937571,
                26.4456785
              ],
              [
                58.796016,
                26.4452739
              ],
              [
                58.7961098,
                26.4452267
              ],
              [
                58.7965691,
                26.4449955
              ],
              [
                58.7971027,
                26.4449954
              ],
              [
                58.7971223,
                26.4449954
              ],
              [
                58.7976824,
                26.4449954
              ],
              [
                58.8032356,
                26.4455435
              ],
              [
                58.8054556,
                26.4461005
              ],
              [
                58.8065689,
                26.4461005
              ],
              [
                58.8552077,
                26.484768
              ],
              [
                58.8557608,
                26.4850464
              ],
              [
                58.8574273,
                26.4850464
              ],
              [
                58.8782605,
                26.494216
              ],
              [
                58.8793738,
                26.4944855
              ],
              [
                58.8902068,
                26.5011584
              ],
              [
                58.897987,
                26.5086577
              ],
              [
                58.9049266,
                26.5128251
              ],
              [
                58.9207667,
                26.5147651
              ],
              [
                58.9224331,
                26.5150435
              ],
              [
                58.9238198,
                26.5150435
              ],
              [
                58.9242096,
                26.5148473
              ],
              [
                58.924373,
                26.5147651
              ],
              [
                58.9247541,
                26.5148412
              ],
              [
                58.9257664,
                26.5150435
              ],
              [
                58.9274331,
                26.5150435
              ],
              [
                58.9278229,
                26.5148473
              ],
              [
                58.9279863,
                26.514765
              ],
              [
                58.9285188,
                26.514765
              ],
              [
                58.9310395,
                26.514765
              ],
              [
                58.9368728,
                26.5142171
              ],
              [
                58.937575,
                26.5140415
              ],
              [
                58.9390994,
                26.5136603
              ],
              [
                58.9392367,
                26.5136603
              ],
              [
                58.9404861,
                26.5136604
              ],
              [
                58.9411329,
                26.5134641
              ],
              [
                58.9560458,
                26.508936
              ],
              [
                58.9579856,
                26.5081008
              ],
              [
                58.9643791,
                26.5064393
              ],
              [
                58.9679857,
                26.5050472
              ],
              [
                58.9683987,
                26.5050472
              ],
              [
                58.968819,
                26.5050472
              ],
              [
                58.9693096,
                26.5048506
              ],
              [
                58.9715992,
                26.5039335
              ],
              [
                58.9815989,
                26.5017151
              ],
              [
                58.9816348,
                26.5017151
              ],
              [
                58.9835455,
                26.5017151
              ],
              [
                58.9849321,
                26.5014367
              ],
              [
                58.9868787,
                26.5014367
              ],
              [
                58.987748,
                26.50124
              ],
              [
                58.9954921,
                26.4994877
              ],
              [
                58.9955186,
                26.4994936
              ],
              [
                58.9979918,
                26.5000445
              ],
              [
                58.9990984,
                26.5000445
              ],
              [
                58.9996586,
                26.5003229
              ],
              [
                59.0003551,
                26.5003229
              ],
              [
                59.0021586,
                26.5014366
              ],
              [
                59.0077119,
                26.5105975
              ],
              [
                59.0077119,
                26.5133817
              ],
              [
                59.0074318,
                26.5150434
              ],
              [
                59.0071584,
                26.5153218
              ],
              [
                59.0077118,
                26.5169923
              ],
              [
                59.008265,
                26.5172707
              ],
              [
                59.008265,
                26.5175491
              ],
              [
                59.0085451,
                26.5178276
              ],
              [
                59.0090982,
                26.5189323
              ],
              [
                59.0093783,
                26.5206029
              ],
              [
                59.0090982,
                26.5233782
              ],
              [
                59.0063252,
                26.5264319
              ],
              [
                59.0060451,
                26.5281025
              ],
              [
                59.0135448,
                26.5342191
              ],
              [
                59.0277115,
                26.5381081
              ],
              [
                59.031878,
                26.5400482
              ],
              [
                59.0321581,
                26.5405961
              ],
              [
                59.0332713,
                26.5411619
              ],
              [
                59.0354913,
                26.5436589
              ],
              [
                59.0374382,
                26.5475481
              ],
              [
                59.0374382,
                26.5506019
              ],
              [
                59.0352112,
                26.5608774
              ],
              [
                59.0349382,
                26.5611559
              ],
              [
                59.0349382,
                26.5614343
              ],
              [
                59.0285447,
                26.5664375
              ],
              [
                59.0263248,
                26.5680991
              ],
              [
                59.0043787,
                26.5853274
              ],
              [
                59.002992,
                26.5869892
              ],
              [
                59.000492,
                26.5942202
              ],
              [
                58.9996588,
                26.596439
              ],
              [
                58.9990986,
                26.6042091
              ],
              [
                59.0010456,
                26.6158779
              ],
              [
                59.002432,
                26.6186537
              ],
              [
                59.0118786,
                26.6306013
              ],
              [
                59.0149318,
                26.6367189
              ],
              [
                59.0174318,
                26.6514428
              ],
              [
                59.0177119,
                26.6561592
              ],
              [
                59.0174318,
                26.6597707
              ],
              [
                59.0160451,
                26.6625466
              ],
              [
                59.0029922,
                26.6747737
              ],
              [
                58.9979922,
                26.6853299
              ],
              [
                58.9960457,
                26.7114384
              ],
              [
                58.9957657,
                26.7142236
              ],
              [
                58.9960457,
                26.7147717
              ],
              [
                58.9965988,
                26.7231094
              ],
              [
                58.9965988,
                26.7303241
              ],
              [
                58.9963259,
                26.7342145
              ],
              [
                58.9935458,
                26.7489409
              ],
              [
                58.9929926,
                26.7506122
              ],
              [
                58.9924324,
                26.7514388
              ],
              [
                58.9904926,
                26.7583844
              ],
              [
                58.9904926,
                26.7586629
              ],
              [
                58.9904926,
                26.75922
              ],
              [
                58.9902126,
                26.7594986
              ],
              [
                58.989968,
                26.7595803
              ],
              [
                58.9893793,
                26.759777
              ],
              [
                58.9890709,
                26.7597771
              ],
              [
                58.9885461,
                26.7597771
              ],
              [
                58.9881834,
                26.7599556
              ],
              [
                58.9874324,
                26.7603252
              ],
              [
                58.9872348,
                26.7601284
              ],
              [
                58.9871527,
                26.7600466
              ],
              [
                58.9865992,
                26.7600466
              ],
              [
                58.9865992,
                26.7601284
              ],
              [
                58.9865992,
                26.7603251
              ],
              [
                58.9851862,
                26.7603252
              ],
              [
                58.9846526,
                26.7603252
              ],
              [
                58.9844901,
                26.760407
              ],
              [
                58.9840992,
                26.7606037
              ],
              [
                58.9828843,
                26.7606037
              ],
              [
                58.9821526,
                26.7606037
              ],
              [
                58.9820724,
                26.7606855
              ],
              [
                58.9818796,
                26.7608822
              ],
              [
                58.9801064,
                26.7608823
              ],
              [
                58.9793796,
                26.7608823
              ],
              [
                58.9792973,
                26.7609642
              ],
              [
                58.9790995,
                26.7611609
              ],
              [
                58.9779666,
                26.7611609
              ],
              [
                58.9774327,
                26.7611609
              ],
              [
                58.9772702,
                26.7612427
              ],
              [
                58.9768795,
                26.7614394
              ],
              [
                58.9765753,
                26.7614394
              ],
              [
                58.9760463,
                26.7614393
              ],
              [
                58.9758815,
                26.7615213
              ],
              [
                58.9754861,
                26.7617179
              ],
              [
                58.9742731,
                26.7617179
              ],
              [
                58.9735462,
                26.7617179
              ],
              [
                58.9734638,
                26.7617998
              ],
              [
                58.9732662,
                26.7619965
              ],
              [
                58.9721753,
                26.7619965
              ],
              [
                58.9718794,
                26.7619965
              ],
              [
                58.9585465,
                26.7661657
              ],
              [
                58.957153,
                26.7669923
              ],
              [
                58.9560463,
                26.7672709
              ],
              [
                58.9057608,
                26.7878299
              ],
              [
                58.899374,
                26.7911635
              ],
              [
                58.886321,
                26.8000505
              ],
              [
                58.8629813,
                26.8186696
              ],
              [
                58.8613147,
                26.8194963
              ],
              [
                58.8602082,
                26.8206106
              ],
              [
                58.8535417,
                26.8247712
              ],
              [
                58.8510417,
                26.8303338
              ],
              [
                58.8507615,
                26.8311605
              ],
              [
                58.8502084,
                26.8331105
              ],
              [
                58.8504814,
                26.8361659
              ],
              [
                58.8502084,
                26.846725
              ],
              [
                58.8493752,
                26.857554
              ],
              [
                58.8502084,
                26.8619934
              ],
              [
                58.8643748,
                26.9086636
              ],
              [
                58.8765946,
                26.933946
              ],
              [
                58.897988,
                26.9692244
              ],
              [
                58.8988213,
                26.9697817
              ],
              [
                58.9118742,
                26.9886666
              ],
              [
                58.9129876,
                26.9999296
              ],
              [
                58.908541,
                27.0053319
              ],
              [
                58.9049277,
                27.0072735
              ],
              [
                58.8907615,
                27.0189413
              ],
              [
                58.8893747,
                27.0203346
              ],
              [
                58.8768749,
                27.0372794
              ],
              [
                58.8757616,
                27.0394997
              ],
              [
                58.8746484,
                27.040893
              ],
              [
                58.8713151,
                27.0472756
              ],
              [
                58.8702084,
                27.048669
              ],
              [
                58.8599286,
                27.071449
              ],
              [
                58.8593755,
                27.0742269
              ],
              [
                58.8552091,
                27.0872804
              ],
              [
                58.8504821,
                27.096729
              ],
              [
                58.8485422,
                27.1017277
              ],
              [
                58.8385359,
                27.1339499
              ],
              [
                58.8385358,
                27.1342286
              ],
              [
                58.8385358,
                27.1344983
              ],
              [
                58.8382624,
                27.1351502
              ],
              [
                58.8352026,
                27.1508887
              ],
              [
                58.8349292,
                27.1545031
              ],
              [
                58.8346491,
                27.1572813
              ],
              [
                58.8335358,
                27.1642226
              ],
              [
                58.8330053,
                27.183222
              ],
              [
                58.8310364,
                27.2536735
              ],
              [
                58.8318696,
                27.2620006
              ],
              [
                58.835483,
                27.2920006
              ],
              [
                58.8368694,
                27.3017311
              ],
              [
                58.854096,
                27.3931258
              ],
              [
                58.8624294,
                27.426172
              ],
              [
                58.8657628,
                27.4372808
              ],
              [
                58.8707629,
                27.4620085
              ],
              [
                58.8740962,
                27.4756186
              ],
              [
                58.8746493,
                27.4767341
              ],
              [
                58.8746493,
                27.4770128
              ],
              [
                58.8746493,
                27.4772913
              ],
              [
                58.866043,
                27.4772918
              ],
              [
                58.8657628,
                27.4775706
              ],
              [
                58.8574295,
                27.4775706
              ],
              [
                58.8527099,
                27.4778405
              ],
              [
                58.8513165,
                27.4781193
              ],
              [
                58.8463165,
                27.4781194
              ],
              [
                58.7924241,
                27.47507
              ],
              [
                58.789924,
                27.4747821
              ],
              [
                58.7834505,
                27.4747824
              ],
              [
                58.774091,
                27.4747822
              ],
              [
                58.7657576,
                27.4745124
              ],
              [
                58.7638178,
                27.4742335
              ],
              [
                58.7618712,
                27.4745123
              ],
              [
                58.761038,
                27.4742335
              ],
              [
                58.7590911,
                27.4742335
              ],
              [
                58.7574247,
                27.4745124
              ],
              [
                58.7563114,
                27.4742335
              ],
              [
                58.7543714,
                27.4745123
              ],
              [
                58.7460381,
                27.4745123
              ],
              [
                58.7274249,
                27.47534
              ],
              [
                58.7257585,
                27.4756189
              ],
              [
                58.7226983,
                27.4756189
              ],
              [
                58.6868656,
                27.4820058
              ],
              [
                58.6846457,
                27.4822936
              ],
              [
                58.6765859,
                27.4845066
              ],
              [
                58.6757526,
                27.4850643
              ],
              [
                58.6679795,
                27.4872862
              ],
              [
                58.666586,
                27.487844
              ],
              [
                58.6649192,
                27.4881228
              ],
              [
                58.6340867,
                27.4992326
              ],
              [
                58.6335332,
                27.4997904
              ],
              [
                58.6149203,
                27.5058986
              ],
              [
                58.6143669,
                27.5058987
              ],
              [
                58.6138071,
                27.5058986
              ],
              [
                58.6129734,
                27.5061775
              ],
              [
                58.6118672,
                27.5061775
              ],
              [
                58.595474,
                27.5106215
              ],
              [
                58.5876942,
                27.5134013
              ],
              [
                58.5454748,
                27.5336788
              ],
              [
                58.537975,
                27.5384018
              ],
              [
                58.5001956,
                27.5889543
              ],
              [
                58.4835226,
                27.6000657
              ],
              [
                58.4724162,
                27.6081272
              ],
              [
                58.4557429,
                27.6175655
              ],
              [
                58.4421364,
                27.6214614
              ],
              [
                58.4399098,
                27.6214614
              ],
              [
                58.4343566,
                27.6222892
              ],
              [
                58.4324101,
                27.6222892
              ],
              [
                58.421297,
                27.6239537
              ],
              [
                58.4074104,
                27.6275708
              ],
              [
                58.4024103,
                27.6292353
              ],
              [
                58.3929641,
                27.6317366
              ],
              [
                58.3921306,
                27.6317366
              ],
              [
                58.3907441,
                27.6322944
              ],
              [
                58.3893574,
                27.6325644
              ],
              [
                58.3776843,
                27.6378461
              ],
              [
                58.3757443,
                27.6384039
              ],
              [
                58.354078,
                27.6495161
              ],
              [
                58.3332381,
                27.6634089
              ],
              [
                58.3212986,
                27.6734058
              ],
              [
                58.2968525,
                27.6909074
              ],
              [
                58.2904589,
                27.6945158
              ],
              [
                58.2824057,
                27.6964594
              ],
              [
                58.2807393,
                27.6967384
              ],
              [
                58.2804592,
                27.6970173
              ],
              [
                58.279626,
                27.6970173
              ],
              [
                58.2790725,
                27.6972962
              ],
              [
                58.2721258,
                27.6975662
              ],
              [
                58.2715727,
                27.6978451
              ],
              [
                58.2693461,
                27.6978452
              ],
              [
                58.2685129,
                27.6981241
              ],
              [
                58.2682395,
                27.6978452
              ],
              [
                58.2657394,
                27.6978452
              ],
              [
                58.2651793,
                27.6975663
              ],
              [
                58.2629597,
                27.6975663
              ],
              [
                58.2212937,
                27.6822871
              ],
              [
                58.2196269,
                27.6811804
              ],
              [
                58.2196269,
                27.6809014
              ],
              [
                58.2182335,
                27.6806315
              ],
              [
                58.2174003,
                27.6806315
              ],
              [
                58.2171269,
                27.6803435
              ],
              [
                58.2129603,
                27.6803435
              ],
              [
                58.2126802,
                27.6800737
              ],
              [
                58.2087938,
                27.6803436
              ],
              [
                58.2082338,
                27.6806315
              ],
              [
                58.2060137,
                27.6806315
              ],
              [
                58.2043469,
                27.6809015
              ],
              [
                58.2037938,
                27.6811803
              ],
              [
                58.2024004,
                27.6811804
              ],
              [
                58.1999004,
                27.6817383
              ],
              [
                58.1976804,
                27.6817383
              ],
              [
                58.1974003,
                27.6820172
              ],
              [
                58.1946206,
                27.6820173
              ],
              [
                58.1926807,
                27.6822872
              ],
              [
                58.1801809,
                27.6859046
              ],
              [
                58.1715675,
                27.6875692
              ],
              [
                58.1646209,
                27.6897918
              ],
              [
                58.1640678,
                27.6903497
              ],
              [
                58.1607344,
                27.6917354
              ],
              [
                58.1485081,
                27.7003469
              ],
              [
                58.1471214,
                27.7022906
              ],
              [
                58.1460081,
                27.7031275
              ],
              [
                58.1454546,
                27.7039553
              ],
              [
                58.1240686,
                27.7170123
              ],
              [
                58.1057285,
                27.7247963
              ],
              [
                58.0865622,
                27.7303486
              ],
              [
                58.0798957,
                27.7311855
              ],
              [
                58.0743425,
                27.7311855
              ],
              [
                58.0737827,
                27.7309066
              ],
              [
                58.072676,
                27.7309065
              ],
              [
                58.072396,
                27.7306276
              ],
              [
                58.0712827,
                27.7306276
              ],
              [
                58.0707291,
                27.7303486
              ],
              [
                58.0696158,
                27.7303486
              ],
              [
                58.0690628,
                27.7300697
              ],
              [
                58.0679493,
                27.7300696
              ],
              [
                58.0651763,
                27.7292418
              ],
              [
                58.0612829,
                27.7292418
              ],
              [
                58.0607294,
                27.7295207
              ],
              [
                58.059616,
                27.7295207
              ],
              [
                58.0576762,
                27.7300697
              ],
              [
                58.0554496,
                27.7311855
              ],
              [
                58.0510096,
                27.7336872
              ],
              [
                58.0210033,
                27.7617374
              ],
              [
                58.0118368,
                27.7761813
              ],
              [
                58.0104504,
                27.7795201
              ],
              [
                58.0068372,
                27.7931275
              ],
              [
                58.0060039,
                27.8042421
              ],
              [
                58.0054504,
                27.8111899
              ],
              [
                58.0048903,
                27.815627
              ],
              [
                58.004057,
                27.8184079
              ],
              [
                58.0029504,
                27.8225749
              ],
              [
                57.9871173,
                27.8453544
              ],
              [
                57.9840575,
                27.8475684
              ],
              [
                57.9837841,
                27.8481264
              ],
              [
                57.9521113,
                27.860079
              ],
              [
                57.948778,
                27.8617441
              ],
              [
                57.9315582,
                27.8731299
              ],
              [
                57.9265585,
                27.8784043
              ],
              [
                57.9251653,
                27.8803484
              ],
              [
                57.9218319,
                27.8828507
              ],
              [
                57.9212784,
                27.8834087
              ],
              [
                57.920165,
                27.8822926
              ],
              [
                57.9148919,
                27.8792413
              ],
              [
                57.8532198,
                27.8361832
              ],
              [
                57.8421063,
                27.8303512
              ],
              [
                57.8407199,
                27.8295142
              ],
              [
                57.7658763,
                27.8181139
              ],
              [
                57.768946,
                27.8020248
              ],
              [
                57.7705277,
                27.7901875
              ],
              [
                57.7731528,
                27.778943
              ],
              [
                57.7774825,
                27.7613225
              ],
              [
                57.7843107,
                27.7472437
              ],
              [
                57.7837572,
                27.7258604
              ],
              [
                57.7785355,
                27.704115
              ],
              [
                57.7747506,
                27.6894472
              ],
              [
                57.7787736,
                27.6678458
              ],
              [
                57.7782138,
                27.662294
              ],
              [
                57.7782138,
                27.6561754
              ],
              [
                57.770844,
                27.6354463
              ],
              [
                57.7665139,
                27.617365
              ],
              [
                57.7649467,
                27.6130298
              ],
              [
                57.7638309,
                27.607479
              ],
              [
                57.7645397,
                27.6023665
              ],
              [
                57.7646882,
                27.5894594
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555167,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کرمان",
          "name:ar": "مقاطعة كرمان",
          "name:azb": "کیرمان بؤلگه‌سی",
          "name:de": "Verwaltungsbezirk Kerman",
          "name:en": "Kerman County",
          "name:es": "Condado de Kermán",
          "name:glk": "شهرستان کرمان",
          "name:ps": "کرمان ولسوالي",
          "name:tg": "Шаҳристони Кирмон",
          "name:ur": "شہرستان کرمان",
          "place": "county",
          "population": "738724",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1286434",
          "wikipedia": "fa:شهرستان کرمان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.2484307,
                30.1617935
              ],
              [
                56.2639869,
                30.1476289
              ],
              [
                56.2648204,
                30.1467899
              ],
              [
                56.2903766,
                30.1276273
              ],
              [
                56.3303793,
                30.1040083
              ],
              [
                56.3317694,
                30.1028986
              ],
              [
                56.334546,
                30.1015093
              ],
              [
                56.3392691,
                30.0990103
              ],
              [
                56.3528789,
                30.0923433
              ],
              [
                56.3820486,
                30.0801191
              ],
              [
                56.3839918,
                30.0795687
              ],
              [
                56.3942717,
                30.0748414
              ],
              [
                56.4162182,
                30.0667853
              ],
              [
                56.4178848,
                30.0659552
              ],
              [
                56.4239947,
                30.0642953
              ],
              [
                56.4256612,
                30.0634563
              ],
              [
                56.4270512,
                30.0631766
              ],
              [
                56.4312179,
                30.0617874
              ],
              [
                56.4781638,
                30.0478944
              ],
              [
                56.5114999,
                30.0381784
              ],
              [
                56.5117767,
                30.0378988
              ],
              [
                56.5128865,
                30.0378987
              ],
              [
                56.5195532,
                30.0359592
              ],
              [
                56.5214997,
                30.0356795
              ],
              [
                56.600392,
                30.0276235
              ],
              [
                56.6020586,
                30.0273439
              ],
              [
                56.6076152,
                30.0273439
              ],
              [
                56.6090019,
                30.0270642
              ],
              [
                56.6112251,
                30.0270643
              ],
              [
                56.6126152,
                30.0267935
              ],
              [
                56.6162251,
                30.0267936
              ],
              [
                56.620115,
                30.0262342
              ],
              [
                56.6248383,
                30.0259546
              ],
              [
                56.6337249,
                30.0251246
              ],
              [
                56.6370581,
                30.0245653
              ],
              [
                56.643448,
                30.0245653
              ],
              [
                56.6465048,
                30.0251246
              ],
              [
                56.6515046,
                30.0251247
              ],
              [
                56.6556711,
                30.0253953
              ],
              [
                56.6567811,
                30.0256749
              ],
              [
                56.660951,
                30.0256749
              ],
              [
                56.6623376,
                30.0259546
              ],
              [
                56.6726175,
                30.0259546
              ],
              [
                56.6740042,
                30.0262342
              ],
              [
                56.682894,
                30.0262342
              ],
              [
                56.6865075,
                30.0270641
              ],
              [
                56.6870608,
                30.0273438
              ],
              [
                56.6895606,
                30.0273438
              ],
              [
                56.6901172,
                30.0276235
              ],
              [
                56.6953939,
                30.0276235
              ],
              [
                56.6965072,
                30.0273438
              ],
              [
                56.6978973,
                30.0273438
              ],
              [
                56.6990073,
                30.0270642
              ],
              [
                56.7045638,
                30.0270642
              ],
              [
                56.7070638,
                30.0267935
              ],
              [
                56.707617,
                30.0267934
              ],
              [
                56.7090071,
                30.0267935
              ],
              [
                56.7178969,
                30.0251245
              ],
              [
                56.7184537,
                30.0248449
              ],
              [
                56.7276201,
                30.0248449
              ],
              [
                56.7317867,
                30.0256749
              ],
              [
                56.7384533,
                30.0256748
              ],
              [
                56.7490097,
                30.0251245
              ],
              [
                56.7531764,
                30.0251245
              ],
              [
                56.7590097,
                30.0253952
              ],
              [
                56.7598429,
                30.0256748
              ],
              [
                56.7670663,
                30.0256748
              ],
              [
                56.7842892,
                30.0234556
              ],
              [
                56.7862327,
                30.0228962
              ],
              [
                56.7876225,
                30.0228963
              ],
              [
                56.7915124,
                30.0220663
              ],
              [
                56.7937324,
                30.0220663
              ],
              [
                56.7945658,
                30.0217866
              ],
              [
                56.7976223,
                30.0217866
              ],
              [
                56.7978991,
                30.0220663
              ],
              [
                56.7995657,
                30.0220663
              ],
              [
                56.8001223,
                30.0223459
              ],
              [
                56.8012324,
                30.0223459
              ],
              [
                56.8020656,
                30.0226256
              ],
              [
                56.8067889,
                30.0226256
              ],
              [
                56.8112357,
                30.0217866
              ],
              [
                56.8123454,
                30.0217866
              ],
              [
                56.8142888,
                30.0212273
              ],
              [
                56.820402,
                30.0212273
              ],
              [
                56.8229021,
                30.0209567
              ],
              [
                56.8254019,
                30.020677
              ],
              [
                56.8267886,
                30.020677
              ],
              [
                56.8273453,
                30.0203974
              ],
              [
                56.8312353,
                30.0203973
              ],
              [
                56.8323452,
                30.0201176
              ],
              [
                56.8340118,
                30.0201177
              ],
              [
                56.8415118,
                30.0187284
              ],
              [
                56.8429017,
                30.0187284
              ],
              [
                56.8590149,
                30.0153996
              ],
              [
                56.8648481,
                30.0153996
              ],
              [
                56.8656814,
                30.01512
              ],
              [
                56.8670715,
                30.0151199
              ],
              [
                56.8770712,
                30.0129008
              ],
              [
                56.8806813,
                30.0129008
              ],
              [
                56.8815145,
                30.0126212
              ],
              [
                56.8823479,
                30.0126211
              ],
              [
                56.8826243,
                30.0123414
              ],
              [
                56.889571,
                30.0123414
              ],
              [
                56.8898476,
                30.0120618
              ],
              [
                56.8915142,
                30.0120618
              ],
              [
                56.8937377,
                30.0112318
              ],
              [
                56.8942944,
                30.011045
              ],
              [
                56.8951276,
                30.0106815
              ],
              [
                56.8951275,
                30.0103929
              ],
              [
                56.8965144,
                30.0103929
              ],
              [
                56.8973476,
                30.0101223
              ],
              [
                56.9029041,
                30.0092923
              ],
              [
                56.9034609,
                30.0090127
              ],
              [
                56.9076274,
                30.0090126
              ],
              [
                56.907904,
                30.0087329
              ],
              [
                56.9101274,
                30.008733
              ],
              [
                56.9106841,
                30.0084534
              ],
              [
                56.911794,
                30.0084533
              ],
              [
                56.9123507,
                30.0081737
              ],
              [
                56.9137373,
                30.0081737
              ],
              [
                56.9140173,
                30.007894
              ],
              [
                56.9259606,
                30.007894
              ],
              [
                56.9284604,
                30.0076234
              ],
              [
                56.9295738,
                30.0073437
              ],
              [
                56.9356836,
                30.0073437
              ],
              [
                56.9362405,
                30.007064
              ],
              [
                56.9431836,
                30.0070641
              ],
              [
                56.9434636,
                30.0073437
              ],
              [
                56.9451302,
                30.0073437
              ],
              [
                56.9454069,
                30.0076234
              ],
              [
                56.9470735,
                30.0076233
              ],
              [
                56.9476303,
                30.007894
              ],
              [
                56.949297,
                30.0076234
              ],
              [
                56.9495735,
                30.0073437
              ],
              [
                56.9515166,
                30.0073437
              ],
              [
                56.9517969,
                30.0070641
              ],
              [
                56.9529067,
                30.007064
              ],
              [
                56.9559435,
                30.0077537
              ],
              [
                56.9610951,
                30.0088005
              ],
              [
                56.997759,
                30.0050092
              ],
              [
                57.0042373,
                30.0079722
              ],
              [
                57.0230242,
                30.0092391
              ],
              [
                57.0345349,
                30.007562
              ],
              [
                57.0446042,
                30.0095559
              ],
              [
                57.0525367,
                30.009191
              ],
              [
                57.0692621,
                30.0084201
              ],
              [
                57.0788187,
                30.0064767
              ],
              [
                57.0915779,
                30.0078509
              ],
              [
                57.1055966,
                30.0093592
              ],
              [
                57.1103424,
                30.0084105
              ],
              [
                57.1130492,
                30.0059109
              ],
              [
                57.1131002,
                30.0017747
              ],
              [
                57.1084405,
                29.9951507
              ],
              [
                57.105614,
                29.9943187
              ],
              [
                57.1074884,
                29.9894938
              ],
              [
                57.1118531,
                29.9782566
              ],
              [
                57.1138014,
                29.9604069
              ],
              [
                57.1148488,
                29.9552607
              ],
              [
                57.1175292,
                29.9380289
              ],
              [
                57.1194542,
                29.9256496
              ],
              [
                57.1194079,
                29.9132884
              ],
              [
                57.118471,
                29.9120666
              ],
              [
                57.1193042,
                29.9026223
              ],
              [
                57.1193041,
                29.8903908
              ],
              [
                57.1187475,
                29.8881718
              ],
              [
                57.1187474,
                29.8829263
              ],
              [
                57.1187474,
                29.8775485
              ],
              [
                57.1187474,
                29.8751196
              ],
              [
                57.1187474,
                29.87484
              ],
              [
                57.1209707,
                29.8545628
              ],
              [
                57.120414,
                29.8487269
              ],
              [
                57.1201375,
                29.8453896
              ],
              [
                57.1198573,
                29.8442801
              ],
              [
                57.1195808,
                29.8423408
              ],
              [
                57.119304,
                29.8409518
              ],
              [
                57.1184709,
                29.8387239
              ],
              [
                57.1181907,
                29.8365049
              ],
              [
                57.1179142,
                29.8351159
              ],
              [
                57.1176374,
                29.8337268
              ],
              [
                57.1173573,
                29.8320672
              ],
              [
                57.1170807,
                29.8303895
              ],
              [
                57.1168042,
                29.826502
              ],
              [
                57.1165241,
                29.8251129
              ],
              [
                57.1162474,
                29.8223439
              ],
              [
                57.1159708,
                29.8217847
              ],
              [
                57.116524,
                29.8098335
              ],
              [
                57.1159707,
                29.8034476
              ],
              [
                57.1162473,
                29.7990009
              ],
              [
                57.1162473,
                29.7981711
              ],
              [
                57.1159707,
                29.797621
              ],
              [
                57.1159707,
                29.7945633
              ],
              [
                57.1159708,
                29.7923355
              ],
              [
                57.1156907,
                29.7917853
              ],
              [
                57.1156906,
                29.7909465
              ],
              [
                57.1154141,
                29.7895574
              ],
              [
                57.1151374,
                29.7873387
              ],
              [
                57.1148575,
                29.7870591
              ],
              [
                57.1151375,
                29.7865089
              ],
              [
                57.116524,
                29.7798345
              ],
              [
                57.1173572,
                29.7740079
              ],
              [
                57.1248572,
                29.7578904
              ],
              [
                57.1265238,
                29.7562218
              ],
              [
                57.1276371,
                29.7556716
              ],
              [
                57.1279139,
                29.7551123
              ],
              [
                57.1287471,
                29.7548418
              ],
              [
                57.1298571,
                29.7537234
              ],
              [
                57.1734732,
                29.7067791
              ],
              [
                57.1762496,
                29.7040012
              ],
              [
                57.2293089,
                29.6673399
              ],
              [
                57.2306955,
                29.6662217
              ],
              [
                57.2751415,
                29.6334484
              ],
              [
                57.2773648,
                29.6312209
              ],
              [
                57.2798647,
                29.6290024
              ],
              [
                57.2854214,
                29.6214992
              ],
              [
                57.2873644,
                29.6176123
              ],
              [
                57.2879214,
                29.6173327
              ],
              [
                57.2923644,
                29.6084408
              ],
              [
                57.2951445,
                29.5973395
              ],
              [
                57.2965309,
                29.5876091
              ],
              [
                57.2968109,
                29.5853907
              ],
              [
                57.2973645,
                29.5814949
              ],
              [
                57.2973644,
                29.574001
              ],
              [
                57.2901444,
                29.5426102
              ],
              [
                57.2895878,
                29.5406624
              ],
              [
                57.2893111,
                29.5403918
              ],
              [
                57.2864339,
                29.5348056
              ],
              [
                57.2845878,
                29.531221
              ],
              [
                57.274588,
                29.5176136
              ],
              [
                57.2737546,
                29.513718
              ],
              [
                57.2734745,
                29.513168
              ],
              [
                57.274588,
                29.5051064
              ],
              [
                57.2754212,
                29.5028882
              ],
              [
                57.2768079,
                29.5003904
              ],
              [
                57.2787544,
                29.497054
              ],
              [
                57.3126439,
                29.4662244
              ],
              [
                57.3131974,
                29.4645562
              ],
              [
                57.3131974,
                29.4639972
              ],
              [
                57.3143107,
                29.4598313
              ],
              [
                57.3143107,
                29.4595518
              ],
              [
                57.3140306,
                29.4592723
              ],
              [
                57.3140306,
                29.4587223
              ],
              [
                57.313477,
                29.4587222
              ],
              [
                57.3134771,
                29.4584427
              ],
              [
                57.312924,
                29.4578836
              ],
              [
                57.3120907,
                29.4576041
              ],
              [
                57.3012572,
                29.4523293
              ],
              [
                57.297924,
                29.4512202
              ],
              [
                57.2895876,
                29.4512202
              ],
              [
                57.2890308,
                29.4514997
              ],
              [
                57.2851444,
                29.4514997
              ],
              [
                57.2837545,
                29.4509407
              ],
              [
                57.2829211,
                29.4509406
              ],
              [
                57.2770877,
                29.447884
              ],
              [
                57.2743078,
                29.4442772
              ],
              [
                57.2740313,
                29.4431591
              ],
              [
                57.2734744,
                29.4426091
              ],
              [
                57.2720878,
                29.4398319
              ],
              [
                57.2712546,
                29.4376047
              ],
              [
                57.2709745,
                29.4359457
              ],
              [
                57.270698,
                29.4356662
              ],
              [
                57.2726411,
                29.4151082
              ],
              [
                57.2693079,
                29.4103835
              ],
              [
                57.2668078,
                29.4089949
              ],
              [
                57.2665312,
                29.4084449
              ],
              [
                57.2540314,
                29.4045498
              ],
              [
                57.2531981,
                29.4042702
              ],
              [
                57.2509747,
                29.4042703
              ],
              [
                57.2504181,
                29.4039908
              ],
              [
                57.2451416,
                29.4031613
              ],
              [
                57.2451416,
                29.4026023
              ],
              [
                57.2523648,
                29.3884465
              ],
              [
                57.2648645,
                29.3578813
              ],
              [
                57.2648646,
                29.3576018
              ],
              [
                57.2712544,
                29.3412196
              ],
              [
                57.270421,
                29.3389928
              ],
              [
                57.2687544,
                29.3367748
              ],
              [
                57.2695878,
                29.3367748
              ],
              [
                57.2698644,
                29.3364953
              ],
              [
                57.2709743,
                29.3364953
              ],
              [
                57.2712545,
                29.3362158
              ],
              [
                57.2726409,
                29.3362158
              ],
              [
                57.2729211,
                29.3359363
              ],
              [
                57.275141,
                29.3359363
              ],
              [
                57.2756977,
                29.3356658
              ],
              [
                57.2773643,
                29.3353774
              ],
              [
                57.2865306,
                29.3342773
              ],
              [
                57.3345901,
                29.3248287
              ],
              [
                57.3354234,
                29.3248286
              ],
              [
                57.3359765,
                29.3245492
              ],
              [
                57.3384765,
                29.3242787
              ],
              [
                57.3520897,
                29.3226107
              ],
              [
                57.3534764,
                29.3223312
              ],
              [
                57.3584765,
                29.3223312
              ],
              [
                57.3595898,
                29.3220517
              ],
              [
                57.3609761,
                29.3220517
              ],
              [
                57.3620895,
                29.3217722
              ],
              [
                57.3634763,
                29.3217722
              ],
              [
                57.3645895,
                29.3214928
              ],
              [
                57.3659762,
                29.3214927
              ],
              [
                57.3668165,
                29.3212133
              ],
              [
                57.368483,
                29.3212133
              ],
              [
                57.3732029,
                29.3201043
              ],
              [
                57.4037554,
                29.316498
              ],
              [
                57.4051492,
                29.3162185
              ],
              [
                57.4062626,
                29.3162185
              ],
              [
                57.4068156,
                29.315939
              ],
              [
                57.4093157,
                29.315939
              ],
              [
                57.423482,
                29.3137211
              ],
              [
                57.4243155,
                29.3134417
              ],
              [
                57.4254289,
                29.3134416
              ],
              [
                57.4262621,
                29.3131622
              ],
              [
                57.4270953,
                29.3131621
              ],
              [
                57.4276488,
                29.3128826
              ],
              [
                57.430702,
                29.3126032
              ],
              [
                57.4404284,
                29.3101058
              ],
              [
                57.441262,
                29.3095468
              ],
              [
                57.4423753,
                29.3095468
              ],
              [
                57.4526481,
                29.3064905
              ],
              [
                57.4712612,
                29.2976011
              ],
              [
                57.4876546,
                29.2870528
              ],
              [
                57.5001544,
                29.2806608
              ],
              [
                57.5001543,
                29.2803813
              ],
              [
                57.5009876,
                29.2801108
              ],
              [
                57.5057076,
                29.2773251
              ],
              [
                57.5065408,
                29.2773251
              ],
              [
                57.5079271,
                29.2764957
              ],
              [
                57.5084874,
                29.2764957
              ],
              [
                57.5090409,
                29.2762162
              ],
              [
                57.5098741,
                29.2762162
              ],
              [
                57.5109874,
                29.2756572
              ],
              [
                57.5293204,
                29.2734394
              ],
              [
                57.5298737,
                29.27316
              ],
              [
                57.5332068,
                29.2731599
              ],
              [
                57.5343202,
                29.2734394
              ],
              [
                57.5379335,
                29.2734394
              ],
              [
                57.5498732,
                29.2762162
              ],
              [
                57.5532064,
                29.277325
              ],
              [
                57.5626532,
                29.2803812
              ],
              [
                57.5690466,
                29.2834375
              ],
              [
                57.601546,
                29.3123235
              ],
              [
                57.6026594,
                29.3137209
              ],
              [
                57.6040461,
                29.3153888
              ],
              [
                57.6087657,
                29.321213
              ],
              [
                57.6154327,
                29.3298321
              ],
              [
                57.6237657,
                29.3442756
              ],
              [
                57.6290458,
                29.3492705
              ],
              [
                57.6365456,
                29.3520474
              ],
              [
                57.6371058,
                29.3520474
              ],
              [
                57.6376589,
                29.3523269
              ],
              [
                57.638212,
                29.3523269
              ],
              [
                57.6384921,
                29.3526064
              ],
              [
                57.6398788,
                29.3526065
              ],
              [
                57.6401589,
                29.3528859
              ],
              [
                57.6412723,
                29.3528859
              ],
              [
                57.6432121,
                29.3534359
              ],
              [
                57.6434922,
                29.3537154
              ],
              [
                57.6451586,
                29.3539949
              ],
              [
                57.6665449,
                29.3576013
              ],
              [
                57.6673786,
                29.3578808
              ],
              [
                57.6676583,
                29.3576013
              ],
              [
                57.6682184,
                29.3578808
              ],
              [
                57.6718252,
                29.3578808
              ],
              [
                57.6723853,
                29.3576013
              ],
              [
                57.6751584,
                29.3576013
              ],
              [
                57.6757186,
                29.3573308
              ],
              [
                57.7012713,
                29.3578808
              ],
              [
                57.7012713,
                29.3584397
              ],
              [
                57.7012713,
                29.3595488
              ],
              [
                57.7009912,
                29.3603872
              ],
              [
                57.7012714,
                29.3614962
              ],
              [
                57.7012714,
                29.3617757
              ],
              [
                57.7023847,
                29.3653822
              ],
              [
                57.7101645,
                29.3787172
              ],
              [
                57.7357174,
                29.4053877
              ],
              [
                57.7384975,
                29.4084443
              ],
              [
                57.7898903,
                29.4512196
              ],
              [
                57.7921103,
                29.4528876
              ],
              [
                57.8415561,
                29.4928873
              ],
              [
                57.8426695,
                29.494826
              ],
              [
                57.8435027,
                29.4956646
              ],
              [
                57.8437761,
                29.4965032
              ],
              [
                57.8446094,
                29.4973328
              ],
              [
                57.8451695,
                29.499001
              ],
              [
                57.8535025,
                29.5126081
              ],
              [
                57.8546092,
                29.5159446
              ],
              [
                57.8546091,
                29.5162241
              ],
              [
                57.8593359,
                29.5378842
              ],
              [
                57.8596159,
                29.539832
              ],
              [
                57.8598894,
                29.5417798
              ],
              [
                57.859616,
                29.5501121
              ],
              [
                57.8590558,
                29.5517804
              ],
              [
                57.8590559,
                29.5567762
              ],
              [
                57.8587828,
                29.5609424
              ],
              [
                57.8585027,
                29.5615015
              ],
              [
                57.8587827,
                29.5623311
              ],
              [
                57.8579496,
                29.572891
              ],
              [
                57.8579496,
                29.5748299
              ],
              [
                57.8579496,
                29.5853899
              ],
              [
                57.8582227,
                29.58594
              ],
              [
                57.8579496,
                29.5892767
              ],
              [
                57.8582227,
                29.5898358
              ],
              [
                57.8623892,
                29.6095583
              ],
              [
                57.8673893,
                29.6253853
              ],
              [
                57.8687826,
                29.6276128
              ],
              [
                57.8687827,
                29.6287221
              ],
              [
                57.887949,
                29.6231667
              ],
              [
                57.8904491,
                29.622328
              ],
              [
                57.9635077,
                29.5956613
              ],
              [
                57.9673945,
                29.5942816
              ],
              [
                57.9998939,
                29.5814939
              ],
              [
                58.0012873,
                29.5812234
              ],
              [
                58.0032272,
                29.5803848
              ],
              [
                58.0523999,
                29.5712224
              ],
              [
                58.0548996,
                29.5709429
              ],
              [
                58.0601798,
                29.5709429
              ],
              [
                58.0607329,
                29.5706633
              ],
              [
                58.0615665,
                29.5706634
              ],
              [
                58.0757328,
                29.5637196
              ],
              [
                58.1157318,
                29.5253855
              ],
              [
                58.1171256,
                29.5239968
              ],
              [
                58.1379584,
                29.5031666
              ],
              [
                58.1754578,
                29.457603
              ],
              [
                58.1779578,
                29.4551052
              ],
              [
                58.2112971,
                29.4281629
              ],
              [
                58.2568497,
                29.3942696
              ],
              [
                58.257963,
                29.3934401
              ],
              [
                58.260183,
                29.391213
              ],
              [
                58.2921292,
                29.3559414
              ],
              [
                58.302129,
                29.3412182
              ],
              [
                58.3057422,
                29.3389913
              ],
              [
                58.3065755,
                29.3389912
              ],
              [
                58.3074088,
                29.3389913
              ],
              [
                58.3079622,
                29.3389913
              ],
              [
                58.3210219,
                29.3426066
              ],
              [
                58.323802,
                29.3437156
              ],
              [
                58.3385219,
                29.3500989
              ],
              [
                58.3496349,
                29.3534348
              ],
              [
                58.3721346,
                29.3648312
              ],
              [
                58.382968,
                29.3720532
              ],
              [
                58.3846344,
                29.3731622
              ],
              [
                58.4418605,
                29.4106613
              ],
              [
                58.4424137,
                29.4106613
              ],
              [
                58.443807,
                29.4117703
              ],
              [
                58.4579734,
                29.4189926
              ],
              [
                58.45908,
                29.4192721
              ],
              [
                58.4993663,
                29.4459346
              ],
              [
                58.5001996,
                29.4464936
              ],
              [
                58.5046394,
                29.4467731
              ],
              [
                58.5051996,
                29.4470527
              ],
              [
                58.5060328,
                29.4470526
              ],
              [
                58.5263058,
                29.4562137
              ],
              [
                58.526866,
                29.4567729
              ],
              [
                58.5698815,
                29.4756231
              ],
              [
                58.5940915,
                29.4862224
              ],
              [
                58.5954783,
                29.4864929
              ],
              [
                58.5965915,
                29.4873316
              ],
              [
                58.605198,
                29.4909384
              ],
              [
                58.6063112,
                29.491777
              ],
              [
                58.6071445,
                29.4920475
              ],
              [
                58.6685371,
                29.5231663
              ],
              [
                58.6724239,
                29.5245549
              ],
              [
                58.6738173,
                29.5253846
              ],
              [
                58.7185365,
                29.5406602
              ],
              [
                58.7224299,
                29.5414988
              ],
              [
                58.7238162,
                29.542049
              ],
              [
                58.761876,
                29.5503812
              ],
              [
                58.8213215,
                29.5667754
              ],
              [
                58.8221552,
                29.5667754
              ],
              [
                58.8252083,
                29.5681642
              ],
              [
                58.8288217,
                29.5692733
              ],
              [
                58.8304881,
                29.570112
              ],
              [
                58.8368746,
                29.5720508
              ],
              [
                58.8374348,
                29.5723304
              ],
              [
                58.838268,
                29.5726099
              ],
              [
                58.8388215,
                29.5728895
              ],
              [
                58.8549347,
                29.5759375
              ],
              [
                58.8575306,
                29.5763107
              ],
              [
                58.8607676,
                29.5767761
              ],
              [
                58.8836798,
                29.5823644
              ],
              [
                58.913267,
                29.5895545
              ],
              [
                58.9152135,
                29.5895545
              ],
              [
                58.9221601,
                29.5906637
              ],
              [
                58.923827,
                29.5906636
              ],
              [
                58.9260469,
                29.5912228
              ],
              [
                58.9277133,
                29.5912227
              ],
              [
                58.9452133,
                29.5942799
              ],
              [
                58.9466067,
                29.5942799
              ],
              [
                58.9471598,
                29.5942799
              ],
              [
                58.9804925,
                29.5987167
              ],
              [
                58.981326,
                29.5989962
              ],
              [
                58.9838261,
                29.5989963
              ],
              [
                58.9924391,
                29.600385
              ],
              [
                58.9943858,
                29.600385
              ],
              [
                58.9971658,
                29.6009441
              ],
              [
                59.0010526,
                29.6009441
              ],
              [
                59.0110524,
                29.6017738
              ],
              [
                59.0124388,
                29.6020533
              ],
              [
                59.0199389,
                29.6020533
              ],
              [
                59.0293852,
                29.6031625
              ],
              [
                59.0304989,
                29.6034421
              ],
              [
                59.0341122,
                29.6034421
              ],
              [
                59.0427186,
                29.6042717
              ],
              [
                59.0429983,
                29.6045513
              ],
              [
                59.044112,
                29.6045513
              ],
              [
                59.0452183,
                29.6048309
              ],
              [
                59.0477183,
                29.6048309
              ],
              [
                59.0482785,
                29.6051104
              ],
              [
                59.0496652,
                29.6051104
              ],
              [
                59.0499449,
                29.60539
              ],
              [
                59.0518847,
                29.60539
              ],
              [
                59.0524449,
                29.6056605
              ],
              [
                59.0582782,
                29.60539
              ],
              [
                59.0591115,
                29.6051104
              ],
              [
                59.0635514,
                29.6051104
              ],
              [
                59.0643846,
                29.6048308
              ],
              [
                59.065778,
                29.6048308
              ],
              [
                59.0666117,
                29.6045513
              ],
              [
                59.068278,
                29.6045513
              ],
              [
                59.0693914,
                29.6042716
              ],
              [
                59.0716113,
                29.6042717
              ],
              [
                59.0718914,
                29.6040011
              ],
              [
                59.0746645,
                29.603442
              ],
              [
                59.0954977,
                29.5998347
              ],
              [
                59.0960579,
                29.5995552
              ],
              [
                59.0971641,
                29.5995551
              ],
              [
                59.0988309,
                29.598996
              ],
              [
                59.0996642,
                29.5989961
              ],
              [
                59.1032775,
                29.5976072
              ],
              [
                59.1357768,
                29.5776053
              ],
              [
                59.1396703,
                29.5751073
              ],
              [
                59.1543901,
                29.5662157
              ],
              [
                59.1668899,
                29.556774
              ],
              [
                59.1946693,
                29.5381615
              ],
              [
                59.1949493,
                29.5376114
              ],
              [
                59.2121691,
                29.5289997
              ],
              [
                59.2135625,
                29.5287201
              ],
              [
                59.2143957,
                29.528161
              ],
              [
                59.2177289,
                29.5267723
              ],
              [
                59.2396755,
                29.5173309
              ],
              [
                59.2541218,
                29.5117762
              ],
              [
                59.3055075,
                29.4887189
              ],
              [
                59.3094009,
                29.4870507
              ],
              [
                59.3149541,
                29.4845529
              ],
              [
                59.3519004,
                29.4706574
              ],
              [
                59.3557868,
                29.4695484
              ],
              [
                59.3674601,
                29.4648234
              ],
              [
                59.3988461,
                29.4548235
              ],
              [
                59.4018993,
                29.4537145
              ],
              [
                59.451072,
                29.4403874
              ],
              [
                59.4519053,
                29.4400989
              ],
              [
                59.4555186,
                29.4400989
              ],
              [
                59.4560721,
                29.4398284
              ],
              [
                59.4616249,
                29.4398284
              ],
              [
                59.4607917,
                29.4412169
              ],
              [
                59.4607917,
                29.4420465
              ],
              [
                59.4596851,
                29.4437146
              ],
              [
                59.4574585,
                29.461496
              ],
              [
                59.4580187,
                29.4662209
              ],
              [
                59.4580187,
                29.4717754
              ],
              [
                59.4580187,
                29.4720459
              ],
              [
                59.4577387,
                29.4801072
              ],
              [
                59.4552386,
                29.5042734
              ],
              [
                59.4560724,
                29.5728883
              ],
              [
                59.4563521,
                29.5745476
              ],
              [
                59.4560724,
                29.5773341
              ],
              [
                59.4563521,
                29.5789934
              ],
              [
                59.4560725,
                29.5881647
              ],
              [
                59.4557924,
                29.5917809
              ],
              [
                59.4519057,
                29.6109443
              ],
              [
                59.4519057,
                29.6114945
              ],
              [
                59.4499592,
                29.6214957
              ],
              [
                59.4499592,
                29.6239937
              ],
              [
                59.449126,
                29.6295489
              ],
              [
                59.4488525,
                29.6390003
              ],
              [
                59.4480194,
                29.6506611
              ],
              [
                59.4477394,
                29.6723327
              ],
              [
                59.4474593,
                29.6745513
              ],
              [
                59.4477394,
                29.6937251
              ],
              [
                59.4474593,
                29.6990011
              ],
              [
                59.4485727,
                29.7117809
              ],
              [
                59.4488528,
                29.7273296
              ],
              [
                59.4485727,
                29.7295574
              ],
              [
                59.4488528,
                29.7303872
              ],
              [
                59.4485728,
                29.7353927
              ],
              [
                59.4466263,
                29.7456656
              ],
              [
                59.4466262,
                29.7470545
              ],
              [
                59.4460728,
                29.7503916
              ],
              [
                59.4449594,
                29.7548381
              ],
              [
                59.4388466,
                29.8148358
              ],
              [
                59.4335736,
                29.8717785
              ],
              [
                59.4335736,
                29.8723377
              ],
              [
                59.4330135,
                29.8887273
              ],
              [
                59.43246,
                29.9020593
              ],
              [
                59.4321799,
                29.9078955
              ],
              [
                59.4327401,
                29.9103941
              ],
              [
                59.4341269,
                29.9192883
              ],
              [
                59.434407,
                29.9206684
              ],
              [
                59.43468,
                29.9231671
              ],
              [
                59.4349601,
                29.9256748
              ],
              [
                59.4352403,
                29.9290033
              ],
              [
                59.4355133,
                29.9312224
              ],
              [
                59.4399602,
                29.95123
              ],
              [
                59.4402404,
                29.9528989
              ],
              [
                59.4405134,
                29.9545587
              ],
              [
                59.4405134,
                29.9548383
              ],
              [
                59.4432935,
                29.9684506
              ],
              [
                59.446907,
                29.9809535
              ],
              [
                59.447187,
                29.9826134
              ],
              [
                59.4474601,
                29.9837319
              ],
              [
                59.4477402,
                29.9851121
              ],
              [
                59.4480202,
                29.9865013
              ],
              [
                59.4482934,
                29.9881703
              ],
              [
                59.4488535,
                29.9909486
              ],
              [
                59.449127,
                29.9926175
              ],
              [
                59.4494066,
                29.9934475
              ],
              [
                59.4474601,
                30.0000509
              ],
              [
                59.4449602,
                30.0176148
              ],
              [
                59.441627,
                30.0351159
              ],
              [
                59.4407937,
                30.0370645
              ],
              [
                59.4385738,
                30.0520669
              ],
              [
                59.4382937,
                30.0545659
              ],
              [
                59.4357937,
                30.0692797
              ],
              [
                59.4352405,
                30.0709488
              ],
              [
                59.4344074,
                30.0990059
              ],
              [
                59.4338473,
                30.1045631
              ],
              [
                59.4321805,
                30.1187273
              ],
              [
                59.4319074,
                30.120676
              ],
              [
                59.4319075,
                30.1234548
              ],
              [
                59.4316274,
                30.1287325
              ],
              [
                59.4313473,
                30.1301218
              ],
              [
                59.4316273,
                30.1312315
              ],
              [
                59.4313473,
                30.1348403
              ],
              [
                59.4305141,
                30.1381784
              ],
              [
                59.4296809,
                30.1445659
              ],
              [
                59.4294074,
                30.1456756
              ],
              [
                59.4296809,
                30.1515038
              ],
              [
                59.4291275,
                30.1787324
              ],
              [
                59.4285743,
                30.1845698
              ],
              [
                59.4263478,
                30.1926266
              ],
              [
                59.4263478,
                30.1934567
              ],
              [
                59.4260744,
                30.1937364
              ],
              [
                59.4260744,
                30.1945665
              ],
              [
                59.4257943,
                30.2090112
              ],
              [
                59.4257943,
                30.2115104
              ],
              [
                59.4260745,
                30.2348424
              ],
              [
                59.4249612,
                30.2526259
              ],
              [
                59.426348,
                30.2595734
              ],
              [
                59.4269078,
                30.2631824
              ],
              [
                59.4271812,
                30.2654019
              ],
              [
                59.4277414,
                30.2704005
              ],
              [
                59.4280145,
                30.2728999
              ],
              [
                59.4288476,
                30.2809572
              ],
              [
                59.4291277,
                30.2826264
              ],
              [
                59.4307946,
                30.2917936
              ],
              [
                59.4313477,
                30.2954027
              ],
              [
                59.432181,
                30.299842
              ],
              [
                59.4349611,
                30.3131779
              ],
              [
                59.4352413,
                30.3148471
              ],
              [
                59.4357944,
                30.3181767
              ],
              [
                59.4360745,
                30.320676
              ],
              [
                59.4363479,
                30.3242942
              ],
              [
                59.4385746,
                30.3359611
              ],
              [
                59.4388479,
                30.337901
              ],
              [
                59.4391277,
                30.3426292
              ],
              [
                59.4394079,
                30.345679
              ],
              [
                59.4410747,
                30.3579055
              ],
              [
                59.4413477,
                30.3595657
              ],
              [
                59.4416278,
                30.3620742
              ],
              [
                59.4419079,
                30.3648443
              ],
              [
                59.4421814,
                30.3687334
              ],
              [
                59.4432946,
                30.3745715
              ],
              [
                59.444408,
                30.3773417
              ],
              [
                59.4452412,
                30.3806803
              ],
              [
                59.4460745,
                30.3826203
              ],
              [
                59.4460745,
                30.3834595
              ],
              [
                59.4530212,
                30.4179021
              ],
              [
                59.4530211,
                30.4226305
              ],
              [
                59.4532946,
                30.4234606
              ],
              [
                59.4535747,
                30.4270701
              ],
              [
                59.4538547,
                30.4298494
              ],
              [
                59.4594081,
                30.4540149
              ],
              [
                59.4596878,
                30.4551248
              ],
              [
                59.4602413,
                30.4590141
              ],
              [
                59.4602413,
                30.460124
              ],
              [
                59.4663547,
                30.4826205
              ],
              [
                59.4666278,
                30.4834598
              ],
              [
                59.467188,
                30.4851292
              ],
              [
                59.4680212,
                30.4898487
              ],
              [
                59.4680213,
                30.4987374
              ],
              [
                59.4682947,
                30.4995767
              ],
              [
                59.4830583,
                30.5275894
              ],
              [
                59.468116,
                30.5427928
              ],
              [
                59.4582706,
                30.5535857
              ],
              [
                59.4348258,
                30.5827064
              ],
              [
                59.4165464,
                30.6010153
              ],
              [
                59.4029492,
                30.6145196
              ],
              [
                59.3818185,
                30.6373168
              ],
              [
                59.3697661,
                30.6489304
              ],
              [
                59.3536918,
                30.6646169
              ],
              [
                59.3141562,
                30.7069197
              ],
              [
                59.3094605,
                30.7118515
              ],
              [
                59.3036492,
                30.7214042
              ],
              [
                59.2981334,
                30.7303009
              ],
              [
                59.2903345,
                30.7481443
              ],
              [
                59.2819522,
                30.763829
              ],
              [
                59.2742169,
                30.7778027
              ],
              [
                59.2678069,
                30.7885207
              ],
              [
                59.263448,
                30.7938734
              ],
              [
                59.2412655,
                30.8108148
              ],
              [
                59.2329541,
                30.8176491
              ],
              [
                59.1885723,
                30.8645116
              ],
              [
                59.1608189,
                30.8911404
              ],
              [
                59.1434672,
                30.90644
              ],
              [
                59.0834423,
                30.95818
              ],
              [
                59.0439602,
                30.9855566
              ],
              [
                59.0195843,
                31.0182216
              ],
              [
                58.964309,
                31.0570522
              ],
              [
                58.8719555,
                31.1287874
              ],
              [
                58.8389965,
                31.1517078
              ],
              [
                58.8015744,
                31.1743289
              ],
              [
                58.7796014,
                31.1857846
              ],
              [
                58.7708471,
                31.1903365
              ],
              [
                58.7449261,
                31.1943015
              ],
              [
                58.7239834,
                31.2081036
              ],
              [
                58.6920544,
                31.226014
              ],
              [
                58.6661335,
                31.2475901
              ],
              [
                58.6391827,
                31.2808985
              ],
              [
                58.6053895,
                31.3194036
              ],
              [
                58.5880535,
                31.3353187
              ],
              [
                58.5737405,
                31.3367174
              ],
              [
                58.573467,
                31.3369975
              ],
              [
                58.4527574,
                31.4063972
              ],
              [
                58.3834395,
                31.4728265
              ],
              [
                58.3764929,
                31.4778278
              ],
              [
                58.3734397,
                31.4800577
              ],
              [
                58.3353417,
                31.5352382
              ],
              [
                58.3090669,
                31.54981
              ],
              [
                58.3043401,
                31.553141
              ],
              [
                58.2804538,
                31.5687031
              ],
              [
                58.2793405,
                31.5689739
              ],
              [
                58.2288615,
                31.5915793
              ],
              [
                58.2238615,
                31.5943506
              ],
              [
                58.1415761,
                31.6259887
              ],
              [
                58.1385158,
                31.627659
              ],
              [
                58.0723572,
                31.6521082
              ],
              [
                58.0712434,
                31.6529389
              ],
              [
                58.0212781,
                31.6688824
              ],
              [
                57.9937359,
                31.6761744
              ],
              [
                57.959747,
                31.6782196
              ],
              [
                57.9205686,
                31.6928896
              ],
              [
                57.9200156,
                31.6931694
              ],
              [
                57.8005542,
                31.7363406
              ],
              [
                57.7720245,
                31.7432724
              ],
              [
                57.7706312,
                31.7438322
              ],
              [
                57.7578321,
                31.7006882
              ],
              [
                57.7506402,
                31.7005402
              ],
              [
                57.7458216,
                31.707815
              ],
              [
                57.7476878,
                31.5503436
              ],
              [
                57.7478977,
                31.5391124
              ],
              [
                57.7470846,
                31.5273272
              ],
              [
                57.7483879,
                31.4991897
              ],
              [
                57.7437144,
                31.466139
              ],
              [
                57.7460208,
                31.4394362
              ],
              [
                57.7360012,
                31.4298704
              ],
              [
                57.7371078,
                31.4204273
              ],
              [
                57.7365547,
                31.3973701
              ],
              [
                57.7368348,
                31.3943187
              ],
              [
                57.7371078,
                31.3590383
              ],
              [
                57.735721,
                31.3401525
              ],
              [
                57.736001,
                31.3384823
              ],
              [
                57.7365546,
                31.3332012
              ],
              [
                57.7376678,
                31.3259791
              ],
              [
                57.7387745,
                31.3159855
              ],
              [
                57.7396077,
                31.3073732
              ],
              [
                57.7398877,
                31.2984812
              ],
              [
                57.7404408,
                31.2912592
              ],
              [
                57.7423873,
                31.247368
              ],
              [
                57.7429409,
                31.2468173
              ],
              [
                57.7429408,
                31.2462576
              ],
              [
                57.7426675,
                31.2459777
              ],
              [
                57.7426674,
                31.2440369
              ],
              [
                57.7423873,
                31.242096
              ],
              [
                57.7421076,
                31.240426
              ],
              [
                57.7418342,
                31.2387559
              ],
              [
                57.7437811,
                31.2251428
              ],
              [
                57.7446142,
                31.2101485
              ],
              [
                57.7446142,
                31.1976459
              ],
              [
                57.7457208,
                31.1859738
              ],
              [
                57.7543338,
                31.1193094
              ],
              [
                57.7546139,
                31.1154189
              ],
              [
                57.7554471,
                31.0987553
              ],
              [
                57.755167,
                31.0979158
              ],
              [
                57.7560005,
                31.0907034
              ],
              [
                57.7562802,
                31.0870837
              ],
              [
                57.7565537,
                31.0859734
              ],
              [
                57.7571138,
                31.080422
              ],
              [
                57.7568338,
                31.0795824
              ],
              [
                57.7571138,
                31.0784813
              ],
              [
                57.7568338,
                31.0745907
              ],
              [
                57.7535005,
                31.0640295
              ],
              [
                57.7526669,
                31.0629192
              ],
              [
                57.7390537,
                31.0395854
              ],
              [
                57.7146075,
                31.00709
              ],
              [
                57.7096073,
                31.0001939
              ],
              [
                57.6804411,
                30.9718061
              ],
              [
                57.6623814,
                30.9509735
              ],
              [
                57.6298819,
                30.9073594
              ],
              [
                57.6293287,
                30.9067997
              ],
              [
                57.6246016,
                30.898198
              ],
              [
                57.6240486,
                30.8979181
              ],
              [
                57.6123819,
                30.8737467
              ],
              [
                57.6121017,
                30.873476
              ],
              [
                57.5984956,
                30.8448642
              ],
              [
                57.5984956,
                30.842355
              ],
              [
                57.5979355,
                30.8406943
              ],
              [
                57.5971022,
                30.8393043
              ],
              [
                57.5968287,
                30.838474
              ],
              [
                57.5959955,
                30.8373638
              ],
              [
                57.5857157,
                30.814583
              ],
              [
                57.5854355,
                30.8143033
              ],
              [
                57.581269,
                30.8043029
              ],
              [
                57.5684891,
                30.7754123
              ],
              [
                57.5679359,
                30.7745819
              ],
              [
                57.5507093,
                30.7259717
              ],
              [
                57.5504359,
                30.7251323
              ],
              [
                57.5498757,
                30.7226324
              ],
              [
                57.5490425,
                30.7204122
              ],
              [
                57.5490425,
                30.7193021
              ],
              [
                57.5487695,
                30.7184718
              ],
              [
                57.5484894,
                30.718192
              ],
              [
                57.547376,
                30.7145819
              ],
              [
                57.5473761,
                30.7137426
              ],
              [
                57.5459893,
                30.713192
              ],
              [
                57.5334895,
                30.7084719
              ],
              [
                57.5332094,
                30.7079124
              ],
              [
                57.511823,
                30.6965228
              ],
              [
                57.5045963,
                30.6920825
              ],
              [
                57.4818236,
                30.6826333
              ],
              [
                57.4784833,
                30.6812434
              ],
              [
                57.4223709,
                30.6548547
              ],
              [
                57.4187646,
                30.6537447
              ],
              [
                57.4176509,
                30.6537446
              ],
              [
                57.4173712,
                30.6534648
              ],
              [
                57.4062648,
                30.6501347
              ],
              [
                57.3768184,
                30.6392959
              ],
              [
                57.3723714,
                30.6379152
              ],
              [
                57.3476452,
                30.6301359
              ],
              [
                57.3404256,
                30.6281865
              ],
              [
                57.2812563,
                30.6098575
              ],
              [
                57.2795896,
                30.609298
              ],
              [
                57.2181972,
                30.5873593
              ],
              [
                57.2176404,
                30.5867999
              ],
              [
                57.2168072,
                30.5865201
              ],
              [
                57.2145873,
                30.5854101
              ],
              [
                57.1684744,
                30.5640222
              ],
              [
                57.1676377,
                30.5640222
              ],
              [
                57.1651378,
                30.5629123
              ],
              [
                57.1643044,
                30.5626324
              ],
              [
                57.1629179,
                30.5626324
              ],
              [
                57.1626378,
                30.5634718
              ],
              [
                57.1245819,
                30.6137474
              ],
              [
                57.1226386,
                30.6159674
              ],
              [
                57.0926356,
                30.6401357
              ],
              [
                57.0754127,
                30.6565247
              ],
              [
                57.0734693,
                30.658474
              ],
              [
                57.0731893,
                30.6590245
              ],
              [
                57.056523,
                30.6795834
              ],
              [
                57.0548563,
                30.6826338
              ],
              [
                57.0542996,
                30.6856933
              ],
              [
                57.0534662,
                30.6851337
              ],
              [
                57.0498564,
                30.6834731
              ],
              [
                57.0462464,
                30.6829136
              ],
              [
                57.0440231,
                30.6829135
              ],
              [
                57.0398563,
                30.6818035
              ],
              [
                57.0026337,
                30.6581943
              ],
              [
                57.0018004,
                30.6576348
              ],
              [
                57.0012438,
                30.6576348
              ],
              [
                57.0001439,
                30.6570843
              ],
              [
                56.9951303,
                30.6554147
              ],
              [
                56.9942972,
                30.6554147
              ],
              [
                56.974854,
                30.6454153
              ],
              [
                56.9745742,
                30.6451355
              ],
              [
                56.9737407,
                30.6451355
              ],
              [
                56.9681874,
                30.6429063
              ],
              [
                56.9676308,
                30.6429064
              ],
              [
                56.9673543,
                30.6448557
              ],
              [
                56.9673543,
                30.6454153
              ],
              [
                56.9631876,
                30.6631942
              ],
              [
                56.9545744,
                30.6815239
              ],
              [
                56.9523511,
                30.6881934
              ],
              [
                56.9520745,
                30.6884731
              ],
              [
                56.9490179,
                30.6990234
              ],
              [
                56.9388649,
                30.7161568
              ],
              [
                56.9356846,
                30.721523
              ],
              [
                56.935128,
                30.721523
              ],
              [
                56.9348514,
                30.7218027
              ],
              [
                56.9301281,
                30.7218027
              ],
              [
                56.9298515,
                30.721523
              ],
              [
                56.9281848,
                30.721523
              ],
              [
                56.9254083,
                30.7209724
              ],
              [
                56.9248517,
                30.7206927
              ],
              [
                56.9240182,
                30.7206927
              ],
              [
                56.923185,
                30.7204129
              ],
              [
                56.9134618,
                30.7187523
              ],
              [
                56.9112385,
                30.7181927
              ],
              [
                56.9084618,
                30.7181928
              ],
              [
                56.9081851,
                30.717913
              ],
              [
                56.9067953,
                30.717913
              ],
              [
                56.9056852,
                30.7181927
              ],
              [
                56.8951286,
                30.7181928
              ],
              [
                56.8942954,
                30.7184725
              ],
              [
                56.8898487,
                30.7184726
              ],
              [
                56.8890154,
                30.7187523
              ],
              [
                56.8854054,
                30.7187524
              ],
              [
                56.8831821,
                30.7190231
              ],
              [
                56.8826255,
                30.7193028
              ],
              [
                56.8770723,
                30.7193029
              ],
              [
                56.8765156,
                30.7190231
              ],
              [
                56.8706822,
                30.7190231
              ],
              [
                56.8701256,
                30.7190231
              ],
              [
                56.8701256,
                30.7184726
              ],
              [
                56.8704056,
                30.717913
              ],
              [
                56.870959,
                30.7095828
              ],
              [
                56.8662389,
                30.6968033
              ],
              [
                56.8631825,
                30.693464
              ],
              [
                56.862349,
                30.6931933
              ],
              [
                56.8484593,
                30.6859733
              ],
              [
                56.8476259,
                30.6856935
              ],
              [
                56.8467927,
                30.6848632
              ],
              [
                56.8462359,
                30.6845834
              ],
              [
                56.8459593,
                30.6843037
              ],
              [
                56.8454026,
                30.6843037
              ],
              [
                56.8454026,
                30.6840239
              ],
              [
                56.8420694,
                30.6806936
              ],
              [
                56.8417928,
                30.6798634
              ],
              [
                56.8409594,
                30.6790241
              ],
              [
                56.8406793,
                30.6781938
              ],
              [
                56.8329028,
                30.6723636
              ],
              [
                56.810123,
                30.6590248
              ],
              [
                56.8084564,
                30.6568048
              ],
              [
                56.8073464,
                30.6559745
              ],
              [
                56.8065132,
                30.6554149
              ],
              [
                56.7940133,
                30.6504152
              ],
              [
                56.7923467,
                30.6504151
              ],
              [
                56.7917901,
                30.6501354
              ],
              [
                56.7906801,
                30.6501354
              ],
              [
                56.7904,
                30.6498557
              ],
              [
                56.7892901,
                30.6498557
              ],
              [
                56.7884567,
                30.6495759
              ],
              [
                56.78401,
                30.6490253
              ],
              [
                56.7792902,
                30.6490254
              ],
              [
                56.7729002,
                30.6509657
              ],
              [
                56.7717869,
                30.6509657
              ],
              [
                56.7598437,
                30.6534656
              ],
              [
                56.7584539,
                30.6534656
              ],
              [
                56.7409541,
                30.660135
              ],
              [
                56.7390108,
                30.6606946
              ],
              [
                56.7259543,
                30.6670841
              ],
              [
                56.7134511,
                30.6773636
              ],
              [
                56.7126177,
                30.6770838
              ],
              [
                56.7120646,
                30.6769722
              ],
              [
                56.7112312,
                30.676804
              ],
              [
                56.7034514,
                30.6751344
              ],
              [
                56.7015079,
                30.6748637
              ],
              [
                56.7012314,
                30.674584
              ],
              [
                56.7006747,
                30.6745839
              ],
              [
                56.6812283,
                30.6670842
              ],
              [
                56.6531721,
                30.6556949
              ],
              [
                56.6520621,
                30.6551353
              ],
              [
                56.651782,
                30.6548555
              ],
              [
                56.650672,
                30.6548556
              ],
              [
                56.6503955,
                30.6551353
              ],
              [
                56.6495621,
                30.6551353
              ],
              [
                56.6456721,
                30.6609744
              ],
              [
                56.6417823,
                30.6701347
              ],
              [
                56.6278924,
                30.6845836
              ],
              [
                56.6267824,
                30.6851342
              ],
              [
                56.6167826,
                30.6920835
              ],
              [
                56.615116,
                30.6940238
              ],
              [
                56.609836,
                30.6987439
              ],
              [
                56.6048361,
                30.7009731
              ],
              [
                56.6040027,
                30.7009731
              ],
              [
                56.6037261,
                30.7012529
              ],
              [
                56.6028928,
                30.7012529
              ],
              [
                56.6006694,
                30.7018034
              ],
              [
                56.5990027,
                30.7018034
              ],
              [
                56.5984461,
                30.7015237
              ],
              [
                56.5976128,
                30.7015237
              ],
              [
                56.5967795,
                30.7018034
              ],
              [
                56.5934462,
                30.7018035
              ],
              [
                56.5923362,
                30.7015237
              ],
              [
                56.587893,
                30.7012529
              ],
              [
                56.5740033,
                30.6948542
              ],
              [
                56.5723367,
                30.6948542
              ],
              [
                56.5681699,
                30.6934643
              ],
              [
                56.5673367,
                30.6929138
              ],
              [
                56.5656701,
                30.6920834
              ],
              [
                56.5634466,
                30.6904139
              ],
              [
                56.5473335,
                30.673474
              ],
              [
                56.5470569,
                30.6729144
              ],
              [
                56.5467805,
                30.6726349
              ],
              [
                56.5465001,
                30.6723639
              ],
              [
                56.5403903,
                30.6659743
              ],
              [
                56.5401101,
                30.6651349
              ],
              [
                56.5215005,
                30.6451359
              ],
              [
                56.5223339,
                30.6445764
              ],
              [
                56.5345569,
                30.6218069
              ],
              [
                56.5406668,
                30.6023589
              ],
              [
                56.5406668,
                30.6015287
              ],
              [
                56.5415002,
                30.5973502
              ],
              [
                56.5428902,
                30.5945797
              ],
              [
                56.5451135,
                30.5843008
              ],
              [
                56.5456668,
                30.5801315
              ],
              [
                56.5465001,
                30.5565236
              ],
              [
                56.5459467,
                30.5523544
              ],
              [
                56.5456668,
                30.5487447
              ],
              [
                56.5453901,
                30.546245
              ],
              [
                56.5451134,
                30.5456855
              ],
              [
                56.5451134,
                30.5426352
              ],
              [
                56.5448334,
                30.5420757
              ],
              [
                56.54789,
                30.5187391
              ],
              [
                56.5501133,
                30.5084606
              ],
              [
                56.5503899,
                30.501801
              ],
              [
                56.5503899,
                30.4873535
              ],
              [
                56.5499151,
                30.484659
              ],
              [
                56.5477935,
                30.4801671
              ],
              [
                56.5462357,
                30.4763124
              ],
              [
                56.5464659,
                30.471094
              ],
              [
                56.5494063,
                30.4619085
              ],
              [
                56.5538733,
                30.4581618
              ],
              [
                56.5584517,
                30.4558529
              ],
              [
                56.5604093,
                30.4548657
              ],
              [
                56.5658688,
                30.452112
              ],
              [
                56.5706541,
                30.4484264
              ],
              [
                56.5797521,
                30.4443232
              ],
              [
                56.5962429,
                30.4423422
              ],
              [
                56.6083709,
                30.4424729
              ],
              [
                56.6163751,
                30.4449234
              ],
              [
                56.6310455,
                30.4494129
              ],
              [
                56.6427205,
                30.4529842
              ],
              [
                56.6480176,
                30.4575159
              ],
              [
                56.6530323,
                30.4618054
              ],
              [
                56.6579604,
                30.4684083
              ],
              [
                56.6626228,
                30.4783782
              ],
              [
                56.6908225,
                30.5000242
              ],
              [
                56.6921559,
                30.5012837
              ],
              [
                56.691679,
                30.4957792
              ],
              [
                56.6894901,
                30.4901624
              ],
              [
                56.6880944,
                30.4812833
              ],
              [
                56.6878945,
                30.4806846
              ],
              [
                56.6776181,
                30.456239
              ],
              [
                56.6759516,
                30.4501299
              ],
              [
                56.6740047,
                30.4443005
              ],
              [
                56.6728948,
                30.4404023
              ],
              [
                56.6520618,
                30.378185
              ],
              [
                56.651551,
                30.3763793
              ],
              [
                56.6484484,
                30.365408
              ],
              [
                56.6481718,
                30.3641587
              ],
              [
                56.647895,
                30.3629085
              ],
              [
                56.6467817,
                30.35763
              ],
              [
                56.6465051,
                30.3573502
              ],
              [
                56.6376151,
                30.3356856
              ],
              [
                56.6373385,
                30.3348464
              ],
              [
                56.6370584,
                30.3337365
              ],
              [
                56.6331719,
                30.3270685
              ],
              [
                56.6320586,
                30.3262384
              ],
              [
                56.6298386,
                30.325679
              ],
              [
                56.6290054,
                30.3254083
              ],
              [
                56.628172,
                30.325679
              ],
              [
                56.6228919,
                30.3256789
              ],
              [
                56.6226154,
                30.3259587
              ],
              [
                56.621782,
                30.3259587
              ],
              [
                56.6212253,
                30.3262384
              ],
              [
                56.6201154,
                30.3262384
              ],
              [
                56.6192822,
                30.3265181
              ],
              [
                56.6181686,
                30.3265181
              ],
              [
                56.6128921,
                30.3279077
              ],
              [
                56.6120588,
                30.3284581
              ],
              [
                56.6090023,
                30.3298476
              ],
              [
                56.6070588,
                30.3315169
              ],
              [
                56.5842792,
                30.3437343
              ],
              [
                56.5828927,
                30.344014
              ],
              [
                56.5820559,
                30.344014
              ],
              [
                56.5817793,
                30.3442937
              ],
              [
                56.5806693,
                30.3442937
              ],
              [
                56.5798359,
                30.3445734
              ],
              [
                56.5787226,
                30.3445734
              ],
              [
                56.5781693,
                30.3448531
              ],
              [
                56.5740028,
                30.3448531
              ],
              [
                56.5734461,
                30.3445734
              ],
              [
                56.5720562,
                30.3445734
              ],
              [
                56.5720561,
                30.344014
              ],
              [
                56.5717795,
                30.3437343
              ],
              [
                56.5640029,
                30.3323471
              ],
              [
                56.5245534,
                30.2929077
              ],
              [
                56.4992771,
                30.2717943
              ],
              [
                56.4976105,
                30.2709552
              ],
              [
                56.491497,
                30.2659567
              ],
              [
                56.4870538,
                30.2626273
              ],
              [
                56.4806641,
                30.257349
              ],
              [
                56.4378845,
                30.2323475
              ],
              [
                56.3845486,
                30.2109554
              ],
              [
                56.3837154,
                30.2109553
              ],
              [
                56.3714921,
                30.2073464
              ],
              [
                56.366769,
                30.2062367
              ],
              [
                56.3598257,
                30.2042969
              ],
              [
                56.358159,
                30.2034579
              ],
              [
                56.2978764,
                30.1817955
              ],
              [
                56.2973233,
                30.1817955
              ],
              [
                56.2967665,
                30.1812361
              ],
              [
                56.2962099,
                30.1812361
              ],
              [
                56.2959333,
                30.1809564
              ],
              [
                56.2953767,
                30.1806767
              ],
              [
                56.2931566,
                30.1792963
              ],
              [
                56.28899,
                30.1776273
              ],
              [
                56.2587105,
                30.1651226
              ],
              [
                56.2578771,
                30.1651226
              ],
              [
                56.2570439,
                30.1645723
              ],
              [
                56.2562105,
                30.1645722
              ],
              [
                56.2484307,
                30.1617935
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555177,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کهنوج",
          "name:en": "Kahnuj County",
          "place": "county",
          "population": "95848",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1286542",
          "wikipedia": "en:Kahnuj County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.2738875,
                27.9801011
              ],
              [
                57.2796908,
                27.9723154
              ],
              [
                57.2860806,
                27.9709302
              ],
              [
                57.286306,
                27.9709021
              ],
              [
                57.357961,
                27.8932051
              ],
              [
                57.3588814,
                27.8930208
              ],
              [
                57.3593543,
                27.8929261
              ],
              [
                57.3593729,
                27.8929261
              ],
              [
                57.4076668,
                27.8254264
              ],
              [
                57.41294,
                27.8229249
              ],
              [
                57.4134884,
                27.8229249
              ],
              [
                57.4140533,
                27.8229249
              ],
              [
                57.4143294,
                27.8227402
              ],
              [
                57.4148869,
                27.8223671
              ],
              [
                57.4157472,
                27.8222343
              ],
              [
                57.4185002,
                27.8218092
              ],
              [
                57.43922,
                27.8130143
              ],
              [
                57.4328698,
                27.8057087
              ],
              [
                57.43931,
                27.8030586
              ],
              [
                57.4747004,
                27.7910374
              ],
              [
                57.4807262,
                27.7987674
              ],
              [
                57.4860477,
                27.8018044
              ],
              [
                57.4972915,
                27.8022599
              ],
              [
                57.513063,
                27.7980243
              ],
              [
                57.5103377,
                27.7666465
              ],
              [
                57.5090269,
                27.7620764
              ],
              [
                57.5073265,
                27.7492837
              ],
              [
                57.5074767,
                27.7303672
              ],
              [
                57.5074049,
                27.7165647
              ],
              [
                57.5013264,
                27.674475
              ],
              [
                57.5126406,
                27.6772949
              ],
              [
                57.5290236,
                27.6814689
              ],
              [
                57.535572,
                27.6835282
              ],
              [
                57.5335979,
                27.6728869
              ],
              [
                57.5311088,
                27.6557827
              ],
              [
                57.5290334,
                27.6444166
              ],
              [
                57.5885386,
                27.6167115
              ],
              [
                57.6456112,
                27.5900291
              ],
              [
                57.6927183,
                27.5873509
              ],
              [
                57.7368607,
                27.5884464
              ],
              [
                57.7646882,
                27.5894594
              ],
              [
                57.7645397,
                27.6023665
              ],
              [
                57.7638309,
                27.607479
              ],
              [
                57.7649467,
                27.6130298
              ],
              [
                57.7665139,
                27.617365
              ],
              [
                57.770844,
                27.6354463
              ],
              [
                57.7782138,
                27.6561754
              ],
              [
                57.7782138,
                27.662294
              ],
              [
                57.7787736,
                27.6678458
              ],
              [
                57.7747506,
                27.6894472
              ],
              [
                57.7785355,
                27.704115
              ],
              [
                57.7837572,
                27.7258604
              ],
              [
                57.7843107,
                27.7472437
              ],
              [
                57.7774825,
                27.7613225
              ],
              [
                57.7731528,
                27.778943
              ],
              [
                57.7705277,
                27.7901875
              ],
              [
                57.768946,
                27.8020248
              ],
              [
                57.7658763,
                27.8181139
              ],
              [
                57.8407199,
                27.8295142
              ],
              [
                57.8421063,
                27.8303512
              ],
              [
                57.8532198,
                27.8361832
              ],
              [
                57.9148919,
                27.8792413
              ],
              [
                57.920165,
                27.8822926
              ],
              [
                57.9212784,
                27.8834087
              ],
              [
                57.9204452,
                27.8845248
              ],
              [
                57.9198921,
                27.8847948
              ],
              [
                57.919892,
                27.8850739
              ],
              [
                57.9151654,
                27.8906274
              ],
              [
                57.9151654,
                27.8909064
              ],
              [
                57.912392,
                27.8928506
              ],
              [
                57.8737796,
                27.9367403
              ],
              [
                57.8718328,
                27.9389636
              ],
              [
                57.8715526,
                27.9395217
              ],
              [
                57.8925594,
                27.954932
              ],
              [
                57.8601479,
                27.9711659
              ],
              [
                57.8410416,
                27.9885639
              ],
              [
                57.8280787,
                28.0051596
              ],
              [
                57.8232763,
                28.0083456
              ],
              [
                57.8205298,
                28.0119829
              ],
              [
                57.835121,
                28.0228941
              ],
              [
                57.84122,
                28.0272038
              ],
              [
                57.8590865,
                28.0472213
              ],
              [
                57.8637027,
                28.064634
              ],
              [
                57.8666482,
                28.0707587
              ],
              [
                57.8692613,
                28.0827299
              ],
              [
                57.8722,
                28.1051464
              ],
              [
                57.8725432,
                28.1097964
              ],
              [
                57.8715348,
                28.1144015
              ],
              [
                57.8695016,
                28.1186099
              ],
              [
                57.8675848,
                28.1282533
              ],
              [
                57.8684018,
                28.1319444
              ],
              [
                57.867136,
                28.1352747
              ],
              [
                57.8648186,
                28.137394
              ],
              [
                57.8618572,
                28.1382456
              ],
              [
                57.8531883,
                28.1401756
              ],
              [
                57.8518902,
                28.1416135
              ],
              [
                57.852212,
                28.1432124
              ],
              [
                57.8538751,
                28.1441678
              ],
              [
                57.8648184,
                28.1461735
              ],
              [
                57.8649901,
                28.1498061
              ],
              [
                57.8607844,
                28.1566168
              ],
              [
                57.8522287,
                28.1750934
              ],
              [
                57.8528881,
                28.1770089
              ],
              [
                57.8528265,
                28.1796195
              ],
              [
                57.8555488,
                28.1816618
              ],
              [
                57.8578727,
                28.1847816
              ],
              [
                57.8525166,
                28.1882215
              ],
              [
                57.8282304,
                28.2150032
              ],
              [
                57.8214311,
                28.2248664
              ],
              [
                57.7905059,
                28.1913193
              ],
              [
                57.7759411,
                28.1697043
              ],
              [
                57.7595264,
                28.1406814
              ],
              [
                57.7534102,
                28.1280085
              ],
              [
                57.7415655,
                28.1137771
              ],
              [
                57.7334975,
                28.106055
              ],
              [
                57.7268027,
                28.103708
              ],
              [
                57.7217513,
                28.103165
              ],
              [
                57.7152156,
                28.1052979
              ],
              [
                57.7079106,
                28.1098987
              ],
              [
                57.6914728,
                28.1017698
              ],
              [
                57.6666183,
                28.0901039
              ],
              [
                57.6391617,
                28.0760392
              ],
              [
                57.6193606,
                28.0668481
              ],
              [
                57.5248718,
                28.0159125
              ],
              [
                57.5095918,
                28.0117444
              ],
              [
                57.4907056,
                28.0081345
              ],
              [
                57.4795925,
                28.0064691
              ],
              [
                57.4757057,
                28.005911
              ],
              [
                57.4732057,
                28.005911
              ],
              [
                57.4701458,
                28.0053529
              ],
              [
                57.4662591,
                28.0050828
              ],
              [
                57.4501463,
                28.0050827
              ],
              [
                57.4454263,
                28.005632
              ],
              [
                57.4423731,
                28.0056319
              ],
              [
                57.4229267,
                28.0073064
              ],
              [
                57.4095936,
                28.0086928
              ],
              [
                57.4090335,
                28.0084137
              ],
              [
                57.4082003,
                28.0084137
              ],
              [
                57.4079268,
                28.0086927
              ],
              [
                57.4068135,
                28.0081346
              ],
              [
                57.4054267,
                28.0081346
              ],
              [
                57.404867,
                28.0078555
              ],
              [
                57.4043135,
                28.0078555
              ],
              [
                57.4029201,
                28.0073064
              ],
              [
                57.4023669,
                28.0073065
              ],
              [
                57.4015338,
                28.0070184
              ],
              [
                57.3818138,
                28.0025803
              ],
              [
                57.3759806,
                27.9997986
              ],
              [
                57.3593075,
                27.9861874
              ],
              [
                57.2730541,
                27.9834289
              ],
              [
                57.2738516,
                27.9802447
              ],
              [
                57.2738875,
                27.9801011
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555181,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوهبنان",
          "name:en": "Kuhbanan County",
          "place": "county",
          "population": "21205",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q2610488",
          "wikipedia": "en:Kuhbanan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.7597987,
                31.2848698
              ],
              [
                55.7605648,
                31.2844908
              ],
              [
                55.7609119,
                31.2843191
              ],
              [
                55.7620219,
                31.2843191
              ],
              [
                55.7622987,
                31.2840393
              ],
              [
                55.7642454,
                31.2840392
              ],
              [
                55.764522,
                31.2837594
              ],
              [
                55.7670218,
                31.2837594
              ],
              [
                55.7798017,
                31.2820983
              ],
              [
                55.7806351,
                31.2818185
              ],
              [
                55.7845216,
                31.2818185
              ],
              [
                55.7848016,
                31.2815386
              ],
              [
                55.785635,
                31.2818185
              ],
              [
                55.7864683,
                31.2815386
              ],
              [
                55.7917449,
                31.2815386
              ],
              [
                55.7923016,
                31.2812588
              ],
              [
                55.7945249,
                31.2812588
              ],
              [
                55.8100814,
                31.2812587
              ],
              [
                55.828971,
                31.2823691
              ],
              [
                55.8300811,
                31.2820983
              ],
              [
                55.8303578,
                31.2823691
              ],
              [
                55.8348043,
                31.2820983
              ],
              [
                55.8353577,
                31.2818184
              ],
              [
                55.8375809,
                31.2818185
              ],
              [
                55.8536942,
                31.2787581
              ],
              [
                55.8553607,
                31.2787582
              ],
              [
                55.8581372,
                31.2782074
              ],
              [
                55.859804,
                31.2782075
              ],
              [
                55.861194,
                31.2779276
              ],
              [
                55.8634138,
                31.2779276
              ],
              [
                55.8648039,
                31.2776478
              ],
              [
                55.8684173,
                31.2776477
              ],
              [
                55.8698038,
                31.2773769
              ],
              [
                55.8798036,
                31.2773769
              ],
              [
                55.8803602,
                31.277088
              ],
              [
                55.8839703,
                31.277088
              ],
              [
                55.8875837,
                31.277088
              ],
              [
                55.9020267,
                31.2776478
              ],
              [
                55.9036967,
                31.2779276
              ],
              [
                55.9153632,
                31.2779276
              ],
              [
                55.9159164,
                31.2776476
              ],
              [
                55.9359195,
                31.2773769
              ],
              [
                55.9375862,
                31.277088
              ],
              [
                55.9417529,
                31.277088
              ],
              [
                55.9431429,
                31.2768172
              ],
              [
                55.9439762,
                31.277088
              ],
              [
                55.9459194,
                31.2768171
              ],
              [
                55.9464761,
                31.2770881
              ],
              [
                55.9659191,
                31.2757067
              ],
              [
                55.9678658,
                31.2754269
              ],
              [
                55.9703657,
                31.275427
              ],
              [
                55.970919,
                31.2751471
              ],
              [
                55.9748089,
                31.2751471
              ],
              [
                55.9917556,
                31.2737659
              ],
              [
                55.9931422,
                31.2740367
              ],
              [
                55.9953654,
                31.2740367
              ],
              [
                56.0284215,
                31.275147
              ],
              [
                56.0300883,
                31.2754268
              ],
              [
                56.0350882,
                31.2754269
              ],
              [
                56.0359248,
                31.2751471
              ],
              [
                56.0389781,
                31.275147
              ],
              [
                56.0403682,
                31.2754269
              ],
              [
                56.0509246,
                31.2754269
              ],
              [
                56.0834241,
                31.2737658
              ],
              [
                56.0839807,
                31.2734859
              ],
              [
                56.095094,
                31.2740366
              ],
              [
                56.0967606,
                31.2743164
              ],
              [
                56.101204,
                31.2743165
              ],
              [
                56.1059272,
                31.2737657
              ],
              [
                56.1064806,
                31.2740366
              ],
              [
                56.1076412,
                31.2740365
              ],
              [
                56.1100938,
                31.2740366
              ],
              [
                56.1216243,
                31.2690721
              ],
              [
                56.1302801,
                31.2497695
              ],
              [
                56.1623499,
                31.2002685
              ],
              [
                56.2131052,
                31.1703274
              ],
              [
                56.2237649,
                31.1594933
              ],
              [
                56.239044,
                31.1346237
              ],
              [
                56.2517164,
                31.1283464
              ],
              [
                56.2919536,
                31.1028
              ],
              [
                56.3160722,
                31.0877712
              ],
              [
                56.3362072,
                31.0622243
              ],
              [
                56.3640176,
                31.0326108
              ],
              [
                56.3682745,
                31.0279305
              ],
              [
                56.3761709,
                31.017633
              ],
              [
                56.3897942,
                31.0055331
              ],
              [
                56.4101599,
                31.0092471
              ],
              [
                56.4350508,
                31.010277
              ],
              [
                56.4369391,
                30.9871753
              ],
              [
                56.486034,
                30.9435318
              ],
              [
                56.4945315,
                30.9515553
              ],
              [
                56.505432,
                30.9648775
              ],
              [
                56.5116977,
                30.9715747
              ],
              [
                56.5201091,
                30.9786394
              ],
              [
                56.5270795,
                30.9860865
              ],
              [
                56.5129851,
                31.0111597
              ],
              [
                56.5002821,
                31.0319021
              ],
              [
                56.5016661,
                31.0416571
              ],
              [
                56.4858765,
                31.0409741
              ],
              [
                56.4727773,
                31.0498094
              ],
              [
                56.4539852,
                31.0585067
              ],
              [
                56.4473406,
                31.0651128
              ],
              [
                56.4432321,
                31.0779356
              ],
              [
                56.4566197,
                31.0787931
              ],
              [
                56.4799855,
                31.0820922
              ],
              [
                56.4910352,
                31.0878525
              ],
              [
                56.488472,
                31.1111353
              ],
              [
                56.4872591,
                31.1174249
              ],
              [
                56.4861887,
                31.1224859
              ],
              [
                56.4819401,
                31.1364448
              ],
              [
                56.4849272,
                31.157241
              ],
              [
                56.4861886,
                31.1654174
              ],
              [
                56.4861582,
                31.1716077
              ],
              [
                56.4892959,
                31.1749528
              ],
              [
                56.4925705,
                31.179488
              ],
              [
                56.4959884,
                31.1865578
              ],
              [
                56.4988231,
                31.190263
              ],
              [
                56.5001286,
                31.1924904
              ],
              [
                56.5044689,
                31.1949724
              ],
              [
                56.5073252,
                31.1969499
              ],
              [
                56.5117096,
                31.2006706
              ],
              [
                56.5180802,
                31.2056628
              ],
              [
                56.5269195,
                31.2107143
              ],
              [
                56.5372858,
                31.2141612
              ],
              [
                56.5418097,
                31.2152851
              ],
              [
                56.5469698,
                31.2166923
              ],
              [
                56.537361,
                31.2257203
              ],
              [
                56.5252414,
                31.2337531
              ],
              [
                56.5126417,
                31.2452417
              ],
              [
                56.502857,
                31.2503783
              ],
              [
                56.4948735,
                31.2561614
              ],
              [
                56.4901118,
                31.2593126
              ],
              [
                56.4845752,
                31.2651993
              ],
              [
                56.4819635,
                31.2717673
              ],
              [
                56.4416653,
                31.2623106
              ],
              [
                56.4314959,
                31.2873699
              ],
              [
                56.430106,
                31.2959821
              ],
              [
                56.430106,
                31.2962619
              ],
              [
                56.4291191,
                31.3067442
              ],
              [
                56.4283734,
                31.3170426
              ],
              [
                56.4374046,
                31.3367709
              ],
              [
                56.4378564,
                31.3460026
              ],
              [
                56.4396779,
                31.3562862
              ],
              [
                56.4377951,
                31.3644329
              ],
              [
                56.4407156,
                31.3715199
              ],
              [
                56.4422517,
                31.3813236
              ],
              [
                56.4461556,
                31.3933157
              ],
              [
                56.4561203,
                31.4258401
              ],
              [
                56.4591479,
                31.4355478
              ],
              [
                56.463891,
                31.4427106
              ],
              [
                56.4660559,
                31.4498987
              ],
              [
                56.470716,
                31.4644316
              ],
              [
                56.4739776,
                31.4772432
              ],
              [
                56.4747858,
                31.4883306
              ],
              [
                56.473521,
                31.4983203
              ],
              [
                56.4688194,
                31.5065963
              ],
              [
                56.4637745,
                31.5172094
              ],
              [
                56.4523816,
                31.53082
              ],
              [
                56.4444187,
                31.5385894
              ],
              [
                56.4368237,
                31.544669
              ],
              [
                56.4314473,
                31.5494777
              ],
              [
                56.4266394,
                31.5551339
              ],
              [
                56.4205994,
                31.5689348
              ],
              [
                56.4183678,
                31.5773249
              ],
              [
                56.4172743,
                31.5847245
              ],
              [
                56.4161778,
                31.5910291
              ],
              [
                56.416942,
                31.5953848
              ],
              [
                56.4202668,
                31.6073231
              ],
              [
                56.4229488,
                31.6126037
              ],
              [
                56.424322,
                31.6202052
              ],
              [
                56.426991,
                31.6276117
              ],
              [
                56.4352572,
                31.651652
              ],
              [
                56.4174349,
                31.6449523
              ],
              [
                56.4070477,
                31.6407776
              ],
              [
                56.3936885,
                31.6368209
              ],
              [
                56.3520302,
                31.6229366
              ],
              [
                56.3103174,
                31.6081753
              ],
              [
                56.2830354,
                31.5980256
              ],
              [
                56.2688126,
                31.5921038
              ],
              [
                56.2611479,
                31.574361
              ],
              [
                56.2581244,
                31.5685967
              ],
              [
                56.2548249,
                31.5671193
              ],
              [
                56.2488428,
                31.559294
              ],
              [
                56.2323858,
                31.5596597
              ],
              [
                56.2236759,
                31.5590635
              ],
              [
                56.1786707,
                31.5483183
              ],
              [
                56.1784286,
                31.5483171
              ],
              [
                56.1605022,
                31.5526083
              ],
              [
                56.1510771,
                31.5601186
              ],
              [
                56.1469394,
                31.566504
              ],
              [
                56.14341,
                31.5719498
              ],
              [
                56.1393405,
                31.5806838
              ],
              [
                56.1342837,
                31.5851004
              ],
              [
                56.1289493,
                31.5878262
              ],
              [
                56.1251592,
                31.5897145
              ],
              [
                56.1218783,
                31.5905063
              ],
              [
                56.1211953,
                31.5906712
              ],
              [
                56.115575,
                31.5908616
              ],
              [
                56.1137004,
                31.590709
              ],
              [
                56.1123872,
                31.5907155
              ],
              [
                56.1110169,
                31.5900845
              ],
              [
                56.1078044,
                31.5886051
              ],
              [
                56.0995661,
                31.5867636
              ],
              [
                56.0934911,
                31.5873453
              ],
              [
                56.0875442,
                31.5856679
              ],
              [
                56.0628098,
                31.5786875
              ],
              [
                56.059222,
                31.5765428
              ],
              [
                56.0581481,
                31.5765429
              ],
              [
                56.0567583,
                31.5762721
              ],
              [
                56.0537016,
                31.576272
              ],
              [
                56.053425,
                31.5759921
              ],
              [
                56.0525915,
                31.5759921
              ],
              [
                56.0489782,
                31.5751525
              ],
              [
                56.0420352,
                31.5734913
              ],
              [
                56.0350885,
                31.5704307
              ],
              [
                56.0292551,
                31.5648783
              ],
              [
                56.0289786,
                31.5640478
              ],
              [
                56.0259219,
                31.5593169
              ],
              [
                56.0239785,
                31.5543243
              ],
              [
                56.0223119,
                31.5448808
              ],
              [
                56.0220352,
                31.5429306
              ],
              [
                56.0217552,
                31.5409896
              ],
              [
                56.0214787,
                31.5384888
              ],
              [
                56.0212021,
                31.5357171
              ],
              [
                56.0209219,
                31.5259847
              ],
              [
                56.0206452,
                31.5218228
              ],
              [
                56.0200885,
                31.5090389
              ],
              [
                56.0198119,
                31.5084883
              ],
              [
                56.0200885,
                31.506818
              ],
              [
                56.0206451,
                31.4954336
              ],
              [
                56.0203686,
                31.4926529
              ],
              [
                56.0200885,
                31.490432
              ],
              [
                56.0198119,
                31.4876514
              ],
              [
                56.0195353,
                31.4868207
              ],
              [
                56.0195354,
                31.4854305
              ],
              [
                56.0181454,
                31.4773774
              ],
              [
                56.0178685,
                31.4759872
              ],
              [
                56.0128652,
                31.4648737
              ],
              [
                55.9964755,
                31.4484878
              ],
              [
                55.9670326,
                31.4329328
              ],
              [
                55.9656427,
                31.4315425
              ],
              [
                55.9639761,
                31.4307118
              ],
              [
                55.9592527,
                31.4248709
              ],
              [
                55.9564761,
                31.4195986
              ],
              [
                55.9556427,
                31.4176575
              ],
              [
                55.9556427,
                31.416818
              ],
              [
                55.9461962,
                31.395431
              ],
              [
                55.9450862,
                31.39182
              ],
              [
                55.9450862,
                31.3907095
              ],
              [
                55.9435367,
                31.3874806
              ],
              [
                55.9384197,
                31.3768158
              ],
              [
                55.9348064,
                31.3732047
              ],
              [
                55.9267531,
                31.3673728
              ],
              [
                55.8456376,
                31.3251505
              ],
              [
                55.8436909,
                31.3245998
              ],
              [
                55.8342477,
                31.3209888
              ],
              [
                55.8298045,
                31.318759
              ],
              [
                55.8231345,
                31.3148681
              ],
              [
                55.8203577,
                31.3132071
              ],
              [
                55.7728552,
                31.2912612
              ],
              [
                55.7659121,
                31.2884807
              ],
              [
                55.7656319,
                31.28793
              ],
              [
                55.7597987,
                31.2848698
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555215,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان منوجان",
          "name:en": "Manujan County",
          "place": "county",
          "population": "65705",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q1286524",
          "wikipedia": "en:Manujan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.2302418,
                27.6016704
              ],
              [
                57.2336196,
                27.5945656
              ],
              [
                57.237819,
                27.5882338
              ],
              [
                57.2497557,
                27.5895452
              ],
              [
                57.2554205,
                27.5877195
              ],
              [
                57.2803114,
                27.5846765
              ],
              [
                57.3046015,
                27.5885563
              ],
              [
                57.3082923,
                27.5833071
              ],
              [
                57.3175619,
                27.5810249
              ],
              [
                57.3275184,
                27.5795794
              ],
              [
                57.3353897,
                27.5721441
              ],
              [
                57.3400496,
                27.5661889
              ],
              [
                57.3438262,
                27.540088
              ],
              [
                57.333269,
                27.4990597
              ],
              [
                57.3282972,
                27.4853745
              ],
              [
                57.3317384,
                27.462383
              ],
              [
                57.3322785,
                27.4360582
              ],
              [
                57.3309684,
                27.4193102
              ],
              [
                57.3318088,
                27.4101936
              ],
              [
                57.3309801,
                27.4060738
              ],
              [
                57.3386764,
                27.394098
              ],
              [
                57.3462295,
                27.3880013
              ],
              [
                57.3621081,
                27.3776363
              ],
              [
                57.3922686,
                27.349494
              ],
              [
                57.4024434,
                27.3420127
              ],
              [
                57.4134204,
                27.3286425
              ],
              [
                57.4193717,
                27.3208861
              ],
              [
                57.4420162,
                27.2898757
              ],
              [
                57.4772505,
                27.2672613
              ],
              [
                57.4653622,
                27.2479152
              ],
              [
                57.4654287,
                27.2295862
              ],
              [
                57.4796104,
                27.2100605
              ],
              [
                57.4837435,
                27.1920264
              ],
              [
                57.4869442,
                27.1785271
              ],
              [
                57.490425,
                27.1653208
              ],
              [
                57.4918841,
                27.1605098
              ],
              [
                57.4926566,
                27.1526438
              ],
              [
                57.4929141,
                27.1465339
              ],
              [
                57.4948024,
                27.1358408
              ],
              [
                57.4952315,
                27.1318688
              ],
              [
                57.4967765,
                27.1262161
              ],
              [
                57.4992656,
                27.1205631
              ],
              [
                57.504501,
                27.115674
              ],
              [
                57.5111783,
                27.1003336
              ],
              [
                57.5153158,
                27.0886261
              ],
              [
                57.5378035,
                27.0721192
              ],
              [
                57.5582311,
                27.0672278
              ],
              [
                57.5693892,
                27.0643234
              ],
              [
                57.5798605,
                27.0612661
              ],
              [
                57.6070612,
                27.0545364
              ],
              [
                57.6271987,
                27.0484421
              ],
              [
                57.653275,
                27.0447196
              ],
              [
                57.6742685,
                27.0392305
              ],
              [
                57.6952125,
                27.0233273
              ],
              [
                57.7158199,
                27.0086424
              ],
              [
                57.7350361,
                27.0004818
              ],
              [
                57.7489197,
                26.9866903
              ],
              [
                57.7678296,
                26.9710379
              ],
              [
                57.8043826,
                26.9547373
              ],
              [
                57.8247564,
                26.9455638
              ],
              [
                57.8398415,
                26.9388288
              ],
              [
                57.8522735,
                26.9342066
              ],
              [
                57.8639789,
                26.9453072
              ],
              [
                57.8756177,
                26.954423
              ],
              [
                57.8892397,
                26.9642096
              ],
              [
                57.9012472,
                26.9735902
              ],
              [
                57.9173205,
                26.9887824
              ],
              [
                57.925261,
                26.9985364
              ],
              [
                57.9309344,
                27.0047981
              ],
              [
                57.9398043,
                27.0159879
              ],
              [
                57.9435034,
                27.0217295
              ],
              [
                57.9473898,
                27.0253341
              ],
              [
                57.969935,
                27.0583071
              ],
              [
                57.9929329,
                27.1016045
              ],
              [
                58.0032662,
                27.1209383
              ],
              [
                58.0198285,
                27.1492836
              ],
              [
                58.0295053,
                27.1795931
              ],
              [
                58.0260974,
                27.1878184
              ],
              [
                58.0105742,
                27.2283052
              ],
              [
                57.9945658,
                27.2777765
              ],
              [
                57.9957103,
                27.2962826
              ],
              [
                57.9996543,
                27.3142441
              ],
              [
                57.9782008,
                27.3285415
              ],
              [
                57.9709858,
                27.33174
              ],
              [
                57.9606055,
                27.3353276
              ],
              [
                57.9422615,
                27.3399096
              ],
              [
                57.9192374,
                27.3426674
              ],
              [
                57.8970094,
                27.3454121
              ],
              [
                57.8777912,
                27.3477449
              ],
              [
                57.8527935,
                27.3469178
              ],
              [
                57.8329269,
                27.3464541
              ],
              [
                57.8128928,
                27.3475215
              ],
              [
                57.7959015,
                27.3483234
              ],
              [
                57.7883308,
                27.4053261
              ],
              [
                57.7887374,
                27.4110635
              ],
              [
                57.7881225,
                27.4155564
              ],
              [
                57.786982,
                27.4205471
              ],
              [
                57.7857302,
                27.425789
              ],
              [
                57.7829337,
                27.4346757
              ],
              [
                57.778738,
                27.4490332
              ],
              [
                57.77721,
                27.4603747
              ],
              [
                57.7735574,
                27.472598
              ],
              [
                57.7738284,
                27.4840887
              ],
              [
                57.7728688,
                27.4952204
              ],
              [
                57.7716918,
                27.5011152
              ],
              [
                57.7710683,
                27.5115944
              ],
              [
                57.7691801,
                27.5282673
              ],
              [
                57.7696093,
                27.5411707
              ],
              [
                57.7680015,
                27.5462523
              ],
              [
                57.7676345,
                27.5542012
              ],
              [
                57.7669932,
                27.5599802
              ],
              [
                57.7664079,
                27.5644088
              ],
              [
                57.7659155,
                27.5719796
              ],
              [
                57.7654616,
                27.5830723
              ],
              [
                57.7646882,
                27.5894594
              ],
              [
                57.7368607,
                27.5884464
              ],
              [
                57.6927183,
                27.5873509
              ],
              [
                57.6456112,
                27.5900291
              ],
              [
                57.5885386,
                27.6167115
              ],
              [
                57.5290334,
                27.6444166
              ],
              [
                57.5311088,
                27.6557827
              ],
              [
                57.5335979,
                27.6728869
              ],
              [
                57.535572,
                27.6835282
              ],
              [
                57.5290236,
                27.6814689
              ],
              [
                57.5126406,
                27.6772949
              ],
              [
                57.5013264,
                27.674475
              ],
              [
                57.5074049,
                27.7165647
              ],
              [
                57.5074767,
                27.7303672
              ],
              [
                57.5073265,
                27.7492837
              ],
              [
                57.5090269,
                27.7620764
              ],
              [
                57.5103377,
                27.7666465
              ],
              [
                57.513063,
                27.7980243
              ],
              [
                57.4972915,
                27.8022599
              ],
              [
                57.4860477,
                27.8018044
              ],
              [
                57.4807262,
                27.7987674
              ],
              [
                57.4747004,
                27.7910374
              ],
              [
                57.4665963,
                27.7828675
              ],
              [
                57.4510801,
                27.7773089
              ],
              [
                57.4302529,
                27.7730101
              ],
              [
                57.4170398,
                27.7721904
              ],
              [
                57.4013947,
                27.7760793
              ],
              [
                57.4004185,
                27.7478263
              ],
              [
                57.3919178,
                27.7349036
              ],
              [
                57.3560305,
                27.7035217
              ],
              [
                57.3409077,
                27.6999443
              ],
              [
                57.3213383,
                27.70268
              ],
              [
                57.2850804,
                27.7148039
              ],
              [
                57.2834247,
                27.7158554
              ],
              [
                57.2837229,
                27.7085858
              ],
              [
                57.2839161,
                27.7024521
              ],
              [
                57.2811283,
                27.6969481
              ],
              [
                57.2741651,
                27.694163
              ],
              [
                57.2749042,
                27.6893424
              ],
              [
                57.2760122,
                27.6839315
              ],
              [
                57.2814528,
                27.6785314
              ],
              [
                57.2831942,
                27.6720788
              ],
              [
                57.28328,
                27.666732
              ],
              [
                57.280097,
                27.6621305
              ],
              [
                57.2716856,
                27.6596218
              ],
              [
                57.2526311,
                27.6573791
              ],
              [
                57.2487635,
                27.65822
              ],
              [
                57.2442624,
                27.6490925
              ],
              [
                57.2404858,
                27.6395124
              ],
              [
                57.2349068,
                27.6351022
              ],
              [
                57.223663,
                27.6322127
              ],
              [
                57.2220322,
                27.6201215
              ],
              [
                57.2302418,
                27.6016704
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555233,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نرماشیر",
          "name:en": "Narmashir County",
          "place": "county",
          "population": "54228",
          "population:date": "2016",
          "source:population": "www.amar.org.ir",
          "type": "boundary",
          "wikidata": "Q5099954",
          "wikipedia": "en:Narmashir County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                58.4963052,
                28.9725942
              ],
              [
                58.4977491,
                28.9504823
              ],
              [
                58.4983941,
                28.9406043
              ],
              [
                58.4991502,
                28.9328621
              ],
              [
                58.4972843,
                28.9122902
              ],
              [
                58.5009437,
                28.8992758
              ],
              [
                58.5020458,
                28.895356
              ],
              [
                58.5056313,
                28.8826022
              ],
              [
                58.5088574,
                28.8711257
              ],
              [
                58.512371,
                28.8690895
              ],
              [
                58.5156364,
                28.8671971
              ],
              [
                58.5272597,
                28.8604608
              ],
              [
                58.5310434,
                28.8614549
              ],
              [
                58.5445486,
                28.8650032
              ],
              [
                58.5512922,
                28.8667749
              ],
              [
                58.59381,
                28.8453709
              ],
              [
                58.6140897,
                28.8512013
              ],
              [
                58.6154764,
                28.8512012
              ],
              [
                58.6257563,
                28.8537065
              ],
              [
                58.6621492,
                28.8600955
              ],
              [
                58.663816,
                28.8600956
              ],
              [
                58.6646492,
                28.8603749
              ],
              [
                58.6827023,
                28.8603749
              ],
              [
                58.6849222,
                28.8600955
              ],
              [
                58.6899289,
                28.8600955
              ],
              [
                58.7063151,
                28.8587077
              ],
              [
                58.706774,
                28.8585539
              ],
              [
                58.7071484,
                28.8584284
              ],
              [
                58.7075124,
                28.8584284
              ],
              [
                58.7099285,
                28.8584283
              ],
              [
                58.7103149,
                28.8582332
              ],
              [
                58.7104817,
                28.8581489
              ],
              [
                58.7110414,
                28.8581489
              ],
              [
                58.7135348,
                28.8581489
              ],
              [
                58.7140917,
                28.858149
              ],
              [
                58.7199284,
                28.866755
              ],
              [
                58.7204814,
                28.8670344
              ],
              [
                58.7207615,
                28.8678725
              ],
              [
                58.7338149,
                28.8817595
              ],
              [
                58.7368748,
                28.8845352
              ],
              [
                58.7396478,
                28.8873107
              ],
              [
                58.7518746,
                28.8948176
              ],
              [
                58.7524278,
                28.8953764
              ],
              [
                58.7585411,
                28.8975934
              ],
              [
                58.7621475,
                28.8981521
              ],
              [
                58.7674277,
                28.898152
              ],
              [
                58.7685409,
                28.8984314
              ],
              [
                58.7713211,
                28.8984314
              ],
              [
                58.8015354,
                28.8890689
              ],
              [
                58.8010168,
                28.8969024
              ],
              [
                58.8031626,
                28.899091
              ],
              [
                58.808012,
                28.9063983
              ],
              [
                58.8112666,
                28.9162828
              ],
              [
                58.8027748,
                28.9196056
              ],
              [
                58.8036989,
                28.9253895
              ],
              [
                58.8070504,
                28.9463633
              ],
              [
                58.808473,
                28.9552646
              ],
              [
                58.8062324,
                28.9581665
              ],
              [
                58.8036057,
                28.9616942
              ],
              [
                58.8006064,
                28.9663774
              ],
              [
                58.7982048,
                28.9700861
              ],
              [
                58.7948809,
                28.972691
              ],
              [
                58.7930573,
                28.9750455
              ],
              [
                58.7910473,
                28.9779778
              ],
              [
                58.7875072,
                28.9805912
              ],
              [
                58.7841532,
                28.9826267
              ],
              [
                58.7816818,
                28.985007
              ],
              [
                58.7790926,
                28.9892931
              ],
              [
                58.7766993,
                28.9931911
              ],
              [
                58.7768955,
                28.9969856
              ],
              [
                58.7772879,
                29.0003921
              ],
              [
                58.7780042,
                29.0058769
              ],
              [
                58.7796133,
                29.0118965
              ],
              [
                58.7811243,
                29.0160187
              ],
              [
                58.7827142,
                29.0216588
              ],
              [
                58.7844808,
                29.0265313
              ],
              [
                58.7857961,
                29.0310417
              ],
              [
                58.7878281,
                29.0368542
              ],
              [
                58.7882801,
                29.0413992
              ],
              [
                58.7900966,
                29.0472204
              ],
              [
                58.7906023,
                29.0509498
              ],
              [
                58.7768747,
                29.0634366
              ],
              [
                58.7635413,
                29.0812114
              ],
              [
                58.7618749,
                29.0831584
              ],
              [
                58.7449285,
                29.1026012
              ],
              [
                58.7349287,
                29.11093
              ],
              [
                58.7332619,
                29.1123181
              ],
              [
                58.7338154,
                29.1125976
              ],
              [
                58.7354819,
                29.1125976
              ],
              [
                58.7415953,
                29.1137063
              ],
              [
                58.7424285,
                29.1139857
              ],
              [
                58.7446484,
                29.1139857
              ],
              [
                58.7454817,
                29.1142651
              ],
              [
                58.746595,
                29.1142651
              ],
              [
                58.7490951,
                29.1145445
              ],
              [
                58.7765948,
                29.1178706
              ],
              [
                58.777708,
                29.1181501
              ],
              [
                58.7793745,
                29.1181501
              ],
              [
                58.8054874,
                29.1259292
              ],
              [
                58.8068742,
                29.1262087
              ],
              [
                58.8332673,
                29.1403789
              ],
              [
                58.8338205,
                29.1406583
              ],
              [
                58.8371536,
                29.1434346
              ],
              [
                58.9124329,
                29.2087088
              ],
              [
                58.9166061,
                29.2142619
              ],
              [
                58.9196592,
                29.2184358
              ],
              [
                58.9832719,
                29.2878799
              ],
              [
                58.9841051,
                29.2892683
              ],
              [
                59.0004984,
                29.3053792
              ],
              [
                59.0038317,
                29.3089944
              ],
              [
                59.0232715,
                29.3309388
              ],
              [
                59.0235516,
                29.3317683
              ],
              [
                59.0249379,
                29.3331657
              ],
              [
                59.0546644,
                29.377047
              ],
              [
                59.0749441,
                29.4037174
              ],
              [
                59.0774442,
                29.4076036
              ],
              [
                59.0785575,
                29.4092716
              ],
              [
                59.0841107,
                29.4203801
              ],
              [
                59.0866108,
                29.4278819
              ],
              [
                59.0868908,
                29.42955
              ],
              [
                59.0866108,
                29.4326067
              ],
              [
                59.0868909,
                29.4331567
              ],
              [
                59.0866108,
                29.4373314
              ],
              [
                59.0860576,
                29.4389996
              ],
              [
                59.0860577,
                29.4403881
              ],
              [
                59.0771643,
                29.4773306
              ],
              [
                59.0768912,
                29.4809375
              ],
              [
                59.0766111,
                29.4817761
              ],
              [
                59.0766112,
                29.4842739
              ],
              [
                59.0763311,
                29.4864921
              ],
              [
                59.0668915,
                29.5120561
              ],
              [
                59.0563316,
                29.5276112
              ],
              [
                59.0502182,
                29.5381618
              ],
              [
                59.049385,
                29.5409392
              ],
              [
                59.0477181,
                29.5439962
              ],
              [
                59.0477182,
                29.5442757
              ],
              [
                59.046885,
                29.5467737
              ],
              [
                59.0452182,
                29.5756666
              ],
              [
                59.0446651,
                29.6020533
              ],
              [
                59.0449452,
                29.6023329
              ],
              [
                59.0452183,
                29.6037217
              ],
              [
                59.0452183,
                29.6048309
              ],
              [
                59.044112,
                29.6045513
              ],
              [
                59.0429983,
                29.6045513
              ],
              [
                59.0427186,
                29.6042717
              ],
              [
                59.0341122,
                29.6034421
              ],
              [
                59.0304989,
                29.6034421
              ],
              [
                59.0293852,
                29.6031625
              ],
              [
                59.0199389,
                29.6020533
              ],
              [
                59.0124388,
                29.6020533
              ],
              [
                59.0110524,
                29.6017738
              ],
              [
                59.0010526,
                29.6009441
              ],
              [
                58.9971658,
                29.6009441
              ],
              [
                58.9943858,
                29.600385
              ],
              [
                58.9924391,
                29.600385
              ],
              [
                58.9838261,
                29.5989963
              ],
              [
                58.981326,
                29.5989962
              ],
              [
                58.9804925,
                29.5987167
              ],
              [
                58.9471598,
                29.5942799
              ],
              [
                58.9466067,
                29.5942799
              ],
              [
                58.9452133,
                29.5942799
              ],
              [
                58.9277133,
                29.5912227
              ],
              [
                58.9260469,
                29.5912228
              ],
              [
                58.923827,
                29.5906636
              ],
              [
                58.9221601,
                29.5906637
              ],
              [
                58.9152135,
                29.5895545
              ],
              [
                58.913267,
                29.5895545
              ],
              [
                58.8836798,
                29.5823644
              ],
              [
                58.8607676,
                29.5767761
              ],
              [
                58.8575306,
                29.5763107
              ],
              [
                58.8549347,
                29.5759375
              ],
              [
                58.8388215,
                29.5728895
              ],
              [
                58.838268,
                29.5726099
              ],
              [
                58.8374348,
                29.5723304
              ],
              [
                58.8368746,
                29.5720508
              ],
              [
                58.8304881,
                29.570112
              ],
              [
                58.8288217,
                29.5692733
              ],
              [
                58.8252083,
                29.5681642
              ],
              [
                58.8221552,
                29.5667754
              ],
              [
                58.8213215,
                29.5667754
              ],
              [
                58.761876,
                29.5503812
              ],
              [
                58.7238162,
                29.542049
              ],
              [
                58.7224299,
                29.5414988
              ],
              [
                58.7185365,
                29.5406602
              ],
              [
                58.6738173,
                29.5253846
              ],
              [
                58.6724239,
                29.5245549
              ],
              [
                58.6685371,
                29.5231663
              ],
              [
                58.6071445,
                29.4920475
              ],
              [
                58.6063112,
                29.491777
              ],
              [
                58.605198,
                29.4909384
              ],
              [
                58.5965915,
                29.4873316
              ],
              [
                58.5954783,
                29.4864929
              ],
              [
                58.5940915,
                29.4862224
              ],
              [
                58.5698815,
                29.4756231
              ],
              [
                58.553839,
                29.3359433
              ],
              [
                58.5500194,
                29.205808
              ],
              [
                58.5461985,
                29.0754644
              ],
              [
                58.5354715,
                29.0587139
              ],
              [
                58.5051755,
                29.0338579
              ],
              [
                58.4963052,
                28.9725942
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 850590739
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.3634502,
          28.4568592
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984236861
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.5191365,
          28.4109615
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984254712
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.702749,
          29.3301299
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32677946
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.6704717,
          29.4458687
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984237659
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.4765229,
          29.0677811
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249310458
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.6059046,
          29.2356229
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984252541
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.9878876,
          29.2489509
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984234006
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.7232334,
          29.7691249
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984243832
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.4883351,
          27.154958
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984251354
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.6697047,
          27.2865905
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5679358234
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.4949725,
          27.4014947
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 850576493
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.8771387,
          27.5239005
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820309189
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.229663,
          28.0986408
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984247507
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.6697047,
          27.8472587
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 26476270
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.7025775,
          27.9502255
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4449325204
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.0006441,
          28.0185535
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984254308
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.4098363,
          27.912681
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984242044
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.2200198,
          28.1591443
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 850572020
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.844051,
          28.4779105
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984247506
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.4902789,
          28.7457869
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 344623598
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.7373382,
          28.6697367
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984227441
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.1384547,
          28.3971518
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 820309254
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.6963456,
          28.9513934
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5933316990
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.1782498,
          29.1403563
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32678002
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.3565663,
          29.1059864
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984253873
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.8606437,
          28.5056084
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4408013397
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.0196167,
          28.6523096
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4323197680
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.8845357,
          28.9454742
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984251649
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.7215887,
          29.253844
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984236402
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          59.2037956,
          29.0893425
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249311493
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.1243149,
          30.1191968
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984254392
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.9222443,
          30.2624007
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984225285
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.3068918,
          30.8254578
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2503865006
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.2716302,
          30.8723337
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2108742744
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.9941776,
          30.402184
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984252573
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.9113315,
          30.5023155
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249310574
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.5717384,
          29.9283973
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249311304
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.5672432,
          30.8134822
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984254451
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.310554,
          30.8822585
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984250240
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.2847626,
          31.358426
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5673596876
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.2825998,
          31.4100681
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 249312588
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.8069974,
          31.2676737
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32677945
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.0645647,
          30.2924085
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984249939
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          58.1653663,
          30.2817706
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5984253346
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.1874955,
          31.3411904
        ]
      }
    }
  ]
},
"کرمانشاه.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554883,
        "tags": {
          "admin_level": "5",
          "alt_name:ku": "Şaristana Şehabad",
          "boundary": "administrative",
          "name": "شهرستان اسلام آباد غرب",
          "name:en": "Eslamabad-e Gharb County",
          "name:ku": "Şehabad",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q393368",
          "wikipedia": "en:Eslamabad-e Gharb County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.3171432,
                34.1207618
              ],
              [
                46.3174197,
                34.120482
              ],
              [
                46.317976,
                34.1202022
              ],
              [
                46.3190862,
                34.1196517
              ],
              [
                46.3418664,
                34.1060408
              ],
              [
                46.3432563,
                34.1046508
              ],
              [
                46.3443664,
                34.1040912
              ],
              [
                46.3765891,
                34.0849293
              ],
              [
                46.3779789,
                34.0843697
              ],
              [
                46.3782555,
                34.0838192
              ],
              [
                46.4285387,
                34.0471465
              ],
              [
                46.4296489,
                34.0457566
              ],
              [
                46.4302051,
                34.0454767
              ],
              [
                46.4352053,
                34.0404762
              ],
              [
                46.4357584,
                34.0404763
              ],
              [
                46.446085,
                34.0233898
              ],
              [
                46.4725023,
                33.9996605
              ],
              [
                46.4866014,
                33.9813469
              ],
              [
                46.5071865,
                33.9584542
              ],
              [
                46.5454046,
                33.9422397
              ],
              [
                46.5843767,
                33.9207598
              ],
              [
                46.5849338,
                33.9202002
              ],
              [
                46.5877104,
                33.9185393
              ],
              [
                46.5901373,
                33.9163903
              ],
              [
                46.5904902,
                33.9160389
              ],
              [
                46.5925312,
                33.9141604
              ],
              [
                46.5932668,
                33.9136098
              ],
              [
                46.594934,
                33.9124905
              ],
              [
                46.6079906,
                33.8994379
              ],
              [
                46.6379936,
                33.8808249
              ],
              [
                46.6396601,
                33.8802743
              ],
              [
                46.6402132,
                33.8797146
              ],
              [
                46.6485462,
                33.8755533
              ],
              [
                46.6488267,
                33.8749936
              ],
              [
                46.6682693,
                33.8622207
              ],
              [
                46.6699365,
                33.8602709
              ],
              [
                46.6699365,
                33.8599911
              ],
              [
                46.6716029,
                33.8577705
              ],
              [
                46.6738265,
                33.8513795
              ],
              [
                46.6732734,
                33.8480485
              ],
              [
                46.6702163,
                33.8444377
              ],
              [
                46.6638263,
                33.8397167
              ],
              [
                46.65827,
                33.8372161
              ],
              [
                46.6471604,
                33.8344359
              ],
              [
                46.6446604,
                33.8344359
              ],
              [
                46.6424369,
                33.834156
              ],
              [
                46.6416033,
                33.8344358
              ],
              [
                46.6399368,
                33.8344358
              ],
              [
                46.6391032,
                33.8347157
              ],
              [
                46.6377133,
                33.8344358
              ],
              [
                46.6352132,
                33.8344358
              ],
              [
                46.6293803,
                33.8333255
              ],
              [
                46.6260467,
                33.8330547
              ],
              [
                46.6254905,
                33.8327658
              ],
              [
                46.621324,
                33.830825
              ],
              [
                46.6216036,
                33.830203
              ],
              [
                46.6352134,
                33.8193707
              ],
              [
                46.6411214,
                33.8144911
              ],
              [
                46.6607701,
                33.7982565
              ],
              [
                46.6657702,
                33.7949255
              ],
              [
                46.667993,
                33.7932555
              ],
              [
                46.6707696,
                33.7904752
              ],
              [
                46.6713267,
                33.7893649
              ],
              [
                46.6932733,
                33.7593676
              ],
              [
                46.6952163,
                33.7571469
              ],
              [
                46.7027166,
                33.7529764
              ],
              [
                46.7052166,
                33.7521458
              ],
              [
                46.7129964,
                33.7493655
              ],
              [
                46.7135527,
                33.7488058
              ],
              [
                46.7143863,
                33.7485349
              ],
              [
                46.724106,
                33.7421437
              ],
              [
                46.7252193,
                33.7421437
              ],
              [
                46.7252193,
                33.7418638
              ],
              [
                46.7268858,
                33.7418638
              ],
              [
                46.7268858,
                33.7421437
              ],
              [
                46.7279674,
                33.7421437
              ],
              [
                46.7288296,
                33.7421437
              ],
              [
                46.7296624,
                33.7421437
              ],
              [
                46.7299429,
                33.7418639
              ],
              [
                46.7313296,
                33.7418638
              ],
              [
                46.7318858,
                33.7418639
              ],
              [
                46.7324429,
                33.741584
              ],
              [
                46.7335524,
                33.741584
              ],
              [
                46.7341093,
                33.7418639
              ],
              [
                46.7360524,
                33.7418638
              ],
              [
                46.7363289,
                33.7421437
              ],
              [
                46.739386,
                33.7426944
              ],
              [
                46.7504988,
                33.7529764
              ],
              [
                46.7513324,
                33.7543666
              ],
              [
                46.7524425,
                33.7574179
              ],
              [
                46.7554988,
                33.7676999
              ],
              [
                46.7588324,
                33.7710309
              ],
              [
                46.7599418,
                33.7710309
              ],
              [
                46.7604988,
                33.7713107
              ],
              [
                46.7627183,
                33.7713108
              ],
              [
                46.763552,
                33.7710309
              ],
              [
                46.7646653,
                33.771031
              ],
              [
                46.7652184,
                33.770751
              ],
              [
                46.7663317,
                33.7707511
              ],
              [
                46.7666083,
                33.7704713
              ],
              [
                46.7688319,
                33.7702005
              ],
              [
                46.770499,
                33.7693609
              ],
              [
                46.7771656,
                33.7676999
              ],
              [
                46.7791086,
                33.7671403
              ],
              [
                46.7799422,
                33.7671403
              ],
              [
                46.8293918,
                33.7490859
              ],
              [
                46.8299449,
                33.7485353
              ],
              [
                46.8307776,
                33.7482554
              ],
              [
                46.8338347,
                33.7460257
              ],
              [
                46.8388349,
                33.7432543
              ],
              [
                46.8427248,
                33.7413045
              ],
              [
                46.8582814,
                33.7338119
              ],
              [
                46.8591143,
                33.7338119
              ],
              [
                46.8596674,
                33.733532
              ],
              [
                46.8627245,
                33.733532
              ],
              [
                46.8630042,
                33.7332522
              ],
              [
                46.8688378,
                33.7332522
              ],
              [
                46.8696707,
                33.7335321
              ],
              [
                46.8718911,
                33.7335321
              ],
              [
                46.8727239,
                33.7338119
              ],
              [
                46.8738372,
                33.7338119
              ],
              [
                46.8826572,
                33.741441
              ],
              [
                46.8893569,
                33.7407478
              ],
              [
                46.8905891,
                33.7403185
              ],
              [
                46.8949469,
                33.7418643
              ],
              [
                46.8968939,
                33.7424149
              ],
              [
                46.9002275,
                33.7435343
              ],
              [
                46.9005041,
                33.744085
              ],
              [
                46.9132832,
                33.7576981
              ],
              [
                46.9141168,
                33.761309
              ],
              [
                46.9141168,
                33.7626992
              ],
              [
                46.9138371,
                33.7632499
              ],
              [
                46.91467,
                33.7643693
              ],
              [
                46.9146699,
                33.7649199
              ],
              [
                46.9149504,
                33.7651998
              ],
              [
                46.9161996,
                33.767937
              ],
              [
                46.9172096,
                33.769461
              ],
              [
                46.9189626,
                33.7715498
              ],
              [
                46.9206563,
                33.7712064
              ],
              [
                46.9247797,
                33.7698329
              ],
              [
                46.9293276,
                33.7682216
              ],
              [
                46.9329313,
                33.7667351
              ],
              [
                46.9341941,
                33.7662534
              ],
              [
                46.9352661,
                33.7655277
              ],
              [
                46.9363111,
                33.7650639
              ],
              [
                46.9376489,
                33.7646622
              ],
              [
                46.9393299,
                33.7641177
              ],
              [
                46.9405506,
                33.7639328
              ],
              [
                46.9413166,
                33.7639284
              ],
              [
                46.9428607,
                33.7637171
              ],
              [
                46.943332,
                33.7636485
              ],
              [
                46.9449834,
                33.7630144
              ],
              [
                46.9474686,
                33.7631416
              ],
              [
                46.9645137,
                33.7513768
              ],
              [
                46.9680749,
                33.7479871
              ],
              [
                46.9686405,
                33.743944
              ],
              [
                46.969943,
                33.7433909
              ],
              [
                46.9706703,
                33.7432359
              ],
              [
                46.971503,
                33.743197
              ],
              [
                46.9735402,
                33.7438572
              ],
              [
                46.9751694,
                33.7438986
              ],
              [
                46.9768178,
                33.7442498
              ],
              [
                46.9779031,
                33.7444803
              ],
              [
                46.9785626,
                33.7443651
              ],
              [
                46.9793962,
                33.7454754
              ],
              [
                46.9874527,
                33.7585289
              ],
              [
                46.9882862,
                33.7624196
              ],
              [
                46.993566,
                33.7729724
              ],
              [
                46.9988426,
                33.7818642
              ],
              [
                46.9991192,
                33.7835341
              ],
              [
                46.9995462,
                33.7865854
              ],
              [
                46.998009,
                33.7951972
              ],
              [
                46.9977324,
                33.795477
              ],
              [
                46.9977324,
                33.8007489
              ],
              [
                46.9968988,
                33.805479
              ],
              [
                46.9971753,
                33.8115904
              ],
              [
                46.9968987,
                33.812141
              ],
              [
                46.9785624,
                33.833535
              ],
              [
                46.9588392,
                33.8663116
              ],
              [
                46.9555063,
                33.8757536
              ],
              [
                46.953839,
                33.8802037
              ],
              [
                46.9374495,
                33.9163196
              ],
              [
                46.9349494,
                33.9252019
              ],
              [
                46.9305063,
                33.9410344
              ],
              [
                46.9299493,
                33.9415941
              ],
              [
                46.9299492,
                33.9421447
              ],
              [
                46.9296726,
                33.9429841
              ],
              [
                46.9296726,
                33.9468746
              ],
              [
                46.9293929,
                33.9474252
              ],
              [
                46.9291157,
                33.9499255
              ],
              [
                46.9280062,
                33.9563163
              ],
              [
                46.9280062,
                33.9652074
              ],
              [
                46.9282827,
                33.9713183
              ],
              [
                46.9280061,
                33.9718689
              ],
              [
                46.9277256,
                33.9740893
              ],
              [
                46.9280061,
                33.9776999
              ],
              [
                46.9280061,
                33.9782596
              ],
              [
                46.9282826,
                33.9785394
              ],
              [
                46.9310592,
                33.9807599
              ],
              [
                46.9321725,
                33.9815903
              ],
              [
                46.9607856,
                33.9963214
              ],
              [
                46.9695239,
                34.0008915
              ],
              [
                46.9610622,
                34.0077035
              ],
              [
                46.9602285,
                34.0079834
              ],
              [
                46.9593957,
                34.0088137
              ],
              [
                46.9541151,
                34.011314
              ],
              [
                46.9538385,
                34.0115939
              ],
              [
                46.9530057,
                34.0115938
              ],
              [
                46.9505056,
                34.0127041
              ],
              [
                46.9338389,
                34.0171449
              ],
              [
                46.9327256,
                34.0174338
              ],
              [
                46.9299489,
                34.0174337
              ],
              [
                46.9230058,
                34.0193744
              ],
              [
                46.9202261,
                34.0204846
              ],
              [
                46.9063359,
                34.0252053
              ],
              [
                46.8657795,
                34.0457577
              ],
              [
                46.863556,
                34.0474275
              ],
              [
                46.8563333,
                34.0546484
              ],
              [
                46.8557802,
                34.0549282
              ],
              [
                46.8554997,
                34.0557586
              ],
              [
                46.8549465,
                34.0563183
              ],
              [
                46.8535566,
                34.0613186
              ],
              [
                46.8535566,
                34.0665898
              ],
              [
                46.8541129,
                34.0702092
              ],
              [
                46.8546667,
                34.0735398
              ],
              [
                46.8604996,
                34.1004823
              ],
              [
                46.860223,
                34.1013217
              ],
              [
                46.859666,
                34.1040926
              ],
              [
                46.8566127,
                34.1138224
              ],
              [
                46.8499462,
                34.1232634
              ],
              [
                46.8493899,
                34.1232634
              ],
              [
                46.8491133,
                34.1235432
              ],
              [
                46.8491133,
                34.123814
              ],
              [
                46.8382764,
                34.1271535
              ],
              [
                46.8374428,
                34.1271535
              ],
              [
                46.8130001,
                34.1385438
              ],
              [
                46.7974434,
                34.1513241
              ],
              [
                46.7960535,
                34.1532647
              ],
              [
                46.7949434,
                34.1549254
              ],
              [
                46.7877205,
                34.1702056
              ],
              [
                46.7874439,
                34.1704855
              ],
              [
                46.7860532,
                34.1740956
              ],
              [
                46.7832735,
                34.1768755
              ],
              [
                46.7796632,
                34.1790958
              ],
              [
                46.7788305,
                34.1799262
              ],
              [
                46.7596636,
                34.1877061
              ],
              [
                46.7543838,
                34.1888162
              ],
              [
                46.7299411,
                34.1977062
              ],
              [
                46.726884,
                34.1990961
              ],
              [
                46.7004944,
                34.2082658
              ],
              [
                46.697438,
                34.2088163
              ],
              [
                46.6791049,
                34.2163255
              ],
              [
                46.6591012,
                34.222986
              ],
              [
                46.6496581,
                34.2274265
              ],
              [
                46.6490554,
                34.2276289
              ],
              [
                46.647712,
                34.2282658
              ],
              [
                46.647712,
                34.2285366
              ],
              [
                46.6471588,
                34.2288164
              ],
              [
                46.6463252,
                34.2288164
              ],
              [
                46.6452118,
                34.2293759
              ],
              [
                46.6354922,
                34.235486
              ],
              [
                46.6352117,
                34.2357658
              ],
              [
                46.6341023,
                34.2363253
              ],
              [
                46.6274357,
                34.2429859
              ],
              [
                46.624102,
                34.2496555
              ],
              [
                46.6210456,
                34.2607655
              ],
              [
                46.6207683,
                34.2688249
              ],
              [
                46.6204886,
                34.2693754
              ],
              [
                46.620212,
                34.2707653
              ],
              [
                46.620212,
                34.2724349
              ],
              [
                46.619655,
                34.2727147
              ],
              [
                46.6193784,
                34.2729855
              ],
              [
                46.6185455,
                34.2732652
              ],
              [
                46.6179885,
                34.2732652
              ],
              [
                46.617712,
                34.273545
              ],
              [
                46.6168784,
                34.273545
              ],
              [
                46.6102118,
                34.2774348
              ],
              [
                46.6090985,
                34.278265
              ],
              [
                46.6007655,
                34.2832649
              ],
              [
                46.5993787,
                34.2838244
              ],
              [
                46.575486,
                34.3027046
              ],
              [
                46.5715991,
                34.3102132
              ],
              [
                46.5704858,
                34.311603
              ],
              [
                46.562709,
                34.325763
              ],
              [
                46.5613192,
                34.3274326
              ],
              [
                46.5610425,
                34.3282719
              ],
              [
                46.5529861,
                34.3366017
              ],
              [
                46.5352061,
                34.3496605
              ],
              [
                46.5347448,
                34.3501181
              ],
              [
                46.530763,
                34.3413216
              ],
              [
                46.4996499,
                34.3302121
              ],
              [
                46.4860403,
                34.330212
              ],
              [
                46.4721502,
                34.3232629
              ],
              [
                46.465204,
                34.3154835
              ],
              [
                46.4638133,
                34.3132724
              ],
              [
                46.4454811,
                34.2902047
              ],
              [
                46.4338145,
                34.2607649
              ],
              [
                46.4315911,
                34.2563155
              ],
              [
                46.4290911,
                34.253265
              ],
              [
                46.4279809,
                34.2507651
              ],
              [
                46.4252011,
                34.2499348
              ],
              [
                46.4252011,
                34.249655
              ],
              [
                46.4224245,
                34.2374349
              ],
              [
                46.4218683,
                34.2365955
              ],
              [
                46.4152011,
                34.2188157
              ],
              [
                46.4149245,
                34.2168752
              ],
              [
                46.4021446,
                34.1921547
              ],
              [
                46.4004782,
                34.1899253
              ],
              [
                46.4004782,
                34.1893748
              ],
              [
                46.4002017,
                34.1888152
              ],
              [
                46.3990914,
                34.1874253
              ],
              [
                46.3985351,
                34.1868747
              ],
              [
                46.3982586,
                34.186595
              ],
              [
                46.3974251,
                34.1857646
              ],
              [
                46.3946453,
                34.1835443
              ],
              [
                46.3546462,
                34.1468733
              ],
              [
                46.3290864,
                34.1310422
              ],
              [
                46.3265863,
                34.1293724
              ],
              [
                46.3207526,
                34.1257621
              ],
              [
                46.3171432,
                34.1207618
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554973,
        "tags": {
          "admin_level": "5",
          "alt_name:ku": "Şaristana Selasê Bawecanî",
          "boundary": "administrative",
          "name": "شهرستان ثلاث باباجانی",
          "name:en": "Salas-e Babajani County",
          "name:ku": "Selasê Bawecanî",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q393364",
          "wikipedia": "en:Salas-e Babajani County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.754581,
                34.829016
              ],
              [
                45.7550739,
                34.8274707
              ],
              [
                45.7551701,
                34.8268005
              ],
              [
                45.7551701,
                34.826334
              ],
              [
                45.7548904,
                34.8260544
              ],
              [
                45.7548904,
                34.822996
              ],
              [
                45.7579468,
                34.814389
              ],
              [
                45.7646134,
                34.8060526
              ],
              [
                45.7665603,
                34.7993854
              ],
              [
                45.7671135,
                34.7966066
              ],
              [
                45.76489,
                34.779663
              ],
              [
                45.7626705,
                34.7738346
              ],
              [
                45.7626705,
                34.773555
              ],
              [
                45.7596142,
                34.7635583
              ],
              [
                45.7596142,
                34.76022
              ],
              [
                45.7623909,
                34.7524428
              ],
              [
                45.7665605,
                34.7474444
              ],
              [
                45.7698942,
                34.7454955
              ],
              [
                45.770727,
                34.7452159
              ],
              [
                45.7715606,
                34.7452159
              ],
              [
                45.7721137,
                34.7452158
              ],
              [
                45.7746138,
                34.7446655
              ],
              [
                45.7832273,
                34.7454956
              ],
              [
                45.7876703,
                34.7454956
              ],
              [
                45.8040598,
                34.7474445
              ],
              [
                45.8068403,
                34.7468851
              ],
              [
                45.8135068,
                34.7468852
              ],
              [
                45.8151732,
                34.7471648
              ],
              [
                45.8179499,
                34.7471648
              ],
              [
                45.8218397,
                34.7477243
              ],
              [
                45.8271165,
                34.7479949
              ],
              [
                45.8460059,
                34.7471649
              ],
              [
                45.8479528,
                34.7463258
              ],
              [
                45.857396,
                34.7438267
              ],
              [
                45.8804528,
                34.7321697
              ],
              [
                45.8851755,
                34.7296705
              ],
              [
                45.9096222,
                34.7224435
              ],
              [
                45.9107324,
                34.7224436
              ],
              [
                45.9115651,
                34.7221638
              ],
              [
                45.9162887,
                34.7213338
              ],
              [
                45.9382353,
                34.7132767
              ],
              [
                45.9493449,
                34.7113278
              ],
              [
                45.9521215,
                34.7104977
              ],
              [
                45.9579584,
                34.7077188
              ],
              [
                45.958792,
                34.7077188
              ],
              [
                45.9599014,
                34.7071594
              ],
              [
                45.9679586,
                34.7052196
              ],
              [
                45.9687914,
                34.7046601
              ],
              [
                45.9701782,
                34.7043895
              ],
              [
                45.978515,
                34.7010511
              ],
              [
                45.9801815,
                34.6999412
              ],
              [
                45.9821245,
                34.6988315
              ],
              [
                45.9824011,
                34.6985517
              ],
              [
                45.9982382,
                34.6943834
              ],
              [
                45.9987913,
                34.6938329
              ],
              [
                46.0037915,
                34.6921638
              ],
              [
                46.0040712,
                34.6916044
              ],
              [
                46.0056097,
                34.6898106
              ],
              [
                46.0076814,
                34.6882749
              ],
              [
                46.0079579,
                34.6879953
              ],
              [
                46.0174042,
                34.6835471
              ],
              [
                46.0410173,
                34.6782778
              ],
              [
                46.0429611,
                34.6782779
              ],
              [
                46.0432376,
                34.6779981
              ],
              [
                46.0482377,
                34.6779981
              ],
              [
                46.0485174,
                34.6777185
              ],
              [
                46.0501839,
                34.6777184
              ],
              [
                46.0507409,
                34.6774387
              ],
              [
                46.0526839,
                34.6771681
              ],
              [
                46.055184,
                34.6771681
              ],
              [
                46.055741,
                34.6768884
              ],
              [
                46.0582403,
                34.6768883
              ],
              [
                46.0590739,
                34.6766087
              ],
              [
                46.0590739,
                34.6760582
              ],
              [
                46.0587941,
                34.6754988
              ],
              [
                46.0560176,
                34.6671617
              ],
              [
                46.0415714,
                34.6396597
              ],
              [
                46.041294,
                34.6377197
              ],
              [
                46.0462942,
                34.6257731
              ],
              [
                46.0562944,
                34.6116067
              ],
              [
                46.0579609,
                34.6099375
              ],
              [
                46.0596273,
                34.6077177
              ],
              [
                46.0762973,
                34.5910518
              ],
              [
                46.0768504,
                34.5902216
              ],
              [
                46.077684,
                34.5896622
              ],
              [
                46.0787973,
                34.5896622
              ],
              [
                46.0790739,
                34.5893825
              ],
              [
                46.0815739,
                34.5893825
              ],
              [
                46.0835169,
                34.5899419
              ],
              [
                46.0857404,
                34.5899419
              ],
              [
                46.0862975,
                34.5902216
              ],
              [
                46.0896303,
                34.5902216
              ],
              [
                46.0921304,
                34.5904923
              ],
              [
                46.092964,
                34.590772
              ],
              [
                46.0937968,
                34.5907721
              ],
              [
                46.0962969,
                34.5907721
              ],
              [
                46.1004642,
                34.5913225
              ],
              [
                46.1007407,
                34.5916023
              ],
              [
                46.1035205,
                34.5916022
              ],
              [
                46.1040736,
                34.591882
              ],
              [
                46.1054635,
                34.591882
              ],
              [
                46.1112972,
                34.5932716
              ],
              [
                46.11213,
                34.5932716
              ],
              [
                46.1132433,
                34.5938311
              ],
              [
                46.1143535,
                34.593831
              ],
              [
                46.1307437,
                34.59883
              ],
              [
                46.1315765,
                34.5988301
              ],
              [
                46.1454666,
                34.605769
              ],
              [
                46.1460229,
                34.6066081
              ],
              [
                46.1468565,
                34.6068788
              ],
              [
                46.14769,
                34.6079977
              ],
              [
                46.1490767,
                34.6093873
              ],
              [
                46.162413,
                34.6243839
              ],
              [
                46.1938026,
                34.6410496
              ],
              [
                46.1940792,
                34.6413294
              ],
              [
                46.1957011,
                34.6403882
              ],
              [
                46.2026926,
                34.6363306
              ],
              [
                46.2129687,
                34.6260533
              ],
              [
                46.2157452,
                34.6238245
              ],
              [
                46.2260252,
                34.6191054
              ],
              [
                46.2263017,
                34.6188258
              ],
              [
                46.2268588,
                34.6188258
              ],
              [
                46.2268588,
                34.618546
              ],
              [
                46.2276924,
                34.618546
              ],
              [
                46.2365817,
                34.6141067
              ],
              [
                46.2385255,
                34.6129968
              ],
              [
                46.2488054,
                34.6088282
              ],
              [
                46.2543587,
                34.607998
              ],
              [
                46.2557485,
                34.6077183
              ],
              [
                46.2574149,
                34.6077183
              ],
              [
                46.2585282,
                34.6074386
              ],
              [
                46.2618619,
                34.6074386
              ],
              [
                46.2626947,
                34.6071589
              ],
              [
                46.2651948,
                34.6071588
              ],
              [
                46.2654714,
                34.6068792
              ],
              [
                46.266305,
                34.6068791
              ],
              [
                46.2665815,
                34.6066084
              ],
              [
                46.2721379,
                34.6068791
              ],
              [
                46.2735286,
                34.6071588
              ],
              [
                46.2915844,
                34.6071589
              ],
              [
                46.2921383,
                34.6074386
              ],
              [
                46.2926945,
                34.607159
              ],
              [
                46.2951946,
                34.607159
              ],
              [
                46.2957516,
                34.6068792
              ],
              [
                46.2976947,
                34.6068793
              ],
              [
                46.2979744,
                34.6066086
              ],
              [
                46.2999181,
                34.6060491
              ],
              [
                46.301308,
                34.6060491
              ],
              [
                46.3018612,
                34.6057694
              ],
              [
                46.3049175,
                34.6057694
              ],
              [
                46.311584,
                34.6046686
              ],
              [
                46.3121411,
                34.6043888
              ],
              [
                46.3135309,
                34.6043889
              ],
              [
                46.3138075,
                34.6041091
              ],
              [
                46.3149177,
                34.6041092
              ],
              [
                46.3151974,
                34.6038295
              ],
              [
                46.3168646,
                34.6038294
              ],
              [
                46.3174178,
                34.6035498
              ],
              [
                46.3213077,
                34.6035497
              ],
              [
                46.3257507,
                34.6029993
              ],
              [
                46.3415877,
                34.5988306
              ],
              [
                46.3438074,
                34.5988306
              ],
              [
                46.3513107,
                34.5971613
              ],
              [
                46.3524209,
                34.5971614
              ],
              [
                46.3529771,
                34.5968816
              ],
              [
                46.3535302,
                34.5968816
              ],
              [
                46.3538108,
                34.5966019
              ],
              [
                46.3546443,
                34.5966019
              ],
              [
                46.3568639,
                34.5960514
              ],
              [
                46.3702001,
                34.5924422
              ],
              [
                46.3704775,
                34.5921625
              ],
              [
                46.3735339,
                34.5921625
              ],
              [
                46.3743674,
                34.5918828
              ],
              [
                46.3796433,
                34.5918828
              ],
              [
                46.3802003,
                34.591603
              ],
              [
                46.3840761,
                34.5916031
              ],
              [
                46.3840653,
                34.5921831
              ],
              [
                46.3928629,
                34.5927107
              ],
              [
                46.3954367,
                34.5928649
              ],
              [
                46.3985252,
                34.5940513
              ],
              [
                46.4055712,
                34.5967574
              ],
              [
                46.4057563,
                34.5968817
              ],
              [
                46.4063103,
                34.6005001
              ],
              [
                46.404643,
                34.607439
              ],
              [
                46.4043664,
                34.6096677
              ],
              [
                46.4040897,
                34.6110483
              ],
              [
                46.4021428,
                34.6157765
              ],
              [
                46.3979763,
                34.6202159
              ],
              [
                46.3904769,
                34.6263336
              ],
              [
                46.3896433,
                34.6266042
              ],
              [
                46.387977,
                34.6277231
              ],
              [
                46.3874199,
                34.6279938
              ],
              [
                46.3738101,
                34.6377207
              ],
              [
                46.3724203,
                34.638271
              ],
              [
                46.3596434,
                34.6438292
              ],
              [
                46.3593637,
                34.6441089
              ],
              [
                46.3585301,
                34.6441089
              ],
              [
                46.3404734,
                34.6546658
              ],
              [
                46.3396406,
                34.6552161
              ],
              [
                46.327974,
                34.6779989
              ],
              [
                46.3246403,
                34.6846668
              ],
              [
                46.3243636,
                34.6849374
              ],
              [
                46.3218644,
                34.6882759
              ],
              [
                46.311861,
                34.6968926
              ],
              [
                46.2965842,
                34.70744
              ],
              [
                46.2926941,
                34.7113288
              ],
              [
                46.2763047,
                34.7335513
              ],
              [
                46.2621378,
                34.7627207
              ],
              [
                46.2613042,
                34.7649492
              ],
              [
                46.2613042,
                34.7652199
              ],
              [
                46.2604713,
                34.766889
              ],
              [
                46.2601948,
                34.7682784
              ],
              [
                46.2315814,
                34.8166098
              ],
              [
                46.2304681,
                34.820778
              ],
              [
                46.2304682,
                34.821617
              ],
              [
                46.2301908,
                34.8218876
              ],
              [
                46.2299142,
                34.824107
              ],
              [
                46.2301908,
                34.8268948
              ],
              [
                46.2410245,
                34.8466165
              ],
              [
                46.2413043,
                34.8468872
              ],
              [
                46.2410245,
                34.8471668
              ],
              [
                46.2390807,
                34.8471669
              ],
              [
                46.2338009,
                34.8488359
              ],
              [
                46.2324142,
                34.8491155
              ],
              [
                46.2307478,
                34.8502252
              ],
              [
                46.2293578,
                34.8505049
              ],
              [
                46.2260242,
                34.8521649
              ],
              [
                46.2246343,
                34.8524445
              ],
              [
                46.2199147,
                34.8560532
              ],
              [
                46.2088011,
                34.8777231
              ],
              [
                46.2085246,
                34.8793921
              ],
              [
                46.2065776,
                34.8835601
              ],
              [
                46.2057448,
                34.8857794
              ],
              [
                46.204358,
                34.8882783
              ],
              [
                46.2040775,
                34.888558
              ],
              [
                46.1804646,
                34.8788327
              ],
              [
                46.1796317,
                34.8788327
              ],
              [
                46.1793551,
                34.878553
              ],
              [
                46.1718551,
                34.878553
              ],
              [
                46.1715784,
                34.8788327
              ],
              [
                46.1707448,
                34.8788327
              ],
              [
                46.1701886,
                34.8785531
              ],
              [
                46.1690784,
                34.878553
              ],
              [
                46.1687987,
                34.8788327
              ],
              [
                46.1671314,
                34.8788327
              ],
              [
                46.163522,
                34.8805017
              ],
              [
                46.1632455,
                34.8807813
              ],
              [
                46.1346322,
                34.9043904
              ],
              [
                46.1301852,
                34.9074487
              ],
              [
                46.1293517,
                34.9079989
              ],
              [
                46.1293516,
                34.9082786
              ],
              [
                46.1285188,
                34.9096679
              ],
              [
                46.1283805,
                34.9100828
              ],
              [
                46.1179623,
                34.9193928
              ],
              [
                46.1176857,
                34.9202227
              ],
              [
                46.1174091,
                34.9205025
              ],
              [
                46.1168521,
                34.9213324
              ],
              [
                46.1151857,
                34.9230013
              ],
              [
                46.1135192,
                34.9238312
              ],
              [
                46.1132418,
                34.9241109
              ],
              [
                46.112409,
                34.9241109
              ],
              [
                46.1121286,
                34.9243906
              ],
              [
                46.1112957,
                34.9241109
              ],
              [
                46.1096286,
                34.9241109
              ],
              [
                46.0987955,
                34.9157752
              ],
              [
                46.0868492,
                34.9104977
              ],
              [
                46.0854625,
                34.9104977
              ],
              [
                46.0849062,
                34.9102181
              ],
              [
                46.0835155,
                34.9102181
              ],
              [
                46.0826827,
                34.9102181
              ],
              [
                46.0824061,
                34.9104977
              ],
              [
                46.077406,
                34.9104977
              ],
              [
                46.076849,
                34.910218
              ],
              [
                46.072406,
                34.910218
              ],
              [
                46.0721294,
                34.9104977
              ],
              [
                46.0710161,
                34.9104977
              ],
              [
                46.0704629,
                34.9107774
              ],
              [
                46.0696293,
                34.9107773
              ],
              [
                46.0690731,
                34.911057
              ],
              [
                46.0532398,
                34.9249497
              ],
              [
                46.03907,
                34.9363345
              ],
              [
                46.038516,
                34.9371644
              ],
              [
                46.0371261,
                34.938283
              ],
              [
                46.0290698,
                34.9399429
              ],
              [
                46.0287932,
                34.9402225
              ],
              [
                46.0251798,
                34.9402225
              ],
              [
                46.0243462,
                34.9405022
              ],
              [
                46.021293,
                34.9435604
              ],
              [
                46.0193469,
                34.9443903
              ],
              [
                46.0182367,
                34.9443902
              ],
              [
                46.0176796,
                34.9446699
              ],
              [
                46.0118467,
                34.9446699
              ],
              [
                46.0107365,
                34.9452202
              ],
              [
                46.008513,
                34.9488376
              ],
              [
                46.0079568,
                34.9499472
              ],
              [
                46.0076802,
                34.9510568
              ],
              [
                46.0062903,
                34.9535647
              ],
              [
                46.0026801,
                34.9552245
              ],
              [
                45.9960135,
                34.9638306
              ],
              [
                45.9960135,
                34.9685575
              ],
              [
                45.99629,
                34.9688372
              ],
              [
                45.9960134,
                34.9693965
              ],
              [
                45.9957369,
                34.9710563
              ],
              [
                45.9912899,
                34.9757832
              ],
              [
                45.9904571,
                34.9771725
              ],
              [
                45.9901805,
                34.978282
              ],
              [
                45.9901805,
                34.9785617
              ],
              [
                45.9882336,
                34.9818904
              ],
              [
                45.9807333,
                34.9921651
              ],
              [
                45.9796232,
                34.9921651
              ],
              [
                45.979067,
                34.9924448
              ],
              [
                45.9787904,
                34.9921651
              ],
              [
                45.9768466,
                34.992165
              ],
              [
                45.9710106,
                34.989946
              ],
              [
                45.9696238,
                34.9896663
              ],
              [
                45.9674002,
                34.9896663
              ],
              [
                45.9662901,
                34.9910645
              ],
              [
                45.9660104,
                34.9916147
              ],
              [
                45.9676769,
                34.99995
              ],
              [
                45.9676768,
                35.0024487
              ],
              [
                45.9674002,
                35.003008
              ],
              [
                45.9587906,
                35.0205081
              ],
              [
                45.9446207,
                35.0338403
              ],
              [
                45.9393441,
                35.0377282
              ],
              [
                45.9360104,
                35.0410567
              ],
              [
                45.9318869,
                35.0441741
              ],
              [
                45.930543,
                35.045045
              ],
              [
                45.930254,
                35.045094
              ],
              [
                45.929841,
                35.045124
              ],
              [
                45.92938,
                35.045088
              ],
              [
                45.928947,
                35.045143
              ],
              [
                45.928264,
                35.045256
              ],
              [
                45.927851,
                35.045483
              ],
              [
                45.927535,
                35.045574
              ],
              [
                45.927202,
                35.045732
              ],
              [
                45.926949,
                35.045886
              ],
              [
                45.926672,
                35.045961
              ],
              [
                45.926356,
                35.046011
              ],
              [
                45.926063,
                35.046089
              ],
              [
                45.92583,
                35.046193
              ],
              [
                45.925601,
                35.046292
              ],
              [
                45.925379,
                35.046307
              ],
              [
                45.924995,
                35.04617
              ],
              [
                45.924548,
                35.04604
              ],
              [
                45.924198,
                35.045975
              ],
              [
                45.923952,
                35.045981
              ],
              [
                45.923633,
                35.04593
              ],
              [
                45.923339,
                35.045874
              ],
              [
                45.923056,
                35.045817
              ],
              [
                45.922631,
                35.045687
              ],
              [
                45.922362,
                35.045646
              ],
              [
                45.922033,
                35.045688
              ],
              [
                45.92169,
                35.045738
              ],
              [
                45.921464,
                35.045735
              ],
              [
                45.921138,
                35.045814
              ],
              [
                45.92081,
                35.04588
              ],
              [
                45.920389,
                35.045851
              ],
              [
                45.919971,
                35.045816
              ],
              [
                45.919434,
                35.04589
              ],
              [
                45.919014,
                35.045953
              ],
              [
                45.918657,
                35.045926
              ],
              [
                45.918027,
                35.045924
              ],
              [
                45.917405,
                35.045934
              ],
              [
                45.917002,
                35.045961
              ],
              [
                45.916548,
                35.045952
              ],
              [
                45.916252,
                35.04591
              ],
              [
                45.915885,
                35.045886
              ],
              [
                45.915478,
                35.045937
              ],
              [
                45.915034,
                35.04599
              ],
              [
                45.914746,
                35.04598
              ],
              [
                45.914385,
                35.045959
              ],
              [
                45.914132,
                35.045979
              ],
              [
                45.913789,
                35.045854
              ],
              [
                45.913433,
                35.045657
              ],
              [
                45.913152,
                35.045498
              ],
              [
                45.912812,
                35.045409
              ],
              [
                45.912572,
                35.045547
              ],
              [
                45.912294,
                35.045751
              ],
              [
                45.911887,
                35.045871
              ],
              [
                45.91136,
                35.045962
              ],
              [
                45.910916,
                35.046015
              ],
              [
                45.910577,
                35.046105
              ],
              [
                45.910225,
                35.046336
              ],
              [
                45.909887,
                35.046384
              ],
              [
                45.909595,
                35.046425
              ],
              [
                45.909343,
                35.046561
              ],
              [
                45.909111,
                35.046798
              ],
              [
                45.908924,
                35.04689
              ],
              [
                45.908605,
                35.046949
              ],
              [
                45.908195,
                35.046969
              ],
              [
                45.907759,
                35.047099
              ],
              [
                45.907383,
                35.047278
              ],
              [
                45.907025,
                35.047377
              ],
              [
                45.906461,
                35.047446
              ],
              [
                45.906156,
                35.047456
              ],
              [
                45.905835,
                35.04753
              ],
              [
                45.905483,
                35.047608
              ],
              [
                45.904996,
                35.047664
              ],
              [
                45.904661,
                35.04768
              ],
              [
                45.904235,
                35.047569
              ],
              [
                45.903818,
                35.047471
              ],
              [
                45.903302,
                35.047476
              ],
              [
                45.902976,
                35.047417
              ],
              [
                45.902655,
                35.047316
              ],
              [
                45.902457,
                35.047193
              ],
              [
                45.902114,
                35.047045
              ],
              [
                45.9019962,
                35.0470014
              ],
              [
                45.901765,
                35.046916
              ],
              [
                45.901167,
                35.046806
              ],
              [
                45.900587,
                35.04668
              ],
              [
                45.900242,
                35.046634
              ],
              [
                45.89987,
                35.046458
              ],
              [
                45.899484,
                35.046359
              ],
              [
                45.899068,
                35.046283
              ],
              [
                45.898168,
                35.046062
              ],
              [
                45.88039,
                35.037985
              ],
              [
                45.88039,
                35.037984
              ],
              [
                45.8803005,
                35.0378417
              ],
              [
                45.879807,
                35.036878
              ],
              [
                45.879752,
                35.036675
              ],
              [
                45.87966,
                35.036434
              ],
              [
                45.879586,
                35.036267
              ],
              [
                45.879562,
                35.035949
              ],
              [
                45.879489,
                35.035524
              ],
              [
                45.879334,
                35.035155
              ],
              [
                45.879238,
                35.034918
              ],
              [
                45.879125,
                35.034703
              ],
              [
                45.879074,
                35.03456
              ],
              [
                45.879039,
                35.034331
              ],
              [
                45.879105,
                35.03414
              ],
              [
                45.878922,
                35.033813
              ],
              [
                45.878764,
                35.033564
              ],
              [
                45.87858,
                35.033209
              ],
              [
                45.878379,
                35.033008
              ],
              [
                45.878009,
                35.032814
              ],
              [
                45.877819,
                35.032612
              ],
              [
                45.877681,
                35.032488
              ],
              [
                45.877539,
                35.032329
              ],
              [
                45.877312,
                35.032087
              ],
              [
                45.877198,
                35.031991
              ],
              [
                45.876813,
                35.031763
              ],
              [
                45.876525,
                35.031513
              ],
              [
                45.876671,
                35.031318
              ],
              [
                45.876815,
                35.030962
              ],
              [
                45.876943,
                35.030806
              ],
              [
                45.877112,
                35.030639
              ],
              [
                45.877296,
                35.030511
              ],
              [
                45.877448,
                35.030342
              ],
              [
                45.87745,
                35.030153
              ],
              [
                45.877517,
                35.029815
              ],
              [
                45.877504,
                35.02939
              ],
              [
                45.877558,
                35.029104
              ],
              [
                45.877489,
                35.028936
              ],
              [
                45.877531,
                35.028649
              ],
              [
                45.877609,
                35.028285
              ],
              [
                45.877729,
                35.028095
              ],
              [
                45.877783,
                35.027768
              ],
              [
                45.877677,
                35.027515
              ],
              [
                45.877618,
                35.027253
              ],
              [
                45.877661,
                35.027034
              ],
              [
                45.877549,
                35.02669
              ],
              [
                45.877367,
                35.026256
              ],
              [
                45.877221,
                35.025687
              ],
              [
                45.877185,
                35.025344
              ],
              [
                45.877207,
                35.02506
              ],
              [
                45.87719,
                35.02475
              ],
              [
                45.877182,
                35.024567
              ],
              [
                45.87721,
                35.024396
              ],
              [
                45.877218,
                35.024211
              ],
              [
                45.877396,
                35.023969
              ],
              [
                45.877504,
                35.023775
              ],
              [
                45.8776,
                35.023552
              ],
              [
                45.877683,
                35.023386
              ],
              [
                45.877809,
                35.023157
              ],
              [
                45.877899,
                35.022994
              ],
              [
                45.878051,
                35.022784
              ],
              [
                45.878254,
                35.022667
              ],
              [
                45.878369,
                35.0225
              ],
              [
                45.878386,
                35.022221
              ],
              [
                45.878577,
                35.022055
              ],
              [
                45.878686,
                35.021907
              ],
              [
                45.87893,
                35.021695
              ],
              [
                45.879027,
                35.021632
              ],
              [
                45.879084,
                35.021448
              ],
              [
                45.879243,
                35.021176
              ],
              [
                45.879234,
                35.020985
              ],
              [
                45.87913,
                35.020915
              ],
              [
                45.878976,
                35.020859
              ],
              [
                45.878792,
                35.020895
              ],
              [
                45.878675,
                35.020837
              ],
              [
                45.878624,
                35.020717
              ],
              [
                45.878675,
                35.020597
              ],
              [
                45.878747,
                35.020364
              ],
              [
                45.87876,
                35.020265
              ],
              [
                45.878773,
                35.020162
              ],
              [
                45.87873,
                35.019967
              ],
              [
                45.878704,
                35.019796
              ],
              [
                45.878746,
                35.01966
              ],
              [
                45.878862,
                35.019475
              ],
              [
                45.878919,
                35.019226
              ],
              [
                45.878843,
                35.019073
              ],
              [
                45.87878,
                35.018969
              ],
              [
                45.878589,
                35.01896
              ],
              [
                45.878469,
                35.018866
              ],
              [
                45.878424,
                35.018772
              ],
              [
                45.878387,
                35.018686
              ],
              [
                45.878249,
                35.018604
              ],
              [
                45.878091,
                35.018535
              ],
              [
                45.878055,
                35.01843
              ],
              [
                45.878064,
                35.018249
              ],
              [
                45.878135,
                35.018012
              ],
              [
                45.878365,
                35.017876
              ],
              [
                45.878526,
                35.017632
              ],
              [
                45.878616,
                35.017474
              ],
              [
                45.878752,
                35.017326
              ],
              [
                45.878908,
                35.017171
              ],
              [
                45.879062,
                35.017144
              ],
              [
                45.879179,
                35.017179
              ],
              [
                45.879305,
                35.01719
              ],
              [
                45.879533,
                35.017022
              ],
              [
                45.87957,
                35.016845
              ],
              [
                45.879581,
                35.016715
              ],
              [
                45.879777,
                35.016506
              ],
              [
                45.879854,
                35.016337
              ],
              [
                45.879791,
                35.016232
              ],
              [
                45.879624,
                35.016169
              ],
              [
                45.879644,
                35.015986
              ],
              [
                45.87969,
                35.015868
              ],
              [
                45.879964,
                35.015669
              ],
              [
                45.880049,
                35.015553
              ],
              [
                45.8801,
                35.015324
              ],
              [
                45.880124,
                35.015117
              ],
              [
                45.880039,
                35.014772
              ],
              [
                45.879902,
                35.014543
              ],
              [
                45.879696,
                35.014472
              ],
              [
                45.879558,
                35.014459
              ],
              [
                45.879417,
                35.01441
              ],
              [
                45.879133,
                35.014394
              ],
              [
                45.878845,
                35.014383
              ],
              [
                45.878565,
                35.014293
              ],
              [
                45.878456,
                35.014137
              ],
              [
                45.878359,
                35.013984
              ],
              [
                45.878324,
                35.013865
              ],
              [
                45.87837,
                35.013701
              ],
              [
                45.878579,
                35.013545
              ],
              [
                45.878723,
                35.013429
              ],
              [
                45.878772,
                35.013255
              ],
              [
                45.87894,
                35.013065
              ],
              [
                45.878973,
                35.012806
              ],
              [
                45.87913,
                35.012632
              ],
              [
                45.879093,
                35.012482
              ],
              [
                45.878972,
                35.012231
              ],
              [
                45.878883,
                35.012154
              ],
              [
                45.878777,
                35.011988
              ],
              [
                45.87862,
                35.011983
              ],
              [
                45.878356,
                35.012005
              ],
              [
                45.878185,
                35.011924
              ],
              [
                45.878098,
                35.01181
              ],
              [
                45.878037,
                35.011627
              ],
              [
                45.877644,
                35.011474
              ],
              [
                45.877561,
                35.011336
              ],
              [
                45.87741,
                35.011247
              ],
              [
                45.877288,
                35.011079
              ],
              [
                45.877042,
                35.010997
              ],
              [
                45.876834,
                35.010918
              ],
              [
                45.87649,
                35.01077
              ],
              [
                45.876195,
                35.010599
              ],
              [
                45.875954,
                35.010452
              ],
              [
                45.875704,
                35.010334
              ],
              [
                45.875403,
                35.010247
              ],
              [
                45.875029,
                35.010127
              ],
              [
                45.875061,
                35.009975
              ],
              [
                45.875046,
                35.009761
              ],
              [
                45.875106,
                35.009566
              ],
              [
                45.87513,
                35.009317
              ],
              [
                45.875225,
                35.009225
              ],
              [
                45.87521,
                35.009124
              ],
              [
                45.875262,
                35.008974
              ],
              [
                45.875292,
                35.008829
              ],
              [
                45.875312,
                35.008689
              ],
              [
                45.875325,
                35.008499
              ],
              [
                45.875327,
                35.008157
              ],
              [
                45.875263,
                35.007803
              ],
              [
                45.875227,
                35.00764
              ],
              [
                45.875196,
                35.007477
              ],
              [
                45.875344,
                35.007395
              ],
              [
                45.875566,
                35.007383
              ],
              [
                45.875876,
                35.007341
              ],
              [
                45.87611,
                35.007308
              ],
              [
                45.876387,
                35.007137
              ],
              [
                45.87664,
                35.007068
              ],
              [
                45.876802,
                35.006866
              ],
              [
                45.877151,
                35.006517
              ],
              [
                45.877362,
                35.006245
              ],
              [
                45.877753,
                35.006189
              ],
              [
                45.878018,
                35.006146
              ],
              [
                45.878241,
                35.005918
              ],
              [
                45.878512,
                35.005701
              ],
              [
                45.878783,
                35.005441
              ],
              [
                45.879078,
                35.005276
              ],
              [
                45.879285,
                35.005159
              ],
              [
                45.879403,
                35.005007
              ],
              [
                45.879543,
                35.004742
              ],
              [
                45.879715,
                35.004515
              ],
              [
                45.879777,
                35.004382
              ],
              [
                45.879826,
                35.004068
              ],
              [
                45.879924,
                35.003793
              ],
              [
                45.879956,
                35.003656
              ],
              [
                45.880285,
                35.003494
              ],
              [
                45.88071,
                35.003305
              ],
              [
                45.880818,
                35.00307
              ],
              [
                45.88083,
                35.00281
              ],
              [
                45.880905,
                35.002553
              ],
              [
                45.881005,
                35.002352
              ],
              [
                45.881337,
                35.002461
              ],
              [
                45.88158,
                35.002615
              ],
              [
                45.881755,
                35.002705
              ],
              [
                45.881943,
                35.002779
              ],
              [
                45.882183,
                35.002877
              ],
              [
                45.882381,
                35.002836
              ],
              [
                45.882503,
                35.002571
              ],
              [
                45.882886,
                35.002418
              ],
              [
                45.882989,
                35.002268
              ],
              [
                45.883047,
                35.002103
              ],
              [
                45.883006,
                35.001857
              ],
              [
                45.883048,
                35.001714
              ],
              [
                45.883101,
                35.001568
              ],
              [
                45.883577,
                35.001623
              ],
              [
                45.883898,
                35.001556
              ],
              [
                45.884163,
                35.001687
              ],
              [
                45.884364,
                35.001768
              ],
              [
                45.884583,
                35.001766
              ],
              [
                45.884573,
                35.001552
              ],
              [
                45.884484,
                35.001231
              ],
              [
                45.884476,
                35.001026
              ],
              [
                45.884498,
                35.000872
              ],
              [
                45.884885,
                35.000906
              ],
              [
                45.885136,
                35.000856
              ],
              [
                45.885291,
                35.000669
              ],
              [
                45.885301,
                35.000489
              ],
              [
                45.885389,
                35.000417
              ],
              [
                45.885522,
                35.000407
              ],
              [
                45.885695,
                35.000465
              ],
              [
                45.885727,
                35.000328
              ],
              [
                45.885771,
                35.000105
              ],
              [
                45.886155,
                34.999914
              ],
              [
                45.886175,
                34.999751
              ],
              [
                45.886236,
                34.999421
              ],
              [
                45.886231,
                34.999183
              ],
              [
                45.88644,
                34.999052
              ],
              [
                45.886384,
                34.998795
              ],
              [
                45.886393,
                34.998545
              ],
              [
                45.886466,
                34.998414
              ],
              [
                45.886334,
                34.998143
              ],
              [
                45.886271,
                34.997986
              ],
              [
                45.886209,
                34.997725
              ],
              [
                45.886239,
                34.997405
              ],
              [
                45.886284,
                34.997055
              ],
              [
                45.886217,
                34.996819
              ],
              [
                45.886161,
                34.99651
              ],
              [
                45.88615,
                34.996297
              ],
              [
                45.886017,
                34.996129
              ],
              [
                45.88628,
                34.995927
              ],
              [
                45.886483,
                34.995862
              ],
              [
                45.886523,
                34.995583
              ],
              [
                45.886887,
                34.995246
              ],
              [
                45.887036,
                34.995168
              ],
              [
                45.886997,
                34.994973
              ],
              [
                45.886919,
                34.994739
              ],
              [
                45.886846,
                34.994541
              ],
              [
                45.886717,
                34.994152
              ],
              [
                45.886612,
                34.993964
              ],
              [
                45.886591,
                34.993795
              ],
              [
                45.886564,
                34.993603
              ],
              [
                45.886649,
                34.993363
              ],
              [
                45.886936,
                34.993189
              ],
              [
                45.887392,
                34.992971
              ],
              [
                45.887692,
                34.992692
              ],
              [
                45.887968,
                34.992493
              ],
              [
                45.887876,
                34.99227
              ],
              [
                45.887791,
                34.992028
              ],
              [
                45.887779,
                34.991721
              ],
              [
                45.888069,
                34.991467
              ],
              [
                45.88821,
                34.991315
              ],
              [
                45.888202,
                34.991003
              ],
              [
                45.888163,
                34.990677
              ],
              [
                45.888195,
                34.990428
              ],
              [
                45.888095,
                34.990282
              ],
              [
                45.8881,
                34.990084
              ],
              [
                45.888245,
                34.989814
              ],
              [
                45.888346,
                34.989707
              ],
              [
                45.888372,
                34.989609
              ],
              [
                45.888567,
                34.989428
              ],
              [
                45.88881,
                34.989277
              ],
              [
                45.888997,
                34.98915
              ],
              [
                45.889214,
                34.988923
              ],
              [
                45.889509,
                34.988842
              ],
              [
                45.889706,
                34.988732
              ],
              [
                45.889744,
                34.988598
              ],
              [
                45.889643,
                34.988359
              ],
              [
                45.889483,
                34.988242
              ],
              [
                45.889379,
                34.988012
              ],
              [
                45.889019,
                34.987904
              ],
              [
                45.888872,
                34.987705
              ],
              [
                45.888529,
                34.987556
              ],
              [
                45.888522,
                34.987421
              ],
              [
                45.888652,
                34.987271
              ],
              [
                45.888645,
                34.98709
              ],
              [
                45.888485,
                34.986776
              ],
              [
                45.888282,
                34.98649
              ],
              [
                45.888404,
                34.986308
              ],
              [
                45.888623,
                34.986133
              ],
              [
                45.888469,
                34.985842
              ],
              [
                45.888438,
                34.985655
              ],
              [
                45.888408,
                34.985497
              ],
              [
                45.888294,
                34.985316
              ],
              [
                45.888344,
                34.985073
              ],
              [
                45.888373,
                34.984795
              ],
              [
                45.888179,
                34.984741
              ],
              [
                45.888089,
                34.984612
              ],
              [
                45.888032,
                34.984519
              ],
              [
                45.88791,
                34.984354
              ],
              [
                45.887629,
                34.984184
              ],
              [
                45.887447,
                34.98387
              ],
              [
                45.887476,
                34.983654
              ],
              [
                45.887504,
                34.983391
              ],
              [
                45.887474,
                34.983256
              ],
              [
                45.887509,
                34.983062
              ],
              [
                45.88745,
                34.982684
              ],
              [
                45.887365,
                34.982352
              ],
              [
                45.887566,
                34.982105
              ],
              [
                45.88762,
                34.981922
              ],
              [
                45.887925,
                34.9816
              ],
              [
                45.888213,
                34.981403
              ],
              [
                45.888447,
                34.981371
              ],
              [
                45.888827,
                34.981101
              ],
              [
                45.889237,
                34.980811
              ],
              [
                45.889181,
                34.980639
              ],
              [
                45.889099,
                34.980147
              ],
              [
                45.889449,
                34.979845
              ],
              [
                45.889692,
                34.979629
              ],
              [
                45.889595,
                34.979276
              ],
              [
                45.889535,
                34.978846
              ],
              [
                45.889742,
                34.97849
              ],
              [
                45.88979,
                34.978219
              ],
              [
                45.8898381,
                34.9781093
              ],
              [
                45.889892,
                34.977981
              ],
              [
                45.889935,
                34.977757
              ],
              [
                45.889913,
                34.977475
              ],
              [
                45.889873,
                34.977211
              ],
              [
                45.889997,
                34.976949
              ],
              [
                45.890112,
                34.976629
              ],
              [
                45.8899761,
                34.976443
              ],
              [
                45.890567,
                34.976013
              ],
              [
                45.890866,
                34.975753
              ],
              [
                45.89084,
                34.975654
              ],
              [
                45.890731,
                34.975318
              ],
              [
                45.890879,
                34.975062
              ],
              [
                45.891123,
                34.974896
              ],
              [
                45.891203,
                34.974769
              ],
              [
                45.891337,
                34.974483
              ],
              [
                45.891229,
                34.974216
              ],
              [
                45.891106,
                34.973892
              ],
              [
                45.891094,
                34.97365
              ],
              [
                45.890964,
                34.973298
              ],
              [
                45.890723,
                34.973173
              ],
              [
                45.890541,
                34.972882
              ],
              [
                45.890292,
                34.97266
              ],
              [
                45.89022,
                34.972556
              ],
              [
                45.889933,
                34.97234
              ],
              [
                45.889772,
                34.972196
              ],
              [
                45.889608,
                34.972061
              ],
              [
                45.889574,
                34.971889
              ],
              [
                45.889475,
                34.971766
              ],
              [
                45.889301,
                34.971549
              ],
              [
                45.889139,
                34.97125
              ],
              [
                45.889335,
                34.971051
              ],
              [
                45.889683,
                34.970937
              ],
              [
                45.889772,
                34.970865
              ],
              [
                45.889906,
                34.97062
              ],
              [
                45.889846,
                34.970411
              ],
              [
                45.889949,
                34.969938
              ],
              [
                45.889937,
                34.969781
              ],
              [
                45.890081,
                34.969356
              ],
              [
                45.890688,
                34.969154
              ],
              [
                45.891158,
                34.969013
              ],
              [
                45.891351,
                34.968824
              ],
              [
                45.891624,
                34.96892
              ],
              [
                45.891844,
                34.968899
              ],
              [
                45.891966,
                34.968737
              ],
              [
                45.892092,
                34.968419
              ],
              [
                45.892274,
                34.968185
              ],
              [
                45.8926,
                34.967985
              ],
              [
                45.893025,
                34.967689
              ],
              [
                45.893044,
                34.967329
              ],
              [
                45.893065,
                34.966908
              ],
              [
                45.893062,
                34.966548
              ],
              [
                45.893312,
                34.966274
              ],
              [
                45.893551,
                34.96602
              ],
              [
                45.893624,
                34.965824
              ],
              [
                45.893655,
                34.965636
              ],
              [
                45.893784,
                34.965416
              ],
              [
                45.893839,
                34.965195
              ],
              [
                45.893952,
                34.964978
              ],
              [
                45.894164,
                34.964902
              ],
              [
                45.894389,
                34.964707
              ],
              [
                45.89435,
                34.964489
              ],
              [
                45.894237,
                34.964205
              ],
              [
                45.894262,
                34.963952
              ],
              [
                45.894307,
                34.963775
              ],
              [
                45.894392,
                34.963605
              ],
              [
                45.894739,
                34.963398
              ],
              [
                45.895061,
                34.963382
              ],
              [
                45.895352,
                34.963484
              ],
              [
                45.895604,
                34.963388
              ],
              [
                45.89584,
                34.963364
              ],
              [
                45.895843,
                34.963246
              ],
              [
                45.896062,
                34.963048
              ],
              [
                45.89621,
                34.962702
              ],
              [
                45.896041,
                34.962531
              ],
              [
                45.895929,
                34.962336
              ],
              [
                45.895995,
                34.962066
              ],
              [
                45.896146,
                34.961716
              ],
              [
                45.896166,
                34.961379
              ],
              [
                45.896417,
                34.960908
              ],
              [
                45.89658,
                34.960733
              ],
              [
                45.896725,
                34.960534
              ],
              [
                45.896864,
                34.960438
              ],
              [
                45.897,
                34.960222
              ],
              [
                45.897312,
                34.959992
              ],
              [
                45.897018,
                34.959595
              ],
              [
                45.89683,
                34.959498
              ],
              [
                45.896489,
                34.959377
              ],
              [
                45.896297,
                34.959223
              ],
              [
                45.896151,
                34.959161
              ],
              [
                45.895983,
                34.959036
              ],
              [
                45.895684,
                34.958856
              ],
              [
                45.895446,
                34.958786
              ],
              [
                45.895214,
                34.958673
              ],
              [
                45.895051,
                34.958501
              ],
              [
                45.895118,
                34.958324
              ],
              [
                45.895141,
                34.958044
              ],
              [
                45.89518,
                34.957606
              ],
              [
                45.895062,
                34.957388
              ],
              [
                45.895245,
                34.95705
              ],
              [
                45.895206,
                34.956833
              ],
              [
                45.895059,
                34.956634
              ],
              [
                45.894918,
                34.95657
              ],
              [
                45.8947,
                34.956553
              ],
              [
                45.894615,
                34.956423
              ],
              [
                45.894503,
                34.956293
              ],
              [
                45.894445,
                34.956177
              ],
              [
                45.894462,
                34.955916
              ],
              [
                45.894322,
                34.955834
              ],
              [
                45.89414,
                34.955848
              ],
              [
                45.893951,
                34.9559
              ],
              [
                45.89391,
                34.955786
              ],
              [
                45.893739,
                34.955582
              ],
              [
                45.893496,
                34.955424
              ],
              [
                45.893314,
                34.955312
              ],
              [
                45.893117,
                34.955244
              ],
              [
                45.892721,
                34.955151
              ],
              [
                45.892475,
                34.955312
              ],
              [
                45.892153,
                34.955506
              ],
              [
                45.892133,
                34.955229
              ],
              [
                45.892174,
                34.955062
              ],
              [
                45.892059,
                34.954834
              ],
              [
                45.891866,
                34.9547
              ],
              [
                45.89181,
                34.954462
              ],
              [
                45.891716,
                34.954272
              ],
              [
                45.891636,
                34.954113
              ],
              [
                45.891619,
                34.953896
              ],
              [
                45.891466,
                34.953413
              ],
              [
                45.891806,
                34.953333
              ],
              [
                45.892119,
                34.9533
              ],
              [
                45.892308,
                34.953205
              ],
              [
                45.892751,
                34.953173
              ],
              [
                45.893287,
                34.953067
              ],
              [
                45.893597,
                34.952936
              ],
              [
                45.893943,
                34.952729
              ],
              [
                45.893897,
                34.95255
              ],
              [
                45.893657,
                34.952166
              ],
              [
                45.893628,
                34.951881
              ],
              [
                45.893527,
                34.951576
              ],
              [
                45.893388,
                34.951409
              ],
              [
                45.893466,
                34.951188
              ],
              [
                45.893504,
                34.951008
              ],
              [
                45.89351,
                34.950834
              ],
              [
                45.89365,
                34.950724
              ],
              [
                45.893867,
                34.95069
              ],
              [
                45.894148,
                34.950621
              ],
              [
                45.894222,
                34.950364
              ],
              [
                45.894162,
                34.950042
              ],
              [
                45.894153,
                34.949898
              ],
              [
                45.894145,
                34.949782
              ],
              [
                45.893783,
                34.949688
              ],
              [
                45.893432,
                34.949704
              ],
              [
                45.893021,
                34.949881
              ],
              [
                45.892841,
                34.949989
              ],
              [
                45.892414,
                34.950018
              ],
              [
                45.892209,
                34.949919
              ],
              [
                45.892075,
                34.949836
              ],
              [
                45.891941,
                34.949625
              ],
              [
                45.891725,
                34.949552
              ],
              [
                45.891327,
                34.949492
              ],
              [
                45.890911,
                34.949431
              ],
              [
                45.890542,
                34.949445
              ],
              [
                45.890222,
                34.949381
              ],
              [
                45.890471,
                34.948905
              ],
              [
                45.890734,
                34.948506
              ],
              [
                45.891041,
                34.947884
              ],
              [
                45.891459,
                34.947364
              ],
              [
                45.891535,
                34.946961
              ],
              [
                45.891698,
                34.946374
              ],
              [
                45.891207,
                34.946411
              ],
              [
                45.891005,
                34.94648
              ],
              [
                45.890569,
                34.946493
              ],
              [
                45.890209,
                34.946604
              ],
              [
                45.889952,
                34.946636
              ],
              [
                45.88969,
                34.946777
              ],
              [
                45.889527,
                34.946582
              ],
              [
                45.88937,
                34.946389
              ],
              [
                45.889207,
                34.946325
              ],
              [
                45.889101,
                34.946156
              ],
              [
                45.88894,
                34.946012
              ],
              [
                45.888729,
                34.945741
              ],
              [
                45.888371,
                34.945486
              ],
              [
                45.888108,
                34.94543
              ],
              [
                45.887854,
                34.945382
              ],
              [
                45.887529,
                34.945281
              ],
              [
                45.88729,
                34.945273
              ],
              [
                45.886991,
                34.945228
              ],
              [
                45.886475,
                34.944997
              ],
              [
                45.885932,
                34.944837
              ],
              [
                45.885626,
                34.944784
              ],
              [
                45.885166,
                34.945012
              ],
              [
                45.88444,
                34.945339
              ],
              [
                45.884268,
                34.945351
              ],
              [
                45.883559,
                34.945441
              ],
              [
                45.882828,
                34.945446
              ],
              [
                45.882485,
                34.945451
              ],
              [
                45.88213,
                34.945538
              ],
              [
                45.881906,
                34.945476
              ],
              [
                45.881633,
                34.945117
              ],
              [
                45.881382,
                34.944867
              ],
              [
                45.881456,
                34.944629
              ],
              [
                45.881537,
                34.944309
              ],
              [
                45.881516,
                34.943704
              ],
              [
                45.881448,
                34.943529
              ],
              [
                45.881293,
                34.943299
              ],
              [
                45.88138,
                34.94296
              ],
              [
                45.881257,
                34.942569
              ],
              [
                45.880945,
                34.942279
              ],
              [
                45.880864,
                34.942031
              ],
              [
                45.880651,
                34.941797
              ],
              [
                45.880484,
                34.94178
              ],
              [
                45.880186,
                34.94174
              ],
              [
                45.879983,
                34.941542
              ],
              [
                45.879812,
                34.941428
              ],
              [
                45.879572,
                34.941326
              ],
              [
                45.879479,
                34.940986
              ],
              [
                45.879353,
                34.940718
              ],
              [
                45.879205,
                34.940627
              ],
              [
                45.879045,
                34.94053
              ],
              [
                45.879078,
                34.94035
              ],
              [
                45.879123,
                34.940089
              ],
              [
                45.879191,
                34.939852
              ],
              [
                45.879117,
                34.939631
              ],
              [
                45.878989,
                34.939396
              ],
              [
                45.878881,
                34.939242
              ],
              [
                45.878723,
                34.939172
              ],
              [
                45.878634,
                34.939071
              ],
              [
                45.878474,
                34.938997
              ],
              [
                45.87818,
                34.938928
              ],
              [
                45.877996,
                34.938736
              ],
              [
                45.877973,
                34.938473
              ],
              [
                45.878022,
                34.938206
              ],
              [
                45.878135,
                34.937947
              ],
              [
                45.878196,
                34.937786
              ],
              [
                45.878005,
                34.937661
              ],
              [
                45.877974,
                34.937474
              ],
              [
                45.877933,
                34.93736
              ],
              [
                45.87769,
                34.937249
              ],
              [
                45.877545,
                34.937101
              ],
              [
                45.877188,
                34.936959
              ],
              [
                45.876982,
                34.936753
              ],
              [
                45.876757,
                34.936667
              ],
              [
                45.876431,
                34.936603
              ],
              [
                45.876145,
                34.9365
              ],
              [
                45.875884,
                34.93643
              ],
              [
                45.875597,
                34.936495
              ],
              [
                45.875367,
                34.93641
              ],
              [
                45.875143,
                34.936263
              ],
              [
                45.874992,
                34.936027
              ],
              [
                45.874882,
                34.935799
              ],
              [
                45.874703,
                34.935737
              ],
              [
                45.874328,
                34.93564
              ],
              [
                45.874163,
                34.935633
              ],
              [
                45.87386,
                34.93557
              ],
              [
                45.873591,
                34.935642
              ],
              [
                45.873423,
                34.93578
              ],
              [
                45.873337,
                34.935945
              ],
              [
                45.873266,
                34.936216
              ],
              [
                45.873098,
                34.936241
              ],
              [
                45.872927,
                34.936277
              ],
              [
                45.872635,
                34.936413
              ],
              [
                45.872427,
                34.936348
              ],
              [
                45.87235,
                34.936118
              ],
              [
                45.872306,
                34.935924
              ],
              [
                45.87214,
                34.935719
              ],
              [
                45.871948,
                34.935562
              ],
              [
                45.871785,
                34.935371
              ],
              [
                45.871831,
                34.935091
              ],
              [
                45.871767,
                34.934755
              ],
              [
                45.871685,
                34.934569
              ],
              [
                45.87168,
                34.934373
              ],
              [
                45.871656,
                34.934021
              ],
              [
                45.871515,
                34.933474
              ],
              [
                45.871482,
                34.933237
              ],
              [
                45.871541,
                34.932898
              ],
              [
                45.871824,
                34.932599
              ],
              [
                45.871968,
                34.932306
              ],
              [
                45.872162,
                34.932032
              ],
              [
                45.872343,
                34.931924
              ],
              [
                45.872428,
                34.931773
              ],
              [
                45.872389,
                34.931579
              ],
              [
                45.872459,
                34.931346
              ],
              [
                45.872628,
                34.931044
              ],
              [
                45.872594,
                34.930867
              ],
              [
                45.872627,
                34.930711
              ],
              [
                45.872571,
                34.930365
              ],
              [
                45.87295,
                34.930086
              ],
              [
                45.873065,
                34.929724
              ],
              [
                45.872794,
                34.929613
              ],
              [
                45.872604,
                34.929469
              ],
              [
                45.872265,
                34.929398
              ],
              [
                45.871989,
                34.929331
              ],
              [
                45.871829,
                34.929172
              ],
              [
                45.871675,
                34.928989
              ],
              [
                45.871537,
                34.928934
              ],
              [
                45.871352,
                34.928958
              ],
              [
                45.871136,
                34.928973
              ],
              [
                45.871005,
                34.928814
              ],
              [
                45.870803,
                34.928579
              ],
              [
                45.870528,
                34.928323
              ],
              [
                45.870294,
                34.928309
              ],
              [
                45.869804,
                34.928355
              ],
              [
                45.869401,
                34.928385
              ],
              [
                45.869122,
                34.928159
              ],
              [
                45.868869,
                34.927984
              ],
              [
                45.868676,
                34.927695
              ],
              [
                45.868549,
                34.927507
              ],
              [
                45.86845,
                34.9273
              ],
              [
                45.868177,
                34.927269
              ],
              [
                45.868036,
                34.927201
              ],
              [
                45.867806,
                34.927139
              ],
              [
                45.867611,
                34.927062
              ],
              [
                45.867601,
                34.926937
              ],
              [
                45.867648,
                34.926638
              ],
              [
                45.867523,
                34.926417
              ],
              [
                45.867498,
                34.926276
              ],
              [
                45.867365,
                34.926065
              ],
              [
                45.867546,
                34.925873
              ],
              [
                45.867741,
                34.925778
              ],
              [
                45.867923,
                34.92552
              ],
              [
                45.868116,
                34.925396
              ],
              [
                45.868222,
                34.925199
              ],
              [
                45.86823,
                34.924968
              ],
              [
                45.868534,
                34.92466
              ],
              [
                45.868488,
                34.924397
              ],
              [
                45.868626,
                34.923969
              ],
              [
                45.868579,
                34.923767
              ],
              [
                45.868778,
                34.923272
              ],
              [
                45.868755,
                34.922877
              ],
              [
                45.869009,
                34.92264
              ],
              [
                45.869133,
                34.922463
              ],
              [
                45.869088,
                34.922138
              ],
              [
                45.86924,
                34.921787
              ],
              [
                45.869228,
                34.921391
              ],
              [
                45.868983,
                34.921187
              ],
              [
                45.868794,
                34.921108
              ],
              [
                45.868568,
                34.920999
              ],
              [
                45.868514,
                34.920788
              ],
              [
                45.868593,
                34.92046
              ],
              [
                45.868634,
                34.92027
              ],
              [
                45.868467,
                34.920169
              ],
              [
                45.86818,
                34.920169
              ],
              [
                45.868049,
                34.92008
              ],
              [
                45.86799,
                34.919936
              ],
              [
                45.868041,
                34.919744
              ],
              [
                45.867919,
                34.919663
              ],
              [
                45.867795,
                34.91953
              ],
              [
                45.867591,
                34.919351
              ],
              [
                45.867437,
                34.919084
              ],
              [
                45.867365,
                34.918759
              ],
              [
                45.867417,
                34.918506
              ],
              [
                45.867522,
                34.918211
              ],
              [
                45.867468,
                34.918047
              ],
              [
                45.867326,
                34.91789
              ],
              [
                45.866998,
                34.917668
              ],
              [
                45.86711,
                34.917554
              ],
              [
                45.867291,
                34.917404
              ],
              [
                45.86749,
                34.917303
              ],
              [
                45.867572,
                34.917119
              ],
              [
                45.867396,
                34.916917
              ],
              [
                45.867288,
                34.916631
              ],
              [
                45.867116,
                34.916489
              ],
              [
                45.867137,
                34.916307
              ],
              [
                45.867261,
                34.916004
              ],
              [
                45.86735,
                34.915758
              ],
              [
                45.867416,
                34.915512
              ],
              [
                45.867627,
                34.915216
              ],
              [
                45.867716,
                34.915083
              ],
              [
                45.867802,
                34.914847
              ],
              [
                45.867875,
                34.914651
              ],
              [
                45.867932,
                34.914346
              ],
              [
                45.867859,
                34.914022
              ],
              [
                45.867826,
                34.913587
              ],
              [
                45.867826,
                34.913371
              ],
              [
                45.867893,
                34.913064
              ],
              [
                45.867919,
                34.912792
              ],
              [
                45.868007,
                34.912458
              ],
              [
                45.868139,
                34.912181
              ],
              [
                45.86815,
                34.91157
              ],
              [
                45.868043,
                34.911355
              ],
              [
                45.867939,
                34.911125
              ],
              [
                45.868029,
                34.910865
              ],
              [
                45.868199,
                34.910516
              ],
              [
                45.868373,
                34.91034
              ],
              [
                45.868543,
                34.910257
              ],
              [
                45.868766,
                34.91025
              ],
              [
                45.868942,
                34.91034
              ],
              [
                45.869071,
                34.910317
              ],
              [
                45.869098,
                34.910223
              ],
              [
                45.869061,
                34.91008
              ],
              [
                45.869113,
                34.909977
              ],
              [
                45.869117,
                34.90984
              ],
              [
                45.86921,
                34.909613
              ],
              [
                45.869061,
                34.909316
              ],
              [
                45.868912,
                34.909179
              ],
              [
                45.868573,
                34.908959
              ],
              [
                45.868371,
                34.908742
              ],
              [
                45.868203,
                34.908331
              ],
              [
                45.868186,
                34.908067
              ],
              [
                45.86819,
                34.907757
              ],
              [
                45.868217,
                34.907579
              ],
              [
                45.868193,
                34.907288
              ],
              [
                45.868296,
                34.906881
              ],
              [
                45.868416,
                34.906559
              ],
              [
                45.868481,
                34.906224
              ],
              [
                45.868529,
                34.906037
              ],
              [
                45.868506,
                34.905882
              ],
              [
                45.868419,
                34.905654
              ],
              [
                45.868278,
                34.905459
              ],
              [
                45.868049,
                34.905228
              ],
              [
                45.867757,
                34.905145
              ],
              [
                45.867474,
                34.90514
              ],
              [
                45.867325,
                34.905129
              ],
              [
                45.867107,
                34.905112
              ],
              [
                45.866795,
                34.905191
              ],
              [
                45.866507,
                34.905102
              ],
              [
                45.866227,
                34.905064
              ],
              [
                45.866031,
                34.905179
              ],
              [
                45.865809,
                34.905256
              ],
              [
                45.865554,
                34.905274
              ],
              [
                45.865244,
                34.904945
              ],
              [
                45.865021,
                34.904713
              ],
              [
                45.864969,
                34.904141
              ],
              [
                45.864768,
                34.903606
              ],
              [
                45.864607,
                34.903372
              ],
              [
                45.864462,
                34.903094
              ],
              [
                45.864771,
                34.902743
              ],
              [
                45.864935,
                34.902442
              ],
              [
                45.864923,
                34.902219
              ],
              [
                45.864971,
                34.902056
              ],
              [
                45.864945,
                34.901979
              ],
              [
                45.86484,
                34.90193
              ],
              [
                45.864688,
                34.901809
              ],
              [
                45.864589,
                34.901736
              ],
              [
                45.864355,
                34.901656
              ],
              [
                45.86407,
                34.901617
              ],
              [
                45.863993,
                34.90154
              ],
              [
                45.863909,
                34.901375
              ],
              [
                45.863809,
                34.901258
              ],
              [
                45.863771,
                34.901134
              ],
              [
                45.863738,
                34.900987
              ],
              [
                45.863889,
                34.900871
              ],
              [
                45.86395,
                34.900711
              ],
              [
                45.864024,
                34.900514
              ],
              [
                45.864176,
                34.900334
              ],
              [
                45.864247,
                34.900083
              ],
              [
                45.864226,
                34.899898
              ],
              [
                45.864192,
                34.899747
              ],
              [
                45.86419,
                34.899459
              ],
              [
                45.864528,
                34.899355
              ],
              [
                45.864817,
                34.899299
              ],
              [
                45.86491,
                34.899175
              ],
              [
                45.8649,
                34.89901
              ],
              [
                45.864973,
                34.898853
              ],
              [
                45.864983,
                34.898739
              ],
              [
                45.865056,
                34.898497
              ],
              [
                45.86499,
                34.898401
              ],
              [
                45.864778,
                34.898182
              ],
              [
                45.864914,
                34.898005
              ],
              [
                45.864826,
                34.897782
              ],
              [
                45.864766,
                34.897622
              ],
              [
                45.86475,
                34.897193
              ],
              [
                45.864856,
                34.896949
              ],
              [
                45.865005,
                34.896712
              ],
              [
                45.864933,
                34.89659
              ],
              [
                45.864986,
                34.89649
              ],
              [
                45.86504,
                34.896328
              ],
              [
                45.864775,
                34.89619
              ],
              [
                45.864273,
                34.896045
              ],
              [
                45.86406,
                34.895952
              ],
              [
                45.863895,
                34.895783
              ],
              [
                45.8636,
                34.895836
              ],
              [
                45.86314,
                34.895611
              ],
              [
                45.863051,
                34.895469
              ],
              [
                45.862945,
                34.895308
              ],
              [
                45.862699,
                34.895028
              ],
              [
                45.862559,
                34.894931
              ],
              [
                45.862317,
                34.894794
              ],
              [
                45.862128,
                34.894836
              ],
              [
                45.861829,
                34.894831
              ],
              [
                45.861401,
                34.894942
              ],
              [
                45.861193,
                34.894934
              ],
              [
                45.86092,
                34.894919
              ],
              [
                45.860592,
                34.895107
              ],
              [
                45.860271,
                34.895254
              ],
              [
                45.860137,
                34.895462
              ],
              [
                45.859806,
                34.89566
              ],
              [
                45.859775,
                34.895863
              ],
              [
                45.859632,
                34.89632
              ],
              [
                45.859258,
                34.896265
              ],
              [
                45.858961,
                34.896119
              ],
              [
                45.858721,
                34.896031
              ],
              [
                45.858419,
                34.895864
              ],
              [
                45.858122,
                34.895778
              ],
              [
                45.857791,
                34.895849
              ],
              [
                45.857576,
                34.895833
              ],
              [
                45.857387,
                34.89579
              ],
              [
                45.857084,
                34.895556
              ],
              [
                45.856848,
                34.895377
              ],
              [
                45.856576,
                34.895367
              ],
              [
                45.856213,
                34.895291
              ],
              [
                45.855849,
                34.895666
              ],
              [
                45.855456,
                34.895843
              ],
              [
                45.855128,
                34.896072
              ],
              [
                45.854907,
                34.896147
              ],
              [
                45.854652,
                34.896197
              ],
              [
                45.854371,
                34.896111
              ],
              [
                45.854085,
                34.895892
              ],
              [
                45.853766,
                34.8959046
              ],
              [
                45.853462,
                34.8958467
              ],
              [
                45.853159,
                34.895745
              ],
              [
                45.852859,
                34.895803
              ],
              [
                45.852562,
                34.895801
              ],
              [
                45.852283,
                34.895635
              ],
              [
                45.852027,
                34.89564
              ],
              [
                45.851785,
                34.89557
              ],
              [
                45.85155,
                34.895418
              ],
              [
                45.851197,
                34.895381
              ],
              [
                45.850948,
                34.895196
              ],
              [
                45.850851,
                34.895132
              ],
              [
                45.850632,
                34.895018
              ],
              [
                45.850322,
                34.894951
              ],
              [
                45.849851,
                34.894576
              ],
              [
                45.849629,
                34.894516
              ],
              [
                45.849484,
                34.894766
              ],
              [
                45.849276,
                34.894911
              ],
              [
                45.849179,
                34.895234
              ],
              [
                45.848988,
                34.895528
              ],
              [
                45.848607,
                34.895686
              ],
              [
                45.848235,
                34.89599
              ],
              [
                45.848102,
                34.896198
              ],
              [
                45.847757,
                34.896515
              ],
              [
                45.84757,
                34.896651
              ],
              [
                45.847363,
                34.89671
              ],
              [
                45.847047,
                34.896771
              ],
              [
                45.846819,
                34.89686
              ],
              [
                45.846522,
                34.897034
              ],
              [
                45.846328,
                34.897253
              ],
              [
                45.846047,
                34.897464
              ],
              [
                45.845953,
                34.89767
              ],
              [
                45.845648,
                34.897944
              ],
              [
                45.845423,
                34.898217
              ],
              [
                45.845104,
                34.898265
              ],
              [
                45.844845,
                34.898283
              ],
              [
                45.844282,
                34.898252
              ],
              [
                45.844035,
                34.898161
              ],
              [
                45.843842,
                34.898146
              ],
              [
                45.843609,
                34.898236
              ],
              [
                45.843458,
                34.898421
              ],
              [
                45.843208,
                34.898667
              ],
              [
                45.843007,
                34.898685
              ],
              [
                45.84284,
                34.89853
              ],
              [
                45.842637,
                34.898431
              ],
              [
                45.842562,
                34.8983
              ],
              [
                45.842436,
                34.898192
              ],
              [
                45.842206,
                34.898102
              ],
              [
                45.841865,
                34.897852
              ],
              [
                45.841619,
                34.897679
              ],
              [
                45.841358,
                34.897667
              ],
              [
                45.841166,
                34.897782
              ],
              [
                45.841088,
                34.897985
              ],
              [
                45.840897,
                34.898149
              ],
              [
                45.840683,
                34.898312
              ],
              [
                45.840358,
                34.898401
              ],
              [
                45.840295,
                34.898682
              ],
              [
                45.840213,
                34.89876
              ],
              [
                45.83999,
                34.898911
              ],
              [
                45.839594,
                34.898864
              ],
              [
                45.839412,
                34.89887
              ],
              [
                45.839136,
                34.898734
              ],
              [
                45.838925,
                34.898713
              ],
              [
                45.838693,
                34.898637
              ],
              [
                45.838437,
                34.898646
              ],
              [
                45.838116,
                34.89877
              ],
              [
                45.83789,
                34.898824
              ],
              [
                45.837599,
                34.898785
              ],
              [
                45.837238,
                34.898759
              ],
              [
                45.836768,
                34.898648
              ],
              [
                45.836503,
                34.898664
              ],
              [
                45.835915,
                34.898646
              ],
              [
                45.835821,
                34.899027
              ],
              [
                45.835591,
                34.899301
              ],
              [
                45.83523,
                34.899406
              ],
              [
                45.834935,
                34.89948
              ],
              [
                45.83458,
                34.899457
              ],
              [
                45.834382,
                34.899596
              ],
              [
                45.834246,
                34.899795
              ],
              [
                45.834166,
                34.900012
              ],
              [
                45.834017,
                34.900398
              ],
              [
                45.833928,
                34.901034
              ],
              [
                45.833961,
                34.901456
              ],
              [
                45.834181,
                34.901812
              ],
              [
                45.8344655,
                34.902239
              ],
              [
                45.8345059,
                34.9024089
              ],
              [
                45.8345766,
                34.9026368
              ],
              [
                45.834481,
                34.902686
              ],
              [
                45.83424,
                34.902616
              ],
              [
                45.833962,
                34.902602
              ],
              [
                45.833737,
                34.902619
              ],
              [
                45.83355,
                34.902796
              ],
              [
                45.833388,
                34.902987
              ],
              [
                45.833149,
                34.903119
              ],
              [
                45.832981,
                34.903238
              ],
              [
                45.832899,
                34.903446
              ],
              [
                45.832767,
                34.903663
              ],
              [
                45.832543,
                34.903873
              ],
              [
                45.832126,
                34.903898
              ],
              [
                45.831813,
                34.903926
              ],
              [
                45.831648,
                34.903712
              ],
              [
                45.831468,
                34.903443
              ],
              [
                45.831363,
                34.903245
              ],
              [
                45.831178,
                34.90313
              ],
              [
                45.831005,
                34.903232
              ],
              [
                45.830942,
                34.903468
              ],
              [
                45.830841,
                34.903841
              ],
              [
                45.830637,
                34.903999
              ],
              [
                45.830382,
                34.904138
              ],
              [
                45.830065,
                34.904257
              ],
              [
                45.829912,
                34.904221
              ],
              [
                45.829753,
                34.904011
              ],
              [
                45.829549,
                34.904015
              ],
              [
                45.829437,
                34.904197
              ],
              [
                45.829285,
                34.904336
              ],
              [
                45.829175,
                34.904482
              ],
              [
                45.828931,
                34.904489
              ],
              [
                45.828663,
                34.904365
              ],
              [
                45.828507,
                34.904357
              ],
              [
                45.828289,
                34.904269
              ],
              [
                45.828036,
                34.904264
              ],
              [
                45.827884,
                34.904188
              ],
              [
                45.82772,
                34.904086
              ],
              [
                45.827634,
                34.90398
              ],
              [
                45.827469,
                34.903766
              ],
              [
                45.827318,
                34.903694
              ],
              [
                45.827129,
                34.903714
              ],
              [
                45.826999,
                34.903827
              ],
              [
                45.827011,
                34.904198
              ],
              [
                45.826884,
                34.904495
              ],
              [
                45.826919,
                34.904646
              ],
              [
                45.826846,
                34.904911
              ],
              [
                45.826717,
                34.905136
              ],
              [
                45.826596,
                34.905306
              ],
              [
                45.826543,
                34.90545
              ],
              [
                45.826353,
                34.905663
              ],
              [
                45.826089,
                34.905894
              ],
              [
                45.825993,
                34.906181
              ],
              [
                45.825763,
                34.906586
              ],
              [
                45.825705,
                34.906839
              ],
              [
                45.825655,
                34.90719
              ],
              [
                45.825625,
                34.907532
              ],
              [
                45.825606,
                34.907783
              ],
              [
                45.825466,
                34.90801
              ],
              [
                45.825117,
                34.908184
              ],
              [
                45.824994,
                34.908408
              ],
              [
                45.824894,
                34.908633
              ],
              [
                45.824756,
                34.90872
              ],
              [
                45.824532,
                34.908737
              ],
              [
                45.824312,
                34.908812
              ],
              [
                45.823982,
                34.908861
              ],
              [
                45.823753,
                34.908798
              ],
              [
                45.823522,
                34.908681
              ],
              [
                45.823312,
                34.908732
              ],
              [
                45.823127,
                34.908855
              ],
              [
                45.82312,
                34.909085
              ],
              [
                45.823148,
                34.909278
              ],
              [
                45.823087,
                34.909586
              ],
              [
                45.823113,
                34.909815
              ],
              [
                45.823051,
                34.909947
              ],
              [
                45.822814,
                34.910174
              ],
              [
                45.822554,
                34.910444
              ],
              [
                45.822408,
                34.91065
              ],
              [
                45.822139,
                34.910841
              ],
              [
                45.821821,
                34.910938
              ],
              [
                45.821298,
                34.910949
              ],
              [
                45.82053,
                34.911247
              ],
              [
                45.820041,
                34.911428
              ],
              [
                45.819456,
                34.911509
              ],
              [
                45.818866,
                34.911658
              ],
              [
                45.817818,
                34.911933
              ],
              [
                45.817497,
                34.9118
              ],
              [
                45.81728,
                34.911587
              ],
              [
                45.817074,
                34.911308
              ],
              [
                45.816825,
                34.911186
              ],
              [
                45.816417,
                34.911074
              ],
              [
                45.816311,
                34.911191
              ],
              [
                45.816178,
                34.911489
              ],
              [
                45.816073,
                34.911674
              ],
              [
                45.815904,
                34.911812
              ],
              [
                45.815771,
                34.912024
              ],
              [
                45.815539,
                34.912074
              ],
              [
                45.815274,
                34.912134
              ],
              [
                45.815042,
                34.912229
              ],
              [
                45.81478,
                34.912276
              ],
              [
                45.814457,
                34.91218
              ],
              [
                45.814152,
                34.91213
              ],
              [
                45.813775,
                34.912174
              ],
              [
                45.813579,
                34.912065
              ],
              [
                45.813316,
                34.911913
              ],
              [
                45.813121,
                34.911651
              ],
              [
                45.812889,
                34.91149
              ],
              [
                45.812668,
                34.911389
              ],
              [
                45.812305,
                34.911422
              ],
              [
                45.811929,
                34.91134
              ],
              [
                45.811629,
                34.911029
              ],
              [
                45.81091,
                34.91067
              ],
              [
                45.810575,
                34.910765
              ],
              [
                45.80984,
                34.9108
              ],
              [
                45.80929,
                34.910884
              ],
              [
                45.808836,
                34.911306
              ],
              [
                45.80857,
                34.911447
              ],
              [
                45.807792,
                34.911405
              ],
              [
                45.807338,
                34.911458
              ],
              [
                45.806984,
                34.911377
              ],
              [
                45.8067,
                34.911274
              ],
              [
                45.806171,
                34.911286
              ],
              [
                45.805595,
                34.911379
              ],
              [
                45.80513,
                34.911439
              ],
              [
                45.804433,
                34.911679
              ],
              [
                45.804029,
                34.911925
              ],
              [
                45.803524,
                34.912113
              ],
              [
                45.8032,
                34.912121
              ],
              [
                45.80241,
                34.912139
              ],
              [
                45.801946,
                34.912028
              ],
              [
                45.80151,
                34.911875
              ],
              [
                45.801162,
                34.911878
              ],
              [
                45.800666,
                34.911903
              ],
              [
                45.79988,
                34.911831
              ],
              [
                45.799234,
                34.911684
              ],
              [
                45.798639,
                34.911555
              ],
              [
                45.798202,
                34.911524
              ],
              [
                45.79802,
                34.911871
              ],
              [
                45.797698,
                34.912211
              ],
              [
                45.797286,
                34.912405
              ],
              [
                45.796719,
                34.91238
              ],
              [
                45.795592,
                34.911796
              ],
              [
                45.794816,
                34.911699
              ],
              [
                45.794449,
                34.91176
              ],
              [
                45.794171,
                34.911854
              ],
              [
                45.793938,
                34.911859
              ],
              [
                45.793662,
                34.911791
              ],
              [
                45.792912,
                34.911703
              ],
              [
                45.792188,
                34.911795
              ],
              [
                45.791625,
                34.911916
              ],
              [
                45.791121,
                34.91183
              ],
              [
                45.790552,
                34.911688
              ],
              [
                45.789945,
                34.911709
              ],
              [
                45.789475,
                34.912008
              ],
              [
                45.789303,
                34.912178
              ],
              [
                45.78882,
                34.912322
              ],
              [
                45.788431,
                34.912296
              ],
              [
                45.78826,
                34.9116462
              ],
              [
                45.7889698,
                34.9097008
              ],
              [
                45.7895676,
                34.90846
              ],
              [
                45.7897917,
                34.9076787
              ],
              [
                45.7900346,
                34.9059936
              ],
              [
                45.7904829,
                34.9044463
              ],
              [
                45.7899038,
                34.9038029
              ],
              [
                45.7905576,
                34.9013058
              ],
              [
                45.790782,
                34.900229
              ],
              [
                45.790917,
                34.899747
              ],
              [
                45.791163,
                34.899595
              ],
              [
                45.791116,
                34.899073
              ],
              [
                45.791187,
                34.898737
              ],
              [
                45.79142,
                34.898408
              ],
              [
                45.791758,
                34.897871
              ],
              [
                45.792088,
                34.89739
              ],
              [
                45.792171,
                34.896926
              ],
              [
                45.792099,
                34.89657
              ],
              [
                45.792365,
                34.895804
              ],
              [
                45.792545,
                34.895016
              ],
              [
                45.792871,
                34.894347
              ],
              [
                45.793134,
                34.893572
              ],
              [
                45.793346,
                34.893337
              ],
              [
                45.793453,
                34.892877
              ],
              [
                45.793634,
                34.892567
              ],
              [
                45.793733,
                34.892252
              ],
              [
                45.793871,
                34.891176
              ],
              [
                45.793934,
                34.890724
              ],
              [
                45.793985,
                34.8904
              ],
              [
                45.793866,
                34.890079
              ],
              [
                45.793715,
                34.889683
              ],
              [
                45.793922,
                34.889341
              ],
              [
                45.794191,
                34.888718
              ],
              [
                45.794466,
                34.888246
              ],
              [
                45.794439,
                34.887712
              ],
              [
                45.794364,
                34.887257
              ],
              [
                45.794199,
                34.88672
              ],
              [
                45.794395,
                34.886038
              ],
              [
                45.794791,
                34.885851
              ],
              [
                45.794951,
                34.885589
              ],
              [
                45.79513,
                34.884541
              ],
              [
                45.795419,
                34.884292
              ],
              [
                45.795581,
                34.883867
              ],
              [
                45.79588,
                34.883617
              ],
              [
                45.796109,
                34.882668
              ],
              [
                45.796045,
                34.882167
              ],
              [
                45.79629,
                34.881539
              ],
              [
                45.796383,
                34.880983
              ],
              [
                45.796195,
                34.880449
              ],
              [
                45.796261,
                34.880006
              ],
              [
                45.796396,
                34.879181
              ],
              [
                45.796531,
                34.878654
              ],
              [
                45.796701,
                34.87839
              ],
              [
                45.796982,
                34.878026
              ],
              [
                45.796949,
                34.877555
              ],
              [
                45.797067,
                34.876923
              ],
              [
                45.797431,
                34.87657
              ],
              [
                45.797512,
                34.876142
              ],
              [
                45.797723,
                34.875646
              ],
              [
                45.797964,
                34.875172
              ],
              [
                45.798022,
                34.874658
              ],
              [
                45.798038,
                34.8739
              ],
              [
                45.797845,
                34.87326
              ],
              [
                45.797971,
                34.872914
              ],
              [
                45.798204,
                34.872414
              ],
              [
                45.798052,
                34.871712
              ],
              [
                45.797807,
                34.871135
              ],
              [
                45.797894,
                34.870858
              ],
              [
                45.797775,
                34.86998
              ],
              [
                45.797893,
                34.869303
              ],
              [
                45.797871,
                34.868398
              ],
              [
                45.797825,
                34.867795
              ],
              [
                45.797816,
                34.866771
              ],
              [
                45.797735,
                34.86612
              ],
              [
                45.797716,
                34.865188
              ],
              [
                45.797622,
                34.864791
              ],
              [
                45.797656,
                34.864227
              ],
              [
                45.797426,
                34.863791
              ],
              [
                45.797644,
                34.863366
              ],
              [
                45.797939,
                34.862234
              ],
              [
                45.79774,
                34.861874
              ],
              [
                45.797186,
                34.861207
              ],
              [
                45.796913,
                34.860913
              ],
              [
                45.796751,
                34.860088
              ],
              [
                45.796651,
                34.859278
              ],
              [
                45.796356,
                34.858943
              ],
              [
                45.796315,
                34.858357
              ],
              [
                45.795935,
                34.857615
              ],
              [
                45.795986,
                34.857291
              ],
              [
                45.795752,
                34.856882
              ],
              [
                45.795173,
                34.856211
              ],
              [
                45.794597,
                34.855809
              ],
              [
                45.793831,
                34.855162
              ],
              [
                45.793461,
                34.854805
              ],
              [
                45.793041,
                34.854384
              ],
              [
                45.792569,
                34.85364
              ],
              [
                45.792074,
                34.853026
              ],
              [
                45.791532,
                34.852537
              ],
              [
                45.791054,
                34.852073
              ],
              [
                45.790518,
                34.851646
              ],
              [
                45.789429,
                34.850777
              ],
              [
                45.787894,
                34.850382
              ],
              [
                45.787209,
                34.849999
              ],
              [
                45.786707,
                34.849575
              ],
              [
                45.786506,
                34.849206
              ],
              [
                45.786083,
                34.848687
              ],
              [
                45.784851,
                34.848401
              ],
              [
                45.784427,
                34.848224
              ],
              [
                45.783909,
                34.84774
              ],
              [
                45.783184,
                34.847463
              ],
              [
                45.78281,
                34.847089
              ],
              [
                45.782425,
                34.846329
              ],
              [
                45.781915,
                34.8457
              ],
              [
                45.781299,
                34.845017
              ],
              [
                45.780314,
                34.844282
              ],
              [
                45.779676,
                34.843559
              ],
              [
                45.779056,
                34.842733
              ],
              [
                45.778639,
                34.84224
              ],
              [
                45.778273,
                34.841981
              ],
              [
                45.778091,
                34.841338
              ],
              [
                45.777718,
                34.841008
              ],
              [
                45.777125,
                34.840241
              ],
              [
                45.7769,
                34.839912
              ],
              [
                45.776809,
                34.839136
              ],
              [
                45.776367,
                34.838809
              ],
              [
                45.7761853,
                34.8381219
              ],
              [
                45.77595,
                34.837885
              ],
              [
                45.775825,
                34.837457
              ],
              [
                45.775507,
                34.836992
              ],
              [
                45.775255,
                34.836686
              ],
              [
                45.774805,
                34.836198
              ],
              [
                45.774364,
                34.835746
              ],
              [
                45.77384,
                34.835667
              ],
              [
                45.773193,
                34.835557
              ],
              [
                45.773108,
                34.835149
              ],
              [
                45.772402,
                34.83495
              ],
              [
                45.771779,
                34.835015
              ],
              [
                45.771355,
                34.835269
              ],
              [
                45.770807,
                34.835413
              ],
              [
                45.769886,
                34.835575
              ],
              [
                45.768689,
                34.835513
              ],
              [
                45.768116,
                34.835161
              ],
              [
                45.767934,
                34.834768
              ],
              [
                45.767866,
                34.834554
              ],
              [
                45.767678,
                34.834313
              ],
              [
                45.767025,
                34.834098
              ],
              [
                45.764366,
                34.832868
              ],
              [
                45.762188,
                34.832648
              ],
              [
                45.760078,
                34.832209
              ],
              [
                45.75886,
                34.832065
              ],
              [
                45.758165,
                34.832083
              ],
              [
                45.75756,
                34.832049
              ],
              [
                45.757145,
                34.831423
              ],
              [
                45.756527,
                34.831032
              ],
              [
                45.756108,
                34.830653
              ],
              [
                45.755812,
                34.830309
              ],
              [
                45.755617,
                34.830089
              ],
              [
                45.755236,
                34.829505
              ],
              [
                45.754962,
                34.829204
              ],
              [
                45.754581,
                34.829016
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554980,
        "tags": {
          "admin_level": "5",
          "alt_name:ku": "Şaristanê Ciwanro",
          "boundary": "administrative",
          "name": "شهرستان جوانرود",
          "name:en": "Javanrud County",
          "name:ku": "Ciwanro",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q349964",
          "wikipedia": "en:Javanrud County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.9220009,
                35.0956079
              ],
              [
                45.921987,
                35.095489
              ],
              [
                45.921986,
                35.092095
              ],
              [
                45.922083,
                35.091989
              ],
              [
                45.922215,
                35.091824
              ],
              [
                45.922333,
                35.091548
              ],
              [
                45.922449,
                35.091239
              ],
              [
                45.922598,
                35.090744
              ],
              [
                45.922649,
                35.090279
              ],
              [
                45.922637,
                35.089763
              ],
              [
                45.922532,
                35.089143
              ],
              [
                45.92226,
                35.08872
              ],
              [
                45.92191,
                35.088532
              ],
              [
                45.921437,
                35.088219
              ],
              [
                45.921317,
                35.087816
              ],
              [
                45.921395,
                35.087064
              ],
              [
                45.921689,
                35.086288
              ],
              [
                45.922123,
                35.085629
              ],
              [
                45.922367,
                35.085218
              ],
              [
                45.922672,
                35.08486
              ],
              [
                45.922897,
                35.084573
              ],
              [
                45.923035,
                35.084035
              ],
              [
                45.923179,
                35.083475
              ],
              [
                45.923345,
                35.083005
              ],
              [
                45.923507,
                35.082662
              ],
              [
                45.923554,
                35.08236
              ],
              [
                45.923754,
                35.081874
              ],
              [
                45.923664,
                35.081513
              ],
              [
                45.923567,
                35.081174
              ],
              [
                45.923516,
                35.080922
              ],
              [
                45.923424,
                35.080551
              ],
              [
                45.923409,
                35.080197
              ],
              [
                45.923421,
                35.079797
              ],
              [
                45.9235,
                35.079029
              ],
              [
                45.923411,
                35.078374
              ],
              [
                45.923298,
                35.077871
              ],
              [
                45.92315,
                35.077426
              ],
              [
                45.922974,
                35.07707
              ],
              [
                45.922797,
                35.076757
              ],
              [
                45.922651,
                35.07627
              ],
              [
                45.922436,
                35.075952
              ],
              [
                45.922299,
                35.075652
              ],
              [
                45.922236,
                35.075375
              ],
              [
                45.922248,
                35.075174
              ],
              [
                45.922194,
                35.074985
              ],
              [
                45.9221,
                35.074855
              ],
              [
                45.922146,
                35.074569
              ],
              [
                45.922141,
                35.07435
              ],
              [
                45.922122,
                35.074228
              ],
              [
                45.922102,
                35.074095
              ],
              [
                45.922215,
                35.073782
              ],
              [
                45.922294,
                35.07348
              ],
              [
                45.922266,
                35.072971
              ],
              [
                45.92222,
                35.072419
              ],
              [
                45.922217,
                35.072037
              ],
              [
                45.922117,
                35.071511
              ],
              [
                45.922232,
                35.071155
              ],
              [
                45.922504,
                35.070786
              ],
              [
                45.922785,
                35.070427
              ],
              [
                45.922982,
                35.070203
              ],
              [
                45.923027,
                35.069891
              ],
              [
                45.922946,
                35.069712
              ],
              [
                45.922853,
                35.069142
              ],
              [
                45.922576,
                35.068354
              ],
              [
                45.922667,
                35.068002
              ],
              [
                45.922956,
                35.067752
              ],
              [
                45.923274,
                35.06759
              ],
              [
                45.923437,
                35.067377
              ],
              [
                45.923269,
                35.066904
              ],
              [
                45.922962,
                35.066415
              ],
              [
                45.922729,
                35.065802
              ],
              [
                45.922646,
                35.065635
              ],
              [
                45.922441,
                35.065199
              ],
              [
                45.922237,
                35.064906
              ],
              [
                45.922017,
                35.064413
              ],
              [
                45.92201,
                35.063848
              ],
              [
                45.921741,
                35.062884
              ],
              [
                45.921331,
                35.062098
              ],
              [
                45.92122,
                35.061098
              ],
              [
                45.921221,
                35.059873
              ],
              [
                45.921064,
                35.058662
              ],
              [
                45.921292,
                35.057775
              ],
              [
                45.921119,
                35.05751
              ],
              [
                45.920826,
                35.056935
              ],
              [
                45.920668,
                35.056336
              ],
              [
                45.92053,
                35.055909
              ],
              [
                45.920292,
                35.055508
              ],
              [
                45.920406,
                35.055382
              ],
              [
                45.920578,
                35.05516
              ],
              [
                45.920766,
                35.054943
              ],
              [
                45.920932,
                35.054827
              ],
              [
                45.921204,
                35.05473
              ],
              [
                45.921483,
                35.054682
              ],
              [
                45.921756,
                35.054653
              ],
              [
                45.921855,
                35.054642
              ],
              [
                45.922128,
                35.054549
              ],
              [
                45.922506,
                35.054291
              ],
              [
                45.922809,
                35.054207
              ],
              [
                45.92313,
                35.054133
              ],
              [
                45.923578,
                35.054075
              ],
              [
                45.923938,
                35.053986
              ],
              [
                45.924286,
                35.053825
              ],
              [
                45.924616,
                35.053722
              ],
              [
                45.924795,
                35.053682
              ],
              [
                45.925127,
                35.053653
              ],
              [
                45.925538,
                35.053615
              ],
              [
                45.925952,
                35.053507
              ],
              [
                45.926382,
                35.053351
              ],
              [
                45.926848,
                35.053229
              ],
              [
                45.927246,
                35.053097
              ],
              [
                45.927579,
                35.053095
              ],
              [
                45.927922,
                35.052999
              ],
              [
                45.928302,
                35.052971
              ],
              [
                45.928589,
                35.052802
              ],
              [
                45.92903,
                35.052584
              ],
              [
                45.929191,
                35.052382
              ],
              [
                45.929392,
                35.052062
              ],
              [
                45.929394,
                35.051808
              ],
              [
                45.929526,
                35.051514
              ],
              [
                45.929691,
                35.051311
              ],
              [
                45.929687,
                35.051054
              ],
              [
                45.929865,
                35.05077
              ],
              [
                45.930147,
                35.050428
              ],
              [
                45.930435,
                35.05007
              ],
              [
                45.930678,
                35.04983
              ],
              [
                45.930798,
                35.049621
              ],
              [
                45.930986,
                35.049506
              ],
              [
                45.931183,
                35.049413
              ],
              [
                45.931278,
                35.049295
              ],
              [
                45.93135,
                35.049149
              ],
              [
                45.93133,
                35.048959
              ],
              [
                45.931265,
                35.048717
              ],
              [
                45.931277,
                35.048439
              ],
              [
                45.931381,
                35.048182
              ],
              [
                45.93151,
                35.047921
              ],
              [
                45.931548,
                35.04768
              ],
              [
                45.931537,
                35.047419
              ],
              [
                45.931399,
                35.047208
              ],
              [
                45.931271,
                35.046949
              ],
              [
                45.931244,
                35.046646
              ],
              [
                45.931178,
                35.046289
              ],
              [
                45.931114,
                35.045964
              ],
              [
                45.930963,
                35.045635
              ],
              [
                45.930795,
                35.045347
              ],
              [
                45.930543,
                35.045045
              ],
              [
                45.9318869,
                35.0441741
              ],
              [
                45.9360104,
                35.0410567
              ],
              [
                45.9393441,
                35.0377282
              ],
              [
                45.9446207,
                35.0338403
              ],
              [
                45.9587906,
                35.0205081
              ],
              [
                45.9674002,
                35.003008
              ],
              [
                45.9676768,
                35.0024487
              ],
              [
                45.9676769,
                34.99995
              ],
              [
                45.9660104,
                34.9916147
              ],
              [
                45.9662901,
                34.9910645
              ],
              [
                45.9674002,
                34.9896663
              ],
              [
                45.9696238,
                34.9896663
              ],
              [
                45.9710106,
                34.989946
              ],
              [
                45.9768466,
                34.992165
              ],
              [
                45.9787904,
                34.9921651
              ],
              [
                45.979067,
                34.9924448
              ],
              [
                45.9796232,
                34.9921651
              ],
              [
                45.9807333,
                34.9921651
              ],
              [
                45.9882336,
                34.9818904
              ],
              [
                45.9901805,
                34.9785617
              ],
              [
                45.9901805,
                34.978282
              ],
              [
                45.9904571,
                34.9771725
              ],
              [
                45.9912899,
                34.9757832
              ],
              [
                45.9957369,
                34.9710563
              ],
              [
                45.9960134,
                34.9693965
              ],
              [
                45.99629,
                34.9688372
              ],
              [
                45.9960135,
                34.9685575
              ],
              [
                45.9960135,
                34.9638306
              ],
              [
                46.0026801,
                34.9552245
              ],
              [
                46.0062903,
                34.9535647
              ],
              [
                46.0076802,
                34.9510568
              ],
              [
                46.0079568,
                34.9499472
              ],
              [
                46.008513,
                34.9488376
              ],
              [
                46.0107365,
                34.9452202
              ],
              [
                46.0118467,
                34.9446699
              ],
              [
                46.0176796,
                34.9446699
              ],
              [
                46.0182367,
                34.9443902
              ],
              [
                46.0193469,
                34.9443903
              ],
              [
                46.021293,
                34.9435604
              ],
              [
                46.0243462,
                34.9405022
              ],
              [
                46.0251798,
                34.9402225
              ],
              [
                46.0287932,
                34.9402225
              ],
              [
                46.0290698,
                34.9399429
              ],
              [
                46.0371261,
                34.938283
              ],
              [
                46.038516,
                34.9371644
              ],
              [
                46.03907,
                34.9363345
              ],
              [
                46.0532398,
                34.9249497
              ],
              [
                46.0690731,
                34.911057
              ],
              [
                46.0696293,
                34.9107773
              ],
              [
                46.0704629,
                34.9107774
              ],
              [
                46.0710161,
                34.9104977
              ],
              [
                46.0721294,
                34.9104977
              ],
              [
                46.072406,
                34.910218
              ],
              [
                46.076849,
                34.910218
              ],
              [
                46.077406,
                34.9104977
              ],
              [
                46.0824061,
                34.9104977
              ],
              [
                46.0826827,
                34.9102181
              ],
              [
                46.0835155,
                34.9102181
              ],
              [
                46.0849062,
                34.9102181
              ],
              [
                46.0854625,
                34.9104977
              ],
              [
                46.0868492,
                34.9104977
              ],
              [
                46.0987955,
                34.9157752
              ],
              [
                46.1096286,
                34.9241109
              ],
              [
                46.1112957,
                34.9241109
              ],
              [
                46.1121286,
                34.9243906
              ],
              [
                46.112409,
                34.9241109
              ],
              [
                46.1132418,
                34.9241109
              ],
              [
                46.1135192,
                34.9238312
              ],
              [
                46.1151857,
                34.9230013
              ],
              [
                46.1168521,
                34.9213324
              ],
              [
                46.1174091,
                34.9205025
              ],
              [
                46.1176857,
                34.9202227
              ],
              [
                46.1179623,
                34.9193928
              ],
              [
                46.1283805,
                34.9100828
              ],
              [
                46.1285188,
                34.9096679
              ],
              [
                46.1293516,
                34.9082786
              ],
              [
                46.1293517,
                34.9079989
              ],
              [
                46.1301852,
                34.9074487
              ],
              [
                46.1346322,
                34.9043904
              ],
              [
                46.1632455,
                34.8807813
              ],
              [
                46.163522,
                34.8805017
              ],
              [
                46.1671314,
                34.8788327
              ],
              [
                46.1687987,
                34.8788327
              ],
              [
                46.1690784,
                34.878553
              ],
              [
                46.1701886,
                34.8785531
              ],
              [
                46.1707448,
                34.8788327
              ],
              [
                46.1715784,
                34.8788327
              ],
              [
                46.1718551,
                34.878553
              ],
              [
                46.1793551,
                34.878553
              ],
              [
                46.1796317,
                34.8788327
              ],
              [
                46.1804646,
                34.8788327
              ],
              [
                46.2040775,
                34.888558
              ],
              [
                46.204358,
                34.8882783
              ],
              [
                46.2057448,
                34.8857794
              ],
              [
                46.2065776,
                34.8835601
              ],
              [
                46.2085246,
                34.8793921
              ],
              [
                46.2088011,
                34.8777231
              ],
              [
                46.2199147,
                34.8560532
              ],
              [
                46.2246343,
                34.8524445
              ],
              [
                46.2260242,
                34.8521649
              ],
              [
                46.2293578,
                34.8505049
              ],
              [
                46.2307478,
                34.8502252
              ],
              [
                46.2324142,
                34.8491155
              ],
              [
                46.2338009,
                34.8488359
              ],
              [
                46.2390807,
                34.8471669
              ],
              [
                46.2410245,
                34.8471668
              ],
              [
                46.2413043,
                34.8468872
              ],
              [
                46.2410245,
                34.8466165
              ],
              [
                46.2301908,
                34.8268948
              ],
              [
                46.2299142,
                34.824107
              ],
              [
                46.2301908,
                34.8218876
              ],
              [
                46.2304682,
                34.821617
              ],
              [
                46.2304681,
                34.820778
              ],
              [
                46.2315814,
                34.8166098
              ],
              [
                46.2601948,
                34.7682784
              ],
              [
                46.2604713,
                34.766889
              ],
              [
                46.2613042,
                34.7652199
              ],
              [
                46.2613042,
                34.7649492
              ],
              [
                46.2621378,
                34.7627207
              ],
              [
                46.2763047,
                34.7335513
              ],
              [
                46.2926941,
                34.7113288
              ],
              [
                46.2965842,
                34.70744
              ],
              [
                46.311861,
                34.6968926
              ],
              [
                46.3218644,
                34.6882759
              ],
              [
                46.3243636,
                34.6849374
              ],
              [
                46.3246403,
                34.6846668
              ],
              [
                46.327974,
                34.6779989
              ],
              [
                46.3396406,
                34.6552161
              ],
              [
                46.3404734,
                34.6546658
              ],
              [
                46.3585301,
                34.6441089
              ],
              [
                46.3593637,
                34.6441089
              ],
              [
                46.3596434,
                34.6438292
              ],
              [
                46.3724203,
                34.638271
              ],
              [
                46.3738101,
                34.6377207
              ],
              [
                46.3874199,
                34.6279938
              ],
              [
                46.3882534,
                34.6293833
              ],
              [
                46.3754765,
                34.655496
              ],
              [
                46.3743671,
                34.6566058
              ],
              [
                46.3743671,
                34.6571653
              ],
              [
                46.3718672,
                34.6599443
              ],
              [
                46.3690865,
                34.6666032
              ],
              [
                46.3690866,
                34.6702214
              ],
              [
                46.3696435,
                34.672441
              ],
              [
                46.3701998,
                34.6752201
              ],
              [
                46.3721436,
                34.6810488
              ],
              [
                46.3729764,
                34.6821586
              ],
              [
                46.3729764,
                34.682718
              ],
              [
                46.3910329,
                34.6982823
              ],
              [
                46.4063098,
                34.7049411
              ],
              [
                46.4385354,
                34.7257743
              ],
              [
                46.4388127,
                34.7260541
              ],
              [
                46.439369,
                34.7263337
              ],
              [
                46.4410354,
                34.7277232
              ],
              [
                46.4429792,
                34.728833
              ],
              [
                46.4652023,
                34.7318917
              ],
              [
                46.4668688,
                34.7318917
              ],
              [
                46.4704821,
                34.7327218
              ],
              [
                46.4713149,
                34.7327218
              ],
              [
                46.4727017,
                34.7332812
              ],
              [
                46.4740915,
                34.7335519
              ],
              [
                46.4796486,
                34.7363308
              ],
              [
                46.4849253,
                34.7418886
              ],
              [
                46.4860386,
                34.7438285
              ],
              [
                46.4921481,
                34.748836
              ],
              [
                46.4938153,
                34.749666
              ],
              [
                46.4996483,
                34.7541141
              ],
              [
                46.5324278,
                34.7616117
              ],
              [
                46.5335379,
                34.7624417
              ],
              [
                46.5338176,
                34.7630011
              ],
              [
                46.5343708,
                34.7632809
              ],
              [
                46.5349278,
                34.7635605
              ],
              [
                46.5374279,
                34.76495
              ],
              [
                46.5410412,
                34.7696686
              ],
              [
                46.5427077,
                34.7707784
              ],
              [
                46.5438178,
                34.771058
              ],
              [
                46.5468741,
                34.7710581
              ],
              [
                46.5513171,
                34.7721679
              ],
              [
                46.5527078,
                34.7721678
              ],
              [
                46.5529844,
                34.7724476
              ],
              [
                46.5538172,
                34.7724476
              ],
              [
                46.5543743,
                34.7727273
              ],
              [
                46.5554845,
                34.7727272
              ],
              [
                46.5565939,
                34.7732775
              ],
              [
                46.5574275,
                34.7732776
              ],
              [
                46.5599571,
                34.7746566
              ],
              [
                46.5594732,
                34.7877926
              ],
              [
                46.5645285,
                34.7887537
              ],
              [
                46.577741,
                34.7938654
              ],
              [
                46.5815369,
                34.7982201
              ],
              [
                46.5825167,
                34.8000404
              ],
              [
                46.5819454,
                34.8010124
              ],
              [
                46.5807608,
                34.8013939
              ],
              [
                46.5839195,
                34.8035496
              ],
              [
                46.5841341,
                34.8069324
              ],
              [
                46.5820312,
                34.8093637
              ],
              [
                46.5759158,
                34.8135919
              ],
              [
                46.5731477,
                34.8155298
              ],
              [
                46.5733302,
                34.8176261
              ],
              [
                46.5737915,
                34.8178728
              ],
              [
                46.574167,
                34.8181722
              ],
              [
                46.5742528,
                34.81841
              ],
              [
                46.5739953,
                34.8187271
              ],
              [
                46.5736842,
                34.818824
              ],
              [
                46.5733731,
                34.8187888
              ],
              [
                46.5723002,
                34.8184805
              ],
              [
                46.5712273,
                34.8182603
              ],
              [
                46.5696501,
                34.8177847
              ],
              [
                46.5686202,
                34.8196167
              ],
              [
                46.5691781,
                34.8208498
              ],
              [
                46.5697789,
                34.8208498
              ],
              [
                46.5706372,
                34.8229637
              ],
              [
                46.5704548,
                34.8234393
              ],
              [
                46.5699398,
                34.8235714
              ],
              [
                46.5694356,
                34.8235273
              ],
              [
                46.5672684,
                34.8238092
              ],
              [
                46.5670323,
                34.8237167
              ],
              [
                46.5668875,
                34.8234701
              ],
              [
                46.5666139,
                34.82336
              ],
              [
                46.5654015,
                34.8243729
              ],
              [
                46.5650046,
                34.8251215
              ],
              [
                46.5648866,
                34.8264954
              ],
              [
                46.5643394,
                34.8283713
              ],
              [
                46.5628266,
                34.8293753
              ],
              [
                46.5609813,
                34.8294986
              ],
              [
                46.5605628,
                34.8293753
              ],
              [
                46.5604126,
                34.8291903
              ],
              [
                46.5605199,
                34.8290406
              ],
              [
                46.561346,
                34.8290935
              ],
              [
                46.5624618,
                34.8284682
              ],
              [
                46.5642857,
                34.8260991
              ],
              [
                46.5630734,
                34.8254562
              ],
              [
                46.5611636,
                34.8250334
              ],
              [
                46.5593934,
                34.8247075
              ],
              [
                46.5584492,
                34.8247604
              ],
              [
                46.5576146,
                34.8243574
              ],
              [
                46.5562683,
                34.8219587
              ],
              [
                46.5526472,
                34.8200116
              ],
              [
                46.5380859,
                34.8238092
              ],
              [
                46.5343523,
                34.8290935
              ],
              [
                46.5343093,
                34.832123
              ],
              [
                46.533451,
                34.8349234
              ],
              [
                46.5353179,
                34.8359097
              ],
              [
                46.53732,
                34.8374156
              ],
              [
                46.5379786,
                34.8385163
              ],
              [
                46.5374851,
                34.8393616
              ],
              [
                46.5334296,
                34.8405768
              ],
              [
                46.5327215,
                34.8444512
              ],
              [
                46.5309619,
                34.8452261
              ],
              [
                46.5282222,
                34.8459564
              ],
              [
                46.5242672,
                34.8458953
              ],
              [
                46.5197181,
                34.8465645
              ],
              [
                46.5179586,
                34.8497694
              ],
              [
                46.5151262,
                34.8525516
              ],
              [
                46.5129299,
                34.8570066
              ],
              [
                46.5119432,
                34.8603871
              ],
              [
                46.5102767,
                34.8646656
              ],
              [
                46.5084336,
                34.8670415
              ],
              [
                46.507616,
                34.8688909
              ],
              [
                46.5047835,
                34.8733977
              ],
              [
                46.5023803,
                34.8757919
              ],
              [
                46.4979171,
                34.8770593
              ],
              [
                46.4931964,
                34.876496
              ],
              [
                46.4877891,
                34.8747357
              ],
              [
                46.4822101,
                34.871919
              ],
              [
                46.4765452,
                34.8698064
              ],
              [
                46.4762878,
                34.8628345
              ],
              [
                46.4766311,
                34.8583976
              ],
              [
                46.4753007,
                34.8568128
              ],
              [
                46.473172,
                34.8556445
              ],
              [
                46.4704484,
                34.852942
              ],
              [
                46.4665889,
                34.8531151
              ],
              [
                46.4627753,
                34.8548184
              ],
              [
                46.4595876,
                34.8565686
              ],
              [
                46.4539825,
                34.8571123
              ],
              [
                46.4408397,
                34.8598061
              ],
              [
                46.4382219,
                34.8606512
              ],
              [
                46.4281128,
                34.8629716
              ],
              [
                46.4197898,
                34.8636796
              ],
              [
                46.4159358,
                34.8638459
              ],
              [
                46.4136743,
                34.8643134
              ],
              [
                46.4098661,
                34.8674846
              ],
              [
                46.4069702,
                34.870718
              ],
              [
                46.4060665,
                34.8751131
              ],
              [
                46.4049196,
                34.877693
              ],
              [
                46.4052629,
                34.882305
              ],
              [
                46.4052629,
                34.8847341
              ],
              [
                46.4050977,
                34.8862713
              ],
              [
                46.4051342,
                34.88836
              ],
              [
                46.4060783,
                34.8904369
              ],
              [
                46.405894,
                34.8917608
              ],
              [
                46.4042329,
                34.8935697
              ],
              [
                46.4015293,
                34.8963504
              ],
              [
                46.3985252,
                34.9002574
              ],
              [
                46.3962078,
                34.9023692
              ],
              [
                46.3938903,
                34.903777
              ],
              [
                46.3923974,
                34.9061739
              ],
              [
                46.3919377,
                34.9068565
              ],
              [
                46.3904464,
                34.9085107
              ],
              [
                46.3890087,
                34.9097688
              ],
              [
                46.3869274,
                34.9109566
              ],
              [
                46.3864553,
                34.9121179
              ],
              [
                46.3839447,
                34.9145373
              ],
              [
                46.3808226,
                34.916376
              ],
              [
                46.3797068,
                34.9167015
              ],
              [
                46.3767028,
                34.9166751
              ],
              [
                46.375426,
                34.9170446
              ],
              [
                46.374439,
                34.9178628
              ],
              [
                46.3737738,
                34.9190768
              ],
              [
                46.3722396,
                34.9196486
              ],
              [
                46.3699651,
                34.9189712
              ],
              [
                46.3661134,
                34.9189888
              ],
              [
                46.3623905,
                34.9186106
              ],
              [
                46.3598263,
                34.9188745
              ],
              [
                46.3570368,
                34.9196398
              ],
              [
                46.3543653,
                34.9209594
              ],
              [
                46.349945,
                34.9217599
              ],
              [
                46.3480568,
                34.9230971
              ],
              [
                46.3468122,
                34.9240823
              ],
              [
                46.3437606,
                34.9250246
              ],
              [
                46.3414049,
                34.926475
              ],
              [
                46.340332,
                34.9273194
              ],
              [
                46.3398599,
                34.9290435
              ],
              [
                46.3376712,
                34.9318582
              ],
              [
                46.3361692,
                34.93221
              ],
              [
                46.3348388,
                34.9334063
              ],
              [
                46.333208,
                34.9353765
              ],
              [
                46.331706,
                34.9358338
              ],
              [
                46.3277578,
                34.9355876
              ],
              [
                46.3260841,
                34.9353765
              ],
              [
                46.3247537,
                34.9337933
              ],
              [
                46.3228654,
                34.9323156
              ],
              [
                46.3217067,
                34.930486
              ],
              [
                46.3217936,
                34.9290164
              ],
              [
                46.3211579,
                34.9282284
              ],
              [
                46.3185481,
                34.9283163
              ],
              [
                46.3148655,
                34.9287513
              ],
              [
                46.311267,
                34.9282587
              ],
              [
                46.3073871,
                34.9272602
              ],
              [
                46.3051183,
                34.9275065
              ],
              [
                46.3010858,
                34.9266991
              ],
              [
                46.2978069,
                34.9266288
              ],
              [
                46.2954949,
                34.9263469
              ],
              [
                46.2932659,
                34.9269801
              ],
              [
                46.2893471,
                34.9275612
              ],
              [
                46.2880826,
                34.9291138
              ],
              [
                46.2865963,
                34.9297386
              ],
              [
                46.2843051,
                34.9302331
              ],
              [
                46.2818085,
                34.9315038
              ],
              [
                46.2816614,
                34.9315899
              ],
              [
                46.2812483,
                34.9336349
              ],
              [
                46.2807034,
                34.9346016
              ],
              [
                46.27877,
                34.9357107
              ],
              [
                46.276095,
                34.9369538
              ],
              [
                46.2747472,
                34.9367408
              ],
              [
                46.2727885,
                34.9369322
              ],
              [
                46.2709216,
                34.9381861
              ],
              [
                46.2682402,
                34.939996
              ],
              [
                46.2664532,
                34.9404249
              ],
              [
                46.2654719,
                34.9413146
              ],
              [
                46.2601611,
                34.9430443
              ],
              [
                46.2576119,
                34.9434876
              ],
              [
                46.2560412,
                34.9463792
              ],
              [
                46.2533118,
                34.9473501
              ],
              [
                46.2510973,
                34.9479621
              ],
              [
                46.2451493,
                34.9533862
              ],
              [
                46.2435528,
                34.9557499
              ],
              [
                46.2414414,
                34.9568684
              ],
              [
                46.2341029,
                34.9584089
              ],
              [
                46.2316824,
                34.9576914
              ],
              [
                46.2294938,
                34.9575437
              ],
              [
                46.2258631,
                34.9609835
              ],
              [
                46.2121929,
                34.9733083
              ],
              [
                46.2073786,
                34.9773082
              ],
              [
                46.2053444,
                34.9792914
              ],
              [
                46.202512,
                34.9825193
              ],
              [
                46.2019455,
                34.9830889
              ],
              [
                46.2008125,
                34.9830046
              ],
              [
                46.1958944,
                34.9799033
              ],
              [
                46.1922123,
                34.9808105
              ],
              [
                46.1866762,
                34.9852619
              ],
              [
                46.1837923,
                34.9861479
              ],
              [
                46.1736729,
                34.9859792
              ],
              [
                46.1708147,
                34.986823
              ],
              [
                46.1631672,
                34.9857049
              ],
              [
                46.1584293,
                34.9848822
              ],
              [
                46.1524555,
                34.9844391
              ],
              [
                46.1496231,
                34.9858737
              ],
              [
                46.1470739,
                34.98638
              ],
              [
                46.14522,
                34.98638
              ],
              [
                46.1426193,
                34.9860846
              ],
              [
                46.138757,
                34.9844391
              ],
              [
                46.1372635,
                34.9840383
              ],
              [
                46.1354611,
                34.9853041
              ],
              [
                46.1340448,
                34.9871394
              ],
              [
                46.1319592,
                34.9891857
              ],
              [
                46.1314957,
                34.9894389
              ],
              [
                46.1234362,
                34.9922656
              ],
              [
                46.1204235,
                34.9926031
              ],
              [
                46.1176663,
                34.9938475
              ],
              [
                46.1139069,
                34.993067
              ],
              [
                46.1101217,
                34.9924763
              ],
              [
                46.1036587,
                34.9895653
              ],
              [
                46.1007748,
                34.9894598
              ],
              [
                46.0929213,
                34.9929615
              ],
              [
                46.0886212,
                34.9942272
              ],
              [
                46.0858145,
                34.9937631
              ],
              [
                46.0806646,
                34.995999
              ],
              [
                46.0797377,
                34.9973279
              ],
              [
                46.0762873,
                35.000977
              ],
              [
                46.0714464,
                35.0016941
              ],
              [
                46.0674811,
                35.0048789
              ],
              [
                46.0655756,
                35.0086542
              ],
              [
                46.0624126,
                35.0094211
              ],
              [
                46.0564903,
                35.0099484
              ],
              [
                46.0485081,
                35.0103491
              ],
              [
                46.0457014,
                35.0102014
              ],
              [
                46.0430492,
                35.0114668
              ],
              [
                46.0370497,
                35.0143771
              ],
              [
                46.0289644,
                35.0193961
              ],
              [
                46.0254368,
                35.022032
              ],
              [
                46.011043,
                35.0312464
              ],
              [
                46.0034727,
                35.0389208
              ],
              [
                46.0013098,
                35.042821
              ],
              [
                45.995336,
                35.0471215
              ],
              [
                45.9895939,
                35.0488922
              ],
              [
                45.9848045,
                35.0520331
              ],
              [
                45.9829248,
                35.0532978
              ],
              [
                45.9782385,
                35.0540145
              ],
              [
                45.9770769,
                35.0560047
              ],
              [
                45.9755834,
                35.0584286
              ],
              [
                45.9730085,
                35.0612951
              ],
              [
                45.9678586,
                35.0639929
              ],
              [
                45.9667514,
                35.0656579
              ],
              [
                45.965052,
                35.068503
              ],
              [
                45.9598506,
                35.073034
              ],
              [
                45.9573787,
                35.0753521
              ],
              [
                45.9530529,
                35.0797352
              ],
              [
                45.9504779,
                35.0821795
              ],
              [
                45.9463323,
                35.0843076
              ],
              [
                45.9450158,
                35.0860654
              ],
              [
                45.9428289,
                35.0869336
              ],
              [
                45.941326,
                35.088202
              ],
              [
                45.941271,
                35.0882698
              ],
              [
                45.9410196,
                35.088009
              ],
              [
                45.9407936,
                35.0872859
              ],
              [
                45.9397875,
                35.0863782
              ],
              [
                45.938704,
                35.0854494
              ],
              [
                45.9376979,
                35.084225
              ],
              [
                45.9373883,
                35.0834228
              ],
              [
                45.937053,
                35.0824728
              ],
              [
                45.9362017,
                35.0814806
              ],
              [
                45.9356599,
                35.0811428
              ],
              [
                45.934628,
                35.0812695
              ],
              [
                45.9332349,
                35.0817339
              ],
              [
                45.9324868,
                35.0816917
              ],
              [
                45.9319451,
                35.0816072
              ],
              [
                45.9312743,
                35.0816706
              ],
              [
                45.9307326,
                35.082135
              ],
              [
                45.9299845,
                35.0828739
              ],
              [
                45.9293395,
                35.0840561
              ],
              [
                45.9281786,
                35.0847949
              ],
              [
                45.9272757,
                35.0856816
              ],
              [
                45.9264244,
                35.0870326
              ],
              [
                45.9259084,
                35.088278
              ],
              [
                45.9254183,
                35.09079
              ],
              [
                45.9249023,
                35.0920987
              ],
              [
                45.9222968,
                35.0955393
              ],
              [
                45.9220009,
                35.0956079
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555009,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دالاهو",
          "name:en": "Dalahu County",
          "name:ku": "Dalahû",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q393274",
          "wikipedia": "en:Dalahu County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.9104564,
                34.5746557
              ],
              [
                45.9096228,
                34.5746558
              ],
              [
                45.9082329,
                34.5746557
              ],
              [
                45.9079563,
                34.574376
              ],
              [
                45.9065666,
                34.5727157
              ],
              [
                45.9062899,
                34.5707666
              ],
              [
                45.9160097,
                34.5527197
              ],
              [
                45.9161029,
                34.55244
              ],
              [
                45.9162895,
                34.5518804
              ],
              [
                45.9235131,
                34.5427215
              ],
              [
                45.9376791,
                34.5188267
              ],
              [
                45.9379564,
                34.518547
              ],
              [
                45.9385128,
                34.5174372
              ],
              [
                45.9385127,
                34.5165979
              ],
              [
                45.9407362,
                34.5129884
              ],
              [
                45.9407362,
                34.512438
              ],
              [
                45.9407363,
                34.5113281
              ],
              [
                45.9410127,
                34.5107686
              ],
              [
                45.9410128,
                34.5104888
              ],
              [
                45.9410129,
                34.5091082
              ],
              [
                45.9412893,
                34.5074298
              ],
              [
                45.9415699,
                34.5057694
              ],
              [
                45.9418464,
                34.5049302
              ],
              [
                45.9418464,
                34.5038293
              ],
              [
                45.9457365,
                34.4879923
              ],
              [
                45.9465693,
                34.4841031
              ],
              [
                45.9468459,
                34.4827134
              ],
              [
                45.9532359,
                34.4699354
              ],
              [
                45.9618462,
                34.4616062
              ],
              [
                45.9629596,
                34.4610467
              ],
              [
                45.9743496,
                34.4535477
              ],
              [
                45.9765692,
                34.4518782
              ],
              [
                46.0012926,
                34.4341007
              ],
              [
                46.0021253,
                34.4341007
              ],
              [
                46.0024058,
                34.4338209
              ],
              [
                46.0026823,
                34.4335502
              ],
              [
                46.0035159,
                34.4329908
              ],
              [
                46.0093361,
                34.4293037
              ],
              [
                46.020182,
                34.4224324
              ],
              [
                46.0424052,
                34.396325
              ],
              [
                46.0599088,
                34.3771571
              ],
              [
                46.0610182,
                34.3732675
              ],
              [
                46.0618517,
                34.3693779
              ],
              [
                46.0624089,
                34.3665984
              ],
              [
                46.0554619,
                34.3446594
              ],
              [
                46.0462955,
                34.3263211
              ],
              [
                46.0462954,
                34.325211
              ],
              [
                46.0462954,
                34.3249313
              ],
              [
                46.0462955,
                34.3235415
              ],
              [
                46.0462954,
                34.3221607
              ],
              [
                46.046572,
                34.3218809
              ],
              [
                46.046572,
                34.3213213
              ],
              [
                46.057409,
                34.3129915
              ],
              [
                46.062409,
                34.3110421
              ],
              [
                46.1029647,
                34.2932631
              ],
              [
                46.1037983,
                34.2924328
              ],
              [
                46.1074116,
                34.2904835
              ],
              [
                46.1096313,
                34.2890936
              ],
              [
                46.1349115,
                34.268264
              ],
              [
                46.1463017,
                34.2538148
              ],
              [
                46.1468579,
                34.2529844
              ],
              [
                46.146858,
                34.2521541
              ],
              [
                46.1468579,
                34.2518743
              ],
              [
                46.146858,
                34.2513148
              ],
              [
                46.1624146,
                34.223815
              ],
              [
                46.1832479,
                34.1988148
              ],
              [
                46.1932474,
                34.1874247
              ],
              [
                46.195471,
                34.1840944
              ],
              [
                46.2054712,
                34.1685434
              ],
              [
                46.2140808,
                34.147983
              ],
              [
                46.2210279,
                34.138813
              ],
              [
                46.2224177,
                34.1374321
              ],
              [
                46.2235272,
                34.1363219
              ],
              [
                46.2268609,
                34.1340926
              ],
              [
                46.2290843,
                34.1324319
              ],
              [
                46.2293609,
                34.132152
              ],
              [
                46.2354704,
                34.1321521
              ],
              [
                46.2360275,
                34.1324319
              ],
              [
                46.2826971,
                34.1357625
              ],
              [
                46.2832533,
                34.1354827
              ],
              [
                46.2849198,
                34.1354827
              ],
              [
                46.2854738,
                34.135212
              ],
              [
                46.28603,
                34.1352119
              ],
              [
                46.2863066,
                34.1349322
              ],
              [
                46.2876965,
                34.1349321
              ],
              [
                46.287973,
                34.1346524
              ],
              [
                46.2888066,
                34.1346523
              ],
              [
                46.2890863,
                34.1343726
              ],
              [
                46.28992,
                34.1343725
              ],
              [
                46.2913066,
                34.133813
              ],
              [
                46.29492,
                34.1332624
              ],
              [
                46.3143666,
                34.1210415
              ],
              [
                46.3151994,
                34.1210416
              ],
              [
                46.3157534,
                34.1207618
              ],
              [
                46.3171432,
                34.1207618
              ],
              [
                46.3207526,
                34.1257621
              ],
              [
                46.3265863,
                34.1293724
              ],
              [
                46.3290864,
                34.1310422
              ],
              [
                46.3546462,
                34.1468733
              ],
              [
                46.3946453,
                34.1835443
              ],
              [
                46.3974251,
                34.1857646
              ],
              [
                46.3982586,
                34.186595
              ],
              [
                46.3985351,
                34.1868747
              ],
              [
                46.3990914,
                34.1874253
              ],
              [
                46.4002017,
                34.1888152
              ],
              [
                46.4004782,
                34.1893748
              ],
              [
                46.4004782,
                34.1899253
              ],
              [
                46.4021446,
                34.1921547
              ],
              [
                46.4149245,
                34.2168752
              ],
              [
                46.4152011,
                34.2188157
              ],
              [
                46.4218683,
                34.2365955
              ],
              [
                46.4224245,
                34.2374349
              ],
              [
                46.4252011,
                34.249655
              ],
              [
                46.4252011,
                34.2499348
              ],
              [
                46.4279809,
                34.2507651
              ],
              [
                46.4290911,
                34.253265
              ],
              [
                46.4315911,
                34.2563155
              ],
              [
                46.4338145,
                34.2607649
              ],
              [
                46.4454811,
                34.2902047
              ],
              [
                46.4638133,
                34.3132724
              ],
              [
                46.465204,
                34.3154835
              ],
              [
                46.4721502,
                34.3232629
              ],
              [
                46.4860403,
                34.330212
              ],
              [
                46.4996499,
                34.3302121
              ],
              [
                46.530763,
                34.3413216
              ],
              [
                46.5347448,
                34.3501181
              ],
              [
                46.5340959,
                34.351321
              ],
              [
                46.5340959,
                34.3518805
              ],
              [
                46.5074296,
                34.3690994
              ],
              [
                46.5068733,
                34.3693792
              ],
              [
                46.4996497,
                34.3799289
              ],
              [
                46.4949262,
                34.3882675
              ],
              [
                46.4943731,
                34.388827
              ],
              [
                46.4885401,
                34.4029862
              ],
              [
                46.4882596,
                34.403266
              ],
              [
                46.485483,
                34.4085453
              ],
              [
                46.4854829,
                34.408825
              ],
              [
                46.4835368,
                34.4141042
              ],
              [
                46.4835368,
                34.417714
              ],
              [
                46.4829828,
                34.4207732
              ],
              [
                46.4829828,
                34.4299329
              ],
              [
                46.4832593,
                34.4316024
              ],
              [
                46.4874266,
                34.4413305
              ],
              [
                46.4882594,
                34.4429909
              ],
              [
                46.4968728,
                34.4591081
              ],
              [
                46.497426,
                34.4616078
              ],
              [
                46.4977064,
                34.4621582
              ],
              [
                46.4974259,
                34.4627178
              ],
              [
                46.4960392,
                34.4674373
              ],
              [
                46.4949259,
                34.4690978
              ],
              [
                46.4949259,
                34.4696572
              ],
              [
                46.4893726,
                34.4760462
              ],
              [
                46.4890929,
                34.4777156
              ],
              [
                46.4885397,
                34.4802153
              ],
              [
                46.4890929,
                34.4910441
              ],
              [
                46.4885397,
                34.4924427
              ],
              [
                46.4879827,
                34.4935527
              ],
              [
                46.4879826,
                34.4941031
              ],
              [
                46.4863162,
                34.4954928
              ],
              [
                46.4746496,
                34.4977126
              ],
              [
                46.473816,
                34.4979924
              ],
              [
                46.4663165,
                34.4979923
              ],
              [
                46.4649267,
                34.4979924
              ],
              [
                46.4640931,
                34.4979923
              ],
              [
                46.4635361,
                34.498272
              ],
              [
                46.4624267,
                34.4982721
              ],
              [
                46.4599265,
                34.4991023
              ],
              [
                46.459093,
                34.4991023
              ],
              [
                46.4504795,
                34.5041014
              ],
              [
                46.4446465,
                34.5099398
              ],
              [
                46.4407566,
                34.5165994
              ],
              [
                46.4402035,
                34.5171589
              ],
              [
                46.4402034,
                34.5177184
              ],
              [
                46.4363135,
                34.5218783
              ],
              [
                46.4360369,
                34.5224377
              ],
              [
                46.4288134,
                34.526327
              ],
              [
                46.4282563,
                34.5266067
              ],
              [
                46.4282563,
                34.5271571
              ],
              [
                46.4285369,
                34.5274369
              ],
              [
                46.4293613,
                34.5354113
              ],
              [
                46.4232652,
                34.5403309
              ],
              [
                46.4138951,
                34.5473336
              ],
              [
                46.4037932,
                34.5539767
              ],
              [
                46.3947221,
                34.5575298
              ],
              [
                46.3888956,
                34.5631675
              ],
              [
                46.3844742,
                34.5701499
              ],
              [
                46.3840761,
                34.5916031
              ],
              [
                46.3802003,
                34.591603
              ],
              [
                46.3796433,
                34.5918828
              ],
              [
                46.3743674,
                34.5918828
              ],
              [
                46.3735339,
                34.5921625
              ],
              [
                46.3704775,
                34.5921625
              ],
              [
                46.3702001,
                34.5924422
              ],
              [
                46.3568639,
                34.5960514
              ],
              [
                46.3546443,
                34.5966019
              ],
              [
                46.3538108,
                34.5966019
              ],
              [
                46.3535302,
                34.5968816
              ],
              [
                46.3529771,
                34.5968816
              ],
              [
                46.3524209,
                34.5971614
              ],
              [
                46.3513107,
                34.5971613
              ],
              [
                46.3438074,
                34.5988306
              ],
              [
                46.3415877,
                34.5988306
              ],
              [
                46.3257507,
                34.6029993
              ],
              [
                46.3213077,
                34.6035497
              ],
              [
                46.3174178,
                34.6035498
              ],
              [
                46.3168646,
                34.6038294
              ],
              [
                46.3151974,
                34.6038295
              ],
              [
                46.3149177,
                34.6041092
              ],
              [
                46.3138075,
                34.6041091
              ],
              [
                46.3135309,
                34.6043889
              ],
              [
                46.3121411,
                34.6043888
              ],
              [
                46.311584,
                34.6046686
              ],
              [
                46.3049175,
                34.6057694
              ],
              [
                46.3018612,
                34.6057694
              ],
              [
                46.301308,
                34.6060491
              ],
              [
                46.2999181,
                34.6060491
              ],
              [
                46.2979744,
                34.6066086
              ],
              [
                46.2976947,
                34.6068793
              ],
              [
                46.2957516,
                34.6068792
              ],
              [
                46.2951946,
                34.607159
              ],
              [
                46.2926945,
                34.607159
              ],
              [
                46.2921383,
                34.6074386
              ],
              [
                46.2915844,
                34.6071589
              ],
              [
                46.2735286,
                34.6071588
              ],
              [
                46.2721379,
                34.6068791
              ],
              [
                46.2665815,
                34.6066084
              ],
              [
                46.266305,
                34.6068791
              ],
              [
                46.2654714,
                34.6068792
              ],
              [
                46.2651948,
                34.6071588
              ],
              [
                46.2626947,
                34.6071589
              ],
              [
                46.2618619,
                34.6074386
              ],
              [
                46.2585282,
                34.6074386
              ],
              [
                46.2574149,
                34.6077183
              ],
              [
                46.2557485,
                34.6077183
              ],
              [
                46.2543587,
                34.607998
              ],
              [
                46.2488054,
                34.6088282
              ],
              [
                46.2385255,
                34.6129968
              ],
              [
                46.2365817,
                34.6141067
              ],
              [
                46.2276924,
                34.618546
              ],
              [
                46.2268588,
                34.618546
              ],
              [
                46.2268588,
                34.6188258
              ],
              [
                46.2263017,
                34.6188258
              ],
              [
                46.2260252,
                34.6191054
              ],
              [
                46.2157452,
                34.6238245
              ],
              [
                46.2129687,
                34.6260533
              ],
              [
                46.2026926,
                34.6363306
              ],
              [
                46.1957011,
                34.6403882
              ],
              [
                46.1940792,
                34.6413294
              ],
              [
                46.1938026,
                34.6410496
              ],
              [
                46.162413,
                34.6243839
              ],
              [
                46.1490767,
                34.6093873
              ],
              [
                46.14769,
                34.6079977
              ],
              [
                46.1468565,
                34.6068788
              ],
              [
                46.1460229,
                34.6066081
              ],
              [
                46.1454666,
                34.605769
              ],
              [
                46.1315765,
                34.5988301
              ],
              [
                46.1307437,
                34.59883
              ],
              [
                46.1143535,
                34.593831
              ],
              [
                46.1132433,
                34.5938311
              ],
              [
                46.11213,
                34.5932716
              ],
              [
                46.1112972,
                34.5932716
              ],
              [
                46.1054635,
                34.591882
              ],
              [
                46.1040736,
                34.591882
              ],
              [
                46.1035205,
                34.5916022
              ],
              [
                46.1007407,
                34.5916023
              ],
              [
                46.1004642,
                34.5913225
              ],
              [
                46.0962969,
                34.5907721
              ],
              [
                46.0937968,
                34.5907721
              ],
              [
                46.092964,
                34.590772
              ],
              [
                46.0921304,
                34.5904923
              ],
              [
                46.0896303,
                34.5902216
              ],
              [
                46.0862975,
                34.5902216
              ],
              [
                46.0857404,
                34.5899419
              ],
              [
                46.0835169,
                34.5899419
              ],
              [
                46.0815739,
                34.5893825
              ],
              [
                46.0790739,
                34.5893825
              ],
              [
                46.0787973,
                34.5896622
              ],
              [
                46.077684,
                34.5896622
              ],
              [
                46.0768504,
                34.5902216
              ],
              [
                46.0762972,
                34.5902216
              ],
              [
                46.075741,
                34.5899418
              ],
              [
                46.0749074,
                34.5899419
              ],
              [
                46.0746309,
                34.5896621
              ],
              [
                46.0732409,
                34.5896621
              ],
              [
                46.073241,
                34.5893824
              ],
              [
                46.0649079,
                34.5893824
              ],
              [
                46.0643509,
                34.5896621
              ],
              [
                46.0626845,
                34.5896622
              ],
              [
                46.0621275,
                34.5899419
              ],
              [
                46.0612946,
                34.5899418
              ],
              [
                46.0607407,
                34.5902216
              ],
              [
                46.0590742,
                34.5904922
              ],
              [
                46.0562945,
                34.5904923
              ],
              [
                46.0557414,
                34.5907719
              ],
              [
                46.0482381,
                34.5907719
              ],
              [
                46.0479607,
                34.5904922
              ],
              [
                46.0440708,
                34.589662
              ],
              [
                46.0426848,
                34.5896621
              ],
              [
                46.0421278,
                34.5893823
              ],
              [
                46.0412942,
                34.5893823
              ],
              [
                46.0410176,
                34.5891026
              ],
              [
                46.0315714,
                34.5874332
              ],
              [
                46.0293478,
                34.5871626
              ],
              [
                46.0090716,
                34.5852224
              ],
              [
                46.0087911,
                34.5854931
              ],
              [
                46.0074052,
                34.5841035
              ],
              [
                46.0062919,
                34.5829936
              ],
              [
                45.9799024,
                34.5757748
              ],
              [
                45.9785156,
                34.5757749
              ],
              [
                45.9779585,
                34.5754952
              ],
              [
                45.9749023,
                34.5749356
              ],
              [
                45.9726788,
                34.5749357
              ],
              [
                45.9682357,
                34.5743761
              ],
              [
                45.9521221,
                34.5732753
              ],
              [
                45.9504557,
                34.573546
              ],
              [
                45.9482361,
                34.573546
              ],
              [
                45.9468454,
                34.5738257
              ],
              [
                45.9440689,
                34.5738257
              ],
              [
                45.943236,
                34.5741054
              ],
              [
                45.9257325,
                34.5749356
              ],
              [
                45.9257325,
                34.5752152
              ],
              [
                45.9160096,
                34.5752152
              ],
              [
                45.9135096,
                34.5749355
              ],
              [
                45.9135096,
                34.5746558
              ],
              [
                45.9129564,
                34.5746557
              ],
              [
                45.9110095,
                34.5746558
              ],
              [
                45.910733,
                34.5749354
              ],
              [
                45.9104564,
                34.5746557
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555046,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان روانسر",
          "name:en": "Ravansar County",
          "name:ku": "Riwanser",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2609596"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.3874199,
                34.6279938
              ],
              [
                46.387977,
                34.6277231
              ],
              [
                46.3896433,
                34.6266042
              ],
              [
                46.3904769,
                34.6263336
              ],
              [
                46.3979763,
                34.6202159
              ],
              [
                46.4021428,
                34.6157765
              ],
              [
                46.4040897,
                34.6110483
              ],
              [
                46.4043664,
                34.6096677
              ],
              [
                46.404643,
                34.607439
              ],
              [
                46.4063103,
                34.6005001
              ],
              [
                46.4057563,
                34.5968817
              ],
              [
                46.4060388,
                34.596937
              ],
              [
                46.4071867,
                34.5971615
              ],
              [
                46.4075554,
                34.5972278
              ],
              [
                46.4087422,
                34.5974412
              ],
              [
                46.4109869,
                34.5978447
              ],
              [
                46.41336,
                34.5982714
              ],
              [
                46.4136651,
                34.5983262
              ],
              [
                46.4165958,
                34.5995435
              ],
              [
                46.4241227,
                34.6026695
              ],
              [
                46.4318693,
                34.6060495
              ],
              [
                46.4324232,
                34.6063292
              ],
              [
                46.4327029,
                34.6066089
              ],
              [
                46.4446461,
                34.6174369
              ],
              [
                46.4471461,
                34.6188264
              ],
              [
                46.4513126,
                34.6204958
              ],
              [
                46.4523981,
                34.6207166
              ],
              [
                46.473661,
                34.608448
              ],
              [
                46.4993316,
                34.5972639
              ],
              [
                46.5464488,
                34.5802279
              ],
              [
                46.5818471,
                34.565722
              ],
              [
                46.5922408,
                34.5650867
              ],
              [
                46.5943145,
                34.5649599
              ],
              [
                46.6054638,
                34.5642773
              ],
              [
                46.6138306,
                34.5625081
              ],
              [
                46.6200299,
                34.5635866
              ],
              [
                46.6299832,
                34.5653176
              ],
              [
                46.6325162,
                34.5621587
              ],
              [
                46.6335879,
                34.557196
              ],
              [
                46.6345633,
                34.5526789
              ],
              [
                46.6375372,
                34.5489906
              ],
              [
                46.6390749,
                34.5470835
              ],
              [
                46.6422966,
                34.5465748
              ],
              [
                46.6436645,
                34.5454275
              ],
              [
                46.6450983,
                34.5442249
              ],
              [
                46.6499219,
                34.5436071
              ],
              [
                46.6539898,
                34.543086
              ],
              [
                46.6587389,
                34.5424775
              ],
              [
                46.6676948,
                34.5437382
              ],
              [
                46.6835253,
                34.5437549
              ],
              [
                46.6855438,
                34.5433732
              ],
              [
                46.6907979,
                34.5423795
              ],
              [
                46.701895,
                34.5419416
              ],
              [
                46.7167834,
                34.5419014
              ],
              [
                46.7203682,
                34.5418915
              ],
              [
                46.727071,
                34.5411642
              ],
              [
                46.7297849,
                34.5413977
              ],
              [
                46.7311992,
                34.5391389
              ],
              [
                46.7338134,
                34.5371828
              ],
              [
                46.7364136,
                34.5359629
              ],
              [
                46.738258,
                34.5358774
              ],
              [
                46.7409012,
                34.5357548
              ],
              [
                46.7417227,
                34.5357167
              ],
              [
                46.7435494,
                34.5360553
              ],
              [
                46.7518825,
                34.5329964
              ],
              [
                46.7554958,
                34.5293869
              ],
              [
                46.756606,
                34.5274378
              ],
              [
                46.7568826,
                34.5254977
              ],
              [
                46.7568825,
                34.5252179
              ],
              [
                46.758549,
                34.524108
              ],
              [
                46.7593826,
                34.524108
              ],
              [
                46.7596623,
                34.5238283
              ],
              [
                46.7627154,
                34.5238283
              ],
              [
                46.7696625,
                34.5246585
              ],
              [
                46.7702187,
                34.5249382
              ],
              [
                46.7724392,
                34.5249382
              ],
              [
                46.7727188,
                34.525218
              ],
              [
                46.776329,
                34.5252181
              ],
              [
                46.776886,
                34.5254978
              ],
              [
                46.7824386,
                34.5254978
              ],
              [
                46.7843854,
                34.5257684
              ],
              [
                46.785219,
                34.5260482
              ],
              [
                46.7866089,
                34.5260482
              ],
              [
                46.7899418,
                34.5268874
              ],
              [
                46.791052,
                34.5268874
              ],
              [
                46.7921621,
                34.5274379
              ],
              [
                46.7932754,
                34.5274378
              ],
              [
                46.795495,
                34.5282681
              ],
              [
                46.7959286,
                34.5287994
              ],
              [
                46.79606,
                34.5304243
              ],
              [
                46.7960153,
                34.531551
              ],
              [
                46.7965818,
                34.5315763
              ],
              [
                46.797087,
                34.5318285
              ],
              [
                46.7980975,
                34.5321943
              ],
              [
                46.8007769,
                34.5329511
              ],
              [
                46.8115862,
                34.5343763
              ],
              [
                46.8160517,
                34.5349366
              ],
              [
                46.8163322,
                34.5352164
              ],
              [
                46.817165,
                34.5352164
              ],
              [
                46.8224416,
                34.5382754
              ],
              [
                46.823555,
                34.5424443
              ],
              [
                46.8229987,
                34.5441047
              ],
              [
                46.8227182,
                34.5443844
              ],
              [
                46.8224416,
                34.5452146
              ],
              [
                46.8179986,
                34.5510529
              ],
              [
                46.8121648,
                34.5538321
              ],
              [
                46.8102188,
                34.5543825
              ],
              [
                46.7929956,
                34.5593815
              ],
              [
                46.7918854,
                34.5602207
              ],
              [
                46.7904956,
                34.5624404
              ],
              [
                46.7910518,
                34.5660499
              ],
              [
                46.7974418,
                34.5713286
              ],
              [
                46.7988286,
                34.571888
              ],
              [
                46.809385,
                34.5810559
              ],
              [
                46.8096655,
                34.5816064
              ],
              [
                46.811885,
                34.5838261
              ],
              [
                46.8149413,
                34.5896642
              ],
              [
                46.8157748,
                34.6013313
              ],
              [
                46.8154983,
                34.601602
              ],
              [
                46.8124419,
                34.6132691
              ],
              [
                46.8107747,
                34.6154979
              ],
              [
                46.8104982,
                34.616328
              ],
              [
                46.792718,
                34.6321636
              ],
              [
                46.7904953,
                34.634663
              ],
              [
                46.778552,
                34.6477193
              ],
              [
                46.778552,
                34.6482787
              ],
              [
                46.7766051,
                34.6502186
              ],
              [
                46.7677189,
                34.6652238
              ],
              [
                46.7632719,
                34.6780002
              ],
              [
                46.7629953,
                34.6793897
              ],
              [
                46.7632719,
                34.681889
              ],
              [
                46.7635485,
                34.6821597
              ],
              [
                46.7635485,
                34.6824394
              ],
              [
                46.7632719,
                34.6827191
              ],
              [
                46.7629953,
                34.6843882
              ],
              [
                46.7947215,
                34.7076365
              ],
              [
                46.7941903,
                34.7094175
              ],
              [
                46.787238,
                34.7124726
              ],
              [
                46.7859577,
                34.7151566
              ],
              [
                46.7870051,
                34.7291275
              ],
              [
                46.7872969,
                34.7369983
              ],
              [
                46.7718337,
                34.7442334
              ],
              [
                46.7592113,
                34.7497603
              ],
              [
                46.7627477,
                34.7530376
              ],
              [
                46.7601728,
                34.7532139
              ],
              [
                46.7545938,
                34.7567046
              ],
              [
                46.7467832,
                34.7630156
              ],
              [
                46.7440795,
                34.7687268
              ],
              [
                46.7384147,
                34.7821572
              ],
              [
                46.7325782,
                34.7922374
              ],
              [
                46.729243,
                34.8002393
              ],
              [
                46.7250318,
                34.8075361
              ],
              [
                46.7294164,
                34.8119864
              ],
              [
                46.7244939,
                34.8207874
              ],
              [
                46.7232755,
                34.8230268
              ],
              [
                46.7186972,
                34.8282178
              ],
              [
                46.7179685,
                34.8329954
              ],
              [
                46.7136526,
                34.8365614
              ],
              [
                46.7037204,
                34.8430064
              ],
              [
                46.6935682,
                34.8502273
              ],
              [
                46.6815948,
                34.8580806
              ],
              [
                46.6758871,
                34.8585032
              ],
              [
                46.6715526,
                34.8597709
              ],
              [
                46.6694068,
                34.8587497
              ],
              [
                46.666789,
                34.8588201
              ],
              [
                46.6626691,
                34.8612499
              ],
              [
                46.6598367,
                34.8624471
              ],
              [
                46.6583347,
                34.8635387
              ],
              [
                46.6516828,
                34.8660388
              ],
              [
                46.6446018,
                34.8693838
              ],
              [
                46.6427993,
                34.8693838
              ],
              [
                46.6394519,
                34.8659684
              ],
              [
                46.6369199,
                34.864419
              ],
              [
                46.6347312,
                34.8634331
              ],
              [
                46.6324938,
                34.8611519
              ],
              [
                46.6286674,
                34.8615275
              ],
              [
                46.6227475,
                34.8668511
              ],
              [
                46.6170798,
                34.870475
              ],
              [
                46.6133021,
                34.8725809
              ],
              [
                46.611307,
                34.8745316
              ],
              [
                46.6088104,
                34.8756862
              ],
              [
                46.601901,
                34.8804391
              ],
              [
                46.5978241,
                34.88403
              ],
              [
                46.5950775,
                34.8853325
              ],
              [
                46.5915155,
                34.8877615
              ],
              [
                46.5891981,
                34.8878671
              ],
              [
                46.5865389,
                34.8873241
              ],
              [
                46.5842199,
                34.8881839
              ],
              [
                46.5802502,
                34.8888352
              ],
              [
                46.5731263,
                34.88968
              ],
              [
                46.5708518,
                34.8898736
              ],
              [
                46.5701651,
                34.890824
              ],
              [
                46.5691781,
                34.8914577
              ],
              [
                46.5679121,
                34.8920737
              ],
              [
                46.5664744,
                34.8919681
              ],
              [
                46.563878,
                34.8921617
              ],
              [
                46.5623545,
                34.8928657
              ],
              [
                46.5611958,
                34.8937985
              ],
              [
                46.5561103,
                34.8956465
              ],
              [
                46.5529775,
                34.897864
              ],
              [
                46.5506387,
                34.8999758
              ],
              [
                46.5495013,
                34.9015949
              ],
              [
                46.5462398,
                34.9060647
              ],
              [
                46.5448665,
                34.9074725
              ],
              [
                46.5431499,
                34.9101472
              ],
              [
                46.5431499,
                34.9122587
              ],
              [
                46.5440346,
                34.9146662
              ],
              [
                46.5468406,
                34.9181707
              ],
              [
                46.5477599,
                34.9199799
              ],
              [
                46.5452956,
                34.9220415
              ],
              [
                46.5415461,
                34.9264755
              ],
              [
                46.5374395,
                34.9285728
              ],
              [
                46.5347904,
                34.9287532
              ],
              [
                46.531906,
                34.9299231
              ],
              [
                46.5292195,
                34.9317859
              ],
              [
                46.5290598,
                34.9328682
              ],
              [
                46.5286315,
                34.9345182
              ],
              [
                46.5321421,
                34.9405481
              ],
              [
                46.5367324,
                34.9432113
              ],
              [
                46.5391555,
                34.9449356
              ],
              [
                46.5396085,
                34.9469968
              ],
              [
                46.5427247,
                34.9519705
              ],
              [
                46.5468255,
                34.9508431
              ],
              [
                46.5495014,
                34.9518048
              ],
              [
                46.5524196,
                34.9546539
              ],
              [
                46.5544366,
                34.9575029
              ],
              [
                46.5551662,
                34.9620752
              ],
              [
                46.548171,
                34.9673858
              ],
              [
                46.5416391,
                34.9752628
              ],
              [
                46.5348445,
                34.9836719
              ],
              [
                46.53128,
                34.9872983
              ],
              [
                46.5235767,
                34.9864368
              ],
              [
                46.5117988,
                34.9837631
              ],
              [
                46.5006299,
                34.9803876
              ],
              [
                46.4927772,
                34.9774355
              ],
              [
                46.4864568,
                34.9760991
              ],
              [
                46.4789132,
                34.9750289
              ],
              [
                46.4712941,
                34.9765607
              ],
              [
                46.4645758,
                34.9793239
              ],
              [
                46.4617188,
                34.9792672
              ],
              [
                46.455349,
                34.9783387
              ],
              [
                46.4502659,
                34.976839
              ],
              [
                46.4412688,
                34.977795
              ],
              [
                46.4338874,
                34.9769862
              ],
              [
                46.4284801,
                34.9736104
              ],
              [
                46.4186954,
                34.9684057
              ],
              [
                46.4146184,
                34.9679133
              ],
              [
                46.411786,
                34.967843
              ],
              [
                46.4074516,
                34.9685024
              ],
              [
                46.4066362,
                34.9662164
              ],
              [
                46.4092755,
                34.9614861
              ],
              [
                46.4118182,
                34.9599694
              ],
              [
                46.4114588,
                34.9586416
              ],
              [
                46.4093184,
                34.9579602
              ],
              [
                46.4071029,
                34.9581228
              ],
              [
                46.4067167,
                34.9578239
              ],
              [
                46.4058369,
                34.9580481
              ],
              [
                46.4053166,
                34.9577843
              ],
              [
                46.4050483,
                34.9572523
              ],
              [
                46.4042061,
                34.956839
              ],
              [
                46.4028328,
                34.9570325
              ],
              [
                46.4014059,
                34.9569138
              ],
              [
                46.4006281,
                34.9559553
              ],
              [
                46.3989115,
                34.9548474
              ],
              [
                46.3994479,
                34.9543725
              ],
              [
                46.4002418,
                34.9535987
              ],
              [
                46.3993513,
                34.9523148
              ],
              [
                46.3994694,
                34.9515673
              ],
              [
                46.3991582,
                34.9499141
              ],
              [
                46.3992119,
                34.948252
              ],
              [
                46.3981175,
                34.9460271
              ],
              [
                46.3973343,
                34.944875
              ],
              [
                46.395843,
                34.9447695
              ],
              [
                46.3933754,
                34.9455522
              ],
              [
                46.3948882,
                34.9410669
              ],
              [
                46.3945877,
                34.9392288
              ],
              [
                46.3944268,
                34.933978
              ],
              [
                46.3958645,
                34.9272402
              ],
              [
                46.3980746,
                34.9256041
              ],
              [
                46.4003384,
                34.9237656
              ],
              [
                46.4044797,
                34.916684
              ],
              [
                46.4064377,
                34.9148122
              ],
              [
                46.4064254,
                34.9144271
              ],
              [
                46.4064216,
                34.9141525
              ],
              [
                46.4050698,
                34.9123467
              ],
              [
                46.3991904,
                34.9094433
              ],
              [
                46.3923974,
                34.9061739
              ],
              [
                46.3938903,
                34.903777
              ],
              [
                46.3962078,
                34.9023692
              ],
              [
                46.3985252,
                34.9002574
              ],
              [
                46.4015293,
                34.8963504
              ],
              [
                46.4042329,
                34.8935697
              ],
              [
                46.405894,
                34.8917608
              ],
              [
                46.4060783,
                34.8904369
              ],
              [
                46.4051342,
                34.88836
              ],
              [
                46.4050977,
                34.8862713
              ],
              [
                46.4052629,
                34.8847341
              ],
              [
                46.4052629,
                34.882305
              ],
              [
                46.4049196,
                34.877693
              ],
              [
                46.4060665,
                34.8751131
              ],
              [
                46.4069702,
                34.870718
              ],
              [
                46.4098661,
                34.8674846
              ],
              [
                46.4136743,
                34.8643134
              ],
              [
                46.4159358,
                34.8638459
              ],
              [
                46.4197898,
                34.8636796
              ],
              [
                46.4281128,
                34.8629716
              ],
              [
                46.4382219,
                34.8606512
              ],
              [
                46.4408397,
                34.8598061
              ],
              [
                46.4539825,
                34.8571123
              ],
              [
                46.4595876,
                34.8565686
              ],
              [
                46.4627753,
                34.8548184
              ],
              [
                46.4665889,
                34.8531151
              ],
              [
                46.4704484,
                34.852942
              ],
              [
                46.473172,
                34.8556445
              ],
              [
                46.4753007,
                34.8568128
              ],
              [
                46.4766311,
                34.8583976
              ],
              [
                46.4762878,
                34.8628345
              ],
              [
                46.4765452,
                34.8698064
              ],
              [
                46.4822101,
                34.871919
              ],
              [
                46.4877891,
                34.8747357
              ],
              [
                46.4931964,
                34.876496
              ],
              [
                46.4979171,
                34.8770593
              ],
              [
                46.5023803,
                34.8757919
              ],
              [
                46.5047835,
                34.8733977
              ],
              [
                46.507616,
                34.8688909
              ],
              [
                46.5084336,
                34.8670415
              ],
              [
                46.5102767,
                34.8646656
              ],
              [
                46.5119432,
                34.8603871
              ],
              [
                46.5129299,
                34.8570066
              ],
              [
                46.5151262,
                34.8525516
              ],
              [
                46.5179586,
                34.8497694
              ],
              [
                46.5197181,
                34.8465645
              ],
              [
                46.5242672,
                34.8458953
              ],
              [
                46.5282222,
                34.8459564
              ],
              [
                46.5309619,
                34.8452261
              ],
              [
                46.5327215,
                34.8444512
              ],
              [
                46.5334296,
                34.8405768
              ],
              [
                46.5374851,
                34.8393616
              ],
              [
                46.5379786,
                34.8385163
              ],
              [
                46.53732,
                34.8374156
              ],
              [
                46.5353179,
                34.8359097
              ],
              [
                46.533451,
                34.8349234
              ],
              [
                46.5343093,
                34.832123
              ],
              [
                46.5343523,
                34.8290935
              ],
              [
                46.5380859,
                34.8238092
              ],
              [
                46.5526472,
                34.8200116
              ],
              [
                46.5562683,
                34.8219587
              ],
              [
                46.5576146,
                34.8243574
              ],
              [
                46.5584492,
                34.8247604
              ],
              [
                46.5593934,
                34.8247075
              ],
              [
                46.5611636,
                34.8250334
              ],
              [
                46.5630734,
                34.8254562
              ],
              [
                46.5642857,
                34.8260991
              ],
              [
                46.5624618,
                34.8284682
              ],
              [
                46.561346,
                34.8290935
              ],
              [
                46.5605199,
                34.8290406
              ],
              [
                46.5604126,
                34.8291903
              ],
              [
                46.5605628,
                34.8293753
              ],
              [
                46.5609813,
                34.8294986
              ],
              [
                46.5628266,
                34.8293753
              ],
              [
                46.5643394,
                34.8283713
              ],
              [
                46.5648866,
                34.8264954
              ],
              [
                46.5650046,
                34.8251215
              ],
              [
                46.5654015,
                34.8243729
              ],
              [
                46.5666139,
                34.82336
              ],
              [
                46.5668875,
                34.8234701
              ],
              [
                46.5670323,
                34.8237167
              ],
              [
                46.5672684,
                34.8238092
              ],
              [
                46.5694356,
                34.8235273
              ],
              [
                46.5699398,
                34.8235714
              ],
              [
                46.5704548,
                34.8234393
              ],
              [
                46.5706372,
                34.8229637
              ],
              [
                46.5697789,
                34.8208498
              ],
              [
                46.5691781,
                34.8208498
              ],
              [
                46.5686202,
                34.8196167
              ],
              [
                46.5696501,
                34.8177847
              ],
              [
                46.5712273,
                34.8182603
              ],
              [
                46.5723002,
                34.8184805
              ],
              [
                46.5733731,
                34.8187888
              ],
              [
                46.5736842,
                34.818824
              ],
              [
                46.5739953,
                34.8187271
              ],
              [
                46.5742528,
                34.81841
              ],
              [
                46.574167,
                34.8181722
              ],
              [
                46.5737915,
                34.8178728
              ],
              [
                46.5733302,
                34.8176261
              ],
              [
                46.5731477,
                34.8155298
              ],
              [
                46.5759158,
                34.8135919
              ],
              [
                46.5820312,
                34.8093637
              ],
              [
                46.5841341,
                34.8069324
              ],
              [
                46.5839195,
                34.8035496
              ],
              [
                46.5807608,
                34.8013939
              ],
              [
                46.5819454,
                34.8010124
              ],
              [
                46.5825167,
                34.8000404
              ],
              [
                46.5815369,
                34.7982201
              ],
              [
                46.577741,
                34.7938654
              ],
              [
                46.5645285,
                34.7887537
              ],
              [
                46.5594732,
                34.7877926
              ],
              [
                46.5599571,
                34.7746566
              ],
              [
                46.5574275,
                34.7732776
              ],
              [
                46.5565939,
                34.7732775
              ],
              [
                46.5554845,
                34.7727272
              ],
              [
                46.5543743,
                34.7727273
              ],
              [
                46.5538172,
                34.7724476
              ],
              [
                46.5529844,
                34.7724476
              ],
              [
                46.5527078,
                34.7721678
              ],
              [
                46.5513171,
                34.7721679
              ],
              [
                46.5468741,
                34.7710581
              ],
              [
                46.5438178,
                34.771058
              ],
              [
                46.5427077,
                34.7707784
              ],
              [
                46.5410412,
                34.7696686
              ],
              [
                46.5374279,
                34.76495
              ],
              [
                46.5349278,
                34.7635605
              ],
              [
                46.5343708,
                34.7632809
              ],
              [
                46.5338176,
                34.7630011
              ],
              [
                46.5335379,
                34.7624417
              ],
              [
                46.5324278,
                34.7616117
              ],
              [
                46.4996483,
                34.7541141
              ],
              [
                46.4938153,
                34.749666
              ],
              [
                46.4921481,
                34.748836
              ],
              [
                46.4860386,
                34.7438285
              ],
              [
                46.4849253,
                34.7418886
              ],
              [
                46.4796486,
                34.7363308
              ],
              [
                46.4740915,
                34.7335519
              ],
              [
                46.4727017,
                34.7332812
              ],
              [
                46.4713149,
                34.7327218
              ],
              [
                46.4704821,
                34.7327218
              ],
              [
                46.4668688,
                34.7318917
              ],
              [
                46.4652023,
                34.7318917
              ],
              [
                46.4429792,
                34.728833
              ],
              [
                46.4410354,
                34.7277232
              ],
              [
                46.439369,
                34.7263337
              ],
              [
                46.4388127,
                34.7260541
              ],
              [
                46.4385354,
                34.7257743
              ],
              [
                46.4063098,
                34.7049411
              ],
              [
                46.3910329,
                34.6982823
              ],
              [
                46.3729764,
                34.682718
              ],
              [
                46.3729764,
                34.6821586
              ],
              [
                46.3721436,
                34.6810488
              ],
              [
                46.3701998,
                34.6752201
              ],
              [
                46.3696435,
                34.672441
              ],
              [
                46.3690866,
                34.6702214
              ],
              [
                46.3690865,
                34.6666032
              ],
              [
                46.3718672,
                34.6599443
              ],
              [
                46.3743671,
                34.6571653
              ],
              [
                46.3743671,
                34.6566058
              ],
              [
                46.3754765,
                34.655496
              ],
              [
                46.3882534,
                34.6293833
              ],
              [
                46.3874199,
                34.6279938
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555079,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سرپل ذهاب",
          "name:en": "Sarpol-e-Zahab County",
          "name:ku": "Serpêlzehaw",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291765",
          "wikipedia": "en:Sarpol-e Zahab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.653259,
                34.72311
              ],
              [
                45.654146,
                34.722776
              ],
              [
                45.654645,
                34.722629
              ],
              [
                45.655151,
                34.722464
              ],
              [
                45.655282,
                34.72198
              ],
              [
                45.655153,
                34.721568
              ],
              [
                45.655334,
                34.721015
              ],
              [
                45.655827,
                34.720801
              ],
              [
                45.656375,
                34.720757
              ],
              [
                45.656868,
                34.720713
              ],
              [
                45.657091,
                34.720538
              ],
              [
                45.657058,
                34.719937
              ],
              [
                45.657217,
                34.719559
              ],
              [
                45.657298,
                34.719136
              ],
              [
                45.657549,
                34.718853
              ],
              [
                45.657854,
                34.718432
              ],
              [
                45.658188,
                34.718255
              ],
              [
                45.658837,
                34.718295
              ],
              [
                45.659606,
                34.718109
              ],
              [
                45.660235,
                34.718205
              ],
              [
                45.660637,
                34.71816
              ],
              [
                45.661057,
                34.717967
              ],
              [
                45.661401,
                34.717352
              ],
              [
                45.661839,
                34.717096
              ],
              [
                45.662498,
                34.717007
              ],
              [
                45.662636,
                34.716675
              ],
              [
                45.662769,
                34.716413
              ],
              [
                45.662987,
                34.715786
              ],
              [
                45.663343,
                34.715476
              ],
              [
                45.663753,
                34.715371
              ],
              [
                45.664375,
                34.715484
              ],
              [
                45.665058,
                34.71557
              ],
              [
                45.665685,
                34.716049
              ],
              [
                45.666548,
                34.715924
              ],
              [
                45.667083,
                34.715139
              ],
              [
                45.667854,
                34.71427
              ],
              [
                45.668478,
                34.7137
              ],
              [
                45.669367,
                34.713417
              ],
              [
                45.66944,
                34.712747
              ],
              [
                45.669947,
                34.712027
              ],
              [
                45.670793,
                34.711836
              ],
              [
                45.671307,
                34.711661
              ],
              [
                45.671838,
                34.711423
              ],
              [
                45.672028,
                34.710861
              ],
              [
                45.67213,
                34.710476
              ],
              [
                45.672655,
                34.710128
              ],
              [
                45.672926,
                34.709663
              ],
              [
                45.673656,
                34.709373
              ],
              [
                45.674287,
                34.708955
              ],
              [
                45.674833,
                34.70886
              ],
              [
                45.675607,
                34.708998
              ],
              [
                45.675803,
                34.709408
              ],
              [
                45.676198,
                34.709723
              ],
              [
                45.677188,
                34.710002
              ],
              [
                45.677799,
                34.709853
              ],
              [
                45.678304,
                34.709688
              ],
              [
                45.67875,
                34.70955
              ],
              [
                45.679617,
                34.709613
              ],
              [
                45.679932,
                34.709361
              ],
              [
                45.680156,
                34.709015
              ],
              [
                45.680721,
                34.708822
              ],
              [
                45.681224,
                34.708649
              ],
              [
                45.681958,
                34.708973
              ],
              [
                45.682645,
                34.70899
              ],
              [
                45.682896,
                34.708792
              ],
              [
                45.683555,
                34.708532
              ],
              [
                45.684389,
                34.708122
              ],
              [
                45.684589,
                34.707771
              ],
              [
                45.684834,
                34.707464
              ],
              [
                45.685032,
                34.70719
              ],
              [
                45.686132,
                34.707032
              ],
              [
                45.68694,
                34.706567
              ],
              [
                45.687437,
                34.706369
              ],
              [
                45.68783,
                34.706112
              ],
              [
                45.688254,
                34.706021
              ],
              [
                45.688755,
                34.706096
              ],
              [
                45.689566,
                34.705903
              ],
              [
                45.690547,
                34.705544
              ],
              [
                45.691145,
                34.70526
              ],
              [
                45.691345,
                34.704867
              ],
              [
                45.691443,
                34.704466
              ],
              [
                45.691658,
                34.704087
              ],
              [
                45.691524,
                34.703529
              ],
              [
                45.691449,
                34.702894
              ],
              [
                45.691341,
                34.70252
              ],
              [
                45.691186,
                34.701967
              ],
              [
                45.691038,
                34.701566
              ],
              [
                45.690908,
                34.700982
              ],
              [
                45.690961,
                34.700495
              ],
              [
                45.69136,
                34.700178
              ],
              [
                45.691988,
                34.699923
              ],
              [
                45.69234,
                34.699469
              ],
              [
                45.692755,
                34.698824
              ],
              [
                45.692939,
                34.698195
              ],
              [
                45.693366,
                34.697471
              ],
              [
                45.694079,
                34.696937
              ],
              [
                45.694704,
                34.696589
              ],
              [
                45.695595,
                34.696399
              ],
              [
                45.696099,
                34.696354
              ],
              [
                45.696776,
                34.696466
              ],
              [
                45.697603,
                34.696501
              ],
              [
                45.698497,
                34.696456
              ],
              [
                45.698971,
                34.696339
              ],
              [
                45.699793,
                34.696101
              ],
              [
                45.70106,
                34.695462
              ],
              [
                45.702218,
                34.694534
              ],
              [
                45.702625,
                34.693772
              ],
              [
                45.703342,
                34.691359
              ],
              [
                45.702681,
                34.690982
              ],
              [
                45.702295,
                34.690662
              ],
              [
                45.701814,
                34.690226
              ],
              [
                45.701489,
                34.689461
              ],
              [
                45.701194,
                34.688903
              ],
              [
                45.700996,
                34.688337
              ],
              [
                45.700838,
                34.687932
              ],
              [
                45.700365,
                34.687229
              ],
              [
                45.700148,
                34.686462
              ],
              [
                45.700048,
                34.68586
              ],
              [
                45.699849,
                34.68563
              ],
              [
                45.699767,
                34.68514
              ],
              [
                45.69954,
                34.684508
              ],
              [
                45.699428,
                34.684068
              ],
              [
                45.699228,
                34.683537
              ],
              [
                45.699187,
                34.683208
              ],
              [
                45.698923,
                34.682388
              ],
              [
                45.698528,
                34.682114
              ],
              [
                45.698521,
                34.681363
              ],
              [
                45.698057,
                34.680994
              ],
              [
                45.698078,
                34.680566
              ],
              [
                45.697815,
                34.679958
              ],
              [
                45.697757,
                34.679561
              ],
              [
                45.697828,
                34.679203
              ],
              [
                45.697744,
                34.678828
              ],
              [
                45.697953,
                34.678498
              ],
              [
                45.698043,
                34.678172
              ],
              [
                45.698037,
                34.677766
              ],
              [
                45.6978,
                34.677561
              ],
              [
                45.697681,
                34.677263
              ],
              [
                45.697585,
                34.676758
              ],
              [
                45.697584,
                34.676201
              ],
              [
                45.697524,
                34.675839
              ],
              [
                45.697482,
                34.675289
              ],
              [
                45.697377,
                34.67475
              ],
              [
                45.697089,
                34.674049
              ],
              [
                45.696995,
                34.673721
              ],
              [
                45.69687,
                34.673318
              ],
              [
                45.696825,
                34.67276
              ],
              [
                45.696785,
                34.672218
              ],
              [
                45.696747,
                34.671773
              ],
              [
                45.696864,
                34.671123
              ],
              [
                45.69697,
                34.670219
              ],
              [
                45.696837,
                34.66957
              ],
              [
                45.697333,
                34.66964
              ],
              [
                45.697995,
                34.669635
              ],
              [
                45.698562,
                34.669604
              ],
              [
                45.699233,
                34.669509
              ],
              [
                45.699477,
                34.669527
              ],
              [
                45.699865,
                34.669643
              ],
              [
                45.700388,
                34.669647
              ],
              [
                45.700777,
                34.669514
              ],
              [
                45.701193,
                34.669183
              ],
              [
                45.701364,
                34.668877
              ],
              [
                45.701741,
                34.668694
              ],
              [
                45.702141,
                34.668684
              ],
              [
                45.702534,
                34.668648
              ],
              [
                45.703127,
                34.668462
              ],
              [
                45.703681,
                34.668335
              ],
              [
                45.704238,
                34.668305
              ],
              [
                45.704504,
                34.668408
              ],
              [
                45.704881,
                34.668694
              ],
              [
                45.705307,
                34.668617
              ],
              [
                45.705682,
                34.668638
              ],
              [
                45.70592,
                34.668719
              ],
              [
                45.706271,
                34.668647
              ],
              [
                45.706636,
                34.668634
              ],
              [
                45.707037,
                34.668713
              ],
              [
                45.707669,
                34.669059
              ],
              [
                45.708233,
                34.669188
              ],
              [
                45.708979,
                34.669301
              ],
              [
                45.709583,
                34.669281
              ],
              [
                45.71035,
                34.669266
              ],
              [
                45.711139,
                34.66908
              ],
              [
                45.711053,
                34.668528
              ],
              [
                45.711076,
                34.668064
              ],
              [
                45.711102,
                34.667103
              ],
              [
                45.710918,
                34.666596
              ],
              [
                45.710733,
                34.666124
              ],
              [
                45.710717,
                34.665808
              ],
              [
                45.710574,
                34.665418
              ],
              [
                45.710461,
                34.664845
              ],
              [
                45.710393,
                34.664238
              ],
              [
                45.710366,
                34.663578
              ],
              [
                45.710591,
                34.663183
              ],
              [
                45.710472,
                34.662293
              ],
              [
                45.710672,
                34.661584
              ],
              [
                45.710993,
                34.661012
              ],
              [
                45.711239,
                34.660233
              ],
              [
                45.711446,
                34.659682
              ],
              [
                45.712102,
                34.658846
              ],
              [
                45.712412,
                34.658188
              ],
              [
                45.712436,
                34.657555
              ],
              [
                45.712801,
                34.656772
              ],
              [
                45.713123,
                34.656076
              ],
              [
                45.713548,
                34.655273
              ],
              [
                45.713571,
                34.654853
              ],
              [
                45.713331,
                34.654294
              ],
              [
                45.713578,
                34.653134
              ],
              [
                45.713816,
                34.652577
              ],
              [
                45.714271,
                34.65176
              ],
              [
                45.71464,
                34.651038
              ],
              [
                45.714959,
                34.650201
              ],
              [
                45.715205,
                34.649378
              ],
              [
                45.7161267,
                34.6473324
              ],
              [
                45.7172459,
                34.6453064
              ],
              [
                45.7186319,
                34.6432835
              ],
              [
                45.7186867,
                34.6428412
              ],
              [
                45.718608,
                34.642574
              ],
              [
                45.718646,
                34.642257
              ],
              [
                45.719248,
                34.641334
              ],
              [
                45.71932,
                34.641064
              ],
              [
                45.719621,
                34.640797
              ],
              [
                45.719765,
                34.640426
              ],
              [
                45.719765,
                34.639531
              ],
              [
                45.719676,
                34.639052
              ],
              [
                45.720123,
                34.638803
              ],
              [
                45.72168,
                34.638478
              ],
              [
                45.722263,
                34.638249
              ],
              [
                45.72288,
                34.637517
              ],
              [
                45.723417,
                34.637155
              ],
              [
                45.723787,
                34.636132
              ],
              [
                45.724602,
                34.635666
              ],
              [
                45.724757,
                34.635337
              ],
              [
                45.724888,
                34.632612
              ],
              [
                45.724728,
                34.632198
              ],
              [
                45.724117,
                34.631636
              ],
              [
                45.72422,
                34.631316
              ],
              [
                45.724633,
                34.630976
              ],
              [
                45.725073,
                34.630701
              ],
              [
                45.7255099,
                34.6302438
              ],
              [
                45.725931,
                34.629803
              ],
              [
                45.726163,
                34.629265
              ],
              [
                45.726781,
                34.628153
              ],
              [
                45.72705,
                34.626696
              ],
              [
                45.726993,
                34.625963
              ],
              [
                45.727455,
                34.625472
              ],
              [
                45.728421,
                34.624235
              ],
              [
                45.728503,
                34.62345
              ],
              [
                45.728847,
                34.62237
              ],
              [
                45.729365,
                34.621674
              ],
              [
                45.729534,
                34.620678
              ],
              [
                45.729822,
                34.619971
              ],
              [
                45.729958,
                34.619394
              ],
              [
                45.729473,
                34.618314
              ],
              [
                45.729505,
                34.616524
              ],
              [
                45.729013,
                34.615841
              ],
              [
                45.727553,
                34.615052
              ],
              [
                45.726839,
                34.614954
              ],
              [
                45.725611,
                34.614557
              ],
              [
                45.724874,
                34.6145
              ],
              [
                45.724378,
                34.614229
              ],
              [
                45.724237,
                34.613933
              ],
              [
                45.72442,
                34.613624
              ],
              [
                45.725077,
                34.613076
              ],
              [
                45.725569,
                34.612481
              ],
              [
                45.726385,
                34.611741
              ],
              [
                45.726283,
                34.611303
              ],
              [
                45.726232,
                34.610722
              ],
              [
                45.725613,
                34.610569
              ],
              [
                45.72526,
                34.610258
              ],
              [
                45.724917,
                34.609519
              ],
              [
                45.724569,
                34.608931
              ],
              [
                45.724046,
                34.608425
              ],
              [
                45.722933,
                34.607501
              ],
              [
                45.723439,
                34.607255
              ],
              [
                45.72375,
                34.606976
              ],
              [
                45.724224,
                34.606184
              ],
              [
                45.724371,
                34.60565
              ],
              [
                45.724896,
                34.605013
              ],
              [
                45.725157,
                34.604369
              ],
              [
                45.725156,
                34.603981
              ],
              [
                45.725707,
                34.603406
              ],
              [
                45.726163,
                34.603095
              ],
              [
                45.726719,
                34.601981
              ],
              [
                45.726998,
                34.601664
              ],
              [
                45.726972,
                34.601011
              ],
              [
                45.727308,
                34.60019
              ],
              [
                45.728016,
                34.599461
              ],
              [
                45.728629,
                34.598569
              ],
              [
                45.729219,
                34.598226
              ],
              [
                45.729454,
                34.597909
              ],
              [
                45.729324,
                34.597528
              ],
              [
                45.729077,
                34.595974
              ],
              [
                45.729285,
                34.595549
              ],
              [
                45.729757,
                34.594876
              ],
              [
                45.729984,
                34.594186
              ],
              [
                45.731064,
                34.591965
              ],
              [
                45.73129,
                34.591395
              ],
              [
                45.731724,
                34.590707
              ],
              [
                45.731843,
                34.590148
              ],
              [
                45.732437,
                34.590118
              ],
              [
                45.733202,
                34.589947
              ],
              [
                45.733825,
                34.589733
              ],
              [
                45.734593,
                34.589575
              ],
              [
                45.73573,
                34.589659
              ],
              [
                45.736833,
                34.589824
              ],
              [
                45.737044,
                34.589667
              ],
              [
                45.737208,
                34.589369
              ],
              [
                45.737188,
                34.589037
              ],
              [
                45.737556,
                34.588472
              ],
              [
                45.737817,
                34.588209
              ],
              [
                45.737788,
                34.587968
              ],
              [
                45.738119,
                34.587641
              ],
              [
                45.739151,
                34.586847
              ],
              [
                45.739377,
                34.586621
              ],
              [
                45.739509,
                34.586202
              ],
              [
                45.739826,
                34.585818
              ],
              [
                45.739942,
                34.585334
              ],
              [
                45.739882,
                34.584971
              ],
              [
                45.739723,
                34.584738
              ],
              [
                45.739642,
                34.584334
              ],
              [
                45.739832,
                34.584099
              ],
              [
                45.739963,
                34.583673
              ],
              [
                45.740056,
                34.582798
              ],
              [
                45.740061,
                34.582565
              ],
              [
                45.739979,
                34.582244
              ],
              [
                45.739806,
                34.581871
              ],
              [
                45.73987,
                34.580926
              ],
              [
                45.740291,
                34.58027
              ],
              [
                45.740793,
                34.57933
              ],
              [
                45.740226,
                34.577974
              ],
              [
                45.7394,
                34.577312
              ],
              [
                45.739147,
                34.57667
              ],
              [
                45.739144,
                34.576274
              ],
              [
                45.739346,
                34.574932
              ],
              [
                45.739507,
                34.574411
              ],
              [
                45.740124,
                34.573324
              ],
              [
                45.741249,
                34.570811
              ],
              [
                45.740924,
                34.570398
              ],
              [
                45.740407,
                34.570257
              ],
              [
                45.740048,
                34.570007
              ],
              [
                45.73999,
                34.569487
              ],
              [
                45.740377,
                34.567799
              ],
              [
                45.739996,
                34.566402
              ],
              [
                45.739501,
                34.566093
              ],
              [
                45.739036,
                34.565689
              ],
              [
                45.738243,
                34.565112
              ],
              [
                45.736843,
                34.56426
              ],
              [
                45.736266,
                34.563585
              ],
              [
                45.736351,
                34.563324
              ],
              [
                45.736192,
                34.562747
              ],
              [
                45.736108,
                34.562037
              ],
              [
                45.735494,
                34.561391
              ],
              [
                45.735019,
                34.560735
              ],
              [
                45.735042,
                34.559588
              ],
              [
                45.734617,
                34.558319
              ],
              [
                45.734671,
                34.558018
              ],
              [
                45.734969,
                34.557563
              ],
              [
                45.735844,
                34.556542
              ],
              [
                45.735993,
                34.556061
              ],
              [
                45.73596,
                34.555633
              ],
              [
                45.736011,
                34.555281
              ],
              [
                45.736268,
                34.55484
              ],
              [
                45.736015,
                34.554237
              ],
              [
                45.73659,
                34.554136
              ],
              [
                45.738862,
                34.554027
              ],
              [
                45.739382,
                34.554092
              ],
              [
                45.740059,
                34.5541
              ],
              [
                45.74036,
                34.553969
              ],
              [
                45.740512,
                34.553649
              ],
              [
                45.740614,
                34.553231
              ],
              [
                45.740519,
                34.553017
              ],
              [
                45.740595,
                34.552761
              ],
              [
                45.741119,
                34.55237
              ],
              [
                45.741461,
                34.552294
              ],
              [
                45.741868,
                34.552051
              ],
              [
                45.742121,
                34.551743
              ],
              [
                45.742445,
                34.551486
              ],
              [
                45.742489,
                34.551313
              ],
              [
                45.742464,
                34.551098
              ],
              [
                45.742634,
                34.550863
              ],
              [
                45.74268,
                34.550515
              ],
              [
                45.742787,
                34.550263
              ],
              [
                45.742757,
                34.550074
              ],
              [
                45.742896,
                34.549835
              ],
              [
                45.743302,
                34.54954
              ],
              [
                45.74335,
                34.549297
              ],
              [
                45.743222,
                34.549061
              ],
              [
                45.742935,
                34.548875
              ],
              [
                45.7428,
                34.548658
              ],
              [
                45.742844,
                34.548485
              ],
              [
                45.743103,
                34.548062
              ],
              [
                45.743131,
                34.547243
              ],
              [
                45.742629,
                34.546641
              ],
              [
                45.742579,
                34.546403
              ],
              [
                45.742778,
                34.545735
              ],
              [
                45.742861,
                34.544943
              ],
              [
                45.742732,
                34.544751
              ],
              [
                45.742217,
                34.544423
              ],
              [
                45.742171,
                34.544298
              ],
              [
                45.741914,
                34.544064
              ],
              [
                45.741357,
                34.544013
              ],
              [
                45.741306,
                34.543862
              ],
              [
                45.741336,
                34.54363
              ],
              [
                45.741236,
                34.543531
              ],
              [
                45.74094,
                34.543398
              ],
              [
                45.740951,
                34.54316
              ],
              [
                45.741114,
                34.542944
              ],
              [
                45.740988,
                34.542769
              ],
              [
                45.741039,
                34.541912
              ],
              [
                45.741226,
                34.541762
              ],
              [
                45.741096,
                34.541422
              ],
              [
                45.741291,
                34.541219
              ],
              [
                45.741726,
                34.541016
              ],
              [
                45.741813,
                34.540478
              ],
              [
                45.741955,
                34.540256
              ],
              [
                45.742248,
                34.539994
              ],
              [
                45.742191,
                34.539766
              ],
              [
                45.742223,
                34.53949
              ],
              [
                45.7422938,
                34.5393909
              ],
              [
                45.7425982,
                34.5393209
              ],
              [
                45.7427822,
                34.539076
              ],
              [
                45.7428954,
                34.5388486
              ],
              [
                45.7428388,
                34.5385396
              ],
              [
                45.7428176,
                34.5381781
              ],
              [
                45.7432041,
                34.5380347
              ],
              [
                45.7426762,
                34.5377686
              ],
              [
                45.742296,
                34.5374417
              ],
              [
                45.7414572,
                34.536784
              ],
              [
                45.74081,
                34.5365206
              ],
              [
                45.7397196,
                34.5366499
              ],
              [
                45.7392389,
                34.5369997
              ],
              [
                45.7386905,
                34.5372151
              ],
              [
                45.7377752,
                34.5373275
              ],
              [
                45.736963,
                34.538043
              ],
              [
                45.7365564,
                34.5382639
              ],
              [
                45.7353459,
                34.5383048
              ],
              [
                45.7350747,
                34.5371395
              ],
              [
                45.7348858,
                34.5354961
              ],
              [
                45.7354483,
                34.5346538
              ],
              [
                45.736282,
                34.5329934
              ],
              [
                45.7398923,
                34.5279854
              ],
              [
                45.7582247,
                34.5102085
              ],
              [
                45.7590583,
                34.5099379
              ],
              [
                45.7707281,
                34.5015998
              ],
              [
                45.7718382,
                34.4999394
              ],
              [
                45.7723945,
                34.4996597
              ],
              [
                45.7862848,
                34.4871617
              ],
              [
                45.7887848,
                34.4802132
              ],
              [
                45.7890614,
                34.4796538
              ],
              [
                45.7882278,
                34.4685452
              ],
              [
                45.7882278,
                34.4682745
              ],
              [
                45.7857286,
                34.4649355
              ],
              [
                45.7718385,
                34.4549368
              ],
              [
                45.7710049,
                34.4549368
              ],
              [
                45.7576718,
                34.4507677
              ],
              [
                45.7565586,
                34.4507676
              ],
              [
                45.756282,
                34.4504878
              ],
              [
                45.7546155,
                34.4502171
              ],
              [
                45.7526718,
                34.4502172
              ],
              [
                45.752392,
                34.4499374
              ],
              [
                45.7512818,
                34.4499374
              ],
              [
                45.7507256,
                34.4496577
              ],
              [
                45.7498921,
                34.4496576
              ],
              [
                45.7490584,
                34.4493779
              ],
              [
                45.7487819,
                34.4493779
              ],
              [
                45.7465591,
                34.4490981
              ],
              [
                45.7451685,
                34.4485477
              ],
              [
                45.744059,
                34.4485476
              ],
              [
                45.7382254,
                34.4435482
              ],
              [
                45.7407254,
                34.4399296
              ],
              [
                45.7596157,
                34.4241011
              ],
              [
                45.7607252,
                34.4232708
              ],
              [
                45.7921189,
                34.3990948
              ],
              [
                45.7927329,
                34.3974953
              ],
              [
                45.7935048,
                34.3971545
              ],
              [
                45.8060081,
                34.4143731
              ],
              [
                45.8132278,
                34.4204915
              ],
              [
                45.8140614,
                34.4210511
              ],
              [
                45.8187849,
                34.4232711
              ],
              [
                45.8229514,
                34.4232711
              ],
              [
                45.8235076,
                34.4229913
              ],
              [
                45.8287844,
                34.4229914
              ],
              [
                45.8301742,
                34.4221521
              ],
              [
                45.8301743,
                34.4218723
              ],
              [
                45.8304516,
                34.4216016
              ],
              [
                45.8307313,
                34.4210511
              ],
              [
                45.8623976,
                34.3860456
              ],
              [
                45.863511,
                34.3852063
              ],
              [
                45.8785105,
                34.3724367
              ],
              [
                45.9043439,
                34.3513192
              ],
              [
                45.9060104,
                34.3504889
              ],
              [
                45.9074003,
                34.3493788
              ],
              [
                45.9371237,
                34.3199312
              ],
              [
                45.9374948,
                34.3194285
              ],
              [
                45.9457373,
                34.3082621
              ],
              [
                45.9471232,
                34.3066015
              ],
              [
                45.9604603,
                34.2921526
              ],
              [
                45.9612939,
                34.2918729
              ],
              [
                45.9874031,
                34.2724331
              ],
              [
                45.9882366,
                34.2715937
              ],
              [
                46.00462,
                34.2582699
              ],
              [
                46.0051832,
                34.2574335
              ],
              [
                46.0085161,
                34.2557638
              ],
              [
                46.0093497,
                34.2557638
              ],
              [
                46.0096262,
                34.255484
              ],
              [
                46.0115732,
                34.2554841
              ],
              [
                46.0121294,
                34.2557638
              ],
              [
                46.0140732,
                34.2557638
              ],
              [
                46.0146294,
                34.2560436
              ],
              [
                46.0160162,
                34.2563144
              ],
              [
                46.0176826,
                34.2563144
              ],
              [
                46.0176826,
                34.2565942
              ],
              [
                46.0193499,
                34.2565942
              ],
              [
                46.0199062,
                34.2568739
              ],
              [
                46.0254625,
                34.2568739
              ],
              [
                46.0260164,
                34.2565941
              ],
              [
                46.0271297,
                34.2565941
              ],
              [
                46.0274062,
                34.2563144
              ],
              [
                46.0299063,
                34.2552043
              ],
              [
                46.0324064,
                34.2504842
              ],
              [
                46.0326861,
                34.2499336
              ],
              [
                46.0324064,
                34.2488145
              ],
              [
                46.0299064,
                34.2457639
              ],
              [
                46.0296298,
                34.2454842
              ],
              [
                46.0218492,
                34.2413235
              ],
              [
                46.0210164,
                34.2413235
              ],
              [
                46.01935,
                34.2404842
              ],
              [
                46.0185163,
                34.2404842
              ],
              [
                46.0171295,
                34.2399336
              ],
              [
                46.0162968,
                34.2399337
              ],
              [
                46.0037934,
                34.2354842
              ],
              [
                45.9982402,
                34.2354841
              ],
              [
                45.9979597,
                34.235764
              ],
              [
                45.9971269,
                34.2357639
              ],
              [
                45.9971269,
                34.2360437
              ],
              [
                45.996573,
                34.2360437
              ],
              [
                45.9910166,
                34.2407639
              ],
              [
                45.9910166,
                34.2410437
              ],
              [
                45.9774037,
                34.2554839
              ],
              [
                45.9768498,
                34.2554839
              ],
              [
                45.9757365,
                34.2563142
              ],
              [
                45.9724036,
                34.2557637
              ],
              [
                45.9701801,
                34.2538142
              ],
              [
                45.9699036,
                34.2529839
              ],
              [
                45.9685137,
                34.2482637
              ],
              [
                45.9715701,
                34.2432638
              ],
              [
                45.9718466,
                34.2427042
              ],
              [
                45.9749038,
                34.2396537
              ],
              [
                45.9751835,
                34.2388234
              ],
              [
                45.9757365,
                34.2382638
              ],
              [
                45.9757367,
                34.2377043
              ],
              [
                45.9774038,
                34.2346538
              ],
              [
                45.9779601,
                34.2338234
              ],
              [
                45.9760172,
                34.2210436
              ],
              [
                45.9829603,
                34.2157638
              ],
              [
                45.9837939,
                34.2157639
              ],
              [
                45.9840704,
                34.2154841
              ],
              [
                45.9862931,
                34.2149336
              ],
              [
                45.9885166,
                34.2149336
              ],
              [
                45.9887932,
                34.2146538
              ],
              [
                45.9893502,
                34.2146538
              ],
              [
                45.9915698,
                34.2146538
              ],
              [
                45.9918503,
                34.2143739
              ],
              [
                45.9962933,
                34.214374
              ],
              [
                45.996573,
                34.2140942
              ],
              [
                46.0015731,
                34.2132639
              ],
              [
                46.0037936,
                34.2132639
              ],
              [
                46.0040732,
                34.2129841
              ],
              [
                46.0062935,
                34.2129841
              ],
              [
                46.0068498,
                34.213264
              ],
              [
                46.0076834,
                34.2132639
              ],
              [
                46.0121296,
                34.2157639
              ],
              [
                46.0229634,
                34.2238145
              ],
              [
                46.02324,
                34.2240943
              ],
              [
                46.0310198,
                34.2274247
              ],
              [
                46.0321291,
                34.2274247
              ],
              [
                46.0332394,
                34.2279843
              ],
              [
                46.034073,
                34.2279843
              ],
              [
                46.0479623,
                34.2340944
              ],
              [
                46.0487959,
                34.2340944
              ],
              [
                46.0490724,
                34.2343742
              ],
              [
                46.0501857,
                34.2343742
              ],
              [
                46.0507428,
                34.234654
              ],
              [
                46.0529624,
                34.234654
              ],
              [
                46.0576858,
                34.2321541
              ],
              [
                46.0582421,
                34.2318742
              ],
              [
                46.0662955,
                34.2288148
              ],
              [
                46.0674087,
                34.2288147
              ],
              [
                46.0676853,
                34.228535
              ],
              [
                46.0726855,
                34.2285349
              ],
              [
                46.0732425,
                34.2288148
              ],
              [
                46.0740753,
                34.2288148
              ],
              [
                46.0826856,
                34.2318743
              ],
              [
                46.0843521,
                34.2318743
              ],
              [
                46.0849092,
                34.2321541
              ],
              [
                46.093242,
                34.2329844
              ],
              [
                46.0949085,
                34.2338238
              ],
              [
                46.0957422,
                34.2338238
              ],
              [
                46.0968554,
                34.2343743
              ],
              [
                46.0985219,
                34.2346541
              ],
              [
                46.1090783,
                34.2365946
              ],
              [
                46.1099119,
                34.2368744
              ],
              [
                46.1107456,
                34.2368744
              ],
              [
                46.1110221,
                34.2371542
              ],
              [
                46.1118549,
                34.2371542
              ],
              [
                46.1121315,
                34.237434
              ],
              [
                46.1132449,
                34.237434
              ],
              [
                46.1243552,
                34.2413239
              ],
              [
                46.142411,
                34.2518744
              ],
              [
                46.1432446,
                34.2518743
              ],
              [
                46.143525,
                34.2521541
              ],
              [
                46.1463017,
                34.2521541
              ],
              [
                46.146858,
                34.2521541
              ],
              [
                46.1468579,
                34.2529844
              ],
              [
                46.1463017,
                34.2538148
              ],
              [
                46.1349115,
                34.268264
              ],
              [
                46.1096313,
                34.2890936
              ],
              [
                46.1074116,
                34.2904835
              ],
              [
                46.1037983,
                34.2924328
              ],
              [
                46.1029647,
                34.2932631
              ],
              [
                46.062409,
                34.3110421
              ],
              [
                46.057409,
                34.3129915
              ],
              [
                46.046572,
                34.3213213
              ],
              [
                46.046572,
                34.3218809
              ],
              [
                46.0462954,
                34.3221607
              ],
              [
                46.0462955,
                34.3235415
              ],
              [
                46.0462954,
                34.3249313
              ],
              [
                46.0462954,
                34.325211
              ],
              [
                46.0462955,
                34.3263211
              ],
              [
                46.0554619,
                34.3446594
              ],
              [
                46.0624089,
                34.3665984
              ],
              [
                46.0618517,
                34.3693779
              ],
              [
                46.0610182,
                34.3732675
              ],
              [
                46.0599088,
                34.3771571
              ],
              [
                46.0424052,
                34.396325
              ],
              [
                46.020182,
                34.4224324
              ],
              [
                46.0093361,
                34.4293037
              ],
              [
                46.0035159,
                34.4329908
              ],
              [
                46.0026823,
                34.4335502
              ],
              [
                46.0024058,
                34.4338209
              ],
              [
                46.0021253,
                34.4341007
              ],
              [
                46.0012926,
                34.4341007
              ],
              [
                45.9765692,
                34.4518782
              ],
              [
                45.9743496,
                34.4535477
              ],
              [
                45.9629596,
                34.4610467
              ],
              [
                45.9618462,
                34.4616062
              ],
              [
                45.9532359,
                34.4699354
              ],
              [
                45.9468459,
                34.4827134
              ],
              [
                45.9465693,
                34.4841031
              ],
              [
                45.9457365,
                34.4879923
              ],
              [
                45.9418464,
                34.5038293
              ],
              [
                45.9418464,
                34.5049302
              ],
              [
                45.9415699,
                34.5057694
              ],
              [
                45.9412893,
                34.5074298
              ],
              [
                45.9410129,
                34.5091082
              ],
              [
                45.9410128,
                34.5104888
              ],
              [
                45.9410127,
                34.5107686
              ],
              [
                45.9407363,
                34.5113281
              ],
              [
                45.9407362,
                34.512438
              ],
              [
                45.9407362,
                34.5129884
              ],
              [
                45.9385127,
                34.5165979
              ],
              [
                45.9385128,
                34.5174372
              ],
              [
                45.9379564,
                34.518547
              ],
              [
                45.9376791,
                34.5188267
              ],
              [
                45.9235131,
                34.5427215
              ],
              [
                45.9162895,
                34.5518804
              ],
              [
                45.9161029,
                34.55244
              ],
              [
                45.9160097,
                34.5527197
              ],
              [
                45.9062899,
                34.5707666
              ],
              [
                45.9065666,
                34.5727157
              ],
              [
                45.9079563,
                34.574376
              ],
              [
                45.9082329,
                34.5746557
              ],
              [
                45.9096228,
                34.5746558
              ],
              [
                45.9104564,
                34.5746557
              ],
              [
                45.910733,
                34.5749354
              ],
              [
                45.9110095,
                34.5746558
              ],
              [
                45.9129564,
                34.5746557
              ],
              [
                45.9135096,
                34.5746558
              ],
              [
                45.9135096,
                34.5749355
              ],
              [
                45.9160096,
                34.5752152
              ],
              [
                45.9257325,
                34.5752152
              ],
              [
                45.9257325,
                34.5749356
              ],
              [
                45.943236,
                34.5741054
              ],
              [
                45.9440689,
                34.5738257
              ],
              [
                45.9468454,
                34.5738257
              ],
              [
                45.9482361,
                34.573546
              ],
              [
                45.9504557,
                34.573546
              ],
              [
                45.9521221,
                34.5732753
              ],
              [
                45.9682357,
                34.5743761
              ],
              [
                45.9726788,
                34.5749357
              ],
              [
                45.9749023,
                34.5749356
              ],
              [
                45.9779585,
                34.5754952
              ],
              [
                45.9785156,
                34.5757749
              ],
              [
                45.9799024,
                34.5757748
              ],
              [
                46.0062919,
                34.5829936
              ],
              [
                46.0074052,
                34.5841035
              ],
              [
                46.0087911,
                34.5854931
              ],
              [
                46.0090716,
                34.5852224
              ],
              [
                46.0293478,
                34.5871626
              ],
              [
                46.0315714,
                34.5874332
              ],
              [
                46.0410176,
                34.5891026
              ],
              [
                46.0412942,
                34.5893823
              ],
              [
                46.0421278,
                34.5893823
              ],
              [
                46.0426848,
                34.5896621
              ],
              [
                46.0440708,
                34.589662
              ],
              [
                46.0479607,
                34.5904922
              ],
              [
                46.0482381,
                34.5907719
              ],
              [
                46.0557414,
                34.5907719
              ],
              [
                46.0562945,
                34.5904923
              ],
              [
                46.0590742,
                34.5904922
              ],
              [
                46.0607407,
                34.5902216
              ],
              [
                46.0612946,
                34.5899418
              ],
              [
                46.0621275,
                34.5899419
              ],
              [
                46.0626845,
                34.5896622
              ],
              [
                46.0643509,
                34.5896621
              ],
              [
                46.0649079,
                34.5893824
              ],
              [
                46.073241,
                34.5893824
              ],
              [
                46.0732409,
                34.5896621
              ],
              [
                46.0746309,
                34.5896621
              ],
              [
                46.0749074,
                34.5899419
              ],
              [
                46.075741,
                34.5899418
              ],
              [
                46.0762972,
                34.5902216
              ],
              [
                46.0768504,
                34.5902216
              ],
              [
                46.0762973,
                34.5910518
              ],
              [
                46.0596273,
                34.6077177
              ],
              [
                46.0579609,
                34.6099375
              ],
              [
                46.0562944,
                34.6116067
              ],
              [
                46.0462942,
                34.6257731
              ],
              [
                46.041294,
                34.6377197
              ],
              [
                46.0415714,
                34.6396597
              ],
              [
                46.0560176,
                34.6671617
              ],
              [
                46.0587941,
                34.6754988
              ],
              [
                46.0590739,
                34.6760582
              ],
              [
                46.0590739,
                34.6766087
              ],
              [
                46.0582403,
                34.6768883
              ],
              [
                46.055741,
                34.6768884
              ],
              [
                46.055184,
                34.6771681
              ],
              [
                46.0526839,
                34.6771681
              ],
              [
                46.0507409,
                34.6774387
              ],
              [
                46.0501839,
                34.6777184
              ],
              [
                46.0485174,
                34.6777185
              ],
              [
                46.0482377,
                34.6779981
              ],
              [
                46.0432376,
                34.6779981
              ],
              [
                46.0429611,
                34.6782779
              ],
              [
                46.0410173,
                34.6782778
              ],
              [
                46.0174042,
                34.6835471
              ],
              [
                46.0079579,
                34.6879953
              ],
              [
                46.0076814,
                34.6882749
              ],
              [
                46.0056097,
                34.6898106
              ],
              [
                46.0040712,
                34.6916044
              ],
              [
                46.0037915,
                34.6921638
              ],
              [
                45.9987913,
                34.6938329
              ],
              [
                45.9982382,
                34.6943834
              ],
              [
                45.9824011,
                34.6985517
              ],
              [
                45.9821245,
                34.6988315
              ],
              [
                45.9801815,
                34.6999412
              ],
              [
                45.978515,
                34.7010511
              ],
              [
                45.9701782,
                34.7043895
              ],
              [
                45.9687914,
                34.7046601
              ],
              [
                45.9679586,
                34.7052196
              ],
              [
                45.9599014,
                34.7071594
              ],
              [
                45.958792,
                34.7077188
              ],
              [
                45.9579584,
                34.7077188
              ],
              [
                45.9521215,
                34.7104977
              ],
              [
                45.9493449,
                34.7113278
              ],
              [
                45.9382353,
                34.7132767
              ],
              [
                45.9162887,
                34.7213338
              ],
              [
                45.9115651,
                34.7221638
              ],
              [
                45.9107324,
                34.7224436
              ],
              [
                45.9096222,
                34.7224435
              ],
              [
                45.8851755,
                34.7296705
              ],
              [
                45.8804528,
                34.7321697
              ],
              [
                45.857396,
                34.7438267
              ],
              [
                45.8479528,
                34.7463258
              ],
              [
                45.8460059,
                34.7471649
              ],
              [
                45.8271165,
                34.7479949
              ],
              [
                45.8218397,
                34.7477243
              ],
              [
                45.8179499,
                34.7471648
              ],
              [
                45.8151732,
                34.7471648
              ],
              [
                45.8135068,
                34.7468852
              ],
              [
                45.8068403,
                34.7468851
              ],
              [
                45.8040598,
                34.7474445
              ],
              [
                45.7876703,
                34.7454956
              ],
              [
                45.7832273,
                34.7454956
              ],
              [
                45.7746138,
                34.7446655
              ],
              [
                45.7721137,
                34.7452158
              ],
              [
                45.7715606,
                34.7452159
              ],
              [
                45.770727,
                34.7452159
              ],
              [
                45.7698942,
                34.7454955
              ],
              [
                45.7665605,
                34.7474444
              ],
              [
                45.7623909,
                34.7524428
              ],
              [
                45.7596142,
                34.76022
              ],
              [
                45.7596142,
                34.7635583
              ],
              [
                45.7626705,
                34.773555
              ],
              [
                45.7626705,
                34.7738346
              ],
              [
                45.76489,
                34.779663
              ],
              [
                45.7671135,
                34.7966066
              ],
              [
                45.7665603,
                34.7993854
              ],
              [
                45.7646134,
                34.8060526
              ],
              [
                45.7579468,
                34.814389
              ],
              [
                45.7548904,
                34.822996
              ],
              [
                45.7548904,
                34.8260544
              ],
              [
                45.7551701,
                34.826334
              ],
              [
                45.7551701,
                34.8268005
              ],
              [
                45.7550739,
                34.8274707
              ],
              [
                45.754581,
                34.829016
              ],
              [
                45.753623,
                34.828685
              ],
              [
                45.752932,
                34.82876
              ],
              [
                45.752077,
                34.828825
              ],
              [
                45.751136,
                34.828906
              ],
              [
                45.750382,
                34.828964
              ],
              [
                45.749524,
                34.828794
              ],
              [
                45.748259,
                34.828769
              ],
              [
                45.747247,
                34.828956
              ],
              [
                45.747244,
                34.828957
              ],
              [
                45.736536,
                34.831227
              ],
              [
                45.736536,
                34.831228
              ],
              [
                45.736322,
                34.831555
              ],
              [
                45.736163,
                34.831914
              ],
              [
                45.736097,
                34.832584
              ],
              [
                45.735962,
                34.833656
              ],
              [
                45.735947,
                34.834043
              ],
              [
                45.736095,
                34.834474
              ],
              [
                45.73619,
                34.835009
              ],
              [
                45.736197,
                34.835783
              ],
              [
                45.736078,
                34.836587
              ],
              [
                45.735993,
                34.837153
              ],
              [
                45.735908,
                34.837749
              ],
              [
                45.736307,
                34.838703
              ],
              [
                45.736452,
                34.839605
              ],
              [
                45.736632,
                34.840591
              ],
              [
                45.736914,
                34.841491
              ],
              [
                45.737233,
                34.842843
              ],
              [
                45.73738,
                34.843998
              ],
              [
                45.73735,
                34.844422
              ],
              [
                45.737353,
                34.844788
              ],
              [
                45.73739,
                34.845098
              ],
              [
                45.737053,
                34.845608
              ],
              [
                45.736852,
                34.846089
              ],
              [
                45.73689,
                34.846417
              ],
              [
                45.736542,
                34.845895
              ],
              [
                45.736132,
                34.845427
              ],
              [
                45.735976,
                34.844796
              ],
              [
                45.735975,
                34.844162
              ],
              [
                45.736054,
                34.84342
              ],
              [
                45.735884,
                34.842814
              ],
              [
                45.735771,
                34.841935
              ],
              [
                45.735827,
                34.841477
              ],
              [
                45.735699,
                34.840647
              ],
              [
                45.735665,
                34.840239
              ],
              [
                45.735533,
                34.839966
              ],
              [
                45.735386,
                34.839823
              ],
              [
                45.735044,
                34.83966
              ],
              [
                45.734668,
                34.839625
              ],
              [
                45.734367,
                34.839503
              ],
              [
                45.733885,
                34.839419
              ],
              [
                45.733643,
                34.83926
              ],
              [
                45.733508,
                34.839273
              ],
              [
                45.733312,
                34.839225
              ],
              [
                45.733206,
                34.839077
              ],
              [
                45.732679,
                34.838956
              ],
              [
                45.732348,
                34.838908
              ],
              [
                45.731628,
                34.839024
              ],
              [
                45.731146,
                34.838965
              ],
              [
                45.731085,
                34.838879
              ],
              [
                45.730663,
                34.838745
              ],
              [
                45.730497,
                34.838622
              ],
              [
                45.730226,
                34.838599
              ],
              [
                45.729881,
                34.838576
              ],
              [
                45.72955,
                34.838578
              ],
              [
                45.729401,
                34.83874
              ],
              [
                45.729475,
                34.838905
              ],
              [
                45.729447,
                34.839048
              ],
              [
                45.729275,
                34.839192
              ],
              [
                45.729015,
                34.839241
              ],
              [
                45.728783,
                34.839171
              ],
              [
                45.728523,
                34.839268
              ],
              [
                45.728351,
                34.83946
              ],
              [
                45.728092,
                34.839557
              ],
              [
                45.727773,
                34.839511
              ],
              [
                45.727163,
                34.839252
              ],
              [
                45.727045,
                34.838991
              ],
              [
                45.727043,
                34.838728
              ],
              [
                45.726925,
                34.838514
              ],
              [
                45.72649,
                34.838397
              ],
              [
                45.725996,
                34.838138
              ],
              [
                45.72556,
                34.83795
              ],
              [
                45.724953,
                34.837953
              ],
              [
                45.724635,
                34.838075
              ],
              [
                45.724403,
                34.838004
              ],
              [
                45.724171,
                34.83791
              ],
              [
                45.723939,
                34.837864
              ],
              [
                45.723853,
                34.837936
              ],
              [
                45.723621,
                34.837961
              ],
              [
                45.723387,
                34.837653
              ],
              [
                45.723154,
                34.837511
              ],
              [
                45.722895,
                34.837584
              ],
              [
                45.722546,
                34.837419
              ],
              [
                45.722373,
                34.837515
              ],
              [
                45.722521,
                34.837849
              ],
              [
                45.722369,
                34.838006
              ],
              [
                45.714734,
                34.830856
              ],
              [
                45.71363,
                34.83029
              ],
              [
                45.712986,
                34.829483
              ],
              [
                45.711677,
                34.828631
              ],
              [
                45.703344,
                34.825292
              ],
              [
                45.699191,
                34.824222
              ],
              [
                45.698577,
                34.823511
              ],
              [
                45.696957,
                34.822559
              ],
              [
                45.696912,
                34.822065
              ],
              [
                45.696639,
                34.821208
              ],
              [
                45.695421,
                34.820544
              ],
              [
                45.69479,
                34.819794
              ],
              [
                45.694063,
                34.819115
              ],
              [
                45.693804,
                34.818615
              ],
              [
                45.693469,
                34.817885
              ],
              [
                45.693146,
                34.817502
              ],
              [
                45.69281,
                34.81706
              ],
              [
                45.69224,
                34.816237
              ],
              [
                45.691683,
                34.815564
              ],
              [
                45.691121,
                34.81551
              ],
              [
                45.690435,
                34.815604
              ],
              [
                45.689876,
                34.815711
              ],
              [
                45.689538,
                34.815161
              ],
              [
                45.689365,
                34.8146
              ],
              [
                45.689303,
                34.813786
              ],
              [
                45.689137,
                34.812911
              ],
              [
                45.689001,
                34.812262
              ],
              [
                45.689008,
                34.81175
              ],
              [
                45.689184,
                34.811442
              ],
              [
                45.689656,
                34.811099
              ],
              [
                45.690312,
                34.810823
              ],
              [
                45.690749,
                34.810719
              ],
              [
                45.691018,
                34.810573
              ],
              [
                45.691153,
                34.810128
              ],
              [
                45.691304,
                34.809511
              ],
              [
                45.691628,
                34.808961
              ],
              [
                45.691734,
                34.808539
              ],
              [
                45.691802,
                34.808151
              ],
              [
                45.691943,
                34.807732
              ],
              [
                45.691845,
                34.807453
              ],
              [
                45.691862,
                34.807083
              ],
              [
                45.691996,
                34.806683
              ],
              [
                45.691952,
                34.806243
              ],
              [
                45.692038,
                34.805833
              ],
              [
                45.691944,
                34.805124
              ],
              [
                45.691832,
                34.804633
              ],
              [
                45.691781,
                34.804212
              ],
              [
                45.691656,
                34.803615
              ],
              [
                45.69174,
                34.803144
              ],
              [
                45.691762,
                34.802647
              ],
              [
                45.692019,
                34.802297
              ],
              [
                45.692463,
                34.801933
              ],
              [
                45.692613,
                34.801557
              ],
              [
                45.692777,
                34.801044
              ],
              [
                45.693018,
                34.800724
              ],
              [
                45.693203,
                34.80045
              ],
              [
                45.693419,
                34.800018
              ],
              [
                45.69352,
                34.799624
              ],
              [
                45.693676,
                34.799372
              ],
              [
                45.694123,
                34.79907
              ],
              [
                45.694448,
                34.799201
              ],
              [
                45.694839,
                34.79967
              ],
              [
                45.69508,
                34.799995
              ],
              [
                45.695803,
                34.800023
              ],
              [
                45.696475,
                34.800068
              ],
              [
                45.697062,
                34.800042
              ],
              [
                45.69733,
                34.799483
              ],
              [
                45.697676,
                34.798961
              ],
              [
                45.698116,
                34.798671
              ],
              [
                45.698523,
                34.798387
              ],
              [
                45.698546,
                34.797913
              ],
              [
                45.69838,
                34.797532
              ],
              [
                45.698493,
                34.797103
              ],
              [
                45.698755,
                34.796733
              ],
              [
                45.699069,
                34.796089
              ],
              [
                45.699537,
                34.795521
              ],
              [
                45.699827,
                34.795086
              ],
              [
                45.700136,
                34.794767
              ],
              [
                45.700642,
                34.794431
              ],
              [
                45.700753,
                34.794079
              ],
              [
                45.700951,
                34.793507
              ],
              [
                45.701006,
                34.792942
              ],
              [
                45.701166,
                34.792393
              ],
              [
                45.70164,
                34.791892
              ],
              [
                45.701977,
                34.791509
              ],
              [
                45.702165,
                34.791024
              ],
              [
                45.703093,
                34.790503
              ],
              [
                45.703631,
                34.790119
              ],
              [
                45.70402,
                34.789633
              ],
              [
                45.703809,
                34.789209
              ],
              [
                45.703547,
                34.788759
              ],
              [
                45.702956,
                34.788163
              ],
              [
                45.702115,
                34.7879
              ],
              [
                45.701418,
                34.787629
              ],
              [
                45.700942,
                34.787302
              ],
              [
                45.700551,
                34.786961
              ],
              [
                45.700275,
                34.786411
              ],
              [
                45.700096,
                34.786024
              ],
              [
                45.699862,
                34.785596
              ],
              [
                45.699414,
                34.785554
              ],
              [
                45.699012,
                34.785513
              ],
              [
                45.698162,
                34.784996
              ],
              [
                45.697499,
                34.7846
              ],
              [
                45.697184,
                34.784032
              ],
              [
                45.696918,
                34.783651
              ],
              [
                45.696518,
                34.783576
              ],
              [
                45.695982,
                34.783669
              ],
              [
                45.695567,
                34.783751
              ],
              [
                45.695212,
                34.783505
              ],
              [
                45.69486,
                34.783225
              ],
              [
                45.6944,
                34.783092
              ],
              [
                45.693756,
                34.782897
              ],
              [
                45.693283,
                34.782843
              ],
              [
                45.692806,
                34.782773
              ],
              [
                45.692869,
                34.78254
              ],
              [
                45.693362,
                34.78224
              ],
              [
                45.693793,
                34.781918
              ],
              [
                45.694124,
                34.781424
              ],
              [
                45.694459,
                34.780862
              ],
              [
                45.694833,
                34.780361
              ],
              [
                45.69532,
                34.779952
              ],
              [
                45.695938,
                34.779358
              ],
              [
                45.69647,
                34.779034
              ],
              [
                45.696879,
                34.778672
              ],
              [
                45.697267,
                34.777965
              ],
              [
                45.697618,
                34.776904
              ],
              [
                45.69791,
                34.775957
              ],
              [
                45.698113,
                34.775316
              ],
              [
                45.698772,
                34.772848
              ],
              [
                45.69876,
                34.77002
              ],
              [
                45.69774,
                34.768675
              ],
              [
                45.695866,
                34.769858
              ],
              [
                45.695024,
                34.770697
              ],
              [
                45.691336,
                34.770762
              ],
              [
                45.690301,
                34.770311
              ],
              [
                45.689902,
                34.769203
              ],
              [
                45.689245,
                34.768353
              ],
              [
                45.68831,
                34.767723
              ],
              [
                45.685778,
                34.766807
              ],
              [
                45.684417,
                34.766089
              ],
              [
                45.681982,
                34.764773
              ],
              [
                45.680427,
                34.763909
              ],
              [
                45.678303,
                34.762538
              ],
              [
                45.678033,
                34.761672
              ],
              [
                45.677687,
                34.759991
              ],
              [
                45.677092,
                34.757696
              ],
              [
                45.676851,
                34.756552
              ],
              [
                45.676161,
                34.755921
              ],
              [
                45.675925,
                34.755399
              ],
              [
                45.676349,
                34.754616
              ],
              [
                45.676562,
                34.75393
              ],
              [
                45.675838,
                34.752563
              ],
              [
                45.675393,
                34.751667
              ],
              [
                45.675072,
                34.750127
              ],
              [
                45.674665,
                34.748166
              ],
              [
                45.674281,
                34.747508
              ],
              [
                45.673629,
                34.747067
              ],
              [
                45.673355,
                34.74644
              ],
              [
                45.673206,
                34.745305
              ],
              [
                45.672843,
                34.743516
              ],
              [
                45.672406,
                34.741962
              ],
              [
                45.671867,
                34.741091
              ],
              [
                45.671586,
                34.739792
              ],
              [
                45.671526,
                34.738266
              ],
              [
                45.671174,
                34.737209
              ],
              [
                45.670295,
                34.736842
              ],
              [
                45.668881,
                34.73644
              ],
              [
                45.667636,
                34.735436
              ],
              [
                45.666274,
                34.734326
              ],
              [
                45.665828,
                34.733166
              ],
              [
                45.665262,
                34.731762
              ],
              [
                45.664527,
                34.730482
              ],
              [
                45.663802,
                34.729541
              ],
              [
                45.6629,
                34.728828
              ],
              [
                45.662093,
                34.728474
              ],
              [
                45.661453,
                34.728338
              ],
              [
                45.660325,
                34.728219
              ],
              [
                45.659447,
                34.727895
              ],
              [
                45.658598,
                34.727428
              ],
              [
                45.657437,
                34.727136
              ],
              [
                45.656871,
                34.726594
              ],
              [
                45.656191,
                34.725655
              ],
              [
                45.655791,
                34.725366
              ],
              [
                45.654705,
                34.72489
              ],
              [
                45.653868,
                34.724208
              ],
              [
                45.653259,
                34.72311
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555086,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سنقر",
          "name:en": "Sonqor County",
          "name:ku": "Sunqur",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1113866",
          "wikipedia": "en:Sonqor County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.0710676,
                34.8834557
              ],
              [
                47.0720815,
                34.8766368
              ],
              [
                47.0758151,
                34.8677641
              ],
              [
                47.0800209,
                34.8605104
              ],
              [
                47.0835828,
                34.8514599
              ],
              [
                47.0885181,
                34.8411404
              ],
              [
                47.0945262,
                34.8293754
              ],
              [
                47.0991611,
                34.8228933
              ],
              [
                47.1018218,
                34.8226114
              ],
              [
                47.1092891,
                34.820709
              ],
              [
                47.1115422,
                34.8207794
              ],
              [
                47.1161341,
                34.8236859
              ],
              [
                47.1166277,
                34.8237035
              ],
              [
                47.1189022,
                34.8226114
              ],
              [
                47.1212625,
                34.821026
              ],
              [
                47.1237945,
                34.8198457
              ],
              [
                47.1241593,
                34.818137
              ],
              [
                47.1236872,
                34.8160759
              ],
              [
                47.1245241,
                34.8140852
              ],
              [
                47.1272063,
                34.8115307
              ],
              [
                47.1280432,
                34.8108965
              ],
              [
                47.128365,
                34.8088704
              ],
              [
                47.1299958,
                34.8068972
              ],
              [
                47.1319914,
                34.8061748
              ],
              [
                47.134459,
                34.8056815
              ],
              [
                47.1361542,
                34.8059282
              ],
              [
                47.13727,
                34.8045891
              ],
              [
                47.139008,
                34.8033734
              ],
              [
                47.1404028,
                34.8012238
              ],
              [
                47.1405759,
                34.7998757
              ],
              [
                47.1416688,
                34.8010124
              ],
              [
                47.1449947,
                34.8014881
              ],
              [
                47.1532988,
                34.80103
              ],
              [
                47.1688771,
                34.7980522
              ],
              [
                47.171731,
                34.7969598
              ],
              [
                47.1746921,
                34.7951977
              ],
              [
                47.1756363,
                34.79481
              ],
              [
                47.179048,
                34.7945633
              ],
              [
                47.183876,
                34.7925369
              ],
              [
                47.1902489,
                34.7931184
              ],
              [
                47.1965146,
                34.7951272
              ],
              [
                47.1988106,
                34.7961316
              ],
              [
                47.1994757,
                34.7975765
              ],
              [
                47.2009992,
                34.7990213
              ],
              [
                47.2020507,
                34.7992328
              ],
              [
                47.2045827,
                34.7984927
              ],
              [
                47.2102904,
                34.7960787
              ],
              [
                47.2118997,
                34.7953915
              ],
              [
                47.2131657,
                34.7946867
              ],
              [
                47.2173071,
                34.7945809
              ],
              [
                47.2201609,
                34.7959025
              ],
              [
                47.2240233,
                34.795321
              ],
              [
                47.2281647,
                34.7936823
              ],
              [
                47.231512,
                34.7926778
              ],
              [
                47.2341084,
                34.7923254
              ],
              [
                47.2346663,
                34.7931184
              ],
              [
                47.2346663,
                34.7943519
              ],
              [
                47.2374987,
                34.7991094
              ],
              [
                47.2377777,
                34.8002547
              ],
              [
                47.2372627,
                34.8012767
              ],
              [
                47.2376919,
                34.8019462
              ],
              [
                47.2394728,
                34.8018581
              ],
              [
                47.2439146,
                34.8011886
              ],
              [
                47.2467685,
                34.8011534
              ],
              [
                47.2500515,
                34.8016819
              ],
              [
                47.2540855,
                34.8006952
              ],
              [
                47.2575187,
                34.8005543
              ],
              [
                47.2608018,
                34.8007305
              ],
              [
                47.2642994,
                34.8003957
              ],
              [
                47.2656512,
                34.7997261
              ],
              [
                47.2684192,
                34.7965721
              ],
              [
                47.2718525,
                34.7957968
              ],
              [
                47.273612,
                34.7940876
              ],
              [
                47.2743201,
                34.7930831
              ],
              [
                47.2751999,
                34.7922373
              ],
              [
                47.2769594,
                34.7916734
              ],
              [
                47.2785687,
                34.7919377
              ],
              [
                47.2803497,
                34.7928012
              ],
              [
                47.2816372,
                34.7932417
              ],
              [
                47.2828173,
                34.7947748
              ],
              [
                47.2847914,
                34.7956911
              ],
              [
                47.287066,
                34.7951977
              ],
              [
                47.2896623,
                34.7936999
              ],
              [
                47.2915935,
                34.7911624
              ],
              [
                47.2917866,
                34.7901579
              ],
              [
                47.2928166,
                34.7890301
              ],
              [
                47.2937393,
                34.7887129
              ],
              [
                47.2964215,
                34.7883605
              ],
              [
                47.2983098,
                34.7877789
              ],
              [
                47.3051119,
                34.7877261
              ],
              [
                47.3082018,
                34.7866511
              ],
              [
                47.3121928,
                34.7858228
              ],
              [
                47.3165273,
                34.7852589
              ],
              [
                47.318716,
                34.7851531
              ],
              [
                47.3193597,
                34.7849064
              ],
              [
                47.3214197,
                34.7848359
              ],
              [
                47.3221492,
                34.784413
              ],
              [
                47.3243379,
                34.7807825
              ],
              [
                47.3245525,
                34.7789848
              ],
              [
                47.3305606,
                34.7758476
              ],
              [
                47.332406,
                34.7724988
              ],
              [
                47.3322343,
                34.7703484
              ],
              [
                47.3330497,
                34.7688325
              ],
              [
                47.3327922,
                34.7662942
              ],
              [
                47.3342943,
                34.7655186
              ],
              [
                47.3362684,
                34.7625572
              ],
              [
                47.3374271,
                34.7610059
              ],
              [
                47.339015,
                34.7578328
              ],
              [
                47.341032,
                34.7557525
              ],
              [
                47.3464822,
                34.7535312
              ],
              [
                47.3542499,
                34.7503225
              ],
              [
                47.3573293,
                34.7516481
              ],
              [
                47.3622408,
                34.7523557
              ],
              [
                47.3668064,
                34.7536603
              ],
              [
                47.375482,
                34.7556677
              ],
              [
                47.3905236,
                34.7455001
              ],
              [
                47.3980238,
                34.7402219
              ],
              [
                47.4060803,
                34.7324446
              ],
              [
                47.4063569,
                34.7316145
              ],
              [
                47.4121906,
                34.7238371
              ],
              [
                47.4130233,
                34.7221679
              ],
              [
                47.4208041,
                34.7060535
              ],
              [
                47.4246901,
                34.7027242
              ],
              [
                47.4263573,
                34.7016144
              ],
              [
                47.4671934,
                34.6849405
              ],
              [
                47.4674731,
                34.6846698
              ],
              [
                47.4685832,
                34.6843901
              ],
              [
                47.4694165,
                34.6841105
              ],
              [
                47.4860828,
                34.6818909
              ],
              [
                47.4946963,
                34.6818909
              ],
              [
                47.4963627,
                34.6824412
              ],
              [
                47.4991394,
                34.682721
              ],
              [
                47.5008062,
                34.6832804
              ],
              [
                47.5033062,
                34.6835511
              ],
              [
                47.5563655,
                34.692998
              ],
              [
                47.5583089,
                34.6929981
              ],
              [
                47.560532,
                34.6935575
              ],
              [
                47.5624754,
                34.6935575
              ],
              [
                47.5635888,
                34.6938372
              ],
              [
                47.565532,
                34.6938372
              ],
              [
                47.566922,
                34.6941169
              ],
              [
                47.5735885,
                34.694947
              ],
              [
                47.5785887,
                34.694947
              ],
              [
                47.5802551,
                34.694947
              ],
              [
                47.5830317,
                34.694947
              ],
              [
                47.5835884,
                34.6946673
              ],
              [
                47.5858118,
                34.6946673
              ],
              [
                47.5860884,
                34.6943876
              ],
              [
                47.5921982,
                34.6932779
              ],
              [
                47.5935882,
                34.6921681
              ],
              [
                47.5966449,
                34.6907785
              ],
              [
                47.5971983,
                34.6907786
              ],
              [
                47.597755,
                34.6907786
              ],
              [
                47.5980351,
                34.6904988
              ],
              [
                47.5999781,
                34.6902191
              ],
              [
                47.6022017,
                34.689389
              ],
              [
                47.603868,
                34.6893891
              ],
              [
                47.6044216,
                34.6891093
              ],
              [
                47.6102549,
                34.688559
              ],
              [
                47.6108115,
                34.688559
              ],
              [
                47.6110881,
                34.6882793
              ],
              [
                47.6116448,
                34.6882793
              ],
              [
                47.6119214,
                34.6879996
              ],
              [
                47.612478,
                34.6879996
              ],
              [
                47.6127545,
                34.6877199
              ],
              [
                47.6133112,
                34.6877199
              ],
              [
                47.6135882,
                34.6874492
              ],
              [
                47.620258,
                34.6818911
              ],
              [
                47.6249779,
                34.6763331
              ],
              [
                47.6258111,
                34.6760625
              ],
              [
                47.6263678,
                34.675503
              ],
              [
                47.6377579,
                34.6685555
              ],
              [
                47.6438678,
                34.6663358
              ],
              [
                47.6444245,
                34.6657765
              ],
              [
                47.6805374,
                34.653
              ],
              [
                47.683314,
                34.6518902
              ],
              [
                47.7180405,
                34.640774
              ],
              [
                47.7438735,
                34.6360549
              ],
              [
                47.7491533,
                34.6355045
              ],
              [
                47.7558199,
                34.6355045
              ],
              [
                47.7585964,
                34.6352248
              ],
              [
                47.7680432,
                34.6352248
              ],
              [
                47.7688763,
                34.6355046
              ],
              [
                47.7705431,
                34.6355046
              ],
              [
                47.771653,
                34.6352248
              ],
              [
                47.788876,
                34.6352249
              ],
              [
                47.7897095,
                34.6355046
              ],
              [
                47.7938761,
                34.6355047
              ],
              [
                47.7947093,
                34.6357843
              ],
              [
                47.8077659,
                34.6382747
              ],
              [
                47.8094326,
                34.6382748
              ],
              [
                47.8097092,
                34.6385544
              ],
              [
                47.8108225,
                34.6385544
              ],
              [
                47.8116557,
                34.6388342
              ],
              [
                47.8288791,
                34.6418931
              ],
              [
                47.8305454,
                34.6421637
              ],
              [
                47.8310987,
                34.6424434
              ],
              [
                47.8319323,
                34.6424434
              ],
              [
                47.832489,
                34.6427231
              ],
              [
                47.8349919,
                34.6429464
              ],
              [
                47.8429182,
                34.6433793
              ],
              [
                47.8586019,
                34.6482813
              ],
              [
                47.8577687,
                34.649671
              ],
              [
                47.8574886,
                34.6499416
              ],
              [
                47.8572117,
                34.6505011
              ],
              [
                47.8569351,
                34.6507807
              ],
              [
                47.8569351,
                34.6510605
              ],
              [
                47.8555451,
                34.6535598
              ],
              [
                47.8536018,
                34.6613377
              ],
              [
                47.8538784,
                34.6674462
              ],
              [
                47.854712,
                34.6718944
              ],
              [
                47.8636016,
                34.6827218
              ],
              [
                47.8641581,
                34.684391
              ],
              [
                47.8644351,
                34.6880001
              ],
              [
                47.8638785,
                34.6910589
              ],
              [
                47.8638784,
                34.6913386
              ],
              [
                47.8630449,
                34.694668
              ],
              [
                47.8652683,
                34.7224487
              ],
              [
                47.8649917,
                34.7229991
              ],
              [
                47.8624916,
                34.7302261
              ],
              [
                47.8591548,
                34.7346742
              ],
              [
                47.858045,
                34.7371734
              ],
              [
                47.8574883,
                34.7377238
              ],
              [
                47.8574883,
                34.7380035
              ],
              [
                47.8574883,
                34.7382831
              ],
              [
                47.8572114,
                34.7388335
              ],
              [
                47.8574884,
                34.7407824
              ],
              [
                47.8577684,
                34.741053
              ],
              [
                47.8577684,
                34.7441117
              ],
              [
                47.8574883,
                34.7443914
              ],
              [
                47.8558215,
                34.7507792
              ],
              [
                47.854155,
                34.7541175
              ],
              [
                47.8533214,
                34.7549475
              ],
              [
                47.8513784,
                34.7585565
              ],
              [
                47.8511014,
                34.7591159
              ],
              [
                47.8491549,
                34.7630045
              ],
              [
                47.8488783,
                34.7646736
              ],
              [
                47.8488783,
                34.7649533
              ],
              [
                47.813875,
                34.8138351
              ],
              [
                47.8135985,
                34.8143945
              ],
              [
                47.8119316,
                34.8163433
              ],
              [
                47.8074886,
                34.8210617
              ],
              [
                47.8019318,
                34.8321766
              ],
              [
                47.8002654,
                34.834387
              ],
              [
                47.8016517,
                34.8427232
              ],
              [
                47.7971938,
                34.8511636
              ],
              [
                47.8092814,
                34.8562871
              ],
              [
                47.8231499,
                34.8573783
              ],
              [
                47.8256962,
                34.8567797
              ],
              [
                47.8320284,
                34.8577943
              ],
              [
                47.833598,
                34.8518893
              ],
              [
                47.8338781,
                34.852169
              ],
              [
                47.8347113,
                34.852169
              ],
              [
                47.8352648,
                34.8524487
              ],
              [
                47.8433213,
                34.8524488
              ],
              [
                47.843878,
                34.8527284
              ],
              [
                47.8472112,
                34.8527284
              ],
              [
                47.8480448,
                34.8530081
              ],
              [
                47.8491546,
                34.8530081
              ],
              [
                47.8586012,
                34.8557778
              ],
              [
                47.8622111,
                34.8574558
              ],
              [
                47.863601,
                34.8580062
              ],
              [
                47.8819341,
                34.8732888
              ],
              [
                47.9074905,
                34.8868934
              ],
              [
                47.9086037,
                34.8877324
              ],
              [
                47.9086038,
                34.8880031
              ],
              [
                47.9102705,
                34.8891127
              ],
              [
                47.9177704,
                34.8955089
              ],
              [
                47.9261037,
                34.9152297
              ],
              [
                47.9266603,
                34.9163393
              ],
              [
                47.9274935,
                34.9252343
              ],
              [
                47.9277701,
                34.9288428
              ],
              [
                47.9272133,
                34.9299524
              ],
              [
                47.9236036,
                34.9335609
              ],
              [
                47.9230468,
                34.9338405
              ],
              [
                47.9230469,
                34.9341202
              ],
              [
                47.9223534,
                34.9345351
              ],
              [
                47.919437,
                34.9335608
              ],
              [
                47.9183268,
                34.9335608
              ],
              [
                47.9002707,
                34.9280127
              ],
              [
                47.899437,
                34.9277331
              ],
              [
                47.8980471,
                34.9277331
              ],
              [
                47.8969338,
                34.9274534
              ],
              [
                47.8952669,
                34.9274534
              ],
              [
                47.8941572,
                34.9271737
              ],
              [
                47.8911005,
                34.9271738
              ],
              [
                47.8899907,
                34.9268941
              ],
              [
                47.8836008,
                34.926894
              ],
              [
                47.8833238,
                34.9271737
              ],
              [
                47.8805472,
                34.9271737
              ],
              [
                47.8627675,
                34.9318918
              ],
              [
                47.8624909,
                34.9321714
              ],
              [
                47.8616577,
                34.9321714
              ],
              [
                47.8613776,
                34.9324511
              ],
              [
                47.8608209,
                34.9324511
              ],
              [
                47.8605444,
                34.9327308
              ],
              [
                47.8599874,
                34.9327307
              ],
              [
                47.858601,
                34.9332901
              ],
              [
                47.8399878,
                34.938838
              ],
              [
                47.8322113,
                34.945225
              ],
              [
                47.8144312,
                34.968012
              ],
              [
                47.813598,
                34.9696809
              ],
              [
                47.8052646,
                34.980515
              ],
              [
                47.8052645,
                34.9849533
              ],
              [
                47.8060982,
                34.9888412
              ],
              [
                47.8094314,
                34.9977267
              ],
              [
                47.8113744,
                34.9988453
              ],
              [
                47.8113745,
                34.9993955
              ],
              [
                47.8110978,
                35.0003247
              ],
              [
                47.8108212,
                35.001344
              ],
              [
                47.8105412,
                35.0021739
              ],
              [
                47.8055414,
                35.0116186
              ],
              [
                47.8041512,
                35.0130078
              ],
              [
                47.8038746,
                35.0138376
              ],
              [
                47.8030414,
                35.0149562
              ],
              [
                47.7910904,
                35.0219162
              ],
              [
                47.7901863,
                35.0218899
              ],
              [
                47.7899933,
                35.0222065
              ],
              [
                47.7777883,
                35.0329462
              ],
              [
                47.7769607,
                35.0343965
              ],
              [
                47.7717957,
                35.0386575
              ],
              [
                47.7683729,
                35.0414994
              ],
              [
                47.7657599,
                35.0436287
              ],
              [
                47.7624092,
                35.0447168
              ],
              [
                47.7541762,
                35.0459434
              ],
              [
                47.7537781,
                35.0460016
              ],
              [
                47.7457091,
                35.0473936
              ],
              [
                47.736844,
                35.0518469
              ],
              [
                47.7331741,
                35.0562333
              ],
              [
                47.7311069,
                35.0605149
              ],
              [
                47.7301146,
                35.061439
              ],
              [
                47.7286935,
                35.062194
              ],
              [
                47.7275647,
                35.0621909
              ],
              [
                47.7272307,
                35.0624615
              ],
              [
                47.7261522,
                35.0624638
              ],
              [
                47.725582,
                35.0627369
              ],
              [
                47.7236017,
                35.0627673
              ],
              [
                47.7227645,
                35.06246
              ],
              [
                47.7209811,
                35.0624692
              ],
              [
                47.7114923,
                35.0594205
              ],
              [
                47.7097548,
                35.0588353
              ],
              [
                47.7087165,
                35.0588855
              ],
              [
                47.707848,
                35.0585577
              ],
              [
                47.7044974,
                35.0580174
              ],
              [
                47.7023027,
                35.0580228
              ],
              [
                47.7014774,
                35.057709
              ],
              [
                47.6914726,
                35.0577012
              ],
              [
                47.6909124,
                35.0579526
              ],
              [
                47.6827871,
                35.0605787
              ],
              [
                47.6745879,
                35.0632576
              ],
              [
                47.6666248,
                35.0645663
              ],
              [
                47.6657855,
                35.0647184
              ],
              [
                47.6629571,
                35.0649778
              ],
              [
                47.6545634,
                35.065645
              ],
              [
                47.6471333,
                35.0668953
              ],
              [
                47.6382091,
                35.0703052
              ],
              [
                47.631536,
                35.0702348
              ],
              [
                47.624536,
                35.0706644
              ],
              [
                47.6204343,
                35.0711604
              ],
              [
                47.6187599,
                35.0714568
              ],
              [
                47.6148154,
                35.071688
              ],
              [
                47.6120635,
                35.0716071
              ],
              [
                47.6099675,
                35.0716298
              ],
              [
                47.6068405,
                35.0717782
              ],
              [
                47.6012522,
                35.0724866
              ],
              [
                47.5927645,
                35.0728805
              ],
              [
                47.5868096,
                35.0724283
              ],
              [
                47.5835656,
                35.0720255
              ],
              [
                47.5805981,
                35.0717827
              ],
              [
                47.5758299,
                35.0714453
              ],
              [
                47.5685706,
                35.0715242
              ],
              [
                47.5658435,
                35.0708654
              ],
              [
                47.5598124,
                35.0710519
              ],
              [
                47.5485236,
                35.069453
              ],
              [
                47.5432825,
                35.0673527
              ],
              [
                47.5373016,
                35.0639228
              ],
              [
                47.5236793,
                35.0637669
              ],
              [
                47.5051247,
                35.0682052
              ],
              [
                47.4978056,
                35.0661775
              ],
              [
                47.4872276,
                35.0632418
              ],
              [
                47.4847791,
                35.0613824
              ],
              [
                47.4753793,
                35.0544726
              ],
              [
                47.4728566,
                35.0525827
              ],
              [
                47.4708396,
                35.0511043
              ],
              [
                47.4693599,
                35.050844
              ],
              [
                47.4672476,
                35.0508007
              ],
              [
                47.4667776,
                35.0505234
              ],
              [
                47.457162,
                35.0501318
              ],
              [
                47.4517373,
                35.0502176
              ],
              [
                47.451384,
                35.0504702
              ],
              [
                47.4495099,
                35.0504902
              ],
              [
                47.4491238,
                35.0507775
              ],
              [
                47.4416925,
                35.0515702
              ],
              [
                47.4345097,
                35.0516291
              ],
              [
                47.434173,
                35.0518713
              ],
              [
                47.4296625,
                35.0518523
              ],
              [
                47.4292075,
                35.0521714
              ],
              [
                47.426991,
                35.052207
              ],
              [
                47.4257373,
                35.0525998
              ],
              [
                47.4252047,
                35.052776
              ],
              [
                47.4246721,
                35.0530799
              ],
              [
                47.420581,
                35.056306
              ],
              [
                47.4202721,
                35.0561035
              ],
              [
                47.4108638,
                35.0605213
              ],
              [
                47.4100044,
                35.0605119
              ],
              [
                47.4097927,
                35.0607578
              ],
              [
                47.4091763,
                35.06082
              ],
              [
                47.4089891,
                35.0610662
              ],
              [
                47.4046504,
                35.0616286
              ],
              [
                47.4029975,
                35.0616365
              ],
              [
                47.3997634,
                35.061691
              ],
              [
                47.399424,
                35.0612889
              ],
              [
                47.396038,
                35.0604986
              ],
              [
                47.392917,
                35.0597163
              ],
              [
                47.3901409,
                35.0590346
              ],
              [
                47.3872245,
                35.0583513
              ],
              [
                47.3855304,
                35.0574358
              ],
              [
                47.3846981,
                35.0574139
              ],
              [
                47.3763468,
                35.0549607
              ],
              [
                47.3763143,
                35.0546714
              ],
              [
                47.371857,
                35.0538958
              ],
              [
                47.3657125,
                35.0538538
              ],
              [
                47.3652929,
                35.0535888
              ],
              [
                47.3632763,
                35.0535498
              ],
              [
                47.3608429,
                35.0527717
              ],
              [
                47.35722,
                35.0474502
              ],
              [
                47.356102,
                35.045794
              ],
              [
                47.356081,
                35.0427322
              ],
              [
                47.3585111,
                35.0367294
              ],
              [
                47.3599822,
                35.032876
              ],
              [
                47.3611225,
                35.0298943
              ],
              [
                47.3613554,
                35.0288884
              ],
              [
                47.3616803,
                35.0286096
              ],
              [
                47.3600191,
                35.0224775
              ],
              [
                47.3550574,
                35.0180366
              ],
              [
                47.3494766,
                35.0179218
              ],
              [
                47.3491724,
                35.018192
              ],
              [
                47.3469148,
                35.0182483
              ],
              [
                47.3451204,
                35.0182721
              ],
              [
                47.3376751,
                35.018235
              ],
              [
                47.3333229,
                35.0174616
              ],
              [
                47.3313443,
                35.0174831
              ],
              [
                47.3310545,
                35.0171456
              ],
              [
                47.3293807,
                35.0171679
              ],
              [
                47.3291268,
                35.0169121
              ],
              [
                47.3235745,
                35.0168807
              ],
              [
                47.3232846,
                35.017171
              ],
              [
                47.3217618,
                35.0172279
              ],
              [
                47.3207706,
                35.0171825
              ],
              [
                47.3204654,
                35.016869
              ],
              [
                47.3172841,
                35.0160468
              ],
              [
                47.3159031,
                35.015225
              ],
              [
                47.3119306,
                35.0105577
              ],
              [
                47.3082916,
                35.0062991
              ],
              [
                47.3081532,
                35.0047052
              ],
              [
                47.3080798,
                35.003873
              ],
              [
                47.3080982,
                35.0032391
              ],
              [
                47.3023276,
                35.0016452
              ],
              [
                47.2981632,
                34.9989149
              ],
              [
                47.2951591,
                34.9920756
              ],
              [
                47.2903295,
                34.9871304
              ],
              [
                47.2944478,
                34.9798005
              ],
              [
                47.304292,
                34.9763921
              ],
              [
                47.3090172,
                34.9692497
              ],
              [
                47.310525,
                34.9662384
              ],
              [
                47.3224925,
                34.9627787
              ],
              [
                47.3208743,
                34.9615451
              ],
              [
                47.3199087,
                34.9592558
              ],
              [
                47.3209626,
                34.9578281
              ],
              [
                47.3251874,
                34.9580443
              ],
              [
                47.3276565,
                34.957723
              ],
              [
                47.3293931,
                34.9573188
              ],
              [
                47.3299117,
                34.955792
              ],
              [
                47.3235225,
                34.9456842
              ],
              [
                47.3206042,
                34.9402667
              ],
              [
                47.3177718,
                34.938578
              ],
              [
                47.312622,
                34.937804
              ],
              [
                47.3041247,
                34.9344266
              ],
              [
                47.2987174,
                34.9335822
              ],
              [
                47.2954988,
                34.9308379
              ],
              [
                47.2924518,
                34.9296417
              ],
              [
                47.2742557,
                34.9241527
              ],
              [
                47.2606086,
                34.9244342
              ],
              [
                47.2515534,
                34.9284806
              ],
              [
                47.2458457,
                34.9299935
              ],
              [
                47.2437185,
                34.9408529
              ],
              [
                47.2426739,
                34.9480859
              ],
              [
                47.2421827,
                34.9518832
              ],
              [
                47.2425579,
                34.9544228
              ],
              [
                47.2409749,
                34.9544428
              ],
              [
                47.2386599,
                34.9534994
              ],
              [
                47.2363632,
                34.9529384
              ],
              [
                47.2344138,
                34.9524019
              ],
              [
                47.228673,
                34.9501459
              ],
              [
                47.2269803,
                34.9498311
              ],
              [
                47.2221486,
                34.9480131
              ],
              [
                47.2209647,
                34.9448121
              ],
              [
                47.2172892,
                34.9426187
              ],
              [
                47.2137988,
                34.9407365
              ],
              [
                47.2115023,
                34.9396456
              ],
              [
                47.2080775,
                34.9378149
              ],
              [
                47.2052246,
                34.9361773
              ],
              [
                47.2014989,
                34.9344199
              ],
              [
                47.1955571,
                34.9309896
              ],
              [
                47.1900036,
                34.9325922
              ],
              [
                47.1869052,
                34.9379677
              ],
              [
                47.1865368,
                34.9434503
              ],
              [
                47.1858411,
                34.9528746
              ],
              [
                47.1859477,
                34.9583262
              ],
              [
                47.1858856,
                34.9628334
              ],
              [
                47.1817954,
                34.9642208
              ],
              [
                47.1738871,
                34.9633172
              ],
              [
                47.1688987,
                34.9612057
              ],
              [
                47.1706863,
                34.9573719
              ],
              [
                47.171291,
                34.9531052
              ],
              [
                47.1718882,
                34.9520607
              ],
              [
                47.1734611,
                34.947055
              ],
              [
                47.174124,
                34.9431625
              ],
              [
                47.1745039,
                34.9383935
              ],
              [
                47.1775532,
                34.9363354
              ],
              [
                47.1799563,
                34.9348205
              ],
              [
                47.1804131,
                34.9339783
              ],
              [
                47.1801563,
                34.9328334
              ],
              [
                47.1782814,
                34.9320283
              ],
              [
                47.1771694,
                34.9313601
              ],
              [
                47.1772352,
                34.9279093
              ],
              [
                47.1775334,
                34.9263302
              ],
              [
                47.1769573,
                34.9249905
              ],
              [
                47.1762468,
                34.9236923
              ],
              [
                47.17662,
                34.9221744
              ],
              [
                47.1762371,
                34.9205284
              ],
              [
                47.1750354,
                34.9193671
              ],
              [
                47.17422,
                34.9186634
              ],
              [
                47.1743917,
                34.9173262
              ],
              [
                47.1760654,
                34.912857
              ],
              [
                47.1746063,
                34.9102175
              ],
              [
                47.1744776,
                34.908757
              ],
              [
                47.1739626,
                34.90793
              ],
              [
                47.1739626,
                34.9060471
              ],
              [
                47.1737831,
                34.9044802
              ],
              [
                47.1728099,
                34.9033707
              ],
              [
                47.1719334,
                34.9015581
              ],
              [
                47.1718308,
                34.9002753
              ],
              [
                47.170483,
                34.8999761
              ],
              [
                47.1670292,
                34.9012274
              ],
              [
                47.1647866,
                34.9014406
              ],
              [
                47.1632109,
                34.9016322
              ],
              [
                47.1613449,
                34.9019823
              ],
              [
                47.1592493,
                34.9024536
              ],
              [
                47.157242,
                34.9028455
              ],
              [
                47.1502232,
                34.9030168
              ],
              [
                47.1479607,
                34.9024888
              ],
              [
                47.1457141,
                34.9017202
              ],
              [
                47.1420259,
                34.8992916
              ],
              [
                47.1410635,
                34.8983783
              ],
              [
                47.1392755,
                34.8978152
              ],
              [
                47.1311042,
                34.8972297
              ],
              [
                47.127144,
                34.8984968
              ],
              [
                47.1227675,
                34.9000084
              ],
              [
                47.1150491,
                34.9036335
              ],
              [
                47.1112842,
                34.9047755
              ],
              [
                47.1105148,
                34.9041772
              ],
              [
                47.1097571,
                34.9025513
              ],
              [
                47.1088638,
                34.9006595
              ],
              [
                47.1078132,
                34.8991303
              ],
              [
                47.1060815,
                34.898268
              ],
              [
                47.1029376,
                34.8963505
              ],
              [
                47.1009635,
                34.8951537
              ],
              [
                47.0988177,
                34.8927601
              ],
              [
                47.0969295,
                34.8919857
              ],
              [
                47.0907497,
                34.8919857
              ],
              [
                47.0841407,
                34.8943793
              ],
              [
                47.0807933,
                34.8934641
              ],
              [
                47.0799887,
                34.8933057
              ],
              [
                47.0790874,
                34.8933057
              ],
              [
                47.0766734,
                34.8933937
              ],
              [
                47.07574,
                34.8937193
              ],
              [
                47.0710408,
                34.8921881
              ],
              [
                47.0702898,
                34.8917041
              ],
              [
                47.0697962,
                34.8910793
              ],
              [
                47.0690668,
                34.8902696
              ],
              [
                47.068895,
                34.889328
              ],
              [
                47.0701932,
                34.8872863
              ],
              [
                47.0719635,
                34.8847252
              ],
              [
                47.072095,
                34.883975
              ],
              [
                47.0710676,
                34.8834557
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555115,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان صحنه",
          "name:en": "Sahneh County",
          "name:ku": "Sehne",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291793",
          "wikipedia": "en:Sahneh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.1157881,
                34.5696601
              ],
              [
                47.1169015,
                34.5693893
              ],
              [
                47.1174546,
                34.5693895
              ],
              [
                47.1180117,
                34.5691096
              ],
              [
                47.1188444,
                34.5691097
              ],
              [
                47.1194015,
                34.56883
              ],
              [
                47.1232875,
                34.5688299
              ],
              [
                47.123568,
                34.5691097
              ],
              [
                47.1246782,
                34.5691097
              ],
              [
                47.1249547,
                34.5693894
              ],
              [
                47.1446809,
                34.5760578
              ],
              [
                47.1463473,
                34.5771677
              ],
              [
                47.1521811,
                34.5793875
              ],
              [
                47.1532904,
                34.5793874
              ],
              [
                47.1535678,
                34.5796672
              ],
              [
                47.1552342,
                34.5796672
              ],
              [
                47.1557905,
                34.5793875
              ],
              [
                47.1574577,
                34.5793875
              ],
              [
                47.158014,
                34.5791078
              ],
              [
                47.1591241,
                34.5791077
              ],
              [
                47.1594007,
                34.578828
              ],
              [
                47.1610672,
                34.5782686
              ],
              [
                47.1719042,
                34.5677202
              ],
              [
                47.1730136,
                34.5655004
              ],
              [
                47.1802371,
                34.5596623
              ],
              [
                47.1813473,
                34.5593825
              ],
              [
                47.1830138,
                34.5585523
              ],
              [
                47.1841271,
                34.5585524
              ],
              [
                47.1844036,
                34.5582726
              ],
              [
                47.1935702,
                34.5557731
              ],
              [
                47.1949602,
                34.5557731
              ],
              [
                47.1977368,
                34.554943
              ],
              [
                47.1991267,
                34.554943
              ],
              [
                47.199404,
                34.5546632
              ],
              [
                47.2019032,
                34.5546632
              ],
              [
                47.2021837,
                34.5543836
              ],
              [
                47.2030173,
                34.5543835
              ],
              [
                47.2060705,
                34.5543835
              ],
              [
                47.2094035,
                34.5543835
              ],
              [
                47.2096839,
                34.5541038
              ],
              [
                47.2107932,
                34.5538331
              ],
              [
                47.2130168,
                34.5538331
              ],
              [
                47.2291265,
                34.5477152
              ],
              [
                47.2410729,
                34.5393863
              ],
              [
                47.2432963,
                34.5371576
              ],
              [
                47.2444066,
                34.5366071
              ],
              [
                47.249963,
                34.5313282
              ],
              [
                47.2499629,
                34.5310486
              ],
              [
                47.251073,
                34.5293881
              ],
              [
                47.2516301,
                34.528549
              ],
              [
                47.252463,
                34.528549
              ],
              [
                47.252463,
                34.5288288
              ],
              [
                47.2532967,
                34.5288287
              ],
              [
                47.2630194,
                34.5338279
              ],
              [
                47.2855189,
                34.5588323
              ],
              [
                47.2857956,
                34.559103
              ],
              [
                47.3024654,
                34.5729992
              ],
              [
                47.3182985,
                34.5810572
              ],
              [
                47.3207985,
                34.5818874
              ],
              [
                47.3210751,
                34.5816077
              ],
              [
                47.3216322,
                34.5813279
              ],
              [
                47.3585783,
                34.5710504
              ],
              [
                47.3596885,
                34.5710503
              ],
              [
                47.3624683,
                34.5702202
              ],
              [
                47.3641347,
                34.5702201
              ],
              [
                47.3738584,
                34.5682802
              ],
              [
                47.3758012,
                34.5682802
              ],
              [
                47.3769115,
                34.5680004
              ],
              [
                47.3783014,
                34.5680004
              ],
              [
                47.3794115,
                34.5677207
              ],
              [
                47.3808014,
                34.5677207
              ],
              [
                47.381635,
                34.567441
              ],
              [
                47.3838577,
                34.567441
              ],
              [
                47.3844116,
                34.567441
              ],
              [
                47.3852445,
                34.5671613
              ],
              [
                47.387468,
                34.5671613
              ],
              [
                47.3883016,
                34.5668816
              ],
              [
                47.3969142,
                34.5660514
              ],
              [
                47.4019144,
                34.5660514
              ],
              [
                47.4033011,
                34.5657717
              ],
              [
                47.413581,
                34.565501
              ],
              [
                47.4144146,
                34.5657717
              ],
              [
                47.4152474,
                34.5655011
              ],
              [
                47.4155241,
                34.5657717
              ],
              [
                47.4408038,
                34.5624422
              ],
              [
                47.4408038,
                34.5621624
              ],
              [
                47.4405272,
                34.5618827
              ],
              [
                47.4408039,
                34.5599425
              ],
              [
                47.4410808,
                34.5588327
              ],
              [
                47.4413604,
                34.558553
              ],
              [
                47.4413605,
                34.5577228
              ],
              [
                47.4413606,
                34.5571634
              ],
              [
                47.4413605,
                34.5502242
              ],
              [
                47.441914,
                34.5457756
              ],
              [
                47.4421941,
                34.5438265
              ],
              [
                47.4424707,
                34.5424459
              ],
              [
                47.4477506,
                34.529109
              ],
              [
                47.4538605,
                34.5254994
              ],
              [
                47.4546941,
                34.5254995
              ],
              [
                47.4549707,
                34.5252197
              ],
              [
                47.4558039,
                34.5252198
              ],
              [
                47.4619173,
                34.5224404
              ],
              [
                47.4627506,
                34.5224405
              ],
              [
                47.4630271,
                34.5221607
              ],
              [
                47.4813603,
                34.5118917
              ],
              [
                47.4819169,
                34.5110525
              ],
              [
                47.4871968,
                34.5068835
              ],
              [
                47.4919168,
                34.5007744
              ],
              [
                47.4913637,
                34.4982748
              ],
              [
                47.4894168,
                34.4968851
              ],
              [
                47.4871968,
                34.496885
              ],
              [
                47.4855304,
                34.4968851
              ],
              [
                47.4846972,
                34.4968851
              ],
              [
                47.4841406,
                34.4971648
              ],
              [
                47.4824736,
                34.4971648
              ],
              [
                47.481917,
                34.4974446
              ],
              [
                47.4810838,
                34.4974445
              ],
              [
                47.4805271,
                34.4971648
              ],
              [
                47.4791404,
                34.4971648
              ],
              [
                47.4783072,
                34.496885
              ],
              [
                47.476917,
                34.496885
              ],
              [
                47.4766404,
                34.4966053
              ],
              [
                47.4746938,
                34.4966053
              ],
              [
                47.4744172,
                34.4963255
              ],
              [
                47.4674738,
                34.4929958
              ],
              [
                47.4666405,
                34.4882762
              ],
              [
                47.4691406,
                34.4785484
              ],
              [
                47.4752506,
                34.46522
              ],
              [
                47.4755272,
                34.4646604
              ],
              [
                47.4755272,
                34.4632707
              ],
              [
                47.4755272,
                34.4621608
              ],
              [
                47.4758073,
                34.4616103
              ],
              [
                47.4755271,
                34.4610508
              ],
              [
                47.474694,
                34.4402141
              ],
              [
                47.4760839,
                34.4371639
              ],
              [
                47.4896971,
                34.430495
              ],
              [
                47.4905306,
                34.4304951
              ],
              [
                47.4908073,
                34.4302152
              ],
              [
                47.4916405,
                34.4302152
              ],
              [
                47.4919171,
                34.4299355
              ],
              [
                47.5033072,
                34.4252159
              ],
              [
                47.5041403,
                34.4246654
              ],
              [
                47.5058068,
                34.4235463
              ],
              [
                47.5063635,
                34.4235464
              ],
              [
                47.5052536,
                34.4216062
              ],
              [
                47.5044205,
                34.4213264
              ],
              [
                47.4894171,
                34.4141069
              ],
              [
                47.4891405,
                34.4135474
              ],
              [
                47.4877507,
                34.4116071
              ],
              [
                47.4860838,
                34.4038282
              ],
              [
                47.4855307,
                34.3993791
              ],
              [
                47.4855308,
                34.391609
              ],
              [
                47.4852507,
                34.3888295
              ],
              [
                47.4855307,
                34.38827
              ],
              [
                47.4852506,
                34.3866005
              ],
              [
                47.4855308,
                34.3849309
              ],
              [
                47.4858074,
                34.3835502
              ],
              [
                47.4860839,
                34.3821605
              ],
              [
                47.486364,
                34.3816009
              ],
              [
                47.4877507,
                34.3802111
              ],
              [
                47.4880309,
                34.3799314
              ],
              [
                47.4880308,
                34.3804909
              ],
              [
                47.4885839,
                34.3807707
              ],
              [
                47.4902508,
                34.3829907
              ],
              [
                47.4908074,
                34.3829908
              ],
              [
                47.4919173,
                34.3835502
              ],
              [
                47.493584,
                34.3835502
              ],
              [
                47.4938641,
                34.38383
              ],
              [
                47.4977505,
                34.38383
              ],
              [
                47.4980306,
                34.3841098
              ],
              [
                47.5110872,
                34.3852109
              ],
              [
                47.5191405,
                34.3852108
              ],
              [
                47.5199737,
                34.3854906
              ],
              [
                47.5205303,
                34.3852109
              ],
              [
                47.5294203,
                34.3852108
              ],
              [
                47.529977,
                34.3849311
              ],
              [
                47.5355302,
                34.3846604
              ],
              [
                47.5366435,
                34.3849312
              ],
              [
                47.5444198,
                34.3849311
              ],
              [
                47.5469199,
                34.3852108
              ],
              [
                47.5533098,
                34.3852109
              ],
              [
                47.5535864,
                34.3854907
              ],
              [
                47.5546998,
                34.3854907
              ],
              [
                47.5552533,
                34.3857705
              ],
              [
                47.5560865,
                34.3857704
              ],
              [
                47.5588666,
                34.3866007
              ],
              [
                47.5599764,
                34.3866007
              ],
              [
                47.5605331,
                34.3868804
              ],
              [
                47.5616432,
                34.3868805
              ],
              [
                47.5627565,
                34.3871602
              ],
              [
                47.5705328,
                34.3871602
              ],
              [
                47.5710896,
                34.38744
              ],
              [
                47.5719231,
                34.3871602
              ],
              [
                47.5727563,
                34.38744
              ],
              [
                47.5860894,
                34.38744
              ],
              [
                47.5869226,
                34.3871603
              ],
              [
                47.5905329,
                34.3871602
              ],
              [
                47.5910896,
                34.38744
              ],
              [
                47.5977561,
                34.38744
              ],
              [
                47.5983127,
                34.3871603
              ],
              [
                47.6027558,
                34.3871603
              ],
              [
                47.6033125,
                34.3868805
              ],
              [
                47.6049792,
                34.3868805
              ],
              [
                47.6052558,
                34.3866008
              ],
              [
                47.6088693,
                34.3863301
              ],
              [
                47.6094224,
                34.3863301
              ],
              [
                47.6097025,
                34.3860503
              ],
              [
                47.6102559,
                34.3860503
              ],
              [
                47.6105357,
                34.3857705
              ],
              [
                47.6110892,
                34.3857705
              ],
              [
                47.6155357,
                34.3841101
              ],
              [
                47.6324787,
                34.3693821
              ],
              [
                47.6344257,
                34.3666025
              ],
              [
                47.6344257,
                34.3663228
              ],
              [
                47.6344257,
                34.366052
              ],
              [
                47.6330358,
                34.357993
              ],
              [
                47.6310925,
                34.353544
              ],
              [
                47.6308123,
                34.3518833
              ],
              [
                47.6305358,
                34.3463241
              ],
              [
                47.6319257,
                34.341884
              ],
              [
                47.6422021,
                34.3346553
              ],
              [
                47.6494257,
                34.3324352
              ],
              [
                47.6513687,
                34.3321553
              ],
              [
                47.6519254,
                34.3318756
              ],
              [
                47.6558153,
                34.3310544
              ],
              [
                47.6572056,
                34.3310544
              ],
              [
                47.6577587,
                34.3307746
              ],
              [
                47.6602588,
                34.3307746
              ],
              [
                47.6608154,
                34.3304948
              ],
              [
                47.6619252,
                34.3304949
              ],
              [
                47.6624823,
                34.3307747
              ],
              [
                47.6633154,
                34.3304948
              ],
              [
                47.6644252,
                34.3307746
              ],
              [
                47.6674819,
                34.3307746
              ],
              [
                47.6677585,
                34.3304948
              ],
              [
                47.6694253,
                34.3304948
              ],
              [
                47.6697055,
                34.3302151
              ],
              [
                47.6708152,
                34.3302151
              ],
              [
                47.6710918,
                34.3299354
              ],
              [
                47.6797052,
                34.3293849
              ],
              [
                47.6797052,
                34.3291051
              ],
              [
                47.6816487,
                34.3291051
              ],
              [
                47.6822053,
                34.3288253
              ],
              [
                47.6833151,
                34.3288253
              ],
              [
                47.6835952,
                34.3285455
              ],
              [
                47.6835952,
                34.3293849
              ],
              [
                47.6833151,
                34.3299354
              ],
              [
                47.6833151,
                34.3324353
              ],
              [
                47.683315,
                34.332715
              ],
              [
                47.681095,
                34.3402146
              ],
              [
                47.6808149,
                34.3416043
              ],
              [
                47.6805385,
                34.3424346
              ],
              [
                47.6797052,
                34.3463243
              ],
              [
                47.6794286,
                34.3477141
              ],
              [
                47.6791485,
                34.3493836
              ],
              [
                47.6788719,
                34.3510532
              ],
              [
                47.6791485,
                34.3560528
              ],
              [
                47.6799817,
                34.359383
              ],
              [
                47.6927616,
                34.3732718
              ],
              [
                47.6930381,
                34.3735515
              ],
              [
                47.6949846,
                34.3752121
              ],
              [
                47.6952616,
                34.3754918
              ],
              [
                47.6969281,
                34.3766019
              ],
              [
                47.6999847,
                34.3779916
              ],
              [
                47.7002613,
                34.3782714
              ],
              [
                47.7010946,
                34.3782714
              ],
              [
                47.7016512,
                34.3779917
              ],
              [
                47.7047048,
                34.3779917
              ],
              [
                47.7052614,
                34.3777119
              ],
              [
                47.7085947,
                34.3777119
              ],
              [
                47.7238743,
                34.3741021
              ],
              [
                47.7252611,
                34.3741021
              ],
              [
                47.7280412,
                34.3732719
              ],
              [
                47.7291511,
                34.3732719
              ],
              [
                47.7308178,
                34.3727124
              ],
              [
                47.7319312,
                34.3727124
              ],
              [
                47.7619306,
                34.3554935
              ],
              [
                47.7630409,
                34.354934
              ],
              [
                47.7635974,
                34.3596539
              ],
              [
                47.7644307,
                34.3627132
              ],
              [
                47.7647072,
                34.3638323
              ],
              [
                47.7691538,
                34.3707722
              ],
              [
                47.7713773,
                34.3718822
              ],
              [
                47.7769305,
                34.374382
              ],
              [
                47.7869338,
                34.3766021
              ],
              [
                47.7897104,
                34.3766021
              ],
              [
                47.7905436,
                34.3768819
              ],
              [
                47.7913769,
                34.3766021
              ],
              [
                47.7930437,
                34.3768818
              ],
              [
                47.7958203,
                34.3768819
              ],
              [
                47.8066569,
                34.3796615
              ],
              [
                47.8127667,
                34.3849317
              ],
              [
                47.8147097,
                34.3885505
              ],
              [
                47.8133233,
                34.3927198
              ],
              [
                47.8130432,
                34.3938208
              ],
              [
                47.8130433,
                34.3943804
              ],
              [
                47.8019332,
                34.4241066
              ],
              [
                47.8016531,
                34.4263266
              ],
              [
                47.8013765,
                34.4274365
              ],
              [
                47.801653,
                34.4307755
              ],
              [
                47.8030433,
                34.4329955
              ],
              [
                47.8038766,
                34.4341055
              ],
              [
                47.8044332,
                34.434665
              ],
              [
                47.8116564,
                34.4385454
              ],
              [
                47.8138763,
                34.4385454
              ],
              [
                47.8144329,
                34.4388251
              ],
              [
                47.8177662,
                34.4388252
              ],
              [
                47.8183229,
                34.4391049
              ],
              [
                47.8222097,
                34.4391049
              ],
              [
                47.8227664,
                34.4388251
              ],
              [
                47.8252664,
                34.4388252
              ],
              [
                47.8258231,
                34.4391049
              ],
              [
                47.8280461,
                34.4391049
              ],
              [
                47.8283231,
                34.4393847
              ],
              [
                47.8294329,
                34.4393846
              ],
              [
                47.829713,
                34.4396644
              ],
              [
                47.8308228,
                34.4396645
              ],
              [
                47.8349896,
                34.4427146
              ],
              [
                47.8355463,
                34.4446639
              ],
              [
                47.8355463,
                34.4449346
              ],
              [
                47.8358229,
                34.4463242
              ],
              [
                47.8352662,
                34.4474433
              ],
              [
                47.8352662,
                34.4479937
              ],
              [
                47.8352662,
                34.4482735
              ],
              [
                47.8344329,
                34.4499429
              ],
              [
                47.8302661,
                34.4529931
              ],
              [
                47.8299895,
                34.4535526
              ],
              [
                47.8294329,
                34.4535526
              ],
              [
                47.8288797,
                34.4541031
              ],
              [
                47.8185998,
                34.4568824
              ],
              [
                47.8180432,
                34.4571622
              ],
              [
                47.816933,
                34.4571622
              ],
              [
                47.8163763,
                34.457442
              ],
              [
                47.8119329,
                34.457442
              ],
              [
                47.8110996,
                34.4571622
              ],
              [
                47.8091566,
                34.4571622
              ],
              [
                47.8088765,
                34.4568824
              ],
              [
                47.8074898,
                34.4568825
              ],
              [
                47.8069332,
                34.4571622
              ],
              [
                47.8063765,
                34.4571622
              ],
              [
                47.8044331,
                34.4577127
              ],
              [
                47.8022101,
                34.4588316
              ],
              [
                47.801653,
                34.4588316
              ],
              [
                47.7997099,
                34.459382
              ],
              [
                47.7922099,
                34.4632715
              ],
              [
                47.7908199,
                34.463831
              ],
              [
                47.7705437,
                34.4777189
              ],
              [
                47.7630403,
                34.486048
              ],
              [
                47.7560968,
                34.496606
              ],
              [
                47.7552637,
                34.4971654
              ],
              [
                47.7530401,
                34.5004952
              ],
              [
                47.752487,
                34.5016052
              ],
              [
                47.7513737,
                34.5046642
              ],
              [
                47.7510971,
                34.504935
              ],
              [
                47.7510971,
                34.5052147
              ],
              [
                47.7510971,
                34.5054945
              ],
              [
                47.7508205,
                34.5057742
              ],
              [
                47.7505405,
                34.5066134
              ],
              [
                47.7502639,
                34.5071638
              ],
              [
                47.7502639,
                34.5074346
              ],
              [
                47.7494303,
                34.509113
              ],
              [
                47.7488737,
                34.5110531
              ],
              [
                47.7319306,
                34.5324393
              ],
              [
                47.7199839,
                34.5421668
              ],
              [
                47.7191506,
                34.542997
              ],
              [
                47.7158174,
                34.5474366
              ],
              [
                47.7158173,
                34.5485555
              ],
              [
                47.7152607,
                34.5499452
              ],
              [
                47.7152606,
                34.5532749
              ],
              [
                47.7155407,
                34.5543847
              ],
              [
                47.7210939,
                34.5621631
              ],
              [
                47.7349837,
                34.5730003
              ],
              [
                47.7355404,
                34.5735507
              ],
              [
                47.7358169,
                34.5738304
              ],
              [
                47.7519301,
                34.5779993
              ],
              [
                47.7527632,
                34.5779993
              ],
              [
                47.7830432,
                34.5935557
              ],
              [
                47.7833198,
                34.5938354
              ],
              [
                47.810266,
                34.6082728
              ],
              [
                47.8122093,
                34.6091119
              ],
              [
                47.8224893,
                34.6160598
              ],
              [
                47.8241557,
                34.6168899
              ],
              [
                47.8408219,
                34.6307766
              ],
              [
                47.8499885,
                34.6416134
              ],
              [
                47.8583175,
                34.6480612
              ],
              [
                47.8586019,
                34.6482813
              ],
              [
                47.8429182,
                34.6433793
              ],
              [
                47.8349919,
                34.6429464
              ],
              [
                47.832489,
                34.6427231
              ],
              [
                47.8319323,
                34.6424434
              ],
              [
                47.8310987,
                34.6424434
              ],
              [
                47.8305454,
                34.6421637
              ],
              [
                47.8288791,
                34.6418931
              ],
              [
                47.8116557,
                34.6388342
              ],
              [
                47.8108225,
                34.6385544
              ],
              [
                47.8097092,
                34.6385544
              ],
              [
                47.8094326,
                34.6382748
              ],
              [
                47.8077659,
                34.6382747
              ],
              [
                47.7947093,
                34.6357843
              ],
              [
                47.7938761,
                34.6355047
              ],
              [
                47.7897095,
                34.6355046
              ],
              [
                47.788876,
                34.6352249
              ],
              [
                47.771653,
                34.6352248
              ],
              [
                47.7705431,
                34.6355046
              ],
              [
                47.7688763,
                34.6355046
              ],
              [
                47.7680432,
                34.6352248
              ],
              [
                47.7585964,
                34.6352248
              ],
              [
                47.7558199,
                34.6355045
              ],
              [
                47.7491533,
                34.6355045
              ],
              [
                47.7438735,
                34.6360549
              ],
              [
                47.7180405,
                34.640774
              ],
              [
                47.683314,
                34.6518902
              ],
              [
                47.6805374,
                34.653
              ],
              [
                47.6444245,
                34.6657765
              ],
              [
                47.6438678,
                34.6663358
              ],
              [
                47.6377579,
                34.6685555
              ],
              [
                47.6263678,
                34.675503
              ],
              [
                47.6258111,
                34.6760625
              ],
              [
                47.6249779,
                34.6763331
              ],
              [
                47.620258,
                34.6818911
              ],
              [
                47.6135882,
                34.6874492
              ],
              [
                47.6133112,
                34.6877199
              ],
              [
                47.6127545,
                34.6877199
              ],
              [
                47.612478,
                34.6879996
              ],
              [
                47.6119214,
                34.6879996
              ],
              [
                47.6116448,
                34.6882793
              ],
              [
                47.6110881,
                34.6882793
              ],
              [
                47.6108115,
                34.688559
              ],
              [
                47.6102549,
                34.688559
              ],
              [
                47.6044216,
                34.6891093
              ],
              [
                47.603868,
                34.6893891
              ],
              [
                47.6022017,
                34.689389
              ],
              [
                47.5999781,
                34.6902191
              ],
              [
                47.5980351,
                34.6904988
              ],
              [
                47.597755,
                34.6907786
              ],
              [
                47.5971983,
                34.6907786
              ],
              [
                47.5966449,
                34.6907785
              ],
              [
                47.5935882,
                34.6921681
              ],
              [
                47.5921982,
                34.6932779
              ],
              [
                47.5860884,
                34.6943876
              ],
              [
                47.5858118,
                34.6946673
              ],
              [
                47.5835884,
                34.6946673
              ],
              [
                47.5830317,
                34.694947
              ],
              [
                47.5802551,
                34.694947
              ],
              [
                47.5785887,
                34.694947
              ],
              [
                47.5735885,
                34.694947
              ],
              [
                47.566922,
                34.6941169
              ],
              [
                47.565532,
                34.6938372
              ],
              [
                47.5635888,
                34.6938372
              ],
              [
                47.5624754,
                34.6935575
              ],
              [
                47.560532,
                34.6935575
              ],
              [
                47.5583089,
                34.6929981
              ],
              [
                47.5563655,
                34.692998
              ],
              [
                47.5033062,
                34.6835511
              ],
              [
                47.5008062,
                34.6832804
              ],
              [
                47.4991394,
                34.682721
              ],
              [
                47.4963627,
                34.6824412
              ],
              [
                47.4946963,
                34.6818909
              ],
              [
                47.4860828,
                34.6818909
              ],
              [
                47.4694165,
                34.6841105
              ],
              [
                47.4685832,
                34.6843901
              ],
              [
                47.4674731,
                34.6846698
              ],
              [
                47.4671934,
                34.6849405
              ],
              [
                47.4263573,
                34.7016144
              ],
              [
                47.4246901,
                34.7027242
              ],
              [
                47.4208041,
                34.7060535
              ],
              [
                47.4130233,
                34.7221679
              ],
              [
                47.4121906,
                34.7238371
              ],
              [
                47.4063569,
                34.7316145
              ],
              [
                47.4060803,
                34.7324446
              ],
              [
                47.3980238,
                34.7402219
              ],
              [
                47.3905236,
                34.7455001
              ],
              [
                47.375482,
                34.7556677
              ],
              [
                47.3668064,
                34.7536603
              ],
              [
                47.3622408,
                34.7523557
              ],
              [
                47.3573293,
                34.7516481
              ],
              [
                47.3542499,
                34.7503225
              ],
              [
                47.3464822,
                34.7535312
              ],
              [
                47.341032,
                34.7557525
              ],
              [
                47.339015,
                34.7578328
              ],
              [
                47.3374271,
                34.7610059
              ],
              [
                47.3362684,
                34.7625572
              ],
              [
                47.3342943,
                34.7655186
              ],
              [
                47.3327922,
                34.7662942
              ],
              [
                47.3330497,
                34.7688325
              ],
              [
                47.3322343,
                34.7703484
              ],
              [
                47.332406,
                34.7724988
              ],
              [
                47.3305606,
                34.7758476
              ],
              [
                47.3245525,
                34.7789848
              ],
              [
                47.3243379,
                34.7807825
              ],
              [
                47.3221492,
                34.784413
              ],
              [
                47.3214197,
                34.7848359
              ],
              [
                47.3193597,
                34.7849064
              ],
              [
                47.318716,
                34.7851531
              ],
              [
                47.3165273,
                34.7852589
              ],
              [
                47.3121928,
                34.7858228
              ],
              [
                47.3082018,
                34.7866511
              ],
              [
                47.3051119,
                34.7877261
              ],
              [
                47.2983098,
                34.7877789
              ],
              [
                47.2964215,
                34.7883605
              ],
              [
                47.2937393,
                34.7887129
              ],
              [
                47.2928166,
                34.7890301
              ],
              [
                47.2917866,
                34.7901579
              ],
              [
                47.2915935,
                34.7911624
              ],
              [
                47.2896623,
                34.7936999
              ],
              [
                47.287066,
                34.7951977
              ],
              [
                47.2847914,
                34.7956911
              ],
              [
                47.2828173,
                34.7947748
              ],
              [
                47.2816372,
                34.7932417
              ],
              [
                47.2803497,
                34.7928012
              ],
              [
                47.2785687,
                34.7919377
              ],
              [
                47.2769594,
                34.7916734
              ],
              [
                47.2751999,
                34.7922373
              ],
              [
                47.2743201,
                34.7930831
              ],
              [
                47.273612,
                34.7940876
              ],
              [
                47.2718525,
                34.7957968
              ],
              [
                47.2684192,
                34.7965721
              ],
              [
                47.2656512,
                34.7997261
              ],
              [
                47.2642994,
                34.8003957
              ],
              [
                47.2608018,
                34.8007305
              ],
              [
                47.2575187,
                34.8005543
              ],
              [
                47.2540855,
                34.8006952
              ],
              [
                47.2500515,
                34.8016819
              ],
              [
                47.2467685,
                34.8011534
              ],
              [
                47.2439146,
                34.8011886
              ],
              [
                47.2394728,
                34.8018581
              ],
              [
                47.2376919,
                34.8019462
              ],
              [
                47.2372627,
                34.8012767
              ],
              [
                47.2377777,
                34.8002547
              ],
              [
                47.2374987,
                34.7991094
              ],
              [
                47.2346663,
                34.7943519
              ],
              [
                47.2346663,
                34.7931184
              ],
              [
                47.2341084,
                34.7923254
              ],
              [
                47.231512,
                34.7926778
              ],
              [
                47.2281647,
                34.7936823
              ],
              [
                47.2240233,
                34.795321
              ],
              [
                47.2201609,
                34.7959025
              ],
              [
                47.2173071,
                34.7945809
              ],
              [
                47.2131657,
                34.7946867
              ],
              [
                47.2118997,
                34.7953915
              ],
              [
                47.2102904,
                34.7960787
              ],
              [
                47.2045827,
                34.7984927
              ],
              [
                47.2020507,
                34.7992328
              ],
              [
                47.2009992,
                34.7990213
              ],
              [
                47.1994757,
                34.7975765
              ],
              [
                47.1988106,
                34.7961316
              ],
              [
                47.1965146,
                34.7951272
              ],
              [
                47.1902489,
                34.7931184
              ],
              [
                47.183876,
                34.7925369
              ],
              [
                47.179048,
                34.7945633
              ],
              [
                47.1756363,
                34.79481
              ],
              [
                47.1746921,
                34.7951977
              ],
              [
                47.171731,
                34.7969598
              ],
              [
                47.1688771,
                34.7980522
              ],
              [
                47.1532988,
                34.80103
              ],
              [
                47.1449947,
                34.8014881
              ],
              [
                47.1416688,
                34.8010124
              ],
              [
                47.1405759,
                34.7998757
              ],
              [
                47.1395311,
                34.7994244
              ],
              [
                47.1366906,
                34.7987923
              ],
              [
                47.1336222,
                34.7988628
              ],
              [
                47.1324874,
                34.7982923
              ],
              [
                47.1338344,
                34.7961675
              ],
              [
                47.133814,
                34.7923804
              ],
              [
                47.133814,
                34.7906954
              ],
              [
                47.1342145,
                34.7885876
              ],
              [
                47.1333968,
                34.7870027
              ],
              [
                47.1343639,
                34.7849858
              ],
              [
                47.1435668,
                34.7816156
              ],
              [
                47.1435668,
                34.7746686
              ],
              [
                47.1438434,
                34.7732791
              ],
              [
                47.144124,
                34.77078
              ],
              [
                47.1446801,
                34.7693906
              ],
              [
                47.1474568,
                34.761893
              ],
              [
                47.1510671,
                34.758275
              ],
              [
                47.1838467,
                34.7402214
              ],
              [
                47.1860694,
                34.7388319
              ],
              [
                47.2238492,
                34.7066125
              ],
              [
                47.2246829,
                34.7057824
              ],
              [
                47.2249595,
                34.705223
              ],
              [
                47.2310728,
                34.7010545
              ],
              [
                47.2344057,
                34.7005042
              ],
              [
                47.2346823,
                34.7007838
              ],
              [
                47.2357924,
                34.7005042
              ],
              [
                47.2363495,
                34.7007838
              ],
              [
                47.2407957,
                34.7007838
              ],
              [
                47.2416293,
                34.7005042
              ],
              [
                47.2444059,
                34.7005042
              ],
              [
                47.2449622,
                34.7002245
              ],
              [
                47.2471826,
                34.7002245
              ],
              [
                47.2477388,
                34.6999448
              ],
              [
                47.248849,
                34.6999448
              ],
              [
                47.2494061,
                34.6996651
              ],
              [
                47.2505154,
                34.6993944
              ],
              [
                47.2519061,
                34.6993944
              ],
              [
                47.2524623,
                34.6991147
              ],
              [
                47.2538492,
                34.6991147
              ],
              [
                47.2544061,
                34.698835
              ],
              [
                47.2566289,
                34.698835
              ],
              [
                47.257182,
                34.6985553
              ],
              [
                47.2616289,
                34.6982846
              ],
              [
                47.2663525,
                34.6982846
              ],
              [
                47.2680189,
                34.698005
              ],
              [
                47.2691291,
                34.6980049
              ],
              [
                47.2694056,
                34.6977253
              ],
              [
                47.2705189,
                34.6977252
              ],
              [
                47.2757957,
                34.695226
              ],
              [
                47.2860755,
                34.6874484
              ],
              [
                47.2874623,
                34.6857792
              ],
              [
                47.2871857,
                34.6854994
              ],
              [
                47.2863521,
                34.6854994
              ],
              [
                47.2849623,
                34.6849401
              ],
              [
                47.2816286,
                34.6843897
              ],
              [
                47.2816286,
                34.68411
              ],
              [
                47.2796856,
                34.68411
              ],
              [
                47.2794091,
                34.6838303
              ],
              [
                47.272462,
                34.6838302
              ],
              [
                47.2721855,
                34.6835505
              ],
              [
                47.2660721,
                34.6830001
              ],
              [
                47.2657955,
                34.6832798
              ],
              [
                47.2649627,
                34.6830001
              ],
              [
                47.2638525,
                34.6830001
              ],
              [
                47.2619056,
                34.6824407
              ],
              [
                47.2602391,
                34.6824407
              ],
              [
                47.259686,
                34.682161
              ],
              [
                47.2552391,
                34.6818903
              ],
              [
                47.2549625,
                34.682161
              ],
              [
                47.2541288,
                34.6818903
              ],
              [
                47.2519062,
                34.6818902
              ],
              [
                47.2516296,
                34.6816105
              ],
              [
                47.241906,
                34.6816105
              ],
              [
                47.2413497,
                34.6818902
              ],
              [
                47.2352394,
                34.682161
              ],
              [
                47.2344058,
                34.6821609
              ],
              [
                47.2266259,
                34.680221
              ],
              [
                47.2263494,
                34.6796616
              ],
              [
                47.2138499,
                34.6641152
              ],
              [
                47.2116265,
                34.6607766
              ],
              [
                47.1982934,
                34.6493896
              ],
              [
                47.19607,
                34.6477204
              ],
              [
                47.18718,
                34.6410523
              ],
              [
                47.1760705,
                34.6282757
              ],
              [
                47.1741235,
                34.6218873
              ],
              [
                47.1724572,
                34.6093901
              ],
              [
                47.1716235,
                34.6077207
              ],
              [
                47.1649571,
                34.5993922
              ],
              [
                47.159957,
                34.5966041
              ],
              [
                47.1574576,
                34.596604
              ],
              [
                47.156624,
                34.5963243
              ],
              [
                47.1549576,
                34.5960536
              ],
              [
                47.1530137,
                34.5960536
              ],
              [
                47.1524576,
                34.5957739
              ],
              [
                47.1513473,
                34.5957739
              ],
              [
                47.1419011,
                34.5932744
              ],
              [
                47.128011,
                34.5852255
              ],
              [
                47.1263446,
                34.5838269
              ],
              [
                47.1238445,
                34.5818869
              ],
              [
                47.1238445,
                34.5816072
              ],
              [
                47.1155116,
                34.5727191
              ],
              [
                47.1155116,
                34.5699399
              ],
              [
                47.1157881,
                34.5696601
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555153,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قصر شیرین",
          "name:en": "Qasr-e-Shirin County",
          "name:ku": "Qesra Şîrîn",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q767866"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.407661,
                33.977255
              ],
              [
                45.409135,
                33.976761
              ],
              [
                45.412044,
                33.975201
              ],
              [
                45.413407,
                33.974283
              ],
              [
                45.414953,
                33.973082
              ],
              [
                45.415933,
                33.97188
              ],
              [
                45.41714,
                33.969983
              ],
              [
                45.417241,
                33.969639
              ],
              [
                45.417227,
                33.969391
              ],
              [
                45.417496,
                33.96895
              ],
              [
                45.41758,
                33.967746
              ],
              [
                45.41777,
                33.967058
              ],
              [
                45.418269,
                33.966132
              ],
              [
                45.419089,
                33.965108
              ],
              [
                45.419189,
                33.964506
              ],
              [
                45.419134,
                33.963786
              ],
              [
                45.420033,
                33.962923
              ],
              [
                45.420788,
                33.961857
              ],
              [
                45.420788,
                33.961738
              ],
              [
                45.420159,
                33.959753
              ],
              [
                45.420158,
                33.959634
              ],
              [
                45.420467,
                33.959365
              ],
              [
                45.420736,
                33.959009
              ],
              [
                45.421109,
                33.958782
              ],
              [
                45.421534,
                33.958856
              ],
              [
                45.42165,
                33.958813
              ],
              [
                45.421804,
                33.958661
              ],
              [
                45.421985,
                33.958672
              ],
              [
                45.422459,
                33.958036
              ],
              [
                45.423217,
                33.957571
              ],
              [
                45.424016,
                33.957321
              ],
              [
                45.42448,
                33.957287
              ],
              [
                45.424814,
                33.957028
              ],
              [
                45.426294,
                33.956454
              ],
              [
                45.426447,
                33.956066
              ],
              [
                45.427181,
                33.955903
              ],
              [
                45.427758,
                33.955267
              ],
              [
                45.428531,
                33.954931
              ],
              [
                45.429868,
                33.954096
              ],
              [
                45.429993,
                33.953966
              ],
              [
                45.429931,
                33.953094
              ],
              [
                45.429965,
                33.952571
              ],
              [
                45.429797,
                33.951842
              ],
              [
                45.42977,
                33.951392
              ],
              [
                45.429673,
                33.951097
              ],
              [
                45.429849,
                33.950997
              ],
              [
                45.430047,
                33.950486
              ],
              [
                45.42986,
                33.94952
              ],
              [
                45.429898,
                33.949417
              ],
              [
                45.430128,
                33.949161
              ],
              [
                45.430167,
                33.949037
              ],
              [
                45.430189,
                33.948449
              ],
              [
                45.430831,
                33.94776
              ],
              [
                45.431054,
                33.946971
              ],
              [
                45.431109,
                33.946416
              ],
              [
                45.431065,
                33.946079
              ],
              [
                45.431309,
                33.945793
              ],
              [
                45.431354,
                33.945628
              ],
              [
                45.431545,
                33.945556
              ],
              [
                45.43182,
                33.945599
              ],
              [
                45.432113,
                33.945737
              ],
              [
                45.432294,
                33.945764
              ],
              [
                45.432815,
                33.94632
              ],
              [
                45.433255,
                33.946508
              ],
              [
                45.433615,
                33.946719
              ],
              [
                45.434125,
                33.946804
              ],
              [
                45.434432,
                33.94674
              ],
              [
                45.434719,
                33.94648
              ],
              [
                45.435418,
                33.94634
              ],
              [
                45.435637,
                33.946666
              ],
              [
                45.435832,
                33.946727
              ],
              [
                45.436051,
                33.947031
              ],
              [
                45.436382,
                33.947283
              ],
              [
                45.436987,
                33.947385
              ],
              [
                45.437145,
                33.947484
              ],
              [
                45.437523,
                33.947437
              ],
              [
                45.437754,
                33.947507
              ],
              [
                45.437968,
                33.947458
              ],
              [
                45.438258,
                33.947541
              ],
              [
                45.438418,
                33.947668
              ],
              [
                45.438565,
                33.947951
              ],
              [
                45.439061,
                33.947954
              ],
              [
                45.439371,
                33.948048
              ],
              [
                45.439549,
                33.948014
              ],
              [
                45.439903,
                33.947512
              ],
              [
                45.440173,
                33.947297
              ],
              [
                45.440454,
                33.9472
              ],
              [
                45.441518,
                33.947265
              ],
              [
                45.441824,
                33.947768
              ],
              [
                45.441985,
                33.94776
              ],
              [
                45.442122,
                33.94765
              ],
              [
                45.442278,
                33.94705
              ],
              [
                45.442744,
                33.9469
              ],
              [
                45.442935,
                33.946781
              ],
              [
                45.443399,
                33.946813
              ],
              [
                45.443601,
                33.946762
              ],
              [
                45.443768,
                33.946586
              ],
              [
                45.443933,
                33.946546
              ],
              [
                45.444036,
                33.946622
              ],
              [
                45.444112,
                33.946846
              ],
              [
                45.444106,
                33.947107
              ],
              [
                45.444259,
                33.947393
              ],
              [
                45.444477,
                33.947571
              ],
              [
                45.444516,
                33.947949
              ],
              [
                45.444787,
                33.947975
              ],
              [
                45.445105,
                33.948128
              ],
              [
                45.445275,
                33.948105
              ],
              [
                45.445464,
                33.947764
              ],
              [
                45.445672,
                33.947619
              ],
              [
                45.445986,
                33.947545
              ],
              [
                45.446582,
                33.947607
              ],
              [
                45.446817,
                33.947671
              ],
              [
                45.44706,
                33.947817
              ],
              [
                45.44726,
                33.947803
              ],
              [
                45.447413,
                33.947593
              ],
              [
                45.447416,
                33.947416
              ],
              [
                45.447698,
                33.947134
              ],
              [
                45.448013,
                33.94699
              ],
              [
                45.448838,
                33.946741
              ],
              [
                45.449027,
                33.946632
              ],
              [
                45.449832,
                33.946557
              ],
              [
                45.449976,
                33.946432
              ],
              [
                45.450033,
                33.946246
              ],
              [
                45.449997,
                33.945928
              ],
              [
                45.450064,
                33.945782
              ],
              [
                45.450808,
                33.945217
              ],
              [
                45.450955,
                33.945008
              ],
              [
                45.451211,
                33.94485
              ],
              [
                45.451516,
                33.944806
              ],
              [
                45.451774,
                33.944871
              ],
              [
                45.451935,
                33.945026
              ],
              [
                45.452186,
                33.945134
              ],
              [
                45.453776,
                33.945373
              ],
              [
                45.454183,
                33.94559
              ],
              [
                45.454678,
                33.945751
              ],
              [
                45.454967,
                33.945756
              ],
              [
                45.455638,
                33.945642
              ],
              [
                45.455837,
                33.945647
              ],
              [
                45.456092,
                33.945912
              ],
              [
                45.456384,
                33.94593
              ],
              [
                45.456733,
                33.94605
              ],
              [
                45.457005,
                33.946052
              ],
              [
                45.457161,
                33.945953
              ],
              [
                45.457312,
                33.94578
              ],
              [
                45.457722,
                33.944972
              ],
              [
                45.457929,
                33.944943
              ],
              [
                45.458565,
                33.945012
              ],
              [
                45.458907,
                33.945096
              ],
              [
                45.459415,
                33.945102
              ],
              [
                45.459796,
                33.945161
              ],
              [
                45.460045,
                33.945237
              ],
              [
                45.46035,
                33.945545
              ],
              [
                45.460637,
                33.945614
              ],
              [
                45.460839,
                33.94573
              ],
              [
                45.460991,
                33.945752
              ],
              [
                45.461817,
                33.945576
              ],
              [
                45.4621,
                33.945888
              ],
              [
                45.462289,
                33.945996
              ],
              [
                45.462849,
                33.94605
              ],
              [
                45.463045,
                33.946139
              ],
              [
                45.463461,
                33.946609
              ],
              [
                45.463504,
                33.946718
              ],
              [
                45.463545,
                33.946842
              ],
              [
                45.463389,
                33.947396
              ],
              [
                45.463729,
                33.94792
              ],
              [
                45.463884,
                33.948406
              ],
              [
                45.46428,
                33.948717
              ],
              [
                45.46455,
                33.948813
              ],
              [
                45.464788,
                33.948862
              ],
              [
                45.465235,
                33.948493
              ],
              [
                45.466001,
                33.948254
              ],
              [
                45.46634,
                33.948282
              ],
              [
                45.466964,
                33.94865
              ],
              [
                45.467282,
                33.94871
              ],
              [
                45.467576,
                33.94883
              ],
              [
                45.467778,
                33.949038
              ],
              [
                45.467977,
                33.94914
              ],
              [
                45.468224,
                33.949114
              ],
              [
                45.468456,
                33.948998
              ],
              [
                45.468593,
                33.948818
              ],
              [
                45.468779,
                33.948417
              ],
              [
                45.468979,
                33.948357
              ],
              [
                45.469594,
                33.948336
              ],
              [
                45.469907,
                33.94842
              ],
              [
                45.47052,
                33.948294
              ],
              [
                45.470793,
                33.948305
              ],
              [
                45.471056,
                33.948462
              ],
              [
                45.47117,
                33.948657
              ],
              [
                45.471379,
                33.948776
              ],
              [
                45.471663,
                33.948832
              ],
              [
                45.471919,
                33.949125
              ],
              [
                45.472184,
                33.949291
              ],
              [
                45.473508,
                33.949411
              ],
              [
                45.474152,
                33.949344
              ],
              [
                45.474485,
                33.949439
              ],
              [
                45.474843,
                33.949474
              ],
              [
                45.47539,
                33.949288
              ],
              [
                45.476809,
                33.949211
              ],
              [
                45.477187,
                33.949141
              ],
              [
                45.477469,
                33.949165
              ],
              [
                45.477686,
                33.94932
              ],
              [
                45.478243,
                33.949527
              ],
              [
                45.478718,
                33.949534
              ],
              [
                45.479102,
                33.949657
              ],
              [
                45.480022,
                33.949569
              ],
              [
                45.480349,
                33.949405
              ],
              [
                45.480919,
                33.948413
              ],
              [
                45.481348,
                33.948112
              ],
              [
                45.481825,
                33.947886
              ],
              [
                45.48205,
                33.947627
              ],
              [
                45.482369,
                33.94752
              ],
              [
                45.482605,
                33.947519
              ],
              [
                45.482901,
                33.947624
              ],
              [
                45.483668,
                33.948122
              ],
              [
                45.484144,
                33.94837
              ],
              [
                45.48461,
                33.948503
              ],
              [
                45.485038,
                33.94874
              ],
              [
                45.48528,
                33.948975
              ],
              [
                45.485958,
                33.949218
              ],
              [
                45.486531,
                33.949705
              ],
              [
                45.486876,
                33.949899
              ],
              [
                45.487917,
                33.95013
              ],
              [
                45.488377,
                33.950121
              ],
              [
                45.489298,
                33.949726
              ],
              [
                45.490154,
                33.94963
              ],
              [
                45.490857,
                33.94972
              ],
              [
                45.491341,
                33.949619
              ],
              [
                45.49185,
                33.949629
              ],
              [
                45.492336,
                33.949797
              ],
              [
                45.492728,
                33.950072
              ],
              [
                45.493461,
                33.950334
              ],
              [
                45.493806,
                33.950408
              ],
              [
                45.494109,
                33.950591
              ],
              [
                45.494439,
                33.951052
              ],
              [
                45.494657,
                33.951258
              ],
              [
                45.494866,
                33.951308
              ],
              [
                45.495619,
                33.951298
              ],
              [
                45.49603,
                33.951412
              ],
              [
                45.496382,
                33.951448
              ],
              [
                45.496688,
                33.951454
              ],
              [
                45.497967,
                33.950932
              ],
              [
                45.498517,
                33.950876
              ],
              [
                45.49893,
                33.950976
              ],
              [
                45.499409,
                33.951024
              ],
              [
                45.500405,
                33.95097
              ],
              [
                45.500965,
                33.950884
              ],
              [
                45.50126,
                33.951105
              ],
              [
                45.501437,
                33.951397
              ],
              [
                45.501506,
                33.95183
              ],
              [
                45.501646,
                33.951989
              ],
              [
                45.502122,
                33.952213
              ],
              [
                45.502228,
                33.952326
              ],
              [
                45.502385,
                33.952394
              ],
              [
                45.502405,
                33.952525
              ],
              [
                45.502324,
                33.952941
              ],
              [
                45.50246,
                33.953086
              ],
              [
                45.502731,
                33.953182
              ],
              [
                45.502947,
                33.953165
              ],
              [
                45.503305,
                33.952968
              ],
              [
                45.503704,
                33.952936
              ],
              [
                45.503865,
                33.952882
              ],
              [
                45.50395,
                33.952767
              ],
              [
                45.50405,
                33.952454
              ],
              [
                45.504411,
                33.952219
              ],
              [
                45.504295,
                33.951825
              ],
              [
                45.504337,
                33.951716
              ],
              [
                45.50494,
                33.95141
              ],
              [
                45.505265,
                33.951353
              ],
              [
                45.505311,
                33.95129
              ],
              [
                45.505201,
                33.951062
              ],
              [
                45.505191,
                33.950925
              ],
              [
                45.505291,
                33.950825
              ],
              [
                45.5055,
                33.950759
              ],
              [
                45.505701,
                33.950773
              ],
              [
                45.505803,
                33.950728
              ],
              [
                45.505864,
                33.95063
              ],
              [
                45.506253,
                33.950512
              ],
              [
                45.506395,
                33.950396
              ],
              [
                45.506459,
                33.950265
              ],
              [
                45.506755,
                33.949948
              ],
              [
                45.506741,
                33.9497
              ],
              [
                45.507023,
                33.949367
              ],
              [
                45.507042,
                33.949257
              ],
              [
                45.507154,
                33.94916
              ],
              [
                45.50762,
                33.948941
              ],
              [
                45.507662,
                33.948619
              ],
              [
                45.507771,
                33.948486
              ],
              [
                45.508306,
                33.948343
              ],
              [
                45.508371,
                33.948217
              ],
              [
                45.508389,
                33.947913
              ],
              [
                45.508715,
                33.947744
              ],
              [
                45.508976,
                33.947465
              ],
              [
                45.509183,
                33.94739
              ],
              [
                45.509367,
                33.947379
              ],
              [
                45.509586,
                33.94719
              ],
              [
                45.509663,
                33.947039
              ],
              [
                45.509943,
                33.946887
              ],
              [
                45.510033,
                33.946771
              ],
              [
                45.510033,
                33.946488
              ],
              [
                45.510136,
                33.94635
              ],
              [
                45.510448,
                33.946217
              ],
              [
                45.510638,
                33.945977
              ],
              [
                45.51148,
                33.945656
              ],
              [
                45.511585,
                33.945574
              ],
              [
                45.511539,
                33.945335
              ],
              [
                45.511359,
                33.945077
              ],
              [
                45.511404,
                33.944935
              ],
              [
                45.51139,
                33.944664
              ],
              [
                45.511445,
                33.944585
              ],
              [
                45.511757,
                33.944498
              ],
              [
                45.511863,
                33.944425
              ],
              [
                45.511918,
                33.943948
              ],
              [
                45.512078,
                33.943625
              ],
              [
                45.512067,
                33.943506
              ],
              [
                45.511889,
                33.94328
              ],
              [
                45.511906,
                33.943166
              ],
              [
                45.512095,
                33.942894
              ],
              [
                45.51211,
                33.94265
              ],
              [
                45.511789,
                33.942364
              ],
              [
                45.511941,
                33.942177
              ],
              [
                45.512282,
                33.942024
              ],
              [
                45.512329,
                33.941887
              ],
              [
                45.512266,
                33.941721
              ],
              [
                45.512314,
                33.941449
              ],
              [
                45.51245,
                33.941357
              ],
              [
                45.512764,
                33.941279
              ],
              [
                45.51286,
                33.941184
              ],
              [
                45.512946,
                33.940767
              ],
              [
                45.512945,
                33.940619
              ],
              [
                45.512862,
                33.940511
              ],
              [
                45.512545,
                33.940363
              ],
              [
                45.512526,
                33.940209
              ],
              [
                45.512633,
                33.939737
              ],
              [
                45.512884,
                33.939446
              ],
              [
                45.512981,
                33.939259
              ],
              [
                45.512944,
                33.938917
              ],
              [
                45.512768,
                33.938579
              ],
              [
                45.512861,
                33.938425
              ],
              [
                45.513305,
                33.938065
              ],
              [
                45.513868,
                33.937923
              ],
              [
                45.514869,
                33.937418
              ],
              [
                45.515112,
                33.936498
              ],
              [
                45.515711,
                33.936007
              ],
              [
                45.516127,
                33.935884
              ],
              [
                45.516383,
                33.935708
              ],
              [
                45.516517,
                33.935371
              ],
              [
                45.516435,
                33.934884
              ],
              [
                45.516317,
                33.934578
              ],
              [
                45.516478,
                33.934214
              ],
              [
                45.51675,
                33.933984
              ],
              [
                45.516783,
                33.93384
              ],
              [
                45.516604,
                33.933586
              ],
              [
                45.516415,
                33.933454
              ],
              [
                45.516308,
                33.933267
              ],
              [
                45.516311,
                33.93271
              ],
              [
                45.516366,
                33.932492
              ],
              [
                45.516561,
                33.932294
              ],
              [
                45.516652,
                33.932038
              ],
              [
                45.517044,
                33.931766
              ],
              [
                45.516962,
                33.931519
              ],
              [
                45.517054,
                33.931217
              ],
              [
                45.517274,
                33.930959
              ],
              [
                45.517263,
                33.930724
              ],
              [
                45.517329,
                33.930574
              ],
              [
                45.517375,
                33.930177
              ],
              [
                45.517226,
                33.92984
              ],
              [
                45.51722,
                33.92972
              ],
              [
                45.517334,
                33.929581
              ],
              [
                45.517739,
                33.929344
              ],
              [
                45.51781,
                33.92924
              ],
              [
                45.517806,
                33.929078
              ],
              [
                45.51767,
                33.92884
              ],
              [
                45.517761,
                33.928418
              ],
              [
                45.518058,
                33.928198
              ],
              [
                45.518148,
                33.928058
              ],
              [
                45.518235,
                33.927877
              ],
              [
                45.518276,
                33.927481
              ],
              [
                45.518613,
                33.927218
              ],
              [
                45.518622,
                33.927068
              ],
              [
                45.518491,
                33.926802
              ],
              [
                45.518353,
                33.926648
              ],
              [
                45.518367,
                33.926539
              ],
              [
                45.518531,
                33.926188
              ],
              [
                45.518553,
                33.925952
              ],
              [
                45.518962,
                33.925399
              ],
              [
                45.518977,
                33.925035
              ],
              [
                45.519298,
                33.924538
              ],
              [
                45.519266,
                33.924121
              ],
              [
                45.519312,
                33.924007
              ],
              [
                45.519737,
                33.923827
              ],
              [
                45.519747,
                33.923394
              ],
              [
                45.51986,
                33.923301
              ],
              [
                45.520002,
                33.923237
              ],
              [
                45.520406,
                33.92325
              ],
              [
                45.520636,
                33.923176
              ],
              [
                45.520893,
                33.922861
              ],
              [
                45.52097,
                33.922547
              ],
              [
                45.521256,
                33.921903
              ],
              [
                45.521334,
                33.921612
              ],
              [
                45.521631,
                33.921323
              ],
              [
                45.521923,
                33.921201
              ],
              [
                45.521962,
                33.921056
              ],
              [
                45.521921,
                33.920956
              ],
              [
                45.521701,
                33.920718
              ],
              [
                45.521685,
                33.920414
              ],
              [
                45.52146,
                33.920205
              ],
              [
                45.521454,
                33.920062
              ],
              [
                45.522019,
                33.919662
              ],
              [
                45.522357,
                33.919639
              ],
              [
                45.522434,
                33.919538
              ],
              [
                45.522636,
                33.919417
              ],
              [
                45.522796,
                33.919145
              ],
              [
                45.523298,
                33.919124
              ],
              [
                45.523616,
                33.91923
              ],
              [
                45.524088,
                33.919269
              ],
              [
                45.52427,
                33.919253
              ],
              [
                45.524387,
                33.919178
              ],
              [
                45.52446,
                33.919036
              ],
              [
                45.524433,
                33.918874
              ],
              [
                45.524597,
                33.91862
              ],
              [
                45.524385,
                33.918209
              ],
              [
                45.524953,
                33.917853
              ],
              [
                45.525002,
                33.917659
              ],
              [
                45.524937,
                33.917317
              ],
              [
                45.525269,
                33.917082
              ],
              [
                45.525303,
                33.916896
              ],
              [
                45.525484,
                33.91669
              ],
              [
                45.525517,
                33.916523
              ],
              [
                45.525937,
                33.916487
              ],
              [
                45.526603,
                33.916633
              ],
              [
                45.526894,
                33.916623
              ],
              [
                45.527867,
                33.916218
              ],
              [
                45.527749,
                33.915987
              ],
              [
                45.527746,
                33.915575
              ],
              [
                45.52851,
                33.914931
              ],
              [
                45.528552,
                33.914804
              ],
              [
                45.528503,
                33.914622
              ],
              [
                45.528521,
                33.914419
              ],
              [
                45.528956,
                33.914186
              ],
              [
                45.529097,
                33.914047
              ],
              [
                45.528928,
                33.913723
              ],
              [
                45.528898,
                33.913477
              ],
              [
                45.528969,
                33.913308
              ],
              [
                45.52909,
                33.913177
              ],
              [
                45.529727,
                33.91299
              ],
              [
                45.530977,
                33.912262
              ],
              [
                45.531701,
                33.911968
              ],
              [
                45.532488,
                33.911844
              ],
              [
                45.532747,
                33.911751
              ],
              [
                45.53359,
                33.911952
              ],
              [
                45.534079,
                33.911761
              ],
              [
                45.534552,
                33.911735
              ],
              [
                45.534699,
                33.911665
              ],
              [
                45.535543,
                33.910794
              ],
              [
                45.535633,
                33.910678
              ],
              [
                45.535627,
                33.910465
              ],
              [
                45.535935,
                33.910081
              ],
              [
                45.536025,
                33.909802
              ],
              [
                45.536063,
                33.90949
              ],
              [
                45.536008,
                33.909263
              ],
              [
                45.535743,
                33.908745
              ],
              [
                45.535405,
                33.908281
              ],
              [
                45.535218,
                33.908112
              ],
              [
                45.534362,
                33.907714
              ],
              [
                45.534209,
                33.907479
              ],
              [
                45.534164,
                33.907222
              ],
              [
                45.534397,
                33.906317
              ],
              [
                45.534559,
                33.906147
              ],
              [
                45.534771,
                33.906043
              ],
              [
                45.535011,
                33.90599
              ],
              [
                45.535532,
                33.906044
              ],
              [
                45.535871,
                33.906002
              ],
              [
                45.536274,
                33.906016
              ],
              [
                45.536828,
                33.905693
              ],
              [
                45.536899,
                33.905589
              ],
              [
                45.536909,
                33.905258
              ],
              [
                45.53703,
                33.904919
              ],
              [
                45.537549,
                33.904338
              ],
              [
                45.538286,
                33.903323
              ],
              [
                45.538727,
                33.902324
              ],
              [
                45.539542,
                33.901667
              ],
              [
                45.539925,
                33.901251
              ],
              [
                45.54043,
                33.900872
              ],
              [
                45.54049,
                33.900698
              ],
              [
                45.540658,
                33.900502
              ],
              [
                45.540887,
                33.900374
              ],
              [
                45.541341,
                33.899887
              ],
              [
                45.541588,
                33.89969
              ],
              [
                45.5418,
                33.899422
              ],
              [
                45.54265,
                33.89936
              ],
              [
                45.542868,
                33.899239
              ],
              [
                45.543108,
                33.898747
              ],
              [
                45.543158,
                33.898444
              ],
              [
                45.543278,
                33.898272
              ],
              [
                45.543498,
                33.898073
              ],
              [
                45.543978,
                33.8979
              ],
              [
                45.544594,
                33.897542
              ],
              [
                45.544715,
                33.897403
              ],
              [
                45.544826,
                33.896498
              ],
              [
                45.545205,
                33.896089
              ],
              [
                45.545226,
                33.895834
              ],
              [
                45.545369,
                33.895763
              ],
              [
                45.545344,
                33.895509
              ],
              [
                45.545522,
                33.895328
              ],
              [
                45.545936,
                33.895105
              ],
              [
                45.546094,
                33.89484
              ],
              [
                45.546373,
                33.894692
              ],
              [
                45.546483,
                33.89456
              ],
              [
                45.546373,
                33.894172
              ],
              [
                45.5464,
                33.893998
              ],
              [
                45.54664,
                33.893857
              ],
              [
                45.546782,
                33.893693
              ],
              [
                45.546856,
                33.893407
              ],
              [
                45.547134,
                33.893227
              ],
              [
                45.547111,
                33.892864
              ],
              [
                45.547287,
                33.892618
              ],
              [
                45.547451,
                33.892521
              ],
              [
                45.547785,
                33.892557
              ],
              [
                45.548556,
                33.892382
              ],
              [
                45.549084,
                33.89213
              ],
              [
                45.549363,
                33.892158
              ],
              [
                45.549519,
                33.892232
              ],
              [
                45.549721,
                33.892239
              ],
              [
                45.549926,
                33.892174
              ],
              [
                45.550251,
                33.891768
              ],
              [
                45.550216,
                33.891527
              ],
              [
                45.55026,
                33.891345
              ],
              [
                45.550485,
                33.891108
              ],
              [
                45.550627,
                33.890856
              ],
              [
                45.550729,
                33.890489
              ],
              [
                45.551122,
                33.889826
              ],
              [
                45.551222,
                33.889219
              ],
              [
                45.551415,
                33.888845
              ],
              [
                45.55158,
                33.888808
              ],
              [
                45.551859,
                33.888518
              ],
              [
                45.551946,
                33.888319
              ],
              [
                45.551965,
                33.887965
              ],
              [
                45.552066,
                33.887884
              ],
              [
                45.552301,
                33.887836
              ],
              [
                45.552399,
                33.887684
              ],
              [
                45.55245,
                33.887326
              ],
              [
                45.55267,
                33.887215
              ],
              [
                45.552818,
                33.887077
              ],
              [
                45.552893,
                33.88694
              ],
              [
                45.55284,
                33.88674
              ],
              [
                45.553389,
                33.886003
              ],
              [
                45.553589,
                33.885337
              ],
              [
                45.553824,
                33.885087
              ],
              [
                45.554105,
                33.8846
              ],
              [
                45.55425,
                33.884479
              ],
              [
                45.554362,
                33.884013
              ],
              [
                45.554659,
                33.88383
              ],
              [
                45.554856,
                33.88347
              ],
              [
                45.554953,
                33.88305
              ],
              [
                45.555282,
                33.882632
              ],
              [
                45.555672,
                33.881926
              ],
              [
                45.555972,
                33.881611
              ],
              [
                45.556076,
                33.881425
              ],
              [
                45.556129,
                33.88099
              ],
              [
                45.556287,
                33.880697
              ],
              [
                45.55639,
                33.880594
              ],
              [
                45.556605,
                33.880489
              ],
              [
                45.556912,
                33.88003
              ],
              [
                45.556946,
                33.879741
              ],
              [
                45.557124,
                33.87939
              ],
              [
                45.557345,
                33.879076
              ],
              [
                45.557778,
                33.87879
              ],
              [
                45.558045,
                33.878415
              ],
              [
                45.558105,
                33.878159
              ],
              [
                45.558807,
                33.877448
              ],
              [
                45.558918,
                33.877151
              ],
              [
                45.559086,
                33.876955
              ],
              [
                45.559854,
                33.876185
              ],
              [
                45.559922,
                33.875873
              ],
              [
                45.560124,
                33.875453
              ],
              [
                45.560482,
                33.875041
              ],
              [
                45.560494,
                33.874487
              ],
              [
                45.56084,
                33.874373
              ],
              [
                45.561028,
                33.874119
              ],
              [
                45.561117,
                33.873782
              ],
              [
                45.561574,
                33.873279
              ],
              [
                45.562095,
                33.873176
              ],
              [
                45.562296,
                33.873008
              ],
              [
                45.562357,
                33.872839
              ],
              [
                45.562262,
                33.872455
              ],
              [
                45.562326,
                33.872269
              ],
              [
                45.562499,
                33.872095
              ],
              [
                45.562651,
                33.872033
              ],
              [
                45.562878,
                33.871833
              ],
              [
                45.562971,
                33.87166
              ],
              [
                45.562895,
                33.870955
              ],
              [
                45.563059,
                33.870886
              ],
              [
                45.56336,
                33.870893
              ],
              [
                45.563844,
                33.870594
              ],
              [
                45.563982,
                33.870244
              ],
              [
                45.563857,
                33.869828
              ],
              [
                45.563992,
                33.869635
              ],
              [
                45.564237,
                33.869514
              ],
              [
                45.564327,
                33.869254
              ],
              [
                45.564339,
                33.869044
              ],
              [
                45.564641,
                33.868869
              ],
              [
                45.564803,
                33.86869
              ],
              [
                45.565037,
                33.868134
              ],
              [
                45.565035,
                33.867806
              ],
              [
                45.565203,
                33.867665
              ],
              [
                45.565419,
                33.867653
              ],
              [
                45.565534,
                33.867602
              ],
              [
                45.565624,
                33.867487
              ],
              [
                45.565658,
                33.867274
              ],
              [
                45.565865,
                33.866987
              ],
              [
                45.565846,
                33.866702
              ],
              [
                45.565941,
                33.866554
              ],
              [
                45.566119,
                33.866011
              ],
              [
                45.566114,
                33.865799
              ],
              [
                45.566605,
                33.865503
              ],
              [
                45.566767,
                33.865152
              ],
              [
                45.566978,
                33.865057
              ],
              [
                45.56712,
                33.864794
              ],
              [
                45.56712,
                33.864317
              ],
              [
                45.567196,
                33.864169
              ],
              [
                45.56753,
                33.863914
              ],
              [
                45.567752,
                33.86365
              ],
              [
                45.567733,
                33.863092
              ],
              [
                45.568,
                33.862864
              ],
              [
                45.568209,
                33.86276
              ],
              [
                45.568297,
                33.862623
              ],
              [
                45.568357,
                33.862116
              ],
              [
                45.568703,
                33.861726
              ],
              [
                45.568774,
                33.861414
              ],
              [
                45.568977,
                33.861122
              ],
              [
                45.569067,
                33.860862
              ],
              [
                45.569458,
                33.860511
              ],
              [
                45.569555,
                33.859962
              ],
              [
                45.56996,
                33.859685
              ],
              [
                45.57026,
                33.859267
              ],
              [
                45.570297,
                33.85908
              ],
              [
                45.570474,
                33.858982
              ],
              [
                45.570727,
                33.858594
              ],
              [
                45.571288,
                33.857979
              ],
              [
                45.5715,
                33.8575
              ],
              [
                45.571821,
                33.857031
              ],
              [
                45.57204,
                33.856855
              ],
              [
                45.572112,
                33.856499
              ],
              [
                45.572302,
                33.856242
              ],
              [
                45.572306,
                33.856069
              ],
              [
                45.572401,
                33.85595
              ],
              [
                45.572789,
                33.855698
              ],
              [
                45.572934,
                33.855547
              ],
              [
                45.573065,
                33.855146
              ],
              [
                45.573383,
                33.85484
              ],
              [
                45.573414,
                33.854668
              ],
              [
                45.573361,
                33.854397
              ],
              [
                45.5734,
                33.85432
              ],
              [
                45.573623,
                33.854203
              ],
              [
                45.573844,
                33.853908
              ],
              [
                45.574047,
                33.853776
              ],
              [
                45.574431,
                33.853393
              ],
              [
                45.574688,
                33.852789
              ],
              [
                45.574854,
                33.852657
              ],
              [
                45.575384,
                33.851666
              ],
              [
                45.575636,
                33.851402
              ],
              [
                45.57596,
                33.850914
              ],
              [
                45.576072,
                33.850622
              ],
              [
                45.57633,
                33.850413
              ],
              [
                45.576525,
                33.850043
              ],
              [
                45.576936,
                33.849634
              ],
              [
                45.576992,
                33.849283
              ],
              [
                45.577071,
                33.849194
              ],
              [
                45.577454,
                33.849009
              ],
              [
                45.577706,
                33.848786
              ],
              [
                45.577846,
                33.848529
              ],
              [
                45.57784,
                33.848267
              ],
              [
                45.578089,
                33.848108
              ],
              [
                45.578249,
                33.847936
              ],
              [
                45.578307,
                33.847697
              ],
              [
                45.578485,
                33.847516
              ],
              [
                45.578527,
                33.847293
              ],
              [
                45.578479,
                33.847158
              ],
              [
                45.578525,
                33.847041
              ],
              [
                45.579015,
                33.846464
              ],
              [
                45.579368,
                33.846294
              ],
              [
                45.579443,
                33.846184
              ],
              [
                45.579653,
                33.845492
              ],
              [
                45.580179,
                33.844871
              ],
              [
                45.580657,
                33.844523
              ],
              [
                45.580984,
                33.844105
              ],
              [
                45.580965,
                33.843835
              ],
              [
                45.581053,
                33.843569
              ],
              [
                45.581417,
                33.84343
              ],
              [
                45.581828,
                33.843175
              ],
              [
                45.582018,
                33.842743
              ],
              [
                45.58215,
                33.842566
              ],
              [
                45.582302,
                33.842129
              ],
              [
                45.582814,
                33.841344
              ],
              [
                45.582779,
                33.841062
              ],
              [
                45.582596,
                33.840732
              ],
              [
                45.582648,
                33.840565
              ],
              [
                45.582863,
                33.840532
              ],
              [
                45.583092,
                33.840603
              ],
              [
                45.583204,
                33.840596
              ],
              [
                45.583296,
                33.840448
              ],
              [
                45.583475,
                33.84036
              ],
              [
                45.583522,
                33.840229
              ],
              [
                45.58378,
                33.840077
              ],
              [
                45.583808,
                33.839938
              ],
              [
                45.584188,
                33.839685
              ],
              [
                45.584271,
                33.839073
              ],
              [
                45.584463,
                33.838682
              ],
              [
                45.584906,
                33.83835
              ],
              [
                45.585216,
                33.837932
              ],
              [
                45.585237,
                33.837795
              ],
              [
                45.585345,
                33.837641
              ],
              [
                45.585671,
                33.837325
              ],
              [
                45.58579,
                33.836899
              ],
              [
                45.585421,
                33.836682
              ],
              [
                45.585102,
                33.836122
              ],
              [
                45.585078,
                33.835553
              ],
              [
                45.585192,
                33.835369
              ],
              [
                45.585224,
                33.834915
              ],
              [
                45.585156,
                33.834778
              ],
              [
                45.58514,
                33.834548
              ],
              [
                45.585032,
                33.834425
              ],
              [
                45.585087,
                33.834263
              ],
              [
                45.584997,
                33.83394
              ],
              [
                45.585037,
                33.83374
              ],
              [
                45.584865,
                33.833137
              ],
              [
                45.584621,
                33.832984
              ],
              [
                45.584667,
                33.832779
              ],
              [
                45.58463,
                33.832621
              ],
              [
                45.584693,
                33.832515
              ],
              [
                45.585248,
                33.832429
              ],
              [
                45.585652,
                33.832451
              ],
              [
                45.585835,
                33.83251
              ],
              [
                45.586178,
                33.832495
              ],
              [
                45.58634,
                33.832317
              ],
              [
                45.586714,
                33.832165
              ],
              [
                45.586795,
                33.832057
              ],
              [
                45.586802,
                33.831853
              ],
              [
                45.586734,
                33.831661
              ],
              [
                45.586784,
                33.831487
              ],
              [
                45.587218,
                33.830869
              ],
              [
                45.587553,
                33.830551
              ],
              [
                45.587875,
                33.830471
              ],
              [
                45.588292,
                33.829944
              ],
              [
                45.588444,
                33.829868
              ],
              [
                45.588681,
                33.82987
              ],
              [
                45.588837,
                33.829823
              ],
              [
                45.589629,
                33.829279
              ],
              [
                45.589836,
                33.828877
              ],
              [
                45.590059,
                33.828648
              ],
              [
                45.590132,
                33.828442
              ],
              [
                45.590555,
                33.827966
              ],
              [
                45.59117,
                33.827793
              ],
              [
                45.59152,
                33.827564
              ],
              [
                45.591907,
                33.827641
              ],
              [
                45.592006,
                33.827581
              ],
              [
                45.592087,
                33.827295
              ],
              [
                45.592363,
                33.826992
              ],
              [
                45.592835,
                33.826875
              ],
              [
                45.593189,
                33.826491
              ],
              [
                45.593599,
                33.826365
              ],
              [
                45.593762,
                33.826235
              ],
              [
                45.593918,
                33.82568
              ],
              [
                45.594034,
                33.825492
              ],
              [
                45.594187,
                33.825378
              ],
              [
                45.594385,
                33.825126
              ],
              [
                45.594521,
                33.824864
              ],
              [
                45.59445,
                33.824713
              ],
              [
                45.5945,
                33.824599
              ],
              [
                45.595228,
                33.824568
              ],
              [
                45.59538,
                33.824475
              ],
              [
                45.595474,
                33.823914
              ],
              [
                45.595743,
                33.823636
              ],
              [
                45.595895,
                33.823358
              ],
              [
                45.596428,
                33.823261
              ],
              [
                45.596683,
                33.823025
              ],
              [
                45.59683,
                33.82281
              ],
              [
                45.597348,
                33.822576
              ],
              [
                45.597567,
                33.82234
              ],
              [
                45.597654,
                33.82214
              ],
              [
                45.597635,
                33.821916
              ],
              [
                45.597785,
                33.821627
              ],
              [
                45.598279,
                33.821605
              ],
              [
                45.59873,
                33.821384
              ],
              [
                45.598786,
                33.821091
              ],
              [
                45.599169,
                33.820933
              ],
              [
                45.599251,
                33.820726
              ],
              [
                45.599201,
                33.820361
              ],
              [
                45.599725,
                33.819836
              ],
              [
                45.599818,
                33.819606
              ],
              [
                45.600151,
                33.819343
              ],
              [
                45.600409,
                33.819281
              ],
              [
                45.600628,
                33.819135
              ],
              [
                45.601013,
                33.818566
              ],
              [
                45.601207,
                33.818456
              ],
              [
                45.599542,
                33.810392
              ],
              [
                45.603272,
                33.803023
              ],
              [
                45.607034,
                33.800299
              ],
              [
                45.6097194,
                33.7989764
              ],
              [
                45.6127931,
                33.7996876
              ],
              [
                45.6183973,
                33.8006724
              ],
              [
                45.6473543,
                33.8055201
              ],
              [
                45.670041,
                33.8196565
              ],
              [
                45.6917542,
                33.8441255
              ],
              [
                45.7089943,
                33.879916
              ],
              [
                45.7186746,
                33.8889922
              ],
              [
                45.7391354,
                33.9081675
              ],
              [
                45.7477141,
                33.9213075
              ],
              [
                45.7469562,
                33.948055
              ],
              [
                45.7464546,
                33.9657457
              ],
              [
                45.7545245,
                33.9812383
              ],
              [
                45.7658164,
                34.0029062
              ],
              [
                45.7215612,
                34.032143
              ],
              [
                45.700171,
                34.0427036
              ],
              [
                45.6843346,
                34.0543652
              ],
              [
                45.6690584,
                34.0696463
              ],
              [
                45.6668349,
                34.074096
              ],
              [
                45.6657248,
                34.0763074
              ],
              [
                45.6629449,
                34.0882578
              ],
              [
                45.6635011,
                34.1121492
              ],
              [
                45.6640581,
                34.1238105
              ],
              [
                45.663501,
                34.1257602
              ],
              [
                45.6632244,
                34.1279804
              ],
              [
                45.6598915,
                34.1429812
              ],
              [
                45.6598916,
                34.1457611
              ],
              [
                45.6596111,
                34.1490915
              ],
              [
                45.6593344,
                34.1496512
              ],
              [
                45.6587782,
                34.1607617
              ],
              [
                45.6590579,
                34.161592
              ],
              [
                45.6587781,
                34.1635416
              ],
              [
                45.6590578,
                34.1704822
              ],
              [
                45.6593344,
                34.1724226
              ],
              [
                45.6782244,
                34.2046527
              ],
              [
                45.6796143,
                34.2077032
              ],
              [
                45.6798909,
                34.207983
              ],
              [
                45.6801674,
                34.211873
              ],
              [
                45.6818338,
                34.2229832
              ],
              [
                45.6821142,
                34.2235428
              ],
              [
                45.6818338,
                34.2243731
              ],
              [
                45.6823908,
                34.2321529
              ],
              [
                45.6821143,
                34.2324327
              ],
              [
                45.6823908,
                34.233263
              ],
              [
                45.6821143,
                34.2335427
              ],
              [
                45.6818337,
                34.2357629
              ],
              [
                45.6815571,
                34.2377034
              ],
              [
                45.6812806,
                34.2399326
              ],
              [
                45.6812805,
                34.2402034
              ],
              [
                45.6718342,
                34.2668727
              ],
              [
                45.6712771,
                34.2699322
              ],
              [
                45.6712771,
                34.2718725
              ],
              [
                45.6710005,
                34.2721523
              ],
              [
                45.670724,
                34.273822
              ],
              [
                45.6704435,
                34.276322
              ],
              [
                45.6701669,
                34.2777118
              ],
              [
                45.6696107,
                34.2788219
              ],
              [
                45.6696107,
                34.2793724
              ],
              [
                45.6693341,
                34.2796521
              ],
              [
                45.6693341,
                34.2804915
              ],
              [
                45.669334,
                34.2813217
              ],
              [
                45.6693341,
                34.2816016
              ],
              [
                45.6690575,
                34.2818724
              ],
              [
                45.6690575,
                34.2885418
              ],
              [
                45.6698903,
                34.2921518
              ],
              [
                45.6701669,
                34.2927113
              ],
              [
                45.6704434,
                34.2941012
              ],
              [
                45.6704434,
                34.2974314
              ],
              [
                45.6701668,
                34.2979909
              ],
              [
                45.6698903,
                34.299101
              ],
              [
                45.6696106,
                34.2999312
              ],
              [
                45.6479436,
                34.3271501
              ],
              [
                45.6448873,
                34.3315993
              ],
              [
                45.6443341,
                34.3321499
              ],
              [
                45.6443341,
                34.3327094
              ],
              [
                45.6435004,
                34.3338195
              ],
              [
                45.6435004,
                34.334379
              ],
              [
                45.641834,
                34.3382686
              ],
              [
                45.639887,
                34.3435391
              ],
              [
                45.6396106,
                34.3438189
              ],
              [
                45.6376676,
                34.3485387
              ],
              [
                45.6371105,
                34.3507679
              ],
              [
                45.6407207,
                34.3585471
              ],
              [
                45.6446106,
                34.3604874
              ],
              [
                45.6460004,
                34.3604875
              ],
              [
                45.6476668,
                34.361047
              ],
              [
                45.6485005,
                34.361047
              ],
              [
                45.6490536,
                34.3607672
              ],
              [
                45.6515536,
                34.3607672
              ],
              [
                45.6521107,
                34.3604874
              ],
              [
                45.6532241,
                34.3604874
              ],
              [
                45.6537772,
                34.3602077
              ],
              [
                45.65461,
                34.3602077
              ],
              [
                45.6551671,
                34.3599279
              ],
              [
                45.6565569,
                34.3599279
              ],
              [
                45.659057,
                34.3593774
              ],
              [
                45.6596101,
                34.3590977
              ],
              [
                45.6621102,
                34.3590977
              ],
              [
                45.6668336,
                34.3579876
              ],
              [
                45.6779464,
                34.3579877
              ],
              [
                45.6785003,
                34.3582674
              ],
              [
                45.6862801,
                34.3582675
              ],
              [
                45.6868332,
                34.3579877
              ],
              [
                45.6951701,
                34.3579877
              ],
              [
                45.696003,
                34.3582675
              ],
              [
                45.6985031,
                34.3582675
              ],
              [
                45.6987796,
                34.3585473
              ],
              [
                45.7029462,
                34.3585473
              ],
              [
                45.7054462,
                34.358818
              ],
              [
                45.70739,
                34.3593776
              ],
              [
                45.7112799,
                34.3596483
              ],
              [
                45.7121127,
                34.3599281
              ],
              [
                45.713226,
                34.3599281
              ],
              [
                45.7137799,
                34.3602078
              ],
              [
                45.7154463,
                34.3602079
              ],
              [
                45.7218364,
                34.3613179
              ],
              [
                45.7221129,
                34.3615978
              ],
              [
                45.7287826,
                34.3615977
              ],
              [
                45.7296162,
                34.3618774
              ],
              [
                45.7385023,
                34.3618775
              ],
              [
                45.7393358,
                34.3615978
              ],
              [
                45.7454493,
                34.3615978
              ],
              [
                45.7465595,
                34.3613179
              ],
              [
                45.7473923,
                34.3615978
              ],
              [
                45.7504494,
                34.3615978
              ],
              [
                45.750726,
                34.3618775
              ],
              [
                45.7518393,
                34.3618775
              ],
              [
                45.7526721,
                34.3621573
              ],
              [
                45.7537823,
                34.3621573
              ],
              [
                45.7546159,
                34.3624371
              ],
              [
                45.756559,
                34.362437
              ],
              [
                45.7643388,
                34.3654874
              ],
              [
                45.7654489,
                34.366047
              ],
              [
                45.7671153,
                34.3668772
              ],
              [
                45.7782288,
                34.3765967
              ],
              [
                45.7896188,
                34.3938155
              ],
              [
                45.790172,
                34.3940952
              ],
              [
                45.7921189,
                34.396604
              ],
              [
                45.7923954,
                34.3971544
              ],
              [
                45.7927329,
                34.3974953
              ],
              [
                45.7921189,
                34.3990948
              ],
              [
                45.7607252,
                34.4232708
              ],
              [
                45.7596157,
                34.4241011
              ],
              [
                45.7407254,
                34.4399296
              ],
              [
                45.7382254,
                34.4435482
              ],
              [
                45.744059,
                34.4485476
              ],
              [
                45.7451685,
                34.4485477
              ],
              [
                45.7465591,
                34.4490981
              ],
              [
                45.7487819,
                34.4493779
              ],
              [
                45.7490584,
                34.4493779
              ],
              [
                45.7498921,
                34.4496576
              ],
              [
                45.7507256,
                34.4496577
              ],
              [
                45.7512818,
                34.4499374
              ],
              [
                45.752392,
                34.4499374
              ],
              [
                45.7526718,
                34.4502172
              ],
              [
                45.7546155,
                34.4502171
              ],
              [
                45.756282,
                34.4504878
              ],
              [
                45.7565586,
                34.4507676
              ],
              [
                45.7576718,
                34.4507677
              ],
              [
                45.7710049,
                34.4549368
              ],
              [
                45.7718385,
                34.4549368
              ],
              [
                45.7857286,
                34.4649355
              ],
              [
                45.7882278,
                34.4682745
              ],
              [
                45.7882278,
                34.4685452
              ],
              [
                45.7890614,
                34.4796538
              ],
              [
                45.7887848,
                34.4802132
              ],
              [
                45.7862848,
                34.4871617
              ],
              [
                45.7723945,
                34.4996597
              ],
              [
                45.7718382,
                34.4999394
              ],
              [
                45.7707281,
                34.5015998
              ],
              [
                45.7590583,
                34.5099379
              ],
              [
                45.7582247,
                34.5102085
              ],
              [
                45.7398923,
                34.5279854
              ],
              [
                45.736282,
                34.5329934
              ],
              [
                45.7354483,
                34.5346538
              ],
              [
                45.7348858,
                34.5354961
              ],
              [
                45.7350747,
                34.5371395
              ],
              [
                45.7353459,
                34.5383048
              ],
              [
                45.7343163,
                34.5383247
              ],
              [
                45.7333639,
                34.5386801
              ],
              [
                45.7328204,
                34.5387085
              ],
              [
                45.7323073,
                34.5385263
              ],
              [
                45.7321071,
                34.538174
              ],
              [
                45.7323856,
                34.5368448
              ],
              [
                45.7322943,
                34.5365251
              ],
              [
                45.7320281,
                34.5362182
              ],
              [
                45.7314194,
                34.5359897
              ],
              [
                45.730986,
                34.536032
              ],
              [
                45.7304288,
                34.5365763
              ],
              [
                45.7298303,
                34.5369666
              ],
              [
                45.7286656,
                34.5374361
              ],
              [
                45.7277437,
                34.5375839
              ],
              [
                45.7272402,
                34.5377779
              ],
              [
                45.7266772,
                34.5378974
              ],
              [
                45.7255415,
                34.5376321
              ],
              [
                45.7251787,
                34.5371937
              ],
              [
                45.7243827,
                34.537125
              ],
              [
                45.7242213,
                34.5372235
              ],
              [
                45.7243052,
                34.5375501
              ],
              [
                45.7239732,
                34.5385247
              ],
              [
                45.7236689,
                34.5386284
              ],
              [
                45.7234353,
                34.538493
              ],
              [
                45.7231442,
                34.538493
              ],
              [
                45.7228471,
                34.5385826
              ],
              [
                45.7224373,
                34.5392113
              ],
              [
                45.7219062,
                34.5395655
              ],
              [
                45.7214026,
                34.5397655
              ],
              [
                45.7211249,
                34.5395875
              ],
              [
                45.7210407,
                34.5390674
              ],
              [
                45.7206826,
                34.5383334
              ],
              [
                45.7201771,
                34.5379233
              ],
              [
                45.7191265,
                34.5379626
              ],
              [
                45.717977,
                34.5378626
              ],
              [
                45.717439,
                34.5379857
              ],
              [
                45.7173479,
                34.5382055
              ],
              [
                45.7176524,
                34.5386042
              ],
              [
                45.7178173,
                34.5390117
              ],
              [
                45.7180615,
                34.5394904
              ],
              [
                45.7179421,
                34.5399215
              ],
              [
                45.7172251,
                34.5401548
              ],
              [
                45.7164075,
                34.5399729
              ],
              [
                45.7154265,
                34.5402336
              ],
              [
                45.7141487,
                34.5409623
              ],
              [
                45.7138896,
                34.5409869
              ],
              [
                45.7130535,
                34.5404319
              ],
              [
                45.7127489,
                34.540489
              ],
              [
                45.712347,
                34.5408325
              ],
              [
                45.7122792,
                34.5411862
              ],
              [
                45.7124035,
                34.5416471
              ],
              [
                45.712913,
                34.5422293
              ],
              [
                45.7129311,
                34.5426398
              ],
              [
                45.7126801,
                34.5428705
              ],
              [
                45.7112035,
                34.5429189
              ],
              [
                45.7108098,
                34.5428231
              ],
              [
                45.7105053,
                34.5424639
              ],
              [
                45.7101654,
                34.5423414
              ],
              [
                45.7095065,
                34.5426595
              ],
              [
                45.7090166,
                34.5435316
              ],
              [
                45.7090091,
                34.5438887
              ],
              [
                45.7092398,
                34.544142
              ],
              [
                45.7099924,
                34.5440839
              ],
              [
                45.7106679,
                34.5441825
              ],
              [
                45.7113071,
                34.544709
              ],
              [
                45.7115886,
                34.5454187
              ],
              [
                45.7114369,
                34.5458014
              ],
              [
                45.7110988,
                34.5458341
              ],
              [
                45.710571,
                34.545687
              ],
              [
                45.7096785,
                34.5458183
              ],
              [
                45.7088634,
                34.5459913
              ],
              [
                45.707879,
                34.5455552
              ],
              [
                45.7072125,
                34.5454605
              ],
              [
                45.7065829,
                34.5458754
              ],
              [
                45.7061685,
                34.5461053
              ],
              [
                45.7057069,
                34.5461711
              ],
              [
                45.7051208,
                34.5459332
              ],
              [
                45.7047217,
                34.5459197
              ],
              [
                45.7043702,
                34.5457813
              ],
              [
                45.7041461,
                34.5459062
              ],
              [
                45.7039442,
                34.5463794
              ],
              [
                45.7038568,
                34.5468898
              ],
              [
                45.7039717,
                34.5476603
              ],
              [
                45.703625,
                34.5485607
              ],
              [
                45.7022671,
                34.5487635
              ],
              [
                45.7004422,
                34.5475052
              ],
              [
                45.6986244,
                34.5487834
              ],
              [
                45.699807,
                34.5500806
              ],
              [
                45.6996863,
                34.5510584
              ],
              [
                45.698138,
                34.5510927
              ],
              [
                45.6963779,
                34.5507303
              ],
              [
                45.695761,
                34.5516077
              ],
              [
                45.6952435,
                34.5530734
              ],
              [
                45.6936972,
                34.5536396
              ],
              [
                45.6930309,
                34.5553035
              ],
              [
                45.6919256,
                34.5556208
              ],
              [
                45.6907058,
                34.5554687
              ],
              [
                45.6905467,
                34.5548885
              ],
              [
                45.690065,
                34.5540712
              ],
              [
                45.6892219,
                34.5544905
              ],
              [
                45.688314,
                34.5553067
              ],
              [
                45.6875762,
                34.5577667
              ],
              [
                45.6867666,
                34.5576097
              ],
              [
                45.6855937,
                34.5569901
              ],
              [
                45.6851885,
                34.5553066
              ],
              [
                45.6840868,
                34.5554038
              ],
              [
                45.6837179,
                34.5559185
              ],
              [
                45.684416,
                34.557639
              ],
              [
                45.6842883,
                34.5589611
              ],
              [
                45.6834717,
                34.5595769
              ],
              [
                45.6823506,
                34.5596119
              ],
              [
                45.6815102,
                34.5580565
              ],
              [
                45.6805563,
                34.5557869
              ],
              [
                45.6794479,
                34.5555679
              ],
              [
                45.6774207,
                34.5566574
              ],
              [
                45.6761859,
                34.5567683
              ],
              [
                45.6756651,
                34.5562535
              ],
              [
                45.6748715,
                34.5555581
              ],
              [
                45.6740335,
                34.5543865
              ],
              [
                45.67423,
                34.5536803
              ],
              [
                45.6736179,
                34.5529914
              ],
              [
                45.6705671,
                34.5520556
              ],
              [
                45.6680598,
                34.5539436
              ],
              [
                45.666198,
                34.5537395
              ],
              [
                45.6653199,
                34.5527091
              ],
              [
                45.665688,
                34.5515963
              ],
              [
                45.664375,
                34.5503217
              ],
              [
                45.6636097,
                34.5513031
              ],
              [
                45.66226,
                34.5522206
              ],
              [
                45.6609211,
                34.554262
              ],
              [
                45.6597047,
                34.5547528
              ],
              [
                45.657542,
                34.5544739
              ],
              [
                45.6558199,
                34.5556087
              ],
              [
                45.6546552,
                34.5551674
              ],
              [
                45.6550982,
                34.5535386
              ],
              [
                45.6535262,
                34.5532732
              ],
              [
                45.6524696,
                34.5546524
              ],
              [
                45.652774,
                34.5557091
              ],
              [
                45.6519474,
                34.5562007
              ],
              [
                45.6509342,
                34.5561619
              ],
              [
                45.6509072,
                34.5553487
              ],
              [
                45.6504663,
                34.5547676
              ],
              [
                45.6512297,
                34.5536216
              ],
              [
                45.6510563,
                34.5527646
              ],
              [
                45.650118,
                34.5531428
              ],
              [
                45.6486595,
                34.553124
              ],
              [
                45.6486368,
                34.5523022
              ],
              [
                45.647851,
                34.5508817
              ],
              [
                45.645982,
                34.5514907
              ],
              [
                45.6454071,
                34.5522124
              ],
              [
                45.6420566,
                34.5533341
              ],
              [
                45.6410926,
                34.5535475
              ],
              [
                45.6405311,
                34.5538345
              ],
              [
                45.6417839,
                34.5562305
              ],
              [
                45.6406887,
                34.5587559
              ],
              [
                45.6398941,
                34.5589125
              ],
              [
                45.639254,
                34.5579146
              ],
              [
                45.6395831,
                34.557025
              ],
              [
                45.6382128,
                34.5565326
              ],
              [
                45.6365871,
                34.5561848
              ],
              [
                45.6357365,
                34.5564363
              ],
              [
                45.6352733,
                34.5577808
              ],
              [
                45.6337133,
                34.5590105
              ],
              [
                45.6327033,
                34.5583677
              ],
              [
                45.6320862,
                34.5567482
              ],
              [
                45.6326708,
                34.5542848
              ],
              [
                45.6322472,
                34.5520519
              ],
              [
                45.6311593,
                34.5511732
              ],
              [
                45.6295913,
                34.5507107
              ],
              [
                45.6292485,
                34.5497965
              ],
              [
                45.6276892,
                34.5488034
              ],
              [
                45.6262052,
                34.5493058
              ],
              [
                45.626222,
                34.5505837
              ],
              [
                45.6254844,
                34.5531871
              ],
              [
                45.6246502,
                34.5533796
              ],
              [
                45.6227966,
                34.5507319
              ],
              [
                45.6184235,
                34.5502564
              ],
              [
                45.6162405,
                34.5517052
              ],
              [
                45.6152564,
                34.5519318
              ],
              [
                45.6146702,
                34.55141
              ],
              [
                45.6132364,
                34.5510586
              ],
              [
                45.6093555,
                34.5509068
              ],
              [
                45.607493,
                34.5486058
              ],
              [
                45.6000944,
                34.5518117
              ],
              [
                45.5976611,
                34.5495531
              ],
              [
                45.594687,
                34.5498888
              ],
              [
                45.5942279,
                34.5528078
              ],
              [
                45.5953848,
                34.5536852
              ],
              [
                45.5949585,
                34.5547326
              ],
              [
                45.5941011,
                34.5554192
              ],
              [
                45.5937703,
                34.5554888
              ],
              [
                45.5930173,
                34.5556471
              ],
              [
                45.5921144,
                34.5556113
              ],
              [
                45.5915347,
                34.5555952
              ],
              [
                45.5911309,
                34.5556033
              ],
              [
                45.5907759,
                34.5556489
              ],
              [
                45.5906248,
                34.5556993
              ],
              [
                45.5904796,
                34.5558018
              ],
              [
                45.5896967,
                34.5565777
              ],
              [
                45.5895583,
                34.5573373
              ],
              [
                45.5890049,
                34.5577884
              ],
              [
                45.5887616,
                34.5587258
              ],
              [
                45.5878749,
                34.5586335
              ],
              [
                45.5877366,
                34.5584008
              ],
              [
                45.5847833,
                34.5568105
              ],
              [
                45.581821,
                34.5577919
              ],
              [
                45.5816794,
                34.5591738
              ],
              [
                45.5804821,
                34.5596686
              ],
              [
                45.5790787,
                34.5577283
              ],
              [
                45.5771432,
                34.5587497
              ],
              [
                45.5763397,
                34.5611986
              ],
              [
                45.5744696,
                34.5621214
              ],
              [
                45.5752635,
                34.5653939
              ],
              [
                45.5735598,
                34.5657402
              ],
              [
                45.5718046,
                34.5628847
              ],
              [
                45.5658393,
                34.5658816
              ],
              [
                45.5665174,
                34.5702177
              ],
              [
                45.565501,
                34.5733499
              ],
              [
                45.5626164,
                34.57461
              ],
              [
                45.5597454,
                34.5738432
              ],
              [
                45.5581575,
                34.5762143
              ],
              [
                45.5604191,
                34.5793838
              ],
              [
                45.5558014,
                34.5799633
              ],
              [
                45.5545397,
                34.5823836
              ],
              [
                45.5587111,
                34.5833976
              ],
              [
                45.5539475,
                34.5887362
              ],
              [
                45.5569129,
                34.5901599
              ],
              [
                45.5562134,
                34.5924457
              ],
              [
                45.5539775,
                34.5916862
              ],
              [
                45.551364,
                34.593442
              ],
              [
                45.5467776,
                34.5940018
              ],
              [
                45.5432429,
                34.5966241
              ],
              [
                45.5403847,
                34.5949532
              ],
              [
                45.5372647,
                34.5921481
              ],
              [
                45.5338101,
                34.5937874
              ],
              [
                45.5347113,
                34.5965181
              ],
              [
                45.5371617,
                34.5984293
              ],
              [
                45.5375265,
                34.6005488
              ],
              [
                45.5352821,
                34.6023115
              ],
              [
                45.5314626,
                34.6018982
              ],
              [
                45.531175,
                34.60147
              ],
              [
                45.530931,
                34.601323
              ],
              [
                45.530469,
                34.601127
              ],
              [
                45.530239,
                34.600863
              ],
              [
                45.52989,
                34.600833
              ],
              [
                45.529725,
                34.600486
              ],
              [
                45.529817,
                34.600299
              ],
              [
                45.529646,
                34.600158
              ],
              [
                45.529644,
                34.600086
              ],
              [
                45.52957,
                34.600012
              ],
              [
                45.529269,
                34.600019
              ],
              [
                45.529074,
                34.599875
              ],
              [
                45.529041,
                34.599702
              ],
              [
                45.529097,
                34.599559
              ],
              [
                45.528963,
                34.599336
              ],
              [
                45.529045,
                34.599253
              ],
              [
                45.52904,
                34.59917
              ],
              [
                45.528934,
                34.598946
              ],
              [
                45.528836,
                34.598902
              ],
              [
                45.528922,
                34.598667
              ],
              [
                45.528872,
                34.5986
              ],
              [
                45.528666,
                34.59856
              ],
              [
                45.528643,
                34.598446
              ],
              [
                45.528675,
                34.598341
              ],
              [
                45.529194,
                34.59825
              ],
              [
                45.529139,
                34.598161
              ],
              [
                45.529166,
                34.5981
              ],
              [
                45.529315,
                34.598089
              ],
              [
                45.52956,
                34.598175
              ],
              [
                45.529833,
                34.598077
              ],
              [
                45.529972,
                34.59784
              ],
              [
                45.530131,
                34.597763
              ],
              [
                45.53076,
                34.597022
              ],
              [
                45.530463,
                34.596584
              ],
              [
                45.530611,
                34.595935
              ],
              [
                45.530473,
                34.59578
              ],
              [
                45.53041,
                34.595404
              ],
              [
                45.530426,
                34.595321
              ],
              [
                45.530711,
                34.595355
              ],
              [
                45.530791,
                34.595329
              ],
              [
                45.530752,
                34.595028
              ],
              [
                45.530821,
                34.594895
              ],
              [
                45.530979,
                34.594795
              ],
              [
                45.530893,
                34.59465
              ],
              [
                45.530558,
                34.594629
              ],
              [
                45.530537,
                34.594485
              ],
              [
                45.530546,
                34.594248
              ],
              [
                45.530667,
                34.593957
              ],
              [
                45.530782,
                34.593857
              ],
              [
                45.530896,
                34.593837
              ],
              [
                45.530943,
                34.593767
              ],
              [
                45.530653,
                34.593439
              ],
              [
                45.530636,
                34.593289
              ],
              [
                45.530898,
                34.593042
              ],
              [
                45.530882,
                34.592958
              ],
              [
                45.530689,
                34.59282
              ],
              [
                45.530676,
                34.592705
              ],
              [
                45.531059,
                34.592402
              ],
              [
                45.531026,
                34.592146
              ],
              [
                45.531062,
                34.59201
              ],
              [
                45.531375,
                34.591773
              ],
              [
                45.531174,
                34.591645
              ],
              [
                45.531,
                34.591603
              ],
              [
                45.530965,
                34.591507
              ],
              [
                45.531067,
                34.591379
              ],
              [
                45.531269,
                34.591279
              ],
              [
                45.531342,
                34.591118
              ],
              [
                45.531409,
                34.590874
              ],
              [
                45.531381,
                34.59072
              ],
              [
                45.531465,
                34.590142
              ],
              [
                45.531568,
                34.589972
              ],
              [
                45.531499,
                34.589768
              ],
              [
                45.531314,
                34.589679
              ],
              [
                45.531294,
                34.58958
              ],
              [
                45.531543,
                34.58941
              ],
              [
                45.531486,
                34.589231
              ],
              [
                45.531521,
                34.589156
              ],
              [
                45.531765,
                34.58909
              ],
              [
                45.531696,
                34.58895
              ],
              [
                45.531142,
                34.588862
              ],
              [
                45.531282,
                34.588602
              ],
              [
                45.531432,
                34.588556
              ],
              [
                45.531814,
                34.588584
              ],
              [
                45.532093,
                34.588425
              ],
              [
                45.532108,
                34.588339
              ],
              [
                45.532007,
                34.58828
              ],
              [
                45.531481,
                34.588198
              ],
              [
                45.531099,
                34.587425
              ],
              [
                45.530974,
                34.586919
              ],
              [
                45.530923,
                34.586867
              ],
              [
                45.530239,
                34.586798
              ],
              [
                45.530081,
                34.586689
              ],
              [
                45.530061,
                34.586612
              ],
              [
                45.530134,
                34.586474
              ],
              [
                45.530372,
                34.586303
              ],
              [
                45.530356,
                34.586219
              ],
              [
                45.530191,
                34.586084
              ],
              [
                45.53028,
                34.585776
              ],
              [
                45.530118,
                34.585611
              ],
              [
                45.529376,
                34.585125
              ],
              [
                45.529278,
                34.584747
              ],
              [
                45.528715,
                34.584516
              ],
              [
                45.52863,
                34.584417
              ],
              [
                45.52863,
                34.584037
              ],
              [
                45.528429,
                34.583673
              ],
              [
                45.52857,
                34.583443
              ],
              [
                45.528531,
                34.583355
              ],
              [
                45.528359,
                34.583298
              ],
              [
                45.528346,
                34.583141
              ],
              [
                45.528467,
                34.582872
              ],
              [
                45.528411,
                34.582783
              ],
              [
                45.528026,
                34.582802
              ],
              [
                45.527872,
                34.582897
              ],
              [
                45.527888,
                34.583111
              ],
              [
                45.52777,
                34.583177
              ],
              [
                45.527586,
                34.583202
              ],
              [
                45.527428,
                34.582755
              ],
              [
                45.52761,
                34.582533
              ],
              [
                45.52761,
                34.582385
              ],
              [
                45.527353,
                34.582122
              ],
              [
                45.527177,
                34.58148
              ],
              [
                45.527153,
                34.58126
              ],
              [
                45.527297,
                34.581125
              ],
              [
                45.527232,
                34.581019
              ],
              [
                45.527054,
                34.580894
              ],
              [
                45.526883,
                34.580863
              ],
              [
                45.526802,
                34.580505
              ],
              [
                45.527271,
                34.580472
              ],
              [
                45.527514,
                34.580578
              ],
              [
                45.527669,
                34.580524
              ],
              [
                45.527775,
                34.580327
              ],
              [
                45.527769,
                34.580176
              ],
              [
                45.52732,
                34.579905
              ],
              [
                45.527121,
                34.57972
              ],
              [
                45.527099,
                34.579401
              ],
              [
                45.527003,
                34.57922
              ],
              [
                45.526749,
                34.579033
              ],
              [
                45.526532,
                34.578733
              ],
              [
                45.526523,
                34.578214
              ],
              [
                45.52639,
                34.578161
              ],
              [
                45.525973,
                34.578246
              ],
              [
                45.525851,
                34.57813
              ],
              [
                45.525364,
                34.577923
              ],
              [
                45.525179,
                34.577751
              ],
              [
                45.524626,
                34.577517
              ],
              [
                45.524313,
                34.577185
              ],
              [
                45.52421,
                34.577229
              ],
              [
                45.524127,
                34.577453
              ],
              [
                45.524136,
                34.577527
              ],
              [
                45.524348,
                34.577699
              ],
              [
                45.524326,
                34.577806
              ],
              [
                45.524091,
                34.577862
              ],
              [
                45.523983,
                34.577797
              ],
              [
                45.523882,
                34.57745
              ],
              [
                45.523779,
                34.577343
              ],
              [
                45.523698,
                34.577091
              ],
              [
                45.523511,
                34.576828
              ],
              [
                45.523202,
                34.576487
              ],
              [
                45.522937,
                34.576427
              ],
              [
                45.522834,
                34.576324
              ],
              [
                45.522891,
                34.575995
              ],
              [
                45.522951,
                34.575912
              ],
              [
                45.52289,
                34.575611
              ],
              [
                45.52292,
                34.575454
              ],
              [
                45.523009,
                34.575316
              ],
              [
                45.5231,
                34.575266
              ],
              [
                45.523098,
                34.575153
              ],
              [
                45.522847,
                34.57479
              ],
              [
                45.52281,
                34.574626
              ],
              [
                45.522888,
                34.574422
              ],
              [
                45.523027,
                34.574329
              ],
              [
                45.523172,
                34.574323
              ],
              [
                45.523338,
                34.574423
              ],
              [
                45.523554,
                34.574438
              ],
              [
                45.523745,
                34.574423
              ],
              [
                45.52378,
                34.574368
              ],
              [
                45.523731,
                34.574285
              ],
              [
                45.523583,
                34.574194
              ],
              [
                45.523142,
                34.574039
              ],
              [
                45.523061,
                34.573784
              ],
              [
                45.523084,
                34.573495
              ],
              [
                45.522775,
                34.57337
              ],
              [
                45.522642,
                34.573147
              ],
              [
                45.522492,
                34.573025
              ],
              [
                45.522554,
                34.572908
              ],
              [
                45.52272,
                34.572837
              ],
              [
                45.522872,
                34.572837
              ],
              [
                45.523021,
                34.572909
              ],
              [
                45.523152,
                34.573042
              ],
              [
                45.523599,
                34.573116
              ],
              [
                45.523722,
                34.573067
              ],
              [
                45.523701,
                34.572965
              ],
              [
                45.523561,
                34.572841
              ],
              [
                45.523395,
                34.572783
              ],
              [
                45.523409,
                34.572606
              ],
              [
                45.523324,
                34.57228
              ],
              [
                45.52334,
                34.572177
              ],
              [
                45.523474,
                34.571988
              ],
              [
                45.523395,
                34.571912
              ],
              [
                45.523264,
                34.571905
              ],
              [
                45.522847,
                34.572059
              ],
              [
                45.522703,
                34.572022
              ],
              [
                45.522646,
                34.571924
              ],
              [
                45.522318,
                34.571839
              ],
              [
                45.522235,
                34.571749
              ],
              [
                45.522193,
                34.571401
              ],
              [
                45.521986,
                34.571368
              ],
              [
                45.521945,
                34.571274
              ],
              [
                45.522033,
                34.570807
              ],
              [
                45.522148,
                34.57069
              ],
              [
                45.522383,
                34.570583
              ],
              [
                45.522639,
                34.570368
              ],
              [
                45.523013,
                34.570503
              ],
              [
                45.523141,
                34.570419
              ],
              [
                45.52302,
                34.570158
              ],
              [
                45.522962,
                34.569852
              ],
              [
                45.522842,
                34.569679
              ],
              [
                45.522881,
                34.569541
              ],
              [
                45.522988,
                34.569437
              ],
              [
                45.523271,
                34.569388
              ],
              [
                45.52332,
                34.569309
              ],
              [
                45.523283,
                34.569185
              ],
              [
                45.523138,
                34.569063
              ],
              [
                45.52302,
                34.568999
              ],
              [
                45.522859,
                34.568981
              ],
              [
                45.522832,
                34.56892
              ],
              [
                45.522998,
                34.568833
              ],
              [
                45.523023,
                34.568682
              ],
              [
                45.522645,
                34.568489
              ],
              [
                45.522555,
                34.56837
              ],
              [
                45.522559,
                34.568056
              ],
              [
                45.522407,
                34.567696
              ],
              [
                45.522306,
                34.567617
              ],
              [
                45.522304,
                34.567529
              ],
              [
                45.522679,
                34.567316
              ],
              [
                45.522858,
                34.566972
              ],
              [
                45.52314,
                34.566961
              ],
              [
                45.523266,
                34.566908
              ],
              [
                45.523355,
                34.566776
              ],
              [
                45.523553,
                34.566691
              ],
              [
                45.523635,
                34.566572
              ],
              [
                45.523807,
                34.56597
              ],
              [
                45.523756,
                34.565921
              ],
              [
                45.523655,
                34.565943
              ],
              [
                45.523401,
                34.566061
              ],
              [
                45.52323,
                34.565944
              ],
              [
                45.522843,
                34.565819
              ],
              [
                45.522848,
                34.565733
              ],
              [
                45.523488,
                34.565053
              ],
              [
                45.523508,
                34.564925
              ],
              [
                45.523238,
                34.56442
              ],
              [
                45.523366,
                34.564212
              ],
              [
                45.52302,
                34.564018
              ],
              [
                45.522958,
                34.563901
              ],
              [
                45.522966,
                34.563768
              ],
              [
                45.523053,
                34.563668
              ],
              [
                45.523036,
                34.563563
              ],
              [
                45.52269,
                34.563059
              ],
              [
                45.522351,
                34.562933
              ],
              [
                45.522309,
                34.562771
              ],
              [
                45.5223131,
                34.5626304
              ],
              [
                45.522329,
                34.562083
              ],
              [
                45.522407,
                34.561907
              ],
              [
                45.522415,
                34.561647
              ],
              [
                45.522521,
                34.561578
              ],
              [
                45.522951,
                34.561541
              ],
              [
                45.523015,
                34.561352
              ],
              [
                45.5232,
                34.56132
              ],
              [
                45.523347,
                34.560935
              ],
              [
                45.523236,
                34.56061
              ],
              [
                45.523252,
                34.560422
              ],
              [
                45.523187,
                34.560337
              ],
              [
                45.522875,
                34.560191
              ],
              [
                45.522816,
                34.56005
              ],
              [
                45.522446,
                34.559845
              ],
              [
                45.522345,
                34.559519
              ],
              [
                45.521856,
                34.559454
              ],
              [
                45.521755,
                34.559232
              ],
              [
                45.521674,
                34.559169
              ],
              [
                45.521562,
                34.559131
              ],
              [
                45.521192,
                34.559153
              ],
              [
                45.521078,
                34.559107
              ],
              [
                45.520845,
                34.559102
              ],
              [
                45.520705,
                34.558914
              ],
              [
                45.520418,
                34.558864
              ],
              [
                45.520368,
                34.558795
              ],
              [
                45.52046,
                34.558547
              ],
              [
                45.520452,
                34.558413
              ],
              [
                45.520183,
                34.55792
              ],
              [
                45.520049,
                34.557835
              ],
              [
                45.519757,
                34.557747
              ],
              [
                45.519336,
                34.55774
              ],
              [
                45.5189,
                34.557283
              ],
              [
                45.518705,
                34.557176
              ],
              [
                45.518606,
                34.557064
              ],
              [
                45.518417,
                34.556647
              ],
              [
                45.518308,
                34.55658
              ],
              [
                45.5179521,
                34.5564772
              ],
              [
                45.517602,
                34.556376
              ],
              [
                45.517531,
                34.556299
              ],
              [
                45.517516,
                34.556183
              ],
              [
                45.517403,
                34.556117
              ],
              [
                45.516999,
                34.556074
              ],
              [
                45.51692,
                34.555872
              ],
              [
                45.516452,
                34.555695
              ],
              [
                45.51633,
                34.555517
              ],
              [
                45.516274,
                34.555307
              ],
              [
                45.516166,
                34.555288
              ],
              [
                45.515959,
                34.555378
              ],
              [
                45.51551,
                34.555155
              ],
              [
                45.51535,
                34.555121
              ],
              [
                45.515237,
                34.554963
              ],
              [
                45.515024,
                34.554849
              ],
              [
                45.514997,
                34.554771
              ],
              [
                45.515069,
                34.554578
              ],
              [
                45.515019,
                34.554485
              ],
              [
                45.515102,
                34.554347
              ],
              [
                45.515092,
                34.554231
              ],
              [
                45.515253,
                34.55413
              ],
              [
                45.515277,
                34.554061
              ],
              [
                45.515135,
                34.553977
              ],
              [
                45.515041,
                34.553794
              ],
              [
                45.514952,
                34.553746
              ],
              [
                45.514772,
                34.553284
              ],
              [
                45.514668,
                34.553234
              ],
              [
                45.514372,
                34.552897
              ],
              [
                45.51411,
                34.552734
              ],
              [
                45.513874,
                34.55265
              ],
              [
                45.51377,
                34.552469
              ],
              [
                45.513516,
                34.55241
              ],
              [
                45.513377,
                34.552317
              ],
              [
                45.513154,
                34.552065
              ],
              [
                45.51199,
                34.551635
              ],
              [
                45.512834,
                34.551049
              ],
              [
                45.513001,
                34.550999
              ],
              [
                45.513608,
                34.551044
              ],
              [
                45.513728,
                34.551005
              ],
              [
                45.513903,
                34.55081
              ],
              [
                45.514411,
                34.550473
              ],
              [
                45.515108,
                34.550182
              ],
              [
                45.514243,
                34.54943
              ],
              [
                45.513989,
                34.549123
              ],
              [
                45.513945,
                34.548807
              ],
              [
                45.51399,
                34.548131
              ],
              [
                45.513584,
                34.547218
              ],
              [
                45.513572,
                34.546868
              ],
              [
                45.513627,
                34.546533
              ],
              [
                45.513721,
                34.546333
              ],
              [
                45.514646,
                34.545727
              ],
              [
                45.51559,
                34.545349
              ],
              [
                45.516067,
                34.544686
              ],
              [
                45.516585,
                34.544481
              ],
              [
                45.517149,
                34.544057
              ],
              [
                45.517429,
                34.543918
              ],
              [
                45.517623,
                34.543742
              ],
              [
                45.518587,
                34.543635
              ],
              [
                45.518939,
                34.543438
              ],
              [
                45.519272,
                34.54336
              ],
              [
                45.519635,
                34.543191
              ],
              [
                45.520067,
                34.543068
              ],
              [
                45.520303,
                34.542952
              ],
              [
                45.520447,
                34.542662
              ],
              [
                45.520641,
                34.542443
              ],
              [
                45.521183,
                34.5422271
              ],
              [
                45.5212578,
                34.5421776
              ],
              [
                45.5213305,
                34.5420766
              ],
              [
                45.5213328,
                34.54189
              ],
              [
                45.5212209,
                34.5415553
              ],
              [
                45.52119,
                34.5412979
              ],
              [
                45.5212,
                34.541223
              ],
              [
                45.521658,
                34.540588
              ],
              [
                45.521855,
                34.540447
              ],
              [
                45.522573,
                34.540119
              ],
              [
                45.5226295,
                34.5400012
              ],
              [
                45.5226935,
                34.539973
              ],
              [
                45.5227114,
                34.539578
              ],
              [
                45.5227254,
                34.5394699
              ],
              [
                45.522866,
                34.539177
              ],
              [
                45.522888,
                34.538895
              ],
              [
                45.522976,
                34.538617
              ],
              [
                45.52314,
                34.538376
              ],
              [
                45.523218,
                34.538096
              ],
              [
                45.523031,
                34.537465
              ],
              [
                45.523057,
                34.537109
              ],
              [
                45.522996,
                34.536987
              ],
              [
                45.522773,
                34.536823
              ],
              [
                45.522461,
                34.53648
              ],
              [
                45.522504,
                34.536226
              ],
              [
                45.522788,
                34.535851
              ],
              [
                45.522852,
                34.535602
              ],
              [
                45.523079,
                34.535261
              ],
              [
                45.523107,
                34.535096
              ],
              [
                45.523273,
                34.534816
              ],
              [
                45.523506,
                34.534548
              ],
              [
                45.523952,
                34.534332
              ],
              [
                45.52413,
                34.534085
              ],
              [
                45.524117,
                34.533617
              ],
              [
                45.524498,
                34.53301
              ],
              [
                45.524255,
                34.532596
              ],
              [
                45.524291,
                34.532469
              ],
              [
                45.524489,
                34.532246
              ],
              [
                45.524775,
                34.531787
              ],
              [
                45.525025,
                34.531604
              ],
              [
                45.525536,
                34.531566
              ],
              [
                45.525938,
                34.531352
              ],
              [
                45.526642,
                34.530573
              ],
              [
                45.526665,
                34.529909
              ],
              [
                45.526766,
                34.529538
              ],
              [
                45.526666,
                34.529078
              ],
              [
                45.526975,
                34.528433
              ],
              [
                45.527084,
                34.528052
              ],
              [
                45.526959,
                34.527343
              ],
              [
                45.526676,
                34.52704
              ],
              [
                45.526654,
                34.526869
              ],
              [
                45.526698,
                34.526462
              ],
              [
                45.526857,
                34.526196
              ],
              [
                45.5268547,
                34.5258138
              ],
              [
                45.526853,
                34.525518
              ],
              [
                45.527002,
                34.52507
              ],
              [
                45.52669,
                34.523957
              ],
              [
                45.526443,
                34.523749
              ],
              [
                45.526389,
                34.523548
              ],
              [
                45.526364,
                34.522981
              ],
              [
                45.526392,
                34.522812
              ],
              [
                45.526714,
                34.522231
              ],
              [
                45.52677,
                34.521966
              ],
              [
                45.526837,
                34.521548
              ],
              [
                45.526781,
                34.521247
              ],
              [
                45.526573,
                34.520676
              ],
              [
                45.526616,
                34.520487
              ],
              [
                45.52679,
                34.520202
              ],
              [
                45.526742,
                34.519934
              ],
              [
                45.526817,
                34.519623
              ],
              [
                45.527062,
                34.519388
              ],
              [
                45.527029,
                34.519193
              ],
              [
                45.527093,
                34.51894
              ],
              [
                45.527058,
                34.518715
              ],
              [
                45.527208,
                34.518293
              ],
              [
                45.527205,
                34.518163
              ],
              [
                45.527041,
                34.517999
              ],
              [
                45.52636,
                34.517591
              ],
              [
                45.526341,
                34.516711
              ],
              [
                45.526413,
                34.516431
              ],
              [
                45.526581,
                34.516185
              ],
              [
                45.526562,
                34.515918
              ],
              [
                45.526676,
                34.515736
              ],
              [
                45.526629,
                34.51516
              ],
              [
                45.526432,
                34.514683
              ],
              [
                45.526215,
                34.514483
              ],
              [
                45.526123,
                34.514288
              ],
              [
                45.525927,
                34.513524
              ],
              [
                45.525909,
                34.513213
              ],
              [
                45.525068,
                34.511732
              ],
              [
                45.525167,
                34.511552
              ],
              [
                45.525492,
                34.511232
              ],
              [
                45.525692,
                34.511129
              ],
              [
                45.525991,
                34.510669
              ],
              [
                45.526305,
                34.510072
              ],
              [
                45.52637,
                34.50985
              ],
              [
                45.526408,
                34.509322
              ],
              [
                45.526189,
                34.509153
              ],
              [
                45.52597,
                34.508897
              ],
              [
                45.525929,
                34.508664
              ],
              [
                45.526057,
                34.508232
              ],
              [
                45.526002,
                34.507483
              ],
              [
                45.526242,
                34.506905
              ],
              [
                45.52651,
                34.505757
              ],
              [
                45.526393,
                34.504947
              ],
              [
                45.525959,
                34.504543
              ],
              [
                45.525669,
                34.504367
              ],
              [
                45.525522,
                34.504188
              ],
              [
                45.525481,
                34.504024
              ],
              [
                45.525606,
                34.503871
              ],
              [
                45.525877,
                34.503689
              ],
              [
                45.525914,
                34.503384
              ],
              [
                45.526342,
                34.502836
              ],
              [
                45.526377,
                34.502631
              ],
              [
                45.526168,
                34.502012
              ],
              [
                45.526188,
                34.50147
              ],
              [
                45.526306,
                34.501218
              ],
              [
                45.526533,
                34.500925
              ],
              [
                45.526606,
                34.50074
              ],
              [
                45.526597,
                34.500585
              ],
              [
                45.52644,
                34.500272
              ],
              [
                45.526045,
                34.499819
              ],
              [
                45.525152,
                34.499228
              ],
              [
                45.525054,
                34.498781
              ],
              [
                45.525307,
                34.497788
              ],
              [
                45.525704,
                34.497074
              ],
              [
                45.525603,
                34.496858
              ],
              [
                45.525577,
                34.496653
              ],
              [
                45.525624,
                34.496211
              ],
              [
                45.525516,
                34.495961
              ],
              [
                45.525772,
                34.495485
              ],
              [
                45.525955,
                34.494898
              ],
              [
                45.525918,
                34.494725
              ],
              [
                45.525524,
                34.494163
              ],
              [
                45.525506,
                34.494013
              ],
              [
                45.525671,
                34.493707
              ],
              [
                45.525705,
                34.493163
              ],
              [
                45.525542,
                34.492799
              ],
              [
                45.52544,
                34.492692
              ],
              [
                45.525151,
                34.492589
              ],
              [
                45.524988,
                34.492451
              ],
              [
                45.524926,
                34.492303
              ],
              [
                45.524979,
                34.491983
              ],
              [
                45.524904,
                34.491458
              ],
              [
                45.524647,
                34.490977
              ],
              [
                45.52413,
                34.490328
              ],
              [
                45.524183,
                34.490025
              ],
              [
                45.523731,
                34.489267
              ],
              [
                45.523891,
                34.488983
              ],
              [
                45.523864,
                34.488791
              ],
              [
                45.523427,
                34.488005
              ],
              [
                45.52359,
                34.487646
              ],
              [
                45.523632,
                34.48734
              ],
              [
                45.523946,
                34.4869
              ],
              [
                45.52374,
                34.486564
              ],
              [
                45.523184,
                34.485102
              ],
              [
                45.522577,
                34.484649
              ],
              [
                45.522516,
                34.484505
              ],
              [
                45.522517,
                34.483466
              ],
              [
                45.522213,
                34.482569
              ],
              [
                45.521943,
                34.48219
              ],
              [
                45.52134,
                34.481827
              ],
              [
                45.521232,
                34.481716
              ],
              [
                45.521199,
                34.481586
              ],
              [
                45.521281,
                34.481261
              ],
              [
                45.521255,
                34.480982
              ],
              [
                45.521152,
                34.480871
              ],
              [
                45.520618,
                34.480664
              ],
              [
                45.520497,
                34.48022
              ],
              [
                45.52004,
                34.479958
              ],
              [
                45.519785,
                34.479873
              ],
              [
                45.519381,
                34.479539
              ],
              [
                45.519059,
                34.47951
              ],
              [
                45.518316,
                34.478863
              ],
              [
                45.517956,
                34.47841
              ],
              [
                45.518091,
                34.478034
              ],
              [
                45.51835,
                34.477545
              ],
              [
                45.518099,
                34.477076
              ],
              [
                45.517643,
                34.476749
              ],
              [
                45.517478,
                34.476398
              ],
              [
                45.517377,
                34.475978
              ],
              [
                45.517209,
                34.475705
              ],
              [
                45.516112,
                34.475157
              ],
              [
                45.515929,
                34.474678
              ],
              [
                45.515813,
                34.474512
              ],
              [
                45.515156,
                34.474257
              ],
              [
                45.514539,
                34.473736
              ],
              [
                45.514068,
                34.473568
              ],
              [
                45.513681,
                34.473649
              ],
              [
                45.513393,
                34.473594
              ],
              [
                45.513126,
                34.473458
              ],
              [
                45.512519,
                34.472526
              ],
              [
                45.511285,
                34.472301
              ],
              [
                45.510789,
                34.472059
              ],
              [
                45.510362,
                34.472006
              ],
              [
                45.509799,
                34.471999
              ],
              [
                45.509553,
                34.471825
              ],
              [
                45.50938,
                34.471484
              ],
              [
                45.50908,
                34.471283
              ],
              [
                45.508009,
                34.471305
              ],
              [
                45.507672,
                34.470935
              ],
              [
                45.507301,
                34.470866
              ],
              [
                45.506602,
                34.470966
              ],
              [
                45.505975,
                34.470759
              ],
              [
                45.50532,
                34.470608
              ],
              [
                45.504473,
                34.470616
              ],
              [
                45.504239,
                34.470536
              ],
              [
                45.50396,
                34.47075
              ],
              [
                45.50359,
                34.470863
              ],
              [
                45.502951,
                34.470832
              ],
              [
                45.502162,
                34.471423
              ],
              [
                45.501892,
                34.471496
              ],
              [
                45.50159,
                34.471426
              ],
              [
                45.50114,
                34.47149
              ],
              [
                45.500911,
                34.471661
              ],
              [
                45.500509,
                34.471675
              ],
              [
                45.500302,
                34.472035
              ],
              [
                45.500073,
                34.472164
              ],
              [
                45.499703,
                34.472234
              ],
              [
                45.499172,
                34.472692
              ],
              [
                45.49792,
                34.473244
              ],
              [
                45.497695,
                34.473659
              ],
              [
                45.496734,
                34.473917
              ],
              [
                45.495858,
                34.474242
              ],
              [
                45.495325,
                34.474109
              ],
              [
                45.494922,
                34.474114
              ],
              [
                45.494473,
                34.47423
              ],
              [
                45.493535,
                34.474363
              ],
              [
                45.492828,
                34.474377
              ],
              [
                45.492708,
                34.474464
              ],
              [
                45.492654,
                34.474758
              ],
              [
                45.492547,
                34.474991
              ],
              [
                45.492287,
                34.475159
              ],
              [
                45.491651,
                34.475093
              ],
              [
                45.491142,
                34.475113
              ],
              [
                45.491034,
                34.47525
              ],
              [
                45.49078,
                34.475399
              ],
              [
                45.490488,
                34.47551
              ],
              [
                45.490198,
                34.475534
              ],
              [
                45.489099,
                34.475429
              ],
              [
                45.488659,
                34.475448
              ],
              [
                45.488264,
                34.4754
              ],
              [
                45.487887,
                34.475436
              ],
              [
                45.487317,
                34.475674
              ],
              [
                45.487009,
                34.475622
              ],
              [
                45.486622,
                34.475703
              ],
              [
                45.486392,
                34.475823
              ],
              [
                45.485788,
                34.475813
              ],
              [
                45.485593,
                34.476006
              ],
              [
                45.485219,
                34.476103
              ],
              [
                45.484942,
                34.476281
              ],
              [
                45.483415,
                34.476611
              ],
              [
                45.483152,
                34.476762
              ],
              [
                45.482461,
                34.476582
              ],
              [
                45.482116,
                34.476535
              ],
              [
                45.48202,
                34.47587
              ],
              [
                45.481882,
                34.47569
              ],
              [
                45.480821,
                34.475396
              ],
              [
                45.478921,
                34.475597
              ],
              [
                45.478271,
                34.475742
              ],
              [
                45.477758,
                34.475606
              ],
              [
                45.477255,
                34.475651
              ],
              [
                45.475841,
                34.475913
              ],
              [
                45.475126,
                34.475893
              ],
              [
                45.474825,
                34.475823
              ],
              [
                45.474507,
                34.475676
              ],
              [
                45.474165,
                34.475647
              ],
              [
                45.473815,
                34.47581
              ],
              [
                45.473424,
                34.476326
              ],
              [
                45.473065,
                34.476534
              ],
              [
                45.472629,
                34.476526
              ],
              [
                45.47222,
                34.476463
              ],
              [
                45.471845,
                34.476507
              ],
              [
                45.471689,
                34.476651
              ],
              [
                45.471661,
                34.476977
              ],
              [
                45.471478,
                34.477221
              ],
              [
                45.47131,
                34.477358
              ],
              [
                45.47096,
                34.477425
              ],
              [
                45.470784,
                34.477572
              ],
              [
                45.470604,
                34.477876
              ],
              [
                45.470337,
                34.47801
              ],
              [
                45.469923,
                34.47806
              ],
              [
                45.469512,
                34.477892
              ],
              [
                45.469043,
                34.477832
              ],
              [
                45.468759,
                34.477502
              ],
              [
                45.467564,
                34.476425
              ],
              [
                45.467424,
                34.476333
              ],
              [
                45.466721,
                34.47616
              ],
              [
                45.466197,
                34.475588
              ],
              [
                45.466086,
                34.475319
              ],
              [
                45.466127,
                34.475081
              ],
              [
                45.466315,
                34.474797
              ],
              [
                45.466201,
                34.474615
              ],
              [
                45.466019,
                34.474507
              ],
              [
                45.465686,
                34.474403
              ],
              [
                45.465565,
                34.474437
              ],
              [
                45.465271,
                34.474779
              ],
              [
                45.465021,
                34.474973
              ],
              [
                45.464901,
                34.475231
              ],
              [
                45.464557,
                34.47552
              ],
              [
                45.464362,
                34.475543
              ],
              [
                45.464046,
                34.475506
              ],
              [
                45.463394,
                34.475218
              ],
              [
                45.463008,
                34.474872
              ],
              [
                45.462573,
                34.474373
              ],
              [
                45.462404,
                34.474259
              ],
              [
                45.462122,
                34.474165
              ],
              [
                45.461668,
                34.474147
              ],
              [
                45.461139,
                34.473611
              ],
              [
                45.461268,
                34.473501
              ],
              [
                45.461232,
                34.473244
              ],
              [
                45.461113,
                34.472964
              ],
              [
                45.460932,
                34.472739
              ],
              [
                45.460692,
                34.471693
              ],
              [
                45.460744,
                34.47156
              ],
              [
                45.461087,
                34.471121
              ],
              [
                45.46165,
                34.470831
              ],
              [
                45.462408,
                34.470958
              ],
              [
                45.462906,
                34.47078
              ],
              [
                45.463227,
                34.470748
              ],
              [
                45.46353,
                34.470603
              ],
              [
                45.463587,
                34.47047
              ],
              [
                45.463114,
                34.470101
              ],
              [
                45.462912,
                34.470043
              ],
              [
                45.462748,
                34.469855
              ],
              [
                45.462691,
                34.469717
              ],
              [
                45.462736,
                34.469375
              ],
              [
                45.462685,
                34.46924
              ],
              [
                45.462451,
                34.469066
              ],
              [
                45.462226,
                34.468693
              ],
              [
                45.462218,
                34.468531
              ],
              [
                45.462319,
                34.468448
              ],
              [
                45.462657,
                34.468401
              ],
              [
                45.462626,
                34.468172
              ],
              [
                45.462716,
                34.468082
              ],
              [
                45.463017,
                34.467946
              ],
              [
                45.462859,
                34.467641
              ],
              [
                45.462843,
                34.467264
              ],
              [
                45.462758,
                34.467177
              ],
              [
                45.462628,
                34.467165
              ],
              [
                45.462296,
                34.467336
              ],
              [
                45.462187,
                34.467283
              ],
              [
                45.462081,
                34.466966
              ],
              [
                45.461962,
                34.466832
              ],
              [
                45.461781,
                34.466758
              ],
              [
                45.461693,
                34.466758
              ],
              [
                45.46154,
                34.466921
              ],
              [
                45.461363,
                34.466989
              ],
              [
                45.461211,
                34.466963
              ],
              [
                45.460943,
                34.46657
              ],
              [
                45.460823,
                34.466509
              ],
              [
                45.459791,
                34.466576
              ],
              [
                45.459462,
                34.466493
              ],
              [
                45.459015,
                34.46628
              ],
              [
                45.458641,
                34.4657
              ],
              [
                45.457724,
                34.465997
              ],
              [
                45.457354,
                34.466202
              ],
              [
                45.457015,
                34.46632
              ],
              [
                45.456543,
                34.466443
              ],
              [
                45.456209,
                34.466451
              ],
              [
                45.455552,
                34.466571
              ],
              [
                45.455279,
                34.466666
              ],
              [
                45.454803,
                34.466939
              ],
              [
                45.454432,
                34.467091
              ],
              [
                45.454122,
                34.466824
              ],
              [
                45.453908,
                34.46675
              ],
              [
                45.453418,
                34.466246
              ],
              [
                45.453046,
                34.465962
              ],
              [
                45.45276,
                34.465876
              ],
              [
                45.45251,
                34.465835
              ],
              [
                45.452104,
                34.465936
              ],
              [
                45.451893,
                34.466058
              ],
              [
                45.451628,
                34.466307
              ],
              [
                45.451399,
                34.466367
              ],
              [
                45.450851,
                34.466165
              ],
              [
                45.450445,
                34.465943
              ],
              [
                45.450071,
                34.465597
              ],
              [
                45.450227,
                34.465233
              ],
              [
                45.450172,
                34.464967
              ],
              [
                45.449996,
                34.464737
              ],
              [
                45.450318,
                34.464153
              ],
              [
                45.450114,
                34.463664
              ],
              [
                45.449033,
                34.463741
              ],
              [
                45.448618,
                34.463576
              ],
              [
                45.448215,
                34.463567
              ],
              [
                45.447438,
                34.463882
              ],
              [
                45.446986,
                34.463999
              ],
              [
                45.446471,
                34.464073
              ],
              [
                45.446191,
                34.463994
              ],
              [
                45.445971,
                34.464036
              ],
              [
                45.445334,
                34.464033
              ],
              [
                45.444928,
                34.464097
              ],
              [
                45.444657,
                34.463934
              ],
              [
                45.444488,
                34.463757
              ],
              [
                45.444479,
                34.463677
              ],
              [
                45.444552,
                34.463562
              ],
              [
                45.444457,
                34.463408
              ],
              [
                45.444279,
                34.463425
              ],
              [
                45.444099,
                34.463605
              ],
              [
                45.443855,
                34.463598
              ],
              [
                45.443789,
                34.463473
              ],
              [
                45.443943,
                34.46314
              ],
              [
                45.443934,
                34.463054
              ],
              [
                45.443663,
                34.462794
              ],
              [
                45.443512,
                34.462735
              ],
              [
                45.443354,
                34.461838
              ],
              [
                45.443388,
                34.461413
              ],
              [
                45.443323,
                34.461287
              ],
              [
                45.44306,
                34.46108
              ],
              [
                45.443032,
                34.460667
              ],
              [
                45.442941,
                34.460633
              ],
              [
                45.44261,
                34.46065
              ],
              [
                45.442182,
                34.460527
              ],
              [
                45.44204,
                34.460411
              ],
              [
                45.441833,
                34.460013
              ],
              [
                45.441742,
                34.460002
              ],
              [
                45.441567,
                34.460091
              ],
              [
                45.441474,
                34.460069
              ],
              [
                45.441668,
                34.459507
              ],
              [
                45.441656,
                34.459202
              ],
              [
                45.441584,
                34.459135
              ],
              [
                45.44149,
                34.459132
              ],
              [
                45.441217,
                34.459245
              ],
              [
                45.441123,
                34.459441
              ],
              [
                45.44076,
                34.459477
              ],
              [
                45.440675,
                34.459447
              ],
              [
                45.440632,
                34.45923
              ],
              [
                45.440497,
                34.459072
              ],
              [
                45.44042,
                34.459055
              ],
              [
                45.440259,
                34.459161
              ],
              [
                45.440162,
                34.459147
              ],
              [
                45.440097,
                34.459041
              ],
              [
                45.439814,
                34.458932
              ],
              [
                45.439987,
                34.458783
              ],
              [
                45.440082,
                34.458395
              ],
              [
                45.440015,
                34.458331
              ],
              [
                45.439826,
                34.458299
              ],
              [
                45.439852,
                34.458131
              ],
              [
                45.439741,
                34.457973
              ],
              [
                45.44006,
                34.457716
              ],
              [
                45.440077,
                34.457603
              ],
              [
                45.44004,
                34.457466
              ],
              [
                45.439794,
                34.45715
              ],
              [
                45.439895,
                34.456888
              ],
              [
                45.439838,
                34.456601
              ],
              [
                45.43999,
                34.4565
              ],
              [
                45.440068,
                34.456222
              ],
              [
                45.440038,
                34.455873
              ],
              [
                45.439938,
                34.455768
              ],
              [
                45.43993,
                34.455654
              ],
              [
                45.440124,
                34.455517
              ],
              [
                45.440294,
                34.455506
              ],
              [
                45.440364,
                34.455458
              ],
              [
                45.440356,
                34.455368
              ],
              [
                45.440082,
                34.455055
              ],
              [
                45.439969,
                34.45471
              ],
              [
                45.439922,
                34.454425
              ],
              [
                45.439824,
                34.454255
              ],
              [
                45.439841,
                34.453823
              ],
              [
                45.439989,
                34.453501
              ],
              [
                45.440117,
                34.453354
              ],
              [
                45.440335,
                34.453237
              ],
              [
                45.440432,
                34.452952
              ],
              [
                45.440549,
                34.452875
              ],
              [
                45.440735,
                34.452843
              ],
              [
                45.440993,
                34.453027
              ],
              [
                45.441162,
                34.453082
              ],
              [
                45.441287,
                34.453019
              ],
              [
                45.441375,
                34.452843
              ],
              [
                45.441374,
                34.45259
              ],
              [
                45.441801,
                34.45253
              ],
              [
                45.441912,
                34.452691
              ],
              [
                45.441984,
                34.452682
              ],
              [
                45.442139,
                34.452125
              ],
              [
                45.442232,
                34.452048
              ],
              [
                45.442415,
                34.452
              ],
              [
                45.442665,
                34.451776
              ],
              [
                45.442664,
                34.451692
              ],
              [
                45.44256,
                34.451663
              ],
              [
                45.442114,
                34.45163
              ],
              [
                45.442049,
                34.451501
              ],
              [
                45.441964,
                34.451294
              ],
              [
                45.44197,
                34.451178
              ],
              [
                45.442218,
                34.450962
              ],
              [
                45.442284,
                34.450849
              ],
              [
                45.442278,
                34.450743
              ],
              [
                45.442209,
                34.450622
              ],
              [
                45.442001,
                34.450592
              ],
              [
                45.441939,
                34.450328
              ],
              [
                45.441977,
                34.450273
              ],
              [
                45.442228,
                34.450244
              ],
              [
                45.442292,
                34.450171
              ],
              [
                45.442337,
                34.450053
              ],
              [
                45.442271,
                34.449821
              ],
              [
                45.442288,
                34.449708
              ],
              [
                45.443012,
                34.44916
              ],
              [
                45.443192,
                34.44883
              ],
              [
                45.443453,
                34.448508
              ],
              [
                45.443164,
                34.448366
              ],
              [
                45.442976,
                34.447866
              ],
              [
                45.442858,
                34.447721
              ],
              [
                45.442762,
                34.447339
              ],
              [
                45.442494,
                34.447156
              ],
              [
                45.442254,
                34.446863
              ],
              [
                45.44193,
                34.446894
              ],
              [
                45.441755,
                34.44681
              ],
              [
                45.441961,
                34.446556
              ],
              [
                45.441903,
                34.446216
              ],
              [
                45.44195,
                34.446156
              ],
              [
                45.442179,
                34.446095
              ],
              [
                45.442085,
                34.44582
              ],
              [
                45.442315,
                34.445686
              ],
              [
                45.442367,
                34.445576
              ],
              [
                45.44211,
                34.445054
              ],
              [
                45.442157,
                34.44452
              ],
              [
                45.442281,
                34.444377
              ],
              [
                45.442417,
                34.444321
              ],
              [
                45.442656,
                34.444036
              ],
              [
                45.442635,
                34.443978
              ],
              [
                45.442538,
                34.443964
              ],
              [
                45.441894,
                34.443992
              ],
              [
                45.441828,
                34.443912
              ],
              [
                45.441771,
                34.443674
              ],
              [
                45.441802,
                34.443533
              ],
              [
                45.441855,
                34.443426
              ],
              [
                45.441997,
                34.443373
              ],
              [
                45.442043,
                34.443282
              ],
              [
                45.441932,
                34.443048
              ],
              [
                45.441961,
                34.442922
              ],
              [
                45.442032,
                34.442809
              ],
              [
                45.442133,
                34.442769
              ],
              [
                45.442269,
                34.442781
              ],
              [
                45.44238,
                34.442847
              ],
              [
                45.442452,
                34.44296
              ],
              [
                45.442344,
                34.443208
              ],
              [
                45.442384,
                34.443337
              ],
              [
                45.442462,
                34.443384
              ],
              [
                45.442779,
                34.443216
              ],
              [
                45.44299,
                34.442966
              ],
              [
                45.442873,
                34.442652
              ],
              [
                45.442706,
                34.442356
              ],
              [
                45.4426,
                34.44227
              ],
              [
                45.442153,
                34.442402
              ],
              [
                45.442142,
                34.442319
              ],
              [
                45.44218,
                34.442188
              ],
              [
                45.442341,
                34.442059
              ],
              [
                45.442623,
                34.441666
              ],
              [
                45.442851,
                34.441479
              ],
              [
                45.442898,
                34.441365
              ],
              [
                45.442702,
                34.441077
              ],
              [
                45.442562,
                34.440988
              ],
              [
                45.442476,
                34.440758
              ],
              [
                45.442509,
                34.440624
              ],
              [
                45.442756,
                34.440507
              ],
              [
                45.442852,
                34.440391
              ],
              [
                45.442823,
                34.439851
              ],
              [
                45.442858,
                34.439559
              ],
              [
                45.442918,
                34.439313
              ],
              [
                45.44306,
                34.439084
              ],
              [
                45.44324,
                34.438926
              ],
              [
                45.443472,
                34.438807
              ],
              [
                45.443737,
                34.438726
              ],
              [
                45.444574,
                34.4386
              ],
              [
                45.445074,
                34.438832
              ],
              [
                45.445861,
                34.43885
              ],
              [
                45.446166,
                34.43903
              ],
              [
                45.446271,
                34.439142
              ],
              [
                45.446556,
                34.438941
              ],
              [
                45.447041,
                34.438336
              ],
              [
                45.447557,
                34.438029
              ],
              [
                45.448014,
                34.437654
              ],
              [
                45.448199,
                34.437268
              ],
              [
                45.448371,
                34.437136
              ],
              [
                45.448559,
                34.437098
              ],
              [
                45.448679,
                34.437129
              ],
              [
                45.448923,
                34.436822
              ],
              [
                45.44885,
                34.436778
              ],
              [
                45.449004,
                34.436732
              ],
              [
                45.44909,
                34.436773
              ],
              [
                45.449158,
                34.436732
              ],
              [
                45.44913,
                34.436623
              ],
              [
                45.449184,
                34.4366
              ],
              [
                45.449315,
                34.436611
              ],
              [
                45.449429,
                34.436723
              ],
              [
                45.449596,
                34.436652
              ],
              [
                45.449649,
                34.436392
              ],
              [
                45.44992,
                34.436256
              ],
              [
                45.450087,
                34.436113
              ],
              [
                45.450239,
                34.435842
              ],
              [
                45.450266,
                34.435696
              ],
              [
                45.450691,
                34.435634
              ],
              [
                45.450768,
                34.435578
              ],
              [
                45.450745,
                34.435525
              ],
              [
                45.450835,
                34.435499
              ],
              [
                45.45132,
                34.435489
              ],
              [
                45.451427,
                34.435328
              ],
              [
                45.451736,
                34.435357
              ],
              [
                45.452061,
                34.43531
              ],
              [
                45.452169,
                34.435201
              ],
              [
                45.452422,
                34.435114
              ],
              [
                45.452744,
                34.435195
              ],
              [
                45.452867,
                34.435289
              ],
              [
                45.453062,
                34.435318
              ],
              [
                45.453456,
                34.435268
              ],
              [
                45.453961,
                34.435074
              ],
              [
                45.454308,
                34.435109
              ],
              [
                45.454299,
                34.432754
              ],
              [
                45.455941,
                34.432991
              ],
              [
                45.455834,
                34.432545
              ],
              [
                45.455908,
                34.432347
              ],
              [
                45.455887,
                34.431699
              ],
              [
                45.455907,
                34.4316
              ],
              [
                45.456015,
                34.431498
              ],
              [
                45.456109,
                34.431129
              ],
              [
                45.456082,
                34.430796
              ],
              [
                45.456139,
                34.430438
              ],
              [
                45.455985,
                34.430327
              ],
              [
                45.455829,
                34.430066
              ],
              [
                45.455712,
                34.429716
              ],
              [
                45.455725,
                34.428555
              ],
              [
                45.456279,
                34.428027
              ],
              [
                45.456533,
                34.427867
              ],
              [
                45.456655,
                34.42771
              ],
              [
                45.456814,
                34.427325
              ],
              [
                45.456791,
                34.42691
              ],
              [
                45.457062,
                34.42669
              ],
              [
                45.45721,
                34.426368
              ],
              [
                45.456998,
                34.425554
              ],
              [
                45.457034,
                34.425239
              ],
              [
                45.456882,
                34.424968
              ],
              [
                45.457009,
                34.424763
              ],
              [
                45.457096,
                34.424434
              ],
              [
                45.457093,
                34.424273
              ],
              [
                45.456964,
                34.424045
              ],
              [
                45.45696,
                34.423927
              ],
              [
                45.457091,
                34.423665
              ],
              [
                45.457129,
                34.423388
              ],
              [
                45.456998,
                34.423175
              ],
              [
                45.456983,
                34.422925
              ],
              [
                45.456897,
                34.422767
              ],
              [
                45.456476,
                34.422264
              ],
              [
                45.456733,
                34.42177
              ],
              [
                45.456719,
                34.421033
              ],
              [
                45.455552,
                34.419845
              ],
              [
                45.455619,
                34.419387
              ],
              [
                45.455994,
                34.418942
              ],
              [
                45.455517,
                34.418319
              ],
              [
                45.455585,
                34.417912
              ],
              [
                45.455556,
                34.417505
              ],
              [
                45.4562,
                34.416448
              ],
              [
                45.456823,
                34.416562
              ],
              [
                45.457139,
                34.416546
              ],
              [
                45.457305,
                34.416451
              ],
              [
                45.457446,
                34.41648
              ],
              [
                45.458558,
                34.415834
              ],
              [
                45.462498,
                34.4025
              ],
              [
                45.463904,
                34.398679
              ],
              [
                45.4673089,
                34.3825649
              ],
              [
                45.4681427,
                34.3819962
              ],
              [
                45.4677463,
                34.3791461
              ],
              [
                45.480033,
                34.365339
              ],
              [
                45.496178,
                34.336867
              ],
              [
                45.498573,
                34.335315
              ],
              [
                45.498748,
                34.335731
              ],
              [
                45.49888,
                34.336551
              ],
              [
                45.499178,
                34.337214
              ],
              [
                45.5009669,
                34.339051
              ],
              [
                45.5011761,
                34.3394319
              ],
              [
                45.5013478,
                34.3395914
              ],
              [
                45.5015516,
                34.339711
              ],
              [
                45.5017316,
                34.3398906
              ],
              [
                45.5019057,
                34.3401562
              ],
              [
                45.5022007,
                34.3403001
              ],
              [
                45.5025027,
                34.3406435
              ],
              [
                45.5024368,
                34.3411373
              ],
              [
                45.5023386,
                34.3416483
              ],
              [
                45.5022222,
                34.3420586
              ],
              [
                45.5021643,
                34.3424422
              ],
              [
                45.5021248,
                34.3430221
              ],
              [
                45.5023024,
                34.3436836
              ],
              [
                45.502477,
                34.344176
              ],
              [
                45.5027222,
                34.34498
              ],
              [
                45.502986,
                34.3454423
              ],
              [
                45.503702,
                34.346278
              ],
              [
                45.503841,
                34.34642
              ],
              [
                45.504303,
                34.346679
              ],
              [
                45.504725,
                34.347012
              ],
              [
                45.505748,
                34.348133
              ],
              [
                45.505903,
                34.3486428
              ],
              [
                45.5060309,
                34.3493799
              ],
              [
                45.5062743,
                34.35028
              ],
              [
                45.5063863,
                34.3509372
              ],
              [
                45.5067935,
                34.3515286
              ],
              [
                45.5069911,
                34.3517959
              ],
              [
                45.5072094,
                34.3520134
              ],
              [
                45.5076074,
                34.3522591
              ],
              [
                45.5078843,
                34.3523229
              ],
              [
                45.508163,
                34.352325
              ],
              [
                45.508321,
                34.352322
              ],
              [
                45.508716,
                34.352178
              ],
              [
                45.509234,
                34.351837
              ],
              [
                45.510214,
                34.350914
              ],
              [
                45.510931,
                34.350337
              ],
              [
                45.512206,
                34.349703
              ],
              [
                45.513878,
                34.348639
              ],
              [
                45.5140936,
                34.3484853
              ],
              [
                45.5145764,
                34.3484188
              ],
              [
                45.514667,
                34.3483402
              ],
              [
                45.5147253,
                34.3482568
              ],
              [
                45.514842,
                34.3481066
              ],
              [
                45.515017,
                34.347991
              ],
              [
                45.515191,
                34.34794
              ],
              [
                45.515861,
                34.347844
              ],
              [
                45.51672,
                34.347876
              ],
              [
                45.5177136,
                34.3480806
              ],
              [
                45.5185971,
                34.3483391
              ],
              [
                45.519559,
                34.348509
              ],
              [
                45.520327,
                34.348606
              ],
              [
                45.5205806,
                34.3486115
              ],
              [
                45.520838,
                34.348594
              ],
              [
                45.5210264,
                34.3485027
              ],
              [
                45.5211183,
                34.3484255
              ],
              [
                45.5211787,
                34.34839
              ],
              [
                45.5212887,
                34.3483635
              ],
              [
                45.5214496,
                34.3483601
              ],
              [
                45.5216335,
                34.3484276
              ],
              [
                45.5217607,
                34.3484819
              ],
              [
                45.521882,
                34.3485632
              ],
              [
                45.522075,
                34.348821
              ],
              [
                45.5222409,
                34.3489007
              ],
              [
                45.5223097,
                34.3490086
              ],
              [
                45.5223791,
                34.3490837
              ],
              [
                45.5226432,
                34.3490909
              ],
              [
                45.522851,
                34.3490832
              ],
              [
                45.523134,
                34.3490267
              ],
              [
                45.5237887,
                34.34895
              ],
              [
                45.5239508,
                34.348958
              ],
              [
                45.5240192,
                34.3489791
              ],
              [
                45.5241171,
                34.3490234
              ],
              [
                45.524258,
                34.349017
              ],
              [
                45.5243641,
                34.3490481
              ],
              [
                45.5244456,
                34.3491075
              ],
              [
                45.524547,
                34.349148
              ],
              [
                45.5247004,
                34.3491861
              ],
              [
                45.5248906,
                34.3492003
              ],
              [
                45.5250951,
                34.3491669
              ],
              [
                45.5253944,
                34.3490482
              ],
              [
                45.5258471,
                34.3488994
              ],
              [
                45.526125,
                34.348863
              ],
              [
                45.5263178,
                34.34873
              ],
              [
                45.5266786,
                34.348452
              ],
              [
                45.5268969,
                34.3483661
              ],
              [
                45.527141,
                34.348184
              ],
              [
                45.527306,
                34.348121
              ],
              [
                45.527624,
                34.347644
              ],
              [
                45.5278212,
                34.3471698
              ],
              [
                45.5282074,
                34.3469794
              ],
              [
                45.5285346,
                34.3467624
              ],
              [
                45.5289048,
                34.3465321
              ],
              [
                45.5293286,
                34.3463682
              ],
              [
                45.5296451,
                34.3462663
              ],
              [
                45.530026,
                34.346253
              ],
              [
                45.5304176,
                34.3462043
              ],
              [
                45.5307984,
                34.3461024
              ],
              [
                45.5312705,
                34.346129
              ],
              [
                45.5316621,
                34.34616
              ],
              [
                45.5322713,
                34.346182
              ],
              [
                45.532661,
                34.3462313
              ],
              [
                45.5328846,
                34.3464096
              ],
              [
                45.5330166,
                34.3465143
              ],
              [
                45.5330832,
                34.3466349
              ],
              [
                45.5331554,
                34.3467461
              ],
              [
                45.5331856,
                34.3469572
              ],
              [
                45.5331883,
                34.3472894
              ],
              [
                45.5332287,
                34.3475426
              ],
              [
                45.5334109,
                34.3480734
              ],
              [
                45.5335718,
                34.3485362
              ],
              [
                45.5336925,
                34.3489104
              ],
              [
                45.5338785,
                34.3495313
              ],
              [
                45.5339259,
                34.3496346
              ],
              [
                45.5340037,
                34.3497409
              ],
              [
                45.5341083,
                34.3498228
              ],
              [
                45.5342907,
                34.3501107
              ],
              [
                45.5343792,
                34.3504689
              ],
              [
                45.5344087,
                34.3507617
              ],
              [
                45.5343738,
                34.351026
              ],
              [
                45.5343068,
                34.3512843
              ],
              [
                45.5342217,
                34.3514522
              ],
              [
                45.53454,
                34.351529
              ],
              [
                45.535126,
                34.352068
              ],
              [
                45.535361,
                34.352077
              ],
              [
                45.535735,
                34.352186
              ],
              [
                45.535874,
                34.3521
              ],
              [
                45.535945,
                34.351953
              ],
              [
                45.536408,
                34.351871
              ],
              [
                45.536853,
                34.351332
              ],
              [
                45.537206,
                34.351212
              ],
              [
                45.537494,
                34.351176
              ],
              [
                45.537621,
                34.351224
              ],
              [
                45.537661,
                34.351304
              ],
              [
                45.537418,
                34.351647
              ],
              [
                45.537653,
                34.351928
              ],
              [
                45.537719,
                34.352077
              ],
              [
                45.537813,
                34.352139
              ],
              [
                45.538075,
                34.352107
              ],
              [
                45.538192,
                34.351902
              ],
              [
                45.538227,
                34.351533
              ],
              [
                45.538277,
                34.351475
              ],
              [
                45.538381,
                34.351468
              ],
              [
                45.538573,
                34.351587
              ],
              [
                45.538746,
                34.351605
              ],
              [
                45.538865,
                34.351546
              ],
              [
                45.538917,
                34.351019
              ],
              [
                45.539088,
                34.350733
              ],
              [
                45.53943,
                34.350342
              ],
              [
                45.539692,
                34.350283
              ],
              [
                45.539766,
                34.350353
              ],
              [
                45.539515,
                34.350615
              ],
              [
                45.539455,
                34.350766
              ],
              [
                45.539482,
                34.350925
              ],
              [
                45.539533,
                34.350963
              ],
              [
                45.539948,
                34.350838
              ],
              [
                45.540139,
                34.35084
              ],
              [
                45.540261,
                34.350775
              ],
              [
                45.540608,
                34.350379
              ],
              [
                45.5412,
                34.349858
              ],
              [
                45.541287,
                34.349731
              ],
              [
                45.541218,
                34.349433
              ],
              [
                45.541246,
                34.349351
              ],
              [
                45.54135,
                34.349298
              ],
              [
                45.541532,
                34.349328
              ],
              [
                45.541741,
                34.349295
              ],
              [
                45.541965,
                34.349146
              ],
              [
                45.542102,
                34.348802
              ],
              [
                45.542225,
                34.34865
              ],
              [
                45.542494,
                34.348512
              ],
              [
                45.542948,
                34.348532
              ],
              [
                45.543143,
                34.348483
              ],
              [
                45.543345,
                34.34851
              ],
              [
                45.543353,
                34.348813
              ],
              [
                45.543417,
                34.348862
              ],
              [
                45.54354,
                34.348825
              ],
              [
                45.544039,
                34.3484
              ],
              [
                45.544413,
                34.347532
              ],
              [
                45.544716,
                34.347198
              ],
              [
                45.54474,
                34.346939
              ],
              [
                45.544835,
                34.346824
              ],
              [
                45.545057,
                34.346821
              ],
              [
                45.545282,
                34.346381
              ],
              [
                45.545651,
                34.34599
              ],
              [
                45.54609,
                34.345675
              ],
              [
                45.546188,
                34.345664
              ],
              [
                45.546316,
                34.345894
              ],
              [
                45.546416,
                34.345938
              ],
              [
                45.546657,
                34.345927
              ],
              [
                45.546805,
                34.345835
              ],
              [
                45.546887,
                34.345713
              ],
              [
                45.546765,
                34.345464
              ],
              [
                45.546758,
                34.34532
              ],
              [
                45.546904,
                34.345151
              ],
              [
                45.54717,
                34.345023
              ],
              [
                45.547252,
                34.344646
              ],
              [
                45.547035,
                34.344262
              ],
              [
                45.54774,
                34.343951
              ],
              [
                45.548098,
                34.343944
              ],
              [
                45.548222,
                34.343838
              ],
              [
                45.548285,
                34.343701
              ],
              [
                45.548257,
                34.343605
              ],
              [
                45.54805,
                34.343465
              ],
              [
                45.548041,
                34.343153
              ],
              [
                45.548086,
                34.343073
              ],
              [
                45.548183,
                34.343058
              ],
              [
                45.54846,
                34.343114
              ],
              [
                45.548488,
                34.343073
              ],
              [
                45.548405,
                34.342832
              ],
              [
                45.548817,
                34.342717
              ],
              [
                45.548932,
                34.342621
              ],
              [
                45.549042,
                34.342163
              ],
              [
                45.548973,
                34.34191
              ],
              [
                45.549041,
                34.341817
              ],
              [
                45.549562,
                34.341535
              ],
              [
                45.549768,
                34.341557
              ],
              [
                45.549848,
                34.341626
              ],
              [
                45.549868,
                34.3418
              ],
              [
                45.549946,
                34.341865
              ],
              [
                45.550038,
                34.341851
              ],
              [
                45.550407,
                34.341279
              ],
              [
                45.550551,
                34.341215
              ],
              [
                45.550611,
                34.340996
              ],
              [
                45.550843,
                34.340791
              ],
              [
                45.550978,
                34.340756
              ],
              [
                45.551168,
                34.340777
              ],
              [
                45.551301,
                34.340874
              ],
              [
                45.551381,
                34.340875
              ],
              [
                45.551447,
                34.340819
              ],
              [
                45.551443,
                34.34046
              ],
              [
                45.551579,
                34.34043
              ],
              [
                45.551816,
                34.340474
              ],
              [
                45.551933,
                34.340428
              ],
              [
                45.551851,
                34.340259
              ],
              [
                45.551693,
                34.340102
              ],
              [
                45.551782,
                34.340034
              ],
              [
                45.552404,
                34.339999
              ],
              [
                45.552705,
                34.340179
              ],
              [
                45.552974,
                34.3402
              ],
              [
                45.553209,
                34.34014
              ],
              [
                45.553728,
                34.339758
              ],
              [
                45.553892,
                34.339532
              ],
              [
                45.553877,
                34.339444
              ],
              [
                45.553816,
                34.339412
              ],
              [
                45.55353,
                34.33943
              ],
              [
                45.55345,
                34.339361
              ],
              [
                45.55344,
                34.339181
              ],
              [
                45.553476,
                34.338993
              ],
              [
                45.55356,
                34.338925
              ],
              [
                45.554082,
                34.338784
              ],
              [
                45.554169,
                34.338724
              ],
              [
                45.554181,
                34.338663
              ],
              [
                45.554124,
                34.3386
              ],
              [
                45.5539,
                34.338453
              ],
              [
                45.553858,
                34.338319
              ],
              [
                45.554098,
                34.338145
              ],
              [
                45.553937,
                34.337797
              ],
              [
                45.553974,
                34.33766
              ],
              [
                45.554634,
                34.337223
              ],
              [
                45.555223,
                34.337235
              ],
              [
                45.555386,
                34.337296
              ],
              [
                45.555559,
                34.337291
              ],
              [
                45.55572,
                34.337211
              ],
              [
                45.555935,
                34.336977
              ],
              [
                45.55631,
                34.336949
              ],
              [
                45.55646,
                34.336889
              ],
              [
                45.556602,
                34.336526
              ],
              [
                45.556572,
                34.336235
              ],
              [
                45.556685,
                34.335881
              ],
              [
                45.55685,
                34.335773
              ],
              [
                45.557231,
                34.335658
              ],
              [
                45.557276,
                34.335583
              ],
              [
                45.55726,
                34.33549
              ],
              [
                45.557041,
                34.335275
              ],
              [
                45.557036,
                34.335184
              ],
              [
                45.557125,
                34.335138
              ],
              [
                45.557504,
                34.335151
              ],
              [
                45.557603,
                34.335054
              ],
              [
                45.55759,
                34.334956
              ],
              [
                45.557265,
                34.334671
              ],
              [
                45.557254,
                34.334582
              ],
              [
                45.557358,
                34.334483
              ],
              [
                45.557732,
                34.334361
              ],
              [
                45.55829,
                34.334418
              ],
              [
                45.558397,
                34.334378
              ],
              [
                45.558804,
                34.333968
              ],
              [
                45.558758,
                34.333748
              ],
              [
                45.558799,
                34.333719
              ],
              [
                45.559088,
                34.333687
              ],
              [
                45.559312,
                34.333561
              ],
              [
                45.559591,
                34.333467
              ],
              [
                45.559734,
                34.333467
              ],
              [
                45.560339,
                34.333226
              ],
              [
                45.560661,
                34.333156
              ],
              [
                45.560926,
                34.332978
              ],
              [
                45.561153,
                34.332701
              ],
              [
                45.561437,
                34.332625
              ],
              [
                45.561625,
                34.332209
              ],
              [
                45.561807,
                34.331623
              ],
              [
                45.574748,
                34.316232
              ],
              [
                45.583566,
                34.302663
              ],
              [
                45.585172,
                34.296881
              ],
              [
                45.585698,
                34.291206
              ],
              [
                45.585535,
                34.288766
              ],
              [
                45.58562,
                34.286706
              ],
              [
                45.585121,
                34.282757
              ],
              [
                45.584384,
                34.278574
              ],
              [
                45.583216,
                34.273258
              ],
              [
                45.582681,
                34.268939
              ],
              [
                45.582136,
                34.26712
              ],
              [
                45.581739,
                34.264227
              ],
              [
                45.581528,
                34.261019
              ],
              [
                45.581548,
                34.257146
              ],
              [
                45.5816331,
                34.2561528
              ],
              [
                45.581709,
                34.255266
              ],
              [
                45.581772,
                34.2551
              ],
              [
                45.582085,
                34.252976
              ],
              [
                45.582679,
                34.250156
              ],
              [
                45.582813,
                34.249059
              ],
              [
                45.582854,
                34.248159
              ],
              [
                45.582752,
                34.247025
              ],
              [
                45.582462,
                34.246049
              ],
              [
                45.582049,
                34.245308
              ],
              [
                45.581786,
                34.244617
              ],
              [
                45.58149,
                34.241788
              ],
              [
                45.581097,
                34.23956
              ],
              [
                45.578745,
                34.232701
              ],
              [
                45.578221,
                34.231653
              ],
              [
                45.575087,
                34.22711
              ],
              [
                45.573724,
                34.225232
              ],
              [
                45.572126,
                34.222567
              ],
              [
                45.571544,
                34.221293
              ],
              [
                45.570871,
                34.219301
              ],
              [
                45.570332,
                34.216252
              ],
              [
                45.568655,
                34.212268
              ],
              [
                45.566803,
                34.210203
              ],
              [
                45.561731,
                34.205817
              ],
              [
                45.557137,
                34.200427
              ],
              [
                45.556792,
                34.200076
              ],
              [
                45.556031,
                34.199023
              ],
              [
                45.555602,
                34.198242
              ],
              [
                45.555169,
                34.196953
              ],
              [
                45.554975,
                34.196132
              ],
              [
                45.554874,
                34.195116
              ],
              [
                45.555007,
                34.193746
              ],
              [
                45.555702,
                34.19206
              ],
              [
                45.556726,
                34.19006
              ],
              [
                45.558314,
                34.187861
              ],
              [
                45.559949,
                34.185702
              ],
              [
                45.561305,
                34.184209
              ],
              [
                45.56425,
                34.180596
              ],
              [
                45.567476,
                34.176942
              ],
              [
                45.569557,
                34.175118
              ],
              [
                45.571272,
                34.173872
              ],
              [
                45.572253,
                34.172655
              ],
              [
                45.573325,
                34.170928
              ],
              [
                45.573751,
                34.169802
              ],
              [
                45.573889,
                34.16899
              ],
              [
                45.574623,
                34.167197
              ],
              [
                45.574732,
                34.166289
              ],
              [
                45.574782,
                34.163526
              ],
              [
                45.575099,
                34.161725
              ],
              [
                45.575079,
                34.158673
              ],
              [
                45.575167,
                34.157773
              ],
              [
                45.575585,
                34.156871
              ],
              [
                45.576275,
                34.154559
              ],
              [
                45.578897,
                34.149925
              ],
              [
                45.580234,
                34.148057
              ],
              [
                45.580832,
                34.147356
              ],
              [
                45.581162,
                34.146888
              ],
              [
                45.581594,
                34.14613
              ],
              [
                45.56802,
                34.139953
              ],
              [
                45.560063,
                34.138826
              ],
              [
                45.548712,
                34.130668
              ],
              [
                45.544936,
                34.128266
              ],
              [
                45.544597,
                34.127378
              ],
              [
                45.544052,
                34.127099
              ],
              [
                45.543266,
                34.126281
              ],
              [
                45.543052,
                34.125964
              ],
              [
                45.542794,
                34.125258
              ],
              [
                45.542685,
                34.125102
              ],
              [
                45.541953,
                34.124861
              ],
              [
                45.540434,
                34.124638
              ],
              [
                45.5395,
                34.124395
              ],
              [
                45.538495,
                34.123953
              ],
              [
                45.537587,
                34.123305
              ],
              [
                45.536689,
                34.123038
              ],
              [
                45.536116,
                34.123008
              ],
              [
                45.535993,
                34.123076
              ],
              [
                45.535935,
                34.123223
              ],
              [
                45.535955,
                34.123384
              ],
              [
                45.536068,
                34.123509
              ],
              [
                45.536133,
                34.123801
              ],
              [
                45.535976,
                34.123932
              ],
              [
                45.535742,
                34.124
              ],
              [
                45.535485,
                34.123961
              ],
              [
                45.535287,
                34.123859
              ],
              [
                45.535124,
                34.123676
              ],
              [
                45.534866,
                34.123516
              ],
              [
                45.533118,
                34.122881
              ],
              [
                45.531799,
                34.122342
              ],
              [
                45.531374,
                34.122218
              ],
              [
                45.530789,
                34.121901
              ],
              [
                45.530478,
                34.121621
              ],
              [
                45.530106,
                34.121097
              ],
              [
                45.529987,
                34.120725
              ],
              [
                45.52997,
                34.119959
              ],
              [
                45.530101,
                34.119285
              ],
              [
                45.530238,
                34.119068
              ],
              [
                45.531055,
                34.118401
              ],
              [
                45.531664,
                34.118087
              ],
              [
                45.532864,
                34.117832
              ],
              [
                45.53323,
                34.117712
              ],
              [
                45.533548,
                34.117546
              ],
              [
                45.53379,
                34.117393
              ],
              [
                45.53394,
                34.117209
              ],
              [
                45.533955,
                34.117064
              ],
              [
                45.533847,
                34.116815
              ],
              [
                45.532966,
                34.116647
              ],
              [
                45.532368,
                34.116483
              ],
              [
                45.531869,
                34.116482
              ],
              [
                45.531238,
                34.116244
              ],
              [
                45.531119,
                34.116089
              ],
              [
                45.531098,
                34.115759
              ],
              [
                45.530585,
                34.114524
              ],
              [
                45.530286,
                34.114371
              ],
              [
                45.529628,
                34.114324
              ],
              [
                45.528618,
                34.114528
              ],
              [
                45.528057,
                34.114772
              ],
              [
                45.527818,
                34.115005
              ],
              [
                45.527725,
                34.115233
              ],
              [
                45.527731,
                34.11545
              ],
              [
                45.528259,
                34.116224
              ],
              [
                45.528292,
                34.11685
              ],
              [
                45.52822,
                34.117075
              ],
              [
                45.528232,
                34.117557
              ],
              [
                45.52837,
                34.117989
              ],
              [
                45.528353,
                34.118125
              ],
              [
                45.528058,
                34.1183
              ],
              [
                45.527446,
                34.11841
              ],
              [
                45.526778,
                34.118604
              ],
              [
                45.525834,
                34.118624
              ],
              [
                45.525379,
                34.118536
              ],
              [
                45.524806,
                34.118226
              ],
              [
                45.523655,
                34.117865
              ],
              [
                45.523438,
                34.117726
              ],
              [
                45.523412,
                34.117419
              ],
              [
                45.523483,
                34.117164
              ],
              [
                45.523756,
                34.116654
              ],
              [
                45.523998,
                34.115856
              ],
              [
                45.524227,
                34.115549
              ],
              [
                45.524317,
                34.115312
              ],
              [
                45.524304,
                34.115181
              ],
              [
                45.523813,
                34.114263
              ],
              [
                45.52359,
                34.114022
              ],
              [
                45.523205,
                34.113745
              ],
              [
                45.522393,
                34.113624
              ],
              [
                45.522101,
                34.113621
              ],
              [
                45.521652,
                34.11375
              ],
              [
                45.521497,
                34.113721
              ],
              [
                45.521118,
                34.11335
              ],
              [
                45.521025,
                34.113195
              ],
              [
                45.520995,
                34.112987
              ],
              [
                45.52102,
                34.111907
              ],
              [
                45.521084,
                34.111457
              ],
              [
                45.521248,
                34.111169
              ],
              [
                45.521428,
                34.111025
              ],
              [
                45.521473,
                34.110774
              ],
              [
                45.521409,
                34.110344
              ],
              [
                45.521283,
                34.110208
              ],
              [
                45.521108,
                34.110134
              ],
              [
                45.520581,
                34.11015
              ],
              [
                45.520258,
                34.110201
              ],
              [
                45.51956,
                34.110422
              ],
              [
                45.519024,
                34.110853
              ],
              [
                45.518405,
                34.111622
              ],
              [
                45.518157,
                34.111767
              ],
              [
                45.516518,
                34.112386
              ],
              [
                45.515654,
                34.112557
              ],
              [
                45.515284,
                34.112585
              ],
              [
                45.515069,
                34.112525
              ],
              [
                45.514983,
                34.112423
              ],
              [
                45.514948,
                34.112242
              ],
              [
                45.515068,
                34.111925
              ],
              [
                45.515004,
                34.111686
              ],
              [
                45.514449,
                34.110667
              ],
              [
                45.514183,
                34.110638
              ],
              [
                45.513895,
                34.110701
              ],
              [
                45.513283,
                34.110696
              ],
              [
                45.512441,
                34.110006
              ],
              [
                45.511729,
                34.109549
              ],
              [
                45.511585,
                34.109403
              ],
              [
                45.511076,
                34.108497
              ],
              [
                45.51075,
                34.108175
              ],
              [
                45.510052,
                34.107867
              ],
              [
                45.509912,
                34.107746
              ],
              [
                45.509925,
                34.107351
              ],
              [
                45.509828,
                34.107165
              ],
              [
                45.509618,
                34.10697
              ],
              [
                45.50935,
                34.106462
              ],
              [
                45.509196,
                34.106307
              ],
              [
                45.508596,
                34.106012
              ],
              [
                45.508382,
                34.105827
              ],
              [
                45.508076,
                34.105293
              ],
              [
                45.50785,
                34.104672
              ],
              [
                45.507683,
                34.104479
              ],
              [
                45.507134,
                34.104247
              ],
              [
                45.506814,
                34.104194
              ],
              [
                45.505976,
                34.104294
              ],
              [
                45.505668,
                34.104177
              ],
              [
                45.505336,
                34.104122
              ],
              [
                45.504828,
                34.103928
              ],
              [
                45.504428,
                34.103696
              ],
              [
                45.503966,
                34.103245
              ],
              [
                45.503922,
                34.103078
              ],
              [
                45.504109,
                34.102744
              ],
              [
                45.504614,
                34.102339
              ],
              [
                45.504976,
                34.101961
              ],
              [
                45.505896,
                34.100968
              ],
              [
                45.506403,
                34.100209
              ],
              [
                45.506835,
                34.0999
              ],
              [
                45.50698,
                34.099681
              ],
              [
                45.506952,
                34.098952
              ],
              [
                45.506804,
                34.098457
              ],
              [
                45.50668,
                34.098382
              ],
              [
                45.50646,
                34.098372
              ],
              [
                45.505842,
                34.098526
              ],
              [
                45.505182,
                34.098813
              ],
              [
                45.50494,
                34.098779
              ],
              [
                45.504658,
                34.09864
              ],
              [
                45.503962,
                34.098686
              ],
              [
                45.503493,
                34.098657
              ],
              [
                45.503068,
                34.098567
              ],
              [
                45.501267,
                34.097843
              ],
              [
                45.49933,
                34.096742
              ],
              [
                45.498354,
                34.095889
              ],
              [
                45.49761,
                34.095098
              ],
              [
                45.497205,
                34.094911
              ],
              [
                45.496962,
                34.094873
              ],
              [
                45.496476,
                34.094886
              ],
              [
                45.49632,
                34.094808
              ],
              [
                45.496159,
                34.094395
              ],
              [
                45.496249,
                34.094077
              ],
              [
                45.496244,
                34.093921
              ],
              [
                45.496025,
                34.093281
              ],
              [
                45.496002,
                34.092913
              ],
              [
                45.496185,
                34.092022
              ],
              [
                45.496148,
                34.091862
              ],
              [
                45.495961,
                34.091722
              ],
              [
                45.495364,
                34.091556
              ],
              [
                45.494608,
                34.091482
              ],
              [
                45.494097,
                34.091499
              ],
              [
                45.493746,
                34.091451
              ],
              [
                45.493556,
                34.091365
              ],
              [
                45.493427,
                34.091224
              ],
              [
                45.493267,
                34.090726
              ],
              [
                45.493289,
                34.088827
              ],
              [
                45.493188,
                34.088673
              ],
              [
                45.492854,
                34.088448
              ],
              [
                45.492771,
                34.088184
              ],
              [
                45.492616,
                34.087958
              ],
              [
                45.492436,
                34.08787
              ],
              [
                45.491309,
                34.087572
              ],
              [
                45.490226,
                34.087371
              ],
              [
                45.48985,
                34.087103
              ],
              [
                45.489827,
                34.086915
              ],
              [
                45.489973,
                34.086521
              ],
              [
                45.490119,
                34.086306
              ],
              [
                45.49067,
                34.085893
              ],
              [
                45.491601,
                34.085489
              ],
              [
                45.492215,
                34.085321
              ],
              [
                45.494383,
                34.084352
              ],
              [
                45.495378,
                34.083727
              ],
              [
                45.495542,
                34.0835
              ],
              [
                45.49559,
                34.083273
              ],
              [
                45.495543,
                34.083075
              ],
              [
                45.495451,
                34.082955
              ],
              [
                45.494196,
                34.082517
              ],
              [
                45.492941,
                34.082467
              ],
              [
                45.492094,
                34.082479
              ],
              [
                45.491455,
                34.082338
              ],
              [
                45.490886,
                34.082266
              ],
              [
                45.490068,
                34.082041
              ],
              [
                45.489726,
                34.081785
              ],
              [
                45.489536,
                34.08161
              ],
              [
                45.489183,
                34.080945
              ],
              [
                45.488961,
                34.079889
              ],
              [
                45.488841,
                34.079805
              ],
              [
                45.488102,
                34.079894
              ],
              [
                45.487859,
                34.079811
              ],
              [
                45.487569,
                34.079637
              ],
              [
                45.48704,
                34.079175
              ],
              [
                45.486473,
                34.078432
              ],
              [
                45.486016,
                34.078115
              ],
              [
                45.485909,
                34.077908
              ],
              [
                45.485918,
                34.077451
              ],
              [
                45.485969,
                34.077282
              ],
              [
                45.486191,
                34.076939
              ],
              [
                45.486172,
                34.076427
              ],
              [
                45.485888,
                34.075721
              ],
              [
                45.485705,
                34.075526
              ],
              [
                45.485519,
                34.075461
              ],
              [
                45.485313,
                34.075489
              ],
              [
                45.484619,
                34.075879
              ],
              [
                45.484401,
                34.076083
              ],
              [
                45.484181,
                34.076502
              ],
              [
                45.484026,
                34.077152
              ],
              [
                45.483794,
                34.077792
              ],
              [
                45.483679,
                34.077984
              ],
              [
                45.483679,
                34.078954
              ],
              [
                45.483596,
                34.079597
              ],
              [
                45.483203,
                34.080816
              ],
              [
                45.482993,
                34.080939
              ],
              [
                45.482428,
                34.081067
              ],
              [
                45.482059,
                34.08108
              ],
              [
                45.481195,
                34.080929
              ],
              [
                45.480941,
                34.080821
              ],
              [
                45.480472,
                34.080452
              ],
              [
                45.479496,
                34.080073
              ],
              [
                45.479353,
                34.079894
              ],
              [
                45.479268,
                34.079693
              ],
              [
                45.479159,
                34.079026
              ],
              [
                45.479137,
                34.07814
              ],
              [
                45.479241,
                34.076979
              ],
              [
                45.47916,
                34.076634
              ],
              [
                45.478987,
                34.076487
              ],
              [
                45.478536,
                34.07633
              ],
              [
                45.477013,
                34.076134
              ],
              [
                45.476242,
                34.075906
              ],
              [
                45.474756,
                34.075866
              ],
              [
                45.474335,
                34.075949
              ],
              [
                45.473963,
                34.075838
              ],
              [
                45.473516,
                34.075608
              ],
              [
                45.47339,
                34.075364
              ],
              [
                45.473584,
                34.0749
              ],
              [
                45.473604,
                34.074198
              ],
              [
                45.473556,
                34.073994
              ],
              [
                45.473469,
                34.07387
              ],
              [
                45.473302,
                34.073839
              ],
              [
                45.472962,
                34.073675
              ],
              [
                45.472521,
                34.072856
              ],
              [
                45.472503,
                34.072555
              ],
              [
                45.472272,
                34.071734
              ],
              [
                45.471609,
                34.071188
              ],
              [
                45.471522,
                34.07102
              ],
              [
                45.471551,
                34.070742
              ],
              [
                45.472076,
                34.070184
              ],
              [
                45.472326,
                34.069647
              ],
              [
                45.472375,
                34.069383
              ],
              [
                45.472318,
                34.069096
              ],
              [
                45.472181,
                34.068853
              ],
              [
                45.47209,
                34.068734
              ],
              [
                45.471953,
                34.068672
              ],
              [
                45.471106,
                34.068648
              ],
              [
                45.470598,
                34.068378
              ],
              [
                45.470514,
                34.06818
              ],
              [
                45.4706,
                34.068074
              ],
              [
                45.470582,
                34.067794
              ],
              [
                45.470356,
                34.06733
              ],
              [
                45.46984,
                34.066532
              ],
              [
                45.469603,
                34.06629
              ],
              [
                45.469187,
                34.06605
              ],
              [
                45.468792,
                34.066173
              ],
              [
                45.468588,
                34.06616
              ],
              [
                45.46821,
                34.06595
              ],
              [
                45.467853,
                34.065559
              ],
              [
                45.467185,
                34.064992
              ],
              [
                45.466321,
                34.064062
              ],
              [
                45.466126,
                34.06373
              ],
              [
                45.466166,
                34.063384
              ],
              [
                45.466595,
                34.063225
              ],
              [
                45.46835,
                34.06207
              ],
              [
                45.470072,
                34.061089
              ],
              [
                45.470921,
                34.06056
              ],
              [
                45.472049,
                34.05975
              ],
              [
                45.472266,
                34.059707
              ],
              [
                45.472927,
                34.059883
              ],
              [
                45.473588,
                34.05997
              ],
              [
                45.475087,
                34.05995
              ],
              [
                45.477328,
                34.05985
              ],
              [
                45.477637,
                34.059811
              ],
              [
                45.477936,
                34.05969
              ],
              [
                45.478804,
                34.059012
              ],
              [
                45.478939,
                34.058753
              ],
              [
                45.479079,
                34.05825
              ],
              [
                45.479278,
                34.057253
              ],
              [
                45.478977,
                34.056355
              ],
              [
                45.478976,
                34.05617
              ],
              [
                45.479331,
                34.055316
              ],
              [
                45.479258,
                34.054153
              ],
              [
                45.479295,
                34.053547
              ],
              [
                45.479206,
                34.053415
              ],
              [
                45.478808,
                34.0533
              ],
              [
                45.478056,
                34.052759
              ],
              [
                45.477335,
                34.052394
              ],
              [
                45.476696,
                34.051862
              ],
              [
                45.475835,
                34.051059
              ],
              [
                45.475704,
                34.050797
              ],
              [
                45.475678,
                34.050325
              ],
              [
                45.475879,
                34.049896
              ],
              [
                45.476658,
                34.049003
              ],
              [
                45.477241,
                34.048555
              ],
              [
                45.478713,
                34.047612
              ],
              [
                45.479175,
                34.04724
              ],
              [
                45.47946,
                34.046941
              ],
              [
                45.479697,
                34.046533
              ],
              [
                45.479786,
                34.046148
              ],
              [
                45.479783,
                34.045752
              ],
              [
                45.479697,
                34.045434
              ],
              [
                45.479526,
                34.045045
              ],
              [
                45.479228,
                34.044699
              ],
              [
                45.47876,
                34.044286
              ],
              [
                45.4787,
                34.044141
              ],
              [
                45.478783,
                34.043889
              ],
              [
                45.478905,
                34.043778
              ],
              [
                45.479202,
                34.04367
              ],
              [
                45.479381,
                34.043528
              ],
              [
                45.479641,
                34.043037
              ],
              [
                45.479655,
                34.042872
              ],
              [
                45.479422,
                34.042356
              ],
              [
                45.479231,
                34.042103
              ],
              [
                45.479028,
                34.041896
              ],
              [
                45.478119,
                34.041295
              ],
              [
                45.477973,
                34.041057
              ],
              [
                45.477891,
                34.040863
              ],
              [
                45.477874,
                34.040614
              ],
              [
                45.477921,
                34.040452
              ],
              [
                45.478201,
                34.040157
              ],
              [
                45.478249,
                34.040004
              ],
              [
                45.478221,
                34.039841
              ],
              [
                45.478139,
                34.039739
              ],
              [
                45.477747,
                34.039759
              ],
              [
                45.477251,
                34.039316
              ],
              [
                45.477031,
                34.039054
              ],
              [
                45.476913,
                34.038825
              ],
              [
                45.47686,
                34.038577
              ],
              [
                45.476865,
                34.037451
              ],
              [
                45.477088,
                34.036759
              ],
              [
                45.477641,
                34.035848
              ],
              [
                45.477693,
                34.035575
              ],
              [
                45.477662,
                34.035328
              ],
              [
                45.47757,
                34.035143
              ],
              [
                45.477411,
                34.035005
              ],
              [
                45.476918,
                34.034755
              ],
              [
                45.475854,
                34.034553
              ],
              [
                45.475113,
                34.034509
              ],
              [
                45.474634,
                34.03461
              ],
              [
                45.473849,
                34.034872
              ],
              [
                45.473307,
                34.035292
              ],
              [
                45.472716,
                34.035432
              ],
              [
                45.472442,
                34.035549
              ],
              [
                45.471915,
                34.035627
              ],
              [
                45.471712,
                34.035574
              ],
              [
                45.471546,
                34.035454
              ],
              [
                45.471291,
                34.035158
              ],
              [
                45.470846,
                34.034887
              ],
              [
                45.469952,
                34.034553
              ],
              [
                45.469822,
                34.034472
              ],
              [
                45.469725,
                34.034311
              ],
              [
                45.469698,
                34.034196
              ],
              [
                45.469765,
                34.034075
              ],
              [
                45.470035,
                34.033804
              ],
              [
                45.472362,
                34.033505
              ],
              [
                45.472759,
                34.033099
              ],
              [
                45.473044,
                34.032265
              ],
              [
                45.473128,
                34.031316
              ],
              [
                45.473088,
                34.030493
              ],
              [
                45.473134,
                34.029567
              ],
              [
                45.473077,
                34.029192
              ],
              [
                45.472859,
                34.02867
              ],
              [
                45.47216,
                34.027679
              ],
              [
                45.471437,
                34.02708
              ],
              [
                45.470871,
                34.026837
              ],
              [
                45.470687,
                34.026729
              ],
              [
                45.470577,
                34.026596
              ],
              [
                45.470533,
                34.026435
              ],
              [
                45.470567,
                34.026196
              ],
              [
                45.47064,
                34.025743
              ],
              [
                45.470746,
                34.025475
              ],
              [
                45.47183,
                34.02412
              ],
              [
                45.471984,
                34.024012
              ],
              [
                45.472162,
                34.023958
              ],
              [
                45.472371,
                34.02397
              ],
              [
                45.472566,
                34.024054
              ],
              [
                45.474042,
                34.025039
              ],
              [
                45.474933,
                34.025789
              ],
              [
                45.475217,
                34.025961
              ],
              [
                45.4754,
                34.025994
              ],
              [
                45.475523,
                34.025958
              ],
              [
                45.475625,
                34.025805
              ],
              [
                45.475726,
                34.025467
              ],
              [
                45.475736,
                34.025152
              ],
              [
                45.475667,
                34.024925
              ],
              [
                45.475486,
                34.024675
              ],
              [
                45.474927,
                34.023989
              ],
              [
                45.47434,
                34.023426
              ],
              [
                45.474016,
                34.023128
              ],
              [
                45.473263,
                34.022609
              ],
              [
                45.472598,
                34.02201
              ],
              [
                45.472012,
                34.021633
              ],
              [
                45.471849,
                34.021437
              ],
              [
                45.471534,
                34.020996
              ],
              [
                45.471315,
                34.020584
              ],
              [
                45.47109,
                34.019944
              ],
              [
                45.470984,
                34.019382
              ],
              [
                45.470831,
                34.019026
              ],
              [
                45.470646,
                34.018755
              ],
              [
                45.470296,
                34.018394
              ],
              [
                45.470076,
                34.018313
              ],
              [
                45.469755,
                34.018367
              ],
              [
                45.469518,
                34.019022
              ],
              [
                45.469346,
                34.019124
              ],
              [
                45.46904,
                34.01922
              ],
              [
                45.468813,
                34.019242
              ],
              [
                45.468199,
                34.019129
              ],
              [
                45.467705,
                34.0191
              ],
              [
                45.467194,
                34.018954
              ],
              [
                45.466859,
                34.018926
              ],
              [
                45.466762,
                34.018646
              ],
              [
                45.466768,
                34.018517
              ],
              [
                45.467103,
                34.017984
              ],
              [
                45.467182,
                34.017442
              ],
              [
                45.467352,
                34.017107
              ],
              [
                45.467485,
                34.016684
              ],
              [
                45.467547,
                34.016229
              ],
              [
                45.467553,
                34.01587
              ],
              [
                45.467342,
                34.015268
              ],
              [
                45.467302,
                34.015009
              ],
              [
                45.467299,
                34.014656
              ],
              [
                45.467433,
                34.014013
              ],
              [
                45.467377,
                34.013819
              ],
              [
                45.467236,
                34.013624
              ],
              [
                45.46696,
                34.013376
              ],
              [
                45.466265,
                34.012918
              ],
              [
                45.46585,
                34.012572
              ],
              [
                45.465673,
                34.012225
              ],
              [
                45.465698,
                34.012062
              ],
              [
                45.465834,
                34.011785
              ],
              [
                45.466332,
                34.011226
              ],
              [
                45.466926,
                34.010715
              ],
              [
                45.467071,
                34.010498
              ],
              [
                45.467094,
                34.010305
              ],
              [
                45.466848,
                34.009822
              ],
              [
                45.466398,
                34.009349
              ],
              [
                45.464627,
                34.008392
              ],
              [
                45.463753,
                34.008187
              ],
              [
                45.463083,
                34.008172
              ],
              [
                45.462397,
                34.008115
              ],
              [
                45.461866,
                34.007994
              ],
              [
                45.461573,
                34.008009
              ],
              [
                45.460787,
                34.007707
              ],
              [
                45.46025,
                34.007582
              ],
              [
                45.45933,
                34.007456
              ],
              [
                45.459017,
                34.007292
              ],
              [
                45.458543,
                34.007123
              ],
              [
                45.458372,
                34.00696
              ],
              [
                45.458141,
                34.006876
              ],
              [
                45.457601,
                34.00681
              ],
              [
                45.456975,
                34.006916
              ],
              [
                45.454269,
                34.006845
              ],
              [
                45.45233,
                34.006611
              ],
              [
                45.452094,
                34.00633
              ],
              [
                45.451861,
                34.005836
              ],
              [
                45.451011,
                34.004763
              ],
              [
                45.450036,
                34.003952
              ],
              [
                45.449296,
                34.003395
              ],
              [
                45.448786,
                34.003073
              ],
              [
                45.448534,
                34.002745
              ],
              [
                45.448319,
                34.002571
              ],
              [
                45.447562,
                34.002101
              ],
              [
                45.446512,
                34.001328
              ],
              [
                45.446276,
                34.001201
              ],
              [
                45.445896,
                34.001115
              ],
              [
                45.445751,
                34.000974
              ],
              [
                45.445315,
                34.000763
              ],
              [
                45.444948,
                34.000193
              ],
              [
                45.444493,
                33.999699
              ],
              [
                45.444031,
                33.999311
              ],
              [
                45.443681,
                33.998655
              ],
              [
                45.442952,
                33.998145
              ],
              [
                45.442635,
                33.998036
              ],
              [
                45.441638,
                33.997329
              ],
              [
                45.441063,
                33.997026
              ],
              [
                45.440009,
                33.996593
              ],
              [
                45.439837,
                33.996562
              ],
              [
                45.439699,
                33.996606
              ],
              [
                45.439614,
                33.996694
              ],
              [
                45.438941,
                33.997072
              ],
              [
                45.438045,
                33.997338
              ],
              [
                45.437821,
                33.997395
              ],
              [
                45.437439,
                33.997415
              ],
              [
                45.437157,
                33.997498
              ],
              [
                45.436383,
                33.997561
              ],
              [
                45.435312,
                33.997488
              ],
              [
                45.434607,
                33.997257
              ],
              [
                45.434167,
                33.996893
              ],
              [
                45.434066,
                33.996692
              ],
              [
                45.434029,
                33.996266
              ],
              [
                45.433893,
                33.996159
              ],
              [
                45.433605,
                33.996058
              ],
              [
                45.433149,
                33.996013
              ],
              [
                45.432521,
                33.99649
              ],
              [
                45.431771,
                33.996611
              ],
              [
                45.431436,
                33.996601
              ],
              [
                45.431351,
                33.996557
              ],
              [
                45.431275,
                33.996436
              ],
              [
                45.430716,
                33.996267
              ],
              [
                45.430756,
                33.995267
              ],
              [
                45.430629,
                33.994775
              ],
              [
                45.430691,
                33.993799
              ],
              [
                45.43062,
                33.993474
              ],
              [
                45.430646,
                33.993135
              ],
              [
                45.430753,
                33.992624
              ],
              [
                45.431049,
                33.992106
              ],
              [
                45.431132,
                33.991581
              ],
              [
                45.431397,
                33.990975
              ],
              [
                45.431346,
                33.990533
              ],
              [
                45.431297,
                33.99035
              ],
              [
                45.431215,
                33.99027
              ],
              [
                45.430811,
                33.990218
              ],
              [
                45.429623,
                33.990274
              ],
              [
                45.42895,
                33.990184
              ],
              [
                45.428395,
                33.990164
              ],
              [
                45.427843,
                33.990272
              ],
              [
                45.427027,
                33.990875
              ],
              [
                45.426338,
                33.991273
              ],
              [
                45.425688,
                33.991797
              ],
              [
                45.425324,
                33.992026
              ],
              [
                45.424706,
                33.991963
              ],
              [
                45.423634,
                33.991749
              ],
              [
                45.423014,
                33.991408
              ],
              [
                45.422075,
                33.990794
              ],
              [
                45.421545,
                33.990541
              ],
              [
                45.42117,
                33.9901
              ],
              [
                45.420996,
                33.989783
              ],
              [
                45.420832,
                33.989155
              ],
              [
                45.420845,
                33.988672
              ],
              [
                45.420731,
                33.98729
              ],
              [
                45.42107,
                33.986373
              ],
              [
                45.421377,
                33.98591
              ],
              [
                45.421692,
                33.98508
              ],
              [
                45.422084,
                33.984386
              ],
              [
                45.422164,
                33.984155
              ],
              [
                45.422238,
                33.983494
              ],
              [
                45.422671,
                33.982473
              ],
              [
                45.422722,
                33.982219
              ],
              [
                45.422673,
                33.981847
              ],
              [
                45.42236,
                33.981457
              ],
              [
                45.421581,
                33.980859
              ],
              [
                45.4211,
                33.98064
              ],
              [
                45.419718,
                33.979667
              ],
              [
                45.419418,
                33.979544
              ],
              [
                45.41865,
                33.979325
              ],
              [
                45.418186,
                33.97927
              ],
              [
                45.417743,
                33.979281
              ],
              [
                45.417082,
                33.979392
              ],
              [
                45.416361,
                33.979323
              ],
              [
                45.415795,
                33.979007
              ],
              [
                45.415461,
                33.978926
              ],
              [
                45.413963,
                33.978741
              ],
              [
                45.412714,
                33.978377
              ],
              [
                45.411889,
                33.978246
              ],
              [
                45.411551,
                33.978227
              ],
              [
                45.410902,
                33.978341
              ],
              [
                45.410642,
                33.978336
              ],
              [
                45.407661,
                33.977255
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555168,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کرمانشاه",
          "name:azb": "کیرمانشاه بؤلگه‌سی",
          "name:de": "Verwaltungsbezirk Kermanschah",
          "name:en": "Kermanshah County",
          "name:fr": "Préfecture de Kermanchah",
          "name:ku": "Kirmaşan",
          "name:sr": "Керманшашки округ",
          "name:ur": "شہرستان کرمانشاہ",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289717",
          "wikipedia": "fa:شهرستان کرمانشاه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.3840761,
                34.5916031
              ],
              [
                46.3844742,
                34.5701499
              ],
              [
                46.3888956,
                34.5631675
              ],
              [
                46.3947221,
                34.5575298
              ],
              [
                46.4037932,
                34.5539767
              ],
              [
                46.4138951,
                34.5473336
              ],
              [
                46.4232652,
                34.5403309
              ],
              [
                46.4293613,
                34.5354113
              ],
              [
                46.4285369,
                34.5274369
              ],
              [
                46.4282563,
                34.5271571
              ],
              [
                46.4282563,
                34.5266067
              ],
              [
                46.4288134,
                34.526327
              ],
              [
                46.4360369,
                34.5224377
              ],
              [
                46.4363135,
                34.5218783
              ],
              [
                46.4402034,
                34.5177184
              ],
              [
                46.4402035,
                34.5171589
              ],
              [
                46.4407566,
                34.5165994
              ],
              [
                46.4446465,
                34.5099398
              ],
              [
                46.4504795,
                34.5041014
              ],
              [
                46.459093,
                34.4991023
              ],
              [
                46.4599265,
                34.4991023
              ],
              [
                46.4624267,
                34.4982721
              ],
              [
                46.4635361,
                34.498272
              ],
              [
                46.4640931,
                34.4979923
              ],
              [
                46.4649267,
                34.4979924
              ],
              [
                46.4663165,
                34.4979923
              ],
              [
                46.473816,
                34.4979924
              ],
              [
                46.4746496,
                34.4977126
              ],
              [
                46.4863162,
                34.4954928
              ],
              [
                46.4879826,
                34.4941031
              ],
              [
                46.4879827,
                34.4935527
              ],
              [
                46.4885397,
                34.4924427
              ],
              [
                46.4890929,
                34.4910441
              ],
              [
                46.4885397,
                34.4802153
              ],
              [
                46.4890929,
                34.4777156
              ],
              [
                46.4893726,
                34.4760462
              ],
              [
                46.4949259,
                34.4696572
              ],
              [
                46.4949259,
                34.4690978
              ],
              [
                46.4960392,
                34.4674373
              ],
              [
                46.4974259,
                34.4627178
              ],
              [
                46.4977064,
                34.4621582
              ],
              [
                46.497426,
                34.4616078
              ],
              [
                46.4968728,
                34.4591081
              ],
              [
                46.4882594,
                34.4429909
              ],
              [
                46.4874266,
                34.4413305
              ],
              [
                46.4832593,
                34.4316024
              ],
              [
                46.4829828,
                34.4299329
              ],
              [
                46.4829828,
                34.4207732
              ],
              [
                46.4835368,
                34.417714
              ],
              [
                46.4835368,
                34.4141042
              ],
              [
                46.4854829,
                34.408825
              ],
              [
                46.485483,
                34.4085453
              ],
              [
                46.4882596,
                34.403266
              ],
              [
                46.4885401,
                34.4029862
              ],
              [
                46.4943731,
                34.388827
              ],
              [
                46.4949262,
                34.3882675
              ],
              [
                46.4996497,
                34.3799289
              ],
              [
                46.5068733,
                34.3693792
              ],
              [
                46.5074296,
                34.3690994
              ],
              [
                46.5340959,
                34.3518805
              ],
              [
                46.5340959,
                34.351321
              ],
              [
                46.5347448,
                34.3501181
              ],
              [
                46.5352061,
                34.3496605
              ],
              [
                46.5529861,
                34.3366017
              ],
              [
                46.5610425,
                34.3282719
              ],
              [
                46.5613192,
                34.3274326
              ],
              [
                46.562709,
                34.325763
              ],
              [
                46.5704858,
                34.311603
              ],
              [
                46.5715991,
                34.3102132
              ],
              [
                46.575486,
                34.3027046
              ],
              [
                46.5993787,
                34.2838244
              ],
              [
                46.6007655,
                34.2832649
              ],
              [
                46.6090985,
                34.278265
              ],
              [
                46.6102118,
                34.2774348
              ],
              [
                46.6168784,
                34.273545
              ],
              [
                46.617712,
                34.273545
              ],
              [
                46.6179885,
                34.2732652
              ],
              [
                46.6185455,
                34.2732652
              ],
              [
                46.6193784,
                34.2729855
              ],
              [
                46.619655,
                34.2727147
              ],
              [
                46.620212,
                34.2724349
              ],
              [
                46.620212,
                34.2707653
              ],
              [
                46.6204886,
                34.2693754
              ],
              [
                46.6207683,
                34.2688249
              ],
              [
                46.6210456,
                34.2607655
              ],
              [
                46.624102,
                34.2496555
              ],
              [
                46.6274357,
                34.2429859
              ],
              [
                46.6341023,
                34.2363253
              ],
              [
                46.6352117,
                34.2357658
              ],
              [
                46.6354922,
                34.235486
              ],
              [
                46.6452118,
                34.2293759
              ],
              [
                46.6463252,
                34.2288164
              ],
              [
                46.6471588,
                34.2288164
              ],
              [
                46.647712,
                34.2285366
              ],
              [
                46.647712,
                34.2282658
              ],
              [
                46.6490554,
                34.2276289
              ],
              [
                46.6496581,
                34.2274265
              ],
              [
                46.6591012,
                34.222986
              ],
              [
                46.6791049,
                34.2163255
              ],
              [
                46.697438,
                34.2088163
              ],
              [
                46.7004944,
                34.2082658
              ],
              [
                46.726884,
                34.1990961
              ],
              [
                46.7299411,
                34.1977062
              ],
              [
                46.7543838,
                34.1888162
              ],
              [
                46.7596636,
                34.1877061
              ],
              [
                46.7788305,
                34.1799262
              ],
              [
                46.7796632,
                34.1790958
              ],
              [
                46.7832735,
                34.1768755
              ],
              [
                46.7860532,
                34.1740956
              ],
              [
                46.7874439,
                34.1704855
              ],
              [
                46.7877205,
                34.1702056
              ],
              [
                46.7949434,
                34.1549254
              ],
              [
                46.7960535,
                34.1532647
              ],
              [
                46.7974434,
                34.1513241
              ],
              [
                46.8130001,
                34.1385438
              ],
              [
                46.8374428,
                34.1271535
              ],
              [
                46.8382764,
                34.1271535
              ],
              [
                46.8491133,
                34.123814
              ],
              [
                46.8491133,
                34.1235432
              ],
              [
                46.8493899,
                34.1232634
              ],
              [
                46.8499462,
                34.1232634
              ],
              [
                46.8566127,
                34.1138224
              ],
              [
                46.859666,
                34.1040926
              ],
              [
                46.860223,
                34.1013217
              ],
              [
                46.8604996,
                34.1004823
              ],
              [
                46.8546667,
                34.0735398
              ],
              [
                46.8541129,
                34.0702092
              ],
              [
                46.8535566,
                34.0665898
              ],
              [
                46.8535566,
                34.0613186
              ],
              [
                46.8549465,
                34.0563183
              ],
              [
                46.8554997,
                34.0557586
              ],
              [
                46.8557802,
                34.0549282
              ],
              [
                46.8563333,
                34.0546484
              ],
              [
                46.863556,
                34.0474275
              ],
              [
                46.8657795,
                34.0457577
              ],
              [
                46.9063359,
                34.0252053
              ],
              [
                46.9202261,
                34.0204846
              ],
              [
                46.9230058,
                34.0193744
              ],
              [
                46.9299489,
                34.0174337
              ],
              [
                46.9327256,
                34.0174338
              ],
              [
                46.9338389,
                34.0171449
              ],
              [
                46.9505056,
                34.0127041
              ],
              [
                46.9530057,
                34.0115938
              ],
              [
                46.9538385,
                34.0115939
              ],
              [
                46.9541151,
                34.011314
              ],
              [
                46.9593957,
                34.0088137
              ],
              [
                46.9602285,
                34.0079834
              ],
              [
                46.9610622,
                34.0077035
              ],
              [
                46.9695239,
                34.0008915
              ],
              [
                46.9607856,
                33.9963214
              ],
              [
                46.9321725,
                33.9815903
              ],
              [
                46.9310592,
                33.9807599
              ],
              [
                46.9282826,
                33.9785394
              ],
              [
                46.9280061,
                33.9782596
              ],
              [
                46.9280061,
                33.9776999
              ],
              [
                46.9277256,
                33.9740893
              ],
              [
                46.9280061,
                33.9718689
              ],
              [
                46.9282827,
                33.9713183
              ],
              [
                46.9280062,
                33.9652074
              ],
              [
                46.9280062,
                33.9563163
              ],
              [
                46.9291157,
                33.9499255
              ],
              [
                46.9293929,
                33.9474252
              ],
              [
                46.9296726,
                33.9468746
              ],
              [
                46.9296726,
                33.9429841
              ],
              [
                46.9299492,
                33.9421447
              ],
              [
                46.9299493,
                33.9415941
              ],
              [
                46.9305063,
                33.9410344
              ],
              [
                46.9349494,
                33.9252019
              ],
              [
                46.9374495,
                33.9163196
              ],
              [
                46.953839,
                33.8802037
              ],
              [
                46.9555063,
                33.8757536
              ],
              [
                46.9588392,
                33.8663116
              ],
              [
                46.9785624,
                33.833535
              ],
              [
                46.9968987,
                33.812141
              ],
              [
                46.9971753,
                33.8115904
              ],
              [
                46.9977324,
                33.8113105
              ],
              [
                46.9982855,
                33.8113105
              ],
              [
                46.9996072,
                33.8107508
              ],
              [
                47.002452,
                33.8102002
              ],
              [
                47.0043989,
                33.8102002
              ],
              [
                47.004952,
                33.8099204
              ],
              [
                47.0099521,
                33.8110307
              ],
              [
                47.0185656,
                33.8110307
              ],
              [
                47.0193984,
                33.8113106
              ],
              [
                47.020789,
                33.8113106
              ],
              [
                47.0307885,
                33.8143708
              ],
              [
                47.0399551,
                33.8238131
              ],
              [
                47.0443981,
                33.8302042
              ],
              [
                47.0466215,
                33.8318651
              ],
              [
                47.0471786,
                33.8318651
              ],
              [
                47.0521778,
                33.8332553
              ],
              [
                47.0905147,
                33.8243638
              ],
              [
                47.0927342,
                33.8243639
              ],
              [
                47.0938475,
                33.8249236
              ],
              [
                47.0946811,
                33.8249235
              ],
              [
                47.0960679,
                33.8254742
              ],
              [
                47.0994007,
                33.8299245
              ],
              [
                47.0996812,
                33.8304842
              ],
              [
                47.1024578,
                33.8368662
              ],
              [
                47.1063476,
                33.8404771
              ],
              [
                47.1094041,
                33.8402062
              ],
              [
                47.1127377,
                33.8385362
              ],
              [
                47.1269036,
                33.8238133
              ],
              [
                47.1269036,
                33.8232536
              ],
              [
                47.1296803,
                33.8202025
              ],
              [
                47.1299607,
                33.8199226
              ],
              [
                47.1374601,
                33.8146418
              ],
              [
                47.1396805,
                33.8143711
              ],
              [
                47.1402367,
                33.8146418
              ],
              [
                47.1471838,
                33.8146419
              ],
              [
                47.1499604,
                33.8152016
              ],
              [
                47.1521838,
                33.8152016
              ],
              [
                47.1532933,
                33.8154815
              ],
              [
                47.1546839,
                33.8154814
              ],
              [
                47.1602371,
                33.8163119
              ],
              [
                47.1677404,
                33.8168716
              ],
              [
                47.1771836,
                33.8168716
              ],
              [
                47.1777399,
                33.8165828
              ],
              [
                47.1832963,
                33.8157613
              ],
              [
                47.189683,
                33.8138115
              ],
              [
                47.1902401,
                33.8132609
              ],
              [
                47.1907964,
                33.8132609
              ],
              [
                47.1921831,
                33.8121416
              ],
              [
                47.1949628,
                33.8099208
              ],
              [
                47.2069061,
                33.8038096
              ],
              [
                47.2116296,
                33.8026992
              ],
              [
                47.2138531,
                33.8024284
              ],
              [
                47.2199626,
                33.8029792
              ],
              [
                47.2307956,
                33.80325
              ],
              [
                47.2310762,
                33.8035388
              ],
              [
                47.2335762,
                33.8038097
              ],
              [
                47.2341293,
                33.8038097
              ],
              [
                47.2346855,
                33.8038096
              ],
              [
                47.2360763,
                33.8040895
              ],
              [
                47.2380192,
                33.8040895
              ],
              [
                47.2391325,
                33.8043693
              ],
              [
                47.2438522,
                33.8043694
              ],
              [
                47.2444092,
                33.8040895
              ],
              [
                47.2452428,
                33.8040896
              ],
              [
                47.2460756,
                33.8038097
              ],
              [
                47.2491327,
                33.8038097
              ],
              [
                47.2499656,
                33.80325
              ],
              [
                47.2516328,
                33.8029792
              ],
              [
                47.2807991,
                33.7896462
              ],
              [
                47.284132,
                33.7888157
              ],
              [
                47.2852452,
                33.7885359
              ],
              [
                47.2874656,
                33.788536
              ],
              [
                47.2882985,
                33.7882561
              ],
              [
                47.2932985,
                33.7882561
              ],
              [
                47.2935782,
                33.7885359
              ],
              [
                47.2952454,
                33.788536
              ],
              [
                47.304412,
                33.791867
              ],
              [
                47.3077448,
                33.7963083
              ],
              [
                47.308855,
                33.8018691
              ],
              [
                47.3091347,
                33.8121418
              ],
              [
                47.3116348,
                33.8163123
              ],
              [
                47.3158012,
                33.8196433
              ],
              [
                47.3188583,
                33.8210335
              ],
              [
                47.3355243,
                33.8138119
              ],
              [
                47.3371915,
                33.8138118
              ],
              [
                47.3413579,
                33.8149222
              ],
              [
                47.343301,
                33.8160326
              ],
              [
                47.3435814,
                33.8165832
              ],
              [
                47.3441346,
                33.8168721
              ],
              [
                47.3588574,
                33.839927
              ],
              [
                47.3602473,
                33.8421476
              ],
              [
                47.3605239,
                33.8426982
              ],
              [
                47.3713608,
                33.8510302
              ],
              [
                47.3724709,
                33.85131
              ],
              [
                47.378861,
                33.85131
              ],
              [
                47.380804,
                33.8527001
              ],
              [
                47.3830275,
                33.8538105
              ],
              [
                47.3866369,
                33.8613118
              ],
              [
                47.3835806,
                33.870474
              ],
              [
                47.383304,
                33.873534
              ],
              [
                47.3830274,
                33.8740938
              ],
              [
                47.3830273,
                33.8752041
              ],
              [
                47.3821938,
                33.8765852
              ],
              [
                47.3819141,
                33.8777045
              ],
              [
                47.379414,
                33.8818748
              ],
              [
                47.3774702,
                33.8849259
              ],
              [
                47.3596909,
                33.9027085
              ],
              [
                47.3591377,
                33.9027085
              ],
              [
                47.3535805,
                33.9071497
              ],
              [
                47.3505243,
                33.90965
              ],
              [
                47.3196907,
                33.9390947
              ],
              [
                47.3133014,
                33.9527067
              ],
              [
                47.3144108,
                33.9560375
              ],
              [
                47.3149679,
                33.9571477
              ],
              [
                47.3162408,
                33.9610453
              ],
              [
                47.3184165,
                33.9617283
              ],
              [
                47.3190028,
                33.9626023
              ],
              [
                47.3196033,
                33.9629962
              ],
              [
                47.3210631,
                33.9633115
              ],
              [
                47.3221906,
                33.9632761
              ],
              [
                47.3235059,
                33.9633256
              ],
              [
                47.3248942,
                33.9623565
              ],
              [
                47.3255244,
                33.9624282
              ],
              [
                47.3266345,
                33.9624283
              ],
              [
                47.326911,
                33.9621484
              ],
              [
                47.3274673,
                33.9621485
              ],
              [
                47.3285205,
                33.9637552
              ],
              [
                47.3304791,
                33.9640947
              ],
              [
                47.3336814,
                33.9636933
              ],
              [
                47.3386381,
                33.9624189
              ],
              [
                47.3410643,
                33.9629317
              ],
              [
                47.343142,
                33.9627689
              ],
              [
                47.3465939,
                33.9619152
              ],
              [
                47.348001,
                33.96045
              ],
              [
                47.3526571,
                33.9572044
              ],
              [
                47.3581098,
                33.9547631
              ],
              [
                47.3691423,
                33.9505315
              ],
              [
                47.3715305,
                33.9487664
              ],
              [
                47.3731877,
                33.946201
              ],
              [
                47.3765331,
                33.9426555
              ],
              [
                47.3795043,
                33.9395527
              ],
              [
                47.3824711,
                33.9391127
              ],
              [
                47.3853922,
                33.9408508
              ],
              [
                47.3890235,
                33.9411189
              ],
              [
                47.3902911,
                33.9423288
              ],
              [
                47.3885393,
                33.9460523
              ],
              [
                47.3909445,
                33.9474609
              ],
              [
                47.3941737,
                33.9484303
              ],
              [
                47.3976269,
                33.9505547
              ],
              [
                47.4020165,
                33.9507483
              ],
              [
                47.4052584,
                33.9522074
              ],
              [
                47.4103898,
                33.9517217
              ],
              [
                47.4171934,
                33.9510371
              ],
              [
                47.4185833,
                33.9513169
              ],
              [
                47.4213599,
                33.9524271
              ],
              [
                47.4221927,
                33.9521474
              ],
              [
                47.4235834,
                33.9521473
              ],
              [
                47.4244163,
                33.9524271
              ],
              [
                47.4269163,
                33.9524271
              ],
              [
                47.4274733,
                33.9521473
              ],
              [
                47.429973,
                33.9521474
              ],
              [
                47.4308062,
                33.9518675
              ],
              [
                47.4371962,
                33.9510371
              ],
              [
                47.4383064,
                33.9504774
              ],
              [
                47.4524727,
                33.9460364
              ],
              [
                47.4544192,
                33.9454858
              ],
              [
                47.4549728,
                33.945206
              ],
              [
                47.455806,
                33.945206
              ],
              [
                47.4605291,
                33.9440957
              ],
              [
                47.4624725,
                33.9440957
              ],
              [
                47.4630291,
                33.943816
              ],
              [
                47.4652526,
                33.943816
              ],
              [
                47.4658092,
                33.9435362
              ],
              [
                47.4790056,
                33.9440778
              ],
              [
                47.4763886,
                33.9457699
              ],
              [
                47.4778568,
                33.9497446
              ],
              [
                47.4853074,
                33.9484928
              ],
              [
                47.4935471,
                33.9487776
              ],
              [
                47.4977185,
                33.9459581
              ],
              [
                47.4993836,
                33.9480656
              ],
              [
                47.4961221,
                33.9497744
              ],
              [
                47.4922253,
                33.9526508
              ],
              [
                47.4882605,
                33.9565067
              ],
              [
                47.4924754,
                33.964929
              ],
              [
                47.4974754,
                33.9718703
              ],
              [
                47.4983086,
                33.9729806
              ],
              [
                47.4985851,
                33.9757608
              ],
              [
                47.4983086,
                33.9763113
              ],
              [
                47.4980321,
                33.9771508
              ],
              [
                47.4960852,
                33.979651
              ],
              [
                47.4883088,
                33.9846516
              ],
              [
                47.4841423,
                33.9888128
              ],
              [
                47.4816422,
                33.9927031
              ],
              [
                47.481362,
                33.9999243
              ],
              [
                47.4813621,
                34.0018739
              ],
              [
                47.480809,
                34.003264
              ],
              [
                47.4791421,
                34.0038145
              ],
              [
                47.478862,
                34.0040943
              ],
              [
                47.4771956,
                34.0040943
              ],
              [
                47.4769187,
                34.0043742
              ],
              [
                47.4763619,
                34.0043741
              ],
              [
                47.4749756,
                34.006044
              ],
              [
                47.4730287,
                34.010485
              ],
              [
                47.4674755,
                34.0077048
              ],
              [
                47.4666423,
                34.0077048
              ],
              [
                47.4644192,
                34.0090948
              ],
              [
                47.4635856,
                34.0107647
              ],
              [
                47.4635855,
                34.0113153
              ],
              [
                47.4596955,
                34.020486
              ],
              [
                47.4583057,
                34.0221467
              ],
              [
                47.4496958,
                34.026037
              ],
              [
                47.4491392,
                34.0265967
              ],
              [
                47.4485859,
                34.0265967
              ],
              [
                47.4452492,
                34.0310376
              ],
              [
                47.4455292,
                34.0352076
              ],
              [
                47.4430291,
                34.0382675
              ],
              [
                47.4424725,
                34.0388181
              ],
              [
                47.4410826,
                34.0404789
              ],
              [
                47.4408057,
                34.0410385
              ],
              [
                47.4371958,
                34.046039
              ],
              [
                47.4360825,
                34.048819
              ],
              [
                47.4360825,
                34.0493787
              ],
              [
                47.4349727,
                34.05159
              ],
              [
                47.4327492,
                34.0546499
              ],
              [
                47.4324726,
                34.0554893
              ],
              [
                47.4263596,
                34.0604807
              ],
              [
                47.423583,
                34.0646507
              ],
              [
                47.4233056,
                34.0660407
              ],
              [
                47.423583,
                34.0682611
              ],
              [
                47.4255259,
                34.0746515
              ],
              [
                47.4241392,
                34.0763123
              ],
              [
                47.4266392,
                34.0843725
              ],
              [
                47.4280291,
                34.0871524
              ],
              [
                47.4281223,
                34.0874322
              ],
              [
                47.4288627,
                34.0888223
              ],
              [
                47.4291393,
                34.0896527
              ],
              [
                47.4319159,
                34.0963137
              ],
              [
                47.432196,
                34.0965936
              ],
              [
                47.4313624,
                34.0985432
              ],
              [
                47.4313623,
                34.1029839
              ],
              [
                47.4294157,
                34.1057639
              ],
              [
                47.4274728,
                34.1065942
              ],
              [
                47.4263594,
                34.106874
              ],
              [
                47.4066355,
                34.1232648
              ],
              [
                47.4013597,
                34.131045
              ],
              [
                47.3952494,
                34.1349351
              ],
              [
                47.394136,
                34.1354856
              ],
              [
                47.3935829,
                34.1360452
              ],
              [
                47.3927493,
                34.136325
              ],
              [
                47.3919164,
                34.1371554
              ],
              [
                47.3919165,
                34.1382656
              ],
              [
                47.391636,
                34.1385454
              ],
              [
                47.3944157,
                34.1421556
              ],
              [
                47.3952493,
                34.1421556
              ],
              [
                47.3952493,
                34.1424355
              ],
              [
                47.3960829,
                34.1424354
              ],
              [
                47.3966361,
                34.1421556
              ],
              [
                47.398583,
                34.1421556
              ],
              [
                47.4016361,
                34.1438164
              ],
              [
                47.4019158,
                34.148266
              ],
              [
                47.4013596,
                34.1493762
              ],
              [
                47.3988595,
                34.1499267
              ],
              [
                47.3916359,
                34.1454861
              ],
              [
                47.3894125,
                34.1454861
              ],
              [
                47.3866358,
                34.1485458
              ],
              [
                47.3860795,
                34.149656
              ],
              [
                47.3833029,
                34.1565966
              ],
              [
                47.3830264,
                34.1568764
              ],
              [
                47.3827459,
                34.1585462
              ],
              [
                47.3805263,
                34.1596564
              ],
              [
                47.3685799,
                34.1499266
              ],
              [
                47.3663565,
                34.1499267
              ],
              [
                47.3652464,
                34.1518762
              ],
              [
                47.3669128,
                34.1554864
              ],
              [
                47.3669127,
                34.1590967
              ],
              [
                47.3666362,
                34.1615968
              ],
              [
                47.3666361,
                34.1624362
              ],
              [
                47.3691363,
                34.1657666
              ],
              [
                47.3691362,
                34.1682667
              ],
              [
                47.3683025,
                34.1699364
              ],
              [
                47.3669127,
                34.1710466
              ],
              [
                47.3638564,
                34.1721567
              ],
              [
                47.3613563,
                34.1721567
              ],
              [
                47.3605227,
                34.1724274
              ],
              [
                47.3602462,
                34.1727072
              ],
              [
                47.3594134,
                34.1727073
              ],
              [
                47.3574696,
                34.174377
              ],
              [
                47.3552461,
                34.1752073
              ],
              [
                47.3535797,
                34.1752073
              ],
              [
                47.3524702,
                34.1752073
              ],
              [
                47.3494132,
                34.1743769
              ],
              [
                47.3465198,
                34.1774303
              ],
              [
                47.3486846,
                34.1804168
              ],
              [
                47.3502467,
                34.1815974
              ],
              [
                47.3510795,
                34.1829873
              ],
              [
                47.3513561,
                34.1840974
              ],
              [
                47.3480232,
                34.1874278
              ],
              [
                47.3466333,
                34.1902076
              ],
              [
                47.3482997,
                34.1929875
              ],
              [
                47.3510795,
                34.1921572
              ],
              [
                47.3530232,
                34.1921572
              ],
              [
                47.3546897,
                34.1935471
              ],
              [
                47.3549694,
                34.1963179
              ],
              [
                47.3535795,
                34.199928
              ],
              [
                47.3441332,
                34.2065978
              ],
              [
                47.3435801,
                34.2074281
              ],
              [
                47.3432996,
                34.2077079
              ],
              [
                47.345523,
                34.2121484
              ],
              [
                47.3457996,
                34.212717
              ],
              [
                47.3488567,
                34.2135473
              ],
              [
                47.3524701,
                34.2135473
              ],
              [
                47.360803,
                34.2118776
              ],
              [
                47.3610796,
                34.2115979
              ],
              [
                47.3627461,
                34.2115979
              ],
              [
                47.3630226,
                34.2113181
              ],
              [
                47.3641358,
                34.2113181
              ],
              [
                47.3674696,
                34.2135474
              ],
              [
                47.3680228,
                34.215208
              ],
              [
                47.3677462,
                34.2157676
              ],
              [
                47.3649695,
                34.2165979
              ],
              [
                47.3646898,
                34.2168777
              ],
              [
                47.3635796,
                34.2168778
              ],
              [
                47.3613562,
                34.2182676
              ],
              [
                47.360803,
                34.2193778
              ],
              [
                47.3608031,
                34.2196575
              ],
              [
                47.3663562,
                34.2243778
              ],
              [
                47.3685797,
                34.2293778
              ],
              [
                47.369136,
                34.2338272
              ],
              [
                47.369689,
                34.2354879
              ],
              [
                47.3733025,
                34.2382677
              ],
              [
                47.374136,
                34.2413272
              ],
              [
                47.372193,
                34.2438182
              ],
              [
                47.371636,
                34.244098
              ],
              [
                47.3705259,
                34.2463182
              ],
              [
                47.3702461,
                34.2471575
              ],
              [
                47.3716359,
                34.2499372
              ],
              [
                47.3727461,
                34.2507676
              ],
              [
                47.3791361,
                34.2554877
              ],
              [
                47.3813588,
                34.2565978
              ],
              [
                47.3819127,
                34.2571574
              ],
              [
                47.3838589,
                34.2577079
              ],
              [
                47.3877456,
                34.2593775
              ],
              [
                47.3880261,
                34.2596574
              ],
              [
                47.3910824,
                34.2596573
              ],
              [
                47.391359,
                34.2593776
              ],
              [
                47.3924691,
                34.2593776
              ],
              [
                47.3944154,
                34.2599372
              ],
              [
                47.400249,
                34.2665977
              ],
              [
                47.4016358,
                34.2665977
              ],
              [
                47.402192,
                34.2668775
              ],
              [
                47.402749,
                34.2668775
              ],
              [
                47.4030256,
                34.2665977
              ],
              [
                47.4035819,
                34.2668775
              ],
              [
                47.403951,
                34.2670639
              ],
              [
                47.4055256,
                34.2677079
              ],
              [
                47.4058022,
                34.2679876
              ],
              [
                47.4063585,
                34.2685471
              ],
              [
                47.4074686,
                34.273547
              ],
              [
                47.4060819,
                34.2768772
              ],
              [
                47.407192,
                34.2793772
              ],
              [
                47.4077491,
                34.2802166
              ],
              [
                47.413025,
                34.2835467
              ],
              [
                47.4138586,
                34.2835467
              ],
              [
                47.414139,
                34.2838265
              ],
              [
                47.4152484,
                34.2838265
              ],
              [
                47.4169149,
                34.2829962
              ],
              [
                47.4194149,
                34.2838265
              ],
              [
                47.4191383,
                34.2841063
              ],
              [
                47.4169149,
                34.286877
              ],
              [
                47.4163586,
                34.286877
              ],
              [
                47.4152485,
                34.2879871
              ],
              [
                47.4152485,
                34.2885466
              ],
              [
                47.4149719,
                34.2888264
              ],
              [
                47.416082,
                34.2910465
              ],
              [
                47.414139,
                34.2935464
              ],
              [
                47.4119155,
                34.2941061
              ],
              [
                47.4102483,
                34.2927162
              ],
              [
                47.4063584,
                34.2913263
              ],
              [
                47.4060818,
                34.2910465
              ],
              [
                47.405249,
                34.2918769
              ],
              [
                47.4044154,
                34.2932667
              ],
              [
                47.4044153,
                34.2935465
              ],
              [
                47.4033021,
                34.2954868
              ],
              [
                47.4030255,
                34.2963261
              ],
              [
                47.4044153,
                34.2991059
              ],
              [
                47.4069154,
                34.2991058
              ],
              [
                47.4085818,
                34.2999361
              ],
              [
                47.4085818,
                34.3016057
              ],
              [
                47.405249,
                34.3052157
              ],
              [
                47.403302,
                34.3091054
              ],
              [
                47.4038583,
                34.3127153
              ],
              [
                47.4083052,
                34.3163253
              ],
              [
                47.4099716,
                34.3163253
              ],
              [
                47.4105256,
                34.3160455
              ],
              [
                47.4116389,
                34.3160455
              ],
              [
                47.4119154,
                34.3157658
              ],
              [
                47.4135819,
                34.3157658
              ],
              [
                47.4144155,
                34.3160455
              ],
              [
                47.4152483,
                34.3160455
              ],
              [
                47.4163585,
                34.3171556
              ],
              [
                47.4163585,
                34.3179949
              ],
              [
                47.4113584,
                34.3221643
              ],
              [
                47.4099717,
                34.3241046
              ],
              [
                47.4138584,
                34.3274348
              ],
              [
                47.4149717,
                34.330774
              ],
              [
                47.4188585,
                34.3335447
              ],
              [
                47.420525,
                34.3335447
              ],
              [
                47.4208054,
                34.3338244
              ],
              [
                47.4216382,
                34.3338244
              ],
              [
                47.4221913,
                34.3341042
              ],
              [
                47.423025,
                34.3341042
              ],
              [
                47.4241384,
                34.3346547
              ],
              [
                47.4244149,
                34.3349344
              ],
              [
                47.4258047,
                34.3360445
              ],
              [
                47.4263586,
                34.3363243
              ],
              [
                47.4266383,
                34.3368838
              ],
              [
                47.4266383,
                34.3371636
              ],
              [
                47.4224718,
                34.3374343
              ],
              [
                47.4216382,
                34.3371635
              ],
              [
                47.4196913,
                34.3371635
              ],
              [
                47.4194148,
                34.3368838
              ],
              [
                47.4180248,
                34.3368838
              ],
              [
                47.4174717,
                34.3371635
              ],
              [
                47.4133053,
                34.3371636
              ],
              [
                47.4105255,
                34.3374343
              ],
              [
                47.4099716,
                34.337714
              ],
              [
                47.4077489,
                34.337714
              ],
              [
                47.3816358,
                34.3421542
              ],
              [
                47.3785787,
                34.3421541
              ],
              [
                47.3774686,
                34.3424339
              ],
              [
                47.3694121,
                34.3424339
              ],
              [
                47.3685793,
                34.3427136
              ],
              [
                47.3638558,
                34.3427136
              ],
              [
                47.3630221,
                34.3429934
              ],
              [
                47.3610791,
                34.3429933
              ],
              [
                47.3602455,
                34.3432731
              ],
              [
                47.3591361,
                34.3432731
              ],
              [
                47.3355224,
                34.3507726
              ],
              [
                47.3349661,
                34.3518826
              ],
              [
                47.334966,
                34.3571621
              ],
              [
                47.3349661,
                34.3588226
              ],
              [
                47.3346896,
                34.3591023
              ],
              [
                47.3344129,
                34.3618819
              ],
              [
                47.3341325,
                34.3657715
              ],
              [
                47.3338559,
                34.3685511
              ],
              [
                47.3335793,
                34.3699319
              ],
              [
                47.3332996,
                34.3716014
              ],
              [
                47.333023,
                34.3732709
              ],
              [
                47.3327425,
                34.3746607
              ],
              [
                47.332466,
                34.376601
              ],
              [
                47.3321893,
                34.3785503
              ],
              [
                47.3319089,
                34.379931
              ],
              [
                47.3316323,
                34.3816006
              ],
              [
                47.3313557,
                34.3835498
              ],
              [
                47.331076,
                34.3852104
              ],
              [
                47.3305229,
                34.3879899
              ],
              [
                47.3302425,
                34.3893797
              ],
              [
                47.3299659,
                34.3910492
              ],
              [
                47.3296893,
                34.3921592
              ],
              [
                47.3294095,
                34.3929984
              ],
              [
                47.3282994,
                34.3974385
              ],
              [
                47.3282994,
                34.3982687
              ],
              [
                47.3274657,
                34.3999383
              ],
              [
                47.3274658,
                34.400218
              ],
              [
                47.3266329,
                34.402438
              ],
              [
                47.3196889,
                34.4154962
              ],
              [
                47.313856,
                34.4221562
              ],
              [
                47.3071864,
                34.4263253
              ],
              [
                47.3005199,
                34.4282656
              ],
              [
                47.2999659,
                34.4285453
              ],
              [
                47.298576,
                34.4285453
              ],
              [
                47.2960759,
                34.4291049
              ],
              [
                47.2930196,
                34.4291048
              ],
              [
                47.2924626,
                34.4293846
              ],
              [
                47.2871867,
                34.4293846
              ],
              [
                47.2863531,
                34.4291048
              ],
              [
                47.28191,
                34.4291048
              ],
              [
                47.2816295,
                34.428825
              ],
              [
                47.2752395,
                34.428825
              ],
              [
                47.2746864,
                34.4285453
              ],
              [
                47.2702394,
                34.4285452
              ],
              [
                47.2699629,
                34.4282655
              ],
              [
                47.26802,
                34.4282654
              ],
              [
                47.2663535,
                34.4279947
              ],
              [
                47.2657965,
                34.427715
              ],
              [
                47.2646871,
                34.427715
              ],
              [
                47.26163,
                34.4268847
              ],
              [
                47.2605198,
                34.4268848
              ],
              [
                47.2599635,
                34.426605
              ],
              [
                47.2585737,
                34.426605
              ],
              [
                47.2580198,
                34.4263252
              ],
              [
                47.2555166,
                34.4263252
              ],
              [
                47.2549635,
                34.4260455
              ],
              [
                47.2510734,
                34.4260455
              ],
              [
                47.2477398,
                34.425495
              ],
              [
                47.2463499,
                34.4249354
              ],
              [
                47.2452406,
                34.4246647
              ],
              [
                47.246907,
                34.426605
              ],
              [
                47.246907,
                34.4271645
              ],
              [
                47.2469069,
                34.4274352
              ],
              [
                47.2480171,
                34.4577113
              ],
              [
                47.2482967,
                34.460211
              ],
              [
                47.2485733,
                34.4607705
              ],
              [
                47.2482967,
                34.4635499
              ],
              [
                47.2485733,
                34.467719
              ],
              [
                47.2510734,
                34.4746585
              ],
              [
                47.2516304,
                34.4763279
              ],
              [
                47.2538499,
                34.5054932
              ],
              [
                47.2535733,
                34.505773
              ],
              [
                47.2546834,
                34.5166016
              ],
              [
                47.2541295,
                34.5193809
              ],
              [
                47.2538497,
                34.5199403
              ],
              [
                47.2535732,
                34.5221602
              ],
              [
                47.2516302,
                34.5282692
              ],
              [
                47.2516301,
                34.528549
              ],
              [
                47.251073,
                34.5293881
              ],
              [
                47.2499629,
                34.5310486
              ],
              [
                47.249963,
                34.5313282
              ],
              [
                47.2444066,
                34.5366071
              ],
              [
                47.2432963,
                34.5371576
              ],
              [
                47.2410729,
                34.5393863
              ],
              [
                47.2291265,
                34.5477152
              ],
              [
                47.2130168,
                34.5538331
              ],
              [
                47.2107932,
                34.5538331
              ],
              [
                47.2096839,
                34.5541038
              ],
              [
                47.2094035,
                34.5543835
              ],
              [
                47.2060705,
                34.5543835
              ],
              [
                47.2030173,
                34.5543835
              ],
              [
                47.2021837,
                34.5543836
              ],
              [
                47.2019032,
                34.5546632
              ],
              [
                47.199404,
                34.5546632
              ],
              [
                47.1991267,
                34.554943
              ],
              [
                47.1977368,
                34.554943
              ],
              [
                47.1949602,
                34.5557731
              ],
              [
                47.1935702,
                34.5557731
              ],
              [
                47.1844036,
                34.5582726
              ],
              [
                47.1841271,
                34.5585524
              ],
              [
                47.1830138,
                34.5585523
              ],
              [
                47.1813473,
                34.5593825
              ],
              [
                47.1802371,
                34.5596623
              ],
              [
                47.1730136,
                34.5655004
              ],
              [
                47.1719042,
                34.5677202
              ],
              [
                47.1610672,
                34.5782686
              ],
              [
                47.1594007,
                34.578828
              ],
              [
                47.1591241,
                34.5791077
              ],
              [
                47.158014,
                34.5791078
              ],
              [
                47.1574577,
                34.5793875
              ],
              [
                47.1557905,
                34.5793875
              ],
              [
                47.1552342,
                34.5796672
              ],
              [
                47.1535678,
                34.5796672
              ],
              [
                47.1532904,
                34.5793874
              ],
              [
                47.1521811,
                34.5793875
              ],
              [
                47.1463473,
                34.5771677
              ],
              [
                47.1446809,
                34.5760578
              ],
              [
                47.1249547,
                34.5693894
              ],
              [
                47.1246782,
                34.5691097
              ],
              [
                47.123568,
                34.5691097
              ],
              [
                47.1232875,
                34.5688299
              ],
              [
                47.1194015,
                34.56883
              ],
              [
                47.1188444,
                34.5691097
              ],
              [
                47.1180117,
                34.5691096
              ],
              [
                47.1174546,
                34.5693895
              ],
              [
                47.1169015,
                34.5693893
              ],
              [
                47.1157881,
                34.5696601
              ],
              [
                47.1155116,
                34.5699399
              ],
              [
                47.1155116,
                34.5727191
              ],
              [
                47.1238445,
                34.5816072
              ],
              [
                47.1238445,
                34.5818869
              ],
              [
                47.1263446,
                34.5838269
              ],
              [
                47.128011,
                34.5852255
              ],
              [
                47.1419011,
                34.5932744
              ],
              [
                47.1513473,
                34.5957739
              ],
              [
                47.1524576,
                34.5957739
              ],
              [
                47.1530137,
                34.5960536
              ],
              [
                47.1549576,
                34.5960536
              ],
              [
                47.156624,
                34.5963243
              ],
              [
                47.1574576,
                34.596604
              ],
              [
                47.159957,
                34.5966041
              ],
              [
                47.1649571,
                34.5993922
              ],
              [
                47.1716235,
                34.6077207
              ],
              [
                47.1724572,
                34.6093901
              ],
              [
                47.1741235,
                34.6218873
              ],
              [
                47.1760705,
                34.6282757
              ],
              [
                47.18718,
                34.6410523
              ],
              [
                47.19607,
                34.6477204
              ],
              [
                47.1982934,
                34.6493896
              ],
              [
                47.2116265,
                34.6607766
              ],
              [
                47.2138499,
                34.6641152
              ],
              [
                47.2263494,
                34.6796616
              ],
              [
                47.2266259,
                34.680221
              ],
              [
                47.2344058,
                34.6821609
              ],
              [
                47.2352394,
                34.682161
              ],
              [
                47.2413497,
                34.6818902
              ],
              [
                47.241906,
                34.6816105
              ],
              [
                47.2516296,
                34.6816105
              ],
              [
                47.2519062,
                34.6818902
              ],
              [
                47.2541288,
                34.6818903
              ],
              [
                47.2549625,
                34.682161
              ],
              [
                47.2552391,
                34.6818903
              ],
              [
                47.259686,
                34.682161
              ],
              [
                47.2602391,
                34.6824407
              ],
              [
                47.2619056,
                34.6824407
              ],
              [
                47.2638525,
                34.6830001
              ],
              [
                47.2649627,
                34.6830001
              ],
              [
                47.2657955,
                34.6832798
              ],
              [
                47.2660721,
                34.6830001
              ],
              [
                47.2721855,
                34.6835505
              ],
              [
                47.272462,
                34.6838302
              ],
              [
                47.2794091,
                34.6838303
              ],
              [
                47.2796856,
                34.68411
              ],
              [
                47.2816286,
                34.68411
              ],
              [
                47.2816286,
                34.6843897
              ],
              [
                47.2849623,
                34.6849401
              ],
              [
                47.2863521,
                34.6854994
              ],
              [
                47.2871857,
                34.6854994
              ],
              [
                47.2874623,
                34.6857792
              ],
              [
                47.2860755,
                34.6874484
              ],
              [
                47.2757957,
                34.695226
              ],
              [
                47.2705189,
                34.6977252
              ],
              [
                47.2694056,
                34.6977253
              ],
              [
                47.2691291,
                34.6980049
              ],
              [
                47.2680189,
                34.698005
              ],
              [
                47.2663525,
                34.6982846
              ],
              [
                47.2616289,
                34.6982846
              ],
              [
                47.257182,
                34.6985553
              ],
              [
                47.2566289,
                34.698835
              ],
              [
                47.2544061,
                34.698835
              ],
              [
                47.2538492,
                34.6991147
              ],
              [
                47.2524623,
                34.6991147
              ],
              [
                47.2519061,
                34.6993944
              ],
              [
                47.2505154,
                34.6993944
              ],
              [
                47.2494061,
                34.6996651
              ],
              [
                47.248849,
                34.6999448
              ],
              [
                47.2477388,
                34.6999448
              ],
              [
                47.2471826,
                34.7002245
              ],
              [
                47.2449622,
                34.7002245
              ],
              [
                47.2444059,
                34.7005042
              ],
              [
                47.2416293,
                34.7005042
              ],
              [
                47.2407957,
                34.7007838
              ],
              [
                47.2363495,
                34.7007838
              ],
              [
                47.2357924,
                34.7005042
              ],
              [
                47.2346823,
                34.7007838
              ],
              [
                47.2344057,
                34.7005042
              ],
              [
                47.2310728,
                34.7010545
              ],
              [
                47.2249595,
                34.705223
              ],
              [
                47.2246829,
                34.7057824
              ],
              [
                47.2238492,
                34.7066125
              ],
              [
                47.1860694,
                34.7388319
              ],
              [
                47.1838467,
                34.7402214
              ],
              [
                47.1510671,
                34.758275
              ],
              [
                47.1474568,
                34.761893
              ],
              [
                47.1446801,
                34.7693906
              ],
              [
                47.144124,
                34.77078
              ],
              [
                47.1438434,
                34.7732791
              ],
              [
                47.1435668,
                34.7746686
              ],
              [
                47.1435668,
                34.7816156
              ],
              [
                47.1343639,
                34.7849858
              ],
              [
                47.1333968,
                34.7870027
              ],
              [
                47.1342145,
                34.7885876
              ],
              [
                47.133814,
                34.7906954
              ],
              [
                47.133814,
                34.7923804
              ],
              [
                47.1338344,
                34.7961675
              ],
              [
                47.1324874,
                34.7982923
              ],
              [
                47.1318948,
                34.7979817
              ],
              [
                47.1288631,
                34.7968412
              ],
              [
                47.1259326,
                34.7966248
              ],
              [
                47.1236596,
                34.7959226
              ],
              [
                47.1215272,
                34.7952005
              ],
              [
                47.119521,
                34.7946258
              ],
              [
                47.1169516,
                34.7950976
              ],
              [
                47.1140243,
                34.7966004
              ],
              [
                47.1126957,
                34.7979418
              ],
              [
                47.110435,
                34.7989284
              ],
              [
                47.1053706,
                34.7990287
              ],
              [
                47.1004057,
                34.8010829
              ],
              [
                47.0976922,
                34.7990573
              ],
              [
                47.0942154,
                34.7981785
              ],
              [
                47.0911502,
                34.7972975
              ],
              [
                47.0878598,
                34.7969269
              ],
              [
                47.0847201,
                34.7965897
              ],
              [
                47.0794351,
                34.795971
              ],
              [
                47.0750212,
                34.7957707
              ],
              [
                47.0709073,
                34.7954652
              ],
              [
                47.0688021,
                34.7950582
              ],
              [
                47.0660778,
                34.7944048
              ],
              [
                47.0636734,
                34.7935037
              ],
              [
                47.0581939,
                34.7913042
              ],
              [
                47.059483,
                34.789542
              ],
              [
                47.0604647,
                34.7866327
              ],
              [
                47.0627208,
                34.7841688
              ],
              [
                47.0635628,
                34.7828445
              ],
              [
                47.0633268,
                34.7817165
              ],
              [
                47.0623797,
                34.7804562
              ],
              [
                47.0598805,
                34.7790464
              ],
              [
                47.0559006,
                34.7780289
              ],
              [
                47.0524263,
                34.7769403
              ],
              [
                47.0489747,
                34.774962
              ],
              [
                47.046682,
                34.7710163
              ],
              [
                47.0456944,
                34.769548
              ],
              [
                47.0451307,
                34.7679512
              ],
              [
                47.045648,
                34.7658906
              ],
              [
                47.0446372,
                34.7641084
              ],
              [
                47.0431995,
                34.7626629
              ],
              [
                47.0431566,
                34.7618168
              ],
              [
                47.0448518,
                34.7610412
              ],
              [
                47.0480275,
                34.7601069
              ],
              [
                47.0502591,
                34.7594722
              ],
              [
                47.05307,
                34.7583264
              ],
              [
                47.0549369,
                34.7560522
              ],
              [
                47.0548939,
                34.755065
              ],
              [
                47.0541644,
                34.7539896
              ],
              [
                47.0515251,
                34.7507809
              ],
              [
                47.0504093,
                34.7500051
              ],
              [
                47.042986,
                34.7476042
              ],
              [
                47.0371055,
                34.7495996
              ],
              [
                47.0363545,
                34.7500933
              ],
              [
                47.0296746,
                34.752086
              ],
              [
                47.0262448,
                34.7537631
              ],
              [
                47.0200124,
                34.7533135
              ],
              [
                47.0164697,
                34.7540265
              ],
              [
                47.0144676,
                34.7550511
              ],
              [
                47.0111285,
                34.7557118
              ],
              [
                47.0071727,
                34.7575501
              ],
              [
                47.0035211,
                34.7606258
              ],
              [
                46.9998194,
                34.7627932
              ],
              [
                46.991447,
                34.7656532
              ],
              [
                46.9775399,
                34.7645426
              ],
              [
                46.9699352,
                34.7644071
              ],
              [
                46.9613492,
                34.766137
              ],
              [
                46.948591,
                34.7694309
              ],
              [
                46.9439765,
                34.7661362
              ],
              [
                46.9440381,
                34.7640098
              ],
              [
                46.9436283,
                34.7598415
              ],
              [
                46.9420588,
                34.757378
              ],
              [
                46.9333015,
                34.7546801
              ],
              [
                46.9268807,
                34.7545217
              ],
              [
                46.9215258,
                34.7566486
              ],
              [
                46.9153496,
                34.7592081
              ],
              [
                46.9096899,
                34.7614819
              ],
              [
                46.9036182,
                34.7636315
              ],
              [
                46.9006733,
                34.7647073
              ],
              [
                46.8920458,
                34.7657144
              ],
              [
                46.8825377,
                34.7628057
              ],
              [
                46.8807989,
                34.7613978
              ],
              [
                46.8760409,
                34.7609395
              ],
              [
                46.8695424,
                34.7595406
              ],
              [
                46.8593869,
                34.7555045
              ],
              [
                46.8545436,
                34.7535665
              ],
              [
                46.846242,
                34.7508053
              ],
              [
                46.8350263,
                34.7497122
              ],
              [
                46.8240737,
                34.7457737
              ],
              [
                46.8134737,
                34.7427057
              ],
              [
                46.7879819,
                34.7365695
              ],
              [
                46.7872969,
                34.7369983
              ],
              [
                46.7870051,
                34.7291275
              ],
              [
                46.7859577,
                34.7151566
              ],
              [
                46.787238,
                34.7124726
              ],
              [
                46.7941903,
                34.7094175
              ],
              [
                46.7947215,
                34.7076365
              ],
              [
                46.7629953,
                34.6843882
              ],
              [
                46.7632719,
                34.6827191
              ],
              [
                46.7635485,
                34.6824394
              ],
              [
                46.7635485,
                34.6821597
              ],
              [
                46.7632719,
                34.681889
              ],
              [
                46.7629953,
                34.6793897
              ],
              [
                46.7632719,
                34.6780002
              ],
              [
                46.7677189,
                34.6652238
              ],
              [
                46.7766051,
                34.6502186
              ],
              [
                46.778552,
                34.6482787
              ],
              [
                46.778552,
                34.6477193
              ],
              [
                46.7904953,
                34.634663
              ],
              [
                46.792718,
                34.6321636
              ],
              [
                46.8104982,
                34.616328
              ],
              [
                46.8107747,
                34.6154979
              ],
              [
                46.8124419,
                34.6132691
              ],
              [
                46.8154983,
                34.601602
              ],
              [
                46.8157748,
                34.6013313
              ],
              [
                46.8149413,
                34.5896642
              ],
              [
                46.811885,
                34.5838261
              ],
              [
                46.8096655,
                34.5816064
              ],
              [
                46.809385,
                34.5810559
              ],
              [
                46.7988286,
                34.571888
              ],
              [
                46.7974418,
                34.5713286
              ],
              [
                46.7910518,
                34.5660499
              ],
              [
                46.7904956,
                34.5624404
              ],
              [
                46.7918854,
                34.5602207
              ],
              [
                46.7929956,
                34.5593815
              ],
              [
                46.8102188,
                34.5543825
              ],
              [
                46.8121648,
                34.5538321
              ],
              [
                46.8179986,
                34.5510529
              ],
              [
                46.8224416,
                34.5452146
              ],
              [
                46.8227182,
                34.5443844
              ],
              [
                46.8229987,
                34.5441047
              ],
              [
                46.823555,
                34.5424443
              ],
              [
                46.8224416,
                34.5382754
              ],
              [
                46.817165,
                34.5352164
              ],
              [
                46.8163322,
                34.5352164
              ],
              [
                46.8160517,
                34.5349366
              ],
              [
                46.8115862,
                34.5343763
              ],
              [
                46.8007769,
                34.5329511
              ],
              [
                46.7980975,
                34.5321943
              ],
              [
                46.797087,
                34.5318285
              ],
              [
                46.7965818,
                34.5315763
              ],
              [
                46.7960153,
                34.531551
              ],
              [
                46.79606,
                34.5304243
              ],
              [
                46.7959286,
                34.5287994
              ],
              [
                46.795495,
                34.5282681
              ],
              [
                46.7932754,
                34.5274378
              ],
              [
                46.7921621,
                34.5274379
              ],
              [
                46.791052,
                34.5268874
              ],
              [
                46.7899418,
                34.5268874
              ],
              [
                46.7866089,
                34.5260482
              ],
              [
                46.785219,
                34.5260482
              ],
              [
                46.7843854,
                34.5257684
              ],
              [
                46.7824386,
                34.5254978
              ],
              [
                46.776886,
                34.5254978
              ],
              [
                46.776329,
                34.5252181
              ],
              [
                46.7727188,
                34.525218
              ],
              [
                46.7724392,
                34.5249382
              ],
              [
                46.7702187,
                34.5249382
              ],
              [
                46.7696625,
                34.5246585
              ],
              [
                46.7627154,
                34.5238283
              ],
              [
                46.7596623,
                34.5238283
              ],
              [
                46.7593826,
                34.524108
              ],
              [
                46.758549,
                34.524108
              ],
              [
                46.7568825,
                34.5252179
              ],
              [
                46.7568826,
                34.5254977
              ],
              [
                46.756606,
                34.5274378
              ],
              [
                46.7554958,
                34.5293869
              ],
              [
                46.7518825,
                34.5329964
              ],
              [
                46.7435494,
                34.5360553
              ],
              [
                46.7417227,
                34.5357167
              ],
              [
                46.7409012,
                34.5357548
              ],
              [
                46.738258,
                34.5358774
              ],
              [
                46.7364136,
                34.5359629
              ],
              [
                46.7338134,
                34.5371828
              ],
              [
                46.7311992,
                34.5391389
              ],
              [
                46.7297849,
                34.5413977
              ],
              [
                46.727071,
                34.5411642
              ],
              [
                46.7203682,
                34.5418915
              ],
              [
                46.7167834,
                34.5419014
              ],
              [
                46.701895,
                34.5419416
              ],
              [
                46.6907979,
                34.5423795
              ],
              [
                46.6855438,
                34.5433732
              ],
              [
                46.6835253,
                34.5437549
              ],
              [
                46.6676948,
                34.5437382
              ],
              [
                46.6587389,
                34.5424775
              ],
              [
                46.6539898,
                34.543086
              ],
              [
                46.6499219,
                34.5436071
              ],
              [
                46.6450983,
                34.5442249
              ],
              [
                46.6436645,
                34.5454275
              ],
              [
                46.6422966,
                34.5465748
              ],
              [
                46.6390749,
                34.5470835
              ],
              [
                46.6375372,
                34.5489906
              ],
              [
                46.6345633,
                34.5526789
              ],
              [
                46.6335879,
                34.557196
              ],
              [
                46.6325162,
                34.5621587
              ],
              [
                46.6299832,
                34.5653176
              ],
              [
                46.6200299,
                34.5635866
              ],
              [
                46.6138306,
                34.5625081
              ],
              [
                46.6054638,
                34.5642773
              ],
              [
                46.5943145,
                34.5649599
              ],
              [
                46.5922408,
                34.5650867
              ],
              [
                46.5818471,
                34.565722
              ],
              [
                46.5464488,
                34.5802279
              ],
              [
                46.4993316,
                34.5972639
              ],
              [
                46.473661,
                34.608448
              ],
              [
                46.4523981,
                34.6207166
              ],
              [
                46.4513126,
                34.6204958
              ],
              [
                46.4471461,
                34.6188264
              ],
              [
                46.4446461,
                34.6174369
              ],
              [
                46.4327029,
                34.6066089
              ],
              [
                46.4324232,
                34.6063292
              ],
              [
                46.4318693,
                34.6060495
              ],
              [
                46.4241227,
                34.6026695
              ],
              [
                46.4165958,
                34.5995435
              ],
              [
                46.4136651,
                34.5983262
              ],
              [
                46.41336,
                34.5982714
              ],
              [
                46.4109869,
                34.5978447
              ],
              [
                46.4087422,
                34.5974412
              ],
              [
                46.4075554,
                34.5972278
              ],
              [
                46.4071867,
                34.5971615
              ],
              [
                46.4060388,
                34.596937
              ],
              [
                46.4057563,
                34.5968817
              ],
              [
                46.4055712,
                34.5967574
              ],
              [
                46.3985252,
                34.5940513
              ],
              [
                46.3954367,
                34.5928649
              ],
              [
                46.3928629,
                34.5927107
              ],
              [
                46.3840653,
                34.5921831
              ],
              [
                46.3840761,
                34.5916031
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555176,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کنگاور",
          "name:en": "Kangavar County",
          "name:ku": "Kengawer",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289742",
          "wikipedia": "en:Kangavar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.7358169,
                34.5738304
              ],
              [
                47.7355404,
                34.5735507
              ],
              [
                47.7349837,
                34.5730003
              ],
              [
                47.7210939,
                34.5621631
              ],
              [
                47.7155407,
                34.5543847
              ],
              [
                47.7152606,
                34.5532749
              ],
              [
                47.7152607,
                34.5499452
              ],
              [
                47.7158173,
                34.5485555
              ],
              [
                47.7158174,
                34.5474366
              ],
              [
                47.7191506,
                34.542997
              ],
              [
                47.7199839,
                34.5421668
              ],
              [
                47.7319306,
                34.5324393
              ],
              [
                47.7488737,
                34.5110531
              ],
              [
                47.7494303,
                34.509113
              ],
              [
                47.7502639,
                34.5074346
              ],
              [
                47.7502639,
                34.5071638
              ],
              [
                47.7505405,
                34.5066134
              ],
              [
                47.7508205,
                34.5057742
              ],
              [
                47.7510971,
                34.5054945
              ],
              [
                47.7510971,
                34.5052147
              ],
              [
                47.7510971,
                34.504935
              ],
              [
                47.7513737,
                34.5046642
              ],
              [
                47.752487,
                34.5016052
              ],
              [
                47.7530401,
                34.5004952
              ],
              [
                47.7552637,
                34.4971654
              ],
              [
                47.7560968,
                34.496606
              ],
              [
                47.7630403,
                34.486048
              ],
              [
                47.7705437,
                34.4777189
              ],
              [
                47.7908199,
                34.463831
              ],
              [
                47.7922099,
                34.4632715
              ],
              [
                47.7997099,
                34.459382
              ],
              [
                47.801653,
                34.4588316
              ],
              [
                47.8022101,
                34.4588316
              ],
              [
                47.8044331,
                34.4577127
              ],
              [
                47.8063765,
                34.4571622
              ],
              [
                47.8069332,
                34.4571622
              ],
              [
                47.8074898,
                34.4568825
              ],
              [
                47.8088765,
                34.4568824
              ],
              [
                47.8091566,
                34.4571622
              ],
              [
                47.8110996,
                34.4571622
              ],
              [
                47.8119329,
                34.457442
              ],
              [
                47.8163763,
                34.457442
              ],
              [
                47.816933,
                34.4571622
              ],
              [
                47.8180432,
                34.4571622
              ],
              [
                47.8185998,
                34.4568824
              ],
              [
                47.8288797,
                34.4541031
              ],
              [
                47.8294329,
                34.4535526
              ],
              [
                47.8299895,
                34.4535526
              ],
              [
                47.8302661,
                34.4529931
              ],
              [
                47.8344329,
                34.4499429
              ],
              [
                47.8352662,
                34.4482735
              ],
              [
                47.8352662,
                34.4479937
              ],
              [
                47.8352662,
                34.4474433
              ],
              [
                47.8358229,
                34.4463242
              ],
              [
                47.8355463,
                34.4449346
              ],
              [
                47.8355463,
                34.4446639
              ],
              [
                47.8349896,
                34.4427146
              ],
              [
                47.8308228,
                34.4396645
              ],
              [
                47.829713,
                34.4396644
              ],
              [
                47.8294329,
                34.4393846
              ],
              [
                47.8283231,
                34.4393847
              ],
              [
                47.8280461,
                34.4391049
              ],
              [
                47.8258231,
                34.4391049
              ],
              [
                47.8252664,
                34.4388252
              ],
              [
                47.8227664,
                34.4388251
              ],
              [
                47.8222097,
                34.4391049
              ],
              [
                47.8183229,
                34.4391049
              ],
              [
                47.8177662,
                34.4388252
              ],
              [
                47.8144329,
                34.4388251
              ],
              [
                47.8138763,
                34.4385454
              ],
              [
                47.8116564,
                34.4385454
              ],
              [
                47.8044332,
                34.434665
              ],
              [
                47.8038766,
                34.4341055
              ],
              [
                47.8030433,
                34.4329955
              ],
              [
                47.801653,
                34.4307755
              ],
              [
                47.8013765,
                34.4274365
              ],
              [
                47.8016531,
                34.4263266
              ],
              [
                47.8019332,
                34.4241066
              ],
              [
                47.8130433,
                34.3943804
              ],
              [
                47.8130432,
                34.3938208
              ],
              [
                47.8133233,
                34.3927198
              ],
              [
                47.8147097,
                34.3885505
              ],
              [
                47.8127667,
                34.3849317
              ],
              [
                47.8066569,
                34.3796615
              ],
              [
                47.7958203,
                34.3768819
              ],
              [
                47.7930437,
                34.3768818
              ],
              [
                47.7913769,
                34.3766021
              ],
              [
                47.7905436,
                34.3768819
              ],
              [
                47.7897104,
                34.3766021
              ],
              [
                47.7869338,
                34.3766021
              ],
              [
                47.7769305,
                34.374382
              ],
              [
                47.7713773,
                34.3718822
              ],
              [
                47.7691538,
                34.3707722
              ],
              [
                47.7647072,
                34.3638323
              ],
              [
                47.7644307,
                34.3627132
              ],
              [
                47.7635974,
                34.3596539
              ],
              [
                47.7630409,
                34.354934
              ],
              [
                47.7652639,
                34.3535442
              ],
              [
                47.7658206,
                34.3535442
              ],
              [
                47.7660971,
                34.3532645
              ],
              [
                47.780544,
                34.3429944
              ],
              [
                47.784987,
                34.3407652
              ],
              [
                47.7966536,
                34.3366049
              ],
              [
                47.8049901,
                34.3346556
              ],
              [
                47.8091571,
                34.3335455
              ],
              [
                47.8280466,
                34.3238259
              ],
              [
                47.8330467,
                34.3188262
              ],
              [
                47.8380464,
                34.3038268
              ],
              [
                47.8391566,
                34.2996573
              ],
              [
                47.8391566,
                34.2991068
              ],
              [
                47.8461034,
                34.283268
              ],
              [
                47.8461033,
                34.2824377
              ],
              [
                47.8472131,
                34.2799378
              ],
              [
                47.8477697,
                34.279658
              ],
              [
                47.8483233,
                34.2785479
              ],
              [
                47.8522132,
                34.2746581
              ],
              [
                47.874713,
                34.2635483
              ],
              [
                47.8863827,
                34.2554889
              ],
              [
                47.8866593,
                34.2552092
              ],
              [
                47.8877695,
                34.2618787
              ],
              [
                47.8916594,
                34.2677089
              ],
              [
                47.8916594,
                34.2679887
              ],
              [
                47.8927691,
                34.2679887
              ],
              [
                47.901106,
                34.2732683
              ],
              [
                47.9066592,
                34.2813278
              ],
              [
                47.9138824,
                34.295488
              ],
              [
                47.9138824,
                34.2957678
              ],
              [
                47.916659,
                34.2977172
              ],
              [
                47.9408286,
                34.3196567
              ],
              [
                47.9452719,
                34.3268856
              ],
              [
                47.9502716,
                34.3393759
              ],
              [
                47.9524951,
                34.3454946
              ],
              [
                47.9633281,
                34.3552142
              ],
              [
                47.9777745,
                34.3593836
              ],
              [
                47.9783315,
                34.3596544
              ],
              [
                47.9936287,
                34.364661
              ],
              [
                47.9886078,
                34.3979905
              ],
              [
                47.989441,
                34.4010498
              ],
              [
                47.989713,
                34.4013069
              ],
              [
                47.9901187,
                34.4015108
              ],
              [
                47.9905181,
                34.4017389
              ],
              [
                47.9985594,
                34.4014534
              ],
              [
                48.0013878,
                34.4013296
              ],
              [
                48.0130539,
                34.3988299
              ],
              [
                48.0136107,
                34.3985502
              ],
              [
                48.0144442,
                34.3985501
              ],
              [
                48.0149973,
                34.3982704
              ],
              [
                48.0166642,
                34.3982703
              ],
              [
                48.0172209,
                34.3982703
              ],
              [
                48.0186107,
                34.3974401
              ],
              [
                48.019444,
                34.3968806
              ],
              [
                48.0344439,
                34.3907711
              ],
              [
                48.0402772,
                34.3899408
              ],
              [
                48.0408339,
                34.3896611
              ],
              [
                48.0444438,
                34.3896611
              ],
              [
                48.0444437,
                34.3899409
              ],
              [
                48.0458336,
                34.3899408
              ],
              [
                48.047777,
                34.3907711
              ],
              [
                48.0555568,
                34.3985502
              ],
              [
                48.0558337,
                34.39883
              ],
              [
                48.0572236,
                34.4016094
              ],
              [
                48.06111,
                34.4085492
              ],
              [
                48.07389,
                34.4129982
              ],
              [
                48.0744466,
                34.4132781
              ],
              [
                48.0758333,
                34.413278
              ],
              [
                48.0802799,
                34.414379
              ],
              [
                48.0836131,
                34.4160485
              ],
              [
                48.0858332,
                34.4182685
              ],
              [
                48.0905563,
                34.4321569
              ],
              [
                48.0905562,
                34.4329962
              ],
              [
                48.0913899,
                34.4338263
              ],
              [
                48.0913899,
                34.4341061
              ],
              [
                48.0919465,
                34.4346656
              ],
              [
                48.0933363,
                34.4432747
              ],
              [
                48.0938894,
                34.4457744
              ],
              [
                48.0958363,
                34.4507737
              ],
              [
                48.0991696,
                34.4546632
              ],
              [
                48.1050029,
                34.4674413
              ],
              [
                48.1036127,
                34.4710509
              ],
              [
                48.103336,
                34.4713306
              ],
              [
                48.1025029,
                34.4732799
              ],
              [
                48.0975028,
                34.4791093
              ],
              [
                48.0908361,
                34.492167
              ],
              [
                48.090556,
                34.4935566
              ],
              [
                48.0913896,
                34.4985559
              ],
              [
                48.0988894,
                34.5104944
              ],
              [
                48.1013894,
                34.5210523
              ],
              [
                48.1013894,
                34.5257717
              ],
              [
                48.1013894,
                34.5296699
              ],
              [
                48.1008358,
                34.5307708
              ],
              [
                48.0977791,
                34.5382785
              ],
              [
                48.0849994,
                34.5502258
              ],
              [
                48.0833326,
                34.554945
              ],
              [
                48.0872225,
                34.571052
              ],
              [
                48.0863893,
                34.5743817
              ],
              [
                48.0855561,
                34.57606
              ],
              [
                48.0686096,
                34.5946662
              ],
              [
                48.0686095,
                34.5949459
              ],
              [
                48.0681225,
                34.5954303
              ],
              [
                48.0527764,
                34.6160603
              ],
              [
                48.0516662,
                34.6180003
              ],
              [
                48.0497196,
                34.6204997
              ],
              [
                48.0466665,
                34.6229991
              ],
              [
                48.0461098,
                34.6229992
              ],
              [
                48.0458328,
                34.6232788
              ],
              [
                48.0449996,
                34.6232788
              ],
              [
                48.044443,
                34.6235586
              ],
              [
                48.0433332,
                34.6235586
              ],
              [
                48.043053,
                34.6232789
              ],
              [
                48.0422194,
                34.6232788
              ],
              [
                48.0377764,
                34.6080025
              ],
              [
                48.038053,
                34.6077229
              ],
              [
                48.0397199,
                34.6016051
              ],
              [
                48.0399999,
                34.6002245
              ],
              [
                48.0397199,
                34.5974453
              ],
              [
                48.0372199,
                34.5907771
              ],
              [
                48.0344432,
                34.5885573
              ],
              [
                48.0330534,
                34.5879979
              ],
              [
                48.0252767,
                34.5949458
              ],
              [
                48.02222,
                34.5963264
              ],
              [
                48.0219433,
                34.5966061
              ],
              [
                48.0211102,
                34.5966061
              ],
              [
                48.0133303,
                34.5893874
              ],
              [
                48.001107,
                34.5874384
              ],
              [
                47.9994402,
                34.5866082
              ],
              [
                47.9930502,
                34.5932764
              ],
              [
                47.9913838,
                34.594666
              ],
              [
                47.9874969,
                34.5968858
              ],
              [
                47.9872172,
                34.5971654
              ],
              [
                47.9861071,
                34.5971655
              ],
              [
                47.9852738,
                34.5977249
              ],
              [
                47.9844407,
                34.597725
              ],
              [
                47.9841637,
                34.5979956
              ],
              [
                47.9827738,
                34.5982753
              ],
              [
                47.9822171,
                34.5982753
              ],
              [
                47.9819405,
                34.5985551
              ],
              [
                47.9811074,
                34.5985551
              ],
              [
                47.9733271,
                34.602444
              ],
              [
                47.968327,
                34.6077525
              ],
              [
                47.9552708,
                34.6216093
              ],
              [
                47.9549942,
                34.6221688
              ],
              [
                47.9547173,
                34.6227191
              ],
              [
                47.943051,
                34.6249389
              ],
              [
                47.9424943,
                34.6252186
              ],
              [
                47.9394376,
                34.6252186
              ],
              [
                47.9386044,
                34.6254983
              ],
              [
                47.9369376,
                34.6254983
              ],
              [
                47.9358279,
                34.625778
              ],
              [
                47.9319375,
                34.625778
              ],
              [
                47.9313809,
                34.6254983
              ],
              [
                47.9166579,
                34.6266081
              ],
              [
                47.9149911,
                34.6268878
              ],
              [
                47.9122144,
                34.6268878
              ],
              [
                47.9099914,
                34.6271676
              ],
              [
                47.9013814,
                34.6271675
              ],
              [
                47.899438,
                34.6277269
              ],
              [
                47.895268,
                34.6288368
              ],
              [
                47.8944348,
                34.6288368
              ],
              [
                47.8938817,
                34.6291165
              ],
              [
                47.8908249,
                34.6291164
              ],
              [
                47.8866581,
                34.6282773
              ],
              [
                47.8838819,
                34.6282773
              ],
              [
                47.8833248,
                34.6279976
              ],
              [
                47.8802684,
                34.6279975
              ],
              [
                47.8730448,
                34.6293872
              ],
              [
                47.865545,
                34.6332761
              ],
              [
                47.8588785,
                34.6477219
              ],
              [
                47.8586019,
                34.6482813
              ],
              [
                47.8583175,
                34.6480612
              ],
              [
                47.8499885,
                34.6416134
              ],
              [
                47.8408219,
                34.6307766
              ],
              [
                47.8241557,
                34.6168899
              ],
              [
                47.8224893,
                34.6160598
              ],
              [
                47.8122093,
                34.6091119
              ],
              [
                47.810266,
                34.6082728
              ],
              [
                47.7833198,
                34.5938354
              ],
              [
                47.7830432,
                34.5935557
              ],
              [
                47.7527632,
                34.5779993
              ],
              [
                47.7519301,
                34.5779993
              ],
              [
                47.7358169,
                34.5738304
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555249,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان هرسین",
          "name:en": "Harsin County",
          "name:ku": "Hersîn",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286867",
          "wikipedia": "en:Harsin County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.2452406,
                34.4246647
              ],
              [
                47.2463499,
                34.4249354
              ],
              [
                47.2477398,
                34.425495
              ],
              [
                47.2510734,
                34.4260455
              ],
              [
                47.2549635,
                34.4260455
              ],
              [
                47.2555166,
                34.4263252
              ],
              [
                47.2580198,
                34.4263252
              ],
              [
                47.2585737,
                34.426605
              ],
              [
                47.2599635,
                34.426605
              ],
              [
                47.2605198,
                34.4268848
              ],
              [
                47.26163,
                34.4268847
              ],
              [
                47.2646871,
                34.427715
              ],
              [
                47.2657965,
                34.427715
              ],
              [
                47.2663535,
                34.4279947
              ],
              [
                47.26802,
                34.4282654
              ],
              [
                47.2699629,
                34.4282655
              ],
              [
                47.2702394,
                34.4285452
              ],
              [
                47.2746864,
                34.4285453
              ],
              [
                47.2752395,
                34.428825
              ],
              [
                47.2816295,
                34.428825
              ],
              [
                47.28191,
                34.4291048
              ],
              [
                47.2863531,
                34.4291048
              ],
              [
                47.2871867,
                34.4293846
              ],
              [
                47.2924626,
                34.4293846
              ],
              [
                47.2930196,
                34.4291048
              ],
              [
                47.2960759,
                34.4291049
              ],
              [
                47.298576,
                34.4285453
              ],
              [
                47.2999659,
                34.4285453
              ],
              [
                47.3005199,
                34.4282656
              ],
              [
                47.3071864,
                34.4263253
              ],
              [
                47.313856,
                34.4221562
              ],
              [
                47.3196889,
                34.4154962
              ],
              [
                47.3266329,
                34.402438
              ],
              [
                47.3274658,
                34.400218
              ],
              [
                47.3274657,
                34.3999383
              ],
              [
                47.3282994,
                34.3982687
              ],
              [
                47.3282994,
                34.3974385
              ],
              [
                47.3294095,
                34.3929984
              ],
              [
                47.3296893,
                34.3921592
              ],
              [
                47.3299659,
                34.3910492
              ],
              [
                47.3302425,
                34.3893797
              ],
              [
                47.3305229,
                34.3879899
              ],
              [
                47.331076,
                34.3852104
              ],
              [
                47.3313557,
                34.3835498
              ],
              [
                47.3316323,
                34.3816006
              ],
              [
                47.3319089,
                34.379931
              ],
              [
                47.3321893,
                34.3785503
              ],
              [
                47.332466,
                34.376601
              ],
              [
                47.3327425,
                34.3746607
              ],
              [
                47.333023,
                34.3732709
              ],
              [
                47.3332996,
                34.3716014
              ],
              [
                47.3335793,
                34.3699319
              ],
              [
                47.3338559,
                34.3685511
              ],
              [
                47.3341325,
                34.3657715
              ],
              [
                47.3344129,
                34.3618819
              ],
              [
                47.3346896,
                34.3591023
              ],
              [
                47.3349661,
                34.3588226
              ],
              [
                47.334966,
                34.3571621
              ],
              [
                47.3349661,
                34.3518826
              ],
              [
                47.3355224,
                34.3507726
              ],
              [
                47.3591361,
                34.3432731
              ],
              [
                47.3602455,
                34.3432731
              ],
              [
                47.3610791,
                34.3429933
              ],
              [
                47.3630221,
                34.3429934
              ],
              [
                47.3638558,
                34.3427136
              ],
              [
                47.3685793,
                34.3427136
              ],
              [
                47.3694121,
                34.3424339
              ],
              [
                47.3774686,
                34.3424339
              ],
              [
                47.3785787,
                34.3421541
              ],
              [
                47.3816358,
                34.3421542
              ],
              [
                47.4077489,
                34.337714
              ],
              [
                47.4099716,
                34.337714
              ],
              [
                47.4105255,
                34.3374343
              ],
              [
                47.4133053,
                34.3371636
              ],
              [
                47.4174717,
                34.3371635
              ],
              [
                47.4180248,
                34.3368838
              ],
              [
                47.4194148,
                34.3368838
              ],
              [
                47.4196913,
                34.3371635
              ],
              [
                47.4216382,
                34.3371635
              ],
              [
                47.4224718,
                34.3374343
              ],
              [
                47.4266383,
                34.3371636
              ],
              [
                47.4266383,
                34.3368838
              ],
              [
                47.4263586,
                34.3363243
              ],
              [
                47.4258047,
                34.3360445
              ],
              [
                47.4244149,
                34.3349344
              ],
              [
                47.4241384,
                34.3346547
              ],
              [
                47.423025,
                34.3341042
              ],
              [
                47.4221913,
                34.3341042
              ],
              [
                47.4216382,
                34.3338244
              ],
              [
                47.4208054,
                34.3338244
              ],
              [
                47.420525,
                34.3335447
              ],
              [
                47.4188585,
                34.3335447
              ],
              [
                47.4149717,
                34.330774
              ],
              [
                47.4138584,
                34.3274348
              ],
              [
                47.4099717,
                34.3241046
              ],
              [
                47.4113584,
                34.3221643
              ],
              [
                47.4163585,
                34.3179949
              ],
              [
                47.4163585,
                34.3171556
              ],
              [
                47.4152483,
                34.3160455
              ],
              [
                47.4144155,
                34.3160455
              ],
              [
                47.4135819,
                34.3157658
              ],
              [
                47.4119154,
                34.3157658
              ],
              [
                47.4116389,
                34.3160455
              ],
              [
                47.4105256,
                34.3160455
              ],
              [
                47.4099716,
                34.3163253
              ],
              [
                47.4083052,
                34.3163253
              ],
              [
                47.4038583,
                34.3127153
              ],
              [
                47.403302,
                34.3091054
              ],
              [
                47.405249,
                34.3052157
              ],
              [
                47.4085818,
                34.3016057
              ],
              [
                47.4085818,
                34.2999361
              ],
              [
                47.4069154,
                34.2991058
              ],
              [
                47.4044153,
                34.2991059
              ],
              [
                47.4030255,
                34.2963261
              ],
              [
                47.4033021,
                34.2954868
              ],
              [
                47.4044153,
                34.2935465
              ],
              [
                47.4044154,
                34.2932667
              ],
              [
                47.405249,
                34.2918769
              ],
              [
                47.4060818,
                34.2910465
              ],
              [
                47.4063584,
                34.2913263
              ],
              [
                47.4102483,
                34.2927162
              ],
              [
                47.4119155,
                34.2941061
              ],
              [
                47.414139,
                34.2935464
              ],
              [
                47.416082,
                34.2910465
              ],
              [
                47.4149719,
                34.2888264
              ],
              [
                47.4152485,
                34.2885466
              ],
              [
                47.4152485,
                34.2879871
              ],
              [
                47.4163586,
                34.286877
              ],
              [
                47.4169149,
                34.286877
              ],
              [
                47.4191383,
                34.2841063
              ],
              [
                47.4194149,
                34.2838265
              ],
              [
                47.4169149,
                34.2829962
              ],
              [
                47.4152484,
                34.2838265
              ],
              [
                47.414139,
                34.2838265
              ],
              [
                47.4138586,
                34.2835467
              ],
              [
                47.413025,
                34.2835467
              ],
              [
                47.4077491,
                34.2802166
              ],
              [
                47.407192,
                34.2793772
              ],
              [
                47.4060819,
                34.2768772
              ],
              [
                47.4074686,
                34.273547
              ],
              [
                47.4063585,
                34.2685471
              ],
              [
                47.4058022,
                34.2679876
              ],
              [
                47.4055256,
                34.2677079
              ],
              [
                47.403951,
                34.2670639
              ],
              [
                47.4035819,
                34.2668775
              ],
              [
                47.4030256,
                34.2665977
              ],
              [
                47.402749,
                34.2668775
              ],
              [
                47.402192,
                34.2668775
              ],
              [
                47.4016358,
                34.2665977
              ],
              [
                47.400249,
                34.2665977
              ],
              [
                47.3944154,
                34.2599372
              ],
              [
                47.3924691,
                34.2593776
              ],
              [
                47.391359,
                34.2593776
              ],
              [
                47.3910824,
                34.2596573
              ],
              [
                47.3880261,
                34.2596574
              ],
              [
                47.3877456,
                34.2593775
              ],
              [
                47.3838589,
                34.2577079
              ],
              [
                47.3819127,
                34.2571574
              ],
              [
                47.3813588,
                34.2565978
              ],
              [
                47.3791361,
                34.2554877
              ],
              [
                47.3727461,
                34.2507676
              ],
              [
                47.3716359,
                34.2499372
              ],
              [
                47.3702461,
                34.2471575
              ],
              [
                47.3705259,
                34.2463182
              ],
              [
                47.371636,
                34.244098
              ],
              [
                47.372193,
                34.2438182
              ],
              [
                47.374136,
                34.2413272
              ],
              [
                47.3733025,
                34.2382677
              ],
              [
                47.369689,
                34.2354879
              ],
              [
                47.369136,
                34.2338272
              ],
              [
                47.3685797,
                34.2293778
              ],
              [
                47.3663562,
                34.2243778
              ],
              [
                47.3608031,
                34.2196575
              ],
              [
                47.360803,
                34.2193778
              ],
              [
                47.3613562,
                34.2182676
              ],
              [
                47.3635796,
                34.2168778
              ],
              [
                47.3646898,
                34.2168777
              ],
              [
                47.3649695,
                34.2165979
              ],
              [
                47.3677462,
                34.2157676
              ],
              [
                47.3680228,
                34.215208
              ],
              [
                47.3674696,
                34.2135474
              ],
              [
                47.3641358,
                34.2113181
              ],
              [
                47.3630226,
                34.2113181
              ],
              [
                47.3627461,
                34.2115979
              ],
              [
                47.3610796,
                34.2115979
              ],
              [
                47.360803,
                34.2118776
              ],
              [
                47.3524701,
                34.2135473
              ],
              [
                47.3488567,
                34.2135473
              ],
              [
                47.3457996,
                34.212717
              ],
              [
                47.345523,
                34.2121484
              ],
              [
                47.3432996,
                34.2077079
              ],
              [
                47.3435801,
                34.2074281
              ],
              [
                47.3441332,
                34.2065978
              ],
              [
                47.3535795,
                34.199928
              ],
              [
                47.3549694,
                34.1963179
              ],
              [
                47.3546897,
                34.1935471
              ],
              [
                47.3530232,
                34.1921572
              ],
              [
                47.3510795,
                34.1921572
              ],
              [
                47.3482997,
                34.1929875
              ],
              [
                47.3466333,
                34.1902076
              ],
              [
                47.3480232,
                34.1874278
              ],
              [
                47.3513561,
                34.1840974
              ],
              [
                47.3510795,
                34.1829873
              ],
              [
                47.3502467,
                34.1815974
              ],
              [
                47.3486846,
                34.1804168
              ],
              [
                47.3465198,
                34.1774303
              ],
              [
                47.3494132,
                34.1743769
              ],
              [
                47.3524702,
                34.1752073
              ],
              [
                47.3535797,
                34.1752073
              ],
              [
                47.3552461,
                34.1752073
              ],
              [
                47.3574696,
                34.174377
              ],
              [
                47.3594134,
                34.1727073
              ],
              [
                47.3602462,
                34.1727072
              ],
              [
                47.3605227,
                34.1724274
              ],
              [
                47.3613563,
                34.1721567
              ],
              [
                47.3638564,
                34.1721567
              ],
              [
                47.3669127,
                34.1710466
              ],
              [
                47.3683025,
                34.1699364
              ],
              [
                47.3691362,
                34.1682667
              ],
              [
                47.3691363,
                34.1657666
              ],
              [
                47.3666361,
                34.1624362
              ],
              [
                47.3666362,
                34.1615968
              ],
              [
                47.3669127,
                34.1590967
              ],
              [
                47.3669128,
                34.1554864
              ],
              [
                47.3652464,
                34.1518762
              ],
              [
                47.3663565,
                34.1499267
              ],
              [
                47.3685799,
                34.1499266
              ],
              [
                47.3805263,
                34.1596564
              ],
              [
                47.3827459,
                34.1585462
              ],
              [
                47.3830264,
                34.1568764
              ],
              [
                47.3833029,
                34.1565966
              ],
              [
                47.3860795,
                34.149656
              ],
              [
                47.3866358,
                34.1485458
              ],
              [
                47.3894125,
                34.1454861
              ],
              [
                47.3916359,
                34.1454861
              ],
              [
                47.3988595,
                34.1499267
              ],
              [
                47.4013596,
                34.1493762
              ],
              [
                47.4019158,
                34.148266
              ],
              [
                47.4016361,
                34.1438164
              ],
              [
                47.398583,
                34.1421556
              ],
              [
                47.3966361,
                34.1421556
              ],
              [
                47.3960829,
                34.1424354
              ],
              [
                47.3952493,
                34.1424355
              ],
              [
                47.3952493,
                34.1421556
              ],
              [
                47.3944157,
                34.1421556
              ],
              [
                47.391636,
                34.1385454
              ],
              [
                47.3919165,
                34.1382656
              ],
              [
                47.3919164,
                34.1371554
              ],
              [
                47.3927493,
                34.136325
              ],
              [
                47.3935829,
                34.1360452
              ],
              [
                47.394136,
                34.1354856
              ],
              [
                47.3952494,
                34.1349351
              ],
              [
                47.4013597,
                34.131045
              ],
              [
                47.4066355,
                34.1232648
              ],
              [
                47.4263594,
                34.106874
              ],
              [
                47.4274728,
                34.1065942
              ],
              [
                47.4294157,
                34.1057639
              ],
              [
                47.4313623,
                34.1029839
              ],
              [
                47.4313624,
                34.0985432
              ],
              [
                47.432196,
                34.0965936
              ],
              [
                47.4489955,
                34.093029
              ],
              [
                47.4692065,
                34.0919711
              ],
              [
                47.4820517,
                34.0893458
              ],
              [
                47.4935676,
                34.0896517
              ],
              [
                47.503681,
                34.0946057
              ],
              [
                47.5085623,
                34.104413
              ],
              [
                47.5091742,
                34.1157841
              ],
              [
                47.5035093,
                34.1236003
              ],
              [
                47.5014494,
                34.1321263
              ],
              [
                47.5071142,
                34.1406514
              ],
              [
                47.5160406,
                34.1486074
              ],
              [
                47.526512,
                34.1537215
              ],
              [
                47.5337218,
                34.1628126
              ],
              [
                47.5297735,
                34.1694882
              ],
              [
                47.5217055,
                34.1797137
              ],
              [
                47.5116706,
                34.1873297
              ],
              [
                47.5291441,
                34.185208
              ],
              [
                47.5474773,
                34.1799281
              ],
              [
                47.5513672,
                34.1796573
              ],
              [
                47.5524774,
                34.1793776
              ],
              [
                47.5541438,
                34.1793776
              ],
              [
                47.5552539,
                34.1796574
              ],
              [
                47.5577537,
                34.1796574
              ],
              [
                47.559424,
                34.1802079
              ],
              [
                47.5605338,
                34.180208
              ],
              [
                47.5649772,
                34.1821484
              ],
              [
                47.5763669,
                34.1935476
              ],
              [
                47.5785904,
                34.1965983
              ],
              [
                47.5944234,
                34.2132681
              ],
              [
                47.6124797,
                34.2221582
              ],
              [
                47.6141464,
                34.2221581
              ],
              [
                47.6147031,
                34.2224289
              ],
              [
                47.6180364,
                34.2221581
              ],
              [
                47.6197028,
                34.2215986
              ],
              [
                47.6213696,
                34.2215986
              ],
              [
                47.6222029,
                34.2213188
              ],
              [
                47.6274795,
                34.2213189
              ],
              [
                47.6280362,
                34.2215986
              ],
              [
                47.629426,
                34.2215986
              ],
              [
                47.6386088,
                34.2265663
              ],
              [
                47.6397028,
                34.2271582
              ],
              [
                47.640536,
                34.2271582
              ],
              [
                47.6497026,
                34.234938
              ],
              [
                47.6499826,
                34.2354885
              ],
              [
                47.6519256,
                34.237438
              ],
              [
                47.6944284,
                34.2760476
              ],
              [
                47.695262,
                34.2774375
              ],
              [
                47.6974851,
                34.2827171
              ],
              [
                47.6977616,
                34.2874372
              ],
              [
                47.6980385,
                34.2890978
              ],
              [
                47.6977616,
                34.2896574
              ],
              [
                47.6835951,
                34.3274355
              ],
              [
                47.6835952,
                34.3285455
              ],
              [
                47.6833151,
                34.3288253
              ],
              [
                47.6822053,
                34.3288253
              ],
              [
                47.6816487,
                34.3291051
              ],
              [
                47.6797052,
                34.3291051
              ],
              [
                47.6797052,
                34.3293849
              ],
              [
                47.6710918,
                34.3299354
              ],
              [
                47.6708152,
                34.3302151
              ],
              [
                47.6697055,
                34.3302151
              ],
              [
                47.6694253,
                34.3304948
              ],
              [
                47.6677585,
                34.3304948
              ],
              [
                47.6674819,
                34.3307746
              ],
              [
                47.6644252,
                34.3307746
              ],
              [
                47.6633154,
                34.3304948
              ],
              [
                47.6624823,
                34.3307747
              ],
              [
                47.6619252,
                34.3304949
              ],
              [
                47.6608154,
                34.3304948
              ],
              [
                47.6602588,
                34.3307746
              ],
              [
                47.6577587,
                34.3307746
              ],
              [
                47.6572056,
                34.3310544
              ],
              [
                47.6558153,
                34.3310544
              ],
              [
                47.6519254,
                34.3318756
              ],
              [
                47.6513687,
                34.3321553
              ],
              [
                47.6494257,
                34.3324352
              ],
              [
                47.6422021,
                34.3346553
              ],
              [
                47.6319257,
                34.341884
              ],
              [
                47.6305358,
                34.3463241
              ],
              [
                47.6308123,
                34.3518833
              ],
              [
                47.6310925,
                34.353544
              ],
              [
                47.6330358,
                34.357993
              ],
              [
                47.6344257,
                34.366052
              ],
              [
                47.6344257,
                34.3663228
              ],
              [
                47.6344257,
                34.3666025
              ],
              [
                47.6324787,
                34.3693821
              ],
              [
                47.6155357,
                34.3841101
              ],
              [
                47.6110892,
                34.3857705
              ],
              [
                47.6105357,
                34.3857705
              ],
              [
                47.6102559,
                34.3860503
              ],
              [
                47.6097025,
                34.3860503
              ],
              [
                47.6094224,
                34.3863301
              ],
              [
                47.6088693,
                34.3863301
              ],
              [
                47.6052558,
                34.3866008
              ],
              [
                47.6049792,
                34.3868805
              ],
              [
                47.6033125,
                34.3868805
              ],
              [
                47.6027558,
                34.3871603
              ],
              [
                47.5983127,
                34.3871603
              ],
              [
                47.5977561,
                34.38744
              ],
              [
                47.5910896,
                34.38744
              ],
              [
                47.5905329,
                34.3871602
              ],
              [
                47.5869226,
                34.3871603
              ],
              [
                47.5860894,
                34.38744
              ],
              [
                47.5727563,
                34.38744
              ],
              [
                47.5719231,
                34.3871602
              ],
              [
                47.5710896,
                34.38744
              ],
              [
                47.5705328,
                34.3871602
              ],
              [
                47.5627565,
                34.3871602
              ],
              [
                47.5616432,
                34.3868805
              ],
              [
                47.5605331,
                34.3868804
              ],
              [
                47.5599764,
                34.3866007
              ],
              [
                47.5588666,
                34.3866007
              ],
              [
                47.5560865,
                34.3857704
              ],
              [
                47.5552533,
                34.3857705
              ],
              [
                47.5546998,
                34.3854907
              ],
              [
                47.5535864,
                34.3854907
              ],
              [
                47.5533098,
                34.3852109
              ],
              [
                47.5469199,
                34.3852108
              ],
              [
                47.5444198,
                34.3849311
              ],
              [
                47.5366435,
                34.3849312
              ],
              [
                47.5355302,
                34.3846604
              ],
              [
                47.529977,
                34.3849311
              ],
              [
                47.5294203,
                34.3852108
              ],
              [
                47.5205303,
                34.3852109
              ],
              [
                47.5199737,
                34.3854906
              ],
              [
                47.5191405,
                34.3852108
              ],
              [
                47.5110872,
                34.3852109
              ],
              [
                47.4980306,
                34.3841098
              ],
              [
                47.4977505,
                34.38383
              ],
              [
                47.4938641,
                34.38383
              ],
              [
                47.493584,
                34.3835502
              ],
              [
                47.4919173,
                34.3835502
              ],
              [
                47.4908074,
                34.3829908
              ],
              [
                47.4902508,
                34.3829907
              ],
              [
                47.4885839,
                34.3807707
              ],
              [
                47.4880308,
                34.3804909
              ],
              [
                47.4880309,
                34.3799314
              ],
              [
                47.4877507,
                34.3802111
              ],
              [
                47.486364,
                34.3816009
              ],
              [
                47.4860839,
                34.3821605
              ],
              [
                47.4858074,
                34.3835502
              ],
              [
                47.4855308,
                34.3849309
              ],
              [
                47.4852506,
                34.3866005
              ],
              [
                47.4855307,
                34.38827
              ],
              [
                47.4852507,
                34.3888295
              ],
              [
                47.4855308,
                34.391609
              ],
              [
                47.4855307,
                34.3993791
              ],
              [
                47.4860838,
                34.4038282
              ],
              [
                47.4877507,
                34.4116071
              ],
              [
                47.4891405,
                34.4135474
              ],
              [
                47.4894171,
                34.4141069
              ],
              [
                47.5044205,
                34.4213264
              ],
              [
                47.5052536,
                34.4216062
              ],
              [
                47.5063635,
                34.4235464
              ],
              [
                47.5058068,
                34.4235463
              ],
              [
                47.5041403,
                34.4246654
              ],
              [
                47.5033072,
                34.4252159
              ],
              [
                47.4919171,
                34.4299355
              ],
              [
                47.4916405,
                34.4302152
              ],
              [
                47.4908073,
                34.4302152
              ],
              [
                47.4905306,
                34.4304951
              ],
              [
                47.4896971,
                34.430495
              ],
              [
                47.4760839,
                34.4371639
              ],
              [
                47.474694,
                34.4402141
              ],
              [
                47.4755271,
                34.4610508
              ],
              [
                47.4758073,
                34.4616103
              ],
              [
                47.4755272,
                34.4621608
              ],
              [
                47.4755272,
                34.4632707
              ],
              [
                47.4755272,
                34.4646604
              ],
              [
                47.4752506,
                34.46522
              ],
              [
                47.4691406,
                34.4785484
              ],
              [
                47.4666405,
                34.4882762
              ],
              [
                47.4674738,
                34.4929958
              ],
              [
                47.4744172,
                34.4963255
              ],
              [
                47.4746938,
                34.4966053
              ],
              [
                47.4766404,
                34.4966053
              ],
              [
                47.476917,
                34.496885
              ],
              [
                47.4783072,
                34.496885
              ],
              [
                47.4791404,
                34.4971648
              ],
              [
                47.4805271,
                34.4971648
              ],
              [
                47.4810838,
                34.4974445
              ],
              [
                47.481917,
                34.4974446
              ],
              [
                47.4824736,
                34.4971648
              ],
              [
                47.4841406,
                34.4971648
              ],
              [
                47.4846972,
                34.4968851
              ],
              [
                47.4855304,
                34.4968851
              ],
              [
                47.4871968,
                34.496885
              ],
              [
                47.4894168,
                34.4968851
              ],
              [
                47.4913637,
                34.4982748
              ],
              [
                47.4919168,
                34.5007744
              ],
              [
                47.4871968,
                34.5068835
              ],
              [
                47.4819169,
                34.5110525
              ],
              [
                47.4813603,
                34.5118917
              ],
              [
                47.4630271,
                34.5221607
              ],
              [
                47.4627506,
                34.5224405
              ],
              [
                47.4619173,
                34.5224404
              ],
              [
                47.4558039,
                34.5252198
              ],
              [
                47.4549707,
                34.5252197
              ],
              [
                47.4546941,
                34.5254995
              ],
              [
                47.4538605,
                34.5254994
              ],
              [
                47.4477506,
                34.529109
              ],
              [
                47.4424707,
                34.5424459
              ],
              [
                47.4421941,
                34.5438265
              ],
              [
                47.441914,
                34.5457756
              ],
              [
                47.4413605,
                34.5502242
              ],
              [
                47.4413606,
                34.5571634
              ],
              [
                47.4413605,
                34.5577228
              ],
              [
                47.4413604,
                34.558553
              ],
              [
                47.4410808,
                34.5588327
              ],
              [
                47.4408039,
                34.5599425
              ],
              [
                47.4405272,
                34.5618827
              ],
              [
                47.4408038,
                34.5621624
              ],
              [
                47.4408038,
                34.5624422
              ],
              [
                47.4155241,
                34.5657717
              ],
              [
                47.4152474,
                34.5655011
              ],
              [
                47.4144146,
                34.5657717
              ],
              [
                47.413581,
                34.565501
              ],
              [
                47.4033011,
                34.5657717
              ],
              [
                47.4019144,
                34.5660514
              ],
              [
                47.3969142,
                34.5660514
              ],
              [
                47.3883016,
                34.5668816
              ],
              [
                47.387468,
                34.5671613
              ],
              [
                47.3852445,
                34.5671613
              ],
              [
                47.3844116,
                34.567441
              ],
              [
                47.3838577,
                34.567441
              ],
              [
                47.381635,
                34.567441
              ],
              [
                47.3808014,
                34.5677207
              ],
              [
                47.3794115,
                34.5677207
              ],
              [
                47.3783014,
                34.5680004
              ],
              [
                47.3769115,
                34.5680004
              ],
              [
                47.3758012,
                34.5682802
              ],
              [
                47.3738584,
                34.5682802
              ],
              [
                47.3641347,
                34.5702201
              ],
              [
                47.3624683,
                34.5702202
              ],
              [
                47.3596885,
                34.5710503
              ],
              [
                47.3585783,
                34.5710504
              ],
              [
                47.3216322,
                34.5813279
              ],
              [
                47.3210751,
                34.5816077
              ],
              [
                47.3207985,
                34.5818874
              ],
              [
                47.3182985,
                34.5810572
              ],
              [
                47.3024654,
                34.5729992
              ],
              [
                47.2857956,
                34.559103
              ],
              [
                47.2855189,
                34.5588323
              ],
              [
                47.2630194,
                34.5338279
              ],
              [
                47.2532967,
                34.5288287
              ],
              [
                47.252463,
                34.5288288
              ],
              [
                47.252463,
                34.528549
              ],
              [
                47.2516301,
                34.528549
              ],
              [
                47.2516302,
                34.5282692
              ],
              [
                47.2535732,
                34.5221602
              ],
              [
                47.2538497,
                34.5199403
              ],
              [
                47.2541295,
                34.5193809
              ],
              [
                47.2546834,
                34.5166016
              ],
              [
                47.2535733,
                34.505773
              ],
              [
                47.2538499,
                34.5054932
              ],
              [
                47.2516304,
                34.4763279
              ],
              [
                47.2510734,
                34.4746585
              ],
              [
                47.2485733,
                34.467719
              ],
              [
                47.2482967,
                34.4635499
              ],
              [
                47.2485733,
                34.4607705
              ],
              [
                47.2482967,
                34.460211
              ],
              [
                47.2480171,
                34.4577113
              ],
              [
                47.2469069,
                34.4274352
              ],
              [
                47.246907,
                34.4271645
              ],
              [
                47.246907,
                34.426605
              ],
              [
                47.2452406,
                34.4246647
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555264,
        "tags": {
          "admin_level": "5",
          "alt_name:ku": "Şehristana Pawe",
          "boundary": "administrative",
          "name": "شهرستان پاوه",
          "name:en": "Paveh County",
          "name:ku": "Pawe",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q393366",
          "wikipedia": "en:Paveh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.941271,
                35.0882698
              ],
              [
                45.941326,
                35.088202
              ],
              [
                45.9428289,
                35.0869336
              ],
              [
                45.9450158,
                35.0860654
              ],
              [
                45.9463323,
                35.0843076
              ],
              [
                45.9504779,
                35.0821795
              ],
              [
                45.9530529,
                35.0797352
              ],
              [
                45.9573787,
                35.0753521
              ],
              [
                45.9598506,
                35.073034
              ],
              [
                45.965052,
                35.068503
              ],
              [
                45.9667514,
                35.0656579
              ],
              [
                45.9678586,
                35.0639929
              ],
              [
                45.9730085,
                35.0612951
              ],
              [
                45.9755834,
                35.0584286
              ],
              [
                45.9770769,
                35.0560047
              ],
              [
                45.9782385,
                35.0540145
              ],
              [
                45.9829248,
                35.0532978
              ],
              [
                45.9848045,
                35.0520331
              ],
              [
                45.9895939,
                35.0488922
              ],
              [
                45.995336,
                35.0471215
              ],
              [
                46.0013098,
                35.042821
              ],
              [
                46.0034727,
                35.0389208
              ],
              [
                46.011043,
                35.0312464
              ],
              [
                46.0254368,
                35.022032
              ],
              [
                46.0289644,
                35.0193961
              ],
              [
                46.0370497,
                35.0143771
              ],
              [
                46.0430492,
                35.0114668
              ],
              [
                46.0457014,
                35.0102014
              ],
              [
                46.0485081,
                35.0103491
              ],
              [
                46.0564903,
                35.0099484
              ],
              [
                46.0624126,
                35.0094211
              ],
              [
                46.0655756,
                35.0086542
              ],
              [
                46.0674811,
                35.0048789
              ],
              [
                46.0714464,
                35.0016941
              ],
              [
                46.0762873,
                35.000977
              ],
              [
                46.0797377,
                34.9973279
              ],
              [
                46.0806646,
                34.995999
              ],
              [
                46.0858145,
                34.9937631
              ],
              [
                46.0886212,
                34.9942272
              ],
              [
                46.0929213,
                34.9929615
              ],
              [
                46.1007748,
                34.9894598
              ],
              [
                46.1036587,
                34.9895653
              ],
              [
                46.1101217,
                34.9924763
              ],
              [
                46.1139069,
                34.993067
              ],
              [
                46.1176663,
                34.9938475
              ],
              [
                46.1204235,
                34.9926031
              ],
              [
                46.1234362,
                34.9922656
              ],
              [
                46.1314957,
                34.9894389
              ],
              [
                46.1319592,
                34.9891857
              ],
              [
                46.1340448,
                34.9871394
              ],
              [
                46.1354611,
                34.9853041
              ],
              [
                46.1372635,
                34.9840383
              ],
              [
                46.138757,
                34.9844391
              ],
              [
                46.1426193,
                34.9860846
              ],
              [
                46.14522,
                34.98638
              ],
              [
                46.1470739,
                34.98638
              ],
              [
                46.1496231,
                34.9858737
              ],
              [
                46.1524555,
                34.9844391
              ],
              [
                46.1584293,
                34.9848822
              ],
              [
                46.1631672,
                34.9857049
              ],
              [
                46.1708147,
                34.986823
              ],
              [
                46.1736729,
                34.9859792
              ],
              [
                46.1837923,
                34.9861479
              ],
              [
                46.1866762,
                34.9852619
              ],
              [
                46.1922123,
                34.9808105
              ],
              [
                46.1958944,
                34.9799033
              ],
              [
                46.2008125,
                34.9830046
              ],
              [
                46.2019455,
                34.9830889
              ],
              [
                46.202512,
                34.9825193
              ],
              [
                46.2053444,
                34.9792914
              ],
              [
                46.2073786,
                34.9773082
              ],
              [
                46.2121929,
                34.9733083
              ],
              [
                46.2258631,
                34.9609835
              ],
              [
                46.2294938,
                34.9575437
              ],
              [
                46.2316824,
                34.9576914
              ],
              [
                46.2341029,
                34.9584089
              ],
              [
                46.2414414,
                34.9568684
              ],
              [
                46.2435528,
                34.9557499
              ],
              [
                46.2451493,
                34.9533862
              ],
              [
                46.2510973,
                34.9479621
              ],
              [
                46.2533118,
                34.9473501
              ],
              [
                46.2560412,
                34.9463792
              ],
              [
                46.2576119,
                34.9434876
              ],
              [
                46.2601611,
                34.9430443
              ],
              [
                46.2654719,
                34.9413146
              ],
              [
                46.2664532,
                34.9404249
              ],
              [
                46.2682402,
                34.939996
              ],
              [
                46.2709216,
                34.9381861
              ],
              [
                46.2727885,
                34.9369322
              ],
              [
                46.2747472,
                34.9367408
              ],
              [
                46.276095,
                34.9369538
              ],
              [
                46.27877,
                34.9357107
              ],
              [
                46.2807034,
                34.9346016
              ],
              [
                46.2812483,
                34.9336349
              ],
              [
                46.2816614,
                34.9315899
              ],
              [
                46.2818085,
                34.9315038
              ],
              [
                46.2843051,
                34.9302331
              ],
              [
                46.2865963,
                34.9297386
              ],
              [
                46.2880826,
                34.9291138
              ],
              [
                46.2893471,
                34.9275612
              ],
              [
                46.2932659,
                34.9269801
              ],
              [
                46.2954949,
                34.9263469
              ],
              [
                46.2978069,
                34.9266288
              ],
              [
                46.3010858,
                34.9266991
              ],
              [
                46.3051183,
                34.9275065
              ],
              [
                46.3073871,
                34.9272602
              ],
              [
                46.311267,
                34.9282587
              ],
              [
                46.3148655,
                34.9287513
              ],
              [
                46.3185481,
                34.9283163
              ],
              [
                46.3211579,
                34.9282284
              ],
              [
                46.3217936,
                34.9290164
              ],
              [
                46.3217067,
                34.930486
              ],
              [
                46.3228654,
                34.9323156
              ],
              [
                46.3247537,
                34.9337933
              ],
              [
                46.3260841,
                34.9353765
              ],
              [
                46.3277578,
                34.9355876
              ],
              [
                46.331706,
                34.9358338
              ],
              [
                46.333208,
                34.9353765
              ],
              [
                46.3348388,
                34.9334063
              ],
              [
                46.3361692,
                34.93221
              ],
              [
                46.3376712,
                34.9318582
              ],
              [
                46.3398599,
                34.9290435
              ],
              [
                46.340332,
                34.9273194
              ],
              [
                46.3414049,
                34.926475
              ],
              [
                46.3437606,
                34.9250246
              ],
              [
                46.3468122,
                34.9240823
              ],
              [
                46.3480568,
                34.9230971
              ],
              [
                46.349945,
                34.9217599
              ],
              [
                46.3543653,
                34.9209594
              ],
              [
                46.3570368,
                34.9196398
              ],
              [
                46.3598263,
                34.9188745
              ],
              [
                46.3623905,
                34.9186106
              ],
              [
                46.3661134,
                34.9189888
              ],
              [
                46.3699651,
                34.9189712
              ],
              [
                46.3722396,
                34.9196486
              ],
              [
                46.3737738,
                34.9190768
              ],
              [
                46.374439,
                34.9178628
              ],
              [
                46.375426,
                34.9170446
              ],
              [
                46.3767028,
                34.9166751
              ],
              [
                46.3797068,
                34.9167015
              ],
              [
                46.3808226,
                34.916376
              ],
              [
                46.3839447,
                34.9145373
              ],
              [
                46.3864553,
                34.9121179
              ],
              [
                46.3869274,
                34.9109566
              ],
              [
                46.3890087,
                34.9097688
              ],
              [
                46.3904464,
                34.9085107
              ],
              [
                46.3919377,
                34.9068565
              ],
              [
                46.3923974,
                34.9061739
              ],
              [
                46.3991904,
                34.9094433
              ],
              [
                46.4050698,
                34.9123467
              ],
              [
                46.4064216,
                34.9141525
              ],
              [
                46.4064254,
                34.9144271
              ],
              [
                46.4064377,
                34.9148122
              ],
              [
                46.4044797,
                34.916684
              ],
              [
                46.4003384,
                34.9237656
              ],
              [
                46.3980746,
                34.9256041
              ],
              [
                46.3958645,
                34.9272402
              ],
              [
                46.3944268,
                34.933978
              ],
              [
                46.3945877,
                34.9392288
              ],
              [
                46.3948882,
                34.9410669
              ],
              [
                46.3933754,
                34.9455522
              ],
              [
                46.395843,
                34.9447695
              ],
              [
                46.3973343,
                34.944875
              ],
              [
                46.3981175,
                34.9460271
              ],
              [
                46.3992119,
                34.948252
              ],
              [
                46.3991582,
                34.9499141
              ],
              [
                46.3994694,
                34.9515673
              ],
              [
                46.3993513,
                34.9523148
              ],
              [
                46.4002418,
                34.9535987
              ],
              [
                46.3994479,
                34.9543725
              ],
              [
                46.3989115,
                34.9548474
              ],
              [
                46.4006281,
                34.9559553
              ],
              [
                46.4014059,
                34.9569138
              ],
              [
                46.4028328,
                34.9570325
              ],
              [
                46.4042061,
                34.956839
              ],
              [
                46.4050483,
                34.9572523
              ],
              [
                46.4053166,
                34.9577843
              ],
              [
                46.4058369,
                34.9580481
              ],
              [
                46.4067167,
                34.9578239
              ],
              [
                46.4071029,
                34.9581228
              ],
              [
                46.4093184,
                34.9579602
              ],
              [
                46.4114588,
                34.9586416
              ],
              [
                46.4118182,
                34.9599694
              ],
              [
                46.4092755,
                34.9614861
              ],
              [
                46.4066362,
                34.9662164
              ],
              [
                46.4074516,
                34.9685024
              ],
              [
                46.411786,
                34.967843
              ],
              [
                46.4146184,
                34.9679133
              ],
              [
                46.4186954,
                34.9684057
              ],
              [
                46.4284801,
                34.9736104
              ],
              [
                46.4338874,
                34.9769862
              ],
              [
                46.4412688,
                34.977795
              ],
              [
                46.4502659,
                34.976839
              ],
              [
                46.455349,
                34.9783387
              ],
              [
                46.4617188,
                34.9792672
              ],
              [
                46.4645758,
                34.9793239
              ],
              [
                46.4712941,
                34.9765607
              ],
              [
                46.4789132,
                34.9750289
              ],
              [
                46.4864568,
                34.9760991
              ],
              [
                46.4927772,
                34.9774355
              ],
              [
                46.5006299,
                34.9803876
              ],
              [
                46.5117988,
                34.9837631
              ],
              [
                46.5235767,
                34.9864368
              ],
              [
                46.53128,
                34.9872983
              ],
              [
                46.5305563,
                34.992321
              ],
              [
                46.5315347,
                34.9994295
              ],
              [
                46.5326162,
                35.0081192
              ],
              [
                46.5320755,
                35.0203718
              ],
              [
                46.529655,
                35.0264237
              ],
              [
                46.5264879,
                35.0295864
              ],
              [
                46.524016,
                35.0350051
              ],
              [
                46.5253468,
                35.0411294
              ],
              [
                46.5197077,
                35.0415721
              ],
              [
                46.5112877,
                35.0444814
              ],
              [
                46.5073996,
                35.0448608
              ],
              [
                46.5040522,
                35.0462522
              ],
              [
                46.5000611,
                35.0473273
              ],
              [
                46.493804,
                35.0510584
              ],
              [
                46.4914093,
                35.0524285
              ],
              [
                46.4889117,
                35.0539041
              ],
              [
                46.4869137,
                35.0557191
              ],
              [
                46.4828169,
                35.057973
              ],
              [
                46.4788515,
                35.0602282
              ],
              [
                46.4757101,
                35.0615139
              ],
              [
                46.4723884,
                35.0627364
              ],
              [
                46.4691955,
                35.0629682
              ],
              [
                46.463299,
                35.0657081
              ],
              [
                46.460621,
                35.0658135
              ],
              [
                46.4567072,
                35.0671623
              ],
              [
                46.4535915,
                35.0677102
              ],
              [
                46.4496776,
                35.06849
              ],
              [
                46.4480554,
                35.0695016
              ],
              [
                46.4485962,
                35.07104
              ],
              [
                46.4479267,
                35.0771724
              ],
              [
                46.4487764,
                35.0788582
              ],
              [
                46.4501154,
                35.0808389
              ],
              [
                46.4507076,
                35.0845896
              ],
              [
                46.4503471,
                35.0857274
              ],
              [
                46.4498321,
                35.087708
              ],
              [
                46.450315,
                35.0910396
              ],
              [
                46.4496197,
                35.0935889
              ],
              [
                46.4486155,
                35.0972758
              ],
              [
                46.4483601,
                35.1015193
              ],
              [
                46.447222,
                35.1044368
              ],
              [
                46.4442865,
                35.1058903
              ],
              [
                46.4419176,
                35.1075544
              ],
              [
                46.4368193,
                35.1112617
              ],
              [
                46.4340126,
                35.1137472
              ],
              [
                46.4325192,
                35.1178965
              ],
              [
                46.429764,
                35.1207399
              ],
              [
                46.4271118,
                35.1222352
              ],
              [
                46.4216015,
                35.1233093
              ],
              [
                46.4150355,
                35.1244045
              ],
              [
                46.412615,
                35.1264262
              ],
              [
                46.4116881,
                35.1277951
              ],
              [
                46.4105036,
                35.1303012
              ],
              [
                46.4077227,
                35.1340285
              ],
              [
                46.4057078,
                35.1364942
              ],
              [
                46.4025406,
                35.1383472
              ],
              [
                46.3988585,
                35.139779
              ],
              [
                46.3956141,
                35.140495
              ],
              [
                46.3898463,
                35.1436533
              ],
              [
                46.3883528,
                35.1460957
              ],
              [
                46.3863959,
                35.1483065
              ],
              [
                46.3835892,
                35.1499276
              ],
              [
                46.3788513,
                35.152054
              ],
              [
                46.3756842,
                35.1538646
              ],
              [
                46.3740105,
                35.1553593
              ],
              [
                46.3732123,
                35.1569172
              ],
              [
                46.3734955,
                35.1593802
              ],
              [
                46.3736754,
                35.1610047
              ],
              [
                46.3670235,
                35.164864
              ],
              [
                46.3653927,
                35.166583
              ],
              [
                46.3630324,
                35.1666181
              ],
              [
                46.3538056,
                35.1707577
              ],
              [
                46.3505506,
                35.1690125
              ],
              [
                46.3498145,
                35.1686178
              ],
              [
                46.3495735,
                35.168391
              ],
              [
                46.3471781,
                35.1697954
              ],
              [
                46.3451954,
                35.1703006
              ],
              [
                46.3437277,
                35.1708058
              ],
              [
                46.3412873,
                35.1723819
              ],
              [
                46.3394591,
                35.1725293
              ],
              [
                46.3358285,
                35.1737921
              ],
              [
                46.3297774,
                35.17596
              ],
              [
                46.3264558,
                35.1774543
              ],
              [
                46.3224389,
                35.1785488
              ],
              [
                46.3168513,
                35.1801483
              ],
              [
                46.3143536,
                35.1811374
              ],
              [
                46.3093068,
                35.184189
              ],
              [
                46.3069894,
                35.1849677
              ],
              [
                46.301891,
                35.1861041
              ],
              [
                46.29584,
                35.1893028
              ],
              [
                46.2924153,
                35.1916386
              ],
              [
                46.287935,
                35.1935955
              ],
              [
                46.2839181,
                35.1956787
              ],
              [
                46.2817037,
                35.1974673
              ],
              [
                46.2765281,
                35.1994872
              ],
              [
                46.2737818,
                35.2014143
              ],
              [
                46.2719705,
                35.2026854
              ],
              [
                46.2673356,
                35.206178
              ],
              [
                46.2648637,
                35.2071037
              ],
              [
                46.2608726,
                35.2082188
              ],
              [
                46.255697,
                35.2094811
              ],
              [
                46.2537658,
                35.2111852
              ],
              [
                46.2502124,
                35.2146563
              ],
              [
                46.2484872,
                35.2153506
              ],
              [
                46.2401584,
                35.2175222
              ],
              [
                46.2379182,
                35.2187003
              ],
              [
                46.2368882,
                35.2209931
              ],
              [
                46.2376058,
                35.223895
              ],
              [
                46.2334636,
                35.2256839
              ],
              [
                46.2295754,
                35.2282921
              ],
              [
                46.2258161,
                35.230732
              ],
              [
                46.2230094,
                35.2335713
              ],
              [
                46.219971,
                35.2372729
              ],
              [
                46.2182973,
                35.239397
              ],
              [
                46.2138942,
                35.2422361
              ],
              [
                46.2106755,
                35.2440867
              ],
              [
                46.2049077,
                35.2448438
              ],
              [
                46.2038486,
                35.2462938
              ],
              [
                46.2029473,
                35.2482494
              ],
              [
                46.2024839,
                35.2505625
              ],
              [
                46.1997287,
                35.2549152
              ],
              [
                46.1961496,
                35.2560926
              ],
              [
                46.1935746,
                35.2584686
              ],
              [
                46.1904847,
                35.2624003
              ],
              [
                46.1837604,
                35.2707791
              ],
              [
                46.1793791,
                35.2740734
              ],
              [
                46.1764952,
                35.2754608
              ],
              [
                46.1741262,
                35.2772686
              ],
              [
                46.1731993,
                35.2775209
              ],
              [
                46.1711651,
                35.2783827
              ],
              [
                46.1695171,
                35.2792866
              ],
              [
                46.1666075,
                35.2806319
              ],
              [
                46.164805,
                35.2815568
              ],
              [
                46.1641871,
                35.282881
              ],
              [
                46.1614576,
                35.2842472
              ],
              [
                46.158684,
                35.284506
              ],
              [
                46.1581915,
                35.2835603
              ],
              [
                46.1579096,
                35.2832798
              ],
              [
                46.157574,
                35.282994
              ],
              [
                46.156862,
                35.282538
              ],
              [
                46.154925,
                35.282048
              ],
              [
                46.153841,
                35.281633
              ],
              [
                46.152081,
                35.280891
              ],
              [
                46.150954,
                35.280463
              ],
              [
                46.149884,
                35.280149
              ],
              [
                46.14894,
                35.279894
              ],
              [
                46.149354,
                35.278609
              ],
              [
                46.149417,
                35.277494
              ],
              [
                46.148946,
                35.27667
              ],
              [
                46.148411,
                35.275765
              ],
              [
                46.14836,
                35.27488
              ],
              [
                46.148257,
                35.274006
              ],
              [
                46.148019,
                35.273283
              ],
              [
                46.14763,
                35.272411
              ],
              [
                46.146861,
                35.271749
              ],
              [
                46.14571,
                35.271336
              ],
              [
                46.144589,
                35.269836
              ],
              [
                46.143793,
                35.26947
              ],
              [
                46.143388,
                35.268342
              ],
              [
                46.143128,
                35.267841
              ],
              [
                46.142335,
                35.267037
              ],
              [
                46.1414232,
                35.266168
              ],
              [
                46.141355,
                35.266103
              ],
              [
                46.140659,
                35.265655
              ],
              [
                46.139295,
                35.265013
              ],
              [
                46.137757,
                35.264633
              ],
              [
                46.136155,
                35.264567
              ],
              [
                46.135614,
                35.264339
              ],
              [
                46.135869,
                35.262928
              ],
              [
                46.135787,
                35.261977
              ],
              [
                46.135723,
                35.261594
              ],
              [
                46.135407,
                35.261436
              ],
              [
                46.134224,
                35.260905
              ],
              [
                46.133109,
                35.260475
              ],
              [
                46.132441,
                35.260032
              ],
              [
                46.131939,
                35.259546
              ],
              [
                46.1312,
                35.258743
              ],
              [
                46.130642,
                35.258299
              ],
              [
                46.130036,
                35.257833
              ],
              [
                46.129497,
                35.257261
              ],
              [
                46.12945,
                35.256241
              ],
              [
                46.129013,
                35.255442
              ],
              [
                46.128418,
                35.254516
              ],
              [
                46.12751,
                35.254442
              ],
              [
                46.126494,
                35.254523
              ],
              [
                46.125903,
                35.253857
              ],
              [
                46.125413,
                35.253515
              ],
              [
                46.125343,
                35.252561
              ],
              [
                46.12527,
                35.251796
              ],
              [
                46.124713,
                35.251061
              ],
              [
                46.12431,
                35.250484
              ],
              [
                46.124122,
                35.250145
              ],
              [
                46.123926,
                35.249382
              ],
              [
                46.123557,
                35.248882
              ],
              [
                46.123637,
                35.247827
              ],
              [
                46.123503,
                35.247437
              ],
              [
                46.123098,
                35.246953
              ],
              [
                46.122881,
                35.246413
              ],
              [
                46.122686,
                35.246149
              ],
              [
                46.121943,
                35.245627
              ],
              [
                46.121249,
                35.24524
              ],
              [
                46.120762,
                35.245105
              ],
              [
                46.12033,
                35.245074
              ],
              [
                46.11973,
                35.244628
              ],
              [
                46.118659,
                35.244408
              ],
              [
                46.118106,
                35.244286
              ],
              [
                46.117418,
                35.244117
              ],
              [
                46.117034,
                35.24391
              ],
              [
                46.1163548,
                35.2438579
              ],
              [
                46.1161854,
                35.2435671
              ],
              [
                46.1162815,
                35.243194
              ],
              [
                46.116488,
                35.2429958
              ],
              [
                46.1170503,
                35.2425718
              ],
              [
                46.1182459,
                35.2411728
              ],
              [
                46.1192911,
                35.2393458
              ],
              [
                46.1194781,
                35.2384107
              ],
              [
                46.1201123,
                35.2378396
              ],
              [
                46.12049,
                35.2367413
              ],
              [
                46.1208439,
                35.2353785
              ],
              [
                46.121044,
                35.2343735
              ],
              [
                46.1213093,
                35.2333136
              ],
              [
                46.121917,
                35.232724
              ],
              [
                46.12213,
                35.232984
              ],
              [
                46.122352,
                35.233184
              ],
              [
                46.122683,
                35.233421
              ],
              [
                46.123163,
                35.233776
              ],
              [
                46.123471,
                35.234252
              ],
              [
                46.123578,
                35.234782
              ],
              [
                46.123622,
                35.235254
              ],
              [
                46.123623,
                35.235359
              ],
              [
                46.123596,
                35.235411
              ],
              [
                46.123462,
                35.235585
              ],
              [
                46.1235,
                35.235667
              ],
              [
                46.123618,
                35.235673
              ],
              [
                46.123755,
                35.235664
              ],
              [
                46.12391,
                35.235633
              ],
              [
                46.124316,
                35.235394
              ],
              [
                46.124653,
                35.235282
              ],
              [
                46.124753,
                35.235266
              ],
              [
                46.124936,
                35.235309
              ],
              [
                46.125321,
                35.23544
              ],
              [
                46.12546,
                35.235581
              ],
              [
                46.125791,
                35.23575
              ],
              [
                46.126151,
                35.235994
              ],
              [
                46.126484,
                35.236313
              ],
              [
                46.12722,
                35.23577
              ],
              [
                46.127224,
                35.235767
              ],
              [
                46.127074,
                35.235454
              ],
              [
                46.127008,
                35.235297
              ],
              [
                46.126812,
                35.235
              ],
              [
                46.126529,
                35.234656
              ],
              [
                46.126524,
                35.23465
              ],
              [
                46.12654,
                35.234478
              ],
              [
                46.12652,
                35.234306
              ],
              [
                46.126453,
                35.234104
              ],
              [
                46.126331,
                35.233888
              ],
              [
                46.12609,
                35.233576
              ],
              [
                46.125692,
                35.233176
              ],
              [
                46.12552,
                35.232958
              ],
              [
                46.125377,
                35.232856
              ],
              [
                46.124852,
                35.232532
              ],
              [
                46.124476,
                35.232371
              ],
              [
                46.124164,
                35.232216
              ],
              [
                46.123914,
                35.232001
              ],
              [
                46.123673,
                35.231727
              ],
              [
                46.123469,
                35.231452
              ],
              [
                46.12348,
                35.231447
              ],
              [
                46.131258,
                35.22771
              ],
              [
                46.13169,
                35.227824
              ],
              [
                46.132558,
                35.227977
              ],
              [
                46.133344,
                35.228252
              ],
              [
                46.134671,
                35.228662
              ],
              [
                46.135449,
                35.228658
              ],
              [
                46.136813,
                35.2288
              ],
              [
                46.138738,
                35.2287
              ],
              [
                46.14005,
                35.228302
              ],
              [
                46.141081,
                35.228176
              ],
              [
                46.141803,
                35.22812
              ],
              [
                46.142923,
                35.228269
              ],
              [
                46.144479,
                35.228468
              ],
              [
                46.146011,
                35.228225
              ],
              [
                46.147393,
                35.228084
              ],
              [
                46.148208,
                35.227968
              ],
              [
                46.14965,
                35.227348
              ],
              [
                46.150633,
                35.226649
              ],
              [
                46.15136,
                35.226062
              ],
              [
                46.152408,
                35.22585
              ],
              [
                46.153205,
                35.225717
              ],
              [
                46.154726,
                35.225435
              ],
              [
                46.15548,
                35.225445
              ],
              [
                46.156023,
                35.225684
              ],
              [
                46.158043,
                35.225877
              ],
              [
                46.158944,
                35.225277
              ],
              [
                46.160211,
                35.224368
              ],
              [
                46.16232,
                35.222943
              ],
              [
                46.162962,
                35.222944
              ],
              [
                46.163428,
                35.223197
              ],
              [
                46.1641,
                35.223609
              ],
              [
                46.164509,
                35.224154
              ],
              [
                46.165024,
                35.224637
              ],
              [
                46.166131,
                35.22434
              ],
              [
                46.167485,
                35.2241
              ],
              [
                46.168431,
                35.224064
              ],
              [
                46.16901,
                35.223984
              ],
              [
                46.16959,
                35.224402
              ],
              [
                46.170031,
                35.224816
              ],
              [
                46.170251,
                35.225221
              ],
              [
                46.170643,
                35.225406
              ],
              [
                46.171219,
                35.225367
              ],
              [
                46.171745,
                35.225391
              ],
              [
                46.172418,
                35.225355
              ],
              [
                46.174727,
                35.227353
              ],
              [
                46.176822,
                35.228746
              ],
              [
                46.177792,
                35.228359
              ],
              [
                46.178566,
                35.227867
              ],
              [
                46.179189,
                35.22747
              ],
              [
                46.179595,
                35.227224
              ],
              [
                46.179908,
                35.227104
              ],
              [
                46.180427,
                35.226817
              ],
              [
                46.180501,
                35.226621
              ],
              [
                46.18068,
                35.22651
              ],
              [
                46.181278,
                35.226387
              ],
              [
                46.182291,
                35.225939
              ],
              [
                46.182716,
                35.225662
              ],
              [
                46.183919,
                35.225267
              ],
              [
                46.183967,
                35.225235
              ],
              [
                46.184435,
                35.224684
              ],
              [
                46.185128,
                35.223888
              ],
              [
                46.18554,
                35.223407
              ],
              [
                46.185758,
                35.223295
              ],
              [
                46.186267,
                35.222337
              ],
              [
                46.18673,
                35.222074
              ],
              [
                46.187197,
                35.221405
              ],
              [
                46.187683,
                35.220768
              ],
              [
                46.188154,
                35.220466
              ],
              [
                46.188649,
                35.219654
              ],
              [
                46.188804,
                35.219287
              ],
              [
                46.189418,
                35.218296
              ],
              [
                46.189443,
                35.218023
              ],
              [
                46.189354,
                35.21782
              ],
              [
                46.189324,
                35.217603
              ],
              [
                46.189287,
                35.217379
              ],
              [
                46.189407,
                35.217023
              ],
              [
                46.189846,
                35.216692
              ],
              [
                46.190326,
                35.216433
              ],
              [
                46.194178,
                35.210945
              ],
              [
                46.194385,
                35.209715
              ],
              [
                46.194911,
                35.207934
              ],
              [
                46.195376,
                35.20694
              ],
              [
                46.195218,
                35.206212
              ],
              [
                46.194745,
                35.205481
              ],
              [
                46.194432,
                35.204741
              ],
              [
                46.194216,
                35.203951
              ],
              [
                46.193999,
                35.203057
              ],
              [
                46.19478,
                35.202668
              ],
              [
                46.19587,
                35.202602
              ],
              [
                46.196877,
                35.202295
              ],
              [
                46.198116,
                35.201932
              ],
              [
                46.199285,
                35.201811
              ],
              [
                46.200277,
                35.201513
              ],
              [
                46.201247,
                35.201229
              ],
              [
                46.2018787,
                35.2009191
              ],
              [
                46.2020044,
                35.2008198
              ],
              [
                46.202009,
                35.2005303
              ],
              [
                46.2023776,
                35.1979544
              ],
              [
                46.2026621,
                35.1967627
              ],
              [
                46.2029851,
                35.1957771
              ],
              [
                46.2030725,
                35.1954595
              ],
              [
                46.2031204,
                35.195221
              ],
              [
                46.2032241,
                35.1947348
              ],
              [
                46.2033783,
                35.1944948
              ],
              [
                46.203746,
                35.193906
              ],
              [
                46.2041902,
                35.19337
              ],
              [
                46.2044438,
                35.1930084
              ],
              [
                46.2042349,
                35.1927355
              ],
              [
                46.2041507,
                35.1923383
              ],
              [
                46.2042583,
                35.1909054
              ],
              [
                46.2036283,
                35.1890367
              ],
              [
                46.2031846,
                35.1892218
              ],
              [
                46.2028673,
                35.1892722
              ],
              [
                46.2023295,
                35.1895576
              ],
              [
                46.2015695,
                35.1901493
              ],
              [
                46.2003896,
                35.1907934
              ],
              [
                46.1995453,
                35.1911641
              ],
              [
                46.198418,
                35.191061
              ],
              [
                46.197327,
                35.189479
              ],
              [
                46.196528,
                35.188424
              ],
              [
                46.196082,
                35.186654
              ],
              [
                46.195818,
                35.185496
              ],
              [
                46.196014,
                35.184791
              ],
              [
                46.194975,
                35.184013
              ],
              [
                46.194476,
                35.184013
              ],
              [
                46.193655,
                35.184204
              ],
              [
                46.191982,
                35.18411
              ],
              [
                46.190305,
                35.183913
              ],
              [
                46.187766,
                35.183715
              ],
              [
                46.18683,
                35.183833
              ],
              [
                46.185251,
                35.184326
              ],
              [
                46.184195,
                35.183404
              ],
              [
                46.183721,
                35.183078
              ],
              [
                46.182878,
                35.182782
              ],
              [
                46.181808,
                35.181634
              ],
              [
                46.181048,
                35.181072
              ],
              [
                46.180397,
                35.180697
              ],
              [
                46.179787,
                35.1805121
              ],
              [
                46.178542,
                35.179992
              ],
              [
                46.177666,
                35.179494
              ],
              [
                46.177152,
                35.179217
              ],
              [
                46.176806,
                35.178867
              ],
              [
                46.17641,
                35.178443
              ],
              [
                46.176066,
                35.177738
              ],
              [
                46.176021,
                35.176955
              ],
              [
                46.17577,
                35.17643
              ],
              [
                46.175343,
                35.175991
              ],
              [
                46.174736,
                35.175806
              ],
              [
                46.174098,
                35.175564
              ],
              [
                46.173505,
                35.175387
              ],
              [
                46.172979,
                35.175249
              ],
              [
                46.172651,
                35.174916
              ],
              [
                46.172422,
                35.174689
              ],
              [
                46.172048,
                35.174386
              ],
              [
                46.171455,
                35.173979
              ],
              [
                46.170928,
                35.173747
              ],
              [
                46.169963,
                35.173631
              ],
              [
                46.169295,
                35.173469
              ],
              [
                46.168465,
                35.173264
              ],
              [
                46.168001,
                35.173062
              ],
              [
                46.166786,
                35.172785
              ],
              [
                46.166203,
                35.172502
              ],
              [
                46.165878,
                35.172043
              ],
              [
                46.165507,
                35.171385
              ],
              [
                46.165358,
                35.170976
              ],
              [
                46.164991,
                35.170421
              ],
              [
                46.164753,
                35.169894
              ],
              [
                46.164574,
                35.169699
              ],
              [
                46.164153,
                35.169416
              ],
              [
                46.163628,
                35.169329
              ],
              [
                46.163233,
                35.169135
              ],
              [
                46.162888,
                35.168701
              ],
              [
                46.162506,
                35.168232
              ],
              [
                46.161946,
                35.167527
              ],
              [
                46.161814,
                35.167084
              ],
              [
                46.161694,
                35.166815
              ],
              [
                46.161539,
                35.166657
              ],
              [
                46.160877,
                35.166337
              ],
              [
                46.160715,
                35.166108
              ],
              [
                46.160377,
                35.165516
              ],
              [
                46.160026,
                35.165469
              ],
              [
                46.159453,
                35.165402
              ],
              [
                46.159074,
                35.165215
              ],
              [
                46.158641,
                35.165028
              ],
              [
                46.158421,
                35.164924
              ],
              [
                46.157905,
                35.164638
              ],
              [
                46.157437,
                35.164291
              ],
              [
                46.156963,
                35.164236
              ],
              [
                46.156918,
                35.163859
              ],
              [
                46.156868,
                35.163556
              ],
              [
                46.156729,
                35.16327
              ],
              [
                46.156705,
                35.162962
              ],
              [
                46.156818,
                35.162388
              ],
              [
                46.15692,
                35.162097
              ],
              [
                46.15686,
                35.161806
              ],
              [
                46.156635,
                35.161276
              ],
              [
                46.156402,
                35.16081
              ],
              [
                46.156146,
                35.160495
              ],
              [
                46.156101,
                35.160295
              ],
              [
                46.155921,
                35.159965
              ],
              [
                46.155373,
                35.15957
              ],
              [
                46.154944,
                35.159215
              ],
              [
                46.154758,
                35.159001
              ],
              [
                46.154892,
                35.158589
              ],
              [
                46.155127,
                35.1582
              ],
              [
                46.155261,
                35.157653
              ],
              [
                46.155225,
                35.157034
              ],
              [
                46.154997,
                35.15663
              ],
              [
                46.154635,
                35.156001
              ],
              [
                46.154474,
                35.155553
              ],
              [
                46.155113,
                35.155239
              ],
              [
                46.155717,
                35.154914
              ],
              [
                46.156333,
                35.154357
              ],
              [
                46.156147,
                35.153914
              ],
              [
                46.15632,
                35.153317
              ],
              [
                46.156587,
                35.152765
              ],
              [
                46.156918,
                35.151972
              ],
              [
                46.157436,
                35.151538
              ],
              [
                46.158401,
                35.150976
              ],
              [
                46.158965,
                35.150513
              ],
              [
                46.159755,
                35.149818
              ],
              [
                46.160254,
                35.149138
              ],
              [
                46.160019,
                35.14862
              ],
              [
                46.159683,
                35.148122
              ],
              [
                46.159307,
                35.147674
              ],
              [
                46.159362,
                35.147225
              ],
              [
                46.159518,
                35.146299
              ],
              [
                46.159411,
                35.145214
              ],
              [
                46.159672,
                35.144371
              ],
              [
                46.1598098,
                35.1434076
              ],
              [
                46.1594493,
                35.1430848
              ],
              [
                46.1592146,
                35.1426813
              ],
              [
                46.1590804,
                35.1424137
              ],
              [
                46.1590923,
                35.1422497
              ],
              [
                46.1591487,
                35.141796
              ],
              [
                46.1591398,
                35.1413442
              ],
              [
                46.160176,
                35.140625
              ],
              [
                46.1607957,
                35.1399093
              ],
              [
                46.160904,
                35.13963
              ],
              [
                46.16046,
                35.139132
              ],
              [
                46.160076,
                35.138611
              ],
              [
                46.159662,
                35.138128
              ],
              [
                46.159227,
                35.137524
              ],
              [
                46.159008,
                35.137108
              ],
              [
                46.158781,
                35.136526
              ],
              [
                46.158415,
                35.136065
              ],
              [
                46.157987,
                35.135804
              ],
              [
                46.157834,
                35.135427
              ],
              [
                46.157321,
                35.135015
              ],
              [
                46.156967,
                35.134687
              ],
              [
                46.156144,
                35.134367
              ],
              [
                46.155701,
                35.133785
              ],
              [
                46.155696,
                35.133181
              ],
              [
                46.155908,
                35.132577
              ],
              [
                46.156136,
                35.131803
              ],
              [
                46.155577,
                35.130421
              ],
              [
                46.154958,
                35.129519
              ],
              [
                46.155059,
                35.128999
              ],
              [
                46.155748,
                35.128594
              ],
              [
                46.156438,
                35.128148
              ],
              [
                46.156677,
                35.127456
              ],
              [
                46.157397,
                35.12716
              ],
              [
                46.158438,
                35.126532
              ],
              [
                46.158756,
                35.126199
              ],
              [
                46.159041,
                35.125842
              ],
              [
                46.159946,
                35.12476
              ],
              [
                46.16118,
                35.124011
              ],
              [
                46.161895,
                35.123696
              ],
              [
                46.163021,
                35.123312
              ],
              [
                46.163861,
                35.122826
              ],
              [
                46.164582,
                35.122395
              ],
              [
                46.16536,
                35.122109
              ],
              [
                46.166094,
                35.121634
              ],
              [
                46.16663,
                35.121395
              ],
              [
                46.167151,
                35.120971
              ],
              [
                46.167826,
                35.120747
              ],
              [
                46.168428,
                35.120141
              ],
              [
                46.168952,
                35.119727
              ],
              [
                46.169356,
                35.119273
              ],
              [
                46.170107,
                35.118899
              ],
              [
                46.17061,
                35.118458
              ],
              [
                46.171481,
                35.117987
              ],
              [
                46.173209,
                35.118175
              ],
              [
                46.174479,
                35.118367
              ],
              [
                46.175525,
                35.118436
              ],
              [
                46.176493,
                35.118249
              ],
              [
                46.177218,
                35.117692
              ],
              [
                46.178299,
                35.117067
              ],
              [
                46.179298,
                35.116165
              ],
              [
                46.180194,
                35.115825
              ],
              [
                46.181389,
                35.11549
              ],
              [
                46.183031,
                35.115027
              ],
              [
                46.183591,
                35.114189
              ],
              [
                46.184374,
                35.113558
              ],
              [
                46.1857651,
                35.1134592
              ],
              [
                46.1869921,
                35.1132968
              ],
              [
                46.1881289,
                35.113282
              ],
              [
                46.189428,
                35.1124998
              ],
              [
                46.1901498,
                35.1115551
              ],
              [
                46.1912362,
                35.1109166
              ],
              [
                46.1903935,
                35.1105613
              ],
              [
                46.1899837,
                35.1103888
              ],
              [
                46.1896095,
                35.1102122
              ],
              [
                46.1890067,
                35.1099458
              ],
              [
                46.1886211,
                35.1097479
              ],
              [
                46.1883018,
                35.1095416
              ],
              [
                46.1880563,
                35.109358
              ],
              [
                46.1878413,
                35.1091745
              ],
              [
                46.1873962,
                35.1087614
              ],
              [
                46.1872685,
                35.1086437
              ],
              [
                46.1871317,
                35.108536
              ],
              [
                46.1869309,
                35.1083866
              ],
              [
                46.1867378,
                35.1082583
              ],
              [
                46.1865823,
                35.1081662
              ],
              [
                46.1863782,
                35.108048
              ],
              [
                46.1863076,
                35.1080056
              ],
              [
                46.1862279,
                35.1079632
              ],
              [
                46.1861141,
                35.1079107
              ],
              [
                46.1858499,
                35.1078031
              ],
              [
                46.1856025,
                35.1077096
              ],
              [
                46.1854066,
                35.1076298
              ],
              [
                46.185204,
                35.1075446
              ],
              [
                46.1848862,
                35.1073762
              ],
              [
                46.1847715,
                35.1073291
              ],
              [
                46.1846165,
                35.1072746
              ],
              [
                46.1843641,
                35.1071891
              ],
              [
                46.1841229,
                35.1071101
              ],
              [
                46.1840043,
                35.1070783
              ],
              [
                46.1838575,
                35.1070531
              ],
              [
                46.183719,
                35.1070272
              ],
              [
                46.183555,
                35.1070017
              ],
              [
                46.1834271,
                35.1069777
              ],
              [
                46.1832996,
                35.1069472
              ],
              [
                46.1831872,
                35.1069112
              ],
              [
                46.1830855,
                35.1068635
              ],
              [
                46.1828521,
                35.1067484
              ],
              [
                46.1826333,
                35.1066282
              ],
              [
                46.1824254,
                35.1065051
              ],
              [
                46.1820239,
                35.1062147
              ],
              [
                46.1813464,
                35.1056934
              ],
              [
                46.1812418,
                35.1056257
              ],
              [
                46.1810832,
                35.1055373
              ],
              [
                46.1809499,
                35.1054579
              ],
              [
                46.1807517,
                35.1053239
              ],
              [
                46.1806039,
                35.1052135
              ],
              [
                46.1803491,
                35.1049927
              ],
              [
                46.1800654,
                35.1047836
              ],
              [
                46.1798882,
                35.1046661
              ],
              [
                46.1797868,
                35.1046135
              ],
              [
                46.1796796,
                35.10456
              ],
              [
                46.1795836,
                35.1045222
              ],
              [
                46.1794731,
                35.1044843
              ],
              [
                46.1792475,
                35.1044056
              ],
              [
                46.178967,
                35.1042999
              ],
              [
                46.1786956,
                35.1041926
              ],
              [
                46.1783492,
                35.1040578
              ],
              [
                46.1780209,
                35.1039201
              ],
              [
                46.1777145,
                35.1037854
              ],
              [
                46.1775742,
                35.1037181
              ],
              [
                46.1771968,
                35.1035209
              ],
              [
                46.1770168,
                35.1034589
              ],
              [
                46.1768375,
                35.1034142
              ],
              [
                46.1767182,
                35.1033695
              ],
              [
                46.176454,
                35.1032345
              ],
              [
                46.1761486,
                35.1030803
              ],
              [
                46.1758419,
                35.1029442
              ],
              [
                46.1755207,
                35.102814
              ],
              [
                46.1751252,
                35.1026387
              ],
              [
                46.1749286,
                35.1025571
              ],
              [
                46.1747212,
                35.1024844
              ],
              [
                46.1743031,
                35.1023407
              ],
              [
                46.1741508,
                35.1022915
              ],
              [
                46.1739985,
                35.1022423
              ],
              [
                46.1738851,
                35.1021985
              ],
              [
                46.1737793,
                35.1021494
              ],
              [
                46.1736933,
                35.1021018
              ],
              [
                46.1735853,
                35.1020198
              ],
              [
                46.1734196,
                35.1018964
              ],
              [
                46.1731655,
                35.101657
              ],
              [
                46.17304,
                35.1015079
              ],
              [
                46.1729874,
                35.1014103
              ],
              [
                46.1729636,
                35.1013068
              ],
              [
                46.1729593,
                35.1011894
              ],
              [
                46.1729369,
                35.1010867
              ],
              [
                46.1728813,
                35.1009492
              ],
              [
                46.172833,
                35.1008374
              ],
              [
                46.1727505,
                35.1006371
              ],
              [
                46.172679,
                35.1004245
              ],
              [
                46.1726148,
                35.1002148
              ],
              [
                46.1725298,
                35.0999948
              ],
              [
                46.1724692,
                35.099884
              ],
              [
                46.1724051,
                35.0997821
              ],
              [
                46.1722863,
                35.0996426
              ],
              [
                46.1721619,
                35.0995072
              ],
              [
                46.1720582,
                35.0994085
              ],
              [
                46.1719793,
                35.0993481
              ],
              [
                46.1719004,
                35.0992995
              ],
              [
                46.1717984,
                35.0992503
              ],
              [
                46.1716332,
                35.0991907
              ],
              [
                46.1715423,
                35.0991561
              ],
              [
                46.1714459,
                35.0991245
              ],
              [
                46.171336,
                35.099098
              ],
              [
                46.1712026,
                35.0990759
              ],
              [
                46.1710685,
                35.0990518
              ],
              [
                46.1709411,
                35.0990236
              ],
              [
                46.1708064,
                35.0989864
              ],
              [
                46.1701061,
                35.0987905
              ],
              [
                46.1695675,
                35.0986771
              ],
              [
                46.1694527,
                35.0986616
              ],
              [
                46.1693379,
                35.098655
              ],
              [
                46.1690417,
                35.0986599
              ],
              [
                46.1689093,
                35.0986517
              ],
              [
                46.1687842,
                35.0986347
              ],
              [
                46.168636,
                35.0986125
              ],
              [
                46.1685095,
                35.0985843
              ],
              [
                46.1681515,
                35.0984776
              ],
              [
                46.168001,
                35.0984292
              ],
              [
                46.1679045,
                35.0983938
              ],
              [
                46.1677973,
                35.0983485
              ],
              [
                46.1676831,
                35.0982928
              ],
              [
                46.1675552,
                35.0982197
              ],
              [
                46.1674329,
                35.0981356
              ],
              [
                46.1673321,
                35.0980631
              ],
              [
                46.1672055,
                35.0979621
              ],
              [
                46.1671152,
                35.0978977
              ],
              [
                46.1670401,
                35.0978308
              ],
              [
                46.1669566,
                35.0977391
              ],
              [
                46.1668703,
                35.0976195
              ],
              [
                46.1668053,
                35.097495
              ],
              [
                46.1666524,
                35.0971747
              ],
              [
                46.1664135,
                35.0965067
              ],
              [
                46.1663201,
                35.0962309
              ],
              [
                46.1662606,
                35.0961154
              ],
              [
                46.1661949,
                35.0960024
              ],
              [
                46.1658928,
                35.0955772
              ],
              [
                46.1657323,
                35.0953595
              ],
              [
                46.1656551,
                35.0952395
              ],
              [
                46.1655786,
                35.0951112
              ],
              [
                46.16549,
                35.0949904
              ],
              [
                46.1653362,
                35.0948018
              ],
              [
                46.1651973,
                35.0946183
              ],
              [
                46.1650462,
                35.0944374
              ],
              [
                46.1647138,
                35.0940904
              ],
              [
                46.1645604,
                35.0938942
              ],
              [
                46.1645176,
                35.0938334
              ],
              [
                46.1644747,
                35.0937849
              ],
              [
                46.1644162,
                35.0937303
              ],
              [
                46.1643612,
                35.0936893
              ],
              [
                46.1643031,
                35.0936484
              ],
              [
                46.1642143,
                35.0935664
              ],
              [
                46.1640459,
                35.0933976
              ],
              [
                46.1635802,
                35.0928616
              ],
              [
                46.1633291,
                35.092606
              ],
              [
                46.1631801,
                35.0924447
              ],
              [
                46.1630462,
                35.0922821
              ],
              [
                46.1629645,
                35.0921725
              ],
              [
                46.1629085,
                35.0920861
              ],
              [
                46.1628737,
                35.092022
              ],
              [
                46.1628238,
                35.091905
              ],
              [
                46.1627831,
                35.0918128
              ],
              [
                46.1627366,
                35.0917382
              ],
              [
                46.1626811,
                35.0916661
              ],
              [
                46.1625396,
                35.091492
              ],
              [
                46.1624883,
                35.0914399
              ],
              [
                46.1624401,
                35.0913852
              ],
              [
                46.1624166,
                35.091343
              ],
              [
                46.1623998,
                35.0912908
              ],
              [
                46.1623814,
                35.0912286
              ],
              [
                46.1623537,
                35.0911539
              ],
              [
                46.1622594,
                35.0909519
              ],
              [
                46.1621925,
                35.0907599
              ],
              [
                46.1621259,
                35.0905365
              ],
              [
                46.1621108,
                35.090426
              ],
              [
                46.1621063,
                35.0903167
              ],
              [
                46.1621063,
                35.0901797
              ],
              [
                46.1620967,
                35.0901171
              ],
              [
                46.1620872,
                35.0900621
              ],
              [
                46.1620682,
                35.0899718
              ],
              [
                46.1620499,
                35.0899062
              ],
              [
                46.1620191,
                35.0898011
              ],
              [
                46.1619869,
                35.0897197
              ],
              [
                46.1618784,
                35.0895554
              ],
              [
                46.1617578,
                35.0893813
              ],
              [
                46.1617028,
                35.0892923
              ],
              [
                46.1616554,
                35.0892233
              ],
              [
                46.1612548,
                35.0887594
              ],
              [
                46.1610667,
                35.0885759
              ],
              [
                46.1604081,
                35.087976
              ],
              [
                46.1603182,
                35.0878893
              ],
              [
                46.1602252,
                35.0878051
              ],
              [
                46.1601031,
                35.0877112
              ],
              [
                46.1598879,
                35.0875806
              ],
              [
                46.1597181,
                35.0874756
              ],
              [
                46.159395,
                35.0872576
              ],
              [
                46.1592074,
                35.0871503
              ],
              [
                46.1590108,
                35.0870604
              ],
              [
                46.1585408,
                35.0868717
              ],
              [
                46.1581375,
                35.0867572
              ],
              [
                46.1577949,
                35.0866923
              ],
              [
                46.1576104,
                35.0866404
              ],
              [
                46.157443,
                35.0866165
              ],
              [
                46.1573186,
                35.0866108
              ],
              [
                46.157147,
                35.0866136
              ],
              [
                46.1568124,
                35.0866296
              ],
              [
                46.1563447,
                35.0866421
              ],
              [
                46.1561238,
                35.086694
              ],
              [
                46.1560133,
                35.0867095
              ],
              [
                46.1559028,
                35.0867179
              ],
              [
                46.1557721,
                35.08671
              ],
              [
                46.1554975,
                35.0866687
              ],
              [
                46.1552299,
                35.0866207
              ],
              [
                46.1549998,
                35.0865678
              ],
              [
                46.1547564,
                35.0865175
              ],
              [
                46.1545659,
                35.0864905
              ],
              [
                46.1544083,
                35.086484
              ],
              [
                46.1542443,
                35.0864899
              ],
              [
                46.1539078,
                35.086505
              ],
              [
                46.1532605,
                35.0865284
              ],
              [
                46.1525116,
                35.0866086
              ],
              [
                46.1523982,
                35.0866212
              ],
              [
                46.1523135,
                35.086646
              ],
              [
                46.1522541,
                35.0866708
              ],
              [
                46.1521924,
                35.0867038
              ],
              [
                46.1521077,
                35.0867322
              ],
              [
                46.1519812,
                35.0867539
              ],
              [
                46.1518569,
                35.0867692
              ],
              [
                46.1516382,
                35.0867845
              ],
              [
                46.1514795,
                35.0868068
              ],
              [
                46.151346,
                35.0868406
              ],
              [
                46.1512489,
                35.0868622
              ],
              [
                46.1511448,
                35.0868632
              ],
              [
                46.1509882,
                35.0868406
              ],
              [
                46.1508252,
                35.0868129
              ],
              [
                46.1507258,
                35.0867919
              ],
              [
                46.1506536,
                35.0867857
              ],
              [
                46.150592,
                35.0867846
              ],
              [
                46.1505152,
                35.0867859
              ],
              [
                46.1504161,
                35.086791
              ],
              [
                46.1502636,
                35.0867988
              ],
              [
                46.1499134,
                35.0868204
              ],
              [
                46.1498524,
                35.0868219
              ],
              [
                46.1497959,
                35.0868123
              ],
              [
                46.1497484,
                35.0867952
              ],
              [
                46.1496658,
                35.0867685
              ],
              [
                46.1496066,
                35.0867549
              ],
              [
                46.1495368,
                35.0867525
              ],
              [
                46.1494154,
                35.086765
              ],
              [
                46.1491938,
                35.0867901
              ],
              [
                46.1487104,
                35.086841
              ],
              [
                46.1485813,
                35.0868576
              ],
              [
                46.1484691,
                35.0868892
              ],
              [
                46.1483419,
                35.0869279
              ],
              [
                46.1481347,
                35.0869806
              ],
              [
                46.1479264,
                35.0870123
              ],
              [
                46.1476813,
                35.0870335
              ],
              [
                46.1473521,
                35.0870473
              ],
              [
                46.1470791,
                35.0870531
              ],
              [
                46.1469303,
                35.0870568
              ],
              [
                46.146835,
                35.0870647
              ],
              [
                46.146563,
                35.0871052
              ],
              [
                46.1463152,
                35.0871478
              ],
              [
                46.1461656,
                35.0871762
              ],
              [
                46.1460404,
                35.0872025
              ],
              [
                46.1459627,
                35.0872209
              ],
              [
                46.1458892,
                35.0872358
              ],
              [
                46.1458535,
                35.0872378
              ],
              [
                46.1458241,
                35.0872376
              ],
              [
                46.1457788,
                35.0872349
              ],
              [
                46.145728,
                35.0872273
              ],
              [
                46.1456884,
                35.0872202
              ],
              [
                46.1456508,
                35.0872105
              ],
              [
                46.1456205,
                35.0871986
              ],
              [
                46.1455825,
                35.0871783
              ],
              [
                46.1455448,
                35.0871555
              ],
              [
                46.1454568,
                35.0870902
              ],
              [
                46.1454337,
                35.0870765
              ],
              [
                46.145411,
                35.0870664
              ],
              [
                46.1453652,
                35.08705
              ],
              [
                46.1452943,
                35.0870231
              ],
              [
                46.145254,
                35.0870065
              ],
              [
                46.1452004,
                35.0869807
              ],
              [
                46.1451511,
                35.0869557
              ],
              [
                46.1450976,
                35.0869323
              ],
              [
                46.1450412,
                35.0869136
              ],
              [
                46.1449847,
                35.0868974
              ],
              [
                46.1449651,
                35.0868927
              ],
              [
                46.1449447,
                35.0868887
              ],
              [
                46.1449207,
                35.0868868
              ],
              [
                46.144899,
                35.086888
              ],
              [
                46.1448787,
                35.0868932
              ],
              [
                46.1448493,
                35.086904
              ],
              [
                46.1448404,
                35.0869064
              ],
              [
                46.144832,
                35.0869078
              ],
              [
                46.1448254,
                35.0869082
              ],
              [
                46.1448184,
                35.0869079
              ],
              [
                46.1448122,
                35.0869065
              ],
              [
                46.1448079,
                35.0869051
              ],
              [
                46.1448001,
                35.0869015
              ],
              [
                46.1447893,
                35.0868951
              ],
              [
                46.144775,
                35.0868857
              ],
              [
                46.1447572,
                35.086875
              ],
              [
                46.1447356,
                35.0868643
              ],
              [
                46.1447109,
                35.0868571
              ],
              [
                46.1446862,
                35.0868523
              ],
              [
                46.1446103,
                35.0868444
              ],
              [
                46.144539,
                35.0868393
              ],
              [
                46.1444661,
                35.0868378
              ],
              [
                46.1443417,
                35.0868349
              ],
              [
                46.1442398,
                35.0868261
              ],
              [
                46.1441636,
                35.0868135
              ],
              [
                46.1440747,
                35.0867887
              ],
              [
                46.1440001,
                35.0867639
              ],
              [
                46.1439125,
                35.0867353
              ],
              [
                46.1438195,
                35.0867127
              ],
              [
                46.1437486,
                35.0866966
              ],
              [
                46.1436814,
                35.0866842
              ],
              [
                46.1435902,
                35.0866698
              ],
              [
                46.1435089,
                35.0866586
              ],
              [
                46.1433684,
                35.0866436
              ],
              [
                46.1433235,
                35.0866388
              ],
              [
                46.143284,
                35.0866323
              ],
              [
                46.1432484,
                35.0866254
              ],
              [
                46.1431924,
                35.0866185
              ],
              [
                46.1431384,
                35.0866154
              ],
              [
                46.1430604,
                35.0866151
              ],
              [
                46.1429816,
                35.0866173
              ],
              [
                46.1429141,
                35.08662
              ],
              [
                46.142735,
                35.086641
              ],
              [
                46.1426571,
                35.0866437
              ],
              [
                46.1425579,
                35.0866389
              ],
              [
                46.1424475,
                35.0866195
              ],
              [
                46.142339,
                35.0865856
              ],
              [
                46.1422252,
                35.0865403
              ],
              [
                46.1417901,
                35.086338
              ],
              [
                46.1414036,
                35.0861706
              ],
              [
                46.1410914,
                35.0860166
              ],
              [
                46.1407564,
                35.0858477
              ],
              [
                46.1404839,
                35.0856862
              ],
              [
                46.140214,
                35.0855067
              ],
              [
                46.1399594,
                35.0853248
              ],
              [
                46.1396622,
                35.0851429
              ],
              [
                46.1393955,
                35.0849858
              ],
              [
                46.1391912,
                35.0848646
              ],
              [
                46.1390781,
                35.0848079
              ],
              [
                46.1389549,
                35.0847518
              ],
              [
                46.1387225,
                35.0846584
              ],
              [
                46.1385023,
                35.0845873
              ],
              [
                46.137979,
                35.0844413
              ],
              [
                46.1377177,
                35.084373
              ],
              [
                46.1374838,
                35.0843022
              ],
              [
                46.1370069,
                35.0841532
              ],
              [
                46.1357904,
                35.0838985
              ],
              [
                46.1355503,
                35.0838448
              ],
              [
                46.1353163,
                35.0837875
              ],
              [
                46.1348604,
                35.0836653
              ],
              [
                46.1341657,
                35.0834868
              ],
              [
                46.133826,
                35.0834308
              ],
              [
                46.1337448,
                35.0834112
              ],
              [
                46.1336781,
                35.0833886
              ],
              [
                46.1336086,
                35.0833645
              ],
              [
                46.1335392,
                35.0833464
              ],
              [
                46.1334859,
                35.0833344
              ],
              [
                46.133416,
                35.0833292
              ],
              [
                46.1333514,
                35.0833291
              ],
              [
                46.1331084,
                35.0833242
              ],
              [
                46.1330186,
                35.0833196
              ],
              [
                46.132945,
                35.0833127
              ],
              [
                46.1328539,
                35.0832998
              ],
              [
                46.1327731,
                35.0832838
              ],
              [
                46.1327068,
                35.0832685
              ],
              [
                46.1325112,
                35.0832132
              ],
              [
                46.1323717,
                35.0831724
              ],
              [
                46.1322585,
                35.0831439
              ],
              [
                46.1321618,
                35.0831217
              ],
              [
                46.1320726,
                35.083108
              ],
              [
                46.1320009,
                35.0830989
              ],
              [
                46.1319216,
                35.0830919
              ],
              [
                46.1318368,
                35.0830822
              ],
              [
                46.1317337,
                35.0830648
              ],
              [
                46.1315937,
                35.0830341
              ],
              [
                46.1306972,
                35.082807
              ],
              [
                46.1302766,
                35.0827067
              ],
              [
                46.1298764,
                35.0825981
              ],
              [
                46.1291372,
                35.0823621
              ],
              [
                46.1288206,
                35.0822587
              ],
              [
                46.128509,
                35.0821531
              ],
              [
                46.128177,
                35.0820236
              ],
              [
                46.12784,
                35.0818899
              ],
              [
                46.1272898,
                35.0816569
              ],
              [
                46.1271472,
                35.0815956
              ],
              [
                46.127029,
                35.0815369
              ],
              [
                46.1269139,
                35.0814592
              ],
              [
                46.126799,
                35.0813559
              ],
              [
                46.1266927,
                35.081254
              ],
              [
                46.1264878,
                35.0810353
              ],
              [
                46.1262965,
                35.0808482
              ],
              [
                46.1262304,
                35.0807736
              ],
              [
                46.1261708,
                35.080699
              ],
              [
                46.1260729,
                35.0805477
              ],
              [
                46.1259626,
                35.0803812
              ],
              [
                46.125865,
                35.0802293
              ],
              [
                46.1258075,
                35.0801543
              ],
              [
                46.125717,
                35.0800506
              ],
              [
                46.1255679,
                35.0798874
              ],
              [
                46.125273,
                35.079563
              ],
              [
                46.1251828,
                35.0794647
              ],
              [
                46.1251364,
                35.0794271
              ],
              [
                46.1250772,
                35.0793915
              ],
              [
                46.1249471,
                35.0793277
              ],
              [
                46.1248285,
                35.0792619
              ],
              [
                46.1247185,
                35.0791904
              ],
              [
                46.1246137,
                35.0791188
              ],
              [
                46.1244565,
                35.0790073
              ],
              [
                46.1243831,
                35.0789498
              ],
              [
                46.1243105,
                35.0788808
              ],
              [
                46.124237,
                35.0787988
              ],
              [
                46.1241797,
                35.0787292
              ],
              [
                46.124127,
                35.0786447
              ],
              [
                46.1239937,
                35.0784111
              ],
              [
                46.1239216,
                35.078292
              ],
              [
                46.1238524,
                35.078198
              ],
              [
                46.1237538,
                35.0780948
              ],
              [
                46.1236114,
                35.0780061
              ],
              [
                46.123473,
                35.0779426
              ],
              [
                46.1233175,
                35.0778896
              ],
              [
                46.1230707,
                35.0778399
              ],
              [
                46.1225129,
                35.0778281
              ],
              [
                46.1218776,
                35.0777926
              ],
              [
                46.1213066,
                35.0777922
              ],
              [
                46.1211198,
                35.0777623
              ],
              [
                46.1209304,
                35.0777136
              ],
              [
                46.12075,
                35.0776481
              ],
              [
                46.120595,
                35.0775827
              ],
              [
                46.1203413,
                35.0774242
              ],
              [
                46.1202279,
                35.0773403
              ],
              [
                46.1201437,
                35.0772832
              ],
              [
                46.1200697,
                35.0772386
              ],
              [
                46.1199379,
                35.0771691
              ],
              [
                46.1196976,
                35.0770433
              ],
              [
                46.1194677,
                35.0769018
              ],
              [
                46.1192825,
                35.0767728
              ],
              [
                46.1191548,
                35.0766729
              ],
              [
                46.118978,
                35.0765159
              ],
              [
                46.118799,
                35.0763519
              ],
              [
                46.1186415,
                35.0761879
              ],
              [
                46.1184333,
                35.0758956
              ],
              [
                46.1183137,
                35.0756964
              ],
              [
                46.1182176,
                35.0755621
              ],
              [
                46.118163,
                35.0754947
              ],
              [
                46.1174545,
                35.074739
              ],
              [
                46.117175,
                35.0745111
              ],
              [
                46.1169062,
                35.0743131
              ],
              [
                46.1167644,
                35.0742381
              ],
              [
                46.1166047,
                35.0741748
              ],
              [
                46.1164377,
                35.0741397
              ],
              [
                46.1162798,
                35.0741134
              ],
              [
                46.1161737,
                35.0741023
              ],
              [
                46.1160712,
                35.0741015
              ],
              [
                46.1159883,
                35.0741076
              ],
              [
                46.1159336,
                35.0741162
              ],
              [
                46.1158773,
                35.0741286
              ],
              [
                46.1157857,
                35.0741519
              ],
              [
                46.1156858,
                35.0741801
              ],
              [
                46.1155984,
                35.0742156
              ],
              [
                46.1154927,
                35.0742661
              ],
              [
                46.1154051,
                35.0743192
              ],
              [
                46.1152451,
                35.0744228
              ],
              [
                46.1149191,
                35.0746575
              ],
              [
                46.1145299,
                35.0750199
              ],
              [
                46.114376,
                35.0752099
              ],
              [
                46.1142565,
                35.0753964
              ],
              [
                46.1141722,
                35.0755206
              ],
              [
                46.1140726,
                35.0756472
              ],
              [
                46.1139883,
                35.0757298
              ],
              [
                46.1139219,
                35.0757885
              ],
              [
                46.1138433,
                35.0758472
              ],
              [
                46.1137567,
                35.0759045
              ],
              [
                46.1136553,
                35.075962
              ],
              [
                46.1134793,
                35.0760682
              ],
              [
                46.1133213,
                35.076195
              ],
              [
                46.1132084,
                35.0763042
              ],
              [
                46.1131243,
                35.0764266
              ],
              [
                46.1130349,
                35.0765726
              ],
              [
                46.1129383,
                35.0767039
              ],
              [
                46.1127911,
                35.0768529
              ],
              [
                46.1124209,
                35.077141
              ],
              [
                46.1123039,
                35.0772078
              ],
              [
                46.1122201,
                35.0772441
              ],
              [
                46.1121557,
                35.0772576
              ],
              [
                46.1120912,
                35.0772635
              ],
              [
                46.1120137,
                35.0772577
              ],
              [
                46.1119445,
                35.0772461
              ],
              [
                46.1118404,
                35.0772264
              ],
              [
                46.1116676,
                35.0771944
              ],
              [
                46.1115635,
                35.077187
              ],
              [
                46.1113855,
                35.0771931
              ],
              [
                46.1112503,
                35.0771852
              ],
              [
                46.1110916,
                35.0771693
              ],
              [
                46.1108923,
                35.0771228
              ],
              [
                46.1107058,
                35.0770727
              ],
              [
                46.1104531,
                35.0770323
              ],
              [
                46.110197,
                35.0770052
              ],
              [
                46.1099043,
                35.0769963
              ],
              [
                46.1094492,
                35.0769962
              ],
              [
                46.1092334,
                35.0770183
              ],
              [
                46.10905,
                35.0770611
              ],
              [
                46.1088233,
                35.077123
              ],
              [
                46.108658,
                35.0771614
              ],
              [
                46.1084989,
                35.0771916
              ],
              [
                46.1083723,
                35.0772219
              ],
              [
                46.1082202,
                35.0772646
              ],
              [
                46.1079814,
                35.0773413
              ],
              [
                46.1078268,
                35.0773745
              ],
              [
                46.1076831,
                35.0773959
              ],
              [
                46.1074936,
                35.077411
              ],
              [
                46.1071616,
                35.0774157
              ],
              [
                46.1068606,
                35.0774151
              ],
              [
                46.1066425,
                35.0773908
              ],
              [
                46.1063866,
                35.0773591
              ],
              [
                46.1061704,
                35.0773156
              ],
              [
                46.1054831,
                35.0771418
              ],
              [
                46.1049419,
                35.0770345
              ],
              [
                46.1046155,
                35.0769879
              ],
              [
                46.1042784,
                35.0769856
              ],
              [
                46.1038683,
                35.0770676
              ],
              [
                46.1034583,
                35.0771733
              ],
              [
                46.1031749,
                35.0772651
              ],
              [
                46.1029168,
                35.0773628
              ],
              [
                46.1024474,
                35.0775493
              ],
              [
                46.1020013,
                35.0777715
              ],
              [
                46.101613,
                35.0779937
              ],
              [
                46.1010729,
                35.078382
              ],
              [
                46.1009215,
                35.0784921
              ],
              [
                46.1007557,
                35.0785756
              ],
              [
                46.1005971,
                35.0786317
              ],
              [
                46.1004348,
                35.0786761
              ],
              [
                46.1001115,
                35.0787736
              ],
              [
                46.0998352,
                35.07888
              ],
              [
                46.0995215,
                35.0790216
              ],
              [
                46.0994169,
                35.0790643
              ],
              [
                46.0992979,
                35.0791071
              ],
              [
                46.0992006,
                35.0791247
              ],
              [
                46.0991116,
                35.0791261
              ],
              [
                46.0990263,
                35.0791097
              ],
              [
                46.0988592,
                35.07908
              ],
              [
                46.0985143,
                35.0790411
              ],
              [
                46.0981523,
                35.0791007
              ],
              [
                46.0979802,
                35.0791969
              ],
              [
                46.0978802,
                35.079293
              ],
              [
                46.0978322,
                35.0794343
              ],
              [
                46.0978276,
                35.0795726
              ],
              [
                46.0978307,
                35.0796581
              ],
              [
                46.0978286,
                35.079726
              ],
              [
                46.0978118,
                35.0797844
              ],
              [
                46.0977629,
                35.0798887
              ],
              [
                46.097727,
                35.0799716
              ],
              [
                46.0976961,
                35.0800546
              ],
              [
                46.0976717,
                35.0801386
              ],
              [
                46.0976549,
                35.0802226
              ],
              [
                46.0976023,
                35.0804035
              ],
              [
                46.0975498,
                35.0805624
              ],
              [
                46.0975071,
                35.080676
              ],
              [
                46.0974474,
                35.0808043
              ],
              [
                46.0973946,
                35.0808971
              ],
              [
                46.0973546,
                35.08099
              ],
              [
                46.0972912,
                35.0811455
              ],
              [
                46.0972125,
                35.0813502
              ],
              [
                46.0971636,
                35.0815107
              ],
              [
                46.097125,
                35.0816692
              ],
              [
                46.0970844,
                35.0818308
              ],
              [
                46.0970515,
                35.0819882
              ],
              [
                46.0970094,
                35.0822501
              ],
              [
                46.0969896,
                35.0823606
              ],
              [
                46.0969647,
                35.0824691
              ],
              [
                46.0969492,
                35.082514
              ],
              [
                46.0969234,
                35.0825693
              ],
              [
                46.0968754,
                35.0826423
              ],
              [
                46.0968108,
                35.0827488
              ],
              [
                46.0967619,
                35.0828625
              ],
              [
                46.0967309,
                35.0829762
              ],
              [
                46.0967008,
                35.0832206
              ],
              [
                46.0967217,
                35.0835422
              ],
              [
                46.0967167,
                35.0837161
              ],
              [
                46.0966684,
                35.0839131
              ],
              [
                46.096675,
                35.0842423
              ],
              [
                46.0965949,
                35.084703
              ],
              [
                46.0964743,
                35.0850602
              ],
              [
                46.0964241,
                35.0851928
              ],
              [
                46.0963509,
                35.0853275
              ],
              [
                46.096288,
                35.0854633
              ],
              [
                46.0961919,
                35.0856387
              ],
              [
                46.0961449,
                35.0857381
              ],
              [
                46.0960825,
                35.0859032
              ],
              [
                46.0960521,
                35.0860047
              ],
              [
                46.0960374,
                35.0860501
              ],
              [
                46.0960075,
                35.0861102
              ],
              [
                46.0959686,
                35.0861525
              ],
              [
                46.0959055,
                35.0862022
              ],
              [
                46.0958253,
                35.0862603
              ],
              [
                46.0956315,
                35.0863884
              ],
              [
                46.0953051,
                35.0866007
              ],
              [
                46.0952147,
                35.0866737
              ],
              [
                46.0951294,
                35.0867467
              ],
              [
                46.0950252,
                35.0868551
              ],
              [
                46.0949239,
                35.0869788
              ],
              [
                46.0948202,
                35.087098
              ],
              [
                46.0947676,
                35.0871517
              ],
              [
                46.0947136,
                35.0871981
              ],
              [
                46.0946458,
                35.0872477
              ],
              [
                46.0945704,
                35.0872868
              ],
              [
                46.0943783,
                35.0873623
              ],
              [
                46.094181,
                35.0874499
              ],
              [
                46.0940986,
                35.0875042
              ],
              [
                46.0940102,
                35.0875667
              ],
              [
                46.0938249,
                35.0877086
              ],
              [
                46.0937392,
                35.0877629
              ],
              [
                46.0936237,
                35.0878212
              ],
              [
                46.0935224,
                35.0878587
              ],
              [
                46.093363,
                35.0879024
              ],
              [
                46.0931666,
                35.0879481
              ],
              [
                46.0929906,
                35.087973
              ],
              [
                46.0927437,
                35.0880039
              ],
              [
                46.0925897,
                35.0880235
              ],
              [
                46.0924637,
                35.0880432
              ],
              [
                46.0923881,
                35.0880547
              ],
              [
                46.0922704,
                35.0880725
              ],
              [
                46.0921515,
                35.088084
              ],
              [
                46.0920325,
                35.0880934
              ],
              [
                46.0919049,
                35.0880974
              ],
              [
                46.09179,
                35.088095
              ],
              [
                46.0916675,
                35.088084
              ],
              [
                46.0915689,
                35.0880676
              ],
              [
                46.0914792,
                35.0880448
              ],
              [
                46.0913979,
                35.0880195
              ],
              [
                46.0913203,
                35.0880025
              ],
              [
                46.0912371,
                35.0879895
              ],
              [
                46.0910007,
                35.0879588
              ],
              [
                46.0907704,
                35.0879307
              ],
              [
                46.0906313,
                35.087908
              ],
              [
                46.0905441,
                35.0878886
              ],
              [
                46.0904594,
                35.0878651
              ],
              [
                46.0903232,
                35.0878201
              ],
              [
                46.0901887,
                35.0877865
              ],
              [
                46.0901085,
                35.0877758
              ],
              [
                46.0900343,
                35.0877774
              ],
              [
                46.0899219,
                35.0877905
              ],
              [
                46.0898285,
                35.0878011
              ],
              [
                46.0897575,
                35.0878088
              ],
              [
                46.089684,
                35.0878123
              ],
              [
                46.0896257,
                35.0878106
              ],
              [
                46.089565,
                35.0877985
              ],
              [
                46.0895036,
                35.0877779
              ],
              [
                46.0894524,
                35.0877512
              ],
              [
                46.0893397,
                35.0876893
              ],
              [
                46.0892666,
                35.0876632
              ],
              [
                46.0888765,
                35.0876025
              ],
              [
                46.0883042,
                35.0874801
              ],
              [
                46.0875765,
                35.087392
              ],
              [
                46.0868127,
                35.0872762
              ],
              [
                46.0862766,
                35.0871679
              ],
              [
                46.0856332,
                35.0870731
              ],
              [
                46.0854514,
                35.0870493
              ],
              [
                46.0853677,
                35.0870411
              ],
              [
                46.0852904,
                35.0870358
              ],
              [
                46.0852199,
                35.0870406
              ],
              [
                46.0851512,
                35.0870462
              ],
              [
                46.0850553,
                35.0870499
              ],
              [
                46.0849883,
                35.0870484
              ],
              [
                46.084925,
                35.0870396
              ],
              [
                46.0848779,
                35.0870308
              ],
              [
                46.0847987,
                35.0870165
              ],
              [
                46.0847294,
                35.0870023
              ],
              [
                46.0846808,
                35.0869893
              ],
              [
                46.0846186,
                35.0869711
              ],
              [
                46.0845394,
                35.0869465
              ],
              [
                46.0844384,
                35.0869217
              ],
              [
                46.0835424,
                35.0867607
              ],
              [
                46.0831833,
                35.0867032
              ],
              [
                46.0830198,
                35.0866762
              ],
              [
                46.0828778,
                35.0866457
              ],
              [
                46.0825398,
                35.0865199
              ],
              [
                46.0822137,
                35.0863915
              ],
              [
                46.0818748,
                35.0862675
              ],
              [
                46.0815391,
                35.0861426
              ],
              [
                46.0811977,
                35.0860564
              ],
              [
                46.0811071,
                35.0860278
              ],
              [
                46.0810331,
                35.086001
              ],
              [
                46.0809555,
                35.0859786
              ],
              [
                46.0808861,
                35.0859592
              ],
              [
                46.0808039,
                35.0859427
              ],
              [
                46.080651,
                35.0859163
              ],
              [
                46.0805486,
                35.0858928
              ],
              [
                46.0804872,
                35.0858778
              ],
              [
                46.080415,
                35.0858561
              ],
              [
                46.0803424,
                35.0858267
              ],
              [
                46.0802274,
                35.0857722
              ],
              [
                46.0800154,
                35.085666
              ],
              [
                46.0795915,
                35.0854375
              ],
              [
                46.0795172,
                35.0854061
              ],
              [
                46.0790235,
                35.0850415
              ],
              [
                46.0786524,
                35.0846451
              ],
              [
                46.0785662,
                35.0845328
              ],
              [
                46.0785021,
                35.0844172
              ],
              [
                46.0784198,
                35.0842221
              ],
              [
                46.0783645,
                35.0841298
              ],
              [
                46.0782875,
                35.0840713
              ],
              [
                46.078177,
                35.0840178
              ],
              [
                46.0780291,
                35.0839752
              ],
              [
                46.0779212,
                35.0839599
              ],
              [
                46.0778584,
                35.0839618
              ],
              [
                46.0778194,
                35.0839638
              ],
              [
                46.0777854,
                35.0839678
              ],
              [
                46.0777392,
                35.0839676
              ],
              [
                46.0776777,
                35.0839632
              ],
              [
                46.0775949,
                35.083957
              ],
              [
                46.0774953,
                35.0839456
              ],
              [
                46.0763375,
                35.0837971
              ],
              [
                46.0757843,
                35.0837584
              ],
              [
                46.0748612,
                35.0837148
              ],
              [
                46.0745051,
                35.0837091
              ],
              [
                46.0743846,
                35.0837173
              ],
              [
                46.0742076,
                35.0837448
              ],
              [
                46.0740883,
                35.0837709
              ],
              [
                46.0739354,
                35.0838164
              ],
              [
                46.0737431,
                35.0838905
              ],
              [
                46.0736897,
                35.0839092
              ],
              [
                46.0736493,
                35.0839193
              ],
              [
                46.0736065,
                35.0839281
              ],
              [
                46.0735653,
                35.0839297
              ],
              [
                46.0735287,
                35.0839289
              ],
              [
                46.0734564,
                35.0839173
              ],
              [
                46.0733887,
                35.0839008
              ],
              [
                46.0732815,
                35.0838659
              ],
              [
                46.0731896,
                35.083826
              ],
              [
                46.0729706,
                35.0837275
              ],
              [
                46.0725312,
                35.08353
              ],
              [
                46.0721956,
                35.083367
              ],
              [
                46.0720079,
                35.0832513
              ],
              [
                46.0718851,
                35.0831675
              ],
              [
                46.0717587,
                35.0830502
              ],
              [
                46.0716761,
                35.0829525
              ],
              [
                46.0715953,
                35.082843
              ],
              [
                46.0715312,
                35.0827362
              ],
              [
                46.0714643,
                35.0825964
              ],
              [
                46.0713667,
                35.0823996
              ],
              [
                46.071207,
                35.0821094
              ],
              [
                46.0711412,
                35.081986
              ],
              [
                46.0711047,
                35.0818798
              ],
              [
                46.0710931,
                35.0817757
              ],
              [
                46.0710941,
                35.0815417
              ],
              [
                46.0710961,
                35.0812981
              ],
              [
                46.0710887,
                35.0811451
              ],
              [
                46.071089,
                35.0810247
              ],
              [
                46.0711079,
                35.0809054
              ],
              [
                46.0711466,
                35.0807743
              ],
              [
                46.0712563,
                35.0804836
              ],
              [
                46.0713274,
                35.0802947
              ],
              [
                46.0713929,
                35.0801183
              ],
              [
                46.0715955,
                35.0796984
              ],
              [
                46.0717475,
                35.0794129
              ],
              [
                46.0718482,
                35.0791885
              ],
              [
                46.0719398,
                35.0789042
              ],
              [
                46.0720061,
                35.0786525
              ],
              [
                46.0720269,
                35.0785092
              ],
              [
                46.0720222,
                35.0784141
              ],
              [
                46.0719947,
                35.0782934
              ],
              [
                46.0719418,
                35.0781698
              ],
              [
                46.0718892,
                35.0780401
              ],
              [
                46.0718233,
                35.0779073
              ],
              [
                46.0717681,
                35.0777995
              ],
              [
                46.0716903,
                35.0776993
              ],
              [
                46.0716033,
                35.0776257
              ],
              [
                46.0714515,
                35.0775321
              ],
              [
                46.0713052,
                35.0774474
              ],
              [
                46.071164,
                35.0773844
              ],
              [
                46.0710887,
                35.0773553
              ],
              [
                46.071017,
                35.0773395
              ],
              [
                46.0708994,
                35.0773206
              ],
              [
                46.0707728,
                35.0772825
              ],
              [
                46.0707021,
                35.0772511
              ],
              [
                46.0706387,
                35.0772138
              ],
              [
                46.0705608,
                35.0771496
              ],
              [
                46.0704985,
                35.0770798
              ],
              [
                46.0703891,
                35.0769376
              ],
              [
                46.0702857,
                35.0768302
              ],
              [
                46.0701943,
                35.0767594
              ],
              [
                46.0700065,
                35.0766767
              ],
              [
                46.069846,
                35.0765693
              ],
              [
                46.0697314,
                35.0764835
              ],
              [
                46.0696587,
                35.0763826
              ],
              [
                46.0696436,
                35.0762719
              ],
              [
                46.0696438,
                35.0760851
              ],
              [
                46.069711,
                35.0756767
              ],
              [
                46.06975,
                35.0754068
              ],
              [
                46.0698028,
                35.0751937
              ],
              [
                46.0699315,
                35.0749111
              ],
              [
                46.0700998,
                35.0746294
              ],
              [
                46.0703628,
                35.0743041
              ],
              [
                46.0706518,
                35.0740461
              ],
              [
                46.070941,
                35.0738081
              ],
              [
                46.0711513,
                35.0736296
              ],
              [
                46.0712673,
                35.0734919
              ],
              [
                46.0714531,
                35.0732027
              ],
              [
                46.0715535,
                35.0729755
              ],
              [
                46.0716522,
                35.0728222
              ],
              [
                46.0717896,
                35.0726711
              ],
              [
                46.0719269,
                35.0725249
              ],
              [
                46.0720351,
                35.0723345
              ],
              [
                46.0722117,
                35.0719364
              ],
              [
                46.0723959,
                35.0714681
              ],
              [
                46.0725831,
                35.0710284
              ],
              [
                46.0727335,
                35.0705456
              ],
              [
                46.0728487,
                35.070027
              ],
              [
                46.0728793,
                35.0698323
              ],
              [
                46.0728738,
                35.0696731
              ],
              [
                46.0728484,
                35.0694697
              ],
              [
                46.0727868,
                35.0692787
              ],
              [
                46.0726836,
                35.0690835
              ],
              [
                46.0725678,
                35.0689341
              ],
              [
                46.0724449,
                35.0688207
              ],
              [
                46.0721759,
                35.0686452
              ],
              [
                46.0720955,
                35.068588
              ],
              [
                46.0720078,
                35.068513
              ],
              [
                46.0718757,
                35.0683779
              ],
              [
                46.0716476,
                35.0681105
              ],
              [
                46.0715162,
                35.0679508
              ],
              [
                46.0713103,
                35.0676644
              ],
              [
                46.0712512,
                35.0675851
              ],
              [
                46.0711993,
                35.0675225
              ],
              [
                46.0711277,
                35.0674452
              ],
              [
                46.07108,
                35.067386
              ],
              [
                46.0710192,
                35.0672927
              ],
              [
                46.0707477,
                35.0667866
              ],
              [
                46.070628,
                35.0665756
              ],
              [
                46.0704779,
                35.0663745
              ],
              [
                46.0700528,
                35.0658889
              ],
              [
                46.0697426,
                35.0655373
              ],
              [
                46.0693959,
                35.0651162
              ],
              [
                46.0691764,
                35.0647975
              ],
              [
                46.0688599,
                35.0643025
              ],
              [
                46.0687729,
                35.0641222
              ],
              [
                46.0687,
                35.0639047
              ],
              [
                46.068618,
                35.0635729
              ],
              [
                46.0685839,
                35.0633752
              ],
              [
                46.0685729,
                35.0632143
              ],
              [
                46.0685916,
                35.0631028
              ],
              [
                46.0686286,
                35.0629962
              ],
              [
                46.0686826,
                35.0628597
              ],
              [
                46.0687243,
                35.0627356
              ],
              [
                46.0687351,
                35.0626464
              ],
              [
                46.0687094,
                35.0624479
              ],
              [
                46.0687209,
                35.062361
              ],
              [
                46.0687444,
                35.0622742
              ],
              [
                46.0688442,
                35.0619835
              ],
              [
                46.0688894,
                35.0617922
              ],
              [
                46.0689196,
                35.0615959
              ],
              [
                46.068959,
                35.0613337
              ],
              [
                46.068974,
                35.0610716
              ],
              [
                46.0689444,
                35.0606944
              ],
              [
                46.0689027,
                35.0603867
              ],
              [
                46.0688798,
                35.0599402
              ],
              [
                46.0689131,
                35.0595491
              ],
              [
                46.0689519,
                35.0592968
              ],
              [
                46.0690955,
                35.058885
              ],
              [
                46.0692781,
                35.0583556
              ],
              [
                46.0694487,
                35.0580168
              ],
              [
                46.0695318,
                35.0579015
              ],
              [
                46.0696222,
                35.0578099
              ],
              [
                46.069736,
                35.0577212
              ],
              [
                46.0698218,
                35.0576754
              ],
              [
                46.069861,
                35.0576525
              ],
              [
                46.0698859,
                35.0576296
              ],
              [
                46.0699028,
                35.0575998
              ],
              [
                46.0699125,
                35.0575567
              ],
              [
                46.0699319,
                35.0575061
              ],
              [
                46.0700105,
                35.0573855
              ],
              [
                46.0700935,
                35.0572989
              ],
              [
                46.0701901,
                35.0572375
              ],
              [
                46.0702653,
                35.0571953
              ],
              [
                46.0703424,
                35.057165
              ],
              [
                46.0704294,
                35.0571399
              ],
              [
                46.0705164,
                35.0571207
              ],
              [
                46.0706422,
                35.057084
              ],
              [
                46.0707699,
                35.05704
              ],
              [
                46.071103,
                35.0568903
              ],
              [
                46.0713997,
                35.0568003
              ],
              [
                46.0717579,
                35.056771
              ],
              [
                46.0721465,
                35.0567765
              ],
              [
                46.0724423,
                35.0569151
              ],
              [
                46.0726302,
                35.0570139
              ],
              [
                46.0728252,
                35.0571008
              ],
              [
                46.0730618,
                35.0571905
              ],
              [
                46.0735317,
                35.0576302
              ],
              [
                46.074265,
                35.0580592
              ],
              [
                46.0750351,
                35.0586869
              ],
              [
                46.0754184,
                35.0590191
              ],
              [
                46.0756144,
                35.0591729
              ],
              [
                46.0757953,
                35.0592775
              ],
              [
                46.076058,
                35.0594123
              ],
              [
                46.0763356,
                35.0595295
              ],
              [
                46.0766063,
                35.0596331
              ],
              [
                46.0769305,
                35.0597596
              ],
              [
                46.0771176,
                35.0598119
              ],
              [
                46.0774012,
                35.059866
              ],
              [
                46.0776688,
                35.0598946
              ],
              [
                46.0778433,
                35.0599037
              ],
              [
                46.0780436,
                35.0598952
              ],
              [
                46.0783342,
                35.0598601
              ],
              [
                46.0786248,
                35.0597864
              ],
              [
                46.0789141,
                35.0596881
              ],
              [
                46.0793512,
                35.0594775
              ],
              [
                46.0795268,
                35.0593498
              ],
              [
                46.0796724,
                35.0592221
              ],
              [
                46.0797419,
                35.0591108
              ],
              [
                46.0797943,
                35.0589995
              ],
              [
                46.0798162,
                35.0588736
              ],
              [
                46.0798424,
                35.0587758
              ],
              [
                46.0798729,
                35.0587061
              ],
              [
                46.0799163,
                35.0586435
              ],
              [
                46.0800237,
                35.0585414
              ],
              [
                46.0801118,
                35.0584428
              ],
              [
                46.0801718,
                35.0583631
              ],
              [
                46.0802203,
                35.0582705
              ],
              [
                46.080246,
                35.0581563
              ],
              [
                46.0802619,
                35.0580127
              ],
              [
                46.0802964,
                35.0577033
              ],
              [
                46.0803232,
                35.0573855
              ],
              [
                46.080341,
                35.0571174
              ],
              [
                46.0803234,
                35.0568212
              ],
              [
                46.0803006,
                35.0563495
              ],
              [
                46.0802986,
                35.0561452
              ],
              [
                46.0802659,
                35.055945
              ],
              [
                46.0801954,
                35.055762
              ],
              [
                46.0801106,
                35.0555923
              ],
              [
                46.0800278,
                35.0554742
              ],
              [
                46.0796751,
                35.0550127
              ],
              [
                46.0794688,
                35.0547583
              ],
              [
                46.0793592,
                35.0546257
              ],
              [
                46.0792725,
                35.0544785
              ],
              [
                46.0792231,
                35.0543911
              ],
              [
                46.0791532,
                35.054312
              ],
              [
                46.0790187,
                35.0541872
              ],
              [
                46.0788312,
                35.054038
              ],
              [
                46.0785582,
                35.0538334
              ],
              [
                46.0783171,
                35.0536397
              ],
              [
                46.0781646,
                35.0535157
              ],
              [
                46.0780683,
                35.0534167
              ],
              [
                46.078002,
                35.0533197
              ],
              [
                46.0779307,
                35.0532051
              ],
              [
                46.0778032,
                35.0530508
              ],
              [
                46.0777091,
                35.0529552
              ],
              [
                46.0775066,
                35.0527723
              ],
              [
                46.0774241,
                35.0526855
              ],
              [
                46.077356,
                35.0525997
              ],
              [
                46.077281,
                35.0524697
              ],
              [
                46.0772124,
                35.0523846
              ],
              [
                46.0771336,
                35.0523183
              ],
              [
                46.0770424,
                35.0522588
              ],
              [
                46.0769415,
                35.0522046
              ],
              [
                46.0768267,
                35.0521464
              ],
              [
                46.0767047,
                35.0520817
              ],
              [
                46.0766438,
                35.0520488
              ],
              [
                46.0765655,
                35.0520145
              ],
              [
                46.0764803,
                35.0519876
              ],
              [
                46.076378,
                35.0519614
              ],
              [
                46.0762731,
                35.0519289
              ],
              [
                46.0761706,
                35.0518891
              ],
              [
                46.0760677,
                35.0518344
              ],
              [
                46.0759589,
                35.0517836
              ],
              [
                46.0758534,
                35.0517489
              ],
              [
                46.0757369,
                35.0517213
              ],
              [
                46.0755244,
                35.05168
              ],
              [
                46.075386,
                35.0516471
              ],
              [
                46.0752366,
                35.0515979
              ],
              [
                46.0750911,
                35.0515456
              ],
              [
                46.0749531,
                35.0514994
              ],
              [
                46.0748251,
                35.0514655
              ],
              [
                46.0746999,
                35.0514428
              ],
              [
                46.0744571,
                35.051411
              ],
              [
                46.0741148,
                35.0513793
              ],
              [
                46.0736494,
                35.0513359
              ],
              [
                46.0735081,
                35.0513031
              ],
              [
                46.0734041,
                35.0512582
              ],
              [
                46.0732982,
                35.0511895
              ],
              [
                46.0730863,
                35.0510319
              ],
              [
                46.0730072,
                35.0509996
              ],
              [
                46.0729079,
                35.0509765
              ],
              [
                46.0724243,
                35.0508802
              ],
              [
                46.0723055,
                35.0508445
              ],
              [
                46.0722211,
                35.0507939
              ],
              [
                46.0721697,
                35.0507429
              ],
              [
                46.0721026,
                35.050666
              ],
              [
                46.0719868,
                35.0505976
              ],
              [
                46.0718439,
                35.0505424
              ],
              [
                46.0713032,
                35.0503683
              ],
              [
                46.0709054,
                35.0502192
              ],
              [
                46.070282,
                35.0499585
              ],
              [
                46.0697942,
                35.0497656
              ],
              [
                46.0693778,
                35.0496103
              ],
              [
                46.06919,
                35.0495399
              ],
              [
                46.0690646,
                35.0494841
              ],
              [
                46.0689632,
                35.0494309
              ],
              [
                46.0688978,
                35.0493891
              ],
              [
                46.0688353,
                35.0493405
              ],
              [
                46.0687694,
                35.0492728
              ],
              [
                46.0687236,
                35.0492025
              ],
              [
                46.0686779,
                35.0491425
              ],
              [
                46.0686136,
                35.0490806
              ],
              [
                46.068463,
                35.0489738
              ],
              [
                46.0683458,
                35.0488784
              ],
              [
                46.0681946,
                35.0487434
              ],
              [
                46.0679634,
                35.0485152
              ],
              [
                46.0678724,
                35.0484267
              ],
              [
                46.0678208,
                35.0483483
              ],
              [
                46.0677965,
                35.048236
              ],
              [
                46.0678026,
                35.0481307
              ],
              [
                46.0678329,
                35.0480295
              ],
              [
                46.0679361,
                35.0478568
              ],
              [
                46.0679918,
                35.0477324
              ],
              [
                46.0680172,
                35.047618
              ],
              [
                46.0680074,
                35.0475233
              ],
              [
                46.067933,
                35.0473537
              ],
              [
                46.0678996,
                35.0472282
              ],
              [
                46.0678782,
                35.0469359
              ],
              [
                46.0678764,
                35.0466926
              ],
              [
                46.0679346,
                35.0460455
              ],
              [
                46.067916,
                35.045351
              ],
              [
                46.0679313,
                35.0446205
              ],
              [
                46.0678422,
                35.0436535
              ],
              [
                46.0677687,
                35.0433458
              ],
              [
                46.0676891,
                35.0431475
              ],
              [
                46.067615,
                35.043044
              ],
              [
                46.0674833,
                35.0429575
              ],
              [
                46.0672639,
                35.0428677
              ],
              [
                46.0670532,
                35.0427568
              ],
              [
                46.0668941,
                35.0426494
              ],
              [
                46.066713,
                35.0424698
              ],
              [
                46.0665741,
                35.0423143
              ],
              [
                46.0664383,
                35.0421149
              ],
              [
                46.0662991,
                35.0419208
              ],
              [
                46.0661556,
                35.0417337
              ],
              [
                46.066021,
                35.0416054
              ],
              [
                46.0658435,
                35.0414735
              ],
              [
                46.0657031,
                35.0413784
              ],
              [
                46.0653537,
                35.0411742
              ],
              [
                46.0650667,
                35.0410117
              ],
              [
                46.0645796,
                35.0407044
              ],
              [
                46.0637191,
                35.0401793
              ],
              [
                46.0635007,
                35.0400437
              ],
              [
                46.063246,
                35.039839
              ],
              [
                46.0625107,
                35.039311
              ],
              [
                46.0620712,
                35.0390313
              ],
              [
                46.0618669,
                35.0389157
              ],
              [
                46.0616454,
                35.0388071
              ],
              [
                46.0612368,
                35.0386321
              ],
              [
                46.0609733,
                35.0385316
              ],
              [
                46.0607483,
                35.0384381
              ],
              [
                46.0604063,
                35.0382744
              ],
              [
                46.0600944,
                35.0381528
              ],
              [
                46.0597806,
                35.0380763
              ],
              [
                46.0594455,
                35.0380385
              ],
              [
                46.0591098,
                35.038019
              ],
              [
                46.0588249,
                35.0380322
              ],
              [
                46.0584371,
                35.0380982
              ],
              [
                46.0579102,
                35.0382792
              ],
              [
                46.0576036,
                35.0383953
              ],
              [
                46.0573829,
                35.0385114
              ],
              [
                46.0571817,
                35.0386522
              ],
              [
                46.056878,
                35.0388952
              ],
              [
                46.0566288,
                35.0391047
              ],
              [
                46.056431,
                35.0393141
              ],
              [
                46.0562676,
                35.0395201
              ],
              [
                46.0561471,
                35.039726
              ],
              [
                46.0560935,
                35.0398827
              ],
              [
                46.0560956,
                35.0400077
              ],
              [
                46.0561256,
                35.0401327
              ],
              [
                46.0561986,
                35.0402401
              ],
              [
                46.0563639,
                35.0404221
              ],
              [
                46.0564744,
                35.0405448
              ],
              [
                46.0565549,
                35.040685
              ],
              [
                46.0565979,
                35.0408161
              ],
              [
                46.0566238,
                35.0409682
              ],
              [
                46.0566498,
                35.0412465
              ],
              [
                46.0566112,
                35.0415672
              ],
              [
                46.0563923,
                35.0424641
              ],
              [
                46.0561685,
                35.0432815
              ],
              [
                46.055988,
                35.0439014
              ],
              [
                46.0554035,
                35.0450833
              ],
              [
                46.0550211,
                35.0456391
              ],
              [
                46.0545185,
                35.046237
              ],
              [
                46.0541997,
                35.0465411
              ],
              [
                46.0528844,
                35.0475264
              ],
              [
                46.0525996,
                35.0478296
              ],
              [
                46.0524362,
                35.0480973
              ],
              [
                46.0523329,
                35.0483578
              ],
              [
                46.0522901,
                35.0486852
              ],
              [
                46.0523117,
                35.0490035
              ],
              [
                46.0523568,
                35.0492258
              ],
              [
                46.0524448,
                35.049406
              ],
              [
                46.0526858,
                35.049716
              ],
              [
                46.0529097,
                35.0501246
              ],
              [
                46.0530643,
                35.0506844
              ],
              [
                46.0531158,
                35.0509994
              ],
              [
                46.053133,
                35.0513145
              ],
              [
                46.0531265,
                35.0516258
              ],
              [
                46.0530342,
                35.0519653
              ],
              [
                46.0528323,
                35.0523632
              ],
              [
                46.0527713,
                35.0525078
              ],
              [
                46.052649,
                35.0526858
              ],
              [
                46.0524964,
                35.0528245
              ],
              [
                46.0522829,
                35.0529433
              ],
              [
                46.0520703,
                35.0530388
              ],
              [
                46.0518122,
                35.0531021
              ],
              [
                46.0515235,
                35.0531446
              ],
              [
                46.051169,
                35.0531562
              ],
              [
                46.0509012,
                35.0531343
              ],
              [
                46.0507229,
                35.053099
              ],
              [
                46.0505131,
                35.0530214
              ],
              [
                46.0503136,
                35.0528769
              ],
              [
                46.0501595,
                35.0527134
              ],
              [
                46.0500657,
                35.0525116
              ],
              [
                46.0499495,
                35.0522335
              ],
              [
                46.0497797,
                35.0519168
              ],
              [
                46.0494187,
                35.0513222
              ],
              [
                46.0490401,
                35.0508638
              ],
              [
                46.0486532,
                35.0505028
              ],
              [
                46.0482662,
                35.0501669
              ],
              [
                46.0480702,
                35.050028
              ],
              [
                46.0478539,
                35.0499141
              ],
              [
                46.0476503,
                35.04984
              ],
              [
                46.0474262,
                35.0497909
              ],
              [
                46.047157,
                35.0497992
              ],
              [
                46.0468419,
                35.0498577
              ],
              [
                46.046447,
                35.0500229
              ],
              [
                46.0461133,
                35.0502131
              ],
              [
                46.0456348,
                35.0505893
              ],
              [
                46.0451067,
                35.0512243
              ],
              [
                46.044676,
                35.0516097
              ],
              [
                46.0442181,
                35.0519453
              ],
              [
                46.0437206,
                35.0522382
              ],
              [
                46.0433869,
                35.05243
              ],
              [
                46.0431893,
                35.0525215
              ],
              [
                46.0429954,
                35.0525923
              ],
              [
                46.0427306,
                35.0526489
              ],
              [
                46.0424549,
                35.052676
              ],
              [
                46.0422198,
                35.0526373
              ],
              [
                46.04201,
                35.0525869
              ],
              [
                46.0417563,
                35.052516
              ],
              [
                46.041499,
                35.0524186
              ],
              [
                46.041118,
                35.0521676
              ],
              [
                46.0408927,
                35.0519735
              ],
              [
                46.0406999,
                35.0517794
              ],
              [
                46.0402689,
                35.0512862
              ],
              [
                46.0399836,
                35.0510713
              ],
              [
                46.0396498,
                35.0509061
              ],
              [
                46.039102,
                35.0507458
              ],
              [
                46.0385663,
                35.0506949
              ],
              [
                46.0378328,
                35.0507594
              ],
              [
                46.0372086,
                35.0509034
              ],
              [
                46.0356274,
                35.0512546
              ],
              [
                46.0345604,
                35.0514573
              ],
              [
                46.0335724,
                35.0517246
              ],
              [
                46.0328527,
                35.0520516
              ],
              [
                46.0320013,
                35.0523873
              ],
              [
                46.0313211,
                35.0524608
              ],
              [
                46.0302146,
                35.0525675
              ],
              [
                46.0298006,
                35.0526038
              ],
              [
                46.0294679,
                35.0528264
              ],
              [
                46.0293469,
                35.053157
              ],
              [
                46.0290877,
                35.0534742
              ],
              [
                46.0282428,
                35.0539411
              ],
              [
                46.0272491,
                35.0544205
              ],
              [
                46.0256293,
                35.0552027
              ],
              [
                46.0254528,
                35.0556231
              ],
              [
                46.0256319,
                35.0559299
              ],
              [
                46.0262496,
                35.0562244
              ],
              [
                46.0268242,
                35.0564592
              ],
              [
                46.0271455,
                35.0566337
              ],
              [
                46.0273946,
                35.0568437
              ],
              [
                46.0276539,
                35.0570626
              ],
              [
                46.0278266,
                35.0573997
              ],
              [
                46.0278141,
                35.0576195
              ],
              [
                46.0276283,
                35.0579929
              ],
              [
                46.0274784,
                35.0582209
              ],
              [
                46.0271841,
                35.0584608
              ],
              [
                46.0268687,
                35.0587093
              ],
              [
                46.0263894,
                35.0591493
              ],
              [
                46.0260978,
                35.0595893
              ],
              [
                46.0257383,
                35.0604812
              ],
              [
                46.0256183,
                35.060774
              ],
              [
                46.0252482,
                35.061188
              ],
              [
                46.0247915,
                35.0615312
              ],
              [
                46.023678,
                35.0621837
              ],
              [
                46.0225376,
                35.0627127
              ],
              [
                46.0217297,
                35.0629106
              ],
              [
                46.021216,
                35.0631688
              ],
              [
                46.0208975,
                35.0634669
              ],
              [
                46.0190256,
                35.0648351
              ],
              [
                46.0180149,
                35.0652235
              ],
              [
                46.0174781,
                35.0655628
              ],
              [
                46.0171285,
                35.0658073
              ],
              [
                46.0165547,
                35.0662723
              ],
              [
                46.0164118,
                35.0664188
              ],
              [
                46.0163296,
                35.066615
              ],
              [
                46.0163209,
                35.0668063
              ],
              [
                46.0163972,
                35.0669976
              ],
              [
                46.0165873,
                35.0672425
              ],
              [
                46.0168695,
                35.0675358
              ],
              [
                46.0170096,
                35.0677735
              ],
              [
                46.0171821,
                35.0681715
              ],
              [
                46.0172696,
                35.0684999
              ],
              [
                46.0172702,
                35.0686885
              ],
              [
                46.0172344,
                35.068897
              ],
              [
                46.0170353,
                35.069304
              ],
              [
                46.0167602,
                35.0697538
              ],
              [
                46.0163675,
                35.0702663
              ],
              [
                46.0159406,
                35.0707283
              ],
              [
                46.0154065,
                35.0712009
              ],
              [
                46.014864,
                35.0714774
              ],
              [
                46.0141669,
                35.0716408
              ],
              [
                46.0136266,
                35.0716291
              ],
              [
                46.0129236,
                35.0714311
              ],
              [
                46.0119824,
                35.0713632
              ],
              [
                46.0096316,
                35.0717413
              ],
              [
                46.0079987,
                35.0718063
              ],
              [
                46.006242,
                35.0715156
              ],
              [
                46.0048747,
                35.0713466
              ],
              [
                46.0038686,
                35.0707766
              ],
              [
                46.0017596,
                35.0666405
              ],
              [
                46.0012653,
                35.0659503
              ],
              [
                46.0010984,
                35.0650569
              ],
              [
                46.0009019,
                35.0638298
              ],
              [
                46.0010454,
                35.0626297
              ],
              [
                46.0008906,
                35.0622752
              ],
              [
                46.0005407,
                35.0620139
              ],
              [
                46.0003318,
                35.0618808
              ],
              [
                45.9983857,
                35.0619879
              ],
              [
                45.9966534,
                35.062307
              ],
              [
                45.9949371,
                35.0629572
              ],
              [
                45.9937493,
                35.0638397
              ],
              [
                45.9927768,
                35.0648454
              ],
              [
                45.9912222,
                35.0658578
              ],
              [
                45.9880968,
                35.0688639
              ],
              [
                45.9862231,
                35.0688763
              ],
              [
                45.9855782,
                35.0686441
              ],
              [
                45.9844947,
                35.0686652
              ],
              [
                45.9834886,
                35.0688763
              ],
              [
                45.9823535,
                35.0695942
              ],
              [
                45.9818633,
                35.0705232
              ],
              [
                45.9815795,
                35.0716422
              ],
              [
                45.9809862,
                35.0722756
              ],
              [
                45.9797479,
                35.0724657
              ],
              [
                45.9783548,
                35.0723812
              ],
              [
                45.9775035,
                35.072149
              ],
              [
                45.9762136,
                35.0722123
              ],
              [
                45.9753881,
                35.0725923
              ],
              [
                45.9752095,
                35.072717
              ],
              [
                45.974511,
                35.0732046
              ],
              [
                45.9739177,
                35.0735635
              ],
              [
                45.9728858,
                35.0737536
              ],
              [
                45.9720086,
                35.0737536
              ],
              [
                45.9711315,
                35.0734369
              ],
              [
                45.9700996,
                35.0732046
              ],
              [
                45.9691967,
                35.0733524
              ],
              [
                45.968268,
                35.0741125
              ],
              [
                45.9675715,
                35.0752737
              ],
              [
                45.9676747,
                35.0762449
              ],
              [
                45.9681648,
                35.0769838
              ],
              [
                45.9683454,
                35.0776172
              ],
              [
                45.9679068,
                35.078525
              ],
              [
                45.9669781,
                35.0793694
              ],
              [
                45.9657398,
                35.0800028
              ],
              [
                45.9640114,
                35.0801083
              ],
              [
                45.9618186,
                35.0804884
              ],
              [
                45.9605029,
                35.0811006
              ],
              [
                45.9591615,
                35.0815861
              ],
              [
                45.9572009,
                35.0821983
              ],
              [
                45.9560658,
                35.0828317
              ],
              [
                45.9552144,
                35.0841405
              ],
              [
                45.9544921,
                35.0853016
              ],
              [
                45.9538988,
                35.0860615
              ],
              [
                45.9529185,
                35.0870537
              ],
              [
                45.9514996,
                35.0880247
              ],
              [
                45.9503903,
                35.0890591
              ],
              [
                45.9492294,
                35.0901568
              ],
              [
                45.9478106,
                35.0907689
              ],
              [
                45.9462111,
                35.0909378
              ],
              [
                45.9442247,
                35.0910644
              ],
              [
                45.9429864,
                35.0906634
              ],
              [
                45.9421609,
                35.0899034
              ],
              [
                45.9415912,
                35.0886019
              ],
              [
                45.941271,
                35.0882698
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555293,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گیلانغرب",
          "name:en": "Gilan-e-Gharb County",
          "name:ku": "Giyelan",
          "name:uk": "Ґілане-Ґерб",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1294730",
          "wikipedia": "en:Gilan-e Gharb County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                45.6097194,
                33.7989764
              ],
              [
                45.629784,
                33.789094
              ],
              [
                45.629744,
                33.788826
              ],
              [
                45.630014,
                33.788712
              ],
              [
                45.63036,
                33.788378
              ],
              [
                45.63048,
                33.788224
              ],
              [
                45.630437,
                33.788125
              ],
              [
                45.630489,
                33.788002
              ],
              [
                45.630955,
                33.787654
              ],
              [
                45.631047,
                33.787501
              ],
              [
                45.631504,
                33.78733
              ],
              [
                45.631803,
                33.787157
              ],
              [
                45.631943,
                33.786915
              ],
              [
                45.632179,
                33.78676
              ],
              [
                45.632297,
                33.786742
              ],
              [
                45.632417,
                33.786617
              ],
              [
                45.632588,
                33.786289
              ],
              [
                45.632912,
                33.786088
              ],
              [
                45.633123,
                33.786012
              ],
              [
                45.633312,
                33.785794
              ],
              [
                45.633396,
                33.785568
              ],
              [
                45.633625,
                33.78537
              ],
              [
                45.633824,
                33.785324
              ],
              [
                45.633996,
                33.785211
              ],
              [
                45.634172,
                33.784972
              ],
              [
                45.634168,
                33.784866
              ],
              [
                45.63497,
                33.784214
              ],
              [
                45.635245,
                33.783871
              ],
              [
                45.635427,
                33.78379
              ],
              [
                45.635732,
                33.783407
              ],
              [
                45.635781,
                33.783273
              ],
              [
                45.636013,
                33.783153
              ],
              [
                45.636137,
                33.782947
              ],
              [
                45.636351,
                33.782837
              ],
              [
                45.636577,
                33.782532
              ],
              [
                45.636589,
                33.78218
              ],
              [
                45.636979,
                33.782085
              ],
              [
                45.637077,
                33.781997
              ],
              [
                45.637134,
                33.781845
              ],
              [
                45.637413,
                33.781721
              ],
              [
                45.637484,
                33.781543
              ],
              [
                45.637585,
                33.781444
              ],
              [
                45.637578,
                33.781191
              ],
              [
                45.637685,
                33.780927
              ],
              [
                45.638153,
                33.780608
              ],
              [
                45.638466,
                33.780184
              ],
              [
                45.638493,
                33.779834
              ],
              [
                45.63876,
                33.77951
              ],
              [
                45.639132,
                33.779215
              ],
              [
                45.639246,
                33.77895
              ],
              [
                45.639607,
                33.778477
              ],
              [
                45.639731,
                33.778203
              ],
              [
                45.639944,
                33.777997
              ],
              [
                45.640069,
                33.777746
              ],
              [
                45.640211,
                33.777599
              ],
              [
                45.640282,
                33.777399
              ],
              [
                45.640289,
                33.777053
              ],
              [
                45.640332,
                33.776921
              ],
              [
                45.64052,
                33.776674
              ],
              [
                45.640588,
                33.77635
              ],
              [
                45.6408,
                33.776093
              ],
              [
                45.641203,
                33.775741
              ],
              [
                45.641328,
                33.775491
              ],
              [
                45.641693,
                33.774989
              ],
              [
                45.641795,
                33.774708
              ],
              [
                45.642428,
                33.774158
              ],
              [
                45.64246,
                33.773825
              ],
              [
                45.642663,
                33.773192
              ],
              [
                45.643015,
                33.772991
              ],
              [
                45.643222,
                33.772741
              ],
              [
                45.643433,
                33.772343
              ],
              [
                45.643764,
                33.772
              ],
              [
                45.643841,
                33.771844
              ],
              [
                45.643833,
                33.771727
              ],
              [
                45.644034,
                33.771337
              ],
              [
                45.644158,
                33.770855
              ],
              [
                45.644758,
                33.769848
              ],
              [
                45.644999,
                33.769597
              ],
              [
                45.645245,
                33.768758
              ],
              [
                45.645402,
                33.768619
              ],
              [
                45.645517,
                33.768404
              ],
              [
                45.645666,
                33.767911
              ],
              [
                45.646047,
                33.767485
              ],
              [
                45.646419,
                33.766542
              ],
              [
                45.646417,
                33.766305
              ],
              [
                45.646715,
                33.766082
              ],
              [
                45.64672,
                33.765962
              ],
              [
                45.646994,
                33.765704
              ],
              [
                45.647097,
                33.765542
              ],
              [
                45.64706,
                33.765397
              ],
              [
                45.647115,
                33.765189
              ],
              [
                45.647269,
                33.764966
              ],
              [
                45.64735,
                33.764639
              ],
              [
                45.647983,
                33.763768
              ],
              [
                45.648138,
                33.763686
              ],
              [
                45.648214,
                33.763411
              ],
              [
                45.647746,
                33.763302
              ],
              [
                45.647625,
                33.763205
              ],
              [
                45.647337,
                33.762859
              ],
              [
                45.647108,
                33.762676
              ],
              [
                45.646857,
                33.762038
              ],
              [
                45.646668,
                33.76178
              ],
              [
                45.646513,
                33.761605
              ],
              [
                45.646079,
                33.761447
              ],
              [
                45.645943,
                33.760501
              ],
              [
                45.646108,
                33.760214
              ],
              [
                45.646136,
                33.759982
              ],
              [
                45.646081,
                33.759601
              ],
              [
                45.645954,
                33.759384
              ],
              [
                45.646129,
                33.758897
              ],
              [
                45.646034,
                33.758691
              ],
              [
                45.645814,
                33.75847
              ],
              [
                45.645651,
                33.758184
              ],
              [
                45.645298,
                33.757955
              ],
              [
                45.645272,
                33.757763
              ],
              [
                45.64536,
                33.757514
              ],
              [
                45.645363,
                33.757316
              ],
              [
                45.645046,
                33.757069
              ],
              [
                45.644582,
                33.75681
              ],
              [
                45.644408,
                33.756548
              ],
              [
                45.644196,
                33.756376
              ],
              [
                45.644045,
                33.756282
              ],
              [
                45.643797,
                33.756256
              ],
              [
                45.643247,
                33.755754
              ],
              [
                45.642766,
                33.755241
              ],
              [
                45.6427,
                33.75495
              ],
              [
                45.642739,
                33.754663
              ],
              [
                45.64261,
                33.75455
              ],
              [
                45.642018,
                33.754438
              ],
              [
                45.641355,
                33.754193
              ],
              [
                45.641215,
                33.754032
              ],
              [
                45.640831,
                33.753962
              ],
              [
                45.64061,
                33.753645
              ],
              [
                45.640445,
                33.753622
              ],
              [
                45.640322,
                33.753519
              ],
              [
                45.640297,
                33.753028
              ],
              [
                45.640126,
                33.7528
              ],
              [
                45.640029,
                33.752574
              ],
              [
                45.639819,
                33.752399
              ],
              [
                45.639717,
                33.752216
              ],
              [
                45.639928,
                33.75155
              ],
              [
                45.639931,
                33.751386
              ],
              [
                45.639837,
                33.751244
              ],
              [
                45.639688,
                33.751158
              ],
              [
                45.639646,
                33.751051
              ],
              [
                45.639919,
                33.750711
              ],
              [
                45.639995,
                33.750341
              ],
              [
                45.639896,
                33.750101
              ],
              [
                45.639957,
                33.749914
              ],
              [
                45.640166,
                33.749714
              ],
              [
                45.640216,
                33.749608
              ],
              [
                45.640146,
                33.749486
              ],
              [
                45.640006,
                33.749385
              ],
              [
                45.640138,
                33.74911
              ],
              [
                45.64009,
                33.748973
              ],
              [
                45.639958,
                33.748853
              ],
              [
                45.639833,
                33.748545
              ],
              [
                45.639705,
                33.748413
              ],
              [
                45.639545,
                33.747829
              ],
              [
                45.639219,
                33.747466
              ],
              [
                45.639026,
                33.746653
              ],
              [
                45.639092,
                33.746391
              ],
              [
                45.638957,
                33.74582
              ],
              [
                45.639093,
                33.745652
              ],
              [
                45.639323,
                33.745481
              ],
              [
                45.639375,
                33.745262
              ],
              [
                45.639528,
                33.745108
              ],
              [
                45.639785,
                33.745118
              ],
              [
                45.640212,
                33.744384
              ],
              [
                45.640251,
                33.744099
              ],
              [
                45.640049,
                33.743671
              ],
              [
                45.64004,
                33.743549
              ],
              [
                45.640037,
                33.743307
              ],
              [
                45.640187,
                33.742656
              ],
              [
                45.640466,
                33.742324
              ],
              [
                45.640502,
                33.741984
              ],
              [
                45.640587,
                33.741854
              ],
              [
                45.640779,
                33.741714
              ],
              [
                45.641172,
                33.740681
              ],
              [
                45.640754,
                33.740359
              ],
              [
                45.64046,
                33.74022
              ],
              [
                45.640283,
                33.740041
              ],
              [
                45.640118,
                33.739832
              ],
              [
                45.639855,
                33.739337
              ],
              [
                45.640061,
                33.739014
              ],
              [
                45.640002,
                33.738653
              ],
              [
                45.640092,
                33.738285
              ],
              [
                45.640055,
                33.738022
              ],
              [
                45.640318,
                33.737867
              ],
              [
                45.640437,
                33.737714
              ],
              [
                45.640551,
                33.737262
              ],
              [
                45.640719,
                33.736975
              ],
              [
                45.640854,
                33.736874
              ],
              [
                45.6413,
                33.736875
              ],
              [
                45.641818,
                33.73698
              ],
              [
                45.642088,
                33.736689
              ],
              [
                45.642136,
                33.736087
              ],
              [
                45.641998,
                33.735527
              ],
              [
                45.641847,
                33.734418
              ],
              [
                45.64196,
                33.734311
              ],
              [
                45.642104,
                33.733966
              ],
              [
                45.642367,
                33.733743
              ],
              [
                45.642898,
                33.733555
              ],
              [
                45.643349,
                33.733214
              ],
              [
                45.643621,
                33.733103
              ],
              [
                45.643705,
                33.732922
              ],
              [
                45.643938,
                33.732785
              ],
              [
                45.644369,
                33.732778
              ],
              [
                45.644677,
                33.732685
              ],
              [
                45.644806,
                33.732693
              ],
              [
                45.646508,
                33.732149
              ],
              [
                45.646565,
                33.729599
              ],
              [
                45.646649,
                33.729271
              ],
              [
                45.646893,
                33.728985
              ],
              [
                45.647241,
                33.728215
              ],
              [
                45.647451,
                33.728021
              ],
              [
                45.647933,
                33.727749
              ],
              [
                45.648184,
                33.727716
              ],
              [
                45.648447,
                33.727748
              ],
              [
                45.648934,
                33.727656
              ],
              [
                45.649699,
                33.727022
              ],
              [
                45.650396,
                33.727013
              ],
              [
                45.650822,
                33.726854
              ],
              [
                45.652005,
                33.726679
              ],
              [
                45.652096,
                33.72657
              ],
              [
                45.652542,
                33.72648
              ],
              [
                45.652783,
                33.726274
              ],
              [
                45.652825,
                33.726091
              ],
              [
                45.652929,
                33.725957
              ],
              [
                45.653047,
                33.725917
              ],
              [
                45.653814,
                33.725864
              ],
              [
                45.653834,
                33.725725
              ],
              [
                45.654019,
                33.725609
              ],
              [
                45.654343,
                33.725685
              ],
              [
                45.654808,
                33.725563
              ],
              [
                45.654996,
                33.725063
              ],
              [
                45.654954,
                33.724784
              ],
              [
                45.655053,
                33.724702
              ],
              [
                45.655238,
                33.724631
              ],
              [
                45.655432,
                33.72466
              ],
              [
                45.655665,
                33.724568
              ],
              [
                45.655997,
                33.724507
              ],
              [
                45.656587,
                33.724484
              ],
              [
                45.656857,
                33.724379
              ],
              [
                45.657157,
                33.724466
              ],
              [
                45.657637,
                33.724025
              ],
              [
                45.658065,
                33.723804
              ],
              [
                45.65833,
                33.723401
              ],
              [
                45.658861,
                33.723436
              ],
              [
                45.658963,
                33.723364
              ],
              [
                45.659005,
                33.723204
              ],
              [
                45.65891,
                33.722907
              ],
              [
                45.658935,
                33.722642
              ],
              [
                45.659165,
                33.722699
              ],
              [
                45.659405,
                33.722682
              ],
              [
                45.659675,
                33.722304
              ],
              [
                45.659885,
                33.722118
              ],
              [
                45.659809,
                33.721981
              ],
              [
                45.659344,
                33.721694
              ],
              [
                45.65916,
                33.721136
              ],
              [
                45.659195,
                33.721009
              ],
              [
                45.659329,
                33.720927
              ],
              [
                45.659566,
                33.720899
              ],
              [
                45.659736,
                33.720826
              ],
              [
                45.659877,
                33.720655
              ],
              [
                45.659881,
                33.720539
              ],
              [
                45.659661,
                33.720426
              ],
              [
                45.659553,
                33.72029
              ],
              [
                45.659542,
                33.720057
              ],
              [
                45.65965,
                33.719773
              ],
              [
                45.659868,
                33.71968
              ],
              [
                45.660066,
                33.719298
              ],
              [
                45.660479,
                33.717989
              ],
              [
                45.660431,
                33.717808
              ],
              [
                45.6605,
                33.717684
              ],
              [
                45.660211,
                33.717066
              ],
              [
                45.660228,
                33.716926
              ],
              [
                45.660364,
                33.716848
              ],
              [
                45.660602,
                33.716799
              ],
              [
                45.661139,
                33.715858
              ],
              [
                45.661384,
                33.715725
              ],
              [
                45.661687,
                33.715411
              ],
              [
                45.662163,
                33.715362
              ],
              [
                45.662388,
                33.715556
              ],
              [
                45.662937,
                33.715809
              ],
              [
                45.663089,
                33.715762
              ],
              [
                45.663229,
                33.715634
              ],
              [
                45.663138,
                33.715183
              ],
              [
                45.662924,
                33.714959
              ],
              [
                45.662881,
                33.714624
              ],
              [
                45.663042,
                33.714323
              ],
              [
                45.663159,
                33.714227
              ],
              [
                45.663322,
                33.714216
              ],
              [
                45.663591,
                33.71427
              ],
              [
                45.664123,
                33.714165
              ],
              [
                45.664255,
                33.714072
              ],
              [
                45.664184,
                33.713688
              ],
              [
                45.663868,
                33.713218
              ],
              [
                45.663758,
                33.712836
              ],
              [
                45.664127,
                33.712344
              ],
              [
                45.664503,
                33.712032
              ],
              [
                45.664529,
                33.711944
              ],
              [
                45.664438,
                33.711558
              ],
              [
                45.664633,
                33.711065
              ],
              [
                45.664727,
                33.710652
              ],
              [
                45.665042,
                33.710423
              ],
              [
                45.665105,
                33.710257
              ],
              [
                45.665334,
                33.709985
              ],
              [
                45.665357,
                33.709254
              ],
              [
                45.665605,
                33.708935
              ],
              [
                45.668773,
                33.706713
              ],
              [
                45.669,
                33.70672
              ],
              [
                45.669059,
                33.706687
              ],
              [
                45.669106,
                33.706422
              ],
              [
                45.669244,
                33.706298
              ],
              [
                45.66945,
                33.706181
              ],
              [
                45.669687,
                33.706155
              ],
              [
                45.669855,
                33.706204
              ],
              [
                45.670072,
                33.706137
              ],
              [
                45.67017,
                33.706012
              ],
              [
                45.670227,
                33.705822
              ],
              [
                45.670483,
                33.705713
              ],
              [
                45.670878,
                33.70567
              ],
              [
                45.670955,
                33.705438
              ],
              [
                45.670954,
                33.705207
              ],
              [
                45.67108,
                33.704992
              ],
              [
                45.67173,
                33.704683
              ],
              [
                45.672224,
                33.704763
              ],
              [
                45.673041,
                33.704329
              ],
              [
                45.673136,
                33.703924
              ],
              [
                45.672974,
                33.703389
              ],
              [
                45.673287,
                33.702991
              ],
              [
                45.673246,
                33.702785
              ],
              [
                45.673126,
                33.702661
              ],
              [
                45.673066,
                33.702505
              ],
              [
                45.673212,
                33.702248
              ],
              [
                45.673839,
                33.701551
              ],
              [
                45.673762,
                33.700802
              ],
              [
                45.674029,
                33.70062
              ],
              [
                45.673943,
                33.70034
              ],
              [
                45.674095,
                33.700024
              ],
              [
                45.674055,
                33.699533
              ],
              [
                45.674334,
                33.69907
              ],
              [
                45.674509,
                33.698905
              ],
              [
                45.674718,
                33.698829
              ],
              [
                45.675134,
                33.698717
              ],
              [
                45.675491,
                33.698722
              ],
              [
                45.675695,
                33.698846
              ],
              [
                45.675879,
                33.698884
              ],
              [
                45.676085,
                33.69886
              ],
              [
                45.676337,
                33.698968
              ],
              [
                45.676782,
                33.699227
              ],
              [
                45.677114,
                33.699574
              ],
              [
                45.677422,
                33.699511
              ],
              [
                45.67775,
                33.699328
              ],
              [
                45.677448,
                33.69897
              ],
              [
                45.677238,
                33.698521
              ],
              [
                45.677268,
                33.698335
              ],
              [
                45.677367,
                33.697964
              ],
              [
                45.677858,
                33.697655
              ],
              [
                45.678043,
                33.697371
              ],
              [
                45.678268,
                33.697193
              ],
              [
                45.678401,
                33.696865
              ],
              [
                45.678403,
                33.696329
              ],
              [
                45.678673,
                33.695514
              ],
              [
                45.678895,
                33.695348
              ],
              [
                45.679157,
                33.695294
              ],
              [
                45.679403,
                33.695314
              ],
              [
                45.679973,
                33.695005
              ],
              [
                45.68019,
                33.695086
              ],
              [
                45.680415,
                33.695061
              ],
              [
                45.680635,
                33.694978
              ],
              [
                45.680981,
                33.694934
              ],
              [
                45.681223,
                33.694813
              ],
              [
                45.681885,
                33.694173
              ],
              [
                45.682408,
                33.694016
              ],
              [
                45.682549,
                33.693889
              ],
              [
                45.682705,
                33.693638
              ],
              [
                45.683044,
                33.693398
              ],
              [
                45.683079,
                33.693239
              ],
              [
                45.688797,
                33.690916
              ],
              [
                45.689217,
                33.690886
              ],
              [
                45.690207,
                33.690935
              ],
              [
                45.691379,
                33.691167
              ],
              [
                45.69252,
                33.69097
              ],
              [
                45.7107663,
                33.6900307
              ],
              [
                45.7230872,
                33.6894406
              ],
              [
                45.7328276,
                33.6889436
              ],
              [
                45.7415812,
                33.6921776
              ],
              [
                45.7492661,
                33.6962515
              ],
              [
                45.7536724,
                33.6999299
              ],
              [
                45.755626,
                33.701161
              ],
              [
                45.7565976,
                33.7004744
              ],
              [
                45.7576479,
                33.7000119
              ],
              [
                45.7582712,
                33.7005824
              ],
              [
                45.7591402,
                33.7020194
              ],
              [
                45.7594192,
                33.7028674
              ],
              [
                45.7605994,
                33.7025193
              ],
              [
                45.7611787,
                33.7027781
              ],
              [
                45.762831,
                33.7038224
              ],
              [
                45.7645047,
                33.7033404
              ],
              [
                45.7656956,
                33.703992
              ],
              [
                45.7666261,
                33.7031229
              ],
              [
                45.7672083,
                33.7031262
              ],
              [
                45.7676151,
                33.7038118
              ],
              [
                45.7670581,
                33.7044382
              ],
              [
                45.7669352,
                33.7051547
              ],
              [
                45.7672083,
                33.7059823
              ],
              [
                45.7682914,
                33.7058513
              ],
              [
                45.7688674,
                33.7063044
              ],
              [
                45.768641,
                33.7067791
              ],
              [
                45.767617,
                33.7081886
              ],
              [
                45.7650578,
                33.7094624
              ],
              [
                45.7649982,
                33.7103824
              ],
              [
                45.7651162,
                33.7112927
              ],
              [
                45.7669401,
                33.7120156
              ],
              [
                45.76825,
                33.7112919
              ],
              [
                45.7686756,
                33.7115999
              ],
              [
                45.7690652,
                33.7118632
              ],
              [
                45.7711857,
                33.7135604
              ],
              [
                45.772326,
                33.7144877
              ],
              [
                45.7735754,
                33.7152669
              ],
              [
                45.7733131,
                33.7158247
              ],
              [
                45.772843,
                33.7162045
              ],
              [
                45.7717116,
                33.7163821
              ],
              [
                45.7725084,
                33.7167054
              ],
              [
                45.7733184,
                33.7169553
              ],
              [
                45.7734686,
                33.7175175
              ],
              [
                45.7731306,
                33.7176737
              ],
              [
                45.7738495,
                33.7182448
              ],
              [
                45.7743967,
                33.7191327
              ],
              [
                45.7743859,
                33.7204401
              ],
              [
                45.7745308,
                33.720739
              ],
              [
                45.7749438,
                33.7207301
              ],
              [
                45.7757324,
                33.7196101
              ],
              [
                45.7761601,
                33.71937
              ],
              [
                45.7768321,
                33.7207345
              ],
              [
                45.7761454,
                33.721618
              ],
              [
                45.7763493,
                33.7219839
              ],
              [
                45.7764029,
                33.7226978
              ],
              [
                45.7762635,
                33.7231261
              ],
              [
                45.7770467,
                33.7229208
              ],
              [
                45.7780659,
                33.723135
              ],
              [
                45.7789993,
                33.7235723
              ],
              [
                45.7797074,
                33.7232332
              ],
              [
                45.7804116,
                33.7234847
              ],
              [
                45.7810749,
                33.7250341
              ],
              [
                45.7816279,
                33.7251606
              ],
              [
                45.782572,
                33.7239284
              ],
              [
                45.7829905,
                33.7237061
              ],
              [
                45.7835752,
                33.72384
              ],
              [
                45.7839453,
                33.7242549
              ],
              [
                45.7842106,
                33.7259628
              ],
              [
                45.7854659,
                33.7270061
              ],
              [
                45.786488,
                33.7266954
              ],
              [
                45.7877794,
                33.7264415
              ],
              [
                45.7906216,
                33.7283316
              ],
              [
                45.7949168,
                33.7291577
              ],
              [
                45.7963664,
                33.7291497
              ],
              [
                45.7982546,
                33.7300351
              ],
              [
                45.7993865,
                33.7305383
              ],
              [
                45.8007715,
                33.7300516
              ],
              [
                45.805485,
                33.7315064
              ],
              [
                45.8064524,
                33.7312129
              ],
              [
                45.8076792,
                33.7313493
              ],
              [
                45.8078833,
                33.7303757
              ],
              [
                45.8097267,
                33.7304966
              ],
              [
                45.8111244,
                33.7323509
              ],
              [
                45.8140075,
                33.7353772
              ],
              [
                45.8165414,
                33.7331621
              ],
              [
                45.8172369,
                33.7337979
              ],
              [
                45.8179235,
                33.7327629
              ],
              [
                45.821979,
                33.7367869
              ],
              [
                45.8253908,
                33.7406054
              ],
              [
                45.8255302,
                33.7426931
              ],
              [
                45.8277863,
                33.7428998
              ],
              [
                45.829103,
                33.744522
              ],
              [
                45.832768,
                33.7477489
              ],
              [
                45.835431,
                33.7485598
              ],
              [
                45.8376646,
                33.7502493
              ],
              [
                45.8435654,
                33.75638
              ],
              [
                45.8458614,
                33.7576709
              ],
              [
                45.8474063,
                33.757778
              ],
              [
                45.85482,
                33.7608285
              ],
              [
                45.8554423,
                33.7612745
              ],
              [
                45.8547878,
                33.7632903
              ],
              [
                45.8534574,
                33.7640217
              ],
              [
                45.8522129,
                33.7645568
              ],
              [
                45.846391,
                33.7710462
              ],
              [
                45.8424164,
                33.7742954
              ],
              [
                45.8437898,
                33.7775293
              ],
              [
                45.8507108,
                33.780164
              ],
              [
                45.8542084,
                33.7810023
              ],
              [
                45.8554101,
                33.7825717
              ],
              [
                45.8545303,
                33.7857818
              ],
              [
                45.8527083,
                33.7882754
              ],
              [
                45.8479955,
                33.7926428
              ],
              [
                45.84473,
                33.7947438
              ],
              [
                45.8438873,
                33.7964102
              ],
              [
                45.8441642,
                33.7981091
              ],
              [
                45.8452161,
                33.8002227
              ],
              [
                45.8475468,
                33.8021779
              ],
              [
                45.8516627,
                33.8078833
              ],
              [
                45.8557687,
                33.813984
              ],
              [
                45.8592506,
                33.8185397
              ],
              [
                45.8617202,
                33.8224671
              ],
              [
                45.8651421,
                33.8268776
              ],
              [
                45.8672691,
                33.8304224
              ],
              [
                45.8683274,
                33.8335958
              ],
              [
                45.8694481,
                33.8365031
              ],
              [
                45.8693141,
                33.8394571
              ],
              [
                45.8688768,
                33.8420836
              ],
              [
                45.868269,
                33.8439311
              ],
              [
                45.8667237,
                33.8459048
              ],
              [
                45.8665225,
                33.8470544
              ],
              [
                45.8665252,
                33.8484452
              ],
              [
                45.8673178,
                33.8492573
              ],
              [
                45.8777982,
                33.8539323
              ],
              [
                45.8814325,
                33.8547885
              ],
              [
                45.8863735,
                33.860224
              ],
              [
                45.8884334,
                33.8652131
              ],
              [
                45.8890342,
                33.8679213
              ],
              [
                45.8882618,
                33.8725179
              ],
              [
                45.8880043,
                33.8759741
              ],
              [
                45.8885622,
                33.8783257
              ],
              [
                45.8898496,
                33.8810334
              ],
              [
                45.8917379,
                33.885095
              ],
              [
                45.8933687,
                33.8877669
              ],
              [
                45.8986473,
                33.893538
              ],
              [
                45.9056854,
                33.8978483
              ],
              [
                45.9058668,
                33.8987048
              ],
              [
                45.8893464,
                33.9054757
              ],
              [
                45.8885128,
                33.9063151
              ],
              [
                45.8593426,
                33.9215881
              ],
              [
                45.8587895,
                33.9221478
              ],
              [
                45.8576761,
                33.9226984
              ],
              [
                45.8537902,
                33.9265889
              ],
              [
                45.8446235,
                33.9490921
              ],
              [
                45.8460094,
                33.955203
              ],
              [
                45.8498993,
                33.9629748
              ],
              [
                45.8498993,
                33.9635345
              ],
              [
                45.851843,
                33.9693655
              ],
              [
                45.8573993,
                33.9788162
              ],
              [
                45.8576811,
                33.9790946
              ],
              [
                45.8673995,
                33.9890883
              ],
              [
                45.8679558,
                33.9890882
              ],
              [
                45.8679558,
                33.989368
              ],
              [
                45.8737895,
                33.9893681
              ],
              [
                45.8757325,
                33.9888084
              ],
              [
                45.8762896,
                33.9885377
              ],
              [
                45.9124021,
                33.9707558
              ],
              [
                45.9185154,
                33.9690949
              ],
              [
                45.9193491,
                33.9688151
              ],
              [
                45.9212921,
                33.9688151
              ],
              [
                45.9215687,
                33.9685353
              ],
              [
                45.9235156,
                33.9685353
              ],
              [
                45.9243484,
                33.9682555
              ],
              [
                45.9257352,
                33.9682555
              ],
              [
                45.9260156,
                33.9679757
              ],
              [
                45.9274017,
                33.9679757
              ],
              [
                45.9279587,
                33.9676958
              ],
              [
                45.9321252,
                33.9676959
              ],
              [
                45.9326822,
                33.967425
              ],
              [
                45.9337916,
                33.9676959
              ],
              [
                45.9349018,
                33.967425
              ],
              [
                45.9354588,
                33.9676959
              ],
              [
                45.937405,
                33.9674251
              ],
              [
                45.9379589,
                33.9674252
              ],
              [
                45.9435153,
                33.9676959
              ],
              [
                45.9446253,
                33.9679757
              ],
              [
                45.9462919,
                33.9679757
              ],
              [
                45.9474051,
                33.9682556
              ],
              [
                45.9529584,
                33.9682556
              ],
              [
                45.9543482,
                33.9685354
              ],
              [
                45.9607382,
                33.9685354
              ],
              [
                45.9615718,
                33.9688153
              ],
              [
                45.9643485,
                33.9688153
              ],
              [
                45.9676812,
                33.9693659
              ],
              [
                45.9682384,
                33.9696456
              ],
              [
                45.9699048,
                33.9696457
              ],
              [
                45.9793511,
                33.9715864
              ],
              [
                45.979905,
                33.9718662
              ],
              [
                45.9810183,
                33.9718663
              ],
              [
                45.9824043,
                33.9724168
              ],
              [
                45.9832378,
                33.9724168
              ],
              [
                46.0132408,
                33.9846477
              ],
              [
                46.0137978,
                33.9846477
              ],
              [
                46.0229643,
                33.9999202
              ],
              [
                46.0385201,
                34.0160322
              ],
              [
                46.0549102,
                34.0374244
              ],
              [
                46.0549102,
                34.0377041
              ],
              [
                46.0587969,
                34.0377041
              ],
              [
                46.0690769,
                34.036594
              ],
              [
                46.0693534,
                34.0363141
              ],
              [
                46.0707433,
                34.0363141
              ],
              [
                46.0746332,
                34.0343646
              ],
              [
                46.0776864,
                34.0321441
              ],
              [
                46.0804662,
                34.0307631
              ],
              [
                46.0812997,
                34.0299237
              ],
              [
                46.0821334,
                34.0296438
              ],
              [
                46.0840763,
                34.0274234
              ],
              [
                46.0846334,
                34.0263132
              ],
              [
                46.0865765,
                34.0243636
              ],
              [
                46.0935227,
                34.0215925
              ],
              [
                46.0946329,
                34.0210329
              ],
              [
                46.0965758,
                34.0210329
              ],
              [
                46.0993564,
                34.0202025
              ],
              [
                46.1007432,
                34.0202025
              ],
              [
                46.1110231,
                34.0149222
              ],
              [
                46.1273844,
                33.9999291
              ],
              [
                46.1401894,
                33.9960303
              ],
              [
                46.1401894,
                33.9957595
              ],
              [
                46.1415791,
                33.9951998
              ],
              [
                46.1485255,
                33.9899285
              ],
              [
                46.1493591,
                33.9899285
              ],
              [
                46.1538022,
                33.9888093
              ],
              [
                46.1565787,
                33.9888093
              ],
              [
                46.1574124,
                33.9890891
              ],
              [
                46.1646353,
                33.9890892
              ],
              [
                46.1651923,
                33.9888093
              ],
              [
                46.1682485,
                33.9879789
              ],
              [
                46.1796355,
                33.9801982
              ],
              [
                46.1949156,
                33.9724175
              ],
              [
                46.1954719,
                33.9721467
              ],
              [
                46.2001954,
                33.970197
              ],
              [
                46.2024149,
                33.9696464
              ],
              [
                46.213248,
                33.965756
              ],
              [
                46.2146386,
                33.965756
              ],
              [
                46.2151949,
                33.9654762
              ],
              [
                46.2251952,
                33.9638154
              ],
              [
                46.2290851,
                33.9624253
              ],
              [
                46.2304718,
                33.9624253
              ],
              [
                46.232418,
                33.9618657
              ],
              [
                46.2338047,
                33.9618656
              ],
              [
                46.2451947,
                33.9593654
              ],
              [
                46.2463081,
                33.9588147
              ],
              [
                46.2782541,
                33.9507633
              ],
              [
                46.2788072,
                33.9507632
              ],
              [
                46.2799213,
                33.9507633
              ],
              [
                46.2815877,
                33.9502036
              ],
              [
                46.2904738,
                33.9543648
              ],
              [
                46.2913074,
                33.957145
              ],
              [
                46.2910309,
                33.9574248
              ],
              [
                46.2913074,
                33.9589556
              ],
              [
                46.2913074,
                33.9596453
              ],
              [
                46.2910309,
                33.9604847
              ],
              [
                46.289087,
                33.9657563
              ],
              [
                46.2918636,
                33.982419
              ],
              [
                46.2951972,
                33.9927
              ],
              [
                46.2976972,
                33.9949296
              ],
              [
                46.2982535,
                33.9952004
              ],
              [
                46.2985308,
                33.9954801
              ],
              [
                46.3068639,
                33.99131
              ],
              [
                46.3074201,
                33.9910392
              ],
              [
                46.3490897,
                33.9727067
              ],
              [
                46.3557564,
                33.9704863
              ],
              [
                46.3921463,
                33.9524244
              ],
              [
                46.3929798,
                33.9518647
              ],
              [
                46.4682619,
                33.9129785
              ],
              [
                46.4696519,
                33.9118682
              ],
              [
                46.4710386,
                33.9113176
              ],
              [
                46.4718722,
                33.910758
              ],
              [
                46.472705,
                33.9107579
              ],
              [
                46.4849288,
                33.9057572
              ],
              [
                46.5013182,
                33.8979763
              ],
              [
                46.5415979,
                33.8699212
              ],
              [
                46.5418777,
                33.8696414
              ],
              [
                46.558264,
                33.8615895
              ],
              [
                46.5591007,
                33.8615894
              ],
              [
                46.5593781,
                33.8613096
              ],
              [
                46.5599343,
                33.8613096
              ],
              [
                46.5602108,
                33.8610298
              ],
              [
                46.5816005,
                33.849647
              ],
              [
                46.582434,
                33.8490873
              ],
              [
                46.5835442,
                33.8488164
              ],
              [
                46.5899342,
                33.8451967
              ],
              [
                46.5907671,
                33.8449259
              ],
              [
                46.6154902,
                33.8340847
              ],
              [
                46.6160473,
                33.8338138
              ],
              [
                46.6163238,
                33.833534
              ],
              [
                46.6168801,
                33.833534
              ],
              [
                46.6168801,
                33.8332542
              ],
              [
                46.62077,
                33.8313134
              ],
              [
                46.6210473,
                33.8310336
              ],
              [
                46.621324,
                33.830825
              ],
              [
                46.6254905,
                33.8327658
              ],
              [
                46.6260467,
                33.8330547
              ],
              [
                46.6293803,
                33.8333255
              ],
              [
                46.6352132,
                33.8344358
              ],
              [
                46.6377133,
                33.8344358
              ],
              [
                46.6391032,
                33.8347157
              ],
              [
                46.6399368,
                33.8344358
              ],
              [
                46.6416033,
                33.8344358
              ],
              [
                46.6424369,
                33.834156
              ],
              [
                46.6446604,
                33.8344359
              ],
              [
                46.6471604,
                33.8344359
              ],
              [
                46.65827,
                33.8372161
              ],
              [
                46.6638263,
                33.8397167
              ],
              [
                46.6702163,
                33.8444377
              ],
              [
                46.6732734,
                33.8480485
              ],
              [
                46.6738265,
                33.8513795
              ],
              [
                46.6716029,
                33.8577705
              ],
              [
                46.6699365,
                33.8599911
              ],
              [
                46.6699365,
                33.8602709
              ],
              [
                46.6682693,
                33.8622207
              ],
              [
                46.6488267,
                33.8749936
              ],
              [
                46.6485462,
                33.8755533
              ],
              [
                46.6402132,
                33.8797146
              ],
              [
                46.6396601,
                33.8802743
              ],
              [
                46.6379936,
                33.8808249
              ],
              [
                46.6079906,
                33.8994379
              ],
              [
                46.594934,
                33.9124905
              ],
              [
                46.5932668,
                33.9136098
              ],
              [
                46.5925312,
                33.9141604
              ],
              [
                46.5904902,
                33.9160389
              ],
              [
                46.5901373,
                33.9163903
              ],
              [
                46.5877104,
                33.9185393
              ],
              [
                46.5849338,
                33.9202002
              ],
              [
                46.5843767,
                33.9207598
              ],
              [
                46.5454046,
                33.9422397
              ],
              [
                46.5071865,
                33.9584542
              ],
              [
                46.4866014,
                33.9813469
              ],
              [
                46.4725023,
                33.9996605
              ],
              [
                46.446085,
                34.0233898
              ],
              [
                46.4357584,
                34.0404763
              ],
              [
                46.4352053,
                34.0404762
              ],
              [
                46.4302051,
                34.0454767
              ],
              [
                46.4296489,
                34.0457566
              ],
              [
                46.4285387,
                34.0471465
              ],
              [
                46.3782555,
                34.0838192
              ],
              [
                46.3779789,
                34.0843697
              ],
              [
                46.3765891,
                34.0849293
              ],
              [
                46.3443664,
                34.1040912
              ],
              [
                46.3432563,
                34.1046508
              ],
              [
                46.3418664,
                34.1060408
              ],
              [
                46.3190862,
                34.1196517
              ],
              [
                46.317976,
                34.1202022
              ],
              [
                46.3174197,
                34.120482
              ],
              [
                46.3171432,
                34.1207618
              ],
              [
                46.3157534,
                34.1207618
              ],
              [
                46.3151994,
                34.1210416
              ],
              [
                46.3143666,
                34.1210415
              ],
              [
                46.29492,
                34.1332624
              ],
              [
                46.2913066,
                34.133813
              ],
              [
                46.28992,
                34.1343725
              ],
              [
                46.2890863,
                34.1343726
              ],
              [
                46.2888066,
                34.1346523
              ],
              [
                46.287973,
                34.1346524
              ],
              [
                46.2876965,
                34.1349321
              ],
              [
                46.2863066,
                34.1349322
              ],
              [
                46.28603,
                34.1352119
              ],
              [
                46.2854738,
                34.135212
              ],
              [
                46.2849198,
                34.1354827
              ],
              [
                46.2832533,
                34.1354827
              ],
              [
                46.2826971,
                34.1357625
              ],
              [
                46.2360275,
                34.1324319
              ],
              [
                46.2354704,
                34.1321521
              ],
              [
                46.2293609,
                34.132152
              ],
              [
                46.2290843,
                34.1324319
              ],
              [
                46.2268609,
                34.1340926
              ],
              [
                46.2235272,
                34.1363219
              ],
              [
                46.2224177,
                34.1374321
              ],
              [
                46.2210279,
                34.138813
              ],
              [
                46.2140808,
                34.147983
              ],
              [
                46.2054712,
                34.1685434
              ],
              [
                46.195471,
                34.1840944
              ],
              [
                46.1932474,
                34.1874247
              ],
              [
                46.1832479,
                34.1988148
              ],
              [
                46.1624146,
                34.223815
              ],
              [
                46.146858,
                34.2513148
              ],
              [
                46.1468579,
                34.2518743
              ],
              [
                46.146858,
                34.2521541
              ],
              [
                46.1463017,
                34.2521541
              ],
              [
                46.143525,
                34.2521541
              ],
              [
                46.1432446,
                34.2518743
              ],
              [
                46.142411,
                34.2518744
              ],
              [
                46.1243552,
                34.2413239
              ],
              [
                46.1132449,
                34.237434
              ],
              [
                46.1121315,
                34.237434
              ],
              [
                46.1118549,
                34.2371542
              ],
              [
                46.1110221,
                34.2371542
              ],
              [
                46.1107456,
                34.2368744
              ],
              [
                46.1099119,
                34.2368744
              ],
              [
                46.1090783,
                34.2365946
              ],
              [
                46.0985219,
                34.2346541
              ],
              [
                46.0968554,
                34.2343743
              ],
              [
                46.0957422,
                34.2338238
              ],
              [
                46.0949085,
                34.2338238
              ],
              [
                46.093242,
                34.2329844
              ],
              [
                46.0849092,
                34.2321541
              ],
              [
                46.0843521,
                34.2318743
              ],
              [
                46.0826856,
                34.2318743
              ],
              [
                46.0740753,
                34.2288148
              ],
              [
                46.0732425,
                34.2288148
              ],
              [
                46.0726855,
                34.2285349
              ],
              [
                46.0676853,
                34.228535
              ],
              [
                46.0674087,
                34.2288147
              ],
              [
                46.0662955,
                34.2288148
              ],
              [
                46.0582421,
                34.2318742
              ],
              [
                46.0576858,
                34.2321541
              ],
              [
                46.0529624,
                34.234654
              ],
              [
                46.0507428,
                34.234654
              ],
              [
                46.0501857,
                34.2343742
              ],
              [
                46.0490724,
                34.2343742
              ],
              [
                46.0487959,
                34.2340944
              ],
              [
                46.0479623,
                34.2340944
              ],
              [
                46.034073,
                34.2279843
              ],
              [
                46.0332394,
                34.2279843
              ],
              [
                46.0321291,
                34.2274247
              ],
              [
                46.0310198,
                34.2274247
              ],
              [
                46.02324,
                34.2240943
              ],
              [
                46.0229634,
                34.2238145
              ],
              [
                46.0121296,
                34.2157639
              ],
              [
                46.0076834,
                34.2132639
              ],
              [
                46.0068498,
                34.213264
              ],
              [
                46.0062935,
                34.2129841
              ],
              [
                46.0040732,
                34.2129841
              ],
              [
                46.0037936,
                34.2132639
              ],
              [
                46.0015731,
                34.2132639
              ],
              [
                45.996573,
                34.2140942
              ],
              [
                45.9962933,
                34.214374
              ],
              [
                45.9918503,
                34.2143739
              ],
              [
                45.9915698,
                34.2146538
              ],
              [
                45.9893502,
                34.2146538
              ],
              [
                45.9887932,
                34.2146538
              ],
              [
                45.9885166,
                34.2149336
              ],
              [
                45.9862931,
                34.2149336
              ],
              [
                45.9840704,
                34.2154841
              ],
              [
                45.9837939,
                34.2157639
              ],
              [
                45.9829603,
                34.2157638
              ],
              [
                45.9760172,
                34.2210436
              ],
              [
                45.9779601,
                34.2338234
              ],
              [
                45.9774038,
                34.2346538
              ],
              [
                45.9757367,
                34.2377043
              ],
              [
                45.9757365,
                34.2382638
              ],
              [
                45.9751835,
                34.2388234
              ],
              [
                45.9749038,
                34.2396537
              ],
              [
                45.9718466,
                34.2427042
              ],
              [
                45.9715701,
                34.2432638
              ],
              [
                45.9685137,
                34.2482637
              ],
              [
                45.9699036,
                34.2529839
              ],
              [
                45.9701801,
                34.2538142
              ],
              [
                45.9724036,
                34.2557637
              ],
              [
                45.9757365,
                34.2563142
              ],
              [
                45.9768498,
                34.2554839
              ],
              [
                45.9774037,
                34.2554839
              ],
              [
                45.9910166,
                34.2410437
              ],
              [
                45.9910166,
                34.2407639
              ],
              [
                45.996573,
                34.2360437
              ],
              [
                45.9971269,
                34.2360437
              ],
              [
                45.9971269,
                34.2357639
              ],
              [
                45.9979597,
                34.235764
              ],
              [
                45.9982402,
                34.2354841
              ],
              [
                46.0037934,
                34.2354842
              ],
              [
                46.0162968,
                34.2399337
              ],
              [
                46.0171295,
                34.2399336
              ],
              [
                46.0185163,
                34.2404842
              ],
              [
                46.01935,
                34.2404842
              ],
              [
                46.0210164,
                34.2413235
              ],
              [
                46.0218492,
                34.2413235
              ],
              [
                46.0296298,
                34.2454842
              ],
              [
                46.0299064,
                34.2457639
              ],
              [
                46.0324064,
                34.2488145
              ],
              [
                46.0326861,
                34.2499336
              ],
              [
                46.0324064,
                34.2504842
              ],
              [
                46.0299063,
                34.2552043
              ],
              [
                46.0274062,
                34.2563144
              ],
              [
                46.0271297,
                34.2565941
              ],
              [
                46.0260164,
                34.2565941
              ],
              [
                46.0254625,
                34.2568739
              ],
              [
                46.0199062,
                34.2568739
              ],
              [
                46.0193499,
                34.2565942
              ],
              [
                46.0176826,
                34.2565942
              ],
              [
                46.0176826,
                34.2563144
              ],
              [
                46.0160162,
                34.2563144
              ],
              [
                46.0146294,
                34.2560436
              ],
              [
                46.0140732,
                34.2557638
              ],
              [
                46.0121294,
                34.2557638
              ],
              [
                46.0115732,
                34.2554841
              ],
              [
                46.0096262,
                34.255484
              ],
              [
                46.0093497,
                34.2557638
              ],
              [
                46.0085161,
                34.2557638
              ],
              [
                46.0051832,
                34.2574335
              ],
              [
                46.00462,
                34.2582699
              ],
              [
                45.9882366,
                34.2715937
              ],
              [
                45.9874031,
                34.2724331
              ],
              [
                45.9612939,
                34.2918729
              ],
              [
                45.9604603,
                34.2921526
              ],
              [
                45.9471232,
                34.3066015
              ],
              [
                45.9457373,
                34.3082621
              ],
              [
                45.9374948,
                34.3194285
              ],
              [
                45.9371237,
                34.3199312
              ],
              [
                45.9074003,
                34.3493788
              ],
              [
                45.9060104,
                34.3504889
              ],
              [
                45.9043439,
                34.3513192
              ],
              [
                45.8785105,
                34.3724367
              ],
              [
                45.863511,
                34.3852063
              ],
              [
                45.8623976,
                34.3860456
              ],
              [
                45.8307313,
                34.4210511
              ],
              [
                45.8304516,
                34.4216016
              ],
              [
                45.8301743,
                34.4218723
              ],
              [
                45.8301742,
                34.4221521
              ],
              [
                45.8287844,
                34.4229914
              ],
              [
                45.8235076,
                34.4229913
              ],
              [
                45.8229514,
                34.4232711
              ],
              [
                45.8187849,
                34.4232711
              ],
              [
                45.8140614,
                34.4210511
              ],
              [
                45.8132278,
                34.4204915
              ],
              [
                45.8060081,
                34.4143731
              ],
              [
                45.7935048,
                34.3971545
              ],
              [
                45.7927329,
                34.3974953
              ],
              [
                45.7923954,
                34.3971544
              ],
              [
                45.7921189,
                34.396604
              ],
              [
                45.790172,
                34.3940952
              ],
              [
                45.7896188,
                34.3938155
              ],
              [
                45.7782288,
                34.3765967
              ],
              [
                45.7671153,
                34.3668772
              ],
              [
                45.7654489,
                34.366047
              ],
              [
                45.7643388,
                34.3654874
              ],
              [
                45.756559,
                34.362437
              ],
              [
                45.7546159,
                34.3624371
              ],
              [
                45.7537823,
                34.3621573
              ],
              [
                45.7526721,
                34.3621573
              ],
              [
                45.7518393,
                34.3618775
              ],
              [
                45.750726,
                34.3618775
              ],
              [
                45.7504494,
                34.3615978
              ],
              [
                45.7473923,
                34.3615978
              ],
              [
                45.7465595,
                34.3613179
              ],
              [
                45.7454493,
                34.3615978
              ],
              [
                45.7393358,
                34.3615978
              ],
              [
                45.7385023,
                34.3618775
              ],
              [
                45.7296162,
                34.3618774
              ],
              [
                45.7287826,
                34.3615977
              ],
              [
                45.7221129,
                34.3615978
              ],
              [
                45.7218364,
                34.3613179
              ],
              [
                45.7154463,
                34.3602079
              ],
              [
                45.7137799,
                34.3602078
              ],
              [
                45.713226,
                34.3599281
              ],
              [
                45.7121127,
                34.3599281
              ],
              [
                45.7112799,
                34.3596483
              ],
              [
                45.70739,
                34.3593776
              ],
              [
                45.7054462,
                34.358818
              ],
              [
                45.7029462,
                34.3585473
              ],
              [
                45.6987796,
                34.3585473
              ],
              [
                45.6985031,
                34.3582675
              ],
              [
                45.696003,
                34.3582675
              ],
              [
                45.6951701,
                34.3579877
              ],
              [
                45.6868332,
                34.3579877
              ],
              [
                45.6862801,
                34.3582675
              ],
              [
                45.6785003,
                34.3582674
              ],
              [
                45.6779464,
                34.3579877
              ],
              [
                45.6668336,
                34.3579876
              ],
              [
                45.6621102,
                34.3590977
              ],
              [
                45.6596101,
                34.3590977
              ],
              [
                45.659057,
                34.3593774
              ],
              [
                45.6565569,
                34.3599279
              ],
              [
                45.6551671,
                34.3599279
              ],
              [
                45.65461,
                34.3602077
              ],
              [
                45.6537772,
                34.3602077
              ],
              [
                45.6532241,
                34.3604874
              ],
              [
                45.6521107,
                34.3604874
              ],
              [
                45.6515536,
                34.3607672
              ],
              [
                45.6490536,
                34.3607672
              ],
              [
                45.6485005,
                34.361047
              ],
              [
                45.6476668,
                34.361047
              ],
              [
                45.6460004,
                34.3604875
              ],
              [
                45.6446106,
                34.3604874
              ],
              [
                45.6407207,
                34.3585471
              ],
              [
                45.6371105,
                34.3507679
              ],
              [
                45.6376676,
                34.3485387
              ],
              [
                45.6396106,
                34.3438189
              ],
              [
                45.639887,
                34.3435391
              ],
              [
                45.641834,
                34.3382686
              ],
              [
                45.6435004,
                34.334379
              ],
              [
                45.6435004,
                34.3338195
              ],
              [
                45.6443341,
                34.3327094
              ],
              [
                45.6443341,
                34.3321499
              ],
              [
                45.6448873,
                34.3315993
              ],
              [
                45.6479436,
                34.3271501
              ],
              [
                45.6696106,
                34.2999312
              ],
              [
                45.6698903,
                34.299101
              ],
              [
                45.6701668,
                34.2979909
              ],
              [
                45.6704434,
                34.2974314
              ],
              [
                45.6704434,
                34.2941012
              ],
              [
                45.6701669,
                34.2927113
              ],
              [
                45.6698903,
                34.2921518
              ],
              [
                45.6690575,
                34.2885418
              ],
              [
                45.6690575,
                34.2818724
              ],
              [
                45.6693341,
                34.2816016
              ],
              [
                45.669334,
                34.2813217
              ],
              [
                45.6693341,
                34.2804915
              ],
              [
                45.6693341,
                34.2796521
              ],
              [
                45.6696107,
                34.2793724
              ],
              [
                45.6696107,
                34.2788219
              ],
              [
                45.6701669,
                34.2777118
              ],
              [
                45.6704435,
                34.276322
              ],
              [
                45.670724,
                34.273822
              ],
              [
                45.6710005,
                34.2721523
              ],
              [
                45.6712771,
                34.2718725
              ],
              [
                45.6712771,
                34.2699322
              ],
              [
                45.6718342,
                34.2668727
              ],
              [
                45.6812805,
                34.2402034
              ],
              [
                45.6812806,
                34.2399326
              ],
              [
                45.6815571,
                34.2377034
              ],
              [
                45.6818337,
                34.2357629
              ],
              [
                45.6821143,
                34.2335427
              ],
              [
                45.6823908,
                34.233263
              ],
              [
                45.6821143,
                34.2324327
              ],
              [
                45.6823908,
                34.2321529
              ],
              [
                45.6818338,
                34.2243731
              ],
              [
                45.6821142,
                34.2235428
              ],
              [
                45.6818338,
                34.2229832
              ],
              [
                45.6801674,
                34.211873
              ],
              [
                45.6798909,
                34.207983
              ],
              [
                45.6796143,
                34.2077032
              ],
              [
                45.6782244,
                34.2046527
              ],
              [
                45.6593344,
                34.1724226
              ],
              [
                45.6590578,
                34.1704822
              ],
              [
                45.6587781,
                34.1635416
              ],
              [
                45.6590579,
                34.161592
              ],
              [
                45.6587782,
                34.1607617
              ],
              [
                45.6593344,
                34.1496512
              ],
              [
                45.6596111,
                34.1490915
              ],
              [
                45.6598916,
                34.1457611
              ],
              [
                45.6598915,
                34.1429812
              ],
              [
                45.6632244,
                34.1279804
              ],
              [
                45.663501,
                34.1257602
              ],
              [
                45.6640581,
                34.1238105
              ],
              [
                45.6635011,
                34.1121492
              ],
              [
                45.6629449,
                34.0882578
              ],
              [
                45.6657248,
                34.0763074
              ],
              [
                45.6668349,
                34.074096
              ],
              [
                45.6690584,
                34.0696463
              ],
              [
                45.6843346,
                34.0543652
              ],
              [
                45.700171,
                34.0427036
              ],
              [
                45.7215612,
                34.032143
              ],
              [
                45.7658164,
                34.0029062
              ],
              [
                45.7545245,
                33.9812383
              ],
              [
                45.7464546,
                33.9657457
              ],
              [
                45.7469562,
                33.948055
              ],
              [
                45.7477141,
                33.9213075
              ],
              [
                45.7391354,
                33.9081675
              ],
              [
                45.7186746,
                33.8889922
              ],
              [
                45.7089943,
                33.879916
              ],
              [
                45.6917542,
                33.8441255
              ],
              [
                45.670041,
                33.8196565
              ],
              [
                45.6473543,
                33.8055201
              ],
              [
                45.6183973,
                33.8006724
              ],
              [
                45.6127931,
                33.7996876
              ],
              [
                45.6097194,
                33.7989764
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 819610833
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          45.5800155,
          34.515594
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3520078317
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          46.1495838,
          34.7390185
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32663279
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.0735891,
          34.3239414
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 831526650
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.5988073,
          34.7832217
        ]
      }
    }
  ]
},
"کهگیلویه و بویراحمد.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554907,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان باشت",
          "name:en": "Basht County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4866908",
          "wikipedia": "en:Basht County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.844582,
                30.6112475
              ],
              [
                50.8434685,
                30.610688
              ],
              [
                50.8431919,
                30.6101374
              ],
              [
                50.8048557,
                30.5906895
              ],
              [
                50.8034659,
                30.5890199
              ],
              [
                50.8051324,
                30.5848506
              ],
              [
                50.8087458,
                30.5812498
              ],
              [
                50.8098558,
                30.5806903
              ],
              [
                50.8101357,
                30.5801307
              ],
              [
                50.8151357,
                30.5770715
              ],
              [
                50.8190221,
                30.5737415
              ],
              [
                50.8276354,
                30.5668018
              ],
              [
                50.8323588,
                30.5623527
              ],
              [
                50.8329121,
                30.5618022
              ],
              [
                50.8473587,
                30.5437446
              ],
              [
                50.8554151,
                30.529017
              ],
              [
                50.8581917,
                30.5206877
              ],
              [
                50.873825,
                30.5102339
              ],
              [
                50.8745815,
                30.5098588
              ],
              [
                50.8751383,
                30.5098588
              ],
              [
                50.8759715,
                30.5092993
              ],
              [
                50.8818049,
                30.5062492
              ],
              [
                50.9004144,
                30.490412
              ],
              [
                50.9595871,
                30.436242
              ],
              [
                50.9615305,
                30.4340222
              ],
              [
                50.9998666,
                30.4056881
              ],
              [
                51.00181,
                30.4023494
              ],
              [
                51.00181,
                30.4026291
              ],
              [
                51.0104197,
                30.3948509
              ],
              [
                51.0220897,
                30.3784644
              ],
              [
                51.0220897,
                30.3781847
              ],
              [
                51.0222101,
                30.3778851
              ],
              [
                51.069869,
                30.3040145
              ],
              [
                51.0862587,
                30.2876289
              ],
              [
                51.0887588,
                30.2854093
              ],
              [
                51.1223718,
                30.2587381
              ],
              [
                51.1718176,
                30.22263
              ],
              [
                51.1779276,
                30.2167924
              ],
              [
                51.178761,
                30.2159624
              ],
              [
                51.1836495,
                30.2105155
              ],
              [
                51.1840409,
                30.2109549
              ],
              [
                51.1862643,
                30.2156827
              ],
              [
                51.189874,
                30.2190119
              ],
              [
                51.1912641,
                30.2259593
              ],
              [
                51.1923741,
                30.227069
              ],
              [
                51.1929307,
                30.2273487
              ],
              [
                51.1945974,
                30.230678
              ],
              [
                51.1945973,
                30.2309577
              ],
              [
                51.1948739,
                30.2323472
              ],
              [
                51.1968173,
                30.2354058
              ],
              [
                51.2059872,
                30.2362359
              ],
              [
                51.2062638,
                30.2365156
              ],
              [
                51.2073737,
                30.2365156
              ],
              [
                51.2076539,
                30.2367952
              ],
              [
                51.2082071,
                30.2367953
              ],
              [
                51.2101539,
                30.2390148
              ],
              [
                51.210707,
                30.2392945
              ],
              [
                51.2109871,
                30.2398539
              ],
              [
                51.2115404,
                30.2401246
              ],
              [
                51.2115405,
                30.2404043
              ],
              [
                51.2123736,
                30.2404042
              ],
              [
                51.2129303,
                30.240684
              ],
              [
                51.2148736,
                30.240684
              ],
              [
                51.2184871,
                30.2417937
              ],
              [
                51.2251536,
                30.2481818
              ],
              [
                51.2276536,
                30.2490208
              ],
              [
                51.2301535,
                30.2492915
              ],
              [
                51.23043,
                30.2495712
              ],
              [
                51.2312634,
                30.2495712
              ],
              [
                51.2315435,
                30.249851
              ],
              [
                51.2326535,
                30.249851
              ],
              [
                51.2345967,
                30.250681
              ],
              [
                51.2354301,
                30.250681
              ],
              [
                51.2379299,
                30.2520705
              ],
              [
                51.2387633,
                30.2567984
              ],
              [
                51.2490432,
                30.2640165
              ],
              [
                51.2629329,
                30.2756829
              ],
              [
                51.2632097,
                30.2759626
              ],
              [
                51.2634896,
                30.2762333
              ],
              [
                51.2637663,
                30.276513
              ],
              [
                51.2637664,
                30.2767927
              ],
              [
                51.2645995,
                30.2767927
              ],
              [
                51.2648763,
                30.2770725
              ],
              [
                51.265433,
                30.2770724
              ],
              [
                51.265433,
                30.2773521
              ],
              [
                51.2676563,
                30.2787416
              ],
              [
                51.2679328,
                30.2790123
              ],
              [
                51.2690428,
                30.2795718
              ],
              [
                51.2707094,
                30.2823507
              ],
              [
                51.2720995,
                30.2890186
              ],
              [
                51.2784253,
                30.2915544
              ],
              [
                51.2793265,
                30.2957602
              ],
              [
                51.2804852,
                30.2978538
              ],
              [
                51.2412391,
                30.3218246
              ],
              [
                51.240016,
                30.3231397
              ],
              [
                51.2379776,
                30.3248808
              ],
              [
                51.2382994,
                30.3362339
              ],
              [
                51.2409188,
                30.3415125
              ],
              [
                51.2426094,
                30.3441305
              ],
              [
                51.243575,
                30.3478525
              ],
              [
                51.2459997,
                30.3511856
              ],
              [
                51.2467078,
                30.3564813
              ],
              [
                51.2506346,
                30.3638318
              ],
              [
                51.2564925,
                30.3699413
              ],
              [
                51.2636809,
                30.3734588
              ],
              [
                51.2693161,
                30.3745189
              ],
              [
                51.2732643,
                30.3758889
              ],
              [
                51.2799377,
                30.3759999
              ],
              [
                51.283049,
                30.3760555
              ],
              [
                51.2861818,
                30.3803872
              ],
              [
                51.2892932,
                30.3890871
              ],
              [
                51.255433,
                30.4156864
              ],
              [
                51.255433,
                30.4159662
              ],
              [
                51.22043,
                30.4537393
              ],
              [
                51.2195967,
                30.4542988
              ],
              [
                51.2184868,
                30.4559682
              ],
              [
                51.2143201,
                30.4615178
              ],
              [
                51.2045969,
                30.4734654
              ],
              [
                51.203207,
                30.474855
              ],
              [
                51.2026501,
                30.4762448
              ],
              [
                51.2012635,
                30.4776344
              ],
              [
                51.1870971,
                30.5048508
              ],
              [
                51.1848737,
                30.5129092
              ],
              [
                51.1790405,
                30.5306869
              ],
              [
                51.1687606,
                30.5398554
              ],
              [
                51.1684839,
                30.5401353
              ],
              [
                51.1640373,
                30.5462446
              ],
              [
                51.1623708,
                30.5476344
              ],
              [
                51.1429277,
                30.5640225
              ],
              [
                51.1432043,
                30.5806907
              ],
              [
                51.143761,
                30.5876396
              ],
              [
                51.1395795,
                30.5929829
              ],
              [
                51.1355668,
                30.5955365
              ],
              [
                51.1266709,
                30.5927478
              ],
              [
                51.1218859,
                30.589423
              ],
              [
                51.1201478,
                30.58819
              ],
              [
                51.116258,
                30.5876395
              ],
              [
                51.1159813,
                30.5873598
              ],
              [
                51.1148713,
                30.5873598
              ],
              [
                51.1145913,
                30.58708
              ],
              [
                51.1129247,
                30.58708
              ],
              [
                51.1123714,
                30.5868003
              ],
              [
                51.111258,
                30.5868002
              ],
              [
                51.1109815,
                30.5865205
              ],
              [
                51.1095914,
                30.5865205
              ],
              [
                51.1087579,
                30.5865205
              ],
              [
                51.1076482,
                30.5865204
              ],
              [
                51.1068148,
                30.5862497
              ],
              [
                51.1009814,
                30.5865205
              ],
              [
                51.0993148,
                30.5862498
              ],
              [
                51.099035,
                30.5859699
              ],
              [
                51.0976482,
                30.58597
              ],
              [
                51.0970915,
                30.5856902
              ],
              [
                51.0926483,
                30.5856902
              ],
              [
                51.0920917,
                30.5854105
              ],
              [
                51.0901485,
                30.5856902
              ],
              [
                51.0884783,
                30.5856902
              ],
              [
                51.0554222,
                30.5954096
              ],
              [
                51.0284758,
                30.6134677
              ],
              [
                51.0279226,
                30.6137475
              ],
              [
                50.9995861,
                30.642076
              ],
              [
                50.9915298,
                30.6465252
              ],
              [
                50.9893098,
                30.6484656
              ],
              [
                50.9887531,
                30.6495757
              ],
              [
                50.9545835,
                30.6781936
              ],
              [
                50.9493069,
                30.6798631
              ],
              [
                50.9454169,
                30.6801338
              ],
              [
                50.9445836,
                30.6798631
              ],
              [
                50.9431969,
                30.6798631
              ],
              [
                50.9412503,
                30.6790238
              ],
              [
                50.9293073,
                30.6737532
              ],
              [
                50.924584,
                30.670414
              ],
              [
                50.9204173,
                30.6651344
              ],
              [
                50.917084,
                30.6565247
              ],
              [
                50.9173608,
                30.6559741
              ],
              [
                50.9184708,
                30.652635
              ],
              [
                50.9259741,
                30.6445758
              ],
              [
                50.9334738,
                30.6395761
              ],
              [
                50.9468071,
                30.6279071
              ],
              [
                50.9468071,
                30.6273566
              ],
              [
                50.9473637,
                30.6267971
              ],
              [
                50.9473637,
                30.625687
              ],
              [
                50.9456971,
                30.6242972
              ],
              [
                50.9437504,
                30.6240265
              ],
              [
                50.9273606,
                30.6254073
              ],
              [
                50.9226408,
                30.626797
              ],
              [
                50.917084,
                30.6290261
              ],
              [
                50.8890278,
                30.6423557
              ],
              [
                50.8851379,
                30.6423557
              ],
              [
                50.8818047,
                30.6415254
              ],
              [
                50.8795812,
                30.6406861
              ],
              [
                50.8745813,
                30.6373559
              ],
              [
                50.8740247,
                30.6365257
              ],
              [
                50.8506919,
                30.612908
              ],
              [
                50.8481918,
                30.6115272
              ],
              [
                50.8476352,
                30.6112475
              ],
              [
                50.8448586,
                30.6112474
              ],
              [
                50.844582,
                30.6112475
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554948,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بهمئی",
          "name:en": "Bahmai County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278157",
          "wikipedia": "en:Bahmai County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.8863183,
                30.9644455
              ],
              [
                49.8862115,
                30.9642596
              ],
              [
                49.8865088,
                30.9625502
              ],
              [
                49.887024,
                30.9607005
              ],
              [
                49.8877565,
                30.9594053
              ],
              [
                49.8884887,
                30.9583876
              ],
              [
                49.8904616,
                30.9569216
              ],
              [
                49.8908654,
                30.9566215
              ],
              [
                49.8936196,
                30.9553595
              ],
              [
                49.8972626,
                30.9524808
              ],
              [
                49.9036483,
                30.9476021
              ],
              [
                49.9130823,
                30.9399404
              ],
              [
                49.9169313,
                30.9371058
              ],
              [
                49.9181442,
                30.9360852
              ],
              [
                49.918934,
                30.935573
              ],
              [
                49.9195672,
                30.9351091
              ],
              [
                49.920044,
                30.9349213
              ],
              [
                49.9207345,
                30.9349181
              ],
              [
                49.9213754,
                30.935052
              ],
              [
                49.9219094,
                30.9350971
              ],
              [
                49.9225464,
                30.9351407
              ],
              [
                49.9230768,
                30.9349512
              ],
              [
                49.92371,
                30.9347196
              ],
              [
                49.9242936,
                30.9343929
              ],
              [
                49.92519,
                30.9338815
              ],
              [
                49.9252929,
                30.9336027
              ],
              [
                49.9253921,
                30.933096
              ],
              [
                49.9253885,
                30.9327711
              ],
              [
                49.9253274,
                30.9320353
              ],
              [
                49.9249953,
                30.9312521
              ],
              [
                49.9246675,
                30.9305614
              ],
              [
                49.9243432,
                30.9299632
              ],
              [
                49.9240151,
                30.9294101
              ],
              [
                49.9236372,
                30.9289513
              ],
              [
                49.9233131,
                30.9286306
              ],
              [
                49.9233094,
                30.9282606
              ],
              [
                49.9234123,
                30.9278915
              ],
              [
                49.9236754,
                30.9277065
              ],
              [
                49.9243128,
                30.9276554
              ],
              [
                49.9250604,
                30.9278376
              ],
              [
                49.9260216,
                30.9282471
              ],
              [
                49.9274672,
                30.9289809
              ],
              [
                49.9285392,
                30.9295266
              ],
              [
                49.9303092,
                30.9306262
              ],
              [
                49.9311638,
                30.9310371
              ],
              [
                49.9315911,
                30.9311737
              ],
              [
                49.9321282,
                30.9312326
              ],
              [
                49.9323921,
                30.9312615
              ],
              [
                49.9329757,
                30.9311648
              ],
              [
                49.9335098,
                30.9312549
              ],
              [
                49.9341544,
                30.9318512
              ],
              [
                49.934536,
                30.9324521
              ],
              [
                49.9348677,
                30.9336007
              ],
              [
                49.9352035,
                30.9346163
              ],
              [
                49.9355277,
                30.9352618
              ],
              [
                49.935852,
                30.9356276
              ],
              [
                49.9358658,
                30.935721
              ],
              [
                49.9359132,
                30.9360432
              ],
              [
                49.9357032,
                30.9363663
              ],
              [
                49.9352799,
                30.9363695
              ],
              [
                49.9343225,
                30.9363729
              ],
              [
                49.9328346,
                30.9365659
              ],
              [
                49.932728,
                30.9366575
              ],
              [
                49.9321443,
                30.9368467
              ],
              [
                49.9318277,
                30.9370786
              ],
              [
                49.9318351,
                30.9375862
              ],
              [
                49.9321593,
                30.937907
              ],
              [
                49.93264,
                30.9381816
              ],
              [
                49.9334412,
                30.938407
              ],
              [
                49.9341353,
                30.9384962
              ],
              [
                49.9353066,
                30.9385352
              ],
              [
                49.9361572,
                30.9383459
              ],
              [
                49.937107,
                30.9378823
              ],
              [
                49.9377403,
                30.9374635
              ],
              [
                49.9381064,
                30.9370469
              ],
              [
                49.9386253,
                30.9361219
              ],
              [
                49.939041,
                30.9352884
              ],
              [
                49.9392509,
                30.9349202
              ],
              [
                49.939617,
                30.934639
              ],
              [
                49.9398843,
                30.9346389
              ],
              [
                49.9402542,
                30.9346375
              ],
              [
                49.9405783,
                30.9348206
              ],
              [
                49.9408493,
                30.9352807
              ],
              [
                49.9411735,
                30.9356939
              ],
              [
                49.9415512,
                30.9359676
              ],
              [
                49.9418715,
                30.9361056
              ],
              [
                49.9422454,
                30.9361042
              ],
              [
                49.942562,
                30.9358722
              ],
              [
                49.9430848,
                30.9352674
              ],
              [
                49.9438704,
                30.9342949
              ],
              [
                49.9454421,
                30.9325348
              ],
              [
                49.946808,
                30.9312827
              ],
              [
                49.9475441,
                30.9307248
              ],
              [
                49.9488641,
                30.9301671
              ],
              [
                49.9500807,
                30.9296988
              ],
              [
                49.9507713,
                30.9296007
              ],
              [
                49.9511414,
                30.9293713
              ],
              [
                49.9512367,
                30.9285849
              ],
              [
                49.9511222,
                30.9264444
              ],
              [
                49.9509507,
                30.9232344
              ],
              [
                49.9510957,
                30.9183927
              ],
              [
                49.9511185,
                30.9088424
              ],
              [
                49.9513512,
                30.9063044
              ],
              [
                49.9511643,
                30.9044601
              ],
              [
                49.950981,
                30.9028007
              ],
              [
                49.9506415,
                30.9012799
              ],
              [
                49.9500389,
                30.900084
              ],
              [
                49.94944,
                30.8988408
              ],
              [
                49.9484596,
                30.8970937
              ],
              [
                49.9479026,
                30.8954335
              ],
              [
                49.9478149,
                30.8928974
              ],
              [
                49.9477959,
                30.8913747
              ],
              [
                49.9485626,
                30.8893418
              ],
              [
                49.9492835,
                30.8877236
              ],
              [
                49.9505233,
                30.8853201
              ],
              [
                49.9510383,
                30.8845001
              ],
              [
                49.9513917,
                30.8839374
              ],
              [
                49.9515057,
                30.8837558
              ],
              [
                49.9527475,
                30.8812508
              ],
              [
                49.9548836,
                30.8782884
              ],
              [
                49.9555053,
                30.877364
              ],
              [
                49.9577904,
                30.8776306
              ],
              [
                49.9619293,
                30.8776571
              ],
              [
                49.968197,
                30.8778606
              ],
              [
                49.9744035,
                30.8779234
              ],
              [
                49.9787026,
                30.8779507
              ],
              [
                49.9856452,
                30.877412
              ],
              [
                49.9922142,
                30.8767844
              ],
              [
                50.0001564,
                30.874376
              ],
              [
                50.0039788,
                30.8741168
              ],
              [
                50.0087051,
                30.8739117
              ],
              [
                50.013855,
                30.8737074
              ],
              [
                50.0196419,
                30.873228
              ],
              [
                50.0250053,
                30.8723753
              ],
              [
                50.0303689,
                30.8716171
              ],
              [
                50.0333405,
                30.8713077
              ],
              [
                50.035267,
                30.8685769
              ],
              [
                50.0401801,
                30.8629426
              ],
              [
                50.0435448,
                30.8586929
              ],
              [
                50.0479164,
                30.8538415
              ],
              [
                50.0528181,
                30.8487187
              ],
              [
                50.0578269,
                30.8428543
              ],
              [
                50.0613443,
                30.8386052
              ],
              [
                50.0654909,
                30.8346381
              ],
              [
                50.0687905,
                30.8309467
              ],
              [
                50.0690295,
                30.8306933
              ],
              [
                50.0697479,
                30.8299317
              ],
              [
                50.0706565,
                30.8309732
              ],
              [
                50.0724335,
                30.8330097
              ],
              [
                50.0766565,
                30.8369333
              ],
              [
                50.0809859,
                30.8406229
              ],
              [
                50.086006,
                30.8445044
              ],
              [
                50.0891227,
                30.8468881
              ],
              [
                50.0962639,
                30.8522639
              ],
              [
                50.0986442,
                30.8541798
              ],
              [
                50.1022949,
                30.8566594
              ],
              [
                50.1055261,
                30.8587638
              ],
              [
                50.1094437,
                30.860733
              ],
              [
                50.1117746,
                30.8621385
              ],
              [
                50.1146353,
                30.8644725
              ],
              [
                50.117176,
                30.8667613
              ],
              [
                50.1188203,
                30.8680673
              ],
              [
                50.1197028,
                30.8685872
              ],
              [
                50.1205675,
                30.8690965
              ],
              [
                50.1223678,
                30.8704058
              ],
              [
                50.1235885,
                30.8712464
              ],
              [
                50.1249658,
                30.8725979
              ],
              [
                50.1262932,
                30.8739062
              ],
              [
                50.128254,
                30.8761413
              ],
              [
                50.1301613,
                30.8783309
              ],
              [
                50.1322289,
                30.8805216
              ],
              [
                50.1336595,
                30.882153
              ],
              [
                50.1357306,
                30.8837842
              ],
              [
                50.1384887,
                30.8862568
              ],
              [
                50.1431617,
                30.8901316
              ],
              [
                50.1461335,
                30.8926957
              ],
              [
                50.1499594,
                30.8954503
              ],
              [
                50.1527749,
                30.8978283
              ],
              [
                50.1564941,
                30.9005369
              ],
              [
                50.1606943,
                30.9037561
              ],
              [
                50.1644708,
                30.9062325
              ],
              [
                50.168564,
                30.908986
              ],
              [
                50.1741525,
                30.9122114
              ],
              [
                50.1804846,
                30.9163233
              ],
              [
                50.1865006,
                30.919596
              ],
              [
                50.1935807,
                30.9232901
              ],
              [
                50.1977386,
                30.9255333
              ],
              [
                50.2045593,
                30.9296899
              ],
              [
                50.2090912,
                30.9322577
              ],
              [
                50.2097283,
                30.932354
              ],
              [
                50.2104225,
                30.9322635
              ],
              [
                50.2108461,
                30.9316661
              ],
              [
                50.2115289,
                30.9292115
              ],
              [
                50.213482,
                30.9244052
              ],
              [
                50.2151109,
                30.9183923
              ],
              [
                50.2174186,
                30.9097871
              ],
              [
                50.2181014,
                30.907337
              ],
              [
                50.2183609,
                30.9062265
              ],
              [
                50.2185668,
                30.9044682
              ],
              [
                50.2190362,
                30.9017845
              ],
              [
                50.2195587,
                30.8993808
              ],
              [
                50.2201843,
                30.8964656
              ],
              [
                50.2206775,
                30.8942058
              ],
              [
                50.2210732,
                30.8923926
              ],
              [
                50.2217485,
                30.8884604
              ],
              [
                50.2231559,
                30.8814286
              ],
              [
                50.2238807,
                30.8774042
              ],
              [
                50.2240333,
                30.8751809
              ],
              [
                50.2242927,
                30.8737005
              ],
              [
                50.2244989,
                30.8724971
              ],
              [
                50.2247086,
                30.8716186
              ],
              [
                50.2251816,
                30.8703244
              ],
              [
                50.225387,
                30.8698891
              ],
              [
                50.22723,
                30.8659831
              ],
              [
                50.228592,
                30.8621947
              ],
              [
                50.2293816,
                30.8606227
              ],
              [
                50.2305947,
                30.8586381
              ],
              [
                50.2322771,
                30.8555441
              ],
              [
                50.2333795,
                30.8533287
              ],
              [
                50.2340089,
                30.8515256
              ],
              [
                50.2379493,
                30.8444657
              ],
              [
                50.2411993,
                30.8374468
              ],
              [
                50.2422011,
                30.8353968
              ],
              [
                50.2432976,
                30.8331528
              ],
              [
                50.2434539,
                30.8325063
              ],
              [
                50.2434387,
                30.8299144
              ],
              [
                50.2433091,
                30.82519
              ],
              [
                50.2430764,
                30.8211125
              ],
              [
                50.2426896,
                30.8178604
              ],
              [
                50.2420846,
                30.8127738
              ],
              [
                50.2409666,
                30.8116552
              ],
              [
                50.2383653,
                30.8089533
              ],
              [
                50.236187,
                30.806811
              ],
              [
                50.234436,
                30.8054563
              ],
              [
                50.2325783,
                30.8036835
              ],
              [
                50.2316741,
                30.8026608
              ],
              [
                50.2309267,
                30.8012668
              ],
              [
                50.2304459,
                30.8001067
              ],
              [
                50.2302283,
                30.7984362
              ],
              [
                50.2302208,
                30.7969541
              ],
              [
                50.230793,
                30.7945032
              ],
              [
                50.2312051,
                30.7921438
              ],
              [
                50.2315138,
                30.7905283
              ],
              [
                50.2328758,
                30.7879422
              ],
              [
                50.2351876,
                30.784624
              ],
              [
                50.2368162,
                30.7827365
              ],
              [
                50.2373972,
                30.7820344
              ],
              [
                50.2377263,
                30.7816365
              ],
              [
                50.2379189,
                30.7814008
              ],
              [
                50.2404329,
                30.7772965
              ],
              [
                50.243309,
                30.7719468
              ],
              [
                50.2460289,
                30.7673337
              ],
              [
                50.2490157,
                30.7635568
              ],
              [
                50.2499919,
                30.7610021
              ],
              [
                50.2515412,
                30.7587711
              ],
              [
                50.2528573,
                30.7569628
              ],
              [
                50.2541769,
                30.7555763
              ],
              [
                50.2541923,
                30.7555605
              ],
              [
                50.2561264,
                30.7535821
              ],
              [
                50.2580224,
                30.7519123
              ],
              [
                50.2599656,
                30.7500083
              ],
              [
                50.261055,
                30.7489903
              ],
              [
                50.2626725,
                30.7479867
              ],
              [
                50.2697295,
                30.7437902
              ],
              [
                50.2811319,
                30.7372218
              ],
              [
                50.2920409,
                30.7308336
              ],
              [
                50.3003693,
                30.7259553
              ],
              [
                50.313568,
                30.718338
              ],
              [
                50.3155516,
                30.717198
              ],
              [
                50.3177489,
                30.7160139
              ],
              [
                50.3209572,
                30.7145148
              ],
              [
                50.323204,
                30.7135137
              ],
              [
                50.3262597,
                30.7118761
              ],
              [
                50.3289299,
                30.7107868
              ],
              [
                50.3317604,
                30.7098855
              ],
              [
                50.3332291,
                30.7094355
              ],
              [
                50.3341065,
                30.7091667
              ],
              [
                50.3354417,
                30.7087156
              ],
              [
                50.3368263,
                30.7084971
              ],
              [
                50.3378372,
                30.7084594
              ],
              [
                50.3388443,
                30.7087488
              ],
              [
                50.3396377,
                30.7091724
              ],
              [
                50.3404275,
                30.7097336
              ],
              [
                50.3411103,
                30.7102514
              ],
              [
                50.3418999,
                30.7110923
              ],
              [
                50.3427888,
                30.7122586
              ],
              [
                50.3441505,
                30.7140318
              ],
              [
                50.3455657,
                30.7159925
              ],
              [
                50.3469313,
                30.7176732
              ],
              [
                50.3477487,
                30.7185075
              ],
              [
                50.3483505,
                30.7191218
              ],
              [
                50.3498231,
                30.7204804
              ],
              [
                50.3513525,
                30.7216521
              ],
              [
                50.3528862,
                30.7227335
              ],
              [
                50.3543625,
                30.7240425
              ],
              [
                50.3561593,
                30.7251252
              ],
              [
                50.3584366,
                30.7262125
              ],
              [
                50.3604507,
                30.7270187
              ],
              [
                50.363262,
                30.7280635
              ],
              [
                50.3654364,
                30.7287328
              ],
              [
                50.368042,
                30.7292666
              ],
              [
                50.3703805,
                30.7297066
              ],
              [
                50.3730353,
                30.7301932
              ],
              [
                50.3772889,
                30.7307889
              ],
              [
                50.3812791,
                30.731196
              ],
              [
                50.3845788,
                30.7313651
              ],
              [
                50.388466,
                30.731494
              ],
              [
                50.3907014,
                30.7314233
              ],
              [
                50.3927478,
                30.7313133
              ],
              [
                50.392841,
                30.7313077
              ],
              [
                50.3928947,
                30.7315221
              ],
              [
                50.3931716,
                30.7318018
              ],
              [
                50.3928946,
                30.7334715
              ],
              [
                50.3931716,
                30.7393019
              ],
              [
                50.3932603,
                30.7394435
              ],
              [
                50.3945615,
                30.7415221
              ],
              [
                50.3948213,
                30.7416686
              ],
              [
                50.3954826,
                30.7420417
              ],
              [
                50.3955148,
                30.7420598
              ],
              [
                50.4053945,
                30.7476322
              ],
              [
                50.4092813,
                30.7537424
              ],
              [
                50.4092812,
                30.7540221
              ],
              [
                50.410118,
                30.7556918
              ],
              [
                50.4103946,
                30.757912
              ],
              [
                50.410118,
                30.7581919
              ],
              [
                50.4098379,
                30.7590222
              ],
              [
                50.4035843,
                30.7671748
              ],
              [
                50.4006714,
                30.7709718
              ],
              [
                50.3996831,
                30.7722883
              ],
              [
                50.3995277,
                30.7724954
              ],
              [
                50.3987378,
                30.7735476
              ],
              [
                50.397338,
                30.7754122
              ],
              [
                50.3974118,
                30.7766748
              ],
              [
                50.3974873,
                30.7779653
              ],
              [
                50.3976146,
                30.7801416
              ],
              [
                50.3978946,
                30.7818023
              ],
              [
                50.397338,
                30.7829124
              ],
              [
                50.3970614,
                30.7840316
              ],
              [
                50.3961613,
                30.7854289
              ],
              [
                50.3954093,
                30.7865963
              ],
              [
                50.3945614,
                30.7879125
              ],
              [
                50.3892813,
                30.7904125
              ],
              [
                50.3890046,
                30.7906923
              ],
              [
                50.388448,
                30.7906924
              ],
              [
                50.3881714,
                30.7909721
              ],
              [
                50.3873382,
                30.7909721
              ],
              [
                50.3856714,
                30.7918025
              ],
              [
                50.3848024,
                30.7918025
              ],
              [
                50.3842816,
                30.7918025
              ],
              [
                50.3837249,
                30.7920822
              ],
              [
                50.3803056,
                30.7920823
              ],
              [
                50.3790049,
                30.7920823
              ],
              [
                50.3787248,
                30.7918025
              ],
              [
                50.3742817,
                30.7918025
              ],
              [
                50.3728915,
                30.7926419
              ],
              [
                50.3717816,
                30.793752
              ],
              [
                50.3720582,
                30.7973622
              ],
              [
                50.3742817,
                30.8009724
              ],
              [
                50.3751149,
                30.8026331
              ],
              [
                50.3762246,
                30.8043028
              ],
              [
                50.3784482,
                30.8123627
              ],
              [
                50.3781716,
                30.8126425
              ],
              [
                50.3781477,
                30.8127052
              ],
              [
                50.3728914,
                30.8265239
              ],
              [
                50.3726148,
                30.8273633
              ],
              [
                50.3723383,
                30.8281937
              ],
              [
                50.3720581,
                30.829024
              ],
              [
                50.3717816,
                30.832914
              ],
              [
                50.3715014,
                30.8343041
              ],
              [
                50.3709484,
                30.8354142
              ],
              [
                50.3695581,
                30.8354142
              ],
              [
                50.364835,
                30.8343041
              ],
              [
                50.3634483,
                30.834304
              ],
              [
                50.362615,
                30.8340242
              ],
              [
                50.3606685,
                30.8337535
              ],
              [
                50.3528918,
                30.8337534
              ],
              [
                50.351502,
                30.8334736
              ],
              [
                50.3490019,
                30.8334736
              ],
              [
                50.3281687,
                30.8312533
              ],
              [
                50.3173357,
                30.8312533
              ],
              [
                50.3153892,
                30.8309734
              ],
              [
                50.3098324,
                30.8309735
              ],
              [
                50.307889,
                30.8306937
              ],
              [
                50.3065007,
                30.8306937
              ],
              [
                50.2903878,
                30.8481675
              ],
              [
                50.2794474,
                30.8768589
              ],
              [
                50.2708223,
                30.9018756
              ],
              [
                50.2548724,
                30.9201131
              ],
              [
                50.2305123,
                30.9315347
              ],
              [
                50.2117645,
                30.9384444
              ],
              [
                50.1935564,
                30.9442308
              ],
              [
                50.1834383,
                30.9406954
              ],
              [
                50.1831607,
                30.9409723
              ],
              [
                50.1720507,
                30.9612541
              ],
              [
                50.171771,
                30.9623643
              ],
              [
                50.1681609,
                30.9681953
              ],
              [
                50.1678842,
                30.9693056
              ],
              [
                50.1673275,
                30.970136
              ],
              [
                50.1675727,
                30.9706956
              ],
              [
                50.1737175,
                30.971526
              ],
              [
                50.1792707,
                30.9731959
              ],
              [
                50.1798274,
                30.9734757
              ],
              [
                50.1814938,
                30.9734757
              ],
              [
                50.1839939,
                30.9737556
              ],
              [
                50.2253867,
                30.9815363
              ],
              [
                50.2270533,
                30.9815363
              ],
              [
                50.2351065,
                30.9831972
              ],
              [
                50.237053,
                30.9831972
              ],
              [
                50.2514963,
                30.9865279
              ],
              [
                50.2528861,
                30.9865279
              ],
              [
                50.2662195,
                30.9909689
              ],
              [
                50.2728861,
                30.9943086
              ],
              [
                50.2742759,
                30.9954189
              ],
              [
                50.2726092,
                31.0002029
              ],
              [
                50.2714993,
                31.0020894
              ],
              [
                50.2709427,
                31.0037503
              ],
              [
                50.2712192,
                31.0076407
              ],
              [
                50.2695528,
                31.0118109
              ],
              [
                50.2692758,
                31.0143112
              ],
              [
                50.2692758,
                31.0154214
              ],
              [
                50.2689993,
                31.015972
              ],
              [
                50.2692759,
                31.017642
              ],
              [
                50.2659426,
                31.0270927
              ],
              [
                50.2626093,
                31.0340341
              ],
              [
                50.2623327,
                31.0348645
              ],
              [
                50.2620526,
                31.035695
              ],
              [
                50.2584427,
                31.0451458
              ],
              [
                50.2570529,
                31.0484766
              ],
              [
                50.2567764,
                31.049307
              ],
              [
                50.2559427,
                31.0520873
              ],
              [
                50.2539961,
                31.0565373
              ],
              [
                50.2534431,
                31.057088
              ],
              [
                50.252886,
                31.0590287
              ],
              [
                50.2520528,
                31.0612582
              ],
              [
                50.252886,
                31.0687505
              ],
              [
                50.2523293,
                31.0704204
              ],
              [
                50.2526094,
                31.0743108
              ],
              [
                50.2548293,
                31.0790318
              ],
              [
                50.2539961,
                31.0857026
              ],
              [
                50.2537196,
                31.0868128
              ],
              [
                50.2545528,
                31.0934746
              ],
              [
                50.2548293,
                31.0937545
              ],
              [
                50.2548293,
                31.0965257
              ],
              [
                50.2631658,
                31.1193094
              ],
              [
                50.2703858,
                31.1295911
              ],
              [
                50.2703859,
                31.1299347
              ],
              [
                50.2278866,
                31.1568073
              ],
              [
                50.2278865,
                31.1570961
              ],
              [
                50.2278863,
                31.1570964
              ],
              [
                50.2274682,
                31.1575069
              ],
              [
                50.2273299,
                31.1579267
              ],
              [
                50.2267728,
                31.159037
              ],
              [
                50.2262197,
                31.1593168
              ],
              [
                50.2262197,
                31.1598675
              ],
              [
                50.1903834,
                31.2015365
              ],
              [
                50.18844,
                31.2051474
              ],
              [
                50.1881603,
                31.2054272
              ],
              [
                50.1878833,
                31.2062577
              ],
              [
                50.1876067,
                31.2073681
              ],
              [
                50.1873267,
                31.2090291
              ],
              [
                50.1873267,
                31.2115386
              ],
              [
                50.19094,
                31.2154294
              ],
              [
                50.1911236,
                31.2157949
              ],
              [
                50.1726037,
                31.231534
              ],
              [
                50.1681602,
                31.2368149
              ],
              [
                50.1514939,
                31.2509788
              ],
              [
                50.1509552,
                31.2513377
              ],
              [
                50.1504553,
                31.2511966
              ],
              [
                50.1484221,
                31.2508786
              ],
              [
                50.1454848,
                31.2506606
              ],
              [
                50.1424943,
                31.2504874
              ],
              [
                50.1399269,
                31.2504499
              ],
              [
                50.1352805,
                31.2503759
              ],
              [
                50.1329308,
                31.2504773
              ],
              [
                50.1299934,
                31.2503492
              ],
              [
                50.1269493,
                31.2504053
              ],
              [
                50.1242791,
                31.250554
              ],
              [
                50.1224632,
                31.2505597
              ],
              [
                50.120968,
                31.2503825
              ],
              [
                50.1190988,
                31.2502976
              ],
              [
                50.1174392,
                31.2499817
              ],
              [
                50.1167451,
                31.2499363
              ],
              [
                50.1137198,
                31.2529402
              ],
              [
                50.1114921,
                31.2550654
              ],
              [
                50.1092606,
                31.2566853
              ],
              [
                50.1075554,
                31.2574742
              ],
              [
                50.106594,
                31.2578916
              ],
              [
                50.1052627,
                31.2580808
              ],
              [
                50.1040305,
                31.2580857
              ],
              [
                50.1028171,
                31.2580592
              ],
              [
                50.1015739,
                31.2579107
              ],
              [
                50.0729367,
                31.254194
              ],
              [
                50.0436708,
                31.2467033
              ],
              [
                50.0117279,
                31.2381406
              ],
              [
                50.0000124,
                31.2330397
              ],
              [
                49.9968414,
                31.2327623
              ],
              [
                49.9916268,
                31.2306171
              ],
              [
                49.9902726,
                31.2291088
              ],
              [
                49.987835,
                31.2260424
              ],
              [
                49.9858934,
                31.2243489
              ],
              [
                49.984478,
                31.2216469
              ],
              [
                49.9828035,
                31.2199984
              ],
              [
                49.9812318,
                31.218213
              ],
              [
                49.9783211,
                31.2157449
              ],
              [
                49.9748268,
                31.2144247
              ],
              [
                49.9665641,
                31.2122902
              ],
              [
                49.9621696,
                31.2115691
              ],
              [
                49.9587403,
                31.2114399
              ],
              [
                49.9557419,
                31.2114495
              ],
              [
                49.95467,
                31.2114047
              ],
              [
                49.9541243,
                31.2101664
              ],
              [
                49.9534682,
                31.2080589
              ],
              [
                49.9532775,
                31.2042545
              ],
              [
                49.953125,
                31.1983843
              ],
              [
                49.9535713,
                31.1941632
              ],
              [
                49.9536081,
                31.1937247
              ],
              [
                49.953641,
                31.1933333
              ],
              [
                49.9539642,
                31.1894816
              ],
              [
                49.9544639,
                31.1850783
              ],
              [
                49.9557381,
                31.1836992
              ],
              [
                49.9588584,
                31.1793329
              ],
              [
                49.9615067,
                31.1758131
              ],
              [
                49.9631462,
                31.1736339
              ],
              [
                49.9678573,
                31.167796
              ],
              [
                49.9710768,
                31.1626497
              ],
              [
                49.9735565,
                31.1586049
              ],
              [
                49.9747691,
                31.1561136
              ],
              [
                49.9756583,
                31.1542864
              ],
              [
                49.9778062,
                31.1493277
              ],
              [
                49.9806406,
                31.1431721
              ],
              [
                49.9856912,
                31.1341693
              ],
              [
                49.9878502,
                31.1307217
              ],
              [
                49.9891626,
                31.1278742
              ],
              [
                49.9899942,
                31.1256725
              ],
              [
                49.9900285,
                31.1232389
              ],
              [
                49.9904163,
                31.12067
              ],
              [
                49.9885354,
                31.1150946
              ],
              [
                49.986223,
                31.1116406
              ],
              [
                49.9837072,
                31.1093051
              ],
              [
                49.9809242,
                31.1067213
              ],
              [
                49.9793461,
                31.1060267
              ],
              [
                49.9779726,
                31.1047369
              ],
              [
                49.9779216,
                31.1045065
              ],
              [
                49.9777836,
                31.1038828
              ],
              [
                49.9780954,
                31.102521
              ],
              [
                49.9791954,
                31.1015918
              ],
              [
                49.9806907,
                31.100751
              ],
              [
                49.9822591,
                31.0992429
              ],
              [
                49.9807439,
                31.0976705
              ],
              [
                49.9785858,
                31.0968264
              ],
              [
                49.9775375,
                31.0960223
              ],
              [
                49.9770115,
                31.0957907
              ],
              [
                49.9760461,
                31.09458
              ],
              [
                49.975841,
                31.0936531
              ],
              [
                49.9754568,
                31.0929363
              ],
              [
                49.9751083,
                31.0917968
              ],
              [
                49.9741615,
                31.0905386
              ],
              [
                49.9728776,
                31.0892809
              ],
              [
                49.9711793,
                31.0875851
              ],
              [
                49.9701108,
                31.0864136
              ],
              [
                49.9682825,
                31.0844663
              ],
              [
                49.9671386,
                31.0831285
              ],
              [
                49.9655383,
                31.0817159
              ],
              [
                49.9634448,
                31.0798801
              ],
              [
                49.9613452,
                31.0786126
              ],
              [
                49.9597714,
                31.0775768
              ],
              [
                49.956872,
                31.0769849
              ],
              [
                49.9539702,
                31.0766204
              ],
              [
                49.9528854,
                31.0764245
              ],
              [
                49.9506746,
                31.0760252
              ],
              [
                49.949486,
                31.0760155
              ],
              [
                49.9486948,
                31.0758953
              ],
              [
                49.948037,
                31.0756626
              ],
              [
                49.9475175,
                31.0748626
              ],
              [
                49.9495135,
                31.0735146
              ],
              [
                49.9512541,
                31.0713688
              ],
              [
                49.9523193,
                31.0705816
              ],
              [
                49.9531217,
                31.0696786
              ],
              [
                49.9548584,
                31.0678738
              ],
              [
                49.9557977,
                31.0665171
              ],
              [
                49.9571307,
                31.0653911
              ],
              [
                49.9594041,
                31.0627947
              ],
              [
                49.9605733,
                31.0605056
              ],
              [
                49.9606185,
                31.060417
              ],
              [
                49.9623524,
                31.0588394
              ],
              [
                49.9631682,
                31.0566859
              ],
              [
                49.9647859,
                31.0536294
              ],
              [
                49.9659878,
                31.0523885
              ],
              [
                49.9666664,
                31.0506886
              ],
              [
                49.9666738,
                31.0500066
              ],
              [
                49.9658939,
                31.0488634
              ],
              [
                49.9649783,
                31.0480603
              ],
              [
                49.9630448,
                31.0467516
              ],
              [
                49.961962,
                31.046146
              ],
              [
                49.9610819,
                31.0451158
              ],
              [
                49.9598992,
                31.0445947
              ],
              [
                49.9587258,
                31.043221
              ],
              [
                49.9582391,
                31.0424496
              ],
              [
                49.9576118,
                31.0401995
              ],
              [
                49.9587183,
                31.0369295
              ],
              [
                49.9591027,
                31.0356305
              ],
              [
                49.9596116,
                31.0346164
              ],
              [
                49.9616205,
                31.0319893
              ],
              [
                49.9631278,
                31.0299551
              ],
              [
                49.9640355,
                31.0284276
              ],
              [
                49.9678881,
                31.0231294
              ],
              [
                49.9705635,
                31.0198539
              ],
              [
                49.9708385,
                31.0188329
              ],
              [
                49.971397,
                31.0159952
              ],
              [
                49.97143,
                31.0129259
              ],
              [
                49.9700286,
                31.0094322
              ],
              [
                49.9643708,
                31.0030458
              ],
              [
                49.9615079,
                31.0000702
              ],
              [
                49.9533472,
                30.9974599
              ],
              [
                49.9465117,
                30.9964795
              ],
              [
                49.9394119,
                30.9951493
              ],
              [
                49.9347242,
                30.9941859
              ],
              [
                49.9281769,
                30.9914723
              ],
              [
                49.9226724,
                30.9870957
              ],
              [
                49.9195481,
                30.9845275
              ],
              [
                49.9171257,
                30.9828787
              ],
              [
                49.914173,
                30.9812795
              ],
              [
                49.9061737,
                30.9765699
              ],
              [
                49.8990898,
                30.9725466
              ],
              [
                49.8951303,
                30.9708595
              ],
              [
                49.894774,
                30.9707405
              ],
              [
                49.8918649,
                30.9697691
              ],
              [
                49.8896179,
                30.9688115
              ],
              [
                49.8886491,
                30.9681242
              ],
              [
                49.8877372,
                30.96739
              ],
              [
                49.8872591,
                30.9667821
              ],
              [
                49.8869782,
                30.9664249
              ],
              [
                49.8864899,
                30.9653673
              ],
              [
                49.8863183,
                30.9644455
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554954,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بویراحمد",
          "name:en": "Buyerahmad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278733",
          "wikipedia": "en:Boyer-Ahmad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.5956779,
                31.1051468
              ],
              [
                50.595958,
                31.1040274
              ],
              [
                50.5962345,
                31.1037567
              ],
              [
                50.598178,
                31.1006966
              ],
              [
                50.6045679,
                31.0957047
              ],
              [
                50.6084578,
                31.0940348
              ],
              [
                50.6104008,
                31.0940348
              ],
              [
                50.6115146,
                31.0937549
              ],
              [
                50.615681,
                31.093755
              ],
              [
                50.6159576,
                31.0940348
              ],
              [
                50.6184576,
                31.0940348
              ],
              [
                50.6190143,
                31.0943146
              ],
              [
                50.6251242,
                31.0943147
              ],
              [
                50.6262374,
                31.0945944
              ],
              [
                50.6292906,
                31.0948653
              ],
              [
                50.6540138,
                31.0895936
              ],
              [
                50.6565169,
                31.0884743
              ],
              [
                50.6823503,
                31.0757015
              ],
              [
                50.6848499,
                31.0715312
              ],
              [
                50.68346,
                31.0670901
              ],
              [
                50.6723501,
                31.0581988
              ],
              [
                50.6706837,
                31.0573684
              ],
              [
                50.6704035,
                31.0568087
              ],
              [
                50.6695704,
                31.0565379
              ],
              [
                50.6662371,
                31.050138
              ],
              [
                50.6665171,
                31.0490278
              ],
              [
                50.6667938,
                31.048757
              ],
              [
                50.666237,
                31.0429167
              ],
              [
                50.6664478,
                31.0425376
              ],
              [
                50.6731838,
                31.030424
              ],
              [
                50.6751267,
                31.0284743
              ],
              [
                50.6762405,
                31.0284743
              ],
              [
                50.6798502,
                31.0251435
              ],
              [
                50.6798504,
                31.0248637
              ],
              [
                50.6804069,
                31.0243131
              ],
              [
                50.6851265,
                31.0201428
              ],
              [
                50.6859602,
                31.0201428
              ],
              [
                50.6879067,
                31.0173627
              ],
              [
                50.6881833,
                31.0170829
              ],
              [
                50.6920732,
                31.0145916
              ],
              [
                50.6929068,
                31.0145916
              ],
              [
                50.6931834,
                31.0143118
              ],
              [
                50.6940166,
                31.0143118
              ],
              [
                50.6979065,
                31.0129217
              ],
              [
                50.7162397,
                31.00209
              ],
              [
                50.719573,
                30.9993098
              ],
              [
                50.7231863,
                30.9959701
              ],
              [
                50.7856889,
                30.9576444
              ],
              [
                50.7867987,
                30.9565252
              ],
              [
                50.7929122,
                30.9520843
              ],
              [
                50.7936298,
                30.95161
              ],
              [
                50.7937454,
                30.9515337
              ],
              [
                50.8590246,
                30.8884776
              ],
              [
                50.8593011,
                30.8881978
              ],
              [
                50.8981941,
                30.8584757
              ],
              [
                50.9021126,
                30.8594468
              ],
              [
                50.9053266,
                30.8601379
              ],
              [
                50.9067847,
                30.8607577
              ],
              [
                50.9077671,
                30.8613841
              ],
              [
                50.9100809,
                30.8616015
              ],
              [
                50.9123094,
                30.8642539
              ],
              [
                50.9163839,
                30.8644049
              ],
              [
                50.9195911,
                30.8659519
              ],
              [
                50.9244811,
                30.8688137
              ],
              [
                50.9253503,
                30.8717821
              ],
              [
                50.9293715,
                30.8742865
              ],
              [
                50.9359126,
                30.8742442
              ],
              [
                50.9393104,
                30.874613
              ],
              [
                50.9453759,
                30.8752444
              ],
              [
                50.9520149,
                30.8755794
              ],
              [
                50.9574437,
                30.8786917
              ],
              [
                50.9580666,
                30.8791306
              ],
              [
                50.9610005,
                30.8800643
              ],
              [
                50.9630125,
                30.8807826
              ],
              [
                50.9654995,
                30.8816701
              ],
              [
                50.9674462,
                30.8830881
              ],
              [
                50.9684322,
                30.8821822
              ],
              [
                50.9714244,
                30.8804863
              ],
              [
                50.9727898,
                30.8796197
              ],
              [
                50.9749343,
                30.8795443
              ],
              [
                50.9798376,
                30.879311
              ],
              [
                50.9828992,
                30.8778431
              ],
              [
                50.9869499,
                30.8787623
              ],
              [
                50.9885681,
                30.8790785
              ],
              [
                50.9907678,
                30.8788344
              ],
              [
                50.9961283,
                30.8809942
              ],
              [
                50.9981918,
                30.8809569
              ],
              [
                51.002729,
                30.879548
              ],
              [
                51.0069036,
                30.8792074
              ],
              [
                51.0107989,
                30.8783589
              ],
              [
                51.0151863,
                30.8727247
              ],
              [
                51.0253786,
                30.8645656
              ],
              [
                51.0440683,
                30.842405
              ],
              [
                51.0624789,
                30.8279602
              ],
              [
                51.0713195,
                30.8196314
              ],
              [
                51.0790443,
                30.8094588
              ],
              [
                51.0820483,
                30.8028977
              ],
              [
                51.0825077,
                30.7885708
              ],
              [
                51.0835368,
                30.7793673
              ],
              [
                51.0849989,
                30.7662892
              ],
              [
                51.0772227,
                30.753003
              ],
              [
                51.0734272,
                30.7464164
              ],
              [
                51.0693311,
                30.7395796
              ],
              [
                51.0754251,
                30.7309724
              ],
              [
                51.0757017,
                30.7306926
              ],
              [
                51.0843116,
                30.724023
              ],
              [
                51.098758,
                30.7168029
              ],
              [
                51.1276476,
                30.7004133
              ],
              [
                51.1409807,
                30.6870833
              ],
              [
                51.1420942,
                30.6865237
              ],
              [
                51.1423707,
                30.6859733
              ],
              [
                51.1515374,
                30.682634
              ],
              [
                51.1554273,
                30.6818038
              ],
              [
                51.16268,
                30.6819284
              ],
              [
                51.1686238,
                30.6809872
              ],
              [
                51.1847814,
                30.6760414
              ],
              [
                51.1934294,
                30.6736349
              ],
              [
                51.1992574,
                30.6737515
              ],
              [
                51.2039222,
                30.6679505
              ],
              [
                51.2105311,
                30.6604384
              ],
              [
                51.2163891,
                30.6524642
              ],
              [
                51.2189854,
                30.6487353
              ],
              [
                51.225153,
                30.6448559
              ],
              [
                51.2279297,
                30.6423561
              ],
              [
                51.2359863,
                30.6329162
              ],
              [
                51.2376529,
                30.6306871
              ],
              [
                51.2518194,
                30.6165183
              ],
              [
                51.296822,
                30.5940291
              ],
              [
                51.3015453,
                30.59069
              ],
              [
                51.3298783,
                30.5734713
              ],
              [
                51.3307115,
                30.5731916
              ],
              [
                51.3421166,
                30.5693355
              ],
              [
                51.358403,
                30.5657512
              ],
              [
                51.3622505,
                30.563534
              ],
              [
                51.3662994,
                30.5605039
              ],
              [
                51.3720501,
                30.5547574
              ],
              [
                51.3717867,
                30.5519217
              ],
              [
                51.3718511,
                30.5468954
              ],
              [
                51.368375,
                30.5344393
              ],
              [
                51.3646413,
                30.5283031
              ],
              [
                51.3590409,
                30.5212238
              ],
              [
                51.353891,
                30.5121474
              ],
              [
                51.3547923,
                30.5062317
              ],
              [
                51.3581397,
                30.5031627
              ],
              [
                51.3626243,
                30.4988179
              ],
              [
                51.3680746,
                30.4927904
              ],
              [
                51.373954,
                30.4851538
              ],
              [
                51.3781109,
                30.4807086
              ],
              [
                51.3828524,
                30.4751034
              ],
              [
                51.3917743,
                30.4683986
              ],
              [
                51.3952792,
                30.4670921
              ],
              [
                51.4022925,
                30.4672563
              ],
              [
                51.4117075,
                30.4680539
              ],
              [
                51.4164595,
                30.4672032
              ],
              [
                51.4211654,
                30.4667634
              ],
              [
                51.4275818,
                30.4654865
              ],
              [
                51.431802,
                30.463489
              ],
              [
                51.440253,
                30.462215
              ],
              [
                51.4463387,
                30.4626566
              ],
              [
                51.4501538,
                30.4654471
              ],
              [
                51.4593549,
                30.4649426
              ],
              [
                51.464866,
                30.4629125
              ],
              [
                51.467663,
                30.4598274
              ],
              [
                51.4682197,
                30.4559684
              ],
              [
                51.4832195,
                30.4512399
              ],
              [
                51.4840528,
                30.45124
              ],
              [
                51.5007194,
                30.4431818
              ],
              [
                51.502666,
                30.4420719
              ],
              [
                51.5212756,
                30.4356831
              ],
              [
                51.522109,
                30.4356831
              ],
              [
                51.5229424,
                30.4356831
              ],
              [
                51.523499,
                30.4354033
              ],
              [
                51.526279,
                30.4354034
              ],
              [
                51.5271124,
                30.4356831
              ],
              [
                51.5279457,
                30.4356832
              ],
              [
                51.528499,
                30.4354034
              ],
              [
                51.5290555,
                30.4356831
              ],
              [
                51.5326654,
                30.4351327
              ],
              [
                51.5329455,
                30.4348529
              ],
              [
                51.5348889,
                30.4348529
              ],
              [
                51.5487786,
                30.4317939
              ],
              [
                51.5607218,
                30.4265151
              ],
              [
                51.5746115,
                30.4223552
              ],
              [
                51.5762782,
                30.4223552
              ],
              [
                51.5790582,
                30.4223552
              ],
              [
                51.5837814,
                30.4234651
              ],
              [
                51.6040578,
                30.4412418
              ],
              [
                51.6112812,
                30.4437413
              ],
              [
                51.6193375,
                30.4437414
              ],
              [
                51.6251709,
                30.4412418
              ],
              [
                51.6260042,
                30.440962
              ],
              [
                51.6273942,
                30.4404026
              ],
              [
                51.6273941,
                30.4401318
              ],
              [
                51.6282275,
                30.4376323
              ],
              [
                51.6321141,
                30.4290147
              ],
              [
                51.6332274,
                30.4279139
              ],
              [
                51.6337808,
                30.4267948
              ],
              [
                51.6396174,
                30.4217957
              ],
              [
                51.6454505,
                30.4192963
              ],
              [
                51.6465605,
                30.4187458
              ],
              [
                51.6487838,
                30.4184662
              ],
              [
                51.6521173,
                30.418466
              ],
              [
                51.6576738,
                30.4165261
              ],
              [
                51.6579503,
                30.4162463
              ],
              [
                51.6590604,
                30.4159666
              ],
              [
                51.7508455,
                30.3608145
              ],
              [
                51.7618273,
                30.362878
              ],
              [
                51.7669772,
                30.3649515
              ],
              [
                51.7721037,
                30.3664878
              ],
              [
                51.7829418,
                30.3715793
              ],
              [
                51.7854308,
                30.3746525
              ],
              [
                51.7843151,
                30.3769109
              ],
              [
                51.7752812,
                30.3793719
              ],
              [
                51.7724275,
                30.3828716
              ],
              [
                51.772579,
                30.385835
              ],
              [
                51.7726422,
                30.387072
              ],
              [
                51.7737579,
                30.3904977
              ],
              [
                51.7757918,
                30.3949112
              ],
              [
                51.7815653,
                30.3990205
              ],
              [
                51.7968452,
                30.4109586
              ],
              [
                51.8249013,
                30.4354036
              ],
              [
                51.8257346,
                30.435963
              ],
              [
                51.8262914,
                30.4365226
              ],
              [
                51.8262914,
                30.4368023
              ],
              [
                51.8312912,
                30.4445717
              ],
              [
                51.8315678,
                30.4456817
              ],
              [
                51.8374012,
                30.4537399
              ],
              [
                51.8418477,
                30.4626283
              ],
              [
                51.8429576,
                30.4656874
              ],
              [
                51.8432344,
                30.4695767
              ],
              [
                51.8415677,
                30.4740164
              ],
              [
                51.8410145,
                30.4745759
              ],
              [
                51.8410144,
                30.4751354
              ],
              [
                51.8399009,
                30.4762453
              ],
              [
                51.8396244,
                30.4770755
              ],
              [
                51.8390677,
                30.4773553
              ],
              [
                51.8335145,
                30.4901332
              ],
              [
                51.8335145,
                30.4912432
              ],
              [
                51.8326812,
                30.4937428
              ],
              [
                51.8324011,
                30.4948527
              ],
              [
                51.8321243,
                30.4968019
              ],
              [
                51.8318478,
                30.4984623
              ],
              [
                51.8315677,
                30.5012417
              ],
              [
                51.8312912,
                30.5054108
              ],
              [
                51.8318478,
                30.5120796
              ],
              [
                51.8329578,
                30.5173588
              ],
              [
                51.8335144,
                30.5184598
              ],
              [
                51.8335144,
                30.519299
              ],
              [
                51.8340678,
                30.5201382
              ],
              [
                51.8343478,
                30.5206887
              ],
              [
                51.8343478,
                30.5209685
              ],
              [
                51.8343479,
                30.5212481
              ],
              [
                51.8440675,
                30.5354161
              ],
              [
                51.8454576,
                30.5379069
              ],
              [
                51.8482375,
                30.5412459
              ],
              [
                51.8557375,
                30.5540243
              ],
              [
                51.8779605,
                30.5754121
              ],
              [
                51.8846271,
                30.5843012
              ],
              [
                51.8876835,
                30.590131
              ],
              [
                51.8879603,
                30.5906905
              ],
              [
                51.8879604,
                30.5920803
              ],
              [
                51.8879603,
                30.59236
              ],
              [
                51.8879603,
                30.5931903
              ],
              [
                51.8882369,
                30.5934701
              ],
              [
                51.8882369,
                30.5981899
              ],
              [
                51.8874036,
                30.5998595
              ],
              [
                51.8871269,
                30.6009695
              ],
              [
                51.8804604,
                30.6087487
              ],
              [
                51.8704605,
                30.6148583
              ],
              [
                51.8699039,
                30.6156887
              ],
              [
                51.8693472,
                30.6159684
              ],
              [
                51.8643472,
                30.6265182
              ],
              [
                51.8629573,
                30.6315269
              ],
              [
                51.854904,
                30.6431869
              ],
              [
                51.8535141,
                30.6442969
              ],
              [
                51.8521241,
                30.6459665
              ],
              [
                51.8489216,
                30.6532311
              ],
              [
                51.8466815,
                30.6589459
              ],
              [
                51.8426388,
                30.6642396
              ],
              [
                51.8422507,
                30.6715815
              ],
              [
                51.8343133,
                30.6773803
              ],
              [
                51.8262022,
                30.6809457
              ],
              [
                51.8168878,
                30.6853959
              ],
              [
                51.8065451,
                30.6901832
              ],
              [
                51.7978906,
                30.6933624
              ],
              [
                51.8112459,
                30.7142277
              ],
              [
                51.8067598,
                30.7129585
              ],
              [
                51.801856,
                30.7131455
              ],
              [
                51.7842493,
                30.7099724
              ],
              [
                51.7732458,
                30.71134
              ],
              [
                51.7669973,
                30.7123239
              ],
              [
                51.763278,
                30.7151329
              ],
              [
                51.7593298,
                30.7155904
              ],
              [
                51.7566747,
                30.7171252
              ],
              [
                51.7505865,
                30.7170072
              ],
              [
                51.7448415,
                30.7202932
              ],
              [
                51.7424117,
                30.7194308
              ],
              [
                51.7395278,
                30.7187421
              ],
              [
                51.7335768,
                30.7213394
              ],
              [
                51.7300749,
                30.7237596
              ],
              [
                51.7252913,
                30.7282652
              ],
              [
                51.7210799,
                30.7289341
              ],
              [
                51.7171202,
                30.7310786
              ],
              [
                51.7157927,
                30.7321016
              ],
              [
                51.7149916,
                30.7343248
              ],
              [
                51.7108489,
                30.7366265
              ],
              [
                51.7067519,
                30.7372954
              ],
              [
                51.7035018,
                30.7367643
              ],
              [
                51.7011672,
                30.73702
              ],
              [
                51.6978713,
                30.739066
              ],
              [
                51.6970473,
                30.7408955
              ],
              [
                51.6978026,
                30.7424889
              ],
              [
                51.6971388,
                30.7447315
              ],
              [
                51.6955367,
                30.747092
              ],
              [
                51.6959487,
                30.7495508
              ],
              [
                51.6948958,
                30.7527767
              ],
              [
                51.6942286,
                30.7558446
              ],
              [
                51.6934046,
                30.7618041
              ],
              [
                51.6808619,
                30.7655802
              ],
              [
                51.6804728,
                30.7700249
              ],
              [
                51.6829218,
                30.7713819
              ],
              [
                51.6827616,
                30.7743907
              ],
              [
                51.6810679,
                30.7753543
              ],
              [
                51.6747965,
                30.774725
              ],
              [
                51.6734461,
                30.7738401
              ],
              [
                51.6692118,
                30.7739581
              ],
              [
                51.6641535,
                30.7725815
              ],
              [
                51.6616587,
                30.7748823
              ],
              [
                51.6557536,
                30.7799558
              ],
              [
                51.6512904,
                30.7855599
              ],
              [
                51.6492075,
                30.7885486
              ],
              [
                51.6439432,
                30.7889419
              ],
              [
                51.6408762,
                30.7902986
              ],
              [
                51.6371455,
                30.791498
              ],
              [
                51.6354746,
                30.7943882
              ],
              [
                51.6341471,
                30.794919
              ],
              [
                51.6331171,
                30.797239
              ],
              [
                51.6303248,
                30.8024293
              ],
              [
                51.6251063,
                30.8028225
              ],
              [
                51.6181025,
                30.803196
              ],
              [
                51.6162485,
                30.80585
              ],
              [
                51.6143259,
                30.8077569
              ],
              [
                51.6093592,
                30.8105483
              ],
              [
                51.6056742,
                30.812003
              ],
              [
                51.6073679,
                30.8140277
              ],
              [
                51.6113734,
                30.8187256
              ],
              [
                51.6130213,
                30.8227354
              ],
              [
                51.6121287,
                30.8272364
              ],
              [
                51.6109238,
                30.8282711
              ],
              [
                51.6080366,
                30.8257255
              ],
              [
                51.6045347,
                30.8245315
              ],
              [
                51.5956255,
                30.8224529
              ],
              [
                51.5927416,
                30.8216126
              ],
              [
                51.5888535,
                30.8205955
              ],
              [
                51.5876432,
                30.8202638
              ],
              [
                51.5849396,
                30.8201311
              ],
              [
                51.577807,
                30.8199763
              ],
              [
                51.5738674,
                30.8197552
              ],
              [
                51.5697733,
                30.8194456
              ],
              [
                51.5628983,
                30.8185611
              ],
              [
                51.5591131,
                30.816991
              ],
              [
                51.5506674,
                30.8140499
              ],
              [
                51.5448223,
                30.8128336
              ],
              [
                51.5389795,
                30.8110666
              ],
              [
                51.5307141,
                30.8088993
              ],
              [
                51.5272637,
                30.8079483
              ],
              [
                51.5185604,
                30.8052944
              ],
              [
                51.515728,
                30.8043876
              ],
              [
                51.5123806,
                30.8027289
              ],
              [
                51.5064583,
                30.800119
              ],
              [
                51.5025187,
                30.7941913
              ],
              [
                51.4970083,
                30.7942798
              ],
              [
                51.4861679,
                30.7958724
              ],
              [
                51.4834957,
                30.7962533
              ],
              [
                51.4541655,
                30.7812037
              ],
              [
                51.4515529,
                30.779863
              ],
              [
                51.4498863,
                30.7809732
              ],
              [
                51.4418297,
                30.7865238
              ],
              [
                51.434883,
                30.7906936
              ],
              [
                51.4337731,
                30.7906936
              ],
              [
                51.4329399,
                30.7909734
              ],
              [
                51.4296066,
                30.7909733
              ],
              [
                51.42544,
                30.7879138
              ],
              [
                51.4248833,
                30.7876429
              ],
              [
                51.4221067,
                30.7868036
              ],
              [
                51.4218266,
                30.7868035
              ],
              [
                51.42155,
                30.7865238
              ],
              [
                51.4207166,
                30.7865237
              ],
              [
                51.4182168,
                30.7876429
              ],
              [
                51.4176601,
                30.7876429
              ],
              [
                51.4159935,
                30.7893036
              ],
              [
                51.4107168,
                30.7923632
              ],
              [
                51.4104403,
                30.792643
              ],
              [
                51.4096036,
                30.7926431
              ],
              [
                51.4051603,
                30.7945835
              ],
              [
                51.3946036,
                30.8054231
              ],
              [
                51.3901604,
                30.8073637
              ],
              [
                51.3898805,
                30.8076345
              ],
              [
                51.3879371,
                30.8087536
              ],
              [
                51.3873804,
                30.809584
              ],
              [
                51.3868271,
                30.8098638
              ],
              [
                51.3840472,
                30.8156943
              ],
              [
                51.373214,
                30.8209743
              ],
              [
                51.3704373,
                30.8209743
              ],
              [
                51.3554376,
                30.8262453
              ],
              [
                51.3518242,
                30.8301353
              ],
              [
                51.3515477,
                30.8312545
              ],
              [
                51.3515477,
                30.831805
              ],
              [
                51.3504342,
                30.8351446
              ],
              [
                51.3443243,
                30.8412549
              ],
              [
                51.3404459,
                30.8473917
              ],
              [
                51.3375234,
                30.8550425
              ],
              [
                51.3335752,
                30.8618211
              ],
              [
                51.3305594,
                30.8701473
              ],
              [
                51.326728,
                30.8742184
              ],
              [
                51.3231301,
                30.8784574
              ],
              [
                51.3181123,
                30.8819079
              ],
              [
                51.3153571,
                30.8840154
              ],
              [
                51.3085599,
                30.8919969
              ],
              [
                51.3102845,
                30.9006558
              ],
              [
                51.3037267,
                30.8997092
              ],
              [
                51.2982981,
                30.9010752
              ],
              [
                51.2861136,
                30.9066041
              ],
              [
                51.2739873,
                30.9099389
              ],
              [
                51.2678366,
                30.913001
              ],
              [
                51.264857,
                30.9144677
              ],
              [
                51.256628,
                30.9196774
              ],
              [
                51.246848,
                30.925666
              ],
              [
                51.2378311,
                30.9311267
              ],
              [
                51.2293774,
                30.9373013
              ],
              [
                51.2252884,
                30.9379108
              ],
              [
                51.1976094,
                30.9441347
              ],
              [
                51.1731147,
                30.9114301
              ],
              [
                51.1742734,
                30.9091473
              ],
              [
                51.176337,
                30.9078351
              ],
              [
                51.1770922,
                30.903347
              ],
              [
                51.1742213,
                30.9005965
              ],
              [
                51.169846,
                30.897341
              ],
              [
                51.1629447,
                30.8964703
              ],
              [
                51.1463802,
                30.8970976
              ],
              [
                51.1293806,
                30.9114934
              ],
              [
                51.1206721,
                30.9152593
              ],
              [
                51.1127569,
                30.9154698
              ],
              [
                51.1058234,
                30.913713
              ],
              [
                51.0923238,
                30.9119686
              ],
              [
                51.0738086,
                30.9112829
              ],
              [
                51.0529339,
                30.9122858
              ],
              [
                51.0443284,
                30.921549
              ],
              [
                51.0344515,
                30.9334317
              ],
              [
                51.0466606,
                30.9399692
              ],
              [
                51.0500633,
                30.9570626
              ],
              [
                51.0490035,
                30.9653927
              ],
              [
                51.0429095,
                30.9760638
              ],
              [
                51.0361289,
                30.9851885
              ],
              [
                50.9641101,
                30.997346
              ],
              [
                50.9518429,
                31.0073345
              ],
              [
                50.9524194,
                31.0203602
              ],
              [
                50.9389327,
                31.0263402
              ],
              [
                50.9226089,
                31.0365965
              ],
              [
                50.9101912,
                31.0512027
              ],
              [
                50.901728,
                31.0607563
              ],
              [
                50.8951766,
                31.0761982
              ],
              [
                50.8908928,
                31.0790328
              ],
              [
                50.8887334,
                31.0797139
              ],
              [
                50.8812473,
                31.0795833
              ],
              [
                50.8801374,
                31.080143
              ],
              [
                50.8790238,
                31.080143
              ],
              [
                50.8781906,
                31.0804228
              ],
              [
                50.8762473,
                31.0804228
              ],
              [
                50.8756906,
                31.0807026
              ],
              [
                50.8748574,
                31.0807027
              ],
              [
                50.8534677,
                31.0898647
              ],
              [
                50.8529144,
                31.0904244
              ],
              [
                50.8506911,
                31.0912549
              ],
              [
                50.8504143,
                31.0915346
              ],
              [
                50.8490244,
                31.0920943
              ],
              [
                50.8248546,
                31.106808
              ],
              [
                50.820688,
                31.1081981
              ],
              [
                50.8198547,
                31.1081981
              ],
              [
                50.8098549,
                31.1143092
              ],
              [
                50.8090215,
                31.114869
              ],
              [
                50.7848552,
                31.1312527
              ],
              [
                50.7809653,
                31.1362627
              ],
              [
                50.7806885,
                31.1365334
              ],
              [
                50.7798553,
                31.1368133
              ],
              [
                50.7773553,
                31.1370841
              ],
              [
                50.7762419,
                31.1370841
              ],
              [
                50.7759654,
                31.1373729
              ],
              [
                50.7756886,
                31.137373
              ],
              [
                50.775132,
                31.137373
              ],
              [
                50.7737419,
                31.1376437
              ],
              [
                50.7726322,
                31.1381944
              ],
              [
                50.7704086,
                31.138763
              ],
              [
                50.7673521,
                31.1395936
              ],
              [
                50.7670754,
                31.1395936
              ],
              [
                50.7665187,
                31.1395936
              ],
              [
                50.7659654,
                31.1398734
              ],
              [
                50.7656855,
                31.1398734
              ],
              [
                50.7640188,
                31.140424
              ],
              [
                50.7637422,
                31.140424
              ],
              [
                50.7626322,
                31.1407038
              ],
              [
                50.7623521,
                31.1409837
              ],
              [
                50.7601323,
                31.1415344
              ],
              [
                50.7595756,
                31.1418141
              ],
              [
                50.7587422,
                31.142094
              ],
              [
                50.7581856,
                31.1423648
              ],
              [
                50.757909,
                31.1423648
              ],
              [
                50.7576322,
                31.1423648
              ],
              [
                50.756519,
                31.1429244
              ],
              [
                50.7562422,
                31.1429245
              ],
              [
                50.7548523,
                31.1434841
              ],
              [
                50.7545755,
                31.1434842
              ],
              [
                50.7540188,
                31.143755
              ],
              [
                50.7534658,
                31.1440348
              ],
              [
                50.7529089,
                31.1443146
              ],
              [
                50.7523522,
                31.1445945
              ],
              [
                50.7520756,
                31.1445945
              ],
              [
                50.7509657,
                31.1451451
              ],
              [
                50.750409,
                31.1454249
              ],
              [
                50.749019,
                31.1459756
              ],
              [
                50.7487424,
                31.1462555
              ],
              [
                50.747909,
                31.1465353
              ],
              [
                50.7465192,
                31.1470949
              ],
              [
                50.7456858,
                31.1476456
              ],
              [
                50.7442957,
                31.148476
              ],
              [
                50.7434624,
                31.1487559
              ],
              [
                50.7423525,
                31.1493156
              ],
              [
                50.7409624,
                31.1501461
              ],
              [
                50.7406858,
                31.1504259
              ],
              [
                50.7401292,
                31.1506967
              ],
              [
                50.7392957,
                31.1509765
              ],
              [
                50.7390192,
                31.1512564
              ],
              [
                50.7384625,
                31.1515362
              ],
              [
                50.7376291,
                31.1520868
              ],
              [
                50.7373525,
                31.1520868
              ],
              [
                50.7367959,
                31.1523667
              ],
              [
                50.7351293,
                31.153477
              ],
              [
                50.7340193,
                31.1540366
              ],
              [
                50.7334626,
                31.1543075
              ],
              [
                50.7331858,
                31.1545873
              ],
              [
                50.7329093,
                31.1548671
              ],
              [
                50.7326292,
                31.1548671
              ],
              [
                50.7315192,
                31.1556976
              ],
              [
                50.730686,
                31.1559775
              ],
              [
                50.7301293,
                31.1565282
              ],
              [
                50.7287393,
                31.1573677
              ],
              [
                50.7276293,
                31.1576475
              ],
              [
                50.7270727,
                31.1576475
              ],
              [
                50.7265192,
                31.1579273
              ],
              [
                50.7259627,
                31.1579273
              ],
              [
                50.7234626,
                31.1579273
              ],
              [
                50.722906,
                31.1576474
              ],
              [
                50.7148528,
                31.1576475
              ],
              [
                50.7142962,
                31.1573676
              ],
              [
                50.7117964,
                31.1573676
              ],
              [
                50.7104061,
                31.1576474
              ],
              [
                50.7098495,
                31.1573676
              ],
              [
                50.694573,
                31.1562573
              ],
              [
                50.6867932,
                31.1562573
              ],
              [
                50.6856834,
                31.1559774
              ],
              [
                50.6740168,
                31.1559774
              ],
              [
                50.6734601,
                31.1556976
              ],
              [
                50.6726269,
                31.1556976
              ],
              [
                50.6717933,
                31.1559774
              ],
              [
                50.6651268,
                31.1559774
              ],
              [
                50.6648502,
                31.1556975
              ],
              [
                50.661517,
                31.1556976
              ],
              [
                50.6609603,
                31.1554178
              ],
              [
                50.6601271,
                31.1554178
              ],
              [
                50.6590169,
                31.1551469
              ],
              [
                50.6584602,
                31.1551469
              ],
              [
                50.6537371,
                31.1531971
              ],
              [
                50.6429037,
                31.1465351
              ],
              [
                50.6395704,
                31.1457047
              ],
              [
                50.6334575,
                31.1457047
              ],
              [
                50.6329039,
                31.1454248
              ],
              [
                50.6323472,
                31.1454248
              ],
              [
                50.6317906,
                31.1454248
              ],
              [
                50.6309573,
                31.1454248
              ],
              [
                50.6306808,
                31.145145
              ],
              [
                50.6140141,
                31.145145
              ],
              [
                50.6131809,
                31.1448651
              ],
              [
                50.6095675,
                31.1443145
              ],
              [
                50.598458,
                31.1387629
              ],
              [
                50.5956778,
                31.1362624
              ],
              [
                50.5951247,
                31.1351431
              ],
              [
                50.5926246,
                31.130422
              ],
              [
                50.592068,
                31.1282014
              ],
              [
                50.592068,
                31.1268112
              ],
              [
                50.5917914,
                31.1248704
              ],
              [
                50.5920681,
                31.1234804
              ],
              [
                50.5923446,
                31.1218103
              ],
              [
                50.5951247,
                31.1062571
              ],
              [
                50.5951247,
                31.1059772
              ],
              [
                50.5956779,
                31.1051468
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555023,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دنا",
          "name:en": "Dena County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278049",
          "wikipedia": "en:Dana County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.86014,
                31.2907095
              ],
              [
                50.882835,
                31.2759103
              ],
              [
                50.8962246,
                31.2650528
              ],
              [
                50.9096142,
                31.2450951
              ],
              [
                50.9333035,
                31.2242525
              ],
              [
                50.950416,
                31.202368
              ],
              [
                50.9495828,
                31.202368
              ],
              [
                50.9495828,
                31.2020881
              ],
              [
                50.948196,
                31.2020881
              ],
              [
                50.9473629,
                31.1959857
              ],
              [
                50.9476394,
                31.1956969
              ],
              [
                50.9534727,
                31.1843137
              ],
              [
                50.9540294,
                31.1840338
              ],
              [
                50.9548629,
                31.1829235
              ],
              [
                50.956806,
                31.1809827
              ],
              [
                50.956806,
                31.1807028
              ],
              [
                50.9570826,
                31.1801522
              ],
              [
                50.9576395,
                31.1795925
              ],
              [
                50.9590293,
                31.1757019
              ],
              [
                50.9593061,
                31.1751422
              ],
              [
                50.9576394,
                31.1668102
              ],
              [
                50.9515296,
                31.1595886
              ],
              [
                50.9515296,
                31.1587581
              ],
              [
                50.9518062,
                31.1584782
              ],
              [
                50.9525206,
                31.1578478
              ],
              [
                50.9529162,
                31.1576478
              ],
              [
                50.9654193,
                31.1479257
              ],
              [
                50.9668059,
                31.1462556
              ],
              [
                50.9834758,
                31.1298628
              ],
              [
                50.9840291,
                31.1287525
              ],
              [
                50.9968088,
                31.1145893
              ],
              [
                50.9998656,
                31.1129194
              ],
              [
                51.0068088,
                31.1006971
              ],
              [
                51.007642,
                31.0993069
              ],
              [
                51.0437549,
                31.0695909
              ],
              [
                51.0848678,
                31.0257036
              ],
              [
                51.1018143,
                31.0079215
              ],
              [
                51.1048674,
                31.0043109
              ],
              [
                51.1090376,
                30.9984798
              ],
              [
                51.1112574,
                30.9937591
              ],
              [
                51.1504269,
                30.9698664
              ],
              [
                51.1976094,
                30.9441347
              ],
              [
                51.2252884,
                30.9379108
              ],
              [
                51.2293774,
                30.9373013
              ],
              [
                51.2378311,
                30.9311267
              ],
              [
                51.246848,
                30.925666
              ],
              [
                51.256628,
                30.9196774
              ],
              [
                51.264857,
                30.9144677
              ],
              [
                51.2678366,
                30.913001
              ],
              [
                51.2739873,
                30.9099389
              ],
              [
                51.2861136,
                30.9066041
              ],
              [
                51.2982981,
                30.9010752
              ],
              [
                51.3037267,
                30.8997092
              ],
              [
                51.3102845,
                30.9006558
              ],
              [
                51.3085599,
                30.8919969
              ],
              [
                51.3153571,
                30.8840154
              ],
              [
                51.3181123,
                30.8819079
              ],
              [
                51.3231301,
                30.8784574
              ],
              [
                51.326728,
                30.8742184
              ],
              [
                51.3305594,
                30.8701473
              ],
              [
                51.3335752,
                30.8618211
              ],
              [
                51.3375234,
                30.8550425
              ],
              [
                51.3404459,
                30.8473917
              ],
              [
                51.3443243,
                30.8412549
              ],
              [
                51.3504342,
                30.8351446
              ],
              [
                51.3515477,
                30.831805
              ],
              [
                51.3515477,
                30.8312545
              ],
              [
                51.3518242,
                30.8301353
              ],
              [
                51.3554376,
                30.8262453
              ],
              [
                51.3704373,
                30.8209743
              ],
              [
                51.373214,
                30.8209743
              ],
              [
                51.3840472,
                30.8156943
              ],
              [
                51.3868271,
                30.8098638
              ],
              [
                51.3873804,
                30.809584
              ],
              [
                51.3879371,
                30.8087536
              ],
              [
                51.3898805,
                30.8076345
              ],
              [
                51.3901604,
                30.8073637
              ],
              [
                51.3946036,
                30.8054231
              ],
              [
                51.4051603,
                30.7945835
              ],
              [
                51.4096036,
                30.7926431
              ],
              [
                51.4104403,
                30.792643
              ],
              [
                51.4107168,
                30.7923632
              ],
              [
                51.4159935,
                30.7893036
              ],
              [
                51.4176601,
                30.7876429
              ],
              [
                51.4182168,
                30.7876429
              ],
              [
                51.4207166,
                30.7865237
              ],
              [
                51.42155,
                30.7865238
              ],
              [
                51.4218266,
                30.7868035
              ],
              [
                51.4221067,
                30.7868036
              ],
              [
                51.4248833,
                30.7876429
              ],
              [
                51.42544,
                30.7879138
              ],
              [
                51.4296066,
                30.7909733
              ],
              [
                51.4329399,
                30.7909734
              ],
              [
                51.4337731,
                30.7906936
              ],
              [
                51.434883,
                30.7906936
              ],
              [
                51.4418297,
                30.7865238
              ],
              [
                51.4498863,
                30.7809732
              ],
              [
                51.4515529,
                30.779863
              ],
              [
                51.4541655,
                30.7812037
              ],
              [
                51.4834957,
                30.7962533
              ],
              [
                51.4861679,
                30.7958724
              ],
              [
                51.4970083,
                30.7942798
              ],
              [
                51.5025187,
                30.7941913
              ],
              [
                51.5064583,
                30.800119
              ],
              [
                51.5123806,
                30.8027289
              ],
              [
                51.515728,
                30.8043876
              ],
              [
                51.5185604,
                30.8052944
              ],
              [
                51.5272637,
                30.8079483
              ],
              [
                51.5307141,
                30.8088993
              ],
              [
                51.5389795,
                30.8110666
              ],
              [
                51.5448223,
                30.8128336
              ],
              [
                51.5506674,
                30.8140499
              ],
              [
                51.5591131,
                30.816991
              ],
              [
                51.5628983,
                30.8185611
              ],
              [
                51.5697733,
                30.8194456
              ],
              [
                51.5738674,
                30.8197552
              ],
              [
                51.577807,
                30.8199763
              ],
              [
                51.5849396,
                30.8201311
              ],
              [
                51.5876432,
                30.8202638
              ],
              [
                51.5888535,
                30.8205955
              ],
              [
                51.5927416,
                30.8216126
              ],
              [
                51.5956255,
                30.8224529
              ],
              [
                51.6045347,
                30.8245315
              ],
              [
                51.6080366,
                30.8257255
              ],
              [
                51.6109238,
                30.8282711
              ],
              [
                51.6101603,
                30.8289267
              ],
              [
                51.6083809,
                30.8289757
              ],
              [
                51.6046501,
                30.8278751
              ],
              [
                51.6020638,
                30.828622
              ],
              [
                51.5978294,
                30.8317666
              ],
              [
                51.5955406,
                30.8321203
              ],
              [
                51.5894753,
                30.8337319
              ],
              [
                51.5863854,
                30.8344591
              ],
              [
                51.5856758,
                30.8360903
              ],
              [
                51.5861336,
                30.8378786
              ],
              [
                51.5862251,
                30.8386058
              ],
              [
                51.5859734,
                30.8388023
              ],
              [
                51.5824486,
                30.8397063
              ],
              [
                51.5787407,
                30.840453
              ],
              [
                51.5765892,
                30.8420252
              ],
              [
                51.5756279,
                30.8478811
              ],
              [
                51.57398,
                30.8486475
              ],
              [
                51.5718056,
                30.8491387
              ],
              [
                51.5710503,
                30.849964
              ],
              [
                51.5688072,
                30.852263
              ],
              [
                51.5652522,
                30.8547784
              ],
              [
                51.5600795,
                30.858158
              ],
              [
                51.5555705,
                30.8609676
              ],
              [
                51.5521831,
                30.8630699
              ],
              [
                51.55097,
                30.8647988
              ],
              [
                51.5469188,
                30.8628931
              ],
              [
                51.5455684,
                30.8613016
              ],
              [
                51.5444011,
                30.8611052
              ],
              [
                51.5430736,
                30.8610855
              ],
              [
                51.5365962,
                30.8627162
              ],
              [
                51.5333461,
                30.8635414
              ],
              [
                51.5304164,
                30.8656829
              ],
              [
                51.5280094,
                30.8685666
              ],
              [
                51.5261974,
                30.8693602
              ],
              [
                51.523983,
                30.8705537
              ],
              [
                51.5216913,
                30.8716145
              ],
              [
                51.5163355,
                30.8710399
              ],
              [
                51.5134773,
                30.8711504
              ],
              [
                51.5079927,
                30.8728301
              ],
              [
                51.4991865,
                30.8801452
              ],
              [
                51.4954786,
                30.8864874
              ],
              [
                51.4959164,
                30.8911278
              ],
              [
                51.4955044,
                30.8959226
              ],
              [
                51.4930067,
                30.8966517
              ],
              [
                51.4914875,
                30.8972483
              ],
              [
                51.4893246,
                30.8994357
              ],
              [
                51.48281,
                30.9040313
              ],
              [
                51.4826555,
                30.9055115
              ],
              [
                51.4804668,
                30.9090685
              ],
              [
                51.4803638,
                30.9118079
              ],
              [
                51.4824753,
                30.9160715
              ],
              [
                51.4824238,
                30.9184794
              ],
              [
                51.483737,
                30.9199594
              ],
              [
                51.483325,
                30.9219917
              ],
              [
                51.4811878,
                30.9219475
              ],
              [
                51.4776859,
                30.9214394
              ],
              [
                51.4772224,
                30.9219917
              ],
              [
                51.4747248,
                30.9227648
              ],
              [
                51.4706307,
                30.9221905
              ],
              [
                51.468854,
                30.9215499
              ],
              [
                51.4669485,
                30.9199815
              ],
              [
                51.4633994,
                30.9216305
              ],
              [
                51.4617565,
                30.92329
              ],
              [
                51.4591559,
                30.9275089
              ],
              [
                51.4542693,
                30.9316465
              ],
              [
                51.451497,
                30.9359883
              ],
              [
                51.4478149,
                30.9404275
              ],
              [
                51.4457035,
                30.942901
              ],
              [
                51.4407596,
                30.9445131
              ],
              [
                51.4383134,
                30.9453082
              ],
              [
                51.437438,
                30.9451757
              ],
              [
                51.4355325,
                30.9467878
              ],
              [
                51.4361505,
                30.9519773
              ],
              [
                51.4324426,
                30.9521098
              ],
              [
                51.4274988,
                30.9581823
              ],
              [
                51.4257736,
                30.9606995
              ],
              [
                51.4250268,
                30.9617814
              ],
              [
                51.4228382,
                30.9626646
              ],
              [
                51.4164524,
                30.9619581
              ],
              [
                51.4139289,
                30.9626867
              ],
              [
                51.4111738,
                30.9631283
              ],
              [
                51.4075399,
                30.9642031
              ],
              [
                51.405171,
                30.9662785
              ],
              [
                51.4020554,
                30.9690384
              ],
              [
                51.3969979,
                30.972536
              ],
              [
                51.393496,
                30.9763112
              ],
              [
                51.3901179,
                30.9810248
              ],
              [
                51.3884375,
                30.9838258
              ],
              [
                51.3867467,
                30.9855162
              ],
              [
                51.384146,
                30.9879223
              ],
              [
                51.3849442,
                30.9924033
              ],
              [
                51.384455,
                30.9933745
              ],
              [
                51.3828586,
                30.9935069
              ],
              [
                51.3790992,
                30.9944561
              ],
              [
                51.3767817,
                30.997502
              ],
              [
                51.3755458,
                31.0067497
              ],
              [
                51.3695758,
                31.0062082
              ],
              [
                51.3665889,
                31.0065834
              ],
              [
                51.3618919,
                31.0138851
              ],
              [
                51.3560211,
                31.0190489
              ],
              [
                51.3541414,
                31.0209025
              ],
              [
                51.3525192,
                31.0235284
              ],
              [
                51.3493521,
                31.0265955
              ],
              [
                51.3488886,
                31.0286034
              ],
              [
                51.3503048,
                31.0316042
              ],
              [
                51.3532917,
                31.0330825
              ],
              [
                51.3537294,
                31.0385762
              ],
              [
                51.352648,
                31.040628
              ],
              [
                51.3505623,
                31.0443123
              ],
              [
                51.3510515,
                31.0492097
              ],
              [
                51.3490431,
                31.0512171
              ],
              [
                51.3475239,
                31.0518127
              ],
              [
                51.3478329,
                31.0551436
              ],
              [
                51.3491461,
                31.0562907
              ],
              [
                51.3487598,
                31.0592023
              ],
              [
                51.3486128,
                31.0616629
              ],
              [
                51.3482118,
                31.0633345
              ],
              [
                51.3489671,
                31.0672753
              ],
              [
                51.3482347,
                31.0710198
              ],
              [
                51.3472047,
                31.0803314
              ],
              [
                51.3470445,
                31.0846242
              ],
              [
                51.3468404,
                31.0886152
              ],
              [
                51.343865,
                31.0926332
              ],
              [
                51.3413702,
                31.0978859
              ],
              [
                51.3428808,
                31.1044317
              ],
              [
                51.3435445,
                31.1128778
              ],
              [
                51.3430657,
                31.1146466
              ],
              [
                51.3425764,
                31.1190775
              ],
              [
                51.3412375,
                31.1232216
              ],
              [
                51.3391003,
                31.1312228
              ],
              [
                51.3390746,
                31.1366448
              ],
              [
                51.3380961,
                31.1463858
              ],
              [
                51.3358301,
                31.1541206
              ],
              [
                51.3332037,
                31.1658428
              ],
              [
                51.33256,
                31.1697426
              ],
              [
                51.3336002,
                31.1755919
              ],
              [
                51.3356224,
                31.1788507
              ],
              [
                51.3326024,
                31.1814434
              ],
              [
                51.3316497,
                31.1832057
              ],
              [
                51.3276843,
                31.1871488
              ],
              [
                51.3264484,
                31.1892415
              ],
              [
                51.3216333,
                31.1941535
              ],
              [
                51.3156337,
                31.197986
              ],
              [
                51.3121318,
                31.2004748
              ],
              [
                51.3060293,
                31.2056064
              ],
              [
                51.3043041,
                31.2073023
              ],
              [
                51.3022699,
                31.2086016
              ],
              [
                51.2985105,
                31.2085135
              ],
              [
                51.2961158,
                31.2083153
              ],
              [
                51.2948026,
                31.2072362
              ],
              [
                51.2913411,
                31.2075568
              ],
              [
                51.2901849,
                31.2076639
              ],
              [
                51.2869662,
                31.2102846
              ],
              [
                51.284417,
                31.2125089
              ],
              [
                51.2814559,
                31.2139183
              ],
              [
                51.2784432,
                31.2149973
              ],
              [
                51.2759713,
                31.215724
              ],
              [
                51.2729329,
                31.2157901
              ],
              [
                51.2710789,
                31.2157681
              ],
              [
                51.2673196,
                31.215658
              ],
              [
                51.2656716,
                31.214645
              ],
              [
                51.2622727,
                31.2115399
              ],
              [
                51.260496,
                31.2097561
              ],
              [
                51.2598265,
                31.2078841
              ],
              [
                51.2579332,
                31.206257
              ],
              [
                51.2570765,
                31.2063379
              ],
              [
                51.2520999,
                31.2068077
              ],
              [
                51.2454319,
                31.2093192
              ],
              [
                51.236542,
                31.218202
              ],
              [
                51.2326911,
                31.220402
              ],
              [
                51.2268188,
                31.2237628
              ],
              [
                51.2237744,
                31.2237608
              ],
              [
                51.2237693,
                31.2237608
              ],
              [
                51.2237637,
                31.2237608
              ],
              [
                51.2237634,
                31.2237607
              ],
              [
                51.2237627,
                31.2237604
              ],
              [
                51.1873739,
                31.2095904
              ],
              [
                51.1873732,
                31.2095902
              ],
              [
                51.1873729,
                31.20959
              ],
              [
                51.1873673,
                31.20959
              ],
              [
                51.1873622,
                31.20959
              ],
              [
                51.1840395,
                31.20959
              ],
              [
                51.182926,
                31.2098698
              ],
              [
                51.1804259,
                31.2098696
              ],
              [
                51.1804258,
                31.2098692
              ],
              [
                51.1804257,
                31.209869
              ],
              [
                51.1787611,
                31.202646
              ],
              [
                51.1790408,
                31.201257
              ],
              [
                51.179041,
                31.2012559
              ],
              [
                51.1829276,
                31.195984
              ],
              [
                51.1843167,
                31.1932056
              ],
              [
                51.1843176,
                31.1932037
              ],
              [
                51.1845963,
                31.1923661
              ],
              [
                51.1848742,
                31.190983
              ],
              [
                51.1848728,
                31.1898746
              ],
              [
                51.1801494,
                31.1818134
              ],
              [
                51.179041,
                31.1748696
              ],
              [
                51.1709846,
                31.1670883
              ],
              [
                51.1707079,
                31.1665286
              ],
              [
                51.1707078,
                31.1665286
              ],
              [
                51.1645947,
                31.1634774
              ],
              [
                51.1645946,
                31.1634774
              ],
              [
                51.1640382,
                31.1587573
              ],
              [
                51.1640381,
                31.1587567
              ],
              [
                51.164038,
                31.1587563
              ],
              [
                51.1643162,
                31.1584782
              ],
              [
                51.1643167,
                31.1584778
              ],
              [
                51.1643175,
                31.158477
              ],
              [
                51.164318,
                31.1584765
              ],
              [
                51.1645946,
                31.157646
              ],
              [
                51.161538,
                31.1523652
              ],
              [
                51.1615379,
                31.1523652
              ],
              [
                51.1601518,
                31.151535
              ],
              [
                51.1601517,
                31.1515349
              ],
              [
                51.1601514,
                31.1515348
              ],
              [
                51.1601514,
                31.1515347
              ],
              [
                51.1601504,
                31.1515344
              ],
              [
                51.1579281,
                31.1506952
              ],
              [
                51.1579281,
                31.1506951
              ],
              [
                51.1548722,
                31.1501447
              ],
              [
                51.1548714,
                31.1501446
              ],
              [
                51.1548662,
                31.1501446
              ],
              [
                51.1537655,
                31.1501465
              ],
              [
                51.15376,
                31.1501465
              ],
              [
                51.1537596,
                31.1501464
              ],
              [
                51.1529271,
                31.1498668
              ],
              [
                51.1529267,
                31.1498667
              ],
              [
                51.1529212,
                31.1498667
              ],
              [
                51.1509834,
                31.1498667
              ],
              [
                51.1504267,
                31.1501465
              ],
              [
                51.1487601,
                31.1501465
              ],
              [
                51.1290385,
                31.1573662
              ],
              [
                51.0957008,
                31.1818133
              ],
              [
                51.0887576,
                31.1854241
              ],
              [
                51.0784776,
                31.1887642
              ],
              [
                51.07154,
                31.1887642
              ],
              [
                51.0715344,
                31.1887642
              ],
              [
                51.0715343,
                31.1887642
              ],
              [
                51.071534,
                31.188764
              ],
              [
                51.071533,
                31.1887635
              ],
              [
                51.0715036,
                31.1887497
              ],
              [
                51.0695204,
                31.1878169
              ],
              [
                51.0695203,
                31.1878169
              ],
              [
                51.06952,
                31.1878167
              ],
              [
                51.0695198,
                31.1878166
              ],
              [
                51.0634031,
                31.1849473
              ],
              [
                51.0537608,
                31.1804232
              ],
              [
                51.0459843,
                31.1790421
              ],
              [
                51.0459828,
                31.1790405
              ],
              [
                51.0457019,
                31.1787534
              ],
              [
                51.0406997,
                31.1787511
              ],
              [
                51.0309765,
                31.1818113
              ],
              [
                51.0206999,
                31.1887622
              ],
              [
                51.0204234,
                31.189033
              ],
              [
                51.0195945,
                31.1901454
              ],
              [
                50.998246,
                31.2056484
              ],
              [
                50.9791627,
                31.2195027
              ],
              [
                50.9791626,
                31.2195027
              ],
              [
                50.9694423,
                31.2265568
              ],
              [
                50.9613761,
                31.2398818
              ],
              [
                50.963202,
                31.2604226
              ],
              [
                50.9604254,
                31.2626523
              ],
              [
                50.959592,
                31.2629232
              ],
              [
                50.9390357,
                31.2843181
              ],
              [
                50.9370889,
                31.2865388
              ],
              [
                50.9273657,
                31.2965323
              ],
              [
                50.9254225,
                31.2976517
              ],
              [
                50.9245891,
                31.2984821
              ],
              [
                50.9198925,
                31.3009305
              ],
              [
                50.9118091,
                31.3051445
              ],
              [
                50.8923662,
                31.3087554
              ],
              [
                50.8923633,
                31.3087547
              ],
              [
                50.8923632,
                31.3087547
              ],
              [
                50.8912529,
                31.3084847
              ],
              [
                50.890694,
                31.3082047
              ],
              [
                50.8906938,
                31.3082047
              ],
              [
                50.889033,
                31.3082047
              ],
              [
                50.8890326,
                31.3082046
              ],
              [
                50.8801431,
                31.3045937
              ],
              [
                50.8781903,
                31.3034832
              ],
              [
                50.8718037,
                31.2995923
              ],
              [
                50.8637472,
                31.2926502
              ],
              [
                50.86014,
                31.2907095
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555178,
        "tags": {
          "admin_level": "5",
          "alt_name:uk": "шахрестан Когкілує",
          "boundary": "administrative",
          "name": "شهرستان کهگیلویه",
          "name:en": "Kohkiluyeh County",
          "name:uk": "шахрестан Кохґілує",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278071",
          "wikipedia": "en:Kohgiluyeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.1509552,
                31.2513377
              ],
              [
                50.1514939,
                31.2509788
              ],
              [
                50.1681602,
                31.2368149
              ],
              [
                50.1726037,
                31.231534
              ],
              [
                50.1911236,
                31.2157949
              ],
              [
                50.19094,
                31.2154294
              ],
              [
                50.1873267,
                31.2115386
              ],
              [
                50.1873267,
                31.2090291
              ],
              [
                50.1876067,
                31.2073681
              ],
              [
                50.1878833,
                31.2062577
              ],
              [
                50.1881603,
                31.2054272
              ],
              [
                50.18844,
                31.2051474
              ],
              [
                50.1903834,
                31.2015365
              ],
              [
                50.2262197,
                31.1598675
              ],
              [
                50.2262197,
                31.1593168
              ],
              [
                50.2267728,
                31.159037
              ],
              [
                50.2273299,
                31.1579267
              ],
              [
                50.2274682,
                31.1575069
              ],
              [
                50.2278863,
                31.1570964
              ],
              [
                50.2278865,
                31.1570961
              ],
              [
                50.2278866,
                31.1568073
              ],
              [
                50.2703859,
                31.1299347
              ],
              [
                50.2712191,
                31.1293113
              ],
              [
                50.2714991,
                31.1290314
              ],
              [
                50.2720522,
                31.1290314
              ],
              [
                50.2726089,
                31.1284808
              ],
              [
                50.2731659,
                31.1284808
              ],
              [
                50.2734425,
                31.1282009
              ],
              [
                50.2773324,
                31.1259803
              ],
              [
                50.277609,
                31.1254207
              ],
              [
                50.2781657,
                31.1251408
              ],
              [
                50.2870557,
                31.1143086
              ],
              [
                50.2870557,
                31.1140288
              ],
              [
                50.2874245,
                31.1136617
              ],
              [
                50.2881654,
                31.1129185
              ],
              [
                50.2956656,
                31.1062567
              ],
              [
                50.3009455,
                31.0951447
              ],
              [
                50.3103886,
                31.0907035
              ],
              [
                50.3120554,
                31.0907035
              ],
              [
                50.3131651,
                31.0904237
              ],
              [
                50.3170551,
                31.0904236
              ],
              [
                50.3178883,
                31.0901439
              ],
              [
                50.3265018,
                31.0901439
              ],
              [
                50.3278885,
                31.0904237
              ],
              [
                50.3348351,
                31.0904237
              ],
              [
                50.3359449,
                31.0901438
              ],
              [
                50.3378913,
                31.0901439
              ],
              [
                50.3390016,
                31.089864
              ],
              [
                50.3417782,
                31.0895933
              ],
              [
                50.3437247,
                31.0893135
              ],
              [
                50.3706678,
                31.0768114
              ],
              [
                50.3715011,
                31.0768114
              ],
              [
                50.3717812,
                31.0765316
              ],
              [
                50.375391,
                31.0757012
              ],
              [
                50.3770578,
                31.0757012
              ],
              [
                50.3776145,
                31.0754213
              ],
              [
                50.3795575,
                31.0754213
              ],
              [
                50.3801145,
                31.0757012
              ],
              [
                50.3812243,
                31.0757011
              ],
              [
                50.3823376,
                31.0762518
              ],
              [
                50.3831708,
                31.0762518
              ],
              [
                50.3870576,
                31.0782016
              ],
              [
                50.3886802,
                31.079618
              ],
              [
                50.3915042,
                31.0820831
              ],
              [
                50.3920608,
                31.0829225
              ],
              [
                50.3945609,
                31.0873637
              ],
              [
                50.3951139,
                31.0876435
              ],
              [
                50.3956707,
                31.0887538
              ],
              [
                50.4001141,
                31.0920938
              ],
              [
                50.4051138,
                31.0926444
              ],
              [
                50.4053939,
                31.0923646
              ],
              [
                50.4259505,
                31.0882032
              ],
              [
                50.4276169,
                31.0882033
              ],
              [
                50.4278935,
                31.0879234
              ],
              [
                50.4295603,
                31.0879234
              ],
              [
                50.4298404,
                31.0882033
              ],
              [
                50.4320604,
                31.0884741
              ],
              [
                50.4320604,
                31.0887539
              ],
              [
                50.4326171,
                31.0887539
              ],
              [
                50.4351167,
                31.0898642
              ],
              [
                50.4359502,
                31.090144
              ],
              [
                50.4395602,
                31.0923646
              ],
              [
                50.4403934,
                31.0923646
              ],
              [
                50.4406734,
                31.0926445
              ],
              [
                50.4412265,
                31.0926445
              ],
              [
                50.4423403,
                31.0915341
              ],
              [
                50.44345,
                31.0909745
              ],
              [
                50.4470599,
                31.0873638
              ],
              [
                50.4620633,
                31.0820832
              ],
              [
                50.4728963,
                31.0807021
              ],
              [
                50.4748398,
                31.0801425
              ],
              [
                50.4762296,
                31.0801424
              ],
              [
                50.4981761,
                31.0754216
              ],
              [
                50.4992858,
                31.0748709
              ],
              [
                50.5003961,
                31.0748708
              ],
              [
                50.5006761,
                31.074591
              ],
              [
                50.5034528,
                31.0737516
              ],
              [
                50.5053992,
                31.0734809
              ],
              [
                50.5059524,
                31.0734807
              ],
              [
                50.5062325,
                31.0732009
              ],
              [
                50.5070657,
                31.0732009
              ],
              [
                50.5073427,
                31.0729211
              ],
              [
                50.5078994,
                31.0729211
              ],
              [
                50.5331756,
                31.0609788
              ],
              [
                50.5380835,
                31.0575492
              ],
              [
                50.5376222,
                31.0570884
              ],
              [
                50.5373421,
                31.0565378
              ],
              [
                50.536789,
                31.0562579
              ],
              [
                50.530399,
                31.0504177
              ],
              [
                50.5298423,
                31.0493074
              ],
              [
                50.5165094,
                31.0318139
              ],
              [
                50.5095658,
                31.0148621
              ],
              [
                50.5092858,
                31.0115314
              ],
              [
                50.5092858,
                31.0106919
              ],
              [
                50.5090092,
                31.0101413
              ],
              [
                50.508176,
                30.9998692
              ],
              [
                50.5084527,
                30.9920885
              ],
              [
                50.5087327,
                30.9901478
              ],
              [
                50.5095164,
                30.988347
              ],
              [
                50.5217858,
                30.9601444
              ],
              [
                50.5217857,
                30.9598646
              ],
              [
                50.5215092,
                30.9593049
              ],
              [
                50.5215092,
                30.9584745
              ],
              [
                50.520676,
                30.9568047
              ],
              [
                50.5190091,
                30.9562541
              ],
              [
                50.5145661,
                30.9565249
              ],
              [
                50.5103996,
                30.9551438
              ],
              [
                50.5098425,
                30.9545842
              ],
              [
                50.5095659,
                30.9515333
              ],
              [
                50.5090093,
                30.9512536
              ],
              [
                50.5081761,
                30.9504231
              ],
              [
                50.5017862,
                30.9523637
              ],
              [
                50.5001193,
                30.9540336
              ],
              [
                50.4992861,
                30.9540336
              ],
              [
                50.4962293,
                30.9531941
              ],
              [
                50.4959528,
                30.9526436
              ],
              [
                50.4884531,
                30.9456934
              ],
              [
                50.4837296,
                30.9479228
              ],
              [
                50.4828963,
                30.9479228
              ],
              [
                50.4815065,
                30.9479228
              ],
              [
                50.480953,
                30.947643
              ],
              [
                50.4801197,
                30.947643
              ],
              [
                50.4723399,
                30.9429133
              ],
              [
                50.4715067,
                30.9420919
              ],
              [
                50.4706731,
                30.9415323
              ],
              [
                50.4703965,
                30.9412524
              ],
              [
                50.4659499,
                30.939023
              ],
              [
                50.4590068,
                30.937642
              ],
              [
                50.4562302,
                30.937642
              ],
              [
                50.4540068,
                30.9370823
              ],
              [
                50.4515067,
                30.9370823
              ],
              [
                50.4495636,
                30.937642
              ],
              [
                50.4381737,
                30.9431931
              ],
              [
                50.4373405,
                30.943193
              ],
              [
                50.4318423,
                30.9446922
              ],
              [
                50.4281703,
                30.9456933
              ],
              [
                50.426784,
                30.9456933
              ],
              [
                50.4265039,
                30.9459731
              ],
              [
                50.4251172,
                30.9459731
              ],
              [
                50.4245605,
                30.9456932
              ],
              [
                50.4234507,
                30.9456933
              ],
              [
                50.4212273,
                30.9451426
              ],
              [
                50.4198373,
                30.9451427
              ],
              [
                50.417894,
                30.9445831
              ],
              [
                50.4145607,
                30.9443123
              ],
              [
                50.4067809,
                30.9409726
              ],
              [
                50.4059476,
                30.940422
              ],
              [
                50.4053942,
                30.9401422
              ],
              [
                50.4012277,
                30.9343112
              ],
              [
                50.4003944,
                30.9309716
              ],
              [
                50.3992812,
                30.9295906
              ],
              [
                50.3926142,
                30.9312514
              ],
              [
                50.3912279,
                30.9312514
              ],
              [
                50.3909478,
                30.9315312
              ],
              [
                50.3887243,
                30.9315312
              ],
              [
                50.3881712,
                30.9312513
              ],
              [
                50.3865043,
                30.9312514
              ],
              [
                50.3856711,
                30.9309717
              ],
              [
                50.3840047,
                30.9309716
              ],
              [
                50.3815047,
                30.9301411
              ],
              [
                50.3812245,
                30.9301411
              ],
              [
                50.380948,
                30.9298613
              ],
              [
                50.3726146,
                30.9254205
              ],
              [
                50.3715013,
                30.9254205
              ],
              [
                50.3706681,
                30.9251407
              ],
              [
                50.3695579,
                30.9251407
              ],
              [
                50.3687248,
                30.9254205
              ],
              [
                50.3676149,
                30.9254205
              ],
              [
                50.3667813,
                30.9257003
              ],
              [
                50.3601148,
                30.9276409
              ],
              [
                50.3542814,
                30.9301412
              ],
              [
                50.3534482,
                30.9301412
              ],
              [
                50.3531681,
                30.930421
              ],
              [
                50.3520584,
                30.930421
              ],
              [
                50.3517783,
                30.9301411
              ],
              [
                50.348445,
                30.9290309
              ],
              [
                50.3403918,
                30.9234709
              ],
              [
                50.339002,
                30.9198604
              ],
              [
                50.3367785,
                30.9184704
              ],
              [
                50.3353921,
                30.9181906
              ],
              [
                50.335112,
                30.9179198
              ],
              [
                50.3312221,
                30.9179197
              ],
              [
                50.3281685,
                30.9168096
              ],
              [
                50.3251123,
                30.9151397
              ],
              [
                50.3228887,
                30.9084695
              ],
              [
                50.3231688,
                30.906529
              ],
              [
                50.3234454,
                30.9043085
              ],
              [
                50.3237219,
                30.9031983
              ],
              [
                50.3228887,
                30.898198
              ],
              [
                50.3228888,
                30.8948583
              ],
              [
                50.3253888,
                30.8895871
              ],
              [
                50.3259455,
                30.8893073
              ],
              [
                50.3387254,
                30.8806966
              ],
              [
                50.3420587,
                30.8768064
              ],
              [
                50.343445,
                30.8740265
              ],
              [
                50.3440017,
                30.8723567
              ],
              [
                50.3442787,
                30.8715263
              ],
              [
                50.3448353,
                30.8706959
              ],
              [
                50.3462252,
                30.866526
              ],
              [
                50.3467783,
                30.8659754
              ],
              [
                50.3512253,
                30.8643056
              ],
              [
                50.3528917,
                30.8626359
              ],
              [
                50.3531684,
                30.8618055
              ],
              [
                50.3531683,
                30.8595851
              ],
              [
                50.354002,
                30.8587548
              ],
              [
                50.3573352,
                30.8590255
              ],
              [
                50.3584485,
                30.8587548
              ],
              [
                50.3631681,
                30.8587548
              ],
              [
                50.3640017,
                30.858475
              ],
              [
                50.365115,
                30.858475
              ],
              [
                50.3695581,
                30.8568052
              ],
              [
                50.3720581,
                30.8537545
              ],
              [
                50.3728913,
                30.849025
              ],
              [
                50.3731714,
                30.8487452
              ],
              [
                50.3728914,
                30.8454147
              ],
              [
                50.3734481,
                30.8440338
              ],
              [
                50.373448,
                30.8426348
              ],
              [
                50.373725,
                30.8404144
              ],
              [
                50.3728914,
                30.8365244
              ],
              [
                50.3728914,
                30.8362446
              ],
              [
                50.3709484,
                30.8354142
              ],
              [
                50.3715014,
                30.8343041
              ],
              [
                50.3717816,
                30.832914
              ],
              [
                50.3720581,
                30.829024
              ],
              [
                50.3723383,
                30.8281937
              ],
              [
                50.3726148,
                30.8273633
              ],
              [
                50.3728914,
                30.8265239
              ],
              [
                50.3781477,
                30.8127052
              ],
              [
                50.3781716,
                30.8126425
              ],
              [
                50.3784482,
                30.8123627
              ],
              [
                50.3762246,
                30.8043028
              ],
              [
                50.3751149,
                30.8026331
              ],
              [
                50.3742817,
                30.8009724
              ],
              [
                50.3720582,
                30.7973622
              ],
              [
                50.3717816,
                30.793752
              ],
              [
                50.3728915,
                30.7926419
              ],
              [
                50.3742817,
                30.7918025
              ],
              [
                50.3787248,
                30.7918025
              ],
              [
                50.3790049,
                30.7920823
              ],
              [
                50.3803056,
                30.7920823
              ],
              [
                50.3837249,
                30.7920822
              ],
              [
                50.3842816,
                30.7918025
              ],
              [
                50.3848024,
                30.7918025
              ],
              [
                50.3856714,
                30.7918025
              ],
              [
                50.3873382,
                30.7909721
              ],
              [
                50.3881714,
                30.7909721
              ],
              [
                50.388448,
                30.7906924
              ],
              [
                50.3890046,
                30.7906923
              ],
              [
                50.3892813,
                30.7904125
              ],
              [
                50.3945614,
                30.7879125
              ],
              [
                50.3954093,
                30.7865963
              ],
              [
                50.3961613,
                30.7854289
              ],
              [
                50.3970614,
                30.7840316
              ],
              [
                50.397338,
                30.7829124
              ],
              [
                50.3978946,
                30.7818023
              ],
              [
                50.3976146,
                30.7801416
              ],
              [
                50.3974873,
                30.7779653
              ],
              [
                50.3974118,
                30.7766748
              ],
              [
                50.397338,
                30.7754122
              ],
              [
                50.3987378,
                30.7735476
              ],
              [
                50.3995277,
                30.7724954
              ],
              [
                50.3996831,
                30.7722883
              ],
              [
                50.4006714,
                30.7709718
              ],
              [
                50.4035843,
                30.7671748
              ],
              [
                50.4098379,
                30.7590222
              ],
              [
                50.410118,
                30.7581919
              ],
              [
                50.4103946,
                30.757912
              ],
              [
                50.410118,
                30.7556918
              ],
              [
                50.4092812,
                30.7540221
              ],
              [
                50.4092813,
                30.7537424
              ],
              [
                50.4053945,
                30.7476322
              ],
              [
                50.3955148,
                30.7420598
              ],
              [
                50.3954826,
                30.7420417
              ],
              [
                50.3948213,
                30.7416686
              ],
              [
                50.3945615,
                30.7415221
              ],
              [
                50.3932603,
                30.7394435
              ],
              [
                50.3931716,
                30.7393019
              ],
              [
                50.3928946,
                30.7334715
              ],
              [
                50.3931716,
                30.7318018
              ],
              [
                50.3928947,
                30.7315221
              ],
              [
                50.392841,
                30.7313077
              ],
              [
                50.3942814,
                30.7284716
              ],
              [
                50.3967815,
                30.7276412
              ],
              [
                50.4117845,
                30.7179121
              ],
              [
                50.4148209,
                30.7095593
              ],
              [
                50.4151177,
                30.7087426
              ],
              [
                50.4153943,
                30.7079123
              ],
              [
                50.4153944,
                30.7043707
              ],
              [
                50.4153944,
                30.6981923
              ],
              [
                50.4151178,
                30.6979125
              ],
              [
                50.4142846,
                30.6893026
              ],
              [
                50.4142846,
                30.6860279
              ],
              [
                50.4142847,
                30.6823624
              ],
              [
                50.416254,
                30.6754609
              ],
              [
                50.4165046,
                30.6745829
              ],
              [
                50.4190046,
                30.6706931
              ],
              [
                50.4237277,
                30.6651337
              ],
              [
                50.4531741,
                30.6481851
              ],
              [
                50.4640264,
                30.6425948
              ],
              [
                50.4892869,
                30.6295761
              ],
              [
                50.4901201,
                30.6295762
              ],
              [
                50.5028964,
                30.6242967
              ],
              [
                50.5076201,
                30.6229159
              ],
              [
                50.51151,
                30.6215262
              ],
              [
                50.5123432,
                30.6209666
              ],
              [
                50.513804,
                30.620318
              ],
              [
                50.5169641,
                30.6178093
              ],
              [
                50.5198097,
                30.6151195
              ],
              [
                50.5233918,
                30.6115977
              ],
              [
                50.52602,
                30.6083543
              ],
              [
                50.5300177,
                30.6041367
              ],
              [
                50.5329589,
                30.6008018
              ],
              [
                50.5339013,
                30.5996434
              ],
              [
                50.5343743,
                30.5987652
              ],
              [
                50.5350533,
                30.5974683
              ],
              [
                50.5357856,
                30.5955263
              ],
              [
                50.5367776,
                30.5928882
              ],
              [
                50.5376624,
                30.5902496
              ],
              [
                50.5389672,
                30.586735
              ],
              [
                50.5403748,
                30.5828959
              ],
              [
                50.5413132,
                30.5806749
              ],
              [
                50.5429307,
                30.5770666
              ],
              [
                50.544548,
                30.5747983
              ],
              [
                50.5467414,
                30.5711446
              ],
              [
                50.5483093,
                30.5691558
              ],
              [
                50.5486349,
                30.5687654
              ],
              [
                50.5487199,
                30.5685105
              ],
              [
                50.548733,
                30.5684709
              ],
              [
                50.5492897,
                30.5665216
              ],
              [
                50.5495663,
                30.5662419
              ],
              [
                50.5495662,
                30.5630552
              ],
              [
                50.5495662,
                30.5626321
              ],
              [
                50.5509561,
                30.5631916
              ],
              [
                50.557066,
                30.5676317
              ],
              [
                50.5592894,
                30.5684709
              ],
              [
                50.5592895,
                30.5681912
              ],
              [
                50.5601227,
                30.5681912
              ],
              [
                50.5603992,
                30.5679114
              ],
              [
                50.561236,
                30.5679114
              ],
              [
                50.563736,
                30.5665217
              ],
              [
                50.5642892,
                30.5665217
              ],
              [
                50.5645693,
                30.5662419
              ],
              [
                50.5665127,
                30.5662419
              ],
              [
                50.5670693,
                30.5665216
              ],
              [
                50.5676224,
                30.5665217
              ],
              [
                50.5692892,
                30.5670721
              ],
              [
                50.5831789,
                30.5779105
              ],
              [
                50.583459,
                30.578461
              ],
              [
                50.5859591,
                30.5795801
              ],
              [
                50.5956788,
                30.5781903
              ],
              [
                50.5981788,
                30.578461
              ],
              [
                50.6059587,
                30.5826303
              ],
              [
                50.6062352,
                30.5831898
              ],
              [
                50.6070685,
                30.5854099
              ],
              [
                50.6081821,
                30.5892994
              ],
              [
                50.6106796,
                30.5919905
              ],
              [
                50.6117919,
                30.593189
              ],
              [
                50.6159585,
                30.5942991
              ],
              [
                50.6167916,
                30.5945788
              ],
              [
                50.6173483,
                30.594299
              ],
              [
                50.6187386,
                30.5942991
              ],
              [
                50.6195718,
                30.5940284
              ],
              [
                50.6198483,
                30.594299
              ],
              [
                50.620405,
                30.5940283
              ],
              [
                50.6262382,
                30.5956888
              ],
              [
                50.6270715,
                30.5956888
              ],
              [
                50.6273484,
                30.5959686
              ],
              [
                50.6281817,
                30.5959686
              ],
              [
                50.6295716,
                30.5965191
              ],
              [
                50.635958,
                30.5973493
              ],
              [
                50.6367948,
                30.5976291
              ],
              [
                50.6387382,
                30.5976291
              ],
              [
                50.6392948,
                30.5973494
              ],
              [
                50.6431816,
                30.5973494
              ],
              [
                50.6437382,
                30.5976291
              ],
              [
                50.644848,
                30.5973493
              ],
              [
                50.647348,
                30.5973494
              ],
              [
                50.6479048,
                30.5973494
              ],
              [
                50.6484614,
                30.5973494
              ],
              [
                50.6540146,
                30.5973494
              ],
              [
                50.6565177,
                30.5970786
              ],
              [
                50.6579045,
                30.5973494
              ],
              [
                50.664571,
                30.6031883
              ],
              [
                50.6673511,
                30.6040186
              ],
              [
                50.6676277,
                30.6042983
              ],
              [
                50.6684609,
                30.6042983
              ],
              [
                50.6687375,
                30.6045781
              ],
              [
                50.6698511,
                30.6045781
              ],
              [
                50.6720708,
                30.6054084
              ],
              [
                50.6740177,
                30.6054083
              ],
              [
                50.6741911,
                30.6055838
              ],
              [
                50.6742942,
                30.6056881
              ],
              [
                50.6754076,
                30.6054083
              ],
              [
                50.6762412,
                30.6054084
              ],
              [
                50.677351,
                30.6051286
              ],
              [
                50.6801275,
                30.6048579
              ],
              [
                50.6806842,
                30.6045781
              ],
              [
                50.682351,
                30.6048579
              ],
              [
                50.6876273,
                30.6109675
              ],
              [
                50.6881839,
                30.6115271
              ],
              [
                50.6917941,
                30.6117978
              ],
              [
                50.6959642,
                30.6104171
              ],
              [
                50.7023506,
                30.6151279
              ],
              [
                50.7034639,
                30.6165177
              ],
              [
                50.7054072,
                30.6215264
              ],
              [
                50.7061055,
                30.6223633
              ],
              [
                50.7009638,
                30.6379152
              ],
              [
                50.6967973,
                30.6484653
              ],
              [
                50.6920738,
                30.6559739
              ],
              [
                50.6862409,
                30.667634
              ],
              [
                50.675961,
                30.6806931
              ],
              [
                50.6748508,
                30.6826335
              ],
              [
                50.6748508,
                30.6829132
              ],
              [
                50.676241,
                30.6834728
              ],
              [
                50.6795743,
                30.6873536
              ],
              [
                50.6809607,
                30.6968028
              ],
              [
                50.6772232,
                30.7069767
              ],
              [
                50.6759608,
                30.7104126
              ],
              [
                50.6692944,
                30.7184721
              ],
              [
                50.6604044,
                30.7301326
              ],
              [
                50.6598508,
                30.7306921
              ],
              [
                50.6567945,
                30.7343022
              ],
              [
                50.652071,
                30.7412517
              ],
              [
                50.6495709,
                30.7473527
              ],
              [
                50.6451279,
                30.7695821
              ],
              [
                50.6437379,
                30.7731923
              ],
              [
                50.643738,
                30.7740317
              ],
              [
                50.6365144,
                30.7884724
              ],
              [
                50.6370714,
                30.792922
              ],
              [
                50.6434609,
                30.7981929
              ],
              [
                50.6434609,
                30.7984727
              ],
              [
                50.6545709,
                30.7998536
              ],
              [
                50.6559608,
                30.8001334
              ],
              [
                50.659571,
                30.8001334
              ],
              [
                50.6642941,
                30.8001334
              ],
              [
                50.6687371,
                30.8009728
              ],
              [
                50.6717939,
                30.8029133
              ],
              [
                50.685407,
                30.8173632
              ],
              [
                50.696517,
                30.822914
              ],
              [
                50.7095734,
                30.825694
              ],
              [
                50.7116222,
                30.8258502
              ],
              [
                50.7167966,
                30.8262445
              ],
              [
                50.7184633,
                30.8265243
              ],
              [
                50.7265198,
                30.8265244
              ],
              [
                50.7270732,
                30.8262446
              ],
              [
                50.7298532,
                30.8262446
              ],
              [
                50.7329098,
                30.827084
              ],
              [
                50.741243,
                30.832364
              ],
              [
                50.7417258,
                30.8327732
              ],
              [
                50.7431863,
                30.8337539
              ],
              [
                50.7434629,
                30.8340247
              ],
              [
                50.743743,
                30.8376441
              ],
              [
                50.7467962,
                30.8465253
              ],
              [
                50.7479094,
                30.8487456
              ],
              [
                50.7481863,
                30.8490255
              ],
              [
                50.7479095,
                30.8506952
              ],
              [
                50.7473528,
                30.8515256
              ],
              [
                50.7467962,
                30.8529156
              ],
              [
                50.7420764,
                30.8593059
              ],
              [
                50.7415195,
                30.8606958
              ],
              [
                50.736243,
                30.8679165
              ],
              [
                50.7262397,
                30.8768069
              ],
              [
                50.7256865,
                30.8773575
              ],
              [
                50.7192966,
                30.8793071
              ],
              [
                50.7190199,
                30.8795869
              ],
              [
                50.7181866,
                30.879587
              ],
              [
                50.7170733,
                30.8801375
              ],
              [
                50.7059635,
                30.8823579
              ],
              [
                50.7056835,
                30.8826376
              ],
              [
                50.7051299,
                30.8826377
              ],
              [
                50.7048502,
                30.8829174
              ],
              [
                50.7031834,
                30.8837569
              ],
              [
                50.6951301,
                30.8909776
              ],
              [
                50.6759605,
                30.8998592
              ],
              [
                50.6737371,
                30.8995793
              ],
              [
                50.6637373,
                30.9029189
              ],
              [
                50.6612372,
                30.9040291
              ],
              [
                50.6559606,
                30.9062495
              ],
              [
                50.6401275,
                30.9098599
              ],
              [
                50.6309577,
                30.9131905
              ],
              [
                50.6298475,
                30.9137501
              ],
              [
                50.629571,
                30.9140299
              ],
              [
                50.6287378,
                30.9140299
              ],
              [
                50.6251245,
                30.9156908
              ],
              [
                50.6245714,
                30.9162503
              ],
              [
                50.609848,
                30.9220811
              ],
              [
                50.6076249,
                30.9232004
              ],
              [
                50.6070678,
                30.9234712
              ],
              [
                50.6126246,
                30.9301415
              ],
              [
                50.6179048,
                30.9337519
              ],
              [
                50.618738,
                30.9340317
              ],
              [
                50.6240146,
                30.9373624
              ],
              [
                50.6245713,
                30.9373623
              ],
              [
                50.6337379,
                30.9481938
              ],
              [
                50.6359574,
                30.956525
              ],
              [
                50.6392941,
                30.9623649
              ],
              [
                50.6392942,
                30.9626358
              ],
              [
                50.6398477,
                30.9629155
              ],
              [
                50.6456806,
                30.9679162
              ],
              [
                50.646794,
                30.9701366
              ],
              [
                50.6473475,
                30.9745866
              ],
              [
                50.6470709,
                30.9748664
              ],
              [
                50.6462373,
                30.9781971
              ],
              [
                50.6459607,
                30.9784769
              ],
              [
                50.6428318,
                30.9837521
              ],
              [
                50.6362374,
                30.9948688
              ],
              [
                50.630681,
                30.9995896
              ],
              [
                50.6320709,
                31.0029203
              ],
              [
                50.6326241,
                31.0051408
              ],
              [
                50.636514,
                31.0120821
              ],
              [
                50.6365139,
                31.0126418
              ],
              [
                50.6420707,
                31.0173626
              ],
              [
                50.6429039,
                31.0173626
              ],
              [
                50.647904,
                31.0193124
              ],
              [
                50.6498474,
                31.0193124
              ],
              [
                50.650404,
                31.0195922
              ],
              [
                50.6534607,
                31.0195923
              ],
              [
                50.6559604,
                31.019863
              ],
              [
                50.6565171,
                31.0201428
              ],
              [
                50.6581838,
                31.0201428
              ],
              [
                50.658737,
                31.0204226
              ],
              [
                50.6626269,
                31.0204226
              ],
              [
                50.6629039,
                31.0201429
              ],
              [
                50.6642938,
                31.0201428
              ],
              [
                50.674017,
                31.0143117
              ],
              [
                50.674017,
                31.0137521
              ],
              [
                50.6762405,
                31.0120822
              ],
              [
                50.6773503,
                31.0120821
              ],
              [
                50.6776268,
                31.0118114
              ],
              [
                50.6792937,
                31.0120822
              ],
              [
                50.6876267,
                31.0170829
              ],
              [
                50.6879067,
                31.0173627
              ],
              [
                50.6859602,
                31.0201428
              ],
              [
                50.6851265,
                31.0201428
              ],
              [
                50.6804069,
                31.0243131
              ],
              [
                50.6798504,
                31.0248637
              ],
              [
                50.6798502,
                31.0251435
              ],
              [
                50.6762405,
                31.0284743
              ],
              [
                50.6751267,
                31.0284743
              ],
              [
                50.6731838,
                31.030424
              ],
              [
                50.6664478,
                31.0425376
              ],
              [
                50.666237,
                31.0429167
              ],
              [
                50.6667938,
                31.048757
              ],
              [
                50.6665171,
                31.0490278
              ],
              [
                50.6662371,
                31.050138
              ],
              [
                50.6695704,
                31.0565379
              ],
              [
                50.6704035,
                31.0568087
              ],
              [
                50.6706837,
                31.0573684
              ],
              [
                50.6723501,
                31.0581988
              ],
              [
                50.68346,
                31.0670901
              ],
              [
                50.6848499,
                31.0715312
              ],
              [
                50.6823503,
                31.0757015
              ],
              [
                50.6565169,
                31.0884743
              ],
              [
                50.6540138,
                31.0895936
              ],
              [
                50.6292906,
                31.0948653
              ],
              [
                50.6262374,
                31.0945944
              ],
              [
                50.6251242,
                31.0943147
              ],
              [
                50.6190143,
                31.0943146
              ],
              [
                50.6184576,
                31.0940348
              ],
              [
                50.6159576,
                31.0940348
              ],
              [
                50.615681,
                31.093755
              ],
              [
                50.6115146,
                31.0937549
              ],
              [
                50.6104008,
                31.0940348
              ],
              [
                50.6084578,
                31.0940348
              ],
              [
                50.6045679,
                31.0957047
              ],
              [
                50.598178,
                31.1006966
              ],
              [
                50.5962345,
                31.1037567
              ],
              [
                50.595958,
                31.1040274
              ],
              [
                50.5956779,
                31.1051468
              ],
              [
                50.5951247,
                31.1059772
              ],
              [
                50.5951247,
                31.1062571
              ],
              [
                50.5923446,
                31.1218103
              ],
              [
                50.5920681,
                31.1234804
              ],
              [
                50.5917914,
                31.1248704
              ],
              [
                50.592068,
                31.1268112
              ],
              [
                50.592068,
                31.1282014
              ],
              [
                50.5926246,
                31.130422
              ],
              [
                50.5951247,
                31.1351431
              ],
              [
                50.5956778,
                31.1362624
              ],
              [
                50.598458,
                31.1387629
              ],
              [
                50.6095675,
                31.1443145
              ],
              [
                50.6131809,
                31.1448651
              ],
              [
                50.6140141,
                31.145145
              ],
              [
                50.6306808,
                31.145145
              ],
              [
                50.6309573,
                31.1454248
              ],
              [
                50.6317906,
                31.1454248
              ],
              [
                50.6323472,
                31.1454248
              ],
              [
                50.6329039,
                31.1454248
              ],
              [
                50.6334575,
                31.1457047
              ],
              [
                50.6395704,
                31.1457047
              ],
              [
                50.6429037,
                31.1465351
              ],
              [
                50.6537371,
                31.1531971
              ],
              [
                50.6584602,
                31.1551469
              ],
              [
                50.6590169,
                31.1551469
              ],
              [
                50.6601271,
                31.1554178
              ],
              [
                50.6609603,
                31.1554178
              ],
              [
                50.661517,
                31.1556976
              ],
              [
                50.6648502,
                31.1556975
              ],
              [
                50.6651268,
                31.1559774
              ],
              [
                50.6717933,
                31.1559774
              ],
              [
                50.6726269,
                31.1556976
              ],
              [
                50.6734601,
                31.1556976
              ],
              [
                50.6740168,
                31.1559774
              ],
              [
                50.6856834,
                31.1559774
              ],
              [
                50.6867932,
                31.1562573
              ],
              [
                50.694573,
                31.1562573
              ],
              [
                50.7098495,
                31.1573676
              ],
              [
                50.7104061,
                31.1576474
              ],
              [
                50.7117964,
                31.1573676
              ],
              [
                50.7142962,
                31.1573676
              ],
              [
                50.7148528,
                31.1576475
              ],
              [
                50.722906,
                31.1576474
              ],
              [
                50.7234626,
                31.1579273
              ],
              [
                50.7259627,
                31.1579273
              ],
              [
                50.7265192,
                31.1579273
              ],
              [
                50.7270727,
                31.1576475
              ],
              [
                50.7276293,
                31.1576475
              ],
              [
                50.7287393,
                31.1573677
              ],
              [
                50.7301293,
                31.1565282
              ],
              [
                50.730686,
                31.1559775
              ],
              [
                50.7315192,
                31.1556976
              ],
              [
                50.7326292,
                31.1548671
              ],
              [
                50.7329093,
                31.1548671
              ],
              [
                50.7331858,
                31.1545873
              ],
              [
                50.7334626,
                31.1543075
              ],
              [
                50.7340193,
                31.1540366
              ],
              [
                50.7351293,
                31.153477
              ],
              [
                50.7367959,
                31.1523667
              ],
              [
                50.7373525,
                31.1520868
              ],
              [
                50.7376291,
                31.1520868
              ],
              [
                50.7384625,
                31.1515362
              ],
              [
                50.7390192,
                31.1512564
              ],
              [
                50.7392957,
                31.1509765
              ],
              [
                50.7401292,
                31.1506967
              ],
              [
                50.7406858,
                31.1504259
              ],
              [
                50.7409624,
                31.1501461
              ],
              [
                50.7423525,
                31.1493156
              ],
              [
                50.7434624,
                31.1487559
              ],
              [
                50.7442957,
                31.148476
              ],
              [
                50.7456858,
                31.1476456
              ],
              [
                50.7465192,
                31.1470949
              ],
              [
                50.747909,
                31.1465353
              ],
              [
                50.7487424,
                31.1462555
              ],
              [
                50.749019,
                31.1459756
              ],
              [
                50.750409,
                31.1454249
              ],
              [
                50.7509657,
                31.1451451
              ],
              [
                50.7520756,
                31.1445945
              ],
              [
                50.7523522,
                31.1445945
              ],
              [
                50.7529089,
                31.1443146
              ],
              [
                50.7534658,
                31.1440348
              ],
              [
                50.7540188,
                31.143755
              ],
              [
                50.7545755,
                31.1434842
              ],
              [
                50.7548523,
                31.1434841
              ],
              [
                50.7562422,
                31.1429245
              ],
              [
                50.756519,
                31.1429244
              ],
              [
                50.7576322,
                31.1423648
              ],
              [
                50.757909,
                31.1423648
              ],
              [
                50.7581856,
                31.1423648
              ],
              [
                50.7587422,
                31.142094
              ],
              [
                50.7595756,
                31.1418141
              ],
              [
                50.7601323,
                31.1415344
              ],
              [
                50.7623521,
                31.1409837
              ],
              [
                50.7626322,
                31.1407038
              ],
              [
                50.7637422,
                31.140424
              ],
              [
                50.7640188,
                31.140424
              ],
              [
                50.7656855,
                31.1398734
              ],
              [
                50.7659654,
                31.1398734
              ],
              [
                50.7665187,
                31.1395936
              ],
              [
                50.7670754,
                31.1395936
              ],
              [
                50.7673521,
                31.1395936
              ],
              [
                50.7704086,
                31.138763
              ],
              [
                50.7726322,
                31.1381944
              ],
              [
                50.7737419,
                31.1376437
              ],
              [
                50.775132,
                31.137373
              ],
              [
                50.7756886,
                31.137373
              ],
              [
                50.7759654,
                31.1373729
              ],
              [
                50.7762419,
                31.1370841
              ],
              [
                50.7773553,
                31.1370841
              ],
              [
                50.7798553,
                31.1368133
              ],
              [
                50.7806885,
                31.1365334
              ],
              [
                50.7812418,
                31.1365335
              ],
              [
                50.7826319,
                31.1379236
              ],
              [
                50.7848552,
                31.1459756
              ],
              [
                50.7848552,
                31.1468151
              ],
              [
                50.7845751,
                31.1482053
              ],
              [
                50.7842985,
                31.1487559
              ],
              [
                50.7840218,
                31.1540367
              ],
              [
                50.7820752,
                31.1620888
              ],
              [
                50.7585522,
                31.1916583
              ],
              [
                50.7309694,
                31.2121094
              ],
              [
                50.7152935,
                31.2242525
              ],
              [
                50.690231,
                31.2486174
              ],
              [
                50.6850811,
                31.2653462
              ],
              [
                50.6589886,
                31.2852996
              ],
              [
                50.6284329,
                31.3102354
              ],
              [
                50.592384,
                31.3372173
              ],
              [
                50.5709962,
                31.3419417
              ],
              [
                50.5164336,
                31.3485746
              ],
              [
                50.4740059,
                31.3776537
              ],
              [
                50.473729,
                31.3779246
              ],
              [
                50.462896,
                31.3887579
              ],
              [
                50.4626158,
                31.3893176
              ],
              [
                50.4587295,
                31.394319
              ],
              [
                50.4581729,
                31.3945989
              ],
              [
                50.4570626,
                31.3965399
              ],
              [
                50.4551161,
                31.3984899
              ],
              [
                50.4409494,
                31.419317
              ],
              [
                50.4403927,
                31.419597
              ],
              [
                50.4403927,
                31.4198768
              ],
              [
                50.4499874,
                31.4313345
              ],
              [
                50.4410377,
                31.4334915
              ],
              [
                50.4296708,
                31.4356921
              ],
              [
                50.421767,
                31.4352611
              ],
              [
                50.4196494,
                31.4322
              ],
              [
                50.4199624,
                31.4281257
              ],
              [
                50.4191291,
                31.423027
              ],
              [
                50.4146058,
                31.4197359
              ],
              [
                50.4094106,
                31.4197303
              ],
              [
                50.4014976,
                31.4195344
              ],
              [
                50.3841116,
                31.4194267
              ],
              [
                50.3748315,
                31.4219734
              ],
              [
                50.3637067,
                31.4248693
              ],
              [
                50.3529031,
                31.4296486
              ],
              [
                50.3424963,
                31.4344152
              ],
              [
                50.3322286,
                31.4455016
              ],
              [
                50.3262017,
                31.4507304
              ],
              [
                50.3189523,
                31.4572918
              ],
              [
                50.3078535,
                31.450065
              ],
              [
                50.3009213,
                31.4456747
              ],
              [
                50.2906772,
                31.4405047
              ],
              [
                50.272572,
                31.4314116
              ],
              [
                50.2607013,
                31.42384
              ],
              [
                50.2368137,
                31.4082167
              ],
              [
                50.234202,
                31.4017872
              ],
              [
                50.2457794,
                31.3941911
              ],
              [
                50.2600674,
                31.3966481
              ],
              [
                50.2601251,
                31.3965859
              ],
              [
                50.2648108,
                31.3915394
              ],
              [
                50.270004,
                31.3835008
              ],
              [
                50.2751766,
                31.3780288
              ],
              [
                50.2774065,
                31.3757213
              ],
              [
                50.2967785,
                31.3620987
              ],
              [
                50.2973316,
                31.3618189
              ],
              [
                50.2995551,
                31.3590383
              ],
              [
                50.2998316,
                31.3587585
              ],
              [
                50.2998317,
                31.3584786
              ],
              [
                50.2995551,
                31.357928
              ],
              [
                50.2992784,
                31.3576481
              ],
              [
                50.2986931,
                31.3561277
              ],
              [
                50.2981126,
                31.3546198
              ],
              [
                50.2978882,
                31.354037
              ],
              [
                50.297566,
                31.3537631
              ],
              [
                50.2967432,
                31.3524734
              ],
              [
                50.2882563,
                31.344356
              ],
              [
                50.2763604,
                31.3351205
              ],
              [
                50.2710175,
                31.330101
              ],
              [
                50.2551509,
                31.3151904
              ],
              [
                50.2467612,
                31.306489
              ],
              [
                50.236351,
                31.308735
              ],
              [
                50.2343711,
                31.3087412
              ],
              [
                50.2317467,
                31.3086105
              ],
              [
                50.229763,
                31.308434
              ],
              [
                50.2279892,
                31.3079339
              ],
              [
                50.2263262,
                31.3073396
              ],
              [
                50.2249794,
                31.3067451
              ],
              [
                50.2236329,
                31.3059227
              ],
              [
                50.2218553,
                31.30473
              ],
              [
                50.220665,
                31.3037213
              ],
              [
                50.2193716,
                31.302757
              ],
              [
                50.2183417,
                31.3016997
              ],
              [
                50.2177429,
                31.30069
              ],
              [
                50.2171975,
                31.2995408
              ],
              [
                50.2168654,
                31.2984381
              ],
              [
                50.2166901,
                31.2972844
              ],
              [
                50.2167894,
                31.2963173
              ],
              [
                50.2168311,
                31.2954424
              ],
              [
                50.2179222,
                31.2922619
              ],
              [
                50.2191163,
                31.2888023
              ],
              [
                50.2193184,
                31.2877434
              ],
              [
                50.2193642,
                31.2870038
              ],
              [
                50.2191429,
                31.2864521
              ],
              [
                50.2187117,
                31.2859488
              ],
              [
                50.2182273,
                31.2858127
              ],
              [
                50.2176399,
                31.2858137
              ],
              [
                50.2166786,
                31.286092
              ],
              [
                50.2155608,
                31.2865115
              ],
              [
                50.213642,
                31.2871629
              ],
              [
                50.2124176,
                31.2874915
              ],
              [
                50.2114526,
                31.2875871
              ],
              [
                50.2107049,
                31.2876344
              ],
              [
                50.2093124,
                31.2874093
              ],
              [
                50.2077559,
                31.2868606
              ],
              [
                50.2064668,
                31.2861286
              ],
              [
                50.2052803,
                31.2853498
              ],
              [
                50.2035562,
                31.283882
              ],
              [
                50.2008516,
                31.2810818
              ],
              [
                50.1984252,
                31.2787885
              ],
              [
                50.196644,
                31.2772752
              ],
              [
                50.1948128,
                31.2760367
              ],
              [
                50.1892815,
                31.2730628
              ],
              [
                50.1831511,
                31.2692639
              ],
              [
                50.1800841,
                31.2671557
              ],
              [
                50.1766931,
                31.2642694
              ],
              [
                50.1698685,
                31.2601022
              ],
              [
                50.1656798,
                31.2576774
              ],
              [
                50.1634293,
                31.2566252
              ],
              [
                50.160103,
                31.2552118
              ],
              [
                50.1576751,
                31.2541667
              ],
              [
                50.1552239,
                31.2531114
              ],
              [
                50.1527063,
                31.2518317
              ],
              [
                50.1509552,
                31.2513377
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555191,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لنده",
          "name:en": "Landeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q15726301",
          "wikipedia": "en:Landeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.1675727,
                30.9706956
              ],
              [
                50.1673275,
                30.970136
              ],
              [
                50.1678842,
                30.9693056
              ],
              [
                50.1681609,
                30.9681953
              ],
              [
                50.171771,
                30.9623643
              ],
              [
                50.1720507,
                30.9612541
              ],
              [
                50.1831607,
                30.9409723
              ],
              [
                50.1834383,
                30.9406954
              ],
              [
                50.1935564,
                30.9442308
              ],
              [
                50.2117645,
                30.9384444
              ],
              [
                50.2305123,
                30.9315347
              ],
              [
                50.2548724,
                30.9201131
              ],
              [
                50.2708223,
                30.9018756
              ],
              [
                50.2794474,
                30.8768589
              ],
              [
                50.2903878,
                30.8481675
              ],
              [
                50.3065007,
                30.8306937
              ],
              [
                50.307889,
                30.8306937
              ],
              [
                50.3098324,
                30.8309735
              ],
              [
                50.3153892,
                30.8309734
              ],
              [
                50.3173357,
                30.8312533
              ],
              [
                50.3281687,
                30.8312533
              ],
              [
                50.3490019,
                30.8334736
              ],
              [
                50.351502,
                30.8334736
              ],
              [
                50.3528918,
                30.8337534
              ],
              [
                50.3606685,
                30.8337535
              ],
              [
                50.362615,
                30.8340242
              ],
              [
                50.3634483,
                30.834304
              ],
              [
                50.364835,
                30.8343041
              ],
              [
                50.3695581,
                30.8354142
              ],
              [
                50.3709484,
                30.8354142
              ],
              [
                50.3728914,
                30.8362446
              ],
              [
                50.3728914,
                30.8365244
              ],
              [
                50.373725,
                30.8404144
              ],
              [
                50.373448,
                30.8426348
              ],
              [
                50.3734481,
                30.8440338
              ],
              [
                50.3728914,
                30.8454147
              ],
              [
                50.3731714,
                30.8487452
              ],
              [
                50.3728913,
                30.849025
              ],
              [
                50.3720581,
                30.8537545
              ],
              [
                50.3695581,
                30.8568052
              ],
              [
                50.365115,
                30.858475
              ],
              [
                50.3640017,
                30.858475
              ],
              [
                50.3631681,
                30.8587548
              ],
              [
                50.3584485,
                30.8587548
              ],
              [
                50.3573352,
                30.8590255
              ],
              [
                50.354002,
                30.8587548
              ],
              [
                50.3531683,
                30.8595851
              ],
              [
                50.3531684,
                30.8618055
              ],
              [
                50.3528917,
                30.8626359
              ],
              [
                50.3512253,
                30.8643056
              ],
              [
                50.3467783,
                30.8659754
              ],
              [
                50.3462252,
                30.866526
              ],
              [
                50.3448353,
                30.8706959
              ],
              [
                50.3442787,
                30.8715263
              ],
              [
                50.3440017,
                30.8723567
              ],
              [
                50.343445,
                30.8740265
              ],
              [
                50.3420587,
                30.8768064
              ],
              [
                50.3387254,
                30.8806966
              ],
              [
                50.3259455,
                30.8893073
              ],
              [
                50.3253888,
                30.8895871
              ],
              [
                50.3228888,
                30.8948583
              ],
              [
                50.3228887,
                30.898198
              ],
              [
                50.3237219,
                30.9031983
              ],
              [
                50.3234454,
                30.9043085
              ],
              [
                50.3231688,
                30.906529
              ],
              [
                50.3228887,
                30.9084695
              ],
              [
                50.3251123,
                30.9151397
              ],
              [
                50.3281685,
                30.9168096
              ],
              [
                50.3312221,
                30.9179197
              ],
              [
                50.335112,
                30.9179198
              ],
              [
                50.3353921,
                30.9181906
              ],
              [
                50.3367785,
                30.9184704
              ],
              [
                50.339002,
                30.9198604
              ],
              [
                50.3403918,
                30.9234709
              ],
              [
                50.348445,
                30.9290309
              ],
              [
                50.3517783,
                30.9301411
              ],
              [
                50.3520584,
                30.930421
              ],
              [
                50.3531681,
                30.930421
              ],
              [
                50.3534482,
                30.9301412
              ],
              [
                50.3542814,
                30.9301412
              ],
              [
                50.3601148,
                30.9276409
              ],
              [
                50.3667813,
                30.9257003
              ],
              [
                50.3676149,
                30.9254205
              ],
              [
                50.3687248,
                30.9254205
              ],
              [
                50.3695579,
                30.9251407
              ],
              [
                50.3706681,
                30.9251407
              ],
              [
                50.3715013,
                30.9254205
              ],
              [
                50.3726146,
                30.9254205
              ],
              [
                50.380948,
                30.9298613
              ],
              [
                50.3812245,
                30.9301411
              ],
              [
                50.3815047,
                30.9301411
              ],
              [
                50.3840047,
                30.9309716
              ],
              [
                50.3856711,
                30.9309717
              ],
              [
                50.3865043,
                30.9312514
              ],
              [
                50.3881712,
                30.9312513
              ],
              [
                50.3887243,
                30.9315312
              ],
              [
                50.3909478,
                30.9315312
              ],
              [
                50.3912279,
                30.9312514
              ],
              [
                50.3926142,
                30.9312514
              ],
              [
                50.3992812,
                30.9295906
              ],
              [
                50.4003944,
                30.9309716
              ],
              [
                50.4012277,
                30.9343112
              ],
              [
                50.4053942,
                30.9401422
              ],
              [
                50.4059476,
                30.940422
              ],
              [
                50.4067809,
                30.9409726
              ],
              [
                50.4145607,
                30.9443123
              ],
              [
                50.417894,
                30.9445831
              ],
              [
                50.4198373,
                30.9451427
              ],
              [
                50.4212273,
                30.9451426
              ],
              [
                50.4234507,
                30.9456933
              ],
              [
                50.4245605,
                30.9456932
              ],
              [
                50.4251172,
                30.9459731
              ],
              [
                50.4265039,
                30.9459731
              ],
              [
                50.426784,
                30.9456933
              ],
              [
                50.4281703,
                30.9456933
              ],
              [
                50.4318423,
                30.9446922
              ],
              [
                50.4373405,
                30.943193
              ],
              [
                50.4381737,
                30.9431931
              ],
              [
                50.4495636,
                30.937642
              ],
              [
                50.4515067,
                30.9370823
              ],
              [
                50.4540068,
                30.9370823
              ],
              [
                50.4562302,
                30.937642
              ],
              [
                50.4590068,
                30.937642
              ],
              [
                50.4659499,
                30.939023
              ],
              [
                50.4703965,
                30.9412524
              ],
              [
                50.4706731,
                30.9415323
              ],
              [
                50.4715067,
                30.9420919
              ],
              [
                50.4723399,
                30.9429133
              ],
              [
                50.4801197,
                30.947643
              ],
              [
                50.480953,
                30.947643
              ],
              [
                50.4815065,
                30.9479228
              ],
              [
                50.4828963,
                30.9479228
              ],
              [
                50.4837296,
                30.9479228
              ],
              [
                50.4884531,
                30.9456934
              ],
              [
                50.4959528,
                30.9526436
              ],
              [
                50.4962293,
                30.9531941
              ],
              [
                50.4992861,
                30.9540336
              ],
              [
                50.5001193,
                30.9540336
              ],
              [
                50.5017862,
                30.9523637
              ],
              [
                50.5081761,
                30.9504231
              ],
              [
                50.5090093,
                30.9512536
              ],
              [
                50.5095659,
                30.9515333
              ],
              [
                50.5098425,
                30.9545842
              ],
              [
                50.5103996,
                30.9551438
              ],
              [
                50.5145661,
                30.9565249
              ],
              [
                50.5190091,
                30.9562541
              ],
              [
                50.520676,
                30.9568047
              ],
              [
                50.5215092,
                30.9584745
              ],
              [
                50.5215092,
                30.9593049
              ],
              [
                50.5217857,
                30.9598646
              ],
              [
                50.5217858,
                30.9601444
              ],
              [
                50.5095164,
                30.988347
              ],
              [
                50.5087327,
                30.9901478
              ],
              [
                50.5084527,
                30.9920885
              ],
              [
                50.508176,
                30.9998692
              ],
              [
                50.5090092,
                31.0101413
              ],
              [
                50.5092858,
                31.0106919
              ],
              [
                50.5092858,
                31.0115314
              ],
              [
                50.5095658,
                31.0148621
              ],
              [
                50.5165094,
                31.0318139
              ],
              [
                50.5298423,
                31.0493074
              ],
              [
                50.530399,
                31.0504177
              ],
              [
                50.536789,
                31.0562579
              ],
              [
                50.5373421,
                31.0565378
              ],
              [
                50.5376222,
                31.0570884
              ],
              [
                50.5380835,
                31.0575492
              ],
              [
                50.5331756,
                31.0609788
              ],
              [
                50.5078994,
                31.0729211
              ],
              [
                50.5073427,
                31.0729211
              ],
              [
                50.5070657,
                31.0732009
              ],
              [
                50.5062325,
                31.0732009
              ],
              [
                50.5059524,
                31.0734807
              ],
              [
                50.5053992,
                31.0734809
              ],
              [
                50.5034528,
                31.0737516
              ],
              [
                50.5006761,
                31.074591
              ],
              [
                50.5003961,
                31.0748708
              ],
              [
                50.4992858,
                31.0748709
              ],
              [
                50.4981761,
                31.0754216
              ],
              [
                50.4762296,
                31.0801424
              ],
              [
                50.4748398,
                31.0801425
              ],
              [
                50.4728963,
                31.0807021
              ],
              [
                50.4620633,
                31.0820832
              ],
              [
                50.4470599,
                31.0873638
              ],
              [
                50.44345,
                31.0909745
              ],
              [
                50.4423403,
                31.0915341
              ],
              [
                50.4412265,
                31.0926445
              ],
              [
                50.4406734,
                31.0926445
              ],
              [
                50.4403934,
                31.0923646
              ],
              [
                50.4395602,
                31.0923646
              ],
              [
                50.4359502,
                31.090144
              ],
              [
                50.4351167,
                31.0898642
              ],
              [
                50.4326171,
                31.0887539
              ],
              [
                50.4320604,
                31.0887539
              ],
              [
                50.4320604,
                31.0884741
              ],
              [
                50.4298404,
                31.0882033
              ],
              [
                50.4295603,
                31.0879234
              ],
              [
                50.4278935,
                31.0879234
              ],
              [
                50.4276169,
                31.0882033
              ],
              [
                50.4259505,
                31.0882032
              ],
              [
                50.4053939,
                31.0923646
              ],
              [
                50.4051138,
                31.0926444
              ],
              [
                50.4001141,
                31.0920938
              ],
              [
                50.3956707,
                31.0887538
              ],
              [
                50.3951139,
                31.0876435
              ],
              [
                50.3945609,
                31.0873637
              ],
              [
                50.3920608,
                31.0829225
              ],
              [
                50.3915042,
                31.0820831
              ],
              [
                50.3886802,
                31.079618
              ],
              [
                50.3870576,
                31.0782016
              ],
              [
                50.3831708,
                31.0762518
              ],
              [
                50.3823376,
                31.0762518
              ],
              [
                50.3812243,
                31.0757011
              ],
              [
                50.3801145,
                31.0757012
              ],
              [
                50.3795575,
                31.0754213
              ],
              [
                50.3776145,
                31.0754213
              ],
              [
                50.3770578,
                31.0757012
              ],
              [
                50.375391,
                31.0757012
              ],
              [
                50.3717812,
                31.0765316
              ],
              [
                50.3715011,
                31.0768114
              ],
              [
                50.3706678,
                31.0768114
              ],
              [
                50.3437247,
                31.0893135
              ],
              [
                50.3417782,
                31.0895933
              ],
              [
                50.3390016,
                31.089864
              ],
              [
                50.3378913,
                31.0901439
              ],
              [
                50.3359449,
                31.0901438
              ],
              [
                50.3348351,
                31.0904237
              ],
              [
                50.3278885,
                31.0904237
              ],
              [
                50.3265018,
                31.0901439
              ],
              [
                50.3178883,
                31.0901439
              ],
              [
                50.3170551,
                31.0904236
              ],
              [
                50.3131651,
                31.0904237
              ],
              [
                50.3120554,
                31.0907035
              ],
              [
                50.3103886,
                31.0907035
              ],
              [
                50.3009455,
                31.0951447
              ],
              [
                50.2956656,
                31.1062567
              ],
              [
                50.2881654,
                31.1129185
              ],
              [
                50.2874245,
                31.1136617
              ],
              [
                50.2870557,
                31.1140288
              ],
              [
                50.2870557,
                31.1143086
              ],
              [
                50.2781657,
                31.1251408
              ],
              [
                50.277609,
                31.1254207
              ],
              [
                50.2773324,
                31.1259803
              ],
              [
                50.2734425,
                31.1282009
              ],
              [
                50.2731659,
                31.1284808
              ],
              [
                50.2726089,
                31.1284808
              ],
              [
                50.2720522,
                31.1290314
              ],
              [
                50.2714991,
                31.1290314
              ],
              [
                50.2712191,
                31.1293113
              ],
              [
                50.2703859,
                31.1299347
              ],
              [
                50.2703858,
                31.1295911
              ],
              [
                50.2631658,
                31.1193094
              ],
              [
                50.2548293,
                31.0965257
              ],
              [
                50.2548293,
                31.0937545
              ],
              [
                50.2545528,
                31.0934746
              ],
              [
                50.2537196,
                31.0868128
              ],
              [
                50.2539961,
                31.0857026
              ],
              [
                50.2548293,
                31.0790318
              ],
              [
                50.2526094,
                31.0743108
              ],
              [
                50.2523293,
                31.0704204
              ],
              [
                50.252886,
                31.0687505
              ],
              [
                50.2520528,
                31.0612582
              ],
              [
                50.252886,
                31.0590287
              ],
              [
                50.2534431,
                31.057088
              ],
              [
                50.2539961,
                31.0565373
              ],
              [
                50.2559427,
                31.0520873
              ],
              [
                50.2567764,
                31.049307
              ],
              [
                50.2570529,
                31.0484766
              ],
              [
                50.2584427,
                31.0451458
              ],
              [
                50.2620526,
                31.035695
              ],
              [
                50.2623327,
                31.0348645
              ],
              [
                50.2626093,
                31.0340341
              ],
              [
                50.2659426,
                31.0270927
              ],
              [
                50.2692759,
                31.017642
              ],
              [
                50.2689993,
                31.015972
              ],
              [
                50.2692758,
                31.0154214
              ],
              [
                50.2692758,
                31.0143112
              ],
              [
                50.2695528,
                31.0118109
              ],
              [
                50.2712192,
                31.0076407
              ],
              [
                50.2709427,
                31.0037503
              ],
              [
                50.2714993,
                31.0020894
              ],
              [
                50.2726092,
                31.0002029
              ],
              [
                50.2742759,
                30.9954189
              ],
              [
                50.2728861,
                30.9943086
              ],
              [
                50.2662195,
                30.9909689
              ],
              [
                50.2528861,
                30.9865279
              ],
              [
                50.2514963,
                30.9865279
              ],
              [
                50.237053,
                30.9831972
              ],
              [
                50.2351065,
                30.9831972
              ],
              [
                50.2270533,
                30.9815363
              ],
              [
                50.2253867,
                30.9815363
              ],
              [
                50.1839939,
                30.9737556
              ],
              [
                50.1814938,
                30.9734757
              ],
              [
                50.1798274,
                30.9734757
              ],
              [
                50.1792707,
                30.9731959
              ],
              [
                50.1737175,
                30.971526
              ],
              [
                50.1675727,
                30.9706956
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555277,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چرام",
          "name:en": "Charam County",
          "name:uk": "повіт Черам",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5073911",
          "wikipedia": "fa:شهرستان چرام"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.6070678,
                30.9234712
              ],
              [
                50.6076249,
                30.9232004
              ],
              [
                50.609848,
                30.9220811
              ],
              [
                50.6245714,
                30.9162503
              ],
              [
                50.6251245,
                30.9156908
              ],
              [
                50.6287378,
                30.9140299
              ],
              [
                50.629571,
                30.9140299
              ],
              [
                50.6298475,
                30.9137501
              ],
              [
                50.6309577,
                30.9131905
              ],
              [
                50.6401275,
                30.9098599
              ],
              [
                50.6559606,
                30.9062495
              ],
              [
                50.6612372,
                30.9040291
              ],
              [
                50.6637373,
                30.9029189
              ],
              [
                50.6737371,
                30.8995793
              ],
              [
                50.6759605,
                30.8998592
              ],
              [
                50.6951301,
                30.8909776
              ],
              [
                50.7031834,
                30.8837569
              ],
              [
                50.7048502,
                30.8829174
              ],
              [
                50.7051299,
                30.8826377
              ],
              [
                50.7056835,
                30.8826376
              ],
              [
                50.7059635,
                30.8823579
              ],
              [
                50.7170733,
                30.8801375
              ],
              [
                50.7181866,
                30.879587
              ],
              [
                50.7190199,
                30.8795869
              ],
              [
                50.7192966,
                30.8793071
              ],
              [
                50.7256865,
                30.8773575
              ],
              [
                50.7262397,
                30.8768069
              ],
              [
                50.736243,
                30.8679165
              ],
              [
                50.7415195,
                30.8606958
              ],
              [
                50.7420764,
                30.8593059
              ],
              [
                50.7467962,
                30.8529156
              ],
              [
                50.7473528,
                30.8515256
              ],
              [
                50.7479095,
                30.8506952
              ],
              [
                50.7481863,
                30.8490255
              ],
              [
                50.7479094,
                30.8487456
              ],
              [
                50.7467962,
                30.8465253
              ],
              [
                50.743743,
                30.8376441
              ],
              [
                50.7434629,
                30.8340247
              ],
              [
                50.7431863,
                30.8337539
              ],
              [
                50.7417258,
                30.8327732
              ],
              [
                50.741243,
                30.832364
              ],
              [
                50.7329098,
                30.827084
              ],
              [
                50.7298532,
                30.8262446
              ],
              [
                50.7270732,
                30.8262446
              ],
              [
                50.7265198,
                30.8265244
              ],
              [
                50.7184633,
                30.8265243
              ],
              [
                50.7167966,
                30.8262445
              ],
              [
                50.7116222,
                30.8258502
              ],
              [
                50.7095734,
                30.825694
              ],
              [
                50.696517,
                30.822914
              ],
              [
                50.685407,
                30.8173632
              ],
              [
                50.6717939,
                30.8029133
              ],
              [
                50.6687371,
                30.8009728
              ],
              [
                50.6642941,
                30.8001334
              ],
              [
                50.659571,
                30.8001334
              ],
              [
                50.6559608,
                30.8001334
              ],
              [
                50.6545709,
                30.7998536
              ],
              [
                50.6434609,
                30.7984727
              ],
              [
                50.6434609,
                30.7981929
              ],
              [
                50.6370714,
                30.792922
              ],
              [
                50.6365144,
                30.7884724
              ],
              [
                50.643738,
                30.7740317
              ],
              [
                50.6437379,
                30.7731923
              ],
              [
                50.6451279,
                30.7695821
              ],
              [
                50.6495709,
                30.7473527
              ],
              [
                50.652071,
                30.7412517
              ],
              [
                50.6567945,
                30.7343022
              ],
              [
                50.6598508,
                30.7306921
              ],
              [
                50.6604044,
                30.7301326
              ],
              [
                50.6692944,
                30.7184721
              ],
              [
                50.6759608,
                30.7104126
              ],
              [
                50.6772232,
                30.7069767
              ],
              [
                50.6809607,
                30.6968028
              ],
              [
                50.6795743,
                30.6873536
              ],
              [
                50.676241,
                30.6834728
              ],
              [
                50.6748508,
                30.6829132
              ],
              [
                50.6748508,
                30.6826335
              ],
              [
                50.675961,
                30.6806931
              ],
              [
                50.6862409,
                30.667634
              ],
              [
                50.6920738,
                30.6559739
              ],
              [
                50.6967973,
                30.6484653
              ],
              [
                50.7009638,
                30.6379152
              ],
              [
                50.7061055,
                30.6223633
              ],
              [
                50.7062406,
                30.6226364
              ],
              [
                50.7067971,
                30.6229161
              ],
              [
                50.7101304,
                30.6267969
              ],
              [
                50.7115172,
                30.6287461
              ],
              [
                50.7120738,
                30.6298562
              ],
              [
                50.7120738,
                30.6315258
              ],
              [
                50.712907,
                30.6348559
              ],
              [
                50.7167969,
                30.6395758
              ],
              [
                50.7190203,
                30.6404152
              ],
              [
                50.720407,
                30.6404152
              ],
              [
                50.7212401,
                30.6406859
              ],
              [
                50.7223535,
                30.6398557
              ],
              [
                50.7329101,
                30.6368052
              ],
              [
                50.7337434,
                30.6365255
              ],
              [
                50.7359633,
                30.6365255
              ],
              [
                50.7406866,
                30.638186
              ],
              [
                50.7420767,
                30.6390254
              ],
              [
                50.7448533,
                30.6401354
              ],
              [
                50.7459631,
                30.6409657
              ],
              [
                50.7470766,
                30.6412455
              ],
              [
                50.7476297,
                30.641796
              ],
              [
                50.7487432,
                30.641796
              ],
              [
                50.7518,
                30.6426352
              ],
              [
                50.7542998,
                30.6426353
              ],
              [
                50.7548531,
                30.6423555
              ],
              [
                50.758743,
                30.6423555
              ],
              [
                50.7629097,
                30.642906
              ],
              [
                50.7634663,
                30.6431858
              ],
              [
                50.7645763,
                30.6431858
              ],
              [
                50.7654095,
                30.6434656
              ],
              [
                50.7717995,
                30.6434655
              ],
              [
                50.7770761,
                30.6395759
              ],
              [
                50.7798561,
                30.6379154
              ],
              [
                50.7929126,
                30.6331955
              ],
              [
                50.7948558,
                30.6323561
              ],
              [
                50.8270787,
                30.6212467
              ],
              [
                50.8279121,
                30.6212467
              ],
              [
                50.8437452,
                30.611798
              ],
              [
                50.844582,
                30.6112475
              ],
              [
                50.8448586,
                30.6112474
              ],
              [
                50.8476352,
                30.6112475
              ],
              [
                50.8481918,
                30.6115272
              ],
              [
                50.8506919,
                30.612908
              ],
              [
                50.8740247,
                30.6365257
              ],
              [
                50.8745813,
                30.6373559
              ],
              [
                50.8795812,
                30.6406861
              ],
              [
                50.8818047,
                30.6415254
              ],
              [
                50.8851379,
                30.6423557
              ],
              [
                50.8890278,
                30.6423557
              ],
              [
                50.917084,
                30.6290261
              ],
              [
                50.9226408,
                30.626797
              ],
              [
                50.9273606,
                30.6254073
              ],
              [
                50.9437504,
                30.6240265
              ],
              [
                50.9456971,
                30.6242972
              ],
              [
                50.9473637,
                30.625687
              ],
              [
                50.9473637,
                30.6267971
              ],
              [
                50.9468071,
                30.6273566
              ],
              [
                50.9468071,
                30.6279071
              ],
              [
                50.9334738,
                30.6395761
              ],
              [
                50.9259741,
                30.6445758
              ],
              [
                50.9184708,
                30.652635
              ],
              [
                50.9173608,
                30.6559741
              ],
              [
                50.917084,
                30.6565247
              ],
              [
                50.9204173,
                30.6651344
              ],
              [
                50.924584,
                30.670414
              ],
              [
                50.9293073,
                30.6737532
              ],
              [
                50.9412503,
                30.6790238
              ],
              [
                50.9431969,
                30.6798631
              ],
              [
                50.9445836,
                30.6798631
              ],
              [
                50.9454169,
                30.6801338
              ],
              [
                50.9493069,
                30.6798631
              ],
              [
                50.9545835,
                30.6781936
              ],
              [
                50.9887531,
                30.6495757
              ],
              [
                50.9893098,
                30.6484656
              ],
              [
                50.9915298,
                30.6465252
              ],
              [
                50.9995861,
                30.642076
              ],
              [
                51.0279226,
                30.6137475
              ],
              [
                51.0284758,
                30.6134677
              ],
              [
                51.0554222,
                30.5954096
              ],
              [
                51.0884783,
                30.5856902
              ],
              [
                51.0901485,
                30.5856902
              ],
              [
                51.0920917,
                30.5854105
              ],
              [
                51.0926483,
                30.5856902
              ],
              [
                51.0970915,
                30.5856902
              ],
              [
                51.0976482,
                30.58597
              ],
              [
                51.099035,
                30.5859699
              ],
              [
                51.0993148,
                30.5862498
              ],
              [
                51.1009814,
                30.5865205
              ],
              [
                51.1068148,
                30.5862497
              ],
              [
                51.1076482,
                30.5865204
              ],
              [
                51.1087579,
                30.5865205
              ],
              [
                51.1095914,
                30.5865205
              ],
              [
                51.1109815,
                30.5865205
              ],
              [
                51.111258,
                30.5868002
              ],
              [
                51.1123714,
                30.5868003
              ],
              [
                51.1129247,
                30.58708
              ],
              [
                51.1145913,
                30.58708
              ],
              [
                51.1148713,
                30.5873598
              ],
              [
                51.1159813,
                30.5873598
              ],
              [
                51.116258,
                30.5876395
              ],
              [
                51.1201478,
                30.58819
              ],
              [
                51.1218859,
                30.589423
              ],
              [
                51.1266709,
                30.5927478
              ],
              [
                51.1355668,
                30.5955365
              ],
              [
                51.1369616,
                30.5986025
              ],
              [
                51.1427766,
                30.6082802
              ],
              [
                51.1532304,
                30.6179181
              ],
              [
                51.1595819,
                30.6261167
              ],
              [
                51.1618173,
                30.6287467
              ],
              [
                51.1770937,
                30.6493051
              ],
              [
                51.1773736,
                30.6498557
              ],
              [
                51.1805821,
                30.6529407
              ],
              [
                51.184466,
                30.656208
              ],
              [
                51.1877061,
                30.6605826
              ],
              [
                51.1888862,
                30.6661198
              ],
              [
                51.1934294,
                30.6736349
              ],
              [
                51.1847814,
                30.6760414
              ],
              [
                51.1686238,
                30.6809872
              ],
              [
                51.16268,
                30.6819284
              ],
              [
                51.1554273,
                30.6818038
              ],
              [
                51.1515374,
                30.682634
              ],
              [
                51.1423707,
                30.6859733
              ],
              [
                51.1420942,
                30.6865237
              ],
              [
                51.1409807,
                30.6870833
              ],
              [
                51.1276476,
                30.7004133
              ],
              [
                51.098758,
                30.7168029
              ],
              [
                51.0843116,
                30.724023
              ],
              [
                51.0757017,
                30.7306926
              ],
              [
                51.0754251,
                30.7309724
              ],
              [
                51.0693311,
                30.7395796
              ],
              [
                51.0734272,
                30.7464164
              ],
              [
                51.0772227,
                30.753003
              ],
              [
                51.0849989,
                30.7662892
              ],
              [
                51.0835368,
                30.7793673
              ],
              [
                51.0825077,
                30.7885708
              ],
              [
                51.0820483,
                30.8028977
              ],
              [
                51.0790443,
                30.8094588
              ],
              [
                51.0713195,
                30.8196314
              ],
              [
                51.0624789,
                30.8279602
              ],
              [
                51.0440683,
                30.842405
              ],
              [
                51.0253786,
                30.8645656
              ],
              [
                51.0151863,
                30.8727247
              ],
              [
                51.0107989,
                30.8783589
              ],
              [
                51.0069036,
                30.8792074
              ],
              [
                51.002729,
                30.879548
              ],
              [
                50.9981918,
                30.8809569
              ],
              [
                50.9961283,
                30.8809942
              ],
              [
                50.9907678,
                30.8788344
              ],
              [
                50.9885681,
                30.8790785
              ],
              [
                50.9869499,
                30.8787623
              ],
              [
                50.9828992,
                30.8778431
              ],
              [
                50.9798376,
                30.879311
              ],
              [
                50.9749343,
                30.8795443
              ],
              [
                50.9727898,
                30.8796197
              ],
              [
                50.9714244,
                30.8804863
              ],
              [
                50.9684322,
                30.8821822
              ],
              [
                50.9674462,
                30.8830881
              ],
              [
                50.9654995,
                30.8816701
              ],
              [
                50.9630125,
                30.8807826
              ],
              [
                50.9610005,
                30.8800643
              ],
              [
                50.9580666,
                30.8791306
              ],
              [
                50.9574437,
                30.8786917
              ],
              [
                50.9520149,
                30.8755794
              ],
              [
                50.9453759,
                30.8752444
              ],
              [
                50.9393104,
                30.874613
              ],
              [
                50.9359126,
                30.8742442
              ],
              [
                50.9293715,
                30.8742865
              ],
              [
                50.9253503,
                30.8717821
              ],
              [
                50.9244811,
                30.8688137
              ],
              [
                50.9195911,
                30.8659519
              ],
              [
                50.9163839,
                30.8644049
              ],
              [
                50.9123094,
                30.8642539
              ],
              [
                50.9100809,
                30.8616015
              ],
              [
                50.9077671,
                30.8613841
              ],
              [
                50.9067847,
                30.8607577
              ],
              [
                50.9053266,
                30.8601379
              ],
              [
                50.9021126,
                30.8594468
              ],
              [
                50.8981941,
                30.8584757
              ],
              [
                50.8593011,
                30.8881978
              ],
              [
                50.8590246,
                30.8884776
              ],
              [
                50.7937454,
                30.9515337
              ],
              [
                50.7936298,
                30.95161
              ],
              [
                50.7929122,
                30.9520843
              ],
              [
                50.7867987,
                30.9565252
              ],
              [
                50.7856889,
                30.9576444
              ],
              [
                50.7231863,
                30.9959701
              ],
              [
                50.719573,
                30.9993098
              ],
              [
                50.7162397,
                31.00209
              ],
              [
                50.6979065,
                31.0129217
              ],
              [
                50.6940166,
                31.0143118
              ],
              [
                50.6931834,
                31.0143118
              ],
              [
                50.6929068,
                31.0145916
              ],
              [
                50.6920732,
                31.0145916
              ],
              [
                50.6881833,
                31.0170829
              ],
              [
                50.6879067,
                31.0173627
              ],
              [
                50.6876267,
                31.0170829
              ],
              [
                50.6792937,
                31.0120822
              ],
              [
                50.6776268,
                31.0118114
              ],
              [
                50.6773503,
                31.0120821
              ],
              [
                50.6762405,
                31.0120822
              ],
              [
                50.674017,
                31.0137521
              ],
              [
                50.674017,
                31.0143117
              ],
              [
                50.6642938,
                31.0201428
              ],
              [
                50.6629039,
                31.0201429
              ],
              [
                50.6626269,
                31.0204226
              ],
              [
                50.658737,
                31.0204226
              ],
              [
                50.6581838,
                31.0201428
              ],
              [
                50.6565171,
                31.0201428
              ],
              [
                50.6559604,
                31.019863
              ],
              [
                50.6534607,
                31.0195923
              ],
              [
                50.650404,
                31.0195922
              ],
              [
                50.6498474,
                31.0193124
              ],
              [
                50.647904,
                31.0193124
              ],
              [
                50.6429039,
                31.0173626
              ],
              [
                50.6420707,
                31.0173626
              ],
              [
                50.6365139,
                31.0126418
              ],
              [
                50.636514,
                31.0120821
              ],
              [
                50.6326241,
                31.0051408
              ],
              [
                50.6320709,
                31.0029203
              ],
              [
                50.630681,
                30.9995896
              ],
              [
                50.6362374,
                30.9948688
              ],
              [
                50.6428318,
                30.9837521
              ],
              [
                50.6459607,
                30.9784769
              ],
              [
                50.6462373,
                30.9781971
              ],
              [
                50.6470709,
                30.9748664
              ],
              [
                50.6473475,
                30.9745866
              ],
              [
                50.646794,
                30.9701366
              ],
              [
                50.6456806,
                30.9679162
              ],
              [
                50.6398477,
                30.9629155
              ],
              [
                50.6392942,
                30.9626358
              ],
              [
                50.6392941,
                30.9623649
              ],
              [
                50.6359574,
                30.956525
              ],
              [
                50.6337379,
                30.9481938
              ],
              [
                50.6245713,
                30.9373623
              ],
              [
                50.6240146,
                30.9373624
              ],
              [
                50.618738,
                30.9340317
              ],
              [
                50.6179048,
                30.9337519
              ],
              [
                50.6126246,
                30.9301415
              ],
              [
                50.6070678,
                30.9234712
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555294,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گچساران",
          "name:ar": "مقاطعة غشساران",
          "name:en": "Gachsaran County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1278063",
          "wikipedia": "en:Gachsaran County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.5096484,
                30.2172528
              ],
              [
                50.5099449,
                30.2102805
              ],
              [
                50.510002,
                30.2058295
              ],
              [
                50.5103415,
                30.2024422
              ],
              [
                50.5108339,
                30.198866
              ],
              [
                50.5114821,
                30.1951956
              ],
              [
                50.5123368,
                30.1908762
              ],
              [
                50.5143279,
                30.1838988
              ],
              [
                50.5155563,
                30.1798966
              ],
              [
                50.5169868,
                30.1752928
              ],
              [
                50.5180168,
                30.1725464
              ],
              [
                50.5198137,
                30.1677048
              ],
              [
                50.520584,
                30.1655169
              ],
              [
                50.5143547,
                30.1660513
              ],
              [
                50.5138933,
                30.1660606
              ],
              [
                50.5148699,
                30.1616618
              ],
              [
                50.5353206,
                30.1531104
              ],
              [
                50.560476,
                30.1467128
              ],
              [
                50.5612367,
                30.1462292
              ],
              [
                50.5654032,
                30.1440098
              ],
              [
                50.5717901,
                30.137902
              ],
              [
                50.5745697,
                30.1328949
              ],
              [
                50.5754033,
                30.1306755
              ],
              [
                50.5762366,
                30.1281765
              ],
              [
                50.5765131,
                30.1273465
              ],
              [
                50.5767897,
                30.1259571
              ],
              [
                50.5770698,
                30.1253977
              ],
              [
                50.5767897,
                30.1245677
              ],
              [
                50.5754034,
                30.1137325
              ],
              [
                50.5748464,
                30.1126229
              ],
              [
                50.5626235,
                30.0992888
              ],
              [
                50.5604001,
                30.0981791
              ],
              [
                50.5595668,
                30.0973401
              ],
              [
                50.5587336,
                30.0970694
              ],
              [
                50.5573468,
                30.0959598
              ],
              [
                50.5481803,
                30.0898431
              ],
              [
                50.5476236,
                30.0890131
              ],
              [
                50.5448471,
                30.0856752
              ],
              [
                50.5426235,
                30.0823462
              ],
              [
                50.5392903,
                30.0731804
              ],
              [
                50.5276242,
                30.0203966
              ],
              [
                50.5279008,
                30.0181774
              ],
              [
                50.5281773,
                30.0173475
              ],
              [
                50.5284574,
                30.0153989
              ],
              [
                50.5284574,
                30.01456
              ],
              [
                50.5290105,
                30.0120611
              ],
              [
                50.5298441,
                30.0098419
              ],
              [
                50.5320673,
                30.0040143
              ],
              [
                50.5323438,
                30.0031753
              ],
              [
                50.5326239,
                30.0017862
              ],
              [
                50.5348204,
                29.992891
              ],
              [
                50.535124,
                29.9917909
              ],
              [
                50.5340107,
                29.9790083
              ],
              [
                50.5342908,
                29.9762298
              ],
              [
                50.5356775,
                29.9726215
              ],
              [
                50.5387338,
                29.9670647
              ],
              [
                50.5392905,
                29.966785
              ],
              [
                50.539844,
                29.9659551
              ],
              [
                50.5554006,
                29.9490142
              ],
              [
                50.5556802,
                29.9478957
              ],
              [
                50.5629039,
                29.934013
              ],
              [
                50.5687368,
                29.9281767
              ],
              [
                50.569847,
                29.9270582
              ],
              [
                50.5737369,
                29.9245595
              ],
              [
                50.5748467,
                29.9245596
              ],
              [
                50.5754037,
                29.9248392
              ],
              [
                50.5762369,
                29.9248392
              ],
              [
                50.5781803,
                29.9253984
              ],
              [
                50.5792901,
                29.9262284
              ],
              [
                50.5851269,
                29.9292863
              ],
              [
                50.6026265,
                29.9420685
              ],
              [
                50.602903,
                29.9434486
              ],
              [
                50.6031831,
                29.9437282
              ],
              [
                50.609293,
                29.952343
              ],
              [
                50.6112364,
                29.954562
              ],
              [
                50.6126263,
                29.9573404
              ],
              [
                50.614293,
                29.9576201
              ],
              [
                50.6151262,
                29.9573404
              ],
              [
                50.6159594,
                29.9601188
              ],
              [
                50.6167927,
                29.9601188
              ],
              [
                50.6173493,
                29.9603985
              ],
              [
                50.6187396,
                29.9603984
              ],
              [
                50.6201259,
                29.9598392
              ],
              [
                50.6215162,
                29.9598392
              ],
              [
                50.6217928,
                29.9603984
              ],
              [
                50.6223495,
                29.9606781
              ],
              [
                50.622626,
                29.9620674
              ],
              [
                50.6223495,
                29.962338
              ],
              [
                50.6220728,
                29.9631769
              ],
              [
                50.622626,
                29.9640067
              ],
              [
                50.6229062,
                29.9642864
              ],
              [
                50.6234592,
                29.9648457
              ],
              [
                50.6242928,
                29.9651254
              ],
              [
                50.6245729,
                29.9648457
              ],
              [
                50.6254062,
                29.9648456
              ],
              [
                50.6259592,
                29.9645661
              ],
              [
                50.6273495,
                29.9659552
              ],
              [
                50.6304058,
                29.9704025
              ],
              [
                50.6337395,
                29.9712324
              ],
              [
                50.635959,
                29.9712325
              ],
              [
                50.6365157,
                29.9709528
              ],
              [
                50.637906,
                29.971512
              ],
              [
                50.6429056,
                29.9770599
              ],
              [
                50.6459624,
                29.9787288
              ],
              [
                50.6479057,
                29.9778989
              ],
              [
                50.6498491,
                29.9773395
              ],
              [
                50.6515156,
                29.9773396
              ],
              [
                50.6545723,
                29.9767893
              ],
              [
                50.6559622,
                29.9778989
              ],
              [
                50.660129,
                29.9801179
              ],
              [
                50.6609622,
                29.9792881
              ],
              [
                50.6670721,
                29.9767893
              ],
              [
                50.6781852,
                29.9892832
              ],
              [
                50.6787419,
                29.9898425
              ],
              [
                50.6834618,
                29.9940102
              ],
              [
                50.6837419,
                29.9945605
              ],
              [
                50.6865185,
                29.9956701
              ],
              [
                50.686795,
                29.9959588
              ],
              [
                50.6954085,
                29.9959588
              ],
              [
                50.697075,
                29.9956701
              ],
              [
                50.7037415,
                29.9956701
              ],
              [
                50.7090181,
                29.9953995
              ],
              [
                50.7098513,
                29.9951198
              ],
              [
                50.7126315,
                29.9951198
              ],
              [
                50.7137412,
                29.9948402
              ],
              [
                50.7170748,
                29.9948402
              ],
              [
                50.7220746,
                29.9934509
              ],
              [
                50.7329111,
                29.9912318
              ],
              [
                50.7342977,
                29.9909522
              ],
              [
                50.7543008,
                29.992621
              ],
              [
                50.7568009,
                29.9926211
              ],
              [
                50.7581874,
                29.9923414
              ],
              [
                50.7593007,
                29.9923414
              ],
              [
                50.7598541,
                29.9920618
              ],
              [
                50.7612441,
                29.9920618
              ],
              [
                50.7829103,
                29.9842858
              ],
              [
                50.7837438,
                29.9840151
              ],
              [
                50.7951336,
                29.9776194
              ],
              [
                50.8073567,
                29.9715123
              ],
              [
                50.8162465,
                29.967065
              ],
              [
                50.8234698,
                29.964846
              ],
              [
                50.8337462,
                29.9634567
              ],
              [
                50.8354129,
                29.9634568
              ],
              [
                50.8365264,
                29.9631771
              ],
              [
                50.8465261,
                29.9656759
              ],
              [
                50.8604158,
                29.9737315
              ],
              [
                50.8648591,
                29.9812278
              ],
              [
                50.864859,
                29.9817871
              ],
              [
                50.8648545,
                29.9818216
              ],
              [
                50.8626393,
                29.9987284
              ],
              [
                50.8665257,
                30.0051243
              ],
              [
                50.8668058,
                30.0056746
              ],
              [
                50.8745823,
                30.0095626
              ],
              [
                50.8870821,
                30.0145604
              ],
              [
                50.8881954,
                30.014849
              ],
              [
                50.897362,
                30.0248444
              ],
              [
                50.9031953,
                30.03484
              ],
              [
                50.9045853,
                30.0373388
              ],
              [
                50.9159717,
                30.0584487
              ],
              [
                50.919585,
                30.0662342
              ],
              [
                50.9229182,
                30.0840066
              ],
              [
                50.9226416,
                30.0848456
              ],
              [
                50.9223616,
                30.0890136
              ],
              [
                50.9223616,
                30.0898435
              ],
              [
                50.9220848,
                30.0904029
              ],
              [
                50.9218082,
                30.0923426
              ],
              [
                50.9215281,
                30.0937319
              ],
              [
                50.9218082,
                30.1012288
              ],
              [
                50.9245848,
                30.1126233
              ],
              [
                50.9248614,
                30.1151223
              ],
              [
                50.9354179,
                30.1359537
              ],
              [
                50.9370846,
                30.1395716
              ],
              [
                50.9373611,
                30.1398422
              ],
              [
                50.9373611,
                30.1401218
              ],
              [
                50.9390314,
                30.1412316
              ],
              [
                50.9393078,
                30.1417909
              ],
              [
                50.9398645,
                30.1420616
              ],
              [
                50.9559742,
                30.1559554
              ],
              [
                50.9579209,
                30.1567855
              ],
              [
                50.9606975,
                30.1579042
              ],
              [
                50.9806972,
                30.1670707
              ],
              [
                50.989587,
                30.176237
              ],
              [
                50.9903616,
                30.1763437
              ],
              [
                50.9915304,
                30.1767965
              ],
              [
                50.994867,
                30.1767965
              ],
              [
                50.9962536,
                30.1762372
              ],
              [
                50.9987536,
                30.173738
              ],
              [
                50.9987536,
                30.1734583
              ],
              [
                50.9998532,
                30.1734583
              ],
              [
                51.0132002,
                30.1787363
              ],
              [
                51.0134768,
                30.179016
              ],
              [
                51.0140334,
                30.179016
              ],
              [
                51.01431,
                30.1792957
              ],
              [
                51.0154234,
                30.1792956
              ],
              [
                51.0165335,
                30.1795663
              ],
              [
                51.0201433,
                30.1823452
              ],
              [
                51.0234765,
                30.1840143
              ],
              [
                51.0245899,
                30.1826249
              ],
              [
                51.0248666,
                30.1817948
              ],
              [
                51.0259766,
                30.178186
              ],
              [
                51.0270899,
                30.1773469
              ],
              [
                51.0279233,
                30.1773469
              ],
              [
                51.0281998,
                30.1770672
              ],
              [
                51.0304232,
                30.1770672
              ],
              [
                51.0309765,
                30.1773469
              ],
              [
                51.0320897,
                30.1809557
              ],
              [
                51.0326431,
                30.1809557
              ],
              [
                51.034313,
                30.1792957
              ],
              [
                51.0381997,
                30.1795664
              ],
              [
                51.0418131,
                30.1820655
              ],
              [
                51.041813,
                30.1823451
              ],
              [
                51.0426464,
                30.1823452
              ],
              [
                51.042923,
                30.1826249
              ],
              [
                51.044313,
                30.1826248
              ],
              [
                51.044313,
                30.1823452
              ],
              [
                51.0448661,
                30.1823452
              ],
              [
                51.0462562,
                30.1809558
              ],
              [
                51.0501462,
                30.1809557
              ],
              [
                51.050423,
                30.1806761
              ],
              [
                51.0523695,
                30.1817948
              ],
              [
                51.0529227,
                30.1840144
              ],
              [
                51.0532029,
                30.1845736
              ],
              [
                51.0529228,
                30.1848534
              ],
              [
                51.0526462,
                30.1865134
              ],
              [
                51.0529227,
                30.1870728
              ],
              [
                51.0532028,
                30.189572
              ],
              [
                51.0557029,
                30.190402
              ],
              [
                51.0559795,
                30.1901224
              ],
              [
                51.0570894,
                30.1901223
              ],
              [
                51.0576461,
                30.1898427
              ],
              [
                51.0612559,
                30.1915118
              ],
              [
                51.0623694,
                30.1954003
              ],
              [
                51.062646,
                30.1959598
              ],
              [
                51.0623694,
                30.1962394
              ],
              [
                51.0629225,
                30.1973492
              ],
              [
                51.0634794,
                30.1984589
              ],
              [
                51.0662558,
                30.2003987
              ],
              [
                51.0754259,
                30.2003987
              ],
              [
                51.0765359,
                30.200128
              ],
              [
                51.0801457,
                30.1990093
              ],
              [
                51.0820924,
                30.1990093
              ],
              [
                51.0851456,
                30.1995687
              ],
              [
                51.085979,
                30.1998483
              ],
              [
                51.0868122,
                30.1978996
              ],
              [
                51.0873689,
                30.19402
              ],
              [
                51.0884789,
                30.1934606
              ],
              [
                51.090149,
                30.1915118
              ],
              [
                51.0920922,
                30.1909524
              ],
              [
                51.0945923,
                30.1909525
              ],
              [
                51.0965355,
                30.1951297
              ],
              [
                51.0962589,
                30.1962394
              ],
              [
                51.0957022,
                30.1973492
              ],
              [
                51.1004254,
                30.1995686
              ],
              [
                51.1040354,
                30.1970695
              ],
              [
                51.1034821,
                30.1901224
              ],
              [
                51.1040355,
                30.1890127
              ],
              [
                51.1045921,
                30.1876232
              ],
              [
                51.1065353,
                30.1876232
              ],
              [
                51.1076488,
                30.1879029
              ],
              [
                51.1079253,
                30.1881826
              ],
              [
                51.1090387,
                30.1881826
              ],
              [
                51.1182052,
                30.1990093
              ],
              [
                51.1201484,
                30.2006784
              ],
              [
                51.1209819,
                30.2006785
              ],
              [
                51.1215385,
                30.2009582
              ],
              [
                51.1270917,
                30.2009582
              ],
              [
                51.129315,
                30.199289
              ],
              [
                51.1309816,
                30.1992891
              ],
              [
                51.1337617,
                30.2006785
              ],
              [
                51.134595,
                30.2012379
              ],
              [
                51.1345949,
                30.2020679
              ],
              [
                51.1343149,
                30.2026273
              ],
              [
                51.1348715,
                30.2031867
              ],
              [
                51.1365382,
                30.203737
              ],
              [
                51.1368149,
                30.2040168
              ],
              [
                51.1373716,
                30.2040168
              ],
              [
                51.138205,
                30.2056858
              ],
              [
                51.138205,
                30.2062362
              ],
              [
                51.137095,
                30.2067956
              ],
              [
                51.1354284,
                30.2067957
              ],
              [
                51.1351482,
                30.2065159
              ],
              [
                51.1340383,
                30.2065159
              ],
              [
                51.1334816,
                30.2067956
              ],
              [
                51.131815,
                30.2067957
              ],
              [
                51.1304283,
                30.207346
              ],
              [
                51.1320951,
                30.2092948
              ],
              [
                51.1423714,
                30.2156827
              ],
              [
                51.1482616,
                30.2140891
              ],
              [
                51.1473713,
                30.2126241
              ],
              [
                51.1470948,
                30.2106843
              ],
              [
                51.1487614,
                30.2076257
              ],
              [
                51.1509846,
                30.2076257
              ],
              [
                51.1518181,
                30.2079054
              ],
              [
                51.1523712,
                30.2079054
              ],
              [
                51.1532046,
                30.2081851
              ],
              [
                51.1537613,
                30.2084558
              ],
              [
                51.1545946,
                30.2087355
              ],
              [
                51.1551514,
                30.2095655
              ],
              [
                51.1584846,
                30.2092948
              ],
              [
                51.1593178,
                30.2090152
              ],
              [
                51.1626512,
                30.2090151
              ],
              [
                51.1693178,
                30.2120647
              ],
              [
                51.1779276,
                30.2062363
              ],
              [
                51.1820942,
                30.2079054
              ],
              [
                51.1832077,
                30.2092948
              ],
              [
                51.1832076,
                30.2098453
              ],
              [
                51.1836495,
                30.2105155
              ],
              [
                51.178761,
                30.2159624
              ],
              [
                51.1779276,
                30.2167924
              ],
              [
                51.1718176,
                30.22263
              ],
              [
                51.1223718,
                30.2587381
              ],
              [
                51.0887588,
                30.2854093
              ],
              [
                51.0862587,
                30.2876289
              ],
              [
                51.069869,
                30.3040145
              ],
              [
                51.0222101,
                30.3778851
              ],
              [
                51.0220897,
                30.3781847
              ],
              [
                51.0220897,
                30.3784644
              ],
              [
                51.0104197,
                30.3948509
              ],
              [
                51.00181,
                30.4026291
              ],
              [
                51.00181,
                30.4023494
              ],
              [
                50.9998666,
                30.4056881
              ],
              [
                50.9615305,
                30.4340222
              ],
              [
                50.9595871,
                30.436242
              ],
              [
                50.9004144,
                30.490412
              ],
              [
                50.8818049,
                30.5062492
              ],
              [
                50.8759715,
                30.5092993
              ],
              [
                50.8751383,
                30.5098588
              ],
              [
                50.8745815,
                30.5098588
              ],
              [
                50.873825,
                30.5102339
              ],
              [
                50.8581917,
                30.5206877
              ],
              [
                50.8554151,
                30.529017
              ],
              [
                50.8473587,
                30.5437446
              ],
              [
                50.8329121,
                30.5618022
              ],
              [
                50.8323588,
                30.5623527
              ],
              [
                50.8276354,
                30.5668018
              ],
              [
                50.8190221,
                30.5737415
              ],
              [
                50.8151357,
                30.5770715
              ],
              [
                50.8101357,
                30.5801307
              ],
              [
                50.8098558,
                30.5806903
              ],
              [
                50.8087458,
                30.5812498
              ],
              [
                50.8051324,
                30.5848506
              ],
              [
                50.8034659,
                30.5890199
              ],
              [
                50.8048557,
                30.5906895
              ],
              [
                50.8431919,
                30.6101374
              ],
              [
                50.8434685,
                30.610688
              ],
              [
                50.844582,
                30.6112475
              ],
              [
                50.8437452,
                30.611798
              ],
              [
                50.8279121,
                30.6212467
              ],
              [
                50.8270787,
                30.6212467
              ],
              [
                50.7948558,
                30.6323561
              ],
              [
                50.7929126,
                30.6331955
              ],
              [
                50.7798561,
                30.6379154
              ],
              [
                50.7770761,
                30.6395759
              ],
              [
                50.7717995,
                30.6434655
              ],
              [
                50.7654095,
                30.6434656
              ],
              [
                50.7645763,
                30.6431858
              ],
              [
                50.7634663,
                30.6431858
              ],
              [
                50.7629097,
                30.642906
              ],
              [
                50.758743,
                30.6423555
              ],
              [
                50.7548531,
                30.6423555
              ],
              [
                50.7542998,
                30.6426353
              ],
              [
                50.7518,
                30.6426352
              ],
              [
                50.7487432,
                30.641796
              ],
              [
                50.7476297,
                30.641796
              ],
              [
                50.7470766,
                30.6412455
              ],
              [
                50.7459631,
                30.6409657
              ],
              [
                50.7448533,
                30.6401354
              ],
              [
                50.7420767,
                30.6390254
              ],
              [
                50.7406866,
                30.638186
              ],
              [
                50.7359633,
                30.6365255
              ],
              [
                50.7337434,
                30.6365255
              ],
              [
                50.7329101,
                30.6368052
              ],
              [
                50.7223535,
                30.6398557
              ],
              [
                50.7212401,
                30.6406859
              ],
              [
                50.720407,
                30.6404152
              ],
              [
                50.7190203,
                30.6404152
              ],
              [
                50.7167969,
                30.6395758
              ],
              [
                50.712907,
                30.6348559
              ],
              [
                50.7120738,
                30.6315258
              ],
              [
                50.7120738,
                30.6298562
              ],
              [
                50.7115172,
                30.6287461
              ],
              [
                50.7101304,
                30.6267969
              ],
              [
                50.7067971,
                30.6229161
              ],
              [
                50.7062406,
                30.6226364
              ],
              [
                50.7061055,
                30.6223633
              ],
              [
                50.7054072,
                30.6215264
              ],
              [
                50.7034639,
                30.6165177
              ],
              [
                50.7023506,
                30.6151279
              ],
              [
                50.6959642,
                30.6104171
              ],
              [
                50.6917941,
                30.6117978
              ],
              [
                50.6881839,
                30.6115271
              ],
              [
                50.6876273,
                30.6109675
              ],
              [
                50.682351,
                30.6048579
              ],
              [
                50.6806842,
                30.6045781
              ],
              [
                50.6801275,
                30.6048579
              ],
              [
                50.677351,
                30.6051286
              ],
              [
                50.6762412,
                30.6054084
              ],
              [
                50.6754076,
                30.6054083
              ],
              [
                50.6742942,
                30.6056881
              ],
              [
                50.6741911,
                30.6055838
              ],
              [
                50.6740177,
                30.6054083
              ],
              [
                50.6720708,
                30.6054084
              ],
              [
                50.6698511,
                30.6045781
              ],
              [
                50.6687375,
                30.6045781
              ],
              [
                50.6684609,
                30.6042983
              ],
              [
                50.6676277,
                30.6042983
              ],
              [
                50.6673511,
                30.6040186
              ],
              [
                50.664571,
                30.6031883
              ],
              [
                50.6579045,
                30.5973494
              ],
              [
                50.6565177,
                30.5970786
              ],
              [
                50.6540146,
                30.5973494
              ],
              [
                50.6484614,
                30.5973494
              ],
              [
                50.6479048,
                30.5973494
              ],
              [
                50.647348,
                30.5973494
              ],
              [
                50.644848,
                30.5973493
              ],
              [
                50.6437382,
                30.5976291
              ],
              [
                50.6431816,
                30.5973494
              ],
              [
                50.6392948,
                30.5973494
              ],
              [
                50.6387382,
                30.5976291
              ],
              [
                50.6367948,
                30.5976291
              ],
              [
                50.635958,
                30.5973493
              ],
              [
                50.6295716,
                30.5965191
              ],
              [
                50.6281817,
                30.5959686
              ],
              [
                50.6273484,
                30.5959686
              ],
              [
                50.6270715,
                30.5956888
              ],
              [
                50.6262382,
                30.5956888
              ],
              [
                50.620405,
                30.5940283
              ],
              [
                50.6198483,
                30.594299
              ],
              [
                50.6195718,
                30.5940284
              ],
              [
                50.6187386,
                30.5942991
              ],
              [
                50.6173483,
                30.594299
              ],
              [
                50.6167916,
                30.5945788
              ],
              [
                50.6159585,
                30.5942991
              ],
              [
                50.6117919,
                30.593189
              ],
              [
                50.6106796,
                30.5919905
              ],
              [
                50.6081821,
                30.5892994
              ],
              [
                50.6070685,
                30.5854099
              ],
              [
                50.6062352,
                30.5831898
              ],
              [
                50.6059587,
                30.5826303
              ],
              [
                50.5981788,
                30.578461
              ],
              [
                50.5956788,
                30.5781903
              ],
              [
                50.5859591,
                30.5795801
              ],
              [
                50.583459,
                30.578461
              ],
              [
                50.5831789,
                30.5779105
              ],
              [
                50.5692892,
                30.5670721
              ],
              [
                50.5676224,
                30.5665217
              ],
              [
                50.5670693,
                30.5665216
              ],
              [
                50.5665127,
                30.5662419
              ],
              [
                50.5645693,
                30.5662419
              ],
              [
                50.5642892,
                30.5665217
              ],
              [
                50.563736,
                30.5665217
              ],
              [
                50.561236,
                30.5679114
              ],
              [
                50.5603992,
                30.5679114
              ],
              [
                50.5601227,
                30.5681912
              ],
              [
                50.5592895,
                30.5681912
              ],
              [
                50.5592894,
                30.5684709
              ],
              [
                50.557066,
                30.5676317
              ],
              [
                50.5509561,
                30.5631916
              ],
              [
                50.5495662,
                30.5626321
              ],
              [
                50.5495662,
                30.5630552
              ],
              [
                50.5491753,
                30.5628671
              ],
              [
                50.548542,
                30.562822
              ],
              [
                50.5472334,
                30.5630092
              ],
              [
                50.546238,
                30.5634253
              ],
              [
                50.5451851,
                30.563566
              ],
              [
                50.5443991,
                30.5635656
              ],
              [
                50.5434531,
                30.5632915
              ],
              [
                50.5426636,
                30.5628759
              ],
              [
                50.5419272,
                30.5622281
              ],
              [
                50.5411376,
                30.5613523
              ],
              [
                50.5406075,
                30.5600127
              ],
              [
                50.5404471,
                30.5589947
              ],
              [
                50.5403365,
                30.5583942
              ],
              [
                50.5402831,
                30.5579767
              ],
              [
                50.5402833,
                30.5577917
              ],
              [
                50.5401763,
                30.557471
              ],
              [
                50.5397034,
                30.5570091
              ],
              [
                50.5386008,
                30.5563172
              ],
              [
                50.5376549,
                30.5557611
              ],
              [
                50.5370752,
                30.5552988
              ],
              [
                50.5364419,
                30.5547935
              ],
              [
                50.5359192,
                30.5543314
              ],
              [
                50.5358125,
                30.5542859
              ],
              [
                50.5356027,
                30.5540055
              ],
              [
                50.5351792,
                30.5534535
              ],
              [
                50.5346528,
                30.5528064
              ],
              [
                50.53434,
                30.5523902
              ],
              [
                50.5341797,
                30.5519746
              ],
              [
                50.53397,
                30.5517437
              ],
              [
                50.5335663,
                30.5515232
              ],
              [
                50.5335502,
                30.5515143
              ],
              [
                50.5331802,
                30.5514205
              ],
              [
                50.5328161,
                30.5514853
              ],
              [
                50.5326578,
                30.5515134
              ],
              [
                50.5318183,
                30.5518826
              ],
              [
                50.530983,
                30.552394
              ],
              [
                50.5303535,
                30.5526714
              ],
              [
                50.5286752,
                30.552997
              ],
              [
                50.5281526,
                30.5529974
              ],
              [
                50.5277329,
                30.5528131
              ],
              [
                50.5275192,
                30.5523972
              ],
              [
                50.5273628,
                30.5517966
              ],
              [
                50.5270996,
                30.5509655
              ],
              [
                50.5269393,
                30.5499001
              ],
              [
                50.5269354,
                30.549485
              ],
              [
                50.5267864,
                30.5487614
              ],
              [
                50.5267256,
                30.5484668
              ],
              [
                50.5263556,
                30.5477729
              ],
              [
                50.5257797,
                30.5470805
              ],
              [
                50.5251463,
                30.5464803
              ],
              [
                50.5243074,
                30.5458795
              ],
              [
                50.523468,
                30.5452334
              ],
              [
                50.5226288,
                30.5446326
              ],
              [
                50.5213164,
                30.5438472
              ],
              [
                50.5202676,
                30.5433854
              ],
              [
                50.5193786,
                30.5432467
              ],
              [
                50.5188524,
                30.5430621
              ],
              [
                50.518013,
                30.5425559
              ],
              [
                50.5173341,
                30.5419533
              ],
              [
                50.5170173,
                30.5411219
              ],
              [
                50.5158616,
                30.5402424
              ],
              [
                50.5150758,
                30.5399665
              ],
              [
                50.5141333,
                30.5399675
              ],
              [
                50.513329,
                30.540057
              ],
              [
                50.5098436,
                30.5382292
              ],
              [
                50.5099944,
                30.5377953
              ],
              [
                50.5103606,
                30.5372868
              ],
              [
                50.5105172,
                30.5367776
              ],
              [
                50.5104638,
                30.5363149
              ],
              [
                50.5103074,
                30.5359917
              ],
              [
                50.5100976,
                30.535806
              ],
              [
                50.5093649,
                30.5358077
              ],
              [
                50.5085257,
                30.5358091
              ],
              [
                50.5079498,
                30.5356693
              ],
              [
                50.5076369,
                30.5355779
              ],
              [
                50.5075303,
                30.5352075
              ],
              [
                50.5075301,
                30.5347924
              ],
              [
                50.5076866,
                30.5341884
              ],
              [
                50.5077934,
                30.533679
              ],
              [
                50.5078429,
                30.5331716
              ],
              [
                50.5076333,
                30.5324782
              ],
              [
                50.5073205,
                30.5321093
              ],
              [
                50.5069543,
                30.5315981
              ],
              [
                50.5065878,
                30.5310891
              ],
              [
                50.5060119,
                30.5305816
              ],
              [
                50.5050162,
                30.5301672
              ],
              [
                50.5039711,
                30.5297955
              ],
              [
                50.5027657,
                30.5292405
              ],
              [
                50.5017205,
                30.5289658
              ],
              [
                50.500885,
                30.528455
              ],
              [
                50.500044,
                30.5281788
              ],
              [
                50.49905,
                30.5275749
              ],
              [
                50.4986838,
                30.527014
              ],
              [
                50.4980011,
                30.5266369
              ],
              [
                50.4973184,
                30.526632
              ],
              [
                50.4965857,
                30.5267646
              ],
              [
                50.4957074,
                30.5270764
              ],
              [
                50.4937305,
                30.5270764
              ],
              [
                50.4937305,
                30.5273561
              ],
              [
                50.4928969,
                30.5273561
              ],
              [
                50.4926203,
                30.5276359
              ],
              [
                50.4892871,
                30.5290166
              ],
              [
                50.486414,
                30.5279651
              ],
              [
                50.4809537,
                30.5259664
              ],
              [
                50.4799358,
                30.5260427
              ],
              [
                50.4791718,
                30.5261479
              ],
              [
                50.4782295,
                30.5263246
              ],
              [
                50.477703,
                30.5264128
              ],
              [
                50.4770735,
                30.5263155
              ],
              [
                50.4763411,
                30.5261682
              ],
              [
                50.4763044,
                30.5261648
              ],
              [
                50.4760299,
                30.5261395
              ],
              [
                50.4754325,
                30.5260846
              ],
              [
                50.4751207,
                30.5262371
              ],
              [
                50.4742872,
                30.5262371
              ],
              [
                50.470664,
                30.5271002
              ],
              [
                50.4665655,
                30.5280763
              ],
              [
                50.4626174,
                30.5290165
              ],
              [
                50.4618168,
                30.5291406
              ],
              [
                50.4600677,
                30.5298737
              ],
              [
                50.4579696,
                30.5304583
              ],
              [
                50.4564438,
                30.5308151
              ],
              [
                50.4552382,
                30.5310357
              ],
              [
                50.4537164,
                30.5312549
              ],
              [
                50.4524574,
                30.5312451
              ],
              [
                50.4515112,
                30.5312817
              ],
              [
                50.4502524,
                30.5313644
              ],
              [
                50.4486238,
                30.5316282
              ],
              [
                50.4477311,
                30.5317598
              ],
              [
                50.4468918,
                30.5320292
              ],
              [
                50.4460487,
                30.5324858
              ],
              [
                50.4446793,
                30.5334478
              ],
              [
                50.443947,
                30.5336274
              ],
              [
                50.4433669,
                30.5336655
              ],
              [
                50.4428939,
                30.5336635
              ],
              [
                50.4419518,
                30.5333775
              ],
              [
                50.4408531,
                30.532626
              ],
              [
                50.4394913,
                30.5319186
              ],
              [
                50.4388123,
                30.5315886
              ],
              [
                50.4381294,
                30.5313961
              ],
              [
                50.4374505,
                30.5313909
              ],
              [
                50.4362946,
                30.5314739
              ],
              [
                50.4353485,
                30.5316029
              ],
              [
                50.4345093,
                30.531782
              ],
              [
                50.4339828,
                30.5319625
              ],
              [
                50.4335098,
                30.5321431
              ],
              [
                50.4331932,
                30.5321869
              ],
              [
                50.4325675,
                30.5319495
              ],
              [
                50.4320947,
                30.5318076
              ],
              [
                50.4313089,
                30.5314297
              ],
              [
                50.430889,
                30.5311459
              ],
              [
                50.4291612,
                30.5309917
              ],
              [
                50.4279517,
                30.5312142
              ],
              [
                50.4264296,
                30.5312933
              ],
              [
                50.4245413,
                30.5312759
              ],
              [
                50.4237021,
                30.5311301
              ],
              [
                50.4202462,
                30.5300815
              ],
              [
                50.4169997,
                30.5291715
              ],
              [
                50.4155809,
                30.5291606
              ],
              [
                50.4105989,
                30.5287434
              ],
              [
                50.4071923,
                30.5285271
              ],
              [
                50.4034653,
                30.5284966
              ],
              [
                50.401947,
                30.5283904
              ],
              [
                50.4006882,
                30.5281003
              ],
              [
                50.3993264,
                30.5278121
              ],
              [
                50.3980178,
                30.5276143
              ],
              [
                50.3967662,
                30.5271928
              ],
              [
                50.3937797,
                30.5261869
              ],
              [
                50.3894348,
                30.5250364
              ],
              [
                50.387863,
                30.5247448
              ],
              [
                50.3870811,
                30.5244592
              ],
              [
                50.3866615,
                30.52427
              ],
              [
                50.3864555,
                30.524084
              ],
              [
                50.3864593,
                30.5235268
              ],
              [
                50.3865662,
                30.5231573
              ],
              [
                50.3868295,
                30.5229285
              ],
              [
                50.3875197,
                30.5221467
              ],
              [
                50.3889543,
                30.5198885
              ],
              [
                50.3911819,
                30.5168963
              ],
              [
                50.3934057,
                30.5137642
              ],
              [
                50.3943139,
                30.5119636
              ],
              [
                50.3968087,
                30.5076303
              ],
              [
                50.4003105,
                30.5019142
              ],
              [
                50.4012108,
                30.5001249
              ],
              [
                50.4044305,
                30.497613
              ],
              [
                50.4086954,
                30.493847
              ],
              [
                50.4132081,
                30.4882749
              ],
              [
                50.4162485,
                30.4840993
              ],
              [
                50.4185982,
                30.4803401
              ],
              [
                50.4202689,
                30.4777894
              ],
              [
                50.4220351,
                30.4743118
              ],
              [
                50.4241676,
                30.4700936
              ],
              [
                50.4260408,
                30.4666638
              ],
              [
                50.4285966,
                30.4628129
              ],
              [
                50.4303209,
                30.460402
              ],
              [
                50.4316786,
                30.4585468
              ],
              [
                50.4347039,
                30.4540932
              ],
              [
                50.4389838,
                30.4482958
              ],
              [
                50.4412308,
                30.4455126
              ],
              [
                50.4441069,
                30.4420801
              ],
              [
                50.4466629,
                30.4388807
              ],
              [
                50.4491238,
                30.4360099
              ],
              [
                50.4494857,
                30.4355877
              ],
              [
                50.4526215,
                30.4322936
              ],
              [
                50.4557129,
                30.4294643
              ],
              [
                50.4557647,
                30.4294169
              ],
              [
                50.4594308,
                30.4261204
              ],
              [
                50.4646646,
                30.4215285
              ],
              [
                50.4667092,
                30.4201811
              ],
              [
                50.4704855,
                30.4175344
              ],
              [
                50.4749986,
                30.4144687
              ],
              [
                50.4800911,
                30.4117278
              ],
              [
                50.4841346,
                30.4094969
              ],
              [
                50.4882317,
                30.4074984
              ],
              [
                50.4930686,
                30.4053583
              ],
              [
                50.4963265,
                30.4039632
              ],
              [
                50.4985314,
                30.4028482
              ],
              [
                50.4999294,
                30.4023888
              ],
              [
                50.5020903,
                30.4017857
              ],
              [
                50.5035247,
                30.4010039
              ],
              [
                50.5045928,
                30.4002161
              ],
              [
                50.505764,
                30.3992437
              ],
              [
                50.5070419,
                30.3986462
              ],
              [
                50.5086325,
                30.3979528
              ],
              [
                50.5105476,
                30.3969831
              ],
              [
                50.5158655,
                30.3937995
              ],
              [
                50.5197448,
                30.3914428
              ],
              [
                50.5204887,
                30.3909808
              ],
              [
                50.5207594,
                30.3904245
              ],
              [
                50.520977,
                30.3894981
              ],
              [
                50.5206796,
                30.3869884
              ],
              [
                50.5206949,
                30.3849896
              ],
              [
                50.5206032,
                30.3834552
              ],
              [
                50.5202522,
                30.3809904
              ],
              [
                50.519909,
                30.377551
              ],
              [
                50.5196572,
                30.3758311
              ],
              [
                50.5193597,
                30.3735537
              ],
              [
                50.5190657,
                30.3704844
              ],
              [
                50.5188753,
                30.3680676
              ],
              [
                50.5188982,
                30.365189
              ],
              [
                50.5189704,
                30.362913
              ],
              [
                50.5190047,
                30.3584982
              ],
              [
                50.5190698,
                30.3569666
              ],
              [
                50.5190888,
                30.3545956
              ],
              [
                50.5190011,
                30.3524589
              ],
              [
                50.5188217,
                30.3486478
              ],
              [
                50.5186233,
                30.3468807
              ],
              [
                50.5185318,
                30.3453011
              ],
              [
                50.5184365,
                30.3439066
              ],
              [
                50.5184517,
                30.34228
              ],
              [
                50.518055,
                30.3390254
              ],
              [
                50.5176659,
                30.334979
              ],
              [
                50.5171167,
                30.331214
              ],
              [
                50.5165406,
                30.3244732
              ],
              [
                50.5164853,
                30.3230336
              ],
              [
                50.5164527,
                30.3222417
              ],
              [
                50.5165826,
                30.3196861
              ],
              [
                50.5164946,
                30.3175493
              ],
              [
                50.5162049,
                30.3140627
              ],
              [
                50.5153694,
                30.3072262
              ],
              [
                50.5146788,
                30.3017393
              ],
              [
                50.5143851,
                30.2994145
              ],
              [
                50.514202,
                30.2961607
              ],
              [
                50.5139656,
                30.2932788
              ],
              [
                50.5135116,
                30.2907188
              ],
              [
                50.5129661,
                30.2872764
              ],
              [
                50.512783,
                30.2838827
              ],
              [
                50.5126076,
                30.2802566
              ],
              [
                50.5124702,
                30.2775601
              ],
              [
                50.5120315,
                30.2738857
              ],
              [
                50.5119515,
                30.2711421
              ],
              [
                50.5117532,
                30.2699344
              ],
              [
                50.5113679,
                30.2659804
              ],
              [
                50.5113982,
                30.262495
              ],
              [
                50.5111047,
                30.260028
              ],
              [
                50.5107079,
                30.2575652
              ],
              [
                50.510479,
                30.2539367
              ],
              [
                50.5102916,
                30.2500804
              ],
              [
                50.5099716,
                30.2390225
              ],
              [
                50.5101126,
                30.2323903
              ],
              [
                50.5099334,
                30.2302148
              ],
              [
                50.5093766,
                30.2275799
              ],
              [
                50.5096016,
                30.2183513
              ],
              [
                50.5096484,
                30.2172528
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 12225381,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مارگون",
          "type": "boundary",
          "wikidata": "Q6760724",
          "wikipedia": "en:Margown County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.4499874,
                31.4313345
              ],
              [
                50.4403927,
                31.4198768
              ],
              [
                50.4403927,
                31.419597
              ],
              [
                50.4409494,
                31.419317
              ],
              [
                50.4551161,
                31.3984899
              ],
              [
                50.4570626,
                31.3965399
              ],
              [
                50.4581729,
                31.3945989
              ],
              [
                50.4587295,
                31.394319
              ],
              [
                50.4626158,
                31.3893176
              ],
              [
                50.462896,
                31.3887579
              ],
              [
                50.473729,
                31.3779246
              ],
              [
                50.4740059,
                31.3776537
              ],
              [
                50.5164336,
                31.3485746
              ],
              [
                50.5709962,
                31.3419417
              ],
              [
                50.592384,
                31.3372173
              ],
              [
                50.6284329,
                31.3102354
              ],
              [
                50.6589886,
                31.2852996
              ],
              [
                50.6850811,
                31.2653462
              ],
              [
                50.690231,
                31.2486174
              ],
              [
                50.7152935,
                31.2242525
              ],
              [
                50.7309694,
                31.2121094
              ],
              [
                50.7585522,
                31.1916583
              ],
              [
                50.7820752,
                31.1620888
              ],
              [
                50.7840218,
                31.1540367
              ],
              [
                50.7842985,
                31.1487559
              ],
              [
                50.7845751,
                31.1482053
              ],
              [
                50.7848552,
                31.1468151
              ],
              [
                50.7848552,
                31.1459756
              ],
              [
                50.7826319,
                31.1379236
              ],
              [
                50.7812418,
                31.1365335
              ],
              [
                50.7806885,
                31.1365334
              ],
              [
                50.7809653,
                31.1362627
              ],
              [
                50.7848552,
                31.1312527
              ],
              [
                50.8090215,
                31.114869
              ],
              [
                50.8098549,
                31.1143092
              ],
              [
                50.8198547,
                31.1081981
              ],
              [
                50.820688,
                31.1081981
              ],
              [
                50.8248546,
                31.106808
              ],
              [
                50.8490244,
                31.0920943
              ],
              [
                50.8504143,
                31.0915346
              ],
              [
                50.8506911,
                31.0912549
              ],
              [
                50.8529144,
                31.0904244
              ],
              [
                50.8534677,
                31.0898647
              ],
              [
                50.8748574,
                31.0807027
              ],
              [
                50.8756906,
                31.0807026
              ],
              [
                50.8762473,
                31.0804228
              ],
              [
                50.8781906,
                31.0804228
              ],
              [
                50.8790238,
                31.080143
              ],
              [
                50.8801374,
                31.080143
              ],
              [
                50.8812473,
                31.0795833
              ],
              [
                50.8887334,
                31.0797139
              ],
              [
                50.8908928,
                31.0790328
              ],
              [
                50.8951766,
                31.0761982
              ],
              [
                50.901728,
                31.0607563
              ],
              [
                50.9101912,
                31.0512027
              ],
              [
                50.9226089,
                31.0365965
              ],
              [
                50.9389327,
                31.0263402
              ],
              [
                50.9524194,
                31.0203602
              ],
              [
                50.9518429,
                31.0073345
              ],
              [
                50.9641101,
                30.997346
              ],
              [
                51.0361289,
                30.9851885
              ],
              [
                51.0429095,
                30.9760638
              ],
              [
                51.0490035,
                30.9653927
              ],
              [
                51.0500633,
                30.9570626
              ],
              [
                51.0466606,
                30.9399692
              ],
              [
                51.0344515,
                30.9334317
              ],
              [
                51.0443284,
                30.921549
              ],
              [
                51.0529339,
                30.9122858
              ],
              [
                51.0738086,
                30.9112829
              ],
              [
                51.0923238,
                30.9119686
              ],
              [
                51.1058234,
                30.913713
              ],
              [
                51.1127569,
                30.9154698
              ],
              [
                51.1206721,
                30.9152593
              ],
              [
                51.1293806,
                30.9114934
              ],
              [
                51.1463802,
                30.8970976
              ],
              [
                51.1629447,
                30.8964703
              ],
              [
                51.169846,
                30.897341
              ],
              [
                51.1742213,
                30.9005965
              ],
              [
                51.1770922,
                30.903347
              ],
              [
                51.176337,
                30.9078351
              ],
              [
                51.1742734,
                30.9091473
              ],
              [
                51.1731147,
                30.9114301
              ],
              [
                51.1976094,
                30.9441347
              ],
              [
                51.1504269,
                30.9698664
              ],
              [
                51.1112574,
                30.9937591
              ],
              [
                51.1090376,
                30.9984798
              ],
              [
                51.1048674,
                31.0043109
              ],
              [
                51.1018143,
                31.0079215
              ],
              [
                51.0848678,
                31.0257036
              ],
              [
                51.0437549,
                31.0695909
              ],
              [
                51.007642,
                31.0993069
              ],
              [
                51.0068088,
                31.1006971
              ],
              [
                50.9998656,
                31.1129194
              ],
              [
                50.9968088,
                31.1145893
              ],
              [
                50.9840291,
                31.1287525
              ],
              [
                50.9834758,
                31.1298628
              ],
              [
                50.9668059,
                31.1462556
              ],
              [
                50.9654193,
                31.1479257
              ],
              [
                50.9529162,
                31.1576478
              ],
              [
                50.9525206,
                31.1578478
              ],
              [
                50.9518062,
                31.1584782
              ],
              [
                50.9515296,
                31.1587581
              ],
              [
                50.9515296,
                31.1595886
              ],
              [
                50.9576394,
                31.1668102
              ],
              [
                50.9593061,
                31.1751422
              ],
              [
                50.9590293,
                31.1757019
              ],
              [
                50.9576395,
                31.1795925
              ],
              [
                50.9570826,
                31.1801522
              ],
              [
                50.956806,
                31.1807028
              ],
              [
                50.956806,
                31.1809827
              ],
              [
                50.9548629,
                31.1829235
              ],
              [
                50.9540294,
                31.1840338
              ],
              [
                50.9534727,
                31.1843137
              ],
              [
                50.9476394,
                31.1956969
              ],
              [
                50.9473629,
                31.1959857
              ],
              [
                50.948196,
                31.2020881
              ],
              [
                50.9495828,
                31.2020881
              ],
              [
                50.9495828,
                31.202368
              ],
              [
                50.950416,
                31.202368
              ],
              [
                50.9333035,
                31.2242525
              ],
              [
                50.9096142,
                31.2450951
              ],
              [
                50.8962246,
                31.2650528
              ],
              [
                50.882835,
                31.2759103
              ],
              [
                50.86014,
                31.2907095
              ],
              [
                50.8598571,
                31.2904204
              ],
              [
                50.8570867,
                31.2904206
              ],
              [
                50.8568068,
                31.2907094
              ],
              [
                50.8556906,
                31.2907093
              ],
              [
                50.8437441,
                31.2970917
              ],
              [
                50.8431909,
                31.2976514
              ],
              [
                50.8393049,
                31.2990402
              ],
              [
                50.8376343,
                31.2995923
              ],
              [
                50.8362442,
                31.300143
              ],
              [
                50.8359676,
                31.3004319
              ],
              [
                50.8312442,
                31.3007027
              ],
              [
                50.8304108,
                31.3009825
              ],
              [
                50.8265304,
                31.3009827
              ],
              [
                50.8204172,
                31.3079248
              ],
              [
                50.8179172,
                31.309315
              ],
              [
                50.8170778,
                31.3093149
              ],
              [
                50.8168013,
                31.3095948
              ],
              [
                50.8140495,
                31.3095948
              ],
              [
                50.8140264,
                31.3095948
              ],
              [
                50.8140263,
                31.3095948
              ],
              [
                50.8140211,
                31.3095948
              ],
              [
                50.8081879,
                31.3084844
              ],
              [
                50.8079113,
                31.3082047
              ],
              [
                50.8079112,
                31.3082045
              ],
              [
                50.8062507,
                31.3082047
              ],
              [
                50.8006942,
                31.311256
              ],
              [
                50.7987446,
                31.3120954
              ],
              [
                50.7962447,
                31.312926
              ],
              [
                50.7917982,
                31.3137564
              ],
              [
                50.7915276,
                31.3140364
              ],
              [
                50.7906944,
                31.3140365
              ],
              [
                50.7901314,
                31.3143161
              ],
              [
                50.7892982,
                31.3143162
              ],
              [
                50.7787455,
                31.3223659
              ],
              [
                50.7554087,
                31.3407038
              ],
              [
                50.7506864,
                31.3473736
              ],
              [
                50.749852,
                31.3487564
              ],
              [
                50.7245722,
                31.370152
              ],
              [
                50.7240191,
                31.3709825
              ],
              [
                50.7245793,
                31.3784822
              ],
              [
                50.7242957,
                31.3793152
              ],
              [
                50.7198524,
                31.3832062
              ],
              [
                50.7176291,
                31.3840366
              ],
              [
                50.7165191,
                31.3845965
              ],
              [
                50.7009626,
                31.3909881
              ],
              [
                50.6992962,
                31.3940394
              ],
              [
                50.6822057,
                31.402467
              ],
              [
                50.679016,
                31.4107048
              ],
              [
                50.6756829,
                31.4120952
              ],
              [
                50.6751261,
                31.4123749
              ],
              [
                50.6742929,
                31.4123749
              ],
              [
                50.6740164,
                31.4126548
              ],
              [
                50.6709597,
                31.4126548
              ],
              [
                50.6690162,
                31.4129256
              ],
              [
                50.6623499,
                31.4151466
              ],
              [
                50.6617931,
                31.4154264
              ],
              [
                50.6601266,
                31.4154263
              ],
              [
                50.6559597,
                31.4165368
              ],
              [
                50.6556797,
                31.4168166
              ],
              [
                50.6545699,
                31.4168166
              ],
              [
                50.6545699,
                31.4168167
              ],
              [
                50.6545698,
                31.4170956
              ],
              [
                50.6545698,
                31.4170964
              ],
              [
                50.6545698,
                31.4170965
              ],
              [
                50.6520698,
                31.4173673
              ],
              [
                50.6515132,
                31.4170965
              ],
              [
                50.6490131,
                31.4173673
              ],
              [
                50.6473467,
                31.4182069
              ],
              [
                50.6417934,
                31.4259889
              ],
              [
                50.6412367,
                31.4268195
              ],
              [
                50.6395699,
                31.42765
              ],
              [
                50.6379034,
                31.4273792
              ],
              [
                50.6315137,
                31.4198771
              ],
              [
                50.6315136,
                31.419877
              ],
              [
                50.6301238,
                31.4190375
              ],
              [
                50.6301237,
                31.4190374
              ],
              [
                50.6301238,
                31.4187579
              ],
              [
                50.6301238,
                31.4187577
              ],
              [
                50.6301237,
                31.4187577
              ],
              [
                50.6217904,
                31.4184868
              ],
              [
                50.6204036,
                31.4187576
              ],
              [
                50.619847,
                31.4190375
              ],
              [
                50.6187371,
                31.4190374
              ],
              [
                50.6181805,
                31.4193173
              ],
              [
                50.6131804,
                31.4193172
              ],
              [
                50.6129004,
                31.4195971
              ],
              [
                50.611514,
                31.4195972
              ],
              [
                50.609014,
                31.4201478
              ],
              [
                50.6084573,
                31.4204277
              ],
              [
                50.6070671,
                31.4204278
              ],
              [
                50.6062338,
                31.4207075
              ],
              [
                50.6059572,
                31.4207075
              ],
              [
                50.6054005,
                31.4204277
              ],
              [
                50.6048474,
                31.4204277
              ],
              [
                50.6045673,
                31.4201479
              ],
              [
                50.5981774,
                31.4201478
              ],
              [
                50.5967906,
                31.4195971
              ],
              [
                50.5951242,
                31.4195972
              ],
              [
                50.5804009,
                31.410154
              ],
              [
                50.5767875,
                31.4087636
              ],
              [
                50.5737344,
                31.4090435
              ],
              [
                50.5687342,
                31.4123748
              ],
              [
                50.5681776,
                31.4132054
              ],
              [
                50.5681776,
                31.4134852
              ],
              [
                50.5606778,
                31.4234881
              ],
              [
                50.5476214,
                31.4304305
              ],
              [
                50.5470646,
                31.4304306
              ],
              [
                50.5448447,
                31.4326514
              ],
              [
                50.5445646,
                31.4329312
              ],
              [
                50.5442881,
                31.4337618
              ],
              [
                50.5440115,
                31.4351521
              ],
              [
                50.5442881,
                31.4365424
              ],
              [
                50.5440115,
                31.4368223
              ],
              [
                50.5437314,
                31.4384834
              ],
              [
                50.5426212,
                31.4395938
              ],
              [
                50.5423447,
                31.4401536
              ],
              [
                50.5390083,
                31.4412641
              ],
              [
                50.537898,
                31.441264
              ],
              [
                50.5342882,
                31.4398737
              ],
              [
                50.5315082,
                31.4398737
              ],
              [
                50.530955,
                31.4398737
              ],
              [
                50.5303983,
                31.4401535
              ],
              [
                50.5295651,
                31.4401535
              ],
              [
                50.5226184,
                31.4448752
              ],
              [
                50.5123417,
                31.4504274
              ],
              [
                50.509285,
                31.4512579
              ],
              [
                50.5081752,
                31.4518177
              ],
              [
                50.5003954,
                31.4526482
              ],
              [
                50.4976188,
                31.4523773
              ],
              [
                50.4965086,
                31.4518176
              ],
              [
                50.4956754,
                31.4518177
              ],
              [
                50.492062,
                31.4498766
              ],
              [
                50.4803955,
                31.431261
              ],
              [
                50.4795622,
                31.4301506
              ],
              [
                50.4781513,
                31.4289187
              ],
              [
                50.4773392,
                31.4282096
              ],
              [
                50.476229,
                31.4276498
              ],
              [
                50.4601692,
                31.4289306
              ],
              [
                50.4499874,
                31.4313345
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 840769598
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.0917097,
          30.8924843
        ]
      }
    }
  ]
},
"گلستان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554859,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آزادشهر",
          "name:en": "Azadshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286475",
          "wikipedia": "en:Azadshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.0539386,
                37.1427879
              ],
              [
                55.0542152,
                37.1425179
              ],
              [
                55.0544953,
                37.141681
              ],
              [
                55.0550486,
                37.141123
              ],
              [
                55.0558819,
                37.140844
              ],
              [
                55.0689384,
                37.1330686
              ],
              [
                55.0811616,
                37.1191824
              ],
              [
                55.0831049,
                37.1175175
              ],
              [
                55.090328,
                37.1125137
              ],
              [
                55.0978281,
                37.1097328
              ],
              [
                55.0989414,
                37.1097327
              ],
              [
                55.1000514,
                37.1094538
              ],
              [
                55.1031081,
                37.1091838
              ],
              [
                55.1078279,
                37.1072399
              ],
              [
                55.1086612,
                37.1072399
              ],
              [
                55.1125513,
                37.1058448
              ],
              [
                55.1181078,
                37.102515
              ],
              [
                55.1222745,
                37.0983481
              ],
              [
                55.1294977,
                37.0839031
              ],
              [
                55.1300543,
                37.0836242
              ],
              [
                55.1306076,
                37.0827871
              ],
              [
                55.131441,
                37.0822381
              ],
              [
                55.1331076,
                37.0805731
              ],
              [
                55.1350544,
                37.0788992
              ],
              [
                55.1404288,
                37.0746335
              ],
              [
                55.1411642,
                37.0741831
              ],
              [
                55.1539441,
                37.0644538
              ],
              [
                55.1578307,
                37.0605657
              ],
              [
                55.1736672,
                37.0483432
              ],
              [
                55.1767205,
                37.0411247
              ],
              [
                55.1797771,
                37.0325111
              ],
              [
                55.179777,
                37.0294599
              ],
              [
                55.1811672,
                37.0219532
              ],
              [
                55.1853338,
                37.0138974
              ],
              [
                55.1922769,
                37.0080648
              ],
              [
                55.1928336,
                37.0077947
              ],
              [
                55.2017235,
                37.0027902
              ],
              [
                55.2089468,
                36.9994598
              ],
              [
                55.2117233,
                36.9969575
              ],
              [
                55.2178332,
                36.9941761
              ],
              [
                55.2231133,
                36.9902876
              ],
              [
                55.2345031,
                36.9833476
              ],
              [
                55.2356131,
                36.9827895
              ],
              [
                55.2636695,
                36.9683423
              ],
              [
                55.2647828,
                36.9683422
              ],
              [
                55.2671424,
                36.967375
              ],
              [
                55.2675594,
                36.966956
              ],
              [
                55.2706162,
                36.961123
              ],
              [
                55.2711693,
                36.9372324
              ],
              [
                55.2689495,
                36.9202906
              ],
              [
                55.2689495,
                36.9105593
              ],
              [
                55.2667261,
                36.8947242
              ],
              [
                55.2678361,
                36.8783396
              ],
              [
                55.2689494,
                36.8550044
              ],
              [
                55.2686694,
                36.8533389
              ],
              [
                55.2689494,
                36.8527897
              ],
              [
                55.2689494,
                36.8500078
              ],
              [
                55.2692259,
                36.8438948
              ],
              [
                55.2717259,
                36.8169571
              ],
              [
                55.2723725,
                36.798917
              ],
              [
                55.273116,
                36.798338
              ],
              [
                55.2811725,
                36.798338
              ],
              [
                55.2820058,
                36.798617
              ],
              [
                55.2845059,
                36.7986171
              ],
              [
                55.2867258,
                36.7991753
              ],
              [
                55.2872823,
                36.7991753
              ],
              [
                55.2925589,
                36.7997245
              ],
              [
                55.2947823,
                36.7997245
              ],
              [
                55.295339,
                36.8000036
              ],
              [
                55.2967257,
                36.8000036
              ],
              [
                55.2983922,
                36.8005618
              ],
              [
                55.3164487,
                36.8030648
              ],
              [
                55.3183956,
                36.8030648
              ],
              [
                55.3220055,
                36.8036141
              ],
              [
                55.3245054,
                36.803614
              ],
              [
                55.3542283,
                36.8077827
              ],
              [
                55.3595083,
                36.8083409
              ],
              [
                55.3603416,
                36.80862
              ],
              [
                55.362285,
                36.8086199
              ],
              [
                55.3736748,
                36.8105647
              ],
              [
                55.4008978,
                36.8169571
              ],
              [
                55.4128444,
                36.8252852
              ],
              [
                55.4164544,
                36.8277791
              ],
              [
                55.4706239,
                36.8772322
              ],
              [
                55.5000701,
                36.9011157
              ],
              [
                55.50618,
                36.8994503
              ],
              [
                55.5397425,
                36.9163334
              ],
              [
                55.5416891,
                36.9168915
              ],
              [
                55.5430758,
                36.9168915
              ],
              [
                55.5472424,
                36.9188355
              ],
              [
                55.548357,
                36.9193923
              ],
              [
                55.5508557,
                36.9205006
              ],
              [
                55.5511324,
                36.9207795
              ],
              [
                55.5525223,
                36.9207796
              ],
              [
                55.5603495,
                36.9252866
              ],
              [
                55.5625728,
                36.9283473
              ],
              [
                55.5636862,
                36.9294545
              ],
              [
                55.5792393,
                36.9555598
              ],
              [
                55.5795194,
                36.9572341
              ],
              [
                55.585076,
                36.9708445
              ],
              [
                55.5914625,
                36.9889012
              ],
              [
                55.5961859,
                36.9983434
              ],
              [
                55.5970192,
                37.0019529
              ],
              [
                55.5986858,
                37.0063993
              ],
              [
                55.5986859,
                37.0083436
              ],
              [
                55.5989626,
                37.0086226
              ],
              [
                55.5986859,
                37.0091717
              ],
              [
                55.5989626,
                37.0094507
              ],
              [
                55.5992426,
                37.0130691
              ],
              [
                55.6017425,
                37.0327899
              ],
              [
                55.6020192,
                37.0380643
              ],
              [
                55.6025759,
                37.0439057
              ],
              [
                55.6036858,
                37.051124
              ],
              [
                55.6039659,
                37.0519521
              ],
              [
                55.6041866,
                37.0530654
              ],
              [
                55.6041872,
                37.0530682
              ],
              [
                55.6028525,
                37.0530681
              ],
              [
                55.6025758,
                37.0533471
              ],
              [
                55.5995193,
                37.0533471
              ],
              [
                55.598686,
                37.0536262
              ],
              [
                55.5984092,
                37.0533472
              ],
              [
                55.5959093,
                37.0533472
              ],
              [
                55.5953527,
                37.0536261
              ],
              [
                55.5942426,
                37.0536261
              ],
              [
                55.5934093,
                37.0539052
              ],
              [
                55.592296,
                37.0539052
              ],
              [
                55.5920193,
                37.0541753
              ],
              [
                55.588686,
                37.0541752
              ],
              [
                55.5856294,
                37.0539052
              ],
              [
                55.585076,
                37.0536262
              ],
              [
                55.5822961,
                37.0536261
              ],
              [
                55.5817393,
                37.0533472
              ],
              [
                55.5792394,
                37.0533472
              ],
              [
                55.5786861,
                37.0533472
              ],
              [
                55.578406,
                37.0530681
              ],
              [
                55.5764627,
                37.0530682
              ],
              [
                55.5759061,
                37.0527891
              ],
              [
                55.5745195,
                37.0527892
              ],
              [
                55.5736863,
                37.0525101
              ],
              [
                55.5728529,
                37.0525101
              ],
              [
                55.5722961,
                37.0522311
              ],
              [
                55.5709062,
                37.0522311
              ],
              [
                55.5589631,
                37.0491799
              ],
              [
                55.5578497,
                37.0491799
              ],
              [
                55.5497965,
                37.0463988
              ],
              [
                55.5492398,
                37.0461288
              ],
              [
                55.5409065,
                37.0416826
              ],
              [
                55.5122935,
                37.0222321
              ],
              [
                55.5000702,
                37.0094508
              ],
              [
                55.4939603,
                37.0119531
              ],
              [
                55.4525675,
                37.0197298
              ],
              [
                55.4511809,
                37.0200089
              ],
              [
                55.4492342,
                37.0200089
              ],
              [
                55.4481242,
                37.020288
              ],
              [
                55.4456242,
                37.0202879
              ],
              [
                55.4422909,
                37.020846
              ],
              [
                55.4411775,
                37.020846
              ],
              [
                55.4400656,
                37.0210952
              ],
              [
                55.4311777,
                37.021953
              ],
              [
                55.4297877,
                37.0222321
              ],
              [
                55.4250678,
                37.0222321
              ],
              [
                55.4209013,
                37.0222321
              ],
              [
                55.4186779,
                37.0222321
              ],
              [
                55.4178446,
                37.0219531
              ],
              [
                55.4147878,
                37.021953
              ],
              [
                55.3945115,
                37.0180647
              ],
              [
                55.3931216,
                37.0180647
              ],
              [
                55.3900648,
                37.0172367
              ],
              [
                55.3895081,
                37.0169577
              ],
              [
                55.3886748,
                37.0169576
              ],
              [
                55.3883982,
                37.0166786
              ],
              [
                55.3872882,
                37.0166786
              ],
              [
                55.3870082,
                37.0163996
              ],
              [
                55.3858983,
                37.0163996
              ],
              [
                55.3856215,
                37.0161205
              ],
              [
                55.3850649,
                37.0161205
              ],
              [
                55.3845082,
                37.0161206
              ],
              [
                55.3686751,
                37.0400085
              ],
              [
                55.3670085,
                37.0425107
              ],
              [
                55.3661751,
                37.0430687
              ],
              [
                55.3520086,
                37.0686208
              ],
              [
                55.3295056,
                37.098069
              ],
              [
                55.316449,
                37.1091837
              ],
              [
                55.313949,
                37.1108486
              ],
              [
                55.2858926,
                37.1191823
              ],
              [
                55.2822826,
                37.1199633
              ],
              [
                55.2756162,
                37.1214052
              ],
              [
                55.2739495,
                37.1214052
              ],
              [
                55.2539463,
                37.1263999
              ],
              [
                55.2381132,
                37.1336265
              ],
              [
                55.2376899,
                37.1340439
              ],
              [
                55.2317233,
                37.139458
              ],
              [
                55.2303367,
                37.141402
              ],
              [
                55.2295033,
                37.1425178
              ],
              [
                55.2270034,
                37.1500142
              ],
              [
                55.2272801,
                37.1502931
              ],
              [
                55.2267233,
                37.1502931
              ],
              [
                55.2264468,
                37.1505721
              ],
              [
                55.2250567,
                37.1505721
              ],
              [
                55.22339,
                37.151121
              ],
              [
                55.2222801,
                37.1511211
              ],
              [
                55.2156135,
                37.1522369
              ],
              [
                55.2131135,
                37.152237
              ],
              [
                55.2122803,
                37.1525159
              ],
              [
                55.2092235,
                37.152516
              ],
              [
                55.2086669,
                37.1527949
              ],
              [
                55.2078336,
                37.152795
              ],
              [
                55.2075569,
                37.1530739
              ],
              [
                55.2031102,
                37.1530739
              ],
              [
                55.2028337,
                37.1533528
              ],
              [
                55.2022769,
                37.1533529
              ],
              [
                55.1995004,
                37.1569615
              ],
              [
                55.200057,
                37.1589053
              ],
              [
                55.2003336,
                37.1600122
              ],
              [
                55.2042236,
                37.1694611
              ],
              [
                55.2039436,
                37.170019
              ],
              [
                55.2033903,
                37.1722327
              ],
              [
                55.202557,
                37.1725207
              ],
              [
                55.1970004,
                37.1741855
              ],
              [
                55.1958904,
                37.1741855
              ],
              [
                55.1953337,
                37.1744555
              ],
              [
                55.1942238,
                37.1744555
              ],
              [
                55.1933905,
                37.1747344
              ],
              [
                55.192277,
                37.1747345
              ],
              [
                55.1917237,
                37.1750134
              ],
              [
                55.1897771,
                37.1750134
              ],
              [
                55.1889438,
                37.1752924
              ],
              [
                55.1856105,
                37.1752923
              ],
              [
                55.1850538,
                37.1750135
              ],
              [
                55.1822772,
                37.1750135
              ],
              [
                55.1820005,
                37.1747344
              ],
              [
                55.1745005,
                37.1747345
              ],
              [
                55.1736673,
                37.1750134
              ],
              [
                55.1722774,
                37.1750134
              ],
              [
                55.1697773,
                37.1758503
              ],
              [
                55.1658874,
                37.1822395
              ],
              [
                55.1650541,
                37.1847411
              ],
              [
                55.1633874,
                37.185848
              ],
              [
                55.1631107,
                37.1861269
              ],
              [
                55.1594974,
                37.1872427
              ],
              [
                55.1581108,
                37.1872427
              ],
              [
                55.1536641,
                37.1880707
              ],
              [
                55.1483875,
                37.1880706
              ],
              [
                55.137831,
                37.1844622
              ],
              [
                55.1361643,
                37.1844621
              ],
              [
                55.1342211,
                37.1839042
              ],
              [
                55.1297744,
                37.1839043
              ],
              [
                55.1289411,
                37.1841832
              ],
              [
                55.1278311,
                37.1841832
              ],
              [
                55.1272745,
                37.1844622
              ],
              [
                55.1258844,
                37.1844621
              ],
              [
                55.1253312,
                37.1850201
              ],
              [
                55.114498,
                37.1883496
              ],
              [
                55.1097747,
                37.1897354
              ],
              [
                55.1039415,
                37.192237
              ],
              [
                55.1031082,
                37.192237
              ],
              [
                55.0961615,
                37.1936229
              ],
              [
                55.0942181,
                37.1930739
              ],
              [
                55.0933849,
                37.192516
              ],
              [
                55.0933849,
                37.192237
              ],
              [
                55.0928281,
                37.1914001
              ],
              [
                55.0919949,
                37.1889075
              ],
              [
                55.0917182,
                37.1886286
              ],
              [
                55.0919948,
                37.1880706
              ],
              [
                55.0922748,
                37.1864059
              ],
              [
                55.1014415,
                37.1777941
              ],
              [
                55.1019947,
                37.1766783
              ],
              [
                55.1058846,
                37.1711259
              ],
              [
                55.1078279,
                37.1636298
              ],
              [
                55.1075513,
                37.162514
              ],
              [
                55.1050513,
                37.1580685
              ],
              [
                55.0944948,
                37.152237
              ],
              [
                55.0892183,
                37.1511211
              ],
              [
                55.0886615,
                37.1508511
              ],
              [
                55.0872716,
                37.1505722
              ],
              [
                55.0831049,
                37.1494563
              ],
              [
                55.0581051,
                37.1447407
              ],
              [
                55.0539386,
                37.1427879
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554864,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آق قلا",
          "name:en": "Aqqala County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292673",
          "wikipedia": "en:Aqqala County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.2242496,
                37.3216901
              ],
              [
                54.2263547,
                37.3172808
              ],
              [
                54.2375108,
                37.2955784
              ],
              [
                54.254607,
                37.2910562
              ],
              [
                54.254887,
                37.2905074
              ],
              [
                54.2551637,
                37.2899495
              ],
              [
                54.2593302,
                37.2818974
              ],
              [
                54.2598869,
                37.2793961
              ],
              [
                54.2636435,
                37.2551631
              ],
              [
                54.2636436,
                37.2546052
              ],
              [
                54.2658669,
                37.2440519
              ],
              [
                54.2664202,
                37.2393283
              ],
              [
                54.2669769,
                37.2382217
              ],
              [
                54.2745768,
                37.2218508
              ],
              [
                54.2751334,
                37.221293
              ],
              [
                54.2752932,
                37.2207351
              ],
              [
                54.2756901,
                37.2193495
              ],
              [
                54.2762434,
                37.2187916
              ],
              [
                54.2762433,
                37.2182338
              ],
              [
                54.2815233,
                37.209902
              ],
              [
                54.2818,
                37.2093442
              ],
              [
                54.2876799,
                37.1951982
              ],
              [
                54.30191,
                37.1732681
              ],
              [
                54.3024666,
                37.1729891
              ],
              [
                54.3027433,
                37.1721523
              ],
              [
                54.2971798,
                37.1627793
              ],
              [
                54.3074795,
                37.1378774
              ],
              [
                54.335323,
                37.1364635
              ],
              [
                54.3532861,
                37.1402514
              ],
              [
                54.3541193,
                37.1402514
              ],
              [
                54.3557861,
                37.1396934
              ],
              [
                54.3568959,
                37.1396934
              ],
              [
                54.359676,
                37.1388654
              ],
              [
                54.3749525,
                37.1388655
              ],
              [
                54.3757858,
                37.1385865
              ],
              [
                54.377177,
                37.1385865
              ],
              [
                54.3807892,
                37.1385865
              ],
              [
                54.3816224,
                37.1383076
              ],
              [
                54.3846757,
                37.1383076
              ],
              [
                54.3849558,
                37.1380286
              ],
              [
                54.3866224,
                37.1380286
              ],
              [
                54.3871757,
                37.1377497
              ],
              [
                54.3882891,
                37.1377497
              ],
              [
                54.3885657,
                37.1374707
              ],
              [
                54.3896757,
                37.1374707
              ],
              [
                54.4030422,
                37.136287
              ],
              [
                54.4079761,
                37.1358118
              ],
              [
                54.4107993,
                37.1323772
              ],
              [
                54.4106356,
                37.1309823
              ],
              [
                54.4098023,
                37.1226589
              ],
              [
                54.4095256,
                37.1201572
              ],
              [
                54.3965626,
                37.0971128
              ],
              [
                54.3951727,
                37.093774
              ],
              [
                54.393506,
                37.0898865
              ],
              [
                54.3743887,
                37.0497084
              ],
              [
                54.3721528,
                37.0463783
              ],
              [
                54.3613162,
                37.0344348
              ],
              [
                54.3605834,
                37.0337533
              ],
              [
                54.3551192,
                37.0138319
              ],
              [
                54.351506,
                37.0110507
              ],
              [
                54.3462793,
                37.0016535
              ],
              [
                54.345446,
                36.9997004
              ],
              [
                54.3468325,
                36.9944258
              ],
              [
                54.3433741,
                36.9802154
              ],
              [
                54.3441244,
                36.9790174
              ],
              [
                54.3530694,
                36.9647329
              ],
              [
                54.3583494,
                36.9569556
              ],
              [
                54.3616826,
                36.9472337
              ],
              [
                54.361406,
                36.9461175
              ],
              [
                54.3605727,
                36.9447311
              ],
              [
                54.3594593,
                36.9408424
              ],
              [
                54.3594593,
                36.9383399
              ],
              [
                54.357516,
                36.933902
              ],
              [
                54.3503227,
                36.9323368
              ],
              [
                54.3483795,
                36.9309596
              ],
              [
                54.3451244,
                36.9265444
              ],
              [
                54.3428528,
                36.9285485
              ],
              [
                54.3401715,
                36.926379
              ],
              [
                54.3467013,
                36.9244648
              ],
              [
                54.3522112,
                36.9239502
              ],
              [
                54.3634139,
                36.9228615
              ],
              [
                54.3892278,
                36.9207435
              ],
              [
                54.4150187,
                36.9183464
              ],
              [
                54.4161287,
                36.9183464
              ],
              [
                54.4175188,
                36.9189046
              ],
              [
                54.4186288,
                36.9189045
              ],
              [
                54.419742,
                36.9191746
              ],
              [
                54.4211287,
                36.9191746
              ],
              [
                54.4239087,
                36.9197328
              ],
              [
                54.4250186,
                36.9197328
              ],
              [
                54.4261286,
                36.9200118
              ],
              [
                54.4266853,
                36.9200118
              ],
              [
                54.4280753,
                36.9205609
              ],
              [
                54.4572416,
                36.9316784
              ],
              [
                54.458355,
                36.9316785
              ],
              [
                54.459465,
                36.9319575
              ],
              [
                54.4630749,
                36.9319575
              ],
              [
                54.4647415,
                36.9313994
              ],
              [
                54.4655748,
                36.9305623
              ],
              [
                54.4672415,
                36.929455
              ],
              [
                54.4714115,
                36.9263943
              ],
              [
                54.4722448,
                36.9263943
              ],
              [
                54.4730782,
                36.9261152
              ],
              [
                54.4747448,
                36.9261152
              ],
              [
                54.4758547,
                36.9258451
              ],
              [
                54.4794647,
                36.9261152
              ],
              [
                54.4961345,
                36.9339019
              ],
              [
                54.5000211,
                36.934451
              ],
              [
                54.5044678,
                36.934172
              ],
              [
                54.5053011,
                36.9339019
              ],
              [
                54.5066911,
                36.9339019
              ],
              [
                54.5180776,
                36.9316784
              ],
              [
                54.5260875,
                36.941832
              ],
              [
                54.5271974,
                36.9415528
              ],
              [
                54.5313675,
                36.9415529
              ],
              [
                54.5319207,
                36.9412738
              ],
              [
                54.5335874,
                36.9412738
              ],
              [
                54.549424,
                36.9393296
              ],
              [
                54.5538672,
                36.9393297
              ],
              [
                54.5549771,
                36.9390506
              ],
              [
                54.5616437,
                36.9390506
              ],
              [
                54.5627571,
                36.9393297
              ],
              [
                54.564977,
                36.9393297
              ],
              [
                54.5652572,
                36.9396086
              ],
              [
                54.5666436,
                36.9396086
              ],
              [
                54.5697003,
                36.9404367
              ],
              [
                54.5710903,
                36.9404367
              ],
              [
                54.571367,
                36.9407158
              ],
              [
                54.572757,
                36.9407157
              ],
              [
                54.5730336,
                36.9409949
              ],
              [
                54.5747002,
                36.9409948
              ],
              [
                54.57882,
                36.9440409
              ],
              [
                54.5791001,
                36.945976
              ],
              [
                54.5793768,
                36.9487572
              ],
              [
                54.5796533,
                36.9498642
              ],
              [
                54.5799335,
                36.9504223
              ],
              [
                54.5804867,
                36.9540315
              ],
              [
                54.5802101,
                36.9548685
              ],
              [
                54.5799334,
                36.9612588
              ],
              [
                54.58021,
                36.9618078
              ],
              [
                54.5807668,
                36.9654261
              ],
              [
                54.5802101,
                36.9690351
              ],
              [
                54.5796534,
                36.9729232
              ],
              [
                54.5799335,
                36.9756953
              ],
              [
                54.58021,
                36.9770813
              ],
              [
                54.5807667,
                36.9779184
              ],
              [
                54.5821534,
                36.978057
              ],
              [
                54.5835433,
                36.9781973
              ],
              [
                54.5918766,
                36.9751463
              ],
              [
                54.6040998,
                36.9695841
              ],
              [
                54.6082665,
                36.9681981
              ],
              [
                54.619933,
                36.9607008
              ],
              [
                54.6207663,
                36.9595848
              ],
              [
                54.6215996,
                36.9593058
              ],
              [
                54.6366028,
                36.9487573
              ],
              [
                54.6418794,
                36.9473621
              ],
              [
                54.6438227,
                36.9473621
              ],
              [
                54.644656,
                36.9470921
              ],
              [
                54.6496594,
                36.9470921
              ],
              [
                54.6504927,
                36.9468131
              ],
              [
                54.6529926,
                36.9468132
              ],
              [
                54.6554926,
                36.9470921
              ],
              [
                54.6602125,
                36.9470921
              ],
              [
                54.6610459,
                36.9473621
              ],
              [
                54.6696592,
                36.9470921
              ],
              [
                54.6699357,
                36.9468131
              ],
              [
                54.6718824,
                36.9468131
              ],
              [
                54.6724357,
                36.946534
              ],
              [
                54.6738257,
                36.946534
              ],
              [
                54.6741024,
                36.9462551
              ],
              [
                54.6752157,
                36.9462551
              ],
              [
                54.676049,
                36.945976
              ],
              [
                54.6785491,
                36.945976
              ],
              [
                54.679659,
                36.945697
              ],
              [
                54.681049,
                36.945697
              ],
              [
                54.6824355,
                36.9459761
              ],
              [
                54.6829922,
                36.945697
              ],
              [
                54.6843823,
                36.945697
              ],
              [
                54.6849389,
                36.945427
              ],
              [
                54.6857723,
                36.945427
              ],
              [
                54.6874389,
                36.944869
              ],
              [
                54.6885489,
                36.944869
              ],
              [
                54.6954921,
                36.9423668
              ],
              [
                54.6977154,
                36.9434829
              ],
              [
                54.6944155,
                36.9544432
              ],
              [
                54.6958055,
                36.95916
              ],
              [
                54.6960822,
                36.9602762
              ],
              [
                54.6822859,
                36.9676974
              ],
              [
                54.6894758,
                36.9722311
              ],
              [
                54.6881827,
                36.9908459
              ],
              [
                54.6811713,
                37.004885
              ],
              [
                54.6833895,
                37.0149488
              ],
              [
                54.6845028,
                37.0182878
              ],
              [
                54.6994592,
                37.0233034
              ],
              [
                54.7116988,
                37.0250136
              ],
              [
                54.712969,
                37.025922
              ],
              [
                54.7233655,
                37.0311252
              ],
              [
                54.7239221,
                37.0316832
              ],
              [
                54.7358686,
                37.0363995
              ],
              [
                54.736702,
                37.0363995
              ],
              [
                54.7628117,
                37.043348
              ],
              [
                54.766425,
                37.0447341
              ],
              [
                54.7797582,
                37.0508454
              ],
              [
                54.7861481,
                37.0530685
              ],
              [
                54.7878147,
                37.0539055
              ],
              [
                54.7969813,
                37.0566777
              ],
              [
                54.798648,
                37.0569567
              ],
              [
                54.8214278,
                37.06557
              ],
              [
                54.822261,
                37.0655699
              ],
              [
                54.8439274,
                37.0764062
              ],
              [
                54.854484,
                37.0841823
              ],
              [
                54.8553174,
                37.0847403
              ],
              [
                54.8572607,
                37.0880702
              ],
              [
                54.8572606,
                37.0883492
              ],
              [
                54.8578174,
                37.0897352
              ],
              [
                54.858094,
                37.0902932
              ],
              [
                54.858094,
                37.0911213
              ],
              [
                54.858094,
                37.0919583
              ],
              [
                54.8583739,
                37.0925162
              ],
              [
                54.8589273,
                37.0961252
              ],
              [
                54.8578174,
                37.1022361
              ],
              [
                54.8119812,
                37.1311248
              ],
              [
                54.8117045,
                37.1316828
              ],
              [
                54.8078146,
                37.1344636
              ],
              [
                54.8061479,
                37.1361284
              ],
              [
                54.8047579,
                37.1369563
              ],
              [
                54.7900381,
                37.1522371
              ],
              [
                54.7797583,
                37.1680664
              ],
              [
                54.7793407,
                37.1689034
              ],
              [
                54.7728149,
                37.1847412
              ],
              [
                54.7617018,
                37.231407
              ],
              [
                54.7608685,
                37.2347363
              ],
              [
                54.7558685,
                37.2547386
              ],
              [
                54.7550352,
                37.2564032
              ],
              [
                54.7525352,
                37.2589045
              ],
              [
                54.7444786,
                37.2666876
              ],
              [
                54.738922,
                37.2711324
              ],
              [
                54.7308654,
                37.2755771
              ],
              [
                54.7300321,
                37.2758561
              ],
              [
                54.6850327,
                37.2908548
              ],
              [
                54.6666961,
                37.2997441
              ],
              [
                54.6658628,
                37.300014
              ],
              [
                54.6407861,
                37.3088545
              ],
              [
                54.6183627,
                37.3143255
              ],
              [
                54.6126831,
                37.3179488
              ],
              [
                54.6121264,
                37.3182278
              ],
              [
                54.58752,
                37.3234871
              ],
              [
                54.5755569,
                37.330878
              ],
              [
                54.5747236,
                37.331157
              ],
              [
                54.571667,
                37.3344961
              ],
              [
                54.5672236,
                37.3422722
              ],
              [
                54.5672236,
                37.3425512
              ],
              [
                54.5601651,
                37.3586969
              ],
              [
                54.5395657,
                37.3726131
              ],
              [
                54.5370745,
                37.3846404
              ],
              [
                54.5379079,
                37.3868624
              ],
              [
                54.5490211,
                37.4004723
              ],
              [
                54.5509644,
                37.4013087
              ],
              [
                54.551521,
                37.4018665
              ],
              [
                54.560131,
                37.4051946
              ],
              [
                54.5609643,
                37.4051947
              ],
              [
                54.5640209,
                37.4068678
              ],
              [
                54.5654109,
                37.4113114
              ],
              [
                54.5651309,
                37.4124178
              ],
              [
                54.5651309,
                37.4126967
              ],
              [
                54.5780804,
                37.412523
              ],
              [
                54.5764138,
                37.4227959
              ],
              [
                54.5769704,
                37.4264121
              ],
              [
                54.5766939,
                37.4347418
              ],
              [
                54.5769705,
                37.4352996
              ],
              [
                54.5772471,
                37.4369637
              ],
              [
                54.5775272,
                37.440022
              ],
              [
                54.5797471,
                37.4475241
              ],
              [
                54.5800271,
                37.449467
              ],
              [
                54.5800271,
                37.4497458
              ],
              [
                54.5797712,
                37.4518368
              ],
              [
                54.5795374,
                37.4548216
              ],
              [
                54.5790571,
                37.4534556
              ],
              [
                54.5783274,
                37.4521523
              ],
              [
                54.5782058,
                37.4515634
              ],
              [
                54.5784126,
                37.4511483
              ],
              [
                54.5788747,
                37.4507428
              ],
              [
                54.5789476,
                37.4502408
              ],
              [
                54.5787477,
                37.4499963
              ],
              [
                54.5785198,
                37.4499651
              ],
              [
                54.5782442,
                37.4496697
              ],
              [
                54.5782442,
                37.4488491
              ],
              [
                54.5782855,
                37.4483567
              ],
              [
                54.5780788,
                37.4482363
              ],
              [
                54.577624,
                37.4480285
              ],
              [
                54.577081,
                37.4474831
              ],
              [
                54.5765799,
                37.4472188
              ],
              [
                54.5763362,
                37.4472072
              ],
              [
                54.5760049,
                37.4473658
              ],
              [
                54.5754133,
                37.4477569
              ],
              [
                54.5751034,
                37.4478146
              ],
              [
                54.5746405,
                37.4477024
              ],
              [
                54.5742458,
                37.4476444
              ],
              [
                54.5738463,
                37.4477333
              ],
              [
                54.5737927,
                37.4479538
              ],
              [
                54.5739328,
                37.4480948
              ],
              [
                54.5741094,
                37.4482749
              ],
              [
                54.5742263,
                37.4484954
              ],
              [
                54.5745138,
                37.4487701
              ],
              [
                54.5746405,
                37.4490331
              ],
              [
                54.57447,
                37.4492034
              ],
              [
                54.5741532,
                37.4493813
              ],
              [
                54.5739291,
                37.4494316
              ],
              [
                54.5734564,
                37.4493155
              ],
              [
                54.5731623,
                37.4490076
              ],
              [
                54.5731251,
                37.4488745
              ],
              [
                54.5730374,
                37.4485921
              ],
              [
                54.5728181,
                37.4483678
              ],
              [
                54.5723796,
                37.4483523
              ],
              [
                54.5714635,
                37.4484645
              ],
              [
                54.5705913,
                37.4484877
              ],
              [
                54.5697122,
                37.4483211
              ],
              [
                54.5694638,
                37.4482493
              ],
              [
                54.5690263,
                37.4482849
              ],
              [
                54.5688988,
                37.4483971
              ],
              [
                54.569009,
                37.4486049
              ],
              [
                54.569171,
                37.4488593
              ],
              [
                54.5694845,
                37.4490317
              ],
              [
                54.5698084,
                37.4490754
              ],
              [
                54.570184,
                37.4490371
              ],
              [
                54.5704286,
                37.4491165
              ],
              [
                54.5706009,
                37.4491657
              ],
              [
                54.5705595,
                37.4494119
              ],
              [
                54.5704045,
                37.4501094
              ],
              [
                54.5700398,
                37.4506076
              ],
              [
                54.5698187,
                37.4507604
              ],
              [
                54.5691313,
                37.4508616
              ],
              [
                54.5687438,
                37.4508373
              ],
              [
                54.5685232,
                37.4508042
              ],
              [
                54.5684402,
                37.4507101
              ],
              [
                54.5685226,
                37.450611
              ],
              [
                54.5685925,
                37.450387
              ],
              [
                54.5684652,
                37.4501572
              ],
              [
                54.5684077,
                37.4499689
              ],
              [
                54.5684177,
                37.4497766
              ],
              [
                54.5682704,
                37.4497192
              ],
              [
                54.5679908,
                37.449739
              ],
              [
                54.5676663,
                37.4496181
              ],
              [
                54.5671207,
                37.4496032
              ],
              [
                54.5668135,
                37.4493818
              ],
              [
                54.5666229,
                37.4492164
              ],
              [
                54.5665664,
                37.4490819
              ],
              [
                54.5668273,
                37.4489284
              ],
              [
                54.5670013,
                37.4487204
              ],
              [
                54.5671362,
                37.4484112
              ],
              [
                54.5670563,
                37.4482963
              ],
              [
                54.5668715,
                37.4481179
              ],
              [
                54.5666169,
                37.4480307
              ],
              [
                54.5662874,
                37.4480069
              ],
              [
                54.5659129,
                37.4481179
              ],
              [
                54.5655513,
                37.4481339
              ],
              [
                54.5653887,
                37.4484826
              ],
              [
                54.5652339,
                37.4489146
              ],
              [
                54.5650542,
                37.448982
              ],
              [
                54.5648595,
                37.4489384
              ],
              [
                54.5642513,
                37.4485843
              ],
              [
                54.5632144,
                37.4481915
              ],
              [
                54.5631221,
                37.4480776
              ],
              [
                54.5632269,
                37.447919
              ],
              [
                54.5634192,
                37.4477598
              ],
              [
                54.5636962,
                37.447594
              ],
              [
                54.5637961,
                37.447487
              ],
              [
                54.5637761,
                37.44738
              ],
              [
                54.5637062,
                37.447269
              ],
              [
                54.5634965,
                37.4470153
              ],
              [
                54.5633368,
                37.4466268
              ],
              [
                54.5633526,
                37.4463464
              ],
              [
                54.5632397,
                37.4458588
              ],
              [
                54.5630596,
                37.4452337
              ],
              [
                54.5628375,
                37.4448678
              ],
              [
                54.5625724,
                37.4447544
              ],
              [
                54.5624488,
                37.4447264
              ],
              [
                54.56229,
                37.4447824
              ],
              [
                54.5619708,
                37.445059
              ],
              [
                54.5618204,
                37.4452421
              ],
              [
                54.5619158,
                37.4454888
              ],
              [
                54.5621099,
                37.445727
              ],
              [
                54.5623112,
                37.4459512
              ],
              [
                54.5623712,
                37.4461082
              ],
              [
                54.5622476,
                37.4462259
              ],
              [
                54.5621116,
                37.4462655
              ],
              [
                54.5619166,
                37.4462767
              ],
              [
                54.5616201,
                37.4463383
              ],
              [
                54.5612176,
                37.4463551
              ],
              [
                54.5607586,
                37.4464224
              ],
              [
                54.5602573,
                37.4463551
              ],
              [
                54.5598443,
                37.4462262
              ],
              [
                54.5594206,
                37.4460945
              ],
              [
                54.5589193,
                37.4460608
              ],
              [
                54.5586051,
                37.44603
              ],
              [
                54.5578801,
                37.4460589
              ],
              [
                54.557542,
                37.4462452
              ],
              [
                54.5573223,
                37.4465227
              ],
              [
                54.5572923,
                37.4467566
              ],
              [
                54.5573751,
                37.4469155
              ],
              [
                54.557361,
                37.4470612
              ],
              [
                54.5572251,
                37.4471859
              ],
              [
                54.5570133,
                37.4472294
              ],
              [
                54.5567079,
                37.4471775
              ],
              [
                54.5562922,
                37.447095
              ],
              [
                54.556064,
                37.4469683
              ],
              [
                54.5557581,
                37.4467569
              ],
              [
                54.5555509,
                37.4466142
              ],
              [
                54.555496,
                37.4465012
              ],
              [
                54.5555135,
                37.4463744
              ],
              [
                54.5557312,
                37.4460954
              ],
              [
                54.5564577,
                37.4456173
              ],
              [
                54.5566724,
                37.445324
              ],
              [
                54.5568771,
                37.4449315
              ],
              [
                54.5572865,
                37.4446105
              ],
              [
                54.5575811,
                37.4443726
              ],
              [
                54.5578357,
                37.4440159
              ],
              [
                54.5578407,
                37.4437661
              ],
              [
                54.5577483,
                37.4436805
              ],
              [
                54.5576609,
                37.4435996
              ],
              [
                54.5574013,
                37.4435679
              ],
              [
                54.5571367,
                37.4436195
              ],
              [
                54.5568571,
                37.443782
              ],
              [
                54.5564277,
                37.444111
              ],
              [
                54.5554891,
                37.4446977
              ],
              [
                54.554711,
                37.4449708
              ],
              [
                54.5542958,
                37.4453002
              ],
              [
                54.5539014,
                37.445867
              ],
              [
                54.5537217,
                37.4461088
              ],
              [
                54.553512,
                37.4462475
              ],
              [
                54.5531239,
                37.4463867
              ],
              [
                54.5528907,
                37.4464697
              ],
              [
                54.5526577,
                37.4464304
              ],
              [
                54.5524741,
                37.4463127
              ],
              [
                54.5524,
                37.446153
              ],
              [
                54.5523965,
                37.4459119
              ],
              [
                54.5523894,
                37.4455588
              ],
              [
                54.5522552,
                37.4452308
              ],
              [
                54.5520399,
                37.4449223
              ],
              [
                54.5520258,
                37.4446925
              ],
              [
                54.5520787,
                37.4443841
              ],
              [
                54.5519799,
                37.4441459
              ],
              [
                54.551708,
                37.4439581
              ],
              [
                54.5515965,
                37.443748
              ],
              [
                54.5513908,
                37.4436725
              ],
              [
                54.5510712,
                37.4437082
              ],
              [
                54.5508416,
                37.4436448
              ],
              [
                54.5506918,
                37.4435179
              ],
              [
                54.5507018,
                37.443284
              ],
              [
                54.5509757,
                37.4429283
              ],
              [
                54.5509757,
                37.4427737
              ],
              [
                54.5509207,
                37.4426429
              ],
              [
                54.550766,
                37.4425676
              ],
              [
                54.5505263,
                37.4425477
              ],
              [
                54.5503066,
                37.4425715
              ],
              [
                54.5499871,
                37.4428213
              ],
              [
                54.5497674,
                37.4429996
              ],
              [
                54.5495534,
                37.4434624
              ],
              [
                54.549393,
                37.4439114
              ],
              [
                54.5492332,
                37.4440342
              ],
              [
                54.5490185,
                37.4440659
              ],
              [
                54.5487239,
                37.4439946
              ],
              [
                54.5476339,
                37.4433643
              ],
              [
                54.5462268,
                37.4431671
              ],
              [
                54.5459585,
                37.4430886
              ],
              [
                54.545839,
                37.4430016
              ],
              [
                54.5457661,
                37.4429289
              ],
              [
                54.5457101,
                37.4428376
              ],
              [
                54.5456819,
                37.4427171
              ],
              [
                54.5459594,
                37.4423702
              ],
              [
                54.546691,
                37.4420011
              ],
              [
                54.5467083,
                37.4417938
              ],
              [
                54.5465688,
                37.4416153
              ],
              [
                54.5461944,
                37.4415043
              ],
              [
                54.5456452,
                37.4414567
              ],
              [
                54.545091,
                37.4413537
              ],
              [
                54.5448863,
                37.4412625
              ],
              [
                54.5447265,
                37.4410365
              ],
              [
                54.5447165,
                37.4408225
              ],
              [
                54.5448613,
                37.4405291
              ],
              [
                54.5448513,
                37.440216
              ],
              [
                54.5445279,
                37.4398233
              ],
              [
                54.5439426,
                37.4391773
              ],
              [
                54.5434983,
                37.4386263
              ],
              [
                54.5428542,
                37.4383845
              ],
              [
                54.5421003,
                37.4381506
              ],
              [
                54.5417358,
                37.4380436
              ],
              [
                54.541641,
                37.4378295
              ],
              [
                54.5418137,
                37.4374241
              ],
              [
                54.5418756,
                37.4371516
              ],
              [
                54.5417159,
                37.4370406
              ],
              [
                54.5413764,
                37.4370327
              ],
              [
                54.5407523,
                37.4370802
              ],
              [
                54.5404128,
                37.4370049
              ],
              [
                54.5401931,
                37.4367671
              ],
              [
                54.5400084,
                37.4364261
              ],
              [
                54.5396988,
                37.4361605
              ],
              [
                54.539559,
                37.4357601
              ],
              [
                54.5393094,
                37.4355579
              ],
              [
                54.5386603,
                37.4355738
              ],
              [
                54.5380912,
                37.4357641
              ],
              [
                54.5375992,
                37.4359628
              ],
              [
                54.5373872,
                37.435998
              ],
              [
                54.5371775,
                37.4359583
              ],
              [
                54.5370626,
                37.4357284
              ],
              [
                54.5369977,
                37.4354271
              ],
              [
                54.536798,
                37.4353518
              ],
              [
                54.5365484,
                37.4354112
              ],
              [
                54.5362838,
                37.4356015
              ],
              [
                54.5359393,
                37.4359068
              ],
              [
                54.5357196,
                37.4363468
              ],
              [
                54.535445,
                37.4364142
              ],
              [
                54.5352103,
                37.4363865
              ],
              [
                54.5351305,
                37.4362636
              ],
              [
                54.5351064,
                37.4359818
              ],
              [
                54.5350755,
                37.4358037
              ],
              [
                54.5348858,
                37.4356689
              ],
              [
                54.534756,
                37.4356332
              ],
              [
                54.5342517,
                37.435772
              ],
              [
                54.5340171,
                37.435768
              ],
              [
                54.5338773,
                37.435657
              ],
              [
                54.5336426,
                37.4353438
              ],
              [
                54.533388,
                37.434884
              ],
              [
                54.5332582,
                37.434547
              ],
              [
                54.5330722,
                37.4341398
              ],
              [
                54.5329172,
                37.4339608
              ],
              [
                54.532715,
                37.4338538
              ],
              [
                54.5325652,
                37.4338161
              ],
              [
                54.5322546,
                37.4338492
              ],
              [
                54.5319651,
                37.4340157
              ],
              [
                54.5317009,
                37.4342299
              ],
              [
                54.5315175,
                37.4342968
              ],
              [
                54.5311251,
                37.4342606
              ],
              [
                54.5307656,
                37.4340743
              ],
              [
                54.5304511,
                37.4340029
              ],
              [
                54.5300167,
                37.4338007
              ],
              [
                54.5299967,
                37.4335747
              ],
              [
                54.5301265,
                37.433317
              ],
              [
                54.5304361,
                37.4331783
              ],
              [
                54.530471,
                37.4329246
              ],
              [
                54.5304011,
                37.4327224
              ],
              [
                54.5302164,
                37.4326193
              ],
              [
                54.5298569,
                37.4325598
              ],
              [
                54.5295474,
                37.4325995
              ],
              [
                54.529333,
                37.4325433
              ],
              [
                54.529098,
                37.4323973
              ],
              [
                54.5288434,
                37.4321515
              ],
              [
                54.5285289,
                37.4320206
              ],
              [
                54.5281794,
                37.431985
              ],
              [
                54.5276352,
                37.431981
              ],
              [
                54.5271109,
                37.4321039
              ],
              [
                54.5260674,
                37.4325479
              ],
              [
                54.525708,
                37.4328056
              ],
              [
                54.5252337,
                37.4333408
              ],
              [
                54.5248659,
                37.4335978
              ],
              [
                54.5245447,
                37.4337333
              ],
              [
                54.5241602,
                37.4337968
              ],
              [
                54.5235162,
                37.4338404
              ],
              [
                54.5231467,
                37.4338047
              ],
              [
                54.5228321,
                37.4338443
              ],
              [
                54.5224527,
                37.4340584
              ],
              [
                54.522218,
                37.434328
              ],
              [
                54.5219684,
                37.4347403
              ],
              [
                54.5218036,
                37.4349068
              ],
              [
                54.5214891,
                37.4349782
              ],
              [
                54.5212494,
                37.4349147
              ],
              [
                54.5210148,
                37.4347324
              ],
              [
                54.5208777,
                37.4344801
              ],
              [
                54.5208299,
                37.4341231
              ],
              [
                54.5206801,
                37.4337782
              ],
              [
                54.5202208,
                37.4334531
              ],
              [
                54.5198713,
                37.4331954
              ],
              [
                54.5190075,
                37.4328861
              ],
              [
                54.5184447,
                37.4326784
              ],
              [
                54.5182986,
                37.4326245
              ],
              [
                54.5180589,
                37.4324857
              ],
              [
                54.5179341,
                37.4321804
              ],
              [
                54.5179541,
                37.4316928
              ],
              [
                54.5177943,
                37.4312527
              ],
              [
                54.5175298,
                37.4309833
              ],
              [
                54.517315,
                37.4309237
              ],
              [
                54.5169755,
                37.4309435
              ],
              [
                54.516646,
                37.430995
              ],
              [
                54.5164662,
                37.4309157
              ],
              [
                54.5161417,
                37.4305946
              ],
              [
                54.5152985,
                37.4308221
              ],
              [
                54.5147712,
                37.4309652
              ],
              [
                54.5145095,
                37.4308597
              ],
              [
                54.5146222,
                37.430425
              ],
              [
                54.5143772,
                37.4302998
              ],
              [
                54.5136701,
                37.4302252
              ],
              [
                54.5131387,
                37.4300206
              ],
              [
                54.5129616,
                37.4296625
              ],
              [
                54.5129616,
                37.4292405
              ],
              [
                54.5129294,
                37.4286523
              ],
              [
                54.5125671,
                37.4280577
              ],
              [
                54.5121806,
                37.4277764
              ],
              [
                54.5117861,
                37.42777
              ],
              [
                54.5112466,
                37.4279618
              ],
              [
                54.5109487,
                37.4280577
              ],
              [
                54.5107796,
                37.4279106
              ],
              [
                54.5107716,
                37.4275398
              ],
              [
                54.510675,
                37.4268748
              ],
              [
                54.5104254,
                37.4264464
              ],
              [
                54.510078,
                37.4257845
              ],
              [
                54.5097909,
                37.425055
              ],
              [
                54.5094835,
                37.4243089
              ],
              [
                54.5090451,
                37.423893
              ],
              [
                54.5086181,
                37.4234001
              ],
              [
                54.5081797,
                37.4230882
              ],
              [
                54.5074794,
                37.4227807
              ],
              [
                54.5070183,
                37.4223466
              ],
              [
                54.5068064,
                37.4216774
              ],
              [
                54.5066084,
                37.4213022
              ],
              [
                54.5062895,
                37.4209585
              ],
              [
                54.5059423,
                37.4207279
              ],
              [
                54.5054128,
                37.4204702
              ],
              [
                54.5051224,
                37.4204521
              ],
              [
                54.5047581,
                37.4205109
              ],
              [
                54.5044563,
                37.4207144
              ],
              [
                54.5043083,
                37.4212977
              ],
              [
                54.5041729,
                37.4214814
              ],
              [
                54.5038286,
                37.4215763
              ],
              [
                54.503269,
                37.4217042
              ],
              [
                54.5027778,
                37.4218417
              ],
              [
                54.5026007,
                37.4217585
              ],
              [
                54.5025604,
                37.4215475
              ],
              [
                54.5025926,
                37.4210168
              ],
              [
                54.5028342,
                37.4203102
              ],
              [
                54.5028181,
                37.4201375
              ],
              [
                54.5028221,
                37.420016
              ],
              [
                54.5026571,
                37.4198722
              ],
              [
                54.5023914,
                37.4197443
              ],
              [
                54.5019928,
                37.4197379
              ],
              [
                54.5015822,
                37.4196739
              ],
              [
                54.5013368,
                37.4195359
              ],
              [
                54.5011232,
                37.4193286
              ],
              [
                54.5009542,
                37.4190441
              ],
              [
                54.5007046,
                37.4189481
              ],
              [
                54.5003624,
                37.4190537
              ],
              [
                54.5000363,
                37.4193126
              ],
              [
                54.4996297,
                37.4198913
              ],
              [
                54.4994002,
                37.4200448
              ],
              [
                54.4987682,
                37.4199585
              ],
              [
                54.4979832,
                37.4200704
              ],
              [
                54.4973723,
                37.4204632
              ],
              [
                54.4966064,
                37.420534
              ],
              [
                54.4956925,
                37.4209464
              ],
              [
                54.4945814,
                37.420956
              ],
              [
                54.4938487,
                37.4210743
              ],
              [
                54.4937038,
                37.4210487
              ],
              [
                54.4936474,
                37.4209273
              ],
              [
                54.4926249,
                37.42055
              ],
              [
                54.4923391,
                37.4205724
              ],
              [
                54.4921136,
                37.420566
              ],
              [
                54.4916386,
                37.4203517
              ],
              [
                54.4912722,
                37.4203901
              ],
              [
                54.4910307,
                37.4201599
              ],
              [
                54.4907335,
                37.4200773
              ],
              [
                54.4901611,
                37.4199649
              ],
              [
                54.4894928,
                37.4196739
              ],
              [
                54.4886716,
                37.4192615
              ],
              [
                54.488067,
                37.4187774
              ],
              [
                54.4874066,
                37.4182438
              ],
              [
                54.4870878,
                37.4178504
              ],
              [
                54.486712,
                37.4174977
              ],
              [
                54.4866152,
                37.4170365
              ],
              [
                54.4863932,
                37.4167516
              ],
              [
                54.4861655,
                37.4166069
              ],
              [
                54.4856343,
                37.4164874
              ],
              [
                54.4855717,
                37.4161257
              ],
              [
                54.4856457,
                37.4157323
              ],
              [
                54.4855034,
                37.4155288
              ],
              [
                54.4850991,
                37.4154248
              ],
              [
                54.4847177,
                37.4150495
              ],
              [
                54.4847006,
                37.4148369
              ],
              [
                54.4845009,
                37.4143988
              ],
              [
                54.4840801,
                37.4140366
              ],
              [
                54.4834196,
                37.4132814
              ],
              [
                54.4830837,
                37.4127704
              ],
              [
                54.4827307,
                37.4124312
              ],
              [
                54.4817743,
                37.4119112
              ],
              [
                54.4812733,
                37.411468
              ],
              [
                54.4801105,
                37.410874
              ],
              [
                54.4788707,
                37.4101023
              ],
              [
                54.4786487,
                37.4097858
              ],
              [
                54.4780964,
                37.4093562
              ],
              [
                54.4772424,
                37.4090505
              ],
              [
                54.4765564,
                37.4085987
              ],
              [
                54.4762575,
                37.4084381
              ],
              [
                54.4759614,
                37.4084042
              ],
              [
                54.4756807,
                37.4082161
              ],
              [
                54.4753824,
                37.4081003
              ],
              [
                54.4752226,
                37.4079332
              ],
              [
                54.4751964,
                37.4078043
              ],
              [
                54.4752854,
                37.4076359
              ],
              [
                54.4751545,
                37.4073847
              ],
              [
                54.4749863,
                37.4072684
              ],
              [
                54.4749313,
                37.407023
              ],
              [
                54.474769,
                37.4069564
              ],
              [
                54.4743894,
                37.4068795
              ],
              [
                54.4742324,
                37.4066424
              ],
              [
                54.4740334,
                37.4065031
              ],
              [
                54.4738894,
                37.4063908
              ],
              [
                54.473748,
                37.4060851
              ],
              [
                54.4735412,
                37.4058834
              ],
              [
                54.473193,
                37.4057773
              ],
              [
                54.4730439,
                37.4056886
              ],
              [
                54.4729625,
                37.4053945
              ],
              [
                54.4728182,
                37.4052354
              ],
              [
                54.4725553,
                37.405056
              ],
              [
                54.4723887,
                37.4046766
              ],
              [
                54.4721925,
                37.404259
              ],
              [
                54.4719925,
                37.4040619
              ],
              [
                54.4717001,
                37.4038737
              ],
              [
                54.4714372,
                37.4038972
              ],
              [
                54.4711188,
                37.4039678
              ],
              [
                54.4709374,
                37.4037973
              ],
              [
                54.4708263,
                37.4035679
              ],
              [
                54.4704857,
                37.4034649
              ],
              [
                54.4701451,
                37.4035355
              ],
              [
                54.4697267,
                37.4034943
              ],
              [
                54.4694528,
                37.4034237
              ],
              [
                54.469064,
                37.4034708
              ],
              [
                54.4687975,
                37.4034032
              ],
              [
                54.4686086,
                37.4032002
              ],
              [
                54.4683122,
                37.4030647
              ],
              [
                54.4680607,
                37.4028719
              ],
              [
                54.4678312,
                37.4027337
              ],
              [
                54.4674832,
                37.4027278
              ],
              [
                54.4670648,
                37.4025866
              ],
              [
                54.466602,
                37.402519
              ],
              [
                54.4663984,
                37.4025337
              ],
              [
                54.4661392,
                37.4025778
              ],
              [
                54.4658764,
                37.4024543
              ],
              [
                54.465321,
                37.4022896
              ],
              [
                54.4649582,
                37.402166
              ],
              [
                54.464516,
                37.402039
              ],
              [
                54.4637695,
                37.4021286
              ],
              [
                54.4633094,
                37.402101
              ],
              [
                54.4627582,
                37.4019355
              ],
              [
                54.4622678,
                37.4017356
              ],
              [
                54.4620039,
                37.4015382
              ],
              [
                54.4616602,
                37.4010847
              ],
              [
                54.4614331,
                37.4004167
              ],
              [
                54.460836,
                37.3997941
              ],
              [
                54.4600233,
                37.3992862
              ],
              [
                54.4592985,
                37.3989828
              ],
              [
                54.4590511,
                37.3986345
              ],
              [
                54.4588862,
                37.3984345
              ],
              [
                54.4582829,
                37.3981759
              ],
              [
                54.4581527,
                37.3980001
              ],
              [
                54.4578464,
                37.3973495
              ],
              [
                54.4577751,
                37.3968898
              ],
              [
                54.4576899,
                37.3967453
              ],
              [
                54.4574903,
                37.396697
              ],
              [
                54.4572326,
                37.3965106
              ],
              [
                54.4569456,
                37.3961768
              ],
              [
                54.4567001,
                37.3961304
              ],
              [
                54.4565927,
                37.3961012
              ],
              [
                54.4565629,
                37.3959997
              ],
              [
                54.4565587,
                37.3959155
              ],
              [
                54.4565087,
                37.3958535
              ],
              [
                54.4563156,
                37.3958362
              ],
              [
                54.4562071,
                37.395869
              ],
              [
                54.4561442,
                37.3958466
              ],
              [
                54.4561225,
                37.3957811
              ],
              [
                54.4561507,
                37.3954759
              ],
              [
                54.4561594,
                37.3952828
              ],
              [
                54.4561033,
                37.3951484
              ],
              [
                54.4559867,
                37.3950671
              ],
              [
                54.4557878,
                37.395011
              ],
              [
                54.4555967,
                37.3950276
              ],
              [
                54.4554056,
                37.3950068
              ],
              [
                54.4551935,
                37.3949403
              ],
              [
                54.4549631,
                37.3949548
              ],
              [
                54.4548558,
                37.3948113
              ],
              [
                54.4547746,
                37.3947843
              ],
              [
                54.4545731,
                37.3947635
              ],
              [
                54.4543715,
                37.3946512
              ],
              [
                54.4541333,
                37.3946907
              ],
              [
                54.4539386,
                37.3946646
              ],
              [
                54.45367,
                37.3946108
              ],
              [
                54.4535145,
                37.3944137
              ],
              [
                54.453396,
                37.3943961
              ],
              [
                54.4532479,
                37.3944314
              ],
              [
                54.4532183,
                37.3945696
              ],
              [
                54.4529406,
                37.3946902
              ],
              [
                54.4527,
                37.3946696
              ],
              [
                54.4521298,
                37.3948079
              ],
              [
                54.4519151,
                37.3947343
              ],
              [
                54.4517352,
                37.3947752
              ],
              [
                54.451531,
                37.3948217
              ],
              [
                54.4513375,
                37.3948255
              ],
              [
                54.4511709,
                37.3946137
              ],
              [
                54.4508525,
                37.3945225
              ],
              [
                54.4504711,
                37.3944388
              ],
              [
                54.4502194,
                37.3942078
              ],
              [
                54.4496632,
                37.3939101
              ],
              [
                54.4495012,
                37.3936548
              ],
              [
                54.4492457,
                37.393496
              ],
              [
                54.4491088,
                37.3932371
              ],
              [
                54.4485904,
                37.3927959
              ],
              [
                54.4482386,
                37.3925017
              ],
              [
                54.4480055,
                37.3923871
              ],
              [
                54.4478574,
                37.3922047
              ],
              [
                54.4478356,
                37.3918366
              ],
              [
                54.4476172,
                37.3914322
              ],
              [
                54.4475131,
                37.391384
              ],
              [
                54.4473835,
                37.3914193
              ],
              [
                54.4473205,
                37.3914987
              ],
              [
                54.4471238,
                37.3915125
              ],
              [
                54.4466023,
                37.3914929
              ],
              [
                54.4463839,
                37.3915282
              ],
              [
                54.4462061,
                37.391484
              ],
              [
                54.4460803,
                37.3914664
              ],
              [
                54.4458581,
                37.3914929
              ],
              [
                54.4456841,
                37.3913899
              ],
              [
                54.4456767,
                37.3910163
              ],
              [
                54.4455027,
                37.3907339
              ],
              [
                54.4452102,
                37.3903898
              ],
              [
                54.4450447,
                37.3903122
              ],
              [
                54.4448992,
                37.3903339
              ],
              [
                54.4446993,
                37.3903957
              ],
              [
                54.4445734,
                37.3902986
              ],
              [
                54.4445549,
                37.390128
              ],
              [
                54.444218,
                37.3897632
              ],
              [
                54.4437663,
                37.3895662
              ],
              [
                54.4434887,
                37.3893661
              ],
              [
                54.4432702,
                37.3891779
              ],
              [
                54.4429259,
                37.3891896
              ],
              [
                54.442552,
                37.3893191
              ],
              [
                54.442241,
                37.3893955
              ],
              [
                54.4418477,
                37.3891424
              ],
              [
                54.4414801,
                37.3890219
              ],
              [
                54.4412061,
                37.3890543
              ],
              [
                54.4408174,
                37.3889484
              ],
              [
                54.4405471,
                37.389019
              ],
              [
                54.4403953,
                37.3889131
              ],
              [
                54.4402991,
                37.388666
              ],
              [
                54.4398548,
                37.3884924
              ],
              [
                54.4393323,
                37.3883475
              ],
              [
                54.4388047,
                37.3882394
              ],
              [
                54.4384333,
                37.3880991
              ],
              [
                54.4380642,
                37.387806
              ],
              [
                54.4297094,
                37.382206
              ],
              [
                54.4188565,
                37.3749273
              ],
              [
                54.4082085,
                37.367778
              ],
              [
                54.3976597,
                37.3606995
              ],
              [
                54.3726605,
                37.3546483
              ],
              [
                54.3476436,
                37.3486292
              ],
              [
                54.3296932,
                37.3495358
              ],
              [
                54.3074765,
                37.3506518
              ],
              [
                54.2851929,
                37.351769
              ],
              [
                54.262637,
                37.3321853
              ],
              [
                54.2491366,
                37.323784
              ],
              [
                54.246327,
                37.3229226
              ],
              [
                54.2458388,
                37.3224859
              ],
              [
                54.245475,
                37.3219965
              ],
              [
                54.2446779,
                37.3199856
              ],
              [
                54.2242496,
                37.3216901
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554941,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بندر گز",
          "name:en": "Bandar-e-Gaz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286460",
          "wikipedia": "en:Bandar-e Gaz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.8548049,
                36.939096
              ],
              [
                53.8565366,
                36.9023082
              ],
              [
                53.8574156,
                36.8836278
              ],
              [
                53.8621766,
                36.7823724
              ],
              [
                53.8622148,
                36.7815592
              ],
              [
                53.8622148,
                36.7811231
              ],
              [
                53.8624914,
                36.780844
              ],
              [
                53.8622148,
                36.7805649
              ],
              [
                53.8624915,
                36.7800067
              ],
              [
                53.8622148,
                36.7769544
              ],
              [
                53.8616582,
                36.7636195
              ],
              [
                53.8661048,
                36.7494471
              ],
              [
                53.8644382,
                36.7447289
              ],
              [
                53.8608248,
                36.7397225
              ],
              [
                53.8605482,
                36.7391733
              ],
              [
                53.8602681,
                36.7358417
              ],
              [
                53.8611015,
                36.7333385
              ],
              [
                53.8616582,
                36.7300068
              ],
              [
                53.8619348,
                36.7250003
              ],
              [
                53.8622149,
                36.7233345
              ],
              [
                53.8624915,
                36.7230554
              ],
              [
                53.8624915,
                36.7050012
              ],
              [
                53.8622148,
                36.7044429
              ],
              [
                53.8608248,
                36.698896
              ],
              [
                53.8608248,
                36.6972211
              ],
              [
                53.8613815,
                36.6961134
              ],
              [
                53.8619348,
                36.6941684
              ],
              [
                53.8622149,
                36.6936191
              ],
              [
                53.8622148,
                36.6925025
              ],
              [
                53.8622148,
                36.6902783
              ],
              [
                53.8619348,
                36.6861091
              ],
              [
                53.8647148,
                36.6794543
              ],
              [
                53.869158,
                36.6736101
              ],
              [
                53.8711345,
                36.672555
              ],
              [
                53.8733247,
                36.6713859
              ],
              [
                53.8747147,
                36.6711157
              ],
              [
                53.8827713,
                36.6691706
              ],
              [
                53.8872145,
                36.6691705
              ],
              [
                53.8883279,
                36.6694497
              ],
              [
                53.8911045,
                36.6694497
              ],
              [
                53.8927711,
                36.6694497
              ],
              [
                53.8936045,
                36.6697289
              ],
              [
                53.8949945,
                36.6697289
              ],
              [
                53.8958278,
                36.6700081
              ],
              [
                53.8972144,
                36.670008
              ],
              [
                53.9044377,
                36.6713858
              ],
              [
                53.9063844,
                36.6713858
              ],
              [
                53.9130509,
                36.6730608
              ],
              [
                53.9205508,
                36.6755551
              ],
              [
                53.9233274,
                36.6758343
              ],
              [
                53.9244409,
                36.6761135
              ],
              [
                53.9266608,
                36.6761135
              ],
              [
                53.9280508,
                36.6763926
              ],
              [
                53.929994,
                36.6763926
              ],
              [
                53.932774,
                36.6769419
              ],
              [
                53.9383272,
                36.676942
              ],
              [
                53.9391606,
                36.6766628
              ],
              [
                53.9465393,
                36.6767714
              ],
              [
                53.9472172,
                36.6769419
              ],
              [
                53.9499972,
                36.6769419
              ],
              [
                53.9511072,
                36.6766628
              ],
              [
                53.9647204,
                36.675285
              ],
              [
                53.9738474,
                36.669847
              ],
              [
                53.9744402,
                36.6694497
              ],
              [
                53.9922201,
                36.6544471
              ],
              [
                53.9936101,
                36.6533394
              ],
              [
                53.9969433,
                36.6513942
              ],
              [
                54.0109196,
                36.6450476
              ],
              [
                54.0136963,
                36.6447684
              ],
              [
                54.014253,
                36.6444893
              ],
              [
                54.0167529,
                36.6444893
              ],
              [
                54.0173096,
                36.644219
              ],
              [
                54.0184196,
                36.6442191
              ],
              [
                54.0186962,
                36.6439399
              ],
              [
                54.0195295,
                36.6439398
              ],
              [
                54.0198095,
                36.6450477
              ],
              [
                54.0288761,
                36.664737
              ],
              [
                54.0347094,
                36.6722384
              ],
              [
                54.0380562,
                36.6836147
              ],
              [
                54.0404847,
                36.6844703
              ],
              [
                54.0438181,
                36.6880723
              ],
              [
                54.0457614,
                36.6891889
              ],
              [
                54.0449386,
                36.7074859
              ],
              [
                54.0477188,
                36.7177598
              ],
              [
                54.0479954,
                36.7188762
              ],
              [
                54.0523907,
                36.7468627
              ],
              [
                54.0460523,
                36.7539294
              ],
              [
                54.0449391,
                36.7575389
              ],
              [
                54.0432726,
                36.7644878
              ],
              [
                54.0429961,
                36.7689255
              ],
              [
                54.0427194,
                36.7700326
              ],
              [
                54.042996,
                36.7705907
              ],
              [
                54.0435528,
                36.773093
              ],
              [
                54.0466061,
                36.7800327
              ],
              [
                54.0463295,
                36.783084
              ],
              [
                54.0424397,
                36.7867025
              ],
              [
                54.0446537,
                36.8089086
              ],
              [
                54.0435438,
                36.8122489
              ],
              [
                54.0438205,
                36.8133563
              ],
              [
                54.0446539,
                36.8172458
              ],
              [
                54.0446544,
                36.8214816
              ],
              [
                54.0389923,
                36.8188807
              ],
              [
                54.0361318,
                36.8177308
              ],
              [
                54.0361293,
                36.8177298
              ],
              [
                54.0341054,
                36.8190855
              ],
              [
                54.0331033,
                36.8195543
              ],
              [
                54.033079,
                36.8195657
              ],
              [
                54.0354901,
                36.8281084
              ],
              [
                54.0382085,
                36.8328927
              ],
              [
                54.0401325,
                36.8389133
              ],
              [
                54.0428001,
                36.8533515
              ],
              [
                54.0439008,
                36.864659
              ],
              [
                54.0440344,
                36.8657596
              ],
              [
                54.0441016,
                36.8764326
              ],
              [
                54.0430533,
                36.8856187
              ],
              [
                54.0420313,
                36.8896871
              ],
              [
                54.0421623,
                36.8916163
              ],
              [
                54.0417692,
                36.8950134
              ],
              [
                54.0425696,
                36.8950157
              ],
              [
                54.0424462,
                36.8963227
              ],
              [
                54.043181,
                36.8965782
              ],
              [
                54.0428202,
                36.8971905
              ],
              [
                54.0429406,
                36.8978931
              ],
              [
                54.0430739,
                36.8984005
              ],
              [
                54.0441345,
                36.8986698
              ],
              [
                54.0439062,
                36.9015698
              ],
              [
                54.0433672,
                36.9017302
              ],
              [
                54.0433207,
                36.9030948
              ],
              [
                54.0425764,
                36.9039756
              ],
              [
                54.0420902,
                36.9071028
              ],
              [
                54.0413826,
                36.9124698
              ],
              [
                54.0407536,
                36.9158239
              ],
              [
                54.0414874,
                36.921379
              ],
              [
                54.0437061,
                36.9230106
              ],
              [
                54.0436778,
                36.9237615
              ],
              [
                54.044589,
                36.9241179
              ],
              [
                54.0442145,
                36.9389184
              ],
              [
                53.8632038,
                36.9334786
              ],
              [
                53.8571537,
                36.9375251
              ],
              [
                53.8548049,
                36.939096
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554964,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ترکمن",
          "name:en": "Torkaman County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292693",
          "wikipedia": "en:Torkaman County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.8548049,
                36.939096
              ],
              [
                53.8571537,
                36.9375251
              ],
              [
                53.8632038,
                36.9334786
              ],
              [
                54.0442145,
                36.9389184
              ],
              [
                54.044589,
                36.9241179
              ],
              [
                54.0436778,
                36.9237615
              ],
              [
                54.0437061,
                36.9230106
              ],
              [
                54.0414874,
                36.921379
              ],
              [
                54.0407536,
                36.9158239
              ],
              [
                54.0413826,
                36.9124698
              ],
              [
                54.0420902,
                36.9071028
              ],
              [
                54.0425764,
                36.9039756
              ],
              [
                54.0433207,
                36.9030948
              ],
              [
                54.0433672,
                36.9017302
              ],
              [
                54.0439062,
                36.9015698
              ],
              [
                54.0441345,
                36.8986698
              ],
              [
                54.0430739,
                36.8984005
              ],
              [
                54.0429406,
                36.8978931
              ],
              [
                54.0428202,
                36.8971905
              ],
              [
                54.043181,
                36.8965782
              ],
              [
                54.0424462,
                36.8963227
              ],
              [
                54.0425696,
                36.8950157
              ],
              [
                54.0417692,
                36.8950134
              ],
              [
                54.0421623,
                36.8916163
              ],
              [
                54.0420313,
                36.8896871
              ],
              [
                54.0430533,
                36.8856187
              ],
              [
                54.0441016,
                36.8764326
              ],
              [
                54.0440344,
                36.8657596
              ],
              [
                54.0439008,
                36.864659
              ],
              [
                54.0428001,
                36.8533515
              ],
              [
                54.0401325,
                36.8389133
              ],
              [
                54.0382085,
                36.8328927
              ],
              [
                54.0354901,
                36.8281084
              ],
              [
                54.033079,
                36.8195657
              ],
              [
                54.0331033,
                36.8195543
              ],
              [
                54.0341054,
                36.8190855
              ],
              [
                54.0361293,
                36.8177298
              ],
              [
                54.0361318,
                36.8177308
              ],
              [
                54.0389923,
                36.8188807
              ],
              [
                54.0446544,
                36.8214816
              ],
              [
                54.0674724,
                36.831959
              ],
              [
                54.0725676,
                36.8442279
              ],
              [
                54.089357,
                36.8590889
              ],
              [
                54.1132727,
                36.8605607
              ],
              [
                54.115967,
                36.8609319
              ],
              [
                54.1163313,
                36.860982
              ],
              [
                54.1163066,
                36.8610244
              ],
              [
                54.1157831,
                36.8619245
              ],
              [
                54.1158079,
                36.8619277
              ],
              [
                54.1213421,
                36.8626318
              ],
              [
                54.123823,
                36.862376
              ],
              [
                54.126314,
                36.8623736
              ],
              [
                54.1281253,
                36.8622505
              ],
              [
                54.1300119,
                36.8619454
              ],
              [
                54.1317474,
                36.8615191
              ],
              [
                54.1333315,
                36.860911
              ],
              [
                54.137029,
                36.86024
              ],
              [
                54.1404256,
                36.8602364
              ],
              [
                54.1426145,
                36.860234
              ],
              [
                54.1451061,
                36.8606558
              ],
              [
                54.1477486,
                36.8610168
              ],
              [
                54.1505421,
                36.8614382
              ],
              [
                54.1526565,
                36.8619209
              ],
              [
                54.1536387,
                36.8624656
              ],
              [
                54.1541622,
                36.8630946
              ],
              [
                54.1550001,
                36.8639197
              ],
              [
                54.1558321,
                36.8648285
              ],
              [
                54.1569659,
                36.8656763
              ],
              [
                54.1577222,
                36.8664638
              ],
              [
                54.1590822,
                36.8671294
              ],
              [
                54.1611978,
                36.8681579
              ],
              [
                54.1660935,
                36.8693517
              ],
              [
                54.1694964,
                36.870354
              ],
              [
                54.1741523,
                36.8713546
              ],
              [
                54.1798838,
                36.8730726
              ],
              [
                54.1832867,
                36.8739307
              ],
              [
                54.1875853,
                36.8750751
              ],
              [
                54.1913473,
                36.876364
              ],
              [
                54.1962985,
                36.8787791
              ],
              [
                54.2194178,
                36.8804819
              ],
              [
                54.2290766,
                36.8797921
              ],
              [
                54.2371787,
                36.8805463
              ],
              [
                54.2472971,
                36.8903394
              ],
              [
                54.2498355,
                36.8912857
              ],
              [
                54.2612219,
                36.8955299
              ],
              [
                54.2749619,
                36.9006496
              ],
              [
                54.3127392,
                36.9096223
              ],
              [
                54.3195819,
                36.9155878
              ],
              [
                54.3204832,
                36.9167544
              ],
              [
                54.3219852,
                36.916377
              ],
              [
                54.3240022,
                36.9170632
              ],
              [
                54.328165,
                36.920357
              ],
              [
                54.3332969,
                36.9196382
              ],
              [
                54.3360568,
                36.9200874
              ],
              [
                54.3377738,
                36.9209768
              ],
              [
                54.3376493,
                36.9241996
              ],
              [
                54.3401715,
                36.926379
              ],
              [
                54.3428528,
                36.9285485
              ],
              [
                54.3451244,
                36.9265444
              ],
              [
                54.3483795,
                36.9309596
              ],
              [
                54.3503227,
                36.9323368
              ],
              [
                54.357516,
                36.933902
              ],
              [
                54.3594593,
                36.9383399
              ],
              [
                54.3594593,
                36.9408424
              ],
              [
                54.3605727,
                36.9447311
              ],
              [
                54.361406,
                36.9461175
              ],
              [
                54.3616826,
                36.9472337
              ],
              [
                54.3583494,
                36.9569556
              ],
              [
                54.3530694,
                36.9647329
              ],
              [
                54.3441244,
                36.9790174
              ],
              [
                54.342325,
                36.9775832
              ],
              [
                54.3392466,
                36.9760506
              ],
              [
                54.3376969,
                36.9726654
              ],
              [
                54.3369117,
                36.9683538
              ],
              [
                54.3361241,
                36.9634259
              ],
              [
                54.3360946,
                36.9560311
              ],
              [
                54.3360848,
                36.9535662
              ],
              [
                54.3353023,
                36.9498707
              ],
              [
                54.3329867,
                36.9467954
              ],
              [
                54.3283692,
                36.9440339
              ],
              [
                54.3245257,
                36.942811
              ],
              [
                54.3199181,
                36.9425142
              ],
              [
                54.3156956,
                36.9425244
              ],
              [
                54.3099375,
                36.9425382
              ],
              [
                54.3030279,
                36.9425543
              ],
              [
                54.2957343,
                36.942571
              ],
              [
                54.288444,
                36.9435116
              ],
              [
                54.2846094,
                36.9447525
              ],
              [
                54.2800039,
                36.9450706
              ],
              [
                54.2746305,
                36.9453901
              ],
              [
                54.2673436,
                36.947562
              ],
              [
                54.2623587,
                36.9494208
              ],
              [
                54.2577604,
                36.9522031
              ],
              [
                54.2550842,
                36.9559058
              ],
              [
                54.2550944,
                36.9592951
              ],
              [
                54.2524142,
                36.9617652
              ],
              [
                54.24858,
                36.9636212
              ],
              [
                54.2432098,
                36.96548
              ],
              [
                54.2370663,
                36.9654913
              ],
              [
                54.2313058,
                36.9651935
              ],
              [
                54.2243918,
                36.9642811
              ],
              [
                54.217478,
                36.9633684
              ],
              [
                54.2086422,
                36.9615341
              ],
              [
                54.2021098,
                36.9593875
              ],
              [
                54.195582,
                36.9590893
              ],
              [
                54.1879031,
                36.9591005
              ],
              [
                54.1832977,
                36.9600314
              ],
              [
                54.1752361,
                36.9606587
              ],
              [
                54.1667952,
                36.9637509
              ],
              [
                54.1608719,
                36.9667382
              ],
              [
                54.1608651,
                36.9667306
              ],
              [
                54.137827,
                36.9719848
              ],
              [
                54.1166202,
                36.9720827
              ],
              [
                54.0451133,
                36.9479997
              ],
              [
                53.8548049,
                36.939096
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555037,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رامیان",
          "name:en": "Ramian County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q426494",
          "wikipedia": "en:Ramian County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.9135612,
                37.0639919
              ],
              [
                54.9136534,
                37.0633469
              ],
              [
                54.9139301,
                37.0622399
              ],
              [
                54.9042102,
                37.0539055
              ],
              [
                54.9042103,
                37.0533475
              ],
              [
                54.9030968,
                37.0519524
              ],
              [
                54.9033769,
                37.0514034
              ],
              [
                54.9055968,
                37.044455
              ],
              [
                54.9128201,
                37.0369575
              ],
              [
                54.9144868,
                37.0347343
              ],
              [
                54.9322664,
                37.0155627
              ],
              [
                54.9322665,
                37.0147346
              ],
              [
                54.9336531,
                37.0114043
              ],
              [
                54.9342098,
                37.0058416
              ],
              [
                54.9354424,
                37.000669
              ],
              [
                54.9355997,
                37.000009
              ],
              [
                54.9367098,
                36.9955624
              ],
              [
                54.9369864,
                36.9947343
              ],
              [
                54.9375431,
                36.9897296
              ],
              [
                54.9355998,
                36.9858411
              ],
              [
                54.9308765,
                36.9811243
              ],
              [
                54.9333765,
                36.9738963
              ],
              [
                54.937543,
                36.9691796
              ],
              [
                54.9378197,
                36.9686215
              ],
              [
                54.938653,
                36.9641747
              ],
              [
                54.9353197,
                36.9572344
              ],
              [
                54.935043,
                36.954453
              ],
              [
                54.9353197,
                36.9533457
              ],
              [
                54.9353197,
                36.9527876
              ],
              [
                54.9372664,
                36.9466755
              ],
              [
                54.9369864,
                36.9455682
              ],
              [
                54.9294865,
                36.9322364
              ],
              [
                54.9292098,
                36.9316784
              ],
              [
                54.9311532,
                36.9247288
              ],
              [
                54.9317098,
                36.9244587
              ],
              [
                54.9319864,
                36.9239006
              ],
              [
                54.936153,
                36.9200117
              ],
              [
                54.936153,
                36.9194535
              ],
              [
                54.941433,
                36.9158437
              ],
              [
                54.9547661,
                36.9086239
              ],
              [
                54.9553228,
                36.9080658
              ],
              [
                54.9967124,
                36.8752878
              ],
              [
                55.0244921,
                36.8655649
              ],
              [
                55.0300487,
                36.8633412
              ],
              [
                55.0311586,
                36.862783
              ],
              [
                55.0317154,
                36.862783
              ],
              [
                55.0675483,
                36.8477842
              ],
              [
                55.0680804,
                36.8473415
              ],
              [
                55.0692149,
                36.8463977
              ],
              [
                55.0694949,
                36.8458395
              ],
              [
                55.1211644,
                36.7925036
              ],
              [
                55.1222743,
                36.7919454
              ],
              [
                55.1225509,
                36.7913962
              ],
              [
                55.1267174,
                36.7875067
              ],
              [
                55.1267174,
                36.7872275
              ],
              [
                55.1278309,
                36.7855618
              ],
              [
                55.1281075,
                36.7833379
              ],
              [
                55.1297741,
                36.7833379
              ],
              [
                55.1303308,
                36.783617
              ],
              [
                55.1311642,
                36.783617
              ],
              [
                55.1317209,
                36.7838961
              ],
              [
                55.1372741,
                36.7838961
              ],
              [
                55.1386642,
                36.7841752
              ],
              [
                55.1417208,
                36.7841753
              ],
              [
                55.1553305,
                36.7855618
              ],
              [
                55.1806102,
                36.7866692
              ],
              [
                55.1878336,
                36.7872274
              ],
              [
                55.1906102,
                36.7872275
              ],
              [
                55.1945001,
                36.7877857
              ],
              [
                55.1986668,
                36.7877857
              ],
              [
                55.2075566,
                36.788614
              ],
              [
                55.2172799,
                36.788614
              ],
              [
                55.2197798,
                36.7888931
              ],
              [
                55.2233898,
                36.7888932
              ],
              [
                55.2258898,
                36.7891723
              ],
              [
                55.2281131,
                36.7891722
              ],
              [
                55.229223,
                36.7894514
              ],
              [
                55.231723,
                36.7894513
              ],
              [
                55.2542261,
                36.7922245
              ],
              [
                55.2661693,
                36.7947275
              ],
              [
                55.2683926,
                36.7955648
              ],
              [
                55.2728359,
                36.7980589
              ],
              [
                55.273116,
                36.798338
              ],
              [
                55.2723725,
                36.798917
              ],
              [
                55.2717259,
                36.8169571
              ],
              [
                55.2692259,
                36.8438948
              ],
              [
                55.2689494,
                36.8500078
              ],
              [
                55.2689494,
                36.8527897
              ],
              [
                55.2686694,
                36.8533389
              ],
              [
                55.2689494,
                36.8550044
              ],
              [
                55.2678361,
                36.8783396
              ],
              [
                55.2667261,
                36.8947242
              ],
              [
                55.2689495,
                36.9105593
              ],
              [
                55.2689495,
                36.9202906
              ],
              [
                55.2711693,
                36.9372324
              ],
              [
                55.2706162,
                36.961123
              ],
              [
                55.2675594,
                36.966956
              ],
              [
                55.2671424,
                36.967375
              ],
              [
                55.2647828,
                36.9683422
              ],
              [
                55.2636695,
                36.9683423
              ],
              [
                55.2356131,
                36.9827895
              ],
              [
                55.2345031,
                36.9833476
              ],
              [
                55.2231133,
                36.9902876
              ],
              [
                55.2178332,
                36.9941761
              ],
              [
                55.2117233,
                36.9969575
              ],
              [
                55.2089468,
                36.9994598
              ],
              [
                55.2017235,
                37.0027902
              ],
              [
                55.1928336,
                37.0077947
              ],
              [
                55.1922769,
                37.0080648
              ],
              [
                55.1853338,
                37.0138974
              ],
              [
                55.1811672,
                37.0219532
              ],
              [
                55.179777,
                37.0294599
              ],
              [
                55.1797771,
                37.0325111
              ],
              [
                55.1767205,
                37.0411247
              ],
              [
                55.1736672,
                37.0483432
              ],
              [
                55.1578307,
                37.0605657
              ],
              [
                55.1539441,
                37.0644538
              ],
              [
                55.1411642,
                37.0741831
              ],
              [
                55.1404288,
                37.0746335
              ],
              [
                55.1350544,
                37.0788992
              ],
              [
                55.1331076,
                37.0805731
              ],
              [
                55.131441,
                37.0822381
              ],
              [
                55.1306076,
                37.0827871
              ],
              [
                55.1300543,
                37.0836242
              ],
              [
                55.1294977,
                37.0839031
              ],
              [
                55.1222745,
                37.0983481
              ],
              [
                55.1181078,
                37.102515
              ],
              [
                55.1125513,
                37.1058448
              ],
              [
                55.1086612,
                37.1072399
              ],
              [
                55.1078279,
                37.1072399
              ],
              [
                55.1031081,
                37.1091838
              ],
              [
                55.1000514,
                37.1094538
              ],
              [
                55.0989414,
                37.1097327
              ],
              [
                55.0978281,
                37.1097328
              ],
              [
                55.090328,
                37.1125137
              ],
              [
                55.0831049,
                37.1175175
              ],
              [
                55.0811616,
                37.1191824
              ],
              [
                55.0689384,
                37.1330686
              ],
              [
                55.0558819,
                37.140844
              ],
              [
                55.0550486,
                37.141123
              ],
              [
                55.0544953,
                37.141681
              ],
              [
                55.0542152,
                37.1425179
              ],
              [
                55.0539386,
                37.1427879
              ],
              [
                55.0453253,
                37.1447407
              ],
              [
                55.0442153,
                37.1450107
              ],
              [
                55.0428253,
                37.1450107
              ],
              [
                55.0417154,
                37.1452897
              ],
              [
                55.0306021,
                37.1452896
              ],
              [
                55.0292156,
                37.1455687
              ],
              [
                55.0267156,
                37.1455686
              ],
              [
                55.0261589,
                37.1452897
              ],
              [
                55.0233823,
                37.1452897
              ],
              [
                55.0225488,
                37.1450107
              ],
              [
                55.0206023,
                37.1450107
              ],
              [
                55.0158789,
                37.1425179
              ],
              [
                55.0156022,
                37.14196
              ],
              [
                55.0150457,
                37.14196
              ],
              [
                55.0144923,
                37.1411231
              ],
              [
                55.013659,
                37.1408441
              ],
              [
                55.0133789,
                37.1402951
              ],
              [
                55.0075457,
                37.1361285
              ],
              [
                54.9969926,
                37.1227912
              ],
              [
                54.9953225,
                37.1200104
              ],
              [
                54.9861559,
                37.1105698
              ],
              [
                54.9853225,
                37.1094539
              ],
              [
                54.951433,
                37.0841822
              ],
              [
                54.9483763,
                37.0826995
              ],
              [
                54.9480996,
                37.0825172
              ],
              [
                54.9442097,
                37.0808432
              ],
              [
                54.91421,
                37.0647329
              ],
              [
                54.9135612,
                37.0639919
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555124,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان علی آباد کتول",
          "name:en": "Aliabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292562",
          "wikipedia": "en:Aliabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.6977154,
                36.9434829
              ],
              [
                54.6979921,
                36.9429248
              ],
              [
                54.6988254,
                36.9420878
              ],
              [
                54.6996588,
                36.9412597
              ],
              [
                54.7119755,
                36.9122249
              ],
              [
                54.7139221,
                36.9102894
              ],
              [
                54.7147555,
                36.9097313
              ],
              [
                54.7311453,
                36.8911234
              ],
              [
                54.7405885,
                36.8766743
              ],
              [
                54.7408685,
                36.8747297
              ],
              [
                54.7405885,
                36.872227
              ],
              [
                54.7403118,
                36.8708406
              ],
              [
                54.7380884,
                36.8588939
              ],
              [
                54.7378119,
                36.8572283
              ],
              [
                54.7375352,
                36.8547256
              ],
              [
                54.7369784,
                36.8505662
              ],
              [
                54.736702,
                36.8486215
              ],
              [
                54.7364218,
                36.8480634
              ],
              [
                54.7383685,
                36.8172274
              ],
              [
                54.7394785,
                36.7991755
              ],
              [
                54.7405885,
                36.7936202
              ],
              [
                54.7411451,
                36.7894515
              ],
              [
                54.7414217,
                36.7888933
              ],
              [
                54.7450351,
                36.7633403
              ],
              [
                54.744755,
                36.75584
              ],
              [
                54.7444785,
                36.7544443
              ],
              [
                54.7430884,
                36.7480603
              ],
              [
                54.7425351,
                36.747232
              ],
              [
                54.7397551,
                36.7352833
              ],
              [
                54.7394784,
                36.7333384
              ],
              [
                54.7392018,
                36.7302858
              ],
              [
                54.7389217,
                36.7291693
              ],
              [
                54.7378119,
                36.7277827
              ],
              [
                54.7378118,
                36.7275035
              ],
              [
                54.7378118,
                36.7266751
              ],
              [
                54.7358685,
                36.720561
              ],
              [
                54.7342019,
                36.7172204
              ],
              [
                54.727812,
                36.7005617
              ],
              [
                54.7244786,
                36.6944475
              ],
              [
                54.719305,
                36.6750275
              ],
              [
                54.7159717,
                36.6636465
              ],
              [
                54.7159718,
                36.6619809
              ],
              [
                54.715415,
                36.6597569
              ],
              [
                54.715415,
                36.6578121
              ],
              [
                54.7148618,
                36.6547597
              ],
              [
                54.7145818,
                36.6539223
              ],
              [
                54.7145817,
                36.6533731
              ],
              [
                54.7110434,
                36.6417761
              ],
              [
                54.7104868,
                36.6392727
              ],
              [
                54.7008655,
                36.6325007
              ],
              [
                54.7219787,
                36.6175062
              ],
              [
                54.7253119,
                36.6158312
              ],
              [
                54.747255,
                36.6041687
              ],
              [
                54.7550349,
                36.6019442
              ],
              [
                54.7617015,
                36.6008365
              ],
              [
                54.7642015,
                36.6008365
              ],
              [
                54.7655915,
                36.6005573
              ],
              [
                54.7669781,
                36.6005573
              ],
              [
                54.7678114,
                36.6002781
              ],
              [
                54.7780913,
                36.6002781
              ],
              [
                54.7889245,
                36.6027817
              ],
              [
                54.8231499,
                36.6100166
              ],
              [
                54.8378773,
                36.6291045
              ],
              [
                54.842324,
                36.6304911
              ],
              [
                54.8598237,
                36.6377129
              ],
              [
                54.9122631,
                36.6644427
              ],
              [
                54.9228197,
                36.6750057
              ],
              [
                54.923653,
                36.6766626
              ],
              [
                54.9472661,
                36.7047219
              ],
              [
                54.9472661,
                36.7050009
              ],
              [
                54.9475428,
                36.7052802
              ],
              [
                54.9478227,
                36.7055593
              ],
              [
                54.9478228,
                36.7058384
              ],
              [
                54.9589327,
                36.7183369
              ],
              [
                54.9769892,
                36.7422255
              ],
              [
                54.9806026,
                36.7472319
              ],
              [
                54.9872691,
                36.7547233
              ],
              [
                55.0014356,
                36.7641687
              ],
              [
                55.0100454,
                36.767221
              ],
              [
                55.0375485,
                36.7730645
              ],
              [
                55.0383819,
                36.7733347
              ],
              [
                55.0406052,
                36.7733347
              ],
              [
                55.0500485,
                36.7750094
              ],
              [
                55.0525483,
                36.7750094
              ],
              [
                55.0561617,
                36.7755586
              ],
              [
                55.0575483,
                36.7755586
              ],
              [
                55.0583817,
                36.7758377
              ],
              [
                55.0611616,
                36.7758377
              ],
              [
                55.0619949,
                36.7761168
              ],
              [
                55.0656049,
                36.7761168
              ],
              [
                55.0667149,
                36.776396
              ],
              [
                55.072828,
                36.7763959
              ],
              [
                55.0761615,
                36.7766751
              ],
              [
                55.079218,
                36.776675
              ],
              [
                55.0808847,
                36.7769542
              ],
              [
                55.084218,
                36.7769542
              ],
              [
                55.0908846,
                36.7775034
              ],
              [
                55.0956079,
                36.778899
              ],
              [
                55.1069943,
                36.7808439
              ],
              [
                55.1097745,
                36.7808438
              ],
              [
                55.1111644,
                36.7811229
              ],
              [
                55.1125511,
                36.7811229
              ],
              [
                55.115331,
                36.7811229
              ],
              [
                55.1161643,
                36.781123
              ],
              [
                55.1219976,
                36.781123
              ],
              [
                55.1278309,
                36.7830587
              ],
              [
                55.1281075,
                36.7833379
              ],
              [
                55.1278309,
                36.7855618
              ],
              [
                55.1267174,
                36.7872275
              ],
              [
                55.1267174,
                36.7875067
              ],
              [
                55.1225509,
                36.7913962
              ],
              [
                55.1222743,
                36.7919454
              ],
              [
                55.1211644,
                36.7925036
              ],
              [
                55.0694949,
                36.8458395
              ],
              [
                55.0692149,
                36.8463977
              ],
              [
                55.0680804,
                36.8473415
              ],
              [
                55.0675483,
                36.8477842
              ],
              [
                55.0317154,
                36.862783
              ],
              [
                55.0311586,
                36.862783
              ],
              [
                55.0300487,
                36.8633412
              ],
              [
                55.0244921,
                36.8655649
              ],
              [
                54.9967124,
                36.8752878
              ],
              [
                54.9553228,
                36.9080658
              ],
              [
                54.9547661,
                36.9086239
              ],
              [
                54.941433,
                36.9158437
              ],
              [
                54.936153,
                36.9194535
              ],
              [
                54.936153,
                36.9200117
              ],
              [
                54.9319864,
                36.9239006
              ],
              [
                54.9317098,
                36.9244587
              ],
              [
                54.9311532,
                36.9247288
              ],
              [
                54.9292098,
                36.9316784
              ],
              [
                54.9294865,
                36.9322364
              ],
              [
                54.9369864,
                36.9455682
              ],
              [
                54.9372664,
                36.9466755
              ],
              [
                54.9353197,
                36.9527876
              ],
              [
                54.9353197,
                36.9533457
              ],
              [
                54.935043,
                36.954453
              ],
              [
                54.9353197,
                36.9572344
              ],
              [
                54.938653,
                36.9641747
              ],
              [
                54.9378197,
                36.9686215
              ],
              [
                54.937543,
                36.9691796
              ],
              [
                54.9333765,
                36.9738963
              ],
              [
                54.9308765,
                36.9811243
              ],
              [
                54.9355998,
                36.9858411
              ],
              [
                54.9375431,
                36.9897296
              ],
              [
                54.9369864,
                36.9947343
              ],
              [
                54.9367098,
                36.9955624
              ],
              [
                54.9355997,
                37.000009
              ],
              [
                54.9354424,
                37.000669
              ],
              [
                54.9342098,
                37.0058416
              ],
              [
                54.9336531,
                37.0114043
              ],
              [
                54.9322665,
                37.0147346
              ],
              [
                54.9322664,
                37.0155627
              ],
              [
                54.9144868,
                37.0347343
              ],
              [
                54.9128201,
                37.0369575
              ],
              [
                54.9055968,
                37.044455
              ],
              [
                54.9033769,
                37.0514034
              ],
              [
                54.9030968,
                37.0519524
              ],
              [
                54.9042103,
                37.0533475
              ],
              [
                54.9042102,
                37.0539055
              ],
              [
                54.9139301,
                37.0622399
              ],
              [
                54.9136534,
                37.0633469
              ],
              [
                54.9135612,
                37.0639919
              ],
              [
                54.91171,
                37.0677931
              ],
              [
                54.9111535,
                37.068621
              ],
              [
                54.8978203,
                37.0855683
              ],
              [
                54.8883736,
                37.0897353
              ],
              [
                54.8872636,
                37.0897352
              ],
              [
                54.886707,
                37.0900142
              ],
              [
                54.8850404,
                37.0900142
              ],
              [
                54.8842069,
                37.0902933
              ],
              [
                54.8825404,
                37.0902932
              ],
              [
                54.8817071,
                37.0905723
              ],
              [
                54.8769837,
                37.0905722
              ],
              [
                54.8764305,
                37.0908512
              ],
              [
                54.8744838,
                37.0908513
              ],
              [
                54.8736505,
                37.0911212
              ],
              [
                54.8694839,
                37.0908513
              ],
              [
                54.8653171,
                37.0900142
              ],
              [
                54.8617073,
                37.0900142
              ],
              [
                54.8603173,
                37.0905723
              ],
              [
                54.8594839,
                37.0905722
              ],
              [
                54.8589273,
                37.0908512
              ],
              [
                54.858094,
                37.0911213
              ],
              [
                54.858094,
                37.0902932
              ],
              [
                54.8578174,
                37.0897352
              ],
              [
                54.8572606,
                37.0883492
              ],
              [
                54.8572607,
                37.0880702
              ],
              [
                54.8553174,
                37.0847403
              ],
              [
                54.854484,
                37.0841823
              ],
              [
                54.8439274,
                37.0764062
              ],
              [
                54.822261,
                37.0655699
              ],
              [
                54.8214278,
                37.06557
              ],
              [
                54.798648,
                37.0569567
              ],
              [
                54.7969813,
                37.0566777
              ],
              [
                54.7878147,
                37.0539055
              ],
              [
                54.7861481,
                37.0530685
              ],
              [
                54.7797582,
                37.0508454
              ],
              [
                54.766425,
                37.0447341
              ],
              [
                54.7628117,
                37.043348
              ],
              [
                54.736702,
                37.0363995
              ],
              [
                54.7358686,
                37.0363995
              ],
              [
                54.7239221,
                37.0316832
              ],
              [
                54.7233655,
                37.0311252
              ],
              [
                54.712969,
                37.025922
              ],
              [
                54.7116988,
                37.0250136
              ],
              [
                54.6994592,
                37.0233034
              ],
              [
                54.6845028,
                37.0182878
              ],
              [
                54.6833895,
                37.0149488
              ],
              [
                54.6811713,
                37.004885
              ],
              [
                54.6881827,
                36.9908459
              ],
              [
                54.6894758,
                36.9722311
              ],
              [
                54.6822859,
                36.9676974
              ],
              [
                54.6960822,
                36.9602762
              ],
              [
                54.6958055,
                36.95916
              ],
              [
                54.6944155,
                36.9544432
              ],
              [
                54.6977154,
                36.9434829
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555166,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کردکوی",
          "name:en": "Kordkuy County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286411",
          "wikipedia": "en:Kordkuy County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.0195295,
                36.6439398
              ],
              [
                54.0200862,
                36.6436607
              ],
              [
                54.0211962,
                36.6436607
              ],
              [
                54.0225861,
                36.6431023
              ],
              [
                54.0236961,
                36.6431024
              ],
              [
                54.0242528,
                36.6428231
              ],
              [
                54.0256428,
                36.6428231
              ],
              [
                54.0264761,
                36.642553
              ],
              [
                54.0275861,
                36.6425529
              ],
              [
                54.0307613,
                36.6439023
              ],
              [
                54.0346512,
                36.6439023
              ],
              [
                54.0477795,
                36.6422267
              ],
              [
                54.0699562,
                36.6323587
              ],
              [
                54.0832898,
                36.6224168
              ],
              [
                54.1498339,
                36.6169662
              ],
              [
                54.1506672,
                36.6161287
              ],
              [
                54.1559472,
                36.6130756
              ],
              [
                54.1645571,
                36.6036281
              ],
              [
                54.1662237,
                36.600575
              ],
              [
                54.1687237,
                36.5950181
              ],
              [
                54.1673306,
                36.5713915
              ],
              [
                54.167884,
                36.5691759
              ],
              [
                54.1698306,
                36.5494516
              ],
              [
                54.1687207,
                36.5416789
              ],
              [
                54.1515045,
                36.5241196
              ],
              [
                54.1512245,
                36.5221833
              ],
              [
                54.1503912,
                36.5174551
              ],
              [
                54.1501146,
                36.5152306
              ],
              [
                54.1498379,
                36.5127358
              ],
              [
                54.1505536,
                36.5091793
              ],
              [
                54.1518045,
                36.5073446
              ],
              [
                54.1548411,
                36.5064548
              ],
              [
                54.1612555,
                36.5057032
              ],
              [
                54.1645577,
                36.5061248
              ],
              [
                54.1709785,
                36.5067781
              ],
              [
                54.1723413,
                36.5057876
              ],
              [
                54.1725832,
                36.5052321
              ],
              [
                54.1729727,
                36.504826
              ],
              [
                54.1746296,
                36.5053178
              ],
              [
                54.1759101,
                36.5056977
              ],
              [
                54.1762582,
                36.505792
              ],
              [
                54.1779369,
                36.5057919
              ],
              [
                54.1789886,
                36.5057919
              ],
              [
                54.1795801,
                36.5060739
              ],
              [
                54.1813369,
                36.506334
              ],
              [
                54.1827294,
                36.5065402
              ],
              [
                54.1843423,
                36.5067789
              ],
              [
                54.1860666,
                36.5070342
              ],
              [
                54.1876265,
                36.5072651
              ],
              [
                54.189106,
                36.5074841
              ],
              [
                54.1905883,
                36.5077036
              ],
              [
                54.1920782,
                36.5079241
              ],
              [
                54.1936936,
                36.5081633
              ],
              [
                54.1951303,
                36.508376
              ],
              [
                54.1965468,
                36.5085857
              ],
              [
                54.1983021,
                36.5088455
              ],
              [
                54.1993511,
                36.5088454
              ],
              [
                54.2007506,
                36.5088454
              ],
              [
                54.2020733,
                36.5088453
              ],
              [
                54.2032262,
                36.5088453
              ],
              [
                54.2063842,
                36.5088451
              ],
              [
                54.2225074,
                36.5049987
              ],
              [
                54.234454,
                36.5049987
              ],
              [
                54.2489006,
                36.505548
              ],
              [
                54.2597338,
                36.5063857
              ],
              [
                54.2747335,
                36.5063857
              ],
              [
                54.2766769,
                36.5066649
              ],
              [
                54.2914,
                36.506665
              ],
              [
                54.2994566,
                36.5074936
              ],
              [
                54.3019566,
                36.5074936
              ],
              [
                54.3091799,
                36.5083312
              ],
              [
                54.3111232,
                36.5083312
              ],
              [
                54.3127897,
                36.5086104
              ],
              [
                54.3150131,
                36.5086104
              ],
              [
                54.3230697,
                36.5099975
              ],
              [
                54.325013,
                36.5099976
              ],
              [
                54.3258463,
                36.5102767
              ],
              [
                54.3311263,
                36.5102768
              ],
              [
                54.3327929,
                36.510556
              ],
              [
                54.3344595,
                36.5105559
              ],
              [
                54.3377929,
                36.5113846
              ],
              [
                54.3400162,
                36.5113846
              ],
              [
                54.3405695,
                36.5116638
              ],
              [
                54.3414028,
                36.5116638
              ],
              [
                54.3419595,
                36.511943
              ],
              [
                54.3444595,
                36.5122222
              ],
              [
                54.3439027,
                36.5136093
              ],
              [
                54.3427928,
                36.5230575
              ],
              [
                54.3430695,
                36.5238861
              ],
              [
                54.341297,
                36.5326745
              ],
              [
                54.3515967,
                36.5424671
              ],
              [
                54.3534775,
                36.5501366
              ],
              [
                54.3537542,
                36.5540183
              ],
              [
                54.3541716,
                36.5617729
              ],
              [
                54.3615838,
                36.5696355
              ],
              [
                54.3618639,
                36.5746332
              ],
              [
                54.3584631,
                36.5765248
              ],
              [
                54.3527983,
                36.5726647
              ],
              [
                54.3461761,
                36.5753845
              ],
              [
                54.3464527,
                36.5784465
              ],
              [
                54.3467328,
                36.5801126
              ],
              [
                54.3456278,
                36.5899762
              ],
              [
                54.3464612,
                36.5916421
              ],
              [
                54.348681,
                36.5955327
              ],
              [
                54.3622393,
                36.6102747
              ],
              [
                54.3630725,
                36.6111122
              ],
              [
                54.3665191,
                36.6114149
              ],
              [
                54.3676324,
                36.6130718
              ],
              [
                54.3715065,
                36.6234051
              ],
              [
                54.3717991,
                36.6241853
              ],
              [
                54.3780589,
                36.630866
              ],
              [
                54.3811922,
                36.6406133
              ],
              [
                54.3797456,
                36.6500154
              ],
              [
                54.3789123,
                36.6516904
              ],
              [
                54.3777989,
                36.655851
              ],
              [
                54.3727824,
                36.6697525
              ],
              [
                54.3711158,
                36.6783617
              ],
              [
                54.3711157,
                36.6797485
              ],
              [
                54.3677458,
                36.6836146
              ],
              [
                54.3652925,
                36.6894499
              ],
              [
                54.3641135,
                36.6999726
              ],
              [
                54.3601795,
                36.7038131
              ],
              [
                54.3566827,
                36.7072253
              ],
              [
                54.356406,
                36.7077836
              ],
              [
                54.355493,
                36.707863
              ],
              [
                54.3422362,
                36.7119527
              ],
              [
                54.3416829,
                36.7119527
              ],
              [
                54.3389145,
                36.711409
              ],
              [
                54.3320596,
                36.7097682
              ],
              [
                54.3245597,
                36.7092189
              ],
              [
                54.3217796,
                36.7086606
              ],
              [
                54.3195562,
                36.7086606
              ],
              [
                54.3184463,
                36.7083814
              ],
              [
                54.3162229,
                36.7083814
              ],
              [
                54.2950933,
                36.7000858
              ],
              [
                54.2920367,
                36.7000858
              ],
              [
                54.2906501,
                36.6998156
              ],
              [
                54.2839835,
                36.6998157
              ],
              [
                54.2812035,
                36.7003651
              ],
              [
                54.2738204,
                36.7088156
              ],
              [
                54.2710935,
                36.7266119
              ],
              [
                54.2708169,
                36.7316099
              ],
              [
                54.2708169,
                36.7318891
              ],
              [
                54.2708168,
                36.7324474
              ],
              [
                54.2710935,
                36.7329967
              ],
              [
                54.2710935,
                36.7335551
              ],
              [
                54.265722,
                36.7422721
              ],
              [
                54.2660021,
                36.7433796
              ],
              [
                54.265722,
                36.7442172
              ],
              [
                54.2660021,
                36.7444963
              ],
              [
                54.2631805,
                36.7563821
              ],
              [
                54.2631805,
                36.7599927
              ],
              [
                54.2615138,
                36.769996
              ],
              [
                54.2606805,
                36.7761096
              ],
              [
                54.265567,
                36.7800067
              ],
              [
                54.2658437,
                36.7816724
              ],
              [
                54.2666769,
                36.7861203
              ],
              [
                54.2697142,
                36.7969144
              ],
              [
                54.2751268,
                36.8054713
              ],
              [
                54.2748502,
                36.8113059
              ],
              [
                54.2557157,
                36.8177148
              ],
              [
                54.2543291,
                36.8243868
              ],
              [
                54.2573823,
                36.8313289
              ],
              [
                54.2626761,
                36.8319587
              ],
              [
                54.2608021,
                36.8415465
              ],
              [
                54.2605222,
                36.8426631
              ],
              [
                54.2602456,
                36.8429422
              ],
              [
                54.2591356,
                36.8440495
              ],
              [
                54.2577455,
                36.8446077
              ],
              [
                54.252189,
                36.8459942
              ],
              [
                54.2469256,
                36.8511373
              ],
              [
                54.2435924,
                36.853082
              ],
              [
                54.242759,
                36.8530819
              ],
              [
                54.2333659,
                36.861822
              ],
              [
                54.2308941,
                36.8667965
              ],
              [
                54.2260324,
                36.8735828
              ],
              [
                54.2251991,
                36.8738617
              ],
              [
                54.2226992,
                36.8769136
              ],
              [
                54.2226991,
                36.8771927
              ],
              [
                54.2194178,
                36.8804819
              ],
              [
                54.1962985,
                36.8787791
              ],
              [
                54.1913473,
                36.876364
              ],
              [
                54.1875853,
                36.8750751
              ],
              [
                54.1832867,
                36.8739307
              ],
              [
                54.1798838,
                36.8730726
              ],
              [
                54.1741523,
                36.8713546
              ],
              [
                54.1694964,
                36.870354
              ],
              [
                54.1660935,
                36.8693517
              ],
              [
                54.1611978,
                36.8681579
              ],
              [
                54.1590822,
                36.8671294
              ],
              [
                54.1577222,
                36.8664638
              ],
              [
                54.1569659,
                36.8656763
              ],
              [
                54.1558321,
                36.8648285
              ],
              [
                54.1550001,
                36.8639197
              ],
              [
                54.1541622,
                36.8630946
              ],
              [
                54.1536387,
                36.8624656
              ],
              [
                54.1526565,
                36.8619209
              ],
              [
                54.1505421,
                36.8614382
              ],
              [
                54.1477486,
                36.8610168
              ],
              [
                54.1451061,
                36.8606558
              ],
              [
                54.1426145,
                36.860234
              ],
              [
                54.1404256,
                36.8602364
              ],
              [
                54.137029,
                36.86024
              ],
              [
                54.1333315,
                36.860911
              ],
              [
                54.1317474,
                36.8615191
              ],
              [
                54.1300119,
                36.8619454
              ],
              [
                54.1281253,
                36.8622505
              ],
              [
                54.126314,
                36.8623736
              ],
              [
                54.123823,
                36.862376
              ],
              [
                54.1213421,
                36.8626318
              ],
              [
                54.1158079,
                36.8619277
              ],
              [
                54.1157831,
                36.8619245
              ],
              [
                54.1163066,
                36.8610244
              ],
              [
                54.1163313,
                36.860982
              ],
              [
                54.115967,
                36.8609319
              ],
              [
                54.1132727,
                36.8605607
              ],
              [
                54.089357,
                36.8590889
              ],
              [
                54.0725676,
                36.8442279
              ],
              [
                54.0674724,
                36.831959
              ],
              [
                54.0446544,
                36.8214816
              ],
              [
                54.0446539,
                36.8172458
              ],
              [
                54.0438205,
                36.8133563
              ],
              [
                54.0435438,
                36.8122489
              ],
              [
                54.0446537,
                36.8089086
              ],
              [
                54.0424397,
                36.7867025
              ],
              [
                54.0463295,
                36.783084
              ],
              [
                54.0466061,
                36.7800327
              ],
              [
                54.0435528,
                36.773093
              ],
              [
                54.042996,
                36.7705907
              ],
              [
                54.0427194,
                36.7700326
              ],
              [
                54.0429961,
                36.7689255
              ],
              [
                54.0432726,
                36.7644878
              ],
              [
                54.0449391,
                36.7575389
              ],
              [
                54.0460523,
                36.7539294
              ],
              [
                54.0523907,
                36.7468627
              ],
              [
                54.0479954,
                36.7188762
              ],
              [
                54.0477188,
                36.7177598
              ],
              [
                54.0449386,
                36.7074859
              ],
              [
                54.0457614,
                36.6891889
              ],
              [
                54.0438181,
                36.6880723
              ],
              [
                54.0404847,
                36.6844703
              ],
              [
                54.0380562,
                36.6836147
              ],
              [
                54.0347094,
                36.6722384
              ],
              [
                54.0288761,
                36.664737
              ],
              [
                54.0198095,
                36.6450477
              ],
              [
                54.0195295,
                36.6439398
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555171,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کلاله",
          "name:en": "Kalaleh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292702",
          "wikipedia": "en:Kalaleh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.2983928,
                37.5530821
              ],
              [
                55.2983929,
                37.5528033
              ],
              [
                55.2986729,
                37.551967
              ],
              [
                55.2995062,
                37.5464087
              ],
              [
                55.3075628,
                37.5241938
              ],
              [
                55.3097827,
                37.5205781
              ],
              [
                55.3589522,
                37.4708568
              ],
              [
                55.3628422,
                37.4672408
              ],
              [
                55.3939552,
                37.4333562
              ],
              [
                55.3942317,
                37.4311344
              ],
              [
                55.3947885,
                37.4300189
              ],
              [
                55.395065,
                37.4275182
              ],
              [
                55.3847885,
                37.4114073
              ],
              [
                55.3847885,
                37.4111284
              ],
              [
                55.3839553,
                37.4105796
              ],
              [
                55.3831219,
                37.4100219
              ],
              [
                55.3764554,
                37.4036349
              ],
              [
                55.3742319,
                37.4000187
              ],
              [
                55.373952,
                37.3997398
              ],
              [
                55.3686753,
                37.3908519
              ],
              [
                55.3686753,
                37.3900242
              ],
              [
                55.3658987,
                37.3844647
              ],
              [
                55.3604501,
                37.3735698
              ],
              [
                55.3547855,
                37.3622442
              ],
              [
                55.3467288,
                37.3505759
              ],
              [
                55.3464521,
                37.3494603
              ],
              [
                55.3458956,
                37.3486326
              ],
              [
                55.3458955,
                37.347517
              ],
              [
                55.3458955,
                37.3472471
              ],
              [
                55.3473725,
                37.3434043
              ],
              [
                55.350062,
                37.3364062
              ],
              [
                55.3522856,
                37.3341841
              ],
              [
                55.3609877,
                37.3241986
              ],
              [
                55.3633988,
                37.3244676
              ],
              [
                55.3645088,
                37.3244675
              ],
              [
                55.3656185,
                37.3247465
              ],
              [
                55.3689519,
                37.3250163
              ],
              [
                55.3692321,
                37.3247464
              ],
              [
                55.3700652,
                37.3247464
              ],
              [
                55.3703419,
                37.3250163
              ],
              [
                55.3722853,
                37.3250163
              ],
              [
                55.3767317,
                37.3258531
              ],
              [
                55.3808985,
                37.3258531
              ],
              [
                55.3817319,
                37.326132
              ],
              [
                55.3861751,
                37.3261319
              ],
              [
                55.3875651,
                37.3264109
              ],
              [
                55.390065,
                37.3264109
              ],
              [
                55.3917316,
                37.3266898
              ],
              [
                55.3961784,
                37.3266897
              ],
              [
                55.3995117,
                37.3261319
              ],
              [
                55.401455,
                37.3261319
              ],
              [
                55.402845,
                37.3258531
              ],
              [
                55.4156215,
                37.325853
              ],
              [
                55.4172881,
                37.3261319
              ],
              [
                55.4197881,
                37.326132
              ],
              [
                55.4214547,
                37.3264108
              ],
              [
                55.4247879,
                37.3264109
              ],
              [
                55.4311779,
                37.3272385
              ],
              [
                55.4334013,
                37.3272385
              ],
              [
                55.4347913,
                37.3275175
              ],
              [
                55.4370112,
                37.3275174
              ],
              [
                55.4384011,
                37.3277963
              ],
              [
                55.4403445,
                37.3277963
              ],
              [
                55.4417345,
                37.3280752
              ],
              [
                55.4434012,
                37.3280752
              ],
              [
                55.4445111,
                37.3283542
              ],
              [
                55.4472911,
                37.3283541
              ],
              [
                55.4481244,
                37.328633
              ],
              [
                55.4520145,
                37.328633
              ],
              [
                55.456079,
                37.3289086
              ],
              [
                55.4561279,
                37.3289119
              ],
              [
                55.4561281,
                37.328912
              ],
              [
                55.4585108,
                37.329063
              ],
              [
                55.4615463,
                37.3291908
              ],
              [
                55.5001973,
                37.3319002
              ],
              [
                55.5044086,
                37.3277422
              ],
              [
                55.5189603,
                37.3377916
              ],
              [
                55.5211836,
                37.3377916
              ],
              [
                55.5214603,
                37.3380795
              ],
              [
                55.5236837,
                37.3380795
              ],
              [
                55.5386835,
                37.3441882
              ],
              [
                55.5414602,
                37.3475169
              ],
              [
                55.5409068,
                37.3494602
              ],
              [
                55.5384068,
                37.3519612
              ],
              [
                55.5381268,
                37.3522401
              ],
              [
                55.5172938,
                37.3630717
              ],
              [
                55.5128506,
                37.3655728
              ],
              [
                55.5134037,
                37.3658516
              ],
              [
                55.514237,
                37.3658516
              ],
              [
                55.5145172,
                37.3661305
              ],
              [
                55.5156271,
                37.3661305
              ],
              [
                55.5222937,
                37.3680737
              ],
              [
                55.5384068,
                37.3758554
              ],
              [
                55.55535,
                37.3816849
              ],
              [
                55.5572967,
                37.3819638
              ],
              [
                55.5589634,
                37.3825215
              ],
              [
                55.5597967,
                37.3828004
              ],
              [
                55.5617399,
                37.3830792
              ],
              [
                55.6028529,
                37.3950169
              ],
              [
                55.6039663,
                37.3950168
              ],
              [
                55.6056329,
                37.3955746
              ],
              [
                55.6067429,
                37.3955746
              ],
              [
                55.6120195,
                37.396969
              ],
              [
                55.6372991,
                37.4055779
              ],
              [
                55.6395225,
                37.4066844
              ],
              [
                55.6684122,
                37.417803
              ],
              [
                55.6686888,
                37.4180728
              ],
              [
                55.6789686,
                37.4239109
              ],
              [
                55.6853587,
                37.4287738
              ],
              [
                55.685912,
                37.4289124
              ],
              [
                55.6873019,
                37.429461
              ],
              [
                55.6889685,
                37.4294611
              ],
              [
                55.6892453,
                37.42974
              ],
              [
                55.6906352,
                37.42974
              ],
              [
                55.7070253,
                37.4327983
              ],
              [
                55.7092485,
                37.4327984
              ],
              [
                55.7100817,
                37.4330772
              ],
              [
                55.714525,
                37.4330772
              ],
              [
                55.7186917,
                37.4339137
              ],
              [
                55.719805,
                37.4344625
              ],
              [
                55.7309147,
                37.4375208
              ],
              [
                55.7328582,
                37.4383574
              ],
              [
                55.7331381,
                37.4389152
              ],
              [
                55.7342481,
                37.4391849
              ],
              [
                55.7378615,
                37.4416856
              ],
              [
                55.741748,
                37.4453018
              ],
              [
                55.7423047,
                37.4461382
              ],
              [
                55.7509147,
                37.4547466
              ],
              [
                55.7611946,
                37.4597478
              ],
              [
                55.7620278,
                37.4597478
              ],
              [
                55.7631379,
                37.4602965
              ],
              [
                55.7639712,
                37.4602965
              ],
              [
                55.7642512,
                37.4605754
              ],
              [
                55.7650845,
                37.4608541
              ],
              [
                55.7661945,
                37.4608542
              ],
              [
                55.7664711,
                37.461133
              ],
              [
                55.7948075,
                37.4666918
              ],
              [
                55.7964743,
                37.4666919
              ],
              [
                55.7973076,
                37.4669707
              ],
              [
                55.7986976,
                37.4669707
              ],
              [
                55.7998075,
                37.4666919
              ],
              [
                55.8014742,
                37.4666919
              ],
              [
                55.8050841,
                37.4658553
              ],
              [
                55.8064741,
                37.4658554
              ],
              [
                55.8073074,
                37.4655765
              ],
              [
                55.8084173,
                37.4655765
              ],
              [
                55.8192539,
                37.462797
              ],
              [
                55.8309206,
                37.4561318
              ],
              [
                55.8320306,
                37.4555831
              ],
              [
                55.8328637,
                37.4547465
              ],
              [
                55.8598103,
                37.4419645
              ],
              [
                55.8825899,
                37.4352989
              ],
              [
                55.8867565,
                37.4344624
              ],
              [
                55.9337027,
                37.4258538
              ],
              [
                55.9520357,
                37.4203035
              ],
              [
                55.9525926,
                37.4200246
              ],
              [
                55.9714822,
                37.4139077
              ],
              [
                55.9778722,
                37.4128012
              ],
              [
                55.9798155,
                37.4128011
              ],
              [
                55.9806489,
                37.4125223
              ],
              [
                55.9961317,
                37.4047502
              ],
              [
                55.9964085,
                37.4044712
              ],
              [
                55.9975184,
                37.4044712
              ],
              [
                56.0008516,
                37.4039135
              ],
              [
                56.0066848,
                37.4039134
              ],
              [
                56.0069649,
                37.4036346
              ],
              [
                56.0100181,
                37.4036345
              ],
              [
                56.0172698,
                37.4233405
              ],
              [
                56.0169982,
                37.4317542
              ],
              [
                56.016197,
                37.4405194
              ],
              [
                56.0125921,
                37.4456985
              ],
              [
                56.0100172,
                37.4504684
              ],
              [
                56.0127638,
                37.4561918
              ],
              [
                56.0144036,
                37.4739691
              ],
              [
                56.0152367,
                37.475363
              ],
              [
                56.0154596,
                37.4756963
              ],
              [
                56.0376547,
                37.4887528
              ],
              [
                56.0400951,
                37.5140143
              ],
              [
                56.0098187,
                37.5144707
              ],
              [
                56.0087052,
                37.5144707
              ],
              [
                55.9920388,
                37.5191927
              ],
              [
                55.9864823,
                37.520299
              ],
              [
                55.9834289,
                37.5214142
              ],
              [
                55.9825958,
                37.5214141
              ],
              [
                55.9712057,
                37.5275212
              ],
              [
                55.9675924,
                37.5289153
              ],
              [
                55.9539825,
                37.5364162
              ],
              [
                55.9456494,
                37.5436383
              ],
              [
                55.9342595,
                37.5528029
              ],
              [
                55.9328694,
                37.5547456
              ],
              [
                55.9320362,
                37.556967
              ],
              [
                55.9314795,
                37.5586398
              ],
              [
                55.9150897,
                37.5905841
              ],
              [
                55.9142563,
                37.5911417
              ],
              [
                55.9114796,
                37.5953055
              ],
              [
                55.8988667,
                37.6202719
              ],
              [
                55.8806757,
                37.6206689
              ],
              [
                55.8654735,
                37.6209987
              ],
              [
                55.8484005,
                37.621367
              ],
              [
                55.8243455,
                37.6218823
              ],
              [
                55.8000444,
                37.6128488
              ],
              [
                55.79342,
                37.5987963
              ],
              [
                55.7735117,
                37.5923231
              ],
              [
                55.7498264,
                37.5851479
              ],
              [
                55.7252197,
                37.5787295
              ],
              [
                55.6453356,
                37.5972109
              ],
              [
                55.6332638,
                37.6057067
              ],
              [
                55.627834,
                37.6261747
              ],
              [
                55.6272263,
                37.6604827
              ],
              [
                55.645607,
                37.6801234
              ],
              [
                55.6473404,
                37.6851307
              ],
              [
                55.6551525,
                37.6954961
              ],
              [
                55.6586892,
                37.7025295
              ],
              [
                55.6572468,
                37.7278049
              ],
              [
                55.6634772,
                37.7537413
              ],
              [
                55.6607904,
                37.7604922
              ],
              [
                55.6544735,
                37.7763597
              ],
              [
                55.6318599,
                37.7926954
              ],
              [
                55.6009113,
                37.7957535
              ],
              [
                55.5693382,
                37.8055003
              ],
              [
                55.5481333,
                37.8159504
              ],
              [
                55.5434072,
                37.8050329
              ],
              [
                55.5350739,
                37.7936426
              ],
              [
                55.5231274,
                37.7841938
              ],
              [
                55.5000709,
                37.7644778
              ],
              [
                55.4503447,
                37.770034
              ],
              [
                55.4461782,
                37.7705914
              ],
              [
                55.4345116,
                37.7708611
              ],
              [
                55.4334016,
                37.7705914
              ],
              [
                55.4284018,
                37.7705914
              ],
              [
                55.426455,
                37.7703128
              ],
              [
                55.4242351,
                37.7703127
              ],
              [
                55.4228451,
                37.7705914
              ],
              [
                55.4206218,
                37.7708611
              ],
              [
                55.4122886,
                37.7703128
              ],
              [
                55.401732,
                37.7703128
              ],
              [
                55.3983986,
                37.7708611
              ],
              [
                55.3908988,
                37.7705914
              ],
              [
                55.3889554,
                37.7708611
              ],
              [
                55.3700656,
                37.7708611
              ],
              [
                55.3628424,
                37.7714186
              ],
              [
                55.3600658,
                37.771976
              ],
              [
                55.3475625,
                37.771976
              ],
              [
                55.3470093,
                37.7716974
              ],
              [
                55.3456193,
                37.7716973
              ],
              [
                55.3347861,
                37.7678134
              ],
              [
                55.3303394,
                37.764478
              ],
              [
                55.3300627,
                37.7636417
              ],
              [
                55.3300627,
                37.7633631
              ],
              [
                55.3261727,
                37.7544714
              ],
              [
                55.3264528,
                37.7505873
              ],
              [
                55.3267294,
                37.7341969
              ],
              [
                55.3264528,
                37.7325335
              ],
              [
                55.3253394,
                37.7255834
              ],
              [
                55.3178394,
                37.696973
              ],
              [
                55.3167295,
                37.6875317
              ],
              [
                55.3170061,
                37.6866955
              ],
              [
                55.3172827,
                37.6719759
              ],
              [
                55.3139495,
                37.6483626
              ],
              [
                55.3083962,
                37.6250273
              ],
              [
                55.3078396,
                37.6161424
              ],
              [
                55.3075628,
                37.6139121
              ],
              [
                55.3072828,
                37.6097485
              ],
              [
                55.3070061,
                37.5961333
              ],
              [
                55.3067295,
                37.5922482
              ],
              [
                55.3050629,
                37.5822479
              ],
              [
                55.3014495,
                37.5739111
              ],
              [
                55.3014496,
                37.5733624
              ],
              [
                55.3003395,
                37.5686409
              ],
              [
                55.2997829,
                37.5658619
              ],
              [
                55.2992296,
                37.5633618
              ],
              [
                55.2986728,
                37.5600252
              ],
              [
                55.2983929,
                37.5589189
              ],
              [
                55.2983928,
                37.5530821
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555203,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مراوه تپه",
          "name:en": "Maraveh Tappeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2725489",
          "wikipedia": "en:Maraveh Tappeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.5481333,
                37.8159504
              ],
              [
                55.5693382,
                37.8055003
              ],
              [
                55.6009113,
                37.7957535
              ],
              [
                55.6318599,
                37.7926954
              ],
              [
                55.6544735,
                37.7763597
              ],
              [
                55.6607904,
                37.7604922
              ],
              [
                55.6634772,
                37.7537413
              ],
              [
                55.6572468,
                37.7278049
              ],
              [
                55.6586892,
                37.7025295
              ],
              [
                55.6551525,
                37.6954961
              ],
              [
                55.6473404,
                37.6851307
              ],
              [
                55.645607,
                37.6801234
              ],
              [
                55.6272263,
                37.6604827
              ],
              [
                55.627834,
                37.6261747
              ],
              [
                55.6332638,
                37.6057067
              ],
              [
                55.6453356,
                37.5972109
              ],
              [
                55.7252197,
                37.5787295
              ],
              [
                55.7498264,
                37.5851479
              ],
              [
                55.7735117,
                37.5923231
              ],
              [
                55.79342,
                37.5987963
              ],
              [
                55.8000444,
                37.6128488
              ],
              [
                55.8243455,
                37.6218823
              ],
              [
                55.8484005,
                37.621367
              ],
              [
                55.8654735,
                37.6209987
              ],
              [
                55.8806757,
                37.6206689
              ],
              [
                55.8988667,
                37.6202719
              ],
              [
                55.9114796,
                37.5953055
              ],
              [
                55.9142563,
                37.5911417
              ],
              [
                55.9150897,
                37.5905841
              ],
              [
                55.9314795,
                37.5586398
              ],
              [
                55.9320362,
                37.556967
              ],
              [
                55.9328694,
                37.5547456
              ],
              [
                55.9342595,
                37.5528029
              ],
              [
                55.9456494,
                37.5436383
              ],
              [
                55.9539825,
                37.5364162
              ],
              [
                55.9675924,
                37.5289153
              ],
              [
                55.9712057,
                37.5275212
              ],
              [
                55.9825958,
                37.5214141
              ],
              [
                55.9834289,
                37.5214142
              ],
              [
                55.9864823,
                37.520299
              ],
              [
                55.9920388,
                37.5191927
              ],
              [
                56.0087052,
                37.5144707
              ],
              [
                56.0098187,
                37.5144707
              ],
              [
                56.0400951,
                37.5140143
              ],
              [
                56.0465118,
                37.5484696
              ],
              [
                56.0467886,
                37.549306
              ],
              [
                56.0465118,
                37.5543064
              ],
              [
                56.0570249,
                37.573563
              ],
              [
                56.056745,
                37.5757841
              ],
              [
                56.0697483,
                37.6070152
              ],
              [
                56.0705817,
                37.6075637
              ],
              [
                56.0739149,
                37.6111783
              ],
              [
                56.0972514,
                37.6345112
              ],
              [
                56.1066947,
                37.645894
              ],
              [
                56.1125446,
                37.6582266
              ],
              [
                56.113378,
                37.6596203
              ],
              [
                56.114488,
                37.6629471
              ],
              [
                56.1153212,
                37.6640619
              ],
              [
                56.1264046,
                37.6822038
              ],
              [
                56.1277911,
                37.6891542
              ],
              [
                56.1390224,
                37.7095356
              ],
              [
                56.1488826,
                37.7258524
              ],
              [
                56.1648238,
                37.7453091
              ],
              [
                56.2044115,
                37.7901749
              ],
              [
                56.2074832,
                37.7964353
              ],
              [
                56.2077598,
                37.7975502
              ],
              [
                56.2256343,
                37.8098609
              ],
              [
                56.2270245,
                37.8126389
              ],
              [
                56.2275811,
                37.8143111
              ],
              [
                56.2286911,
                37.8159743
              ],
              [
                56.2307738,
                37.8251077
              ],
              [
                56.2360953,
                37.8352765
              ],
              [
                56.2354086,
                37.8523568
              ],
              [
                56.2319754,
                37.8603534
              ],
              [
                56.232233,
                37.8635382
              ],
              [
                56.2350003,
                37.8647055
              ],
              [
                56.2405569,
                37.8641572
              ],
              [
                56.2472235,
                37.8641571
              ],
              [
                56.2622298,
                37.8711423
              ],
              [
                56.2641766,
                37.8711423
              ],
              [
                56.2669532,
                37.8719782
              ],
              [
                56.2680631,
                37.8719782
              ],
              [
                56.2801286,
                37.8728814
              ],
              [
                56.2935619,
                37.8734377
              ],
              [
                56.3041025,
                37.880633
              ],
              [
                56.310484,
                37.8898926
              ],
              [
                56.3236712,
                37.9070818
              ],
              [
                56.3357953,
                37.9143766
              ],
              [
                56.33948,
                37.9172148
              ],
              [
                56.3449732,
                37.9221354
              ],
              [
                56.3560805,
                37.9361976
              ],
              [
                56.3561864,
                37.9369846
              ],
              [
                56.3573248,
                37.9395145
              ],
              [
                56.3593179,
                37.944911
              ],
              [
                56.3595196,
                37.9783041
              ],
              [
                56.3608929,
                37.9845281
              ],
              [
                56.3681027,
                37.9937279
              ],
              [
                56.369476,
                38.0061728
              ],
              [
                56.368446,
                38.0213204
              ],
              [
                56.3196942,
                38.0551205
              ],
              [
                56.3073034,
                38.0728594
              ],
              [
                56.3070235,
                38.0742522
              ],
              [
                56.2899866,
                38.0819364
              ],
              [
                56.2892888,
                38.0841197
              ],
              [
                56.2889756,
                38.0846583
              ],
              [
                56.2865914,
                38.0830619
              ],
              [
                56.2863267,
                38.0827046
              ],
              [
                56.2861794,
                38.0821558
              ],
              [
                56.2859798,
                38.081862
              ],
              [
                56.2856934,
                38.0817051
              ],
              [
                56.2851205,
                38.0816267
              ],
              [
                56.2834642,
                38.0816038
              ],
              [
                56.281237,
                38.0811519
              ],
              [
                56.2806923,
                38.0808098
              ],
              [
                56.2807837,
                38.0789934
              ],
              [
                56.2750711,
                38.080458
              ],
              [
                56.267222,
                38.080833
              ],
              [
                56.260833,
                38.079444
              ],
              [
                56.254444,
                38.077778
              ],
              [
                56.248056,
                38.076389
              ],
              [
                56.2435802,
                38.0777346
              ],
              [
                56.2369056,
                38.0765853
              ],
              [
                56.2316907,
                38.0751964
              ],
              [
                56.2239953,
                38.0744558
              ],
              [
                56.2197567,
                38.0739223
              ],
              [
                56.216111,
                38.072222
              ],
              [
                56.210556,
                38.074722
              ],
              [
                56.204722,
                38.077222
              ],
              [
                56.198889,
                38.079722
              ],
              [
                56.194167,
                38.083056
              ],
              [
                56.189444,
                38.086111
              ],
              [
                56.183611,
                38.088611
              ],
              [
                56.178889,
                38.091667
              ],
              [
                56.173056,
                38.094444
              ],
              [
                56.164444,
                38.095
              ],
              [
                56.1575,
                38.094167
              ],
              [
                56.151111,
                38.092778
              ],
              [
                56.143889,
                38.091944
              ],
              [
                56.136944,
                38.091111
              ],
              [
                56.1301701,
                38.0909461
              ],
              [
                56.123611,
                38.088889
              ],
              [
                56.117222,
                38.0875
              ],
              [
                56.11,
                38.086667
              ],
              [
                56.103889,
                38.085
              ],
              [
                56.096667,
                38.084167
              ],
              [
                56.0931659,
                38.0878973
              ],
              [
                56.0863158,
                38.0860852
              ],
              [
                56.0822053,
                38.0847299
              ],
              [
                56.0734015,
                38.0838129
              ],
              [
                56.0643567,
                38.0824909
              ],
              [
                56.0546311,
                38.0814187
              ],
              [
                56.0387198,
                38.0807245
              ],
              [
                56.0328933,
                38.0797611
              ],
              [
                56.0257659,
                38.0789713
              ],
              [
                56.0213858,
                38.0776766
              ],
              [
                56.0168691,
                38.0798921
              ],
              [
                56.0101299,
                38.0783418
              ],
              [
                56.0016356,
                38.0790348
              ],
              [
                55.9980044,
                38.0771301
              ],
              [
                55.9933502,
                38.078591
              ],
              [
                55.9858853,
                38.0765806
              ],
              [
                55.985971,
                38.0777721
              ],
              [
                55.9837119,
                38.0792086
              ],
              [
                55.979345,
                38.0788649
              ],
              [
                55.976618,
                38.0790564
              ],
              [
                55.9711545,
                38.0839578
              ],
              [
                55.9625,
                38.078333
              ],
              [
                55.956944,
                38.080833
              ],
              [
                55.951944,
                38.083889
              ],
              [
                55.946389,
                38.086389
              ],
              [
                55.940556,
                38.088889
              ],
              [
                55.934722,
                38.091667
              ],
              [
                55.9282736,
                38.0926222
              ],
              [
                55.927222,
                38.092778
              ],
              [
                55.919167,
                38.092778
              ],
              [
                55.911389,
                38.092778
              ],
              [
                55.906111,
                38.091944
              ],
              [
                55.898889,
                38.091111
              ],
              [
                55.891944,
                38.090278
              ],
              [
                55.883333,
                38.091111
              ],
              [
                55.875556,
                38.092222
              ],
              [
                55.868056,
                38.093611
              ],
              [
                55.861111,
                38.095556
              ],
              [
                55.854444,
                38.0975
              ],
              [
                55.848611,
                38.1
              ],
              [
                55.841944,
                38.101944
              ],
              [
                55.837222,
                38.105
              ],
              [
                55.8325,
                38.108056
              ],
              [
                55.8275,
                38.111389
              ],
              [
                55.821944,
                38.113889
              ],
              [
                55.816944,
                38.116944
              ],
              [
                55.812222,
                38.12
              ],
              [
                55.806389,
                38.1225
              ],
              [
                55.798611,
                38.1225
              ],
              [
                55.792222,
                38.121111
              ],
              [
                55.785278,
                38.120278
              ],
              [
                55.777222,
                38.120278
              ],
              [
                55.770556,
                38.122222
              ],
              [
                55.763889,
                38.124167
              ],
              [
                55.756111,
                38.125278
              ],
              [
                55.748333,
                38.125278
              ],
              [
                55.742778,
                38.123056
              ],
              [
                55.736389,
                38.121389
              ],
              [
                55.730278,
                38.12
              ],
              [
                55.723889,
                38.118333
              ],
              [
                55.716944,
                38.1175
              ],
              [
                55.709722,
                38.116667
              ],
              [
                55.703333,
                38.115278
              ],
              [
                55.698056,
                38.113056
              ],
              [
                55.691667,
                38.111389
              ],
              [
                55.684444,
                38.110556
              ],
              [
                55.6827879,
                38.1103571
              ],
              [
                55.6780899,
                38.1041368
              ],
              [
                55.5967435,
                38.0164212
              ],
              [
                55.5936869,
                38.0094833
              ],
              [
                55.5936869,
                38.0092048
              ],
              [
                55.5922968,
                38.0067064
              ],
              [
                55.5917435,
                38.0058707
              ],
              [
                55.5856303,
                37.9983755
              ],
              [
                55.5789637,
                37.9828189
              ],
              [
                55.5611838,
                37.9586426
              ],
              [
                55.5531305,
                37.9394806
              ],
              [
                55.5528506,
                37.9355888
              ],
              [
                55.5506305,
                37.9175318
              ],
              [
                55.5506306,
                37.9089209
              ],
              [
                55.5542405,
                37.881982
              ],
              [
                55.5542405,
                37.8772539
              ],
              [
                55.5542404,
                37.8691999
              ],
              [
                55.5539639,
                37.8667009
              ],
              [
                55.5542405,
                37.8644806
              ],
              [
                55.5547971,
                37.8564263
              ],
              [
                55.5553505,
                37.8547543
              ],
              [
                55.5559071,
                37.8469786
              ],
              [
                55.5556304,
                37.8447583
              ],
              [
                55.5556304,
                37.8417019
              ],
              [
                55.5517405,
                37.8244779
              ],
              [
                55.5514638,
                37.8236419
              ],
              [
                55.5481333,
                37.8159504
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555230,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مینودشت",
          "name:en": "Minudasht County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292665",
          "wikipedia": "en:Minudasht County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.2272801,
                37.1502931
              ],
              [
                55.2270034,
                37.1500142
              ],
              [
                55.2295033,
                37.1425178
              ],
              [
                55.2303367,
                37.141402
              ],
              [
                55.2317233,
                37.139458
              ],
              [
                55.2376899,
                37.1340439
              ],
              [
                55.2381132,
                37.1336265
              ],
              [
                55.2539463,
                37.1263999
              ],
              [
                55.2739495,
                37.1214052
              ],
              [
                55.2756162,
                37.1214052
              ],
              [
                55.2822826,
                37.1199633
              ],
              [
                55.2858926,
                37.1191823
              ],
              [
                55.313949,
                37.1108486
              ],
              [
                55.316449,
                37.1091837
              ],
              [
                55.3295056,
                37.098069
              ],
              [
                55.3520086,
                37.0686208
              ],
              [
                55.3661751,
                37.0430687
              ],
              [
                55.3670085,
                37.0425107
              ],
              [
                55.3686751,
                37.0400085
              ],
              [
                55.3845082,
                37.0161206
              ],
              [
                55.3850649,
                37.0161205
              ],
              [
                55.3856215,
                37.0161205
              ],
              [
                55.3858983,
                37.0163996
              ],
              [
                55.3870082,
                37.0163996
              ],
              [
                55.3872882,
                37.0166786
              ],
              [
                55.3883982,
                37.0166786
              ],
              [
                55.3886748,
                37.0169576
              ],
              [
                55.3895081,
                37.0169577
              ],
              [
                55.3900648,
                37.0172367
              ],
              [
                55.3931216,
                37.0180647
              ],
              [
                55.3945115,
                37.0180647
              ],
              [
                55.4147878,
                37.021953
              ],
              [
                55.4178446,
                37.0219531
              ],
              [
                55.4186779,
                37.0222321
              ],
              [
                55.4209013,
                37.0222321
              ],
              [
                55.4250678,
                37.0222321
              ],
              [
                55.4297877,
                37.0222321
              ],
              [
                55.4311777,
                37.021953
              ],
              [
                55.4400656,
                37.0210952
              ],
              [
                55.4411775,
                37.020846
              ],
              [
                55.4422909,
                37.020846
              ],
              [
                55.4456242,
                37.0202879
              ],
              [
                55.4481242,
                37.020288
              ],
              [
                55.4492342,
                37.0200089
              ],
              [
                55.4511809,
                37.0200089
              ],
              [
                55.4525675,
                37.0197298
              ],
              [
                55.4939603,
                37.0119531
              ],
              [
                55.5000702,
                37.0094508
              ],
              [
                55.5122935,
                37.0222321
              ],
              [
                55.5409065,
                37.0416826
              ],
              [
                55.5492398,
                37.0461288
              ],
              [
                55.5497965,
                37.0463988
              ],
              [
                55.5578497,
                37.0491799
              ],
              [
                55.5589631,
                37.0491799
              ],
              [
                55.5709062,
                37.0522311
              ],
              [
                55.5722961,
                37.0522311
              ],
              [
                55.5728529,
                37.0525101
              ],
              [
                55.5736863,
                37.0525101
              ],
              [
                55.5745195,
                37.0527892
              ],
              [
                55.5759061,
                37.0527891
              ],
              [
                55.5764627,
                37.0530682
              ],
              [
                55.578406,
                37.0530681
              ],
              [
                55.5786861,
                37.0533472
              ],
              [
                55.5792394,
                37.0533472
              ],
              [
                55.5817393,
                37.0533472
              ],
              [
                55.5822961,
                37.0536261
              ],
              [
                55.585076,
                37.0536262
              ],
              [
                55.5856294,
                37.0539052
              ],
              [
                55.588686,
                37.0541752
              ],
              [
                55.5920193,
                37.0541753
              ],
              [
                55.592296,
                37.0539052
              ],
              [
                55.5934093,
                37.0539052
              ],
              [
                55.5942426,
                37.0536261
              ],
              [
                55.5953527,
                37.0536261
              ],
              [
                55.5959093,
                37.0533472
              ],
              [
                55.5984092,
                37.0533472
              ],
              [
                55.598686,
                37.0536262
              ],
              [
                55.5995193,
                37.0533471
              ],
              [
                55.6025758,
                37.0533471
              ],
              [
                55.6028525,
                37.0530681
              ],
              [
                55.6041872,
                37.0530682
              ],
              [
                55.6045191,
                37.0558493
              ],
              [
                55.6070192,
                37.0688997
              ],
              [
                55.6214658,
                37.0991758
              ],
              [
                55.6303556,
                37.1119554
              ],
              [
                55.6306323,
                37.1122344
              ],
              [
                55.6416647,
                37.1234176
              ],
              [
                55.6511887,
                37.1330683
              ],
              [
                55.6547987,
                37.1361281
              ],
              [
                55.6603553,
                37.1408438
              ],
              [
                55.6756351,
                37.1536226
              ],
              [
                55.6767451,
                37.1544595
              ],
              [
                55.6770253,
                37.1552875
              ],
              [
                55.686745,
                37.1639085
              ],
              [
                55.7006349,
                37.1830671
              ],
              [
                55.7072883,
                37.1870346
              ],
              [
                55.7109782,
                37.1912503
              ],
              [
                55.7140049,
                37.1951219
              ],
              [
                55.7205279,
                37.2004712
              ],
              [
                55.7177478,
                37.2001922
              ],
              [
                55.6983752,
                37.1997764
              ],
              [
                55.6950418,
                37.1997764
              ],
              [
                55.6944886,
                37.1994975
              ],
              [
                55.6925418,
                37.1994975
              ],
              [
                55.6908751,
                37.1992276
              ],
              [
                55.6680923,
                37.1976717
              ],
              [
                55.6669791,
                37.1973928
              ],
              [
                55.6655923,
                37.1968348
              ],
              [
                55.6640904,
                37.1952422
              ],
              [
                55.6565871,
                37.1919124
              ],
              [
                55.6385339,
                37.185793
              ],
              [
                55.6207542,
                37.1835791
              ],
              [
                55.6201974,
                37.1833002
              ],
              [
                55.6126975,
                37.1833002
              ],
              [
                55.6121409,
                37.1830212
              ],
              [
                55.6076976,
                37.1830212
              ],
              [
                55.6074209,
                37.1833002
              ],
              [
                55.6040877,
                37.1833002
              ],
              [
                55.6032544,
                37.1835791
              ],
              [
                55.6015877,
                37.1835792
              ],
              [
                55.5960311,
                37.184686
              ],
              [
                55.5943645,
                37.184686
              ],
              [
                55.5876947,
                37.1848284
              ],
              [
                55.5868614,
                37.1848283
              ],
              [
                55.5782481,
                37.1870511
              ],
              [
                55.5771381,
                37.1870511
              ],
              [
                55.5676916,
                37.1903809
              ],
              [
                55.5616377,
                37.1938265
              ],
              [
                55.5508914,
                37.1956933
              ],
              [
                55.5274619,
                37.2071586
              ],
              [
                55.5157954,
                37.212163
              ],
              [
                55.5144054,
                37.212163
              ],
              [
                55.5132955,
                37.212442
              ],
              [
                55.5113522,
                37.212442
              ],
              [
                55.5107955,
                37.212721
              ],
              [
                55.5096856,
                37.2124419
              ],
              [
                55.5082955,
                37.212721
              ],
              [
                55.4996822,
                37.212721
              ],
              [
                55.4994056,
                37.213
              ],
              [
                55.4928607,
                37.2166575
              ],
              [
                55.4762521,
                37.2301286
              ],
              [
                55.461818,
                37.2352655
              ],
              [
                55.450395,
                37.2249948
              ],
              [
                55.4346861,
                37.2234616
              ],
              [
                55.4237972,
                37.2231184
              ],
              [
                55.4135314,
                37.2324478
              ],
              [
                55.411308,
                37.2363347
              ],
              [
                55.4022881,
                37.2441839
              ],
              [
                55.4006215,
                37.2458484
              ],
              [
                55.3620087,
                37.2666874
              ],
              [
                55.3595086,
                37.2672362
              ],
              [
                55.3506189,
                37.2714111
              ],
              [
                55.3472854,
                37.2727967
              ],
              [
                55.3450621,
                37.2741823
              ],
              [
                55.3431188,
                37.2750191
              ],
              [
                55.3383956,
                37.2761258
              ],
              [
                55.3369267,
                37.2763716
              ],
              [
                55.3370089,
                37.2744613
              ],
              [
                55.3372857,
                37.2736245
              ],
              [
                55.3375623,
                37.2694587
              ],
              [
                55.335619,
                37.2614058
              ],
              [
                55.3350622,
                37.2586254
              ],
              [
                55.3322856,
                37.2516882
              ],
              [
                55.3314523,
                37.2508514
              ],
              [
                55.3306191,
                37.2491867
              ],
              [
                55.3128391,
                37.2344571
              ],
              [
                55.3117291,
                37.230291
              ],
              [
                55.3103392,
                37.2225166
              ],
              [
                55.3100625,
                37.2216797
              ],
              [
                55.3103392,
                37.2119616
              ],
              [
                55.3106158,
                37.2094601
              ],
              [
                55.3117292,
                37.2008486
              ],
              [
                55.3067292,
                37.1925159
              ],
              [
                55.2886727,
                37.1772361
              ],
              [
                55.2825595,
                37.1752923
              ],
              [
                55.2814494,
                37.1752924
              ],
              [
                55.2806161,
                37.1750134
              ],
              [
                55.2792261,
                37.1750134
              ],
              [
                55.2728362,
                37.1739065
              ],
              [
                55.2681162,
                37.1730697
              ],
              [
                55.2583931,
                37.170568
              ],
              [
                55.2470032,
                37.1633508
              ],
              [
                55.2292232,
                37.1539018
              ],
              [
                55.22728,
                37.1508511
              ],
              [
                55.2272801,
                37.1502931
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555280,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گالیکش",
          "name:en": "Galikash County",
          "place": "county",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.3369267,
                37.2763716
              ],
              [
                55.3383956,
                37.2761258
              ],
              [
                55.3431188,
                37.2750191
              ],
              [
                55.3450621,
                37.2741823
              ],
              [
                55.3472854,
                37.2727967
              ],
              [
                55.3506189,
                37.2714111
              ],
              [
                55.3595086,
                37.2672362
              ],
              [
                55.3620087,
                37.2666874
              ],
              [
                55.4006215,
                37.2458484
              ],
              [
                55.4022881,
                37.2441839
              ],
              [
                55.411308,
                37.2363347
              ],
              [
                55.4135314,
                37.2324478
              ],
              [
                55.4237972,
                37.2231184
              ],
              [
                55.4346861,
                37.2234616
              ],
              [
                55.450395,
                37.2249948
              ],
              [
                55.461818,
                37.2352655
              ],
              [
                55.4762521,
                37.2301286
              ],
              [
                55.4928607,
                37.2166575
              ],
              [
                55.4994056,
                37.213
              ],
              [
                55.4996822,
                37.212721
              ],
              [
                55.5082955,
                37.212721
              ],
              [
                55.5096856,
                37.2124419
              ],
              [
                55.5107955,
                37.212721
              ],
              [
                55.5113522,
                37.212442
              ],
              [
                55.5132955,
                37.212442
              ],
              [
                55.5144054,
                37.212163
              ],
              [
                55.5157954,
                37.212163
              ],
              [
                55.5274619,
                37.2071586
              ],
              [
                55.5508914,
                37.1956933
              ],
              [
                55.5616377,
                37.1938265
              ],
              [
                55.5676916,
                37.1903809
              ],
              [
                55.5771381,
                37.1870511
              ],
              [
                55.5782481,
                37.1870511
              ],
              [
                55.5868614,
                37.1848283
              ],
              [
                55.5876947,
                37.1848284
              ],
              [
                55.5943645,
                37.184686
              ],
              [
                55.5960311,
                37.184686
              ],
              [
                55.6015877,
                37.1835792
              ],
              [
                55.6032544,
                37.1835791
              ],
              [
                55.6040877,
                37.1833002
              ],
              [
                55.6074209,
                37.1833002
              ],
              [
                55.6076976,
                37.1830212
              ],
              [
                55.6121409,
                37.1830212
              ],
              [
                55.6126975,
                37.1833002
              ],
              [
                55.6201974,
                37.1833002
              ],
              [
                55.6207542,
                37.1835791
              ],
              [
                55.6385339,
                37.185793
              ],
              [
                55.6565871,
                37.1919124
              ],
              [
                55.6640904,
                37.1952422
              ],
              [
                55.6655923,
                37.1968348
              ],
              [
                55.6669791,
                37.1973928
              ],
              [
                55.6680923,
                37.1976717
              ],
              [
                55.6908751,
                37.1992276
              ],
              [
                55.6925418,
                37.1994975
              ],
              [
                55.6944886,
                37.1994975
              ],
              [
                55.6950418,
                37.1997764
              ],
              [
                55.6983752,
                37.1997764
              ],
              [
                55.7177478,
                37.2001922
              ],
              [
                55.7205279,
                37.2004712
              ],
              [
                55.720528,
                37.2018572
              ],
              [
                55.7267877,
                37.2120972
              ],
              [
                55.7270644,
                37.2157058
              ],
              [
                55.7273445,
                37.2226531
              ],
              [
                55.7270644,
                37.2284845
              ],
              [
                55.7273445,
                37.2293215
              ],
              [
                55.7276211,
                37.2315442
              ],
              [
                55.7278978,
                37.233209
              ],
              [
                55.7298443,
                37.2493259
              ],
              [
                55.7301211,
                37.2537713
              ],
              [
                55.7312344,
                37.2579377
              ],
              [
                55.7348443,
                37.2626619
              ],
              [
                55.7450811,
                37.284736
              ],
              [
                55.7513466,
                37.2885519
              ],
              [
                55.7578612,
                37.2925188
              ],
              [
                55.7889741,
                37.3080749
              ],
              [
                55.8086256,
                37.3178633
              ],
              [
                55.8223071,
                37.322245
              ],
              [
                55.8253636,
                37.3230728
              ],
              [
                55.8278637,
                37.3233517
              ],
              [
                55.8292538,
                37.3239094
              ],
              [
                55.8417534,
                37.3255739
              ],
              [
                55.8453635,
                37.3255739
              ],
              [
                55.8514767,
                37.3261317
              ],
              [
                55.8692842,
                37.3230584
              ],
              [
                55.8788637,
                37.3232431
              ],
              [
                55.8865927,
                37.3245777
              ],
              [
                55.898609,
                37.3301743
              ],
              [
                55.9095953,
                37.3316757
              ],
              [
                55.9203695,
                37.3344627
              ],
              [
                55.9214795,
                37.3344626
              ],
              [
                55.9370611,
                37.3389096
              ],
              [
                55.9499357,
                37.339319
              ],
              [
                55.9692072,
                37.3458583
              ],
              [
                55.983753,
                37.3540575
              ],
              [
                55.9942863,
                37.3658765
              ],
              [
                55.9951197,
                37.3661554
              ],
              [
                56.0100181,
                37.4025281
              ],
              [
                56.0100181,
                37.4036345
              ],
              [
                56.0069649,
                37.4036346
              ],
              [
                56.0066848,
                37.4039134
              ],
              [
                56.0008516,
                37.4039135
              ],
              [
                55.9975184,
                37.4044712
              ],
              [
                55.9964085,
                37.4044712
              ],
              [
                55.9961317,
                37.4047502
              ],
              [
                55.9806489,
                37.4125223
              ],
              [
                55.9798155,
                37.4128011
              ],
              [
                55.9778722,
                37.4128012
              ],
              [
                55.9714822,
                37.4139077
              ],
              [
                55.9525926,
                37.4200246
              ],
              [
                55.9520357,
                37.4203035
              ],
              [
                55.9337027,
                37.4258538
              ],
              [
                55.8867565,
                37.4344624
              ],
              [
                55.8825899,
                37.4352989
              ],
              [
                55.8598103,
                37.4419645
              ],
              [
                55.8328637,
                37.4547465
              ],
              [
                55.8320306,
                37.4555831
              ],
              [
                55.8309206,
                37.4561318
              ],
              [
                55.8192539,
                37.462797
              ],
              [
                55.8084173,
                37.4655765
              ],
              [
                55.8073074,
                37.4655765
              ],
              [
                55.8064741,
                37.4658554
              ],
              [
                55.8050841,
                37.4658553
              ],
              [
                55.8014742,
                37.4666919
              ],
              [
                55.7998075,
                37.4666919
              ],
              [
                55.7986976,
                37.4669707
              ],
              [
                55.7973076,
                37.4669707
              ],
              [
                55.7964743,
                37.4666919
              ],
              [
                55.7948075,
                37.4666918
              ],
              [
                55.7664711,
                37.461133
              ],
              [
                55.7661945,
                37.4608542
              ],
              [
                55.7650845,
                37.4608541
              ],
              [
                55.7642512,
                37.4605754
              ],
              [
                55.7639712,
                37.4602965
              ],
              [
                55.7631379,
                37.4602965
              ],
              [
                55.7620278,
                37.4597478
              ],
              [
                55.7611946,
                37.4597478
              ],
              [
                55.7509147,
                37.4547466
              ],
              [
                55.7423047,
                37.4461382
              ],
              [
                55.741748,
                37.4453018
              ],
              [
                55.7378615,
                37.4416856
              ],
              [
                55.7342481,
                37.4391849
              ],
              [
                55.7331381,
                37.4389152
              ],
              [
                55.7328582,
                37.4383574
              ],
              [
                55.7309147,
                37.4375208
              ],
              [
                55.719805,
                37.4344625
              ],
              [
                55.7186917,
                37.4339137
              ],
              [
                55.714525,
                37.4330772
              ],
              [
                55.7100817,
                37.4330772
              ],
              [
                55.7092485,
                37.4327984
              ],
              [
                55.7070253,
                37.4327983
              ],
              [
                55.6906352,
                37.42974
              ],
              [
                55.6892453,
                37.42974
              ],
              [
                55.6889685,
                37.4294611
              ],
              [
                55.6873019,
                37.429461
              ],
              [
                55.685912,
                37.4289124
              ],
              [
                55.6853587,
                37.4287738
              ],
              [
                55.6789686,
                37.4239109
              ],
              [
                55.6686888,
                37.4180728
              ],
              [
                55.6684122,
                37.417803
              ],
              [
                55.6395225,
                37.4066844
              ],
              [
                55.6372991,
                37.4055779
              ],
              [
                55.6120195,
                37.396969
              ],
              [
                55.6067429,
                37.3955746
              ],
              [
                55.6056329,
                37.3955746
              ],
              [
                55.6039663,
                37.3950168
              ],
              [
                55.6028529,
                37.3950169
              ],
              [
                55.5617399,
                37.3830792
              ],
              [
                55.5597967,
                37.3828004
              ],
              [
                55.5589634,
                37.3825215
              ],
              [
                55.5572967,
                37.3819638
              ],
              [
                55.55535,
                37.3816849
              ],
              [
                55.5384068,
                37.3758554
              ],
              [
                55.5222937,
                37.3680737
              ],
              [
                55.5156271,
                37.3661305
              ],
              [
                55.5145172,
                37.3661305
              ],
              [
                55.514237,
                37.3658516
              ],
              [
                55.5134037,
                37.3658516
              ],
              [
                55.5128506,
                37.3655728
              ],
              [
                55.5172938,
                37.3630717
              ],
              [
                55.5381268,
                37.3522401
              ],
              [
                55.5384068,
                37.3519612
              ],
              [
                55.5409068,
                37.3494602
              ],
              [
                55.5414602,
                37.3475169
              ],
              [
                55.5386835,
                37.3441882
              ],
              [
                55.5236837,
                37.3380795
              ],
              [
                55.5214603,
                37.3380795
              ],
              [
                55.5211836,
                37.3377916
              ],
              [
                55.5189603,
                37.3377916
              ],
              [
                55.5044086,
                37.3277422
              ],
              [
                55.5001973,
                37.3319002
              ],
              [
                55.4615463,
                37.3291908
              ],
              [
                55.4585108,
                37.329063
              ],
              [
                55.4561281,
                37.328912
              ],
              [
                55.4561279,
                37.3289119
              ],
              [
                55.456079,
                37.3289086
              ],
              [
                55.4520145,
                37.328633
              ],
              [
                55.4481244,
                37.328633
              ],
              [
                55.4472911,
                37.3283541
              ],
              [
                55.4445111,
                37.3283542
              ],
              [
                55.4434012,
                37.3280752
              ],
              [
                55.4417345,
                37.3280752
              ],
              [
                55.4403445,
                37.3277963
              ],
              [
                55.4384011,
                37.3277963
              ],
              [
                55.4370112,
                37.3275174
              ],
              [
                55.4347913,
                37.3275175
              ],
              [
                55.4334013,
                37.3272385
              ],
              [
                55.4311779,
                37.3272385
              ],
              [
                55.4247879,
                37.3264109
              ],
              [
                55.4214547,
                37.3264108
              ],
              [
                55.4197881,
                37.326132
              ],
              [
                55.4172881,
                37.3261319
              ],
              [
                55.4156215,
                37.325853
              ],
              [
                55.402845,
                37.3258531
              ],
              [
                55.401455,
                37.3261319
              ],
              [
                55.3995117,
                37.3261319
              ],
              [
                55.3961784,
                37.3266897
              ],
              [
                55.3917316,
                37.3266898
              ],
              [
                55.390065,
                37.3264109
              ],
              [
                55.3875651,
                37.3264109
              ],
              [
                55.3861751,
                37.3261319
              ],
              [
                55.3817319,
                37.326132
              ],
              [
                55.3808985,
                37.3258531
              ],
              [
                55.3767317,
                37.3258531
              ],
              [
                55.3722853,
                37.3250163
              ],
              [
                55.3703419,
                37.3250163
              ],
              [
                55.3700652,
                37.3247464
              ],
              [
                55.3692321,
                37.3247464
              ],
              [
                55.3689519,
                37.3250163
              ],
              [
                55.3656185,
                37.3247465
              ],
              [
                55.3645088,
                37.3244675
              ],
              [
                55.3633988,
                37.3244676
              ],
              [
                55.3609877,
                37.3241986
              ],
              [
                55.3611753,
                37.3236309
              ],
              [
                55.362842,
                37.3191863
              ],
              [
                55.3631186,
                37.3147418
              ],
              [
                55.3617321,
                37.3069595
              ],
              [
                55.3608988,
                37.3061317
              ],
              [
                55.3606187,
                37.305295
              ],
              [
                55.3586754,
                37.3033517
              ],
              [
                55.3578421,
                37.3030727
              ],
              [
                55.3572854,
                37.3030727
              ],
              [
                55.3403422,
                37.2986281
              ],
              [
                55.3400623,
                37.2980703
              ],
              [
                55.3375623,
                37.2950202
              ],
              [
                55.3364523,
                37.2908545
              ],
              [
                55.3358956,
                37.289181
              ],
              [
                55.3369249,
                37.276377
              ],
              [
                55.3369267,
                37.2763716
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555286,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گرگان",
          "name:en": "Gorgan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292686",
          "wikipedia": "en:Gorgan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.2194178,
                36.8804819
              ],
              [
                54.2226991,
                36.8771927
              ],
              [
                54.2226992,
                36.8769136
              ],
              [
                54.2251991,
                36.8738617
              ],
              [
                54.2260324,
                36.8735828
              ],
              [
                54.2308941,
                36.8667965
              ],
              [
                54.2333659,
                36.861822
              ],
              [
                54.242759,
                36.8530819
              ],
              [
                54.2435924,
                36.853082
              ],
              [
                54.2469256,
                36.8511373
              ],
              [
                54.252189,
                36.8459942
              ],
              [
                54.2577455,
                36.8446077
              ],
              [
                54.2591356,
                36.8440495
              ],
              [
                54.2602456,
                36.8429422
              ],
              [
                54.2605222,
                36.8426631
              ],
              [
                54.2608021,
                36.8415465
              ],
              [
                54.2626761,
                36.8319587
              ],
              [
                54.2573823,
                36.8313289
              ],
              [
                54.2543291,
                36.8243868
              ],
              [
                54.2557157,
                36.8177148
              ],
              [
                54.2748502,
                36.8113059
              ],
              [
                54.2751268,
                36.8054713
              ],
              [
                54.2697142,
                36.7969144
              ],
              [
                54.2666769,
                36.7861203
              ],
              [
                54.2658437,
                36.7816724
              ],
              [
                54.265567,
                36.7800067
              ],
              [
                54.2606805,
                36.7761096
              ],
              [
                54.2615138,
                36.769996
              ],
              [
                54.2631805,
                36.7599927
              ],
              [
                54.2631805,
                36.7563821
              ],
              [
                54.2660021,
                36.7444963
              ],
              [
                54.265722,
                36.7442172
              ],
              [
                54.2660021,
                36.7433796
              ],
              [
                54.265722,
                36.7422721
              ],
              [
                54.2710935,
                36.7335551
              ],
              [
                54.2710935,
                36.7329967
              ],
              [
                54.2708168,
                36.7324474
              ],
              [
                54.2708169,
                36.7318891
              ],
              [
                54.2708169,
                36.7316099
              ],
              [
                54.2710935,
                36.7266119
              ],
              [
                54.2738204,
                36.7088156
              ],
              [
                54.2812035,
                36.7003651
              ],
              [
                54.2839835,
                36.6998157
              ],
              [
                54.2906501,
                36.6998156
              ],
              [
                54.2920367,
                36.7000858
              ],
              [
                54.2950933,
                36.7000858
              ],
              [
                54.3162229,
                36.7083814
              ],
              [
                54.3184463,
                36.7083814
              ],
              [
                54.3195562,
                36.7086606
              ],
              [
                54.3217796,
                36.7086606
              ],
              [
                54.3245597,
                36.7092189
              ],
              [
                54.3320596,
                36.7097682
              ],
              [
                54.3389145,
                36.711409
              ],
              [
                54.3416829,
                36.7119527
              ],
              [
                54.3422362,
                36.7119527
              ],
              [
                54.355493,
                36.707863
              ],
              [
                54.356406,
                36.7077836
              ],
              [
                54.3566827,
                36.7072253
              ],
              [
                54.3601795,
                36.7038131
              ],
              [
                54.3641135,
                36.6999726
              ],
              [
                54.3652925,
                36.6894499
              ],
              [
                54.3677458,
                36.6836146
              ],
              [
                54.3711157,
                36.6797485
              ],
              [
                54.3711158,
                36.6783617
              ],
              [
                54.3727824,
                36.6697525
              ],
              [
                54.3777989,
                36.655851
              ],
              [
                54.3789123,
                36.6516904
              ],
              [
                54.3797456,
                36.6500154
              ],
              [
                54.3811922,
                36.6406133
              ],
              [
                54.3780589,
                36.630866
              ],
              [
                54.3717991,
                36.6241853
              ],
              [
                54.3715065,
                36.6234051
              ],
              [
                54.3676324,
                36.6130718
              ],
              [
                54.3665191,
                36.6114149
              ],
              [
                54.3630725,
                36.6111122
              ],
              [
                54.3622393,
                36.6102747
              ],
              [
                54.348681,
                36.5955327
              ],
              [
                54.3464612,
                36.5916421
              ],
              [
                54.3456278,
                36.5899762
              ],
              [
                54.3467328,
                36.5801126
              ],
              [
                54.3464527,
                36.5784465
              ],
              [
                54.3461761,
                36.5753845
              ],
              [
                54.3527983,
                36.5726647
              ],
              [
                54.3584631,
                36.5765248
              ],
              [
                54.3618639,
                36.5746332
              ],
              [
                54.3615838,
                36.5696355
              ],
              [
                54.3541716,
                36.5617729
              ],
              [
                54.3537542,
                36.5540183
              ],
              [
                54.3534775,
                36.5501366
              ],
              [
                54.3515967,
                36.5424671
              ],
              [
                54.341297,
                36.5326745
              ],
              [
                54.3430695,
                36.5238861
              ],
              [
                54.3427928,
                36.5230575
              ],
              [
                54.3439027,
                36.5136093
              ],
              [
                54.3444595,
                36.5122222
              ],
              [
                54.3734451,
                36.5102939
              ],
              [
                54.3775357,
                36.5114448
              ],
              [
                54.3792023,
                36.5114448
              ],
              [
                54.3803123,
                36.511724
              ],
              [
                54.3830924,
                36.511724
              ],
              [
                54.3836455,
                36.5120031
              ],
              [
                54.3950354,
                36.5120032
              ],
              [
                54.3961454,
                36.511724
              ],
              [
                54.4122585,
                36.511724
              ],
              [
                54.4314251,
                36.5139141
              ],
              [
                54.4319816,
                36.5139141
              ],
              [
                54.436705,
                36.5128061
              ],
              [
                54.4580019,
                36.5251828
              ],
              [
                54.4593919,
                36.5249037
              ],
              [
                54.4618918,
                36.5251828
              ],
              [
                54.4657784,
                36.5251829
              ],
              [
                54.4685585,
                36.5254531
              ],
              [
                54.4699484,
                36.5257322
              ],
              [
                54.4727251,
                36.5257322
              ],
              [
                54.4807816,
                36.5268488
              ],
              [
                54.4893915,
                36.528794
              ],
              [
                54.4899481,
                36.5290731
              ],
              [
                54.4910582,
                36.5290731
              ],
              [
                54.4958949,
                36.5224634
              ],
              [
                54.5334708,
                36.5170059
              ],
              [
                54.5439241,
                36.5182047
              ],
              [
                54.5561473,
                36.522376
              ],
              [
                54.5564239,
                36.5226551
              ],
              [
                54.5572145,
                36.5229677
              ],
              [
                54.5578139,
                36.5232048
              ],
              [
                54.5714947,
                36.5303298
              ],
              [
                54.5745846,
                36.5595669
              ],
              [
                54.5776745,
                36.5739056
              ],
              [
                54.6099469,
                36.5728027
              ],
              [
                54.6271593,
                36.5797623
              ],
              [
                54.630216,
                36.5828156
              ],
              [
                54.6437125,
                36.610783
              ],
              [
                54.6448226,
                36.612449
              ],
              [
                54.6567691,
                36.6227237
              ],
              [
                54.6587123,
                36.6232821
              ],
              [
                54.6620898,
                36.6243932
              ],
              [
                54.6662316,
                36.6252218
              ],
              [
                54.6755857,
                36.6252782
              ],
              [
                54.685309,
                36.6277817
              ],
              [
                54.686419,
                36.6277817
              ],
              [
                54.6894756,
                36.6288894
              ],
              [
                54.690309,
                36.6288895
              ],
              [
                54.6911422,
                36.6294478
              ],
              [
                54.6994755,
                36.6316631
              ],
              [
                54.7008655,
                36.6325007
              ],
              [
                54.7104868,
                36.6392727
              ],
              [
                54.7110434,
                36.6417761
              ],
              [
                54.7145817,
                36.6533731
              ],
              [
                54.7145818,
                36.6539223
              ],
              [
                54.7148618,
                36.6547597
              ],
              [
                54.715415,
                36.6578121
              ],
              [
                54.715415,
                36.6597569
              ],
              [
                54.7159718,
                36.6619809
              ],
              [
                54.7159717,
                36.6636465
              ],
              [
                54.719305,
                36.6750275
              ],
              [
                54.7244786,
                36.6944475
              ],
              [
                54.727812,
                36.7005617
              ],
              [
                54.7342019,
                36.7172204
              ],
              [
                54.7358685,
                36.720561
              ],
              [
                54.7378118,
                36.7266751
              ],
              [
                54.7378118,
                36.7275035
              ],
              [
                54.7378119,
                36.7277827
              ],
              [
                54.7389217,
                36.7291693
              ],
              [
                54.7392018,
                36.7302858
              ],
              [
                54.7394784,
                36.7333384
              ],
              [
                54.7397551,
                36.7352833
              ],
              [
                54.7425351,
                36.747232
              ],
              [
                54.7430884,
                36.7480603
              ],
              [
                54.7444785,
                36.7544443
              ],
              [
                54.744755,
                36.75584
              ],
              [
                54.7450351,
                36.7633403
              ],
              [
                54.7414217,
                36.7888933
              ],
              [
                54.7411451,
                36.7894515
              ],
              [
                54.7405885,
                36.7936202
              ],
              [
                54.7394785,
                36.7991755
              ],
              [
                54.7383685,
                36.8172274
              ],
              [
                54.7364218,
                36.8480634
              ],
              [
                54.736702,
                36.8486215
              ],
              [
                54.7369784,
                36.8505662
              ],
              [
                54.7375352,
                36.8547256
              ],
              [
                54.7378119,
                36.8572283
              ],
              [
                54.7380884,
                36.8588939
              ],
              [
                54.7403118,
                36.8708406
              ],
              [
                54.7405885,
                36.872227
              ],
              [
                54.7408685,
                36.8747297
              ],
              [
                54.7405885,
                36.8766743
              ],
              [
                54.7311453,
                36.8911234
              ],
              [
                54.7147555,
                36.9097313
              ],
              [
                54.7139221,
                36.9102894
              ],
              [
                54.7119755,
                36.9122249
              ],
              [
                54.6996588,
                36.9412597
              ],
              [
                54.6988254,
                36.9420878
              ],
              [
                54.6979921,
                36.9429248
              ],
              [
                54.6977154,
                36.9434829
              ],
              [
                54.6954921,
                36.9423668
              ],
              [
                54.6885489,
                36.944869
              ],
              [
                54.6874389,
                36.944869
              ],
              [
                54.6857723,
                36.945427
              ],
              [
                54.6849389,
                36.945427
              ],
              [
                54.6843823,
                36.945697
              ],
              [
                54.6829922,
                36.945697
              ],
              [
                54.6824355,
                36.9459761
              ],
              [
                54.681049,
                36.945697
              ],
              [
                54.679659,
                36.945697
              ],
              [
                54.6785491,
                36.945976
              ],
              [
                54.676049,
                36.945976
              ],
              [
                54.6752157,
                36.9462551
              ],
              [
                54.6741024,
                36.9462551
              ],
              [
                54.6738257,
                36.946534
              ],
              [
                54.6724357,
                36.946534
              ],
              [
                54.6718824,
                36.9468131
              ],
              [
                54.6699357,
                36.9468131
              ],
              [
                54.6696592,
                36.9470921
              ],
              [
                54.6610459,
                36.9473621
              ],
              [
                54.6602125,
                36.9470921
              ],
              [
                54.6554926,
                36.9470921
              ],
              [
                54.6529926,
                36.9468132
              ],
              [
                54.6504927,
                36.9468131
              ],
              [
                54.6496594,
                36.9470921
              ],
              [
                54.644656,
                36.9470921
              ],
              [
                54.6438227,
                36.9473621
              ],
              [
                54.6418794,
                36.9473621
              ],
              [
                54.6366028,
                36.9487573
              ],
              [
                54.6215996,
                36.9593058
              ],
              [
                54.6207663,
                36.9595848
              ],
              [
                54.619933,
                36.9607008
              ],
              [
                54.6082665,
                36.9681981
              ],
              [
                54.6040998,
                36.9695841
              ],
              [
                54.5918766,
                36.9751463
              ],
              [
                54.5835433,
                36.9781973
              ],
              [
                54.5821534,
                36.978057
              ],
              [
                54.5807667,
                36.9779184
              ],
              [
                54.58021,
                36.9770813
              ],
              [
                54.5799335,
                36.9756953
              ],
              [
                54.5796534,
                36.9729232
              ],
              [
                54.5802101,
                36.9690351
              ],
              [
                54.5807668,
                36.9654261
              ],
              [
                54.58021,
                36.9618078
              ],
              [
                54.5799334,
                36.9612588
              ],
              [
                54.5802101,
                36.9548685
              ],
              [
                54.5804867,
                36.9540315
              ],
              [
                54.5799335,
                36.9504223
              ],
              [
                54.5796533,
                36.9498642
              ],
              [
                54.5793768,
                36.9487572
              ],
              [
                54.5791001,
                36.945976
              ],
              [
                54.57882,
                36.9440409
              ],
              [
                54.5747002,
                36.9409948
              ],
              [
                54.5730336,
                36.9409949
              ],
              [
                54.572757,
                36.9407157
              ],
              [
                54.571367,
                36.9407158
              ],
              [
                54.5710903,
                36.9404367
              ],
              [
                54.5697003,
                36.9404367
              ],
              [
                54.5666436,
                36.9396086
              ],
              [
                54.5652572,
                36.9396086
              ],
              [
                54.564977,
                36.9393297
              ],
              [
                54.5627571,
                36.9393297
              ],
              [
                54.5616437,
                36.9390506
              ],
              [
                54.5549771,
                36.9390506
              ],
              [
                54.5538672,
                36.9393297
              ],
              [
                54.549424,
                36.9393296
              ],
              [
                54.5335874,
                36.9412738
              ],
              [
                54.5319207,
                36.9412738
              ],
              [
                54.5313675,
                36.9415529
              ],
              [
                54.5271974,
                36.9415528
              ],
              [
                54.5260875,
                36.941832
              ],
              [
                54.5180776,
                36.9316784
              ],
              [
                54.5066911,
                36.9339019
              ],
              [
                54.5053011,
                36.9339019
              ],
              [
                54.5044678,
                36.934172
              ],
              [
                54.5000211,
                36.934451
              ],
              [
                54.4961345,
                36.9339019
              ],
              [
                54.4794647,
                36.9261152
              ],
              [
                54.4758547,
                36.9258451
              ],
              [
                54.4747448,
                36.9261152
              ],
              [
                54.4730782,
                36.9261152
              ],
              [
                54.4722448,
                36.9263943
              ],
              [
                54.4714115,
                36.9263943
              ],
              [
                54.4672415,
                36.929455
              ],
              [
                54.4655748,
                36.9305623
              ],
              [
                54.4647415,
                36.9313994
              ],
              [
                54.4630749,
                36.9319575
              ],
              [
                54.459465,
                36.9319575
              ],
              [
                54.458355,
                36.9316785
              ],
              [
                54.4572416,
                36.9316784
              ],
              [
                54.4280753,
                36.9205609
              ],
              [
                54.4266853,
                36.9200118
              ],
              [
                54.4261286,
                36.9200118
              ],
              [
                54.4250186,
                36.9197328
              ],
              [
                54.4239087,
                36.9197328
              ],
              [
                54.4211287,
                36.9191746
              ],
              [
                54.419742,
                36.9191746
              ],
              [
                54.4186288,
                36.9189045
              ],
              [
                54.4175188,
                36.9189046
              ],
              [
                54.4161287,
                36.9183464
              ],
              [
                54.4150187,
                36.9183464
              ],
              [
                54.3892278,
                36.9207435
              ],
              [
                54.3634139,
                36.9228615
              ],
              [
                54.3522112,
                36.9239502
              ],
              [
                54.3467013,
                36.9244648
              ],
              [
                54.3401715,
                36.926379
              ],
              [
                54.3376493,
                36.9241996
              ],
              [
                54.3377738,
                36.9209768
              ],
              [
                54.3360568,
                36.9200874
              ],
              [
                54.3332969,
                36.9196382
              ],
              [
                54.328165,
                36.920357
              ],
              [
                54.3240022,
                36.9170632
              ],
              [
                54.3219852,
                36.916377
              ],
              [
                54.3204832,
                36.9167544
              ],
              [
                54.3195819,
                36.9155878
              ],
              [
                54.3127392,
                36.9096223
              ],
              [
                54.2749619,
                36.9006496
              ],
              [
                54.2612219,
                36.8955299
              ],
              [
                54.2498355,
                36.8912857
              ],
              [
                54.2472971,
                36.8903394
              ],
              [
                54.2371787,
                36.8805463
              ],
              [
                54.2290766,
                36.8797921
              ],
              [
                54.2194178,
                36.8804819
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555289,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گمیشان",
          "name:en": "Gomishan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4814857",
          "wikipedia": "en:Gomishan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.6649493,
                37.3561378
              ],
              [
                53.6615361,
                37.3557644
              ],
              [
                53.6610461,
                37.3516823
              ],
              [
                53.6606429,
                37.3473226
              ],
              [
                53.6603589,
                37.342957
              ],
              [
                53.6601943,
                37.3385874
              ],
              [
                53.6603225,
                37.3272808
              ],
              [
                53.6607963,
                37.3203546
              ],
              [
                53.6615699,
                37.3134457
              ],
              [
                53.6626423,
                37.3065622
              ],
              [
                53.66491,
                37.2938074
              ],
              [
                53.6663438,
                37.2866685
              ],
              [
                53.6673666,
                37.2823739
              ],
              [
                53.6685062,
                37.2780982
              ],
              [
                53.6691179,
                37.2764618
              ],
              [
                53.6692445,
                37.2758027
              ],
              [
                53.6693616,
                37.2752005
              ],
              [
                53.669732,
                37.2714612
              ],
              [
                53.6702826,
                37.2671118
              ],
              [
                53.6709516,
                37.262773
              ],
              [
                53.6717388,
                37.2584469
              ],
              [
                53.6726438,
                37.2541355
              ],
              [
                53.6732982,
                37.2520675
              ],
              [
                53.6737852,
                37.2498659
              ],
              [
                53.6742823,
                37.2477773
              ],
              [
                53.6748382,
                37.2455731
              ],
              [
                53.6753888,
                37.2435058
              ],
              [
                53.6760089,
                37.2412966
              ],
              [
                53.6766102,
                37.2392574
              ],
              [
                53.6772696,
                37.2371444
              ],
              [
                53.6776241,
                37.2359424
              ],
              [
                53.6778915,
                37.2350153
              ],
              [
                53.6791319,
                37.2307367
              ],
              [
                53.6805412,
                37.2267468
              ],
              [
                53.6814494,
                37.2236964
              ],
              [
                53.6836677,
                37.2170138
              ],
              [
                53.6838183,
                37.2163634
              ],
              [
                53.6847287,
                37.2120306
              ],
              [
                53.6858673,
                37.2077548
              ],
              [
                53.687122,
                37.2035
              ],
              [
                53.6884924,
                37.1992679
              ],
              [
                53.6899777,
                37.1950608
              ],
              [
                53.6915807,
                37.1910831
              ],
              [
                53.6931791,
                37.1869051
              ],
              [
                53.6946727,
                37.1829018
              ],
              [
                53.6963854,
                37.1787505
              ],
              [
                53.6968562,
                37.1776877
              ],
              [
                53.6975599,
                37.175694
              ],
              [
                53.699159,
                37.1715137
              ],
              [
                53.7008714,
                37.1673624
              ],
              [
                53.7011251,
                37.1667896
              ],
              [
                53.7017597,
                37.1649785
              ],
              [
                53.7033166,
                37.1608748
              ],
              [
                53.7049826,
                37.1567986
              ],
              [
                53.7067571,
                37.1527518
              ],
              [
                53.7114965,
                37.142298
              ],
              [
                53.7116877,
                37.1415795
              ],
              [
                53.7129414,
                37.1373246
              ],
              [
                53.7143105,
                37.1330925
              ],
              [
                53.7157945,
                37.1288853
              ],
              [
                53.7173925,
                37.1247051
              ],
              [
                53.7178565,
                37.1235323
              ],
              [
                53.7194114,
                37.119105
              ],
              [
                53.7210093,
                37.1149248
              ],
              [
                53.7227205,
                37.1107734
              ],
              [
                53.7235979,
                37.1087907
              ],
              [
                53.7237851,
                37.1082149
              ],
              [
                53.7252557,
                37.1040584
              ],
              [
                53.7268377,
                37.0999283
              ],
              [
                53.7285303,
                37.0958264
              ],
              [
                53.7287893,
                37.0952413
              ],
              [
                53.7289582,
                37.0947085
              ],
              [
                53.7295316,
                37.0930997
              ],
              [
                53.8548049,
                36.939096
              ],
              [
                54.0451133,
                36.9479997
              ],
              [
                54.1166202,
                36.9720827
              ],
              [
                54.137827,
                36.9719848
              ],
              [
                54.1608651,
                36.9667306
              ],
              [
                54.1608719,
                36.9667382
              ],
              [
                54.1667952,
                36.9637509
              ],
              [
                54.1752361,
                36.9606587
              ],
              [
                54.1832977,
                36.9600314
              ],
              [
                54.1879031,
                36.9591005
              ],
              [
                54.195582,
                36.9590893
              ],
              [
                54.2021098,
                36.9593875
              ],
              [
                54.2086422,
                36.9615341
              ],
              [
                54.217478,
                36.9633684
              ],
              [
                54.2243918,
                36.9642811
              ],
              [
                54.2313058,
                36.9651935
              ],
              [
                54.2370663,
                36.9654913
              ],
              [
                54.2432098,
                36.96548
              ],
              [
                54.24858,
                36.9636212
              ],
              [
                54.2524142,
                36.9617652
              ],
              [
                54.2550944,
                36.9592951
              ],
              [
                54.2550842,
                36.9559058
              ],
              [
                54.2577604,
                36.9522031
              ],
              [
                54.2623587,
                36.9494208
              ],
              [
                54.2673436,
                36.947562
              ],
              [
                54.2746305,
                36.9453901
              ],
              [
                54.2800039,
                36.9450706
              ],
              [
                54.2846094,
                36.9447525
              ],
              [
                54.288444,
                36.9435116
              ],
              [
                54.2957343,
                36.942571
              ],
              [
                54.3030279,
                36.9425543
              ],
              [
                54.3099375,
                36.9425382
              ],
              [
                54.3156956,
                36.9425244
              ],
              [
                54.3199181,
                36.9425142
              ],
              [
                54.3245257,
                36.942811
              ],
              [
                54.3283692,
                36.9440339
              ],
              [
                54.3329867,
                36.9467954
              ],
              [
                54.3353023,
                36.9498707
              ],
              [
                54.3360848,
                36.9535662
              ],
              [
                54.3360946,
                36.9560311
              ],
              [
                54.3361241,
                36.9634259
              ],
              [
                54.3369117,
                36.9683538
              ],
              [
                54.3376969,
                36.9726654
              ],
              [
                54.3392466,
                36.9760506
              ],
              [
                54.342325,
                36.9775832
              ],
              [
                54.3441244,
                36.9790174
              ],
              [
                54.3433741,
                36.9802154
              ],
              [
                54.3468325,
                36.9944258
              ],
              [
                54.345446,
                36.9997004
              ],
              [
                54.3462793,
                37.0016535
              ],
              [
                54.351506,
                37.0110507
              ],
              [
                54.3551192,
                37.0138319
              ],
              [
                54.3605834,
                37.0337533
              ],
              [
                54.3613162,
                37.0344348
              ],
              [
                54.3721528,
                37.0463783
              ],
              [
                54.3743887,
                37.0497084
              ],
              [
                54.393506,
                37.0898865
              ],
              [
                54.3951727,
                37.093774
              ],
              [
                54.3965626,
                37.0971128
              ],
              [
                54.4095256,
                37.1201572
              ],
              [
                54.4098023,
                37.1226589
              ],
              [
                54.4106356,
                37.1309823
              ],
              [
                54.4107993,
                37.1323772
              ],
              [
                54.4079761,
                37.1358118
              ],
              [
                54.4030422,
                37.136287
              ],
              [
                54.3896757,
                37.1374707
              ],
              [
                54.3885657,
                37.1374707
              ],
              [
                54.3882891,
                37.1377497
              ],
              [
                54.3871757,
                37.1377497
              ],
              [
                54.3866224,
                37.1380286
              ],
              [
                54.3849558,
                37.1380286
              ],
              [
                54.3846757,
                37.1383076
              ],
              [
                54.3816224,
                37.1383076
              ],
              [
                54.3807892,
                37.1385865
              ],
              [
                54.377177,
                37.1385865
              ],
              [
                54.3757858,
                37.1385865
              ],
              [
                54.3749525,
                37.1388655
              ],
              [
                54.359676,
                37.1388654
              ],
              [
                54.3568959,
                37.1396934
              ],
              [
                54.3557861,
                37.1396934
              ],
              [
                54.3541193,
                37.1402514
              ],
              [
                54.3532861,
                37.1402514
              ],
              [
                54.335323,
                37.1364635
              ],
              [
                54.3074795,
                37.1378774
              ],
              [
                54.2971798,
                37.1627793
              ],
              [
                54.3027433,
                37.1721523
              ],
              [
                54.3024666,
                37.1729891
              ],
              [
                54.30191,
                37.1732681
              ],
              [
                54.2876799,
                37.1951982
              ],
              [
                54.2818,
                37.2093442
              ],
              [
                54.2815233,
                37.209902
              ],
              [
                54.2762433,
                37.2182338
              ],
              [
                54.2762434,
                37.2187916
              ],
              [
                54.2756901,
                37.2193495
              ],
              [
                54.2752932,
                37.2207351
              ],
              [
                54.2751334,
                37.221293
              ],
              [
                54.2745768,
                37.2218508
              ],
              [
                54.2669769,
                37.2382217
              ],
              [
                54.2664202,
                37.2393283
              ],
              [
                54.2658669,
                37.2440519
              ],
              [
                54.2636436,
                37.2546052
              ],
              [
                54.2636435,
                37.2551631
              ],
              [
                54.2598869,
                37.2793961
              ],
              [
                54.2593302,
                37.2818974
              ],
              [
                54.2551637,
                37.2899495
              ],
              [
                54.254887,
                37.2905074
              ],
              [
                54.254607,
                37.2910562
              ],
              [
                54.2375108,
                37.2955784
              ],
              [
                54.2263547,
                37.3172808
              ],
              [
                54.2242496,
                37.3216901
              ],
              [
                54.2196008,
                37.322078
              ],
              [
                54.1950823,
                37.3241297
              ],
              [
                54.1705752,
                37.3261564
              ],
              [
                54.1654921,
                37.3265843
              ],
              [
                54.1457754,
                37.328244
              ],
              [
                54.1210053,
                37.3302989
              ],
              [
                54.0976908,
                37.3322544
              ],
              [
                54.0739299,
                37.3342226
              ],
              [
                54.0492799,
                37.3362906
              ],
              [
                54.030556,
                37.342222
              ],
              [
                54.021944,
                37.342778
              ],
              [
                54.013333,
                37.343333
              ],
              [
                54.004722,
                37.343889
              ],
              [
                53.996111,
                37.344722
              ],
              [
                53.987778,
                37.345278
              ],
              [
                53.9706342,
                37.3460666
              ],
              [
                53.9706491,
                37.3460373
              ],
              [
                53.8484159,
                37.3562681
              ],
              [
                53.6649493,
                37.3561378
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555292,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گنبد کاووس",
          "name:en": "Gonbad-e-Kavus County",
          "name:uk": "Ґомбеде-Кавус",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q720279",
          "wikipedia": "en:Gonbad-e Kavus County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.5795374,
                37.4548216
              ],
              [
                54.5797712,
                37.4518368
              ],
              [
                54.5800271,
                37.4497458
              ],
              [
                54.5800271,
                37.449467
              ],
              [
                54.5797471,
                37.4475241
              ],
              [
                54.5775272,
                37.440022
              ],
              [
                54.5772471,
                37.4369637
              ],
              [
                54.5769705,
                37.4352996
              ],
              [
                54.5766939,
                37.4347418
              ],
              [
                54.5769704,
                37.4264121
              ],
              [
                54.5764138,
                37.4227959
              ],
              [
                54.5780804,
                37.412523
              ],
              [
                54.5651309,
                37.4126967
              ],
              [
                54.5651309,
                37.4124178
              ],
              [
                54.5654109,
                37.4113114
              ],
              [
                54.5640209,
                37.4068678
              ],
              [
                54.5609643,
                37.4051947
              ],
              [
                54.560131,
                37.4051946
              ],
              [
                54.551521,
                37.4018665
              ],
              [
                54.5509644,
                37.4013087
              ],
              [
                54.5490211,
                37.4004723
              ],
              [
                54.5379079,
                37.3868624
              ],
              [
                54.5370745,
                37.3846404
              ],
              [
                54.5395657,
                37.3726131
              ],
              [
                54.5601651,
                37.3586969
              ],
              [
                54.5672236,
                37.3425512
              ],
              [
                54.5672236,
                37.3422722
              ],
              [
                54.571667,
                37.3344961
              ],
              [
                54.5747236,
                37.331157
              ],
              [
                54.5755569,
                37.330878
              ],
              [
                54.58752,
                37.3234871
              ],
              [
                54.6121264,
                37.3182278
              ],
              [
                54.6126831,
                37.3179488
              ],
              [
                54.6183627,
                37.3143255
              ],
              [
                54.6407861,
                37.3088545
              ],
              [
                54.6658628,
                37.300014
              ],
              [
                54.6666961,
                37.2997441
              ],
              [
                54.6850327,
                37.2908548
              ],
              [
                54.7300321,
                37.2758561
              ],
              [
                54.7308654,
                37.2755771
              ],
              [
                54.738922,
                37.2711324
              ],
              [
                54.7444786,
                37.2666876
              ],
              [
                54.7525352,
                37.2589045
              ],
              [
                54.7550352,
                37.2564032
              ],
              [
                54.7558685,
                37.2547386
              ],
              [
                54.7608685,
                37.2347363
              ],
              [
                54.7617018,
                37.231407
              ],
              [
                54.7728149,
                37.1847412
              ],
              [
                54.7793407,
                37.1689034
              ],
              [
                54.7797583,
                37.1680664
              ],
              [
                54.7900381,
                37.1522371
              ],
              [
                54.8047579,
                37.1369563
              ],
              [
                54.8061479,
                37.1361284
              ],
              [
                54.8078146,
                37.1344636
              ],
              [
                54.8117045,
                37.1316828
              ],
              [
                54.8119812,
                37.1311248
              ],
              [
                54.8578174,
                37.1022361
              ],
              [
                54.8589273,
                37.0961252
              ],
              [
                54.8583739,
                37.0925162
              ],
              [
                54.858094,
                37.0919583
              ],
              [
                54.858094,
                37.0911213
              ],
              [
                54.8589273,
                37.0908512
              ],
              [
                54.8594839,
                37.0905722
              ],
              [
                54.8603173,
                37.0905723
              ],
              [
                54.8617073,
                37.0900142
              ],
              [
                54.8653171,
                37.0900142
              ],
              [
                54.8694839,
                37.0908513
              ],
              [
                54.8736505,
                37.0911212
              ],
              [
                54.8744838,
                37.0908513
              ],
              [
                54.8764305,
                37.0908512
              ],
              [
                54.8769837,
                37.0905722
              ],
              [
                54.8817071,
                37.0905723
              ],
              [
                54.8825404,
                37.0902932
              ],
              [
                54.8842069,
                37.0902933
              ],
              [
                54.8850404,
                37.0900142
              ],
              [
                54.886707,
                37.0900142
              ],
              [
                54.8872636,
                37.0897352
              ],
              [
                54.8883736,
                37.0897353
              ],
              [
                54.8978203,
                37.0855683
              ],
              [
                54.9111535,
                37.068621
              ],
              [
                54.91171,
                37.0677931
              ],
              [
                54.9135612,
                37.0639919
              ],
              [
                54.91421,
                37.0647329
              ],
              [
                54.9442097,
                37.0808432
              ],
              [
                54.9480996,
                37.0825172
              ],
              [
                54.9483763,
                37.0826995
              ],
              [
                54.951433,
                37.0841822
              ],
              [
                54.9853225,
                37.1094539
              ],
              [
                54.9861559,
                37.1105698
              ],
              [
                54.9953225,
                37.1200104
              ],
              [
                54.9969926,
                37.1227912
              ],
              [
                55.0075457,
                37.1361285
              ],
              [
                55.0133789,
                37.1402951
              ],
              [
                55.013659,
                37.1408441
              ],
              [
                55.0144923,
                37.1411231
              ],
              [
                55.0150457,
                37.14196
              ],
              [
                55.0156022,
                37.14196
              ],
              [
                55.0158789,
                37.1425179
              ],
              [
                55.0206023,
                37.1450107
              ],
              [
                55.0225488,
                37.1450107
              ],
              [
                55.0233823,
                37.1452897
              ],
              [
                55.0261589,
                37.1452897
              ],
              [
                55.0267156,
                37.1455686
              ],
              [
                55.0292156,
                37.1455687
              ],
              [
                55.0306021,
                37.1452896
              ],
              [
                55.0417154,
                37.1452897
              ],
              [
                55.0428253,
                37.1450107
              ],
              [
                55.0442153,
                37.1450107
              ],
              [
                55.0453253,
                37.1447407
              ],
              [
                55.0539386,
                37.1427879
              ],
              [
                55.0581051,
                37.1447407
              ],
              [
                55.0831049,
                37.1494563
              ],
              [
                55.0872716,
                37.1505722
              ],
              [
                55.0886615,
                37.1508511
              ],
              [
                55.0892183,
                37.1511211
              ],
              [
                55.0944948,
                37.152237
              ],
              [
                55.1050513,
                37.1580685
              ],
              [
                55.1075513,
                37.162514
              ],
              [
                55.1078279,
                37.1636298
              ],
              [
                55.1058846,
                37.1711259
              ],
              [
                55.1019947,
                37.1766783
              ],
              [
                55.1014415,
                37.1777941
              ],
              [
                55.0922748,
                37.1864059
              ],
              [
                55.0919948,
                37.1880706
              ],
              [
                55.0917182,
                37.1886286
              ],
              [
                55.0919949,
                37.1889075
              ],
              [
                55.0928281,
                37.1914001
              ],
              [
                55.0933849,
                37.192237
              ],
              [
                55.0933849,
                37.192516
              ],
              [
                55.0942181,
                37.1930739
              ],
              [
                55.0961615,
                37.1936229
              ],
              [
                55.1031082,
                37.192237
              ],
              [
                55.1039415,
                37.192237
              ],
              [
                55.1097747,
                37.1897354
              ],
              [
                55.114498,
                37.1883496
              ],
              [
                55.1253312,
                37.1850201
              ],
              [
                55.1258844,
                37.1844621
              ],
              [
                55.1272745,
                37.1844622
              ],
              [
                55.1278311,
                37.1841832
              ],
              [
                55.1289411,
                37.1841832
              ],
              [
                55.1297744,
                37.1839043
              ],
              [
                55.1342211,
                37.1839042
              ],
              [
                55.1361643,
                37.1844621
              ],
              [
                55.137831,
                37.1844622
              ],
              [
                55.1483875,
                37.1880706
              ],
              [
                55.1536641,
                37.1880707
              ],
              [
                55.1581108,
                37.1872427
              ],
              [
                55.1594974,
                37.1872427
              ],
              [
                55.1631107,
                37.1861269
              ],
              [
                55.1633874,
                37.185848
              ],
              [
                55.1650541,
                37.1847411
              ],
              [
                55.1658874,
                37.1822395
              ],
              [
                55.1697773,
                37.1758503
              ],
              [
                55.1722774,
                37.1750134
              ],
              [
                55.1736673,
                37.1750134
              ],
              [
                55.1745005,
                37.1747345
              ],
              [
                55.1820005,
                37.1747344
              ],
              [
                55.1822772,
                37.1750135
              ],
              [
                55.1850538,
                37.1750135
              ],
              [
                55.1856105,
                37.1752923
              ],
              [
                55.1889438,
                37.1752924
              ],
              [
                55.1897771,
                37.1750134
              ],
              [
                55.1917237,
                37.1750134
              ],
              [
                55.192277,
                37.1747345
              ],
              [
                55.1933905,
                37.1747344
              ],
              [
                55.1942238,
                37.1744555
              ],
              [
                55.1953337,
                37.1744555
              ],
              [
                55.1958904,
                37.1741855
              ],
              [
                55.1970004,
                37.1741855
              ],
              [
                55.202557,
                37.1725207
              ],
              [
                55.2033903,
                37.1722327
              ],
              [
                55.2039436,
                37.170019
              ],
              [
                55.2042236,
                37.1694611
              ],
              [
                55.2003336,
                37.1600122
              ],
              [
                55.200057,
                37.1589053
              ],
              [
                55.1995004,
                37.1569615
              ],
              [
                55.2022769,
                37.1533529
              ],
              [
                55.2028337,
                37.1533528
              ],
              [
                55.2031102,
                37.1530739
              ],
              [
                55.2075569,
                37.1530739
              ],
              [
                55.2078336,
                37.152795
              ],
              [
                55.2086669,
                37.1527949
              ],
              [
                55.2092235,
                37.152516
              ],
              [
                55.2122803,
                37.1525159
              ],
              [
                55.2131135,
                37.152237
              ],
              [
                55.2156135,
                37.1522369
              ],
              [
                55.2222801,
                37.1511211
              ],
              [
                55.22339,
                37.151121
              ],
              [
                55.2250567,
                37.1505721
              ],
              [
                55.2264468,
                37.1505721
              ],
              [
                55.2267233,
                37.1502931
              ],
              [
                55.2272801,
                37.1502931
              ],
              [
                55.22728,
                37.1508511
              ],
              [
                55.2292232,
                37.1539018
              ],
              [
                55.2470032,
                37.1633508
              ],
              [
                55.2583931,
                37.170568
              ],
              [
                55.2681162,
                37.1730697
              ],
              [
                55.2728362,
                37.1739065
              ],
              [
                55.2792261,
                37.1750134
              ],
              [
                55.2806161,
                37.1750134
              ],
              [
                55.2814494,
                37.1752924
              ],
              [
                55.2825595,
                37.1752923
              ],
              [
                55.2886727,
                37.1772361
              ],
              [
                55.3067292,
                37.1925159
              ],
              [
                55.3117292,
                37.2008486
              ],
              [
                55.3106158,
                37.2094601
              ],
              [
                55.3103392,
                37.2119616
              ],
              [
                55.3100625,
                37.2216797
              ],
              [
                55.3103392,
                37.2225166
              ],
              [
                55.3117291,
                37.230291
              ],
              [
                55.3128391,
                37.2344571
              ],
              [
                55.3306191,
                37.2491867
              ],
              [
                55.3314523,
                37.2508514
              ],
              [
                55.3322856,
                37.2516882
              ],
              [
                55.3350622,
                37.2586254
              ],
              [
                55.335619,
                37.2614058
              ],
              [
                55.3375623,
                37.2694587
              ],
              [
                55.3372857,
                37.2736245
              ],
              [
                55.3370089,
                37.2744613
              ],
              [
                55.3369267,
                37.2763716
              ],
              [
                55.3369249,
                37.276377
              ],
              [
                55.3358956,
                37.289181
              ],
              [
                55.3364523,
                37.2908545
              ],
              [
                55.3375623,
                37.2950202
              ],
              [
                55.3400623,
                37.2980703
              ],
              [
                55.3403422,
                37.2986281
              ],
              [
                55.3572854,
                37.3030727
              ],
              [
                55.3578421,
                37.3030727
              ],
              [
                55.3586754,
                37.3033517
              ],
              [
                55.3606187,
                37.305295
              ],
              [
                55.3608988,
                37.3061317
              ],
              [
                55.3617321,
                37.3069595
              ],
              [
                55.3631186,
                37.3147418
              ],
              [
                55.362842,
                37.3191863
              ],
              [
                55.3611753,
                37.3236309
              ],
              [
                55.3609877,
                37.3241986
              ],
              [
                55.3522856,
                37.3341841
              ],
              [
                55.350062,
                37.3364062
              ],
              [
                55.3473725,
                37.3434043
              ],
              [
                55.3458955,
                37.3472471
              ],
              [
                55.3458955,
                37.347517
              ],
              [
                55.3458956,
                37.3486326
              ],
              [
                55.3464521,
                37.3494603
              ],
              [
                55.3467288,
                37.3505759
              ],
              [
                55.3547855,
                37.3622442
              ],
              [
                55.3604501,
                37.3735698
              ],
              [
                55.3658987,
                37.3844647
              ],
              [
                55.3686753,
                37.3900242
              ],
              [
                55.3686753,
                37.3908519
              ],
              [
                55.373952,
                37.3997398
              ],
              [
                55.3742319,
                37.4000187
              ],
              [
                55.3764554,
                37.4036349
              ],
              [
                55.3831219,
                37.4100219
              ],
              [
                55.3839553,
                37.4105796
              ],
              [
                55.3847885,
                37.4111284
              ],
              [
                55.3847885,
                37.4114073
              ],
              [
                55.395065,
                37.4275182
              ],
              [
                55.3947885,
                37.4300189
              ],
              [
                55.3942317,
                37.4311344
              ],
              [
                55.3939552,
                37.4333562
              ],
              [
                55.3628422,
                37.4672408
              ],
              [
                55.3589522,
                37.4708568
              ],
              [
                55.3097827,
                37.5205781
              ],
              [
                55.3075628,
                37.5241938
              ],
              [
                55.2995062,
                37.5464087
              ],
              [
                55.2986729,
                37.551967
              ],
              [
                55.2983929,
                37.5528033
              ],
              [
                55.2983928,
                37.5530821
              ],
              [
                55.2983929,
                37.5589189
              ],
              [
                55.2986728,
                37.5600252
              ],
              [
                55.2992296,
                37.5633618
              ],
              [
                55.2997829,
                37.5658619
              ],
              [
                55.3003395,
                37.5686409
              ],
              [
                55.3014496,
                37.5733624
              ],
              [
                55.3014495,
                37.5739111
              ],
              [
                55.3050629,
                37.5822479
              ],
              [
                55.3067295,
                37.5922482
              ],
              [
                55.3070061,
                37.5961333
              ],
              [
                55.3072828,
                37.6097485
              ],
              [
                55.3075628,
                37.6139121
              ],
              [
                55.3078396,
                37.6161424
              ],
              [
                55.3083962,
                37.6250273
              ],
              [
                55.3139495,
                37.6483626
              ],
              [
                55.3172827,
                37.6719759
              ],
              [
                55.3170061,
                37.6866955
              ],
              [
                55.3167295,
                37.6875317
              ],
              [
                55.3178394,
                37.696973
              ],
              [
                55.3253394,
                37.7255834
              ],
              [
                55.3264528,
                37.7325335
              ],
              [
                55.3267294,
                37.7341969
              ],
              [
                55.3264528,
                37.7505873
              ],
              [
                55.3261727,
                37.7544714
              ],
              [
                55.3300627,
                37.7633631
              ],
              [
                55.3300627,
                37.7636417
              ],
              [
                55.3303394,
                37.764478
              ],
              [
                55.3347861,
                37.7678134
              ],
              [
                55.3456193,
                37.7716973
              ],
              [
                55.3470093,
                37.7716974
              ],
              [
                55.3475625,
                37.771976
              ],
              [
                55.3600658,
                37.771976
              ],
              [
                55.3628424,
                37.7714186
              ],
              [
                55.3700656,
                37.7708611
              ],
              [
                55.3889554,
                37.7708611
              ],
              [
                55.3908988,
                37.7705914
              ],
              [
                55.3983986,
                37.7708611
              ],
              [
                55.401732,
                37.7703128
              ],
              [
                55.4122886,
                37.7703128
              ],
              [
                55.4206218,
                37.7708611
              ],
              [
                55.4228451,
                37.7705914
              ],
              [
                55.4242351,
                37.7703127
              ],
              [
                55.426455,
                37.7703128
              ],
              [
                55.4284018,
                37.7705914
              ],
              [
                55.4334016,
                37.7705914
              ],
              [
                55.4345116,
                37.7708611
              ],
              [
                55.4461782,
                37.7705914
              ],
              [
                55.4503447,
                37.770034
              ],
              [
                55.5000709,
                37.7644778
              ],
              [
                55.5231274,
                37.7841938
              ],
              [
                55.5350739,
                37.7936426
              ],
              [
                55.5434072,
                37.8050329
              ],
              [
                55.5481333,
                37.8159504
              ],
              [
                55.5514638,
                37.8236419
              ],
              [
                55.5517405,
                37.8244779
              ],
              [
                55.5556304,
                37.8417019
              ],
              [
                55.5556304,
                37.8447583
              ],
              [
                55.5559071,
                37.8469786
              ],
              [
                55.5553505,
                37.8547543
              ],
              [
                55.5547971,
                37.8564263
              ],
              [
                55.5542405,
                37.8644806
              ],
              [
                55.5539639,
                37.8667009
              ],
              [
                55.5542404,
                37.8691999
              ],
              [
                55.5542405,
                37.8772539
              ],
              [
                55.5542405,
                37.881982
              ],
              [
                55.5506306,
                37.9089209
              ],
              [
                55.5506305,
                37.9175318
              ],
              [
                55.5528506,
                37.9355888
              ],
              [
                55.5531305,
                37.9394806
              ],
              [
                55.5611838,
                37.9586426
              ],
              [
                55.5789637,
                37.9828189
              ],
              [
                55.5856303,
                37.9983755
              ],
              [
                55.5917435,
                38.0058707
              ],
              [
                55.5922968,
                38.0067064
              ],
              [
                55.5936869,
                38.0092048
              ],
              [
                55.5936869,
                38.0094833
              ],
              [
                55.5967435,
                38.0164212
              ],
              [
                55.6780899,
                38.1041368
              ],
              [
                55.6827879,
                38.1103571
              ],
              [
                55.6775,
                38.109722
              ],
              [
                55.670278,
                38.108889
              ],
              [
                55.6625,
                38.108889
              ],
              [
                55.654722,
                38.108889
              ],
              [
                55.646944,
                38.108889
              ],
              [
                55.638889,
                38.108889
              ],
              [
                55.631111,
                38.108611
              ],
              [
                55.624167,
                38.107778
              ],
              [
                55.616111,
                38.107778
              ],
              [
                55.61,
                38.106389
              ],
              [
                55.603611,
                38.104722
              ],
              [
                55.597222,
                38.103333
              ],
              [
                55.592778,
                38.101389
              ],
              [
                55.586389,
                38.1
              ],
              [
                55.579444,
                38.099167
              ],
              [
                55.571667,
                38.099167
              ],
              [
                55.564444,
                38.098333
              ],
              [
                55.556667,
                38.098333
              ],
              [
                55.549444,
                38.0975
              ],
              [
                55.5425,
                38.096667
              ],
              [
                55.536111,
                38.095
              ],
              [
                55.53,
                38.093611
              ],
              [
                55.523611,
                38.091944
              ],
              [
                55.516389,
                38.091111
              ],
              [
                55.507778,
                38.091944
              ],
              [
                55.5,
                38.091667
              ],
              [
                55.492222,
                38.091667
              ],
              [
                55.484444,
                38.091667
              ],
              [
                55.477222,
                38.090833
              ],
              [
                55.469444,
                38.090833
              ],
              [
                55.463056,
                38.089167
              ],
              [
                55.456111,
                38.088333
              ],
              [
                55.448889,
                38.0875
              ],
              [
                55.442778,
                38.086111
              ],
              [
                55.438056,
                38.083056
              ],
              [
                55.4325,
                38.080556
              ],
              [
                55.427778,
                38.0775
              ],
              [
                55.423056,
                38.074444
              ],
              [
                55.418889,
                38.070833
              ],
              [
                55.414167,
                38.067778
              ],
              [
                55.410278,
                38.063889
              ],
              [
                55.406389,
                38.06
              ],
              [
                55.402222,
                38.056389
              ],
              [
                55.398333,
                38.0525
              ],
              [
                55.394444,
                38.048611
              ],
              [
                55.389444,
                38.045
              ],
              [
                55.384722,
                38.041944
              ],
              [
                55.379444,
                38.039444
              ],
              [
                55.373889,
                38.037222
              ],
              [
                55.3675595,
                38.0361742
              ],
              [
                55.361944,
                38.033333
              ],
              [
                55.356389,
                38.031111
              ],
              [
                55.350833,
                38.028889
              ],
              [
                55.344722,
                38.027222
              ],
              [
                55.339167,
                38.025
              ],
              [
                55.332778,
                38.023333
              ],
              [
                55.3275,
                38.021111
              ],
              [
                55.321944,
                38.018611
              ],
              [
                55.316389,
                38.016389
              ],
              [
                55.3139263,
                38.0088697
              ],
              [
                55.3031359,
                38.0054301
              ],
              [
                55.2957659,
                38.0028555
              ],
              [
                55.289167,
                38.000833
              ],
              [
                55.2835226,
                37.997925
              ],
              [
                55.273663,
                37.9904761
              ],
              [
                55.2733911,
                37.9908448
              ],
              [
                55.2729267,
                37.9915752
              ],
              [
                55.2726926,
                37.9922382
              ],
              [
                55.2723457,
                37.9926347
              ],
              [
                55.271844,
                37.9925905
              ],
              [
                55.2714784,
                37.9923544
              ],
              [
                55.2711228,
                37.9917512
              ],
              [
                55.2704379,
                37.991187
              ],
              [
                55.2700062,
                37.9910677
              ],
              [
                55.269421,
                37.991355
              ],
              [
                55.2688852,
                37.9917324
              ],
              [
                55.2686799,
                37.9920559
              ],
              [
                55.2687118,
                37.9925937
              ],
              [
                55.2686164,
                37.9928735
              ],
              [
                55.2683649,
                37.9931131
              ],
              [
                55.2679454,
                37.993211
              ],
              [
                55.2676624,
                37.9930858
              ],
              [
                55.2673241,
                37.992621
              ],
              [
                55.2669339,
                37.9919785
              ],
              [
                55.2667737,
                37.9912624
              ],
              [
                55.2665349,
                37.9909806
              ],
              [
                55.2661793,
                37.9909738
              ],
              [
                55.2655376,
                37.9911856
              ],
              [
                55.2649738,
                37.9913429
              ],
              [
                55.2646603,
                37.9911172
              ],
              [
                55.2644882,
                37.990632
              ],
              [
                55.2644882,
                37.9902219
              ],
              [
                55.2642367,
                37.9898665
              ],
              [
                55.2633696,
                37.9898878
              ],
              [
                55.2625881,
                37.9903281
              ],
              [
                55.2616759,
                37.9906073
              ],
              [
                55.2612068,
                37.9898004
              ],
              [
                55.2610682,
                37.9889263
              ],
              [
                55.2610682,
                37.9881833
              ],
              [
                55.2617614,
                37.9872655
              ],
              [
                55.2617614,
                37.986741
              ],
              [
                55.2613177,
                37.9862602
              ],
              [
                55.2606245,
                37.9863039
              ],
              [
                55.2599314,
                37.9870688
              ],
              [
                55.2591273,
                37.9873966
              ],
              [
                55.2589609,
                37.9878992
              ],
              [
                55.2587668,
                37.988817
              ],
              [
                55.2582954,
                37.9889482
              ],
              [
                55.2576854,
                37.988533
              ],
              [
                55.2572141,
                37.9879429
              ],
              [
                55.2572973,
                37.9872655
              ],
              [
                55.2570477,
                37.9863913
              ],
              [
                55.2565209,
                37.9860417
              ],
              [
                55.2557722,
                37.9859106
              ],
              [
                55.2549404,
                37.985998
              ],
              [
                55.2537481,
                37.9865662
              ],
              [
                55.2526945,
                37.9868503
              ],
              [
                55.2518904,
                37.9868066
              ],
              [
                55.2509477,
                37.986588
              ],
              [
                55.2502822,
                37.9862384
              ],
              [
                55.2504486,
                37.9856702
              ],
              [
                55.2511418,
                37.9852987
              ],
              [
                55.2516131,
                37.9848834
              ],
              [
                55.2515577,
                37.9843152
              ],
              [
                55.2510309,
                37.9838344
              ],
              [
                55.2508645,
                37.9831132
              ],
              [
                55.2510586,
                37.9825232
              ],
              [
                55.2506704,
                37.9823046
              ],
              [
                55.2496445,
                37.9823046
              ],
              [
                55.2488127,
                37.9821079
              ],
              [
                55.2472322,
                37.9816708
              ],
              [
                55.2462617,
                37.9809715
              ],
              [
                55.2455408,
                37.9805344
              ],
              [
                55.2449031,
                37.9808403
              ],
              [
                55.2446535,
                37.9817801
              ],
              [
                55.2438772,
                37.9824139
              ],
              [
                55.2432949,
                37.9824795
              ],
              [
                55.2426572,
                37.9821079
              ],
              [
                55.2420749,
                37.981496
              ],
              [
                55.2417144,
                37.9805562
              ],
              [
                55.2412985,
                37.9802721
              ],
              [
                55.2406053,
                37.9802721
              ],
              [
                55.2399676,
                37.9800317
              ],
              [
                55.2394408,
                37.9797476
              ],
              [
                55.2385535,
                37.9795509
              ],
              [
                55.2384703,
                37.9791137
              ],
              [
                55.2389417,
                37.9786766
              ],
              [
                55.2393299,
                37.9781739
              ],
              [
                55.2393853,
                37.9776057
              ],
              [
                55.2388031,
                37.9771467
              ],
              [
                55.237999,
                37.9768189
              ],
              [
                55.2369453,
                37.9767314
              ],
              [
                55.236058,
                37.9771248
              ],
              [
                55.2355867,
                37.9776275
              ],
              [
                55.234533,
                37.9779772
              ],
              [
                55.2335349,
                37.9788515
              ],
              [
                55.2331189,
                37.9793104
              ],
              [
                55.2325644,
                37.9793542
              ],
              [
                55.2316494,
                37.9791793
              ],
              [
                55.2307898,
                37.9788733
              ],
              [
                55.2303739,
                37.9784362
              ],
              [
                55.2300967,
                37.978021
              ],
              [
                55.2295698,
                37.9781084
              ],
              [
                55.2292371,
                37.9786548
              ],
              [
                55.2291539,
                37.979223
              ],
              [
                55.2287657,
                37.9796164
              ],
              [
                55.2279062,
                37.9796164
              ],
              [
                55.2271298,
                37.9792886
              ],
              [
                55.2266862,
                37.9788296
              ],
              [
                55.2262703,
                37.9779554
              ],
              [
                55.225688,
                37.977409
              ],
              [
                55.2247175,
                37.9772778
              ],
              [
                55.2237193,
                37.9768844
              ],
              [
                55.223248,
                37.9764692
              ],
              [
                55.2234143,
                37.9757479
              ],
              [
                55.2233312,
                37.9749392
              ],
              [
                55.2225271,
                37.9745676
              ],
              [
                55.221723,
                37.9746113
              ],
              [
                55.2208911,
                37.9743709
              ],
              [
                55.2209189,
                37.9737808
              ],
              [
                55.2216121,
                37.9731906
              ],
              [
                55.2216398,
                37.9724693
              ],
              [
                55.2213071,
                37.9720321
              ],
              [
                55.2203643,
                37.9714201
              ],
              [
                55.2195602,
                37.9712453
              ],
              [
                55.2190889,
                37.971442
              ],
              [
                55.2185343,
                37.971595
              ],
              [
                55.2182016,
                37.9715076
              ],
              [
                55.2182293,
                37.9710704
              ],
              [
                55.2186175,
                37.9705458
              ],
              [
                55.2191166,
                37.96989
              ],
              [
                55.2196157,
                37.9695622
              ],
              [
                55.2192275,
                37.9691469
              ],
              [
                55.2184789,
                37.9686878
              ],
              [
                55.2177302,
                37.9687097
              ],
              [
                55.2166489,
                37.968819
              ],
              [
                55.2160389,
                37.9686878
              ],
              [
                55.2153457,
                37.9681632
              ],
              [
                55.2154288,
                37.9675512
              ],
              [
                55.2159002,
                37.9671358
              ],
              [
                55.2155952,
                37.9666331
              ],
              [
                55.214902,
                37.9664363
              ],
              [
                55.2137929,
                37.9661522
              ],
              [
                55.2127393,
                37.9659991
              ],
              [
                55.2117966,
                37.9662833
              ],
              [
                55.2106597,
                37.9665019
              ],
              [
                55.2096061,
                37.9664145
              ],
              [
                55.208802,
                37.9660647
              ],
              [
                55.208497,
                37.9654745
              ],
              [
                55.2086911,
                37.9650373
              ],
              [
                55.2084693,
                37.9646438
              ],
              [
                55.2080256,
                37.9640973
              ],
              [
                55.2077484,
                37.9633759
              ],
              [
                55.2075265,
                37.962895
              ],
              [
                55.206667,
                37.9627638
              ],
              [
                55.2060847,
                37.9625452
              ],
              [
                55.205752,
                37.9619987
              ],
              [
                55.2061956,
                37.9615396
              ],
              [
                55.2069997,
                37.961321
              ],
              [
                55.2074434,
                37.9608838
              ],
              [
                55.2073047,
                37.9605559
              ],
              [
                55.2068333,
                37.9602061
              ],
              [
                55.2058352,
                37.9595284
              ],
              [
                55.2056688,
                37.9590256
              ],
              [
                55.2059461,
                37.9582167
              ],
              [
                55.206667,
                37.957845
              ],
              [
                55.2074156,
                37.9577139
              ],
              [
                55.2075543,
                37.9573641
              ],
              [
                55.2073324,
                37.9569487
              ],
              [
                55.2065561,
                37.9567519
              ],
              [
                55.2055024,
                37.9567082
              ],
              [
                55.2045042,
                37.9566645
              ],
              [
                55.2038942,
                37.9563803
              ],
              [
                55.2038665,
                37.9560305
              ],
              [
                55.2041438,
                37.9555932
              ],
              [
                55.204532,
                37.9551122
              ],
              [
                55.2051142,
                37.9545875
              ],
              [
                55.2056688,
                37.9544126
              ],
              [
                55.2062233,
                37.9541284
              ],
              [
                55.2061124,
                37.9538442
              ],
              [
                55.205447,
                37.9536693
              ],
              [
                55.2045874,
                37.9535818
              ],
              [
                55.2037556,
                37.9535381
              ],
              [
                55.2034506,
                37.9530352
              ],
              [
                55.2036447,
                37.9526636
              ],
              [
                55.2037833,
                37.9521607
              ],
              [
                55.2039774,
                37.9515704
              ],
              [
                55.2043933,
                37.9510019
              ],
              [
                55.205142,
                37.9506958
              ],
              [
                55.205752,
                37.9502804
              ],
              [
                55.2055856,
                37.949865
              ],
              [
                55.2050865,
                37.9494714
              ],
              [
                55.2044765,
                37.949209
              ],
              [
                55.2041172,
                37.9492023
              ],
              [
                55.203312,
                37.9491872
              ],
              [
                55.2025911,
                37.9491872
              ],
              [
                55.2020365,
                37.9489466
              ],
              [
                55.2017038,
                37.9486405
              ],
              [
                55.2020088,
                37.9481595
              ],
              [
                55.2020642,
                37.947591
              ],
              [
                55.2015097,
                37.9473068
              ],
              [
                55.200761,
                37.9474161
              ],
              [
                55.2000124,
                37.9476566
              ],
              [
                55.1994301,
                37.9482688
              ],
              [
                55.1989588,
                37.9488811
              ],
              [
                55.1991251,
                37.9493621
              ],
              [
                55.1993192,
                37.9497119
              ],
              [
                55.199236,
                37.9500617
              ],
              [
                55.1986815,
                37.9501273
              ],
              [
                55.1979328,
                37.9499961
              ],
              [
                55.1973506,
                37.9494714
              ],
              [
                55.1968792,
                37.9489904
              ],
              [
                55.1967406,
                37.948247
              ],
              [
                55.196796,
                37.9476348
              ],
              [
                55.1964633,
                37.9471974
              ],
              [
                55.1957978,
                37.9473068
              ],
              [
                55.1952433,
                37.9478097
              ],
              [
                55.1947719,
                37.9480721
              ],
              [
                55.1944669,
                37.9478971
              ],
              [
                55.1940233,
                37.9476785
              ],
              [
                55.1933301,
                37.9475036
              ],
              [
                55.1927201,
                37.9475692
              ],
              [
                55.1923874,
                37.9480283
              ],
              [
                55.1918883,
                37.9490122
              ],
              [
                55.191306,
                37.9503241
              ],
              [
                55.1909455,
                37.9515485
              ],
              [
                55.1905851,
                37.9520514
              ],
              [
                55.1903078,
                37.9524449
              ],
              [
                55.1903355,
                37.9528166
              ],
              [
                55.1905851,
                37.9531664
              ],
              [
                55.1905019,
                37.9535381
              ],
              [
                55.1901137,
                37.9537567
              ],
              [
                55.1896146,
                37.9535818
              ],
              [
                55.1887533,
                37.9531925
              ],
              [
                55.1872086,
                37.9533902
              ],
              [
                55.1864438,
                37.9536427
              ],
              [
                55.1857167,
                37.9539797
              ],
              [
                55.1849886,
                37.9543402
              ],
              [
                55.1843516,
                37.9545107
              ],
              [
                55.1837567,
                37.9543965
              ],
              [
                55.1831681,
                37.95416
              ],
              [
                55.182685,
                37.9542016
              ],
              [
                55.1823657,
                37.9546073
              ],
              [
                55.182156,
                37.9551813
              ],
              [
                55.1815324,
                37.955821
              ],
              [
                55.1811413,
                37.9558291
              ],
              [
                55.1806366,
                37.9556165
              ],
              [
                55.1801235,
                37.955134
              ],
              [
                55.1796905,
                37.954993
              ],
              [
                55.1792328,
                37.955416
              ],
              [
                55.1791361,
                37.9560114
              ],
              [
                55.1792865,
                37.9563941
              ],
              [
                55.1794262,
                37.9570576
              ],
              [
                55.1793499,
                37.95742
              ],
              [
                55.1789535,
                37.9576274
              ],
              [
                55.1782553,
                37.9576189
              ],
              [
                55.1757016,
                37.9569621
              ],
              [
                55.17514,
                37.956981
              ],
              [
                55.1747103,
                37.9572532
              ],
              [
                55.1741786,
                37.9581082
              ],
              [
                55.1738509,
                37.9581888
              ],
              [
                55.1734105,
                37.9580272
              ],
              [
                55.1730237,
                37.957704
              ],
              [
                55.172723,
                37.9573042
              ],
              [
                55.172261,
                37.9572957
              ],
              [
                55.1717669,
                37.9576104
              ],
              [
                55.1713557,
                37.9581519
              ],
              [
                55.1710686,
                37.9587077
              ],
              [
                55.1706712,
                37.9592095
              ],
              [
                55.1703704,
                37.9596433
              ],
              [
                55.1701873,
                37.9601765
              ],
              [
                55.1699085,
                37.9605363
              ],
              [
                55.1695862,
                37.9606129
              ],
              [
                55.1690061,
                37.9603237
              ],
              [
                55.1686306,
                37.9598825
              ],
              [
                55.1683508,
                37.9593711
              ],
              [
                55.1683186,
                37.9585971
              ],
              [
                55.1683616,
                37.9580357
              ],
              [
                55.1681897,
                37.9575424
              ],
              [
                55.1676872,
                37.9572562
              ],
              [
                55.1666106,
                37.9571171
              ],
              [
                55.1658479,
                37.9571681
              ],
              [
                55.1649885,
                37.9579251
              ],
              [
                55.1643762,
                37.9582654
              ],
              [
                55.1639519,
                37.9581966
              ],
              [
                55.1639035,
                37.9579422
              ],
              [
                55.1640109,
                37.9573212
              ],
              [
                55.1643654,
                37.9567514
              ],
              [
                55.164887,
                37.9562854
              ],
              [
                55.1649348,
                37.9560114
              ],
              [
                55.1643547,
                37.9557052
              ],
              [
                55.1635383,
                37.9554755
              ],
              [
                55.1626332,
                37.955146
              ],
              [
                55.162174,
                37.9551863
              ],
              [
                55.1618732,
                37.955518
              ],
              [
                55.1616254,
                37.95615
              ],
              [
                55.1613039,
                37.9563431
              ],
              [
                55.1608097,
                37.9564367
              ],
              [
                55.1601661,
                37.9563357
              ],
              [
                55.1596603,
                37.956224
              ],
              [
                55.1594884,
                37.9560454
              ],
              [
                55.1596173,
                37.9558327
              ],
              [
                55.1597785,
                37.9555861
              ],
              [
                55.1597785,
                37.9553224
              ],
              [
                55.1597033,
                37.9550502
              ],
              [
                55.1593938,
                37.9545258
              ],
              [
                55.1589083,
                37.9543272
              ],
              [
                55.1584571,
                37.9542081
              ],
              [
                55.1581279,
                37.9540277
              ],
              [
                55.1580597,
                37.9538083
              ],
              [
                55.1582745,
                37.9536042
              ],
              [
                55.1585431,
                37.9533235
              ],
              [
                55.1584357,
                37.9530683
              ],
              [
                55.1580489,
                37.9529832
              ],
              [
                55.1576192,
                37.9530598
              ],
              [
                55.1572218,
                37.9528982
              ],
              [
                55.1570714,
                37.9526345
              ],
              [
                55.1570334,
                37.9520646
              ],
              [
                55.1570929,
                37.9517753
              ],
              [
                55.1573185,
                37.9515542
              ],
              [
                55.1576837,
                37.9513755
              ],
              [
                55.1578126,
                37.9510863
              ],
              [
                55.1575055,
                37.9507791
              ],
              [
                55.1569747,
                37.9503888
              ],
              [
                55.1565987,
                37.9499805
              ],
              [
                55.1561537,
                37.9496543
              ],
              [
                55.1555782,
                37.9496828
              ],
              [
                55.1549981,
                37.949955
              ],
              [
                55.1547833,
                37.9503037
              ],
              [
                55.154461,
                37.9507206
              ],
              [
                55.1540514,
                37.9510265
              ],
              [
                55.1537735,
                37.9511374
              ],
              [
                55.1533545,
                37.9509502
              ],
              [
                55.1529571,
                37.9505164
              ],
              [
                55.1522588,
                37.9504654
              ],
              [
                55.1516895,
                37.9505589
              ],
              [
                55.151154,
                37.9507358
              ],
              [
                55.1507227,
                37.9510523
              ],
              [
                55.1503897,
                37.9513585
              ],
              [
                55.1496807,
                37.9514266
              ],
              [
                55.1492725,
                37.9513841
              ],
              [
                55.1487353,
                37.9507716
              ],
              [
                55.1484131,
                37.9505759
              ],
              [
                55.1481385,
                37.9506011
              ],
              [
                55.1477363,
                37.9509332
              ],
              [
                55.147414,
                37.9514691
              ],
              [
                55.1473558,
                37.952231
              ],
              [
                55.1470595,
                37.9524473
              ],
              [
                55.1465838,
                37.9526315
              ],
              [
                55.1461787,
                37.9530343
              ],
              [
                55.1457705,
                37.9531789
              ],
              [
                55.1453837,
                37.9528641
              ],
              [
                55.1452011,
                37.9521581
              ],
              [
                55.1453515,
                37.9514861
              ],
              [
                55.1458349,
                37.9510863
              ],
              [
                55.1462848,
                37.9505546
              ],
              [
                55.146716,
                37.9500471
              ],
              [
                55.1467243,
                37.9496101
              ],
              [
                55.1463732,
                37.949332
              ],
              [
                55.1458201,
                37.9491064
              ],
              [
                55.1451524,
                37.9489083
              ],
              [
                55.1444759,
                37.9488982
              ],
              [
                55.1440153,
                37.9487825
              ],
              [
                55.1434969,
                37.9484845
              ],
              [
                55.1432042,
                37.948617
              ],
              [
                55.1430035,
                37.9487891
              ],
              [
                55.142644,
                37.9494314
              ],
              [
                55.1423368,
                37.9499767
              ],
              [
                55.142159,
                37.9501133
              ],
              [
                55.14195,
                37.9501531
              ],
              [
                55.1417828,
                37.9501266
              ],
              [
                55.1415654,
                37.9499346
              ],
              [
                55.1412393,
                37.9493519
              ],
              [
                55.1409801,
                37.948948
              ],
              [
                55.1408296,
                37.9486368
              ],
              [
                55.1408045,
                37.9484845
              ],
              [
                55.140746,
                37.9482263
              ],
              [
                55.1407376,
                37.9480144
              ],
              [
                55.1405655,
                37.9478006
              ],
              [
                55.1402192,
                37.94769
              ],
              [
                55.139659,
                37.9477297
              ],
              [
                55.139266,
                37.9480475
              ],
              [
                55.1388145,
                37.9482991
              ],
              [
                55.1380286,
                37.9486037
              ],
              [
                55.1373513,
                37.9488156
              ],
              [
                55.1371039,
                37.9486643
              ],
              [
                55.1370336,
                37.9483256
              ],
              [
                55.1373346,
                37.9480144
              ],
              [
                55.137368,
                37.9475907
              ],
              [
                55.1370252,
                37.9472265
              ],
              [
                55.1366257,
                37.9469891
              ],
              [
                55.1360135,
                37.9468689
              ],
              [
                55.1354951,
                37.9468491
              ],
              [
                55.1351673,
                37.9473298
              ],
              [
                55.1346188,
                37.9476476
              ],
              [
                55.1340168,
                37.9480502
              ],
              [
                55.1334817,
                37.9486487
              ],
              [
                55.1331534,
                37.9491603
              ],
              [
                55.1329064,
                37.9496234
              ],
              [
                55.1327124,
                37.9498299
              ],
              [
                55.1323512,
                37.9498141
              ],
              [
                55.1319967,
                37.9495386
              ],
              [
                55.1317358,
                37.9491255
              ],
              [
                55.1314234,
                37.9488548
              ],
              [
                55.1310201,
                37.948617
              ],
              [
                55.1306054,
                37.948511
              ],
              [
                55.1301238,
                37.9485746
              ],
              [
                55.1294013,
                37.9488553
              ],
              [
                55.1286589,
                37.9491308
              ],
              [
                55.1282241,
                37.9492579
              ],
              [
                55.1278829,
                37.9492844
              ],
              [
                55.1276555,
                37.9491996
              ],
              [
                55.1275618,
                37.9490036
              ],
              [
                55.1276154,
                37.9486752
              ],
              [
                55.1278829,
                37.9482568
              ],
              [
                55.1279435,
                37.9479267
              ],
              [
                55.1279364,
                37.94769
              ],
              [
                55.1278695,
                37.9474569
              ],
              [
                55.1276421,
                37.9473192
              ],
              [
                55.1274147,
                37.9472662
              ],
              [
                55.1269197,
                37.947049
              ],
              [
                55.1268127,
                37.9466359
              ],
              [
                55.1268796,
                37.9461432
              ],
              [
                55.1268862,
                37.9456082
              ],
              [
                55.1267859,
                37.945301
              ],
              [
                55.1264515,
                37.9451421
              ],
              [
                55.1260551,
                37.944995
              ],
              [
                55.1255551,
                37.9446653
              ],
              [
                55.1248936,
                37.9444353
              ],
              [
                55.1240434,
                37.9445594
              ],
              [
                55.1231805,
                37.9446282
              ],
              [
                55.1226186,
                37.9446547
              ],
              [
                55.1223054,
                37.9446113
              ],
              [
                55.1222039,
                37.9443952
              ],
              [
                55.1223845,
                37.9440826
              ],
              [
                55.1230333,
                37.9435317
              ],
              [
                55.1236421,
                37.9429013
              ],
              [
                55.1238561,
                37.9426153
              ],
              [
                55.123816,
                37.9424034
              ],
              [
                55.123663,
                37.9421981
              ],
              [
                55.1231203,
                37.9420061
              ],
              [
                55.1224782,
                37.9419743
              ],
              [
                55.1215539,
                37.9419821
              ],
              [
                55.1213878,
                37.9417571
              ],
              [
                55.1212875,
                37.9414763
              ],
              [
                55.1213745,
                37.94083
              ],
              [
                55.1217758,
                37.9402314
              ],
              [
                55.1219631,
                37.9396751
              ],
              [
                55.121797,
                37.9394217
              ],
              [
                55.1212674,
                37.9392142
              ],
              [
                55.1205183,
                37.9392142
              ],
              [
                55.1197148,
                37.9393551
              ],
              [
                55.1185584,
                37.9395851
              ],
              [
                55.1181838,
                37.9395586
              ],
              [
                55.1180166,
                37.9393361
              ],
              [
                55.1179898,
                37.9388116
              ],
              [
                55.1180299,
                37.9382289
              ],
              [
                55.1178359,
                37.9378368
              ],
              [
                55.1174385,
                37.9376934
              ],
              [
                55.1168995,
                37.9376355
              ],
              [
                55.1164781,
                37.9377203
              ],
              [
                55.1160901,
                37.9381918
              ],
              [
                55.1156687,
                37.9386898
              ],
              [
                55.1152941,
                37.9390765
              ],
              [
                55.1149329,
                37.9391136
              ],
              [
                55.1146051,
                37.9388646
              ],
              [
                55.1143577,
                37.938471
              ],
              [
                55.1141235,
                37.9380488
              ],
              [
                55.1137155,
                37.9375402
              ],
              [
                55.1129596,
                37.9368621
              ],
              [
                55.1123712,
                37.9364849
              ],
              [
                55.1116954,
                37.9364117
              ],
              [
                55.1109596,
                37.9364912
              ],
              [
                55.1104896,
                37.9364214
              ],
              [
                55.1103576,
                37.9362899
              ],
              [
                55.1102974,
                37.9360462
              ],
              [
                55.1100566,
                37.935527
              ],
              [
                55.1096418,
                37.9351138
              ],
              [
                55.1093141,
                37.9347164
              ],
              [
                55.1093074,
                37.9343879
              ],
              [
                55.1094151,
                37.934075
              ],
              [
                55.1093342,
                37.9338369
              ],
              [
                55.1084713,
                37.9337098
              ],
              [
                55.1076963,
                37.9335876
              ],
              [
                55.1071401,
                37.9335085
              ],
              [
                55.1068258,
                37.9333124
              ],
              [
                55.1067522,
                37.9330369
              ],
              [
                55.106906,
                37.9325283
              ],
              [
                55.1069863,
                37.9321098
              ],
              [
                55.1069183,
                37.9318056
              ],
              [
                55.1066719,
                37.9316011
              ],
              [
                55.1062371,
                37.9315482
              ],
              [
                55.1056418,
                37.9316435
              ],
              [
                55.1049127,
                37.931829
              ],
              [
                55.104197,
                37.9318872
              ],
              [
                55.103615,
                37.9318766
              ],
              [
                55.1033935,
                37.9317797
              ],
              [
                55.1033675,
                37.9315217
              ],
              [
                55.1034344,
                37.9312832
              ],
              [
                55.1036618,
                37.9309283
              ],
              [
                55.1040097,
                37.9304461
              ],
              [
                55.1041501,
                37.9300487
              ],
              [
                55.1039377,
                37.9298842
              ],
              [
                55.1033541,
                37.9298368
              ],
              [
                55.1027521,
                37.9299216
              ],
              [
                55.1019963,
                37.9298474
              ],
              [
                55.1013942,
                37.9297256
              ],
              [
                55.1012689,
                37.9296234
              ],
              [
                55.1013407,
                37.9294235
              ],
              [
                55.1015213,
                37.9292328
              ],
              [
                55.1018825,
                37.9289202
              ],
              [
                55.1020698,
                37.9286447
              ],
              [
                55.1024244,
                37.9283215
              ],
              [
                55.1028658,
                37.9282314
              ],
              [
                55.1032471,
                37.9282155
              ],
              [
                55.1033635,
                37.928143
              ],
              [
                55.1034143,
                37.9280301
              ],
              [
                55.1034277,
                37.9278344
              ],
              [
                55.1033943,
                37.9276539
              ],
              [
                55.1030392,
                37.9271673
              ],
              [
                55.1025629,
                37.9269426
              ],
              [
                55.1020498,
                37.9267902
              ],
              [
                55.1015013,
                37.926729
              ],
              [
                55.101013,
                37.926716
              ],
              [
                55.1001454,
                37.9267634
              ],
              [
                55.099502,
                37.9268782
              ],
              [
                55.0990868,
                37.9268985
              ],
              [
                55.09874,
                37.9266849
              ],
              [
                55.098496,
                37.9261457
              ],
              [
                55.0982648,
                37.9255319
              ],
              [
                55.0979455,
                37.9248784
              ],
              [
                55.0976355,
                37.9245281
              ],
              [
                55.0971132,
                37.9245112
              ],
              [
                55.0962828,
                37.9247021
              ],
              [
                55.095525,
                37.9247926
              ],
              [
                55.0952938,
                37.9246434
              ],
              [
                55.0952039,
                37.9244162
              ],
              [
                55.0952638,
                37.9239889
              ],
              [
                55.0953281,
                37.9235888
              ],
              [
                55.0951654,
                37.9230631
              ],
              [
                55.0950327,
                37.9227613
              ],
              [
                55.0949342,
                37.922273
              ],
              [
                55.0949,
                37.9217507
              ],
              [
                55.0948058,
                37.9215099
              ],
              [
                55.0945232,
                37.9213777
              ],
              [
                55.0941377,
                37.9213574
              ],
              [
                55.0933759,
                37.9215065
              ],
              [
                55.092417,
                37.9216557
              ],
              [
                55.091244,
                37.9217541
              ],
              [
                55.0909315,
                37.9217507
              ],
              [
                55.0907408,
                37.9216588
              ],
              [
                55.0907046,
                37.9215065
              ],
              [
                55.090863,
                37.9212352
              ],
              [
                55.0911241,
                37.9207096
              ],
              [
                55.0914832,
                37.9202644
              ],
              [
                55.0920017,
                37.9201669
              ],
              [
                55.0925668,
                37.92015
              ],
              [
                55.0931447,
                37.9200822
              ],
              [
                55.0934701,
                37.9198448
              ],
              [
                55.0935429,
                37.9193632
              ],
              [
                55.0934755,
                37.9187672
              ],
              [
                55.0931704,
                37.9183898
              ],
              [
                55.0927006,
                37.9180974
              ],
              [
                55.0918904,
                37.9178133
              ],
              [
                55.0912144,
                37.9176878
              ],
              [
                55.0902178,
                37.9175189
              ],
              [
                55.0896534,
                37.9170801
              ],
              [
                55.0893503,
                37.9166247
              ],
              [
                55.0888904,
                37.9161776
              ],
              [
                55.0886695,
                37.9158054
              ],
              [
                55.0886919,
                37.9152336
              ],
              [
                55.0890368,
                37.9151674
              ],
              [
                55.0895489,
                37.9153661
              ],
              [
                55.0898729,
                37.9153247
              ],
              [
                55.0899983,
                37.9151177
              ],
              [
                55.0898311,
                37.9146954
              ],
              [
                55.089319,
                37.9143311
              ],
              [
                55.088023,
                37.9143807
              ],
              [
                55.0865842,
                37.9147113
              ],
              [
                55.0856086,
                37.9153827
              ],
              [
                55.0851592,
                37.9159706
              ],
              [
                55.0845321,
                37.9162438
              ],
              [
                55.0841182,
                37.9162312
              ],
              [
                55.0838841,
                37.9160699
              ],
              [
                55.0838527,
                37.9156393
              ],
              [
                55.0830584,
                37.9147451
              ],
              [
                55.0822508,
                37.9138939
              ],
              [
                55.081752,
                37.9138342
              ],
              [
                55.0813025,
                37.9140909
              ],
              [
                55.0811353,
                37.9146291
              ],
              [
                55.0806754,
                37.9149438
              ],
              [
                55.0800692,
                37.9148527
              ],
              [
                55.0795609,
                37.9144156
              ],
              [
                55.0793167,
                37.9140081
              ],
              [
                55.0794317,
                37.9135527
              ],
              [
                55.0797243,
                37.9131635
              ],
              [
                55.0799856,
                37.9124514
              ],
              [
                55.0798602,
                37.9118635
              ],
              [
                55.0796825,
                37.9110933
              ],
              [
                55.0796595,
                37.9104822
              ],
              [
                55.0798811,
                37.910406
              ],
              [
                55.0802469,
                37.9106048
              ],
              [
                55.0806754,
                37.9105965
              ],
              [
                55.0807486,
                37.9103398
              ],
              [
                55.0805849,
                37.9098966
              ],
              [
                55.0804873,
                37.9092716
              ],
              [
                55.0807591,
                37.9083772
              ],
              [
                55.0809263,
                37.9073752
              ],
              [
                55.0810238,
                37.906975
              ],
              [
                55.0808636,
                37.9066382
              ],
              [
                55.0805291,
                37.9065802
              ],
              [
                55.0801111,
                37.9063732
              ],
              [
                55.0795236,
                37.9060044
              ],
              [
                55.0787523,
                37.9058018
              ],
              [
                55.0779789,
                37.9058349
              ],
              [
                55.0776445,
                37.9056527
              ],
              [
                55.0773695,
                37.9052336
              ],
              [
                55.0771741,
                37.9046424
              ],
              [
                55.077392,
                37.9035054
              ],
              [
                55.0772891,
                37.9031185
              ],
              [
                55.0770383,
                37.9029778
              ],
              [
                55.0766801,
                37.9030772
              ],
              [
                55.0763485,
                37.9031517
              ],
              [
                55.076162,
                37.9030301
              ],
              [
                55.0760663,
                37.9028452
              ],
              [
                55.0759814,
                37.902235
              ],
              [
                55.0757071,
                37.9017633
              ],
              [
                55.0752634,
                37.9014163
              ],
              [
                55.0748496,
                37.901423
              ],
              [
                55.0746891,
                37.9016054
              ],
              [
                55.0745767,
                37.9022456
              ],
              [
                55.0746325,
                37.9029707
              ],
              [
                55.0740897,
                37.903187
              ],
              [
                55.0733459,
                37.9033481
              ],
              [
                55.0727626,
                37.9033015
              ],
              [
                55.0723506,
                37.903081
              ],
              [
                55.0723773,
                37.9029283
              ],
              [
                55.0724897,
                37.9027884
              ],
              [
                55.0730229,
                37.9027926
              ],
              [
                55.0732068,
                37.9027163
              ],
              [
                55.0733673,
                37.902428
              ],
              [
                55.0731907,
                37.9020082
              ],
              [
                55.0728001,
                37.9016562
              ],
              [
                55.072388,
                37.9017877
              ],
              [
                55.0720241,
                37.9018301
              ],
              [
                55.0714583,
                37.9012913
              ],
              [
                55.0708312,
                37.9009468
              ],
              [
                55.0701642,
                37.900808
              ],
              [
                55.0694264,
                37.9003571
              ],
              [
                55.0689488,
                37.9001999
              ],
              [
                55.0685318,
                37.9002842
              ],
              [
                55.0682809,
                37.9004101
              ],
              [
                55.0678545,
                37.9004565
              ],
              [
                55.0669515,
                37.900324
              ],
              [
                55.0659481,
                37.9000788
              ],
              [
                55.0653628,
                37.8999728
              ],
              [
                55.0647525,
                37.9000258
              ],
              [
                55.063816,
                37.9000855
              ],
              [
                55.062729,
                37.8999397
              ],
              [
                55.0620263,
                37.899717
              ],
              [
                55.0617089,
                37.8994892
              ],
              [
                55.0619347,
                37.8991446
              ],
              [
                55.0623214,
                37.89898
              ],
              [
                55.0626454,
                37.8986079
              ],
              [
                55.0629297,
                37.8982965
              ],
              [
                55.0630969,
                37.8979454
              ],
              [
                55.06307,
                37.8976409
              ],
              [
                55.0622942,
                37.8976008
              ],
              [
                55.0615668,
                37.8974948
              ],
              [
                55.0610484,
                37.8973358
              ],
              [
                55.060626,
                37.8968694
              ],
              [
                55.0600618,
                37.8963684
              ],
              [
                55.0599865,
                37.8960437
              ],
              [
                55.059744,
                37.8957058
              ],
              [
                55.0595099,
                37.8953745
              ],
              [
                55.0594096,
                37.8950498
              ],
              [
                55.0591813,
                37.8948176
              ],
              [
                55.0583393,
                37.8947848
              ],
              [
                55.0579213,
                37.8948974
              ],
              [
                55.0575985,
                37.8948839
              ],
              [
                55.0572858,
                37.8946788
              ],
              [
                55.0569513,
                37.8941421
              ],
              [
                55.0567639,
                37.893614
              ],
              [
                55.0571219,
                37.8925589
              ],
              [
                55.0570926,
                37.8920747
              ],
              [
                55.0568773,
                37.8918242
              ],
              [
                55.0565829,
                37.8915824
              ],
              [
                55.0565937,
                37.8913831
              ],
              [
                55.0568291,
                37.8908021
              ],
              [
                55.0569896,
                37.8902041
              ],
              [
                55.0574659,
                37.8897292
              ],
              [
                55.0574713,
                37.8893517
              ],
              [
                55.0570378,
                37.8890676
              ],
              [
                55.0565669,
                37.8889827
              ],
              [
                55.0555769,
                37.888864
              ],
              [
                55.0545816,
                37.8889318
              ],
              [
                55.0543568,
                37.8889191
              ],
              [
                55.054213,
                37.888798
              ],
              [
                55.0542552,
                37.8886095
              ],
              [
                55.0543836,
                37.8883339
              ],
              [
                55.0542766,
                37.8879903
              ],
              [
                55.0539341,
                37.8877401
              ],
              [
                55.0537147,
                37.8874135
              ],
              [
                55.0536665,
                37.8869767
              ],
              [
                55.0537735,
                37.8868961
              ],
              [
                55.0539394,
                37.8868367
              ],
              [
                55.0543675,
                37.8870742
              ],
              [
                55.0547363,
                37.8872531
              ],
              [
                55.0554699,
                37.8869682
              ],
              [
                55.0565722,
                37.8864211
              ],
              [
                55.0567007,
                37.8863108
              ],
              [
                55.0567151,
                37.8861304
              ],
              [
                55.05631,
                37.8858401
              ],
              [
                55.0555769,
                37.8855686
              ],
              [
                55.0548482,
                37.8853264
              ],
              [
                55.0542016,
                37.8850809
              ],
              [
                55.0534601,
                37.8842933
              ],
              [
                55.0531344,
                37.8838642
              ],
              [
                55.0527996,
                37.8838
              ],
              [
                55.0523555,
                37.8840333
              ],
              [
                55.05212,
                37.8844659
              ],
              [
                55.0518524,
                37.884555
              ],
              [
                55.0514886,
                37.8844108
              ],
              [
                55.0511621,
                37.8842199
              ],
              [
                55.0510872,
                37.8838764
              ],
              [
                55.0512531,
                37.883554
              ],
              [
                55.051617,
                37.883414
              ],
              [
                55.0518953,
                37.8832189
              ],
              [
                55.0519086,
                37.8828788
              ],
              [
                55.0513548,
                37.882587
              ],
              [
                55.0506484,
                37.8823749
              ],
              [
                55.0500544,
                37.881955
              ],
              [
                55.049423,
                37.8817514
              ],
              [
                55.0489574,
                37.8817048
              ],
              [
                55.0483708,
                37.8816703
              ],
              [
                55.04715,
                37.8810871
              ],
              [
                55.046155,
                37.8808154
              ],
              [
                55.0449556,
                37.8806322
              ],
              [
                55.0444744,
                37.8807226
              ],
              [
                55.0442821,
                37.8809943
              ],
              [
                55.0439058,
                37.8813124
              ],
              [
                55.0435163,
                37.8814827
              ],
              [
                55.0433874,
                37.8813787
              ],
              [
                55.0432787,
                37.8810208
              ],
              [
                55.0429108,
                37.8806298
              ],
              [
                55.0421918,
                37.8803846
              ],
              [
                55.0414811,
                37.8800267
              ],
              [
                55.0410295,
                37.8796158
              ],
              [
                55.0406115,
                37.8789729
              ],
              [
                55.0398673,
                37.8781445
              ],
              [
                55.0391993,
                37.877644
              ],
              [
                55.0387469,
                37.87721
              ],
              [
                55.0384961,
                37.8769648
              ],
              [
                55.0383874,
                37.8766268
              ],
              [
                55.038588,
                37.8762291
              ],
              [
                55.0386884,
                37.8759706
              ],
              [
                55.0385964,
                37.875679
              ],
              [
                55.0382369,
                37.875447
              ],
              [
                55.0380027,
                37.8750891
              ],
              [
                55.0378606,
                37.8747246
              ],
              [
                55.0376766,
                37.8738961
              ],
              [
                55.0377827,
                37.873565
              ],
              [
                55.0379693,
                37.8734852
              ],
              [
                55.0387803,
                37.8736045
              ],
              [
                55.039675,
                37.8736509
              ],
              [
                55.040461,
                37.8736045
              ],
              [
                55.040634,
                37.8734641
              ],
              [
                55.0404944,
                37.8731471
              ],
              [
                55.040068,
                37.8728422
              ],
              [
                55.0391733,
                37.8727296
              ],
              [
                55.0385379,
                37.8722921
              ],
              [
                55.0378857,
                37.8721264
              ],
              [
                55.0372001,
                37.8718281
              ],
              [
                55.0368907,
                37.8716691
              ],
              [
                55.036586,
                37.8715898
              ],
              [
                55.0362134,
                37.8718878
              ],
              [
                55.0360462,
                37.8723915
              ],
              [
                55.0359542,
                37.8728422
              ],
              [
                55.0357117,
                37.8730875
              ],
              [
                55.035367,
                37.8731064
              ],
              [
                55.0351181,
                37.8730079
              ],
              [
                55.0348923,
                37.8726434
              ],
              [
                55.0344659,
                37.8720203
              ],
              [
                55.0339931,
                37.8716792
              ],
              [
                55.0335115,
                37.8712974
              ],
              [
                55.0330084,
                37.8709623
              ],
              [
                55.0325964,
                37.8708265
              ],
              [
                55.0322539,
                37.8706356
              ],
              [
                55.0321132,
                37.8704094
              ],
              [
                55.0322272,
                37.870186
              ],
              [
                55.0324305,
                37.8700205
              ],
              [
                55.032789,
                37.8699993
              ],
              [
                55.0331636,
                37.8701436
              ],
              [
                55.0335436,
                37.8704363
              ],
              [
                55.0339021,
                37.870555
              ],
              [
                55.0341429,
                37.8705508
              ],
              [
                55.0345603,
                37.870415
              ],
              [
                55.0348974,
                37.8702157
              ],
              [
                55.0352934,
                37.8701139
              ],
              [
                55.0355736,
                37.8699812
              ],
              [
                55.0357269,
                37.8696981
              ],
              [
                55.035775,
                37.8692612
              ],
              [
                55.0355824,
                37.8688242
              ],
              [
                55.0354326,
                37.8685485
              ],
              [
                55.0355342,
                37.8681752
              ],
              [
                55.0358585,
                37.8676857
              ],
              [
                55.0362727,
                37.8672885
              ],
              [
                55.0366045,
                37.8672419
              ],
              [
                55.0370486,
                37.867314
              ],
              [
                55.0374232,
                37.8671867
              ],
              [
                55.0376105,
                37.8668134
              ],
              [
                55.0376105,
                37.8664274
              ],
              [
                55.0375409,
                37.8660328
              ],
              [
                55.0376694,
                37.8658546
              ],
              [
                55.0380505,
                37.8656556
              ],
              [
                55.0385844,
                37.8654092
              ],
              [
                55.0392212,
                37.8648577
              ],
              [
                55.0395316,
                37.8642383
              ],
              [
                55.039635,
                37.8635269
              ],
              [
                55.0393711,
                37.8626176
              ],
              [
                55.0394085,
                37.8620746
              ],
              [
                55.0394139,
                37.861243
              ],
              [
                55.0392551,
                37.8606766
              ],
              [
                55.0389965,
                37.8603775
              ],
              [
                55.038547,
                37.8602715
              ],
              [
                55.0379744,
                37.8602927
              ],
              [
                55.0374714,
                37.8604072
              ],
              [
                55.037161,
                37.8604327
              ],
              [
                55.0368679,
                37.8603289
              ],
              [
                55.0361229,
                37.8598684
              ],
              [
                55.0358071,
                37.8597878
              ],
              [
                55.0356252,
                37.8596775
              ],
              [
                55.035577,
                37.8595587
              ],
              [
                55.0356627,
                37.8593762
              ],
              [
                55.0358125,
                37.8589859
              ],
              [
                55.0357643,
                37.8585531
              ],
              [
                55.0351277,
                37.8583993
              ],
              [
                55.033763,
                37.8583792
              ],
              [
                55.033383,
                37.8585065
              ],
              [
                55.0326767,
                37.8587356
              ],
              [
                55.0318407,
                37.8587038
              ],
              [
                55.0310285,
                37.8585404
              ],
              [
                55.0306111,
                37.8583113
              ],
              [
                55.0305736,
                37.8580143
              ],
              [
                55.0306111,
                37.8576706
              ],
              [
                55.0305036,
                37.8572332
              ],
              [
                55.0304719,
                37.8570172
              ],
              [
                55.0306539,
                37.8568093
              ],
              [
                55.0312104,
                37.856436
              ],
              [
                55.0324248,
                37.8559158
              ],
              [
                55.0328051,
                37.8557698
              ],
              [
                55.0330673,
                37.8555661
              ],
              [
                55.0330566,
                37.8552522
              ],
              [
                55.0327088,
                37.8549382
              ],
              [
                55.032163,
                37.8545948
              ],
              [
                55.0310017,
                37.8540811
              ],
              [
                55.0298191,
                37.8536228
              ],
              [
                55.0292198,
                37.8534149
              ],
              [
                55.0288452,
                37.853084
              ],
              [
                55.0285318,
                37.8528966
              ],
              [
                55.0282191,
                37.852927
              ],
              [
                55.0274806,
                37.8532579
              ],
              [
                55.0271453,
                37.8532903
              ],
              [
                55.0270632,
                37.8531264
              ],
              [
                55.0270846,
                37.8528464
              ],
              [
                55.0272237,
                37.8525239
              ],
              [
                55.0274699,
                37.8521505
              ],
              [
                55.0275448,
                37.851828
              ],
              [
                55.0274592,
                37.8515564
              ],
              [
                55.0272237,
                37.8514164
              ],
              [
                55.0268893,
                37.8513031
              ],
              [
                55.0263836,
                37.8512424
              ],
              [
                55.0258164,
                37.8513485
              ],
              [
                55.025019,
                37.8512976
              ],
              [
                55.0237182,
                37.8512961
              ],
              [
                55.0227768,
                37.8511958
              ],
              [
                55.0221775,
                37.8510345
              ],
              [
                55.0216638,
                37.8507672
              ],
              [
                55.0215245,
                37.8504903
              ],
              [
                55.0216959,
                37.8503132
              ],
              [
                55.0220598,
                37.8503259
              ],
              [
                55.0223969,
                37.8504405
              ],
              [
                55.0226859,
                37.8503938
              ],
              [
                55.0227875,
                37.8502198
              ],
              [
                55.0226591,
                37.849927
              ],
              [
                55.0222524,
                37.8495876
              ],
              [
                55.0220812,
                37.8491462
              ],
              [
                55.0217922,
                37.8490147
              ],
              [
                55.0212838,
                37.8490868
              ],
              [
                55.0207113,
                37.8490232
              ],
              [
                55.0201012,
                37.8488789
              ],
              [
                55.0197373,
                37.8485819
              ],
              [
                55.0198016,
                37.8482976
              ],
              [
                55.0201547,
                37.848043
              ],
              [
                55.0209146,
                37.8477205
              ],
              [
                55.021225,
                37.8474913
              ],
              [
                55.0212143,
                37.8472919
              ],
              [
                55.0204047,
                37.8464907
              ],
              [
                55.0189454,
                37.8453823
              ],
              [
                55.018528,
                37.8449579
              ],
              [
                55.0184851,
                37.8447415
              ],
              [
                55.0188276,
                37.8445888
              ],
              [
                55.0192878,
                37.8446524
              ],
              [
                55.0196848,
                37.8445895
              ],
              [
                55.0201333,
                37.8443469
              ],
              [
                55.0207594,
                37.8440413
              ],
              [
                55.021439,
                37.8439395
              ],
              [
                55.0220758,
                37.8437697
              ],
              [
                55.0231012,
                37.8433946
              ],
              [
                55.0232906,
                37.8432138
              ],
              [
                55.0233227,
                37.8429634
              ],
              [
                55.0229481,
                37.842904
              ],
              [
                55.0223828,
                37.8428993
              ],
              [
                55.0217922,
                37.8429847
              ],
              [
                55.0213053,
                37.8428658
              ],
              [
                55.0210484,
                37.8430441
              ],
              [
                55.0206925,
                37.84334
              ],
              [
                55.0204223,
                37.8435236
              ],
              [
                55.0201494,
                37.8434048
              ],
              [
                55.019946,
                37.8431162
              ],
              [
                55.0198658,
                37.8426112
              ],
              [
                55.0197656,
                37.8422427
              ],
              [
                55.0193895,
                37.8421444
              ],
              [
                55.0187688,
                37.8421741
              ],
              [
                55.017736,
                37.8424372
              ],
              [
                55.0170243,
                37.8426452
              ],
              [
                55.0165463,
                37.8427638
              ],
              [
                55.0160343,
                37.8427979
              ],
              [
                55.0153012,
                37.8427852
              ],
              [
                55.0147286,
                37.8429931
              ],
              [
                55.0141346,
                37.8433241
              ],
              [
                55.0136637,
                37.8434048
              ],
              [
                55.0129627,
                37.8433878
              ],
              [
                55.01241,
                37.8433425
              ],
              [
                55.0120855,
                37.8429135
              ],
              [
                55.0118282,
                37.8425815
              ],
              [
                55.0111014,
                37.8422814
              ],
              [
                55.0106456,
                37.8422123
              ],
              [
                55.0100944,
                37.8422165
              ],
              [
                55.0093366,
                37.8423571
              ],
              [
                55.0090402,
                37.8423778
              ],
              [
                55.0087566,
                37.8422759
              ],
              [
                55.0085532,
                37.8420638
              ],
              [
                55.0085907,
                37.8417625
              ],
              [
                55.0085158,
                37.8413084
              ],
              [
                55.0081893,
                37.8406251
              ],
              [
                55.0077462,
                37.8400716
              ],
              [
                55.0074627,
                37.840041
              ],
              [
                55.0072537,
                37.8400617
              ],
              [
                55.0063913,
                37.8403145
              ],
              [
                55.0049683,
                37.8406016
              ],
              [
                55.0041167,
                37.8409275
              ],
              [
                55.0037547,
                37.8409138
              ],
              [
                55.0035222,
                37.8407882
              ],
              [
                55.0032544,
                37.8402516
              ],
              [
                55.0025097,
                37.839648
              ],
              [
                55.0023333,
                37.8394158
              ],
              [
                55.0023463,
                37.8388638
              ],
              [
                55.0021827,
                37.8380206
              ],
              [
                55.0019244,
                37.8374687
              ],
              [
                55.0014867,
                37.837252
              ],
              [
                55.0007158,
                37.8370817
              ],
              [
                54.9997359,
                37.8370972
              ],
              [
                54.9986645,
                37.8371282
              ],
              [
                54.9984097,
                37.8370043
              ],
              [
                54.99834,
                37.8368061
              ],
              [
                54.9984685,
                37.8365451
              ],
              [
                54.9988083,
                37.8362304
              ],
              [
                54.9988474,
                37.8359105
              ],
              [
                54.9986057,
                37.8355597
              ],
              [
                54.9982203,
                37.8354049
              ],
              [
                54.9974494,
                37.8354359
              ],
              [
                54.9970019,
                37.8353374
              ],
              [
                54.9967635,
                37.8348219
              ],
              [
                54.9962287,
                37.8345057
              ],
              [
                54.9956268,
                37.8341563
              ],
              [
                54.9953426,
                37.8339803
              ],
              [
                54.9953472,
                37.8337687
              ],
              [
                54.995735,
                37.8335678
              ],
              [
                54.9959077,
                37.8334495
              ],
              [
                54.9961235,
                37.833117
              ],
              [
                54.9959207,
                37.8326703
              ],
              [
                54.9960122,
                37.8322782
              ],
              [
                54.9961951,
                37.8321079
              ],
              [
                54.9968353,
                37.8319222
              ],
              [
                54.9978828,
                37.8314341
              ],
              [
                54.9986341,
                37.831011
              ],
              [
                54.99932,
                37.8304795
              ],
              [
                54.9997904,
                37.8297984
              ],
              [
                55.0000844,
                37.829009
              ],
              [
                54.9999341,
                37.8280595
              ],
              [
                54.9995683,
                37.8275384
              ],
              [
                54.9990587,
                37.8270636
              ],
              [
                54.9982291,
                37.8266766
              ],
              [
                54.9975562,
                37.8265476
              ],
              [
                54.996831,
                37.8266973
              ],
              [
                54.9961712,
                37.8270894
              ],
              [
                54.996217,
                37.8273836
              ],
              [
                54.9967722,
                37.8275435
              ],
              [
                54.9973406,
                37.8277138
              ],
              [
                54.997824,
                37.8281421
              ],
              [
                54.9980788,
                37.8285342
              ],
              [
                54.9978436,
                37.8290244
              ],
              [
                54.9978044,
                37.8296127
              ],
              [
                54.997615,
                37.8297675
              ],
              [
                54.9971838,
                37.8296127
              ],
              [
                54.99672,
                37.8295972
              ],
              [
                54.9962823,
                37.8295817
              ],
              [
                54.9959752,
                37.8291534
              ],
              [
                54.9955791,
                37.8291445
              ],
              [
                54.9942898,
                37.8294372
              ],
              [
                54.9935712,
                37.8294682
              ],
              [
                54.993674,
                37.8290206
              ],
              [
                54.9940601,
                37.8284488
              ],
              [
                54.9941084,
                37.8280447
              ],
              [
                54.993954,
                37.8275491
              ],
              [
                54.9937609,
                37.8273661
              ],
              [
                54.9934134,
                37.8272212
              ],
              [
                54.9929018,
                37.8272441
              ],
              [
                54.9922164,
                37.8276177
              ],
              [
                54.9916403,
                37.8277736
              ],
              [
                54.9887575,
                37.8278566
              ],
              [
                54.9874478,
                37.8276253
              ],
              [
                54.9863377,
                37.8273661
              ],
              [
                54.9862605,
                37.8270306
              ],
              [
                54.9867142,
                37.8267027
              ],
              [
                54.9866852,
                37.8259631
              ],
              [
                54.9862036,
                37.8252393
              ],
              [
                54.9831242,
                37.8227038
              ],
              [
                54.9809667,
                37.8215907
              ],
              [
                54.980343,
                37.8212577
              ],
              [
                54.980302,
                37.8211606
              ],
              [
                54.9803225,
                37.8210528
              ],
              [
                54.9807594,
                37.8209665
              ],
              [
                54.981087,
                37.8208479
              ],
              [
                54.9812508,
                37.8206969
              ],
              [
                54.9811553,
                37.8204112
              ],
              [
                54.9810051,
                37.820244
              ],
              [
                54.9806775,
                37.8201092
              ],
              [
                54.9803839,
                37.8200769
              ],
              [
                54.9792167,
                37.8204651
              ],
              [
                54.9790256,
                37.8206592
              ],
              [
                54.9789369,
                37.8213763
              ],
              [
                54.9787932,
                37.821537
              ],
              [
                54.9781384,
                37.8214764
              ],
              [
                54.976507,
                37.821667
              ],
              [
                54.9763236,
                37.8216517
              ],
              [
                54.9761595,
                37.8214535
              ],
              [
                54.975832,
                37.8208411
              ],
              [
                54.9747791,
                37.8201038
              ],
              [
                54.9741227,
                37.819448
              ],
              [
                54.973698,
                37.8189295
              ],
              [
                54.9737366,
                37.8186016
              ],
              [
                54.9740938,
                37.8185559
              ],
              [
                54.9746826,
                37.8186474
              ],
              [
                54.9752811,
                37.8182966
              ],
              [
                54.9757813,
                37.8180578
              ],
              [
                54.9758217,
                37.8178238
              ],
              [
                54.9755224,
                37.817473
              ],
              [
                54.9749625,
                37.8171299
              ],
              [
                54.9741034,
                37.8166952
              ],
              [
                54.972974,
                37.8164817
              ],
              [
                54.9725879,
                37.8166113
              ],
              [
                54.9720792,
                37.8167805
              ],
              [
                54.9695114,
                37.8162847
              ],
              [
                54.966279,
                37.8164577
              ],
              [
                54.9659076,
                37.8163594
              ],
              [
                54.9651429,
                37.8154672
              ],
              [
                54.9651312,
                37.8150264
              ],
              [
                54.9619456,
                37.813076
              ],
              [
                54.9579635,
                37.8118177
              ],
              [
                54.9559725,
                37.8098672
              ],
              [
                54.9550965,
                37.8069728
              ],
              [
                54.9560521,
                37.8050851
              ],
              [
                54.9581228,
                37.8057773
              ],
              [
                54.9591581,
                37.8050222
              ],
              [
                54.9582821,
                37.8032603
              ],
              [
                54.9551761,
                37.8032603
              ],
              [
                54.9539815,
                37.8009949
              ],
              [
                54.9546186,
                37.7993588
              ],
              [
                54.952309,
                37.7979743
              ],
              [
                54.950314,
                37.7971132
              ],
              [
                54.9500697,
                37.7969698
              ],
              [
                54.9498279,
                37.7968182
              ],
              [
                54.9495352,
                37.7966941
              ],
              [
                54.9493213,
                37.7966516
              ],
              [
                54.9489539,
                37.7965894
              ],
              [
                54.948547,
                37.7965012
              ],
              [
                54.9481245,
                37.7964711
              ],
              [
                54.9477741,
                37.7964878
              ],
              [
                54.947459,
                37.7964889
              ],
              [
                54.9472117,
                37.796442
              ],
              [
                54.9469121,
                37.7963516
              ],
              [
                54.9466493,
                37.7962623
              ],
              [
                54.9465108,
                37.7962489
              ],
              [
                54.9463257,
                37.7962545
              ],
              [
                54.9461208,
                37.7961997
              ],
              [
                54.9459244,
                37.7960993
              ],
              [
                54.9458001,
                37.7959753
              ],
              [
                54.9457393,
                37.7958637
              ],
              [
                54.9456277,
                37.7957185
              ],
              [
                54.9455783,
                37.795608
              ],
              [
                54.9455571,
                37.795503
              ],
              [
                54.945574,
                37.7953701
              ],
              [
                54.9455641,
                37.7952205
              ],
              [
                54.9454906,
                37.7950798
              ],
              [
                54.9453847,
                37.7949358
              ],
              [
                54.9451628,
                37.7947817
              ],
              [
                54.9449904,
                37.7946332
              ],
              [
                54.9448562,
                37.794459
              ],
              [
                54.9447474,
                37.7942759
              ],
              [
                54.9446556,
                37.7940615
              ],
              [
                54.9445906,
                37.7939231
              ],
              [
                54.9444902,
                37.7938281
              ],
              [
                54.9443645,
                37.7937734
              ],
              [
                54.9442274,
                37.7937533
              ],
              [
                54.9440677,
                37.7937556
              ],
              [
                54.943918,
                37.793779
              ],
              [
                54.9437357,
                37.7938382
              ],
              [
                54.9435548,
                37.7939365
              ],
              [
                54.9432524,
                37.7941252
              ],
              [
                54.9430645,
                37.794277
              ],
              [
                54.9428441,
                37.7944769
              ],
              [
                54.9426971,
                37.794583
              ],
              [
                54.9425883,
                37.7946276
              ],
              [
                54.9423947,
                37.7946689
              ],
              [
                54.9422266,
                37.7946656
              ],
              [
                54.9419511,
                37.7945975
              ],
              [
                54.9416444,
                37.7945573
              ],
              [
                54.9414353,
                37.7945662
              ],
              [
                54.9411937,
                37.7946198
              ],
              [
                54.9409549,
                37.7946712
              ],
              [
                54.9408235,
                37.7946857
              ],
              [
                54.9407118,
                37.79467
              ],
              [
                54.9406016,
                37.7946254
              ],
              [
                54.9405493,
                37.7945696
              ],
              [
                54.9405282,
                37.7945137
              ],
              [
                54.940531,
                37.7944378
              ],
              [
                54.9405621,
                37.7943596
              ],
              [
                54.9406596,
                37.7942335
              ],
              [
                54.9408221,
                37.7940805
              ],
              [
                54.9410821,
                37.7938527
              ],
              [
                54.9412445,
                37.7936808
              ],
              [
                54.9413576,
                37.7935222
              ],
              [
                54.9413816,
                37.793434
              ],
              [
                54.9413576,
                37.7933391
              ],
              [
                54.9412926,
                37.7932609
              ],
              [
                54.9411442,
                37.7931794
              ],
              [
                54.9409563,
                37.7930867
              ],
              [
                54.9408291,
                37.7929806
              ],
              [
                54.9408037,
                37.7928869
              ],
              [
                54.9408023,
                37.7926189
              ],
              [
                54.9406746,
                37.7922217
              ],
              [
                54.9405474,
                37.7919481
              ],
              [
                54.9403878,
                37.7917884
              ],
              [
                54.9401673,
                37.7916377
              ],
              [
                54.9398946,
                37.7915048
              ],
              [
                54.9396332,
                37.7914143
              ],
              [
                54.9392305,
                37.7912859
              ],
              [
                54.9388857,
                37.7911653
              ],
              [
                54.9385947,
                37.7910481
              ],
              [
                54.9381708,
                37.7908147
              ],
              [
                54.9380031,
                37.7906882
              ],
              [
                54.9379302,
                37.7905832
              ],
              [
                54.9379112,
                37.7905145
              ],
              [
                54.9379142,
                37.7904395
              ],
              [
                54.9379662,
                37.7904024
              ],
              [
                54.9380881,
                37.7903771
              ],
              [
                54.9383179,
                37.7903605
              ],
              [
                54.9385487,
                37.7903882
              ],
              [
                54.9389112,
                37.7904507
              ],
              [
                54.9392447,
                37.7904607
              ],
              [
                54.9396969,
                37.7904697
              ],
              [
                54.9402183,
                37.7905266
              ],
              [
                54.9408287,
                37.790597
              ],
              [
                54.9413034,
                37.7906461
              ],
              [
                54.9417923,
                37.7906483
              ],
              [
                54.9421089,
                37.7906115
              ],
              [
                54.9422134,
                37.7905367
              ],
              [
                54.9422756,
                37.7904429
              ],
              [
                54.9422714,
                37.7903044
              ],
              [
                54.942229,
                37.7901615
              ],
              [
                54.9420933,
                37.7899839
              ],
              [
                54.9418814,
                37.7897863
              ],
              [
                54.9416087,
                37.7895976
              ],
              [
                54.941432,
                37.7895071
              ],
              [
                54.941141,
                37.7894256
              ],
              [
                54.9409813,
                37.7893564
              ],
              [
                54.9406068,
                37.7892905
              ],
              [
                54.9402804,
                37.7892391
              ],
              [
                54.9400105,
                37.7891799
              ],
              [
                54.939646,
                37.7890806
              ],
              [
                54.9393521,
                37.7889868
              ],
              [
                54.9391359,
                37.788884
              ],
              [
                54.9389653,
                37.7887801
              ],
              [
                54.9388724,
                37.7887311
              ],
              [
                54.9387965,
                37.7887177
              ],
              [
                54.9386896,
                37.7887232
              ],
              [
                54.9385697,
                37.7887485
              ],
              [
                54.9383668,
                37.7888243
              ],
              [
                54.9380951,
                37.7889443
              ],
              [
                54.9379082,
                37.7890517
              ],
              [
                54.9377194,
                37.7891077
              ],
              [
                54.9373944,
                37.789177
              ],
              [
                54.9369352,
                37.7892585
              ],
              [
                54.9366497,
                37.7893411
              ],
              [
                54.9363954,
                37.789464
              ],
              [
                54.9361481,
                37.7896091
              ],
              [
                54.935987,
                37.7897409
              ],
              [
                54.9358132,
                37.789924
              ],
              [
                54.9357087,
                37.7901295
              ],
              [
                54.9356677,
                37.7902746
              ],
              [
                54.9356069,
                37.7904745
              ],
              [
                54.9355342,
                37.7906627
              ],
              [
                54.9354748,
                37.7907107
              ],
              [
                54.9354197,
                37.790728
              ],
              [
                54.9352495,
                37.7907319
              ],
              [
                54.9350986,
                37.790709
              ],
              [
                54.9348838,
                37.7906277
              ],
              [
                54.934621,
                37.7905329
              ],
              [
                54.9343402,
                37.79042
              ],
              [
                54.9342113,
                37.790364
              ],
              [
                54.9341764,
                37.7903158
              ],
              [
                54.9341664,
                37.7902589
              ],
              [
                54.9341794,
                37.7901958
              ],
              [
                54.9342463,
                37.790105
              ],
              [
                54.9343582,
                37.7900315
              ],
              [
                54.9344791,
                37.7898918
              ],
              [
                54.934553,
                37.7898499
              ],
              [
                54.9346604,
                37.7896926
              ],
              [
                54.934737,
                37.7895438
              ],
              [
                54.9347959,
                37.789374
              ],
              [
                54.9348868,
                37.7893045
              ],
              [
                54.9351047,
                37.7891798
              ],
              [
                54.9352046,
                37.7890558
              ],
              [
                54.9352504,
                37.7889497
              ],
              [
                54.9352544,
                37.7888431
              ],
              [
                54.9352044,
                37.7887515
              ],
              [
                54.9350925,
                37.7886773
              ],
              [
                54.9349337,
                37.7886212
              ],
              [
                54.934579,
                37.7885683
              ],
              [
                54.9342318,
                37.7885542
              ],
              [
                54.9339124,
                37.7885219
              ],
              [
                54.9335597,
                37.7884209
              ],
              [
                54.9333738,
                37.788334
              ],
              [
                54.9332679,
                37.7882377
              ],
              [
                54.933136,
                37.7880964
              ],
              [
                54.9329472,
                37.7878311
              ],
              [
                54.9327554,
                37.7875231
              ],
              [
                54.9325655,
                37.7873841
              ],
              [
                54.9323287,
                37.7872175
              ],
              [
                54.9321589,
                37.7870667
              ],
              [
                54.932054,
                37.786923
              ],
              [
                54.931957,
                37.786769
              ],
              [
                54.9318601,
                37.7865929
              ],
              [
                54.9318012,
                37.7863718
              ],
              [
                54.9317033,
                37.7861855
              ],
              [
                54.9316353,
                37.7859478
              ],
              [
                54.9315854,
                37.7856454
              ],
              [
                54.9315284,
                37.7854582
              ],
              [
                54.9315074,
                37.7853327
              ],
              [
                54.9315264,
                37.7851803
              ],
              [
                54.9315514,
                37.7850445
              ],
              [
                54.9315454,
                37.7848273
              ],
              [
                54.9315074,
                37.7846449
              ],
              [
                54.9314485,
                37.7845644
              ],
              [
                54.9313406,
                37.7845059
              ],
              [
                54.9312007,
                37.7844901
              ],
              [
                54.9310598,
                37.7845138
              ],
              [
                54.930804,
                37.7846086
              ],
              [
                54.9305752,
                37.7847073
              ],
              [
                54.9304094,
                37.7847405
              ],
              [
                54.9302295,
                37.7847468
              ],
              [
                54.9299867,
                37.7847499
              ],
              [
                54.9297429,
                37.7847807
              ],
              [
                54.9295401,
                37.7848321
              ],
              [
                54.9294032,
                37.7849047
              ],
              [
                54.9293143,
                37.7850018
              ],
              [
                54.9292533,
                37.785125
              ],
              [
                54.9291724,
                37.7852948
              ],
              [
                54.9290465,
                37.7854172
              ],
              [
                54.9288397,
                37.7855546
              ],
              [
                54.9287068,
                37.7855948
              ],
              [
                54.9285679,
                37.7856098
              ],
              [
                54.928471,
                37.7855925
              ],
              [
                54.9284219,
                37.7855448
              ],
              [
                54.9283821,
                37.785451
              ],
              [
                54.9283801,
                37.7853018
              ],
              [
                54.928431,
                37.7851628
              ],
              [
                54.928509,
                37.7850807
              ],
              [
                54.9285649,
                37.7849346
              ],
              [
                54.9285679,
                37.7848604
              ],
              [
                54.9285269,
                37.784704
              ],
              [
                54.9285399,
                37.784479
              ],
              [
                54.928501,
                37.7841758
              ],
              [
                54.928453,
                37.7840068
              ],
              [
                54.9283891,
                37.7839483
              ],
              [
                54.9282981,
                37.7839112
              ],
              [
                54.9282132,
                37.7839231
              ],
              [
                54.9280883,
                37.7839973
              ],
              [
                54.9279434,
                37.7840802
              ],
              [
                54.9277936,
                37.7841876
              ],
              [
                54.9274908,
                37.7843487
              ],
              [
                54.927341,
                37.7845082
              ],
              [
                54.927293,
                37.7846472
              ],
              [
                54.9272251,
                37.7847996
              ],
              [
                54.927241,
                37.7849093
              ],
              [
                54.927269,
                37.7850783
              ],
              [
                54.9272341,
                37.7853729
              ],
              [
                54.9271301,
                37.7857487
              ],
              [
                54.9270362,
                37.7859667
              ],
              [
                54.9268704,
                37.7862904
              ],
              [
                54.9266565,
                37.7866315
              ],
              [
                54.9265936,
                37.7867602
              ],
              [
                54.9265646,
                37.7869071
              ],
              [
                54.9265766,
                37.7871085
              ],
              [
                54.9265386,
                37.7872601
              ],
              [
                54.9264557,
                37.7873785
              ],
              [
                54.9263648,
                37.787448
              ],
              [
                54.9262589,
                37.7874756
              ],
              [
                54.926144,
                37.7874741
              ],
              [
                54.9260181,
                37.7874211
              ],
              [
                54.9257951,
                37.7873162
              ],
              [
                54.9256349,
                37.7872225
              ],
              [
                54.925421,
                37.7870314
              ],
              [
                54.9253061,
                37.7869682
              ],
              [
                54.9249325,
                37.7868648
              ],
              [
                54.9246797,
                37.7867779
              ],
              [
                54.9244828,
                37.7867574
              ],
              [
                54.924313,
                37.7867708
              ],
              [
                54.9240932,
                37.7868229
              ],
              [
                54.9237864,
                37.7868672
              ],
              [
                54.9234277,
                37.7868901
              ],
              [
                54.923077,
                37.7869706
              ],
              [
                54.9227193,
                37.787059
              ],
              [
                54.9225365,
                37.7870764
              ],
              [
                54.9224556,
                37.7870709
              ],
              [
                54.9223676,
                37.7870306
              ],
              [
                54.9221468,
                37.7869106
              ],
              [
                54.9217442,
                37.7867353
              ],
              [
                54.9215124,
                37.7866398
              ],
              [
                54.9213685,
                37.7866184
              ],
              [
                54.9212766,
                37.7865742
              ],
              [
                54.9211926,
                37.7865071
              ],
              [
                54.9209269,
                37.7864037
              ],
              [
                54.9205872,
                37.786271
              ],
              [
                54.9202594,
                37.7861281
              ],
              [
                54.9199217,
                37.7859401
              ],
              [
                54.9197239,
                37.7858399
              ],
              [
                54.9194911,
                37.7857459
              ],
              [
                54.9192323,
                37.7856203
              ],
              [
                54.9189406,
                37.7854324
              ],
              [
                54.9186658,
                37.7852761
              ],
              [
                54.9183061,
                37.7850873
              ],
              [
                54.9180603,
                37.7849918
              ],
              [
                54.9178075,
                37.7849239
              ],
              [
                54.9176097,
                37.7848994
              ],
              [
                54.9171611,
                37.7848773
              ],
              [
                54.9167514,
                37.7848623
              ],
              [
                54.9164657,
                37.7848228
              ],
              [
                54.9162359,
                37.7847833
              ],
              [
                54.9159711,
                37.7846957
              ],
              [
                54.9158642,
                37.784627
              ],
              [
                54.9158332,
                37.784578
              ],
              [
                54.9158192,
                37.7845093
              ],
              [
                54.9158322,
                37.7844335
              ],
              [
                54.9159091,
                37.7843553
              ],
              [
                54.916092,
                37.7842108
              ],
              [
                54.9162926,
                37.7840172
              ],
              [
                54.9163615,
                37.7838956
              ],
              [
                54.9164375,
                37.7836674
              ],
              [
                54.9164654,
                37.7834803
              ],
              [
                54.9164455,
                37.7832813
              ],
              [
                54.9163475,
                37.7831115
              ],
              [
                54.9162077,
                37.7829725
              ],
              [
                54.9160938,
                37.7829086
              ],
              [
                54.9159049,
                37.7828628
              ],
              [
                54.9155782,
                37.7828075
              ],
              [
                54.9152735,
                37.7827885
              ],
              [
                54.9149308,
                37.7827751
              ],
              [
                54.914629,
                37.7827704
              ],
              [
                54.9143862,
                37.7827798
              ],
              [
                54.9141874,
                37.7828209
              ],
              [
                54.9138657,
                37.7829267
              ],
              [
                54.9136239,
                37.7829694
              ],
              [
                54.9133031,
                37.7830444
              ],
              [
                54.9130354,
                37.7831075
              ],
              [
                54.9128026,
                37.7831241
              ],
              [
                54.9125648,
                37.7831162
              ],
              [
                54.91232,
                37.7830681
              ],
              [
                54.9121561,
                37.7830057
              ],
              [
                54.9120952,
                37.7829386
              ],
              [
                54.9120552,
                37.7828485
              ],
              [
                54.9120322,
                37.7826677
              ],
              [
                54.9119703,
                37.782415
              ],
              [
                54.9118893,
                37.7822587
              ],
              [
                54.9117675,
                37.7821426
              ],
              [
                54.9115157,
                37.7819854
              ],
              [
                54.9112269,
                37.7818757
              ],
              [
                54.9110111,
                37.7817383
              ],
              [
                54.9109551,
                37.7816648
              ],
              [
                54.9109511,
                37.7815708
              ],
              [
                54.9109691,
                37.7814785
              ],
              [
                54.911069,
                37.7813766
              ],
              [
                54.9112119,
                37.781281
              ],
              [
                54.9114427,
                37.7811665
              ],
              [
                54.9116376,
                37.7811128
              ],
              [
                54.9118024,
                37.7810978
              ],
              [
                54.9121251,
                37.7810228
              ],
              [
                54.9124828,
                37.7809288
              ],
              [
                54.9125558,
                37.7808941
              ],
              [
                54.9125848,
                37.7808601
              ],
              [
                54.9125808,
                37.7807472
              ],
              [
                54.9125318,
                37.7804527
              ],
              [
                54.9124069,
                37.7802229
              ],
              [
                54.912345,
                37.7799773
              ],
              [
                54.9121921,
                37.7797214
              ],
              [
                54.9120302,
                37.77949
              ],
              [
                54.9118604,
                37.7792318
              ],
              [
                54.9116286,
                37.7789191
              ],
              [
                54.9114287,
                37.7786569
              ],
              [
                54.9112119,
                37.7784294
              ],
              [
                54.9110341,
                37.7782154
              ],
              [
                54.9108542,
                37.7780385
              ],
              [
                54.9106884,
                37.7779311
              ],
              [
                54.9105485,
                37.7778885
              ],
              [
                54.9104166,
                37.7778853
              ],
              [
                54.9102378,
                37.7779169
              ],
              [
                54.9101448,
                37.7779777
              ],
              [
                54.909954,
                37.7781759
              ],
              [
                54.9096952,
                37.7784263
              ],
              [
                54.9096003,
                37.7785321
              ],
              [
                54.9095443,
                37.7786411
              ],
              [
                54.9094914,
                37.7788219
              ],
              [
                54.9094564,
                37.7791046
              ],
              [
                54.9094185,
                37.779291
              ],
              [
                54.9093555,
                37.779411
              ],
              [
                54.9092936,
                37.7794655
              ],
              [
                54.9092306,
                37.7794884
              ],
              [
                54.9091227,
                37.7794813
              ],
              [
                54.9089988,
                37.779445
              ],
              [
                54.908807,
                37.7793487
              ],
              [
                54.9086531,
                37.7793155
              ],
              [
                54.9084563,
                37.779325
              ],
              [
                54.9082864,
                37.7793771
              ],
              [
                54.9080766,
                37.7795003
              ],
              [
                54.9079187,
                37.7795619
              ],
              [
                54.9077888,
                37.7795816
              ],
              [
                54.907635,
                37.7795761
              ],
              [
                54.9075361,
                37.7795532
              ],
              [
                54.9074511,
                37.7794884
              ],
              [
                54.9074062,
                37.7794197
              ],
              [
                54.9073922,
                37.7793487
              ],
              [
                54.9073982,
                37.7792397
              ],
              [
                54.9074781,
                37.7789578
              ],
              [
                54.907594,
                37.7786616
              ],
              [
                54.9076789,
                37.7784247
              ],
              [
                54.9077059,
                37.778157
              ],
              [
                54.9076689,
                37.778003
              ],
              [
                54.907602,
                37.7779406
              ],
              [
                54.9074671,
                37.7778798
              ],
              [
                54.9073033,
                37.7778545
              ],
              [
                54.9071214,
                37.7778656
              ],
              [
                54.9069665,
                37.7779051
              ],
              [
                54.9067118,
                37.7780038
              ],
              [
                54.906472,
                37.7780701
              ],
              [
                54.9061582,
                37.7781214
              ],
              [
                54.9060114,
                37.7781214
              ],
              [
                54.9059234,
                37.7781017
              ],
              [
                54.9057776,
                37.7780227
              ],
              [
                54.9054788,
                37.7778506
              ],
              [
                54.905294,
                37.7777021
              ],
              [
                54.9051051,
                37.7775299
              ],
              [
                54.9048114,
                37.7772938
              ],
              [
                54.9046165,
                37.7771856
              ],
              [
                54.9044167,
                37.7771193
              ],
              [
                54.904092,
                37.7769882
              ],
              [
                54.9037793,
                37.7768547
              ],
              [
                54.9036064,
                37.7767473
              ],
              [
                54.9035085,
                37.7766494
              ],
              [
                54.9033866,
                37.7764678
              ],
              [
                54.9032477,
                37.7762545
              ],
              [
                54.9031278,
                37.7760587
              ],
              [
                54.902886,
                37.7757815
              ],
              [
                54.9027863,
                37.7756242
              ],
              [
                54.9027263,
                37.7754702
              ],
              [
                54.9026948,
                37.7752765
              ],
              [
                54.9026736,
                37.7750554
              ],
              [
                54.9026793,
                37.7747907
              ],
              [
                54.9026454,
                37.7746097
              ],
              [
                54.9024899,
                37.7743551
              ],
              [
                54.9022737,
                37.7740669
              ],
              [
                54.9020533,
                37.773867
              ],
              [
                54.9018357,
                37.7737296
              ],
              [
                54.9016435,
                37.773657
              ],
              [
                54.9013383,
                37.7736291
              ],
              [
                54.9010727,
                37.7735833
              ],
              [
                54.9006516,
                37.7735029
              ],
              [
                54.9003436,
                37.773418
              ],
              [
                54.9002178,
                37.7733588
              ],
              [
                54.9001556,
                37.7732829
              ],
              [
                54.9000991,
                37.773189
              ],
              [
                54.8998208,
                37.7729824
              ],
              [
                54.8995947,
                37.7728808
              ],
              [
                54.8994124,
                37.7728361
              ],
              [
                54.8991213,
                37.7728439
              ],
              [
                54.89872,
                37.7728651
              ],
              [
                54.8984068,
                37.7728911
              ],
              [
                54.8983208,
                37.7728817
              ],
              [
                54.8982039,
                37.7728367
              ],
              [
                54.898098,
                37.7727758
              ],
              [
                54.8979765,
                37.7726373
              ],
              [
                54.8977207,
                37.7723693
              ],
              [
                54.8975102,
                37.7721794
              ],
              [
                54.8972333,
                37.772013
              ],
              [
                54.8969156,
                37.7718226
              ],
              [
                54.8968696,
                37.771776
              ],
              [
                54.8968576,
                37.7717231
              ],
              [
                54.8968846,
                37.7715762
              ],
              [
                54.8969506,
                37.7713859
              ],
              [
                54.8969526,
                37.7712271
              ],
              [
                54.8968876,
                37.7710873
              ],
              [
                54.8967857,
                37.7710004
              ],
              [
                54.8966289,
                37.7709257
              ],
              [
                54.896493,
                37.7708341
              ],
              [
                54.8962994,
                37.7706567
              ],
              [
                54.8961596,
                37.7705372
              ],
              [
                54.8960263,
                37.770474
              ],
              [
                54.8959114,
                37.7704391
              ],
              [
                54.8957785,
                37.7704195
              ],
              [
                54.8956236,
                37.770414
              ],
              [
                54.8954788,
                37.7704456
              ],
              [
                54.895232,
                37.7705538
              ],
              [
                54.8947714,
                37.7707268
              ],
              [
                54.8944846,
                37.7708768
              ],
              [
                54.8942418,
                37.7710585
              ],
              [
                54.8939331,
                37.7712291
              ],
              [
                54.8934905,
                37.7714858
              ],
              [
                54.8932597,
                37.7715948
              ],
              [
                54.8931717,
                37.7716129
              ],
              [
                54.8931058,
                37.7716042
              ],
              [
                54.8930508,
                37.771575
              ],
              [
                54.8930099,
                37.771526
              ],
              [
                54.8929919,
                37.7714565
              ],
              [
                54.8929869,
                37.771233
              ],
              [
                54.8930119,
                37.7709558
              ],
              [
                54.8930628,
                37.7707536
              ],
              [
                54.8931398,
                37.7706423
              ],
              [
                54.8932547,
                37.7704638
              ],
              [
                54.8934354,
                37.7703108
              ],
              [
                54.8937462,
                37.7700975
              ],
              [
                54.8938593,
                37.7699813
              ],
              [
                54.893985,
                37.769806
              ],
              [
                54.894019,
                37.7696719
              ],
              [
                54.8940246,
                37.7695055
              ],
              [
                54.8939836,
                37.7693313
              ],
              [
                54.8939441,
                37.7691559
              ],
              [
                54.8938664,
                37.7689481
              ],
              [
                54.8937166,
                37.7687839
              ],
              [
                54.8936346,
                37.7686499
              ],
              [
                54.8935908,
                37.768527
              ],
              [
                54.893588,
                37.768412
              ],
              [
                54.8936261,
                37.7683237
              ],
              [
                54.8937505,
                37.7681718
              ],
              [
                54.8938706,
                37.7679663
              ],
              [
                54.8939709,
                37.7676457
              ],
              [
                54.8940444,
                37.7673375
              ],
              [
                54.8940345,
                37.7672101
              ],
              [
                54.8939921,
                37.7671464
              ],
              [
                54.8939285,
                37.767066
              ],
              [
                54.8938282,
                37.7669029
              ],
              [
                54.8937886,
                37.7667857
              ],
              [
                54.8937773,
                37.7665187
              ],
              [
                54.8937491,
                37.7662439
              ],
              [
                54.8936714,
                37.7659189
              ],
              [
                54.8935654,
                37.7655469
              ],
              [
                54.8934396,
                37.7652688
              ],
              [
                54.8932913,
                37.7650018
              ],
              [
                54.893174,
                37.7648733
              ],
              [
                54.8930878,
                37.7648275
              ],
              [
                54.8929557,
                37.7648119
              ],
              [
                54.8928603,
                37.76477
              ],
              [
                54.8927381,
                37.7647166
              ],
              [
                54.8926492,
                37.764644
              ],
              [
                54.8925073,
                37.7646218
              ],
              [
                54.8924263,
                37.7645476
              ],
              [
                54.8922328,
                37.7643186
              ],
              [
                54.8919699,
                37.7640717
              ],
              [
                54.8917396,
                37.7639042
              ],
              [
                54.8914683,
                37.763683
              ],
              [
                54.8911009,
                37.7635043
              ],
              [
                54.8909243,
                37.763444
              ],
              [
                54.8903959,
                37.7633747
              ],
              [
                54.8901797,
                37.763368
              ],
              [
                54.8899677,
                37.763378
              ],
              [
                54.8897628,
                37.7634116
              ],
              [
                54.8895565,
                37.7635076
              ],
              [
                54.8892118,
                37.7637422
              ],
              [
                54.8890012,
                37.7638796
              ],
              [
                54.8888373,
                37.7640818
              ],
              [
                54.8887002,
                37.7642371
              ],
              [
                54.8886536,
                37.7643432
              ],
              [
                54.888648,
                37.7644404
              ],
              [
                54.888672,
                37.7645275
              ],
              [
                54.8887313,
                37.7645912
              ],
              [
                54.8888203,
                37.7646157
              ],
              [
                54.8888896,
                37.7646191
              ],
              [
                54.8889715,
                37.7646135
              ],
              [
                54.8891849,
                37.7646749
              ],
              [
                54.8893856,
                37.7647118
              ],
              [
                54.8895141,
                37.7647096
              ],
              [
                54.8898222,
                37.7646437
              ],
              [
                54.8901231,
                37.7645509
              ],
              [
                54.8902432,
                37.7645331
              ],
              [
                54.8903916,
                37.7645521
              ],
              [
                54.8907039,
                37.7646861
              ],
              [
                54.8909837,
                37.7648146
              ],
              [
                54.8911702,
                37.7649073
              ],
              [
                54.8912126,
                37.7649754
              ],
              [
                54.8912112,
                37.7651262
              ],
              [
                54.8912097,
                37.7653038
              ],
              [
                54.8913256,
                37.7654758
              ],
              [
                54.8914968,
                37.7656297
              ],
              [
                54.8917638,
                37.765823
              ],
              [
                54.8920069,
                37.7660531
              ],
              [
                54.8921849,
                37.7662117
              ],
              [
                54.8922994,
                37.7663134
              ],
              [
                54.892305,
                37.766377
              ],
              [
                54.8922358,
                37.766539
              ],
              [
                54.8921185,
                37.7666596
              ],
              [
                54.8920479,
                37.7667734
              ],
              [
                54.8920349,
                37.7668603
              ],
              [
                54.8920449,
                37.7669306
              ],
              [
                54.8921078,
                37.7670143
              ],
              [
                54.8921058,
                37.7671327
              ],
              [
                54.8921048,
                37.7672583
              ],
              [
                54.8921578,
                37.7674518
              ],
              [
                54.8921708,
                37.7675427
              ],
              [
                54.8921698,
                37.7676493
              ],
              [
                54.8922057,
                37.767827
              ],
              [
                54.8922137,
                37.7679992
              ],
              [
                54.8921688,
                37.7680948
              ],
              [
                54.8921228,
                37.7681319
              ],
              [
                54.8920439,
                37.7681493
              ],
              [
                54.891952,
                37.768139
              ],
              [
                54.8918071,
                37.76809
              ],
              [
                54.8916672,
                37.7679937
              ],
              [
                54.8914014,
                37.7677504
              ],
              [
                54.8912715,
                37.7676927
              ],
              [
                54.8911506,
                37.7676627
              ],
              [
                54.8909558,
                37.7676635
              ],
              [
                54.890689,
                37.7676872
              ],
              [
                54.8903933,
                37.7677164
              ],
              [
                54.8900826,
                37.7677678
              ],
              [
                54.8897189,
                37.7678412
              ],
              [
                54.8894861,
                37.7679281
              ],
              [
                54.8891943,
                37.7680347
              ],
              [
                54.8889066,
                37.7681824
              ],
              [
                54.8886907,
                37.7683649
              ],
              [
                54.8885648,
                37.7684889
              ],
              [
                54.8885309,
                37.7685608
              ],
              [
                54.8884749,
                37.768684
              ],
              [
                54.888421,
                37.7688601
              ],
              [
                54.888405,
                37.7689967
              ],
              [
                54.888358,
                37.7691034
              ],
              [
                54.8882611,
                37.7692629
              ],
              [
                54.8881172,
                37.7694074
              ],
              [
                54.8878415,
                37.7695954
              ],
              [
                54.8875947,
                37.7697676
              ],
              [
                54.88722,
                37.769999
              ],
              [
                54.8871161,
                37.7700488
              ],
              [
                54.8870302,
                37.7700622
              ],
              [
                54.8869352,
                37.7700559
              ],
              [
                54.8868743,
                37.770018
              ],
              [
                54.8868083,
                37.7699406
              ],
              [
                54.8867774,
                37.7698474
              ],
              [
                54.8867166,
                37.7696494
              ],
              [
                54.8866662,
                37.7695706
              ],
              [
                54.8865899,
                37.7695394
              ],
              [
                54.8864924,
                37.7695455
              ],
              [
                54.8864189,
                37.7695801
              ],
              [
                54.8863058,
                37.7696622
              ],
              [
                54.8862492,
                37.7697563
              ],
              [
                54.8861862,
                37.7698337
              ],
              [
                54.8861403,
                37.7700012
              ],
              [
                54.8861133,
                37.7702018
              ],
              [
                54.8860553,
                37.770385
              ],
              [
                54.8860174,
                37.7704608
              ],
              [
                54.8859414,
                37.7704885
              ],
              [
                54.8857946,
                37.7704964
              ],
              [
                54.8855308,
                37.7704387
              ],
              [
                54.885335,
                37.7703566
              ],
              [
                54.8851691,
                37.7702492
              ],
              [
                54.8850732,
                37.7701086
              ],
              [
                54.8849723,
                37.7699198
              ],
              [
                54.8849253,
                37.7697516
              ],
              [
                54.8848943,
                37.7695565
              ],
              [
                54.8847395,
                37.7693456
              ],
              [
                54.8845476,
                37.7691355
              ],
              [
                54.8844487,
                37.7690502
              ],
              [
                54.884147,
                37.7688875
              ],
              [
                54.8839621,
                37.7687343
              ],
              [
                54.8837963,
                37.7685487
              ],
              [
                54.8835884,
                37.7683378
              ],
              [
                54.8833846,
                37.7681182
              ],
              [
                54.8832627,
                37.768025
              ],
              [
                54.8830309,
                37.7678963
              ],
              [
                54.882906,
                37.7678726
              ],
              [
                54.8827911,
                37.7678939
              ],
              [
                54.8826732,
                37.7679579
              ],
              [
                54.8825513,
                37.7680843
              ],
              [
                54.8824964,
                37.7681593
              ],
              [
                54.8824854,
                37.7682825
              ],
              [
                54.8824374,
                37.7684429
              ],
              [
                54.8824514,
                37.7685716
              ],
              [
                54.8824124,
                37.7686782
              ],
              [
                54.8823575,
                37.7687469
              ],
              [
                54.8822736,
                37.7687841
              ],
              [
                54.8821047,
                37.7688078
              ],
              [
                54.8819658,
                37.7687999
              ],
              [
                54.8816921,
                37.7687351
              ],
              [
                54.8815702,
                37.768664
              ],
              [
                54.8813434,
                37.7685179
              ],
              [
                54.8811995,
                37.7684176
              ],
              [
                54.8810156,
                37.7683425
              ],
              [
                54.8809077,
                37.7683449
              ],
              [
                54.8808218,
                37.7683852
              ],
              [
                54.8807668,
                37.76845
              ],
              [
                54.8807459,
                37.768506
              ],
              [
                54.8807379,
                37.7685842
              ],
              [
                54.8807459,
                37.7686498
              ],
              [
                54.8807988,
                37.7687422
              ],
              [
                54.8808468,
                37.7688986
              ],
              [
                54.8809907,
                37.7690818
              ],
              [
                54.881146,
                37.7692561
              ],
              [
                54.8813367,
                37.7694963
              ],
              [
                54.8815077,
                37.769761
              ],
              [
                54.881587,
                37.7699607
              ],
              [
                54.881583,
                37.7700618
              ],
              [
                54.8815381,
                37.7701518
              ],
              [
                54.8814551,
                37.7702308
              ],
              [
                54.8813642,
                37.7702893
              ],
              [
                54.8812783,
                37.7703153
              ],
              [
                54.8811314,
                37.7702924
              ],
              [
                54.8810205,
                37.7702269
              ],
              [
                54.8808127,
                37.7701637
              ],
              [
                54.8806418,
                37.7700673
              ],
              [
                54.880458,
                37.7699307
              ],
              [
                54.8803101,
                37.7697403
              ],
              [
                54.8801652,
                37.7695642
              ],
              [
                54.8799604,
                37.7693857
              ],
              [
                54.8796317,
                37.769163
              ],
              [
                54.8794409,
                37.769039
              ],
              [
                54.879245,
                37.7688952
              ],
              [
                54.8790352,
                37.7687697
              ],
              [
                54.8788953,
                37.7687128
              ],
              [
                54.8788144,
                37.7687183
              ],
              [
                54.8787375,
                37.7687452
              ],
              [
                54.8786306,
                37.7688171
              ],
              [
                54.8785716,
                37.7688992
              ],
              [
                54.8784897,
                37.7690453
              ],
              [
                54.8784277,
                37.7691725
              ],
              [
                54.8784257,
                37.7693217
              ],
              [
                54.8783518,
                37.7695642
              ],
              [
                54.8782739,
                37.7698012
              ],
              [
                54.8782249,
                37.7700634
              ],
              [
                54.878122,
                37.7702324
              ],
              [
                54.878055,
                37.7702766
              ],
              [
                54.8779731,
                37.7702948
              ],
              [
                54.8777613,
                37.7702869
              ],
              [
                54.8776624,
                37.7702521
              ],
              [
                54.8773207,
                37.7701929
              ],
              [
                54.876953,
                37.7701605
              ],
              [
                54.8766492,
                37.7701021
              ],
              [
                54.8762536,
                37.7700057
              ],
              [
                54.8761497,
                37.7699615
              ],
              [
                54.8761107,
                37.7699315
              ],
              [
                54.8761007,
                37.7698873
              ],
              [
                54.8761317,
                37.7697119
              ],
              [
                54.8762136,
                37.7695524
              ],
              [
                54.8763055,
                37.7694544
              ],
              [
                54.8763805,
                37.7693802
              ],
              [
                54.8763985,
                37.7693407
              ],
              [
                54.8764144,
                37.769208
              ],
              [
                54.8764504,
                37.7690872
              ],
              [
                54.8765004,
                37.7689166
              ],
              [
                54.8764914,
                37.7688202
              ],
              [
                54.8764694,
                37.7687626
              ],
              [
                54.8764784,
                37.768663
              ],
              [
                54.8764904,
                37.7685256
              ],
              [
                54.8764854,
                37.7681505
              ],
              [
                54.8764484,
                37.7678985
              ],
              [
                54.8763315,
                37.7676063
              ],
              [
                54.8762386,
                37.7673298
              ],
              [
                54.8761447,
                37.7671395
              ],
              [
                54.8759339,
                37.7669207
              ],
              [
                54.875768,
                37.7667951
              ],
              [
                54.8756644,
                37.7667467
              ],
              [
                54.8755521,
                37.7667294
              ],
              [
                54.87542,
                37.7667551
              ],
              [
                54.8753507,
                37.766797
              ],
              [
                54.8753098,
                37.766864
              ],
              [
                54.8752778,
                37.7669668
              ],
              [
                54.8752814,
                37.7670433
              ],
              [
                54.8753096,
                37.767174
              ],
              [
                54.8753365,
                37.7673907
              ],
              [
                54.8753301,
                37.7676526
              ],
              [
                54.8752785,
                37.7678772
              ],
              [
                54.8752573,
                37.7680883
              ],
              [
                54.87521,
                37.768329
              ],
              [
                54.8751662,
                37.7683781
              ],
              [
                54.8750002,
                37.768477
              ],
              [
                54.8748419,
                37.7685552
              ],
              [
                54.8746533,
                37.7686043
              ],
              [
                54.874341,
                37.7686065
              ],
              [
                54.8740104,
                37.7686233
              ],
              [
                54.8737482,
                37.7686736
              ],
              [
                54.8734402,
                37.7687523
              ],
              [
                54.8732855,
                37.7687847
              ],
              [
                54.8730092,
                37.7688042
              ],
              [
                54.8726291,
                37.7688143
              ],
              [
                54.8723147,
                37.7687987
              ],
              [
                54.8721925,
                37.7687685
              ],
              [
                54.8721402,
                37.7687328
              ],
              [
                54.8721,
                37.7686842
              ],
              [
                54.8720802,
                37.7686171
              ],
              [
                54.8720872,
                37.7685278
              ],
              [
                54.8721134,
                37.7684518
              ],
              [
                54.8721968,
                37.768305
              ],
              [
                54.87229,
                37.7681977
              ],
              [
                54.8724469,
                37.7680536
              ],
              [
                54.8726461,
                37.7678721
              ],
              [
                54.8728178,
                37.7677113
              ],
              [
                54.8729506,
                37.7675633
              ],
              [
                54.8731336,
                37.7673617
              ],
              [
                54.8732602,
                37.7671488
              ],
              [
                54.8734575,
                37.7668837
              ],
              [
                54.8735165,
                37.7667281
              ],
              [
                54.8735414,
                37.7665709
              ],
              [
                54.8735394,
                37.766409
              ],
              [
                54.8734959,
                37.7663289
              ],
              [
                54.8733398,
                37.7661748
              ],
              [
                54.8732105,
                37.7660955
              ],
              [
                54.8731363,
                37.7660793
              ],
              [
                54.8729533,
                37.7659793
              ],
              [
                54.8728756,
                37.7659592
              ],
              [
                54.8727117,
                37.7659458
              ],
              [
                54.8725464,
                37.7659475
              ],
              [
                54.8724263,
                37.7659955
              ],
              [
                54.8722066,
                37.7661195
              ],
              [
                54.8720285,
                37.7662586
              ],
              [
                54.8718597,
                37.7664032
              ],
              [
                54.8717622,
                37.7664557
              ],
              [
                54.8715728,
                37.7665093
              ],
              [
                54.871423,
                37.7665451
              ],
              [
                54.8712789,
                37.7665501
              ],
              [
                54.8711793,
                37.76654
              ],
              [
                54.8711058,
                37.7665043
              ],
              [
                54.8710599,
                37.7664384
              ],
              [
                54.8710514,
                37.7663697
              ],
              [
                54.871067,
                37.7663116
              ],
              [
                54.8711256,
                37.7662329
              ],
              [
                54.8712309,
                37.7661363
              ],
              [
                54.871339,
                37.7660402
              ],
              [
                54.8713828,
                37.7659855
              ],
              [
                54.8714018,
                37.7659134
              ],
              [
                54.8713913,
                37.7657872
              ],
              [
                54.8713107,
                37.7656113
              ],
              [
                54.8712273,
                37.7653918
              ],
              [
                54.8711235,
                37.7652147
              ],
              [
                54.8709907,
                37.7650544
              ],
              [
                54.8708303,
                37.7648506
              ],
              [
                54.8707137,
                37.7646607
              ],
              [
                54.87066,
                37.7645233
              ],
              [
                54.8706409,
                37.7643842
              ],
              [
                54.8706424,
                37.7641625
              ],
              [
                54.8706508,
                37.7638882
              ],
              [
                54.8706014,
                37.7636348
              ],
              [
                54.870494,
                37.763307
              ],
              [
                54.8703809,
                37.7630333
              ],
              [
                54.8702057,
                37.7627228
              ],
              [
                54.8700792,
                37.7625479
              ],
              [
                54.8699383,
                37.7624113
              ],
              [
                54.8698174,
                37.7623284
              ],
              [
                54.8697355,
                37.7622904
              ],
              [
                54.8696625,
                37.7622873
              ],
              [
                54.8695746,
                37.7622991
              ],
              [
                54.8694887,
                37.7623536
              ],
              [
                54.8693798,
                37.7625345
              ],
              [
                54.8692659,
                37.7628141
              ],
              [
                54.8692949,
                37.7629919
              ],
              [
                54.8693678,
                37.7632296
              ],
              [
                54.8693788,
                37.7635542
              ],
              [
                54.8693538,
                37.7635993
              ],
              [
                54.8692806,
                37.7636934
              ],
              [
                54.8692594,
                37.7637984
              ],
              [
                54.8692783,
                37.7640338
              ],
              [
                54.8693343,
                37.7642502
              ],
              [
                54.8694432,
                37.7644611
              ],
              [
                54.869635,
                37.7647478
              ],
              [
                54.8697654,
                37.7649947
              ],
              [
                54.8699167,
                37.7651787
              ],
              [
                54.8700646,
                37.7653501
              ],
              [
                54.8701445,
                37.765482
              ],
              [
                54.8701675,
                37.7655554
              ],
              [
                54.8701445,
                37.7656194
              ],
              [
                54.8700786,
                37.7656747
              ],
              [
                54.8699927,
                37.7656984
              ],
              [
                54.8698648,
                37.7657055
              ],
              [
                54.86966,
                37.7656786
              ],
              [
                54.8693712,
                37.7656565
              ],
              [
                54.8691924,
                37.7656597
              ],
              [
                54.8691074,
                37.7656913
              ],
              [
                54.8690255,
                37.7657624
              ],
              [
                54.8689586,
                37.7658682
              ],
              [
                54.8689466,
                37.7659472
              ],
              [
                54.8689705,
                37.766072
              ],
              [
                54.8690645,
                37.7662813
              ],
              [
                54.8691464,
                37.7665246
              ],
              [
                54.8692723,
                37.7667631
              ],
              [
                54.8693922,
                37.7669305
              ],
              [
                54.8694411,
                37.7670806
              ],
              [
                54.8694421,
                37.7671462
              ],
              [
                54.8694092,
                37.7672007
              ],
              [
                54.8693073,
                37.7672441
              ],
              [
                54.8691234,
                37.7672757
              ],
              [
                54.8689725,
                37.7672773
              ],
              [
                54.8688806,
                37.7672599
              ],
              [
                54.8686488,
                37.7671801
              ],
              [
                54.8683521,
                37.7671122
              ],
              [
                54.8679664,
                37.7670443
              ],
              [
                54.8676137,
                37.7670451
              ],
              [
                54.8670512,
                37.7670964
              ],
              [
                54.8667015,
                37.767113
              ],
              [
                54.8664367,
                37.7670909
              ],
              [
                54.8662049,
                37.7670253
              ],
              [
                54.866049,
                37.7669369
              ],
              [
                54.8658672,
                37.7668571
              ],
              [
                54.8658042,
                37.7667986
              ],
              [
                54.8657783,
                37.7667339
              ],
              [
                54.8657593,
                37.766632
              ],
              [
                54.8657623,
                37.7664938
              ],
              [
                54.8658012,
                37.7664377
              ],
              [
                54.8658172,
                37.7663231
              ],
              [
                54.8657963,
                37.7660965
              ],
              [
                54.8657413,
                37.7657939
              ],
              [
                54.8656933,
                37.7655949
              ],
              [
                54.8656833,
                37.7654148
              ],
              [
                54.8656993,
                37.7652561
              ],
              [
                54.8657463,
                37.7651091
              ],
              [
                54.8658432,
                37.7648572
              ],
              [
                54.8659651,
                37.7646755
              ],
              [
                54.866112,
                37.7645357
              ],
              [
                54.8662609,
                37.7643074
              ],
              [
                54.8662808,
                37.7642308
              ],
              [
                54.8662519,
                37.7640302
              ],
              [
                54.8661929,
                37.7638572
              ],
              [
                54.8661839,
                37.7636155
              ],
              [
                54.8661559,
                37.7634173
              ],
              [
                54.866086,
                37.763144
              ],
              [
                54.8658808,
                37.7627752
              ],
              [
                54.865719,
                37.7626686
              ],
              [
                54.8654612,
                37.7624893
              ],
              [
                54.8653193,
                37.7623479
              ],
              [
                54.8652164,
                37.7621552
              ],
              [
                54.8650685,
                37.7619348
              ],
              [
                54.8649037,
                37.7617381
              ],
              [
                54.8647398,
                37.7616141
              ],
              [
                54.86456,
                37.7614956
              ],
              [
                54.8643521,
                37.7614158
              ],
              [
                54.8640074,
                37.7613495
              ],
              [
                54.8639075,
                37.7613518
              ],
              [
                54.8637676,
                37.7614056
              ],
              [
                54.8634969,
                37.7615398
              ],
              [
                54.8634089,
                37.7616086
              ],
              [
                54.863368,
                37.7616757
              ],
              [
                54.863345,
                37.7617523
              ],
              [
                54.863347,
                37.7618534
              ],
              [
                54.863378,
                37.7619395
              ],
              [
                54.8634659,
                37.7620951
              ],
              [
                54.8635758,
                37.7622847
              ],
              [
                54.8636098,
                37.7623842
              ],
              [
                54.8635918,
                37.7624609
              ],
              [
                54.8635478,
                37.7624972
              ],
              [
                54.8634479,
                37.7625225
              ],
              [
                54.8632761,
                37.7625288
              ],
              [
                54.8631502,
                37.7625114
              ],
              [
                54.8630493,
                37.7624577
              ],
              [
                54.8628814,
                37.7623605
              ],
              [
                54.8628264,
                37.7623376
              ],
              [
                54.8627645,
                37.7622642
              ],
              [
                54.8626346,
                37.7619988
              ],
              [
                54.8625067,
                37.7617302
              ],
              [
                54.8623828,
                37.7615098
              ],
              [
                54.862206,
                37.7613376
              ],
              [
                54.8619282,
                37.7610738
              ],
              [
                54.8617614,
                37.760929
              ],
              [
                54.8616934,
                37.7608326
              ],
              [
                54.8616205,
                37.7606849
              ],
              [
                54.8615206,
                37.7604724
              ],
              [
                54.8614576,
                37.7602291
              ],
              [
                54.8613487,
                37.7599542
              ],
              [
                54.861087,
                37.7596588
              ],
              [
                54.8609031,
                37.7594969
              ],
              [
                54.8608332,
                37.7594147
              ],
              [
                54.8608112,
                37.7593515
              ],
              [
                54.8608052,
                37.7593081
              ],
              [
                54.8608082,
                37.7592568
              ],
              [
                54.8608462,
                37.7592086
              ],
              [
                54.8609391,
                37.7591304
              ],
              [
                54.86109,
                37.7590166
              ],
              [
                54.8611629,
                37.758925
              ],
              [
                54.8611779,
                37.7588626
              ],
              [
                54.8611669,
                37.7587852
              ],
              [
                54.861079,
                37.7586888
              ],
              [
                54.8608591,
                37.7585656
              ],
              [
                54.8606034,
                37.7584131
              ],
              [
                54.8603266,
                37.7582251
              ],
              [
                54.8601677,
                37.7581224
              ],
              [
                54.8600648,
                37.7580995
              ],
              [
                54.8599449,
                37.758105
              ],
              [
                54.8596182,
                37.7581706
              ],
              [
                54.8592995,
                37.7582678
              ],
              [
                54.8590017,
                37.7584408
              ],
              [
                54.858666,
                37.758628
              ],
              [
                54.8584052,
                37.7587409
              ],
              [
                54.8581475,
                37.7588444
              ],
              [
                54.8580166,
                37.7588926
              ],
              [
                54.8579396,
                37.7589068
              ],
              [
                54.8578767,
                37.7588942
              ],
              [
                54.8578018,
                37.7588499
              ],
              [
                54.8577678,
                37.7587875
              ],
              [
                54.8577518,
                37.7587101
              ],
              [
                54.8577548,
                37.7586138
              ],
              [
                54.8577798,
                37.7585253
              ],
              [
                54.8578877,
                37.7583499
              ],
              [
                54.8579886,
                37.7582678
              ],
              [
                54.8581345,
                37.7581825
              ],
              [
                54.8582524,
                37.7580806
              ],
              [
                54.8583023,
                37.7580142
              ],
              [
                54.8583173,
                37.7579415
              ],
              [
                54.8583013,
                37.757861
              ],
              [
                54.8582554,
                37.7577986
              ],
              [
                54.8581604,
                37.7577464
              ],
              [
                54.8580156,
                37.7577235
              ],
              [
                54.8576379,
                37.7577275
              ],
              [
                54.8574471,
                37.7577796
              ],
              [
                54.8572762,
                37.7578791
              ],
              [
                54.8569465,
                37.7580908
              ],
              [
                54.8568206,
                37.7581532
              ],
              [
                54.8566447,
                37.7582046
              ],
              [
                54.8564609,
                37.7582322
              ],
              [
                54.856295,
                37.7582243
              ],
              [
                54.8561442,
                37.7581919
              ],
              [
                54.8560662,
                37.7581627
              ],
              [
                54.8560363,
                37.7581208
              ],
              [
                54.8560133,
                37.7580403
              ],
              [
                54.8560083,
                37.7579455
              ],
              [
                54.8560423,
                37.7577717
              ],
              [
                54.8560642,
                37.7576453
              ],
              [
                54.8560682,
                37.7575458
              ],
              [
                54.8560213,
                37.7574897
              ],
              [
                54.8559433,
                37.7574739
              ],
              [
                54.8557935,
                37.7574391
              ],
              [
                54.8555846,
                37.7573586
              ],
              [
                54.8554667,
                37.7572251
              ],
              [
                54.8554058,
                37.7570631
              ],
              [
                54.8553758,
                37.7568569
              ],
              [
                54.8553818,
                37.756556
              ],
              [
                54.8553628,
                37.7562171
              ],
              [
                54.8553179,
                37.756067
              ],
              [
                54.855205,
                37.7559343
              ],
              [
                54.8549292,
                37.7556404
              ],
              [
                54.8547913,
                37.755439
              ],
              [
                54.8546554,
                37.755168
              ],
              [
                54.8545415,
                37.7549255
              ],
              [
                54.8544136,
                37.7546822
              ],
              [
                54.8543687,
                37.754555
              ],
              [
                54.8543617,
                37.7544736
              ],
              [
                54.8543797,
                37.7544152
              ],
              [
                54.8544176,
                37.7543654
              ],
              [
                54.8544806,
                37.7543283
              ],
              [
                54.8545735,
                37.7543362
              ],
              [
                54.8546484,
                37.7543662
              ],
              [
                54.8547723,
                37.7544215
              ],
              [
                54.8549522,
                37.7544294
              ],
              [
                54.8551633,
                37.754416
              ],
              [
                54.8554521,
                37.7543599
              ],
              [
                54.8557848,
                37.7543133
              ],
              [
                54.8560916,
                37.754243
              ],
              [
                54.8562095,
                37.7541727
              ],
              [
                54.8562694,
                37.7541008
              ],
              [
                54.8562734,
                37.7540337
              ],
              [
                54.8562454,
                37.7539705
              ],
              [
                54.8561065,
                37.7538417
              ],
              [
                54.8559777,
                37.7537572
              ],
              [
                54.8557029,
                37.753626
              ],
              [
                54.8554621,
                37.7534791
              ],
              [
                54.8553502,
                37.7533788
              ],
              [
                54.8552433,
                37.7532279
              ],
              [
                54.8551464,
                37.7530494
              ],
              [
                54.8550325,
                37.7527887
              ],
              [
                54.8549266,
                37.7525343
              ],
              [
                54.8548376,
                37.7522752
              ],
              [
                54.8548216,
                37.7521448
              ],
              [
                54.8548466,
                37.7520674
              ],
              [
                54.8548826,
                37.7520303
              ],
              [
                54.8549755,
                37.7520074
              ],
              [
                54.8551384,
                37.7520176
              ],
              [
                54.8553042,
                37.7520042
              ],
              [
                54.8554691,
                37.7519473
              ],
              [
                54.85552,
                37.7519102
              ],
              [
                54.85555,
                37.7518573
              ],
              [
                54.855518,
                37.7517261
              ],
              [
                54.8553582,
                37.7515136
              ],
              [
                54.8551297,
                37.7512679
              ],
              [
                54.8550458,
                37.7511502
              ],
              [
                54.8550048,
                37.7510728
              ],
              [
                54.8549829,
                37.7510064
              ],
              [
                54.8549809,
                37.7509314
              ],
              [
                54.8550668,
                37.7508042
              ],
              [
                54.8552376,
                37.7506841
              ],
              [
                54.8554505,
                37.7505561
              ],
              [
                54.8557092,
                37.7503949
              ],
              [
                54.8558122,
                37.7503009
              ],
              [
                54.8558331,
                37.7502369
              ],
              [
                54.8558042,
                37.7501611
              ],
              [
                54.8557262,
                37.7500545
              ],
              [
                54.8556183,
                37.7499668
              ],
              [
                54.8553685,
                37.7498522
              ],
              [
                54.8551178,
                37.7497685
              ],
              [
                54.854817,
                37.7497448
              ],
              [
                54.8544663,
                37.7497274
              ],
              [
                54.8541086,
                37.7497084
              ],
              [
                54.8537445,
                37.7497081
              ],
              [
                54.8535426,
                37.7496804
              ],
              [
                54.8534427,
                37.7496386
              ],
              [
                54.8534088,
                37.749592
              ],
              [
                54.8533958,
                37.7495367
              ],
              [
                54.8534038,
                37.7494798
              ],
              [
                54.8534437,
                37.7494245
              ],
              [
                54.8535576,
                37.7493605
              ],
              [
                54.8536575,
                37.7493281
              ],
              [
                54.8538044,
                37.749332
              ],
              [
                54.8541541,
                37.7493004
              ],
              [
                54.8546047,
                37.7492341
              ],
              [
                54.8548385,
                37.7491574
              ],
              [
                54.8549634,
                37.7490784
              ],
              [
                54.8550174,
                37.7490034
              ],
              [
                54.8550364,
                37.7489031
              ],
              [
                54.8550204,
                37.7487838
              ],
              [
                54.8549225,
                37.7486566
              ],
              [
                54.8548046,
                37.7486021
              ],
              [
                54.8545708,
                37.7485507
              ],
              [
                54.8544589,
                37.7484891
              ],
              [
                54.8541271,
                37.7484204
              ],
              [
                54.8538274,
                37.7484069
              ],
              [
                54.8533014,
                37.7483743
              ],
              [
                54.8528803,
                37.7483911
              ],
              [
                54.8522995,
                37.7485173
              ],
              [
                54.8517471,
                37.7486481
              ],
              [
                54.8514023,
                37.7487453
              ],
              [
                54.8510974,
                37.7488962
              ],
              [
                54.8508982,
                37.7489928
              ],
              [
                54.8508003,
                37.7490845
              ],
              [
                54.8507143,
                37.7492622
              ],
              [
                54.8506914,
                37.7493949
              ],
              [
                54.8506374,
                37.7496201
              ],
              [
                54.8504835,
                37.749959
              ],
              [
                54.8504026,
                37.7500222
              ],
              [
                54.8503127,
                37.7500507
              ],
              [
                54.8502527,
                37.7500538
              ],
              [
                54.8501778,
                37.7500388
              ],
              [
                54.8500909,
                37.7499969
              ],
              [
                54.849995,
                37.7498998
              ],
              [
                54.8498721,
                37.7497426
              ],
              [
                54.8497811,
                37.7495545
              ],
              [
                54.8496762,
                37.7493507
              ],
              [
                54.8495623,
                37.749218
              ],
              [
                54.8494654,
                37.74912
              ],
              [
                54.8493795,
                37.7491034
              ],
              [
                54.8492686,
                37.7491184
              ],
              [
                54.8491517,
                37.7492006
              ],
              [
                54.8490777,
                37.7493815
              ],
              [
                54.8489429,
                37.7495853
              ],
              [
                54.8488719,
                37.7496312
              ],
              [
                54.848789,
                37.7496509
              ],
              [
                54.8487011,
                37.7496873
              ],
              [
                54.8485752,
                37.7497054
              ],
              [
                54.8485042,
                37.7496983
              ],
              [
                54.8484243,
                37.7496588
              ],
              [
                54.8483803,
                37.7496075
              ],
              [
                54.8483464,
                37.7494976
              ],
              [
                54.8483314,
                37.749357
              ],
              [
                54.8483574,
                37.7492283
              ],
              [
                54.8484683,
                37.7490244
              ],
              [
                54.8486851,
                37.7487345
              ],
              [
                54.8488649,
                37.7485038
              ],
              [
                54.8489968,
                37.7483482
              ],
              [
                54.8490348,
                37.7482723
              ],
              [
                54.8490068,
                37.7481902
              ],
              [
                54.8488889,
                37.7480495
              ],
              [
                54.8486711,
                37.74795
              ],
              [
                54.8484083,
                37.7478868
              ],
              [
                54.8479057,
                37.7477596
              ],
              [
                54.8478078,
                37.7477153
              ],
              [
                54.8477768,
                37.7476758
              ],
              [
                54.8477719,
                37.74763
              ],
              [
                54.8477958,
                37.7475557
              ],
              [
                54.8479467,
                37.7473906
              ],
              [
                54.8481775,
                37.7472058
              ],
              [
                54.8484133,
                37.7470493
              ],
              [
                54.8486441,
                37.7468455
              ],
              [
                54.848732,
                37.746738
              ],
              [
                54.84875,
                37.7466662
              ],
              [
                54.848719,
                37.7465903
              ],
              [
                54.8485991,
                37.7464797
              ],
              [
                54.8484003,
                37.7463904
              ],
              [
                54.8481805,
                37.7463493
              ],
              [
                54.8478208,
                37.7463604
              ],
              [
                54.847573,
                37.7464197
              ],
              [
                54.8473422,
                37.7465145
              ],
              [
                54.8470964,
                37.7466306
              ],
              [
                54.8468926,
                37.7466899
              ],
              [
                54.8467957,
                37.7467057
              ],
              [
                54.8466908,
                37.7467009
              ],
              [
                54.8465559,
                37.7466464
              ],
              [
                54.8463571,
                37.7465729
              ],
              [
                54.8460783,
                37.7465208
              ],
              [
                54.8458415,
                37.7464125
              ],
              [
                54.8457905,
                37.7463565
              ],
              [
                54.8457885,
                37.7462846
              ],
              [
                54.8458045,
                37.7462016
              ],
              [
                54.8458475,
                37.7461455
              ],
              [
                54.8460134,
                37.7460649
              ],
              [
                54.8462492,
                37.7459717
              ],
              [
                54.8464969,
                37.7458974
              ],
              [
                54.8465239,
                37.7458374
              ],
              [
                54.846427,
                37.7456928
              ],
              [
                54.8462621,
                37.7455451
              ],
              [
                54.8460883,
                37.7454747
              ],
              [
                54.8458905,
                37.7454747
              ],
              [
                54.8456766,
                37.7454992
              ],
              [
                54.8454126,
                37.7455572
              ],
              [
                54.8452161,
                37.7456653
              ],
              [
                54.8450262,
                37.7458154
              ],
              [
                54.8448244,
                37.746005
              ],
              [
                54.8446226,
                37.746133
              ],
              [
                54.8445436,
                37.7461583
              ],
              [
                54.8444667,
                37.7461543
              ],
              [
                54.8443968,
                37.746133
              ],
              [
                54.8443388,
                37.7460974
              ],
              [
                54.8442979,
                37.7460113
              ],
              [
                54.8442579,
                37.7458446
              ],
              [
                54.8442759,
                37.7457087
              ],
              [
                54.8442399,
                37.7454022
              ],
              [
                54.844167,
                37.7450877
              ],
              [
                54.8440551,
                37.7447409
              ],
              [
                54.8439462,
                37.7444952
              ],
              [
                54.8438632,
                37.7444423
              ],
              [
                54.8437523,
                37.7444201
              ],
              [
                54.8435406,
                37.7444337
              ],
              [
                54.8433781,
                37.7444895
              ],
              [
                54.8432457,
                37.7445979
              ],
              [
                54.8430239,
                37.7448537
              ],
              [
                54.8427936,
                37.7450155
              ],
              [
                54.8425568,
                37.7450779
              ],
              [
                54.8422241,
                37.7450819
              ],
              [
                54.842015,
                37.7450528
              ],
              [
                54.8417431,
                37.7450259
              ],
              [
                54.8415683,
                37.7450456
              ],
              [
                54.8414364,
                37.7450891
              ],
              [
                54.8412466,
                37.745202
              ],
              [
                54.8409432,
                37.7454673
              ],
              [
                54.8406365,
                37.7456919
              ],
              [
                54.8404969,
                37.7457596
              ],
              [
                54.840412,
                37.7457754
              ],
              [
                54.8403121,
                37.745758
              ],
              [
                54.8402131,
                37.745694
              ],
              [
                54.8401642,
                37.7456142
              ],
              [
                54.8400813,
                37.7454128
              ],
              [
                54.8400443,
                37.74525
              ],
              [
                54.8400773,
                37.7451165
              ],
              [
                54.8401622,
                37.7449648
              ],
              [
                54.8402331,
                37.7447144
              ],
              [
                54.840356,
                37.7444574
              ],
              [
                54.8403851,
                37.7443439
              ],
              [
                54.8403641,
                37.7442025
              ],
              [
                54.8402792,
                37.7440602
              ],
              [
                54.8401763,
                37.7439757
              ],
              [
                54.8399715,
                37.7438556
              ],
              [
                54.8399185,
                37.743794
              ],
              [
                54.8399075,
                37.7437276
              ],
              [
                54.8399205,
                37.7436628
              ],
              [
                54.8399695,
                37.743587
              ],
              [
                54.8400614,
                37.7435293
              ],
              [
                54.8402662,
                37.743455
              ],
              [
                54.8404471,
                37.7433168
              ],
              [
                54.8406579,
                37.7431856
              ],
              [
                54.8409466,
                37.743041
              ],
              [
                54.8411834,
                37.7428704
              ],
              [
                54.8413713,
                37.7427424
              ],
              [
                54.8414832,
                37.7426926
              ],
              [
                54.8415991,
                37.742691
              ],
              [
                54.841719,
                37.7427258
              ],
              [
                54.8417939,
                37.7428064
              ],
              [
                54.8418349,
                37.7429288
              ],
              [
                54.8418689,
                37.7431185
              ],
              [
                54.8418808,
                37.7433342
              ],
              [
                54.8419118,
                37.7434598
              ],
              [
                54.8419598,
                37.7435159
              ],
              [
                54.8420517,
                37.7435617
              ],
              [
                54.8422096,
                37.7435704
              ],
              [
                54.8424274,
                37.7435333
              ],
              [
                54.8426912,
                37.7434424
              ],
              [
                54.8429559,
                37.7432749
              ],
              [
                54.8430359,
                37.7431848
              ],
              [
                54.8430858,
                37.7430339
              ],
              [
                54.8431448,
                37.7427874
              ],
              [
                54.8431438,
                37.7426333
              ],
              [
                54.8430708,
                37.7422999
              ],
              [
                54.8429919,
                37.7420139
              ],
              [
                54.842847,
                37.7417042
              ],
              [
                54.8426792,
                37.7413866
              ],
              [
                54.8425013,
                37.7411424
              ],
              [
                54.8423245,
                37.7408588
              ],
              [
                54.8422755,
                37.7407553
              ],
              [
                54.8422775,
                37.740666
              ],
              [
                54.8423295,
                37.7405364
              ],
              [
                54.8423994,
                37.7404882
              ],
              [
                54.8425643,
                37.7404613
              ],
              [
                54.842848,
                37.7404218
              ],
              [
                54.8431827,
                37.7404416
              ],
              [
                54.8434695,
                37.7404613
              ],
              [
                54.8437502,
                37.7404361
              ],
              [
                54.8441219,
                37.7403618
              ],
              [
                54.8443691,
                37.740319
              ],
              [
                54.8445952,
                37.7403346
              ],
              [
                54.8450035,
                37.7403469
              ],
              [
                54.8453596,
                37.7403145
              ],
              [
                54.8456451,
                37.7402464
              ],
              [
                54.8457298,
                37.7401838
              ],
              [
                54.8458601,
                37.7400109
              ],
              [
                54.8458731,
                37.7398561
              ],
              [
                54.8458081,
                37.7396862
              ],
              [
                54.8456902,
                37.7395274
              ],
              [
                54.8455194,
                37.7394104
              ],
              [
                54.8453005,
                37.7393283
              ],
              [
                54.8448879,
                37.7392864
              ],
              [
                54.8444822,
                37.7392176
              ],
              [
                54.8437569,
                37.7391307
              ],
              [
                54.8431687,
                37.7390993
              ],
              [
                54.8428196,
                37.7390456
              ],
              [
                54.8425596,
                37.7389808
              ],
              [
                54.8422516,
                37.7388669
              ],
              [
                54.8419959,
                37.7388043
              ],
              [
                54.8416384,
                37.7387316
              ],
              [
                54.841507,
                37.7387305
              ],
              [
                54.841124,
                37.7387685
              ],
              [
                54.840857,
                37.7387998
              ],
              [
                54.8405285,
                37.7388282
              ],
              [
                54.8403107,
                37.738829
              ],
              [
                54.8402378,
                37.7388108
              ],
              [
                54.8401848,
                37.7387681
              ],
              [
                54.8401379,
                37.7386622
              ],
              [
                54.8401269,
                37.7384608
              ],
              [
                54.8400469,
                37.7382616
              ],
              [
                54.8397217,
                37.7378735
              ],
              [
                54.8395288,
                37.7376175
              ],
              [
                54.8394519,
                37.7374129
              ],
              [
                54.8394329,
                37.7373323
              ],
              [
                54.8394389,
                37.7372841
              ],
              [
                54.8394779,
                37.7372335
              ],
              [
                54.8396048,
                37.7371695
              ],
              [
                54.8397277,
                37.7371474
              ],
              [
                54.8400084,
                37.7371553
              ],
              [
                54.8404481,
                37.7371316
              ],
              [
                54.8406978,
                37.7370439
              ],
              [
                54.8407318,
                37.7370107
              ],
              [
                54.8407338,
                37.7368187
              ],
              [
                54.8407338,
                37.7367191
              ],
              [
                54.8406968,
                37.7365824
              ],
              [
                54.8406079,
                37.7365018
              ],
              [
                54.840464,
                37.7364109
              ],
              [
                54.8403112,
                37.7362284
              ],
              [
                54.8401853,
                37.736117
              ],
              [
                54.8400664,
                37.7360649
              ],
              [
                54.8398586,
                37.7360222
              ],
              [
                54.8394929,
                37.73588
              ],
              [
                54.8391502,
                37.7357504
              ],
              [
                54.8388164,
                37.7355994
              ],
              [
                54.8387435,
                37.7355512
              ],
              [
                54.8387115,
                37.7354928
              ],
              [
                54.8386736,
                37.735364
              ],
              [
                54.8386806,
                37.7352541
              ],
              [
                54.8387425,
                37.7351222
              ],
              [
                54.8389144,
                37.7349555
              ],
              [
                54.8390672,
                37.7348472
              ],
              [
                54.8391092,
                37.7347816
              ],
              [
                54.8392331,
                37.7346813
              ],
              [
                54.8392711,
                37.7346267
              ],
              [
                54.839282,
                37.7345793
              ],
              [
                54.8392691,
                37.7345035
              ],
              [
                54.8392081,
                37.7344316
              ],
              [
                54.8390003,
                37.7342783
              ],
              [
                54.8385836,
                37.7340286
              ],
              [
                54.8384717,
                37.7339251
              ],
              [
                54.8384288,
                37.7337639
              ],
              [
                54.8384198,
                37.733594
              ],
              [
                54.8384388,
                37.7333482
              ],
              [
                54.8384228,
                37.733127
              ],
              [
                54.8383349,
                37.7329144
              ],
              [
                54.8380822,
                37.732603
              ],
              [
                54.8378494,
                37.7323659
              ],
              [
                54.8376747,
                37.732254
              ],
              [
                54.8375438,
                37.732209
              ],
              [
                54.8374319,
                37.7322066
              ],
              [
                54.83728,
                37.7322335
              ],
              [
                54.8371371,
                37.7323149
              ],
              [
                54.8370162,
                37.7324318
              ],
              [
                54.8367904,
                37.7326942
              ],
              [
                54.8365896,
                37.7329589
              ],
              [
                54.8364397,
                37.7331059
              ],
              [
                54.8362599,
                37.7332181
              ],
              [
                54.836074,
                37.7332584
              ],
              [
                54.8358492,
                37.7332663
              ],
              [
                54.8355385,
                37.7332331
              ],
              [
                54.8353786,
                37.7331896
              ],
              [
                54.8351778,
                37.7331177
              ],
              [
                54.8351118,
                37.7330711
              ],
              [
                54.8350819,
                37.7330253
              ],
              [
                54.8350649,
                37.7329004
              ],
              [
                54.8350799,
                37.7326096
              ],
              [
                54.8350989,
                37.732431
              ],
              [
                54.8350849,
                37.7321213
              ],
              [
                54.8351019,
                37.7319996
              ],
              [
                54.8351568,
                37.7318305
              ],
              [
                54.8353407,
                37.7316621
              ],
              [
                54.8355755,
                37.7314488
              ],
              [
                54.8357843,
                37.7312346
              ],
              [
                54.8358123,
                37.7311809
              ],
              [
                54.8358123,
                37.7311335
              ],
              [
                54.8357533,
                37.7310545
              ],
              [
                54.8356574,
                37.7309999
              ],
              [
                54.8354935,
                37.7309905
              ],
              [
                54.8351998,
                37.731011
              ],
              [
                54.834978,
                37.7310916
              ],
              [
                54.8347811,
                37.7311564
              ],
              [
                54.8346652,
                37.731177
              ],
              [
                54.8345633,
                37.7311619
              ],
              [
                54.8344874,
                37.731128
              ],
              [
                54.8344554,
                37.7310798
              ],
              [
                54.8344494,
                37.7309802
              ],
              [
                54.8345034,
                37.7307534
              ],
              [
                54.8346702,
                37.730465
              ],
              [
                54.8347472,
                37.7303804
              ],
              [
                54.8348121,
                37.7302295
              ],
              [
                54.8347971,
                37.7300801
              ],
              [
                54.8347032,
                37.7299845
              ],
              [
                54.8344554,
                37.7298383
              ],
              [
                54.8342386,
                37.7296265
              ],
              [
                54.8341057,
                37.7293729
              ],
              [
                54.8339808,
                37.7291255
              ],
              [
                54.8338809,
                37.7288624
              ],
              [
                54.833785,
                37.7287138
              ],
              [
                54.8336139,
                37.728604
              ],
              [
                54.8334381,
                37.7285449
              ],
              [
                54.8332503,
                37.7285046
              ],
              [
                54.8330595,
                37.7285046
              ],
              [
                54.8328077,
                37.7285252
              ],
              [
                54.8326078,
                37.7285576
              ],
              [
                54.8325109,
                37.7285457
              ],
              [
                54.8323231,
                37.7284936
              ],
              [
                54.8321542,
                37.728398
              ],
              [
                54.8320953,
                37.7283339
              ],
              [
                54.8320603,
                37.7282478
              ],
              [
                54.8320263,
                37.7281356
              ],
              [
                54.8320253,
                37.7280392
              ],
              [
                54.8320823,
                37.7279396
              ],
              [
                54.8322302,
                37.7277831
              ],
              [
                54.832446,
                37.7275777
              ],
              [
                54.8326108,
                37.7274062
              ],
              [
                54.8326468,
                37.7273082
              ],
              [
                54.8326188,
                37.727158
              ],
              [
                54.8325279,
                37.7270466
              ],
              [
                54.8324553,
                37.7269818
              ],
              [
                54.8322157,
                37.7269382
              ],
              [
                54.8320174,
                37.7269361
              ],
              [
                54.8318663,
                37.7269788
              ],
              [
                54.8317233,
                37.7270695
              ],
              [
                54.8315641,
                37.7272541
              ],
              [
                54.8314224,
                37.727428
              ],
              [
                54.8312241,
                37.7275091
              ],
              [
                54.8311,
                37.7275454
              ],
              [
                54.830992,
                37.7275305
              ],
              [
                54.830878,
                37.7274838
              ],
              [
                54.8307653,
                37.7273794
              ],
              [
                54.8305917,
                37.7272518
              ],
              [
                54.8304963,
                37.7272269
              ],
              [
                54.8304067,
                37.727233
              ],
              [
                54.8302779,
                37.7272881
              ],
              [
                54.830151,
                37.7273628
              ],
              [
                54.8300813,
                37.7274654
              ],
              [
                54.8300231,
                37.7275982
              ],
              [
                54.8299993,
                37.7277083
              ],
              [
                54.8300003,
                37.7279113
              ],
              [
                54.8299451,
                37.7282961
              ],
              [
                54.8298484,
                37.7283688
              ],
              [
                54.8297453,
                37.7283937
              ],
              [
                54.8296318,
                37.7283915
              ],
              [
                54.8294887,
                37.728356
              ],
              [
                54.8293733,
                37.7282851
              ],
              [
                54.8291825,
                37.7280995
              ],
              [
                54.8290489,
                37.7279297
              ],
              [
                54.8288305,
                37.7277433
              ],
              [
                54.8287809,
                37.7276249
              ],
              [
                54.8287446,
                37.7274943
              ],
              [
                54.8287379,
                37.7274098
              ],
              [
                54.8287522,
                37.7273593
              ],
              [
                54.8288381,
                37.7272695
              ],
              [
                54.8290637,
                37.7270333
              ],
              [
                54.8292013,
                37.7269138
              ],
              [
                54.8292809,
                37.7267356
              ],
              [
                54.829289,
                37.7264155
              ],
              [
                54.8293308,
                37.72609
              ],
              [
                54.8293646,
                37.7260046
              ],
              [
                54.8294536,
                37.7258872
              ],
              [
                54.8295953,
                37.7257944
              ],
              [
                54.8297072,
                37.7256535
              ],
              [
                54.8298233,
                37.7254636
              ],
              [
                54.8298421,
                37.7253409
              ],
              [
                54.8298044,
                37.7252438
              ],
              [
                54.8296937,
                37.7251584
              ],
              [
                54.8294644,
                37.7250965
              ],
              [
                54.8290273,
                37.7250154
              ],
              [
                54.8286212,
                37.7250432
              ],
              [
                54.8283001,
                37.7250826
              ],
              [
                54.8278778,
                37.7251808
              ],
              [
                54.8276565,
                37.7252993
              ],
              [
                54.8275035,
                37.7254546
              ],
              [
                54.8273888,
                37.7256712
              ],
              [
                54.8272391,
                37.725859
              ],
              [
                54.8271042,
                37.7259583
              ],
              [
                54.8267305,
                37.7260554
              ],
              [
                54.826404,
                37.7261237
              ],
              [
                54.8262906,
                37.7261952
              ],
              [
                54.8262367,
                37.7262859
              ],
              [
                54.8262421,
                37.726351
              ],
              [
                54.8263298,
                37.7265281
              ],
              [
                54.8264984,
                37.7267981
              ],
              [
                54.8265119,
                37.7269112
              ],
              [
                54.8264377,
                37.7270072
              ],
              [
                54.8263325,
                37.7270435
              ],
              [
                54.8261746,
                37.7270563
              ],
              [
                54.8259237,
                37.726988
              ],
              [
                54.8256754,
                37.7268269
              ],
              [
                54.8253341,
                37.7266348
              ],
              [
                54.8249982,
                37.7264854
              ],
              [
                54.8246676,
                37.7263574
              ],
              [
                54.8244275,
                37.7262336
              ],
              [
                54.8243735,
                37.7261845
              ],
              [
                54.824356,
                37.7261226
              ],
              [
                54.8243546,
                37.7260212
              ],
              [
                54.824414,
                37.7258537
              ],
              [
                54.824553,
                37.7255762
              ],
              [
                54.8247149,
                37.7253532
              ],
              [
                54.8249483,
                37.725016
              ],
              [
                54.8251129,
                37.7247471
              ],
              [
                54.8251196,
                37.7246137
              ],
              [
                54.8250427,
                37.7244344
              ],
              [
                54.8249172,
                37.7241602
              ],
              [
                54.8247472,
                37.723871
              ],
              [
                54.824584,
                37.7235882
              ],
              [
                54.8243115,
                37.7231667
              ],
              [
                54.8240983,
                37.7228786
              ],
              [
                54.8240214,
                37.7227153
              ],
              [
                54.8239607,
                37.7225285
              ],
              [
                54.8239391,
                37.7223909
              ],
              [
                54.823962,
                37.7222618
              ],
              [
                54.8238716,
                37.7218392
              ],
              [
                54.8237246,
                37.7214646
              ],
              [
                54.8236558,
                37.7212682
              ],
              [
                54.8236356,
                37.7210943
              ],
              [
                54.8236558,
                37.7207432
              ],
              [
                54.8236167,
                37.7205148
              ],
              [
                54.8235155,
                37.7202459
              ],
              [
                54.8233293,
                37.7198019
              ],
              [
                54.8232645,
                37.7195586
              ],
              [
                54.8232564,
                37.719405
              ],
              [
                54.8232672,
                37.7192833
              ],
              [
                54.8233023,
                37.7191979
              ],
              [
                54.82339,
                37.7190997
              ],
              [
                54.8235425,
                37.7188095
              ],
              [
                54.8235613,
                37.7186985
              ],
              [
                54.8235128,
                37.7186302
              ],
              [
                54.8233454,
                37.7185374
              ],
              [
                54.8232252,
                37.7184038
              ],
              [
                54.8231728,
                37.7182559
              ],
              [
                54.8231957,
                37.7180551
              ],
              [
                54.8232434,
                37.7178574
              ],
              [
                54.8233283,
                37.7177073
              ],
              [
                54.8234838,
                37.7175941
              ],
              [
                54.8236173,
                37.7175548
              ],
              [
                54.8238456,
                37.7175537
              ],
              [
                54.8240507,
                37.7175823
              ],
              [
                54.8244295,
                37.7176457
              ],
              [
                54.8246403,
                37.7176918
              ],
              [
                54.8247281,
                37.7176872
              ],
              [
                54.8248225,
                37.7176563
              ],
              [
                54.8249399,
                37.7175771
              ],
              [
                54.8250009,
                37.717488
              ],
              [
                54.8250362,
                37.7172329
              ],
              [
                54.8250553,
                37.7169643
              ],
              [
                54.8250566,
                37.7165865
              ],
              [
                54.8250688,
                37.7164061
              ],
              [
                54.8251173,
                37.7162962
              ],
              [
                54.8252792,
                37.7161767
              ],
              [
                54.8255383,
                37.715991
              ],
              [
                54.8256732,
                37.7158426
              ],
              [
                54.825684,
                37.7157434
              ],
              [
                54.8255949,
                37.7154531
              ],
              [
                54.8253548,
                37.714896
              ],
              [
                54.8250931,
                37.7143293
              ],
              [
                54.8249865,
                37.7142631
              ],
              [
                54.8248678,
                37.7142439
              ],
              [
                54.8246951,
                37.7142663
              ],
              [
                54.8245129,
                37.7143442
              ],
              [
                54.8242863,
                37.7145256
              ],
              [
                54.8241379,
                37.7146825
              ],
              [
                54.8239045,
                37.714912
              ],
              [
                54.8237318,
                37.7151511
              ],
              [
                54.8235861,
                37.7153133
              ],
              [
                54.8234377,
                37.7153869
              ],
              [
                54.8233142,
                37.7153969
              ],
              [
                54.8231816,
                37.7153614
              ],
              [
                54.8229889,
                37.715252
              ],
              [
                54.8226687,
                37.7149774
              ],
              [
                54.8224785,
                37.7148536
              ],
              [
                54.8222438,
                37.7147639
              ],
              [
                54.8219375,
                37.7146508
              ],
              [
                54.8218301,
                37.7145946
              ],
              [
                54.8217748,
                37.7145493
              ],
              [
                54.821751,
                37.714504
              ],
              [
                54.8217481,
                37.7144535
              ],
              [
                54.821792,
                37.7143176
              ],
              [
                54.8219215,
                37.7140337
              ],
              [
                54.82199,
                37.7137824
              ],
              [
                54.821968,
                37.7136609
              ],
              [
                54.8218889,
                37.7135899
              ],
              [
                54.8217916,
                37.713556
              ],
              [
                54.8215912,
                37.7135515
              ],
              [
                54.8214004,
                37.7136111
              ],
              [
                54.8211373,
                37.7137324
              ],
              [
                54.8209053,
                37.7139363
              ],
              [
                54.8207407,
                37.7140377
              ],
              [
                54.8205248,
                37.7140974
              ],
              [
                54.8203909,
                37.7140917
              ],
              [
                54.8201915,
                37.7140253
              ],
              [
                54.8199225,
                37.7139189
              ],
              [
                54.8198424,
                37.7138744
              ],
              [
                54.8197784,
                37.7137883
              ],
              [
                54.8197174,
                37.7136865
              ],
              [
                54.8197069,
                37.7136367
              ],
              [
                54.8197155,
                37.7135612
              ],
              [
                54.819787,
                37.7134457
              ],
              [
                54.819912,
                37.7133152
              ],
              [
                54.8202421,
                37.7130254
              ],
              [
                54.8203833,
                37.7128692
              ],
              [
                54.8205225,
                37.7127129
              ],
              [
                54.8206523,
                37.7124601
              ],
              [
                54.8207582,
                37.7122888
              ],
              [
                54.8208345,
                37.7122277
              ],
              [
                54.821072,
                37.7120979
              ],
              [
                54.8211865,
                37.712002
              ],
              [
                54.8212285,
                37.7119379
              ],
              [
                54.8212428,
                37.7118669
              ],
              [
                54.8212476,
                37.7117854
              ],
              [
                54.8212161,
                37.7117145
              ],
              [
                54.8210825,
                37.7116579
              ],
              [
                54.8208221,
                37.7115598
              ],
              [
                54.8204659,
                37.7114274
              ],
              [
                54.8201529,
                37.7113111
              ],
              [
                54.8198912,
                37.7111785
              ],
              [
                54.819854,
                37.7111402
              ],
              [
                54.8198439,
                37.7110847
              ],
              [
                54.819847,
                37.7109789
              ],
              [
                54.8198766,
                37.7108823
              ],
              [
                54.8199968,
                37.7107064
              ],
              [
                54.8202181,
                37.7104528
              ],
              [
                54.8203788,
                37.7101544
              ],
              [
                54.8205083,
                37.7099409
              ],
              [
                54.8206244,
                37.7096827
              ],
              [
                54.8207701,
                37.7095343
              ],
              [
                54.820909,
                37.7094478
              ],
              [
                54.8214312,
                37.7092547
              ],
              [
                54.8215984,
                37.709133
              ],
              [
                54.8216403,
                37.7090156
              ],
              [
                54.8216254,
                37.7089046
              ],
              [
                54.8215215,
                37.7087637
              ],
              [
                54.8213408,
                37.7086548
              ],
              [
                54.8211829,
                37.7086217
              ],
              [
                54.8210048,
                37.7086345
              ],
              [
                54.8208052,
                37.7087285
              ],
              [
                54.8204233,
                37.7089846
              ],
              [
                54.8202345,
                37.7090956
              ],
              [
                54.8201252,
                37.7091212
              ],
              [
                54.81997,
                37.7090839
              ],
              [
                54.8197636,
                37.708991
              ],
              [
                54.8196935,
                37.7089152
              ],
              [
                54.8196638,
                37.7088021
              ],
              [
                54.8196665,
                37.7086601
              ],
              [
                54.8197016,
                37.7085577
              ],
              [
                54.8199201,
                37.7083581
              ],
              [
                54.8201697,
                37.708182
              ],
              [
                54.8203545,
                37.7080656
              ],
              [
                54.8204895,
                37.7079568
              ],
              [
                54.8205852,
                37.7078127
              ],
              [
                54.8206257,
                37.7076675
              ],
              [
                54.8205852,
                37.7074487
              ],
              [
                54.8205852,
                37.7073665
              ],
              [
                54.8206999,
                37.7072182
              ],
              [
                54.8208106,
                37.7071296
              ],
              [
                54.8210291,
                37.7070762
              ],
              [
                54.8211991,
                37.7069652
              ],
              [
                54.8212652,
                37.706835
              ],
              [
                54.8214635,
                37.706265
              ],
              [
                54.8216206,
                37.7059446
              ],
              [
                54.8218499,
                37.705714
              ],
              [
                54.8221184,
                37.7054461
              ],
              [
                54.8222264,
                37.7051729
              ],
              [
                54.8223936,
                37.7048516
              ],
              [
                54.8225245,
                37.7046776
              ],
              [
                54.8227161,
                37.7045922
              ],
              [
                54.8229751,
                37.7045527
              ],
              [
                54.8231262,
                37.7044566
              ],
              [
                54.8231748,
                37.7043467
              ],
              [
                54.8231559,
                37.7041994
              ],
              [
                54.8229994,
                37.7039603
              ],
              [
                54.8228807,
                37.7038322
              ],
              [
                54.8227338,
                37.7035137
              ],
              [
                54.8225801,
                37.7032026
              ],
              [
                54.8224438,
                37.7029677
              ],
              [
                54.8222145,
                37.7028631
              ],
              [
                54.8219096,
                37.7027895
              ],
              [
                54.8215224,
                37.7027638
              ],
              [
                54.8212604,
                37.7027307
              ],
              [
                54.8211774,
                37.7026937
              ],
              [
                54.8211402,
                37.7026431
              ],
              [
                54.821145,
                37.7025292
              ],
              [
                54.8211888,
                37.7023442
              ],
              [
                54.8212881,
                37.702114
              ],
              [
                54.8212833,
                37.7020627
              ],
              [
                54.8211669,
                37.7019646
              ],
              [
                54.8209828,
                37.7019185
              ],
              [
                54.8207052,
                37.7018914
              ],
              [
                54.8202992,
                37.7018796
              ],
              [
                54.8202124,
                37.7018766
              ],
              [
                54.8201256,
                37.7018019
              ],
              [
                54.8200702,
                37.701709
              ],
              [
                54.8200655,
                37.7016071
              ],
              [
                54.8200865,
                37.7014916
              ],
              [
                54.8201485,
                37.7014252
              ],
              [
                54.8202429,
                37.7013814
              ],
              [
                54.8204327,
                37.701349
              ],
              [
                54.8207934,
                37.701346
              ],
              [
                54.8210821,
                37.7013414
              ],
              [
                54.82124,
                37.7013184
              ],
              [
                54.8213268,
                37.7012437
              ],
              [
                54.8214146,
                37.7010814
              ],
              [
                54.8214976,
                37.7009372
              ],
              [
                54.8216264,
                37.7007976
              ],
              [
                54.8218038,
                37.700741
              ],
              [
                54.8220833,
                37.700667
              ],
              [
                54.8222588,
                37.7006512
              ],
              [
                54.8224811,
                37.7006753
              ],
              [
                54.822692,
                37.7006383
              ],
              [
                54.8228618,
                37.7005712
              ],
              [
                54.8229448,
                37.700504
              ],
              [
                54.8229476,
                37.7004232
              ],
              [
                54.8229457,
                37.7002813
              ],
              [
                54.8228799,
                37.7001613
              ],
              [
                54.8226614,
                37.699962
              ],
              [
                54.8224067,
                37.699765
              ],
              [
                54.822318,
                37.6996842
              ],
              [
                54.8222579,
                37.699602
              ],
              [
                54.8222369,
                37.6994782
              ],
              [
                54.8222493,
                37.699365
              ],
              [
                54.8223037,
                37.6992064
              ],
              [
                54.8223085,
                37.6990962
              ],
              [
                54.8222856,
                37.6989558
              ],
              [
                54.8222121,
                37.6988404
              ],
              [
                54.8220747,
                37.6987407
              ],
              [
                54.8219173,
                37.6987083
              ],
              [
                54.8216597,
                37.6987022
              ],
              [
                54.8213774,
                37.6987098
              ],
              [
                54.821094,
                37.6987566
              ],
              [
                54.8208031,
                37.6988471
              ],
              [
                54.8205331,
                37.6989438
              ],
              [
                54.820223,
                37.6990766
              ],
              [
                54.8198777,
                37.6992381
              ],
              [
                54.8196802,
                37.6993393
              ],
              [
                54.8194942,
                37.6993982
              ],
              [
                54.8192834,
                37.6994163
              ],
              [
                54.819063,
                37.6993801
              ],
              [
                54.8187621,
                37.699274
              ],
              [
                54.8186191,
                37.6992452
              ],
              [
                54.818503,
                37.6992623
              ],
              [
                54.8181226,
                37.6994
              ],
              [
                54.8178514,
                37.6994833
              ],
              [
                54.8176787,
                37.6994939
              ],
              [
                54.8175411,
                37.6994352
              ],
              [
                54.8173873,
                37.6992868
              ],
              [
                54.8173347,
                37.6991812
              ],
              [
                54.8173239,
                37.6990648
              ],
              [
                54.8173981,
                37.6988887
              ],
              [
                54.8175317,
                37.698641
              ],
              [
                54.8176021,
                37.698448
              ],
              [
                54.8175897,
                37.6983529
              ],
              [
                54.8174761,
                37.6982487
              ],
              [
                54.817313,
                37.6982246
              ],
              [
                54.8171193,
                37.6982382
              ],
              [
                54.8166379,
                37.6983524
              ],
              [
                54.8162642,
                37.6985168
              ],
              [
                54.8159742,
                37.6986385
              ],
              [
                54.8158757,
                37.6986598
              ],
              [
                54.8157677,
                37.6986481
              ],
              [
                54.8156117,
                37.6985529
              ],
              [
                54.8155011,
                37.6984345
              ],
              [
                54.8154467,
                37.6983469
              ],
              [
                54.8154114,
                37.6982201
              ],
              [
                54.8154076,
                37.6981016
              ],
              [
                54.8154236,
                37.6979079
              ],
              [
                54.8154546,
                37.697799
              ],
              [
                54.8155545,
                37.6976047
              ],
              [
                54.815647,
                37.6975035
              ],
              [
                54.8157347,
                37.6974522
              ],
              [
                54.8158397,
                37.6974522
              ],
              [
                54.8160705,
                37.6975201
              ],
              [
                54.8164402,
                37.6976311
              ],
              [
                54.8165738,
                37.6976461
              ],
              [
                54.8167761,
                37.6976418
              ],
              [
                54.816938,
                37.6975831
              ],
              [
                54.8171674,
                37.6974582
              ],
              [
                54.8176234,
                37.6973397
              ],
              [
                54.8181388,
                37.6972255
              ],
              [
                54.8182467,
                37.6971636
              ],
              [
                54.818298,
                37.6970547
              ],
              [
                54.8183142,
                37.6969404
              ],
              [
                54.8182454,
                37.6966725
              ],
              [
                54.8181698,
                37.6964035
              ],
              [
                54.8181725,
                37.6962914
              ],
              [
                54.8182265,
                37.696158
              ],
              [
                54.8184383,
                37.6958815
              ],
              [
                54.8185368,
                37.6956968
              ],
              [
                54.8185799,
                37.6955345
              ],
              [
                54.8185489,
                37.6953744
              ],
              [
                54.8184019,
                37.6950851
              ],
              [
                54.818159,
                37.6948
              ],
              [
                54.8180106,
                37.6946292
              ],
              [
                54.8178447,
                37.6943453
              ],
              [
                54.8177367,
                37.6942268
              ],
              [
                54.8174669,
                37.6940688
              ],
              [
                54.817073,
                37.6938222
              ],
              [
                54.8168976,
                37.6936919
              ],
              [
                54.8167734,
                37.6936482
              ],
              [
                54.8166642,
                37.6936418
              ],
              [
                54.8165441,
                37.6936813
              ],
              [
                54.8164658,
                37.6937421
              ],
              [
                54.8163579,
                37.69393
              ],
              [
                54.8162068,
                37.6940901
              ],
              [
                54.8161367,
                37.6941158
              ],
              [
                54.8160017,
                37.6941083
              ],
              [
                54.8159181,
                37.6940624
              ],
              [
                54.8157899,
                37.6939225
              ],
              [
                54.8154985,
                37.6935681
              ],
              [
                54.8152557,
                37.6934154
              ],
              [
                54.81511,
                37.6932959
              ],
              [
                54.8150816,
                37.6932158
              ],
              [
                54.8150749,
                37.6931368
              ],
              [
                54.8151248,
                37.6930364
              ],
              [
                54.8152678,
                37.692824
              ],
              [
                54.8153636,
                37.6926703
              ],
              [
                54.8153784,
                37.6925795
              ],
              [
                54.8153002,
                37.6923884
              ],
              [
                54.8151693,
                37.6921899
              ],
              [
                54.8149737,
                37.6918749
              ],
              [
                54.814882,
                37.6916454
              ],
              [
                54.8148064,
                37.6913742
              ],
              [
                54.8147781,
                37.6911394
              ],
              [
                54.8147754,
                37.6909408
              ],
              [
                54.8146998,
                37.6908073
              ],
              [
                54.8146175,
                37.690739
              ],
              [
                54.8144421,
                37.6906878
              ],
              [
                54.8141602,
                37.6906429
              ],
              [
                54.8136502,
                37.6904657
              ],
              [
                54.8134627,
                37.6903867
              ],
              [
                54.8132805,
                37.6902735
              ],
              [
                54.8129756,
                37.6902266
              ],
              [
                54.8128502,
                37.6902276
              ],
              [
                54.8126114,
                37.6902799
              ],
              [
                54.8123807,
                37.6902767
              ],
              [
                54.8122174,
                37.6902383
              ],
              [
                54.812154,
                37.6901625
              ],
              [
                54.8121378,
                37.6900974
              ],
              [
                54.8121891,
                37.6899319
              ],
              [
                54.81232,
                37.6898091
              ],
              [
                54.8124724,
                37.6896778
              ],
              [
                54.812525,
                37.6895625
              ],
              [
                54.8125034,
                37.6894429
              ],
              [
                54.8123119,
                37.6892508
              ],
              [
                54.8119611,
                37.6890084
              ],
              [
                54.8117128,
                37.6889187
              ],
              [
                54.811381,
                37.6889262
              ],
              [
                54.8110288,
                37.6890458
              ],
              [
                54.8107873,
                37.6891045
              ],
              [
                54.810477,
                37.689128
              ],
              [
                54.8103259,
                37.6890767
              ],
              [
                54.810164,
                37.688954
              ],
              [
                54.809909,
                37.688639
              ],
              [
                54.8095691,
                37.6884308
              ],
              [
                54.8094396,
                37.6882974
              ],
              [
                54.8094315,
                37.6882173
              ],
              [
                54.8094814,
                37.6881095
              ],
              [
                54.8095961,
                37.688023
              ],
              [
                54.8098888,
                37.6879429
              ],
              [
                54.8103084,
                37.6878415
              ],
              [
                54.8105121,
                37.6877379
              ],
              [
                54.8106781,
                37.6876045
              ],
              [
                54.8107455,
                37.6875041
              ],
              [
                54.810983,
                37.6872788
              ],
              [
                54.8113,
                37.6870034
              ],
              [
                54.8115955,
                37.6866639
              ],
              [
                54.8117371,
                37.6864749
              ],
              [
                54.8118478,
                37.6864162
              ],
              [
                54.8119705,
                37.6864172
              ],
              [
                54.8121135,
                37.686445
              ],
              [
                54.8123415,
                37.6865176
              ],
              [
                54.8125641,
                37.6865293
              ],
              [
                54.8127166,
                37.6864909
              ],
              [
                54.8128299,
                37.6864322
              ],
              [
                54.812892,
                37.6863542
              ],
              [
                54.8129122,
                37.686271
              ],
              [
                54.8128718,
                37.6860884
              ],
              [
                54.8127517,
                37.6859122
              ],
              [
                54.8125345,
                37.6857489
              ],
              [
                54.8121635,
                37.6855471
              ],
              [
                54.81181,
                37.6854563
              ],
              [
                54.8115833,
                37.6853688
              ],
              [
                54.8114997,
                37.6852919
              ],
              [
                54.811439,
                37.6852033
              ],
              [
                54.8114376,
                37.6850901
              ],
              [
                54.8115078,
                37.6849428
              ],
              [
                54.8116238,
                37.6848221
              ],
              [
                54.8117695,
                37.6847719
              ],
              [
                54.8119854,
                37.6847645
              ],
              [
                54.8121958,
                37.6848072
              ],
              [
                54.8124711,
                37.6849033
              ],
              [
                54.8126491,
                37.6849353
              ],
              [
                54.8127517,
                37.6849268
              ],
              [
                54.8128353,
                37.6848809
              ],
              [
                54.8129905,
                37.6847111
              ],
              [
                54.8132778,
                37.6843588
              ],
              [
                54.8133588,
                37.6842232
              ],
              [
                54.8133669,
                37.6840854
              ],
              [
                54.8133075,
                37.6838612
              ],
              [
                54.8131132,
                37.6837021
              ],
              [
                54.812896,
                37.6835815
              ],
              [
                54.8127463,
                37.6835655
              ],
              [
                54.8124643,
                37.6834299
              ],
              [
                54.8120852,
                37.6833839
              ],
              [
                54.8116643,
                37.6833274
              ],
              [
                54.8113256,
                37.6833049
              ],
              [
                54.8111071,
                37.6833252
              ],
              [
                54.810562,
                37.6833434
              ],
              [
                54.8101195,
                37.6833284
              ],
              [
                54.8097404,
                37.6832056
              ],
              [
                54.8095286,
                37.6831992
              ],
              [
                54.8093694,
                37.6832355
              ],
              [
                54.8091778,
                37.6833348
              ],
              [
                54.8089808,
                37.6835046
              ],
              [
                54.8087987,
                37.6836199
              ],
              [
                54.8085033,
                37.6838879
              ],
              [
                54.8082253,
                37.6840812
              ],
              [
                54.8080742,
                37.6841303
              ],
              [
                54.8079703,
                37.6841207
              ],
              [
                54.8079015,
                37.6840801
              ],
              [
                54.8078557,
                37.6840085
              ],
              [
                54.8078327,
                37.6839359
              ],
              [
                54.8078368,
                37.6838505
              ],
              [
                54.8078826,
                37.6837299
              ],
              [
                54.8079717,
                37.6836242
              ],
              [
                54.8081228,
                37.6834704
              ],
              [
                54.8081606,
                37.6833519
              ],
              [
                54.8081943,
                37.6831469
              ],
              [
                54.808224,
                37.6829462
              ],
              [
                54.8082901,
                37.6827593
              ],
              [
                54.8083157,
                37.6825543
              ],
              [
                54.8082699,
                37.6824337
              ],
              [
                54.8081187,
                37.6823237
              ],
              [
                54.8079622,
                37.6822981
              ],
              [
                54.8076762,
                37.6822767
              ],
              [
                54.8075386,
                37.6822329
              ],
              [
                54.8074752,
                37.6821828
              ],
              [
                54.8074577,
                37.6821166
              ],
              [
                54.8074698,
                37.6820504
              ],
              [
                54.80754,
                37.6819874
              ],
              [
                54.8077113,
                37.6819265
              ],
              [
                54.8079555,
                37.6818582
              ],
              [
                54.8082334,
                37.6818123
              ],
              [
                54.8085788,
                37.6817909
              ],
              [
                54.808796,
                37.6817535
              ],
              [
                54.8089889,
                37.6816649
              ],
              [
                54.8091711,
                37.6815144
              ],
              [
                54.8092655,
                37.6813681
              ],
              [
                54.80931,
                37.6811834
              ],
              [
                54.8093006,
                37.6810307
              ],
              [
                54.8092372,
                37.6808417
              ],
              [
                54.8090793,
                37.6806591
              ],
              [
                54.8087974,
                37.6804733
              ],
              [
                54.8085151,
                37.6803731
              ],
              [
                54.8082466,
                37.6803015
              ],
              [
                54.8078959,
                37.6801595
              ],
              [
                54.8075707,
                37.6800655
              ],
              [
                54.8074223,
                37.6800399
              ],
              [
                54.8071511,
                37.6800495
              ],
              [
                54.8068287,
                37.6799865
              ],
              [
                54.8066182,
                37.6799139
              ],
              [
                54.8062418,
                37.6799075
              ],
              [
                54.8059234,
                37.6799064
              ],
              [
                54.805717,
                37.6798563
              ],
              [
                54.8054769,
                37.679742
              ],
              [
                54.8052354,
                37.6795498
              ],
              [
                54.8050573,
                37.6793779
              ],
              [
                54.8048306,
                37.679143
              ],
              [
                54.80455,
                37.6789252
              ],
              [
                54.8042478,
                37.6787127
              ],
              [
                54.8041817,
                37.6786283
              ],
              [
                54.8041277,
                37.6785087
              ],
              [
                54.8040306,
                37.6782738
              ],
              [
                54.8038862,
                37.677945
              ],
              [
                54.8037446,
                37.6775798
              ],
              [
                54.8036231,
                37.6772349
              ],
              [
                54.8034626,
                37.6770811
              ],
              [
                54.8033466,
                37.6770384
              ],
              [
                54.8030835,
                37.6769797
              ],
              [
                54.8026882,
                37.6769434
              ],
              [
                54.8023091,
                37.6769252
              ],
              [
                54.801849,
                37.6769177
              ],
              [
                54.8014956,
                37.6769113
              ],
              [
                54.8010503,
                37.6768601
              ],
              [
                54.8006213,
                37.6768152
              ],
              [
                54.8002557,
                37.6767907
              ],
              [
                54.7999548,
                37.6767714
              ],
              [
                54.7997579,
                37.6767202
              ],
              [
                54.7997026,
                37.6766647
              ],
              [
                54.799685,
                37.6765547
              ],
              [
                54.799739,
                37.6763689
              ],
              [
                54.7998645,
                37.6761959
              ],
              [
                54.800141,
                37.6760464
              ],
              [
                54.8004446,
                37.6758948
              ],
              [
                54.8005781,
                37.6757666
              ],
              [
                54.8007616,
                37.6755008
              ],
              [
                54.8009019,
                37.6753918
              ],
              [
                54.8012136,
                37.6752445
              ],
              [
                54.8014672,
                37.6750886
              ],
              [
                54.8018409,
                37.6748942
              ],
              [
                54.8020204,
                37.6747458
              ],
              [
                54.8020824,
                37.6745878
              ],
              [
                54.8021782,
                37.6742941
              ],
              [
                54.8022713,
                37.6739278
              ],
              [
                54.8022794,
                37.6736822
              ],
              [
                54.8022619,
                37.673301
              ],
              [
                54.802305,
                37.673096
              ],
              [
                54.8023792,
                37.6730009
              ],
              [
                54.8025479,
                37.6729678
              ],
              [
                54.8026855,
                37.6729956
              ],
              [
                54.8029971,
                37.6730938
              ],
              [
                54.8030943,
                37.6731003
              ],
              [
                54.8032197,
                37.6730672
              ],
              [
                54.8033155,
                37.6730106
              ],
              [
                54.8034059,
                37.6728504
              ],
              [
                54.8034289,
                37.6727233
              ],
              [
                54.8033614,
                37.6725631
              ],
              [
                54.8032009,
                37.6724211
              ],
              [
                54.8028865,
                37.6722663
              ],
              [
                54.8027017,
                37.6722449
              ],
              [
                54.8024548,
                37.6722876
              ],
              [
                54.8021809,
                37.6724115
              ],
              [
                54.8019462,
                37.6725802
              ],
              [
                54.8016966,
                37.6727703
              ],
              [
                54.8014848,
                37.6728803
              ],
              [
                54.8013539,
                37.6728952
              ],
              [
                54.8011097,
                37.6728685
              ],
              [
                54.8007036,
                37.6727543
              ],
              [
                54.8003569,
                37.6726208
              ],
              [
                54.8000358,
                37.6724563
              ],
              [
                54.7997956,
                37.6723677
              ],
              [
                54.7996891,
                37.6723784
              ],
              [
                54.7995461,
                37.6724328
              ],
              [
                54.7994624,
                37.6725119
              ],
              [
                54.7993855,
                37.6726496
              ],
              [
                54.7993127,
                37.6728781
              ],
              [
                54.799202,
                37.6730629
              ],
              [
                54.7991346,
                37.6731152
              ],
              [
                54.7989241,
                37.6731611
              ],
              [
                54.7986273,
                37.6732252
              ],
              [
                54.7983534,
                37.673316
              ],
              [
                54.7980364,
                37.673443
              ],
              [
                54.7979136,
                37.673443
              ],
              [
                54.7977773,
                37.6733939
              ],
              [
                54.7977328,
                37.6733234
              ],
              [
                54.7977531,
                37.6731996
              ],
              [
                54.7978232,
                37.672971
              ],
              [
                54.7979662,
                37.6726945
              ],
              [
                54.7980634,
                37.6724542
              ],
              [
                54.798116,
                37.6721616
              ],
              [
                54.7981929,
                37.6719907
              ],
              [
                54.7983264,
                37.6718007
              ],
              [
                54.7986327,
                37.671492
              ],
              [
                54.7989093,
                37.6712315
              ],
              [
                54.7991251,
                37.6710211
              ],
              [
                54.7992546,
                37.6708257
              ],
              [
                54.7995177,
                37.6705448
              ],
              [
                54.7997875,
                37.6703163
              ],
              [
                54.7999616,
                37.6701583
              ],
              [
                54.8000412,
                37.6700461
              ],
              [
                54.8000439,
                37.6699169
              ],
              [
                54.8000493,
                37.6696873
              ],
              [
                54.8001019,
                37.669509
              ],
              [
                54.800226,
                37.6693499
              ],
              [
                54.800338,
                37.6693029
              ],
              [
                54.8004743,
                37.6693103
              ],
              [
                54.8005539,
                37.6693509
              ],
              [
                54.800651,
                37.6694257
              ],
              [
                54.8008682,
                37.6695143
              ],
              [
                54.8009991,
                37.6695378
              ],
              [
                54.8011556,
                37.6695004
              ],
              [
                54.8012514,
                37.6694267
              ],
              [
                54.801281,
                37.6692911
              ],
              [
                54.8013222,
                37.6691924
              ],
              [
                54.8013862,
                37.6691124
              ],
              [
                54.8013833,
                37.6690641
              ],
              [
                54.8013375,
                37.6689863
              ],
              [
                54.8013308,
                37.6688179
              ],
              [
                54.8012879,
                37.6687227
              ],
              [
                54.8012354,
                37.6686412
              ],
              [
                54.8011657,
                37.668318
              ],
              [
                54.8010928,
                37.6681984
              ],
              [
                54.8009485,
                37.6679144
              ],
              [
                54.8008743,
                37.6678012
              ],
              [
                54.8008311,
                37.6676453
              ],
              [
                54.8007879,
                37.6675694
              ],
              [
                54.8008054,
                37.6674658
              ],
              [
                54.8008985,
                37.6673783
              ],
              [
                54.8011036,
                37.6673195
              ],
              [
                54.8012776,
                37.6673217
              ],
              [
                54.8014207,
                37.6673505
              ],
              [
                54.8015758,
                37.6674349
              ],
              [
                54.8017202,
                37.6674851
              ],
              [
                54.8019171,
                37.6675822
              ],
              [
                54.802245,
                37.6676527
              ],
              [
                54.8025148,
                37.6676666
              ],
              [
                54.8028116,
                37.6676538
              ],
              [
                54.8031813,
                37.6675684
              ],
              [
                54.8032541,
                37.6675203
              ],
              [
                54.8033364,
                37.667469
              ],
              [
                54.8033756,
                37.6673879
              ],
              [
                54.803354,
                37.667249
              ],
              [
                54.8032217,
                37.6669233
              ],
              [
                54.8030841,
                37.6665869
              ],
              [
                54.8029344,
                37.6662687
              ],
              [
                54.8027738,
                37.6661042
              ],
              [
                54.8024973,
                37.6659291
              ],
              [
                54.8023731,
                37.6657935
              ],
              [
                54.8023002,
                37.6656536
              ],
              [
                54.8022908,
                37.6655276
              ],
              [
                54.8023191,
                37.6652713
              ],
              [
                54.8023947,
                37.6650619
              ],
              [
                54.8024614,
                37.6648022
              ],
              [
                54.8024958,
                37.6645016
              ],
              [
                54.8023987,
                37.664209
              ],
              [
                54.8022957,
                37.66391
              ],
              [
                54.8023057,
                37.6637912
              ],
              [
                54.8023569,
                37.663725
              ],
              [
                54.8024797,
                37.6636695
              ],
              [
                54.8026578,
                37.6636567
              ],
              [
                54.8028049,
                37.6636022
              ],
              [
                54.8028764,
                37.6635477
              ],
              [
                54.8029168,
                37.6634933
              ],
              [
                54.8028993,
                37.6633202
              ],
              [
                54.8028622,
                37.6630885
              ],
              [
                54.8028111,
                37.6626997
              ],
              [
                54.8028287,
                37.6626185
              ],
              [
                54.802973,
                37.6625064
              ],
              [
                54.8032172,
                37.6623088
              ],
              [
                54.8033535,
                37.6620856
              ],
              [
                54.8035801,
                37.661731
              ],
              [
                54.8037596,
                37.6615046
              ],
              [
                54.8039565,
                37.6613839
              ],
              [
                54.8043073,
                37.6612376
              ],
              [
                54.8046608,
                37.6610881
              ],
              [
                54.8047269,
                37.6610325
              ],
              [
                54.8047525,
                37.6609439
              ],
              [
                54.8047512,
                37.6607869
              ],
              [
                54.8047107,
                37.6606395
              ],
              [
                54.8044759,
                37.6603874
              ],
              [
                54.8042628,
                37.6602465
              ],
              [
                54.8038891,
                37.6600563
              ],
              [
                54.8036341,
                37.6599506
              ],
              [
                54.8034938,
                37.6599346
              ],
              [
                54.8033238,
                37.6599709
              ],
              [
                54.8031848,
                37.6600147
              ],
              [
                54.803085,
                37.6600927
              ],
              [
                54.8028988,
                37.6601834
              ],
              [
                54.8027545,
                37.6601909
              ],
              [
                54.8026425,
                37.6602646
              ],
              [
                54.8025264,
                37.6603693
              ],
              [
                54.802235,
                37.6604846
              ],
              [
                54.8019908,
                37.6605562
              ],
              [
                54.8017655,
                37.6605775
              ],
              [
                54.8015429,
                37.6605605
              ],
              [
                54.8011571,
                37.660459
              ],
              [
                54.8007011,
                37.6602764
              ],
              [
                54.8004016,
                37.6601845
              ],
              [
                54.7999833,
                37.6601097
              ],
              [
                54.799646,
                37.6600232
              ],
              [
                54.7995651,
                37.6599794
              ],
              [
                54.7995273,
                37.6599271
              ],
              [
                54.7995314,
                37.6598
              ],
              [
                54.7995853,
                37.659548
              ],
              [
                54.7996083,
                37.6594508
              ],
              [
                54.7995894,
                37.6593397
              ],
              [
                54.7995718,
                37.6591688
              ],
              [
                54.7995341,
                37.6590321
              ],
              [
                54.7994099,
                37.6588003
              ],
              [
                54.799325,
                37.6587544
              ],
              [
                54.7991981,
                37.6586198
              ],
              [
                54.7990254,
                37.658497
              ],
              [
                54.7988716,
                37.6584532
              ],
              [
                54.7986477,
                37.658513
              ],
              [
                54.798305,
                37.6585846
              ],
              [
                54.7980109,
                37.6586102
              ],
              [
                54.7978018,
                37.6585878
              ],
              [
                54.797509,
                37.6584863
              ],
              [
                54.7971717,
                37.6583293
              ],
              [
                54.797022,
                37.6582246
              ],
              [
                54.7969923,
                37.6581157
              ],
              [
                54.7970071,
                37.6580228
              ],
              [
                54.7970989,
                37.657932
              ],
              [
                54.7972608,
                37.6577942
              ],
              [
                54.797478,
                37.6576756
              ],
              [
                54.7975724,
                37.6575998
              ],
              [
                54.7976156,
                37.6574909
              ],
              [
                54.7976008,
                37.6574011
              ],
              [
                54.7974888,
                37.6573029
              ],
              [
                54.7972608,
                37.6572463
              ],
              [
                54.7969788,
                37.657132
              ],
              [
                54.7966753,
                37.6570156
              ],
              [
                54.7963177,
                37.6568906
              ],
              [
                54.7959872,
                37.6567945
              ],
              [
                54.7956513,
                37.6567913
              ],
              [
                54.7952546,
                37.6567699
              ],
              [
                54.795032,
                37.6567347
              ],
              [
                54.794916,
                37.6566919
              ],
              [
                54.7948526,
                37.6566225
              ],
              [
                54.7947946,
                37.6564142
              ],
              [
                54.7947001,
                37.6561493
              ],
              [
                54.7946232,
                37.6558674
              ],
              [
                54.7945018,
                37.6556324
              ],
              [
                54.7943898,
                37.655501
              ],
              [
                54.7943615,
                37.6553931
              ],
              [
                54.7943547,
                37.6552639
              ],
              [
                54.7943993,
                37.6551357
              ],
              [
                54.7945706,
                37.654921
              ],
              [
                54.7946623,
                37.6546689
              ],
              [
                54.7946704,
                37.654497
              ],
              [
                54.7945962,
                37.6542225
              ],
              [
                54.7944654,
                37.6538796
              ],
              [
                54.7942967,
                37.6536297
              ],
              [
                54.7941308,
                37.6535698
              ],
              [
                54.7940121,
                37.6535634
              ],
              [
                54.793865,
                37.6535827
              ],
              [
                54.7936599,
                37.6536702
              ],
              [
                54.79344,
                37.653808
              ],
              [
                54.7930528,
                37.6540195
              ],
              [
                54.7925887,
                37.6542139
              ],
              [
                54.792161,
                37.6544521
              ],
              [
                54.7918116,
                37.6546412
              ],
              [
                54.7916956,
                37.6546486
              ],
              [
                54.7915445,
                37.6546348
              ],
              [
                54.7914635,
                37.6545643
              ],
              [
                54.7914352,
                37.6544607
              ],
              [
                54.7914231,
                37.6543368
              ],
              [
                54.7914541,
                37.654215
              ],
              [
                54.7915674,
                37.6540922
              ],
              [
                54.7917819,
                37.6538924
              ],
              [
                54.7919169,
                37.6537536
              ],
              [
                54.791983,
                37.6536062
              ],
              [
                54.7920464,
                37.6533316
              ],
              [
                54.7920909,
                37.6530486
              ],
              [
                54.7922083,
                37.6528531
              ],
              [
                54.7924093,
                37.6527089
              ],
              [
                54.7927101,
                37.652569
              ],
              [
                54.7931715,
                37.652381
              ],
              [
                54.7935979,
                37.6522037
              ],
              [
                54.7941227,
                37.6520883
              ],
              [
                54.7943858,
                37.6519655
              ],
              [
                54.7944816,
                37.6518597
              ],
              [
                54.7945045,
                37.6517123
              ],
              [
                54.7944532,
                37.6515126
              ],
              [
                54.7943048,
                37.6513054
              ],
              [
                54.7942131,
                37.6511088
              ],
              [
                54.7941955,
                37.6509999
              ],
              [
                54.7942104,
                37.6509197
              ],
              [
                54.7942981,
                37.6508225
              ],
              [
                54.794522,
                37.650689
              ],
              [
                54.7948755,
                37.6505053
              ],
              [
                54.795005,
                37.6504113
              ],
              [
                54.7950738,
                37.6503141
              ],
              [
                54.7950954,
                37.6501742
              ],
              [
                54.7950806,
                37.6499253
              ],
              [
                54.794978,
                37.6496839
              ],
              [
                54.7948742,
                37.6495952
              ],
              [
                54.7946542,
                37.6495311
              ],
              [
                54.7942994,
                37.6494798
              ],
              [
                54.793869,
                37.649388
              ],
              [
                54.7935493,
                37.6493111
              ],
              [
                54.7931823,
                37.6492277
              ],
              [
                54.7929584,
                37.6491188
              ],
              [
                54.7926508,
                37.648919
              ],
              [
                54.7923459,
                37.6487524
              ],
              [
                54.7921476,
                37.6487011
              ],
              [
                54.7919344,
                37.6486872
              ],
              [
                54.7918062,
                37.6487033
              ],
              [
                54.7916619,
                37.6487545
              ],
              [
                54.7915512,
                37.6488378
              ],
              [
                54.7914946,
                37.6489457
              ],
              [
                54.7913516,
                37.6492042
              ],
              [
                54.7912315,
                37.6494659
              ],
              [
                54.791187,
                37.6496272
              ],
              [
                54.7912045,
                37.6498975
              ],
              [
                54.7912976,
                37.6500225
              ],
              [
                54.7914163,
                37.6501507
              ],
              [
                54.7915175,
                37.6503333
              ],
              [
                54.7915755,
                37.6505245
              ],
              [
                54.7916254,
                37.6507948
              ],
              [
                54.7916362,
                37.6510052
              ],
              [
                54.7916025,
                37.65119
              ],
              [
                54.7915404,
                37.6512829
              ],
              [
                54.7914541,
                37.651347
              ],
              [
                54.7913111,
                37.6513769
              ],
              [
                54.7911654,
                37.6513748
              ],
              [
                54.7909037,
                37.6513246
              ],
              [
                54.7907998,
                37.651268
              ],
              [
                54.7906352,
                37.6510992
              ],
              [
                54.7904004,
                37.6509059
              ],
              [
                54.7901225,
                37.6506452
              ],
              [
                54.7898311,
                37.6504337
              ],
              [
                54.7895248,
                37.6502543
              ],
              [
                54.7891849,
                37.6500577
              ],
              [
                54.7888759,
                37.6499167
              ],
              [
                54.7887032,
                37.6497747
              ],
              [
                54.7885494,
                37.6495728
              ],
              [
                54.7884455,
                37.6494072
              ],
              [
                54.7884104,
                37.6492758
              ],
              [
                54.7883929,
                37.648981
              ],
              [
                54.7883875,
                37.6486798
              ],
              [
                54.7883821,
                37.6483411
              ],
              [
                54.7883214,
                37.6478797
              ],
              [
                54.7883228,
                37.6476895
              ],
              [
                54.7883821,
                37.6474331
              ],
              [
                54.7885049,
                37.6472932
              ],
              [
                54.788714,
                37.6471298
              ],
              [
                54.7889879,
                37.6469984
              ],
              [
                54.7893427,
                37.6468552
              ],
              [
                54.7896557,
                37.6467805
              ],
              [
                54.7900766,
                37.6468008
              ],
              [
                54.7906055,
                37.6468574
              ],
              [
                54.790905,
                37.646883
              ],
              [
                54.7910467,
                37.6468563
              ],
              [
                54.7912166,
                37.6467676
              ],
              [
                54.7913003,
                37.6466544
              ],
              [
                54.7913057,
                37.6465252
              ],
              [
                54.7912639,
                37.6463478
              ],
              [
                54.7911101,
                37.6461513
              ],
              [
                54.790851,
                37.6459536
              ],
              [
                54.7905556,
                37.6458383
              ],
              [
                54.7901927,
                37.6457592
              ],
              [
                54.7898662,
                37.6457229
              ],
              [
                54.7894682,
                37.6456759
              ],
              [
                54.789166,
                37.6456161
              ],
              [
                54.7891026,
                37.6455637
              ],
              [
                54.7890676,
                37.6454439
              ],
              [
                54.7890648,
                37.6453608
              ],
              [
                54.7890924,
                37.645243
              ],
              [
                54.7892098,
                37.6450277
              ],
              [
                54.7892546,
                37.6449114
              ],
              [
                54.7892492,
                37.6447127
              ],
              [
                54.7891901,
                37.6446151
              ],
              [
                54.7890651,
                37.6445433
              ],
              [
                54.7888362,
                37.6445124
              ],
              [
                54.7886249,
                37.6445394
              ],
              [
                54.7884528,
                37.6445917
              ],
              [
                54.7882896,
                37.6446654
              ],
              [
                54.7881412,
                37.6448097
              ],
              [
                54.7879645,
                37.6450019
              ],
              [
                54.7878525,
                37.6451536
              ],
              [
                54.7876596,
                37.6455307
              ],
              [
                54.7875284,
                37.6456826
              ],
              [
                54.7874101,
                37.64574
              ],
              [
                54.7872784,
                37.6457551
              ],
              [
                54.7871687,
                37.6457294
              ],
              [
                54.787101,
                37.6456667
              ],
              [
                54.7870352,
                37.6455648
              ],
              [
                54.787018,
                37.6454341
              ],
              [
                54.7869951,
                37.645215
              ],
              [
                54.7869102,
                37.6449257
              ],
              [
                54.7868396,
                37.6447913
              ],
              [
                54.786686,
                37.644619
              ],
              [
                54.7864828,
                37.6444582
              ],
              [
                54.786312,
                37.6443078
              ],
              [
                54.7861766,
                37.6441696
              ],
              [
                54.7860287,
                37.6440631
              ],
              [
                54.7859619,
                37.6439717
              ],
              [
                54.7859495,
                37.6438946
              ],
              [
                54.7859705,
                37.6438131
              ],
              [
                54.7860793,
                37.6436673
              ],
              [
                54.7862061,
                37.6435358
              ],
              [
                54.7863378,
                37.6434867
              ],
              [
                54.7864294,
                37.6434701
              ],
              [
                54.7866364,
                37.6434739
              ],
              [
                54.7868949,
                37.643495
              ],
              [
                54.7870409,
                37.6434973
              ],
              [
                54.7872116,
                37.6434505
              ],
              [
                54.7873194,
                37.643384
              ],
              [
                54.7873939,
                37.6432745
              ],
              [
                54.7874034,
                37.6431702
              ],
              [
                54.7874005,
                37.6429731
              ],
              [
                54.7872861,
                37.6427238
              ],
              [
                54.7871859,
                37.6424481
              ],
              [
                54.7870953,
                37.6422116
              ],
              [
                54.7870399,
                37.6420152
              ],
              [
                54.7870247,
                37.641914
              ],
              [
                54.7870361,
                37.6417826
              ],
              [
                54.7870895,
                37.6415914
              ],
              [
                54.7871849,
                37.6414592
              ],
              [
                54.7873853,
                37.6413255
              ],
              [
                54.7876362,
                37.6411503
              ],
              [
                54.7878422,
                37.6409901
              ],
              [
                54.7879233,
                37.6409252
              ],
              [
                54.7879701,
                37.6408164
              ],
              [
                54.7879853,
                37.6407038
              ],
              [
                54.7879577,
                37.6405558
              ],
              [
                54.7878871,
                37.6404477
              ],
              [
                54.7877783,
                37.6403918
              ],
              [
                54.7875999,
                37.6403684
              ],
              [
                54.7872994,
                37.6403737
              ],
              [
                54.7870762,
                37.640348
              ],
              [
                54.786467,
                37.6402264
              ],
              [
                54.7859368,
                37.6401452
              ],
              [
                54.7854511,
                37.6400405
              ],
              [
                54.7850741,
                37.639918
              ],
              [
                54.7849978,
                37.6398575
              ],
              [
                54.7849453,
                37.6397744
              ],
              [
                54.7849319,
                37.6396966
              ],
              [
                54.784951,
                37.6396317
              ],
              [
                54.7850378,
                37.6395047
              ],
              [
                54.7851533,
                37.6394269
              ],
              [
                54.7853269,
                37.6392728
              ],
              [
                54.785594,
                37.6391202
              ],
              [
                54.7858478,
                37.639022
              ],
              [
                54.7861883,
                37.6389042
              ],
              [
                54.7865623,
                37.6387962
              ],
              [
                54.7868103,
                37.638735
              ],
              [
                54.7870746,
                37.6386473
              ],
              [
                54.7873045,
                37.6386065
              ],
              [
                54.7875592,
                37.638599
              ],
              [
                54.7877347,
                37.6386315
              ],
              [
                54.7879732,
                37.6386322
              ],
              [
                54.7881507,
                37.6386065
              ],
              [
                54.7883071,
                37.6385272
              ],
              [
                54.7883777,
                37.6384388
              ],
              [
                54.788414,
                37.6382938
              ],
              [
                54.7884359,
                37.6380838
              ],
              [
                54.7884207,
                37.6378715
              ],
              [
                54.7882911,
                37.6377038
              ],
              [
                54.7880416,
                37.6375392
              ],
              [
                54.7877194,
                37.6373151
              ],
              [
                54.7875153,
                37.6371504
              ],
              [
                54.7872587,
                37.6369736
              ],
              [
                54.7870707,
                37.636886
              ],
              [
                54.7869171,
                37.636852
              ],
              [
                54.7866977,
                37.6368626
              ],
              [
                54.7865184,
                37.6369185
              ],
              [
                54.786215,
                37.6370801
              ],
              [
                54.7859526,
                37.6372184
              ],
              [
                54.7857132,
                37.6372841
              ],
              [
                54.7854499,
                37.6373166
              ],
              [
                54.7852858,
                37.6373158
              ],
              [
                54.7851608,
                37.6372698
              ],
              [
                54.7850578,
                37.6371655
              ],
              [
                54.7849557,
                37.6369585
              ],
              [
                54.7849195,
                37.636787
              ],
              [
                54.7848813,
                37.6365385
              ],
              [
                54.7848355,
                37.6362839
              ],
              [
                54.7846615,
                37.6358544
              ],
              [
                54.7845131,
                37.6357005
              ],
              [
                54.7841461,
                37.635458
              ],
              [
                54.7840153,
                37.6353576
              ],
              [
                54.7837846,
                37.6351845
              ],
              [
                54.7834621,
                37.6349463
              ],
              [
                54.7830857,
                37.6347401
              ],
              [
                54.782874,
                37.6345801
              ],
              [
                54.7827882,
                37.6344555
              ],
              [
                54.7827548,
                37.6343399
              ],
              [
                54.7827174,
                37.6340436
              ],
              [
                54.7827147,
                37.6337188
              ],
              [
                54.782766,
                37.6334934
              ],
              [
                54.7828887,
                37.6333951
              ],
              [
                54.7831343,
                37.633284
              ],
              [
                54.7833097,
                37.6332049
              ],
              [
                54.7834284,
                37.6331782
              ],
              [
                54.7836523,
                37.63319
              ],
              [
                54.7838534,
                37.6332669
              ],
              [
                54.7840679,
                37.6333502
              ],
              [
                54.7843134,
                37.633393
              ],
              [
                54.7845684,
                37.6334015
              ],
              [
                54.7848058,
                37.6333609
              ],
              [
                54.7849016,
                37.6332957
              ],
              [
                54.7849475,
                37.6331964
              ],
              [
                54.7849124,
                37.6328908
              ],
              [
                54.7848958,
                37.6326107
              ],
              [
                54.7848988,
                37.6324438
              ],
              [
                54.784966,
                37.6322647
              ],
              [
                54.7850996,
                37.6320941
              ],
              [
                54.7853083,
                37.6319864
              ],
              [
                54.7855405,
                37.6319429
              ],
              [
                54.7857941,
                37.6319646
              ],
              [
                54.7861424,
                37.6320276
              ],
              [
                54.7864113,
                37.6320856
              ],
              [
                54.7866099,
                37.6321002
              ],
              [
                54.7867505,
                37.6320832
              ],
              [
                54.7869308,
                37.6320276
              ],
              [
                54.7871574,
                37.6317963
              ],
              [
                54.7867384,
                37.631387
              ],
              [
                54.7864656,
                37.6311063
              ],
              [
                54.7862887,
                37.6309063
              ],
              [
                54.7861809,
                37.6307605
              ],
              [
                54.7861383,
                37.6306603
              ],
              [
                54.786175,
                37.6305418
              ],
              [
                54.7864592,
                37.6303377
              ],
              [
                54.7867189,
                37.6302223
              ],
              [
                54.7871039,
                37.6301522
              ],
              [
                54.7872903,
                37.6300844
              ],
              [
                54.7877525,
                37.6298503
              ],
              [
                54.7889751,
                37.6278814
              ],
              [
                54.7883832,
                37.6276031
              ],
              [
                54.7874372,
                37.6278118
              ],
              [
                54.7871956,
                37.6277698
              ],
              [
                54.7880962,
                37.6262098
              ],
              [
                54.7888087,
                37.6260146
              ],
              [
                54.7890018,
                37.6254197
              ],
              [
                54.7893695,
                37.6246523
              ],
              [
                54.7893721,
                37.6244068
              ],
              [
                54.7876529,
                37.6237272
              ],
              [
                54.7868383,
                37.6230244
              ],
              [
                54.7869625,
                37.621994
              ],
              [
                54.7871539,
                37.6217855
              ],
              [
                54.7876474,
                37.621692
              ],
              [
                54.7882967,
                37.6219518
              ],
              [
                54.788789,
                37.6221421
              ],
              [
                54.7892781,
                37.6221999
              ],
              [
                54.7896087,
                37.6220711
              ],
              [
                54.7897255,
                37.6214779
              ],
              [
                54.7900971,
                37.6208512
              ],
              [
                54.7898002,
                37.6204137
              ],
              [
                54.7890444,
                37.620413
              ],
              [
                54.7889245,
                37.6202761
              ],
              [
                54.7893856,
                37.6186714
              ],
              [
                54.7896701,
                37.618565
              ],
              [
                54.7904334,
                37.6185406
              ],
              [
                54.7912663,
                37.6181399
              ],
              [
                54.7914896,
                37.6181226
              ],
              [
                54.7919237,
                37.6186797
              ],
              [
                54.7923584,
                37.6189491
              ],
              [
                54.7928012,
                37.6188838
              ],
              [
                54.7932561,
                37.6182766
              ],
              [
                54.7937845,
                37.6178912
              ],
              [
                54.7947137,
                37.6178599
              ],
              [
                54.7950648,
                37.6175058
              ],
              [
                54.7948333,
                37.6169197
              ],
              [
                54.7950973,
                37.616726
              ],
              [
                54.7959804,
                37.6165194
              ],
              [
                54.7968345,
                37.6159329
              ],
              [
                54.7968913,
                37.6150216
              ],
              [
                54.7971733,
                37.6144321
              ],
              [
                54.797555,
                37.6142383
              ],
              [
                54.7979084,
                37.6142463
              ],
              [
                54.7983592,
                37.6147717
              ],
              [
                54.8001264,
                37.6160606
              ],
              [
                54.8007365,
                37.6153098
              ],
              [
                54.8021892,
                37.615266
              ],
              [
                54.8031034,
                37.6149139
              ],
              [
                54.804084,
                37.6142958
              ],
              [
                54.8055281,
                37.6142746
              ],
              [
                54.8076713,
                37.6139131
              ],
              [
                54.8101965,
                37.6135035
              ],
              [
                54.8110786,
                37.6125735
              ],
              [
                54.8127063,
                37.612366
              ],
              [
                54.812963,
                37.6117903
              ],
              [
                54.812704,
                37.6100055
              ],
              [
                54.8129248,
                37.6087765
              ],
              [
                54.8136546,
                37.6083852
              ],
              [
                54.8137321,
                37.6083436
              ],
              [
                54.8151658,
                37.6079309
              ],
              [
                54.8159685,
                37.6070307
              ],
              [
                54.8167764,
                37.6048279
              ],
              [
                54.8168046,
                37.6013276
              ],
              [
                54.8190261,
                37.6002549
              ],
              [
                54.8183857,
                37.598404
              ],
              [
                54.8170222,
                37.5959703
              ],
              [
                54.8167633,
                37.5942852
              ],
              [
                54.8171423,
                37.5930715
              ],
              [
                54.8160294,
                37.5903124
              ],
              [
                54.814243,
                37.5896108
              ],
              [
                54.8121358,
                37.585699
              ],
              [
                54.8109679,
                37.5849522
              ],
              [
                54.8101923,
                37.5834813
              ],
              [
                54.8093726,
                37.576348
              ],
              [
                54.8090007,
                37.5759831
              ],
              [
                54.8090411,
                37.574928
              ],
              [
                54.8105229,
                37.5731792
              ],
              [
                54.8098895,
                37.5717198
              ],
              [
                54.8099105,
                37.5705603
              ],
              [
                54.8085215,
                37.5702325
              ],
              [
                54.8079692,
                37.5695909
              ],
              [
                54.8085582,
                37.5674694
              ],
              [
                54.8084275,
                37.5665882
              ],
              [
                54.8069275,
                37.5664153
              ],
              [
                54.8065061,
                37.5654926
              ],
              [
                54.8033921,
                37.5654119
              ],
              [
                54.8031233,
                37.5651399
              ],
              [
                54.80239,
                37.5623676
              ],
              [
                54.8029714,
                37.5609594
              ],
              [
                54.8053905,
                37.5614471
              ],
              [
                54.8060931,
                37.5634241
              ],
              [
                54.8074944,
                37.5619653
              ],
              [
                54.8078242,
                37.5607602
              ],
              [
                54.8067764,
                37.5602502
              ],
              [
                54.8049888,
                37.5604764
              ],
              [
                54.8041238,
                37.5599727
              ],
              [
                54.8044484,
                37.559503
              ],
              [
                54.8051172,
                37.5590408
              ],
              [
                54.8061531,
                37.5581021
              ],
              [
                54.8064318,
                37.5561958
              ],
              [
                54.8040357,
                37.5550571
              ],
              [
                54.8040436,
                37.5546136
              ],
              [
                54.8049025,
                37.5543044
              ],
              [
                54.8035463,
                37.5518841
              ],
              [
                54.8035328,
                37.5506004
              ],
              [
                54.8029627,
                37.550399
              ],
              [
                54.8022807,
                37.5511144
              ],
              [
                54.8001715,
                37.5516419
              ],
              [
                54.7996639,
                37.5501229
              ],
              [
                54.7991971,
                37.5498901
              ],
              [
                54.7978775,
                37.5509522
              ],
              [
                54.7970718,
                37.5513025
              ],
              [
                54.796528,
                37.5501085
              ],
              [
                54.7965233,
                37.5498405
              ],
              [
                54.7977342,
                37.5484633
              ],
              [
                54.7993949,
                37.5475836
              ],
              [
                54.7964496,
                37.5462751
              ],
              [
                54.7964388,
                37.5457489
              ],
              [
                54.798552,
                37.5442571
              ],
              [
                54.798599,
                37.5437435
              ],
              [
                54.7965427,
                37.5435383
              ],
              [
                54.7965308,
                37.5426172
              ],
              [
                54.7982526,
                37.5411696
              ],
              [
                54.7980053,
                37.5385113
              ],
              [
                54.7976807,
                37.5361679
              ],
              [
                54.7983946,
                37.535595
              ],
              [
                54.7982744,
                37.5350136
              ],
              [
                54.7991551,
                37.5345115
              ],
              [
                54.7995544,
                37.5337625
              ],
              [
                54.7987309,
                37.5316494
              ],
              [
                54.7994145,
                37.5313458
              ],
              [
                54.7998962,
                37.5307598
              ],
              [
                54.7996037,
                37.5298588
              ],
              [
                54.7973981,
                37.5285076
              ],
              [
                54.7981074,
                37.526607
              ],
              [
                54.7999263,
                37.5267807
              ],
              [
                54.8000678,
                37.5262037
              ],
              [
                54.7985416,
                37.5242277
              ],
              [
                54.7990254,
                37.5229165
              ],
              [
                54.7985684,
                37.5220193
              ],
              [
                54.7968818,
                37.521673
              ],
              [
                54.7953701,
                37.5226715
              ],
              [
                54.7945967,
                37.5225463
              ],
              [
                54.7932371,
                37.5211325
              ],
              [
                54.7858556,
                37.5193774
              ],
              [
                54.7843485,
                37.5199032
              ],
              [
                54.782604,
                37.5173542
              ],
              [
                54.782206,
                37.5183312
              ],
              [
                54.7808225,
                37.5190434
              ],
              [
                54.7805239,
                37.5190594
              ],
              [
                54.7801229,
                37.5173781
              ],
              [
                54.7791313,
                37.5157539
              ],
              [
                54.7759934,
                37.5154468
              ],
              [
                54.77564,
                37.5148184
              ],
              [
                54.7752033,
                37.5146276
              ],
              [
                54.7739329,
                37.5157188
              ],
              [
                54.7736736,
                37.5158015
              ],
              [
                54.7733827,
                37.5155675
              ],
              [
                54.7734911,
                37.5144787
              ],
              [
                54.7744881,
                37.5136061
              ],
              [
                54.7745615,
                37.513012
              ],
              [
                54.7742292,
                37.5128733
              ],
              [
                54.7721684,
                37.5132062
              ],
              [
                54.7720165,
                37.5125172
              ],
              [
                54.7707021,
                37.5117726
              ],
              [
                54.7698284,
                37.5108213
              ],
              [
                54.7698521,
                37.5102189
              ],
              [
                54.7710214,
                37.5093577
              ],
              [
                54.7724561,
                37.5097354
              ],
              [
                54.7743941,
                37.5096644
              ],
              [
                54.7745072,
                37.5095206
              ],
              [
                54.7717161,
                37.5070842
              ],
              [
                54.7709205,
                37.5068959
              ],
              [
                54.7695379,
                37.506285
              ],
              [
                54.7695373,
                37.5059346
              ],
              [
                54.7702078,
                37.505087
              ],
              [
                54.771017,
                37.5046197
              ],
              [
                54.7710459,
                37.5043454
              ],
              [
                54.7702163,
                37.5041333
              ],
              [
                54.7706309,
                37.5036686
              ],
              [
                54.7715724,
                37.5031222
              ],
              [
                54.7715529,
                37.5028432
              ],
              [
                54.7709418,
                37.5025281
              ],
              [
                54.7705365,
                37.5023274
              ],
              [
                54.7705512,
                37.5010754
              ],
              [
                54.7705652,
                37.5005878
              ],
              [
                54.7705053,
                37.5001137
              ],
              [
                54.7700233,
                37.4996228
              ],
              [
                54.769854,
                37.4991785
              ],
              [
                54.7700299,
                37.4984861
              ],
              [
                54.7700624,
                37.4979848
              ],
              [
                54.7696912,
                37.4976128
              ],
              [
                54.7691831,
                37.4976806
              ],
              [
                54.7680941,
                37.4977272
              ],
              [
                54.766402,
                37.4980475
              ],
              [
                54.7660308,
                37.4983213
              ],
              [
                54.7662978,
                37.4989466
              ],
              [
                54.7664997,
                37.4995511
              ],
              [
                54.7662132,
                37.4999025
              ],
              [
                54.7660012,
                37.5000948
              ],
              [
                54.7645707,
                37.5003971
              ],
              [
                54.7635604,
                37.4997952
              ],
              [
                54.763565,
                37.4994079
              ],
              [
                54.7639262,
                37.4983228
              ],
              [
                54.763917,
                37.4974752
              ],
              [
                54.7636039,
                37.4970586
              ],
              [
                54.7627501,
                37.4969032
              ],
              [
                54.761817,
                37.4968102
              ],
              [
                54.7611814,
                37.4970586
              ],
              [
                54.7596794,
                37.49778
              ],
              [
                54.7587814,
                37.4981965
              ],
              [
                54.7584238,
                37.4982235
              ],
              [
                54.7583208,
                37.4981783
              ],
              [
                54.7579291,
                37.4980836
              ],
              [
                54.7575794,
                37.4977289
              ],
              [
                54.7572938,
                37.4974206
              ],
              [
                54.7572662,
                37.4971698
              ],
              [
                54.7575702,
                37.4966217
              ],
              [
                54.7577197,
                37.4961041
              ],
              [
                54.7580605,
                37.4955341
              ],
              [
                54.7578824,
                37.4947706
              ],
              [
                54.7578639,
                37.4943248
              ],
              [
                54.7581495,
                37.4938133
              ],
              [
                54.7580666,
                37.4932944
              ],
              [
                54.7578639,
                37.4928047
              ],
              [
                54.7575968,
                37.4925563
              ],
              [
                54.7573481,
                37.4924539
              ],
              [
                54.7569981,
                37.4924466
              ],
              [
                54.7565929,
                37.492644
              ],
              [
                54.7561747,
                37.4930782
              ],
              [
                54.7558814,
                37.4936815
              ],
              [
                54.7556626,
                37.4941933
              ],
              [
                54.7554139,
                37.4942371
              ],
              [
                54.7551468,
                37.4941056
              ],
              [
                54.7546634,
                37.4940122
              ],
              [
                54.7543638,
                37.4938623
              ],
              [
                54.7540838,
                37.4935006
              ],
              [
                54.7538428,
                37.4930665
              ],
              [
                54.7535888,
                37.4927771
              ],
              [
                54.7532114,
                37.4925225
              ],
              [
                54.7525518,
                37.492252
              ],
              [
                54.7520437,
                37.4921332
              ],
              [
                54.7514836,
                37.492035
              ],
              [
                54.751423,
                37.4919543
              ],
              [
                54.7514641,
                37.4917094
              ],
              [
                54.7513849,
                37.4915582
              ],
              [
                54.7512491,
                37.4914717
              ],
              [
                54.7506458,
                37.4914344
              ],
              [
                54.7500182,
                37.4913477
              ],
              [
                54.7496339,
                37.4916009
              ],
              [
                54.7492366,
                37.4918593
              ],
              [
                54.7485853,
                37.4921073
              ],
              [
                54.7481945,
                37.4925311
              ],
              [
                54.7477517,
                37.4925621
              ],
              [
                54.7471394,
                37.4923244
              ],
              [
                54.7466359,
                37.4919905
              ],
              [
                54.74647,
                37.4917952
              ],
              [
                54.7463318,
                37.4914225
              ],
              [
                54.7461937,
                37.4912654
              ],
              [
                54.7458253,
                37.4912398
              ],
              [
                54.7453141,
                37.4913238
              ],
              [
                54.744614,
                37.4915321
              ],
              [
                54.7438726,
                37.4917915
              ],
              [
                54.7434627,
                37.4922008
              ],
              [
                54.7432622,
                37.4925848
              ],
              [
                54.743075,
                37.4930732
              ],
              [
                54.7428424,
                37.4932526
              ],
              [
                54.7422133,
                37.4933507
              ],
              [
                54.7414797,
                37.4935181
              ],
              [
                54.7410929,
                37.4935181
              ],
              [
                54.7406231,
                37.493509
              ],
              [
                54.7403767,
                37.4934487
              ],
              [
                54.7401852,
                37.4932513
              ],
              [
                54.740076,
                37.4930558
              ],
              [
                54.7401635,
                37.4926667
              ],
              [
                54.740293,
                37.4923828
              ],
              [
                54.740445,
                37.4921727
              ],
              [
                54.7404283,
                37.4918463
              ],
              [
                54.740251,
                37.4917312
              ],
              [
                54.7399163,
                37.4916355
              ],
              [
                54.7384578,
                37.4916129
              ],
              [
                54.7375567,
                37.49157
              ],
              [
                54.736953,
                37.4916057
              ],
              [
                54.7362534,
                37.4918441
              ],
              [
                54.7358392,
                37.4920514
              ],
              [
                54.735304,
                37.4922385
              ],
              [
                54.7349599,
                37.492193
              ],
              [
                54.7345139,
                37.4919857
              ],
              [
                54.7341443,
                37.4918492
              ],
              [
                54.7339103,
                37.491944
              ],
              [
                54.7335645,
                37.4922738
              ],
              [
                54.7333288,
                37.4924912
              ],
              [
                54.7328764,
                37.4927642
              ],
              [
                54.732647,
                37.4927238
              ],
              [
                54.7325705,
                37.4925165
              ],
              [
                54.7326088,
                37.492284
              ],
              [
                54.7326534,
                37.4919705
              ],
              [
                54.7326406,
                37.491647
              ],
              [
                54.7324176,
                37.4915155
              ],
              [
                54.7321245,
                37.4914852
              ],
              [
                54.7315511,
                37.4915458
              ],
              [
                54.7308757,
                37.4915964
              ],
              [
                54.7304233,
                37.4915357
              ],
              [
                54.7300027,
                37.4913891
              ],
              [
                54.7297479,
                37.4912021
              ],
              [
                54.7296077,
                37.4910049
              ],
              [
                54.7294739,
                37.490651
              ],
              [
                54.7293528,
                37.4902516
              ],
              [
                54.7291298,
                37.4898522
              ],
              [
                54.7288048,
                37.4896702
              ],
              [
                54.7286034,
                37.4895302
              ],
              [
                54.7286047,
                37.4894153
              ],
              [
                54.7289488,
                37.4891828
              ],
              [
                54.729535,
                37.4890867
              ],
              [
                54.7301849,
                37.4891625
              ],
              [
                54.7305162,
                37.4893698
              ],
              [
                54.7310274,
                37.4896232
              ],
              [
                54.7317122,
                37.4895088
              ],
              [
                54.7321898,
                37.4893801
              ],
              [
                54.7328206,
                37.4894015
              ],
              [
                54.7332261,
                37.4892657
              ],
              [
                54.7334243,
                37.489137
              ],
              [
                54.7332396,
                37.4886365
              ],
              [
                54.733181,
                37.4885185
              ],
              [
                54.7329017,
                37.4884005
              ],
              [
                54.7326043,
                37.4882075
              ],
              [
                54.7321988,
                37.4881002
              ],
              [
                54.7316582,
                37.4880216
              ],
              [
                54.7310094,
                37.4880144
              ],
              [
                54.7303876,
                37.4880931
              ],
              [
                54.7297478,
                37.4881574
              ],
              [
                54.7293089,
                37.4880568
              ],
              [
                54.7289881,
                37.4878453
              ],
              [
                54.7284671,
                37.4878002
              ],
              [
                54.7276478,
                37.4877498
              ],
              [
                54.7273944,
                37.4875319
              ],
              [
                54.7275601,
                37.4871931
              ],
              [
                54.7278978,
                37.486819
              ],
              [
                54.7285031,
                37.4864752
              ],
              [
                54.7288599,
                37.4862932
              ],
              [
                54.7290256,
                37.4861617
              ],
              [
                54.7290383,
                37.4860303
              ],
              [
                54.7288917,
                37.4858533
              ],
              [
                54.7284266,
                37.48556
              ],
              [
                54.7280583,
                37.4852033
              ],
              [
                54.7276238,
                37.4849685
              ],
              [
                54.7272224,
                37.4847511
              ],
              [
                54.7269802,
                37.4845033
              ],
              [
                54.7258015,
                37.4830927
              ],
              [
                54.7254574,
                37.4826275
              ],
              [
                54.7253491,
                37.4822483
              ],
              [
                54.7251579,
                37.4820208
              ],
              [
                54.7247246,
                37.4817629
              ],
              [
                54.7243551,
                37.481505
              ],
              [
                54.7238517,
                37.4813786
              ],
              [
                54.7233352,
                37.4812611
              ],
              [
                54.7233118,
                37.4810644
              ],
              [
                54.7235613,
                37.4808688
              ],
              [
                54.7237326,
                37.480522
              ],
              [
                54.723701,
                37.4801823
              ],
              [
                54.7235073,
                37.4799213
              ],
              [
                54.7232415,
                37.4795852
              ],
              [
                54.7231378,
                37.4793886
              ],
              [
                54.7231153,
                37.4791419
              ],
              [
                54.7230297,
                37.4789381
              ],
              [
                54.7228855,
                37.478745
              ],
              [
                54.7226783,
                37.4786699
              ],
              [
                54.72248,
                37.4787164
              ],
              [
                54.7221782,
                37.4789238
              ],
              [
                54.72182,
                37.4793196
              ],
              [
                54.7214186,
                37.4798581
              ],
              [
                54.7211542,
                37.4799162
              ],
              [
                54.7208907,
                37.4797833
              ],
              [
                54.7206864,
                37.4795781
              ],
              [
                54.7205854,
                37.4794458
              ],
              [
                54.7205325,
                37.4792044
              ],
              [
                54.720543,
                37.4788874
              ],
              [
                54.7206271,
                37.4786277
              ],
              [
                54.7211553,
                37.4778888
              ],
              [
                54.7211975,
                37.4776804
              ],
              [
                54.7212224,
                37.4775542
              ],
              [
                54.7211394,
                37.4774236
              ],
              [
                54.7209046,
                37.4771913
              ],
              [
                54.7204433,
                37.4768475
              ],
              [
                54.7200039,
                37.476662
              ],
              [
                54.7193047,
                37.4765853
              ],
              [
                54.7188185,
                37.4765878
              ],
              [
                54.7186124,
                37.4765129
              ],
              [
                54.7184841,
                37.4763833
              ],
              [
                54.7183594,
                37.4762423
              ],
              [
                54.7183313,
                37.4758664
              ],
              [
                54.718432,
                37.4753964
              ],
              [
                54.7185146,
                37.4750921
              ],
              [
                54.7186865,
                37.4749801
              ],
              [
                54.7187923,
                37.4749347
              ],
              [
                54.7188408,
                37.4748227
              ],
              [
                54.7187218,
                37.4747073
              ],
              [
                54.7184882,
                37.4746443
              ],
              [
                54.7181444,
                37.4746128
              ],
              [
                54.7177745,
                37.4747615
              ],
              [
                54.7174042,
                37.4749259
              ],
              [
                54.7169635,
                37.4749924
              ],
              [
                54.7166814,
                37.4749189
              ],
              [
                54.7164213,
                37.4746846
              ],
              [
                54.7162406,
                37.4743627
              ],
              [
                54.7162847,
                37.4741074
              ],
              [
                54.7164257,
                37.473817
              ],
              [
                54.7166152,
                37.4735966
              ],
              [
                54.7169106,
                37.4731699
              ],
              [
                54.7172235,
                37.472918
              ],
              [
                54.7175717,
                37.4727536
              ],
              [
                54.7181624,
                37.4725682
              ],
              [
                54.718277,
                37.4724072
              ],
              [
                54.7182241,
                37.4722078
              ],
              [
                54.717985,
                37.4720554
              ],
              [
                54.7175869,
                37.471812
              ],
              [
                54.7170531,
                37.4713569
              ],
              [
                54.7169908,
                37.4709908
              ],
              [
                54.7171162,
                37.4707216
              ],
              [
                54.7169972,
                37.4704102
              ],
              [
                54.7164699,
                37.4701398
              ],
              [
                54.7158709,
                37.4694735
              ],
              [
                54.7151292,
                37.4686595
              ],
              [
                54.7136139,
                37.4672436
              ],
              [
                54.7135506,
                37.4669154
              ],
              [
                54.7128588,
                37.4664969
              ],
              [
                54.7124327,
                37.4661152
              ],
              [
                54.7119527,
                37.4658776
              ],
              [
                54.7104051,
                37.4644856
              ],
              [
                54.7100322,
                37.4639908
              ],
              [
                54.709543,
                37.4635125
              ],
              [
                54.7089911,
                37.4628969
              ],
              [
                54.708663,
                37.4627454
              ],
              [
                54.7081301,
                37.4619928
              ],
              [
                54.7071148,
                37.4590428
              ],
              [
                54.7064273,
                37.4579153
              ],
              [
                54.7050982,
                37.4567113
              ],
              [
                54.7043433,
                37.455685
              ],
              [
                54.7036514,
                37.4551157
              ],
              [
                54.7025461,
                37.4545464
              ],
              [
                54.7007996,
                37.4533407
              ],
              [
                54.7002317,
                37.4524898
              ],
              [
                54.6992771,
                37.4516988
              ],
              [
                54.6978095,
                37.4502827
              ],
              [
                54.696497,
                37.4496101
              ],
              [
                54.6956735,
                37.4494806
              ],
              [
                54.6913882,
                37.4481831
              ],
              [
                54.687676,
                37.4468581
              ],
              [
                54.6866326,
                37.4461489
              ],
              [
                54.6846114,
                37.4444145
              ],
              [
                54.6837014,
                37.4430651
              ],
              [
                54.6818604,
                37.4418897
              ],
              [
                54.6784733,
                37.4397403
              ],
              [
                54.6736676,
                37.437055
              ],
              [
                54.6734335,
                37.4370105
              ],
              [
                54.6726478,
                37.4371365
              ],
              [
                54.6713486,
                37.4370465
              ],
              [
                54.6703408,
                37.4368548
              ],
              [
                54.6699133,
                37.4366327
              ],
              [
                54.6693468,
                37.4363448
              ],
              [
                54.6687802,
                37.4362608
              ],
              [
                54.6683345,
                37.4362548
              ],
              [
                54.668055,
                37.4363508
              ],
              [
                54.6677378,
                37.4365367
              ],
              [
                54.6674583,
                37.4368246
              ],
              [
                54.6671712,
                37.4369865
              ],
              [
                54.6668508,
                37.4369986
              ],
              [
                54.6662754,
                37.4367435
              ],
              [
                54.6655661,
                37.4363185
              ],
              [
                54.6648435,
                37.4356491
              ],
              [
                54.6643617,
                37.4356066
              ],
              [
                54.6640941,
                37.4356809
              ],
              [
                54.6638799,
                37.435936
              ],
              [
                54.6636658,
                37.4363822
              ],
              [
                54.6634383,
                37.4369348
              ],
              [
                54.6631707,
                37.437498
              ],
              [
                54.6628361,
                37.4376361
              ],
              [
                54.6625417,
                37.4375086
              ],
              [
                54.6622741,
                37.4371898
              ],
              [
                54.6620188,
                37.436696
              ],
              [
                54.6619438,
                37.4366277
              ],
              [
                54.6618207,
                37.4365801
              ],
              [
                54.6614979,
                37.4365523
              ],
              [
                54.6610964,
                37.436701
              ],
              [
                54.6607619,
                37.4368923
              ],
              [
                54.6604273,
                37.4371898
              ],
              [
                54.660219,
                37.4376211
              ],
              [
                54.6598781,
                37.4376453
              ],
              [
                54.6594499,
                37.4374752
              ],
              [
                54.6589607,
                37.4370663
              ],
              [
                54.6584194,
                37.4368483
              ],
              [
                54.6580046,
                37.4366996
              ],
              [
                54.6574425,
                37.4365508
              ],
              [
                54.6570678,
                37.4366146
              ],
              [
                54.656934,
                37.4368483
              ],
              [
                54.6569608,
                37.4371033
              ],
              [
                54.6571883,
                37.4374752
              ],
              [
                54.6578172,
                37.4384741
              ],
              [
                54.6578306,
                37.4388247
              ],
              [
                54.6571749,
                37.4389416
              ],
              [
                54.6566931,
                37.4389203
              ],
              [
                54.6559972,
                37.4388885
              ],
              [
                54.6556761,
                37.439101
              ],
              [
                54.6552478,
                37.4394622
              ],
              [
                54.6549534,
                37.4399191
              ],
              [
                54.6548999,
                37.4403442
              ],
              [
                54.6550471,
                37.440631
              ],
              [
                54.6554084,
                37.440801
              ],
              [
                54.6558366,
                37.4409604
              ],
              [
                54.6559972,
                37.4412473
              ],
              [
                54.6558902,
                37.4415129
              ],
              [
                54.6555958,
                37.4417361
              ],
              [
                54.6551274,
                37.4417998
              ],
              [
                54.652481,
                37.44188
              ],
              [
                54.6518833,
                37.4419658
              ],
              [
                54.6514905,
                37.4421038
              ],
              [
                54.6513168,
                37.4421757
              ],
              [
                54.6510977,
                37.4421637
              ],
              [
                54.6509769,
                37.4420378
              ],
              [
                54.6509693,
                37.4418399
              ],
              [
                54.6510902,
                37.4416599
              ],
              [
                54.6512564,
                37.441384
              ],
              [
                54.6512186,
                37.4410961
              ],
              [
                54.650992,
                37.4408982
              ],
              [
                54.649315,
                37.4403884
              ],
              [
                54.6479251,
                37.4399266
              ],
              [
                54.6475549,
                37.4398366
              ],
              [
                54.6471697,
                37.4398126
              ],
              [
                54.6469582,
                37.4398786
              ],
              [
                54.6466116,
                37.4400752
              ],
              [
                54.6462103,
                37.4402445
              ],
              [
                54.6458251,
                37.4403524
              ],
              [
                54.6455809,
                37.4403121
              ],
              [
                54.6454247,
                37.4402625
              ],
              [
                54.6453718,
                37.4400705
              ],
              [
                54.6453189,
                37.4397886
              ],
              [
                54.6452661,
                37.4396027
              ],
              [
                54.6450546,
                37.4395667
              ],
              [
                54.6447297,
                37.4395727
              ],
              [
                54.644352,
                37.4397167
              ],
              [
                54.6439819,
                37.4399386
              ],
              [
                54.6438082,
                37.4401965
              ],
              [
                54.6438006,
                37.4404664
              ],
              [
                54.6439517,
                37.4409282
              ],
              [
                54.6441995,
                37.4420924
              ],
              [
                54.6442463,
                37.4423856
              ],
              [
                54.6441254,
                37.4427215
              ],
              [
                54.6438308,
                37.4428714
              ],
              [
                54.6434682,
                37.4428355
              ],
              [
                54.6431661,
                37.4426016
              ],
              [
                54.6426977,
                37.4422597
              ],
              [
                54.6422596,
                37.4420918
              ],
              [
                54.6417761,
                37.4420798
              ],
              [
                54.6414664,
                37.4423557
              ],
              [
                54.6413229,
                37.4426855
              ],
              [
                54.64127,
                37.4430754
              ],
              [
                54.6409754,
                37.4432253
              ],
              [
                54.6404617,
                37.4432793
              ],
              [
                54.6397441,
                37.4432313
              ],
              [
                54.6391876,
                37.4429327
              ],
              [
                54.6387319,
                37.4426375
              ],
              [
                54.6380294,
                37.4421157
              ],
              [
                54.6372664,
                37.4417859
              ],
              [
                54.6366545,
                37.4416359
              ],
              [
                54.6361107,
                37.4416119
              ],
              [
                54.6357783,
                37.4416659
              ],
              [
                54.6354988,
                37.4418099
              ],
              [
                54.6354157,
                37.4420558
              ],
              [
                54.6354837,
                37.4422297
              ],
              [
                54.6356725,
                37.4422777
              ],
              [
                54.6363826,
                37.4424396
              ],
              [
                54.6368509,
                37.4427515
              ],
              [
                54.637206,
                37.4433273
              ],
              [
                54.6374553,
                37.444035
              ],
              [
                54.6373477,
                37.4449028
              ],
              [
                54.6370608,
                37.4453462
              ],
              [
                54.6366355,
                37.4456432
              ],
              [
                54.6363947,
                37.4457815
              ],
              [
                54.6362563,
                37.4459686
              ],
              [
                54.636241,
                37.4460988
              ],
              [
                54.6363998,
                37.4463713
              ],
              [
                54.6365126,
                37.4465502
              ],
              [
                54.6366292,
                37.4470623
              ],
              [
                54.6338848,
                37.4476603
              ],
              [
                54.6314249,
                37.4481677
              ],
              [
                54.6309086,
                37.447918
              ],
              [
                54.630458,
                37.4479627
              ],
              [
                54.6302937,
                37.4482757
              ],
              [
                54.6286557,
                37.4485589
              ],
              [
                54.6281424,
                37.4484176
              ],
              [
                54.6273327,
                37.4483649
              ],
              [
                54.627047,
                37.4482331
              ],
              [
                54.6266621,
                37.4475586
              ],
              [
                54.6264629,
                37.447
              ],
              [
                54.6262638,
                37.4469157
              ],
              [
                54.6254275,
                37.4474427
              ],
              [
                54.6251221,
                37.44739
              ],
              [
                54.6249097,
                37.447116
              ],
              [
                54.624238,
                37.4462633
              ],
              [
                54.623583,
                37.4459473
              ],
              [
                54.6230536,
                37.4458181
              ],
              [
                54.6222047,
                37.4457822
              ],
              [
                54.6216176,
                37.4458629
              ],
              [
                54.6208034,
                37.4461214
              ],
              [
                54.6203852,
                37.4463223
              ],
              [
                54.6200671,
                37.4465885
              ],
              [
                54.6186956,
                37.4482305
              ],
              [
                54.6151975,
                37.4497615
              ],
              [
                54.6148046,
                37.4499449
              ],
              [
                54.6146083,
                37.4503573
              ],
              [
                54.6139828,
                37.4507996
              ],
              [
                54.6135617,
                37.4513217
              ],
              [
                54.6133099,
                37.4516084
              ],
              [
                54.6130635,
                37.4522724
              ],
              [
                54.6128809,
                37.4526257
              ],
              [
                54.612697,
                37.4530411
              ],
              [
                54.6126237,
                37.4532756
              ],
              [
                54.6123778,
                37.4538036
              ],
              [
                54.6121576,
                37.4543339
              ],
              [
                54.6120093,
                37.4544649
              ],
              [
                54.6119903,
                37.4546388
              ],
              [
                54.6118788,
                37.4547355
              ],
              [
                54.6115369,
                37.4547355
              ],
              [
                54.611164,
                37.4548194
              ],
              [
                54.6107911,
                37.4550562
              ],
              [
                54.6102317,
                37.4551253
              ],
              [
                54.609747,
                37.455145
              ],
              [
                54.6093057,
                37.4552042
              ],
              [
                54.6089141,
                37.4553769
              ],
              [
                54.6084857,
                37.4556107
              ],
              [
                54.6082319,
                37.4555822
              ],
              [
                54.6078539,
                37.4553275
              ],
              [
                54.6075595,
                37.4552054
              ],
              [
                54.6066801,
                37.4550626
              ],
              [
                54.6060433,
                37.4549996
              ],
              [
                54.605718,
                37.4549717
              ],
              [
                54.6055994,
                37.4549717
              ],
              [
                54.6054763,
                37.4550554
              ],
              [
                54.6054368,
                37.4552194
              ],
              [
                54.6055642,
                37.4555682
              ],
              [
                54.6056038,
                37.4560427
              ],
              [
                54.6038091,
                37.456973
              ],
              [
                54.6029056,
                37.4572244
              ],
              [
                54.6022182,
                37.45732
              ],
              [
                54.6014661,
                37.4572065
              ],
              [
                54.6006893,
                37.4569943
              ],
              [
                54.5996202,
                37.4567723
              ],
              [
                54.5989401,
                37.4568504
              ],
              [
                54.5985139,
                37.4570387
              ],
              [
                54.5982218,
                37.4573545
              ],
              [
                54.5980167,
                37.4579219
              ],
              [
                54.5979732,
                37.4583412
              ],
              [
                54.5977122,
                37.458578
              ],
              [
                54.5973393,
                37.4586471
              ],
              [
                54.5968943,
                37.4586951
              ],
              [
                54.5967389,
                37.4588234
              ],
              [
                54.5966892,
                37.4591293
              ],
              [
                54.5965338,
                37.4593809
              ],
              [
                54.5962666,
                37.4594006
              ],
              [
                54.5959372,
                37.4592378
              ],
              [
                54.5954337,
                37.4588579
              ],
              [
                54.5948868,
                37.4584879
              ],
              [
                54.5945325,
                37.4583596
              ],
              [
                54.593975,
                37.4581914
              ],
              [
                54.5937556,
                37.4583646
              ],
              [
                54.5936065,
                37.4586951
              ],
              [
                54.5935568,
                37.4589566
              ],
              [
                54.5935692,
                37.4593069
              ],
              [
                54.5934262,
                37.4595239
              ],
              [
                54.5927799,
                37.4598841
              ],
              [
                54.592494,
                37.4598496
              ],
              [
                54.5919839,
                37.4599257
              ],
              [
                54.5910458,
                37.4599137
              ],
              [
                54.5902068,
                37.4597558
              ],
              [
                54.5893391,
                37.4595057
              ],
              [
                54.5884518,
                37.4594033
              ],
              [
                54.5877596,
                37.4594237
              ],
              [
                54.5875704,
                37.4594749
              ],
              [
                54.5873898,
                37.4596114
              ],
              [
                54.5872695,
                37.4598367
              ],
              [
                54.5871706,
                37.4599664
              ],
              [
                54.5869728,
                37.4600483
              ],
              [
                54.5867621,
                37.4600312
              ],
              [
                54.5866231,
                37.4599729
              ],
              [
                54.5864526,
                37.4599015
              ],
              [
                54.5862548,
                37.4597377
              ],
              [
                54.5862161,
                37.459492
              ],
              [
                54.5862161,
                37.459178
              ],
              [
                54.5862763,
                37.4589084
              ],
              [
                54.5863881,
                37.4586831
              ],
              [
                54.5865772,
                37.4585091
              ],
              [
                54.5865938,
                37.4583232
              ],
              [
                54.586381,
                37.4581446
              ],
              [
                54.5859392,
                37.4580115
              ],
              [
                54.5857282,
                37.4579976
              ],
              [
                54.5854359,
                37.4581341
              ],
              [
                54.5847523,
                37.4587586
              ],
              [
                54.5843739,
                37.4589429
              ],
              [
                54.5839998,
                37.4589327
              ],
              [
                54.5822551,
                37.458475
              ],
              [
                54.5817007,
                37.4577625
              ],
              [
                54.5813509,
                37.4570305
              ],
              [
                54.5811544,
                37.4568451
              ],
              [
                54.5797073,
                37.4564638
              ],
              [
                54.5794823,
                37.456348
              ],
              [
                54.5794215,
                37.4559956
              ],
              [
                54.5795796,
                37.4558025
              ],
              [
                54.5798653,
                37.4555371
              ],
              [
                54.5795374,
                37.4548216
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 295926933
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.0697204,
          36.8929175
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2074455167
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.4320858,
          36.8392776
        ]
      }
    }
  ]
},
"گیلان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554860,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آستارا",
          "name:en": "Astara County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289684",
          "wikipedia": "en:Astara County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.5818264,
                38.4603383
              ],
              [
                48.5813141,
                38.4595204
              ],
              [
                48.5809063,
                38.4579987
              ],
              [
                48.5805953,
                38.4548107
              ],
              [
                48.5807243,
                38.4539868
              ],
              [
                48.5827914,
                38.4450453
              ],
              [
                48.5822344,
                38.444767
              ],
              [
                48.5819578,
                38.4442102
              ],
              [
                48.5736213,
                38.4383733
              ],
              [
                48.5730682,
                38.4364336
              ],
              [
                48.5725115,
                38.4267083
              ],
              [
                48.5706923,
                38.4214543
              ],
              [
                48.5700116,
                38.4194882
              ],
              [
                48.5691779,
                38.4142079
              ],
              [
                48.5694549,
                38.4125465
              ],
              [
                48.5702881,
                38.4072661
              ],
              [
                48.5705683,
                38.4058741
              ],
              [
                48.5733449,
                38.3936516
              ],
              [
                48.5739016,
                38.3917118
              ],
              [
                48.5708448,
                38.382264
              ],
              [
                48.5708449,
                38.3747649
              ],
              [
                48.5739016,
                38.3617065
              ],
              [
                48.5744548,
                38.3608803
              ],
              [
                48.5744548,
                38.3605929
              ],
              [
                48.5766784,
                38.3564255
              ],
              [
                48.5830684,
                38.3489262
              ],
              [
                48.6122347,
                38.3214335
              ],
              [
                48.6191813,
                38.3153169
              ],
              [
                48.6264046,
                38.3008737
              ],
              [
                48.639782,
                38.2973434
              ],
              [
                48.6538376,
                38.2989915
              ],
              [
                48.6646485,
                38.3058167
              ],
              [
                48.6681578,
                38.3088708
              ],
              [
                48.6693263,
                38.3099251
              ],
              [
                48.6737952,
                38.3097479
              ],
              [
                48.6752486,
                38.306305
              ],
              [
                48.675614,
                38.302908
              ],
              [
                48.675785,
                38.297313
              ],
              [
                48.6734444,
                38.2817164
              ],
              [
                48.6739049,
                38.276001
              ],
              [
                48.6790131,
                38.2679424
              ],
              [
                48.6849354,
                38.265432
              ],
              [
                48.6992597,
                38.2567844
              ],
              [
                48.7003437,
                38.2551276
              ],
              [
                48.7043237,
                38.2553353
              ],
              [
                48.7080317,
                38.2563745
              ],
              [
                48.7170478,
                38.2565422
              ],
              [
                48.7254174,
                38.2549082
              ],
              [
                48.7363063,
                38.2529933
              ],
              [
                48.7453079,
                38.2498673
              ],
              [
                48.7454472,
                38.249937
              ],
              [
                48.7535476,
                38.2534144
              ],
              [
                48.7671088,
                38.256717
              ],
              [
                48.7796401,
                38.2538862
              ],
              [
                48.8138959,
                38.2626424
              ],
              [
                48.8461127,
                38.2707109
              ],
              [
                48.8688612,
                38.2722506
              ],
              [
                48.8678231,
                38.2764732
              ],
              [
                48.8707065,
                38.2778432
              ],
              [
                48.8742256,
                38.2778095
              ],
              [
                48.8768434,
                38.2775737
              ],
              [
                48.8787209,
                38.2757535
              ],
              [
                48.8797187,
                38.2727896
              ],
              [
                48.8826524,
                38.2730035
              ],
              [
                49.0281678,
                38.2922883
              ],
              [
                49.1362825,
                38.2941605
              ],
              [
                49.1363341,
                38.2963583
              ],
              [
                49.1362888,
                38.300729
              ],
              [
                49.1361226,
                38.3050979
              ],
              [
                49.1358354,
                38.3094629
              ],
              [
                49.1354274,
                38.3138218
              ],
              [
                49.1348987,
                38.3181728
              ],
              [
                49.1348429,
                38.3185463
              ],
              [
                49.1342496,
                38.3225136
              ],
              [
                49.1334804,
                38.3268423
              ],
              [
                49.1325914,
                38.3311566
              ],
              [
                49.131583,
                38.3354547
              ],
              [
                49.1303654,
                38.3397234
              ],
              [
                49.1299329,
                38.3418272
              ],
              [
                49.1293658,
                38.3461921
              ],
              [
                49.1285964,
                38.3505207
              ],
              [
                49.1282407,
                38.3522462
              ],
              [
                49.1282332,
                38.3531828
              ],
              [
                49.1282037,
                38.356904
              ],
              [
                49.1288802,
                38.3633276
              ],
              [
                49.1289766,
                38.3645358
              ],
              [
                49.1292034,
                38.3653738
              ],
              [
                49.1302418,
                38.3696675
              ],
              [
                49.1311094,
                38.373992
              ],
              [
                49.1314026,
                38.3752818
              ],
              [
                49.1320426,
                38.3782834
              ],
              [
                49.1323047,
                38.3795942
              ],
              [
                49.133361,
                38.3838859
              ],
              [
                49.1341608,
                38.3882111
              ],
              [
                49.1348407,
                38.392549
              ],
              [
                49.1354003,
                38.3968976
              ],
              [
                49.1358392,
                38.4012547
              ],
              [
                49.1361573,
                38.4056183
              ],
              [
                49.1363543,
                38.4099863
              ],
              [
                49.1364278,
                38.414591
              ],
              [
                49.1364766,
                38.4154627
              ],
              [
                49.1372312,
                38.428124
              ],
              [
                49.1374324,
                38.4325381
              ],
              [
                49.1375098,
                38.4369547
              ],
              [
                49.1374657,
                38.4412768
              ],
              [
                49.137303,
                38.4455971
              ],
              [
                49.1370219,
                38.4499137
              ],
              [
                49.1368682,
                38.4515723
              ],
              [
                48.8822901,
                38.4417873
              ],
              [
                48.8816756,
                38.4420418
              ],
              [
                48.8809664,
                38.4422288
              ],
              [
                48.8801215,
                38.4422252
              ],
              [
                48.8799388,
                38.4421659
              ],
              [
                48.8756913,
                38.4407863
              ],
              [
                48.873879,
                38.4401977
              ],
              [
                48.8732535,
                38.4402224
              ],
              [
                48.8727608,
                38.4402419
              ],
              [
                48.8717076,
                38.4405607
              ],
              [
                48.8711047,
                38.4409891
              ],
              [
                48.8693701,
                38.4428635
              ],
              [
                48.8688552,
                38.4438625
              ],
              [
                48.8680095,
                38.4444883
              ],
              [
                48.8675872,
                38.4445487
              ],
              [
                48.8670282,
                38.44438
              ],
              [
                48.8666526,
                38.4444063
              ],
              [
                48.8660332,
                38.4442903
              ],
              [
                48.8656969,
                38.4439519
              ],
              [
                48.865758,
                38.4435453
              ],
              [
                48.8654777,
                38.4427489
              ],
              [
                48.8651488,
                38.4424111
              ],
              [
                48.8644813,
                38.442253
              ],
              [
                48.8634088,
                38.4426818
              ],
              [
                48.8627289,
                38.443476
              ],
              [
                48.862732,
                38.4439447
              ],
              [
                48.8624645,
                38.4444517
              ],
              [
                48.8619442,
                38.4449253
              ],
              [
                48.8605427,
                38.4457575
              ],
              [
                48.8601256,
                38.4461629
              ],
              [
                48.8590312,
                38.4464438
              ],
              [
                48.858258,
                38.4463879
              ],
              [
                48.8568327,
                38.4470823
              ],
              [
                48.8561715,
                38.4475076
              ],
              [
                48.8554556,
                38.4477208
              ],
              [
                48.8549869,
                38.447732
              ],
              [
                48.8536602,
                38.4487946
              ],
              [
                48.8527655,
                38.4485052
              ],
              [
                48.8520418,
                38.4487276
              ],
              [
                48.8514978,
                38.4490862
              ],
              [
                48.8513945,
                38.4497607
              ],
              [
                48.8508165,
                38.4503464
              ],
              [
                48.8503746,
                38.4502079
              ],
              [
                48.8498861,
                38.4499161
              ],
              [
                48.8491777,
                38.4492657
              ],
              [
                48.8482552,
                38.4489143
              ],
              [
                48.8477548,
                38.448632
              ],
              [
                48.8466433,
                38.4487061
              ],
              [
                48.8462326,
                38.448923
              ],
              [
                48.845484,
                38.4492578
              ],
              [
                48.8444288,
                38.4501882
              ],
              [
                48.84409,
                38.4503078
              ],
              [
                48.8431281,
                38.4514148
              ],
              [
                48.843133,
                38.4516614
              ],
              [
                48.8418546,
                38.4521737
              ],
              [
                48.8411531,
                38.4522751
              ],
              [
                48.8405882,
                38.4522034
              ],
              [
                48.8398248,
                38.451926
              ],
              [
                48.8393056,
                38.451805
              ],
              [
                48.8384602,
                38.4519874
              ],
              [
                48.8373341,
                38.4520686
              ],
              [
                48.8362065,
                38.4518016
              ],
              [
                48.8355211,
                38.4517143
              ],
              [
                48.8341871,
                38.4520393
              ],
              [
                48.8338401,
                38.4518064
              ],
              [
                48.8327394,
                38.4501949
              ],
              [
                48.8314203,
                38.4494912
              ],
              [
                48.8301645,
                38.4492316
              ],
              [
                48.8285316,
                38.4494517
              ],
              [
                48.8255962,
                38.4491873
              ],
              [
                48.8240135,
                38.4492084
              ],
              [
                48.8233257,
                38.4487124
              ],
              [
                48.8210939,
                38.4480921
              ],
              [
                48.8201993,
                38.4481808
              ],
              [
                48.8197822,
                38.4485753
              ],
              [
                48.8195732,
                38.4497355
              ],
              [
                48.8192659,
                38.4501612
              ],
              [
                48.8184354,
                38.4506562
              ],
              [
                48.8169241,
                38.4507551
              ],
              [
                48.815262,
                38.4504148
              ],
              [
                48.8144933,
                38.4497906
              ],
              [
                48.8136288,
                38.4480277
              ],
              [
                48.8122857,
                38.447667
              ],
              [
                48.8115932,
                38.4476154
              ],
              [
                48.8106246,
                38.4480449
              ],
              [
                48.8098918,
                38.4488029
              ],
              [
                48.8089941,
                38.4492603
              ],
              [
                48.8080353,
                38.4490923
              ],
              [
                48.8072108,
                38.4492788
              ],
              [
                48.8065043,
                38.4493028
              ],
              [
                48.8060047,
                38.4491377
              ],
              [
                48.8050486,
                38.4489755
              ],
              [
                48.8042704,
                38.4491879
              ],
              [
                48.8035558,
                38.4490827
              ],
              [
                48.8024474,
                38.4494773
              ],
              [
                48.8019665,
                38.4498374
              ],
              [
                48.8017879,
                38.4504027
              ],
              [
                48.801289,
                38.4511792
              ],
              [
                48.8005299,
                38.4515051
              ],
              [
                48.7999963,
                38.4514834
              ],
              [
                48.7993879,
                38.4512277
              ],
              [
                48.7987924,
                38.4508212
              ],
              [
                48.7978856,
                38.4505343
              ],
              [
                48.7956934,
                38.4508574
              ],
              [
                48.7941665,
                38.4512493
              ],
              [
                48.7926825,
                38.4513999
              ],
              [
                48.7921817,
                38.451608
              ],
              [
                48.7913236,
                38.4517477
              ],
              [
                48.7902702,
                38.451144
              ],
              [
                48.789171,
                38.4507088
              ],
              [
                48.7883893,
                38.4509504
              ],
              [
                48.7877683,
                38.4505947
              ],
              [
                48.7872778,
                38.4498073
              ],
              [
                48.7872443,
                38.4488221
              ],
              [
                48.7870275,
                38.4480114
              ],
              [
                48.7862712,
                38.4472004
              ],
              [
                48.7853267,
                38.4471457
              ],
              [
                48.7841114,
                38.4473992
              ],
              [
                48.7836809,
                38.4472988
              ],
              [
                48.7827791,
                38.4469003
              ],
              [
                48.781439,
                38.444947
              ],
              [
                48.7799252,
                38.4437381
              ],
              [
                48.7795145,
                38.441604
              ],
              [
                48.7742558,
                38.4396928
              ],
              [
                48.7719475,
                38.4401542
              ],
              [
                48.7700408,
                38.4413435
              ],
              [
                48.76731,
                38.440739
              ],
              [
                48.7648876,
                38.43793
              ],
              [
                48.7642574,
                38.4345715
              ],
              [
                48.7614328,
                38.4332757
              ],
              [
                48.7598002,
                38.431183
              ],
              [
                48.7578791,
                38.4305851
              ],
              [
                48.756268,
                38.4289275
              ],
              [
                48.7533339,
                38.4282408
              ],
              [
                48.7524734,
                38.4249915
              ],
              [
                48.7487879,
                38.4235326
              ],
              [
                48.7478518,
                38.4225018
              ],
              [
                48.7478974,
                38.4190443
              ],
              [
                48.7468532,
                38.4171495
              ],
              [
                48.7431185,
                38.4158349
              ],
              [
                48.7413672,
                38.4144627
              ],
              [
                48.7398237,
                38.4120439
              ],
              [
                48.7383031,
                38.4111207
              ],
              [
                48.7327592,
                38.4116718
              ],
              [
                48.7308783,
                38.4107843
              ],
              [
                48.7259062,
                38.409945
              ],
              [
                48.7231122,
                38.4101134
              ],
              [
                48.7207348,
                38.4085225
              ],
              [
                48.7169976,
                38.4079736
              ],
              [
                48.7135296,
                38.4083883
              ],
              [
                48.7111797,
                38.4079736
              ],
              [
                48.7067974,
                38.4083586
              ],
              [
                48.7023639,
                38.4066477
              ],
              [
                48.7012954,
                38.4053219
              ],
              [
                48.6993927,
                38.4053138
              ],
              [
                48.6943126,
                38.4011517
              ],
              [
                48.6936669,
                38.4002742
              ],
              [
                48.6906392,
                38.3992739
              ],
              [
                48.6860783,
                38.398891
              ],
              [
                48.6815596,
                38.3974225
              ],
              [
                48.6764884,
                38.3970701
              ],
              [
                48.6710869,
                38.3958997
              ],
              [
                48.6686731,
                38.3969525
              ],
              [
                48.6673394,
                38.396469
              ],
              [
                48.6664693,
                38.3942382
              ],
              [
                48.6635134,
                38.3934911
              ],
              [
                48.6622715,
                38.3929551
              ],
              [
                48.6592833,
                38.3933659
              ],
              [
                48.6570243,
                38.3960313
              ],
              [
                48.6560848,
                38.3981499
              ],
              [
                48.6544846,
                38.3978572
              ],
              [
                48.6508748,
                38.4000145
              ],
              [
                48.6459001,
                38.4014102
              ],
              [
                48.6421851,
                38.401147
              ],
              [
                48.6409568,
                38.3996062
              ],
              [
                48.6390158,
                38.3991402
              ],
              [
                48.63713,
                38.3995158
              ],
              [
                48.6325079,
                38.402033
              ],
              [
                48.6289704,
                38.4021763
              ],
              [
                48.6282904,
                38.4038445
              ],
              [
                48.6262755,
                38.4045353
              ],
              [
                48.6250371,
                38.4046176
              ],
              [
                48.6236099,
                38.4052919
              ],
              [
                48.6223296,
                38.4074136
              ],
              [
                48.6191602,
                38.4078084
              ],
              [
                48.6184046,
                38.4086965
              ],
              [
                48.6166416,
                38.4092722
              ],
              [
                48.6162123,
                38.4099405
              ],
              [
                48.6145958,
                38.4103575
              ],
              [
                48.6081648,
                38.4154124
              ],
              [
                48.6062137,
                38.4162401
              ],
              [
                48.6048366,
                38.4162494
              ],
              [
                48.6038299,
                38.4170543
              ],
              [
                48.6030904,
                38.4168128
              ],
              [
                48.6018782,
                38.4173601
              ],
              [
                48.602248,
                38.4237662
              ],
              [
                48.6009743,
                38.424233
              ],
              [
                48.5982694,
                38.4260715
              ],
              [
                48.5981218,
                38.427941
              ],
              [
                48.59423,
                38.4315578
              ],
              [
                48.5925356,
                38.4352187
              ],
              [
                48.591972,
                38.4369483
              ],
              [
                48.5928854,
                38.4459367
              ],
              [
                48.5904182,
                38.4495263
              ],
              [
                48.5915804,
                38.4530758
              ],
              [
                48.5908553,
                38.4556542
              ],
              [
                48.5873966,
                38.4546229
              ],
              [
                48.5832971,
                38.456565
              ],
              [
                48.5828061,
                38.4585362
              ],
              [
                48.582031,
                38.459962
              ],
              [
                48.5818264,
                38.4603383
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554861,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آستانه اشرفیه",
          "name:en": "Astaneh-ye Ashrafiyeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2570903",
          "wikipedia": "en:Astaneh-ye Ashrafiyeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.7704797,
                37.2303334
              ],
              [
                49.7706842,
                37.229645
              ],
              [
                49.7717041,
                37.2283574
              ],
              [
                49.7778987,
                37.2261253
              ],
              [
                49.7793278,
                37.223661
              ],
              [
                49.7788381,
                37.2228278
              ],
              [
                49.7778485,
                37.2190651
              ],
              [
                49.7789276,
                37.2172114
              ],
              [
                49.7820535,
                37.215503
              ],
              [
                49.7806406,
                37.2146088
              ],
              [
                49.7803831,
                37.2134467
              ],
              [
                49.7820997,
                37.2129341
              ],
              [
                49.786005,
                37.2125923
              ],
              [
                49.7896568,
                37.2098371
              ],
              [
                49.7912926,
                37.2076843
              ],
              [
                49.7964334,
                37.2074313
              ],
              [
                49.7981071,
                37.2031929
              ],
              [
                49.7981071,
                37.1981338
              ],
              [
                49.7973691,
                37.1930121
              ],
              [
                49.8082351,
                37.1981338
              ],
              [
                49.8119688,
                37.2004241
              ],
              [
                49.8157246,
                37.2011035
              ],
              [
                49.832061,
                37.2044485
              ],
              [
                49.8391491,
                37.2063519
              ],
              [
                49.8472544,
                37.2180984
              ],
              [
                49.8492193,
                37.2192225
              ],
              [
                49.852208,
                37.221908
              ],
              [
                49.8541826,
                37.223376
              ],
              [
                49.8577885,
                37.2251482
              ],
              [
                49.8604289,
                37.2270457
              ],
              [
                49.8638871,
                37.228233
              ],
              [
                49.870634,
                37.2271164
              ],
              [
                49.8727369,
                37.225647
              ],
              [
                49.8757158,
                37.2229514
              ],
              [
                49.879927,
                37.2186435
              ],
              [
                49.8839275,
                37.2110041
              ],
              [
                49.8849785,
                37.2105501
              ],
              [
                49.8853905,
                37.2106108
              ],
              [
                49.8942588,
                37.2115841
              ],
              [
                49.9107906,
                37.2133811
              ],
              [
                49.9252742,
                37.2178295
              ],
              [
                49.9327326,
                37.2209141
              ],
              [
                49.9350071,
                37.221495
              ],
              [
                49.9392985,
                37.2230158
              ],
              [
                49.9443519,
                37.2246817
              ],
              [
                49.9453175,
                37.2248184
              ],
              [
                49.9462213,
                37.2250629
              ],
              [
                49.9477412,
                37.2260938
              ],
              [
                49.9504995,
                37.2264501
              ],
              [
                49.9492217,
                37.2299148
              ],
              [
                49.9436057,
                37.2336397
              ],
              [
                49.9439753,
                37.2402286
              ],
              [
                49.9503382,
                37.2412693
              ],
              [
                49.953684,
                37.2310097
              ],
              [
                49.9558405,
                37.2315389
              ],
              [
                49.9569239,
                37.2300515
              ],
              [
                49.9581274,
                37.2274123
              ],
              [
                49.9641681,
                37.2281757
              ],
              [
                49.9728584,
                37.2293716
              ],
              [
                49.9743175,
                37.2299696
              ],
              [
                49.9816775,
                37.2320369
              ],
              [
                49.9888869,
                37.2341143
              ],
              [
                49.9906253,
                37.2355562
              ],
              [
                49.9919879,
                37.2363847
              ],
              [
                49.9952173,
                37.240237
              ],
              [
                49.9959468,
                37.2418085
              ],
              [
                49.9962043,
                37.2435509
              ],
              [
                49.9961185,
                37.245464
              ],
              [
                49.9956035,
                37.2462839
              ],
              [
                49.9930286,
                37.2468305
              ],
              [
                49.9843168,
                37.2521938
              ],
              [
                49.9835872,
                37.2534235
              ],
              [
                49.9788666,
                37.2544141
              ],
              [
                49.9780297,
                37.2569589
              ],
              [
                49.9800038,
                37.2591108
              ],
              [
                49.984231,
                37.2591279
              ],
              [
                49.9901533,
                37.2629533
              ],
              [
                49.9929428,
                37.2651221
              ],
              [
                49.9936009,
                37.2670661
              ],
              [
                49.9964692,
                37.2671068
              ],
              [
                50.0010434,
                37.2671002
              ],
              [
                50.0037789,
                37.2677007
              ],
              [
                50.0059139,
                37.2715165
              ],
              [
                50.0083622,
                37.271682
              ],
              [
                50.0090575,
                37.2720721
              ],
              [
                50.0138278,
                37.2717152
              ],
              [
                50.0147845,
                37.2729506
              ],
              [
                50.0151681,
                37.2738241
              ],
              [
                50.0150966,
                37.2748418
              ],
              [
                50.0159478,
                37.2785731
              ],
              [
                50.0162223,
                37.2804119
              ],
              [
                50.017081,
                37.2807412
              ],
              [
                50.0181014,
                37.2806
              ],
              [
                50.0213551,
                37.2813743
              ],
              [
                50.0221856,
                37.2817012
              ],
              [
                50.0257649,
                37.2811575
              ],
              [
                50.0318699,
                37.2818021
              ],
              [
                50.0370312,
                37.2830728
              ],
              [
                50.0418496,
                37.2851424
              ],
              [
                50.0528998,
                37.2936255
              ],
              [
                50.0532388,
                37.2967249
              ],
              [
                50.0559854,
                37.2985001
              ],
              [
                50.0613384,
                37.2995919
              ],
              [
                50.0644826,
                37.3023236
              ],
              [
                50.0662422,
                37.3055324
              ],
              [
                50.0683879,
                37.3073757
              ],
              [
                50.0724479,
                37.3146493
              ],
              [
                50.0738924,
                37.3177056
              ],
              [
                50.0765848,
                37.321745
              ],
              [
                50.0804042,
                37.3250553
              ],
              [
                50.0898824,
                37.3323658
              ],
              [
                50.0996729,
                37.3399983
              ],
              [
                50.1022052,
                37.3421168
              ],
              [
                50.1045226,
                37.3434133
              ],
              [
                50.1077842,
                37.3451192
              ],
              [
                50.1145648,
                37.345938
              ],
              [
                50.1161098,
                37.345665
              ],
              [
                50.1249503,
                37.3457333
              ],
              [
                50.126152,
                37.3449145
              ],
              [
                50.1288985,
                37.3447098
              ],
              [
                50.1322459,
                37.343618
              ],
              [
                50.13422,
                37.3434815
              ],
              [
                50.1379108,
                37.3432768
              ],
              [
                50.1397562,
                37.3430891
              ],
              [
                50.1407218,
                37.3431062
              ],
              [
                50.1408505,
                37.3426967
              ],
              [
                50.1407432,
                37.3415537
              ],
              [
                50.1402925,
                37.3403938
              ],
              [
                50.1474379,
                37.3376471
              ],
              [
                50.1491975,
                37.3387389
              ],
              [
                50.150874,
                37.3405728
              ],
              [
                50.1548589,
                37.3432453
              ],
              [
                50.1579952,
                37.3449144
              ],
              [
                50.1590251,
                37.3470297
              ],
              [
                50.1582527,
                37.3505777
              ],
              [
                50.156579,
                37.3521129
              ],
              [
                50.1583385,
                37.3555925
              ],
              [
                50.1610422,
                37.3567182
              ],
              [
                50.1629734,
                37.356957
              ],
              [
                50.165162,
                37.3585261
              ],
              [
                50.1652479,
                37.3602658
              ],
              [
                50.1679945,
                37.3633698
              ],
              [
                50.1695823,
                37.3629946
              ],
              [
                50.1715848,
                37.3664565
              ],
              [
                50.1711685,
                37.3666724
              ],
              [
                50.1763374,
                37.3720389
              ],
              [
                50.1795468,
                37.3753952
              ],
              [
                50.1829326,
                37.3787741
              ],
              [
                50.1824196,
                37.3826788
              ],
              [
                50.1804703,
                37.386426
              ],
              [
                50.2953536,
                37.5661873
              ],
              [
                50.2904048,
                37.5680824
              ],
              [
                50.2854049,
                37.5698909
              ],
              [
                50.2803565,
                37.5716119
              ],
              [
                50.2752618,
                37.5732447
              ],
              [
                50.2701234,
                37.5747884
              ],
              [
                50.2614736,
                37.57716
              ],
              [
                50.2527207,
                37.5792793
              ],
              [
                50.2199582,
                37.5866905
              ],
              [
                50.2137902,
                37.5880175
              ],
              [
                50.2075818,
                37.5892192
              ],
              [
                50.2013368,
                37.5902948
              ],
              [
                50.1950594,
                37.5912437
              ],
              [
                50.1931115,
                37.5915114
              ],
              [
                50.1505369,
                37.5972186
              ],
              [
                50.1377042,
                37.5984864
              ],
              [
                50.1357293,
                37.6003256
              ],
              [
                50.13207,
                37.6035864
              ],
              [
                50.1283218,
                37.6067827
              ],
              [
                50.1244866,
                37.6099131
              ],
              [
                50.1205661,
                37.6129761
              ],
              [
                50.1165622,
                37.6159702
              ],
              [
                50.1124769,
                37.6188939
              ],
              [
                50.108312,
                37.6217459
              ],
              [
                50.0998825,
                37.6269509
              ],
              [
                50.0954487,
                37.6296403
              ],
              [
                50.0912535,
                37.6321234
              ],
              [
                50.0865449,
                37.6347368
              ],
              [
                50.0827148,
                37.6368111
              ],
              [
                50.0819988,
                37.6371816
              ],
              [
                50.0773716,
                37.6395186
              ],
              [
                50.0737117,
                37.6413226
              ],
              [
                50.0726991,
                37.64181
              ],
              [
                50.0711247,
                37.6425492
              ],
              [
                50.0698417,
                37.6431318
              ],
              [
                50.0680237,
                37.6441518
              ],
              [
                50.0632365,
                37.646301
              ],
              [
                50.0583913,
                37.6483665
              ],
              [
                50.0534904,
                37.6503473
              ],
              [
                50.0485359,
                37.6522424
              ],
              [
                50.0435305,
                37.6540509
              ],
              [
                50.0384763,
                37.6557719
              ],
              [
                50.0333759,
                37.6574046
              ],
              [
                50.0282317,
                37.6589483
              ],
              [
                50.023118,
                37.6603827
              ],
              [
                50.0179665,
                37.6617291
              ],
              [
                50.0127795,
                37.6629869
              ],
              [
                50.0075595,
                37.6641554
              ],
              [
                49.9958984,
                37.6666575
              ],
              [
                49.9905077,
                37.6677631
              ],
              [
                49.9850876,
                37.6687736
              ],
              [
                49.9796405,
                37.6696884
              ],
              [
                49.9741692,
                37.6705071
              ],
              [
                49.9687437,
                37.671221
              ],
              [
                49.9632997,
                37.6718405
              ],
              [
                49.95784,
                37.6723651
              ],
              [
                49.9523672,
                37.6727947
              ],
              [
                49.9468837,
                37.6731291
              ],
              [
                49.9413924,
                37.673368
              ],
              [
                49.9358958,
                37.6735114
              ],
              [
                49.9281284,
                37.6734654
              ],
              [
                49.9190279,
                37.6737956
              ],
              [
                49.9135287,
                37.6737478
              ],
              [
                49.908032,
                37.6736044
              ],
              [
                49.8978318,
                37.4532577
              ],
              [
                49.8975769,
                37.4466844
              ],
              [
                49.8986903,
                37.4377971
              ],
              [
                49.8989672,
                37.4355754
              ],
              [
                49.8992438,
                37.4330746
              ],
              [
                49.8995239,
                37.4314104
              ],
              [
                49.8998004,
                37.4308527
              ],
              [
                49.8879367,
                37.4358218
              ],
              [
                49.8871987,
                37.4332575
              ],
              [
                49.8870636,
                37.4292341
              ],
              [
                49.8884432,
                37.4186781
              ],
              [
                49.8989722,
                37.4170878
              ],
              [
                49.9084686,
                37.4139764
              ],
              [
                49.9108278,
                37.4125323
              ],
              [
                49.9153517,
                37.4092168
              ],
              [
                49.9143218,
                37.4075965
              ],
              [
                49.9140226,
                37.4033628
              ],
              [
                49.9174117,
                37.4010511
              ],
              [
                49.9169579,
                37.3963121
              ],
              [
                49.9120238,
                37.3944655
              ],
              [
                49.9085712,
                37.3933458
              ],
              [
                49.9078845,
                37.3900726
              ],
              [
                49.9059772,
                37.3875938
              ],
              [
                49.9048804,
                37.3842077
              ],
              [
                49.9047946,
                37.3788197
              ],
              [
                49.9052238,
                37.3754094
              ],
              [
                49.907112,
                37.3713851
              ],
              [
                49.9075412,
                37.3674287
              ],
              [
                49.9058914,
                37.3626147
              ],
              [
                49.905872,
                37.3596723
              ],
              [
                49.9073549,
                37.3554958
              ],
              [
                49.9091077,
                37.3541768
              ],
              [
                49.9103546,
                37.3536148
              ],
              [
                49.9137985,
                37.3506631
              ],
              [
                49.9147213,
                37.3494801
              ],
              [
                49.9159134,
                37.3476682
              ],
              [
                49.9172819,
                37.3456425
              ],
              [
                49.9175607,
                37.34486
              ],
              [
                49.9189819,
                37.3415087
              ],
              [
                49.9200095,
                37.3378432
              ],
              [
                49.9192357,
                37.3324093
              ],
              [
                49.9197066,
                37.3299148
              ],
              [
                49.9150944,
                37.3272565
              ],
              [
                49.9128413,
                37.3264374
              ],
              [
                49.9071576,
                37.3260455
              ],
              [
                49.9045372,
                37.3262156
              ],
              [
                49.8979989,
                37.324369
              ],
              [
                49.8963571,
                37.3223772
              ],
              [
                49.893812,
                37.3207893
              ],
              [
                49.8899622,
                37.3188293
              ],
              [
                49.8764353,
                37.3125174
              ],
              [
                49.8759556,
                37.3098674
              ],
              [
                49.87613,
                37.3087218
              ],
              [
                49.8870352,
                37.3080787
              ],
              [
                49.8883581,
                37.3063858
              ],
              [
                49.8902034,
                37.3057713
              ],
              [
                49.8804187,
                37.2994901
              ],
              [
                49.8814916,
                37.2941644
              ],
              [
                49.8873388,
                37.2918353
              ],
              [
                49.8942244,
                37.2885663
              ],
              [
                49.8903322,
                37.2824532
              ],
              [
                49.8884223,
                37.2813678
              ],
              [
                49.8875427,
                37.2797215
              ],
              [
                49.887326,
                37.2777544
              ],
              [
                49.88786,
                37.2762493
              ],
              [
                49.889256,
                37.2745304
              ],
              [
                49.8924746,
                37.2725667
              ],
              [
                49.8981157,
                37.2709707
              ],
              [
                49.8996019,
                37.2688619
              ],
              [
                49.8996019,
                37.2675641
              ],
              [
                49.8991819,
                37.2665626
              ],
              [
                49.9032428,
                37.2651543
              ],
              [
                49.9119615,
                37.2645586
              ],
              [
                49.9142789,
                37.2644903
              ],
              [
                49.9171114,
                37.2633632
              ],
              [
                49.9177766,
                37.2619458
              ],
              [
                49.9192222,
                37.2614317
              ],
              [
                49.9182272,
                37.2605454
              ],
              [
                49.9176478,
                37.2595549
              ],
              [
                49.9117899,
                37.2584448
              ],
              [
                49.9059963,
                37.2576591
              ],
              [
                49.9033355,
                37.2573517
              ],
              [
                49.8970699,
                37.2553706
              ],
              [
                49.8944091,
                37.2539701
              ],
              [
                49.8841953,
                37.2551315
              ],
              [
                49.8786592,
                37.2563612
              ],
              [
                49.8753878,
                37.2552606
              ],
              [
                49.8715697,
                37.2544695
              ],
              [
                49.8649005,
                37.2563518
              ],
              [
                49.8583029,
                37.2558509
              ],
              [
                49.8514186,
                37.2550255
              ],
              [
                49.8431592,
                37.2542207
              ],
              [
                49.8314821,
                37.2530648
              ],
              [
                49.7885799,
                37.2437218
              ],
              [
                49.7833934,
                37.2411519
              ],
              [
                49.7771806,
                37.2406392
              ],
              [
                49.7719034,
                37.235086
              ],
              [
                49.7704797,
                37.2303334
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554892,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان املش",
          "name:en": "Amlash County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286046",
          "wikipedia": "en:Amlash County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.0028088,
                36.9367535
              ],
              [
                50.005334,
                36.9312419
              ],
              [
                50.00853,
                36.9197275
              ],
              [
                50.012287,
                36.908914
              ],
              [
                50.0129073,
                36.9012135
              ],
              [
                50.0150588,
                36.8929888
              ],
              [
                50.0160723,
                36.8837453
              ],
              [
                50.0150442,
                36.8705754
              ],
              [
                50.0204086,
                36.8686006
              ],
              [
                50.0256443,
                36.8670556
              ],
              [
                50.0289905,
                36.8674161
              ],
              [
                50.0335886,
                36.8653932
              ],
              [
                50.0370597,
                36.8630728
              ],
              [
                50.0434112,
                36.8491314
              ],
              [
                50.0444412,
                36.8445638
              ],
              [
                50.0459003,
                36.8412667
              ],
              [
                50.0461149,
                36.8386565
              ],
              [
                50.0477944,
                36.835844
              ],
              [
                50.0530468,
                36.8364455
              ],
              [
                50.0577175,
                36.8356564
              ],
              [
                50.0605606,
                36.8365075
              ],
              [
                50.070044,
                36.8323691
              ],
              [
                50.0781503,
                36.8282386
              ],
              [
                50.0877136,
                36.8234853
              ],
              [
                50.0943955,
                36.8195153
              ],
              [
                50.0989358,
                36.8172057
              ],
              [
                50.094786,
                36.8132076
              ],
              [
                50.1032249,
                36.8117568
              ],
              [
                50.111459,
                36.8094204
              ],
              [
                50.1213181,
                36.8116733
              ],
              [
                50.1288127,
                36.8109683
              ],
              [
                50.1407006,
                36.8107119
              ],
              [
                50.1452687,
                36.811472
              ],
              [
                50.1466585,
                36.8099175
              ],
              [
                50.1497125,
                36.8104873
              ],
              [
                50.1528024,
                36.8102812
              ],
              [
                50.1541972,
                36.8094565
              ],
              [
                50.1539611,
                36.8117242
              ],
              [
                50.1529516,
                36.8130197
              ],
              [
                50.1513764,
                36.8210086
              ],
              [
                50.1497696,
                36.8269983
              ],
              [
                50.1498395,
                36.8353789
              ],
              [
                50.1620465,
                36.8554224
              ],
              [
                50.1539152,
                36.8583113
              ],
              [
                50.1522618,
                36.8636722
              ],
              [
                50.1521282,
                36.8688105
              ],
              [
                50.1531699,
                36.8705479
              ],
              [
                50.1562871,
                36.8733539
              ],
              [
                50.1567589,
                36.9030669
              ],
              [
                50.1578305,
                36.9151549
              ],
              [
                50.1669737,
                36.92865
              ],
              [
                50.1760955,
                36.9398807
              ],
              [
                50.1803012,
                36.9444129
              ],
              [
                50.1876135,
                36.9556258
              ],
              [
                50.1969443,
                36.9644575
              ],
              [
                50.2063989,
                36.9719347
              ],
              [
                50.2179908,
                36.9819179
              ],
              [
                50.2296439,
                36.9893913
              ],
              [
                50.233097,
                36.9909677
              ],
              [
                50.2426242,
                36.9922017
              ],
              [
                50.2531813,
                36.991859
              ],
              [
                50.2598761,
                36.99371
              ],
              [
                50.265541,
                37.0003593
              ],
              [
                50.2720836,
                37.0048194
              ],
              [
                50.2773161,
                37.0080213
              ],
              [
                50.2861565,
                37.0113992
              ],
              [
                50.2752399,
                37.0164661
              ],
              [
                50.2715491,
                37.016192
              ],
              [
                50.2691761,
                37.0179175
              ],
              [
                50.2679272,
                37.0265146
              ],
              [
                50.2713775,
                37.028664
              ],
              [
                50.2720641,
                37.0309936
              ],
              [
                50.2699184,
                37.0333918
              ],
              [
                50.2702022,
                37.0359959
              ],
              [
                50.2718066,
                37.0380508
              ],
              [
                50.2851962,
                37.036475
              ],
              [
                50.2851251,
                37.0435102
              ],
              [
                50.2839094,
                37.0481945
              ],
              [
                50.2825355,
                37.0518892
              ],
              [
                50.2774715,
                37.0521632
              ],
              [
                50.2768063,
                37.0535332
              ],
              [
                50.2737807,
                37.0539442
              ],
              [
                50.2728367,
                37.055023
              ],
              [
                50.2720641,
                37.0570951
              ],
              [
                50.2728683,
                37.0595117
              ],
              [
                50.2720427,
                37.0611362
              ],
              [
                50.2708626,
                37.0621978
              ],
              [
                50.2693132,
                37.0647905
              ],
              [
                50.2646342,
                37.0681464
              ],
              [
                50.2650851,
                37.0698515
              ],
              [
                50.2635877,
                37.0728748
              ],
              [
                50.260525,
                37.0740028
              ],
              [
                50.2542832,
                37.0701486
              ],
              [
                50.2514747,
                37.0716695
              ],
              [
                50.25229,
                37.0752032
              ],
              [
                50.2524438,
                37.0773331
              ],
              [
                50.2535596,
                37.0801105
              ],
              [
                50.2546682,
                37.0836218
              ],
              [
                50.2552413,
                37.0857895
              ],
              [
                50.2532672,
                37.0872958
              ],
              [
                50.2513361,
                37.0879119
              ],
              [
                50.2502631,
                37.0891444
              ],
              [
                50.2504133,
                37.0906164
              ],
              [
                50.2523017,
                37.0922595
              ],
              [
                50.2544474,
                37.0934063
              ],
              [
                50.2564429,
                37.0938685
              ],
              [
                50.2575803,
                37.0935775
              ],
              [
                50.2602839,
                37.0932694
              ],
              [
                50.2624297,
                37.0932351
              ],
              [
                50.2632451,
                37.0937486
              ],
              [
                50.2639404,
                37.0950871
              ],
              [
                50.2603739,
                37.1016756
              ],
              [
                50.2596488,
                37.1032877
              ],
              [
                50.255803,
                37.1084983
              ],
              [
                50.2543401,
                37.1114956
              ],
              [
                50.2546405,
                37.1145071
              ],
              [
                50.2560138,
                37.1171422
              ],
              [
                50.2583312,
                37.1189217
              ],
              [
                50.2615928,
                37.1200167
              ],
              [
                50.2625799,
                37.1221041
              ],
              [
                50.2617216,
                37.1243967
              ],
              [
                50.2603912,
                37.1251837
              ],
              [
                50.2590179,
                37.1256627
              ],
              [
                50.2546835,
                37.1239518
              ],
              [
                50.2531814,
                37.1240887
              ],
              [
                50.2517223,
                37.1224462
              ],
              [
                50.249834,
                37.1220014
              ],
              [
                50.2484607,
                37.1221383
              ],
              [
                50.2466154,
                37.122412
              ],
              [
                50.2441263,
                37.1241229
              ],
              [
                50.2426242,
                37.1260049
              ],
              [
                50.2411222,
                37.1293238
              ],
              [
                50.2370075,
                37.1335064
              ],
              [
                50.2284203,
                37.1325945
              ],
              [
                50.2198181,
                37.1317443
              ],
              [
                50.2166258,
                37.1304785
              ],
              [
                50.2136564,
                37.1323347
              ],
              [
                50.2119787,
                37.1341155
              ],
              [
                50.2088499,
                37.1352771
              ],
              [
                50.2057395,
                37.1347656
              ],
              [
                50.2033138,
                37.1353284
              ],
              [
                50.2017045,
                37.1354823
              ],
              [
                50.2005188,
                37.1352498
              ],
              [
                50.1991228,
                37.1344668
              ],
              [
                50.1963188,
                37.1342656
              ],
              [
                50.1956678,
                37.134579
              ],
              [
                50.1934004,
                37.1329335
              ],
              [
                50.1914014,
                37.1312246
              ],
              [
                50.1877855,
                37.1296534
              ],
              [
                50.1867699,
                37.1301621
              ],
              [
                50.1830919,
                37.1311878
              ],
              [
                50.1829566,
                37.1250655
              ],
              [
                50.1823831,
                37.1217902
              ],
              [
                50.1857399,
                37.1195547
              ],
              [
                50.1852893,
                37.1105031
              ],
              [
                50.1834543,
                37.1007924
              ],
              [
                50.1828003,
                37.0999956
              ],
              [
                50.1810837,
                37.1001154
              ],
              [
                50.1785301,
                37.1018097
              ],
              [
                50.1734447,
                37.0998929
              ],
              [
                50.1721358,
                37.0988318
              ],
              [
                50.1691209,
                37.0978372
              ],
              [
                50.1658374,
                37.0961768
              ],
              [
                50.1652807,
                37.0950697
              ],
              [
                50.1646689,
                37.0938479
              ],
              [
                50.1662749,
                37.09228
              ],
              [
                50.1635741,
                37.0911299
              ],
              [
                50.1545619,
                37.0912669
              ],
              [
                50.1458036,
                37.0813986
              ],
              [
                50.1474481,
                37.0788354
              ],
              [
                50.1482622,
                37.0752286
              ],
              [
                50.1461505,
                37.0718203
              ],
              [
                50.1466655,
                37.062917
              ],
              [
                50.1434898,
                37.0599034
              ],
              [
                50.1409148,
                37.0548347
              ],
              [
                50.1398849,
                37.0512727
              ],
              [
                50.1368808,
                37.0505877
              ],
              [
                50.1263236,
                37.047505
              ],
              [
                50.1208305,
                37.0449018
              ],
              [
                50.1152515,
                37.0399692
              ],
              [
                50.113633,
                37.0370933
              ],
              [
                50.1116288,
                37.0294325
              ],
              [
                50.1059223,
                37.0133227
              ],
              [
                50.104207,
                37.0076839
              ],
              [
                50.1028289,
                36.999595
              ],
              [
                50.1011752,
                36.9948067
              ],
              [
                50.098257,
                36.9900079
              ],
              [
                50.0932215,
                36.9859569
              ],
              [
                50.087214,
                36.9802007
              ],
              [
                50.0827387,
                36.9779391
              ],
              [
                50.0673988,
                36.9708716
              ],
              [
                50.0497068,
                36.9630095
              ],
              [
                50.0028088,
                36.9367535
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554938,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بندر انزلی",
          "name:en": "Bandar-e-Anzali County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291657",
          "wikipedia": "en:Bandar-e Anzali County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.1996489,
                37.5715232
              ],
              [
                49.1934494,
                37.5574662
              ],
              [
                49.1936212,
                37.5557252
              ],
              [
                49.1914157,
                37.54646
              ],
              [
                49.1943558,
                37.5413557
              ],
              [
                49.2059611,
                37.5337561
              ],
              [
                49.2099862,
                37.5277223
              ],
              [
                49.2120202,
                37.5223338
              ],
              [
                49.2128166,
                37.516656
              ],
              [
                49.2137466,
                37.5098058
              ],
              [
                49.2145013,
                37.5037341
              ],
              [
                49.214186,
                37.5025713
              ],
              [
                49.2167513,
                37.4996699
              ],
              [
                49.2179051,
                37.4988825
              ],
              [
                49.2184764,
                37.4983058
              ],
              [
                49.2210673,
                37.4965162
              ],
              [
                49.2265605,
                37.4929751
              ],
              [
                49.2329978,
                37.4884803
              ],
              [
                49.2408942,
                37.4835766
              ],
              [
                49.2501639,
                37.4786045
              ],
              [
                49.2569446,
                37.4772422
              ],
              [
                49.2629527,
                37.4749944
              ],
              [
                49.2707568,
                37.4733071
              ],
              [
                49.2808885,
                37.4697703
              ],
              [
                49.2886903,
                37.4671991
              ],
              [
                49.2918777,
                37.4658662
              ],
              [
                49.3070697,
                37.4510815
              ],
              [
                49.3092155,
                37.4478108
              ],
              [
                49.3105029,
                37.4433815
              ],
              [
                49.3166827,
                37.4349309
              ],
              [
                49.317541,
                37.4271611
              ],
              [
                49.3209743,
                37.4202765
              ],
              [
                49.3255233,
                37.4177543
              ],
              [
                49.3288707,
                37.4178907
              ],
              [
                49.3390845,
                37.4170045
              ],
              [
                49.3488209,
                37.4134492
              ],
              [
                49.3509341,
                37.4122063
              ],
              [
                49.3542337,
                37.410528
              ],
              [
                49.3583965,
                37.4051761
              ],
              [
                49.3613378,
                37.4030643
              ],
              [
                49.3642296,
                37.4022366
              ],
              [
                49.372721,
                37.3987528
              ],
              [
                49.3836346,
                37.3960225
              ],
              [
                49.3916988,
                37.3971644
              ],
              [
                49.3945741,
                37.3981531
              ],
              [
                49.398694,
                37.4004033
              ],
              [
                49.4040303,
                37.4057047
              ],
              [
                49.4071737,
                37.407549
              ],
              [
                49.4102659,
                37.4085382
              ],
              [
                49.4138944,
                37.4083119
              ],
              [
                49.42415,
                37.4058977
              ],
              [
                49.431678,
                37.4042954
              ],
              [
                49.4397223,
                37.4031083
              ],
              [
                49.4444074,
                37.3991973
              ],
              [
                49.4483921,
                37.3997363
              ],
              [
                49.4492253,
                37.3997363
              ],
              [
                49.4514453,
                37.400294
              ],
              [
                49.4528351,
                37.400294
              ],
              [
                49.4533919,
                37.4005729
              ],
              [
                49.4550586,
                37.4005729
              ],
              [
                49.4564454,
                37.4008518
              ],
              [
                49.4661682,
                37.4008518
              ],
              [
                49.4667254,
                37.4005729
              ],
              [
                49.4689484,
                37.4005729
              ],
              [
                49.4697817,
                37.4002941
              ],
              [
                49.4708917,
                37.4002941
              ],
              [
                49.4711683,
                37.4000152
              ],
              [
                49.4725582,
                37.4000152
              ],
              [
                49.4731149,
                37.3997364
              ],
              [
                49.4742251,
                37.3997363
              ],
              [
                49.4797818,
                37.3986298
              ],
              [
                49.5217771,
                37.3772205
              ],
              [
                49.5295045,
                37.376131
              ],
              [
                49.536171,
                37.376131
              ],
              [
                49.5367277,
                37.3764099
              ],
              [
                49.5375608,
                37.3764099
              ],
              [
                49.5389512,
                37.3769586
              ],
              [
                49.5456176,
                37.3855769
              ],
              [
                49.5537813,
                37.3866545
              ],
              [
                49.553842,
                37.3882996
              ],
              [
                49.5563221,
                37.3910273
              ],
              [
                49.5613861,
                37.3936527
              ],
              [
                49.5649927,
                37.3968286
              ],
              [
                49.5661292,
                37.3993667
              ],
              [
                49.5682555,
                37.4030022
              ],
              [
                49.5702309,
                37.4070407
              ],
              [
                49.5704026,
                37.4089096
              ],
              [
                49.5699734,
                37.4104659
              ],
              [
                49.5690036,
                37.4122324
              ],
              [
                49.5666688,
                37.4138701
              ],
              [
                49.5654911,
                37.4145812
              ],
              [
                49.5602984,
                37.4180401
              ],
              [
                49.5587682,
                37.4214012
              ],
              [
                49.5581245,
                37.4237188
              ],
              [
                49.5543909,
                37.4236507
              ],
              [
                49.5526743,
                37.4274337
              ],
              [
                49.5529317,
                37.4279449
              ],
              [
                49.5587515,
                37.4290932
              ],
              [
                49.5614544,
                37.4318673
              ],
              [
                49.5652841,
                37.4344232
              ],
              [
                49.5685081,
                37.4354455
              ],
              [
                49.5712061,
                37.4359992
              ],
              [
                49.5709905,
                37.4372365
              ],
              [
                49.5768242,
                37.4380395
              ],
              [
                49.5770801,
                37.4375473
              ],
              [
                49.5797987,
                37.4382563
              ],
              [
                49.582994,
                37.4391648
              ],
              [
                49.585941,
                37.4401507
              ],
              [
                49.5963733,
                37.4426686
              ],
              [
                49.6080893,
                37.4431627
              ],
              [
                49.6153952,
                37.4370322
              ],
              [
                49.6196638,
                37.4393876
              ],
              [
                49.6195191,
                37.4396304
              ],
              [
                49.6216007,
                37.4431172
              ],
              [
                49.6237882,
                37.444951
              ],
              [
                49.6237189,
                37.4486646
              ],
              [
                49.6223028,
                37.4539794
              ],
              [
                49.6244008,
                37.4546546
              ],
              [
                49.6257647,
                37.4533941
              ],
              [
                49.6321163,
                37.4509071
              ],
              [
                49.6343226,
                37.4480049
              ],
              [
                49.6347762,
                37.4457903
              ],
              [
                49.6352648,
                37.4453918
              ],
              [
                49.6434188,
                37.445511
              ],
              [
                49.6442985,
                37.4452213
              ],
              [
                49.6530625,
                37.4455518
              ],
              [
                49.6488998,
                37.4492656
              ],
              [
                49.6471936,
                37.4509028
              ],
              [
                49.64722,
                37.4518654
              ],
              [
                49.6479034,
                37.4519843
              ],
              [
                49.6482199,
                37.4519204
              ],
              [
                49.6494859,
                37.4526614
              ],
              [
                49.6500522,
                37.4526977
              ],
              [
                49.6506949,
                37.4531789
              ],
              [
                49.6531538,
                37.4534259
              ],
              [
                49.658238,
                37.4513052
              ],
              [
                49.6601907,
                37.450743
              ],
              [
                49.6604106,
                37.4487689
              ],
              [
                49.6636962,
                37.4458176
              ],
              [
                49.6827672,
                37.4456219
              ],
              [
                49.687611,
                37.4491715
              ],
              [
                49.6910012,
                37.4550663
              ],
              [
                49.7134228,
                37.6547622
              ],
              [
                49.6789071,
                37.6576495
              ],
              [
                49.6732361,
                37.6579011
              ],
              [
                49.6647901,
                37.6587519
              ],
              [
                49.5973932,
                37.664582
              ],
              [
                49.5908839,
                37.6650752
              ],
              [
                49.5844383,
                37.6654958
              ],
              [
                49.5604918,
                37.6688479
              ],
              [
                49.5399187,
                37.6721225
              ],
              [
                49.5346798,
                37.6733892
              ],
              [
                49.5293845,
                37.6745696
              ],
              [
                49.5240579,
                37.6756577
              ],
              [
                49.5187026,
                37.6766529
              ],
              [
                49.5133211,
                37.6775548
              ],
              [
                49.507916,
                37.6783629
              ],
              [
                49.5024899,
                37.6790769
              ],
              [
                49.4970454,
                37.6796963
              ],
              [
                49.4915762,
                37.6801829
              ],
              [
                49.4840979,
                37.6818876
              ],
              [
                49.467749,
                37.6863393
              ],
              [
                49.4303733,
                37.6983085
              ],
              [
                49.4015397,
                37.7095083
              ],
              [
                49.3992962,
                37.7105147
              ],
              [
                49.3944468,
                37.7125802
              ],
              [
                49.3895416,
                37.714561
              ],
              [
                49.386782,
                37.7156156
              ],
              [
                49.3828313,
                37.7172109
              ],
              [
                49.3778724,
                37.719106
              ],
              [
                49.3734818,
                37.7206909
              ],
              [
                49.3694464,
                37.7227984
              ],
              [
                49.367912,
                37.7237157
              ],
              [
                49.3634436,
                37.7262675
              ],
              [
                49.3589059,
                37.728741
              ],
              [
                49.3543011,
                37.7311352
              ],
              [
                49.3496313,
                37.7334488
              ],
              [
                49.3465365,
                37.7349084
              ],
              [
                49.3413851,
                37.7379712
              ],
              [
                49.1996489,
                37.5715232
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555042,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رشت",
          "name:en": "Rasht County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291688",
          "wikipedia": "en:Rasht County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.4624389,
                37.3078223
              ],
              [
                49.4615865,
                37.304952
              ],
              [
                49.4625306,
                37.3020334
              ],
              [
                49.4636464,
                37.3002582
              ],
              [
                49.4644646,
                37.2987979
              ],
              [
                49.4644431,
                37.2980694
              ],
              [
                49.4661569,
                37.2945058
              ],
              [
                49.4714355,
                37.2880871
              ],
              [
                49.4783019,
                37.2826581
              ],
              [
                49.481821,
                37.2798239
              ],
              [
                49.4827651,
                37.278219
              ],
              [
                49.4828939,
                37.2742919
              ],
              [
                49.4820356,
                37.274087
              ],
              [
                49.4809689,
                37.2727807
              ],
              [
                49.4804907,
                37.2730625
              ],
              [
                49.4790744,
                37.2719355
              ],
              [
                49.478302,
                37.269784
              ],
              [
                49.4783531,
                37.2681147
              ],
              [
                49.479985,
                37.2644692
              ],
              [
                49.4788169,
                37.2632522
              ],
              [
                49.478184,
                37.2629875
              ],
              [
                49.4753194,
                37.2610577
              ],
              [
                49.4736671,
                37.2578641
              ],
              [
                49.4723152,
                37.2551315
              ],
              [
                49.4716715,
                37.2551315
              ],
              [
                49.4702124,
                37.2542946
              ],
              [
                49.4701051,
                37.2511007
              ],
              [
                49.4694636,
                37.2483913
              ],
              [
                49.4700839,
                37.2438148
              ],
              [
                49.4729354,
                37.2420156
              ],
              [
                49.4774653,
                37.2429814
              ],
              [
                49.4831062,
                37.2438902
              ],
              [
                49.4848898,
                37.2432298
              ],
              [
                49.4853401,
                37.2428505
              ],
              [
                49.4846964,
                37.2404249
              ],
              [
                49.4836465,
                37.2394579
              ],
              [
                49.4792461,
                37.2375721
              ],
              [
                49.4727229,
                37.233267
              ],
              [
                49.468603,
                37.2323786
              ],
              [
                49.4680881,
                37.2301918
              ],
              [
                49.4640771,
                37.2278967
              ],
              [
                49.4617762,
                37.224093
              ],
              [
                49.4634071,
                37.2213482
              ],
              [
                49.4723335,
                37.2179881
              ],
              [
                49.475508,
                37.2103427
              ],
              [
                49.4770529,
                37.2081527
              ],
              [
                49.4808914,
                37.2027593
              ],
              [
                49.4803372,
                37.1958409
              ],
              [
                49.4844143,
                37.1902323
              ],
              [
                49.4958921,
                37.1905688
              ],
              [
                49.4961722,
                37.1886251
              ],
              [
                49.4964488,
                37.1877881
              ],
              [
                49.4970055,
                37.1866813
              ],
              [
                49.4967253,
                37.1864024
              ],
              [
                49.4975585,
                37.1850166
              ],
              [
                49.4981152,
                37.1830638
              ],
              [
                49.4983918,
                37.1816781
              ],
              [
                49.4998993,
                37.1804171
              ],
              [
                49.5031153,
                37.1802922
              ],
              [
                49.503672,
                37.1800133
              ],
              [
                49.5045052,
                37.1791764
              ],
              [
                49.512282,
                37.1752889
              ],
              [
                49.5197818,
                37.1658401
              ],
              [
                49.5231186,
                37.1583439
              ],
              [
                49.5278602,
                37.1281743
              ],
              [
                49.5321737,
                37.1352856
              ],
              [
                49.542484,
                37.1294236
              ],
              [
                49.5506605,
                37.128392
              ],
              [
                49.5569677,
                37.1282758
              ],
              [
                49.5612788,
                37.1269538
              ],
              [
                49.5669627,
                37.1207779
              ],
              [
                49.5668137,
                37.1165709
              ],
              [
                49.5643627,
                37.1134589
              ],
              [
                49.5570516,
                37.1097502
              ],
              [
                49.5545196,
                37.1071833
              ],
              [
                49.5519876,
                37.1056432
              ],
              [
                49.5497989,
                37.1032473
              ],
              [
                49.5459794,
                37.1008514
              ],
              [
                49.5415592,
                37.099448
              ],
              [
                49.538598,
                37.0975654
              ],
              [
                49.536538,
                37.0951008
              ],
              [
                49.5328044,
                37.0936288
              ],
              [
                49.5291566,
                37.0928415
              ],
              [
                49.5243501,
                37.089966
              ],
              [
                49.5219039,
                37.0902056
              ],
              [
                49.5207881,
                37.0866796
              ],
              [
                49.5126342,
                37.0692179
              ],
              [
                49.5001865,
                37.0483167
              ],
              [
                49.4933171,
                37.0414158
              ],
              [
                49.4918202,
                37.0385304
              ],
              [
                49.491434,
                37.0348992
              ],
              [
                49.493943,
                37.0277589
              ],
              [
                49.4954681,
                37.0245525
              ],
              [
                49.4964552,
                37.0231648
              ],
              [
                49.4997382,
                37.0184021
              ],
              [
                49.5003176,
                37.0182479
              ],
              [
                49.5011759,
                37.0172371
              ],
              [
                49.5015836,
                37.0165346
              ],
              [
                49.5048237,
                37.0154038
              ],
              [
                49.5084071,
                37.0138789
              ],
              [
                49.5117545,
                37.0129537
              ],
              [
                49.515574,
                37.0121141
              ],
              [
                49.5218181,
                37.011206
              ],
              [
                49.5225262,
                37.0114973
              ],
              [
                49.525187,
                37.0107091
              ],
              [
                49.5343494,
                37.0131764
              ],
              [
                49.5380616,
                37.0167059
              ],
              [
                49.5399713,
                37.0191045
              ],
              [
                49.5369887,
                37.0220684
              ],
              [
                49.5328903,
                37.0223083
              ],
              [
                49.5281482,
                37.0216401
              ],
              [
                49.5186424,
                37.0230107
              ],
              [
                49.5103597,
                37.0275504
              ],
              [
                49.5073128,
                37.0317473
              ],
              [
                49.5057893,
                37.0353445
              ],
              [
                49.5054459,
                37.0377425
              ],
              [
                49.5070553,
                37.0422471
              ],
              [
                49.5093941,
                37.0459808
              ],
              [
                49.5135355,
                37.048858
              ],
              [
                49.517312,
                37.0502451
              ],
              [
                49.5184922,
                37.0502109
              ],
              [
                49.5219054,
                37.0512279
              ],
              [
                49.5254962,
                37.0528207
              ],
              [
                49.5318273,
                37.0543739
              ],
              [
                49.5412097,
                37.0555614
              ],
              [
                49.5466718,
                37.0562363
              ],
              [
                49.5603132,
                37.0541601
              ],
              [
                49.5722321,
                37.0501248
              ],
              [
                49.5850737,
                37.0446873
              ],
              [
                49.5885944,
                37.0381193
              ],
              [
                49.5997523,
                37.0277732
              ],
              [
                49.6099662,
                37.0157808
              ],
              [
                49.6169741,
                37.0161963
              ],
              [
                49.6282064,
                37.0192264
              ],
              [
                49.6338498,
                37.0234629
              ],
              [
                49.6376466,
                37.0247923
              ],
              [
                49.6393203,
                37.0259915
              ],
              [
                49.6456966,
                37.0290627
              ],
              [
                49.6513792,
                37.0362035
              ],
              [
                49.6530401,
                37.0396793
              ],
              [
                49.6563842,
                37.0429855
              ],
              [
                49.6662893,
                37.0496907
              ],
              [
                49.6682062,
                37.0553741
              ],
              [
                49.6703259,
                37.058102
              ],
              [
                49.6709918,
                37.0608623
              ],
              [
                49.675455,
                37.066136
              ],
              [
                49.6838664,
                37.0721627
              ],
              [
                49.6933078,
                37.0759291
              ],
              [
                49.6963119,
                37.0773672
              ],
              [
                49.6991443,
                37.0811333
              ],
              [
                49.7010326,
                37.0831191
              ],
              [
                49.7048949,
                37.0863372
              ],
              [
                49.7077273,
                37.0896237
              ],
              [
                49.7097015,
                37.0944846
              ],
              [
                49.7120189,
                37.0980446
              ],
              [
                49.7133063,
                37.0994822
              ],
              [
                49.7155379,
                37.1005091
              ],
              [
                49.7167396,
                37.1034527
              ],
              [
                49.720087,
                37.1083812
              ],
              [
                49.7212028,
                37.1111876
              ],
              [
                49.7268676,
                37.1175529
              ],
              [
                49.7275542,
                37.1185111
              ],
              [
                49.7257895,
                37.1193034
              ],
              [
                49.7264408,
                37.1196798
              ],
              [
                49.7310948,
                37.1216592
              ],
              [
                49.7341847,
                37.1221982
              ],
              [
                49.7365987,
                37.1233273
              ],
              [
                49.7396226,
                37.1245029
              ],
              [
                49.7400856,
                37.1249441
              ],
              [
                49.7415554,
                37.1258594
              ],
              [
                49.7433042,
                37.1265523
              ],
              [
                49.7494482,
                37.1284986
              ],
              [
                49.7508144,
                37.1293581
              ],
              [
                49.7516298,
                37.1349349
              ],
              [
                49.7533893,
                37.1404088
              ],
              [
                49.7578205,
                37.1495943
              ],
              [
                49.7608565,
                37.1612742
              ],
              [
                49.771757,
                37.1709867
              ],
              [
                49.7824,
                37.1755689
              ],
              [
                49.7884082,
                37.1796037
              ],
              [
                49.7949313,
                37.1873308
              ],
              [
                49.7973691,
                37.1930121
              ],
              [
                49.7981071,
                37.1981338
              ],
              [
                49.7981071,
                37.2031929
              ],
              [
                49.7964334,
                37.2074313
              ],
              [
                49.7912926,
                37.2076843
              ],
              [
                49.7896568,
                37.2098371
              ],
              [
                49.786005,
                37.2125923
              ],
              [
                49.7820997,
                37.2129341
              ],
              [
                49.7803831,
                37.2134467
              ],
              [
                49.7806406,
                37.2146088
              ],
              [
                49.7820535,
                37.215503
              ],
              [
                49.7789276,
                37.2172114
              ],
              [
                49.7778485,
                37.2190651
              ],
              [
                49.7788381,
                37.2228278
              ],
              [
                49.7793278,
                37.223661
              ],
              [
                49.7778987,
                37.2261253
              ],
              [
                49.7717041,
                37.2283574
              ],
              [
                49.7706842,
                37.229645
              ],
              [
                49.7704797,
                37.2303334
              ],
              [
                49.7719034,
                37.235086
              ],
              [
                49.7771806,
                37.2406392
              ],
              [
                49.7833934,
                37.2411519
              ],
              [
                49.7885799,
                37.2437218
              ],
              [
                49.8314821,
                37.2530648
              ],
              [
                49.8431592,
                37.2542207
              ],
              [
                49.8514186,
                37.2550255
              ],
              [
                49.8583029,
                37.2558509
              ],
              [
                49.8649005,
                37.2563518
              ],
              [
                49.8715697,
                37.2544695
              ],
              [
                49.8753878,
                37.2552606
              ],
              [
                49.8786592,
                37.2563612
              ],
              [
                49.8841953,
                37.2551315
              ],
              [
                49.8944091,
                37.2539701
              ],
              [
                49.8970699,
                37.2553706
              ],
              [
                49.9033355,
                37.2573517
              ],
              [
                49.9059963,
                37.2576591
              ],
              [
                49.9117899,
                37.2584448
              ],
              [
                49.9176478,
                37.2595549
              ],
              [
                49.9182272,
                37.2605454
              ],
              [
                49.9192222,
                37.2614317
              ],
              [
                49.9177766,
                37.2619458
              ],
              [
                49.9171114,
                37.2633632
              ],
              [
                49.9142789,
                37.2644903
              ],
              [
                49.9119615,
                37.2645586
              ],
              [
                49.9032428,
                37.2651543
              ],
              [
                49.8991819,
                37.2665626
              ],
              [
                49.8996019,
                37.2675641
              ],
              [
                49.8996019,
                37.2688619
              ],
              [
                49.8981157,
                37.2709707
              ],
              [
                49.8924746,
                37.2725667
              ],
              [
                49.889256,
                37.2745304
              ],
              [
                49.88786,
                37.2762493
              ],
              [
                49.887326,
                37.2777544
              ],
              [
                49.8875427,
                37.2797215
              ],
              [
                49.8884223,
                37.2813678
              ],
              [
                49.8903322,
                37.2824532
              ],
              [
                49.8942244,
                37.2885663
              ],
              [
                49.8873388,
                37.2918353
              ],
              [
                49.8814916,
                37.2941644
              ],
              [
                49.8804187,
                37.2994901
              ],
              [
                49.8902034,
                37.3057713
              ],
              [
                49.8883581,
                37.3063858
              ],
              [
                49.8870352,
                37.3080787
              ],
              [
                49.87613,
                37.3087218
              ],
              [
                49.8759556,
                37.3098674
              ],
              [
                49.8764353,
                37.3125174
              ],
              [
                49.8899622,
                37.3188293
              ],
              [
                49.893812,
                37.3207893
              ],
              [
                49.8963571,
                37.3223772
              ],
              [
                49.8979989,
                37.324369
              ],
              [
                49.9045372,
                37.3262156
              ],
              [
                49.9071576,
                37.3260455
              ],
              [
                49.9128413,
                37.3264374
              ],
              [
                49.9150944,
                37.3272565
              ],
              [
                49.9197066,
                37.3299148
              ],
              [
                49.9192357,
                37.3324093
              ],
              [
                49.9200095,
                37.3378432
              ],
              [
                49.9189819,
                37.3415087
              ],
              [
                49.9175607,
                37.34486
              ],
              [
                49.9172819,
                37.3456425
              ],
              [
                49.9159134,
                37.3476682
              ],
              [
                49.9147213,
                37.3494801
              ],
              [
                49.9137985,
                37.3506631
              ],
              [
                49.9103546,
                37.3536148
              ],
              [
                49.9091077,
                37.3541768
              ],
              [
                49.9073549,
                37.3554958
              ],
              [
                49.905872,
                37.3596723
              ],
              [
                49.9058914,
                37.3626147
              ],
              [
                49.9075412,
                37.3674287
              ],
              [
                49.907112,
                37.3713851
              ],
              [
                49.9052238,
                37.3754094
              ],
              [
                49.9047946,
                37.3788197
              ],
              [
                49.9048804,
                37.3842077
              ],
              [
                49.9059772,
                37.3875938
              ],
              [
                49.9078845,
                37.3900726
              ],
              [
                49.9085712,
                37.3933458
              ],
              [
                49.9120238,
                37.3944655
              ],
              [
                49.9169579,
                37.3963121
              ],
              [
                49.9174117,
                37.4010511
              ],
              [
                49.9140226,
                37.4033628
              ],
              [
                49.9143218,
                37.4075965
              ],
              [
                49.9153517,
                37.4092168
              ],
              [
                49.9108278,
                37.4125323
              ],
              [
                49.9084686,
                37.4139764
              ],
              [
                49.8989722,
                37.4170878
              ],
              [
                49.8884432,
                37.4186781
              ],
              [
                49.8870636,
                37.4292341
              ],
              [
                49.8871987,
                37.4332575
              ],
              [
                49.8879367,
                37.4358218
              ],
              [
                49.8998004,
                37.4308527
              ],
              [
                49.8995239,
                37.4314104
              ],
              [
                49.8992438,
                37.4330746
              ],
              [
                49.8989672,
                37.4355754
              ],
              [
                49.8986903,
                37.4377971
              ],
              [
                49.8975769,
                37.4466844
              ],
              [
                49.8978318,
                37.4532577
              ],
              [
                49.908032,
                37.6736044
              ],
              [
                49.9025407,
                37.6733655
              ],
              [
                49.8970573,
                37.6730311
              ],
              [
                49.8915844,
                37.6726015
              ],
              [
                49.8861246,
                37.6720769
              ],
              [
                49.8806807,
                37.6714574
              ],
              [
                49.8752552,
                37.6707434
              ],
              [
                49.8699929,
                37.6699579
              ],
              [
                49.8585317,
                37.6681456
              ],
              [
                49.8491035,
                37.6665042
              ],
              [
                49.8397618,
                37.6645762
              ],
              [
                49.8305202,
                37.6623647
              ],
              [
                49.8213925,
                37.6598728
              ],
              [
                49.8198162,
                37.6594107
              ],
              [
                49.8191065,
                37.6592005
              ],
              [
                49.8092763,
                37.6560997
              ],
              [
                49.7996191,
                37.652673
              ],
              [
                49.7901523,
                37.6489264
              ],
              [
                49.789138,
                37.6484817
              ],
              [
                49.779823,
                37.6486822
              ],
              [
                49.7008469,
                37.4540116
              ],
              [
                49.7003655,
                37.4523287
              ],
              [
                49.6996324,
                37.449956
              ],
              [
                49.6992638,
                37.448753
              ],
              [
                49.698425,
                37.4480125
              ],
              [
                49.7019,
                37.4468461
              ],
              [
                49.7023912,
                37.4435286
              ],
              [
                49.7020625,
                37.43902
              ],
              [
                49.7008609,
                37.4319321
              ],
              [
                49.7002601,
                37.4279449
              ],
              [
                49.7000455,
                37.4255933
              ],
              [
                49.7007751,
                37.4227986
              ],
              [
                49.7016604,
                37.4215924
              ],
              [
                49.704426,
                37.4189958
              ],
              [
                49.7062683,
                37.4180611
              ],
              [
                49.7124272,
                37.4143342
              ],
              [
                49.7129416,
                37.4130164
              ],
              [
                49.7126412,
                37.4124369
              ],
              [
                49.715023,
                37.4075283
              ],
              [
                49.7261922,
                37.4023486
              ],
              [
                49.7260395,
                37.3958649
              ],
              [
                49.7319008,
                37.3931994
              ],
              [
                49.7320283,
                37.3861381
              ],
              [
                49.731929,
                37.378937
              ],
              [
                49.7311209,
                37.372539
              ],
              [
                49.7313784,
                37.3695198
              ],
              [
                49.7307801,
                37.366855
              ],
              [
                49.7295152,
                37.3648025
              ],
              [
                49.7295153,
                37.3617145
              ],
              [
                49.7303425,
                37.35907
              ],
              [
                49.7334383,
                37.3563039
              ],
              [
                49.7315084,
                37.3564284
              ],
              [
                49.7290193,
                37.3515755
              ],
              [
                49.7287866,
                37.3447727
              ],
              [
                49.7239941,
                37.3446277
              ],
              [
                49.7221978,
                37.3422753
              ],
              [
                49.7235962,
                37.3361253
              ],
              [
                49.7191428,
                37.3348832
              ],
              [
                49.7128772,
                37.3340643
              ],
              [
                49.7057532,
                37.3342008
              ],
              [
                49.6987151,
                37.3329723
              ],
              [
                49.6946811,
                37.3296282
              ],
              [
                49.6928745,
                37.3267131
              ],
              [
                49.6918552,
                37.3256213
              ],
              [
                49.6902732,
                37.3245975
              ],
              [
                49.6876138,
                37.3301882
              ],
              [
                49.6860144,
                37.3332059
              ],
              [
                49.6840845,
                37.3369742
              ],
              [
                49.684158,
                37.3388168
              ],
              [
                49.6800823,
                37.3399055
              ],
              [
                49.6774896,
                37.3398032
              ],
              [
                49.6749215,
                37.3389502
              ],
              [
                49.6702021,
                37.3309716
              ],
              [
                49.668,
                37.3292655
              ],
              [
                49.6651701,
                37.3287253
              ],
              [
                49.6627987,
                37.3296126
              ],
              [
                49.6590044,
                37.333065
              ],
              [
                49.6553099,
                37.3365114
              ],
              [
                49.6533917,
                37.3383658
              ],
              [
                49.6528604,
                37.3417467
              ],
              [
                49.65338,
                37.3440727
              ],
              [
                49.6547615,
                37.3460173
              ],
              [
                49.656589,
                37.3474161
              ],
              [
                49.654578,
                37.3476268
              ],
              [
                49.6529431,
                37.3478655
              ],
              [
                49.6495155,
                37.3481104
              ],
              [
                49.6469688,
                37.3471551
              ],
              [
                49.6448041,
                37.3457623
              ],
              [
                49.643147,
                37.3468882
              ],
              [
                49.6440099,
                37.3474059
              ],
              [
                49.6442518,
                37.3483952
              ],
              [
                49.6397767,
                37.3484071
              ],
              [
                49.6369464,
                37.3488166
              ],
              [
                49.6323317,
                37.3490361
              ],
              [
                49.6279793,
                37.3494396
              ],
              [
                49.6237927,
                37.3499245
              ],
              [
                49.6111622,
                37.3509001
              ],
              [
                49.5990252,
                37.3477873
              ],
              [
                49.597907,
                37.347712
              ],
              [
                49.5913839,
                37.3485308
              ],
              [
                49.5863199,
                37.3504413
              ],
              [
                49.5836591,
                37.3525564
              ],
              [
                49.5779943,
                37.3548079
              ],
              [
                49.5712566,
                37.3594472
              ],
              [
                49.570055,
                37.35972
              ],
              [
                49.5687031,
                37.3604023
              ],
              [
                49.5686173,
                37.3623806
              ],
              [
                49.5688318,
                37.3633869
              ],
              [
                49.5691108,
                37.3653822
              ],
              [
                49.5683384,
                37.3683837
              ],
              [
                49.5673942,
                37.3722036
              ],
              [
                49.5661496,
                37.3753412
              ],
              [
                49.5642184,
                37.3780695
              ],
              [
                49.5629953,
                37.3807806
              ],
              [
                49.5605278,
                37.3818376
              ],
              [
                49.5592403,
                37.3827925
              ],
              [
                49.5565152,
                37.3848044
              ],
              [
                49.5557213,
                37.3862365
              ],
              [
                49.5547342,
                37.3869526
              ],
              [
                49.5542836,
                37.3877539
              ],
              [
                49.553842,
                37.3882996
              ],
              [
                49.5537813,
                37.3866545
              ],
              [
                49.5456176,
                37.3855769
              ],
              [
                49.5389512,
                37.3769586
              ],
              [
                49.5375608,
                37.3764099
              ],
              [
                49.5367277,
                37.3764099
              ],
              [
                49.536171,
                37.376131
              ],
              [
                49.5295045,
                37.376131
              ],
              [
                49.5217771,
                37.3772205
              ],
              [
                49.5185048,
                37.3652519
              ],
              [
                49.5126326,
                37.3613683
              ],
              [
                49.5066269,
                37.3578617
              ],
              [
                49.5023693,
                37.3493513
              ],
              [
                49.4976151,
                37.3453693
              ],
              [
                49.4900881,
                37.3364207
              ],
              [
                49.4877653,
                37.3356906
              ],
              [
                49.4846179,
                37.3313679
              ],
              [
                49.4832883,
                37.3282022
              ],
              [
                49.4829254,
                37.3270685
              ],
              [
                49.4742204,
                37.3180886
              ],
              [
                49.4734955,
                37.3175983
              ],
              [
                49.4725788,
                37.3161629
              ],
              [
                49.4688977,
                37.3129941
              ],
              [
                49.4643545,
                37.3092018
              ],
              [
                49.4624389,
                37.3078223
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555044,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رضوانشهر",
          "name:en": "Rezvanshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286355",
          "wikipedia": "en:Rezvanshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.6825133,
                37.5597993
              ],
              [
                48.6827934,
                37.5589724
              ],
              [
                48.6841799,
                37.5561951
              ],
              [
                48.6850134,
                37.5553592
              ],
              [
                48.6858466,
                37.5536964
              ],
              [
                48.6944958,
                37.5317825
              ],
              [
                48.6896893,
                37.5099985
              ],
              [
                48.7152994,
                37.4741889
              ],
              [
                48.7318804,
                37.4570545
              ],
              [
                48.7359667,
                37.450833
              ],
              [
                48.7414126,
                37.4450183
              ],
              [
                48.7481402,
                37.4364985
              ],
              [
                48.7570134,
                37.429946
              ],
              [
                48.7640189,
                37.4240256
              ],
              [
                48.7668746,
                37.4205747
              ],
              [
                48.8000253,
                37.3919627
              ],
              [
                48.8064153,
                37.3930692
              ],
              [
                48.8089154,
                37.3941847
              ],
              [
                48.809192,
                37.3944636
              ],
              [
                48.8169722,
                37.398071
              ],
              [
                48.8178055,
                37.398071
              ],
              [
                48.8389153,
                37.4094596
              ],
              [
                48.8689183,
                37.4216846
              ],
              [
                48.8697515,
                37.4219635
              ],
              [
                48.880759,
                37.4250906
              ],
              [
                48.8851031,
                37.4293324
              ],
              [
                48.8864187,
                37.4305511
              ],
              [
                48.890585,
                37.4259648
              ],
              [
                48.9027661,
                37.4225755
              ],
              [
                48.9432819,
                37.4249432
              ],
              [
                48.9713306,
                37.433671
              ],
              [
                48.9935742,
                37.4376956
              ],
              [
                48.999898,
                37.4484879
              ],
              [
                49.0078429,
                37.4453703
              ],
              [
                49.0118128,
                37.4447666
              ],
              [
                49.0306644,
                37.4457333
              ],
              [
                49.0463184,
                37.4447214
              ],
              [
                49.0612498,
                37.4427451
              ],
              [
                49.0662447,
                37.4484074
              ],
              [
                49.0767877,
                37.4517462
              ],
              [
                49.0774051,
                37.4563178
              ],
              [
                49.0737364,
                37.4619726
              ],
              [
                49.0614756,
                37.4668161
              ],
              [
                49.0523363,
                37.4546889
              ],
              [
                49.0476894,
                37.4568731
              ],
              [
                49.0418529,
                37.4676374
              ],
              [
                49.0424537,
                37.4689317
              ],
              [
                49.0408229,
                37.4719291
              ],
              [
                49.0410804,
                37.4764248
              ],
              [
                49.0428828,
                37.4805798
              ],
              [
                49.0455436,
                37.4828955
              ],
              [
                49.0567874,
                37.480716
              ],
              [
                49.0699195,
                37.4845301
              ],
              [
                49.0950679,
                37.4754712
              ],
              [
                49.1047602,
                37.4750779
              ],
              [
                49.1238563,
                37.4744702
              ],
              [
                49.1365666,
                37.4741168
              ],
              [
                49.1473303,
                37.4738443
              ],
              [
                49.1654142,
                37.4732249
              ],
              [
                49.1651058,
                37.4746538
              ],
              [
                49.1655778,
                37.4779574
              ],
              [
                49.1687585,
                37.4809768
              ],
              [
                49.1726072,
                37.4851137
              ],
              [
                49.1780064,
                37.489075
              ],
              [
                49.1847396,
                37.4917152
              ],
              [
                49.1904473,
                37.4947116
              ],
              [
                49.1919708,
                37.4947456
              ],
              [
                49.1998458,
                37.4969418
              ],
              [
                49.2034292,
                37.4974184
              ],
              [
                49.2184764,
                37.4983058
              ],
              [
                49.2179051,
                37.4988825
              ],
              [
                49.2167513,
                37.4996699
              ],
              [
                49.214186,
                37.5025713
              ],
              [
                49.2145013,
                37.5037341
              ],
              [
                49.2137466,
                37.5098058
              ],
              [
                49.2128166,
                37.516656
              ],
              [
                49.2120202,
                37.5223338
              ],
              [
                49.2099862,
                37.5277223
              ],
              [
                49.2059611,
                37.5337561
              ],
              [
                49.1943558,
                37.5413557
              ],
              [
                49.1914157,
                37.54646
              ],
              [
                49.1936212,
                37.5557252
              ],
              [
                49.1934494,
                37.5574662
              ],
              [
                49.1996489,
                37.5715232
              ],
              [
                49.3413851,
                37.7379712
              ],
              [
                49.3353924,
                37.7414258
              ],
              [
                49.3290805,
                37.7448372
              ],
              [
                49.3222644,
                37.7491958
              ],
              [
                49.3190021,
                37.7512114
              ],
              [
                49.3184896,
                37.7515618
              ],
              [
                49.3122939,
                37.7555724
              ],
              [
                49.3059406,
                37.7594248
              ],
              [
                49.2994363,
                37.7631152
              ],
              [
                49.2972598,
                37.7642689
              ],
              [
                49.2962586,
                37.7650273
              ],
              [
                49.2883839,
                37.7705144
              ],
              [
                49.2679205,
                37.7859607
              ],
              [
                49.0545429,
                37.6762309
              ],
              [
                49.0326214,
                37.6630113
              ],
              [
                49.0257955,
                37.6587964
              ],
              [
                49.0169992,
                37.6560035
              ],
              [
                49.010154,
                37.6484727
              ],
              [
                49.0036583,
                37.6458739
              ],
              [
                49.0081214,
                37.6366647
              ],
              [
                48.991642,
                37.6244292
              ],
              [
                48.982501,
                37.6260607
              ],
              [
                48.9722923,
                37.6341125
              ],
              [
                48.947207,
                37.6221916
              ],
              [
                48.926355,
                37.6125035
              ],
              [
                48.8936233,
                37.5971641
              ],
              [
                48.8792429,
                37.5909664
              ],
              [
                48.8720937,
                37.587872
              ],
              [
                48.8566944,
                37.5975226
              ],
              [
                48.8330814,
                37.5900223
              ],
              [
                48.831138,
                37.5897436
              ],
              [
                48.8294715,
                37.5889071
              ],
              [
                48.8283614,
                37.5889071
              ],
              [
                48.8153048,
                37.5850221
              ],
              [
                48.7776218,
                37.5748682
              ],
              [
                48.7770653,
                37.5745894
              ],
              [
                48.7635037,
                37.5813174
              ],
              [
                48.7501141,
                37.5832219
              ],
              [
                48.68946,
                37.5634124
              ],
              [
                48.6889034,
                37.5631338
              ],
              [
                48.6825133,
                37.5597993
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555048,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رودبار",
          "name:en": "Rudbar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291695",
          "wikipedia": "en:Rudbar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.1996944,
                36.9594611
              ],
              [
                49.2061682,
                36.9455976
              ],
              [
                49.2220402,
                36.9263899
              ],
              [
                49.2270998,
                36.9200325
              ],
              [
                49.2298946,
                36.9167409
              ],
              [
                49.2326744,
                36.9130993
              ],
              [
                49.2393046,
                36.902649
              ],
              [
                49.2443617,
                36.8849074
              ],
              [
                49.2499516,
                36.8729205
              ],
              [
                49.2589381,
                36.854392
              ],
              [
                49.2638796,
                36.8454154
              ],
              [
                49.2681048,
                36.8365409
              ],
              [
                49.2758416,
                36.8151799
              ],
              [
                49.2862068,
                36.8119117
              ],
              [
                49.2948302,
                36.8065297
              ],
              [
                49.3018153,
                36.7989611
              ],
              [
                49.3194293,
                36.7779425
              ],
              [
                49.3211792,
                36.7737582
              ],
              [
                49.3277165,
                36.7583896
              ],
              [
                49.3321021,
                36.7487899
              ],
              [
                49.3421144,
                36.7421042
              ],
              [
                49.3610896,
                36.7327297
              ],
              [
                49.3677225,
                36.7257603
              ],
              [
                49.3729831,
                36.7191383
              ],
              [
                49.3792987,
                36.7107355
              ],
              [
                49.3870137,
                36.7011122
              ],
              [
                49.3935211,
                36.6961411
              ],
              [
                49.4019774,
                36.6912978
              ],
              [
                49.4088969,
                36.6867629
              ],
              [
                49.4143024,
                36.6842459
              ],
              [
                49.4178431,
                36.6827727
              ],
              [
                49.4233522,
                36.6831764
              ],
              [
                49.4380947,
                36.6625316
              ],
              [
                49.4414362,
                36.6614954
              ],
              [
                49.4466246,
                36.6626258
              ],
              [
                49.4475895,
                36.6620989
              ],
              [
                49.4487522,
                36.6622868
              ],
              [
                49.4525931,
                36.658955
              ],
              [
                49.4577737,
                36.6516337
              ],
              [
                49.4608001,
                36.6507347
              ],
              [
                49.462808,
                36.6503054
              ],
              [
                49.464333,
                36.6499639
              ],
              [
                49.4657119,
                36.6495323
              ],
              [
                49.4669264,
                36.649399
              ],
              [
                49.4697818,
                36.6479365
              ],
              [
                49.4712638,
                36.6458688
              ],
              [
                49.472524,
                36.6449663
              ],
              [
                49.4750833,
                36.6449047
              ],
              [
                49.4774007,
                36.6441128
              ],
              [
                49.479065,
                36.6430738
              ],
              [
                49.4799971,
                36.6430453
              ],
              [
                49.4802332,
                36.6421328
              ],
              [
                49.4790744,
                36.6411515
              ],
              [
                49.4780445,
                36.6401872
              ],
              [
                49.4772934,
                36.6398774
              ],
              [
                49.4731262,
                36.636923
              ],
              [
                49.4750603,
                36.6130538
              ],
              [
                49.4789502,
                36.6108293
              ],
              [
                49.484227,
                36.6080555
              ],
              [
                49.4853403,
                36.6074971
              ],
              [
                49.493117,
                36.6036066
              ],
              [
                49.4997836,
                36.6008328
              ],
              [
                49.5092302,
                36.6033275
              ],
              [
                49.5120065,
                36.6033275
              ],
              [
                49.5125635,
                36.6036066
              ],
              [
                49.5131166,
                36.6033275
              ],
              [
                49.5139499,
                36.6036067
              ],
              [
                49.5147831,
                36.6036067
              ],
              [
                49.5153401,
                36.6033275
              ],
              [
                49.5156166,
                36.6036066
              ],
              [
                49.5186734,
                36.6036066
              ],
              [
                49.5208965,
                36.6041651
              ],
              [
                49.52312,
                36.604165
              ],
              [
                49.5242298,
                36.6044442
              ],
              [
                49.5331197,
                36.6044443
              ],
              [
                49.5333964,
                36.6047235
              ],
              [
                49.5433962,
                36.6047234
              ],
              [
                49.5531195,
                36.6066597
              ],
              [
                49.5570928,
                36.6059535
              ],
              [
                49.5611107,
                36.6041792
              ],
              [
                49.5660461,
                36.6051949
              ],
              [
                49.5698693,
                36.6042744
              ],
              [
                49.5733968,
                36.604348
              ],
              [
                49.5753892,
                36.6034213
              ],
              [
                49.5782559,
                36.6034214
              ],
              [
                49.5807739,
                36.6027823
              ],
              [
                49.582331,
                36.6019827
              ],
              [
                49.5848346,
                36.6002482
              ],
              [
                49.5903019,
                36.5975781
              ],
              [
                49.5938943,
                36.5977811
              ],
              [
                49.5959806,
                36.5985437
              ],
              [
                49.6003948,
                36.5973071
              ],
              [
                49.6054729,
                36.5989274
              ],
              [
                49.606286,
                36.6001176
              ],
              [
                49.6088603,
                36.5989188
              ],
              [
                49.6133652,
                36.5983985
              ],
              [
                49.6156993,
                36.6000178
              ],
              [
                49.6156005,
                36.6013407
              ],
              [
                49.6190293,
                36.5996625
              ],
              [
                49.62192,
                36.6014251
              ],
              [
                49.6220247,
                36.6028964
              ],
              [
                49.6250647,
                36.601377
              ],
              [
                49.6311786,
                36.6024991
              ],
              [
                49.6700864,
                36.6028334
              ],
              [
                49.6760745,
                36.5997877
              ],
              [
                49.6841241,
                36.5969795
              ],
              [
                49.6954536,
                36.5927898
              ],
              [
                49.7042941,
                36.5866563
              ],
              [
                49.7198295,
                36.5825901
              ],
              [
                49.7220611,
                36.5775586
              ],
              [
                49.7267818,
                36.5718375
              ],
              [
                49.7301292,
                36.5618418
              ],
              [
                49.7326182,
                36.5587394
              ],
              [
                49.7374334,
                36.5571151
              ],
              [
                49.7428763,
                36.559735
              ],
              [
                49.7454598,
                36.5637231
              ],
              [
                49.7491388,
                36.5680661
              ],
              [
                49.750462,
                36.5692346
              ],
              [
                49.7583062,
                36.5683384
              ],
              [
                49.7642646,
                36.5665516
              ],
              [
                49.7687026,
                36.5641354
              ],
              [
                49.7731303,
                36.5610145
              ],
              [
                49.7811126,
                36.5581189
              ],
              [
                49.7853183,
                36.5570847
              ],
              [
                49.7889488,
                36.5566251
              ],
              [
                49.7939014,
                36.5556369
              ],
              [
                49.7987079,
                36.5553611
              ],
              [
                49.8020553,
                36.5561195
              ],
              [
                49.8045444,
                36.5577742
              ],
              [
                49.8077201,
                36.5562574
              ],
              [
                49.8116683,
                36.5530858
              ],
              [
                49.8295211,
                36.5503968
              ],
              [
                49.8615622,
                36.5527982
              ],
              [
                49.8647117,
                36.5549474
              ],
              [
                49.8672866,
                36.5559816
              ],
              [
                49.871149,
                36.5561195
              ],
              [
                49.8770713,
                36.5546027
              ],
              [
                49.8795604,
                36.5548095
              ],
              [
                49.8827361,
                36.55674
              ],
              [
                49.8895789,
                36.5647416
              ],
              [
                49.8901175,
                36.5744569
              ],
              [
                49.8905897,
                36.5779032
              ],
              [
                49.8918771,
                36.5804534
              ],
              [
                49.893894,
                36.5842098
              ],
              [
                49.8979282,
                36.5859671
              ],
              [
                49.9051164,
                36.5898783
              ],
              [
                49.9062967,
                36.5912048
              ],
              [
                49.9060177,
                36.5921524
              ],
              [
                49.9041939,
                36.5933928
              ],
              [
                49.9036788,
                36.594237
              ],
              [
                49.9033999,
                36.5949949
              ],
              [
                49.9035071,
                36.5959597
              ],
              [
                49.9050521,
                36.5972001
              ],
              [
                49.9062753,
                36.5977513
              ],
              [
                49.9073694,
                36.5979582
              ],
              [
                49.9079919,
                36.5987333
              ],
              [
                49.9086571,
                36.5999908
              ],
              [
                49.9089789,
                36.6011622
              ],
              [
                49.9090218,
                36.6023681
              ],
              [
                49.9085712,
                36.6036256
              ],
              [
                49.9085498,
                36.6059165
              ],
              [
                49.9089359,
                36.606485
              ],
              [
                49.9094295,
                36.6069846
              ],
              [
                49.9105668,
                36.6072257
              ],
              [
                49.9124335,
                36.607932
              ],
              [
                49.9131202,
                36.609396
              ],
              [
                49.9122405,
                36.6119968
              ],
              [
                49.9107384,
                36.6137536
              ],
              [
                49.9096656,
                36.6162855
              ],
              [
                49.9082708,
                36.6174911
              ],
              [
                49.9083568,
                36.6190047
              ],
              [
                49.9087214,
                36.6199194
              ],
              [
                49.9094081,
                36.6206083
              ],
              [
                49.9121868,
                36.6221621
              ],
              [
                49.9153089,
                36.6234499
              ],
              [
                49.917283,
                36.6244143
              ],
              [
                49.9177122,
                36.6259642
              ],
              [
                49.918828,
                36.6267563
              ],
              [
                49.923377,
                36.6270663
              ],
              [
                49.9261665,
                36.6257231
              ],
              [
                49.9289131,
                36.625172
              ],
              [
                49.9389123,
                36.6188344
              ],
              [
                49.9409294,
                36.6192133
              ],
              [
                49.9449634,
                36.6187655
              ],
              [
                49.9500703,
                36.6201089
              ],
              [
                49.9550914,
                36.6195234
              ],
              [
                49.9618718,
                36.6179391
              ],
              [
                49.9733733,
                36.6157344
              ],
              [
                49.9919986,
                36.61787
              ],
              [
                50.001011,
                36.6153071
              ],
              [
                50.0134563,
                36.6085692
              ],
              [
                50.0197219,
                36.6082247
              ],
              [
                50.028305,
                36.6066401
              ],
              [
                50.033884,
                36.6062956
              ],
              [
                50.0381755,
                36.6083625
              ],
              [
                50.0395429,
                36.6124079
              ],
              [
                50.0440067,
                36.6136233
              ],
              [
                50.04626,
                36.6130272
              ],
              [
                50.0519417,
                36.6090985
              ],
              [
                50.0524948,
                36.609657
              ],
              [
                50.0580516,
                36.6124317
              ],
              [
                50.0619415,
                36.6146658
              ],
              [
                50.0664135,
                36.6342644
              ],
              [
                50.0628051,
                36.6719981
              ],
              [
                50.0673288,
                36.6752866
              ],
              [
                50.0781546,
                36.679457
              ],
              [
                50.0805759,
                36.6792269
              ],
              [
                50.085554,
                36.6806036
              ],
              [
                50.08255,
                36.6837699
              ],
              [
                50.074396,
                36.6856284
              ],
              [
                50.0617789,
                36.6884503
              ],
              [
                50.0455569,
                36.6899645
              ],
              [
                50.0325965,
                36.6907904
              ],
              [
                50.0225543,
                36.6918228
              ],
              [
                50.0193786,
                36.6927175
              ],
              [
                50.0142287,
                36.6934746
              ],
              [
                50.0113105,
                36.6947822
              ],
              [
                50.0099372,
                36.6949198
              ],
              [
                50.0059032,
                36.6959521
              ],
              [
                50.0031566,
                36.6976038
              ],
              [
                50.0014936,
                36.697864
              ],
              [
                49.9915693,
                36.7020082
              ],
              [
                49.9841012,
                36.7163111
              ],
              [
                49.9811362,
                36.7289953
              ],
              [
                49.9798857,
                36.7464038
              ],
              [
                49.9795487,
                36.769349
              ],
              [
                49.978992,
                36.7701774
              ],
              [
                49.9773255,
                36.7796228
              ],
              [
                49.9784222,
                36.7988893
              ],
              [
                49.976944,
                36.8107014
              ],
              [
                49.9743104,
                36.8185356
              ],
              [
                49.9492475,
                36.7878638
              ],
              [
                49.9456373,
                36.7867472
              ],
              [
                49.9296678,
                36.7714611
              ],
              [
                49.9192021,
                36.7689429
              ],
              [
                49.917873,
                36.7690505
              ],
              [
                49.9143921,
                36.7697208
              ],
              [
                49.9061977,
                36.7735158
              ],
              [
                49.8968746,
                36.7761208
              ],
              [
                49.8968134,
                36.7761434
              ],
              [
                49.8959553,
                36.776461
              ],
              [
                49.8617743,
                36.7891088
              ],
              [
                49.8491657,
                36.7966252
              ],
              [
                49.8341817,
                36.8129834
              ],
              [
                49.8333105,
                36.8165292
              ],
              [
                49.827185,
                36.8320421
              ],
              [
                49.8245237,
                36.8387811
              ],
              [
                49.8133989,
                36.8466531
              ],
              [
                49.8086521,
                36.8552853
              ],
              [
                49.7996485,
                36.860487
              ],
              [
                49.7961645,
                36.8626587
              ],
              [
                49.7912209,
                36.8718605
              ],
              [
                49.790731,
                36.8740023
              ],
              [
                49.7879815,
                36.8776317
              ],
              [
                49.785241,
                36.8799794
              ],
              [
                49.7820665,
                36.8823569
              ],
              [
                49.7777133,
                36.8849751
              ],
              [
                49.772039,
                36.8878203
              ],
              [
                49.764803,
                36.891084
              ],
              [
                49.7576838,
                36.8932315
              ],
              [
                49.7489804,
                36.8954828
              ],
              [
                49.7428605,
                36.8970239
              ],
              [
                49.7375787,
                36.8990727
              ],
              [
                49.7320073,
                36.9015936
              ],
              [
                49.7262671,
                36.9061994
              ],
              [
                49.726559,
                36.9096647
              ],
              [
                49.727052,
                36.9140885
              ],
              [
                49.7306441,
                36.9216265
              ],
              [
                49.7340773,
                36.9269786
              ],
              [
                49.7360514,
                36.9332221
              ],
              [
                49.7459219,
                36.9448159
              ],
              [
                49.7449778,
                36.9474911
              ],
              [
                49.7401713,
                36.9522926
              ],
              [
                49.7396305,
                36.9570655
              ],
              [
                49.7396453,
                36.964172
              ],
              [
                49.7385146,
                36.9700583
              ],
              [
                49.7372467,
                36.9746573
              ],
              [
                49.7417882,
                36.9993148
              ],
              [
                49.7368136,
                37.0134162
              ],
              [
                49.743347,
                37.0435317
              ],
              [
                49.7454928,
                37.0555197
              ],
              [
                49.7448062,
                37.0638759
              ],
              [
                49.7434329,
                37.066136
              ],
              [
                49.7334766,
                37.0663415
              ],
              [
                49.7322273,
                37.0713621
              ],
              [
                49.7247183,
                37.0771155
              ],
              [
                49.7176441,
                37.0819879
              ],
              [
                49.7137877,
                37.0867495
              ],
              [
                49.7161934,
                37.0912601
              ],
              [
                49.7211832,
                37.0950059
              ],
              [
                49.7242068,
                37.0972915
              ],
              [
                49.724121,
                37.1007144
              ],
              [
                49.7248935,
                37.1035211
              ],
              [
                49.7283267,
                37.1055747
              ],
              [
                49.7327041,
                37.1091341
              ],
              [
                49.7336053,
                37.1156536
              ],
              [
                49.7352468,
                37.1175358
              ],
              [
                49.7364699,
                37.1201451
              ],
              [
                49.7379183,
                37.1229681
              ],
              [
                49.7396226,
                37.1245029
              ],
              [
                49.7365987,
                37.1233273
              ],
              [
                49.7341847,
                37.1221982
              ],
              [
                49.7310948,
                37.1216592
              ],
              [
                49.7264408,
                37.1196798
              ],
              [
                49.7257895,
                37.1193034
              ],
              [
                49.7275542,
                37.1185111
              ],
              [
                49.7268676,
                37.1175529
              ],
              [
                49.7212028,
                37.1111876
              ],
              [
                49.720087,
                37.1083812
              ],
              [
                49.7167396,
                37.1034527
              ],
              [
                49.7155379,
                37.1005091
              ],
              [
                49.7133063,
                37.0994822
              ],
              [
                49.7120189,
                37.0980446
              ],
              [
                49.7097015,
                37.0944846
              ],
              [
                49.7077273,
                37.0896237
              ],
              [
                49.7048949,
                37.0863372
              ],
              [
                49.7010326,
                37.0831191
              ],
              [
                49.6991443,
                37.0811333
              ],
              [
                49.6963119,
                37.0773672
              ],
              [
                49.6933078,
                37.0759291
              ],
              [
                49.6838664,
                37.0721627
              ],
              [
                49.675455,
                37.066136
              ],
              [
                49.6709918,
                37.0608623
              ],
              [
                49.6703259,
                37.058102
              ],
              [
                49.6682062,
                37.0553741
              ],
              [
                49.6662893,
                37.0496907
              ],
              [
                49.6563842,
                37.0429855
              ],
              [
                49.6530401,
                37.0396793
              ],
              [
                49.6513792,
                37.0362035
              ],
              [
                49.6456966,
                37.0290627
              ],
              [
                49.6393203,
                37.0259915
              ],
              [
                49.6376466,
                37.0247923
              ],
              [
                49.6338498,
                37.0234629
              ],
              [
                49.6282064,
                37.0192264
              ],
              [
                49.6169741,
                37.0161963
              ],
              [
                49.6099662,
                37.0157808
              ],
              [
                49.5997523,
                37.0277732
              ],
              [
                49.5885944,
                37.0381193
              ],
              [
                49.5850737,
                37.0446873
              ],
              [
                49.5722321,
                37.0501248
              ],
              [
                49.5603132,
                37.0541601
              ],
              [
                49.5466718,
                37.0562363
              ],
              [
                49.5412097,
                37.0555614
              ],
              [
                49.5318273,
                37.0543739
              ],
              [
                49.5254962,
                37.0528207
              ],
              [
                49.5219054,
                37.0512279
              ],
              [
                49.5184922,
                37.0502109
              ],
              [
                49.517312,
                37.0502451
              ],
              [
                49.5135355,
                37.048858
              ],
              [
                49.5093941,
                37.0459808
              ],
              [
                49.5070553,
                37.0422471
              ],
              [
                49.5054459,
                37.0377425
              ],
              [
                49.5057893,
                37.0353445
              ],
              [
                49.5073128,
                37.0317473
              ],
              [
                49.5103597,
                37.0275504
              ],
              [
                49.5186424,
                37.0230107
              ],
              [
                49.5281482,
                37.0216401
              ],
              [
                49.5328903,
                37.0223083
              ],
              [
                49.5369887,
                37.0220684
              ],
              [
                49.5399713,
                37.0191045
              ],
              [
                49.5380616,
                37.0167059
              ],
              [
                49.5343494,
                37.0131764
              ],
              [
                49.525187,
                37.0107091
              ],
              [
                49.5225262,
                37.0114973
              ],
              [
                49.5218181,
                37.011206
              ],
              [
                49.515574,
                37.0121141
              ],
              [
                49.5117545,
                37.0129537
              ],
              [
                49.5084071,
                37.0138789
              ],
              [
                49.5048237,
                37.0154038
              ],
              [
                49.5015836,
                37.0165346
              ],
              [
                49.5011759,
                37.0172371
              ],
              [
                49.5003176,
                37.0182479
              ],
              [
                49.4997382,
                37.0184021
              ],
              [
                49.4964552,
                37.0231648
              ],
              [
                49.4954681,
                37.0245525
              ],
              [
                49.493943,
                37.0277589
              ],
              [
                49.4768834,
                37.0199663
              ],
              [
                49.4630897,
                37.0139396
              ],
              [
                49.4496229,
                37.0075041
              ],
              [
                49.4135606,
                36.9907687
              ],
              [
                49.3847769,
                36.9816696
              ],
              [
                49.3822773,
                36.9808415
              ],
              [
                49.3800538,
                36.9797254
              ],
              [
                49.3694022,
                36.9756203
              ],
              [
                49.3566541,
                36.9718399
              ],
              [
                49.3451785,
                36.9663523
              ],
              [
                49.3387702,
                36.9653406
              ],
              [
                49.3249119,
                36.9603341
              ],
              [
                49.31378,
                36.9582187
              ],
              [
                49.2935964,
                36.9536087
              ],
              [
                49.2764903,
                36.9514286
              ],
              [
                49.2733812,
                36.9497546
              ],
              [
                49.2711461,
                36.9491699
              ],
              [
                49.2688322,
                36.9495146
              ],
              [
                49.2616735,
                36.9494443
              ],
              [
                49.2541571,
                36.9492822
              ],
              [
                49.2480982,
                36.9489787
              ],
              [
                49.2427047,
                36.948949
              ],
              [
                49.2297725,
                36.9508696
              ],
              [
                49.2229942,
                36.9525548
              ],
              [
                49.1996944,
                36.9594611
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555050,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رودسر",
          "name:en": "Rudsar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2570961",
          "wikipedia": "en:Rudsar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.1098726,
                36.7383187
              ],
              [
                50.1124893,
                36.7303357
              ],
              [
                50.1160238,
                36.7137059
              ],
              [
                50.1209162,
                36.6850089
              ],
              [
                50.1253055,
                36.6737765
              ],
              [
                50.1309756,
                36.6719329
              ],
              [
                50.142288,
                36.6723432
              ],
              [
                50.1538753,
                36.6743394
              ],
              [
                50.166149,
                36.6780568
              ],
              [
                50.2012056,
                36.6780559
              ],
              [
                50.2214853,
                36.6797219
              ],
              [
                50.223985,
                36.6794517
              ],
              [
                50.2248187,
                36.6791725
              ],
              [
                50.2275953,
                36.6791725
              ],
              [
                50.230375,
                36.6786143
              ],
              [
                50.2320418,
                36.6786142
              ],
              [
                50.2417651,
                36.6761109
              ],
              [
                50.2464852,
                36.6741658
              ],
              [
                50.2506516,
                36.6722207
              ],
              [
                50.2613353,
                36.681464
              ],
              [
                50.2657446,
                36.6843132
              ],
              [
                50.2668353,
                36.6833764
              ],
              [
                50.2703475,
                36.6808101
              ],
              [
                50.2735232,
                36.6772995
              ],
              [
                50.2798747,
                36.6731692
              ],
              [
                50.2861404,
                36.6711727
              ],
              [
                50.2898311,
                36.6673863
              ],
              [
                50.2994441,
                36.6667667
              ],
              [
                50.3069972,
                36.6607768
              ],
              [
                50.3106879,
                36.6587801
              ],
              [
                50.313177,
                36.6551307
              ],
              [
                50.314207,
                36.6528584
              ],
              [
                50.3178977,
                36.650586
              ],
              [
                50.3211716,
                36.6463619
              ],
              [
                50.323411,
                36.6448662
              ],
              [
                50.3252539,
                36.6429379
              ],
              [
                50.3272641,
                36.6395903
              ],
              [
                50.3293132,
                36.6389476
              ],
              [
                50.3321456,
                36.6387582
              ],
              [
                50.3342888,
                36.6376263
              ],
              [
                50.3382826,
                36.6365542
              ],
              [
                50.3397845,
                36.6366059
              ],
              [
                50.3464793,
                36.6366748
              ],
              [
                50.3493117,
                36.637639
              ],
              [
                50.3505992,
                36.6390853
              ],
              [
                50.3531741,
                36.6436307
              ],
              [
                50.3635962,
                36.6533413
              ],
              [
                50.3775119,
                36.6636305
              ],
              [
                50.3834724,
                36.6675928
              ],
              [
                50.3854465,
                36.6680059
              ],
              [
                50.4125978,
                36.6873202
              ],
              [
                50.4122256,
                36.6969844
              ],
              [
                50.4131481,
                36.7074981
              ],
              [
                50.4129323,
                36.7125977
              ],
              [
                50.4154014,
                36.7231315
              ],
              [
                50.4172896,
                36.724301
              ],
              [
                50.4174613,
                36.7282222
              ],
              [
                50.4197787,
                36.7313178
              ],
              [
                50.4246711,
                36.7373022
              ],
              [
                50.4266452,
                36.7384027
              ],
              [
                50.4310226,
                36.7429422
              ],
              [
                50.433855,
                36.7476878
              ],
              [
                50.4355716,
                36.7487194
              ],
              [
                50.4360866,
                36.7533959
              ],
              [
                50.4359149,
                36.7604787
              ],
              [
                50.4364299,
                36.7658421
              ],
              [
                50.4370843,
                36.7703113
              ],
              [
                50.4369019,
                36.7739379
              ],
              [
                50.4349279,
                36.7771175
              ],
              [
                50.4303787,
                36.7828578
              ],
              [
                50.4286192,
                36.7915533
              ],
              [
                50.4254436,
                36.7956084
              ],
              [
                50.4214094,
                36.7996636
              ],
              [
                50.4159163,
                36.8030999
              ],
              [
                50.4078482,
                36.8050241
              ],
              [
                50.4047583,
                36.8116212
              ],
              [
                50.4126547,
                36.8164313
              ],
              [
                50.423126,
                36.8267375
              ],
              [
                50.4221654,
                36.8355556
              ],
              [
                50.4232977,
                36.8440488
              ],
              [
                50.4314518,
                36.8526685
              ],
              [
                50.4354384,
                36.8565305
              ],
              [
                50.4400561,
                36.8617295
              ],
              [
                50.4431018,
                36.8647941
              ],
              [
                50.4447614,
                36.8667343
              ],
              [
                50.4468139,
                36.8683225
              ],
              [
                50.4494471,
                36.870738
              ],
              [
                50.4513645,
                36.8717935
              ],
              [
                50.4532527,
                36.8722055
              ],
              [
                50.4549694,
                36.8729264
              ],
              [
                50.4575598,
                36.8733138
              ],
              [
                50.4650518,
                36.8734855
              ],
              [
                50.4689169,
                36.873716
              ],
              [
                50.4723404,
                36.8744124
              ],
              [
                50.4813398,
                36.8768973
              ],
              [
                50.4864692,
                36.8775953
              ],
              [
                50.49046,
                36.8777485
              ],
              [
                50.4999446,
                36.8768916
              ],
              [
                50.5054163,
                36.8802901
              ],
              [
                50.506854,
                36.8821608
              ],
              [
                50.5080986,
                36.8841518
              ],
              [
                50.5086135,
                36.8855935
              ],
              [
                50.5099868,
                36.8895751
              ],
              [
                50.510232,
                36.8915141
              ],
              [
                50.5150987,
                36.8865545
              ],
              [
                50.5198544,
                36.8882106
              ],
              [
                50.5217878,
                36.8884766
              ],
              [
                50.521473,
                36.8868327
              ],
              [
                50.5226033,
                36.8867565
              ],
              [
                50.5258783,
                36.8927975
              ],
              [
                50.5336375,
                36.9027241
              ],
              [
                50.5350672,
                36.904424
              ],
              [
                50.5359444,
                36.9055611
              ],
              [
                50.5375697,
                36.9069771
              ],
              [
                50.5400672,
                36.9090291
              ],
              [
                50.5578803,
                36.9252631
              ],
              [
                50.5628585,
                36.9299288
              ],
              [
                50.5660342,
                36.9361721
              ],
              [
                50.5674278,
                36.9411326
              ],
              [
                50.5684621,
                36.9487785
              ],
              [
                50.5730036,
                36.9524367
              ],
              [
                50.5811996,
                36.952741
              ],
              [
                50.5853596,
                36.9553636
              ],
              [
                50.5888539,
                36.960171
              ],
              [
                50.5857445,
                36.9672624
              ],
              [
                50.5875665,
                36.968186
              ],
              [
                50.7315385,
                37.1374371
              ],
              [
                50.7272483,
                37.1401417
              ],
              [
                50.7228852,
                37.1427706
              ],
              [
                50.7184511,
                37.1453225
              ],
              [
                50.7139482,
                37.1477961
              ],
              [
                50.7093788,
                37.1501904
              ],
              [
                50.7047448,
                37.1525041
              ],
              [
                50.7000487,
                37.1547362
              ],
              [
                50.6942799,
                37.1573291
              ],
              [
                50.6884271,
                37.1597988
              ],
              [
                50.6720796,
                37.1664753
              ],
              [
                50.6652526,
                37.1691586
              ],
              [
                50.6583265,
                37.1716745
              ],
              [
                50.6513077,
                37.1740203
              ],
              [
                50.6442026,
                37.1761941
              ],
              [
                50.6390503,
                37.1776481
              ],
              [
                50.6338593,
                37.1790115
              ],
              [
                50.6286322,
                37.1802837
              ],
              [
                50.6233715,
                37.1814641
              ],
              [
                50.6180797,
                37.1825523
              ],
              [
                50.6127594,
                37.1835475
              ],
              [
                50.6087603,
                37.1842221
              ],
              [
                50.6079066,
                37.1856549
              ],
              [
                50.6054481,
                37.1895591
              ],
              [
                50.6028834,
                37.1934193
              ],
              [
                50.6002138,
                37.1972338
              ],
              [
                50.5974406,
                37.2010008
              ],
              [
                50.594565,
                37.2047184
              ],
              [
                50.5915884,
                37.2083849
              ],
              [
                50.5885122,
                37.2119984
              ],
              [
                50.5853379,
                37.2155574
              ],
              [
                50.582067,
                37.21906
              ],
              [
                50.578701,
                37.2225046
              ],
              [
                50.5752416,
                37.2258896
              ],
              [
                50.5711045,
                37.2297477
              ],
              [
                50.566846,
                37.2335205
              ],
              [
                50.5624688,
                37.2372055
              ],
              [
                50.5579756,
                37.2408005
              ],
              [
                50.5564232,
                37.2420114
              ],
              [
                50.5497531,
                37.2470265
              ],
              [
                50.5428575,
                37.2518431
              ],
              [
                50.5386358,
                37.2546221
              ],
              [
                50.534339,
                37.2573266
              ],
              [
                50.5299691,
                37.2599555
              ],
              [
                50.5255282,
                37.2625073
              ],
              [
                50.5210184,
                37.2649809
              ],
              [
                50.5164419,
                37.2673752
              ],
              [
                50.514149,
                37.2686541
              ],
              [
                50.5112612,
                37.2754297
              ],
              [
                50.2737805,
                37.2124558
              ],
              [
                50.2710256,
                37.2131436
              ],
              [
                50.2657753,
                37.2134116
              ],
              [
                50.2616759,
                37.2136472
              ],
              [
                50.2608155,
                37.2113907
              ],
              [
                50.2619616,
                37.2038829
              ],
              [
                50.263244,
                37.2019342
              ],
              [
                50.2615069,
                37.1881514
              ],
              [
                50.2617644,
                37.1851427
              ],
              [
                50.2593612,
                37.1804243
              ],
              [
                50.257064,
                37.1781452
              ],
              [
                50.2557929,
                37.1751804
              ],
              [
                50.2556276,
                37.1737223
              ],
              [
                50.2566146,
                37.1724571
              ],
              [
                50.2582025,
                37.171739
              ],
              [
                50.2599191,
                37.1707815
              ],
              [
                50.2616357,
                37.1684219
              ],
              [
                50.2618932,
                37.1654124
              ],
              [
                50.2573871,
                37.1636682
              ],
              [
                50.256443,
                37.1635656
              ],
              [
                50.2526106,
                37.1615774
              ],
              [
                50.2488899,
                37.1591195
              ],
              [
                50.2415507,
                37.163968
              ],
              [
                50.2399206,
                37.1627961
              ],
              [
                50.2379036,
                37.160214
              ],
              [
                50.2374958,
                37.159359
              ],
              [
                50.2388048,
                37.1582816
              ],
              [
                50.2385472,
                37.157666
              ],
              [
                50.2374315,
                37.1569648
              ],
              [
                50.2387619,
                37.1555624
              ],
              [
                50.237174,
                37.1550494
              ],
              [
                50.2362728,
                37.1553572
              ],
              [
                50.2318096,
                37.1546389
              ],
              [
                50.226531,
                37.1535786
              ],
              [
                50.2196216,
                37.1512185
              ],
              [
                50.2187204,
                37.1498503
              ],
              [
                50.213871,
                37.1447192
              ],
              [
                50.211811,
                37.1430429
              ],
              [
                50.2066612,
                37.1477637
              ],
              [
                50.2040863,
                37.149303
              ],
              [
                50.2030563,
                37.1491319
              ],
              [
                50.2004814,
                37.1511843
              ],
              [
                50.1962328,
                37.1489267
              ],
              [
                50.1951891,
                37.1437503
              ],
              [
                50.1987854,
                37.1359378
              ],
              [
                50.1956678,
                37.134579
              ],
              [
                50.1963188,
                37.1342656
              ],
              [
                50.1991228,
                37.1344668
              ],
              [
                50.2005188,
                37.1352498
              ],
              [
                50.2017045,
                37.1354823
              ],
              [
                50.2033138,
                37.1353284
              ],
              [
                50.2057395,
                37.1347656
              ],
              [
                50.2088499,
                37.1352771
              ],
              [
                50.2119787,
                37.1341155
              ],
              [
                50.2136564,
                37.1323347
              ],
              [
                50.2166258,
                37.1304785
              ],
              [
                50.2198181,
                37.1317443
              ],
              [
                50.2284203,
                37.1325945
              ],
              [
                50.2370075,
                37.1335064
              ],
              [
                50.2411222,
                37.1293238
              ],
              [
                50.2426242,
                37.1260049
              ],
              [
                50.2441263,
                37.1241229
              ],
              [
                50.2466154,
                37.122412
              ],
              [
                50.2484607,
                37.1221383
              ],
              [
                50.249834,
                37.1220014
              ],
              [
                50.2517223,
                37.1224462
              ],
              [
                50.2531814,
                37.1240887
              ],
              [
                50.2546835,
                37.1239518
              ],
              [
                50.2590179,
                37.1256627
              ],
              [
                50.2603912,
                37.1251837
              ],
              [
                50.2617216,
                37.1243967
              ],
              [
                50.2625799,
                37.1221041
              ],
              [
                50.2615928,
                37.1200167
              ],
              [
                50.2583312,
                37.1189217
              ],
              [
                50.2560138,
                37.1171422
              ],
              [
                50.2546405,
                37.1145071
              ],
              [
                50.2543401,
                37.1114956
              ],
              [
                50.255803,
                37.1084983
              ],
              [
                50.2596488,
                37.1032877
              ],
              [
                50.2603739,
                37.1016756
              ],
              [
                50.2639404,
                37.0950871
              ],
              [
                50.2632451,
                37.0937486
              ],
              [
                50.2624297,
                37.0932351
              ],
              [
                50.2602839,
                37.0932694
              ],
              [
                50.2575803,
                37.0935775
              ],
              [
                50.2564429,
                37.0938685
              ],
              [
                50.2544474,
                37.0934063
              ],
              [
                50.2523017,
                37.0922595
              ],
              [
                50.2504133,
                37.0906164
              ],
              [
                50.2502631,
                37.0891444
              ],
              [
                50.2513361,
                37.0879119
              ],
              [
                50.2532672,
                37.0872958
              ],
              [
                50.2552413,
                37.0857895
              ],
              [
                50.2546682,
                37.0836218
              ],
              [
                50.2535596,
                37.0801105
              ],
              [
                50.2524438,
                37.0773331
              ],
              [
                50.25229,
                37.0752032
              ],
              [
                50.2514747,
                37.0716695
              ],
              [
                50.2542832,
                37.0701486
              ],
              [
                50.260525,
                37.0740028
              ],
              [
                50.2635877,
                37.0728748
              ],
              [
                50.2650851,
                37.0698515
              ],
              [
                50.2646342,
                37.0681464
              ],
              [
                50.2693132,
                37.0647905
              ],
              [
                50.2708626,
                37.0621978
              ],
              [
                50.2720427,
                37.0611362
              ],
              [
                50.2728683,
                37.0595117
              ],
              [
                50.2720641,
                37.0570951
              ],
              [
                50.2728367,
                37.055023
              ],
              [
                50.2737807,
                37.0539442
              ],
              [
                50.2768063,
                37.0535332
              ],
              [
                50.2774715,
                37.0521632
              ],
              [
                50.2825355,
                37.0518892
              ],
              [
                50.2839094,
                37.0481945
              ],
              [
                50.2851251,
                37.0435102
              ],
              [
                50.2851962,
                37.036475
              ],
              [
                50.2718066,
                37.0380508
              ],
              [
                50.2702022,
                37.0359959
              ],
              [
                50.2699184,
                37.0333918
              ],
              [
                50.2720641,
                37.0309936
              ],
              [
                50.2713775,
                37.028664
              ],
              [
                50.2679272,
                37.0265146
              ],
              [
                50.2691761,
                37.0179175
              ],
              [
                50.2715491,
                37.016192
              ],
              [
                50.2752399,
                37.0164661
              ],
              [
                50.2861565,
                37.0113992
              ],
              [
                50.2773161,
                37.0080213
              ],
              [
                50.2720836,
                37.0048194
              ],
              [
                50.265541,
                37.0003593
              ],
              [
                50.2598761,
                36.99371
              ],
              [
                50.2531813,
                36.991859
              ],
              [
                50.2426242,
                36.9922017
              ],
              [
                50.233097,
                36.9909677
              ],
              [
                50.2296439,
                36.9893913
              ],
              [
                50.2179908,
                36.9819179
              ],
              [
                50.2063989,
                36.9719347
              ],
              [
                50.1969443,
                36.9644575
              ],
              [
                50.1876135,
                36.9556258
              ],
              [
                50.1803012,
                36.9444129
              ],
              [
                50.1760955,
                36.9398807
              ],
              [
                50.1669737,
                36.92865
              ],
              [
                50.1578305,
                36.9151549
              ],
              [
                50.1567589,
                36.9030669
              ],
              [
                50.1562871,
                36.8733539
              ],
              [
                50.1531699,
                36.8705479
              ],
              [
                50.1521282,
                36.8688105
              ],
              [
                50.1522618,
                36.8636722
              ],
              [
                50.1539152,
                36.8583113
              ],
              [
                50.1620465,
                36.8554224
              ],
              [
                50.1498395,
                36.8353789
              ],
              [
                50.1497696,
                36.8269983
              ],
              [
                50.1513764,
                36.8210086
              ],
              [
                50.1529516,
                36.8130197
              ],
              [
                50.1539611,
                36.8117242
              ],
              [
                50.1541972,
                36.8094565
              ],
              [
                50.1571369,
                36.8072919
              ],
              [
                50.158596,
                36.8054707
              ],
              [
                50.1587462,
                36.8040104
              ],
              [
                50.159111,
                36.8034434
              ],
              [
                50.1576038,
                36.8000666
              ],
              [
                50.1561077,
                36.797941
              ],
              [
                50.1485538,
                36.7879789
              ],
              [
                50.1436678,
                36.7792725
              ],
              [
                50.1331901,
                36.7775988
              ],
              [
                50.1233702,
                36.7789205
              ],
              [
                50.1213402,
                36.7751033
              ],
              [
                50.1172179,
                36.7689569
              ],
              [
                50.1093291,
                36.7519518
              ],
              [
                50.1098726,
                36.7383187
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555090,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سیاهکل",
          "name:en": "Siahkal County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2570976",
          "wikipedia": "en:Siahkal County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.727052,
                36.9140885
              ],
              [
                49.726559,
                36.9096647
              ],
              [
                49.7262671,
                36.9061994
              ],
              [
                49.7320073,
                36.9015936
              ],
              [
                49.7375787,
                36.8990727
              ],
              [
                49.7428605,
                36.8970239
              ],
              [
                49.7489804,
                36.8954828
              ],
              [
                49.7576838,
                36.8932315
              ],
              [
                49.764803,
                36.891084
              ],
              [
                49.772039,
                36.8878203
              ],
              [
                49.7777133,
                36.8849751
              ],
              [
                49.7820665,
                36.8823569
              ],
              [
                49.785241,
                36.8799794
              ],
              [
                49.7879815,
                36.8776317
              ],
              [
                49.790731,
                36.8740023
              ],
              [
                49.7912209,
                36.8718605
              ],
              [
                49.7961645,
                36.8626587
              ],
              [
                49.7996485,
                36.860487
              ],
              [
                49.8086521,
                36.8552853
              ],
              [
                49.8133989,
                36.8466531
              ],
              [
                49.8245237,
                36.8387811
              ],
              [
                49.827185,
                36.8320421
              ],
              [
                49.8333105,
                36.8165292
              ],
              [
                49.8341817,
                36.8129834
              ],
              [
                49.8491657,
                36.7966252
              ],
              [
                49.8617743,
                36.7891088
              ],
              [
                49.8959553,
                36.776461
              ],
              [
                49.8968134,
                36.7761434
              ],
              [
                49.8968746,
                36.7761208
              ],
              [
                49.9061977,
                36.7735158
              ],
              [
                49.9143921,
                36.7697208
              ],
              [
                49.917873,
                36.7690505
              ],
              [
                49.9192021,
                36.7689429
              ],
              [
                49.9296678,
                36.7714611
              ],
              [
                49.9456373,
                36.7867472
              ],
              [
                49.9492475,
                36.7878638
              ],
              [
                49.9743104,
                36.8185356
              ],
              [
                49.976944,
                36.8107014
              ],
              [
                49.9784222,
                36.7988893
              ],
              [
                49.9773255,
                36.7796228
              ],
              [
                49.978992,
                36.7701774
              ],
              [
                49.9795487,
                36.769349
              ],
              [
                49.9798857,
                36.7464038
              ],
              [
                49.9811362,
                36.7289953
              ],
              [
                49.9841012,
                36.7163111
              ],
              [
                49.9915693,
                36.7020082
              ],
              [
                50.0014936,
                36.697864
              ],
              [
                50.0031566,
                36.6976038
              ],
              [
                50.0059032,
                36.6959521
              ],
              [
                50.0099372,
                36.6949198
              ],
              [
                50.0113105,
                36.6947822
              ],
              [
                50.0142287,
                36.6934746
              ],
              [
                50.0193786,
                36.6927175
              ],
              [
                50.0225543,
                36.6918228
              ],
              [
                50.0325965,
                36.6907904
              ],
              [
                50.0455569,
                36.6899645
              ],
              [
                50.0617789,
                36.6884503
              ],
              [
                50.074396,
                36.6856284
              ],
              [
                50.08255,
                36.6837699
              ],
              [
                50.085554,
                36.6806036
              ],
              [
                50.0951671,
                36.6797776
              ],
              [
                50.1006602,
                36.6779879
              ],
              [
                50.1121317,
                36.677318
              ],
              [
                50.1253055,
                36.6737765
              ],
              [
                50.1209162,
                36.6850089
              ],
              [
                50.1160238,
                36.7137059
              ],
              [
                50.1124893,
                36.7303357
              ],
              [
                50.1098726,
                36.7383187
              ],
              [
                50.1093291,
                36.7519518
              ],
              [
                50.1172179,
                36.7689569
              ],
              [
                50.1213402,
                36.7751033
              ],
              [
                50.1233702,
                36.7789205
              ],
              [
                50.1331901,
                36.7775988
              ],
              [
                50.1436678,
                36.7792725
              ],
              [
                50.1485538,
                36.7879789
              ],
              [
                50.1561077,
                36.797941
              ],
              [
                50.1576038,
                36.8000666
              ],
              [
                50.159111,
                36.8034434
              ],
              [
                50.1587462,
                36.8040104
              ],
              [
                50.158596,
                36.8054707
              ],
              [
                50.1571369,
                36.8072919
              ],
              [
                50.1541972,
                36.8094565
              ],
              [
                50.1528024,
                36.8102812
              ],
              [
                50.1497125,
                36.8104873
              ],
              [
                50.1466585,
                36.8099175
              ],
              [
                50.1452687,
                36.811472
              ],
              [
                50.1407006,
                36.8107119
              ],
              [
                50.1288127,
                36.8109683
              ],
              [
                50.1213181,
                36.8116733
              ],
              [
                50.111459,
                36.8094204
              ],
              [
                50.1032249,
                36.8117568
              ],
              [
                50.094786,
                36.8132076
              ],
              [
                50.0989358,
                36.8172057
              ],
              [
                50.0943955,
                36.8195153
              ],
              [
                50.0877136,
                36.8234853
              ],
              [
                50.0781503,
                36.8282386
              ],
              [
                50.070044,
                36.8323691
              ],
              [
                50.0605606,
                36.8365075
              ],
              [
                50.0577175,
                36.8356564
              ],
              [
                50.0530468,
                36.8364455
              ],
              [
                50.0477944,
                36.835844
              ],
              [
                50.0461149,
                36.8386565
              ],
              [
                50.0459003,
                36.8412667
              ],
              [
                50.0444412,
                36.8445638
              ],
              [
                50.0434112,
                36.8491314
              ],
              [
                50.0370597,
                36.8630728
              ],
              [
                50.0335886,
                36.8653932
              ],
              [
                50.0289905,
                36.8674161
              ],
              [
                50.0256443,
                36.8670556
              ],
              [
                50.0204086,
                36.8686006
              ],
              [
                50.0150442,
                36.8705754
              ],
              [
                50.0160723,
                36.8837453
              ],
              [
                50.0150588,
                36.8929888
              ],
              [
                50.0129073,
                36.9012135
              ],
              [
                50.012287,
                36.908914
              ],
              [
                50.00853,
                36.9197275
              ],
              [
                50.005334,
                36.9312419
              ],
              [
                50.0028088,
                36.9367535
              ],
              [
                50.0001432,
                36.9395526
              ],
              [
                49.994319,
                36.9463968
              ],
              [
                49.9922206,
                36.9490129
              ],
              [
                49.9896014,
                36.953638
              ],
              [
                49.9864508,
                36.9576262
              ],
              [
                49.9826191,
                36.9620094
              ],
              [
                49.9784803,
                36.9682555
              ],
              [
                49.9755308,
                36.9703818
              ],
              [
                49.9691934,
                36.9718267
              ],
              [
                49.9648174,
                36.9738466
              ],
              [
                49.9636542,
                36.9754164
              ],
              [
                49.9624728,
                36.9773239
              ],
              [
                49.9633741,
                36.9843347
              ],
              [
                49.9688243,
                36.9872656
              ],
              [
                49.9720215,
                36.9872999
              ],
              [
                49.974489,
                36.989052
              ],
              [
                49.9750471,
                36.9912076
              ],
              [
                49.977094,
                36.9939194
              ],
              [
                49.9784341,
                36.9954029
              ],
              [
                49.979948,
                36.9968768
              ],
              [
                49.9824229,
                36.9981547
              ],
              [
                49.9859185,
                37.0012057
              ],
              [
                49.9932485,
                37.0078944
              ],
              [
                50.0042943,
                37.0138527
              ],
              [
                50.0128179,
                37.0176708
              ],
              [
                50.0116646,
                37.0210234
              ],
              [
                50.0084996,
                37.0301371
              ],
              [
                50.0059247,
                37.0375027
              ],
              [
                50.0032425,
                37.0398835
              ],
              [
                50.0022769,
                37.0436686
              ],
              [
                50.0027704,
                37.0500225
              ],
              [
                50.003221,
                37.0528482
              ],
              [
                50.0013757,
                37.0554854
              ],
              [
                49.9998625,
                37.0562273
              ],
              [
                49.9913963,
                37.0530088
              ],
              [
                49.9867627,
                37.0542759
              ],
              [
                49.9852609,
                37.0574033
              ],
              [
                49.9836731,
                37.0639786
              ],
              [
                49.9812144,
                37.0641435
              ],
              [
                49.9776475,
                37.0634118
              ],
              [
                49.9741972,
                37.0622242
              ],
              [
                49.9713207,
                37.0616785
              ],
              [
                49.969896,
                37.0647299
              ],
              [
                49.9665725,
                37.067406
              ],
              [
                49.9645758,
                37.0677882
              ],
              [
                49.9618768,
                37.0674178
              ],
              [
                49.9602235,
                37.0671243
              ],
              [
                49.9594318,
                37.0624475
              ],
              [
                49.9595845,
                37.0605063
              ],
              [
                49.9555254,
                37.0585984
              ],
              [
                49.952582,
                37.057784
              ],
              [
                49.9490585,
                37.0581624
              ],
              [
                49.9412727,
                37.0595609
              ],
              [
                49.9372387,
                37.0598691
              ],
              [
                49.9319601,
                37.0589787
              ],
              [
                49.9169826,
                37.0651771
              ],
              [
                49.9164247,
                37.0664099
              ],
              [
                49.9171972,
                37.0684303
              ],
              [
                49.9191713,
                37.0693891
              ],
              [
                49.9229478,
                37.0702794
              ],
              [
                49.9281406,
                37.0696973
              ],
              [
                49.9363374,
                37.0706903
              ],
              [
                49.9439447,
                37.0748069
              ],
              [
                49.9466371,
                37.0779492
              ],
              [
                49.9524736,
                37.0836326
              ],
              [
                49.9584348,
                37.086476
              ],
              [
                49.966464,
                37.08733
              ],
              [
                49.969511,
                37.0875011
              ],
              [
                49.97509,
                37.0890074
              ],
              [
                49.9798107,
                37.0894525
              ],
              [
                49.9818277,
                37.0889047
              ],
              [
                49.9833687,
                37.0883259
              ],
              [
                49.9831795,
                37.0894867
              ],
              [
                49.9809265,
                37.0930811
              ],
              [
                49.9798627,
                37.0942493
              ],
              [
                49.9788458,
                37.0960151
              ],
              [
                49.9795313,
                37.1015397
              ],
              [
                49.9806697,
                37.1058057
              ],
              [
                49.968996,
                37.1163209
              ],
              [
                49.9560444,
                37.1262985
              ],
              [
                49.94273,
                37.129736
              ],
              [
                49.941138,
                37.1352305
              ],
              [
                49.9418626,
                37.1490024
              ],
              [
                49.9395561,
                37.1512527
              ],
              [
                49.9308872,
                37.1553914
              ],
              [
                49.9292239,
                37.1567395
              ],
              [
                49.928483,
                37.1573514
              ],
              [
                49.9274777,
                37.1590094
              ],
              [
                49.9272823,
                37.1631039
              ],
              [
                49.9267888,
                37.1640273
              ],
              [
                49.9265528,
                37.1648652
              ],
              [
                49.9268961,
                37.1661648
              ],
              [
                49.9276471,
                37.1670368
              ],
              [
                49.9286771,
                37.1675498
              ],
              [
                49.9292779,
                37.167755
              ],
              [
                49.929986,
                37.1684389
              ],
              [
                49.9302435,
                37.1692426
              ],
              [
                49.9301147,
                37.1698068
              ],
              [
                49.9294925,
                37.1706618
              ],
              [
                49.9274969,
                37.1708669
              ],
              [
                49.9258017,
                37.170696
              ],
              [
                49.9246645,
                37.1702001
              ],
              [
                49.9234843,
                37.1694478
              ],
              [
                49.9222657,
                37.1691909
              ],
              [
                49.9205446,
                37.1694136
              ],
              [
                49.9196219,
                37.1700462
              ],
              [
                49.9190855,
                37.1707643
              ],
              [
                49.9161887,
                37.1737052
              ],
              [
                49.9118542,
                37.1782188
              ],
              [
                49.9059105,
                37.1839289
              ],
              [
                49.9032712,
                37.1859119
              ],
              [
                49.9020052,
                37.1876727
              ],
              [
                49.9011891,
                37.1883317
              ],
              [
                49.8894792,
                37.1867597
              ],
              [
                49.8766544,
                37.1850313
              ],
              [
                49.8681552,
                37.1881552
              ],
              [
                49.8641967,
                37.189724
              ],
              [
                49.8602535,
                37.1906794
              ],
              [
                49.8454856,
                37.1850743
              ],
              [
                49.8359584,
                37.1798772
              ],
              [
                49.8269462,
                37.1720126
              ],
              [
                49.8213672,
                37.1695504
              ],
              [
                49.8250109,
                37.1675827
              ],
              [
                49.8242854,
                37.1601114
              ],
              [
                49.8229626,
                37.1585378
              ],
              [
                49.8221241,
                37.1545269
              ],
              [
                49.8079084,
                37.1501457
              ],
              [
                49.8054667,
                37.1497414
              ],
              [
                49.7985286,
                37.1396664
              ],
              [
                49.7914725,
                37.1386293
              ],
              [
                49.7893516,
                37.1386978
              ],
              [
                49.7895496,
                37.1397477
              ],
              [
                49.7822833,
                37.144366
              ],
              [
                49.7796368,
                37.1466472
              ],
              [
                49.7746753,
                37.1467717
              ],
              [
                49.7698725,
                37.1486996
              ],
              [
                49.7610282,
                37.1487557
              ],
              [
                49.7578205,
                37.1495943
              ],
              [
                49.7533893,
                37.1404088
              ],
              [
                49.7516298,
                37.1349349
              ],
              [
                49.7508144,
                37.1293581
              ],
              [
                49.7494482,
                37.1284986
              ],
              [
                49.7433042,
                37.1265523
              ],
              [
                49.7415554,
                37.1258594
              ],
              [
                49.7400856,
                37.1249441
              ],
              [
                49.7396226,
                37.1245029
              ],
              [
                49.7379183,
                37.1229681
              ],
              [
                49.7364699,
                37.1201451
              ],
              [
                49.7352468,
                37.1175358
              ],
              [
                49.7336053,
                37.1156536
              ],
              [
                49.7327041,
                37.1091341
              ],
              [
                49.7283267,
                37.1055747
              ],
              [
                49.7248935,
                37.1035211
              ],
              [
                49.724121,
                37.1007144
              ],
              [
                49.7242068,
                37.0972915
              ],
              [
                49.7211832,
                37.0950059
              ],
              [
                49.7161934,
                37.0912601
              ],
              [
                49.7137877,
                37.0867495
              ],
              [
                49.7176441,
                37.0819879
              ],
              [
                49.7247183,
                37.0771155
              ],
              [
                49.7322273,
                37.0713621
              ],
              [
                49.7334766,
                37.0663415
              ],
              [
                49.7434329,
                37.066136
              ],
              [
                49.7448062,
                37.0638759
              ],
              [
                49.7454928,
                37.0555197
              ],
              [
                49.743347,
                37.0435317
              ],
              [
                49.7368136,
                37.0134162
              ],
              [
                49.7417882,
                36.9993148
              ],
              [
                49.7372467,
                36.9746573
              ],
              [
                49.7385146,
                36.9700583
              ],
              [
                49.7396453,
                36.964172
              ],
              [
                49.7396305,
                36.9570655
              ],
              [
                49.7401713,
                36.9522926
              ],
              [
                49.7449778,
                36.9474911
              ],
              [
                49.7459219,
                36.9448159
              ],
              [
                49.7360514,
                36.9332221
              ],
              [
                49.7340773,
                36.9269786
              ],
              [
                49.7306441,
                36.9216265
              ],
              [
                49.727052,
                36.9140885
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555103,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان شفت",
          "name:en": "Shaft County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2570937",
          "wikipedia": "en:Shaft County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.1708095,
                37.0212894
              ],
              [
                49.1748046,
                37.0116002
              ],
              [
                49.1790761,
                37.0020017
              ],
              [
                49.1834031,
                36.9914532
              ],
              [
                49.1996944,
                36.9594611
              ],
              [
                49.2229942,
                36.9525548
              ],
              [
                49.2297725,
                36.9508696
              ],
              [
                49.2427047,
                36.948949
              ],
              [
                49.2480982,
                36.9489787
              ],
              [
                49.2541571,
                36.9492822
              ],
              [
                49.2616735,
                36.9494443
              ],
              [
                49.2688322,
                36.9495146
              ],
              [
                49.2711461,
                36.9491699
              ],
              [
                49.2733812,
                36.9497546
              ],
              [
                49.2764903,
                36.9514286
              ],
              [
                49.2935964,
                36.9536087
              ],
              [
                49.31378,
                36.9582187
              ],
              [
                49.3249119,
                36.9603341
              ],
              [
                49.3387702,
                36.9653406
              ],
              [
                49.3451785,
                36.9663523
              ],
              [
                49.3566541,
                36.9718399
              ],
              [
                49.3694022,
                36.9756203
              ],
              [
                49.3800538,
                36.9797254
              ],
              [
                49.3822773,
                36.9808415
              ],
              [
                49.3847769,
                36.9816696
              ],
              [
                49.4135606,
                36.9907687
              ],
              [
                49.4496229,
                37.0075041
              ],
              [
                49.4630897,
                37.0139396
              ],
              [
                49.4768834,
                37.0199663
              ],
              [
                49.493943,
                37.0277589
              ],
              [
                49.491434,
                37.0348992
              ],
              [
                49.4918202,
                37.0385304
              ],
              [
                49.4933171,
                37.0414158
              ],
              [
                49.5001865,
                37.0483167
              ],
              [
                49.5126342,
                37.0692179
              ],
              [
                49.5207881,
                37.0866796
              ],
              [
                49.5219039,
                37.0902056
              ],
              [
                49.5243501,
                37.089966
              ],
              [
                49.5291566,
                37.0928415
              ],
              [
                49.5328044,
                37.0936288
              ],
              [
                49.536538,
                37.0951008
              ],
              [
                49.538598,
                37.0975654
              ],
              [
                49.5415592,
                37.099448
              ],
              [
                49.5459794,
                37.1008514
              ],
              [
                49.5497989,
                37.1032473
              ],
              [
                49.5519876,
                37.1056432
              ],
              [
                49.5545196,
                37.1071833
              ],
              [
                49.5570516,
                37.1097502
              ],
              [
                49.5643627,
                37.1134589
              ],
              [
                49.5668137,
                37.1165709
              ],
              [
                49.5669627,
                37.1207779
              ],
              [
                49.5612788,
                37.1269538
              ],
              [
                49.5569677,
                37.1282758
              ],
              [
                49.5506605,
                37.128392
              ],
              [
                49.542484,
                37.1294236
              ],
              [
                49.5321737,
                37.1352856
              ],
              [
                49.5278602,
                37.1281743
              ],
              [
                49.5231186,
                37.1583439
              ],
              [
                49.5197818,
                37.1658401
              ],
              [
                49.512282,
                37.1752889
              ],
              [
                49.5045052,
                37.1791764
              ],
              [
                49.503672,
                37.1800133
              ],
              [
                49.5031153,
                37.1802922
              ],
              [
                49.4998993,
                37.1804171
              ],
              [
                49.4983918,
                37.1816781
              ],
              [
                49.4981152,
                37.1830638
              ],
              [
                49.4975585,
                37.1850166
              ],
              [
                49.4967253,
                37.1864024
              ],
              [
                49.4970055,
                37.1866813
              ],
              [
                49.4964488,
                37.1877881
              ],
              [
                49.4961722,
                37.1886251
              ],
              [
                49.4958921,
                37.1905688
              ],
              [
                49.4844143,
                37.1902323
              ],
              [
                49.4803372,
                37.1958409
              ],
              [
                49.4808914,
                37.2027593
              ],
              [
                49.4770529,
                37.2081527
              ],
              [
                49.475508,
                37.2103427
              ],
              [
                49.4723335,
                37.2179881
              ],
              [
                49.4634071,
                37.2213482
              ],
              [
                49.4617762,
                37.224093
              ],
              [
                49.4640771,
                37.2278967
              ],
              [
                49.4680881,
                37.2301918
              ],
              [
                49.468603,
                37.2323786
              ],
              [
                49.4727229,
                37.233267
              ],
              [
                49.4792461,
                37.2375721
              ],
              [
                49.4836465,
                37.2394579
              ],
              [
                49.4846964,
                37.2404249
              ],
              [
                49.4853401,
                37.2428505
              ],
              [
                49.4848898,
                37.2432298
              ],
              [
                49.4831062,
                37.2438902
              ],
              [
                49.4774653,
                37.2429814
              ],
              [
                49.4729354,
                37.2420156
              ],
              [
                49.4700839,
                37.2438148
              ],
              [
                49.4694636,
                37.2483913
              ],
              [
                49.4701051,
                37.2511007
              ],
              [
                49.4702124,
                37.2542946
              ],
              [
                49.4716715,
                37.2551315
              ],
              [
                49.4723152,
                37.2551315
              ],
              [
                49.4736671,
                37.2578641
              ],
              [
                49.4753194,
                37.2610577
              ],
              [
                49.478184,
                37.2629875
              ],
              [
                49.4788169,
                37.2632522
              ],
              [
                49.479985,
                37.2644692
              ],
              [
                49.4783531,
                37.2681147
              ],
              [
                49.478302,
                37.269784
              ],
              [
                49.4790744,
                37.2719355
              ],
              [
                49.4804907,
                37.2730625
              ],
              [
                49.4809689,
                37.2727807
              ],
              [
                49.4820356,
                37.274087
              ],
              [
                49.4828939,
                37.2742919
              ],
              [
                49.4827651,
                37.278219
              ],
              [
                49.481821,
                37.2798239
              ],
              [
                49.4783019,
                37.2826581
              ],
              [
                49.4714355,
                37.2880871
              ],
              [
                49.4661569,
                37.2945058
              ],
              [
                49.4644431,
                37.2980694
              ],
              [
                49.4644646,
                37.2987979
              ],
              [
                49.4636464,
                37.3002582
              ],
              [
                49.4625306,
                37.3020334
              ],
              [
                49.4615865,
                37.304952
              ],
              [
                49.4624389,
                37.3078223
              ],
              [
                49.4572305,
                37.3031599
              ],
              [
                49.4516944,
                37.2987391
              ],
              [
                49.4481325,
                37.2965201
              ],
              [
                49.4415235,
                37.2898284
              ],
              [
                49.4400908,
                37.2892686
              ],
              [
                49.4367599,
                37.2867043
              ],
              [
                49.4339456,
                37.2855695
              ],
              [
                49.4328143,
                37.2852451
              ],
              [
                49.4313443,
                37.2846107
              ],
              [
                49.4289607,
                37.2835635
              ],
              [
                49.4256298,
                37.282232
              ],
              [
                49.4222872,
                37.2808773
              ],
              [
                49.4193233,
                37.2796651
              ],
              [
                49.4163659,
                37.2790106
              ],
              [
                49.4135462,
                37.2775934
              ],
              [
                49.41329,
                37.2782023
              ],
              [
                49.4112993,
                37.2787145
              ],
              [
                49.4091615,
                37.2791698
              ],
              [
                49.4078796,
                37.2790078
              ],
              [
                49.4059718,
                37.2779082
              ],
              [
                49.4042492,
                37.2770053
              ],
              [
                49.4034114,
                37.2763329
              ],
              [
                49.4025967,
                37.2760965
              ],
              [
                49.4009731,
                37.2748343
              ],
              [
                49.4004261,
                37.2725094
              ],
              [
                49.4004419,
                37.2713607
              ],
              [
                49.4117374,
                37.2614815
              ],
              [
                49.4127954,
                37.2607218
              ],
              [
                49.4133893,
                37.2602954
              ],
              [
                49.4136658,
                37.2594587
              ],
              [
                49.4232376,
                37.2507489
              ],
              [
                49.4238325,
                37.246714
              ],
              [
                49.422545,
                37.2450629
              ],
              [
                49.4214899,
                37.2396099
              ],
              [
                49.4251725,
                37.2337761
              ],
              [
                49.4313525,
                37.2298501
              ],
              [
                49.4335841,
                37.2282783
              ],
              [
                49.4376983,
                37.2274854
              ],
              [
                49.4353999,
                37.220985
              ],
              [
                49.4323768,
                37.2101059
              ],
              [
                49.4141006,
                37.2154974
              ],
              [
                49.4100665,
                37.2112594
              ],
              [
                49.4144439,
                37.206611
              ],
              [
                49.4156455,
                37.1999114
              ],
              [
                49.4293784,
                37.1979287
              ],
              [
                49.4294695,
                37.1962679
              ],
              [
                49.4210444,
                37.1942934
              ],
              [
                49.4088211,
                37.1926922
              ],
              [
                49.388066,
                37.1917017
              ],
              [
                49.3850898,
                37.1898608
              ],
              [
                49.3792623,
                37.1882393
              ],
              [
                49.3735172,
                37.1888205
              ],
              [
                49.368197,
                37.1922051
              ],
              [
                49.3587006,
                37.1940512
              ],
              [
                49.3589784,
                37.1895672
              ],
              [
                49.3595257,
                37.1816436
              ],
              [
                49.3599428,
                37.1764008
              ],
              [
                49.3601989,
                37.1691742
              ],
              [
                49.3608856,
                37.1677721
              ],
              [
                49.3604993,
                37.1665752
              ],
              [
                49.3589544,
                37.1660964
              ],
              [
                49.3566799,
                37.1657202
              ],
              [
                49.3540952,
                37.1656069
              ],
              [
                49.3475818,
                37.1626593
              ],
              [
                49.3420444,
                37.160222
              ],
              [
                49.3385696,
                37.1575805
              ],
              [
                49.3311689,
                37.1545374
              ],
              [
                49.3328189,
                37.1496451
              ],
              [
                49.3161641,
                37.1197275
              ],
              [
                49.2961913,
                37.1008438
              ],
              [
                49.2894748,
                37.0957634
              ],
              [
                49.2852998,
                37.093443
              ],
              [
                49.2721485,
                37.0840273
              ],
              [
                49.250208,
                37.0717823
              ],
              [
                49.2469024,
                37.0714094
              ],
              [
                49.2400359,
                37.0677797
              ],
              [
                49.2375408,
                37.0642714
              ],
              [
                49.2282686,
                37.0572591
              ],
              [
                49.2178509,
                37.0493415
              ],
              [
                49.2047689,
                37.0408417
              ],
              [
                49.1851043,
                37.0290751
              ],
              [
                49.1708095,
                37.0212894
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555116,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان صومعه سرا",
          "name:en": "Sowme'eh Sara County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291836",
          "wikipedia": "en:Sowme'eh Sara County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.0462497,
                37.2768178
              ],
              [
                49.0511722,
                37.2736643
              ],
              [
                49.0639756,
                37.2665261
              ],
              [
                49.079139,
                37.2621042
              ],
              [
                49.0854212,
                37.2611987
              ],
              [
                49.0926917,
                37.2618819
              ],
              [
                49.1049384,
                37.2634657
              ],
              [
                49.1122185,
                37.2662078
              ],
              [
                49.1182422,
                37.2676324
              ],
              [
                49.1272897,
                37.2735809
              ],
              [
                49.1431448,
                37.2855205
              ],
              [
                49.1545483,
                37.288736
              ],
              [
                49.1627515,
                37.2877319
              ],
              [
                49.1679184,
                37.2861129
              ],
              [
                49.1774654,
                37.278902
              ],
              [
                49.1801261,
                37.2778093
              ],
              [
                49.181902,
                37.2726884
              ],
              [
                49.1814994,
                37.2677007
              ],
              [
                49.1812848,
                37.262202
              ],
              [
                49.182701,
                37.2596061
              ],
              [
                49.183216,
                37.2562246
              ],
              [
                49.1869497,
                37.2540726
              ],
              [
                49.1932153,
                37.2551656
              ],
              [
                49.2053604,
                37.258923
              ],
              [
                49.2079782,
                37.2560196
              ],
              [
                49.2064333,
                37.2535602
              ],
              [
                49.2063025,
                37.250738
              ],
              [
                49.2063474,
                37.249478
              ],
              [
                49.2071414,
                37.2487607
              ],
              [
                49.2077233,
                37.2484628
              ],
              [
                49.209347,
                37.2491677
              ],
              [
                49.2120981,
                37.2516643
              ],
              [
                49.2121801,
                37.2519783
              ],
              [
                49.2128062,
                37.2540725
              ],
              [
                49.2145765,
                37.2531332
              ],
              [
                49.2195046,
                37.2527167
              ],
              [
                49.2203283,
                37.2530384
              ],
              [
                49.2211048,
                37.2538394
              ],
              [
                49.2221761,
                37.2544982
              ],
              [
                49.2242149,
                37.2544556
              ],
              [
                49.2260137,
                37.2545866
              ],
              [
                49.227076,
                37.2545524
              ],
              [
                49.2286632,
                37.2553379
              ],
              [
                49.2303083,
                37.2566529
              ],
              [
                49.2324185,
                37.2590254
              ],
              [
                49.2328782,
                37.261312
              ],
              [
                49.2347145,
                37.2631241
              ],
              [
                49.2367315,
                37.2654466
              ],
              [
                49.2365598,
                37.2664712
              ],
              [
                49.2370748,
                37.26934
              ],
              [
                49.2361307,
                37.2708427
              ],
              [
                49.2365169,
                37.2721404
              ],
              [
                49.2380189,
                37.2733357
              ],
              [
                49.2376756,
                37.2749066
              ],
              [
                49.2370319,
                37.2758628
              ],
              [
                49.2381058,
                37.2779365
              ],
              [
                49.2384481,
                37.2777068
              ],
              [
                49.240787,
                37.2810532
              ],
              [
                49.2449495,
                37.2861288
              ],
              [
                49.2549204,
                37.2862824
              ],
              [
                49.2589187,
                37.2860044
              ],
              [
                49.2654935,
                37.2763776
              ],
              [
                49.2709199,
                37.2661949
              ],
              [
                49.2801602,
                37.2648117
              ],
              [
                49.2870212,
                37.26478
              ],
              [
                49.2953068,
                37.2671276
              ],
              [
                49.31498,
                37.270446
              ],
              [
                49.320395,
                37.2706719
              ],
              [
                49.3230422,
                37.2711852
              ],
              [
                49.3341727,
                37.2749304
              ],
              [
                49.3360866,
                37.2750526
              ],
              [
                49.3408012,
                37.277297
              ],
              [
                49.3489766,
                37.2798069
              ],
              [
                49.3503284,
                37.2802379
              ],
              [
                49.3509507,
                37.280541
              ],
              [
                49.3516266,
                37.2808227
              ],
              [
                49.3536007,
                37.2807374
              ],
              [
                49.3555474,
                37.2795602
              ],
              [
                49.3584925,
                37.2800605
              ],
              [
                49.3595552,
                37.2797556
              ],
              [
                49.3594479,
                37.2782361
              ],
              [
                49.3598985,
                37.2774677
              ],
              [
                49.3621731,
                37.2771092
              ],
              [
                49.3631172,
                37.2774677
              ],
              [
                49.3646192,
                37.2762043
              ],
              [
                49.3621832,
                37.268884
              ],
              [
                49.3591589,
                37.2586492
              ],
              [
                49.3611841,
                37.2559973
              ],
              [
                49.363628,
                37.2550386
              ],
              [
                49.3676404,
                37.257071
              ],
              [
                49.3681165,
                37.2607028
              ],
              [
                49.3685947,
                37.2658463
              ],
              [
                49.3698549,
                37.2665224
              ],
              [
                49.3714535,
                37.2674189
              ],
              [
                49.3731257,
                37.2681424
              ],
              [
                49.3731809,
                37.2680315
              ],
              [
                49.3728666,
                37.26746
              ],
              [
                49.3738129,
                37.2668613
              ],
              [
                49.375523,
                37.2682967
              ],
              [
                49.3770212,
                37.2689128
              ],
              [
                49.3782247,
                37.268413
              ],
              [
                49.3825433,
                37.2681178
              ],
              [
                49.3876823,
                37.2679011
              ],
              [
                49.3927891,
                37.2687251
              ],
              [
                49.396821,
                37.2697868
              ],
              [
                49.4004419,
                37.2713607
              ],
              [
                49.4004261,
                37.2725094
              ],
              [
                49.4009731,
                37.2748343
              ],
              [
                49.4025967,
                37.2760965
              ],
              [
                49.4034114,
                37.2763329
              ],
              [
                49.4042492,
                37.2770053
              ],
              [
                49.4059718,
                37.2779082
              ],
              [
                49.4078796,
                37.2790078
              ],
              [
                49.4091615,
                37.2791698
              ],
              [
                49.4112993,
                37.2787145
              ],
              [
                49.41329,
                37.2782023
              ],
              [
                49.4135462,
                37.2775934
              ],
              [
                49.4163659,
                37.2790106
              ],
              [
                49.4193233,
                37.2796651
              ],
              [
                49.4222872,
                37.2808773
              ],
              [
                49.4256298,
                37.282232
              ],
              [
                49.4289607,
                37.2835635
              ],
              [
                49.4313443,
                37.2846107
              ],
              [
                49.4328143,
                37.2852451
              ],
              [
                49.4339456,
                37.2855695
              ],
              [
                49.4367599,
                37.2867043
              ],
              [
                49.4400908,
                37.2892686
              ],
              [
                49.4415235,
                37.2898284
              ],
              [
                49.4481325,
                37.2965201
              ],
              [
                49.4516944,
                37.2987391
              ],
              [
                49.4572305,
                37.3031599
              ],
              [
                49.4624389,
                37.3078223
              ],
              [
                49.4643545,
                37.3092018
              ],
              [
                49.4688977,
                37.3129941
              ],
              [
                49.4725788,
                37.3161629
              ],
              [
                49.4734955,
                37.3175983
              ],
              [
                49.4742204,
                37.3180886
              ],
              [
                49.4829254,
                37.3270685
              ],
              [
                49.4832883,
                37.3282022
              ],
              [
                49.4846179,
                37.3313679
              ],
              [
                49.4877653,
                37.3356906
              ],
              [
                49.4900881,
                37.3364207
              ],
              [
                49.4976151,
                37.3453693
              ],
              [
                49.5023693,
                37.3493513
              ],
              [
                49.5066269,
                37.3578617
              ],
              [
                49.5126326,
                37.3613683
              ],
              [
                49.5185048,
                37.3652519
              ],
              [
                49.5217771,
                37.3772205
              ],
              [
                49.4797818,
                37.3986298
              ],
              [
                49.4742251,
                37.3997363
              ],
              [
                49.4731149,
                37.3997364
              ],
              [
                49.4725582,
                37.4000152
              ],
              [
                49.4711683,
                37.4000152
              ],
              [
                49.4708917,
                37.4002941
              ],
              [
                49.4697817,
                37.4002941
              ],
              [
                49.4689484,
                37.4005729
              ],
              [
                49.4667254,
                37.4005729
              ],
              [
                49.4661682,
                37.4008518
              ],
              [
                49.4564454,
                37.4008518
              ],
              [
                49.4550586,
                37.4005729
              ],
              [
                49.4533919,
                37.4005729
              ],
              [
                49.4528351,
                37.400294
              ],
              [
                49.4514453,
                37.400294
              ],
              [
                49.4492253,
                37.3997363
              ],
              [
                49.4483921,
                37.3997363
              ],
              [
                49.4444074,
                37.3991973
              ],
              [
                49.4397223,
                37.4031083
              ],
              [
                49.431678,
                37.4042954
              ],
              [
                49.42415,
                37.4058977
              ],
              [
                49.4138944,
                37.4083119
              ],
              [
                49.4102659,
                37.4085382
              ],
              [
                49.4071737,
                37.407549
              ],
              [
                49.4040303,
                37.4057047
              ],
              [
                49.398694,
                37.4004033
              ],
              [
                49.3945741,
                37.3981531
              ],
              [
                49.3916988,
                37.3971644
              ],
              [
                49.3836346,
                37.3960225
              ],
              [
                49.372721,
                37.3987528
              ],
              [
                49.3642296,
                37.4022366
              ],
              [
                49.3613378,
                37.4030643
              ],
              [
                49.3583965,
                37.4051761
              ],
              [
                49.3542337,
                37.410528
              ],
              [
                49.3509341,
                37.4122063
              ],
              [
                49.3488209,
                37.4134492
              ],
              [
                49.3390845,
                37.4170045
              ],
              [
                49.3288707,
                37.4178907
              ],
              [
                49.3255233,
                37.4177543
              ],
              [
                49.3209743,
                37.4202765
              ],
              [
                49.317541,
                37.4271611
              ],
              [
                49.3166827,
                37.4349309
              ],
              [
                49.3105029,
                37.4433815
              ],
              [
                49.3092155,
                37.4478108
              ],
              [
                49.3070697,
                37.4510815
              ],
              [
                49.2918777,
                37.4658662
              ],
              [
                49.2886903,
                37.4671991
              ],
              [
                49.2808885,
                37.4697703
              ],
              [
                49.2707568,
                37.4733071
              ],
              [
                49.2629527,
                37.4749944
              ],
              [
                49.2569446,
                37.4772422
              ],
              [
                49.2501639,
                37.4786045
              ],
              [
                49.2408942,
                37.4835766
              ],
              [
                49.2329978,
                37.4884803
              ],
              [
                49.2265605,
                37.4929751
              ],
              [
                49.2210673,
                37.4965162
              ],
              [
                49.2184764,
                37.4983058
              ],
              [
                49.2034292,
                37.4974184
              ],
              [
                49.1998458,
                37.4969418
              ],
              [
                49.1919708,
                37.4947456
              ],
              [
                49.1904473,
                37.4947116
              ],
              [
                49.1847396,
                37.4917152
              ],
              [
                49.1780064,
                37.489075
              ],
              [
                49.1726072,
                37.4851137
              ],
              [
                49.1687585,
                37.4809768
              ],
              [
                49.1655778,
                37.4779574
              ],
              [
                49.1651058,
                37.4746538
              ],
              [
                49.1654142,
                37.4732249
              ],
              [
                49.1661787,
                37.470771
              ],
              [
                49.1677204,
                37.4686316
              ],
              [
                49.1759204,
                37.464163
              ],
              [
                49.1782593,
                37.462444
              ],
              [
                49.1796549,
                37.4603786
              ],
              [
                49.1779375,
                37.4561577
              ],
              [
                49.1773796,
                37.4510815
              ],
              [
                49.1781263,
                37.4483281
              ],
              [
                49.1808986,
                37.4453576
              ],
              [
                49.1856621,
                37.440826
              ],
              [
                49.1868049,
                37.4402101
              ],
              [
                49.185954,
                37.4345526
              ],
              [
                49.165492,
                37.4087214
              ],
              [
                49.1642474,
                37.4080055
              ],
              [
                49.1600094,
                37.4043791
              ],
              [
                49.1572521,
                37.4019034
              ],
              [
                49.1561047,
                37.3999192
              ],
              [
                49.1557613,
                37.3947754
              ],
              [
                49.156351,
                37.3924593
              ],
              [
                49.1585258,
                37.3869627
              ],
              [
                49.1593735,
                37.3860926
              ],
              [
                49.1649202,
                37.380801
              ],
              [
                49.1698265,
                37.3744545
              ],
              [
                49.1727876,
                37.3650752
              ],
              [
                49.1741912,
                37.3613878
              ],
              [
                49.1738176,
                37.3548761
              ],
              [
                49.1733026,
                37.3543303
              ],
              [
                49.1733026,
                37.3515671
              ],
              [
                49.1746759,
                37.3493837
              ],
              [
                49.1754979,
                37.3436718
              ],
              [
                49.1759634,
                37.3421167
              ],
              [
                49.1758029,
                37.3375503
              ],
              [
                49.1755657,
                37.3361395
              ],
              [
                49.175663,
                37.3353268
              ],
              [
                49.1748905,
                37.3342348
              ],
              [
                49.1748046,
                37.3324263
              ],
              [
                49.1742038,
                37.330413
              ],
              [
                49.1717577,
                37.3277513
              ],
              [
                49.1714143,
                37.3264545
              ],
              [
                49.1701696,
                37.3243047
              ],
              [
                49.166007,
                37.3227006
              ],
              [
                49.1659641,
                37.3149532
              ],
              [
                49.1659982,
                37.3125122
              ],
              [
                49.1659387,
                37.3096109
              ],
              [
                49.1679188,
                37.3062376
              ],
              [
                49.1615009,
                37.3050886
              ],
              [
                49.1558663,
                37.3062376
              ],
              [
                49.1587972,
                37.30898
              ],
              [
                49.1593259,
                37.3138211
              ],
              [
                49.1541194,
                37.3193218
              ],
              [
                49.152098,
                37.3196096
              ],
              [
                49.1391849,
                37.3140657
              ],
              [
                49.1318035,
                37.3119496
              ],
              [
                49.1287565,
                37.3129053
              ],
              [
                49.1270398,
                37.3127858
              ],
              [
                49.119401,
                37.3140145
              ],
              [
                49.1086507,
                37.3139633
              ],
              [
                49.1041105,
                37.3131204
              ],
              [
                49.0922094,
                37.3103041
              ],
              [
                49.0839099,
                37.3079218
              ],
              [
                49.0619372,
                37.2936523
              ],
              [
                49.0522381,
                37.2859363
              ],
              [
                49.0477749,
                37.280951
              ],
              [
                49.0462497,
                37.2768178
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555120,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان طوالش",
          "name:en": "Talesh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2570890",
          "wikipedia": "en:Talesh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.5674486,
                37.8493404
              ],
              [
                48.5695708,
                37.8478445
              ],
              [
                48.5729359,
                37.8418889
              ],
              [
                48.5722921,
                37.8353266
              ],
              [
                48.5702311,
                37.8316334
              ],
              [
                48.5661733,
                37.8258146
              ],
              [
                48.5632099,
                37.8199981
              ],
              [
                48.5623169,
                37.8128693
              ],
              [
                48.5677554,
                37.8030093
              ],
              [
                48.5788905,
                37.7900884
              ],
              [
                48.5917757,
                37.7813026
              ],
              [
                48.601101,
                37.7789593
              ],
              [
                48.6094397,
                37.7835795
              ],
              [
                48.6158328,
                37.7889383
              ],
              [
                48.618123,
                37.78936
              ],
              [
                48.6228054,
                37.783965
              ],
              [
                48.627501,
                37.7808977
              ],
              [
                48.6333926,
                37.7787375
              ],
              [
                48.6410506,
                37.7779619
              ],
              [
                48.6442319,
                37.7750664
              ],
              [
                48.6438559,
                37.7635228
              ],
              [
                48.6340712,
                37.7498152
              ],
              [
                48.6330412,
                37.7378699
              ],
              [
                48.6316749,
                37.7185589
              ],
              [
                48.6108499,
                37.7055818
              ],
              [
                48.6083498,
                37.7047455
              ],
              [
                48.60696,
                37.7047455
              ],
              [
                48.6055701,
                37.7055818
              ],
              [
                48.6047364,
                37.7055817
              ],
              [
                48.5991837,
                37.7030821
              ],
              [
                48.59807,
                37.7014186
              ],
              [
                48.59807,
                37.7005825
              ],
              [
                48.59835,
                37.6997462
              ],
              [
                48.59835,
                37.6994675
              ],
              [
                48.5991836,
                37.6983525
              ],
              [
                48.5975134,
                37.6944682
              ],
              [
                48.5958468,
                37.691411
              ],
              [
                48.5961269,
                37.6908535
              ],
              [
                48.5958469,
                37.6905837
              ],
              [
                48.5966801,
                37.6880751
              ],
              [
                48.5997369,
                37.6853057
              ],
              [
                48.6058502,
                37.6800275
              ],
              [
                48.6069601,
                37.678355
              ],
              [
                48.6097367,
                37.6725193
              ],
              [
                48.6097367,
                37.6722406
              ],
              [
                48.6097367,
                37.6716921
              ],
              [
                48.6100168,
                37.6714133
              ],
              [
                48.6097368,
                37.662799
              ],
              [
                48.6097368,
                37.6594719
              ],
              [
                48.6122369,
                37.6519724
              ],
              [
                48.6139032,
                37.6497423
              ],
              [
                48.6144599,
                37.6491938
              ],
              [
                48.615017,
                37.6480788
              ],
              [
                48.6164069,
                37.6464152
              ],
              [
                48.6252935,
                37.6330795
              ],
              [
                48.6369632,
                37.6208585
              ],
              [
                48.6377965,
                37.6205798
              ],
              [
                48.6386302,
                37.6197435
              ],
              [
                48.6809359,
                37.6010516
              ],
              [
                48.6826028,
                37.5996668
              ],
              [
                48.6848263,
                37.5966093
              ],
              [
                48.6848262,
                37.5963305
              ],
              [
                48.6884361,
                37.5863307
              ],
              [
                48.6867693,
                37.5766093
              ],
              [
                48.6848263,
                37.575773
              ],
              [
                48.6839928,
                37.575773
              ],
              [
                48.6839928,
                37.5754942
              ],
              [
                48.682883,
                37.5752155
              ],
              [
                48.6826028,
                37.5746668
              ],
              [
                48.6761296,
                37.5691845
              ],
              [
                48.6825133,
                37.5597993
              ],
              [
                48.6889034,
                37.5631338
              ],
              [
                48.68946,
                37.5634124
              ],
              [
                48.7501141,
                37.5832219
              ],
              [
                48.7635037,
                37.5813174
              ],
              [
                48.7770653,
                37.5745894
              ],
              [
                48.7776218,
                37.5748682
              ],
              [
                48.8153048,
                37.5850221
              ],
              [
                48.8283614,
                37.5889071
              ],
              [
                48.8294715,
                37.5889071
              ],
              [
                48.831138,
                37.5897436
              ],
              [
                48.8330814,
                37.5900223
              ],
              [
                48.8566944,
                37.5975226
              ],
              [
                48.8720937,
                37.587872
              ],
              [
                48.8792429,
                37.5909664
              ],
              [
                48.8936233,
                37.5971641
              ],
              [
                48.926355,
                37.6125035
              ],
              [
                48.947207,
                37.6221916
              ],
              [
                48.9722923,
                37.6341125
              ],
              [
                48.982501,
                37.6260607
              ],
              [
                48.991642,
                37.6244292
              ],
              [
                49.0081214,
                37.6366647
              ],
              [
                49.0036583,
                37.6458739
              ],
              [
                49.010154,
                37.6484727
              ],
              [
                49.0169992,
                37.6560035
              ],
              [
                49.0257955,
                37.6587964
              ],
              [
                49.0326214,
                37.6630113
              ],
              [
                49.0545429,
                37.6762309
              ],
              [
                49.2679205,
                37.7859607
              ],
              [
                49.2620927,
                37.7910705
              ],
              [
                49.26032,
                37.7930065
              ],
              [
                49.2561599,
                37.7973003
              ],
              [
                49.2518546,
                37.801503
              ],
              [
                49.245258,
                37.8075189
              ],
              [
                49.2362111,
                37.8154415
              ],
              [
                49.2333791,
                37.8187043
              ],
              [
                49.233249,
                37.8254784
              ],
              [
                49.2327861,
                37.8326556
              ],
              [
                49.2314177,
                37.8483477
              ],
              [
                49.2308865,
                37.8534787
              ],
              [
                49.2301891,
                37.8585971
              ],
              [
                49.229326,
                37.8636995
              ],
              [
                49.2282978,
                37.8687828
              ],
              [
                49.2272955,
                37.8730811
              ],
              [
                49.226175,
                37.8773611
              ],
              [
                49.2249369,
                37.8816207
              ],
              [
                49.2235817,
                37.8858578
              ],
              [
                49.22211,
                37.8900705
              ],
              [
                49.2205225,
                37.8942567
              ],
              [
                49.21882,
                37.8984145
              ],
              [
                49.2170032,
                37.9025418
              ],
              [
                49.2150731,
                37.9066366
              ],
              [
                49.2130304,
                37.9106971
              ],
              [
                49.2108762,
                37.9147213
              ],
              [
                49.2086114,
                37.9187073
              ],
              [
                49.2062372,
                37.9226531
              ],
              [
                49.2037546,
                37.9265569
              ],
              [
                49.2011649,
                37.9304168
              ],
              [
                49.1984691,
                37.934231
              ],
              [
                49.1939853,
                37.9401747
              ],
              [
                49.1903282,
                37.9446619
              ],
              [
                49.1909329,
                37.952302
              ],
              [
                49.191162,
                37.9602989
              ],
              [
                49.1911588,
                37.9619939
              ],
              [
                49.1911118,
                37.968464
              ],
              [
                49.1908334,
                37.976779
              ],
              [
                49.190119,
                37.9850778
              ],
              [
                49.1889699,
                37.9933458
              ],
              [
                49.1873878,
                38.001569
              ],
              [
                49.1863838,
                38.0058673
              ],
              [
                49.1852614,
                38.0101472
              ],
              [
                49.1840211,
                38.0144067
              ],
              [
                49.1826635,
                38.0186438
              ],
              [
                49.1811892,
                38.0228564
              ],
              [
                49.179599,
                38.0270425
              ],
              [
                49.1778935,
                38.0312002
              ],
              [
                49.1760735,
                38.0353274
              ],
              [
                49.1738759,
                38.0399022
              ],
              [
                49.1738986,
                38.0412175
              ],
              [
                49.1738534,
                38.0455884
              ],
              [
                49.1736875,
                38.0499575
              ],
              [
                49.1734012,
                38.0543226
              ],
              [
                49.1729945,
                38.0586818
              ],
              [
                49.1724675,
                38.0630329
              ],
              [
                49.1718206,
                38.0673739
              ],
              [
                49.1710539,
                38.0717027
              ],
              [
                49.1701679,
                38.0760173
              ],
              [
                49.1691293,
                38.0804507
              ],
              [
                49.1684198,
                38.0831395
              ],
              [
                49.168634,
                38.0852766
              ],
              [
                49.1689506,
                38.0896405
              ],
              [
                49.1691466,
                38.0940087
              ],
              [
                49.1692221,
                38.0983793
              ],
              [
                49.1692228,
                38.0991895
              ],
              [
                49.1692136,
                38.1047106
              ],
              [
                49.1691489,
                38.1089801
              ],
              [
                49.1689691,
                38.1132474
              ],
              [
                49.1686742,
                38.1175108
              ],
              [
                49.1682101,
                38.1217767
              ],
              [
                49.1682205,
                38.1224438
              ],
              [
                49.1688168,
                38.1267973
              ],
              [
                49.169254,
                38.1311547
              ],
              [
                49.1695708,
                38.1355185
              ],
              [
                49.1697669,
                38.1398867
              ],
              [
                49.1698424,
                38.1442573
              ],
              [
                49.1696469,
                38.1526896
              ],
              [
                49.1696119,
                38.1533915
              ],
              [
                49.1691423,
                38.1600143
              ],
              [
                49.1683953,
                38.1666212
              ],
              [
                49.1673715,
                38.1732049
              ],
              [
                49.1660719,
                38.1797583
              ],
              [
                49.1653908,
                38.1827236
              ],
              [
                49.1631617,
                38.192027
              ],
              [
                49.1610831,
                38.1998436
              ],
              [
                49.1586109,
                38.2075886
              ],
              [
                49.1557489,
                38.2152496
              ],
              [
                49.1525015,
                38.2228144
              ],
              [
                49.1494215,
                38.2291878
              ],
              [
                49.1481125,
                38.2328703
              ],
              [
                49.1480711,
                38.2368686
              ],
              [
                49.1479049,
                38.2412376
              ],
              [
                49.147618,
                38.2456026
              ],
              [
                49.1472103,
                38.2499617
              ],
              [
                49.1466821,
                38.2543127
              ],
              [
                49.1460335,
                38.2586535
              ],
              [
                49.1452649,
                38.2629822
              ],
              [
                49.1443767,
                38.2672966
              ],
              [
                49.1431163,
                38.2725976
              ],
              [
                49.1416752,
                38.2778699
              ],
              [
                49.1400543,
                38.2831097
              ],
              [
                49.1382548,
                38.2883132
              ],
              [
                49.1362729,
                38.2937527
              ],
              [
                49.1362825,
                38.2941605
              ],
              [
                49.0281678,
                38.2922883
              ],
              [
                48.8826524,
                38.2730035
              ],
              [
                48.8797187,
                38.2727896
              ],
              [
                48.8787209,
                38.2757535
              ],
              [
                48.8768434,
                38.2775737
              ],
              [
                48.8742256,
                38.2778095
              ],
              [
                48.8707065,
                38.2778432
              ],
              [
                48.8678231,
                38.2764732
              ],
              [
                48.8688612,
                38.2722506
              ],
              [
                48.8461127,
                38.2707109
              ],
              [
                48.8138959,
                38.2626424
              ],
              [
                48.7796401,
                38.2538862
              ],
              [
                48.7671088,
                38.256717
              ],
              [
                48.7535476,
                38.2534144
              ],
              [
                48.7454472,
                38.249937
              ],
              [
                48.7453079,
                38.2498673
              ],
              [
                48.7363063,
                38.2529933
              ],
              [
                48.7254174,
                38.2549082
              ],
              [
                48.7170478,
                38.2565422
              ],
              [
                48.7080317,
                38.2563745
              ],
              [
                48.7043237,
                38.2553353
              ],
              [
                48.7003437,
                38.2551276
              ],
              [
                48.6962986,
                38.249168
              ],
              [
                48.6893145,
                38.2427659
              ],
              [
                48.6896627,
                38.2392046
              ],
              [
                48.692873,
                38.2358719
              ],
              [
                48.6943521,
                38.2330105
              ],
              [
                48.6936378,
                38.2295505
              ],
              [
                48.693023,
                38.224132
              ],
              [
                48.6964497,
                38.2211365
              ],
              [
                48.7012236,
                38.2192437
              ],
              [
                48.7067699,
                38.2179528
              ],
              [
                48.7086581,
                38.2153903
              ],
              [
                48.7084865,
                38.2130974
              ],
              [
                48.706169,
                38.2106021
              ],
              [
                48.70265,
                38.2087812
              ],
              [
                48.6924328,
                38.2079654
              ],
              [
                48.6894596,
                38.2035366
              ],
              [
                48.6862899,
                38.1954056
              ],
              [
                48.6838506,
                38.1839113
              ],
              [
                48.6832691,
                38.1770876
              ],
              [
                48.6825754,
                38.1721181
              ],
              [
                48.6813726,
                38.1643156
              ],
              [
                48.6792442,
                38.1585642
              ],
              [
                48.674082,
                38.1481084
              ],
              [
                48.6697547,
                38.140059
              ],
              [
                48.6681061,
                38.137865
              ],
              [
                48.6594865,
                38.1257881
              ],
              [
                48.6575202,
                38.1144169
              ],
              [
                48.6538553,
                38.1078848
              ],
              [
                48.6499071,
                38.1035624
              ],
              [
                48.6508082,
                38.1006581
              ],
              [
                48.6548423,
                38.0945791
              ],
              [
                48.6534689,
                38.0857973
              ],
              [
                48.6490057,
                38.0752578
              ],
              [
                48.6419676,
                38.0628246
              ],
              [
                48.6385344,
                38.0533631
              ],
              [
                48.6308096,
                38.0495782
              ],
              [
                48.6175917,
                38.0445764
              ],
              [
                48.6091803,
                38.0428189
              ],
              [
                48.6030005,
                38.0375462
              ],
              [
                48.5998105,
                38.0320927
              ],
              [
                48.5918079,
                38.0244786
              ],
              [
                48.5882377,
                38.0196635
              ],
              [
                48.586774,
                38.0166258
              ],
              [
                48.5859395,
                38.012795
              ],
              [
                48.5861349,
                38.0092835
              ],
              [
                48.5872936,
                38.0064431
              ],
              [
                48.5887527,
                38.004448
              ],
              [
                48.5913291,
                38.0019515
              ],
              [
                48.5957789,
                37.9992892
              ],
              [
                48.5991382,
                37.9975832
              ],
              [
                48.6011123,
                37.9973126
              ],
              [
                48.6034449,
                37.9941729
              ],
              [
                48.6021943,
                37.9875002
              ],
              [
                48.5983228,
                37.9804011
              ],
              [
                48.5920572,
                37.9750563
              ],
              [
                48.5904693,
                37.9701847
              ],
              [
                48.5902977,
                37.9583427
              ],
              [
                48.5904693,
                37.955365
              ],
              [
                48.5913014,
                37.9456828
              ],
              [
                48.5911524,
                37.9419484
              ],
              [
                48.5861349,
                37.9383424
              ],
              [
                48.5817749,
                37.9365559
              ],
              [
                48.5778093,
                37.9349238
              ],
              [
                48.5631752,
                37.9332653
              ],
              [
                48.5532617,
                37.9300835
              ],
              [
                48.5512018,
                37.9247688
              ],
              [
                48.5428762,
                37.9187767
              ],
              [
                48.5375118,
                37.9127502
              ],
              [
                48.5361814,
                37.9033371
              ],
              [
                48.5387563,
                37.8979867
              ],
              [
                48.5414171,
                37.8973771
              ],
              [
                48.5460519,
                37.8999847
              ],
              [
                48.5464811,
                37.9000863
              ],
              [
                48.5527467,
                37.9025921
              ],
              [
                48.5553646,
                37.902626
              ],
              [
                48.5584868,
                37.9015366
              ],
              [
                48.5602139,
                37.8994768
              ],
              [
                48.5611475,
                37.8960446
              ],
              [
                48.5610427,
                37.8877656
              ],
              [
                48.5592594,
                37.8830233
              ],
              [
                48.5581967,
                37.8764119
              ],
              [
                48.5587222,
                37.8708663
              ],
              [
                48.5590179,
                37.8585879
              ],
              [
                48.5641569,
                37.8518474
              ],
              [
                48.5674486,
                37.8493404
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555142,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فومن",
          "name:en": "Fuman County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289677",
          "wikipedia": "en:Fuman County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.8777775,
                37.2519893
              ],
              [
                48.8953085,
                37.2255624
              ],
              [
                48.8994749,
                37.2183459
              ],
              [
                48.901422,
                37.2150075
              ],
              [
                48.9203115,
                37.1852855
              ],
              [
                48.9205884,
                37.1833418
              ],
              [
                48.920865,
                37.181677
              ],
              [
                48.9211451,
                37.1802912
              ],
              [
                48.9214217,
                37.1800122
              ],
              [
                48.9208613,
                37.1770978
              ],
              [
                48.9207078,
                37.1766933
              ],
              [
                48.9202965,
                37.1756236
              ],
              [
                48.9201232,
                37.1750198
              ],
              [
                48.919517,
                37.1746748
              ],
              [
                48.9187808,
                37.1738121
              ],
              [
                48.9180229,
                37.1727769
              ],
              [
                48.9178064,
                37.1720351
              ],
              [
                48.9181312,
                37.1710344
              ],
              [
                48.9182611,
                37.1706893
              ],
              [
                48.9228116,
                37.1672339
              ],
              [
                48.9247551,
                37.1622304
              ],
              [
                48.9261449,
                37.1600077
              ],
              [
                48.9308649,
                37.1516745
              ],
              [
                48.9314215,
                37.1513956
              ],
              [
                48.9319782,
                37.1502887
              ],
              [
                48.9394534,
                37.1448358
              ],
              [
                48.9554211,
                37.132814
              ],
              [
                48.9682959,
                37.1339087
              ],
              [
                48.988134,
                37.1360832
              ],
              [
                48.9978216,
                37.1371931
              ],
              [
                49.0197518,
                37.1334077
              ],
              [
                49.0343394,
                37.1313055
              ],
              [
                49.0351731,
                37.1304778
              ],
              [
                49.0715641,
                37.121786
              ],
              [
                49.0908318,
                37.1161689
              ],
              [
                49.1078642,
                37.1051205
              ],
              [
                49.1240481,
                37.09095
              ],
              [
                49.1298434,
                37.0840608
              ],
              [
                49.1393832,
                37.0716808
              ],
              [
                49.1585477,
                37.0431084
              ],
              [
                49.1599379,
                37.038942
              ],
              [
                49.1708095,
                37.0212894
              ],
              [
                49.1851043,
                37.0290751
              ],
              [
                49.2047689,
                37.0408417
              ],
              [
                49.2178509,
                37.0493415
              ],
              [
                49.2282686,
                37.0572591
              ],
              [
                49.2375408,
                37.0642714
              ],
              [
                49.2400359,
                37.0677797
              ],
              [
                49.2469024,
                37.0714094
              ],
              [
                49.250208,
                37.0717823
              ],
              [
                49.2721485,
                37.0840273
              ],
              [
                49.2852998,
                37.093443
              ],
              [
                49.2894748,
                37.0957634
              ],
              [
                49.2961913,
                37.1008438
              ],
              [
                49.3161641,
                37.1197275
              ],
              [
                49.3328189,
                37.1496451
              ],
              [
                49.3311689,
                37.1545374
              ],
              [
                49.3385696,
                37.1575805
              ],
              [
                49.3420444,
                37.160222
              ],
              [
                49.3475818,
                37.1626593
              ],
              [
                49.3540952,
                37.1656069
              ],
              [
                49.3566799,
                37.1657202
              ],
              [
                49.3589544,
                37.1660964
              ],
              [
                49.3604993,
                37.1665752
              ],
              [
                49.3608856,
                37.1677721
              ],
              [
                49.3601989,
                37.1691742
              ],
              [
                49.3599428,
                37.1764008
              ],
              [
                49.3595257,
                37.1816436
              ],
              [
                49.3589784,
                37.1895672
              ],
              [
                49.3587006,
                37.1940512
              ],
              [
                49.368197,
                37.1922051
              ],
              [
                49.3735172,
                37.1888205
              ],
              [
                49.3792623,
                37.1882393
              ],
              [
                49.3850898,
                37.1898608
              ],
              [
                49.388066,
                37.1917017
              ],
              [
                49.4088211,
                37.1926922
              ],
              [
                49.4210444,
                37.1942934
              ],
              [
                49.4294695,
                37.1962679
              ],
              [
                49.4293784,
                37.1979287
              ],
              [
                49.4156455,
                37.1999114
              ],
              [
                49.4144439,
                37.206611
              ],
              [
                49.4100665,
                37.2112594
              ],
              [
                49.4141006,
                37.2154974
              ],
              [
                49.4323768,
                37.2101059
              ],
              [
                49.4353999,
                37.220985
              ],
              [
                49.4376983,
                37.2274854
              ],
              [
                49.4335841,
                37.2282783
              ],
              [
                49.4313525,
                37.2298501
              ],
              [
                49.4251725,
                37.2337761
              ],
              [
                49.4214899,
                37.2396099
              ],
              [
                49.422545,
                37.2450629
              ],
              [
                49.4238325,
                37.246714
              ],
              [
                49.4232376,
                37.2507489
              ],
              [
                49.4136658,
                37.2594587
              ],
              [
                49.4133893,
                37.2602954
              ],
              [
                49.4127954,
                37.2607218
              ],
              [
                49.4117374,
                37.2614815
              ],
              [
                49.4004419,
                37.2713607
              ],
              [
                49.396821,
                37.2697868
              ],
              [
                49.3927891,
                37.2687251
              ],
              [
                49.3876823,
                37.2679011
              ],
              [
                49.3825433,
                37.2681178
              ],
              [
                49.3782247,
                37.268413
              ],
              [
                49.3770212,
                37.2689128
              ],
              [
                49.375523,
                37.2682967
              ],
              [
                49.3738129,
                37.2668613
              ],
              [
                49.3728666,
                37.26746
              ],
              [
                49.3731809,
                37.2680315
              ],
              [
                49.3731257,
                37.2681424
              ],
              [
                49.3714535,
                37.2674189
              ],
              [
                49.3698549,
                37.2665224
              ],
              [
                49.3685947,
                37.2658463
              ],
              [
                49.3681165,
                37.2607028
              ],
              [
                49.3676404,
                37.257071
              ],
              [
                49.363628,
                37.2550386
              ],
              [
                49.3611841,
                37.2559973
              ],
              [
                49.3591589,
                37.2586492
              ],
              [
                49.3621832,
                37.268884
              ],
              [
                49.3646192,
                37.2762043
              ],
              [
                49.3631172,
                37.2774677
              ],
              [
                49.3621731,
                37.2771092
              ],
              [
                49.3598985,
                37.2774677
              ],
              [
                49.3594479,
                37.2782361
              ],
              [
                49.3595552,
                37.2797556
              ],
              [
                49.3584925,
                37.2800605
              ],
              [
                49.3555474,
                37.2795602
              ],
              [
                49.3536007,
                37.2807374
              ],
              [
                49.3516266,
                37.2808227
              ],
              [
                49.3509507,
                37.280541
              ],
              [
                49.3503284,
                37.2802379
              ],
              [
                49.3489766,
                37.2798069
              ],
              [
                49.3408012,
                37.277297
              ],
              [
                49.3360866,
                37.2750526
              ],
              [
                49.3341727,
                37.2749304
              ],
              [
                49.3230422,
                37.2711852
              ],
              [
                49.320395,
                37.2706719
              ],
              [
                49.31498,
                37.270446
              ],
              [
                49.2953068,
                37.2671276
              ],
              [
                49.2870212,
                37.26478
              ],
              [
                49.2801602,
                37.2648117
              ],
              [
                49.2709199,
                37.2661949
              ],
              [
                49.2654935,
                37.2763776
              ],
              [
                49.2589187,
                37.2860044
              ],
              [
                49.2549204,
                37.2862824
              ],
              [
                49.2449495,
                37.2861288
              ],
              [
                49.240787,
                37.2810532
              ],
              [
                49.2384481,
                37.2777068
              ],
              [
                49.2381058,
                37.2779365
              ],
              [
                49.2370319,
                37.2758628
              ],
              [
                49.2376756,
                37.2749066
              ],
              [
                49.2380189,
                37.2733357
              ],
              [
                49.2365169,
                37.2721404
              ],
              [
                49.2361307,
                37.2708427
              ],
              [
                49.2370748,
                37.26934
              ],
              [
                49.2365598,
                37.2664712
              ],
              [
                49.2367315,
                37.2654466
              ],
              [
                49.2347145,
                37.2631241
              ],
              [
                49.2328782,
                37.261312
              ],
              [
                49.2324185,
                37.2590254
              ],
              [
                49.2303083,
                37.2566529
              ],
              [
                49.2286632,
                37.2553379
              ],
              [
                49.227076,
                37.2545524
              ],
              [
                49.2260137,
                37.2545866
              ],
              [
                49.2242149,
                37.2544556
              ],
              [
                49.2221761,
                37.2544982
              ],
              [
                49.2211048,
                37.2538394
              ],
              [
                49.2203283,
                37.2530384
              ],
              [
                49.2195046,
                37.2527167
              ],
              [
                49.2145765,
                37.2531332
              ],
              [
                49.2128062,
                37.2540725
              ],
              [
                49.2121801,
                37.2519783
              ],
              [
                49.2120981,
                37.2516643
              ],
              [
                49.209347,
                37.2491677
              ],
              [
                49.2077233,
                37.2484628
              ],
              [
                49.2071414,
                37.2487607
              ],
              [
                49.2063474,
                37.249478
              ],
              [
                49.2063025,
                37.250738
              ],
              [
                49.2064333,
                37.2535602
              ],
              [
                49.2079782,
                37.2560196
              ],
              [
                49.2053604,
                37.258923
              ],
              [
                49.1932153,
                37.2551656
              ],
              [
                49.1869497,
                37.2540726
              ],
              [
                49.183216,
                37.2562246
              ],
              [
                49.182701,
                37.2596061
              ],
              [
                49.1812848,
                37.262202
              ],
              [
                49.1814994,
                37.2677007
              ],
              [
                49.181902,
                37.2726884
              ],
              [
                49.1801261,
                37.2778093
              ],
              [
                49.1774654,
                37.278902
              ],
              [
                49.1679184,
                37.2861129
              ],
              [
                49.1627515,
                37.2877319
              ],
              [
                49.1545483,
                37.288736
              ],
              [
                49.1431448,
                37.2855205
              ],
              [
                49.1272897,
                37.2735809
              ],
              [
                49.1182422,
                37.2676324
              ],
              [
                49.1122185,
                37.2662078
              ],
              [
                49.1049384,
                37.2634657
              ],
              [
                49.0926917,
                37.2618819
              ],
              [
                49.0854212,
                37.2611987
              ],
              [
                49.079139,
                37.2621042
              ],
              [
                49.0639756,
                37.2665261
              ],
              [
                49.0511722,
                37.2736643
              ],
              [
                49.0462497,
                37.2768178
              ],
              [
                49.0452003,
                37.2760335
              ],
              [
                49.0454578,
                37.2724136
              ],
              [
                49.0474878,
                37.2684814
              ],
              [
                49.0469991,
                37.265032
              ],
              [
                49.0405666,
                37.2589464
              ],
              [
                49.0352398,
                37.255402
              ],
              [
                49.0324835,
                37.2545081
              ],
              [
                49.0241764,
                37.25325
              ],
              [
                49.0155029,
                37.2521596
              ],
              [
                49.005076,
                37.2515495
              ],
              [
                48.9994982,
                37.2510712
              ],
              [
                48.9843982,
                37.2530579
              ],
              [
                48.9574751,
                37.2511419
              ],
              [
                48.8903101,
                37.2515901
              ],
              [
                48.8777775,
                37.2519893
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555188,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لاهیجان",
          "name:en": "Lahijan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1289706",
          "wikipedia": "en:Lahijan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.7578205,
                37.1495943
              ],
              [
                49.7610282,
                37.1487557
              ],
              [
                49.7698725,
                37.1486996
              ],
              [
                49.7746753,
                37.1467717
              ],
              [
                49.7796368,
                37.1466472
              ],
              [
                49.7822833,
                37.144366
              ],
              [
                49.7895496,
                37.1397477
              ],
              [
                49.7893516,
                37.1386978
              ],
              [
                49.7914725,
                37.1386293
              ],
              [
                49.7985286,
                37.1396664
              ],
              [
                49.8054667,
                37.1497414
              ],
              [
                49.8079084,
                37.1501457
              ],
              [
                49.8221241,
                37.1545269
              ],
              [
                49.8229626,
                37.1585378
              ],
              [
                49.8242854,
                37.1601114
              ],
              [
                49.8250109,
                37.1675827
              ],
              [
                49.8213672,
                37.1695504
              ],
              [
                49.8269462,
                37.1720126
              ],
              [
                49.8359584,
                37.1798772
              ],
              [
                49.8454856,
                37.1850743
              ],
              [
                49.8602535,
                37.1906794
              ],
              [
                49.8641967,
                37.189724
              ],
              [
                49.8681552,
                37.1881552
              ],
              [
                49.8766544,
                37.1850313
              ],
              [
                49.8894792,
                37.1867597
              ],
              [
                49.9011891,
                37.1883317
              ],
              [
                49.9020052,
                37.1876727
              ],
              [
                49.9032712,
                37.1859119
              ],
              [
                49.9059105,
                37.1839289
              ],
              [
                49.9118542,
                37.1782188
              ],
              [
                49.9161887,
                37.1737052
              ],
              [
                49.9190855,
                37.1707643
              ],
              [
                49.9196219,
                37.1700462
              ],
              [
                49.9205446,
                37.1694136
              ],
              [
                49.9222657,
                37.1691909
              ],
              [
                49.9234843,
                37.1694478
              ],
              [
                49.9246645,
                37.1702001
              ],
              [
                49.9258017,
                37.170696
              ],
              [
                49.9274969,
                37.1708669
              ],
              [
                49.9294925,
                37.1706618
              ],
              [
                49.9301147,
                37.1698068
              ],
              [
                49.9302435,
                37.1692426
              ],
              [
                49.929986,
                37.1684389
              ],
              [
                49.9292779,
                37.167755
              ],
              [
                49.9286771,
                37.1675498
              ],
              [
                49.9276471,
                37.1670368
              ],
              [
                49.9268961,
                37.1661648
              ],
              [
                49.9265528,
                37.1648652
              ],
              [
                49.9267888,
                37.1640273
              ],
              [
                49.9272823,
                37.1631039
              ],
              [
                49.9274777,
                37.1590094
              ],
              [
                49.928483,
                37.1573514
              ],
              [
                49.9292239,
                37.1567395
              ],
              [
                49.9308872,
                37.1553914
              ],
              [
                49.9395561,
                37.1512527
              ],
              [
                49.9418626,
                37.1490024
              ],
              [
                49.941138,
                37.1352305
              ],
              [
                49.94273,
                37.129736
              ],
              [
                49.9560444,
                37.1262985
              ],
              [
                49.968996,
                37.1163209
              ],
              [
                49.9806697,
                37.1058057
              ],
              [
                49.9795313,
                37.1015397
              ],
              [
                49.9788458,
                37.0960151
              ],
              [
                49.9798627,
                37.0942493
              ],
              [
                49.9809265,
                37.0930811
              ],
              [
                49.9831795,
                37.0894867
              ],
              [
                49.9833687,
                37.0883259
              ],
              [
                49.9857226,
                37.0873975
              ],
              [
                49.9875354,
                37.0866111
              ],
              [
                49.9888658,
                37.0832902
              ],
              [
                49.9891662,
                37.0821605
              ],
              [
                49.9952602,
                37.0805856
              ],
              [
                50.0001366,
                37.0808183
              ],
              [
                50.0235843,
                37.0872273
              ],
              [
                50.0485621,
                37.0905975
              ],
              [
                50.0555831,
                37.0950648
              ],
              [
                50.0620272,
                37.1015822
              ],
              [
                50.0561839,
                37.106497
              ],
              [
                50.0586576,
                37.1112341
              ],
              [
                50.0636507,
                37.116577
              ],
              [
                50.0705821,
                37.119531
              ],
              [
                50.0786832,
                37.1216453
              ],
              [
                50.0889442,
                37.1185207
              ],
              [
                50.0992011,
                37.1251153
              ],
              [
                50.0998018,
                37.135893
              ],
              [
                50.0932567,
                37.1511028
              ],
              [
                50.0923347,
                37.1538865
              ],
              [
                50.0863771,
                37.1643914
              ],
              [
                50.0819752,
                37.1720305
              ],
              [
                50.078063,
                37.18039
              ],
              [
                50.0813461,
                37.183541
              ],
              [
                50.0847555,
                37.1842038
              ],
              [
                50.0942197,
                37.188718
              ],
              [
                50.0970949,
                37.1897718
              ],
              [
                50.0982549,
                37.1919788
              ],
              [
                50.0990489,
                37.1943595
              ],
              [
                50.096884,
                37.1955101
              ],
              [
                50.0931743,
                37.1949589
              ],
              [
                50.091222,
                37.194672
              ],
              [
                50.0909224,
                37.1955729
              ],
              [
                50.0903034,
                37.1979971
              ],
              [
                50.0900887,
                37.1989023
              ],
              [
                50.090062,
                37.1989955
              ],
              [
                50.0888239,
                37.200846
              ],
              [
                50.0895988,
                37.2028355
              ],
              [
                50.0878631,
                37.2058251
              ],
              [
                50.0826358,
                37.207363
              ],
              [
                50.0786447,
                37.212524
              ],
              [
                50.0748718,
                37.2153921
              ],
              [
                50.0680712,
                37.2166611
              ],
              [
                50.0697612,
                37.2197352
              ],
              [
                50.0702103,
                37.2261213
              ],
              [
                50.0671863,
                37.2303285
              ],
              [
                50.0685596,
                37.234087
              ],
              [
                50.0757909,
                37.2389728
              ],
              [
                50.0774,
                37.2410711
              ],
              [
                50.0801468,
                37.242731
              ],
              [
                50.0813602,
                37.2432239
              ],
              [
                50.0853288,
                37.2444904
              ],
              [
                50.0884938,
                37.2455324
              ],
              [
                50.0901031,
                37.2451224
              ],
              [
                50.0924635,
                37.2413986
              ],
              [
                50.0964548,
                37.2398444
              ],
              [
                50.1060759,
                37.2378179
              ],
              [
                50.1097383,
                37.2367898
              ],
              [
                50.1255083,
                37.2398953
              ],
              [
                50.1367393,
                37.2349688
              ],
              [
                50.1422882,
                37.2340528
              ],
              [
                50.1476955,
                37.2372304
              ],
              [
                50.1492405,
                37.2385628
              ],
              [
                50.148983,
                37.2403053
              ],
              [
                50.147749,
                37.2435458
              ],
              [
                50.1436615,
                37.2433118
              ],
              [
                50.1428031,
                37.2416719
              ],
              [
                50.1403999,
                37.242116
              ],
              [
                50.1380395,
                37.2437217
              ],
              [
                50.1363229,
                37.2455665
              ],
              [
                50.1358938,
                37.2474455
              ],
              [
                50.13628,
                37.2504175
              ],
              [
                50.1388979,
                37.2532869
              ],
              [
                50.1427173,
                37.2562245
              ],
              [
                50.1462793,
                37.2577275
              ],
              [
                50.1574373,
                37.2599818
              ],
              [
                50.1687432,
                37.2593727
              ],
              [
                50.1728438,
                37.2576592
              ],
              [
                50.1800536,
                37.2571127
              ],
              [
                50.1901056,
                37.2598281
              ],
              [
                50.1930084,
                37.2625719
              ],
              [
                50.1967906,
                37.2750091
              ],
              [
                50.1980091,
                37.2917829
              ],
              [
                50.1996237,
                37.2972324
              ],
              [
                50.2026159,
                37.3037126
              ],
              [
                50.2077967,
                37.310077
              ],
              [
                50.2153499,
                37.3149071
              ],
              [
                50.2194932,
                37.3184331
              ],
              [
                50.2228485,
                37.3201369
              ],
              [
                50.468763,
                37.3878905
              ],
              [
                50.4675327,
                37.3921504
              ],
              [
                50.4661862,
                37.3963878
              ],
              [
                50.4647239,
                37.4006008
              ],
              [
                50.4631465,
                37.4047873
              ],
              [
                50.4614549,
                37.4089454
              ],
              [
                50.4596498,
                37.4130729
              ],
              [
                50.457612,
                37.4174156
              ],
              [
                50.4554486,
                37.4217194
              ],
              [
                50.4531606,
                37.4259821
              ],
              [
                50.4507493,
                37.4302014
              ],
              [
                50.4455308,
                37.4390578
              ],
              [
                50.4409637,
                37.4464119
              ],
              [
                50.4360217,
                37.4536105
              ],
              [
                50.4334635,
                37.4571043
              ],
              [
                50.4311541,
                37.4612001
              ],
              [
                50.4287942,
                37.4651462
              ],
              [
                50.4263267,
                37.4690502
              ],
              [
                50.4237526,
                37.4729103
              ],
              [
                50.4210732,
                37.4767247
              ],
              [
                50.4170435,
                37.482119
              ],
              [
                50.4128032,
                37.48741
              ],
              [
                50.4083564,
                37.4925923
              ],
              [
                50.4037074,
                37.4976609
              ],
              [
                50.4004046,
                37.5011453
              ],
              [
                50.3966176,
                37.5050396
              ],
              [
                50.3927112,
                37.5088584
              ],
              [
                50.3891466,
                37.512182
              ],
              [
                50.3854916,
                37.5154428
              ],
              [
                50.3817478,
                37.5186392
              ],
              [
                50.377917,
                37.5217696
              ],
              [
                50.3740011,
                37.5248326
              ],
              [
                50.3700019,
                37.5278267
              ],
              [
                50.3659214,
                37.5307504
              ],
              [
                50.3617614,
                37.5336025
              ],
              [
                50.3572479,
                37.5365582
              ],
              [
                50.352649,
                37.5394295
              ],
              [
                50.3521998,
                37.5397033
              ],
              [
                50.345724,
                37.5435205
              ],
              [
                50.3390974,
                37.5471704
              ],
              [
                50.3323268,
                37.5506491
              ],
              [
                50.3254191,
                37.553953
              ],
              [
                50.3206378,
                37.5561023
              ],
              [
                50.3157984,
                37.5581678
              ],
              [
                50.3109033,
                37.5601486
              ],
              [
                50.3059549,
                37.5620437
              ],
              [
                50.3017682,
                37.5635582
              ],
              [
                50.3002491,
                37.5642065
              ],
              [
                50.2953536,
                37.5661873
              ],
              [
                50.1804703,
                37.386426
              ],
              [
                50.1824196,
                37.3826788
              ],
              [
                50.1829326,
                37.3787741
              ],
              [
                50.1795468,
                37.3753952
              ],
              [
                50.1763374,
                37.3720389
              ],
              [
                50.1711685,
                37.3666724
              ],
              [
                50.1715848,
                37.3664565
              ],
              [
                50.1695823,
                37.3629946
              ],
              [
                50.1679945,
                37.3633698
              ],
              [
                50.1652479,
                37.3602658
              ],
              [
                50.165162,
                37.3585261
              ],
              [
                50.1629734,
                37.356957
              ],
              [
                50.1610422,
                37.3567182
              ],
              [
                50.1583385,
                37.3555925
              ],
              [
                50.156579,
                37.3521129
              ],
              [
                50.1582527,
                37.3505777
              ],
              [
                50.1590251,
                37.3470297
              ],
              [
                50.1579952,
                37.3449144
              ],
              [
                50.1548589,
                37.3432453
              ],
              [
                50.150874,
                37.3405728
              ],
              [
                50.1491975,
                37.3387389
              ],
              [
                50.1474379,
                37.3376471
              ],
              [
                50.1402925,
                37.3403938
              ],
              [
                50.1407432,
                37.3415537
              ],
              [
                50.1408505,
                37.3426967
              ],
              [
                50.1407218,
                37.3431062
              ],
              [
                50.1397562,
                37.3430891
              ],
              [
                50.1379108,
                37.3432768
              ],
              [
                50.13422,
                37.3434815
              ],
              [
                50.1322459,
                37.343618
              ],
              [
                50.1288985,
                37.3447098
              ],
              [
                50.126152,
                37.3449145
              ],
              [
                50.1249503,
                37.3457333
              ],
              [
                50.1161098,
                37.345665
              ],
              [
                50.1145648,
                37.345938
              ],
              [
                50.1077842,
                37.3451192
              ],
              [
                50.1045226,
                37.3434133
              ],
              [
                50.1022052,
                37.3421168
              ],
              [
                50.0996729,
                37.3399983
              ],
              [
                50.0898824,
                37.3323658
              ],
              [
                50.0804042,
                37.3250553
              ],
              [
                50.0765848,
                37.321745
              ],
              [
                50.0738924,
                37.3177056
              ],
              [
                50.0724479,
                37.3146493
              ],
              [
                50.0683879,
                37.3073757
              ],
              [
                50.0662422,
                37.3055324
              ],
              [
                50.0644826,
                37.3023236
              ],
              [
                50.0613384,
                37.2995919
              ],
              [
                50.0559854,
                37.2985001
              ],
              [
                50.0532388,
                37.2967249
              ],
              [
                50.0528998,
                37.2936255
              ],
              [
                50.0418496,
                37.2851424
              ],
              [
                50.0370312,
                37.2830728
              ],
              [
                50.0318699,
                37.2818021
              ],
              [
                50.0257649,
                37.2811575
              ],
              [
                50.0221856,
                37.2817012
              ],
              [
                50.0213551,
                37.2813743
              ],
              [
                50.0181014,
                37.2806
              ],
              [
                50.017081,
                37.2807412
              ],
              [
                50.0162223,
                37.2804119
              ],
              [
                50.0159478,
                37.2785731
              ],
              [
                50.0150966,
                37.2748418
              ],
              [
                50.0151681,
                37.2738241
              ],
              [
                50.0147845,
                37.2729506
              ],
              [
                50.0138278,
                37.2717152
              ],
              [
                50.0090575,
                37.2720721
              ],
              [
                50.0083622,
                37.271682
              ],
              [
                50.0059139,
                37.2715165
              ],
              [
                50.0037789,
                37.2677007
              ],
              [
                50.0010434,
                37.2671002
              ],
              [
                49.9964692,
                37.2671068
              ],
              [
                49.9936009,
                37.2670661
              ],
              [
                49.9929428,
                37.2651221
              ],
              [
                49.9901533,
                37.2629533
              ],
              [
                49.984231,
                37.2591279
              ],
              [
                49.9800038,
                37.2591108
              ],
              [
                49.9780297,
                37.2569589
              ],
              [
                49.9788666,
                37.2544141
              ],
              [
                49.9835872,
                37.2534235
              ],
              [
                49.9843168,
                37.2521938
              ],
              [
                49.9930286,
                37.2468305
              ],
              [
                49.9956035,
                37.2462839
              ],
              [
                49.9961185,
                37.245464
              ],
              [
                49.9962043,
                37.2435509
              ],
              [
                49.9959468,
                37.2418085
              ],
              [
                49.9952173,
                37.240237
              ],
              [
                49.9919879,
                37.2363847
              ],
              [
                49.9906253,
                37.2355562
              ],
              [
                49.9888869,
                37.2341143
              ],
              [
                49.9816775,
                37.2320369
              ],
              [
                49.9743175,
                37.2299696
              ],
              [
                49.9728584,
                37.2293716
              ],
              [
                49.9641681,
                37.2281757
              ],
              [
                49.9581274,
                37.2274123
              ],
              [
                49.9569239,
                37.2300515
              ],
              [
                49.9558405,
                37.2315389
              ],
              [
                49.953684,
                37.2310097
              ],
              [
                49.9503382,
                37.2412693
              ],
              [
                49.9439753,
                37.2402286
              ],
              [
                49.9436057,
                37.2336397
              ],
              [
                49.9492217,
                37.2299148
              ],
              [
                49.9504995,
                37.2264501
              ],
              [
                49.9477412,
                37.2260938
              ],
              [
                49.9462213,
                37.2250629
              ],
              [
                49.9453175,
                37.2248184
              ],
              [
                49.9443519,
                37.2246817
              ],
              [
                49.9392985,
                37.2230158
              ],
              [
                49.9350071,
                37.221495
              ],
              [
                49.9327326,
                37.2209141
              ],
              [
                49.9252742,
                37.2178295
              ],
              [
                49.9107906,
                37.2133811
              ],
              [
                49.8942588,
                37.2115841
              ],
              [
                49.8853905,
                37.2106108
              ],
              [
                49.8849785,
                37.2105501
              ],
              [
                49.8839275,
                37.2110041
              ],
              [
                49.879927,
                37.2186435
              ],
              [
                49.8757158,
                37.2229514
              ],
              [
                49.8727369,
                37.225647
              ],
              [
                49.870634,
                37.2271164
              ],
              [
                49.8638871,
                37.228233
              ],
              [
                49.8604289,
                37.2270457
              ],
              [
                49.8577885,
                37.2251482
              ],
              [
                49.8541826,
                37.223376
              ],
              [
                49.852208,
                37.221908
              ],
              [
                49.8492193,
                37.2192225
              ],
              [
                49.8472544,
                37.2180984
              ],
              [
                49.8391491,
                37.2063519
              ],
              [
                49.832061,
                37.2044485
              ],
              [
                49.8157246,
                37.2011035
              ],
              [
                49.8119688,
                37.2004241
              ],
              [
                49.8082351,
                37.1981338
              ],
              [
                49.7973691,
                37.1930121
              ],
              [
                49.7949313,
                37.1873308
              ],
              [
                49.7884082,
                37.1796037
              ],
              [
                49.7824,
                37.1755689
              ],
              [
                49.771757,
                37.1709867
              ],
              [
                49.7608565,
                37.1612742
              ],
              [
                49.7578205,
                37.1495943
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555192,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان لنگرود",
          "name:en": "Langarud County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291775",
          "wikipedia": "en:Langarud County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.9636542,
                36.9754164
              ],
              [
                49.9648174,
                36.9738466
              ],
              [
                49.9691934,
                36.9718267
              ],
              [
                49.9755308,
                36.9703818
              ],
              [
                49.9784803,
                36.9682555
              ],
              [
                49.9826191,
                36.9620094
              ],
              [
                49.9864508,
                36.9576262
              ],
              [
                49.9896014,
                36.953638
              ],
              [
                49.9922206,
                36.9490129
              ],
              [
                49.994319,
                36.9463968
              ],
              [
                50.0001432,
                36.9395526
              ],
              [
                50.0028088,
                36.9367535
              ],
              [
                50.0497068,
                36.9630095
              ],
              [
                50.0673988,
                36.9708716
              ],
              [
                50.0827387,
                36.9779391
              ],
              [
                50.087214,
                36.9802007
              ],
              [
                50.0932215,
                36.9859569
              ],
              [
                50.098257,
                36.9900079
              ],
              [
                50.1011752,
                36.9948067
              ],
              [
                50.1028289,
                36.999595
              ],
              [
                50.104207,
                37.0076839
              ],
              [
                50.1059223,
                37.0133227
              ],
              [
                50.1116288,
                37.0294325
              ],
              [
                50.113633,
                37.0370933
              ],
              [
                50.1152515,
                37.0399692
              ],
              [
                50.1208305,
                37.0449018
              ],
              [
                50.1263236,
                37.047505
              ],
              [
                50.1368808,
                37.0505877
              ],
              [
                50.1398849,
                37.0512727
              ],
              [
                50.1409148,
                37.0548347
              ],
              [
                50.1434898,
                37.0599034
              ],
              [
                50.1466655,
                37.062917
              ],
              [
                50.1461505,
                37.0718203
              ],
              [
                50.1482622,
                37.0752286
              ],
              [
                50.1474481,
                37.0788354
              ],
              [
                50.1458036,
                37.0813986
              ],
              [
                50.1545619,
                37.0912669
              ],
              [
                50.1635741,
                37.0911299
              ],
              [
                50.1662749,
                37.09228
              ],
              [
                50.1646689,
                37.0938479
              ],
              [
                50.1652807,
                37.0950697
              ],
              [
                50.1658374,
                37.0961768
              ],
              [
                50.1691209,
                37.0978372
              ],
              [
                50.1721358,
                37.0988318
              ],
              [
                50.1734447,
                37.0998929
              ],
              [
                50.1785301,
                37.1018097
              ],
              [
                50.1810837,
                37.1001154
              ],
              [
                50.1828003,
                37.0999956
              ],
              [
                50.1834543,
                37.1007924
              ],
              [
                50.1852893,
                37.1105031
              ],
              [
                50.1857399,
                37.1195547
              ],
              [
                50.1823831,
                37.1217902
              ],
              [
                50.1829566,
                37.1250655
              ],
              [
                50.1830919,
                37.1311878
              ],
              [
                50.1867699,
                37.1301621
              ],
              [
                50.1877855,
                37.1296534
              ],
              [
                50.1914014,
                37.1312246
              ],
              [
                50.1934004,
                37.1329335
              ],
              [
                50.1956678,
                37.134579
              ],
              [
                50.1987854,
                37.1359378
              ],
              [
                50.1951891,
                37.1437503
              ],
              [
                50.1962328,
                37.1489267
              ],
              [
                50.2004814,
                37.1511843
              ],
              [
                50.2030563,
                37.1491319
              ],
              [
                50.2040863,
                37.149303
              ],
              [
                50.2066612,
                37.1477637
              ],
              [
                50.211811,
                37.1430429
              ],
              [
                50.213871,
                37.1447192
              ],
              [
                50.2187204,
                37.1498503
              ],
              [
                50.2196216,
                37.1512185
              ],
              [
                50.226531,
                37.1535786
              ],
              [
                50.2318096,
                37.1546389
              ],
              [
                50.2362728,
                37.1553572
              ],
              [
                50.237174,
                37.1550494
              ],
              [
                50.2387619,
                37.1555624
              ],
              [
                50.2374315,
                37.1569648
              ],
              [
                50.2385472,
                37.157666
              ],
              [
                50.2388048,
                37.1582816
              ],
              [
                50.2374958,
                37.159359
              ],
              [
                50.2379036,
                37.160214
              ],
              [
                50.2399206,
                37.1627961
              ],
              [
                50.2415507,
                37.163968
              ],
              [
                50.2488899,
                37.1591195
              ],
              [
                50.2526106,
                37.1615774
              ],
              [
                50.256443,
                37.1635656
              ],
              [
                50.2573871,
                37.1636682
              ],
              [
                50.2618932,
                37.1654124
              ],
              [
                50.2616357,
                37.1684219
              ],
              [
                50.2599191,
                37.1707815
              ],
              [
                50.2582025,
                37.171739
              ],
              [
                50.2566146,
                37.1724571
              ],
              [
                50.2556276,
                37.1737223
              ],
              [
                50.2557929,
                37.1751804
              ],
              [
                50.257064,
                37.1781452
              ],
              [
                50.2593612,
                37.1804243
              ],
              [
                50.2617644,
                37.1851427
              ],
              [
                50.2615069,
                37.1881514
              ],
              [
                50.263244,
                37.2019342
              ],
              [
                50.2619616,
                37.2038829
              ],
              [
                50.2608155,
                37.2113907
              ],
              [
                50.2616759,
                37.2136472
              ],
              [
                50.2657753,
                37.2134116
              ],
              [
                50.2710256,
                37.2131436
              ],
              [
                50.2737805,
                37.2124558
              ],
              [
                50.5112612,
                37.2754297
              ],
              [
                50.5093469,
                37.279525
              ],
              [
                50.507321,
                37.2835858
              ],
              [
                50.5051845,
                37.2876103
              ],
              [
                50.5029384,
                37.2915966
              ],
              [
                50.5005523,
                37.2955926
              ],
              [
                50.4965277,
                37.3040251
              ],
              [
                50.4881236,
                37.3189529
              ],
              [
                50.4850899,
                37.3265758
              ],
              [
                50.484642,
                37.3276297
              ],
              [
                50.4829999,
                37.3320408
              ],
              [
                50.4812259,
                37.3364326
              ],
              [
                50.4793256,
                37.3407905
              ],
              [
                50.4774564,
                37.3447889
              ],
              [
                50.4755084,
                37.3486991
              ],
              [
                50.4748739,
                37.3551215
              ],
              [
                50.473967,
                37.3616017
              ],
              [
                50.4725334,
                37.3705247
              ],
              [
                50.471764,
                37.3749255
              ],
              [
                50.4708724,
                37.3793115
              ],
              [
                50.4698764,
                37.3836102
              ],
              [
                50.468763,
                37.3878905
              ],
              [
                50.2228485,
                37.3201369
              ],
              [
                50.2194932,
                37.3184331
              ],
              [
                50.2153499,
                37.3149071
              ],
              [
                50.2077967,
                37.310077
              ],
              [
                50.2026159,
                37.3037126
              ],
              [
                50.1996237,
                37.2972324
              ],
              [
                50.1980091,
                37.2917829
              ],
              [
                50.1967906,
                37.2750091
              ],
              [
                50.1930084,
                37.2625719
              ],
              [
                50.1901056,
                37.2598281
              ],
              [
                50.1800536,
                37.2571127
              ],
              [
                50.1728438,
                37.2576592
              ],
              [
                50.1687432,
                37.2593727
              ],
              [
                50.1574373,
                37.2599818
              ],
              [
                50.1462793,
                37.2577275
              ],
              [
                50.1427173,
                37.2562245
              ],
              [
                50.1388979,
                37.2532869
              ],
              [
                50.13628,
                37.2504175
              ],
              [
                50.1358938,
                37.2474455
              ],
              [
                50.1363229,
                37.2455665
              ],
              [
                50.1380395,
                37.2437217
              ],
              [
                50.1403999,
                37.242116
              ],
              [
                50.1428031,
                37.2416719
              ],
              [
                50.1436615,
                37.2433118
              ],
              [
                50.147749,
                37.2435458
              ],
              [
                50.148983,
                37.2403053
              ],
              [
                50.1492405,
                37.2385628
              ],
              [
                50.1476955,
                37.2372304
              ],
              [
                50.1422882,
                37.2340528
              ],
              [
                50.1367393,
                37.2349688
              ],
              [
                50.1255083,
                37.2398953
              ],
              [
                50.1097383,
                37.2367898
              ],
              [
                50.1060759,
                37.2378179
              ],
              [
                50.0964548,
                37.2398444
              ],
              [
                50.0924635,
                37.2413986
              ],
              [
                50.0901031,
                37.2451224
              ],
              [
                50.0884938,
                37.2455324
              ],
              [
                50.0853288,
                37.2444904
              ],
              [
                50.0813602,
                37.2432239
              ],
              [
                50.0801468,
                37.242731
              ],
              [
                50.0774,
                37.2410711
              ],
              [
                50.0757909,
                37.2389728
              ],
              [
                50.0685596,
                37.234087
              ],
              [
                50.0671863,
                37.2303285
              ],
              [
                50.0702103,
                37.2261213
              ],
              [
                50.0697612,
                37.2197352
              ],
              [
                50.0680712,
                37.2166611
              ],
              [
                50.0748718,
                37.2153921
              ],
              [
                50.0786447,
                37.212524
              ],
              [
                50.0826358,
                37.207363
              ],
              [
                50.0878631,
                37.2058251
              ],
              [
                50.0895988,
                37.2028355
              ],
              [
                50.0888239,
                37.200846
              ],
              [
                50.090062,
                37.1989955
              ],
              [
                50.0900887,
                37.1989023
              ],
              [
                50.0903034,
                37.1979971
              ],
              [
                50.0909224,
                37.1955729
              ],
              [
                50.091222,
                37.194672
              ],
              [
                50.0931743,
                37.1949589
              ],
              [
                50.096884,
                37.1955101
              ],
              [
                50.0990489,
                37.1943595
              ],
              [
                50.0982549,
                37.1919788
              ],
              [
                50.0970949,
                37.1897718
              ],
              [
                50.0942197,
                37.188718
              ],
              [
                50.0847555,
                37.1842038
              ],
              [
                50.0813461,
                37.183541
              ],
              [
                50.078063,
                37.18039
              ],
              [
                50.0819752,
                37.1720305
              ],
              [
                50.0863771,
                37.1643914
              ],
              [
                50.0923347,
                37.1538865
              ],
              [
                50.0932567,
                37.1511028
              ],
              [
                50.0998018,
                37.135893
              ],
              [
                50.0992011,
                37.1251153
              ],
              [
                50.0889442,
                37.1185207
              ],
              [
                50.0786832,
                37.1216453
              ],
              [
                50.0705821,
                37.119531
              ],
              [
                50.0636507,
                37.116577
              ],
              [
                50.0586576,
                37.1112341
              ],
              [
                50.0561839,
                37.106497
              ],
              [
                50.0620272,
                37.1015822
              ],
              [
                50.0555831,
                37.0950648
              ],
              [
                50.0485621,
                37.0905975
              ],
              [
                50.0235843,
                37.0872273
              ],
              [
                50.0001366,
                37.0808183
              ],
              [
                49.9952602,
                37.0805856
              ],
              [
                49.9891662,
                37.0821605
              ],
              [
                49.9888658,
                37.0832902
              ],
              [
                49.9875354,
                37.0866111
              ],
              [
                49.9857226,
                37.0873975
              ],
              [
                49.9833687,
                37.0883259
              ],
              [
                49.9818277,
                37.0889047
              ],
              [
                49.9798107,
                37.0894525
              ],
              [
                49.97509,
                37.0890074
              ],
              [
                49.969511,
                37.0875011
              ],
              [
                49.966464,
                37.08733
              ],
              [
                49.9584348,
                37.086476
              ],
              [
                49.9524736,
                37.0836326
              ],
              [
                49.9466371,
                37.0779492
              ],
              [
                49.9439447,
                37.0748069
              ],
              [
                49.9363374,
                37.0706903
              ],
              [
                49.9281406,
                37.0696973
              ],
              [
                49.9229478,
                37.0702794
              ],
              [
                49.9191713,
                37.0693891
              ],
              [
                49.9171972,
                37.0684303
              ],
              [
                49.9164247,
                37.0664099
              ],
              [
                49.9169826,
                37.0651771
              ],
              [
                49.9319601,
                37.0589787
              ],
              [
                49.9372387,
                37.0598691
              ],
              [
                49.9412727,
                37.0595609
              ],
              [
                49.9490585,
                37.0581624
              ],
              [
                49.952582,
                37.057784
              ],
              [
                49.9555254,
                37.0585984
              ],
              [
                49.9595845,
                37.0605063
              ],
              [
                49.9594318,
                37.0624475
              ],
              [
                49.9602235,
                37.0671243
              ],
              [
                49.9618768,
                37.0674178
              ],
              [
                49.9645758,
                37.0677882
              ],
              [
                49.9665725,
                37.067406
              ],
              [
                49.969896,
                37.0647299
              ],
              [
                49.9713207,
                37.0616785
              ],
              [
                49.9741972,
                37.0622242
              ],
              [
                49.9776475,
                37.0634118
              ],
              [
                49.9812144,
                37.0641435
              ],
              [
                49.9836731,
                37.0639786
              ],
              [
                49.9852609,
                37.0574033
              ],
              [
                49.9867627,
                37.0542759
              ],
              [
                49.9913963,
                37.0530088
              ],
              [
                49.9998625,
                37.0562273
              ],
              [
                50.0013757,
                37.0554854
              ],
              [
                50.003221,
                37.0528482
              ],
              [
                50.0027704,
                37.0500225
              ],
              [
                50.0022769,
                37.0436686
              ],
              [
                50.0032425,
                37.0398835
              ],
              [
                50.0059247,
                37.0375027
              ],
              [
                50.0084996,
                37.0301371
              ],
              [
                50.0116646,
                37.0210234
              ],
              [
                50.0128179,
                37.0176708
              ],
              [
                50.0042943,
                37.0138527
              ],
              [
                49.9932485,
                37.0078944
              ],
              [
                49.9859185,
                37.0012057
              ],
              [
                49.9824229,
                36.9981547
              ],
              [
                49.979948,
                36.9968768
              ],
              [
                49.9784341,
                36.9954029
              ],
              [
                49.977094,
                36.9939194
              ],
              [
                49.9750471,
                36.9912076
              ],
              [
                49.974489,
                36.989052
              ],
              [
                49.9720215,
                36.9872999
              ],
              [
                49.9688243,
                36.9872656
              ],
              [
                49.9633741,
                36.9843347
              ],
              [
                49.9624728,
                36.9773239
              ],
              [
                49.9636542,
                36.9754164
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555193,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ماسال",
          "name:en": "Masal County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1291651",
          "wikipedia": "en:Masal County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.8000253,
                37.3919627
              ],
              [
                48.8003024,
                37.3916839
              ],
              [
                48.8097487,
                37.3839023
              ],
              [
                48.8139156,
                37.3805738
              ],
              [
                48.8112257,
                37.3505096
              ],
              [
                48.8266752,
                37.3330407
              ],
              [
                48.8433264,
                37.3107892
              ],
              [
                48.8477896,
                37.3072392
              ],
              [
                48.8654707,
                37.3008216
              ],
              [
                48.8714789,
                37.2969981
              ],
              [
                48.8751944,
                37.2929557
              ],
              [
                48.8756847,
                37.2861409
              ],
              [
                48.8696765,
                37.2747359
              ],
              [
                48.8731097,
                37.267974
              ],
              [
                48.8737964,
                37.261553
              ],
              [
                48.8755566,
                37.2548425
              ],
              [
                48.8777775,
                37.2519893
              ],
              [
                48.8903101,
                37.2515901
              ],
              [
                48.9574751,
                37.2511419
              ],
              [
                48.9843982,
                37.2530579
              ],
              [
                48.9994982,
                37.2510712
              ],
              [
                49.005076,
                37.2515495
              ],
              [
                49.0155029,
                37.2521596
              ],
              [
                49.0241764,
                37.25325
              ],
              [
                49.0324835,
                37.2545081
              ],
              [
                49.0352398,
                37.255402
              ],
              [
                49.0405666,
                37.2589464
              ],
              [
                49.0469991,
                37.265032
              ],
              [
                49.0474878,
                37.2684814
              ],
              [
                49.0454578,
                37.2724136
              ],
              [
                49.0452003,
                37.2760335
              ],
              [
                49.0462497,
                37.2768178
              ],
              [
                49.0477749,
                37.280951
              ],
              [
                49.0522381,
                37.2859363
              ],
              [
                49.0619372,
                37.2936523
              ],
              [
                49.0839099,
                37.3079218
              ],
              [
                49.0922094,
                37.3103041
              ],
              [
                49.1041105,
                37.3131204
              ],
              [
                49.1086507,
                37.3139633
              ],
              [
                49.119401,
                37.3140145
              ],
              [
                49.1270398,
                37.3127858
              ],
              [
                49.1287565,
                37.3129053
              ],
              [
                49.1318035,
                37.3119496
              ],
              [
                49.1391849,
                37.3140657
              ],
              [
                49.152098,
                37.3196096
              ],
              [
                49.1541194,
                37.3193218
              ],
              [
                49.1593259,
                37.3138211
              ],
              [
                49.1587972,
                37.30898
              ],
              [
                49.1558663,
                37.3062376
              ],
              [
                49.1615009,
                37.3050886
              ],
              [
                49.1679188,
                37.3062376
              ],
              [
                49.1659387,
                37.3096109
              ],
              [
                49.1659982,
                37.3125122
              ],
              [
                49.1659641,
                37.3149532
              ],
              [
                49.166007,
                37.3227006
              ],
              [
                49.1701696,
                37.3243047
              ],
              [
                49.1714143,
                37.3264545
              ],
              [
                49.1717577,
                37.3277513
              ],
              [
                49.1742038,
                37.330413
              ],
              [
                49.1748046,
                37.3324263
              ],
              [
                49.1748905,
                37.3342348
              ],
              [
                49.175663,
                37.3353268
              ],
              [
                49.1755657,
                37.3361395
              ],
              [
                49.1758029,
                37.3375503
              ],
              [
                49.1759634,
                37.3421167
              ],
              [
                49.1754979,
                37.3436718
              ],
              [
                49.1746759,
                37.3493837
              ],
              [
                49.1733026,
                37.3515671
              ],
              [
                49.1733026,
                37.3543303
              ],
              [
                49.1738176,
                37.3548761
              ],
              [
                49.1741912,
                37.3613878
              ],
              [
                49.1727876,
                37.3650752
              ],
              [
                49.1698265,
                37.3744545
              ],
              [
                49.1649202,
                37.380801
              ],
              [
                49.1593735,
                37.3860926
              ],
              [
                49.1585258,
                37.3869627
              ],
              [
                49.156351,
                37.3924593
              ],
              [
                49.1557613,
                37.3947754
              ],
              [
                49.1561047,
                37.3999192
              ],
              [
                49.1572521,
                37.4019034
              ],
              [
                49.1600094,
                37.4043791
              ],
              [
                49.1642474,
                37.4080055
              ],
              [
                49.165492,
                37.4087214
              ],
              [
                49.185954,
                37.4345526
              ],
              [
                49.1868049,
                37.4402101
              ],
              [
                49.1856621,
                37.440826
              ],
              [
                49.1808986,
                37.4453576
              ],
              [
                49.1781263,
                37.4483281
              ],
              [
                49.1773796,
                37.4510815
              ],
              [
                49.1779375,
                37.4561577
              ],
              [
                49.1796549,
                37.4603786
              ],
              [
                49.1782593,
                37.462444
              ],
              [
                49.1759204,
                37.464163
              ],
              [
                49.1677204,
                37.4686316
              ],
              [
                49.1661787,
                37.470771
              ],
              [
                49.1654142,
                37.4732249
              ],
              [
                49.1473303,
                37.4738443
              ],
              [
                49.1365666,
                37.4741168
              ],
              [
                49.1238563,
                37.4744702
              ],
              [
                49.1047602,
                37.4750779
              ],
              [
                49.0950679,
                37.4754712
              ],
              [
                49.0699195,
                37.4845301
              ],
              [
                49.0567874,
                37.480716
              ],
              [
                49.0455436,
                37.4828955
              ],
              [
                49.0428828,
                37.4805798
              ],
              [
                49.0410804,
                37.4764248
              ],
              [
                49.0408229,
                37.4719291
              ],
              [
                49.0424537,
                37.4689317
              ],
              [
                49.0418529,
                37.4676374
              ],
              [
                49.0476894,
                37.4568731
              ],
              [
                49.0523363,
                37.4546889
              ],
              [
                49.0614756,
                37.4668161
              ],
              [
                49.0737364,
                37.4619726
              ],
              [
                49.0774051,
                37.4563178
              ],
              [
                49.0767877,
                37.4517462
              ],
              [
                49.0662447,
                37.4484074
              ],
              [
                49.0612498,
                37.4427451
              ],
              [
                49.0463184,
                37.4447214
              ],
              [
                49.0306644,
                37.4457333
              ],
              [
                49.0118128,
                37.4447666
              ],
              [
                49.0078429,
                37.4453703
              ],
              [
                48.999898,
                37.4484879
              ],
              [
                48.9935742,
                37.4376956
              ],
              [
                48.9713306,
                37.433671
              ],
              [
                48.9432819,
                37.4249432
              ],
              [
                48.9027661,
                37.4225755
              ],
              [
                48.890585,
                37.4259648
              ],
              [
                48.8864187,
                37.4305511
              ],
              [
                48.8851031,
                37.4293324
              ],
              [
                48.880759,
                37.4250906
              ],
              [
                48.8697515,
                37.4219635
              ],
              [
                48.8689183,
                37.4216846
              ],
              [
                48.8389153,
                37.4094596
              ],
              [
                48.8178055,
                37.398071
              ],
              [
                48.8169722,
                37.398071
              ],
              [
                48.809192,
                37.3944636
              ],
              [
                48.8089154,
                37.3941847
              ],
              [
                48.8064153,
                37.3930692
              ],
              [
                48.8000253,
                37.3919627
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 13074061,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خمام",
          "ref:sci": "0117",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.553842,
                37.3882996
              ],
              [
                49.5542836,
                37.3877539
              ],
              [
                49.5547342,
                37.3869526
              ],
              [
                49.5557213,
                37.3862365
              ],
              [
                49.5565152,
                37.3848044
              ],
              [
                49.5592403,
                37.3827925
              ],
              [
                49.5605278,
                37.3818376
              ],
              [
                49.5629953,
                37.3807806
              ],
              [
                49.5642184,
                37.3780695
              ],
              [
                49.5661496,
                37.3753412
              ],
              [
                49.5673942,
                37.3722036
              ],
              [
                49.5683384,
                37.3683837
              ],
              [
                49.5691108,
                37.3653822
              ],
              [
                49.5688318,
                37.3633869
              ],
              [
                49.5686173,
                37.3623806
              ],
              [
                49.5687031,
                37.3604023
              ],
              [
                49.570055,
                37.35972
              ],
              [
                49.5712566,
                37.3594472
              ],
              [
                49.5779943,
                37.3548079
              ],
              [
                49.5836591,
                37.3525564
              ],
              [
                49.5863199,
                37.3504413
              ],
              [
                49.5913839,
                37.3485308
              ],
              [
                49.597907,
                37.347712
              ],
              [
                49.5990252,
                37.3477873
              ],
              [
                49.6111622,
                37.3509001
              ],
              [
                49.6237927,
                37.3499245
              ],
              [
                49.6279793,
                37.3494396
              ],
              [
                49.6323317,
                37.3490361
              ],
              [
                49.6369464,
                37.3488166
              ],
              [
                49.6397767,
                37.3484071
              ],
              [
                49.6442518,
                37.3483952
              ],
              [
                49.6440099,
                37.3474059
              ],
              [
                49.643147,
                37.3468882
              ],
              [
                49.6448041,
                37.3457623
              ],
              [
                49.6469688,
                37.3471551
              ],
              [
                49.6495155,
                37.3481104
              ],
              [
                49.6529431,
                37.3478655
              ],
              [
                49.654578,
                37.3476268
              ],
              [
                49.656589,
                37.3474161
              ],
              [
                49.6547615,
                37.3460173
              ],
              [
                49.65338,
                37.3440727
              ],
              [
                49.6528604,
                37.3417467
              ],
              [
                49.6533917,
                37.3383658
              ],
              [
                49.6553099,
                37.3365114
              ],
              [
                49.6590044,
                37.333065
              ],
              [
                49.6627987,
                37.3296126
              ],
              [
                49.6651701,
                37.3287253
              ],
              [
                49.668,
                37.3292655
              ],
              [
                49.6702021,
                37.3309716
              ],
              [
                49.6749215,
                37.3389502
              ],
              [
                49.6774896,
                37.3398032
              ],
              [
                49.6800823,
                37.3399055
              ],
              [
                49.684158,
                37.3388168
              ],
              [
                49.6840845,
                37.3369742
              ],
              [
                49.6860144,
                37.3332059
              ],
              [
                49.6876138,
                37.3301882
              ],
              [
                49.6902732,
                37.3245975
              ],
              [
                49.6918552,
                37.3256213
              ],
              [
                49.6928745,
                37.3267131
              ],
              [
                49.6946811,
                37.3296282
              ],
              [
                49.6987151,
                37.3329723
              ],
              [
                49.7057532,
                37.3342008
              ],
              [
                49.7128772,
                37.3340643
              ],
              [
                49.7191428,
                37.3348832
              ],
              [
                49.7235962,
                37.3361253
              ],
              [
                49.7221978,
                37.3422753
              ],
              [
                49.7239941,
                37.3446277
              ],
              [
                49.7287866,
                37.3447727
              ],
              [
                49.7290193,
                37.3515755
              ],
              [
                49.7315084,
                37.3564284
              ],
              [
                49.7334383,
                37.3563039
              ],
              [
                49.7303425,
                37.35907
              ],
              [
                49.7295153,
                37.3617145
              ],
              [
                49.7295152,
                37.3648025
              ],
              [
                49.7307801,
                37.366855
              ],
              [
                49.7313784,
                37.3695198
              ],
              [
                49.7311209,
                37.372539
              ],
              [
                49.731929,
                37.378937
              ],
              [
                49.7320283,
                37.3861381
              ],
              [
                49.7319008,
                37.3931994
              ],
              [
                49.7260395,
                37.3958649
              ],
              [
                49.7261922,
                37.4023486
              ],
              [
                49.715023,
                37.4075283
              ],
              [
                49.7126412,
                37.4124369
              ],
              [
                49.7129416,
                37.4130164
              ],
              [
                49.7124272,
                37.4143342
              ],
              [
                49.7062683,
                37.4180611
              ],
              [
                49.704426,
                37.4189958
              ],
              [
                49.7016604,
                37.4215924
              ],
              [
                49.7007751,
                37.4227986
              ],
              [
                49.7000455,
                37.4255933
              ],
              [
                49.7002601,
                37.4279449
              ],
              [
                49.7008609,
                37.4319321
              ],
              [
                49.7020625,
                37.43902
              ],
              [
                49.7023912,
                37.4435286
              ],
              [
                49.7019,
                37.4468461
              ],
              [
                49.698425,
                37.4480125
              ],
              [
                49.6992638,
                37.448753
              ],
              [
                49.6996324,
                37.449956
              ],
              [
                49.7003655,
                37.4523287
              ],
              [
                49.7008469,
                37.4540116
              ],
              [
                49.779823,
                37.6486822
              ],
              [
                49.7561108,
                37.6511624
              ],
              [
                49.7477207,
                37.6515986
              ],
              [
                49.7437422,
                37.6521011
              ],
              [
                49.735028,
                37.6529548
              ],
              [
                49.7134228,
                37.6547622
              ],
              [
                49.6910012,
                37.4550663
              ],
              [
                49.687611,
                37.4491715
              ],
              [
                49.6827672,
                37.4456219
              ],
              [
                49.6636962,
                37.4458176
              ],
              [
                49.6604106,
                37.4487689
              ],
              [
                49.6601907,
                37.450743
              ],
              [
                49.658238,
                37.4513052
              ],
              [
                49.6531538,
                37.4534259
              ],
              [
                49.6506949,
                37.4531789
              ],
              [
                49.6500522,
                37.4526977
              ],
              [
                49.6494859,
                37.4526614
              ],
              [
                49.6482199,
                37.4519204
              ],
              [
                49.6479034,
                37.4519843
              ],
              [
                49.64722,
                37.4518654
              ],
              [
                49.6471936,
                37.4509028
              ],
              [
                49.6488998,
                37.4492656
              ],
              [
                49.6530625,
                37.4455518
              ],
              [
                49.6442985,
                37.4452213
              ],
              [
                49.6434188,
                37.445511
              ],
              [
                49.6352648,
                37.4453918
              ],
              [
                49.6347762,
                37.4457903
              ],
              [
                49.6343226,
                37.4480049
              ],
              [
                49.6321163,
                37.4509071
              ],
              [
                49.6257647,
                37.4533941
              ],
              [
                49.6244008,
                37.4546546
              ],
              [
                49.6223028,
                37.4539794
              ],
              [
                49.6237189,
                37.4486646
              ],
              [
                49.6237882,
                37.444951
              ],
              [
                49.6216007,
                37.4431172
              ],
              [
                49.6195191,
                37.4396304
              ],
              [
                49.6196638,
                37.4393876
              ],
              [
                49.6153952,
                37.4370322
              ],
              [
                49.6080893,
                37.4431627
              ],
              [
                49.5963733,
                37.4426686
              ],
              [
                49.585941,
                37.4401507
              ],
              [
                49.582994,
                37.4391648
              ],
              [
                49.5797987,
                37.4382563
              ],
              [
                49.5770801,
                37.4375473
              ],
              [
                49.5768242,
                37.4380395
              ],
              [
                49.5709905,
                37.4372365
              ],
              [
                49.5712061,
                37.4359992
              ],
              [
                49.5685081,
                37.4354455
              ],
              [
                49.5652841,
                37.4344232
              ],
              [
                49.5614544,
                37.4318673
              ],
              [
                49.5587515,
                37.4290932
              ],
              [
                49.5529317,
                37.4279449
              ],
              [
                49.5526743,
                37.4274337
              ],
              [
                49.5543909,
                37.4236507
              ],
              [
                49.5581245,
                37.4237188
              ],
              [
                49.5587682,
                37.4214012
              ],
              [
                49.5602984,
                37.4180401
              ],
              [
                49.5654911,
                37.4145812
              ],
              [
                49.5666688,
                37.4138701
              ],
              [
                49.5690036,
                37.4122324
              ],
              [
                49.5699734,
                37.4104659
              ],
              [
                49.5704026,
                37.4089096
              ],
              [
                49.5702309,
                37.4070407
              ],
              [
                49.5682555,
                37.4030022
              ],
              [
                49.5661292,
                37.3993667
              ],
              [
                49.5649927,
                37.3968286
              ],
              [
                49.5613861,
                37.3936527
              ],
              [
                49.5563221,
                37.3910273
              ],
              [
                49.553842,
                37.3882996
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 30291253
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.4268249,
          36.8219055
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 729168184
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.3141954,
          37.2273234
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 842111727
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.4027782,
          37.1703562
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 729167674
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.3147378,
          37.301672
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 729167975
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.8716407,
          37.1521893
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32673769
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.1844452,
          37.0961905
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2623416275
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.0028774,
          37.2060727
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3965822956
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.9456642,
          37.2607374
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2421209184
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.1529566,
          37.1955948
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2421209186
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.2927862,
          37.1381592
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 842111819
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.1328792,
          37.3640801
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 303698717
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.1395774,
          37.5479126
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 27442136
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.4685904,
          37.4716356
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 303698653
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          48.904184,
          37.7974981
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3048675994
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          48.8715278,
          38.4193239
        ]
      }
    }
  ]
},
"لرستان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554878,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ازنا",
          "name:en": "Azna County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q666797",
          "wikipedia": "en:Azna County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.2622809,
                33.5463044
              ],
              [
                49.2622809,
                33.5460336
              ],
              [
                49.2614473,
                33.539362
              ],
              [
                49.2617243,
                33.5388113
              ],
              [
                49.2617243,
                33.5379717
              ],
              [
                49.2633907,
                33.5329793
              ],
              [
                49.2672807,
                33.5282576
              ],
              [
                49.268114,
                33.5251971
              ],
              [
                49.2681139,
                33.5243665
              ],
              [
                49.2681138,
                33.5240867
              ],
              [
                49.2681139,
                33.5229763
              ],
              [
                49.2667241,
                33.519365
              ],
              [
                49.2656143,
                33.5171442
              ],
              [
                49.2483909,
                33.4954769
              ],
              [
                49.2483909,
                33.4843634
              ],
              [
                49.2481143,
                33.4835327
              ],
              [
                49.2475577,
                33.4801923
              ],
              [
                49.2475578,
                33.4796416
              ],
              [
                49.2472811,
                33.4765811
              ],
              [
                49.244501,
                33.4685281
              ],
              [
                49.2425581,
                33.4663071
              ],
              [
                49.2417244,
                33.4660272
              ],
              [
                49.2325578,
                33.4615854
              ],
              [
                49.2297781,
                33.458254
              ],
              [
                49.2295016,
                33.4563039
              ],
              [
                49.2311681,
                33.452142
              ],
              [
                49.2295016,
                33.4432491
              ],
              [
                49.2278348,
                33.4396379
              ],
              [
                49.2275582,
                33.4388073
              ],
              [
                49.2264449,
                33.4354759
              ],
              [
                49.2258914,
                33.4226919
              ],
              [
                49.2333916,
                33.4013039
              ],
              [
                49.2339447,
                33.4007532
              ],
              [
                49.2453349,
                33.3799159
              ],
              [
                49.2458915,
                33.3790852
              ],
              [
                49.2536679,
                33.3651906
              ],
              [
                49.2706143,
                33.3490839
              ],
              [
                49.2708909,
                33.348804
              ],
              [
                49.2713094,
                33.3483887
              ],
              [
                49.271324,
                33.3483745
              ],
              [
                49.2713247,
                33.3483737
              ],
              [
                49.271448,
                33.3479734
              ],
              [
                49.2842276,
                33.3362996
              ],
              [
                49.2992275,
                33.3290859
              ],
              [
                49.3092273,
                33.3235244
              ],
              [
                49.3097839,
                33.3232445
              ],
              [
                49.3100606,
                33.3229737
              ],
              [
                49.3253405,
                33.3165815
              ],
              [
                49.3261737,
                33.3165815
              ],
              [
                49.3264504,
                33.3163017
              ],
              [
                49.327284,
                33.3163016
              ],
              [
                49.3275605,
                33.3163017
              ],
              [
                49.3281171,
                33.3160308
              ],
              [
                49.3372837,
                33.3138008
              ],
              [
                49.3467305,
                33.3118597
              ],
              [
                49.3492301,
                33.3107492
              ],
              [
                49.3500637,
                33.3107492
              ],
              [
                49.3506168,
                33.3104693
              ],
              [
                49.3697867,
                33.3015762
              ],
              [
                49.37062,
                33.3007455
              ],
              [
                49.37923,
                33.295193
              ],
              [
                49.3797865,
                33.295193
              ],
              [
                49.418123,
                33.2726939
              ],
              [
                49.4192328,
                33.2715834
              ],
              [
                49.4395125,
                33.2532463
              ],
              [
                49.4400656,
                33.2526865
              ],
              [
                49.4553456,
                33.2368593
              ],
              [
                49.4628454,
                33.2301871
              ],
              [
                49.4631224,
                33.230476
              ],
              [
                49.4647888,
                33.2326908
              ],
              [
                49.4650689,
                33.232968
              ],
              [
                49.4703455,
                33.2454727
              ],
              [
                49.4709022,
                33.2496348
              ],
              [
                49.4831254,
                33.2724141
              ],
              [
                49.483402,
                33.2729739
              ],
              [
                49.492015,
                33.284359
              ],
              [
                49.4997917,
                33.2918617
              ],
              [
                49.5109047,
                33.3221434
              ],
              [
                49.5114579,
                33.3235248
              ],
              [
                49.5120145,
                33.3260257
              ],
              [
                49.5122915,
                33.3282466
              ],
              [
                49.5147911,
                33.3357493
              ],
              [
                49.516738,
                33.3390899
              ],
              [
                49.5170146,
                33.3401913
              ],
              [
                49.5300711,
                33.3585281
              ],
              [
                49.5350712,
                33.3615887
              ],
              [
                49.5378478,
                33.3626902
              ],
              [
                49.5470175,
                33.3682517
              ],
              [
                49.547294,
                33.3688114
              ],
              [
                49.5486843,
                33.3704727
              ],
              [
                49.5603505,
                33.3882495
              ],
              [
                49.5628505,
                33.3996433
              ],
              [
                49.562574,
                33.400194
              ],
              [
                49.5545171,
                33.4074166
              ],
              [
                49.5534038,
                33.4079764
              ],
              [
                49.5470174,
                33.4138086
              ],
              [
                49.5442372,
                33.4182505
              ],
              [
                49.5442372,
                33.4265836
              ],
              [
                49.5445173,
                33.429915
              ],
              [
                49.5461841,
                33.4365869
              ],
              [
                49.549794,
                33.4421393
              ],
              [
                49.5511838,
                33.4438094
              ],
              [
                49.5550706,
                33.4474207
              ],
              [
                49.5670168,
                33.4526932
              ],
              [
                49.5675736,
                33.4529731
              ],
              [
                49.5728502,
                33.4529731
              ],
              [
                49.5734069,
                33.4526932
              ],
              [
                49.5750738,
                33.4526932
              ],
              [
                49.5806301,
                33.4515918
              ],
              [
                49.5809071,
                33.4513029
              ],
              [
                49.5845168,
                33.4513029
              ],
              [
                49.5847969,
                33.4515918
              ],
              [
                49.5906303,
                33.4515918
              ],
              [
                49.5920166,
                33.4521425
              ],
              [
                49.5931299,
                33.4521425
              ],
              [
                49.5936835,
                33.4524224
              ],
              [
                49.5939542,
                33.4524224
              ],
              [
                49.5959065,
                33.4532531
              ],
              [
                49.5967402,
                33.4532531
              ],
              [
                49.6000734,
                33.4560337
              ],
              [
                49.6003535,
                33.4568643
              ],
              [
                49.6000734,
                33.4596449
              ],
              [
                49.6003535,
                33.465757
              ],
              [
                49.6000734,
                33.4663077
              ],
              [
                49.5997964,
                33.4696391
              ],
              [
                49.5989632,
                33.4735302
              ],
              [
                49.5995199,
                33.4782519
              ],
              [
                49.5997964,
                33.4785318
              ],
              [
                49.60063,
                33.4804818
              ],
              [
                49.6197963,
                33.5018693
              ],
              [
                49.6242429,
                33.5068619
              ],
              [
                49.5994525,
                33.504763
              ],
              [
                49.6053203,
                33.5088142
              ],
              [
                49.6109409,
                33.5125649
              ],
              [
                49.6154795,
                33.5160548
              ],
              [
                49.6186911,
                33.5185861
              ],
              [
                49.6207307,
                33.5210575
              ],
              [
                49.6239438,
                33.5267817
              ],
              [
                49.6268337,
                33.5309613
              ],
              [
                49.6298984,
                33.5346691
              ],
              [
                49.6327885,
                33.5383986
              ],
              [
                49.634342,
                33.5417141
              ],
              [
                49.6353468,
                33.5471445
              ],
              [
                49.6370786,
                33.550796
              ],
              [
                49.6387705,
                33.5530071
              ],
              [
                49.6410702,
                33.557213
              ],
              [
                49.6463394,
                33.5613774
              ],
              [
                49.6504728,
                33.5643109
              ],
              [
                49.6565418,
                33.5693423
              ],
              [
                49.66077,
                33.5723398
              ],
              [
                49.6521349,
                33.5780657
              ],
              [
                49.6477749,
                33.5805157
              ],
              [
                49.6438292,
                33.582516
              ],
              [
                49.639795,
                33.58851
              ],
              [
                49.6382045,
                33.5928158
              ],
              [
                49.6352862,
                33.5975344
              ],
              [
                49.6322786,
                33.6039398
              ],
              [
                49.6297073,
                33.6116887
              ],
              [
                49.6297931,
                33.6146908
              ],
              [
                49.6247632,
                33.618874
              ],
              [
                49.6195668,
                33.6229358
              ],
              [
                49.6114019,
                33.6257737
              ],
              [
                49.6016424,
                33.6287039
              ],
              [
                49.5941704,
                33.6328031
              ],
              [
                49.5843631,
                33.6383174
              ],
              [
                49.5857173,
                33.6510752
              ],
              [
                49.5923929,
                33.6628039
              ],
              [
                49.5946436,
                33.6667334
              ],
              [
                49.5973821,
                33.6714104
              ],
              [
                49.5988161,
                33.6745326
              ],
              [
                49.6008871,
                33.6776761
              ],
              [
                49.6030787,
                33.6820793
              ],
              [
                49.605387,
                33.6861336
              ],
              [
                49.6096837,
                33.693153
              ],
              [
                49.6115303,
                33.6981536
              ],
              [
                49.616661,
                33.7099184
              ],
              [
                49.6191643,
                33.7143319
              ],
              [
                49.6242675,
                33.7239378
              ],
              [
                49.6269425,
                33.72842
              ],
              [
                49.6310372,
                33.7349938
              ],
              [
                49.6332958,
                33.738745
              ],
              [
                49.6223717,
                33.7383793
              ],
              [
                49.6166452,
                33.7382163
              ],
              [
                49.6089219,
                33.7355858
              ],
              [
                49.6015974,
                33.7332881
              ],
              [
                49.5942597,
                33.7297507
              ],
              [
                49.5869701,
                33.7261318
              ],
              [
                49.5829994,
                33.7240374
              ],
              [
                49.5786994,
                33.7221563
              ],
              [
                49.5760542,
                33.7206424
              ],
              [
                49.5717086,
                33.7179856
              ],
              [
                49.5589089,
                33.7089036
              ],
              [
                49.5533609,
                33.7044918
              ],
              [
                49.5473006,
                33.7000738
              ],
              [
                49.54106,
                33.6956015
              ],
              [
                49.5367343,
                33.6927419
              ],
              [
                49.5302255,
                33.688034
              ],
              [
                49.5155096,
                33.6869605
              ],
              [
                49.5028581,
                33.6869519
              ],
              [
                49.4985151,
                33.6895672
              ],
              [
                49.4931508,
                33.692926
              ],
              [
                49.4885165,
                33.6957483
              ],
              [
                49.4863271,
                33.6954945
              ],
              [
                49.4845676,
                33.6974226
              ],
              [
                49.4823789,
                33.6996006
              ],
              [
                49.4810056,
                33.7009573
              ],
              [
                49.4788169,
                33.7021712
              ],
              [
                49.4758987,
                33.702671
              ],
              [
                49.4704485,
                33.7024211
              ],
              [
                49.46002,
                33.7022426
              ],
              [
                49.4558572,
                33.7014571
              ],
              [
                49.4495058,
                33.7011715
              ],
              [
                49.4456005,
                33.7007431
              ],
              [
                49.442811,
                33.7004217
              ],
              [
                49.4380045,
                33.700386
              ],
              [
                49.4350433,
                33.6998862
              ],
              [
                49.4283914,
                33.6982795
              ],
              [
                49.4219276,
                33.6966061
              ],
              [
                49.4220185,
                33.7007073
              ],
              [
                49.4223082,
                33.7035011
              ],
              [
                49.4229948,
                33.7045275
              ],
              [
                49.4227052,
                33.7047685
              ],
              [
                49.4195509,
                33.7100433
              ],
              [
                49.4158172,
                33.7168794
              ],
              [
                49.412384,
                33.7206275
              ],
              [
                49.4089428,
                33.7248783
              ],
              [
                49.3938925,
                33.7295897
              ],
              [
                49.3869267,
                33.7285375
              ],
              [
                49.3799384,
                33.7248107
              ],
              [
                49.3737363,
                33.7165953
              ],
              [
                49.3682047,
                33.7036664
              ],
              [
                49.3685922,
                33.7005188
              ],
              [
                49.3693726,
                33.6937849
              ],
              [
                49.3665489,
                33.6878415
              ],
              [
                49.3664883,
                33.6862105
              ],
              [
                49.3659554,
                33.6851749
              ],
              [
                49.3586724,
                33.6802036
              ],
              [
                49.3556192,
                33.6768725
              ],
              [
                49.3545059,
                33.6699212
              ],
              [
                49.3561726,
                33.6657595
              ],
              [
                49.3567294,
                33.6643693
              ],
              [
                49.3578392,
                33.661309
              ],
              [
                49.3561728,
                33.6571472
              ],
              [
                49.3514492,
                33.6529765
              ],
              [
                49.3467295,
                33.6515953
              ],
              [
                49.3464495,
                33.6513154
              ],
              [
                49.3445061,
                33.6513154
              ],
              [
                49.3439495,
                33.6510356
              ],
              [
                49.3378396,
                33.6510355
              ],
              [
                49.337283,
                33.6507557
              ],
              [
                49.3350629,
                33.6507556
              ],
              [
                49.3342297,
                33.6504758
              ],
              [
                49.3295062,
                33.6504758
              ],
              [
                49.3289495,
                33.6507557
              ],
              [
                49.3281164,
                33.6507556
              ],
              [
                49.3236729,
                33.6540868
              ],
              [
                49.3228397,
                33.6551972
              ],
              [
                49.3217263,
                33.6568673
              ],
              [
                49.3156165,
                33.6590881
              ],
              [
                49.3145032,
                33.6588173
              ],
              [
                49.3061697,
                33.6546466
              ],
              [
                49.3031166,
                33.653816
              ],
              [
                49.3028365,
                33.6535361
              ],
              [
                49.3020033,
                33.6535361
              ],
              [
                49.2970032,
                33.6504758
              ],
              [
                49.29645,
                33.6502049
              ],
              [
                49.2945036,
                33.6424232
              ],
              [
                49.2947802,
                33.6421433
              ],
              [
                49.2953367,
                33.6402023
              ],
              [
                49.2989502,
                33.6365913
              ],
              [
                49.2886704,
                33.6121443
              ],
              [
                49.2881137,
                33.6088131
              ],
              [
                49.2878371,
                33.6079825
              ],
              [
                49.2875602,
                33.6077026
              ],
              [
                49.287366,
                33.6072273
              ],
              [
                49.293947,
                33.6043714
              ],
              [
                49.2947802,
                33.6038118
              ],
              [
                49.2986701,
                33.5993611
              ],
              [
                49.2986702,
                33.5974201
              ],
              [
                49.2983936,
                33.5971493
              ],
              [
                49.2950604,
                33.5879771
              ],
              [
                49.2945038,
                33.5876972
              ],
              [
                49.2945037,
                33.5871465
              ],
              [
                49.2828371,
                33.5685311
              ],
              [
                49.2795038,
                33.5643693
              ],
              [
                49.2792273,
                33.5640894
              ],
              [
                49.2650575,
                33.5504754
              ],
              [
                49.2622809,
                33.5463044
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554891,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان الیگودرز",
          "name:en": "Aligudarz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279488",
          "wikipedia": "en:Aligudarz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.8310749,
                32.9472019
              ],
              [
                48.8310509,
                32.9471316
              ],
              [
                48.8307723,
                32.9465789
              ],
              [
                48.8301163,
                32.9457965
              ],
              [
                48.8296203,
                32.9449199
              ],
              [
                48.829342,
                32.9442748
              ],
              [
                48.8292312,
                32.943858
              ],
              [
                48.8292276,
                32.9434432
              ],
              [
                48.8293343,
                32.943073
              ],
              [
                48.8295481,
                32.9426529
              ],
              [
                48.8298685,
                32.942424
              ],
              [
                48.8305703,
                32.9417261
              ],
              [
                48.8311616,
                32.9411231
              ],
              [
                48.8316995,
                32.9405666
              ],
              [
                48.8322944,
                32.9401012
              ],
              [
                48.8328896,
                32.9398681
              ],
              [
                48.8333741,
                32.9396826
              ],
              [
                48.8339157,
                32.9394958
              ],
              [
                48.8340509,
                32.9394025
              ],
              [
                48.8341866,
                32.9393089
              ],
              [
                48.8345108,
                32.9392131
              ],
              [
                48.8350524,
                32.9391639
              ],
              [
                48.8357049,
                32.9393465
              ],
              [
                48.8363609,
                32.9396216
              ],
              [
                48.8370706,
                32.9400826
              ],
              [
                48.8377228,
                32.9404478
              ],
              [
                48.8381615,
                32.9407237
              ],
              [
                48.8385965,
                32.9408146
              ],
              [
                48.8389778,
                32.9408122
              ],
              [
                48.8395158,
                32.9406231
              ],
              [
                48.8398932,
                32.9403456
              ],
              [
                48.8402175,
                32.9400671
              ],
              [
                48.8403778,
                32.939743
              ],
              [
                48.8405379,
                32.9393265
              ],
              [
                48.8405875,
                32.9388155
              ],
              [
                48.8406907,
                32.9383078
              ],
              [
                48.8405944,
                32.9378669
              ],
              [
                48.8405801,
                32.9378009
              ],
              [
                48.8405188,
                32.9372949
              ],
              [
                48.8402977,
                32.9368785
              ],
              [
                48.8400232,
                32.9364161
              ],
              [
                48.8394737,
                32.9357731
              ],
              [
                48.8388176,
                32.9350358
              ],
              [
                48.8384858,
                32.9344326
              ],
              [
                48.8383751,
                32.9341579
              ],
              [
                48.8383178,
                32.9337421
              ],
              [
                48.8383675,
                32.9331388
              ],
              [
                48.8386344,
                32.932679
              ],
              [
                48.8388481,
                32.9323535
              ],
              [
                48.8389017,
                32.9320749
              ],
              [
                48.8390618,
                32.9316606
              ],
              [
                48.839382,
                32.931382
              ],
              [
                48.8398132,
                32.930871
              ],
              [
                48.8403548,
                32.9305422
              ],
              [
                48.8407325,
                32.9302646
              ],
              [
                48.8411637,
                32.9301233
              ],
              [
                48.8414878,
                32.9299846
              ],
              [
                48.8420868,
                32.9299363
              ],
              [
                48.8425179,
                32.9299776
              ],
              [
                48.8425808,
                32.9300067
              ],
              [
                48.8431207,
                32.9302563
              ],
              [
                48.843609,
                32.9304857
              ],
              [
                48.8442076,
                32.9307147
              ],
              [
                48.8445358,
                32.9308511
              ],
              [
                48.8450776,
                32.9308469
              ],
              [
                48.8456765,
                32.9308437
              ],
              [
                48.8460008,
                32.9306554
              ],
              [
                48.8461569,
                32.9302411
              ],
              [
                48.8461532,
                32.9297337
              ],
              [
                48.8460425,
                32.9292268
              ],
              [
                48.8460352,
                32.9291872
              ],
              [
                48.8458708,
                32.9282995
              ],
              [
                48.8458633,
                32.9275622
              ],
              [
                48.8459701,
                32.9271425
              ],
              [
                48.8460731,
                32.9266821
              ],
              [
                48.8462332,
                32.9262655
              ],
              [
                48.8465042,
                32.9260334
              ],
              [
                48.8467713,
                32.9258915
              ],
              [
                48.8474769,
                32.9255227
              ],
              [
                48.8482322,
                32.9252403
              ],
              [
                48.8486794,
                32.9250271
              ],
              [
                48.8487204,
                32.9250075
              ],
              [
                48.8491517,
                32.9247737
              ],
              [
                48.849312,
                32.9245871
              ],
              [
                48.8495253,
                32.9242639
              ],
              [
                48.8496324,
                32.9239388
              ],
              [
                48.8496817,
                32.9234324
              ],
              [
                48.8496862,
                32.9234168
              ],
              [
                48.8497886,
                32.9230623
              ],
              [
                48.8497313,
                32.9227366
              ],
              [
                48.849617,
                32.9223221
              ],
              [
                48.8492888,
                32.9219963
              ],
              [
                48.8486861,
                32.9211225
              ],
              [
                48.8483542,
                32.9206163
              ],
              [
                48.848301,
                32.9204282
              ],
              [
                48.848297,
                32.9202456
              ],
              [
                48.8482971,
                32.9199683
              ],
              [
                48.8482322,
                32.9188129
              ],
              [
                48.8482819,
                32.9185364
              ],
              [
                48.8484421,
                32.9181176
              ],
              [
                48.8486024,
                32.9178881
              ],
              [
                48.8488198,
                32.9176552
              ],
              [
                48.8488693,
                32.9173765
              ],
              [
                48.8491363,
                32.916867
              ],
              [
                48.8495139,
                32.9164497
              ],
              [
                48.8500519,
                32.9160306
              ],
              [
                48.8503727,
                32.9159263
              ],
              [
                48.8504867,
                32.9158893
              ],
              [
                48.8509749,
                32.9158436
              ],
              [
                48.8517304,
                32.9156063
              ],
              [
                48.8521614,
                32.9151921
              ],
              [
                48.852539,
                32.9148176
              ],
              [
                48.8527526,
                32.9144944
              ],
              [
                48.8529129,
                32.9139854
              ],
              [
                48.8529727,
                32.9135383
              ],
              [
                48.8530119,
                32.9132454
              ],
              [
                48.8530083,
                32.9126885
              ],
              [
                48.8531648,
                32.9119945
              ],
              [
                48.8534315,
                32.9113926
              ],
              [
                48.8538629,
                32.9108387
              ],
              [
                48.8544006,
                32.9103745
              ],
              [
                48.8552094,
                32.9098631
              ],
              [
                48.8558578,
                32.9095338
              ],
              [
                48.856617,
                32.9093484
              ],
              [
                48.8577005,
                32.90911
              ],
              [
                48.8584299,
                32.9090526
              ],
              [
                48.8589477,
                32.9090119
              ],
              [
                48.8608473,
                32.9089136
              ],
              [
                48.8620949,
                32.9089079
              ],
              [
                48.8629609,
                32.90881
              ],
              [
                48.8635062,
                32.908763
              ],
              [
                48.864048,
                32.9087136
              ],
              [
                48.8645364,
                32.9085732
              ],
              [
                48.8649672,
                32.9083867
              ],
              [
                48.8652915,
                32.9081532
              ],
              [
                48.8656693,
                32.9079207
              ],
              [
                48.8659934,
                32.9075971
              ],
              [
                48.8662604,
                32.9073176
              ],
              [
                48.8668022,
                32.9072231
              ],
              [
                48.8674011,
                32.9072694
              ],
              [
                48.8677827,
                32.9074067
              ],
              [
                48.8685454,
                32.9077263
              ],
              [
                48.8697432,
                32.9083216
              ],
              [
                48.8701782,
                32.9084598
              ],
              [
                48.8711053,
                32.908683
              ],
              [
                48.8716468,
                32.9086832
              ],
              [
                48.8721352,
                32.9085878
              ],
              [
                48.8725129,
                32.9084004
              ],
              [
                48.872673,
                32.9080762
              ],
              [
                48.8727225,
                32.9077524
              ],
              [
                48.8727226,
                32.9074278
              ],
              [
                48.8727189,
                32.9071053
              ],
              [
                48.8725509,
                32.9066425
              ],
              [
                48.8723833,
                32.9062767
              ],
              [
                48.872326,
                32.905906
              ],
              [
                48.8722152,
                32.9053991
              ],
              [
                48.8723184,
                32.9048417
              ],
              [
                48.8726386,
                32.9043309
              ],
              [
                48.8729592,
                32.9037773
              ],
              [
                48.8733369,
                32.90345
              ],
              [
                48.8739852,
                32.9032176
              ],
              [
                48.874958,
                32.9027967
              ],
              [
                48.8756104,
                32.9026568
              ],
              [
                48.8768042,
                32.90265
              ],
              [
                48.8777277,
                32.9026454
              ],
              [
                48.8786467,
                32.9025032
              ],
              [
                48.8793527,
                32.9023168
              ],
              [
                48.8803787,
                32.9018517
              ],
              [
                48.8814584,
                32.9012455
              ],
              [
                48.8820533,
                32.9010121
              ],
              [
                48.8825951,
                32.9007305
              ],
              [
                48.8830262,
                32.900359
              ],
              [
                48.8833466,
                32.9000353
              ],
              [
                48.8835105,
                32.8998036
              ],
              [
                48.8836708,
                32.8995245
              ],
              [
                48.8837205,
                32.8989212
              ],
              [
                48.8836594,
                32.8984602
              ],
              [
                48.8835489,
                32.8980908
              ],
              [
                48.883385,
                32.897953
              ],
              [
                48.8833848,
                32.8979528
              ],
              [
                48.8830568,
                32.8975865
              ],
              [
                48.882618,
                32.8972161
              ],
              [
                48.8820725,
                32.8968958
              ],
              [
                48.8819084,
                32.8966179
              ],
              [
                48.8817406,
                32.8962025
              ],
              [
                48.8816835,
                32.8956943
              ],
              [
                48.8816795,
                32.895232
              ],
              [
                48.8817292,
                32.8947707
              ],
              [
                48.8818321,
                32.8944478
              ],
              [
                48.881939,
                32.8941678
              ],
              [
                48.8821565,
                32.8939821
              ],
              [
                48.8825342,
                32.8938893
              ],
              [
                48.8832399,
                32.8937953
              ],
              [
                48.8837813,
                32.8937008
              ],
              [
                48.8845938,
                32.8935094
              ],
              [
                48.8854065,
                32.8934126
              ],
              [
                48.8857842,
                32.893277
              ],
              [
                48.8863258,
                32.8930855
              ],
              [
                48.8866396,
                32.8929874
              ],
              [
                48.8869208,
                32.8928994
              ],
              [
                48.8872986,
                32.8925744
              ],
              [
                48.887947,
                32.8921097
              ],
              [
                48.8884851,
                32.8915055
              ],
              [
                48.8889693,
                32.8910876
              ],
              [
                48.8893,
                32.8907304
              ],
              [
                48.8893968,
                32.8906259
              ],
              [
                48.8900986,
                32.8901598
              ],
              [
                48.8912314,
                32.889462
              ],
              [
                48.8923151,
                32.8888084
              ],
              [
                48.893284,
                32.8882476
              ],
              [
                48.8943137,
                32.8877825
              ],
              [
                48.8957178,
                32.8870396
              ],
              [
                48.8960954,
                32.886807
              ],
              [
                48.8964157,
                32.8864787
              ],
              [
                48.8970107,
                32.8861077
              ],
              [
                48.8980369,
                32.8856898
              ],
              [
                48.8989602,
                32.8853604
              ],
              [
                48.8994981,
                32.8851282
              ],
              [
                48.8998756,
                32.8849407
              ],
              [
                48.9001466,
                32.8848911
              ],
              [
                48.9004747,
                32.8848448
              ],
              [
                48.9006385,
                32.8849828
              ],
              [
                48.9009095,
                32.8850753
              ],
              [
                48.9015617,
                32.8851651
              ],
              [
                48.9021073,
                32.8854403
              ],
              [
                48.9021136,
                32.8854446
              ],
              [
                48.9027061,
                32.8858539
              ],
              [
                48.9034158,
                32.88631
              ],
              [
                48.9037978,
                32.8860204
              ],
              [
                48.9050066,
                32.886696
              ],
              [
                48.9062979,
                32.8870113
              ],
              [
                48.9074345,
                32.8872711
              ],
              [
                48.9084323,
                32.8873212
              ],
              [
                48.9092138,
                32.8871442
              ],
              [
                48.9098605,
                32.8868235
              ],
              [
                48.9104226,
                32.88618
              ],
              [
                48.9111427,
                32.8859125
              ],
              [
                48.9118416,
                32.8856589
              ],
              [
                48.912365,
                32.8854903
              ],
              [
                48.91285,
                32.885314
              ],
              [
                48.9133704,
                32.8851298
              ],
              [
                48.913933,
                32.8851643
              ],
              [
                48.9142887,
                32.8853111
              ],
              [
                48.9158238,
                32.8864134
              ],
              [
                48.9166728,
                32.8872015
              ],
              [
                48.9173241,
                32.8878253
              ],
              [
                48.9184442,
                32.8888278
              ],
              [
                48.9190962,
                32.8890716
              ],
              [
                48.9196081,
                32.889379
              ],
              [
                48.92066,
                32.889651
              ],
              [
                48.9217318,
                32.8900871
              ],
              [
                48.9224554,
                32.8909413
              ],
              [
                48.9229989,
                32.8920576
              ],
              [
                48.9236119,
                32.8928987
              ],
              [
                48.924318,
                32.8938144
              ],
              [
                48.9248394,
                32.8945836
              ],
              [
                48.9253914,
                32.8953696
              ],
              [
                48.9256943,
                32.8962231
              ],
              [
                48.9258221,
                32.8969771
              ],
              [
                48.9259578,
                32.8973634
              ],
              [
                48.9266875,
                32.8974549
              ],
              [
                48.9273769,
                32.8973934
              ],
              [
                48.9279404,
                32.8973039
              ],
              [
                48.9286326,
                32.897098
              ],
              [
                48.9296511,
                32.896754
              ],
              [
                48.930464,
                32.8964691
              ],
              [
                48.9317133,
                32.8961375
              ],
              [
                48.9322987,
                32.895801
              ],
              [
                48.9327228,
                32.8954973
              ],
              [
                48.933495,
                32.8951319
              ],
              [
                48.9340791,
                32.8949579
              ],
              [
                48.9346994,
                32.8951421
              ],
              [
                48.9350484,
                32.8957949
              ],
              [
                48.9352907,
                32.896405
              ],
              [
                48.9356049,
                32.8970048
              ],
              [
                48.9359048,
                32.897532
              ],
              [
                48.9365662,
                32.8977851
              ],
              [
                48.9372455,
                32.8976971
              ],
              [
                48.9379344,
                32.8976102
              ],
              [
                48.9389514,
                32.8976503
              ],
              [
                48.9399465,
                32.8976454
              ],
              [
                48.9409318,
                32.8976906
              ],
              [
                48.9421483,
                32.8980449
              ],
              [
                48.9428747,
                32.8980117
              ],
              [
                48.9433844,
                32.8979521
              ],
              [
                48.9439869,
                32.8978808
              ],
              [
                48.9445691,
                32.8975598
              ],
              [
                48.9448573,
                32.8970623
              ],
              [
                48.9452623,
                32.8961189
              ],
              [
                48.945519,
                32.8957407
              ],
              [
                48.9458426,
                32.895264
              ],
              [
                48.9462585,
                32.8949625
              ],
              [
                48.9470357,
                32.8948738
              ],
              [
                48.9477526,
                32.8949317
              ],
              [
                48.9481622,
                32.8949095
              ],
              [
                48.9488323,
                32.8948033
              ],
              [
                48.9495884,
                32.8947777
              ],
              [
                48.9501643,
                32.8944258
              ],
              [
                48.9506413,
                32.8938859
              ],
              [
                48.9509538,
                32.893425
              ],
              [
                48.9514281,
                32.8930684
              ],
              [
                48.9521096,
                32.8927271
              ],
              [
                48.9526053,
                32.8925958
              ],
              [
                48.9530369,
                32.8924726
              ],
              [
                48.953536,
                32.8923488
              ],
              [
                48.9540458,
                32.8924041
              ],
              [
                48.9547279,
                32.8922238
              ],
              [
                48.9554858,
                32.8927051
              ],
              [
                48.9560164,
                32.8932571
              ],
              [
                48.9565657,
                32.8936719
              ],
              [
                48.9569465,
                32.8940734
              ],
              [
                48.9570044,
                32.8941345
              ],
              [
                48.9576035,
                32.894638
              ],
              [
                48.9580423,
                32.8950081
              ],
              [
                48.9584236,
                32.8951902
              ],
              [
                48.9588586,
                32.8953732
              ],
              [
                48.9596216,
                32.8956945
              ],
              [
                48.9601136,
                32.8960159
              ],
              [
                48.9603348,
                32.896245
              ],
              [
                48.9607696,
                32.8964279
              ],
              [
                48.9612578,
                32.8965644
              ],
              [
                48.9617461,
                32.8966107
              ],
              [
                48.9623986,
                32.896698
              ],
              [
                48.9628333,
                32.8968358
              ],
              [
                48.963272,
                32.897109
              ],
              [
                48.9637643,
                32.89748
              ],
              [
                48.9642526,
                32.8975714
              ],
              [
                48.9647981,
                32.8977043
              ],
              [
                48.9655038,
                32.8977969
              ],
              [
                48.9663163,
                32.8977921
              ],
              [
                48.9667511,
                32.8977428
              ],
              [
                48.9672927,
                32.8976479
              ],
              [
                48.9678346,
                32.8976477
              ],
              [
                48.9681624,
                32.8977861
              ],
              [
                48.9685441,
                32.8980132
              ],
              [
                48.9688185,
                32.8984303
              ],
              [
                48.9688759,
                32.8987536
              ],
              [
                48.9688836,
                32.8994436
              ],
              [
                48.9688874,
                32.8998157
              ],
              [
                48.9691084,
                32.9002769
              ],
              [
                48.9694901,
                32.900459
              ],
              [
                48.9701425,
                32.9005057
              ],
              [
                48.971119,
                32.9005463
              ],
              [
                48.9719352,
                32.9005438
              ],
              [
                48.9728011,
                32.90063
              ],
              [
                48.9734,
                32.9007682
              ],
              [
                48.9742698,
                32.9009469
              ],
              [
                48.9742936,
                32.9009437
              ],
              [
                48.9749755,
                32.9008524
              ],
              [
                48.9757882,
                32.9006198
              ],
              [
                48.9763833,
                32.9006159
              ],
              [
                48.976986,
                32.9009368
              ],
              [
                48.9774208,
                32.9011648
              ],
              [
                48.9778594,
                32.9014424
              ],
              [
                48.9781305,
                32.9017173
              ],
              [
                48.978405,
                32.9020893
              ],
              [
                48.9785194,
                32.9026412
              ],
              [
                48.9785805,
                32.9032442
              ],
              [
                48.978548,
                32.903547
              ],
              [
                48.9785309,
                32.9037056
              ],
              [
                48.9784812,
                32.9043045
              ],
              [
                48.9782714,
                32.9049526
              ],
              [
                48.9781646,
                32.9054176
              ],
              [
                48.9781684,
                32.9056927
              ],
              [
                48.978279,
                32.9059267
              ],
              [
                48.9785003,
                32.9061558
              ],
              [
                48.9788246,
                32.9063369
              ],
              [
                48.9791528,
                32.9065203
              ],
              [
                48.9794809,
                32.9065662
              ],
              [
                48.9799155,
                32.9066115
              ],
              [
                48.9806746,
                32.906608
              ],
              [
                48.9812736,
                32.9066966
              ],
              [
                48.9822501,
                32.9068341
              ],
              [
                48.9826849,
                32.9069719
              ],
              [
                48.9830667,
                32.9071088
              ],
              [
                48.9835051,
                32.9074293
              ],
              [
                48.9838869,
                32.9078908
              ],
              [
                48.9840547,
                32.9081641
              ],
              [
                48.9841118,
                32.9085799
              ],
              [
                48.9841157,
                32.908997
              ],
              [
                48.9841195,
                32.9095089
              ],
              [
                48.9840697,
                32.9098778
              ],
              [
                48.9839631,
                32.910203
              ],
              [
                48.9837495,
                32.9106189
              ],
              [
                48.9836463,
                32.9108968
              ],
              [
                48.9835398,
                32.9112197
              ],
              [
                48.9835435,
                32.9115399
              ],
              [
                48.9836006,
                32.9118204
              ],
              [
                48.9837113,
                32.9120522
              ],
              [
                48.983986,
                32.9123722
              ],
              [
                48.9843674,
                32.9126016
              ],
              [
                48.9845846,
                32.9128351
              ],
              [
                48.9850731,
                32.9129218
              ],
              [
                48.9855652,
                32.9129681
              ],
              [
                48.9861604,
                32.9129642
              ],
              [
                48.986431,
                32.9129189
              ],
              [
                48.9869194,
                32.9128231
              ],
              [
                48.9875146,
                32.9126365
              ],
              [
                48.9881096,
                32.9124026
              ],
              [
                48.9884339,
                32.9121711
              ],
              [
                48.9890251,
                32.9117974
              ],
              [
                48.9894026,
                32.9114269
              ],
              [
                48.9896203,
                32.9112861
              ],
              [
                48.9898337,
                32.9110979
              ],
              [
                48.9901581,
                32.9110535
              ],
              [
                48.9905397,
                32.911098
              ],
              [
                48.9910851,
                32.9113277
              ],
              [
                48.9920122,
                32.9119671
              ],
              [
                48.9928323,
                32.9125665
              ],
              [
                48.9934882,
                32.9129332
              ],
              [
                48.9935767,
                32.9119628
              ],
              [
                48.9938003,
                32.9122802
              ],
              [
                48.9942167,
                32.9126556
              ],
              [
                48.9948882,
                32.9127856
              ],
              [
                48.9956257,
                32.9126932
              ],
              [
                48.9971083,
                32.9121711
              ],
              [
                48.9988196,
                32.9120676
              ],
              [
                49.0005791,
                32.9123828
              ],
              [
                49.0021237,
                32.9129934
              ],
              [
                49.0034524,
                32.9138847
              ],
              [
                49.0045269,
                32.9144738
              ],
              [
                49.0063003,
                32.9151821
              ],
              [
                49.0080594,
                32.9148737
              ],
              [
                49.0085389,
                32.9146367
              ],
              [
                49.009278,
                32.9140496
              ],
              [
                49.0093005,
                32.9131483
              ],
              [
                49.0089463,
                32.9123462
              ],
              [
                49.0082096,
                32.911829
              ],
              [
                49.0078093,
                32.9114754
              ],
              [
                49.0067972,
                32.9109612
              ],
              [
                49.0060777,
                32.9102298
              ],
              [
                49.0052678,
                32.9094995
              ],
              [
                49.0046932,
                32.9086448
              ],
              [
                49.0045852,
                32.9082745
              ],
              [
                49.0043156,
                32.907493
              ],
              [
                49.0046672,
                32.90663
              ],
              [
                49.0055757,
                32.9060345
              ],
              [
                49.0064843,
                32.9056441
              ],
              [
                49.0073588,
                32.9051483
              ],
              [
                49.0084071,
                32.9046388
              ],
              [
                49.0092057,
                32.9042565
              ],
              [
                49.0099401,
                32.9036536
              ],
              [
                49.0103606,
                32.903213
              ],
              [
                49.0111636,
                32.9026628
              ],
              [
                49.0116669,
                32.9023
              ],
              [
                49.0119983,
                32.9018629
              ],
              [
                49.0120107,
                32.9010313
              ],
              [
                49.012134,
                32.9004414
              ],
              [
                49.0121241,
                32.8998486
              ],
              [
                49.0123785,
                32.8992193
              ],
              [
                49.0129846,
                32.8987095
              ],
              [
                49.0135984,
                32.8981726
              ],
              [
                49.0143367,
                32.8977427
              ],
              [
                49.0149645,
                32.8976369
              ],
              [
                49.015971,
                32.8983364
              ],
              [
                49.0164975,
                32.8988382
              ],
              [
                49.0171318,
                32.8993413
              ],
              [
                49.0176813,
                32.8996161
              ],
              [
                49.0182837,
                32.9001645
              ],
              [
                49.0190505,
                32.9007155
              ],
              [
                49.0200348,
                32.9013556
              ],
              [
                49.0209083,
                32.9018091
              ],
              [
                49.0223314,
                32.9023096
              ],
              [
                49.0234755,
                32.9027628
              ],
              [
                49.0247306,
                32.9031253
              ],
              [
                49.0258217,
                32.9033049
              ],
              [
                49.026638,
                32.9033471
              ],
              [
                49.0275118,
                32.9033384
              ],
              [
                49.0281065,
                32.9031989
              ],
              [
                49.0293005,
                32.9027759
              ],
              [
                49.0304946,
                32.9023055
              ],
              [
                49.0317422,
                32.9014661
              ],
              [
                49.0332605,
                32.9006265
              ],
              [
                49.0342904,
                32.8999754
              ],
              [
                49.0355339,
                32.8992757
              ],
              [
                49.0362931,
                32.8989021
              ],
              [
                49.0371094,
                32.898712
              ],
              [
                49.0379792,
                32.8984303
              ],
              [
                49.038685,
                32.8981934
              ],
              [
                49.0398828,
                32.8981851
              ],
              [
                49.041191,
                32.8984108
              ],
              [
                49.0429917,
                32.8987704
              ],
              [
                49.0443535,
                32.8991277
              ],
              [
                49.045233,
                32.8994584
              ],
              [
                49.0454482,
                32.8995393
              ],
              [
                49.0463753,
                32.8999033
              ],
              [
                49.0476341,
                32.900676
              ],
              [
                49.0488357,
                32.9014095
              ],
              [
                49.049713,
                32.9020499
              ],
              [
                49.0499902,
                32.902344
              ],
              [
                49.050537,
                32.9029241
              ],
              [
                49.0516358,
                32.9040685
              ],
              [
                49.0521279,
                32.9043422
              ],
              [
                49.0527841,
                32.9047537
              ],
              [
                49.0531656,
                32.9049378
              ],
              [
                49.0538215,
                32.9050247
              ],
              [
                49.0544206,
                32.9051129
              ],
              [
                49.0549659,
                32.9051552
              ],
              [
                49.0553438,
                32.9051092
              ],
              [
                49.0559426,
                32.9047353
              ],
              [
                49.0564803,
                32.9042251
              ],
              [
                49.0570755,
                32.9038037
              ],
              [
                49.0577277,
                32.9033855
              ],
              [
                49.0588684,
                32.9030109
              ],
              [
                49.0602798,
                32.9027262
              ],
              [
                49.0616952,
                32.9025317
              ],
              [
                49.0634347,
                32.9023354
              ],
              [
                49.0646896,
                32.9023752
              ],
              [
                49.0658303,
                32.9021381
              ],
              [
                49.0667535,
                32.9019021
              ],
              [
                49.0672417,
                32.9016188
              ],
              [
                49.0677262,
                32.9010626
              ],
              [
                49.0680503,
                32.9005085
              ],
              [
                49.0683135,
                32.8994912
              ],
              [
                49.0684522,
                32.8987119
              ],
              [
                49.0684699,
                32.8986121
              ],
              [
                49.0687903,
                32.8979181
              ],
              [
                49.0691799,
                32.897382
              ],
              [
                49.0693282,
                32.8971779
              ],
              [
                49.0701982,
                32.8966187
              ],
              [
                49.0709572,
                32.8963846
              ],
              [
                49.0717201,
                32.896331
              ],
              [
                49.0728607,
                32.8963238
              ],
              [
                49.0739518,
                32.8965503
              ],
              [
                49.0749893,
                32.8967737
              ],
              [
                49.0764657,
                32.897412
              ],
              [
                49.0782128,
                32.89814
              ],
              [
                49.078594,
                32.8983691
              ],
              [
                49.0790291,
                32.8983645
              ],
              [
                49.08012,
                32.8983565
              ],
              [
                49.0804978,
                32.897988
              ],
              [
                49.0809822,
                32.8975671
              ],
              [
                49.0822296,
                32.8967317
              ],
              [
                49.0832595,
                32.8960305
              ],
              [
                49.0840719,
                32.8955199
              ],
              [
                49.0847207,
                32.8950992
              ],
              [
                49.0851516,
                32.8945422
              ],
              [
                49.0859071,
                32.8934783
              ],
              [
                49.0865554,
                32.8926427
              ],
              [
                49.0868225,
                32.892135
              ],
              [
                49.0870362,
                32.8915792
              ],
              [
                49.0871927,
                32.890842
              ],
              [
                49.0874632,
                32.8903321
              ],
              [
                49.0880547,
                32.8894506
              ],
              [
                49.0887567,
                32.8886181
              ],
              [
                49.0894584,
                32.8879209
              ],
              [
                49.0901604,
                32.8873184
              ],
              [
                49.0908662,
                32.8868512
              ],
              [
                49.0915146,
                32.8864778
              ],
              [
                49.0925447,
                32.8858712
              ],
              [
                49.0935784,
                32.8855443
              ],
              [
                49.0950469,
                32.8852127
              ],
              [
                49.09684,
                32.8849717
              ],
              [
                49.0984191,
                32.8848695
              ],
              [
                49.0999451,
                32.8849062
              ],
              [
                49.1009788,
                32.8850369
              ],
              [
                49.1023445,
                32.8852605
              ],
              [
                49.1038704,
                32.8857572
              ],
              [
                49.1058921,
                32.8866243
              ],
              [
                49.1074218,
                32.8873982
              ],
              [
                49.1086806,
                32.8880351
              ],
              [
                49.1098825,
                32.8884433
              ],
              [
                49.1108094,
                32.8887594
              ],
              [
                49.1116255,
                32.8888484
              ],
              [
                49.1125527,
                32.8889346
              ],
              [
                49.1134225,
                32.8888846
              ],
              [
                49.1141321,
                32.8887397
              ],
              [
                49.114891,
                32.888458
              ],
              [
                49.1157569,
                32.887948
              ],
              [
                49.1172217,
                32.887199
              ],
              [
                49.11874,
                32.8864508
              ],
              [
                49.1202623,
                32.885892
              ],
              [
                49.1211815,
                32.8851933
              ],
              [
                49.1225356,
                32.8842622
              ],
              [
                49.1236724,
                32.8832399
              ],
              [
                49.1245383,
                32.8823127
              ],
              [
                49.1250229,
                32.8815737
              ],
              [
                49.1255608,
                32.8806912
              ],
              [
                49.1257486,
                32.8801527
              ],
              [
                49.1259309,
                32.8796303
              ],
              [
                49.1261979,
                32.8787031
              ],
              [
                49.1264077,
                32.8775068
              ],
              [
                49.1265641,
                32.8769026
              ],
              [
                49.1270484,
                32.8760261
              ],
              [
                49.1278037,
                32.8750994
              ],
              [
                49.1283988,
                32.8743553
              ],
              [
                49.1293718,
                32.8734748
              ],
              [
                49.1304017,
                32.8727304
              ],
              [
                49.1317023,
                32.8718953
              ],
              [
                49.1332781,
                32.8711928
              ],
              [
                49.1350668,
                32.8705364
              ],
              [
                49.1370774,
                32.8698313
              ],
              [
                49.1393089,
                32.8694948
              ],
              [
                49.1414299,
                32.8692061
              ],
              [
                49.1425723,
                32.8690717
              ],
              [
                49.1430627,
                32.869014
              ],
              [
                49.1453476,
                32.8690005
              ],
              [
                49.1472015,
                32.8688972
              ],
              [
                49.1491622,
                32.8689759
              ],
              [
                49.1508521,
                32.8691519
              ],
              [
                49.1522674,
                32.869236
              ],
              [
                49.1531399,
                32.8693448
              ],
              [
                49.1536827,
                32.8694125
              ],
              [
                49.1542854,
                32.8695003
              ],
              [
                49.1549949,
                32.8699572
              ],
              [
                49.156086,
                32.8704557
              ],
              [
                49.15707,
                32.8708693
              ],
              [
                49.1585997,
                32.8713653
              ],
              [
                49.1596908,
                32.8716362
              ],
              [
                49.1608888,
                32.8718612
              ],
              [
                49.1614379,
                32.8720857
              ],
              [
                49.1618195,
                32.8725468
              ],
              [
                49.1624793,
                32.8732802
              ],
              [
                49.1629754,
                32.8738737
              ],
              [
                49.1631431,
                32.8746157
              ],
              [
                49.1630468,
                32.8748122
              ],
              [
                49.1628722,
                32.8751687
              ],
              [
                49.1624449,
                32.8760462
              ],
              [
                49.1622314,
                32.8768299
              ],
              [
                49.1620751,
                32.8775243
              ],
              [
                49.1619681,
                32.8778046
              ],
              [
                49.1620787,
                32.8784488
              ],
              [
                49.1624108,
                32.8787693
              ],
              [
                49.1630095,
                32.8791321
              ],
              [
                49.1636124,
                32.8794521
              ],
              [
                49.164486,
                32.8797693
              ],
              [
                49.1652489,
                32.8800894
              ],
              [
                49.1662332,
                32.8802233
              ],
              [
                49.1669961,
                32.8804465
              ],
              [
                49.167431,
                32.8806264
              ],
              [
                49.1679268,
                32.8810892
              ],
              [
                49.1684228,
                32.8818675
              ],
              [
                49.1689187,
                32.8828308
              ],
              [
                49.1695213,
                32.8834303
              ],
              [
                49.1699028,
                32.8836546
              ],
              [
                49.1706694,
                32.883977
              ],
              [
                49.171215,
                32.8839714
              ],
              [
                49.1719742,
                32.8839216
              ],
              [
                49.1725733,
                32.8836395
              ],
              [
                49.1732751,
                32.883129
              ],
              [
                49.174141,
                32.8822939
              ],
              [
                49.1751709,
                32.8812763
              ],
              [
                49.176033,
                32.8803486
              ],
              [
                49.1768457,
                32.8797427
              ],
              [
                49.1780394,
                32.8788605
              ],
              [
                49.1791765,
                32.8780203
              ],
              [
                49.1804771,
                32.8772321
              ],
              [
                49.181343,
                32.8764871
              ],
              [
                49.1825369,
                32.8757897
              ],
              [
                49.1838914,
                32.8749504
              ],
              [
                49.1853028,
                32.8741614
              ],
              [
                49.1870919,
                32.8729518
              ],
              [
                49.1888238,
                32.8717887
              ],
              [
                49.190235,
                32.8709952
              ],
              [
                49.1918107,
                32.8701544
              ],
              [
                49.1932717,
                32.869321
              ],
              [
                49.1947367,
                32.8683885
              ],
              [
                49.1959839,
                32.867322
              ],
              [
                49.1966896,
                32.867039
              ],
              [
                49.1976129,
                32.8666645
              ],
              [
                49.1983146,
                32.8661989
              ],
              [
                49.1989631,
                32.8654597
              ],
              [
                49.1996118,
                32.8646235
              ],
              [
                49.2000427,
                32.864021
              ],
              [
                49.2002749,
                32.8637652
              ],
              [
                49.2017232,
                32.8632389
              ],
              [
                49.2024522,
                32.8630096
              ],
              [
                49.2027054,
                32.8630401
              ],
              [
                49.2027628,
                32.8634062
              ],
              [
                49.2028199,
                32.8638693
              ],
              [
                49.2030945,
                32.8643264
              ],
              [
                49.2033692,
                32.8646505
              ],
              [
                49.2037544,
                32.8649221
              ],
              [
                49.2042998,
                32.8649683
              ],
              [
                49.205059,
                32.8645485
              ],
              [
                49.2062493,
                32.8636637
              ],
              [
                49.2072791,
                32.8628736
              ],
              [
                49.2085228,
                32.8618542
              ],
              [
                49.2100412,
                32.86069
              ],
              [
                49.2113382,
                32.8593941
              ],
              [
                49.2123145,
                32.8584678
              ],
              [
                49.2130698,
                32.8575858
              ],
              [
                49.2137224,
                32.8571667
              ],
              [
                49.2140999,
                32.8567054
              ],
              [
                49.2144737,
                32.8559644
              ],
              [
                49.2149581,
                32.8546726
              ],
              [
                49.215168,
                32.8539766
              ],
              [
                49.2154923,
                32.853607
              ],
              [
                49.2161445,
                32.8530053
              ],
              [
                49.217121,
                32.8524938
              ],
              [
                49.2179907,
                32.8521658
              ],
              [
                49.2188074,
                32.8520196
              ],
              [
                49.2193488,
                32.8519258
              ],
              [
                49.2198409,
                32.8520163
              ],
              [
                49.2204399,
                32.8523337
              ],
              [
                49.2210999,
                32.8527917
              ],
              [
                49.2215348,
                32.8530662
              ],
              [
                49.2222444,
                32.8531981
              ],
              [
                49.2230605,
                32.8531961
              ],
              [
                49.2237665,
                32.8530078
              ],
              [
                49.2248572,
                32.8528632
              ],
              [
                49.2257844,
                32.8530883
              ],
              [
                49.2264403,
                32.853314
              ],
              [
                49.2274744,
                32.8534008
              ],
              [
                49.2288359,
                32.8535757
              ],
              [
                49.2298737,
                32.8538474
              ],
              [
                49.2307472,
                32.8539815
              ],
              [
                49.231781,
                32.8542983
              ],
              [
                49.2324408,
                32.8547563
              ],
              [
                49.2336958,
                32.8556218
              ],
              [
                49.2348479,
                32.856815
              ],
              [
                49.2357789,
                32.8574572
              ],
              [
                49.2364351,
                32.8579602
              ],
              [
                49.2368736,
                32.8580927
              ],
              [
                49.2372016,
                32.8581401
              ],
              [
                49.2377435,
                32.8580891
              ],
              [
                49.2395323,
                32.8569261
              ],
              [
                49.2405662,
                32.8564153
              ],
              [
                49.2407578,
                32.8563194
              ],
              [
                49.2415962,
                32.8558999
              ],
              [
                49.2424089,
                32.8553432
              ],
              [
                49.2434425,
                32.8548278
              ],
              [
                49.2443123,
                32.8546416
              ],
              [
                49.2455634,
                32.8543097
              ],
              [
                49.2461625,
                32.8543046
              ],
              [
                49.2467041,
                32.8543054
              ],
              [
                49.2473603,
                32.8544386
              ],
              [
                49.2477418,
                32.8546672
              ],
              [
                49.2478414,
                32.8549973
              ],
              [
                49.2478525,
                32.855034
              ],
              [
                49.2478027,
                32.8556781
              ],
              [
                49.2478599,
                32.8561862
              ],
              [
                49.2478103,
                32.8566027
              ],
              [
                49.2480851,
                32.8569222
              ],
              [
                49.2485771,
                32.8572425
              ],
              [
                49.2492332,
                32.8575132
              ],
              [
                49.2500496,
                32.8577884
              ],
              [
                49.2513275,
                32.8578762
              ],
              [
                49.2520867,
                32.8575937
              ],
              [
                49.2527848,
                32.8569902
              ],
              [
                49.2533262,
                32.8568963
              ],
              [
                49.2538108,
                32.8568963
              ],
              [
                49.2543293,
                32.8570265
              ],
              [
                49.2543527,
                32.8570323
              ],
              [
                49.2543595,
                32.8570382
              ],
              [
                49.2548371,
                32.8574495
              ],
              [
                49.2551612,
                32.8578643
              ],
              [
                49.2552185,
                32.8587445
              ],
              [
                49.2553291,
                32.8594405
              ],
              [
                49.2555465,
                32.860271
              ],
              [
                49.2558708,
                32.8609204
              ],
              [
                49.2565727,
                32.8615186
              ],
              [
                49.2570075,
                32.8618426
              ],
              [
                49.2576523,
                32.8618426
              ],
              [
                49.2584115,
                32.8617021
              ],
              [
                49.2587318,
                32.8613728
              ],
              [
                49.2594873,
                32.8607701
              ],
              [
                49.2603492,
                32.8599816
              ],
              [
                49.2612115,
                32.8593285
              ],
              [
                49.2618573,
                32.8591114
              ],
              [
                49.2624548,
                32.8589106
              ],
              [
                49.2641257,
                32.8586272
              ],
              [
                49.2652587,
                32.8581626
              ],
              [
                49.2656899,
                32.8578845
              ],
              [
                49.2661742,
                32.8572779
              ],
              [
                49.2667694,
                32.8567203
              ],
              [
                49.2673074,
                32.8561167
              ],
              [
                49.2674674,
                32.8555146
              ],
              [
                49.2678415,
                32.8546337
              ],
              [
                49.268055,
                32.8540775
              ],
              [
                49.2684328,
                32.8533319
              ],
              [
                49.268753,
                32.8527298
              ],
              [
                49.2692413,
                32.8524502
              ],
              [
                49.2697257,
                32.8522653
              ],
              [
                49.2710188,
                32.8520284
              ],
              [
                49.2724227,
                32.8519328
              ],
              [
                49.2734452,
                32.8517913
              ],
              [
                49.2746886,
                32.8516055
              ],
              [
                49.2755508,
                32.8515543
              ],
              [
                49.276306,
                32.8515061
              ],
              [
                49.2770082,
                32.8515045
              ],
              [
                49.2774926,
                32.8517344
              ],
              [
                49.2777673,
                32.8521034
              ],
              [
                49.2780393,
                32.8523094
              ],
              [
                49.2781981,
                32.8524295
              ],
              [
                49.2783623,
                32.8526573
              ],
              [
                49.278633,
                32.8527489
              ],
              [
                49.2789001,
                32.8527481
              ],
              [
                49.2793311,
                32.8525624
              ],
              [
                49.2796556,
                32.8521001
              ],
              [
                49.2797277,
                32.8519744
              ],
              [
                49.2800291,
                32.8514491
              ],
              [
                49.2805671,
                32.850753
              ],
              [
                49.2818071,
                32.8501004
              ],
              [
                49.283043,
                32.8495402
              ],
              [
                49.2837981,
                32.8492168
              ],
              [
                49.2846605,
                32.8491204
              ],
              [
                49.2859039,
                32.8491172
              ],
              [
                49.2865487,
                32.8492545
              ],
              [
                49.2871645,
                32.8496655
              ],
              [
                49.2873076,
                32.849761
              ],
              [
                49.2882804,
                32.8505026
              ],
              [
                49.2891466,
                32.850918
              ],
              [
                49.2897415,
                32.8511471
              ],
              [
                49.2903366,
                32.8514213
              ],
              [
                49.291256,
                32.8514677
              ],
              [
                49.2924423,
                32.8514185
              ],
              [
                49.2934113,
                32.851089
              ],
              [
                49.2941664,
                32.8506235
              ],
              [
                49.2955095,
                32.8496926
              ],
              [
                49.2963716,
                32.8491362
              ],
              [
                49.2965911,
                32.8490722
              ],
              [
                49.2973403,
                32.848854
              ],
              [
                49.298416,
                32.8486679
              ],
              [
                49.2990112,
                32.8486219
              ],
              [
                49.2996596,
                32.8487096
              ],
              [
                49.2996655,
                32.8487117
              ],
              [
                49.3001976,
                32.8488951
              ],
              [
                49.3006325,
                32.8490791
              ],
              [
                49.3011169,
                32.8492616
              ],
              [
                49.3016586,
                32.8493072
              ],
              [
                49.3018104,
                32.8492679
              ],
              [
                49.3021965,
                32.849168
              ],
              [
                49.3025207,
                32.8488883
              ],
              [
                49.3028411,
                32.8484733
              ],
              [
                49.3034859,
                32.8479612
              ],
              [
                49.3042374,
                32.8476331
              ],
              [
                49.3051529,
                32.8472126
              ],
              [
                49.3063354,
                32.8466063
              ],
              [
                49.3073579,
                32.8459122
              ],
              [
                49.3083834,
                32.8454356
              ],
              [
                49.3087579,
                32.8452615
              ],
              [
                49.3098296,
                32.8444214
              ],
              [
                49.3105813,
                32.8437281
              ],
              [
                49.310791,
                32.843555
              ],
              [
                49.3120373,
                32.8425988
              ],
              [
                49.3123916,
                32.8423652
              ],
              [
                49.3125113,
                32.8422863
              ],
              [
                49.3134268,
                32.8417733
              ],
              [
                49.3145026,
                32.8412579
              ],
              [
                49.3154145,
                32.8409342
              ],
              [
                49.3162667,
                32.8407837
              ],
              [
                49.3177486,
                32.8401788
              ],
              [
                49.3179437,
                32.8399536
              ],
              [
                49.3181039,
                32.8395837
              ],
              [
                49.3184241,
                32.8393513
              ],
              [
                49.3187445,
                32.8391639
              ],
              [
                49.3190156,
                32.8391653
              ],
              [
                49.3195037,
                32.8392553
              ],
              [
                49.3199377,
                32.8393477
              ],
              [
                49.3239518,
                32.8393477
              ],
              [
                49.3256434,
                32.8397739
              ],
              [
                49.3258667,
                32.8397036
              ],
              [
                49.3262443,
                32.8397019
              ],
              [
                49.3266754,
                32.8396987
              ],
              [
                49.3269996,
                32.8398405
              ],
              [
                49.3276483,
                32.8400679
              ],
              [
                49.3280678,
                32.8403825
              ],
              [
                49.3280829,
                32.8403939
              ],
              [
                49.3287315,
                32.8406686
              ],
              [
                49.3293801,
                32.8408509
              ],
              [
                49.3300284,
                32.840943
              ],
              [
                49.3302419,
                32.8409244
              ],
              [
                49.3305665,
                32.8408961
              ],
              [
                49.3312682,
                32.8408468
              ],
              [
                49.3316992,
                32.840706
              ],
              [
                49.333313,
                32.8402856
              ],
              [
                49.335144,
                32.8399582
              ],
              [
                49.3363801,
                32.8396297
              ],
              [
                49.3371352,
                32.8395811
              ],
              [
                49.3376197,
                32.8395807
              ],
              [
                49.3382148,
                32.8397645
              ],
              [
                49.3385391,
                32.839992
              ],
              [
                49.3390845,
                32.8405044
              ],
              [
                49.3397369,
                32.8411489
              ],
              [
                49.3400916,
                32.8415562
              ],
              [
                49.3404998,
                32.8420248
              ],
              [
                49.3413162,
                32.8430435
              ],
              [
                49.3418044,
                32.8434153
              ],
              [
                49.3421288,
                32.8436428
              ],
              [
                49.3428879,
                32.8439685
              ],
              [
                49.3434297,
                32.8441042
              ],
              [
                49.3440247,
                32.8442428
              ],
              [
                49.3445626,
                32.8444258
              ],
              [
                49.3450508,
                32.8446533
              ],
              [
                49.3455391,
                32.845025
              ],
              [
                49.3464049,
                32.8452529
              ],
              [
                49.3471109,
                32.8454809
              ],
              [
                49.3471689,
                32.8454926
              ],
              [
                49.3480263,
                32.8456644
              ],
              [
                49.3490523,
                32.8457568
              ],
              [
                49.349594,
                32.8457527
              ],
              [
                49.3500785,
                32.8456622
              ],
              [
                49.3502923,
                32.8453831
              ],
              [
                49.350506,
                32.8451492
              ],
              [
                49.3507158,
                32.8448724
              ],
              [
                49.3510399,
                32.8446399
              ],
              [
                49.3514137,
                32.8444509
              ],
              [
                49.3519517,
                32.8442641
              ],
              [
                49.3526496,
                32.8439869
              ],
              [
                49.3535117,
                32.8438449
              ],
              [
                49.354805,
                32.8437966
              ],
              [
                49.3569105,
                32.8437927
              ],
              [
                49.3583108,
                32.8438336
              ],
              [
                49.3598214,
                32.8437339
              ],
              [
                49.3610078,
                32.843639
              ],
              [
                49.3615456,
                32.8436393
              ],
              [
                49.3625184,
                32.843776
              ],
              [
                49.3633841,
                32.8439587
              ],
              [
                49.3640862,
                32.8441437
              ],
              [
                49.3647346,
                32.8443258
              ],
              [
                49.3653722,
                32.8445071
              ],
              [
                49.365383,
                32.8445102
              ],
              [
                49.3660316,
                32.8446472
              ],
              [
                49.3664666,
                32.8446461
              ],
              [
                49.3671645,
                32.8445515
              ],
              [
                49.3675957,
                32.8443632
              ],
              [
                49.3682145,
                32.8440701
              ],
              [
                49.3692588,
                32.8435754
              ],
              [
                49.3697394,
                32.8432006
              ],
              [
                49.3711282,
                32.8421319
              ],
              [
                49.3727408,
                32.8409445
              ],
              [
                49.3728944,
                32.8408314
              ],
              [
                49.374981,
                32.8393906
              ],
              [
                49.3751946,
                32.8391566
              ],
              [
                49.3754615,
                32.8389279
              ],
              [
                49.375511,
                32.8386489
              ],
              [
                49.375468,
                32.8383206
              ],
              [
                49.3754501,
                32.8381836
              ],
              [
                49.3753928,
                32.8378605
              ],
              [
                49.3754427,
                32.8374891
              ],
              [
                49.3756561,
                32.8371198
              ],
              [
                49.3760261,
                32.8364707
              ],
              [
                49.3765563,
                32.8357741
              ],
              [
                49.3773003,
                32.8349382
              ],
              [
                49.3781547,
                32.8342886
              ],
              [
                49.3795966,
                32.8331303
              ],
              [
                49.3805047,
                32.8324318
              ],
              [
                49.3815726,
                32.8317331
              ],
              [
                49.3825913,
                32.8311758
              ],
              [
                49.3830185,
                32.8308477
              ],
              [
                49.3836593,
                32.8303418
              ],
              [
                49.3850976,
                32.8290414
              ],
              [
                49.3855783,
                32.8287116
              ],
              [
                49.3862228,
                32.8284787
              ],
              [
                49.3866182,
                32.8284349
              ],
              [
                49.3870811,
                32.8283837
              ],
              [
                49.3877793,
                32.8281515
              ],
              [
                49.3888511,
                32.8277324
              ],
              [
                49.3892118,
                32.8274854
              ],
              [
                49.3898658,
                32.8270374
              ],
              [
                49.3908807,
                32.8262929
              ],
              [
                49.3916206,
                32.8254117
              ],
              [
                49.3937529,
                32.8236015
              ],
              [
                49.3958818,
                32.8216062
              ],
              [
                49.3967323,
                32.8207693
              ],
              [
                49.3976364,
                32.8199804
              ],
              [
                49.3981132,
                32.8195604
              ],
              [
                49.3985976,
                32.8193749
              ],
              [
                49.3992386,
                32.8192366
              ],
              [
                49.3996696,
                32.8191406
              ],
              [
                49.4000474,
                32.8191409
              ],
              [
                49.400692,
                32.8192326
              ],
              [
                49.4011231,
                32.819184
              ],
              [
                49.4016038,
                32.8189038
              ],
              [
                49.4018671,
                32.8184426
              ],
              [
                49.4023934,
                32.8176985
              ],
              [
                49.4029236,
                32.8169093
              ],
              [
                49.4036635,
                32.8160755
              ],
              [
                49.4043006,
                32.815335
              ],
              [
                49.4054145,
                32.8143571
              ],
              [
                49.4063684,
                32.813199
              ],
              [
                49.4068412,
                32.8124587
              ],
              [
                49.4071579,
                32.8119013
              ],
              [
                49.4072569,
                32.8114403
              ],
              [
                49.4073562,
                32.8109275
              ],
              [
                49.4076196,
                32.8104167
              ],
              [
                49.4080964,
                32.8097689
              ],
              [
                49.4088898,
                32.8089785
              ],
              [
                49.4098433,
                32.8080053
              ],
              [
                49.4103165,
                32.8071703
              ],
              [
                49.4112167,
                32.8062437
              ],
              [
                49.4123306,
                32.8053131
              ],
              [
                49.4132347,
                32.8044316
              ],
              [
                49.4139213,
                32.803597
              ],
              [
                49.4143905,
                32.8028115
              ],
              [
                49.4146539,
                32.8022985
              ],
              [
                49.41502,
                32.8016042
              ],
              [
                49.4152259,
                32.80091
              ],
              [
                49.415432,
                32.8003535
              ],
              [
                49.4157411,
                32.7995186
              ],
              [
                49.4164735,
                32.7982674
              ],
              [
                49.4170456,
                32.7970165
              ],
              [
                49.4174689,
                32.7965551
              ],
              [
                49.417942,
                32.7959026
              ],
              [
                49.4181519,
                32.7954859
              ],
              [
                49.4182548,
                32.7952527
              ],
              [
                49.4183044,
                32.7947911
              ],
              [
                49.418293,
                32.7941889
              ],
              [
                49.4181824,
                32.7939147
              ],
              [
                49.4180678,
                32.7935457
              ],
              [
                49.4181671,
                32.7929878
              ],
              [
                49.4182129,
                32.7924765
              ],
              [
                49.4185258,
                32.7916913
              ],
              [
                49.4189986,
                32.7910884
              ],
              [
                49.4201087,
                32.7900201
              ],
              [
                49.4230656,
                32.7901943
              ],
              [
                49.4263378,
                32.7886019
              ],
              [
                49.4271499,
                32.7871361
              ],
              [
                49.4290062,
                32.7839756
              ],
              [
                49.430839,
                32.7807178
              ],
              [
                49.4354877,
                32.7737911
              ],
              [
                49.4354586,
                32.7693499
              ],
              [
                49.4366243,
                32.76428
              ],
              [
                49.4420354,
                32.7572068
              ],
              [
                49.4456033,
                32.751201
              ],
              [
                49.4525131,
                32.7457109
              ],
              [
                49.4649419,
                32.7404657
              ],
              [
                49.4699917,
                32.7349729
              ],
              [
                49.4731551,
                32.7278668
              ],
              [
                49.4767932,
                32.7274907
              ],
              [
                49.4799022,
                32.7294881
              ],
              [
                49.4863205,
                32.7224433
              ],
              [
                49.4878946,
                32.7207446
              ],
              [
                49.5004575,
                32.7160295
              ],
              [
                49.5008323,
                32.7160473
              ],
              [
                49.5037787,
                32.7161871
              ],
              [
                49.5124159,
                32.7199787
              ],
              [
                49.512915,
                32.7204423
              ],
              [
                49.520093,
                32.7156323
              ],
              [
                49.5194671,
                32.7137457
              ],
              [
                49.5157088,
                32.7109292
              ],
              [
                49.5117177,
                32.7062982
              ],
              [
                49.510678,
                32.7044025
              ],
              [
                49.5104825,
                32.7024073
              ],
              [
                49.5122602,
                32.7033102
              ],
              [
                49.5151662,
                32.7044723
              ],
              [
                49.5174089,
                32.7059375
              ],
              [
                49.5226861,
                32.7086458
              ],
              [
                49.5262813,
                32.7092751
              ],
              [
                49.5295337,
                32.7093867
              ],
              [
                49.5325127,
                32.7101449
              ],
              [
                49.5382877,
                32.7128012
              ],
              [
                49.5411515,
                32.7143664
              ],
              [
                49.5430611,
                32.7148688
              ],
              [
                49.5448794,
                32.7139754
              ],
              [
                49.5476429,
                32.7129462
              ],
              [
                49.5566968,
                32.7127023
              ],
              [
                49.5621585,
                32.713211
              ],
              [
                49.563686,
                32.7140384
              ],
              [
                49.5701837,
                32.7153413
              ],
              [
                49.5745853,
                32.7166108
              ],
              [
                49.5767623,
                32.7197521
              ],
              [
                49.5775574,
                32.7254294
              ],
              [
                49.5777898,
                32.7300056
              ],
              [
                49.5767125,
                32.7306281
              ],
              [
                49.5770546,
                32.7318828
              ],
              [
                49.5775028,
                32.7369457
              ],
              [
                49.578136,
                32.7386062
              ],
              [
                49.5772268,
                32.7441927
              ],
              [
                49.5775021,
                32.7499591
              ],
              [
                49.591018,
                32.7499952
              ],
              [
                49.5912517,
                32.7520796
              ],
              [
                49.5916118,
                32.7533789
              ],
              [
                49.5926978,
                32.754444
              ],
              [
                49.5946472,
                32.7557072
              ],
              [
                49.5948703,
                32.7571073
              ],
              [
                49.5943689,
                32.7585182
              ],
              [
                49.5944357,
                32.7592446
              ],
              [
                49.5948923,
                32.7602297
              ],
              [
                49.595527,
                32.7610452
              ],
              [
                49.5958249,
                32.7633387
              ],
              [
                49.5956929,
                32.7665284
              ],
              [
                49.5951327,
                32.7685225
              ],
              [
                49.5945307,
                32.7716487
              ],
              [
                49.5943946,
                32.7740623
              ],
              [
                49.5946893,
                32.7756977
              ],
              [
                49.5953096,
                32.7768058
              ],
              [
                49.5975292,
                32.7792963
              ],
              [
                49.5994357,
                32.7824354
              ],
              [
                49.5999494,
                32.7853852
              ],
              [
                49.6004846,
                32.7860347
              ],
              [
                49.600355,
                32.7899037
              ],
              [
                49.602298,
                32.7899037
              ],
              [
                49.6025746,
                32.7896238
              ],
              [
                49.6042415,
                32.7896238
              ],
              [
                49.6181311,
                32.7849015
              ],
              [
                49.6184675,
                32.7847885
              ],
              [
                49.6189644,
                32.7846216
              ],
              [
                49.6272977,
                32.7818496
              ],
              [
                49.6275779,
                32.7815697
              ],
              [
                49.6286876,
                32.7815697
              ],
              [
                49.6314643,
                32.780739
              ],
              [
                49.6325779,
                32.780739
              ],
              [
                49.6331311,
                32.7804591
              ],
              [
                49.6336877,
                32.7804591
              ],
              [
                49.6345209,
                32.7801792
              ],
              [
                49.6356311,
                32.7801792
              ],
              [
                49.6364679,
                32.7798993
              ],
              [
                49.6386878,
                32.7798993
              ],
              [
                49.6406344,
                32.7796285
              ],
              [
                49.6411875,
                32.7793485
              ],
              [
                49.6439676,
                32.7793485
              ],
              [
                49.6442442,
                32.7790686
              ],
              [
                49.6550777,
                32.7790687
              ],
              [
                49.6556343,
                32.7793485
              ],
              [
                49.6600773,
                32.7793485
              ],
              [
                49.6925803,
                32.789624
              ],
              [
                49.69369,
                32.7901838
              ],
              [
                49.6959135,
                32.7910145
              ],
              [
                49.7192463,
                32.8057323
              ],
              [
                49.7248032,
                32.8085133
              ],
              [
                49.7256363,
                32.8085133
              ],
              [
                49.7256364,
                32.8087933
              ],
              [
                49.7273032,
                32.8087932
              ],
              [
                49.7281364,
                32.8090731
              ],
              [
                49.7298032,
                32.8090731
              ],
              [
                49.7311931,
                32.8085133
              ],
              [
                49.7317497,
                32.8082425
              ],
              [
                49.7331365,
                32.8082425
              ],
              [
                49.7350831,
                32.809344
              ],
              [
                49.7352067,
                32.8098742
              ],
              [
                49.7359162,
                32.8115743
              ],
              [
                49.7359162,
                32.8118542
              ],
              [
                49.7370264,
                32.8143463
              ],
              [
                49.7439694,
                32.8210099
              ],
              [
                49.7453594,
                32.8251815
              ],
              [
                49.7453594,
                32.8257412
              ],
              [
                49.7453593,
                32.8299038
              ],
              [
                49.7442495,
                32.8329647
              ],
              [
                49.7439695,
                32.8332446
              ],
              [
                49.743693,
                32.8340753
              ],
              [
                49.7439695,
                32.8407389
              ],
              [
                49.7448026,
                32.8435199
              ],
              [
                49.7492492,
                32.8524048
              ],
              [
                49.7495262,
                32.8535154
              ],
              [
                49.7489726,
                32.8549058
              ],
              [
                49.7486925,
                32.8557365
              ],
              [
                49.7473027,
                32.8579577
              ],
              [
                49.7461929,
                32.8590773
              ],
              [
                49.740083,
                32.8646303
              ],
              [
                49.7323028,
                32.8749056
              ],
              [
                49.7295261,
                32.8760162
              ],
              [
                49.7284128,
                32.8760162
              ],
              [
                49.7217462,
                32.8796279
              ],
              [
                49.7203596,
                32.8796279
              ],
              [
                49.7200798,
                32.8799078
              ],
              [
                49.7195264,
                32.8799078
              ],
              [
                49.7189696,
                32.8804676
              ],
              [
                49.71397,
                32.8840702
              ],
              [
                49.7128598,
                32.8846301
              ],
              [
                49.7061896,
                32.8912936
              ],
              [
                49.7042467,
                32.8926841
              ],
              [
                49.70369,
                32.8926841
              ],
              [
                49.7036901,
                32.892964
              ],
              [
                49.7031365,
                32.892964
              ],
              [
                49.7028564,
                32.8932439
              ],
              [
                49.7000799,
                32.8937947
              ],
              [
                49.6881335,
                32.8968466
              ],
              [
                49.6881335,
                32.8971264
              ],
              [
                49.6867467,
                32.8971265
              ],
              [
                49.6823002,
                32.8990767
              ],
              [
                49.6814669,
                32.9001873
              ],
              [
                49.6809133,
                32.9007381
              ],
              [
                49.6809134,
                32.9015689
              ],
              [
                49.6803568,
                32.9024085
              ],
              [
                49.6809134,
                32.9085214
              ],
              [
                49.6785358,
                32.9127921
              ],
              [
                49.6781336,
                32.9135145
              ],
              [
                49.6775801,
                32.9137944
              ],
              [
                49.6761902,
                32.9162955
              ],
              [
                49.6714671,
                32.9210177
              ],
              [
                49.6706335,
                32.9210177
              ],
              [
                49.6673002,
                32.9232389
              ],
              [
                49.6667435,
                32.9240786
              ],
              [
                49.6659103,
                32.9254601
              ],
              [
                49.6650771,
                32.9279612
              ],
              [
                49.6642435,
                32.9293517
              ],
              [
                49.6636903,
                32.9293516
              ],
              [
                49.6634102,
                32.9296315
              ],
              [
                49.662577,
                32.9296316
              ],
              [
                49.662577,
                32.9299114
              ],
              [
                49.6614668,
                32.9299115
              ],
              [
                49.6589672,
                32.9326834
              ],
              [
                49.6586902,
                32.936575
              ],
              [
                49.6584106,
                32.9374057
              ],
              [
                49.6581336,
                32.9385162
              ],
              [
                49.6559105,
                32.9432385
              ],
              [
                49.6550773,
                32.9443491
              ],
              [
                49.6533512,
                32.9636742
              ],
              [
                49.6518802,
                32.965626
              ],
              [
                49.6498418,
                32.9672634
              ],
              [
                49.6498319,
                32.9688363
              ],
              [
                49.6500226,
                32.9700494
              ],
              [
                49.6498081,
                32.9717615
              ],
              [
                49.6500063,
                32.97382
              ],
              [
                49.6506785,
                32.9755246
              ],
              [
                49.6531235,
                32.9764083
              ],
              [
                49.6406339,
                32.9782445
              ],
              [
                49.6409105,
                32.9785153
              ],
              [
                49.6417437,
                32.9787952
              ],
              [
                49.6453539,
                32.9787952
              ],
              [
                49.6509102,
                32.9782444
              ],
              [
                49.6703568,
                32.9707413
              ],
              [
                49.6720236,
                32.9707413
              ],
              [
                49.6725767,
                32.9704614
              ],
              [
                49.6764667,
                32.9704614
              ],
              [
                49.6772999,
                32.9707413
              ],
              [
                49.6784136,
                32.9707413
              ],
              [
                49.6786902,
                32.9710212
              ],
              [
                49.6803566,
                32.9712921
              ],
              [
                49.6842464,
                32.9735222
              ],
              [
                49.6853567,
                32.9749037
              ],
              [
                49.6864665,
                32.9757435
              ],
              [
                49.6936896,
                32.9776847
              ],
              [
                49.6948033,
                32.9779646
              ],
              [
                49.6953565,
                32.9776847
              ],
              [
                49.6959131,
                32.9779646
              ],
              [
                49.6998031,
                32.9779646
              ],
              [
                49.7050797,
                32.9801858
              ],
              [
                49.7078563,
                32.982407
              ],
              [
                49.7078563,
                32.9832467
              ],
              [
                49.7075797,
                32.9835176
              ],
              [
                49.7075797,
                32.9837974
              ],
              [
                49.7075797,
                32.9843572
              ],
              [
                49.7075798,
                32.9846372
              ],
              [
                49.7064696,
                32.9874091
              ],
              [
                49.7059129,
                32.9885197
              ],
              [
                49.7059128,
                32.9887995
              ],
              [
                49.7048032,
                32.9901901
              ],
              [
                49.7009132,
                32.992962
              ],
              [
                49.7003565,
                32.9929619
              ],
              [
                49.699803,
                32.9935217
              ],
              [
                49.6992463,
                32.9935218
              ],
              [
                49.6989698,
                32.9938017
              ],
              [
                49.6920232,
                32.9938017
              ],
              [
                49.6917466,
                32.9935217
              ],
              [
                49.6861899,
                32.9935218
              ],
              [
                49.6834133,
                32.9940725
              ],
              [
                49.6706333,
                32.9987947
              ],
              [
                49.6645233,
                33.0018555
              ],
              [
                49.6550771,
                33.0074084
              ],
              [
                49.6536869,
                33.0101894
              ],
              [
                49.6539669,
                33.0104693
              ],
              [
                49.6539669,
                33.0115799
              ],
              [
                49.6556337,
                33.0140719
              ],
              [
                49.6678567,
                33.0221349
              ],
              [
                49.6686902,
                33.0274078
              ],
              [
                49.6659101,
                33.037132
              ],
              [
                49.6656335,
                33.040193
              ],
              [
                49.66591,
                33.0432448
              ],
              [
                49.6689667,
                33.0501881
              ],
              [
                49.6717433,
                33.0512987
              ],
              [
                49.6797998,
                33.0568515
              ],
              [
                49.685633,
                33.0663048
              ],
              [
                49.6909129,
                33.0699075
              ],
              [
                49.6956364,
                33.0712979
              ],
              [
                49.6964695,
                33.0712979
              ],
              [
                49.6967461,
                33.0715778
              ],
              [
                49.698413,
                33.0715778
              ],
              [
                49.6989696,
                33.0718578
              ],
              [
                49.7011895,
                33.0718577
              ],
              [
                49.7017462,
                33.0715778
              ],
              [
                49.7036896,
                33.0715778
              ],
              [
                49.7125794,
                33.0751895
              ],
              [
                49.7178594,
                33.0815819
              ],
              [
                49.7188335,
                33.0822699
              ],
              [
                49.722026,
                33.0843538
              ],
              [
                49.724246,
                33.0843539
              ],
              [
                49.7248024,
                33.0840739
              ],
              [
                49.7261924,
                33.0835232
              ],
              [
                49.7281358,
                33.0826925
              ],
              [
                49.7373024,
                33.073799
              ],
              [
                49.7425822,
                33.0721377
              ],
              [
                49.7445256,
                33.0715779
              ],
              [
                49.7456354,
                33.0715779
              ],
              [
                49.7548055,
                33.0679663
              ],
              [
                49.7620255,
                33.0660251
              ],
              [
                49.7661921,
                33.0643547
              ],
              [
                49.7795286,
                33.0618537
              ],
              [
                49.7803619,
                33.0618537
              ],
              [
                49.7809149,
                33.0615738
              ],
              [
                49.7828619,
                33.0615738
              ],
              [
                49.7856386,
                33.0610231
              ],
              [
                49.8098081,
                33.0565808
              ],
              [
                49.8345314,
                33.0501883
              ],
              [
                49.8364743,
                33.0501884
              ],
              [
                49.837308,
                33.0499084
              ],
              [
                49.8389743,
                33.0499084
              ],
              [
                49.8398075,
                33.0501883
              ],
              [
                49.8411979,
                33.0501884
              ],
              [
                49.8489742,
                33.0535201
              ],
              [
                49.8498075,
                33.0535201
              ],
              [
                49.8542543,
                33.0571317
              ],
              [
                49.8564743,
                33.0624137
              ],
              [
                49.8570309,
                33.0629645
              ],
              [
                49.858974,
                33.0657453
              ],
              [
                49.8598076,
                33.0668559
              ],
              [
                49.8636975,
                33.0690771
              ],
              [
                49.8648108,
                33.069077
              ],
              [
                49.8653639,
                33.069357
              ],
              [
                49.8689773,
                33.0693569
              ],
              [
                49.8698105,
                33.069077
              ],
              [
                49.8714773,
                33.069077
              ],
              [
                49.8925872,
                33.0624137
              ],
              [
                49.8928672,
                33.0621339
              ],
              [
                49.8948102,
                33.0621338
              ],
              [
                49.8956439,
                33.0618538
              ],
              [
                49.8967536,
                33.0618539
              ],
              [
                49.8975868,
                33.0621338
              ],
              [
                49.8989771,
                33.0621339
              ],
              [
                49.9000869,
                33.0624138
              ],
              [
                49.9014767,
                33.0624138
              ],
              [
                49.9037002,
                33.0629645
              ],
              [
                49.90481,
                33.0629645
              ],
              [
                49.9053667,
                33.0632444
              ],
              [
                49.9070335,
                33.0632444
              ],
              [
                49.9084234,
                33.0638042
              ],
              [
                49.9095336,
                33.0638042
              ],
              [
                49.9103668,
                33.064075
              ],
              [
                49.9142567,
                33.0657455
              ],
              [
                49.9148102,
                33.0657454
              ],
              [
                49.9214799,
                33.0721379
              ],
              [
                49.9220334,
                33.0732485
              ],
              [
                49.9242565,
                33.0896361
              ],
              [
                49.9239798,
                33.0901868
              ],
              [
                49.9231467,
                33.0915773
              ],
              [
                49.9228666,
                33.092417
              ],
              [
                49.9220333,
                33.0932386
              ],
              [
                49.9217568,
                33.0940783
              ],
              [
                49.9211998,
                33.0943582
              ],
              [
                49.9203665,
                33.0962994
              ],
              [
                49.9198134,
                33.0971302
              ],
              [
                49.9189801,
                33.0996311
              ],
              [
                49.9187001,
                33.1004708
              ],
              [
                49.8795304,
                33.1279729
              ],
              [
                49.878977,
                33.1282436
              ],
              [
                49.878977,
                33.1285236
              ],
              [
                49.8778636,
                33.1296341
              ],
              [
                49.8775871,
                33.1301939
              ],
              [
                49.8767539,
                33.1321351
              ],
              [
                49.8770304,
                33.1340855
              ],
              [
                49.8775871,
                33.134907
              ],
              [
                49.8803637,
                33.1379678
              ],
              [
                49.8884201,
                33.1396291
              ],
              [
                49.8887002,
                33.139909
              ],
              [
                49.8892537,
                33.139909
              ],
              [
                49.8898104,
                33.1407396
              ],
              [
                49.890367,
                33.1438005
              ],
              [
                49.8906435,
                33.1446311
              ],
              [
                49.890367,
                33.144911
              ],
              [
                49.8887001,
                33.1507527
              ],
              [
                49.88842,
                33.1518632
              ],
              [
                49.8823102,
                33.1685214
              ],
              [
                49.8809202,
                33.1718531
              ],
              [
                49.8725869,
                33.1826875
              ],
              [
                49.871197,
                33.1876895
              ],
              [
                49.8714771,
                33.191301
              ],
              [
                49.8770303,
                33.2029661
              ],
              [
                49.8773103,
                33.2040768
              ],
              [
                49.8875867,
                33.2179719
              ],
              [
                49.8895336,
                33.2196333
              ],
              [
                49.8948099,
                33.2210237
              ],
              [
                49.8989768,
                33.2218543
              ],
              [
                49.89981,
                33.2218543
              ],
              [
                49.9050898,
                33.2240844
              ],
              [
                49.9150896,
                33.2285265
              ],
              [
                49.9206464,
                33.2301878
              ],
              [
                49.9250898,
                33.2301878
              ],
              [
                49.9289797,
                33.229917
              ],
              [
                49.9298129,
                33.229637
              ],
              [
                49.9320329,
                33.2296371
              ],
              [
                49.9328661,
                33.2293571
              ],
              [
                49.9384228,
                33.2293572
              ],
              [
                49.9392561,
                33.2290774
              ],
              [
                49.9437027,
                33.2290773
              ],
              [
                49.9442561,
                33.2288065
              ],
              [
                49.9464793,
                33.229917
              ],
              [
                49.9470359,
                33.2299169
              ],
              [
                49.9473125,
                33.2326888
              ],
              [
                49.9462026,
                33.2343591
              ],
              [
                49.9423128,
                33.2371399
              ],
              [
                49.9417561,
                33.2376907
              ],
              [
                49.9400893,
                33.2388012
              ],
              [
                49.9395361,
                33.2390811
              ],
              [
                49.9389794,
                33.2390811
              ],
              [
                49.9389795,
                33.239361
              ],
              [
                49.9384228,
                33.239361
              ],
              [
                49.9361994,
                33.241582
              ],
              [
                49.9359227,
                33.2424127
              ],
              [
                49.9375892,
                33.2471437
              ],
              [
                49.9409228,
                33.2490849
              ],
              [
                49.9423127,
                33.2490849
              ],
              [
                49.9428693,
                33.248805
              ],
              [
                49.9450893,
                33.2488049
              ],
              [
                49.9464792,
                33.2499155
              ],
              [
                49.9473123,
                33.2574092
              ],
              [
                49.9570356,
                33.267413
              ],
              [
                49.9578692,
                33.2676929
              ],
              [
                49.958979,
                33.2685235
              ],
              [
                49.9595356,
                33.2688034
              ],
              [
                49.961479,
                33.269914
              ],
              [
                49.9620358,
                33.2704737
              ],
              [
                49.9673123,
                33.2782473
              ],
              [
                49.9678691,
                33.279078
              ],
              [
                49.9709257,
                33.2807483
              ],
              [
                49.9970387,
                33.3015772
              ],
              [
                49.9987051,
                33.3035274
              ],
              [
                50.0000919,
                33.3060283
              ],
              [
                50.0000919,
                33.3068589
              ],
              [
                50.000372,
                33.3074187
              ],
              [
                49.998425,
                33.3104703
              ],
              [
                49.9981485,
                33.31103
              ],
              [
                49.9967586,
                33.3129712
              ],
              [
                49.9959249,
                33.3146414
              ],
              [
                49.9956485,
                33.3154721
              ],
              [
                49.9953718,
                33.3163027
              ],
              [
                49.9959249,
                33.3232456
              ],
              [
                50.0059251,
                33.3440833
              ],
              [
                50.0070384,
                33.3488052
              ],
              [
                50.0125916,
                33.357969
              ],
              [
                50.0137049,
                33.3588088
              ],
              [
                50.0139815,
                33.3593595
              ],
              [
                50.0162049,
                33.3601901
              ],
              [
                50.0167617,
                33.36047
              ],
              [
                50.0184281,
                33.3601901
              ],
              [
                50.0195382,
                33.3615895
              ],
              [
                50.0198148,
                33.3640813
              ],
              [
                50.018148,
                33.3685323
              ],
              [
                50.0153713,
                33.3715839
              ],
              [
                50.0106482,
                33.3738049
              ],
              [
                50.0100916,
                33.3743646
              ],
              [
                50.0064817,
                33.375755
              ],
              [
                50.0034249,
                33.375755
              ],
              [
                50.0028714,
                33.3754751
              ],
              [
                50.0023148,
                33.3754751
              ],
              [
                49.998705,
                33.3751952
              ],
              [
                49.9975917,
                33.3749153
              ],
              [
                49.9959249,
                33.3749153
              ],
              [
                49.9903685,
                33.373534
              ],
              [
                49.9767584,
                33.3721436
              ],
              [
                49.9620355,
                33.3763057
              ],
              [
                49.9520357,
                33.3826978
              ],
              [
                49.951479,
                33.3829776
              ],
              [
                49.951479,
                33.3835283
              ],
              [
                49.9487024,
                33.3865799
              ],
              [
                49.9484224,
                33.3871397
              ],
              [
                49.9478688,
                33.3874196
              ],
              [
                49.9467555,
                33.3860292
              ],
              [
                49.9437023,
                33.3854785
              ],
              [
                49.9434222,
                33.3851986
              ],
              [
                49.9420359,
                33.3851985
              ],
              [
                49.9373123,
                33.3840881
              ],
              [
                49.9345325,
                33.3849186
              ],
              [
                49.927866,
                33.3921413
              ],
              [
                49.925366,
                33.3957526
              ],
              [
                49.9250894,
                33.3963124
              ],
              [
                49.9225894,
                33.399364
              ],
              [
                49.9203659,
                33.401305
              ],
              [
                49.9086996,
                33.4074172
              ],
              [
                49.9073094,
                33.4076971
              ],
              [
                49.9064762,
                33.4082478
              ],
              [
                49.8986994,
                33.4104687
              ],
              [
                49.8984193,
                33.4107486
              ],
              [
                49.8973094,
                33.4107486
              ],
              [
                49.8823096,
                33.4157503
              ],
              [
                49.8625865,
                33.4196414
              ],
              [
                49.8614732,
                33.4196414
              ],
              [
                49.8586966,
                33.420472
              ],
              [
                49.8578634,
                33.420472
              ],
              [
                49.8573067,
                33.4207518
              ],
              [
                49.8564735,
                33.4207518
              ],
              [
                49.85592,
                33.4210317
              ],
              [
                49.8548067,
                33.4210318
              ],
              [
                49.8528633,
                33.4215825
              ],
              [
                49.8520301,
                33.4215825
              ],
              [
                49.8489734,
                33.4229728
              ],
              [
                49.8481402,
                33.4229728
              ],
              [
                49.8409169,
                33.4260333
              ],
              [
                49.8392501,
                33.4268639
              ],
              [
                49.8353638,
                33.4276946
              ],
              [
                49.8067507,
                33.4379776
              ],
              [
                49.7964708,
                33.4465905
              ],
              [
                49.7956374,
                33.4479808
              ],
              [
                49.7942508,
                33.4510324
              ],
              [
                49.7942508,
                33.4513033
              ],
              [
                49.7920276,
                33.4607557
              ],
              [
                49.7923041,
                33.4693685
              ],
              [
                49.7925842,
                33.4738104
              ],
              [
                49.7920275,
                33.4752007
              ],
              [
                49.7917507,
                33.476582
              ],
              [
                49.791471,
                33.4774216
              ],
              [
                49.7895275,
                33.4840844
              ],
              [
                49.787304,
                33.4904763
              ],
              [
                49.7864708,
                33.4918666
              ],
              [
                49.7864708,
                33.4924173
              ],
              [
                49.7861943,
                33.4926971
              ],
              [
                49.7861942,
                33.492977
              ],
              [
                49.7856375,
                33.4935368
              ],
              [
                49.7856376,
                33.4938076
              ],
              [
                49.7770276,
                33.5093628
              ],
              [
                49.7745275,
                33.5129741
              ],
              [
                49.7736943,
                33.5138137
              ],
              [
                49.7709142,
                33.5176957
              ],
              [
                49.7623042,
                33.5263085
              ],
              [
                49.6969428,
                33.5733891
              ],
              [
                49.6883597,
                33.5735974
              ],
              [
                49.6831369,
                33.5712927
              ],
              [
                49.6742534,
                33.5702558
              ],
              [
                49.6673011,
                33.5708636
              ],
              [
                49.66077,
                33.5723398
              ],
              [
                49.6565418,
                33.5693423
              ],
              [
                49.6504728,
                33.5643109
              ],
              [
                49.6463394,
                33.5613774
              ],
              [
                49.6410702,
                33.557213
              ],
              [
                49.6387705,
                33.5530071
              ],
              [
                49.6370786,
                33.550796
              ],
              [
                49.6353468,
                33.5471445
              ],
              [
                49.634342,
                33.5417141
              ],
              [
                49.6327885,
                33.5383986
              ],
              [
                49.6298984,
                33.5346691
              ],
              [
                49.6268337,
                33.5309613
              ],
              [
                49.6239438,
                33.5267817
              ],
              [
                49.6207307,
                33.5210575
              ],
              [
                49.6186911,
                33.5185861
              ],
              [
                49.6154795,
                33.5160548
              ],
              [
                49.6109409,
                33.5125649
              ],
              [
                49.6053203,
                33.5088142
              ],
              [
                49.5994525,
                33.504763
              ],
              [
                49.6242429,
                33.5068619
              ],
              [
                49.6197963,
                33.5018693
              ],
              [
                49.60063,
                33.4804818
              ],
              [
                49.5997964,
                33.4785318
              ],
              [
                49.5995199,
                33.4782519
              ],
              [
                49.5989632,
                33.4735302
              ],
              [
                49.5997964,
                33.4696391
              ],
              [
                49.6000734,
                33.4663077
              ],
              [
                49.6003535,
                33.465757
              ],
              [
                49.6000734,
                33.4596449
              ],
              [
                49.6003535,
                33.4568643
              ],
              [
                49.6000734,
                33.4560337
              ],
              [
                49.5967402,
                33.4532531
              ],
              [
                49.5959065,
                33.4532531
              ],
              [
                49.5939542,
                33.4524224
              ],
              [
                49.5936835,
                33.4524224
              ],
              [
                49.5931299,
                33.4521425
              ],
              [
                49.5920166,
                33.4521425
              ],
              [
                49.5906303,
                33.4515918
              ],
              [
                49.5847969,
                33.4515918
              ],
              [
                49.5845168,
                33.4513029
              ],
              [
                49.5809071,
                33.4513029
              ],
              [
                49.5806301,
                33.4515918
              ],
              [
                49.5750738,
                33.4526932
              ],
              [
                49.5734069,
                33.4526932
              ],
              [
                49.5728502,
                33.4529731
              ],
              [
                49.5675736,
                33.4529731
              ],
              [
                49.5670168,
                33.4526932
              ],
              [
                49.5550706,
                33.4474207
              ],
              [
                49.5511838,
                33.4438094
              ],
              [
                49.549794,
                33.4421393
              ],
              [
                49.5461841,
                33.4365869
              ],
              [
                49.5445173,
                33.429915
              ],
              [
                49.5442372,
                33.4265836
              ],
              [
                49.5442372,
                33.4182505
              ],
              [
                49.5470174,
                33.4138086
              ],
              [
                49.5534038,
                33.4079764
              ],
              [
                49.5545171,
                33.4074166
              ],
              [
                49.562574,
                33.400194
              ],
              [
                49.5628505,
                33.3996433
              ],
              [
                49.5603505,
                33.3882495
              ],
              [
                49.5486843,
                33.3704727
              ],
              [
                49.547294,
                33.3688114
              ],
              [
                49.5470175,
                33.3682517
              ],
              [
                49.5378478,
                33.3626902
              ],
              [
                49.5350712,
                33.3615887
              ],
              [
                49.5300711,
                33.3585281
              ],
              [
                49.5170146,
                33.3401913
              ],
              [
                49.516738,
                33.3390899
              ],
              [
                49.5147911,
                33.3357493
              ],
              [
                49.5122915,
                33.3282466
              ],
              [
                49.5120145,
                33.3260257
              ],
              [
                49.5114579,
                33.3235248
              ],
              [
                49.5109047,
                33.3221434
              ],
              [
                49.4997917,
                33.2918617
              ],
              [
                49.492015,
                33.284359
              ],
              [
                49.483402,
                33.2729739
              ],
              [
                49.4831254,
                33.2724141
              ],
              [
                49.4709022,
                33.2496348
              ],
              [
                49.4703455,
                33.2454727
              ],
              [
                49.4650689,
                33.232968
              ],
              [
                49.4647888,
                33.2326908
              ],
              [
                49.4631224,
                33.230476
              ],
              [
                49.4628454,
                33.2301871
              ],
              [
                49.4553456,
                33.2368593
              ],
              [
                49.4400656,
                33.2526865
              ],
              [
                49.4395125,
                33.2532463
              ],
              [
                49.4192328,
                33.2715834
              ],
              [
                49.418123,
                33.2726939
              ],
              [
                49.3797865,
                33.295193
              ],
              [
                49.37923,
                33.295193
              ],
              [
                49.37062,
                33.3007455
              ],
              [
                49.3697867,
                33.3015762
              ],
              [
                49.3506168,
                33.3104693
              ],
              [
                49.3500637,
                33.3107492
              ],
              [
                49.3492301,
                33.3107492
              ],
              [
                49.3467305,
                33.3118597
              ],
              [
                49.3372837,
                33.3138008
              ],
              [
                49.3281171,
                33.3160308
              ],
              [
                49.3275605,
                33.3163017
              ],
              [
                49.327284,
                33.3163016
              ],
              [
                49.3270073,
                33.3160308
              ],
              [
                49.3270074,
                33.3157509
              ],
              [
                49.3258936,
                33.3135299
              ],
              [
                49.3150607,
                33.2999148
              ],
              [
                49.3070043,
                33.2935226
              ],
              [
                49.3003374,
                33.2899112
              ],
              [
                49.2983943,
                33.2893604
              ],
              [
                49.2975608,
                33.2893604
              ],
              [
                49.2972842,
                33.2890806
              ],
              [
                49.2933943,
                33.2890805
              ],
              [
                49.2925611,
                33.2893604
              ],
              [
                49.2908942,
                33.2893604
              ],
              [
                49.2906146,
                33.2896403
              ],
              [
                49.2892278,
                33.2896403
              ],
              [
                49.2808944,
                33.2924121
              ],
              [
                49.2650582,
                33.3032463
              ],
              [
                49.2425584,
                33.3176919
              ],
              [
                49.2283918,
                33.3199129
              ],
              [
                49.2270018,
                33.3201927
              ],
              [
                49.2189451,
                33.3201928
              ],
              [
                49.2178353,
                33.3204727
              ],
              [
                49.2117219,
                33.3204726
              ],
              [
                49.2078355,
                33.3207434
              ],
              [
                49.1922789,
                33.3224138
              ],
              [
                49.1911655,
                33.3226936
              ],
              [
                49.1817225,
                33.3226936
              ],
              [
                49.170889,
                33.3204726
              ],
              [
                49.169499,
                33.3199128
              ],
              [
                49.1678327,
                33.3199127
              ],
              [
                49.1658893,
                33.3193621
              ],
              [
                49.1633857,
                33.319362
              ],
              [
                49.1628327,
                33.3190821
              ],
              [
                49.1575528,
                33.3190821
              ],
              [
                49.1564427,
                33.3188023
              ],
              [
                49.1522762,
                33.3188022
              ],
              [
                49.142553,
                33.3179716
              ],
              [
                49.1414427,
                33.3176917
              ],
              [
                49.1383864,
                33.3176917
              ],
              [
                49.1375528,
                33.3174118
              ],
              [
                49.136163,
                33.3174118
              ],
              [
                49.1342195,
                33.3171409
              ],
              [
                49.1300532,
                33.3160304
              ],
              [
                49.1158867,
                33.3074172
              ],
              [
                49.1056069,
                33.2904706
              ],
              [
                49.0958837,
                33.2862994
              ],
              [
                49.0950501,
                33.2862994
              ],
              [
                49.0944969,
                33.2860285
              ],
              [
                49.0936637,
                33.2857486
              ],
              [
                49.0928301,
                33.2857487
              ],
              [
                49.0928302,
                33.2854687
              ],
              [
                49.0883835,
                33.2854688
              ],
              [
                49.0878269,
                33.2857486
              ],
              [
                49.0847737,
                33.2857487
              ],
              [
                49.0839405,
                33.2860285
              ],
              [
                49.0828271,
                33.2860285
              ],
              [
                49.0808838,
                33.2865792
              ],
              [
                49.0797736,
                33.2865793
              ],
              [
                49.0781072,
                33.2871391
              ],
              [
                49.0769938,
                33.287139
              ],
              [
                49.0497707,
                33.3004742
              ],
              [
                49.049494,
                33.300745
              ],
              [
                49.0483808,
                33.3013048
              ],
              [
                49.0453276,
                33.3038056
              ],
              [
                49.0444944,
                33.3046363
              ],
              [
                49.0422708,
                33.3068573
              ],
              [
                49.006158,
                33.3351887
              ],
              [
                48.9914346,
                33.3457519
              ],
              [
                48.9906014,
                33.3463027
              ],
              [
                48.9711549,
                33.3604682
              ],
              [
                48.9522651,
                33.3665804
              ],
              [
                48.952265,
                33.3668603
              ],
              [
                48.9505986,
                33.3668602
              ],
              [
                48.950322,
                33.3671402
              ],
              [
                48.9469888,
                33.3671402
              ],
              [
                48.9464321,
                33.36519
              ],
              [
                48.9469888,
                33.3649191
              ],
              [
                48.9469888,
                33.3646393
              ],
              [
                48.9436554,
                33.3635288
              ],
              [
                48.9425453,
                33.3635288
              ],
              [
                48.9386554,
                33.3624183
              ],
              [
                48.9372655,
                33.3624182
              ],
              [
                48.9367088,
                33.3621384
              ],
              [
                48.9358752,
                33.3621384
              ],
              [
                48.9355987,
                33.3618585
              ],
              [
                48.9308755,
                33.3610279
              ],
              [
                48.9297653,
                33.3604682
              ],
              [
                48.9289322,
                33.3604681
              ],
              [
                48.913099,
                33.3551955
              ],
              [
                48.910599,
                33.3535252
              ],
              [
                48.9078192,
                33.3507535
              ],
              [
                48.9072658,
                33.3499139
              ],
              [
                48.9036524,
                33.3438016
              ],
              [
                48.8950429,
                33.3387999
              ],
              [
                48.888653,
                33.3376893
              ],
              [
                48.8830962,
                33.3371386
              ],
              [
                48.8780965,
                33.3326965
              ],
              [
                48.8744863,
                33.3215825
              ],
              [
                48.8744863,
                33.3210228
              ],
              [
                48.8742062,
                33.3176911
              ],
              [
                48.8744863,
                33.3157501
              ],
              [
                48.8747628,
                33.3135291
              ],
              [
                48.8750398,
                33.3093579
              ],
              [
                48.8753199,
                33.3076876
              ],
              [
                48.8764297,
                33.3032456
              ],
              [
                48.8769863,
                33.302415
              ],
              [
                48.8794865,
                33.293251
              ],
              [
                48.8811529,
                33.2790762
              ],
              [
                48.879763,
                33.2668514
              ],
              [
                48.8797631,
                33.2629691
              ],
              [
                48.8860784,
                33.2422454
              ],
              [
                48.8891584,
                33.2221972
              ],
              [
                48.8868015,
                33.2179398
              ],
              [
                48.8859001,
                33.2163115
              ],
              [
                48.8781259,
                33.2022647
              ],
              [
                48.8781741,
                33.2014326
              ],
              [
                48.8711534,
                33.1788034
              ],
              [
                48.87143,
                33.1785236
              ],
              [
                48.8725401,
                33.1743522
              ],
              [
                48.8728203,
                33.1738016
              ],
              [
                48.8730967,
                33.1732417
              ],
              [
                48.8736535,
                33.1724111
              ],
              [
                48.8736534,
                33.1713005
              ],
              [
                48.87393,
                33.1699101
              ],
              [
                48.8742066,
                33.1696302
              ],
              [
                48.8797633,
                33.1590755
              ],
              [
                48.88004,
                33.1588046
              ],
              [
                48.88282,
                33.1474102
              ],
              [
                48.8830967,
                33.1465796
              ],
              [
                48.8828202,
                33.1260209
              ],
              [
                48.8830967,
                33.1254701
              ],
              [
                48.8830968,
                33.1218585
              ],
              [
                48.8833768,
                33.1215787
              ],
              [
                48.8830967,
                33.1212987
              ],
              [
                48.8828201,
                33.1201882
              ],
              [
                48.8825436,
                33.1196374
              ],
              [
                48.8822635,
                33.115746
              ],
              [
                48.8825437,
                33.1140756
              ],
              [
                48.8828202,
                33.1132449
              ],
              [
                48.8830968,
                33.1112948
              ],
              [
                48.8836534,
                33.1093535
              ],
              [
                48.8911536,
                33.087964
              ],
              [
                48.8917103,
                33.0874132
              ],
              [
                48.8955967,
                33.0785197
              ],
              [
                48.8958768,
                33.077689
              ],
              [
                48.8964299,
                33.0762986
              ],
              [
                48.8958769,
                33.0724071
              ],
              [
                48.8947635,
                33.0712965
              ],
              [
                48.89421,
                33.0707457
              ],
              [
                48.8872633,
                33.0668542
              ],
              [
                48.8864301,
                33.0668542
              ],
              [
                48.8853204,
                33.0663035
              ],
              [
                48.8844868,
                33.0663034
              ],
              [
                48.8800401,
                33.059631
              ],
              [
                48.876987,
                33.0582406
              ],
              [
                48.8725405,
                33.0582405
              ],
              [
                48.8719873,
                33.0585205
              ],
              [
                48.8692071,
                33.0585204
              ],
              [
                48.8689306,
                33.0582406
              ],
              [
                48.8644872,
                33.0568501
              ],
              [
                48.8633739,
                33.0560194
              ],
              [
                48.8597641,
                33.051857
              ],
              [
                48.859764,
                33.0510173
              ],
              [
                48.859764,
                33.0504666
              ],
              [
                48.8597641,
                33.0462951
              ],
              [
                48.8614305,
                33.0446338
              ],
              [
                48.8614305,
                33.0443539
              ],
              [
                48.8614305,
                33.044074
              ],
              [
                48.8617071,
                33.0437941
              ],
              [
                48.8667072,
                33.0354694
              ],
              [
                48.8678205,
                33.0343498
              ],
              [
                48.8694873,
                33.0315779
              ],
              [
                48.868097,
                33.025736
              ],
              [
                48.8630974,
                33.0176822
              ],
              [
                48.8628208,
                33.0137997
              ],
              [
                48.8630974,
                33.0121293
              ],
              [
                48.863374,
                33.0118583
              ],
              [
                48.8642072,
                33.0085176
              ],
              [
                48.8642072,
                33.0074071
              ],
              [
                48.8644872,
                33.0071271
              ],
              [
                48.8644873,
                33.0001658
              ],
              [
                48.850041,
                32.9707398
              ],
              [
                48.8358744,
                32.9490789
              ],
              [
                48.8317079,
                32.9465687
              ],
              [
                48.8314278,
                32.9468487
              ],
              [
                48.8310749,
                32.9472019
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554920,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بروجرد",
          "name:en": "Borujerd County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286028",
          "wikipedia": "fa:شهرستان بروجرد"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.4722371,
                34.0063171
              ],
              [
                48.4730763,
                33.9996556
              ],
              [
                48.473633,
                33.9974261
              ],
              [
                48.4739095,
                33.9971553
              ],
              [
                48.4744662,
                33.9952056
              ],
              [
                48.4747427,
                33.9943752
              ],
              [
                48.4800194,
                33.9804837
              ],
              [
                48.482243,
                33.9746526
              ],
              [
                48.482243,
                33.9743729
              ],
              [
                48.4833528,
                33.9724231
              ],
              [
                48.484186,
                33.9710421
              ],
              [
                48.484186,
                33.9707623
              ],
              [
                48.484466,
                33.9704915
              ],
              [
                48.484743,
                33.9702026
              ],
              [
                48.484743,
                33.9696521
              ],
              [
                48.4989094,
                33.9432676
              ],
              [
                48.4991895,
                33.942708
              ],
              [
                48.503356,
                33.936597
              ],
              [
                48.5075225,
                33.9288161
              ],
              [
                48.5080796,
                33.9285454
              ],
              [
                48.5244678,
                33.8969743
              ],
              [
                48.5274267,
                33.8922556
              ],
              [
                48.5310877,
                33.8806845
              ],
              [
                48.5353964,
                33.8704733
              ],
              [
                48.5477183,
                33.8637812
              ],
              [
                48.5656976,
                33.8600755
              ],
              [
                48.5745971,
                33.8412273
              ],
              [
                48.5899542,
                33.8095335
              ],
              [
                48.5997389,
                33.7804316
              ],
              [
                48.6021422,
                33.7688737
              ],
              [
                48.6144624,
                33.7632522
              ],
              [
                48.6234282,
                33.7600259
              ],
              [
                48.6379516,
                33.7486528
              ],
              [
                48.6382019,
                33.7476711
              ],
              [
                48.6398649,
                33.7450037
              ],
              [
                48.6423546,
                33.7395755
              ],
              [
                48.6451444,
                33.7349614
              ],
              [
                48.6509799,
                33.7242683
              ],
              [
                48.6634692,
                33.7092692
              ],
              [
                48.6724146,
                33.6984421
              ],
              [
                48.674755,
                33.6906385
              ],
              [
                48.6793854,
                33.6839561
              ],
              [
                48.6866979,
                33.6799225
              ],
              [
                48.6940455,
                33.6746018
              ],
              [
                48.7014649,
                33.667914
              ],
              [
                48.707714,
                33.6615677
              ],
              [
                48.7114042,
                33.6550741
              ],
              [
                48.7149238,
                33.6498509
              ],
              [
                48.7221114,
                33.6368905
              ],
              [
                48.7302619,
                33.625519
              ],
              [
                48.7377536,
                33.6138517
              ],
              [
                48.7406277,
                33.6098549
              ],
              [
                48.7435269,
                33.6082754
              ],
              [
                48.7456464,
                33.6076986
              ],
              [
                48.7499776,
                33.6072766
              ],
              [
                48.7498619,
                33.6107255
              ],
              [
                48.7522449,
                33.6106423
              ],
              [
                48.7625627,
                33.6091769
              ],
              [
                48.7674729,
                33.6085039
              ],
              [
                48.7774745,
                33.6070041
              ],
              [
                48.7792758,
                33.6096369
              ],
              [
                48.7820863,
                33.6127966
              ],
              [
                48.7864208,
                33.6158702
              ],
              [
                48.7907981,
                33.6178715
              ],
              [
                48.7980079,
                33.6201587
              ],
              [
                48.8010549,
                33.6205518
              ],
              [
                48.8061618,
                33.6231963
              ],
              [
                48.8104534,
                33.6260908
              ],
              [
                48.8133287,
                33.6302001
              ],
              [
                48.8158385,
                33.6317989
              ],
              [
                48.8147903,
                33.6324211
              ],
              [
                48.8135169,
                33.6325251
              ],
              [
                48.8119005,
                33.6334868
              ],
              [
                48.8110541,
                33.6358457
              ],
              [
                48.8110541,
                33.6435631
              ],
              [
                48.8104969,
                33.6461373
              ],
              [
                48.805561,
                33.6541377
              ],
              [
                48.803321,
                33.656691
              ],
              [
                48.8011527,
                33.6612365
              ],
              [
                48.7964129,
                33.6653622
              ],
              [
                48.7948678,
                33.668435
              ],
              [
                48.7904655,
                33.673641
              ],
              [
                48.7920856,
                33.6779257
              ],
              [
                48.7982654,
                33.6814255
              ],
              [
                48.8066768,
                33.6869962
              ],
              [
                48.8134574,
                33.6933522
              ],
              [
                48.8203433,
                33.6971336
              ],
              [
                48.8270988,
                33.6994072
              ],
              [
                48.8335418,
                33.7047061
              ],
              [
                48.8383173,
                33.7072939
              ],
              [
                48.8384889,
                33.7135789
              ],
              [
                48.8373099,
                33.7206768
              ],
              [
                48.8367282,
                33.7251423
              ],
              [
                48.8382625,
                33.7280518
              ],
              [
                48.8415812,
                33.7307708
              ],
              [
                48.844668,
                33.7360882
              ],
              [
                48.8500085,
                33.739717
              ],
              [
                48.8545173,
                33.7423532
              ],
              [
                48.8605785,
                33.7466809
              ],
              [
                48.86384,
                33.7495356
              ],
              [
                48.8667583,
                33.7473946
              ],
              [
                48.8730677,
                33.7395298
              ],
              [
                48.8756609,
                33.7341204
              ],
              [
                48.8769619,
                33.7313315
              ],
              [
                48.8754173,
                33.7239716
              ],
              [
                48.8758563,
                33.7217698
              ],
              [
                48.8753413,
                33.7196281
              ],
              [
                48.8774442,
                33.7180575
              ],
              [
                48.8801479,
                33.7174863
              ],
              [
                48.887186,
                33.7187
              ],
              [
                48.8931083,
                33.710668
              ],
              [
                48.9007161,
                33.7050254
              ],
              [
                48.9044443,
                33.7036961
              ],
              [
                48.9112186,
                33.6973155
              ],
              [
                48.9143943,
                33.6952089
              ],
              [
                48.9169263,
                33.694102
              ],
              [
                48.9200162,
                33.6947447
              ],
              [
                48.9277587,
                33.7010917
              ],
              [
                48.9349508,
                33.7068124
              ],
              [
                48.9452727,
                33.712431
              ],
              [
                48.9475655,
                33.7136747
              ],
              [
                48.94999,
                33.7148884
              ],
              [
                48.9564227,
                33.720951
              ],
              [
                48.9615386,
                33.7245646
              ],
              [
                48.964978,
                33.7276234
              ],
              [
                48.9670366,
                33.7291825
              ],
              [
                48.9684804,
                33.7327855
              ],
              [
                48.971815,
                33.7346902
              ],
              [
                48.9749593,
                33.7354776
              ],
              [
                48.9835738,
                33.7371884
              ],
              [
                48.9877796,
                33.7370099
              ],
              [
                49.0000834,
                33.7379655
              ],
              [
                48.999992,
                33.7352241
              ],
              [
                49.0038552,
                33.7361331
              ],
              [
                49.0078427,
                33.7406382
              ],
              [
                49.0100955,
                33.744183
              ],
              [
                49.0096664,
                33.7476087
              ],
              [
                49.0064906,
                33.7497497
              ],
              [
                49.0088939,
                33.7504634
              ],
              [
                49.0052032,
                33.7533179
              ],
              [
                49.0054169,
                33.7598866
              ],
              [
                49.005448,
                33.7630671
              ],
              [
                49.0001762,
                33.7687072
              ],
              [
                49.0002192,
                33.769686
              ],
              [
                48.9965862,
                33.7726863
              ],
              [
                48.9919097,
                33.7779001
              ],
              [
                48.9883877,
                33.7796479
              ],
              [
                48.9860402,
                33.7836164
              ],
              [
                48.9856741,
                33.7896331
              ],
              [
                48.9856146,
                33.7959794
              ],
              [
                48.9853613,
                33.7998151
              ],
              [
                48.9847668,
                33.8077042
              ],
              [
                48.9847669,
                33.807984
              ],
              [
                48.9928236,
                33.8149258
              ],
              [
                48.9942135,
                33.8218676
              ],
              [
                48.9936569,
                33.8260381
              ],
              [
                48.9939334,
                33.8299286
              ],
              [
                48.9931002,
                33.8318695
              ],
              [
                48.9931002,
                33.8324292
              ],
              [
                48.9919899,
                33.8335394
              ],
              [
                48.9914333,
                33.83437
              ],
              [
                48.9886567,
                33.8354802
              ],
              [
                48.988377,
                33.8357601
              ],
              [
                48.9878235,
                33.8357601
              ],
              [
                48.9875433,
                33.8360399
              ],
              [
                48.9869903,
                33.8360399
              ],
              [
                48.9867101,
                33.8363197
              ],
              [
                48.9858769,
                33.8363197
              ],
              [
                48.9856003,
                33.8365906
              ],
              [
                48.98171,
                33.8368704
              ],
              [
                48.9803237,
                33.8368704
              ],
              [
                48.9803237,
                33.8371502
              ],
              [
                48.9789334,
                33.8371502
              ],
              [
                48.9781003,
                33.8374301
              ],
              [
                48.9758771,
                33.8396507
              ],
              [
                48.9758772,
                33.8413116
              ],
              [
                48.9972666,
                33.866596
              ],
              [
                48.9980997,
                33.866596
              ],
              [
                49.0000467,
                33.8665959
              ],
              [
                49.0011565,
                33.8660363
              ],
              [
                49.0044898,
                33.8660364
              ],
              [
                49.0061566,
                33.8671466
              ],
              [
                49.0061565,
                33.8674265
              ],
              [
                49.0064331,
                33.8693762
              ],
              [
                49.0055999,
                33.8710372
              ],
              [
                48.9978232,
                33.8790981
              ],
              [
                48.9975466,
                33.8799286
              ],
              [
                48.9972665,
                33.8827088
              ],
              [
                48.9947664,
                33.8882603
              ],
              [
                48.9939332,
                33.8893705
              ],
              [
                48.9939332,
                33.89021
              ],
              [
                48.9936567,
                33.8904809
              ],
              [
                48.9947664,
                33.8927104
              ],
              [
                48.99949,
                33.8952017
              ],
              [
                49.0114331,
                33.9015927
              ],
              [
                49.0122663,
                33.9060429
              ],
              [
                49.0117132,
                33.9071532
              ],
              [
                49.0097663,
                33.9090939
              ],
              [
                49.0028232,
                33.9121539
              ],
              [
                49.0011564,
                33.9115943
              ],
              [
                49.0003231,
                33.9115943
              ],
              [
                48.9998178,
                33.9113236
              ],
              [
                48.9980996,
                33.9107638
              ],
              [
                48.9967133,
                33.9107638
              ],
              [
                48.9964333,
                33.910484
              ],
              [
                48.9953235,
                33.910484
              ],
              [
                48.9950465,
                33.9102041
              ],
              [
                48.9942132,
                33.9102042
              ],
              [
                48.9936566,
                33.9099334
              ],
              [
                48.9842098,
                33.9124247
              ],
              [
                48.9839333,
                33.9127136
              ],
              [
                48.9828236,
                33.9127136
              ],
              [
                48.9822669,
                33.9129844
              ],
              [
                48.9803235,
                33.9127135
              ],
              [
                48.9678201,
                33.9054832
              ],
              [
                48.9664338,
                33.9049325
              ],
              [
                48.9642103,
                33.9049325
              ],
              [
                48.9633771,
                33.9052033
              ],
              [
                48.9628205,
                33.9054832
              ],
              [
                48.9606005,
                33.9074239
              ],
              [
                48.9594871,
                33.9079835
              ],
              [
                48.9575438,
                33.9102041
              ],
              [
                48.9555968,
                33.9168748
              ],
              [
                48.9558769,
                33.9199348
              ],
              [
                48.9561538,
                33.921325
              ],
              [
                48.9564304,
                33.9218755
              ],
              [
                48.9561538,
                33.9224262
              ],
              [
                48.9564304,
                33.922706
              ],
              [
                48.9575437,
                33.927427
              ],
              [
                48.9636535,
                33.9365979
              ],
              [
                48.9639336,
                33.9393781
              ],
              [
                48.9617101,
                33.9427089
              ],
              [
                48.9614336,
                33.9443698
              ],
              [
                48.9619867,
                33.9499301
              ],
              [
                48.9653199,
                33.9560411
              ],
              [
                48.9658766,
                33.9566007
              ],
              [
                48.9686532,
                33.9596517
              ],
              [
                48.9869899,
                33.9721533
              ],
              [
                48.9878231,
                33.9721534
              ],
              [
                48.9980995,
                33.9777046
              ],
              [
                49.0086564,
                33.981595
              ],
              [
                49.0089329,
                33.9818748
              ],
              [
                49.0100462,
                33.9818748
              ],
              [
                49.0103227,
                33.9821546
              ],
              [
                49.0119895,
                33.9821546
              ],
              [
                49.0128228,
                33.9824254
              ],
              [
                49.0158795,
                33.9824255
              ],
              [
                49.0189361,
                33.9821546
              ],
              [
                49.0194894,
                33.9818748
              ],
              [
                49.0211562,
                33.9818748
              ],
              [
                49.0228226,
                33.9813242
              ],
              [
                49.0303224,
                33.9768742
              ],
              [
                49.0306025,
                33.9763146
              ],
              [
                49.037269,
                33.9752134
              ],
              [
                49.037546,
                33.9749335
              ],
              [
                49.0381026,
                33.9752134
              ],
              [
                49.0386593,
                33.9749335
              ],
              [
                49.0417125,
                33.9763146
              ],
              [
                49.052549,
                33.9857652
              ],
              [
                49.0528256,
                33.9860451
              ],
              [
                49.0553256,
                33.9885453
              ],
              [
                49.0564354,
                33.9940966
              ],
              [
                49.0561588,
                33.9946562
              ],
              [
                49.0542158,
                33.9999276
              ],
              [
                49.0544924,
                34.0015975
              ],
              [
                49.0708821,
                34.0102085
              ],
              [
                49.0775724,
                34.01471
              ],
              [
                49.0758818,
                34.0146495
              ],
              [
                49.0750486,
                34.0143787
              ],
              [
                49.0739388,
                34.0143786
              ],
              [
                49.0731051,
                34.0140989
              ],
              [
                49.0703254,
                34.0140988
              ],
              [
                49.0700485,
                34.013819
              ],
              [
                49.0681019,
                34.013819
              ],
              [
                49.0678254,
                34.0135392
              ],
              [
                49.0642155,
                34.0132685
              ],
              [
                49.063382,
                34.0135392
              ],
              [
                49.0631023,
                34.013819
              ],
              [
                49.0622687,
                34.013819
              ],
              [
                49.061992,
                34.0140988
              ],
              [
                49.0556021,
                34.0157687
              ],
              [
                49.046712,
                34.0160394
              ],
              [
                49.0467121,
                34.0163192
              ],
              [
                49.0461589,
                34.0163193
              ],
              [
                49.0433788,
                34.0171497
              ],
              [
                49.0433788,
                34.0168789
              ],
              [
                49.0425456,
                34.0157687
              ],
              [
                49.0408791,
                34.015209
              ],
              [
                49.0389357,
                34.015209
              ],
              [
                49.0383791,
                34.0149291
              ],
              [
                49.0378259,
                34.015209
              ],
              [
                49.0367122,
                34.015209
              ],
              [
                49.0361591,
                34.0154889
              ],
              [
                49.0353259,
                34.0154889
              ],
              [
                49.0178228,
                34.0218704
              ],
              [
                49.0167126,
                34.0218703
              ],
              [
                49.0158793,
                34.0221501
              ],
              [
                49.0111558,
                34.0221501
              ],
              [
                49.0039326,
                34.0204893
              ],
              [
                48.9855999,
                34.010768
              ],
              [
                48.9836565,
                34.0102084
              ],
              [
                48.9825433,
                34.0102084
              ],
              [
                48.9819897,
                34.0099286
              ],
              [
                48.9811565,
                34.0099286
              ],
              [
                48.9808764,
                34.0096488
              ],
              [
                48.9778232,
                34.0090981
              ],
              [
                48.9694866,
                34.0090981
              ],
              [
                48.9692101,
                34.0088183
              ],
              [
                48.9500438,
                34.0027075
              ],
              [
                48.948377,
                34.0027074
              ],
              [
                48.9480968,
                34.0029873
              ],
              [
                48.9475437,
                34.0029873
              ],
              [
                48.9447636,
                34.0063179
              ],
              [
                48.9444869,
                34.0099284
              ],
              [
                48.9442104,
                34.0102083
              ],
              [
                48.9442104,
                34.0110477
              ],
              [
                48.9436537,
                34.0118781
              ],
              [
                48.9433768,
                34.012149
              ],
              [
                48.9419869,
                34.0132682
              ],
              [
                48.9308738,
                34.0218701
              ],
              [
                48.9305973,
                34.0240997
              ],
              [
                48.9280971,
                34.0268706
              ],
              [
                48.9225403,
                34.0282697
              ],
              [
                48.9203205,
                34.0285404
              ],
              [
                48.9161503,
                34.0285404
              ],
              [
                48.9136507,
                34.0274302
              ],
              [
                48.9117074,
                34.0202093
              ],
              [
                48.911984,
                34.0190991
              ],
              [
                48.9122641,
                34.0185394
              ],
              [
                48.9117073,
                34.0140985
              ],
              [
                48.9103176,
                34.0110477
              ],
              [
                48.9042073,
                34.0063179
              ],
              [
                48.8992075,
                34.0043772
              ],
              [
                48.8980943,
                34.0043772
              ],
              [
                48.8975407,
                34.0040974
              ],
              [
                48.8936507,
                34.003267
              ],
              [
                48.8911512,
                34.0032669
              ],
              [
                48.890041,
                34.0035468
              ],
              [
                48.8828178,
                34.004657
              ],
              [
                48.8789279,
                34.004657
              ],
              [
                48.8742043,
                34.0035468
              ],
              [
                48.8725379,
                34.0035467
              ],
              [
                48.868928,
                34.0027074
              ],
              [
                48.8675377,
                34.0027073
              ],
              [
                48.8611478,
                34.0010465
              ],
              [
                48.8544813,
                34.0018768
              ],
              [
                48.8517047,
                34.0027073
              ],
              [
                48.849205,
                34.006047
              ],
              [
                48.8472615,
                34.0129881
              ],
              [
                48.8469815,
                34.013268
              ],
              [
                48.8461482,
                34.0154884
              ],
              [
                48.8461482,
                34.0174381
              ],
              [
                48.8458717,
                34.0177089
              ],
              [
                48.8458716,
                34.0260401
              ],
              [
                48.8439283,
                34.0338207
              ],
              [
                48.8417048,
                34.0363209
              ],
              [
                48.8408715,
                34.0366007
              ],
              [
                48.8403148,
                34.0371513
              ],
              [
                48.8147584,
                34.0499322
              ],
              [
                48.8139252,
                34.0499322
              ],
              [
                48.804202,
                34.0527122
              ],
              [
                48.7969788,
                34.0557631
              ],
              [
                48.7944787,
                34.0568732
              ],
              [
                48.7800355,
                34.0641031
              ],
              [
                48.7792022,
                34.0649335
              ],
              [
                48.765589,
                34.072434
              ],
              [
                48.7597557,
                34.0804942
              ],
              [
                48.7583658,
                34.0846552
              ],
              [
                48.7530891,
                34.0918759
              ],
              [
                48.7500324,
                34.0952155
              ],
              [
                48.7497559,
                34.0954862
              ],
              [
                48.7491992,
                34.0960459
              ],
              [
                48.7478094,
                34.0977157
              ],
              [
                48.7308659,
                34.1210474
              ],
              [
                48.7236428,
                34.1232677
              ],
              [
                48.722533,
                34.1232677
              ],
              [
                48.7219759,
                34.1235476
              ],
              [
                48.7175328,
                34.1235475
              ],
              [
                48.7169762,
                34.1232677
              ],
              [
                48.7158659,
                34.1232677
              ],
              [
                48.7147527,
                34.1227081
              ],
              [
                48.7133664,
                34.1221575
              ],
              [
                48.7130863,
                34.1213272
              ],
              [
                48.7116995,
                34.1163178
              ],
              [
                48.7150329,
                34.1054869
              ],
              [
                48.7153094,
                34.1040968
              ],
              [
                48.7155864,
                34.1032665
              ],
              [
                48.7150329,
                34.0979864
              ],
              [
                48.7128097,
                34.0946558
              ],
              [
                48.7094765,
                34.0918759
              ],
              [
                48.6850299,
                34.0835448
              ],
              [
                48.6805868,
                34.0815953
              ],
              [
                48.67225,
                34.0790951
              ],
              [
                48.6672504,
                34.0788242
              ],
              [
                48.6680073,
                34.0787291
              ],
              [
                48.6618974,
                34.0787291
              ],
              [
                48.6593973,
                34.0792887
              ],
              [
                48.6576542,
                34.0760602
              ],
              [
                48.6474543,
                34.0783667
              ],
              [
                48.6469737,
                34.0821548
              ],
              [
                48.6341937,
                34.0885451
              ],
              [
                48.6339171,
                34.0890958
              ],
              [
                48.6333605,
                34.0890957
              ],
              [
                48.6258607,
                34.0954861
              ],
              [
                48.6247506,
                34.0954861
              ],
              [
                48.6244709,
                34.0957658
              ],
              [
                48.6233607,
                34.0957658
              ],
              [
                48.6219708,
                34.0963164
              ],
              [
                48.6172508,
                34.0960456
              ],
              [
                48.6144706,
                34.0938253
              ],
              [
                48.6141941,
                34.0935454
              ],
              [
                48.5994712,
                34.0702133
              ],
              [
                48.5894714,
                34.0643825
              ],
              [
                48.5886378,
                34.0643825
              ],
              [
                48.5875245,
                34.0638229
              ],
              [
                48.5864147,
                34.0638229
              ],
              [
                48.5858581,
                34.0635431
              ],
              [
                48.5816912,
                34.063543
              ],
              [
                48.580858,
                34.0632632
              ],
              [
                48.5755813,
                34.0632633
              ],
              [
                48.574468,
                34.0635431
              ],
              [
                48.5730817,
                34.063543
              ],
              [
                48.5672483,
                34.0649331
              ],
              [
                48.5650248,
                34.0654837
              ],
              [
                48.5641916,
                34.0654837
              ],
              [
                48.5603017,
                34.0665938
              ],
              [
                48.5597482,
                34.0671535
              ],
              [
                48.5566919,
                34.0696536
              ],
              [
                48.5530785,
                34.0763148
              ],
              [
                48.5528015,
                34.077434
              ],
              [
                48.5500249,
                34.0915957
              ],
              [
                48.5494682,
                34.094105
              ],
              [
                48.5489115,
                34.0954859
              ],
              [
                48.5489115,
                34.096596
              ],
              [
                48.5469685,
                34.1004863
              ],
              [
                48.5458583,
                34.1018762
              ],
              [
                48.5450251,
                34.102156
              ],
              [
                48.5414117,
                34.1049359
              ],
              [
                48.5414117,
                34.1052158
              ],
              [
                48.5405785,
                34.1054865
              ],
              [
                48.5364115,
                34.1074361
              ],
              [
                48.5344687,
                34.1077069
              ],
              [
                48.5269684,
                34.1071563
              ],
              [
                48.5258551,
                34.1065967
              ],
              [
                48.5214122,
                34.100766
              ],
              [
                48.5197453,
                34.0938251
              ],
              [
                48.5191887,
                34.0874347
              ],
              [
                48.5186321,
                34.0660431
              ],
              [
                48.5189122,
                34.0652127
              ],
              [
                48.5189121,
                34.0632632
              ],
              [
                48.5191887,
                34.0604832
              ],
              [
                48.520022,
                34.0571525
              ],
              [
                48.520299,
                34.0568728
              ],
              [
                48.5194655,
                34.0507621
              ],
              [
                48.5114124,
                34.0441008
              ],
              [
                48.4830761,
                34.0102073
              ],
              [
                48.4811327,
                34.0090971
              ],
              [
                48.476133,
                34.0068767
              ],
              [
                48.4752994,
                34.0068767
              ],
              [
                48.4750197,
                34.0065969
              ],
              [
                48.474186,
                34.0065969
              ],
              [
                48.4736329,
                34.006317
              ],
              [
                48.4722371,
                34.0063171
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554991,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خرم آباد",
          "name:en": "Khorramabad County",
          "name:uk": "Хорремабад",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279146",
          "wikipedia": "en:Khorramabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.0486125,
                33.6879736
              ],
              [
                48.0488895,
                33.687423
              ],
              [
                48.055836,
                33.6807517
              ],
              [
                48.0841687,
                33.6635362
              ],
              [
                48.0847254,
                33.6632564
              ],
              [
                48.1358382,
                33.6343592
              ],
              [
                48.1394516,
                33.6335376
              ],
              [
                48.1405617,
                33.6332487
              ],
              [
                48.1475084,
                33.6318675
              ],
              [
                48.1519514,
                33.6304773
              ],
              [
                48.1533412,
                33.6304773
              ],
              [
                48.1552847,
                33.6296378
              ],
              [
                48.156118,
                33.6296377
              ],
              [
                48.1658412,
                33.6249163
              ],
              [
                48.1666747,
                33.6240857
              ],
              [
                48.1827877,
                33.6152026
              ],
              [
                48.1830646,
                33.6146428
              ],
              [
                48.191121,
                33.6107519
              ],
              [
                48.1919543,
                33.6101922
              ],
              [
                48.1922308,
                33.6099213
              ],
              [
                48.1950074,
                33.608811
              ],
              [
                48.2038974,
                33.6032589
              ],
              [
                48.206121,
                33.6010291
              ],
              [
                48.2072307,
                33.6004784
              ],
              [
                48.2188974,
                33.5910353
              ],
              [
                48.2339004,
                33.5779722
              ],
              [
                48.234454,
                33.5774215
              ],
              [
                48.233446,
                33.5629845
              ],
              [
                48.238836,
                33.5576268
              ],
              [
                48.2447524,
                33.5520005
              ],
              [
                48.2473293,
                33.5472449
              ],
              [
                48.2437773,
                33.5437799
              ],
              [
                48.2355931,
                33.5352331
              ],
              [
                48.2256017,
                33.5243596
              ],
              [
                48.2231868,
                33.52335
              ],
              [
                48.219481,
                33.5216476
              ],
              [
                48.2132591,
                33.5213327
              ],
              [
                48.2110118,
                33.5247961
              ],
              [
                48.2068061,
                33.5246888
              ],
              [
                48.2012701,
                33.5222202
              ],
              [
                48.1988005,
                33.5155961
              ],
              [
                48.1880283,
                33.5047872
              ],
              [
                48.1844164,
                33.5007871
              ],
              [
                48.1846469,
                33.5008311
              ],
              [
                48.1945753,
                33.4948462
              ],
              [
                48.1974935,
                33.4935936
              ],
              [
                48.2093136,
                33.4786895
              ],
              [
                48.2148313,
                33.4748023
              ],
              [
                48.2238798,
                33.4703286
              ],
              [
                48.2247723,
                33.464129
              ],
              [
                48.2253921,
                33.4601348
              ],
              [
                48.2257355,
                33.4577286
              ],
              [
                48.2249825,
                33.4535903
              ],
              [
                48.2216119,
                33.4490605
              ],
              [
                48.2192509,
                33.4442571
              ],
              [
                48.2215659,
                33.4426906
              ],
              [
                48.2236878,
                33.4428105
              ],
              [
                48.225638,
                33.4420651
              ],
              [
                48.2319466,
                33.4423142
              ],
              [
                48.2300663,
                33.4267137
              ],
              [
                48.2282976,
                33.421662
              ],
              [
                48.2207536,
                33.4164337
              ],
              [
                48.2122472,
                33.41153
              ],
              [
                48.2093052,
                33.408576
              ],
              [
                48.2105827,
                33.4038596
              ],
              [
                48.2157325,
                33.3992379
              ],
              [
                48.2240152,
                33.3967657
              ],
              [
                48.2265472,
                33.3933977
              ],
              [
                48.2269763,
                33.387593
              ],
              [
                48.2230281,
                33.3815012
              ],
              [
                48.2148741,
                33.3764125
              ],
              [
                48.1827734,
                33.3652305
              ],
              [
                48.1765578,
                33.3645815
              ],
              [
                48.1612166,
                33.3567616
              ],
              [
                48.1546267,
                33.3492482
              ],
              [
                48.1471153,
                33.3455926
              ],
              [
                48.1397339,
                33.3416068
              ],
              [
                48.13385,
                33.3397071
              ],
              [
                48.1273743,
                33.3391826
              ],
              [
                48.1164075,
                33.338173
              ],
              [
                48.1056535,
                33.33725
              ],
              [
                48.0970038,
                33.3371796
              ],
              [
                48.0955417,
                33.3314987
              ],
              [
                48.0962538,
                33.3305676
              ],
              [
                48.0998611,
                33.3280901
              ],
              [
                48.1062293,
                33.3221996
              ],
              [
                48.1159091,
                33.3150518
              ],
              [
                48.1317627,
                33.3042194
              ],
              [
                48.1422614,
                33.3012646
              ],
              [
                48.1509303,
                33.2990407
              ],
              [
                48.1595991,
                33.2983951
              ],
              [
                48.1710147,
                33.2954537
              ],
              [
                48.1868933,
                33.2927993
              ],
              [
                48.2445715,
                33.2844766
              ],
              [
                48.2557295,
                33.3039906
              ],
              [
                48.2723807,
                33.3018385
              ],
              [
                48.2898901,
                33.3051384
              ],
              [
                48.2909201,
                33.3136025
              ],
              [
                48.2944752,
                33.3118388
              ],
              [
                48.3001218,
                33.3078207
              ],
              [
                48.3060693,
                33.3033808
              ],
              [
                48.3107042,
                33.3013363
              ],
              [
                48.3134079,
                33.2998657
              ],
              [
                48.316369,
                33.2958841
              ],
              [
                48.3197593,
                33.2922252
              ],
              [
                48.32345,
                33.2895348
              ],
              [
                48.327531,
                33.2880736
              ],
              [
                48.3303763,
                33.2879945
              ],
              [
                48.3451019,
                33.289512
              ],
              [
                48.3602748,
                33.2908342
              ],
              [
                48.3662669,
                33.28931
              ],
              [
                48.3666228,
                33.2875618
              ],
              [
                48.3649062,
                33.2845483
              ],
              [
                48.3596706,
                33.2785928
              ],
              [
                48.3570098,
                33.2712734
              ],
              [
                48.3600997,
                33.2693358
              ],
              [
                48.3648204,
                33.2633075
              ],
              [
                48.3656787,
                33.2604368
              ],
              [
                48.3622455,
                33.2546949
              ],
              [
                48.360958,
                33.2499576
              ],
              [
                48.365507,
                33.2506036
              ],
              [
                48.3695411,
                33.2490245
              ],
              [
                48.3691119,
                33.2458661
              ],
              [
                48.3668803,
                33.2431384
              ],
              [
                48.3640479,
                33.2372518
              ],
              [
                48.3657475,
                33.2344277
              ],
              [
                48.3743748,
                33.2273479
              ],
              [
                48.3755132,
                33.2259317
              ],
              [
                48.3749756,
                33.2151496
              ],
              [
                48.3737107,
                33.2074879
              ],
              [
                48.3737739,
                33.1960665
              ],
              [
                48.3740371,
                33.1931642
              ],
              [
                48.3779663,
                33.1873776
              ],
              [
                48.3794279,
                33.1814563
              ],
              [
                48.3796691,
                33.1763532
              ],
              [
                48.3799932,
                33.1723316
              ],
              [
                48.3804416,
                33.1711087
              ],
              [
                48.3854863,
                33.1658013
              ],
              [
                48.3883267,
                33.1588272
              ],
              [
                48.3884986,
                33.1549976
              ],
              [
                48.3891685,
                33.1492119
              ],
              [
                48.3886727,
                33.1452747
              ],
              [
                48.3863136,
                33.1401465
              ],
              [
                48.3813555,
                33.1365281
              ],
              [
                48.3779032,
                33.1324388
              ],
              [
                48.3760586,
                33.1266244
              ],
              [
                48.3761079,
                33.1172029
              ],
              [
                48.3770293,
                33.1058119
              ],
              [
                48.3783557,
                33.0958251
              ],
              [
                48.3795633,
                33.0884182
              ],
              [
                48.3794108,
                33.0859899
              ],
              [
                48.3794967,
                33.0840564
              ],
              [
                48.3797958,
                33.0803328
              ],
              [
                48.3800123,
                33.074138
              ],
              [
                48.379087,
                33.0653514
              ],
              [
                48.3786988,
                33.0578484
              ],
              [
                48.3790659,
                33.0485108
              ],
              [
                48.3788274,
                33.0398851
              ],
              [
                48.3770943,
                33.036679
              ],
              [
                48.3706097,
                33.0360084
              ],
              [
                48.3639813,
                33.0337839
              ],
              [
                48.3592416,
                33.0304818
              ],
              [
                48.3602615,
                33.0159096
              ],
              [
                48.4089099,
                32.9999029
              ],
              [
                48.40891,
                32.997131
              ],
              [
                48.4069635,
                32.9890681
              ],
              [
                48.40641,
                32.9885173
              ],
              [
                48.4044635,
                32.9790728
              ],
              [
                48.4039555,
                32.9658055
              ],
              [
                48.406414,
                32.9655524
              ],
              [
                48.4097213,
                32.9657135
              ],
              [
                48.4134559,
                32.9655881
              ],
              [
                48.4172973,
                32.9651875
              ],
              [
                48.4212455,
                32.9647867
              ],
              [
                48.422586,
                32.964731
              ],
              [
                48.4238433,
                32.9646713
              ],
              [
                48.4259033,
                32.9647025
              ],
              [
                48.4275323,
                32.9651982
              ],
              [
                48.4304695,
                32.9662393
              ],
              [
                48.4326477,
                32.9670573
              ],
              [
                48.4347648,
                32.967599
              ],
              [
                48.4365539,
                32.9678161
              ],
              [
                48.4399184,
                32.9682052
              ],
              [
                48.4445801,
                32.9686772
              ],
              [
                48.4496193,
                32.9686856
              ],
              [
                48.4538955,
                32.9685565
              ],
              [
                48.4561157,
                32.9684935
              ],
              [
                48.4593582,
                32.9680479
              ],
              [
                48.4629248,
                32.9672323
              ],
              [
                48.466053,
                32.9662814
              ],
              [
                48.4675103,
                32.9658511
              ],
              [
                48.4697837,
                32.9656943
              ],
              [
                48.4738998,
                32.9658002
              ],
              [
                48.4754716,
                32.9658816
              ],
              [
                48.4790381,
                32.9653902
              ],
              [
                48.4808459,
                32.9651948
              ],
              [
                48.4832037,
                32.96494
              ],
              [
                48.4877931,
                32.9638332
              ],
              [
                48.492817,
                32.9626357
              ],
              [
                48.499612,
                32.9612031
              ],
              [
                48.5022086,
                32.9615053
              ],
              [
                48.5045663,
                32.9616899
              ],
              [
                48.5071413,
                32.9622869
              ],
              [
                48.5098801,
                32.963622
              ],
              [
                48.5143167,
                32.9654619
              ],
              [
                48.5174943,
                32.9670716
              ],
              [
                48.5222625,
                32.9697835
              ],
              [
                48.5229936,
                32.9702654
              ],
              [
                48.5265924,
                32.9726376
              ],
              [
                48.5288393,
                32.9740143
              ],
              [
                48.53207,
                32.9762694
              ],
              [
                48.5340461,
                32.9780149
              ],
              [
                48.5351944,
                32.9790272
              ],
              [
                48.5366744,
                32.9800866
              ],
              [
                48.5378264,
                32.9807743
              ],
              [
                48.5396919,
                32.9815595
              ],
              [
                48.5402817,
                32.9798486
              ],
              [
                48.5427459,
                32.9802953
              ],
              [
                48.5437075,
                32.9805279
              ],
              [
                48.5460216,
                32.9790355
              ],
              [
                48.5490732,
                32.9790728
              ],
              [
                48.5509963,
                32.9760485
              ],
              [
                48.5565902,
                32.9756971
              ],
              [
                48.5596838,
                32.9737084
              ],
              [
                48.5595102,
                32.9711164
              ],
              [
                48.56248,
                32.9686038
              ],
              [
                48.5745374,
                32.9639392
              ],
              [
                48.5912501,
                32.9558476
              ],
              [
                48.6082857,
                32.9464485
              ],
              [
                48.6156796,
                32.9396993
              ],
              [
                48.6208507,
                32.9379036
              ],
              [
                48.6267391,
                32.937627
              ],
              [
                48.6312258,
                32.9430486
              ],
              [
                48.6354814,
                32.9505641
              ],
              [
                48.636806,
                32.9541694
              ],
              [
                48.6409962,
                32.9548677
              ],
              [
                48.6471638,
                32.9491458
              ],
              [
                48.6503898,
                32.9476055
              ],
              [
                48.6559733,
                32.939888
              ],
              [
                48.6632446,
                32.9361646
              ],
              [
                48.6685134,
                32.934377
              ],
              [
                48.6774157,
                32.9292254
              ],
              [
                48.6839021,
                32.9213477
              ],
              [
                48.686695,
                32.9189753
              ],
              [
                48.6890955,
                32.9169516
              ],
              [
                48.6911346,
                32.9150081
              ],
              [
                48.6942528,
                32.9119811
              ],
              [
                48.6953008,
                32.9084942
              ],
              [
                48.6993687,
                32.907042
              ],
              [
                48.7050813,
                32.9052725
              ],
              [
                48.7072031,
                32.902423
              ],
              [
                48.7108999,
                32.8962061
              ],
              [
                48.7137121,
                32.8923774
              ],
              [
                48.716316,
                32.8911555
              ],
              [
                48.7199026,
                32.8956084
              ],
              [
                48.7217883,
                32.8973072
              ],
              [
                48.7252617,
                32.8980398
              ],
              [
                48.7268628,
                32.899461
              ],
              [
                48.7275411,
                32.9012338
              ],
              [
                48.7291155,
                32.9021081
              ],
              [
                48.7315063,
                32.9026102
              ],
              [
                48.7338408,
                32.902442
              ],
              [
                48.7341929,
                32.9011541
              ],
              [
                48.7338685,
                32.8994216
              ],
              [
                48.7351807,
                32.8975835
              ],
              [
                48.7380218,
                32.8973087
              ],
              [
                48.7401009,
                32.8978049
              ],
              [
                48.741708,
                32.8989916
              ],
              [
                48.7457799,
                32.9017432
              ],
              [
                48.7471753,
                32.9039224
              ],
              [
                48.7492017,
                32.9074671
              ],
              [
                48.7512282,
                32.9115579
              ],
              [
                48.752983,
                32.9152229
              ],
              [
                48.755292,
                32.9164744
              ],
              [
                48.7598593,
                32.9170436
              ],
              [
                48.7616349,
                32.9168185
              ],
              [
                48.7642897,
                32.9180377
              ],
              [
                48.7661171,
                32.9203137
              ],
              [
                48.7666627,
                32.920727
              ],
              [
                48.7674254,
                32.9213268
              ],
              [
                48.767975,
                32.9220625
              ],
              [
                48.7686882,
                32.922986
              ],
              [
                48.7689666,
                32.9235839
              ],
              [
                48.7692414,
                32.9242291
              ],
              [
                48.7695772,
                32.9252022
              ],
              [
                48.7695885,
                32.9264942
              ],
              [
                48.769436,
                32.9278824
              ],
              [
                48.7693368,
                32.9288523
              ],
              [
                48.7689628,
                32.929921
              ],
              [
                48.7684822,
                32.9308435
              ],
              [
                48.7681124,
                32.9316778
              ],
              [
                48.7675209,
                32.9327426
              ],
              [
                48.7669335,
                32.9335775
              ],
              [
                48.7663421,
                32.9345047
              ],
              [
                48.7659148,
                32.935108
              ],
              [
                48.7657546,
                32.9355267
              ],
              [
                48.765648,
                32.9358968
              ],
              [
                48.7656518,
                32.936359
              ],
              [
                48.7656059,
                32.9373321
              ],
              [
                48.7657737,
                32.9380227
              ],
              [
                48.7659453,
                32.9389456
              ],
              [
                48.7660066,
                32.9399634
              ],
              [
                48.7659607,
                32.9409365
              ],
              [
                48.7660254,
                32.9419522
              ],
              [
                48.7659798,
                32.9431529
              ],
              [
                48.7658768,
                32.9438477
              ],
              [
                48.7657777,
                32.9447297
              ],
              [
                48.765457,
                32.9455603
              ],
              [
                48.7650338,
                32.9466258
              ],
              [
                48.7641717,
                32.9476925
              ],
              [
                48.76326,
                32.9488057
              ],
              [
                48.7626649,
                32.949318
              ],
              [
                48.7620202,
                32.949967
              ],
              [
                48.7612647,
                32.9505261
              ],
              [
                48.7606735,
                32.951176
              ],
              [
                48.7604064,
                32.951825
              ],
              [
                48.7602995,
                32.9522852
              ],
              [
                48.7603072,
                32.9529346
              ],
              [
                48.7605858,
                32.9538572
              ],
              [
                48.761135,
                32.9546899
              ],
              [
                48.7618483,
                32.9554714
              ],
              [
                48.7628325,
                32.9562082
              ],
              [
                48.7640877,
                32.9569859
              ],
              [
                48.7648506,
                32.9575384
              ],
              [
                48.7654533,
                32.9579505
              ],
              [
                48.7657813,
                32.9584117
              ],
              [
                48.7661094,
                32.9588279
              ],
              [
                48.7663878,
                32.9593356
              ],
              [
                48.7664489,
                32.9601212
              ],
              [
                48.7662888,
                32.9606775
              ],
              [
                48.7658615,
                32.9613732
              ],
              [
                48.7653236,
                32.9621571
              ],
              [
                48.7646789,
                32.9629481
              ],
              [
                48.7640343,
                32.9637369
              ],
              [
                48.7637102,
                32.9640625
              ],
              [
                48.7634466,
                32.9647566
              ],
              [
                48.7629622,
                32.9653138
              ],
              [
                48.7623528,
                32.965926
              ],
              [
                48.762314,
                32.965965
              ],
              [
                48.7621573,
                32.9664266
              ],
              [
                48.7620505,
                32.9667516
              ],
              [
                48.7619974,
                32.9671203
              ],
              [
                48.7622185,
                32.9674444
              ],
              [
                48.7624397,
                32.9676738
              ],
              [
                48.7628212,
                32.9679489
              ],
              [
                48.7634202,
                32.9681784
              ],
              [
                48.7638015,
                32.9683159
              ],
              [
                48.7642898,
                32.9683608
              ],
              [
                48.7648849,
                32.9683579
              ],
              [
                48.7649711,
                32.9683453
              ],
              [
                48.7658617,
                32.9682153
              ],
              [
                48.7665138,
                32.9680737
              ],
              [
                48.7670555,
                32.9679346
              ],
              [
                48.7674903,
                32.9679288
              ],
              [
                48.7682184,
                32.9678449
              ],
              [
                48.768303,
                32.9678351
              ],
              [
                48.7691689,
                32.9674606
              ],
              [
                48.7696534,
                32.9671356
              ],
              [
                48.7702554,
                32.9664153
              ],
              [
                48.7703513,
                32.9663004
              ],
              [
                48.7707292,
                32.9657909
              ],
              [
                48.7709961,
                32.9652794
              ],
              [
                48.7711563,
                32.964863
              ],
              [
                48.7713701,
                32.9645376
              ],
              [
                48.7717478,
                32.9641679
              ],
              [
                48.7721788,
                32.9639366
              ],
              [
                48.7727202,
                32.9637952
              ],
              [
                48.7733194,
                32.9637901
              ],
              [
                48.7739145,
                32.9637872
              ],
              [
                48.7739721,
                32.9638066
              ],
              [
                48.7744598,
                32.9639705
              ],
              [
                48.7751121,
                32.9641535
              ],
              [
                48.7756042,
                32.9643359
              ],
              [
                48.7759859,
                32.9644734
              ],
              [
                48.7762566,
                32.9644241
              ],
              [
                48.7764701,
                32.9643332
              ],
              [
                48.7766305,
                32.9639619
              ],
              [
                48.7769547,
                32.9636836
              ],
              [
                48.7779236,
                32.9627991
              ],
              [
                48.7787363,
                32.9621958
              ],
              [
                48.7792206,
                32.9618234
              ],
              [
                48.7798652,
                32.9613119
              ],
              [
                48.7805139,
                32.9607553
              ],
              [
                48.7815401,
                32.9602888
              ],
              [
                48.7824591,
                32.9598701
              ],
              [
                48.7831651,
                32.9595873
              ],
              [
                48.7841379,
                32.9593047
              ],
              [
                48.7846259,
                32.9591172
              ],
              [
                48.78479,
                32.9590254
              ],
              [
                48.7852212,
                32.9588392
              ],
              [
                48.7855987,
                32.9586994
              ],
              [
                48.7863579,
                32.9586024
              ],
              [
                48.7869568,
                32.9585544
              ],
              [
                48.7874985,
                32.9584129
              ],
              [
                48.7882044,
                32.958457
              ],
              [
                48.789074,
                32.9587317
              ],
              [
                48.7900544,
                32.9590939
              ],
              [
                48.7902184,
                32.9593268
              ],
              [
                48.7905464,
                32.9593236
              ],
              [
                48.790924,
                32.9591409
              ],
              [
                48.7913017,
                32.9587666
              ],
              [
                48.7916221,
                32.9582605
              ],
              [
                48.7921066,
                32.9579309
              ],
              [
                48.7930299,
                32.9578367
              ],
              [
                48.7940635,
                32.9578325
              ],
              [
                48.7948761,
                32.9579663
              ],
              [
                48.795639,
                32.9581939
              ],
              [
                48.7964592,
                32.9588848
              ],
              [
                48.7972794,
                32.9594809
              ],
              [
                48.7976609,
                32.9597581
              ],
              [
                48.7984772,
                32.959892
              ],
              [
                48.7992935,
                32.9599334
              ],
              [
                48.7997781,
                32.9598428
              ],
              [
                48.8004264,
                32.9593763
              ],
              [
                48.800911,
                32.9590038
              ],
              [
                48.8015061,
                32.9587708
              ],
              [
                48.802105,
                32.9587205
              ],
              [
                48.8028107,
                32.9587171
              ],
              [
                48.8036805,
                32.9588542
              ],
              [
                48.8045501,
                32.9591287
              ],
              [
                48.805313,
                32.9593541
              ],
              [
                48.8058014,
                32.9594911
              ],
              [
                48.8060761,
                32.959629
              ],
              [
                48.8063468,
                32.9596292
              ],
              [
                48.8065645,
                32.9596285
              ],
              [
                48.806942,
                32.9594886
              ],
              [
                48.8069953,
                32.9591176
              ],
              [
                48.8072624,
                32.9586534
              ],
              [
                48.8076934,
                32.9583273
              ],
              [
                48.808235,
                32.9580505
              ],
              [
                48.8088301,
                32.9578174
              ],
              [
                48.8096962,
                32.9576252
              ],
              [
                48.8105622,
                32.9574398
              ],
              [
                48.8112106,
                32.9571581
              ],
              [
                48.8119127,
                32.9566924
              ],
              [
                48.8123436,
                32.956231
              ],
              [
                48.8126144,
                32.9559021
              ],
              [
                48.8130416,
                32.9554407
              ],
              [
                48.8136367,
                32.9548379
              ],
              [
                48.8143387,
                32.9543723
              ],
              [
                48.8151473,
                32.9538566
              ],
              [
                48.8158988,
                32.9530221
              ],
              [
                48.8163299,
                32.9523736
              ],
              [
                48.8169646,
                32.951629
              ],
              [
                48.8170816,
                32.9514917
              ],
              [
                48.8177833,
                32.9508885
              ],
              [
                48.818161,
                32.9506562
              ],
              [
                48.8188097,
                32.9506066
              ],
              [
                48.8192442,
                32.9506999
              ],
              [
                48.8193317,
                32.9507402
              ],
              [
                48.8197367,
                32.9509272
              ],
              [
                48.8204459,
                32.951431
              ],
              [
                48.8211022,
                32.9517513
              ],
              [
                48.8215371,
                32.9519798
              ],
              [
                48.8222427,
                32.9519809
              ],
              [
                48.8227843,
                32.9518393
              ],
              [
                48.8235435,
                32.9516992
              ],
              [
                48.8243028,
                32.9515524
              ],
              [
                48.8247336,
                32.9513209
              ],
              [
                48.8256569,
                32.9511792
              ],
              [
                48.8261452,
                32.951084
              ],
              [
                48.8265762,
                32.9508052
              ],
              [
                48.8273314,
                32.9504328
              ],
              [
                48.8279266,
                32.9501072
              ],
              [
                48.8282508,
                32.9498739
              ],
              [
                48.8285219,
                32.9496419
              ],
              [
                48.8288459,
                32.949501
              ],
              [
                48.8292238,
                32.9493137
              ],
              [
                48.8294944,
                32.9491267
              ],
              [
                48.8298188,
                32.9489408
              ],
              [
                48.830303,
                32.948753
              ],
              [
                48.8307382,
                32.9485216
              ],
              [
                48.8308984,
                32.9483373
              ],
              [
                48.8310051,
                32.9481047
              ],
              [
                48.8311118,
                32.947827
              ],
              [
                48.8311616,
                32.9474559
              ],
              [
                48.8310749,
                32.9472019
              ],
              [
                48.8314278,
                32.9468487
              ],
              [
                48.8317079,
                32.9465687
              ],
              [
                48.8358744,
                32.9490789
              ],
              [
                48.850041,
                32.9707398
              ],
              [
                48.8644873,
                33.0001658
              ],
              [
                48.8644872,
                33.0071271
              ],
              [
                48.8642072,
                33.0074071
              ],
              [
                48.8642072,
                33.0085176
              ],
              [
                48.863374,
                33.0118583
              ],
              [
                48.8630974,
                33.0121293
              ],
              [
                48.8628208,
                33.0137997
              ],
              [
                48.8630974,
                33.0176822
              ],
              [
                48.868097,
                33.025736
              ],
              [
                48.8694873,
                33.0315779
              ],
              [
                48.8678205,
                33.0343498
              ],
              [
                48.8667072,
                33.0354694
              ],
              [
                48.8617071,
                33.0437941
              ],
              [
                48.8614305,
                33.044074
              ],
              [
                48.8614305,
                33.0443539
              ],
              [
                48.8614305,
                33.0446338
              ],
              [
                48.8597641,
                33.0462951
              ],
              [
                48.859764,
                33.0504666
              ],
              [
                48.859764,
                33.0510173
              ],
              [
                48.8597641,
                33.051857
              ],
              [
                48.8633739,
                33.0560194
              ],
              [
                48.8644872,
                33.0568501
              ],
              [
                48.8689306,
                33.0582406
              ],
              [
                48.8692071,
                33.0585204
              ],
              [
                48.8719873,
                33.0585205
              ],
              [
                48.8725405,
                33.0582405
              ],
              [
                48.876987,
                33.0582406
              ],
              [
                48.8800401,
                33.059631
              ],
              [
                48.8844868,
                33.0663034
              ],
              [
                48.8853204,
                33.0663035
              ],
              [
                48.8864301,
                33.0668542
              ],
              [
                48.8872633,
                33.0668542
              ],
              [
                48.89421,
                33.0707457
              ],
              [
                48.8947635,
                33.0712965
              ],
              [
                48.8958769,
                33.0724071
              ],
              [
                48.8964299,
                33.0762986
              ],
              [
                48.8958768,
                33.077689
              ],
              [
                48.8955967,
                33.0785197
              ],
              [
                48.8917103,
                33.0874132
              ],
              [
                48.8911536,
                33.087964
              ],
              [
                48.8836534,
                33.1093535
              ],
              [
                48.8830968,
                33.1112948
              ],
              [
                48.8828202,
                33.1132449
              ],
              [
                48.8825437,
                33.1140756
              ],
              [
                48.8822635,
                33.115746
              ],
              [
                48.8825436,
                33.1196374
              ],
              [
                48.8828201,
                33.1201882
              ],
              [
                48.8830967,
                33.1212987
              ],
              [
                48.8833768,
                33.1215787
              ],
              [
                48.8830968,
                33.1218585
              ],
              [
                48.8830967,
                33.1254701
              ],
              [
                48.8828202,
                33.1260209
              ],
              [
                48.8830967,
                33.1465796
              ],
              [
                48.88282,
                33.1474102
              ],
              [
                48.88004,
                33.1588046
              ],
              [
                48.8797633,
                33.1590755
              ],
              [
                48.8742066,
                33.1696302
              ],
              [
                48.87393,
                33.1699101
              ],
              [
                48.8736534,
                33.1713005
              ],
              [
                48.8736535,
                33.1724111
              ],
              [
                48.8730967,
                33.1732417
              ],
              [
                48.8728203,
                33.1738016
              ],
              [
                48.8725401,
                33.1743522
              ],
              [
                48.87143,
                33.1785236
              ],
              [
                48.8711534,
                33.1788034
              ],
              [
                48.8781741,
                33.2014326
              ],
              [
                48.8781259,
                33.2022647
              ],
              [
                48.8859001,
                33.2163115
              ],
              [
                48.8868015,
                33.2179398
              ],
              [
                48.8891584,
                33.2221972
              ],
              [
                48.8860784,
                33.2422454
              ],
              [
                48.8797631,
                33.2629691
              ],
              [
                48.879763,
                33.2668514
              ],
              [
                48.8811529,
                33.2790762
              ],
              [
                48.8794865,
                33.293251
              ],
              [
                48.8769863,
                33.302415
              ],
              [
                48.8764297,
                33.3032456
              ],
              [
                48.8753199,
                33.3076876
              ],
              [
                48.8750398,
                33.3093579
              ],
              [
                48.8747628,
                33.3135291
              ],
              [
                48.8744863,
                33.3157501
              ],
              [
                48.8742062,
                33.3176911
              ],
              [
                48.8744863,
                33.3210228
              ],
              [
                48.8744863,
                33.3215825
              ],
              [
                48.8780965,
                33.3326965
              ],
              [
                48.8830962,
                33.3371386
              ],
              [
                48.888653,
                33.3376893
              ],
              [
                48.8950429,
                33.3387999
              ],
              [
                48.9036524,
                33.3438016
              ],
              [
                48.9072658,
                33.3499139
              ],
              [
                48.9078192,
                33.3507535
              ],
              [
                48.910599,
                33.3535252
              ],
              [
                48.913099,
                33.3551955
              ],
              [
                48.9289322,
                33.3604681
              ],
              [
                48.9297653,
                33.3604682
              ],
              [
                48.9308755,
                33.3610279
              ],
              [
                48.9355987,
                33.3618585
              ],
              [
                48.9358752,
                33.3621384
              ],
              [
                48.9367088,
                33.3621384
              ],
              [
                48.9372655,
                33.3624182
              ],
              [
                48.9386554,
                33.3624183
              ],
              [
                48.9425453,
                33.3635288
              ],
              [
                48.9436554,
                33.3635288
              ],
              [
                48.9469888,
                33.3646393
              ],
              [
                48.9469888,
                33.3649191
              ],
              [
                48.9464321,
                33.36519
              ],
              [
                48.941432,
                33.3668602
              ],
              [
                48.9383788,
                33.367411
              ],
              [
                48.9378222,
                33.3676909
              ],
              [
                48.9367088,
                33.3676909
              ],
              [
                48.9358752,
                33.3679707
              ],
              [
                48.9300424,
                33.3690812
              ],
              [
                48.9005991,
                33.3785249
              ],
              [
                48.8936525,
                33.3840863
              ],
              [
                48.8935164,
                33.3843571
              ],
              [
                48.8933759,
                33.384637
              ],
              [
                48.8933759,
                33.3849169
              ],
              [
                48.8930958,
                33.3851967
              ],
              [
                48.8908759,
                33.3910291
              ],
              [
                48.8911528,
                33.3946404
              ],
              [
                48.8914294,
                33.3949203
              ],
              [
                48.8911529,
                33.395471
              ],
              [
                48.8919859,
                33.3982518
              ],
              [
                48.8942091,
                33.4013033
              ],
              [
                48.9172654,
                33.4154778
              ],
              [
                48.9175422,
                33.4157486
              ],
              [
                48.9255988,
                33.4196398
              ],
              [
                48.9292086,
                33.4201905
              ],
              [
                48.9297653,
                33.4204704
              ],
              [
                48.9369888,
                33.4204704
              ],
              [
                48.9375455,
                33.4207503
              ],
              [
                48.9414318,
                33.4207503
              ],
              [
                48.9450452,
                33.4218607
              ],
              [
                48.9555981,
                33.4285236
              ],
              [
                48.9650447,
                33.4418583
              ],
              [
                48.965878,
                33.4435285
              ],
              [
                48.9664351,
                33.4449189
              ],
              [
                48.9719879,
                33.4549222
              ],
              [
                48.9728214,
                33.4579736
              ],
              [
                48.9833778,
                33.4713082
              ],
              [
                48.9889346,
                33.4732492
              ],
              [
                48.9892112,
                33.4735292
              ],
              [
                48.9903245,
                33.4735291
              ],
              [
                48.9942144,
                33.4751993
              ],
              [
                48.9989344,
                33.4804808
              ],
              [
                48.9989344,
                33.4807517
              ],
              [
                48.9989344,
                33.4813114
              ],
              [
                48.9986578,
                33.4818621
              ],
              [
                48.9983809,
                33.4829725
              ],
              [
                48.9983809,
                33.4846428
              ],
              [
                48.9981007,
                33.4851935
              ],
              [
                48.9978242,
                33.4854734
              ],
              [
                48.9975477,
                33.4865838
              ],
              [
                48.964768,
                33.5282571
              ],
              [
                48.9642113,
                33.5288077
              ],
              [
                48.9642114,
                33.5290877
              ],
              [
                48.9569881,
                33.5393615
              ],
              [
                48.9530981,
                33.547974
              ],
              [
                48.9528216,
                33.5490935
              ],
              [
                48.9525446,
                33.5510346
              ],
              [
                48.9522646,
                33.5529756
              ],
              [
                48.9522645,
                33.554782
              ],
              [
                48.9522645,
                33.5565866
              ],
              [
                48.951988,
                33.5571373
              ],
              [
                48.9517114,
                33.5582568
              ],
              [
                48.9514312,
                33.5601978
              ],
              [
                48.9494879,
                33.5649194
              ],
              [
                48.9486547,
                33.5663097
              ],
              [
                48.9486547,
                33.5665896
              ],
              [
                48.9461545,
                33.5713111
              ],
              [
                48.945878,
                33.5715819
              ],
              [
                48.945598,
                33.5724214
              ],
              [
                48.9455979,
                33.5729722
              ],
              [
                48.9453213,
                33.5732521
              ],
              [
                48.9422647,
                33.5796437
              ],
              [
                48.9244885,
                33.5951986
              ],
              [
                48.9239318,
                33.5951986
              ],
              [
                48.9236549,
                33.5954785
              ],
              [
                48.9211552,
                33.5954784
              ],
              [
                48.9208751,
                33.5957583
              ],
              [
                48.9194884,
                33.5957584
              ],
              [
                48.9189317,
                33.5960381
              ],
              [
                48.9172649,
                33.5960382
              ],
              [
                48.9164316,
                33.596309
              ],
              [
                48.9158749,
                33.596309
              ],
              [
                48.9153183,
                33.596309
              ],
              [
                48.9150418,
                33.5965889
              ],
              [
                48.9139317,
                33.5965888
              ],
              [
                48.9136519,
                33.596309
              ],
              [
                48.9128183,
                33.596309
              ],
              [
                48.9122651,
                33.5960381
              ],
              [
                48.9086518,
                33.5954784
              ],
              [
                48.9042084,
                33.5946479
              ],
              [
                48.9039318,
                33.594368
              ],
              [
                48.898652,
                33.5943679
              ],
              [
                48.8978187,
                33.5946478
              ],
              [
                48.8933753,
                33.5946479
              ],
              [
                48.8919855,
                33.5949187
              ],
              [
                48.8719057,
                33.6055883
              ],
              [
                48.8617641,
                33.6110714
              ],
              [
                48.8404279,
                33.6232649
              ],
              [
                48.8158385,
                33.6317989
              ],
              [
                48.8133287,
                33.6302001
              ],
              [
                48.8104534,
                33.6260908
              ],
              [
                48.8061618,
                33.6231963
              ],
              [
                48.8010549,
                33.6205518
              ],
              [
                48.7980079,
                33.6201587
              ],
              [
                48.7907981,
                33.6178715
              ],
              [
                48.7864208,
                33.6158702
              ],
              [
                48.7820863,
                33.6127966
              ],
              [
                48.7792758,
                33.6096369
              ],
              [
                48.7774745,
                33.6070041
              ],
              [
                48.7674729,
                33.6085039
              ],
              [
                48.7625627,
                33.6091769
              ],
              [
                48.7522449,
                33.6106423
              ],
              [
                48.7498619,
                33.6107255
              ],
              [
                48.7499776,
                33.6072766
              ],
              [
                48.7456464,
                33.6076986
              ],
              [
                48.7435269,
                33.6082754
              ],
              [
                48.7406277,
                33.6098549
              ],
              [
                48.7377536,
                33.6138517
              ],
              [
                48.7302619,
                33.625519
              ],
              [
                48.7221114,
                33.6368905
              ],
              [
                48.7149238,
                33.6498509
              ],
              [
                48.7114042,
                33.6550741
              ],
              [
                48.707714,
                33.6615677
              ],
              [
                48.7014649,
                33.667914
              ],
              [
                48.6940455,
                33.6746018
              ],
              [
                48.6866979,
                33.6799225
              ],
              [
                48.6793854,
                33.6839561
              ],
              [
                48.674755,
                33.6906385
              ],
              [
                48.6724146,
                33.6984421
              ],
              [
                48.6634692,
                33.7092692
              ],
              [
                48.6509799,
                33.7242683
              ],
              [
                48.6451444,
                33.7349614
              ],
              [
                48.6423546,
                33.7395755
              ],
              [
                48.6398649,
                33.7450037
              ],
              [
                48.6382019,
                33.7476711
              ],
              [
                48.6379516,
                33.7486528
              ],
              [
                48.6234282,
                33.7600259
              ],
              [
                48.6144624,
                33.7632522
              ],
              [
                48.6021422,
                33.7688737
              ],
              [
                48.5997389,
                33.7804316
              ],
              [
                48.5899542,
                33.8095335
              ],
              [
                48.5745971,
                33.8412273
              ],
              [
                48.5656976,
                33.8600755
              ],
              [
                48.5477183,
                33.8637812
              ],
              [
                48.5353964,
                33.8704733
              ],
              [
                48.5310877,
                33.8806845
              ],
              [
                48.5188133,
                33.8785021
              ],
              [
                48.5179801,
                33.878502
              ],
              [
                48.5135368,
                33.8765608
              ],
              [
                48.5129801,
                33.8762809
              ],
              [
                48.5042233,
                33.8709453
              ],
              [
                48.5042233,
                33.8706653
              ],
              [
                48.5036701,
                33.8706652
              ],
              [
                48.4956441,
                33.8568894
              ],
              [
                48.495091,
                33.8563296
              ],
              [
                48.4873866,
                33.8511718
              ],
              [
                48.474484,
                33.8517219
              ],
              [
                48.4742074,
                33.851442
              ],
              [
                48.4672,
                33.8470826
              ],
              [
                48.4666433,
                33.8459722
              ],
              [
                48.446407,
                33.8479815
              ],
              [
                48.4336306,
                33.8385393
              ],
              [
                48.4327971,
                33.8382594
              ],
              [
                48.4177976,
                33.8227059
              ],
              [
                48.4175175,
                33.8221463
              ],
              [
                48.4122408,
                33.8138143
              ],
              [
                48.4002946,
                33.7904794
              ],
              [
                48.399461,
                33.7888183
              ],
              [
                48.3986278,
                33.7879788
              ],
              [
                48.3977946,
                33.7863178
              ],
              [
                48.3969613,
                33.7854783
              ],
              [
                48.3961278,
                33.7838173
              ],
              [
                48.3944613,
                33.7818675
              ],
              [
                48.3858514,
                33.7674239
              ],
              [
                48.3858514,
                33.7671441
              ],
              [
                48.3833513,
                33.7618722
              ],
              [
                48.3814048,
                33.7482591
              ],
              [
                48.3816849,
                33.7476995
              ],
              [
                48.3897379,
                33.7157518
              ],
              [
                48.3894614,
                33.7140907
              ],
              [
                48.3886282,
                33.7121498
              ],
              [
                48.3886281,
                33.7115901
              ],
              [
                48.3883516,
                33.7110394
              ],
              [
                48.3883516,
                33.7107596
              ],
              [
                48.3844617,
                33.7107596
              ],
              [
                48.3841847,
                33.7110395
              ],
              [
                48.3805717,
                33.7110394
              ],
              [
                48.3802949,
                33.7107596
              ],
              [
                48.3752951,
                33.7107596
              ],
              [
                48.3741849,
                33.7104797
              ],
              [
                48.3714052,
                33.7104797
              ],
              [
                48.3708486,
                33.7107595
              ],
              [
                48.370295,
                33.7104797
              ],
              [
                48.3700149,
                33.7107595
              ],
              [
                48.367795,
                33.7107595
              ],
              [
                48.3583487,
                33.7113102
              ],
              [
                48.356962,
                33.71159
              ],
              [
                48.3516822,
                33.71159
              ],
              [
                48.3514052,
                33.7118699
              ],
              [
                48.3391823,
                33.7118698
              ],
              [
                48.3383487,
                33.7121497
              ],
              [
                48.3366822,
                33.7121498
              ],
              [
                48.335849,
                33.7124205
              ],
              [
                48.3319591,
                33.7121497
              ],
              [
                48.3308489,
                33.7118699
              ],
              [
                48.3297356,
                33.7118698
              ],
              [
                48.3280688,
                33.7113102
              ],
              [
                48.326959,
                33.7113102
              ],
              [
                48.3258492,
                33.7107595
              ],
              [
                48.3044593,
                33.7071484
              ],
              [
                48.3027925,
                33.7068686
              ],
              [
                48.2969596,
                33.7068686
              ],
              [
                48.2950127,
                33.7068686
              ],
              [
                48.2914029,
                33.7068686
              ],
              [
                48.2908461,
                33.7065888
              ],
              [
                48.2886226,
                33.7065888
              ],
              [
                48.2877894,
                33.7063089
              ],
              [
                48.2864028,
                33.7063089
              ],
              [
                48.2855694,
                33.706029
              ],
              [
                48.2841796,
                33.706029
              ],
              [
                48.2466765,
                33.6968661
              ],
              [
                48.2458434,
                33.6968661
              ],
              [
                48.2438999,
                33.6960356
              ],
              [
                48.23362,
                33.6899239
              ],
              [
                48.2294536,
                33.6821423
              ],
              [
                48.2294536,
                33.6818624
              ],
              [
                48.2275102,
                33.6735301
              ],
              [
                48.2250106,
                33.6660281
              ],
              [
                48.222234,
                33.6615866
              ],
              [
                48.2141772,
                33.6538138
              ],
              [
                48.2052872,
                33.6527034
              ],
              [
                48.2038973,
                33.6529742
              ],
              [
                48.1972307,
                33.6549243
              ],
              [
                48.1966741,
                33.655195
              ],
              [
                48.1519513,
                33.6838122
              ],
              [
                48.1502848,
                33.6852024
              ],
              [
                48.1497278,
                33.6854823
              ],
              [
                48.1488945,
                33.6860329
              ],
              [
                48.0911151,
                33.7207613
              ],
              [
                48.0897252,
                33.7213119
              ],
              [
                48.0786153,
                33.7260333
              ],
              [
                48.0777821,
                33.7260332
              ],
              [
                48.077502,
                33.7263131
              ],
              [
                48.0766688,
                33.7263131
              ],
              [
                48.0761157,
                33.726593
              ],
              [
                48.0727823,
                33.7265929
              ],
              [
                48.0722257,
                33.7264061
              ],
              [
                48.0717156,
                33.7261959
              ],
              [
                48.0680588,
                33.7243632
              ],
              [
                48.0488894,
                33.6885333
              ],
              [
                48.0486125,
                33.6879736
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555019,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دلفان",
          "name:en": "Delfan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279548",
          "wikipedia": "en:Delfan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.4281223,
                34.0874322
              ],
              [
                47.4280291,
                34.0871524
              ],
              [
                47.4266392,
                34.0843725
              ],
              [
                47.4241392,
                34.0763123
              ],
              [
                47.4255259,
                34.0746515
              ],
              [
                47.423583,
                34.0682611
              ],
              [
                47.4233056,
                34.0660407
              ],
              [
                47.423583,
                34.0646507
              ],
              [
                47.4263596,
                34.0604807
              ],
              [
                47.4324726,
                34.0554893
              ],
              [
                47.4327492,
                34.0546499
              ],
              [
                47.4349727,
                34.05159
              ],
              [
                47.4360825,
                34.0493787
              ],
              [
                47.4360825,
                34.048819
              ],
              [
                47.4371958,
                34.046039
              ],
              [
                47.4408057,
                34.0410385
              ],
              [
                47.4410826,
                34.0404789
              ],
              [
                47.4424725,
                34.0388181
              ],
              [
                47.4430291,
                34.0382675
              ],
              [
                47.4455292,
                34.0352076
              ],
              [
                47.4452492,
                34.0310376
              ],
              [
                47.4485859,
                34.0265967
              ],
              [
                47.4491392,
                34.0265967
              ],
              [
                47.4496958,
                34.026037
              ],
              [
                47.4583057,
                34.0221467
              ],
              [
                47.4596955,
                34.020486
              ],
              [
                47.4635855,
                34.0113153
              ],
              [
                47.4635856,
                34.0107647
              ],
              [
                47.4644192,
                34.0090948
              ],
              [
                47.4666423,
                34.0077048
              ],
              [
                47.4674755,
                34.0077048
              ],
              [
                47.4730287,
                34.010485
              ],
              [
                47.4749756,
                34.006044
              ],
              [
                47.4763619,
                34.0043741
              ],
              [
                47.4769187,
                34.0043742
              ],
              [
                47.4771956,
                34.0040943
              ],
              [
                47.478862,
                34.0040943
              ],
              [
                47.4791421,
                34.0038145
              ],
              [
                47.480809,
                34.003264
              ],
              [
                47.4813621,
                34.0018739
              ],
              [
                47.481362,
                33.9999243
              ],
              [
                47.4816422,
                33.9927031
              ],
              [
                47.4841423,
                33.9888128
              ],
              [
                47.4883088,
                33.9846516
              ],
              [
                47.4960852,
                33.979651
              ],
              [
                47.4980321,
                33.9771508
              ],
              [
                47.4983086,
                33.9763113
              ],
              [
                47.4985851,
                33.9757608
              ],
              [
                47.4983086,
                33.9729806
              ],
              [
                47.4974754,
                33.9718703
              ],
              [
                47.4924754,
                33.964929
              ],
              [
                47.4882605,
                33.9565067
              ],
              [
                47.4902346,
                33.9567902
              ],
              [
                47.4914448,
                33.9566407
              ],
              [
                47.4938395,
                33.9558291
              ],
              [
                47.4969809,
                33.9552737
              ],
              [
                47.4990408,
                33.9560213
              ],
              [
                47.5012553,
                33.9559572
              ],
              [
                47.502826,
                33.9549747
              ],
              [
                47.5046542,
                33.953266
              ],
              [
                47.5077183,
                33.9511942
              ],
              [
                47.5236056,
                33.9463028
              ],
              [
                47.5293219,
                33.9436968
              ],
              [
                47.5312273,
                33.9419024
              ],
              [
                47.5366604,
                33.9395099
              ],
              [
                47.5463936,
                33.9358355
              ],
              [
                47.5602724,
                33.9297254
              ],
              [
                47.5741513,
                33.9237644
              ],
              [
                47.5770352,
                33.9225252
              ],
              [
                47.5838845,
                33.9193415
              ],
              [
                47.5875924,
                33.9174184
              ],
              [
                47.6003897,
                33.9108583
              ],
              [
                47.6046641,
                33.9090846
              ],
              [
                47.6117709,
                33.9055157
              ],
              [
                47.6156332,
                33.9032077
              ],
              [
                47.6215298,
                33.900985
              ],
              [
                47.6267826,
                33.8976723
              ],
              [
                47.6284821,
                33.8972021
              ],
              [
                47.6357434,
                33.894103
              ],
              [
                47.6417429,
                33.8908969
              ],
              [
                47.6587889,
                33.8837789
              ],
              [
                47.6690113,
                33.8791187
              ],
              [
                47.6767876,
                33.8751638
              ],
              [
                47.6798679,
                33.8732117
              ],
              [
                47.6824834,
                33.8710344
              ],
              [
                47.6835967,
                33.8710344
              ],
              [
                47.6885968,
                33.8693734
              ],
              [
                47.6888734,
                33.8690937
              ],
              [
                47.6894301,
                33.8690936
              ],
              [
                47.6897066,
                33.8688138
              ],
              [
                47.6897066,
                33.8690936
              ],
              [
                47.6902633,
                33.8688138
              ],
              [
                47.6909565,
                33.8686739
              ],
              [
                47.6924867,
                33.8682632
              ],
              [
                47.6960966,
                33.8665932
              ],
              [
                47.6960966,
                33.8663133
              ],
              [
                47.6966532,
                33.8663134
              ],
              [
                47.6972063,
                33.8657537
              ],
              [
                47.7113762,
                33.8618723
              ],
              [
                47.7119298,
                33.8618722
              ],
              [
                47.7122098,
                33.8615924
              ],
              [
                47.7125902,
                33.8615924
              ],
              [
                47.7141528,
                33.8610327
              ],
              [
                47.7147095,
                33.8610327
              ],
              [
                47.7147095,
                33.8607619
              ],
              [
                47.7174861,
                33.859092
              ],
              [
                47.7180432,
                33.8588122
              ],
              [
                47.7485993,
                33.8449289
              ],
              [
                47.7549893,
                33.8421485
              ],
              [
                47.779989,
                33.833537
              ],
              [
                47.784432,
                33.8329863
              ],
              [
                47.7872122,
                33.8338168
              ],
              [
                47.7899888,
                33.8349271
              ],
              [
                47.7941553,
                33.8363173
              ],
              [
                47.7949886,
                33.8368679
              ],
              [
                47.7966553,
                33.8371478
              ],
              [
                47.7974886,
                33.8371478
              ],
              [
                47.7988789,
                33.8377074
              ],
              [
                47.7999886,
                33.8377075
              ],
              [
                47.8027687,
                33.8382581
              ],
              [
                47.8127685,
                33.8390886
              ],
              [
                47.8133252,
                33.8393684
              ],
              [
                47.8163784,
                33.8393684
              ],
              [
                47.8172116,
                33.8396483
              ],
              [
                47.823045,
                33.8396482
              ],
              [
                47.831935,
                33.8382582
              ],
              [
                47.8336014,
                33.8382582
              ],
              [
                47.844715,
                33.8363174
              ],
              [
                47.8461048,
                33.8365882
              ],
              [
                47.8708279,
                33.8463102
              ],
              [
                47.881661,
                33.8474295
              ],
              [
                47.8863841,
                33.8477004
              ],
              [
                47.8874943,
                33.8479802
              ],
              [
                47.8997172,
                33.8457597
              ],
              [
                47.9030508,
                33.8452
              ],
              [
                47.9127736,
                33.8426996
              ],
              [
                47.9141605,
                33.8426996
              ],
              [
                47.9149937,
                33.8424198
              ],
              [
                47.9177738,
                33.8424198
              ],
              [
                47.9180504,
                33.8421489
              ],
              [
                47.9238837,
                33.8424197
              ],
              [
                47.924997,
                33.8426996
              ],
              [
                47.9294404,
                33.8426996
              ],
              [
                47.9449966,
                33.84381
              ],
              [
                47.9549968,
                33.8465903
              ],
              [
                47.9563867,
                33.8468701
              ],
              [
                47.9627766,
                33.8499302
              ],
              [
                47.9638864,
                33.8502011
              ],
              [
                47.9644431,
                33.8507607
              ],
              [
                47.9719432,
                33.8538119
              ],
              [
                47.973053,
                33.8546513
              ],
              [
                47.9894427,
                33.8618728
              ],
              [
                47.9908313,
                33.8622881
              ],
              [
                47.9919428,
                33.8629832
              ],
              [
                47.9938894,
                33.8635428
              ],
              [
                47.9944428,
                33.8638137
              ],
              [
                47.9944429,
                33.8640935
              ],
              [
                47.9994591,
                33.8716482
              ],
              [
                48.0022227,
                33.8771463
              ],
              [
                48.0177792,
                33.8865974
              ],
              [
                48.0180558,
                33.8868681
              ],
              [
                48.030279,
                33.9007603
              ],
              [
                48.032222,
                33.907422
              ],
              [
                48.0380552,
                33.919933
              ],
              [
                48.0403972,
                33.9223331
              ],
              [
                48.0609032,
                33.9311278
              ],
              [
                48.0725734,
                33.9434125
              ],
              [
                48.0832479,
                33.958909
              ],
              [
                48.0869451,
                33.9599625
              ],
              [
                48.1024196,
                33.9643709
              ],
              [
                48.1229405,
                33.9614176
              ],
              [
                48.1508631,
                33.9529374
              ],
              [
                48.1722453,
                33.9487125
              ],
              [
                48.1886198,
                33.9519397
              ],
              [
                48.1938439,
                33.9529689
              ],
              [
                48.2111566,
                33.9511575
              ],
              [
                48.2392905,
                33.9511426
              ],
              [
                48.2695624,
                33.966212
              ],
              [
                48.2853508,
                33.9829267
              ],
              [
                48.3205681,
                33.9993755
              ],
              [
                48.3294581,
                34.0090969
              ],
              [
                48.3322347,
                34.0138176
              ],
              [
                48.3327914,
                34.014648
              ],
              [
                48.3325148,
                34.0149278
              ],
              [
                48.3319582,
                34.0149278
              ],
              [
                48.3250146,
                34.0165976
              ],
              [
                48.3230681,
                34.0165976
              ],
              [
                48.3227915,
                34.0168774
              ],
              [
                48.304735,
                34.0213183
              ],
              [
                48.3041783,
                34.0227084
              ],
              [
                48.3039017,
                34.0265987
              ],
              [
                48.3036251,
                34.0268694
              ],
              [
                48.3039017,
                34.0285393
              ],
              [
                48.3047348,
                34.0379897
              ],
              [
                48.3047348,
                34.0390999
              ],
              [
                48.3050114,
                34.0413202
              ],
              [
                48.305845,
                34.0546519
              ],
              [
                48.305568,
                34.0552115
              ],
              [
                48.3052915,
                34.0554912
              ],
              [
                48.3052915,
                34.055762
              ],
              [
                48.3044582,
                34.0566015
              ],
              [
                48.3030684,
                34.0568723
              ],
              [
                48.3025117,
                34.0566015
              ],
              [
                48.3011249,
                34.0566015
              ],
              [
                48.2994582,
                34.0560419
              ],
              [
                48.2983449,
                34.0560419
              ],
              [
                48.2930682,
                34.0549316
              ],
              [
                48.2905686,
                34.0549316
              ],
              [
                48.2897349,
                34.0546518
              ],
              [
                48.2880685,
                34.0546518
              ],
              [
                48.2866786,
                34.054372
              ],
              [
                48.2752886,
                34.054372
              ],
              [
                48.2741787,
                34.0540921
              ],
              [
                48.255842,
                34.0515919
              ],
              [
                48.2538987,
                34.0507615
              ],
              [
                48.2461223,
                34.0491006
              ],
              [
                48.2405656,
                34.0491006
              ],
              [
                48.2358424,
                34.0507614
              ],
              [
                48.2344526,
                34.0513211
              ],
              [
                48.2308423,
                34.0543719
              ],
              [
                48.2177858,
                34.0657627
              ],
              [
                48.2152862,
                34.0671527
              ],
              [
                48.2147294,
                34.0674326
              ],
              [
                48.193063,
                34.0788233
              ],
              [
                48.1916727,
                34.0790941
              ],
              [
                48.1880628,
                34.079094
              ],
              [
                48.1869531,
                34.0796536
              ],
              [
                48.1861194,
                34.0804931
              ],
              [
                48.1772298,
                34.086044
              ],
              [
                48.1769497,
                34.0868744
              ],
              [
                48.1763966,
                34.087434
              ],
              [
                48.1747297,
                34.0918747
              ],
              [
                48.1693972,
                34.1027568
              ],
              [
                48.1688964,
                34.1032654
              ],
              [
                48.1686163,
                34.1040958
              ],
              [
                48.167783,
                34.1049352
              ],
              [
                48.1675065,
                34.1057655
              ],
              [
                48.1538933,
                34.1207665
              ],
              [
                48.1527831,
                34.1221563
              ],
              [
                48.1447266,
                34.1338177
              ],
              [
                48.1377835,
                34.1410472
              ],
              [
                48.1372268,
                34.141327
              ],
              [
                48.1369499,
                34.1415978
              ],
              [
                48.1363932,
                34.1415977
              ],
              [
                48.1358366,
                34.1421574
              ],
              [
                48.1294501,
                34.1449373
              ],
              [
                48.1291701,
                34.1452171
              ],
              [
                48.1286169,
                34.145217
              ],
              [
                48.1280602,
                34.145217
              ],
              [
                48.1275036,
                34.1454878
              ],
              [
                48.1263934,
                34.1454878
              ],
              [
                48.1258367,
                34.1457676
              ],
              [
                48.1238933,
                34.1457676
              ],
              [
                48.1233367,
                34.1454878
              ],
              [
                48.1130603,
                34.1454877
              ],
              [
                48.1122271,
                34.1457676
              ],
              [
                48.1108368,
                34.1457676
              ],
              [
                48.1080603,
                34.1465979
              ],
              [
                48.100837,
                34.1535476
              ],
              [
                48.0933372,
                34.1671582
              ],
              [
                48.0916704,
                34.1685482
              ],
              [
                48.0900039,
                34.1702088
              ],
              [
                48.0822241,
                34.1760484
              ],
              [
                48.0822241,
                34.1763281
              ],
              [
                48.0817616,
                34.1766932
              ],
              [
                48.0811139,
                34.1771585
              ],
              [
                48.0722242,
                34.1946589
              ],
              [
                48.0722242,
                34.1954892
              ],
              [
                48.0705574,
                34.1990994
              ],
              [
                48.0558344,
                34.2099299
              ],
              [
                48.0547242,
                34.2115996
              ],
              [
                48.053891,
                34.2127187
              ],
              [
                48.0477776,
                34.2154894
              ],
              [
                48.0466678,
                34.2154894
              ],
              [
                48.0463876,
                34.2157692
              ],
              [
                48.0452775,
                34.2157692
              ],
              [
                48.0444443,
                34.216049
              ],
              [
                48.0433345,
                34.216049
              ],
              [
                48.0427778,
                34.2163288
              ],
              [
                48.0388875,
                34.2168793
              ],
              [
                48.0286112,
                34.2168793
              ],
              [
                48.0283311,
                34.2171591
              ],
              [
                48.0272212,
                34.217159
              ],
              [
                48.0269447,
                34.2168793
              ],
              [
                48.0216645,
                34.2168793
              ],
              [
                48.0211113,
                34.2171591
              ],
              [
                48.0191644,
                34.217159
              ],
              [
                48.0130546,
                34.219659
              ],
              [
                48.0119413,
                34.2202096
              ],
              [
                48.0105549,
                34.2207692
              ],
              [
                48.0077748,
                34.2207692
              ],
              [
                48.0074982,
                34.221049
              ],
              [
                48.0055548,
                34.221049
              ],
              [
                48.0047216,
                34.2207692
              ],
              [
                48.0005546,
                34.2207691
              ],
              [
                47.999997,
                34.218371
              ],
              [
                47.9852751,
                34.222159
              ],
              [
                47.9727752,
                34.2291084
              ],
              [
                47.9713853,
                34.2293792
              ],
              [
                47.9711083,
                34.2293792
              ],
              [
                47.9705517,
                34.2293792
              ],
              [
                47.9697185,
                34.2293792
              ],
              [
                47.9647187,
                34.2313286
              ],
              [
                47.9449953,
                34.2440993
              ],
              [
                47.9436054,
                34.244379
              ],
              [
                47.9386057,
                34.2457689
              ],
              [
                47.935549,
                34.245769
              ],
              [
                47.9349954,
                34.2454892
              ],
              [
                47.9316622,
                34.2454891
              ],
              [
                47.9311055,
                34.2452094
              ],
              [
                47.9230491,
                34.2440992
              ],
              [
                47.9113825,
                34.2407689
              ],
              [
                47.9083258,
                34.2399386
              ],
              [
                47.9077727,
                34.2399386
              ],
              [
                47.9049925,
                34.2388285
              ],
              [
                47.9041593,
                34.2388285
              ],
              [
                47.9033261,
                34.2385487
              ],
              [
                47.9002729,
                34.2385487
              ],
              [
                47.9002729,
                34.2388285
              ],
              [
                47.889993,
                34.2502093
              ],
              [
                47.889993,
                34.2507688
              ],
              [
                47.8874929,
                34.2540991
              ],
              [
                47.8874929,
                34.2543789
              ],
              [
                47.8872163,
                34.2546586
              ],
              [
                47.8866593,
                34.2552092
              ],
              [
                47.8863827,
                34.2554889
              ],
              [
                47.874713,
                34.2635483
              ],
              [
                47.8522132,
                34.2746581
              ],
              [
                47.8483233,
                34.2785479
              ],
              [
                47.8477697,
                34.279658
              ],
              [
                47.8472131,
                34.2799378
              ],
              [
                47.8461033,
                34.2824377
              ],
              [
                47.8461034,
                34.283268
              ],
              [
                47.8391566,
                34.2991068
              ],
              [
                47.8391566,
                34.2996573
              ],
              [
                47.8380464,
                34.3038268
              ],
              [
                47.8330467,
                34.3188262
              ],
              [
                47.8280466,
                34.3238259
              ],
              [
                47.8091571,
                34.3335455
              ],
              [
                47.8049901,
                34.3346556
              ],
              [
                47.7966536,
                34.3366049
              ],
              [
                47.784987,
                34.3407652
              ],
              [
                47.780544,
                34.3429944
              ],
              [
                47.7660971,
                34.3532645
              ],
              [
                47.7658206,
                34.3535442
              ],
              [
                47.7652639,
                34.3535442
              ],
              [
                47.7630409,
                34.354934
              ],
              [
                47.7619306,
                34.3554935
              ],
              [
                47.7319312,
                34.3727124
              ],
              [
                47.7308178,
                34.3727124
              ],
              [
                47.7291511,
                34.3732719
              ],
              [
                47.7280412,
                34.3732719
              ],
              [
                47.7252611,
                34.3741021
              ],
              [
                47.7238743,
                34.3741021
              ],
              [
                47.7085947,
                34.3777119
              ],
              [
                47.7052614,
                34.3777119
              ],
              [
                47.7047048,
                34.3779917
              ],
              [
                47.7016512,
                34.3779917
              ],
              [
                47.7010946,
                34.3782714
              ],
              [
                47.7002613,
                34.3782714
              ],
              [
                47.6999847,
                34.3779916
              ],
              [
                47.6969281,
                34.3766019
              ],
              [
                47.6952616,
                34.3754918
              ],
              [
                47.6949846,
                34.3752121
              ],
              [
                47.6930381,
                34.3735515
              ],
              [
                47.6927616,
                34.3732718
              ],
              [
                47.6799817,
                34.359383
              ],
              [
                47.6791485,
                34.3560528
              ],
              [
                47.6788719,
                34.3510532
              ],
              [
                47.6791485,
                34.3493836
              ],
              [
                47.6794286,
                34.3477141
              ],
              [
                47.6797052,
                34.3463243
              ],
              [
                47.6805385,
                34.3424346
              ],
              [
                47.6808149,
                34.3416043
              ],
              [
                47.681095,
                34.3402146
              ],
              [
                47.683315,
                34.332715
              ],
              [
                47.6833151,
                34.3324353
              ],
              [
                47.6833151,
                34.3299354
              ],
              [
                47.6835952,
                34.3293849
              ],
              [
                47.6835952,
                34.3285455
              ],
              [
                47.6835951,
                34.3274355
              ],
              [
                47.6977616,
                34.2896574
              ],
              [
                47.6980385,
                34.2890978
              ],
              [
                47.6977616,
                34.2874372
              ],
              [
                47.6974851,
                34.2827171
              ],
              [
                47.695262,
                34.2774375
              ],
              [
                47.6944284,
                34.2760476
              ],
              [
                47.6519256,
                34.237438
              ],
              [
                47.6499826,
                34.2354885
              ],
              [
                47.6497026,
                34.234938
              ],
              [
                47.640536,
                34.2271582
              ],
              [
                47.6397028,
                34.2271582
              ],
              [
                47.6386088,
                34.2265663
              ],
              [
                47.629426,
                34.2215986
              ],
              [
                47.6280362,
                34.2215986
              ],
              [
                47.6274795,
                34.2213189
              ],
              [
                47.6222029,
                34.2213188
              ],
              [
                47.6213696,
                34.2215986
              ],
              [
                47.6197028,
                34.2215986
              ],
              [
                47.6180364,
                34.2221581
              ],
              [
                47.6147031,
                34.2224289
              ],
              [
                47.6141464,
                34.2221581
              ],
              [
                47.6124797,
                34.2221582
              ],
              [
                47.5944234,
                34.2132681
              ],
              [
                47.5785904,
                34.1965983
              ],
              [
                47.5763669,
                34.1935476
              ],
              [
                47.5649772,
                34.1821484
              ],
              [
                47.5605338,
                34.180208
              ],
              [
                47.559424,
                34.1802079
              ],
              [
                47.5577537,
                34.1796574
              ],
              [
                47.5552539,
                34.1796574
              ],
              [
                47.5541438,
                34.1793776
              ],
              [
                47.5524774,
                34.1793776
              ],
              [
                47.5513672,
                34.1796573
              ],
              [
                47.5474773,
                34.1799281
              ],
              [
                47.5291441,
                34.185208
              ],
              [
                47.5116706,
                34.1873297
              ],
              [
                47.5217055,
                34.1797137
              ],
              [
                47.5297735,
                34.1694882
              ],
              [
                47.5337218,
                34.1628126
              ],
              [
                47.526512,
                34.1537215
              ],
              [
                47.5160406,
                34.1486074
              ],
              [
                47.5071142,
                34.1406514
              ],
              [
                47.5014494,
                34.1321263
              ],
              [
                47.5035093,
                34.1236003
              ],
              [
                47.5091742,
                34.1157841
              ],
              [
                47.5085623,
                34.104413
              ],
              [
                47.503681,
                34.0946057
              ],
              [
                47.4935676,
                34.0896517
              ],
              [
                47.4820517,
                34.0893458
              ],
              [
                47.4692065,
                34.0919711
              ],
              [
                47.4489955,
                34.093029
              ],
              [
                47.432196,
                34.0965936
              ],
              [
                47.4319159,
                34.0963137
              ],
              [
                47.4291393,
                34.0896527
              ],
              [
                47.4288627,
                34.0888223
              ],
              [
                47.4281223,
                34.0874322
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555027,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چگنی",
          "name:en": "Chegeni county",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610703"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.6767876,
                33.8751638
              ],
              [
                47.6719982,
                33.8689211
              ],
              [
                47.6639645,
                33.8623572
              ],
              [
                47.6601794,
                33.8581663
              ],
              [
                47.6545918,
                33.8549375
              ],
              [
                47.6511929,
                33.8505752
              ],
              [
                47.648721,
                33.8473246
              ],
              [
                47.647806,
                33.8444608
              ],
              [
                47.647484,
                33.8290954
              ],
              [
                47.6460941,
                33.8263151
              ],
              [
                47.6280376,
                33.8007504
              ],
              [
                47.6269279,
                33.7949279
              ],
              [
                47.627481,
                33.7924275
              ],
              [
                47.6294276,
                33.7893673
              ],
              [
                47.631371,
                33.7874264
              ],
              [
                47.6324807,
                33.7854766
              ],
              [
                47.6344277,
                33.7824254
              ],
              [
                47.6408176,
                33.7740933
              ],
              [
                47.6419274,
                33.7721435
              ],
              [
                47.6433177,
                33.7688125
              ],
              [
                47.6438709,
                33.7657523
              ],
              [
                47.644151,
                33.7538093
              ],
              [
                47.6410943,
                33.7446466
              ],
              [
                47.639151,
                33.7396454
              ],
              [
                47.639151,
                33.7354748
              ],
              [
                47.6491509,
                33.7207603
              ],
              [
                47.6574842,
                33.7115886
              ],
              [
                47.6716506,
                33.6971447
              ],
              [
                47.6747073,
                33.6943642
              ],
              [
                47.6774839,
                33.6915838
              ],
              [
                47.6810973,
                33.6885325
              ],
              [
                47.7086106,
                33.6625148
              ],
              [
                47.7169301,
                33.6546432
              ],
              [
                47.7322102,
                33.6354777
              ],
              [
                47.73582,
                33.6315868
              ],
              [
                47.7358201,
                33.6310271
              ],
              [
                47.7366532,
                33.6299257
              ],
              [
                47.7369334,
                33.6288153
              ],
              [
                47.7372103,
                33.627416
              ],
              [
                47.7383201,
                33.6251952
              ],
              [
                47.7383201,
                33.6240848
              ],
              [
                47.7383201,
                33.623805
              ],
              [
                47.7383201,
                33.6232542
              ],
              [
                47.7380435,
                33.621864
              ],
              [
                47.7380436,
                33.6215844
              ],
              [
                47.7380436,
                33.6215843
              ],
              [
                47.737767,
                33.6182529
              ],
              [
                47.7358201,
                33.6146419
              ],
              [
                47.7233203,
                33.5996467
              ],
              [
                47.7233203,
                33.599087
              ],
              [
                47.7230437,
                33.5985273
              ],
              [
                47.7224871,
                33.5954759
              ],
              [
                47.7224871,
                33.5924156
              ],
              [
                47.7244306,
                33.5863037
              ],
              [
                47.7316537,
                33.5760301
              ],
              [
                47.7424868,
                33.5701982
              ],
              [
                47.7838798,
                33.551032
              ],
              [
                47.7892616,
                33.5478623
              ],
              [
                47.7930983,
                33.546639
              ],
              [
                47.7958792,
                33.5445574
              ],
              [
                47.7962397,
                33.5427117
              ],
              [
                47.7918108,
                33.5380759
              ],
              [
                47.7880257,
                33.5366165
              ],
              [
                47.7859142,
                33.5349209
              ],
              [
                47.7842405,
                33.533118
              ],
              [
                47.7838028,
                33.5317014
              ],
              [
                47.7818716,
                33.5277304
              ],
              [
                47.7818459,
                33.5260132
              ],
              [
                47.7810219,
                33.5245321
              ],
              [
                47.7806872,
                33.5236734
              ],
              [
                47.7808417,
                33.5224713
              ],
              [
                47.7814081,
                33.5200671
              ],
              [
                47.7810219,
                33.5184785
              ],
              [
                47.7807129,
                33.515151
              ],
              [
                47.7766445,
                33.5064774
              ],
              [
                47.7787116,
                33.5044372
              ],
              [
                47.7803338,
                33.504201
              ],
              [
                47.7844279,
                33.5039004
              ],
              [
                47.7857926,
                33.502741
              ],
              [
                47.7925647,
                33.499327
              ],
              [
                47.7960666,
                33.4980172
              ],
              [
                47.7995942,
                33.497781
              ],
              [
                47.8053077,
                33.496338
              ],
              [
                47.8079867,
                33.4963807
              ],
              [
                47.8114629,
                33.4958869
              ],
              [
                47.8123383,
                33.4948347
              ],
              [
                47.8128276,
                33.4937181
              ],
              [
                47.8150678,
                33.4928591
              ],
              [
                47.8180547,
                33.4927303
              ],
              [
                47.8271441,
                33.4927947
              ],
              [
                47.8323712,
                33.4926229
              ],
              [
                47.8364653,
                33.4929236
              ],
              [
                47.8394265,
                33.4919572
              ],
              [
                47.8412289,
                33.4912056
              ],
              [
                47.8446536,
                33.4870181
              ],
              [
                47.8457351,
                33.4855792
              ],
              [
                47.8536401,
                33.4787713
              ],
              [
                47.8576312,
                33.4765376
              ],
              [
                47.8606438,
                33.4744972
              ],
              [
                47.8661284,
                33.4724353
              ],
              [
                47.8693342,
                33.4710525
              ],
              [
                47.8706989,
                33.4704296
              ],
              [
                47.8762607,
                33.466864
              ],
              [
                47.8780889,
                33.4655322
              ],
              [
                47.8805351,
                33.4646086
              ],
              [
                47.882801,
                33.4632553
              ],
              [
                47.8889293,
                33.4603553
              ],
              [
                47.8988685,
                33.4546195
              ],
              [
                47.9034004,
                33.4511392
              ],
              [
                47.9115114,
                33.4476587
              ],
              [
                47.9160175,
                33.4448871
              ],
              [
                47.9184894,
                33.4438128
              ],
              [
                47.9306259,
                33.4472576
              ],
              [
                47.9377439,
                33.4473804
              ],
              [
                47.9400227,
                33.4471727
              ],
              [
                47.943031,
                33.4478639
              ],
              [
                47.9445245,
                33.4477063
              ],
              [
                47.9452412,
                33.4477385
              ],
              [
                47.9457562,
                33.448093
              ],
              [
                47.946932,
                33.4488772
              ],
              [
                47.9476015,
                33.4513694
              ],
              [
                47.9507687,
                33.4584588
              ],
              [
                47.9518244,
                33.4595544
              ],
              [
                47.9540903,
                33.4608218
              ],
              [
                47.9613258,
                33.4603492
              ],
              [
                47.9664757,
                33.4604136
              ],
              [
                47.9758523,
                33.4591336
              ],
              [
                47.9832033,
                33.4589439
              ],
              [
                47.9866027,
                33.4587001
              ],
              [
                47.9953286,
                33.4578149
              ],
              [
                47.9974722,
                33.4576885
              ],
              [
                48.0000005,
                33.4568612
              ],
              [
                48.006944,
                33.4529701
              ],
              [
                48.0175005,
                33.4471379
              ],
              [
                48.0183337,
                33.4471379
              ],
              [
                48.0186137,
                33.446858
              ],
              [
                48.0236139,
                33.4451969
              ],
              [
                48.0252804,
                33.4451968
              ],
              [
                48.0252804,
                33.444917
              ],
              [
                48.0272237,
                33.444917
              ],
              [
                48.0277804,
                33.4446371
              ],
              [
                48.0500035,
                33.440755
              ],
              [
                48.0600033,
                33.4357534
              ],
              [
                48.0874156,
                33.4292925
              ],
              [
                48.0927464,
                33.4271645
              ],
              [
                48.0964186,
                33.4236788
              ],
              [
                48.0982303,
                33.4217709
              ],
              [
                48.0991744,
                33.4191202
              ],
              [
                48.0995187,
                33.4113117
              ],
              [
                48.0979681,
                33.4031515
              ],
              [
                48.0961848,
                33.397511
              ],
              [
                48.0945623,
                33.3865367
              ],
              [
                48.094648,
                33.3715706
              ],
              [
                48.0956346,
                33.3506292
              ],
              [
                48.095984,
                33.3480934
              ],
              [
                48.0956211,
                33.3441166
              ],
              [
                48.0958493,
                33.3406128
              ],
              [
                48.0962562,
                33.3387211
              ],
              [
                48.0970038,
                33.3371796
              ],
              [
                48.1056535,
                33.33725
              ],
              [
                48.1164075,
                33.338173
              ],
              [
                48.1273743,
                33.3391826
              ],
              [
                48.13385,
                33.3397071
              ],
              [
                48.1397339,
                33.3416068
              ],
              [
                48.1471153,
                33.3455926
              ],
              [
                48.1546267,
                33.3492482
              ],
              [
                48.1612166,
                33.3567616
              ],
              [
                48.1765578,
                33.3645815
              ],
              [
                48.1827734,
                33.3652305
              ],
              [
                48.2148741,
                33.3764125
              ],
              [
                48.2230281,
                33.3815012
              ],
              [
                48.2269763,
                33.387593
              ],
              [
                48.2265472,
                33.3933977
              ],
              [
                48.2240152,
                33.3967657
              ],
              [
                48.2157325,
                33.3992379
              ],
              [
                48.2105827,
                33.4038596
              ],
              [
                48.2093052,
                33.408576
              ],
              [
                48.2122472,
                33.41153
              ],
              [
                48.2207536,
                33.4164337
              ],
              [
                48.2282976,
                33.421662
              ],
              [
                48.2300663,
                33.4267137
              ],
              [
                48.2319466,
                33.4423142
              ],
              [
                48.225638,
                33.4420651
              ],
              [
                48.2236878,
                33.4428105
              ],
              [
                48.2215659,
                33.4426906
              ],
              [
                48.2192509,
                33.4442571
              ],
              [
                48.2216119,
                33.4490605
              ],
              [
                48.2249825,
                33.4535903
              ],
              [
                48.2257355,
                33.4577286
              ],
              [
                48.2253921,
                33.4601348
              ],
              [
                48.2247723,
                33.464129
              ],
              [
                48.2238798,
                33.4703286
              ],
              [
                48.2148313,
                33.4748023
              ],
              [
                48.2093136,
                33.4786895
              ],
              [
                48.1974935,
                33.4935936
              ],
              [
                48.1945753,
                33.4948462
              ],
              [
                48.1846469,
                33.5008311
              ],
              [
                48.1844164,
                33.5007871
              ],
              [
                48.1880283,
                33.5047872
              ],
              [
                48.1988005,
                33.5155961
              ],
              [
                48.2012701,
                33.5222202
              ],
              [
                48.2068061,
                33.5246888
              ],
              [
                48.2110118,
                33.5247961
              ],
              [
                48.2132591,
                33.5213327
              ],
              [
                48.219481,
                33.5216476
              ],
              [
                48.2231868,
                33.52335
              ],
              [
                48.2256017,
                33.5243596
              ],
              [
                48.2355931,
                33.5352331
              ],
              [
                48.2437773,
                33.5437799
              ],
              [
                48.2473293,
                33.5472449
              ],
              [
                48.2447524,
                33.5520005
              ],
              [
                48.238836,
                33.5576268
              ],
              [
                48.233446,
                33.5629845
              ],
              [
                48.234454,
                33.5774215
              ],
              [
                48.2339004,
                33.5779722
              ],
              [
                48.2188974,
                33.5910353
              ],
              [
                48.2072307,
                33.6004784
              ],
              [
                48.206121,
                33.6010291
              ],
              [
                48.2038974,
                33.6032589
              ],
              [
                48.1950074,
                33.608811
              ],
              [
                48.1922308,
                33.6099213
              ],
              [
                48.1919543,
                33.6101922
              ],
              [
                48.191121,
                33.6107519
              ],
              [
                48.1830646,
                33.6146428
              ],
              [
                48.1827877,
                33.6152026
              ],
              [
                48.1666747,
                33.6240857
              ],
              [
                48.1658412,
                33.6249163
              ],
              [
                48.156118,
                33.6296377
              ],
              [
                48.1552847,
                33.6296378
              ],
              [
                48.1533412,
                33.6304773
              ],
              [
                48.1519514,
                33.6304773
              ],
              [
                48.1475084,
                33.6318675
              ],
              [
                48.1405617,
                33.6332487
              ],
              [
                48.1394516,
                33.6335376
              ],
              [
                48.1358382,
                33.6343592
              ],
              [
                48.0847254,
                33.6632564
              ],
              [
                48.0841687,
                33.6635362
              ],
              [
                48.055836,
                33.6807517
              ],
              [
                48.0488895,
                33.687423
              ],
              [
                48.0486125,
                33.6879736
              ],
              [
                48.0483358,
                33.6877028
              ],
              [
                48.0480558,
                33.6871431
              ],
              [
                48.0472226,
                33.6871431
              ],
              [
                48.0469459,
                33.6868633
              ],
              [
                48.0416694,
                33.6868633
              ],
              [
                48.0322227,
                33.6879736
              ],
              [
                48.0249994,
                33.689084
              ],
              [
                48.0077765,
                33.6929748
              ],
              [
                48.0074999,
                33.6932546
              ],
              [
                48.0063897,
                33.6932546
              ],
              [
                48.0061097,
                33.6935345
              ],
              [
                48.0052764,
                33.6935345
              ],
              [
                48.0047233,
                33.6938143
              ],
              [
                48.003333,
                33.6938143
              ],
              [
                48.0022233,
                33.6940851
              ],
              [
                47.9999396,
                33.690671
              ],
              [
                47.9952767,
                33.687143
              ],
              [
                47.9925,
                33.6885333
              ],
              [
                47.9922199,
                33.6888131
              ],
              [
                47.9911102,
                33.6888131
              ],
              [
                47.9655537,
                33.6965856
              ],
              [
                47.9624971,
                33.6971454
              ],
              [
                47.9605537,
                33.6971453
              ],
              [
                47.9533304,
                33.6993661
              ],
              [
                47.949164,
                33.7002056
              ],
              [
                47.9383305,
                33.7043673
              ],
              [
                47.9374972,
                33.7046471
              ],
              [
                47.9366641,
                33.7051977
              ],
              [
                47.9358309,
                33.7054776
              ],
              [
                47.9355507,
                33.7054776
              ],
              [
                47.9352738,
                33.7057574
              ],
              [
                47.9344406,
                33.7063081
              ],
              [
                47.9336073,
                33.7063081
              ],
              [
                47.9336073,
                33.706588
              ],
              [
                47.9330507,
                33.7065879
              ],
              [
                47.9330506,
                33.7068678
              ],
              [
                47.9319405,
                33.7068678
              ],
              [
                47.8972179,
                33.7179805
              ],
              [
                47.8549916,
                33.7354753
              ],
              [
                47.8327684,
                33.7479781
              ],
              [
                47.8322153,
                33.7483496
              ],
              [
                47.8319353,
                33.7485377
              ],
              [
                47.8313817,
                33.7488086
              ],
              [
                47.768046,
                33.7749242
              ],
              [
                47.7608228,
                33.7774247
              ],
              [
                47.7599891,
                33.7779754
              ],
              [
                47.7533227,
                33.7802051
              ],
              [
                47.7363761,
                33.7888169
              ],
              [
                47.7341531,
                33.791868
              ],
              [
                47.7294294,
                33.8038109
              ],
              [
                47.7294295,
                33.8082522
              ],
              [
                47.7222098,
                33.8379781
              ],
              [
                47.7222096,
                33.8477001
              ],
              [
                47.7219296,
                33.8496499
              ],
              [
                47.7197096,
                33.855761
              ],
              [
                47.7183197,
                33.8582615
              ],
              [
                47.7180432,
                33.8588122
              ],
              [
                47.7174861,
                33.859092
              ],
              [
                47.7147095,
                33.8607619
              ],
              [
                47.7147095,
                33.8610327
              ],
              [
                47.7141528,
                33.8610327
              ],
              [
                47.7125902,
                33.8615924
              ],
              [
                47.7122098,
                33.8615924
              ],
              [
                47.7119298,
                33.8618722
              ],
              [
                47.7113762,
                33.8618723
              ],
              [
                47.6972063,
                33.8657537
              ],
              [
                47.6966532,
                33.8663134
              ],
              [
                47.6960966,
                33.8663133
              ],
              [
                47.6960966,
                33.8665932
              ],
              [
                47.6924867,
                33.8682632
              ],
              [
                47.6909565,
                33.8686739
              ],
              [
                47.6902633,
                33.8688138
              ],
              [
                47.6897066,
                33.8690936
              ],
              [
                47.6897066,
                33.8688138
              ],
              [
                47.6894301,
                33.8690936
              ],
              [
                47.6888734,
                33.8690937
              ],
              [
                47.6885968,
                33.8693734
              ],
              [
                47.6835967,
                33.8710344
              ],
              [
                47.6824834,
                33.8710344
              ],
              [
                47.6798679,
                33.8732117
              ],
              [
                47.6767876,
                33.8751638
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555028,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دورود",
          "name:en": "Dorud County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279194",
          "wikipedia": "en:Dorud County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.8158385,
                33.6317989
              ],
              [
                48.8404279,
                33.6232649
              ],
              [
                48.8617641,
                33.6110714
              ],
              [
                48.8719057,
                33.6055883
              ],
              [
                48.8919855,
                33.5949187
              ],
              [
                48.8933753,
                33.5946479
              ],
              [
                48.8978187,
                33.5946478
              ],
              [
                48.898652,
                33.5943679
              ],
              [
                48.9039318,
                33.594368
              ],
              [
                48.9042084,
                33.5946479
              ],
              [
                48.9086518,
                33.5954784
              ],
              [
                48.9122651,
                33.5960381
              ],
              [
                48.9128183,
                33.596309
              ],
              [
                48.9136519,
                33.596309
              ],
              [
                48.9139317,
                33.5965888
              ],
              [
                48.9150418,
                33.5965889
              ],
              [
                48.9153183,
                33.596309
              ],
              [
                48.9158749,
                33.596309
              ],
              [
                48.9164316,
                33.596309
              ],
              [
                48.9172649,
                33.5960382
              ],
              [
                48.9189317,
                33.5960381
              ],
              [
                48.9194884,
                33.5957584
              ],
              [
                48.9208751,
                33.5957583
              ],
              [
                48.9211552,
                33.5954784
              ],
              [
                48.9236549,
                33.5954785
              ],
              [
                48.9239318,
                33.5951986
              ],
              [
                48.9244885,
                33.5951986
              ],
              [
                48.9422647,
                33.5796437
              ],
              [
                48.9453213,
                33.5732521
              ],
              [
                48.9455979,
                33.5729722
              ],
              [
                48.945598,
                33.5724214
              ],
              [
                48.945878,
                33.5715819
              ],
              [
                48.9461545,
                33.5713111
              ],
              [
                48.9486547,
                33.5665896
              ],
              [
                48.9486547,
                33.5663097
              ],
              [
                48.9494879,
                33.5649194
              ],
              [
                48.9514312,
                33.5601978
              ],
              [
                48.9517114,
                33.5582568
              ],
              [
                48.951988,
                33.5571373
              ],
              [
                48.9522645,
                33.5565866
              ],
              [
                48.9522645,
                33.554782
              ],
              [
                48.9522646,
                33.5529756
              ],
              [
                48.9525446,
                33.5510346
              ],
              [
                48.9528216,
                33.5490935
              ],
              [
                48.9530981,
                33.547974
              ],
              [
                48.9569881,
                33.5393615
              ],
              [
                48.9642114,
                33.5290877
              ],
              [
                48.9642113,
                33.5288077
              ],
              [
                48.964768,
                33.5282571
              ],
              [
                48.9975477,
                33.4865838
              ],
              [
                48.9978242,
                33.4854734
              ],
              [
                48.9981007,
                33.4851935
              ],
              [
                48.9983809,
                33.4846428
              ],
              [
                48.9983809,
                33.4829725
              ],
              [
                48.9986578,
                33.4818621
              ],
              [
                48.9989344,
                33.4813114
              ],
              [
                48.9989344,
                33.4807517
              ],
              [
                48.9989344,
                33.4804808
              ],
              [
                48.9942144,
                33.4751993
              ],
              [
                48.9903245,
                33.4735291
              ],
              [
                48.9892112,
                33.4735292
              ],
              [
                48.9889346,
                33.4732492
              ],
              [
                48.9833778,
                33.4713082
              ],
              [
                48.9728214,
                33.4579736
              ],
              [
                48.9719879,
                33.4549222
              ],
              [
                48.9664351,
                33.4449189
              ],
              [
                48.965878,
                33.4435285
              ],
              [
                48.9650447,
                33.4418583
              ],
              [
                48.9555981,
                33.4285236
              ],
              [
                48.9450452,
                33.4218607
              ],
              [
                48.9414318,
                33.4207503
              ],
              [
                48.9375455,
                33.4207503
              ],
              [
                48.9369888,
                33.4204704
              ],
              [
                48.9297653,
                33.4204704
              ],
              [
                48.9292086,
                33.4201905
              ],
              [
                48.9255988,
                33.4196398
              ],
              [
                48.9175422,
                33.4157486
              ],
              [
                48.9172654,
                33.4154778
              ],
              [
                48.8942091,
                33.4013033
              ],
              [
                48.8919859,
                33.3982518
              ],
              [
                48.8911529,
                33.395471
              ],
              [
                48.8914294,
                33.3949203
              ],
              [
                48.8911528,
                33.3946404
              ],
              [
                48.8908759,
                33.3910291
              ],
              [
                48.8930958,
                33.3851967
              ],
              [
                48.8933759,
                33.3849169
              ],
              [
                48.8933759,
                33.384637
              ],
              [
                48.8935164,
                33.3843571
              ],
              [
                48.8936525,
                33.3840863
              ],
              [
                48.9005991,
                33.3785249
              ],
              [
                48.9300424,
                33.3690812
              ],
              [
                48.9358752,
                33.3679707
              ],
              [
                48.9367088,
                33.3676909
              ],
              [
                48.9378222,
                33.3676909
              ],
              [
                48.9383788,
                33.367411
              ],
              [
                48.941432,
                33.3668602
              ],
              [
                48.9464321,
                33.36519
              ],
              [
                48.9469888,
                33.3671402
              ],
              [
                48.950322,
                33.3671402
              ],
              [
                48.9505986,
                33.3668602
              ],
              [
                48.952265,
                33.3668603
              ],
              [
                48.9522651,
                33.3665804
              ],
              [
                48.9711549,
                33.3604682
              ],
              [
                48.9906014,
                33.3463027
              ],
              [
                48.9914346,
                33.3457519
              ],
              [
                49.006158,
                33.3351887
              ],
              [
                49.0422708,
                33.3068573
              ],
              [
                49.0444944,
                33.3046363
              ],
              [
                49.0453276,
                33.3038056
              ],
              [
                49.0483808,
                33.3013048
              ],
              [
                49.049494,
                33.300745
              ],
              [
                49.0497707,
                33.3004742
              ],
              [
                49.0769938,
                33.287139
              ],
              [
                49.0781072,
                33.2871391
              ],
              [
                49.0797736,
                33.2865793
              ],
              [
                49.0808838,
                33.2865792
              ],
              [
                49.0828271,
                33.2860285
              ],
              [
                49.0839405,
                33.2860285
              ],
              [
                49.0847737,
                33.2857487
              ],
              [
                49.0878269,
                33.2857486
              ],
              [
                49.0883835,
                33.2854688
              ],
              [
                49.0928302,
                33.2854687
              ],
              [
                49.0928301,
                33.2857487
              ],
              [
                49.0936637,
                33.2857486
              ],
              [
                49.0944969,
                33.2860285
              ],
              [
                49.0950501,
                33.2862994
              ],
              [
                49.0958837,
                33.2862994
              ],
              [
                49.1056069,
                33.2904706
              ],
              [
                49.1158867,
                33.3074172
              ],
              [
                49.1300532,
                33.3160304
              ],
              [
                49.1342195,
                33.3171409
              ],
              [
                49.136163,
                33.3174118
              ],
              [
                49.1375528,
                33.3174118
              ],
              [
                49.1383864,
                33.3176917
              ],
              [
                49.1414427,
                33.3176917
              ],
              [
                49.142553,
                33.3179716
              ],
              [
                49.1522762,
                33.3188022
              ],
              [
                49.1564427,
                33.3188023
              ],
              [
                49.1575528,
                33.3190821
              ],
              [
                49.1628327,
                33.3190821
              ],
              [
                49.1633857,
                33.319362
              ],
              [
                49.1658893,
                33.3193621
              ],
              [
                49.1678327,
                33.3199127
              ],
              [
                49.169499,
                33.3199128
              ],
              [
                49.170889,
                33.3204726
              ],
              [
                49.1817225,
                33.3226936
              ],
              [
                49.1911655,
                33.3226936
              ],
              [
                49.1922789,
                33.3224138
              ],
              [
                49.2078355,
                33.3207434
              ],
              [
                49.2117219,
                33.3204726
              ],
              [
                49.2178353,
                33.3204727
              ],
              [
                49.2189451,
                33.3201928
              ],
              [
                49.2270018,
                33.3201927
              ],
              [
                49.2283918,
                33.3199129
              ],
              [
                49.2425584,
                33.3176919
              ],
              [
                49.2650582,
                33.3032463
              ],
              [
                49.2808944,
                33.2924121
              ],
              [
                49.2892278,
                33.2896403
              ],
              [
                49.2906146,
                33.2896403
              ],
              [
                49.2908942,
                33.2893604
              ],
              [
                49.2925611,
                33.2893604
              ],
              [
                49.2933943,
                33.2890805
              ],
              [
                49.2972842,
                33.2890806
              ],
              [
                49.2975608,
                33.2893604
              ],
              [
                49.2983943,
                33.2893604
              ],
              [
                49.3003374,
                33.2899112
              ],
              [
                49.3070043,
                33.2935226
              ],
              [
                49.3150607,
                33.2999148
              ],
              [
                49.3258936,
                33.3135299
              ],
              [
                49.3270074,
                33.3157509
              ],
              [
                49.3270073,
                33.3160308
              ],
              [
                49.327284,
                33.3163016
              ],
              [
                49.3264504,
                33.3163017
              ],
              [
                49.3261737,
                33.3165815
              ],
              [
                49.3253405,
                33.3165815
              ],
              [
                49.3100606,
                33.3229737
              ],
              [
                49.3097839,
                33.3232445
              ],
              [
                49.3092273,
                33.3235244
              ],
              [
                49.2992275,
                33.3290859
              ],
              [
                49.2842276,
                33.3362996
              ],
              [
                49.271448,
                33.3479734
              ],
              [
                49.2713247,
                33.3483737
              ],
              [
                49.271324,
                33.3483745
              ],
              [
                49.2713094,
                33.3483887
              ],
              [
                49.2708909,
                33.348804
              ],
              [
                49.2706143,
                33.3490839
              ],
              [
                49.2536679,
                33.3651906
              ],
              [
                49.2458915,
                33.3790852
              ],
              [
                49.2453349,
                33.3799159
              ],
              [
                49.2339447,
                33.4007532
              ],
              [
                49.2333916,
                33.4013039
              ],
              [
                49.2258914,
                33.4226919
              ],
              [
                49.2264449,
                33.4354759
              ],
              [
                49.2275582,
                33.4388073
              ],
              [
                49.2278348,
                33.4396379
              ],
              [
                49.2295016,
                33.4432491
              ],
              [
                49.2311681,
                33.452142
              ],
              [
                49.2295016,
                33.4563039
              ],
              [
                49.2297781,
                33.458254
              ],
              [
                49.2325578,
                33.4615854
              ],
              [
                49.2417244,
                33.4660272
              ],
              [
                49.2425581,
                33.4663071
              ],
              [
                49.244501,
                33.4685281
              ],
              [
                49.2472811,
                33.4765811
              ],
              [
                49.2475578,
                33.4796416
              ],
              [
                49.2475577,
                33.4801923
              ],
              [
                49.2481143,
                33.4835327
              ],
              [
                49.2483909,
                33.4843634
              ],
              [
                49.2483909,
                33.4954769
              ],
              [
                49.2656143,
                33.5171442
              ],
              [
                49.2667241,
                33.519365
              ],
              [
                49.2681139,
                33.5229763
              ],
              [
                49.2681138,
                33.5240867
              ],
              [
                49.2681139,
                33.5243665
              ],
              [
                49.268114,
                33.5251971
              ],
              [
                49.2672807,
                33.5282576
              ],
              [
                49.2633907,
                33.5329793
              ],
              [
                49.2617243,
                33.5379717
              ],
              [
                49.2617243,
                33.5388113
              ],
              [
                49.2614473,
                33.539362
              ],
              [
                49.2622809,
                33.5460336
              ],
              [
                49.2622809,
                33.5463044
              ],
              [
                49.2650575,
                33.5504754
              ],
              [
                49.2792273,
                33.5640894
              ],
              [
                49.2795038,
                33.5643693
              ],
              [
                49.2828371,
                33.5685311
              ],
              [
                49.2945037,
                33.5871465
              ],
              [
                49.2945038,
                33.5876972
              ],
              [
                49.2950604,
                33.5879771
              ],
              [
                49.2983936,
                33.5971493
              ],
              [
                49.2986702,
                33.5974201
              ],
              [
                49.2986701,
                33.5993611
              ],
              [
                49.2947802,
                33.6038118
              ],
              [
                49.293947,
                33.6043714
              ],
              [
                49.287366,
                33.6072273
              ],
              [
                49.2850605,
                33.6043715
              ],
              [
                49.2842269,
                33.6040916
              ],
              [
                49.2808936,
                33.6040916
              ],
              [
                49.2667238,
                33.6104832
              ],
              [
                49.265614,
                33.610754
              ],
              [
                49.2586705,
                33.6129749
              ],
              [
                49.2581138,
                33.6132547
              ],
              [
                49.2572807,
                33.6132546
              ],
              [
                49.256724,
                33.6135346
              ],
              [
                49.2556142,
                33.6135345
              ],
              [
                49.2536673,
                33.6143651
              ],
              [
                49.2531141,
                33.6143651
              ],
              [
                49.2528341,
                33.6146449
              ],
              [
                49.2522809,
                33.614645
              ],
              [
                49.2517239,
                33.6152046
              ],
              [
                49.2467242,
                33.6171456
              ],
              [
                49.2408908,
                33.6171455
              ],
              [
                49.2403342,
                33.6168658
              ],
              [
                49.2392244,
                33.6168657
              ],
              [
                49.2228346,
                33.6121442
              ],
              [
                49.2195009,
                33.6121442
              ],
              [
                49.2192213,
                33.6124241
              ],
              [
                49.2181111,
                33.6124241
              ],
              [
                49.2172779,
                33.6127039
              ],
              [
                49.2167212,
                33.6127039
              ],
              [
                49.2156111,
                33.6129748
              ],
              [
                49.2120011,
                33.6182559
              ],
              [
                49.211168,
                33.6207566
              ],
              [
                49.2053347,
                33.6243677
              ],
              [
                49.2045015,
                33.6251983
              ],
              [
                49.2042213,
                33.6265885
              ],
              [
                49.2045014,
                33.6301995
              ],
              [
                49.2083878,
                33.6443639
              ],
              [
                49.2086678,
                33.6463139
              ],
              [
                49.2083877,
                33.6468736
              ],
              [
                49.2064444,
                33.6513151
              ],
              [
                49.2047779,
                33.6524255
              ],
              [
                49.2020014,
                33.657147
              ],
              [
                49.2014446,
                33.6588171
              ],
              [
                49.2011645,
                33.6596476
              ],
              [
                49.2000547,
                33.6640891
              ],
              [
                49.1997778,
                33.6665898
              ],
              [
                49.1989445,
                33.6715911
              ],
              [
                49.1961644,
                33.6760326
              ],
              [
                49.1956113,
                33.6763125
              ],
              [
                49.1956112,
                33.6768721
              ],
              [
                49.1950547,
                33.6774228
              ],
              [
                49.1950546,
                33.6777026
              ],
              [
                49.194778,
                33.6785332
              ],
              [
                49.1950546,
                33.6863149
              ],
              [
                49.1856114,
                33.6965881
              ],
              [
                49.1853313,
                33.6976984
              ],
              [
                49.1842215,
                33.6993685
              ],
              [
                49.1797746,
                33.702149
              ],
              [
                49.1706084,
                33.7040899
              ],
              [
                49.1697747,
                33.7040898
              ],
              [
                49.1669981,
                33.7046495
              ],
              [
                49.1467184,
                33.7182628
              ],
              [
                49.1417187,
                33.7215939
              ],
              [
                49.1383854,
                33.7215939
              ],
              [
                49.1300521,
                33.7182628
              ],
              [
                49.1294954,
                33.7179829
              ],
              [
                49.1283852,
                33.7171524
              ],
              [
                49.1281086,
                33.7168636
              ],
              [
                49.1256055,
                33.716033
              ],
              [
                49.1253289,
                33.7157532
              ],
              [
                49.1244953,
                33.7157532
              ],
              [
                49.123662,
                33.7152025
              ],
              [
                49.1211621,
                33.7152025
              ],
              [
                49.1200522,
                33.7152026
              ],
              [
                49.1194956,
                33.7154823
              ],
              [
                49.1186624,
                33.7154823
              ],
              [
                49.112552,
                33.7196439
              ],
              [
                49.1117189,
                33.7199238
              ],
              [
                49.1114388,
                33.7202036
              ],
              [
                49.1089391,
                33.7202037
              ],
              [
                49.1086621,
                33.7199238
              ],
              [
                49.107829,
                33.7199238
              ],
              [
                49.101439,
                33.7171524
              ],
              [
                49.1011624,
                33.7168636
              ],
              [
                49.0961624,
                33.7165927
              ],
              [
                49.0944959,
                33.7168635
              ],
              [
                49.0894958,
                33.7185336
              ],
              [
                49.0858824,
                33.7196439
              ],
              [
                49.0856058,
                33.7199238
              ],
              [
                49.0850492,
                33.7199237
              ],
              [
                49.0825491,
                33.7199238
              ],
              [
                49.075606,
                33.7179829
              ],
              [
                49.0736596,
                33.7007586
              ],
              [
                49.0708829,
                33.689366
              ],
              [
                49.0703263,
                33.6888153
              ],
              [
                49.0694927,
                33.6888152
              ],
              [
                49.0658829,
                33.6907562
              ],
              [
                49.0650496,
                33.6913159
              ],
              [
                49.0528263,
                33.7024286
              ],
              [
                49.0508833,
                33.7032591
              ],
              [
                49.0497696,
                33.7032591
              ],
              [
                49.049213,
                33.703539
              ],
              [
                49.0461597,
                33.703539
              ],
              [
                49.0458797,
                33.7032592
              ],
              [
                49.0442133,
                33.7032591
              ],
              [
                49.0442132,
                33.7029793
              ],
              [
                49.0433796,
                33.7029792
              ],
              [
                49.0431031,
                33.7026994
              ],
              [
                49.0422698,
                33.7026994
              ],
              [
                49.0342134,
                33.6971476
              ],
              [
                49.0325466,
                33.696317
              ],
              [
                49.0300466,
                33.6954775
              ],
              [
                49.0261566,
                33.6954775
              ],
              [
                49.0258801,
                33.6957572
              ],
              [
                49.02338,
                33.6957573
              ],
              [
                49.0219901,
                33.6963169
              ],
              [
                49.0211569,
                33.696317
              ],
              [
                49.0167135,
                33.6990884
              ],
              [
                49.0161568,
                33.7004786
              ],
              [
                49.0158803,
                33.7007585
              ],
              [
                49.0156037,
                33.7018688
              ],
              [
                49.0144224,
                33.7068628
              ],
              [
                49.0140008,
                33.7110607
              ],
              [
                49.012928,
                33.7153802
              ],
              [
                49.008364,
                33.7224282
              ],
              [
                49.005542,
                33.7303133
              ],
              [
                49.0038552,
                33.7361331
              ],
              [
                48.999992,
                33.7352241
              ],
              [
                49.0000834,
                33.7379655
              ],
              [
                48.9877796,
                33.7370099
              ],
              [
                48.9835738,
                33.7371884
              ],
              [
                48.9749593,
                33.7354776
              ],
              [
                48.971815,
                33.7346902
              ],
              [
                48.9684804,
                33.7327855
              ],
              [
                48.9670366,
                33.7291825
              ],
              [
                48.964978,
                33.7276234
              ],
              [
                48.9615386,
                33.7245646
              ],
              [
                48.9564227,
                33.720951
              ],
              [
                48.94999,
                33.7148884
              ],
              [
                48.9475655,
                33.7136747
              ],
              [
                48.9452727,
                33.712431
              ],
              [
                48.9349508,
                33.7068124
              ],
              [
                48.9277587,
                33.7010917
              ],
              [
                48.9200162,
                33.6947447
              ],
              [
                48.9169263,
                33.694102
              ],
              [
                48.9143943,
                33.6952089
              ],
              [
                48.9112186,
                33.6973155
              ],
              [
                48.9044443,
                33.7036961
              ],
              [
                48.9007161,
                33.7050254
              ],
              [
                48.8931083,
                33.710668
              ],
              [
                48.887186,
                33.7187
              ],
              [
                48.8801479,
                33.7174863
              ],
              [
                48.8774442,
                33.7180575
              ],
              [
                48.8753413,
                33.7196281
              ],
              [
                48.8758563,
                33.7217698
              ],
              [
                48.8754173,
                33.7239716
              ],
              [
                48.8769619,
                33.7313315
              ],
              [
                48.8756609,
                33.7341204
              ],
              [
                48.8730677,
                33.7395298
              ],
              [
                48.8667583,
                33.7473946
              ],
              [
                48.86384,
                33.7495356
              ],
              [
                48.8605785,
                33.7466809
              ],
              [
                48.8545173,
                33.7423532
              ],
              [
                48.8500085,
                33.739717
              ],
              [
                48.844668,
                33.7360882
              ],
              [
                48.8415812,
                33.7307708
              ],
              [
                48.8382625,
                33.7280518
              ],
              [
                48.8367282,
                33.7251423
              ],
              [
                48.8373099,
                33.7206768
              ],
              [
                48.8384889,
                33.7135789
              ],
              [
                48.8383173,
                33.7072939
              ],
              [
                48.8335418,
                33.7047061
              ],
              [
                48.8270988,
                33.6994072
              ],
              [
                48.8203433,
                33.6971336
              ],
              [
                48.8134574,
                33.6933522
              ],
              [
                48.8066768,
                33.6869962
              ],
              [
                48.7982654,
                33.6814255
              ],
              [
                48.7920856,
                33.6779257
              ],
              [
                48.7904655,
                33.673641
              ],
              [
                48.7948678,
                33.668435
              ],
              [
                48.7964129,
                33.6653622
              ],
              [
                48.8011527,
                33.6612365
              ],
              [
                48.803321,
                33.656691
              ],
              [
                48.805561,
                33.6541377
              ],
              [
                48.8104969,
                33.6461373
              ],
              [
                48.8110541,
                33.6435631
              ],
              [
                48.8110541,
                33.6358457
              ],
              [
                48.8119005,
                33.6334868
              ],
              [
                48.8135169,
                33.6325251
              ],
              [
                48.8147903,
                33.6324211
              ],
              [
                48.8158385,
                33.6317989
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555051,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رومشکان",
          "name:en": "Rumeshkan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q7379250",
          "wikipedia": "en:Rumeshkan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.1795837,
                33.3062327
              ],
              [
                47.1805183,
                33.3015716
              ],
              [
                47.1880185,
                33.2987998
              ],
              [
                47.1891318,
                33.2987997
              ],
              [
                47.1894084,
                33.2990796
              ],
              [
                47.1910748,
                33.2990796
              ],
              [
                47.1977413,
                33.3024112
              ],
              [
                47.1991312,
                33.3024113
              ],
              [
                47.1996851,
                33.3026911
              ],
              [
                47.2007984,
                33.3026911
              ],
              [
                47.201075,
                33.3024112
              ],
              [
                47.2019079,
                33.3024113
              ],
              [
                47.2041313,
                33.2990797
              ],
              [
                47.2044079,
                33.29852
              ],
              [
                47.2038548,
                33.2943577
              ],
              [
                47.2030219,
                33.2932473
              ],
              [
                47.2007985,
                33.2907463
              ],
              [
                47.1955179,
                33.2826838
              ],
              [
                47.2013548,
                33.2757408
              ],
              [
                47.2044079,
                33.2746303
              ],
              [
                47.2116316,
                33.2746303
              ],
              [
                47.2121878,
                33.2749103
              ],
              [
                47.213855,
                33.2749103
              ],
              [
                47.2141316,
                33.2751901
              ],
              [
                47.2174645,
                33.2754701
              ],
              [
                47.2177411,
                33.2751901
              ],
              [
                47.2196879,
                33.2751902
              ],
              [
                47.222188,
                33.2746304
              ],
              [
                47.2252443,
                33.27324
              ],
              [
                47.2282983,
                33.2696285
              ],
              [
                47.2282983,
                33.2690778
              ],
              [
                47.2288546,
                33.2687979
              ],
              [
                47.2288546,
                33.2682472
              ],
              [
                47.2324648,
                33.2629654
              ],
              [
                47.2327445,
                33.2601847
              ],
              [
                47.2330212,
                33.2599137
              ],
              [
                47.2302445,
                33.2515714
              ],
              [
                47.230521,
                33.2513004
              ],
              [
                47.2305211,
                33.2504608
              ],
              [
                47.2319109,
                33.2487995
              ],
              [
                47.2324649,
                33.2479689
              ],
              [
                47.2396877,
                33.2446283
              ],
              [
                47.2427447,
                33.2440776
              ],
              [
                47.2455214,
                33.2440776
              ],
              [
                47.2463542,
                33.2443575
              ],
              [
                47.2463542,
                33.2451881
              ],
              [
                47.2474675,
                33.2460187
              ],
              [
                47.2474675,
                33.2462986
              ],
              [
                47.2505206,
                33.2510206
              ],
              [
                47.2524676,
                33.2521311
              ],
              [
                47.2544114,
                33.2521312
              ],
              [
                47.2546879,
                33.2518512
              ],
              [
                47.2552442,
                33.2518513
              ],
              [
                47.2552443,
                33.2515713
              ],
              [
                47.2588576,
                33.2501901
              ],
              [
                47.2594107,
                33.2496303
              ],
              [
                47.2660772,
                33.2451881
              ],
              [
                47.2694109,
                33.2368547
              ],
              [
                47.2702438,
                33.2346336
              ],
              [
                47.2713579,
                33.2329634
              ],
              [
                47.2733009,
                33.2315729
              ],
              [
                47.2749674,
                33.2310222
              ],
              [
                47.2771908,
                33.2310222
              ],
              [
                47.2808011,
                33.233794
              ],
              [
                47.2860808,
                33.2379652
              ],
              [
                47.2883004,
                33.2379652
              ],
              [
                47.2971904,
                33.2324126
              ],
              [
                47.2974709,
                33.2321327
              ],
              [
                47.2971904,
                33.2296319
              ],
              [
                47.2991373,
                33.2274107
              ],
              [
                47.3013569,
                33.2271309
              ],
              [
                47.301914,
                33.2271309
              ],
              [
                47.3021906,
                33.2274107
              ],
              [
                47.3033038,
                33.2274107
              ],
              [
                47.3074704,
                33.2304715
              ],
              [
                47.308304,
                33.2304715
              ],
              [
                47.3085805,
                33.2301826
              ],
              [
                47.3094133,
                33.2299118
              ],
              [
                47.3105235,
                33.2276906
              ],
              [
                47.310804,
                33.2271309
              ],
              [
                47.3105235,
                33.2265801
              ],
              [
                47.3099704,
                33.2226888
              ],
              [
                47.3119134,
                33.2204677
              ],
              [
                47.3169135,
                33.2212984
              ],
              [
                47.3199706,
                33.2224089
              ],
              [
                47.3246933,
                33.2246299
              ],
              [
                47.3258035,
                33.22463
              ],
              [
                47.3263606,
                33.2249099
              ],
              [
                47.3283036,
                33.2249099
              ],
              [
                47.3310802,
                33.2218491
              ],
              [
                47.3313599,
                33.2193572
              ],
              [
                47.3330271,
                33.2174071
              ],
              [
                47.3360834,
                33.2162965
              ],
              [
                47.338303,
                33.2162965
              ],
              [
                47.3444164,
                33.2190774
              ],
              [
                47.3469164,
                33.2190774
              ],
              [
                47.3508032,
                33.2179669
              ],
              [
                47.3510829,
                33.2174071
              ],
              [
                47.3524735,
                33.215186
              ],
              [
                47.3527501,
                33.2146262
              ],
              [
                47.3527502,
                33.2132449
              ],
              [
                47.3530268,
                33.210464
              ],
              [
                47.3533065,
                33.2088028
              ],
              [
                47.3535831,
                33.2062927
              ],
              [
                47.3538596,
                33.2060219
              ],
              [
                47.3566401,
                33.2021305
              ],
              [
                47.3571933,
                33.2024104
              ],
              [
                47.3583066,
                33.2024104
              ],
              [
                47.3602496,
                33.2035209
              ],
              [
                47.3680262,
                33.210464
              ],
              [
                47.3719162,
                33.2104641
              ],
              [
                47.3749733,
                33.2093536
              ],
              [
                47.3808062,
                33.2046315
              ],
              [
                47.3863626,
                33.1982391
              ],
              [
                47.3871962,
                33.1979593
              ],
              [
                47.3877493,
                33.1974085
              ],
              [
                47.3894157,
                33.1965779
              ],
              [
                47.3905292,
                33.1965779
              ],
              [
                47.3919197,
                33.1968488
              ],
              [
                47.3952526,
                33.1990699
              ],
              [
                47.3996957,
                33.1976884
              ],
              [
                47.4030294,
                33.1907454
              ],
              [
                47.4060857,
                33.1888042
              ],
              [
                47.4069193,
                33.1888041
              ],
              [
                47.4158094,
                33.1857434
              ],
              [
                47.4194188,
                33.1824118
              ],
              [
                47.4194188,
                33.1821319
              ],
              [
                47.4196953,
                33.1815721
              ],
              [
                47.4199759,
                33.1813013
              ],
              [
                47.4188625,
                33.1804616
              ],
              [
                47.4152524,
                33.1788003
              ],
              [
                47.4149757,
                33.1779696
              ],
              [
                47.4158093,
                33.17713
              ],
              [
                47.4188625,
                33.1760194
              ],
              [
                47.4221954,
                33.1760194
              ],
              [
                47.4224759,
                33.1762993
              ],
              [
                47.4238627,
                33.1762993
              ],
              [
                47.4241424,
                33.1765792
              ],
              [
                47.4252526,
                33.1765792
              ],
              [
                47.4255291,
                33.1768591
              ],
              [
                47.429419,
                33.1768591
              ],
              [
                47.4299757,
                33.1765791
              ],
              [
                47.4299756,
                33.1762994
              ],
              [
                47.4302522,
                33.1760195
              ],
              [
                47.4302523,
                33.1754597
              ],
              [
                47.4308088,
                33.1749089
              ],
              [
                47.4308088,
                33.1743491
              ],
              [
                47.4313656,
                33.1740692
              ],
              [
                47.4327522,
                33.1724079
              ],
              [
                47.4333089,
                33.1724079
              ],
              [
                47.4369188,
                33.1704668
              ],
              [
                47.4371989,
                33.169907
              ],
              [
                47.435809,
                33.1590724
              ],
              [
                47.4358091,
                33.1551899
              ],
              [
                47.4374755,
                33.1532398
              ],
              [
                47.4391423,
                33.1532397
              ],
              [
                47.4402521,
                33.1535197
              ],
              [
                47.4408087,
                33.1535196
              ],
              [
                47.4413655,
                33.1537995
              ],
              [
                47.444142,
                33.1537996
              ],
              [
                47.444419,
                33.1535196
              ],
              [
                47.4458089,
                33.1535197
              ],
              [
                47.4474753,
                33.1529689
              ],
              [
                47.448589,
                33.152969
              ],
              [
                47.448589,
                33.1526891
              ],
              [
                47.4491421,
                33.152689
              ],
              [
                47.4494222,
                33.1524091
              ],
              [
                47.4499753,
                33.1524092
              ],
              [
                47.4505321,
                33.1521292
              ],
              [
                47.4538652,
                33.1515785
              ],
              [
                47.4560888,
                33.1515785
              ],
              [
                47.4563654,
                33.1512986
              ],
              [
                47.4608087,
                33.1512986
              ],
              [
                47.4671398,
                33.1478451
              ],
              [
                47.4699785,
                33.1462966
              ],
              [
                47.4705321,
                33.1460258
              ],
              [
                47.4710887,
                33.1460258
              ],
              [
                47.4710887,
                33.1457368
              ],
              [
                47.4719219,
                33.1457368
              ],
              [
                47.4719219,
                33.1454569
              ],
              [
                47.4727551,
                33.145457
              ],
              [
                47.4730317,
                33.1451861
              ],
              [
                47.4774787,
                33.1510187
              ],
              [
                47.4783118,
                33.1524092
              ],
              [
                47.4880351,
                33.1671262
              ],
              [
                47.5044247,
                33.1949078
              ],
              [
                47.5135913,
                33.206573
              ],
              [
                47.5224904,
                33.2142385
              ],
              [
                47.523591,
                33.2151864
              ],
              [
                47.5244243,
                33.2157372
              ],
              [
                47.5266477,
                33.2165769
              ],
              [
                47.5277576,
                33.2168477
              ],
              [
                47.5397008,
                33.2196286
              ],
              [
                47.5402574,
                33.2199085
              ],
              [
                47.5427575,
                33.2199085
              ],
              [
                47.5438708,
                33.2201884
              ],
              [
                47.5497041,
                33.2201884
              ],
              [
                47.5510904,
                33.2199085
              ],
              [
                47.5535904,
                33.2199085
              ],
              [
                47.5552573,
                33.2196286
              ],
              [
                47.5574804,
                33.2196287
              ],
              [
                47.5833169,
                33.2140761
              ],
              [
                47.5966499,
                33.211575
              ],
              [
                47.6047068,
                33.2110244
              ],
              [
                47.6066498,
                33.2107445
              ],
              [
                47.6097064,
                33.2107445
              ],
              [
                47.6116498,
                33.2104646
              ],
              [
                47.6147065,
                33.2104647
              ],
              [
                47.616373,
                33.2101847
              ],
              [
                47.6274829,
                33.2112953
              ],
              [
                47.6283162,
                33.2115752
              ],
              [
                47.6291494,
                33.2115752
              ],
              [
                47.6291494,
                33.2118551
              ],
              [
                47.6294295,
                33.2124058
              ],
              [
                47.6413726,
                33.2343547
              ],
              [
                47.6424858,
                33.238246
              ],
              [
                47.6433195,
                33.240467
              ],
              [
                47.6430394,
                33.2407469
              ],
              [
                47.6427625,
                33.2432478
              ],
              [
                47.6424859,
                33.2451891
              ],
              [
                47.6422058,
                33.2454689
              ],
              [
                47.641096,
                33.2507417
              ],
              [
                47.6360958,
                33.2668488
              ],
              [
                47.6313727,
                33.2782428
              ],
              [
                47.6313727,
                33.2790734
              ],
              [
                47.6252627,
                33.2912982
              ],
              [
                47.6249826,
                33.2924087
              ],
              [
                47.6099826,
                33.3151966
              ],
              [
                47.6097061,
                33.3162981
              ],
              [
                47.6090112,
                33.3176885
              ],
              [
                47.5983164,
                33.3204693
              ],
              [
                47.5974828,
                33.3204692
              ],
              [
                47.5880365,
                33.325471
              ],
              [
                47.5874829,
                33.325471
              ],
              [
                47.5863696,
                33.3260218
              ],
              [
                47.5858165,
                33.3265815
              ],
              [
                47.5821313,
                33.3280305
              ],
              [
                47.5740968,
                33.323624
              ],
              [
                47.5587503,
                33.315082
              ],
              [
                47.5485536,
                33.3106277
              ],
              [
                47.5448457,
                33.3094011
              ],
              [
                47.5388204,
                33.308196
              ],
              [
                47.534443,
                33.3080669
              ],
              [
                47.5318422,
                33.3083341
              ],
              [
                47.5309965,
                33.308421
              ],
              [
                47.52088,
                33.3094603
              ],
              [
                47.5102576,
                33.3129663
              ],
              [
                47.501121,
                33.3157462
              ],
              [
                47.4847013,
                33.3207398
              ],
              [
                47.4588648,
                33.3301926
              ],
              [
                47.4585423,
                33.3303495
              ],
              [
                47.4577545,
                33.3304635
              ],
              [
                47.4574749,
                33.3307433
              ],
              [
                47.4563647,
                33.3307433
              ],
              [
                47.455808,
                33.3310232
              ],
              [
                47.4546983,
                33.3313031
              ],
              [
                47.4508079,
                33.3329643
              ],
              [
                47.4499747,
                33.3329643
              ],
              [
                47.4345959,
                33.3379883
              ],
              [
                47.4324175,
                33.3386998
              ],
              [
                47.4323906,
                33.3387086
              ],
              [
                47.4219182,
                33.3421281
              ],
              [
                47.4191417,
                33.3426879
              ],
              [
                47.390806,
                33.3501904
              ],
              [
                47.3885824,
                33.3504703
              ],
              [
                47.3766392,
                33.3535219
              ],
              [
                47.3741392,
                33.3538017
              ],
              [
                47.346916,
                33.3604646
              ],
              [
                47.3380259,
                33.3635253
              ],
              [
                47.3374697,
                33.364076
              ],
              [
                47.3313594,
                33.366306
              ],
              [
                47.3305265,
                33.3665769
              ],
              [
                47.3269131,
                33.3674074
              ],
              [
                47.3263601,
                33.366306
              ],
              [
                47.3113567,
                33.3501902
              ],
              [
                47.3027464,
                33.3460191
              ],
              [
                47.301637,
                33.3457482
              ],
              [
                47.2994135,
                33.3457482
              ],
              [
                47.2980236,
                33.3454684
              ],
              [
                47.2908,
                33.3454683
              ],
              [
                47.2899672,
                33.3457482
              ],
              [
                47.2741341,
                33.3485199
              ],
              [
                47.2496043,
                33.3576969
              ],
              [
                47.2475435,
                33.3570419
              ],
              [
                47.2466165,
                33.3551278
              ],
              [
                47.2415439,
                33.3491914
              ],
              [
                47.2390977,
                33.3480299
              ],
              [
                47.2357503,
                33.3468899
              ],
              [
                47.2310897,
                33.3479439
              ],
              [
                47.2280513,
                33.349385
              ],
              [
                47.2187301,
                33.352977
              ],
              [
                47.2039243,
                33.3575366
              ],
              [
                47.2025381,
                33.3574605
              ],
              [
                47.2005816,
                33.3565524
              ],
              [
                47.1991396,
                33.3546812
              ],
              [
                47.1988821,
                33.3520142
              ],
              [
                47.1963587,
                33.3468735
              ],
              [
                47.195921,
                33.3448946
              ],
              [
                47.1962285,
                33.3423595
              ],
              [
                47.1963072,
                33.341711
              ],
              [
                47.1964617,
                33.3390866
              ],
              [
                47.1959467,
                33.3378389
              ],
              [
                47.1944533,
                33.3363761
              ],
              [
                47.1918526,
                33.3325468
              ],
              [
                47.1926251,
                33.3316002
              ],
              [
                47.1938095,
                33.3311054
              ],
              [
                47.1936293,
                33.3300943
              ],
              [
                47.1927538,
                33.3295349
              ],
              [
                47.1916209,
                33.3290186
              ],
              [
                47.1912861,
                33.3285237
              ],
              [
                47.1914406,
                33.3272759
              ],
              [
                47.1926251,
                33.326028
              ],
              [
                47.1935778,
                33.3258344
              ],
              [
                47.1938353,
                33.3251244
              ],
              [
                47.1937065,
                33.3232095
              ],
              [
                47.1947108,
                33.321811
              ],
              [
                47.194685,
                33.3201327
              ],
              [
                47.1893807,
                33.3150547
              ],
              [
                47.1873207,
                33.3124726
              ],
              [
                47.1837673,
                33.3102992
              ],
              [
                47.1795837,
                33.3062327
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555081,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سلسله",
          "name:en": "Selseleh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270900",
          "wikipedia": "en:Selseleh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.7180432,
                33.8588122
              ],
              [
                47.7183197,
                33.8582615
              ],
              [
                47.7197096,
                33.855761
              ],
              [
                47.7219296,
                33.8496499
              ],
              [
                47.7222096,
                33.8477001
              ],
              [
                47.7222098,
                33.8379781
              ],
              [
                47.7294295,
                33.8082522
              ],
              [
                47.7294294,
                33.8038109
              ],
              [
                47.7341531,
                33.791868
              ],
              [
                47.7363761,
                33.7888169
              ],
              [
                47.7533227,
                33.7802051
              ],
              [
                47.7599891,
                33.7779754
              ],
              [
                47.7608228,
                33.7774247
              ],
              [
                47.768046,
                33.7749242
              ],
              [
                47.8313817,
                33.7488086
              ],
              [
                47.8319353,
                33.7485377
              ],
              [
                47.8322153,
                33.7483496
              ],
              [
                47.8327684,
                33.7479781
              ],
              [
                47.8549916,
                33.7354753
              ],
              [
                47.8972179,
                33.7179805
              ],
              [
                47.9319405,
                33.7068678
              ],
              [
                47.9330506,
                33.7068678
              ],
              [
                47.9330507,
                33.7065879
              ],
              [
                47.9336073,
                33.706588
              ],
              [
                47.9336073,
                33.7063081
              ],
              [
                47.9344406,
                33.7063081
              ],
              [
                47.9352738,
                33.7057574
              ],
              [
                47.9355507,
                33.7054776
              ],
              [
                47.9358309,
                33.7054776
              ],
              [
                47.9366641,
                33.7051977
              ],
              [
                47.9374972,
                33.7046471
              ],
              [
                47.9383305,
                33.7043673
              ],
              [
                47.949164,
                33.7002056
              ],
              [
                47.9533304,
                33.6993661
              ],
              [
                47.9605537,
                33.6971453
              ],
              [
                47.9624971,
                33.6971454
              ],
              [
                47.9655537,
                33.6965856
              ],
              [
                47.9911102,
                33.6888131
              ],
              [
                47.9922199,
                33.6888131
              ],
              [
                47.9925,
                33.6885333
              ],
              [
                47.9952767,
                33.687143
              ],
              [
                47.9999396,
                33.690671
              ],
              [
                48.0022233,
                33.6940851
              ],
              [
                48.003333,
                33.6938143
              ],
              [
                48.0047233,
                33.6938143
              ],
              [
                48.0052764,
                33.6935345
              ],
              [
                48.0061097,
                33.6935345
              ],
              [
                48.0063897,
                33.6932546
              ],
              [
                48.0074999,
                33.6932546
              ],
              [
                48.0077765,
                33.6929748
              ],
              [
                48.0249994,
                33.689084
              ],
              [
                48.0322227,
                33.6879736
              ],
              [
                48.0416694,
                33.6868633
              ],
              [
                48.0469459,
                33.6868633
              ],
              [
                48.0472226,
                33.6871431
              ],
              [
                48.0480558,
                33.6871431
              ],
              [
                48.0483358,
                33.6877028
              ],
              [
                48.0486125,
                33.6879736
              ],
              [
                48.0488894,
                33.6885333
              ],
              [
                48.0680588,
                33.7243632
              ],
              [
                48.0717156,
                33.7261959
              ],
              [
                48.0722257,
                33.7264061
              ],
              [
                48.0727823,
                33.7265929
              ],
              [
                48.0761157,
                33.726593
              ],
              [
                48.0766688,
                33.7263131
              ],
              [
                48.077502,
                33.7263131
              ],
              [
                48.0777821,
                33.7260332
              ],
              [
                48.0786153,
                33.7260333
              ],
              [
                48.0897252,
                33.7213119
              ],
              [
                48.0911151,
                33.7207613
              ],
              [
                48.1488945,
                33.6860329
              ],
              [
                48.1497278,
                33.6854823
              ],
              [
                48.1502848,
                33.6852024
              ],
              [
                48.1519513,
                33.6838122
              ],
              [
                48.1966741,
                33.655195
              ],
              [
                48.1972307,
                33.6549243
              ],
              [
                48.2038973,
                33.6529742
              ],
              [
                48.2052872,
                33.6527034
              ],
              [
                48.2141772,
                33.6538138
              ],
              [
                48.222234,
                33.6615866
              ],
              [
                48.2250106,
                33.6660281
              ],
              [
                48.2275102,
                33.6735301
              ],
              [
                48.2294536,
                33.6818624
              ],
              [
                48.2294536,
                33.6821423
              ],
              [
                48.23362,
                33.6899239
              ],
              [
                48.2438999,
                33.6960356
              ],
              [
                48.2458434,
                33.6968661
              ],
              [
                48.2466765,
                33.6968661
              ],
              [
                48.2841796,
                33.706029
              ],
              [
                48.2855694,
                33.706029
              ],
              [
                48.2864028,
                33.7063089
              ],
              [
                48.2877894,
                33.7063089
              ],
              [
                48.2886226,
                33.7065888
              ],
              [
                48.2908461,
                33.7065888
              ],
              [
                48.2914029,
                33.7068686
              ],
              [
                48.2950127,
                33.7068686
              ],
              [
                48.2969596,
                33.7068686
              ],
              [
                48.3027925,
                33.7068686
              ],
              [
                48.3044593,
                33.7071484
              ],
              [
                48.3258492,
                33.7107595
              ],
              [
                48.326959,
                33.7113102
              ],
              [
                48.3280688,
                33.7113102
              ],
              [
                48.3297356,
                33.7118698
              ],
              [
                48.3308489,
                33.7118699
              ],
              [
                48.3319591,
                33.7121497
              ],
              [
                48.335849,
                33.7124205
              ],
              [
                48.3366822,
                33.7121498
              ],
              [
                48.3383487,
                33.7121497
              ],
              [
                48.3391823,
                33.7118698
              ],
              [
                48.3514052,
                33.7118699
              ],
              [
                48.3516822,
                33.71159
              ],
              [
                48.356962,
                33.71159
              ],
              [
                48.3583487,
                33.7113102
              ],
              [
                48.367795,
                33.7107595
              ],
              [
                48.3700149,
                33.7107595
              ],
              [
                48.370295,
                33.7104797
              ],
              [
                48.3708486,
                33.7107595
              ],
              [
                48.3714052,
                33.7104797
              ],
              [
                48.3741849,
                33.7104797
              ],
              [
                48.3752951,
                33.7107596
              ],
              [
                48.3802949,
                33.7107596
              ],
              [
                48.3805717,
                33.7110394
              ],
              [
                48.3841847,
                33.7110395
              ],
              [
                48.3844617,
                33.7107596
              ],
              [
                48.3883516,
                33.7107596
              ],
              [
                48.3883516,
                33.7110394
              ],
              [
                48.3886281,
                33.7115901
              ],
              [
                48.3886282,
                33.7121498
              ],
              [
                48.3894614,
                33.7140907
              ],
              [
                48.3897379,
                33.7157518
              ],
              [
                48.3816849,
                33.7476995
              ],
              [
                48.3814048,
                33.7482591
              ],
              [
                48.3833513,
                33.7618722
              ],
              [
                48.3858514,
                33.7671441
              ],
              [
                48.3858514,
                33.7674239
              ],
              [
                48.3944613,
                33.7818675
              ],
              [
                48.3961278,
                33.7838173
              ],
              [
                48.3969613,
                33.7854783
              ],
              [
                48.3977946,
                33.7863178
              ],
              [
                48.3986278,
                33.7879788
              ],
              [
                48.399461,
                33.7888183
              ],
              [
                48.4002946,
                33.7904794
              ],
              [
                48.4122408,
                33.8138143
              ],
              [
                48.4175175,
                33.8221463
              ],
              [
                48.4177976,
                33.8227059
              ],
              [
                48.4327971,
                33.8382594
              ],
              [
                48.4336306,
                33.8385393
              ],
              [
                48.446407,
                33.8479815
              ],
              [
                48.4666433,
                33.8459722
              ],
              [
                48.4672,
                33.8470826
              ],
              [
                48.4742074,
                33.851442
              ],
              [
                48.474484,
                33.8517219
              ],
              [
                48.4873866,
                33.8511718
              ],
              [
                48.495091,
                33.8563296
              ],
              [
                48.4956441,
                33.8568894
              ],
              [
                48.5036701,
                33.8706652
              ],
              [
                48.5042233,
                33.8706653
              ],
              [
                48.5042233,
                33.8709453
              ],
              [
                48.5129801,
                33.8762809
              ],
              [
                48.5135368,
                33.8765608
              ],
              [
                48.5179801,
                33.878502
              ],
              [
                48.5188133,
                33.8785021
              ],
              [
                48.5310877,
                33.8806845
              ],
              [
                48.5274267,
                33.8922556
              ],
              [
                48.5244678,
                33.8969743
              ],
              [
                48.5080796,
                33.9285454
              ],
              [
                48.5075225,
                33.9288161
              ],
              [
                48.503356,
                33.936597
              ],
              [
                48.4991895,
                33.942708
              ],
              [
                48.4989094,
                33.9432676
              ],
              [
                48.484743,
                33.9696521
              ],
              [
                48.484743,
                33.9702026
              ],
              [
                48.484466,
                33.9704915
              ],
              [
                48.484186,
                33.9707623
              ],
              [
                48.484186,
                33.9710421
              ],
              [
                48.4833528,
                33.9724231
              ],
              [
                48.482243,
                33.9743729
              ],
              [
                48.482243,
                33.9746526
              ],
              [
                48.4800194,
                33.9804837
              ],
              [
                48.4747427,
                33.9943752
              ],
              [
                48.4744662,
                33.9952056
              ],
              [
                48.4739095,
                33.9971553
              ],
              [
                48.473633,
                33.9974261
              ],
              [
                48.4730763,
                33.9996556
              ],
              [
                48.4722371,
                34.0063171
              ],
              [
                48.4719661,
                34.006317
              ],
              [
                48.4714094,
                34.006317
              ],
              [
                48.4705762,
                34.006317
              ],
              [
                48.4605764,
                34.0085465
              ],
              [
                48.4561299,
                34.0088172
              ],
              [
                48.4550196,
                34.0085464
              ],
              [
                48.4455734,
                34.0085465
              ],
              [
                48.4447398,
                34.0082666
              ],
              [
                48.4433534,
                34.0082667
              ],
              [
                48.420017,
                34.0027065
              ],
              [
                48.4158502,
                34.0027064
              ],
              [
                48.4147404,
                34.0024266
              ],
              [
                48.4105738,
                34.0021558
              ],
              [
                48.4055738,
                34.0021558
              ],
              [
                48.4044604,
                34.0018759
              ],
              [
                48.3989072,
                34.0018759
              ],
              [
                48.3977939,
                34.0015961
              ],
              [
                48.3944606,
                34.0015961
              ],
              [
                48.3933504,
                34.0013163
              ],
              [
                48.3908508,
                34.0013163
              ],
              [
                48.3883507,
                34.0013163
              ],
              [
                48.3849697,
                34.0013163
              ],
              [
                48.3791841,
                34.0013163
              ],
              [
                48.3522379,
                34.0068765
              ],
              [
                48.333348,
                34.0143772
              ],
              [
                48.3327914,
                34.014648
              ],
              [
                48.3322347,
                34.0138176
              ],
              [
                48.3294581,
                34.0090969
              ],
              [
                48.3205681,
                33.9993755
              ],
              [
                48.2853508,
                33.9829267
              ],
              [
                48.2695624,
                33.966212
              ],
              [
                48.2392905,
                33.9511426
              ],
              [
                48.2111566,
                33.9511575
              ],
              [
                48.1938439,
                33.9529689
              ],
              [
                48.1886198,
                33.9519397
              ],
              [
                48.1722453,
                33.9487125
              ],
              [
                48.1508631,
                33.9529374
              ],
              [
                48.1229405,
                33.9614176
              ],
              [
                48.1024196,
                33.9643709
              ],
              [
                48.0869451,
                33.9599625
              ],
              [
                48.0832479,
                33.958909
              ],
              [
                48.0725734,
                33.9434125
              ],
              [
                48.0609032,
                33.9311278
              ],
              [
                48.0403972,
                33.9223331
              ],
              [
                48.0380552,
                33.919933
              ],
              [
                48.032222,
                33.907422
              ],
              [
                48.030279,
                33.9007603
              ],
              [
                48.0180558,
                33.8868681
              ],
              [
                48.0177792,
                33.8865974
              ],
              [
                48.0022227,
                33.8771463
              ],
              [
                47.9994591,
                33.8716482
              ],
              [
                47.9944429,
                33.8640935
              ],
              [
                47.9944428,
                33.8638137
              ],
              [
                47.9938894,
                33.8635428
              ],
              [
                47.9919428,
                33.8629832
              ],
              [
                47.9908313,
                33.8622881
              ],
              [
                47.9894427,
                33.8618728
              ],
              [
                47.973053,
                33.8546513
              ],
              [
                47.9719432,
                33.8538119
              ],
              [
                47.9644431,
                33.8507607
              ],
              [
                47.9638864,
                33.8502011
              ],
              [
                47.9627766,
                33.8499302
              ],
              [
                47.9563867,
                33.8468701
              ],
              [
                47.9549968,
                33.8465903
              ],
              [
                47.9449966,
                33.84381
              ],
              [
                47.9294404,
                33.8426996
              ],
              [
                47.924997,
                33.8426996
              ],
              [
                47.9238837,
                33.8424197
              ],
              [
                47.9180504,
                33.8421489
              ],
              [
                47.9177738,
                33.8424198
              ],
              [
                47.9149937,
                33.8424198
              ],
              [
                47.9141605,
                33.8426996
              ],
              [
                47.9127736,
                33.8426996
              ],
              [
                47.9030508,
                33.8452
              ],
              [
                47.8997172,
                33.8457597
              ],
              [
                47.8874943,
                33.8479802
              ],
              [
                47.8863841,
                33.8477004
              ],
              [
                47.881661,
                33.8474295
              ],
              [
                47.8708279,
                33.8463102
              ],
              [
                47.8461048,
                33.8365882
              ],
              [
                47.844715,
                33.8363174
              ],
              [
                47.8336014,
                33.8382582
              ],
              [
                47.831935,
                33.8382582
              ],
              [
                47.823045,
                33.8396482
              ],
              [
                47.8172116,
                33.8396483
              ],
              [
                47.8163784,
                33.8393684
              ],
              [
                47.8133252,
                33.8393684
              ],
              [
                47.8127685,
                33.8390886
              ],
              [
                47.8027687,
                33.8382581
              ],
              [
                47.7999886,
                33.8377075
              ],
              [
                47.7988789,
                33.8377074
              ],
              [
                47.7974886,
                33.8371478
              ],
              [
                47.7966553,
                33.8371478
              ],
              [
                47.7949886,
                33.8368679
              ],
              [
                47.7941553,
                33.8363173
              ],
              [
                47.7899888,
                33.8349271
              ],
              [
                47.7872122,
                33.8338168
              ],
              [
                47.784432,
                33.8329863
              ],
              [
                47.779989,
                33.833537
              ],
              [
                47.7549893,
                33.8421485
              ],
              [
                47.7485993,
                33.8449289
              ],
              [
                47.7180432,
                33.8588122
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555182,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کوهدشت",
          "name:en": "Kuhdasht County",
          "name:fa": "شهرستان کوهدشت",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279114",
          "wikipedia": "en:Kuhdasht County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                46.8385176,
                33.5519856
              ],
              [
                46.8386223,
                33.5514913
              ],
              [
                46.8392474,
                33.5504494
              ],
              [
                46.8395599,
                33.5489339
              ],
              [
                46.8400714,
                33.5476551
              ],
              [
                46.8407533,
                33.5466368
              ],
              [
                46.841833,
                33.5456896
              ],
              [
                46.8432253,
                33.5446476
              ],
              [
                46.8447597,
                33.5443871
              ],
              [
                46.8462088,
                33.5444582
              ],
              [
                46.8480841,
                33.5442924
              ],
              [
                46.848766,
                33.5436293
              ],
              [
                46.8488797,
                33.5427294
              ],
              [
                46.8490786,
                33.5415926
              ],
              [
                46.8489365,
                33.5404795
              ],
              [
                46.8489649,
                33.5394849
              ],
              [
                46.8493059,
                33.5381349
              ],
              [
                46.8509255,
                33.5379454
              ],
              [
                46.8518915,
                33.5377086
              ],
              [
                46.8528292,
                33.5383244
              ],
              [
                46.8541362,
                33.5381112
              ],
              [
                46.8549886,
                33.5375902
              ],
              [
                46.8554154,
                33.5370199
              ],
              [
                46.8565004,
                33.5353787
              ],
              [
                46.8579068,
                33.5342064
              ],
              [
                46.8587506,
                33.5325651
              ],
              [
                46.8595945,
                33.5312588
              ],
              [
                46.8609607,
                33.5304214
              ],
              [
                46.8619251,
                33.5288135
              ],
              [
                46.862568,
                33.5276076
              ],
              [
                46.8624475,
                33.5260667
              ],
              [
                46.8617242,
                33.5246598
              ],
              [
                46.8609205,
                33.5231188
              ],
              [
                46.860358,
                33.5218793
              ],
              [
                46.8599963,
                33.5207068
              ],
              [
                46.8597552,
                33.5191323
              ],
              [
                46.8598758,
                33.5177923
              ],
              [
                46.8612822,
                33.5164522
              ],
              [
                46.8629297,
                33.5163182
              ],
              [
                46.8628091,
                33.5168877
              ],
              [
                46.8631708,
                33.5181608
              ],
              [
                46.8655014,
                33.5188978
              ],
              [
                46.8671087,
                33.5199028
              ],
              [
                46.8689572,
                33.5202713
              ],
              [
                46.8703636,
                33.5194673
              ],
              [
                46.8714887,
                33.5183953
              ],
              [
                46.8728148,
                33.5175913
              ],
              [
                46.8733773,
                33.5159832
              ],
              [
                46.8744623,
                33.5144086
              ],
              [
                46.8764714,
                33.513169
              ],
              [
                46.8779984,
                33.5121974
              ],
              [
                46.8798066,
                33.5120299
              ],
              [
                46.8817354,
                33.5112593
              ],
              [
                46.8829811,
                33.5100866
              ],
              [
                46.8843473,
                33.5092155
              ],
              [
                46.8855126,
                33.5083779
              ],
              [
                46.8867985,
                33.5074062
              ],
              [
                46.888888,
                33.505999
              ],
              [
                46.8902141,
                33.5058985
              ],
              [
                46.8907547,
                33.5048622
              ],
              [
                46.8908116,
                33.5026825
              ],
              [
                46.891664,
                33.5012135
              ],
              [
                46.8905843,
                33.4994127
              ],
              [
                46.8911525,
                33.4980859
              ],
              [
                46.8930279,
                33.4980385
              ],
              [
                46.8948463,
                33.4979911
              ],
              [
                46.8967217,
                33.4985124
              ],
              [
                46.8984833,
                33.4985124
              ],
              [
                46.9009269,
                33.4978489
              ],
              [
                46.9025181,
                33.4975172
              ],
              [
                46.9041092,
                33.4979437
              ],
              [
                46.9054163,
                33.4985598
              ],
              [
                46.9068938,
                33.4980385
              ],
              [
                46.9076326,
                33.4971381
              ],
              [
                46.9072916,
                33.4953847
              ],
              [
                46.9062687,
                33.4936312
              ],
              [
                46.9052458,
                33.4917355
              ],
              [
                46.9054731,
                33.4896503
              ],
              [
                46.906496,
                33.4876597
              ],
              [
                46.9083145,
                33.4864274
              ],
              [
                46.9104739,
                33.4859061
              ],
              [
                46.9120083,
                33.4852425
              ],
              [
                46.9132017,
                33.4837259
              ],
              [
                46.9139404,
                33.482304
              ],
              [
                46.9151338,
                33.480882
              ],
              [
                46.9160431,
                33.4796023
              ],
              [
                46.9168386,
                33.4782277
              ],
              [
                46.9186571,
                33.4774219
              ],
              [
                46.9210439,
                33.4770901
              ],
              [
                46.9230329,
                33.4771375
              ],
              [
                46.9249082,
                33.4774219
              ],
              [
                46.9267835,
                33.4780381
              ],
              [
                46.9287725,
                33.4778485
              ],
              [
                46.9298522,
                33.4767109
              ],
              [
                46.9308182,
                33.4753836
              ],
              [
                46.9317275,
                33.4739142
              ],
              [
                46.9319548,
                33.4725395
              ],
              [
                46.9317275,
                33.4715915
              ],
              [
                46.9351178,
                33.4692592
              ],
              [
                46.9384138,
                33.4674578
              ],
              [
                46.9410279,
                33.4674578
              ],
              [
                46.9431873,
                33.4669364
              ],
              [
                46.9454036,
                33.4652772
              ],
              [
                46.9478472,
                33.4636179
              ],
              [
                46.9505749,
                33.4619586
              ],
              [
                46.9529049,
                33.4621009
              ],
              [
                46.9544392,
                33.4629068
              ],
              [
                46.9554621,
                33.4635705
              ],
              [
                46.9573943,
                33.4634283
              ],
              [
                46.9588718,
                33.4627646
              ],
              [
                46.9606334,
                33.4627172
              ],
              [
                46.9626224,
                33.4621009
              ],
              [
                46.9638726,
                33.4604889
              ],
              [
                46.9648387,
                33.4598252
              ],
              [
                46.9651796,
                33.45864
              ],
              [
                46.9640999,
                33.4573599
              ],
              [
                46.9640431,
                33.4557953
              ],
              [
                46.9648955,
                33.4546574
              ],
              [
                46.9664299,
                33.453804
              ],
              [
                46.9679809,
                33.4524015
              ],
              [
                46.970254,
                33.4511214
              ],
              [
                46.9734364,
                33.4505998
              ],
              [
                46.9756527,
                33.4485609
              ],
              [
                46.9778689,
                33.4469014
              ],
              [
                46.9802557,
                33.4456685
              ],
              [
                46.982813,
                33.4463798
              ],
              [
                46.9845746,
                33.4460953
              ],
              [
                46.9867909,
                33.4445305
              ],
              [
                46.9891776,
                33.4441511
              ],
              [
                46.9901437,
                33.444246
              ],
              [
                46.9901437,
                33.4455737
              ],
              [
                46.991053,
                33.4468539
              ],
              [
                46.9924168,
                33.4478971
              ],
              [
                46.9944058,
                33.4469488
              ],
              [
                46.9946899,
                33.4458582
              ],
              [
                46.9930419,
                33.4446253
              ],
              [
                46.992019,
                33.4431554
              ],
              [
                46.9913939,
                33.4416854
              ],
              [
                46.9913939,
                33.4396463
              ],
              [
                46.9926441,
                33.4376072
              ],
              [
                46.9937239,
                33.4363742
              ],
              [
                46.9960538,
                33.4360897
              ],
              [
                46.9984406,
                33.4367061
              ],
              [
                47.0012251,
                33.4372278
              ],
              [
                47.0043506,
                33.4376072
              ],
              [
                47.0074193,
                33.438034
              ],
              [
                47.0100902,
                33.4374649
              ],
              [
                47.0112268,
                33.4361845
              ],
              [
                47.0128748,
                33.4340979
              ],
              [
                47.0145796,
                33.4319638
              ],
              [
                47.0149206,
                33.4299245
              ],
              [
                47.014466,
                33.4281697
              ],
              [
                47.0139545,
                33.4258457
              ],
              [
                47.0147501,
                33.4245177
              ],
              [
                47.0180461,
                33.4237114
              ],
              [
                47.0204329,
                33.423332
              ],
              [
                47.0234447,
                33.4229526
              ],
              [
                47.0245245,
                33.4219565
              ],
              [
                47.0257747,
                33.4213874
              ],
              [
                47.0261156,
                33.420249
              ],
              [
                47.0254337,
                33.4198696
              ],
              [
                47.0239562,
                33.4198221
              ],
              [
                47.0237857,
                33.4188735
              ],
              [
                47.0231606,
                33.4171185
              ],
              [
                47.0228764,
                33.4155532
              ],
              [
                47.0228764,
                33.4137507
              ],
              [
                47.0228764,
                33.4116161
              ],
              [
                47.0221377,
                33.4096712
              ],
              [
                47.021528,
                33.4079421
              ],
              [
                47.0181752,
                33.406851
              ],
              [
                47.0148224,
                33.4055702
              ],
              [
                47.0114696,
                33.4047163
              ],
              [
                47.0088555,
                33.4028661
              ],
              [
                47.007378,
                33.4010633
              ],
              [
                47.0064687,
                33.3994503
              ],
              [
                47.0062414,
                33.3973628
              ],
              [
                47.0062414,
                33.3952752
              ],
              [
                47.0064119,
                33.3929978
              ],
              [
                47.0073211,
                33.3911474
              ],
              [
                47.0074348,
                33.3884429
              ],
              [
                47.0088555,
                33.3869245
              ],
              [
                47.0110718,
                33.3857383
              ],
              [
                47.0136858,
                33.3853587
              ],
              [
                47.0166409,
                33.385501
              ],
              [
                47.0167927,
                33.3855445
              ],
              [
                47.0204483,
                33.3865924
              ],
              [
                47.0224373,
                33.3877311
              ],
              [
                47.0250514,
                33.3873041
              ],
              [
                47.0268698,
                33.3861653
              ],
              [
                47.0297112,
                33.385074
              ],
              [
                47.0307931,
                33.383911
              ],
              [
                47.0310342,
                33.3799516
              ],
              [
                47.033847,
                33.3782739
              ],
              [
                47.0397941,
                33.377133
              ],
              [
                47.0430088,
                33.3747841
              ],
              [
                47.0462235,
                33.3737774
              ],
              [
                47.0505632,
                33.3728378
              ],
              [
                47.0542601,
                33.3713612
              ],
              [
                47.0558674,
                33.3686094
              ],
              [
                47.0565907,
                33.3650521
              ],
              [
                47.0586803,
                33.3618974
              ],
              [
                47.0613324,
                33.360622
              ],
              [
                47.0675206,
                33.3599508
              ],
              [
                47.0712174,
                33.3598837
              ],
              [
                47.0739499,
                33.3597494
              ],
              [
                47.0761198,
                33.3583398
              ],
              [
                47.0778075,
                33.3560575
              ],
              [
                47.0767651,
                33.3540758
              ],
              [
                47.0786135,
                33.3524647
              ],
              [
                47.0808638,
                33.3521291
              ],
              [
                47.0845606,
                33.3519948
              ],
              [
                47.0860876,
                33.3517934
              ],
              [
                47.0876094,
                33.3524296
              ],
              [
                47.0885789,
                33.3526661
              ],
              [
                47.0905881,
                33.3523976
              ],
              [
                47.0931598,
                33.3511221
              ],
              [
                47.0947672,
                33.3506522
              ],
              [
                47.097012,
                33.3500698
              ],
              [
                47.0988494,
                33.3494569
              ],
              [
                47.1017813,
                33.349842
              ],
              [
                47.1038486,
                33.3496452
              ],
              [
                47.1056166,
                33.3489739
              ],
              [
                47.1050541,
                33.3472284
              ],
              [
                47.1038486,
                33.3458186
              ],
              [
                47.1023216,
                33.3437373
              ],
              [
                47.1013572,
                33.3417232
              ],
              [
                47.1019198,
                33.3399776
              ],
              [
                47.1022412,
                33.3378962
              ],
              [
                47.1034467,
                33.3364191
              ],
              [
                47.1054559,
                33.3349419
              ],
              [
                47.1084295,
                33.3337333
              ],
              [
                47.1111183,
                33.3337774
              ],
              [
                47.1125281,
                33.3338005
              ],
              [
                47.1173501,
                33.3351434
              ],
              [
                47.1206452,
                33.3356134
              ],
              [
                47.1232972,
                33.3364191
              ],
              [
                47.1240205,
                33.3378962
              ],
              [
                47.1254671,
                33.3395076
              ],
              [
                47.1272352,
                33.3403804
              ],
              [
                47.1295658,
                33.340649
              ],
              [
                47.1318965,
                33.3403804
              ],
              [
                47.1347093,
                33.3403804
              ],
              [
                47.1376828,
                33.3403133
              ],
              [
                47.1417815,
                33.3397762
              ],
              [
                47.1440318,
                33.3394405
              ],
              [
                47.1469473,
                33.3376313
              ],
              [
                47.150403,
                33.3352813
              ],
              [
                47.1539391,
                33.3324612
              ],
              [
                47.1575556,
                33.3287681
              ],
              [
                47.1628598,
                33.3248062
              ],
              [
                47.1659137,
                33.3219186
              ],
              [
                47.1708965,
                33.3193668
              ],
              [
                47.1742718,
                33.3160089
              ],
              [
                47.1760399,
                33.313121
              ],
              [
                47.177808,
                33.3084196
              ],
              [
                47.1795837,
                33.3062327
              ],
              [
                47.1837673,
                33.3102992
              ],
              [
                47.1873207,
                33.3124726
              ],
              [
                47.1893807,
                33.3150547
              ],
              [
                47.194685,
                33.3201327
              ],
              [
                47.1947108,
                33.321811
              ],
              [
                47.1937065,
                33.3232095
              ],
              [
                47.1938353,
                33.3251244
              ],
              [
                47.1935778,
                33.3258344
              ],
              [
                47.1926251,
                33.326028
              ],
              [
                47.1914406,
                33.3272759
              ],
              [
                47.1912861,
                33.3285237
              ],
              [
                47.1916209,
                33.3290186
              ],
              [
                47.1927538,
                33.3295349
              ],
              [
                47.1936293,
                33.3300943
              ],
              [
                47.1938095,
                33.3311054
              ],
              [
                47.1926251,
                33.3316002
              ],
              [
                47.1918526,
                33.3325468
              ],
              [
                47.1944533,
                33.3363761
              ],
              [
                47.1959467,
                33.3378389
              ],
              [
                47.1964617,
                33.3390866
              ],
              [
                47.1963072,
                33.341711
              ],
              [
                47.1962285,
                33.3423595
              ],
              [
                47.195921,
                33.3448946
              ],
              [
                47.1963587,
                33.3468735
              ],
              [
                47.1988821,
                33.3520142
              ],
              [
                47.1991396,
                33.3546812
              ],
              [
                47.2005816,
                33.3565524
              ],
              [
                47.2025381,
                33.3574605
              ],
              [
                47.2039243,
                33.3575366
              ],
              [
                47.2187301,
                33.352977
              ],
              [
                47.2280513,
                33.349385
              ],
              [
                47.2310897,
                33.3479439
              ],
              [
                47.2357503,
                33.3468899
              ],
              [
                47.2390977,
                33.3480299
              ],
              [
                47.2415439,
                33.3491914
              ],
              [
                47.2466165,
                33.3551278
              ],
              [
                47.2475435,
                33.3570419
              ],
              [
                47.2496043,
                33.3576969
              ],
              [
                47.2741341,
                33.3485199
              ],
              [
                47.2899672,
                33.3457482
              ],
              [
                47.2908,
                33.3454683
              ],
              [
                47.2980236,
                33.3454684
              ],
              [
                47.2994135,
                33.3457482
              ],
              [
                47.301637,
                33.3457482
              ],
              [
                47.3027464,
                33.3460191
              ],
              [
                47.3113567,
                33.3501902
              ],
              [
                47.3263601,
                33.366306
              ],
              [
                47.3269131,
                33.3674074
              ],
              [
                47.3305265,
                33.3665769
              ],
              [
                47.3313594,
                33.366306
              ],
              [
                47.3374697,
                33.364076
              ],
              [
                47.3380259,
                33.3635253
              ],
              [
                47.346916,
                33.3604646
              ],
              [
                47.3741392,
                33.3538017
              ],
              [
                47.3766392,
                33.3535219
              ],
              [
                47.3885824,
                33.3504703
              ],
              [
                47.390806,
                33.3501904
              ],
              [
                47.4191417,
                33.3426879
              ],
              [
                47.4219182,
                33.3421281
              ],
              [
                47.4323906,
                33.3387086
              ],
              [
                47.4324175,
                33.3386998
              ],
              [
                47.4345959,
                33.3379883
              ],
              [
                47.4499747,
                33.3329643
              ],
              [
                47.4508079,
                33.3329643
              ],
              [
                47.4546983,
                33.3313031
              ],
              [
                47.455808,
                33.3310232
              ],
              [
                47.4563647,
                33.3307433
              ],
              [
                47.4574749,
                33.3307433
              ],
              [
                47.4577545,
                33.3304635
              ],
              [
                47.4585423,
                33.3303495
              ],
              [
                47.4588648,
                33.3301926
              ],
              [
                47.4847013,
                33.3207398
              ],
              [
                47.501121,
                33.3157462
              ],
              [
                47.5102576,
                33.3129663
              ],
              [
                47.52088,
                33.3094603
              ],
              [
                47.5309965,
                33.308421
              ],
              [
                47.5318422,
                33.3083341
              ],
              [
                47.534443,
                33.3080669
              ],
              [
                47.5388204,
                33.308196
              ],
              [
                47.5448457,
                33.3094011
              ],
              [
                47.5485536,
                33.3106277
              ],
              [
                47.5587503,
                33.315082
              ],
              [
                47.5740968,
                33.323624
              ],
              [
                47.5821313,
                33.3280305
              ],
              [
                47.5858165,
                33.3265815
              ],
              [
                47.5863696,
                33.3260218
              ],
              [
                47.5874829,
                33.325471
              ],
              [
                47.5880365,
                33.325471
              ],
              [
                47.5974828,
                33.3204692
              ],
              [
                47.5983164,
                33.3204693
              ],
              [
                47.6090112,
                33.3176885
              ],
              [
                47.6088729,
                33.3182392
              ],
              [
                47.6088729,
                33.3185281
              ],
              [
                47.6085928,
                33.3193588
              ],
              [
                47.6083162,
                33.3196387
              ],
              [
                47.6080396,
                33.32102
              ],
              [
                47.6060927,
                33.3274122
              ],
              [
                47.6063728,
                33.3296332
              ],
              [
                47.6077596,
                33.3321341
              ],
              [
                47.6099826,
                33.3321341
              ],
              [
                47.6110928,
                33.332134
              ],
              [
                47.6116495,
                33.3318542
              ],
              [
                47.6133159,
                33.3318542
              ],
              [
                47.6363725,
                33.3251912
              ],
              [
                47.6380391,
                33.3243516
              ],
              [
                47.6449857,
                33.3224105
              ],
              [
                47.6541523,
                33.3207403
              ],
              [
                47.6566523,
                33.3199096
              ],
              [
                47.6652619,
                33.3185282
              ],
              [
                47.6666521,
                33.3182394
              ],
              [
                47.6788754,
                33.3182394
              ],
              [
                47.6805419,
                33.3185283
              ],
              [
                47.6819317,
                33.3185283
              ],
              [
                47.6858185,
                33.319359
              ],
              [
                47.6916549,
                33.3235211
              ],
              [
                47.6999883,
                33.3285229
              ],
              [
                47.7008215,
                33.3288028
              ],
              [
                47.7016547,
                33.3290827
              ],
              [
                47.7019317,
                33.3290826
              ],
              [
                47.7019317,
                33.3293535
              ],
              [
                47.7033216,
                33.3304641
              ],
              [
                47.7033216,
                33.3307439
              ],
              [
                47.707208,
                33.3318544
              ],
              [
                47.7133214,
                33.3343553
              ],
              [
                47.7138781,
                33.3346352
              ],
              [
                47.733601,
                33.3443589
              ],
              [
                47.7341546,
                33.3449186
              ],
              [
                47.7467918,
                33.3485991
              ],
              [
                47.7460537,
                33.3582803
              ],
              [
                47.7484741,
                33.3591406
              ],
              [
                47.7571259,
                33.3599363
              ],
              [
                47.7612715,
                33.3613127
              ],
              [
                47.768713,
                33.3666891
              ],
              [
                47.7713137,
                33.3694417
              ],
              [
                47.7738886,
                33.3713125
              ],
              [
                47.7778797,
                33.3747101
              ],
              [
                47.7804546,
                33.3766238
              ],
              [
                47.7853212,
                33.3793546
              ],
              [
                47.7890806,
                33.3803007
              ],
              [
                47.7968569,
                33.3833753
              ],
              [
                47.7986078,
                33.3837623
              ],
              [
                47.8031139,
                33.3834613
              ],
              [
                47.8119717,
                33.3814402
              ],
              [
                47.8168898,
                33.378946
              ],
              [
                47.8199282,
                33.3777204
              ],
              [
                47.8229923,
                33.3762153
              ],
              [
                47.8287086,
                33.3710975
              ],
              [
                47.831644,
                33.3695277
              ],
              [
                47.8334465,
                33.3689686
              ],
              [
                47.8356352,
                33.3697643
              ],
              [
                47.8382101,
                33.3698933
              ],
              [
                47.8423042,
                33.3697643
              ],
              [
                47.8445444,
                33.3698503
              ],
              [
                47.8464241,
                33.3699578
              ],
              [
                47.8518572,
                33.3749896
              ],
              [
                47.8537013,
                33.3770213
              ],
              [
                47.8544469,
                33.377612
              ],
              [
                47.8555684,
                33.3784868
              ],
              [
                47.8570689,
                33.3797783
              ],
              [
                47.8576759,
                33.3805167
              ],
              [
                47.8582366,
                33.3813117
              ],
              [
                47.8575321,
                33.3816175
              ],
              [
                47.8543468,
                33.3834608
              ],
              [
                47.8522612,
                33.3846649
              ],
              [
                47.8504587,
                33.3872234
              ],
              [
                47.8456694,
                33.3908568
              ],
              [
                47.8364769,
                33.3956079
              ],
              [
                47.8350349,
                33.3979296
              ],
              [
                47.8311983,
                33.4010467
              ],
              [
                47.8252502,
                33.4037552
              ],
              [
                47.8229586,
                33.4058617
              ],
              [
                47.8201519,
                33.4081402
              ],
              [
                47.8173452,
                33.4105691
              ],
              [
                47.816547,
                33.4134922
              ],
              [
                47.809569,
                33.4168236
              ],
              [
                47.8071485,
                33.4180917
              ],
              [
                47.8045479,
                33.4185
              ],
              [
                47.800325,
                33.4180487
              ],
              [
                47.7949949,
                33.418629
              ],
              [
                47.7910038,
                33.4229703
              ],
              [
                47.7904116,
                33.4286867
              ],
              [
                47.7887636,
                33.4334572
              ],
              [
                47.7881199,
                33.4359928
              ],
              [
                47.7870384,
                33.4420092
              ],
              [
                47.7852617,
                33.4456188
              ],
              [
                47.7840258,
                33.4488201
              ],
              [
                47.7791849,
                33.461001
              ],
              [
                47.7798801,
                33.4684977
              ],
              [
                47.7784639,
                33.4721062
              ],
              [
                47.7770735,
                33.4769818
              ],
              [
                47.7770735,
                33.4796235
              ],
              [
                47.7782322,
                33.4838973
              ],
              [
                47.7772795,
                33.4864958
              ],
              [
                47.775786,
                33.4886004
              ],
              [
                47.7742925,
                33.4891372
              ],
              [
                47.767675,
                33.4901465
              ],
              [
                47.7648426,
                33.4908552
              ],
              [
                47.7568346,
                33.4925087
              ],
              [
                47.7612634,
                33.5000671
              ],
              [
                47.7530752,
                33.5030087
              ],
              [
                47.7542194,
                33.5045207
              ],
              [
                47.7629742,
                33.5055513
              ],
              [
                47.7681755,
                33.5061954
              ],
              [
                47.7745111,
                33.5064791
              ],
              [
                47.7766445,
                33.5064774
              ],
              [
                47.7807129,
                33.515151
              ],
              [
                47.7810219,
                33.5184785
              ],
              [
                47.7814081,
                33.5200671
              ],
              [
                47.7808417,
                33.5224713
              ],
              [
                47.7806872,
                33.5236734
              ],
              [
                47.7810219,
                33.5245321
              ],
              [
                47.7818459,
                33.5260132
              ],
              [
                47.7818716,
                33.5277304
              ],
              [
                47.7838028,
                33.5317014
              ],
              [
                47.7842405,
                33.533118
              ],
              [
                47.7859142,
                33.5349209
              ],
              [
                47.7880257,
                33.5366165
              ],
              [
                47.7918108,
                33.5380759
              ],
              [
                47.7962397,
                33.5427117
              ],
              [
                47.7958792,
                33.5445574
              ],
              [
                47.7930983,
                33.546639
              ],
              [
                47.7892616,
                33.5478623
              ],
              [
                47.7838798,
                33.551032
              ],
              [
                47.7424868,
                33.5701982
              ],
              [
                47.7316537,
                33.5760301
              ],
              [
                47.7244306,
                33.5863037
              ],
              [
                47.7224871,
                33.5924156
              ],
              [
                47.7224871,
                33.5954759
              ],
              [
                47.7230437,
                33.5985273
              ],
              [
                47.7233203,
                33.599087
              ],
              [
                47.7233203,
                33.5996467
              ],
              [
                47.7358201,
                33.6146419
              ],
              [
                47.737767,
                33.6182529
              ],
              [
                47.7380436,
                33.6215843
              ],
              [
                47.7380436,
                33.6215844
              ],
              [
                47.7380435,
                33.621864
              ],
              [
                47.7383201,
                33.6232542
              ],
              [
                47.7383201,
                33.623805
              ],
              [
                47.7383201,
                33.6240848
              ],
              [
                47.7383201,
                33.6251952
              ],
              [
                47.7372103,
                33.627416
              ],
              [
                47.7369334,
                33.6288153
              ],
              [
                47.7366532,
                33.6299257
              ],
              [
                47.7358201,
                33.6310271
              ],
              [
                47.73582,
                33.6315868
              ],
              [
                47.7322102,
                33.6354777
              ],
              [
                47.7169301,
                33.6546432
              ],
              [
                47.7086106,
                33.6625148
              ],
              [
                47.6810973,
                33.6885325
              ],
              [
                47.6774839,
                33.6915838
              ],
              [
                47.6747073,
                33.6943642
              ],
              [
                47.6716506,
                33.6971447
              ],
              [
                47.6574842,
                33.7115886
              ],
              [
                47.6491509,
                33.7207603
              ],
              [
                47.639151,
                33.7354748
              ],
              [
                47.639151,
                33.7396454
              ],
              [
                47.6410943,
                33.7446466
              ],
              [
                47.644151,
                33.7538093
              ],
              [
                47.6438709,
                33.7657523
              ],
              [
                47.6433177,
                33.7688125
              ],
              [
                47.6419274,
                33.7721435
              ],
              [
                47.6408176,
                33.7740933
              ],
              [
                47.6344277,
                33.7824254
              ],
              [
                47.6324807,
                33.7854766
              ],
              [
                47.631371,
                33.7874264
              ],
              [
                47.6294276,
                33.7893673
              ],
              [
                47.627481,
                33.7924275
              ],
              [
                47.6269279,
                33.7949279
              ],
              [
                47.6280376,
                33.8007504
              ],
              [
                47.6460941,
                33.8263151
              ],
              [
                47.647484,
                33.8290954
              ],
              [
                47.647806,
                33.8444608
              ],
              [
                47.648721,
                33.8473246
              ],
              [
                47.6511929,
                33.8505752
              ],
              [
                47.6545918,
                33.8549375
              ],
              [
                47.6601794,
                33.8581663
              ],
              [
                47.6639645,
                33.8623572
              ],
              [
                47.6719982,
                33.8689211
              ],
              [
                47.6767876,
                33.8751638
              ],
              [
                47.6690113,
                33.8791187
              ],
              [
                47.6587889,
                33.8837789
              ],
              [
                47.6417429,
                33.8908969
              ],
              [
                47.6357434,
                33.894103
              ],
              [
                47.6284821,
                33.8972021
              ],
              [
                47.6267826,
                33.8976723
              ],
              [
                47.6215298,
                33.900985
              ],
              [
                47.6156332,
                33.9032077
              ],
              [
                47.6117709,
                33.9055157
              ],
              [
                47.6046641,
                33.9090846
              ],
              [
                47.6003897,
                33.9108583
              ],
              [
                47.5875924,
                33.9174184
              ],
              [
                47.5838845,
                33.9193415
              ],
              [
                47.5770352,
                33.9225252
              ],
              [
                47.5741513,
                33.9237644
              ],
              [
                47.5602724,
                33.9297254
              ],
              [
                47.5463936,
                33.9358355
              ],
              [
                47.5366604,
                33.9395099
              ],
              [
                47.5312273,
                33.9419024
              ],
              [
                47.5293219,
                33.9436968
              ],
              [
                47.5236056,
                33.9463028
              ],
              [
                47.5077183,
                33.9511942
              ],
              [
                47.5046542,
                33.953266
              ],
              [
                47.502826,
                33.9549747
              ],
              [
                47.5012553,
                33.9559572
              ],
              [
                47.4990408,
                33.9560213
              ],
              [
                47.4969809,
                33.9552737
              ],
              [
                47.4938395,
                33.9558291
              ],
              [
                47.4914448,
                33.9566407
              ],
              [
                47.4902346,
                33.9567902
              ],
              [
                47.4882605,
                33.9565067
              ],
              [
                47.4922253,
                33.9526508
              ],
              [
                47.4961221,
                33.9497744
              ],
              [
                47.4993836,
                33.9480656
              ],
              [
                47.4977185,
                33.9459581
              ],
              [
                47.4935471,
                33.9487776
              ],
              [
                47.4853074,
                33.9484928
              ],
              [
                47.4778568,
                33.9497446
              ],
              [
                47.4763886,
                33.9457699
              ],
              [
                47.4790056,
                33.9440778
              ],
              [
                47.4836423,
                33.9425403
              ],
              [
                47.4842774,
                33.9376698
              ],
              [
                47.479222,
                33.9325924
              ],
              [
                47.4817025,
                33.929694
              ],
              [
                47.4801576,
                33.9282697
              ],
              [
                47.4815823,
                33.9250221
              ],
              [
                47.4870755,
                33.9234553
              ],
              [
                47.4894788,
                33.9203215
              ],
              [
                47.4983537,
                33.9150223
              ],
              [
                47.5050484,
                33.9071868
              ],
              [
                47.5026452,
                33.9046224
              ],
              [
                47.4990403,
                33.9034826
              ],
              [
                47.4957787,
                33.9010605
              ],
              [
                47.4958302,
                33.8990942
              ],
              [
                47.5011517,
                33.8970994
              ],
              [
                47.5021817,
                33.8941072
              ],
              [
                47.5036065,
                33.8907443
              ],
              [
                47.5051857,
                33.8884519
              ],
              [
                47.5006368,
                33.8856998
              ],
              [
                47.5029885,
                33.8785458
              ],
              [
                47.5000703,
                33.8751253
              ],
              [
                47.4996325,
                33.8714766
              ],
              [
                47.5008084,
                33.8627534
              ],
              [
                47.504585,
                33.8601876
              ],
              [
                47.5063016,
                33.8576217
              ],
              [
                47.50407,
                33.8554834
              ],
              [
                47.5043618,
                33.8533165
              ],
              [
                47.5057855,
                33.8501861
              ],
              [
                47.5059319,
                33.8493758
              ],
              [
                47.5058181,
                33.8482684
              ],
              [
                47.5055579,
                33.8480658
              ],
              [
                47.5051838,
                33.8467422
              ],
              [
                47.5051838,
                33.8467152
              ],
              [
                47.5052326,
                33.8460534
              ],
              [
                47.5054115,
                33.8452835
              ],
              [
                47.5067578,
                33.8437197
              ],
              [
                47.5085477,
                33.8422826
              ],
              [
                47.5092005,
                33.8412991
              ],
              [
                47.5110219,
                33.8404092
              ],
              [
                47.5116786,
                33.8377159
              ],
              [
                47.5112007,
                33.8345859
              ],
              [
                47.5101274,
                33.8327624
              ],
              [
                47.5052668,
                33.8262366
              ],
              [
                47.4993133,
                33.8253325
              ],
              [
                47.4989777,
                33.8263445
              ],
              [
                47.4963802,
                33.8285861
              ],
              [
                47.4936216,
                33.8292502
              ],
              [
                47.4915048,
                33.8290254
              ],
              [
                47.4901579,
                33.8292502
              ],
              [
                47.4846614,
                33.8294123
              ],
              [
                47.4840071,
                33.8297313
              ],
              [
                47.4834048,
                33.8299104
              ],
              [
                47.4829864,
                33.8300201
              ],
              [
                47.4823957,
                33.8300793
              ],
              [
                47.4819212,
                33.8300414
              ],
              [
                47.4811712,
                33.8298749
              ],
              [
                47.4802869,
                33.8295744
              ],
              [
                47.4800267,
                33.8283991
              ],
              [
                47.4799617,
                33.82744
              ],
              [
                47.4798966,
                33.8264403
              ],
              [
                47.4793437,
                33.8258729
              ],
              [
                47.4782216,
                33.8252245
              ],
              [
                47.4768069,
                33.8242653
              ],
              [
                47.4763027,
                33.8238735
              ],
              [
                47.4752945,
                33.8227252
              ],
              [
                47.4750994,
                33.8221578
              ],
              [
                47.4743513,
                33.8214823
              ],
              [
                47.4728227,
                33.8209013
              ],
              [
                47.4719446,
                33.8201448
              ],
              [
                47.4713429,
                33.8193612
              ],
              [
                47.4706761,
                33.8179831
              ],
              [
                47.468741,
                33.8171184
              ],
              [
                47.4672286,
                33.8159565
              ],
              [
                47.4668383,
                33.8145244
              ],
              [
                47.466692,
                33.8136596
              ],
              [
                47.4661879,
                33.8129976
              ],
              [
                47.4658138,
                33.8125382
              ],
              [
                47.4649845,
                33.8118897
              ],
              [
                47.4640738,
                33.8115654
              ],
              [
                47.4631306,
                33.8114303
              ],
              [
                47.46061,
                33.8107412
              ],
              [
                47.459179,
                33.810498
              ],
              [
                47.4585448,
                33.8103628
              ],
              [
                47.4569023,
                33.8101196
              ],
              [
                47.4552761,
                33.8086468
              ],
              [
                47.455081,
                33.8083901
              ],
              [
                47.4545606,
                33.8073497
              ],
              [
                47.4550485,
                33.8064173
              ],
              [
                47.4556176,
                33.8061336
              ],
              [
                47.4562031,
                33.8046607
              ],
              [
                47.4575691,
                33.801796
              ],
              [
                47.4579431,
                33.8009582
              ],
              [
                47.4573577,
                33.7991203
              ],
              [
                47.4562031,
                33.7974447
              ],
              [
                47.4549997,
                33.7967419
              ],
              [
                47.4536825,
                33.7954446
              ],
              [
                47.4519912,
                33.7935661
              ],
              [
                47.4515684,
                33.7927012
              ],
              [
                47.4515522,
                33.7917822
              ],
              [
                47.4513408,
                33.7906064
              ],
              [
                47.4515522,
                33.7892819
              ],
              [
                47.4514871,
                33.7884575
              ],
              [
                47.4507553,
                33.7872952
              ],
              [
                47.4497634,
                33.7861599
              ],
              [
                47.4485112,
                33.7854571
              ],
              [
                47.4471289,
                33.7856598
              ],
              [
                47.4453401,
                33.7867681
              ],
              [
                47.4433237,
                33.7881061
              ],
              [
                47.4421203,
                33.7886738
              ],
              [
                47.4414048,
                33.7888495
              ],
              [
                47.4407706,
                33.7886738
              ],
              [
                47.4403477,
                33.788025
              ],
              [
                47.4411446,
                33.7874844
              ],
              [
                47.4414048,
                33.7869438
              ],
              [
                47.4416812,
                33.7859572
              ],
              [
                47.4417951,
                33.784511
              ],
              [
                47.4427708,
                33.7833081
              ],
              [
                47.4436001,
                33.7826728
              ],
              [
                47.4477144,
                33.7784963
              ],
              [
                47.4483811,
                33.7774825
              ],
              [
                47.4483323,
                33.7768202
              ],
              [
                47.4471127,
                33.7761308
              ],
              [
                47.446511,
                33.7757523
              ],
              [
                47.4455028,
                33.7741437
              ],
              [
                47.4452588,
                33.7726839
              ],
              [
                47.4444457,
                33.7717782
              ],
              [
                47.4440229,
                33.771251
              ],
              [
                47.4435676,
                33.7705886
              ],
              [
                47.4418601,
                33.7700208
              ],
              [
                47.4407055,
                33.7698316
              ],
              [
                47.4392907,
                33.7692638
              ],
              [
                47.4373393,
                33.7681688
              ],
              [
                47.4362498,
                33.7678444
              ],
              [
                47.4322331,
                33.7696018
              ],
              [
                47.4311273,
                33.7700479
              ],
              [
                47.430363,
                33.7703858
              ],
              [
                47.4292734,
                33.7704264
              ],
              [
                47.4282814,
                33.7703993
              ],
              [
                47.426704,
                33.7701966
              ],
              [
                47.42633,
                33.7699127
              ],
              [
                47.4259072,
                33.7695612
              ],
              [
                47.4255657,
                33.768669
              ],
              [
                47.4246062,
                33.7676551
              ],
              [
                47.4232403,
                33.766817
              ],
              [
                47.4226386,
                33.7658166
              ],
              [
                47.4228988,
                33.7647351
              ],
              [
                47.4253868,
                33.7624233
              ],
              [
                47.425273,
                33.7617068
              ],
              [
                47.4243623,
                33.7608551
              ],
              [
                47.4238094,
                33.7593409
              ],
              [
                47.4236468,
                33.7581376
              ],
              [
                47.4232565,
                33.7551632
              ],
              [
                47.4220857,
                33.755055
              ],
              [
                47.4206546,
                33.7549468
              ],
              [
                47.4196139,
                33.7548657
              ],
              [
                47.4178088,
                33.7542708
              ],
              [
                47.4143938,
                33.7511069
              ],
              [
                47.4134018,
                33.7507959
              ],
              [
                47.4128652,
                33.7502145
              ],
              [
                47.4123285,
                33.749552
              ],
              [
                47.4118732,
                33.7480241
              ],
              [
                47.4120683,
                33.7465908
              ],
              [
                47.4107837,
                33.7437376
              ],
              [
                47.4097429,
                33.7406274
              ],
              [
                47.4076939,
                33.7392887
              ],
              [
                47.4063442,
                33.739451
              ],
              [
                47.4048318,
                33.7397079
              ],
              [
                47.4039211,
                33.739167
              ],
              [
                47.4033195,
                33.7385855
              ],
              [
                47.4000183,
                33.7368951
              ],
              [
                47.3974814,
                33.7363271
              ],
              [
                47.3938713,
                33.7363406
              ],
              [
                47.3929281,
                33.7365435
              ],
              [
                47.3907002,
                33.7367058
              ],
              [
                47.3882447,
                33.7367193
              ],
              [
                47.3870413,
                33.7370438
              ],
              [
                47.3825368,
                33.7381257
              ],
              [
                47.3802113,
                33.7386531
              ],
              [
                47.3778859,
                33.7387748
              ],
              [
                47.3753816,
                33.7383556
              ],
              [
                47.3742757,
                33.738031
              ],
              [
                47.3734952,
                33.7375577
              ],
              [
                47.3732675,
                33.7369898
              ],
              [
                47.3729748,
                33.7358944
              ],
              [
                47.3728284,
                33.7352858
              ],
              [
                47.3722105,
                33.7353805
              ],
              [
                47.3706006,
                33.735989
              ],
              [
                47.3693972,
                33.7358944
              ],
              [
                47.3680312,
                33.7359485
              ],
              [
                47.3666652,
                33.7358808
              ],
              [
                47.3650553,
                33.7353669
              ],
              [
                47.3635104,
                33.7341228
              ],
              [
                47.3619005,
                33.733406
              ],
              [
                47.360632,
                33.732838
              ],
              [
                47.3588432,
                33.7325675
              ],
              [
                47.3574772,
                33.7323106
              ],
              [
                47.3550542,
                33.7321077
              ],
              [
                47.3521433,
                33.7330679
              ],
              [
                47.3512815,
                33.7344879
              ],
              [
                47.3511126,
                33.7354766
              ],
              [
                47.3500456,
                33.7367869
              ],
              [
                47.3490536,
                33.7382068
              ],
              [
                47.3476225,
                33.7388019
              ],
              [
                47.346842,
                33.7378958
              ],
              [
                47.3452971,
                33.7367193
              ],
              [
                47.3434595,
                33.7348666
              ],
              [
                47.3425326,
                33.7344068
              ],
              [
                47.3402722,
                33.734285
              ],
              [
                47.3384996,
                33.734231
              ],
              [
                47.3372149,
                33.7340281
              ],
              [
                47.3362067,
                33.733095
              ],
              [
                47.3343041,
                33.7319319
              ],
              [
                47.3324014,
                33.7317425
              ],
              [
                47.3309704,
                33.7313503
              ],
              [
                47.3294743,
                33.7306877
              ],
              [
                47.3275066,
                33.7309176
              ],
              [
                47.326287,
                33.7315532
              ],
              [
                47.3257178,
                33.73227
              ],
              [
                47.3250023,
                33.7330273
              ],
              [
                47.3243681,
                33.7338658
              ],
              [
                47.3235062,
                33.734231
              ],
              [
                47.3223353,
                33.7345285
              ],
              [
                47.3207742,
                33.7341498
              ],
              [
                47.3199611,
                33.7337982
              ],
              [
                47.3192781,
                33.7330003
              ],
              [
                47.3184813,
                33.7323376
              ],
              [
                47.3177169,
                33.732013
              ],
              [
                47.3166924,
                33.7317155
              ],
              [
                47.3160745,
                33.731702
              ],
              [
                47.314985,
                33.7312422
              ],
              [
                47.3138466,
                33.7307012
              ],
              [
                47.3124644,
                33.7297815
              ],
              [
                47.3107731,
                33.7284155
              ],
              [
                47.3095372,
                33.7274418
              ],
              [
                47.3091607,
                33.7270931
              ],
              [
                47.3088217,
                33.726779
              ],
              [
                47.3080737,
                33.7262245
              ],
              [
                47.3071467,
                33.7258864
              ],
              [
                47.3060734,
                33.725697
              ],
              [
                47.3053904,
                33.7259135
              ],
              [
                47.3041708,
                33.7266303
              ],
              [
                47.3028536,
                33.7279692
              ],
              [
                47.302382,
                33.7290647
              ],
              [
                47.3014876,
                33.7301873
              ],
              [
                47.2999265,
                33.7306877
              ],
              [
                47.2947714,
                33.732581
              ],
              [
                47.293503,
                33.7329327
              ],
              [
                47.291828,
                33.7330814
              ],
              [
                47.2891286,
                33.7326487
              ],
              [
                47.2860226,
                33.7330138
              ],
              [
                47.2834694,
                33.7331355
              ],
              [
                47.2815018,
                33.7328245
              ],
              [
                47.2789974,
                33.7319995
              ],
              [
                47.2771924,
                33.7317155
              ],
              [
                47.2761841,
                33.7321212
              ],
              [
                47.2754361,
                33.7327569
              ],
              [
                47.2750783,
                33.7336359
              ],
              [
                47.2750458,
                33.7347043
              ],
              [
                47.2753873,
                33.7350153
              ],
              [
                47.2758751,
                33.7354346
              ],
              [
                47.276298,
                33.7357997
              ],
              [
                47.2764118,
                33.7367463
              ],
              [
                47.2761679,
                33.7376659
              ],
              [
                47.2754198,
                33.7392616
              ],
              [
                47.2743303,
                33.7402894
              ],
              [
                47.2733871,
                33.7409114
              ],
              [
                47.2724602,
                33.7407221
              ],
              [
                47.2718422,
                33.7401406
              ],
              [
                47.270525,
                33.7401271
              ],
              [
                47.2695981,
                33.7403705
              ],
              [
                47.2687947,
                33.7408996
              ],
              [
                47.2683557,
                33.7414119
              ],
              [
                47.267917,
                33.7419238
              ],
              [
                47.2670959,
                33.7428302
              ],
              [
                47.2665721,
                33.7435248
              ],
              [
                47.2655386,
                33.7436778
              ],
              [
                47.2644627,
                33.7441487
              ],
              [
                47.263132,
                33.7449727
              ],
              [
                47.2623109,
                33.7458438
              ],
              [
                47.2620419,
                33.7466913
              ],
              [
                47.2617305,
                33.747327
              ],
              [
                47.2608952,
                33.7480568
              ],
              [
                47.2593521,
                33.7485394
              ],
              [
                47.2574268,
                33.7488102
              ],
              [
                47.2554165,
                33.7489161
              ],
              [
                47.2525427,
                33.7481039
              ],
              [
                47.249315,
                33.7468444
              ],
              [
                47.2477719,
                33.7463617
              ],
              [
                47.2471206,
                33.7460439
              ],
              [
                47.245252,
                33.7449138
              ],
              [
                47.2440345,
                33.7443959
              ],
              [
                47.2426613,
                33.7417708
              ],
              [
                47.2427604,
                33.7400638
              ],
              [
                47.2428878,
                33.7381684
              ],
              [
                47.2429302,
                33.7358728
              ],
              [
                47.2431284,
                33.7348367
              ],
              [
                47.2434399,
                33.7330825
              ],
              [
                47.2435956,
                33.7314931
              ],
              [
                47.2428311,
                33.7306925
              ],
              [
                47.2420101,
                33.730669
              ],
              [
                47.2408067,
                33.7306454
              ],
              [
                47.2388814,
                33.7303511
              ],
              [
                47.2377772,
                33.7302451
              ],
              [
                47.2358094,
                33.7303511
              ],
              [
                47.2331196,
                33.7311399
              ],
              [
                47.2305572,
                33.7320465
              ],
              [
                47.2282497,
                33.7327411
              ],
              [
                47.2272021,
                33.7328118
              ],
              [
                47.2268481,
                33.732329
              ],
              [
                47.226565,
                33.7315167
              ],
              [
                47.2254891,
                33.7309986
              ],
              [
                47.2240168,
                33.7303393
              ],
              [
                47.2217517,
                33.729315
              ],
              [
                47.2200246,
                33.7288794
              ],
              [
                47.2185947,
                33.7286204
              ],
              [
                47.2168534,
                33.7274783
              ],
              [
                47.2151122,
                33.7250293
              ],
              [
                47.2146875,
                33.72384
              ],
              [
                47.21456,
                33.7233808
              ],
              [
                47.2141353,
                33.7225095
              ],
              [
                47.2135832,
                33.7218266
              ],
              [
                47.2120826,
                33.7209435
              ],
              [
                47.2102847,
                33.7201663
              ],
              [
                47.2095061,
                33.7199073
              ],
              [
                47.2086991,
                33.7195069
              ],
              [
                47.2075949,
                33.7199426
              ],
              [
                47.206519,
                33.7201545
              ],
              [
                47.2049051,
                33.7203312
              ],
              [
                47.203447,
                33.720131
              ],
              [
                47.2015075,
                33.719919
              ],
              [
                47.2002617,
                33.7197424
              ],
              [
                47.198931,
                33.7198484
              ],
              [
                47.1980815,
                33.7203312
              ],
              [
                47.1965526,
                33.7211319
              ],
              [
                47.1950803,
                33.7219443
              ],
              [
                47.1940469,
                33.7228274
              ],
              [
                47.1919233,
                33.72384
              ],
              [
                47.1899839,
                33.7248526
              ],
              [
                47.1882426,
                33.7254531
              ],
              [
                47.1865155,
                33.7255473
              ],
              [
                47.1841796,
                33.7255591
              ],
              [
                47.182594,
                33.7259476
              ],
              [
                47.1814049,
                33.7254178
              ],
              [
                47.1812916,
                33.7239225
              ],
              [
                47.1807395,
                33.7236163
              ],
              [
                47.1801449,
                33.7232513
              ],
              [
                47.1787717,
                33.7225919
              ],
              [
                47.1775967,
                33.7221327
              ],
              [
                47.1766057,
                33.7217677
              ],
              [
                47.1761102,
                33.7215204
              ],
              [
                47.1746662,
                33.720025
              ],
              [
                47.1737036,
                33.7187886
              ],
              [
                47.1730948,
                33.7172578
              ],
              [
                47.1734629,
                33.7163511
              ],
              [
                47.1736611,
                33.7160685
              ],
              [
                47.1739725,
                33.7143728
              ],
              [
                47.1734346,
                33.7135956
              ],
              [
                47.1723587,
                33.7133247
              ],
              [
                47.1708439,
                33.7129832
              ],
              [
                47.1688903,
                33.7116408
              ],
              [
                47.1675737,
                33.7106398
              ],
              [
                47.165889,
                33.7105927
              ],
              [
                47.1650962,
                33.7105573
              ],
              [
                47.1635248,
                33.7103218
              ],
              [
                47.1618119,
                33.7098743
              ],
              [
                47.1601414,
                33.709521
              ],
              [
                47.1589664,
                33.7091324
              ],
              [
                47.1587257,
                33.708414
              ],
              [
                47.1583576,
                33.707731
              ],
              [
                47.157494,
                33.7073306
              ],
              [
                47.1571118,
                33.7068006
              ],
              [
                47.156319,
                33.7063766
              ],
              [
                47.1555121,
                33.7062
              ],
              [
                47.1545494,
                33.7070008
              ],
              [
                47.153785,
                33.7077545
              ],
              [
                47.1522844,
                33.7075072
              ],
              [
                47.1509395,
                33.707201
              ],
              [
                47.1498352,
                33.7076485
              ],
              [
                47.1487168,
                33.7082138
              ],
              [
                47.1472445,
                33.7082138
              ],
              [
                47.1461262,
                33.708838
              ],
              [
                47.1440451,
                33.7096859
              ],
              [
                47.1429833,
                33.7096152
              ],
              [
                47.1419357,
                33.7095799
              ],
              [
                47.1405342,
                33.7093326
              ],
              [
                47.1391327,
                33.7084022
              ],
              [
                47.1384673,
                33.7076132
              ],
              [
                47.1378727,
                33.7069773
              ],
              [
                47.1370233,
                33.7066475
              ],
              [
                47.1361456,
                33.7065768
              ],
              [
                47.1344043,
                33.7062942
              ],
              [
                47.1329037,
                33.7059291
              ],
              [
                47.13221,
                33.705882
              ],
              [
                47.1311341,
                33.7066004
              ],
              [
                47.1307094,
                33.7070244
              ],
              [
                47.1298175,
                33.7071775
              ],
              [
                47.1286425,
                33.7068595
              ],
              [
                47.1276091,
                33.7061647
              ],
              [
                47.1273967,
                33.7053167
              ],
              [
                47.1262642,
                33.7042097
              ],
              [
                47.1243813,
                33.703715
              ],
              [
                47.1232346,
                33.7035266
              ],
              [
                47.1218897,
                33.7034677
              ],
              [
                47.1190442,
                33.7035737
              ],
              [
                47.1174162,
                33.7034677
              ],
              [
                47.1167225,
                33.7033146
              ],
              [
                47.1144008,
                33.7031026
              ],
              [
                47.1116402,
                33.7025844
              ],
              [
                47.1104511,
                33.7033735
              ],
              [
                47.1096583,
                33.7045747
              ],
              [
                47.1092244,
                33.705805
              ],
              [
                47.1074518,
                33.706292
              ],
              [
                47.1059557,
                33.7064814
              ],
              [
                47.1040368,
                33.706062
              ],
              [
                47.1029473,
                33.7065626
              ],
              [
                47.0997762,
                33.7075095
              ],
              [
                47.0981012,
                33.7086729
              ],
              [
                47.0963124,
                33.7100392
              ],
              [
                47.0956578,
                33.7099568
              ],
              [
                47.0943773,
                33.7097957
              ],
              [
                47.0937593,
                33.7082265
              ],
              [
                47.0934178,
                33.7067249
              ],
              [
                47.0935642,
                33.7051962
              ],
              [
                47.0927836,
                33.7040598
              ],
              [
                47.0916128,
                33.7036134
              ],
              [
                47.0906208,
                33.7020441
              ],
              [
                47.0889946,
                33.7012188
              ],
              [
                47.0872383,
                33.70061
              ],
              [
                47.0849779,
                33.7009888
              ],
              [
                47.0821853,
                33.7024496
              ],
              [
                47.0807874,
                33.7029999
              ],
              [
                47.0799022,
                33.7033309
              ],
              [
                47.0787333,
                33.7034711
              ],
              [
                47.0773205,
                33.7046519
              ],
              [
                47.0752378,
                33.7061898
              ],
              [
                47.0739314,
                33.7077071
              ],
              [
                47.0719965,
                33.7094705
              ],
              [
                47.0700493,
                33.7112543
              ],
              [
                47.0686073,
                33.7116337
              ],
              [
                47.0672886,
                33.7108033
              ],
              [
                47.0652305,
                33.7090092
              ],
              [
                47.0656988,
                33.7084556
              ],
              [
                47.065514,
                33.7073483
              ],
              [
                47.0643185,
                33.7058822
              ],
              [
                47.0629136,
                33.7047852
              ],
              [
                47.0615579,
                33.7035959
              ],
              [
                47.0599188,
                33.7019247
              ],
              [
                47.0595491,
                33.7004072
              ],
              [
                47.0595737,
                33.6993101
              ],
              [
                47.0601849,
                33.6982814
              ],
              [
                47.0638756,
                33.6956214
              ],
              [
                47.0692401,
                33.6938004
              ],
              [
                47.0712571,
                33.6924971
              ],
              [
                47.0714717,
                33.6912831
              ],
              [
                47.0701627,
                33.6895155
              ],
              [
                47.067502,
                33.6888549
              ],
              [
                47.0656137,
                33.6891406
              ],
              [
                47.0641975,
                33.6883729
              ],
              [
                47.0631246,
                33.6870695
              ],
              [
                47.0626526,
                33.684677
              ],
              [
                47.0601849,
                33.6826058
              ],
              [
                47.0583713,
                33.6820961
              ],
              [
                47.0571728,
                33.6817108
              ],
              [
                47.0563449,
                33.6814654
              ],
              [
                47.056108,
                33.6808336
              ],
              [
                47.0559792,
                33.6798917
              ],
              [
                47.0561509,
                33.6782132
              ],
              [
                47.0549278,
                33.6760347
              ],
              [
                47.0541768,
                33.6728026
              ],
              [
                47.0551424,
                33.671749
              ],
              [
                47.0589189,
                33.6715704
              ],
              [
                47.0606785,
                33.6718383
              ],
              [
                47.0609359,
                33.6705168
              ],
              [
                47.0602278,
                33.6683738
              ],
              [
                47.0582537,
                33.6678023
              ],
              [
                47.0536832,
                33.6682131
              ],
              [
                47.0495634,
                33.6685345
              ],
              [
                47.0472889,
                33.6679988
              ],
              [
                47.0444779,
                33.6672309
              ],
              [
                47.0441131,
                33.6663558
              ],
              [
                47.0447998,
                33.6644449
              ],
              [
                47.044199,
                33.6634448
              ],
              [
                47.04392,
                33.6626589
              ],
              [
                47.0439629,
                33.6618374
              ],
              [
                47.0432334,
                33.6603193
              ],
              [
                47.0439844,
                33.6585512
              ],
              [
                47.0443706,
                33.6568723
              ],
              [
                47.0443706,
                33.6556756
              ],
              [
                47.0432334,
                33.6551755
              ],
              [
                47.0419459,
                33.6550504
              ],
              [
                47.0402078,
                33.6552826
              ],
              [
                47.0381479,
                33.6549611
              ],
              [
                47.0379237,
                33.6546522
              ],
              [
                47.0375256,
                33.6541038
              ],
              [
                47.0377831,
                33.6526034
              ],
              [
                47.0367531,
                33.6513888
              ],
              [
                47.0348863,
                33.6506386
              ],
              [
                47.0319681,
                33.6493526
              ],
              [
                47.0311098,
                33.6480665
              ],
              [
                47.0302086,
                33.6473698
              ],
              [
                47.0281057,
                33.6461909
              ],
              [
                47.0277624,
                33.645655
              ],
              [
                47.0269899,
                33.6439758
              ],
              [
                47.0260458,
                33.6397957
              ],
              [
                47.0243721,
                33.633936
              ],
              [
                47.0234279,
                33.6318814
              ],
              [
                47.0214538,
                33.6317564
              ],
              [
                47.020617,
                33.6305057
              ],
              [
                47.0200805,
                33.6283082
              ],
              [
                47.0206384,
                33.625378
              ],
              [
                47.0215826,
                33.6242702
              ],
              [
                47.0220976,
                33.620911
              ],
              [
                47.0235996,
                33.6195531
              ],
              [
                47.0265178,
                33.6179091
              ],
              [
                47.0281272,
                33.6169442
              ],
              [
                47.0291571,
                33.6154075
              ],
              [
                47.0284276,
                33.6136384
              ],
              [
                47.0275263,
                33.6120301
              ],
              [
                47.026947,
                33.6105647
              ],
              [
                47.0248871,
                33.607902
              ],
              [
                47.0246081,
                33.6068476
              ],
              [
                47.0264964,
                33.6049533
              ],
              [
                47.0269899,
                33.6035235
              ],
              [
                47.028213,
                33.6013253
              ],
              [
                47.0293502,
                33.5971967
              ],
              [
                47.030466,
                33.5941761
              ],
              [
                47.0312171,
                33.5928534
              ],
              [
                47.0338134,
                33.5906727
              ],
              [
                47.0348207,
                33.5904124
              ],
              [
                47.0361738,
                33.589636
              ],
              [
                47.037203,
                33.5886828
              ],
              [
                47.0373983,
                33.5879007
              ],
              [
                47.0369463,
                33.5872765
              ],
              [
                47.0364084,
                33.586384
              ],
              [
                47.0360021,
                33.5854353
              ],
              [
                47.0348626,
                33.5857417
              ],
              [
                47.031775,
                33.5881345
              ],
              [
                47.0298652,
                33.5893679
              ],
              [
                47.0284061,
                33.5901186
              ],
              [
                47.0266037,
                33.5911553
              ],
              [
                47.0245008,
                33.5928355
              ],
              [
                47.0219259,
                33.5945335
              ],
              [
                47.0205795,
                33.5947367
              ],
              [
                47.0197339,
                33.5944116
              ],
              [
                47.018498,
                33.5938021
              ],
              [
                47.0171645,
                33.5933821
              ],
              [
                47.0157172,
                33.5933144
              ],
              [
                47.0142211,
                33.5932331
              ],
              [
                47.0113265,
                33.5939375
              ],
              [
                47.0091637,
                33.5945877
              ],
              [
                47.0074887,
                33.5947232
              ],
              [
                47.0018621,
                33.5938427
              ],
              [
                47.0006262,
                33.5930435
              ],
              [
                46.9992765,
                33.5918921
              ],
              [
                46.9988049,
                33.5904291
              ],
              [
                46.9985935,
                33.5884919
              ],
              [
                46.998317,
                33.587801
              ],
              [
                46.9974064,
                33.5862296
              ],
              [
                46.9968209,
                33.5850104
              ],
              [
                46.9963299,
                33.5847906
              ],
              [
                46.9957314,
                33.5845227
              ],
              [
                46.9939914,
                33.5847801
              ],
              [
                46.9921375,
                33.5854845
              ],
              [
                46.9897145,
                33.5862296
              ],
              [
                46.9873403,
                33.587503
              ],
              [
                46.9857303,
                33.5885055
              ],
              [
                46.9820226,
                33.5908761
              ],
              [
                46.979811,
                33.5928267
              ],
              [
                46.9788353,
                33.5938969
              ],
              [
                46.9777624,
                33.5952956
              ],
              [
                46.9766359,
                33.5972885
              ],
              [
                46.9767324,
                33.5988613
              ],
              [
                46.9775908,
                33.6001303
              ],
              [
                46.9786958,
                33.6008452
              ],
              [
                46.979125,
                33.6014171
              ],
              [
                46.9779233,
                33.6034366
              ],
              [
                46.9769685,
                33.6041604
              ],
              [
                46.9757454,
                33.6049915
              ],
              [
                46.9746403,
                33.6055455
              ],
              [
                46.9740181,
                33.6059476
              ],
              [
                46.9733207,
                33.6063944
              ],
              [
                46.9714109,
                33.6071092
              ],
              [
                46.9700269,
                33.6078866
              ],
              [
                46.9692759,
                33.6083602
              ],
              [
                46.9680314,
                33.6086819
              ],
              [
                46.9671731,
                33.6089052
              ],
              [
                46.9661216,
                33.6088695
              ],
              [
                46.9648878,
                33.6091822
              ],
              [
                46.9638793,
                33.6093341
              ],
              [
                46.9627313,
                33.6096022
              ],
              [
                46.9614868,
                33.6098256
              ],
              [
                46.9602637,
                33.6099149
              ],
              [
                46.9590406,
                33.6099685
              ],
              [
                46.9576566,
                33.6102634
              ],
              [
                46.9562511,
                33.6109246
              ],
              [
                46.9552748,
                33.6115858
              ],
              [
                46.9542341,
                33.6121487
              ],
              [
                46.9537513,
                33.6129261
              ],
              [
                46.9537513,
                33.6135962
              ],
              [
                46.9536655,
                33.6144361
              ],
              [
                46.9536762,
                33.6152938
              ],
              [
                46.9535903,
                33.6162587
              ],
              [
                46.9534616,
                33.617045
              ],
              [
                46.9529573,
                33.6177329
              ],
              [
                46.9520669,
                33.6182332
              ],
              [
                46.9511549,
                33.6184209
              ],
              [
                46.94961,
                33.618805
              ],
              [
                46.9485049,
                33.6187872
              ],
              [
                46.9468634,
                33.6191267
              ],
              [
                46.9453506,
                33.6196359
              ],
              [
                46.9449322,
                33.6199308
              ],
              [
                46.9440202,
                33.6203953
              ],
              [
                46.942722,
                33.6212352
              ],
              [
                46.9410162,
                33.6220928
              ],
              [
                46.9390528,
                33.6228165
              ],
              [
                46.9377546,
                33.6233078
              ],
              [
                46.9362525,
                33.6235044
              ],
              [
                46.9340639,
                33.6228075
              ],
              [
                46.9324653,
                33.6218963
              ],
              [
                46.930813,
                33.6211726
              ],
              [
                46.9294505,
                33.6207348
              ],
              [
                46.9276909,
                33.6203328
              ],
              [
                46.9265537,
                33.620172
              ],
              [
                46.9246225,
                33.6204758
              ],
              [
                46.9234316,
                33.6204489
              ],
              [
                46.9228522,
                33.6203328
              ],
              [
                46.9220261,
                33.6203596
              ],
              [
                46.9211785,
                33.6208421
              ],
              [
                46.9194083,
                33.6210207
              ],
              [
                46.9178419,
                33.6213424
              ],
              [
                46.9173376,
                33.621253
              ],
              [
                46.9163613,
                33.6213156
              ],
              [
                46.9158785,
                33.6211458
              ],
              [
                46.9151811,
                33.62044
              ],
              [
                46.9146232,
                33.6201184
              ],
              [
                46.913722,
                33.6193947
              ],
              [
                46.912853,
                33.61868
              ],
              [
                46.9106321,
                33.6168841
              ],
              [
                46.9093661,
                33.6157227
              ],
              [
                46.9081323,
                33.6151687
              ],
              [
                46.9068985,
                33.6149364
              ],
              [
                46.9057612,
                33.6147845
              ],
              [
                46.9048063,
                33.6148739
              ],
              [
                46.9035081,
                33.6149275
              ],
              [
                46.9022958,
                33.6153385
              ],
              [
                46.9014267,
                33.6157852
              ],
              [
                46.9000105,
                33.6164106
              ],
              [
                46.8987875,
                33.6167948
              ],
              [
                46.8975536,
                33.6171879
              ],
              [
                46.8961696,
                33.6177151
              ],
              [
                46.8946139,
                33.6184298
              ],
              [
                46.8932728,
                33.6190552
              ],
              [
                46.8912129,
                33.6195913
              ],
              [
                46.8869428,
                33.6203596
              ],
              [
                46.8849156,
                33.6207764
              ],
              [
                46.8815628,
                33.6208711
              ],
              [
                46.8788919,
                33.6199247
              ],
              [
                46.8761641,
                33.6194514
              ],
              [
                46.8731523,
                33.6189309
              ],
              [
                46.8713906,
                33.6179844
              ],
              [
                46.8696289,
                33.6168013
              ],
              [
                46.8671285,
                33.6160915
              ],
              [
                46.8648554,
                33.6152396
              ],
              [
                46.8618436,
                33.6140565
              ],
              [
                46.8589453,
                33.6134886
              ],
              [
                46.8562176,
                33.6130154
              ],
              [
                46.8534899,
                33.6129207
              ],
              [
                46.8508758,
                33.6120688
              ],
              [
                46.8472957,
                33.6115482
              ],
              [
                46.8468428,
                33.6116825
              ],
              [
                46.8457917,
                33.61145
              ],
              [
                46.8460074,
                33.6103239
              ],
              [
                46.8466501,
                33.6098086
              ],
              [
                46.8487164,
                33.6082353
              ],
              [
                46.8512168,
                33.6061055
              ],
              [
                46.853774,
                33.604023
              ],
              [
                46.8553652,
                33.6020351
              ],
              [
                46.8572973,
                33.5993371
              ],
              [
                46.8592295,
                33.5967337
              ],
              [
                46.8612185,
                33.5949823
              ],
              [
                46.8625823,
                33.5933256
              ],
              [
                46.862696,
                33.5920001
              ],
              [
                46.8615026,
                33.5913847
              ],
              [
                46.8608775,
                33.5915268
              ],
              [
                46.8604797,
                33.590722
              ],
              [
                46.8593431,
                33.5896806
              ],
              [
                46.8596273,
                33.5886865
              ],
              [
                46.8604797,
                33.5872663
              ],
              [
                46.8610735,
                33.5864971
              ],
              [
                46.8615959,
                33.585359
              ],
              [
                46.8627612,
                33.5845556
              ],
              [
                46.8636854,
                33.5839865
              ],
              [
                46.8647301,
                33.5829822
              ],
              [
                46.8650114,
                33.5822792
              ],
              [
                46.8646096,
                33.5812414
              ],
              [
                46.86469,
                33.579668
              ],
              [
                46.8650114,
                33.5785967
              ],
              [
                46.86469,
                33.5768893
              ],
              [
                46.8632434,
                33.5757845
              ],
              [
                46.8616762,
                33.5746463
              ],
              [
                46.8597072,
                33.5739432
              ],
              [
                46.8572159,
                33.5737423
              ],
              [
                46.8554076,
                33.5739767
              ],
              [
                46.853961,
                33.5752489
              ],
              [
                46.8515099,
                33.5756506
              ],
              [
                46.8494605,
                33.5756171
              ],
              [
                46.847813,
                33.5750145
              ],
              [
                46.8458038,
                33.5746463
              ],
              [
                46.8441965,
                33.5747467
              ],
              [
                46.8431919,
                33.5745123
              ],
              [
                46.8420668,
                33.5737423
              ],
              [
                46.8415846,
                33.5732736
              ],
              [
                46.8406286,
                33.5727304
              ],
              [
                46.839492,
                33.5719729
              ],
              [
                46.8390942,
                33.5708128
              ],
              [
                46.8379861,
                33.569345
              ],
              [
                46.8375315,
                33.5680665
              ],
              [
                46.8380429,
                33.5667881
              ],
              [
                46.8388669,
                33.5657227
              ],
              [
                46.8398046,
                33.5643494
              ],
              [
                46.8402308,
                33.5629999
              ],
              [
                46.8405149,
                33.5614609
              ],
              [
                46.8406854,
                33.5600876
              ],
              [
                46.8406002,
                33.5590221
              ],
              [
                46.8404976,
                33.5576479
              ],
              [
                46.8404692,
                33.5567954
              ],
              [
                46.8400714,
                33.5555168
              ],
              [
                46.8394747,
                33.5546407
              ],
              [
                46.8386223,
                33.5537646
              ],
              [
                46.8383665,
                33.552699
              ],
              [
                46.8385176,
                33.5519856
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555266,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان معمولان",
          "name:en": "Mamulan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q304295"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.4730317,
                33.1451861
              ],
              [
                47.4733118,
                33.1449062
              ],
              [
                47.474145,
                33.1449062
              ],
              [
                47.474145,
                33.1446263
              ],
              [
                47.4758119,
                33.142965
              ],
              [
                47.4758119,
                33.1424142
              ],
              [
                47.4763649,
                33.1401841
              ],
              [
                47.4766451,
                33.1385138
              ],
              [
                47.4769216,
                33.1376922
              ],
              [
                47.4794217,
                33.1349022
              ],
              [
                47.4880533,
                33.1327125
              ],
              [
                47.4901227,
                33.1314066
              ],
              [
                47.4898592,
                33.1297199
              ],
              [
                47.4894187,
                33.1294441
              ],
              [
                47.4886482,
                33.129211
              ],
              [
                47.487262,
                33.1299219
              ],
              [
                47.4847745,
                33.1292705
              ],
              [
                47.4818534,
                33.1278483
              ],
              [
                47.4814727,
                33.1255496
              ],
              [
                47.4827441,
                33.1239906
              ],
              [
                47.4844218,
                33.123246
              ],
              [
                47.4866449,
                33.1207449
              ],
              [
                47.4919216,
                33.1182439
              ],
              [
                47.4914894,
                33.1170929
              ],
              [
                47.4896619,
                33.1149593
              ],
              [
                47.4922255,
                33.1134397
              ],
              [
                47.4955276,
                33.1128952
              ],
              [
                47.499645,
                33.1073299
              ],
              [
                47.5013386,
                33.1049149
              ],
              [
                47.5057499,
                33.103622
              ],
              [
                47.508061,
                33.102614
              ],
              [
                47.5083352,
                33.1023843
              ],
              [
                47.5086514,
                33.1021194
              ],
              [
                47.5092308,
                33.1019952
              ],
              [
                47.5101803,
                33.1018585
              ],
              [
                47.5107208,
                33.1017614
              ],
              [
                47.5116447,
                33.1015767
              ],
              [
                47.5133302,
                33.1022425
              ],
              [
                47.5146359,
                33.1041982
              ],
              [
                47.5191274,
                33.1069899
              ],
              [
                47.5222314,
                33.1062316
              ],
              [
                47.5233055,
                33.1053696
              ],
              [
                47.5236166,
                33.1042694
              ],
              [
                47.5226399,
                33.1013522
              ],
              [
                47.5254563,
                33.0990389
              ],
              [
                47.5259884,
                33.0958458
              ],
              [
                47.5255392,
                33.0934766
              ],
              [
                47.5256132,
                33.0922632
              ],
              [
                47.527758,
                33.0904621
              ],
              [
                47.5305451,
                33.088101
              ],
              [
                47.5291479,
                33.0857399
              ],
              [
                47.5328328,
                33.0835832
              ],
              [
                47.5376454,
                33.0844568
              ],
              [
                47.539566,
                33.0828297
              ],
              [
                47.5403342,
                33.0814237
              ],
              [
                47.541999,
                33.0808941
              ],
              [
                47.5432435,
                33.081301
              ],
              [
                47.5440654,
                33.0815966
              ],
              [
                47.5458403,
                33.0818492
              ],
              [
                47.5469244,
                33.08546
              ],
              [
                47.5491478,
                33.0871304
              ],
              [
                47.5499811,
                33.0871304
              ],
              [
                47.5522045,
                33.0860199
              ],
              [
                47.556091,
                33.0790766
              ],
              [
                47.5622043,
                33.0762957
              ],
              [
                47.5644275,
                33.0740746
              ],
              [
                47.5669275,
                33.0715736
              ],
              [
                47.5755375,
                33.06268
              ],
              [
                47.5785942,
                33.0615695
              ],
              [
                47.5788708,
                33.0610187
              ],
              [
                47.5797039,
                33.0607388
              ],
              [
                47.5799841,
                33.060179
              ],
              [
                47.5872038,
                33.0493533
              ],
              [
                47.5874839,
                33.0490733
              ],
              [
                47.5922039,
                33.0451818
              ],
              [
                47.5933172,
                33.0451819
              ],
              [
                47.5977607,
                33.047403
              ],
              [
                47.5999837,
                33.047403
              ],
              [
                47.6002604,
                33.0471231
              ],
              [
                47.6019272,
                33.0465724
              ],
              [
                47.6113738,
                33.0387983
              ],
              [
                47.6124836,
                33.0387984
              ],
              [
                47.6197069,
                33.0362883
              ],
              [
                47.6238737,
                33.0321259
              ],
              [
                47.6244304,
                33.032126
              ],
              [
                47.6247069,
                33.0318461
              ],
              [
                47.6255401,
                33.0318461
              ],
              [
                47.6280402,
                33.0324059
              ],
              [
                47.6288734,
                33.0326857
              ],
              [
                47.6308168,
                33.0343471
              ],
              [
                47.6322067,
                33.0349069
              ],
              [
                47.6335969,
                33.0349069
              ],
              [
                47.6341501,
                33.0346271
              ],
              [
                47.6366533,
                33.034627
              ],
              [
                47.6372067,
                33.0343471
              ],
              [
                47.6405401,
                33.0337964
              ],
              [
                47.6408201,
                33.0332366
              ],
              [
                47.6416534,
                33.0326858
              ],
              [
                47.6458199,
                33.026853
              ],
              [
                47.6466535,
                33.0262933
              ],
              [
                47.6485965,
                33.0262933
              ],
              [
                47.648873,
                33.0260133
              ],
              [
                47.6502634,
                33.0260134
              ],
              [
                47.6505399,
                33.0257334
              ],
              [
                47.6538732,
                33.0235123
              ],
              [
                47.65721,
                33.0201806
              ],
              [
                47.6605432,
                33.01907
              ],
              [
                47.661653,
                33.0176795
              ],
              [
                47.6749861,
                33.0101855
              ],
              [
                47.6758198,
                33.0101854
              ],
              [
                47.6760999,
                33.0099056
              ],
              [
                47.6769331,
                33.0099056
              ],
              [
                47.6772095,
                33.0096257
              ],
              [
                47.6783194,
                33.0096257
              ],
              [
                47.6785995,
                33.0093457
              ],
              [
                47.6797096,
                33.0090749
              ],
              [
                47.6799862,
                33.008795
              ],
              [
                47.6872094,
                33.0051834
              ],
              [
                47.6905427,
                33.0024024
              ],
              [
                47.691656,
                33.0021316
              ],
              [
                47.7063759,
                33.0049034
              ],
              [
                47.7080427,
                33.0049035
              ],
              [
                47.7083227,
                33.0051834
              ],
              [
                47.7113791,
                33.0051834
              ],
              [
                47.7116561,
                33.0049035
              ],
              [
                47.7122127,
                33.0049036
              ],
              [
                47.717489,
                33.0032422
              ],
              [
                47.7180459,
                33.0029623
              ],
              [
                47.7210992,
                33.0029623
              ],
              [
                47.7216558,
                33.0032422
              ],
              [
                47.7230457,
                33.0032422
              ],
              [
                47.7235988,
                33.0035221
              ],
              [
                47.7266555,
                33.0035221
              ],
              [
                47.7269321,
                33.0032422
              ],
              [
                47.7274892,
                33.0032423
              ],
              [
                47.7280458,
                33.0026824
              ],
              [
                47.728599,
                33.0026824
              ],
              [
                47.7302689,
                33.0007412
              ],
              [
                47.7308224,
                32.9993507
              ],
              [
                47.7422121,
                32.9949085
              ],
              [
                47.7441555,
                32.9949084
              ],
              [
                47.7444356,
                32.9951883
              ],
              [
                47.7491587,
                32.9979603
              ],
              [
                47.7499919,
                32.9979603
              ],
              [
                47.7505454,
                32.9982402
              ],
              [
                47.7519353,
                32.9982401
              ],
              [
                47.7533252,
                32.9982401
              ],
              [
                47.7616586,
                32.9937979
              ],
              [
                47.7713818,
                32.9846333
              ],
              [
                47.7722151,
                32.9832429
              ],
              [
                47.7760044,
                32.9799021
              ],
              [
                47.7763816,
                32.9796312
              ],
              [
                47.7780484,
                32.9790714
              ],
              [
                47.7802685,
                32.9790714
              ],
              [
                47.7808251,
                32.9787915
              ],
              [
                47.784715,
                32.9787916
              ],
              [
                47.7849915,
                32.9785117
              ],
              [
                47.7888814,
                32.9774101
              ],
              [
                47.7902718,
                32.9768503
              ],
              [
                47.7905483,
                32.9765703
              ],
              [
                47.7911049,
                32.9765704
              ],
              [
                47.7969382,
                32.9746291
              ],
              [
                47.798048,
                32.9746293
              ],
              [
                47.7999915,
                32.9740693
              ],
              [
                47.8097147,
                32.9718482
              ],
              [
                47.8111046,
                32.9710176
              ],
              [
                47.8211044,
                32.9654556
              ],
              [
                47.8258279,
                32.959072
              ],
              [
                47.825828,
                32.9582414
              ],
              [
                47.8299944,
                32.9532393
              ],
              [
                47.8322179,
                32.9518487
              ],
              [
                47.8333277,
                32.951018
              ],
              [
                47.8374942,
                32.9482371
              ],
              [
                47.8477741,
                32.9371222
              ],
              [
                47.8486078,
                32.9368513
              ],
              [
                47.8491608,
                32.9362915
              ],
              [
                47.8533274,
                32.9343503
              ],
              [
                47.8555509,
                32.9343503
              ],
              [
                47.8561076,
                32.9340704
              ],
              [
                47.8563841,
                32.9343502
              ],
              [
                47.8572173,
                32.9340704
              ],
              [
                47.8577743,
                32.9343503
              ],
              [
                47.860274,
                32.9343503
              ],
              [
                47.8605509,
                32.9346302
              ],
              [
                47.8613842,
                32.9346301
              ],
              [
                47.862774,
                32.9349011
              ],
              [
                47.8633307,
                32.9349011
              ],
              [
                47.8677742,
                32.9390726
              ],
              [
                47.8691641,
                32.9390726
              ],
              [
                47.8694405,
                32.9387926
              ],
              [
                47.8702739,
                32.9387927
              ],
              [
                47.8719406,
                32.9382329
              ],
              [
                47.8741641,
                32.9365715
              ],
              [
                47.8774974,
                32.9324091
              ],
              [
                47.8774974,
                32.9268471
              ],
              [
                47.8794404,
                32.9229555
              ],
              [
                47.886107,
                32.9201836
              ],
              [
                47.8874973,
                32.919073
              ],
              [
                47.8877738,
                32.9187931
              ],
              [
                47.8888872,
                32.9157321
              ],
              [
                47.8891636,
                32.9149015
              ],
              [
                47.8894402,
                32.9140708
              ],
              [
                47.892497,
                32.9115697
              ],
              [
                47.8936071,
                32.9115697
              ],
              [
                47.8941638,
                32.9112898
              ],
              [
                47.8966639,
                32.9112898
              ],
              [
                47.8997202,
                32.9121296
              ],
              [
                47.9016636,
                32.9137909
              ],
              [
                47.9027768,
                32.913791
              ],
              [
                47.9047202,
                32.9115697
              ],
              [
                47.9044438,
                32.9087887
              ],
              [
                47.9049969,
                32.9076782
              ],
              [
                47.9061101,
                32.9071274
              ],
              [
                47.910277,
                32.9071274
              ],
              [
                47.9105536,
                32.9074073
              ],
              [
                47.912497,
                32.9079581
              ],
              [
                47.9147201,
                32.9079581
              ],
              [
                47.9194436,
                32.905457
              ],
              [
                47.9230534,
                32.9015654
              ],
              [
                47.9236101,
                32.9015654
              ],
              [
                47.9263868,
                32.9001839
              ],
              [
                47.9313864,
                32.9015654
              ],
              [
                47.9344431,
                32.8999041
              ],
              [
                47.9355534,
                32.8987935
              ],
              [
                47.9349998,
                32.8949019
              ],
              [
                47.9347197,
                32.8940712
              ],
              [
                47.9344432,
                32.8924008
              ],
              [
                47.93611,
                32.8896198
              ],
              [
                47.9366666,
                32.8893489
              ],
              [
                47.9438898,
                32.8832361
              ],
              [
                47.9547229,
                32.878234
              ],
              [
                47.9580562,
                32.8779631
              ],
              [
                47.9591663,
                32.878234
              ],
              [
                47.9630563,
                32.8749022
              ],
              [
                47.9638895,
                32.8737916
              ],
              [
                47.9641661,
                32.872681
              ],
              [
                47.9644461,
                32.8707398
              ],
              [
                47.9647232,
                32.8682387
              ],
              [
                47.9649998,
                32.867408
              ],
              [
                47.9652798,
                32.8660084
              ],
              [
                47.9658329,
                32.8649069
              ],
              [
                47.9733327,
                32.8565638
              ],
              [
                47.974723,
                32.856013
              ],
              [
                47.9769461,
                32.856013
              ],
              [
                47.9772226,
                32.8557331
              ],
              [
                47.9780563,
                32.8554622
              ],
              [
                47.9797227,
                32.8554623
              ],
              [
                47.9800028,
                32.8551823
              ],
              [
                47.9811129,
                32.8551823
              ],
              [
                47.9833361,
                32.8529612
              ],
              [
                47.983336,
                32.8526813
              ],
              [
                47.9833361,
                32.8518505
              ],
              [
                47.9827794,
                32.85046
              ],
              [
                47.9822228,
                32.8501802
              ],
              [
                47.981113,
                32.8468483
              ],
              [
                47.9813896,
                32.8465685
              ],
              [
                47.9813896,
                32.8460177
              ],
              [
                47.9825029,
                32.844898
              ],
              [
                47.9833361,
                32.8446181
              ],
              [
                47.9847228,
                32.8446181
              ],
              [
                47.9850029,
                32.8446181
              ],
              [
                47.9852795,
                32.844898
              ],
              [
                47.9863893,
                32.844898
              ],
              [
                47.9875026,
                32.8457377
              ],
              [
                47.9883362,
                32.8457378
              ],
              [
                47.9886127,
                32.8460177
              ],
              [
                47.9897226,
                32.8460177
              ],
              [
                47.9897225,
                32.8462976
              ],
              [
                47.9913893,
                32.8462976
              ],
              [
                47.9941696,
                32.8435165
              ],
              [
                47.9952793,
                32.8418461
              ],
              [
                47.9952793,
                32.8412864
              ],
              [
                47.9952793,
                32.8390652
              ],
              [
                48.0002794,
                32.8232368
              ],
              [
                48.0005591,
                32.8224062
              ],
              [
                48.0008361,
                32.8212865
              ],
              [
                48.0011126,
                32.8204558
              ],
              [
                48.0013928,
                32.8193452
              ],
              [
                48.0025026,
                32.817124
              ],
              [
                48.0025025,
                32.8168441
              ],
              [
                48.0025026,
                32.8165642
              ],
              [
                48.0027792,
                32.8151827
              ],
              [
                48.0033357,
                32.8137922
              ],
              [
                48.0033358,
                32.8135123
              ],
              [
                48.0033358,
                32.8132324
              ],
              [
                48.0033357,
                32.8129525
              ],
              [
                48.0033358,
                32.8118509
              ],
              [
                48.0027791,
                32.8112911
              ],
              [
                48.0030593,
                32.8110111
              ],
              [
                48.0094457,
                32.8007358
              ],
              [
                48.0113927,
                32.7940722
              ],
              [
                48.0116692,
                32.7937923
              ],
              [
                48.0125025,
                32.7904605
              ],
              [
                48.0100024,
                32.7793454
              ],
              [
                48.0066692,
                32.7746231
              ],
              [
                48.0063926,
                32.7743431
              ],
              [
                47.9988928,
                32.7685101
              ],
              [
                47.996946,
                32.7676794
              ],
              [
                47.9952795,
                32.7676794
              ],
              [
                47.9916697,
                32.7671196
              ],
              [
                47.991113,
                32.7673995
              ],
              [
                47.990836,
                32.7671196
              ],
              [
                47.9830563,
                32.7671196
              ],
              [
                47.9825031,
                32.7668397
              ],
              [
                47.9636133,
                32.7665688
              ],
              [
                47.9630567,
                32.7662889
              ],
              [
                47.9586136,
                32.7662888
              ],
              [
                47.9580566,
                32.7660089
              ],
              [
                47.9486102,
                32.7651782
              ],
              [
                47.9433336,
                32.7637876
              ],
              [
                47.9419438,
                32.7632278
              ],
              [
                47.9408335,
                32.7626771
              ],
              [
                47.9400003,
                32.7626771
              ],
              [
                47.9400004,
                32.7623972
              ],
              [
                47.9394436,
                32.7623972
              ],
              [
                47.9350002,
                32.7560044
              ],
              [
                47.9352768,
                32.7551737
              ],
              [
                47.9350003,
                32.7499005
              ],
              [
                47.931667,
                32.7473994
              ],
              [
                47.9308338,
                32.7473994
              ],
              [
                47.9305537,
                32.7471195
              ],
              [
                47.9275005,
                32.7462887
              ],
              [
                47.9244438,
                32.7374039
              ],
              [
                47.9247205,
                32.737124
              ],
              [
                47.9238873,
                32.7310111
              ],
              [
                47.9227774,
                32.7299004
              ],
              [
                47.9222208,
                32.7296206
              ],
              [
                47.9172207,
                32.7276793
              ],
              [
                47.9161105,
                32.7276792
              ],
              [
                47.9105541,
                32.7235076
              ],
              [
                47.9102776,
                32.7212864
              ],
              [
                47.9161106,
                32.7140629
              ],
              [
                47.9172207,
                32.7135122
              ],
              [
                47.918054,
                32.7126725
              ],
              [
                47.9286104,
                32.7073992
              ],
              [
                47.9288874,
                32.7071194
              ],
              [
                47.9411104,
                32.6987853
              ],
              [
                47.9502769,
                32.6901803
              ],
              [
                47.9516672,
                32.6862887
              ],
              [
                47.9519438,
                32.6860087
              ],
              [
                47.950557,
                32.6790651
              ],
              [
                47.9525004,
                32.6748936
              ],
              [
                47.9586139,
                32.6671192
              ],
              [
                47.9588904,
                32.6668393
              ],
              [
                47.9693907,
                32.6587288
              ],
              [
                47.9691466,
                32.6582799
              ],
              [
                47.970131,
                32.6585111
              ],
              [
                47.9713326,
                32.6586956
              ],
              [
                47.9720422,
                32.6586947
              ],
              [
                47.973133,
                32.6584213
              ],
              [
                47.9748801,
                32.6579135
              ],
              [
                47.9774399,
                32.6568573
              ],
              [
                47.9789657,
                32.6559835
              ],
              [
                47.9798889,
                32.6552011
              ],
              [
                47.9804878,
                32.65451
              ],
              [
                47.9815216,
                32.653728
              ],
              [
                47.9821206,
                32.6534494
              ],
              [
                47.9831008,
                32.6534955
              ],
              [
                47.9843064,
                32.6537274
              ],
              [
                47.984447,
                32.6537829
              ],
              [
                47.9852371,
                32.6540946
              ],
              [
                47.9867668,
                32.6546025
              ],
              [
                47.9878082,
                32.6549227
              ],
              [
                47.9891205,
                32.6553847
              ],
              [
                47.9904131,
                32.6556886
              ],
              [
                47.9908715,
                32.6557964
              ],
              [
                47.9919662,
                32.6564876
              ],
              [
                47.9934464,
                32.6572691
              ],
              [
                47.9941389,
                32.6578166
              ],
              [
                47.9944344,
                32.6580501
              ],
              [
                47.9952049,
                32.6589702
              ],
              [
                47.9963569,
                32.6597528
              ],
              [
                47.9972381,
                32.661133
              ],
              [
                47.998066,
                32.6627419
              ],
              [
                47.9989549,
                32.6649968
              ],
              [
                47.9993879,
                32.666346
              ],
              [
                47.9995515,
                32.6665736
              ],
              [
                47.9995906,
                32.666628
              ],
              [
                47.9999771,
                32.6668875
              ],
              [
                48.0012818,
                32.6675904
              ],
              [
                48.0019418,
                32.6681358
              ],
              [
                48.0021668,
                32.6685942
              ],
              [
                48.0021782,
                32.6692887
              ],
              [
                48.0018043,
                32.6698004
              ],
              [
                48.0014801,
                32.6698941
              ],
              [
                48.0013351,
                32.6708643
              ],
              [
                48.001236,
                32.6714164
              ],
              [
                48.0012401,
                32.6716658
              ],
              [
                48.0012435,
                32.6718786
              ],
              [
                48.0012512,
                32.6724806
              ],
              [
                48.0009957,
                32.673358
              ],
              [
                48.0011634,
                32.6738669
              ],
              [
                48.0014992,
                32.6743235
              ],
              [
                48.0020447,
                32.6745484
              ],
              [
                48.0034026,
                32.6745335
              ],
              [
                48.0042152,
                32.6745259
              ],
              [
                48.0050887,
                32.6747023
              ],
              [
                48.0058479,
                32.6746979
              ],
              [
                48.0062828,
                32.6748773
              ],
              [
                48.0067215,
                32.6750568
              ],
              [
                48.0073776,
                32.6752348
              ],
              [
                48.0082474,
                32.6755035
              ],
              [
                48.0086326,
                32.6756366
              ],
              [
                48.0093917,
                32.6756322
              ],
              [
                48.0100366,
                32.6753456
              ],
              [
                48.0107421,
                32.675155
              ],
              [
                48.0119285,
                32.6748204
              ],
              [
                48.0132789,
                32.6743477
              ],
              [
                48.0145759,
                32.6739662
              ],
              [
                48.0159835,
                32.6737224
              ],
              [
                48.0178756,
                32.673195
              ],
              [
                48.0188485,
                32.6729544
              ],
              [
                48.0202561,
                32.6727557
              ],
              [
                48.0211753,
                32.6725206
              ],
              [
                48.0223694,
                32.6725084
              ],
              [
                48.0231819,
                32.6723586
              ],
              [
                48.0239448,
                32.6724015
              ],
              [
                48.0247613,
                32.6725314
              ],
              [
                48.0255241,
                32.6727072
              ],
              [
                48.0260125,
                32.6728856
              ],
              [
                48.0265656,
                32.6734352
              ],
              [
                48.0271683,
                32.673889
              ],
              [
                48.0276146,
                32.6744833
              ],
              [
                48.0283851,
                32.675171
              ],
              [
                48.0291482,
                32.675437
              ],
              [
                48.0298042,
                32.6757095
              ],
              [
                48.030674,
                32.6757459
              ],
              [
                48.0322495,
                32.6757314
              ],
              [
                48.0335502,
                32.6756292
              ],
              [
                48.0352325,
                32.675563
              ],
              [
                48.0371322,
                32.6754998
              ],
              [
                48.0388145,
                32.6755756
              ],
              [
                48.0400123,
                32.6757954
              ],
              [
                48.0416526,
                32.6764269
              ],
              [
                48.043129,
                32.6770546
              ],
              [
                48.0443802,
                32.6774131
              ],
              [
                48.0452004,
                32.6776353
              ],
              [
                48.0462342,
                32.6777183
              ],
              [
                48.0468864,
                32.6777562
              ],
              [
                48.0473175,
                32.6775703
              ],
              [
                48.0478516,
                32.6770554
              ],
              [
                48.0480004,
                32.6763151
              ],
              [
                48.0484772,
                32.6755284
              ],
              [
                48.0492248,
                32.6747369
              ],
              [
                48.0499763,
                32.6743173
              ],
              [
                48.0510559,
                32.6738423
              ],
              [
                48.0525704,
                32.6735534
              ],
              [
                48.0546874,
                32.6733484
              ],
              [
                48.057129,
                32.6733697
              ],
              [
                48.0594102,
                32.6735337
              ],
              [
                48.0618629,
                32.6739698
              ],
              [
                48.0630035,
                32.6741904
              ],
              [
                48.064911,
                32.6745416
              ],
              [
                48.0658416,
                32.6751291
              ],
              [
                48.066887,
                32.6758568
              ],
              [
                48.0676537,
                32.6762196
              ],
              [
                48.068798,
                32.676483
              ],
              [
                48.0697212,
                32.6766128
              ],
              [
                48.0700981,
                32.6766379
              ],
              [
                48.070919,
                32.6766927
              ],
              [
                48.0718955,
                32.6766862
              ],
              [
                48.0727691,
                32.6770897
              ],
              [
                48.0729942,
                32.6775976
              ],
              [
                48.0730592,
                32.6782415
              ],
              [
                48.0732269,
                32.6786083
              ],
              [
                48.0737267,
                32.6792939
              ],
              [
                48.0738564,
                32.6804465
              ],
              [
                48.0745164,
                32.6811291
              ],
              [
                48.0745278,
                32.681774
              ],
              [
                48.0744924,
                32.6821173
              ],
              [
                48.0744324,
                32.6826981
              ],
              [
                48.0743942,
                32.6834839
              ],
              [
                48.0744553,
                32.684033
              ],
              [
                48.0744629,
                32.6845403
              ],
              [
                48.0745811,
                32.685048
              ],
              [
                48.0749093,
                32.685272
              ],
              [
                48.0756226,
                32.6855885
              ],
              [
                48.0767631,
                32.6857638
              ],
              [
                48.0798188,
                32.6866532
              ],
              [
                48.0818368,
                32.6873697
              ],
              [
                48.0833663,
                32.6878628
              ],
              [
                48.0840225,
                32.6880426
              ],
              [
                48.0846749,
                32.6882674
              ],
              [
                48.0853843,
                32.688489
              ],
              [
                48.0865288,
                32.6886644
              ],
              [
                48.0873985,
                32.6888852
              ],
              [
                48.0881156,
                32.6893842
              ],
              [
                48.0883137,
                32.689622
              ],
              [
                48.0886116,
                32.6899795
              ],
              [
                48.0891686,
                32.6908941
              ],
              [
                48.0897255,
                32.6917658
              ],
              [
                48.0899544,
                32.6925465
              ],
              [
                48.0901947,
                32.6939698
              ],
              [
                48.0903205,
                32.6948473
              ],
              [
                48.0904389,
                32.6956299
              ],
              [
                48.0903968,
                32.6962285
              ],
              [
                48.0900269,
                32.6969231
              ],
              [
                48.0895538,
                32.6978025
              ],
              [
                48.0889702,
                32.6987311
              ],
              [
                48.088005,
                32.6995246
              ],
              [
                48.0874786,
                32.7005424
              ],
              [
                48.0870552,
                32.7012832
              ],
              [
                48.08675,
                32.7024391
              ],
              [
                48.0866013,
                32.7034522
              ],
              [
                48.0865632,
                32.7042853
              ],
              [
                48.0859222,
                32.7049827
              ],
              [
                48.0852738,
                32.7051276
              ],
              [
                48.0844574,
                32.7051357
              ],
              [
                48.0832634,
                32.7051462
              ],
              [
                48.0826072,
                32.7048762
              ],
              [
                48.0821724,
                32.704697
              ],
              [
                48.0814055,
                32.7042893
              ],
              [
                48.0804672,
                32.7032847
              ],
              [
                48.0798531,
                32.7023237
              ],
              [
                48.0789222,
                32.7018737
              ],
              [
                48.0781517,
                32.7012337
              ],
              [
                48.0776063,
                32.7010564
              ],
              [
                48.0771714,
                32.7009201
              ],
              [
                48.0764655,
                32.7009284
              ],
              [
                48.0759773,
                32.7009801
              ],
              [
                48.0753365,
                32.7015827
              ],
              [
                48.0748558,
                32.7022364
              ],
              [
                48.0744362,
                32.7032094
              ],
              [
                48.0737457,
                32.7040453
              ],
              [
                48.072731,
                32.704975
              ],
              [
                48.0718193,
                32.7057223
              ],
              [
                48.0705796,
                32.7064281
              ],
              [
                48.0693359,
                32.7067597
              ],
              [
                48.0677147,
                32.7071004
              ],
              [
                48.0656623,
                32.7077218
              ],
              [
                48.0645294,
                32.7082407
              ],
              [
                48.0645027,
                32.7082663
              ],
              [
                48.0639953,
                32.7087511
              ],
              [
                48.0637931,
                32.7096299
              ],
              [
                48.0636979,
                32.7104143
              ],
              [
                48.0638122,
                32.710967
              ],
              [
                48.0640908,
                32.7113341
              ],
              [
                48.0645828,
                32.7115598
              ],
              [
                48.0652351,
                32.7115976
              ],
              [
                48.0661583,
                32.7115899
              ],
              [
                48.0669747,
                32.7117646
              ],
              [
                48.0678977,
                32.7118448
              ],
              [
                48.0686645,
                32.7121625
              ],
              [
                48.0692672,
                32.7124786
              ],
              [
                48.0696526,
                32.7127942
              ],
              [
                48.0698814,
                32.7135321
              ],
              [
                48.0701065,
                32.714085
              ],
              [
                48.0703392,
                32.7150033
              ],
              [
                48.0705643,
                32.7154166
              ],
              [
                48.0710068,
                32.7161031
              ],
              [
                48.0718802,
                32.7164165
              ],
              [
                48.0724297,
                32.7167314
              ],
              [
                48.0732459,
                32.7167707
              ],
              [
                48.0741157,
                32.7168542
              ],
              [
                48.0753594,
                32.7166556
              ],
              [
                48.0765991,
                32.7161819
              ],
              [
                48.078659,
                32.715885
              ],
              [
                48.0802841,
                32.715684
              ],
              [
                48.0820235,
                32.7158057
              ],
              [
                48.0829505,
                32.7160729
              ],
              [
                48.0830421,
                32.7160785
              ],
              [
                48.0835496,
                32.7161094
              ],
              [
                48.0842057,
                32.7164718
              ],
              [
                48.0848656,
                32.7170191
              ],
              [
                48.0854187,
                32.7177037
              ],
              [
                48.0858688,
                32.7184827
              ],
              [
                48.0859832,
                32.7189452
              ],
              [
                48.0860444,
                32.7194064
              ],
              [
                48.0860481,
                32.7196815
              ],
              [
                48.0859489,
                32.7200962
              ],
              [
                48.0854149,
                32.7207487
              ],
              [
                48.084938,
                32.7215806
              ],
              [
                48.0845681,
                32.7220926
              ],
              [
                48.0845795,
                32.7228773
              ],
              [
                48.0845986,
                32.7239799
              ],
              [
                48.0843392,
                32.72472
              ],
              [
                48.0839082,
                32.725048
              ],
              [
                48.0835839,
                32.7250517
              ],
              [
                48.0828782,
                32.7250601
              ],
              [
                48.0824966,
                32.7250625
              ],
              [
                48.081955,
                32.7250679
              ],
              [
                48.0816344,
                32.7252588
              ],
              [
                48.0814209,
                32.7254905
              ],
              [
                48.0814285,
                32.7260429
              ],
              [
                48.0816003,
                32.7265923
              ],
              [
                48.0819397,
                32.7273756
              ],
              [
                48.0819511,
                32.7281107
              ],
              [
                48.0819626,
                32.7288931
              ],
              [
                48.081543,
                32.7299111
              ],
              [
                48.0811272,
                32.7309292
              ],
              [
                48.0809746,
                32.7315793
              ],
              [
                48.0805474,
                32.731948
              ],
              [
                48.0800628,
                32.732232
              ],
              [
                48.0793038,
                32.7323293
              ],
              [
                48.0785941,
                32.7321549
              ],
              [
                48.0776711,
                32.7321672
              ],
              [
                48.0757636,
                32.7316787
              ],
              [
                48.0742874,
                32.7310942
              ],
              [
                48.0728683,
                32.7305562
              ],
              [
                48.072319,
                32.7301444
              ],
              [
                48.0714988,
                32.7298322
              ],
              [
                48.0700874,
                32.729709
              ],
              [
                48.0685693,
                32.7298155
              ],
              [
                48.0678112,
                32.7299255
              ],
              [
                48.0675392,
                32.729965
              ],
              [
                48.0669441,
                32.7302012
              ],
              [
                48.0665779,
                32.7310379
              ],
              [
                48.0665359,
                32.7317739
              ],
              [
                48.0665475,
                32.732509
              ],
              [
                48.066616,
                32.7332499
              ],
              [
                48.0666276,
                32.7339399
              ],
              [
                48.066655,
                32.7340791
              ],
              [
                48.0667457,
                32.7345399
              ],
              [
                48.0670739,
                32.7349015
              ],
              [
                48.0673484,
                32.7350837
              ],
              [
                48.0677834,
                32.7350804
              ],
              [
                48.0681114,
                32.7350768
              ],
              [
                48.0684395,
                32.7352107
              ],
              [
                48.0686645,
                32.7357141
              ],
              [
                48.0686684,
                32.7360388
              ],
              [
                48.0686188,
                32.7364073
              ],
              [
                48.0684585,
                32.73655
              ],
              [
                48.0678138,
                32.737015
              ],
              [
                48.0671158,
                32.7373007
              ],
              [
                48.0664139,
                32.737584
              ],
              [
                48.0656013,
                32.7376822
              ],
              [
                48.0648422,
                32.7378312
              ],
              [
                48.0635986,
                32.7382123
              ],
              [
                48.061689,
                32.7392354
              ],
              [
                48.0609626,
                32.7396245
              ],
              [
                48.0599975,
                32.7403727
              ],
              [
                48.0597916,
                32.7409697
              ],
              [
                48.0598526,
                32.7415233
              ],
              [
                48.0600776,
                32.7419817
              ],
              [
                48.0604096,
                32.7423028
              ],
              [
                48.0611686,
                32.7423859
              ],
              [
                48.0618209,
                32.7423787
              ],
              [
                48.0625267,
                32.7424651
              ],
              [
                48.0631828,
                32.7426406
              ],
              [
                48.063839,
                32.7429129
              ],
              [
                48.063884,
                32.7429377
              ],
              [
                48.064331,
                32.7431836
              ],
              [
                48.0646095,
                32.7435959
              ],
              [
                48.0648919,
                32.7442358
              ],
              [
                48.0648994,
                32.7447432
              ],
              [
                48.0647468,
                32.7454834
              ],
              [
                48.0645408,
                32.7461773
              ],
              [
                48.0641213,
                32.7469631
              ],
              [
                48.0639153,
                32.747657
              ],
              [
                48.0634422,
                32.7485858
              ],
              [
                48.0634499,
                32.7491833
              ],
              [
                48.063501,
                32.7501199
              ],
              [
                48.0636444,
                32.7507431
              ],
              [
                48.063221,
                32.7515761
              ],
              [
                48.0623664,
                32.7528656
              ],
              [
                48.0610275,
                32.7541122
              ],
              [
                48.0600128,
                32.7548074
              ],
              [
                48.0593148,
                32.7555438
              ],
              [
                48.0589272,
                32.7566284
              ],
              [
                48.0588379,
                32.7568782
              ],
              [
                48.058792,
                32.7579838
              ],
              [
                48.0590133,
                32.7590416
              ],
              [
                48.0596085,
                32.7595018
              ],
              [
                48.060955,
                32.7598197
              ],
              [
                48.0617103,
                32.7599569
              ],
              [
                48.0626224,
                32.7599175
              ],
              [
                48.062893,
                32.7599058
              ],
              [
                48.0646171,
                32.7601783
              ],
              [
                48.0655861,
                32.760174
              ],
              [
                48.0663948,
                32.7602651
              ],
              [
                48.066986,
                32.760448
              ],
              [
                48.067852,
                32.7609055
              ],
              [
                48.0681762,
                32.7613639
              ],
              [
                48.0683975,
                32.7618717
              ],
              [
                48.0686684,
                32.7624213
              ],
              [
                48.0687829,
                32.7633391
              ],
              [
                48.0686799,
                32.764263
              ],
              [
                48.0680924,
                32.76509
              ],
              [
                48.0676155,
                32.7658767
              ],
              [
                48.0670242,
                32.766521
              ],
              [
                48.0661125,
                32.767124
              ],
              [
                48.0649873,
                32.767864
              ],
              [
                48.0644494,
                32.76823
              ],
              [
                48.0635375,
                32.7685129
              ],
              [
                48.0627824,
                32.7686034
              ],
              [
                48.0614929,
                32.7685619
              ],
              [
                48.0601997,
                32.7685202
              ],
              [
                48.0587465,
                32.768752
              ],
              [
                48.0580445,
                32.7688032
              ],
              [
                48.0575599,
                32.7686205
              ],
              [
                48.0572357,
                32.7683897
              ],
              [
                48.0565339,
                32.7678864
              ],
              [
                48.0560989,
                32.7676124
              ],
              [
                48.0554505,
                32.7671509
              ],
              [
                48.054966,
                32.7669682
              ],
              [
                48.0544815,
                32.7668802
              ],
              [
                48.0540505,
                32.7670165
              ],
              [
                48.05373,
                32.7672051
              ],
              [
                48.0535697,
                32.767758
              ],
              [
                48.0537415,
                32.7698244
              ],
              [
                48.0537675,
                32.7706794
              ],
              [
                48.0538101,
                32.7720822
              ],
              [
                48.0542527,
                32.7741956
              ],
              [
                48.0545807,
                32.7755309
              ],
              [
                48.054802,
                32.7760342
              ],
              [
                48.0551262,
                32.7765895
              ],
              [
                48.0562095,
                32.7773205
              ],
              [
                48.0569115,
                32.7776863
              ],
              [
                48.0578308,
                32.7780528
              ],
              [
                48.0584903,
                32.7783338
              ],
              [
                48.058693,
                32.7784202
              ],
              [
                48.0595055,
                32.778969
              ],
              [
                48.060154,
                32.7795229
              ],
              [
                48.0622635,
                32.781033
              ],
              [
                48.0640564,
                32.7828714
              ],
              [
                48.0659485,
                32.7843808
              ],
              [
                48.0670357,
                32.7856685
              ],
              [
                48.0675278,
                32.7865411
              ],
              [
                48.0679093,
                32.7876004
              ],
              [
                48.0682373,
                32.7883338
              ],
              [
                48.0682412,
                32.7888861
              ],
              [
                48.0680847,
                32.7896691
              ],
              [
                48.0677644,
                32.7902679
              ],
              [
                48.0672837,
                32.7907299
              ],
              [
                48.0661545,
                32.7913323
              ],
              [
                48.065403,
                32.7915649
              ],
              [
                48.0638923,
                32.7916602
              ],
              [
                48.0629195,
                32.7916644
              ],
              [
                48.0616799,
                32.7914347
              ],
              [
                48.0605469,
                32.7913472
              ],
              [
                48.0591966,
                32.7909842
              ],
              [
                48.0589791,
                32.7907514
              ],
              [
                48.0584373,
                32.7901572
              ],
              [
                48.0578384,
                32.7894669
              ],
              [
                48.0571862,
                32.7881353
              ],
              [
                48.0568581,
                32.7873545
              ],
              [
                48.0565091,
                32.7869798
              ],
              [
                48.0562592,
                32.7867115
              ],
              [
                48.055935,
                32.7863884
              ],
              [
                48.0555573,
                32.7861586
              ],
              [
                48.0553437,
                32.786255
              ],
              [
                48.0552368,
                32.7866221
              ],
              [
                48.0551873,
                32.7872656
              ],
              [
                48.0550873,
                32.7878686
              ],
              [
                48.0550052,
                32.7879504
              ],
              [
                48.0546192,
                32.7896279
              ],
              [
                48.0544558,
                32.7903377
              ],
              [
                48.0543441,
                32.7912262
              ],
              [
                48.054512,
                32.7920528
              ],
              [
                48.0545196,
                32.7935248
              ],
              [
                48.05447,
                32.7941705
              ],
              [
                48.0543666,
                32.7946053
              ],
              [
                48.0542068,
                32.7952778
              ],
              [
                48.0540542,
                32.7975349
              ],
              [
                48.0542222,
                32.7986365
              ],
              [
                48.0543614,
                32.7990261
              ],
              [
                48.0543862,
                32.7990956
              ],
              [
                48.0544472,
                32.7997845
              ],
              [
                48.0547219,
                32.8006587
              ],
              [
                48.0548325,
                32.8015832
              ],
              [
                48.0546761,
                32.8024563
              ],
              [
                48.0544091,
                32.8032389
              ],
              [
                48.0536041,
                32.8037947
              ],
              [
                48.0526351,
                32.8044864
              ],
              [
                48.0517769,
                32.8049057
              ],
              [
                48.0509682,
                32.804997
              ],
              [
                48.0501533,
                32.8049608
              ],
              [
                48.0499955,
                32.8049538
              ],
              [
                48.0490227,
                32.8050954
              ],
              [
                48.0488091,
                32.8054172
              ],
              [
                48.0490266,
                32.8057852
              ],
              [
                48.049889,
                32.8061937
              ],
              [
                48.0562783,
                32.8092197
              ],
              [
                48.0574592,
                32.8099007
              ],
              [
                48.0575661,
                32.8099624
              ],
              [
                48.0579445,
                32.8101805
              ],
              [
                48.0654841,
                32.8086245
              ],
              [
                48.074976,
                32.8078603
              ],
              [
                48.0789286,
                32.8034739
              ],
              [
                48.0783467,
                32.8007824
              ],
              [
                48.0797724,
                32.8002151
              ],
              [
                48.0899842,
                32.8047236
              ],
              [
                48.0979953,
                32.8061275
              ],
              [
                48.1071238,
                32.8155439
              ],
              [
                48.109829,
                32.8208779
              ],
              [
                48.1144269,
                32.8246248
              ],
              [
                48.1208057,
                32.8307657
              ],
              [
                48.1183216,
                32.8335299
              ],
              [
                48.1149866,
                32.832806
              ],
              [
                48.1114794,
                32.8353214
              ],
              [
                48.1077472,
                32.8373066
              ],
              [
                48.1064337,
                32.8425198
              ],
              [
                48.105734,
                32.8435321
              ],
              [
                48.1043761,
                32.8442421
              ],
              [
                48.1045036,
                32.8445738
              ],
              [
                48.1040841,
                32.8459548
              ],
              [
                48.1043091,
                32.8469653
              ],
              [
                48.105236,
                32.8480236
              ],
              [
                48.1062699,
                32.8488499
              ],
              [
                48.106936,
                32.8491029
              ],
              [
                48.1073569,
                32.8492627
              ],
              [
                48.1092605,
                32.8505893
              ],
              [
                48.1104622,
                32.8518748
              ],
              [
                48.1119347,
                32.8529772
              ],
              [
                48.1127548,
                32.8541253
              ],
              [
                48.1135178,
                32.8548124
              ],
              [
                48.1138001,
                32.8559639
              ],
              [
                48.1141319,
                32.8570219
              ],
              [
                48.1141433,
                32.8583114
              ],
              [
                48.1144218,
                32.8592307
              ],
              [
                48.1141502,
                32.859774
              ],
              [
                48.1138915,
                32.8602914
              ],
              [
                48.1146012,
                32.8608848
              ],
              [
                48.1151542,
                32.8624505
              ],
              [
                48.1161346,
                32.8629983
              ],
              [
                48.1173362,
                32.8639637
              ],
              [
                48.1187553,
                32.8652
              ],
              [
                48.1195371,
                32.865538
              ],
              [
                48.1207658,
                32.866069
              ],
              [
                48.1219635,
                32.8668021
              ],
              [
                48.1226234,
                32.8676761
              ],
              [
                48.1230049,
                32.868228
              ],
              [
                48.1236611,
                32.8689148
              ],
              [
                48.1239929,
                32.8693778
              ],
              [
                48.1246986,
                32.8698809
              ],
              [
                48.1256751,
                32.8700611
              ],
              [
                48.1263809,
                32.8699691
              ],
              [
                48.1276245,
                32.8699188
              ],
              [
                48.1282768,
                32.8702404
              ],
              [
                48.1288223,
                32.8704693
              ],
              [
                48.1288833,
                32.8712956
              ],
              [
                48.1286773,
                32.8724021
              ],
              [
                48.1285249,
                32.8733205
              ],
              [
                48.1282081,
                32.8742914
              ],
              [
                48.1282767,
                32.8757175
              ],
              [
                48.1285591,
                32.8766819
              ],
              [
                48.1285668,
                32.8777392
              ],
              [
                48.1285248,
                32.87889
              ],
              [
                48.1285323,
                32.8795822
              ],
              [
                48.1285935,
                32.8804085
              ],
              [
                48.1280097,
                32.8816528
              ],
              [
                48.1273155,
                32.8829915
              ],
              [
                48.1266212,
                32.8839154
              ],
              [
                48.1259193,
                32.8843298
              ],
              [
                48.1257586,
                32.8844964
              ],
              [
                48.1253853,
                32.8848833
              ],
              [
                48.1251716,
                32.8854373
              ],
              [
                48.1253549,
                32.8859945
              ],
              [
                48.1255646,
                32.886632
              ],
              [
                48.1253547,
                32.8874633
              ],
              [
                48.1248208,
                32.8883369
              ],
              [
                48.1245472,
                32.8889917
              ],
              [
                48.1243973,
                32.8893504
              ],
              [
                48.1230507,
                32.8905073
              ],
              [
                48.1219787,
                32.8920243
              ],
              [
                48.1212311,
                32.893089
              ],
              [
                48.1202163,
                32.8947944
              ],
              [
                48.1194688,
                32.8961746
              ],
              [
                48.1190986,
                32.8971893
              ],
              [
                48.1187325,
                32.8984792
              ],
              [
                48.1186829,
                32.8990325
              ],
              [
                48.1195068,
                32.9001807
              ],
              [
                48.1206055,
                32.901741
              ],
              [
                48.1225853,
                32.9046356
              ],
              [
                48.1238519,
                32.9066122
              ],
              [
                48.1265488,
                32.9106097
              ],
              [
                48.1280898,
                32.9126331
              ],
              [
                48.1295127,
                32.9139168
              ],
              [
                48.1310501,
                32.9156606
              ],
              [
                48.1327477,
                32.9171759
              ],
              [
                48.1341172,
                32.9183231
              ],
              [
                48.1356505,
                32.919377
              ],
              [
                48.1368485,
                32.9197426
              ],
              [
                48.1376648,
                32.9198808
              ],
              [
                48.1385345,
                32.9198759
              ],
              [
                48.1397248,
                32.9197341
              ],
              [
                48.1415176,
                32.9194979
              ],
              [
                48.1436807,
                32.9188036
              ],
              [
                48.1456833,
                32.9180605
              ],
              [
                48.1473046,
                32.9172748
              ],
              [
                48.1484908,
                32.9165806
              ],
              [
                48.1496734,
                32.9152913
              ],
              [
                48.1515046,
                32.9139018
              ],
              [
                48.1537055,
                32.9117363
              ],
              [
                48.1554795,
                32.9100276
              ],
              [
                48.1575737,
                32.9079521
              ],
              [
                48.158207,
                32.9064293
              ],
              [
                48.1586081,
                32.9059827
              ],
              [
                48.1594926,
                32.9049979
              ],
              [
                48.1610031,
                32.9040292
              ],
              [
                48.1633224,
                32.9028242
              ],
              [
                48.1641738,
                32.9023863
              ],
              [
                48.1652247,
                32.9018459
              ],
              [
                48.1657486,
                32.9015764
              ],
              [
                48.1691018,
                32.9005548
              ],
              [
                48.1718635,
                32.9000403
              ],
              [
                48.1755486,
                32.8997563
              ],
              [
                48.1767425,
                32.8997539
              ],
              [
                48.1780471,
                32.9001621
              ],
              [
                48.1796875,
                32.9009407
              ],
              [
                48.1817093,
                32.9023162
              ],
              [
                48.1820567,
                32.9026734
              ],
              [
                48.183361,
                32.9040146
              ],
              [
                48.1861687,
                32.9070014
              ],
              [
                48.1879959,
                32.9098961
              ],
              [
                48.1914673,
                32.9137541
              ],
              [
                48.1943398,
                32.9175649
              ],
              [
                48.1973725,
                32.920917
              ],
              [
                48.1991997,
                32.9235389
              ],
              [
                48.2006875,
                32.9250058
              ],
              [
                48.2039413,
                32.9284011
              ],
              [
                48.2073631,
                32.9322622
              ],
              [
                48.2103462,
                32.9355205
              ],
              [
                48.2134857,
                32.9384126
              ],
              [
                48.2164649,
                32.9413034
              ],
              [
                48.2189483,
                32.9438787
              ],
              [
                48.2205544,
                32.9457132
              ],
              [
                48.222599,
                32.9479181
              ],
              [
                48.2254257,
                32.9513169
              ],
              [
                48.2273064,
                32.9534752
              ],
              [
                48.2286873,
                32.9547163
              ],
              [
                48.2303963,
                32.9560886
              ],
              [
                48.2321015,
                32.9573751
              ],
              [
                48.23452,
                32.9589344
              ],
              [
                48.2348116,
                32.9591663
              ],
              [
                48.2358436,
                32.9599871
              ],
              [
                48.2386664,
                32.9629753
              ],
              [
                48.2404862,
                32.9643972
              ],
              [
                48.2441292,
                32.9673809
              ],
              [
                48.2451249,
                32.9682955
              ],
              [
                48.2470818,
                32.971465
              ],
              [
                48.2491394,
                32.9739425
              ],
              [
                48.24965,
                32.9765745
              ],
              [
                48.2499466,
                32.9781032
              ],
              [
                48.2514267,
                32.9794815
              ],
              [
                48.2531777,
                32.9810415
              ],
              [
                48.2551003,
                32.9831553
              ],
              [
                48.2569122,
                32.985084
              ],
              [
                48.2580071,
                32.9861404
              ],
              [
                48.2593193,
                32.9871949
              ],
              [
                48.2604141,
                32.9880687
              ],
              [
                48.2609995,
                32.9883782
              ],
              [
                48.2620506,
                32.9889341
              ],
              [
                48.2635194,
                32.9897079
              ],
              [
                48.26614,
                32.9912147
              ],
              [
                48.268486,
                32.9927718
              ],
              [
                48.2689253,
                32.9930986
              ],
              [
                48.2699622,
                32.9938702
              ],
              [
                48.2710571,
                32.994602
              ],
              [
                48.272419,
                32.9952426
              ],
              [
                48.2730141,
                32.9953773
              ],
              [
                48.2736169,
                32.9957421
              ],
              [
                48.2745972,
                32.9963338
              ],
              [
                48.2759018,
                32.9966508
              ],
              [
                48.2759552,
                32.9966971
              ],
              [
                48.2775841,
                32.996913
              ],
              [
                48.2796974,
                32.9971281
              ],
              [
                48.2818107,
                32.997066
              ],
              [
                48.2827414,
                32.9970014
              ],
              [
                48.2855416,
                32.9968069
              ],
              [
                48.2869492,
                32.9965625
              ],
              [
                48.2881356,
                32.9962772
              ],
              [
                48.2901383,
                32.9962148
              ],
              [
                48.2930603,
                32.9959604
              ],
              [
                48.296196,
                32.9956091
              ],
              [
                48.2990609,
                32.9949409
              ],
              [
                48.3024064,
                32.9941252
              ],
              [
                48.3048363,
                32.9935533
              ],
              [
                48.3068352,
                32.9929811
              ],
              [
                48.3134689,
                32.9906582
              ],
              [
                48.320423,
                32.9882899
              ],
              [
                48.3231735,
                32.9871565
              ],
              [
                48.3253784,
                32.9861173
              ],
              [
                48.3266182,
                32.9854631
              ],
              [
                48.3281822,
                32.9849399
              ],
              [
                48.330288,
                32.9844124
              ],
              [
                48.3323364,
                32.9836087
              ],
              [
                48.3340034,
                32.9827607
              ],
              [
                48.3352432,
                32.9821515
              ],
              [
                48.3378868,
                32.9813875
              ],
              [
                48.3401491,
                32.9806775
              ],
              [
                48.3410682,
                32.9803891
              ],
              [
                48.3438224,
                32.9795799
              ],
              [
                48.3471642,
                32.9784879
              ],
              [
                48.352726,
                32.9771949
              ],
              [
                48.3555908,
                32.9765253
              ],
              [
                48.3575363,
                32.9762307
              ],
              [
                48.3591004,
                32.9756168
              ],
              [
                48.3617935,
                32.974434
              ],
              [
                48.3664246,
                32.9725009
              ],
              [
                48.3696594,
                32.971176
              ],
              [
                48.371601,
                32.9707413
              ],
              [
                48.3740844,
                32.9700272
              ],
              [
                48.3763504,
                32.9693152
              ],
              [
                48.3782348,
                32.9683269
              ],
              [
                48.3806038,
                32.9671977
              ],
              [
                48.3833542,
                32.9663402
              ],
              [
                48.3861084,
                32.9658547
              ],
              [
                48.389679,
                32.9654538
              ],
              [
                48.3934212,
                32.965701
              ],
              [
                48.3976441,
                32.9657621
              ],
              [
                48.4030076,
                32.9659031
              ],
              [
                48.4039555,
                32.9658055
              ],
              [
                48.4044635,
                32.9790728
              ],
              [
                48.40641,
                32.9885173
              ],
              [
                48.4069635,
                32.9890681
              ],
              [
                48.40891,
                32.997131
              ],
              [
                48.4089099,
                32.9999029
              ],
              [
                48.3602615,
                33.0159096
              ],
              [
                48.3592416,
                33.0304818
              ],
              [
                48.3639813,
                33.0337839
              ],
              [
                48.3706097,
                33.0360084
              ],
              [
                48.3770943,
                33.036679
              ],
              [
                48.3788274,
                33.0398851
              ],
              [
                48.3790659,
                33.0485108
              ],
              [
                48.3786988,
                33.0578484
              ],
              [
                48.379087,
                33.0653514
              ],
              [
                48.3800123,
                33.074138
              ],
              [
                48.3797958,
                33.0803328
              ],
              [
                48.3794967,
                33.0840564
              ],
              [
                48.3794108,
                33.0859899
              ],
              [
                48.3795633,
                33.0884182
              ],
              [
                48.3783557,
                33.0958251
              ],
              [
                48.3770293,
                33.1058119
              ],
              [
                48.3761079,
                33.1172029
              ],
              [
                48.3760586,
                33.1266244
              ],
              [
                48.3779032,
                33.1324388
              ],
              [
                48.3813555,
                33.1365281
              ],
              [
                48.3863136,
                33.1401465
              ],
              [
                48.3886727,
                33.1452747
              ],
              [
                48.3891685,
                33.1492119
              ],
              [
                48.3884986,
                33.1549976
              ],
              [
                48.3883267,
                33.1588272
              ],
              [
                48.3854863,
                33.1658013
              ],
              [
                48.3804416,
                33.1711087
              ],
              [
                48.3799932,
                33.1723316
              ],
              [
                48.3796691,
                33.1763532
              ],
              [
                48.3794279,
                33.1814563
              ],
              [
                48.3779663,
                33.1873776
              ],
              [
                48.3740371,
                33.1931642
              ],
              [
                48.3737739,
                33.1960665
              ],
              [
                48.3737107,
                33.2074879
              ],
              [
                48.3749756,
                33.2151496
              ],
              [
                48.3755132,
                33.2259317
              ],
              [
                48.3743748,
                33.2273479
              ],
              [
                48.3657475,
                33.2344277
              ],
              [
                48.3640479,
                33.2372518
              ],
              [
                48.3668803,
                33.2431384
              ],
              [
                48.3691119,
                33.2458661
              ],
              [
                48.3695411,
                33.2490245
              ],
              [
                48.365507,
                33.2506036
              ],
              [
                48.360958,
                33.2499576
              ],
              [
                48.3622455,
                33.2546949
              ],
              [
                48.3656787,
                33.2604368
              ],
              [
                48.3648204,
                33.2633075
              ],
              [
                48.3600997,
                33.2693358
              ],
              [
                48.3570098,
                33.2712734
              ],
              [
                48.3596706,
                33.2785928
              ],
              [
                48.3649062,
                33.2845483
              ],
              [
                48.3666228,
                33.2875618
              ],
              [
                48.3662669,
                33.28931
              ],
              [
                48.3602748,
                33.2908342
              ],
              [
                48.3451019,
                33.289512
              ],
              [
                48.3303763,
                33.2879945
              ],
              [
                48.327531,
                33.2880736
              ],
              [
                48.32345,
                33.2895348
              ],
              [
                48.3197593,
                33.2922252
              ],
              [
                48.316369,
                33.2958841
              ],
              [
                48.3134079,
                33.2998657
              ],
              [
                48.3107042,
                33.3013363
              ],
              [
                48.3060693,
                33.3033808
              ],
              [
                48.3001218,
                33.3078207
              ],
              [
                48.2944752,
                33.3118388
              ],
              [
                48.2909201,
                33.3136025
              ],
              [
                48.2898901,
                33.3051384
              ],
              [
                48.2723807,
                33.3018385
              ],
              [
                48.2557295,
                33.3039906
              ],
              [
                48.2445715,
                33.2844766
              ],
              [
                48.1868933,
                33.2927993
              ],
              [
                48.1710147,
                33.2954537
              ],
              [
                48.1595991,
                33.2983951
              ],
              [
                48.1509303,
                33.2990407
              ],
              [
                48.1422614,
                33.3012646
              ],
              [
                48.1317627,
                33.3042194
              ],
              [
                48.1159091,
                33.3150518
              ],
              [
                48.1062293,
                33.3221996
              ],
              [
                48.0998611,
                33.3280901
              ],
              [
                48.0962538,
                33.3305676
              ],
              [
                48.0955417,
                33.3314987
              ],
              [
                48.0970038,
                33.3371796
              ],
              [
                48.0962562,
                33.3387211
              ],
              [
                48.0958493,
                33.3406128
              ],
              [
                48.0956211,
                33.3441166
              ],
              [
                48.095984,
                33.3480934
              ],
              [
                48.0956346,
                33.3506292
              ],
              [
                48.094648,
                33.3715706
              ],
              [
                48.0945623,
                33.3865367
              ],
              [
                48.0961848,
                33.397511
              ],
              [
                48.0979681,
                33.4031515
              ],
              [
                48.0995187,
                33.4113117
              ],
              [
                48.0991744,
                33.4191202
              ],
              [
                48.0982303,
                33.4217709
              ],
              [
                48.0964186,
                33.4236788
              ],
              [
                48.0927464,
                33.4271645
              ],
              [
                48.0874156,
                33.4292925
              ],
              [
                48.0600033,
                33.4357534
              ],
              [
                48.0500035,
                33.440755
              ],
              [
                48.0277804,
                33.4446371
              ],
              [
                48.0272237,
                33.444917
              ],
              [
                48.0252804,
                33.444917
              ],
              [
                48.0252804,
                33.4451968
              ],
              [
                48.0236139,
                33.4451969
              ],
              [
                48.0186137,
                33.446858
              ],
              [
                48.0183337,
                33.4471379
              ],
              [
                48.0175005,
                33.4471379
              ],
              [
                48.006944,
                33.4529701
              ],
              [
                48.0000005,
                33.4568612
              ],
              [
                47.9974722,
                33.4576885
              ],
              [
                47.9953286,
                33.4578149
              ],
              [
                47.9866027,
                33.4587001
              ],
              [
                47.9832033,
                33.4589439
              ],
              [
                47.9758523,
                33.4591336
              ],
              [
                47.9664757,
                33.4604136
              ],
              [
                47.9613258,
                33.4603492
              ],
              [
                47.9540903,
                33.4608218
              ],
              [
                47.9518244,
                33.4595544
              ],
              [
                47.9507687,
                33.4584588
              ],
              [
                47.9476015,
                33.4513694
              ],
              [
                47.946932,
                33.4488772
              ],
              [
                47.9457562,
                33.448093
              ],
              [
                47.9452412,
                33.4477385
              ],
              [
                47.9445245,
                33.4477063
              ],
              [
                47.943031,
                33.4478639
              ],
              [
                47.9400227,
                33.4471727
              ],
              [
                47.9377439,
                33.4473804
              ],
              [
                47.9306259,
                33.4472576
              ],
              [
                47.9184894,
                33.4438128
              ],
              [
                47.9160175,
                33.4448871
              ],
              [
                47.9115114,
                33.4476587
              ],
              [
                47.9034004,
                33.4511392
              ],
              [
                47.8988685,
                33.4546195
              ],
              [
                47.8889293,
                33.4603553
              ],
              [
                47.882801,
                33.4632553
              ],
              [
                47.8805351,
                33.4646086
              ],
              [
                47.8780889,
                33.4655322
              ],
              [
                47.8762607,
                33.466864
              ],
              [
                47.8706989,
                33.4704296
              ],
              [
                47.8693342,
                33.4710525
              ],
              [
                47.8661284,
                33.4724353
              ],
              [
                47.8606438,
                33.4744972
              ],
              [
                47.8576312,
                33.4765376
              ],
              [
                47.8536401,
                33.4787713
              ],
              [
                47.8457351,
                33.4855792
              ],
              [
                47.8446536,
                33.4870181
              ],
              [
                47.8412289,
                33.4912056
              ],
              [
                47.8394265,
                33.4919572
              ],
              [
                47.8364653,
                33.4929236
              ],
              [
                47.8323712,
                33.4926229
              ],
              [
                47.8271441,
                33.4927947
              ],
              [
                47.8180547,
                33.4927303
              ],
              [
                47.8150678,
                33.4928591
              ],
              [
                47.8128276,
                33.4937181
              ],
              [
                47.8123383,
                33.4948347
              ],
              [
                47.8114629,
                33.4958869
              ],
              [
                47.8079867,
                33.4963807
              ],
              [
                47.8053077,
                33.496338
              ],
              [
                47.7995942,
                33.497781
              ],
              [
                47.7960666,
                33.4980172
              ],
              [
                47.7925647,
                33.499327
              ],
              [
                47.7857926,
                33.502741
              ],
              [
                47.7844279,
                33.5039004
              ],
              [
                47.7803338,
                33.504201
              ],
              [
                47.7787116,
                33.5044372
              ],
              [
                47.7766445,
                33.5064774
              ],
              [
                47.7745111,
                33.5064791
              ],
              [
                47.7681755,
                33.5061954
              ],
              [
                47.7629742,
                33.5055513
              ],
              [
                47.7542194,
                33.5045207
              ],
              [
                47.7530752,
                33.5030087
              ],
              [
                47.7612634,
                33.5000671
              ],
              [
                47.7568346,
                33.4925087
              ],
              [
                47.7648426,
                33.4908552
              ],
              [
                47.767675,
                33.4901465
              ],
              [
                47.7742925,
                33.4891372
              ],
              [
                47.775786,
                33.4886004
              ],
              [
                47.7772795,
                33.4864958
              ],
              [
                47.7782322,
                33.4838973
              ],
              [
                47.7770735,
                33.4796235
              ],
              [
                47.7770735,
                33.4769818
              ],
              [
                47.7784639,
                33.4721062
              ],
              [
                47.7798801,
                33.4684977
              ],
              [
                47.7791849,
                33.461001
              ],
              [
                47.7840258,
                33.4488201
              ],
              [
                47.7852617,
                33.4456188
              ],
              [
                47.7870384,
                33.4420092
              ],
              [
                47.7881199,
                33.4359928
              ],
              [
                47.7887636,
                33.4334572
              ],
              [
                47.7904116,
                33.4286867
              ],
              [
                47.7910038,
                33.4229703
              ],
              [
                47.7949949,
                33.418629
              ],
              [
                47.800325,
                33.4180487
              ],
              [
                47.8045479,
                33.4185
              ],
              [
                47.8071485,
                33.4180917
              ],
              [
                47.809569,
                33.4168236
              ],
              [
                47.816547,
                33.4134922
              ],
              [
                47.8173452,
                33.4105691
              ],
              [
                47.8201519,
                33.4081402
              ],
              [
                47.8229586,
                33.4058617
              ],
              [
                47.8252502,
                33.4037552
              ],
              [
                47.8311983,
                33.4010467
              ],
              [
                47.8350349,
                33.3979296
              ],
              [
                47.8364769,
                33.3956079
              ],
              [
                47.8456694,
                33.3908568
              ],
              [
                47.8504587,
                33.3872234
              ],
              [
                47.8522612,
                33.3846649
              ],
              [
                47.8543468,
                33.3834608
              ],
              [
                47.8575321,
                33.3816175
              ],
              [
                47.8582366,
                33.3813117
              ],
              [
                47.8576759,
                33.3805167
              ],
              [
                47.8570689,
                33.3797783
              ],
              [
                47.8555684,
                33.3784868
              ],
              [
                47.8544469,
                33.377612
              ],
              [
                47.8537013,
                33.3770213
              ],
              [
                47.8518572,
                33.3749896
              ],
              [
                47.8464241,
                33.3699578
              ],
              [
                47.8445444,
                33.3698503
              ],
              [
                47.8423042,
                33.3697643
              ],
              [
                47.8382101,
                33.3698933
              ],
              [
                47.8356352,
                33.3697643
              ],
              [
                47.8334465,
                33.3689686
              ],
              [
                47.831644,
                33.3695277
              ],
              [
                47.8287086,
                33.3710975
              ],
              [
                47.8229923,
                33.3762153
              ],
              [
                47.8199282,
                33.3777204
              ],
              [
                47.8168898,
                33.378946
              ],
              [
                47.8119717,
                33.3814402
              ],
              [
                47.8031139,
                33.3834613
              ],
              [
                47.7986078,
                33.3837623
              ],
              [
                47.7968569,
                33.3833753
              ],
              [
                47.7890806,
                33.3803007
              ],
              [
                47.7853212,
                33.3793546
              ],
              [
                47.7804546,
                33.3766238
              ],
              [
                47.7778797,
                33.3747101
              ],
              [
                47.7738886,
                33.3713125
              ],
              [
                47.7713137,
                33.3694417
              ],
              [
                47.768713,
                33.3666891
              ],
              [
                47.7612715,
                33.3613127
              ],
              [
                47.7571259,
                33.3599363
              ],
              [
                47.7484741,
                33.3591406
              ],
              [
                47.7460537,
                33.3582803
              ],
              [
                47.7467918,
                33.3485991
              ],
              [
                47.7341546,
                33.3449186
              ],
              [
                47.733601,
                33.3443589
              ],
              [
                47.7138781,
                33.3346352
              ],
              [
                47.7133214,
                33.3343553
              ],
              [
                47.707208,
                33.3318544
              ],
              [
                47.7033216,
                33.3307439
              ],
              [
                47.7033216,
                33.3304641
              ],
              [
                47.7019317,
                33.3293535
              ],
              [
                47.7019317,
                33.3290826
              ],
              [
                47.7016547,
                33.3290827
              ],
              [
                47.7008215,
                33.3288028
              ],
              [
                47.6999883,
                33.3285229
              ],
              [
                47.6916549,
                33.3235211
              ],
              [
                47.6858185,
                33.319359
              ],
              [
                47.6819317,
                33.3185283
              ],
              [
                47.6805419,
                33.3185283
              ],
              [
                47.6788754,
                33.3182394
              ],
              [
                47.6666521,
                33.3182394
              ],
              [
                47.6652619,
                33.3185282
              ],
              [
                47.6566523,
                33.3199096
              ],
              [
                47.6541523,
                33.3207403
              ],
              [
                47.6449857,
                33.3224105
              ],
              [
                47.6380391,
                33.3243516
              ],
              [
                47.6363725,
                33.3251912
              ],
              [
                47.6133159,
                33.3318542
              ],
              [
                47.6116495,
                33.3318542
              ],
              [
                47.6110928,
                33.332134
              ],
              [
                47.6099826,
                33.3321341
              ],
              [
                47.6077596,
                33.3321341
              ],
              [
                47.6063728,
                33.3296332
              ],
              [
                47.6060927,
                33.3274122
              ],
              [
                47.6080396,
                33.32102
              ],
              [
                47.6083162,
                33.3196387
              ],
              [
                47.6085928,
                33.3193588
              ],
              [
                47.6088729,
                33.3185281
              ],
              [
                47.6088729,
                33.3182392
              ],
              [
                47.6090112,
                33.3176885
              ],
              [
                47.6097061,
                33.3162981
              ],
              [
                47.6099826,
                33.3151966
              ],
              [
                47.6249826,
                33.2924087
              ],
              [
                47.6252627,
                33.2912982
              ],
              [
                47.6313727,
                33.2790734
              ],
              [
                47.6313727,
                33.2782428
              ],
              [
                47.6360958,
                33.2668488
              ],
              [
                47.641096,
                33.2507417
              ],
              [
                47.6422058,
                33.2454689
              ],
              [
                47.6424859,
                33.2451891
              ],
              [
                47.6427625,
                33.2432478
              ],
              [
                47.6430394,
                33.2407469
              ],
              [
                47.6433195,
                33.240467
              ],
              [
                47.6424858,
                33.238246
              ],
              [
                47.6413726,
                33.2343547
              ],
              [
                47.6294295,
                33.2124058
              ],
              [
                47.6291494,
                33.2118551
              ],
              [
                47.6291494,
                33.2115752
              ],
              [
                47.6283162,
                33.2115752
              ],
              [
                47.6274829,
                33.2112953
              ],
              [
                47.616373,
                33.2101847
              ],
              [
                47.6147065,
                33.2104647
              ],
              [
                47.6116498,
                33.2104646
              ],
              [
                47.6097064,
                33.2107445
              ],
              [
                47.6066498,
                33.2107445
              ],
              [
                47.6047068,
                33.2110244
              ],
              [
                47.5966499,
                33.211575
              ],
              [
                47.5833169,
                33.2140761
              ],
              [
                47.5574804,
                33.2196287
              ],
              [
                47.5552573,
                33.2196286
              ],
              [
                47.5535904,
                33.2199085
              ],
              [
                47.5510904,
                33.2199085
              ],
              [
                47.5497041,
                33.2201884
              ],
              [
                47.5438708,
                33.2201884
              ],
              [
                47.5427575,
                33.2199085
              ],
              [
                47.5402574,
                33.2199085
              ],
              [
                47.5397008,
                33.2196286
              ],
              [
                47.5277576,
                33.2168477
              ],
              [
                47.5266477,
                33.2165769
              ],
              [
                47.5244243,
                33.2157372
              ],
              [
                47.523591,
                33.2151864
              ],
              [
                47.5224904,
                33.2142385
              ],
              [
                47.5135913,
                33.206573
              ],
              [
                47.5044247,
                33.1949078
              ],
              [
                47.4880351,
                33.1671262
              ],
              [
                47.4783118,
                33.1524092
              ],
              [
                47.4774787,
                33.1510187
              ],
              [
                47.4730317,
                33.1451861
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 819610896
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.7117493,
          33.1524187
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 819610941
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          47.6078615,
          33.533792
        ]
      }
    }
  ]
},
"مازندران.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554865,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آمل",
          "name:en": "Amol County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282247",
          "wikipedia": "en:Amol County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.7274191,
                36.0266362
              ],
              [
                51.7285028,
                36.0261011
              ],
              [
                51.760449,
                36.0066529
              ],
              [
                51.7698922,
                36.0002271
              ],
              [
                51.7798922,
                35.9808143
              ],
              [
                51.8143384,
                35.9524786
              ],
              [
                51.8246184,
                35.9419245
              ],
              [
                51.8291354,
                35.9346017
              ],
              [
                51.8473982,
                35.9049799
              ],
              [
                51.8507316,
                35.9005364
              ],
              [
                51.8573981,
                35.886088
              ],
              [
                51.8573981,
                35.8855381
              ],
              [
                51.8607314,
                35.8788772
              ],
              [
                51.8776744,
                35.8605858
              ],
              [
                51.8782311,
                35.8599847
              ],
              [
                51.8821211,
                35.8571995
              ],
              [
                51.9340671,
                35.828869
              ],
              [
                51.9843466,
                35.7985906
              ],
              [
                51.9929599,
                35.7933082
              ],
              [
                52.0062932,
                35.7866467
              ],
              [
                52.0104597,
                35.7846996
              ],
              [
                52.0268495,
                35.7785878
              ],
              [
                52.0376827,
                35.7738642
              ],
              [
                52.0515726,
                35.7685908
              ],
              [
                52.0587959,
                35.7666436
              ],
              [
                52.0601859,
                35.7660937
              ],
              [
                52.0726856,
                35.7633173
              ],
              [
                52.0957422,
                35.7616496
              ],
              [
                52.0965753,
                35.7613611
              ],
              [
                52.1101886,
                35.7613611
              ],
              [
                52.1121319,
                35.7616496
              ],
              [
                52.1185218,
                35.7616496
              ],
              [
                52.1226884,
                35.76192
              ],
              [
                52.1293549,
                35.7621995
              ],
              [
                52.1374115,
                35.7621995
              ],
              [
                52.1551879,
                35.7630289
              ],
              [
                52.1560213,
                35.7633173
              ],
              [
                52.1585212,
                35.7630289
              ],
              [
                52.1751912,
                35.7630289
              ],
              [
                52.1771345,
                35.7633173
              ],
              [
                52.1840776,
                35.7633174
              ],
              [
                52.1907477,
                35.7635878
              ],
              [
                52.1918577,
                35.7638672
              ],
              [
                52.1946343,
                35.7638673
              ],
              [
                52.1954675,
                35.7641467
              ],
              [
                52.1979676,
                35.7641467
              ],
              [
                52.1990809,
                35.7644262
              ],
              [
                52.201024,
                35.7644261
              ],
              [
                52.2024141,
                35.7646966
              ],
              [
                52.2046374,
                35.7646966
              ],
              [
                52.2090807,
                35.7652555
              ],
              [
                52.2107473,
                35.7652555
              ],
              [
                52.2113042,
                35.765535
              ],
              [
                52.2135239,
                35.765535
              ],
              [
                52.2146375,
                35.7658144
              ],
              [
                52.2154707,
                35.765535
              ],
              [
                52.2165806,
                35.7655351
              ],
              [
                52.2171373,
                35.7658144
              ],
              [
                52.217414,
                35.765535
              ],
              [
                52.2179707,
                35.7655349
              ],
              [
                52.2182473,
                35.7658144
              ],
              [
                52.2201905,
                35.7658144
              ],
              [
                52.2260273,
                35.7669232
              ],
              [
                52.2274139,
                35.7674821
              ],
              [
                52.2374138,
                35.7696997
              ],
              [
                52.240747,
                35.771088
              ],
              [
                52.2446369,
                35.7730351
              ],
              [
                52.2657501,
                35.7974821
              ],
              [
                52.2665834,
                35.7985908
              ],
              [
                52.2921399,
                35.8155375
              ],
              [
                52.3003625,
                35.818777
              ],
              [
                52.3196427,
                35.8263724
              ],
              [
                52.326586,
                35.8283195
              ],
              [
                52.3782555,
                35.8485917
              ],
              [
                52.3785321,
                35.8488711
              ],
              [
                52.3793654,
                35.8494299
              ],
              [
                52.3943686,
                35.8616436
              ],
              [
                52.4090882,
                35.8830327
              ],
              [
                52.412425,
                35.8874763
              ],
              [
                52.4152015,
                35.8910908
              ],
              [
                52.4157583,
                35.8922085
              ],
              [
                52.4176557,
                35.8941065
              ],
              [
                52.4357581,
                35.9122089
              ],
              [
                52.4627044,
                35.92526
              ],
              [
                52.4635377,
                35.9252599
              ],
              [
                52.4663143,
                35.9263775
              ],
              [
                52.4685377,
                35.9269273
              ],
              [
                52.4702042,
                35.9277655
              ],
              [
                52.4740942,
                35.9288742
              ],
              [
                52.4752041,
                35.929424
              ],
              [
                52.4790942,
                35.9302622
              ],
              [
                52.4796475,
                35.9302622
              ],
              [
                52.4805157,
                35.9304368
              ],
              [
                52.4782609,
                35.9374816
              ],
              [
                52.4774276,
                35.9394284
              ],
              [
                52.4774275,
                35.9399781
              ],
              [
                52.4771475,
                35.9402576
              ],
              [
                52.4768708,
                35.9424838
              ],
              [
                52.4765942,
                35.9449804
              ],
              [
                52.4763141,
                35.9474859
              ],
              [
                52.4765942,
                35.9516498
              ],
              [
                52.4818708,
                35.9735958
              ],
              [
                52.4829806,
                35.9766511
              ],
              [
                52.483814,
                35.978039
              ],
              [
                52.4896507,
                35.9830409
              ],
              [
                52.492984,
                35.9866459
              ],
              [
                52.4960372,
                35.9927654
              ],
              [
                52.4963173,
                35.9947031
              ],
              [
                52.4999272,
                35.9977582
              ],
              [
                52.5007605,
                36.0019309
              ],
              [
                52.5232602,
                36.0327616
              ],
              [
                52.5243735,
                36.0338701
              ],
              [
                52.5249303,
                36.0341494
              ],
              [
                52.5249302,
                36.0344288
              ],
              [
                52.5271501,
                36.0385923
              ],
              [
                52.5279833,
                36.0416474
              ],
              [
                52.5288167,
                36.0469284
              ],
              [
                52.5293735,
                36.0555437
              ],
              [
                52.5288168,
                36.0574902
              ],
              [
                52.5288167,
                36.0577696
              ],
              [
                52.5288167,
                36.0599865
              ],
              [
                52.5285402,
                36.0624917
              ],
              [
                52.5282635,
                36.065817
              ],
              [
                52.5279835,
                36.0672139
              ],
              [
                52.5277068,
                36.068881
              ],
              [
                52.5254834,
                36.0811007
              ],
              [
                52.5252069,
                36.0847143
              ],
              [
                52.5249302,
                36.0872106
              ],
              [
                52.5246501,
                36.0902655
              ],
              [
                52.5243736,
                36.0924912
              ],
              [
                52.5238168,
                36.0944287
              ],
              [
                52.5224269,
                36.1036023
              ],
              [
                52.5224268,
                36.1052603
              ],
              [
                52.5221501,
                36.1074861
              ],
              [
                52.5218735,
                36.112208
              ],
              [
                52.5215935,
                36.121931
              ],
              [
                52.5217938,
                36.1232861
              ],
              [
                52.5220821,
                36.1264418
              ],
              [
                52.5207193,
                36.1333667
              ],
              [
                52.5206407,
                36.1353361
              ],
              [
                52.5212172,
                36.1367972
              ],
              [
                52.5185703,
                36.1390841
              ],
              [
                52.5141412,
                36.1397193
              ],
              [
                52.5089521,
                36.1402064
              ],
              [
                52.5077204,
                36.1452245
              ],
              [
                52.5052044,
                36.1485487
              ],
              [
                52.5004347,
                36.1522114
              ],
              [
                52.4953504,
                36.1531217
              ],
              [
                52.4902924,
                36.1539262
              ],
              [
                52.487593,
                36.1564667
              ],
              [
                52.4795735,
                36.1570382
              ],
              [
                52.4677801,
                36.1633466
              ],
              [
                52.4628269,
                36.1667758
              ],
              [
                52.4598655,
                36.171242
              ],
              [
                52.4415464,
                36.181782
              ],
              [
                52.437327,
                36.1840252
              ],
              [
                52.436567,
                36.1875805
              ],
              [
                52.4349421,
                36.1916223
              ],
              [
                52.4316138,
                36.1946905
              ],
              [
                52.4295434,
                36.195558
              ],
              [
                52.4310001,
                36.2031278
              ],
              [
                52.431079,
                36.203538
              ],
              [
                52.4314041,
                36.2052273
              ],
              [
                52.4333435,
                36.2097548
              ],
              [
                52.4354663,
                36.2120396
              ],
              [
                52.439843,
                36.2144089
              ],
              [
                52.4402393,
                36.2154219
              ],
              [
                52.4406292,
                36.2164185
              ],
              [
                52.4390043,
                36.2181743
              ],
              [
                52.435807,
                36.2234413
              ],
              [
                52.4307489,
                36.231669
              ],
              [
                52.4265033,
                36.2365333
              ],
              [
                52.4231226,
                36.2390922
              ],
              [
                52.4234895,
                36.2427718
              ],
              [
                52.4207377,
                36.248735
              ],
              [
                52.4229653,
                36.2490099
              ],
              [
                52.4276827,
                36.2509763
              ],
              [
                52.4327931,
                36.2529216
              ],
              [
                52.4383229,
                36.2528793
              ],
              [
                52.4422016,
                36.2537039
              ],
              [
                52.448439,
                36.2543594
              ],
              [
                52.4493039,
                36.2569389
              ],
              [
                52.4506142,
                36.2603217
              ],
              [
                52.4502735,
                36.2667908
              ],
              [
                52.4489107,
                36.2723717
              ],
              [
                52.4442458,
                36.2757749
              ],
              [
                52.4423327,
                36.2775082
              ],
              [
                52.4438003,
                36.283976
              ],
              [
                52.4412844,
                36.2926199
              ],
              [
                52.439214,
                36.2971423
              ],
              [
                52.4417561,
                36.3027844
              ],
              [
                52.4465259,
                36.3049819
              ],
              [
                52.4506404,
                36.3093346
              ],
              [
                52.4512432,
                36.3232571
              ],
              [
                52.4528419,
                36.326278
              ],
              [
                52.4599703,
                36.3299957
              ],
              [
                52.470034,
                36.3401764
              ],
              [
                52.4725792,
                36.3428968
              ],
              [
                52.4738341,
                36.345055
              ],
              [
                52.4774507,
                36.3471036
              ],
              [
                52.4904758,
                36.3499545
              ],
              [
                52.4924676,
                36.3520662
              ],
              [
                52.4924414,
                36.3662134
              ],
              [
                52.4925331,
                36.3707738
              ],
              [
                52.4937125,
                36.3734761
              ],
              [
                52.4948656,
                36.3759461
              ],
              [
                52.4948918,
                36.3792604
              ],
              [
                52.4974601,
                36.3879149
              ],
              [
                52.4978532,
                36.392875
              ],
              [
                52.499714,
                36.3956398
              ],
              [
                52.5020726,
                36.3957242
              ],
              [
                52.5032258,
                36.3962941
              ],
              [
                52.5035288,
                36.3997816
              ],
              [
                52.5037646,
                36.4005202
              ],
              [
                52.5038355,
                36.4020003
              ],
              [
                52.5038813,
                36.4031459
              ],
              [
                52.5046615,
                36.4035771
              ],
              [
                52.5049267,
                36.4041583
              ],
              [
                52.5020454,
                36.4058864
              ],
              [
                52.5015935,
                36.4061131
              ],
              [
                52.4915936,
                36.4113829
              ],
              [
                52.4896504,
                36.4133286
              ],
              [
                52.4871502,
                36.4183281
              ],
              [
                52.4871503,
                36.4186072
              ],
              [
                52.4868703,
                36.4191658
              ],
              [
                52.4865937,
                36.419445
              ],
              [
                52.4838136,
                36.4255524
              ],
              [
                52.482427,
                36.4269396
              ],
              [
                52.481037,
                36.4274981
              ],
              [
                52.4799271,
                36.427498
              ],
              [
                52.479647,
                36.4277773
              ],
              [
                52.4779804,
                36.4280475
              ],
              [
                52.4754804,
                36.4291645
              ],
              [
                52.4740938,
                36.4311102
              ],
              [
                52.4752038,
                36.4347134
              ],
              [
                52.4749271,
                36.4358303
              ],
              [
                52.4746471,
                36.4361005
              ],
              [
                52.474925,
                36.437769
              ],
              [
                52.4752037,
                36.4394425
              ],
              [
                52.4755125,
                36.4399577
              ],
              [
                52.4777036,
                36.443613
              ],
              [
                52.4779804,
                36.4438832
              ],
              [
                52.4815937,
                36.4486123
              ],
              [
                52.4818703,
                36.4516659
              ],
              [
                52.4815937,
                36.4702754
              ],
              [
                52.4821469,
                36.4713833
              ],
              [
                52.4837019,
                36.4757914
              ],
              [
                52.4852036,
                36.4800033
              ],
              [
                52.4854801,
                36.4805528
              ],
              [
                52.486275,
                36.4818626
              ],
              [
                52.4865936,
                36.4822191
              ],
              [
                52.4893702,
                36.4863805
              ],
              [
                52.5049267,
                36.5013864
              ],
              [
                52.5049267,
                36.5019449
              ],
              [
                52.5227064,
                36.5211116
              ],
              [
                52.5227065,
                36.5213909
              ],
              [
                52.5238164,
                36.5241649
              ],
              [
                52.5240931,
                36.5261104
              ],
              [
                52.5288247,
                36.5461375
              ],
              [
                52.5324296,
                36.5613892
              ],
              [
                52.5327064,
                36.5619476
              ],
              [
                52.533263,
                36.5666669
              ],
              [
                52.5296497,
                36.5749977
              ],
              [
                52.5271496,
                36.5777716
              ],
              [
                52.5263164,
                36.5780508
              ],
              [
                52.522567,
                36.5806936
              ],
              [
                52.5218731,
                36.581113
              ],
              [
                52.5043699,
                36.5938925
              ],
              [
                52.5038487,
                36.5940577
              ],
              [
                52.50215,
                36.5944419
              ],
              [
                52.499864,
                36.5941669
              ],
              [
                52.4902034,
                36.5952794
              ],
              [
                52.4857601,
                36.5952794
              ],
              [
                52.4852036,
                36.5955587
              ],
              [
                52.4840935,
                36.5955587
              ],
              [
                52.4824269,
                36.5961171
              ],
              [
                52.4813134,
                36.5961171
              ],
              [
                52.4804801,
                36.5963872
              ],
              [
                52.4755445,
                36.5971575
              ],
              [
                52.4715937,
                36.5977741
              ],
              [
                52.4765936,
                36.600557
              ],
              [
                52.477427,
                36.6016647
              ],
              [
                52.4838135,
                36.6177761
              ],
              [
                52.4840936,
                36.619163
              ],
              [
                52.4840935,
                36.6194421
              ],
              [
                52.4838135,
                36.6202797
              ],
              [
                52.4837173,
                36.6223097
              ],
              [
                52.4836919,
                36.6228454
              ],
              [
                52.4835369,
                36.6261154
              ],
              [
                52.4838134,
                36.6266647
              ],
              [
                52.4832602,
                36.6352741
              ],
              [
                52.4829801,
                36.6361114
              ],
              [
                52.4829801,
                36.6366699
              ],
              [
                52.4824269,
                36.6377776
              ],
              [
                52.4820949,
                36.6391655
              ],
              [
                52.4793701,
                36.6505563
              ],
              [
                52.4771468,
                36.6561126
              ],
              [
                52.4771468,
                36.6563918
              ],
              [
                52.4771468,
                36.6566709
              ],
              [
                52.4765936,
                36.6580578
              ],
              [
                52.4763136,
                36.6591654
              ],
              [
                52.4760369,
                36.6608404
              ],
              [
                52.4757603,
                36.6624972
              ],
              [
                52.4754801,
                36.6666667
              ],
              [
                52.4752036,
                36.6700076
              ],
              [
                52.4753347,
                36.6709245
              ],
              [
                52.4714965,
                36.6680778
              ],
              [
                52.4700412,
                36.6671314
              ],
              [
                52.4625096,
                36.6575784
              ],
              [
                52.4565061,
                36.6510806
              ],
              [
                52.4519057,
                36.6455441
              ],
              [
                52.4515194,
                36.6450791
              ],
              [
                52.450907,
                36.6414469
              ],
              [
                52.4508343,
                36.6364381
              ],
              [
                52.4508341,
                36.6236158
              ],
              [
                52.4508341,
                36.6153319
              ],
              [
                52.4502977,
                36.6089935
              ],
              [
                52.4490531,
                36.6039293
              ],
              [
                52.4471659,
                36.6011669
              ],
              [
                52.4434411,
                36.5988875
              ],
              [
                52.4360069,
                36.5938171
              ],
              [
                52.4298056,
                36.5897168
              ],
              [
                52.425278,
                36.5850304
              ],
              [
                52.4219306,
                36.5818772
              ],
              [
                52.4200303,
                36.5805743
              ],
              [
                52.4180455,
                36.5759132
              ],
              [
                52.4147088,
                36.5732077
              ],
              [
                52.4094838,
                36.5712259
              ],
              [
                52.4068124,
                36.5688305
              ],
              [
                52.4019255,
                36.564081
              ],
              [
                52.3999009,
                36.564081
              ],
              [
                52.3993678,
                36.5638929
              ],
              [
                52.3988112,
                36.5641721
              ],
              [
                52.3982545,
                36.5641721
              ],
              [
                52.3935345,
                36.5652709
              ],
              [
                52.3921446,
                36.5652709
              ],
              [
                52.3915879,
                36.5655501
              ],
              [
                52.390478,
                36.5655501
              ],
              [
                52.3893645,
                36.5655501
              ],
              [
                52.3890879,
                36.5652709
              ],
              [
                52.3779781,
                36.5605516
              ],
              [
                52.3729747,
                36.5605515
              ],
              [
                52.3726981,
                36.5608307
              ],
              [
                52.3721415,
                36.5608307
              ],
              [
                52.3693649,
                36.562776
              ],
              [
                52.3688081,
                36.5638929
              ],
              [
                52.3679749,
                36.5647214
              ],
              [
                52.3671415,
                36.566946
              ],
              [
                52.3668649,
                36.5672252
              ],
              [
                52.3668649,
                36.5677746
              ],
              [
                52.3665882,
                36.5680538
              ],
              [
                52.3657549,
                36.5702784
              ],
              [
                52.3651983,
                36.5705576
              ],
              [
                52.3579749,
                36.575556
              ],
              [
                52.3571416,
                36.5755561
              ],
              [
                52.3568649,
                36.5758352
              ],
              [
                52.3560317,
                36.5758352
              ],
              [
                52.354085,
                36.5763936
              ],
              [
                52.3496416,
                36.5763936
              ],
              [
                52.3488084,
                36.5747185
              ],
              [
                52.346585,
                36.5711069
              ],
              [
                52.3368653,
                36.5569489
              ],
              [
                52.3329751,
                36.5519414
              ],
              [
                52.3329751,
                36.5508335
              ],
              [
                52.3326953,
                36.5502752
              ],
              [
                52.3324185,
                36.5486089
              ],
              [
                52.327142,
                36.5422233
              ],
              [
                52.3263086,
                36.5419441
              ],
              [
                52.3124189,
                36.5344415
              ],
              [
                52.3115855,
                36.5344416
              ],
              [
                52.3107522,
                36.5341623
              ],
              [
                52.3026956,
                36.5341623
              ],
              [
                52.3021389,
                36.5341623
              ],
              [
                52.301029,
                36.5338922
              ],
              [
                52.289639,
                36.5338921
              ],
              [
                52.2890824,
                36.5341623
              ],
              [
                52.2874157,
                36.5341623
              ],
              [
                52.287139,
                36.5344415
              ],
              [
                52.2863059,
                36.5344415
              ],
              [
                52.2821391,
                36.5358375
              ],
              [
                52.2810242,
                36.5363268
              ],
              [
                52.2707492,
                36.5408363
              ],
              [
                52.2690826,
                36.5416648
              ],
              [
                52.257136,
                36.5448305
              ],
              [
                52.231303,
                36.5516711
              ],
              [
                52.2163033,
                36.5541659
              ],
              [
                52.2099133,
                36.5541658
              ],
              [
                52.20908,
                36.5544451
              ],
              [
                52.2057466,
                36.5544451
              ],
              [
                52.2046366,
                36.5547242
              ],
              [
                52.2046366,
                36.5541658
              ],
              [
                52.2138033,
                36.5449973
              ],
              [
                52.2140799,
                36.5441686
              ],
              [
                52.2146367,
                36.5436102
              ],
              [
                52.2188032,
                36.5266687
              ],
              [
                52.2190799,
                36.524444
              ],
              [
                52.2201897,
                36.5177699
              ],
              [
                52.2204698,
                36.5155542
              ],
              [
                52.2207466,
                36.51278
              ],
              [
                52.2210232,
                36.5108346
              ],
              [
                52.2213032,
                36.5088891
              ],
              [
                52.2215798,
                36.5080515
              ],
              [
                52.2215799,
                36.5058267
              ],
              [
                52.2213032,
                36.5025031
              ],
              [
                52.2290157,
                36.4866257
              ],
              [
                52.237473,
                36.4695944
              ],
              [
                52.2383652,
                36.467374
              ],
              [
                52.2390524,
                36.4659588
              ],
              [
                52.2403304,
                36.4633269
              ],
              [
                52.2449163,
                36.4538816
              ],
              [
                52.2443597,
                36.4522152
              ],
              [
                52.2399131,
                36.4438831
              ],
              [
                52.240193,
                36.4416672
              ],
              [
                52.2404697,
                36.4402801
              ],
              [
                52.2407463,
                36.4394423
              ],
              [
                52.2414924,
                36.4372519
              ],
              [
                52.2423761,
                36.434232
              ],
              [
                52.2449164,
                36.4261107
              ],
              [
                52.2449163,
                36.4258315
              ],
              [
                52.2449163,
                36.4255522
              ],
              [
                52.2454697,
                36.4247146
              ],
              [
                52.2477005,
                36.4163527
              ],
              [
                52.2488029,
                36.4122204
              ],
              [
                52.248803,
                36.4113827
              ],
              [
                52.2499163,
                36.4083289
              ],
              [
                52.2596362,
                36.3811061
              ],
              [
                52.2588029,
                36.373602
              ],
              [
                52.2524164,
                36.3644403
              ],
              [
                52.2301932,
                36.3527741
              ],
              [
                52.2279699,
                36.3522156
              ],
              [
                52.2254699,
                36.3511076
              ],
              [
                52.2171368,
                36.3477743
              ],
              [
                52.1999137,
                36.3405492
              ],
              [
                52.1988002,
                36.3405492
              ],
              [
                52.1985236,
                36.3402699
              ],
              [
                52.1974137,
                36.3402699
              ],
              [
                52.1951903,
                36.3397113
              ],
              [
                52.1949136,
                36.3397114
              ],
              [
                52.1946337,
                36.3394411
              ],
              [
                52.1935238,
                36.3394411
              ],
              [
                52.1932469,
                36.3391618
              ],
              [
                52.1921337,
                36.3391619
              ],
              [
                52.1907471,
                36.3386033
              ],
              [
                52.1899137,
                36.3386033
              ],
              [
                52.1899137,
                36.338324
              ],
              [
                52.1885238,
                36.3363871
              ],
              [
                52.1890805,
                36.3355493
              ],
              [
                52.1907471,
                36.3294322
              ],
              [
                52.1913005,
                36.3277746
              ],
              [
                52.1913004,
                36.3269368
              ],
              [
                52.1918571,
                36.3247115
              ],
              [
                52.1921337,
                36.3199908
              ],
              [
                52.1924138,
                36.3138826
              ],
              [
                52.1926904,
                36.3113781
              ],
              [
                52.1929671,
                36.31027
              ],
              [
                52.1926903,
                36.3069366
              ],
              [
                52.1926903,
                36.3066573
              ],
              [
                52.1896338,
                36.2963777
              ],
              [
                52.1729673,
                36.282215
              ],
              [
                52.1726907,
                36.2797193
              ],
              [
                52.1729673,
                36.2772147
              ],
              [
                52.1732441,
                36.27471
              ],
              [
                52.173524,
                36.2741605
              ],
              [
                52.173244,
                36.2699891
              ],
              [
                52.173244,
                36.2663852
              ],
              [
                52.1729673,
                36.2658266
              ],
              [
                52.1726907,
                36.2627724
              ],
              [
                52.1729673,
                36.2588802
              ],
              [
                52.1732441,
                36.257772
              ],
              [
                52.1725255,
                36.2516543
              ],
              [
                52.1721341,
                36.2483207
              ],
              [
                52.1713007,
                36.246654
              ],
              [
                52.1690773,
                36.2405452
              ],
              [
                52.1690774,
                36.239437
              ],
              [
                52.1685241,
                36.2377701
              ],
              [
                52.1676909,
                36.2305442
              ],
              [
                52.1740773,
                36.2180472
              ],
              [
                52.1768573,
                36.2135962
              ],
              [
                52.1860239,
                36.2047122
              ],
              [
                52.189634,
                36.2022162
              ],
              [
                52.2193569,
                36.1847091
              ],
              [
                52.2304702,
                36.1797083
              ],
              [
                52.2629731,
                36.1613807
              ],
              [
                52.2676931,
                36.1580467
              ],
              [
                52.2682498,
                36.1577675
              ],
              [
                52.2868629,
                36.1444314
              ],
              [
                52.2871394,
                36.1438727
              ],
              [
                52.2871394,
                36.1424851
              ],
              [
                52.2851962,
                36.1410974
              ],
              [
                52.2804729,
                36.1405387
              ],
              [
                52.2774163,
                36.1405387
              ],
              [
                52.2763064,
                36.1408271
              ],
              [
                52.2693597,
                36.1410973
              ],
              [
                52.2638065,
                36.13916
              ],
              [
                52.2624164,
                36.13916
              ],
              [
                52.2621399,
                36.1388806
              ],
              [
                52.2576931,
                36.1388807
              ],
              [
                52.2574165,
                36.13916
              ],
              [
                52.2557498,
                36.13916
              ],
              [
                52.2554698,
                36.1394303
              ],
              [
                52.2535266,
                36.1394303
              ],
              [
                52.2526932,
                36.1397096
              ],
              [
                52.25075,
                36.1397097
              ],
              [
                52.2501933,
                36.139989
              ],
              [
                52.24686,
                36.139989
              ],
              [
                52.2457501,
                36.1402683
              ],
              [
                52.2385267,
                36.140827
              ],
              [
                52.220747,
                36.140827
              ],
              [
                52.2188035,
                36.1410973
              ],
              [
                52.2160236,
                36.1413767
              ],
              [
                52.214357,
                36.1413766
              ],
              [
                52.2076904,
                36.1436024
              ],
              [
                52.1979672,
                36.1455487
              ],
              [
                52.1904673,
                36.1455486
              ],
              [
                52.189634,
                36.1452694
              ],
              [
                52.1868574,
                36.1452694
              ],
              [
                52.1863005,
                36.14499
              ],
              [
                52.1840773,
                36.1449901
              ],
              [
                52.1835241,
                36.1447107
              ],
              [
                52.1801907,
                36.1447107
              ],
              [
                52.1790774,
                36.1444313
              ],
              [
                52.1674109,
                36.1444313
              ],
              [
                52.1668575,
                36.144152
              ],
              [
                52.1604675,
                36.144152
              ],
              [
                52.1593542,
                36.1438727
              ],
              [
                52.1343545,
                36.1391599
              ],
              [
                52.1296314,
                36.1380425
              ],
              [
                52.1285214,
                36.1374929
              ],
              [
                52.0504623,
                36.1149922
              ],
              [
                52.0496289,
                36.1144335
              ],
              [
                52.0485155,
                36.1141542
              ],
              [
                52.0440723,
                36.1122077
              ],
              [
                52.0424056,
                36.1113787
              ],
              [
                52.0315724,
                36.1069271
              ],
              [
                51.9957362,
                36.0736028
              ],
              [
                51.9824031,
                36.0683219
              ],
              [
                51.9751799,
                36.0663754
              ],
              [
                51.9729564,
                36.0655464
              ],
              [
                51.9721231,
                36.0649877
              ],
              [
                51.9516892,
                36.0547758
              ],
              [
                51.9225252,
                36.0401908
              ],
              [
                51.9221239,
                36.0399888
              ],
              [
                51.8946208,
                36.0302649
              ],
              [
                51.8923975,
                36.0294267
              ],
              [
                51.8921207,
                36.0297061
              ],
              [
                51.8898974,
                36.0297061
              ],
              [
                51.8896209,
                36.0294267
              ],
              [
                51.8848975,
                36.0291564
              ],
              [
                51.8840643,
                36.0294267
              ],
              [
                51.8829543,
                36.0294268
              ],
              [
                51.8818408,
                36.0291563
              ],
              [
                51.8804543,
                36.0294267
              ],
              [
                51.8762876,
                36.0291563
              ],
              [
                51.8673978,
                36.0291563
              ],
              [
                51.8660076,
                36.0288769
              ],
              [
                51.8521179,
                36.028877
              ],
              [
                51.8512845,
                36.0285976
              ],
              [
                51.8468412,
                36.0285976
              ],
              [
                51.844898,
                36.0283182
              ],
              [
                51.838228,
                36.0283181
              ],
              [
                51.8373947,
                36.0280389
              ],
              [
                51.8326749,
                36.0280388
              ],
              [
                51.8307282,
                36.0277595
              ],
              [
                51.8207282,
                36.0277594
              ],
              [
                51.8193383,
                36.0280388
              ],
              [
                51.8157282,
                36.0280388
              ],
              [
                51.8140616,
                36.0283182
              ],
              [
                51.806005,
                36.0283181
              ],
              [
                51.8040618,
                36.0285976
              ],
              [
                51.7993384,
                36.0285975
              ],
              [
                51.7973952,
                36.0288769
              ],
              [
                51.7951719,
                36.0288769
              ],
              [
                51.7935054,
                36.0291562
              ],
              [
                51.7873919,
                36.0294266
              ],
              [
                51.7807254,
                36.0294267
              ],
              [
                51.7754488,
                36.0294266
              ],
              [
                51.7740588,
                36.0291562
              ],
              [
                51.7698921,
                36.0291562
              ],
              [
                51.7682255,
                36.0288769
              ],
              [
                51.7657256,
                36.0288769
              ],
              [
                51.7274191,
                36.0266362
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554904,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بابل",
          "name:en": "Babol County",
          "name:uk": "Баболь шагрестан",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282212",
          "wikipedia": "en:Babol County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.4310001,
                36.2031278
              ],
              [
                52.4295434,
                36.195558
              ],
              [
                52.4316138,
                36.1946905
              ],
              [
                52.4349421,
                36.1916223
              ],
              [
                52.436567,
                36.1875805
              ],
              [
                52.437327,
                36.1840252
              ],
              [
                52.4415464,
                36.181782
              ],
              [
                52.4598655,
                36.171242
              ],
              [
                52.4628269,
                36.1667758
              ],
              [
                52.4677801,
                36.1633466
              ],
              [
                52.4795735,
                36.1570382
              ],
              [
                52.487593,
                36.1564667
              ],
              [
                52.4902924,
                36.1539262
              ],
              [
                52.4953504,
                36.1531217
              ],
              [
                52.5004347,
                36.1522114
              ],
              [
                52.5052044,
                36.1485487
              ],
              [
                52.5077204,
                36.1452245
              ],
              [
                52.5089521,
                36.1402064
              ],
              [
                52.5141412,
                36.1397193
              ],
              [
                52.5185703,
                36.1390841
              ],
              [
                52.5212172,
                36.1367972
              ],
              [
                52.5206407,
                36.1353361
              ],
              [
                52.5207193,
                36.1333667
              ],
              [
                52.5220821,
                36.1264418
              ],
              [
                52.5217938,
                36.1232861
              ],
              [
                52.5215935,
                36.121931
              ],
              [
                52.5218735,
                36.112208
              ],
              [
                52.5221501,
                36.1074861
              ],
              [
                52.5224268,
                36.1052603
              ],
              [
                52.5224269,
                36.1036023
              ],
              [
                52.5238168,
                36.0944287
              ],
              [
                52.5243736,
                36.0924912
              ],
              [
                52.5246501,
                36.0902655
              ],
              [
                52.5249302,
                36.0872106
              ],
              [
                52.5252069,
                36.0847143
              ],
              [
                52.5254834,
                36.0811007
              ],
              [
                52.5277068,
                36.068881
              ],
              [
                52.5279835,
                36.0672139
              ],
              [
                52.5282635,
                36.065817
              ],
              [
                52.5285402,
                36.0624917
              ],
              [
                52.5288167,
                36.0599865
              ],
              [
                52.5288167,
                36.0577696
              ],
              [
                52.5288168,
                36.0574902
              ],
              [
                52.5293735,
                36.0555437
              ],
              [
                52.5288167,
                36.0469284
              ],
              [
                52.5279833,
                36.0416474
              ],
              [
                52.5271501,
                36.0385923
              ],
              [
                52.5249302,
                36.0344288
              ],
              [
                52.5249303,
                36.0341494
              ],
              [
                52.5243735,
                36.0338701
              ],
              [
                52.5232602,
                36.0327616
              ],
              [
                52.5007605,
                36.0019309
              ],
              [
                52.4999272,
                35.9977582
              ],
              [
                52.4963173,
                35.9947031
              ],
              [
                52.4960372,
                35.9927654
              ],
              [
                52.492984,
                35.9866459
              ],
              [
                52.4896507,
                35.9830409
              ],
              [
                52.483814,
                35.978039
              ],
              [
                52.4829806,
                35.9766511
              ],
              [
                52.4818708,
                35.9735958
              ],
              [
                52.4765942,
                35.9516498
              ],
              [
                52.4763141,
                35.9474859
              ],
              [
                52.4765942,
                35.9449804
              ],
              [
                52.4768708,
                35.9424838
              ],
              [
                52.4771475,
                35.9402576
              ],
              [
                52.4774275,
                35.9399781
              ],
              [
                52.4774276,
                35.9394284
              ],
              [
                52.4782609,
                35.9374816
              ],
              [
                52.4805157,
                35.9304368
              ],
              [
                52.4935373,
                35.9333176
              ],
              [
                52.4943706,
                35.9333176
              ],
              [
                52.4949272,
                35.933597
              ],
              [
                52.4957606,
                35.933597
              ],
              [
                52.4999272,
                35.9338674
              ],
              [
                52.54104,
                35.940537
              ],
              [
                52.5418733,
                35.9402576
              ],
              [
                52.5435401,
                35.940537
              ],
              [
                52.54604,
                35.940537
              ],
              [
                52.5482634,
                35.9410958
              ],
              [
                52.5679864,
                35.943313
              ],
              [
                52.5685432,
                35.9430426
              ],
              [
                52.5749297,
                35.9430426
              ],
              [
                52.5757629,
                35.943313
              ],
              [
                52.5777097,
                35.9433131
              ],
              [
                52.5799296,
                35.9430426
              ],
              [
                52.581043,
                35.943313
              ],
              [
                52.5832664,
                35.9430426
              ],
              [
                52.6024192,
                35.943043
              ],
              [
                52.6077094,
                35.9485946
              ],
              [
                52.6088227,
                35.9499825
              ],
              [
                52.6118759,
                35.9530379
              ],
              [
                52.6268791,
                35.9760923
              ],
              [
                52.640769,
                35.9922067
              ],
              [
                52.6513221,
                35.9988758
              ],
              [
                52.6896583,
                36.0285982
              ],
              [
                52.6938249,
                36.0322119
              ],
              [
                52.7268705,
                36.0453942
              ],
              [
                52.7400433,
                36.0553665
              ],
              [
                52.7538499,
                36.0533964
              ],
              [
                52.7615188,
                36.0535922
              ],
              [
                52.7671691,
                36.0549427
              ],
              [
                52.7676887,
                36.0581265
              ],
              [
                52.7694468,
                36.0627589
              ],
              [
                52.7699359,
                36.0669406
              ],
              [
                52.7735001,
                36.0695051
              ],
              [
                52.7789775,
                36.0756721
              ],
              [
                52.7860273,
                36.078978
              ],
              [
                52.7887791,
                36.0822202
              ],
              [
                52.7914785,
                36.0901872
              ],
              [
                52.8069671,
                36.1035133
              ],
              [
                52.8134928,
                36.1046361
              ],
              [
                52.8202281,
                36.1065003
              ],
              [
                52.8290076,
                36.1071358
              ],
              [
                52.8319166,
                36.1108216
              ],
              [
                52.8376823,
                36.1200778
              ],
              [
                52.8412989,
                36.1263468
              ],
              [
                52.8448631,
                36.1378245
              ],
              [
                52.8484274,
                36.1530691
              ],
              [
                52.8515723,
                36.158531
              ],
              [
                52.8506812,
                36.1589968
              ],
              [
                52.8504283,
                36.1600876
              ],
              [
                52.8511948,
                36.161237
              ],
              [
                52.857723,
                36.1619307
              ],
              [
                52.8663329,
                36.1649854
              ],
              [
                52.8699462,
                36.1685986
              ],
              [
                52.8723351,
                36.1745212
              ],
              [
                52.8763327,
                36.1844301
              ],
              [
                52.882166,
                36.2061002
              ],
              [
                52.882446,
                36.2072174
              ],
              [
                52.8835559,
                36.212218
              ],
              [
                52.8846693,
                36.2316529
              ],
              [
                52.8857793,
                36.2472129
              ],
              [
                52.8860559,
                36.2488797
              ],
              [
                52.8857793,
                36.249159
              ],
              [
                52.886336,
                36.2499969
              ],
              [
                52.8865067,
                36.2503361
              ],
              [
                52.8757795,
                36.2558262
              ],
              [
                52.8535562,
                36.2761069
              ],
              [
                52.8521663,
                36.2766565
              ],
              [
                52.8510564,
                36.2766565
              ],
              [
                52.8504996,
                36.2769358
              ],
              [
                52.8479997,
                36.2769358
              ],
              [
                52.8468897,
                36.2772151
              ],
              [
                52.8454997,
                36.2772151
              ],
              [
                52.8446664,
                36.2774944
              ],
              [
                52.8402197,
                36.2774943
              ],
              [
                52.8391098,
                36.277215
              ],
              [
                52.8338332,
                36.2772151
              ],
              [
                52.8321665,
                36.2769358
              ],
              [
                52.8235532,
                36.2769358
              ],
              [
                52.8221633,
                36.2766564
              ],
              [
                52.8155906,
                36.2769112
              ],
              [
                52.8155352,
                36.2771439
              ],
              [
                52.8171186,
                36.2865733
              ],
              [
                52.8185741,
                36.2961693
              ],
              [
                52.8200936,
                36.3134107
              ],
              [
                52.8192827,
                36.3206563
              ],
              [
                52.8187708,
                36.3257113
              ],
              [
                52.8182749,
                36.3288447
              ],
              [
                52.8181149,
                36.3339894
              ],
              [
                52.8160992,
                36.336452
              ],
              [
                52.8156192,
                36.3390435
              ],
              [
                52.8155103,
                36.3397299
              ],
              [
                52.8149824,
                36.3456731
              ],
              [
                52.8149427,
                36.3460024
              ],
              [
                52.8138306,
                36.3552252
              ],
              [
                52.8148864,
                36.3627784
              ],
              [
                52.8132546,
                36.3657815
              ],
              [
                52.8159734,
                36.3789086
              ],
              [
                52.8143783,
                36.3824354
              ],
              [
                52.8114813,
                36.3810833
              ],
              [
                52.8028353,
                36.3808109
              ],
              [
                52.7956509,
                36.3857599
              ],
              [
                52.7893216,
                36.3884901
              ],
              [
                52.7835514,
                36.38976
              ],
              [
                52.7816081,
                36.3897998
              ],
              [
                52.7795264,
                36.389951
              ],
              [
                52.7750742,
                36.390112
              ],
              [
                52.7685763,
                36.3892322
              ],
              [
                52.7550754,
                36.3869671
              ],
              [
                52.7484311,
                36.3922331
              ],
              [
                52.7467786,
                36.4013588
              ],
              [
                52.7475258,
                36.4055033
              ],
              [
                52.7466239,
                36.4137882
              ],
              [
                52.7382529,
                36.4223802
              ],
              [
                52.7343182,
                36.425392
              ],
              [
                52.7336981,
                36.4278193
              ],
              [
                52.7333059,
                36.4290655
              ],
              [
                52.7329683,
                36.4303081
              ],
              [
                52.732509,
                36.4346304
              ],
              [
                52.7354661,
                36.4406269
              ],
              [
                52.7382578,
                36.4462641
              ],
              [
                52.7455173,
                36.4534746
              ],
              [
                52.746258,
                36.4542328
              ],
              [
                52.747498,
                36.4555022
              ],
              [
                52.7480143,
                36.4560892
              ],
              [
                52.7543839,
                36.4633308
              ],
              [
                52.7613271,
                36.4725004
              ],
              [
                52.7616071,
                36.4772202
              ],
              [
                52.7607738,
                36.4788866
              ],
              [
                52.7588273,
                36.4813906
              ],
              [
                52.7546606,
                36.485552
              ],
              [
                52.7524407,
                36.4888847
              ],
              [
                52.753274,
                36.4927757
              ],
              [
                52.755774,
                36.4952797
              ],
              [
                52.7624405,
                36.4991618
              ],
              [
                52.7635504,
                36.499441
              ],
              [
                52.7638272,
                36.4997202
              ],
              [
                52.7666071,
                36.5011073
              ],
              [
                52.7719276,
                36.5074908
              ],
              [
                52.7735873,
                36.5094819
              ],
              [
                52.7749403,
                36.5111051
              ],
              [
                52.7754653,
                36.5153014
              ],
              [
                52.775497,
                36.5155545
              ],
              [
                52.7754609,
                36.515824
              ],
              [
                52.7749403,
                36.5197157
              ],
              [
                52.7771368,
                36.5244398
              ],
              [
                52.7797676,
                36.5300979
              ],
              [
                52.7805458,
                36.531631
              ],
              [
                52.7841975,
                36.532582
              ],
              [
                52.7903523,
                36.5319958
              ],
              [
                52.7993611,
                36.5312447
              ],
              [
                52.8006577,
                36.5336227
              ],
              [
                52.8006093,
                36.5366814
              ],
              [
                52.799737,
                36.5383824
              ],
              [
                52.7991718,
                36.539567
              ],
              [
                52.7985586,
                36.5412783
              ],
              [
                52.7974683,
                36.5430965
              ],
              [
                52.7950051,
                36.5438907
              ],
              [
                52.7912768,
                36.5434964
              ],
              [
                52.784906,
                36.5436361
              ],
              [
                52.7829695,
                36.544668
              ],
              [
                52.7820518,
                36.5466935
              ],
              [
                52.7831396,
                36.5490429
              ],
              [
                52.7880734,
                36.5518193
              ],
              [
                52.7881358,
                36.5556943
              ],
              [
                52.7855697,
                36.5598732
              ],
              [
                52.7831592,
                36.5627341
              ],
              [
                52.7785455,
                36.5645096
              ],
              [
                52.7752801,
                36.565722
              ],
              [
                52.771892,
                36.5671903
              ],
              [
                52.7694751,
                36.5684139
              ],
              [
                52.7678914,
                36.5704747
              ],
              [
                52.7654645,
                36.5736336
              ],
              [
                52.7642667,
                36.5759959
              ],
              [
                52.7630112,
                36.5776249
              ],
              [
                52.765075,
                36.5914181
              ],
              [
                52.7624404,
                36.6041685
              ],
              [
                52.7618837,
                36.6086084
              ],
              [
                52.7616071,
                36.6108329
              ],
              [
                52.7613271,
                36.6116703
              ],
              [
                52.7611393,
                36.6128013
              ],
              [
                52.7610505,
                36.6133364
              ],
              [
                52.7607738,
                36.6141739
              ],
              [
                52.7605245,
                36.6151517
              ],
              [
                52.7596548,
                36.6213691
              ],
              [
                52.7585224,
                36.6214373
              ],
              [
                52.7565044,
                36.6213531
              ],
              [
                52.7537002,
                36.6206166
              ],
              [
                52.750896,
                36.6202378
              ],
              [
                52.7459428,
                36.6204061
              ],
              [
                52.7430247,
                36.6208835
              ],
              [
                52.7415461,
                36.6206495
              ],
              [
                52.7408061,
                36.6205324
              ],
              [
                52.7371371,
                36.6188488
              ],
              [
                52.7306114,
                36.6178597
              ],
              [
                52.7279907,
                36.6173336
              ],
              [
                52.7204429,
                36.6177756
              ],
              [
                52.7193737,
                36.6173254
              ],
              [
                52.7133966,
                36.6173182
              ],
              [
                52.7101119,
                36.6172825
              ],
              [
                52.7062594,
                36.6174298
              ],
              [
                52.7059187,
                36.6174087
              ],
              [
                52.7045072,
                36.6173338
              ],
              [
                52.7011757,
                36.6173536
              ],
              [
                52.6969402,
                36.6179096
              ],
              [
                52.6941622,
                36.6194458
              ],
              [
                52.692747,
                36.6196983
              ],
              [
                52.685802,
                36.6194879
              ],
              [
                52.6814777,
                36.6196983
              ],
              [
                52.6776777,
                36.6199298
              ],
              [
                52.67317,
                36.6207506
              ],
              [
                52.6714141,
                36.6207506
              ],
              [
                52.6665395,
                36.6207716
              ],
              [
                52.664207,
                36.6203507
              ],
              [
                52.6613343,
                36.6195163
              ],
              [
                52.6590516,
                36.6195559
              ],
              [
                52.6575734,
                36.6194757
              ],
              [
                52.6569135,
                36.620153
              ],
              [
                52.6555134,
                36.6203834
              ],
              [
                52.654156,
                36.6207937
              ],
              [
                52.6526641,
                36.6205541
              ],
              [
                52.6507963,
                36.6208588
              ],
              [
                52.6511873,
                36.6213365
              ],
              [
                52.649903,
                36.6219204
              ],
              [
                52.6493177,
                36.6223627
              ],
              [
                52.6491719,
                36.6229741
              ],
              [
                52.6505038,
                36.6237661
              ],
              [
                52.6503615,
                36.6244842
              ],
              [
                52.6498687,
                36.6251357
              ],
              [
                52.6489707,
                36.6259224
              ],
              [
                52.6480977,
                36.626149
              ],
              [
                52.6472764,
                36.6259781
              ],
              [
                52.6451473,
                36.6254313
              ],
              [
                52.6441,
                36.6253444
              ],
              [
                52.6440345,
                36.6259762
              ],
              [
                52.6432827,
                36.6267459
              ],
              [
                52.6422122,
                36.6260089
              ],
              [
                52.6405309,
                36.625972
              ],
              [
                52.6390502,
                36.625409
              ],
              [
                52.639187,
                36.625002
              ],
              [
                52.6387314,
                36.6248286
              ],
              [
                52.6365058,
                36.6234285
              ],
              [
                52.6350836,
                36.6229515
              ],
              [
                52.6332556,
                36.6226196
              ],
              [
                52.6324658,
                36.6228309
              ],
              [
                52.6313981,
                36.6243732
              ],
              [
                52.6307855,
                36.6239458
              ],
              [
                52.6306204,
                36.6224951
              ],
              [
                52.6314217,
                36.6199552
              ],
              [
                52.6319722,
                36.6196535
              ],
              [
                52.6312319,
                36.618956
              ],
              [
                52.6310764,
                36.6181308
              ],
              [
                52.6320518,
                36.6177007
              ],
              [
                52.6328806,
                36.6188125
              ],
              [
                52.6353196,
                36.6187493
              ],
              [
                52.6358785,
                36.618973
              ],
              [
                52.6367251,
                36.6188096
              ],
              [
                52.6385058,
                36.6188456
              ],
              [
                52.6386791,
                36.6177503
              ],
              [
                52.6388062,
                36.6161944
              ],
              [
                52.6324483,
                36.6156778
              ],
              [
                52.6303531,
                36.6159306
              ],
              [
                52.6287005,
                36.6162854
              ],
              [
                52.6267613,
                36.6166248
              ],
              [
                52.6236688,
                36.6175087
              ],
              [
                52.6199736,
                36.6180979
              ],
              [
                52.6163831,
                36.6192133
              ],
              [
                52.6146015,
                36.6200061
              ],
              [
                52.6102506,
                36.6203076
              ],
              [
                52.6048256,
                36.6193606
              ],
              [
                52.6002655,
                36.6188976
              ],
              [
                52.5975662,
                36.6179085
              ],
              [
                52.5935302,
                36.6174456
              ],
              [
                52.5921936,
                36.616246
              ],
              [
                52.5900818,
                36.6158643
              ],
              [
                52.5893757,
                36.6141739
              ],
              [
                52.587663,
                36.6064064
              ],
              [
                52.5871635,
                36.6060535
              ],
              [
                52.586802,
                36.6057981
              ],
              [
                52.5862069,
                36.6056883
              ],
              [
                52.5843424,
                36.6053444
              ],
              [
                52.5689026,
                36.6024962
              ],
              [
                52.5612755,
                36.5978941
              ],
              [
                52.5556109,
                36.594631
              ],
              [
                52.5488054,
                36.5898489
              ],
              [
                52.5442797,
                36.5882924
              ],
              [
                52.5400946,
                36.5873043
              ],
              [
                52.5337819,
                36.5856384
              ],
              [
                52.531909,
                36.5851441
              ],
              [
                52.5272102,
                36.5829056
              ],
              [
                52.522567,
                36.5806936
              ],
              [
                52.5263164,
                36.5780508
              ],
              [
                52.5271496,
                36.5777716
              ],
              [
                52.5296497,
                36.5749977
              ],
              [
                52.533263,
                36.5666669
              ],
              [
                52.5327064,
                36.5619476
              ],
              [
                52.5324296,
                36.5613892
              ],
              [
                52.5288247,
                36.5461375
              ],
              [
                52.5240931,
                36.5261104
              ],
              [
                52.5238164,
                36.5241649
              ],
              [
                52.5227065,
                36.5213909
              ],
              [
                52.5227064,
                36.5211116
              ],
              [
                52.5049267,
                36.5019449
              ],
              [
                52.5049267,
                36.5013864
              ],
              [
                52.4893702,
                36.4863805
              ],
              [
                52.4865936,
                36.4822191
              ],
              [
                52.486275,
                36.4818626
              ],
              [
                52.4854801,
                36.4805528
              ],
              [
                52.4852036,
                36.4800033
              ],
              [
                52.4837019,
                36.4757914
              ],
              [
                52.4821469,
                36.4713833
              ],
              [
                52.4815937,
                36.4702754
              ],
              [
                52.4818703,
                36.4516659
              ],
              [
                52.4815937,
                36.4486123
              ],
              [
                52.4779804,
                36.4438832
              ],
              [
                52.4777036,
                36.443613
              ],
              [
                52.4755125,
                36.4399577
              ],
              [
                52.4752037,
                36.4394425
              ],
              [
                52.474925,
                36.437769
              ],
              [
                52.4746471,
                36.4361005
              ],
              [
                52.4749271,
                36.4358303
              ],
              [
                52.4752038,
                36.4347134
              ],
              [
                52.4740938,
                36.4311102
              ],
              [
                52.4754804,
                36.4291645
              ],
              [
                52.4779804,
                36.4280475
              ],
              [
                52.479647,
                36.4277773
              ],
              [
                52.4799271,
                36.427498
              ],
              [
                52.481037,
                36.4274981
              ],
              [
                52.482427,
                36.4269396
              ],
              [
                52.4838136,
                36.4255524
              ],
              [
                52.4865937,
                36.419445
              ],
              [
                52.4868703,
                36.4191658
              ],
              [
                52.4871503,
                36.4186072
              ],
              [
                52.4871502,
                36.4183281
              ],
              [
                52.4896504,
                36.4133286
              ],
              [
                52.4915936,
                36.4113829
              ],
              [
                52.5015935,
                36.4061131
              ],
              [
                52.5020454,
                36.4058864
              ],
              [
                52.5049267,
                36.4041583
              ],
              [
                52.5046615,
                36.4035771
              ],
              [
                52.5038813,
                36.4031459
              ],
              [
                52.5038355,
                36.4020003
              ],
              [
                52.5037646,
                36.4005202
              ],
              [
                52.5035288,
                36.3997816
              ],
              [
                52.5032258,
                36.3962941
              ],
              [
                52.5020726,
                36.3957242
              ],
              [
                52.499714,
                36.3956398
              ],
              [
                52.4978532,
                36.392875
              ],
              [
                52.4974601,
                36.3879149
              ],
              [
                52.4948918,
                36.3792604
              ],
              [
                52.4948656,
                36.3759461
              ],
              [
                52.4937125,
                36.3734761
              ],
              [
                52.4925331,
                36.3707738
              ],
              [
                52.4924414,
                36.3662134
              ],
              [
                52.4924676,
                36.3520662
              ],
              [
                52.4904758,
                36.3499545
              ],
              [
                52.4774507,
                36.3471036
              ],
              [
                52.4738341,
                36.345055
              ],
              [
                52.4725792,
                36.3428968
              ],
              [
                52.470034,
                36.3401764
              ],
              [
                52.4599703,
                36.3299957
              ],
              [
                52.4528419,
                36.326278
              ],
              [
                52.4512432,
                36.3232571
              ],
              [
                52.4506404,
                36.3093346
              ],
              [
                52.4465259,
                36.3049819
              ],
              [
                52.4417561,
                36.3027844
              ],
              [
                52.439214,
                36.2971423
              ],
              [
                52.4412844,
                36.2926199
              ],
              [
                52.4438003,
                36.283976
              ],
              [
                52.4423327,
                36.2775082
              ],
              [
                52.4442458,
                36.2757749
              ],
              [
                52.4489107,
                36.2723717
              ],
              [
                52.4502735,
                36.2667908
              ],
              [
                52.4506142,
                36.2603217
              ],
              [
                52.4493039,
                36.2569389
              ],
              [
                52.448439,
                36.2543594
              ],
              [
                52.4422016,
                36.2537039
              ],
              [
                52.4383229,
                36.2528793
              ],
              [
                52.4327931,
                36.2529216
              ],
              [
                52.4276827,
                36.2509763
              ],
              [
                52.4229653,
                36.2490099
              ],
              [
                52.4207377,
                36.248735
              ],
              [
                52.4234895,
                36.2427718
              ],
              [
                52.4231226,
                36.2390922
              ],
              [
                52.4265033,
                36.2365333
              ],
              [
                52.4307489,
                36.231669
              ],
              [
                52.435807,
                36.2234413
              ],
              [
                52.4390043,
                36.2181743
              ],
              [
                52.4406292,
                36.2164185
              ],
              [
                52.4402393,
                36.2154219
              ],
              [
                52.439843,
                36.2144089
              ],
              [
                52.4354663,
                36.2120396
              ],
              [
                52.4333435,
                36.2097548
              ],
              [
                52.4314041,
                36.2052273
              ],
              [
                52.431079,
                36.203538
              ],
              [
                52.4310001,
                36.2031278
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554905,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بابلسر",
          "name:en": "Babolsar County",
          "name:uk": "Баболь-Сер шагрестан",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282224",
          "wikipedia": "en:Babolsar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.5566307,
                36.6227898
              ],
              [
                52.5624293,
                36.619163
              ],
              [
                52.5632627,
                36.6186137
              ],
              [
                52.5804857,
                36.611391
              ],
              [
                52.5815991,
                36.611391
              ],
              [
                52.586319,
                36.6094458
              ],
              [
                52.5866411,
                36.6087173
              ],
              [
                52.5876399,
                36.6064587
              ],
              [
                52.587663,
                36.6064064
              ],
              [
                52.5893757,
                36.6141739
              ],
              [
                52.5900818,
                36.6158643
              ],
              [
                52.5921936,
                36.616246
              ],
              [
                52.5935302,
                36.6174456
              ],
              [
                52.5975662,
                36.6179085
              ],
              [
                52.6002655,
                36.6188976
              ],
              [
                52.6048256,
                36.6193606
              ],
              [
                52.6102506,
                36.6203076
              ],
              [
                52.6146015,
                36.6200061
              ],
              [
                52.6163831,
                36.6192133
              ],
              [
                52.6199736,
                36.6180979
              ],
              [
                52.6236688,
                36.6175087
              ],
              [
                52.6267613,
                36.6166248
              ],
              [
                52.6287005,
                36.6162854
              ],
              [
                52.6303531,
                36.6159306
              ],
              [
                52.6324483,
                36.6156778
              ],
              [
                52.6388062,
                36.6161944
              ],
              [
                52.6386791,
                36.6177503
              ],
              [
                52.6385058,
                36.6188456
              ],
              [
                52.6367251,
                36.6188096
              ],
              [
                52.6358785,
                36.618973
              ],
              [
                52.6353196,
                36.6187493
              ],
              [
                52.6328806,
                36.6188125
              ],
              [
                52.6320518,
                36.6177007
              ],
              [
                52.6310764,
                36.6181308
              ],
              [
                52.6312319,
                36.618956
              ],
              [
                52.6319722,
                36.6196535
              ],
              [
                52.6314217,
                36.6199552
              ],
              [
                52.6306204,
                36.6224951
              ],
              [
                52.6307855,
                36.6239458
              ],
              [
                52.6313981,
                36.6243732
              ],
              [
                52.6324658,
                36.6228309
              ],
              [
                52.6332556,
                36.6226196
              ],
              [
                52.6350836,
                36.6229515
              ],
              [
                52.6365058,
                36.6234285
              ],
              [
                52.6387314,
                36.6248286
              ],
              [
                52.639187,
                36.625002
              ],
              [
                52.6390502,
                36.625409
              ],
              [
                52.6405309,
                36.625972
              ],
              [
                52.6422122,
                36.6260089
              ],
              [
                52.6432827,
                36.6267459
              ],
              [
                52.6440345,
                36.6259762
              ],
              [
                52.6441,
                36.6253444
              ],
              [
                52.6451473,
                36.6254313
              ],
              [
                52.6472764,
                36.6259781
              ],
              [
                52.6480977,
                36.626149
              ],
              [
                52.6489707,
                36.6259224
              ],
              [
                52.6498687,
                36.6251357
              ],
              [
                52.6503615,
                36.6244842
              ],
              [
                52.6505038,
                36.6237661
              ],
              [
                52.6491719,
                36.6229741
              ],
              [
                52.6493177,
                36.6223627
              ],
              [
                52.649903,
                36.6219204
              ],
              [
                52.6511873,
                36.6213365
              ],
              [
                52.6507963,
                36.6208588
              ],
              [
                52.6526641,
                36.6205541
              ],
              [
                52.654156,
                36.6207937
              ],
              [
                52.6555134,
                36.6203834
              ],
              [
                52.6569135,
                36.620153
              ],
              [
                52.6575734,
                36.6194757
              ],
              [
                52.6590516,
                36.6195559
              ],
              [
                52.6613343,
                36.6195163
              ],
              [
                52.664207,
                36.6203507
              ],
              [
                52.6665395,
                36.6207716
              ],
              [
                52.6714141,
                36.6207506
              ],
              [
                52.67317,
                36.6207506
              ],
              [
                52.6776777,
                36.6199298
              ],
              [
                52.6814777,
                36.6196983
              ],
              [
                52.685802,
                36.6194879
              ],
              [
                52.692747,
                36.6196983
              ],
              [
                52.6941622,
                36.6194458
              ],
              [
                52.6969402,
                36.6179096
              ],
              [
                52.7011757,
                36.6173536
              ],
              [
                52.7045072,
                36.6173338
              ],
              [
                52.7059187,
                36.6174087
              ],
              [
                52.7062594,
                36.6174298
              ],
              [
                52.7101119,
                36.6172825
              ],
              [
                52.7133966,
                36.6173182
              ],
              [
                52.7193737,
                36.6173254
              ],
              [
                52.7204429,
                36.6177756
              ],
              [
                52.7279907,
                36.6173336
              ],
              [
                52.7306114,
                36.6178597
              ],
              [
                52.7371371,
                36.6188488
              ],
              [
                52.7408061,
                36.6205324
              ],
              [
                52.7415461,
                36.6206495
              ],
              [
                52.7430247,
                36.6208835
              ],
              [
                52.7459428,
                36.6204061
              ],
              [
                52.750896,
                36.6202378
              ],
              [
                52.7537002,
                36.6206166
              ],
              [
                52.7565044,
                36.6213531
              ],
              [
                52.7585224,
                36.6214373
              ],
              [
                52.7596548,
                36.6213691
              ],
              [
                52.7589944,
                36.6260905
              ],
              [
                52.7605504,
                36.6295588
              ],
              [
                52.7639022,
                36.6323246
              ],
              [
                52.7775876,
                36.6366265
              ],
              [
                52.7879193,
                36.6383057
              ],
              [
                52.8027553,
                36.6371477
              ],
              [
                52.8054129,
                36.638611
              ],
              [
                52.8069811,
                36.6413593
              ],
              [
                52.8101705,
                36.6431151
              ],
              [
                52.8124432,
                36.6422265
              ],
              [
                52.8124432,
                36.6427758
              ],
              [
                52.8121632,
                36.6436132
              ],
              [
                52.8118865,
                36.6438924
              ],
              [
                52.8116099,
                36.6458376
              ],
              [
                52.8160532,
                36.6711155
              ],
              [
                52.8157764,
                36.6716647
              ],
              [
                52.8143865,
                36.6755549
              ],
              [
                52.8142773,
                36.675628
              ],
              [
                52.8135532,
                36.6761132
              ],
              [
                52.8132765,
                36.6763924
              ],
              [
                52.8124431,
                36.6772208
              ],
              [
                52.8104965,
                36.6788958
              ],
              [
                52.8091099,
                36.6819485
              ],
              [
                52.8110531,
                36.6844519
              ],
              [
                52.8149431,
                36.686388
              ],
              [
                52.8157765,
                36.686388
              ],
              [
                52.8316096,
                36.6947265
              ],
              [
                52.8324429,
                36.6991658
              ],
              [
                52.829943,
                36.7072251
              ],
              [
                52.8299429,
                36.7088909
              ],
              [
                52.829943,
                36.7133392
              ],
              [
                52.8274429,
                36.7177785
              ],
              [
                52.8274429,
                36.7211191
              ],
              [
                52.8360528,
                36.7280617
              ],
              [
                52.8366095,
                36.7280616
              ],
              [
                52.8429995,
                36.7347249
              ],
              [
                52.8446661,
                36.7408388
              ],
              [
                52.8446661,
                36.741109
              ],
              [
                52.8439792,
                36.7440367
              ],
              [
                52.8439791,
                36.7440371
              ],
              [
                52.7865799,
                36.9395826
              ],
              [
                52.751428,
                36.9324757
              ],
              [
                52.7465157,
                36.9314289
              ],
              [
                52.7449528,
                36.9312779
              ],
              [
                52.7359028,
                36.9301309
              ],
              [
                52.730551,
                36.9293227
              ],
              [
                52.7252225,
                36.9284208
              ],
              [
                52.7197779,
                36.9273962
              ],
              [
                52.7159293,
                36.9270143
              ],
              [
                52.7065751,
                36.9258334
              ],
              [
                52.6962122,
                36.9241797
              ],
              [
                52.6859463,
                36.9221744
              ],
              [
                52.6793697,
                36.9207816
              ],
              [
                52.6739812,
                36.9201613
              ],
              [
                52.668711,
                36.9194599
              ],
              [
                52.6633599,
                36.9186518
              ],
              [
                52.6580316,
                36.9176872
              ],
              [
                52.6566557,
                36.9175639
              ],
              [
                52.6556655,
                36.9174839
              ],
              [
                52.6504335,
                36.9175956
              ],
              [
                52.6449916,
                36.9174521
              ],
              [
                52.6395549,
                36.9172132
              ],
              [
                52.6341261,
                36.9168788
              ],
              [
                52.6287077,
                36.9164492
              ],
              [
                52.6233024,
                36.9159245
              ],
              [
                52.6179126,
                36.915305
              ],
              [
                52.6125411,
                36.914591
              ],
              [
                52.6071904,
                36.9137828
              ],
              [
                52.601863,
                36.9128809
              ],
              [
                52.5965615,
                36.9118856
              ],
              [
                52.5912885,
                36.9107975
              ],
              [
                52.5860464,
                36.909617
              ],
              [
                52.5808378,
                36.9083448
              ],
              [
                52.5756652,
                36.9069813
              ],
              [
                52.5705311,
                36.9055274
              ],
              [
                52.5644927,
                36.9036858
              ],
              [
                52.6054743,
                36.7048671
              ],
              [
                52.6054528,
                36.7044193
              ],
              [
                52.6053429,
                36.7035582
              ],
              [
                52.6053213,
                36.7033887
              ],
              [
                52.6052087,
                36.7025065
              ],
              [
                52.6023467,
                36.7007112
              ],
              [
                52.6015152,
                36.70021
              ],
              [
                52.5973174,
                36.6976796
              ],
              [
                52.5957163,
                36.6944257
              ],
              [
                52.5944341,
                36.6904914
              ],
              [
                52.5938862,
                36.6856339
              ],
              [
                52.5939492,
                36.6818376
              ],
              [
                52.5941896,
                36.6768197
              ],
              [
                52.5956206,
                36.6732981
              ],
              [
                52.5973658,
                36.6718813
              ],
              [
                52.5588193,
                36.6333379
              ],
              [
                52.5582628,
                36.6322212
              ],
              [
                52.5543727,
                36.6261154
              ],
              [
                52.5543726,
                36.6249988
              ],
              [
                52.5557626,
                36.6233327
              ],
              [
                52.5566307,
                36.6227898
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554947,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بهشهر",
          "name:en": "Behshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282178",
          "wikipedia": "en:Behshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.2029624,
                37.043566
              ],
              [
                53.2649093,
                36.8424972
              ],
              [
                53.2649094,
                36.842497
              ],
              [
                53.2657981,
                36.8407874
              ],
              [
                53.2660748,
                36.8402847
              ],
              [
                53.266908,
                36.8386192
              ],
              [
                53.2707851,
                36.8294968
              ],
              [
                53.2744091,
                36.8250703
              ],
              [
                53.2750587,
                36.8198157
              ],
              [
                53.2718497,
                36.8160649
              ],
              [
                53.2673462,
                36.810889
              ],
              [
                53.2639764,
                36.8073434
              ],
              [
                53.2600576,
                36.8000748
              ],
              [
                53.2613754,
                36.795849
              ],
              [
                53.2655733,
                36.7874381
              ],
              [
                53.2663649,
                36.7860212
              ],
              [
                53.271753,
                36.7824141
              ],
              [
                53.2779836,
                36.7811735
              ],
              [
                53.2832193,
                36.779008
              ],
              [
                53.2888078,
                36.7755273
              ],
              [
                53.3122766,
                36.7605607
              ],
              [
                53.3216245,
                36.757024
              ],
              [
                53.3245468,
                36.7556652
              ],
              [
                53.3292797,
                36.7543755
              ],
              [
                53.3421421,
                36.7475158
              ],
              [
                53.3464917,
                36.7427648
              ],
              [
                53.3499097,
                36.7381963
              ],
              [
                53.3656203,
                36.7252647
              ],
              [
                53.3747107,
                36.715744
              ],
              [
                53.3814413,
                36.7081237
              ],
              [
                53.3828244,
                36.7054606
              ],
              [
                53.3814525,
                36.7019737
              ],
              [
                53.3829116,
                36.698292
              ],
              [
                53.3853185,
                36.6942677
              ],
              [
                53.3872695,
                36.6901179
              ],
              [
                53.3878196,
                36.6868458
              ],
              [
                53.3867311,
                36.6827718
              ],
              [
                53.3866024,
                36.6798464
              ],
              [
                53.3874019,
                36.6768247
              ],
              [
                53.3886761,
                36.6706465
              ],
              [
                53.3891586,
                36.6695314
              ],
              [
                53.3889404,
                36.6665683
              ],
              [
                53.3887254,
                36.6646875
              ],
              [
                53.3879673,
                36.6593593
              ],
              [
                53.3866899,
                36.6530749
              ],
              [
                53.3855603,
                36.6447847
              ],
              [
                53.3853629,
                36.642354
              ],
              [
                53.3851262,
                36.6338803
              ],
              [
                53.3902114,
                36.6334934
              ],
              [
                53.3973531,
                36.6348442
              ],
              [
                53.4036971,
                36.6342665
              ],
              [
                53.4102548,
                36.6331382
              ],
              [
                53.4172052,
                36.6328149
              ],
              [
                53.4324586,
                36.6362127
              ],
              [
                53.4374416,
                36.6353135
              ],
              [
                53.4433582,
                36.6304393
              ],
              [
                53.4460353,
                36.6264494
              ],
              [
                53.4495897,
                36.6241565
              ],
              [
                53.4530662,
                36.6235925
              ],
              [
                53.4567626,
                36.6265118
              ],
              [
                53.4620886,
                36.6306641
              ],
              [
                53.4672748,
                36.6334789
              ],
              [
                53.4726777,
                36.6334657
              ],
              [
                53.4784075,
                36.6323348
              ],
              [
                53.4823669,
                36.6283631
              ],
              [
                53.4851789,
                36.6248245
              ],
              [
                53.4887784,
                36.6222607
              ],
              [
                53.4925586,
                36.6210131
              ],
              [
                53.4962921,
                36.6183606
              ],
              [
                53.4988061,
                36.6161758
              ],
              [
                53.4989692,
                36.6129075
              ],
              [
                53.4982943,
                36.6107406
              ],
              [
                53.4976644,
                36.6082305
              ],
              [
                53.4984518,
                36.6069483
              ],
              [
                53.4981143,
                36.6037699
              ],
              [
                53.4981593,
                36.601386
              ],
              [
                53.4975977,
                36.599386
              ],
              [
                53.4949424,
                36.5963109
              ],
              [
                53.4929852,
                36.5940893
              ],
              [
                53.4894982,
                36.5921025
              ],
              [
                53.489262,
                36.5898086
              ],
              [
                53.4899144,
                36.5872075
              ],
              [
                53.4903548,
                36.5861537
              ],
              [
                53.4923778,
                36.5862004
              ],
              [
                53.4942787,
                36.5857624
              ],
              [
                53.4959547,
                36.585488
              ],
              [
                53.4968152,
                36.584814
              ],
              [
                53.4985586,
                36.5841366
              ],
              [
                53.4993091,
                36.5826885
              ],
              [
                53.5007666,
                36.582112
              ],
              [
                53.501454,
                36.582445
              ],
              [
                53.5022777,
                36.5831722
              ],
              [
                53.5041314,
                36.5834308
              ],
              [
                53.5050018,
                36.5836596
              ],
              [
                53.5064113,
                36.583532
              ],
              [
                53.5065688,
                36.5827366
              ],
              [
                53.5066096,
                36.5820885
              ],
              [
                53.5077091,
                36.5819689
              ],
              [
                53.5085611,
                36.5815014
              ],
              [
                53.5087214,
                36.5808511
              ],
              [
                53.5080606,
                36.579424
              ],
              [
                53.509745,
                36.5799411
              ],
              [
                53.5114547,
                36.5797062
              ],
              [
                53.5116037,
                36.5787036
              ],
              [
                53.5131033,
                36.5773363
              ],
              [
                53.5149416,
                36.5771477
              ],
              [
                53.5168088,
                36.5778048
              ],
              [
                53.5160749,
                36.5761337
              ],
              [
                53.5171069,
                36.5757611
              ],
              [
                53.5185129,
                36.5753388
              ],
              [
                53.5195084,
                36.5758108
              ],
              [
                53.5219211,
                36.5779042
              ],
              [
                53.5229447,
                36.5770416
              ],
              [
                53.5232147,
                36.576075
              ],
              [
                53.5243957,
                36.5745123
              ],
              [
                53.5253743,
                36.5744897
              ],
              [
                53.5266426,
                36.5755613
              ],
              [
                53.5282089,
                36.5765312
              ],
              [
                53.5304697,
                36.5778139
              ],
              [
                53.5337036,
                36.5787262
              ],
              [
                53.5395639,
                36.5791598
              ],
              [
                53.5415436,
                36.5796746
              ],
              [
                53.5419485,
                36.5804604
              ],
              [
                53.5415098,
                36.5812553
              ],
              [
                53.5417657,
                36.5827327
              ],
              [
                53.5434544,
                36.5832447
              ],
              [
                53.5442878,
                36.5842613
              ],
              [
                53.5442994,
                36.586232
              ],
              [
                53.5452667,
                36.5876049
              ],
              [
                53.5455858,
                36.5886167
              ],
              [
                53.5450769,
                36.5899052
              ],
              [
                53.5462565,
                36.5928611
              ],
              [
                53.5474714,
                36.5943061
              ],
              [
                53.5503059,
                36.5953356
              ],
              [
                53.552578,
                36.5964373
              ],
              [
                53.5549401,
                36.5968527
              ],
              [
                53.5591228,
                36.5977547
              ],
              [
                53.560508,
                36.5984011
              ],
              [
                53.5619262,
                36.6005391
              ],
              [
                53.5631963,
                36.6009435
              ],
              [
                53.5645236,
                36.6022529
              ],
              [
                53.5671557,
                36.6037879
              ],
              [
                53.5685504,
                36.6045103
              ],
              [
                53.5707978,
                36.6065218
              ],
              [
                53.5729822,
                36.6068806
              ],
              [
                53.574242,
                36.6064607
              ],
              [
                53.5753668,
                36.6052869
              ],
              [
                53.5765816,
                36.6046051
              ],
              [
                53.5781142,
                36.6043388
              ],
              [
                53.5788397,
                36.6039708
              ],
              [
                53.5801473,
                36.6024921
              ],
              [
                53.5818683,
                36.6021671
              ],
              [
                53.5827344,
                36.6010519
              ],
              [
                53.5844666,
                36.6004784
              ],
              [
                53.5855014,
                36.599896
              ],
              [
                53.5867725,
                36.5999231
              ],
              [
                53.5875205,
                36.5983518
              ],
              [
                53.5895227,
                36.5976881
              ],
              [
                53.5902257,
                36.5966721
              ],
              [
                53.5911255,
                36.59576
              ],
              [
                53.5922757,
                36.5952904
              ],
              [
                53.5934652,
                36.5938139
              ],
              [
                53.5940276,
                36.5926895
              ],
              [
                53.5950287,
                36.593123
              ],
              [
                53.5958723,
                36.5925992
              ],
              [
                53.5955798,
                36.5916961
              ],
              [
                53.5963559,
                36.5908201
              ],
              [
                53.5978632,
                36.5914703
              ],
              [
                53.5985381,
                36.5932314
              ],
              [
                53.5993001,
                36.5935574
              ],
              [
                53.6013839,
                36.5938003
              ],
              [
                53.6024185,
                36.5946305
              ],
              [
                53.6032623,
                36.5943061
              ],
              [
                53.6034198,
                36.5935249
              ],
              [
                53.6032547,
                36.5925534
              ],
              [
                53.6038641,
                36.592116
              ],
              [
                53.6053376,
                36.5915742
              ],
              [
                53.606033,
                36.590408
              ],
              [
                53.608075,
                36.591221
              ],
              [
                53.6094491,
                36.592861
              ],
              [
                53.609038,
                36.5951531
              ],
              [
                53.610819,
                36.5955525
              ],
              [
                53.6159727,
                36.5897363
              ],
              [
                53.6167337,
                36.5877978
              ],
              [
                53.6674511,
                36.5609711
              ],
              [
                53.6691176,
                36.5607009
              ],
              [
                53.669671,
                36.5595838
              ],
              [
                53.7038533,
                36.5439171
              ],
              [
                53.7286374,
                36.5328126
              ],
              [
                53.7296097,
                36.5227351
              ],
              [
                53.7125012,
                36.5129477
              ],
              [
                53.7114712,
                36.4963898
              ],
              [
                53.7264364,
                36.4815035
              ],
              [
                53.7275498,
                36.4798368
              ],
              [
                53.7275498,
                36.4795574
              ],
              [
                53.7278264,
                36.4792781
              ],
              [
                53.7297697,
                36.4776114
              ],
              [
                53.7325497,
                36.4767826
              ],
              [
                53.7336597,
                36.4767826
              ],
              [
                53.7342164,
                36.4765034
              ],
              [
                53.736993,
                36.4765033
              ],
              [
                53.7397696,
                36.4756655
              ],
              [
                53.7411596,
                36.4756655
              ],
              [
                53.7414362,
                36.4753862
              ],
              [
                53.7428261,
                36.4753862
              ],
              [
                53.7431029,
                36.4751159
              ],
              [
                53.7442163,
                36.475116
              ],
              [
                53.7447695,
                36.4748366
              ],
              [
                53.7519928,
                36.4748366
              ],
              [
                53.7528261,
                36.4745573
              ],
              [
                53.7908018,
                36.4737291
              ],
              [
                53.7916351,
                36.4740084
              ],
              [
                53.7938584,
                36.4740085
              ],
              [
                53.7941351,
                36.4742876
              ],
              [
                53.796635,
                36.474558
              ],
              [
                53.7977485,
                36.4751165
              ],
              [
                53.7988583,
                36.4751165
              ],
              [
                53.800525,
                36.4756752
              ],
              [
                53.801635,
                36.4756751
              ],
              [
                53.801915,
                36.4759544
              ],
              [
                53.8069149,
                36.4770626
              ],
              [
                53.8083016,
                36.4770626
              ],
              [
                53.826672,
                36.4780883
              ],
              [
                53.8280619,
                36.4769713
              ],
              [
                53.8283386,
                36.4761426
              ],
              [
                53.8338785,
                36.4786075
              ],
              [
                53.8355452,
                36.4786076
              ],
              [
                53.8363785,
                36.4788868
              ],
              [
                53.8380451,
                36.4788868
              ],
              [
                53.8399918,
                36.4794453
              ],
              [
                53.8411017,
                36.4797245
              ],
              [
                53.8441583,
                36.4822196
              ],
              [
                53.8447117,
                36.4833365
              ],
              [
                53.8477683,
                36.4863809
              ],
              [
                53.848325,
                36.4863809
              ],
              [
                53.8549916,
                36.4905512
              ],
              [
                53.8599916,
                36.4922176
              ],
              [
                53.8630482,
                36.4922175
              ],
              [
                53.8636014,
                36.4919383
              ],
              [
                53.8644382,
                36.4919383
              ],
              [
                53.8763814,
                36.4869393
              ],
              [
                53.8822146,
                36.4836156
              ],
              [
                53.8844379,
                36.482778
              ],
              [
                53.8886045,
                36.4819403
              ],
              [
                53.8919378,
                36.4819404
              ],
              [
                53.8927711,
                36.4816701
              ],
              [
                53.8958279,
                36.4816701
              ],
              [
                53.8963811,
                36.4813909
              ],
              [
                53.8977711,
                36.481391
              ],
              [
                53.8983278,
                36.4811117
              ],
              [
                53.899161,
                36.4811116
              ],
              [
                53.8999945,
                36.4808324
              ],
              [
                53.9016611,
                36.4808324
              ],
              [
                53.9019377,
                36.4805532
              ],
              [
                53.904161,
                36.4805533
              ],
              [
                53.9049944,
                36.4808325
              ],
              [
                53.906661,
                36.4808324
              ],
              [
                53.9072177,
                36.4811117
              ],
              [
                53.9080511,
                36.4811116
              ],
              [
                53.9086043,
                36.4813909
              ],
              [
                53.9097177,
                36.4813909
              ],
              [
                53.910551,
                36.4816701
              ],
              [
                53.9127709,
                36.4819403
              ],
              [
                53.9131939,
                36.4819403
              ],
              [
                53.9158276,
                36.4819403
              ],
              [
                53.9169375,
                36.4822195
              ],
              [
                53.9186041,
                36.4822195
              ],
              [
                53.9194375,
                36.4824988
              ],
              [
                53.9208275,
                36.4824988
              ],
              [
                53.9219409,
                36.482778
              ],
              [
                53.9238841,
                36.482778
              ],
              [
                53.9244408,
                36.4830572
              ],
              [
                53.9263842,
                36.4830572
              ],
              [
                53.9269408,
                36.4833365
              ],
              [
                53.9294408,
                36.4833364
              ],
              [
                53.929994,
                36.4836157
              ],
              [
                53.933884,
                36.4836156
              ],
              [
                53.9355507,
                36.483886
              ],
              [
                53.9424974,
                36.4838859
              ],
              [
                53.9433306,
                36.4841651
              ],
              [
                53.9447171,
                36.4841651
              ],
              [
                53.9458306,
                36.4844443
              ],
              [
                53.9472172,
                36.4844444
              ],
              [
                53.9480505,
                36.4847236
              ],
              [
                53.9513838,
                36.4847236
              ],
              [
                53.9519405,
                36.4850028
              ],
              [
                53.9538838,
                36.4850028
              ],
              [
                53.9555504,
                36.4850028
              ],
              [
                53.9613872,
                36.4850028
              ],
              [
                53.9619404,
                36.4847236
              ],
              [
                53.9633303,
                36.4847236
              ],
              [
                53.9641637,
                36.4844444
              ],
              [
                53.9652736,
                36.4844443
              ],
              [
                53.9699969,
                36.4833364
              ],
              [
                54.000903,
                36.4747191
              ],
              [
                54.0017364,
                36.4747192
              ],
              [
                54.0117363,
                36.4705488
              ],
              [
                54.0141097,
                36.4699324
              ],
              [
                54.0237579,
                36.4631371
              ],
              [
                54.0238642,
                36.4625829
              ],
              [
                54.024047,
                36.4622869
              ],
              [
                54.0274255,
                36.4591799
              ],
              [
                54.0323154,
                36.4557169
              ],
              [
                54.0444565,
                36.4449122
              ],
              [
                54.0444564,
                36.4446138
              ],
              [
                54.0462657,
                36.4453083
              ],
              [
                54.0468223,
                36.4455875
              ],
              [
                54.0532813,
                36.4590488
              ],
              [
                54.0613791,
                36.4688563
              ],
              [
                54.0730592,
                36.4719422
              ],
              [
                54.093059,
                36.4788868
              ],
              [
                54.1041687,
                36.4841652
              ],
              [
                54.1465012,
                36.4971818
              ],
              [
                54.1486932,
                36.4975881
              ],
              [
                54.1540732,
                36.4963727
              ],
              [
                54.1588167,
                36.4966046
              ],
              [
                54.1630099,
                36.4979536
              ],
              [
                54.1688804,
                36.5007357
              ],
              [
                54.1700597,
                36.5021057
              ],
              [
                54.1701908,
                36.5033492
              ],
              [
                54.1707936,
                36.5042344
              ],
              [
                54.1721106,
                36.5047405
              ],
              [
                54.1729727,
                36.504826
              ],
              [
                54.1725832,
                36.5052321
              ],
              [
                54.1723413,
                36.5057876
              ],
              [
                54.1709785,
                36.5067781
              ],
              [
                54.1645577,
                36.5061248
              ],
              [
                54.1612555,
                36.5057032
              ],
              [
                54.1548411,
                36.5064548
              ],
              [
                54.1518045,
                36.5073446
              ],
              [
                54.1505536,
                36.5091793
              ],
              [
                54.1498379,
                36.5127358
              ],
              [
                54.1501146,
                36.5152306
              ],
              [
                54.1503912,
                36.5174551
              ],
              [
                54.1512245,
                36.5221833
              ],
              [
                54.1515045,
                36.5241196
              ],
              [
                54.1687207,
                36.5416789
              ],
              [
                54.1698306,
                36.5494516
              ],
              [
                54.167884,
                36.5691759
              ],
              [
                54.1673306,
                36.5713915
              ],
              [
                54.1687237,
                36.5950181
              ],
              [
                54.1662237,
                36.600575
              ],
              [
                54.1645571,
                36.6036281
              ],
              [
                54.1559472,
                36.6130756
              ],
              [
                54.1506672,
                36.6161287
              ],
              [
                54.1498339,
                36.6169662
              ],
              [
                54.0832898,
                36.6224168
              ],
              [
                54.0699562,
                36.6323587
              ],
              [
                54.0491664,
                36.6309715
              ],
              [
                54.0352988,
                36.6282298
              ],
              [
                54.0231148,
                36.6241678
              ],
              [
                54.0130325,
                36.6211207
              ],
              [
                54.0008507,
                36.6248473
              ],
              [
                53.9920074,
                36.6237038
              ],
              [
                53.9798474,
                36.622136
              ],
              [
                53.9697663,
                36.6204404
              ],
              [
                53.9565077,
                36.620599
              ],
              [
                53.9443257,
                36.6156769
              ],
              [
                53.9212254,
                36.611599
              ],
              [
                53.8977077,
                36.6071778
              ],
              [
                53.8762879,
                36.6058035
              ],
              [
                53.8557093,
                36.6040877
              ],
              [
                53.8506692,
                36.6029978
              ],
              [
                53.829457,
                36.5992986
              ],
              [
                53.816811,
                36.5975222
              ],
              [
                53.7981185,
                36.5990191
              ],
              [
                53.7850289,
                36.6007574
              ],
              [
                53.7741289,
                36.5989802
              ],
              [
                53.7693225,
                36.6021381
              ],
              [
                53.7684263,
                36.610932
              ],
              [
                53.769937,
                36.6260337
              ],
              [
                53.7726285,
                36.6373537
              ],
              [
                53.774583,
                36.6436783
              ],
              [
                53.7757624,
                36.6463956
              ],
              [
                53.7745142,
                36.6483824
              ],
              [
                53.7682914,
                36.6498285
              ],
              [
                53.7602163,
                36.6508555
              ],
              [
                53.7498336,
                36.6525477
              ],
              [
                53.7456321,
                36.6518255
              ],
              [
                53.741598,
                36.6518944
              ],
              [
                53.7361634,
                36.6530761
              ],
              [
                53.7274068,
                36.6512737
              ],
              [
                53.7222979,
                36.6504649
              ],
              [
                53.7130487,
                36.6494746
              ],
              [
                53.7054059,
                36.6489379
              ],
              [
                53.6963653,
                36.6492088
              ],
              [
                53.6930725,
                36.6505062
              ],
              [
                53.6816453,
                36.6550963
              ],
              [
                53.6804437,
                36.6547175
              ],
              [
                53.678255,
                36.6558881
              ],
              [
                53.6779975,
                36.657403
              ],
              [
                53.6755942,
                36.6583669
              ],
              [
                53.6738716,
                36.6581858
              ],
              [
                53.670659,
                36.6590554
              ],
              [
                53.6662817,
                36.6615341
              ],
              [
                53.6631488,
                36.6642193
              ],
              [
                53.6606422,
                36.6667187
              ],
              [
                53.6582136,
                36.6706564
              ],
              [
                53.6605739,
                36.6745804
              ],
              [
                53.6628483,
                36.6787796
              ],
              [
                53.6635351,
                36.6798464
              ],
              [
                53.66508,
                36.6812231
              ],
              [
                53.6652946,
                36.6830128
              ],
              [
                53.6648654,
                36.6845271
              ],
              [
                53.6629772,
                36.6850089
              ],
              [
                53.6560249,
                36.6856972
              ],
              [
                53.653202,
                36.6863776
              ],
              [
                53.650403,
                36.6885191
              ],
              [
                53.6498451,
                36.690171
              ],
              [
                53.6497592,
                36.6916507
              ],
              [
                53.6490947,
                36.6936128
              ],
              [
                53.6485576,
                36.6954015
              ],
              [
                53.6469268,
                36.6988081
              ],
              [
                53.6467123,
                36.7008382
              ],
              [
                53.6479568,
                36.7030059
              ],
              [
                53.649376,
                36.705925
              ],
              [
                53.6495876,
                36.707926
              ],
              [
                53.6491799,
                36.708528
              ],
              [
                53.6489009,
                36.7095774
              ],
              [
                53.6490083,
                36.7107127
              ],
              [
                53.6493552,
                36.7112189
              ],
              [
                53.6495018,
                36.7126909
              ],
              [
                53.6491155,
                36.7134822
              ],
              [
                53.6492228,
                36.7144798
              ],
              [
                53.6498236,
                36.7149442
              ],
              [
                53.6501026,
                36.7159763
              ],
              [
                53.6495876,
                36.7167331
              ],
              [
                53.6493353,
                36.7185507
              ],
              [
                53.6494159,
                36.7205859
              ],
              [
                53.6494374,
                36.7210331
              ],
              [
                53.6499969,
                36.7221365
              ],
              [
                53.6500382,
                36.7240946
              ],
              [
                53.6503601,
                36.7265196
              ],
              [
                53.6494159,
                36.731077
              ],
              [
                53.6469698,
                36.7357545
              ],
              [
                53.6487192,
                36.7382108
              ],
              [
                53.6502661,
                36.7378214
              ],
              [
                53.6530208,
                36.7387122
              ],
              [
                53.6565828,
                36.7416698
              ],
              [
                53.6584711,
                36.7438707
              ],
              [
                53.6596079,
                36.7465389
              ],
              [
                53.6598014,
                36.7488913
              ],
              [
                53.6611747,
                36.7538428
              ],
              [
                53.6629343,
                36.7569373
              ],
              [
                53.6641814,
                36.7613334
              ],
              [
                53.6646509,
                36.7676297
              ],
              [
                53.6672772,
                36.7726513
              ],
              [
                53.6658954,
                36.7785612
              ],
              [
                53.6648926,
                36.7820517
              ],
              [
                53.6640071,
                36.7870509
              ],
              [
                53.6680412,
                36.7971205
              ],
              [
                53.66927,
                36.7990647
              ],
              [
                53.6599728,
                36.8367676
              ],
              [
                53.6899706,
                36.8678455
              ],
              [
                53.6930179,
                36.8769431
              ],
              [
                53.6939185,
                36.8912918
              ],
              [
                53.6929747,
                36.8943118
              ],
              [
                53.6322864,
                37.0842039
              ],
              [
                53.6257318,
                37.0834895
              ],
              [
                53.6192032,
                37.0826361
              ],
              [
                53.6147304,
                37.0819594
              ],
              [
                53.5878877,
                37.0802918
              ],
              [
                53.5710601,
                37.0787815
              ],
              [
                53.5439463,
                37.0755943
              ],
              [
                53.5207122,
                37.0736617
              ],
              [
                53.464508,
                37.0689865
              ],
              [
                53.4532567,
                37.0678387
              ],
              [
                53.4117443,
                37.0628613
              ],
              [
                53.4063396,
                37.0635184
              ],
              [
                53.4009238,
                37.0640431
              ],
              [
                53.3954949,
                37.0644727
              ],
              [
                53.3900556,
                37.0648071
              ],
              [
                53.3846084,
                37.065046
              ],
              [
                53.379156,
                37.0651894
              ],
              [
                53.373701,
                37.0652372
              ],
              [
                53.368246,
                37.0651894
              ],
              [
                53.3627936,
                37.065046
              ],
              [
                53.3573464,
                37.0648071
              ],
              [
                53.3519071,
                37.0644727
              ],
              [
                53.3464782,
                37.0640431
              ],
              [
                53.3410624,
                37.0635184
              ],
              [
                53.3356622,
                37.0628989
              ],
              [
                53.3302803,
                37.0621849
              ],
              [
                53.3249192,
                37.0613768
              ],
              [
                53.3195815,
                37.0604748
              ],
              [
                53.3142698,
                37.0594796
              ],
              [
                53.3089866,
                37.0583915
              ],
              [
                53.3037344,
                37.057211
              ],
              [
                53.2985158,
                37.0559387
              ],
              [
                53.2933332,
                37.0545753
              ],
              [
                53.2881891,
                37.0531214
              ],
              [
                53.2830861,
                37.0515777
              ],
              [
                53.2780265,
                37.0499448
              ],
              [
                53.2730127,
                37.0482237
              ],
              [
                53.272129,
                37.0478347
              ],
              [
                53.2677268,
                37.0480953
              ],
              [
                53.2622756,
                37.0482387
              ],
              [
                53.2568218,
                37.0482865
              ],
              [
                53.251368,
                37.0482387
              ],
              [
                53.2459168,
                37.0480953
              ],
              [
                53.2404708,
                37.0478563
              ],
              [
                53.2350327,
                37.0475219
              ],
              [
                53.229605,
                37.0470923
              ],
              [
                53.2241904,
                37.0465676
              ],
              [
                53.2187915,
                37.0459482
              ],
              [
                53.2134108,
                37.0452342
              ],
              [
                53.2080509,
                37.044426
              ],
              [
                53.2029624,
                37.043566
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554968,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تنکابن",
          "name:en": "Tonekabon County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282199",
          "wikipedia": "en:Tonekabon County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.5086608,
                36.5463533
              ],
              [
                50.5173046,
                36.5435539
              ],
              [
                50.5380756,
                36.5412979
              ],
              [
                50.5466003,
                36.5419683
              ],
              [
                50.5712872,
                36.5372907
              ],
              [
                50.5731368,
                36.5365019
              ],
              [
                50.5743813,
                36.5355365
              ],
              [
                50.5752826,
                36.5348296
              ],
              [
                50.5753469,
                36.5339503
              ],
              [
                50.5766772,
                36.53264
              ],
              [
                50.5770635,
                36.5318985
              ],
              [
                50.5775141,
                36.5313296
              ],
              [
                50.5787372,
                36.530433
              ],
              [
                50.5840587,
                36.5311571
              ],
              [
                50.5858612,
                36.5308123
              ],
              [
                50.5879211,
                36.5305364
              ],
              [
                50.5894153,
                36.5305294
              ],
              [
                50.5935001,
                36.5284329
              ],
              [
                50.5949592,
                36.5270534
              ],
              [
                50.597425,
                36.5261053
              ],
              [
                50.5990502,
                36.5256595
              ],
              [
                50.6025443,
                36.5256938
              ],
              [
                50.6042742,
                36.5259868
              ],
              [
                50.606886,
                36.5271249
              ],
              [
                50.6094646,
                36.527019
              ],
              [
                50.6127638,
                36.5264866
              ],
              [
                50.6185626,
                36.5232945
              ],
              [
                50.6227877,
                36.5240617
              ],
              [
                50.6269059,
                36.5243953
              ],
              [
                50.6286906,
                36.5232944
              ],
              [
                50.6321239,
                36.5254326
              ],
              [
                50.634613,
                36.5262603
              ],
              [
                50.6403636,
                36.5241221
              ],
              [
                50.6441402,
                36.521846
              ],
              [
                50.6478309,
                36.5197077
              ],
              [
                50.6511783,
                36.5163967
              ],
              [
                50.6560351,
                36.5144651
              ],
              [
                50.6591605,
                36.5081875
              ],
              [
                50.6490325,
                36.4990115
              ],
              [
                50.6536018,
                36.4980256
              ],
              [
                50.6612343,
                36.4926325
              ],
              [
                50.670639,
                36.4852786
              ],
              [
                50.6759374,
                36.4812957
              ],
              [
                50.6762353,
                36.4810718
              ],
              [
                50.6844433,
                36.4772949
              ],
              [
                50.7024192,
                36.4703727
              ],
              [
                50.7142203,
                36.4644059
              ],
              [
                50.7219669,
                36.4635276
              ],
              [
                50.7334899,
                36.4620896
              ],
              [
                50.7481323,
                36.4592034
              ],
              [
                50.7545416,
                36.4517144
              ],
              [
                50.7613743,
                36.445002
              ],
              [
                50.7674983,
                36.4381657
              ],
              [
                50.7738884,
                36.4334392
              ],
              [
                50.7824752,
                36.4283524
              ],
              [
                50.786835,
                36.4237807
              ],
              [
                50.7915118,
                36.4198904
              ],
              [
                50.7981295,
                36.4151083
              ],
              [
                50.8015212,
                36.411306
              ],
              [
                50.804719,
                36.4096702
              ],
              [
                50.8057593,
                36.4069156
              ],
              [
                50.8106282,
                36.4010029
              ],
              [
                50.8136557,
                36.3957241
              ],
              [
                50.8203785,
                36.3934856
              ],
              [
                50.8287619,
                36.3900586
              ],
              [
                50.8311191,
                36.3911392
              ],
              [
                50.8547514,
                36.3771124
              ],
              [
                50.8656045,
                36.3704312
              ],
              [
                50.8720834,
                36.3615428
              ],
              [
                50.881445,
                36.3508941
              ],
              [
                50.8817933,
                36.3504978
              ],
              [
                50.8837366,
                36.3493864
              ],
              [
                50.890485,
                36.3469668
              ],
              [
                50.8954771,
                36.3448186
              ],
              [
                50.9002477,
                36.3409258
              ],
              [
                50.9029717,
                36.3376248
              ],
              [
                50.9049797,
                36.3332948
              ],
              [
                50.9061246,
                36.3300928
              ],
              [
                50.905838,
                36.3229744
              ],
              [
                50.9030485,
                36.3159897
              ],
              [
                50.9017914,
                36.3116473
              ],
              [
                50.9024911,
                36.3091185
              ],
              [
                50.9076038,
                36.3011458
              ],
              [
                50.9140298,
                36.2939145
              ],
              [
                50.9149297,
                36.2929376
              ],
              [
                50.9186055,
                36.2865326
              ],
              [
                50.9273386,
                36.2838932
              ],
              [
                50.9412963,
                36.2805097
              ],
              [
                50.9409749,
                36.2810997
              ],
              [
                50.9410295,
                36.282375
              ],
              [
                50.9410422,
                36.2826711
              ],
              [
                50.9411161,
                36.2843989
              ],
              [
                50.9398188,
                36.2923081
              ],
              [
                50.9434134,
                36.3049889
              ],
              [
                50.9448225,
                36.3150252
              ],
              [
                50.9445118,
                36.3209032
              ],
              [
                50.9456276,
                36.3274714
              ],
              [
                50.9477779,
                36.3328425
              ],
              [
                50.9557056,
                36.3425078
              ],
              [
                50.9574222,
                36.3482458
              ],
              [
                50.9567785,
                36.3549166
              ],
              [
                50.9541197,
                36.3651404
              ],
              [
                50.9546756,
                36.3692932
              ],
              [
                50.9561783,
                36.3743723
              ],
              [
                50.9599113,
                36.3889531
              ],
              [
                50.9605544,
                36.396526
              ],
              [
                50.9579545,
                36.4169783
              ],
              [
                50.9568995,
                36.4349479
              ],
              [
                50.94738,
                36.4469707
              ],
              [
                50.9396552,
                36.4528391
              ],
              [
                50.9344803,
                36.4599404
              ],
              [
                50.9309864,
                36.467094
              ],
              [
                50.9301188,
                36.4717969
              ],
              [
                50.9292268,
                36.4759287
              ],
              [
                50.926744,
                36.4831996
              ],
              [
                50.918498,
                36.4948371
              ],
              [
                50.9160533,
                36.5004484
              ],
              [
                50.9156468,
                36.5031335
              ],
              [
                50.9155798,
                36.5059798
              ],
              [
                50.9152364,
                36.5077735
              ],
              [
                50.9140352,
                36.5100077
              ],
              [
                50.9125757,
                36.512982
              ],
              [
                50.9107732,
                36.5162587
              ],
              [
                50.9106705,
                36.5172147
              ],
              [
                50.9118624,
                36.5182875
              ],
              [
                50.9139061,
                36.5171554
              ],
              [
                50.9196567,
                36.5156723
              ],
              [
                50.9266948,
                36.5146376
              ],
              [
                50.931158,
                36.5139478
              ],
              [
                50.9360933,
                36.5134649
              ],
              [
                50.9430027,
                36.5130855
              ],
              [
                50.9478521,
                36.5114298
              ],
              [
                50.9543323,
                36.5108435
              ],
              [
                50.9589243,
                36.5098432
              ],
              [
                50.9611988,
                36.5092913
              ],
              [
                50.9663057,
                36.5092223
              ],
              [
                50.971713,
                36.5082564
              ],
              [
                50.9796524,
                36.5053244
              ],
              [
                50.9877204,
                36.5012883
              ],
              [
                50.992881,
                36.5007191
              ],
              [
                50.9961614,
                36.4998496
              ],
              [
                50.9982991,
                36.4986923
              ],
              [
                51.0000157,
                36.4982007
              ],
              [
                51.0004531,
                36.4976158
              ],
              [
                51.0110664,
                36.4945266
              ],
              [
                51.0151862,
                36.4931466
              ],
              [
                51.0227393,
                36.4924566
              ],
              [
                51.0302924,
                36.4923186
              ],
              [
                51.0360431,
                36.4927326
              ],
              [
                51.0407638,
                36.4939746
              ],
              [
                51.0447831,
                36.4959992
              ],
              [
                51.0502386,
                36.5003999
              ],
              [
                51.0650708,
                36.5109746
              ],
              [
                51.0717571,
                36.5172094
              ],
              [
                51.1001586,
                36.5369503
              ],
              [
                51.1123466,
                36.5431566
              ],
              [
                51.1159085,
                36.5458459
              ],
              [
                51.1183977,
                36.547225
              ],
              [
                51.1228179,
                36.5485351
              ],
              [
                51.1255645,
                36.5523963
              ],
              [
                51.1273241,
                36.5539132
              ],
              [
                51.1281411,
                36.5570815
              ],
              [
                51.0945519,
                36.5745545
              ],
              [
                51.0734693,
                36.5886048
              ],
              [
                51.0670792,
                36.5972236
              ],
              [
                51.0668028,
                36.5974938
              ],
              [
                51.0645792,
                36.6002766
              ],
              [
                51.0584693,
                36.6063826
              ],
              [
                51.054026,
                36.6122184
              ],
              [
                51.0529128,
                36.6133351
              ],
              [
                51.0515227,
                36.6155504
              ],
              [
                51.0393029,
                36.6277803
              ],
              [
                51.0301329,
                36.6369479
              ],
              [
                51.0287446,
                36.6383333
              ],
              [
                51.0287447,
                36.6383334
              ],
              [
                51.0431894,
                36.6499967
              ],
              [
                51.0445795,
                36.6508343
              ],
              [
                51.0631926,
                36.6683315
              ],
              [
                51.0656926,
                36.6861075
              ],
              [
                51.0599021,
                36.690576
              ],
              [
                51.0595627,
                36.6911097
              ],
              [
                51.0594409,
                36.6915376
              ],
              [
                51.0615258,
                36.6974986
              ],
              [
                51.0615258,
                36.6980569
              ],
              [
                51.0612457,
                36.698336
              ],
              [
                51.0609693,
                36.6997228
              ],
              [
                51.0612457,
                36.7033337
              ],
              [
                51.0620792,
                36.7047204
              ],
              [
                51.0648591,
                36.7094479
              ],
              [
                51.0654124,
                36.7130587
              ],
              [
                51.0651359,
                36.7141663
              ],
              [
                51.0523592,
                36.7227837
              ],
              [
                51.0515224,
                36.7233329
              ],
              [
                51.0629123,
                36.7311128
              ],
              [
                51.0712913,
                36.7350396
              ],
              [
                51.072866,
                36.7389708
              ],
              [
                51.1663096,
                36.9253497
              ],
              [
                51.1602732,
                36.9266538
              ],
              [
                51.1553583,
                36.9276101
              ],
              [
                51.1281787,
                36.9353277
              ],
              [
                51.12435,
                36.9366721
              ],
              [
                51.1225636,
                36.9374817
              ],
              [
                51.1177636,
                36.9395474
              ],
              [
                51.1129083,
                36.9415283
              ],
              [
                51.1080001,
                36.9434235
              ],
              [
                51.1030413,
                36.945232
              ],
              [
                51.0980343,
                36.9469532
              ],
              [
                51.0929815,
                36.948586
              ],
              [
                51.0878853,
                36.9501298
              ],
              [
                51.0851513,
                36.9509036
              ],
              [
                51.0780703,
                36.9538308
              ],
              [
                51.0736934,
                36.9564021
              ],
              [
                51.0692701,
                36.958954
              ],
              [
                51.0647782,
                36.9614277
              ],
              [
                51.0602199,
                36.963822
              ],
              [
                51.0555973,
                36.9661358
              ],
              [
                51.0531763,
                36.9672893
              ],
              [
                51.0456617,
                36.9725846
              ],
              [
                51.0400608,
                36.9762582
              ],
              [
                51.034329,
                36.9797998
              ],
              [
                51.0275384,
                36.9838706
              ],
              [
                51.0216459,
                36.9872962
              ],
              [
                51.0156311,
                36.9905824
              ],
              [
                51.0094989,
                36.9937263
              ],
              [
                51.0059608,
                36.9954255
              ],
              [
                50.9999708,
                36.9987307
              ],
              [
                50.9934571,
                37.0020905
              ],
              [
                50.9866976,
                37.0053414
              ],
              [
                50.9861894,
                37.0055769
              ],
              [
                50.9814698,
                37.0077088
              ],
              [
                50.9766933,
                37.009758
              ],
              [
                50.9718623,
                37.0117235
              ],
              [
                50.9669791,
                37.0136043
              ],
              [
                50.962046,
                37.0153995
              ],
              [
                50.9570652,
                37.0171084
              ],
              [
                50.9520392,
                37.0187301
              ],
              [
                50.9508236,
                37.019098
              ],
              [
                50.9429801,
                37.0221793
              ],
              [
                50.9372961,
                37.0251394
              ],
              [
                50.9324478,
                37.0284708
              ],
              [
                50.9282385,
                37.0312499
              ],
              [
                50.9239543,
                37.0339545
              ],
              [
                50.9195972,
                37.0365834
              ],
              [
                50.9151693,
                37.0391353
              ],
              [
                50.7772926,
                36.869596
              ],
              [
                50.7772736,
                36.8695708
              ],
              [
                50.7715123,
                36.8619531
              ],
              [
                50.7496371,
                36.8402283
              ],
              [
                50.748642,
                36.8392418
              ],
              [
                50.7372995,
                36.8280213
              ],
              [
                50.7245472,
                36.8152805
              ],
              [
                50.7206607,
                36.8122283
              ],
              [
                50.7037142,
                36.8013881
              ],
              [
                50.7026043,
                36.801118
              ],
              [
                50.7012141,
                36.8000015
              ],
              [
                50.6845632,
                36.7900078
              ],
              [
                50.6837143,
                36.7897282
              ],
              [
                50.6392837,
                36.7666698
              ],
              [
                50.6356549,
                36.7647246
              ],
              [
                50.6278786,
                36.7588899
              ],
              [
                50.6128753,
                36.7377841
              ],
              [
                50.6109477,
                36.7302838
              ],
              [
                50.6073374,
                36.7216665
              ],
              [
                50.6006709,
                36.7083307
              ],
              [
                50.5984478,
                36.7038915
              ],
              [
                50.5786559,
                36.6638666
              ],
              [
                50.5676114,
                36.646385
              ],
              [
                50.5503882,
                36.621944
              ],
              [
                50.5453883,
                36.6158291
              ],
              [
                50.5420549,
                36.6119386
              ],
              [
                50.5414983,
                36.6116684
              ],
              [
                50.513444,
                36.5580676
              ],
              [
                50.5086608,
                36.5463533
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554981,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جویبار",
          "name:en": "Juybar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1283615",
          "wikipedia": "en:Juybar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.7865799,
                36.9395826
              ],
              [
                52.8439791,
                36.7440371
              ],
              [
                52.8439792,
                36.7440367
              ],
              [
                52.8446661,
                36.741109
              ],
              [
                52.8446661,
                36.7408388
              ],
              [
                52.8429995,
                36.7347249
              ],
              [
                52.8366095,
                36.7280616
              ],
              [
                52.8360528,
                36.7280617
              ],
              [
                52.8274429,
                36.7211191
              ],
              [
                52.8274429,
                36.7177785
              ],
              [
                52.829943,
                36.7133392
              ],
              [
                52.8299429,
                36.7088909
              ],
              [
                52.829943,
                36.7072251
              ],
              [
                52.8324429,
                36.6991658
              ],
              [
                52.8316096,
                36.6947265
              ],
              [
                52.8157765,
                36.686388
              ],
              [
                52.8149431,
                36.686388
              ],
              [
                52.8110531,
                36.6844519
              ],
              [
                52.8091099,
                36.6819485
              ],
              [
                52.8104965,
                36.6788958
              ],
              [
                52.8124431,
                36.6772208
              ],
              [
                52.8132765,
                36.6763924
              ],
              [
                52.8135532,
                36.6761132
              ],
              [
                52.8142773,
                36.675628
              ],
              [
                52.8143865,
                36.6755549
              ],
              [
                52.8157764,
                36.6716647
              ],
              [
                52.8160532,
                36.6711155
              ],
              [
                52.8116099,
                36.6458376
              ],
              [
                52.8118865,
                36.6438924
              ],
              [
                52.8121632,
                36.6436132
              ],
              [
                52.8124432,
                36.6427758
              ],
              [
                52.8124432,
                36.6422265
              ],
              [
                52.8141098,
                36.6416681
              ],
              [
                52.8156141,
                36.6405406
              ],
              [
                52.8167294,
                36.6367587
              ],
              [
                52.8222694,
                36.6317167
              ],
              [
                52.8397661,
                36.6157905
              ],
              [
                52.8455027,
                36.6105667
              ],
              [
                52.8459538,
                36.6083565
              ],
              [
                52.8498811,
                36.6021934
              ],
              [
                52.8516468,
                36.6007231
              ],
              [
                52.8557118,
                36.5973381
              ],
              [
                52.8595467,
                36.5896605
              ],
              [
                52.8493337,
                36.5793901
              ],
              [
                52.8544213,
                36.5716072
              ],
              [
                52.8630518,
                36.5709492
              ],
              [
                52.866168,
                36.5705277
              ],
              [
                52.8750483,
                36.569722
              ],
              [
                52.8806775,
                36.5693147
              ],
              [
                52.8926958,
                36.5698357
              ],
              [
                52.900908,
                36.5699052
              ],
              [
                52.9313353,
                36.5733318
              ],
              [
                52.9335585,
                36.5733318
              ],
              [
                52.9358665,
                36.5739809
              ],
              [
                52.9399484,
                36.5758355
              ],
              [
                52.9421718,
                36.5822209
              ],
              [
                52.9410038,
                36.5843616
              ],
              [
                52.938835,
                36.588336
              ],
              [
                52.9380017,
                36.589723
              ],
              [
                52.9391152,
                36.5952796
              ],
              [
                52.9392731,
                36.5955983
              ],
              [
                52.9404678,
                36.5970544
              ],
              [
                52.9410584,
                36.5977743
              ],
              [
                52.9424484,
                36.5977743
              ],
              [
                52.943005,
                36.5980535
              ],
              [
                52.9438384,
                36.5980535
              ],
              [
                52.9443918,
                36.5983327
              ],
              [
                52.953005,
                36.5983327
              ],
              [
                52.9535582,
                36.5986119
              ],
              [
                52.955505,
                36.5986119
              ],
              [
                52.9563383,
                36.5988911
              ],
              [
                52.9574482,
                36.5988911
              ],
              [
                52.9602283,
                36.5994495
              ],
              [
                52.9602283,
                36.5997196
              ],
              [
                52.9613381,
                36.5997197
              ],
              [
                52.9624481,
                36.6005572
              ],
              [
                52.9652282,
                36.6100044
              ],
              [
                52.9657814,
                36.611112
              ],
              [
                52.9663382,
                36.6150025
              ],
              [
                52.9680048,
                36.6211174
              ],
              [
                52.9696714,
                36.6225043
              ],
              [
                52.9709241,
                36.6229509
              ],
              [
                52.9735613,
                36.6238912
              ],
              [
                52.9743946,
                36.6238912
              ],
              [
                52.9755046,
                36.6244495
              ],
              [
                52.9768947,
                36.6244496
              ],
              [
                52.977448,
                36.6247198
              ],
              [
                52.9799513,
                36.6247197
              ],
              [
                52.9805046,
                36.6249989
              ],
              [
                52.9818947,
                36.6249989
              ],
              [
                52.9824513,
                36.6252781
              ],
              [
                52.9832846,
                36.6252781
              ],
              [
                52.9927278,
                36.6291686
              ],
              [
                52.9949512,
                36.6305554
              ],
              [
                52.9985611,
                36.6330589
              ],
              [
                53.0021495,
                36.6468424
              ],
              [
                53.0038411,
                36.6533392
              ],
              [
                53.0041176,
                36.6536184
              ],
              [
                53.0041177,
                36.654726
              ],
              [
                53.004951,
                36.6638934
              ],
              [
                53.0068943,
                36.6788959
              ],
              [
                53.0066176,
                36.679175
              ],
              [
                53.0043944,
                36.6869463
              ],
              [
                53.0034236,
                36.6888914
              ],
              [
                53.0032844,
                36.6891705
              ],
              [
                52.9943944,
                36.7041726
              ],
              [
                52.9941178,
                36.7044426
              ],
              [
                52.9941178,
                36.705001
              ],
              [
                52.9941178,
                36.7052801
              ],
              [
                52.9913377,
                36.7136185
              ],
              [
                52.9902278,
                36.7152843
              ],
              [
                52.9899512,
                36.7163918
              ],
              [
                52.9896711,
                36.7172203
              ],
              [
                52.9893945,
                36.7197235
              ],
              [
                52.9896712,
                36.734725
              ],
              [
                52.9905044,
                36.7380656
              ],
              [
                52.9910611,
                36.7408389
              ],
              [
                52.9982844,
                36.7625029
              ],
              [
                52.9985609,
                36.7638895
              ],
              [
                52.9982843,
                36.7644477
              ],
              [
                52.9980078,
                36.767221
              ],
              [
                52.9977276,
                36.7686166
              ],
              [
                53.0021743,
                36.776396
              ],
              [
                53.0043943,
                36.77862
              ],
              [
                53.006061,
                36.7808439
              ],
              [
                53.0070556,
                36.7837865
              ],
              [
                53.0069107,
                36.7844125
              ],
              [
                53.0069105,
                36.7844132
              ],
              [
                52.9456467,
                36.9789574
              ],
              [
                52.944895,
                36.9787298
              ],
              [
                52.9415254,
                36.9778773
              ],
              [
                52.9103556,
                36.9694672
              ],
              [
                52.9091765,
                36.9692461
              ],
              [
                52.9038995,
                36.9681579
              ],
              [
                52.8986535,
                36.9669774
              ],
              [
                52.8934411,
                36.9657052
              ],
              [
                52.8882646,
                36.9643418
              ],
              [
                52.8831266,
                36.9628878
              ],
              [
                52.8772544,
                36.9610561
              ],
              [
                52.8728543,
                36.9600659
              ],
              [
                52.8676423,
                36.9587936
              ],
              [
                52.8624663,
                36.9574302
              ],
              [
                52.8601351,
                36.9567705
              ],
              [
                52.8590652,
                36.9565506
              ],
              [
                52.8518129,
                36.9548702
              ],
              [
                52.7975896,
                36.9415691
              ],
              [
                52.7952563,
                36.9412033
              ],
              [
                52.7865799,
                36.9395826
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555034,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رامسر",
          "name:en": "Ramsar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q968801",
          "wikipedia": "en:Ramsar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.3342888,
                36.6376263
              ],
              [
                50.3369951,
                36.6364853
              ],
              [
                50.3389262,
                36.6354351
              ],
              [
                50.3417801,
                36.6325767
              ],
              [
                50.3489684,
                36.6297183
              ],
              [
                50.3551482,
                36.6282718
              ],
              [
                50.3547191,
                36.6230366
              ],
              [
                50.3542041,
                36.6220722
              ],
              [
                50.352745,
                36.6183522
              ],
              [
                50.3519725,
                36.6139432
              ],
              [
                50.3490543,
                36.609396
              ],
              [
                50.3456615,
                36.6060523
              ],
              [
                50.3538608,
                36.6016791
              ],
              [
                50.3605556,
                36.5992674
              ],
              [
                50.3661346,
                36.5982337
              ],
              [
                50.3686236,
                36.5967867
              ],
              [
                50.3752326,
                36.5966488
              ],
              [
                50.380125,
                36.5966488
              ],
              [
                50.3847598,
                36.5955463
              ],
              [
                50.3901414,
                36.5952063
              ],
              [
                50.3933429,
                36.5938235
              ],
              [
                50.3960036,
                36.5938925
              ],
              [
                50.3968619,
                36.5929277
              ],
              [
                50.4048442,
                36.5870009
              ],
              [
                50.4076765,
                36.5825901
              ],
              [
                50.40699,
                36.579902
              ],
              [
                50.4114531,
                36.5761112
              ],
              [
                50.424156,
                36.5740433
              ],
              [
                50.4369195,
                36.5650352
              ],
              [
                50.4420089,
                36.5642546
              ],
              [
                50.4479312,
                36.5632206
              ],
              [
                50.4518794,
                36.5617039
              ],
              [
                50.455656,
                36.5616349
              ],
              [
                50.4660412,
                36.5653578
              ],
              [
                50.4751394,
                36.5674258
              ],
              [
                50.4808975,
                36.5658775
              ],
              [
                50.4867401,
                36.5595789
              ],
              [
                50.4999585,
                36.5497882
              ],
              [
                50.5086608,
                36.5463533
              ],
              [
                50.513444,
                36.5580676
              ],
              [
                50.5414983,
                36.6116684
              ],
              [
                50.5420549,
                36.6119386
              ],
              [
                50.5453883,
                36.6158291
              ],
              [
                50.5503882,
                36.621944
              ],
              [
                50.5676114,
                36.646385
              ],
              [
                50.5786559,
                36.6638666
              ],
              [
                50.5984478,
                36.7038915
              ],
              [
                50.6006709,
                36.7083307
              ],
              [
                50.6073374,
                36.7216665
              ],
              [
                50.6109477,
                36.7302838
              ],
              [
                50.6128753,
                36.7377841
              ],
              [
                50.6278786,
                36.7588899
              ],
              [
                50.6356549,
                36.7647246
              ],
              [
                50.6392837,
                36.7666698
              ],
              [
                50.6837143,
                36.7897282
              ],
              [
                50.6845632,
                36.7900078
              ],
              [
                50.7012141,
                36.8000015
              ],
              [
                50.7026043,
                36.801118
              ],
              [
                50.7037142,
                36.8013881
              ],
              [
                50.7206607,
                36.8122283
              ],
              [
                50.7245472,
                36.8152805
              ],
              [
                50.7372995,
                36.8280213
              ],
              [
                50.748642,
                36.8392418
              ],
              [
                50.7496371,
                36.8402283
              ],
              [
                50.7715123,
                36.8619531
              ],
              [
                50.7772736,
                36.8695708
              ],
              [
                50.7772926,
                36.869596
              ],
              [
                50.9151693,
                37.0391353
              ],
              [
                50.9106727,
                37.041609
              ],
              [
                50.9061095,
                37.0440033
              ],
              [
                50.9014821,
                37.046317
              ],
              [
                50.8967924,
                37.0485491
              ],
              [
                50.8932914,
                37.0501441
              ],
              [
                50.8927074,
                37.0504052
              ],
              [
                50.8839662,
                37.0541324
              ],
              [
                50.8750469,
                37.0575786
              ],
              [
                50.865838,
                37.0607774
              ],
              [
                50.8626426,
                37.0620669
              ],
              [
                50.8577267,
                37.0639621
              ],
              [
                50.8527601,
                37.0657707
              ],
              [
                50.8520718,
                37.0660069
              ],
              [
                50.8434125,
                37.0739607
              ],
              [
                50.8369756,
                37.0796476
              ],
              [
                50.8302706,
                37.0851324
              ],
              [
                50.8233074,
                37.090407
              ],
              [
                50.8160961,
                37.0954636
              ],
              [
                50.8118831,
                37.0982427
              ],
              [
                50.8075951,
                37.1009473
              ],
              [
                50.8032341,
                37.1035761
              ],
              [
                50.7988023,
                37.106128
              ],
              [
                50.7943018,
                37.1086017
              ],
              [
                50.7897347,
                37.110996
              ],
              [
                50.7851031,
                37.1133097
              ],
              [
                50.7804094,
                37.1155418
              ],
              [
                50.7756557,
                37.1176911
              ],
              [
                50.7708443,
                37.1197567
              ],
              [
                50.7659776,
                37.1217376
              ],
              [
                50.7610578,
                37.1236327
              ],
              [
                50.7560873,
                37.1254413
              ],
              [
                50.7520011,
                37.1268426
              ],
              [
                50.7414062,
                37.1307152
              ],
              [
                50.7398919,
                37.131806
              ],
              [
                50.7357537,
                37.1346581
              ],
              [
                50.7315385,
                37.1374371
              ],
              [
                50.5875665,
                36.968186
              ],
              [
                50.5857445,
                36.9672624
              ],
              [
                50.5888539,
                36.960171
              ],
              [
                50.5853596,
                36.9553636
              ],
              [
                50.5811996,
                36.952741
              ],
              [
                50.5730036,
                36.9524367
              ],
              [
                50.5684621,
                36.9487785
              ],
              [
                50.5674278,
                36.9411326
              ],
              [
                50.5660342,
                36.9361721
              ],
              [
                50.5628585,
                36.9299288
              ],
              [
                50.5578803,
                36.9252631
              ],
              [
                50.5400672,
                36.9090291
              ],
              [
                50.5375697,
                36.9069771
              ],
              [
                50.5359444,
                36.9055611
              ],
              [
                50.5350672,
                36.904424
              ],
              [
                50.5336375,
                36.9027241
              ],
              [
                50.5258783,
                36.8927975
              ],
              [
                50.5226033,
                36.8867565
              ],
              [
                50.521473,
                36.8868327
              ],
              [
                50.5217878,
                36.8884766
              ],
              [
                50.5198544,
                36.8882106
              ],
              [
                50.5150987,
                36.8865545
              ],
              [
                50.510232,
                36.8915141
              ],
              [
                50.5099868,
                36.8895751
              ],
              [
                50.5086135,
                36.8855935
              ],
              [
                50.5080986,
                36.8841518
              ],
              [
                50.506854,
                36.8821608
              ],
              [
                50.5054163,
                36.8802901
              ],
              [
                50.4999446,
                36.8768916
              ],
              [
                50.49046,
                36.8777485
              ],
              [
                50.4864692,
                36.8775953
              ],
              [
                50.4813398,
                36.8768973
              ],
              [
                50.4723404,
                36.8744124
              ],
              [
                50.4689169,
                36.873716
              ],
              [
                50.4650518,
                36.8734855
              ],
              [
                50.4575598,
                36.8733138
              ],
              [
                50.4549694,
                36.8729264
              ],
              [
                50.4532527,
                36.8722055
              ],
              [
                50.4513645,
                36.8717935
              ],
              [
                50.4494471,
                36.870738
              ],
              [
                50.4468139,
                36.8683225
              ],
              [
                50.4447614,
                36.8667343
              ],
              [
                50.4431018,
                36.8647941
              ],
              [
                50.4400561,
                36.8617295
              ],
              [
                50.4354384,
                36.8565305
              ],
              [
                50.4314518,
                36.8526685
              ],
              [
                50.4232977,
                36.8440488
              ],
              [
                50.4221654,
                36.8355556
              ],
              [
                50.423126,
                36.8267375
              ],
              [
                50.4126547,
                36.8164313
              ],
              [
                50.4047583,
                36.8116212
              ],
              [
                50.4078482,
                36.8050241
              ],
              [
                50.4159163,
                36.8030999
              ],
              [
                50.4214094,
                36.7996636
              ],
              [
                50.4254436,
                36.7956084
              ],
              [
                50.4286192,
                36.7915533
              ],
              [
                50.4303787,
                36.7828578
              ],
              [
                50.4349279,
                36.7771175
              ],
              [
                50.4369019,
                36.7739379
              ],
              [
                50.4370843,
                36.7703113
              ],
              [
                50.4364299,
                36.7658421
              ],
              [
                50.4359149,
                36.7604787
              ],
              [
                50.4360866,
                36.7533959
              ],
              [
                50.4355716,
                36.7487194
              ],
              [
                50.433855,
                36.7476878
              ],
              [
                50.4310226,
                36.7429422
              ],
              [
                50.4266452,
                36.7384027
              ],
              [
                50.4246711,
                36.7373022
              ],
              [
                50.4197787,
                36.7313178
              ],
              [
                50.4174613,
                36.7282222
              ],
              [
                50.4172896,
                36.724301
              ],
              [
                50.4154014,
                36.7231315
              ],
              [
                50.4129323,
                36.7125977
              ],
              [
                50.4131481,
                36.7074981
              ],
              [
                50.4122256,
                36.6969844
              ],
              [
                50.4125978,
                36.6873202
              ],
              [
                50.3854465,
                36.6680059
              ],
              [
                50.3834724,
                36.6675928
              ],
              [
                50.3775119,
                36.6636305
              ],
              [
                50.3635962,
                36.6533413
              ],
              [
                50.3531741,
                36.6436307
              ],
              [
                50.3505992,
                36.6390853
              ],
              [
                50.3493117,
                36.637639
              ],
              [
                50.3464793,
                36.6366748
              ],
              [
                50.3397845,
                36.6366059
              ],
              [
                50.3382826,
                36.6365542
              ],
              [
                50.3342888,
                36.6376263
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555063,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ساری",
          "name:ar": "مقاطعة ساري",
          "name:en": "Sari County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q662960",
          "wikipedia": "en:Sari County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.9313353,
                36.5733318
              ],
              [
                52.9293919,
                36.5691709
              ],
              [
                52.9266153,
                36.5652711
              ],
              [
                52.9260586,
                36.5616686
              ],
              [
                52.9266153,
                36.5602726
              ],
              [
                52.9335585,
                36.5525
              ],
              [
                52.9371684,
                36.5502755
              ],
              [
                52.9399485,
                36.5475014
              ],
              [
                52.9413384,
                36.5447184
              ],
              [
                52.9410585,
                36.533334
              ],
              [
                52.9430051,
                36.5261106
              ],
              [
                52.9441151,
                36.5247235
              ],
              [
                52.945802,
                36.521709
              ],
              [
                52.9468917,
                36.5224989
              ],
              [
                52.9474484,
                36.5222197
              ],
              [
                52.9568915,
                36.5141675
              ],
              [
                52.9597198,
                36.510099
              ],
              [
                52.9677283,
                36.4986124
              ],
              [
                52.9882846,
                36.4819402
              ],
              [
                52.9910612,
                36.4791659
              ],
              [
                53.0004315,
                36.4704212
              ],
              [
                53.0077277,
                36.4636102
              ],
              [
                53.008561,
                36.4636102
              ],
              [
                53.0169882,
                36.4587043
              ],
              [
                53.0296742,
                36.4533325
              ],
              [
                53.0305076,
                36.4533326
              ],
              [
                53.0382875,
                36.4511077
              ],
              [
                53.0388407,
                36.4505492
              ],
              [
                53.0405074,
                36.4499997
              ],
              [
                53.0418974,
                36.449162
              ],
              [
                53.0443974,
                36.4463876
              ],
              [
                53.0446739,
                36.4458292
              ],
              [
                53.044674,
                36.4436133
              ],
              [
                53.0430073,
                36.4430548
              ],
              [
                53.0407875,
                36.4430548
              ],
              [
                53.0405074,
                36.4427756
              ],
              [
                53.0396741,
                36.4427756
              ],
              [
                53.0357875,
                36.4411091
              ],
              [
                53.0355074,
                36.4405507
              ],
              [
                53.0327308,
                36.438614
              ],
              [
                53.0260643,
                36.429444
              ],
              [
                53.0263409,
                36.4280478
              ],
              [
                53.0266176,
                36.4255526
              ],
              [
                53.0267397,
                36.4249472
              ],
              [
                53.0268976,
                36.4241654
              ],
              [
                53.0302309,
                36.4119416
              ],
              [
                53.0302309,
                36.4097166
              ],
              [
                53.0296742,
                36.4091671
              ],
              [
                53.0280076,
                36.4075006
              ],
              [
                53.0080079,
                36.3922137
              ],
              [
                53.0085611,
                36.3919434
              ],
              [
                53.0091178,
                36.3911056
              ],
              [
                53.0257842,
                36.3691612
              ],
              [
                53.0277309,
                36.3663866
              ],
              [
                53.031782,
                36.3516869
              ],
              [
                53.0332593,
                36.3497143
              ],
              [
                53.0365443,
                36.346306
              ],
              [
                53.073921,
                36.3369768
              ],
              [
                53.0722044,
                36.31803
              ],
              [
                53.0759808,
                36.3131889
              ],
              [
                53.0986401,
                36.3004621
              ],
              [
                53.1045864,
                36.2889171
              ],
              [
                53.1073664,
                36.2855833
              ],
              [
                53.1254193,
                36.2783236
              ],
              [
                53.1384095,
                36.257485
              ],
              [
                53.1395195,
                36.2569264
              ],
              [
                53.1397996,
                36.2563768
              ],
              [
                53.1629092,
                36.2364022
              ],
              [
                53.1637425,
                36.2358437
              ],
              [
                53.1642958,
                36.2352939
              ],
              [
                53.1642958,
                36.2350146
              ],
              [
                53.1637426,
                36.2286171
              ],
              [
                53.1626291,
                36.2258419
              ],
              [
                53.1369215,
                36.2174509
              ],
              [
                53.1357897,
                36.2158222
              ],
              [
                53.1230162,
                36.1980188
              ],
              [
                53.1207383,
                36.1784765
              ],
              [
                53.1204581,
                36.1773682
              ],
              [
                53.1185149,
                36.1740429
              ],
              [
                53.1121717,
                36.1729175
              ],
              [
                53.1076997,
                36.1691574
              ],
              [
                53.1074568,
                36.167211
              ],
              [
                53.1077335,
                36.1666524
              ],
              [
                53.1090018,
                36.1626181
              ],
              [
                53.1092785,
                36.1601223
              ],
              [
                53.109555,
                36.1578967
              ],
              [
                53.1098351,
                36.1548423
              ],
              [
                53.1159649,
                36.1412316
              ],
              [
                53.1162416,
                36.1387357
              ],
              [
                53.1187415,
                36.1209575
              ],
              [
                53.1187415,
                36.1195698
              ],
              [
                53.1139767,
                36.1099934
              ],
              [
                53.1142533,
                36.1086056
              ],
              [
                53.11481,
                36.105821
              ],
              [
                53.1159157,
                36.1020879
              ],
              [
                53.1163468,
                36.100818
              ],
              [
                53.130943,
                36.0941566
              ],
              [
                53.149706,
                36.0820721
              ],
              [
                53.1510959,
                36.0770708
              ],
              [
                53.1520042,
                36.0694324
              ],
              [
                53.1522809,
                36.0688737
              ],
              [
                53.1522809,
                36.0685942
              ],
              [
                53.1600609,
                36.0658188
              ],
              [
                53.1617275,
                36.0655394
              ],
              [
                53.1620042,
                36.0658188
              ],
              [
                53.1639508,
                36.0658188
              ],
              [
                53.1647841,
                36.0660982
              ],
              [
                53.165894,
                36.0660981
              ],
              [
                53.167004,
                36.0663775
              ],
              [
                53.1753407,
                36.0663776
              ],
              [
                53.1828706,
                36.0626256
              ],
              [
                53.1953704,
                36.0573536
              ],
              [
                53.1995588,
                36.0344434
              ],
              [
                53.1998388,
                36.0333257
              ],
              [
                53.2012253,
                36.0308292
              ],
              [
                53.2097052,
                36.0243905
              ],
              [
                53.2158187,
                35.9897149
              ],
              [
                53.2172086,
                35.9897149
              ],
              [
                53.218042,
                35.9894356
              ],
              [
                53.223375,
                35.9655388
              ],
              [
                53.2232955,
                35.9660976
              ],
              [
                53.2246856,
                35.9674855
              ],
              [
                53.2246855,
                35.9680443
              ],
              [
                53.2635751,
                35.9933154
              ],
              [
                53.2741543,
                36.0016722
              ],
              [
                53.2862865,
                36.0104474
              ],
              [
                53.2994615,
                36.0160189
              ],
              [
                53.308345,
                36.0216942
              ],
              [
                53.3100831,
                36.0241759
              ],
              [
                53.313173,
                36.0263625
              ],
              [
                53.3173358,
                36.0292084
              ],
              [
                53.323065,
                36.0312908
              ],
              [
                53.3246529,
                36.0338763
              ],
              [
                53.3262193,
                36.0354901
              ],
              [
                53.32785,
                36.037017
              ],
              [
                53.3326566,
                36.040574
              ],
              [
                53.3352744,
                36.0415283
              ],
              [
                53.3373773,
                36.0438185
              ],
              [
                53.3407461,
                36.0449462
              ],
              [
                53.3447372,
                36.0472017
              ],
              [
                53.3469005,
                36.0484889
              ],
              [
                53.3483153,
                36.0493307
              ],
              [
                53.349694,
                36.050151
              ],
              [
                53.3536851,
                36.0539849
              ],
              [
                53.3558952,
                36.0550431
              ],
              [
                53.3592641,
                36.0568299
              ],
              [
                53.3648431,
                36.0566738
              ],
              [
                53.3688771,
                36.058634
              ],
              [
                53.3754432,
                36.0610625
              ],
              [
                53.3773409,
                36.0617712
              ],
              [
                53.3788335,
                36.0623287
              ],
              [
                53.383404,
                36.0630919
              ],
              [
                53.3857858,
                36.0643408
              ],
              [
                53.3936178,
                36.0674282
              ],
              [
                53.4050333,
                36.0722499
              ],
              [
                53.4094107,
                36.0745566
              ],
              [
                53.4123718,
                36.0761522
              ],
              [
                53.417354,
                36.0773711
              ],
              [
                53.4189566,
                36.0772894
              ],
              [
                53.4236164,
                36.0762265
              ],
              [
                53.4266345,
                36.0762061
              ],
              [
                53.427861,
                36.0763974
              ],
              [
                53.4305672,
                36.0771359
              ],
              [
                53.4358428,
                36.0761114
              ],
              [
                53.4367259,
                36.0761231
              ],
              [
                53.4375008,
                36.0763844
              ],
              [
                53.4387853,
                36.0765455
              ],
              [
                53.4400225,
                36.0768302
              ],
              [
                53.4415977,
                36.077078
              ],
              [
                53.4425107,
                36.0770685
              ],
              [
                53.4442405,
                36.0773102
              ],
              [
                53.447085,
                36.077399
              ],
              [
                53.4480186,
                36.0773525
              ],
              [
                53.4485929,
                36.0771769
              ],
              [
                53.4522649,
                36.0774804
              ],
              [
                53.4538792,
                36.0775307
              ],
              [
                53.4549891,
                36.0770032
              ],
              [
                53.4559759,
                36.0763588
              ],
              [
                53.4568859,
                36.0754523
              ],
              [
                53.4579124,
                36.0748995
              ],
              [
                53.461092,
                36.0747035
              ],
              [
                53.4648097,
                36.074893
              ],
              [
                53.4673047,
                36.0745712
              ],
              [
                53.4685118,
                36.0746049
              ],
              [
                53.4700321,
                36.0744699
              ],
              [
                53.4713296,
                36.0742877
              ],
              [
                53.4724618,
                36.0745009
              ],
              [
                53.4734714,
                36.0750772
              ],
              [
                53.4743359,
                36.0758457
              ],
              [
                53.4758662,
                36.0764067
              ],
              [
                53.476712,
                36.0768219
              ],
              [
                53.4773561,
                36.0774034
              ],
              [
                53.4780592,
                36.0778936
              ],
              [
                53.4809439,
                36.0787758
              ],
              [
                53.4828351,
                36.0789574
              ],
              [
                53.4866772,
                36.0787042
              ],
              [
                53.4885817,
                36.0784056
              ],
              [
                53.4893201,
                36.0780995
              ],
              [
                53.4901085,
                36.0775086
              ],
              [
                53.4909191,
                36.0766107
              ],
              [
                53.4914197,
                36.075762
              ],
              [
                53.4922456,
                36.0748187
              ],
              [
                53.4942895,
                36.0729848
              ],
              [
                53.4953071,
                36.0722268
              ],
              [
                53.4965134,
                36.0717555
              ],
              [
                53.4975455,
                36.0714997
              ],
              [
                53.498526,
                36.0710849
              ],
              [
                53.4990026,
                36.0711268
              ],
              [
                53.500717,
                36.0711203
              ],
              [
                53.5020919,
                36.0715467
              ],
              [
                53.5033262,
                36.0721564
              ],
              [
                53.5076179,
                36.074036
              ],
              [
                53.5098776,
                36.0745925
              ],
              [
                53.5119419,
                36.074849
              ],
              [
                53.5133597,
                36.0750941
              ],
              [
                53.5157293,
                36.0764617
              ],
              [
                53.5162474,
                36.0769105
              ],
              [
                53.5173718,
                36.0768102
              ],
              [
                53.5191989,
                36.0764609
              ],
              [
                53.5230195,
                36.0763917
              ],
              [
                53.5240162,
                36.0767042
              ],
              [
                53.5253344,
                36.0773254
              ],
              [
                53.5268202,
                36.0783035
              ],
              [
                53.5278863,
                36.0787857
              ],
              [
                53.5303713,
                36.079434
              ],
              [
                53.5323226,
                36.0798637
              ],
              [
                53.5334578,
                36.080554
              ],
              [
                53.5349712,
                36.0819754
              ],
              [
                53.5360227,
                36.0825615
              ],
              [
                53.5373424,
                36.0829436
              ],
              [
                53.5390276,
                36.0829935
              ],
              [
                53.5405454,
                36.0829523
              ],
              [
                53.5418936,
                36.0831175
              ],
              [
                53.5438866,
                36.0835236
              ],
              [
                53.5454312,
                36.0839054
              ],
              [
                53.5470294,
                36.0848921
              ],
              [
                53.550016,
                36.0870278
              ],
              [
                53.5511934,
                36.0880505
              ],
              [
                53.552921,
                36.0880542
              ],
              [
                53.554565,
                36.0879448
              ],
              [
                53.5580204,
                36.088218
              ],
              [
                53.5625012,
                36.088458
              ],
              [
                53.5638787,
                36.0883474
              ],
              [
                53.5651298,
                36.0880412
              ],
              [
                53.5666194,
                36.0878155
              ],
              [
                53.5684595,
                36.0879924
              ],
              [
                53.5704108,
                36.0884102
              ],
              [
                53.5722084,
                36.0887343
              ],
              [
                53.5745684,
                36.088785
              ],
              [
                53.5763521,
                36.0888931
              ],
              [
                53.5799771,
                36.0887069
              ],
              [
                53.582323,
                36.0888163
              ],
              [
                53.5843456,
                36.0889485
              ],
              [
                53.586312,
                36.0892733
              ],
              [
                53.5884188,
                36.0895184
              ],
              [
                53.5897678,
                36.0892797
              ],
              [
                53.5913845,
                36.0888031
              ],
              [
                53.5934928,
                36.0882933
              ],
              [
                53.5955166,
                36.0879566
              ],
              [
                53.5977505,
                36.0877436
              ],
              [
                53.6013489,
                36.0870887
              ],
              [
                53.6029358,
                36.0870813
              ],
              [
                53.6046504,
                36.0869246
              ],
              [
                53.6066446,
                36.0871223
              ],
              [
                53.608751,
                36.0875045
              ],
              [
                53.6106327,
                36.0879322
              ],
              [
                53.6124856,
                36.0887255
              ],
              [
                53.6137203,
                36.0895638
              ],
              [
                53.6147427,
                36.0896842
              ],
              [
                53.6148016,
                36.0896911
              ],
              [
                53.6175005,
                36.0889314
              ],
              [
                53.6196501,
                36.0885825
              ],
              [
                53.6216322,
                36.0881042
              ],
              [
                53.6225742,
                36.0877664
              ],
              [
                53.6228969,
                36.0876507
              ],
              [
                53.6252721,
                36.0873463
              ],
              [
                53.6264086,
                36.0879432
              ],
              [
                53.6278828,
                36.0884044
              ],
              [
                53.6298915,
                36.0884549
              ],
              [
                53.6321954,
                36.0886769
              ],
              [
                53.6336699,
                36.0888969
              ],
              [
                53.6348499,
                36.0889227
              ],
              [
                53.6364513,
                36.0888897
              ],
              [
                53.6377863,
                36.0887792
              ],
              [
                53.6390791,
                36.0885863
              ],
              [
                53.6401325,
                36.0886239
              ],
              [
                53.6458267,
                36.0914855
              ],
              [
                53.6506688,
                36.0970745
              ],
              [
                53.6523189,
                36.1006872
              ],
              [
                53.6590289,
                36.1065373
              ],
              [
                53.6767959,
                36.1142342
              ],
              [
                53.7030601,
                36.118741
              ],
              [
                53.7198227,
                36.1238228
              ],
              [
                53.7258362,
                36.1259769
              ],
              [
                53.7306749,
                36.1298444
              ],
              [
                53.7353324,
                36.1325372
              ],
              [
                53.7466851,
                36.1355286
              ],
              [
                53.7556811,
                36.138895
              ],
              [
                53.7613953,
                36.1399947
              ],
              [
                53.7666842,
                36.1424764
              ],
              [
                53.7765443,
                36.1451998
              ],
              [
                53.7859473,
                36.1490848
              ],
              [
                53.7906518,
                36.1531735
              ],
              [
                53.8022449,
                36.1601574
              ],
              [
                53.8068723,
                36.1649287
              ],
              [
                53.8155622,
                36.1774271
              ],
              [
                53.8209851,
                36.1826056
              ],
              [
                53.8289905,
                36.1865184
              ],
              [
                53.8380346,
                36.1908982
              ],
              [
                53.8457552,
                36.198635
              ],
              [
                53.8512323,
                36.2081977
              ],
              [
                53.8601138,
                36.2133532
              ],
              [
                53.88707,
                36.2237766
              ],
              [
                53.9135168,
                36.2369354
              ],
              [
                53.9250181,
                36.243858
              ],
              [
                53.9352965,
                36.2480353
              ],
              [
                53.9411747,
                36.2525794
              ],
              [
                53.9459015,
                36.2578807
              ],
              [
                53.9478756,
                36.2601833
              ],
              [
                53.9494206,
                36.2618379
              ],
              [
                53.9504204,
                36.2642822
              ],
              [
                53.9479122,
                36.2675452
              ],
              [
                53.9627836,
                36.2751406
              ],
              [
                53.9699934,
                36.2834436
              ],
              [
                53.9701866,
                36.291906
              ],
              [
                53.967335,
                36.302558
              ],
              [
                53.9566038,
                36.3206579
              ],
              [
                53.9317124,
                36.3342115
              ],
              [
                53.9188163,
                36.3409097
              ],
              [
                53.8987539,
                36.3527392
              ],
              [
                53.885536,
                36.3584074
              ],
              [
                53.882532,
                36.3633148
              ],
              [
                53.8863943,
                36.371954
              ],
              [
                53.9033888,
                36.3919932
              ],
              [
                53.9126928,
                36.4032289
              ],
              [
                53.8853643,
                36.3976585
              ],
              [
                53.8704298,
                36.3827344
              ],
              [
                53.8620184,
                36.3825962
              ],
              [
                53.8493716,
                36.3759982
              ],
              [
                53.8451472,
                36.377075
              ],
              [
                53.8343482,
                36.3728608
              ],
              [
                53.8335148,
                36.3728608
              ],
              [
                53.8332347,
                36.37314
              ],
              [
                53.8324014,
                36.37314
              ],
              [
                53.8318482,
                36.3734103
              ],
              [
                53.8307348,
                36.3734103
              ],
              [
                53.8126887,
                36.3609843
              ],
              [
                53.812412,
                36.3612547
              ],
              [
                53.811022,
                36.3612547
              ],
              [
                53.8101887,
                36.3615341
              ],
              [
                53.8090787,
                36.3615341
              ],
              [
                53.8082454,
                36.3612547
              ],
              [
                53.8057454,
                36.3612547
              ],
              [
                53.7999121,
                36.3598669
              ],
              [
                53.7993555,
                36.3595876
              ],
              [
                53.7924088,
                36.3573706
              ],
              [
                53.7915756,
                36.3573706
              ],
              [
                53.7912988,
                36.3570912
              ],
              [
                53.7901889,
                36.3570913
              ],
              [
                53.7643431,
                36.3466558
              ],
              [
                53.7341198,
                36.3455322
              ],
              [
                53.7293561,
                36.346148
              ],
              [
                53.7204662,
                36.3411475
              ],
              [
                53.7196329,
                36.3405889
              ],
              [
                53.7027883,
                36.3419512
              ],
              [
                53.6860935,
                36.3377751
              ],
              [
                53.6855402,
                36.3372166
              ],
              [
                53.6700586,
                36.3377409
              ],
              [
                53.669502,
                36.3374616
              ],
              [
                53.6686686,
                36.3374615
              ],
              [
                53.668392,
                36.3371822
              ],
              [
                53.6664454,
                36.3371823
              ],
              [
                53.665892,
                36.3369031
              ],
              [
                53.6599172,
                36.3331694
              ],
              [
                53.6588072,
                36.3328902
              ],
              [
                53.6576938,
                36.3331694
              ],
              [
                53.6552606,
                36.3297121
              ],
              [
                53.6538705,
                36.3299913
              ],
              [
                53.6508138,
                36.3299914
              ],
              [
                53.6367173,
                36.3230898
              ],
              [
                53.6356039,
                36.3233602
              ],
              [
                53.6328273,
                36.3233602
              ],
              [
                53.5848648,
                36.3101088
              ],
              [
                53.5301876,
                36.3309393
              ],
              [
                53.5298223,
                36.3310425
              ],
              [
                53.5292657,
                36.3310425
              ],
              [
                53.5284324,
                36.3316013
              ],
              [
                53.5152655,
                36.343122
              ],
              [
                53.5016423,
                36.3688821
              ],
              [
                53.4977522,
                36.3713864
              ],
              [
                53.4894107,
                36.3824938
              ],
              [
                53.4855241,
                36.390277
              ],
              [
                53.4810858,
                36.3969431
              ],
              [
                53.4762709,
                36.404317
              ],
              [
                53.4751609,
                36.4057134
              ],
              [
                53.4643277,
                36.4129291
              ],
              [
                53.4537891,
                36.4168
              ],
              [
                53.4526791,
                36.4168
              ],
              [
                53.4518457,
                36.4165208
              ],
              [
                53.4515658,
                36.4165208
              ],
              [
                53.4512891,
                36.4165208
              ],
              [
                53.4135832,
                36.4105544
              ],
              [
                53.4119167,
                36.4105544
              ],
              [
                53.4116366,
                36.4102752
              ],
              [
                53.4099698,
                36.4102752
              ],
              [
                53.4091366,
                36.4099959
              ],
              [
                53.4077466,
                36.409996
              ],
              [
                53.4069132,
                36.4097167
              ],
              [
                53.4052467,
                36.4097167
              ],
              [
                53.4027466,
                36.4091672
              ],
              [
                53.4019134,
                36.4091672
              ],
              [
                53.40136,
                36.4088879
              ],
              [
                53.3994134,
                36.408888
              ],
              [
                53.39858,
                36.4086087
              ],
              [
                53.3974701,
                36.4086087
              ],
              [
                53.3971935,
                36.4083295
              ],
              [
                53.3944134,
                36.4083294
              ],
              [
                53.3933035,
                36.4080502
              ],
              [
                53.3921901,
                36.4080501
              ],
              [
                53.3916368,
                36.4077709
              ],
              [
                53.3885802,
                36.4077709
              ],
              [
                53.3874702,
                36.4075007
              ],
              [
                53.3838569,
                36.4075007
              ],
              [
                53.3833036,
                36.4072214
              ],
              [
                53.3810803,
                36.4072214
              ],
              [
                53.380247,
                36.4069422
              ],
              [
                53.377747,
                36.4069422
              ],
              [
                53.3766371,
                36.4066629
              ],
              [
                53.3719137,
                36.4061134
              ],
              [
                53.3646905,
                36.4052667
              ],
              [
                53.3635805,
                36.4052667
              ],
              [
                53.3627472,
                36.4049964
              ],
              [
                53.3599671,
                36.4049964
              ],
              [
                53.3585806,
                36.4047172
              ],
              [
                53.351634,
                36.4047172
              ],
              [
                53.3510772,
                36.404438
              ],
              [
                53.3449674,
                36.404438
              ],
              [
                53.3327441,
                36.4036091
              ],
              [
                53.3316343,
                36.4033299
              ],
              [
                53.3310775,
                36.4036091
              ],
              [
                53.3299675,
                36.4036092
              ],
              [
                53.3291342,
                36.40333
              ],
              [
                53.3255209,
                36.4033299
              ],
              [
                53.3202442,
                36.4038795
              ],
              [
                53.3196876,
                36.4041587
              ],
              [
                53.3185777,
                36.4041587
              ],
              [
                53.3177443,
                36.4044379
              ],
              [
                53.3166309,
                36.4044379
              ],
              [
                53.3149643,
                36.4049964
              ],
              [
                53.3138543,
                36.4049964
              ],
              [
                53.3132976,
                36.4052667
              ],
              [
                53.3124643,
                36.4052666
              ],
              [
                53.3119111,
                36.4055459
              ],
              [
                53.3082977,
                36.405546
              ],
              [
                53.3077444,
                36.4058342
              ],
              [
                53.3055211,
                36.4058342
              ],
              [
                53.3049644,
                36.4061135
              ],
              [
                53.3024645,
                36.4061134
              ],
              [
                53.3019112,
                36.4063837
              ],
              [
                53.2994112,
                36.4063837
              ],
              [
                53.2910746,
                36.4083294
              ],
              [
                53.289688,
                36.4083294
              ],
              [
                53.2880214,
                36.4088879
              ],
              [
                53.287188,
                36.4088879
              ],
              [
                53.2857079,
                36.4096305
              ],
              [
                53.2963546,
                36.4174906
              ],
              [
                53.2966312,
                36.4177699
              ],
              [
                53.3060778,
                36.4263815
              ],
              [
                53.3066737,
                36.4273252
              ],
              [
                53.3094111,
                36.4316601
              ],
              [
                53.3113543,
                36.4377764
              ],
              [
                53.3110778,
                36.4380556
              ],
              [
                53.3107976,
                36.44083
              ],
              [
                53.3063545,
                36.4461085
              ],
              [
                53.3038544,
                36.4474956
              ],
              [
                53.278298,
                36.4569446
              ],
              [
                53.2774648,
                36.4572239
              ],
              [
                53.2666316,
                36.4624934
              ],
              [
                53.2571849,
                36.4697172
              ],
              [
                53.2530184,
                36.4725005
              ],
              [
                53.2526973,
                36.4728014
              ],
              [
                53.2502416,
                36.4749956
              ],
              [
                53.2474617,
                36.4816701
              ],
              [
                53.247185,
                36.4830571
              ],
              [
                53.2469085,
                36.4844442
              ],
              [
                53.2466284,
                36.4874977
              ],
              [
                53.2463517,
                36.4919383
              ],
              [
                53.2460751,
                36.4944422
              ],
              [
                53.245795,
                36.496667
              ],
              [
                53.2480183,
                36.5147261
              ],
              [
                53.2477418,
                36.5155547
              ],
              [
                53.2474617,
                36.5166716
              ],
              [
                53.243575,
                36.5250029
              ],
              [
                53.2319051,
                36.5350003
              ],
              [
                53.2032922,
                36.5466639
              ],
              [
                53.1763492,
                36.5658296
              ],
              [
                53.1757925,
                36.5666672
              ],
              [
                53.1755159,
                36.5669464
              ],
              [
                53.1694025,
                36.5738902
              ],
              [
                53.168016,
                36.5775018
              ],
              [
                53.1739105,
                36.6150811
              ],
              [
                53.1746826,
                36.6200008
              ],
              [
                53.1744024,
                36.6213877
              ],
              [
                53.1707972,
                36.6263948
              ],
              [
                53.1660109,
                36.6330411
              ],
              [
                53.1644026,
                36.6352743
              ],
              [
                53.1616261,
                36.6397231
              ],
              [
                53.161626,
                36.6402814
              ],
              [
                53.1605126,
                36.6441718
              ],
              [
                53.1605126,
                36.6483323
              ],
              [
                53.1627359,
                36.6600032
              ],
              [
                53.1624593,
                36.6611197
              ],
              [
                53.1621792,
                36.665001
              ],
              [
                53.1616616,
                36.6677617
              ],
              [
                53.1605125,
                36.6738892
              ],
              [
                53.1560693,
                36.6813903
              ],
              [
                53.1557927,
                36.6822278
              ],
              [
                53.1463461,
                36.690008
              ],
              [
                53.1374562,
                36.6958342
              ],
              [
                53.1388462,
                36.6988958
              ],
              [
                53.1391193,
                36.6991652
              ],
              [
                53.1441227,
                36.7041726
              ],
              [
                53.145236,
                36.705001
              ],
              [
                53.1464418,
                36.7061176
              ],
              [
                53.1582925,
                36.7172203
              ],
              [
                53.1585692,
                36.7180578
              ],
              [
                53.1599594,
                36.7194534
              ],
              [
                53.161626,
                36.7280617
              ],
              [
                53.1613459,
                36.7291693
              ],
              [
                53.1580126,
                36.7341667
              ],
              [
                53.157736,
                36.7347251
              ],
              [
                53.1574593,
                36.7361207
              ],
              [
                53.1613459,
                36.7422256
              ],
              [
                53.1638458,
                36.7469529
              ],
              [
                53.1641259,
                36.7519502
              ],
              [
                53.1619025,
                36.7586132
              ],
              [
                53.161626,
                36.7588923
              ],
              [
                53.1613458,
                36.7594506
              ],
              [
                53.1585692,
                36.7652852
              ],
              [
                53.161626,
                36.7775035
              ],
              [
                53.1621792,
                36.77862
              ],
              [
                53.1630125,
                36.8022277
              ],
              [
                53.1624593,
                36.8047306
              ],
              [
                53.1621791,
                36.8069545
              ],
              [
                53.1619025,
                36.8116723
              ],
              [
                53.1630125,
                36.8233407
              ],
              [
                53.1630124,
                36.8236022
              ],
              [
                53.1628994,
                36.8248604
              ],
              [
                53.1628994,
                36.8248609
              ],
              [
                53.1125265,
                37.0203478
              ],
              [
                53.100179,
                37.0174296
              ],
              [
                53.0990124,
                37.0172537
              ],
              [
                53.0951989,
                37.0167474
              ],
              [
                53.0865554,
                37.0153954
              ],
              [
                53.0858755,
                37.015279
              ],
              [
                53.0651154,
                37.0109684
              ],
              [
                53.0624727,
                37.0103209
              ],
              [
                53.0574715,
                37.0094752
              ],
              [
                53.0521633,
                37.00848
              ],
              [
                53.0468836,
                37.0073918
              ],
              [
                53.0416349,
                37.0062114
              ],
              [
                53.0364198,
                37.0049391
              ],
              [
                53.0312406,
                37.0035757
              ],
              [
                53.0261,
                37.0021218
              ],
              [
                53.0207666,
                37.0005048
              ],
              [
                52.9950966,
                36.9924482
              ],
              [
                52.9941321,
                36.9921435
              ],
              [
                52.9768066,
                36.9866338
              ],
              [
                52.9625813,
                36.9833727
              ],
              [
                52.9540647,
                36.9812865
              ],
              [
                52.9456467,
                36.9789574
              ],
              [
                53.0069105,
                36.7844132
              ],
              [
                53.0069107,
                36.7844125
              ],
              [
                53.0070556,
                36.7837865
              ],
              [
                53.006061,
                36.7808439
              ],
              [
                53.0043943,
                36.77862
              ],
              [
                53.0021743,
                36.776396
              ],
              [
                52.9977276,
                36.7686166
              ],
              [
                52.9980078,
                36.767221
              ],
              [
                52.9982843,
                36.7644477
              ],
              [
                52.9985609,
                36.7638895
              ],
              [
                52.9982844,
                36.7625029
              ],
              [
                52.9910611,
                36.7408389
              ],
              [
                52.9905044,
                36.7380656
              ],
              [
                52.9896712,
                36.734725
              ],
              [
                52.9893945,
                36.7197235
              ],
              [
                52.9896711,
                36.7172203
              ],
              [
                52.9899512,
                36.7163918
              ],
              [
                52.9902278,
                36.7152843
              ],
              [
                52.9913377,
                36.7136185
              ],
              [
                52.9941178,
                36.7052801
              ],
              [
                52.9941178,
                36.705001
              ],
              [
                52.9941178,
                36.7044426
              ],
              [
                52.9943944,
                36.7041726
              ],
              [
                53.0032844,
                36.6891705
              ],
              [
                53.0034236,
                36.6888914
              ],
              [
                53.0043944,
                36.6869463
              ],
              [
                53.0066176,
                36.679175
              ],
              [
                53.0068943,
                36.6788959
              ],
              [
                53.004951,
                36.6638934
              ],
              [
                53.0041177,
                36.654726
              ],
              [
                53.0041176,
                36.6536184
              ],
              [
                53.0038411,
                36.6533392
              ],
              [
                53.0021495,
                36.6468424
              ],
              [
                52.9985611,
                36.6330589
              ],
              [
                52.9949512,
                36.6305554
              ],
              [
                52.9927278,
                36.6291686
              ],
              [
                52.9832846,
                36.6252781
              ],
              [
                52.9824513,
                36.6252781
              ],
              [
                52.9818947,
                36.6249989
              ],
              [
                52.9805046,
                36.6249989
              ],
              [
                52.9799513,
                36.6247197
              ],
              [
                52.977448,
                36.6247198
              ],
              [
                52.9768947,
                36.6244496
              ],
              [
                52.9755046,
                36.6244495
              ],
              [
                52.9743946,
                36.6238912
              ],
              [
                52.9735613,
                36.6238912
              ],
              [
                52.9709241,
                36.6229509
              ],
              [
                52.9696714,
                36.6225043
              ],
              [
                52.9680048,
                36.6211174
              ],
              [
                52.9663382,
                36.6150025
              ],
              [
                52.9657814,
                36.611112
              ],
              [
                52.9652282,
                36.6100044
              ],
              [
                52.9624481,
                36.6005572
              ],
              [
                52.9613381,
                36.5997197
              ],
              [
                52.9602283,
                36.5997196
              ],
              [
                52.9602283,
                36.5994495
              ],
              [
                52.9574482,
                36.5988911
              ],
              [
                52.9563383,
                36.5988911
              ],
              [
                52.955505,
                36.5986119
              ],
              [
                52.9535582,
                36.5986119
              ],
              [
                52.953005,
                36.5983327
              ],
              [
                52.9443918,
                36.5983327
              ],
              [
                52.9438384,
                36.5980535
              ],
              [
                52.943005,
                36.5980535
              ],
              [
                52.9424484,
                36.5977743
              ],
              [
                52.9410584,
                36.5977743
              ],
              [
                52.9404678,
                36.5970544
              ],
              [
                52.9392731,
                36.5955983
              ],
              [
                52.9391152,
                36.5952796
              ],
              [
                52.9380017,
                36.589723
              ],
              [
                52.938835,
                36.588336
              ],
              [
                52.9410038,
                36.5843616
              ],
              [
                52.9421718,
                36.5822209
              ],
              [
                52.9399484,
                36.5758355
              ],
              [
                52.9358665,
                36.5739809
              ],
              [
                52.9335585,
                36.5733318
              ],
              [
                52.9313353,
                36.5733318
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555088,
        "tags": {
          "admin_level": "5",
          "alt_name": "سواد کوه شمالی",
          "boundary": "administrative",
          "name": "شهرستان سوادکوه شمالی",
          "name:en": "North Savadkuh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q7498569"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.8143783,
                36.3824354
              ],
              [
                52.8159734,
                36.3789086
              ],
              [
                52.8132546,
                36.3657815
              ],
              [
                52.8148864,
                36.3627784
              ],
              [
                52.8138306,
                36.3552252
              ],
              [
                52.8149427,
                36.3460024
              ],
              [
                52.8149824,
                36.3456731
              ],
              [
                52.8155103,
                36.3397299
              ],
              [
                52.8156192,
                36.3390435
              ],
              [
                52.8160992,
                36.336452
              ],
              [
                52.8181149,
                36.3339894
              ],
              [
                52.8182749,
                36.3288447
              ],
              [
                52.8187708,
                36.3257113
              ],
              [
                52.8192827,
                36.3206563
              ],
              [
                52.8200936,
                36.3134107
              ],
              [
                52.8185741,
                36.2961693
              ],
              [
                52.8171186,
                36.2865733
              ],
              [
                52.8155352,
                36.2771439
              ],
              [
                52.8155906,
                36.2769112
              ],
              [
                52.8221633,
                36.2766564
              ],
              [
                52.8235532,
                36.2769358
              ],
              [
                52.8321665,
                36.2769358
              ],
              [
                52.8338332,
                36.2772151
              ],
              [
                52.8391098,
                36.277215
              ],
              [
                52.8402197,
                36.2774943
              ],
              [
                52.8446664,
                36.2774944
              ],
              [
                52.8454997,
                36.2772151
              ],
              [
                52.8468897,
                36.2772151
              ],
              [
                52.8479997,
                36.2769358
              ],
              [
                52.8504996,
                36.2769358
              ],
              [
                52.8510564,
                36.2766565
              ],
              [
                52.8521663,
                36.2766565
              ],
              [
                52.8535562,
                36.2761069
              ],
              [
                52.8757795,
                36.2558262
              ],
              [
                52.8865067,
                36.2503361
              ],
              [
                52.888836,
                36.2505465
              ],
              [
                52.8893892,
                36.2502673
              ],
              [
                52.8916125,
                36.2502672
              ],
              [
                52.8988357,
                36.249159
              ],
              [
                52.9005025,
                36.2491591
              ],
              [
                52.9013357,
                36.2488797
              ],
              [
                52.9049456,
                36.2488797
              ],
              [
                52.906059,
                36.2486004
              ],
              [
                52.908559,
                36.2486004
              ],
              [
                52.9099456,
                36.2483211
              ],
              [
                52.9116123,
                36.2483211
              ],
              [
                52.912169,
                36.2480508
              ],
              [
                52.9149456,
                36.2480509
              ],
              [
                52.9241155,
                36.2469426
              ],
              [
                52.9335588,
                36.2469426
              ],
              [
                52.9352253,
                36.2466544
              ],
              [
                52.9377254,
                36.2466543
              ],
              [
                52.9468919,
                36.2449965
              ],
              [
                52.9474485,
                36.2449965
              ],
              [
                52.949672,
                36.2458254
              ],
              [
                52.9510585,
                36.2483211
              ],
              [
                52.9516152,
                36.2602681
              ],
              [
                52.9513386,
                36.261106
              ],
              [
                52.9510585,
                36.2633224
              ],
              [
                52.9507818,
                36.2652685
              ],
              [
                52.9505052,
                36.273323
              ],
              [
                52.9491951,
                36.2752791
              ],
              [
                52.9514185,
                36.2877754
              ],
              [
                52.9561418,
                36.2941632
              ],
              [
                52.9566951,
                36.2944424
              ],
              [
                52.9583651,
                36.2961092
              ],
              [
                52.9619521,
                36.2982285
              ],
              [
                53.0024474,
                36.2831414
              ],
              [
                53.0093762,
                36.2932678
              ],
              [
                53.0066296,
                36.3101457
              ],
              [
                53.0117794,
                36.3275732
              ],
              [
                53.0358169,
                36.3459564
              ],
              [
                53.0365443,
                36.346306
              ],
              [
                53.0332593,
                36.3497143
              ],
              [
                53.031782,
                36.3516869
              ],
              [
                53.0277309,
                36.3663866
              ],
              [
                53.0257842,
                36.3691612
              ],
              [
                53.0091178,
                36.3911056
              ],
              [
                53.0085611,
                36.3919434
              ],
              [
                53.0080079,
                36.3922137
              ],
              [
                53.0046745,
                36.3899976
              ],
              [
                53.0032846,
                36.3899977
              ],
              [
                53.0024512,
                36.3897184
              ],
              [
                52.9988413,
                36.3897184
              ],
              [
                52.9977279,
                36.3894391
              ],
              [
                52.9955046,
                36.3894391
              ],
              [
                52.9946712,
                36.3891599
              ],
              [
                52.981338,
                36.3891599
              ],
              [
                52.9802281,
                36.3888896
              ],
              [
                52.9788381,
                36.3891599
              ],
              [
                52.9732815,
                36.3888896
              ],
              [
                52.9721715,
                36.3891598
              ],
              [
                52.9718949,
                36.3888897
              ],
              [
                52.9682815,
                36.3891599
              ],
              [
                52.9668949,
                36.3894391
              ],
              [
                52.9602284,
                36.3894391
              ],
              [
                52.959395,
                36.3897184
              ],
              [
                52.9510584,
                36.3897184
              ],
              [
                52.9507817,
                36.3899976
              ],
              [
                52.9463386,
                36.3899976
              ],
              [
                52.9452252,
                36.3902768
              ],
              [
                52.9441152,
                36.3902769
              ],
              [
                52.9432818,
                36.3902769
              ],
              [
                52.9349487,
                36.3905471
              ],
              [
                52.9299486,
                36.3911056
              ],
              [
                52.9291153,
                36.3911056
              ],
              [
                52.9288353,
                36.3913849
              ],
              [
                52.9266154,
                36.3913849
              ],
              [
                52.9255021,
                36.3916642
              ],
              [
                52.9180021,
                36.3916642
              ],
              [
                52.9168922,
                36.3913849
              ],
              [
                52.9132789,
                36.3913849
              ],
              [
                52.9127255,
                36.3911057
              ],
              [
                52.9093922,
                36.3911057
              ],
              [
                52.9077257,
                36.3908264
              ],
              [
                52.9030022,
                36.3908263
              ],
              [
                52.8882791,
                36.3883311
              ],
              [
                52.8877224,
                36.3880518
              ],
              [
                52.8863359,
                36.3880518
              ],
              [
                52.8830026,
                36.387223
              ],
              [
                52.8816125,
                36.3872231
              ],
              [
                52.8810558,
                36.3869438
              ],
              [
                52.8796659,
                36.3869438
              ],
              [
                52.8791126,
                36.3866645
              ],
              [
                52.8763326,
                36.3866645
              ],
              [
                52.8754993,
                36.3863852
              ],
              [
                52.8652228,
                36.3863852
              ],
              [
                52.8643895,
                36.386106
              ],
              [
                52.8577228,
                36.386106
              ],
              [
                52.8566095,
                36.3863853
              ],
              [
                52.8524429,
                36.3863852
              ],
              [
                52.8521662,
                36.3866645
              ],
              [
                52.8491096,
                36.3866645
              ],
              [
                52.8482763,
                36.3869438
              ],
              [
                52.8460563,
                36.3869437
              ],
              [
                52.8452195,
                36.387223
              ],
              [
                52.8443862,
                36.387223
              ],
              [
                52.843833,
                36.3874933
              ],
              [
                52.8354998,
                36.3886103
              ],
              [
                52.8346664,
                36.3886103
              ],
              [
                52.8341097,
                36.3888895
              ],
              [
                52.8332765,
                36.3888895
              ],
              [
                52.8329998,
                36.3886103
              ],
              [
                52.8310531,
                36.3886103
              ],
              [
                52.8266098,
                36.387223
              ],
              [
                52.8143783,
                36.3824354
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555089,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سوادکوه",
          "name:en": "Savadkuh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282207",
          "wikipedia": "en:Savadkuh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.6024192,
                35.943043
              ],
              [
                52.6065993,
                35.9430426
              ],
              [
                52.6077093,
                35.9427633
              ],
              [
                52.6129892,
                35.9427632
              ],
              [
                52.6149325,
                35.9424838
              ],
              [
                52.6196559,
                35.9424839
              ],
              [
                52.6227125,
                35.941925
              ],
              [
                52.6435456,
                35.9405371
              ],
              [
                52.6443789,
                35.9408165
              ],
              [
                52.6477122,
                35.9402576
              ],
              [
                52.6488221,
                35.9405371
              ],
              [
                52.6502122,
                35.9402576
              ],
              [
                52.6524355,
                35.9402577
              ],
              [
                52.6538222,
                35.9399783
              ],
              [
                52.6560454,
                35.9399783
              ],
              [
                52.6571589,
                35.9397079
              ],
              [
                52.6585453,
                35.9397079
              ],
              [
                52.6591021,
                35.9394285
              ],
              [
                52.660212,
                35.9394284
              ],
              [
                52.6616785,
                35.9390399
              ],
              [
                52.6832685,
                35.9333177
              ],
              [
                52.6841018,
                35.9333177
              ],
              [
                52.692435,
                35.9308211
              ],
              [
                52.6935484,
                35.9308211
              ],
              [
                52.6949384,
                35.9302623
              ],
              [
                52.6993816,
                35.9294241
              ],
              [
                52.7016049,
                35.928595
              ],
              [
                52.7049383,
                35.9280361
              ],
              [
                52.7057716,
                35.9274863
              ],
              [
                52.7881052,
                35.8929868
              ],
              [
                52.7966072,
                35.8894235
              ],
              [
                52.8038129,
                35.8854164
              ],
              [
                52.8146636,
                35.8794276
              ],
              [
                52.815777,
                35.8791482
              ],
              [
                52.8218869,
                35.876372
              ],
              [
                52.8229968,
                35.8760926
              ],
              [
                52.8281778,
                35.8741024
              ],
              [
                52.8291102,
                35.8738753
              ],
              [
                52.8704997,
                35.8594264
              ],
              [
                52.8718897,
                35.8585882
              ],
              [
                52.8774463,
                35.8566503
              ],
              [
                52.9171691,
                35.8391455
              ],
              [
                52.9180024,
                35.8391455
              ],
              [
                52.9207825,
                35.8377573
              ],
              [
                52.9216158,
                35.8377573
              ],
              [
                52.9357823,
                35.8341427
              ],
              [
                52.9368923,
                35.8338723
              ],
              [
                52.937449,
                35.8338723
              ],
              [
                52.9430055,
                35.8327546
              ],
              [
                52.9449488,
                35.8327546
              ],
              [
                52.9455055,
                35.8324842
              ],
              [
                52.9468922,
                35.8324842
              ],
              [
                52.9480055,
                35.8322047
              ],
              [
                52.9507821,
                35.8322048
              ],
              [
                52.9516155,
                35.8319253
              ],
              [
                52.9613387,
                35.8319253
              ],
              [
                52.9627287,
                35.8322048
              ],
              [
                52.9632819,
                35.8319254
              ],
              [
                52.9643953,
                35.8322048
              ],
              [
                52.9663387,
                35.8322048
              ],
              [
                52.9674485,
                35.8324842
              ],
              [
                52.9707818,
                35.8324842
              ],
              [
                52.9874517,
                35.83554
              ],
              [
                53.0038415,
                35.8435893
              ],
              [
                53.0046748,
                35.8444276
              ],
              [
                53.0068947,
                35.8455364
              ],
              [
                53.0071748,
                35.8460951
              ],
              [
                53.0107847,
                35.8483126
              ],
              [
                53.0110614,
                35.8485919
              ],
              [
                53.0174514,
                35.8535946
              ],
              [
                53.0470905,
                35.8677671
              ],
              [
                53.0482004,
                35.8713725
              ],
              [
                53.0484805,
                35.8785922
              ],
              [
                53.0482004,
                35.8794305
              ],
              [
                53.0465337,
                35.8855415
              ],
              [
                53.0504237,
                35.8905439
              ],
              [
                53.0649541,
                35.9149853
              ],
              [
                53.0744006,
                35.917482
              ],
              [
                53.0763439,
                35.917482
              ],
              [
                53.0780106,
                35.9177613
              ],
              [
                53.0844205,
                35.9177614
              ],
              [
                53.0874537,
                35.9177614
              ],
              [
                53.0905105,
                35.9183202
              ],
              [
                53.0938437,
                35.9183201
              ],
              [
                53.097457,
                35.9188699
              ],
              [
                53.1002336,
                35.91887
              ],
              [
                53.1015565,
                35.9190917
              ],
              [
                53.1019003,
                35.9191493
              ],
              [
                53.1032903,
                35.9191494
              ],
              [
                53.1041237,
                35.91887
              ],
              [
                53.107457,
                35.9191494
              ],
              [
                53.108567,
                35.9188699
              ],
              [
                53.1124569,
                35.9191493
              ],
              [
                53.1149568,
                35.9191494
              ],
              [
                53.1166235,
                35.9194287
              ],
              [
                53.1191234,
                35.9194288
              ],
              [
                53.1205134,
                35.9197082
              ],
              [
                53.1274566,
                35.9197082
              ],
              [
                53.1285701,
                35.9194288
              ],
              [
                53.1324566,
                35.9194288
              ],
              [
                53.1330134,
                35.9197082
              ],
              [
                53.1341232,
                35.9197082
              ],
              [
                53.1349565,
                35.9197082
              ],
              [
                53.1385699,
                35.9197082
              ],
              [
                53.1567129,
                35.9138658
              ],
              [
                53.1592128,
                35.9138657
              ],
              [
                53.161156,
                35.9141452
              ],
              [
                53.1644895,
                35.9138657
              ],
              [
                53.1678226,
                35.9138657
              ],
              [
                53.170046,
                35.9135863
              ],
              [
                53.1736559,
                35.9135863
              ],
              [
                53.1781025,
                35.9130274
              ],
              [
                53.1792126,
                35.9133159
              ],
              [
                53.1850458,
                35.9133158
              ],
              [
                53.2026988,
                35.9091427
              ],
              [
                53.2302486,
                35.9069091
              ],
              [
                53.2321918,
                35.907468
              ],
              [
                53.2333052,
                35.907468
              ],
              [
                53.2338585,
                35.9077473
              ],
              [
                53.2349719,
                35.9077474
              ],
              [
                53.2380251,
                35.9085768
              ],
              [
                53.2408051,
                35.9099652
              ],
              [
                53.245805,
                35.9141301
              ],
              [
                53.2480283,
                35.923019
              ],
              [
                53.2458051,
                35.9310874
              ],
              [
                53.2455284,
                35.9316373
              ],
              [
                53.2249622,
                35.9580402
              ],
              [
                53.2246856,
                35.9591489
              ],
              [
                53.2235722,
                35.9641508
              ],
              [
                53.223375,
                35.9655388
              ],
              [
                53.218042,
                35.9894356
              ],
              [
                53.2172086,
                35.9897149
              ],
              [
                53.2158187,
                35.9897149
              ],
              [
                53.2097052,
                36.0243905
              ],
              [
                53.2012253,
                36.0308292
              ],
              [
                53.1998388,
                36.0333257
              ],
              [
                53.1995588,
                36.0344434
              ],
              [
                53.1953704,
                36.0573536
              ],
              [
                53.1828706,
                36.0626256
              ],
              [
                53.1753407,
                36.0663776
              ],
              [
                53.167004,
                36.0663775
              ],
              [
                53.165894,
                36.0660981
              ],
              [
                53.1647841,
                36.0660982
              ],
              [
                53.1639508,
                36.0658188
              ],
              [
                53.1620042,
                36.0658188
              ],
              [
                53.1617275,
                36.0655394
              ],
              [
                53.1600609,
                36.0658188
              ],
              [
                53.1522809,
                36.0685942
              ],
              [
                53.1522809,
                36.0688737
              ],
              [
                53.1520042,
                36.0694324
              ],
              [
                53.1510959,
                36.0770708
              ],
              [
                53.149706,
                36.0820721
              ],
              [
                53.130943,
                36.0941566
              ],
              [
                53.1163468,
                36.100818
              ],
              [
                53.1159157,
                36.1020879
              ],
              [
                53.11481,
                36.105821
              ],
              [
                53.1142533,
                36.1086056
              ],
              [
                53.1139767,
                36.1099934
              ],
              [
                53.1187415,
                36.1195698
              ],
              [
                53.1187415,
                36.1209575
              ],
              [
                53.1162416,
                36.1387357
              ],
              [
                53.1159649,
                36.1412316
              ],
              [
                53.1098351,
                36.1548423
              ],
              [
                53.109555,
                36.1578967
              ],
              [
                53.1092785,
                36.1601223
              ],
              [
                53.1090018,
                36.1626181
              ],
              [
                53.1077335,
                36.1666524
              ],
              [
                53.1074568,
                36.167211
              ],
              [
                53.1076997,
                36.1691574
              ],
              [
                53.1121717,
                36.1729175
              ],
              [
                53.1185149,
                36.1740429
              ],
              [
                53.1204581,
                36.1773682
              ],
              [
                53.1207383,
                36.1784765
              ],
              [
                53.1230162,
                36.1980188
              ],
              [
                53.1357897,
                36.2158222
              ],
              [
                53.1369215,
                36.2174509
              ],
              [
                53.1626291,
                36.2258419
              ],
              [
                53.1637426,
                36.2286171
              ],
              [
                53.1642958,
                36.2350146
              ],
              [
                53.1642958,
                36.2352939
              ],
              [
                53.1637425,
                36.2358437
              ],
              [
                53.1629092,
                36.2364022
              ],
              [
                53.1397996,
                36.2563768
              ],
              [
                53.1395195,
                36.2569264
              ],
              [
                53.1384095,
                36.257485
              ],
              [
                53.1254193,
                36.2783236
              ],
              [
                53.1073664,
                36.2855833
              ],
              [
                53.1045864,
                36.2889171
              ],
              [
                53.0986401,
                36.3004621
              ],
              [
                53.0759808,
                36.3131889
              ],
              [
                53.0722044,
                36.31803
              ],
              [
                53.073921,
                36.3369768
              ],
              [
                53.0365443,
                36.346306
              ],
              [
                53.0358169,
                36.3459564
              ],
              [
                53.0117794,
                36.3275732
              ],
              [
                53.0066296,
                36.3101457
              ],
              [
                53.0093762,
                36.2932678
              ],
              [
                53.0024474,
                36.2831414
              ],
              [
                52.9619521,
                36.2982285
              ],
              [
                52.9583651,
                36.2961092
              ],
              [
                52.9566951,
                36.2944424
              ],
              [
                52.9561418,
                36.2941632
              ],
              [
                52.9514185,
                36.2877754
              ],
              [
                52.9491951,
                36.2752791
              ],
              [
                52.9505052,
                36.273323
              ],
              [
                52.9507818,
                36.2652685
              ],
              [
                52.9510585,
                36.2633224
              ],
              [
                52.9513386,
                36.261106
              ],
              [
                52.9516152,
                36.2602681
              ],
              [
                52.9510585,
                36.2483211
              ],
              [
                52.949672,
                36.2458254
              ],
              [
                52.9474485,
                36.2449965
              ],
              [
                52.9468919,
                36.2449965
              ],
              [
                52.9377254,
                36.2466543
              ],
              [
                52.9352253,
                36.2466544
              ],
              [
                52.9335588,
                36.2469426
              ],
              [
                52.9241155,
                36.2469426
              ],
              [
                52.9149456,
                36.2480509
              ],
              [
                52.912169,
                36.2480508
              ],
              [
                52.9116123,
                36.2483211
              ],
              [
                52.9099456,
                36.2483211
              ],
              [
                52.908559,
                36.2486004
              ],
              [
                52.906059,
                36.2486004
              ],
              [
                52.9049456,
                36.2488797
              ],
              [
                52.9013357,
                36.2488797
              ],
              [
                52.9005025,
                36.2491591
              ],
              [
                52.8988357,
                36.249159
              ],
              [
                52.8916125,
                36.2502672
              ],
              [
                52.8893892,
                36.2502673
              ],
              [
                52.888836,
                36.2505465
              ],
              [
                52.8865067,
                36.2503361
              ],
              [
                52.886336,
                36.2499969
              ],
              [
                52.8857793,
                36.249159
              ],
              [
                52.8860559,
                36.2488797
              ],
              [
                52.8857793,
                36.2472129
              ],
              [
                52.8846693,
                36.2316529
              ],
              [
                52.8835559,
                36.212218
              ],
              [
                52.882446,
                36.2072174
              ],
              [
                52.882166,
                36.2061002
              ],
              [
                52.8763327,
                36.1844301
              ],
              [
                52.8723351,
                36.1745212
              ],
              [
                52.8699462,
                36.1685986
              ],
              [
                52.8663329,
                36.1649854
              ],
              [
                52.857723,
                36.1619307
              ],
              [
                52.8511948,
                36.161237
              ],
              [
                52.8504283,
                36.1600876
              ],
              [
                52.8506812,
                36.1589968
              ],
              [
                52.8515723,
                36.158531
              ],
              [
                52.8484274,
                36.1530691
              ],
              [
                52.8448631,
                36.1378245
              ],
              [
                52.8412989,
                36.1263468
              ],
              [
                52.8376823,
                36.1200778
              ],
              [
                52.8319166,
                36.1108216
              ],
              [
                52.8290076,
                36.1071358
              ],
              [
                52.8202281,
                36.1065003
              ],
              [
                52.8134928,
                36.1046361
              ],
              [
                52.8069671,
                36.1035133
              ],
              [
                52.7914785,
                36.0901872
              ],
              [
                52.7887791,
                36.0822202
              ],
              [
                52.7860273,
                36.078978
              ],
              [
                52.7789775,
                36.0756721
              ],
              [
                52.7735001,
                36.0695051
              ],
              [
                52.7699359,
                36.0669406
              ],
              [
                52.7694468,
                36.0627589
              ],
              [
                52.7676887,
                36.0581265
              ],
              [
                52.7671691,
                36.0549427
              ],
              [
                52.7615188,
                36.0535922
              ],
              [
                52.7538499,
                36.0533964
              ],
              [
                52.7400433,
                36.0553665
              ],
              [
                52.7268705,
                36.0453942
              ],
              [
                52.6938249,
                36.0322119
              ],
              [
                52.6896583,
                36.0285982
              ],
              [
                52.6513221,
                35.9988758
              ],
              [
                52.640769,
                35.9922067
              ],
              [
                52.6268791,
                35.9760923
              ],
              [
                52.6118759,
                35.9530379
              ],
              [
                52.6088227,
                35.9499825
              ],
              [
                52.6077094,
                35.9485946
              ],
              [
                52.6024192,
                35.943043
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555095,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سیمرغ",
          "name:en": "Simorgh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2586999",
          "wikipedia": "en:Simorgh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.7596548,
                36.6213691
              ],
              [
                52.7605245,
                36.6151517
              ],
              [
                52.7607738,
                36.6141739
              ],
              [
                52.7610505,
                36.6133364
              ],
              [
                52.7611393,
                36.6128013
              ],
              [
                52.7613271,
                36.6116703
              ],
              [
                52.7616071,
                36.6108329
              ],
              [
                52.7618837,
                36.6086084
              ],
              [
                52.7624404,
                36.6041685
              ],
              [
                52.765075,
                36.5914181
              ],
              [
                52.7630112,
                36.5776249
              ],
              [
                52.7642667,
                36.5759959
              ],
              [
                52.7654645,
                36.5736336
              ],
              [
                52.7678914,
                36.5704747
              ],
              [
                52.7694751,
                36.5684139
              ],
              [
                52.771892,
                36.5671903
              ],
              [
                52.7752801,
                36.565722
              ],
              [
                52.7785455,
                36.5645096
              ],
              [
                52.7831592,
                36.5627341
              ],
              [
                52.7855697,
                36.5598732
              ],
              [
                52.7881358,
                36.5556943
              ],
              [
                52.7880734,
                36.5518193
              ],
              [
                52.7831396,
                36.5490429
              ],
              [
                52.7820518,
                36.5466935
              ],
              [
                52.7829695,
                36.544668
              ],
              [
                52.784906,
                36.5436361
              ],
              [
                52.7912768,
                36.5434964
              ],
              [
                52.7950051,
                36.5438907
              ],
              [
                52.7974683,
                36.5430965
              ],
              [
                52.7985586,
                36.5412783
              ],
              [
                52.7991718,
                36.539567
              ],
              [
                52.799737,
                36.5383824
              ],
              [
                52.8006093,
                36.5366814
              ],
              [
                52.8006577,
                36.5336227
              ],
              [
                52.7993611,
                36.5312447
              ],
              [
                52.7903523,
                36.5319958
              ],
              [
                52.7841975,
                36.532582
              ],
              [
                52.7805458,
                36.531631
              ],
              [
                52.7797676,
                36.5300979
              ],
              [
                52.7814102,
                36.5296053
              ],
              [
                52.784367,
                36.5282139
              ],
              [
                52.787075,
                36.5272948
              ],
              [
                52.7965593,
                36.5218976
              ],
              [
                52.8021674,
                36.5186165
              ],
              [
                52.8073096,
                36.5140685
              ],
              [
                52.8121805,
                36.5121197
              ],
              [
                52.8126531,
                36.5121669
              ],
              [
                52.8155172,
                36.5125336
              ],
              [
                52.8188538,
                36.513827
              ],
              [
                52.82084,
                36.5157316
              ],
              [
                52.8261282,
                36.5221525
              ],
              [
                52.8291535,
                36.5249498
              ],
              [
                52.8299634,
                36.5266786
              ],
              [
                52.8453504,
                36.5362128
              ],
              [
                52.8582319,
                36.5424091
              ],
              [
                52.8614914,
                36.5431138
              ],
              [
                52.8699579,
                36.5449444
              ],
              [
                52.8781115,
                36.5440416
              ],
              [
                52.8850333,
                36.5450742
              ],
              [
                52.8886747,
                36.5476935
              ],
              [
                52.8913141,
                36.5490208
              ],
              [
                52.8955454,
                36.5546131
              ],
              [
                52.8957609,
                36.5548979
              ],
              [
                52.8960047,
                36.5558832
              ],
              [
                52.8964927,
                36.557856
              ],
              [
                52.896907,
                36.5595303
              ],
              [
                52.8956557,
                36.5624559
              ],
              [
                52.8963356,
                36.5638932
              ],
              [
                52.8926958,
                36.5698357
              ],
              [
                52.8806775,
                36.5693147
              ],
              [
                52.8750483,
                36.569722
              ],
              [
                52.866168,
                36.5705277
              ],
              [
                52.8630518,
                36.5709492
              ],
              [
                52.8544213,
                36.5716072
              ],
              [
                52.8493337,
                36.5793901
              ],
              [
                52.8595467,
                36.5896605
              ],
              [
                52.8557118,
                36.5973381
              ],
              [
                52.8516468,
                36.6007231
              ],
              [
                52.8498811,
                36.6021934
              ],
              [
                52.8459538,
                36.6083565
              ],
              [
                52.8455027,
                36.6105667
              ],
              [
                52.8397661,
                36.6157905
              ],
              [
                52.8222694,
                36.6317167
              ],
              [
                52.8167294,
                36.6367587
              ],
              [
                52.8156141,
                36.6405406
              ],
              [
                52.8141098,
                36.6416681
              ],
              [
                52.8124432,
                36.6422265
              ],
              [
                52.8101705,
                36.6431151
              ],
              [
                52.8069811,
                36.6413593
              ],
              [
                52.8054129,
                36.638611
              ],
              [
                52.8027553,
                36.6371477
              ],
              [
                52.7879193,
                36.6383057
              ],
              [
                52.7775876,
                36.6366265
              ],
              [
                52.7639022,
                36.6323246
              ],
              [
                52.7605504,
                36.6295588
              ],
              [
                52.7589944,
                36.6260905
              ],
              [
                52.7596548,
                36.6213691
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555121,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان عباس آباد",
          "name:en": "Abbasabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4663894",
          "wikipedia": "en:Abbasabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.0287446,
                36.6383333
              ],
              [
                51.0301329,
                36.6369479
              ],
              [
                51.0393029,
                36.6277803
              ],
              [
                51.0515227,
                36.6155504
              ],
              [
                51.0529128,
                36.6133351
              ],
              [
                51.054026,
                36.6122184
              ],
              [
                51.0584693,
                36.6063826
              ],
              [
                51.0645792,
                36.6002766
              ],
              [
                51.0668028,
                36.5974938
              ],
              [
                51.0670792,
                36.5972236
              ],
              [
                51.0734693,
                36.5886048
              ],
              [
                51.0945519,
                36.5745545
              ],
              [
                51.1281411,
                36.5570815
              ],
              [
                51.1350077,
                36.5617697
              ],
              [
                51.1368214,
                36.5640414
              ],
              [
                51.137967,
                36.5678221
              ],
              [
                51.1392116,
                36.5693386
              ],
              [
                51.1424302,
                36.5725957
              ],
              [
                51.1449622,
                36.5748548
              ],
              [
                51.1491894,
                36.5764385
              ],
              [
                51.1568069,
                36.5776964
              ],
              [
                51.1660766,
                36.5836238
              ],
              [
                51.1690378,
                36.5865874
              ],
              [
                51.1708939,
                36.5875178
              ],
              [
                51.172117,
                36.588741
              ],
              [
                51.1739329,
                36.5894776
              ],
              [
                51.1763763,
                36.5898954
              ],
              [
                51.185646,
                36.5925141
              ],
              [
                51.1963749,
                36.5919284
              ],
              [
                51.2032413,
                36.5911014
              ],
              [
                51.2122964,
                36.5872766
              ],
              [
                51.2146997,
                36.5859671
              ],
              [
                51.2180471,
                36.585812
              ],
              [
                51.2218022,
                36.5863806
              ],
              [
                51.227468,
                36.5879722
              ],
              [
                51.2323118,
                36.5894021
              ],
              [
                51.2408379,
                36.5915159
              ],
              [
                51.2460285,
                36.5925359
              ],
              [
                51.2514124,
                36.5912438
              ],
              [
                51.2573146,
                36.6012656
              ],
              [
                51.2571429,
                36.6075358
              ],
              [
                51.2585162,
                36.6111874
              ],
              [
                51.2689876,
                36.6176633
              ],
              [
                51.2719058,
                36.6197989
              ],
              [
                51.274497,
                36.625472
              ],
              [
                51.2794936,
                36.6541751
              ],
              [
                51.2883831,
                36.697331
              ],
              [
                51.3295772,
                36.8953859
              ],
              [
                51.3242278,
                36.8961941
              ],
              [
                51.3149746,
                36.8973642
              ],
              [
                51.3056254,
                36.8984011
              ],
              [
                51.2961008,
                36.900424
              ],
              [
                51.2743004,
                36.9035576
              ],
              [
                51.2703103,
                36.9044563
              ],
              [
                51.2650377,
                36.9055444
              ],
              [
                51.2597367,
                36.9065397
              ],
              [
                51.2544097,
                36.9074416
              ],
              [
                51.2490594,
                36.9082498
              ],
              [
                51.2436883,
                36.9089638
              ],
              [
                51.2382991,
                36.9095833
              ],
              [
                51.2365719,
                36.9097509
              ],
              [
                51.2255462,
                36.9121645
              ],
              [
                51.2188572,
                36.9136287
              ],
              [
                51.2027171,
                36.9165348
              ],
              [
                51.194467,
                36.918814
              ],
              [
                51.1856116,
                36.9209684
              ],
              [
                51.1663096,
                36.9253497
              ],
              [
                51.072866,
                36.7389708
              ],
              [
                51.0712913,
                36.7350396
              ],
              [
                51.0629123,
                36.7311128
              ],
              [
                51.0515224,
                36.7233329
              ],
              [
                51.0523592,
                36.7227837
              ],
              [
                51.0651359,
                36.7141663
              ],
              [
                51.0654124,
                36.7130587
              ],
              [
                51.0648591,
                36.7094479
              ],
              [
                51.0620792,
                36.7047204
              ],
              [
                51.0612457,
                36.7033337
              ],
              [
                51.0609693,
                36.6997228
              ],
              [
                51.0612457,
                36.698336
              ],
              [
                51.0615258,
                36.6980569
              ],
              [
                51.0615258,
                36.6974986
              ],
              [
                51.0594409,
                36.6915376
              ],
              [
                51.0595627,
                36.6911097
              ],
              [
                51.0599021,
                36.690576
              ],
              [
                51.0656926,
                36.6861075
              ],
              [
                51.0631926,
                36.6683315
              ],
              [
                51.0445795,
                36.6508343
              ],
              [
                51.0431894,
                36.6499967
              ],
              [
                51.0287447,
                36.6383334
              ],
              [
                51.0287446,
                36.6383333
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555136,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فریدونکنار",
          "name:en": "Fereydunkenar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2403208",
          "wikipedia": "en:Fereydunkenar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.422036,
                36.8810184
              ],
              [
                52.4810479,
                36.6855588
              ],
              [
                52.4810771,
                36.6854453
              ],
              [
                52.4810409,
                36.6852801
              ],
              [
                52.4802034,
                36.6844517
              ],
              [
                52.4793995,
                36.6827891
              ],
              [
                52.479482,
                36.6823847
              ],
              [
                52.4791741,
                36.6823231
              ],
              [
                52.4783223,
                36.6805612
              ],
              [
                52.4783728,
                36.6797012
              ],
              [
                52.4784086,
                36.6778049
              ],
              [
                52.4782297,
                36.6771609
              ],
              [
                52.478015,
                36.6767673
              ],
              [
                52.4774426,
                36.6763379
              ],
              [
                52.4770848,
                36.6762306
              ],
              [
                52.4763692,
                36.6741554
              ],
              [
                52.4756953,
                36.6734461
              ],
              [
                52.4753347,
                36.6709245
              ],
              [
                52.4752036,
                36.6700076
              ],
              [
                52.4754801,
                36.6666667
              ],
              [
                52.4757603,
                36.6624972
              ],
              [
                52.4760369,
                36.6608404
              ],
              [
                52.4763136,
                36.6591654
              ],
              [
                52.4765936,
                36.6580578
              ],
              [
                52.4771468,
                36.6566709
              ],
              [
                52.4771468,
                36.6563918
              ],
              [
                52.4771468,
                36.6561126
              ],
              [
                52.4793701,
                36.6505563
              ],
              [
                52.4820949,
                36.6391655
              ],
              [
                52.4824269,
                36.6377776
              ],
              [
                52.4829801,
                36.6366699
              ],
              [
                52.4829801,
                36.6361114
              ],
              [
                52.4832602,
                36.6352741
              ],
              [
                52.4838134,
                36.6266647
              ],
              [
                52.4835369,
                36.6261154
              ],
              [
                52.4836919,
                36.6228454
              ],
              [
                52.4837173,
                36.6223097
              ],
              [
                52.4838135,
                36.6202797
              ],
              [
                52.4840935,
                36.6194421
              ],
              [
                52.4840936,
                36.619163
              ],
              [
                52.4838135,
                36.6177761
              ],
              [
                52.477427,
                36.6016647
              ],
              [
                52.4765936,
                36.600557
              ],
              [
                52.4715937,
                36.5977741
              ],
              [
                52.4755445,
                36.5971575
              ],
              [
                52.4804801,
                36.5963872
              ],
              [
                52.4813134,
                36.5961171
              ],
              [
                52.4824269,
                36.5961171
              ],
              [
                52.4840935,
                36.5955587
              ],
              [
                52.4852036,
                36.5955587
              ],
              [
                52.4857601,
                36.5952794
              ],
              [
                52.4902034,
                36.5952794
              ],
              [
                52.499864,
                36.5941669
              ],
              [
                52.50215,
                36.5944419
              ],
              [
                52.5038487,
                36.5940577
              ],
              [
                52.5043699,
                36.5938925
              ],
              [
                52.5218731,
                36.581113
              ],
              [
                52.522567,
                36.5806936
              ],
              [
                52.5272102,
                36.5829056
              ],
              [
                52.531909,
                36.5851441
              ],
              [
                52.5337819,
                36.5856384
              ],
              [
                52.5400946,
                36.5873043
              ],
              [
                52.5442797,
                36.5882924
              ],
              [
                52.5488054,
                36.5898489
              ],
              [
                52.5556109,
                36.594631
              ],
              [
                52.5612755,
                36.5978941
              ],
              [
                52.5689026,
                36.6024962
              ],
              [
                52.5843424,
                36.6053444
              ],
              [
                52.5862069,
                36.6056883
              ],
              [
                52.586802,
                36.6057981
              ],
              [
                52.5871635,
                36.6060535
              ],
              [
                52.587663,
                36.6064064
              ],
              [
                52.5876399,
                36.6064587
              ],
              [
                52.5866411,
                36.6087173
              ],
              [
                52.586319,
                36.6094458
              ],
              [
                52.5815991,
                36.611391
              ],
              [
                52.5804857,
                36.611391
              ],
              [
                52.5632627,
                36.6186137
              ],
              [
                52.5624293,
                36.619163
              ],
              [
                52.5566307,
                36.6227898
              ],
              [
                52.5557626,
                36.6233327
              ],
              [
                52.5543726,
                36.6249988
              ],
              [
                52.5543727,
                36.6261154
              ],
              [
                52.5582628,
                36.6322212
              ],
              [
                52.5588193,
                36.6333379
              ],
              [
                52.5973658,
                36.6718813
              ],
              [
                52.5956206,
                36.6732981
              ],
              [
                52.5941896,
                36.6768197
              ],
              [
                52.5939492,
                36.6818376
              ],
              [
                52.5938862,
                36.6856339
              ],
              [
                52.5944341,
                36.6904914
              ],
              [
                52.5957163,
                36.6944257
              ],
              [
                52.5973174,
                36.6976796
              ],
              [
                52.6015152,
                36.70021
              ],
              [
                52.6023467,
                36.7007112
              ],
              [
                52.6052087,
                36.7025065
              ],
              [
                52.6053213,
                36.7033887
              ],
              [
                52.6053429,
                36.7035582
              ],
              [
                52.6054528,
                36.7044193
              ],
              [
                52.6054743,
                36.7048671
              ],
              [
                52.5644927,
                36.9036858
              ],
              [
                52.5623865,
                36.9030182
              ],
              [
                52.5584397,
                36.9030529
              ],
              [
                52.5529963,
                36.9030051
              ],
              [
                52.5475554,
                36.9028617
              ],
              [
                52.5421198,
                36.9026227
              ],
              [
                52.536692,
                36.9022883
              ],
              [
                52.5312747,
                36.9018587
              ],
              [
                52.5258703,
                36.901334
              ],
              [
                52.5204816,
                36.9007145
              ],
              [
                52.5151111,
                36.9000005
              ],
              [
                52.5097614,
                36.8991924
              ],
              [
                52.504435,
                36.8982904
              ],
              [
                52.4991346,
                36.8972952
              ],
              [
                52.4938625,
                36.896207
              ],
              [
                52.4886215,
                36.8950265
              ],
              [
                52.4834139,
                36.8937543
              ],
              [
                52.4782423,
                36.8923908
              ],
              [
                52.4731091,
                36.8909369
              ],
              [
                52.4680169,
                36.8893931
              ],
              [
                52.462968,
                36.8877603
              ],
              [
                52.457978,
                36.8859404
              ],
              [
                52.4570988,
                36.8857231
              ],
              [
                52.4553544,
                36.8854911
              ],
              [
                52.4500056,
                36.8846829
              ],
              [
                52.4446803,
                36.883781
              ],
              [
                52.4414436,
                36.8831731
              ],
              [
                52.4373199,
                36.8827981
              ],
              [
                52.4296607,
                36.8820035
              ],
              [
                52.422036,
                36.8810184
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555146,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قائم شهر",
          "name:en": "Qaem Shahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q638092",
          "wikipedia": "fa:شهرستان قائم‌شهر"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.7354661,
                36.4406269
              ],
              [
                52.732509,
                36.4346304
              ],
              [
                52.7329683,
                36.4303081
              ],
              [
                52.7333059,
                36.4290655
              ],
              [
                52.7336981,
                36.4278193
              ],
              [
                52.7343182,
                36.425392
              ],
              [
                52.7382529,
                36.4223802
              ],
              [
                52.7466239,
                36.4137882
              ],
              [
                52.7475258,
                36.4055033
              ],
              [
                52.7467786,
                36.4013588
              ],
              [
                52.7484311,
                36.3922331
              ],
              [
                52.7550754,
                36.3869671
              ],
              [
                52.7685763,
                36.3892322
              ],
              [
                52.7750742,
                36.390112
              ],
              [
                52.7795264,
                36.389951
              ],
              [
                52.7816081,
                36.3897998
              ],
              [
                52.7835514,
                36.38976
              ],
              [
                52.7893216,
                36.3884901
              ],
              [
                52.7956509,
                36.3857599
              ],
              [
                52.8028353,
                36.3808109
              ],
              [
                52.8114813,
                36.3810833
              ],
              [
                52.8143783,
                36.3824354
              ],
              [
                52.8266098,
                36.387223
              ],
              [
                52.8310531,
                36.3886103
              ],
              [
                52.8329998,
                36.3886103
              ],
              [
                52.8332765,
                36.3888895
              ],
              [
                52.8341097,
                36.3888895
              ],
              [
                52.8346664,
                36.3886103
              ],
              [
                52.8354998,
                36.3886103
              ],
              [
                52.843833,
                36.3874933
              ],
              [
                52.8443862,
                36.387223
              ],
              [
                52.8452195,
                36.387223
              ],
              [
                52.8460563,
                36.3869437
              ],
              [
                52.8482763,
                36.3869438
              ],
              [
                52.8491096,
                36.3866645
              ],
              [
                52.8521662,
                36.3866645
              ],
              [
                52.8524429,
                36.3863852
              ],
              [
                52.8566095,
                36.3863853
              ],
              [
                52.8577228,
                36.386106
              ],
              [
                52.8643895,
                36.386106
              ],
              [
                52.8652228,
                36.3863852
              ],
              [
                52.8754993,
                36.3863852
              ],
              [
                52.8763326,
                36.3866645
              ],
              [
                52.8791126,
                36.3866645
              ],
              [
                52.8796659,
                36.3869438
              ],
              [
                52.8810558,
                36.3869438
              ],
              [
                52.8816125,
                36.3872231
              ],
              [
                52.8830026,
                36.387223
              ],
              [
                52.8863359,
                36.3880518
              ],
              [
                52.8877224,
                36.3880518
              ],
              [
                52.8882791,
                36.3883311
              ],
              [
                52.9030022,
                36.3908263
              ],
              [
                52.9077257,
                36.3908264
              ],
              [
                52.9093922,
                36.3911057
              ],
              [
                52.9127255,
                36.3911057
              ],
              [
                52.9132789,
                36.3913849
              ],
              [
                52.9168922,
                36.3913849
              ],
              [
                52.9180021,
                36.3916642
              ],
              [
                52.9255021,
                36.3916642
              ],
              [
                52.9266154,
                36.3913849
              ],
              [
                52.9288353,
                36.3913849
              ],
              [
                52.9291153,
                36.3911056
              ],
              [
                52.9299486,
                36.3911056
              ],
              [
                52.9349487,
                36.3905471
              ],
              [
                52.9432818,
                36.3902769
              ],
              [
                52.9441152,
                36.3902769
              ],
              [
                52.9452252,
                36.3902768
              ],
              [
                52.9463386,
                36.3899976
              ],
              [
                52.9507817,
                36.3899976
              ],
              [
                52.9510584,
                36.3897184
              ],
              [
                52.959395,
                36.3897184
              ],
              [
                52.9602284,
                36.3894391
              ],
              [
                52.9668949,
                36.3894391
              ],
              [
                52.9682815,
                36.3891599
              ],
              [
                52.9718949,
                36.3888897
              ],
              [
                52.9721715,
                36.3891598
              ],
              [
                52.9732815,
                36.3888896
              ],
              [
                52.9788381,
                36.3891599
              ],
              [
                52.9802281,
                36.3888896
              ],
              [
                52.981338,
                36.3891599
              ],
              [
                52.9946712,
                36.3891599
              ],
              [
                52.9955046,
                36.3894391
              ],
              [
                52.9977279,
                36.3894391
              ],
              [
                52.9988413,
                36.3897184
              ],
              [
                53.0024512,
                36.3897184
              ],
              [
                53.0032846,
                36.3899977
              ],
              [
                53.0046745,
                36.3899976
              ],
              [
                53.0080079,
                36.3922137
              ],
              [
                53.0280076,
                36.4075006
              ],
              [
                53.0296742,
                36.4091671
              ],
              [
                53.0302309,
                36.4097166
              ],
              [
                53.0302309,
                36.4119416
              ],
              [
                53.0268976,
                36.4241654
              ],
              [
                53.0267397,
                36.4249472
              ],
              [
                53.0266176,
                36.4255526
              ],
              [
                53.0263409,
                36.4280478
              ],
              [
                53.0260643,
                36.429444
              ],
              [
                53.0327308,
                36.438614
              ],
              [
                53.0355074,
                36.4405507
              ],
              [
                53.0357875,
                36.4411091
              ],
              [
                53.0396741,
                36.4427756
              ],
              [
                53.0405074,
                36.4427756
              ],
              [
                53.0407875,
                36.4430548
              ],
              [
                53.0430073,
                36.4430548
              ],
              [
                53.044674,
                36.4436133
              ],
              [
                53.0446739,
                36.4458292
              ],
              [
                53.0443974,
                36.4463876
              ],
              [
                53.0418974,
                36.449162
              ],
              [
                53.0405074,
                36.4499997
              ],
              [
                53.0388407,
                36.4505492
              ],
              [
                53.0382875,
                36.4511077
              ],
              [
                53.0305076,
                36.4533326
              ],
              [
                53.0296742,
                36.4533325
              ],
              [
                53.0169882,
                36.4587043
              ],
              [
                53.008561,
                36.4636102
              ],
              [
                53.0077277,
                36.4636102
              ],
              [
                53.0004315,
                36.4704212
              ],
              [
                52.9910612,
                36.4791659
              ],
              [
                52.9882846,
                36.4819402
              ],
              [
                52.9677283,
                36.4986124
              ],
              [
                52.9597198,
                36.510099
              ],
              [
                52.9568915,
                36.5141675
              ],
              [
                52.9474484,
                36.5222197
              ],
              [
                52.9468917,
                36.5224989
              ],
              [
                52.945802,
                36.521709
              ],
              [
                52.9441151,
                36.5247235
              ],
              [
                52.9430051,
                36.5261106
              ],
              [
                52.9410585,
                36.533334
              ],
              [
                52.9413384,
                36.5447184
              ],
              [
                52.9399485,
                36.5475014
              ],
              [
                52.9371684,
                36.5502755
              ],
              [
                52.9335585,
                36.5525
              ],
              [
                52.9266153,
                36.5602726
              ],
              [
                52.9260586,
                36.5616686
              ],
              [
                52.9266153,
                36.5652711
              ],
              [
                52.9293919,
                36.5691709
              ],
              [
                52.9313353,
                36.5733318
              ],
              [
                52.900908,
                36.5699052
              ],
              [
                52.8926958,
                36.5698357
              ],
              [
                52.8963356,
                36.5638932
              ],
              [
                52.8956557,
                36.5624559
              ],
              [
                52.896907,
                36.5595303
              ],
              [
                52.8964927,
                36.557856
              ],
              [
                52.8960047,
                36.5558832
              ],
              [
                52.8957609,
                36.5548979
              ],
              [
                52.8955454,
                36.5546131
              ],
              [
                52.8913141,
                36.5490208
              ],
              [
                52.8886747,
                36.5476935
              ],
              [
                52.8850333,
                36.5450742
              ],
              [
                52.8781115,
                36.5440416
              ],
              [
                52.8699579,
                36.5449444
              ],
              [
                52.8614914,
                36.5431138
              ],
              [
                52.8582319,
                36.5424091
              ],
              [
                52.8453504,
                36.5362128
              ],
              [
                52.8299634,
                36.5266786
              ],
              [
                52.8291535,
                36.5249498
              ],
              [
                52.8261282,
                36.5221525
              ],
              [
                52.82084,
                36.5157316
              ],
              [
                52.8188538,
                36.513827
              ],
              [
                52.8155172,
                36.5125336
              ],
              [
                52.8126531,
                36.5121669
              ],
              [
                52.8121805,
                36.5121197
              ],
              [
                52.8073096,
                36.5140685
              ],
              [
                52.8021674,
                36.5186165
              ],
              [
                52.7965593,
                36.5218976
              ],
              [
                52.787075,
                36.5272948
              ],
              [
                52.784367,
                36.5282139
              ],
              [
                52.7814102,
                36.5296053
              ],
              [
                52.7797676,
                36.5300979
              ],
              [
                52.7771368,
                36.5244398
              ],
              [
                52.7749403,
                36.5197157
              ],
              [
                52.7754609,
                36.515824
              ],
              [
                52.775497,
                36.5155545
              ],
              [
                52.7754653,
                36.5153014
              ],
              [
                52.7749403,
                36.5111051
              ],
              [
                52.7735873,
                36.5094819
              ],
              [
                52.7719276,
                36.5074908
              ],
              [
                52.7666071,
                36.5011073
              ],
              [
                52.7638272,
                36.4997202
              ],
              [
                52.7635504,
                36.499441
              ],
              [
                52.7624405,
                36.4991618
              ],
              [
                52.755774,
                36.4952797
              ],
              [
                52.753274,
                36.4927757
              ],
              [
                52.7524407,
                36.4888847
              ],
              [
                52.7546606,
                36.485552
              ],
              [
                52.7588273,
                36.4813906
              ],
              [
                52.7607738,
                36.4788866
              ],
              [
                52.7616071,
                36.4772202
              ],
              [
                52.7613271,
                36.4725004
              ],
              [
                52.7543839,
                36.4633308
              ],
              [
                52.7480143,
                36.4560892
              ],
              [
                52.747498,
                36.4555022
              ],
              [
                52.746258,
                36.4542328
              ],
              [
                52.7455173,
                36.4534746
              ],
              [
                52.7382578,
                36.4462641
              ],
              [
                52.7354661,
                36.4406269
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555170,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کلاردشت",
          "name:en": "Kelardasht County",
          "place": "county",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.9118624,
                36.5182875
              ],
              [
                50.9106705,
                36.5172147
              ],
              [
                50.9107732,
                36.5162587
              ],
              [
                50.9125757,
                36.512982
              ],
              [
                50.9140352,
                36.5100077
              ],
              [
                50.9152364,
                36.5077735
              ],
              [
                50.9155798,
                36.5059798
              ],
              [
                50.9156468,
                36.5031335
              ],
              [
                50.9160533,
                36.5004484
              ],
              [
                50.918498,
                36.4948371
              ],
              [
                50.926744,
                36.4831996
              ],
              [
                50.9292268,
                36.4759287
              ],
              [
                50.9301188,
                36.4717969
              ],
              [
                50.9309864,
                36.467094
              ],
              [
                50.9344803,
                36.4599404
              ],
              [
                50.9396552,
                36.4528391
              ],
              [
                50.94738,
                36.4469707
              ],
              [
                50.9568995,
                36.4349479
              ],
              [
                50.9579545,
                36.4169783
              ],
              [
                50.9605544,
                36.396526
              ],
              [
                50.9599113,
                36.3889531
              ],
              [
                50.9561783,
                36.3743723
              ],
              [
                50.9546756,
                36.3692932
              ],
              [
                50.9541197,
                36.3651404
              ],
              [
                50.9567785,
                36.3549166
              ],
              [
                50.9574222,
                36.3482458
              ],
              [
                50.9557056,
                36.3425078
              ],
              [
                50.9477779,
                36.3328425
              ],
              [
                50.9456276,
                36.3274714
              ],
              [
                50.9445118,
                36.3209032
              ],
              [
                50.9448225,
                36.3150252
              ],
              [
                50.9434134,
                36.3049889
              ],
              [
                50.9398188,
                36.2923081
              ],
              [
                50.9411161,
                36.2843989
              ],
              [
                50.9410422,
                36.2826711
              ],
              [
                50.9410295,
                36.282375
              ],
              [
                50.9409749,
                36.2810997
              ],
              [
                50.9412963,
                36.2805097
              ],
              [
                50.9517574,
                36.2780466
              ],
              [
                50.964117,
                36.2729608
              ],
              [
                50.9756049,
                36.267309
              ],
              [
                50.9845088,
                36.2619347
              ],
              [
                50.9946189,
                36.2523003
              ],
              [
                51.0001284,
                36.2485033
              ],
              [
                51.0033416,
                36.2525103
              ],
              [
                51.0080623,
                36.2575629
              ],
              [
                51.0143279,
                36.2629612
              ],
              [
                51.0188769,
                36.2664906
              ],
              [
                51.0230154,
                36.2705634
              ],
              [
                51.0269728,
                36.2728916
              ],
              [
                51.0303914,
                36.2773666
              ],
              [
                51.0325363,
                36.283779
              ],
              [
                51.0341077,
                36.2887275
              ],
              [
                51.034755,
                36.2918138
              ],
              [
                51.0363442,
                36.295746
              ],
              [
                51.0401364,
                36.3051157
              ],
              [
                51.0437246,
                36.3128197
              ],
              [
                51.0456467,
                36.3192563
              ],
              [
                51.0459974,
                36.3250812
              ],
              [
                51.045137,
                36.3313765
              ],
              [
                51.0395736,
                36.3431414
              ],
              [
                51.0345692,
                36.3559343
              ],
              [
                51.0356517,
                36.3581217
              ],
              [
                51.0375277,
                36.3603476
              ],
              [
                51.0387937,
                36.3616799
              ],
              [
                51.0432958,
                36.3641787
              ],
              [
                51.0503767,
                36.3676
              ],
              [
                51.0611914,
                36.3715394
              ],
              [
                51.0679721,
                36.3730942
              ],
              [
                51.0742377,
                36.3740273
              ],
              [
                51.0903738,
                36.3766533
              ],
              [
                51.0987852,
                36.3784501
              ],
              [
                51.1051309,
                36.3791948
              ],
              [
                51.1101794,
                36.3875015
              ],
              [
                51.1126294,
                36.3917275
              ],
              [
                51.1188697,
                36.3978657
              ],
              [
                51.1228179,
                36.4011818
              ],
              [
                51.132325,
                36.4068491
              ],
              [
                51.139189,
                36.4137565
              ],
              [
                51.1427908,
                36.417741
              ],
              [
                51.1439673,
                36.4205817
              ],
              [
                51.1495113,
                36.4280507
              ],
              [
                51.1555194,
                36.4317798
              ],
              [
                51.1628155,
                36.4351347
              ],
              [
                51.1750888,
                36.4445542
              ],
              [
                51.1854743,
                36.454496
              ],
              [
                51.1908816,
                36.4611232
              ],
              [
                51.1945724,
                36.4642295
              ],
              [
                51.200985,
                36.4664962
              ],
              [
                51.2066889,
                36.4684995
              ],
              [
                51.2157703,
                36.472529
              ],
              [
                51.2236303,
                36.4755605
              ],
              [
                51.2266451,
                36.4770999
              ],
              [
                51.2294468,
                36.4793138
              ],
              [
                51.232767,
                36.4908005
              ],
              [
                51.2341403,
                36.4979075
              ],
              [
                51.2320804,
                36.5002534
              ],
              [
                51.2320804,
                36.5097052
              ],
              [
                51.2326812,
                36.5125336
              ],
              [
                51.2346553,
                36.515086
              ],
              [
                51.2427273,
                36.5163918
              ],
              [
                51.2498257,
                36.5166379
              ],
              [
                51.2532947,
                36.517818
              ],
              [
                51.2562464,
                36.5221223
              ],
              [
                51.2528873,
                36.531899
              ],
              [
                51.2530231,
                36.5370882
              ],
              [
                51.2516498,
                36.5438462
              ],
              [
                51.2517299,
                36.5475471
              ],
              [
                51.2556839,
                36.5549129
              ],
              [
                51.257379,
                36.5574295
              ],
              [
                51.2600183,
                36.5607042
              ],
              [
                51.2670089,
                36.5656513
              ],
              [
                51.2743521,
                36.5698039
              ],
              [
                51.2771118,
                36.5720381
              ],
              [
                51.2702053,
                36.5750275
              ],
              [
                51.2552634,
                36.5830919
              ],
              [
                51.2535167,
                36.5840029
              ],
              [
                51.2522077,
                36.5857862
              ],
              [
                51.2516713,
                36.5881466
              ],
              [
                51.2514124,
                36.5912438
              ],
              [
                51.2460285,
                36.5925359
              ],
              [
                51.2408379,
                36.5915159
              ],
              [
                51.2323118,
                36.5894021
              ],
              [
                51.227468,
                36.5879722
              ],
              [
                51.2218022,
                36.5863806
              ],
              [
                51.2180471,
                36.585812
              ],
              [
                51.2146997,
                36.5859671
              ],
              [
                51.2122964,
                36.5872766
              ],
              [
                51.2032413,
                36.5911014
              ],
              [
                51.1963749,
                36.5919284
              ],
              [
                51.185646,
                36.5925141
              ],
              [
                51.1763763,
                36.5898954
              ],
              [
                51.1739329,
                36.5894776
              ],
              [
                51.172117,
                36.588741
              ],
              [
                51.1708939,
                36.5875178
              ],
              [
                51.1690378,
                36.5865874
              ],
              [
                51.1660766,
                36.5836238
              ],
              [
                51.1568069,
                36.5776964
              ],
              [
                51.1491894,
                36.5764385
              ],
              [
                51.1449622,
                36.5748548
              ],
              [
                51.1424302,
                36.5725957
              ],
              [
                51.1392116,
                36.5693386
              ],
              [
                51.137967,
                36.5678221
              ],
              [
                51.1368214,
                36.5640414
              ],
              [
                51.1350077,
                36.5617697
              ],
              [
                51.1281411,
                36.5570815
              ],
              [
                51.1273241,
                36.5539132
              ],
              [
                51.1255645,
                36.5523963
              ],
              [
                51.1228179,
                36.5485351
              ],
              [
                51.1183977,
                36.547225
              ],
              [
                51.1159085,
                36.5458459
              ],
              [
                51.1123466,
                36.5431566
              ],
              [
                51.1001586,
                36.5369503
              ],
              [
                51.0717571,
                36.5172094
              ],
              [
                51.0650708,
                36.5109746
              ],
              [
                51.0502386,
                36.5003999
              ],
              [
                51.0447831,
                36.4959992
              ],
              [
                51.0407638,
                36.4939746
              ],
              [
                51.0360431,
                36.4927326
              ],
              [
                51.0302924,
                36.4923186
              ],
              [
                51.0227393,
                36.4924566
              ],
              [
                51.0151862,
                36.4931466
              ],
              [
                51.0110664,
                36.4945266
              ],
              [
                51.0004531,
                36.4976158
              ],
              [
                51.0000157,
                36.4982007
              ],
              [
                50.9982991,
                36.4986923
              ],
              [
                50.9961614,
                36.4998496
              ],
              [
                50.992881,
                36.5007191
              ],
              [
                50.9877204,
                36.5012883
              ],
              [
                50.9796524,
                36.5053244
              ],
              [
                50.971713,
                36.5082564
              ],
              [
                50.9663057,
                36.5092223
              ],
              [
                50.9611988,
                36.5092913
              ],
              [
                50.9589243,
                36.5098432
              ],
              [
                50.9543323,
                36.5108435
              ],
              [
                50.9478521,
                36.5114298
              ],
              [
                50.9430027,
                36.5130855
              ],
              [
                50.9360933,
                36.5134649
              ],
              [
                50.931158,
                36.5139478
              ],
              [
                50.9266948,
                36.5146376
              ],
              [
                50.9196567,
                36.5156723
              ],
              [
                50.9139061,
                36.5171554
              ],
              [
                50.9118624,
                36.5182875
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555201,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان محمودآباد",
          "name:en": "Mahmudabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282219",
          "wikipedia": "en:Mahmudabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.1424719,
                36.8161792
              ],
              [
                52.1857635,
                36.6160337
              ],
              [
                52.1857637,
                36.6160331
              ],
              [
                52.1863,
                36.6138945
              ],
              [
                52.1865801,
                36.6133361
              ],
              [
                52.1868569,
                36.6113908
              ],
              [
                52.1871334,
                36.6088872
              ],
              [
                52.1871334,
                36.6072212
              ],
              [
                52.1874136,
                36.606942
              ],
              [
                52.1876901,
                36.6011151
              ],
              [
                52.186857,
                36.5930548
              ],
              [
                52.1851903,
                36.5863903
              ],
              [
                52.1846334,
                36.5855528
              ],
              [
                52.1835236,
                36.5805543
              ],
              [
                52.181577,
                36.5763935
              ],
              [
                52.1813002,
                36.5744482
              ],
              [
                52.1807435,
                36.5733314
              ],
              [
                52.1801902,
                36.5683329
              ],
              [
                52.1799103,
                36.5677745
              ],
              [
                52.1799104,
                36.5672251
              ],
              [
                52.1799103,
                36.5652707
              ],
              [
                52.1801902,
                36.5644421
              ],
              [
                52.1826902,
                36.5616682
              ],
              [
                52.1851904,
                36.5602722
              ],
              [
                52.1871335,
                36.5594436
              ],
              [
                52.1929668,
                36.5574982
              ],
              [
                52.1932468,
                36.5572191
              ],
              [
                52.2021332,
                36.5549945
              ],
              [
                52.2032467,
                36.5549945
              ],
              [
                52.2038035,
                36.5547243
              ],
              [
                52.2046366,
                36.5547242
              ],
              [
                52.2057466,
                36.5544451
              ],
              [
                52.20908,
                36.5544451
              ],
              [
                52.2099133,
                36.5541658
              ],
              [
                52.2163033,
                36.5541659
              ],
              [
                52.231303,
                36.5516711
              ],
              [
                52.257136,
                36.5448305
              ],
              [
                52.2690826,
                36.5416648
              ],
              [
                52.2707492,
                36.5408363
              ],
              [
                52.2810242,
                36.5363268
              ],
              [
                52.2821391,
                36.5358375
              ],
              [
                52.2863059,
                36.5344415
              ],
              [
                52.287139,
                36.5344415
              ],
              [
                52.2874157,
                36.5341623
              ],
              [
                52.2890824,
                36.5341623
              ],
              [
                52.289639,
                36.5338921
              ],
              [
                52.301029,
                36.5338922
              ],
              [
                52.3021389,
                36.5341623
              ],
              [
                52.3026956,
                36.5341623
              ],
              [
                52.3107522,
                36.5341623
              ],
              [
                52.3115855,
                36.5344416
              ],
              [
                52.3124189,
                36.5344415
              ],
              [
                52.3263086,
                36.5419441
              ],
              [
                52.327142,
                36.5422233
              ],
              [
                52.3324185,
                36.5486089
              ],
              [
                52.3326953,
                36.5502752
              ],
              [
                52.3329751,
                36.5508335
              ],
              [
                52.3329751,
                36.5519414
              ],
              [
                52.3368653,
                36.5569489
              ],
              [
                52.346585,
                36.5711069
              ],
              [
                52.3488084,
                36.5747185
              ],
              [
                52.3496416,
                36.5763936
              ],
              [
                52.354085,
                36.5763936
              ],
              [
                52.3560317,
                36.5758352
              ],
              [
                52.3568649,
                36.5758352
              ],
              [
                52.3571416,
                36.5755561
              ],
              [
                52.3579749,
                36.575556
              ],
              [
                52.3651983,
                36.5705576
              ],
              [
                52.3657549,
                36.5702784
              ],
              [
                52.3665882,
                36.5680538
              ],
              [
                52.3668649,
                36.5677746
              ],
              [
                52.3668649,
                36.5672252
              ],
              [
                52.3671415,
                36.566946
              ],
              [
                52.3679749,
                36.5647214
              ],
              [
                52.3688081,
                36.5638929
              ],
              [
                52.3693649,
                36.562776
              ],
              [
                52.3721415,
                36.5608307
              ],
              [
                52.3726981,
                36.5608307
              ],
              [
                52.3729747,
                36.5605515
              ],
              [
                52.3779781,
                36.5605516
              ],
              [
                52.3890879,
                36.5652709
              ],
              [
                52.3893645,
                36.5655501
              ],
              [
                52.390478,
                36.5655501
              ],
              [
                52.3915879,
                36.5655501
              ],
              [
                52.3921446,
                36.5652709
              ],
              [
                52.3935345,
                36.5652709
              ],
              [
                52.3982545,
                36.5641721
              ],
              [
                52.3988112,
                36.5641721
              ],
              [
                52.3993678,
                36.5638929
              ],
              [
                52.3999009,
                36.564081
              ],
              [
                52.4019255,
                36.564081
              ],
              [
                52.4068124,
                36.5688305
              ],
              [
                52.4094838,
                36.5712259
              ],
              [
                52.4147088,
                36.5732077
              ],
              [
                52.4180455,
                36.5759132
              ],
              [
                52.4200303,
                36.5805743
              ],
              [
                52.4219306,
                36.5818772
              ],
              [
                52.425278,
                36.5850304
              ],
              [
                52.4298056,
                36.5897168
              ],
              [
                52.4360069,
                36.5938171
              ],
              [
                52.4434411,
                36.5988875
              ],
              [
                52.4471659,
                36.6011669
              ],
              [
                52.4490531,
                36.6039293
              ],
              [
                52.4502977,
                36.6089935
              ],
              [
                52.4508341,
                36.6153319
              ],
              [
                52.4508341,
                36.6236158
              ],
              [
                52.4508343,
                36.6364381
              ],
              [
                52.450907,
                36.6414469
              ],
              [
                52.4515194,
                36.6450791
              ],
              [
                52.4519057,
                36.6455441
              ],
              [
                52.4565061,
                36.6510806
              ],
              [
                52.4625096,
                36.6575784
              ],
              [
                52.4700412,
                36.6671314
              ],
              [
                52.4714965,
                36.6680778
              ],
              [
                52.4753347,
                36.6709245
              ],
              [
                52.4756953,
                36.6734461
              ],
              [
                52.4763692,
                36.6741554
              ],
              [
                52.4770848,
                36.6762306
              ],
              [
                52.4774426,
                36.6763379
              ],
              [
                52.478015,
                36.6767673
              ],
              [
                52.4782297,
                36.6771609
              ],
              [
                52.4784086,
                36.6778049
              ],
              [
                52.4783728,
                36.6797012
              ],
              [
                52.4783223,
                36.6805612
              ],
              [
                52.4791741,
                36.6823231
              ],
              [
                52.479482,
                36.6823847
              ],
              [
                52.4793995,
                36.6827891
              ],
              [
                52.4802034,
                36.6844517
              ],
              [
                52.4810409,
                36.6852801
              ],
              [
                52.4810771,
                36.6854453
              ],
              [
                52.4810479,
                36.6855588
              ],
              [
                52.422036,
                36.8810184
              ],
              [
                52.4174534,
                36.8803319
              ],
              [
                52.3921071,
                36.8763345
              ],
              [
                52.3826259,
                36.8746832
              ],
              [
                52.3732322,
                36.8727362
              ],
              [
                52.3639403,
                36.8704965
              ],
              [
                52.3547645,
                36.8679674
              ],
              [
                52.3496486,
                36.8664158
              ],
              [
                52.3445766,
                36.8647742
              ],
              [
                52.3395507,
                36.8630435
              ],
              [
                52.3377839,
                36.8623977
              ],
              [
                52.3144962,
                36.8570576
              ],
              [
                52.313312,
                36.8567832
              ],
              [
                52.2898152,
                36.8512841
              ],
              [
                52.2818503,
                36.8500852
              ],
              [
                52.27165,
                36.8480939
              ],
              [
                52.2615636,
                36.8457584
              ],
              [
                52.2516091,
                36.8430831
              ],
              [
                52.2430161,
                36.8406091
              ],
              [
                52.2048628,
                36.8326024
              ],
              [
                52.1838444,
                36.8267107
              ],
              [
                52.1786808,
                36.8257403
              ],
              [
                52.1734136,
                36.8246521
              ],
              [
                52.1681775,
                36.8234716
              ],
              [
                52.1629747,
                36.8221993
              ],
              [
                52.1578079,
                36.8208359
              ],
              [
                52.1526795,
                36.819382
              ],
              [
                52.147592,
                36.8178382
              ],
              [
                52.1425478,
                36.8162053
              ],
              [
                52.1424719,
                36.8161792
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555225,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میاندورود",
          "name:en": "Miandorud County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q5249029",
          "wikipedia": "en:Miandorud County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.1125265,
                37.0203478
              ],
              [
                53.1628994,
                36.8248609
              ],
              [
                53.1628994,
                36.8248604
              ],
              [
                53.1630124,
                36.8236022
              ],
              [
                53.1630125,
                36.8233407
              ],
              [
                53.1619025,
                36.8116723
              ],
              [
                53.1621791,
                36.8069545
              ],
              [
                53.1624593,
                36.8047306
              ],
              [
                53.1630125,
                36.8022277
              ],
              [
                53.1621792,
                36.77862
              ],
              [
                53.161626,
                36.7775035
              ],
              [
                53.1585692,
                36.7652852
              ],
              [
                53.1613458,
                36.7594506
              ],
              [
                53.161626,
                36.7588923
              ],
              [
                53.1619025,
                36.7586132
              ],
              [
                53.1641259,
                36.7519502
              ],
              [
                53.1638458,
                36.7469529
              ],
              [
                53.1613459,
                36.7422256
              ],
              [
                53.1574593,
                36.7361207
              ],
              [
                53.157736,
                36.7347251
              ],
              [
                53.1580126,
                36.7341667
              ],
              [
                53.1613459,
                36.7291693
              ],
              [
                53.161626,
                36.7280617
              ],
              [
                53.1599594,
                36.7194534
              ],
              [
                53.1585692,
                36.7180578
              ],
              [
                53.1582925,
                36.7172203
              ],
              [
                53.1464418,
                36.7061176
              ],
              [
                53.145236,
                36.705001
              ],
              [
                53.1441227,
                36.7041726
              ],
              [
                53.1391193,
                36.6991652
              ],
              [
                53.1388462,
                36.6988958
              ],
              [
                53.1374562,
                36.6958342
              ],
              [
                53.1463461,
                36.690008
              ],
              [
                53.1557927,
                36.6822278
              ],
              [
                53.1560693,
                36.6813903
              ],
              [
                53.1605125,
                36.6738892
              ],
              [
                53.1616616,
                36.6677617
              ],
              [
                53.1621792,
                36.665001
              ],
              [
                53.1624593,
                36.6611197
              ],
              [
                53.1627359,
                36.6600032
              ],
              [
                53.1605126,
                36.6483323
              ],
              [
                53.1605126,
                36.6441718
              ],
              [
                53.161626,
                36.6402814
              ],
              [
                53.1616261,
                36.6397231
              ],
              [
                53.1644026,
                36.6352743
              ],
              [
                53.1660109,
                36.6330411
              ],
              [
                53.1707972,
                36.6263948
              ],
              [
                53.1744024,
                36.6213877
              ],
              [
                53.1746826,
                36.6200008
              ],
              [
                53.1739105,
                36.6150811
              ],
              [
                53.168016,
                36.5775018
              ],
              [
                53.1694025,
                36.5738902
              ],
              [
                53.1755159,
                36.5669464
              ],
              [
                53.1757925,
                36.5666672
              ],
              [
                53.1763492,
                36.5658296
              ],
              [
                53.2032922,
                36.5466639
              ],
              [
                53.2319051,
                36.5350003
              ],
              [
                53.243575,
                36.5250029
              ],
              [
                53.2474617,
                36.5166716
              ],
              [
                53.2477418,
                36.5155547
              ],
              [
                53.2480183,
                36.5147261
              ],
              [
                53.245795,
                36.496667
              ],
              [
                53.2460751,
                36.4944422
              ],
              [
                53.2463517,
                36.4919383
              ],
              [
                53.2466284,
                36.4874977
              ],
              [
                53.2469085,
                36.4844442
              ],
              [
                53.247185,
                36.4830571
              ],
              [
                53.2474617,
                36.4816701
              ],
              [
                53.2502416,
                36.4749956
              ],
              [
                53.2526973,
                36.4728014
              ],
              [
                53.2530184,
                36.4725005
              ],
              [
                53.2571849,
                36.4697172
              ],
              [
                53.2666316,
                36.4624934
              ],
              [
                53.2774648,
                36.4572239
              ],
              [
                53.278298,
                36.4569446
              ],
              [
                53.3038544,
                36.4474956
              ],
              [
                53.3063545,
                36.4461085
              ],
              [
                53.3107976,
                36.44083
              ],
              [
                53.3110778,
                36.4380556
              ],
              [
                53.3113543,
                36.4377764
              ],
              [
                53.3094111,
                36.4316601
              ],
              [
                53.3066737,
                36.4273252
              ],
              [
                53.3060778,
                36.4263815
              ],
              [
                53.2966312,
                36.4177699
              ],
              [
                53.2963546,
                36.4174906
              ],
              [
                53.2857079,
                36.4096305
              ],
              [
                53.287188,
                36.4088879
              ],
              [
                53.2880214,
                36.4088879
              ],
              [
                53.289688,
                36.4083294
              ],
              [
                53.2910746,
                36.4083294
              ],
              [
                53.2994112,
                36.4063837
              ],
              [
                53.3019112,
                36.4063837
              ],
              [
                53.3024645,
                36.4061134
              ],
              [
                53.3049644,
                36.4061135
              ],
              [
                53.3055211,
                36.4058342
              ],
              [
                53.3077444,
                36.4058342
              ],
              [
                53.3082977,
                36.405546
              ],
              [
                53.3119111,
                36.4055459
              ],
              [
                53.3124643,
                36.4052666
              ],
              [
                53.3132976,
                36.4052667
              ],
              [
                53.3138543,
                36.4049964
              ],
              [
                53.3149643,
                36.4049964
              ],
              [
                53.3166309,
                36.4044379
              ],
              [
                53.3177443,
                36.4044379
              ],
              [
                53.3185777,
                36.4041587
              ],
              [
                53.3196876,
                36.4041587
              ],
              [
                53.3202442,
                36.4038795
              ],
              [
                53.3255209,
                36.4033299
              ],
              [
                53.3291342,
                36.40333
              ],
              [
                53.3299675,
                36.4036092
              ],
              [
                53.3310775,
                36.4036091
              ],
              [
                53.3316343,
                36.4033299
              ],
              [
                53.3327441,
                36.4036091
              ],
              [
                53.3449674,
                36.404438
              ],
              [
                53.3510772,
                36.404438
              ],
              [
                53.351634,
                36.4047172
              ],
              [
                53.3585806,
                36.4047172
              ],
              [
                53.3599671,
                36.4049964
              ],
              [
                53.3627472,
                36.4049964
              ],
              [
                53.3635805,
                36.4052667
              ],
              [
                53.3646905,
                36.4052667
              ],
              [
                53.3719137,
                36.4061134
              ],
              [
                53.3766371,
                36.4066629
              ],
              [
                53.377747,
                36.4069422
              ],
              [
                53.380247,
                36.4069422
              ],
              [
                53.3810803,
                36.4072214
              ],
              [
                53.3833036,
                36.4072214
              ],
              [
                53.3838569,
                36.4075007
              ],
              [
                53.3874702,
                36.4075007
              ],
              [
                53.3885802,
                36.4077709
              ],
              [
                53.3916368,
                36.4077709
              ],
              [
                53.3921901,
                36.4080501
              ],
              [
                53.3933035,
                36.4080502
              ],
              [
                53.3944134,
                36.4083294
              ],
              [
                53.3971935,
                36.4083295
              ],
              [
                53.3974701,
                36.4086087
              ],
              [
                53.39858,
                36.4086087
              ],
              [
                53.3994134,
                36.408888
              ],
              [
                53.40136,
                36.4088879
              ],
              [
                53.4019134,
                36.4091672
              ],
              [
                53.4027466,
                36.4091672
              ],
              [
                53.4052467,
                36.4097167
              ],
              [
                53.4069132,
                36.4097167
              ],
              [
                53.4077466,
                36.409996
              ],
              [
                53.4091366,
                36.4099959
              ],
              [
                53.4099698,
                36.4102752
              ],
              [
                53.4116366,
                36.4102752
              ],
              [
                53.4119167,
                36.4105544
              ],
              [
                53.4135832,
                36.4105544
              ],
              [
                53.4512891,
                36.4165208
              ],
              [
                53.4526022,
                36.4257179
              ],
              [
                53.4478789,
                36.437663
              ],
              [
                53.4237271,
                36.4601818
              ],
              [
                53.418724,
                36.4670878
              ],
              [
                53.4142626,
                36.4726057
              ],
              [
                53.4142626,
                36.4728759
              ],
              [
                53.4144645,
                36.4732332
              ],
              [
                53.4131527,
                36.4742722
              ],
              [
                53.4021799,
                36.4901571
              ],
              [
                53.3957841,
                36.4945835
              ],
              [
                53.3932907,
                36.498329
              ],
              [
                53.3908375,
                36.500706
              ],
              [
                53.3835308,
                36.508186
              ],
              [
                53.375791,
                36.5129215
              ],
              [
                53.3653343,
                36.5224633
              ],
              [
                53.362765,
                36.5237522
              ],
              [
                53.3608818,
                36.5251145
              ],
              [
                53.3579206,
                36.5272682
              ],
              [
                53.349964,
                36.5265336
              ],
              [
                53.3469711,
                36.5263166
              ],
              [
                53.34323,
                36.5271743
              ],
              [
                53.3385827,
                36.5270379
              ],
              [
                53.3318085,
                36.5293318
              ],
              [
                53.3290854,
                36.5332724
              ],
              [
                53.3252892,
                36.5350701
              ],
              [
                53.3172211,
                36.5387822
              ],
              [
                53.3149011,
                36.5411164
              ],
              [
                53.3108849,
                36.5434305
              ],
              [
                53.3103372,
                36.5503854
              ],
              [
                53.310885,
                36.5566032
              ],
              [
                53.3122719,
                36.5584812
              ],
              [
                53.3137567,
                36.5611194
              ],
              [
                53.3151964,
                36.5622036
              ],
              [
                53.3155958,
                36.5642087
              ],
              [
                53.307228,
                36.5730606
              ],
              [
                53.3073002,
                36.5743813
              ],
              [
                53.3064454,
                36.575375
              ],
              [
                53.302666,
                36.5785907
              ],
              [
                53.3003264,
                36.5801805
              ],
              [
                53.2958258,
                36.5821394
              ],
              [
                53.2941624,
                36.5838476
              ],
              [
                53.2909567,
                36.5863765
              ],
              [
                53.2893257,
                36.5874603
              ],
              [
                53.2865248,
                36.5886074
              ],
              [
                53.2853888,
                36.5898989
              ],
              [
                53.2825517,
                36.591388
              ],
              [
                53.2805746,
                36.5915064
              ],
              [
                53.2787749,
                36.5934391
              ],
              [
                53.2773708,
                36.595016
              ],
              [
                53.2731732,
                36.6033184
              ],
              [
                53.2642709,
                36.6161232
              ],
              [
                53.2590455,
                36.620726
              ],
              [
                53.2545546,
                36.6214168
              ],
              [
                53.2534665,
                36.6218635
              ],
              [
                53.2529041,
                36.6222968
              ],
              [
                53.2521369,
                36.6231713
              ],
              [
                53.2511352,
                36.6247579
              ],
              [
                53.2499296,
                36.626526
              ],
              [
                53.249441,
                36.6278924
              ],
              [
                53.2457066,
                36.634137
              ],
              [
                53.2454299,
                36.6346954
              ],
              [
                53.2454299,
                36.6349746
              ],
              [
                53.2454299,
                36.6350204
              ],
              [
                53.24543,
                36.6358031
              ],
              [
                53.2281723,
                36.6469248
              ],
              [
                53.2318589,
                36.6545616
              ],
              [
                53.2332489,
                36.6562275
              ],
              [
                53.2335256,
                36.6565067
              ],
              [
                53.2549446,
                36.6690901
              ],
              [
                53.2559967,
                36.6738854
              ],
              [
                53.2580349,
                36.6800734
              ],
              [
                53.258035,
                36.6803525
              ],
              [
                53.2566448,
                36.6850807
              ],
              [
                53.2560882,
                36.688683
              ],
              [
                53.2558116,
                36.6903581
              ],
              [
                53.255535,
                36.6928616
              ],
              [
                53.2552549,
                36.6942486
              ],
              [
                53.2450218,
                36.7008762
              ],
              [
                53.2447452,
                36.7028212
              ],
              [
                53.2444651,
                36.7042081
              ],
              [
                53.2441885,
                36.7053156
              ],
              [
                53.2426409,
                36.7117028
              ],
              [
                53.2405919,
                36.7219224
              ],
              [
                53.2403154,
                36.7227507
              ],
              [
                53.2400386,
                36.7238673
              ],
              [
                53.2397586,
                36.7252539
              ],
              [
                53.239482,
                36.7260823
              ],
              [
                53.2367055,
                36.7316468
              ],
              [
                53.2364254,
                36.732196
              ],
              [
                53.2454104,
                36.7452422
              ],
              [
                53.2398819,
                36.7630634
              ],
              [
                53.2349392,
                36.7779427
              ],
              [
                53.2226311,
                36.7952664
              ],
              [
                53.2134477,
                36.8358867
              ],
              [
                53.1868707,
                37.0402602
              ],
              [
                53.1816532,
                37.038988
              ],
              [
                53.1764718,
                37.0376246
              ],
              [
                53.1713289,
                37.0361706
              ],
              [
                53.166227,
                37.0346269
              ],
              [
                53.1611685,
                37.0329941
              ],
              [
                53.1561559,
                37.031273
              ],
              [
                53.1511915,
                37.0294644
              ],
              [
                53.1462778,
                37.0275692
              ],
              [
                53.1417385,
                37.0257193
              ],
              [
                53.1395597,
                37.0254394
              ],
              [
                53.1327375,
                37.0243935
              ],
              [
                53.1259544,
                37.0231957
              ],
              [
                53.1192157,
                37.0218468
              ],
              [
                53.1125265,
                37.0203478
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555237,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نکا",
          "name:en": "Neka County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282190",
          "wikipedia": "en:Neka County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.1868707,
                37.0402602
              ],
              [
                53.2134477,
                36.8358867
              ],
              [
                53.2226311,
                36.7952664
              ],
              [
                53.2349392,
                36.7779427
              ],
              [
                53.2398819,
                36.7630634
              ],
              [
                53.2454104,
                36.7452422
              ],
              [
                53.2364254,
                36.732196
              ],
              [
                53.2367055,
                36.7316468
              ],
              [
                53.239482,
                36.7260823
              ],
              [
                53.2397586,
                36.7252539
              ],
              [
                53.2400386,
                36.7238673
              ],
              [
                53.2403154,
                36.7227507
              ],
              [
                53.2405919,
                36.7219224
              ],
              [
                53.2426409,
                36.7117028
              ],
              [
                53.2441885,
                36.7053156
              ],
              [
                53.2444651,
                36.7042081
              ],
              [
                53.2447452,
                36.7028212
              ],
              [
                53.2450218,
                36.7008762
              ],
              [
                53.2552549,
                36.6942486
              ],
              [
                53.255535,
                36.6928616
              ],
              [
                53.2558116,
                36.6903581
              ],
              [
                53.2560882,
                36.688683
              ],
              [
                53.2566448,
                36.6850807
              ],
              [
                53.258035,
                36.6803525
              ],
              [
                53.2580349,
                36.6800734
              ],
              [
                53.2559967,
                36.6738854
              ],
              [
                53.2549446,
                36.6690901
              ],
              [
                53.2335256,
                36.6565067
              ],
              [
                53.2332489,
                36.6562275
              ],
              [
                53.2318589,
                36.6545616
              ],
              [
                53.2281723,
                36.6469248
              ],
              [
                53.24543,
                36.6358031
              ],
              [
                53.2454299,
                36.6350204
              ],
              [
                53.2454299,
                36.6349746
              ],
              [
                53.2454299,
                36.6346954
              ],
              [
                53.2457066,
                36.634137
              ],
              [
                53.249441,
                36.6278924
              ],
              [
                53.2499296,
                36.626526
              ],
              [
                53.2511352,
                36.6247579
              ],
              [
                53.2521369,
                36.6231713
              ],
              [
                53.2529041,
                36.6222968
              ],
              [
                53.2534665,
                36.6218635
              ],
              [
                53.2545546,
                36.6214168
              ],
              [
                53.2590455,
                36.620726
              ],
              [
                53.2642709,
                36.6161232
              ],
              [
                53.2731732,
                36.6033184
              ],
              [
                53.2773708,
                36.595016
              ],
              [
                53.2787749,
                36.5934391
              ],
              [
                53.2805746,
                36.5915064
              ],
              [
                53.2825517,
                36.591388
              ],
              [
                53.2853888,
                36.5898989
              ],
              [
                53.2865248,
                36.5886074
              ],
              [
                53.2893257,
                36.5874603
              ],
              [
                53.2909567,
                36.5863765
              ],
              [
                53.2941624,
                36.5838476
              ],
              [
                53.2958258,
                36.5821394
              ],
              [
                53.3003264,
                36.5801805
              ],
              [
                53.302666,
                36.5785907
              ],
              [
                53.3064454,
                36.575375
              ],
              [
                53.3073002,
                36.5743813
              ],
              [
                53.307228,
                36.5730606
              ],
              [
                53.3155958,
                36.5642087
              ],
              [
                53.3151964,
                36.5622036
              ],
              [
                53.3137567,
                36.5611194
              ],
              [
                53.3122719,
                36.5584812
              ],
              [
                53.310885,
                36.5566032
              ],
              [
                53.3103372,
                36.5503854
              ],
              [
                53.3108849,
                36.5434305
              ],
              [
                53.3149011,
                36.5411164
              ],
              [
                53.3172211,
                36.5387822
              ],
              [
                53.3252892,
                36.5350701
              ],
              [
                53.3290854,
                36.5332724
              ],
              [
                53.3318085,
                36.5293318
              ],
              [
                53.3385827,
                36.5270379
              ],
              [
                53.34323,
                36.5271743
              ],
              [
                53.3469711,
                36.5263166
              ],
              [
                53.349964,
                36.5265336
              ],
              [
                53.3579206,
                36.5272682
              ],
              [
                53.3608818,
                36.5251145
              ],
              [
                53.362765,
                36.5237522
              ],
              [
                53.3653343,
                36.5224633
              ],
              [
                53.375791,
                36.5129215
              ],
              [
                53.3835308,
                36.508186
              ],
              [
                53.3908375,
                36.500706
              ],
              [
                53.3932907,
                36.498329
              ],
              [
                53.3957841,
                36.4945835
              ],
              [
                53.4021799,
                36.4901571
              ],
              [
                53.4131527,
                36.4742722
              ],
              [
                53.4144645,
                36.4732332
              ],
              [
                53.4142626,
                36.4728759
              ],
              [
                53.4142626,
                36.4726057
              ],
              [
                53.418724,
                36.4670878
              ],
              [
                53.4237271,
                36.4601818
              ],
              [
                53.4478789,
                36.437663
              ],
              [
                53.4526022,
                36.4257179
              ],
              [
                53.4512891,
                36.4165208
              ],
              [
                53.4515658,
                36.4165208
              ],
              [
                53.4518457,
                36.4165208
              ],
              [
                53.4526791,
                36.4168
              ],
              [
                53.4537891,
                36.4168
              ],
              [
                53.4643277,
                36.4129291
              ],
              [
                53.4751609,
                36.4057134
              ],
              [
                53.4762709,
                36.404317
              ],
              [
                53.4810858,
                36.3969431
              ],
              [
                53.4855241,
                36.390277
              ],
              [
                53.4894107,
                36.3824938
              ],
              [
                53.4977522,
                36.3713864
              ],
              [
                53.5016423,
                36.3688821
              ],
              [
                53.5152655,
                36.343122
              ],
              [
                53.5284324,
                36.3316013
              ],
              [
                53.5292657,
                36.3310425
              ],
              [
                53.5298223,
                36.3310425
              ],
              [
                53.5301876,
                36.3309393
              ],
              [
                53.5848648,
                36.3101088
              ],
              [
                53.6328273,
                36.3233602
              ],
              [
                53.6356039,
                36.3233602
              ],
              [
                53.6367173,
                36.3230898
              ],
              [
                53.6508138,
                36.3299914
              ],
              [
                53.6538705,
                36.3299913
              ],
              [
                53.6552606,
                36.3297121
              ],
              [
                53.6576938,
                36.3331694
              ],
              [
                53.6588072,
                36.3328902
              ],
              [
                53.6599172,
                36.3331694
              ],
              [
                53.665892,
                36.3369031
              ],
              [
                53.6664454,
                36.3371823
              ],
              [
                53.668392,
                36.3371822
              ],
              [
                53.6686686,
                36.3374615
              ],
              [
                53.669502,
                36.3374616
              ],
              [
                53.6700586,
                36.3377409
              ],
              [
                53.6855402,
                36.3372166
              ],
              [
                53.6860935,
                36.3377751
              ],
              [
                53.7027883,
                36.3419512
              ],
              [
                53.7196329,
                36.3405889
              ],
              [
                53.7204662,
                36.3411475
              ],
              [
                53.7293561,
                36.346148
              ],
              [
                53.7341198,
                36.3455322
              ],
              [
                53.7643431,
                36.3466558
              ],
              [
                53.7901889,
                36.3570913
              ],
              [
                53.7912988,
                36.3570912
              ],
              [
                53.7915756,
                36.3573706
              ],
              [
                53.7924088,
                36.3573706
              ],
              [
                53.7993555,
                36.3595876
              ],
              [
                53.7999121,
                36.3598669
              ],
              [
                53.8057454,
                36.3612547
              ],
              [
                53.8082454,
                36.3612547
              ],
              [
                53.8090787,
                36.3615341
              ],
              [
                53.8101887,
                36.3615341
              ],
              [
                53.811022,
                36.3612547
              ],
              [
                53.812412,
                36.3612547
              ],
              [
                53.8126887,
                36.3609843
              ],
              [
                53.8307348,
                36.3734103
              ],
              [
                53.8318482,
                36.3734103
              ],
              [
                53.8324014,
                36.37314
              ],
              [
                53.8332347,
                36.37314
              ],
              [
                53.8335148,
                36.3728608
              ],
              [
                53.8343482,
                36.3728608
              ],
              [
                53.8451472,
                36.377075
              ],
              [
                53.8493716,
                36.3759982
              ],
              [
                53.8620184,
                36.3825962
              ],
              [
                53.8704298,
                36.3827344
              ],
              [
                53.8853643,
                36.3976585
              ],
              [
                53.9126928,
                36.4032289
              ],
              [
                53.966047,
                36.4027308
              ],
              [
                53.9763235,
                36.4049569
              ],
              [
                53.9777134,
                36.4049569
              ],
              [
                53.9788235,
                36.4052272
              ],
              [
                53.9796568,
                36.4049568
              ],
              [
                53.9832667,
                36.4049569
              ],
              [
                53.9838234,
                36.4046775
              ],
              [
                53.9871567,
                36.4046775
              ],
              [
                53.9924609,
                36.4043407
              ],
              [
                54.005427,
                36.4027964
              ],
              [
                54.0236202,
                36.4134109
              ],
              [
                54.0252027,
                36.413507
              ],
              [
                54.033536,
                36.4162916
              ],
              [
                54.0432125,
                36.4442003
              ],
              [
                54.0437658,
                36.4444795
              ],
              [
                54.0444564,
                36.4446138
              ],
              [
                54.0444565,
                36.4449122
              ],
              [
                54.0323154,
                36.4557169
              ],
              [
                54.0274255,
                36.4591799
              ],
              [
                54.024047,
                36.4622869
              ],
              [
                54.0238642,
                36.4625829
              ],
              [
                54.0237579,
                36.4631371
              ],
              [
                54.0141097,
                36.4699324
              ],
              [
                54.0117363,
                36.4705488
              ],
              [
                54.0017364,
                36.4747192
              ],
              [
                54.000903,
                36.4747191
              ],
              [
                53.9699969,
                36.4833364
              ],
              [
                53.9652736,
                36.4844443
              ],
              [
                53.9641637,
                36.4844444
              ],
              [
                53.9633303,
                36.4847236
              ],
              [
                53.9619404,
                36.4847236
              ],
              [
                53.9613872,
                36.4850028
              ],
              [
                53.9555504,
                36.4850028
              ],
              [
                53.9538838,
                36.4850028
              ],
              [
                53.9519405,
                36.4850028
              ],
              [
                53.9513838,
                36.4847236
              ],
              [
                53.9480505,
                36.4847236
              ],
              [
                53.9472172,
                36.4844444
              ],
              [
                53.9458306,
                36.4844443
              ],
              [
                53.9447171,
                36.4841651
              ],
              [
                53.9433306,
                36.4841651
              ],
              [
                53.9424974,
                36.4838859
              ],
              [
                53.9355507,
                36.483886
              ],
              [
                53.933884,
                36.4836156
              ],
              [
                53.929994,
                36.4836157
              ],
              [
                53.9294408,
                36.4833364
              ],
              [
                53.9269408,
                36.4833365
              ],
              [
                53.9263842,
                36.4830572
              ],
              [
                53.9244408,
                36.4830572
              ],
              [
                53.9238841,
                36.482778
              ],
              [
                53.9219409,
                36.482778
              ],
              [
                53.9208275,
                36.4824988
              ],
              [
                53.9194375,
                36.4824988
              ],
              [
                53.9186041,
                36.4822195
              ],
              [
                53.9169375,
                36.4822195
              ],
              [
                53.9158276,
                36.4819403
              ],
              [
                53.9131939,
                36.4819403
              ],
              [
                53.9127709,
                36.4819403
              ],
              [
                53.910551,
                36.4816701
              ],
              [
                53.9097177,
                36.4813909
              ],
              [
                53.9086043,
                36.4813909
              ],
              [
                53.9080511,
                36.4811116
              ],
              [
                53.9072177,
                36.4811117
              ],
              [
                53.906661,
                36.4808324
              ],
              [
                53.9049944,
                36.4808325
              ],
              [
                53.904161,
                36.4805533
              ],
              [
                53.9019377,
                36.4805532
              ],
              [
                53.9016611,
                36.4808324
              ],
              [
                53.8999945,
                36.4808324
              ],
              [
                53.899161,
                36.4811116
              ],
              [
                53.8983278,
                36.4811117
              ],
              [
                53.8977711,
                36.481391
              ],
              [
                53.8963811,
                36.4813909
              ],
              [
                53.8958279,
                36.4816701
              ],
              [
                53.8927711,
                36.4816701
              ],
              [
                53.8919378,
                36.4819404
              ],
              [
                53.8886045,
                36.4819403
              ],
              [
                53.8844379,
                36.482778
              ],
              [
                53.8822146,
                36.4836156
              ],
              [
                53.8763814,
                36.4869393
              ],
              [
                53.8644382,
                36.4919383
              ],
              [
                53.8636014,
                36.4919383
              ],
              [
                53.8630482,
                36.4922175
              ],
              [
                53.8599916,
                36.4922176
              ],
              [
                53.8549916,
                36.4905512
              ],
              [
                53.848325,
                36.4863809
              ],
              [
                53.8477683,
                36.4863809
              ],
              [
                53.8447117,
                36.4833365
              ],
              [
                53.8441583,
                36.4822196
              ],
              [
                53.8411017,
                36.4797245
              ],
              [
                53.8399918,
                36.4794453
              ],
              [
                53.8380451,
                36.4788868
              ],
              [
                53.8363785,
                36.4788868
              ],
              [
                53.8355452,
                36.4786076
              ],
              [
                53.8338785,
                36.4786075
              ],
              [
                53.8283386,
                36.4761426
              ],
              [
                53.8280619,
                36.4769713
              ],
              [
                53.826672,
                36.4780883
              ],
              [
                53.8083016,
                36.4770626
              ],
              [
                53.8069149,
                36.4770626
              ],
              [
                53.801915,
                36.4759544
              ],
              [
                53.801635,
                36.4756751
              ],
              [
                53.800525,
                36.4756752
              ],
              [
                53.7988583,
                36.4751165
              ],
              [
                53.7977485,
                36.4751165
              ],
              [
                53.796635,
                36.474558
              ],
              [
                53.7941351,
                36.4742876
              ],
              [
                53.7938584,
                36.4740085
              ],
              [
                53.7916351,
                36.4740084
              ],
              [
                53.7908018,
                36.4737291
              ],
              [
                53.7528261,
                36.4745573
              ],
              [
                53.7519928,
                36.4748366
              ],
              [
                53.7447695,
                36.4748366
              ],
              [
                53.7442163,
                36.475116
              ],
              [
                53.7431029,
                36.4751159
              ],
              [
                53.7428261,
                36.4753862
              ],
              [
                53.7414362,
                36.4753862
              ],
              [
                53.7411596,
                36.4756655
              ],
              [
                53.7397696,
                36.4756655
              ],
              [
                53.736993,
                36.4765033
              ],
              [
                53.7342164,
                36.4765034
              ],
              [
                53.7336597,
                36.4767826
              ],
              [
                53.7325497,
                36.4767826
              ],
              [
                53.7297697,
                36.4776114
              ],
              [
                53.7278264,
                36.4792781
              ],
              [
                53.7275498,
                36.4795574
              ],
              [
                53.7275498,
                36.4798368
              ],
              [
                53.7264364,
                36.4815035
              ],
              [
                53.7114712,
                36.4963898
              ],
              [
                53.7125012,
                36.5129477
              ],
              [
                53.7296097,
                36.5227351
              ],
              [
                53.7286374,
                36.5328126
              ],
              [
                53.7038533,
                36.5439171
              ],
              [
                53.669671,
                36.5595838
              ],
              [
                53.6691176,
                36.5607009
              ],
              [
                53.6674511,
                36.5609711
              ],
              [
                53.6167337,
                36.5877978
              ],
              [
                53.6159727,
                36.5897363
              ],
              [
                53.610819,
                36.5955525
              ],
              [
                53.609038,
                36.5951531
              ],
              [
                53.6094491,
                36.592861
              ],
              [
                53.608075,
                36.591221
              ],
              [
                53.606033,
                36.590408
              ],
              [
                53.6053376,
                36.5915742
              ],
              [
                53.6038641,
                36.592116
              ],
              [
                53.6032547,
                36.5925534
              ],
              [
                53.6034198,
                36.5935249
              ],
              [
                53.6032623,
                36.5943061
              ],
              [
                53.6024185,
                36.5946305
              ],
              [
                53.6013839,
                36.5938003
              ],
              [
                53.5993001,
                36.5935574
              ],
              [
                53.5985381,
                36.5932314
              ],
              [
                53.5978632,
                36.5914703
              ],
              [
                53.5963559,
                36.5908201
              ],
              [
                53.5955798,
                36.5916961
              ],
              [
                53.5958723,
                36.5925992
              ],
              [
                53.5950287,
                36.593123
              ],
              [
                53.5940276,
                36.5926895
              ],
              [
                53.5934652,
                36.5938139
              ],
              [
                53.5922757,
                36.5952904
              ],
              [
                53.5911255,
                36.59576
              ],
              [
                53.5902257,
                36.5966721
              ],
              [
                53.5895227,
                36.5976881
              ],
              [
                53.5875205,
                36.5983518
              ],
              [
                53.5867725,
                36.5999231
              ],
              [
                53.5855014,
                36.599896
              ],
              [
                53.5844666,
                36.6004784
              ],
              [
                53.5827344,
                36.6010519
              ],
              [
                53.5818683,
                36.6021671
              ],
              [
                53.5801473,
                36.6024921
              ],
              [
                53.5788397,
                36.6039708
              ],
              [
                53.5781142,
                36.6043388
              ],
              [
                53.5765816,
                36.6046051
              ],
              [
                53.5753668,
                36.6052869
              ],
              [
                53.574242,
                36.6064607
              ],
              [
                53.5729822,
                36.6068806
              ],
              [
                53.5707978,
                36.6065218
              ],
              [
                53.5685504,
                36.6045103
              ],
              [
                53.5671557,
                36.6037879
              ],
              [
                53.5645236,
                36.6022529
              ],
              [
                53.5631963,
                36.6009435
              ],
              [
                53.5619262,
                36.6005391
              ],
              [
                53.560508,
                36.5984011
              ],
              [
                53.5591228,
                36.5977547
              ],
              [
                53.5549401,
                36.5968527
              ],
              [
                53.552578,
                36.5964373
              ],
              [
                53.5503059,
                36.5953356
              ],
              [
                53.5474714,
                36.5943061
              ],
              [
                53.5462565,
                36.5928611
              ],
              [
                53.5450769,
                36.5899052
              ],
              [
                53.5455858,
                36.5886167
              ],
              [
                53.5452667,
                36.5876049
              ],
              [
                53.5442994,
                36.586232
              ],
              [
                53.5442878,
                36.5842613
              ],
              [
                53.5434544,
                36.5832447
              ],
              [
                53.5417657,
                36.5827327
              ],
              [
                53.5415098,
                36.5812553
              ],
              [
                53.5419485,
                36.5804604
              ],
              [
                53.5415436,
                36.5796746
              ],
              [
                53.5395639,
                36.5791598
              ],
              [
                53.5337036,
                36.5787262
              ],
              [
                53.5304697,
                36.5778139
              ],
              [
                53.5282089,
                36.5765312
              ],
              [
                53.5266426,
                36.5755613
              ],
              [
                53.5253743,
                36.5744897
              ],
              [
                53.5243957,
                36.5745123
              ],
              [
                53.5232147,
                36.576075
              ],
              [
                53.5229447,
                36.5770416
              ],
              [
                53.5219211,
                36.5779042
              ],
              [
                53.5195084,
                36.5758108
              ],
              [
                53.5185129,
                36.5753388
              ],
              [
                53.5171069,
                36.5757611
              ],
              [
                53.5160749,
                36.5761337
              ],
              [
                53.5168088,
                36.5778048
              ],
              [
                53.5149416,
                36.5771477
              ],
              [
                53.5131033,
                36.5773363
              ],
              [
                53.5116037,
                36.5787036
              ],
              [
                53.5114547,
                36.5797062
              ],
              [
                53.509745,
                36.5799411
              ],
              [
                53.5080606,
                36.579424
              ],
              [
                53.5087214,
                36.5808511
              ],
              [
                53.5085611,
                36.5815014
              ],
              [
                53.5077091,
                36.5819689
              ],
              [
                53.5066096,
                36.5820885
              ],
              [
                53.5065688,
                36.5827366
              ],
              [
                53.5064113,
                36.583532
              ],
              [
                53.5050018,
                36.5836596
              ],
              [
                53.5041314,
                36.5834308
              ],
              [
                53.5022777,
                36.5831722
              ],
              [
                53.501454,
                36.582445
              ],
              [
                53.5007666,
                36.582112
              ],
              [
                53.4993091,
                36.5826885
              ],
              [
                53.4985586,
                36.5841366
              ],
              [
                53.4968152,
                36.584814
              ],
              [
                53.4959547,
                36.585488
              ],
              [
                53.4942787,
                36.5857624
              ],
              [
                53.4923778,
                36.5862004
              ],
              [
                53.4903548,
                36.5861537
              ],
              [
                53.4899144,
                36.5872075
              ],
              [
                53.489262,
                36.5898086
              ],
              [
                53.4894982,
                36.5921025
              ],
              [
                53.4929852,
                36.5940893
              ],
              [
                53.4949424,
                36.5963109
              ],
              [
                53.4975977,
                36.599386
              ],
              [
                53.4981593,
                36.601386
              ],
              [
                53.4981143,
                36.6037699
              ],
              [
                53.4984518,
                36.6069483
              ],
              [
                53.4976644,
                36.6082305
              ],
              [
                53.4982943,
                36.6107406
              ],
              [
                53.4989692,
                36.6129075
              ],
              [
                53.4988061,
                36.6161758
              ],
              [
                53.4962921,
                36.6183606
              ],
              [
                53.4925586,
                36.6210131
              ],
              [
                53.4887784,
                36.6222607
              ],
              [
                53.4851789,
                36.6248245
              ],
              [
                53.4823669,
                36.6283631
              ],
              [
                53.4784075,
                36.6323348
              ],
              [
                53.4726777,
                36.6334657
              ],
              [
                53.4672748,
                36.6334789
              ],
              [
                53.4620886,
                36.6306641
              ],
              [
                53.4567626,
                36.6265118
              ],
              [
                53.4530662,
                36.6235925
              ],
              [
                53.4495897,
                36.6241565
              ],
              [
                53.4460353,
                36.6264494
              ],
              [
                53.4433582,
                36.6304393
              ],
              [
                53.4374416,
                36.6353135
              ],
              [
                53.4324586,
                36.6362127
              ],
              [
                53.4172052,
                36.6328149
              ],
              [
                53.4102548,
                36.6331382
              ],
              [
                53.4036971,
                36.6342665
              ],
              [
                53.3973531,
                36.6348442
              ],
              [
                53.3902114,
                36.6334934
              ],
              [
                53.3851262,
                36.6338803
              ],
              [
                53.3853629,
                36.642354
              ],
              [
                53.3855603,
                36.6447847
              ],
              [
                53.3866899,
                36.6530749
              ],
              [
                53.3879673,
                36.6593593
              ],
              [
                53.3887254,
                36.6646875
              ],
              [
                53.3889404,
                36.6665683
              ],
              [
                53.3891586,
                36.6695314
              ],
              [
                53.3886761,
                36.6706465
              ],
              [
                53.3874019,
                36.6768247
              ],
              [
                53.3866024,
                36.6798464
              ],
              [
                53.3867311,
                36.6827718
              ],
              [
                53.3878196,
                36.6868458
              ],
              [
                53.3872695,
                36.6901179
              ],
              [
                53.3853185,
                36.6942677
              ],
              [
                53.3829116,
                36.698292
              ],
              [
                53.3814525,
                36.7019737
              ],
              [
                53.3828244,
                36.7054606
              ],
              [
                53.3814413,
                36.7081237
              ],
              [
                53.3747107,
                36.715744
              ],
              [
                53.3656203,
                36.7252647
              ],
              [
                53.3499097,
                36.7381963
              ],
              [
                53.3464917,
                36.7427648
              ],
              [
                53.3421421,
                36.7475158
              ],
              [
                53.3292797,
                36.7543755
              ],
              [
                53.3245468,
                36.7556652
              ],
              [
                53.3216245,
                36.757024
              ],
              [
                53.3122766,
                36.7605607
              ],
              [
                53.2888078,
                36.7755273
              ],
              [
                53.2832193,
                36.779008
              ],
              [
                53.2779836,
                36.7811735
              ],
              [
                53.271753,
                36.7824141
              ],
              [
                53.2663649,
                36.7860212
              ],
              [
                53.2655733,
                36.7874381
              ],
              [
                53.2613754,
                36.795849
              ],
              [
                53.2600576,
                36.8000748
              ],
              [
                53.2639764,
                36.8073434
              ],
              [
                53.2673462,
                36.810889
              ],
              [
                53.2718497,
                36.8160649
              ],
              [
                53.2750587,
                36.8198157
              ],
              [
                53.2744091,
                36.8250703
              ],
              [
                53.2707851,
                36.8294968
              ],
              [
                53.266908,
                36.8386192
              ],
              [
                53.2660748,
                36.8402847
              ],
              [
                53.2657981,
                36.8407874
              ],
              [
                53.2649094,
                36.842497
              ],
              [
                53.2649093,
                36.8424972
              ],
              [
                53.2029624,
                37.043566
              ],
              [
                53.2027144,
                37.0435241
              ],
              [
                53.1974038,
                37.0425288
              ],
              [
                53.1921218,
                37.0414407
              ],
              [
                53.1868707,
                37.0402602
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555241,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نور",
          "name:en": "Nur County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286144",
          "wikipedia": "en:Nur County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.3444697,
                36.1598446
              ],
              [
                51.346786,
                36.1603174
              ],
              [
                51.3507201,
                36.159828
              ],
              [
                51.3536246,
                36.158031
              ],
              [
                51.3563012,
                36.1576846
              ],
              [
                51.360781,
                36.1589991
              ],
              [
                51.3693968,
                36.1610087
              ],
              [
                51.3720743,
                36.1611451
              ],
              [
                51.3811708,
                36.1600365
              ],
              [
                51.3850217,
                36.1585119
              ],
              [
                51.4004212,
                36.1560885
              ],
              [
                51.407888,
                36.1565044
              ],
              [
                51.4142812,
                36.1574073
              ],
              [
                51.4239594,
                36.1590013
              ],
              [
                51.4286109,
                36.1602465
              ],
              [
                51.4317368,
                36.1603158
              ],
              [
                51.4382541,
                36.1551856
              ],
              [
                51.4464438,
                36.1517204
              ],
              [
                51.4559429,
                36.1461336
              ],
              [
                51.4696597,
                36.1340623
              ],
              [
                51.4736938,
                36.1298336
              ],
              [
                51.4824485,
                36.1269913
              ],
              [
                51.4866542,
                36.1261594
              ],
              [
                51.4903449,
                36.1238715
              ],
              [
                51.4926623,
                36.1217223
              ],
              [
                51.4967822,
                36.1192957
              ],
              [
                51.5007304,
                36.1173543
              ],
              [
                51.5087985,
                36.11153
              ],
              [
                51.5113735,
                36.107092
              ],
              [
                51.5168666,
                36.0948865
              ],
              [
                51.525278,
                36.081708
              ],
              [
                51.5242488,
                36.0792001
              ],
              [
                51.5380668,
                36.0907945
              ],
              [
                51.5527438,
                36.1016137
              ],
              [
                51.5581069,
                36.1003115
              ],
              [
                51.5729376,
                36.0949868
              ],
              [
                51.5865508,
                36.0902648
              ],
              [
                51.5943274,
                36.0860924
              ],
              [
                51.5979408,
                36.084155
              ],
              [
                51.598494,
                36.084155
              ],
              [
                51.5990507,
                36.0835963
              ],
              [
                51.653777,
                36.0602653
              ],
              [
                51.6548867,
                36.0597065
              ],
              [
                51.6934997,
                36.0427643
              ],
              [
                51.699613,
                36.0397092
              ],
              [
                51.7071128,
                36.0369336
              ],
              [
                51.7145335,
                36.0334998
              ],
              [
                51.7154463,
                36.0330404
              ],
              [
                51.7274191,
                36.0266362
              ],
              [
                51.7657256,
                36.0288769
              ],
              [
                51.7682255,
                36.0288769
              ],
              [
                51.7698921,
                36.0291562
              ],
              [
                51.7740588,
                36.0291562
              ],
              [
                51.7754488,
                36.0294266
              ],
              [
                51.7807254,
                36.0294267
              ],
              [
                51.7873919,
                36.0294266
              ],
              [
                51.7935054,
                36.0291562
              ],
              [
                51.7951719,
                36.0288769
              ],
              [
                51.7973952,
                36.0288769
              ],
              [
                51.7993384,
                36.0285975
              ],
              [
                51.8040618,
                36.0285976
              ],
              [
                51.806005,
                36.0283181
              ],
              [
                51.8140616,
                36.0283182
              ],
              [
                51.8157282,
                36.0280388
              ],
              [
                51.8193383,
                36.0280388
              ],
              [
                51.8207282,
                36.0277594
              ],
              [
                51.8307282,
                36.0277595
              ],
              [
                51.8326749,
                36.0280388
              ],
              [
                51.8373947,
                36.0280389
              ],
              [
                51.838228,
                36.0283181
              ],
              [
                51.844898,
                36.0283182
              ],
              [
                51.8468412,
                36.0285976
              ],
              [
                51.8512845,
                36.0285976
              ],
              [
                51.8521179,
                36.028877
              ],
              [
                51.8660076,
                36.0288769
              ],
              [
                51.8673978,
                36.0291563
              ],
              [
                51.8762876,
                36.0291563
              ],
              [
                51.8804543,
                36.0294267
              ],
              [
                51.8818408,
                36.0291563
              ],
              [
                51.8829543,
                36.0294268
              ],
              [
                51.8840643,
                36.0294267
              ],
              [
                51.8848975,
                36.0291564
              ],
              [
                51.8896209,
                36.0294267
              ],
              [
                51.8898974,
                36.0297061
              ],
              [
                51.8921207,
                36.0297061
              ],
              [
                51.8923975,
                36.0294267
              ],
              [
                51.8946208,
                36.0302649
              ],
              [
                51.9221239,
                36.0399888
              ],
              [
                51.9225252,
                36.0401908
              ],
              [
                51.9516892,
                36.0547758
              ],
              [
                51.9721231,
                36.0649877
              ],
              [
                51.9729564,
                36.0655464
              ],
              [
                51.9751799,
                36.0663754
              ],
              [
                51.9824031,
                36.0683219
              ],
              [
                51.9957362,
                36.0736028
              ],
              [
                52.0315724,
                36.1069271
              ],
              [
                52.0424056,
                36.1113787
              ],
              [
                52.0440723,
                36.1122077
              ],
              [
                52.0485155,
                36.1141542
              ],
              [
                52.0496289,
                36.1144335
              ],
              [
                52.0504623,
                36.1149922
              ],
              [
                52.1285214,
                36.1374929
              ],
              [
                52.1296314,
                36.1380425
              ],
              [
                52.1343545,
                36.1391599
              ],
              [
                52.1593542,
                36.1438727
              ],
              [
                52.1604675,
                36.144152
              ],
              [
                52.1668575,
                36.144152
              ],
              [
                52.1674109,
                36.1444313
              ],
              [
                52.1790774,
                36.1444313
              ],
              [
                52.1801907,
                36.1447107
              ],
              [
                52.1835241,
                36.1447107
              ],
              [
                52.1840773,
                36.1449901
              ],
              [
                52.1863005,
                36.14499
              ],
              [
                52.1868574,
                36.1452694
              ],
              [
                52.189634,
                36.1452694
              ],
              [
                52.1904673,
                36.1455486
              ],
              [
                52.1979672,
                36.1455487
              ],
              [
                52.2076904,
                36.1436024
              ],
              [
                52.214357,
                36.1413766
              ],
              [
                52.2160236,
                36.1413767
              ],
              [
                52.2188035,
                36.1410973
              ],
              [
                52.220747,
                36.140827
              ],
              [
                52.2385267,
                36.140827
              ],
              [
                52.2457501,
                36.1402683
              ],
              [
                52.24686,
                36.139989
              ],
              [
                52.2501933,
                36.139989
              ],
              [
                52.25075,
                36.1397097
              ],
              [
                52.2526932,
                36.1397096
              ],
              [
                52.2535266,
                36.1394303
              ],
              [
                52.2554698,
                36.1394303
              ],
              [
                52.2557498,
                36.13916
              ],
              [
                52.2574165,
                36.13916
              ],
              [
                52.2576931,
                36.1388807
              ],
              [
                52.2621399,
                36.1388806
              ],
              [
                52.2624164,
                36.13916
              ],
              [
                52.2638065,
                36.13916
              ],
              [
                52.2693597,
                36.1410973
              ],
              [
                52.2763064,
                36.1408271
              ],
              [
                52.2774163,
                36.1405387
              ],
              [
                52.2804729,
                36.1405387
              ],
              [
                52.2851962,
                36.1410974
              ],
              [
                52.2871394,
                36.1424851
              ],
              [
                52.2871394,
                36.1438727
              ],
              [
                52.2868629,
                36.1444314
              ],
              [
                52.2682498,
                36.1577675
              ],
              [
                52.2676931,
                36.1580467
              ],
              [
                52.2629731,
                36.1613807
              ],
              [
                52.2304702,
                36.1797083
              ],
              [
                52.2193569,
                36.1847091
              ],
              [
                52.189634,
                36.2022162
              ],
              [
                52.1860239,
                36.2047122
              ],
              [
                52.1768573,
                36.2135962
              ],
              [
                52.1740773,
                36.2180472
              ],
              [
                52.1676909,
                36.2305442
              ],
              [
                52.1685241,
                36.2377701
              ],
              [
                52.1690774,
                36.239437
              ],
              [
                52.1690773,
                36.2405452
              ],
              [
                52.1713007,
                36.246654
              ],
              [
                52.1721341,
                36.2483207
              ],
              [
                52.1725255,
                36.2516543
              ],
              [
                52.1732441,
                36.257772
              ],
              [
                52.1729673,
                36.2588802
              ],
              [
                52.1726907,
                36.2627724
              ],
              [
                52.1729673,
                36.2658266
              ],
              [
                52.173244,
                36.2663852
              ],
              [
                52.173244,
                36.2699891
              ],
              [
                52.173524,
                36.2741605
              ],
              [
                52.1732441,
                36.27471
              ],
              [
                52.1729673,
                36.2772147
              ],
              [
                52.1726907,
                36.2797193
              ],
              [
                52.1729673,
                36.282215
              ],
              [
                52.1896338,
                36.2963777
              ],
              [
                52.1926903,
                36.3066573
              ],
              [
                52.1926903,
                36.3069366
              ],
              [
                52.1929671,
                36.31027
              ],
              [
                52.1926904,
                36.3113781
              ],
              [
                52.1924138,
                36.3138826
              ],
              [
                52.1921337,
                36.3199908
              ],
              [
                52.1918571,
                36.3247115
              ],
              [
                52.1913004,
                36.3269368
              ],
              [
                52.1913005,
                36.3277746
              ],
              [
                52.1907471,
                36.3294322
              ],
              [
                52.1890805,
                36.3355493
              ],
              [
                52.1885238,
                36.3363871
              ],
              [
                52.1899137,
                36.338324
              ],
              [
                52.1899137,
                36.3386033
              ],
              [
                52.1907471,
                36.3386033
              ],
              [
                52.1921337,
                36.3391619
              ],
              [
                52.1932469,
                36.3391618
              ],
              [
                52.1935238,
                36.3394411
              ],
              [
                52.1946337,
                36.3394411
              ],
              [
                52.1949136,
                36.3397114
              ],
              [
                52.1951903,
                36.3397113
              ],
              [
                52.1974137,
                36.3402699
              ],
              [
                52.1985236,
                36.3402699
              ],
              [
                52.1988002,
                36.3405492
              ],
              [
                52.1999137,
                36.3405492
              ],
              [
                52.2171368,
                36.3477743
              ],
              [
                52.2254699,
                36.3511076
              ],
              [
                52.2279699,
                36.3522156
              ],
              [
                52.2301932,
                36.3527741
              ],
              [
                52.2524164,
                36.3644403
              ],
              [
                52.2588029,
                36.373602
              ],
              [
                52.2596362,
                36.3811061
              ],
              [
                52.2499163,
                36.4083289
              ],
              [
                52.248803,
                36.4113827
              ],
              [
                52.2488029,
                36.4122204
              ],
              [
                52.2477005,
                36.4163527
              ],
              [
                52.2454697,
                36.4247146
              ],
              [
                52.2449163,
                36.4255522
              ],
              [
                52.2449163,
                36.4258315
              ],
              [
                52.2449164,
                36.4261107
              ],
              [
                52.2423761,
                36.434232
              ],
              [
                52.2414924,
                36.4372519
              ],
              [
                52.2407463,
                36.4394423
              ],
              [
                52.2404697,
                36.4402801
              ],
              [
                52.240193,
                36.4416672
              ],
              [
                52.2399131,
                36.4438831
              ],
              [
                52.2443597,
                36.4522152
              ],
              [
                52.2449163,
                36.4538816
              ],
              [
                52.2403304,
                36.4633269
              ],
              [
                52.2390524,
                36.4659588
              ],
              [
                52.2383652,
                36.467374
              ],
              [
                52.237473,
                36.4695944
              ],
              [
                52.2290157,
                36.4866257
              ],
              [
                52.2213032,
                36.5025031
              ],
              [
                52.2215799,
                36.5058267
              ],
              [
                52.2215798,
                36.5080515
              ],
              [
                52.2213032,
                36.5088891
              ],
              [
                52.2210232,
                36.5108346
              ],
              [
                52.2207466,
                36.51278
              ],
              [
                52.2204698,
                36.5155542
              ],
              [
                52.2201897,
                36.5177699
              ],
              [
                52.2190799,
                36.524444
              ],
              [
                52.2188032,
                36.5266687
              ],
              [
                52.2146367,
                36.5436102
              ],
              [
                52.2140799,
                36.5441686
              ],
              [
                52.2138033,
                36.5449973
              ],
              [
                52.2046366,
                36.5541658
              ],
              [
                52.2046366,
                36.5547242
              ],
              [
                52.2038035,
                36.5547243
              ],
              [
                52.2032467,
                36.5549945
              ],
              [
                52.2021332,
                36.5549945
              ],
              [
                52.1932468,
                36.5572191
              ],
              [
                52.1929668,
                36.5574982
              ],
              [
                52.1871335,
                36.5594436
              ],
              [
                52.1851904,
                36.5602722
              ],
              [
                52.1826902,
                36.5616682
              ],
              [
                52.1801902,
                36.5644421
              ],
              [
                52.1799103,
                36.5652707
              ],
              [
                52.1799104,
                36.5672251
              ],
              [
                52.1799103,
                36.5677745
              ],
              [
                52.1801902,
                36.5683329
              ],
              [
                52.1807435,
                36.5733314
              ],
              [
                52.1813002,
                36.5744482
              ],
              [
                52.181577,
                36.5763935
              ],
              [
                52.1835236,
                36.5805543
              ],
              [
                52.1846334,
                36.5855528
              ],
              [
                52.1851903,
                36.5863903
              ],
              [
                52.186857,
                36.5930548
              ],
              [
                52.1876901,
                36.6011151
              ],
              [
                52.1874136,
                36.606942
              ],
              [
                52.1871334,
                36.6072212
              ],
              [
                52.1871334,
                36.6088872
              ],
              [
                52.1868569,
                36.6113908
              ],
              [
                52.1865801,
                36.6133361
              ],
              [
                52.1863,
                36.6138945
              ],
              [
                52.1857637,
                36.6160331
              ],
              [
                52.1857635,
                36.6160337
              ],
              [
                52.1424719,
                36.8161792
              ],
              [
                52.1375494,
                36.8144842
              ],
              [
                52.1352215,
                36.8136337
              ],
              [
                52.1257289,
                36.8110266
              ],
              [
                52.1243485,
                36.8106077
              ],
              [
                52.1194244,
                36.8094455
              ],
              [
                52.1133233,
                36.8078671
              ],
              [
                52.1107788,
                36.8071501
              ],
              [
                52.1052579,
                36.8058235
              ],
              [
                52.0957717,
                36.8032069
              ],
              [
                52.0943704,
                36.8029249
              ],
              [
                52.0852069,
                36.8008804
              ],
              [
                52.0761476,
                36.7985556
              ],
              [
                52.0543489,
                36.7925865
              ],
              [
                52.0202721,
                36.7849011
              ],
              [
                52.0135963,
                36.7833954
              ],
              [
                51.9846635,
                36.7786306
              ],
              [
                51.9793921,
                36.7778799
              ],
              [
                51.969123,
                36.7764175
              ],
              [
                51.9670241,
                36.7762134
              ],
              [
                51.962756,
                36.7757219
              ],
              [
                51.9586134,
                36.7754663
              ],
              [
                51.953205,
                36.7750367
              ],
              [
                51.9478096,
                36.774512
              ],
              [
                51.9424297,
                36.7738925
              ],
              [
                51.9398748,
                36.7734837
              ],
              [
                51.9370656,
                36.7732353
              ],
              [
                51.9400574,
                36.5722276
              ],
              [
                51.9376764,
                36.5619472
              ],
              [
                51.9373996,
                36.5594434
              ],
              [
                51.937123,
                36.5561111
              ],
              [
                51.9356906,
                36.5523174
              ],
              [
                51.9308799,
                36.5395749
              ],
              [
                51.9212899,
                36.5141669
              ],
              [
                51.91212,
                36.4986119
              ],
              [
                51.9104534,
                36.4963871
              ],
              [
                51.9049002,
                36.4913881
              ],
              [
                51.8496186,
                36.4647679
              ],
              [
                51.8448975,
                36.4624926
              ],
              [
                51.8446174,
                36.461943
              ],
              [
                51.8404509,
                36.459439
              ],
              [
                51.8362843,
                36.4566646
              ],
              [
                51.835451,
                36.4558269
              ],
              [
                51.834341,
                36.4552775
              ],
              [
                51.825451,
                36.445279
              ],
              [
                51.825451,
                36.4424956
              ],
              [
                51.8346176,
                36.4116617
              ],
              [
                51.8382275,
                36.4024914
              ],
              [
                51.8396177,
                36.3986089
              ],
              [
                51.8412842,
                36.3949966
              ],
              [
                51.841561,
                36.3941588
              ],
              [
                51.836841,
                36.374998
              ],
              [
                51.8321176,
                36.3552692
              ],
              [
                51.8276744,
                36.3455488
              ],
              [
                51.8265611,
                36.3427741
              ],
              [
                51.8248944,
                36.3386031
              ],
              [
                51.8040615,
                36.3013866
              ],
              [
                51.8037814,
                36.3011073
              ],
              [
                51.8032283,
                36.2988821
              ],
              [
                51.7971148,
                36.2866563
              ],
              [
                51.7826717,
                36.2694391
              ],
              [
                51.7810052,
                36.2672138
              ],
              [
                51.7771153,
                36.2636009
              ],
              [
                51.7593353,
                36.2594384
              ],
              [
                51.7582254,
                36.2594385
              ],
              [
                51.7579488,
                36.2591592
              ],
              [
                51.7571154,
                36.2591591
              ],
              [
                51.7565587,
                36.2588799
              ],
              [
                51.7554488,
                36.2588799
              ],
              [
                51.753502,
                36.2583213
              ],
              [
                51.7521154,
                36.2583212
              ],
              [
                51.7510022,
                36.258042
              ],
              [
                51.7493355,
                36.2580419
              ],
              [
                51.7479456,
                36.2577716
              ],
              [
                51.7460023,
                36.2577717
              ],
              [
                51.7446123,
                36.2574923
              ],
              [
                51.7426688,
                36.2574923
              ],
              [
                51.7412789,
                36.257213
              ],
              [
                51.7398923,
                36.2572131
              ],
              [
                51.7387788,
                36.2569338
              ],
              [
                51.7237791,
                36.2569338
              ],
              [
                51.7218358,
                36.2566545
              ],
              [
                51.709056,
                36.2566544
              ],
              [
                51.707666,
                36.2566545
              ],
              [
                51.7057226,
                36.2566545
              ],
              [
                51.7043326,
                36.2569337
              ],
              [
                51.697666,
                36.2569338
              ],
              [
                51.6926661,
                36.2569337
              ],
              [
                51.6912761,
                36.257213
              ],
              [
                51.6857229,
                36.257213
              ],
              [
                51.684333,
                36.2574923
              ],
              [
                51.680723,
                36.2574924
              ],
              [
                51.6790563,
                36.2577715
              ],
              [
                51.6718331,
                36.2577716
              ],
              [
                51.6651666,
                36.2580419
              ],
              [
                51.6637765,
                36.2577716
              ],
              [
                51.6440534,
                36.2577716
              ],
              [
                51.6429434,
                36.2580419
              ],
              [
                51.5826606,
                36.2613754
              ],
              [
                51.5807174,
                36.2616547
              ],
              [
                51.5765508,
                36.2616547
              ],
              [
                51.5754374,
                36.261934
              ],
              [
                51.5676609,
                36.2622133
              ],
              [
                51.562661,
                36.2622133
              ],
              [
                51.5607142,
                36.2624926
              ],
              [
                51.5554376,
                36.2624926
              ],
              [
                51.553771,
                36.2627719
              ],
              [
                51.547381,
                36.2627718
              ],
              [
                51.5459944,
                36.2630512
              ],
              [
                51.5407144,
                36.2630512
              ],
              [
                51.5221013,
                36.2644297
              ],
              [
                51.5209914,
                36.2647089
              ],
              [
                51.5123816,
                36.2647088
              ],
              [
                51.5109916,
                36.2644296
              ],
              [
                51.4979351,
                36.2644296
              ],
              [
                51.4809886,
                36.2627718
              ],
              [
                51.478212,
                36.2627718
              ],
              [
                51.4765453,
                36.2624925
              ],
              [
                51.4757119,
                36.2624925
              ],
              [
                51.4734275,
                36.262389
              ],
              [
                51.4696333,
                36.2576954
              ],
              [
                51.4680557,
                36.2578952
              ],
              [
                51.4671397,
                36.2560831
              ],
              [
                51.465606,
                36.2549743
              ],
              [
                51.4610123,
                36.2547493
              ],
              [
                51.4554287,
                36.2579513
              ],
              [
                51.4532211,
                36.2573066
              ],
              [
                51.4499581,
                36.2571966
              ],
              [
                51.4451589,
                36.2567571
              ],
              [
                51.4430516,
                36.2573864
              ],
              [
                51.4419982,
                36.2571659
              ],
              [
                51.4384015,
                36.2538679
              ],
              [
                51.432868,
                36.2533288
              ],
              [
                51.4240822,
                36.2515152
              ],
              [
                51.4167746,
                36.251507
              ],
              [
                51.4132077,
                36.2510538
              ],
              [
                51.4106679,
                36.2516589
              ],
              [
                51.4055161,
                36.2511458
              ],
              [
                51.4023863,
                36.2531906
              ],
              [
                51.4009797,
                36.2551362
              ],
              [
                51.3947068,
                36.2571122
              ],
              [
                51.391776,
                36.2591964
              ],
              [
                51.385627,
                36.2633222
              ],
              [
                51.3835242,
                36.2663067
              ],
              [
                51.3789267,
                36.2676998
              ],
              [
                51.3756214,
                36.2704076
              ],
              [
                51.3746258,
                36.2680238
              ],
              [
                51.3733715,
                36.2677007
              ],
              [
                51.3720404,
                36.2669304
              ],
              [
                51.3711701,
                36.2663066
              ],
              [
                51.3692403,
                36.263481
              ],
              [
                51.3663829,
                36.2589202
              ],
              [
                51.3630117,
                36.2547631
              ],
              [
                51.358161,
                36.2489957
              ],
              [
                51.3517656,
                36.2428982
              ],
              [
                51.3452615,
                36.2361109
              ],
              [
                51.3435639,
                36.2327848
              ],
              [
                51.3420108,
                36.2279124
              ],
              [
                51.341366,
                36.2211313
              ],
              [
                51.3416201,
                36.2175574
              ],
              [
                51.3431453,
                36.2151943
              ],
              [
                51.3452052,
                36.2070918
              ],
              [
                51.3441753,
                36.2027286
              ],
              [
                51.3414287,
                36.1968413
              ],
              [
                51.3392328,
                36.1859082
              ],
              [
                51.3371729,
                36.1809895
              ],
              [
                51.3346206,
                36.1783547
              ],
              [
                51.3327706,
                36.1761958
              ],
              [
                51.3329649,
                36.1737665
              ],
              [
                51.333928,
                36.1700899
              ],
              [
                51.3367415,
                36.1664111
              ],
              [
                51.3396619,
                36.1629243
              ],
              [
                51.3444697,
                36.1598446
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555242,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نوشهر",
          "name:en": "Nowshahr County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282260",
          "wikipedia": "en:Nowshahr County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.3234569,
                36.5244424
              ],
              [
                51.3240325,
                36.5202892
              ],
              [
                51.3254075,
                36.5161798
              ],
              [
                51.3277233,
                36.5110636
              ],
              [
                51.3291015,
                36.5071275
              ],
              [
                51.3189954,
                36.4925804
              ],
              [
                51.3186005,
                36.491977
              ],
              [
                51.3186121,
                36.491478
              ],
              [
                51.3190051,
                36.4909791
              ],
              [
                51.3197417,
                36.4907071
              ],
              [
                51.3204324,
                36.4900634
              ],
              [
                51.3240337,
                36.4851455
              ],
              [
                51.3258924,
                36.4824726
              ],
              [
                51.3266119,
                36.4810421
              ],
              [
                51.327271,
                36.4765161
              ],
              [
                51.327198,
                36.4736965
              ],
              [
                51.3280881,
                36.4718629
              ],
              [
                51.3298866,
                36.4703508
              ],
              [
                51.3304991,
                36.4663149
              ],
              [
                51.331323,
                36.4615901
              ],
              [
                51.3321934,
                36.4594148
              ],
              [
                51.3332762,
                36.4559132
              ],
              [
                51.3340721,
                36.4537401
              ],
              [
                51.3350845,
                36.4486453
              ],
              [
                51.3373947,
                36.4426899
              ],
              [
                51.3371949,
                36.4382044
              ],
              [
                51.3367252,
                36.4350267
              ],
              [
                51.3364188,
                36.4307424
              ],
              [
                51.3361265,
                36.4277924
              ],
              [
                51.3364764,
                36.4231261
              ],
              [
                51.3377307,
                36.4152269
              ],
              [
                51.3398123,
                36.4096892
              ],
              [
                51.3461365,
                36.4013322
              ],
              [
                51.3492849,
                36.3958796
              ],
              [
                51.3507341,
                36.3888946
              ],
              [
                51.3512992,
                36.3842545
              ],
              [
                51.3507748,
                36.3815258
              ],
              [
                51.3493067,
                36.3789801
              ],
              [
                51.3449466,
                36.3716857
              ],
              [
                51.340641,
                36.3640231
              ],
              [
                51.3367137,
                36.3567888
              ],
              [
                51.3330237,
                36.3501749
              ],
              [
                51.3286526,
                36.343944
              ],
              [
                51.3285552,
                36.3437502
              ],
              [
                51.3255961,
                36.3378638
              ],
              [
                51.3241483,
                36.3356559
              ],
              [
                51.3190202,
                36.3298412
              ],
              [
                51.3141504,
                36.3249748
              ],
              [
                51.3108918,
                36.3203586
              ],
              [
                51.3128951,
                36.3175312
              ],
              [
                51.314671,
                36.3149018
              ],
              [
                51.3172122,
                36.3104902
              ],
              [
                51.3191801,
                36.3056271
              ],
              [
                51.3214301,
                36.3011537
              ],
              [
                51.323513,
                36.2982619
              ],
              [
                51.3291325,
                36.2944038
              ],
              [
                51.3338756,
                36.2923683
              ],
              [
                51.3379954,
                36.2914689
              ],
              [
                51.3428878,
                36.291123
              ],
              [
                51.3480376,
                36.2893243
              ],
              [
                51.3585948,
                36.2801916
              ],
              [
                51.3648604,
                36.2741718
              ],
              [
                51.3746258,
                36.2680238
              ],
              [
                51.3756214,
                36.2704076
              ],
              [
                51.3789267,
                36.2676998
              ],
              [
                51.3835242,
                36.2663067
              ],
              [
                51.385627,
                36.2633222
              ],
              [
                51.391776,
                36.2591964
              ],
              [
                51.3947068,
                36.2571122
              ],
              [
                51.4009797,
                36.2551362
              ],
              [
                51.4023863,
                36.2531906
              ],
              [
                51.4055161,
                36.2511458
              ],
              [
                51.4106679,
                36.2516589
              ],
              [
                51.4132077,
                36.2510538
              ],
              [
                51.4167746,
                36.251507
              ],
              [
                51.4240822,
                36.2515152
              ],
              [
                51.432868,
                36.2533288
              ],
              [
                51.4384015,
                36.2538679
              ],
              [
                51.4419982,
                36.2571659
              ],
              [
                51.4430516,
                36.2573864
              ],
              [
                51.4451589,
                36.2567571
              ],
              [
                51.4499581,
                36.2571966
              ],
              [
                51.4532211,
                36.2573066
              ],
              [
                51.4554287,
                36.2579513
              ],
              [
                51.4610123,
                36.2547493
              ],
              [
                51.465606,
                36.2549743
              ],
              [
                51.4671397,
                36.2560831
              ],
              [
                51.4680557,
                36.2578952
              ],
              [
                51.4696333,
                36.2576954
              ],
              [
                51.4734275,
                36.262389
              ],
              [
                51.4757119,
                36.2624925
              ],
              [
                51.4765453,
                36.2624925
              ],
              [
                51.478212,
                36.2627718
              ],
              [
                51.4809886,
                36.2627718
              ],
              [
                51.4979351,
                36.2644296
              ],
              [
                51.5109916,
                36.2644296
              ],
              [
                51.5123816,
                36.2647088
              ],
              [
                51.5209914,
                36.2647089
              ],
              [
                51.5221013,
                36.2644297
              ],
              [
                51.5407144,
                36.2630512
              ],
              [
                51.5459944,
                36.2630512
              ],
              [
                51.547381,
                36.2627718
              ],
              [
                51.553771,
                36.2627719
              ],
              [
                51.5554376,
                36.2624926
              ],
              [
                51.5607142,
                36.2624926
              ],
              [
                51.562661,
                36.2622133
              ],
              [
                51.5676609,
                36.2622133
              ],
              [
                51.5754374,
                36.261934
              ],
              [
                51.5765508,
                36.2616547
              ],
              [
                51.5807174,
                36.2616547
              ],
              [
                51.5826606,
                36.2613754
              ],
              [
                51.6429434,
                36.2580419
              ],
              [
                51.6440534,
                36.2577716
              ],
              [
                51.6637765,
                36.2577716
              ],
              [
                51.6651666,
                36.2580419
              ],
              [
                51.6718331,
                36.2577716
              ],
              [
                51.6790563,
                36.2577715
              ],
              [
                51.680723,
                36.2574924
              ],
              [
                51.684333,
                36.2574923
              ],
              [
                51.6857229,
                36.257213
              ],
              [
                51.6912761,
                36.257213
              ],
              [
                51.6926661,
                36.2569337
              ],
              [
                51.697666,
                36.2569338
              ],
              [
                51.7043326,
                36.2569337
              ],
              [
                51.7057226,
                36.2566545
              ],
              [
                51.707666,
                36.2566545
              ],
              [
                51.709056,
                36.2566544
              ],
              [
                51.7218358,
                36.2566545
              ],
              [
                51.7237791,
                36.2569338
              ],
              [
                51.7387788,
                36.2569338
              ],
              [
                51.7398923,
                36.2572131
              ],
              [
                51.7412789,
                36.257213
              ],
              [
                51.7426688,
                36.2574923
              ],
              [
                51.7446123,
                36.2574923
              ],
              [
                51.7460023,
                36.2577717
              ],
              [
                51.7479456,
                36.2577716
              ],
              [
                51.7493355,
                36.2580419
              ],
              [
                51.7510022,
                36.258042
              ],
              [
                51.7521154,
                36.2583212
              ],
              [
                51.753502,
                36.2583213
              ],
              [
                51.7554488,
                36.2588799
              ],
              [
                51.7565587,
                36.2588799
              ],
              [
                51.7571154,
                36.2591591
              ],
              [
                51.7579488,
                36.2591592
              ],
              [
                51.7582254,
                36.2594385
              ],
              [
                51.7593353,
                36.2594384
              ],
              [
                51.7771153,
                36.2636009
              ],
              [
                51.7810052,
                36.2672138
              ],
              [
                51.7826717,
                36.2694391
              ],
              [
                51.7971148,
                36.2866563
              ],
              [
                51.8032283,
                36.2988821
              ],
              [
                51.8037814,
                36.3011073
              ],
              [
                51.8040615,
                36.3013866
              ],
              [
                51.8248944,
                36.3386031
              ],
              [
                51.8265611,
                36.3427741
              ],
              [
                51.8276744,
                36.3455488
              ],
              [
                51.8321176,
                36.3552692
              ],
              [
                51.836841,
                36.374998
              ],
              [
                51.841561,
                36.3941588
              ],
              [
                51.8412842,
                36.3949966
              ],
              [
                51.8396177,
                36.3986089
              ],
              [
                51.8382275,
                36.4024914
              ],
              [
                51.8346176,
                36.4116617
              ],
              [
                51.825451,
                36.4424956
              ],
              [
                51.825451,
                36.445279
              ],
              [
                51.834341,
                36.4552775
              ],
              [
                51.835451,
                36.4558269
              ],
              [
                51.8362843,
                36.4566646
              ],
              [
                51.8404509,
                36.459439
              ],
              [
                51.8446174,
                36.461943
              ],
              [
                51.8448975,
                36.4624926
              ],
              [
                51.8496186,
                36.4647679
              ],
              [
                51.9049002,
                36.4913881
              ],
              [
                51.9104534,
                36.4963871
              ],
              [
                51.91212,
                36.4986119
              ],
              [
                51.9212899,
                36.5141669
              ],
              [
                51.9308799,
                36.5395749
              ],
              [
                51.9356906,
                36.5523174
              ],
              [
                51.937123,
                36.5561111
              ],
              [
                51.9373996,
                36.5594434
              ],
              [
                51.9376764,
                36.5619472
              ],
              [
                51.9400574,
                36.5722276
              ],
              [
                51.9370656,
                36.7732353
              ],
              [
                51.9344573,
                36.7731775
              ],
              [
                51.9296859,
                36.772883
              ],
              [
                51.9275544,
                36.7728643
              ],
              [
                51.9221228,
                36.7727209
              ],
              [
                51.9164712,
                36.772468
              ],
              [
                51.9084123,
                36.7729792
              ],
              [
                51.9029781,
                36.7729314
              ],
              [
                51.8986427,
                36.7728401
              ],
              [
                51.8973287,
                36.7729251
              ],
              [
                51.8967654,
                36.7730849
              ],
              [
                51.8916018,
                36.7744483
              ],
              [
                51.8864023,
                36.7757206
              ],
              [
                51.8811693,
                36.7769011
              ],
              [
                51.8759055,
                36.7779892
              ],
              [
                51.8706132,
                36.7789845
              ],
              [
                51.8652951,
                36.7798865
              ],
              [
                51.8599537,
                36.7806946
              ],
              [
                51.8537056,
                36.7815173
              ],
              [
                51.8477059,
                36.7821815
              ],
              [
                51.8414346,
                36.7833156
              ],
              [
                51.8339249,
                36.7844796
              ],
              [
                51.8285625,
                36.7851936
              ],
              [
                51.8231819,
                36.7858131
              ],
              [
                51.8177857,
                36.7863378
              ],
              [
                51.8123765,
                36.7867675
              ],
              [
                51.8069568,
                36.7871018
              ],
              [
                51.8015294,
                36.7873408
              ],
              [
                51.7960967,
                36.7874842
              ],
              [
                51.7816031,
                36.7872194
              ],
              [
                51.7804546,
                36.7873103
              ],
              [
                51.7756936,
                36.7871754
              ],
              [
                51.7613063,
                36.7890674
              ],
              [
                51.7569517,
                36.7892295
              ],
              [
                51.751598,
                36.7900396
              ],
              [
                51.7463646,
                36.7907375
              ],
              [
                51.7411139,
                36.7913454
              ],
              [
                51.7370531,
                36.7917446
              ],
              [
                51.7361499,
                36.7918689
              ],
              [
                51.7303498,
                36.792641
              ],
              [
                51.7285881,
                36.7931347
              ],
              [
                51.7221887,
                36.7947606
              ],
              [
                51.7198054,
                36.7960152
              ],
              [
                51.7154189,
                36.7985512
              ],
              [
                51.7109364,
                36.8010249
              ],
              [
                51.7063875,
                36.8034193
              ],
              [
                51.7017745,
                36.8057331
              ],
              [
                51.6970996,
                36.8079652
              ],
              [
                51.692365,
                36.8101146
              ],
              [
                51.6875729,
                36.8121803
              ],
              [
                51.6827256,
                36.8141612
              ],
              [
                51.6778255,
                36.8160564
              ],
              [
                51.672875,
                36.817865
              ],
              [
                51.6678763,
                36.8195861
              ],
              [
                51.6647682,
                36.8205922
              ],
              [
                51.6621506,
                36.8222493
              ],
              [
                51.6578054,
                36.8248782
              ],
              [
                51.6533897,
                36.8274302
              ],
              [
                51.6489055,
                36.8299039
              ],
              [
                51.644355,
                36.8322982
              ],
              [
                51.6397402,
                36.834612
              ],
              [
                51.6350636,
                36.8368442
              ],
              [
                51.6303271,
                36.8389936
              ],
              [
                51.6255332,
                36.8410592
              ],
              [
                51.6206842,
                36.8430401
              ],
              [
                51.6157823,
                36.8449353
              ],
              [
                51.6108298,
                36.8467439
              ],
              [
                51.6058293,
                36.8484651
              ],
              [
                51.6007829,
                36.8500979
              ],
              [
                51.5956933,
                36.8516417
              ],
              [
                51.5905628,
                36.8530956
              ],
              [
                51.5853938,
                36.8544591
              ],
              [
                51.5801889,
                36.8557313
              ],
              [
                51.5749505,
                36.8569118
              ],
              [
                51.5696812,
                36.858
              ],
              [
                51.5643834,
                36.8589952
              ],
              [
                51.5590598,
                36.8598972
              ],
              [
                51.5537128,
                36.8607053
              ],
              [
                51.5483534,
                36.8614182
              ],
              [
                51.5436187,
                36.8633519
              ],
              [
                51.5387155,
                36.8652471
              ],
              [
                51.5337617,
                36.8670557
              ],
              [
                51.5287598,
                36.8687768
              ],
              [
                51.5237122,
                36.8704097
              ],
              [
                51.5186212,
                36.8719534
              ],
              [
                51.5169527,
                36.8724373
              ],
              [
                51.5120475,
                36.8738438
              ],
              [
                51.4558239,
                36.6721051
              ],
              [
                51.4527299,
                36.6693262
              ],
              [
                51.4514399,
                36.6682332
              ],
              [
                51.4506447,
                36.6677459
              ],
              [
                51.448123,
                36.6666259
              ],
              [
                51.452233,
                36.6586811
              ],
              [
                51.4524418,
                36.6577485
              ],
              [
                51.4525462,
                36.656823
              ],
              [
                51.4527566,
                36.65676
              ],
              [
                51.4515331,
                36.6556245
              ],
              [
                51.4514592,
                36.6553233
              ],
              [
                51.4519046,
                36.6550394
              ],
              [
                51.4521669,
                36.6542123
              ],
              [
                51.4520529,
                36.6540905
              ],
              [
                51.4518597,
                36.6541084
              ],
              [
                51.4514657,
                36.653538
              ],
              [
                51.4510045,
                36.6524573
              ],
              [
                51.450647,
                36.6516176
              ],
              [
                51.4502467,
                36.651637
              ],
              [
                51.449881,
                36.651136
              ],
              [
                51.449805,
                36.6505611
              ],
              [
                51.4500011,
                36.6503456
              ],
              [
                51.4504013,
                36.650403
              ],
              [
                51.4503329,
                36.6499609
              ],
              [
                51.4500603,
                36.6495278
              ],
              [
                51.4503773,
                36.6493588
              ],
              [
                51.4501232,
                36.6490666
              ],
              [
                51.4499829,
                36.648683
              ],
              [
                51.4500194,
                36.6486008
              ],
              [
                51.4499461,
                36.6482734
              ],
              [
                51.4496699,
                36.6483659
              ],
              [
                51.4495075,
                36.6482301
              ],
              [
                51.4494298,
                36.6481879
              ],
              [
                51.4497107,
                36.6468202
              ],
              [
                51.4506498,
                36.6466495
              ],
              [
                51.4512242,
                36.6458516
              ],
              [
                51.4509639,
                36.644859
              ],
              [
                51.4500652,
                36.6447598
              ],
              [
                51.4494009,
                36.6443471
              ],
              [
                51.4495056,
                36.6435952
              ],
              [
                51.4490319,
                36.6431357
              ],
              [
                51.4481074,
                36.6407386
              ],
              [
                51.4464485,
                36.6385568
              ],
              [
                51.4456742,
                36.638234
              ],
              [
                51.4437651,
                36.63639
              ],
              [
                51.4415417,
                36.6330579
              ],
              [
                51.4418217,
                36.6322204
              ],
              [
                51.4420985,
                36.631662
              ],
              [
                51.4420984,
                36.630005
              ],
              [
                51.4420985,
                36.6294467
              ],
              [
                51.4423751,
                36.6263937
              ],
              [
                51.4426551,
                36.6244486
              ],
              [
                51.4429317,
                36.6230527
              ],
              [
                51.4473751,
                36.614173
              ],
              [
                51.4534882,
                36.6074997
              ],
              [
                51.4648782,
                36.5983317
              ],
              [
                51.4771014,
                36.5822199
              ],
              [
                51.4779347,
                36.5805537
              ],
              [
                51.4782115,
                36.5799955
              ],
              [
                51.4818213,
                36.5674947
              ],
              [
                51.4782115,
                36.5491666
              ],
              [
                51.4726547,
                36.5372149
              ],
              [
                51.4659882,
                36.525281
              ],
              [
                51.4651551,
                36.5219395
              ],
              [
                51.4651549,
                36.5213901
              ],
              [
                51.4598784,
                36.5086092
              ],
              [
                51.4590452,
                36.5086093
              ],
              [
                51.4579316,
                36.5088885
              ],
              [
                51.4551552,
                36.5091587
              ],
              [
                51.4493218,
                36.5091586
              ],
              [
                51.4123756,
                36.5155535
              ],
              [
                51.4076522,
                36.5169406
              ],
              [
                51.399319,
                36.5183277
              ],
              [
                51.3968191,
                36.5183277
              ],
              [
                51.3957092,
                36.5186069
              ],
              [
                51.3937624,
                36.5186069
              ],
              [
                51.3926525,
                36.5188862
              ],
              [
                51.3901937,
                36.5203171
              ],
              [
                51.3892555,
                36.5211365
              ],
              [
                51.3873982,
                36.5224068
              ],
              [
                51.3853837,
                36.5228303
              ],
              [
                51.3821504,
                36.5237355
              ],
              [
                51.3805722,
                36.5234453
              ],
              [
                51.3644075,
                36.5214658
              ],
              [
                51.3595441,
                36.5219248
              ],
              [
                51.3432551,
                36.5230351
              ],
              [
                51.336729,
                36.5256264
              ],
              [
                51.3285876,
                36.525068
              ],
              [
                51.3234569,
                36.5244424
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555273,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان چالوس",
          "name:en": "Chalus County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1282160",
          "wikipedia": "en:Chalus County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                51.0001284,
                36.2485033
              ],
              [
                50.9989763,
                36.2485704
              ],
              [
                51.0042285,
                36.246513
              ],
              [
                51.0098114,
                36.2447504
              ],
              [
                51.0246514,
                36.2409887
              ],
              [
                51.0410168,
                36.2372096
              ],
              [
                51.063938,
                36.2301506
              ],
              [
                51.1044501,
                36.2168909
              ],
              [
                51.1250198,
                36.2123269
              ],
              [
                51.1346527,
                36.2103084
              ],
              [
                51.144385,
                36.2099152
              ],
              [
                51.157123,
                36.2090527
              ],
              [
                51.1712837,
                36.2086446
              ],
              [
                51.1791362,
                36.2085041
              ],
              [
                51.1854099,
                36.2087599
              ],
              [
                51.1933831,
                36.2080661
              ],
              [
                51.2011319,
                36.2085395
              ],
              [
                51.2098019,
                36.2090136
              ],
              [
                51.2204855,
                36.2105949
              ],
              [
                51.239461,
                36.2105845
              ],
              [
                51.2494899,
                36.2096164
              ],
              [
                51.2433763,
                36.2024141
              ],
              [
                51.2408941,
                36.1986662
              ],
              [
                51.2428373,
                36.1973065
              ],
              [
                51.2453628,
                36.1938543
              ],
              [
                51.2464072,
                36.1856445
              ],
              [
                51.2476134,
                36.1785692
              ],
              [
                51.2494351,
                36.1733257
              ],
              [
                51.2644413,
                36.1685286
              ],
              [
                51.2730428,
                36.1672499
              ],
              [
                51.2821287,
                36.1667527
              ],
              [
                51.2886791,
                36.1678267
              ],
              [
                51.2928339,
                36.1676867
              ],
              [
                51.2973159,
                36.1665777
              ],
              [
                51.3001314,
                36.1666993
              ],
              [
                51.3068389,
                36.1650423
              ],
              [
                51.3125896,
                36.1622012
              ],
              [
                51.3197565,
                36.1580434
              ],
              [
                51.3275479,
                36.1543661
              ],
              [
                51.3312653,
                36.1535463
              ],
              [
                51.3346052,
                36.1539026
              ],
              [
                51.3376912,
                36.1535621
              ],
              [
                51.3388324,
                36.1540239
              ],
              [
                51.3444697,
                36.1598446
              ],
              [
                51.3396619,
                36.1629243
              ],
              [
                51.3367415,
                36.1664111
              ],
              [
                51.333928,
                36.1700899
              ],
              [
                51.3329649,
                36.1737665
              ],
              [
                51.3327706,
                36.1761958
              ],
              [
                51.3346206,
                36.1783547
              ],
              [
                51.3371729,
                36.1809895
              ],
              [
                51.3392328,
                36.1859082
              ],
              [
                51.3414287,
                36.1968413
              ],
              [
                51.3441753,
                36.2027286
              ],
              [
                51.3452052,
                36.2070918
              ],
              [
                51.3431453,
                36.2151943
              ],
              [
                51.3416201,
                36.2175574
              ],
              [
                51.341366,
                36.2211313
              ],
              [
                51.3420108,
                36.2279124
              ],
              [
                51.3435639,
                36.2327848
              ],
              [
                51.3452615,
                36.2361109
              ],
              [
                51.3517656,
                36.2428982
              ],
              [
                51.358161,
                36.2489957
              ],
              [
                51.3630117,
                36.2547631
              ],
              [
                51.3663829,
                36.2589202
              ],
              [
                51.3692403,
                36.263481
              ],
              [
                51.3711701,
                36.2663066
              ],
              [
                51.3720404,
                36.2669304
              ],
              [
                51.3733715,
                36.2677007
              ],
              [
                51.3746258,
                36.2680238
              ],
              [
                51.3648604,
                36.2741718
              ],
              [
                51.3585948,
                36.2801916
              ],
              [
                51.3480376,
                36.2893243
              ],
              [
                51.3428878,
                36.291123
              ],
              [
                51.3379954,
                36.2914689
              ],
              [
                51.3338756,
                36.2923683
              ],
              [
                51.3291325,
                36.2944038
              ],
              [
                51.323513,
                36.2982619
              ],
              [
                51.3214301,
                36.3011537
              ],
              [
                51.3191801,
                36.3056271
              ],
              [
                51.3172122,
                36.3104902
              ],
              [
                51.314671,
                36.3149018
              ],
              [
                51.3128951,
                36.3175312
              ],
              [
                51.3108918,
                36.3203586
              ],
              [
                51.3141504,
                36.3249748
              ],
              [
                51.3190202,
                36.3298412
              ],
              [
                51.3241483,
                36.3356559
              ],
              [
                51.3255961,
                36.3378638
              ],
              [
                51.3285552,
                36.3437502
              ],
              [
                51.3286526,
                36.343944
              ],
              [
                51.3330237,
                36.3501749
              ],
              [
                51.3367137,
                36.3567888
              ],
              [
                51.340641,
                36.3640231
              ],
              [
                51.3449466,
                36.3716857
              ],
              [
                51.3493067,
                36.3789801
              ],
              [
                51.3507748,
                36.3815258
              ],
              [
                51.3512992,
                36.3842545
              ],
              [
                51.3507341,
                36.3888946
              ],
              [
                51.3492849,
                36.3958796
              ],
              [
                51.3461365,
                36.4013322
              ],
              [
                51.3398123,
                36.4096892
              ],
              [
                51.3377307,
                36.4152269
              ],
              [
                51.3364764,
                36.4231261
              ],
              [
                51.3361265,
                36.4277924
              ],
              [
                51.3364188,
                36.4307424
              ],
              [
                51.3367252,
                36.4350267
              ],
              [
                51.3371949,
                36.4382044
              ],
              [
                51.3373947,
                36.4426899
              ],
              [
                51.3350845,
                36.4486453
              ],
              [
                51.3340721,
                36.4537401
              ],
              [
                51.3332762,
                36.4559132
              ],
              [
                51.3321934,
                36.4594148
              ],
              [
                51.331323,
                36.4615901
              ],
              [
                51.3304991,
                36.4663149
              ],
              [
                51.3298866,
                36.4703508
              ],
              [
                51.3280881,
                36.4718629
              ],
              [
                51.327198,
                36.4736965
              ],
              [
                51.327271,
                36.4765161
              ],
              [
                51.3266119,
                36.4810421
              ],
              [
                51.3258924,
                36.4824726
              ],
              [
                51.3240337,
                36.4851455
              ],
              [
                51.3204324,
                36.4900634
              ],
              [
                51.3197417,
                36.4907071
              ],
              [
                51.3190051,
                36.4909791
              ],
              [
                51.3186121,
                36.491478
              ],
              [
                51.3186005,
                36.491977
              ],
              [
                51.3189954,
                36.4925804
              ],
              [
                51.3291015,
                36.5071275
              ],
              [
                51.3277233,
                36.5110636
              ],
              [
                51.3254075,
                36.5161798
              ],
              [
                51.3240325,
                36.5202892
              ],
              [
                51.3234569,
                36.5244424
              ],
              [
                51.3285876,
                36.525068
              ],
              [
                51.336729,
                36.5256264
              ],
              [
                51.3432551,
                36.5230351
              ],
              [
                51.3595441,
                36.5219248
              ],
              [
                51.3644075,
                36.5214658
              ],
              [
                51.3805722,
                36.5234453
              ],
              [
                51.3821504,
                36.5237355
              ],
              [
                51.3853837,
                36.5228303
              ],
              [
                51.3873982,
                36.5224068
              ],
              [
                51.3892555,
                36.5211365
              ],
              [
                51.3901937,
                36.5203171
              ],
              [
                51.3926525,
                36.5188862
              ],
              [
                51.3937624,
                36.5186069
              ],
              [
                51.3957092,
                36.5186069
              ],
              [
                51.3968191,
                36.5183277
              ],
              [
                51.399319,
                36.5183277
              ],
              [
                51.4076522,
                36.5169406
              ],
              [
                51.4123756,
                36.5155535
              ],
              [
                51.4493218,
                36.5091586
              ],
              [
                51.4551552,
                36.5091587
              ],
              [
                51.4579316,
                36.5088885
              ],
              [
                51.4590452,
                36.5086093
              ],
              [
                51.4598784,
                36.5086092
              ],
              [
                51.4651549,
                36.5213901
              ],
              [
                51.4651551,
                36.5219395
              ],
              [
                51.4659882,
                36.525281
              ],
              [
                51.4726547,
                36.5372149
              ],
              [
                51.4782115,
                36.5491666
              ],
              [
                51.4818213,
                36.5674947
              ],
              [
                51.4782115,
                36.5799955
              ],
              [
                51.4779347,
                36.5805537
              ],
              [
                51.4771014,
                36.5822199
              ],
              [
                51.4648782,
                36.5983317
              ],
              [
                51.4534882,
                36.6074997
              ],
              [
                51.4473751,
                36.614173
              ],
              [
                51.4429317,
                36.6230527
              ],
              [
                51.4426551,
                36.6244486
              ],
              [
                51.4423751,
                36.6263937
              ],
              [
                51.4420985,
                36.6294467
              ],
              [
                51.4420984,
                36.630005
              ],
              [
                51.4420985,
                36.631662
              ],
              [
                51.4418217,
                36.6322204
              ],
              [
                51.4415417,
                36.6330579
              ],
              [
                51.4437651,
                36.63639
              ],
              [
                51.4456742,
                36.638234
              ],
              [
                51.4464485,
                36.6385568
              ],
              [
                51.4481074,
                36.6407386
              ],
              [
                51.4490319,
                36.6431357
              ],
              [
                51.4495056,
                36.6435952
              ],
              [
                51.4494009,
                36.6443471
              ],
              [
                51.4500652,
                36.6447598
              ],
              [
                51.4509639,
                36.644859
              ],
              [
                51.4512242,
                36.6458516
              ],
              [
                51.4506498,
                36.6466495
              ],
              [
                51.4497107,
                36.6468202
              ],
              [
                51.4494298,
                36.6481879
              ],
              [
                51.4495075,
                36.6482301
              ],
              [
                51.4496699,
                36.6483659
              ],
              [
                51.4499461,
                36.6482734
              ],
              [
                51.4500194,
                36.6486008
              ],
              [
                51.4499829,
                36.648683
              ],
              [
                51.4501232,
                36.6490666
              ],
              [
                51.4503773,
                36.6493588
              ],
              [
                51.4500603,
                36.6495278
              ],
              [
                51.4503329,
                36.6499609
              ],
              [
                51.4504013,
                36.650403
              ],
              [
                51.4500011,
                36.6503456
              ],
              [
                51.449805,
                36.6505611
              ],
              [
                51.449881,
                36.651136
              ],
              [
                51.4502467,
                36.651637
              ],
              [
                51.450647,
                36.6516176
              ],
              [
                51.4510045,
                36.6524573
              ],
              [
                51.4514657,
                36.653538
              ],
              [
                51.4518597,
                36.6541084
              ],
              [
                51.4520529,
                36.6540905
              ],
              [
                51.4521669,
                36.6542123
              ],
              [
                51.4519046,
                36.6550394
              ],
              [
                51.4514592,
                36.6553233
              ],
              [
                51.4515331,
                36.6556245
              ],
              [
                51.4527566,
                36.65676
              ],
              [
                51.4525462,
                36.656823
              ],
              [
                51.4524418,
                36.6577485
              ],
              [
                51.452233,
                36.6586811
              ],
              [
                51.448123,
                36.6666259
              ],
              [
                51.4506447,
                36.6677459
              ],
              [
                51.4514399,
                36.6682332
              ],
              [
                51.4527299,
                36.6693262
              ],
              [
                51.4558239,
                36.6721051
              ],
              [
                51.5120475,
                36.8738438
              ],
              [
                51.4840685,
                36.880409
              ],
              [
                51.4819627,
                36.8807971
              ],
              [
                51.4758148,
                36.8818648
              ],
              [
                51.4696352,
                36.8828073
              ],
              [
                51.4634783,
                36.8836179
              ],
              [
                51.457298,
                36.8843042
              ],
              [
                51.4510982,
                36.8848659
              ],
              [
                51.4477694,
                36.8850997
              ],
              [
                51.4448827,
                36.8853025
              ],
              [
                51.4438894,
                36.8853621
              ],
              [
                51.4404255,
                36.8858932
              ],
              [
                51.435056,
                36.8866072
              ],
              [
                51.4296683,
                36.8872267
              ],
              [
                51.4242649,
                36.8877513
              ],
              [
                51.4188486,
                36.888181
              ],
              [
                51.4134218,
                36.8885154
              ],
              [
                51.4079871,
                36.8887543
              ],
              [
                51.4025473,
                36.8888977
              ],
              [
                51.3971049,
                36.8889455
              ],
              [
                51.3925733,
                36.8889057
              ],
              [
                51.3875979,
                36.8891841
              ],
              [
                51.3558096,
                36.8919624
              ],
              [
                51.3409383,
                36.893337
              ],
              [
                51.3402035,
                36.8934887
              ],
              [
                51.3349033,
                36.894484
              ],
              [
                51.3295772,
                36.8953859
              ],
              [
                51.2883831,
                36.697331
              ],
              [
                51.2794936,
                36.6541751
              ],
              [
                51.274497,
                36.625472
              ],
              [
                51.2719058,
                36.6197989
              ],
              [
                51.2689876,
                36.6176633
              ],
              [
                51.2585162,
                36.6111874
              ],
              [
                51.2571429,
                36.6075358
              ],
              [
                51.2573146,
                36.6012656
              ],
              [
                51.2514124,
                36.5912438
              ],
              [
                51.2516713,
                36.5881466
              ],
              [
                51.2522077,
                36.5857862
              ],
              [
                51.2535167,
                36.5840029
              ],
              [
                51.2552634,
                36.5830919
              ],
              [
                51.2702053,
                36.5750275
              ],
              [
                51.2771118,
                36.5720381
              ],
              [
                51.2743521,
                36.5698039
              ],
              [
                51.2670089,
                36.5656513
              ],
              [
                51.2600183,
                36.5607042
              ],
              [
                51.257379,
                36.5574295
              ],
              [
                51.2556839,
                36.5549129
              ],
              [
                51.2517299,
                36.5475471
              ],
              [
                51.2516498,
                36.5438462
              ],
              [
                51.2530231,
                36.5370882
              ],
              [
                51.2528873,
                36.531899
              ],
              [
                51.2562464,
                36.5221223
              ],
              [
                51.2532947,
                36.517818
              ],
              [
                51.2498257,
                36.5166379
              ],
              [
                51.2427273,
                36.5163918
              ],
              [
                51.2346553,
                36.515086
              ],
              [
                51.2326812,
                36.5125336
              ],
              [
                51.2320804,
                36.5097052
              ],
              [
                51.2320804,
                36.5002534
              ],
              [
                51.2341403,
                36.4979075
              ],
              [
                51.232767,
                36.4908005
              ],
              [
                51.2294468,
                36.4793138
              ],
              [
                51.2266451,
                36.4770999
              ],
              [
                51.2236303,
                36.4755605
              ],
              [
                51.2157703,
                36.472529
              ],
              [
                51.2066889,
                36.4684995
              ],
              [
                51.200985,
                36.4664962
              ],
              [
                51.1945724,
                36.4642295
              ],
              [
                51.1908816,
                36.4611232
              ],
              [
                51.1854743,
                36.454496
              ],
              [
                51.1750888,
                36.4445542
              ],
              [
                51.1628155,
                36.4351347
              ],
              [
                51.1555194,
                36.4317798
              ],
              [
                51.1495113,
                36.4280507
              ],
              [
                51.1439673,
                36.4205817
              ],
              [
                51.1427908,
                36.417741
              ],
              [
                51.139189,
                36.4137565
              ],
              [
                51.132325,
                36.4068491
              ],
              [
                51.1228179,
                36.4011818
              ],
              [
                51.1188697,
                36.3978657
              ],
              [
                51.1126294,
                36.3917275
              ],
              [
                51.1101794,
                36.3875015
              ],
              [
                51.1051309,
                36.3791948
              ],
              [
                51.0987852,
                36.3784501
              ],
              [
                51.0903738,
                36.3766533
              ],
              [
                51.0742377,
                36.3740273
              ],
              [
                51.0679721,
                36.3730942
              ],
              [
                51.0611914,
                36.3715394
              ],
              [
                51.0503767,
                36.3676
              ],
              [
                51.0432958,
                36.3641787
              ],
              [
                51.0387937,
                36.3616799
              ],
              [
                51.0375277,
                36.3603476
              ],
              [
                51.0356517,
                36.3581217
              ],
              [
                51.0345692,
                36.3559343
              ],
              [
                51.0395736,
                36.3431414
              ],
              [
                51.045137,
                36.3313765
              ],
              [
                51.0459974,
                36.3250812
              ],
              [
                51.0456467,
                36.3192563
              ],
              [
                51.0437246,
                36.3128197
              ],
              [
                51.0401364,
                36.3051157
              ],
              [
                51.0363442,
                36.295746
              ],
              [
                51.034755,
                36.2918138
              ],
              [
                51.0341077,
                36.2887275
              ],
              [
                51.0325363,
                36.283779
              ],
              [
                51.0303914,
                36.2773666
              ],
              [
                51.0269728,
                36.2728916
              ],
              [
                51.0230154,
                36.2705634
              ],
              [
                51.0188769,
                36.2664906
              ],
              [
                51.0143279,
                36.2629612
              ],
              [
                51.0080623,
                36.2575629
              ],
              [
                51.0033416,
                36.2525103
              ],
              [
                51.0001284,
                36.2485033
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555287,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان گلوگاه",
          "name:en": "Galugah County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2725545",
          "wikipedia": "en:Galugah County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.6322864,
                37.0842039
              ],
              [
                53.6929747,
                36.8943118
              ],
              [
                53.6939185,
                36.8912918
              ],
              [
                53.6930179,
                36.8769431
              ],
              [
                53.6899706,
                36.8678455
              ],
              [
                53.6599728,
                36.8367676
              ],
              [
                53.66927,
                36.7990647
              ],
              [
                53.6680412,
                36.7971205
              ],
              [
                53.6640071,
                36.7870509
              ],
              [
                53.6648926,
                36.7820517
              ],
              [
                53.6658954,
                36.7785612
              ],
              [
                53.6672772,
                36.7726513
              ],
              [
                53.6646509,
                36.7676297
              ],
              [
                53.6641814,
                36.7613334
              ],
              [
                53.6629343,
                36.7569373
              ],
              [
                53.6611747,
                36.7538428
              ],
              [
                53.6598014,
                36.7488913
              ],
              [
                53.6596079,
                36.7465389
              ],
              [
                53.6584711,
                36.7438707
              ],
              [
                53.6565828,
                36.7416698
              ],
              [
                53.6530208,
                36.7387122
              ],
              [
                53.6502661,
                36.7378214
              ],
              [
                53.6487192,
                36.7382108
              ],
              [
                53.6469698,
                36.7357545
              ],
              [
                53.6494159,
                36.731077
              ],
              [
                53.6503601,
                36.7265196
              ],
              [
                53.6500382,
                36.7240946
              ],
              [
                53.6499969,
                36.7221365
              ],
              [
                53.6494374,
                36.7210331
              ],
              [
                53.6494159,
                36.7205859
              ],
              [
                53.6493353,
                36.7185507
              ],
              [
                53.6495876,
                36.7167331
              ],
              [
                53.6501026,
                36.7159763
              ],
              [
                53.6498236,
                36.7149442
              ],
              [
                53.6492228,
                36.7144798
              ],
              [
                53.6491155,
                36.7134822
              ],
              [
                53.6495018,
                36.7126909
              ],
              [
                53.6493552,
                36.7112189
              ],
              [
                53.6490083,
                36.7107127
              ],
              [
                53.6489009,
                36.7095774
              ],
              [
                53.6491799,
                36.708528
              ],
              [
                53.6495876,
                36.707926
              ],
              [
                53.649376,
                36.705925
              ],
              [
                53.6479568,
                36.7030059
              ],
              [
                53.6467123,
                36.7008382
              ],
              [
                53.6469268,
                36.6988081
              ],
              [
                53.6485576,
                36.6954015
              ],
              [
                53.6490947,
                36.6936128
              ],
              [
                53.6497592,
                36.6916507
              ],
              [
                53.6498451,
                36.690171
              ],
              [
                53.650403,
                36.6885191
              ],
              [
                53.653202,
                36.6863776
              ],
              [
                53.6560249,
                36.6856972
              ],
              [
                53.6629772,
                36.6850089
              ],
              [
                53.6648654,
                36.6845271
              ],
              [
                53.6652946,
                36.6830128
              ],
              [
                53.66508,
                36.6812231
              ],
              [
                53.6635351,
                36.6798464
              ],
              [
                53.6628483,
                36.6787796
              ],
              [
                53.6605739,
                36.6745804
              ],
              [
                53.6582136,
                36.6706564
              ],
              [
                53.6606422,
                36.6667187
              ],
              [
                53.6631488,
                36.6642193
              ],
              [
                53.6662817,
                36.6615341
              ],
              [
                53.670659,
                36.6590554
              ],
              [
                53.6738716,
                36.6581858
              ],
              [
                53.6755942,
                36.6583669
              ],
              [
                53.6779975,
                36.657403
              ],
              [
                53.678255,
                36.6558881
              ],
              [
                53.6804437,
                36.6547175
              ],
              [
                53.6816453,
                36.6550963
              ],
              [
                53.6930725,
                36.6505062
              ],
              [
                53.6963653,
                36.6492088
              ],
              [
                53.7054059,
                36.6489379
              ],
              [
                53.7130487,
                36.6494746
              ],
              [
                53.7222979,
                36.6504649
              ],
              [
                53.7274068,
                36.6512737
              ],
              [
                53.7361634,
                36.6530761
              ],
              [
                53.741598,
                36.6518944
              ],
              [
                53.7456321,
                36.6518255
              ],
              [
                53.7498336,
                36.6525477
              ],
              [
                53.7602163,
                36.6508555
              ],
              [
                53.7682914,
                36.6498285
              ],
              [
                53.7745142,
                36.6483824
              ],
              [
                53.7757624,
                36.6463956
              ],
              [
                53.774583,
                36.6436783
              ],
              [
                53.7726285,
                36.6373537
              ],
              [
                53.769937,
                36.6260337
              ],
              [
                53.7684263,
                36.610932
              ],
              [
                53.7693225,
                36.6021381
              ],
              [
                53.7741289,
                36.5989802
              ],
              [
                53.7850289,
                36.6007574
              ],
              [
                53.7981185,
                36.5990191
              ],
              [
                53.816811,
                36.5975222
              ],
              [
                53.829457,
                36.5992986
              ],
              [
                53.8506692,
                36.6029978
              ],
              [
                53.8557093,
                36.6040877
              ],
              [
                53.8762879,
                36.6058035
              ],
              [
                53.8977077,
                36.6071778
              ],
              [
                53.9212254,
                36.611599
              ],
              [
                53.9443257,
                36.6156769
              ],
              [
                53.9565077,
                36.620599
              ],
              [
                53.9697663,
                36.6204404
              ],
              [
                53.9798474,
                36.622136
              ],
              [
                53.9920074,
                36.6237038
              ],
              [
                54.0008507,
                36.6248473
              ],
              [
                54.0130325,
                36.6211207
              ],
              [
                54.0231148,
                36.6241678
              ],
              [
                54.0352988,
                36.6282298
              ],
              [
                54.0491664,
                36.6309715
              ],
              [
                54.0699562,
                36.6323587
              ],
              [
                54.0477795,
                36.6422267
              ],
              [
                54.0346512,
                36.6439023
              ],
              [
                54.0307613,
                36.6439023
              ],
              [
                54.0275861,
                36.6425529
              ],
              [
                54.0264761,
                36.642553
              ],
              [
                54.0256428,
                36.6428231
              ],
              [
                54.0242528,
                36.6428231
              ],
              [
                54.0236961,
                36.6431024
              ],
              [
                54.0225861,
                36.6431023
              ],
              [
                54.0211962,
                36.6436607
              ],
              [
                54.0200862,
                36.6436607
              ],
              [
                54.0195295,
                36.6439398
              ],
              [
                54.0186962,
                36.6439399
              ],
              [
                54.0184196,
                36.6442191
              ],
              [
                54.0173096,
                36.644219
              ],
              [
                54.0167529,
                36.6444893
              ],
              [
                54.014253,
                36.6444893
              ],
              [
                54.0136963,
                36.6447684
              ],
              [
                54.0109196,
                36.6450476
              ],
              [
                53.9969433,
                36.6513942
              ],
              [
                53.9936101,
                36.6533394
              ],
              [
                53.9922201,
                36.6544471
              ],
              [
                53.9744402,
                36.6694497
              ],
              [
                53.9738474,
                36.669847
              ],
              [
                53.9647204,
                36.675285
              ],
              [
                53.9511072,
                36.6766628
              ],
              [
                53.9499972,
                36.6769419
              ],
              [
                53.9472172,
                36.6769419
              ],
              [
                53.9465393,
                36.6767714
              ],
              [
                53.9391606,
                36.6766628
              ],
              [
                53.9383272,
                36.676942
              ],
              [
                53.932774,
                36.6769419
              ],
              [
                53.929994,
                36.6763926
              ],
              [
                53.9280508,
                36.6763926
              ],
              [
                53.9266608,
                36.6761135
              ],
              [
                53.9244409,
                36.6761135
              ],
              [
                53.9233274,
                36.6758343
              ],
              [
                53.9205508,
                36.6755551
              ],
              [
                53.9130509,
                36.6730608
              ],
              [
                53.9063844,
                36.6713858
              ],
              [
                53.9044377,
                36.6713858
              ],
              [
                53.8972144,
                36.670008
              ],
              [
                53.8958278,
                36.6700081
              ],
              [
                53.8949945,
                36.6697289
              ],
              [
                53.8936045,
                36.6697289
              ],
              [
                53.8927711,
                36.6694497
              ],
              [
                53.8911045,
                36.6694497
              ],
              [
                53.8883279,
                36.6694497
              ],
              [
                53.8872145,
                36.6691705
              ],
              [
                53.8827713,
                36.6691706
              ],
              [
                53.8747147,
                36.6711157
              ],
              [
                53.8733247,
                36.6713859
              ],
              [
                53.8711345,
                36.672555
              ],
              [
                53.869158,
                36.6736101
              ],
              [
                53.8647148,
                36.6794543
              ],
              [
                53.8619348,
                36.6861091
              ],
              [
                53.8622148,
                36.6902783
              ],
              [
                53.8622148,
                36.6925025
              ],
              [
                53.8622149,
                36.6936191
              ],
              [
                53.8619348,
                36.6941684
              ],
              [
                53.8613815,
                36.6961134
              ],
              [
                53.8608248,
                36.6972211
              ],
              [
                53.8608248,
                36.698896
              ],
              [
                53.8622148,
                36.7044429
              ],
              [
                53.8624915,
                36.7050012
              ],
              [
                53.8624915,
                36.7230554
              ],
              [
                53.8622149,
                36.7233345
              ],
              [
                53.8619348,
                36.7250003
              ],
              [
                53.8616582,
                36.7300068
              ],
              [
                53.8611015,
                36.7333385
              ],
              [
                53.8602681,
                36.7358417
              ],
              [
                53.8605482,
                36.7391733
              ],
              [
                53.8608248,
                36.7397225
              ],
              [
                53.8644382,
                36.7447289
              ],
              [
                53.8661048,
                36.7494471
              ],
              [
                53.8616582,
                36.7636195
              ],
              [
                53.8622148,
                36.7769544
              ],
              [
                53.8624915,
                36.7800067
              ],
              [
                53.8622148,
                36.7805649
              ],
              [
                53.8624914,
                36.780844
              ],
              [
                53.8622148,
                36.7811231
              ],
              [
                53.8622148,
                36.7815592
              ],
              [
                53.8621766,
                36.7823724
              ],
              [
                53.8574156,
                36.8836278
              ],
              [
                53.8565366,
                36.9023082
              ],
              [
                53.8548049,
                36.939096
              ],
              [
                53.7295316,
                37.0930997
              ],
              [
                53.7287684,
                37.0930393
              ],
              [
                53.7265603,
                37.0928646
              ],
              [
                53.7211424,
                37.09234
              ],
              [
                53.7157402,
                37.0917205
              ],
              [
                53.7103563,
                37.0910065
              ],
              [
                53.708484,
                37.0907104
              ],
              [
                53.6974703,
                37.090144
              ],
              [
                53.6933988,
                37.0896508
              ],
              [
                53.6662469,
                37.0863611
              ],
              [
                53.645455,
                37.0852139
              ],
              [
                53.6388623,
                37.0847789
              ],
              [
                53.6322864,
                37.0842039
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32674103
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.0586327,
          36.5659626
        ]
      }
    }
  ]
},
"مرکزی.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554862,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان آشتیان",
          "name:en": "Ashtian County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277854",
          "wikipedia": "fa:شهرستان آشتیان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.7750789,
                34.4691049
              ],
              [
                49.7750789,
                34.4688341
              ],
              [
                49.774802,
                34.4685544
              ],
              [
                49.7742453,
                34.4674444
              ],
              [
                49.7611888,
                34.4510476
              ],
              [
                49.7578556,
                34.4393884
              ],
              [
                49.7581357,
                34.4382784
              ],
              [
                49.7584122,
                34.4374482
              ],
              [
                49.7586888,
                34.435499
              ],
              [
                49.7606357,
                34.4313298
              ],
              [
                49.7723024,
                34.4230004
              ],
              [
                49.7750791,
                34.4216107
              ],
              [
                49.7890288,
                34.4113832
              ],
              [
                49.7935225,
                34.4069767
              ],
              [
                49.8167483,
                34.3888342
              ],
              [
                49.8248051,
                34.3821651
              ],
              [
                49.8342484,
                34.3660563
              ],
              [
                49.8386948,
                34.3621667
              ],
              [
                49.8403614,
                34.3610567
              ],
              [
                49.841195,
                34.3602174
              ],
              [
                49.8703612,
                34.3507777
              ],
              [
                49.8720276,
                34.3507776
              ],
              [
                49.8728613,
                34.3504979
              ],
              [
                49.8775844,
                34.3504979
              ],
              [
                49.8917507,
                34.3488284
              ],
              [
                49.8959175,
                34.3488284
              ],
              [
                49.8967508,
                34.3485487
              ],
              [
                49.9059209,
                34.3482779
              ],
              [
                49.9070307,
                34.3485487
              ],
              [
                49.9089741,
                34.3482779
              ],
              [
                49.9109206,
                34.3485486
              ],
              [
                49.9161973,
                34.3485487
              ],
              [
                49.9178637,
                34.3488284
              ],
              [
                49.9236971,
                34.3488284
              ],
              [
                49.9245303,
                34.3491082
              ],
              [
                49.9270303,
                34.3491082
              ],
              [
                49.9289773,
                34.349388
              ],
              [
                49.9375868,
                34.349388
              ],
              [
                49.9420338,
                34.3488285
              ],
              [
                49.9445334,
                34.3488285
              ],
              [
                49.9462003,
                34.3485487
              ],
              [
                49.951477,
                34.348278
              ],
              [
                49.9542535,
                34.348278
              ],
              [
                49.96481,
                34.348278
              ],
              [
                49.9650901,
                34.3479982
              ],
              [
                49.9661999,
                34.3479982
              ],
              [
                49.9664765,
                34.3477185
              ],
              [
                49.9670331,
                34.3477185
              ],
              [
                49.9684233,
                34.347159
              ],
              [
                49.9739766,
                34.3432783
              ],
              [
                49.9773135,
                34.3352192
              ],
              [
                49.97759,
                34.3346597
              ],
              [
                49.9806467,
                34.3224401
              ],
              [
                49.9809233,
                34.3207796
              ],
              [
                49.98148,
                34.3182707
              ],
              [
                49.9817565,
                34.3163304
              ],
              [
                49.9823132,
                34.3149405
              ],
              [
                49.9823132,
                34.3138305
              ],
              [
                49.9825898,
                34.31328
              ],
              [
                49.9825897,
                34.3085509
              ],
              [
                49.9828663,
                34.3082711
              ],
              [
                49.9850898,
                34.3077206
              ],
              [
                50.0134228,
                34.3077207
              ],
              [
                50.0139794,
                34.3080005
              ],
              [
                50.0292594,
                34.3093813
              ],
              [
                50.0328694,
                34.3093813
              ],
              [
                50.0339826,
                34.3096611
              ],
              [
                50.035649,
                34.3096611
              ],
              [
                50.0364826,
                34.3099408
              ],
              [
                50.0381492,
                34.3099409
              ],
              [
                50.0628722,
                34.3152204
              ],
              [
                50.0650922,
                34.3154912
              ],
              [
                50.0670387,
                34.315771
              ],
              [
                50.0678719,
                34.3160507
              ],
              [
                50.0695388,
                34.3160507
              ],
              [
                50.0698153,
                34.3163305
              ],
              [
                50.0712052,
                34.3163305
              ],
              [
                50.0714822,
                34.3166102
              ],
              [
                50.0759287,
                34.3171608
              ],
              [
                50.0787054,
                34.3171608
              ],
              [
                50.078982,
                34.3174405
              ],
              [
                50.0798152,
                34.3174406
              ],
              [
                50.0809285,
                34.3174406
              ],
              [
                50.081482,
                34.3174406
              ],
              [
                50.0817621,
                34.3177203
              ],
              [
                50.0825953,
                34.3177203
              ],
              [
                50.0834285,
                34.3180001
              ],
              [
                50.1014851,
                34.3246605
              ],
              [
                50.1120416,
                34.3296692
              ],
              [
                50.1200949,
                34.331059
              ],
              [
                50.1206516,
                34.3307793
              ],
              [
                50.1220414,
                34.3307793
              ],
              [
                50.1228746,
                34.3304995
              ],
              [
                50.1239848,
                34.3304995
              ],
              [
                50.128708,
                34.3285502
              ],
              [
                50.1331515,
                34.3202203
              ],
              [
                50.137598,
                34.3154913
              ],
              [
                50.1534312,
                34.3093815
              ],
              [
                50.1703776,
                34.3066109
              ],
              [
                50.1731542,
                34.3066109
              ],
              [
                50.1739875,
                34.3063311
              ],
              [
                50.178711,
                34.3063311
              ],
              [
                50.1795441,
                34.3060513
              ],
              [
                50.1825974,
                34.3060513
              ],
              [
                50.1828775,
                34.3057715
              ],
              [
                50.1839873,
                34.3057716
              ],
              [
                50.1878771,
                34.3043818
              ],
              [
                50.1901007,
                34.2985516
              ],
              [
                50.1903773,
                34.2954922
              ],
              [
                50.1906538,
                34.2938315
              ],
              [
                50.1912105,
                34.2929923
              ],
              [
                50.1914874,
                34.2918822
              ],
              [
                50.1956539,
                34.2902126
              ],
              [
                50.1978773,
                34.2899418
              ],
              [
                50.2037103,
                34.2902126
              ],
              [
                50.204267,
                34.2899419
              ],
              [
                50.2053771,
                34.2899419
              ],
              [
                50.2109339,
                34.2877127
              ],
              [
                50.2139903,
                34.2852218
              ],
              [
                50.215657,
                34.2835522
              ],
              [
                50.2209337,
                34.2793827
              ],
              [
                50.2298234,
                34.2716031
              ],
              [
                50.2351001,
                34.2691031
              ],
              [
                50.2489898,
                34.2635527
              ],
              [
                50.2509368,
                34.2616033
              ],
              [
                50.2514899,
                34.2616032
              ],
              [
                50.25177,
                34.2613235
              ],
              [
                50.2539899,
                34.260773
              ],
              [
                50.2553798,
                34.260773
              ],
              [
                50.2581564,
                34.2618831
              ],
              [
                50.2589931,
                34.2618831
              ],
              [
                50.2592697,
                34.2621628
              ],
              [
                50.2601033,
                34.2621629
              ],
              [
                50.2603799,
                34.2624426
              ],
              [
                50.2612131,
                34.2624427
              ],
              [
                50.2617697,
                34.2624426
              ],
              [
                50.2639932,
                34.2627134
              ],
              [
                50.2642698,
                34.2624427
              ],
              [
                50.2703797,
                34.2638325
              ],
              [
                50.2709363,
                34.2643831
              ],
              [
                50.271493,
                34.2646628
              ],
              [
                50.2717695,
                34.2649426
              ],
              [
                50.2723262,
                34.2652134
              ],
              [
                50.2917692,
                34.2743829
              ],
              [
                50.3270487,
                34.2941116
              ],
              [
                50.3281621,
                34.2952217
              ],
              [
                50.3289957,
                34.2957721
              ],
              [
                50.3403854,
                34.3099413
              ],
              [
                50.3548285,
                34.3379994
              ],
              [
                50.3598282,
                34.344389
              ],
              [
                50.3613046,
                34.3455173
              ],
              [
                50.36219,
                34.3461939
              ],
              [
                50.3614951,
                34.3468888
              ],
              [
                50.3601083,
                34.3488291
              ],
              [
                50.3601083,
                34.3493886
              ],
              [
                50.3528851,
                34.374107
              ],
              [
                50.3531617,
                34.3743867
              ],
              [
                50.3523285,
                34.3777168
              ],
              [
                50.352605,
                34.3804964
              ],
              [
                50.352885,
                34.3816063
              ],
              [
                50.3531617,
                34.3821658
              ],
              [
                50.3495518,
                34.3879957
              ],
              [
                50.3492716,
                34.3882754
              ],
              [
                50.3403852,
                34.3957747
              ],
              [
                50.3362187,
                34.4002238
              ],
              [
                50.335662,
                34.4005035
              ],
              [
                50.3353854,
                34.4010541
              ],
              [
                50.3348287,
                34.4013338
              ],
              [
                50.3317721,
                34.4068837
              ],
              [
                50.3314956,
                34.4080028
              ],
              [
                50.3353854,
                34.4213317
              ],
              [
                50.3362187,
                34.4241112
              ],
              [
                50.3370518,
                34.4274411
              ],
              [
                50.337885,
                34.4371693
              ],
              [
                50.3376054,
                34.4379995
              ],
              [
                50.3373284,
                34.439669
              ],
              [
                50.3351052,
                34.4421688
              ],
              [
                50.3314955,
                34.4424394
              ],
              [
                50.3292719,
                34.4421687
              ],
              [
                50.3126056,
                34.4377198
              ],
              [
                50.311772,
                34.4377198
              ],
              [
                50.3106587,
                34.4371692
              ],
              [
                50.3095489,
                34.4371693
              ],
              [
                50.3084387,
                34.4366098
              ],
              [
                50.3076055,
                34.4366098
              ],
              [
                50.3070488,
                34.43633
              ],
              [
                50.3053825,
                34.43633
              ],
              [
                50.3051055,
                34.4360503
              ],
              [
                50.3042722,
                34.4360502
              ],
              [
                50.300939,
                34.4363299
              ],
              [
                50.2917689,
                34.4377198
              ],
              [
                50.2912157,
                34.4379995
              ],
              [
                50.2903826,
                34.4379994
              ],
              [
                50.2898258,
                34.4382792
              ],
              [
                50.2889926,
                34.4382792
              ],
              [
                50.2814925,
                34.4416092
              ],
              [
                50.2809358,
                34.4421686
              ],
              [
                50.2770459,
                34.4435583
              ],
              [
                50.2762127,
                34.4443886
              ],
              [
                50.2751025,
                34.444939
              ],
              [
                50.2712126,
                34.4524471
              ],
              [
                50.2698261,
                34.4529976
              ],
              [
                50.2664926,
                34.4527268
              ],
              [
                50.2662128,
                34.4524471
              ],
              [
                50.2603795,
                34.4529976
              ],
              [
                50.259826,
                34.4532774
              ],
              [
                50.2545461,
                34.4532773
              ],
              [
                50.2542697,
                34.4535571
              ],
              [
                50.2520461,
                34.4535571
              ],
              [
                50.2512129,
                34.4538369
              ],
              [
                50.2470465,
                34.4538369
              ],
              [
                50.2439897,
                34.4541075
              ],
              [
                50.2437132,
                34.4543873
              ],
              [
                50.2414896,
                34.4543873
              ],
              [
                50.2406565,
                34.454667
              ],
              [
                50.2398229,
                34.454667
              ],
              [
                50.2395462,
                34.4549468
              ],
              [
                50.2384329,
                34.4549467
              ],
              [
                50.2281566,
                34.457997
              ],
              [
                50.2217666,
                34.4591159
              ],
              [
                50.2156568,
                34.4602168
              ],
              [
                50.2148235,
                34.4604965
              ],
              [
                50.2134333,
                34.4604966
              ],
              [
                50.1951004,
                34.4643859
              ],
              [
                50.1937102,
                34.4643859
              ],
              [
                50.1931534,
                34.4646657
              ],
              [
                50.1912101,
                34.4646656
              ],
              [
                50.1906535,
                34.4649453
              ],
              [
                50.1887105,
                34.4649454
              ],
              [
                50.1856538,
                34.4655048
              ],
              [
                50.1784305,
                34.4655049
              ],
              [
                50.177877,
                34.4657847
              ],
              [
                50.1753769,
                34.4657846
              ],
              [
                50.1653772,
                34.4677248
              ],
              [
                50.1637072,
                34.4677248
              ],
              [
                50.1595407,
                34.4685549
              ],
              [
                50.1481542,
                34.4732836
              ],
              [
                50.1464877,
                34.4752237
              ],
              [
                50.1462075,
                34.4760539
              ],
              [
                50.1459306,
                34.4763337
              ],
              [
                50.1467643,
                34.4780031
              ],
              [
                50.147874,
                34.4805027
              ],
              [
                50.1498209,
                34.4835528
              ],
              [
                50.1575972,
                34.490781
              ],
              [
                50.1589871,
                34.5035588
              ],
              [
                50.1570406,
                34.5091175
              ],
              [
                50.1484306,
                34.5163366
              ],
              [
                50.1442641,
                34.5180059
              ],
              [
                50.118151,
                34.5368926
              ],
              [
                50.1175943,
                34.5382821
              ],
              [
                50.1125942,
                34.5452213
              ],
              [
                50.1100946,
                34.5496699
              ],
              [
                50.1051137,
                34.557358
              ],
              [
                50.1045378,
                34.5579987
              ],
              [
                50.1025944,
                34.5607869
              ],
              [
                50.1000943,
                34.5632774
              ],
              [
                50.0987045,
                34.564667
              ],
              [
                50.0912047,
                34.5724543
              ],
              [
                50.0887046,
                34.5788339
              ],
              [
                50.0864811,
                34.5823911
              ],
              [
                50.0859877,
                34.5823628
              ],
              [
                50.0853714,
                34.5824432
              ],
              [
                50.0745383,
                34.5896709
              ],
              [
                50.0737047,
                34.5896709
              ],
              [
                50.0617584,
                34.5949496
              ],
              [
                50.0575915,
                34.5988386
              ],
              [
                50.0523152,
                34.6088364
              ],
              [
                50.0520382,
                34.6107854
              ],
              [
                50.051205,
                34.6155045
              ],
              [
                50.0509249,
                34.6157842
              ],
              [
                50.0453685,
                34.6202236
              ],
              [
                50.0445349,
                34.6202237
              ],
              [
                50.0398153,
                34.6213426
              ],
              [
                50.034535,
                34.6213425
              ],
              [
                50.0337018,
                34.6210628
              ],
              [
                50.0312019,
                34.6210628
              ],
              [
                50.0245353,
                34.6185544
              ],
              [
                50.0234254,
                34.6185543
              ],
              [
                50.0145355,
                34.6163347
              ],
              [
                50.0084221,
                34.6149451
              ],
              [
                50.0073122,
                34.6143946
              ],
              [
                50.0061002,
                34.6139879
              ],
              [
                50.0056454,
                34.6138352
              ],
              [
                50.0045357,
                34.6135555
              ],
              [
                49.9875892,
                34.6080062
              ],
              [
                49.9864791,
                34.6080062
              ],
              [
                49.9859224,
                34.6077265
              ],
              [
                49.9836993,
                34.6077264
              ],
              [
                49.9831458,
                34.6074467
              ],
              [
                49.9775895,
                34.6074467
              ],
              [
                49.9773128,
                34.6077265
              ],
              [
                49.9767558,
                34.6077264
              ],
              [
                49.9764793,
                34.6080062
              ],
              [
                49.971756,
                34.6102259
              ],
              [
                49.9709228,
                34.6102258
              ],
              [
                49.9703662,
                34.6105056
              ],
              [
                49.969256,
                34.6105055
              ],
              [
                49.9686993,
                34.6107853
              ],
              [
                49.9606429,
                34.6127253
              ],
              [
                49.958423,
                34.6127252
              ],
              [
                49.9461997,
                34.6082768
              ],
              [
                49.945643,
                34.6080062
              ],
              [
                49.9331432,
                34.5993979
              ],
              [
                49.90814,
                34.5799435
              ],
              [
                49.8984167,
                34.5771733
              ],
              [
                49.8828637,
                34.5668866
              ],
              [
                49.8820305,
                34.5663361
              ],
              [
                49.8809172,
                34.5657766
              ],
              [
                49.8653606,
                34.5566178
              ],
              [
                49.8509177,
                34.5527286
              ],
              [
                49.8467509,
                34.5521691
              ],
              [
                49.8311948,
                34.5477205
              ],
              [
                49.8298045,
                34.5468903
              ],
              [
                49.8017484,
                34.5371627
              ],
              [
                49.7953585,
                34.5335533
              ],
              [
                49.7923018,
                34.5305033
              ],
              [
                49.7917483,
                34.5299438
              ],
              [
                49.7909151,
                34.5288339
              ],
              [
                49.7873017,
                34.5243942
              ],
              [
                49.7870251,
                34.5241145
              ],
              [
                49.7865801,
                34.5234508
              ],
              [
                49.7864685,
                34.5232843
              ],
              [
                49.7859118,
                34.5227248
              ],
              [
                49.7784121,
                34.5102178
              ],
              [
                49.7764687,
                34.499669
              ],
              [
                49.7767453,
                34.4963301
              ],
              [
                49.7770254,
                34.4955
              ],
              [
                49.7756356,
                34.4777229
              ],
              [
                49.7759121,
                34.4768835
              ],
              [
                49.7759121,
                34.4735537
              ],
              [
                49.7756355,
                34.4730033
              ],
              [
                49.7750789,
                34.4696644
              ],
              [
                49.7750789,
                34.4691049
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554870,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اراک",
          "name:cs": "Arák",
          "name:en": "Arak County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1266092",
          "wikipedia": "fa:شهرستان اراک"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.2900578,
                34.5285533
              ],
              [
                49.2900579,
                34.5277231
              ],
              [
                49.2903345,
                34.5271637
              ],
              [
                49.286168,
                34.5043877
              ],
              [
                49.2858915,
                34.501888
              ],
              [
                49.2920014,
                34.4857804
              ],
              [
                49.292558,
                34.4827212
              ],
              [
                49.2928346,
                34.478832
              ],
              [
                49.2931112,
                34.4782815
              ],
              [
                49.2931112,
                34.4702231
              ],
              [
                49.3006145,
                34.4502257
              ],
              [
                49.3008915,
                34.449946
              ],
              [
                49.3008915,
                34.445497
              ],
              [
                49.2992246,
                34.4418873
              ],
              [
                49.2945016,
                34.4382776
              ],
              [
                49.2920015,
                34.4374474
              ],
              [
                49.2811681,
                34.4332783
              ],
              [
                49.2653354,
                34.4121613
              ],
              [
                49.2647783,
                34.4066024
              ],
              [
                49.2670018,
                34.4007726
              ],
              [
                49.277835,
                34.3882738
              ],
              [
                49.2797783,
                34.3852145
              ],
              [
                49.2806115,
                34.3843843
              ],
              [
                49.2847785,
                34.3779949
              ],
              [
                49.2861684,
                34.3766051
              ],
              [
                49.2875582,
                34.3760546
              ],
              [
                49.289225,
                34.3760546
              ],
              [
                49.2897782,
                34.3757749
              ],
              [
                49.2911684,
                34.3757749
              ],
              [
                49.2917251,
                34.3754951
              ],
              [
                49.2925583,
                34.3754951
              ],
              [
                49.2942247,
                34.3757748
              ],
              [
                49.2947783,
                34.3760547
              ],
              [
                49.3056148,
                34.3793848
              ],
              [
                49.3067246,
                34.3793848
              ],
              [
                49.3072813,
                34.3796644
              ],
              [
                49.3097813,
                34.3799352
              ],
              [
                49.317558,
                34.3799352
              ],
              [
                49.3189479,
                34.380215
              ],
              [
                49.3217245,
                34.380215
              ],
              [
                49.3228378,
                34.3799352
              ],
              [
                49.3292243,
                34.3793848
              ],
              [
                49.3397812,
                34.3788343
              ],
              [
                49.3408945,
                34.379114
              ],
              [
                49.3514474,
                34.3793848
              ],
              [
                49.3522806,
                34.379114
              ],
              [
                49.3545041,
                34.3791141
              ],
              [
                49.3553374,
                34.3788343
              ],
              [
                49.3567276,
                34.3788343
              ],
              [
                49.3575609,
                34.3785545
              ],
              [
                49.3589506,
                34.3785545
              ],
              [
                49.3689505,
                34.3743853
              ],
              [
                49.3695041,
                34.373555
              ],
              [
                49.3706174,
                34.3729954
              ],
              [
                49.3714506,
                34.3718854
              ],
              [
                49.3720073,
                34.3704956
              ],
              [
                49.3722838,
                34.3693856
              ],
              [
                49.3733939,
                34.3674453
              ],
              [
                49.3739506,
                34.3674453
              ],
              [
                49.3742272,
                34.3671656
              ],
              [
                49.3756174,
                34.3666061
              ],
              [
                49.3761741,
                34.3657758
              ],
              [
                49.3753405,
                34.3621659
              ],
              [
                49.3742272,
                34.3579966
              ],
              [
                49.3850607,
                34.347158
              ],
              [
                49.3908971,
                34.3452177
              ],
              [
                49.3975637,
                34.3452177
              ],
              [
                49.3997837,
                34.3454974
              ],
              [
                49.4017302,
                34.3454975
              ],
              [
                49.4054021,
                34.3453124
              ],
              [
                49.408117,
                34.3438279
              ],
              [
                49.4092304,
                34.3407686
              ],
              [
                49.4095069,
                34.3393787
              ],
              [
                49.4108968,
                34.3357779
              ],
              [
                49.4120069,
                34.3346588
              ],
              [
                49.412007,
                34.3318791
              ],
              [
                49.4103402,
                34.3268884
              ],
              [
                49.4100635,
                34.3207787
              ],
              [
                49.4122871,
                34.3168799
              ],
              [
                49.4150638,
                34.3149397
              ],
              [
                49.4170068,
                34.3141003
              ],
              [
                49.422287,
                34.3124398
              ],
              [
                49.424787,
                34.3118893
              ],
              [
                49.4297867,
                34.3104994
              ],
              [
                49.4361767,
                34.3104995
              ],
              [
                49.4370099,
                34.3102197
              ],
              [
                49.4389533,
                34.3102197
              ],
              [
                49.4397864,
                34.3099399
              ],
              [
                49.4422866,
                34.30994
              ],
              [
                49.4486765,
                34.3082703
              ],
              [
                49.4556197,
                34.2993898
              ],
              [
                49.4564533,
                34.2993899
              ],
              [
                49.456733,
                34.29911
              ],
              [
                49.4581197,
                34.2991101
              ],
              [
                49.4586764,
                34.2988303
              ],
              [
                49.4647863,
                34.2988303
              ],
              [
                49.4653428,
                34.2991101
              ],
              [
                49.4670097,
                34.29911
              ],
              [
                49.4722895,
                34.3002201
              ],
              [
                49.4750662,
                34.3002201
              ],
              [
                49.476456,
                34.2996606
              ],
              [
                49.4789561,
                34.2991101
              ],
              [
                49.4825659,
                34.2991101
              ],
              [
                49.4831229,
                34.2993898
              ],
              [
                49.4886794,
                34.3002201
              ],
              [
                49.4925661,
                34.3002202
              ],
              [
                49.4928461,
                34.2999404
              ],
              [
                49.4936794,
                34.2999404
              ],
              [
                49.4939559,
                34.2996606
              ],
              [
                49.4997894,
                34.2982709
              ],
              [
                49.5131224,
                34.2941103
              ],
              [
                49.5145123,
                34.2941103
              ],
              [
                49.5147889,
                34.2938305
              ],
              [
                49.5164557,
                34.2938306
              ],
              [
                49.5170123,
                34.2935508
              ],
              [
                49.5189557,
                34.2935508
              ],
              [
                49.5195124,
                34.293271
              ],
              [
                49.5195124,
                34.2907711
              ],
              [
                49.5220125,
                34.286051
              ],
              [
                49.5231258,
                34.2846612
              ],
              [
                49.5309022,
                34.2641021
              ],
              [
                49.5311787,
                34.2621617
              ],
              [
                49.5314588,
                34.2610516
              ],
              [
                49.5317358,
                34.259382
              ],
              [
                49.5320123,
                34.2582719
              ],
              [
                49.5322924,
                34.2571619
              ],
              [
                49.532569,
                34.2541023
              ],
              [
                49.5328456,
                34.2516023
              ],
              [
                49.5331256,
                34.2513225
              ],
              [
                49.5331256,
                34.2504922
              ],
              [
                49.5334023,
                34.2502124
              ],
              [
                49.5336789,
                34.2485518
              ],
              [
                49.5339589,
                34.248272
              ],
              [
                49.5334023,
                34.239662
              ],
              [
                49.5328455,
                34.2379924
              ],
              [
                49.5309022,
                34.2324418
              ],
              [
                49.5306257,
                34.2249328
              ],
              [
                49.5195125,
                34.2154923
              ],
              [
                49.4997896,
                34.2038315
              ],
              [
                49.4981227,
                34.2035517
              ],
              [
                49.4981227,
                34.2032719
              ],
              [
                49.4964563,
                34.2032719
              ],
              [
                49.4961797,
                34.2029922
              ],
              [
                49.4942328,
                34.2029921
              ],
              [
                49.4939562,
                34.2027123
              ],
              [
                49.4836763,
                34.2024416
              ],
              [
                49.4828431,
                34.2021618
              ],
              [
                49.4811762,
                34.2021618
              ],
              [
                49.4806231,
                34.2018819
              ],
              [
                49.4761766,
                34.2018819
              ],
              [
                49.4761765,
                34.2016021
              ],
              [
                49.4753429,
                34.2016022
              ],
              [
                49.4720097,
                34.2002122
              ],
              [
                49.4714565,
                34.2002122
              ],
              [
                49.469233,
                34.1988223
              ],
              [
                49.4720097,
                34.1924414
              ],
              [
                49.4722897,
                34.191602
              ],
              [
                49.4725663,
                34.1882716
              ],
              [
                49.4728433,
                34.1879918
              ],
              [
                49.4734,
                34.1866019
              ],
              [
                49.4778431,
                34.1821524
              ],
              [
                49.4822896,
                34.1807714
              ],
              [
                49.4858998,
                34.1796612
              ],
              [
                49.4892331,
                34.1766017
              ],
              [
                49.4908996,
                34.1732712
              ],
              [
                49.4911797,
                34.1718813
              ],
              [
                49.4867331,
                34.1635507
              ],
              [
                49.4839565,
                34.1554908
              ],
              [
                49.4833998,
                34.1546605
              ],
              [
                49.4778431,
                34.1477107
              ],
              [
                49.4661765,
                34.1452196
              ],
              [
                49.4650668,
                34.1449398
              ],
              [
                49.4631202,
                34.1449398
              ],
              [
                49.4403436,
                34.1340999
              ],
              [
                49.438397,
                34.1332695
              ],
              [
                49.4328438,
                34.1274389
              ],
              [
                49.4322871,
                34.1243792
              ],
              [
                49.4322872,
                34.1227094
              ],
              [
                49.4322872,
                34.1224386
              ],
              [
                49.433397,
                34.1193789
              ],
              [
                49.4347872,
                34.117989
              ],
              [
                49.4347873,
                34.1174384
              ],
              [
                49.4361772,
                34.1160484
              ],
              [
                49.4370104,
                34.1143787
              ],
              [
                49.4370104,
                34.1074378
              ],
              [
                49.4386773,
                34.102988
              ],
              [
                49.4539537,
                34.0899366
              ],
              [
                49.4561769,
                34.0871567
              ],
              [
                49.457287,
                34.0838261
              ],
              [
                49.457287,
                34.0832665
              ],
              [
                49.4572869,
                34.0824361
              ],
              [
                49.4575671,
                34.0818765
              ],
              [
                49.4578437,
                34.0802157
              ],
              [
                49.4578437,
                34.0799359
              ],
              [
                49.4578437,
                34.0788257
              ],
              [
                49.4589534,
                34.077156
              ],
              [
                49.4625669,
                34.0727062
              ],
              [
                49.4897901,
                34.0540945
              ],
              [
                49.49118,
                34.0527135
              ],
              [
                49.4928468,
                34.0482636
              ],
              [
                49.4931233,
                34.0479838
              ],
              [
                49.4933999,
                34.0466028
              ],
              [
                49.49368,
                34.044933
              ],
              [
                49.4939566,
                34.0410427
              ],
              [
                49.49368,
                34.0382717
              ],
              [
                49.4939567,
                34.0371525
              ],
              [
                49.4928468,
                34.0268717
              ],
              [
                49.4906233,
                34.022151
              ],
              [
                49.4822901,
                34.0140995
              ],
              [
                49.4806236,
                34.0129893
              ],
              [
                49.480067,
                34.0118791
              ],
              [
                49.4798815,
                34.0117859
              ],
              [
                49.4797817,
                34.0117358
              ],
              [
                49.4796198,
                34.0116544
              ],
              [
                49.4795103,
                34.0115993
              ],
              [
                49.4794801,
                34.0114785
              ],
              [
                49.4793818,
                34.0110844
              ],
              [
                49.4784001,
                34.0071493
              ],
              [
                49.4775669,
                34.0038186
              ],
              [
                49.4767337,
                34.0027084
              ],
              [
                49.4764568,
                34.0002894
              ],
              [
                49.4764567,
                33.9979876
              ],
              [
                49.4836495,
                33.9955904
              ],
              [
                49.4872902,
                33.9943771
              ],
              [
                49.4939568,
                33.988817
              ],
              [
                49.4983998,
                33.9871561
              ],
              [
                49.4995135,
                33.9871561
              ],
              [
                49.5006233,
                33.9871561
              ],
              [
                49.5011799,
                33.9868763
              ],
              [
                49.5020131,
                33.9868763
              ],
              [
                49.5022901,
                33.9865965
              ],
              [
                49.5028468,
                33.9865965
              ],
              [
                49.5134033,
                33.979935
              ],
              [
                49.5192366,
                33.9757648
              ],
              [
                49.5200698,
                33.9757648
              ],
              [
                49.5203464,
                33.975485
              ],
              [
                49.5242363,
                33.975485
              ],
              [
                49.5247929,
                33.9757649
              ],
              [
                49.5256266,
                33.9757648
              ],
              [
                49.5267363,
                33.975485
              ],
              [
                49.5270129,
                33.9757648
              ],
              [
                49.5297929,
                33.9757649
              ],
              [
                49.5300695,
                33.9760447
              ],
              [
                49.5311793,
                33.9760447
              ],
              [
                49.5317364,
                33.9757648
              ],
              [
                49.5331263,
                33.9757648
              ],
              [
                49.5331263,
                33.975485
              ],
              [
                49.5359029,
                33.9749344
              ],
              [
                49.5364596,
                33.9743748
              ],
              [
                49.5375693,
                33.9738242
              ],
              [
                49.5400695,
                33.9704935
              ],
              [
                49.540346,
                33.969654
              ],
              [
                49.5409026,
                33.9679841
              ],
              [
                49.5411827,
                33.9674335
              ],
              [
                49.5406262,
                33.9627126
              ],
              [
                49.5422929,
                33.959102
              ],
              [
                49.5431262,
                33.9585424
              ],
              [
                49.5450695,
                33.9585425
              ],
              [
                49.5456262,
                33.9588222
              ],
              [
                49.5464595,
                33.9588223
              ],
              [
                49.5475696,
                33.9591021
              ],
              [
                49.5589593,
                33.9666031
              ],
              [
                49.5625726,
                33.9671537
              ],
              [
                49.5681258,
                33.9671537
              ],
              [
                49.5697923,
                33.9666031
              ],
              [
                49.5709059,
                33.9666031
              ],
              [
                49.5711826,
                33.9663233
              ],
              [
                49.5722924,
                33.9663233
              ],
              [
                49.5725724,
                33.9660434
              ],
              [
                49.5736823,
                33.9660435
              ],
              [
                49.5797957,
                33.963823
              ],
              [
                49.5797956,
                33.9635431
              ],
              [
                49.5815553,
                33.9625253
              ],
              [
                49.5820156,
                33.9621531
              ],
              [
                49.5834055,
                33.9613226
              ],
              [
                49.5845156,
                33.9602034
              ],
              [
                49.585629,
                33.9560421
              ],
              [
                49.5845157,
                33.9474309
              ],
              [
                49.587849,
                33.9410402
              ],
              [
                49.5922955,
                33.9390994
              ],
              [
                49.5939624,
                33.9390994
              ],
              [
                49.5945156,
                33.9388196
              ],
              [
                49.5959054,
                33.9388196
              ],
              [
                49.598129,
                33.93826
              ],
              [
                49.5995187,
                33.9374295
              ],
              [
                49.608962,
                33.932158
              ],
              [
                49.6314616,
                33.9052045
              ],
              [
                49.6336852,
                33.9035436
              ],
              [
                49.6339617,
                33.9032638
              ],
              [
                49.641465,
                33.9004836
              ],
              [
                49.6428518,
                33.898263
              ],
              [
                49.6417416,
                33.8946524
              ],
              [
                49.6395185,
                33.8929914
              ],
              [
                49.6382386,
                33.8915071
              ],
              [
                49.6320569,
                33.8834442
              ],
              [
                49.6248984,
                33.8761319
              ],
              [
                49.6204082,
                33.8728687
              ],
              [
                49.6209088,
                33.8718687
              ],
              [
                49.6300754,
                33.8602061
              ],
              [
                49.6317418,
                33.8602061
              ],
              [
                49.6322954,
                33.8604859
              ],
              [
                49.6331286,
                33.8604859
              ],
              [
                49.6350751,
                33.8610365
              ],
              [
                49.638965,
                33.8624268
              ],
              [
                49.6470183,
                33.8613164
              ],
              [
                49.6497985,
                33.8604859
              ],
              [
                49.6503516,
                33.8599263
              ],
              [
                49.6509083,
                33.8599262
              ],
              [
                49.656465,
                33.8574349
              ],
              [
                49.6590951,
                33.8561181
              ],
              [
                49.669203,
                33.8549013
              ],
              [
                49.676159,
                33.8472915
              ],
              [
                49.6793603,
                33.8395526
              ],
              [
                49.6687581,
                33.8258454
              ],
              [
                49.6628551,
                33.8146471
              ],
              [
                49.662575,
                33.8143763
              ],
              [
                49.6622984,
                33.8124264
              ],
              [
                49.6620219,
                33.8004837
              ],
              [
                49.669976,
                33.7868708
              ],
              [
                49.6733528,
                33.7802831
              ],
              [
                49.687578,
                33.7760382
              ],
              [
                49.6878549,
                33.7757584
              ],
              [
                49.6903545,
                33.7749279
              ],
              [
                49.6909112,
                33.7743682
              ],
              [
                49.6981348,
                33.7710373
              ],
              [
                49.7023013,
                33.7671465
              ],
              [
                49.7028544,
                33.7660362
              ],
              [
                49.7034111,
                33.7657563
              ],
              [
                49.703688,
                33.7652057
              ],
              [
                49.713968,
                33.7563139
              ],
              [
                49.7225775,
                33.7518724
              ],
              [
                49.7253578,
                33.751042
              ],
              [
                49.7273011,
                33.7510419
              ],
              [
                49.7278577,
                33.7507531
              ],
              [
                49.733414,
                33.7504823
              ],
              [
                49.7339676,
                33.7507531
              ],
              [
                49.7350809,
                33.7507531
              ],
              [
                49.735634,
                33.751042
              ],
              [
                49.7398009,
                33.7513128
              ],
              [
                49.7398009,
                33.7515927
              ],
              [
                49.7403575,
                33.7515926
              ],
              [
                49.7448006,
                33.7549237
              ],
              [
                49.7492472,
                33.7621455
              ],
              [
                49.7495242,
                33.7668668
              ],
              [
                49.7492471,
                33.7688167
              ],
              [
                49.7486905,
                33.7713172
              ],
              [
                49.748414,
                33.771597
              ],
              [
                49.748414,
                33.773258
              ],
              [
                49.7492471,
                33.7763182
              ],
              [
                49.7525804,
                33.779929
              ],
              [
                49.7586903,
                33.7829802
              ],
              [
                49.7634138,
                33.7829802
              ],
              [
                49.7636904,
                33.7827004
              ],
              [
                49.7720269,
                33.7793694
              ],
              [
                49.7736937,
                33.778259
              ],
              [
                49.7753601,
                33.7782591
              ],
              [
                49.7870268,
                33.7732581
              ],
              [
                49.7881366,
                33.7729782
              ],
              [
                49.7886937,
                33.7727074
              ],
              [
                49.7895268,
                33.7727074
              ],
              [
                49.79175,
                33.7721477
              ],
              [
                49.7939699,
                33.7721477
              ],
              [
                49.79425,
                33.7724276
              ],
              [
                49.7950832,
                33.7724276
              ],
              [
                49.8086933,
                33.7768689
              ],
              [
                49.8100832,
                33.776869
              ],
              [
                49.81175,
                33.7774286
              ],
              [
                49.8150832,
                33.7774287
              ],
              [
                49.8159164,
                33.7777086
              ],
              [
                49.8267494,
                33.7796494
              ],
              [
                49.8284164,
                33.7796494
              ],
              [
                49.828973,
                33.7799292
              ],
              [
                49.8311965,
                33.7799292
              ],
              [
                49.8317496,
                33.7802091
              ],
              [
                49.8373064,
                33.7815902
              ],
              [
                49.8414728,
                33.7840907
              ],
              [
                49.8436959,
                33.7863205
              ],
              [
                49.8453627,
                33.7882613
              ],
              [
                49.8500859,
                33.7963135
              ],
              [
                49.8525858,
                33.8096464
              ],
              [
                49.8559191,
                33.8190978
              ],
              [
                49.8598059,
                33.8249292
              ],
              [
                49.8661959,
                33.8316002
              ],
              [
                49.8673092,
                33.8324306
              ],
              [
                49.8686955,
                33.8329903
              ],
              [
                49.8692522,
                33.8332611
              ],
              [
                49.8770289,
                33.8374316
              ],
              [
                49.8775855,
                33.8377114
              ],
              [
                49.8778621,
                33.8379822
              ],
              [
                49.8786953,
                33.8379823
              ],
              [
                49.8792523,
                33.8382621
              ],
              [
                49.8800856,
                33.8382621
              ],
              [
                49.9003653,
                33.8443733
              ],
              [
                49.9014751,
                33.8443733
              ],
              [
                49.9020318,
                33.8446532
              ],
              [
                49.9028652,
                33.8446531
              ],
              [
                49.9031419,
                33.8449331
              ],
              [
                49.905922,
                33.8454836
              ],
              [
                49.9073084,
                33.8465939
              ],
              [
                49.9081415,
                33.846594
              ],
              [
                49.9084217,
                33.8468738
              ],
              [
                49.9092553,
                33.8468738
              ],
              [
                49.9125886,
                33.8452038
              ],
              [
                49.9161984,
                33.8424235
              ],
              [
                49.9173083,
                33.8415931
              ],
              [
                49.9184215,
                33.8402119
              ],
              [
                49.9195316,
                33.8399321
              ],
              [
                49.9223118,
                33.8385419
              ],
              [
                49.9225885,
                33.8382621
              ],
              [
                49.9225884,
                33.8379824
              ],
              [
                49.9234216,
                33.8374317
              ],
              [
                49.9239783,
                33.8371518
              ],
              [
                49.9248115,
                33.8371518
              ],
              [
                49.925365,
                33.8374316
              ],
              [
                49.9278651,
                33.8374317
              ],
              [
                49.9281448,
                33.8377115
              ],
              [
                49.9336979,
                33.8379823
              ],
              [
                49.9339781,
                33.8377115
              ],
              [
                49.9348112,
                33.8377115
              ],
              [
                49.9350883,
                33.8374317
              ],
              [
                49.9409216,
                33.8340917
              ],
              [
                49.9420349,
                33.8346514
              ],
              [
                49.9464779,
                33.8346514
              ],
              [
                49.9470346,
                33.8349312
              ],
              [
                49.9495346,
                33.8354819
              ],
              [
                49.9512015,
                33.8354819
              ],
              [
                49.9517546,
                33.8357617
              ],
              [
                49.9531445,
                33.8357617
              ],
              [
                49.9537012,
                33.8360415
              ],
              [
                49.9548113,
                33.8360416
              ],
              [
                49.9550878,
                33.8363214
              ],
              [
                49.9634244,
                33.8399322
              ],
              [
                49.9653677,
                33.8415931
              ],
              [
                49.985924,
                33.8685384
              ],
              [
                49.9856475,
                33.8699285
              ],
              [
                49.9853673,
                33.8715985
              ],
              [
                49.9856474,
                33.8724289
              ],
              [
                49.985924,
                33.8735392
              ],
              [
                49.9950906,
                33.8871517
              ],
              [
                49.9956472,
                33.8899319
              ],
              [
                49.9987039,
                33.9004841
              ],
              [
                50.0037039,
                33.9090956
              ],
              [
                50.0048137,
                33.9102059
              ],
              [
                50.0059239,
                33.911596
              ],
              [
                50.0095368,
                33.9138165
              ],
              [
                50.0148135,
                33.9154865
              ],
              [
                50.0228704,
                33.9154865
              ],
              [
                50.023427,
                33.9157663
              ],
              [
                50.02537,
                33.9157663
              ],
              [
                50.025647,
                33.9160461
              ],
              [
                50.0273134,
                33.9160461
              ],
              [
                50.0275934,
                33.916326
              ],
              [
                50.0364835,
                33.9188174
              ],
              [
                50.0498166,
                33.9263185
              ],
              [
                50.0500931,
                33.9268781
              ],
              [
                50.051483,
                33.9277086
              ],
              [
                50.0559264,
                33.9313192
              ],
              [
                50.057873,
                33.9324295
              ],
              [
                50.0662063,
                33.9357694
              ],
              [
                50.0720397,
                33.9371504
              ],
              [
                50.0873161,
                33.9416005
              ],
              [
                50.0884295,
                33.9416005
              ],
              [
                50.088706,
                33.9418804
              ],
              [
                50.0950959,
                33.9435413
              ],
              [
                50.1117623,
                33.9382607
              ],
              [
                50.1156523,
                33.9374303
              ],
              [
                50.117319,
                33.9368707
              ],
              [
                50.1209289,
                33.9368706
              ],
              [
                50.1228755,
                33.9374303
              ],
              [
                50.1242622,
                33.9374303
              ],
              [
                50.1248189,
                33.9377102
              ],
              [
                50.1264857,
                33.9377102
              ],
              [
                50.1278755,
                33.9382608
              ],
              [
                50.1287088,
                33.9382608
              ],
              [
                50.1300991,
                33.9388204
              ],
              [
                50.132042,
                33.9388204
              ],
              [
                50.1323186,
                33.9391002
              ],
              [
                50.1339854,
                33.9391002
              ],
              [
                50.134542,
                33.93938
              ],
              [
                50.1364855,
                33.93938
              ],
              [
                50.1370421,
                33.9391002
              ],
              [
                50.1420418,
                33.9391003
              ],
              [
                50.1423188,
                33.9388204
              ],
              [
                50.1459317,
                33.9388204
              ],
              [
                50.1462087,
                33.9385406
              ],
              [
                50.1484318,
                33.9385407
              ],
              [
                50.1489885,
                33.9382608
              ],
              [
                50.155655,
                33.9379899
              ],
              [
                50.155932,
                33.9429907
              ],
              [
                50.1556549,
                33.9432706
              ],
              [
                50.1553753,
                33.9454911
              ],
              [
                50.1567651,
                33.9549328
              ],
              [
                50.162875,
                33.9640947
              ],
              [
                50.1628749,
                33.9643835
              ],
              [
                50.1634317,
                33.9646543
              ],
              [
                50.1639862,
                33.9649331
              ],
              [
                50.1731549,
                33.9677053
              ],
              [
                50.1862114,
                33.9782661
              ],
              [
                50.1937111,
                33.9813261
              ],
              [
                50.1939877,
                33.9815969
              ],
              [
                50.1945444,
                33.981597
              ],
              [
                50.197878,
                33.9824274
              ],
              [
                50.1981546,
                33.9827072
              ],
              [
                50.1995445,
                33.9827072
              ],
              [
                50.2001011,
                33.9829869
              ],
              [
                50.2067676,
                33.9829869
              ],
              [
                50.2070442,
                33.9832668
              ],
              [
                50.2089911,
                33.9832669
              ],
              [
                50.2095443,
                33.9835467
              ],
              [
                50.2109346,
                33.9835466
              ],
              [
                50.2123244,
                33.984377
              ],
              [
                50.2134342,
                33.9846569
              ],
              [
                50.2170445,
                33.9882675
              ],
              [
                50.217324,
                33.988818
              ],
              [
                50.2192675,
                33.9963279
              ],
              [
                50.2206573,
                33.9990991
              ],
              [
                50.2217675,
                34.0003447
              ],
              [
                50.2242675,
                34.00493
              ],
              [
                50.2245476,
                34.0060493
              ],
              [
                50.2267673,
                34.00938
              ],
              [
                50.2270473,
                34.0099306
              ],
              [
                50.241214,
                34.0157706
              ],
              [
                50.2445473,
                34.0171516
              ],
              [
                50.2487137,
                34.0193811
              ],
              [
                50.2531571,
                34.0202115
              ],
              [
                50.264827,
                34.0285427
              ],
              [
                50.2728802,
                34.0416035
              ],
              [
                50.2792701,
                34.067716
              ],
              [
                50.2795498,
                34.0682665
              ],
              [
                50.2798268,
                34.0702162
              ],
              [
                50.2826034,
                34.0796573
              ],
              [
                50.3014928,
                34.1082695
              ],
              [
                50.3070495,
                34.1168801
              ],
              [
                50.3081597,
                34.1204905
              ],
              [
                50.3084394,
                34.1213299
              ],
              [
                50.3084394,
                34.1227108
              ],
              [
                50.3087163,
                34.1257705
              ],
              [
                50.3084394,
                34.1260503
              ],
              [
                50.3039928,
                34.1349406
              ],
              [
                50.3034397,
                34.1352205
              ],
              [
                50.3009396,
                34.1421612
              ],
              [
                50.3012161,
                34.1449411
              ],
              [
                50.3095495,
                34.1524414
              ],
              [
                50.3103828,
                34.1527122
              ],
              [
                50.3087162,
                34.1546618
              ],
              [
                50.3081595,
                34.1549325
              ],
              [
                50.3078827,
                34.1552123
              ],
              [
                50.2656598,
                34.1941033
              ],
              [
                50.2645466,
                34.1946628
              ],
              [
                50.2564901,
                34.2032731
              ],
              [
                50.2545467,
                34.2068832
              ],
              [
                50.2545467,
                34.207163
              ],
              [
                50.2542702,
                34.2079933
              ],
              [
                50.2517701,
                34.2149429
              ],
              [
                50.2517701,
                34.2157732
              ],
              [
                50.25149,
                34.216053
              ],
              [
                50.2503802,
                34.2213238
              ],
              [
                50.2514899,
                34.2282732
              ],
              [
                50.2703797,
                34.2604932
              ],
              [
                50.271213,
                34.263273
              ],
              [
                50.2717696,
                34.2643831
              ],
              [
                50.2717695,
                34.2649426
              ],
              [
                50.271493,
                34.2646628
              ],
              [
                50.2709363,
                34.2643831
              ],
              [
                50.2703797,
                34.2638325
              ],
              [
                50.2642698,
                34.2624427
              ],
              [
                50.2639932,
                34.2627134
              ],
              [
                50.2617697,
                34.2624426
              ],
              [
                50.2612131,
                34.2624427
              ],
              [
                50.2603799,
                34.2624426
              ],
              [
                50.2601033,
                34.2621629
              ],
              [
                50.2592697,
                34.2621628
              ],
              [
                50.2589931,
                34.2618831
              ],
              [
                50.2581564,
                34.2618831
              ],
              [
                50.2553798,
                34.260773
              ],
              [
                50.2539899,
                34.260773
              ],
              [
                50.25177,
                34.2613235
              ],
              [
                50.2514899,
                34.2616032
              ],
              [
                50.2509368,
                34.2616033
              ],
              [
                50.2489898,
                34.2635527
              ],
              [
                50.2351001,
                34.2691031
              ],
              [
                50.2298234,
                34.2716031
              ],
              [
                50.2209337,
                34.2793827
              ],
              [
                50.215657,
                34.2835522
              ],
              [
                50.2139903,
                34.2852218
              ],
              [
                50.2109339,
                34.2877127
              ],
              [
                50.2053771,
                34.2899419
              ],
              [
                50.204267,
                34.2899419
              ],
              [
                50.2037103,
                34.2902126
              ],
              [
                50.1978773,
                34.2899418
              ],
              [
                50.1956539,
                34.2902126
              ],
              [
                50.1914874,
                34.2918822
              ],
              [
                50.1912105,
                34.2929923
              ],
              [
                50.1906538,
                34.2938315
              ],
              [
                50.1903773,
                34.2954922
              ],
              [
                50.1901007,
                34.2985516
              ],
              [
                50.1878771,
                34.3043818
              ],
              [
                50.1839873,
                34.3057716
              ],
              [
                50.1828775,
                34.3057715
              ],
              [
                50.1825974,
                34.3060513
              ],
              [
                50.1795441,
                34.3060513
              ],
              [
                50.178711,
                34.3063311
              ],
              [
                50.1739875,
                34.3063311
              ],
              [
                50.1731542,
                34.3066109
              ],
              [
                50.1703776,
                34.3066109
              ],
              [
                50.1534312,
                34.3093815
              ],
              [
                50.137598,
                34.3154913
              ],
              [
                50.1331515,
                34.3202203
              ],
              [
                50.128708,
                34.3285502
              ],
              [
                50.1239848,
                34.3304995
              ],
              [
                50.1228746,
                34.3304995
              ],
              [
                50.1220414,
                34.3307793
              ],
              [
                50.1206516,
                34.3307793
              ],
              [
                50.1200949,
                34.331059
              ],
              [
                50.1120416,
                34.3296692
              ],
              [
                50.1014851,
                34.3246605
              ],
              [
                50.0834285,
                34.3180001
              ],
              [
                50.0825953,
                34.3177203
              ],
              [
                50.0817621,
                34.3177203
              ],
              [
                50.081482,
                34.3174406
              ],
              [
                50.0809285,
                34.3174406
              ],
              [
                50.0798152,
                34.3174406
              ],
              [
                50.078982,
                34.3174405
              ],
              [
                50.0787054,
                34.3171608
              ],
              [
                50.0759287,
                34.3171608
              ],
              [
                50.0714822,
                34.3166102
              ],
              [
                50.0712052,
                34.3163305
              ],
              [
                50.0698153,
                34.3163305
              ],
              [
                50.0695388,
                34.3160507
              ],
              [
                50.0678719,
                34.3160507
              ],
              [
                50.0670387,
                34.315771
              ],
              [
                50.0650922,
                34.3154912
              ],
              [
                50.0628722,
                34.3152204
              ],
              [
                50.0381492,
                34.3099409
              ],
              [
                50.0364826,
                34.3099408
              ],
              [
                50.035649,
                34.3096611
              ],
              [
                50.0339826,
                34.3096611
              ],
              [
                50.0328694,
                34.3093813
              ],
              [
                50.0292594,
                34.3093813
              ],
              [
                50.0139794,
                34.3080005
              ],
              [
                50.0134228,
                34.3077207
              ],
              [
                49.9850898,
                34.3077206
              ],
              [
                49.9828663,
                34.3082711
              ],
              [
                49.9825897,
                34.3085509
              ],
              [
                49.9825898,
                34.31328
              ],
              [
                49.9823132,
                34.3138305
              ],
              [
                49.9823132,
                34.3149405
              ],
              [
                49.9817565,
                34.3163304
              ],
              [
                49.98148,
                34.3182707
              ],
              [
                49.9809233,
                34.3207796
              ],
              [
                49.9806467,
                34.3224401
              ],
              [
                49.97759,
                34.3346597
              ],
              [
                49.9773135,
                34.3352192
              ],
              [
                49.9739766,
                34.3432783
              ],
              [
                49.9684233,
                34.347159
              ],
              [
                49.9670331,
                34.3477185
              ],
              [
                49.9664765,
                34.3477185
              ],
              [
                49.9661999,
                34.3479982
              ],
              [
                49.9650901,
                34.3479982
              ],
              [
                49.96481,
                34.348278
              ],
              [
                49.9542535,
                34.348278
              ],
              [
                49.951477,
                34.348278
              ],
              [
                49.9462003,
                34.3485487
              ],
              [
                49.9445334,
                34.3488285
              ],
              [
                49.9420338,
                34.3488285
              ],
              [
                49.9375868,
                34.349388
              ],
              [
                49.9289773,
                34.349388
              ],
              [
                49.9270303,
                34.3491082
              ],
              [
                49.9245303,
                34.3491082
              ],
              [
                49.9236971,
                34.3488284
              ],
              [
                49.9178637,
                34.3488284
              ],
              [
                49.9161973,
                34.3485487
              ],
              [
                49.9109206,
                34.3485486
              ],
              [
                49.9089741,
                34.3482779
              ],
              [
                49.9070307,
                34.3485487
              ],
              [
                49.9059209,
                34.3482779
              ],
              [
                49.8967508,
                34.3485487
              ],
              [
                49.8959175,
                34.3488284
              ],
              [
                49.8917507,
                34.3488284
              ],
              [
                49.8775844,
                34.3504979
              ],
              [
                49.8728613,
                34.3504979
              ],
              [
                49.8720276,
                34.3507776
              ],
              [
                49.8703612,
                34.3507777
              ],
              [
                49.841195,
                34.3602174
              ],
              [
                49.8403614,
                34.3610567
              ],
              [
                49.8386948,
                34.3621667
              ],
              [
                49.8342484,
                34.3660563
              ],
              [
                49.8248051,
                34.3821651
              ],
              [
                49.8167483,
                34.3888342
              ],
              [
                49.7935225,
                34.4069767
              ],
              [
                49.7838592,
                34.3922499
              ],
              [
                49.7675168,
                34.3746121
              ],
              [
                49.7479492,
                34.3595223
              ],
              [
                49.7428245,
                34.3436441
              ],
              [
                49.740043,
                34.3315629
              ],
              [
                49.6826101,
                34.3306299
              ],
              [
                49.682457,
                34.3525961
              ],
              [
                49.6767435,
                34.3807752
              ],
              [
                49.6756302,
                34.3804954
              ],
              [
                49.6725735,
                34.3799358
              ],
              [
                49.6642401,
                34.3791145
              ],
              [
                49.6450738,
                34.3760553
              ],
              [
                49.644517,
                34.3757755
              ],
              [
                49.6434073,
                34.3757754
              ],
              [
                49.6406307,
                34.3749361
              ],
              [
                49.6314606,
                34.3749362
              ],
              [
                49.6303508,
                34.3752159
              ],
              [
                49.6275741,
                34.3752159
              ],
              [
                49.624794,
                34.3757755
              ],
              [
                49.6220174,
                34.3757754
              ],
              [
                49.6214607,
                34.3760552
              ],
              [
                49.6178509,
                34.3760552
              ],
              [
                49.6170176,
                34.3757754
              ],
              [
                49.6153508,
                34.3757754
              ],
              [
                49.6142375,
                34.3754956
              ],
              [
                49.6122941,
                34.3754957
              ],
              [
                49.6109043,
                34.3752158
              ],
              [
                49.6086843,
                34.375216
              ],
              [
                49.607571,
                34.3749362
              ],
              [
                49.6039611,
                34.3749361
              ],
              [
                49.6031279,
                34.3746654
              ],
              [
                49.5942379,
                34.3749361
              ],
              [
                49.5931277,
                34.3752158
              ],
              [
                49.5881281,
                34.3752159
              ],
              [
                49.5870148,
                34.3752158
              ],
              [
                49.5870147,
                34.3754956
              ],
              [
                49.5859046,
                34.3766056
              ],
              [
                49.5856281,
                34.3768854
              ],
              [
                49.5834044,
                34.3793851
              ],
              [
                49.5809048,
                34.3854947
              ],
              [
                49.5809049,
                34.3954938
              ],
              [
                49.5812588,
                34.4007962
              ],
              [
                49.5814614,
                34.4038324
              ],
              [
                49.5811813,
                34.4046626
              ],
              [
                49.5809047,
                34.4077219
              ],
              [
                49.5747913,
                34.431889
              ],
              [
                49.5745147,
                34.4335585
              ],
              [
                49.573958,
                34.4360491
              ],
              [
                49.5736811,
                34.4379984
              ],
              [
                49.5734045,
                34.4385489
              ],
              [
                49.5734045,
                34.4396679
              ],
              [
                49.5728478,
                34.4410576
              ],
              [
                49.5725714,
                34.4424383
              ],
              [
                49.5722912,
                34.4441077
              ],
              [
                49.569238,
                34.4518866
              ],
              [
                49.5689579,
                34.4527258
              ],
              [
                49.5659047,
                34.455776
              ],
              [
                49.5478481,
                34.469664
              ],
              [
                49.547848,
                34.4702235
              ],
              [
                49.539235,
                34.4782819
              ],
              [
                49.5384017,
                34.4785526
              ],
              [
                49.537845,
                34.4791121
              ],
              [
                49.5311782,
                34.4816117
              ],
              [
                49.5297918,
                34.4818915
              ],
              [
                49.5286785,
                34.4824419
              ],
              [
                49.4997889,
                34.4885511
              ],
              [
                49.4945122,
                34.4885511
              ],
              [
                49.4925656,
                34.4882804
              ],
              [
                49.4922887,
                34.4885511
              ],
              [
                49.4856222,
                34.4882803
              ],
              [
                49.4833991,
                34.4885511
              ],
              [
                49.4825655,
                34.4888308
              ],
              [
                49.4817322,
                34.4888308
              ],
              [
                49.4814556,
                34.4891105
              ],
              [
                49.4803423,
                34.4891106
              ],
              [
                49.4786755,
                34.4899498
              ],
              [
                49.4778423,
                34.4899497
              ],
              [
                49.470066,
                34.4938301
              ],
              [
                49.4670093,
                34.4960589
              ],
              [
                49.465619,
                34.4974486
              ],
              [
                49.4625658,
                34.5007784
              ],
              [
                49.4286763,
                34.5274437
              ],
              [
                49.4233962,
                34.5327225
              ],
              [
                49.4225629,
                34.5343828
              ],
              [
                49.4224186,
                34.5346747
              ],
              [
                49.4167296,
                34.5341121
              ],
              [
                49.4158964,
                34.5338324
              ],
              [
                49.4125631,
                34.5338324
              ],
              [
                49.4114529,
                34.5335526
              ],
              [
                49.4095063,
                34.5335526
              ],
              [
                49.4089497,
                34.5338324
              ],
              [
                49.403673,
                34.5338324
              ],
              [
                49.4028399,
                34.5335527
              ],
              [
                49.4020067,
                34.5338324
              ],
              [
                49.4006164,
                34.5338323
              ],
              [
                49.4000633,
                34.5335526
              ],
              [
                49.3950632,
                34.5335527
              ],
              [
                49.3945065,
                34.5332819
              ],
              [
                49.3925635,
                34.5335526
              ],
              [
                49.3842266,
                34.5332818
              ],
              [
                49.3767268,
                34.5335526
              ],
              [
                49.3764503,
                34.5338324
              ],
              [
                49.3750599,
                34.5338323
              ],
              [
                49.3728404,
                34.534112
              ],
              [
                49.3633937,
                34.5343827
              ],
              [
                49.3592268,
                34.5335526
              ],
              [
                49.3564506,
                34.5332819
              ],
              [
                49.3547837,
                34.5327224
              ],
              [
                49.3536705,
                34.5327224
              ],
              [
                49.3533939,
                34.5324427
              ],
              [
                49.351447,
                34.5324427
              ],
              [
                49.3508939,
                34.5321629
              ],
              [
                49.3481137,
                34.5321629
              ],
              [
                49.3453371,
                34.5316125
              ],
              [
                49.3425605,
                34.5316124
              ],
              [
                49.3414473,
                34.5313327
              ],
              [
                49.332004,
                34.5313326
              ],
              [
                49.3311708,
                34.531053
              ],
              [
                49.3270043,
                34.5310529
              ],
              [
                49.3158908,
                34.5296723
              ],
              [
                49.3156143,
                34.5293926
              ],
              [
                49.3131142,
                34.5293925
              ],
              [
                49.3120009,
                34.5291128
              ],
              [
                49.3103344,
                34.5291129
              ],
              [
                49.3092243,
                34.5288331
              ],
              [
                49.3072809,
                34.5288331
              ],
              [
                49.3061675,
                34.5285533
              ],
              [
                49.3006143,
                34.5285533
              ],
              [
                49.299501,
                34.5288331
              ],
              [
                49.2906115,
                34.5288331
              ],
              [
                49.2900578,
                34.5285533
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554966,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تفرش",
          "name:en": "Tafresh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277816",
          "wikipedia": "fa:شهرستان تفرش"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.5012317,
                34.9097091
              ],
              [
                49.5151924,
                34.9000491
              ],
              [
                49.5266194,
                34.8974546
              ],
              [
                49.5459097,
                34.8941089
              ],
              [
                49.5554789,
                34.8899431
              ],
              [
                49.5604112,
                34.8849725
              ],
              [
                49.5709536,
                34.8769827
              ],
              [
                49.5813303,
                34.8722003
              ],
              [
                49.5822935,
                34.8716142
              ],
              [
                49.5822935,
                34.8710639
              ],
              [
                49.5920133,
                34.8607883
              ],
              [
                49.6056265,
                34.8538416
              ],
              [
                49.6061832,
                34.8535709
              ],
              [
                49.60785,
                34.8530116
              ],
              [
                49.6084031,
                34.8524522
              ],
              [
                49.6092366,
                34.8521725
              ],
              [
                49.6097934,
                34.8516222
              ],
              [
                49.61035,
                34.8516222
              ],
              [
                49.6177262,
                34.8455656
              ],
              [
                49.6211831,
                34.8427268
              ],
              [
                49.6339595,
                34.821345
              ],
              [
                49.6364632,
                34.8185662
              ],
              [
                49.6364631,
                34.8182866
              ],
              [
                49.6370163,
                34.8180069
              ],
              [
                49.6414627,
                34.811069
              ],
              [
                49.6447962,
                34.7996742
              ],
              [
                49.6439629,
                34.7916174
              ],
              [
                49.6406297,
                34.7852298
              ],
              [
                49.6367398,
                34.7819005
              ],
              [
                49.6359066,
                34.7805021
              ],
              [
                49.6303499,
                34.7732843
              ],
              [
                49.6300733,
                34.7713355
              ],
              [
                49.6303499,
                34.7685567
              ],
              [
                49.6306264,
                34.7680063
              ],
              [
                49.6303499,
                34.7666169
              ],
              [
                49.6286831,
                34.7588396
              ],
              [
                49.6278499,
                34.7574502
              ],
              [
                49.6275733,
                34.7499526
              ],
              [
                49.6317398,
                34.7402265
              ],
              [
                49.6320164,
                34.7399467
              ],
              [
                49.6325734,
                34.738837
              ],
              [
                49.63285,
                34.7382866
              ],
              [
                49.6339597,
                34.7374476
              ],
              [
                49.6345164,
                34.7377273
              ],
              [
                49.638963,
                34.7396762
              ],
              [
                49.643963,
                34.7410566
              ],
              [
                49.648683,
                34.7410565
              ],
              [
                49.6492397,
                34.7413362
              ],
              [
                49.6514628,
                34.7416159
              ],
              [
                49.6528496,
                34.7421754
              ],
              [
                49.6570196,
                34.7430054
              ],
              [
                49.658686,
                34.7430054
              ],
              [
                49.6592396,
                34.7432852
              ],
              [
                49.6656295,
                34.7435558
              ],
              [
                49.6661862,
                34.7432851
              ],
              [
                49.6686862,
                34.7432851
              ],
              [
                49.6703527,
                34.7427258
              ],
              [
                49.6717395,
                34.7427257
              ],
              [
                49.6725727,
                34.742446
              ],
              [
                49.6850761,
                34.7405063
              ],
              [
                49.6920192,
                34.7405062
              ],
              [
                49.6931324,
                34.740786
              ],
              [
                49.6947993,
                34.7407859
              ],
              [
                49.7120223,
                34.7438355
              ],
              [
                49.7142422,
                34.7438356
              ],
              [
                49.7203552,
                34.7446747
              ],
              [
                49.7250753,
                34.7449453
              ],
              [
                49.7261886,
                34.7449454
              ],
              [
                49.7286886,
                34.7455047
              ],
              [
                49.7300753,
                34.7455047
              ],
              [
                49.7309121,
                34.7457844
              ],
              [
                49.7322985,
                34.7457845
              ],
              [
                49.7339653,
                34.7460641
              ],
              [
                49.7397986,
                34.7460641
              ],
              [
                49.7400787,
                34.7457844
              ],
              [
                49.7406318,
                34.7457845
              ],
              [
                49.7425784,
                34.745225
              ],
              [
                49.7442452,
                34.744395
              ],
              [
                49.7450785,
                34.744395
              ],
              [
                49.7892482,
                34.7230027
              ],
              [
                49.7898012,
                34.7227321
              ],
              [
                49.7917478,
                34.721893
              ],
              [
                49.7925814,
                34.721893
              ],
              [
                49.7964678,
                34.7205035
              ],
              [
                49.7981346,
                34.7205035
              ],
              [
                49.8017481,
                34.7216133
              ],
              [
                49.812581,
                34.7357877
              ],
              [
                49.8156378,
                34.7371772
              ],
              [
                49.8159143,
                34.7368975
              ],
              [
                49.8175811,
                34.7363381
              ],
              [
                49.8198042,
                34.7363381
              ],
              [
                49.8225809,
                34.7349486
              ],
              [
                49.8256375,
                34.7321787
              ],
              [
                49.8256375,
                34.731899
              ],
              [
                49.8261942,
                34.731899
              ],
              [
                49.8273039,
                34.7313396
              ],
              [
                49.827581,
                34.7310599
              ],
              [
                49.8286943,
                34.7307893
              ],
              [
                49.8300806,
                34.7305096
              ],
              [
                49.8373042,
                34.7288404
              ],
              [
                49.8386941,
                34.7288404
              ],
              [
                49.8392472,
                34.7285607
              ],
              [
                49.8486939,
                34.7269006
              ],
              [
                49.8575839,
                34.721063
              ],
              [
                49.8589703,
                34.7196735
              ],
              [
                49.8603605,
                34.717454
              ],
              [
                49.8636938,
                34.7130059
              ],
              [
                49.8714737,
                34.6949515
              ],
              [
                49.8725835,
                34.693562
              ],
              [
                49.8742503,
                34.6924522
              ],
              [
                49.8742504,
                34.6921725
              ],
              [
                49.883417,
                34.6874536
              ],
              [
                49.8842502,
                34.6874537
              ],
              [
                49.8845303,
                34.6871739
              ],
              [
                49.88564,
                34.6871739
              ],
              [
                49.8861967,
                34.6868942
              ],
              [
                49.8881401,
                34.6868942
              ],
              [
                49.8886967,
                34.6866145
              ],
              [
                49.889807,
                34.6866146
              ],
              [
                49.8953633,
                34.6838355
              ],
              [
                49.8959168,
                34.6827257
              ],
              [
                49.8973067,
                34.6816159
              ],
              [
                49.8973067,
                34.6810565
              ],
              [
                49.8975833,
                34.6793963
              ],
              [
                49.8978634,
                34.6791165
              ],
              [
                49.8970302,
                34.674948
              ],
              [
                49.8939735,
                34.6699494
              ],
              [
                49.8903636,
                34.6671703
              ],
              [
                49.8670272,
                34.6577233
              ],
              [
                49.866194,
                34.6577233
              ],
              [
                49.8620271,
                34.656054
              ],
              [
                49.8617506,
                34.6555036
              ],
              [
                49.8603607,
                34.6546735
              ],
              [
                49.8539708,
                34.6449468
              ],
              [
                49.8528606,
                34.6424473
              ],
              [
                49.8492507,
                34.6366184
              ],
              [
                49.8484175,
                34.636059
              ],
              [
                49.8478609,
                34.6352288
              ],
              [
                49.8445276,
                34.6324497
              ],
              [
                49.8411943,
                34.6305008
              ],
              [
                49.7911914,
                34.5957793
              ],
              [
                49.789525,
                34.5949492
              ],
              [
                49.7884148,
                34.5943897
              ],
              [
                49.7775782,
                34.5913308
              ],
              [
                49.7731352,
                34.5860611
              ],
              [
                49.7728587,
                34.5849512
              ],
              [
                49.772302,
                34.5807825
              ],
              [
                49.7720251,
                34.5805027
              ],
              [
                49.772025,
                34.580223
              ],
              [
                49.7720251,
                34.5796726
              ],
              [
                49.7714684,
                34.5743848
              ],
              [
                49.771745,
                34.5730043
              ],
              [
                49.7720251,
                34.5713349
              ],
              [
                49.7725786,
                34.5685557
              ],
              [
                49.7742451,
                34.5579982
              ],
              [
                49.7745251,
                34.5560581
              ],
              [
                49.7756353,
                34.5510591
              ],
              [
                49.7759119,
                34.5493897
              ],
              [
                49.776192,
                34.5463397
              ],
              [
                49.7764686,
                34.5455006
              ],
              [
                49.7767452,
                34.5441109
              ],
              [
                49.7770252,
                34.5421709
              ],
              [
                49.7773018,
                34.5407812
              ],
              [
                49.7775784,
                34.5388321
              ],
              [
                49.7778585,
                34.5377222
              ],
              [
                49.7800785,
                34.5327231
              ],
              [
                49.7809117,
                34.5302235
              ],
              [
                49.782302,
                34.5282744
              ],
              [
                49.7865801,
                34.5234508
              ],
              [
                49.7870251,
                34.5241145
              ],
              [
                49.7873017,
                34.5243942
              ],
              [
                49.7909151,
                34.5288339
              ],
              [
                49.7917483,
                34.5299438
              ],
              [
                49.7923018,
                34.5305033
              ],
              [
                49.7953585,
                34.5335533
              ],
              [
                49.8017484,
                34.5371627
              ],
              [
                49.8298045,
                34.5468903
              ],
              [
                49.8311948,
                34.5477205
              ],
              [
                49.8467509,
                34.5521691
              ],
              [
                49.8509177,
                34.5527286
              ],
              [
                49.8653606,
                34.5566178
              ],
              [
                49.8809172,
                34.5657766
              ],
              [
                49.8820305,
                34.5663361
              ],
              [
                49.8828637,
                34.5668866
              ],
              [
                49.8984167,
                34.5771733
              ],
              [
                49.90814,
                34.5799435
              ],
              [
                49.9331432,
                34.5993979
              ],
              [
                49.945643,
                34.6080062
              ],
              [
                49.9461997,
                34.6082768
              ],
              [
                49.958423,
                34.6127252
              ],
              [
                49.9606429,
                34.6127253
              ],
              [
                49.9686993,
                34.6107853
              ],
              [
                49.969256,
                34.6105055
              ],
              [
                49.9703662,
                34.6105056
              ],
              [
                49.9709228,
                34.6102258
              ],
              [
                49.971756,
                34.6102259
              ],
              [
                49.9764793,
                34.6080062
              ],
              [
                49.9767558,
                34.6077264
              ],
              [
                49.9773128,
                34.6077265
              ],
              [
                49.9775895,
                34.6074467
              ],
              [
                49.9831458,
                34.6074467
              ],
              [
                49.9836993,
                34.6077264
              ],
              [
                49.9859224,
                34.6077265
              ],
              [
                49.9864791,
                34.6080062
              ],
              [
                49.9875892,
                34.6080062
              ],
              [
                50.0045357,
                34.6135555
              ],
              [
                50.0056454,
                34.6138352
              ],
              [
                50.0061002,
                34.6139879
              ],
              [
                50.0073122,
                34.6143946
              ],
              [
                50.0084221,
                34.6149451
              ],
              [
                50.0145355,
                34.6163347
              ],
              [
                50.0234254,
                34.6185543
              ],
              [
                50.0245353,
                34.6185544
              ],
              [
                50.0312019,
                34.6210628
              ],
              [
                50.0337018,
                34.6210628
              ],
              [
                50.034535,
                34.6213425
              ],
              [
                50.0398153,
                34.6213426
              ],
              [
                50.0445349,
                34.6202237
              ],
              [
                50.0453685,
                34.6202236
              ],
              [
                50.0509249,
                34.6157842
              ],
              [
                50.051205,
                34.6155045
              ],
              [
                50.0520382,
                34.6107854
              ],
              [
                50.0523152,
                34.6088364
              ],
              [
                50.0575915,
                34.5988386
              ],
              [
                50.0617584,
                34.5949496
              ],
              [
                50.0737047,
                34.5896709
              ],
              [
                50.0745383,
                34.5896709
              ],
              [
                50.0853714,
                34.5824432
              ],
              [
                50.0859877,
                34.5823628
              ],
              [
                50.0864811,
                34.5823911
              ],
              [
                50.0864671,
                34.5830887
              ],
              [
                50.0862046,
                34.5835621
              ],
              [
                50.0864812,
                34.5860616
              ],
              [
                50.1014846,
                34.6110562
              ],
              [
                50.1014845,
                34.6116156
              ],
              [
                50.1081511,
                34.6238331
              ],
              [
                50.1092482,
                34.6323985
              ],
              [
                50.1109277,
                34.6455065
              ],
              [
                50.1112077,
                34.6463366
              ],
              [
                50.1109276,
                34.6466163
              ],
              [
                50.1106511,
                34.650785
              ],
              [
                50.1103741,
                34.6524542
              ],
              [
                50.1100944,
                34.6538347
              ],
              [
                50.1096736,
                34.6543289
              ],
              [
                50.1075943,
                34.6566138
              ],
              [
                50.1025941,
                34.6643916
              ],
              [
                50.1023176,
                34.6655013
              ],
              [
                50.1020375,
                34.6693903
              ],
              [
                50.1031508,
                34.6755077
              ],
              [
                50.1081509,
                34.6843952
              ],
              [
                50.1114842,
                34.6863352
              ],
              [
                50.1134276,
                34.6899533
              ],
              [
                50.1139842,
                34.6905037
              ],
              [
                50.1145409,
                34.6932827
              ],
              [
                50.1134276,
                34.6952316
              ],
              [
                50.1134275,
                34.6955113
              ],
              [
                50.1128741,
                34.6971714
              ],
              [
                50.1131506,
                34.698561
              ],
              [
                50.1217605,
                34.7102273
              ],
              [
                50.1245406,
                34.7157852
              ],
              [
                50.1248172,
                34.7193943
              ],
              [
                50.1231507,
                34.7249521
              ],
              [
                50.1206506,
                34.7330093
              ],
              [
                50.120094,
                34.7338393
              ],
              [
                50.1198171,
                34.7346783
              ],
              [
                50.1195405,
                34.7388377
              ],
              [
                50.119817,
                34.7393971
              ],
              [
                50.1195405,
                34.7402272
              ],
              [
                50.1198171,
                34.7435566
              ],
              [
                50.1200941,
                34.7441159
              ],
              [
                50.1203741,
                34.7452257
              ],
              [
                50.1203741,
                34.7466151
              ],
              [
                50.1214839,
                34.7510631
              ],
              [
                50.1220405,
                34.7555112
              ],
              [
                50.1314836,
                34.7746745
              ],
              [
                50.15954,
                34.8135599
              ],
              [
                50.1598201,
                34.8143989
              ],
              [
                50.1620492,
                34.8175437
              ],
              [
                50.1673968,
                34.8203045
              ],
              [
                50.1701204,
                34.8210637
              ],
              [
                50.165355,
                34.8466905
              ],
              [
                50.1554879,
                34.8506279
              ],
              [
                50.1272253,
                34.8622322
              ],
              [
                50.1225401,
                34.8620255
              ],
              [
                50.1044864,
                34.8656945
              ],
              [
                50.0756437,
                34.8756736
              ],
              [
                50.0636089,
                34.8874568
              ],
              [
                50.0622887,
                34.8886724
              ],
              [
                50.0602493,
                34.8909425
              ],
              [
                50.0533172,
                34.897042
              ],
              [
                50.0434845,
                34.9055262
              ],
              [
                50.0394837,
                34.9099616
              ],
              [
                50.0340681,
                34.9161741
              ],
              [
                50.0217606,
                34.9211099
              ],
              [
                50.0125745,
                34.9246661
              ],
              [
                49.9890708,
                34.926075
              ],
              [
                49.9807042,
                34.9266531
              ],
              [
                49.9627214,
                34.9306375
              ],
              [
                49.9505301,
                34.9332807
              ],
              [
                49.9295465,
                34.9445409
              ],
              [
                49.9199459,
                34.9481116
              ],
              [
                49.9091919,
                34.9524459
              ],
              [
                49.8995464,
                34.9560087
              ],
              [
                49.8676514,
                34.9718784
              ],
              [
                49.8576341,
                34.9796676
              ],
              [
                49.8489367,
                34.9878505
              ],
              [
                49.8403534,
                34.9949973
              ],
              [
                49.8361378,
                34.9991572
              ],
              [
                49.8305583,
                34.9997678
              ],
              [
                49.8014848,
                35.0099139
              ],
              [
                49.784524,
                35.0163492
              ],
              [
                49.7839673,
                35.018009
              ],
              [
                49.7836907,
                35.0191275
              ],
              [
                49.7834106,
                35.0193981
              ],
              [
                49.7848004,
                35.0255141
              ],
              [
                49.7850774,
                35.0285721
              ],
              [
                49.7839673,
                35.0324599
              ],
              [
                49.7828574,
                35.0343994
              ],
              [
                49.7800774,
                35.0357885
              ],
              [
                49.7792441,
                35.0357885
              ],
              [
                49.7792441,
                35.0360681
              ],
              [
                49.7781339,
                35.0366274
              ],
              [
                49.7773007,
                35.0366274
              ],
              [
                49.7773007,
                35.036907
              ],
              [
                49.7736908,
                35.0377369
              ],
              [
                49.7736909,
                35.0374573
              ],
              [
                49.7745241,
                35.036907
              ],
              [
                49.7739675,
                35.0366273
              ],
              [
                49.7723009,
                35.0366274
              ],
              [
                49.772024,
                35.036907
              ],
              [
                49.7703576,
                35.0371776
              ],
              [
                49.7698009,
                35.0374573
              ],
              [
                49.7692443,
                35.0374573
              ],
              [
                49.7686908,
                35.0380075
              ],
              [
                49.7681341,
                35.0380075
              ],
              [
                49.7645207,
                35.042184
              ],
              [
                49.7642442,
                35.0457921
              ],
              [
                49.7636875,
                35.0485704
              ],
              [
                49.763411,
                35.04885
              ],
              [
                49.7634109,
                35.0491297
              ],
              [
                49.7625777,
                35.0496799
              ],
              [
                49.7600777,
                35.0510691
              ],
              [
                49.7592445,
                35.051069
              ],
              [
                49.7586873,
                35.0513487
              ],
              [
                49.757021,
                35.0513487
              ],
              [
                49.7564678,
                35.0510691
              ],
              [
                49.7528544,
                35.0496799
              ],
              [
                49.7467446,
                35.0457921
              ],
              [
                49.7414643,
                35.0446826
              ],
              [
                49.7159079,
                35.0488499
              ],
              [
                49.7109082,
                35.0502301
              ],
              [
                49.7017417,
                35.0499595
              ],
              [
                49.6984084,
                35.0491296
              ],
              [
                49.6972982,
                35.0488499
              ],
              [
                49.6950751,
                35.04885
              ],
              [
                49.6947986,
                35.0485703
              ],
              [
                49.6934083,
                35.0485703
              ],
              [
                49.6928516,
                35.0482907
              ],
              [
                49.6920184,
                35.0482907
              ],
              [
                49.6917418,
                35.0480111
              ],
              [
                49.6886851,
                35.048011
              ],
              [
                49.6884086,
                35.0482907
              ],
              [
                49.6878519,
                35.0482906
              ],
              [
                49.6847952,
                35.0491295
              ],
              [
                49.6842417,
                35.0496798
              ],
              [
                49.6828518,
                35.05023
              ],
              [
                49.6825752,
                35.0507983
              ],
              [
                49.6806284,
                35.0516192
              ],
              [
                49.6803518,
                35.0521784
              ],
              [
                49.6795186,
                35.0524581
              ],
              [
                49.6775752,
                35.0544064
              ],
              [
                49.676742,
                35.0546771
              ],
              [
                49.6764618,
                35.0552364
              ],
              [
                49.6736852,
                35.0566254
              ],
              [
                49.672852,
                35.0566255
              ],
              [
                49.6722954,
                35.0569051
              ],
              [
                49.6711851,
                35.056905
              ],
              [
                49.670352,
                35.0571847
              ],
              [
                49.6650721,
                35.0571847
              ],
              [
                49.6642386,
                35.056905
              ],
              [
                49.6628522,
                35.0569051
              ],
              [
                49.6550724,
                35.0527377
              ],
              [
                49.6547954,
                35.0521783
              ],
              [
                49.6500723,
                35.0485702
              ],
              [
                49.6486824,
                35.0477403
              ],
              [
                49.6481288,
                35.0477404
              ],
              [
                49.6478487,
                35.0474607
              ],
              [
                49.6428491,
                35.0455123
              ],
              [
                49.6414623,
                35.0455123
              ],
              [
                49.6411822,
                35.0452326
              ],
              [
                49.6397958,
                35.0452327
              ],
              [
                49.6389622,
                35.0455123
              ],
              [
                49.6328493,
                35.0455123
              ],
              [
                49.6322925,
                35.0457919
              ],
              [
                49.6306257,
                35.0457919
              ],
              [
                49.629516,
                35.0460716
              ],
              [
                49.6292389,
                35.0457919
              ],
              [
                49.6281257,
                35.0457919
              ],
              [
                49.6228494,
                35.0416245
              ],
              [
                49.6225725,
                35.0371774
              ],
              [
                49.6228494,
                35.0357882
              ],
              [
                49.6270159,
                35.0271736
              ],
              [
                49.627016,
                35.0263437
              ],
              [
                49.6275726,
                35.0249546
              ],
              [
                49.6278492,
                35.0235655
              ],
              [
                49.6281258,
                35.0232858
              ],
              [
                49.6275726,
                35.0171789
              ],
              [
                49.6253491,
                35.0119018
              ],
              [
                49.6212138,
                34.9986689
              ],
              [
                49.6050764,
                34.9963696
              ],
              [
                49.6014596,
                34.9966206
              ],
              [
                49.5942364,
                34.9924531
              ],
              [
                49.5934032,
                34.9924531
              ],
              [
                49.5928462,
                34.9921735
              ],
              [
                49.58368,
                34.9919028
              ],
              [
                49.583403,
                34.9916231
              ],
              [
                49.5820131,
                34.9916232
              ],
              [
                49.58118,
                34.9913435
              ],
              [
                49.5742369,
                34.9896746
              ],
              [
                49.5720133,
                34.986346
              ],
              [
                49.5717368,
                34.9846771
              ],
              [
                49.5717368,
                34.9843974
              ],
              [
                49.5720134,
                34.9830173
              ],
              [
                49.5722899,
                34.981619
              ],
              [
                49.57257,
                34.9802389
              ],
              [
                49.5728465,
                34.9763509
              ],
              [
                49.5731231,
                34.9749526
              ],
              [
                49.5736798,
                34.9730131
              ],
              [
                49.5739568,
                34.9721831
              ],
              [
                49.57479,
                34.9696844
              ],
              [
                49.5750701,
                34.9685658
              ],
              [
                49.5756232,
                34.9652371
              ],
              [
                49.5759033,
                34.9627383
              ],
              [
                49.5761799,
                34.96134
              ],
              [
                49.5764565,
                34.9610694
              ],
              [
                49.5753467,
                34.9571723
              ],
              [
                49.5750702,
                34.9569017
              ],
              [
                49.5742369,
                34.9563423
              ],
              [
                49.5717704,
                34.9533443
              ],
              [
                49.5716642,
                34.9532152
              ],
              [
                49.5459005,
                34.9218996
              ],
              [
                49.5386772,
                34.9182911
              ],
              [
                49.537844,
                34.918291
              ],
              [
                49.5367339,
                34.9177317
              ],
              [
                49.5359006,
                34.9177317
              ],
              [
                49.5339572,
                34.9169017
              ],
              [
                49.533124,
                34.9169017
              ],
              [
                49.5322909,
                34.9166221
              ],
              [
                49.5311771,
                34.9166221
              ],
              [
                49.5306239,
                34.9163425
              ],
              [
                49.5292341,
                34.9163424
              ],
              [
                49.526734,
                34.9157831
              ],
              [
                49.5178441,
                34.9146826
              ],
              [
                49.5070109,
                34.9119039
              ],
              [
                49.5039543,
                34.9099553
              ],
              [
                49.5031211,
                34.9099553
              ],
              [
                49.5012317,
                34.9097091
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554997,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خمین",
          "name:en": "Khomein County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q720750",
          "wikipedia": "fa:خمین"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.6332958,
                33.738745
              ],
              [
                49.6310372,
                33.7349938
              ],
              [
                49.6269425,
                33.72842
              ],
              [
                49.6242675,
                33.7239378
              ],
              [
                49.6191643,
                33.7143319
              ],
              [
                49.616661,
                33.7099184
              ],
              [
                49.6115303,
                33.6981536
              ],
              [
                49.6096837,
                33.693153
              ],
              [
                49.605387,
                33.6861336
              ],
              [
                49.6030787,
                33.6820793
              ],
              [
                49.6008871,
                33.6776761
              ],
              [
                49.5988161,
                33.6745326
              ],
              [
                49.5973821,
                33.6714104
              ],
              [
                49.5946436,
                33.6667334
              ],
              [
                49.5923929,
                33.6628039
              ],
              [
                49.5857173,
                33.6510752
              ],
              [
                49.5843631,
                33.6383174
              ],
              [
                49.5941704,
                33.6328031
              ],
              [
                49.6016424,
                33.6287039
              ],
              [
                49.6114019,
                33.6257737
              ],
              [
                49.6195668,
                33.6229358
              ],
              [
                49.6247632,
                33.618874
              ],
              [
                49.6297931,
                33.6146908
              ],
              [
                49.6297073,
                33.6116887
              ],
              [
                49.6322786,
                33.6039398
              ],
              [
                49.6352862,
                33.5975344
              ],
              [
                49.6382045,
                33.5928158
              ],
              [
                49.639795,
                33.58851
              ],
              [
                49.6438292,
                33.582516
              ],
              [
                49.6477749,
                33.5805157
              ],
              [
                49.6521349,
                33.5780657
              ],
              [
                49.66077,
                33.5723398
              ],
              [
                49.6673011,
                33.5708636
              ],
              [
                49.6742534,
                33.5702558
              ],
              [
                49.6831369,
                33.5712927
              ],
              [
                49.6883597,
                33.5735974
              ],
              [
                49.6969428,
                33.5733891
              ],
              [
                49.7623042,
                33.5263085
              ],
              [
                49.7709142,
                33.5176957
              ],
              [
                49.7736943,
                33.5138137
              ],
              [
                49.7745275,
                33.5129741
              ],
              [
                49.7770276,
                33.5093628
              ],
              [
                49.7856376,
                33.4938076
              ],
              [
                49.7856375,
                33.4935368
              ],
              [
                49.7861942,
                33.492977
              ],
              [
                49.7861943,
                33.4926971
              ],
              [
                49.7864708,
                33.4924173
              ],
              [
                49.7864708,
                33.4918666
              ],
              [
                49.787304,
                33.4904763
              ],
              [
                49.7895275,
                33.4840844
              ],
              [
                49.791471,
                33.4774216
              ],
              [
                49.7917507,
                33.476582
              ],
              [
                49.7920275,
                33.4752007
              ],
              [
                49.7925842,
                33.4738104
              ],
              [
                49.7923041,
                33.4693685
              ],
              [
                49.7920276,
                33.4607557
              ],
              [
                49.7942508,
                33.4513033
              ],
              [
                49.7942508,
                33.4510324
              ],
              [
                49.7956374,
                33.4479808
              ],
              [
                49.7964708,
                33.4465905
              ],
              [
                49.8067507,
                33.4379776
              ],
              [
                49.8353638,
                33.4276946
              ],
              [
                49.8392501,
                33.4268639
              ],
              [
                49.8409169,
                33.4260333
              ],
              [
                49.8481402,
                33.4229728
              ],
              [
                49.8489734,
                33.4229728
              ],
              [
                49.8520301,
                33.4215825
              ],
              [
                49.8528633,
                33.4215825
              ],
              [
                49.8548067,
                33.4210318
              ],
              [
                49.85592,
                33.4210317
              ],
              [
                49.8564735,
                33.4207518
              ],
              [
                49.8573067,
                33.4207518
              ],
              [
                49.8578634,
                33.420472
              ],
              [
                49.8586966,
                33.420472
              ],
              [
                49.8614732,
                33.4196414
              ],
              [
                49.8625865,
                33.4196414
              ],
              [
                49.8823096,
                33.4157503
              ],
              [
                49.8973094,
                33.4107486
              ],
              [
                49.8984193,
                33.4107486
              ],
              [
                49.8986994,
                33.4104687
              ],
              [
                49.9064762,
                33.4082478
              ],
              [
                49.9073094,
                33.4076971
              ],
              [
                49.9086996,
                33.4074172
              ],
              [
                49.9203659,
                33.401305
              ],
              [
                49.9225894,
                33.399364
              ],
              [
                49.9250894,
                33.3963124
              ],
              [
                49.925366,
                33.3957526
              ],
              [
                49.927866,
                33.3921413
              ],
              [
                49.9345325,
                33.3849186
              ],
              [
                49.9373123,
                33.3840881
              ],
              [
                49.9420359,
                33.3851985
              ],
              [
                49.9434222,
                33.3851986
              ],
              [
                49.9437023,
                33.3854785
              ],
              [
                49.9467555,
                33.3860292
              ],
              [
                49.9478688,
                33.3874196
              ],
              [
                49.9500887,
                33.3951929
              ],
              [
                49.9578689,
                33.407977
              ],
              [
                49.9592588,
                33.4135294
              ],
              [
                49.959812,
                33.4157504
              ],
              [
                49.9606455,
                33.4163101
              ],
              [
                49.9625921,
                33.4168608
              ],
              [
                49.9637018,
                33.4171407
              ],
              [
                49.9656453,
                33.4171407
              ],
              [
                49.9687019,
                33.4160302
              ],
              [
                49.9745352,
                33.4160303
              ],
              [
                49.9748118,
                33.4163102
              ],
              [
                49.9784252,
                33.4163102
              ],
              [
                49.9809252,
                33.416581
              ],
              [
                49.9812019,
                33.4168608
              ],
              [
                49.9823151,
                33.4168608
              ],
              [
                49.9825917,
                33.4171408
              ],
              [
                49.9856483,
                33.4171408
              ],
              [
                49.9898148,
                33.4196415
              ],
              [
                49.9903684,
                33.4199214
              ],
              [
                49.9914817,
                33.4326964
              ],
              [
                49.9912016,
                33.4332562
              ],
              [
                49.990925,
                33.4351972
              ],
              [
                49.9903683,
                33.4401989
              ],
              [
                49.9723117,
                33.4663083
              ],
              [
                49.9720351,
                33.4676986
              ],
              [
                49.9731449,
                33.4757517
              ],
              [
                49.973425,
                33.4765823
              ],
              [
                49.973425,
                33.4771421
              ],
              [
                49.9745351,
                33.4801935
              ],
              [
                49.9837016,
                33.4924176
              ],
              [
                49.9853682,
                33.4929773
              ],
              [
                49.987315,
                33.4940878
              ],
              [
                50.0270377,
                33.4993603
              ],
              [
                50.0284275,
                33.4996491
              ],
              [
                50.0342609,
                33.4996491
              ],
              [
                50.0514839,
                33.5007506
              ],
              [
                50.052594,
                33.5010304
              ],
              [
                50.0545406,
                33.5010304
              ],
              [
                50.071207,
                33.5035313
              ],
              [
                50.0725972,
                33.5035312
              ],
              [
                50.073707,
                33.5038111
              ],
              [
                50.0764836,
                33.5038111
              ],
              [
                50.0789836,
                33.504082
              ],
              [
                50.0798169,
                33.5043708
              ],
              [
                50.0845404,
                33.5049215
              ],
              [
                50.09732,
                33.5068626
              ],
              [
                50.1387094,
                33.5190867
              ],
              [
                50.1431528,
                33.5204769
              ],
              [
                50.1492663,
                33.5229777
              ],
              [
                50.1762125,
                33.5285299
              ],
              [
                50.1831556,
                33.5299202
              ],
              [
                50.1839888,
                33.5302001
              ],
              [
                50.1859358,
                33.5302001
              ],
              [
                50.1867689,
                33.5304799
              ],
              [
                50.1884353,
                33.53048
              ],
              [
                50.1906553,
                33.5310397
              ],
              [
                50.1917691,
                33.5310397
              ],
              [
                50.2056588,
                33.542424
              ],
              [
                50.2064921,
                33.5440941
              ],
              [
                50.206492,
                33.5446448
              ],
              [
                50.206492,
                33.5465949
              ],
              [
                50.2046897,
                33.5495951
              ],
              [
                50.203992,
                33.5507567
              ],
              [
                50.2034352,
                33.5524269
              ],
              [
                50.2037118,
                33.556038
              ],
              [
                50.2048251,
                33.5596401
              ],
              [
                50.2095452,
                33.5685326
              ],
              [
                50.2098253,
                33.5707534
              ],
              [
                50.2098252,
                33.5743736
              ],
              [
                50.2101018,
                33.5757548
              ],
              [
                50.211212,
                33.5777048
              ],
              [
                50.2153784,
                33.5799258
              ],
              [
                50.2259348,
                33.5888091
              ],
              [
                50.228715,
                33.5932507
              ],
              [
                50.2306583,
                33.6002021
              ],
              [
                50.2328815,
                33.6027028
              ],
              [
                50.2353814,
                33.6035334
              ],
              [
                50.2381581,
                33.604093
              ],
              [
                50.2389913,
                33.6043729
              ],
              [
                50.2403816,
                33.604373
              ],
              [
                50.2409383,
                33.6046438
              ],
              [
                50.243438,
                33.6043729
              ],
              [
                50.2487146,
                33.600482
              ],
              [
                50.2562144,
                33.5865883
              ],
              [
                50.2589945,
                33.5843674
              ],
              [
                50.2614946,
                33.5835369
              ],
              [
                50.2731613,
                33.5824265
              ],
              [
                50.2751043,
                33.5826973
              ],
              [
                50.2787175,
                33.5829772
              ],
              [
                50.2889943,
                33.5840876
              ],
              [
                50.2895509,
                33.5843675
              ],
              [
                50.2923276,
                33.5843675
              ],
              [
                50.2928842,
                33.5846474
              ],
              [
                50.2937175,
                33.5846473
              ],
              [
                50.2942706,
                33.5849273
              ],
              [
                50.2951043,
                33.5849272
              ],
              [
                50.3164972,
                33.5946502
              ],
              [
                50.3184406,
                33.5957606
              ],
              [
                50.3259403,
                33.6049238
              ],
              [
                50.3267736,
                33.6071446
              ],
              [
                50.3281634,
                33.6099252
              ],
              [
                50.331217,
                33.6135363
              ],
              [
                50.3370534,
                33.6154772
              ],
              [
                50.3370535,
                33.615757
              ],
              [
                50.3476068,
                33.6165876
              ],
              [
                50.3481635,
                33.6163168
              ],
              [
                50.3526065,
                33.6165876
              ],
              [
                50.3534432,
                33.6168675
              ],
              [
                50.3570531,
                33.6168675
              ],
              [
                50.3578867,
                33.6171473
              ],
              [
                50.3598297,
                33.6171474
              ],
              [
                50.3609433,
                33.6174272
              ],
              [
                50.3659431,
                33.6174272
              ],
              [
                50.3667763,
                33.6177071
              ],
              [
                50.3681631,
                33.6177071
              ],
              [
                50.3770531,
                33.6196481
              ],
              [
                50.3781663,
                33.619648
              ],
              [
                50.3787194,
                33.6193682
              ],
              [
                50.3801098,
                33.6193682
              ],
              [
                50.380943,
                33.6196481
              ],
              [
                50.3820528,
                33.619648
              ],
              [
                50.3823329,
                33.6199279
              ],
              [
                50.3831661,
                33.6199279
              ],
              [
                50.3839997,
                33.619648
              ],
              [
                50.384274,
                33.6199256
              ],
              [
                50.3864993,
                33.6199279
              ],
              [
                50.3884428,
                33.6201987
              ],
              [
                50.3884427,
                33.6204786
              ],
              [
                50.3909428,
                33.6204786
              ],
              [
                50.3928893,
                33.6204786
              ],
              [
                50.3934428,
                33.6207584
              ],
              [
                50.3987226,
                33.6207585
              ],
              [
                50.3992762,
                33.6210383
              ],
              [
                50.4001094,
                33.6207585
              ],
              [
                50.400666,
                33.6210383
              ],
              [
                50.4067759,
                33.6210383
              ],
              [
                50.4112225,
                33.6213092
              ],
              [
                50.4117791,
                33.621589
              ],
              [
                50.4134459,
                33.621589
              ],
              [
                50.4142792,
                33.6218689
              ],
              [
                50.4156659,
                33.6218689
              ],
              [
                50.4164991,
                33.6221488
              ],
              [
                50.4181656,
                33.6221487
              ],
              [
                50.4192793,
                33.6224286
              ],
              [
                50.4206656,
                33.6224286
              ],
              [
                50.4214988,
                33.6226995
              ],
              [
                50.4220556,
                33.6224286
              ],
              [
                50.4253892,
                33.6226995
              ],
              [
                50.4320557,
                33.6246495
              ],
              [
                50.4448352,
                33.6315918
              ],
              [
                50.4495588,
                33.6332528
              ],
              [
                50.4523354,
                33.6338125
              ],
              [
                50.4537253,
                33.6346521
              ],
              [
                50.4540018,
                33.6343633
              ],
              [
                50.4540018,
                33.6346521
              ],
              [
                50.4512252,
                33.6415944
              ],
              [
                50.4506686,
                33.6424249
              ],
              [
                50.450392,
                33.6432554
              ],
              [
                50.4498353,
                33.6446457
              ],
              [
                50.4498354,
                33.6449256
              ],
              [
                50.4470552,
                33.6560385
              ],
              [
                50.4467787,
                33.6563093
              ],
              [
                50.446502,
                33.6571489
              ],
              [
                50.4459454,
                33.658819
              ],
              [
                50.4303888,
                33.6777045
              ],
              [
                50.429002,
                33.6793747
              ],
              [
                50.394556,
                33.7110429
              ],
              [
                50.3934427,
                33.7115936
              ],
              [
                50.3928891,
                33.7121533
              ],
              [
                50.3898324,
                33.7132636
              ],
              [
                50.3862195,
                33.7132636
              ],
              [
                50.3837194,
                33.7129837
              ],
              [
                50.3828862,
                33.7129838
              ],
              [
                50.3814994,
                33.7124241
              ],
              [
                50.3803861,
                33.712424
              ],
              [
                50.3798327,
                33.7127039
              ],
              [
                50.3767759,
                33.7127039
              ],
              [
                50.3742762,
                33.7146448
              ],
              [
                50.3739996,
                33.7152045
              ],
              [
                50.3729453,
                33.7157796
              ],
              [
                50.3648296,
                33.7202057
              ],
              [
                50.3642765,
                33.7202057
              ],
              [
                50.3639964,
                33.7204855
              ],
              [
                50.3623296,
                33.7204855
              ],
              [
                50.3617764,
                33.7207653
              ],
              [
                50.3609431,
                33.7207653
              ],
              [
                50.3603862,
                33.7204854
              ],
              [
                50.3584431,
                33.7204855
              ],
              [
                50.3578865,
                33.7202056
              ],
              [
                50.3562196,
                33.7202056
              ],
              [
                50.355663,
                33.7199258
              ],
              [
                50.3539965,
                33.7199258
              ],
              [
                50.353443,
                33.7196459
              ],
              [
                50.3517731,
                33.7196459
              ],
              [
                50.3464964,
                33.724647
              ],
              [
                50.3459397,
                33.7249269
              ],
              [
                50.3445533,
                33.7254777
              ],
              [
                50.3439963,
                33.7257574
              ],
              [
                50.3398298,
                33.7257574
              ],
              [
                50.3392732,
                33.7260373
              ],
              [
                50.3053838,
                33.722986
              ],
              [
                50.3042737,
                33.7232568
              ],
              [
                50.303717,
                33.7235366
              ],
              [
                50.3028838,
                33.7235366
              ],
              [
                50.2989939,
                33.7254776
              ],
              [
                50.2986297,
                33.7258454
              ],
              [
                50.294827,
                33.7282579
              ],
              [
                50.2942703,
                33.7285378
              ],
              [
                50.2751039,
                33.7449224
              ],
              [
                50.273994,
                33.7463216
              ],
              [
                50.2720472,
                33.7488131
              ],
              [
                50.2464911,
                33.7838206
              ],
              [
                50.2451044,
                33.7854815
              ],
              [
                50.2401043,
                33.7907624
              ],
              [
                50.2331577,
                33.7960432
              ],
              [
                50.2270477,
                33.8024344
              ],
              [
                50.2214914,
                33.8152076
              ],
              [
                50.2209347,
                33.8160381
              ],
              [
                50.2198245,
                33.8179879
              ],
              [
                50.2198246,
                33.8182678
              ],
              [
                50.2153779,
                33.8263199
              ],
              [
                50.1867683,
                33.8527056
              ],
              [
                50.1839882,
                33.8560455
              ],
              [
                50.1703785,
                33.8713189
              ],
              [
                50.1703785,
                33.8718696
              ],
              [
                50.1700984,
                33.8721493
              ],
              [
                50.1698218,
                33.8729889
              ],
              [
                50.1612083,
                33.8927124
              ],
              [
                50.1609317,
                33.893263
              ],
              [
                50.1570418,
                33.8971535
              ],
              [
                50.1567652,
                33.8974243
              ],
              [
                50.1567652,
                33.8982638
              ],
              [
                50.1553753,
                33.9002045
              ],
              [
                50.1537085,
                33.9024341
              ],
              [
                50.1525988,
                33.9049345
              ],
              [
                50.1523218,
                33.9063246
              ],
              [
                50.1520417,
                33.9079855
              ],
              [
                50.1545417,
                33.9182669
              ],
              [
                50.1548219,
                33.9202077
              ],
              [
                50.1523217,
                33.9235475
              ],
              [
                50.1525986,
                33.9263186
              ],
              [
                50.1550983,
                33.9299293
              ],
              [
                50.1562085,
                33.9332601
              ],
              [
                50.1559319,
                33.9335399
              ],
              [
                50.155655,
                33.9352098
              ],
              [
                50.155655,
                33.9379899
              ],
              [
                50.1489885,
                33.9382608
              ],
              [
                50.1484318,
                33.9385407
              ],
              [
                50.1462087,
                33.9385406
              ],
              [
                50.1459317,
                33.9388204
              ],
              [
                50.1423188,
                33.9388204
              ],
              [
                50.1420418,
                33.9391003
              ],
              [
                50.1370421,
                33.9391002
              ],
              [
                50.1364855,
                33.93938
              ],
              [
                50.134542,
                33.93938
              ],
              [
                50.1339854,
                33.9391002
              ],
              [
                50.1323186,
                33.9391002
              ],
              [
                50.132042,
                33.9388204
              ],
              [
                50.1300991,
                33.9388204
              ],
              [
                50.1287088,
                33.9382608
              ],
              [
                50.1278755,
                33.9382608
              ],
              [
                50.1264857,
                33.9377102
              ],
              [
                50.1248189,
                33.9377102
              ],
              [
                50.1242622,
                33.9374303
              ],
              [
                50.1228755,
                33.9374303
              ],
              [
                50.1209289,
                33.9368706
              ],
              [
                50.117319,
                33.9368707
              ],
              [
                50.1156523,
                33.9374303
              ],
              [
                50.1117623,
                33.9382607
              ],
              [
                50.0950959,
                33.9435413
              ],
              [
                50.088706,
                33.9418804
              ],
              [
                50.0884295,
                33.9416005
              ],
              [
                50.0873161,
                33.9416005
              ],
              [
                50.0720397,
                33.9371504
              ],
              [
                50.0662063,
                33.9357694
              ],
              [
                50.057873,
                33.9324295
              ],
              [
                50.0559264,
                33.9313192
              ],
              [
                50.051483,
                33.9277086
              ],
              [
                50.0500931,
                33.9268781
              ],
              [
                50.0498166,
                33.9263185
              ],
              [
                50.0364835,
                33.9188174
              ],
              [
                50.0275934,
                33.916326
              ],
              [
                50.0273134,
                33.9160461
              ],
              [
                50.025647,
                33.9160461
              ],
              [
                50.02537,
                33.9157663
              ],
              [
                50.023427,
                33.9157663
              ],
              [
                50.0228704,
                33.9154865
              ],
              [
                50.0148135,
                33.9154865
              ],
              [
                50.0095368,
                33.9138165
              ],
              [
                50.0059239,
                33.911596
              ],
              [
                50.0048137,
                33.9102059
              ],
              [
                50.0037039,
                33.9090956
              ],
              [
                49.9987039,
                33.9004841
              ],
              [
                49.9956472,
                33.8899319
              ],
              [
                49.9950906,
                33.8871517
              ],
              [
                49.985924,
                33.8735392
              ],
              [
                49.9856474,
                33.8724289
              ],
              [
                49.9853673,
                33.8715985
              ],
              [
                49.9856475,
                33.8699285
              ],
              [
                49.985924,
                33.8685384
              ],
              [
                49.9653677,
                33.8415931
              ],
              [
                49.9634244,
                33.8399322
              ],
              [
                49.9550878,
                33.8363214
              ],
              [
                49.9548113,
                33.8360416
              ],
              [
                49.9537012,
                33.8360415
              ],
              [
                49.9531445,
                33.8357617
              ],
              [
                49.9517546,
                33.8357617
              ],
              [
                49.9512015,
                33.8354819
              ],
              [
                49.9495346,
                33.8354819
              ],
              [
                49.9470346,
                33.8349312
              ],
              [
                49.9464779,
                33.8346514
              ],
              [
                49.9420349,
                33.8346514
              ],
              [
                49.9409216,
                33.8340917
              ],
              [
                49.9350883,
                33.8374317
              ],
              [
                49.9348112,
                33.8377115
              ],
              [
                49.9339781,
                33.8377115
              ],
              [
                49.9336979,
                33.8379823
              ],
              [
                49.9281448,
                33.8377115
              ],
              [
                49.9278651,
                33.8374317
              ],
              [
                49.925365,
                33.8374316
              ],
              [
                49.9248115,
                33.8371518
              ],
              [
                49.9239783,
                33.8371518
              ],
              [
                49.9234216,
                33.8374317
              ],
              [
                49.9225884,
                33.8379824
              ],
              [
                49.9225885,
                33.8382621
              ],
              [
                49.9223118,
                33.8385419
              ],
              [
                49.9195316,
                33.8399321
              ],
              [
                49.9184215,
                33.8402119
              ],
              [
                49.9173083,
                33.8415931
              ],
              [
                49.9161984,
                33.8424235
              ],
              [
                49.9125886,
                33.8452038
              ],
              [
                49.9092553,
                33.8468738
              ],
              [
                49.9084217,
                33.8468738
              ],
              [
                49.9081415,
                33.846594
              ],
              [
                49.9073084,
                33.8465939
              ],
              [
                49.905922,
                33.8454836
              ],
              [
                49.9031419,
                33.8449331
              ],
              [
                49.9028652,
                33.8446531
              ],
              [
                49.9020318,
                33.8446532
              ],
              [
                49.9014751,
                33.8443733
              ],
              [
                49.9003653,
                33.8443733
              ],
              [
                49.8800856,
                33.8382621
              ],
              [
                49.8792523,
                33.8382621
              ],
              [
                49.8786953,
                33.8379823
              ],
              [
                49.8778621,
                33.8379822
              ],
              [
                49.8775855,
                33.8377114
              ],
              [
                49.8770289,
                33.8374316
              ],
              [
                49.8692522,
                33.8332611
              ],
              [
                49.8686955,
                33.8329903
              ],
              [
                49.8673092,
                33.8324306
              ],
              [
                49.8661959,
                33.8316002
              ],
              [
                49.8598059,
                33.8249292
              ],
              [
                49.8559191,
                33.8190978
              ],
              [
                49.8525858,
                33.8096464
              ],
              [
                49.8500859,
                33.7963135
              ],
              [
                49.8453627,
                33.7882613
              ],
              [
                49.8436959,
                33.7863205
              ],
              [
                49.8414728,
                33.7840907
              ],
              [
                49.8373064,
                33.7815902
              ],
              [
                49.8317496,
                33.7802091
              ],
              [
                49.8311965,
                33.7799292
              ],
              [
                49.828973,
                33.7799292
              ],
              [
                49.8284164,
                33.7796494
              ],
              [
                49.8267494,
                33.7796494
              ],
              [
                49.8159164,
                33.7777086
              ],
              [
                49.8150832,
                33.7774287
              ],
              [
                49.81175,
                33.7774286
              ],
              [
                49.8100832,
                33.776869
              ],
              [
                49.8086933,
                33.7768689
              ],
              [
                49.7950832,
                33.7724276
              ],
              [
                49.79425,
                33.7724276
              ],
              [
                49.7939699,
                33.7721477
              ],
              [
                49.79175,
                33.7721477
              ],
              [
                49.7895268,
                33.7727074
              ],
              [
                49.7886937,
                33.7727074
              ],
              [
                49.7881366,
                33.7729782
              ],
              [
                49.7870268,
                33.7732581
              ],
              [
                49.7753601,
                33.7782591
              ],
              [
                49.7736937,
                33.778259
              ],
              [
                49.7720269,
                33.7793694
              ],
              [
                49.7636904,
                33.7827004
              ],
              [
                49.7634138,
                33.7829802
              ],
              [
                49.7586903,
                33.7829802
              ],
              [
                49.7525804,
                33.779929
              ],
              [
                49.7492471,
                33.7763182
              ],
              [
                49.748414,
                33.773258
              ],
              [
                49.748414,
                33.771597
              ],
              [
                49.7486905,
                33.7713172
              ],
              [
                49.7492471,
                33.7688167
              ],
              [
                49.7495242,
                33.7668668
              ],
              [
                49.7492472,
                33.7621455
              ],
              [
                49.7448006,
                33.7549237
              ],
              [
                49.7403575,
                33.7515926
              ],
              [
                49.7398009,
                33.7515927
              ],
              [
                49.7398009,
                33.7513128
              ],
              [
                49.735634,
                33.751042
              ],
              [
                49.7350809,
                33.7507531
              ],
              [
                49.7339676,
                33.7507531
              ],
              [
                49.733414,
                33.7504823
              ],
              [
                49.7278577,
                33.7507531
              ],
              [
                49.7273011,
                33.7510419
              ],
              [
                49.7253578,
                33.751042
              ],
              [
                49.7225775,
                33.7518724
              ],
              [
                49.713968,
                33.7563139
              ],
              [
                49.703688,
                33.7652057
              ],
              [
                49.7034111,
                33.7657563
              ],
              [
                49.7028544,
                33.7660362
              ],
              [
                49.7023013,
                33.7671465
              ],
              [
                49.6981348,
                33.7710373
              ],
              [
                49.6909112,
                33.7743682
              ],
              [
                49.6903545,
                33.7749279
              ],
              [
                49.6878549,
                33.7757584
              ],
              [
                49.687578,
                33.7760382
              ],
              [
                49.6733528,
                33.7802831
              ],
              [
                49.6732154,
                33.7802375
              ],
              [
                49.6692782,
                33.7761508
              ],
              [
                49.663947,
                33.7705434
              ],
              [
                49.6546985,
                33.7611877
              ],
              [
                49.6471797,
                33.7532489
              ],
              [
                49.6432794,
                33.749107
              ],
              [
                49.6387875,
                33.7443009
              ],
              [
                49.6332958,
                33.738745
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555001,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خنداب",
          "name:en": "Khondab County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2610766",
          "wikipedia": "fa:شهرستان خنداب"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.0011545,
                34.5974473
              ],
              [
                49.0014314,
                34.5971675
              ],
              [
                49.005878,
                34.5907791
              ],
              [
                49.0078211,
                34.58689
              ],
              [
                49.0086547,
                34.5860598
              ],
              [
                49.0194878,
                34.569944
              ],
              [
                49.0203211,
                34.5693936
              ],
              [
                49.0283778,
                34.5613357
              ],
              [
                49.0286544,
                34.5605054
              ],
              [
                49.029211,
                34.5602258
              ],
              [
                49.0314346,
                34.5546672
              ],
              [
                49.0317111,
                34.5543875
              ],
              [
                49.0317111,
                34.551888
              ],
              [
                49.0317111,
                34.5485583
              ],
              [
                49.033101,
                34.5452195
              ],
              [
                49.0336577,
                34.5449398
              ],
              [
                49.0339342,
                34.5443894
              ],
              [
                49.039491,
                34.5363403
              ],
              [
                49.0400442,
                34.5302222
              ],
              [
                49.0447677,
                34.5218843
              ],
              [
                49.0539343,
                34.5107761
              ],
              [
                49.0547675,
                34.5079968
              ],
              [
                49.0547675,
                34.5074373
              ],
              [
                49.0547675,
                34.5052174
              ],
              [
                49.0531008,
                34.5013372
              ],
              [
                49.0492108,
                34.4988286
              ],
              [
                49.0339344,
                34.4960582
              ],
              [
                49.0314347,
                34.4952189
              ],
              [
                49.0197681,
                34.4793909
              ],
              [
                49.0119882,
                34.4724424
              ],
              [
                49.0103214,
                34.4710528
              ],
              [
                49.0036549,
                34.4657827
              ],
              [
                49.0036549,
                34.4652232
              ],
              [
                49.0030982,
                34.4624438
              ],
              [
                49.0067116,
                34.4593847
              ],
              [
                49.0072647,
                34.4591139
              ],
              [
                49.0072647,
                34.4588342
              ],
              [
                49.014768,
                34.4516058
              ],
              [
                49.0156017,
                34.4477255
              ],
              [
                49.0153216,
                34.4454965
              ],
              [
                49.0108782,
                34.4360482
              ],
              [
                49.0078215,
                34.4313285
              ],
              [
                49.0053219,
                34.4257695
              ],
              [
                49.003655,
                34.4238294
              ],
              [
                49.0005983,
                34.4221598
              ],
              [
                48.9983783,
                34.4216093
              ],
              [
                48.9961552,
                34.4207791
              ],
              [
                48.994765,
                34.4207791
              ],
              [
                48.9942118,
                34.4204994
              ],
              [
                48.9880985,
                34.4204994
              ],
              [
                48.9875418,
                34.4202196
              ],
              [
                48.986432,
                34.4202195
              ],
              [
                48.9858754,
                34.4199399
              ],
              [
                48.9842086,
                34.4199398
              ],
              [
                48.9828222,
                34.4193893
              ],
              [
                48.9819886,
                34.4193894
              ],
              [
                48.977542,
                34.4174401
              ],
              [
                48.9661523,
                34.4099408
              ],
              [
                48.9555955,
                34.4043818
              ],
              [
                48.9528193,
                34.4016113
              ],
              [
                48.951429,
                34.3996621
              ],
              [
                48.9511524,
                34.3991026
              ],
              [
                48.9497625,
                34.3896629
              ],
              [
                48.9500427,
                34.388553
              ],
              [
                48.9525423,
                34.3841129
              ],
              [
                48.9547623,
                34.3829938
              ],
              [
                48.9561526,
                34.3827231
              ],
              [
                48.9583757,
                34.3827231
              ],
              [
                48.9589323,
                34.3824434
              ],
              [
                48.9603191,
                34.3824433
              ],
              [
                48.9608757,
                34.3827232
              ],
              [
                48.9647657,
                34.3832737
              ],
              [
                48.9683754,
                34.3841129
              ],
              [
                48.9747655,
                34.3866037
              ],
              [
                48.9755987,
                34.3866037
              ],
              [
                48.9836556,
                34.389663
              ],
              [
                48.9855989,
                34.389663
              ],
              [
                48.9894889,
                34.389663
              ],
              [
                48.990322,
                34.3893833
              ],
              [
                48.9917088,
                34.3893833
              ],
              [
                48.9922654,
                34.3891035
              ],
              [
                49.007265,
                34.3843837
              ],
              [
                49.0122651,
                34.3782741
              ],
              [
                49.0092119,
                34.3618855
              ],
              [
                49.009212,
                34.3568859
              ],
              [
                49.0094885,
                34.3557759
              ],
              [
                49.0097652,
                34.3549366
              ],
              [
                49.0161973,
                34.3448964
              ],
              [
                49.015602,
                34.344107
              ],
              [
                49.0150454,
                34.3432767
              ],
              [
                49.0153219,
                34.3416072
              ],
              [
                49.0158785,
                34.3388275
              ],
              [
                49.0147683,
                34.3332683
              ],
              [
                49.0125454,
                34.3296674
              ],
              [
                49.0089319,
                34.3257687
              ],
              [
                49.0089319,
                34.3241081
              ],
              [
                49.0108785,
                34.3224386
              ],
              [
                49.015602,
                34.3193881
              ],
              [
                49.0208784,
                34.3096594
              ],
              [
                49.0256019,
                34.3054899
              ],
              [
                49.0331017,
                34.3032698
              ],
              [
                49.0361584,
                34.3032698
              ],
              [
                49.036435,
                34.30299
              ],
              [
                49.038935,
                34.3029901
              ],
              [
                49.0400447,
                34.3027102
              ],
              [
                49.0433781,
                34.2996598
              ],
              [
                49.0450449,
                34.2977195
              ],
              [
                49.0506017,
                34.2904905
              ],
              [
                49.0639348,
                34.2863209
              ],
              [
                49.0642148,
                34.2860502
              ],
              [
                49.0644914,
                34.2857705
              ],
              [
                49.0650481,
                34.2854907
              ],
              [
                49.0700478,
                34.2835504
              ],
              [
                49.0789379,
                34.2738304
              ],
              [
                49.0792144,
                34.2735506
              ],
              [
                49.0839379,
                34.2629913
              ],
              [
                49.0919944,
                34.2582712
              ],
              [
                49.0931046,
                34.2582711
              ],
              [
                49.0933811,
                34.2579913
              ],
              [
                49.0967143,
                34.2577117
              ],
              [
                49.0975476,
                34.2574409
              ],
              [
                49.0986609,
                34.2574408
              ],
              [
                49.0992145,
                34.2571611
              ],
              [
                49.1006043,
                34.2571611
              ],
              [
                49.1011609,
                34.2568813
              ],
              [
                49.1033809,
                34.2568813
              ],
              [
                49.1039376,
                34.2566016
              ],
              [
                49.1061611,
                34.2566016
              ],
              [
                49.1092174,
                34.2557712
              ],
              [
                49.1106041,
                34.2557712
              ],
              [
                49.1133842,
                34.2546612
              ],
              [
                49.1194941,
                34.2510511
              ],
              [
                49.1217173,
                34.2488219
              ],
              [
                49.1219942,
                34.2479916
              ],
              [
                49.1228274,
                34.2466017
              ],
              [
                49.1236607,
                34.2435512
              ],
              [
                49.1239373,
                34.2429916
              ],
              [
                49.1231041,
                34.2374411
              ],
              [
                49.1189375,
                34.2296613
              ],
              [
                49.118661,
                34.2293815
              ],
              [
                49.118384,
                34.2291108
              ],
              [
                49.1169941,
                34.2271613
              ],
              [
                49.1161609,
                34.2257714
              ],
              [
                49.1153274,
                34.2218815
              ],
              [
                49.1156044,
                34.2202118
              ],
              [
                49.1242174,
                34.2032713
              ],
              [
                49.124494,
                34.2029915
              ],
              [
                49.1242175,
                34.2021611
              ],
              [
                49.1236607,
                34.2018813
              ],
              [
                49.1269941,
                34.2013308
              ],
              [
                49.1389407,
                34.1957712
              ],
              [
                49.139494,
                34.1957711
              ],
              [
                49.1400506,
                34.1952116
              ],
              [
                49.1439405,
                34.1941014
              ],
              [
                49.1492172,
                34.1941015
              ],
              [
                49.1500505,
                34.1943813
              ],
              [
                49.1525504,
                34.1946611
              ],
              [
                49.154774,
                34.1946611
              ],
              [
                49.1556073,
                34.1949408
              ],
              [
                49.1572736,
                34.1949408
              ],
              [
                49.1606069,
                34.1957711
              ],
              [
                49.1622737,
                34.1957712
              ],
              [
                49.1625503,
                34.196051
              ],
              [
                49.1642202,
                34.196051
              ],
              [
                49.1689403,
                34.1946611
              ],
              [
                49.1717204,
                34.1946611
              ],
              [
                49.1725536,
                34.1949408
              ],
              [
                49.1750536,
                34.1949409
              ],
              [
                49.1756067,
                34.1946611
              ],
              [
                49.1781068,
                34.1946611
              ],
              [
                49.1839432,
                34.1932712
              ],
              [
                49.2083864,
                34.1793811
              ],
              [
                49.2092197,
                34.1779911
              ],
              [
                49.2094997,
                34.1777113
              ],
              [
                49.2097767,
                34.1766012
              ],
              [
                49.2097766,
                34.1732707
              ],
              [
                49.20672,
                34.1668807
              ],
              [
                49.2058864,
                34.1638301
              ],
              [
                49.2083864,
                34.1624401
              ],
              [
                49.2136666,
                34.1624401
              ],
              [
                49.2139432,
                34.1621603
              ],
              [
                49.2161662,
                34.1621604
              ],
              [
                49.2236664,
                34.1591007
              ],
              [
                49.2242231,
                34.1591007
              ],
              [
                49.2294998,
                34.1585501
              ],
              [
                49.2428329,
                34.1632705
              ],
              [
                49.2456126,
                34.1641009
              ],
              [
                49.2533893,
                34.165211
              ],
              [
                49.2547792,
                34.1649402
              ],
              [
                49.2645025,
                34.1604907
              ],
              [
                49.2653361,
                34.1596603
              ],
              [
                49.2914455,
                34.1460497
              ],
              [
                49.2917257,
                34.1457699
              ],
              [
                49.2933921,
                34.1449395
              ],
              [
                49.3153386,
                34.13382
              ],
              [
                49.3300585,
                34.1307692
              ],
              [
                49.3322816,
                34.1307693
              ],
              [
                49.3350618,
                34.1302187
              ],
              [
                49.3370051,
                34.1302187
              ],
              [
                49.3372817,
                34.1299299
              ],
              [
                49.338395,
                34.1299298
              ],
              [
                49.3400614,
                34.1293793
              ],
              [
                49.3414483,
                34.1293793
              ],
              [
                49.3422815,
                34.1290995
              ],
              [
                49.3433952,
                34.1290995
              ],
              [
                49.3442283,
                34.1288197
              ],
              [
                49.3461714,
                34.1288198
              ],
              [
                49.3525613,
                34.127159
              ],
              [
                49.3583946,
                34.1263287
              ],
              [
                49.3595048,
                34.1268792
              ],
              [
                49.3602829,
                34.1272689
              ],
              [
                49.3686714,
                34.1315997
              ],
              [
                49.3975642,
                34.1421598
              ],
              [
                49.3983974,
                34.1421598
              ],
              [
                49.4008974,
                34.1438206
              ],
              [
                49.4017306,
                34.14855
              ],
              [
                49.401451,
                34.1491006
              ],
              [
                49.4006173,
                34.1513299
              ],
              [
                49.3995075,
                34.1535503
              ],
              [
                49.399784,
                34.161601
              ],
              [
                49.4000643,
                34.1621606
              ],
              [
                49.3997841,
                34.1627202
              ],
              [
                49.3995075,
                34.1663214
              ],
              [
                49.3975641,
                34.173271
              ],
              [
                49.397284,
                34.1735418
              ],
              [
                49.3897842,
                34.1904917
              ],
              [
                49.3895076,
                34.1916018
              ],
              [
                49.380341,
                34.2063223
              ],
              [
                49.380341,
                34.2066021
              ],
              [
                49.3800609,
                34.2077122
              ],
              [
                49.3800609,
                34.2085516
              ],
              [
                49.3817277,
                34.2110426
              ],
              [
                49.3922842,
                34.2121527
              ],
              [
                49.3936741,
                34.2118819
              ],
              [
                49.3939507,
                34.2116021
              ],
              [
                49.3947843,
                34.2116022
              ],
              [
                49.402284,
                34.2074325
              ],
              [
                49.406174,
                34.2035515
              ],
              [
                49.4072837,
                34.2018819
              ],
              [
                49.4108971,
                34.1982717
              ],
              [
                49.4131206,
                34.1971616
              ],
              [
                49.4136737,
                34.196602
              ],
              [
                49.4189539,
                34.1946615
              ],
              [
                49.4197872,
                34.1946616
              ],
              [
                49.4203402,
                34.1943817
              ],
              [
                49.4211739,
                34.1943817
              ],
              [
                49.4217305,
                34.194102
              ],
              [
                49.4228403,
                34.1941019
              ],
              [
                49.4270068,
                34.194102
              ],
              [
                49.4295104,
                34.194102
              ],
              [
                49.4297869,
                34.1943817
              ],
              [
                49.4317304,
                34.1943818
              ],
              [
                49.438677,
                34.1968818
              ],
              [
                49.4461767,
                34.2068819
              ],
              [
                49.4470099,
                34.2071617
              ],
              [
                49.4503432,
                34.2071618
              ],
              [
                49.4620099,
                34.2010516
              ],
              [
                49.4628431,
                34.200492
              ],
              [
                49.4686764,
                34.1988223
              ],
              [
                49.469233,
                34.1988223
              ],
              [
                49.4714565,
                34.2002122
              ],
              [
                49.4720097,
                34.2002122
              ],
              [
                49.4753429,
                34.2016022
              ],
              [
                49.4761765,
                34.2016021
              ],
              [
                49.4761766,
                34.2018819
              ],
              [
                49.4806231,
                34.2018819
              ],
              [
                49.4811762,
                34.2021618
              ],
              [
                49.4828431,
                34.2021618
              ],
              [
                49.4836763,
                34.2024416
              ],
              [
                49.4939562,
                34.2027123
              ],
              [
                49.4942328,
                34.2029921
              ],
              [
                49.4961797,
                34.2029922
              ],
              [
                49.4964563,
                34.2032719
              ],
              [
                49.4981227,
                34.2032719
              ],
              [
                49.4981227,
                34.2035517
              ],
              [
                49.4997896,
                34.2038315
              ],
              [
                49.5195125,
                34.2154923
              ],
              [
                49.5306257,
                34.2249328
              ],
              [
                49.5309022,
                34.2324418
              ],
              [
                49.5328455,
                34.2379924
              ],
              [
                49.5334023,
                34.239662
              ],
              [
                49.5339589,
                34.248272
              ],
              [
                49.5336789,
                34.2485518
              ],
              [
                49.5334023,
                34.2502124
              ],
              [
                49.5331256,
                34.2504922
              ],
              [
                49.5331256,
                34.2513225
              ],
              [
                49.5328456,
                34.2516023
              ],
              [
                49.532569,
                34.2541023
              ],
              [
                49.5322924,
                34.2571619
              ],
              [
                49.5320123,
                34.2582719
              ],
              [
                49.5317358,
                34.259382
              ],
              [
                49.5314588,
                34.2610516
              ],
              [
                49.5311787,
                34.2621617
              ],
              [
                49.5309022,
                34.2641021
              ],
              [
                49.5231258,
                34.2846612
              ],
              [
                49.5220125,
                34.286051
              ],
              [
                49.5195124,
                34.2907711
              ],
              [
                49.5195124,
                34.293271
              ],
              [
                49.5189557,
                34.2935508
              ],
              [
                49.5170123,
                34.2935508
              ],
              [
                49.5164557,
                34.2938306
              ],
              [
                49.5147889,
                34.2938305
              ],
              [
                49.5145123,
                34.2941103
              ],
              [
                49.5131224,
                34.2941103
              ],
              [
                49.4997894,
                34.2982709
              ],
              [
                49.4939559,
                34.2996606
              ],
              [
                49.4936794,
                34.2999404
              ],
              [
                49.4928461,
                34.2999404
              ],
              [
                49.4925661,
                34.3002202
              ],
              [
                49.4886794,
                34.3002201
              ],
              [
                49.4831229,
                34.2993898
              ],
              [
                49.4825659,
                34.2991101
              ],
              [
                49.4789561,
                34.2991101
              ],
              [
                49.476456,
                34.2996606
              ],
              [
                49.4750662,
                34.3002201
              ],
              [
                49.4722895,
                34.3002201
              ],
              [
                49.4670097,
                34.29911
              ],
              [
                49.4653428,
                34.2991101
              ],
              [
                49.4647863,
                34.2988303
              ],
              [
                49.4586764,
                34.2988303
              ],
              [
                49.4581197,
                34.2991101
              ],
              [
                49.456733,
                34.29911
              ],
              [
                49.4564533,
                34.2993899
              ],
              [
                49.4556197,
                34.2993898
              ],
              [
                49.4486765,
                34.3082703
              ],
              [
                49.4422866,
                34.30994
              ],
              [
                49.4397864,
                34.3099399
              ],
              [
                49.4389533,
                34.3102197
              ],
              [
                49.4370099,
                34.3102197
              ],
              [
                49.4361767,
                34.3104995
              ],
              [
                49.4297867,
                34.3104994
              ],
              [
                49.424787,
                34.3118893
              ],
              [
                49.422287,
                34.3124398
              ],
              [
                49.4170068,
                34.3141003
              ],
              [
                49.4150638,
                34.3149397
              ],
              [
                49.4122871,
                34.3168799
              ],
              [
                49.4100635,
                34.3207787
              ],
              [
                49.4103402,
                34.3268884
              ],
              [
                49.412007,
                34.3318791
              ],
              [
                49.4120069,
                34.3346588
              ],
              [
                49.4108968,
                34.3357779
              ],
              [
                49.4095069,
                34.3393787
              ],
              [
                49.4092304,
                34.3407686
              ],
              [
                49.408117,
                34.3438279
              ],
              [
                49.4054021,
                34.3453124
              ],
              [
                49.4017302,
                34.3454975
              ],
              [
                49.3997837,
                34.3454974
              ],
              [
                49.3975637,
                34.3452177
              ],
              [
                49.3908971,
                34.3452177
              ],
              [
                49.3850607,
                34.347158
              ],
              [
                49.3742272,
                34.3579966
              ],
              [
                49.3753405,
                34.3621659
              ],
              [
                49.3761741,
                34.3657758
              ],
              [
                49.3756174,
                34.3666061
              ],
              [
                49.3742272,
                34.3671656
              ],
              [
                49.3739506,
                34.3674453
              ],
              [
                49.3733939,
                34.3674453
              ],
              [
                49.3722838,
                34.3693856
              ],
              [
                49.3720073,
                34.3704956
              ],
              [
                49.3714506,
                34.3718854
              ],
              [
                49.3706174,
                34.3729954
              ],
              [
                49.3695041,
                34.373555
              ],
              [
                49.3689505,
                34.3743853
              ],
              [
                49.3589506,
                34.3785545
              ],
              [
                49.3575609,
                34.3785545
              ],
              [
                49.3567276,
                34.3788343
              ],
              [
                49.3553374,
                34.3788343
              ],
              [
                49.3545041,
                34.3791141
              ],
              [
                49.3522806,
                34.379114
              ],
              [
                49.3514474,
                34.3793848
              ],
              [
                49.3408945,
                34.379114
              ],
              [
                49.3397812,
                34.3788343
              ],
              [
                49.3292243,
                34.3793848
              ],
              [
                49.3228378,
                34.3799352
              ],
              [
                49.3217245,
                34.380215
              ],
              [
                49.3189479,
                34.380215
              ],
              [
                49.317558,
                34.3799352
              ],
              [
                49.3097813,
                34.3799352
              ],
              [
                49.3072813,
                34.3796644
              ],
              [
                49.3067246,
                34.3793848
              ],
              [
                49.3056148,
                34.3793848
              ],
              [
                49.2947783,
                34.3760547
              ],
              [
                49.2942247,
                34.3757748
              ],
              [
                49.2925583,
                34.3754951
              ],
              [
                49.2917251,
                34.3754951
              ],
              [
                49.2911684,
                34.3757749
              ],
              [
                49.2897782,
                34.3757749
              ],
              [
                49.289225,
                34.3760546
              ],
              [
                49.2875582,
                34.3760546
              ],
              [
                49.2861684,
                34.3766051
              ],
              [
                49.2847785,
                34.3779949
              ],
              [
                49.2806115,
                34.3843843
              ],
              [
                49.2797783,
                34.3852145
              ],
              [
                49.277835,
                34.3882738
              ],
              [
                49.2670018,
                34.4007726
              ],
              [
                49.2647783,
                34.4066024
              ],
              [
                49.2653354,
                34.4121613
              ],
              [
                49.2811681,
                34.4332783
              ],
              [
                49.2920015,
                34.4374474
              ],
              [
                49.2945016,
                34.4382776
              ],
              [
                49.2992246,
                34.4418873
              ],
              [
                49.3008915,
                34.445497
              ],
              [
                49.3008915,
                34.449946
              ],
              [
                49.3006145,
                34.4502257
              ],
              [
                49.2931112,
                34.4702231
              ],
              [
                49.2931112,
                34.4782815
              ],
              [
                49.2928346,
                34.478832
              ],
              [
                49.292558,
                34.4827212
              ],
              [
                49.2920014,
                34.4857804
              ],
              [
                49.2858915,
                34.501888
              ],
              [
                49.286168,
                34.5043877
              ],
              [
                49.2903345,
                34.5271637
              ],
              [
                49.2900579,
                34.5277231
              ],
              [
                49.2900578,
                34.5285533
              ],
              [
                49.2842245,
                34.5285533
              ],
              [
                49.2839444,
                34.5288331
              ],
              [
                49.2822781,
                34.5288331
              ],
              [
                49.279778,
                34.5288331
              ],
              [
                49.2767212,
                34.528833
              ],
              [
                49.2761682,
                34.5291128
              ],
              [
                49.2670015,
                34.5291128
              ],
              [
                49.2658882,
                34.5293925
              ],
              [
                49.2631116,
                34.5293925
              ],
              [
                49.2620015,
                34.5296722
              ],
              [
                49.2556119,
                34.5296722
              ],
              [
                49.2528317,
                34.5299429
              ],
              [
                49.234222,
                34.5382807
              ],
              [
                49.2328321,
                34.5382808
              ],
              [
                49.2319985,
                34.5385605
              ],
              [
                49.2147754,
                34.5363407
              ],
              [
                49.212832,
                34.5357811
              ],
              [
                49.2114422,
                34.5357812
              ],
              [
                49.2103324,
                34.5355015
              ],
              [
                49.2089422,
                34.5355014
              ],
              [
                49.208109,
                34.5352216
              ],
              [
                49.2075522,
                34.5352216
              ],
              [
                49.204499,
                34.5352217
              ],
              [
                49.2014424,
                34.5352216
              ],
              [
                49.2006092,
                34.5355014
              ],
              [
                49.1986622,
                34.5355014
              ],
              [
                49.1981091,
                34.5357811
              ],
              [
                49.193109,
                34.5357811
              ],
              [
                49.1875527,
                34.5332815
              ],
              [
                49.1869959,
                34.5327221
              ],
              [
                49.1858858,
                34.5324423
              ],
              [
                49.1817193,
                34.5293923
              ],
              [
                49.1783861,
                34.5274433
              ],
              [
                49.175886,
                34.5268927
              ],
              [
                49.1756059,
                34.526613
              ],
              [
                49.173386,
                34.5266131
              ],
              [
                49.1731059,
                34.5268928
              ],
              [
                49.1714394,
                34.5268928
              ],
              [
                49.160606,
                34.5288328
              ],
              [
                49.1600494,
                34.5291125
              ],
              [
                49.1586629,
                34.5291126
              ],
              [
                49.1511628,
                34.5310526
              ],
              [
                49.1500495,
                34.5310527
              ],
              [
                49.149773,
                34.5313323
              ],
              [
                49.1489397,
                34.5313324
              ],
              [
                49.1483831,
                34.5316121
              ],
              [
                49.1478295,
                34.5316121
              ],
              [
                49.1478295,
                34.5324423
              ],
              [
                49.1475494,
                34.532722
              ],
              [
                49.147273,
                34.5343824
              ],
              [
                49.1386598,
                34.5543877
              ],
              [
                49.1383832,
                34.5549472
              ],
              [
                49.1333831,
                34.5657754
              ],
              [
                49.1331065,
                34.567165
              ],
              [
                49.1328264,
                34.5693938
              ],
              [
                49.1325498,
                34.5713339
              ],
              [
                49.1322733,
                34.5727234
              ],
              [
                49.1308829,
                34.5796715
              ],
              [
                49.1214362,
                34.5932787
              ],
              [
                49.1208832,
                34.5946684
              ],
              [
                49.120603,
                34.5963286
              ],
              [
                49.1203265,
                34.5971678
              ],
              [
                49.1197698,
                34.5968881
              ],
              [
                49.1189367,
                34.5963286
              ],
              [
                49.118103,
                34.5960579
              ],
              [
                49.1069934,
                34.5866104
              ],
              [
                49.1061601,
                34.5866104
              ],
              [
                49.1056036,
                34.5863307
              ],
              [
                49.1028269,
                34.5857803
              ],
              [
                49.1003269,
                34.5857803
              ],
              [
                49.0994937,
                34.5855006
              ],
              [
                49.0972702,
                34.5852299
              ],
              [
                49.0939369,
                34.5852298
              ],
              [
                49.0933803,
                34.5849501
              ],
              [
                49.0906036,
                34.5849501
              ],
              [
                49.090047,
                34.5846704
              ],
              [
                49.0869903,
                34.5846704
              ],
              [
                49.0864372,
                34.5843907
              ],
              [
                49.0831035,
                34.5843906
              ],
              [
                49.0825468,
                34.5846704
              ],
              [
                49.0811569,
                34.5846704
              ],
              [
                49.0808804,
                34.58495
              ],
              [
                49.0803237,
                34.5849501
              ],
              [
                49.0800472,
                34.5852298
              ],
              [
                49.0775471,
                34.58606
              ],
              [
                49.0753236,
                34.588
              ],
              [
                49.0742139,
                34.5902288
              ],
              [
                49.0739372,
                34.5907792
              ],
              [
                49.0742138,
                34.5916093
              ],
              [
                49.0739373,
                34.5924485
              ],
              [
                49.0742138,
                34.5932786
              ],
              [
                49.0742138,
                34.6055052
              ],
              [
                49.0700468,
                34.6227215
              ],
              [
                49.0700468,
                34.6285595
              ],
              [
                49.0683804,
                34.6321687
              ],
              [
                49.0672671,
                34.6329988
              ],
              [
                49.0633803,
                34.6346681
              ],
              [
                49.0625471,
                34.634668
              ],
              [
                49.0619904,
                34.6349478
              ],
              [
                49.060047,
                34.6349478
              ],
              [
                49.0550473,
                34.6329988
              ],
              [
                49.0442108,
                34.6163331
              ],
              [
                49.0397673,
                34.614393
              ],
              [
                49.0383775,
                34.614393
              ],
              [
                49.0356008,
                34.6135539
              ],
              [
                49.0319911,
                34.6135538
              ],
              [
                49.0311543,
                34.6132742
              ],
              [
                49.0239342,
                34.6121643
              ],
              [
                49.0208775,
                34.6093941
              ],
              [
                49.0197677,
                34.6077248
              ],
              [
                49.0186544,
                34.6060555
              ],
              [
                49.0114313,
                34.6018867
              ],
              [
                49.0097644,
                34.6018868
              ],
              [
                49.0097644,
                34.601607
              ],
              [
                49.0028213,
                34.5991166
              ],
              [
                49.0011545,
                34.5974473
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555020,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان دلیجان",
          "name:en": "Delijan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277846",
          "wikipedia": "fa:شهرستان دلیجان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.2717695,
                34.2649426
              ],
              [
                50.2717696,
                34.2643831
              ],
              [
                50.271213,
                34.263273
              ],
              [
                50.2703797,
                34.2604932
              ],
              [
                50.2514899,
                34.2282732
              ],
              [
                50.2503802,
                34.2213238
              ],
              [
                50.25149,
                34.216053
              ],
              [
                50.2517701,
                34.2157732
              ],
              [
                50.2517701,
                34.2149429
              ],
              [
                50.2542702,
                34.2079933
              ],
              [
                50.2545467,
                34.207163
              ],
              [
                50.2545467,
                34.2068832
              ],
              [
                50.2564901,
                34.2032731
              ],
              [
                50.2645466,
                34.1946628
              ],
              [
                50.2656598,
                34.1941033
              ],
              [
                50.3078827,
                34.1552123
              ],
              [
                50.3081595,
                34.1549325
              ],
              [
                50.3087162,
                34.1546618
              ],
              [
                50.3103828,
                34.1527122
              ],
              [
                50.3106592,
                34.1527122
              ],
              [
                50.3114929,
                34.1524414
              ],
              [
                50.316216,
                34.1527122
              ],
              [
                50.342329,
                34.1518819
              ],
              [
                50.3562188,
                34.1518819
              ],
              [
                50.357329,
                34.1521617
              ],
              [
                50.3598286,
                34.1521618
              ],
              [
                50.3612189,
                34.1524415
              ],
              [
                50.3742754,
                34.1538225
              ],
              [
                50.3828853,
                34.1535516
              ],
              [
                50.3953883,
                34.1535517
              ],
              [
                50.3984416,
                34.1532719
              ],
              [
                50.3989982,
                34.1529921
              ],
              [
                50.4001083,
                34.1529922
              ],
              [
                50.4012217,
                34.1527123
              ],
              [
                50.4156649,
                34.1513315
              ],
              [
                50.424278,
                34.1493819
              ],
              [
                50.4253881,
                34.1488223
              ],
              [
                50.441778,
                34.1452211
              ],
              [
                50.4517778,
                34.1452211
              ],
              [
                50.4531677,
                34.1449413
              ],
              [
                50.4576108,
                34.1449414
              ],
              [
                50.459001,
                34.1446525
              ],
              [
                50.4720575,
                34.1429918
              ],
              [
                50.4745575,
                34.1429918
              ],
              [
                50.4751142,
                34.142712
              ],
              [
                50.4923372,
                34.1407715
              ],
              [
                50.4945572,
                34.1402209
              ],
              [
                50.5178936,
                34.1338217
              ],
              [
                50.5234504,
                34.1296609
              ],
              [
                50.5242836,
                34.1279911
              ],
              [
                50.53706,
                34.1071596
              ],
              [
                50.5381698,
                34.105219
              ],
              [
                50.5517831,
                34.075217
              ],
              [
                50.5526167,
                34.0716065
              ],
              [
                50.5528932,
                34.0713268
              ],
              [
                50.5570598,
                34.0546557
              ],
              [
                50.5573399,
                34.0535455
              ],
              [
                50.557893,
                34.0515958
              ],
              [
                50.557893,
                34.0504946
              ],
              [
                50.5581731,
                34.0488249
              ],
              [
                50.5584497,
                34.0482652
              ],
              [
                50.5573399,
                34.0424343
              ],
              [
                50.5415033,
                34.0349336
              ],
              [
                50.5365035,
                34.0293736
              ],
              [
                50.5367836,
                34.0274328
              ],
              [
                50.5398368,
                34.0238224
              ],
              [
                50.5398368,
                34.0235426
              ],
              [
                50.5403934,
                34.0229919
              ],
              [
                50.5428106,
                34.019549
              ],
              [
                50.5431736,
                34.0191017
              ],
              [
                50.5431736,
                34.0188219
              ],
              [
                50.5434501,
                34.0191017
              ],
              [
                50.5437268,
                34.0196523
              ],
              [
                50.5448401,
                34.0204917
              ],
              [
                50.5495601,
                34.0221525
              ],
              [
                50.5556731,
                34.0221526
              ],
              [
                50.5656733,
                34.0179915
              ],
              [
                50.5753965,
                34.0102109
              ],
              [
                50.5803963,
                34.0077106
              ],
              [
                50.5806728,
                34.007151
              ],
              [
                50.5820632,
                34.0054901
              ],
              [
                50.5862296,
                33.9996592
              ],
              [
                50.5953962,
                33.9913189
              ],
              [
                50.6155323,
                33.9598709
              ],
              [
                50.6162291,
                33.9591036
              ],
              [
                50.622066,
                33.9504833
              ],
              [
                50.6317857,
                33.943542
              ],
              [
                50.6331756,
                33.9432711
              ],
              [
                50.6337326,
                33.9429913
              ],
              [
                50.6390089,
                33.9418811
              ],
              [
                50.6403992,
                33.9418811
              ],
              [
                50.6409558,
                33.9416013
              ],
              [
                50.6434555,
                33.9416013
              ],
              [
                50.6437325,
                33.9413215
              ],
              [
                50.6442891,
                33.9413214
              ],
              [
                50.6448422,
                33.9410417
              ],
              [
                50.6456754,
                33.9410416
              ],
              [
                50.6581788,
                33.93438
              ],
              [
                50.6687319,
                33.9218782
              ],
              [
                50.6709553,
                33.9171573
              ],
              [
                50.6862353,
                33.8929929
              ],
              [
                50.6870686,
                33.8918736
              ],
              [
                50.6906784,
                33.8854826
              ],
              [
                50.6934586,
                33.8816011
              ],
              [
                50.7176249,
                33.8465951
              ],
              [
                50.7187349,
                33.8440946
              ],
              [
                50.7181816,
                33.841874
              ],
              [
                50.7173482,
                33.8399332
              ],
              [
                50.7173483,
                33.8327026
              ],
              [
                50.7179015,
                33.8310416
              ],
              [
                50.7179015,
                33.8302112
              ],
              [
                50.7181816,
                33.8293716
              ],
              [
                50.7312347,
                33.7971543
              ],
              [
                50.7340147,
                33.7932635
              ],
              [
                50.7362381,
                33.7910429
              ],
              [
                50.7365146,
                33.7902034
              ],
              [
                50.7387382,
                33.7879827
              ],
              [
                50.7387381,
                33.787432
              ],
              [
                50.7570712,
                33.763817
              ],
              [
                50.7576278,
                33.7629864
              ],
              [
                50.7590144,
                33.7604859
              ],
              [
                50.7590144,
                33.7596464
              ],
              [
                50.7595712,
                33.756875
              ],
              [
                50.7604045,
                33.7540947
              ],
              [
                50.7581812,
                33.7493734
              ],
              [
                50.7523479,
                33.7424224
              ],
              [
                50.7520713,
                33.7402016
              ],
              [
                50.7556812,
                33.7338194
              ],
              [
                50.7571071,
                33.727937
              ],
              [
                50.7592516,
                33.7290434
              ],
              [
                50.7633949,
                33.7312016
              ],
              [
                50.7693353,
                33.7340924
              ],
              [
                50.7743551,
                33.7363822
              ],
              [
                50.7831042,
                33.7399867
              ],
              [
                50.7971713,
                33.7431051
              ],
              [
                50.8052503,
                33.744247
              ],
              [
                50.8163634,
                33.7452782
              ],
              [
                50.8265743,
                33.7448106
              ],
              [
                50.8420302,
                33.7452383
              ],
              [
                50.8536554,
                33.7448993
              ],
              [
                50.8716359,
                33.7431807
              ],
              [
                50.8778516,
                33.743252
              ],
              [
                50.8825913,
                33.7441027
              ],
              [
                50.8959802,
                33.7439878
              ],
              [
                50.9015785,
                33.7446867
              ],
              [
                50.9124469,
                33.7453249
              ],
              [
                50.9214387,
                33.7466678
              ],
              [
                50.9338727,
                33.7476744
              ],
              [
                50.9482521,
                33.7492101
              ],
              [
                50.9543213,
                33.7484194
              ],
              [
                50.960647,
                33.7481525
              ],
              [
                50.9653653,
                33.7483407
              ],
              [
                50.9677219,
                33.7472519
              ],
              [
                50.9737235,
                33.7477378
              ],
              [
                50.9746741,
                33.7485365
              ],
              [
                50.9750468,
                33.7550939
              ],
              [
                50.979025,
                33.7579856
              ],
              [
                50.989305,
                33.7635374
              ],
              [
                50.9912482,
                33.7640971
              ],
              [
                50.9998615,
                33.7677079
              ],
              [
                51.0093045,
                33.7729798
              ],
              [
                51.0237511,
                33.7860422
              ],
              [
                51.0468074,
                33.8157683
              ],
              [
                51.0487508,
                33.8188195
              ],
              [
                51.049584,
                33.8202096
              ],
              [
                51.050974,
                33.8274312
              ],
              [
                51.050694,
                33.8279819
              ],
              [
                51.0504174,
                33.8296519
              ],
              [
                51.0484739,
                33.8332627
              ],
              [
                51.0484739,
                33.8338224
              ],
              [
                51.0362508,
                33.8460448
              ],
              [
                51.0351408,
                33.8465955
              ],
              [
                51.0326375,
                33.8496556
              ],
              [
                51.0320842,
                33.8529864
              ],
              [
                51.0359741,
                33.860208
              ],
              [
                51.0373609,
                33.8621578
              ],
              [
                51.0379175,
                33.8627085
              ],
              [
                51.0418074,
                33.8754904
              ],
              [
                51.0415273,
                33.8763209
              ],
              [
                51.0401407,
                33.8827118
              ],
              [
                51.0393073,
                33.8868732
              ],
              [
                51.0390274,
                33.8882633
              ],
              [
                51.0426408,
                33.8963242
              ],
              [
                51.043474,
                33.8988156
              ],
              [
                51.0468073,
                33.9024353
              ],
              [
                51.0473606,
                33.9024353
              ],
              [
                51.0481938,
                33.9027151
              ],
              [
                51.0495839,
                33.9077159
              ],
              [
                51.0498605,
                33.9079867
              ],
              [
                51.0481535,
                33.9107632
              ],
              [
                51.0476407,
                33.9115973
              ],
              [
                51.0476407,
                33.912157
              ],
              [
                51.0470841,
                33.9124278
              ],
              [
                51.0460226,
                33.914733
              ],
              [
                51.0454172,
                33.9160475
              ],
              [
                51.0448605,
                33.918268
              ],
              [
                51.0449459,
                33.9197933
              ],
              [
                51.0451406,
                33.9232688
              ],
              [
                51.0481938,
                33.9288202
              ],
              [
                51.0484071,
                33.9330564
              ],
              [
                51.0487507,
                33.9347913
              ],
              [
                51.0487506,
                33.9349311
              ],
              [
                51.0487506,
                33.9366011
              ],
              [
                51.0484739,
                33.9368718
              ],
              [
                51.0390273,
                33.9460428
              ],
              [
                51.0387506,
                33.9463226
              ],
              [
                51.0354173,
                33.9491028
              ],
              [
                51.0351408,
                33.9493826
              ],
              [
                51.0282877,
                33.9548253
              ],
              [
                51.0270604,
                33.9577851
              ],
              [
                51.0262364,
                33.9600062
              ],
              [
                51.0263651,
                33.9620992
              ],
              [
                51.0281418,
                33.9663277
              ],
              [
                51.0289915,
                33.9681856
              ],
              [
                51.0293263,
                33.970556
              ],
              [
                51.030485,
                33.9719654
              ],
              [
                51.0340384,
                33.975019
              ],
              [
                51.0348109,
                33.9763429
              ],
              [
                51.0348109,
                33.9784568
              ],
              [
                51.0356091,
                33.9830047
              ],
              [
                51.0384158,
                33.9866984
              ],
              [
                51.0403727,
                33.989538
              ],
              [
                51.0441836,
                33.995537
              ],
              [
                51.0453938,
                33.9975864
              ],
              [
                51.0523203,
                34.0045241
              ],
              [
                51.0553587,
                34.0103941
              ],
              [
                51.054097,
                34.0145775
              ],
              [
                51.0539425,
                34.0240534
              ],
              [
                51.0538653,
                34.0266356
              ],
              [
                51.0537108,
                34.0280654
              ],
              [
                51.0462435,
                34.0286203
              ],
              [
                51.0401667,
                34.0292818
              ],
              [
                51.0344246,
                34.0306902
              ],
              [
                51.0318497,
                34.0314157
              ],
              [
                51.0292748,
                34.0327814
              ],
              [
                51.0275753,
                34.0336563
              ],
              [
                51.0268029,
                34.0354914
              ],
              [
                51.0270346,
                34.0375825
              ],
              [
                51.0274981,
                34.0388628
              ],
              [
                51.0280646,
                34.0411672
              ],
              [
                51.0281418,
                34.0432582
              ],
              [
                51.0279873,
                34.0443463
              ],
              [
                51.0277813,
                34.0461172
              ],
              [
                51.0285538,
                34.0494241
              ],
              [
                51.029352,
                34.0564216
              ],
              [
                51.0298413,
                34.0594934
              ],
              [
                51.0296353,
                34.060816
              ],
              [
                51.0290688,
                34.0616053
              ],
              [
                51.0276011,
                34.0625439
              ],
              [
                51.0236357,
                34.064549
              ],
              [
                51.0209649,
                34.0654905
              ],
              [
                51.0018043,
                34.0766075
              ],
              [
                51.0004142,
                34.0771581
              ],
              [
                51.0000233,
                34.0788906
              ],
              [
                50.9998609,
                34.0796583
              ],
              [
                50.9943044,
                34.0810482
              ],
              [
                50.9940242,
                34.0813281
              ],
              [
                50.993191,
                34.081328
              ],
              [
                50.9859712,
                34.0849384
              ],
              [
                50.9837477,
                34.0879892
              ],
              [
                50.9837477,
                34.088269
              ],
              [
                50.9815244,
                34.0907692
              ],
              [
                50.9806912,
                34.0915996
              ],
              [
                50.9693013,
                34.0974393
              ],
              [
                50.968748,
                34.0974393
              ],
              [
                50.961248,
                34.1052195
              ],
              [
                50.9529114,
                34.1116009
              ],
              [
                50.9526347,
                34.1124312
              ],
              [
                50.9518014,
                34.1146606
              ],
              [
                50.9518015,
                34.1149403
              ],
              [
                50.9406423,
                34.1327301
              ],
              [
                50.9343024,
                34.1371138
              ],
              [
                50.931924,
                34.1407814
              ],
              [
                50.9315006,
                34.1486309
              ],
              [
                50.9299439,
                34.1563956
              ],
              [
                50.9282821,
                34.1593659
              ],
              [
                50.9177588,
                34.1618173
              ],
              [
                50.9113343,
                34.1631755
              ],
              [
                50.9034518,
                34.1657966
              ],
              [
                50.8989754,
                34.168421
              ],
              [
                50.8920005,
                34.171589
              ],
              [
                50.8811641,
                34.1751681
              ],
              [
                50.8708035,
                34.1796179
              ],
              [
                50.8565365,
                34.1838649
              ],
              [
                50.8501991,
                34.1847255
              ],
              [
                50.8305247,
                34.1875703
              ],
              [
                50.8234922,
                34.1898817
              ],
              [
                50.815958,
                34.1943017
              ],
              [
                50.8098532,
                34.1976995
              ],
              [
                50.8053588,
                34.2000239
              ],
              [
                50.7954305,
                34.2050602
              ],
              [
                50.7840512,
                34.2102926
              ],
              [
                50.7742082,
                34.213951
              ],
              [
                50.7596978,
                34.2180179
              ],
              [
                50.7502237,
                34.222883
              ],
              [
                50.7360823,
                34.2248623
              ],
              [
                50.7248633,
                34.2264236
              ],
              [
                50.7188437,
                34.2282232
              ],
              [
                50.7131241,
                34.2313587
              ],
              [
                50.7050142,
                34.2334916
              ],
              [
                50.6927487,
                34.2353366
              ],
              [
                50.6771645,
                34.2377102
              ],
              [
                50.6585597,
                34.2367831
              ],
              [
                50.640294,
                34.2330941
              ],
              [
                50.6174772,
                34.2280177
              ],
              [
                50.6023523,
                34.2240108
              ],
              [
                50.5916305,
                34.2194898
              ],
              [
                50.583887,
                34.2152801
              ],
              [
                50.5755453,
                34.2114958
              ],
              [
                50.5639676,
                34.2043168
              ],
              [
                50.5545594,
                34.2029937
              ],
              [
                50.5351165,
                34.1954935
              ],
              [
                50.5340032,
                34.1954936
              ],
              [
                50.5317832,
                34.1943834
              ],
              [
                50.5170602,
                34.1899339
              ],
              [
                50.50928,
                34.1899339
              ],
              [
                50.5056702,
                34.1899338
              ],
              [
                50.4998369,
                34.1899338
              ],
              [
                50.4990037,
                34.1902136
              ],
              [
                50.4962236,
                34.1902136
              ],
              [
                50.4953903,
                34.1904934
              ],
              [
                50.494557,
                34.1904934
              ],
              [
                50.4940036,
                34.1907732
              ],
              [
                50.4815005,
                34.189663
              ],
              [
                50.4792806,
                34.1899337
              ],
              [
                50.4784474,
                34.1902135
              ],
              [
                50.4770571,
                34.1902136
              ],
              [
                50.474834,
                34.1907731
              ],
              [
                50.4731672,
                34.1907732
              ],
              [
                50.472334,
                34.1904934
              ],
              [
                50.4676139,
                34.1904934
              ],
              [
                50.4667807,
                34.1907731
              ],
              [
                50.4651107,
                34.1907731
              ],
              [
                50.4420545,
                34.2010531
              ],
              [
                50.4415009,
                34.2016036
              ],
              [
                50.4387212,
                34.2029935
              ],
              [
                50.4323343,
                34.2068835
              ],
              [
                50.4284443,
                34.211324
              ],
              [
                50.4287213,
                34.2154936
              ],
              [
                50.4317777,
                34.2246633
              ],
              [
                50.4323343,
                34.2252139
              ],
              [
                50.4351108,
                34.2371633
              ],
              [
                50.4356679,
                34.2460532
              ],
              [
                50.4353878,
                34.2466037
              ],
              [
                50.4348342,
                34.2491037
              ],
              [
                50.4245543,
                34.2774425
              ],
              [
                50.4192781,
                34.2843917
              ],
              [
                50.4189979,
                34.2849423
              ],
              [
                50.4176112,
                34.2871625
              ],
              [
                50.4151111,
                34.2910522
              ],
              [
                50.4145545,
                34.2924421
              ],
              [
                50.3962212,
                34.3135513
              ],
              [
                50.3831647,
                34.3230002
              ],
              [
                50.3823315,
                34.323271
              ],
              [
                50.3817749,
                34.3238305
              ],
              [
                50.3812182,
                34.3238305
              ],
              [
                50.3809416,
                34.3241103
              ],
              [
                50.3809416,
                34.3249407
              ],
              [
                50.380385,
                34.3260506
              ],
              [
                50.380385,
                34.3263305
              ],
              [
                50.3701081,
                34.3346602
              ],
              [
                50.3659417,
                34.3427193
              ],
              [
                50.3626084,
                34.3460586
              ],
              [
                50.36219,
                34.3461939
              ],
              [
                50.3613046,
                34.3455173
              ],
              [
                50.3598282,
                34.344389
              ],
              [
                50.3548285,
                34.3379994
              ],
              [
                50.3403854,
                34.3099413
              ],
              [
                50.3289957,
                34.2957721
              ],
              [
                50.3281621,
                34.2952217
              ],
              [
                50.3270487,
                34.2941116
              ],
              [
                50.2917692,
                34.2743829
              ],
              [
                50.2723262,
                34.2652134
              ],
              [
                50.2717695,
                34.2649426
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555058,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زرندیه",
          "name:en": "Zarandieh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277875",
          "wikipedia": "en:Zarandieh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.5427042,
                35.4027091
              ],
              [
                49.56155,
                35.3877347
              ],
              [
                49.579556,
                35.3694386
              ],
              [
                49.6053487,
                35.3530243
              ],
              [
                49.611182,
                35.3505263
              ],
              [
                49.6331251,
                35.3405251
              ],
              [
                49.647848,
                35.3316332
              ],
              [
                49.6486817,
                35.3313537
              ],
              [
                49.6500715,
                35.3310741
              ],
              [
                49.6517385,
                35.3310741
              ],
              [
                49.6690921,
                35.3346636
              ],
              [
                49.6975745,
                35.3307946
              ],
              [
                49.7003512,
                35.3305241
              ],
              [
                49.7134077,
                35.3316333
              ],
              [
                49.7175742,
                35.3316334
              ],
              [
                49.7195207,
                35.3313537
              ],
              [
                49.722854,
                35.3305241
              ],
              [
                49.7284072,
                35.3266372
              ],
              [
                49.7482645,
                35.3135039
              ],
              [
                49.7589669,
                35.3069051
              ],
              [
                49.7617435,
                35.3060754
              ],
              [
                49.7636869,
                35.3057958
              ],
              [
                49.7686901,
                35.3055252
              ],
              [
                49.772857,
                35.3052367
              ],
              [
                49.7979471,
                35.2922755
              ],
              [
                49.8014666,
                35.2907981
              ],
              [
                49.8086898,
                35.2877408
              ],
              [
                49.8117466,
                35.2666281
              ],
              [
                49.8129582,
                35.2644424
              ],
              [
                49.8153564,
                35.262741
              ],
              [
                49.8173079,
                35.2621085
              ],
              [
                49.8203561,
                35.2616317
              ],
              [
                49.8228562,
                35.2616317
              ],
              [
                49.837026,
                35.2616317
              ],
              [
                49.8409129,
                35.2613521
              ],
              [
                49.8450828,
                35.2610726
              ],
              [
                49.852026,
                35.2610725
              ],
              [
                49.8548025,
                35.2613521
              ],
              [
                49.8734159,
                35.2669077
              ],
              [
                49.8798058,
                35.2702357
              ],
              [
                49.8809251,
                35.2707029
              ],
              [
                49.8823055,
                35.2710744
              ],
              [
                49.8848056,
                35.2713539
              ],
              [
                49.8917487,
                35.271354
              ],
              [
                49.8939721,
                35.271354
              ],
              [
                49.8967487,
                35.271354
              ],
              [
                49.8978621,
                35.2716335
              ],
              [
                49.9106384,
                35.2791282
              ],
              [
                49.9128619,
                35.2799669
              ],
              [
                49.9148053,
                35.2802374
              ],
              [
                49.9198945,
                35.2793033
              ],
              [
                49.9253618,
                35.2758003
              ],
              [
                49.9311952,
                35.2657986
              ],
              [
                49.9348082,
                35.2627411
              ],
              [
                49.9367516,
                35.2619024
              ],
              [
                49.9395317,
                35.2613523
              ],
              [
                49.9436982,
                35.2613523
              ],
              [
                49.9445314,
                35.2616318
              ],
              [
                49.9514749,
                35.2627411
              ],
              [
                49.9545316,
                35.2627412
              ],
              [
                49.957588,
                35.2613523
              ],
              [
                49.9678647,
                35.2549669
              ],
              [
                49.968698,
                35.254967
              ],
              [
                49.9853644,
                35.25163
              ],
              [
                49.988421,
                35.2510709
              ],
              [
                49.9939777,
                35.2502411
              ],
              [
                50.0023108,
                35.2502412
              ],
              [
                50.0025878,
                35.2505207
              ],
              [
                50.0050874,
                35.2505207
              ],
              [
                50.0053674,
                35.2508003
              ],
              [
                50.0162008,
                35.253019
              ],
              [
                50.0200909,
                35.253019
              ],
              [
                50.0212006,
                35.2532986
              ],
              [
                50.0214772,
                35.253019
              ],
              [
                50.0281437,
                35.2521802
              ],
              [
                50.0289774,
                35.2516301
              ],
              [
                50.0323137,
                35.2488523
              ],
              [
                50.0339806,
                35.2446855
              ],
              [
                50.0342571,
                35.2424668
              ],
              [
                50.0345337,
                35.2413485
              ],
              [
                50.0348138,
                35.2407983
              ],
              [
                50.0353673,
                35.2380205
              ],
              [
                50.035647,
                35.2374613
              ],
              [
                50.0491709,
                35.226809
              ],
              [
                50.0504903,
                35.2156012
              ],
              [
                50.0645518,
                35.2076676
              ],
              [
                50.0691914,
                35.2051613
              ],
              [
                50.0757318,
                35.2018779
              ],
              [
                50.0811957,
                35.1989489
              ],
              [
                50.0904048,
                35.196965
              ],
              [
                50.0959965,
                35.2002423
              ],
              [
                50.1026502,
                35.2043792
              ],
              [
                50.1142531,
                35.2107961
              ],
              [
                50.1200466,
                35.2135623
              ],
              [
                50.1431392,
                35.2276825
              ],
              [
                50.1492804,
                35.2303687
              ],
              [
                50.1659153,
                35.2394007
              ],
              [
                50.1784987,
                35.2398202
              ],
              [
                50.1887816,
                35.239773
              ],
              [
                50.1963504,
                35.2368762
              ],
              [
                50.2112192,
                35.2332419
              ],
              [
                50.2305784,
                35.2284951
              ],
              [
                50.2357831,
                35.2256487
              ],
              [
                50.2380014,
                35.2200363
              ],
              [
                50.2356306,
                35.2160356
              ],
              [
                50.2395534,
                35.2091678
              ],
              [
                50.242994,
                35.2038333
              ],
              [
                50.2440903,
                35.201525
              ],
              [
                50.2665753,
                35.2089588
              ],
              [
                50.2818795,
                35.2090191
              ],
              [
                50.2897762,
                35.2047095
              ],
              [
                50.2921223,
                35.1977573
              ],
              [
                50.2941992,
                35.1871191
              ],
              [
                50.3141998,
                35.1774833
              ],
              [
                50.3220069,
                35.1756948
              ],
              [
                50.3302376,
                35.1765486
              ],
              [
                50.345383,
                35.1840156
              ],
              [
                50.3565951,
                35.1917857
              ],
              [
                50.3707357,
                35.1940895
              ],
              [
                50.386559,
                35.1934472
              ],
              [
                50.4008477,
                35.1877484
              ],
              [
                50.4049974,
                35.1862719
              ],
              [
                50.412243,
                35.1835395
              ],
              [
                50.4236791,
                35.1799605
              ],
              [
                50.4308295,
                35.1765998
              ],
              [
                50.4434004,
                35.1692895
              ],
              [
                50.4499219,
                35.1659058
              ],
              [
                50.4523654,
                35.1644631
              ],
              [
                50.4665731,
                35.1603331
              ],
              [
                50.4932763,
                35.1582182
              ],
              [
                50.4992548,
                35.152735
              ],
              [
                50.5219505,
                35.1523347
              ],
              [
                50.5241489,
                35.148442
              ],
              [
                50.5313158,
                35.1458453
              ],
              [
                50.5392946,
                35.1447918
              ],
              [
                50.5553847,
                35.1456056
              ],
              [
                50.560391,
                35.167184
              ],
              [
                50.5609476,
                35.1674636
              ],
              [
                50.5662279,
                35.1674636
              ],
              [
                50.5698378,
                35.1677342
              ],
              [
                50.5720612,
                35.1677342
              ],
              [
                50.5917842,
                35.1674636
              ],
              [
                50.6206739,
                35.1696825
              ],
              [
                50.6295635,
                35.1688527
              ],
              [
                50.62984,
                35.1685731
              ],
              [
                50.6317835,
                35.1685731
              ],
              [
                50.6384536,
                35.1669045
              ],
              [
                50.64734,
                35.1616281
              ],
              [
                50.6478967,
                35.161628
              ],
              [
                50.6484533,
                35.1610689
              ],
              [
                50.6506733,
                35.1591296
              ],
              [
                50.6517866,
                35.1585704
              ],
              [
                50.6528968,
                35.1571814
              ],
              [
                50.6531734,
                35.1563516
              ],
              [
                50.6540066,
                35.1555218
              ],
              [
                50.655673,
                35.1513547
              ],
              [
                50.66012,
                35.1463488
              ],
              [
                50.6609532,
                35.1460692
              ],
              [
                50.6612298,
                35.1455191
              ],
              [
                50.6648432,
                35.1441301
              ],
              [
                50.6662299,
                35.14413
              ],
              [
                50.6670631,
                35.1438504
              ],
              [
                50.6728965,
                35.1438504
              ],
              [
                50.6828999,
                35.1457896
              ],
              [
                50.6831764,
                35.1460692
              ],
              [
                50.6856764,
                35.1460692
              ],
              [
                50.6895664,
                35.1449689
              ],
              [
                50.6926196,
                35.1419022
              ],
              [
                50.6928996,
                35.1410723
              ],
              [
                50.6928997,
                35.1346863
              ],
              [
                50.6931762,
                35.1341271
              ],
              [
                50.6928997,
                35.1338476
              ],
              [
                50.6931763,
                35.1330177
              ],
              [
                50.6934564,
                35.1274615
              ],
              [
                50.6937329,
                35.124963
              ],
              [
                50.6940095,
                35.1224555
              ],
              [
                50.6942896,
                35.1202456
              ],
              [
                50.6956763,
                35.1138505
              ],
              [
                50.6984561,
                35.1080146
              ],
              [
                50.704843,
                35.1021787
              ],
              [
                50.7176227,
                35.0991299
              ],
              [
                50.7203993,
                35.0985707
              ],
              [
                50.7267891,
                35.0977409
              ],
              [
                50.7273459,
                35.0974613
              ],
              [
                50.7281791,
                35.0974613
              ],
              [
                50.7287325,
                35.0971817
              ],
              [
                50.7295657,
                35.0971817
              ],
              [
                50.7331791,
                35.0944035
              ],
              [
                50.7348457,
                35.0944035
              ],
              [
                50.7476222,
                35.0971817
              ],
              [
                50.748179,
                35.0974614
              ],
              [
                50.7512355,
                35.0974613
              ],
              [
                50.7517924,
                35.097741
              ],
              [
                50.7562354,
                35.0977409
              ],
              [
                50.7570688,
                35.0969112
              ],
              [
                50.7584589,
                35.0971817
              ],
              [
                50.7673454,
                35.1057958
              ],
              [
                50.7704018,
                35.1107929
              ],
              [
                50.7706819,
                35.1116317
              ],
              [
                50.7720685,
                35.1141302
              ],
              [
                50.8065149,
                35.1524643
              ],
              [
                50.8159613,
                35.1574612
              ],
              [
                50.8165147,
                35.1580205
              ],
              [
                50.8195714,
                35.1591299
              ],
              [
                50.8204046,
                35.1596891
              ],
              [
                50.8231812,
                35.1607984
              ],
              [
                50.8317945,
                35.1638471
              ],
              [
                50.8326277,
                35.1644063
              ],
              [
                50.8334612,
                35.1644063
              ],
              [
                50.8470742,
                35.1708012
              ],
              [
                50.8431728,
                35.2145523
              ],
              [
                50.8450219,
                35.2226081
              ],
              [
                50.8466885,
                35.2245462
              ],
              [
                50.8488812,
                35.2360305
              ],
              [
                50.8555604,
                35.2527998
              ],
              [
                50.8666959,
                35.2677876
              ],
              [
                50.8675294,
                35.2694552
              ],
              [
                50.8683626,
                35.2702844
              ],
              [
                50.8740358,
                35.2748425
              ],
              [
                50.8743124,
                35.2759602
              ],
              [
                50.8745891,
                35.2762396
              ],
              [
                50.8765358,
                35.2812332
              ],
              [
                50.8844623,
                35.289215
              ],
              [
                50.8933937,
                35.2998653
              ],
              [
                50.9048304,
                35.3211906
              ],
              [
                50.9067737,
                35.3247975
              ],
              [
                50.9473561,
                35.3794128
              ],
              [
                50.9484661,
                35.3819107
              ],
              [
                50.9583663,
                35.3861111
              ],
              [
                50.9653824,
                35.394178
              ],
              [
                50.9651057,
                35.3944576
              ],
              [
                50.9645489,
                35.3955667
              ],
              [
                50.9645489,
                35.3958463
              ],
              [
                50.9648257,
                35.3958463
              ],
              [
                50.9615226,
                35.417188
              ],
              [
                50.9622033,
                35.436015
              ],
              [
                50.9670258,
                35.4392095
              ],
              [
                50.9667254,
                35.4395242
              ],
              [
                50.9665109,
                35.4399787
              ],
              [
                50.966307,
                35.4407129
              ],
              [
                50.9660495,
                35.4413773
              ],
              [
                50.96591,
                35.4418755
              ],
              [
                50.9654058,
                35.442531
              ],
              [
                50.9650196,
                35.4432565
              ],
              [
                50.9643651,
                35.443781
              ],
              [
                50.9634403,
                35.4448193
              ],
              [
                50.9632864,
                35.4457835
              ],
              [
                50.9634924,
                35.4464128
              ],
              [
                50.9633121,
                35.4467904
              ],
              [
                50.9621534,
                35.4476504
              ],
              [
                50.9611749,
                35.4487202
              ],
              [
                50.960763,
                35.4488461
              ],
              [
                50.9592438,
                35.4489509
              ],
              [
                50.9582395,
                35.4493705
              ],
              [
                50.9578533,
                35.4501675
              ],
              [
                50.9574671,
                35.4509017
              ],
              [
                50.9567461,
                35.4516988
              ],
              [
                50.9552526,
                35.4522231
              ],
              [
                50.9542484,
                35.4525168
              ],
              [
                50.9531412,
                35.4528314
              ],
              [
                50.9527292,
                35.453188
              ],
              [
                50.9515705,
                35.4529363
              ],
              [
                50.950695,
                35.4527056
              ],
              [
                50.9496908,
                35.4527895
              ],
              [
                50.9493818,
                35.45323
              ],
              [
                50.9485063,
                35.4537124
              ],
              [
                50.9488411,
                35.4541738
              ],
              [
                50.9492788,
                35.4543626
              ],
              [
                50.9493046,
                35.4550548
              ],
              [
                50.9487381,
                35.4554533
              ],
              [
                50.9473734,
                35.4557259
              ],
              [
                50.9469356,
                35.4555791
              ],
              [
                50.9462147,
                35.455684
              ],
              [
                50.9458257,
                35.4557088
              ],
              [
                50.9418391,
                35.4569857
              ],
              [
                50.934107,
                35.4603151
              ],
              [
                50.9218277,
                35.4656001
              ],
              [
                50.915952,
                35.4684298
              ],
              [
                50.91212,
                35.4704133
              ],
              [
                50.9096846,
                35.4734231
              ],
              [
                50.9065339,
                35.4746713
              ],
              [
                50.9036046,
                35.4760444
              ],
              [
                50.899977,
                35.4799
              ],
              [
                50.8975415,
                35.4816335
              ],
              [
                50.8948336,
                35.4828955
              ],
              [
                50.8915269,
                35.4851248
              ],
              [
                50.8779066,
                35.4846914
              ],
              [
                50.8765168,
                35.4849709
              ],
              [
                50.8756834,
                35.484971
              ],
              [
                50.8751302,
                35.484971
              ],
              [
                50.8731835,
                35.4849709
              ],
              [
                50.8673502,
                35.4835823
              ],
              [
                50.8637403,
                35.4824732
              ],
              [
                50.8634635,
                35.4821936
              ],
              [
                50.8626303,
                35.4821936
              ],
              [
                50.8623502,
                35.4819141
              ],
              [
                50.8615168,
                35.4819141
              ],
              [
                50.8576269,
                35.480805
              ],
              [
                50.851517,
                35.480805
              ],
              [
                50.845127,
                35.4813551
              ],
              [
                50.8223473,
                35.4844118
              ],
              [
                50.8217941,
                35.4846913
              ],
              [
                50.8112375,
                35.4846913
              ],
              [
                50.8104042,
                35.4844117
              ],
              [
                50.8092942,
                35.4844118
              ],
              [
                50.8084608,
                35.4841413
              ],
              [
                50.8017909,
                35.4835822
              ],
              [
                50.8009575,
                35.4835822
              ],
              [
                50.8004044,
                35.4833027
              ],
              [
                50.799571,
                35.4835822
              ],
              [
                50.7987376,
                35.4833027
              ],
              [
                50.7904044,
                35.4833026
              ],
              [
                50.7895712,
                35.4835822
              ],
              [
                50.7876245,
                35.4835822
              ],
              [
                50.786791,
                35.4838617
              ],
              [
                50.7848478,
                35.4838617
              ],
              [
                50.7842912,
                35.4841413
              ],
              [
                50.7823478,
                35.4841413
              ],
              [
                50.7787346,
                35.4849708
              ],
              [
                50.7776246,
                35.4849708
              ],
              [
                50.775958,
                35.4855299
              ],
              [
                50.7745679,
                35.4855298
              ],
              [
                50.7726247,
                35.4860799
              ],
              [
                50.7715148,
                35.4860799
              ],
              [
                50.7712347,
                35.4863594
              ],
              [
                50.7684581,
                35.4869184
              ],
              [
                50.7676246,
                35.4869185
              ],
              [
                50.7560459,
                35.48778
              ],
              [
                50.7410345,
                35.4928463
              ],
              [
                50.7075471,
                35.5040966
              ],
              [
                50.6885559,
                35.5115726
              ],
              [
                50.6767683,
                35.5129611
              ],
              [
                50.6558252,
                35.5207698
              ],
              [
                50.6526361,
                35.5241491
              ],
              [
                50.6497631,
                35.5251971
              ],
              [
                50.6414739,
                35.5323054
              ],
              [
                50.6328629,
                35.540979
              ],
              [
                50.6270627,
                35.5469157
              ],
              [
                50.6259494,
                35.5474747
              ],
              [
                50.6181764,
                35.5524796
              ],
              [
                50.6063747,
                35.5532827
              ],
              [
                50.5969082,
                35.552784
              ],
              [
                50.5911172,
                35.5527142
              ],
              [
                50.5883665,
                35.5527493
              ],
              [
                50.5762269,
                35.5535788
              ],
              [
                50.5709466,
                35.5538583
              ],
              [
                50.5669582,
                35.5542342
              ],
              [
                50.5587537,
                35.5546785
              ],
              [
                50.5536786,
                35.5581875
              ],
              [
                50.5418645,
                35.5651006
              ],
              [
                50.531693,
                35.5706074
              ],
              [
                50.4929353,
                35.56849
              ],
              [
                50.456632,
                35.5601728
              ],
              [
                50.4523712,
                35.5590905
              ],
              [
                50.4417564,
                35.5585589
              ],
              [
                50.4228684,
                35.5582374
              ],
              [
                50.4157664,
                35.5589101
              ],
              [
                50.4055309,
                35.5598813
              ],
              [
                50.4027049,
                35.5606034
              ],
              [
                50.3884791,
                35.564339
              ],
              [
                50.3738139,
                35.5638952
              ],
              [
                50.3573286,
                35.5637571
              ],
              [
                50.3351497,
                35.5508736
              ],
              [
                50.3329055,
                35.5507027
              ],
              [
                50.3289699,
                35.5472422
              ],
              [
                50.3223609,
                35.5432615
              ],
              [
                50.2850243,
                35.5366967
              ],
              [
                50.2280472,
                35.5320984
              ],
              [
                50.2200507,
                35.5311786
              ],
              [
                50.2019068,
                35.5271473
              ],
              [
                50.1778749,
                35.5221916
              ],
              [
                50.1500954,
                35.5185848
              ],
              [
                50.1467621,
                35.5185849
              ],
              [
                50.1462053,
                35.5183053
              ],
              [
                50.1364821,
                35.5183054
              ],
              [
                50.1356486,
                35.5180258
              ],
              [
                50.1342622,
                35.5180258
              ],
              [
                50.1306489,
                35.5177463
              ],
              [
                50.1295386,
                35.5174668
              ],
              [
                50.127039,
                35.5174668
              ],
              [
                50.1264823,
                35.5171872
              ],
              [
                50.1017591,
                35.51386
              ],
              [
                50.068703,
                35.5077466
              ],
              [
                50.0550899,
                35.506358
              ],
              [
                50.0431466,
                35.5055284
              ],
              [
                50.0359234,
                35.5055284
              ],
              [
                50.0353668,
                35.505249
              ],
              [
                50.02981,
                35.5052488
              ],
              [
                50.0292568,
                35.5049694
              ],
              [
                50.0253666,
                35.5049694
              ],
              [
                50.0242567,
                35.5046898
              ],
              [
                50.0214765,
                35.5046898
              ],
              [
                50.0209235,
                35.5044103
              ],
              [
                50.0198102,
                35.5044103
              ],
              [
                50.0148101,
                35.5044102
              ],
              [
                50.0137003,
                35.5041398
              ],
              [
                50.0103671,
                35.5041398
              ],
              [
                50.0092537,
                35.5038602
              ],
              [
                50.0053669,
                35.5038602
              ],
              [
                50.0042535,
                35.5035807
              ],
              [
                49.9923104,
                35.5035807
              ],
              [
                49.990644,
                35.5038603
              ],
              [
                49.9881439,
                35.5038602
              ],
              [
                49.9839774,
                35.5044103
              ],
              [
                49.9817539,
                35.5044103
              ],
              [
                49.9723072,
                35.5060874
              ],
              [
                49.9253613,
                35.5191345
              ],
              [
                49.9211944,
                35.5208027
              ],
              [
                49.9192514,
                35.5221913
              ],
              [
                49.904528,
                35.5385834
              ],
              [
                49.9042514,
                35.539413
              ],
              [
                49.9039714,
                35.5396924
              ],
              [
                49.9034182,
                35.5399719
              ],
              [
                49.9023048,
                35.540522
              ],
              [
                49.8906383,
                35.5449761
              ],
              [
                49.8803583,
                35.5469146
              ],
              [
                49.8725816,
                35.5469147
              ],
              [
                49.8711917,
                35.5466352
              ],
              [
                49.8599052,
                35.5388295
              ],
              [
                49.8399051,
                35.5296681
              ],
              [
                49.8176168,
                35.5206887
              ],
              [
                49.8051985,
                35.5137983
              ],
              [
                49.8006299,
                35.5081479
              ],
              [
                49.7814488,
                35.512829
              ],
              [
                49.7814728,
                35.5213616
              ],
              [
                49.7781395,
                35.5221911
              ],
              [
                49.7684162,
                35.5230207
              ],
              [
                49.7645264,
                35.5230208
              ],
              [
                49.7636927,
                35.5233002
              ],
              [
                49.7625829,
                35.5233003
              ],
              [
                49.7617497,
                35.5235797
              ],
              [
                49.754803,
                35.5241388
              ],
              [
                49.7445263,
                35.5257978
              ],
              [
                49.7400797,
                35.5274658
              ],
              [
                49.7395265,
                35.5280249
              ],
              [
                49.7259133,
                35.5338587
              ],
              [
                49.7245266,
                35.5338587
              ],
              [
                49.72397,
                35.5341381
              ],
              [
                49.7236935,
                35.5338587
              ],
              [
                49.7173035,
                35.5338586
              ],
              [
                49.7170233,
                35.5335792
              ],
              [
                49.7156366,
                35.5335792
              ],
              [
                49.7153568,
                35.5332996
              ],
              [
                49.7128569,
                35.5332996
              ],
              [
                49.7114702,
                35.5332996
              ],
              [
                49.71119,
                35.5335791
              ],
              [
                49.7106369,
                35.5335791
              ],
              [
                49.7100802,
                35.5332996
              ],
              [
                49.7095236,
                35.5330201
              ],
              [
                49.7081368,
                35.5330201
              ],
              [
                49.7073037,
                35.5332996
              ],
              [
                49.7048036,
                35.5332996
              ],
              [
                49.7042469,
                35.5335792
              ],
              [
                49.6992469,
                35.5335791
              ],
              [
                49.6989671,
                35.5332996
              ],
              [
                49.6978569,
                35.5332996
              ],
              [
                49.6975804,
                35.5330201
              ],
              [
                49.6956335,
                35.5327496
              ],
              [
                49.6945237,
                35.5321906
              ],
              [
                49.6934138,
                35.5321906
              ],
              [
                49.6911904,
                35.5316315
              ],
              [
                49.6856336,
                35.5288544
              ],
              [
                49.6820238,
                35.5230206
              ],
              [
                49.6814672,
                35.5177457
              ],
              [
                49.6842438,
                35.5116324
              ],
              [
                49.6842438,
                35.5113529
              ],
              [
                49.6856337,
                35.5094053
              ],
              [
                49.6895237,
                35.5035802
              ],
              [
                49.6925741,
                35.4838602
              ],
              [
                49.6936838,
                35.4810829
              ],
              [
                49.6942408,
                35.4774671
              ],
              [
                49.6931307,
                35.471083
              ],
              [
                49.692574,
                35.4702444
              ],
              [
                49.6922941,
                35.4696943
              ],
              [
                49.6839606,
                35.4608034
              ],
              [
                49.6842407,
                35.4596943
              ],
              [
                49.6847943,
                35.4577466
              ],
              [
                49.6856275,
                35.4519124
              ],
              [
                49.6847943,
                35.4496941
              ],
              [
                49.6842407,
                35.449135
              ],
              [
                49.6842407,
                35.4488555
              ],
              [
                49.6822942,
                35.4471963
              ],
              [
                49.681461,
                35.4471964
              ],
              [
                49.6811845,
                35.4469079
              ],
              [
                49.6789609,
                35.4466373
              ],
              [
                49.678961,
                35.4463577
              ],
              [
                49.6770176,
                35.4463577
              ],
              [
                49.6764609,
                35.4460782
              ],
              [
                49.6756277,
                35.4460782
              ],
              [
                49.6750745,
                35.4457986
              ],
              [
                49.6717378,
                35.4452396
              ],
              [
                49.6684045,
                35.4452395
              ],
              [
                49.6542377,
                35.449135
              ],
              [
                49.6478478,
                35.4510828
              ],
              [
                49.6445145,
                35.4510828
              ],
              [
                49.6439614,
                35.4508032
              ],
              [
                49.6414613,
                35.4508032
              ],
              [
                49.6403479,
                35.4505237
              ],
              [
                49.6375714,
                35.4505236
              ],
              [
                49.6364617,
                35.4502442
              ],
              [
                49.6336814,
                35.4502442
              ],
              [
                49.6303481,
                35.4499645
              ],
              [
                49.6300716,
                35.449694
              ],
              [
                49.6284048,
                35.4496941
              ],
              [
                49.6228485,
                35.4488555
              ],
              [
                49.6222914,
                35.4485759
              ],
              [
                49.6161815,
                35.4460781
              ],
              [
                49.6075685,
                35.4335799
              ],
              [
                49.5995152,
                35.4280252
              ],
              [
                49.5986819,
                35.4280252
              ],
              [
                49.5959018,
                35.426907
              ],
              [
                49.5925685,
                35.4257979
              ],
              [
                49.5859021,
                35.4235796
              ],
              [
                49.5797921,
                35.4194135
              ],
              [
                49.5778456,
                35.4171861
              ],
              [
                49.5720123,
                35.4102425
              ],
              [
                49.5686791,
                35.4083037
              ],
              [
                49.5678458,
                35.4083038
              ],
              [
                49.5675688,
                35.4080242
              ],
              [
                49.5592324,
                35.4052468
              ],
              [
                49.5581226,
                35.4052467
              ],
              [
                49.5508994,
                35.4035785
              ],
              [
                49.5427042,
                35.4027091
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555066,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ساوه",
          "name:ar": "مقاطعة ساوة",
          "name:azb": "ساوه بؤلگه‌سی",
          "name:de": "Schahrestan Saveh",
          "name:en": "Saveh County",
          "name:es": "Condado de Saveh",
          "name:ur": "شہرستان ساوہ",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277821",
          "wikipedia": "fa:شهرستان ساوه"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.3831299,
                35.238578
              ],
              [
                49.3831298,
                35.2382884
              ],
              [
                49.4378413,
                35.2049645
              ],
              [
                49.4381178,
                35.2021866
              ],
              [
                49.4383944,
                35.1999588
              ],
              [
                49.4386744,
                35.1985699
              ],
              [
                49.4414511,
                35.1927434
              ],
              [
                49.4439512,
                35.190236
              ],
              [
                49.4464508,
                35.1894063
              ],
              [
                49.4481177,
                35.1894062
              ],
              [
                49.4489509,
                35.1891267
              ],
              [
                49.4508978,
                35.1891266
              ],
              [
                49.4511744,
                35.188847
              ],
              [
                49.453951,
                35.1888471
              ],
              [
                49.4542311,
                35.1885674
              ],
              [
                49.4567307,
                35.1882968
              ],
              [
                49.4570077,
                35.1880172
              ],
              [
                49.4661739,
                35.1791241
              ],
              [
                49.4678407,
                35.1707992
              ],
              [
                49.4681209,
                35.17024
              ],
              [
                49.4678408,
                35.1694102
              ],
              [
                49.4658974,
                35.1616263
              ],
              [
                49.4645076,
                35.1494048
              ],
              [
                49.4633974,
                35.1455173
              ],
              [
                49.4631177,
                35.1427392
              ],
              [
                49.4628408,
                35.1382925
              ],
              [
                49.4539512,
                35.1196756
              ],
              [
                49.4536746,
                35.1185752
              ],
              [
                49.450341,
                35.1069034
              ],
              [
                49.4472846,
                35.091903
              ],
              [
                49.4453414,
                35.0871766
              ],
              [
                49.4411749,
                35.0794012
              ],
              [
                49.4206182,
                35.0541264
              ],
              [
                49.4175616,
                35.0449527
              ],
              [
                49.4172849,
                35.0435725
              ],
              [
                49.4170049,
                35.0399554
              ],
              [
                49.4161717,
                35.0380069
              ],
              [
                49.4150619,
                35.0366268
              ],
              [
                49.4111719,
                35.0341191
              ],
              [
                49.4095051,
                35.0341191
              ],
              [
                49.4089485,
                35.0343987
              ],
              [
                49.4078384,
                35.0343988
              ],
              [
                49.4075618,
                35.0346784
              ],
              [
                49.4070051,
                35.0346783
              ],
              [
                49.4042285,
                35.0366268
              ],
              [
                49.3906153,
                35.0474603
              ],
              [
                49.3864488,
                35.0485698
              ],
              [
                49.3842253,
                35.0485698
              ],
              [
                49.3836721,
                35.0488494
              ],
              [
                49.3795056,
                35.0488494
              ],
              [
                49.3720055,
                35.0527371
              ],
              [
                49.3681155,
                35.0532874
              ],
              [
                49.3650589,
                35.0532875
              ],
              [
                49.3642256,
                35.053567
              ],
              [
                49.3628357,
                35.0535671
              ],
              [
                49.3556157,
                35.0574637
              ],
              [
                49.3553356,
                35.0582936
              ],
              [
                49.3545024,
                35.0594032
              ],
              [
                49.3547824,
                35.0610719
              ],
              [
                49.3564493,
                35.0638502
              ],
              [
                49.3567258,
                35.0685678
              ],
              [
                49.3564492,
                35.069127
              ],
              [
                49.3553355,
                35.0705161
              ],
              [
                49.355059,
                35.0716256
              ],
              [
                49.3525589,
                35.0741242
              ],
              [
                49.3520023,
                35.0741242
              ],
              [
                49.3517258,
                35.0744038
              ],
              [
                49.3489456,
                35.0744038
              ],
              [
                49.3428357,
                35.0719052
              ],
              [
                49.3420025,
                35.0719053
              ],
              [
                49.341726,
                35.0716256
              ],
              [
                49.3406126,
                35.0716256
              ],
              [
                49.3383927,
                35.0724554
              ],
              [
                49.337836,
                35.0730147
              ],
              [
                49.3367258,
                35.0755133
              ],
              [
                49.3356125,
                35.0774617
              ],
              [
                49.3328359,
                35.0777323
              ],
              [
                49.3297791,
                35.0777323
              ],
              [
                49.3295026,
                35.0780119
              ],
              [
                49.328946,
                35.0780119
              ],
              [
                49.3283893,
                35.0802399
              ],
              [
                49.3281126,
                35.0805105
              ],
              [
                49.3281127,
                35.0810697
              ],
              [
                49.325056,
                35.0830181
              ],
              [
                49.3242227,
                35.083018
              ],
              [
                49.3239462,
                35.0832977
              ],
              [
                49.3064462,
                35.0849574
              ],
              [
                49.3042232,
                35.0843981
              ],
              [
                49.2939432,
                35.078571
              ],
              [
                49.290333,
                35.0760725
              ],
              [
                49.2900564,
                35.0757928
              ],
              [
                49.2608868,
                35.0516185
              ],
              [
                49.259777,
                35.0421831
              ],
              [
                49.2639435,
                35.0318998
              ],
              [
                49.2656104,
                35.0294011
              ],
              [
                49.2758868,
                35.0121808
              ],
              [
                49.2828334,
                35.0077337
              ],
              [
                49.2842234,
                35.0077337
              ],
              [
                49.2889433,
                35.0060648
              ],
              [
                49.2925566,
                35.0060649
              ],
              [
                49.29339,
                35.0063445
              ],
              [
                49.2972798,
                35.0077336
              ],
              [
                49.3058898,
                35.0116216
              ],
              [
                49.3067231,
                35.0116216
              ],
              [
                49.3125563,
                35.0127402
              ],
              [
                49.322003,
                35.0138407
              ],
              [
                49.3411694,
                35.0135701
              ],
              [
                49.3422792,
                35.0138407
              ],
              [
                49.3483926,
                35.0132905
              ],
              [
                49.3556158,
                35.0119013
              ],
              [
                49.3578357,
                35.0110714
              ],
              [
                49.3636691,
                35.0110715
              ],
              [
                49.3647824,
                35.0113511
              ],
              [
                49.3683922,
                35.0116217
              ],
              [
                49.3703356,
                35.012181
              ],
              [
                49.3764491,
                35.0138408
              ],
              [
                49.378392,
                35.0138408
              ],
              [
                49.3792256,
                35.0141205
              ],
              [
                49.3800589,
                35.0138408
              ],
              [
                49.3908955,
                35.0135702
              ],
              [
                49.391172,
                35.0132906
              ],
              [
                49.3931155,
                35.0132906
              ],
              [
                49.3947822,
                35.0127403
              ],
              [
                49.3958955,
                35.0127403
              ],
              [
                49.3986721,
                35.0119014
              ],
              [
                49.4017285,
                35.0105123
              ],
              [
                49.4025621,
                35.0105122
              ],
              [
                49.4028386,
                35.0102326
              ],
              [
                49.4036719,
                35.0102326
              ],
              [
                49.4039484,
                35.009953
              ],
              [
                49.4050621,
                35.0096824
              ],
              [
                49.4058954,
                35.0088434
              ],
              [
                49.4142284,
                35.0016269
              ],
              [
                49.4142284,
                35.0010676
              ],
              [
                49.4128386,
                34.9982892
              ],
              [
                49.4075619,
                34.9835673
              ],
              [
                49.4050622,
                34.9777308
              ],
              [
                49.4047821,
                34.9757913
              ],
              [
                49.4070053,
                34.9649572
              ],
              [
                49.4072818,
                34.962738
              ],
              [
                49.407562,
                34.9607894
              ],
              [
                49.4078385,
                34.9605098
              ],
              [
                49.4078385,
                34.9582906
              ],
              [
                49.4089486,
                34.9591205
              ],
              [
                49.4125621,
                34.9599595
              ],
              [
                49.4136718,
                34.9605098
              ],
              [
                49.4145054,
                34.9605098
              ],
              [
                49.4147851,
                34.9607894
              ],
              [
                49.4158953,
                34.9607895
              ],
              [
                49.4183954,
                34.9616194
              ],
              [
                49.4186719,
                34.9613398
              ],
              [
                49.418952,
                34.9616194
              ],
              [
                49.4197853,
                34.9616193
              ],
              [
                49.4203384,
                34.9618991
              ],
              [
                49.4233951,
                34.9618991
              ],
              [
                49.4256185,
                34.9571721
              ],
              [
                49.4258952,
                34.9566218
              ],
              [
                49.4258952,
                34.9516241
              ],
              [
                49.4278385,
                34.9480067
              ],
              [
                49.4306183,
                34.9466264
              ],
              [
                49.4314519,
                34.9466264
              ],
              [
                49.4317284,
                34.9463467
              ],
              [
                49.4325617,
                34.9463468
              ],
              [
                49.4331184,
                34.9460672
              ],
              [
                49.4345087,
                34.9460672
              ],
              [
                49.4353418,
                34.9457875
              ],
              [
                49.4389517,
                34.9457875
              ],
              [
                49.4406186,
                34.9457875
              ],
              [
                49.4420084,
                34.9457875
              ],
              [
                49.4425615,
                34.9460671
              ],
              [
                49.4442284,
                34.9460671
              ],
              [
                49.4445085,
                34.9463468
              ],
              [
                49.4456183,
                34.9463468
              ],
              [
                49.4461749,
                34.9466264
              ],
              [
                49.4545083,
                34.9474564
              ],
              [
                49.4586748,
                34.9474564
              ],
              [
                49.4592313,
                34.9477361
              ],
              [
                49.4645081,
                34.9482863
              ],
              [
                49.4675647,
                34.9482864
              ],
              [
                49.4689547,
                34.9480067
              ],
              [
                49.4731212,
                34.9457875
              ],
              [
                49.4789545,
                34.937452
              ],
              [
                49.4800646,
                34.9360717
              ],
              [
                49.4806213,
                34.9352329
              ],
              [
                49.4883976,
                34.9277363
              ],
              [
                49.4889544,
                34.9266176
              ],
              [
                49.489788,
                34.9257876
              ],
              [
                49.4961779,
                34.9149531
              ],
              [
                49.4997878,
                34.9130045
              ],
              [
                49.5000777,
                34.9123476
              ],
              [
                49.5012317,
                34.9097091
              ],
              [
                49.5031211,
                34.9099553
              ],
              [
                49.5039543,
                34.9099553
              ],
              [
                49.5070109,
                34.9119039
              ],
              [
                49.5178441,
                34.9146826
              ],
              [
                49.526734,
                34.9157831
              ],
              [
                49.5292341,
                34.9163424
              ],
              [
                49.5306239,
                34.9163425
              ],
              [
                49.5311771,
                34.9166221
              ],
              [
                49.5322909,
                34.9166221
              ],
              [
                49.533124,
                34.9169017
              ],
              [
                49.5339572,
                34.9169017
              ],
              [
                49.5359006,
                34.9177317
              ],
              [
                49.5367339,
                34.9177317
              ],
              [
                49.537844,
                34.918291
              ],
              [
                49.5386772,
                34.9182911
              ],
              [
                49.5459005,
                34.9218996
              ],
              [
                49.5716642,
                34.9532152
              ],
              [
                49.5717704,
                34.9533443
              ],
              [
                49.5742369,
                34.9563423
              ],
              [
                49.5750702,
                34.9569017
              ],
              [
                49.5753467,
                34.9571723
              ],
              [
                49.5764565,
                34.9610694
              ],
              [
                49.5761799,
                34.96134
              ],
              [
                49.5759033,
                34.9627383
              ],
              [
                49.5756232,
                34.9652371
              ],
              [
                49.5750701,
                34.9685658
              ],
              [
                49.57479,
                34.9696844
              ],
              [
                49.5739568,
                34.9721831
              ],
              [
                49.5736798,
                34.9730131
              ],
              [
                49.5731231,
                34.9749526
              ],
              [
                49.5728465,
                34.9763509
              ],
              [
                49.57257,
                34.9802389
              ],
              [
                49.5722899,
                34.981619
              ],
              [
                49.5720134,
                34.9830173
              ],
              [
                49.5717368,
                34.9843974
              ],
              [
                49.5717368,
                34.9846771
              ],
              [
                49.5720133,
                34.986346
              ],
              [
                49.5742369,
                34.9896746
              ],
              [
                49.58118,
                34.9913435
              ],
              [
                49.5820131,
                34.9916232
              ],
              [
                49.583403,
                34.9916231
              ],
              [
                49.58368,
                34.9919028
              ],
              [
                49.5928462,
                34.9921735
              ],
              [
                49.5934032,
                34.9924531
              ],
              [
                49.5942364,
                34.9924531
              ],
              [
                49.6014596,
                34.9966206
              ],
              [
                49.6050764,
                34.9963696
              ],
              [
                49.6212138,
                34.9986689
              ],
              [
                49.6253491,
                35.0119018
              ],
              [
                49.6275726,
                35.0171789
              ],
              [
                49.6281258,
                35.0232858
              ],
              [
                49.6278492,
                35.0235655
              ],
              [
                49.6275726,
                35.0249546
              ],
              [
                49.627016,
                35.0263437
              ],
              [
                49.6270159,
                35.0271736
              ],
              [
                49.6228494,
                35.0357882
              ],
              [
                49.6225725,
                35.0371774
              ],
              [
                49.6228494,
                35.0416245
              ],
              [
                49.6281257,
                35.0457919
              ],
              [
                49.6292389,
                35.0457919
              ],
              [
                49.629516,
                35.0460716
              ],
              [
                49.6306257,
                35.0457919
              ],
              [
                49.6322925,
                35.0457919
              ],
              [
                49.6328493,
                35.0455123
              ],
              [
                49.6389622,
                35.0455123
              ],
              [
                49.6397958,
                35.0452327
              ],
              [
                49.6411822,
                35.0452326
              ],
              [
                49.6414623,
                35.0455123
              ],
              [
                49.6428491,
                35.0455123
              ],
              [
                49.6478487,
                35.0474607
              ],
              [
                49.6481288,
                35.0477404
              ],
              [
                49.6486824,
                35.0477403
              ],
              [
                49.6500723,
                35.0485702
              ],
              [
                49.6547954,
                35.0521783
              ],
              [
                49.6550724,
                35.0527377
              ],
              [
                49.6628522,
                35.0569051
              ],
              [
                49.6642386,
                35.056905
              ],
              [
                49.6650721,
                35.0571847
              ],
              [
                49.670352,
                35.0571847
              ],
              [
                49.6711851,
                35.056905
              ],
              [
                49.6722954,
                35.0569051
              ],
              [
                49.672852,
                35.0566255
              ],
              [
                49.6736852,
                35.0566254
              ],
              [
                49.6764618,
                35.0552364
              ],
              [
                49.676742,
                35.0546771
              ],
              [
                49.6775752,
                35.0544064
              ],
              [
                49.6795186,
                35.0524581
              ],
              [
                49.6803518,
                35.0521784
              ],
              [
                49.6806284,
                35.0516192
              ],
              [
                49.6825752,
                35.0507983
              ],
              [
                49.6828518,
                35.05023
              ],
              [
                49.6842417,
                35.0496798
              ],
              [
                49.6847952,
                35.0491295
              ],
              [
                49.6878519,
                35.0482906
              ],
              [
                49.6884086,
                35.0482907
              ],
              [
                49.6886851,
                35.048011
              ],
              [
                49.6917418,
                35.0480111
              ],
              [
                49.6920184,
                35.0482907
              ],
              [
                49.6928516,
                35.0482907
              ],
              [
                49.6934083,
                35.0485703
              ],
              [
                49.6947986,
                35.0485703
              ],
              [
                49.6950751,
                35.04885
              ],
              [
                49.6972982,
                35.0488499
              ],
              [
                49.6984084,
                35.0491296
              ],
              [
                49.7017417,
                35.0499595
              ],
              [
                49.7109082,
                35.0502301
              ],
              [
                49.7159079,
                35.0488499
              ],
              [
                49.7414643,
                35.0446826
              ],
              [
                49.7467446,
                35.0457921
              ],
              [
                49.7528544,
                35.0496799
              ],
              [
                49.7564678,
                35.0510691
              ],
              [
                49.757021,
                35.0513487
              ],
              [
                49.7586873,
                35.0513487
              ],
              [
                49.7592445,
                35.051069
              ],
              [
                49.7600777,
                35.0510691
              ],
              [
                49.7625777,
                35.0496799
              ],
              [
                49.7634109,
                35.0491297
              ],
              [
                49.763411,
                35.04885
              ],
              [
                49.7636875,
                35.0485704
              ],
              [
                49.7642442,
                35.0457921
              ],
              [
                49.7645207,
                35.042184
              ],
              [
                49.7681341,
                35.0380075
              ],
              [
                49.7686908,
                35.0380075
              ],
              [
                49.7692443,
                35.0374573
              ],
              [
                49.7698009,
                35.0374573
              ],
              [
                49.7703576,
                35.0371776
              ],
              [
                49.772024,
                35.036907
              ],
              [
                49.7723009,
                35.0366274
              ],
              [
                49.7739675,
                35.0366273
              ],
              [
                49.7745241,
                35.036907
              ],
              [
                49.7736909,
                35.0374573
              ],
              [
                49.7736908,
                35.0377369
              ],
              [
                49.7773007,
                35.036907
              ],
              [
                49.7773007,
                35.0366274
              ],
              [
                49.7781339,
                35.0366274
              ],
              [
                49.7792441,
                35.0360681
              ],
              [
                49.7792441,
                35.0357885
              ],
              [
                49.7800774,
                35.0357885
              ],
              [
                49.7828574,
                35.0343994
              ],
              [
                49.7839673,
                35.0324599
              ],
              [
                49.7850774,
                35.0285721
              ],
              [
                49.7848004,
                35.0255141
              ],
              [
                49.7834106,
                35.0193981
              ],
              [
                49.7836907,
                35.0191275
              ],
              [
                49.7839673,
                35.018009
              ],
              [
                49.784524,
                35.0163492
              ],
              [
                49.8014848,
                35.0099139
              ],
              [
                49.8305583,
                34.9997678
              ],
              [
                49.8361378,
                34.9991572
              ],
              [
                49.8403534,
                34.9949973
              ],
              [
                49.8489367,
                34.9878505
              ],
              [
                49.8576341,
                34.9796676
              ],
              [
                49.8676514,
                34.9718784
              ],
              [
                49.8995464,
                34.9560087
              ],
              [
                49.9091919,
                34.9524459
              ],
              [
                49.9199459,
                34.9481116
              ],
              [
                49.9295465,
                34.9445409
              ],
              [
                49.9505301,
                34.9332807
              ],
              [
                49.9627214,
                34.9306375
              ],
              [
                49.9807042,
                34.9266531
              ],
              [
                49.9890708,
                34.926075
              ],
              [
                50.0125745,
                34.9246661
              ],
              [
                50.0217606,
                34.9211099
              ],
              [
                50.0340681,
                34.9161741
              ],
              [
                50.0394837,
                34.9099616
              ],
              [
                50.0434845,
                34.9055262
              ],
              [
                50.0533172,
                34.897042
              ],
              [
                50.0602493,
                34.8909425
              ],
              [
                50.0622887,
                34.8886724
              ],
              [
                50.0636089,
                34.8874568
              ],
              [
                50.0756437,
                34.8756736
              ],
              [
                50.1044864,
                34.8656945
              ],
              [
                50.1225401,
                34.8620255
              ],
              [
                50.1272253,
                34.8622322
              ],
              [
                50.1554879,
                34.8506279
              ],
              [
                50.165355,
                34.8466905
              ],
              [
                50.1701204,
                34.8210637
              ],
              [
                50.1730065,
                34.8213116
              ],
              [
                50.174263,
                34.8213458
              ],
              [
                50.1823197,
                34.8193971
              ],
              [
                50.1828764,
                34.8193971
              ],
              [
                50.1853765,
                34.818567
              ],
              [
                50.2139891,
                34.8146786
              ],
              [
                50.2148227,
                34.814399
              ],
              [
                50.2178759,
                34.814399
              ],
              [
                50.2287125,
                34.8130095
              ],
              [
                50.2292657,
                34.8132802
              ],
              [
                50.2426022,
                34.8130096
              ],
              [
                50.2456555,
                34.8138396
              ],
              [
                50.2462121,
                34.8141193
              ],
              [
                50.2684341,
                34.8138197
              ],
              [
                50.2721849,
                34.8116225
              ],
              [
                50.275986,
                34.8097799
              ],
              [
                50.2788544,
                34.808439
              ],
              [
                50.2954101,
                34.7998847
              ],
              [
                50.3120483,
                34.7813422
              ],
              [
                50.3137147,
                34.7799527
              ],
              [
                50.3278814,
                34.7680074
              ],
              [
                50.3412177,
                34.7599505
              ],
              [
                50.3478846,
                34.7591204
              ],
              [
                50.3484378,
                34.7588407
              ],
              [
                50.3587176,
                34.7588407
              ],
              [
                50.3617743,
                34.7591204
              ],
              [
                50.366494,
                34.7591204
              ],
              [
                50.367051,
                34.7588407
              ],
              [
                50.3684409,
                34.7588407
              ],
              [
                50.368994,
                34.758561
              ],
              [
                50.3709409,
                34.7585611
              ],
              [
                50.3948305,
                34.7527326
              ],
              [
                50.4012205,
                34.7519026
              ],
              [
                50.4014971,
                34.7516229
              ],
              [
                50.4059405,
                34.7516229
              ],
              [
                50.4067737,
                34.7519026
              ],
              [
                50.4092738,
                34.7519027
              ],
              [
                50.4153868,
                34.7546724
              ],
              [
                50.4156638,
                34.7549522
              ],
              [
                50.4176103,
                34.7557822
              ],
              [
                50.4181635,
                34.7560619
              ],
              [
                50.4284433,
                34.7541222
              ],
              [
                50.4340001,
                34.7574514
              ],
              [
                50.4398334,
                34.7752343
              ],
              [
                50.4406666,
                34.7777334
              ],
              [
                50.4487234,
                34.8035638
              ],
              [
                50.4501097,
                34.8107905
              ],
              [
                50.451223,
                34.8180081
              ],
              [
                50.4506663,
                34.8205072
              ],
              [
                50.4509428,
                34.8243956
              ],
              [
                50.451223,
                34.8269037
              ],
              [
                50.4551111,
                34.8319907
              ],
              [
                50.458443,
                34.8363496
              ],
              [
                50.4642763,
                34.8413477
              ],
              [
                50.4681662,
                34.844397
              ],
              [
                50.4817794,
                34.8566215
              ],
              [
                50.4881694,
                34.8596708
              ],
              [
                50.4892791,
                34.8602302
              ],
              [
                50.4901123,
                34.8602302
              ],
              [
                50.4903893,
                34.8605099
              ],
              [
                50.4915026,
                34.8605099
              ],
              [
                50.4948359,
                34.8618993
              ],
              [
                50.501779,
                34.8638389
              ],
              [
                50.5087256,
                34.8652372
              ],
              [
                50.5165024,
                34.8657875
              ],
              [
                50.5178922,
                34.8655169
              ],
              [
                50.5184453,
                34.8652373
              ],
              [
                50.5201122,
                34.8652373
              ],
              [
                50.5206688,
                34.8649575
              ],
              [
                50.5226123,
                34.8649576
              ],
              [
                50.5303921,
                34.8621789
              ],
              [
                50.5362254,
                34.8596709
              ],
              [
                50.5420584,
                34.8574606
              ],
              [
                50.542892,
                34.8574606
              ],
              [
                50.5434486,
                34.8571809
              ],
              [
                50.5442818,
                34.8574607
              ],
              [
                50.5445584,
                34.8571809
              ],
              [
                50.5462252,
                34.8571809
              ],
              [
                50.5465054,
                34.8574606
              ],
              [
                50.5473386,
                34.8571809
              ],
              [
                50.5545583,
                34.8577312
              ],
              [
                50.5615049,
                34.8555119
              ],
              [
                50.5617814,
                34.8552322
              ],
              [
                50.5692816,
                34.8552323
              ],
              [
                50.5698382,
                34.8549526
              ],
              [
                50.5720618,
                34.8549526
              ],
              [
                50.5728949,
                34.8552322
              ],
              [
                50.5742814,
                34.8552323
              ],
              [
                50.5751149,
                34.855512
              ],
              [
                50.5765048,
                34.8555119
              ],
              [
                50.5801181,
                34.8569013
              ],
              [
                50.5809515,
                34.857181
              ],
              [
                50.5823381,
                34.8574607
              ],
              [
                50.5826182,
                34.8577313
              ],
              [
                50.5834513,
                34.8577313
              ],
              [
                50.583728,
                34.858011
              ],
              [
                50.5845612,
                34.858011
              ],
              [
                50.5848381,
                34.8582907
              ],
              [
                50.5859515,
                34.8582906
              ],
              [
                50.5923379,
                34.86051
              ],
              [
                50.5981712,
                34.8627294
              ],
              [
                50.5998412,
                34.863839
              ],
              [
                50.600951,
                34.8638389
              ],
              [
                50.6028944,
                34.864678
              ],
              [
                50.6212311,
                34.8677274
              ],
              [
                50.6498406,
                34.8702354
              ],
              [
                50.6506739,
                34.8699558
              ],
              [
                50.6523403,
                34.8699557
              ],
              [
                50.653454,
                34.8696761
              ],
              [
                50.6565102,
                34.8696761
              ],
              [
                50.659287,
                34.8694054
              ],
              [
                50.6601205,
                34.8691257
              ],
              [
                50.6615104,
                34.8691258
              ],
              [
                50.6620635,
                34.8688461
              ],
              [
                50.6642871,
                34.8688461
              ],
              [
                50.6651202,
                34.8685665
              ],
              [
                50.6715102,
                34.8685664
              ],
              [
                50.6720634,
                34.8682868
              ],
              [
                50.6756767,
                34.8682868
              ],
              [
                50.6762337,
                34.8685665
              ],
              [
                50.6895669,
                34.8685665
              ],
              [
                50.6995667,
                34.8680071
              ],
              [
                50.7028999,
                34.8680071
              ],
              [
                50.7034565,
                34.8682868
              ],
              [
                50.7040097,
                34.8682868
              ],
              [
                50.705123,
                34.8682868
              ],
              [
                50.7048433,
                34.8713451
              ],
              [
                50.7045664,
                34.8727344
              ],
              [
                50.7048433,
                34.8735644
              ],
              [
                50.7040097,
                34.8766227
              ],
              [
                50.7042898,
                34.8769024
              ],
              [
                50.7040097,
                34.8771821
              ],
              [
                50.7031765,
                34.8799607
              ],
              [
                50.7029,
                34.881341
              ],
              [
                50.7026234,
                34.88301
              ],
              [
                50.7023432,
                34.8857886
              ],
              [
                50.7023433,
                34.8882877
              ],
              [
                50.7023433,
                34.8896769
              ],
              [
                50.7020667,
                34.8899566
              ],
              [
                50.7020667,
                34.8907865
              ],
              [
                50.7020667,
                34.8938449
              ],
              [
                50.7017898,
                34.8941244
              ],
              [
                50.70151,
                34.8963437
              ],
              [
                50.701233,
                34.8980127
              ],
              [
                50.7009565,
                34.8999613
              ],
              [
                50.7006765,
                34.9016213
              ],
              [
                50.7001233,
                34.9041202
              ],
              [
                50.6998432,
                34.9052388
              ],
              [
                50.6984564,
                34.9110666
              ],
              [
                50.6981764,
                34.9130063
              ],
              [
                50.6962334,
                34.9238408
              ],
              [
                50.6945664,
                34.9299572
              ],
              [
                50.6945665,
                34.9310668
              ],
              [
                50.6942899,
                34.9316261
              ],
              [
                50.6942898,
                34.9318968
              ],
              [
                50.6942899,
                34.9324561
              ],
              [
                50.6934567,
                34.9357939
              ],
              [
                50.6934567,
                34.9485678
              ],
              [
                50.6923434,
                34.9518966
              ],
              [
                50.6851197,
                34.9652386
              ],
              [
                50.6845666,
                34.965789
              ],
              [
                50.6845665,
                34.9663482
              ],
              [
                50.6823435,
                34.9685675
              ],
              [
                50.6820665,
                34.9694063
              ],
              [
                50.6809532,
                34.9705159
              ],
              [
                50.6806767,
                34.9710662
              ],
              [
                50.6603969,
                34.9877367
              ],
              [
                50.65873,
                34.9885666
              ],
              [
                50.6534538,
                34.9944031
              ],
              [
                50.6498404,
                34.9996803
              ],
              [
                50.6506736,
                35.008286
              ],
              [
                50.6512302,
                35.0102344
              ],
              [
                50.6517869,
                35.0138427
              ],
              [
                50.6537302,
                35.0182898
              ],
              [
                50.654287,
                35.0193994
              ],
              [
                50.66512,
                35.0299625
              ],
              [
                50.6715099,
                35.0319019
              ],
              [
                50.6956764,
                35.0435744
              ],
              [
                50.6959565,
                35.0441247
              ],
              [
                50.6970663,
                35.044684
              ],
              [
                50.7003995,
                35.0477418
              ],
              [
                50.7195659,
                35.0705181
              ],
              [
                50.7512355,
                35.0930145
              ],
              [
                50.7537355,
                35.0946831
              ],
              [
                50.7540122,
                35.0952424
              ],
              [
                50.7567922,
                35.0966225
              ],
              [
                50.7570688,
                35.0969112
              ],
              [
                50.7562354,
                35.0977409
              ],
              [
                50.7517924,
                35.097741
              ],
              [
                50.7512355,
                35.0974613
              ],
              [
                50.748179,
                35.0974614
              ],
              [
                50.7476222,
                35.0971817
              ],
              [
                50.7348457,
                35.0944035
              ],
              [
                50.7331791,
                35.0944035
              ],
              [
                50.7295657,
                35.0971817
              ],
              [
                50.7287325,
                35.0971817
              ],
              [
                50.7281791,
                35.0974613
              ],
              [
                50.7273459,
                35.0974613
              ],
              [
                50.7267891,
                35.0977409
              ],
              [
                50.7203993,
                35.0985707
              ],
              [
                50.7176227,
                35.0991299
              ],
              [
                50.704843,
                35.1021787
              ],
              [
                50.6984561,
                35.1080146
              ],
              [
                50.6956763,
                35.1138505
              ],
              [
                50.6942896,
                35.1202456
              ],
              [
                50.6940095,
                35.1224555
              ],
              [
                50.6937329,
                35.124963
              ],
              [
                50.6934564,
                35.1274615
              ],
              [
                50.6931763,
                35.1330177
              ],
              [
                50.6928997,
                35.1338476
              ],
              [
                50.6931762,
                35.1341271
              ],
              [
                50.6928997,
                35.1346863
              ],
              [
                50.6928996,
                35.1410723
              ],
              [
                50.6926196,
                35.1419022
              ],
              [
                50.6895664,
                35.1449689
              ],
              [
                50.6856764,
                35.1460692
              ],
              [
                50.6831764,
                35.1460692
              ],
              [
                50.6828999,
                35.1457896
              ],
              [
                50.6728965,
                35.1438504
              ],
              [
                50.6670631,
                35.1438504
              ],
              [
                50.6662299,
                35.14413
              ],
              [
                50.6648432,
                35.1441301
              ],
              [
                50.6612298,
                35.1455191
              ],
              [
                50.6609532,
                35.1460692
              ],
              [
                50.66012,
                35.1463488
              ],
              [
                50.655673,
                35.1513547
              ],
              [
                50.6540066,
                35.1555218
              ],
              [
                50.6531734,
                35.1563516
              ],
              [
                50.6528968,
                35.1571814
              ],
              [
                50.6517866,
                35.1585704
              ],
              [
                50.6506733,
                35.1591296
              ],
              [
                50.6484533,
                35.1610689
              ],
              [
                50.6478967,
                35.161628
              ],
              [
                50.64734,
                35.1616281
              ],
              [
                50.6384536,
                35.1669045
              ],
              [
                50.6317835,
                35.1685731
              ],
              [
                50.62984,
                35.1685731
              ],
              [
                50.6295635,
                35.1688527
              ],
              [
                50.6206739,
                35.1696825
              ],
              [
                50.5917842,
                35.1674636
              ],
              [
                50.5720612,
                35.1677342
              ],
              [
                50.5698378,
                35.1677342
              ],
              [
                50.5662279,
                35.1674636
              ],
              [
                50.5609476,
                35.1674636
              ],
              [
                50.560391,
                35.167184
              ],
              [
                50.5553847,
                35.1456056
              ],
              [
                50.5392946,
                35.1447918
              ],
              [
                50.5313158,
                35.1458453
              ],
              [
                50.5241489,
                35.148442
              ],
              [
                50.5219505,
                35.1523347
              ],
              [
                50.4992548,
                35.152735
              ],
              [
                50.4932763,
                35.1582182
              ],
              [
                50.4665731,
                35.1603331
              ],
              [
                50.4523654,
                35.1644631
              ],
              [
                50.4499219,
                35.1659058
              ],
              [
                50.4434004,
                35.1692895
              ],
              [
                50.4308295,
                35.1765998
              ],
              [
                50.4236791,
                35.1799605
              ],
              [
                50.412243,
                35.1835395
              ],
              [
                50.4049974,
                35.1862719
              ],
              [
                50.4008477,
                35.1877484
              ],
              [
                50.386559,
                35.1934472
              ],
              [
                50.3707357,
                35.1940895
              ],
              [
                50.3565951,
                35.1917857
              ],
              [
                50.345383,
                35.1840156
              ],
              [
                50.3302376,
                35.1765486
              ],
              [
                50.3220069,
                35.1756948
              ],
              [
                50.3141998,
                35.1774833
              ],
              [
                50.2941992,
                35.1871191
              ],
              [
                50.2921223,
                35.1977573
              ],
              [
                50.2897762,
                35.2047095
              ],
              [
                50.2818795,
                35.2090191
              ],
              [
                50.2665753,
                35.2089588
              ],
              [
                50.2440903,
                35.201525
              ],
              [
                50.242994,
                35.2038333
              ],
              [
                50.2395534,
                35.2091678
              ],
              [
                50.2356306,
                35.2160356
              ],
              [
                50.2380014,
                35.2200363
              ],
              [
                50.2357831,
                35.2256487
              ],
              [
                50.2305784,
                35.2284951
              ],
              [
                50.2112192,
                35.2332419
              ],
              [
                50.1963504,
                35.2368762
              ],
              [
                50.1887816,
                35.239773
              ],
              [
                50.1784987,
                35.2398202
              ],
              [
                50.1659153,
                35.2394007
              ],
              [
                50.1492804,
                35.2303687
              ],
              [
                50.1431392,
                35.2276825
              ],
              [
                50.1200466,
                35.2135623
              ],
              [
                50.1142531,
                35.2107961
              ],
              [
                50.1026502,
                35.2043792
              ],
              [
                50.0959965,
                35.2002423
              ],
              [
                50.0904048,
                35.196965
              ],
              [
                50.0811957,
                35.1989489
              ],
              [
                50.0757318,
                35.2018779
              ],
              [
                50.0691914,
                35.2051613
              ],
              [
                50.0645518,
                35.2076676
              ],
              [
                50.0504903,
                35.2156012
              ],
              [
                50.0491709,
                35.226809
              ],
              [
                50.035647,
                35.2374613
              ],
              [
                50.0353673,
                35.2380205
              ],
              [
                50.0348138,
                35.2407983
              ],
              [
                50.0345337,
                35.2413485
              ],
              [
                50.0342571,
                35.2424668
              ],
              [
                50.0339806,
                35.2446855
              ],
              [
                50.0323137,
                35.2488523
              ],
              [
                50.0289774,
                35.2516301
              ],
              [
                50.0281437,
                35.2521802
              ],
              [
                50.0214772,
                35.253019
              ],
              [
                50.0212006,
                35.2532986
              ],
              [
                50.0200909,
                35.253019
              ],
              [
                50.0162008,
                35.253019
              ],
              [
                50.0053674,
                35.2508003
              ],
              [
                50.0050874,
                35.2505207
              ],
              [
                50.0025878,
                35.2505207
              ],
              [
                50.0023108,
                35.2502412
              ],
              [
                49.9939777,
                35.2502411
              ],
              [
                49.988421,
                35.2510709
              ],
              [
                49.9853644,
                35.25163
              ],
              [
                49.968698,
                35.254967
              ],
              [
                49.9678647,
                35.2549669
              ],
              [
                49.957588,
                35.2613523
              ],
              [
                49.9545316,
                35.2627412
              ],
              [
                49.9514749,
                35.2627411
              ],
              [
                49.9445314,
                35.2616318
              ],
              [
                49.9436982,
                35.2613523
              ],
              [
                49.9395317,
                35.2613523
              ],
              [
                49.9367516,
                35.2619024
              ],
              [
                49.9348082,
                35.2627411
              ],
              [
                49.9311952,
                35.2657986
              ],
              [
                49.9253618,
                35.2758003
              ],
              [
                49.9198945,
                35.2793033
              ],
              [
                49.9148053,
                35.2802374
              ],
              [
                49.9128619,
                35.2799669
              ],
              [
                49.9106384,
                35.2791282
              ],
              [
                49.8978621,
                35.2716335
              ],
              [
                49.8967487,
                35.271354
              ],
              [
                49.8939721,
                35.271354
              ],
              [
                49.8917487,
                35.271354
              ],
              [
                49.8848056,
                35.2713539
              ],
              [
                49.8823055,
                35.2710744
              ],
              [
                49.8809251,
                35.2707029
              ],
              [
                49.8798058,
                35.2702357
              ],
              [
                49.8734159,
                35.2669077
              ],
              [
                49.8548025,
                35.2613521
              ],
              [
                49.852026,
                35.2610725
              ],
              [
                49.8450828,
                35.2610726
              ],
              [
                49.8409129,
                35.2613521
              ],
              [
                49.837026,
                35.2616317
              ],
              [
                49.8228562,
                35.2616317
              ],
              [
                49.8203561,
                35.2616317
              ],
              [
                49.8173079,
                35.2621085
              ],
              [
                49.8153564,
                35.262741
              ],
              [
                49.8129582,
                35.2644424
              ],
              [
                49.8117466,
                35.2666281
              ],
              [
                49.8086898,
                35.2877408
              ],
              [
                49.8014666,
                35.2907981
              ],
              [
                49.7979471,
                35.2922755
              ],
              [
                49.772857,
                35.3052367
              ],
              [
                49.7686901,
                35.3055252
              ],
              [
                49.7636869,
                35.3057958
              ],
              [
                49.7617435,
                35.3060754
              ],
              [
                49.7589669,
                35.3069051
              ],
              [
                49.7482645,
                35.3135039
              ],
              [
                49.7284072,
                35.3266372
              ],
              [
                49.722854,
                35.3305241
              ],
              [
                49.7195207,
                35.3313537
              ],
              [
                49.7175742,
                35.3316334
              ],
              [
                49.7134077,
                35.3316333
              ],
              [
                49.7003512,
                35.3305241
              ],
              [
                49.6975745,
                35.3307946
              ],
              [
                49.6690921,
                35.3346636
              ],
              [
                49.6517385,
                35.3310741
              ],
              [
                49.6500715,
                35.3310741
              ],
              [
                49.6486817,
                35.3313537
              ],
              [
                49.647848,
                35.3316332
              ],
              [
                49.6331251,
                35.3405251
              ],
              [
                49.611182,
                35.3505263
              ],
              [
                49.6053487,
                35.3530243
              ],
              [
                49.579556,
                35.3694386
              ],
              [
                49.56155,
                35.3877347
              ],
              [
                49.5427042,
                35.4027091
              ],
              [
                49.537807,
                35.3910238
              ],
              [
                49.516501,
                35.3952118
              ],
              [
                49.5136615,
                35.3917167
              ],
              [
                49.4948869,
                35.3907057
              ],
              [
                49.4892882,
                35.3905895
              ],
              [
                49.472796,
                35.393249
              ],
              [
                49.4707195,
                35.3796745
              ],
              [
                49.4687761,
                35.375786
              ],
              [
                49.4684995,
                35.3752266
              ],
              [
                49.4673862,
                35.3735666
              ],
              [
                49.4559961,
                35.3646709
              ],
              [
                49.4451631,
                35.352446
              ],
              [
                49.4428931,
                35.3423871
              ],
              [
                49.4423396,
                35.3421073
              ],
              [
                49.4392833,
                35.3407177
              ],
              [
                49.4158604,
                35.3198329
              ],
              [
                49.3944706,
                35.2903821
              ],
              [
                49.3933608,
                35.2887132
              ],
              [
                49.3889174,
                35.2834365
              ],
              [
                49.3858607,
                35.2773207
              ],
              [
                49.3747816,
                35.2632994
              ],
              [
                49.3764484,
                35.2591327
              ],
              [
                49.3831299,
                35.2396773
              ],
              [
                49.3831299,
                35.238578
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555098,
        "tags": {
          "admin_level": "5",
          "alt_name:uk": "Шазенд шагрестан",
          "boundary": "administrative",
          "name": "شهرستان شازند",
          "name:en": "Shazand County",
          "name:uk": "Шазанд шагрестан",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277811",
          "wikipedia": "fa:شهرستان شازند"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.9628205,
                33.9054832
              ],
              [
                48.9633771,
                33.9052033
              ],
              [
                48.9642103,
                33.9049325
              ],
              [
                48.9664338,
                33.9049325
              ],
              [
                48.9678201,
                33.9054832
              ],
              [
                48.9803235,
                33.9127135
              ],
              [
                48.9822669,
                33.9129844
              ],
              [
                48.9828236,
                33.9127136
              ],
              [
                48.9839333,
                33.9127136
              ],
              [
                48.9842098,
                33.9124247
              ],
              [
                48.9936566,
                33.9099334
              ],
              [
                48.9942132,
                33.9102042
              ],
              [
                48.9950465,
                33.9102041
              ],
              [
                48.9953235,
                33.910484
              ],
              [
                48.9964333,
                33.910484
              ],
              [
                48.9967133,
                33.9107638
              ],
              [
                48.9980996,
                33.9107638
              ],
              [
                48.9998178,
                33.9113236
              ],
              [
                49.0003231,
                33.9115943
              ],
              [
                49.0011564,
                33.9115943
              ],
              [
                49.0028232,
                33.9121539
              ],
              [
                49.0097663,
                33.9090939
              ],
              [
                49.0117132,
                33.9071532
              ],
              [
                49.0122663,
                33.9060429
              ],
              [
                49.0114331,
                33.9015927
              ],
              [
                48.99949,
                33.8952017
              ],
              [
                48.9947664,
                33.8927104
              ],
              [
                48.9936567,
                33.8904809
              ],
              [
                48.9939332,
                33.89021
              ],
              [
                48.9939332,
                33.8893705
              ],
              [
                48.9947664,
                33.8882603
              ],
              [
                48.9972665,
                33.8827088
              ],
              [
                48.9975466,
                33.8799286
              ],
              [
                48.9978232,
                33.8790981
              ],
              [
                49.0055999,
                33.8710372
              ],
              [
                49.0064331,
                33.8693762
              ],
              [
                49.0061565,
                33.8674265
              ],
              [
                49.0061566,
                33.8671466
              ],
              [
                49.0044898,
                33.8660364
              ],
              [
                49.0011565,
                33.8660363
              ],
              [
                49.0000467,
                33.8665959
              ],
              [
                48.9980997,
                33.866596
              ],
              [
                48.9972666,
                33.866596
              ],
              [
                48.9758772,
                33.8413116
              ],
              [
                48.9758771,
                33.8396507
              ],
              [
                48.9781003,
                33.8374301
              ],
              [
                48.9789334,
                33.8371502
              ],
              [
                48.9803237,
                33.8371502
              ],
              [
                48.9803237,
                33.8368704
              ],
              [
                48.98171,
                33.8368704
              ],
              [
                48.9856003,
                33.8365906
              ],
              [
                48.9858769,
                33.8363197
              ],
              [
                48.9867101,
                33.8363197
              ],
              [
                48.9869903,
                33.8360399
              ],
              [
                48.9875433,
                33.8360399
              ],
              [
                48.9878235,
                33.8357601
              ],
              [
                48.988377,
                33.8357601
              ],
              [
                48.9886567,
                33.8354802
              ],
              [
                48.9914333,
                33.83437
              ],
              [
                48.9919899,
                33.8335394
              ],
              [
                48.9931002,
                33.8324292
              ],
              [
                48.9931002,
                33.8318695
              ],
              [
                48.9939334,
                33.8299286
              ],
              [
                48.9936569,
                33.8260381
              ],
              [
                48.9942135,
                33.8218676
              ],
              [
                48.9928236,
                33.8149258
              ],
              [
                48.9847669,
                33.807984
              ],
              [
                48.9847668,
                33.8077042
              ],
              [
                48.9853613,
                33.7998151
              ],
              [
                48.9856146,
                33.7959794
              ],
              [
                48.9856741,
                33.7896331
              ],
              [
                48.9860402,
                33.7836164
              ],
              [
                48.9883877,
                33.7796479
              ],
              [
                48.9919097,
                33.7779001
              ],
              [
                48.9965862,
                33.7726863
              ],
              [
                49.0002192,
                33.769686
              ],
              [
                49.0001762,
                33.7687072
              ],
              [
                49.005448,
                33.7630671
              ],
              [
                49.0054169,
                33.7598866
              ],
              [
                49.0052032,
                33.7533179
              ],
              [
                49.0088939,
                33.7504634
              ],
              [
                49.0064906,
                33.7497497
              ],
              [
                49.0096664,
                33.7476087
              ],
              [
                49.0100955,
                33.744183
              ],
              [
                49.0078427,
                33.7406382
              ],
              [
                49.0038552,
                33.7361331
              ],
              [
                49.005542,
                33.7303133
              ],
              [
                49.008364,
                33.7224282
              ],
              [
                49.012928,
                33.7153802
              ],
              [
                49.0140008,
                33.7110607
              ],
              [
                49.0144224,
                33.7068628
              ],
              [
                49.0156037,
                33.7018688
              ],
              [
                49.0158803,
                33.7007585
              ],
              [
                49.0161568,
                33.7004786
              ],
              [
                49.0167135,
                33.6990884
              ],
              [
                49.0211569,
                33.696317
              ],
              [
                49.0219901,
                33.6963169
              ],
              [
                49.02338,
                33.6957573
              ],
              [
                49.0258801,
                33.6957572
              ],
              [
                49.0261566,
                33.6954775
              ],
              [
                49.0300466,
                33.6954775
              ],
              [
                49.0325466,
                33.696317
              ],
              [
                49.0342134,
                33.6971476
              ],
              [
                49.0422698,
                33.7026994
              ],
              [
                49.0431031,
                33.7026994
              ],
              [
                49.0433796,
                33.7029792
              ],
              [
                49.0442132,
                33.7029793
              ],
              [
                49.0442133,
                33.7032591
              ],
              [
                49.0458797,
                33.7032592
              ],
              [
                49.0461597,
                33.703539
              ],
              [
                49.049213,
                33.703539
              ],
              [
                49.0497696,
                33.7032591
              ],
              [
                49.0508833,
                33.7032591
              ],
              [
                49.0528263,
                33.7024286
              ],
              [
                49.0650496,
                33.6913159
              ],
              [
                49.0658829,
                33.6907562
              ],
              [
                49.0694927,
                33.6888152
              ],
              [
                49.0703263,
                33.6888153
              ],
              [
                49.0708829,
                33.689366
              ],
              [
                49.0736596,
                33.7007586
              ],
              [
                49.075606,
                33.7179829
              ],
              [
                49.0825491,
                33.7199238
              ],
              [
                49.0850492,
                33.7199237
              ],
              [
                49.0856058,
                33.7199238
              ],
              [
                49.0858824,
                33.7196439
              ],
              [
                49.0894958,
                33.7185336
              ],
              [
                49.0944959,
                33.7168635
              ],
              [
                49.0961624,
                33.7165927
              ],
              [
                49.1011624,
                33.7168636
              ],
              [
                49.101439,
                33.7171524
              ],
              [
                49.107829,
                33.7199238
              ],
              [
                49.1086621,
                33.7199238
              ],
              [
                49.1089391,
                33.7202037
              ],
              [
                49.1114388,
                33.7202036
              ],
              [
                49.1117189,
                33.7199238
              ],
              [
                49.112552,
                33.7196439
              ],
              [
                49.1186624,
                33.7154823
              ],
              [
                49.1194956,
                33.7154823
              ],
              [
                49.1200522,
                33.7152026
              ],
              [
                49.1211621,
                33.7152025
              ],
              [
                49.123662,
                33.7152025
              ],
              [
                49.1244953,
                33.7157532
              ],
              [
                49.1253289,
                33.7157532
              ],
              [
                49.1256055,
                33.716033
              ],
              [
                49.1281086,
                33.7168636
              ],
              [
                49.1283852,
                33.7171524
              ],
              [
                49.1294954,
                33.7179829
              ],
              [
                49.1300521,
                33.7182628
              ],
              [
                49.1383854,
                33.7215939
              ],
              [
                49.1417187,
                33.7215939
              ],
              [
                49.1467184,
                33.7182628
              ],
              [
                49.1669981,
                33.7046495
              ],
              [
                49.1697747,
                33.7040898
              ],
              [
                49.1706084,
                33.7040899
              ],
              [
                49.1797746,
                33.702149
              ],
              [
                49.1842215,
                33.6993685
              ],
              [
                49.1853313,
                33.6976984
              ],
              [
                49.1856114,
                33.6965881
              ],
              [
                49.1950546,
                33.6863149
              ],
              [
                49.194778,
                33.6785332
              ],
              [
                49.1950546,
                33.6777026
              ],
              [
                49.1950547,
                33.6774228
              ],
              [
                49.1956112,
                33.6768721
              ],
              [
                49.1956113,
                33.6763125
              ],
              [
                49.1961644,
                33.6760326
              ],
              [
                49.1989445,
                33.6715911
              ],
              [
                49.1997778,
                33.6665898
              ],
              [
                49.2000547,
                33.6640891
              ],
              [
                49.2011645,
                33.6596476
              ],
              [
                49.2014446,
                33.6588171
              ],
              [
                49.2020014,
                33.657147
              ],
              [
                49.2047779,
                33.6524255
              ],
              [
                49.2064444,
                33.6513151
              ],
              [
                49.2083877,
                33.6468736
              ],
              [
                49.2086678,
                33.6463139
              ],
              [
                49.2083878,
                33.6443639
              ],
              [
                49.2045014,
                33.6301995
              ],
              [
                49.2042213,
                33.6265885
              ],
              [
                49.2045015,
                33.6251983
              ],
              [
                49.2053347,
                33.6243677
              ],
              [
                49.211168,
                33.6207566
              ],
              [
                49.2120011,
                33.6182559
              ],
              [
                49.2156111,
                33.6129748
              ],
              [
                49.2167212,
                33.6127039
              ],
              [
                49.2172779,
                33.6127039
              ],
              [
                49.2181111,
                33.6124241
              ],
              [
                49.2192213,
                33.6124241
              ],
              [
                49.2195009,
                33.6121442
              ],
              [
                49.2228346,
                33.6121442
              ],
              [
                49.2392244,
                33.6168657
              ],
              [
                49.2403342,
                33.6168658
              ],
              [
                49.2408908,
                33.6171455
              ],
              [
                49.2467242,
                33.6171456
              ],
              [
                49.2517239,
                33.6152046
              ],
              [
                49.2522809,
                33.614645
              ],
              [
                49.2528341,
                33.6146449
              ],
              [
                49.2531141,
                33.6143651
              ],
              [
                49.2536673,
                33.6143651
              ],
              [
                49.2556142,
                33.6135345
              ],
              [
                49.256724,
                33.6135346
              ],
              [
                49.2572807,
                33.6132546
              ],
              [
                49.2581138,
                33.6132547
              ],
              [
                49.2586705,
                33.6129749
              ],
              [
                49.265614,
                33.610754
              ],
              [
                49.2667238,
                33.6104832
              ],
              [
                49.2808936,
                33.6040916
              ],
              [
                49.2842269,
                33.6040916
              ],
              [
                49.2850605,
                33.6043715
              ],
              [
                49.287366,
                33.6072273
              ],
              [
                49.2875602,
                33.6077026
              ],
              [
                49.2878371,
                33.6079825
              ],
              [
                49.2881137,
                33.6088131
              ],
              [
                49.2886704,
                33.6121443
              ],
              [
                49.2989502,
                33.6365913
              ],
              [
                49.2953367,
                33.6402023
              ],
              [
                49.2947802,
                33.6421433
              ],
              [
                49.2945036,
                33.6424232
              ],
              [
                49.29645,
                33.6502049
              ],
              [
                49.2970032,
                33.6504758
              ],
              [
                49.3020033,
                33.6535361
              ],
              [
                49.3028365,
                33.6535361
              ],
              [
                49.3031166,
                33.653816
              ],
              [
                49.3061697,
                33.6546466
              ],
              [
                49.3145032,
                33.6588173
              ],
              [
                49.3156165,
                33.6590881
              ],
              [
                49.3217263,
                33.6568673
              ],
              [
                49.3228397,
                33.6551972
              ],
              [
                49.3236729,
                33.6540868
              ],
              [
                49.3281164,
                33.6507556
              ],
              [
                49.3289495,
                33.6507557
              ],
              [
                49.3295062,
                33.6504758
              ],
              [
                49.3342297,
                33.6504758
              ],
              [
                49.3350629,
                33.6507556
              ],
              [
                49.337283,
                33.6507557
              ],
              [
                49.3378396,
                33.6510355
              ],
              [
                49.3439495,
                33.6510356
              ],
              [
                49.3445061,
                33.6513154
              ],
              [
                49.3464495,
                33.6513154
              ],
              [
                49.3467295,
                33.6515953
              ],
              [
                49.3514492,
                33.6529765
              ],
              [
                49.3561728,
                33.6571472
              ],
              [
                49.3578392,
                33.661309
              ],
              [
                49.3567294,
                33.6643693
              ],
              [
                49.3561726,
                33.6657595
              ],
              [
                49.3545059,
                33.6699212
              ],
              [
                49.3556192,
                33.6768725
              ],
              [
                49.3586724,
                33.6802036
              ],
              [
                49.3659554,
                33.6851749
              ],
              [
                49.3664883,
                33.6862105
              ],
              [
                49.3665489,
                33.6878415
              ],
              [
                49.3693726,
                33.6937849
              ],
              [
                49.3685922,
                33.7005188
              ],
              [
                49.3682047,
                33.7036664
              ],
              [
                49.3737363,
                33.7165953
              ],
              [
                49.3799384,
                33.7248107
              ],
              [
                49.3869267,
                33.7285375
              ],
              [
                49.3938925,
                33.7295897
              ],
              [
                49.4089428,
                33.7248783
              ],
              [
                49.412384,
                33.7206275
              ],
              [
                49.4158172,
                33.7168794
              ],
              [
                49.4195509,
                33.7100433
              ],
              [
                49.4227052,
                33.7047685
              ],
              [
                49.4229948,
                33.7045275
              ],
              [
                49.4223082,
                33.7035011
              ],
              [
                49.4220185,
                33.7007073
              ],
              [
                49.4219276,
                33.6966061
              ],
              [
                49.4283914,
                33.6982795
              ],
              [
                49.4350433,
                33.6998862
              ],
              [
                49.4380045,
                33.700386
              ],
              [
                49.442811,
                33.7004217
              ],
              [
                49.4456005,
                33.7007431
              ],
              [
                49.4495058,
                33.7011715
              ],
              [
                49.4558572,
                33.7014571
              ],
              [
                49.46002,
                33.7022426
              ],
              [
                49.4704485,
                33.7024211
              ],
              [
                49.4758987,
                33.702671
              ],
              [
                49.4788169,
                33.7021712
              ],
              [
                49.4810056,
                33.7009573
              ],
              [
                49.4823789,
                33.6996006
              ],
              [
                49.4845676,
                33.6974226
              ],
              [
                49.4863271,
                33.6954945
              ],
              [
                49.4885165,
                33.6957483
              ],
              [
                49.4931508,
                33.692926
              ],
              [
                49.4985151,
                33.6895672
              ],
              [
                49.5028581,
                33.6869519
              ],
              [
                49.5155096,
                33.6869605
              ],
              [
                49.5302255,
                33.688034
              ],
              [
                49.5367343,
                33.6927419
              ],
              [
                49.54106,
                33.6956015
              ],
              [
                49.5473006,
                33.7000738
              ],
              [
                49.5533609,
                33.7044918
              ],
              [
                49.5589089,
                33.7089036
              ],
              [
                49.5717086,
                33.7179856
              ],
              [
                49.5760542,
                33.7206424
              ],
              [
                49.5786994,
                33.7221563
              ],
              [
                49.5829994,
                33.7240374
              ],
              [
                49.5869701,
                33.7261318
              ],
              [
                49.5942597,
                33.7297507
              ],
              [
                49.6015974,
                33.7332881
              ],
              [
                49.6089219,
                33.7355858
              ],
              [
                49.6166452,
                33.7382163
              ],
              [
                49.6223717,
                33.7383793
              ],
              [
                49.6332958,
                33.738745
              ],
              [
                49.6387875,
                33.7443009
              ],
              [
                49.6432794,
                33.749107
              ],
              [
                49.6471797,
                33.7532489
              ],
              [
                49.6546985,
                33.7611877
              ],
              [
                49.663947,
                33.7705434
              ],
              [
                49.6692782,
                33.7761508
              ],
              [
                49.6732154,
                33.7802375
              ],
              [
                49.6733528,
                33.7802831
              ],
              [
                49.669976,
                33.7868708
              ],
              [
                49.6620219,
                33.8004837
              ],
              [
                49.6622984,
                33.8124264
              ],
              [
                49.662575,
                33.8143763
              ],
              [
                49.6628551,
                33.8146471
              ],
              [
                49.6687581,
                33.8258454
              ],
              [
                49.6793603,
                33.8395526
              ],
              [
                49.676159,
                33.8472915
              ],
              [
                49.669203,
                33.8549013
              ],
              [
                49.6590951,
                33.8561181
              ],
              [
                49.656465,
                33.8574349
              ],
              [
                49.6509083,
                33.8599262
              ],
              [
                49.6503516,
                33.8599263
              ],
              [
                49.6497985,
                33.8604859
              ],
              [
                49.6470183,
                33.8613164
              ],
              [
                49.638965,
                33.8624268
              ],
              [
                49.6350751,
                33.8610365
              ],
              [
                49.6331286,
                33.8604859
              ],
              [
                49.6322954,
                33.8604859
              ],
              [
                49.6317418,
                33.8602061
              ],
              [
                49.6300754,
                33.8602061
              ],
              [
                49.6209088,
                33.8718687
              ],
              [
                49.6204082,
                33.8728687
              ],
              [
                49.6248984,
                33.8761319
              ],
              [
                49.6320569,
                33.8834442
              ],
              [
                49.6382386,
                33.8915071
              ],
              [
                49.6395185,
                33.8929914
              ],
              [
                49.6417416,
                33.8946524
              ],
              [
                49.6428518,
                33.898263
              ],
              [
                49.641465,
                33.9004836
              ],
              [
                49.6339617,
                33.9032638
              ],
              [
                49.6336852,
                33.9035436
              ],
              [
                49.6314616,
                33.9052045
              ],
              [
                49.608962,
                33.932158
              ],
              [
                49.5995187,
                33.9374295
              ],
              [
                49.598129,
                33.93826
              ],
              [
                49.5959054,
                33.9388196
              ],
              [
                49.5945156,
                33.9388196
              ],
              [
                49.5939624,
                33.9390994
              ],
              [
                49.5922955,
                33.9390994
              ],
              [
                49.587849,
                33.9410402
              ],
              [
                49.5845157,
                33.9474309
              ],
              [
                49.585629,
                33.9560421
              ],
              [
                49.5845156,
                33.9602034
              ],
              [
                49.5834055,
                33.9613226
              ],
              [
                49.5820156,
                33.9621531
              ],
              [
                49.5815553,
                33.9625253
              ],
              [
                49.5797956,
                33.9635431
              ],
              [
                49.5797957,
                33.963823
              ],
              [
                49.5736823,
                33.9660435
              ],
              [
                49.5725724,
                33.9660434
              ],
              [
                49.5722924,
                33.9663233
              ],
              [
                49.5711826,
                33.9663233
              ],
              [
                49.5709059,
                33.9666031
              ],
              [
                49.5697923,
                33.9666031
              ],
              [
                49.5681258,
                33.9671537
              ],
              [
                49.5625726,
                33.9671537
              ],
              [
                49.5589593,
                33.9666031
              ],
              [
                49.5475696,
                33.9591021
              ],
              [
                49.5464595,
                33.9588223
              ],
              [
                49.5456262,
                33.9588222
              ],
              [
                49.5450695,
                33.9585425
              ],
              [
                49.5431262,
                33.9585424
              ],
              [
                49.5422929,
                33.959102
              ],
              [
                49.5406262,
                33.9627126
              ],
              [
                49.5411827,
                33.9674335
              ],
              [
                49.5409026,
                33.9679841
              ],
              [
                49.540346,
                33.969654
              ],
              [
                49.5400695,
                33.9704935
              ],
              [
                49.5375693,
                33.9738242
              ],
              [
                49.5364596,
                33.9743748
              ],
              [
                49.5359029,
                33.9749344
              ],
              [
                49.5331263,
                33.975485
              ],
              [
                49.5331263,
                33.9757648
              ],
              [
                49.5317364,
                33.9757648
              ],
              [
                49.5311793,
                33.9760447
              ],
              [
                49.5300695,
                33.9760447
              ],
              [
                49.5297929,
                33.9757649
              ],
              [
                49.5270129,
                33.9757648
              ],
              [
                49.5267363,
                33.975485
              ],
              [
                49.5256266,
                33.9757648
              ],
              [
                49.5247929,
                33.9757649
              ],
              [
                49.5242363,
                33.975485
              ],
              [
                49.5203464,
                33.975485
              ],
              [
                49.5200698,
                33.9757648
              ],
              [
                49.5192366,
                33.9757648
              ],
              [
                49.5134033,
                33.979935
              ],
              [
                49.5028468,
                33.9865965
              ],
              [
                49.5022901,
                33.9865965
              ],
              [
                49.5020131,
                33.9868763
              ],
              [
                49.5011799,
                33.9868763
              ],
              [
                49.5006233,
                33.9871561
              ],
              [
                49.4995135,
                33.9871561
              ],
              [
                49.4983998,
                33.9871561
              ],
              [
                49.4939568,
                33.988817
              ],
              [
                49.4872902,
                33.9943771
              ],
              [
                49.4836495,
                33.9955904
              ],
              [
                49.4764567,
                33.9979876
              ],
              [
                49.4764568,
                34.0002894
              ],
              [
                49.4767337,
                34.0027084
              ],
              [
                49.4775669,
                34.0038186
              ],
              [
                49.4784001,
                34.0071493
              ],
              [
                49.4793818,
                34.0110844
              ],
              [
                49.4794801,
                34.0114785
              ],
              [
                49.4795103,
                34.0115993
              ],
              [
                49.4796198,
                34.0116544
              ],
              [
                49.4797817,
                34.0117358
              ],
              [
                49.4798815,
                34.0117859
              ],
              [
                49.480067,
                34.0118791
              ],
              [
                49.4806236,
                34.0129893
              ],
              [
                49.4822901,
                34.0140995
              ],
              [
                49.4906233,
                34.022151
              ],
              [
                49.4928468,
                34.0268717
              ],
              [
                49.4939567,
                34.0371525
              ],
              [
                49.49368,
                34.0382717
              ],
              [
                49.4939566,
                34.0410427
              ],
              [
                49.49368,
                34.044933
              ],
              [
                49.4933999,
                34.0466028
              ],
              [
                49.4931233,
                34.0479838
              ],
              [
                49.4928468,
                34.0482636
              ],
              [
                49.49118,
                34.0527135
              ],
              [
                49.4897901,
                34.0540945
              ],
              [
                49.4625669,
                34.0727062
              ],
              [
                49.4589534,
                34.077156
              ],
              [
                49.4578437,
                34.0788257
              ],
              [
                49.4578437,
                34.0799359
              ],
              [
                49.4578437,
                34.0802157
              ],
              [
                49.4575671,
                34.0818765
              ],
              [
                49.4572869,
                34.0824361
              ],
              [
                49.457287,
                34.0832665
              ],
              [
                49.457287,
                34.0838261
              ],
              [
                49.4561769,
                34.0871567
              ],
              [
                49.4539537,
                34.0899366
              ],
              [
                49.4386773,
                34.102988
              ],
              [
                49.4370104,
                34.1074378
              ],
              [
                49.4370104,
                34.1143787
              ],
              [
                49.4361772,
                34.1160484
              ],
              [
                49.4347873,
                34.1174384
              ],
              [
                49.4347872,
                34.117989
              ],
              [
                49.433397,
                34.1193789
              ],
              [
                49.4322872,
                34.1224386
              ],
              [
                49.4322872,
                34.1227094
              ],
              [
                49.4322871,
                34.1243792
              ],
              [
                49.4328438,
                34.1274389
              ],
              [
                49.438397,
                34.1332695
              ],
              [
                49.4403436,
                34.1340999
              ],
              [
                49.4631202,
                34.1449398
              ],
              [
                49.4650668,
                34.1449398
              ],
              [
                49.4661765,
                34.1452196
              ],
              [
                49.4778431,
                34.1477107
              ],
              [
                49.4833998,
                34.1546605
              ],
              [
                49.4839565,
                34.1554908
              ],
              [
                49.4867331,
                34.1635507
              ],
              [
                49.4911797,
                34.1718813
              ],
              [
                49.4908996,
                34.1732712
              ],
              [
                49.4892331,
                34.1766017
              ],
              [
                49.4858998,
                34.1796612
              ],
              [
                49.4822896,
                34.1807714
              ],
              [
                49.4778431,
                34.1821524
              ],
              [
                49.4734,
                34.1866019
              ],
              [
                49.4728433,
                34.1879918
              ],
              [
                49.4725663,
                34.1882716
              ],
              [
                49.4722897,
                34.191602
              ],
              [
                49.4720097,
                34.1924414
              ],
              [
                49.469233,
                34.1988223
              ],
              [
                49.4686764,
                34.1988223
              ],
              [
                49.4628431,
                34.200492
              ],
              [
                49.4620099,
                34.2010516
              ],
              [
                49.4503432,
                34.2071618
              ],
              [
                49.4470099,
                34.2071617
              ],
              [
                49.4461767,
                34.2068819
              ],
              [
                49.438677,
                34.1968818
              ],
              [
                49.4317304,
                34.1943818
              ],
              [
                49.4297869,
                34.1943817
              ],
              [
                49.4295104,
                34.194102
              ],
              [
                49.4270068,
                34.194102
              ],
              [
                49.4228403,
                34.1941019
              ],
              [
                49.4217305,
                34.194102
              ],
              [
                49.4211739,
                34.1943817
              ],
              [
                49.4203402,
                34.1943817
              ],
              [
                49.4197872,
                34.1946616
              ],
              [
                49.4189539,
                34.1946615
              ],
              [
                49.4136737,
                34.196602
              ],
              [
                49.4131206,
                34.1971616
              ],
              [
                49.4108971,
                34.1982717
              ],
              [
                49.4072837,
                34.2018819
              ],
              [
                49.406174,
                34.2035515
              ],
              [
                49.402284,
                34.2074325
              ],
              [
                49.3947843,
                34.2116022
              ],
              [
                49.3939507,
                34.2116021
              ],
              [
                49.3936741,
                34.2118819
              ],
              [
                49.3922842,
                34.2121527
              ],
              [
                49.3817277,
                34.2110426
              ],
              [
                49.3800609,
                34.2085516
              ],
              [
                49.3800609,
                34.2077122
              ],
              [
                49.380341,
                34.2066021
              ],
              [
                49.380341,
                34.2063223
              ],
              [
                49.3895076,
                34.1916018
              ],
              [
                49.3897842,
                34.1904917
              ],
              [
                49.397284,
                34.1735418
              ],
              [
                49.3975641,
                34.173271
              ],
              [
                49.3995075,
                34.1663214
              ],
              [
                49.3997841,
                34.1627202
              ],
              [
                49.4000643,
                34.1621606
              ],
              [
                49.399784,
                34.161601
              ],
              [
                49.3995075,
                34.1535503
              ],
              [
                49.4006173,
                34.1513299
              ],
              [
                49.401451,
                34.1491006
              ],
              [
                49.4017306,
                34.14855
              ],
              [
                49.4008974,
                34.1438206
              ],
              [
                49.3983974,
                34.1421598
              ],
              [
                49.3975642,
                34.1421598
              ],
              [
                49.3686714,
                34.1315997
              ],
              [
                49.3602829,
                34.1272689
              ],
              [
                49.3595048,
                34.1268792
              ],
              [
                49.3583946,
                34.1263287
              ],
              [
                49.3525613,
                34.127159
              ],
              [
                49.3461714,
                34.1288198
              ],
              [
                49.3442283,
                34.1288197
              ],
              [
                49.3433952,
                34.1290995
              ],
              [
                49.3422815,
                34.1290995
              ],
              [
                49.3414483,
                34.1293793
              ],
              [
                49.3400614,
                34.1293793
              ],
              [
                49.338395,
                34.1299298
              ],
              [
                49.3372817,
                34.1299299
              ],
              [
                49.3370051,
                34.1302187
              ],
              [
                49.3350618,
                34.1302187
              ],
              [
                49.3322816,
                34.1307693
              ],
              [
                49.3300585,
                34.1307692
              ],
              [
                49.3153386,
                34.13382
              ],
              [
                49.2933921,
                34.1449395
              ],
              [
                49.2917257,
                34.1457699
              ],
              [
                49.2914455,
                34.1460497
              ],
              [
                49.2653361,
                34.1596603
              ],
              [
                49.2645025,
                34.1604907
              ],
              [
                49.2547792,
                34.1649402
              ],
              [
                49.2533893,
                34.165211
              ],
              [
                49.2456126,
                34.1641009
              ],
              [
                49.2428329,
                34.1632705
              ],
              [
                49.2294998,
                34.1585501
              ],
              [
                49.2242231,
                34.1591007
              ],
              [
                49.2236664,
                34.1591007
              ],
              [
                49.2161662,
                34.1621604
              ],
              [
                49.2139432,
                34.1621603
              ],
              [
                49.2136666,
                34.1624401
              ],
              [
                49.2083864,
                34.1624401
              ],
              [
                49.2058864,
                34.1638301
              ],
              [
                49.20672,
                34.1668807
              ],
              [
                49.2097766,
                34.1732707
              ],
              [
                49.2097767,
                34.1766012
              ],
              [
                49.2094997,
                34.1777113
              ],
              [
                49.2092197,
                34.1779911
              ],
              [
                49.2083864,
                34.1793811
              ],
              [
                49.1839432,
                34.1932712
              ],
              [
                49.1781068,
                34.1946611
              ],
              [
                49.1756067,
                34.1946611
              ],
              [
                49.1750536,
                34.1949409
              ],
              [
                49.1725536,
                34.1949408
              ],
              [
                49.1717204,
                34.1946611
              ],
              [
                49.1689403,
                34.1946611
              ],
              [
                49.1642202,
                34.196051
              ],
              [
                49.1625503,
                34.196051
              ],
              [
                49.1622737,
                34.1957712
              ],
              [
                49.1606069,
                34.1957711
              ],
              [
                49.1572736,
                34.1949408
              ],
              [
                49.1556073,
                34.1949408
              ],
              [
                49.154774,
                34.1946611
              ],
              [
                49.1525504,
                34.1946611
              ],
              [
                49.1500505,
                34.1943813
              ],
              [
                49.1492172,
                34.1941015
              ],
              [
                49.1439405,
                34.1941014
              ],
              [
                49.1400506,
                34.1952116
              ],
              [
                49.139494,
                34.1957711
              ],
              [
                49.1389407,
                34.1957712
              ],
              [
                49.1269941,
                34.2013308
              ],
              [
                49.1236607,
                34.2018813
              ],
              [
                49.1236608,
                34.2016016
              ],
              [
                49.1239374,
                34.2004914
              ],
              [
                49.1242175,
                34.1991015
              ],
              [
                49.1244941,
                34.1985419
              ],
              [
                49.1233842,
                34.1910418
              ],
              [
                49.1197709,
                34.1863215
              ],
              [
                49.1114376,
                34.1824315
              ],
              [
                49.1106044,
                34.1824315
              ],
              [
                49.1072711,
                34.1810416
              ],
              [
                49.1052979,
                34.1806167
              ],
              [
                49.1025479,
                34.1796606
              ],
              [
                49.0997713,
                34.1788212
              ],
              [
                49.0947712,
                34.1721604
              ],
              [
                49.093938,
                34.1691007
              ],
              [
                49.0936614,
                34.1641006
              ],
              [
                49.093938,
                34.1627197
              ],
              [
                49.0979816,
                34.1558944
              ],
              [
                49.0983811,
                34.1554901
              ],
              [
                49.0989378,
                34.1552104
              ],
              [
                49.0992148,
                34.1546598
              ],
              [
                49.1000479,
                34.1535496
              ],
              [
                49.1003281,
                34.1532699
              ],
              [
                49.1008811,
                34.1532698
              ],
              [
                49.1044946,
                34.1513293
              ],
              [
                49.1081043,
                34.1471595
              ],
              [
                49.1092177,
                34.145219
              ],
              [
                49.1103279,
                34.1432695
              ],
              [
                49.1108845,
                34.1429897
              ],
              [
                49.1111611,
                34.1421593
              ],
              [
                49.1167179,
                34.1352185
              ],
              [
                49.1383843,
                34.1193784
              ],
              [
                49.1392176,
                34.1193784
              ],
              [
                49.1394941,
                34.1190986
              ],
              [
                49.1500506,
                34.1165984
              ],
              [
                49.1525506,
                34.1165985
              ],
              [
                49.1531073,
                34.1163186
              ],
              [
                49.1572738,
                34.1157682
              ],
              [
                49.1597739,
                34.1157681
              ],
              [
                49.1606071,
                34.1160479
              ],
              [
                49.1683874,
                34.1171581
              ],
              [
                49.1717207,
                34.1171582
              ],
              [
                49.1736636,
                34.1163187
              ],
              [
                49.1750539,
                34.1121578
              ],
              [
                49.1753304,
                34.1115983
              ],
              [
                49.1734573,
                34.1031297
              ],
              [
                49.173107,
                34.1027078
              ],
              [
                49.1728305,
                34.1018774
              ],
              [
                49.1714405,
                34.1002076
              ],
              [
                49.171164,
                34.0999368
              ],
              [
                49.1672741,
                34.0935465
              ],
              [
                49.153664,
                34.0838255
              ],
              [
                49.1472741,
                34.0807658
              ],
              [
                49.1419944,
                34.0766048
              ],
              [
                49.1225514,
                34.0546535
              ],
              [
                49.1214377,
                34.0538231
              ],
              [
                49.1172712,
                34.0515936
              ],
              [
                49.107828,
                34.0482629
              ],
              [
                49.1031049,
                34.0446525
              ],
              [
                49.1017147,
                34.0404824
              ],
              [
                49.0975482,
                34.0288207
              ],
              [
                49.091995,
                34.0218704
              ],
              [
                49.0811585,
                34.0152091
              ],
              [
                49.0803252,
                34.0152091
              ],
              [
                49.0797717,
                34.0149293
              ],
              [
                49.0786584,
                34.0149292
              ],
              [
                49.0775724,
                34.01471
              ],
              [
                49.0708821,
                34.0102085
              ],
              [
                49.0544924,
                34.0015975
              ],
              [
                49.0542158,
                33.9999276
              ],
              [
                49.0561588,
                33.9946562
              ],
              [
                49.0564354,
                33.9940966
              ],
              [
                49.0553256,
                33.9885453
              ],
              [
                49.0528256,
                33.9860451
              ],
              [
                49.052549,
                33.9857652
              ],
              [
                49.0417125,
                33.9763146
              ],
              [
                49.0386593,
                33.9749335
              ],
              [
                49.0381026,
                33.9752134
              ],
              [
                49.037546,
                33.9749335
              ],
              [
                49.037269,
                33.9752134
              ],
              [
                49.0306025,
                33.9763146
              ],
              [
                49.0303224,
                33.9768742
              ],
              [
                49.0228226,
                33.9813242
              ],
              [
                49.0211562,
                33.9818748
              ],
              [
                49.0194894,
                33.9818748
              ],
              [
                49.0189361,
                33.9821546
              ],
              [
                49.0158795,
                33.9824255
              ],
              [
                49.0128228,
                33.9824254
              ],
              [
                49.0119895,
                33.9821546
              ],
              [
                49.0103227,
                33.9821546
              ],
              [
                49.0100462,
                33.9818748
              ],
              [
                49.0089329,
                33.9818748
              ],
              [
                49.0086564,
                33.981595
              ],
              [
                48.9980995,
                33.9777046
              ],
              [
                48.9878231,
                33.9721534
              ],
              [
                48.9869899,
                33.9721533
              ],
              [
                48.9686532,
                33.9596517
              ],
              [
                48.9658766,
                33.9566007
              ],
              [
                48.9653199,
                33.9560411
              ],
              [
                48.9619867,
                33.9499301
              ],
              [
                48.9614336,
                33.9443698
              ],
              [
                48.9617101,
                33.9427089
              ],
              [
                48.9639336,
                33.9393781
              ],
              [
                48.9636535,
                33.9365979
              ],
              [
                48.9575437,
                33.927427
              ],
              [
                48.9564304,
                33.922706
              ],
              [
                48.9561538,
                33.9224262
              ],
              [
                48.9564304,
                33.9218755
              ],
              [
                48.9561538,
                33.921325
              ],
              [
                48.9558769,
                33.9199348
              ],
              [
                48.9555968,
                33.9168748
              ],
              [
                48.9575438,
                33.9102041
              ],
              [
                48.9594871,
                33.9079835
              ],
              [
                48.9606005,
                33.9074239
              ],
              [
                48.9628205,
                33.9054832
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555131,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فراهان",
          "name:en": "Farahan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q4808792"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.4224186,
                34.5346747
              ],
              [
                49.4225629,
                34.5343828
              ],
              [
                49.4233962,
                34.5327225
              ],
              [
                49.4286763,
                34.5274437
              ],
              [
                49.4625658,
                34.5007784
              ],
              [
                49.465619,
                34.4974486
              ],
              [
                49.4670093,
                34.4960589
              ],
              [
                49.470066,
                34.4938301
              ],
              [
                49.4778423,
                34.4899497
              ],
              [
                49.4786755,
                34.4899498
              ],
              [
                49.4803423,
                34.4891106
              ],
              [
                49.4814556,
                34.4891105
              ],
              [
                49.4817322,
                34.4888308
              ],
              [
                49.4825655,
                34.4888308
              ],
              [
                49.4833991,
                34.4885511
              ],
              [
                49.4856222,
                34.4882803
              ],
              [
                49.4922887,
                34.4885511
              ],
              [
                49.4925656,
                34.4882804
              ],
              [
                49.4945122,
                34.4885511
              ],
              [
                49.4997889,
                34.4885511
              ],
              [
                49.5286785,
                34.4824419
              ],
              [
                49.5297918,
                34.4818915
              ],
              [
                49.5311782,
                34.4816117
              ],
              [
                49.537845,
                34.4791121
              ],
              [
                49.5384017,
                34.4785526
              ],
              [
                49.539235,
                34.4782819
              ],
              [
                49.547848,
                34.4702235
              ],
              [
                49.5478481,
                34.469664
              ],
              [
                49.5659047,
                34.455776
              ],
              [
                49.5689579,
                34.4527258
              ],
              [
                49.569238,
                34.4518866
              ],
              [
                49.5722912,
                34.4441077
              ],
              [
                49.5725714,
                34.4424383
              ],
              [
                49.5728478,
                34.4410576
              ],
              [
                49.5734045,
                34.4396679
              ],
              [
                49.5734045,
                34.4385489
              ],
              [
                49.5736811,
                34.4379984
              ],
              [
                49.573958,
                34.4360491
              ],
              [
                49.5745147,
                34.4335585
              ],
              [
                49.5747913,
                34.431889
              ],
              [
                49.5809047,
                34.4077219
              ],
              [
                49.5811813,
                34.4046626
              ],
              [
                49.5814614,
                34.4038324
              ],
              [
                49.5812588,
                34.4007962
              ],
              [
                49.5809049,
                34.3954938
              ],
              [
                49.5809048,
                34.3854947
              ],
              [
                49.5834044,
                34.3793851
              ],
              [
                49.5856281,
                34.3768854
              ],
              [
                49.5859046,
                34.3766056
              ],
              [
                49.5870147,
                34.3754956
              ],
              [
                49.5870148,
                34.3752158
              ],
              [
                49.5881281,
                34.3752159
              ],
              [
                49.5931277,
                34.3752158
              ],
              [
                49.5942379,
                34.3749361
              ],
              [
                49.6031279,
                34.3746654
              ],
              [
                49.6039611,
                34.3749361
              ],
              [
                49.607571,
                34.3749362
              ],
              [
                49.6086843,
                34.375216
              ],
              [
                49.6109043,
                34.3752158
              ],
              [
                49.6122941,
                34.3754957
              ],
              [
                49.6142375,
                34.3754956
              ],
              [
                49.6153508,
                34.3757754
              ],
              [
                49.6170176,
                34.3757754
              ],
              [
                49.6178509,
                34.3760552
              ],
              [
                49.6214607,
                34.3760552
              ],
              [
                49.6220174,
                34.3757754
              ],
              [
                49.624794,
                34.3757755
              ],
              [
                49.6275741,
                34.3752159
              ],
              [
                49.6303508,
                34.3752159
              ],
              [
                49.6314606,
                34.3749362
              ],
              [
                49.6406307,
                34.3749361
              ],
              [
                49.6434073,
                34.3757754
              ],
              [
                49.644517,
                34.3757755
              ],
              [
                49.6450738,
                34.3760553
              ],
              [
                49.6642401,
                34.3791145
              ],
              [
                49.6725735,
                34.3799358
              ],
              [
                49.6756302,
                34.3804954
              ],
              [
                49.6767435,
                34.3807752
              ],
              [
                49.682457,
                34.3525961
              ],
              [
                49.6826101,
                34.3306299
              ],
              [
                49.740043,
                34.3315629
              ],
              [
                49.7428245,
                34.3436441
              ],
              [
                49.7479492,
                34.3595223
              ],
              [
                49.7675168,
                34.3746121
              ],
              [
                49.7838592,
                34.3922499
              ],
              [
                49.7935225,
                34.4069767
              ],
              [
                49.7890288,
                34.4113832
              ],
              [
                49.7750791,
                34.4216107
              ],
              [
                49.7723024,
                34.4230004
              ],
              [
                49.7606357,
                34.4313298
              ],
              [
                49.7586888,
                34.435499
              ],
              [
                49.7584122,
                34.4374482
              ],
              [
                49.7581357,
                34.4382784
              ],
              [
                49.7578556,
                34.4393884
              ],
              [
                49.7611888,
                34.4510476
              ],
              [
                49.7742453,
                34.4674444
              ],
              [
                49.774802,
                34.4685544
              ],
              [
                49.7750789,
                34.4688341
              ],
              [
                49.7750789,
                34.4691049
              ],
              [
                49.7750789,
                34.4696644
              ],
              [
                49.7756355,
                34.4730033
              ],
              [
                49.7759121,
                34.4735537
              ],
              [
                49.7759121,
                34.4768835
              ],
              [
                49.7756356,
                34.4777229
              ],
              [
                49.7770254,
                34.4955
              ],
              [
                49.7767453,
                34.4963301
              ],
              [
                49.7764687,
                34.499669
              ],
              [
                49.7784121,
                34.5102178
              ],
              [
                49.7859118,
                34.5227248
              ],
              [
                49.7864685,
                34.5232843
              ],
              [
                49.7865801,
                34.5234508
              ],
              [
                49.782302,
                34.5282744
              ],
              [
                49.7809117,
                34.5302235
              ],
              [
                49.7800785,
                34.5327231
              ],
              [
                49.7778585,
                34.5377222
              ],
              [
                49.7775784,
                34.5388321
              ],
              [
                49.7773018,
                34.5407812
              ],
              [
                49.7770252,
                34.5421709
              ],
              [
                49.7767452,
                34.5441109
              ],
              [
                49.7764686,
                34.5455006
              ],
              [
                49.776192,
                34.5463397
              ],
              [
                49.7759119,
                34.5493897
              ],
              [
                49.7756353,
                34.5510591
              ],
              [
                49.7745251,
                34.5560581
              ],
              [
                49.7742451,
                34.5579982
              ],
              [
                49.7725786,
                34.5685557
              ],
              [
                49.7720251,
                34.5713349
              ],
              [
                49.771745,
                34.5730043
              ],
              [
                49.7714684,
                34.5743848
              ],
              [
                49.7720251,
                34.5796726
              ],
              [
                49.772025,
                34.580223
              ],
              [
                49.7720251,
                34.5805027
              ],
              [
                49.772302,
                34.5807825
              ],
              [
                49.7728587,
                34.5849512
              ],
              [
                49.7731352,
                34.5860611
              ],
              [
                49.7775782,
                34.5913308
              ],
              [
                49.7884148,
                34.5943897
              ],
              [
                49.789525,
                34.5949492
              ],
              [
                49.7911914,
                34.5957793
              ],
              [
                49.8411943,
                34.6305008
              ],
              [
                49.8445276,
                34.6324497
              ],
              [
                49.8478609,
                34.6352288
              ],
              [
                49.8484175,
                34.636059
              ],
              [
                49.8492507,
                34.6366184
              ],
              [
                49.8528606,
                34.6424473
              ],
              [
                49.8539708,
                34.6449468
              ],
              [
                49.8603607,
                34.6546735
              ],
              [
                49.8617506,
                34.6555036
              ],
              [
                49.8620271,
                34.656054
              ],
              [
                49.866194,
                34.6577233
              ],
              [
                49.8670272,
                34.6577233
              ],
              [
                49.8903636,
                34.6671703
              ],
              [
                49.8939735,
                34.6699494
              ],
              [
                49.8970302,
                34.674948
              ],
              [
                49.8978634,
                34.6791165
              ],
              [
                49.8975833,
                34.6793963
              ],
              [
                49.8973067,
                34.6810565
              ],
              [
                49.8973067,
                34.6816159
              ],
              [
                49.8959168,
                34.6827257
              ],
              [
                49.8953633,
                34.6838355
              ],
              [
                49.889807,
                34.6866146
              ],
              [
                49.8886967,
                34.6866145
              ],
              [
                49.8881401,
                34.6868942
              ],
              [
                49.8861967,
                34.6868942
              ],
              [
                49.88564,
                34.6871739
              ],
              [
                49.8845303,
                34.6871739
              ],
              [
                49.8842502,
                34.6874537
              ],
              [
                49.883417,
                34.6874536
              ],
              [
                49.8742504,
                34.6921725
              ],
              [
                49.8742503,
                34.6924522
              ],
              [
                49.8725835,
                34.693562
              ],
              [
                49.8714737,
                34.6949515
              ],
              [
                49.8636938,
                34.7130059
              ],
              [
                49.8603605,
                34.717454
              ],
              [
                49.8589703,
                34.7196735
              ],
              [
                49.8575839,
                34.721063
              ],
              [
                49.8486939,
                34.7269006
              ],
              [
                49.8392472,
                34.7285607
              ],
              [
                49.8386941,
                34.7288404
              ],
              [
                49.8373042,
                34.7288404
              ],
              [
                49.8300806,
                34.7305096
              ],
              [
                49.8286943,
                34.7307893
              ],
              [
                49.827581,
                34.7310599
              ],
              [
                49.8273039,
                34.7313396
              ],
              [
                49.8261942,
                34.731899
              ],
              [
                49.8256375,
                34.731899
              ],
              [
                49.8256375,
                34.7321787
              ],
              [
                49.8225809,
                34.7349486
              ],
              [
                49.8198042,
                34.7363381
              ],
              [
                49.8175811,
                34.7363381
              ],
              [
                49.8159143,
                34.7368975
              ],
              [
                49.8156378,
                34.7371772
              ],
              [
                49.812581,
                34.7357877
              ],
              [
                49.8017481,
                34.7216133
              ],
              [
                49.7981346,
                34.7205035
              ],
              [
                49.7964678,
                34.7205035
              ],
              [
                49.7925814,
                34.721893
              ],
              [
                49.7917478,
                34.721893
              ],
              [
                49.7898012,
                34.7227321
              ],
              [
                49.7892482,
                34.7230027
              ],
              [
                49.7450785,
                34.744395
              ],
              [
                49.7442452,
                34.744395
              ],
              [
                49.7425784,
                34.745225
              ],
              [
                49.7406318,
                34.7457845
              ],
              [
                49.7400787,
                34.7457844
              ],
              [
                49.7397986,
                34.7460641
              ],
              [
                49.7339653,
                34.7460641
              ],
              [
                49.7322985,
                34.7457845
              ],
              [
                49.7309121,
                34.7457844
              ],
              [
                49.7300753,
                34.7455047
              ],
              [
                49.7286886,
                34.7455047
              ],
              [
                49.7261886,
                34.7449454
              ],
              [
                49.7250753,
                34.7449453
              ],
              [
                49.7203552,
                34.7446747
              ],
              [
                49.7142422,
                34.7438356
              ],
              [
                49.7120223,
                34.7438355
              ],
              [
                49.6947993,
                34.7407859
              ],
              [
                49.6931324,
                34.740786
              ],
              [
                49.6920192,
                34.7405062
              ],
              [
                49.6850761,
                34.7405063
              ],
              [
                49.6725727,
                34.742446
              ],
              [
                49.6717395,
                34.7427257
              ],
              [
                49.6703527,
                34.7427258
              ],
              [
                49.6686862,
                34.7432851
              ],
              [
                49.6661862,
                34.7432851
              ],
              [
                49.6656295,
                34.7435558
              ],
              [
                49.6592396,
                34.7432852
              ],
              [
                49.658686,
                34.7430054
              ],
              [
                49.6570196,
                34.7430054
              ],
              [
                49.6528496,
                34.7421754
              ],
              [
                49.6514628,
                34.7416159
              ],
              [
                49.6492397,
                34.7413362
              ],
              [
                49.648683,
                34.7410565
              ],
              [
                49.643963,
                34.7410566
              ],
              [
                49.638963,
                34.7396762
              ],
              [
                49.6345164,
                34.7377273
              ],
              [
                49.6339597,
                34.7374476
              ],
              [
                49.63285,
                34.7382866
              ],
              [
                49.6325734,
                34.738837
              ],
              [
                49.6320164,
                34.7399467
              ],
              [
                49.6317398,
                34.7402265
              ],
              [
                49.6275733,
                34.7499526
              ],
              [
                49.6278499,
                34.7574502
              ],
              [
                49.6286831,
                34.7588396
              ],
              [
                49.6303499,
                34.7666169
              ],
              [
                49.6306264,
                34.7680063
              ],
              [
                49.6303499,
                34.7685567
              ],
              [
                49.6300733,
                34.7713355
              ],
              [
                49.6303499,
                34.7732843
              ],
              [
                49.6359066,
                34.7805021
              ],
              [
                49.6367398,
                34.7819005
              ],
              [
                49.6406297,
                34.7852298
              ],
              [
                49.6439629,
                34.7916174
              ],
              [
                49.6447962,
                34.7996742
              ],
              [
                49.6414627,
                34.811069
              ],
              [
                49.6370163,
                34.8180069
              ],
              [
                49.6364631,
                34.8182866
              ],
              [
                49.6364632,
                34.8185662
              ],
              [
                49.6339595,
                34.821345
              ],
              [
                49.6211831,
                34.8427268
              ],
              [
                49.6177262,
                34.8455656
              ],
              [
                49.61035,
                34.8516222
              ],
              [
                49.6097934,
                34.8516222
              ],
              [
                49.6092366,
                34.8521725
              ],
              [
                49.6084031,
                34.8524522
              ],
              [
                49.60785,
                34.8530116
              ],
              [
                49.6061832,
                34.8535709
              ],
              [
                49.6056265,
                34.8538416
              ],
              [
                49.5920133,
                34.8607883
              ],
              [
                49.5822935,
                34.8710639
              ],
              [
                49.5822935,
                34.8716142
              ],
              [
                49.5813303,
                34.8722003
              ],
              [
                49.5709536,
                34.8769827
              ],
              [
                49.5604112,
                34.8849725
              ],
              [
                49.5554789,
                34.8899431
              ],
              [
                49.5459097,
                34.8941089
              ],
              [
                49.5266194,
                34.8974546
              ],
              [
                49.5151924,
                34.9000491
              ],
              [
                49.5012317,
                34.9097091
              ],
              [
                49.5080208,
                34.8952998
              ],
              [
                49.4910396,
                34.8658657
              ],
              [
                49.4745087,
                34.8493349
              ],
              [
                49.4608528,
                34.8184293
              ],
              [
                49.460134,
                34.776024
              ],
              [
                49.4709151,
                34.7558995
              ],
              [
                49.4752275,
                34.7393686
              ],
              [
                49.4694776,
                34.7178066
              ],
              [
                49.4653112,
                34.7108242
              ],
              [
                49.4653111,
                34.7108241
              ],
              [
                49.4458955,
                34.6782858
              ],
              [
                49.4514522,
                34.675227
              ],
              [
                49.467289,
                34.6607814
              ],
              [
                49.4675654,
                34.6605017
              ],
              [
                49.4747887,
                34.6532833
              ],
              [
                49.4753418,
                34.6516142
              ],
              [
                49.4747887,
                34.651614
              ],
              [
                49.4645088,
                34.651614
              ],
              [
                49.4639522,
                34.6513343
              ],
              [
                49.4583989,
                34.6507839
              ],
              [
                49.4542324,
                34.6507839
              ],
              [
                49.4536758,
                34.6505042
              ],
              [
                49.4508991,
                34.6505042
              ],
              [
                49.4500656,
                34.6502245
              ],
              [
                49.4481191,
                34.6502245
              ],
              [
                49.4470088,
                34.6499448
              ],
              [
                49.4417291,
                34.6491147
              ],
              [
                49.4353427,
                34.6443956
              ],
              [
                49.4333957,
                34.6399473
              ],
              [
                49.4331191,
                34.6379982
              ],
              [
                49.4333957,
                34.6374479
              ],
              [
                49.4333957,
                34.6341184
              ],
              [
                49.4336758,
                34.6305001
              ],
              [
                49.4339524,
                34.6288399
              ],
              [
                49.4342293,
                34.6268908
              ],
              [
                49.4345095,
                34.6243915
              ],
              [
                49.434786,
                34.6238319
              ],
              [
                49.4339524,
                34.6188331
              ],
              [
                49.4289527,
                34.6091151
              ],
              [
                49.4281196,
                34.6013371
              ],
              [
                49.4283961,
                34.6010573
              ],
              [
                49.4283961,
                34.5943891
              ],
              [
                49.4297859,
                34.5838318
              ],
              [
                49.429786,
                34.5821716
              ],
              [
                49.4297861,
                34.5785531
              ],
              [
                49.4295095,
                34.5760627
              ],
              [
                49.427286,
                34.5610566
              ],
              [
                49.4208961,
                34.5446698
              ],
              [
                49.4203394,
                34.5399504
              ],
              [
                49.4208961,
                34.5371621
              ],
              [
                49.4220063,
                34.5355018
              ],
              [
                49.4222863,
                34.5349424
              ],
              [
                49.4224186,
                34.5346747
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555173,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کمیجان",
          "name:en": "Komijan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1277826",
          "wikipedia": "fa:شهرستان کمیجان"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.1089363,
                34.766616
              ],
              [
                49.1086594,
                34.7663363
              ],
              [
                49.1072695,
                34.7649559
              ],
              [
                49.1072695,
                34.7646762
              ],
              [
                49.1033795,
                34.7555095
              ],
              [
                49.1031031,
                34.7535606
              ],
              [
                49.1028265,
                34.7505111
              ],
              [
                49.1025464,
                34.7377264
              ],
              [
                49.1050462,
                34.7280092
              ],
              [
                49.1056032,
                34.7274497
              ],
              [
                49.1211594,
                34.6996692
              ],
              [
                49.1239361,
                34.6952299
              ],
              [
                49.1244927,
                34.6943908
              ],
              [
                49.1281061,
                34.6860629
              ],
              [
                49.1311593,
                34.676616
              ],
              [
                49.1314394,
                34.6760656
              ],
              [
                49.1314394,
                34.6743963
              ],
              [
                49.1317159,
                34.6741167
              ],
              [
                49.1317159,
                34.6735572
              ],
              [
                49.1317159,
                34.6716173
              ],
              [
                49.1319929,
                34.6693887
              ],
              [
                49.1322729,
                34.6682788
              ],
              [
                49.1325496,
                34.6668893
              ],
              [
                49.1328262,
                34.6652291
              ],
              [
                49.1331063,
                34.6635599
              ],
              [
                49.1333829,
                34.6605011
              ],
              [
                49.1336593,
                34.6599507
              ],
              [
                49.1336594,
                34.6552226
              ],
              [
                49.1350497,
                34.6480043
              ],
              [
                49.1328262,
                34.6366172
              ],
              [
                49.1353263,
                34.629119
              ],
              [
                49.1350497,
                34.6280001
              ],
              [
                49.1347728,
                34.6221712
              ],
              [
                49.1350498,
                34.6205019
              ],
              [
                49.1353263,
                34.6188326
              ],
              [
                49.1356064,
                34.6182732
              ],
              [
                49.1347728,
                34.6135541
              ],
              [
                49.1278262,
                34.6030058
              ],
              [
                49.1203265,
                34.5971678
              ],
              [
                49.120603,
                34.5963286
              ],
              [
                49.1208832,
                34.5946684
              ],
              [
                49.1214362,
                34.5932787
              ],
              [
                49.1308829,
                34.5796715
              ],
              [
                49.1322733,
                34.5727234
              ],
              [
                49.1325498,
                34.5713339
              ],
              [
                49.1328264,
                34.5693938
              ],
              [
                49.1331065,
                34.567165
              ],
              [
                49.1333831,
                34.5657754
              ],
              [
                49.1383832,
                34.5549472
              ],
              [
                49.1386598,
                34.5543877
              ],
              [
                49.147273,
                34.5343824
              ],
              [
                49.1475494,
                34.532722
              ],
              [
                49.1478295,
                34.5324423
              ],
              [
                49.1478295,
                34.5316121
              ],
              [
                49.1483831,
                34.5316121
              ],
              [
                49.1489397,
                34.5313324
              ],
              [
                49.149773,
                34.5313323
              ],
              [
                49.1500495,
                34.5310527
              ],
              [
                49.1511628,
                34.5310526
              ],
              [
                49.1586629,
                34.5291126
              ],
              [
                49.1600494,
                34.5291125
              ],
              [
                49.160606,
                34.5288328
              ],
              [
                49.1714394,
                34.5268928
              ],
              [
                49.1731059,
                34.5268928
              ],
              [
                49.173386,
                34.5266131
              ],
              [
                49.1756059,
                34.526613
              ],
              [
                49.175886,
                34.5268927
              ],
              [
                49.1783861,
                34.5274433
              ],
              [
                49.1817193,
                34.5293923
              ],
              [
                49.1858858,
                34.5324423
              ],
              [
                49.1869959,
                34.5327221
              ],
              [
                49.1875527,
                34.5332815
              ],
              [
                49.193109,
                34.5357811
              ],
              [
                49.1981091,
                34.5357811
              ],
              [
                49.1986622,
                34.5355014
              ],
              [
                49.2006092,
                34.5355014
              ],
              [
                49.2014424,
                34.5352216
              ],
              [
                49.204499,
                34.5352217
              ],
              [
                49.2075522,
                34.5352216
              ],
              [
                49.208109,
                34.5352216
              ],
              [
                49.2089422,
                34.5355014
              ],
              [
                49.2103324,
                34.5355015
              ],
              [
                49.2114422,
                34.5357812
              ],
              [
                49.212832,
                34.5357811
              ],
              [
                49.2147754,
                34.5363407
              ],
              [
                49.2319985,
                34.5385605
              ],
              [
                49.2328321,
                34.5382808
              ],
              [
                49.234222,
                34.5382807
              ],
              [
                49.2528317,
                34.5299429
              ],
              [
                49.2556119,
                34.5296722
              ],
              [
                49.2620015,
                34.5296722
              ],
              [
                49.2631116,
                34.5293925
              ],
              [
                49.2658882,
                34.5293925
              ],
              [
                49.2670015,
                34.5291128
              ],
              [
                49.2761682,
                34.5291128
              ],
              [
                49.2767212,
                34.528833
              ],
              [
                49.279778,
                34.5288331
              ],
              [
                49.2822781,
                34.5288331
              ],
              [
                49.2839444,
                34.5288331
              ],
              [
                49.2842245,
                34.5285533
              ],
              [
                49.2900578,
                34.5285533
              ],
              [
                49.2906115,
                34.5288331
              ],
              [
                49.299501,
                34.5288331
              ],
              [
                49.3006143,
                34.5285533
              ],
              [
                49.3061675,
                34.5285533
              ],
              [
                49.3072809,
                34.5288331
              ],
              [
                49.3092243,
                34.5288331
              ],
              [
                49.3103344,
                34.5291129
              ],
              [
                49.3120009,
                34.5291128
              ],
              [
                49.3131142,
                34.5293925
              ],
              [
                49.3156143,
                34.5293926
              ],
              [
                49.3158908,
                34.5296723
              ],
              [
                49.3270043,
                34.5310529
              ],
              [
                49.3311708,
                34.531053
              ],
              [
                49.332004,
                34.5313326
              ],
              [
                49.3414473,
                34.5313327
              ],
              [
                49.3425605,
                34.5316124
              ],
              [
                49.3453371,
                34.5316125
              ],
              [
                49.3481137,
                34.5321629
              ],
              [
                49.3508939,
                34.5321629
              ],
              [
                49.351447,
                34.5324427
              ],
              [
                49.3533939,
                34.5324427
              ],
              [
                49.3536705,
                34.5327224
              ],
              [
                49.3547837,
                34.5327224
              ],
              [
                49.3564506,
                34.5332819
              ],
              [
                49.3592268,
                34.5335526
              ],
              [
                49.3633937,
                34.5343827
              ],
              [
                49.3728404,
                34.534112
              ],
              [
                49.3750599,
                34.5338323
              ],
              [
                49.3764503,
                34.5338324
              ],
              [
                49.3767268,
                34.5335526
              ],
              [
                49.3842266,
                34.5332818
              ],
              [
                49.3925635,
                34.5335526
              ],
              [
                49.3945065,
                34.5332819
              ],
              [
                49.3950632,
                34.5335527
              ],
              [
                49.4000633,
                34.5335526
              ],
              [
                49.4006164,
                34.5338323
              ],
              [
                49.4020067,
                34.5338324
              ],
              [
                49.4028399,
                34.5335527
              ],
              [
                49.403673,
                34.5338324
              ],
              [
                49.4089497,
                34.5338324
              ],
              [
                49.4095063,
                34.5335526
              ],
              [
                49.4114529,
                34.5335526
              ],
              [
                49.4125631,
                34.5338324
              ],
              [
                49.4158964,
                34.5338324
              ],
              [
                49.4167296,
                34.5341121
              ],
              [
                49.4224186,
                34.5346747
              ],
              [
                49.4222863,
                34.5349424
              ],
              [
                49.4220063,
                34.5355018
              ],
              [
                49.4208961,
                34.5371621
              ],
              [
                49.4203394,
                34.5399504
              ],
              [
                49.4208961,
                34.5446698
              ],
              [
                49.427286,
                34.5610566
              ],
              [
                49.4295095,
                34.5760627
              ],
              [
                49.4297861,
                34.5785531
              ],
              [
                49.429786,
                34.5821716
              ],
              [
                49.4297859,
                34.5838318
              ],
              [
                49.4283961,
                34.5943891
              ],
              [
                49.4283961,
                34.6010573
              ],
              [
                49.4281196,
                34.6013371
              ],
              [
                49.4289527,
                34.6091151
              ],
              [
                49.4339524,
                34.6188331
              ],
              [
                49.434786,
                34.6238319
              ],
              [
                49.4345095,
                34.6243915
              ],
              [
                49.4342293,
                34.6268908
              ],
              [
                49.4339524,
                34.6288399
              ],
              [
                49.4336758,
                34.6305001
              ],
              [
                49.4333957,
                34.6341184
              ],
              [
                49.4333957,
                34.6374479
              ],
              [
                49.4331191,
                34.6379982
              ],
              [
                49.4333957,
                34.6399473
              ],
              [
                49.4353427,
                34.6443956
              ],
              [
                49.4417291,
                34.6491147
              ],
              [
                49.4470088,
                34.6499448
              ],
              [
                49.4481191,
                34.6502245
              ],
              [
                49.4500656,
                34.6502245
              ],
              [
                49.4508991,
                34.6505042
              ],
              [
                49.4536758,
                34.6505042
              ],
              [
                49.4542324,
                34.6507839
              ],
              [
                49.4583989,
                34.6507839
              ],
              [
                49.4639522,
                34.6513343
              ],
              [
                49.4645088,
                34.651614
              ],
              [
                49.4747887,
                34.651614
              ],
              [
                49.4753418,
                34.6516142
              ],
              [
                49.4747887,
                34.6532833
              ],
              [
                49.4675654,
                34.6605017
              ],
              [
                49.467289,
                34.6607814
              ],
              [
                49.4514522,
                34.675227
              ],
              [
                49.4458955,
                34.6782858
              ],
              [
                49.4653111,
                34.7108241
              ],
              [
                49.4653112,
                34.7108242
              ],
              [
                49.4694776,
                34.7178066
              ],
              [
                49.4752275,
                34.7393686
              ],
              [
                49.4709151,
                34.7558995
              ],
              [
                49.460134,
                34.776024
              ],
              [
                49.4608528,
                34.8184293
              ],
              [
                49.4745087,
                34.8493349
              ],
              [
                49.4910396,
                34.8658657
              ],
              [
                49.5080208,
                34.8952998
              ],
              [
                49.5012317,
                34.9097091
              ],
              [
                49.5000777,
                34.9123476
              ],
              [
                49.4997878,
                34.9130045
              ],
              [
                49.4961779,
                34.9149531
              ],
              [
                49.489788,
                34.9257876
              ],
              [
                49.4889544,
                34.9266176
              ],
              [
                49.4883976,
                34.9277363
              ],
              [
                49.4806213,
                34.9352329
              ],
              [
                49.4800646,
                34.9360717
              ],
              [
                49.4789545,
                34.937452
              ],
              [
                49.4731212,
                34.9457875
              ],
              [
                49.4689547,
                34.9480067
              ],
              [
                49.4675647,
                34.9482864
              ],
              [
                49.4645081,
                34.9482863
              ],
              [
                49.4592313,
                34.9477361
              ],
              [
                49.4586748,
                34.9474564
              ],
              [
                49.4545083,
                34.9474564
              ],
              [
                49.4461749,
                34.9466264
              ],
              [
                49.4456183,
                34.9463468
              ],
              [
                49.4445085,
                34.9463468
              ],
              [
                49.4442284,
                34.9460671
              ],
              [
                49.4425615,
                34.9460671
              ],
              [
                49.4420084,
                34.9457875
              ],
              [
                49.4406186,
                34.9457875
              ],
              [
                49.4389517,
                34.9457875
              ],
              [
                49.4353418,
                34.9457875
              ],
              [
                49.4345087,
                34.9460672
              ],
              [
                49.4331184,
                34.9460672
              ],
              [
                49.4325617,
                34.9463468
              ],
              [
                49.4317284,
                34.9463467
              ],
              [
                49.4314519,
                34.9466264
              ],
              [
                49.4306183,
                34.9466264
              ],
              [
                49.4278385,
                34.9480067
              ],
              [
                49.4258952,
                34.9516241
              ],
              [
                49.4258952,
                34.9566218
              ],
              [
                49.4256185,
                34.9571721
              ],
              [
                49.4233951,
                34.9618991
              ],
              [
                49.4203384,
                34.9618991
              ],
              [
                49.4197853,
                34.9616193
              ],
              [
                49.418952,
                34.9616194
              ],
              [
                49.4186719,
                34.9613398
              ],
              [
                49.4183954,
                34.9616194
              ],
              [
                49.4158953,
                34.9607895
              ],
              [
                49.4147851,
                34.9607894
              ],
              [
                49.4145054,
                34.9605098
              ],
              [
                49.4136718,
                34.9605098
              ],
              [
                49.4125621,
                34.9599595
              ],
              [
                49.4089486,
                34.9591205
              ],
              [
                49.4078385,
                34.9582906
              ],
              [
                49.4078385,
                34.958011
              ],
              [
                49.4075619,
                34.9574517
              ],
              [
                49.4072818,
                34.9560714
              ],
              [
                49.4022821,
                34.9502348
              ],
              [
                49.3995055,
                34.9488455
              ],
              [
                49.3986724,
                34.9488456
              ],
              [
                49.3967289,
                34.9480066
              ],
              [
                49.3889491,
                34.9452281
              ],
              [
                49.3883924,
                34.9432885
              ],
              [
                49.3886725,
                34.9416197
              ],
              [
                49.3889491,
                34.9407897
              ],
              [
                49.3892257,
                34.9396801
              ],
              [
                49.3895057,
                34.9385705
              ],
              [
                49.3897824,
                34.9374519
              ],
              [
                49.3903389,
                34.9352327
              ],
              [
                49.3906156,
                34.9338434
              ],
              [
                49.3908957,
                34.9335637
              ],
              [
                49.3911723,
                34.9316242
              ],
              [
                49.3914488,
                34.9302349
              ],
              [
                49.3917288,
                34.9291163
              ],
              [
                49.3920058,
                34.9274564
              ],
              [
                49.3922824,
                34.9268971
              ],
              [
                49.3920059,
                34.9260672
              ],
              [
                49.3897823,
                34.9174518
              ],
              [
                49.3881155,
                34.9152326
              ],
              [
                49.3833925,
                34.9132839
              ],
              [
                49.3825592,
                34.9132839
              ],
              [
                49.3822826,
                34.9130043
              ],
              [
                49.3778392,
                34.9119037
              ],
              [
                49.3758927,
                34.9119037
              ],
              [
                49.3753391,
                34.911624
              ],
              [
                49.3714492,
                34.911624
              ],
              [
                49.3711691,
                34.9119036
              ],
              [
                49.3695027,
                34.9119037
              ],
              [
                49.3678358,
                34.912454
              ],
              [
                49.3658928,
                34.9127337
              ],
              [
                49.3583927,
                34.9144026
              ],
              [
                49.3567263,
                34.9144026
              ],
              [
                49.3558926,
                34.9146823
              ],
              [
                49.349503,
                34.9157828
              ],
              [
                49.3478362,
                34.9157828
              ],
              [
                49.347003,
                34.9160625
              ],
              [
                49.3442264,
                34.9160624
              ],
              [
                49.3433932,
                34.9163421
              ],
              [
                49.3408931,
                34.9163421
              ],
              [
                49.3400594,
                34.9166218
              ],
              [
                49.338393,
                34.9166217
              ],
              [
                49.3378364,
                34.9163422
              ],
              [
                49.331723,
                34.916342
              ],
              [
                49.3311698,
                34.9160624
              ],
              [
                49.3289463,
                34.9160625
              ],
              [
                49.3278365,
                34.9155121
              ],
              [
                49.3264462,
                34.9155122
              ],
              [
                49.3258896,
                34.9152324
              ],
              [
                49.3247799,
                34.9152325
              ],
              [
                49.3242232,
                34.9149528
              ],
              [
                49.3211701,
                34.9144025
              ],
              [
                49.3183899,
                34.9144025
              ],
              [
                49.3175567,
                34.9141229
              ],
              [
                49.3158899,
                34.9141228
              ],
              [
                49.3156133,
                34.9138432
              ],
              [
                49.3142235,
                34.9138432
              ],
              [
                49.3139469,
                34.9135636
              ],
              [
                49.3125566,
                34.9135635
              ],
              [
                49.3070003,
                34.912454
              ],
              [
                49.3061666,
                34.9124539
              ],
              [
                49.3056135,
                34.9124539
              ],
              [
                49.3045002,
                34.9119035
              ],
              [
                49.3036666,
                34.9119035
              ],
              [
                49.2981137,
                34.9093956
              ],
              [
                49.2968225,
                34.9089059
              ],
              [
                49.2933902,
                34.907456
              ],
              [
                49.2931101,
                34.9068967
              ],
              [
                49.2925569,
                34.906617
              ],
              [
                49.2736672,
                34.891064
              ],
              [
                49.2731105,
                34.8907844
              ],
              [
                49.2717207,
                34.8902341
              ],
              [
                49.270887,
                34.8902341
              ],
              [
                49.2706105,
                34.8899545
              ],
              [
                49.2697772,
                34.8899544
              ],
              [
                49.2686675,
                34.8893952
              ],
              [
                49.2681104,
                34.8893951
              ],
              [
                49.2675538,
                34.889395
              ],
              [
                49.2542206,
                34.8846768
              ],
              [
                49.2531109,
                34.8838469
              ],
              [
                49.2347742,
                34.8638369
              ],
              [
                49.2333879,
                34.8616266
              ],
              [
                49.2333879,
                34.8613469
              ],
              [
                49.229498,
                34.8530109
              ],
              [
                49.2256077,
                34.8505119
              ],
              [
                49.2186646,
                34.8466235
              ],
              [
                49.2183844,
                34.8460641
              ],
              [
                49.2117179,
                34.8421758
              ],
              [
                49.209498,
                34.8421757
              ],
              [
                49.2067182,
                34.8438357
              ],
              [
                49.2058846,
                34.8460641
              ],
              [
                49.205608,
                34.8471738
              ],
              [
                49.2050514,
                34.8480038
              ],
              [
                49.2050514,
                34.8482834
              ],
              [
                49.2044983,
                34.8513419
              ],
              [
                49.2042181,
                34.8530109
              ],
              [
                49.2025513,
                34.8577292
              ],
              [
                49.2017181,
                34.8585683
              ],
              [
                49.1964414,
                34.8613469
              ],
              [
                49.1956083,
                34.8613468
              ],
              [
                49.1928281,
                34.8621769
              ],
              [
                49.1917183,
                34.8621769
              ],
              [
                49.1808852,
                34.8646759
              ],
              [
                49.1789383,
                34.8657855
              ],
              [
                49.1786617,
                34.8657855
              ],
              [
                49.1778285,
                34.8655149
              ],
              [
                49.1750519,
                34.8663448
              ],
              [
                49.1697717,
                34.8663448
              ],
              [
                49.1692186,
                34.8660651
              ],
              [
                49.1681052,
                34.8660652
              ],
              [
                49.1631052,
                34.8607875
              ],
              [
                49.1628287,
                34.8588388
              ],
              [
                49.1636618,
                34.8566195
              ],
              [
                49.1681053,
                34.8494021
              ],
              [
                49.1678287,
                34.8491224
              ],
              [
                49.1672721,
                34.8468941
              ],
              [
                49.1639385,
                34.841896
              ],
              [
                49.1619955,
                34.8391172
              ],
              [
                49.1586622,
                34.8327298
              ],
              [
                49.1586622,
                34.8318998
              ],
              [
                49.1575488,
                34.8285617
              ],
              [
                49.1544954,
                34.8066203
              ],
              [
                49.1492156,
                34.7971742
              ],
              [
                49.1425491,
                34.7910662
              ],
              [
                49.1392158,
                34.788558
              ],
              [
                49.1153259,
                34.772733
              ],
              [
                49.1089363,
                34.766616
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555199,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان محلات",
          "name:en": "Mahallat County",
          "place": "county",
          "type": "boundary",
          "wikipedia": "fa:شهرستان محلات"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                50.155655,
                33.9379899
              ],
              [
                50.155655,
                33.9352098
              ],
              [
                50.1559319,
                33.9335399
              ],
              [
                50.1562085,
                33.9332601
              ],
              [
                50.1550983,
                33.9299293
              ],
              [
                50.1525986,
                33.9263186
              ],
              [
                50.1523217,
                33.9235475
              ],
              [
                50.1548219,
                33.9202077
              ],
              [
                50.1545417,
                33.9182669
              ],
              [
                50.1520417,
                33.9079855
              ],
              [
                50.1523218,
                33.9063246
              ],
              [
                50.1525988,
                33.9049345
              ],
              [
                50.1537085,
                33.9024341
              ],
              [
                50.1553753,
                33.9002045
              ],
              [
                50.1567652,
                33.8982638
              ],
              [
                50.1567652,
                33.8974243
              ],
              [
                50.1570418,
                33.8971535
              ],
              [
                50.1609317,
                33.893263
              ],
              [
                50.1612083,
                33.8927124
              ],
              [
                50.1698218,
                33.8729889
              ],
              [
                50.1700984,
                33.8721493
              ],
              [
                50.1703785,
                33.8718696
              ],
              [
                50.1703785,
                33.8713189
              ],
              [
                50.1839882,
                33.8560455
              ],
              [
                50.1867683,
                33.8527056
              ],
              [
                50.2153779,
                33.8263199
              ],
              [
                50.2198246,
                33.8182678
              ],
              [
                50.2198245,
                33.8179879
              ],
              [
                50.2209347,
                33.8160381
              ],
              [
                50.2214914,
                33.8152076
              ],
              [
                50.2270477,
                33.8024344
              ],
              [
                50.2331577,
                33.7960432
              ],
              [
                50.2401043,
                33.7907624
              ],
              [
                50.2451044,
                33.7854815
              ],
              [
                50.2464911,
                33.7838206
              ],
              [
                50.2720472,
                33.7488131
              ],
              [
                50.273994,
                33.7463216
              ],
              [
                50.2751039,
                33.7449224
              ],
              [
                50.2942703,
                33.7285378
              ],
              [
                50.294827,
                33.7282579
              ],
              [
                50.2986297,
                33.7258454
              ],
              [
                50.2989939,
                33.7254776
              ],
              [
                50.3028838,
                33.7235366
              ],
              [
                50.303717,
                33.7235366
              ],
              [
                50.3042737,
                33.7232568
              ],
              [
                50.3053838,
                33.722986
              ],
              [
                50.3392732,
                33.7260373
              ],
              [
                50.3398298,
                33.7257574
              ],
              [
                50.3439963,
                33.7257574
              ],
              [
                50.3445533,
                33.7254777
              ],
              [
                50.3459397,
                33.7249269
              ],
              [
                50.3464964,
                33.724647
              ],
              [
                50.3517731,
                33.7196459
              ],
              [
                50.353443,
                33.7196459
              ],
              [
                50.3539965,
                33.7199258
              ],
              [
                50.355663,
                33.7199258
              ],
              [
                50.3562196,
                33.7202056
              ],
              [
                50.3578865,
                33.7202056
              ],
              [
                50.3584431,
                33.7204855
              ],
              [
                50.3603862,
                33.7204854
              ],
              [
                50.3609431,
                33.7207653
              ],
              [
                50.3617764,
                33.7207653
              ],
              [
                50.3623296,
                33.7204855
              ],
              [
                50.3639964,
                33.7204855
              ],
              [
                50.3642765,
                33.7202057
              ],
              [
                50.3648296,
                33.7202057
              ],
              [
                50.3729453,
                33.7157796
              ],
              [
                50.3739996,
                33.7152045
              ],
              [
                50.3742762,
                33.7146448
              ],
              [
                50.3767759,
                33.7127039
              ],
              [
                50.3798327,
                33.7127039
              ],
              [
                50.3803861,
                33.712424
              ],
              [
                50.3814994,
                33.7124241
              ],
              [
                50.3828862,
                33.7129838
              ],
              [
                50.3837194,
                33.7129837
              ],
              [
                50.3862195,
                33.7132636
              ],
              [
                50.3898324,
                33.7132636
              ],
              [
                50.3928891,
                33.7121533
              ],
              [
                50.3934427,
                33.7115936
              ],
              [
                50.394556,
                33.7110429
              ],
              [
                50.429002,
                33.6793747
              ],
              [
                50.4303888,
                33.6777045
              ],
              [
                50.4459454,
                33.658819
              ],
              [
                50.446502,
                33.6571489
              ],
              [
                50.4467787,
                33.6563093
              ],
              [
                50.4470552,
                33.6560385
              ],
              [
                50.4498354,
                33.6449256
              ],
              [
                50.4498353,
                33.6446457
              ],
              [
                50.450392,
                33.6432554
              ],
              [
                50.4506686,
                33.6424249
              ],
              [
                50.4512252,
                33.6415944
              ],
              [
                50.4540018,
                33.6346521
              ],
              [
                50.4540018,
                33.6343633
              ],
              [
                50.455112,
                33.6335417
              ],
              [
                50.4556687,
                33.6335417
              ],
              [
                50.4559452,
                33.6332528
              ],
              [
                50.4573351,
                33.6332528
              ],
              [
                50.4598352,
                33.6327021
              ],
              [
                50.4642786,
                33.6318717
              ],
              [
                50.4656685,
                33.6313119
              ],
              [
                50.4667817,
                33.6313119
              ],
              [
                50.4673349,
                33.631032
              ],
              [
                50.4687252,
                33.631032
              ],
              [
                50.4695584,
                33.6313119
              ],
              [
                50.4737248,
                33.6313119
              ],
              [
                50.4837246,
                33.6343632
              ],
              [
                50.5126144,
                33.6360335
              ],
              [
                50.5251177,
                33.6340925
              ],
              [
                50.5256709,
                33.6338126
              ],
              [
                50.5267846,
                33.6338126
              ],
              [
                50.528171,
                33.633253
              ],
              [
                50.5292842,
                33.6332529
              ],
              [
                50.5376175,
                33.6304815
              ],
              [
                50.5428943,
                33.6299308
              ],
              [
                50.5587274,
                33.6282606
              ],
              [
                50.5601172,
                33.6279807
              ],
              [
                50.5612306,
                33.6282607
              ],
              [
                50.5631739,
                33.6282607
              ],
              [
                50.5742836,
                33.6307614
              ],
              [
                50.5748403,
                33.631312
              ],
              [
                50.5756738,
                33.6315919
              ],
              [
                50.5776168,
                33.6340925
              ],
              [
                50.5778969,
                33.6363134
              ],
              [
                50.5776168,
                33.6365932
              ],
              [
                50.5798402,
                33.6435355
              ],
              [
                50.5831736,
                33.6460362
              ],
              [
                50.5867868,
                33.6535381
              ],
              [
                50.586787,
                33.6538179
              ],
              [
                50.5870635,
                33.6540887
              ],
              [
                50.5873409,
                33.6543677
              ],
              [
                50.5876201,
                33.6546484
              ],
              [
                50.5881736,
                33.6549283
              ],
              [
                50.5934535,
                33.6604803
              ],
              [
                50.5956733,
                33.6621504
              ],
              [
                50.6070631,
                33.6685419
              ],
              [
                50.6084534,
                33.6690925
              ],
              [
                50.6095631,
                33.6699231
              ],
              [
                50.61151,
                33.6707627
              ],
              [
                50.6128964,
                33.671873
              ],
              [
                50.6290095,
                33.6796457
              ],
              [
                50.6426227,
                33.6896482
              ],
              [
                50.6465095,
                33.691869
              ],
              [
                50.6556757,
                33.6957598
              ],
              [
                50.6595661,
                33.6965903
              ],
              [
                50.6904021,
                33.7207657
              ],
              [
                50.7006785,
                33.7263176
              ],
              [
                50.7040117,
                33.7271481
              ],
              [
                50.7156818,
                33.7265975
              ],
              [
                50.7187351,
                33.7277078
              ],
              [
                50.7242917,
                33.7277079
              ],
              [
                50.7292916,
                33.7263176
              ],
              [
                50.7304016,
                33.7263176
              ],
              [
                50.7337381,
                33.7252073
              ],
              [
                50.7351249,
                33.7252073
              ],
              [
                50.7370715,
                33.7246476
              ],
              [
                50.7379048,
                33.7246476
              ],
              [
                50.7381815,
                33.7243677
              ],
              [
                50.7420715,
                33.7243677
              ],
              [
                50.7442913,
                33.7240969
              ],
              [
                50.7445714,
                33.7238171
              ],
              [
                50.7520714,
                33.7238171
              ],
              [
                50.752628,
                33.7235372
              ],
              [
                50.7540145,
                33.7235373
              ],
              [
                50.7548479,
                33.7232574
              ],
              [
                50.7584613,
                33.7240969
              ],
              [
                50.7571071,
                33.727937
              ],
              [
                50.7556812,
                33.7338194
              ],
              [
                50.7520713,
                33.7402016
              ],
              [
                50.7523479,
                33.7424224
              ],
              [
                50.7581812,
                33.7493734
              ],
              [
                50.7604045,
                33.7540947
              ],
              [
                50.7595712,
                33.756875
              ],
              [
                50.7590144,
                33.7596464
              ],
              [
                50.7590144,
                33.7604859
              ],
              [
                50.7576278,
                33.7629864
              ],
              [
                50.7570712,
                33.763817
              ],
              [
                50.7387381,
                33.787432
              ],
              [
                50.7387382,
                33.7879827
              ],
              [
                50.7365146,
                33.7902034
              ],
              [
                50.7362381,
                33.7910429
              ],
              [
                50.7340147,
                33.7932635
              ],
              [
                50.7312347,
                33.7971543
              ],
              [
                50.7181816,
                33.8293716
              ],
              [
                50.7179015,
                33.8302112
              ],
              [
                50.7179015,
                33.8310416
              ],
              [
                50.7173483,
                33.8327026
              ],
              [
                50.7173482,
                33.8399332
              ],
              [
                50.7181816,
                33.841874
              ],
              [
                50.7187349,
                33.8440946
              ],
              [
                50.7176249,
                33.8465951
              ],
              [
                50.6934586,
                33.8816011
              ],
              [
                50.6906784,
                33.8854826
              ],
              [
                50.6870686,
                33.8918736
              ],
              [
                50.6862353,
                33.8929929
              ],
              [
                50.6709553,
                33.9171573
              ],
              [
                50.6687319,
                33.9218782
              ],
              [
                50.6581788,
                33.93438
              ],
              [
                50.6456754,
                33.9410416
              ],
              [
                50.6448422,
                33.9410417
              ],
              [
                50.6442891,
                33.9413214
              ],
              [
                50.6437325,
                33.9413215
              ],
              [
                50.6434555,
                33.9416013
              ],
              [
                50.6409558,
                33.9416013
              ],
              [
                50.6403992,
                33.9418811
              ],
              [
                50.6390089,
                33.9418811
              ],
              [
                50.6337326,
                33.9429913
              ],
              [
                50.6331756,
                33.9432711
              ],
              [
                50.6317857,
                33.943542
              ],
              [
                50.622066,
                33.9504833
              ],
              [
                50.6162291,
                33.9591036
              ],
              [
                50.6155323,
                33.9598709
              ],
              [
                50.5953962,
                33.9913189
              ],
              [
                50.5862296,
                33.9996592
              ],
              [
                50.5820632,
                34.0054901
              ],
              [
                50.5806728,
                34.007151
              ],
              [
                50.5803963,
                34.0077106
              ],
              [
                50.5753965,
                34.0102109
              ],
              [
                50.5656733,
                34.0179915
              ],
              [
                50.5556731,
                34.0221526
              ],
              [
                50.5495601,
                34.0221525
              ],
              [
                50.5448401,
                34.0204917
              ],
              [
                50.5437268,
                34.0196523
              ],
              [
                50.5434501,
                34.0191017
              ],
              [
                50.5431736,
                34.0188219
              ],
              [
                50.5431736,
                34.0191017
              ],
              [
                50.5428106,
                34.019549
              ],
              [
                50.5403934,
                34.0229919
              ],
              [
                50.5398368,
                34.0235426
              ],
              [
                50.5398368,
                34.0238224
              ],
              [
                50.5367836,
                34.0274328
              ],
              [
                50.5365035,
                34.0293736
              ],
              [
                50.5415033,
                34.0349336
              ],
              [
                50.5573399,
                34.0424343
              ],
              [
                50.5584497,
                34.0482652
              ],
              [
                50.5581731,
                34.0488249
              ],
              [
                50.557893,
                34.0504946
              ],
              [
                50.557893,
                34.0515958
              ],
              [
                50.5573399,
                34.0535455
              ],
              [
                50.5570598,
                34.0546557
              ],
              [
                50.5528932,
                34.0713268
              ],
              [
                50.5526167,
                34.0716065
              ],
              [
                50.5517831,
                34.075217
              ],
              [
                50.5381698,
                34.105219
              ],
              [
                50.53706,
                34.1071596
              ],
              [
                50.5242836,
                34.1279911
              ],
              [
                50.5234504,
                34.1296609
              ],
              [
                50.5178936,
                34.1338217
              ],
              [
                50.4945572,
                34.1402209
              ],
              [
                50.4923372,
                34.1407715
              ],
              [
                50.4751142,
                34.142712
              ],
              [
                50.4745575,
                34.1429918
              ],
              [
                50.4720575,
                34.1429918
              ],
              [
                50.459001,
                34.1446525
              ],
              [
                50.4576108,
                34.1449414
              ],
              [
                50.4531677,
                34.1449413
              ],
              [
                50.4517778,
                34.1452211
              ],
              [
                50.441778,
                34.1452211
              ],
              [
                50.4253881,
                34.1488223
              ],
              [
                50.424278,
                34.1493819
              ],
              [
                50.4156649,
                34.1513315
              ],
              [
                50.4012217,
                34.1527123
              ],
              [
                50.4001083,
                34.1529922
              ],
              [
                50.3989982,
                34.1529921
              ],
              [
                50.3984416,
                34.1532719
              ],
              [
                50.3953883,
                34.1535517
              ],
              [
                50.3828853,
                34.1535516
              ],
              [
                50.3742754,
                34.1538225
              ],
              [
                50.3612189,
                34.1524415
              ],
              [
                50.3598286,
                34.1521618
              ],
              [
                50.357329,
                34.1521617
              ],
              [
                50.3562188,
                34.1518819
              ],
              [
                50.342329,
                34.1518819
              ],
              [
                50.316216,
                34.1527122
              ],
              [
                50.3114929,
                34.1524414
              ],
              [
                50.3106592,
                34.1527122
              ],
              [
                50.3103828,
                34.1527122
              ],
              [
                50.3095495,
                34.1524414
              ],
              [
                50.3012161,
                34.1449411
              ],
              [
                50.3009396,
                34.1421612
              ],
              [
                50.3034397,
                34.1352205
              ],
              [
                50.3039928,
                34.1349406
              ],
              [
                50.3084394,
                34.1260503
              ],
              [
                50.3087163,
                34.1257705
              ],
              [
                50.3084394,
                34.1227108
              ],
              [
                50.3084394,
                34.1213299
              ],
              [
                50.3081597,
                34.1204905
              ],
              [
                50.3070495,
                34.1168801
              ],
              [
                50.3014928,
                34.1082695
              ],
              [
                50.2826034,
                34.0796573
              ],
              [
                50.2798268,
                34.0702162
              ],
              [
                50.2795498,
                34.0682665
              ],
              [
                50.2792701,
                34.067716
              ],
              [
                50.2728802,
                34.0416035
              ],
              [
                50.264827,
                34.0285427
              ],
              [
                50.2531571,
                34.0202115
              ],
              [
                50.2487137,
                34.0193811
              ],
              [
                50.2445473,
                34.0171516
              ],
              [
                50.241214,
                34.0157706
              ],
              [
                50.2270473,
                34.0099306
              ],
              [
                50.2267673,
                34.00938
              ],
              [
                50.2245476,
                34.0060493
              ],
              [
                50.2242675,
                34.00493
              ],
              [
                50.2217675,
                34.0003447
              ],
              [
                50.2206573,
                33.9990991
              ],
              [
                50.2192675,
                33.9963279
              ],
              [
                50.217324,
                33.988818
              ],
              [
                50.2170445,
                33.9882675
              ],
              [
                50.2134342,
                33.9846569
              ],
              [
                50.2123244,
                33.984377
              ],
              [
                50.2109346,
                33.9835466
              ],
              [
                50.2095443,
                33.9835467
              ],
              [
                50.2089911,
                33.9832669
              ],
              [
                50.2070442,
                33.9832668
              ],
              [
                50.2067676,
                33.9829869
              ],
              [
                50.2001011,
                33.9829869
              ],
              [
                50.1995445,
                33.9827072
              ],
              [
                50.1981546,
                33.9827072
              ],
              [
                50.197878,
                33.9824274
              ],
              [
                50.1945444,
                33.981597
              ],
              [
                50.1939877,
                33.9815969
              ],
              [
                50.1937111,
                33.9813261
              ],
              [
                50.1862114,
                33.9782661
              ],
              [
                50.1731549,
                33.9677053
              ],
              [
                50.1639862,
                33.9649331
              ],
              [
                50.1634317,
                33.9646543
              ],
              [
                50.1628749,
                33.9643835
              ],
              [
                50.162875,
                33.9640947
              ],
              [
                50.1567651,
                33.9549328
              ],
              [
                50.1553753,
                33.9454911
              ],
              [
                50.1556549,
                33.9432706
              ],
              [
                50.155932,
                33.9429907
              ],
              [
                50.155655,
                33.9379899
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821009013
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.4070049,
          33.9293155
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 403875292
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.0801376,
          33.6446965
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821045213
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.1840004,
          34.3933112
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821045221
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.3219622,
          34.7207822
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4698589016
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.6893884,
          34.0862719
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821045216
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          49.6842027,
          34.5044405
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821009075
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.0018687,
          34.5216784
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821009031
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.0146963,
          34.6927402
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4032601918
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.4526427,
          33.9060573
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 415878485
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.6862901,
          33.9880486
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 32637964
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.3652364,
          35.0196331
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 821045214
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          50.5073612,
          35.3011297
        ]
      }
    }
  ]
},
"هرمزگان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554869,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ابوموسی",
          "name:en": "Abumusa County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1280077",
          "wikipedia": "en:Abumusa County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.9642391,
                26.2946269
              ],
              [
                54.2235447,
                26.0576023
              ],
              [
                54.2297691,
                26.0410041
              ],
              [
                54.2375385,
                26.0250214
              ],
              [
                54.2468543,
                26.0096503
              ],
              [
                54.2575724,
                25.9951275
              ],
              [
                54.2696951,
                25.9814492
              ],
              [
                54.275906,
                25.9467903
              ],
              [
                54.2729859,
                25.8995289
              ],
              [
                54.2778793,
                25.8768174
              ],
              [
                54.2860221,
                25.8528901
              ],
              [
                54.296753,
                25.8296844
              ],
              [
                54.3101781,
                25.8076861
              ],
              [
                54.3260118,
                25.7870329
              ],
              [
                54.3441077,
                25.7679515
              ],
              [
                54.3642839,
                25.7506226
              ],
              [
                54.3863527,
                25.735296
              ],
              [
                54.4100443,
                25.7220685
              ],
              [
                54.4351214,
                25.7111078
              ],
              [
                54.4613158,
                25.7025255
              ],
              [
                54.4708746,
                25.700382
              ],
              [
                54.4883627,
                25.6965272
              ],
              [
                54.5159429,
                25.6928202
              ],
              [
                54.5436524,
                25.6918282
              ],
              [
                54.5716023,
                25.6934357
              ],
              [
                54.58534,
                25.6955214
              ],
              [
                54.5990909,
                25.6975881
              ],
              [
                54.6190637,
                25.7026044
              ],
              [
                54.6258258,
                25.7042635
              ],
              [
                54.6519252,
                25.7134028
              ],
              [
                54.6767096,
                25.7248928
              ],
              [
                54.7000503,
                25.7386164
              ],
              [
                54.7217009,
                25.7544272
              ],
              [
                54.7414318,
                25.7721568
              ],
              [
                54.7590341,
                25.7916165
              ],
              [
                54.7743209,
                25.8125993
              ],
              [
                54.7871304,
                25.8348818
              ],
              [
                54.7973266,
                25.8582273
              ],
              [
                54.8048017,
                25.8823877
              ],
              [
                54.8087095,
                25.8996273
              ],
              [
                54.8076138,
                25.8774522
              ],
              [
                54.8091753,
                25.8552956
              ],
              [
                54.8133758,
                25.8334146
              ],
              [
                54.8201666,
                25.812063
              ],
              [
                54.829469,
                25.7914891
              ],
              [
                54.841175,
                25.7719318
              ],
              [
                54.855149,
                25.7536187
              ],
              [
                54.8712287,
                25.7367627
              ],
              [
                54.8957331,
                25.7157681
              ],
              [
                54.9239689,
                25.6989095
              ],
              [
                54.954653,
                25.6859813
              ],
              [
                54.9871159,
                25.6772667
              ],
              [
                55.0206491,
                25.6729569
              ],
              [
                55.0545208,
                25.6731464
              ],
              [
                55.0879921,
                25.677831
              ],
              [
                55.1203324,
                25.6869081
              ],
              [
                55.150836,
                25.7001786
              ],
              [
                55.1788374,
                25.7173514
              ],
              [
                55.2037254,
                25.7380504
              ],
              [
                55.224957,
                25.761822
              ],
              [
                55.2420689,
                25.788146
              ],
              [
                55.2546876,
                25.8164463
              ],
              [
                55.2625378,
                25.8461041
              ],
              [
                55.2654482,
                25.8764716
              ],
              [
                55.2637304,
                25.9069312
              ],
              [
                55.2591225,
                25.9287322
              ],
              [
                55.2519346,
                25.9499572
              ],
              [
                55.2422501,
                25.9703603
              ],
              [
                55.2301812,
                25.9897054
              ],
              [
                55.215868,
                26.0077687
              ],
              [
                55.1994765,
                26.0243412
              ],
              [
                55.1811969,
                26.0392315
              ],
              [
                55.1788651,
                26.0409943
              ],
              [
                55.1612411,
                26.0522674
              ],
              [
                55.1504174,
                26.0578601
              ],
              [
                55.1519953,
                26.0576683
              ],
              [
                55.18293,
                26.0587404
              ],
              [
                55.2132042,
                26.0645704
              ],
              [
                55.2276063,
                26.0697747
              ],
              [
                55.2305856,
                26.070854
              ],
              [
                55.2305889,
                26.0708541
              ],
              [
                55.2364483,
                26.0687437
              ],
              [
                55.262387,
                26.0617678
              ],
              [
                55.2890603,
                26.0575868
              ],
              [
                55.3160963,
                26.0562592
              ],
              [
                55.3431179,
                26.0578037
              ],
              [
                55.3697486,
                26.0621986
              ],
              [
                55.3956169,
                26.0693824
              ],
              [
                55.4203623,
                26.0792544
              ],
              [
                55.452337,
                26.0972343
              ],
              [
                55.4805966,
                26.1196753
              ],
              [
                55.5043764,
                26.1459677
              ],
              [
                55.5183109,
                26.1668057
              ],
              [
                55.5294118,
                26.1889687
              ],
              [
                55.5375243,
                26.2121469
              ],
              [
                55.5425355,
                26.2360167
              ],
              [
                55.5443754,
                26.260245
              ],
              [
                55.5430183,
                26.2844938
              ],
              [
                55.5430188,
                26.2844948
              ],
              [
                55.5308334,
                26.3317057
              ],
              [
                55.5201754,
                26.3540114
              ],
              [
                55.5066579,
                26.3750319
              ],
              [
                55.4904693,
                26.3944748
              ],
              [
                55.4718353,
                26.41207
              ],
              [
                55.4510157,
                26.427573
              ],
              [
                55.4283008,
                26.4407686
              ],
              [
                55.4040073,
                26.4514737
              ],
              [
                55.3784738,
                26.4595396
              ],
              [
                55.3520564,
                26.4648545
              ],
              [
                55.3251234,
                26.4673448
              ],
              [
                55.2980502,
                26.4669757
              ],
              [
                55.2712144,
                26.4637526
              ],
              [
                55.2484746,
                26.4585216
              ],
              [
                55.1235637,
                26.617585
              ],
              [
                55.0215905,
                26.5449234
              ],
              [
                54.9459973,
                26.4825395
              ],
              [
                54.8272691,
                26.3844897
              ],
              [
                54.625396,
                26.4133961
              ],
              [
                54.4152805,
                26.4213922
              ],
              [
                54.2611577,
                26.3780916
              ],
              [
                54.1137475,
                26.3366617
              ],
              [
                53.9642391,
                26.2946269
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554931,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بستک",
          "name:en": "Bastak County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q3924526",
          "wikipedia": "en:Bastak County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.8218329,
                27.0147479
              ],
              [
                53.8223896,
                27.0144692
              ],
              [
                53.8344961,
                27.0054692
              ],
              [
                53.882832,
                26.9749031
              ],
              [
                53.8878319,
                26.971568
              ],
              [
                53.8881085,
                26.9712893
              ],
              [
                53.8886652,
                26.9710106
              ],
              [
                53.9086649,
                26.9637919
              ],
              [
                53.9103315,
                26.9635133
              ],
              [
                53.9156115,
                26.9621289
              ],
              [
                53.9678339,
                26.9476828
              ],
              [
                53.9695006,
                26.9476827
              ],
              [
                53.9725572,
                26.9471253
              ],
              [
                53.9808904,
                26.9471254
              ],
              [
                53.9814471,
                26.9474041
              ],
              [
                53.9831138,
                26.947404
              ],
              [
                53.983947,
                26.9476827
              ],
              [
                53.9847803,
                26.9476828
              ],
              [
                53.98844,
                26.9488264
              ],
              [
                53.9956135,
                26.9493457
              ],
              [
                54.0031134,
                26.9476827
              ],
              [
                54.0036701,
                26.9474042
              ],
              [
                54.0047801,
                26.9474041
              ],
              [
                54.0064466,
                26.9468467
              ],
              [
                54.0070033,
                26.9468467
              ],
              [
                54.0072799,
                26.946568
              ],
              [
                54.0081132,
                26.9465681
              ],
              [
                54.0083933,
                26.9462893
              ],
              [
                54.0106133,
                26.9462894
              ],
              [
                54.0120033,
                26.9457321
              ],
              [
                54.0131132,
                26.945732
              ],
              [
                54.0139465,
                26.9454533
              ],
              [
                54.0276962,
                26.9423928
              ],
              [
                54.0285295,
                26.9421141
              ],
              [
                54.0299195,
                26.9421141
              ],
              [
                54.0307529,
                26.9418355
              ],
              [
                54.0340862,
                26.9418355
              ],
              [
                54.0407527,
                26.9412871
              ],
              [
                54.0435293,
                26.9404511
              ],
              [
                54.0457526,
                26.9404511
              ],
              [
                54.0463093,
                26.9401724
              ],
              [
                54.0490858,
                26.9401724
              ],
              [
                54.0504759,
                26.9398938
              ],
              [
                54.0524191,
                26.9398937
              ],
              [
                54.0538092,
                26.9396151
              ],
              [
                54.0554757,
                26.9396151
              ],
              [
                54.0560325,
                26.9393363
              ],
              [
                54.0588091,
                26.9393363
              ],
              [
                54.0596424,
                26.9390577
              ],
              [
                54.0654756,
                26.9390577
              ],
              [
                54.0663089,
                26.9387791
              ],
              [
                54.0693655,
                26.938779
              ],
              [
                54.0704755,
                26.9385003
              ],
              [
                54.0721421,
                26.9385003
              ],
              [
                54.0732555,
                26.9382217
              ],
              [
                54.0746421,
                26.9382217
              ],
              [
                54.0757555,
                26.937943
              ],
              [
                54.0776987,
                26.937943
              ],
              [
                54.0788087,
                26.9376733
              ],
              [
                54.0818654,
                26.9376734
              ],
              [
                54.0832553,
                26.9373946
              ],
              [
                54.0863085,
                26.9373946
              ],
              [
                54.0876985,
                26.9371159
              ],
              [
                54.0899218,
                26.937116
              ],
              [
                54.1082549,
                26.9343382
              ],
              [
                54.1096449,
                26.9343382
              ],
              [
                54.1202014,
                26.9321178
              ],
              [
                54.1213113,
                26.9321178
              ],
              [
                54.1227014,
                26.9315605
              ],
              [
                54.1235347,
                26.9315605
              ],
              [
                54.124368,
                26.9312817
              ],
              [
                54.1396444,
                26.928504
              ],
              [
                54.1402011,
                26.9282254
              ],
              [
                54.1407578,
                26.9282255
              ],
              [
                54.1410344,
                26.9279466
              ],
              [
                54.1415911,
                26.9279467
              ],
              [
                54.1443676,
                26.9273895
              ],
              [
                54.1460343,
                26.9273894
              ],
              [
                54.1474243,
                26.9271196
              ],
              [
                54.1496477,
                26.9271197
              ],
              [
                54.1532575,
                26.9265624
              ],
              [
                54.1546475,
                26.9265624
              ],
              [
                54.1563142,
                26.9260049
              ],
              [
                54.1577007,
                26.926005
              ],
              [
                54.1602007,
                26.9254477
              ],
              [
                54.161034,
                26.9254477
              ],
              [
                54.1654807,
                26.923506
              ],
              [
                54.166314,
                26.923506
              ],
              [
                54.1799238,
                26.9179505
              ],
              [
                54.2077033,
                26.9115594
              ],
              [
                54.2085366,
                26.9115593
              ],
              [
                54.20965,
                26.911002
              ],
              [
                54.2179832,
                26.9096087
              ],
              [
                54.2193698,
                26.9096087
              ],
              [
                54.221593,
                26.9090513
              ],
              [
                54.2232597,
                26.9090513
              ],
              [
                54.2246497,
                26.9087727
              ],
              [
                54.226593,
                26.9087727
              ],
              [
                54.2302063,
                26.9082244
              ],
              [
                54.2321496,
                26.9082243
              ],
              [
                54.2335396,
                26.9079457
              ],
              [
                54.2443727,
                26.9079456
              ],
              [
                54.245206,
                26.907667
              ],
              [
                54.248816,
                26.907667
              ],
              [
                54.2496493,
                26.9079456
              ],
              [
                54.2543725,
                26.9079457
              ],
              [
                54.2557626,
                26.907667
              ],
              [
                54.2579824,
                26.9079456
              ],
              [
                54.2604824,
                26.9079456
              ],
              [
                54.2621524,
                26.9082243
              ],
              [
                54.2643724,
                26.9082244
              ],
              [
                54.2679857,
                26.9087727
              ],
              [
                54.2782622,
                26.9087727
              ],
              [
                54.2832621,
                26.9096086
              ],
              [
                54.2846521,
                26.9096087
              ],
              [
                54.2943752,
                26.911838
              ],
              [
                54.2957619,
                26.9118379
              ],
              [
                54.2965952,
                26.9121167
              ],
              [
                54.2982618,
                26.9121167
              ],
              [
                54.2993752,
                26.9123953
              ],
              [
                54.3043751,
                26.9123952
              ],
              [
                54.3057651,
                26.912665
              ],
              [
                54.307985,
                26.912665
              ],
              [
                54.309375,
                26.9129436
              ],
              [
                54.3146516,
                26.9129436
              ],
              [
                54.3225647,
                26.9092425
              ],
              [
                54.324508,
                26.9092425
              ],
              [
                54.3270113,
                26.9097998
              ],
              [
                54.3283979,
                26.9100784
              ],
              [
                54.3339545,
                26.9106268
              ],
              [
                54.3347878,
                26.9109055
              ],
              [
                54.3372878,
                26.9109055
              ],
              [
                54.3381211,
                26.9111842
              ],
              [
                54.3391277,
                26.9111842
              ],
              [
                54.3514542,
                26.9111841
              ],
              [
                54.3581207,
                26.9120202
              ],
              [
                54.361734,
                26.9120202
              ],
              [
                54.3622873,
                26.9122988
              ],
              [
                54.3634007,
                26.9120202
              ],
              [
                54.3700672,
                26.9120202
              ],
              [
                54.3717338,
                26.9117415
              ],
              [
                54.3739571,
                26.9117415
              ],
              [
                54.3753438,
                26.9114628
              ],
              [
                54.3770104,
                26.9114629
              ],
              [
                54.3775671,
                26.9111841
              ],
              [
                54.3831237,
                26.9111842
              ],
              [
                54.3836804,
                26.9109055
              ],
              [
                54.387567,
                26.9109055
              ],
              [
                54.3886803,
                26.9111841
              ],
              [
                54.3931236,
                26.9111841
              ],
              [
                54.3936802,
                26.9114629
              ],
              [
                54.3972902,
                26.9114629
              ],
              [
                54.3984001,
                26.9117415
              ],
              [
                54.4003467,
                26.9117414
              ],
              [
                54.40368,
                26.9122988
              ],
              [
                54.4056233,
                26.9122988
              ],
              [
                54.40729,
                26.9125776
              ],
              [
                54.4131232,
                26.9125776
              ],
              [
                54.4145131,
                26.9128562
              ],
              [
                54.4172897,
                26.9128562
              ],
              [
                54.4192365,
                26.9128561
              ],
              [
                54.4197932,
                26.9131349
              ],
              [
                54.4225698,
                26.9131349
              ],
              [
                54.4231265,
                26.9128561
              ],
              [
                54.424513,
                26.9128561
              ],
              [
                54.4270129,
                26.9122988
              ],
              [
                54.4281263,
                26.9122988
              ],
              [
                54.4286796,
                26.9120201
              ],
              [
                54.4311795,
                26.9120202
              ],
              [
                54.4317362,
                26.9117414
              ],
              [
                54.4331262,
                26.9117415
              ],
              [
                54.4342362,
                26.9114628
              ],
              [
                54.4384028,
                26.9106267
              ],
              [
                54.4409027,
                26.9106268
              ],
              [
                54.4417361,
                26.9103571
              ],
              [
                54.4431261,
                26.9103571
              ],
              [
                54.4439594,
                26.9100784
              ],
              [
                54.4453494,
                26.9100784
              ],
              [
                54.4653491,
                26.904523
              ],
              [
                54.4664589,
                26.9045229
              ],
              [
                54.4697922,
                26.9034082
              ],
              [
                54.4709056,
                26.9034082
              ],
              [
                54.4722923,
                26.9028509
              ],
              [
                54.4781289,
                26.9017452
              ],
              [
                54.4789622,
                26.9017453
              ],
              [
                54.4795155,
                26.9014665
              ],
              [
                54.4806288,
                26.9014664
              ],
              [
                54.4809055,
                26.9011879
              ],
              [
                54.4825721,
                26.9011879
              ],
              [
                54.4947952,
                26.8986888
              ],
              [
                54.4950718,
                26.8984102
              ],
              [
                54.4956286,
                26.8984102
              ],
              [
                54.4956285,
                26.8981315
              ],
              [
                54.4978518,
                26.8981315
              ],
              [
                54.4981285,
                26.8978529
              ],
              [
                54.5000718,
                26.8978529
              ],
              [
                54.5020185,
                26.8972955
              ],
              [
                54.5028518,
                26.8972955
              ],
              [
                54.5128516,
                26.8947964
              ],
              [
                54.5134049,
                26.8945179
              ],
              [
                54.5145182,
                26.8945178
              ],
              [
                54.5164616,
                26.8939604
              ],
              [
                54.5228514,
                26.8939604
              ],
              [
                54.5381312,
                26.8961898
              ],
              [
                54.5397978,
                26.8961898
              ],
              [
                54.5403511,
                26.8964685
              ],
              [
                54.5414645,
                26.8964684
              ],
              [
                54.5434078,
                26.8972956
              ],
              [
                54.5436843,
                26.8975742
              ],
              [
                54.5447978,
                26.8975741
              ],
              [
                54.545351,
                26.8978529
              ],
              [
                54.5461844,
                26.8978528
              ],
              [
                54.5464644,
                26.8981314
              ],
              [
                54.5475744,
                26.8981315
              ],
              [
                54.5475744,
                26.8984102
              ],
              [
                54.5484077,
                26.8984102
              ],
              [
                54.5486843,
                26.8986889
              ],
              [
                54.5497977,
                26.8986888
              ],
              [
                54.5547977,
                26.9000732
              ],
              [
                54.5556309,
                26.9000732
              ],
              [
                54.5561876,
                26.9003519
              ],
              [
                54.5572976,
                26.9003518
              ],
              [
                54.5575742,
                26.9006306
              ],
              [
                54.5592408,
                26.9006306
              ],
              [
                54.5597975,
                26.9009091
              ],
              [
                54.5603542,
                26.9009091
              ],
              [
                54.5611875,
                26.9011879
              ],
              [
                54.5625741,
                26.9011879
              ],
              [
                54.5634074,
                26.9014665
              ],
              [
                54.5647974,
                26.9014665
              ],
              [
                54.5656308,
                26.9017452
              ],
              [
                54.5670208,
                26.9017453
              ],
              [
                54.567574,
                26.9020238
              ],
              [
                54.568964,
                26.9020239
              ],
              [
                54.5981337,
                26.9114628
              ],
              [
                54.598967,
                26.9114628
              ],
              [
                54.6000769,
                26.9120202
              ],
              [
                54.6011869,
                26.9120201
              ],
              [
                54.6011868,
                26.9122988
              ],
              [
                54.6020201,
                26.9122988
              ],
              [
                54.6025768,
                26.9125775
              ],
              [
                54.6036868,
                26.9125775
              ],
              [
                54.6042435,
                26.9128561
              ],
              [
                54.6053533,
                26.9128561
              ],
              [
                54.6056334,
                26.9131348
              ],
              [
                54.6073002,
                26.9131349
              ],
              [
                54.6084101,
                26.9136922
              ],
              [
                54.6098,
                26.9139708
              ],
              [
                54.61091,
                26.9139708
              ],
              [
                54.6139666,
                26.9147979
              ],
              [
                54.6153566,
                26.9147979
              ],
              [
                54.61591,
                26.9150765
              ],
              [
                54.6164667,
                26.9150765
              ],
              [
                54.6166617,
                26.9156788
              ],
              [
                54.6175298,
                26.9160947
              ],
              [
                54.6551182,
                26.9342307
              ],
              [
                54.6734653,
                26.9430761
              ],
              [
                54.6974938,
                26.9826649
              ],
              [
                54.7036736,
                27.0040794
              ],
              [
                54.6968072,
                27.0334411
              ],
              [
                54.7066761,
                27.0649279
              ],
              [
                54.7228997,
                27.1227027
              ],
              [
                54.8164154,
                27.1100607
              ],
              [
                54.8183836,
                27.1100607
              ],
              [
                54.8194935,
                27.1103395
              ],
              [
                54.8233834,
                27.1103395
              ],
              [
                54.8247701,
                27.1106181
              ],
              [
                54.8306068,
                27.1106182
              ],
              [
                54.8317168,
                27.1108968
              ],
              [
                54.8344933,
                27.1108969
              ],
              [
                54.8356067,
                27.1111757
              ],
              [
                54.8383832,
                27.1111757
              ],
              [
                54.8389398,
                27.1114544
              ],
              [
                54.8419931,
                27.1114544
              ],
              [
                54.8425498,
                27.1117241
              ],
              [
                54.8464398,
                27.1117241
              ],
              [
                54.8467164,
                27.1120029
              ],
              [
                54.8475497,
                27.1120029
              ],
              [
                54.8481065,
                27.1122816
              ],
              [
                54.8486631,
                27.1122817
              ],
              [
                54.8547729,
                27.1142328
              ],
              [
                54.8558829,
                27.1142328
              ],
              [
                54.8564396,
                27.1145115
              ],
              [
                54.8578295,
                27.1145115
              ],
              [
                54.8581062,
                27.1147814
              ],
              [
                54.8586629,
                27.1147813
              ],
              [
                54.8586628,
                27.1150601
              ],
              [
                54.8597728,
                27.11506
              ],
              [
                54.8600495,
                27.1153388
              ],
              [
                54.8606062,
                27.1153387
              ],
              [
                54.8611629,
                27.1156175
              ],
              [
                54.8622728,
                27.1156176
              ],
              [
                54.8639394,
                27.116175
              ],
              [
                54.8656062,
                27.116175
              ],
              [
                54.8775526,
                27.118396
              ],
              [
                54.8792193,
                27.118396
              ],
              [
                54.8822724,
                27.1189534
              ],
              [
                54.8833859,
                27.1189534
              ],
              [
                54.8839425,
                27.1192322
              ],
              [
                54.8853292,
                27.1192322
              ],
              [
                54.8858858,
                27.1195109
              ],
              [
                54.8883858,
                27.1195109
              ],
              [
                54.8886624,
                27.1197896
              ],
              [
                54.8900523,
                27.1197896
              ],
              [
                54.8908857,
                27.1200594
              ],
              [
                54.8939424,
                27.1200594
              ],
              [
                54.8947757,
                27.1203382
              ],
              [
                54.8964423,
                27.1203382
              ],
              [
                54.8972756,
                27.1206169
              ],
              [
                54.9058855,
                27.1206169
              ],
              [
                54.9069988,
                27.1203381
              ],
              [
                54.9122754,
                27.1203381
              ],
              [
                54.912552,
                27.1200593
              ],
              [
                54.9136654,
                27.1203382
              ],
              [
                54.9144987,
                27.1200594
              ],
              [
                54.9167187,
                27.1200594
              ],
              [
                54.9169986,
                27.1197896
              ],
              [
                54.9189419,
                27.1197896
              ],
              [
                54.9214418,
                27.1192322
              ],
              [
                54.9242219,
                27.1192322
              ],
              [
                54.9247751,
                27.1189534
              ],
              [
                54.9272752,
                27.1189533
              ],
              [
                54.9281084,
                27.1186747
              ],
              [
                54.9308884,
                27.1186747
              ],
              [
                54.9317217,
                27.1183959
              ],
              [
                54.9383884,
                27.118396
              ],
              [
                54.9392217,
                27.1183959
              ],
              [
                54.9431115,
                27.1181171
              ],
              [
                54.9447782,
                27.1178385
              ],
              [
                54.9461649,
                27.1178384
              ],
              [
                54.9472781,
                27.1175597
              ],
              [
                54.9600546,
                27.1175597
              ],
              [
                54.961168,
                27.1172809
              ],
              [
                54.9617212,
                27.1175597
              ],
              [
                54.9631112,
                27.1172809
              ],
              [
                54.9658879,
                27.1172809
              ],
              [
                54.9858909,
                27.1139541
              ],
              [
                54.9878342,
                27.1139541
              ],
              [
                54.9889442,
                27.1136663
              ],
              [
                54.9908908,
                27.1136662
              ],
              [
                55.0322802,
                27.1061672
              ],
              [
                55.0345035,
                27.1061672
              ],
              [
                55.0495033,
                27.1036767
              ],
              [
                55.0500598,
                27.1033978
              ],
              [
                55.1206187,
                27.090621
              ],
              [
                55.1320085,
                27.0878337
              ],
              [
                55.1328419,
                27.0872853
              ],
              [
                55.1336752,
                27.0872853
              ],
              [
                55.1342285,
                27.0870065
              ],
              [
                55.1372852,
                27.0870065
              ],
              [
                55.1378418,
                27.0867278
              ],
              [
                55.138395,
                27.0870065
              ],
              [
                55.141175,
                27.0870065
              ],
              [
                55.1456183,
                27.0861703
              ],
              [
                55.1464516,
                27.0861703
              ],
              [
                55.1470083,
                27.0856129
              ],
              [
                55.1475649,
                27.0856129
              ],
              [
                55.1477322,
                27.0852812
              ],
              [
                55.1486749,
                27.0847857
              ],
              [
                55.1492316,
                27.0847857
              ],
              [
                55.1492316,
                27.084507
              ],
              [
                55.1545082,
                27.084507
              ],
              [
                55.1572848,
                27.084507
              ],
              [
                55.1633981,
                27.084507
              ],
              [
                55.164508,
                27.0847856
              ],
              [
                55.1672881,
                27.0847857
              ],
              [
                55.1978442,
                27.0897758
              ],
              [
                55.1992307,
                27.0900546
              ],
              [
                55.2008974,
                27.0900546
              ],
              [
                55.2020107,
                27.0903333
              ],
              [
                55.205344,
                27.0903332
              ],
              [
                55.2059008,
                27.090621
              ],
              [
                55.2109006,
                27.0906209
              ],
              [
                55.2111773,
                27.0908908
              ],
              [
                55.2175672,
                27.0908908
              ],
              [
                55.2228438,
                27.090621
              ],
              [
                55.2242336,
                27.0903333
              ],
              [
                55.2356235,
                27.0903333
              ],
              [
                55.2370101,
                27.0900545
              ],
              [
                55.2428468,
                27.0900546
              ],
              [
                55.2439568,
                27.0897757
              ],
              [
                55.2481233,
                27.0895061
              ],
              [
                55.2522899,
                27.089506
              ],
              [
                55.2533998,
                27.0892273
              ],
              [
                55.2550665,
                27.0892273
              ],
              [
                55.2581231,
                27.0886699
              ],
              [
                55.2597899,
                27.0886699
              ],
              [
                55.3120156,
                27.0789503
              ],
              [
                55.3131256,
                27.0789503
              ],
              [
                55.3134023,
                27.0786716
              ],
              [
                55.3145156,
                27.0786716
              ],
              [
                55.3150689,
                27.0783929
              ],
              [
                55.3383886,
                27.0836704
              ],
              [
                55.3389452,
                27.0836705
              ],
              [
                55.3395019,
                27.0834007
              ],
              [
                55.3395018,
                27.0839491
              ],
              [
                55.3395019,
                27.0853426
              ],
              [
                55.365588,
                27.0975085
              ],
              [
                55.3716978,
                27.1172271
              ],
              [
                55.3719778,
                27.1188995
              ],
              [
                55.3722544,
                27.120563
              ],
              [
                55.3725311,
                27.1213993
              ],
              [
                55.3728112,
                27.1219478
              ],
              [
                55.3728112,
                27.1222265
              ],
              [
                55.3733645,
                27.123899
              ],
              [
                55.3736447,
                27.1247263
              ],
              [
                55.3750311,
                27.1275137
              ],
              [
                55.3668183,
                27.1642874
              ],
              [
                55.365705,
                27.1645663
              ],
              [
                55.3651516,
                27.1651328
              ],
              [
                55.2090447,
                27.2076184
              ],
              [
                54.9214287,
                27.2572837
              ],
              [
                54.9025356,
                27.2590816
              ],
              [
                54.8950356,
                27.2665826
              ],
              [
                54.8955925,
                27.2665826
              ],
              [
                54.8961646,
                27.2669425
              ],
              [
                54.921795,
                27.2849042
              ],
              [
                54.9871075,
                27.3680294
              ],
              [
                55.0427724,
                27.4193703
              ],
              [
                55.0430491,
                27.4196581
              ],
              [
                55.0430491,
                27.4234981
              ],
              [
                55.0408257,
                27.4235443
              ],
              [
                55.0399924,
                27.4238232
              ],
              [
                55.0372159,
                27.4238234
              ],
              [
                55.0327727,
                27.424372
              ],
              [
                55.028326,
                27.424372
              ],
              [
                55.0266594,
                27.4246509
              ],
              [
                55.0222162,
                27.4246509
              ],
              [
                54.9810784,
                27.4266336
              ],
              [
                54.9525716,
                27.4255482
              ],
              [
                54.945625,
                27.4255482
              ],
              [
                54.9295153,
                27.4272125
              ],
              [
                54.9256253,
                27.4272124
              ],
              [
                54.924792,
                27.4274913
              ],
              [
                54.9206254,
                27.4274913
              ],
              [
                54.8934025,
                27.4305409
              ],
              [
                54.8909027,
                27.4305409
              ],
              [
                54.8850693,
                27.4313776
              ],
              [
                54.8822894,
                27.4313775
              ],
              [
                54.8806227,
                27.4316564
              ],
              [
                54.8789261,
                27.4420164
              ],
              [
                54.8780928,
                27.4422863
              ],
              [
                54.8744794,
                27.4422863
              ],
              [
                54.7187798,
                27.4741618
              ],
              [
                54.6569696,
                27.4667354
              ],
              [
                54.6544696,
                27.4667354
              ],
              [
                54.6511363,
                27.4672931
              ],
              [
                54.6469697,
                27.4672931
              ],
              [
                54.6464165,
                27.4675719
              ],
              [
                54.6416932,
                27.467572
              ],
              [
                54.6411365,
                27.4678509
              ],
              [
                54.6289134,
                27.4678509
              ],
              [
                54.62836,
                27.467572
              ],
              [
                54.6233601,
                27.467572
              ],
              [
                54.6219701,
                27.4672931
              ],
              [
                54.6180801,
                27.4672931
              ],
              [
                54.6166902,
                27.4670143
              ],
              [
                54.611137,
                27.4667354
              ],
              [
                54.6100236,
                27.4667355
              ],
              [
                54.608357,
                27.4664566
              ],
              [
                54.6039137,
                27.4661867
              ],
              [
                54.5978004,
                27.4661867
              ],
              [
                54.5961337,
                27.4658988
              ],
              [
                54.5897473,
                27.4658989
              ],
              [
                54.5880807,
                27.4656199
              ],
              [
                54.5376131,
                27.4534312
              ],
              [
                54.5349748,
                27.4534312
              ],
              [
                54.5344181,
                27.4537101
              ],
              [
                54.5238616,
                27.45371
              ],
              [
                54.5230283,
                27.4534311
              ],
              [
                54.5183085,
                27.4534311
              ],
              [
                54.5169184,
                27.4531523
              ],
              [
                54.5085853,
                27.4531523
              ],
              [
                54.5080285,
                27.4528734
              ],
              [
                54.5046953,
                27.4528734
              ],
              [
                54.5038619,
                27.4525945
              ],
              [
                54.5019187,
                27.4525945
              ],
              [
                54.5016386,
                27.4523156
              ],
              [
                54.3921414,
                27.4442642
              ],
              [
                54.3904747,
                27.4442641
              ],
              [
                54.3876948,
                27.4437064
              ],
              [
                54.3857515,
                27.4437065
              ],
              [
                54.3804715,
                27.4428788
              ],
              [
                54.3788048,
                27.4428788
              ],
              [
                54.3776949,
                27.4431487
              ],
              [
                54.3735283,
                27.4431487
              ],
              [
                54.3710284,
                27.4437065
              ],
              [
                54.3671384,
                27.4437065
              ],
              [
                54.3660284,
                27.4439853
              ],
              [
                54.3646385,
                27.4439853
              ],
              [
                54.350472,
                27.4475927
              ],
              [
                54.349082,
                27.4475928
              ],
              [
                54.3488055,
                27.4478806
              ],
              [
                54.3471388,
                27.4481504
              ],
              [
                54.3401922,
                27.4481504
              ],
              [
                54.3396389,
                27.4484294
              ],
              [
                54.3371389,
                27.4484294
              ],
              [
                54.3363056,
                27.4487083
              ],
              [
                54.3338058,
                27.4487083
              ],
              [
                54.3335256,
                27.4489871
              ],
              [
                54.3299157,
                27.4489871
              ],
              [
                54.3296391,
                27.4487083
              ],
              [
                54.3290824,
                27.4487082
              ],
              [
                54.3288057,
                27.4489871
              ],
              [
                54.3282491,
                27.4489871
              ],
              [
                54.327969,
                27.4487083
              ],
              [
                54.3249158,
                27.4487082
              ],
              [
                54.3243591,
                27.4489871
              ],
              [
                54.3235258,
                27.4489871
              ],
              [
                54.3229691,
                27.449257
              ],
              [
                54.3221358,
                27.4495449
              ],
              [
                54.3210258,
                27.4492569
              ],
              [
                54.3193592,
                27.449257
              ],
              [
                54.3107494,
                27.4481504
              ],
              [
                54.3065794,
                27.4481505
              ],
              [
                54.3054694,
                27.4478806
              ],
              [
                54.293803,
                27.4495449
              ],
              [
                54.288523,
                27.4495449
              ],
              [
                54.2876896,
                27.4492569
              ],
              [
                54.2688817,
                27.4465022
              ],
              [
                54.2472487,
                27.4433288
              ],
              [
                54.2365771,
                27.4417633
              ],
              [
                54.2343573,
                27.4417633
              ],
              [
                54.2224107,
                27.4395413
              ],
              [
                54.2168541,
                27.438147
              ],
              [
                54.2146308,
                27.4378772
              ],
              [
                54.2132442,
                27.4373194
              ],
              [
                54.2124109,
                27.4373194
              ],
              [
                54.1956645,
                27.4272149
              ],
              [
                54.1811364,
                27.4113959
              ],
              [
                54.1268914,
                27.3809141
              ],
              [
                54.0795132,
                27.3623158
              ],
              [
                54.0444943,
                27.3610961
              ],
              [
                54.0341517,
                27.3588473
              ],
              [
                54.0157912,
                27.3534385
              ],
              [
                54.0123063,
                27.3523659
              ],
              [
                54.0048001,
                27.3521264
              ],
              [
                53.9959166,
                27.3490378
              ],
              [
                53.9956366,
                27.348759
              ],
              [
                53.9781369,
                27.3426425
              ],
              [
                53.9781369,
                27.3423726
              ],
              [
                53.9773965,
                27.3417234
              ],
              [
                53.9770269,
                27.341536
              ],
              [
                53.97166,
                27.3393096
              ],
              [
                53.9658306,
                27.3353436
              ],
              [
                53.8954919,
                27.2839262
              ],
              [
                53.8815665,
                27.2386592
              ],
              [
                53.8823999,
                27.2375434
              ],
              [
                53.8915663,
                27.2222546
              ],
              [
                53.9497369,
                27.1660849
              ],
              [
                53.9640676,
                27.1455798
              ],
              [
                53.934161,
                27.1245049
              ],
              [
                53.9333276,
                27.1236778
              ],
              [
                53.9188846,
                27.1159009
              ],
              [
                53.9130514,
                27.1136713
              ],
              [
                53.9111047,
                27.1131139
              ],
              [
                53.9069381,
                27.1114507
              ],
              [
                53.8737918,
                27.0863678
              ],
              [
                53.8732351,
                27.0858104
              ],
              [
                53.871845,
                27.085262
              ],
              [
                53.8444622,
                27.0720127
              ],
              [
                53.8436289,
                27.0714554
              ],
              [
                53.8274928,
                27.0570068
              ],
              [
                53.8184998,
                27.0328006
              ],
              [
                53.8187763,
                27.0294651
              ],
              [
                53.8190563,
                27.0261297
              ],
              [
                53.819333,
                27.0239091
              ],
              [
                53.8196096,
                27.0219671
              ],
              [
                53.8198897,
                27.0203039
              ],
              [
                53.8201664,
                27.0194679
              ],
              [
                53.8215563,
                27.0153054
              ],
              [
                53.8215563,
                27.0150267
              ],
              [
                53.8218329,
                27.0147479
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554932,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بشاگرد",
          "name:en": "Bashagard County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q213133",
          "wikipedia": "en:Bashagard County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                57.3683103,
                26.4688198
              ],
              [
                57.3683103,
                26.4663229
              ],
              [
                57.3680302,
                26.4657661
              ],
              [
                57.3695719,
                26.4583758
              ],
              [
                57.3779052,
                26.4444921
              ],
              [
                57.3806851,
                26.4386638
              ],
              [
                57.3881851,
                26.4292168
              ],
              [
                57.3890183,
                26.427268
              ],
              [
                57.4137444,
                26.3867157
              ],
              [
                57.4145781,
                26.3853238
              ],
              [
                57.425411,
                26.3694935
              ],
              [
                57.4482842,
                26.3289363
              ],
              [
                57.4493974,
                26.3272663
              ],
              [
                57.4766165,
                26.2794942
              ],
              [
                57.4771701,
                26.2769895
              ],
              [
                57.4774502,
                26.2758763
              ],
              [
                57.483283,
                26.2536572
              ],
              [
                57.4907831,
                26.232265
              ],
              [
                57.5120892,
                26.2111489
              ],
              [
                57.5126424,
                26.2100447
              ],
              [
                57.5129225,
                26.2083748
              ],
              [
                57.513476,
                26.2072616
              ],
              [
                57.5143092,
                26.2030959
              ],
              [
                57.5148623,
                26.2011477
              ],
              [
                57.5151424,
                26.2006001
              ],
              [
                57.5165291,
                26.1947647
              ],
              [
                57.5165291,
                26.1922599
              ],
              [
                57.5173624,
                26.1919816
              ],
              [
                57.528592,
                26.1880414
              ],
              [
                57.6222607,
                26.1733106
              ],
              [
                57.6541897,
                26.1683806
              ],
              [
                57.681483,
                26.1717831
              ],
              [
                57.6982193,
                26.1798426
              ],
              [
                57.6991018,
                26.17934
              ],
              [
                57.7021127,
                26.1776254
              ],
              [
                57.7026659,
                26.1778946
              ],
              [
                57.703219,
                26.1776253
              ],
              [
                57.7043327,
                26.1776253
              ],
              [
                57.7273854,
                26.1698423
              ],
              [
                57.7284987,
                26.1698423
              ],
              [
                57.7298855,
                26.1692857
              ],
              [
                57.7307257,
                26.1692857
              ],
              [
                57.7329453,
                26.168451
              ],
              [
                57.7440587,
                26.1640074
              ],
              [
                57.7521116,
                26.152616
              ],
              [
                57.7526651,
                26.1506772
              ],
              [
                57.7529452,
                26.148451
              ],
              [
                57.7546116,
                26.1420599
              ],
              [
                57.7571117,
                26.1384515
              ],
              [
                57.7573916,
                26.1387297
              ],
              [
                57.765083,
                26.1566709
              ],
              [
                57.7952954,
                26.1619096
              ],
              [
                57.8035351,
                26.1643748
              ],
              [
                57.8285573,
                26.169634
              ],
              [
                57.8293904,
                26.169634
              ],
              [
                57.8299436,
                26.1699123
              ],
              [
                57.831337,
                26.1699124
              ],
              [
                57.8318905,
                26.1701906
              ],
              [
                57.8352238,
                26.1701906
              ],
              [
                57.8449435,
                26.1668601
              ],
              [
                57.8510568,
                26.1590768
              ],
              [
                57.8516167,
                26.1590768
              ],
              [
                57.8530034,
                26.1590768
              ],
              [
                57.8538365,
                26.1593551
              ],
              [
                57.8566167,
                26.1593551
              ],
              [
                57.8574499,
                26.1596334
              ],
              [
                57.8717166,
                26.1479229
              ],
              [
                57.8722697,
                26.1476445
              ],
              [
                57.8739361,
                26.1476445
              ],
              [
                57.9267876,
                26.1196857
              ],
              [
                57.9981988,
                26.0913222
              ],
              [
                58.0642665,
                26.090249
              ],
              [
                58.0650998,
                26.090249
              ],
              [
                58.0664932,
                26.0896927
              ],
              [
                58.0698264,
                26.0894235
              ],
              [
                58.0745464,
                26.0894235
              ],
              [
                58.0750995,
                26.0896927
              ],
              [
                58.076493,
                26.0896927
              ],
              [
                58.1457315,
                26.1028157
              ],
              [
                58.1457316,
                26.1030939
              ],
              [
                58.146005,
                26.1033721
              ],
              [
                58.1465652,
                26.1039285
              ],
              [
                58.1471183,
                26.1042068
              ],
              [
                58.1482316,
                26.1047632
              ],
              [
                58.1490649,
                26.1050414
              ],
              [
                58.1562849,
                26.1078146
              ],
              [
                58.1857311,
                26.1169869
              ],
              [
                58.1904507,
                26.1192036
              ],
              [
                58.2388684,
                26.1221515
              ],
              [
                58.2832362,
                26.1150392
              ],
              [
                58.2865695,
                26.1142045
              ],
              [
                58.2887895,
                26.1139352
              ],
              [
                58.2915691,
                26.1139352
              ],
              [
                58.2926824,
                26.113648
              ],
              [
                58.2940692,
                26.113648
              ],
              [
                58.2946223,
                26.1139352
              ],
              [
                58.297956,
                26.1139352
              ],
              [
                58.2993493,
                26.113648
              ],
              [
                58.3037888,
                26.1136481
              ],
              [
                58.304349,
                26.1133698
              ],
              [
                58.3442685,
                26.0873135
              ],
              [
                58.4084698,
                26.0900886
              ],
              [
                58.5292317,
                26.096102
              ],
              [
                58.532565,
                26.0983272
              ],
              [
                58.5345119,
                26.0991618
              ],
              [
                58.535065,
                26.09944
              ],
              [
                58.5378452,
                26.1008308
              ],
              [
                58.5811612,
                26.1203019
              ],
              [
                58.6253905,
                26.1479503
              ],
              [
                58.6314972,
                26.1496193
              ],
              [
                58.6495569,
                26.1529487
              ],
              [
                58.6526101,
                26.153227
              ],
              [
                58.6639019,
                26.1616015
              ],
              [
                58.7291333,
                26.1683806
              ],
              [
                58.7847515,
                26.1791647
              ],
              [
                58.9004513,
                26.208739
              ],
              [
                58.9666053,
                26.2083195
              ],
              [
                58.972712,
                26.2083196
              ],
              [
                58.9732718,
                26.2080414
              ],
              [
                58.9741054,
                26.2083196
              ],
              [
                59.0092034,
                26.2080916
              ],
              [
                58.9377861,
                26.2270727
              ],
              [
                58.9377861,
                26.2279077
              ],
              [
                58.9380595,
                26.2292993
              ],
              [
                58.8523861,
                26.2318386
              ],
              [
                58.8173672,
                26.2429249
              ],
              [
                58.8238903,
                26.2823339
              ],
              [
                58.8527295,
                26.3091121
              ],
              [
                58.8712689,
                26.3269608
              ],
              [
                58.8807599,
                26.3542345
              ],
              [
                58.7974023,
                26.4444295
              ],
              [
                58.7971288,
                26.4449823
              ],
              [
                58.7971223,
                26.4449954
              ],
              [
                58.7971027,
                26.4449954
              ],
              [
                58.7965691,
                26.4449955
              ],
              [
                58.7961098,
                26.4452267
              ],
              [
                58.796016,
                26.4452739
              ],
              [
                58.7937571,
                26.4456785
              ],
              [
                58.7929557,
                26.445822
              ],
              [
                58.690477,
                26.5367166
              ],
              [
                58.6543643,
                26.5544919
              ],
              [
                58.6451978,
                26.5586596
              ],
              [
                58.6138147,
                26.5947723
              ],
              [
                58.5949285,
                26.6094943
              ],
              [
                58.535193,
                26.6417146
              ],
              [
                58.5138911,
                26.6686058
              ],
              [
                58.5001937,
                26.6858879
              ],
              [
                58.4978269,
                26.6801935
              ],
              [
                58.4969936,
                26.6807506
              ],
              [
                58.486994,
                26.6882538
              ],
              [
                58.4861603,
                26.688811
              ],
              [
                58.4591998,
                26.6525887
              ],
              [
                58.3269843,
                26.7299323
              ],
              [
                58.3247573,
                26.7307681
              ],
              [
                58.3129238,
                26.7341797
              ],
              [
                58.3122579,
                26.7343716
              ],
              [
                58.3113287,
                26.7343716
              ],
              [
                58.310591,
                26.7343716
              ],
              [
                58.3105061,
                26.7344583
              ],
              [
                58.3103181,
                26.7346503
              ],
              [
                58.3092759,
                26.7346503
              ],
              [
                58.3089243,
                26.7346503
              ],
              [
                58.308665,
                26.734737
              ],
              [
                58.308091,
                26.7349288
              ],
              [
                58.3067316,
                26.7349289
              ],
              [
                58.3067047,
                26.7349289
              ],
              [
                58.2945503,
                26.737523
              ],
              [
                58.2936514,
                26.7377148
              ],
              [
                58.2922579,
                26.7377148
              ],
              [
                58.2892047,
                26.738272
              ],
              [
                58.2874179,
                26.738272
              ],
              [
                58.2872582,
                26.738272
              ],
              [
                58.2865604,
                26.7384466
              ],
              [
                58.286145,
                26.7385505
              ],
              [
                58.2603117,
                26.74299
              ],
              [
                58.2555921,
                26.7438258
              ],
              [
                58.2547463,
                26.7438258
              ],
              [
                58.2542054,
                26.7438258
              ],
              [
                58.2540302,
                26.7439129
              ],
              [
                58.2536453,
                26.7441043
              ],
              [
                58.252842,
                26.7441044
              ],
              [
                58.252812,
                26.7441044
              ],
              [
                58.2248295,
                26.7500809
              ],
              [
                58.224199,
                26.7502155
              ],
              [
                58.2169794,
                26.7515995
              ],
              [
                58.2153012,
                26.7515996
              ],
              [
                58.2147595,
                26.7515996
              ],
              [
                58.2145837,
                26.7516869
              ],
              [
                58.2141992,
                26.7518781
              ],
              [
                58.2134473,
                26.751878
              ],
              [
                58.213093,
                26.751878
              ],
              [
                58.2128312,
                26.7519656
              ],
              [
                58.2122594,
                26.7521568
              ],
              [
                58.2106673,
                26.7521567
              ],
              [
                58.2103129,
                26.7521567
              ],
              [
                58.2100513,
                26.7522442
              ],
              [
                58.2094797,
                26.7524352
              ],
              [
                58.2087206,
                26.7524353
              ],
              [
                58.2083659,
                26.7524353
              ],
              [
                58.2081043,
                26.7525229
              ],
              [
                58.2075328,
                26.752714
              ],
              [
                58.2053872,
                26.7527139
              ],
              [
                58.2050327,
                26.7527139
              ],
              [
                58.2047709,
                26.7528014
              ],
              [
                58.2041995,
                26.7529924
              ],
              [
                58.2025214,
                26.7529925
              ],
              [
                58.2019795,
                26.7529925
              ],
              [
                58.2018035,
                26.75308
              ],
              [
                58.2014193,
                26.7532711
              ],
              [
                58.2006676,
                26.7532712
              ],
              [
                58.200313,
                26.7532712
              ],
              [
                58.2000512,
                26.7533587
              ],
              [
                58.1994795,
                26.7535497
              ],
              [
                58.198913,
                26.7535497
              ],
              [
                58.1983662,
                26.7535497
              ],
              [
                58.1981922,
                26.7536373
              ],
              [
                58.197813,
                26.7538283
              ],
              [
                58.1972464,
                26.7538284
              ],
              [
                58.1966997,
                26.7538284
              ],
              [
                58.1965258,
                26.7539159
              ],
              [
                58.1961462,
                26.7541069
              ],
              [
                58.1955799,
                26.7541069
              ],
              [
                58.1950329,
                26.7541069
              ],
              [
                58.1948591,
                26.7541945
              ],
              [
                58.1944799,
                26.7543856
              ],
              [
                58.1936466,
                26.7543856
              ],
              [
                58.1911465,
                26.7546641
              ],
              [
                58.1396008,
                26.7747972
              ],
              [
                58.1394139,
                26.7749877
              ],
              [
                58.138937,
                26.7749877
              ],
              [
                58.1385806,
                26.7749877
              ],
              [
                58.1369141,
                26.7755447
              ],
              [
                58.1263542,
                26.783039
              ],
              [
                58.1241342,
                26.7855372
              ],
              [
                58.1235807,
                26.7855372
              ],
              [
                58.1235807,
                26.7858157
              ],
              [
                58.1202475,
                26.78888
              ],
              [
                58.116354,
                26.791378
              ],
              [
                58.0694084,
                26.8310979
              ],
              [
                58.0627419,
                26.8349893
              ],
              [
                58.0562282,
                26.8367405
              ],
              [
                58.055522,
                26.8369303
              ],
              [
                58.0551448,
                26.8369303
              ],
              [
                58.0544086,
                26.8369304
              ],
              [
                58.0543194,
                26.8370191
              ],
              [
                58.0541285,
                26.8372089
              ],
              [
                58.049962,
                26.8372089
              ],
              [
                58.0457956,
                26.8374876
              ],
              [
                58.0445787,
                26.8374876
              ],
              [
                58.0444088,
                26.8374875
              ],
              [
                58.0399622,
                26.838602
              ],
              [
                58.034129,
                26.8408217
              ],
              [
                58.0327426,
                26.8416575
              ],
              [
                58.0280155,
                26.8436076
              ],
              [
                58.005516,
                26.8560995
              ],
              [
                58.0046828,
                26.8569353
              ],
              [
                58.0019097,
                26.8585979
              ],
              [
                57.9763499,
                26.8819379
              ],
              [
                57.9738499,
                26.8847151
              ],
              [
                57.9732968,
                26.8849937
              ],
              [
                57.9140571,
                26.9236655
              ],
              [
                57.9108088,
                26.9236655
              ],
              [
                57.9104437,
                26.9236655
              ],
              [
                57.9101735,
                26.9237558
              ],
              [
                57.9096104,
                26.9239441
              ],
              [
                57.9076635,
                26.9239442
              ],
              [
                57.9062772,
                26.9242228
              ],
              [
                57.8931723,
                26.9224626
              ],
              [
                57.8522735,
                26.9342066
              ],
              [
                57.8367779,
                26.9200695
              ],
              [
                57.8227614,
                26.9012524
              ],
              [
                57.8095512,
                26.8972938
              ],
              [
                57.8081649,
                26.896458
              ],
              [
                57.8059449,
                26.8950738
              ],
              [
                57.8053848,
                26.894238
              ],
              [
                57.7856825,
                26.902477
              ],
              [
                57.7784727,
                26.921764
              ],
              [
                57.768688,
                26.9199272
              ],
              [
                57.7577132,
                26.9022813
              ],
              [
                57.7516064,
                26.8972846
              ],
              [
                57.7254368,
                26.8739041
              ],
              [
                57.7252133,
                26.8736761
              ],
              [
                57.7246602,
                26.8736761
              ],
              [
                57.7246601,
                26.8733975
              ],
              [
                57.7241,
                26.8731189
              ],
              [
                57.7232667,
                26.8731189
              ],
              [
                57.7229938,
                26.8728403
              ],
              [
                57.7057673,
                26.8575632
              ],
              [
                57.7049337,
                26.8564489
              ],
              [
                57.7029938,
                26.8500685
              ],
              [
                57.7038274,
                26.8395096
              ],
              [
                57.7035472,
                26.8320063
              ],
              [
                57.7032672,
                26.8264529
              ],
              [
                57.7029938,
                26.8258958
              ],
              [
                57.7029938,
                26.8247816
              ],
              [
                57.7027137,
                26.8228406
              ],
              [
                57.6996605,
                26.8106198
              ],
              [
                57.6988272,
                26.8072862
              ],
              [
                57.6893806,
                26.7864578
              ],
              [
                57.6891005,
                26.7861792
              ],
              [
                57.6891004,
                26.7828366
              ],
              [
                57.6891005,
                26.7825581
              ],
              [
                57.6893805,
                26.7808958
              ],
              [
                57.6891004,
                26.7806173
              ],
              [
                57.6893805,
                26.7800601
              ],
              [
                57.6918805,
                26.7689544
              ],
              [
                57.6913274,
                26.7675618
              ],
              [
                57.6935473,
                26.7406161
              ],
              [
                57.6979939,
                26.7308948
              ],
              [
                57.6996603,
                26.7242283
              ],
              [
                57.6999337,
                26.7214521
              ],
              [
                57.7004939,
                26.7197811
              ],
              [
                57.7004939,
                26.719224
              ],
              [
                57.7038271,
                26.7056218
              ],
              [
                57.7035471,
                26.7045079
              ],
              [
                57.7091236,
                26.6820167
              ],
              [
                57.7088435,
                26.6803545
              ],
              [
                57.7085633,
                26.6795189
              ],
              [
                57.6943971,
                26.6586156
              ],
              [
                57.6935634,
                26.6577803
              ],
              [
                57.689397,
                26.6497225
              ],
              [
                57.6880102,
                26.646947
              ],
              [
                57.6857836,
                26.6422221
              ],
              [
                57.6855106,
                26.6408387
              ],
              [
                57.6841171,
                26.6363923
              ],
              [
                57.6824503,
                26.6269428
              ],
              [
                57.6821773,
                26.6250024
              ],
              [
                57.6818972,
                26.6199994
              ],
              [
                57.6816171,
                26.6194514
              ],
              [
                57.6818971,
                26.6183375
              ],
              [
                57.6821772,
                26.6119513
              ],
              [
                57.6818971,
                26.6102806
              ],
              [
                57.6821773,
                26.6097326
              ],
              [
                57.6821772,
                26.608062
              ],
              [
                57.6818971,
                26.6077836
              ],
              [
                57.6821772,
                26.6072266
              ],
              [
                57.6948801,
                26.596998
              ],
              [
                57.6484682,
                26.5205888
              ],
              [
                57.6493018,
                26.5194837
              ],
              [
                57.6526351,
                26.5125389
              ],
              [
                57.6540214,
                26.5111464
              ],
              [
                57.6540214,
                26.5100324
              ],
              [
                57.6543014,
                26.5091968
              ],
              [
                57.6643179,
                26.5002267
              ],
              [
                57.6559063,
                26.4936208
              ],
              [
                57.6325604,
                26.4945426
              ],
              [
                57.6176545,
                26.4811596
              ],
              [
                57.6165412,
                26.4811596
              ],
              [
                57.6159876,
                26.481438
              ],
              [
                57.6054276,
                26.4828301
              ],
              [
                57.6023745,
                26.4828301
              ],
              [
                57.6018214,
                26.4831085
              ],
              [
                57.5984846,
                26.4766551
              ],
              [
                57.5979311,
                26.4769335
              ],
              [
                57.5837649,
                26.4780382
              ],
              [
                57.5765449,
                26.4780383
              ],
              [
                57.5740452,
                26.4783167
              ],
              [
                57.5723784,
                26.4783167
              ],
              [
                57.5715452,
                26.4780382
              ],
              [
                57.568765,
                26.4780383
              ],
              [
                57.5679318,
                26.4777598
              ],
              [
                57.5651517,
                26.4777599
              ],
              [
                57.5645986,
                26.4774814
              ],
              [
                57.5620986,
                26.4774814
              ],
              [
                57.5612652,
                26.477203
              ],
              [
                57.557652,
                26.4769335
              ],
              [
                57.5487654,
                26.4769336
              ],
              [
                57.5476521,
                26.4766552
              ],
              [
                57.5393189,
                26.4766551
              ],
              [
                57.5379321,
                26.4763768
              ],
              [
                57.5170927,
                26.4763768
              ],
              [
                57.5154259,
                26.4766552
              ],
              [
                57.5009862,
                26.4766552
              ],
              [
                57.4990396,
                26.4763769
              ],
              [
                57.4970927,
                26.4763768
              ],
              [
                57.4959865,
                26.4760895
              ],
              [
                57.4815398,
                26.4749847
              ],
              [
                57.4707067,
                26.4749847
              ],
              [
                57.4695934,
                26.4747063
              ],
              [
                57.4668133,
                26.4747063
              ],
              [
                57.4651465,
                26.4744278
              ],
              [
                57.4618133,
                26.4744279
              ],
              [
                57.46098,
                26.4741495
              ],
              [
                57.4459802,
                26.4741496
              ],
              [
                57.433474,
                26.471662
              ],
              [
                57.4226409,
                26.4716621
              ],
              [
                57.4215276,
                26.4713836
              ],
              [
                57.4184745,
                26.4713835
              ],
              [
                57.4173608,
                26.4711052
              ],
              [
                57.4151413,
                26.4711052
              ],
              [
                57.4143076,
                26.4708267
              ],
              [
                57.4104212,
                26.4708267
              ],
              [
                57.4098611,
                26.4705483
              ],
              [
                57.4065279,
                26.4705483
              ],
              [
                57.4056945,
                26.4702698
              ],
              [
                57.3987546,
                26.4702699
              ],
              [
                57.3979144,
                26.4699914
              ],
              [
                57.3721971,
                26.4699335
              ],
              [
                57.3716436,
                26.4699335
              ],
              [
                57.3713635,
                26.4696461
              ],
              [
                57.3683103,
                26.4688198
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554937,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بندر لنگه",
          "name:en": "Bandar Lengeh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q920432",
          "wikipedia": "en:Bandar Lengeh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.9477745,
                26.7105243
              ],
              [
                53.0913411,
                26.6243518
              ],
              [
                53.1282214,
                26.6061774
              ],
              [
                53.4031013,
                26.4987712
              ],
              [
                53.8207246,
                26.3353974
              ],
              [
                53.849842,
                26.3222684
              ],
              [
                53.8721513,
                26.3160149
              ],
              [
                53.8865706,
                26.310408
              ],
              [
                53.9313845,
                26.2993223
              ],
              [
                53.9642391,
                26.2946269
              ],
              [
                54.1137475,
                26.3366617
              ],
              [
                54.2611577,
                26.3780916
              ],
              [
                54.4152805,
                26.4213922
              ],
              [
                54.625396,
                26.4133961
              ],
              [
                54.8272691,
                26.3844897
              ],
              [
                54.9459973,
                26.4825395
              ],
              [
                55.0215905,
                26.5449234
              ],
              [
                55.1235637,
                26.617585
              ],
              [
                55.2344506,
                26.6965457
              ],
              [
                55.2764707,
                26.7059041
              ],
              [
                55.3570172,
                26.7238406
              ],
              [
                55.4867932,
                26.7339596
              ],
              [
                55.5076112,
                26.7523565
              ],
              [
                55.5607795,
                26.799328
              ],
              [
                55.5767437,
                26.8369383
              ],
              [
                55.6248407,
                26.9109964
              ],
              [
                55.5975402,
                26.9245797
              ],
              [
                55.5886074,
                26.9240083
              ],
              [
                55.5793307,
                26.9270144
              ],
              [
                55.578959,
                26.9268476
              ],
              [
                55.5595082,
                26.9192279
              ],
              [
                55.5483985,
                26.9297796
              ],
              [
                55.5325654,
                26.9478364
              ],
              [
                55.5231189,
                26.9631163
              ],
              [
                55.5211756,
                26.9714485
              ],
              [
                55.5214522,
                26.9725631
              ],
              [
                55.5211755,
                26.9806169
              ],
              [
                55.5256188,
                26.9970032
              ],
              [
                55.5256188,
                26.9980124
              ],
              [
                55.5222856,
                27.00201
              ],
              [
                55.5081191,
                27.0236735
              ],
              [
                55.5070091,
                27.0250669
              ],
              [
                55.5045057,
                27.0283929
              ],
              [
                55.5000626,
                27.0311706
              ],
              [
                55.4703398,
                27.0406184
              ],
              [
                55.4675597,
                27.0417241
              ],
              [
                55.4664497,
                27.0417241
              ],
              [
                55.4661731,
                27.0420028
              ],
              [
                55.45895,
                27.0436749
              ],
              [
                55.4581166,
                27.0442232
              ],
              [
                55.4570066,
                27.0442232
              ],
              [
                55.45534,
                27.0447806
              ],
              [
                55.4542266,
                27.0447806
              ],
              [
                55.4367269,
                27.0489517
              ],
              [
                55.431447,
                27.0503361
              ],
              [
                55.4295037,
                27.0508935
              ],
              [
                55.408114,
                27.0570065
              ],
              [
                55.4056141,
                27.0581121
              ],
              [
                55.3595015,
                27.0733948
              ],
              [
                55.3564449,
                27.0747883
              ],
              [
                55.3395019,
                27.0834007
              ],
              [
                55.3389452,
                27.0836705
              ],
              [
                55.3383886,
                27.0836704
              ],
              [
                55.3150689,
                27.0783929
              ],
              [
                55.3145156,
                27.0786716
              ],
              [
                55.3134023,
                27.0786716
              ],
              [
                55.3131256,
                27.0789503
              ],
              [
                55.3120156,
                27.0789503
              ],
              [
                55.2597899,
                27.0886699
              ],
              [
                55.2581231,
                27.0886699
              ],
              [
                55.2550665,
                27.0892273
              ],
              [
                55.2533998,
                27.0892273
              ],
              [
                55.2522899,
                27.089506
              ],
              [
                55.2481233,
                27.0895061
              ],
              [
                55.2439568,
                27.0897757
              ],
              [
                55.2428468,
                27.0900546
              ],
              [
                55.2370101,
                27.0900545
              ],
              [
                55.2356235,
                27.0903333
              ],
              [
                55.2242336,
                27.0903333
              ],
              [
                55.2228438,
                27.090621
              ],
              [
                55.2175672,
                27.0908908
              ],
              [
                55.2111773,
                27.0908908
              ],
              [
                55.2109006,
                27.0906209
              ],
              [
                55.2059008,
                27.090621
              ],
              [
                55.205344,
                27.0903332
              ],
              [
                55.2020107,
                27.0903333
              ],
              [
                55.2008974,
                27.0900546
              ],
              [
                55.1992307,
                27.0900546
              ],
              [
                55.1978442,
                27.0897758
              ],
              [
                55.1672881,
                27.0847857
              ],
              [
                55.164508,
                27.0847856
              ],
              [
                55.1633981,
                27.084507
              ],
              [
                55.1572848,
                27.084507
              ],
              [
                55.1545082,
                27.084507
              ],
              [
                55.1492316,
                27.084507
              ],
              [
                55.1492316,
                27.0847857
              ],
              [
                55.1486749,
                27.0847857
              ],
              [
                55.1477322,
                27.0852812
              ],
              [
                55.1475649,
                27.0856129
              ],
              [
                55.1470083,
                27.0856129
              ],
              [
                55.1464516,
                27.0861703
              ],
              [
                55.1456183,
                27.0861703
              ],
              [
                55.141175,
                27.0870065
              ],
              [
                55.138395,
                27.0870065
              ],
              [
                55.1378418,
                27.0867278
              ],
              [
                55.1372852,
                27.0870065
              ],
              [
                55.1342285,
                27.0870065
              ],
              [
                55.1336752,
                27.0872853
              ],
              [
                55.1328419,
                27.0872853
              ],
              [
                55.1320085,
                27.0878337
              ],
              [
                55.1206187,
                27.090621
              ],
              [
                55.0500598,
                27.1033978
              ],
              [
                55.0495033,
                27.1036767
              ],
              [
                55.0345035,
                27.1061672
              ],
              [
                55.0322802,
                27.1061672
              ],
              [
                54.9908908,
                27.1136662
              ],
              [
                54.9889442,
                27.1136663
              ],
              [
                54.9878342,
                27.1139541
              ],
              [
                54.9858909,
                27.1139541
              ],
              [
                54.9658879,
                27.1172809
              ],
              [
                54.9631112,
                27.1172809
              ],
              [
                54.9617212,
                27.1175597
              ],
              [
                54.961168,
                27.1172809
              ],
              [
                54.9600546,
                27.1175597
              ],
              [
                54.9472781,
                27.1175597
              ],
              [
                54.9461649,
                27.1178384
              ],
              [
                54.9447782,
                27.1178385
              ],
              [
                54.9431115,
                27.1181171
              ],
              [
                54.9392217,
                27.1183959
              ],
              [
                54.9383884,
                27.118396
              ],
              [
                54.9317217,
                27.1183959
              ],
              [
                54.9308884,
                27.1186747
              ],
              [
                54.9281084,
                27.1186747
              ],
              [
                54.9272752,
                27.1189533
              ],
              [
                54.9247751,
                27.1189534
              ],
              [
                54.9242219,
                27.1192322
              ],
              [
                54.9214418,
                27.1192322
              ],
              [
                54.9189419,
                27.1197896
              ],
              [
                54.9169986,
                27.1197896
              ],
              [
                54.9167187,
                27.1200594
              ],
              [
                54.9144987,
                27.1200594
              ],
              [
                54.9136654,
                27.1203382
              ],
              [
                54.912552,
                27.1200593
              ],
              [
                54.9122754,
                27.1203381
              ],
              [
                54.9069988,
                27.1203381
              ],
              [
                54.9058855,
                27.1206169
              ],
              [
                54.8972756,
                27.1206169
              ],
              [
                54.8964423,
                27.1203382
              ],
              [
                54.8947757,
                27.1203382
              ],
              [
                54.8939424,
                27.1200594
              ],
              [
                54.8908857,
                27.1200594
              ],
              [
                54.8900523,
                27.1197896
              ],
              [
                54.8886624,
                27.1197896
              ],
              [
                54.8883858,
                27.1195109
              ],
              [
                54.8858858,
                27.1195109
              ],
              [
                54.8853292,
                27.1192322
              ],
              [
                54.8839425,
                27.1192322
              ],
              [
                54.8833859,
                27.1189534
              ],
              [
                54.8822724,
                27.1189534
              ],
              [
                54.8792193,
                27.118396
              ],
              [
                54.8775526,
                27.118396
              ],
              [
                54.8656062,
                27.116175
              ],
              [
                54.8639394,
                27.116175
              ],
              [
                54.8622728,
                27.1156176
              ],
              [
                54.8611629,
                27.1156175
              ],
              [
                54.8606062,
                27.1153387
              ],
              [
                54.8600495,
                27.1153388
              ],
              [
                54.8597728,
                27.11506
              ],
              [
                54.8586628,
                27.1150601
              ],
              [
                54.8586629,
                27.1147813
              ],
              [
                54.8581062,
                27.1147814
              ],
              [
                54.8578295,
                27.1145115
              ],
              [
                54.8564396,
                27.1145115
              ],
              [
                54.8558829,
                27.1142328
              ],
              [
                54.8547729,
                27.1142328
              ],
              [
                54.8486631,
                27.1122817
              ],
              [
                54.8481065,
                27.1122816
              ],
              [
                54.8475497,
                27.1120029
              ],
              [
                54.8467164,
                27.1120029
              ],
              [
                54.8464398,
                27.1117241
              ],
              [
                54.8425498,
                27.1117241
              ],
              [
                54.8419931,
                27.1114544
              ],
              [
                54.8389398,
                27.1114544
              ],
              [
                54.8383832,
                27.1111757
              ],
              [
                54.8356067,
                27.1111757
              ],
              [
                54.8344933,
                27.1108969
              ],
              [
                54.8317168,
                27.1108968
              ],
              [
                54.8306068,
                27.1106182
              ],
              [
                54.8247701,
                27.1106181
              ],
              [
                54.8233834,
                27.1103395
              ],
              [
                54.8194935,
                27.1103395
              ],
              [
                54.8183836,
                27.1100607
              ],
              [
                54.8164154,
                27.1100607
              ],
              [
                54.7228997,
                27.1227027
              ],
              [
                54.7066761,
                27.0649279
              ],
              [
                54.6968072,
                27.0334411
              ],
              [
                54.7036736,
                27.0040794
              ],
              [
                54.6974938,
                26.9826649
              ],
              [
                54.6734653,
                26.9430761
              ],
              [
                54.6551182,
                26.9342307
              ],
              [
                54.6175298,
                26.9160947
              ],
              [
                54.6166617,
                26.9156788
              ],
              [
                54.6164667,
                26.9150765
              ],
              [
                54.61591,
                26.9150765
              ],
              [
                54.6153566,
                26.9147979
              ],
              [
                54.6139666,
                26.9147979
              ],
              [
                54.61091,
                26.9139708
              ],
              [
                54.6098,
                26.9139708
              ],
              [
                54.6084101,
                26.9136922
              ],
              [
                54.6073002,
                26.9131349
              ],
              [
                54.6056334,
                26.9131348
              ],
              [
                54.6053533,
                26.9128561
              ],
              [
                54.6042435,
                26.9128561
              ],
              [
                54.6036868,
                26.9125775
              ],
              [
                54.6025768,
                26.9125775
              ],
              [
                54.6020201,
                26.9122988
              ],
              [
                54.6011868,
                26.9122988
              ],
              [
                54.6011869,
                26.9120201
              ],
              [
                54.6000769,
                26.9120202
              ],
              [
                54.598967,
                26.9114628
              ],
              [
                54.5981337,
                26.9114628
              ],
              [
                54.568964,
                26.9020239
              ],
              [
                54.567574,
                26.9020238
              ],
              [
                54.5670208,
                26.9017453
              ],
              [
                54.5656308,
                26.9017452
              ],
              [
                54.5647974,
                26.9014665
              ],
              [
                54.5634074,
                26.9014665
              ],
              [
                54.5625741,
                26.9011879
              ],
              [
                54.5611875,
                26.9011879
              ],
              [
                54.5603542,
                26.9009091
              ],
              [
                54.5597975,
                26.9009091
              ],
              [
                54.5592408,
                26.9006306
              ],
              [
                54.5575742,
                26.9006306
              ],
              [
                54.5572976,
                26.9003518
              ],
              [
                54.5561876,
                26.9003519
              ],
              [
                54.5556309,
                26.9000732
              ],
              [
                54.5547977,
                26.9000732
              ],
              [
                54.5497977,
                26.8986888
              ],
              [
                54.5486843,
                26.8986889
              ],
              [
                54.5484077,
                26.8984102
              ],
              [
                54.5475744,
                26.8984102
              ],
              [
                54.5475744,
                26.8981315
              ],
              [
                54.5464644,
                26.8981314
              ],
              [
                54.5461844,
                26.8978528
              ],
              [
                54.545351,
                26.8978529
              ],
              [
                54.5447978,
                26.8975741
              ],
              [
                54.5436843,
                26.8975742
              ],
              [
                54.5434078,
                26.8972956
              ],
              [
                54.5414645,
                26.8964684
              ],
              [
                54.5403511,
                26.8964685
              ],
              [
                54.5397978,
                26.8961898
              ],
              [
                54.5381312,
                26.8961898
              ],
              [
                54.5228514,
                26.8939604
              ],
              [
                54.5164616,
                26.8939604
              ],
              [
                54.5145182,
                26.8945178
              ],
              [
                54.5134049,
                26.8945179
              ],
              [
                54.5128516,
                26.8947964
              ],
              [
                54.5028518,
                26.8972955
              ],
              [
                54.5020185,
                26.8972955
              ],
              [
                54.5000718,
                26.8978529
              ],
              [
                54.4981285,
                26.8978529
              ],
              [
                54.4978518,
                26.8981315
              ],
              [
                54.4956285,
                26.8981315
              ],
              [
                54.4956286,
                26.8984102
              ],
              [
                54.4950718,
                26.8984102
              ],
              [
                54.4947952,
                26.8986888
              ],
              [
                54.4825721,
                26.9011879
              ],
              [
                54.4809055,
                26.9011879
              ],
              [
                54.4806288,
                26.9014664
              ],
              [
                54.4795155,
                26.9014665
              ],
              [
                54.4789622,
                26.9017453
              ],
              [
                54.4781289,
                26.9017452
              ],
              [
                54.4722923,
                26.9028509
              ],
              [
                54.4709056,
                26.9034082
              ],
              [
                54.4697922,
                26.9034082
              ],
              [
                54.4664589,
                26.9045229
              ],
              [
                54.4653491,
                26.904523
              ],
              [
                54.4453494,
                26.9100784
              ],
              [
                54.4439594,
                26.9100784
              ],
              [
                54.4431261,
                26.9103571
              ],
              [
                54.4417361,
                26.9103571
              ],
              [
                54.4409027,
                26.9106268
              ],
              [
                54.4384028,
                26.9106267
              ],
              [
                54.4342362,
                26.9114628
              ],
              [
                54.4331262,
                26.9117415
              ],
              [
                54.4317362,
                26.9117414
              ],
              [
                54.4311795,
                26.9120202
              ],
              [
                54.4286796,
                26.9120201
              ],
              [
                54.4281263,
                26.9122988
              ],
              [
                54.4270129,
                26.9122988
              ],
              [
                54.424513,
                26.9128561
              ],
              [
                54.4231265,
                26.9128561
              ],
              [
                54.4225698,
                26.9131349
              ],
              [
                54.4197932,
                26.9131349
              ],
              [
                54.4192365,
                26.9128561
              ],
              [
                54.4172897,
                26.9128562
              ],
              [
                54.4145131,
                26.9128562
              ],
              [
                54.4131232,
                26.9125776
              ],
              [
                54.40729,
                26.9125776
              ],
              [
                54.4056233,
                26.9122988
              ],
              [
                54.40368,
                26.9122988
              ],
              [
                54.4003467,
                26.9117414
              ],
              [
                54.3984001,
                26.9117415
              ],
              [
                54.3972902,
                26.9114629
              ],
              [
                54.3936802,
                26.9114629
              ],
              [
                54.3931236,
                26.9111841
              ],
              [
                54.3886803,
                26.9111841
              ],
              [
                54.387567,
                26.9109055
              ],
              [
                54.3836804,
                26.9109055
              ],
              [
                54.3831237,
                26.9111842
              ],
              [
                54.3775671,
                26.9111841
              ],
              [
                54.3770104,
                26.9114629
              ],
              [
                54.3753438,
                26.9114628
              ],
              [
                54.3739571,
                26.9117415
              ],
              [
                54.3717338,
                26.9117415
              ],
              [
                54.3700672,
                26.9120202
              ],
              [
                54.3634007,
                26.9120202
              ],
              [
                54.3622873,
                26.9122988
              ],
              [
                54.361734,
                26.9120202
              ],
              [
                54.3581207,
                26.9120202
              ],
              [
                54.3514542,
                26.9111841
              ],
              [
                54.3391277,
                26.9111842
              ],
              [
                54.3381211,
                26.9111842
              ],
              [
                54.3372878,
                26.9109055
              ],
              [
                54.3347878,
                26.9109055
              ],
              [
                54.3339545,
                26.9106268
              ],
              [
                54.3283979,
                26.9100784
              ],
              [
                54.3270113,
                26.9097998
              ],
              [
                54.324508,
                26.9092425
              ],
              [
                54.3225647,
                26.9092425
              ],
              [
                54.3146516,
                26.9129436
              ],
              [
                54.309375,
                26.9129436
              ],
              [
                54.307985,
                26.912665
              ],
              [
                54.3057651,
                26.912665
              ],
              [
                54.3043751,
                26.9123952
              ],
              [
                54.2993752,
                26.9123953
              ],
              [
                54.2982618,
                26.9121167
              ],
              [
                54.2965952,
                26.9121167
              ],
              [
                54.2957619,
                26.9118379
              ],
              [
                54.2943752,
                26.911838
              ],
              [
                54.2846521,
                26.9096087
              ],
              [
                54.2832621,
                26.9096086
              ],
              [
                54.2782622,
                26.9087727
              ],
              [
                54.2679857,
                26.9087727
              ],
              [
                54.2643724,
                26.9082244
              ],
              [
                54.2621524,
                26.9082243
              ],
              [
                54.2604824,
                26.9079456
              ],
              [
                54.2579824,
                26.9079456
              ],
              [
                54.2557626,
                26.907667
              ],
              [
                54.2543725,
                26.9079457
              ],
              [
                54.2496493,
                26.9079456
              ],
              [
                54.248816,
                26.907667
              ],
              [
                54.245206,
                26.907667
              ],
              [
                54.2443727,
                26.9079456
              ],
              [
                54.2335396,
                26.9079457
              ],
              [
                54.2321496,
                26.9082243
              ],
              [
                54.2302063,
                26.9082244
              ],
              [
                54.226593,
                26.9087727
              ],
              [
                54.2246497,
                26.9087727
              ],
              [
                54.2232597,
                26.9090513
              ],
              [
                54.221593,
                26.9090513
              ],
              [
                54.2193698,
                26.9096087
              ],
              [
                54.2179832,
                26.9096087
              ],
              [
                54.20965,
                26.911002
              ],
              [
                54.2085366,
                26.9115593
              ],
              [
                54.2077033,
                26.9115594
              ],
              [
                54.1799238,
                26.9179505
              ],
              [
                54.166314,
                26.923506
              ],
              [
                54.1654807,
                26.923506
              ],
              [
                54.161034,
                26.9254477
              ],
              [
                54.1602007,
                26.9254477
              ],
              [
                54.1577007,
                26.926005
              ],
              [
                54.1563142,
                26.9260049
              ],
              [
                54.1546475,
                26.9265624
              ],
              [
                54.1532575,
                26.9265624
              ],
              [
                54.1496477,
                26.9271197
              ],
              [
                54.1474243,
                26.9271196
              ],
              [
                54.1460343,
                26.9273894
              ],
              [
                54.1443676,
                26.9273895
              ],
              [
                54.1415911,
                26.9279467
              ],
              [
                54.1410344,
                26.9279466
              ],
              [
                54.1407578,
                26.9282255
              ],
              [
                54.1402011,
                26.9282254
              ],
              [
                54.1396444,
                26.928504
              ],
              [
                54.124368,
                26.9312817
              ],
              [
                54.1235347,
                26.9315605
              ],
              [
                54.1227014,
                26.9315605
              ],
              [
                54.1213113,
                26.9321178
              ],
              [
                54.1202014,
                26.9321178
              ],
              [
                54.1096449,
                26.9343382
              ],
              [
                54.1082549,
                26.9343382
              ],
              [
                54.0899218,
                26.937116
              ],
              [
                54.0876985,
                26.9371159
              ],
              [
                54.0863085,
                26.9373946
              ],
              [
                54.0832553,
                26.9373946
              ],
              [
                54.0818654,
                26.9376734
              ],
              [
                54.0788087,
                26.9376733
              ],
              [
                54.0776987,
                26.937943
              ],
              [
                54.0757555,
                26.937943
              ],
              [
                54.0746421,
                26.9382217
              ],
              [
                54.0732555,
                26.9382217
              ],
              [
                54.0721421,
                26.9385003
              ],
              [
                54.0704755,
                26.9385003
              ],
              [
                54.0693655,
                26.938779
              ],
              [
                54.0663089,
                26.9387791
              ],
              [
                54.0654756,
                26.9390577
              ],
              [
                54.0596424,
                26.9390577
              ],
              [
                54.0588091,
                26.9393363
              ],
              [
                54.0560325,
                26.9393363
              ],
              [
                54.0554757,
                26.9396151
              ],
              [
                54.0538092,
                26.9396151
              ],
              [
                54.0524191,
                26.9398937
              ],
              [
                54.0504759,
                26.9398938
              ],
              [
                54.0490858,
                26.9401724
              ],
              [
                54.0463093,
                26.9401724
              ],
              [
                54.0457526,
                26.9404511
              ],
              [
                54.0435293,
                26.9404511
              ],
              [
                54.0407527,
                26.9412871
              ],
              [
                54.0340862,
                26.9418355
              ],
              [
                54.0307529,
                26.9418355
              ],
              [
                54.0299195,
                26.9421141
              ],
              [
                54.0285295,
                26.9421141
              ],
              [
                54.0276962,
                26.9423928
              ],
              [
                54.0139465,
                26.9454533
              ],
              [
                54.0131132,
                26.945732
              ],
              [
                54.0120033,
                26.9457321
              ],
              [
                54.0106133,
                26.9462894
              ],
              [
                54.0083933,
                26.9462893
              ],
              [
                54.0081132,
                26.9465681
              ],
              [
                54.0072799,
                26.946568
              ],
              [
                54.0070033,
                26.9468467
              ],
              [
                54.0064466,
                26.9468467
              ],
              [
                54.0047801,
                26.9474041
              ],
              [
                54.0036701,
                26.9474042
              ],
              [
                54.0031134,
                26.9476827
              ],
              [
                53.9956135,
                26.9493457
              ],
              [
                53.98844,
                26.9488264
              ],
              [
                53.9847803,
                26.9476828
              ],
              [
                53.983947,
                26.9476827
              ],
              [
                53.9831138,
                26.947404
              ],
              [
                53.9814471,
                26.9474041
              ],
              [
                53.9808904,
                26.9471254
              ],
              [
                53.9725572,
                26.9471253
              ],
              [
                53.9695006,
                26.9476827
              ],
              [
                53.9678339,
                26.9476828
              ],
              [
                53.9156115,
                26.9621289
              ],
              [
                53.9103315,
                26.9635133
              ],
              [
                53.9086649,
                26.9637919
              ],
              [
                53.8886652,
                26.9710106
              ],
              [
                53.8881085,
                26.9712893
              ],
              [
                53.8878319,
                26.971568
              ],
              [
                53.882832,
                26.9749031
              ],
              [
                53.8344961,
                27.0054692
              ],
              [
                53.8223896,
                27.0144692
              ],
              [
                53.8218329,
                27.0147479
              ],
              [
                53.8221096,
                27.0139118
              ],
              [
                53.821833,
                27.0130757
              ],
              [
                53.8190564,
                27.0114126
              ],
              [
                53.8037766,
                27.005578
              ],
              [
                53.7767025,
                26.9887834
              ],
              [
                53.7668473,
                26.9668757
              ],
              [
                53.7626806,
                26.9499305
              ],
              [
                53.7624007,
                26.9488159
              ],
              [
                53.762124,
                26.9471528
              ],
              [
                53.7587907,
                26.9379837
              ],
              [
                53.7560107,
                26.9349274
              ],
              [
                53.7504575,
                26.9329768
              ],
              [
                53.7432342,
                26.9329768
              ],
              [
                53.7415676,
                26.9332554
              ],
              [
                53.7387876,
                26.9332554
              ],
              [
                53.7368444,
                26.933534
              ],
              [
                53.7343444,
                26.933534
              ],
              [
                53.7235113,
                26.935206
              ],
              [
                53.7132314,
                26.9382624
              ],
              [
                53.7123981,
                26.9388198
              ],
              [
                53.694065,
                26.9429818
              ],
              [
                53.6315627,
                26.9579851
              ],
              [
                53.6271161,
                26.9593783
              ],
              [
                53.6154496,
                26.9621562
              ],
              [
                53.6140631,
                26.9624349
              ],
              [
                53.6073931,
                26.9638193
              ],
              [
                53.5821169,
                26.97271
              ],
              [
                53.5617705,
                26.9892768
              ],
              [
                53.538161,
                26.9956681
              ],
              [
                53.5364943,
                26.9956681
              ],
              [
                53.5234378,
                26.9973311
              ],
              [
                53.5155279,
                26.9991393
              ],
              [
                53.513028,
                26.9991393
              ],
              [
                53.5041381,
                26.9999662
              ],
              [
                53.5008048,
                26.9999663
              ],
              [
                53.5002481,
                27.0002449
              ],
              [
                53.4863584,
                27.0002449
              ],
              [
                53.485525,
                26.9999663
              ],
              [
                53.478865,
                27.003116
              ],
              [
                53.477475,
                27.003116
              ],
              [
                53.4769217,
                27.0031159
              ],
              [
                53.4755317,
                27.0033946
              ],
              [
                53.4724751,
                27.0033947
              ],
              [
                53.4710884,
                27.0036733
              ],
              [
                53.4691418,
                27.0036733
              ],
              [
                53.4658086,
                27.0042216
              ],
              [
                53.4638653,
                27.0042216
              ],
              [
                53.4624752,
                27.0045092
              ],
              [
                53.4474755,
                27.0045093
              ],
              [
                53.4469188,
                27.0042216
              ],
              [
                53.4281624,
                26.9964219
              ],
              [
                53.4274584,
                26.9955119
              ],
              [
                53.4269048,
                26.9943818
              ],
              [
                53.3110275,
                26.9468933
              ],
              [
                53.1291955,
                26.8724691
              ],
              [
                52.9477745,
                26.7105243
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554939,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بندرعباس",
          "name:cs": "Bandar Abbás",
          "name:en": "Bandar-e-Abbas County",
          "name:ko": "반다레아바스군",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q154757",
          "wikipedia": "en:Bandar Abbas County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.2940682,
                27.5076412
              ],
              [
                55.3286539,
                27.5124417
              ],
              [
                55.3615872,
                27.5130186
              ],
              [
                55.3784586,
                27.5185482
              ],
              [
                55.4347425,
                27.5178766
              ],
              [
                55.472913,
                27.5136144
              ],
              [
                55.4994301,
                27.5113843
              ],
              [
                55.5041979,
                27.5096414
              ],
              [
                55.5052004,
                27.5097299
              ],
              [
                55.5090903,
                27.5097299
              ],
              [
                55.5143669,
                27.5100088
              ],
              [
                55.5152001,
                27.5102878
              ],
              [
                55.5328631,
                27.5059478
              ],
              [
                55.5353631,
                27.5065057
              ],
              [
                55.5381397,
                27.5065056
              ],
              [
                55.5389731,
                27.5062267
              ],
              [
                55.540363,
                27.5056689
              ],
              [
                55.6011682,
                27.4845796
              ],
              [
                55.6020014,
                27.4840217
              ],
              [
                55.6025582,
                27.4834639
              ],
              [
                55.6031149,
                27.4834639
              ],
              [
                55.6373176,
                27.4710145
              ],
              [
                55.6392609,
                27.4693502
              ],
              [
                55.6806266,
                27.4514609
              ],
              [
                55.6822933,
                27.4506244
              ],
              [
                55.6839599,
                27.4497878
              ],
              [
                55.6847933,
                27.4497879
              ],
              [
                55.6984064,
                27.4459019
              ],
              [
                55.7222961,
                27.4330012
              ],
              [
                55.7289626,
                27.43355
              ],
              [
                55.7306293,
                27.43355
              ],
              [
                55.7314624,
                27.4332712
              ],
              [
                55.7356291,
                27.4332712
              ],
              [
                55.7361858,
                27.43355
              ],
              [
                55.7364625,
                27.4332711
              ],
              [
                55.7367391,
                27.43355
              ],
              [
                55.7372958,
                27.4332712
              ],
              [
                55.7481289,
                27.4313369
              ],
              [
                55.7561856,
                27.4277204
              ],
              [
                55.7570188,
                27.4277204
              ],
              [
                55.7572955,
                27.4274415
              ],
              [
                55.780055,
                27.4219315
              ],
              [
                55.7808884,
                27.4216526
              ],
              [
                55.8189645,
                27.4159038
              ],
              [
                55.8382974,
                27.4081221
              ],
              [
                55.8410774,
                27.4072856
              ],
              [
                55.8542637,
                27.4026009
              ],
              [
                55.8548204,
                27.4026008
              ],
              [
                55.8575971,
                27.4026008
              ],
              [
                55.8598205,
                27.4031585
              ],
              [
                55.8614872,
                27.4031585
              ],
              [
                55.8638204,
                27.4014958
              ],
              [
                55.8654871,
                27.4014958
              ],
              [
                55.8829466,
                27.3944332
              ],
              [
                55.8843364,
                27.3944331
              ],
              [
                55.9955472,
                27.3839199
              ],
              [
                55.9804913,
                27.347984
              ],
              [
                55.981089,
                27.3284993
              ],
              [
                55.9810891,
                27.3276627
              ],
              [
                55.9928509,
                27.3321255
              ],
              [
                56.0089871,
                27.3266354
              ],
              [
                56.0261532,
                27.3147394
              ],
              [
                56.0306164,
                27.2924691
              ],
              [
                56.0445109,
                27.2801142
              ],
              [
                56.0420075,
                27.2745657
              ],
              [
                56.0397875,
                27.271787
              ],
              [
                56.0357663,
                27.265922
              ],
              [
                56.0337063,
                27.2521882
              ],
              [
                56.0267509,
                27.2433987
              ],
              [
                56.0264743,
                27.2428412
              ],
              [
                56.0236977,
                27.2370052
              ],
              [
                56.0228644,
                27.2347841
              ],
              [
                56.0200843,
                27.2320056
              ],
              [
                56.0195312,
                27.2320055
              ],
              [
                56.0084679,
                27.230417
              ],
              [
                56.0081913,
                27.2298685
              ],
              [
                55.9920782,
                27.2181974
              ],
              [
                55.9884682,
                27.215419
              ],
              [
                55.9762452,
                27.2098713
              ],
              [
                55.9754117,
                27.2098712
              ],
              [
                55.974855,
                27.2095925
              ],
              [
                55.9740218,
                27.2095924
              ],
              [
                55.9704117,
                27.2087562
              ],
              [
                55.9698552,
                27.209035
              ],
              [
                55.9687451,
                27.209035
              ],
              [
                55.9681885,
                27.2093138
              ],
              [
                55.9311327,
                27.1962978
              ],
              [
                55.9233561,
                27.1971342
              ],
              [
                55.9205761,
                27.1979615
              ],
              [
                55.9191896,
                27.1979615
              ],
              [
                55.9183562,
                27.1982403
              ],
              [
                55.9169664,
                27.1982403
              ],
              [
                55.9066899,
                27.203798
              ],
              [
                55.9055765,
                27.2046255
              ],
              [
                55.9041898,
                27.2057406
              ],
              [
                55.9036332,
                27.2057406
              ],
              [
                55.9027999,
                27.2059938
              ],
              [
                55.8972432,
                27.2076831
              ],
              [
                55.8961335,
                27.207683
              ],
              [
                55.882301,
                27.2128087
              ],
              [
                55.819111,
                27.2081219
              ],
              [
                55.8171678,
                27.2081219
              ],
              [
                55.7799852,
                27.1962447
              ],
              [
                55.7777617,
                27.1962447
              ],
              [
                55.7763752,
                27.195957
              ],
              [
                55.7738752,
                27.1956872
              ],
              [
                55.7597054,
                27.1956872
              ],
              [
                55.7585954,
                27.195957
              ],
              [
                55.7572055,
                27.195957
              ],
              [
                55.7563721,
                27.1962448
              ],
              [
                55.7549855,
                27.1962448
              ],
              [
                55.7547056,
                27.1965236
              ],
              [
                55.7519289,
                27.1973509
              ],
              [
                55.7472056,
                27.197351
              ],
              [
                55.746649,
                27.1970721
              ],
              [
                55.7458157,
                27.1970721
              ],
              [
                55.7438723,
                27.195957
              ],
              [
                55.7410957,
                27.1931781
              ],
              [
                55.7383158,
                27.1865144
              ],
              [
                55.7380392,
                27.1829082
              ],
              [
                55.7377625,
                27.1823506
              ],
              [
                55.7380392,
                27.1815144
              ],
              [
                55.7385959,
                27.1779081
              ],
              [
                55.739429,
                27.1759568
              ],
              [
                55.7397058,
                27.1740143
              ],
              [
                55.7424825,
                27.1659569
              ],
              [
                55.7427623,
                27.1628994
              ],
              [
                55.7422057,
                27.1606783
              ],
              [
                55.7413725,
                27.1578996
              ],
              [
                55.7402624,
                27.1531785
              ],
              [
                55.741649,
                27.143179
              ],
              [
                55.7430391,
                27.1409579
              ],
              [
                55.7483155,
                27.1331707
              ],
              [
                55.7488722,
                27.1298434
              ],
              [
                55.7485956,
                27.1273437
              ],
              [
                55.7483155,
                27.12595
              ],
              [
                55.7452677,
                27.1156147
              ],
              [
                55.7357657,
                27.0913038
              ],
              [
                55.7484051,
                27.0753292
              ],
              [
                55.7595484,
                27.0596507
              ],
              [
                55.7572817,
                27.0479556
              ],
              [
                55.7594717,
                27.0430902
              ],
              [
                55.7582577,
                27.0418757
              ],
              [
                55.758233,
                26.975742
              ],
              [
                55.7598118,
                26.9623899
              ],
              [
                55.9574883,
                26.9857244
              ],
              [
                56.0237826,
                27.021745
              ],
              [
                56.0622021,
                27.0426148
              ],
              [
                56.175155,
                27.0872511
              ],
              [
                56.2188637,
                27.0972753
              ],
              [
                56.3056045,
                27.117166
              ],
              [
                56.3217541,
                27.1208689
              ],
              [
                56.4724725,
                27.1312582
              ],
              [
                56.5306908,
                27.1208953
              ],
              [
                56.6269677,
                27.1037558
              ],
              [
                56.7019727,
                27.0791231
              ],
              [
                56.7595273,
                27.0602176
              ],
              [
                56.7730358,
                27.1119686
              ],
              [
                56.7741684,
                27.1127346
              ],
              [
                56.7742564,
                27.1127532
              ],
              [
                56.775237,
                27.1129618
              ],
              [
                56.7759567,
                27.1131149
              ],
              [
                56.7764073,
                27.1132226
              ],
              [
                56.7768339,
                27.1133246
              ],
              [
                56.7772698,
                27.1134288
              ],
              [
                56.7777762,
                27.1135167
              ],
              [
                56.7780173,
                27.1135585
              ],
              [
                56.7780483,
                27.1135615
              ],
              [
                56.7780825,
                27.1135649
              ],
              [
                56.7782542,
                27.1135819
              ],
              [
                56.7784934,
                27.1136566
              ],
              [
                56.778915,
                27.1137997
              ],
              [
                56.7789869,
                27.1138191
              ],
              [
                56.7791175,
                27.1138544
              ],
              [
                56.77961,
                27.1139522
              ],
              [
                56.7798548,
                27.1140008
              ],
              [
                56.7803631,
                27.1141332
              ],
              [
                56.7805542,
                27.114183
              ],
              [
                56.7815106,
                27.1144319
              ],
              [
                56.7823817,
                27.1147791
              ],
              [
                56.7827803,
                27.1149853
              ],
              [
                56.7837658,
                27.1153427
              ],
              [
                56.784837,
                27.116571
              ],
              [
                56.785326,
                27.1178129
              ],
              [
                56.7855406,
                27.118806
              ],
              [
                56.7854762,
                27.119885
              ],
              [
                56.7852294,
                27.1211837
              ],
              [
                56.7851651,
                27.1227307
              ],
              [
                56.7853582,
                27.1240103
              ],
              [
                56.7856693,
                27.1249747
              ],
              [
                56.7862165,
                27.126111
              ],
              [
                56.7869246,
                27.1270468
              ],
              [
                56.787622,
                27.1277056
              ],
              [
                56.7884159,
                27.1281353
              ],
              [
                56.7891347,
                27.1283262
              ],
              [
                56.7906904,
                27.1284695
              ],
              [
                56.7918813,
                27.1286319
              ],
              [
                56.792525,
                27.1287846
              ],
              [
                56.7931044,
                27.1292525
              ],
              [
                56.7935121,
                27.1298922
              ],
              [
                56.793673,
                27.1307516
              ],
              [
                56.7936194,
                27.1315154
              ],
              [
                56.7936493,
                27.1317882
              ],
              [
                56.7937052,
                27.1322984
              ],
              [
                56.793952,
                27.1333009
              ],
              [
                56.7940056,
                27.1342223
              ],
              [
                56.7938661,
                27.1349527
              ],
              [
                56.7935014,
                27.135583
              ],
              [
                56.7925036,
                27.1366522
              ],
              [
                56.7918706,
                27.1375689
              ],
              [
                56.7916882,
                27.1381417
              ],
              [
                56.791656,
                27.1387433
              ],
              [
                56.7917311,
                27.1393734
              ],
              [
                56.7919671,
                27.1401753
              ],
              [
                56.7927289,
                27.1421326
              ],
              [
                56.7928308,
                27.1429823
              ],
              [
                56.792804,
                27.1446626
              ],
              [
                56.808045,
                27.1584722
              ],
              [
                56.8038619,
                27.1626457
              ],
              [
                56.800381,
                27.1727358
              ],
              [
                56.8000986,
                27.1761644
              ],
              [
                56.8020503,
                27.180477
              ],
              [
                56.8089252,
                27.1846474
              ],
              [
                56.8102068,
                27.1882695
              ],
              [
                56.8100769,
                27.1922094
              ],
              [
                56.8109352,
                27.196126
              ],
              [
                56.8127415,
                27.1998704
              ],
              [
                56.8197058,
                27.2048929
              ],
              [
                56.8281691,
                27.2112367
              ],
              [
                56.8321366,
                27.2156251
              ],
              [
                56.8345089,
                27.2197482
              ],
              [
                56.8364198,
                27.2260036
              ],
              [
                56.836353,
                27.2289912
              ],
              [
                56.8370589,
                27.2321139
              ],
              [
                56.8375105,
                27.2361931
              ],
              [
                56.8383022,
                27.2430082
              ],
              [
                56.8412231,
                27.2534907
              ],
              [
                56.8435814,
                27.2595382
              ],
              [
                56.8457856,
                27.2639486
              ],
              [
                56.8472806,
                27.2669682
              ],
              [
                56.8493406,
                27.2701371
              ],
              [
                56.8521659,
                27.2735145
              ],
              [
                56.8580245,
                27.2823237
              ],
              [
                56.8642043,
                27.2939944
              ],
              [
                56.8667845,
                27.3007838
              ],
              [
                56.8679003,
                27.3060939
              ],
              [
                56.869307,
                27.3114076
              ],
              [
                56.8702452,
                27.3154356
              ],
              [
                56.8714469,
                27.3191109
              ],
              [
                56.8730335,
                27.3267693
              ],
              [
                56.874879,
                27.3322242
              ],
              [
                56.8773794,
                27.3379962
              ],
              [
                56.8788655,
                27.343845
              ],
              [
                56.8865557,
                27.3654685
              ],
              [
                56.8905424,
                27.3749285
              ],
              [
                56.8974971,
                27.3908978
              ],
              [
                56.9173466,
                27.4199682
              ],
              [
                56.9261613,
                27.4295178
              ],
              [
                56.9625878,
                27.4677711
              ],
              [
                56.9783746,
                27.4842432
              ],
              [
                56.9800757,
                27.4998973
              ],
              [
                56.9791044,
                27.5157306
              ],
              [
                56.9763995,
                27.5267074
              ],
              [
                56.9739018,
                27.5403672
              ],
              [
                56.9594763,
                27.5840679
              ],
              [
                56.9450562,
                27.6167756
              ],
              [
                56.9227408,
                27.6576833
              ],
              [
                56.9129561,
                27.668022
              ],
              [
                56.9066884,
                27.6785978
              ],
              [
                56.9054889,
                27.682084
              ],
              [
                56.9004249,
                27.6855803
              ],
              [
                56.8958758,
                27.6928004
              ],
              [
                56.8924426,
                27.6995641
              ],
              [
                56.8808557,
                27.7201736
              ],
              [
                56.8793535,
                27.7219041
              ],
              [
                56.8776797,
                27.7253991
              ],
              [
                56.8721058,
                27.7403459
              ],
              [
                56.8706416,
                27.7476579
              ],
              [
                56.8654918,
                27.7562411
              ],
              [
                56.8627793,
                27.7654199
              ],
              [
                56.8595068,
                27.7740863
              ],
              [
                56.8592896,
                27.7772898
              ],
              [
                56.8563938,
                27.7748864
              ],
              [
                56.8507719,
                27.7726461
              ],
              [
                56.8475961,
                27.7717727
              ],
              [
                56.8436908,
                27.7709753
              ],
              [
                56.8350648,
                27.7684691
              ],
              [
                56.8285846,
                27.7650515
              ],
              [
                56.816225,
                27.7606843
              ],
              [
                56.8073415,
                27.7564689
              ],
              [
                56.8025705,
                27.7545887
              ],
              [
                56.7972993,
                27.7520635
              ],
              [
                56.7940176,
                27.7515099
              ],
              [
                56.7876674,
                27.7490619
              ],
              [
                56.7802034,
                27.7453444
              ],
              [
                56.7745039,
                27.7417216
              ],
              [
                56.767927,
                27.7383604
              ],
              [
                56.7569465,
                27.7318519
              ],
              [
                56.7461309,
                27.7268726
              ],
              [
                56.7347839,
                27.7225575
              ],
              [
                56.7303027,
                27.7209049
              ],
              [
                56.7271971,
                27.7214102
              ],
              [
                56.7250592,
                27.7201682
              ],
              [
                56.7221724,
                27.7182177
              ],
              [
                56.718868,
                27.724594
              ],
              [
                56.7169189,
                27.736161
              ],
              [
                56.7166421,
                27.7400535
              ],
              [
                56.7160055,
                27.7427071
              ],
              [
                56.714339,
                27.7482678
              ],
              [
                56.7132257,
                27.755484
              ],
              [
                56.689748,
                27.779558
              ],
              [
                56.6889148,
                27.7817718
              ],
              [
                56.6639119,
                27.8398278
              ],
              [
                56.6558553,
                27.8520497
              ],
              [
                56.6539119,
                27.8548308
              ],
              [
                56.6533552,
                27.8559377
              ],
              [
                56.6525221,
                27.8567748
              ],
              [
                56.6522453,
                27.8576117
              ],
              [
                56.6514121,
                27.8584399
              ],
              [
                56.6511354,
                27.8592768
              ],
              [
                56.6241892,
                27.9120778
              ],
              [
                56.623076,
                27.9131939
              ],
              [
                56.6216891,
                27.914859
              ],
              [
                56.6177993,
                27.9173611
              ],
              [
                56.614466,
                27.9173611
              ],
              [
                56.6130759,
                27.9170821
              ],
              [
                56.6083561,
                27.9170821
              ],
              [
                56.6077995,
                27.9168031
              ],
              [
                56.6058561,
                27.9168031
              ],
              [
                56.6052994,
                27.916524
              ],
              [
                56.6044662,
                27.9165241
              ],
              [
                56.6033528,
                27.9162451
              ],
              [
                56.6016861,
                27.9162451
              ],
              [
                56.6008529,
                27.915966
              ],
              [
                56.5997429,
                27.9159661
              ],
              [
                56.5989095,
                27.915687
              ],
              [
                56.5919663,
                27.9148589
              ],
              [
                56.5894664,
                27.9148589
              ],
              [
                56.5262473,
                27.9011609
              ],
              [
                56.5190239,
                27.8992167
              ],
              [
                56.5165241,
                27.8986676
              ],
              [
                56.514024,
                27.8986677
              ],
              [
                56.514024,
                27.8983888
              ],
              [
                56.5134674,
                27.8983887
              ],
              [
                56.5131909,
                27.8981098
              ],
              [
                56.5126342,
                27.8981097
              ],
              [
                56.5118008,
                27.8981098
              ],
              [
                56.5118007,
                27.8983888
              ],
              [
                56.5032676,
                27.9032434
              ],
              [
                56.4999344,
                27.9085176
              ],
              [
                56.5002145,
                27.9101916
              ],
              [
                56.5010478,
                27.9129637
              ],
              [
                56.5013245,
                27.9132428
              ],
              [
                56.5010477,
                27.9135217
              ],
              [
                56.5013245,
                27.9162938
              ],
              [
                56.5016011,
                27.91741
              ],
              [
                56.5018812,
                27.9187961
              ],
              [
                56.5021577,
                27.9207401
              ],
              [
                56.5024345,
                27.9210191
              ],
              [
                56.5024345,
                27.9215771
              ],
              [
                56.5063244,
                27.9332418
              ],
              [
                56.5071577,
                27.935186
              ],
              [
                56.5099342,
                27.9410184
              ],
              [
                56.5113243,
                27.9424135
              ],
              [
                56.5135476,
                27.9465809
              ],
              [
                56.5132711,
                27.9468509
              ],
              [
                56.5171576,
                27.9593531
              ],
              [
                56.5174375,
                27.9610183
              ],
              [
                56.5171576,
                27.9612973
              ],
              [
                56.5168809,
                27.9624045
              ],
              [
                56.5146576,
                27.9635207
              ],
              [
                56.5135476,
                27.9635206
              ],
              [
                56.5124377,
                27.9635206
              ],
              [
                56.5121575,
                27.9637997
              ],
              [
                56.5088243,
                27.9640697
              ],
              [
                56.5082676,
                27.9640697
              ],
              [
                56.5082109,
                27.9642986
              ],
              [
                56.5079911,
                27.9640697
              ],
              [
                56.5063245,
                27.9632415
              ],
              [
                56.5052144,
                27.9632416
              ],
              [
                56.5049344,
                27.9629625
              ],
              [
                56.504381,
                27.9629625
              ],
              [
                56.5035479,
                27.9626836
              ],
              [
                56.5013245,
                27.9626835
              ],
              [
                56.5004911,
                27.9624045
              ],
              [
                56.498548,
                27.9621344
              ],
              [
                56.4960479,
                27.9621345
              ],
              [
                56.4954913,
                27.9618464
              ],
              [
                56.4924346,
                27.9615763
              ],
              [
                56.4891013,
                27.9615763
              ],
              [
                56.4885446,
                27.9612974
              ],
              [
                56.4854915,
                27.9612974
              ],
              [
                56.484658,
                27.9610183
              ],
              [
                56.4777114,
                27.9610183
              ],
              [
                56.4768782,
                27.9607393
              ],
              [
                56.4743781,
                27.9607393
              ],
              [
                56.4718783,
                27.9601902
              ],
              [
                56.4704883,
                27.9601902
              ],
              [
                56.3629528,
                27.9443701
              ],
              [
                56.2175953,
                27.9470218
              ],
              [
                56.2159287,
                27.9470218
              ],
              [
                56.215372,
                27.9473008
              ],
              [
                56.214262,
                27.9473008
              ],
              [
                56.2137054,
                27.9475799
              ],
              [
                56.2070389,
                27.94758
              ],
              [
                56.2067623,
                27.9473008
              ],
              [
                56.2056789,
                27.9473009
              ],
              [
                56.2039821,
                27.9473009
              ],
              [
                56.2023155,
                27.9473009
              ],
              [
                56.2020389,
                27.9470218
              ],
              [
                56.2006489,
                27.9470218
              ],
              [
                56.2000922,
                27.9467428
              ],
              [
                56.199259,
                27.9467428
              ],
              [
                56.1973156,
                27.9461937
              ],
              [
                56.1765286,
                27.9431569
              ],
              [
                56.1586562,
                27.9316121
              ],
              [
                56.1558796,
                27.9291101
              ],
              [
                56.0232161,
                27.9279514
              ],
              [
                56.0223829,
                27.9271238
              ],
              [
                56.0196063,
                27.924623
              ],
              [
                56.0193262,
                27.9246229
              ],
              [
                56.0184928,
                27.9243441
              ],
              [
                56.0140495,
                27.9243442
              ],
              [
                56.013773,
                27.9240652
              ],
              [
                56.0126597,
                27.9240652
              ],
              [
                56.0123829,
                27.9237864
              ],
              [
                56.0107163,
                27.9237864
              ],
              [
                56.0101597,
                27.9235074
              ],
              [
                56.0029365,
                27.9229497
              ],
              [
                56.0021031,
                27.9232376
              ],
              [
                55.9915467,
                27.9240652
              ],
              [
                55.9823801,
                27.9260084
              ],
              [
                55.9809935,
                27.9260083
              ],
              [
                55.9765468,
                27.9273937
              ],
              [
                55.975437,
                27.9273938
              ],
              [
                55.9668237,
                27.928788
              ],
              [
                55.9637704,
                27.9296247
              ],
              [
                55.953214,
                27.9318377
              ],
              [
                55.9526573,
                27.9318377
              ],
              [
                55.9501572,
                27.9326743
              ],
              [
                55.9462674,
                27.9332321
              ],
              [
                55.9446007,
                27.9337808
              ],
              [
                55.9432142,
                27.9337808
              ],
              [
                55.9418241,
                27.9343386
              ],
              [
                55.9409907,
                27.9343386
              ],
              [
                55.9404341,
                27.9346174
              ],
              [
                55.9384909,
                27.9346174
              ],
              [
                55.9379342,
                27.9348963
              ],
              [
                55.9368242,
                27.9348963
              ],
              [
                55.8589676,
                27.9031318
              ],
              [
                55.8581341,
                27.9028528
              ],
              [
                55.8556343,
                27.9028528
              ],
              [
                55.8548009,
                27.9025738
              ],
              [
                55.852301,
                27.9023038
              ],
              [
                55.848691,
                27.9023038
              ],
              [
                55.8481344,
                27.9020247
              ],
              [
                55.8470244,
                27.9020247
              ],
              [
                55.8453544,
                27.9020248
              ],
              [
                55.8450778,
                27.9017457
              ],
              [
                55.8442445,
                27.9017457
              ],
              [
                55.8431345,
                27.9014666
              ],
              [
                55.8425778,
                27.9014666
              ],
              [
                55.8392446,
                27.9011877
              ],
              [
                55.8381346,
                27.9014666
              ],
              [
                55.8361879,
                27.9014667
              ],
              [
                55.8353546,
                27.9017457
              ],
              [
                55.832578,
                27.9017457
              ],
              [
                55.8317447,
                27.9014666
              ],
              [
                55.8306346,
                27.9014666
              ],
              [
                55.781742,
                27.8864622
              ],
              [
                55.7803521,
                27.8856342
              ],
              [
                55.7764656,
                27.884248
              ],
              [
                55.7750755,
                27.883411
              ],
              [
                55.7725756,
                27.8825829
              ],
              [
                55.7711856,
                27.8820248
              ],
              [
                55.7689623,
                27.8811877
              ],
              [
                55.7188676,
                27.8654274
              ],
              [
                55.715958,
                27.8630573
              ],
              [
                55.7163643,
                27.8618203
              ],
              [
                55.7135377,
                27.8568666
              ],
              [
                55.7138143,
                27.85603
              ],
              [
                55.7295224,
                27.8421122
              ],
              [
                55.7329556,
                27.8290575
              ],
              [
                55.7271191,
                27.8193414
              ],
              [
                55.6567379,
                27.8254141
              ],
              [
                55.5795118,
                27.8036866
              ],
              [
                55.5682455,
                27.7992408
              ],
              [
                55.5679689,
                27.7984128
              ],
              [
                55.5676922,
                27.7967479
              ],
              [
                55.5663022,
                27.7945249
              ],
              [
                55.561859,
                27.7881352
              ],
              [
                55.5430762,
                27.7766383
              ],
              [
                55.5419628,
                27.7749549
              ],
              [
                55.5419628,
                27.7746757
              ],
              [
                55.5414094,
                27.7743968
              ],
              [
                55.5408528,
                27.7735688
              ],
              [
                55.535336,
                27.7722116
              ],
              [
                55.5172796,
                27.7583175
              ],
              [
                55.5164463,
                27.7577596
              ],
              [
                55.5136697,
                27.7560948
              ],
              [
                55.5128364,
                27.7560948
              ],
              [
                55.5050565,
                27.7511006
              ],
              [
                55.500063,
                27.7423018
              ],
              [
                55.5021596,
                27.7320487
              ],
              [
                55.4985497,
                27.7298348
              ],
              [
                55.4924362,
                27.7234453
              ],
              [
                55.4916031,
                27.7231662
              ],
              [
                55.4824364,
                27.7126103
              ],
              [
                55.4675601,
                27.7095192
              ],
              [
                55.4658936,
                27.7056319
              ],
              [
                55.4410808,
                27.6993526
              ],
              [
                55.4039917,
                27.686734
              ],
              [
                55.4034385,
                27.6864552
              ],
              [
                55.4017718,
                27.6836757
              ],
              [
                55.3998251,
                27.6811752
              ],
              [
                55.3970485,
                27.6786745
              ],
              [
                55.3964919,
                27.677847
              ],
              [
                55.3749756,
                27.6395876
              ],
              [
                55.3527526,
                27.6234854
              ],
              [
                55.3521958,
                27.6232063
              ],
              [
                55.3446292,
                27.6025882
              ],
              [
                55.3437959,
                27.6017514
              ],
              [
                55.3396026,
                27.5901494
              ],
              [
                55.3368892,
                27.5786966
              ],
              [
                55.3314457,
                27.5717377
              ],
              [
                55.3267423,
                27.5600332
              ],
              [
                55.323409,
                27.5569743
              ],
              [
                55.3210723,
                27.542951
              ],
              [
                55.319129,
                27.5401708
              ],
              [
                55.2940682,
                27.5076412
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554975,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان جاسک",
          "name:en": "Jask County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1280087"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.8375656,
                26.0513992
              ],
              [
                56.9740812,
                25.9318997
              ],
              [
                57.0020189,
                25.9007986
              ],
              [
                57.0091291,
                25.8924765
              ],
              [
                57.0563963,
                25.8314821
              ],
              [
                57.0773002,
                25.7760651
              ],
              [
                57.0835873,
                25.7454101
              ],
              [
                57.0959893,
                25.7129881
              ],
              [
                57.1125809,
                25.685279
              ],
              [
                57.146293,
                25.6475882
              ],
              [
                57.1858621,
                25.6190402
              ],
              [
                57.2168101,
                25.6039768
              ],
              [
                57.2380265,
                25.5962327
              ],
              [
                57.2561872,
                25.5909346
              ],
              [
                57.2826351,
                25.585335
              ],
              [
                57.2966522,
                25.583358
              ],
              [
                57.4990268,
                25.5121635
              ],
              [
                57.6780601,
                25.4491451
              ],
              [
                57.7013035,
                25.4422427
              ],
              [
                57.9250327,
                25.3877415
              ],
              [
                58.031375,
                25.3618275
              ],
              [
                58.0529943,
                25.3575735
              ],
              [
                58.632055,
                25.2688666
              ],
              [
                58.8229909,
                25.2396028
              ],
              [
                59.0569858,
                25.2037298
              ],
              [
                59.0921639,
                25.2008219
              ],
              [
                59.2187761,
                25.1994033
              ],
              [
                59.2211109,
                25.4393893
              ],
              [
                59.2190376,
                25.4581693
              ],
              [
                59.2179907,
                25.4676514
              ],
              [
                59.2160527,
                25.4903082
              ],
              [
                59.214939,
                25.4997473
              ],
              [
                59.2149391,
                25.5008587
              ],
              [
                59.2146593,
                25.5041934
              ],
              [
                59.2146594,
                25.5047492
              ],
              [
                59.2146594,
                25.51253
              ],
              [
                59.2141059,
                25.5208578
              ],
              [
                59.2107727,
                25.5547533
              ],
              [
                59.2104926,
                25.5578014
              ],
              [
                59.2107727,
                25.5580794
              ],
              [
                59.2110528,
                25.5603027
              ],
              [
                59.2113263,
                25.5622481
              ],
              [
                59.2116059,
                25.5636377
              ],
              [
                59.213826,
                25.5741987
              ],
              [
                59.214106,
                25.5747456
              ],
              [
                59.214106,
                25.5753105
              ],
              [
                59.2193862,
                25.5897539
              ],
              [
                59.2199394,
                25.5905877
              ],
              [
                59.2202195,
                25.5922553
              ],
              [
                59.2343858,
                25.6291952
              ],
              [
                59.2349393,
                25.6314189
              ],
              [
                59.2352194,
                25.6322528
              ],
              [
                59.2354995,
                25.6341986
              ],
              [
                59.2357725,
                25.6367001
              ],
              [
                59.2354994,
                25.6386369
              ],
              [
                59.2352194,
                25.6391929
              ],
              [
                59.2291061,
                25.6519704
              ],
              [
                59.2250633,
                25.6579294
              ],
              [
                59.2246821,
                25.6589755
              ],
              [
                59.2195189,
                25.6651134
              ],
              [
                59.2173512,
                25.6721304
              ],
              [
                59.2135342,
                25.6861947
              ],
              [
                59.2114768,
                25.6930796
              ],
              [
                59.2118864,
                25.6972546
              ],
              [
                59.212993,
                25.7011465
              ],
              [
                59.2148563,
                25.704146
              ],
              [
                59.2054938,
                25.7285449
              ],
              [
                59.1922065,
                25.7401151
              ],
              [
                59.1682309,
                25.7614647
              ],
              [
                59.157801,
                25.7739415
              ],
              [
                59.1413352,
                25.7940185
              ],
              [
                59.1370165,
                25.7995248
              ],
              [
                59.1319644,
                25.8067884
              ],
              [
                59.1462706,
                25.8076186
              ],
              [
                59.1406917,
                25.8134909
              ],
              [
                59.1332391,
                25.8195511
              ],
              [
                59.1289544,
                25.8215262
              ],
              [
                59.1253889,
                25.8232983
              ],
              [
                59.1229892,
                25.8244621
              ],
              [
                59.120779,
                25.8249064
              ],
              [
                59.1173672,
                25.8259493
              ],
              [
                59.1152074,
                25.8269102
              ],
              [
                59.1135798,
                25.8283297
              ],
              [
                59.1132903,
                25.8301598
              ],
              [
                59.1127766,
                25.8316574
              ],
              [
                59.1117132,
                25.8332886
              ],
              [
                59.1103506,
                25.8340515
              ],
              [
                59.1092348,
                25.8345923
              ],
              [
                59.1055226,
                25.8361276
              ],
              [
                59.1029692,
                25.8365429
              ],
              [
                59.0994121,
                25.8368527
              ],
              [
                59.0979266,
                25.8377499
              ],
              [
                59.0954255,
                25.8399529
              ],
              [
                59.094287,
                25.841553
              ],
              [
                59.0820694,
                25.8522721
              ],
              [
                59.0806738,
                25.8539944
              ],
              [
                59.0799536,
                25.8561418
              ],
              [
                59.0795968,
                25.8591298
              ],
              [
                59.0797935,
                25.8609299
              ],
              [
                59.0803062,
                25.8630387
              ],
              [
                59.0800761,
                25.8737417
              ],
              [
                59.0798772,
                25.8787394
              ],
              [
                59.0804827,
                25.8806697
              ],
              [
                59.0803743,
                25.8825462
              ],
              [
                59.0796244,
                25.8846932
              ],
              [
                59.0771579,
                25.8888789
              ],
              [
                59.07516,
                25.8891489
              ],
              [
                59.0744166,
                25.8907072
              ],
              [
                59.0732783,
                25.8920119
              ],
              [
                59.0717585,
                25.8926682
              ],
              [
                59.0696329,
                25.8950698
              ],
              [
                59.0687139,
                25.8968842
              ],
              [
                59.0619377,
                25.8985135
              ],
              [
                59.0480356,
                25.9074309
              ],
              [
                59.0373115,
                25.9140783
              ],
              [
                59.0270591,
                25.9203993
              ],
              [
                59.0037834,
                25.9204774
              ],
              [
                58.9995968,
                25.9377711
              ],
              [
                58.9984263,
                25.9419313
              ],
              [
                59.0020024,
                25.9465741
              ],
              [
                59.0165078,
                25.9658544
              ],
              [
                59.0236051,
                25.9749856
              ],
              [
                59.0389425,
                25.984685
              ],
              [
                59.0519113,
                25.989059
              ],
              [
                59.0629429,
                25.9898172
              ],
              [
                59.0761548,
                25.9905973
              ],
              [
                59.0171417,
                26.0614667
              ],
              [
                58.9970349,
                26.0690051
              ],
              [
                58.9967549,
                26.06984
              ],
              [
                58.9928685,
                26.076231
              ],
              [
                58.9996716,
                26.08423
              ],
              [
                59.0120312,
                26.0882385
              ],
              [
                59.0158078,
                26.0953302
              ],
              [
                59.0079113,
                26.1033464
              ],
              [
                59.0140911,
                26.1249258
              ],
              [
                59.0244902,
                26.1402065
              ],
              [
                59.0239371,
                26.141041
              ],
              [
                59.0225504,
                26.1488218
              ],
              [
                59.0228238,
                26.1507603
              ],
              [
                59.0158078,
                26.167148
              ],
              [
                59.0204376,
                26.190304
              ],
              [
                59.0207177,
                26.1905732
              ],
              [
                59.0209907,
                26.1925205
              ],
              [
                59.0212708,
                26.195024
              ],
              [
                59.0134911,
                26.2025171
              ],
              [
                59.0104378,
                26.2064117
              ],
              [
                59.0101578,
                26.2072463
              ],
              [
                59.0098777,
                26.2075154
              ],
              [
                59.0092034,
                26.2080916
              ],
              [
                58.9741054,
                26.2083196
              ],
              [
                58.9732718,
                26.2080414
              ],
              [
                58.972712,
                26.2083196
              ],
              [
                58.9666053,
                26.2083195
              ],
              [
                58.9004513,
                26.208739
              ],
              [
                58.7847515,
                26.1791647
              ],
              [
                58.7291333,
                26.1683806
              ],
              [
                58.6639019,
                26.1616015
              ],
              [
                58.6526101,
                26.153227
              ],
              [
                58.6495569,
                26.1529487
              ],
              [
                58.6314972,
                26.1496193
              ],
              [
                58.6253905,
                26.1479503
              ],
              [
                58.5811612,
                26.1203019
              ],
              [
                58.5378452,
                26.1008308
              ],
              [
                58.535065,
                26.09944
              ],
              [
                58.5345119,
                26.0991618
              ],
              [
                58.532565,
                26.0983272
              ],
              [
                58.5292317,
                26.096102
              ],
              [
                58.4084698,
                26.0900886
              ],
              [
                58.3442685,
                26.0873135
              ],
              [
                58.304349,
                26.1133698
              ],
              [
                58.3037888,
                26.1136481
              ],
              [
                58.2993493,
                26.113648
              ],
              [
                58.297956,
                26.1139352
              ],
              [
                58.2946223,
                26.1139352
              ],
              [
                58.2940692,
                26.113648
              ],
              [
                58.2926824,
                26.113648
              ],
              [
                58.2915691,
                26.1139352
              ],
              [
                58.2887895,
                26.1139352
              ],
              [
                58.2865695,
                26.1142045
              ],
              [
                58.2832362,
                26.1150392
              ],
              [
                58.2388684,
                26.1221515
              ],
              [
                58.1904507,
                26.1192036
              ],
              [
                58.1857311,
                26.1169869
              ],
              [
                58.1562849,
                26.1078146
              ],
              [
                58.1490649,
                26.1050414
              ],
              [
                58.1482316,
                26.1047632
              ],
              [
                58.1471183,
                26.1042068
              ],
              [
                58.1465652,
                26.1039285
              ],
              [
                58.146005,
                26.1033721
              ],
              [
                58.1457316,
                26.1030939
              ],
              [
                58.1457315,
                26.1028157
              ],
              [
                58.076493,
                26.0896927
              ],
              [
                58.0750995,
                26.0896927
              ],
              [
                58.0745464,
                26.0894235
              ],
              [
                58.0698264,
                26.0894235
              ],
              [
                58.0664932,
                26.0896927
              ],
              [
                58.0650998,
                26.090249
              ],
              [
                58.0642665,
                26.090249
              ],
              [
                57.9981988,
                26.0913222
              ],
              [
                57.9267876,
                26.1196857
              ],
              [
                57.8739361,
                26.1476445
              ],
              [
                57.8722697,
                26.1476445
              ],
              [
                57.8717166,
                26.1479229
              ],
              [
                57.8574499,
                26.1596334
              ],
              [
                57.8566167,
                26.1593551
              ],
              [
                57.8538365,
                26.1593551
              ],
              [
                57.8530034,
                26.1590768
              ],
              [
                57.8516167,
                26.1590768
              ],
              [
                57.8510568,
                26.1590768
              ],
              [
                57.8449435,
                26.1668601
              ],
              [
                57.8352238,
                26.1701906
              ],
              [
                57.8318905,
                26.1701906
              ],
              [
                57.831337,
                26.1699124
              ],
              [
                57.8299436,
                26.1699123
              ],
              [
                57.8293904,
                26.169634
              ],
              [
                57.8285573,
                26.169634
              ],
              [
                57.8035351,
                26.1643748
              ],
              [
                57.7952954,
                26.1619096
              ],
              [
                57.765083,
                26.1566709
              ],
              [
                57.7573916,
                26.1387297
              ],
              [
                57.7571117,
                26.1384515
              ],
              [
                57.7546116,
                26.1420599
              ],
              [
                57.7529452,
                26.148451
              ],
              [
                57.7526651,
                26.1506772
              ],
              [
                57.7521116,
                26.152616
              ],
              [
                57.7440587,
                26.1640074
              ],
              [
                57.7329453,
                26.168451
              ],
              [
                57.7307257,
                26.1692857
              ],
              [
                57.7298855,
                26.1692857
              ],
              [
                57.7284987,
                26.1698423
              ],
              [
                57.7273854,
                26.1698423
              ],
              [
                57.7043327,
                26.1776253
              ],
              [
                57.703219,
                26.1776253
              ],
              [
                57.7026659,
                26.1778946
              ],
              [
                57.7021127,
                26.1776254
              ],
              [
                57.6991018,
                26.17934
              ],
              [
                57.6982193,
                26.1798426
              ],
              [
                57.681483,
                26.1717831
              ],
              [
                57.6541897,
                26.1683806
              ],
              [
                57.6222607,
                26.1733106
              ],
              [
                57.528592,
                26.1880414
              ],
              [
                57.5173624,
                26.1919816
              ],
              [
                57.5165291,
                26.1922599
              ],
              [
                57.5165292,
                26.1919816
              ],
              [
                57.5159756,
                26.1917123
              ],
              [
                57.5154225,
                26.1917123
              ],
              [
                57.5148623,
                26.1914251
              ],
              [
                57.5129224,
                26.191425
              ],
              [
                57.5123622,
                26.1911467
              ],
              [
                57.5081958,
                26.1911467
              ],
              [
                57.5073625,
                26.191425
              ],
              [
                57.5062559,
                26.191425
              ],
              [
                57.5051426,
                26.1917123
              ],
              [
                57.4940295,
                26.1939298
              ],
              [
                57.4923627,
                26.1939298
              ],
              [
                57.4895826,
                26.1944864
              ],
              [
                57.4879161,
                26.1944864
              ],
              [
                57.4868096,
                26.1947647
              ],
              [
                57.4843095,
                26.1947648
              ],
              [
                57.4831961,
                26.195043
              ],
              [
                57.4726433,
                26.1953123
              ],
              [
                57.4548633,
                26.1942082
              ],
              [
                57.4501366,
                26.1933732
              ],
              [
                57.4487503,
                26.1928166
              ],
              [
                57.4479167,
                26.1928166
              ],
              [
                57.4293038,
                26.1861464
              ],
              [
                57.4237506,
                26.1844855
              ],
              [
                57.3995839,
                26.1872662
              ],
              [
                57.3706979,
                26.1725367
              ],
              [
                57.3618048,
                26.1655984
              ],
              [
                57.3520847,
                26.1583819
              ],
              [
                57.3401385,
                26.1486525
              ],
              [
                57.3362515,
                26.1456008
              ],
              [
                57.3351383,
                26.1450443
              ],
              [
                57.3281918,
                26.1403233
              ],
              [
                57.305139,
                26.129212
              ],
              [
                57.2720827,
                26.1139367
              ],
              [
                57.260693,
                26.1086506
              ],
              [
                57.2598597,
                26.1086505
              ],
              [
                57.257913,
                26.1078158
              ],
              [
                57.255693,
                26.1069901
              ],
              [
                57.2501365,
                26.104208
              ],
              [
                57.2481931,
                26.1022605
              ],
              [
                57.2470798,
                26.1017041
              ],
              [
                57.2462465,
                26.1017041
              ],
              [
                57.2459698,
                26.1014259
              ],
              [
                57.2412466,
                26.1000438
              ],
              [
                57.23819,
                26.0983745
              ],
              [
                57.2362466,
                26.0983745
              ],
              [
                57.23597,
                26.0986528
              ],
              [
                57.2351368,
                26.0986527
              ],
              [
                57.2351368,
                26.0983745
              ],
              [
                57.2340233,
                26.0983745
              ],
              [
                57.2329133,
                26.0975399
              ],
              [
                57.2231901,
                26.0930975
              ],
              [
                57.2220803,
                26.0930975
              ],
              [
                57.2215234,
                26.0928193
              ],
              [
                57.2204135,
                26.0928193
              ],
              [
                57.2195803,
                26.0925411
              ],
              [
                57.2179137,
                26.0925411
              ],
              [
                57.216247,
                26.0925411
              ],
              [
                57.2079139,
                26.0925411
              ],
              [
                57.2073573,
                26.0922629
              ],
              [
                57.171368,
                26.0981379
              ],
              [
                56.8375656,
                26.0513992
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554984,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان حاجی آباد",
          "name:en": "Hajjiabad County",
          "name:uk": "Хаджіабад",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1280129",
          "wikipedia": "en:Hajjiabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.2533242,
                28.7136208
              ],
              [
                55.2766796,
                28.7077533
              ],
              [
                55.3192517,
                28.6866727
              ],
              [
                55.3580471,
                28.6571526
              ],
              [
                55.3864085,
                28.6331452
              ],
              [
                55.3953348,
                28.6226288
              ],
              [
                55.4122921,
                28.602609
              ],
              [
                55.4292614,
                28.5810506
              ],
              [
                55.4468744,
                28.5540597
              ],
              [
                55.452376,
                28.5455311
              ],
              [
                55.4550727,
                28.5396106
              ],
              [
                55.4555208,
                28.5357712
              ],
              [
                55.4509443,
                28.5224757
              ],
              [
                55.4503494,
                28.519271
              ],
              [
                55.447091,
                28.5125824
              ],
              [
                55.4454192,
                28.4870358
              ],
              [
                55.4346963,
                28.4794844
              ],
              [
                55.4272431,
                28.4721142
              ],
              [
                55.4188764,
                28.4656572
              ],
              [
                55.4150999,
                28.4623823
              ],
              [
                55.4109,
                28.459721
              ],
              [
                55.4084966,
                28.4567477
              ],
              [
                55.4079734,
                28.4403444
              ],
              [
                55.4078933,
                28.4329923
              ],
              [
                55.4089483,
                28.4253702
              ],
              [
                55.4086717,
                28.4234246
              ],
              [
                55.4083916,
                28.4203623
              ],
              [
                55.4078383,
                28.4184168
              ],
              [
                55.4072816,
                28.3970344
              ],
              [
                55.407005,
                28.3948097
              ],
              [
                55.406725,
                28.3925941
              ],
              [
                55.4064482,
                28.3881447
              ],
              [
                55.4061716,
                28.3878656
              ],
              [
                55.4064482,
                28.3861993
              ],
              [
                55.4070051,
                28.380363
              ],
              [
                55.407005,
                28.362305
              ],
              [
                55.4067249,
                28.3603686
              ],
              [
                55.4050583,
                28.3542533
              ],
              [
                55.4047817,
                28.3520288
              ],
              [
                55.4081148,
                28.3186973
              ],
              [
                55.4078383,
                28.318139
              ],
              [
                55.4081148,
                28.3175896
              ],
              [
                55.4083915,
                28.3156443
              ],
              [
                55.4081148,
                28.3153652
              ],
              [
                55.4083915,
                28.3142484
              ],
              [
                55.4083915,
                28.3125823
              ],
              [
                55.4086716,
                28.3100877
              ],
              [
                55.4083915,
                28.3098085
              ],
              [
                55.4086716,
                28.308971
              ],
              [
                55.4083916,
                28.3086918
              ],
              [
                55.4086716,
                28.3081425
              ],
              [
                55.4083915,
                28.3078633
              ],
              [
                55.4083915,
                28.3073049
              ],
              [
                55.4083915,
                28.3064764
              ],
              [
                55.4078383,
                28.3036936
              ],
              [
                55.4075582,
                28.3017574
              ],
              [
                55.4064482,
                28.2961919
              ],
              [
                55.4058916,
                28.2864749
              ],
              [
                55.4056149,
                28.2856464
              ],
              [
                55.4058916,
                28.2831428
              ],
              [
                55.4056149,
                28.2825845
              ],
              [
                55.4058915,
                28.2792524
              ],
              [
                55.4056149,
                28.2761996
              ],
              [
                55.4053383,
                28.2745336
              ],
              [
                55.4050582,
                28.2723093
              ],
              [
                55.4047815,
                28.2698058
              ],
              [
                55.404505,
                28.2678696
              ],
              [
                55.4077081,
                28.2644478
              ],
              [
                55.4074315,
                28.2624938
              ],
              [
                55.4063214,
                28.2580545
              ],
              [
                55.4057648,
                28.2541644
              ],
              [
                55.4054881,
                28.2511119
              ],
              [
                55.4052081,
                28.2505536
              ],
              [
                55.420281,
                28.2160923
              ],
              [
                55.4200043,
                28.2152549
              ],
              [
                55.4189847,
                28.2136825
              ],
              [
                55.4188911,
                28.2135891
              ],
              [
                55.4120246,
                28.1899858
              ],
              [
                55.4095246,
                28.1777662
              ],
              [
                55.4092481,
                28.1749929
              ],
              [
                55.4089713,
                28.1719313
              ],
              [
                55.4086914,
                28.169707
              ],
              [
                55.408138,
                28.1663754
              ],
              [
                55.4078579,
                28.163602
              ],
              [
                55.4075814,
                28.1577671
              ],
              [
                55.4186343,
                28.1261537
              ],
              [
                55.4183542,
                28.1247666
              ],
              [
                55.4180776,
                28.1225419
              ],
              [
                55.4178009,
                28.1197588
              ],
              [
                55.4175208,
                28.1194887
              ],
              [
                55.4175209,
                28.1183718
              ],
              [
                55.4172443,
                28.1147599
              ],
              [
                55.4169677,
                28.112256
              ],
              [
                55.4166876,
                28.1119859
              ],
              [
                55.4084946,
                28.0953882
              ],
              [
                55.4087746,
                28.0931643
              ],
              [
                55.4096079,
                28.0826122
              ],
              [
                55.3995892,
                28.078342
              ],
              [
                55.3865586,
                28.045682
              ],
              [
                55.3862785,
                28.0445746
              ],
              [
                55.3860019,
                28.0431882
              ],
              [
                55.3857252,
                28.0417929
              ],
              [
                55.3854451,
                28.0401365
              ],
              [
                55.3851686,
                28.0392992
              ],
              [
                55.3818353,
                28.0297743
              ],
              [
                55.3818353,
                28.0292978
              ],
              [
                55.3815553,
                28.0270741
              ],
              [
                55.3949647,
                28.0129396
              ],
              [
                55.397188,
                28.0109955
              ],
              [
                55.402188,
                28.0090513
              ],
              [
                55.427734,
                28.0069857
              ],
              [
                55.4624568,
                27.9908661
              ],
              [
                55.4652368,
                27.98921
              ],
              [
                55.4805131,
                27.9811548
              ],
              [
                55.5241023,
                27.9904218
              ],
              [
                55.5791467,
                27.9950083
              ],
              [
                55.6246459,
                27.9823664
              ],
              [
                55.6246459,
                27.9820876
              ],
              [
                55.6252026,
                27.9818086
              ],
              [
                55.6790245,
                27.9693369
              ],
              [
                55.6812479,
                27.967106
              ],
              [
                55.6840244,
                27.9646142
              ],
              [
                55.6887477,
                27.9568424
              ],
              [
                55.6852337,
                27.9449767
              ],
              [
                55.6767116,
                27.937191
              ],
              [
                55.6772648,
                27.9363635
              ],
              [
                55.6778216,
                27.9360845
              ],
              [
                55.676994,
                27.9067553
              ],
              [
                55.6937247,
                27.9040506
              ],
              [
                55.6986233,
                27.8782321
              ],
              [
                55.7102045,
                27.8710258
              ],
              [
                55.7102044,
                27.8707469
              ],
              [
                55.7104811,
                27.8704681
              ],
              [
                55.715811,
                27.8632055
              ],
              [
                55.715958,
                27.8630573
              ],
              [
                55.7188676,
                27.8654274
              ],
              [
                55.7689623,
                27.8811877
              ],
              [
                55.7711856,
                27.8820248
              ],
              [
                55.7725756,
                27.8825829
              ],
              [
                55.7750755,
                27.883411
              ],
              [
                55.7764656,
                27.884248
              ],
              [
                55.7803521,
                27.8856342
              ],
              [
                55.781742,
                27.8864622
              ],
              [
                55.8306346,
                27.9014666
              ],
              [
                55.8317447,
                27.9014666
              ],
              [
                55.832578,
                27.9017457
              ],
              [
                55.8353546,
                27.9017457
              ],
              [
                55.8361879,
                27.9014667
              ],
              [
                55.8381346,
                27.9014666
              ],
              [
                55.8392446,
                27.9011877
              ],
              [
                55.8425778,
                27.9014666
              ],
              [
                55.8431345,
                27.9014666
              ],
              [
                55.8442445,
                27.9017457
              ],
              [
                55.8450778,
                27.9017457
              ],
              [
                55.8453544,
                27.9020248
              ],
              [
                55.8470244,
                27.9020247
              ],
              [
                55.8481344,
                27.9020247
              ],
              [
                55.848691,
                27.9023038
              ],
              [
                55.852301,
                27.9023038
              ],
              [
                55.8548009,
                27.9025738
              ],
              [
                55.8556343,
                27.9028528
              ],
              [
                55.8581341,
                27.9028528
              ],
              [
                55.8589676,
                27.9031318
              ],
              [
                55.9368242,
                27.9348963
              ],
              [
                55.9379342,
                27.9348963
              ],
              [
                55.9384909,
                27.9346174
              ],
              [
                55.9404341,
                27.9346174
              ],
              [
                55.9409907,
                27.9343386
              ],
              [
                55.9418241,
                27.9343386
              ],
              [
                55.9432142,
                27.9337808
              ],
              [
                55.9446007,
                27.9337808
              ],
              [
                55.9462674,
                27.9332321
              ],
              [
                55.9501572,
                27.9326743
              ],
              [
                55.9526573,
                27.9318377
              ],
              [
                55.953214,
                27.9318377
              ],
              [
                55.9637704,
                27.9296247
              ],
              [
                55.9668237,
                27.928788
              ],
              [
                55.975437,
                27.9273938
              ],
              [
                55.9765468,
                27.9273937
              ],
              [
                55.9809935,
                27.9260083
              ],
              [
                55.9823801,
                27.9260084
              ],
              [
                55.9915467,
                27.9240652
              ],
              [
                56.0021031,
                27.9232376
              ],
              [
                56.0029365,
                27.9229497
              ],
              [
                56.0101597,
                27.9235074
              ],
              [
                56.0107163,
                27.9237864
              ],
              [
                56.0123829,
                27.9237864
              ],
              [
                56.0126597,
                27.9240652
              ],
              [
                56.013773,
                27.9240652
              ],
              [
                56.0140495,
                27.9243442
              ],
              [
                56.0184928,
                27.9243441
              ],
              [
                56.0193262,
                27.9246229
              ],
              [
                56.0196063,
                27.924623
              ],
              [
                56.0223829,
                27.9271238
              ],
              [
                56.0232161,
                27.9279514
              ],
              [
                56.1558796,
                27.9291101
              ],
              [
                56.1586562,
                27.9316121
              ],
              [
                56.1765286,
                27.9431569
              ],
              [
                56.1973156,
                27.9461937
              ],
              [
                56.199259,
                27.9467428
              ],
              [
                56.2000922,
                27.9467428
              ],
              [
                56.2006489,
                27.9470218
              ],
              [
                56.2020389,
                27.9470218
              ],
              [
                56.2023155,
                27.9473009
              ],
              [
                56.2039821,
                27.9473009
              ],
              [
                56.2056789,
                27.9473009
              ],
              [
                56.2067623,
                27.9473008
              ],
              [
                56.2070389,
                27.94758
              ],
              [
                56.2137054,
                27.9475799
              ],
              [
                56.214262,
                27.9473008
              ],
              [
                56.215372,
                27.9473008
              ],
              [
                56.2159287,
                27.9470218
              ],
              [
                56.2175953,
                27.9470218
              ],
              [
                56.3629528,
                27.9443701
              ],
              [
                56.4704883,
                27.9601902
              ],
              [
                56.4718783,
                27.9601902
              ],
              [
                56.4743781,
                27.9607393
              ],
              [
                56.4768782,
                27.9607393
              ],
              [
                56.4777114,
                27.9610183
              ],
              [
                56.484658,
                27.9610183
              ],
              [
                56.4854915,
                27.9612974
              ],
              [
                56.4885446,
                27.9612974
              ],
              [
                56.4891013,
                27.9615763
              ],
              [
                56.4924346,
                27.9615763
              ],
              [
                56.4954913,
                27.9618464
              ],
              [
                56.4960479,
                27.9621345
              ],
              [
                56.498548,
                27.9621344
              ],
              [
                56.5004911,
                27.9624045
              ],
              [
                56.5013245,
                27.9626835
              ],
              [
                56.5035479,
                27.9626836
              ],
              [
                56.504381,
                27.9629625
              ],
              [
                56.5049344,
                27.9629625
              ],
              [
                56.5052144,
                27.9632416
              ],
              [
                56.5063245,
                27.9632415
              ],
              [
                56.5079911,
                27.9640697
              ],
              [
                56.5082109,
                27.9642986
              ],
              [
                56.5082676,
                27.9640697
              ],
              [
                56.5088243,
                27.9640697
              ],
              [
                56.5121575,
                27.9637997
              ],
              [
                56.5124377,
                27.9635206
              ],
              [
                56.5135476,
                27.9635206
              ],
              [
                56.5146576,
                27.9635207
              ],
              [
                56.5168809,
                27.9624045
              ],
              [
                56.5171576,
                27.9612973
              ],
              [
                56.5174375,
                27.9610183
              ],
              [
                56.5171576,
                27.9593531
              ],
              [
                56.5132711,
                27.9468509
              ],
              [
                56.5135476,
                27.9465809
              ],
              [
                56.5113243,
                27.9424135
              ],
              [
                56.5099342,
                27.9410184
              ],
              [
                56.5071577,
                27.935186
              ],
              [
                56.5063244,
                27.9332418
              ],
              [
                56.5024345,
                27.9215771
              ],
              [
                56.5024345,
                27.9210191
              ],
              [
                56.5021577,
                27.9207401
              ],
              [
                56.5018812,
                27.9187961
              ],
              [
                56.5016011,
                27.91741
              ],
              [
                56.5013245,
                27.9162938
              ],
              [
                56.5010477,
                27.9135217
              ],
              [
                56.5013245,
                27.9132428
              ],
              [
                56.5010478,
                27.9129637
              ],
              [
                56.5002145,
                27.9101916
              ],
              [
                56.4999344,
                27.9085176
              ],
              [
                56.5032676,
                27.9032434
              ],
              [
                56.5118007,
                27.8983888
              ],
              [
                56.5118008,
                27.8981098
              ],
              [
                56.5126342,
                27.8981097
              ],
              [
                56.5131909,
                27.8981098
              ],
              [
                56.5134674,
                27.8983887
              ],
              [
                56.514024,
                27.8983888
              ],
              [
                56.514024,
                27.8986677
              ],
              [
                56.5165241,
                27.8986676
              ],
              [
                56.5190239,
                27.8992167
              ],
              [
                56.5262473,
                27.9011609
              ],
              [
                56.5894664,
                27.9148589
              ],
              [
                56.5919663,
                27.9148589
              ],
              [
                56.5989095,
                27.915687
              ],
              [
                56.5997429,
                27.9159661
              ],
              [
                56.6008529,
                27.915966
              ],
              [
                56.6016861,
                27.9162451
              ],
              [
                56.6033528,
                27.9162451
              ],
              [
                56.6044662,
                27.9165241
              ],
              [
                56.6052994,
                27.916524
              ],
              [
                56.6058561,
                27.9168031
              ],
              [
                56.6077995,
                27.9168031
              ],
              [
                56.6083561,
                27.9170821
              ],
              [
                56.6130759,
                27.9170821
              ],
              [
                56.614466,
                27.9173611
              ],
              [
                56.6177993,
                27.9173611
              ],
              [
                56.6216891,
                27.914859
              ],
              [
                56.623076,
                27.9131939
              ],
              [
                56.6241892,
                27.9120778
              ],
              [
                56.6511354,
                27.8592768
              ],
              [
                56.6514121,
                27.8584399
              ],
              [
                56.6522453,
                27.8576117
              ],
              [
                56.6525221,
                27.8567748
              ],
              [
                56.6533552,
                27.8559377
              ],
              [
                56.6539119,
                27.8548308
              ],
              [
                56.6558553,
                27.8520497
              ],
              [
                56.6639119,
                27.8398278
              ],
              [
                56.6889148,
                27.7817718
              ],
              [
                56.689748,
                27.779558
              ],
              [
                56.7132257,
                27.755484
              ],
              [
                56.714339,
                27.7482678
              ],
              [
                56.7160055,
                27.7427071
              ],
              [
                56.7166421,
                27.7400535
              ],
              [
                56.7169189,
                27.736161
              ],
              [
                56.718868,
                27.724594
              ],
              [
                56.7221724,
                27.7182177
              ],
              [
                56.7250592,
                27.7201682
              ],
              [
                56.7271971,
                27.7214102
              ],
              [
                56.7303027,
                27.7209049
              ],
              [
                56.7347839,
                27.7225575
              ],
              [
                56.7461309,
                27.7268726
              ],
              [
                56.7569465,
                27.7318519
              ],
              [
                56.767927,
                27.7383604
              ],
              [
                56.7745039,
                27.7417216
              ],
              [
                56.7802034,
                27.7453444
              ],
              [
                56.7876674,
                27.7490619
              ],
              [
                56.7940176,
                27.7515099
              ],
              [
                56.7972993,
                27.7520635
              ],
              [
                56.8025705,
                27.7545887
              ],
              [
                56.8073415,
                27.7564689
              ],
              [
                56.816225,
                27.7606843
              ],
              [
                56.8285846,
                27.7650515
              ],
              [
                56.8350648,
                27.7684691
              ],
              [
                56.8436908,
                27.7709753
              ],
              [
                56.8475961,
                27.7717727
              ],
              [
                56.8507719,
                27.7726461
              ],
              [
                56.8563938,
                27.7748864
              ],
              [
                56.8592896,
                27.7772898
              ],
              [
                56.8412723,
                27.7894617
              ],
              [
                56.8362724,
                27.8144696
              ],
              [
                56.8351624,
                27.8197431
              ],
              [
                56.8348859,
                27.8211289
              ],
              [
                56.8340525,
                27.8250166
              ],
              [
                56.8329392,
                27.8386234
              ],
              [
                56.8318292,
                27.8514026
              ],
              [
                56.8321059,
                27.8522396
              ],
              [
                56.8271195,
                27.8681277
              ],
              [
                56.827396,
                27.8692346
              ],
              [
                56.834896,
                27.8870176
              ],
              [
                56.8385094,
                27.8959002
              ],
              [
                56.8387859,
                27.8970162
              ],
              [
                56.8390625,
                27.8972951
              ],
              [
                56.8398958,
                27.899788
              ],
              [
                56.8410092,
                27.9025689
              ],
              [
                56.8418426,
                27.9067358
              ],
              [
                56.8482326,
                27.9161767
              ],
              [
                56.8579523,
                27.9281197
              ],
              [
                56.8587858,
                27.9286778
              ],
              [
                56.8587857,
                27.9292357
              ],
              [
                56.8718422,
                27.9411789
              ],
              [
                56.8723989,
                27.9414579
              ],
              [
                56.8729555,
                27.9422859
              ],
              [
                56.8868634,
                27.9525587
              ],
              [
                56.9390141,
                27.9317723
              ],
              [
                56.9392907,
                27.9320514
              ],
              [
                56.940404,
                27.9320514
              ],
              [
                56.9406808,
                27.9323305
              ],
              [
                56.9417941,
                27.9323305
              ],
              [
                56.9754406,
                27.921014
              ],
              [
                57.0025631,
                27.9182838
              ],
              [
                57.0208559,
                27.9242472
              ],
              [
                57.0222111,
                27.9250553
              ],
              [
                57.0253859,
                28.0197302
              ],
              [
                57.0256624,
                28.0202886
              ],
              [
                57.0256625,
                28.0269533
              ],
              [
                57.0256625,
                28.0291779
              ],
              [
                57.0259393,
                28.0300154
              ],
              [
                57.0262191,
                28.0325103
              ],
              [
                57.0264959,
                28.0350142
              ],
              [
                57.0270526,
                28.0405711
              ],
              [
                57.0273291,
                28.043075
              ],
              [
                57.0276058,
                28.0464075
              ],
              [
                57.0165564,
                28.1055804
              ],
              [
                57.0159996,
                28.1286355
              ],
              [
                57.0127131,
                28.1408168
              ],
              [
                57.0127131,
                28.1474795
              ],
              [
                57.0124365,
                28.1483168
              ],
              [
                57.0124366,
                28.148587
              ],
              [
                57.0118798,
                28.1547005
              ],
              [
                57.0152165,
                28.1796602
              ],
              [
                57.015493,
                28.1804887
              ],
              [
                57.0112432,
                28.19061
              ],
              [
                56.9906437,
                28.2412046
              ],
              [
                56.9903672,
                28.2450933
              ],
              [
                56.989254,
                28.2520427
              ],
              [
                56.9884205,
                28.2548154
              ],
              [
                56.9851683,
                28.2696097
              ],
              [
                56.9778641,
                28.2753669
              ],
              [
                56.9698153,
                28.2779674
              ],
              [
                56.9692542,
                28.2781486
              ],
              [
                56.9609211,
                28.2781486
              ],
              [
                56.9165727,
                28.2651846
              ],
              [
                56.9113761,
                28.2653659
              ],
              [
                56.8981506,
                28.2643585
              ],
              [
                56.8608333,
                28.2589378
              ],
              [
                56.8509879,
                28.2590432
              ],
              [
                56.8408339,
                28.260064
              ],
              [
                56.8348468,
                28.2608344
              ],
              [
                56.8287789,
                28.2605698
              ],
              [
                56.8245136,
                28.260721
              ],
              [
                56.8187706,
                28.2621044
              ],
              [
                56.8118786,
                28.2646289
              ],
              [
                56.8097154,
                28.2655557
              ],
              [
                56.8021203,
                28.2698647
              ],
              [
                56.7982542,
                28.2717545
              ],
              [
                56.7925219,
                28.274196
              ],
              [
                56.7807667,
                28.2801686
              ],
              [
                56.7784161,
                28.2814666
              ],
              [
                56.7743371,
                28.2794017
              ],
              [
                56.7109106,
                28.2690087
              ],
              [
                56.7012976,
                28.2640194
              ],
              [
                56.6873004,
                28.235421
              ],
              [
                56.6842437,
                28.231252
              ],
              [
                56.6831337,
                28.2301446
              ],
              [
                56.6269392,
                28.1568534
              ],
              [
                56.6266592,
                28.1565834
              ],
              [
                56.6214277,
                28.1565834
              ],
              [
                56.5761785,
                28.1392472
              ],
              [
                56.5759433,
                28.1392472
              ],
              [
                56.5755412,
                28.1393484
              ],
              [
                56.5748333,
                28.1395264
              ],
              [
                56.5724648,
                28.1395264
              ],
              [
                56.5720534,
                28.1395264
              ],
              [
                56.5717516,
                28.1396274
              ],
              [
                56.57122,
                28.1398054
              ],
              [
                56.5662201,
                28.1398055
              ],
              [
                56.565667,
                28.1395264
              ],
              [
                56.5628869,
                28.1395264
              ],
              [
                56.5617769,
                28.1392473
              ],
              [
                56.551777,
                28.1392473
              ],
              [
                56.5506637,
                28.1389682
              ],
              [
                56.5481637,
                28.1389681
              ],
              [
                56.5339973,
                28.1370324
              ],
              [
                56.5245508,
                28.1353576
              ],
              [
                56.5239975,
                28.1353576
              ],
              [
                56.5184409,
                28.1342502
              ],
              [
                56.505941,
                28.1334218
              ],
              [
                56.5051076,
                28.1331338
              ],
              [
                56.5006611,
                28.1331338
              ],
              [
                56.4989945,
                28.1328547
              ],
              [
                56.4942747,
                28.1328546
              ],
              [
                56.489828,
                28.1325846
              ],
              [
                56.4881612,
                28.1323054
              ],
              [
                56.4809381,
                28.1323054
              ],
              [
                56.4792715,
                28.1320263
              ],
              [
                56.4767715,
                28.1320263
              ],
              [
                56.4751048,
                28.1317472
              ],
              [
                56.4695516,
                28.1317472
              ],
              [
                56.467605,
                28.1320263
              ],
              [
                56.445382,
                28.1309189
              ],
              [
                56.4445487,
                28.1306398
              ],
              [
                56.4345487,
                28.1306398
              ],
              [
                56.4294772,
                28.1358345
              ],
              [
                56.4292733,
                28.1359367
              ],
              [
                56.4289207,
                28.1361135
              ],
              [
                56.4219773,
                28.1361136
              ],
              [
                56.4214207,
                28.1358345
              ],
              [
                56.4166974,
                28.1358344
              ],
              [
                56.4158641,
                28.1358345
              ],
              [
                56.4153075,
                28.1358344
              ],
              [
                56.4090808,
                28.1424948
              ],
              [
                56.4088043,
                28.1422158
              ],
              [
                56.4035276,
                28.1422158
              ],
              [
                56.402971,
                28.1419367
              ],
              [
                56.3763695,
                28.1480976
              ],
              [
                56.3294399,
                28.1574376
              ],
              [
                56.3288702,
                28.1575509
              ],
              [
                56.3280603,
                28.1576865
              ],
              [
                56.3272036,
                28.1578299
              ],
              [
                56.3249803,
                28.1586583
              ],
              [
                56.3197003,
                28.1603238
              ],
              [
                56.2935471,
                28.1672527
              ],
              [
                56.2931644,
                28.1674043
              ],
              [
                56.2704908,
                28.1750228
              ],
              [
                56.2574344,
                28.1794707
              ],
              [
                56.2399346,
                28.1861335
              ],
              [
                56.235768,
                28.1883575
              ],
              [
                56.1743757,
                28.2172423
              ],
              [
                56.1624326,
                28.225022
              ],
              [
                56.1585859,
                28.2280978
              ],
              [
                56.1582659,
                28.2283536
              ],
              [
                56.1582659,
                28.2286327
              ],
              [
                56.1579859,
                28.2291909
              ],
              [
                56.1522554,
                28.2634671
              ],
              [
                56.0943736,
                28.3003012
              ],
              [
                56.0941882,
                28.3006694
              ],
              [
                56.0849272,
                28.3305769
              ],
              [
                56.084374,
                28.3316846
              ],
              [
                56.0840938,
                28.3330715
              ],
              [
                56.0829838,
                28.3361334
              ],
              [
                56.0574179,
                28.3879817
              ],
              [
                56.057558,
                28.3882609
              ],
              [
                56.057698,
                28.3885401
              ],
              [
                56.0576979,
                28.3888102
              ],
              [
                56.0097628,
                28.3903234
              ],
              [
                56.0097627,
                28.3922599
              ],
              [
                56.0097627,
                28.4011495
              ],
              [
                55.9908468,
                28.4428285
              ],
              [
                55.9911267,
                28.4439365
              ],
              [
                55.9914033,
                28.4481069
              ],
              [
                55.9940832,
                28.4914661
              ],
              [
                55.9935298,
                28.501182
              ],
              [
                55.99325,
                28.5020194
              ],
              [
                55.9929732,
                28.5053421
              ],
              [
                55.9929732,
                28.5084036
              ],
              [
                55.9932499,
                28.509232
              ],
              [
                55.9849545,
                28.513953
              ],
              [
                55.9318118,
                28.5109291
              ],
              [
                55.9173199,
                28.5193831
              ],
              [
                55.9108692,
                28.5310071
              ],
              [
                55.9111459,
                28.5321148
              ],
              [
                55.9114258,
                28.5346184
              ],
              [
                55.9117025,
                28.5368429
              ],
              [
                55.9228131,
                28.5582903
              ],
              [
                55.9777447,
                28.5679395
              ],
              [
                55.9973141,
                28.5643212
              ],
              [
                56.0240933,
                28.5809042
              ],
              [
                56.0601146,
                28.5840709
              ],
              [
                56.0601147,
                28.5860157
              ],
              [
                56.0601146,
                28.5865649
              ],
              [
                56.0603948,
                28.5871231
              ],
              [
                56.0603948,
                28.5874023
              ],
              [
                56.0603948,
                28.5876813
              ],
              [
                56.0603947,
                28.591841
              ],
              [
                56.0606715,
                28.5921201
              ],
              [
                56.065478,
                28.6087548
              ],
              [
                56.0652012,
                28.6095922
              ],
              [
                56.065478,
                28.6101414
              ],
              [
                56.0623848,
                28.6423097
              ],
              [
                56.0652084,
                28.6698105
              ],
              [
                56.0654849,
                28.6817578
              ],
              [
                56.0654849,
                28.6917591
              ],
              [
                56.0657615,
                28.6928674
              ],
              [
                56.0660416,
                28.6967598
              ],
              [
                56.058422,
                28.7042569
              ],
              [
                56.0586985,
                28.7092666
              ],
              [
                56.0589786,
                28.7139878
              ],
              [
                56.059532,
                28.7209256
              ],
              [
                56.0598118,
                28.7231511
              ],
              [
                56.0603652,
                28.7298187
              ],
              [
                56.0617385,
                28.7360685
              ],
              [
                56.048641,
                28.7571255
              ],
              [
                56.0433048,
                28.7889229
              ],
              [
                56.0202477,
                28.7907338
              ],
              [
                56.0022923,
                28.787821
              ],
              [
                55.9639476,
                28.7734311
              ],
              [
                55.9556007,
                28.7699915
              ],
              [
                55.9394645,
                28.7607371
              ],
              [
                55.919592,
                28.748515
              ],
              [
                55.9165925,
                28.7386404
              ],
              [
                55.8352658,
                28.7050432
              ],
              [
                55.8218764,
                28.6996978
              ],
              [
                55.8159541,
                28.7017305
              ],
              [
                55.8081435,
                28.7003753
              ],
              [
                55.8035945,
                28.6957828
              ],
              [
                55.802221,
                28.6894585
              ],
              [
                55.7477185,
                28.6601652
              ],
              [
                55.7326123,
                28.6592614
              ],
              [
                55.6970633,
                28.6630073
              ],
              [
                55.6553341,
                28.6716112
              ],
              [
                55.6353645,
                28.6809486
              ],
              [
                55.6151585,
                28.6860689
              ],
              [
                55.5960687,
                28.6923716
              ],
              [
                55.5716628,
                28.7044829
              ],
              [
                55.5437848,
                28.7200985
              ],
              [
                55.529941,
                28.7287216
              ],
              [
                55.5173538,
                28.7379407
              ],
              [
                55.5011195,
                28.7500734
              ],
              [
                55.298679,
                28.7494706
              ],
              [
                55.268696,
                28.7510634
              ],
              [
                55.2533242,
                28.7136208
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554999,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خمیر",
          "name:en": "Khamir County",
          "name:uk": "Хамір",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q955878",
          "wikipedia": "en:Khamir County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.8961646,
                27.2669425
              ],
              [
                54.8955925,
                27.2665826
              ],
              [
                54.8950356,
                27.2665826
              ],
              [
                54.9025356,
                27.2590816
              ],
              [
                54.9214287,
                27.2572837
              ],
              [
                55.2090447,
                27.2076184
              ],
              [
                55.3651516,
                27.1651328
              ],
              [
                55.365705,
                27.1645663
              ],
              [
                55.3668183,
                27.1642874
              ],
              [
                55.3750311,
                27.1275137
              ],
              [
                55.3736447,
                27.1247263
              ],
              [
                55.3733645,
                27.123899
              ],
              [
                55.3728112,
                27.1222265
              ],
              [
                55.3728112,
                27.1219478
              ],
              [
                55.3725311,
                27.1213993
              ],
              [
                55.3722544,
                27.120563
              ],
              [
                55.3719778,
                27.1188995
              ],
              [
                55.3716978,
                27.1172271
              ],
              [
                55.365588,
                27.0975085
              ],
              [
                55.3395019,
                27.0853426
              ],
              [
                55.3395018,
                27.0839491
              ],
              [
                55.3395019,
                27.0834007
              ],
              [
                55.3564449,
                27.0747883
              ],
              [
                55.3595015,
                27.0733948
              ],
              [
                55.4056141,
                27.0581121
              ],
              [
                55.408114,
                27.0570065
              ],
              [
                55.4295037,
                27.0508935
              ],
              [
                55.431447,
                27.0503361
              ],
              [
                55.4367269,
                27.0489517
              ],
              [
                55.4542266,
                27.0447806
              ],
              [
                55.45534,
                27.0447806
              ],
              [
                55.4570066,
                27.0442232
              ],
              [
                55.4581166,
                27.0442232
              ],
              [
                55.45895,
                27.0436749
              ],
              [
                55.4661731,
                27.0420028
              ],
              [
                55.4664497,
                27.0417241
              ],
              [
                55.4675597,
                27.0417241
              ],
              [
                55.4703398,
                27.0406184
              ],
              [
                55.5000626,
                27.0311706
              ],
              [
                55.5045057,
                27.0283929
              ],
              [
                55.5070091,
                27.0250669
              ],
              [
                55.5081191,
                27.0236735
              ],
              [
                55.5222856,
                27.00201
              ],
              [
                55.5256188,
                26.9980124
              ],
              [
                55.5256188,
                26.9970032
              ],
              [
                55.5211755,
                26.9806169
              ],
              [
                55.5214522,
                26.9725631
              ],
              [
                55.5211756,
                26.9714485
              ],
              [
                55.5231189,
                26.9631163
              ],
              [
                55.5325654,
                26.9478364
              ],
              [
                55.5483985,
                26.9297796
              ],
              [
                55.5595082,
                26.9192279
              ],
              [
                55.578959,
                26.9268476
              ],
              [
                55.5793307,
                26.9270144
              ],
              [
                55.5886074,
                26.9240083
              ],
              [
                55.5975402,
                26.9245797
              ],
              [
                55.6248407,
                26.9109964
              ],
              [
                55.634422,
                26.9257435
              ],
              [
                55.7008696,
                26.9474466
              ],
              [
                55.7487484,
                26.9630821
              ],
              [
                55.7598118,
                26.9623899
              ],
              [
                55.758233,
                26.975742
              ],
              [
                55.7582577,
                27.0418757
              ],
              [
                55.7594717,
                27.0430902
              ],
              [
                55.7572817,
                27.0479556
              ],
              [
                55.7595484,
                27.0596507
              ],
              [
                55.7484051,
                27.0753292
              ],
              [
                55.7357657,
                27.0913038
              ],
              [
                55.7452677,
                27.1156147
              ],
              [
                55.7483155,
                27.12595
              ],
              [
                55.7485956,
                27.1273437
              ],
              [
                55.7488722,
                27.1298434
              ],
              [
                55.7483155,
                27.1331707
              ],
              [
                55.7430391,
                27.1409579
              ],
              [
                55.741649,
                27.143179
              ],
              [
                55.7402624,
                27.1531785
              ],
              [
                55.7413725,
                27.1578996
              ],
              [
                55.7422057,
                27.1606783
              ],
              [
                55.7427623,
                27.1628994
              ],
              [
                55.7424825,
                27.1659569
              ],
              [
                55.7397058,
                27.1740143
              ],
              [
                55.739429,
                27.1759568
              ],
              [
                55.7385959,
                27.1779081
              ],
              [
                55.7380392,
                27.1815144
              ],
              [
                55.7377625,
                27.1823506
              ],
              [
                55.7380392,
                27.1829082
              ],
              [
                55.7383158,
                27.1865144
              ],
              [
                55.7410957,
                27.1931781
              ],
              [
                55.7438723,
                27.195957
              ],
              [
                55.7458157,
                27.1970721
              ],
              [
                55.746649,
                27.1970721
              ],
              [
                55.7472056,
                27.197351
              ],
              [
                55.7519289,
                27.1973509
              ],
              [
                55.7547056,
                27.1965236
              ],
              [
                55.7549855,
                27.1962448
              ],
              [
                55.7563721,
                27.1962448
              ],
              [
                55.7572055,
                27.195957
              ],
              [
                55.7585954,
                27.195957
              ],
              [
                55.7597054,
                27.1956872
              ],
              [
                55.7738752,
                27.1956872
              ],
              [
                55.7763752,
                27.195957
              ],
              [
                55.7777617,
                27.1962447
              ],
              [
                55.7799852,
                27.1962447
              ],
              [
                55.8171678,
                27.2081219
              ],
              [
                55.819111,
                27.2081219
              ],
              [
                55.882301,
                27.2128087
              ],
              [
                55.8961335,
                27.207683
              ],
              [
                55.8972432,
                27.2076831
              ],
              [
                55.9027999,
                27.2059938
              ],
              [
                55.9036332,
                27.2057406
              ],
              [
                55.9041898,
                27.2057406
              ],
              [
                55.9055765,
                27.2046255
              ],
              [
                55.9066899,
                27.203798
              ],
              [
                55.9169664,
                27.1982403
              ],
              [
                55.9183562,
                27.1982403
              ],
              [
                55.9191896,
                27.1979615
              ],
              [
                55.9205761,
                27.1979615
              ],
              [
                55.9233561,
                27.1971342
              ],
              [
                55.9311327,
                27.1962978
              ],
              [
                55.9681885,
                27.2093138
              ],
              [
                55.9687451,
                27.209035
              ],
              [
                55.9698552,
                27.209035
              ],
              [
                55.9704117,
                27.2087562
              ],
              [
                55.9740218,
                27.2095924
              ],
              [
                55.974855,
                27.2095925
              ],
              [
                55.9754117,
                27.2098712
              ],
              [
                55.9762452,
                27.2098713
              ],
              [
                55.9884682,
                27.215419
              ],
              [
                55.9920782,
                27.2181974
              ],
              [
                56.0081913,
                27.2298685
              ],
              [
                56.0084679,
                27.230417
              ],
              [
                56.0195312,
                27.2320055
              ],
              [
                56.0200843,
                27.2320056
              ],
              [
                56.0228644,
                27.2347841
              ],
              [
                56.0236977,
                27.2370052
              ],
              [
                56.0264743,
                27.2428412
              ],
              [
                56.0267509,
                27.2433987
              ],
              [
                56.0337063,
                27.2521882
              ],
              [
                56.0357663,
                27.265922
              ],
              [
                56.0397875,
                27.271787
              ],
              [
                56.0420075,
                27.2745657
              ],
              [
                56.0445109,
                27.2801142
              ],
              [
                56.0306164,
                27.2924691
              ],
              [
                56.0261532,
                27.3147394
              ],
              [
                56.0089871,
                27.3266354
              ],
              [
                55.9928509,
                27.3321255
              ],
              [
                55.9810891,
                27.3276627
              ],
              [
                55.981089,
                27.3284993
              ],
              [
                55.9804913,
                27.347984
              ],
              [
                55.9955472,
                27.3839199
              ],
              [
                55.8843364,
                27.3944331
              ],
              [
                55.8829466,
                27.3944332
              ],
              [
                55.8654871,
                27.4014958
              ],
              [
                55.8638204,
                27.4014958
              ],
              [
                55.8614872,
                27.4031585
              ],
              [
                55.8598205,
                27.4031585
              ],
              [
                55.8575971,
                27.4026008
              ],
              [
                55.8548204,
                27.4026008
              ],
              [
                55.8542637,
                27.4026009
              ],
              [
                55.8410774,
                27.4072856
              ],
              [
                55.8382974,
                27.4081221
              ],
              [
                55.8189645,
                27.4159038
              ],
              [
                55.7808884,
                27.4216526
              ],
              [
                55.780055,
                27.4219315
              ],
              [
                55.7572955,
                27.4274415
              ],
              [
                55.7570188,
                27.4277204
              ],
              [
                55.7561856,
                27.4277204
              ],
              [
                55.7481289,
                27.4313369
              ],
              [
                55.7372958,
                27.4332712
              ],
              [
                55.7367391,
                27.43355
              ],
              [
                55.7364625,
                27.4332711
              ],
              [
                55.7361858,
                27.43355
              ],
              [
                55.7356291,
                27.4332712
              ],
              [
                55.7314624,
                27.4332712
              ],
              [
                55.7306293,
                27.43355
              ],
              [
                55.7289626,
                27.43355
              ],
              [
                55.7222961,
                27.4330012
              ],
              [
                55.6984064,
                27.4459019
              ],
              [
                55.6847933,
                27.4497879
              ],
              [
                55.6839599,
                27.4497878
              ],
              [
                55.6822933,
                27.4506244
              ],
              [
                55.6806266,
                27.4514609
              ],
              [
                55.6392609,
                27.4693502
              ],
              [
                55.6373176,
                27.4710145
              ],
              [
                55.6031149,
                27.4834639
              ],
              [
                55.6025582,
                27.4834639
              ],
              [
                55.6020014,
                27.4840217
              ],
              [
                55.6011682,
                27.4845796
              ],
              [
                55.540363,
                27.5056689
              ],
              [
                55.5389731,
                27.5062267
              ],
              [
                55.5381397,
                27.5065056
              ],
              [
                55.5353631,
                27.5065057
              ],
              [
                55.5328631,
                27.5059478
              ],
              [
                55.5152001,
                27.5102878
              ],
              [
                55.5143669,
                27.5100088
              ],
              [
                55.5090903,
                27.5097299
              ],
              [
                55.5052004,
                27.5097299
              ],
              [
                55.5041979,
                27.5096414
              ],
              [
                55.4994301,
                27.5113843
              ],
              [
                55.472913,
                27.5136144
              ],
              [
                55.4347425,
                27.5178766
              ],
              [
                55.3784586,
                27.5185482
              ],
              [
                55.3615872,
                27.5130186
              ],
              [
                55.3286539,
                27.5124417
              ],
              [
                55.2940682,
                27.5076412
              ],
              [
                55.2937961,
                27.5073666
              ],
              [
                55.2879827,
                27.4858809
              ],
              [
                55.2874294,
                27.4858808
              ],
              [
                55.2871494,
                27.485323
              ],
              [
                55.2749627,
                27.4595399
              ],
              [
                55.2433564,
                27.4243228
              ],
              [
                55.2389097,
                27.4220999
              ],
              [
                55.2291899,
                27.4170963
              ],
              [
                55.2063603,
                27.4214877
              ],
              [
                55.1463751,
                27.421934
              ],
              [
                55.1463751,
                27.421664
              ],
              [
                55.1447084,
                27.4208275
              ],
              [
                55.1438752,
                27.4208274
              ],
              [
                55.1438752,
                27.4205486
              ],
              [
                55.1433185,
                27.4205486
              ],
              [
                55.1408185,
                27.4194331
              ],
              [
                55.1383185,
                27.4188843
              ],
              [
                55.138042,
                27.4186055
              ],
              [
                55.1377618,
                27.4183265
              ],
              [
                55.1349852,
                27.4172201
              ],
              [
                55.1338719,
                27.4172201
              ],
              [
                55.1335953,
                27.4169322
              ],
              [
                55.1319287,
                27.4169323
              ],
              [
                55.1310954,
                27.4166623
              ],
              [
                55.0430491,
                27.4234981
              ],
              [
                55.0430491,
                27.4196581
              ],
              [
                55.0427724,
                27.4193703
              ],
              [
                54.9871075,
                27.3680294
              ],
              [
                54.921795,
                27.2849042
              ],
              [
                54.8961646,
                27.2669425
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555047,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رودان",
          "name:en": "Rudan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270925",
          "wikipedia": "en:Rudan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.8592896,
                27.7772898
              ],
              [
                56.8595068,
                27.7740863
              ],
              [
                56.8627793,
                27.7654199
              ],
              [
                56.8654918,
                27.7562411
              ],
              [
                56.8706416,
                27.7476579
              ],
              [
                56.8721058,
                27.7403459
              ],
              [
                56.8776797,
                27.7253991
              ],
              [
                56.8793535,
                27.7219041
              ],
              [
                56.8808557,
                27.7201736
              ],
              [
                56.8924426,
                27.6995641
              ],
              [
                56.8958758,
                27.6928004
              ],
              [
                56.9004249,
                27.6855803
              ],
              [
                56.9054889,
                27.682084
              ],
              [
                56.9066884,
                27.6785978
              ],
              [
                56.9129561,
                27.668022
              ],
              [
                56.9227408,
                27.6576833
              ],
              [
                56.9450562,
                27.6167756
              ],
              [
                56.9594763,
                27.5840679
              ],
              [
                56.9739018,
                27.5403672
              ],
              [
                56.9763995,
                27.5267074
              ],
              [
                56.9791044,
                27.5157306
              ],
              [
                56.9800757,
                27.4998973
              ],
              [
                56.9783746,
                27.4842432
              ],
              [
                57.0171773,
                27.4455491
              ],
              [
                57.0296418,
                27.433311
              ],
              [
                57.0431113,
                27.4197503
              ],
              [
                57.0743678,
                27.3892092
              ],
              [
                57.0898235,
                27.3658732
              ],
              [
                57.1026419,
                27.3469165
              ],
              [
                57.1214203,
                27.3184518
              ],
              [
                57.1355408,
                27.2974129
              ],
              [
                57.1517947,
                27.2720593
              ],
              [
                57.1756477,
                27.2351205
              ],
              [
                57.1550432,
                27.2240141
              ],
              [
                57.1555999,
                27.222908
              ],
              [
                57.1572666,
                27.2212353
              ],
              [
                57.1572665,
                27.2209566
              ],
              [
                57.1711562,
                27.2026294
              ],
              [
                57.1814327,
                27.1856786
              ],
              [
                57.1942126,
                27.1654013
              ],
              [
                57.1947693,
                27.1648437
              ],
              [
                57.1947692,
                27.1645649
              ],
              [
                57.1950458,
                27.1642863
              ],
              [
                57.1951863,
                27.1640075
              ],
              [
                57.1951882,
                27.1640037
              ],
              [
                57.2064357,
                27.1398374
              ],
              [
                57.2328089,
                27.0981982
              ],
              [
                57.2332273,
                27.0986163
              ],
              [
                57.2341105,
                27.0992661
              ],
              [
                57.2353088,
                27.0998616
              ],
              [
                57.2355889,
                27.0998615
              ],
              [
                57.2358655,
                27.1001402
              ],
              [
                57.2361455,
                27.100419
              ],
              [
                57.2364221,
                27.1006976
              ],
              [
                57.2366988,
                27.1009764
              ],
              [
                57.236979,
                27.1009764
              ],
              [
                57.2372556,
                27.1015338
              ],
              [
                57.2375321,
                27.1018126
              ],
              [
                57.2380889,
                27.1018126
              ],
              [
                57.2383655,
                27.1020912
              ],
              [
                57.2386456,
                27.10237
              ],
              [
                57.2507857,
                27.1055891
              ],
              [
                57.2579094,
                27.1126946
              ],
              [
                57.2626303,
                27.113382
              ],
              [
                57.2847746,
                27.1373685
              ],
              [
                57.3089789,
                27.1534076
              ],
              [
                57.3356673,
                27.1537004
              ],
              [
                57.3365009,
                27.1539791
              ],
              [
                57.3381674,
                27.1539791
              ],
              [
                57.3398342,
                27.1542579
              ],
              [
                57.3406674,
                27.1545366
              ],
              [
                57.342614,
                27.1548153
              ],
              [
                57.3511017,
                27.1586339
              ],
              [
                57.3519415,
                27.159368
              ],
              [
                57.353048,
                27.1599255
              ],
              [
                57.3536082,
                27.1604831
              ],
              [
                57.3547142,
                27.1613196
              ],
              [
                57.3558276,
                27.1624256
              ],
              [
                57.3561077,
                27.1629831
              ],
              [
                57.3566039,
                27.1633584
              ],
              [
                57.3572138,
                27.1638196
              ],
              [
                57.3583268,
                27.1649347
              ],
              [
                57.3588802,
                27.1654833
              ],
              [
                57.4127985,
                27.209896
              ],
              [
                57.4125183,
                27.2107322
              ],
              [
                57.4125182,
                27.2112897
              ],
              [
                57.4125181,
                27.2114863
              ],
              [
                57.4122379,
                27.2124046
              ],
              [
                57.4122378,
                27.2129531
              ],
              [
                57.4122377,
                27.2132319
              ],
              [
                57.4122376,
                27.2140681
              ],
              [
                57.4119645,
                27.2146166
              ],
              [
                57.4654287,
                27.2295862
              ],
              [
                57.4653622,
                27.2479152
              ],
              [
                57.4772505,
                27.2672613
              ],
              [
                57.4420162,
                27.2898757
              ],
              [
                57.4193717,
                27.3208861
              ],
              [
                57.4134204,
                27.3286425
              ],
              [
                57.4024434,
                27.3420127
              ],
              [
                57.3922686,
                27.349494
              ],
              [
                57.3621081,
                27.3776363
              ],
              [
                57.3462295,
                27.3880013
              ],
              [
                57.3386764,
                27.394098
              ],
              [
                57.3309801,
                27.4060738
              ],
              [
                57.3318088,
                27.4101936
              ],
              [
                57.3309684,
                27.4193102
              ],
              [
                57.3322785,
                27.4360582
              ],
              [
                57.3317384,
                27.462383
              ],
              [
                57.3282972,
                27.4853745
              ],
              [
                57.333269,
                27.4990597
              ],
              [
                57.3438262,
                27.540088
              ],
              [
                57.3400496,
                27.5661889
              ],
              [
                57.3353897,
                27.5721441
              ],
              [
                57.3275184,
                27.5795794
              ],
              [
                57.3175619,
                27.5810249
              ],
              [
                57.3082923,
                27.5833071
              ],
              [
                57.3046015,
                27.5885563
              ],
              [
                57.2803114,
                27.5846765
              ],
              [
                57.2554205,
                27.5877195
              ],
              [
                57.2497557,
                27.5895452
              ],
              [
                57.237819,
                27.5882338
              ],
              [
                57.2336196,
                27.5945656
              ],
              [
                57.2302418,
                27.6016704
              ],
              [
                57.2220322,
                27.6201215
              ],
              [
                57.223663,
                27.6322127
              ],
              [
                57.2349068,
                27.6351022
              ],
              [
                57.2404858,
                27.6395124
              ],
              [
                57.2442624,
                27.6490925
              ],
              [
                57.2487635,
                27.65822
              ],
              [
                57.2526311,
                27.6573791
              ],
              [
                57.2716856,
                27.6596218
              ],
              [
                57.280097,
                27.6621305
              ],
              [
                57.28328,
                27.666732
              ],
              [
                57.2831942,
                27.6720788
              ],
              [
                57.2814528,
                27.6785314
              ],
              [
                57.2760122,
                27.6839315
              ],
              [
                57.2749042,
                27.6893424
              ],
              [
                57.2741651,
                27.694163
              ],
              [
                57.2811283,
                27.6969481
              ],
              [
                57.2839161,
                27.7024521
              ],
              [
                57.2837229,
                27.7085858
              ],
              [
                57.2834247,
                27.7158554
              ],
              [
                57.2850804,
                27.7148039
              ],
              [
                57.3213383,
                27.70268
              ],
              [
                57.3409077,
                27.6999443
              ],
              [
                57.3560305,
                27.7035217
              ],
              [
                57.3919178,
                27.7349036
              ],
              [
                57.4004185,
                27.7478263
              ],
              [
                57.4013947,
                27.7760793
              ],
              [
                57.4170398,
                27.7721904
              ],
              [
                57.4302529,
                27.7730101
              ],
              [
                57.4510801,
                27.7773089
              ],
              [
                57.4665963,
                27.7828675
              ],
              [
                57.4747004,
                27.7910374
              ],
              [
                57.43931,
                27.8030586
              ],
              [
                57.4328698,
                27.8057087
              ],
              [
                57.43922,
                27.8130143
              ],
              [
                57.4185002,
                27.8218092
              ],
              [
                57.4157472,
                27.8222343
              ],
              [
                57.4148869,
                27.8223671
              ],
              [
                57.4143294,
                27.8227402
              ],
              [
                57.4140533,
                27.8229249
              ],
              [
                57.4134884,
                27.8229249
              ],
              [
                57.41294,
                27.8229249
              ],
              [
                57.4076668,
                27.8254264
              ],
              [
                57.3593729,
                27.8929261
              ],
              [
                57.3593543,
                27.8929261
              ],
              [
                57.3588814,
                27.8930208
              ],
              [
                57.357961,
                27.8932051
              ],
              [
                57.286306,
                27.9709021
              ],
              [
                57.2860806,
                27.9709302
              ],
              [
                57.2796908,
                27.9723154
              ],
              [
                57.2738875,
                27.9801011
              ],
              [
                57.2722209,
                27.9806587
              ],
              [
                57.271111,
                27.9814862
              ],
              [
                57.2446057,
                27.9395173
              ],
              [
                57.2329327,
                27.9122163
              ],
              [
                57.2216031,
                27.8882464
              ],
              [
                57.1862099,
                27.8947272
              ],
              [
                57.1742245,
                27.9040247
              ],
              [
                57.1442107,
                27.9390861
              ],
              [
                57.0222111,
                27.9250553
              ],
              [
                57.0208559,
                27.9242472
              ],
              [
                57.0025631,
                27.9182838
              ],
              [
                56.9754406,
                27.921014
              ],
              [
                56.9417941,
                27.9323305
              ],
              [
                56.9406808,
                27.9323305
              ],
              [
                56.940404,
                27.9320514
              ],
              [
                56.9392907,
                27.9320514
              ],
              [
                56.9390141,
                27.9317723
              ],
              [
                56.8868634,
                27.9525587
              ],
              [
                56.8729555,
                27.9422859
              ],
              [
                56.8723989,
                27.9414579
              ],
              [
                56.8718422,
                27.9411789
              ],
              [
                56.8587857,
                27.9292357
              ],
              [
                56.8587858,
                27.9286778
              ],
              [
                56.8579523,
                27.9281197
              ],
              [
                56.8482326,
                27.9161767
              ],
              [
                56.8418426,
                27.9067358
              ],
              [
                56.8410092,
                27.9025689
              ],
              [
                56.8398958,
                27.899788
              ],
              [
                56.8390625,
                27.8972951
              ],
              [
                56.8387859,
                27.8970162
              ],
              [
                56.8385094,
                27.8959002
              ],
              [
                56.834896,
                27.8870176
              ],
              [
                56.827396,
                27.8692346
              ],
              [
                56.8271195,
                27.8681277
              ],
              [
                56.8321059,
                27.8522396
              ],
              [
                56.8318292,
                27.8514026
              ],
              [
                56.8329392,
                27.8386234
              ],
              [
                56.8340525,
                27.8250166
              ],
              [
                56.8348859,
                27.8211289
              ],
              [
                56.8351624,
                27.8197431
              ],
              [
                56.8362724,
                27.8144696
              ],
              [
                56.8412723,
                27.7894617
              ],
              [
                56.8592896,
                27.7772898
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555094,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان سیریک",
          "name:en": "Sirik County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q6428916",
          "wikipedia": "en:Sirik County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.7542328,
                26.6611203
              ],
              [
                56.7958993,
                26.5875094
              ],
              [
                56.7917325,
                26.420843
              ],
              [
                56.8014547,
                26.3666764
              ],
              [
                56.797288,
                26.2750099
              ],
              [
                56.8000657,
                26.1930656
              ],
              [
                56.8375656,
                26.0513992
              ],
              [
                57.171368,
                26.0981379
              ],
              [
                57.2073573,
                26.0922629
              ],
              [
                57.2079139,
                26.0925411
              ],
              [
                57.216247,
                26.0925411
              ],
              [
                57.2179137,
                26.0925411
              ],
              [
                57.2195803,
                26.0925411
              ],
              [
                57.2204135,
                26.0928193
              ],
              [
                57.2215234,
                26.0928193
              ],
              [
                57.2220803,
                26.0930975
              ],
              [
                57.2231901,
                26.0930975
              ],
              [
                57.2329133,
                26.0975399
              ],
              [
                57.2340233,
                26.0983745
              ],
              [
                57.2351368,
                26.0983745
              ],
              [
                57.2351368,
                26.0986527
              ],
              [
                57.23597,
                26.0986528
              ],
              [
                57.2362466,
                26.0983745
              ],
              [
                57.23819,
                26.0983745
              ],
              [
                57.2412466,
                26.1000438
              ],
              [
                57.2459698,
                26.1014259
              ],
              [
                57.2462465,
                26.1017041
              ],
              [
                57.2470798,
                26.1017041
              ],
              [
                57.2481931,
                26.1022605
              ],
              [
                57.2501365,
                26.104208
              ],
              [
                57.255693,
                26.1069901
              ],
              [
                57.257913,
                26.1078158
              ],
              [
                57.2598597,
                26.1086505
              ],
              [
                57.260693,
                26.1086506
              ],
              [
                57.2720827,
                26.1139367
              ],
              [
                57.305139,
                26.129212
              ],
              [
                57.3281918,
                26.1403233
              ],
              [
                57.3351383,
                26.1450443
              ],
              [
                57.3362515,
                26.1456008
              ],
              [
                57.3401385,
                26.1486525
              ],
              [
                57.3520847,
                26.1583819
              ],
              [
                57.3618048,
                26.1655984
              ],
              [
                57.3706979,
                26.1725367
              ],
              [
                57.3995839,
                26.1872662
              ],
              [
                57.4237506,
                26.1844855
              ],
              [
                57.4293038,
                26.1861464
              ],
              [
                57.4479167,
                26.1928166
              ],
              [
                57.4487503,
                26.1928166
              ],
              [
                57.4501366,
                26.1933732
              ],
              [
                57.4548633,
                26.1942082
              ],
              [
                57.4726433,
                26.1953123
              ],
              [
                57.4831961,
                26.195043
              ],
              [
                57.4843095,
                26.1947648
              ],
              [
                57.4868096,
                26.1947647
              ],
              [
                57.4879161,
                26.1944864
              ],
              [
                57.4895826,
                26.1944864
              ],
              [
                57.4923627,
                26.1939298
              ],
              [
                57.4940295,
                26.1939298
              ],
              [
                57.5051426,
                26.1917123
              ],
              [
                57.5062559,
                26.191425
              ],
              [
                57.5073625,
                26.191425
              ],
              [
                57.5081958,
                26.1911467
              ],
              [
                57.5123622,
                26.1911467
              ],
              [
                57.5129224,
                26.191425
              ],
              [
                57.5148623,
                26.1914251
              ],
              [
                57.5154225,
                26.1917123
              ],
              [
                57.5159756,
                26.1917123
              ],
              [
                57.5165292,
                26.1919816
              ],
              [
                57.5165291,
                26.1922599
              ],
              [
                57.5165291,
                26.1947647
              ],
              [
                57.5151424,
                26.2006001
              ],
              [
                57.5148623,
                26.2011477
              ],
              [
                57.5143092,
                26.2030959
              ],
              [
                57.513476,
                26.2072616
              ],
              [
                57.5129225,
                26.2083748
              ],
              [
                57.5126424,
                26.2100447
              ],
              [
                57.5120892,
                26.2111489
              ],
              [
                57.4907831,
                26.232265
              ],
              [
                57.483283,
                26.2536572
              ],
              [
                57.4774502,
                26.2758763
              ],
              [
                57.4771701,
                26.2769895
              ],
              [
                57.4766165,
                26.2794942
              ],
              [
                57.4493974,
                26.3272663
              ],
              [
                57.4482842,
                26.3289363
              ],
              [
                57.425411,
                26.3694935
              ],
              [
                57.4145781,
                26.3853238
              ],
              [
                57.4137444,
                26.3867157
              ],
              [
                57.3890183,
                26.427268
              ],
              [
                57.3881851,
                26.4292168
              ],
              [
                57.3806851,
                26.4386638
              ],
              [
                57.3779052,
                26.4444921
              ],
              [
                57.3695719,
                26.4583758
              ],
              [
                57.3680302,
                26.4657661
              ],
              [
                57.3683103,
                26.4663229
              ],
              [
                57.3683103,
                26.4688198
              ],
              [
                57.3652571,
                26.4732656
              ],
              [
                57.3478254,
                26.4953808
              ],
              [
                57.3467192,
                26.4962071
              ],
              [
                57.3464391,
                26.4970425
              ],
              [
                57.3453258,
                26.4978778
              ],
              [
                57.3186594,
                26.5392694
              ],
              [
                57.3186594,
                26.5398263
              ],
              [
                57.3183864,
                26.5401048
              ],
              [
                57.3183864,
                26.5403833
              ],
              [
                57.3181063,
                26.5406618
              ],
              [
                57.3075464,
                26.5637213
              ],
              [
                57.3072729,
                26.5639998
              ],
              [
                57.3064397,
                26.5664971
              ],
              [
                57.2978268,
                26.5942742
              ],
              [
                57.2864403,
                26.6292849
              ],
              [
                57.2861602,
                26.6298329
              ],
              [
                57.2858801,
                26.6306684
              ],
              [
                57.2858801,
                26.6312254
              ],
              [
                57.2844938,
                26.6345587
              ],
              [
                57.2842136,
                26.6362208
              ],
              [
                57.2825468,
                26.64012
              ],
              [
                57.2822738,
                26.6409466
              ],
              [
                57.2814402,
                26.6428962
              ],
              [
                57.2786605,
                26.6478917
              ],
              [
                57.2703271,
                26.6731748
              ],
              [
                57.269494,
                26.674846
              ],
              [
                57.2694939,
                26.675403
              ],
              [
                57.2692139,
                26.6759512
              ],
              [
                57.2689373,
                26.6767868
              ],
              [
                57.2625474,
                26.6984591
              ],
              [
                57.2619907,
                26.7006784
              ],
              [
                57.2589374,
                26.7129077
              ],
              [
                57.2539375,
                26.7248496
              ],
              [
                57.2514378,
                26.729019
              ],
              [
                57.2419911,
                26.7545752
              ],
              [
                57.2411578,
                26.7584574
              ],
              [
                57.2408811,
                26.7604074
              ],
              [
                57.2353047,
                26.761771
              ],
              [
                57.2140499,
                26.7643113
              ],
              [
                57.191734,
                26.7713615
              ],
              [
                57.1533292,
                26.796693
              ],
              [
                57.1491626,
                26.7966931
              ],
              [
                57.136543,
                26.8103346
              ],
              [
                57.1362663,
                26.8106132
              ],
              [
                57.135433,
                26.8106132
              ],
              [
                57.1287352,
                26.8148534
              ],
              [
                57.1270999,
                26.8158885
              ],
              [
                57.1259864,
                26.8164456
              ],
              [
                57.1146002,
                26.8381225
              ],
              [
                57.1140436,
                26.840621
              ],
              [
                57.1132101,
                26.8425624
              ],
              [
                57.1079302,
                26.8892354
              ],
              [
                57.1082103,
                26.8897927
              ],
              [
                57.1084869,
                26.8936756
              ],
              [
                57.1082103,
                26.9006233
              ],
              [
                57.1079302,
                26.9022952
              ],
              [
                57.1076537,
                26.9072927
              ],
              [
                57.1073769,
                26.9103487
              ],
              [
                57.1068203,
                26.9150677
              ],
              [
                57.107097,
                26.9153463
              ],
              [
                57.1076536,
                26.917845
              ],
              [
                57.1079301,
                26.9189597
              ],
              [
                57.1087637,
                26.9267348
              ],
              [
                57.1084868,
                26.9286762
              ],
              [
                57.1113635,
                26.9346608
              ],
              [
                57.1113635,
                26.9349395
              ],
              [
                57.1108101,
                26.9363236
              ],
              [
                57.1105303,
                26.9366023
              ],
              [
                57.1096969,
                26.9385528
              ],
              [
                57.1096968,
                26.9388314
              ],
              [
                57.1066437,
                26.9416088
              ],
              [
                57.0921971,
                26.9474423
              ],
              [
                57.0902539,
                26.9474423
              ],
              [
                57.0902539,
                26.947721
              ],
              [
                57.0894205,
                26.947721
              ],
              [
                57.0683075,
                26.9585522
              ],
              [
                57.0677508,
                26.9588309
              ],
              [
                57.0641907,
                26.9595619
              ],
              [
                57.0620227,
                26.9586351
              ],
              [
                57.0595121,
                26.9579657
              ],
              [
                57.058289,
                26.9575545
              ],
              [
                57.0575166,
                26.9572294
              ],
              [
                57.0570713,
                26.9570811
              ],
              [
                57.0567065,
                26.9570429
              ],
              [
                57.0565081,
                26.9571672
              ],
              [
                57.0561701,
                26.9573776
              ],
              [
                57.0558321,
                26.9573919
              ],
              [
                57.0553815,
                26.9572867
              ],
              [
                57.0547861,
                26.9570429
              ],
              [
                57.0542926,
                26.9567847
              ],
              [
                57.0538795,
                26.9565121
              ],
              [
                57.0533913,
                26.9560005
              ],
              [
                57.0526886,
                26.9553645
              ],
              [
                57.0518625,
                26.9545995
              ],
              [
                57.0516318,
                26.9542313
              ],
              [
                57.0514923,
                26.9539061
              ],
              [
                57.0514065,
                26.9535666
              ],
              [
                57.0514387,
                26.9532415
              ],
              [
                57.0515031,
                26.9528876
              ],
              [
                57.0517445,
                26.9523855
              ],
              [
                57.0520073,
                26.9517017
              ],
              [
                57.0523077,
                26.9511375
              ],
              [
                57.0525652,
                26.9508219
              ],
              [
                57.0531285,
                26.9505159
              ],
              [
                57.0548236,
                26.9496264
              ],
              [
                57.0554352,
                26.9493921
              ],
              [
                57.0562935,
                26.9491004
              ],
              [
                57.0566904,
                26.9489044
              ],
              [
                57.0572537,
                26.9485505
              ],
              [
                57.0576131,
                26.9481966
              ],
              [
                57.0580101,
                26.9477232
              ],
              [
                57.0581496,
                26.9474459
              ],
              [
                57.058273,
                26.9470155
              ],
              [
                57.0582837,
                26.9467764
              ],
              [
                57.0582086,
                26.9465803
              ],
              [
                57.0580155,
                26.9463317
              ],
              [
                57.0579404,
                26.9460878
              ],
              [
                57.0579511,
                26.9458248
              ],
              [
                57.0580637,
                26.9454613
              ],
              [
                57.0580637,
                26.9449497
              ],
              [
                57.0579296,
                26.9444045
              ],
              [
                57.0577151,
                26.943888
              ],
              [
                57.0572752,
                26.9433668
              ],
              [
                57.0569587,
                26.9431086
              ],
              [
                57.0565993,
                26.9429555
              ],
              [
                57.0560896,
                26.9428886
              ],
              [
                57.0550919,
                26.9429125
              ],
              [
                57.0542657,
                26.9429555
              ],
              [
                57.0535952,
                26.9431468
              ],
              [
                57.0527261,
                26.9433811
              ],
              [
                57.0515513,
                26.9438402
              ],
              [
                57.0509559,
                26.9441654
              ],
              [
                57.0502102,
                26.9446532
              ],
              [
                57.0488208,
                26.9455713
              ],
              [
                57.0484132,
                26.9459252
              ],
              [
                57.0481288,
                26.9463173
              ],
              [
                57.047925,
                26.946719
              ],
              [
                57.0478123,
                26.9471255
              ],
              [
                57.0474583,
                26.9476419
              ],
              [
                57.0470291,
                26.9480484
              ],
              [
                57.0465088,
                26.9482923
              ],
              [
                57.0459992,
                26.9483401
              ],
              [
                57.0455539,
                26.9483258
              ],
              [
                57.0451677,
                26.9482397
              ],
              [
                57.044422,
                26.948101
              ],
              [
                57.0434403,
                26.9477997
              ],
              [
                57.0427483,
                26.9475319
              ],
              [
                57.0424962,
                26.9473168
              ],
              [
                57.0423835,
                26.947049
              ],
              [
                57.0423943,
                26.9467668
              ],
              [
                57.0424211,
                26.9463938
              ],
              [
                57.0424104,
                26.9460495
              ],
              [
                57.0425123,
                26.9457626
              ],
              [
                57.0426303,
                26.9454326
              ],
              [
                57.0426142,
                26.9451792
              ],
              [
                57.0424533,
                26.9448301
              ],
              [
                57.0420939,
                26.9444428
              ],
              [
                57.0419598,
                26.9441558
              ],
              [
                57.0419168,
                26.9434959
              ],
              [
                57.0418149,
                26.942879
              ],
              [
                57.0415467,
                26.9419513
              ],
              [
                57.0413321,
                26.9409566
              ],
              [
                57.0411175,
                26.9399666
              ],
              [
                57.041139,
                26.9394501
              ],
              [
                57.0412463,
                26.9388428
              ],
              [
                57.0415842,
                26.937542
              ],
              [
                57.0419276,
                26.9365138
              ],
              [
                57.0422226,
                26.9358777
              ],
              [
                57.0425284,
                26.9354808
              ],
              [
                57.0426625,
                26.9351077
              ],
              [
                57.042641,
                26.934663
              ],
              [
                57.0424211,
                26.9341512
              ],
              [
                57.0421207,
                26.9335104
              ],
              [
                57.0415842,
                26.9327021
              ],
              [
                57.0412087,
                26.9322286
              ],
              [
                57.0410263,
                26.9318843
              ],
              [
                57.0410049,
                26.9317169
              ],
              [
                57.040801,
                26.9312817
              ],
              [
                57.0404738,
                26.9309134
              ],
              [
                57.0401305,
                26.930703
              ],
              [
                57.0397818,
                26.9305117
              ],
              [
                57.0396638,
                26.9303251
              ],
              [
                57.0396423,
                26.9301004
              ],
              [
                57.0397013,
                26.9297464
              ],
              [
                57.0398354,
                26.9293782
              ],
              [
                57.0400017,
                26.929139
              ],
              [
                57.0402807,
                26.928809
              ],
              [
                57.0405596,
                26.9284647
              ],
              [
                57.0406669,
                26.928216
              ],
              [
                57.0409298,
                26.927532
              ],
              [
                57.0410854,
                26.9266376
              ],
              [
                57.041257,
                26.9261115
              ],
              [
                57.0414233,
                26.9256906
              ],
              [
                57.0414555,
                26.9253702
              ],
              [
                57.0413858,
                26.9249971
              ],
              [
                57.0412892,
                26.9245236
              ],
              [
                57.0410049,
                26.9237153
              ],
              [
                57.0407206,
                26.9233279
              ],
              [
                57.0404041,
                26.9230696
              ],
              [
                57.0400554,
                26.9228591
              ],
              [
                57.0397282,
                26.9227013
              ],
              [
                57.0394814,
                26.9226535
              ],
              [
                57.0392722,
                26.9226869
              ],
              [
                57.0389557,
                26.9227874
              ],
              [
                57.0384782,
                26.923017
              ],
              [
                57.0382583,
                26.9231078
              ],
              [
                57.0376146,
                26.9232274
              ],
              [
                57.0371425,
                26.9232561
              ],
              [
                57.0366597,
                26.9231987
              ],
              [
                57.036193,
                26.9230839
              ],
              [
                57.0355922,
                26.9228496
              ],
              [
                57.0349216,
                26.922443
              ],
              [
                57.0346427,
                26.9221273
              ],
              [
                57.0343423,
                26.9217782
              ],
              [
                57.0339239,
                26.9214816
              ],
              [
                57.0333713,
                26.9212377
              ],
              [
                57.032631,
                26.9210463
              ],
              [
                57.0316815,
                26.9209316
              ],
              [
                57.0309305,
                26.9209268
              ],
              [
                57.0302921,
                26.9210368
              ],
              [
                57.0297182,
                26.9211755
              ],
              [
                57.0292944,
                26.9214146
              ],
              [
                57.0286238,
                26.9219599
              ],
              [
                57.0279908,
                26.9226439
              ],
              [
                57.0275456,
                26.9231318
              ],
              [
                57.0269126,
                26.9241649
              ],
              [
                57.0263064,
                26.9247962
              ],
              [
                57.0258397,
                26.9249828
              ],
              [
                57.0255071,
                26.925021
              ],
              [
                57.025035,
                26.9250115
              ],
              [
                57.0245844,
                26.9248919
              ],
              [
                57.0241928,
                26.9246527
              ],
              [
                57.023887,
                26.9244136
              ],
              [
                57.0237046,
                26.9241457
              ],
              [
                57.0236134,
                26.9238301
              ],
              [
                57.0236134,
                26.9235
              ],
              [
                57.02371,
                26.92317
              ],
              [
                57.0239353,
                26.922883
              ],
              [
                57.0243859,
                26.9226152
              ],
              [
                57.0252389,
                26.9222469
              ],
              [
                57.0263171,
                26.9217208
              ],
              [
                57.0269984,
                26.921209
              ],
              [
                57.0274115,
                26.9207881
              ],
              [
                57.0276368,
                26.9203193
              ],
              [
                57.0277065,
                26.9199606
              ],
              [
                57.0276421,
                26.9193818
              ],
              [
                57.0274597,
                26.9188509
              ],
              [
                57.0271057,
                26.9182195
              ],
              [
                57.0266712,
                26.9177842
              ],
              [
                57.0262688,
                26.9175451
              ],
              [
                57.0256734,
                26.9174255
              ],
              [
                57.0250189,
                26.9174111
              ],
              [
                57.0243591,
                26.9173442
              ],
              [
                57.0236564,
                26.9171002
              ],
              [
                57.0219988,
                26.916531
              ],
              [
                57.0199817,
                26.9160383
              ],
              [
                57.0167899,
                26.9153974
              ],
              [
                57.0146817,
                26.9147803
              ],
              [
                57.0130187,
                26.9141154
              ],
              [
                57.0097679,
                26.9124891
              ],
              [
                57.0090812,
                26.9120729
              ],
              [
                57.0079493,
                26.9116711
              ],
              [
                57.006399,
                26.9112502
              ],
              [
                57.0044571,
                26.9110014
              ],
              [
                57.0028531,
                26.9107192
              ],
              [
                57.001791,
                26.9103174
              ],
              [
                57.0011151,
                26.9099299
              ],
              [
                57.0007718,
                26.909509
              ],
              [
                57.0005947,
                26.9091311
              ],
              [
                57.0003694,
                26.9082604
              ],
              [
                57.000246,
                26.9074855
              ],
              [
                56.9997203,
                26.9065335
              ],
              [
                56.9990981,
                26.9055624
              ],
              [
                56.9985026,
                26.9048736
              ],
              [
                56.9978589,
                26.90429
              ],
              [
                56.9974995,
                26.904113
              ],
              [
                56.9966519,
                26.9037111
              ],
              [
                56.9959867,
                26.9032567
              ],
              [
                56.994887,
                26.9023716
              ],
              [
                56.9927734,
                26.9010274
              ],
              [
                56.9921994,
                26.9007451
              ],
              [
                56.9916093,
                26.9005729
              ],
              [
                56.9908905,
                26.9006016
              ],
              [
                56.9897747,
                26.9008504
              ],
              [
                56.9856548,
                26.9019028
              ],
              [
                56.9841421,
                26.9020463
              ],
              [
                56.9829941,
                26.9019411
              ],
              [
                56.9816637,
                26.9015871
              ],
              [
                56.97793,
                26.900238
              ],
              [
                56.9746899,
                26.8992047
              ],
              [
                56.9717521,
                26.8984759
              ],
              [
                56.9692182,
                26.8979226
              ],
              [
                56.9676733,
                26.8978078
              ],
              [
                56.9648623,
                26.8976929
              ],
              [
                56.9622874,
                26.8976355
              ],
              [
                56.9594121,
                26.8973485
              ],
              [
                56.9566011,
                26.8973102
              ],
              [
                56.9557891,
                26.8973916
              ],
              [
                56.9484743,
                26.8936367
              ],
              [
                56.7542328,
                26.6611203
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555152,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان قشم",
          "name:en": "Qeshm County",
          "name:ru": "Кешм",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270862",
          "wikipedia": "en:Qeshm County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.1235637,
                26.617585
              ],
              [
                55.2484746,
                26.4585216
              ],
              [
                55.2712144,
                26.4637526
              ],
              [
                55.2980502,
                26.4669757
              ],
              [
                55.3251234,
                26.4673448
              ],
              [
                55.3520564,
                26.4648545
              ],
              [
                55.3784738,
                26.4595396
              ],
              [
                55.4040073,
                26.4514737
              ],
              [
                55.4283008,
                26.4407686
              ],
              [
                55.4510157,
                26.427573
              ],
              [
                55.4718353,
                26.41207
              ],
              [
                55.4904693,
                26.3944748
              ],
              [
                55.5066579,
                26.3750319
              ],
              [
                55.5201754,
                26.3540114
              ],
              [
                55.5308334,
                26.3317057
              ],
              [
                55.5430188,
                26.2844948
              ],
              [
                55.7282468,
                26.3367641
              ],
              [
                55.9322062,
                26.4183004
              ],
              [
                55.9601773,
                26.4301178
              ],
              [
                56.1340243,
                26.5034653
              ],
              [
                56.1431226,
                26.5180653
              ],
              [
                56.1736781,
                26.5472319
              ],
              [
                56.2417336,
                26.5902874
              ],
              [
                56.2750669,
                26.5930651
              ],
              [
                56.298146,
                26.6033906
              ],
              [
                56.3278446,
                26.6166762
              ],
              [
                56.5462498,
                26.7026737
              ],
              [
                56.7595273,
                27.0602176
              ],
              [
                56.7019727,
                27.0791231
              ],
              [
                56.6269677,
                27.1037558
              ],
              [
                56.5306908,
                27.1208953
              ],
              [
                56.4724725,
                27.1312582
              ],
              [
                56.3217541,
                27.1208689
              ],
              [
                56.3056045,
                27.117166
              ],
              [
                56.2188637,
                27.0972753
              ],
              [
                56.175155,
                27.0872511
              ],
              [
                56.0622021,
                27.0426148
              ],
              [
                56.0237826,
                27.021745
              ],
              [
                55.9574883,
                26.9857244
              ],
              [
                55.7598118,
                26.9623899
              ],
              [
                55.7487484,
                26.9630821
              ],
              [
                55.7008696,
                26.9474466
              ],
              [
                55.634422,
                26.9257435
              ],
              [
                55.6248407,
                26.9109964
              ],
              [
                55.5767437,
                26.8369383
              ],
              [
                55.5607795,
                26.799328
              ],
              [
                55.5076112,
                26.7523565
              ],
              [
                55.4867932,
                26.7339596
              ],
              [
                55.3570172,
                26.7238406
              ],
              [
                55.2764707,
                26.7059041
              ],
              [
                55.2344506,
                26.6965457
              ],
              [
                55.1235637,
                26.617585
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555229,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میناب",
          "name:en": "Minab County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1270948",
          "wikipedia": "en:Minab County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                56.5462498,
                26.7026737
              ],
              [
                56.5500665,
                26.7041759
              ],
              [
                56.6833996,
                26.7375091
              ],
              [
                56.7333995,
                26.6930647
              ],
              [
                56.7542328,
                26.6611203
              ],
              [
                56.9484743,
                26.8936367
              ],
              [
                56.9557891,
                26.8973916
              ],
              [
                56.9566011,
                26.8973102
              ],
              [
                56.9594121,
                26.8973485
              ],
              [
                56.9622874,
                26.8976355
              ],
              [
                56.9648623,
                26.8976929
              ],
              [
                56.9676733,
                26.8978078
              ],
              [
                56.9692182,
                26.8979226
              ],
              [
                56.9717521,
                26.8984759
              ],
              [
                56.9746899,
                26.8992047
              ],
              [
                56.97793,
                26.900238
              ],
              [
                56.9816637,
                26.9015871
              ],
              [
                56.9829941,
                26.9019411
              ],
              [
                56.9841421,
                26.9020463
              ],
              [
                56.9856548,
                26.9019028
              ],
              [
                56.9897747,
                26.9008504
              ],
              [
                56.9908905,
                26.9006016
              ],
              [
                56.9916093,
                26.9005729
              ],
              [
                56.9921994,
                26.9007451
              ],
              [
                56.9927734,
                26.9010274
              ],
              [
                56.994887,
                26.9023716
              ],
              [
                56.9959867,
                26.9032567
              ],
              [
                56.9966519,
                26.9037111
              ],
              [
                56.9974995,
                26.904113
              ],
              [
                56.9978589,
                26.90429
              ],
              [
                56.9985026,
                26.9048736
              ],
              [
                56.9990981,
                26.9055624
              ],
              [
                56.9997203,
                26.9065335
              ],
              [
                57.000246,
                26.9074855
              ],
              [
                57.0003694,
                26.9082604
              ],
              [
                57.0005947,
                26.9091311
              ],
              [
                57.0007718,
                26.909509
              ],
              [
                57.0011151,
                26.9099299
              ],
              [
                57.001791,
                26.9103174
              ],
              [
                57.0028531,
                26.9107192
              ],
              [
                57.0044571,
                26.9110014
              ],
              [
                57.006399,
                26.9112502
              ],
              [
                57.0079493,
                26.9116711
              ],
              [
                57.0090812,
                26.9120729
              ],
              [
                57.0097679,
                26.9124891
              ],
              [
                57.0130187,
                26.9141154
              ],
              [
                57.0146817,
                26.9147803
              ],
              [
                57.0167899,
                26.9153974
              ],
              [
                57.0199817,
                26.9160383
              ],
              [
                57.0219988,
                26.916531
              ],
              [
                57.0236564,
                26.9171002
              ],
              [
                57.0243591,
                26.9173442
              ],
              [
                57.0250189,
                26.9174111
              ],
              [
                57.0256734,
                26.9174255
              ],
              [
                57.0262688,
                26.9175451
              ],
              [
                57.0266712,
                26.9177842
              ],
              [
                57.0271057,
                26.9182195
              ],
              [
                57.0274597,
                26.9188509
              ],
              [
                57.0276421,
                26.9193818
              ],
              [
                57.0277065,
                26.9199606
              ],
              [
                57.0276368,
                26.9203193
              ],
              [
                57.0274115,
                26.9207881
              ],
              [
                57.0269984,
                26.921209
              ],
              [
                57.0263171,
                26.9217208
              ],
              [
                57.0252389,
                26.9222469
              ],
              [
                57.0243859,
                26.9226152
              ],
              [
                57.0239353,
                26.922883
              ],
              [
                57.02371,
                26.92317
              ],
              [
                57.0236134,
                26.9235
              ],
              [
                57.0236134,
                26.9238301
              ],
              [
                57.0237046,
                26.9241457
              ],
              [
                57.023887,
                26.9244136
              ],
              [
                57.0241928,
                26.9246527
              ],
              [
                57.0245844,
                26.9248919
              ],
              [
                57.025035,
                26.9250115
              ],
              [
                57.0255071,
                26.925021
              ],
              [
                57.0258397,
                26.9249828
              ],
              [
                57.0263064,
                26.9247962
              ],
              [
                57.0269126,
                26.9241649
              ],
              [
                57.0275456,
                26.9231318
              ],
              [
                57.0279908,
                26.9226439
              ],
              [
                57.0286238,
                26.9219599
              ],
              [
                57.0292944,
                26.9214146
              ],
              [
                57.0297182,
                26.9211755
              ],
              [
                57.0302921,
                26.9210368
              ],
              [
                57.0309305,
                26.9209268
              ],
              [
                57.0316815,
                26.9209316
              ],
              [
                57.032631,
                26.9210463
              ],
              [
                57.0333713,
                26.9212377
              ],
              [
                57.0339239,
                26.9214816
              ],
              [
                57.0343423,
                26.9217782
              ],
              [
                57.0346427,
                26.9221273
              ],
              [
                57.0349216,
                26.922443
              ],
              [
                57.0355922,
                26.9228496
              ],
              [
                57.036193,
                26.9230839
              ],
              [
                57.0366597,
                26.9231987
              ],
              [
                57.0371425,
                26.9232561
              ],
              [
                57.0376146,
                26.9232274
              ],
              [
                57.0382583,
                26.9231078
              ],
              [
                57.0384782,
                26.923017
              ],
              [
                57.0389557,
                26.9227874
              ],
              [
                57.0392722,
                26.9226869
              ],
              [
                57.0394814,
                26.9226535
              ],
              [
                57.0397282,
                26.9227013
              ],
              [
                57.0400554,
                26.9228591
              ],
              [
                57.0404041,
                26.9230696
              ],
              [
                57.0407206,
                26.9233279
              ],
              [
                57.0410049,
                26.9237153
              ],
              [
                57.0412892,
                26.9245236
              ],
              [
                57.0413858,
                26.9249971
              ],
              [
                57.0414555,
                26.9253702
              ],
              [
                57.0414233,
                26.9256906
              ],
              [
                57.041257,
                26.9261115
              ],
              [
                57.0410854,
                26.9266376
              ],
              [
                57.0409298,
                26.927532
              ],
              [
                57.0406669,
                26.928216
              ],
              [
                57.0405596,
                26.9284647
              ],
              [
                57.0402807,
                26.928809
              ],
              [
                57.0400017,
                26.929139
              ],
              [
                57.0398354,
                26.9293782
              ],
              [
                57.0397013,
                26.9297464
              ],
              [
                57.0396423,
                26.9301004
              ],
              [
                57.0396638,
                26.9303251
              ],
              [
                57.0397818,
                26.9305117
              ],
              [
                57.0401305,
                26.930703
              ],
              [
                57.0404738,
                26.9309134
              ],
              [
                57.040801,
                26.9312817
              ],
              [
                57.0410049,
                26.9317169
              ],
              [
                57.0410263,
                26.9318843
              ],
              [
                57.0412087,
                26.9322286
              ],
              [
                57.0415842,
                26.9327021
              ],
              [
                57.0421207,
                26.9335104
              ],
              [
                57.0424211,
                26.9341512
              ],
              [
                57.042641,
                26.934663
              ],
              [
                57.0426625,
                26.9351077
              ],
              [
                57.0425284,
                26.9354808
              ],
              [
                57.0422226,
                26.9358777
              ],
              [
                57.0419276,
                26.9365138
              ],
              [
                57.0415842,
                26.937542
              ],
              [
                57.0412463,
                26.9388428
              ],
              [
                57.041139,
                26.9394501
              ],
              [
                57.0411175,
                26.9399666
              ],
              [
                57.0413321,
                26.9409566
              ],
              [
                57.0415467,
                26.9419513
              ],
              [
                57.0418149,
                26.942879
              ],
              [
                57.0419168,
                26.9434959
              ],
              [
                57.0419598,
                26.9441558
              ],
              [
                57.0420939,
                26.9444428
              ],
              [
                57.0424533,
                26.9448301
              ],
              [
                57.0426142,
                26.9451792
              ],
              [
                57.0426303,
                26.9454326
              ],
              [
                57.0425123,
                26.9457626
              ],
              [
                57.0424104,
                26.9460495
              ],
              [
                57.0424211,
                26.9463938
              ],
              [
                57.0423943,
                26.9467668
              ],
              [
                57.0423835,
                26.947049
              ],
              [
                57.0424962,
                26.9473168
              ],
              [
                57.0427483,
                26.9475319
              ],
              [
                57.0434403,
                26.9477997
              ],
              [
                57.044422,
                26.948101
              ],
              [
                57.0451677,
                26.9482397
              ],
              [
                57.0455539,
                26.9483258
              ],
              [
                57.0459992,
                26.9483401
              ],
              [
                57.0465088,
                26.9482923
              ],
              [
                57.0470291,
                26.9480484
              ],
              [
                57.0474583,
                26.9476419
              ],
              [
                57.0478123,
                26.9471255
              ],
              [
                57.047925,
                26.946719
              ],
              [
                57.0481288,
                26.9463173
              ],
              [
                57.0484132,
                26.9459252
              ],
              [
                57.0488208,
                26.9455713
              ],
              [
                57.0502102,
                26.9446532
              ],
              [
                57.0509559,
                26.9441654
              ],
              [
                57.0515513,
                26.9438402
              ],
              [
                57.0527261,
                26.9433811
              ],
              [
                57.0535952,
                26.9431468
              ],
              [
                57.0542657,
                26.9429555
              ],
              [
                57.0550919,
                26.9429125
              ],
              [
                57.0560896,
                26.9428886
              ],
              [
                57.0565993,
                26.9429555
              ],
              [
                57.0569587,
                26.9431086
              ],
              [
                57.0572752,
                26.9433668
              ],
              [
                57.0577151,
                26.943888
              ],
              [
                57.0579296,
                26.9444045
              ],
              [
                57.0580637,
                26.9449497
              ],
              [
                57.0580637,
                26.9454613
              ],
              [
                57.0579511,
                26.9458248
              ],
              [
                57.0579404,
                26.9460878
              ],
              [
                57.0580155,
                26.9463317
              ],
              [
                57.0582086,
                26.9465803
              ],
              [
                57.0582837,
                26.9467764
              ],
              [
                57.058273,
                26.9470155
              ],
              [
                57.0581496,
                26.9474459
              ],
              [
                57.0580101,
                26.9477232
              ],
              [
                57.0576131,
                26.9481966
              ],
              [
                57.0572537,
                26.9485505
              ],
              [
                57.0566904,
                26.9489044
              ],
              [
                57.0562935,
                26.9491004
              ],
              [
                57.0554352,
                26.9493921
              ],
              [
                57.0548236,
                26.9496264
              ],
              [
                57.0531285,
                26.9505159
              ],
              [
                57.0525652,
                26.9508219
              ],
              [
                57.0523077,
                26.9511375
              ],
              [
                57.0520073,
                26.9517017
              ],
              [
                57.0517445,
                26.9523855
              ],
              [
                57.0515031,
                26.9528876
              ],
              [
                57.0514387,
                26.9532415
              ],
              [
                57.0514065,
                26.9535666
              ],
              [
                57.0514923,
                26.9539061
              ],
              [
                57.0516318,
                26.9542313
              ],
              [
                57.0518625,
                26.9545995
              ],
              [
                57.0526886,
                26.9553645
              ],
              [
                57.0533913,
                26.9560005
              ],
              [
                57.0538795,
                26.9565121
              ],
              [
                57.0542926,
                26.9567847
              ],
              [
                57.0547861,
                26.9570429
              ],
              [
                57.0553815,
                26.9572867
              ],
              [
                57.0558321,
                26.9573919
              ],
              [
                57.0561701,
                26.9573776
              ],
              [
                57.0565081,
                26.9571672
              ],
              [
                57.0567065,
                26.9570429
              ],
              [
                57.0570713,
                26.9570811
              ],
              [
                57.0575166,
                26.9572294
              ],
              [
                57.058289,
                26.9575545
              ],
              [
                57.0595121,
                26.9579657
              ],
              [
                57.0620227,
                26.9586351
              ],
              [
                57.0641907,
                26.9595619
              ],
              [
                57.0677508,
                26.9588309
              ],
              [
                57.0683075,
                26.9585522
              ],
              [
                57.0894205,
                26.947721
              ],
              [
                57.0902539,
                26.947721
              ],
              [
                57.0902539,
                26.9474423
              ],
              [
                57.0921971,
                26.9474423
              ],
              [
                57.1066437,
                26.9416088
              ],
              [
                57.1096968,
                26.9388314
              ],
              [
                57.1096969,
                26.9385528
              ],
              [
                57.1105303,
                26.9366023
              ],
              [
                57.1108101,
                26.9363236
              ],
              [
                57.1113635,
                26.9349395
              ],
              [
                57.1113635,
                26.9346608
              ],
              [
                57.1084868,
                26.9286762
              ],
              [
                57.1087637,
                26.9267348
              ],
              [
                57.1079301,
                26.9189597
              ],
              [
                57.1076536,
                26.917845
              ],
              [
                57.107097,
                26.9153463
              ],
              [
                57.1068203,
                26.9150677
              ],
              [
                57.1073769,
                26.9103487
              ],
              [
                57.1076537,
                26.9072927
              ],
              [
                57.1079302,
                26.9022952
              ],
              [
                57.1082103,
                26.9006233
              ],
              [
                57.1084869,
                26.8936756
              ],
              [
                57.1082103,
                26.8897927
              ],
              [
                57.1079302,
                26.8892354
              ],
              [
                57.1132101,
                26.8425624
              ],
              [
                57.1140436,
                26.840621
              ],
              [
                57.1146002,
                26.8381225
              ],
              [
                57.1259864,
                26.8164456
              ],
              [
                57.1270999,
                26.8158885
              ],
              [
                57.1287352,
                26.8148534
              ],
              [
                57.135433,
                26.8106132
              ],
              [
                57.1362663,
                26.8106132
              ],
              [
                57.136543,
                26.8103346
              ],
              [
                57.1491626,
                26.7966931
              ],
              [
                57.1533292,
                26.796693
              ],
              [
                57.191734,
                26.7713615
              ],
              [
                57.2140499,
                26.7643113
              ],
              [
                57.2353047,
                26.761771
              ],
              [
                57.2408811,
                26.7604074
              ],
              [
                57.2411578,
                26.7584574
              ],
              [
                57.2419911,
                26.7545752
              ],
              [
                57.2514378,
                26.729019
              ],
              [
                57.2539375,
                26.7248496
              ],
              [
                57.2589374,
                26.7129077
              ],
              [
                57.2619907,
                26.7006784
              ],
              [
                57.2625474,
                26.6984591
              ],
              [
                57.2689373,
                26.6767868
              ],
              [
                57.2692139,
                26.6759512
              ],
              [
                57.2694939,
                26.675403
              ],
              [
                57.269494,
                26.674846
              ],
              [
                57.2703271,
                26.6731748
              ],
              [
                57.2786605,
                26.6478917
              ],
              [
                57.2814402,
                26.6428962
              ],
              [
                57.2822738,
                26.6409466
              ],
              [
                57.2825468,
                26.64012
              ],
              [
                57.2842136,
                26.6362208
              ],
              [
                57.2844938,
                26.6345587
              ],
              [
                57.2858801,
                26.6312254
              ],
              [
                57.2858801,
                26.6306684
              ],
              [
                57.2861602,
                26.6298329
              ],
              [
                57.2864403,
                26.6292849
              ],
              [
                57.2978268,
                26.5942742
              ],
              [
                57.3064397,
                26.5664971
              ],
              [
                57.3072729,
                26.5639998
              ],
              [
                57.3075464,
                26.5637213
              ],
              [
                57.3181063,
                26.5406618
              ],
              [
                57.3183864,
                26.5403833
              ],
              [
                57.3183864,
                26.5401048
              ],
              [
                57.3186594,
                26.5398263
              ],
              [
                57.3186594,
                26.5392694
              ],
              [
                57.3453258,
                26.4978778
              ],
              [
                57.3464391,
                26.4970425
              ],
              [
                57.3467192,
                26.4962071
              ],
              [
                57.3478254,
                26.4953808
              ],
              [
                57.3652571,
                26.4732656
              ],
              [
                57.3683103,
                26.4688198
              ],
              [
                57.3713635,
                26.4696461
              ],
              [
                57.3716436,
                26.4699335
              ],
              [
                57.3721971,
                26.4699335
              ],
              [
                57.3979144,
                26.4699914
              ],
              [
                57.3987546,
                26.4702699
              ],
              [
                57.4056945,
                26.4702698
              ],
              [
                57.4065279,
                26.4705483
              ],
              [
                57.4098611,
                26.4705483
              ],
              [
                57.4104212,
                26.4708267
              ],
              [
                57.4143076,
                26.4708267
              ],
              [
                57.4151413,
                26.4711052
              ],
              [
                57.4173608,
                26.4711052
              ],
              [
                57.4184745,
                26.4713835
              ],
              [
                57.4215276,
                26.4713836
              ],
              [
                57.4226409,
                26.4716621
              ],
              [
                57.433474,
                26.471662
              ],
              [
                57.4459802,
                26.4741496
              ],
              [
                57.46098,
                26.4741495
              ],
              [
                57.4618133,
                26.4744279
              ],
              [
                57.4651465,
                26.4744278
              ],
              [
                57.4668133,
                26.4747063
              ],
              [
                57.4695934,
                26.4747063
              ],
              [
                57.4707067,
                26.4749847
              ],
              [
                57.4815398,
                26.4749847
              ],
              [
                57.4959865,
                26.4760895
              ],
              [
                57.4970927,
                26.4763768
              ],
              [
                57.4990396,
                26.4763769
              ],
              [
                57.5009862,
                26.4766552
              ],
              [
                57.5154259,
                26.4766552
              ],
              [
                57.5170927,
                26.4763768
              ],
              [
                57.5379321,
                26.4763768
              ],
              [
                57.5393189,
                26.4766551
              ],
              [
                57.5476521,
                26.4766552
              ],
              [
                57.5487654,
                26.4769336
              ],
              [
                57.557652,
                26.4769335
              ],
              [
                57.5612652,
                26.477203
              ],
              [
                57.5620986,
                26.4774814
              ],
              [
                57.5645986,
                26.4774814
              ],
              [
                57.5651517,
                26.4777599
              ],
              [
                57.5679318,
                26.4777598
              ],
              [
                57.568765,
                26.4780383
              ],
              [
                57.5715452,
                26.4780382
              ],
              [
                57.5723784,
                26.4783167
              ],
              [
                57.5740452,
                26.4783167
              ],
              [
                57.5765449,
                26.4780383
              ],
              [
                57.5837649,
                26.4780382
              ],
              [
                57.5979311,
                26.4769335
              ],
              [
                57.5984846,
                26.4766551
              ],
              [
                57.6018214,
                26.4831085
              ],
              [
                57.6023745,
                26.4828301
              ],
              [
                57.6054276,
                26.4828301
              ],
              [
                57.6159876,
                26.481438
              ],
              [
                57.6165412,
                26.4811596
              ],
              [
                57.6176545,
                26.4811596
              ],
              [
                57.6325604,
                26.4945426
              ],
              [
                57.6559063,
                26.4936208
              ],
              [
                57.6643179,
                26.5002267
              ],
              [
                57.6543014,
                26.5091968
              ],
              [
                57.6540214,
                26.5100324
              ],
              [
                57.6540214,
                26.5111464
              ],
              [
                57.6526351,
                26.5125389
              ],
              [
                57.6493018,
                26.5194837
              ],
              [
                57.6484682,
                26.5205888
              ],
              [
                57.6948801,
                26.596998
              ],
              [
                57.6821772,
                26.6072266
              ],
              [
                57.6818971,
                26.6077836
              ],
              [
                57.6821772,
                26.608062
              ],
              [
                57.6821773,
                26.6097326
              ],
              [
                57.6818971,
                26.6102806
              ],
              [
                57.6821772,
                26.6119513
              ],
              [
                57.6818971,
                26.6183375
              ],
              [
                57.6816171,
                26.6194514
              ],
              [
                57.6818972,
                26.6199994
              ],
              [
                57.6821773,
                26.6250024
              ],
              [
                57.6824503,
                26.6269428
              ],
              [
                57.6841171,
                26.6363923
              ],
              [
                57.6855106,
                26.6408387
              ],
              [
                57.6857836,
                26.6422221
              ],
              [
                57.6880102,
                26.646947
              ],
              [
                57.689397,
                26.6497225
              ],
              [
                57.6935634,
                26.6577803
              ],
              [
                57.6943971,
                26.6586156
              ],
              [
                57.7085633,
                26.6795189
              ],
              [
                57.7088435,
                26.6803545
              ],
              [
                57.7091236,
                26.6820167
              ],
              [
                57.7035471,
                26.7045079
              ],
              [
                57.7038271,
                26.7056218
              ],
              [
                57.7004939,
                26.719224
              ],
              [
                57.7004939,
                26.7197811
              ],
              [
                57.6999337,
                26.7214521
              ],
              [
                57.6996603,
                26.7242283
              ],
              [
                57.6979939,
                26.7308948
              ],
              [
                57.6935473,
                26.7406161
              ],
              [
                57.6913274,
                26.7675618
              ],
              [
                57.6918805,
                26.7689544
              ],
              [
                57.6893805,
                26.7800601
              ],
              [
                57.6891004,
                26.7806173
              ],
              [
                57.6893805,
                26.7808958
              ],
              [
                57.6891005,
                26.7825581
              ],
              [
                57.6891004,
                26.7828366
              ],
              [
                57.6891005,
                26.7861792
              ],
              [
                57.6893806,
                26.7864578
              ],
              [
                57.6988272,
                26.8072862
              ],
              [
                57.6996605,
                26.8106198
              ],
              [
                57.7027137,
                26.8228406
              ],
              [
                57.7029938,
                26.8247816
              ],
              [
                57.7029938,
                26.8258958
              ],
              [
                57.7032672,
                26.8264529
              ],
              [
                57.7035472,
                26.8320063
              ],
              [
                57.7038274,
                26.8395096
              ],
              [
                57.7029938,
                26.8500685
              ],
              [
                57.7049337,
                26.8564489
              ],
              [
                57.7057673,
                26.8575632
              ],
              [
                57.7229938,
                26.8728403
              ],
              [
                57.7232667,
                26.8731189
              ],
              [
                57.7241,
                26.8731189
              ],
              [
                57.7246601,
                26.8733975
              ],
              [
                57.7246602,
                26.8736761
              ],
              [
                57.7252133,
                26.8736761
              ],
              [
                57.7254368,
                26.8739041
              ],
              [
                57.7516064,
                26.8972846
              ],
              [
                57.7577132,
                26.9022813
              ],
              [
                57.768688,
                26.9199272
              ],
              [
                57.7784727,
                26.921764
              ],
              [
                57.7856825,
                26.902477
              ],
              [
                57.8053848,
                26.894238
              ],
              [
                57.8059449,
                26.8950738
              ],
              [
                57.8081649,
                26.896458
              ],
              [
                57.8095512,
                26.8972938
              ],
              [
                57.8227614,
                26.9012524
              ],
              [
                57.8367779,
                26.9200695
              ],
              [
                57.8522735,
                26.9342066
              ],
              [
                57.8398415,
                26.9388288
              ],
              [
                57.8247564,
                26.9455638
              ],
              [
                57.8043826,
                26.9547373
              ],
              [
                57.7678296,
                26.9710379
              ],
              [
                57.7489197,
                26.9866903
              ],
              [
                57.7350361,
                27.0004818
              ],
              [
                57.7158199,
                27.0086424
              ],
              [
                57.6952125,
                27.0233273
              ],
              [
                57.6742685,
                27.0392305
              ],
              [
                57.653275,
                27.0447196
              ],
              [
                57.6271987,
                27.0484421
              ],
              [
                57.6070612,
                27.0545364
              ],
              [
                57.5798605,
                27.0612661
              ],
              [
                57.5693892,
                27.0643234
              ],
              [
                57.5582311,
                27.0672278
              ],
              [
                57.5378035,
                27.0721192
              ],
              [
                57.5153158,
                27.0886261
              ],
              [
                57.5111783,
                27.1003336
              ],
              [
                57.504501,
                27.115674
              ],
              [
                57.4992656,
                27.1205631
              ],
              [
                57.4967765,
                27.1262161
              ],
              [
                57.4952315,
                27.1318688
              ],
              [
                57.4948024,
                27.1358408
              ],
              [
                57.4929141,
                27.1465339
              ],
              [
                57.4926566,
                27.1526438
              ],
              [
                57.4918841,
                27.1605098
              ],
              [
                57.490425,
                27.1653208
              ],
              [
                57.4869442,
                27.1785271
              ],
              [
                57.4837435,
                27.1920264
              ],
              [
                57.4796104,
                27.2100605
              ],
              [
                57.4654287,
                27.2295862
              ],
              [
                57.4119645,
                27.2146166
              ],
              [
                57.4122376,
                27.2140681
              ],
              [
                57.4122377,
                27.2132319
              ],
              [
                57.4122378,
                27.2129531
              ],
              [
                57.4122379,
                27.2124046
              ],
              [
                57.4125181,
                27.2114863
              ],
              [
                57.4125182,
                27.2112897
              ],
              [
                57.4125183,
                27.2107322
              ],
              [
                57.4127985,
                27.209896
              ],
              [
                57.3588802,
                27.1654833
              ],
              [
                57.3583268,
                27.1649347
              ],
              [
                57.3572138,
                27.1638196
              ],
              [
                57.3566039,
                27.1633584
              ],
              [
                57.3561077,
                27.1629831
              ],
              [
                57.3558276,
                27.1624256
              ],
              [
                57.3547142,
                27.1613196
              ],
              [
                57.3536082,
                27.1604831
              ],
              [
                57.353048,
                27.1599255
              ],
              [
                57.3519415,
                27.159368
              ],
              [
                57.3511017,
                27.1586339
              ],
              [
                57.342614,
                27.1548153
              ],
              [
                57.3406674,
                27.1545366
              ],
              [
                57.3398342,
                27.1542579
              ],
              [
                57.3381674,
                27.1539791
              ],
              [
                57.3365009,
                27.1539791
              ],
              [
                57.3356673,
                27.1537004
              ],
              [
                57.3089789,
                27.1534076
              ],
              [
                57.2847746,
                27.1373685
              ],
              [
                57.2626303,
                27.113382
              ],
              [
                57.2579094,
                27.1126946
              ],
              [
                57.2507857,
                27.1055891
              ],
              [
                57.2386456,
                27.10237
              ],
              [
                57.2383655,
                27.1020912
              ],
              [
                57.2380889,
                27.1018126
              ],
              [
                57.2375321,
                27.1018126
              ],
              [
                57.2372556,
                27.1015338
              ],
              [
                57.236979,
                27.1009764
              ],
              [
                57.2366988,
                27.1009764
              ],
              [
                57.2364221,
                27.1006976
              ],
              [
                57.2361455,
                27.100419
              ],
              [
                57.2358655,
                27.1001402
              ],
              [
                57.2355889,
                27.0998615
              ],
              [
                57.2353088,
                27.0998616
              ],
              [
                57.2341105,
                27.0992661
              ],
              [
                57.2332273,
                27.0986163
              ],
              [
                57.2328089,
                27.0981982
              ],
              [
                57.2064357,
                27.1398374
              ],
              [
                57.1951882,
                27.1640037
              ],
              [
                57.1951863,
                27.1640075
              ],
              [
                57.1950458,
                27.1642863
              ],
              [
                57.1947692,
                27.1645649
              ],
              [
                57.1947693,
                27.1648437
              ],
              [
                57.1942126,
                27.1654013
              ],
              [
                57.1814327,
                27.1856786
              ],
              [
                57.1711562,
                27.2026294
              ],
              [
                57.1572665,
                27.2209566
              ],
              [
                57.1572666,
                27.2212353
              ],
              [
                57.1555999,
                27.222908
              ],
              [
                57.1550432,
                27.2240141
              ],
              [
                57.1756477,
                27.2351205
              ],
              [
                57.1517947,
                27.2720593
              ],
              [
                57.1355408,
                27.2974129
              ],
              [
                57.1214203,
                27.3184518
              ],
              [
                57.1026419,
                27.3469165
              ],
              [
                57.0898235,
                27.3658732
              ],
              [
                57.0743678,
                27.3892092
              ],
              [
                57.0431113,
                27.4197503
              ],
              [
                57.0296418,
                27.433311
              ],
              [
                57.0171773,
                27.4455491
              ],
              [
                56.9783746,
                27.4842432
              ],
              [
                56.9625878,
                27.4677711
              ],
              [
                56.9261613,
                27.4295178
              ],
              [
                56.9173466,
                27.4199682
              ],
              [
                56.8974971,
                27.3908978
              ],
              [
                56.8905424,
                27.3749285
              ],
              [
                56.8865557,
                27.3654685
              ],
              [
                56.8788655,
                27.343845
              ],
              [
                56.8773794,
                27.3379962
              ],
              [
                56.874879,
                27.3322242
              ],
              [
                56.8730335,
                27.3267693
              ],
              [
                56.8714469,
                27.3191109
              ],
              [
                56.8702452,
                27.3154356
              ],
              [
                56.869307,
                27.3114076
              ],
              [
                56.8679003,
                27.3060939
              ],
              [
                56.8667845,
                27.3007838
              ],
              [
                56.8642043,
                27.2939944
              ],
              [
                56.8580245,
                27.2823237
              ],
              [
                56.8521659,
                27.2735145
              ],
              [
                56.8493406,
                27.2701371
              ],
              [
                56.8472806,
                27.2669682
              ],
              [
                56.8457856,
                27.2639486
              ],
              [
                56.8435814,
                27.2595382
              ],
              [
                56.8412231,
                27.2534907
              ],
              [
                56.8383022,
                27.2430082
              ],
              [
                56.8375105,
                27.2361931
              ],
              [
                56.8370589,
                27.2321139
              ],
              [
                56.836353,
                27.2289912
              ],
              [
                56.8364198,
                27.2260036
              ],
              [
                56.8345089,
                27.2197482
              ],
              [
                56.8321366,
                27.2156251
              ],
              [
                56.8281691,
                27.2112367
              ],
              [
                56.8197058,
                27.2048929
              ],
              [
                56.8127415,
                27.1998704
              ],
              [
                56.8109352,
                27.196126
              ],
              [
                56.8100769,
                27.1922094
              ],
              [
                56.8102068,
                27.1882695
              ],
              [
                56.8089252,
                27.1846474
              ],
              [
                56.8020503,
                27.180477
              ],
              [
                56.8000986,
                27.1761644
              ],
              [
                56.800381,
                27.1727358
              ],
              [
                56.8038619,
                27.1626457
              ],
              [
                56.808045,
                27.1584722
              ],
              [
                56.792804,
                27.1446626
              ],
              [
                56.7928308,
                27.1429823
              ],
              [
                56.7927289,
                27.1421326
              ],
              [
                56.7919671,
                27.1401753
              ],
              [
                56.7917311,
                27.1393734
              ],
              [
                56.791656,
                27.1387433
              ],
              [
                56.7916882,
                27.1381417
              ],
              [
                56.7918706,
                27.1375689
              ],
              [
                56.7925036,
                27.1366522
              ],
              [
                56.7935014,
                27.135583
              ],
              [
                56.7938661,
                27.1349527
              ],
              [
                56.7940056,
                27.1342223
              ],
              [
                56.793952,
                27.1333009
              ],
              [
                56.7937052,
                27.1322984
              ],
              [
                56.7936493,
                27.1317882
              ],
              [
                56.7936194,
                27.1315154
              ],
              [
                56.793673,
                27.1307516
              ],
              [
                56.7935121,
                27.1298922
              ],
              [
                56.7931044,
                27.1292525
              ],
              [
                56.792525,
                27.1287846
              ],
              [
                56.7918813,
                27.1286319
              ],
              [
                56.7906904,
                27.1284695
              ],
              [
                56.7891347,
                27.1283262
              ],
              [
                56.7884159,
                27.1281353
              ],
              [
                56.787622,
                27.1277056
              ],
              [
                56.7869246,
                27.1270468
              ],
              [
                56.7862165,
                27.126111
              ],
              [
                56.7856693,
                27.1249747
              ],
              [
                56.7853582,
                27.1240103
              ],
              [
                56.7851651,
                27.1227307
              ],
              [
                56.7852294,
                27.1211837
              ],
              [
                56.7854762,
                27.119885
              ],
              [
                56.7855406,
                27.118806
              ],
              [
                56.785326,
                27.1178129
              ],
              [
                56.784837,
                27.116571
              ],
              [
                56.7837658,
                27.1153427
              ],
              [
                56.7827803,
                27.1149853
              ],
              [
                56.7823817,
                27.1147791
              ],
              [
                56.7815106,
                27.1144319
              ],
              [
                56.7805542,
                27.114183
              ],
              [
                56.7803631,
                27.1141332
              ],
              [
                56.7798548,
                27.1140008
              ],
              [
                56.77961,
                27.1139522
              ],
              [
                56.7791175,
                27.1138544
              ],
              [
                56.7789869,
                27.1138191
              ],
              [
                56.778915,
                27.1137997
              ],
              [
                56.7784934,
                27.1136566
              ],
              [
                56.7782542,
                27.1135819
              ],
              [
                56.7780825,
                27.1135649
              ],
              [
                56.7780483,
                27.1135615
              ],
              [
                56.7780173,
                27.1135585
              ],
              [
                56.7777762,
                27.1135167
              ],
              [
                56.7772698,
                27.1134288
              ],
              [
                56.7768339,
                27.1133246
              ],
              [
                56.7764073,
                27.1132226
              ],
              [
                56.7759567,
                27.1131149
              ],
              [
                56.775237,
                27.1129618
              ],
              [
                56.7742564,
                27.1127532
              ],
              [
                56.7741684,
                27.1127346
              ],
              [
                56.7730358,
                27.1119686
              ],
              [
                56.7595273,
                27.0602176
              ],
              [
                56.5462498,
                26.7026737
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555261,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان پارسیان",
          "name:en": "Parsian County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q3924648",
          "wikipedia": "en:Parsian County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.482398,
                26.989407
              ],
              [
                52.6792243,
                26.8715402
              ],
              [
                52.8757597,
                26.753725
              ],
              [
                52.9477745,
                26.7105243
              ],
              [
                53.1291955,
                26.8724691
              ],
              [
                53.3110275,
                26.9468933
              ],
              [
                53.4269048,
                26.9943818
              ],
              [
                53.4274584,
                26.9955119
              ],
              [
                53.4281624,
                26.9964219
              ],
              [
                53.4469188,
                27.0042216
              ],
              [
                53.4474755,
                27.0045093
              ],
              [
                53.4624752,
                27.0045092
              ],
              [
                53.4638653,
                27.0042216
              ],
              [
                53.4658086,
                27.0042216
              ],
              [
                53.4691418,
                27.0036733
              ],
              [
                53.4710884,
                27.0036733
              ],
              [
                53.4724751,
                27.0033947
              ],
              [
                53.4755317,
                27.0033946
              ],
              [
                53.4769217,
                27.0031159
              ],
              [
                53.477475,
                27.003116
              ],
              [
                53.478865,
                27.003116
              ],
              [
                53.485525,
                26.9999663
              ],
              [
                53.4863584,
                27.0002449
              ],
              [
                53.5002481,
                27.0002449
              ],
              [
                53.5008048,
                26.9999663
              ],
              [
                53.5041381,
                26.9999662
              ],
              [
                53.513028,
                26.9991393
              ],
              [
                53.5155279,
                26.9991393
              ],
              [
                53.5234378,
                26.9973311
              ],
              [
                53.5364943,
                26.9956681
              ],
              [
                53.538161,
                26.9956681
              ],
              [
                53.5617705,
                26.9892768
              ],
              [
                53.5821169,
                26.97271
              ],
              [
                53.6073931,
                26.9638193
              ],
              [
                53.6140631,
                26.9624349
              ],
              [
                53.6154496,
                26.9621562
              ],
              [
                53.6271161,
                26.9593783
              ],
              [
                53.6315627,
                26.9579851
              ],
              [
                53.694065,
                26.9429818
              ],
              [
                53.7123981,
                26.9388198
              ],
              [
                53.7132314,
                26.9382624
              ],
              [
                53.7235113,
                26.935206
              ],
              [
                53.7343444,
                26.933534
              ],
              [
                53.7368444,
                26.933534
              ],
              [
                53.7387876,
                26.9332554
              ],
              [
                53.7415676,
                26.9332554
              ],
              [
                53.7432342,
                26.9329768
              ],
              [
                53.7504575,
                26.9329768
              ],
              [
                53.7560107,
                26.9349274
              ],
              [
                53.7587907,
                26.9379837
              ],
              [
                53.762124,
                26.9471528
              ],
              [
                53.7624007,
                26.9488159
              ],
              [
                53.7626806,
                26.9499305
              ],
              [
                53.7668473,
                26.9668757
              ],
              [
                53.7767025,
                26.9887834
              ],
              [
                53.8037766,
                27.005578
              ],
              [
                53.8190564,
                27.0114126
              ],
              [
                53.821833,
                27.0130757
              ],
              [
                53.8221096,
                27.0139118
              ],
              [
                53.8218329,
                27.0147479
              ],
              [
                53.8215563,
                27.0150267
              ],
              [
                53.8215563,
                27.0153054
              ],
              [
                53.8201664,
                27.0194679
              ],
              [
                53.8198897,
                27.0203039
              ],
              [
                53.8196096,
                27.0219671
              ],
              [
                53.819333,
                27.0239091
              ],
              [
                53.8190563,
                27.0261297
              ],
              [
                53.8187763,
                27.0294651
              ],
              [
                53.8184998,
                27.0328006
              ],
              [
                53.8274928,
                27.0570068
              ],
              [
                53.8436289,
                27.0714554
              ],
              [
                53.8102829,
                27.0685726
              ],
              [
                53.8097297,
                27.0680153
              ],
              [
                53.7515874,
                27.0687429
              ],
              [
                53.6846385,
                27.0956815
              ],
              [
                53.6832485,
                27.0959513
              ],
              [
                53.6826952,
                27.0962298
              ],
              [
                53.6776953,
                27.0981805
              ],
              [
                53.6426924,
                27.1081759
              ],
              [
                53.626026,
                27.1142885
              ],
              [
                53.6040793,
                27.1259521
              ],
              [
                53.5822431,
                27.1380976
              ],
              [
                53.5816865,
                27.1389245
              ],
              [
                53.5816864,
                27.1392032
              ],
              [
                53.5814098,
                27.1394821
              ],
              [
                53.5811326,
                27.1397596
              ],
              [
                53.5809927,
                27.1398997
              ],
              [
                53.537494,
                27.0918149
              ],
              [
                53.5372174,
                27.0920938
              ],
              [
                53.5369373,
                27.0918148
              ],
              [
                53.5122709,
                27.1055345
              ],
              [
                53.5117143,
                27.1055345
              ],
              [
                53.511161,
                27.1049861
              ],
              [
                53.5089376,
                27.1041411
              ],
              [
                53.5081043,
                27.103314
              ],
              [
                53.5072711,
                27.103314
              ],
              [
                53.5069944,
                27.1030353
              ],
              [
                53.506161,
                27.1030353
              ],
              [
                53.5056044,
                27.1027566
              ],
              [
                53.5044944,
                27.1027566
              ],
              [
                53.5014378,
                27.1027566
              ],
              [
                53.4964379,
                27.1027566
              ],
              [
                53.4844914,
                27.1046984
              ],
              [
                53.483658,
                27.1046984
              ],
              [
                53.4831047,
                27.1049861
              ],
              [
                53.4819913,
                27.1049861
              ],
              [
                53.4811581,
                27.1052558
              ],
              [
                53.4797681,
                27.1052558
              ],
              [
                53.4789347,
                27.1055345
              ],
              [
                53.4775482,
                27.1055345
              ],
              [
                53.4753249,
                27.1060919
              ],
              [
                53.4736582,
                27.1060919
              ],
              [
                53.4496989,
                27.1061732
              ],
              [
                53.4480288,
                27.1061732
              ],
              [
                53.4468315,
                27.1064139
              ],
              [
                53.4466515,
                27.1064513
              ],
              [
                53.4466228,
                27.1064573
              ],
              [
                53.4464976,
                27.1064833
              ],
              [
                53.415527,
                27.1065061
              ],
              [
                53.4105294,
                27.11395
              ],
              [
                53.4096961,
                27.1139499
              ],
              [
                53.4103772,
                27.1245357
              ],
              [
                53.3843865,
                27.1308377
              ],
              [
                53.3752499,
                27.1472876
              ],
              [
                53.3744167,
                27.1481148
              ],
              [
                53.3627502,
                27.1708983
              ],
              [
                53.3569169,
                27.1864535
              ],
              [
                53.3546936,
                27.1903469
              ],
              [
                53.3541369,
                27.1906166
              ],
              [
                53.3538603,
                27.1908954
              ],
              [
                53.3535802,
                27.1911741
              ],
              [
                53.353027,
                27.1911741
              ],
              [
                53.3527469,
                27.1914529
              ],
              [
                53.3519136,
                27.1914528
              ],
              [
                53.3513603,
                27.1917315
              ],
              [
                53.3502469,
                27.1917316
              ],
              [
                53.3499703,
                27.1920103
              ],
              [
                53.346267,
                27.1986785
              ],
              [
                53.3376371,
                27.2078424
              ],
              [
                53.3362504,
                27.2081122
              ],
              [
                53.308067,
                27.2225785
              ],
              [
                53.2765015,
                27.2320813
              ],
              [
                53.2703917,
                27.2348596
              ],
              [
                53.2692817,
                27.2356958
              ],
              [
                53.2296889,
                27.2397845
              ],
              [
                53.2020665,
                27.2571377
              ],
              [
                53.1822076,
                27.2618262
              ],
              [
                53.1723295,
                27.2648688
              ],
              [
                53.1688986,
                27.2662566
              ],
              [
                53.1542191,
                27.2666585
              ],
              [
                53.1434717,
                27.2771015
              ],
              [
                53.1377792,
                27.2774415
              ],
              [
                53.134122,
                27.2781929
              ],
              [
                53.1128706,
                27.2837146
              ],
              [
                53.1088982,
                27.2850877
              ],
              [
                53.0835353,
                27.2984124
              ],
              [
                53.0732345,
                27.3039859
              ],
              [
                53.0571841,
                27.3064265
              ],
              [
                53.0435371,
                27.3106211
              ],
              [
                53.0393314,
                27.3144342
              ],
              [
                53.0373722,
                27.3150031
              ],
              [
                53.0186482,
                27.3243704
              ],
              [
                53.0161142,
                27.3308671
              ],
              [
                53.0141884,
                27.3353133
              ],
              [
                53.0124866,
                27.3362573
              ],
              [
                53.0048275,
                27.3403406
              ],
              [
                52.9991626,
                27.343295
              ],
              [
                52.9884767,
                27.3476597
              ],
              [
                52.9762941,
                27.352272
              ],
              [
                52.9763834,
                27.3526672
              ],
              [
                52.9607105,
                27.3580848
              ],
              [
                52.926642,
                27.3693946
              ],
              [
                52.9184983,
                27.3722457
              ],
              [
                52.9134056,
                27.3734652
              ],
              [
                52.91316,
                27.3669656
              ],
              [
                52.9120874,
                27.3412746
              ],
              [
                52.9006112,
                27.3183472
              ],
              [
                52.8679501,
                27.3066163
              ],
              [
                52.8676735,
                27.3060588
              ],
              [
                52.8420457,
                27.3173905
              ],
              [
                52.8387145,
                27.3217517
              ],
              [
                52.8325609,
                27.3224233
              ],
              [
                52.8108037,
                27.327995
              ],
              [
                52.8067069,
                27.326112
              ],
              [
                52.7921389,
                27.3117624
              ],
              [
                52.7899507,
                27.311903
              ],
              [
                52.7379214,
                27.2743065
              ],
              [
                52.482398,
                26.989407
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836539801
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          53.0351431,
          27.2082174
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 353119638
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.7745644,
          25.6436156
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836539732
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.362564,
          27.1977195
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3042219710
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.883817,
          26.5620668
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836539842
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.5854804,
          26.9519276
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5495853801
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.2690869,
          26.9503253
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4736094012
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          56.2781423,
          27.1793466
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836539870
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.8984682,
          28.3071782
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836539846
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.101798,
          26.5177389
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 26476202
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.0752814,
          27.1505605
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3640478751
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.9021823,
          26.4550218
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 836539800
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          57.1909085,
          27.4413347
        ]
      }
    }
  ]
},
"همدان.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554880,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اسدآباد",
          "name:en": "Asadabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286181",
          "wikipedia": "en:Asadabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8320284,
                34.8577943
              ],
              [
                47.8256962,
                34.8567797
              ],
              [
                47.8231499,
                34.8573783
              ],
              [
                47.8092814,
                34.8562871
              ],
              [
                47.7971938,
                34.8511636
              ],
              [
                47.8016517,
                34.8427232
              ],
              [
                47.8002654,
                34.834387
              ],
              [
                47.8019318,
                34.8321766
              ],
              [
                47.8074886,
                34.8210617
              ],
              [
                47.8119316,
                34.8163433
              ],
              [
                47.8135985,
                34.8143945
              ],
              [
                47.813875,
                34.8138351
              ],
              [
                47.8488783,
                34.7649533
              ],
              [
                47.8488783,
                34.7646736
              ],
              [
                47.8491549,
                34.7630045
              ],
              [
                47.8511014,
                34.7591159
              ],
              [
                47.8513784,
                34.7585565
              ],
              [
                47.8533214,
                34.7549475
              ],
              [
                47.854155,
                34.7541175
              ],
              [
                47.8558215,
                34.7507792
              ],
              [
                47.8574883,
                34.7443914
              ],
              [
                47.8577684,
                34.7441117
              ],
              [
                47.8577684,
                34.741053
              ],
              [
                47.8574884,
                34.7407824
              ],
              [
                47.8572114,
                34.7388335
              ],
              [
                47.8574883,
                34.7382831
              ],
              [
                47.8574883,
                34.7380035
              ],
              [
                47.8574883,
                34.7377238
              ],
              [
                47.858045,
                34.7371734
              ],
              [
                47.8591548,
                34.7346742
              ],
              [
                47.8624916,
                34.7302261
              ],
              [
                47.8649917,
                34.7229991
              ],
              [
                47.8652683,
                34.7224487
              ],
              [
                47.8630449,
                34.694668
              ],
              [
                47.8638784,
                34.6913386
              ],
              [
                47.8638785,
                34.6910589
              ],
              [
                47.8644351,
                34.6880001
              ],
              [
                47.8641581,
                34.684391
              ],
              [
                47.8636016,
                34.6827218
              ],
              [
                47.854712,
                34.6718944
              ],
              [
                47.8538784,
                34.6674462
              ],
              [
                47.8536018,
                34.6613377
              ],
              [
                47.8555451,
                34.6535598
              ],
              [
                47.8569351,
                34.6510605
              ],
              [
                47.8569351,
                34.6507807
              ],
              [
                47.8572117,
                34.6505011
              ],
              [
                47.8574886,
                34.6499416
              ],
              [
                47.8577687,
                34.649671
              ],
              [
                47.8586019,
                34.6482813
              ],
              [
                47.8588785,
                34.6477219
              ],
              [
                47.865545,
                34.6332761
              ],
              [
                47.8730448,
                34.6293872
              ],
              [
                47.8802684,
                34.6279975
              ],
              [
                47.8833248,
                34.6279976
              ],
              [
                47.8838819,
                34.6282773
              ],
              [
                47.8866581,
                34.6282773
              ],
              [
                47.8908249,
                34.6291164
              ],
              [
                47.8938817,
                34.6291165
              ],
              [
                47.8944348,
                34.6288368
              ],
              [
                47.895268,
                34.6288368
              ],
              [
                47.899438,
                34.6277269
              ],
              [
                47.9013814,
                34.6271675
              ],
              [
                47.9099914,
                34.6271676
              ],
              [
                47.9122144,
                34.6268878
              ],
              [
                47.9149911,
                34.6268878
              ],
              [
                47.9166579,
                34.6266081
              ],
              [
                47.9313809,
                34.6254983
              ],
              [
                47.9319375,
                34.625778
              ],
              [
                47.9358279,
                34.625778
              ],
              [
                47.9369376,
                34.6254983
              ],
              [
                47.9386044,
                34.6254983
              ],
              [
                47.9394376,
                34.6252186
              ],
              [
                47.9424943,
                34.6252186
              ],
              [
                47.943051,
                34.6249389
              ],
              [
                47.9547173,
                34.6227191
              ],
              [
                47.9549942,
                34.6221688
              ],
              [
                47.9552708,
                34.6216093
              ],
              [
                47.968327,
                34.6077525
              ],
              [
                47.9733271,
                34.602444
              ],
              [
                47.9811074,
                34.5985551
              ],
              [
                47.9819405,
                34.5985551
              ],
              [
                47.9822171,
                34.5982753
              ],
              [
                47.9827738,
                34.5982753
              ],
              [
                47.9841637,
                34.5979956
              ],
              [
                47.9844407,
                34.597725
              ],
              [
                47.9852738,
                34.5977249
              ],
              [
                47.9861071,
                34.5971655
              ],
              [
                47.9872172,
                34.5971654
              ],
              [
                47.9874969,
                34.5968858
              ],
              [
                47.9913838,
                34.594666
              ],
              [
                47.9930502,
                34.5932764
              ],
              [
                47.9994402,
                34.5866082
              ],
              [
                48.001107,
                34.5874384
              ],
              [
                48.0133303,
                34.5893874
              ],
              [
                48.0211102,
                34.5966061
              ],
              [
                48.0219433,
                34.5966061
              ],
              [
                48.02222,
                34.5963264
              ],
              [
                48.0252767,
                34.5949458
              ],
              [
                48.0330534,
                34.5879979
              ],
              [
                48.0344432,
                34.5885573
              ],
              [
                48.0372199,
                34.5907771
              ],
              [
                48.0397199,
                34.5974453
              ],
              [
                48.0399999,
                34.6002245
              ],
              [
                48.0397199,
                34.6016051
              ],
              [
                48.038053,
                34.6077229
              ],
              [
                48.0377764,
                34.6080025
              ],
              [
                48.0422194,
                34.6232788
              ],
              [
                48.043053,
                34.6232789
              ],
              [
                48.0433332,
                34.6235586
              ],
              [
                48.044443,
                34.6235586
              ],
              [
                48.0449996,
                34.6232788
              ],
              [
                48.0458328,
                34.6232788
              ],
              [
                48.0461098,
                34.6229992
              ],
              [
                48.0466665,
                34.6229991
              ],
              [
                48.0497196,
                34.6204997
              ],
              [
                48.0516662,
                34.6180003
              ],
              [
                48.0527764,
                34.6160603
              ],
              [
                48.0681225,
                34.5954303
              ],
              [
                48.0763895,
                34.5993945
              ],
              [
                48.0772227,
                34.5999448
              ],
              [
                48.0975023,
                34.6121624
              ],
              [
                48.102779,
                34.6191103
              ],
              [
                48.1091689,
                34.6299471
              ],
              [
                48.109842,
                34.6312885
              ],
              [
                48.1100021,
                34.6316074
              ],
              [
                48.1152787,
                34.6346662
              ],
              [
                48.1158354,
                34.6346662
              ],
              [
                48.1158354,
                34.6349459
              ],
              [
                48.1166686,
                34.6349459
              ],
              [
                48.1216688,
                34.6402244
              ],
              [
                48.1227785,
                34.6407748
              ],
              [
                48.1230586,
                34.6410546
              ],
              [
                48.1311154,
                34.6441133
              ],
              [
                48.1313919,
                34.6443931
              ],
              [
                48.1322251,
                34.6443931
              ],
              [
                48.1347252,
                34.6457736
              ],
              [
                48.1430582,
                34.6485527
              ],
              [
                48.1436149,
                34.6488325
              ],
              [
                48.1444485,
                34.6488325
              ],
              [
                48.1450051,
                34.6491122
              ],
              [
                48.1466716,
                34.6491122
              ],
              [
                48.1472251,
                34.6493918
              ],
              [
                48.1494482,
                34.6493919
              ],
              [
                48.1555581,
                34.648282
              ],
              [
                48.1558382,
                34.6480024
              ],
              [
                48.1566714,
                34.6480023
              ],
              [
                48.1577815,
                34.6471633
              ],
              [
                48.1630582,
                34.6471632
              ],
              [
                48.1633383,
                34.6468835
              ],
              [
                48.1647282,
                34.6468835
              ],
              [
                48.1666715,
                34.6468835
              ],
              [
                48.1675048,
                34.6468835
              ],
              [
                48.1680614,
                34.6471633
              ],
              [
                48.1691712,
                34.6471632
              ],
              [
                48.1802813,
                34.6530011
              ],
              [
                48.1813945,
                34.6532809
              ],
              [
                48.1866712,
                34.6532808
              ],
              [
                48.1877845,
                34.6535606
              ],
              [
                48.1952843,
                34.6591097
              ],
              [
                48.2016741,
                34.6713358
              ],
              [
                48.2027843,
                34.6813331
              ],
              [
                48.2030609,
                34.6835527
              ],
              [
                48.2041741,
                34.6880009
              ],
              [
                48.2122274,
                34.6985576
              ],
              [
                48.2497301,
                34.7171714
              ],
              [
                48.2502867,
                34.7177217
              ],
              [
                48.2527868,
                34.7213397
              ],
              [
                48.2552868,
                34.7349458
              ],
              [
                48.2658432,
                34.7527289
              ],
              [
                48.2672299,
                34.7543891
              ],
              [
                48.26751,
                34.7552281
              ],
              [
                48.2677866,
                34.7557785
              ],
              [
                48.266953,
                34.7568883
              ],
              [
                48.2622299,
                34.7610565
              ],
              [
                48.2619532,
                34.761616
              ],
              [
                48.2611201,
                34.7652248
              ],
              [
                48.26112,
                34.7696729
              ],
              [
                48.2597297,
                34.7749508
              ],
              [
                48.25473,
                34.7830077
              ],
              [
                48.2494533,
                34.7852271
              ],
              [
                48.2450068,
                34.7857775
              ],
              [
                48.2447302,
                34.7860571
              ],
              [
                48.2438966,
                34.7860571
              ],
              [
                48.2405633,
                34.7880059
              ],
              [
                48.2394535,
                34.7891156
              ],
              [
                48.2352835,
                34.7921741
              ],
              [
                48.2347303,
                34.7921741
              ],
              [
                48.2344502,
                34.7924538
              ],
              [
                48.2322303,
                34.7924538
              ],
              [
                48.2316736,
                34.7927245
              ],
              [
                48.2255638,
                34.7924538
              ],
              [
                48.2180605,
                34.7902253
              ],
              [
                48.2169503,
                34.7902253
              ],
              [
                48.2152838,
                34.7893953
              ],
              [
                48.2141737,
                34.7893952
              ],
              [
                48.213617,
                34.7891156
              ],
              [
                48.2127838,
                34.7891156
              ],
              [
                48.2125072,
                34.7888359
              ],
              [
                48.2058407,
                34.7888359
              ],
              [
                48.2052837,
                34.7891156
              ],
              [
                48.2030605,
                34.7891156
              ],
              [
                48.1966706,
                34.792174
              ],
              [
                48.1961174,
                34.7927244
              ],
              [
                48.1958373,
                34.7932838
              ],
              [
                48.1955607,
                34.7935635
              ],
              [
                48.1955608,
                34.7946732
              ],
              [
                48.1952838,
                34.7952235
              ],
              [
                48.1933373,
                34.8016112
              ],
              [
                48.1930607,
                34.8018908
              ],
              [
                48.1927842,
                34.8027299
              ],
              [
                48.190004,
                34.8102271
              ],
              [
                48.1897274,
                34.8118963
              ],
              [
                48.1836174,
                34.8371756
              ],
              [
                48.1833373,
                34.8391153
              ],
              [
                48.1827837,
                34.840225
              ],
              [
                48.1825041,
                34.841064
              ],
              [
                48.1783372,
                34.8466214
              ],
              [
                48.1772274,
                34.8494001
              ],
              [
                48.1747274,
                34.8521699
              ],
              [
                48.1741707,
                34.8521698
              ],
              [
                48.1672275,
                34.8591165
              ],
              [
                48.1644474,
                34.8607855
              ],
              [
                48.1613907,
                34.8643942
              ],
              [
                48.1608376,
                34.8660632
              ],
              [
                48.1608375,
                34.8668932
              ],
              [
                48.1602809,
                34.8682825
              ],
              [
                48.1600043,
                34.8705018
              ],
              [
                48.1583375,
                34.8766184
              ],
              [
                48.1544475,
                34.8810661
              ],
              [
                48.1463907,
                34.8841153
              ],
              [
                48.1386144,
                34.8877329
              ],
              [
                48.1380577,
                34.8877329
              ],
              [
                48.135281,
                34.8907821
              ],
              [
                48.135001,
                34.8910618
              ],
              [
                48.1452809,
                34.8957891
              ],
              [
                48.1480574,
                34.898279
              ],
              [
                48.1488908,
                34.901617
              ],
              [
                48.1486142,
                34.9021762
              ],
              [
                48.1477809,
                34.9043956
              ],
              [
                48.1477809,
                34.9049549
              ],
              [
                48.1458375,
                34.9080041
              ],
              [
                48.146114,
                34.9144002
              ],
              [
                48.1475042,
                34.9232862
              ],
              [
                48.1466707,
                34.9268946
              ],
              [
                48.1466707,
                34.9313421
              ],
              [
                48.1463905,
                34.9318925
              ],
              [
                48.1466706,
                34.9341206
              ],
              [
                48.1472242,
                34.9363399
              ],
              [
                48.1477808,
                34.9430065
              ],
              [
                48.1475042,
                34.9432862
              ],
              [
                48.1469475,
                34.9460647
              ],
              [
                48.1466706,
                34.9468946
              ],
              [
                48.1397239,
                34.9549504
              ],
              [
                48.1391673,
                34.95523
              ],
              [
                48.1383341,
                34.9571695
              ],
              [
                48.1394473,
                34.9680128
              ],
              [
                48.1391673,
                34.9685631
              ],
              [
                48.138614,
                34.9685631
              ],
              [
                48.1372242,
                34.968563
              ],
              [
                48.1363906,
                34.9688426
              ],
              [
                48.1352808,
                34.9688427
              ],
              [
                48.1311143,
                34.9702319
              ],
              [
                48.1291673,
                34.9702319
              ],
              [
                48.1286143,
                34.9705115
              ],
              [
                48.1213911,
                34.9716211
              ],
              [
                48.1161108,
                34.9730104
              ],
              [
                48.1147245,
                34.9730103
              ],
              [
                48.1144445,
                34.97329
              ],
              [
                48.1116679,
                34.97329
              ],
              [
                48.1105576,
                34.9730104
              ],
              [
                48.1091678,
                34.9730104
              ],
              [
                48.1058345,
                34.9721804
              ],
              [
                48.1033345,
                34.9710617
              ],
              [
                48.0886116,
                34.9621761
              ],
              [
                48.0874978,
                34.9621761
              ],
              [
                48.0861114,
                34.9618965
              ],
              [
                48.0858314,
                34.9616168
              ],
              [
                48.0816648,
                34.9616168
              ],
              [
                48.081388,
                34.9613371
              ],
              [
                48.0799981,
                34.9613371
              ],
              [
                48.0797215,
                34.9616167
              ],
              [
                48.0744448,
                34.9616167
              ],
              [
                48.0741647,
                34.9618964
              ],
              [
                48.0730549,
                34.9618964
              ],
              [
                48.0636083,
                34.9685629
              ],
              [
                48.058055,
                34.9743994
              ],
              [
                48.058055,
                34.9749497
              ],
              [
                48.0491649,
                34.983285
              ],
              [
                48.0477751,
                34.9843945
              ],
              [
                48.045275,
                34.9855041
              ],
              [
                48.0444418,
                34.9855041
              ],
              [
                48.0441653,
                34.9857837
              ],
              [
                48.0436085,
                34.9857837
              ],
              [
                48.043052,
                34.9860633
              ],
              [
                48.040832,
                34.9860633
              ],
              [
                48.0333319,
                34.9835646
              ],
              [
                48.0327751,
                34.9835646
              ],
              [
                48.0322185,
                34.9832849
              ],
              [
                48.0180522,
                34.9782874
              ],
              [
                48.0055524,
                34.9707819
              ],
              [
                47.9999871,
                34.9612717
              ],
              [
                47.9719396,
                34.9646746
              ],
              [
                47.9572162,
                34.9702315
              ],
              [
                47.9561064,
                34.9702315
              ],
              [
                47.9558263,
                34.9705112
              ],
              [
                47.9527696,
                34.9705112
              ],
              [
                47.9227703,
                34.9518918
              ],
              [
                47.9199937,
                34.9449455
              ],
              [
                47.9197136,
                34.9430059
              ],
              [
                47.9199937,
                34.9407868
              ],
              [
                47.92138,
                34.9371694
              ],
              [
                47.9216601,
                34.9360687
              ],
              [
                47.9219367,
                34.9357891
              ],
              [
                47.9219366,
                34.9352298
              ],
              [
                47.9223534,
                34.9345351
              ],
              [
                47.9230469,
                34.9341202
              ],
              [
                47.9230468,
                34.9338405
              ],
              [
                47.9236036,
                34.9335609
              ],
              [
                47.9272133,
                34.9299524
              ],
              [
                47.9277701,
                34.9288428
              ],
              [
                47.9274935,
                34.9252343
              ],
              [
                47.9266603,
                34.9163393
              ],
              [
                47.9261037,
                34.9152297
              ],
              [
                47.9177704,
                34.8955089
              ],
              [
                47.9102705,
                34.8891127
              ],
              [
                47.9086038,
                34.8880031
              ],
              [
                47.9086037,
                34.8877324
              ],
              [
                47.9074905,
                34.8868934
              ],
              [
                47.8819341,
                34.8732888
              ],
              [
                47.863601,
                34.8580062
              ],
              [
                47.8622111,
                34.8574558
              ],
              [
                47.8586012,
                34.8557778
              ],
              [
                47.8491546,
                34.8530081
              ],
              [
                47.8480448,
                34.8530081
              ],
              [
                47.8472112,
                34.8527284
              ],
              [
                47.843878,
                34.8527284
              ],
              [
                47.8433213,
                34.8524488
              ],
              [
                47.8352648,
                34.8524487
              ],
              [
                47.8347113,
                34.852169
              ],
              [
                47.8338781,
                34.852169
              ],
              [
                47.833598,
                34.8518893
              ],
              [
                47.8320284,
                34.8577943
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554943,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بهار",
          "name:en": "Bahar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286037",
          "wikipedia": "en:Bahar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.135001,
                34.8910618
              ],
              [
                48.135281,
                34.8907821
              ],
              [
                48.1380577,
                34.8877329
              ],
              [
                48.1386144,
                34.8877329
              ],
              [
                48.1463907,
                34.8841153
              ],
              [
                48.1544475,
                34.8810661
              ],
              [
                48.1583375,
                34.8766184
              ],
              [
                48.1600043,
                34.8705018
              ],
              [
                48.1602809,
                34.8682825
              ],
              [
                48.1608375,
                34.8668932
              ],
              [
                48.1608376,
                34.8660632
              ],
              [
                48.1613907,
                34.8643942
              ],
              [
                48.1644474,
                34.8607855
              ],
              [
                48.1672275,
                34.8591165
              ],
              [
                48.1741707,
                34.8521698
              ],
              [
                48.1747274,
                34.8521699
              ],
              [
                48.1772274,
                34.8494001
              ],
              [
                48.1783372,
                34.8466214
              ],
              [
                48.1825041,
                34.841064
              ],
              [
                48.1827837,
                34.840225
              ],
              [
                48.1833373,
                34.8391153
              ],
              [
                48.1836174,
                34.8371756
              ],
              [
                48.1897274,
                34.8118963
              ],
              [
                48.190004,
                34.8102271
              ],
              [
                48.1927842,
                34.8027299
              ],
              [
                48.1930607,
                34.8018908
              ],
              [
                48.1933373,
                34.8016112
              ],
              [
                48.1952838,
                34.7952235
              ],
              [
                48.1955608,
                34.7946732
              ],
              [
                48.1955607,
                34.7935635
              ],
              [
                48.1958373,
                34.7932838
              ],
              [
                48.1961174,
                34.7927244
              ],
              [
                48.1966706,
                34.792174
              ],
              [
                48.2030605,
                34.7891156
              ],
              [
                48.2052837,
                34.7891156
              ],
              [
                48.2058407,
                34.7888359
              ],
              [
                48.2125072,
                34.7888359
              ],
              [
                48.2127838,
                34.7891156
              ],
              [
                48.213617,
                34.7891156
              ],
              [
                48.2141737,
                34.7893952
              ],
              [
                48.2152838,
                34.7893953
              ],
              [
                48.2169503,
                34.7902253
              ],
              [
                48.2180605,
                34.7902253
              ],
              [
                48.2255638,
                34.7924538
              ],
              [
                48.2316736,
                34.7927245
              ],
              [
                48.2322303,
                34.7924538
              ],
              [
                48.2344502,
                34.7924538
              ],
              [
                48.2347303,
                34.7921741
              ],
              [
                48.2352835,
                34.7921741
              ],
              [
                48.2394535,
                34.7891156
              ],
              [
                48.2405633,
                34.7880059
              ],
              [
                48.2438966,
                34.7860571
              ],
              [
                48.2447302,
                34.7860571
              ],
              [
                48.2450068,
                34.7857775
              ],
              [
                48.2494533,
                34.7852271
              ],
              [
                48.25473,
                34.7830077
              ],
              [
                48.2597297,
                34.7749508
              ],
              [
                48.26112,
                34.7696729
              ],
              [
                48.2611201,
                34.7652248
              ],
              [
                48.2619532,
                34.761616
              ],
              [
                48.2622299,
                34.7610565
              ],
              [
                48.266953,
                34.7568883
              ],
              [
                48.2677866,
                34.7557785
              ],
              [
                48.2741766,
                34.7582777
              ],
              [
                48.2761196,
                34.7582777
              ],
              [
                48.2957908,
                34.7524493
              ],
              [
                48.2959256,
                34.7521271
              ],
              [
                48.2958102,
                34.7516938
              ],
              [
                48.2966883,
                34.7501129
              ],
              [
                48.2989978,
                34.7493665
              ],
              [
                48.302364,
                34.7488906
              ],
              [
                48.3070198,
                34.7495145
              ],
              [
                48.3126216,
                34.7499335
              ],
              [
                48.315715,
                34.7512297
              ],
              [
                48.3186773,
                34.7514952
              ],
              [
                48.3282547,
                34.7543258
              ],
              [
                48.3334654,
                34.7580285
              ],
              [
                48.3372473,
                34.7597464
              ],
              [
                48.3381967,
                34.7603747
              ],
              [
                48.3383512,
                34.7603444
              ],
              [
                48.3396912,
                34.7605232
              ],
              [
                48.3417908,
                34.7606176
              ],
              [
                48.3458344,
                34.7621147
              ],
              [
                48.3487823,
                34.7625785
              ],
              [
                48.3497428,
                34.7632384
              ],
              [
                48.3503894,
                34.7642241
              ],
              [
                48.3519971,
                34.7655545
              ],
              [
                48.3527922,
                34.7658012
              ],
              [
                48.3558454,
                34.7752308
              ],
              [
                48.356402,
                34.7766202
              ],
              [
                48.361402,
                34.8066188
              ],
              [
                48.3616786,
                34.8099479
              ],
              [
                48.3639017,
                34.8143956
              ],
              [
                48.3683452,
                34.8199533
              ],
              [
                48.3686253,
                34.8205036
              ],
              [
                48.3711249,
                34.8221726
              ],
              [
                48.3714018,
                34.8227321
              ],
              [
                48.3777918,
                34.8260611
              ],
              [
                48.3827915,
                34.8280099
              ],
              [
                48.3936249,
                34.8391158
              ],
              [
                48.4044578,
                34.8557789
              ],
              [
                48.4066813,
                34.8593966
              ],
              [
                48.4069579,
                34.8602267
              ],
              [
                48.4075146,
                34.8613454
              ],
              [
                48.423024,
                34.8666477
              ],
              [
                48.4361083,
                34.8752394
              ],
              [
                48.4377223,
                34.878276
              ],
              [
                48.4392637,
                34.8810589
              ],
              [
                48.4401947,
                34.8826677
              ],
              [
                48.4414709,
                34.8833786
              ],
              [
                48.4420245,
                34.8834018
              ],
              [
                48.4516838,
                34.8860646
              ],
              [
                48.470297,
                34.9032866
              ],
              [
                48.4777967,
                34.9066155
              ],
              [
                48.4781657,
                34.9068018
              ],
              [
                48.4794636,
                34.9085641
              ],
              [
                48.4794635,
                34.9096737
              ],
              [
                48.4783004,
                34.9173837
              ],
              [
                48.4752966,
                34.9293942
              ],
              [
                48.4758502,
                34.9341214
              ],
              [
                48.4839065,
                34.9424479
              ],
              [
                48.4975197,
                34.9493942
              ],
              [
                48.4989064,
                34.9499535
              ],
              [
                48.4997396,
                34.9499535
              ],
              [
                48.5002963,
                34.9502331
              ],
              [
                48.5011299,
                34.9502331
              ],
              [
                48.5016865,
                34.9505128
              ],
              [
                48.5039096,
                34.9505128
              ],
              [
                48.5202963,
                34.9538416
              ],
              [
                48.5222428,
                34.9544009
              ],
              [
                48.523076,
                34.9544009
              ],
              [
                48.5244663,
                34.9549512
              ],
              [
                48.5255762,
                34.9549511
              ],
              [
                48.5280761,
                34.9557901
              ],
              [
                48.5291859,
                34.9557902
              ],
              [
                48.5297426,
                34.9560698
              ],
              [
                48.5319661,
                34.9560698
              ],
              [
                48.5336325,
                34.9563404
              ],
              [
                48.5352993,
                34.9563405
              ],
              [
                48.5361326,
                34.9566201
              ],
              [
                48.5369658,
                34.9566201
              ],
              [
                48.5375193,
                34.9566201
              ],
              [
                48.5397423,
                34.9566201
              ],
              [
                48.5402994,
                34.9568998
              ],
              [
                48.5416893,
                34.9568998
              ],
              [
                48.5439093,
                34.9574501
              ],
              [
                48.5455757,
                34.9574501
              ],
              [
                48.5816885,
                34.9663448
              ],
              [
                48.5825221,
                34.9663448
              ],
              [
                48.5836354,
                34.9668951
              ],
              [
                48.5850219,
                34.9668951
              ],
              [
                48.5853019,
                34.9671747
              ],
              [
                48.5864121,
                34.9671748
              ],
              [
                48.5930786,
                34.9691233
              ],
              [
                48.5947451,
                34.9699532
              ],
              [
                48.6019686,
                34.9746802
              ],
              [
                48.6316914,
                34.9896729
              ],
              [
                48.631968,
                34.9899526
              ],
              [
                48.6319679,
                34.9902323
              ],
              [
                48.6322482,
                34.9907915
              ],
              [
                48.6333579,
                34.9946795
              ],
              [
                48.6339145,
                34.9974578
              ],
              [
                48.634468,
                34.9985674
              ],
              [
                48.636138,
                35.0001731
              ],
              [
                48.6364146,
                35.005784
              ],
              [
                48.6364145,
                35.0074528
              ],
              [
                48.6364146,
                35.0107904
              ],
              [
                48.6361379,
                35.0110701
              ],
              [
                48.6355813,
                35.0163472
              ],
              [
                48.6355813,
                35.0207942
              ],
              [
                48.6350247,
                35.0230134
              ],
              [
                48.6364145,
                35.0335674
              ],
              [
                48.6414145,
                35.0535657
              ],
              [
                48.6422477,
                35.0552345
              ],
              [
                48.6469709,
                35.0591222
              ],
              [
                48.6555808,
                35.0599522
              ],
              [
                48.656414,
                35.0602317
              ],
              [
                48.6597473,
                35.0602317
              ],
              [
                48.6683608,
                35.0613413
              ],
              [
                48.6689139,
                35.0616209
              ],
              [
                48.6700272,
                35.0616209
              ],
              [
                48.6705808,
                35.0619005
              ],
              [
                48.6722471,
                35.0619005
              ],
              [
                48.6739175,
                35.0624598
              ],
              [
                48.6747508,
                35.0624598
              ],
              [
                48.6836372,
                35.0677367
              ],
              [
                48.6875272,
                35.0735727
              ],
              [
                48.6880838,
                35.0755121
              ],
              [
                48.688917,
                35.0882937
              ],
              [
                48.6886368,
                35.0885643
              ],
              [
                48.6883603,
                35.0905126
              ],
              [
                48.6858602,
                35.0969078
              ],
              [
                48.6828039,
                35.0999566
              ],
              [
                48.6733603,
                35.1027348
              ],
              [
                48.6719705,
                35.1027347
              ],
              [
                48.6714138,
                35.1030144
              ],
              [
                48.6691939,
                35.1030143
              ],
              [
                48.6686372,
                35.1027347
              ],
              [
                48.667804,
                35.1027347
              ],
              [
                48.6655805,
                35.1030143
              ],
              [
                48.6641941,
                35.1030144
              ],
              [
                48.6589139,
                35.1049536
              ],
              [
                48.6589139,
                35.1052332
              ],
              [
                48.6583608,
                35.1052332
              ],
              [
                48.6578041,
                35.1057925
              ],
              [
                48.6383576,
                35.1121786
              ],
              [
                48.6278012,
                35.1144065
              ],
              [
                48.626691,
                35.1144064
              ],
              [
                48.6264144,
                35.1146861
              ],
              [
                48.6250246,
                35.1146861
              ],
              [
                48.6247476,
                35.1149567
              ],
              [
                48.6241909,
                35.1149567
              ],
              [
                48.6236342,
                35.1152363
              ],
              [
                48.6219678,
                35.1152363
              ],
              [
                48.6216913,
                35.1155159
              ],
              [
                48.6191912,
                35.1155159
              ],
              [
                48.6158579,
                35.1157955
              ],
              [
                48.6086348,
                35.1166254
              ],
              [
                48.6050245,
                35.1171845
              ],
              [
                48.6031892,
                35.1174641
              ],
              [
                48.5978013,
                35.1182849
              ],
              [
                48.5944138,
                35.1191318
              ],
              [
                48.591968,
                35.1199537
              ],
              [
                48.5912346,
                35.1201382
              ],
              [
                48.5908205,
                35.1202423
              ],
              [
                48.5897449,
                35.1205129
              ],
              [
                48.5742576,
                35.1252444
              ],
              [
                48.5686316,
                35.1268988
              ],
              [
                48.565855,
                35.1271784
              ],
              [
                48.5577985,
                35.1271784
              ],
              [
                48.5555751,
                35.1268988
              ],
              [
                48.5549535,
                35.1266192
              ],
              [
                48.5444654,
                35.1219018
              ],
              [
                48.5427987,
                35.1207923
              ],
              [
                48.5397419,
                35.1196739
              ],
              [
                48.5258521,
                35.117464
              ],
              [
                48.5230995,
                35.1172608
              ],
              [
                48.5091539,
                35.1178904
              ],
              [
                48.5064091,
                35.1180142
              ],
              [
                48.4980726,
                35.1177345
              ],
              [
                48.4939057,
                35.1177346
              ],
              [
                48.4900194,
                35.1191236
              ],
              [
                48.4627951,
                35.1376836
              ],
              [
                48.4539065,
                35.1369016
              ],
              [
                48.4416832,
                35.1369016
              ],
              [
                48.4405699,
                35.1369016
              ],
              [
                48.4386264,
                35.1366219
              ],
              [
                48.43696,
                35.1363423
              ],
              [
                48.4241801,
                35.1316249
              ],
              [
                48.4190551,
                35.1295
              ],
              [
                48.4114037,
                35.1263483
              ],
              [
                48.4094603,
                35.1257891
              ],
              [
                48.4066805,
                35.1257891
              ],
              [
                48.4050136,
                35.1255094
              ],
              [
                48.3836238,
                35.1255094
              ],
              [
                48.3769573,
                35.125789
              ],
              [
                48.3733474,
                35.1263483
              ],
              [
                48.3647343,
                35.1263483
              ],
              [
                48.3625108,
                35.1266189
              ],
              [
                48.3547341,
                35.1285671
              ],
              [
                48.3544576,
                35.1288467
              ],
              [
                48.3530677,
                35.1288467
              ],
              [
                48.3514008,
                35.1293969
              ],
              [
                48.3477875,
                35.1302357
              ],
              [
                48.3175114,
                35.134953
              ],
              [
                48.3169548,
                35.1352326
              ],
              [
                48.3158446,
                35.1352326
              ],
              [
                48.315288,
                35.1355122
              ],
              [
                48.3141746,
                35.1355122
              ],
              [
                48.3136215,
                35.1357918
              ],
              [
                48.3122312,
                35.1357919
              ],
              [
                48.3097316,
                35.1363421
              ],
              [
                48.2969551,
                35.1418982
              ],
              [
                48.2963985,
                35.1418982
              ],
              [
                48.2961215,
                35.1421778
              ],
              [
                48.2955649,
                35.1421778
              ],
              [
                48.2952848,
                35.1424573
              ],
              [
                48.2911183,
                35.1430076
              ],
              [
                48.2897316,
                35.1430076
              ],
              [
                48.2844518,
                35.1430076
              ],
              [
                48.2838986,
                35.1432871
              ],
              [
                48.2827849,
                35.1432872
              ],
              [
                48.2822318,
                35.1435668
              ],
              [
                48.2802852,
                35.1435668
              ],
              [
                48.2794516,
                35.1438464
              ],
              [
                48.276675,
                35.1438464
              ],
              [
                48.2763953,
                35.1435667
              ],
              [
                48.2758418,
                35.1438464
              ],
              [
                48.2727851,
                35.1438464
              ],
              [
                48.2719519,
                35.1441259
              ],
              [
                48.2644521,
                35.1441259
              ],
              [
                48.2280623,
                35.1505118
              ],
              [
                48.2244488,
                35.151071
              ],
              [
                48.2138924,
                35.1546789
              ],
              [
                48.2022261,
                35.1602349
              ],
              [
                48.1969495,
                35.1610647
              ],
              [
                48.1963928,
                35.1613443
              ],
              [
                48.1947259,
                35.1613443
              ],
              [
                48.188336,
                35.1624536
              ],
              [
                48.1877829,
                35.1627333
              ],
              [
                48.1858363,
                35.1627333
              ],
              [
                48.1816694,
                35.1635721
              ],
              [
                48.1812528,
                35.1637073
              ],
              [
                48.1813929,
                35.1610646
              ],
              [
                48.1808363,
                35.1599552
              ],
              [
                48.1783363,
                35.1532897
              ],
              [
                48.1597234,
                35.1335636
              ],
              [
                48.1591699,
                35.1313448
              ],
              [
                48.15778,
                35.1288462
              ],
              [
                48.1563902,
                35.1263478
              ],
              [
                48.1525034,
                35.1180134
              ],
              [
                48.1536135,
                35.115515
              ],
              [
                48.1547234,
                35.1144055
              ],
              [
                48.15528,
                35.113296
              ],
              [
                48.1605567,
                35.1091198
              ],
              [
                48.1661135,
                35.1074601
              ],
              [
                48.1672268,
                35.1074601
              ],
              [
                48.1677798,
                35.1071805
              ],
              [
                48.1722265,
                35.1071805
              ],
              [
                48.1727799,
                35.106901
              ],
              [
                48.1794465,
                35.106901
              ],
              [
                48.1822263,
                35.1069009
              ],
              [
                48.1830599,
                35.1069009
              ],
              [
                48.1850029,
                35.1063417
              ],
              [
                48.1886163,
                35.1021745
              ],
              [
                48.1888928,
                35.101065
              ],
              [
                48.1913929,
                35.096068
              ],
              [
                48.1916694,
                35.0952381
              ],
              [
                48.1919496,
                35.0932897
              ],
              [
                48.1922262,
                35.0927395
              ],
              [
                48.1908363,
                35.0793988
              ],
              [
                48.1875031,
                35.0668968
              ],
              [
                48.1875031,
                35.0655076
              ],
              [
                48.1872265,
                35.06079
              ],
              [
                48.1863934,
                35.0588417
              ],
              [
                48.1861163,
                35.0582914
              ],
              [
                48.1855597,
                35.0560724
              ],
              [
                48.1780601,
                35.0146774
              ],
              [
                48.1772269,
                35.0116194
              ],
              [
                48.1766702,
                35.0080111
              ],
              [
                48.1758367,
                35.0021747
              ],
              [
                48.1758366,
                34.9988461
              ],
              [
                48.173337,
                34.9960678
              ],
              [
                48.1727804,
                34.9960677
              ],
              [
                48.1563906,
                34.988842
              ],
              [
                48.1513906,
                34.9816163
              ],
              [
                48.1502807,
                34.977178
              ],
              [
                48.1441674,
                34.9710619
              ],
              [
                48.1438907,
                34.9707822
              ],
              [
                48.1391673,
                34.9685631
              ],
              [
                48.1394473,
                34.9680128
              ],
              [
                48.1383341,
                34.9571695
              ],
              [
                48.1391673,
                34.95523
              ],
              [
                48.1397239,
                34.9549504
              ],
              [
                48.1466706,
                34.9468946
              ],
              [
                48.1469475,
                34.9460647
              ],
              [
                48.1475042,
                34.9432862
              ],
              [
                48.1477808,
                34.9430065
              ],
              [
                48.1472242,
                34.9363399
              ],
              [
                48.1466706,
                34.9341206
              ],
              [
                48.1463905,
                34.9318925
              ],
              [
                48.1466707,
                34.9313421
              ],
              [
                48.1466707,
                34.9268946
              ],
              [
                48.1475042,
                34.9232862
              ],
              [
                48.146114,
                34.9144002
              ],
              [
                48.1458375,
                34.9080041
              ],
              [
                48.1477809,
                34.9049549
              ],
              [
                48.1477809,
                34.9043956
              ],
              [
                48.1486142,
                34.9021762
              ],
              [
                48.1488908,
                34.901617
              ],
              [
                48.1480574,
                34.898279
              ],
              [
                48.1452809,
                34.8957891
              ],
              [
                48.135001,
                34.8910618
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554971,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تویسرکان",
          "name:en": "Tuyserkan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1285930",
          "wikipedia": "en:Tuyserkan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.0681225,
                34.5954303
              ],
              [
                48.0686095,
                34.5949459
              ],
              [
                48.0686096,
                34.5946662
              ],
              [
                48.0855561,
                34.57606
              ],
              [
                48.0863893,
                34.5743817
              ],
              [
                48.0872225,
                34.571052
              ],
              [
                48.0833326,
                34.554945
              ],
              [
                48.0849994,
                34.5502258
              ],
              [
                48.0977791,
                34.5382785
              ],
              [
                48.1008358,
                34.5307708
              ],
              [
                48.1013894,
                34.5296699
              ],
              [
                48.1013894,
                34.5257717
              ],
              [
                48.1013894,
                34.5210523
              ],
              [
                48.0988894,
                34.5104944
              ],
              [
                48.0913896,
                34.4985559
              ],
              [
                48.090556,
                34.4935566
              ],
              [
                48.0908361,
                34.492167
              ],
              [
                48.0975028,
                34.4791093
              ],
              [
                48.1025029,
                34.4732799
              ],
              [
                48.103336,
                34.4713306
              ],
              [
                48.1036127,
                34.4710509
              ],
              [
                48.1050029,
                34.4674413
              ],
              [
                48.0991696,
                34.4546632
              ],
              [
                48.0958363,
                34.4507737
              ],
              [
                48.0938894,
                34.4457744
              ],
              [
                48.0933363,
                34.4432747
              ],
              [
                48.0919465,
                34.4346656
              ],
              [
                48.0913899,
                34.4341061
              ],
              [
                48.0913899,
                34.4338263
              ],
              [
                48.0905562,
                34.4329962
              ],
              [
                48.090883,
                34.4327841
              ],
              [
                48.093613,
                34.4318861
              ],
              [
                48.1111129,
                34.4341061
              ],
              [
                48.113336,
                34.4341061
              ],
              [
                48.117226,
                34.4341062
              ],
              [
                48.1180595,
                34.4338264
              ],
              [
                48.1233358,
                34.4321569
              ],
              [
                48.1294492,
                34.4291067
              ],
              [
                48.1319493,
                34.4291068
              ],
              [
                48.1327825,
                34.4293865
              ],
              [
                48.137226,
                34.4316064
              ],
              [
                48.1375025,
                34.4318863
              ],
              [
                48.1383357,
                34.4324367
              ],
              [
                48.1425022,
                34.434386
              ],
              [
                48.1438925,
                34.434386
              ],
              [
                48.1444491,
                34.4346657
              ],
              [
                48.1477824,
                34.4346658
              ],
              [
                48.1525056,
                34.4321569
              ],
              [
                48.1530591,
                34.4313268
              ],
              [
                48.163059,
                34.4182687
              ],
              [
                48.1644489,
                34.4171678
              ],
              [
                48.1741722,
                34.4049397
              ],
              [
                48.1741721,
                34.40466
              ],
              [
                48.1747287,
                34.4043802
              ],
              [
                48.1752819,
                34.40355
              ],
              [
                48.1850051,
                34.3971607
              ],
              [
                48.1858388,
                34.3971607
              ],
              [
                48.1894522,
                34.395771
              ],
              [
                48.1905619,
                34.395771
              ],
              [
                48.1911185,
                34.3954913
              ],
              [
                48.2033419,
                34.3930005
              ],
              [
                48.2169516,
                34.3841114
              ],
              [
                48.2177848,
                34.3841114
              ],
              [
                48.2186184,
                34.3838317
              ],
              [
                48.2213981,
                34.3835519
              ],
              [
                48.2238982,
                34.3835519
              ],
              [
                48.2244513,
                34.3838317
              ],
              [
                48.2294515,
                34.3838317
              ],
              [
                48.2300081,
                34.3841114
              ],
              [
                48.2483413,
                34.3918816
              ],
              [
                48.249082,
                34.3919741
              ],
              [
                48.2494546,
                34.3921613
              ],
              [
                48.2508413,
                34.3921613
              ],
              [
                48.2527878,
                34.3927209
              ],
              [
                48.2561211,
                34.3927208
              ],
              [
                48.2638978,
                34.3899413
              ],
              [
                48.2641779,
                34.3893818
              ],
              [
                48.2650111,
                34.3891021
              ],
              [
                48.2655642,
                34.3882718
              ],
              [
                48.2663974,
                34.3877213
              ],
              [
                48.2666776,
                34.3874416
              ],
              [
                48.2672311,
                34.386882
              ],
              [
                48.2677877,
                34.3866023
              ],
              [
                48.2914007,
                34.377993
              ],
              [
                48.2930672,
                34.377993
              ],
              [
                48.2939009,
                34.3777132
              ],
              [
                48.2955673,
                34.3774425
              ],
              [
                48.3064007,
                34.3788323
              ],
              [
                48.3064006,
                34.3791121
              ],
              [
                48.3069573,
                34.379112
              ],
              [
                48.3136238,
                34.3871619
              ],
              [
                48.3150137,
                34.3879922
              ],
              [
                48.3191803,
                34.3891022
              ],
              [
                48.3302901,
                34.3860519
              ],
              [
                48.331957,
                34.3852126
              ],
              [
                48.3327902,
                34.3852127
              ],
              [
                48.3330668,
                34.3849329
              ],
              [
                48.3336234,
                34.3849329
              ],
              [
                48.3344567,
                34.3849329
              ],
              [
                48.3350134,
                34.3846622
              ],
              [
                48.3369567,
                34.3846622
              ],
              [
                48.33779,
                34.3843824
              ],
              [
                48.3394568,
                34.3841117
              ],
              [
                48.3422369,
                34.3841117
              ],
              [
                48.3425135,
                34.383832
              ],
              [
                48.3436233,
                34.3838319
              ],
              [
                48.3439034,
                34.3835521
              ],
              [
                48.3447366,
                34.3835522
              ],
              [
                48.3452901,
                34.3832724
              ],
              [
                48.34668,
                34.3832724
              ],
              [
                48.3519566,
                34.3804929
              ],
              [
                48.35946,
                34.3710533
              ],
              [
                48.3664031,
                34.3635539
              ],
              [
                48.3669597,
                34.3618843
              ],
              [
                48.3675133,
                34.3607743
              ],
              [
                48.367793,
                34.3604945
              ],
              [
                48.3686266,
                34.3582744
              ],
              [
                48.3694599,
                34.3568846
              ],
              [
                48.3700129,
                34.3557747
              ],
              [
                48.3705697,
                34.3554948
              ],
              [
                48.3708466,
                34.3546646
              ],
              [
                48.3714032,
                34.3543848
              ],
              [
                48.3925162,
                34.336886
              ],
              [
                48.3927928,
                34.336886
              ],
              [
                48.394183,
                34.336886
              ],
              [
                48.4036262,
                34.3416059
              ],
              [
                48.4044594,
                34.341606
              ],
              [
                48.4130725,
                34.3441058
              ],
              [
                48.4141827,
                34.3441058
              ],
              [
                48.4147392,
                34.3443855
              ],
              [
                48.417796,
                34.3443856
              ],
              [
                48.4194625,
                34.3438261
              ],
              [
                48.4230726,
                34.3438261
              ],
              [
                48.4233492,
                34.3441058
              ],
              [
                48.4241824,
                34.3441058
              ],
              [
                48.425849,
                34.3449361
              ],
              [
                48.4283524,
                34.3466057
              ],
              [
                48.4297392,
                34.3466057
              ],
              [
                48.4300193,
                34.3468854
              ],
              [
                48.4305725,
                34.3466057
              ],
              [
                48.4314057,
                34.3466057
              ],
              [
                48.4316857,
                34.3468854
              ],
              [
                48.4327955,
                34.3468855
              ],
              [
                48.4333526,
                34.3471562
              ],
              [
                48.4339056,
                34.347436
              ],
              [
                48.4341858,
                34.3477158
              ],
              [
                48.4369624,
                34.3527154
              ],
              [
                48.4383523,
                34.3571646
              ],
              [
                48.4433523,
                34.3735533
              ],
              [
                48.4477953,
                34.3779933
              ],
              [
                48.4486286,
                34.3779933
              ],
              [
                48.4500188,
                34.3785528
              ],
              [
                48.450852,
                34.3785528
              ],
              [
                48.4511286,
                34.3788326
              ],
              [
                48.4527955,
                34.3788326
              ],
              [
                48.4533521,
                34.3791124
              ],
              [
                48.4552955,
                34.3793831
              ],
              [
                48.4594619,
                34.3791124
              ],
              [
                48.461962,
                34.3788326
              ],
              [
                48.4630753,
                34.3788326
              ],
              [
                48.4633519,
                34.3785529
              ],
              [
                48.4639085,
                34.3785529
              ],
              [
                48.4716853,
                34.3768833
              ],
              [
                48.4741849,
                34.3768834
              ],
              [
                48.4747416,
                34.3766035
              ],
              [
                48.4764084,
                34.3766036
              ],
              [
                48.4769651,
                34.3768833
              ],
              [
                48.4797417,
                34.3768833
              ],
              [
                48.4814082,
                34.3774429
              ],
              [
                48.4897415,
                34.3793832
              ],
              [
                48.4908548,
                34.3793831
              ],
              [
                48.4914083,
                34.3796629
              ],
              [
                48.4958549,
                34.3802134
              ],
              [
                48.496408,
                34.3799337
              ],
              [
                48.5005745,
                34.3799337
              ],
              [
                48.5008546,
                34.3802134
              ],
              [
                48.502798,
                34.3802134
              ],
              [
                48.5033546,
                34.3804932
              ],
              [
                48.5058547,
                34.3804932
              ],
              [
                48.5061313,
                34.380773
              ],
              [
                48.5069645,
                34.380773
              ],
              [
                48.5086314,
                34.3813234
              ],
              [
                48.5094645,
                34.3813235
              ],
              [
                48.5102978,
                34.3813234
              ],
              [
                48.522521,
                34.3852131
              ],
              [
                48.5300208,
                34.3891027
              ],
              [
                48.5500239,
                34.4193885
              ],
              [
                48.5519673,
                34.422159
              ],
              [
                48.5819701,
                34.4585536
              ],
              [
                48.5828037,
                34.4602141
              ],
              [
                48.5828037,
                34.4604938
              ],
              [
                48.5853034,
                34.4666031
              ],
              [
                48.58558,
                34.469942
              ],
              [
                48.5680802,
                34.4977177
              ],
              [
                48.5678002,
                34.4988276
              ],
              [
                48.567247,
                34.4993871
              ],
              [
                48.5636337,
                34.5060557
              ],
              [
                48.5625235,
                34.5071656
              ],
              [
                48.5622469,
                34.507716
              ],
              [
                48.5428004,
                34.5266118
              ],
              [
                48.5425238,
                34.5268915
              ],
              [
                48.5416495,
                34.5278744
              ],
              [
                48.5380772,
                34.5318906
              ],
              [
                48.5378007,
                34.5327209
              ],
              [
                48.5366874,
                34.5360596
              ],
              [
                48.5364104,
                34.53661
              ],
              [
                48.5397436,
                34.5491078
              ],
              [
                48.5389104,
                34.5507771
              ],
              [
                48.531134,
                34.5699431
              ],
              [
                48.531134,
                34.5718921
              ],
              [
                48.5314105,
                34.5735524
              ],
              [
                48.5378005,
                34.5832798
              ],
              [
                48.5380771,
                34.5846693
              ],
              [
                48.5416904,
                34.6013354
              ],
              [
                48.5414102,
                34.6016061
              ],
              [
                48.5408571,
                34.6018859
              ],
              [
                48.5400204,
                34.6018859
              ],
              [
                48.5389102,
                34.6024452
              ],
              [
                48.5350202,
                34.6074442
              ],
              [
                48.5322436,
                34.6080036
              ],
              [
                48.5297436,
                34.6080036
              ],
              [
                48.5278006,
                34.6082743
              ],
              [
                48.5232259,
                34.6110017
              ],
              [
                48.5197732,
                34.6149102
              ],
              [
                48.5178494,
                34.6179717
              ],
              [
                48.51406,
                34.6205988
              ],
              [
                48.5124932,
                34.6247079
              ],
              [
                48.5095674,
                34.6281879
              ],
              [
                48.508627,
                34.6290533
              ],
              [
                48.5075136,
                34.6302867
              ],
              [
                48.5049432,
                34.6356411
              ],
              [
                48.5033091,
                34.636912
              ],
              [
                48.4969147,
                34.6422025
              ],
              [
                48.4948352,
                34.6465588
              ],
              [
                48.4950106,
                34.6497469
              ],
              [
                48.4952161,
                34.6523165
              ],
              [
                48.495391,
                34.6539767
              ],
              [
                48.4957684,
                34.6560487
              ],
              [
                48.4958057,
                34.6572507
              ],
              [
                48.4887941,
                34.6618191
              ],
              [
                48.4870015,
                34.6634108
              ],
              [
                48.4849163,
                34.6654534
              ],
              [
                48.4831398,
                34.66651
              ],
              [
                48.4811242,
                34.6681871
              ],
              [
                48.4792662,
                34.6679278
              ],
              [
                48.4786216,
                34.6678932
              ],
              [
                48.4782772,
                34.6679168
              ],
              [
                48.4757356,
                34.672062
              ],
              [
                48.4738029,
                34.6756623
              ],
              [
                48.4734293,
                34.6765257
              ],
              [
                48.4739074,
                34.6785546
              ],
              [
                48.4714205,
                34.6835846
              ],
              [
                48.4672423,
                34.6847135
              ],
              [
                48.4629245,
                34.6885476
              ],
              [
                48.4561703,
                34.6923119
              ],
              [
                48.4505221,
                34.6926995
              ],
              [
                48.4494613,
                34.6932291
              ],
              [
                48.4486471,
                34.6942248
              ],
              [
                48.4476073,
                34.6968209
              ],
              [
                48.44679,
                34.6977536
              ],
              [
                48.4453227,
                34.6994237
              ],
              [
                48.4398428,
                34.7051703
              ],
              [
                48.4393075,
                34.7056441
              ],
              [
                48.4389011,
                34.7060356
              ],
              [
                48.438648,
                34.7062298
              ],
              [
                48.4379268,
                34.7070401
              ],
              [
                48.4337658,
                34.7117064
              ],
              [
                48.4327376,
                34.7124004
              ],
              [
                48.4304206,
                34.7133377
              ],
              [
                48.4206363,
                34.7239597
              ],
              [
                48.4146163,
                34.7319567
              ],
              [
                48.4073517,
                34.7413821
              ],
              [
                48.4053765,
                34.744396
              ],
              [
                48.3990152,
                34.7473932
              ],
              [
                48.3967297,
                34.7476574
              ],
              [
                48.3944613,
                34.7488162
              ],
              [
                48.393456,
                34.7529255
              ],
              [
                48.3934449,
                34.753945
              ],
              [
                48.3935921,
                34.755028
              ],
              [
                48.3945185,
                34.7555758
              ],
              [
                48.3901351,
                34.7570368
              ],
              [
                48.3869346,
                34.75833
              ],
              [
                48.3837763,
                34.757538
              ],
              [
                48.379824,
                34.7574864
              ],
              [
                48.3754544,
                34.7602761
              ],
              [
                48.3697258,
                34.7622285
              ],
              [
                48.3670603,
                34.7640504
              ],
              [
                48.3626599,
                34.7654134
              ],
              [
                48.3584956,
                34.7661241
              ],
              [
                48.3574033,
                34.7662979
              ],
              [
                48.35683,
                34.7663685
              ],
              [
                48.3558227,
                34.7664542
              ],
              [
                48.3538591,
                34.7659607
              ],
              [
                48.3527922,
                34.7658012
              ],
              [
                48.3519971,
                34.7655545
              ],
              [
                48.3503894,
                34.7642241
              ],
              [
                48.3497428,
                34.7632384
              ],
              [
                48.3487823,
                34.7625785
              ],
              [
                48.3458344,
                34.7621147
              ],
              [
                48.3417908,
                34.7606176
              ],
              [
                48.3396912,
                34.7605232
              ],
              [
                48.3383512,
                34.7603444
              ],
              [
                48.3381967,
                34.7603747
              ],
              [
                48.3372473,
                34.7597464
              ],
              [
                48.3334654,
                34.7580285
              ],
              [
                48.3282547,
                34.7543258
              ],
              [
                48.3186773,
                34.7514952
              ],
              [
                48.315715,
                34.7512297
              ],
              [
                48.3126216,
                34.7499335
              ],
              [
                48.3070198,
                34.7495145
              ],
              [
                48.302364,
                34.7488906
              ],
              [
                48.2989978,
                34.7493665
              ],
              [
                48.2966883,
                34.7501129
              ],
              [
                48.2958102,
                34.7516938
              ],
              [
                48.2959256,
                34.7521271
              ],
              [
                48.2957908,
                34.7524493
              ],
              [
                48.2761196,
                34.7582777
              ],
              [
                48.2741766,
                34.7582777
              ],
              [
                48.2677866,
                34.7557785
              ],
              [
                48.26751,
                34.7552281
              ],
              [
                48.2672299,
                34.7543891
              ],
              [
                48.2658432,
                34.7527289
              ],
              [
                48.2552868,
                34.7349458
              ],
              [
                48.2527868,
                34.7213397
              ],
              [
                48.2502867,
                34.7177217
              ],
              [
                48.2497301,
                34.7171714
              ],
              [
                48.2122274,
                34.6985576
              ],
              [
                48.2041741,
                34.6880009
              ],
              [
                48.2030609,
                34.6835527
              ],
              [
                48.2027843,
                34.6813331
              ],
              [
                48.2016741,
                34.6713358
              ],
              [
                48.1952843,
                34.6591097
              ],
              [
                48.1877845,
                34.6535606
              ],
              [
                48.1866712,
                34.6532808
              ],
              [
                48.1813945,
                34.6532809
              ],
              [
                48.1802813,
                34.6530011
              ],
              [
                48.1691712,
                34.6471632
              ],
              [
                48.1680614,
                34.6471633
              ],
              [
                48.1675048,
                34.6468835
              ],
              [
                48.1666715,
                34.6468835
              ],
              [
                48.1647282,
                34.6468835
              ],
              [
                48.1633383,
                34.6468835
              ],
              [
                48.1630582,
                34.6471632
              ],
              [
                48.1577815,
                34.6471633
              ],
              [
                48.1566714,
                34.6480023
              ],
              [
                48.1558382,
                34.6480024
              ],
              [
                48.1555581,
                34.648282
              ],
              [
                48.1494482,
                34.6493919
              ],
              [
                48.1472251,
                34.6493918
              ],
              [
                48.1466716,
                34.6491122
              ],
              [
                48.1450051,
                34.6491122
              ],
              [
                48.1444485,
                34.6488325
              ],
              [
                48.1436149,
                34.6488325
              ],
              [
                48.1430582,
                34.6485527
              ],
              [
                48.1347252,
                34.6457736
              ],
              [
                48.1322251,
                34.6443931
              ],
              [
                48.1313919,
                34.6443931
              ],
              [
                48.1311154,
                34.6441133
              ],
              [
                48.1230586,
                34.6410546
              ],
              [
                48.1227785,
                34.6407748
              ],
              [
                48.1216688,
                34.6402244
              ],
              [
                48.1166686,
                34.6349459
              ],
              [
                48.1158354,
                34.6349459
              ],
              [
                48.1158354,
                34.6346662
              ],
              [
                48.1152787,
                34.6346662
              ],
              [
                48.1100021,
                34.6316074
              ],
              [
                48.109842,
                34.6312885
              ],
              [
                48.1091689,
                34.6299471
              ],
              [
                48.102779,
                34.6191103
              ],
              [
                48.0975023,
                34.6121624
              ],
              [
                48.0772227,
                34.5999448
              ],
              [
                48.0763895,
                34.5993945
              ],
              [
                48.0681225,
                34.5954303
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555040,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان رزن",
          "name:en": "Razan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286057",
          "wikipedia": "en:Razan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.5789105,
                35.4380237
              ],
              [
                48.5797441,
                35.4374646
              ],
              [
                48.5803008,
                35.4371851
              ],
              [
                48.5853005,
                35.428853
              ],
              [
                48.5969672,
                35.4232982
              ],
              [
                48.5978004,
                35.4232982
              ],
              [
                48.6072436,
                35.418573
              ],
              [
                48.6116902,
                35.4135773
              ],
              [
                48.613357,
                35.4102408
              ],
              [
                48.6216904,
                35.3924669
              ],
              [
                48.63419,
                35.3835754
              ],
              [
                48.6386369,
                35.3816365
              ],
              [
                48.6394702,
                35.3807979
              ],
              [
                48.6405799,
                35.3802387
              ],
              [
                48.6414136,
                35.3794092
              ],
              [
                48.6425234,
                35.378859
              ],
              [
                48.64308,
                35.3780204
              ],
              [
                48.6439132,
                35.3777409
              ],
              [
                48.6503032,
                35.3730245
              ],
              [
                48.6533564,
                35.3699674
              ],
              [
                48.6630796,
                35.3621849
              ],
              [
                48.673083,
                35.3574595
              ],
              [
                48.6908596,
                35.340794
              ],
              [
                48.6933597,
                35.3388552
              ],
              [
                48.694473,
                35.3377459
              ],
              [
                48.6953062,
                35.3374573
              ],
              [
                48.7366959,
                35.3069033
              ],
              [
                48.7378057,
                35.3066327
              ],
              [
                48.7383622,
                35.3060737
              ],
              [
                48.7397525,
                35.305794
              ],
              [
                48.741419,
                35.3049643
              ],
              [
                48.7469723,
                35.3035755
              ],
              [
                48.7639187,
                35.2988498
              ],
              [
                48.765309,
                35.2988499
              ],
              [
                48.7655855,
                35.2985702
              ],
              [
                48.7666953,
                35.2985703
              ],
              [
                48.7675289,
                35.2982906
              ],
              [
                48.7703087,
                35.2980201
              ],
              [
                48.7908653,
                35.299409
              ],
              [
                48.791422,
                35.2996886
              ],
              [
                48.7916986,
                35.2996886
              ],
              [
                48.7925318,
                35.3002387
              ],
              [
                48.7955885,
                35.3016276
              ],
              [
                48.8272547,
                35.3216305
              ],
              [
                48.828368,
                35.3216305
              ],
              [
                48.8289212,
                35.32191
              ],
              [
                48.8303115,
                35.32191
              ],
              [
                48.830588,
                35.3221896
              ],
              [
                48.8367014,
                35.3221897
              ],
              [
                48.8389214,
                35.3219101
              ],
              [
                48.8397546,
                35.3219101
              ],
              [
                48.8405878,
                35.32191
              ],
              [
                48.8411445,
                35.32191
              ],
              [
                48.8469778,
                35.3219101
              ],
              [
                48.847811,
                35.3216306
              ],
              [
                48.8489244,
                35.3216305
              ],
              [
                48.849758,
                35.3213509
              ],
              [
                48.8528112,
                35.3210804
              ],
              [
                48.8578109,
                35.3210804
              ],
              [
                48.8583675,
                35.3208008
              ],
              [
                48.8597578,
                35.3208009
              ],
              [
                48.8623952,
                35.3198233
              ],
              [
                48.8628144,
                35.3196826
              ],
              [
                48.863091,
                35.319412
              ],
              [
                48.8947574,
                35.2994092
              ],
              [
                48.9030939,
                35.2907965
              ],
              [
                48.9047608,
                35.2885689
              ],
              [
                48.9136474,
                35.268295
              ],
              [
                48.913927,
                35.2680154
              ],
              [
                48.9183705,
                35.2513486
              ],
              [
                48.9186506,
                35.2507984
              ],
              [
                48.9183705,
                35.2499597
              ],
              [
                48.9186507,
                35.2496892
              ],
              [
                48.9183705,
                35.2466317
              ],
              [
                48.9178139,
                35.2432947
              ],
              [
                48.915594,
                35.2382892
              ],
              [
                48.8936474,
                35.2191237
              ],
              [
                48.8933709,
                35.2163547
              ],
              [
                48.8986475,
                35.2107989
              ],
              [
                48.8994808,
                35.2096805
              ],
              [
                48.9017043,
                35.2035745
              ],
              [
                48.9019808,
                35.203295
              ],
              [
                48.9019809,
                35.2027358
              ],
              [
                48.9019808,
                35.2024652
              ],
              [
                48.9080943,
                35.2013558
              ],
              [
                48.9083708,
                35.2010762
              ],
              [
                48.9144808,
                35.2010763
              ],
              [
                48.932537,
                35.2041249
              ],
              [
                48.9342038,
                35.2038542
              ],
              [
                48.935037,
                35.2035747
              ],
              [
                48.9361503,
                35.2035746
              ],
              [
                48.9367038,
                35.203295
              ],
              [
                48.9372605,
                35.203295
              ],
              [
                48.9405937,
                35.2024653
              ],
              [
                48.9550401,
                35.1991281
              ],
              [
                48.9555933,
                35.1991282
              ],
              [
                48.9558734,
                35.1988486
              ],
              [
                48.956707,
                35.1988486
              ],
              [
                48.9572637,
                35.198569
              ],
              [
                48.9580969,
                35.198569
              ],
              [
                48.9586501,
                35.1982894
              ],
              [
                48.9597633,
                35.1982894
              ],
              [
                48.9617067,
                35.1977392
              ],
              [
                48.9628169,
                35.1977392
              ],
              [
                48.9636502,
                35.1974596
              ],
              [
                48.96504,
                35.1974596
              ],
              [
                48.9672635,
                35.1969004
              ],
              [
                48.96893,
                35.1969005
              ],
              [
                48.9725401,
                35.1960706
              ],
              [
                48.9736499,
                35.1960707
              ],
              [
                48.9744832,
                35.1957911
              ],
              [
                48.9758734,
                35.195791
              ],
              [
                48.9944864,
                35.191074
              ],
              [
                48.995043,
                35.1907944
              ],
              [
                48.9986532,
                35.1902352
              ],
              [
                49.0044861,
                35.1891258
              ],
              [
                49.0055964,
                35.1891258
              ],
              [
                49.0103194,
                35.1877369
              ],
              [
                49.0114297,
                35.1877369
              ],
              [
                49.0142094,
                35.1869071
              ],
              [
                49.0153196,
                35.1869071
              ],
              [
                49.0217095,
                35.1849589
              ],
              [
                49.0228194,
                35.1849589
              ],
              [
                49.023376,
                35.1846793
              ],
              [
                49.0336559,
                35.1846794
              ],
              [
                49.0344891,
                35.1849589
              ],
              [
                49.0367091,
                35.184959
              ],
              [
                49.0375427,
                35.1852385
              ],
              [
                49.0386561,
                35.1852386
              ],
              [
                49.0400423,
                35.1857978
              ],
              [
                49.0411561,
                35.1857977
              ],
              [
                49.0519891,
                35.1916334
              ],
              [
                49.0525458,
                35.1919039
              ],
              [
                49.0528223,
                35.1921835
              ],
              [
                49.0539325,
                35.1932928
              ],
              [
                49.0700453,
                35.2224611
              ],
              [
                49.0700453,
                35.2227407
              ],
              [
                49.0680987,
                35.2221815
              ],
              [
                49.0672655,
                35.2221814
              ],
              [
                49.0658788,
                35.2216223
              ],
              [
                49.0644889,
                35.2216223
              ],
              [
                49.0628221,
                35.2210721
              ],
              [
                49.0619888,
                35.2210721
              ],
              [
                49.0617123,
                35.2207925
              ],
              [
                49.0603224,
                35.2207925
              ],
              [
                49.0580989,
                35.2205129
              ],
              [
                49.0539325,
                35.2205129
              ],
              [
                49.0533789,
                35.2207925
              ],
              [
                49.0497656,
                35.2207925
              ],
              [
                49.0489323,
                35.2210721
              ],
              [
                49.0464322,
                35.2210721
              ],
              [
                49.030319,
                35.2235703
              ],
              [
                49.0269857,
                35.2244091
              ],
              [
                49.0258759,
                35.2244091
              ],
              [
                49.0175426,
                35.2274575
              ],
              [
                49.0161526,
                35.2285759
              ],
              [
                49.0144862,
                35.2310741
              ],
              [
                49.0142092,
                35.2313537
              ],
              [
                49.0155995,
                35.2366298
              ],
              [
                49.0164327,
                35.2377392
              ],
              [
                49.0183762,
                35.2410762
              ],
              [
                49.0294856,
                35.2546858
              ],
              [
                49.030876,
                35.2569045
              ],
              [
                49.0322658,
                35.269125
              ],
              [
                49.0319892,
                35.2694045
              ],
              [
                49.0317092,
                35.2716321
              ],
              [
                49.0314325,
                35.2724618
              ],
              [
                49.0311525,
                35.2732915
              ],
              [
                49.0308759,
                35.27496
              ],
              [
                49.0311525,
                35.2785765
              ],
              [
                49.0319893,
                35.2810747
              ],
              [
                49.0355991,
                35.2882986
              ],
              [
                49.0411558,
                35.2963522
              ],
              [
                49.0517121,
                35.3188533
              ],
              [
                49.0517122,
                35.3196829
              ],
              [
                49.0525454,
                35.3213514
              ],
              [
                49.0530985,
                35.3235699
              ],
              [
                49.0536552,
                35.3263475
              ],
              [
                49.0544887,
                35.3324619
              ],
              [
                49.0547652,
                35.3338507
              ],
              [
                49.0619884,
                35.3457998
              ],
              [
                49.068655,
                35.3558009
              ],
              [
                49.0692116,
                35.3560805
              ],
              [
                49.0728215,
                35.3630244
              ],
              [
                49.0739352,
                35.3649632
              ],
              [
                49.081988,
                35.3780213
              ],
              [
                49.0853212,
                35.3919088
              ],
              [
                49.0847682,
                35.3932974
              ],
              [
                49.0844631,
                35.3950151
              ],
              [
                49.0839349,
                35.396634
              ],
              [
                49.079768,
                35.4055165
              ],
              [
                49.0781016,
                35.4080234
              ],
              [
                49.0781016,
                35.4083029
              ],
              [
                49.0767117,
                35.4110803
              ],
              [
                49.0764347,
                35.4119099
              ],
              [
                49.0769882,
                35.418574
              ],
              [
                49.0947678,
                35.4410815
              ],
              [
                49.1139342,
                35.4558069
              ],
              [
                49.1172675,
                35.4580251
              ],
              [
                49.1361573,
                35.4744094
              ],
              [
                49.1606034,
                35.4930205
              ],
              [
                49.1608804,
                35.4933001
              ],
              [
                49.1603269,
                35.4935796
              ],
              [
                49.1600468,
                35.4938591
              ],
              [
                49.152547,
                35.5019112
              ],
              [
                49.1522704,
                35.5030293
              ],
              [
                49.1519938,
                35.5044089
              ],
              [
                49.150327,
                35.5088632
              ],
              [
                49.1453273,
                35.5138585
              ],
              [
                49.1353239,
                35.5208014
              ],
              [
                49.1347704,
                35.5219194
              ],
              [
                49.1342137,
                35.5224694
              ],
              [
                49.1325472,
                35.5296918
              ],
              [
                49.1322707,
                35.5299713
              ],
              [
                49.1325473,
                35.5308008
              ],
              [
                49.1337036,
                35.5493869
              ],
              [
                49.1298172,
                35.5582775
              ],
              [
                49.1259273,
                35.5624523
              ],
              [
                49.125094,
                35.5627228
              ],
              [
                49.1231507,
                35.5643909
              ],
              [
                49.118704,
                35.5668887
              ],
              [
                49.0922673,
                35.5874687
              ],
              [
                49.0911576,
                35.5874687
              ],
              [
                49.0842109,
                35.5997454
              ],
              [
                49.0828211,
                35.5997454
              ],
              [
                49.0825441,
                35.6000248
              ],
              [
                49.0819875,
                35.6000248
              ],
              [
                49.0814343,
                35.6003043
              ],
              [
                49.0794877,
                35.6008632
              ],
              [
                49.0783777,
                35.6008632
              ],
              [
                49.0731009,
                35.6047486
              ],
              [
                49.071711,
                35.6058575
              ],
              [
                49.0621084,
                35.6119197
              ],
              [
                49.0609149,
                35.6146335
              ],
              [
                49.0606157,
                35.6155408
              ],
              [
                49.0606774,
                35.6161077
              ],
              [
                49.0603213,
                35.6161344
              ],
              [
                49.0475413,
                35.6277993
              ],
              [
                49.0303179,
                35.6314007
              ],
              [
                49.0283749,
                35.6314008
              ],
              [
                49.0278182,
                35.6311122
              ],
              [
                49.0219849,
                35.6302828
              ],
              [
                49.0208747,
                35.6305624
              ],
              [
                49.0189317,
                35.6305624
              ],
              [
                49.0153184,
                35.6314007
              ],
              [
                49.0122617,
                35.63278
              ],
              [
                49.0092085,
                35.6358361
              ],
              [
                49.006985,
                35.6380628
              ],
              [
                48.9886517,
                35.6435836
              ],
              [
                48.9475391,
                35.66303
              ],
              [
                48.9467059,
                35.6630299
              ],
              [
                48.9464258,
                35.6633095
              ],
              [
                48.9439257,
                35.6644184
              ],
              [
                48.9330922,
                35.6699718
              ],
              [
                48.9319825,
                35.6699718
              ],
              [
                48.9311492,
                35.6703902
              ],
              [
                48.9308693,
                35.6705309
              ],
              [
                48.930036,
                35.6708103
              ],
              [
                48.8933696,
                35.6938624
              ],
              [
                48.8917031,
                35.6955302
              ],
              [
                48.8905894,
                35.6960801
              ],
              [
                48.8839229,
                35.6994157
              ],
              [
                48.8830896,
                35.6994158
              ],
              [
                48.882813,
                35.6996952
              ],
              [
                48.8741996,
                35.7010835
              ],
              [
                48.87198,
                35.7010835
              ],
              [
                48.8703132,
                35.701363
              ],
              [
                48.8678131,
                35.7013629
              ],
              [
                48.8614231,
                35.7024718
              ],
              [
                48.8594766,
                35.7024718
              ],
              [
                48.8514232,
                35.7038691
              ],
              [
                48.8439235,
                35.7052484
              ],
              [
                48.8430867,
                35.7052484
              ],
              [
                48.8425337,
                35.7055279
              ],
              [
                48.8417,
                35.7055279
              ],
              [
                48.8189203,
                35.71164
              ],
              [
                48.8016972,
                35.7213582
              ],
              [
                48.7908641,
                35.7305263
              ],
              [
                48.7797506,
                35.7335824
              ],
              [
                48.7750309,
                35.7338618
              ],
              [
                48.773084,
                35.7338618
              ],
              [
                48.7719742,
                35.7335824
              ],
              [
                48.7691976,
                35.7335824
              ],
              [
                48.7680843,
                35.733303
              ],
              [
                48.7655843,
                35.7330324
              ],
              [
                48.7628076,
                35.7330324
              ],
              [
                48.762251,
                35.732753
              ],
              [
                48.7608611,
                35.7327529
              ],
              [
                48.7605841,
                35.7324735
              ],
              [
                48.7589177,
                35.7324735
              ],
              [
                48.7583611,
                35.7321941
              ],
              [
                48.7525278,
                35.7310852
              ],
              [
                48.7486414,
                35.7294174
              ],
              [
                48.7419713,
                35.7271908
              ],
              [
                48.7369711,
                35.7244142
              ],
              [
                48.7366945,
                35.7241437
              ],
              [
                48.7363237,
                35.7239575
              ],
              [
                48.7350277,
                35.7227464
              ],
              [
                48.7350278,
                35.7224759
              ],
              [
                48.743506,
                35.7141494
              ],
              [
                48.7460613,
                35.6962608
              ],
              [
                48.7455261,
                35.6892958
              ],
              [
                48.7458613,
                35.684973
              ],
              [
                48.7466946,
                35.6846935
              ],
              [
                48.7506448,
                35.6794017
              ],
              [
                48.7517546,
                35.6788427
              ],
              [
                48.7466851,
                35.6637992
              ],
              [
                48.7458519,
                35.6543583
              ],
              [
                48.7464051,
                35.651581
              ],
              [
                48.7466851,
                35.6476856
              ],
              [
                48.7469617,
                35.6471266
              ],
              [
                48.6698229,
                35.5972334
              ],
              [
                48.669469,
                35.5971873
              ],
              [
                48.6639126,
                35.5988642
              ],
              [
                48.6505795,
                35.6008027
              ],
              [
                48.6480795,
                35.6008027
              ],
              [
                48.6472458,
                35.6010822
              ],
              [
                48.6441895,
                35.6010822
              ],
              [
                48.6433559,
                35.6013616
              ],
              [
                48.634889,
                35.594654
              ],
              [
                48.6340558,
                35.5949336
              ],
              [
                48.6318323,
                35.595204
              ],
              [
                48.6193324,
                35.593545
              ],
              [
                48.6146092,
                35.5918768
              ],
              [
                48.6126659,
                35.5918768
              ],
              [
                48.6096179,
                35.5907677
              ],
              [
                48.5933534,
                35.5694083
              ],
              [
                48.5930768,
                35.5591297
              ],
              [
                48.5928002,
                35.5566321
              ],
              [
                48.5922437,
                35.5541346
              ],
              [
                48.59141,
                35.5466328
              ],
              [
                48.5911335,
                35.5416378
              ],
              [
                48.5908534,
                35.5310793
              ],
              [
                48.5897437,
                35.5032987
              ],
              [
                48.5891871,
                35.5016396
              ],
              [
                48.5869671,
                35.4963557
              ],
              [
                48.5853003,
                35.4908013
              ],
              [
                48.5777971,
                35.4857968
              ],
              [
                48.566964,
                35.4841377
              ],
              [
                48.5639108,
                35.4841377
              ],
              [
                48.5636307,
                35.4838582
              ],
              [
                48.5625205,
                35.4838582
              ],
              [
                48.5619639,
                35.4835786
              ],
              [
                48.5605776,
                35.4835786
              ],
              [
                48.555574,
                35.4810809
              ],
              [
                48.5530743,
                35.4785832
              ],
              [
                48.5522407,
                35.4777446
              ],
              [
                48.5505743,
                35.4746877
              ],
              [
                48.5505743,
                35.4674651
              ],
              [
                48.5514075,
                35.4588536
              ],
              [
                48.5555741,
                35.4452375
              ],
              [
                48.5575209,
                35.4430193
              ],
              [
                48.5636308,
                35.4399624
              ],
              [
                48.565854,
                35.4394123
              ],
              [
                48.5741873,
                35.4396829
              ],
              [
                48.574744,
                35.4394124
              ],
              [
                48.5761307,
                35.4394124
              ],
              [
                48.5764108,
                35.4391328
              ],
              [
                48.576964,
                35.4391329
              ],
              [
                48.577244,
                35.4388533
              ],
              [
                48.5780773,
                35.4385828
              ],
              [
                48.5789105,
                35.4380237
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555129,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان فامنین",
          "name:en": "Famenin County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2415354",
          "wikipedia": "en:Famenin County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.8533684,
                35.0863457
              ],
              [
                48.8550349,
                35.0857864
              ],
              [
                48.8553119,
                35.0855159
              ],
              [
                48.8558684,
                35.0855158
              ],
              [
                48.9097611,
                35.0580132
              ],
              [
                48.9130944,
                35.0566241
              ],
              [
                48.9180945,
                35.0546757
              ],
              [
                48.9597638,
                35.0346776
              ],
              [
                48.9605974,
                35.0346775
              ],
              [
                48.960874,
                35.0343979
              ],
              [
                48.9617071,
                35.0343979
              ],
              [
                48.9644838,
                35.0335681
              ],
              [
                48.9655971,
                35.0335681
              ],
              [
                48.970317,
                35.0321789
              ],
              [
                48.9714305,
                35.0321789
              ],
              [
                48.9744836,
                35.031349
              ],
              [
                48.9758739,
                35.031349
              ],
              [
                48.9761539,
                35.0310693
              ],
              [
                48.9769871,
                35.0310694
              ],
              [
                48.9786537,
                35.0307898
              ],
              [
                48.9819869,
                35.0302304
              ],
              [
                48.9842068,
                35.0296802
              ],
              [
                48.9855971,
                35.0296803
              ],
              [
                48.9861538,
                35.0294006
              ],
              [
                48.9872635,
                35.0294006
              ],
              [
                48.9878203,
                35.029121
              ],
              [
                48.9886534,
                35.029121
              ],
              [
                48.989207,
                35.0288414
              ],
              [
                49.0005966,
                35.0263427
              ],
              [
                49.0014303,
                35.026072
              ],
              [
                49.0047636,
                35.0260721
              ],
              [
                49.0053202,
                35.0257924
              ],
              [
                49.00643,
                35.0257925
              ],
              [
                49.0069866,
                35.0255128
              ],
              [
                49.0092102,
                35.0255128
              ],
              [
                49.0097632,
                35.0252331
              ],
              [
                49.0111531,
                35.0252332
              ],
              [
                49.0117102,
                35.0249536
              ],
              [
                49.0144868,
                35.024683
              ],
              [
                49.0242097,
                35.0249535
              ],
              [
                49.0244865,
                35.0252332
              ],
              [
                49.0278199,
                35.0252332
              ],
              [
                49.0286531,
                35.0255129
              ],
              [
                49.0322664,
                35.0255128
              ],
              [
                49.0328231,
                35.0257925
              ],
              [
                49.0353232,
                35.0257924
              ],
              [
                49.0361564,
                35.0260721
              ],
              [
                49.0475429,
                35.0263427
              ],
              [
                49.0483762,
                35.0260722
              ],
              [
                49.0497661,
                35.0260721
              ],
              [
                49.0505997,
                35.0257926
              ],
              [
                49.0519895,
                35.0257926
              ],
              [
                49.0530993,
                35.0252333
              ],
              [
                49.053933,
                35.0252332
              ],
              [
                49.0561561,
                35.024683
              ],
              [
                49.0580994,
                35.024683
              ],
              [
                49.0600459,
                35.0241237
              ],
              [
                49.0614327,
                35.0241237
              ],
              [
                49.0661559,
                35.0227346
              ],
              [
                49.0692126,
                35.0219046
              ],
              [
                49.0697692,
                35.0219046
              ],
              [
                49.0922689,
                35.0152385
              ],
              [
                49.0928256,
                35.0152385
              ],
              [
                49.0931025,
                35.0149589
              ],
              [
                49.0936592,
                35.0149589
              ],
              [
                49.0972691,
                35.0138404
              ],
              [
                49.0989355,
                35.0127398
              ],
              [
                49.0997691,
                35.0127398
              ],
              [
                49.1003258,
                35.0121806
              ],
              [
                49.1008789,
                35.0121806
              ],
              [
                49.1042121,
                35.0105117
              ],
              [
                49.1050454,
                35.0105118
              ],
              [
                49.1125487,
                35.0074537
              ],
              [
                49.1389387,
                34.9996779
              ],
              [
                49.1472717,
                34.9766207
              ],
              [
                49.1481053,
                34.9741219
              ],
              [
                49.1647717,
                34.9446774
              ],
              [
                49.1758849,
                34.9302345
              ],
              [
                49.175885,
                34.9296753
              ],
              [
                49.1761616,
                34.9291159
              ],
              [
                49.1750518,
                34.9119033
              ],
              [
                49.1750519,
                34.9010596
              ],
              [
                49.1808852,
                34.8902339
              ],
              [
                49.1839415,
                34.8874553
              ],
              [
                49.1858848,
                34.8832874
              ],
              [
                49.1861615,
                34.8830077
              ],
              [
                49.1864415,
                34.8827281
              ],
              [
                49.1875518,
                34.8793991
              ],
              [
                49.1864416,
                34.8738418
              ],
              [
                49.1789383,
                34.8657855
              ],
              [
                49.1808852,
                34.8646759
              ],
              [
                49.1917183,
                34.8621769
              ],
              [
                49.1928281,
                34.8621769
              ],
              [
                49.1956083,
                34.8613468
              ],
              [
                49.1964414,
                34.8613469
              ],
              [
                49.2017181,
                34.8585683
              ],
              [
                49.2025513,
                34.8577292
              ],
              [
                49.2042181,
                34.8530109
              ],
              [
                49.2044983,
                34.8513419
              ],
              [
                49.2050514,
                34.8482834
              ],
              [
                49.2050514,
                34.8480038
              ],
              [
                49.205608,
                34.8471738
              ],
              [
                49.2058846,
                34.8460641
              ],
              [
                49.2067182,
                34.8438357
              ],
              [
                49.209498,
                34.8421757
              ],
              [
                49.2117179,
                34.8421758
              ],
              [
                49.2183844,
                34.8460641
              ],
              [
                49.2186646,
                34.8466235
              ],
              [
                49.2256077,
                34.8505119
              ],
              [
                49.229498,
                34.8530109
              ],
              [
                49.2333879,
                34.8613469
              ],
              [
                49.2333879,
                34.8616266
              ],
              [
                49.2347742,
                34.8638369
              ],
              [
                49.2531109,
                34.8838469
              ],
              [
                49.2542206,
                34.8846768
              ],
              [
                49.2675538,
                34.889395
              ],
              [
                49.2681104,
                34.8893951
              ],
              [
                49.2686675,
                34.8893952
              ],
              [
                49.2697772,
                34.8899544
              ],
              [
                49.2706105,
                34.8899545
              ],
              [
                49.270887,
                34.8902341
              ],
              [
                49.2717207,
                34.8902341
              ],
              [
                49.2731105,
                34.8907844
              ],
              [
                49.2736672,
                34.891064
              ],
              [
                49.2925569,
                34.906617
              ],
              [
                49.2931101,
                34.9068967
              ],
              [
                49.2933902,
                34.907456
              ],
              [
                49.2968225,
                34.9089059
              ],
              [
                49.2981137,
                34.9093956
              ],
              [
                49.3036666,
                34.9119035
              ],
              [
                49.3045002,
                34.9119035
              ],
              [
                49.3056135,
                34.9124539
              ],
              [
                49.3061666,
                34.9124539
              ],
              [
                49.3070003,
                34.912454
              ],
              [
                49.3125566,
                34.9135635
              ],
              [
                49.3139469,
                34.9135636
              ],
              [
                49.3142235,
                34.9138432
              ],
              [
                49.3156133,
                34.9138432
              ],
              [
                49.3158899,
                34.9141228
              ],
              [
                49.3175567,
                34.9141229
              ],
              [
                49.3183899,
                34.9144025
              ],
              [
                49.3211701,
                34.9144025
              ],
              [
                49.3242232,
                34.9149528
              ],
              [
                49.3247799,
                34.9152325
              ],
              [
                49.3258896,
                34.9152324
              ],
              [
                49.3264462,
                34.9155122
              ],
              [
                49.3278365,
                34.9155121
              ],
              [
                49.3289463,
                34.9160625
              ],
              [
                49.3311698,
                34.9160624
              ],
              [
                49.331723,
                34.916342
              ],
              [
                49.3378364,
                34.9163422
              ],
              [
                49.338393,
                34.9166217
              ],
              [
                49.3400594,
                34.9166218
              ],
              [
                49.3408931,
                34.9163421
              ],
              [
                49.3433932,
                34.9163421
              ],
              [
                49.3442264,
                34.9160624
              ],
              [
                49.347003,
                34.9160625
              ],
              [
                49.3478362,
                34.9157828
              ],
              [
                49.349503,
                34.9157828
              ],
              [
                49.3558926,
                34.9146823
              ],
              [
                49.3567263,
                34.9144026
              ],
              [
                49.3583927,
                34.9144026
              ],
              [
                49.3658928,
                34.9127337
              ],
              [
                49.3678358,
                34.912454
              ],
              [
                49.3695027,
                34.9119037
              ],
              [
                49.3711691,
                34.9119036
              ],
              [
                49.3714492,
                34.911624
              ],
              [
                49.3753391,
                34.911624
              ],
              [
                49.3758927,
                34.9119037
              ],
              [
                49.3778392,
                34.9119037
              ],
              [
                49.3822826,
                34.9130043
              ],
              [
                49.3825592,
                34.9132839
              ],
              [
                49.3833925,
                34.9132839
              ],
              [
                49.3881155,
                34.9152326
              ],
              [
                49.3897823,
                34.9174518
              ],
              [
                49.3920059,
                34.9260672
              ],
              [
                49.3922824,
                34.9268971
              ],
              [
                49.3920058,
                34.9274564
              ],
              [
                49.3917288,
                34.9291163
              ],
              [
                49.3914488,
                34.9302349
              ],
              [
                49.3911723,
                34.9316242
              ],
              [
                49.3908957,
                34.9335637
              ],
              [
                49.3906156,
                34.9338434
              ],
              [
                49.3903389,
                34.9352327
              ],
              [
                49.3897824,
                34.9374519
              ],
              [
                49.3895057,
                34.9385705
              ],
              [
                49.3892257,
                34.9396801
              ],
              [
                49.3889491,
                34.9407897
              ],
              [
                49.3886725,
                34.9416197
              ],
              [
                49.3883924,
                34.9432885
              ],
              [
                49.3889491,
                34.9452281
              ],
              [
                49.3967289,
                34.9480066
              ],
              [
                49.3986724,
                34.9488456
              ],
              [
                49.3995055,
                34.9488455
              ],
              [
                49.4022821,
                34.9502348
              ],
              [
                49.4072818,
                34.9560714
              ],
              [
                49.4075619,
                34.9574517
              ],
              [
                49.4078385,
                34.958011
              ],
              [
                49.4078385,
                34.9582906
              ],
              [
                49.4078385,
                34.9605098
              ],
              [
                49.407562,
                34.9607894
              ],
              [
                49.4072818,
                34.962738
              ],
              [
                49.4070053,
                34.9649572
              ],
              [
                49.4047821,
                34.9757913
              ],
              [
                49.4050622,
                34.9777308
              ],
              [
                49.4075619,
                34.9835673
              ],
              [
                49.4128386,
                34.9982892
              ],
              [
                49.4142284,
                35.0010676
              ],
              [
                49.4142284,
                35.0016269
              ],
              [
                49.4058954,
                35.0088434
              ],
              [
                49.4050621,
                35.0096824
              ],
              [
                49.4039484,
                35.009953
              ],
              [
                49.4036719,
                35.0102326
              ],
              [
                49.4028386,
                35.0102326
              ],
              [
                49.4025621,
                35.0105122
              ],
              [
                49.4017285,
                35.0105123
              ],
              [
                49.3986721,
                35.0119014
              ],
              [
                49.3958955,
                35.0127403
              ],
              [
                49.3947822,
                35.0127403
              ],
              [
                49.3931155,
                35.0132906
              ],
              [
                49.391172,
                35.0132906
              ],
              [
                49.3908955,
                35.0135702
              ],
              [
                49.3800589,
                35.0138408
              ],
              [
                49.3792256,
                35.0141205
              ],
              [
                49.378392,
                35.0138408
              ],
              [
                49.3764491,
                35.0138408
              ],
              [
                49.3703356,
                35.012181
              ],
              [
                49.3683922,
                35.0116217
              ],
              [
                49.3647824,
                35.0113511
              ],
              [
                49.3636691,
                35.0110715
              ],
              [
                49.3578357,
                35.0110714
              ],
              [
                49.3556158,
                35.0119013
              ],
              [
                49.3483926,
                35.0132905
              ],
              [
                49.3422792,
                35.0138407
              ],
              [
                49.3411694,
                35.0135701
              ],
              [
                49.322003,
                35.0138407
              ],
              [
                49.3125563,
                35.0127402
              ],
              [
                49.3067231,
                35.0116216
              ],
              [
                49.3058898,
                35.0116216
              ],
              [
                49.2972798,
                35.0077336
              ],
              [
                49.29339,
                35.0063445
              ],
              [
                49.2925566,
                35.0060649
              ],
              [
                49.2889433,
                35.0060648
              ],
              [
                49.2842234,
                35.0077337
              ],
              [
                49.2828334,
                35.0077337
              ],
              [
                49.2758868,
                35.0121808
              ],
              [
                49.2656104,
                35.0294011
              ],
              [
                49.2639435,
                35.0318998
              ],
              [
                49.259777,
                35.0421831
              ],
              [
                49.2608868,
                35.0516185
              ],
              [
                49.2900564,
                35.0757928
              ],
              [
                49.290333,
                35.0760725
              ],
              [
                49.2939432,
                35.078571
              ],
              [
                49.3042232,
                35.0843981
              ],
              [
                49.3064462,
                35.0849574
              ],
              [
                49.3239462,
                35.0832977
              ],
              [
                49.3242227,
                35.083018
              ],
              [
                49.325056,
                35.0830181
              ],
              [
                49.3281127,
                35.0810697
              ],
              [
                49.3281126,
                35.0805105
              ],
              [
                49.3283893,
                35.0802399
              ],
              [
                49.328946,
                35.0780119
              ],
              [
                49.3295026,
                35.0780119
              ],
              [
                49.3297791,
                35.0777323
              ],
              [
                49.3328359,
                35.0777323
              ],
              [
                49.3356125,
                35.0774617
              ],
              [
                49.3367258,
                35.0755133
              ],
              [
                49.337836,
                35.0730147
              ],
              [
                49.3383927,
                35.0724554
              ],
              [
                49.3406126,
                35.0716256
              ],
              [
                49.341726,
                35.0716256
              ],
              [
                49.3420025,
                35.0719053
              ],
              [
                49.3428357,
                35.0719052
              ],
              [
                49.3489456,
                35.0744038
              ],
              [
                49.3517258,
                35.0744038
              ],
              [
                49.3520023,
                35.0741242
              ],
              [
                49.3525589,
                35.0741242
              ],
              [
                49.355059,
                35.0716256
              ],
              [
                49.3553355,
                35.0705161
              ],
              [
                49.3564492,
                35.069127
              ],
              [
                49.3567258,
                35.0685678
              ],
              [
                49.3564493,
                35.0638502
              ],
              [
                49.3547824,
                35.0610719
              ],
              [
                49.3545024,
                35.0594032
              ],
              [
                49.3553356,
                35.0582936
              ],
              [
                49.3556157,
                35.0574637
              ],
              [
                49.3628357,
                35.0535671
              ],
              [
                49.3642256,
                35.053567
              ],
              [
                49.3650589,
                35.0532875
              ],
              [
                49.3681155,
                35.0532874
              ],
              [
                49.3720055,
                35.0527371
              ],
              [
                49.3795056,
                35.0488494
              ],
              [
                49.3836721,
                35.0488494
              ],
              [
                49.3842253,
                35.0485698
              ],
              [
                49.3864488,
                35.0485698
              ],
              [
                49.3906153,
                35.0474603
              ],
              [
                49.4042285,
                35.0366268
              ],
              [
                49.4070051,
                35.0346783
              ],
              [
                49.4075618,
                35.0346784
              ],
              [
                49.4078384,
                35.0343988
              ],
              [
                49.4089485,
                35.0343987
              ],
              [
                49.4095051,
                35.0341191
              ],
              [
                49.4111719,
                35.0341191
              ],
              [
                49.4150619,
                35.0366268
              ],
              [
                49.4161717,
                35.0380069
              ],
              [
                49.4170049,
                35.0399554
              ],
              [
                49.4172849,
                35.0435725
              ],
              [
                49.4175616,
                35.0449527
              ],
              [
                49.4206182,
                35.0541264
              ],
              [
                49.4411749,
                35.0794012
              ],
              [
                49.4453414,
                35.0871766
              ],
              [
                49.4472846,
                35.091903
              ],
              [
                49.450341,
                35.1069034
              ],
              [
                49.4536746,
                35.1185752
              ],
              [
                49.4539512,
                35.1196756
              ],
              [
                49.4628408,
                35.1382925
              ],
              [
                49.4631177,
                35.1427392
              ],
              [
                49.4633974,
                35.1455173
              ],
              [
                49.4645076,
                35.1494048
              ],
              [
                49.4658974,
                35.1616263
              ],
              [
                49.4678408,
                35.1694102
              ],
              [
                49.4681209,
                35.17024
              ],
              [
                49.4678407,
                35.1707992
              ],
              [
                49.4661739,
                35.1791241
              ],
              [
                49.4570077,
                35.1880172
              ],
              [
                49.4567307,
                35.1882968
              ],
              [
                49.4542311,
                35.1885674
              ],
              [
                49.453951,
                35.1888471
              ],
              [
                49.4511744,
                35.188847
              ],
              [
                49.4508978,
                35.1891266
              ],
              [
                49.4489509,
                35.1891267
              ],
              [
                49.4481177,
                35.1894062
              ],
              [
                49.4464508,
                35.1894063
              ],
              [
                49.4439512,
                35.190236
              ],
              [
                49.4414511,
                35.1927434
              ],
              [
                49.4386744,
                35.1985699
              ],
              [
                49.4383944,
                35.1999588
              ],
              [
                49.4381178,
                35.2021866
              ],
              [
                49.4378413,
                35.2049645
              ],
              [
                49.3831298,
                35.2382884
              ],
              [
                49.3831299,
                35.238578
              ],
              [
                49.3767399,
                35.238568
              ],
              [
                49.3759063,
                35.2382883
              ],
              [
                49.3689631,
                35.2377292
              ],
              [
                49.3557649,
                35.2349348
              ],
              [
                49.3488219,
                35.2349348
              ],
              [
                49.3477117,
                35.2346552
              ],
              [
                49.3408184,
                35.2324118
              ],
              [
                49.3399852,
                35.2326914
              ],
              [
                49.3297084,
                35.2298869
              ],
              [
                49.3199488,
                35.2248397
              ],
              [
                49.3177289,
                35.2248396
              ],
              [
                49.3130053,
                35.22456
              ],
              [
                49.3121721,
                35.2248396
              ],
              [
                49.309949,
                35.2248396
              ],
              [
                49.3093923,
                35.22456
              ],
              [
                49.3088388,
                35.2248396
              ],
              [
                49.3071724,
                35.2248396
              ],
              [
                49.3066157,
                35.2245601
              ],
              [
                49.3052255,
                35.2248396
              ],
              [
                49.3041157,
                35.22456
              ],
              [
                49.2819696,
                35.2186701
              ],
              [
                49.281413,
                35.2183905
              ],
              [
                49.2555765,
                35.2158916
              ],
              [
                49.2522432,
                35.215621
              ],
              [
                49.2419668,
                35.2164509
              ],
              [
                49.2358534,
                35.2164508
              ],
              [
                49.2350202,
                35.2167306
              ],
              [
                49.2322436,
                35.2167305
              ],
              [
                49.2266868,
                35.217001
              ],
              [
                49.2219636,
                35.2170011
              ],
              [
                49.2214101,
                35.2172808
              ],
              [
                49.2066007,
                35.227658
              ],
              [
                49.2057674,
                35.2279376
              ],
              [
                49.2027107,
                35.2279377
              ],
              [
                49.2021541,
                35.2282172
              ],
              [
                49.2007674,
                35.2282173
              ],
              [
                49.2004873,
                35.2284969
              ],
              [
                49.1968774,
                35.2287675
              ],
              [
                49.1968774,
                35.229047
              ],
              [
                49.1954875,
                35.2290471
              ],
              [
                49.1952105,
                35.2293267
              ],
              [
                49.1938207,
                35.2293266
              ],
              [
                49.1932641,
                35.2296063
              ],
              [
                49.1825506,
                35.2421858
              ],
              [
                49.1811608,
                35.2421859
              ],
              [
                49.1808843,
                35.2424654
              ],
              [
                49.1803272,
                35.2424655
              ],
              [
                49.1767173,
                35.2435748
              ],
              [
                49.1764373,
                35.244134
              ],
              [
                49.1742173,
                35.2441339
              ],
              [
                49.1731039,
                35.2444045
              ],
              [
                49.1703274,
                35.2444045
              ],
              [
                49.1700508,
                35.2446841
              ],
              [
                49.1683844,
                35.2446841
              ],
              [
                49.1678277,
                35.2449637
              ],
              [
                49.1658843,
                35.2449637
              ],
              [
                49.1644944,
                35.2455138
              ],
              [
                49.1633807,
                35.2455138
              ],
              [
                49.1631041,
                35.2457934
              ],
              [
                49.1625474,
                35.2457934
              ],
              [
                49.1581044,
                35.2471823
              ],
              [
                49.1569942,
                35.2471823
              ],
              [
                49.1550477,
                35.2477415
              ],
              [
                49.1508809,
                35.2482917
              ],
              [
                49.145048,
                35.2482916
              ],
              [
                49.1436576,
                35.248012
              ],
              [
                49.1244913,
                35.2457933
              ],
              [
                49.1208814,
                35.2457934
              ],
              [
                49.1200482,
                35.2455138
              ],
              [
                49.1153246,
                35.2455138
              ],
              [
                49.112825,
                35.2452431
              ],
              [
                49.1069917,
                35.2452432
              ],
              [
                49.1061584,
                35.2449636
              ],
              [
                49.1053249,
                35.2452432
              ],
              [
                49.1047682,
                35.2449636
              ],
              [
                49.0989348,
                35.2449636
              ],
              [
                49.0986583,
                35.244684
              ],
              [
                49.097825,
                35.2449636
              ],
              [
                49.0972684,
                35.2446839
              ],
              [
                49.088935,
                35.2446839
              ],
              [
                49.0886585,
                35.2444044
              ],
              [
                49.0861553,
                35.2444043
              ],
              [
                49.0858783,
                35.2441338
              ],
              [
                49.0858784,
                35.2438542
              ],
              [
                49.0700453,
                35.2227407
              ],
              [
                49.0700453,
                35.2224611
              ],
              [
                49.0539325,
                35.1932928
              ],
              [
                49.0528223,
                35.1921835
              ],
              [
                49.0525458,
                35.1919039
              ],
              [
                49.0519891,
                35.1916334
              ],
              [
                49.0411561,
                35.1857977
              ],
              [
                49.0400423,
                35.1857978
              ],
              [
                49.0386561,
                35.1852386
              ],
              [
                49.0375427,
                35.1852385
              ],
              [
                49.0367091,
                35.184959
              ],
              [
                49.0344891,
                35.1849589
              ],
              [
                49.0336559,
                35.1846794
              ],
              [
                49.023376,
                35.1846793
              ],
              [
                49.0228194,
                35.1849589
              ],
              [
                49.0217095,
                35.1849589
              ],
              [
                49.0153196,
                35.1869071
              ],
              [
                49.0142094,
                35.1869071
              ],
              [
                49.0114297,
                35.1877369
              ],
              [
                49.0103194,
                35.1877369
              ],
              [
                49.0055964,
                35.1891258
              ],
              [
                49.0044861,
                35.1891258
              ],
              [
                48.9986532,
                35.1902352
              ],
              [
                48.995043,
                35.1907944
              ],
              [
                48.9944864,
                35.191074
              ],
              [
                48.9758734,
                35.195791
              ],
              [
                48.9744832,
                35.1957911
              ],
              [
                48.9736499,
                35.1960707
              ],
              [
                48.9725401,
                35.1960706
              ],
              [
                48.96893,
                35.1969005
              ],
              [
                48.9672635,
                35.1969004
              ],
              [
                48.96504,
                35.1974596
              ],
              [
                48.9636502,
                35.1974596
              ],
              [
                48.9628169,
                35.1977392
              ],
              [
                48.9617067,
                35.1977392
              ],
              [
                48.9597633,
                35.1982894
              ],
              [
                48.9586501,
                35.1982894
              ],
              [
                48.9580969,
                35.198569
              ],
              [
                48.9572637,
                35.198569
              ],
              [
                48.956707,
                35.1988486
              ],
              [
                48.9558734,
                35.1988486
              ],
              [
                48.9555933,
                35.1991282
              ],
              [
                48.9550401,
                35.1991281
              ],
              [
                48.9405937,
                35.2024653
              ],
              [
                48.9372605,
                35.203295
              ],
              [
                48.9367038,
                35.203295
              ],
              [
                48.9361503,
                35.2035746
              ],
              [
                48.935037,
                35.2035747
              ],
              [
                48.9342038,
                35.2038542
              ],
              [
                48.932537,
                35.2041249
              ],
              [
                48.9144808,
                35.2010763
              ],
              [
                48.9083708,
                35.2010762
              ],
              [
                48.9080943,
                35.2013558
              ],
              [
                48.9019808,
                35.2024652
              ],
              [
                48.9017043,
                35.2016264
              ],
              [
                48.8980909,
                35.194402
              ],
              [
                48.8922576,
                35.1871865
              ],
              [
                48.8922577,
                35.1869068
              ],
              [
                48.8921217,
                35.1857975
              ],
              [
                48.891981,
                35.1855179
              ],
              [
                48.8900377,
                35.1816215
              ],
              [
                48.8880911,
                35.1769043
              ],
              [
                48.8780914,
                35.1641237
              ],
              [
                48.8758679,
                35.1577378
              ],
              [
                48.8758679,
                35.1563489
              ],
              [
                48.8753148,
                35.1552393
              ],
              [
                48.8747578,
                35.1527409
              ],
              [
                48.873648,
                35.1457867
              ],
              [
                48.8733679,
                35.1418993
              ],
              [
                48.8730914,
                35.1396805
              ],
              [
                48.8692015,
                35.1235711
              ],
              [
                48.8675347,
                35.1107899
              ],
              [
                48.8653147,
                35.1002365
              ],
              [
                48.8617014,
                35.095519
              ],
              [
                48.8594783,
                35.0932912
              ],
              [
                48.8586451,
                35.0921816
              ],
              [
                48.8533684,
                35.0863457
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555164,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان کبودرآهنگ",
          "name:en": "Kabutarahang County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286111"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8851708,
                35.5661705
              ],
              [
                47.8805647,
                35.5611842
              ],
              [
                47.8826164,
                35.5491834
              ],
              [
                47.8823817,
                35.5486643
              ],
              [
                47.8808889,
                35.5457386
              ],
              [
                47.8784626,
                35.5410001
              ],
              [
                47.8778965,
                35.5352344
              ],
              [
                47.8781507,
                35.5332846
              ],
              [
                47.8797743,
                35.5284477
              ],
              [
                47.8802673,
                35.5273133
              ],
              [
                47.8815442,
                35.5255306
              ],
              [
                47.8829201,
                35.5226892
              ],
              [
                47.8835232,
                35.522066
              ],
              [
                47.8851092,
                35.5174392
              ],
              [
                47.8856144,
                35.5169117
              ],
              [
                47.8855726,
                35.5137052
              ],
              [
                47.8855375,
                35.510383
              ],
              [
                47.8861164,
                35.5089453
              ],
              [
                47.8861471,
                35.5083135
              ],
              [
                47.8872237,
                35.5065394
              ],
              [
                47.8875867,
                35.5063575
              ],
              [
                47.8939184,
                35.4933252
              ],
              [
                47.8959432,
                35.4849721
              ],
              [
                47.9016929,
                35.4647273
              ],
              [
                47.9020276,
                35.4645399
              ],
              [
                47.9019263,
                35.4638378
              ],
              [
                47.902856,
                35.462245
              ],
              [
                47.9053066,
                35.4577055
              ],
              [
                47.9088678,
                35.4535664
              ],
              [
                47.9150042,
                35.4485338
              ],
              [
                47.9152361,
                35.4480602
              ],
              [
                47.9158527,
                35.4477699
              ],
              [
                47.9170234,
                35.4461009
              ],
              [
                47.9192454,
                35.4432204
              ],
              [
                47.9214704,
                35.4401868
              ],
              [
                47.9274927,
                35.4319791
              ],
              [
                47.9294172,
                35.426621
              ],
              [
                47.9327526,
                35.4172661
              ],
              [
                47.9366179,
                35.4050941
              ],
              [
                47.9389714,
                35.3996633
              ],
              [
                47.9405738,
                35.3960637
              ],
              [
                47.9414672,
                35.3948612
              ],
              [
                47.9446874,
                35.3897206
              ],
              [
                47.954468,
                35.3794286
              ],
              [
                47.9605446,
                35.376615
              ],
              [
                47.9622,
                35.3760806
              ],
              [
                47.9629014,
                35.3760204
              ],
              [
                47.9634036,
                35.3758051
              ],
              [
                47.9768647,
                35.3725322
              ],
              [
                47.9786343,
                35.3721011
              ],
              [
                47.9802669,
                35.3718967
              ],
              [
                47.9805196,
                35.3716773
              ],
              [
                47.982954,
                35.3710341
              ],
              [
                47.9845319,
                35.3710847
              ],
              [
                47.98478,
                35.3707754
              ],
              [
                47.9852116,
                35.3707884
              ],
              [
                47.9855786,
                35.3705494
              ],
              [
                47.9974921,
                35.3680307
              ],
              [
                47.9999305,
                35.3691808
              ],
              [
                48.0021924,
                35.3713434
              ],
              [
                48.0035665,
                35.3715979
              ],
              [
                48.006114,
                35.3716197
              ],
              [
                48.0063889,
                35.3718899
              ],
              [
                48.0094141,
                35.3724486
              ],
              [
                48.0111462,
                35.3724503
              ],
              [
                48.0114255,
                35.372695
              ],
              [
                48.0136249,
                35.3727871
              ],
              [
                48.0138771,
                35.3730239
              ],
              [
                48.0203744,
                35.3729977
              ],
              [
                48.0209008,
                35.3727196
              ],
              [
                48.0219343,
                35.3727596
              ],
              [
                48.0224515,
                35.3724601
              ],
              [
                48.0233978,
                35.3724469
              ],
              [
                48.023591,
                35.3721644
              ],
              [
                48.0267081,
                35.3707768
              ],
              [
                48.0341478,
                35.3628644
              ],
              [
                48.0341885,
                35.3615733
              ],
              [
                48.0339083,
                35.3596764
              ],
              [
                48.0344691,
                35.3579606
              ],
              [
                48.0465236,
                35.3366308
              ],
              [
                48.0547159,
                35.3222471
              ],
              [
                48.0552784,
                35.3204408
              ],
              [
                48.055256,
                35.3199001
              ],
              [
                48.0568396,
                35.3166275
              ],
              [
                48.0637644,
                35.3019368
              ],
              [
                48.0639713,
                35.3014993
              ],
              [
                48.0717073,
                35.291857
              ],
              [
                48.0874968,
                35.2727395
              ],
              [
                48.0894437,
                35.2696822
              ],
              [
                48.0897204,
                35.2694025
              ],
              [
                48.0919438,
                35.2610693
              ],
              [
                48.0922203,
                35.2591302
              ],
              [
                48.0980537,
                35.2424633
              ],
              [
                48.096387,
                35.2307927
              ],
              [
                48.0963869,
                35.2305131
              ],
              [
                48.0958339,
                35.2282944
              ],
              [
                48.0961104,
                35.2280148
              ],
              [
                48.096387,
                35.2277353
              ],
              [
                48.0972203,
                35.227176
              ],
              [
                48.0980538,
                35.2271761
              ],
              [
                48.0988871,
                35.2271761
              ],
              [
                48.1050005,
                35.2266259
              ],
              [
                48.1088904,
                35.226626
              ],
              [
                48.1094435,
                35.2269055
              ],
              [
                48.1197234,
                35.2288537
              ],
              [
                48.1216669,
                35.2288537
              ],
              [
                48.1225,
                35.2285741
              ],
              [
                48.1269467,
                35.2285741
              ],
              [
                48.139723,
                35.2221796
              ],
              [
                48.1490576,
                35.2116498
              ],
              [
                48.1506136,
                35.2098726
              ],
              [
                48.1544464,
                35.2038526
              ],
              [
                48.1613897,
                35.1844071
              ],
              [
                48.1758361,
                35.1727359
              ],
              [
                48.1775372,
                35.1707979
              ],
              [
                48.1777796,
                35.1699579
              ],
              [
                48.1811128,
                35.1652316
              ],
              [
                48.1812528,
                35.1637073
              ],
              [
                48.1816694,
                35.1635721
              ],
              [
                48.1858363,
                35.1627333
              ],
              [
                48.1877829,
                35.1627333
              ],
              [
                48.188336,
                35.1624536
              ],
              [
                48.1947259,
                35.1613443
              ],
              [
                48.1963928,
                35.1613443
              ],
              [
                48.1969495,
                35.1610647
              ],
              [
                48.2022261,
                35.1602349
              ],
              [
                48.2138924,
                35.1546789
              ],
              [
                48.2244488,
                35.151071
              ],
              [
                48.2280623,
                35.1505118
              ],
              [
                48.2644521,
                35.1441259
              ],
              [
                48.2719519,
                35.1441259
              ],
              [
                48.2727851,
                35.1438464
              ],
              [
                48.2758418,
                35.1438464
              ],
              [
                48.2763953,
                35.1435667
              ],
              [
                48.276675,
                35.1438464
              ],
              [
                48.2794516,
                35.1438464
              ],
              [
                48.2802852,
                35.1435668
              ],
              [
                48.2822318,
                35.1435668
              ],
              [
                48.2827849,
                35.1432872
              ],
              [
                48.2838986,
                35.1432871
              ],
              [
                48.2844518,
                35.1430076
              ],
              [
                48.2897316,
                35.1430076
              ],
              [
                48.2911183,
                35.1430076
              ],
              [
                48.2952848,
                35.1424573
              ],
              [
                48.2955649,
                35.1421778
              ],
              [
                48.2961215,
                35.1421778
              ],
              [
                48.2963985,
                35.1418982
              ],
              [
                48.2969551,
                35.1418982
              ],
              [
                48.3097316,
                35.1363421
              ],
              [
                48.3122312,
                35.1357919
              ],
              [
                48.3136215,
                35.1357918
              ],
              [
                48.3141746,
                35.1355122
              ],
              [
                48.315288,
                35.1355122
              ],
              [
                48.3158446,
                35.1352326
              ],
              [
                48.3169548,
                35.1352326
              ],
              [
                48.3175114,
                35.134953
              ],
              [
                48.3477875,
                35.1302357
              ],
              [
                48.3514008,
                35.1293969
              ],
              [
                48.3530677,
                35.1288467
              ],
              [
                48.3544576,
                35.1288467
              ],
              [
                48.3547341,
                35.1285671
              ],
              [
                48.3625108,
                35.1266189
              ],
              [
                48.3647343,
                35.1263483
              ],
              [
                48.3733474,
                35.1263483
              ],
              [
                48.3769573,
                35.125789
              ],
              [
                48.3836238,
                35.1255094
              ],
              [
                48.4050136,
                35.1255094
              ],
              [
                48.4066805,
                35.1257891
              ],
              [
                48.4094603,
                35.1257891
              ],
              [
                48.4114037,
                35.1263483
              ],
              [
                48.4190551,
                35.1295
              ],
              [
                48.4241801,
                35.1316249
              ],
              [
                48.43696,
                35.1363423
              ],
              [
                48.4386264,
                35.1366219
              ],
              [
                48.4405699,
                35.1369016
              ],
              [
                48.4416832,
                35.1369016
              ],
              [
                48.4539065,
                35.1369016
              ],
              [
                48.4627951,
                35.1376836
              ],
              [
                48.4900194,
                35.1191236
              ],
              [
                48.4939057,
                35.1177346
              ],
              [
                48.4980726,
                35.1177345
              ],
              [
                48.5064091,
                35.1180142
              ],
              [
                48.5091539,
                35.1178904
              ],
              [
                48.5230995,
                35.1172608
              ],
              [
                48.5258521,
                35.117464
              ],
              [
                48.5397419,
                35.1196739
              ],
              [
                48.5427987,
                35.1207923
              ],
              [
                48.5444654,
                35.1219018
              ],
              [
                48.5549535,
                35.1266192
              ],
              [
                48.5555751,
                35.1268988
              ],
              [
                48.5577985,
                35.1271784
              ],
              [
                48.565855,
                35.1271784
              ],
              [
                48.5686316,
                35.1268988
              ],
              [
                48.5742576,
                35.1252444
              ],
              [
                48.5897449,
                35.1205129
              ],
              [
                48.5908205,
                35.1202423
              ],
              [
                48.5912346,
                35.1201382
              ],
              [
                48.591968,
                35.1199537
              ],
              [
                48.5944138,
                35.1191318
              ],
              [
                48.5978013,
                35.1182849
              ],
              [
                48.6031892,
                35.1174641
              ],
              [
                48.6050245,
                35.1171845
              ],
              [
                48.6086348,
                35.1166254
              ],
              [
                48.6158579,
                35.1157955
              ],
              [
                48.6191912,
                35.1155159
              ],
              [
                48.6216913,
                35.1155159
              ],
              [
                48.6219678,
                35.1152363
              ],
              [
                48.6236342,
                35.1152363
              ],
              [
                48.6241909,
                35.1149567
              ],
              [
                48.6247476,
                35.1149567
              ],
              [
                48.6250246,
                35.1146861
              ],
              [
                48.6264144,
                35.1146861
              ],
              [
                48.626691,
                35.1144064
              ],
              [
                48.6278012,
                35.1144065
              ],
              [
                48.6383576,
                35.1121786
              ],
              [
                48.6578041,
                35.1057925
              ],
              [
                48.6583608,
                35.1052332
              ],
              [
                48.6589139,
                35.1052332
              ],
              [
                48.6589139,
                35.1049536
              ],
              [
                48.6641941,
                35.1030144
              ],
              [
                48.6655805,
                35.1030143
              ],
              [
                48.667804,
                35.1027347
              ],
              [
                48.6686372,
                35.1027347
              ],
              [
                48.6691939,
                35.1030143
              ],
              [
                48.6714138,
                35.1030144
              ],
              [
                48.6719705,
                35.1027347
              ],
              [
                48.6733603,
                35.1027348
              ],
              [
                48.6828039,
                35.0999566
              ],
              [
                48.6858602,
                35.0969078
              ],
              [
                48.6883603,
                35.0905126
              ],
              [
                48.6886368,
                35.0885643
              ],
              [
                48.688917,
                35.0882937
              ],
              [
                48.6880838,
                35.0755121
              ],
              [
                48.6875272,
                35.0735727
              ],
              [
                48.6836372,
                35.0677367
              ],
              [
                48.6747508,
                35.0624598
              ],
              [
                48.6739175,
                35.0624598
              ],
              [
                48.6722471,
                35.0619005
              ],
              [
                48.6705808,
                35.0619005
              ],
              [
                48.6700272,
                35.0616209
              ],
              [
                48.6689139,
                35.0616209
              ],
              [
                48.6683608,
                35.0613413
              ],
              [
                48.6597473,
                35.0602317
              ],
              [
                48.656414,
                35.0602317
              ],
              [
                48.6555808,
                35.0599522
              ],
              [
                48.6469709,
                35.0591222
              ],
              [
                48.6422477,
                35.0552345
              ],
              [
                48.6414145,
                35.0535657
              ],
              [
                48.6364145,
                35.0335674
              ],
              [
                48.6350247,
                35.0230134
              ],
              [
                48.6355813,
                35.0207942
              ],
              [
                48.6355813,
                35.0163472
              ],
              [
                48.6361379,
                35.0110701
              ],
              [
                48.6364146,
                35.0107904
              ],
              [
                48.6364145,
                35.0074528
              ],
              [
                48.6364146,
                35.005784
              ],
              [
                48.636138,
                35.0001731
              ],
              [
                48.634468,
                34.9985674
              ],
              [
                48.6339145,
                34.9974578
              ],
              [
                48.6333579,
                34.9946795
              ],
              [
                48.6322482,
                34.9907915
              ],
              [
                48.6319679,
                34.9902323
              ],
              [
                48.631968,
                34.9899526
              ],
              [
                48.631968,
                34.9885634
              ],
              [
                48.6322481,
                34.9882837
              ],
              [
                48.6389147,
                34.9855053
              ],
              [
                48.6397479,
                34.9855054
              ],
              [
                48.6405811,
                34.984955
              ],
              [
                48.6414146,
                34.9849551
              ],
              [
                48.659471,
                34.9738414
              ],
              [
                48.6614144,
                34.9724522
              ],
              [
                48.6711377,
                34.962457
              ],
              [
                48.6750276,
                34.9599582
              ],
              [
                48.6755843,
                34.9593988
              ],
              [
                48.6761374,
                34.9593989
              ],
              [
                48.6764175,
                34.9591192
              ],
              [
                48.6778042,
                34.9591192
              ],
              [
                48.6783608,
                34.9588396
              ],
              [
                48.6803042,
                34.9588396
              ],
              [
                48.6819708,
                34.9582892
              ],
              [
                48.683084,
                34.9582893
              ],
              [
                48.683361,
                34.9580097
              ],
              [
                48.6847509,
                34.9580096
              ],
              [
                48.6855841,
                34.95773
              ],
              [
                48.6869708,
                34.95773
              ],
              [
                48.6872509,
                34.9574503
              ],
              [
                48.6891939,
                34.9574503
              ],
              [
                48.6894709,
                34.9571707
              ],
              [
                48.6933608,
                34.9571707
              ],
              [
                48.6966941,
                34.9569001
              ],
              [
                48.6975273,
                34.9571707
              ],
              [
                48.6988394,
                34.9573717
              ],
              [
                48.6991942,
                34.9574504
              ],
              [
                48.6997507,
                34.9574504
              ],
              [
                48.7014172,
                34.9588396
              ],
              [
                48.7016938,
                34.9591193
              ],
              [
                48.7036407,
                34.9605085
              ],
              [
                48.7058607,
                34.9655061
              ],
              [
                48.7064173,
                34.9663451
              ],
              [
                48.7141971,
                34.9780092
              ],
              [
                48.7147502,
                34.9791187
              ],
              [
                48.7161405,
                34.9924515
              ],
              [
                48.7166971,
                34.9960688
              ],
              [
                48.7178069,
                34.9980083
              ],
              [
                48.7216969,
                35.0002184
              ],
              [
                48.720307,
                35.0027352
              ],
              [
                48.7155838,
                35.0132893
              ],
              [
                48.7153068,
                35.0143988
              ],
              [
                48.7158634,
                35.0221837
              ],
              [
                48.7241967,
                35.0421821
              ],
              [
                48.725307,
                35.0457902
              ],
              [
                48.7286402,
                35.0546753
              ],
              [
                48.7369731,
                35.0657975
              ],
              [
                48.7453065,
                35.0696761
              ],
              [
                48.7489198,
                35.0710652
              ],
              [
                48.7525297,
                35.0719042
              ],
              [
                48.756143,
                35.0724544
              ],
              [
                48.7569762,
                35.072734
              ],
              [
                48.7589196,
                35.072734
              ],
              [
                48.7686429,
                35.0741231
              ],
              [
                48.7722527,
                35.0746734
              ],
              [
                48.7761426,
                35.074953
              ],
              [
                48.7789193,
                35.0749531
              ],
              [
                48.7797524,
                35.0752327
              ],
              [
                48.7850326,
                35.0752326
              ],
              [
                48.7855858,
                35.0755123
              ],
              [
                48.7914227,
                35.0755123
              ],
              [
                48.7925324,
                35.075792
              ],
              [
                48.7969759,
                35.0757919
              ],
              [
                48.8025322,
                35.0763422
              ],
              [
                48.8030889,
                35.0766218
              ],
              [
                48.8044756,
                35.0766218
              ],
              [
                48.8108656,
                35.0780109
              ],
              [
                48.8116988,
                35.0780109
              ],
              [
                48.8128122,
                35.0785702
              ],
              [
                48.8186455,
                35.0791205
              ],
              [
                48.8191986,
                35.0794001
              ],
              [
                48.8214221,
                35.0794001
              ],
              [
                48.8219788,
                35.0796797
              ],
              [
                48.8241987,
                35.0796797
              ],
              [
                48.8244788,
                35.0799593
              ],
              [
                48.8272554,
                35.0799593
              ],
              [
                48.8280887,
                35.080239
              ],
              [
                48.8294789,
                35.0802389
              ],
              [
                48.8330887,
                35.0810688
              ],
              [
                48.8344786,
                35.0810688
              ],
              [
                48.8353118,
                35.0813485
              ],
              [
                48.8378119,
                35.0813485
              ],
              [
                48.8383686,
                35.0816281
              ],
              [
                48.8400354,
                35.0816281
              ],
              [
                48.8405885,
                35.0819077
              ],
              [
                48.8447585,
                35.0819077
              ],
              [
                48.8467019,
                35.0821783
              ],
              [
                48.8514251,
                35.0841176
              ],
              [
                48.8528118,
                35.0857864
              ],
              [
                48.8533684,
                35.0863457
              ],
              [
                48.8586451,
                35.0921816
              ],
              [
                48.8594783,
                35.0932912
              ],
              [
                48.8617014,
                35.095519
              ],
              [
                48.8653147,
                35.1002365
              ],
              [
                48.8675347,
                35.1107899
              ],
              [
                48.8692015,
                35.1235711
              ],
              [
                48.8730914,
                35.1396805
              ],
              [
                48.8733679,
                35.1418993
              ],
              [
                48.873648,
                35.1457867
              ],
              [
                48.8747578,
                35.1527409
              ],
              [
                48.8753148,
                35.1552393
              ],
              [
                48.8758679,
                35.1563489
              ],
              [
                48.8758679,
                35.1577378
              ],
              [
                48.8780914,
                35.1641237
              ],
              [
                48.8880911,
                35.1769043
              ],
              [
                48.8900377,
                35.1816215
              ],
              [
                48.891981,
                35.1855179
              ],
              [
                48.8921217,
                35.1857975
              ],
              [
                48.8922577,
                35.1869068
              ],
              [
                48.8922576,
                35.1871865
              ],
              [
                48.8980909,
                35.194402
              ],
              [
                48.9017043,
                35.2016264
              ],
              [
                48.9019808,
                35.2024652
              ],
              [
                48.9019809,
                35.2027358
              ],
              [
                48.9019808,
                35.203295
              ],
              [
                48.9017043,
                35.2035745
              ],
              [
                48.8994808,
                35.2096805
              ],
              [
                48.8986475,
                35.2107989
              ],
              [
                48.8933709,
                35.2163547
              ],
              [
                48.8936474,
                35.2191237
              ],
              [
                48.915594,
                35.2382892
              ],
              [
                48.9178139,
                35.2432947
              ],
              [
                48.9183705,
                35.2466317
              ],
              [
                48.9186507,
                35.2496892
              ],
              [
                48.9183705,
                35.2499597
              ],
              [
                48.9186506,
                35.2507984
              ],
              [
                48.9183705,
                35.2513486
              ],
              [
                48.913927,
                35.2680154
              ],
              [
                48.9136474,
                35.268295
              ],
              [
                48.9047608,
                35.2885689
              ],
              [
                48.9030939,
                35.2907965
              ],
              [
                48.8947574,
                35.2994092
              ],
              [
                48.863091,
                35.319412
              ],
              [
                48.8628144,
                35.3196826
              ],
              [
                48.8623952,
                35.3198233
              ],
              [
                48.8597578,
                35.3208009
              ],
              [
                48.8583675,
                35.3208008
              ],
              [
                48.8578109,
                35.3210804
              ],
              [
                48.8528112,
                35.3210804
              ],
              [
                48.849758,
                35.3213509
              ],
              [
                48.8489244,
                35.3216305
              ],
              [
                48.847811,
                35.3216306
              ],
              [
                48.8469778,
                35.3219101
              ],
              [
                48.8411445,
                35.32191
              ],
              [
                48.8405878,
                35.32191
              ],
              [
                48.8397546,
                35.3219101
              ],
              [
                48.8389214,
                35.3219101
              ],
              [
                48.8367014,
                35.3221897
              ],
              [
                48.830588,
                35.3221896
              ],
              [
                48.8303115,
                35.32191
              ],
              [
                48.8289212,
                35.32191
              ],
              [
                48.828368,
                35.3216305
              ],
              [
                48.8272547,
                35.3216305
              ],
              [
                48.7955885,
                35.3016276
              ],
              [
                48.7925318,
                35.3002387
              ],
              [
                48.7916986,
                35.2996886
              ],
              [
                48.791422,
                35.2996886
              ],
              [
                48.7908653,
                35.299409
              ],
              [
                48.7703087,
                35.2980201
              ],
              [
                48.7675289,
                35.2982906
              ],
              [
                48.7666953,
                35.2985703
              ],
              [
                48.7655855,
                35.2985702
              ],
              [
                48.765309,
                35.2988499
              ],
              [
                48.7639187,
                35.2988498
              ],
              [
                48.7469723,
                35.3035755
              ],
              [
                48.741419,
                35.3049643
              ],
              [
                48.7397525,
                35.305794
              ],
              [
                48.7383622,
                35.3060737
              ],
              [
                48.7378057,
                35.3066327
              ],
              [
                48.7366959,
                35.3069033
              ],
              [
                48.6953062,
                35.3374573
              ],
              [
                48.694473,
                35.3377459
              ],
              [
                48.6933597,
                35.3388552
              ],
              [
                48.6908596,
                35.340794
              ],
              [
                48.673083,
                35.3574595
              ],
              [
                48.6630796,
                35.3621849
              ],
              [
                48.6533564,
                35.3699674
              ],
              [
                48.6503032,
                35.3730245
              ],
              [
                48.6439132,
                35.3777409
              ],
              [
                48.64308,
                35.3780204
              ],
              [
                48.6425234,
                35.378859
              ],
              [
                48.6414136,
                35.3794092
              ],
              [
                48.6405799,
                35.3802387
              ],
              [
                48.6394702,
                35.3807979
              ],
              [
                48.6386369,
                35.3816365
              ],
              [
                48.63419,
                35.3835754
              ],
              [
                48.6216904,
                35.3924669
              ],
              [
                48.613357,
                35.4102408
              ],
              [
                48.6116902,
                35.4135773
              ],
              [
                48.6072436,
                35.418573
              ],
              [
                48.5978004,
                35.4232982
              ],
              [
                48.5969672,
                35.4232982
              ],
              [
                48.5853005,
                35.428853
              ],
              [
                48.5803008,
                35.4371851
              ],
              [
                48.5797441,
                35.4374646
              ],
              [
                48.5789105,
                35.4380237
              ],
              [
                48.5780773,
                35.4385828
              ],
              [
                48.577244,
                35.4388533
              ],
              [
                48.576964,
                35.4391329
              ],
              [
                48.5764108,
                35.4391328
              ],
              [
                48.5761307,
                35.4394124
              ],
              [
                48.574744,
                35.4394124
              ],
              [
                48.5741873,
                35.4396829
              ],
              [
                48.565854,
                35.4394123
              ],
              [
                48.5636308,
                35.4399624
              ],
              [
                48.5575209,
                35.4430193
              ],
              [
                48.5555741,
                35.4452375
              ],
              [
                48.5514075,
                35.4588536
              ],
              [
                48.5505743,
                35.4674651
              ],
              [
                48.5505743,
                35.4746877
              ],
              [
                48.5522407,
                35.4777446
              ],
              [
                48.5530743,
                35.4785832
              ],
              [
                48.555574,
                35.4810809
              ],
              [
                48.5605776,
                35.4835786
              ],
              [
                48.5619639,
                35.4835786
              ],
              [
                48.5625205,
                35.4838582
              ],
              [
                48.5636307,
                35.4838582
              ],
              [
                48.5639108,
                35.4841377
              ],
              [
                48.566964,
                35.4841377
              ],
              [
                48.5777971,
                35.4857968
              ],
              [
                48.5853003,
                35.4908013
              ],
              [
                48.5869671,
                35.4963557
              ],
              [
                48.5891871,
                35.5016396
              ],
              [
                48.5897437,
                35.5032987
              ],
              [
                48.5908534,
                35.5310793
              ],
              [
                48.5911335,
                35.5416378
              ],
              [
                48.59141,
                35.5466328
              ],
              [
                48.5922437,
                35.5541346
              ],
              [
                48.5928002,
                35.5566321
              ],
              [
                48.5930768,
                35.5591297
              ],
              [
                48.5933534,
                35.5694083
              ],
              [
                48.6096179,
                35.5907677
              ],
              [
                48.6090525,
                35.5904882
              ],
              [
                48.6084993,
                35.5899291
              ],
              [
                48.6040528,
                35.5874315
              ],
              [
                48.6032196,
                35.5874314
              ],
              [
                48.5754397,
                35.5785406
              ],
              [
                48.5743299,
                35.5785406
              ],
              [
                48.5737733,
                35.5782611
              ],
              [
                48.5729397,
                35.5782611
              ],
              [
                48.5726632,
                35.5779816
              ],
              [
                48.5450207,
                35.5852497
              ],
              [
                48.5430737,
                35.5852497
              ],
              [
                48.5427971,
                35.5849702
              ],
              [
                48.538074,
                35.5849702
              ],
              [
                48.5364072,
                35.5855292
              ],
              [
                48.5255742,
                35.5883061
              ],
              [
                48.5211275,
                35.5902536
              ],
              [
                48.4961278,
                35.598864
              ],
              [
                48.495018,
                35.5999729
              ],
              [
                48.4983512,
                35.6199703
              ],
              [
                48.4980712,
                35.6213587
              ],
              [
                48.4977946,
                35.6219177
              ],
              [
                48.4958511,
                35.6277509
              ],
              [
                48.4952945,
                35.6296893
              ],
              [
                48.4925179,
                35.635252
              ],
              [
                48.4919613,
                35.6355225
              ],
              [
                48.4905709,
                35.6374699
              ],
              [
                48.484181,
                35.6446914
              ],
              [
                48.4839044,
                35.644971
              ],
              [
                48.4836278,
                35.6452504
              ],
              [
                48.4816813,
                35.6458093
              ],
              [
                48.4811277,
                35.6458094
              ],
              [
                48.4719611,
                35.6499746
              ],
              [
                48.4680713,
                35.6505245
              ],
              [
                48.4622378,
                35.6521924
              ],
              [
                48.4616811,
                35.6527513
              ],
              [
                48.4611245,
                35.6527513
              ],
              [
                48.4580714,
                35.6541397
              ],
              [
                48.456958,
                35.6541397
              ],
              [
                48.4558482,
                35.6546897
              ],
              [
                48.4550147,
                35.6546897
              ],
              [
                48.4527916,
                35.6552486
              ],
              [
                48.4514048,
                35.6552486
              ],
              [
                48.4508482,
                35.6555281
              ],
              [
                48.4489047,
                35.6557986
              ],
              [
                48.4450148,
                35.6557985
              ],
              [
                48.4447347,
                35.6560871
              ],
              [
                48.4425148,
                35.656087
              ],
              [
                48.4422351,
                35.6557985
              ],
              [
                48.4414015,
                35.6557986
              ],
              [
                48.4391815,
                35.6549691
              ],
              [
                48.4380682,
                35.6549691
              ],
              [
                48.435015,
                35.6541396
              ],
              [
                48.4258449,
                35.6474681
              ],
              [
                48.4216784,
                35.6446913
              ],
              [
                48.4141787,
                35.6408055
              ],
              [
                48.4016788,
                35.6424734
              ],
              [
                48.3952889,
                35.6424734
              ],
              [
                48.3947357,
                35.6427529
              ],
              [
                48.3916789,
                35.6430234
              ],
              [
                48.357509,
                35.6574753
              ],
              [
                48.353066,
                35.6596931
              ],
              [
                48.3433427,
                35.6621994
              ],
              [
                48.3280627,
                35.6666349
              ],
              [
                48.311953,
                35.6727473
              ],
              [
                48.2961198,
                35.6805276
              ],
              [
                48.2901766,
                35.6861535
              ],
              [
                48.2858379,
                35.6894397
              ],
              [
                48.2826376,
                35.6918096
              ],
              [
                48.2772784,
                35.6931287
              ],
              [
                48.2706979,
                35.6960481
              ],
              [
                48.2649998,
                35.696915
              ],
              [
                48.2576416,
                35.6943377
              ],
              [
                48.2406663,
                35.6934826
              ],
              [
                48.2419109,
                35.6918793
              ],
              [
                48.2293555,
                35.6867601
              ],
              [
                48.2195404,
                35.6838154
              ],
              [
                48.2096005,
                35.679811
              ],
              [
                48.1965552,
                35.6765947
              ],
              [
                48.1839975,
                35.6728606
              ],
              [
                48.175298,
                35.6694665
              ],
              [
                48.173654,
                35.6701644
              ],
              [
                48.1355292,
                35.6681734
              ],
              [
                48.1217479,
                35.6597371
              ],
              [
                48.106665,
                35.6510625
              ],
              [
                48.1008052,
                35.6475323
              ],
              [
                48.09732,
                35.6444182
              ],
              [
                48.085184,
                35.6462768
              ],
              [
                48.0643514,
                35.6522853
              ],
              [
                48.0490296,
                35.652793
              ],
              [
                48.0456963,
                35.652243
              ],
              [
                48.0438242,
                35.6513603
              ],
              [
                48.0303077,
                35.6485706
              ],
              [
                48.0064066,
                35.6435558
              ],
              [
                47.9864504,
                35.6351744
              ],
              [
                47.9869399,
                35.6271019
              ],
              [
                47.9794081,
                35.6122227
              ],
              [
                47.976264,
                35.5953297
              ],
              [
                47.9554277,
                35.5872707
              ],
              [
                47.9537612,
                35.5872707
              ],
              [
                47.9532077,
                35.5869913
              ],
              [
                47.9490412,
                35.5867208
              ],
              [
                47.9036017,
                35.5799649
              ],
              [
                47.8938596,
                35.5775297
              ],
              [
                47.8880482,
                35.5722231
              ],
              [
                47.8851708,
                35.5661705
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555211,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ملایر",
          "name:en": "Malayer County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1285937",
          "wikipedia": "fa:شهرستان ملایر"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.3925162,
                34.336886
              ],
              [
                48.3925162,
                34.3354962
              ],
              [
                48.3927928,
                34.3343862
              ],
              [
                48.3930729,
                34.3332671
              ],
              [
                48.3933494,
                34.3316066
              ],
              [
                48.3936264,
                34.3307762
              ],
              [
                48.3939061,
                34.3299369
              ],
              [
                48.3969597,
                34.3210475
              ],
              [
                48.3972394,
                34.3207768
              ],
              [
                48.3964063,
                34.3154882
              ],
              [
                48.3819599,
                34.3071581
              ],
              [
                48.3811266,
                34.3068785
              ],
              [
                48.3797363,
                34.3060482
              ],
              [
                48.3789032,
                34.3060482
              ],
              [
                48.3777934,
                34.3040987
              ],
              [
                48.3791832,
                34.3021584
              ],
              [
                48.3883498,
                34.2974384
              ],
              [
                48.3933496,
                34.2899387
              ],
              [
                48.3986263,
                34.2760492
              ],
              [
                48.3986263,
                34.2754897
              ],
              [
                48.3994595,
                34.273829
              ],
              [
                48.4030729,
                34.2674393
              ],
              [
                48.4036265,
                34.2671596
              ],
              [
                48.4086261,
                34.2618798
              ],
              [
                48.4091827,
                34.2616
              ],
              [
                48.4097395,
                34.2610496
              ],
              [
                48.4130728,
                34.2593799
              ],
              [
                48.414183,
                34.2593799
              ],
              [
                48.4147396,
                34.2591001
              ],
              [
                48.4180729,
                34.2591002
              ],
              [
                48.4183494,
                34.2588204
              ],
              [
                48.4369627,
                34.2577103
              ],
              [
                48.4497427,
                34.2491004
              ],
              [
                48.4550189,
                34.2435498
              ],
              [
                48.4564092,
                34.24216
              ],
              [
                48.4675188,
                34.2304904
              ],
              [
                48.4675188,
                34.2299399
              ],
              [
                48.4780754,
                34.2166004
              ],
              [
                48.4822423,
                34.2149398
              ],
              [
                48.4833521,
                34.2149398
              ],
              [
                48.4836322,
                34.2146601
              ],
              [
                48.4858556,
                34.21466
              ],
              [
                48.4872419,
                34.2141004
              ],
              [
                48.4875221,
                34.2138297
              ],
              [
                48.4880756,
                34.2138297
              ],
              [
                48.4880756,
                34.2135499
              ],
              [
                48.4886322,
                34.2135499
              ],
              [
                48.4905752,
                34.2127196
              ],
              [
                48.4925933,
                34.2114179
              ],
              [
                48.4944652,
                34.2102106
              ],
              [
                48.4944652,
                34.2088207
              ],
              [
                48.4947421,
                34.2074308
              ],
              [
                48.4950222,
                34.20716
              ],
              [
                48.4950222,
                34.2066004
              ],
              [
                48.4972418,
                34.2038296
              ],
              [
                48.4977989,
                34.2038296
              ],
              [
                48.4980754,
                34.2035498
              ],
              [
                48.5002985,
                34.2035498
              ],
              [
                48.5008552,
                34.20327
              ],
              [
                48.5016887,
                34.20327
              ],
              [
                48.5080788,
                34.1993801
              ],
              [
                48.5097452,
                34.1954901
              ],
              [
                48.5091886,
                34.1893799
              ],
              [
                48.506412,
                34.1796595
              ],
              [
                48.5061319,
                34.1774392
              ],
              [
                48.5061319,
                34.1749301
              ],
              [
                48.506412,
                34.1740998
              ],
              [
                48.5079854,
                34.1717862
              ],
              [
                48.5083554,
                34.1713198
              ],
              [
                48.508632,
                34.1707694
              ],
              [
                48.5155786,
                34.1624387
              ],
              [
                48.5127985,
                34.1513282
              ],
              [
                48.5130786,
                34.1504888
              ],
              [
                48.5152986,
                34.146328
              ],
              [
                48.5247453,
                34.1415986
              ],
              [
                48.5264117,
                34.1413278
              ],
              [
                48.5275219,
                34.141048
              ],
              [
                48.5275219,
                34.1407682
              ],
              [
                48.5280786,
                34.1407682
              ],
              [
                48.5316884,
                34.1388186
              ],
              [
                48.5372452,
                34.131878
              ],
              [
                48.5397448,
                34.1207673
              ],
              [
                48.5400218,
                34.1199278
              ],
              [
                48.5403019,
                34.1190974
              ],
              [
                48.5405785,
                34.1177165
              ],
              [
                48.5408586,
                34.1154871
              ],
              [
                48.5411351,
                34.1135466
              ],
              [
                48.5414117,
                34.1107666
              ],
              [
                48.5416918,
                34.1104868
              ],
              [
                48.5414117,
                34.1054865
              ],
              [
                48.5414117,
                34.1052158
              ],
              [
                48.5414117,
                34.1049359
              ],
              [
                48.5450251,
                34.102156
              ],
              [
                48.5458583,
                34.1018762
              ],
              [
                48.5469685,
                34.1004863
              ],
              [
                48.5489115,
                34.096596
              ],
              [
                48.5489115,
                34.0954859
              ],
              [
                48.5494682,
                34.094105
              ],
              [
                48.5500249,
                34.0915957
              ],
              [
                48.5528015,
                34.077434
              ],
              [
                48.5530785,
                34.0763148
              ],
              [
                48.5566919,
                34.0696536
              ],
              [
                48.5597482,
                34.0671535
              ],
              [
                48.5603017,
                34.0665938
              ],
              [
                48.5641916,
                34.0654837
              ],
              [
                48.5650248,
                34.0654837
              ],
              [
                48.5672483,
                34.0649331
              ],
              [
                48.5730817,
                34.063543
              ],
              [
                48.574468,
                34.0635431
              ],
              [
                48.5755813,
                34.0632633
              ],
              [
                48.580858,
                34.0632632
              ],
              [
                48.5816912,
                34.063543
              ],
              [
                48.5858581,
                34.0635431
              ],
              [
                48.5864147,
                34.0638229
              ],
              [
                48.5875245,
                34.0638229
              ],
              [
                48.5886378,
                34.0643825
              ],
              [
                48.5894714,
                34.0643825
              ],
              [
                48.5994712,
                34.0702133
              ],
              [
                48.6141941,
                34.0935454
              ],
              [
                48.6144706,
                34.0938253
              ],
              [
                48.6172508,
                34.0960456
              ],
              [
                48.6219708,
                34.0963164
              ],
              [
                48.6233607,
                34.0957658
              ],
              [
                48.6244709,
                34.0957658
              ],
              [
                48.6247506,
                34.0954861
              ],
              [
                48.6258607,
                34.0954861
              ],
              [
                48.6333605,
                34.0890957
              ],
              [
                48.6339171,
                34.0890958
              ],
              [
                48.6341937,
                34.0885451
              ],
              [
                48.6469737,
                34.0821548
              ],
              [
                48.6474543,
                34.0783667
              ],
              [
                48.6576542,
                34.0760602
              ],
              [
                48.6593973,
                34.0792887
              ],
              [
                48.6618974,
                34.0787291
              ],
              [
                48.6680073,
                34.0787291
              ],
              [
                48.6672504,
                34.0788242
              ],
              [
                48.67225,
                34.0790951
              ],
              [
                48.6805868,
                34.0815953
              ],
              [
                48.6850299,
                34.0835448
              ],
              [
                48.7094765,
                34.0918759
              ],
              [
                48.7128097,
                34.0946558
              ],
              [
                48.7150329,
                34.0979864
              ],
              [
                48.7155864,
                34.1032665
              ],
              [
                48.7153094,
                34.1040968
              ],
              [
                48.7150329,
                34.1054869
              ],
              [
                48.7116995,
                34.1163178
              ],
              [
                48.7130863,
                34.1213272
              ],
              [
                48.7133664,
                34.1221575
              ],
              [
                48.7147527,
                34.1227081
              ],
              [
                48.7158659,
                34.1232677
              ],
              [
                48.7169762,
                34.1232677
              ],
              [
                48.7175328,
                34.1235475
              ],
              [
                48.7219759,
                34.1235476
              ],
              [
                48.722533,
                34.1232677
              ],
              [
                48.7236428,
                34.1232677
              ],
              [
                48.7308659,
                34.1210474
              ],
              [
                48.7478094,
                34.0977157
              ],
              [
                48.7491992,
                34.0960459
              ],
              [
                48.7497559,
                34.0954862
              ],
              [
                48.7500324,
                34.0952155
              ],
              [
                48.7530891,
                34.0918759
              ],
              [
                48.7583658,
                34.0846552
              ],
              [
                48.7597557,
                34.0804942
              ],
              [
                48.765589,
                34.072434
              ],
              [
                48.7792022,
                34.0649335
              ],
              [
                48.7800355,
                34.0641031
              ],
              [
                48.7944787,
                34.0568732
              ],
              [
                48.7969788,
                34.0557631
              ],
              [
                48.804202,
                34.0527122
              ],
              [
                48.8139252,
                34.0499322
              ],
              [
                48.8147584,
                34.0499322
              ],
              [
                48.8403148,
                34.0371513
              ],
              [
                48.8408715,
                34.0366007
              ],
              [
                48.8417048,
                34.0363209
              ],
              [
                48.8439283,
                34.0338207
              ],
              [
                48.8458716,
                34.0260401
              ],
              [
                48.8458717,
                34.0177089
              ],
              [
                48.8461482,
                34.0174381
              ],
              [
                48.8461482,
                34.0154884
              ],
              [
                48.8469815,
                34.013268
              ],
              [
                48.8472615,
                34.0129881
              ],
              [
                48.849205,
                34.006047
              ],
              [
                48.8517047,
                34.0027073
              ],
              [
                48.8544813,
                34.0018768
              ],
              [
                48.8611478,
                34.0010465
              ],
              [
                48.8675377,
                34.0027073
              ],
              [
                48.868928,
                34.0027074
              ],
              [
                48.8725379,
                34.0035467
              ],
              [
                48.8742043,
                34.0035468
              ],
              [
                48.8789279,
                34.004657
              ],
              [
                48.8828178,
                34.004657
              ],
              [
                48.890041,
                34.0035468
              ],
              [
                48.8911512,
                34.0032669
              ],
              [
                48.8936507,
                34.003267
              ],
              [
                48.8975407,
                34.0040974
              ],
              [
                48.8980943,
                34.0043772
              ],
              [
                48.8992075,
                34.0043772
              ],
              [
                48.9042073,
                34.0063179
              ],
              [
                48.9103176,
                34.0110477
              ],
              [
                48.9117073,
                34.0140985
              ],
              [
                48.9122641,
                34.0185394
              ],
              [
                48.911984,
                34.0190991
              ],
              [
                48.9117074,
                34.0202093
              ],
              [
                48.9136507,
                34.0274302
              ],
              [
                48.9161503,
                34.0285404
              ],
              [
                48.9203205,
                34.0285404
              ],
              [
                48.9225403,
                34.0282697
              ],
              [
                48.9280971,
                34.0268706
              ],
              [
                48.9305973,
                34.0240997
              ],
              [
                48.9308738,
                34.0218701
              ],
              [
                48.9419869,
                34.0132682
              ],
              [
                48.9433768,
                34.012149
              ],
              [
                48.9436537,
                34.0118781
              ],
              [
                48.9442104,
                34.0110477
              ],
              [
                48.9442104,
                34.0102083
              ],
              [
                48.9444869,
                34.0099284
              ],
              [
                48.9447636,
                34.0063179
              ],
              [
                48.9475437,
                34.0029873
              ],
              [
                48.9480968,
                34.0029873
              ],
              [
                48.948377,
                34.0027074
              ],
              [
                48.9500438,
                34.0027075
              ],
              [
                48.9692101,
                34.0088183
              ],
              [
                48.9694866,
                34.0090981
              ],
              [
                48.9778232,
                34.0090981
              ],
              [
                48.9808764,
                34.0096488
              ],
              [
                48.9811565,
                34.0099286
              ],
              [
                48.9819897,
                34.0099286
              ],
              [
                48.9825433,
                34.0102084
              ],
              [
                48.9836565,
                34.0102084
              ],
              [
                48.9855999,
                34.010768
              ],
              [
                49.0039326,
                34.0204893
              ],
              [
                49.0111558,
                34.0221501
              ],
              [
                49.0158793,
                34.0221501
              ],
              [
                49.0167126,
                34.0218703
              ],
              [
                49.0178228,
                34.0218704
              ],
              [
                49.0353259,
                34.0154889
              ],
              [
                49.0361591,
                34.0154889
              ],
              [
                49.0367122,
                34.015209
              ],
              [
                49.0378259,
                34.015209
              ],
              [
                49.0383791,
                34.0149291
              ],
              [
                49.0389357,
                34.015209
              ],
              [
                49.0408791,
                34.015209
              ],
              [
                49.0425456,
                34.0157687
              ],
              [
                49.0433788,
                34.0168789
              ],
              [
                49.0433788,
                34.0171497
              ],
              [
                49.0461589,
                34.0163193
              ],
              [
                49.0467121,
                34.0163192
              ],
              [
                49.046712,
                34.0160394
              ],
              [
                49.0556021,
                34.0157687
              ],
              [
                49.061992,
                34.0140988
              ],
              [
                49.0622687,
                34.013819
              ],
              [
                49.0631023,
                34.013819
              ],
              [
                49.063382,
                34.0135392
              ],
              [
                49.0642155,
                34.0132685
              ],
              [
                49.0678254,
                34.0135392
              ],
              [
                49.0681019,
                34.013819
              ],
              [
                49.0700485,
                34.013819
              ],
              [
                49.0703254,
                34.0140988
              ],
              [
                49.0731051,
                34.0140989
              ],
              [
                49.0739388,
                34.0143786
              ],
              [
                49.0750486,
                34.0143787
              ],
              [
                49.0758818,
                34.0146495
              ],
              [
                49.0775724,
                34.01471
              ],
              [
                49.0786584,
                34.0149292
              ],
              [
                49.0797717,
                34.0149293
              ],
              [
                49.0803252,
                34.0152091
              ],
              [
                49.0811585,
                34.0152091
              ],
              [
                49.091995,
                34.0218704
              ],
              [
                49.0975482,
                34.0288207
              ],
              [
                49.1017147,
                34.0404824
              ],
              [
                49.1031049,
                34.0446525
              ],
              [
                49.107828,
                34.0482629
              ],
              [
                49.1172712,
                34.0515936
              ],
              [
                49.1214377,
                34.0538231
              ],
              [
                49.1225514,
                34.0546535
              ],
              [
                49.1419944,
                34.0766048
              ],
              [
                49.1472741,
                34.0807658
              ],
              [
                49.153664,
                34.0838255
              ],
              [
                49.1672741,
                34.0935465
              ],
              [
                49.171164,
                34.0999368
              ],
              [
                49.1714405,
                34.1002076
              ],
              [
                49.1728305,
                34.1018774
              ],
              [
                49.173107,
                34.1027078
              ],
              [
                49.1734573,
                34.1031297
              ],
              [
                49.1753304,
                34.1115983
              ],
              [
                49.1750539,
                34.1121578
              ],
              [
                49.1736636,
                34.1163187
              ],
              [
                49.1717207,
                34.1171582
              ],
              [
                49.1683874,
                34.1171581
              ],
              [
                49.1606071,
                34.1160479
              ],
              [
                49.1597739,
                34.1157681
              ],
              [
                49.1572738,
                34.1157682
              ],
              [
                49.1531073,
                34.1163186
              ],
              [
                49.1525506,
                34.1165985
              ],
              [
                49.1500506,
                34.1165984
              ],
              [
                49.1394941,
                34.1190986
              ],
              [
                49.1392176,
                34.1193784
              ],
              [
                49.1383843,
                34.1193784
              ],
              [
                49.1167179,
                34.1352185
              ],
              [
                49.1111611,
                34.1421593
              ],
              [
                49.1108845,
                34.1429897
              ],
              [
                49.1103279,
                34.1432695
              ],
              [
                49.1092177,
                34.145219
              ],
              [
                49.1081043,
                34.1471595
              ],
              [
                49.1044946,
                34.1513293
              ],
              [
                49.1008811,
                34.1532698
              ],
              [
                49.1003281,
                34.1532699
              ],
              [
                49.1000479,
                34.1535496
              ],
              [
                49.0992148,
                34.1546598
              ],
              [
                49.0989378,
                34.1552104
              ],
              [
                49.0983811,
                34.1554901
              ],
              [
                49.0979816,
                34.1558944
              ],
              [
                49.093938,
                34.1627197
              ],
              [
                49.0936614,
                34.1641006
              ],
              [
                49.093938,
                34.1691007
              ],
              [
                49.0947712,
                34.1721604
              ],
              [
                49.0997713,
                34.1788212
              ],
              [
                49.1025479,
                34.1796606
              ],
              [
                49.1052979,
                34.1806167
              ],
              [
                49.1072711,
                34.1810416
              ],
              [
                49.1106044,
                34.1824315
              ],
              [
                49.1114376,
                34.1824315
              ],
              [
                49.1197709,
                34.1863215
              ],
              [
                49.1233842,
                34.1910418
              ],
              [
                49.1244941,
                34.1985419
              ],
              [
                49.1242175,
                34.1991015
              ],
              [
                49.1239374,
                34.2004914
              ],
              [
                49.1236608,
                34.2016016
              ],
              [
                49.1236607,
                34.2018813
              ],
              [
                49.1242175,
                34.2021611
              ],
              [
                49.124494,
                34.2029915
              ],
              [
                49.1242174,
                34.2032713
              ],
              [
                49.1156044,
                34.2202118
              ],
              [
                49.1153274,
                34.2218815
              ],
              [
                49.1161609,
                34.2257714
              ],
              [
                49.1169941,
                34.2271613
              ],
              [
                49.118384,
                34.2291108
              ],
              [
                49.118661,
                34.2293815
              ],
              [
                49.1189375,
                34.2296613
              ],
              [
                49.1231041,
                34.2374411
              ],
              [
                49.1239373,
                34.2429916
              ],
              [
                49.1236607,
                34.2435512
              ],
              [
                49.1228274,
                34.2466017
              ],
              [
                49.1219942,
                34.2479916
              ],
              [
                49.1217173,
                34.2488219
              ],
              [
                49.1194941,
                34.2510511
              ],
              [
                49.1133842,
                34.2546612
              ],
              [
                49.1106041,
                34.2557712
              ],
              [
                49.1092174,
                34.2557712
              ],
              [
                49.1061611,
                34.2566016
              ],
              [
                49.1039376,
                34.2566016
              ],
              [
                49.1033809,
                34.2568813
              ],
              [
                49.1011609,
                34.2568813
              ],
              [
                49.1006043,
                34.2571611
              ],
              [
                49.0992145,
                34.2571611
              ],
              [
                49.0986609,
                34.2574408
              ],
              [
                49.0975476,
                34.2574409
              ],
              [
                49.0967143,
                34.2577117
              ],
              [
                49.0933811,
                34.2579913
              ],
              [
                49.0931046,
                34.2582711
              ],
              [
                49.0919944,
                34.2582712
              ],
              [
                49.0839379,
                34.2629913
              ],
              [
                49.0792144,
                34.2735506
              ],
              [
                49.0789379,
                34.2738304
              ],
              [
                49.0700478,
                34.2835504
              ],
              [
                49.0650481,
                34.2854907
              ],
              [
                49.0644914,
                34.2857705
              ],
              [
                49.0642148,
                34.2860502
              ],
              [
                49.0639348,
                34.2863209
              ],
              [
                49.0506017,
                34.2904905
              ],
              [
                49.0450449,
                34.2977195
              ],
              [
                49.0433781,
                34.2996598
              ],
              [
                49.0400447,
                34.3027102
              ],
              [
                49.038935,
                34.3029901
              ],
              [
                49.036435,
                34.30299
              ],
              [
                49.0361584,
                34.3032698
              ],
              [
                49.0331017,
                34.3032698
              ],
              [
                49.0256019,
                34.3054899
              ],
              [
                49.0208784,
                34.3096594
              ],
              [
                49.015602,
                34.3193881
              ],
              [
                49.0108785,
                34.3224386
              ],
              [
                49.0089319,
                34.3241081
              ],
              [
                49.0089319,
                34.3257687
              ],
              [
                49.0125454,
                34.3296674
              ],
              [
                49.0147683,
                34.3332683
              ],
              [
                49.0158785,
                34.3388275
              ],
              [
                49.0153219,
                34.3416072
              ],
              [
                49.0150454,
                34.3432767
              ],
              [
                49.015602,
                34.344107
              ],
              [
                49.0161973,
                34.3448964
              ],
              [
                49.0097652,
                34.3549366
              ],
              [
                49.0094885,
                34.3557759
              ],
              [
                49.009212,
                34.3568859
              ],
              [
                49.0092119,
                34.3618855
              ],
              [
                49.0122651,
                34.3782741
              ],
              [
                49.007265,
                34.3843837
              ],
              [
                48.9922654,
                34.3891035
              ],
              [
                48.9917088,
                34.3893833
              ],
              [
                48.990322,
                34.3893833
              ],
              [
                48.9894889,
                34.389663
              ],
              [
                48.9855989,
                34.389663
              ],
              [
                48.9836556,
                34.389663
              ],
              [
                48.9755987,
                34.3866037
              ],
              [
                48.9747655,
                34.3866037
              ],
              [
                48.9683754,
                34.3841129
              ],
              [
                48.9647657,
                34.3832737
              ],
              [
                48.9608757,
                34.3827232
              ],
              [
                48.9603191,
                34.3824433
              ],
              [
                48.9589323,
                34.3824434
              ],
              [
                48.9583757,
                34.3827231
              ],
              [
                48.9561526,
                34.3827231
              ],
              [
                48.9547623,
                34.3829938
              ],
              [
                48.9525423,
                34.3841129
              ],
              [
                48.9500427,
                34.388553
              ],
              [
                48.9497625,
                34.3896629
              ],
              [
                48.9511524,
                34.3991026
              ],
              [
                48.951429,
                34.3996621
              ],
              [
                48.9528193,
                34.4016113
              ],
              [
                48.9555955,
                34.4043818
              ],
              [
                48.9661523,
                34.4099408
              ],
              [
                48.977542,
                34.4174401
              ],
              [
                48.9819886,
                34.4193894
              ],
              [
                48.9828222,
                34.4193893
              ],
              [
                48.9842086,
                34.4199398
              ],
              [
                48.9858754,
                34.4199399
              ],
              [
                48.986432,
                34.4202195
              ],
              [
                48.9875418,
                34.4202196
              ],
              [
                48.9880985,
                34.4204994
              ],
              [
                48.9942118,
                34.4204994
              ],
              [
                48.994765,
                34.4207791
              ],
              [
                48.9961552,
                34.4207791
              ],
              [
                48.9983783,
                34.4216093
              ],
              [
                49.0005983,
                34.4221598
              ],
              [
                49.003655,
                34.4238294
              ],
              [
                49.0053219,
                34.4257695
              ],
              [
                49.0078215,
                34.4313285
              ],
              [
                49.0108782,
                34.4360482
              ],
              [
                49.0153216,
                34.4454965
              ],
              [
                49.0156017,
                34.4477255
              ],
              [
                49.014768,
                34.4516058
              ],
              [
                49.0072647,
                34.4588342
              ],
              [
                49.0072647,
                34.4591139
              ],
              [
                49.0067116,
                34.4593847
              ],
              [
                49.0030982,
                34.4624438
              ],
              [
                49.0036549,
                34.4652232
              ],
              [
                49.0036549,
                34.4657827
              ],
              [
                49.0103214,
                34.4710528
              ],
              [
                49.0119882,
                34.4724424
              ],
              [
                49.0197681,
                34.4793909
              ],
              [
                49.0314347,
                34.4952189
              ],
              [
                49.0339344,
                34.4960582
              ],
              [
                49.0492108,
                34.4988286
              ],
              [
                49.0531008,
                34.5013372
              ],
              [
                49.0547675,
                34.5052174
              ],
              [
                49.0547675,
                34.5074373
              ],
              [
                49.0547675,
                34.5079968
              ],
              [
                49.0539343,
                34.5107761
              ],
              [
                49.0447677,
                34.5218843
              ],
              [
                49.0400442,
                34.5302222
              ],
              [
                49.039491,
                34.5363403
              ],
              [
                49.0339342,
                34.5443894
              ],
              [
                49.0336577,
                34.5449398
              ],
              [
                49.033101,
                34.5452195
              ],
              [
                49.0317111,
                34.5485583
              ],
              [
                49.0317111,
                34.551888
              ],
              [
                49.0317111,
                34.5543875
              ],
              [
                49.0314346,
                34.5546672
              ],
              [
                49.029211,
                34.5602258
              ],
              [
                49.0286544,
                34.5605054
              ],
              [
                49.0283778,
                34.5613357
              ],
              [
                49.0203211,
                34.5693936
              ],
              [
                49.0194878,
                34.569944
              ],
              [
                49.0086547,
                34.5860598
              ],
              [
                49.0078211,
                34.58689
              ],
              [
                49.005878,
                34.5907791
              ],
              [
                49.0014314,
                34.5971675
              ],
              [
                49.0011545,
                34.5974473
              ],
              [
                48.9967114,
                34.6005062
              ],
              [
                48.993098,
                34.6068856
              ],
              [
                48.9919879,
                34.6077248
              ],
              [
                48.990598,
                34.6085549
              ],
              [
                48.9828217,
                34.613274
              ],
              [
                48.9825416,
                34.6141132
              ],
              [
                48.9889315,
                34.6235605
              ],
              [
                48.993098,
                34.6410563
              ],
              [
                48.9933745,
                34.6421662
              ],
              [
                48.9942112,
                34.6441151
              ],
              [
                48.9969878,
                34.6510628
              ],
              [
                48.9964312,
                34.6532825
              ],
              [
                48.9933744,
                34.6574421
              ],
              [
                48.9597648,
                34.6643897
              ],
              [
                48.9575417,
                34.6646694
              ],
              [
                48.9430953,
                34.6646693
              ],
              [
                48.9428184,
                34.6643896
              ],
              [
                48.9405953,
                34.6643896
              ],
              [
                48.9297618,
                34.6616195
              ],
              [
                48.928372,
                34.6607805
              ],
              [
                48.9275387,
                34.6607804
              ],
              [
                48.9183722,
                34.6560524
              ],
              [
                48.917539,
                34.6552222
              ],
              [
                48.9047625,
                34.6493934
              ],
              [
                48.9039289,
                34.6493934
              ],
              [
                48.9033722,
                34.6491137
              ],
              [
                48.9028156,
                34.6491137
              ],
              [
                48.9011491,
                34.6491137
              ],
              [
                48.9008722,
                34.648834
              ],
              [
                48.8961491,
                34.648834
              ],
              [
                48.8953159,
                34.6491137
              ],
              [
                48.8939256,
                34.6491137
              ],
              [
                48.8908724,
                34.6499438
              ],
              [
                48.8903157,
                34.6502234
              ],
              [
                48.8897591,
                34.6505032
              ],
              [
                48.889206,
                34.6505032
              ],
              [
                48.8889259,
                34.6507829
              ],
              [
                48.8869825,
                34.6507829
              ],
              [
                48.8833726,
                34.6518927
              ],
              [
                48.882816,
                34.6518927
              ],
              [
                48.8805924,
                34.6527228
              ],
              [
                48.8772593,
                34.653562
              ],
              [
                48.8755928,
                34.653562
              ],
              [
                48.8742026,
                34.6538326
              ],
              [
                48.873926,
                34.6541124
              ],
              [
                48.8725361,
                34.6541123
              ],
              [
                48.871983,
                34.6543921
              ],
              [
                48.8661496,
                34.6527228
              ],
              [
                48.8650363,
                34.6527228
              ],
              [
                48.8425366,
                34.6405055
              ],
              [
                48.8367033,
                34.6377264
              ],
              [
                48.8353131,
                34.6377265
              ],
              [
                48.8311466,
                34.6360572
              ],
              [
                48.8292032,
                34.6357865
              ],
              [
                48.8272567,
                34.6352271
              ],
              [
                48.8255899,
                34.6352271
              ],
              [
                48.8253133,
                34.6349473
              ],
              [
                48.8239234,
                34.6349474
              ],
              [
                48.8233667,
                34.6346676
              ],
              [
                48.82198,
                34.6346676
              ],
              [
                48.8214234,
                34.6343879
              ],
              [
                48.8175334,
                34.6343879
              ],
              [
                48.8147568,
                34.637167
              ],
              [
                48.8144802,
                34.6396664
              ],
              [
                48.8142001,
                34.6424455
              ],
              [
                48.813647,
                34.645775
              ],
              [
                48.8133669,
                34.6468849
              ],
              [
                48.8117,
                34.6549424
              ],
              [
                48.8030901,
                34.6627291
              ],
              [
                48.8017002,
                34.6632796
              ],
              [
                48.7972571,
                34.664669
              ],
              [
                48.7958669,
                34.6646691
              ],
              [
                48.7950337,
                34.6649488
              ],
              [
                48.7830869,
                34.6649488
              ],
              [
                48.7825338,
                34.6652284
              ],
              [
                48.7603107,
                34.6652284
              ],
              [
                48.7564207,
                34.6654991
              ],
              [
                48.7541972,
                34.6660585
              ],
              [
                48.7516976,
                34.6660586
              ],
              [
                48.7380875,
                34.6677187
              ],
              [
                48.7375309,
                34.6679984
              ],
              [
                48.7361411,
                34.6679984
              ],
              [
                48.7355879,
                34.6682781
              ],
              [
                48.7339211,
                34.6682781
              ],
              [
                48.7325312,
                34.6685578
              ],
              [
                48.7222513,
                34.6691082
              ],
              [
                48.7219743,
                34.6693879
              ],
              [
                48.7197513,
                34.6693879
              ],
              [
                48.718918,
                34.6696676
              ],
              [
                48.7114179,
                34.6696676
              ],
              [
                48.7111413,
                34.6699473
              ],
              [
                48.7094749,
                34.6699472
              ],
              [
                48.7086412,
                34.670227
              ],
              [
                48.7064181,
                34.670227
              ],
              [
                48.7058615,
                34.6705067
              ],
              [
                48.7044748,
                34.6705067
              ],
              [
                48.7014181,
                34.6713368
              ],
              [
                48.6997516,
                34.6713367
              ],
              [
                48.6922515,
                34.6727262
              ],
              [
                48.6903049,
                34.6727263
              ],
              [
                48.681695,
                34.674946
              ],
              [
                48.6814185,
                34.6752257
              ],
              [
                48.673085,
                34.6752256
              ],
              [
                48.6725283,
                34.6755053
              ],
              [
                48.6700283,
                34.6755053
              ],
              [
                48.6683618,
                34.6755053
              ],
              [
                48.6680818,
                34.6752256
              ],
              [
                48.666972,
                34.6732857
              ],
              [
                48.6653052,
                34.6649485
              ],
              [
                48.6669721,
                34.6591107
              ],
              [
                48.6803052,
                34.6355065
              ],
              [
                48.6803052,
                34.6352268
              ],
              [
                48.6808619,
                34.6338372
              ],
              [
                48.6811384,
                34.6324477
              ],
              [
                48.6811385,
                34.6260593
              ],
              [
                48.6808619,
                34.6221703
              ],
              [
                48.6805853,
                34.6207807
              ],
              [
                48.6653054,
                34.5916085
              ],
              [
                48.6647487,
                34.5907784
              ],
              [
                48.6640556,
                34.5895287
              ],
              [
                48.6639156,
                34.5891091
              ],
              [
                48.663639,
                34.5888384
              ],
              [
                48.6625288,
                34.5882789
              ],
              [
                48.6608623,
                34.5882789
              ],
              [
                48.6605823,
                34.5879992
              ],
              [
                48.6566956,
                34.5882789
              ],
              [
                48.6525255,
                34.5893887
              ],
              [
                48.6511391,
                34.5893887
              ],
              [
                48.6505825,
                34.5896685
              ],
              [
                48.6466922,
                34.5896684
              ],
              [
                48.646139,
                34.5893887
              ],
              [
                48.6441925,
                34.5893887
              ],
              [
                48.643639,
                34.589109
              ],
              [
                48.6425256,
                34.589109
              ],
              [
                48.6422492,
                34.5893887
              ],
              [
                48.6405823,
                34.5893888
              ],
              [
                48.6400256,
                34.5891091
              ],
              [
                48.6380826,
                34.589109
              ],
              [
                48.6369724,
                34.5893888
              ],
              [
                48.6350259,
                34.5893887
              ],
              [
                48.6294691,
                34.5918882
              ],
              [
                48.6294691,
                34.592168
              ],
              [
                48.628916,
                34.5921679
              ],
              [
                48.6286359,
                34.5924476
              ],
              [
                48.6280824,
                34.5924476
              ],
              [
                48.6272492,
                34.5927184
              ],
              [
                48.6269691,
                34.5927184
              ],
              [
                48.6247492,
                34.5935575
              ],
              [
                48.613636,
                34.5963276
              ],
              [
                48.6130794,
                34.5966074
              ],
              [
                48.611136,
                34.5966074
              ],
              [
                48.6103027,
                34.5968871
              ],
              [
                48.6089128,
                34.5968871
              ],
              [
                48.6083593,
                34.5971668
              ],
              [
                48.6069695,
                34.5971668
              ],
              [
                48.6066929,
                34.5974466
              ],
              [
                48.6030795,
                34.5974465
              ],
              [
                48.5969697,
                34.5963276
              ],
              [
                48.5936364,
                34.5957772
              ],
              [
                48.5911363,
                34.5957772
              ],
              [
                48.5903031,
                34.5954975
              ],
              [
                48.5883561,
                34.5954975
              ],
              [
                48.5808564,
                34.5938371
              ],
              [
                48.5752996,
                34.5938371
              ],
              [
                48.5744664,
                34.5935574
              ],
              [
                48.5700233,
                34.5935574
              ],
              [
                48.5697468,
                34.5938371
              ],
              [
                48.5686331,
                34.5938371
              ],
              [
                48.5683565,
                34.5941169
              ],
              [
                48.5675233,
                34.5941169
              ],
              [
                48.5669666,
                34.5946672
              ],
              [
                48.5519668,
                34.5999459
              ],
              [
                48.5494666,
                34.5999459
              ],
              [
                48.5458569,
                34.6010557
              ],
              [
                48.5430767,
                34.6010557
              ],
              [
                48.5422435,
                34.6013355
              ],
              [
                48.5416904,
                34.6013354
              ],
              [
                48.5380771,
                34.5846693
              ],
              [
                48.5378005,
                34.5832798
              ],
              [
                48.5314105,
                34.5735524
              ],
              [
                48.531134,
                34.5718921
              ],
              [
                48.531134,
                34.5699431
              ],
              [
                48.5389104,
                34.5507771
              ],
              [
                48.5397436,
                34.5491078
              ],
              [
                48.5364104,
                34.53661
              ],
              [
                48.5366874,
                34.5360596
              ],
              [
                48.5378007,
                34.5327209
              ],
              [
                48.5380772,
                34.5318906
              ],
              [
                48.5416495,
                34.5278744
              ],
              [
                48.5425238,
                34.5268915
              ],
              [
                48.5428004,
                34.5266118
              ],
              [
                48.5622469,
                34.507716
              ],
              [
                48.5625235,
                34.5071656
              ],
              [
                48.5636337,
                34.5060557
              ],
              [
                48.567247,
                34.4993871
              ],
              [
                48.5678002,
                34.4988276
              ],
              [
                48.5680802,
                34.4977177
              ],
              [
                48.58558,
                34.469942
              ],
              [
                48.5853034,
                34.4666031
              ],
              [
                48.5828037,
                34.4604938
              ],
              [
                48.5828037,
                34.4602141
              ],
              [
                48.5819701,
                34.4585536
              ],
              [
                48.5519673,
                34.422159
              ],
              [
                48.5500239,
                34.4193885
              ],
              [
                48.5300208,
                34.3891027
              ],
              [
                48.522521,
                34.3852131
              ],
              [
                48.5102978,
                34.3813234
              ],
              [
                48.5094645,
                34.3813235
              ],
              [
                48.5086314,
                34.3813234
              ],
              [
                48.5069645,
                34.380773
              ],
              [
                48.5061313,
                34.380773
              ],
              [
                48.5058547,
                34.3804932
              ],
              [
                48.5033546,
                34.3804932
              ],
              [
                48.502798,
                34.3802134
              ],
              [
                48.5008546,
                34.3802134
              ],
              [
                48.5005745,
                34.3799337
              ],
              [
                48.496408,
                34.3799337
              ],
              [
                48.4958549,
                34.3802134
              ],
              [
                48.4914083,
                34.3796629
              ],
              [
                48.4908548,
                34.3793831
              ],
              [
                48.4897415,
                34.3793832
              ],
              [
                48.4814082,
                34.3774429
              ],
              [
                48.4797417,
                34.3768833
              ],
              [
                48.4769651,
                34.3768833
              ],
              [
                48.4764084,
                34.3766036
              ],
              [
                48.4747416,
                34.3766035
              ],
              [
                48.4741849,
                34.3768834
              ],
              [
                48.4716853,
                34.3768833
              ],
              [
                48.4639085,
                34.3785529
              ],
              [
                48.4633519,
                34.3785529
              ],
              [
                48.4630753,
                34.3788326
              ],
              [
                48.461962,
                34.3788326
              ],
              [
                48.4594619,
                34.3791124
              ],
              [
                48.4552955,
                34.3793831
              ],
              [
                48.4533521,
                34.3791124
              ],
              [
                48.4527955,
                34.3788326
              ],
              [
                48.4511286,
                34.3788326
              ],
              [
                48.450852,
                34.3785528
              ],
              [
                48.4500188,
                34.3785528
              ],
              [
                48.4486286,
                34.3779933
              ],
              [
                48.4477953,
                34.3779933
              ],
              [
                48.4433523,
                34.3735533
              ],
              [
                48.4383523,
                34.3571646
              ],
              [
                48.4369624,
                34.3527154
              ],
              [
                48.4341858,
                34.3477158
              ],
              [
                48.4339056,
                34.347436
              ],
              [
                48.4333526,
                34.3471562
              ],
              [
                48.4327955,
                34.3468855
              ],
              [
                48.4316857,
                34.3468854
              ],
              [
                48.4314057,
                34.3466057
              ],
              [
                48.4305725,
                34.3466057
              ],
              [
                48.4300193,
                34.3468854
              ],
              [
                48.4297392,
                34.3466057
              ],
              [
                48.4283524,
                34.3466057
              ],
              [
                48.425849,
                34.3449361
              ],
              [
                48.4241824,
                34.3441058
              ],
              [
                48.4233492,
                34.3441058
              ],
              [
                48.4230726,
                34.3438261
              ],
              [
                48.4194625,
                34.3438261
              ],
              [
                48.417796,
                34.3443856
              ],
              [
                48.4147392,
                34.3443855
              ],
              [
                48.4141827,
                34.3441058
              ],
              [
                48.4130725,
                34.3441058
              ],
              [
                48.4044594,
                34.341606
              ],
              [
                48.4036262,
                34.3416059
              ],
              [
                48.394183,
                34.336886
              ],
              [
                48.3927928,
                34.336886
              ],
              [
                48.3925162,
                34.336886
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555239,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان نهاوند",
          "name:en": "Nahavand County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279539",
          "wikipedia": "fa:شهرستان نهاوند"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                47.8866593,
                34.2552092
              ],
              [
                47.8872163,
                34.2546586
              ],
              [
                47.8874929,
                34.2543789
              ],
              [
                47.8874929,
                34.2540991
              ],
              [
                47.889993,
                34.2507688
              ],
              [
                47.889993,
                34.2502093
              ],
              [
                47.9002729,
                34.2388285
              ],
              [
                47.9002729,
                34.2385487
              ],
              [
                47.9033261,
                34.2385487
              ],
              [
                47.9041593,
                34.2388285
              ],
              [
                47.9049925,
                34.2388285
              ],
              [
                47.9077727,
                34.2399386
              ],
              [
                47.9083258,
                34.2399386
              ],
              [
                47.9113825,
                34.2407689
              ],
              [
                47.9230491,
                34.2440992
              ],
              [
                47.9311055,
                34.2452094
              ],
              [
                47.9316622,
                34.2454891
              ],
              [
                47.9349954,
                34.2454892
              ],
              [
                47.935549,
                34.245769
              ],
              [
                47.9386057,
                34.2457689
              ],
              [
                47.9436054,
                34.244379
              ],
              [
                47.9449953,
                34.2440993
              ],
              [
                47.9647187,
                34.2313286
              ],
              [
                47.9697185,
                34.2293792
              ],
              [
                47.9705517,
                34.2293792
              ],
              [
                47.9711083,
                34.2293792
              ],
              [
                47.9713853,
                34.2293792
              ],
              [
                47.9727752,
                34.2291084
              ],
              [
                47.9852751,
                34.222159
              ],
              [
                47.999997,
                34.218371
              ],
              [
                48.0005546,
                34.2207691
              ],
              [
                48.0047216,
                34.2207692
              ],
              [
                48.0055548,
                34.221049
              ],
              [
                48.0074982,
                34.221049
              ],
              [
                48.0077748,
                34.2207692
              ],
              [
                48.0105549,
                34.2207692
              ],
              [
                48.0119413,
                34.2202096
              ],
              [
                48.0130546,
                34.219659
              ],
              [
                48.0191644,
                34.217159
              ],
              [
                48.0211113,
                34.2171591
              ],
              [
                48.0216645,
                34.2168793
              ],
              [
                48.0269447,
                34.2168793
              ],
              [
                48.0272212,
                34.217159
              ],
              [
                48.0283311,
                34.2171591
              ],
              [
                48.0286112,
                34.2168793
              ],
              [
                48.0388875,
                34.2168793
              ],
              [
                48.0427778,
                34.2163288
              ],
              [
                48.0433345,
                34.216049
              ],
              [
                48.0444443,
                34.216049
              ],
              [
                48.0452775,
                34.2157692
              ],
              [
                48.0463876,
                34.2157692
              ],
              [
                48.0466678,
                34.2154894
              ],
              [
                48.0477776,
                34.2154894
              ],
              [
                48.053891,
                34.2127187
              ],
              [
                48.0547242,
                34.2115996
              ],
              [
                48.0558344,
                34.2099299
              ],
              [
                48.0705574,
                34.1990994
              ],
              [
                48.0722242,
                34.1954892
              ],
              [
                48.0722242,
                34.1946589
              ],
              [
                48.0811139,
                34.1771585
              ],
              [
                48.0817616,
                34.1766932
              ],
              [
                48.0822241,
                34.1763281
              ],
              [
                48.0822241,
                34.1760484
              ],
              [
                48.0900039,
                34.1702088
              ],
              [
                48.0916704,
                34.1685482
              ],
              [
                48.0933372,
                34.1671582
              ],
              [
                48.100837,
                34.1535476
              ],
              [
                48.1080603,
                34.1465979
              ],
              [
                48.1108368,
                34.1457676
              ],
              [
                48.1122271,
                34.1457676
              ],
              [
                48.1130603,
                34.1454877
              ],
              [
                48.1233367,
                34.1454878
              ],
              [
                48.1238933,
                34.1457676
              ],
              [
                48.1258367,
                34.1457676
              ],
              [
                48.1263934,
                34.1454878
              ],
              [
                48.1275036,
                34.1454878
              ],
              [
                48.1280602,
                34.145217
              ],
              [
                48.1286169,
                34.145217
              ],
              [
                48.1291701,
                34.1452171
              ],
              [
                48.1294501,
                34.1449373
              ],
              [
                48.1358366,
                34.1421574
              ],
              [
                48.1363932,
                34.1415977
              ],
              [
                48.1369499,
                34.1415978
              ],
              [
                48.1372268,
                34.141327
              ],
              [
                48.1377835,
                34.1410472
              ],
              [
                48.1447266,
                34.1338177
              ],
              [
                48.1527831,
                34.1221563
              ],
              [
                48.1538933,
                34.1207665
              ],
              [
                48.1675065,
                34.1057655
              ],
              [
                48.167783,
                34.1049352
              ],
              [
                48.1686163,
                34.1040958
              ],
              [
                48.1688964,
                34.1032654
              ],
              [
                48.1693972,
                34.1027568
              ],
              [
                48.1747297,
                34.0918747
              ],
              [
                48.1763966,
                34.087434
              ],
              [
                48.1769497,
                34.0868744
              ],
              [
                48.1772298,
                34.086044
              ],
              [
                48.1861194,
                34.0804931
              ],
              [
                48.1869531,
                34.0796536
              ],
              [
                48.1880628,
                34.079094
              ],
              [
                48.1916727,
                34.0790941
              ],
              [
                48.193063,
                34.0788233
              ],
              [
                48.2147294,
                34.0674326
              ],
              [
                48.2152862,
                34.0671527
              ],
              [
                48.2177858,
                34.0657627
              ],
              [
                48.2308423,
                34.0543719
              ],
              [
                48.2344526,
                34.0513211
              ],
              [
                48.2358424,
                34.0507614
              ],
              [
                48.2405656,
                34.0491006
              ],
              [
                48.2461223,
                34.0491006
              ],
              [
                48.2538987,
                34.0507615
              ],
              [
                48.255842,
                34.0515919
              ],
              [
                48.2741787,
                34.0540921
              ],
              [
                48.2752886,
                34.054372
              ],
              [
                48.2866786,
                34.054372
              ],
              [
                48.2880685,
                34.0546518
              ],
              [
                48.2897349,
                34.0546518
              ],
              [
                48.2905686,
                34.0549316
              ],
              [
                48.2930682,
                34.0549316
              ],
              [
                48.2983449,
                34.0560419
              ],
              [
                48.2994582,
                34.0560419
              ],
              [
                48.3011249,
                34.0566015
              ],
              [
                48.3025117,
                34.0566015
              ],
              [
                48.3030684,
                34.0568723
              ],
              [
                48.3044582,
                34.0566015
              ],
              [
                48.3052915,
                34.055762
              ],
              [
                48.3052915,
                34.0554912
              ],
              [
                48.305568,
                34.0552115
              ],
              [
                48.305845,
                34.0546519
              ],
              [
                48.3050114,
                34.0413202
              ],
              [
                48.3047348,
                34.0390999
              ],
              [
                48.3047348,
                34.0379897
              ],
              [
                48.3039017,
                34.0285393
              ],
              [
                48.3036251,
                34.0268694
              ],
              [
                48.3039017,
                34.0265987
              ],
              [
                48.3041783,
                34.0227084
              ],
              [
                48.304735,
                34.0213183
              ],
              [
                48.3227915,
                34.0168774
              ],
              [
                48.3230681,
                34.0165976
              ],
              [
                48.3250146,
                34.0165976
              ],
              [
                48.3319582,
                34.0149278
              ],
              [
                48.3325148,
                34.0149278
              ],
              [
                48.3327914,
                34.014648
              ],
              [
                48.333348,
                34.0143772
              ],
              [
                48.3522379,
                34.0068765
              ],
              [
                48.3791841,
                34.0013163
              ],
              [
                48.3849697,
                34.0013163
              ],
              [
                48.3883507,
                34.0013163
              ],
              [
                48.3908508,
                34.0013163
              ],
              [
                48.3933504,
                34.0013163
              ],
              [
                48.3944606,
                34.0015961
              ],
              [
                48.3977939,
                34.0015961
              ],
              [
                48.3989072,
                34.0018759
              ],
              [
                48.4044604,
                34.0018759
              ],
              [
                48.4055738,
                34.0021558
              ],
              [
                48.4105738,
                34.0021558
              ],
              [
                48.4147404,
                34.0024266
              ],
              [
                48.4158502,
                34.0027064
              ],
              [
                48.420017,
                34.0027065
              ],
              [
                48.4433534,
                34.0082667
              ],
              [
                48.4447398,
                34.0082666
              ],
              [
                48.4455734,
                34.0085465
              ],
              [
                48.4550196,
                34.0085464
              ],
              [
                48.4561299,
                34.0088172
              ],
              [
                48.4605764,
                34.0085465
              ],
              [
                48.4705762,
                34.006317
              ],
              [
                48.4714094,
                34.006317
              ],
              [
                48.4719661,
                34.006317
              ],
              [
                48.4722371,
                34.0063171
              ],
              [
                48.4736329,
                34.006317
              ],
              [
                48.474186,
                34.0065969
              ],
              [
                48.4750197,
                34.0065969
              ],
              [
                48.4752994,
                34.0068767
              ],
              [
                48.476133,
                34.0068767
              ],
              [
                48.4811327,
                34.0090971
              ],
              [
                48.4830761,
                34.0102073
              ],
              [
                48.5114124,
                34.0441008
              ],
              [
                48.5194655,
                34.0507621
              ],
              [
                48.520299,
                34.0568728
              ],
              [
                48.520022,
                34.0571525
              ],
              [
                48.5191887,
                34.0604832
              ],
              [
                48.5189121,
                34.0632632
              ],
              [
                48.5189122,
                34.0652127
              ],
              [
                48.5186321,
                34.0660431
              ],
              [
                48.5191887,
                34.0874347
              ],
              [
                48.5197453,
                34.0938251
              ],
              [
                48.5214122,
                34.100766
              ],
              [
                48.5258551,
                34.1065967
              ],
              [
                48.5269684,
                34.1071563
              ],
              [
                48.5344687,
                34.1077069
              ],
              [
                48.5364115,
                34.1074361
              ],
              [
                48.5405785,
                34.1054865
              ],
              [
                48.5414117,
                34.1052158
              ],
              [
                48.5414117,
                34.1054865
              ],
              [
                48.5416918,
                34.1104868
              ],
              [
                48.5414117,
                34.1107666
              ],
              [
                48.5411351,
                34.1135466
              ],
              [
                48.5408586,
                34.1154871
              ],
              [
                48.5405785,
                34.1177165
              ],
              [
                48.5403019,
                34.1190974
              ],
              [
                48.5400218,
                34.1199278
              ],
              [
                48.5397448,
                34.1207673
              ],
              [
                48.5372452,
                34.131878
              ],
              [
                48.5316884,
                34.1388186
              ],
              [
                48.5280786,
                34.1407682
              ],
              [
                48.5275219,
                34.1407682
              ],
              [
                48.5275219,
                34.141048
              ],
              [
                48.5264117,
                34.1413278
              ],
              [
                48.5247453,
                34.1415986
              ],
              [
                48.5152986,
                34.146328
              ],
              [
                48.5130786,
                34.1504888
              ],
              [
                48.5127985,
                34.1513282
              ],
              [
                48.5155786,
                34.1624387
              ],
              [
                48.508632,
                34.1707694
              ],
              [
                48.5083554,
                34.1713198
              ],
              [
                48.5079854,
                34.1717862
              ],
              [
                48.506412,
                34.1740998
              ],
              [
                48.5061319,
                34.1749301
              ],
              [
                48.5061319,
                34.1774392
              ],
              [
                48.506412,
                34.1796595
              ],
              [
                48.5091886,
                34.1893799
              ],
              [
                48.5097452,
                34.1954901
              ],
              [
                48.5080788,
                34.1993801
              ],
              [
                48.5016887,
                34.20327
              ],
              [
                48.5008552,
                34.20327
              ],
              [
                48.5002985,
                34.2035498
              ],
              [
                48.4980754,
                34.2035498
              ],
              [
                48.4977989,
                34.2038296
              ],
              [
                48.4972418,
                34.2038296
              ],
              [
                48.4950222,
                34.2066004
              ],
              [
                48.4950222,
                34.20716
              ],
              [
                48.4947421,
                34.2074308
              ],
              [
                48.4944652,
                34.2088207
              ],
              [
                48.4944652,
                34.2102106
              ],
              [
                48.4925933,
                34.2114179
              ],
              [
                48.4905752,
                34.2127196
              ],
              [
                48.4886322,
                34.2135499
              ],
              [
                48.4880756,
                34.2135499
              ],
              [
                48.4880756,
                34.2138297
              ],
              [
                48.4875221,
                34.2138297
              ],
              [
                48.4872419,
                34.2141004
              ],
              [
                48.4858556,
                34.21466
              ],
              [
                48.4836322,
                34.2146601
              ],
              [
                48.4833521,
                34.2149398
              ],
              [
                48.4822423,
                34.2149398
              ],
              [
                48.4780754,
                34.2166004
              ],
              [
                48.4675188,
                34.2299399
              ],
              [
                48.4675188,
                34.2304904
              ],
              [
                48.4564092,
                34.24216
              ],
              [
                48.4550189,
                34.2435498
              ],
              [
                48.4497427,
                34.2491004
              ],
              [
                48.4369627,
                34.2577103
              ],
              [
                48.4183494,
                34.2588204
              ],
              [
                48.4180729,
                34.2591002
              ],
              [
                48.4147396,
                34.2591001
              ],
              [
                48.414183,
                34.2593799
              ],
              [
                48.4130728,
                34.2593799
              ],
              [
                48.4097395,
                34.2610496
              ],
              [
                48.4091827,
                34.2616
              ],
              [
                48.4086261,
                34.2618798
              ],
              [
                48.4036265,
                34.2671596
              ],
              [
                48.4030729,
                34.2674393
              ],
              [
                48.3994595,
                34.273829
              ],
              [
                48.3986263,
                34.2754897
              ],
              [
                48.3986263,
                34.2760492
              ],
              [
                48.3933496,
                34.2899387
              ],
              [
                48.3883498,
                34.2974384
              ],
              [
                48.3791832,
                34.3021584
              ],
              [
                48.3777934,
                34.3040987
              ],
              [
                48.3789032,
                34.3060482
              ],
              [
                48.3797363,
                34.3060482
              ],
              [
                48.3811266,
                34.3068785
              ],
              [
                48.3819599,
                34.3071581
              ],
              [
                48.3964063,
                34.3154882
              ],
              [
                48.3972394,
                34.3207768
              ],
              [
                48.3969597,
                34.3210475
              ],
              [
                48.3939061,
                34.3299369
              ],
              [
                48.3936264,
                34.3307762
              ],
              [
                48.3933494,
                34.3316066
              ],
              [
                48.3930729,
                34.3332671
              ],
              [
                48.3927928,
                34.3343862
              ],
              [
                48.3925162,
                34.3354962
              ],
              [
                48.3925162,
                34.336886
              ],
              [
                48.3714032,
                34.3543848
              ],
              [
                48.3708466,
                34.3546646
              ],
              [
                48.3705697,
                34.3554948
              ],
              [
                48.3700129,
                34.3557747
              ],
              [
                48.3694599,
                34.3568846
              ],
              [
                48.3686266,
                34.3582744
              ],
              [
                48.367793,
                34.3604945
              ],
              [
                48.3675133,
                34.3607743
              ],
              [
                48.3669597,
                34.3618843
              ],
              [
                48.3664031,
                34.3635539
              ],
              [
                48.35946,
                34.3710533
              ],
              [
                48.3519566,
                34.3804929
              ],
              [
                48.34668,
                34.3832724
              ],
              [
                48.3452901,
                34.3832724
              ],
              [
                48.3447366,
                34.3835522
              ],
              [
                48.3439034,
                34.3835521
              ],
              [
                48.3436233,
                34.3838319
              ],
              [
                48.3425135,
                34.383832
              ],
              [
                48.3422369,
                34.3841117
              ],
              [
                48.3394568,
                34.3841117
              ],
              [
                48.33779,
                34.3843824
              ],
              [
                48.3369567,
                34.3846622
              ],
              [
                48.3350134,
                34.3846622
              ],
              [
                48.3344567,
                34.3849329
              ],
              [
                48.3336234,
                34.3849329
              ],
              [
                48.3330668,
                34.3849329
              ],
              [
                48.3327902,
                34.3852127
              ],
              [
                48.331957,
                34.3852126
              ],
              [
                48.3302901,
                34.3860519
              ],
              [
                48.3191803,
                34.3891022
              ],
              [
                48.3150137,
                34.3879922
              ],
              [
                48.3136238,
                34.3871619
              ],
              [
                48.3069573,
                34.379112
              ],
              [
                48.3064006,
                34.3791121
              ],
              [
                48.3064007,
                34.3788323
              ],
              [
                48.2955673,
                34.3774425
              ],
              [
                48.2939009,
                34.3777132
              ],
              [
                48.2930672,
                34.377993
              ],
              [
                48.2914007,
                34.377993
              ],
              [
                48.2677877,
                34.3866023
              ],
              [
                48.2672311,
                34.386882
              ],
              [
                48.2666776,
                34.3874416
              ],
              [
                48.2663974,
                34.3877213
              ],
              [
                48.2655642,
                34.3882718
              ],
              [
                48.2650111,
                34.3891021
              ],
              [
                48.2641779,
                34.3893818
              ],
              [
                48.2638978,
                34.3899413
              ],
              [
                48.2561211,
                34.3927208
              ],
              [
                48.2527878,
                34.3927209
              ],
              [
                48.2508413,
                34.3921613
              ],
              [
                48.2494546,
                34.3921613
              ],
              [
                48.249082,
                34.3919741
              ],
              [
                48.2483413,
                34.3918816
              ],
              [
                48.2300081,
                34.3841114
              ],
              [
                48.2294515,
                34.3838317
              ],
              [
                48.2244513,
                34.3838317
              ],
              [
                48.2238982,
                34.3835519
              ],
              [
                48.2213981,
                34.3835519
              ],
              [
                48.2186184,
                34.3838317
              ],
              [
                48.2177848,
                34.3841114
              ],
              [
                48.2169516,
                34.3841114
              ],
              [
                48.2033419,
                34.3930005
              ],
              [
                48.1911185,
                34.3954913
              ],
              [
                48.1905619,
                34.395771
              ],
              [
                48.1894522,
                34.395771
              ],
              [
                48.1858388,
                34.3971607
              ],
              [
                48.1850051,
                34.3971607
              ],
              [
                48.1752819,
                34.40355
              ],
              [
                48.1747287,
                34.4043802
              ],
              [
                48.1741721,
                34.40466
              ],
              [
                48.1741722,
                34.4049397
              ],
              [
                48.1644489,
                34.4171678
              ],
              [
                48.163059,
                34.4182687
              ],
              [
                48.1530591,
                34.4313268
              ],
              [
                48.1525056,
                34.4321569
              ],
              [
                48.1477824,
                34.4346658
              ],
              [
                48.1444491,
                34.4346657
              ],
              [
                48.1438925,
                34.434386
              ],
              [
                48.1425022,
                34.434386
              ],
              [
                48.1383357,
                34.4324367
              ],
              [
                48.1375025,
                34.4318863
              ],
              [
                48.137226,
                34.4316064
              ],
              [
                48.1327825,
                34.4293865
              ],
              [
                48.1319493,
                34.4291068
              ],
              [
                48.1294492,
                34.4291067
              ],
              [
                48.1233358,
                34.4321569
              ],
              [
                48.1180595,
                34.4338264
              ],
              [
                48.117226,
                34.4341062
              ],
              [
                48.113336,
                34.4341061
              ],
              [
                48.1111129,
                34.4341061
              ],
              [
                48.093613,
                34.4318861
              ],
              [
                48.090883,
                34.4327841
              ],
              [
                48.0905562,
                34.4329962
              ],
              [
                48.0905563,
                34.4321569
              ],
              [
                48.0858332,
                34.4182685
              ],
              [
                48.0836131,
                34.4160485
              ],
              [
                48.0802799,
                34.414379
              ],
              [
                48.0758333,
                34.413278
              ],
              [
                48.0744466,
                34.4132781
              ],
              [
                48.07389,
                34.4129982
              ],
              [
                48.06111,
                34.4085492
              ],
              [
                48.0572236,
                34.4016094
              ],
              [
                48.0558337,
                34.39883
              ],
              [
                48.0555568,
                34.3985502
              ],
              [
                48.047777,
                34.3907711
              ],
              [
                48.0458336,
                34.3899408
              ],
              [
                48.0444437,
                34.3899409
              ],
              [
                48.0444438,
                34.3896611
              ],
              [
                48.0408339,
                34.3896611
              ],
              [
                48.0402772,
                34.3899408
              ],
              [
                48.0344439,
                34.3907711
              ],
              [
                48.019444,
                34.3968806
              ],
              [
                48.0186107,
                34.3974401
              ],
              [
                48.0172209,
                34.3982703
              ],
              [
                48.0166642,
                34.3982703
              ],
              [
                48.0149973,
                34.3982704
              ],
              [
                48.0144442,
                34.3985501
              ],
              [
                48.0136107,
                34.3985502
              ],
              [
                48.0130539,
                34.3988299
              ],
              [
                48.0013878,
                34.4013296
              ],
              [
                47.9985594,
                34.4014534
              ],
              [
                47.9905181,
                34.4017389
              ],
              [
                47.9901187,
                34.4015108
              ],
              [
                47.989713,
                34.4013069
              ],
              [
                47.989441,
                34.4010498
              ],
              [
                47.9886078,
                34.3979905
              ],
              [
                47.9936287,
                34.364661
              ],
              [
                47.9783315,
                34.3596544
              ],
              [
                47.9777745,
                34.3593836
              ],
              [
                47.9633281,
                34.3552142
              ],
              [
                47.9524951,
                34.3454946
              ],
              [
                47.9502716,
                34.3393759
              ],
              [
                47.9452719,
                34.3268856
              ],
              [
                47.9408286,
                34.3196567
              ],
              [
                47.916659,
                34.2977172
              ],
              [
                47.9138824,
                34.2957678
              ],
              [
                47.9138824,
                34.295488
              ],
              [
                47.9066592,
                34.2813278
              ],
              [
                47.901106,
                34.2732683
              ],
              [
                47.8927691,
                34.2679887
              ],
              [
                47.8916594,
                34.2679887
              ],
              [
                47.8916594,
                34.2677089
              ],
              [
                47.8877695,
                34.2618787
              ],
              [
                47.8866593,
                34.2552092
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555253,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان همدان",
          "name:en": "Hamedan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1279518",
          "wikipedia": "en:Hamadan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                48.3527922,
                34.7658012
              ],
              [
                48.3538591,
                34.7659607
              ],
              [
                48.3558227,
                34.7664542
              ],
              [
                48.35683,
                34.7663685
              ],
              [
                48.3574033,
                34.7662979
              ],
              [
                48.3584956,
                34.7661241
              ],
              [
                48.3626599,
                34.7654134
              ],
              [
                48.3670603,
                34.7640504
              ],
              [
                48.3697258,
                34.7622285
              ],
              [
                48.3754544,
                34.7602761
              ],
              [
                48.379824,
                34.7574864
              ],
              [
                48.3837763,
                34.757538
              ],
              [
                48.3869346,
                34.75833
              ],
              [
                48.3901351,
                34.7570368
              ],
              [
                48.3945185,
                34.7555758
              ],
              [
                48.3935921,
                34.755028
              ],
              [
                48.3934449,
                34.753945
              ],
              [
                48.393456,
                34.7529255
              ],
              [
                48.3944613,
                34.7488162
              ],
              [
                48.3967297,
                34.7476574
              ],
              [
                48.3990152,
                34.7473932
              ],
              [
                48.4053765,
                34.744396
              ],
              [
                48.4073517,
                34.7413821
              ],
              [
                48.4146163,
                34.7319567
              ],
              [
                48.4206363,
                34.7239597
              ],
              [
                48.4304206,
                34.7133377
              ],
              [
                48.4327376,
                34.7124004
              ],
              [
                48.4337658,
                34.7117064
              ],
              [
                48.4379268,
                34.7070401
              ],
              [
                48.438648,
                34.7062298
              ],
              [
                48.4389011,
                34.7060356
              ],
              [
                48.4393075,
                34.7056441
              ],
              [
                48.4398428,
                34.7051703
              ],
              [
                48.4453227,
                34.6994237
              ],
              [
                48.44679,
                34.6977536
              ],
              [
                48.4476073,
                34.6968209
              ],
              [
                48.4486471,
                34.6942248
              ],
              [
                48.4494613,
                34.6932291
              ],
              [
                48.4505221,
                34.6926995
              ],
              [
                48.4561703,
                34.6923119
              ],
              [
                48.4629245,
                34.6885476
              ],
              [
                48.4672423,
                34.6847135
              ],
              [
                48.4714205,
                34.6835846
              ],
              [
                48.4739074,
                34.6785546
              ],
              [
                48.4734293,
                34.6765257
              ],
              [
                48.4738029,
                34.6756623
              ],
              [
                48.4757356,
                34.672062
              ],
              [
                48.4782772,
                34.6679168
              ],
              [
                48.4786216,
                34.6678932
              ],
              [
                48.4792662,
                34.6679278
              ],
              [
                48.4811242,
                34.6681871
              ],
              [
                48.4831398,
                34.66651
              ],
              [
                48.4849163,
                34.6654534
              ],
              [
                48.4870015,
                34.6634108
              ],
              [
                48.4887941,
                34.6618191
              ],
              [
                48.4958057,
                34.6572507
              ],
              [
                48.4957684,
                34.6560487
              ],
              [
                48.495391,
                34.6539767
              ],
              [
                48.4952161,
                34.6523165
              ],
              [
                48.4950106,
                34.6497469
              ],
              [
                48.4948352,
                34.6465588
              ],
              [
                48.4969147,
                34.6422025
              ],
              [
                48.5033091,
                34.636912
              ],
              [
                48.5049432,
                34.6356411
              ],
              [
                48.5075136,
                34.6302867
              ],
              [
                48.508627,
                34.6290533
              ],
              [
                48.5095674,
                34.6281879
              ],
              [
                48.5124932,
                34.6247079
              ],
              [
                48.51406,
                34.6205988
              ],
              [
                48.5178494,
                34.6179717
              ],
              [
                48.5197732,
                34.6149102
              ],
              [
                48.5232259,
                34.6110017
              ],
              [
                48.5278006,
                34.6082743
              ],
              [
                48.5297436,
                34.6080036
              ],
              [
                48.5322436,
                34.6080036
              ],
              [
                48.5350202,
                34.6074442
              ],
              [
                48.5389102,
                34.6024452
              ],
              [
                48.5400204,
                34.6018859
              ],
              [
                48.5408571,
                34.6018859
              ],
              [
                48.5414102,
                34.6016061
              ],
              [
                48.5416904,
                34.6013354
              ],
              [
                48.5422435,
                34.6013355
              ],
              [
                48.5430767,
                34.6010557
              ],
              [
                48.5458569,
                34.6010557
              ],
              [
                48.5494666,
                34.5999459
              ],
              [
                48.5519668,
                34.5999459
              ],
              [
                48.5669666,
                34.5946672
              ],
              [
                48.5675233,
                34.5941169
              ],
              [
                48.5683565,
                34.5941169
              ],
              [
                48.5686331,
                34.5938371
              ],
              [
                48.5697468,
                34.5938371
              ],
              [
                48.5700233,
                34.5935574
              ],
              [
                48.5744664,
                34.5935574
              ],
              [
                48.5752996,
                34.5938371
              ],
              [
                48.5808564,
                34.5938371
              ],
              [
                48.5883561,
                34.5954975
              ],
              [
                48.5903031,
                34.5954975
              ],
              [
                48.5911363,
                34.5957772
              ],
              [
                48.5936364,
                34.5957772
              ],
              [
                48.5969697,
                34.5963276
              ],
              [
                48.6030795,
                34.5974465
              ],
              [
                48.6066929,
                34.5974466
              ],
              [
                48.6069695,
                34.5971668
              ],
              [
                48.6083593,
                34.5971668
              ],
              [
                48.6089128,
                34.5968871
              ],
              [
                48.6103027,
                34.5968871
              ],
              [
                48.611136,
                34.5966074
              ],
              [
                48.6130794,
                34.5966074
              ],
              [
                48.613636,
                34.5963276
              ],
              [
                48.6247492,
                34.5935575
              ],
              [
                48.6269691,
                34.5927184
              ],
              [
                48.6272492,
                34.5927184
              ],
              [
                48.6280824,
                34.5924476
              ],
              [
                48.6286359,
                34.5924476
              ],
              [
                48.628916,
                34.5921679
              ],
              [
                48.6294691,
                34.592168
              ],
              [
                48.6294691,
                34.5918882
              ],
              [
                48.6350259,
                34.5893887
              ],
              [
                48.6369724,
                34.5893888
              ],
              [
                48.6380826,
                34.589109
              ],
              [
                48.6400256,
                34.5891091
              ],
              [
                48.6405823,
                34.5893888
              ],
              [
                48.6422492,
                34.5893887
              ],
              [
                48.6425256,
                34.589109
              ],
              [
                48.643639,
                34.589109
              ],
              [
                48.6441925,
                34.5893887
              ],
              [
                48.646139,
                34.5893887
              ],
              [
                48.6466922,
                34.5896684
              ],
              [
                48.6505825,
                34.5896685
              ],
              [
                48.6511391,
                34.5893887
              ],
              [
                48.6525255,
                34.5893887
              ],
              [
                48.6566956,
                34.5882789
              ],
              [
                48.6605823,
                34.5879992
              ],
              [
                48.6608623,
                34.5882789
              ],
              [
                48.6625288,
                34.5882789
              ],
              [
                48.663639,
                34.5888384
              ],
              [
                48.6639156,
                34.5891091
              ],
              [
                48.6640556,
                34.5895287
              ],
              [
                48.6647487,
                34.5907784
              ],
              [
                48.6653054,
                34.5916085
              ],
              [
                48.6805853,
                34.6207807
              ],
              [
                48.6808619,
                34.6221703
              ],
              [
                48.6811385,
                34.6260593
              ],
              [
                48.6811384,
                34.6324477
              ],
              [
                48.6808619,
                34.6338372
              ],
              [
                48.6803052,
                34.6352268
              ],
              [
                48.6803052,
                34.6355065
              ],
              [
                48.6669721,
                34.6591107
              ],
              [
                48.6653052,
                34.6649485
              ],
              [
                48.666972,
                34.6732857
              ],
              [
                48.6680818,
                34.6752256
              ],
              [
                48.6683618,
                34.6755053
              ],
              [
                48.6700283,
                34.6755053
              ],
              [
                48.6725283,
                34.6755053
              ],
              [
                48.673085,
                34.6752256
              ],
              [
                48.6814185,
                34.6752257
              ],
              [
                48.681695,
                34.674946
              ],
              [
                48.6903049,
                34.6727263
              ],
              [
                48.6922515,
                34.6727262
              ],
              [
                48.6997516,
                34.6713367
              ],
              [
                48.7014181,
                34.6713368
              ],
              [
                48.7044748,
                34.6705067
              ],
              [
                48.7058615,
                34.6705067
              ],
              [
                48.7064181,
                34.670227
              ],
              [
                48.7086412,
                34.670227
              ],
              [
                48.7094749,
                34.6699472
              ],
              [
                48.7111413,
                34.6699473
              ],
              [
                48.7114179,
                34.6696676
              ],
              [
                48.718918,
                34.6696676
              ],
              [
                48.7197513,
                34.6693879
              ],
              [
                48.7219743,
                34.6693879
              ],
              [
                48.7222513,
                34.6691082
              ],
              [
                48.7325312,
                34.6685578
              ],
              [
                48.7339211,
                34.6682781
              ],
              [
                48.7355879,
                34.6682781
              ],
              [
                48.7361411,
                34.6679984
              ],
              [
                48.7375309,
                34.6679984
              ],
              [
                48.7380875,
                34.6677187
              ],
              [
                48.7516976,
                34.6660586
              ],
              [
                48.7541972,
                34.6660585
              ],
              [
                48.7564207,
                34.6654991
              ],
              [
                48.7603107,
                34.6652284
              ],
              [
                48.7825338,
                34.6652284
              ],
              [
                48.7830869,
                34.6649488
              ],
              [
                48.7950337,
                34.6649488
              ],
              [
                48.7958669,
                34.6646691
              ],
              [
                48.7972571,
                34.664669
              ],
              [
                48.8017002,
                34.6632796
              ],
              [
                48.8030901,
                34.6627291
              ],
              [
                48.8117,
                34.6549424
              ],
              [
                48.8133669,
                34.6468849
              ],
              [
                48.813647,
                34.645775
              ],
              [
                48.8142001,
                34.6424455
              ],
              [
                48.8144802,
                34.6396664
              ],
              [
                48.8147568,
                34.637167
              ],
              [
                48.8175334,
                34.6343879
              ],
              [
                48.8214234,
                34.6343879
              ],
              [
                48.82198,
                34.6346676
              ],
              [
                48.8233667,
                34.6346676
              ],
              [
                48.8239234,
                34.6349474
              ],
              [
                48.8253133,
                34.6349473
              ],
              [
                48.8255899,
                34.6352271
              ],
              [
                48.8272567,
                34.6352271
              ],
              [
                48.8292032,
                34.6357865
              ],
              [
                48.8311466,
                34.6360572
              ],
              [
                48.8353131,
                34.6377265
              ],
              [
                48.8367033,
                34.6377264
              ],
              [
                48.8425366,
                34.6405055
              ],
              [
                48.8650363,
                34.6527228
              ],
              [
                48.8661496,
                34.6527228
              ],
              [
                48.871983,
                34.6543921
              ],
              [
                48.8725361,
                34.6541123
              ],
              [
                48.873926,
                34.6541124
              ],
              [
                48.8742026,
                34.6538326
              ],
              [
                48.8755928,
                34.653562
              ],
              [
                48.8772593,
                34.653562
              ],
              [
                48.8805924,
                34.6527228
              ],
              [
                48.882816,
                34.6518927
              ],
              [
                48.8833726,
                34.6518927
              ],
              [
                48.8869825,
                34.6507829
              ],
              [
                48.8889259,
                34.6507829
              ],
              [
                48.889206,
                34.6505032
              ],
              [
                48.8897591,
                34.6505032
              ],
              [
                48.8903157,
                34.6502234
              ],
              [
                48.8908724,
                34.6499438
              ],
              [
                48.8939256,
                34.6491137
              ],
              [
                48.8953159,
                34.6491137
              ],
              [
                48.8961491,
                34.648834
              ],
              [
                48.9008722,
                34.648834
              ],
              [
                48.9011491,
                34.6491137
              ],
              [
                48.9028156,
                34.6491137
              ],
              [
                48.9033722,
                34.6491137
              ],
              [
                48.9039289,
                34.6493934
              ],
              [
                48.9047625,
                34.6493934
              ],
              [
                48.917539,
                34.6552222
              ],
              [
                48.9183722,
                34.6560524
              ],
              [
                48.9275387,
                34.6607804
              ],
              [
                48.928372,
                34.6607805
              ],
              [
                48.9297618,
                34.6616195
              ],
              [
                48.9405953,
                34.6643896
              ],
              [
                48.9428184,
                34.6643896
              ],
              [
                48.9430953,
                34.6646693
              ],
              [
                48.9575417,
                34.6646694
              ],
              [
                48.9597648,
                34.6643897
              ],
              [
                48.9933744,
                34.6574421
              ],
              [
                48.9964312,
                34.6532825
              ],
              [
                48.9969878,
                34.6510628
              ],
              [
                48.9942112,
                34.6441151
              ],
              [
                48.9933745,
                34.6421662
              ],
              [
                48.993098,
                34.6410563
              ],
              [
                48.9889315,
                34.6235605
              ],
              [
                48.9825416,
                34.6141132
              ],
              [
                48.9828217,
                34.613274
              ],
              [
                48.990598,
                34.6085549
              ],
              [
                48.9919879,
                34.6077248
              ],
              [
                48.993098,
                34.6068856
              ],
              [
                48.9967114,
                34.6005062
              ],
              [
                49.0011545,
                34.5974473
              ],
              [
                49.0028213,
                34.5991166
              ],
              [
                49.0097644,
                34.601607
              ],
              [
                49.0097644,
                34.6018868
              ],
              [
                49.0114313,
                34.6018867
              ],
              [
                49.0186544,
                34.6060555
              ],
              [
                49.0197677,
                34.6077248
              ],
              [
                49.0208775,
                34.6093941
              ],
              [
                49.0239342,
                34.6121643
              ],
              [
                49.0311543,
                34.6132742
              ],
              [
                49.0319911,
                34.6135538
              ],
              [
                49.0356008,
                34.6135539
              ],
              [
                49.0383775,
                34.614393
              ],
              [
                49.0397673,
                34.614393
              ],
              [
                49.0442108,
                34.6163331
              ],
              [
                49.0550473,
                34.6329988
              ],
              [
                49.060047,
                34.6349478
              ],
              [
                49.0619904,
                34.6349478
              ],
              [
                49.0625471,
                34.634668
              ],
              [
                49.0633803,
                34.6346681
              ],
              [
                49.0672671,
                34.6329988
              ],
              [
                49.0683804,
                34.6321687
              ],
              [
                49.0700468,
                34.6285595
              ],
              [
                49.0700468,
                34.6227215
              ],
              [
                49.0742138,
                34.6055052
              ],
              [
                49.0742138,
                34.5932786
              ],
              [
                49.0739373,
                34.5924485
              ],
              [
                49.0742138,
                34.5916093
              ],
              [
                49.0739372,
                34.5907792
              ],
              [
                49.0742139,
                34.5902288
              ],
              [
                49.0753236,
                34.588
              ],
              [
                49.0775471,
                34.58606
              ],
              [
                49.0800472,
                34.5852298
              ],
              [
                49.0803237,
                34.5849501
              ],
              [
                49.0808804,
                34.58495
              ],
              [
                49.0811569,
                34.5846704
              ],
              [
                49.0825468,
                34.5846704
              ],
              [
                49.0831035,
                34.5843906
              ],
              [
                49.0864372,
                34.5843907
              ],
              [
                49.0869903,
                34.5846704
              ],
              [
                49.090047,
                34.5846704
              ],
              [
                49.0906036,
                34.5849501
              ],
              [
                49.0933803,
                34.5849501
              ],
              [
                49.0939369,
                34.5852298
              ],
              [
                49.0972702,
                34.5852299
              ],
              [
                49.0994937,
                34.5855006
              ],
              [
                49.1003269,
                34.5857803
              ],
              [
                49.1028269,
                34.5857803
              ],
              [
                49.1056036,
                34.5863307
              ],
              [
                49.1061601,
                34.5866104
              ],
              [
                49.1069934,
                34.5866104
              ],
              [
                49.118103,
                34.5960579
              ],
              [
                49.1189367,
                34.5963286
              ],
              [
                49.1197698,
                34.5968881
              ],
              [
                49.1203265,
                34.5971678
              ],
              [
                49.1278262,
                34.6030058
              ],
              [
                49.1347728,
                34.6135541
              ],
              [
                49.1356064,
                34.6182732
              ],
              [
                49.1353263,
                34.6188326
              ],
              [
                49.1350498,
                34.6205019
              ],
              [
                49.1347728,
                34.6221712
              ],
              [
                49.1350497,
                34.6280001
              ],
              [
                49.1353263,
                34.629119
              ],
              [
                49.1328262,
                34.6366172
              ],
              [
                49.1350497,
                34.6480043
              ],
              [
                49.1336594,
                34.6552226
              ],
              [
                49.1336593,
                34.6599507
              ],
              [
                49.1333829,
                34.6605011
              ],
              [
                49.1331063,
                34.6635599
              ],
              [
                49.1328262,
                34.6652291
              ],
              [
                49.1325496,
                34.6668893
              ],
              [
                49.1322729,
                34.6682788
              ],
              [
                49.1319929,
                34.6693887
              ],
              [
                49.1317159,
                34.6716173
              ],
              [
                49.1317159,
                34.6735572
              ],
              [
                49.1317159,
                34.6741167
              ],
              [
                49.1314394,
                34.6743963
              ],
              [
                49.1314394,
                34.6760656
              ],
              [
                49.1311593,
                34.676616
              ],
              [
                49.1281061,
                34.6860629
              ],
              [
                49.1244927,
                34.6943908
              ],
              [
                49.1239361,
                34.6952299
              ],
              [
                49.1211594,
                34.6996692
              ],
              [
                49.1056032,
                34.7274497
              ],
              [
                49.1050462,
                34.7280092
              ],
              [
                49.1025464,
                34.7377264
              ],
              [
                49.1028265,
                34.7505111
              ],
              [
                49.1031031,
                34.7535606
              ],
              [
                49.1033795,
                34.7555095
              ],
              [
                49.1072695,
                34.7646762
              ],
              [
                49.1072695,
                34.7649559
              ],
              [
                49.1086594,
                34.7663363
              ],
              [
                49.1089363,
                34.766616
              ],
              [
                49.1153259,
                34.772733
              ],
              [
                49.1392158,
                34.788558
              ],
              [
                49.1425491,
                34.7910662
              ],
              [
                49.1492156,
                34.7971742
              ],
              [
                49.1544954,
                34.8066203
              ],
              [
                49.1575488,
                34.8285617
              ],
              [
                49.1586622,
                34.8318998
              ],
              [
                49.1586622,
                34.8327298
              ],
              [
                49.1619955,
                34.8391172
              ],
              [
                49.1639385,
                34.841896
              ],
              [
                49.1672721,
                34.8468941
              ],
              [
                49.1678287,
                34.8491224
              ],
              [
                49.1681053,
                34.8494021
              ],
              [
                49.1636618,
                34.8566195
              ],
              [
                49.1628287,
                34.8588388
              ],
              [
                49.1631052,
                34.8607875
              ],
              [
                49.1681052,
                34.8660652
              ],
              [
                49.1692186,
                34.8660651
              ],
              [
                49.1697717,
                34.8663448
              ],
              [
                49.1750519,
                34.8663448
              ],
              [
                49.1778285,
                34.8655149
              ],
              [
                49.1786617,
                34.8657855
              ],
              [
                49.1789383,
                34.8657855
              ],
              [
                49.1864416,
                34.8738418
              ],
              [
                49.1875518,
                34.8793991
              ],
              [
                49.1864415,
                34.8827281
              ],
              [
                49.1861615,
                34.8830077
              ],
              [
                49.1858848,
                34.8832874
              ],
              [
                49.1839415,
                34.8874553
              ],
              [
                49.1808852,
                34.8902339
              ],
              [
                49.1750519,
                34.9010596
              ],
              [
                49.1750518,
                34.9119033
              ],
              [
                49.1761616,
                34.9291159
              ],
              [
                49.175885,
                34.9296753
              ],
              [
                49.1758849,
                34.9302345
              ],
              [
                49.1647717,
                34.9446774
              ],
              [
                49.1481053,
                34.9741219
              ],
              [
                49.1472717,
                34.9766207
              ],
              [
                49.1389387,
                34.9996779
              ],
              [
                49.1125487,
                35.0074537
              ],
              [
                49.1050454,
                35.0105118
              ],
              [
                49.1042121,
                35.0105117
              ],
              [
                49.1008789,
                35.0121806
              ],
              [
                49.1003258,
                35.0121806
              ],
              [
                49.0997691,
                35.0127398
              ],
              [
                49.0989355,
                35.0127398
              ],
              [
                49.0972691,
                35.0138404
              ],
              [
                49.0936592,
                35.0149589
              ],
              [
                49.0931025,
                35.0149589
              ],
              [
                49.0928256,
                35.0152385
              ],
              [
                49.0922689,
                35.0152385
              ],
              [
                49.0697692,
                35.0219046
              ],
              [
                49.0692126,
                35.0219046
              ],
              [
                49.0661559,
                35.0227346
              ],
              [
                49.0614327,
                35.0241237
              ],
              [
                49.0600459,
                35.0241237
              ],
              [
                49.0580994,
                35.024683
              ],
              [
                49.0561561,
                35.024683
              ],
              [
                49.053933,
                35.0252332
              ],
              [
                49.0530993,
                35.0252333
              ],
              [
                49.0519895,
                35.0257926
              ],
              [
                49.0505997,
                35.0257926
              ],
              [
                49.0497661,
                35.0260721
              ],
              [
                49.0483762,
                35.0260722
              ],
              [
                49.0475429,
                35.0263427
              ],
              [
                49.0361564,
                35.0260721
              ],
              [
                49.0353232,
                35.0257924
              ],
              [
                49.0328231,
                35.0257925
              ],
              [
                49.0322664,
                35.0255128
              ],
              [
                49.0286531,
                35.0255129
              ],
              [
                49.0278199,
                35.0252332
              ],
              [
                49.0244865,
                35.0252332
              ],
              [
                49.0242097,
                35.0249535
              ],
              [
                49.0144868,
                35.024683
              ],
              [
                49.0117102,
                35.0249536
              ],
              [
                49.0111531,
                35.0252332
              ],
              [
                49.0097632,
                35.0252331
              ],
              [
                49.0092102,
                35.0255128
              ],
              [
                49.0069866,
                35.0255128
              ],
              [
                49.00643,
                35.0257925
              ],
              [
                49.0053202,
                35.0257924
              ],
              [
                49.0047636,
                35.0260721
              ],
              [
                49.0014303,
                35.026072
              ],
              [
                49.0005966,
                35.0263427
              ],
              [
                48.989207,
                35.0288414
              ],
              [
                48.9886534,
                35.029121
              ],
              [
                48.9878203,
                35.029121
              ],
              [
                48.9872635,
                35.0294006
              ],
              [
                48.9861538,
                35.0294006
              ],
              [
                48.9855971,
                35.0296803
              ],
              [
                48.9842068,
                35.0296802
              ],
              [
                48.9819869,
                35.0302304
              ],
              [
                48.9786537,
                35.0307898
              ],
              [
                48.9769871,
                35.0310694
              ],
              [
                48.9761539,
                35.0310693
              ],
              [
                48.9758739,
                35.031349
              ],
              [
                48.9744836,
                35.031349
              ],
              [
                48.9714305,
                35.0321789
              ],
              [
                48.970317,
                35.0321789
              ],
              [
                48.9655971,
                35.0335681
              ],
              [
                48.9644838,
                35.0335681
              ],
              [
                48.9617071,
                35.0343979
              ],
              [
                48.960874,
                35.0343979
              ],
              [
                48.9605974,
                35.0346775
              ],
              [
                48.9597638,
                35.0346776
              ],
              [
                48.9180945,
                35.0546757
              ],
              [
                48.9130944,
                35.0566241
              ],
              [
                48.9097611,
                35.0580132
              ],
              [
                48.8558684,
                35.0855158
              ],
              [
                48.8553119,
                35.0855159
              ],
              [
                48.8550349,
                35.0857864
              ],
              [
                48.8533684,
                35.0863457
              ],
              [
                48.8528118,
                35.0857864
              ],
              [
                48.8514251,
                35.0841176
              ],
              [
                48.8467019,
                35.0821783
              ],
              [
                48.8447585,
                35.0819077
              ],
              [
                48.8405885,
                35.0819077
              ],
              [
                48.8400354,
                35.0816281
              ],
              [
                48.8383686,
                35.0816281
              ],
              [
                48.8378119,
                35.0813485
              ],
              [
                48.8353118,
                35.0813485
              ],
              [
                48.8344786,
                35.0810688
              ],
              [
                48.8330887,
                35.0810688
              ],
              [
                48.8294789,
                35.0802389
              ],
              [
                48.8280887,
                35.080239
              ],
              [
                48.8272554,
                35.0799593
              ],
              [
                48.8244788,
                35.0799593
              ],
              [
                48.8241987,
                35.0796797
              ],
              [
                48.8219788,
                35.0796797
              ],
              [
                48.8214221,
                35.0794001
              ],
              [
                48.8191986,
                35.0794001
              ],
              [
                48.8186455,
                35.0791205
              ],
              [
                48.8128122,
                35.0785702
              ],
              [
                48.8116988,
                35.0780109
              ],
              [
                48.8108656,
                35.0780109
              ],
              [
                48.8044756,
                35.0766218
              ],
              [
                48.8030889,
                35.0766218
              ],
              [
                48.8025322,
                35.0763422
              ],
              [
                48.7969759,
                35.0757919
              ],
              [
                48.7925324,
                35.075792
              ],
              [
                48.7914227,
                35.0755123
              ],
              [
                48.7855858,
                35.0755123
              ],
              [
                48.7850326,
                35.0752326
              ],
              [
                48.7797524,
                35.0752327
              ],
              [
                48.7789193,
                35.0749531
              ],
              [
                48.7761426,
                35.074953
              ],
              [
                48.7722527,
                35.0746734
              ],
              [
                48.7686429,
                35.0741231
              ],
              [
                48.7589196,
                35.072734
              ],
              [
                48.7569762,
                35.072734
              ],
              [
                48.756143,
                35.0724544
              ],
              [
                48.7525297,
                35.0719042
              ],
              [
                48.7489198,
                35.0710652
              ],
              [
                48.7453065,
                35.0696761
              ],
              [
                48.7369731,
                35.0657975
              ],
              [
                48.7286402,
                35.0546753
              ],
              [
                48.725307,
                35.0457902
              ],
              [
                48.7241967,
                35.0421821
              ],
              [
                48.7158634,
                35.0221837
              ],
              [
                48.7153068,
                35.0143988
              ],
              [
                48.7155838,
                35.0132893
              ],
              [
                48.720307,
                35.0027352
              ],
              [
                48.7216969,
                35.0002184
              ],
              [
                48.7178069,
                34.9980083
              ],
              [
                48.7166971,
                34.9960688
              ],
              [
                48.7161405,
                34.9924515
              ],
              [
                48.7147502,
                34.9791187
              ],
              [
                48.7141971,
                34.9780092
              ],
              [
                48.7064173,
                34.9663451
              ],
              [
                48.7058607,
                34.9655061
              ],
              [
                48.7036407,
                34.9605085
              ],
              [
                48.7016938,
                34.9591193
              ],
              [
                48.7014172,
                34.9588396
              ],
              [
                48.6997507,
                34.9574504
              ],
              [
                48.6991942,
                34.9574504
              ],
              [
                48.6988394,
                34.9573717
              ],
              [
                48.6975273,
                34.9571707
              ],
              [
                48.6966941,
                34.9569001
              ],
              [
                48.6933608,
                34.9571707
              ],
              [
                48.6894709,
                34.9571707
              ],
              [
                48.6891939,
                34.9574503
              ],
              [
                48.6872509,
                34.9574503
              ],
              [
                48.6869708,
                34.95773
              ],
              [
                48.6855841,
                34.95773
              ],
              [
                48.6847509,
                34.9580096
              ],
              [
                48.683361,
                34.9580097
              ],
              [
                48.683084,
                34.9582893
              ],
              [
                48.6819708,
                34.9582892
              ],
              [
                48.6803042,
                34.9588396
              ],
              [
                48.6783608,
                34.9588396
              ],
              [
                48.6778042,
                34.9591192
              ],
              [
                48.6764175,
                34.9591192
              ],
              [
                48.6761374,
                34.9593989
              ],
              [
                48.6755843,
                34.9593988
              ],
              [
                48.6750276,
                34.9599582
              ],
              [
                48.6711377,
                34.962457
              ],
              [
                48.6614144,
                34.9724522
              ],
              [
                48.659471,
                34.9738414
              ],
              [
                48.6414146,
                34.9849551
              ],
              [
                48.6405811,
                34.984955
              ],
              [
                48.6397479,
                34.9855054
              ],
              [
                48.6389147,
                34.9855053
              ],
              [
                48.6322481,
                34.9882837
              ],
              [
                48.631968,
                34.9885634
              ],
              [
                48.631968,
                34.9899526
              ],
              [
                48.6316914,
                34.9896729
              ],
              [
                48.6019686,
                34.9746802
              ],
              [
                48.5947451,
                34.9699532
              ],
              [
                48.5930786,
                34.9691233
              ],
              [
                48.5864121,
                34.9671748
              ],
              [
                48.5853019,
                34.9671747
              ],
              [
                48.5850219,
                34.9668951
              ],
              [
                48.5836354,
                34.9668951
              ],
              [
                48.5825221,
                34.9663448
              ],
              [
                48.5816885,
                34.9663448
              ],
              [
                48.5455757,
                34.9574501
              ],
              [
                48.5439093,
                34.9574501
              ],
              [
                48.5416893,
                34.9568998
              ],
              [
                48.5402994,
                34.9568998
              ],
              [
                48.5397423,
                34.9566201
              ],
              [
                48.5375193,
                34.9566201
              ],
              [
                48.5369658,
                34.9566201
              ],
              [
                48.5361326,
                34.9566201
              ],
              [
                48.5352993,
                34.9563405
              ],
              [
                48.5336325,
                34.9563404
              ],
              [
                48.5319661,
                34.9560698
              ],
              [
                48.5297426,
                34.9560698
              ],
              [
                48.5291859,
                34.9557902
              ],
              [
                48.5280761,
                34.9557901
              ],
              [
                48.5255762,
                34.9549511
              ],
              [
                48.5244663,
                34.9549512
              ],
              [
                48.523076,
                34.9544009
              ],
              [
                48.5222428,
                34.9544009
              ],
              [
                48.5202963,
                34.9538416
              ],
              [
                48.5039096,
                34.9505128
              ],
              [
                48.5016865,
                34.9505128
              ],
              [
                48.5011299,
                34.9502331
              ],
              [
                48.5002963,
                34.9502331
              ],
              [
                48.4997396,
                34.9499535
              ],
              [
                48.4989064,
                34.9499535
              ],
              [
                48.4975197,
                34.9493942
              ],
              [
                48.4839065,
                34.9424479
              ],
              [
                48.4758502,
                34.9341214
              ],
              [
                48.4752966,
                34.9293942
              ],
              [
                48.4783004,
                34.9173837
              ],
              [
                48.4794635,
                34.9096737
              ],
              [
                48.4794636,
                34.9085641
              ],
              [
                48.4781657,
                34.9068018
              ],
              [
                48.4777967,
                34.9066155
              ],
              [
                48.470297,
                34.9032866
              ],
              [
                48.4516838,
                34.8860646
              ],
              [
                48.4420245,
                34.8834018
              ],
              [
                48.4414709,
                34.8833786
              ],
              [
                48.4401947,
                34.8826677
              ],
              [
                48.4392637,
                34.8810589
              ],
              [
                48.4377223,
                34.878276
              ],
              [
                48.4361083,
                34.8752394
              ],
              [
                48.423024,
                34.8666477
              ],
              [
                48.4075146,
                34.8613454
              ],
              [
                48.4069579,
                34.8602267
              ],
              [
                48.4066813,
                34.8593966
              ],
              [
                48.4044578,
                34.8557789
              ],
              [
                48.3936249,
                34.8391158
              ],
              [
                48.3827915,
                34.8280099
              ],
              [
                48.3777918,
                34.8260611
              ],
              [
                48.3714018,
                34.8227321
              ],
              [
                48.3711249,
                34.8221726
              ],
              [
                48.3686253,
                34.8205036
              ],
              [
                48.3683452,
                34.8199533
              ],
              [
                48.3639017,
                34.8143956
              ],
              [
                48.3616786,
                34.8099479
              ],
              [
                48.361402,
                34.8066188
              ],
              [
                48.356402,
                34.7766202
              ],
              [
                48.3558454,
                34.7752308
              ],
              [
                48.3527922,
                34.7658012
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 12225371,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان درگزین",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                49.0700453,
                35.2227407
              ],
              [
                49.0858784,
                35.2438542
              ],
              [
                49.0858783,
                35.2441338
              ],
              [
                49.0861553,
                35.2444043
              ],
              [
                49.0886585,
                35.2444044
              ],
              [
                49.088935,
                35.2446839
              ],
              [
                49.0972684,
                35.2446839
              ],
              [
                49.097825,
                35.2449636
              ],
              [
                49.0986583,
                35.244684
              ],
              [
                49.0989348,
                35.2449636
              ],
              [
                49.1047682,
                35.2449636
              ],
              [
                49.1053249,
                35.2452432
              ],
              [
                49.1061584,
                35.2449636
              ],
              [
                49.1069917,
                35.2452432
              ],
              [
                49.112825,
                35.2452431
              ],
              [
                49.1153246,
                35.2455138
              ],
              [
                49.1200482,
                35.2455138
              ],
              [
                49.1208814,
                35.2457934
              ],
              [
                49.1244913,
                35.2457933
              ],
              [
                49.1436576,
                35.248012
              ],
              [
                49.145048,
                35.2482916
              ],
              [
                49.1508809,
                35.2482917
              ],
              [
                49.1550477,
                35.2477415
              ],
              [
                49.1569942,
                35.2471823
              ],
              [
                49.1581044,
                35.2471823
              ],
              [
                49.1625474,
                35.2457934
              ],
              [
                49.1631041,
                35.2457934
              ],
              [
                49.1633807,
                35.2455138
              ],
              [
                49.1644944,
                35.2455138
              ],
              [
                49.1658843,
                35.2449637
              ],
              [
                49.1678277,
                35.2449637
              ],
              [
                49.1683844,
                35.2446841
              ],
              [
                49.1700508,
                35.2446841
              ],
              [
                49.1703274,
                35.2444045
              ],
              [
                49.1731039,
                35.2444045
              ],
              [
                49.1742173,
                35.2441339
              ],
              [
                49.1764373,
                35.244134
              ],
              [
                49.1767173,
                35.2435748
              ],
              [
                49.1803272,
                35.2424655
              ],
              [
                49.1808843,
                35.2424654
              ],
              [
                49.1811608,
                35.2421859
              ],
              [
                49.1825506,
                35.2421858
              ],
              [
                49.1932641,
                35.2296063
              ],
              [
                49.1938207,
                35.2293266
              ],
              [
                49.1952105,
                35.2293267
              ],
              [
                49.1954875,
                35.2290471
              ],
              [
                49.1968774,
                35.229047
              ],
              [
                49.1968774,
                35.2287675
              ],
              [
                49.2004873,
                35.2284969
              ],
              [
                49.2007674,
                35.2282173
              ],
              [
                49.2021541,
                35.2282172
              ],
              [
                49.2027107,
                35.2279377
              ],
              [
                49.2057674,
                35.2279376
              ],
              [
                49.2066007,
                35.227658
              ],
              [
                49.2214101,
                35.2172808
              ],
              [
                49.2219636,
                35.2170011
              ],
              [
                49.2266868,
                35.217001
              ],
              [
                49.2322436,
                35.2167305
              ],
              [
                49.2350202,
                35.2167306
              ],
              [
                49.2358534,
                35.2164508
              ],
              [
                49.2419668,
                35.2164509
              ],
              [
                49.2522432,
                35.215621
              ],
              [
                49.2555765,
                35.2158916
              ],
              [
                49.281413,
                35.2183905
              ],
              [
                49.2819696,
                35.2186701
              ],
              [
                49.3041157,
                35.22456
              ],
              [
                49.3052255,
                35.2248396
              ],
              [
                49.3066157,
                35.2245601
              ],
              [
                49.3071724,
                35.2248396
              ],
              [
                49.3088388,
                35.2248396
              ],
              [
                49.3093923,
                35.22456
              ],
              [
                49.309949,
                35.2248396
              ],
              [
                49.3121721,
                35.2248396
              ],
              [
                49.3130053,
                35.22456
              ],
              [
                49.3177289,
                35.2248396
              ],
              [
                49.3199488,
                35.2248397
              ],
              [
                49.3297084,
                35.2298869
              ],
              [
                49.3399852,
                35.2326914
              ],
              [
                49.3408184,
                35.2324118
              ],
              [
                49.3477117,
                35.2346552
              ],
              [
                49.3488219,
                35.2349348
              ],
              [
                49.3557649,
                35.2349348
              ],
              [
                49.3689631,
                35.2377292
              ],
              [
                49.3759063,
                35.2382883
              ],
              [
                49.3767399,
                35.238568
              ],
              [
                49.3831299,
                35.238578
              ],
              [
                49.3831299,
                35.2396773
              ],
              [
                49.3764484,
                35.2591327
              ],
              [
                49.3747816,
                35.2632994
              ],
              [
                49.3858607,
                35.2773207
              ],
              [
                49.3889174,
                35.2834365
              ],
              [
                49.3933608,
                35.2887132
              ],
              [
                49.3944706,
                35.2903821
              ],
              [
                49.4158604,
                35.3198329
              ],
              [
                49.4392833,
                35.3407177
              ],
              [
                49.4423396,
                35.3421073
              ],
              [
                49.4428931,
                35.3423871
              ],
              [
                49.4451631,
                35.352446
              ],
              [
                49.4559961,
                35.3646709
              ],
              [
                49.4673862,
                35.3735666
              ],
              [
                49.4684995,
                35.3752266
              ],
              [
                49.4687761,
                35.375786
              ],
              [
                49.4707195,
                35.3796745
              ],
              [
                49.472796,
                35.393249
              ],
              [
                49.4727961,
                35.3935198
              ],
              [
                49.4571875,
                35.4072409
              ],
              [
                49.4159888,
                35.4182933
              ],
              [
                49.4083096,
                35.4404832
              ],
              [
                49.4016431,
                35.444369
              ],
              [
                49.4008095,
                35.4443689
              ],
              [
                49.3999762,
                35.4449189
              ],
              [
                49.3988664,
                35.4449188
              ],
              [
                49.3985864,
                35.4452075
              ],
              [
                49.3960863,
                35.4457575
              ],
              [
                49.3946995,
                35.4457574
              ],
              [
                49.3941429,
                35.4454779
              ],
              [
                49.3926077,
                35.4453284
              ],
              [
                49.3913663,
                35.4452074
              ],
              [
                49.3913663,
                35.4449189
              ],
              [
                49.3782811,
                35.4486943
              ],
              [
                49.3760611,
                35.4492532
              ],
              [
                49.3755045,
                35.4495327
              ],
              [
                49.3732811,
                35.4498031
              ],
              [
                49.3518382,
                35.4467057
              ],
              [
                49.3468381,
                35.4478147
              ],
              [
                49.3326718,
                35.4547573
              ],
              [
                49.311722,
                35.4596937
              ],
              [
                49.3097785,
                35.4605232
              ],
              [
                49.3086652,
                35.4608027
              ],
              [
                49.2992221,
                35.4641391
              ],
              [
                49.2986654,
                35.4646892
              ],
              [
                49.2978322,
                35.4646892
              ],
              [
                49.2922754,
                35.4669073
              ],
              [
                49.290609,
                35.4669074
              ],
              [
                49.2900555,
                35.4671869
              ],
              [
                49.2872753,
                35.4671869
              ],
              [
                49.2867222,
                35.4674664
              ],
              [
                49.283942,
                35.4674664
              ],
              [
                49.281999,
                35.4680255
              ],
              [
                49.2808888,
                35.4680255
              ],
              [
                49.2800556,
                35.4685755
              ],
              [
                49.2789423,
                35.4685755
              ],
              [
                49.2692191,
                35.4727504
              ],
              [
                49.2672757,
                35.473021
              ],
              [
                49.266719,
                35.4727505
              ],
              [
                49.2656092,
                35.473021
              ],
              [
                49.2600525,
                35.4727505
              ],
              [
                49.2594993,
                35.4730209
              ],
              [
                49.2592192,
                35.4727505
              ],
              [
                49.2569957,
                35.4727504
              ],
              [
                49.2522762,
                35.4724709
              ],
              [
                49.2461627,
                35.4724708
              ],
              [
                49.2456092,
                35.4727504
              ],
              [
                49.2228297,
                35.4780254
              ],
              [
                49.2108831,
                35.4810821
              ],
              [
                49.2078299,
                35.4810822
              ],
              [
                49.2069967,
                35.4816412
              ],
              [
                49.2056063,
                35.4819117
              ],
              [
                49.2047732,
                35.4824707
              ],
              [
                49.1969932,
                35.4860775
              ],
              [
                49.1961596,
                35.4860775
              ],
              [
                49.1950499,
                35.4866366
              ],
              [
                49.1942167,
                35.4866366
              ],
              [
                49.1828265,
                35.4899729
              ],
              [
                49.1797699,
                35.4905229
              ],
              [
                49.1781034,
                35.4905229
              ],
              [
                49.1775503,
                35.4908025
              ],
              [
                49.1756034,
                35.4910729
              ],
              [
                49.1689368,
                35.4908024
              ],
              [
                49.1686603,
                35.4910728
              ],
              [
                49.1608804,
                35.4933001
              ],
              [
                49.1606034,
                35.4930205
              ],
              [
                49.1361573,
                35.4744094
              ],
              [
                49.1172675,
                35.4580251
              ],
              [
                49.1139342,
                35.4558069
              ],
              [
                49.0947678,
                35.4410815
              ],
              [
                49.0769882,
                35.418574
              ],
              [
                49.0764347,
                35.4119099
              ],
              [
                49.0767117,
                35.4110803
              ],
              [
                49.0781016,
                35.4083029
              ],
              [
                49.0781016,
                35.4080234
              ],
              [
                49.079768,
                35.4055165
              ],
              [
                49.0839349,
                35.396634
              ],
              [
                49.0844631,
                35.3950151
              ],
              [
                49.0847682,
                35.3932974
              ],
              [
                49.0853212,
                35.3919088
              ],
              [
                49.081988,
                35.3780213
              ],
              [
                49.0739352,
                35.3649632
              ],
              [
                49.0728215,
                35.3630244
              ],
              [
                49.0692116,
                35.3560805
              ],
              [
                49.068655,
                35.3558009
              ],
              [
                49.0619884,
                35.3457998
              ],
              [
                49.0547652,
                35.3338507
              ],
              [
                49.0544887,
                35.3324619
              ],
              [
                49.0536552,
                35.3263475
              ],
              [
                49.0530985,
                35.3235699
              ],
              [
                49.0525454,
                35.3213514
              ],
              [
                49.0517122,
                35.3196829
              ],
              [
                49.0517121,
                35.3188533
              ],
              [
                49.0411558,
                35.2963522
              ],
              [
                49.0355991,
                35.2882986
              ],
              [
                49.0319893,
                35.2810747
              ],
              [
                49.0311525,
                35.2785765
              ],
              [
                49.0308759,
                35.27496
              ],
              [
                49.0311525,
                35.2732915
              ],
              [
                49.0314325,
                35.2724618
              ],
              [
                49.0317092,
                35.2716321
              ],
              [
                49.0319892,
                35.2694045
              ],
              [
                49.0322658,
                35.269125
              ],
              [
                49.030876,
                35.2569045
              ],
              [
                49.0294856,
                35.2546858
              ],
              [
                49.0183762,
                35.2410762
              ],
              [
                49.0164327,
                35.2377392
              ],
              [
                49.0155995,
                35.2366298
              ],
              [
                49.0142092,
                35.2313537
              ],
              [
                49.0144862,
                35.2310741
              ],
              [
                49.0161526,
                35.2285759
              ],
              [
                49.0175426,
                35.2274575
              ],
              [
                49.0258759,
                35.2244091
              ],
              [
                49.0269857,
                35.2244091
              ],
              [
                49.030319,
                35.2235703
              ],
              [
                49.0464322,
                35.2210721
              ],
              [
                49.0489323,
                35.2210721
              ],
              [
                49.0497656,
                35.2207925
              ],
              [
                49.0533789,
                35.2207925
              ],
              [
                49.0539325,
                35.2205129
              ],
              [
                49.0580989,
                35.2205129
              ],
              [
                49.0603224,
                35.2207925
              ],
              [
                49.0617123,
                35.2207925
              ],
              [
                49.0619888,
                35.2210721
              ],
              [
                49.0628221,
                35.2210721
              ],
              [
                49.0644889,
                35.2216223
              ],
              [
                49.0658788,
                35.2216223
              ],
              [
                49.0672655,
                35.2221814
              ],
              [
                49.0680987,
                35.2221815
              ],
              [
                49.0700453,
                35.2227407
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 2513410403
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          48.8215749,
          34.2922623
        ]
      }
    }
  ]
},
"یزد.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554867,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان ابرکوه",
          "name:en": "Abarkuh County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286513",
          "wikipedia": "en:Abarkuh County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                52.8010566,
                31.4948743
              ],
              [
                52.8007765,
                31.4943236
              ],
              [
                52.8004999,
                31.4932131
              ],
              [
                52.8016099,
                31.4915429
              ],
              [
                52.8057766,
                31.4871011
              ],
              [
                52.8182797,
                31.4795988
              ],
              [
                52.8457793,
                31.4504294
              ],
              [
                52.8485593,
                31.4476488
              ],
              [
                52.864669,
                31.4370951
              ],
              [
                52.8657824,
                31.4368243
              ],
              [
                52.8874058,
                31.4286341
              ],
              [
                52.8880055,
                31.4284825
              ],
              [
                52.8885588,
                31.4282117
              ],
              [
                52.8896721,
                31.4282117
              ],
              [
                52.9041152,
                31.4237609
              ],
              [
                52.9068952,
                31.4226505
              ],
              [
                52.9346715,
                31.4048746
              ],
              [
                52.9507846,
                31.3898795
              ],
              [
                52.9516179,
                31.3884892
              ],
              [
                52.9627312,
                31.3745955
              ],
              [
                52.9655077,
                31.3695941
              ],
              [
                52.9680077,
                31.3643219
              ],
              [
                52.9682843,
                31.3626518
              ],
              [
                52.968841,
                31.3618213
              ],
              [
                52.9777308,
                31.3254308
              ],
              [
                52.9782876,
                31.3226504
              ],
              [
                52.9780075,
                31.3118172
              ],
              [
                52.9777309,
                31.3107068
              ],
              [
                52.9777309,
                31.3087569
              ],
              [
                52.9777309,
                31.3082063
              ],
              [
                52.9774509,
                31.3076555
              ],
              [
                52.9766176,
                31.3032049
              ],
              [
                52.9746743,
                31.2954323
              ],
              [
                52.9716178,
                31.2770885
              ],
              [
                52.9555079,
                31.2507104
              ],
              [
                52.9457847,
                31.240988
              ],
              [
                52.9288383,
                31.2345968
              ],
              [
                52.924395,
                31.2337572
              ],
              [
                52.9180051,
                31.2326468
              ],
              [
                52.9124486,
                31.2320961
              ],
              [
                52.9085619,
                31.2312656
              ],
              [
                52.907172,
                31.2312657
              ],
              [
                52.9063386,
                31.2309767
              ],
              [
                52.8780023,
                31.2268151
              ],
              [
                52.8755023,
                31.2262645
              ],
              [
                52.8688358,
                31.2237639
              ],
              [
                52.8505028,
                31.2143124
              ],
              [
                52.8502261,
                31.2137618
              ],
              [
                52.8335564,
                31.1956984
              ],
              [
                52.831613,
                31.191257
              ],
              [
                52.831613,
                31.1865358
              ],
              [
                52.8335564,
                31.1790434
              ],
              [
                52.8393896,
                31.1718126
              ],
              [
                52.855226,
                31.1609802
              ],
              [
                52.8568927,
                31.1604295
              ],
              [
                52.8613359,
                31.1584797
              ],
              [
                52.8766158,
                31.1540384
              ],
              [
                52.8877256,
                31.1470967
              ],
              [
                52.8882822,
                31.1462572
              ],
              [
                52.8891155,
                31.1459773
              ],
              [
                52.8927254,
                31.1429262
              ],
              [
                52.8941155,
                31.1415361
              ],
              [
                52.8949488,
                31.1405657
              ],
              [
                52.8952254,
                31.1404257
              ],
              [
                52.8955055,
                31.1401459
              ],
              [
                52.8993921,
                31.1362644
              ],
              [
                52.9118953,
                31.1212617
              ],
              [
                52.9160618,
                31.1118105
              ],
              [
                52.9248571,
                31.0872694
              ],
              [
                52.924592,
                31.0720322
              ],
              [
                52.9254627,
                31.0575953
              ],
              [
                52.9286069,
                31.0307187
              ],
              [
                52.9428597,
                31.0120171
              ],
              [
                52.9534334,
                31.0044968
              ],
              [
                52.9746639,
                30.9984489
              ],
              [
                52.9848195,
                30.9969758
              ],
              [
                52.9965368,
                30.9954015
              ],
              [
                53.0093356,
                30.9943121
              ],
              [
                53.0236277,
                30.9933287
              ],
              [
                53.0333233,
                30.9911316
              ],
              [
                53.0428962,
                30.9887139
              ],
              [
                53.0515984,
                30.9863858
              ],
              [
                53.081623,
                30.9698677
              ],
              [
                53.0957928,
                30.9623669
              ],
              [
                53.096626,
                30.9615365
              ],
              [
                53.1188491,
                30.9487554
              ],
              [
                53.1230157,
                30.9462552
              ],
              [
                53.1371822,
                30.9387544
              ],
              [
                53.1380154,
                30.9387544
              ],
              [
                53.1421821,
                30.9373644
              ],
              [
                53.1427388,
                30.9370845
              ],
              [
                53.1432921,
                30.9365339
              ],
              [
                53.1452387,
                30.9354238
              ],
              [
                53.1474621,
                30.9345843
              ],
              [
                53.2180176,
                30.9018107
              ],
              [
                53.2213509,
                30.9007005
              ],
              [
                53.225521,
                30.8987509
              ],
              [
                53.2269076,
                30.8984801
              ],
              [
                53.2374641,
                30.8948607
              ],
              [
                53.2388541,
                30.8948607
              ],
              [
                53.2407974,
                30.8940303
              ],
              [
                53.2416308,
                30.8940303
              ],
              [
                53.2419108,
                30.8937505
              ],
              [
                53.2430207,
                30.8934797
              ],
              [
                53.24368,
                30.8929811
              ],
              [
                53.2441307,
                30.8926403
              ],
              [
                53.2460774,
                30.8915301
              ],
              [
                53.247744,
                30.8909795
              ],
              [
                53.2530205,
                30.8881995
              ],
              [
                53.2624671,
                30.882089
              ],
              [
                53.2638537,
                30.880699
              ],
              [
                53.2724669,
                30.8756987
              ],
              [
                53.2730203,
                30.8754189
              ],
              [
                53.2735769,
                30.8751391
              ],
              [
                53.2746868,
                30.8745795
              ],
              [
                53.2774669,
                30.8731985
              ],
              [
                53.2799669,
                30.8723591
              ],
              [
                53.2858002,
                30.8701387
              ],
              [
                53.2994133,
                30.8637484
              ],
              [
                53.3635824,
                30.8331963
              ],
              [
                53.3774721,
                30.8254161
              ],
              [
                53.3833054,
                30.8206957
              ],
              [
                53.3880253,
                30.8173652
              ],
              [
                53.3955286,
                30.8120852
              ],
              [
                53.4246948,
                30.7773641
              ],
              [
                53.4327514,
                30.7662448
              ],
              [
                53.4433079,
                30.7540245
              ],
              [
                53.4444179,
                30.7515245
              ],
              [
                53.4487552,
                30.7471871
              ],
              [
                53.4494178,
                30.7465244
              ],
              [
                53.4494178,
                30.7462446
              ],
              [
                53.4585844,
                30.7373638
              ],
              [
                53.4605311,
                30.7368042
              ],
              [
                53.4710875,
                30.7315245
              ],
              [
                53.4905305,
                30.7265336
              ],
              [
                53.4921972,
                30.7262537
              ],
              [
                53.4924773,
                30.7259739
              ],
              [
                53.4969205,
                30.7251346
              ],
              [
                53.5049771,
                30.7226347
              ],
              [
                53.506367,
                30.7226346
              ],
              [
                53.5291433,
                30.7179145
              ],
              [
                53.5533131,
                30.7154145
              ],
              [
                53.5619228,
                30.714864
              ],
              [
                53.5630362,
                30.7145842
              ],
              [
                53.5649796,
                30.7145842
              ],
              [
                53.5922025,
                30.7120843
              ],
              [
                53.597479,
                30.7120842
              ],
              [
                53.5994257,
                30.7118045
              ],
              [
                53.6060922,
                30.7118045
              ],
              [
                53.6083156,
                30.7115247
              ],
              [
                53.6116488,
                30.7115247
              ],
              [
                53.6297053,
                30.7093045
              ],
              [
                53.6330386,
                30.7093045
              ],
              [
                53.6499816,
                30.7073641
              ],
              [
                53.6533149,
                30.7068046
              ],
              [
                53.6577615,
                30.7056945
              ],
              [
                53.6591515,
                30.7056945
              ],
              [
                53.6613714,
                30.7051349
              ],
              [
                53.6638714,
                30.7048641
              ],
              [
                53.7144308,
                30.6934655
              ],
              [
                53.734987,
                30.6890253
              ],
              [
                53.7397104,
                30.6876354
              ],
              [
                53.7838764,
                30.6751358
              ],
              [
                53.8071723,
                30.669507
              ],
              [
                53.8315486,
                30.6563726
              ],
              [
                53.836819,
                30.6525237
              ],
              [
                53.8375472,
                30.6582594
              ],
              [
                53.8383139,
                30.6688755
              ],
              [
                53.839208,
                30.680992
              ],
              [
                53.8414814,
                30.6930443
              ],
              [
                53.8459593,
                30.7132446
              ],
              [
                53.8513821,
                30.7286804
              ],
              [
                53.8619602,
                30.7529087
              ],
              [
                53.8890916,
                30.809598
              ],
              [
                53.9135642,
                30.8614143
              ],
              [
                53.939296,
                30.9162004
              ],
              [
                53.9560305,
                30.9483114
              ],
              [
                53.9609142,
                30.9559747
              ],
              [
                53.9791271,
                30.9792224
              ],
              [
                53.9318705,
                30.978227
              ],
              [
                53.8936592,
                30.9765936
              ],
              [
                53.8600943,
                30.9751954
              ],
              [
                53.8470505,
                30.9747683
              ],
              [
                53.8385106,
                30.9992507
              ],
              [
                53.8391589,
                31.0043125
              ],
              [
                53.8377688,
                31.0043125
              ],
              [
                53.8369356,
                31.0045833
              ],
              [
                53.8355456,
                31.0045833
              ],
              [
                53.8349923,
                31.0048631
              ],
              [
                53.8344356,
                31.0048631
              ],
              [
                53.8330456,
                31.0057026
              ],
              [
                53.8330456,
                31.0059734
              ],
              [
                53.8308257,
                31.0090333
              ],
              [
                53.8161026,
                31.0329264
              ],
              [
                53.813046,
                31.0373675
              ],
              [
                53.8127694,
                31.0384777
              ],
              [
                53.8124893,
                31.0423683
              ],
              [
                53.8122127,
                31.0431986
              ],
              [
                53.8108227,
                31.0493096
              ],
              [
                53.8102693,
                31.0495895
              ],
              [
                53.8063794,
                31.0573704
              ],
              [
                53.8063794,
                31.0587515
              ],
              [
                53.8060994,
                31.059591
              ],
              [
                53.8083227,
                31.0729234
              ],
              [
                53.8083226,
                31.0748732
              ],
              [
                53.8033227,
                31.085976
              ],
              [
                53.802766,
                31.0895957
              ],
              [
                53.8022128,
                31.0912566
              ],
              [
                53.7997129,
                31.0926468
              ],
              [
                53.7983228,
                31.0929266
              ],
              [
                53.7966561,
                31.0929266
              ],
              [
                53.7938796,
                31.0920962
              ],
              [
                53.7855429,
                31.0882056
              ],
              [
                53.7833231,
                31.0882057
              ],
              [
                53.7822097,
                31.0887562
              ],
              [
                53.7813763,
                31.0895958
              ],
              [
                53.780543,
                31.0915365
              ],
              [
                53.7838763,
                31.0990287
              ],
              [
                53.7847096,
                31.1029193
              ],
              [
                53.784433,
                31.1034789
              ],
              [
                53.7838763,
                31.1082
              ],
              [
                53.780543,
                31.1187614
              ],
              [
                53.7800151,
                31.1329177
              ],
              [
                53.6535949,
                31.2295958
              ],
              [
                53.6505382,
                31.2312658
              ],
              [
                53.6488716,
                31.2318165
              ],
              [
                53.6424816,
                31.2329268
              ],
              [
                53.6308151,
                31.2329269
              ],
              [
                53.6299818,
                31.232647
              ],
              [
                53.6263719,
                31.232647
              ],
              [
                53.621372,
                31.2320964
              ],
              [
                53.619982,
                31.2318165
              ],
              [
                53.6183154,
                31.2318165
              ],
              [
                53.6144254,
                31.2309769
              ],
              [
                53.613592,
                31.2309769
              ],
              [
                53.612202,
                31.2304263
              ],
              [
                53.6105354,
                31.2301464
              ],
              [
                53.609702,
                31.2301465
              ],
              [
                53.6083155,
                31.2295958
              ],
              [
                53.6069255,
                31.2295957
              ],
              [
                53.5997022,
                31.2279257
              ],
              [
                53.5935923,
                31.2273751
              ],
              [
                53.5927591,
                31.2276459
              ],
              [
                53.5913691,
                31.2276459
              ],
              [
                53.5891457,
                31.2282055
              ],
              [
                53.5883124,
                31.2282055
              ],
              [
                53.5833125,
                31.2304263
              ],
              [
                53.5813692,
                31.2323761
              ],
              [
                53.5808126,
                31.2340372
              ],
              [
                53.5755359,
                31.2423694
              ],
              [
                53.5727559,
                31.2440395
              ],
              [
                53.570256,
                31.2445902
              ],
              [
                53.5694227,
                31.24487
              ],
              [
                53.567756,
                31.24487
              ],
              [
                53.5669227,
                31.2445901
              ],
              [
                53.5658127,
                31.2445901
              ],
              [
                53.5619228,
                31.2432089
              ],
              [
                53.5588661,
                31.2401487
              ],
              [
                53.5574794,
                31.2384786
              ],
              [
                53.5558129,
                31.2270952
              ],
              [
                53.5560895,
                31.2268153
              ],
              [
                53.5563662,
                31.2232045
              ],
              [
                53.5566462,
                31.2195936
              ],
              [
                53.5560896,
                31.2140328
              ],
              [
                53.5558129,
                31.2126517
              ],
              [
                53.5527562,
                31.2073707
              ],
              [
                53.5502562,
                31.2051501
              ],
              [
                53.5421997,
                31.2009795
              ],
              [
                53.5413664,
                31.2004288
              ],
              [
                53.52609,
                31.1959875
              ],
              [
                53.5224767,
                31.1948681
              ],
              [
                53.5172001,
                31.1932071
              ],
              [
                53.4955303,
                31.1893164
              ],
              [
                53.4941438,
                31.1893164
              ],
              [
                53.4933104,
                31.1890365
              ],
              [
                53.4902538,
                31.1890365
              ],
              [
                53.4888638,
                31.1887657
              ],
              [
                53.4858072,
                31.1887657
              ],
              [
                53.4846971,
                31.1884859
              ],
              [
                53.4796973,
                31.1884859
              ],
              [
                53.4785874,
                31.1887658
              ],
              [
                53.475254,
                31.1887658
              ],
              [
                53.4735873,
                31.1890366
              ],
              [
                53.4727541,
                31.1893164
              ],
              [
                53.4713641,
                31.1893164
              ],
              [
                53.4602508,
                31.1940375
              ],
              [
                53.4585842,
                31.1956986
              ],
              [
                53.4521977,
                31.1995893
              ],
              [
                53.4521977,
                31.1998691
              ],
              [
                53.451641,
                31.1998691
              ],
              [
                53.4513643,
                31.2001489
              ],
              [
                53.4508077,
                31.2009795
              ],
              [
                53.4483078,
                31.2059806
              ],
              [
                53.4483077,
                31.2062604
              ],
              [
                53.4458078,
                31.2123718
              ],
              [
                53.4452511,
                31.2129225
              ],
              [
                53.4449744,
                31.2140328
              ],
              [
                53.4444178,
                31.2145924
              ],
              [
                53.4441411,
                31.2157028
              ],
              [
                53.4171948,
                31.2557027
              ],
              [
                53.4166381,
                31.2565422
              ],
              [
                53.4035817,
                31.2829294
              ],
              [
                53.4034955,
                31.2830442
              ],
              [
                53.4027483,
                31.2840398
              ],
              [
                53.402195,
                31.28543
              ],
              [
                53.4016384,
                31.2857098
              ],
              [
                53.3966384,
                31.2943221
              ],
              [
                53.3899719,
                31.3020947
              ],
              [
                53.3888585,
                31.303485
              ],
              [
                53.3855252,
                31.3129277
              ],
              [
                53.3705254,
                31.3337634
              ],
              [
                53.3702488,
                31.3343231
              ],
              [
                53.3685821,
                31.3370946
              ],
              [
                53.3677488,
                31.3376543
              ],
              [
                53.3641354,
                31.3434861
              ],
              [
                53.3635822,
                31.3445966
              ],
              [
                53.3630255,
                31.3448764
              ],
              [
                53.3294127,
                31.4101561
              ],
              [
                53.3163561,
                31.4334841
              ],
              [
                53.3149661,
                31.4365445
              ],
              [
                53.3144129,
                31.4370953
              ],
              [
                53.3113562,
                31.4457079
              ],
              [
                53.3110796,
                31.4468184
              ],
              [
                53.3013563,
                31.4859909
              ],
              [
                53.2910765,
                31.508209
              ],
              [
                53.2694101,
                31.5348781
              ],
              [
                53.2688534,
                31.535158
              ],
              [
                53.2627435,
                31.5401596
              ],
              [
                53.2616336,
                31.5412701
              ],
              [
                53.2555202,
                31.5446016
              ],
              [
                53.2310739,
                31.5559862
              ],
              [
                53.2296873,
                31.5565459
              ],
              [
                53.2177407,
                31.5665493
              ],
              [
                53.2060743,
                31.584046
              ],
              [
                53.2049643,
                31.5851564
              ],
              [
                53.2029075,
                31.5889258
              ],
              [
                53.1944078,
                31.573212
              ],
              [
                53.1860746,
                31.5679305
              ],
              [
                53.1849612,
                31.5676597
              ],
              [
                53.1832945,
                31.56682
              ],
              [
                53.1355152,
                31.5423805
              ],
              [
                53.133572,
                31.5418208
              ],
              [
                53.1327387,
                31.5412701
              ],
              [
                53.130792,
                31.5407103
              ],
              [
                53.1291253,
                31.5398798
              ],
              [
                53.0913459,
                31.5234936
              ],
              [
                53.0832893,
                31.5201532
              ],
              [
                53.0596797,
                31.5115403
              ],
              [
                53.0574564,
                31.5112694
              ],
              [
                53.0524565,
                31.5098792
              ],
              [
                53.0113437,
                31.5004267
              ],
              [
                53.009397,
                31.4995961
              ],
              [
                53.0071771,
                31.4993252
              ],
              [
                53.0063438,
                31.4987655
              ],
              [
                52.9977306,
                31.4962647
              ],
              [
                52.9966206,
                31.4962647
              ],
              [
                52.9938406,
                31.4954342
              ],
              [
                52.987174,
                31.4943237
              ],
              [
                52.9852307,
                31.4943237
              ],
              [
                52.9843974,
                31.4940438
              ],
              [
                52.9824541,
                31.4940439
              ],
              [
                52.9793974,
                31.4934931
              ],
              [
                52.9774508,
                31.4934932
              ],
              [
                52.9460613,
                31.4901527
              ],
              [
                52.9410613,
                31.4901527
              ],
              [
                52.9385615,
                31.4898728
              ],
              [
                52.9360614,
                31.4901527
              ],
              [
                52.9227283,
                31.4901527
              ],
              [
                52.9213382,
                31.4898729
              ],
              [
                52.9016152,
                31.4890422
              ],
              [
                52.8927253,
                31.4893221
              ],
              [
                52.888282,
                31.4893221
              ],
              [
                52.8868921,
                31.4896019
              ],
              [
                52.8832821,
                31.489602
              ],
              [
                52.8807822,
                31.4898728
              ],
              [
                52.8727256,
                31.4898728
              ],
              [
                52.8716156,
                31.4901527
              ],
              [
                52.8585591,
                31.4901526
              ],
              [
                52.8577259,
                31.4898728
              ],
              [
                52.8535592,
                31.4904326
              ],
              [
                52.849946,
                31.4904325
              ],
              [
                52.8491126,
                31.4907124
              ],
              [
                52.8418894,
                31.4912631
              ],
              [
                52.8368894,
                31.4912631
              ],
              [
                52.8360562,
                31.491543
              ],
              [
                52.8330028,
                31.491543
              ],
              [
                52.8321695,
                31.4918229
              ],
              [
                52.8307796,
                31.4918228
              ],
              [
                52.829113,
                31.4921027
              ],
              [
                52.8132799,
                31.4932132
              ],
              [
                52.8077232,
                31.4943236
              ],
              [
                52.8060565,
                31.4943236
              ],
              [
                52.8057765,
                31.4946034
              ],
              [
                52.8010566,
                31.4948743
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554873,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اردکان",
          "name:ar": "مقاطعة أردكان",
          "name:en": "Ardakan County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1287822",
          "wikipedia": "en:Ardakan County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.0220287,
                32.4497819
              ],
              [
                53.0218638,
                32.4453502
              ],
              [
                53.0228869,
                32.4430735
              ],
              [
                53.0233668,
                32.4336572
              ],
              [
                53.0245534,
                32.4225924
              ],
              [
                53.0250414,
                32.4101267
              ],
              [
                53.0257736,
                32.3968515
              ],
              [
                53.0270802,
                32.3801167
              ],
              [
                53.0276177,
                32.3645667
              ],
              [
                53.0278086,
                32.350659
              ],
              [
                53.0288684,
                32.3390763
              ],
              [
                53.0289769,
                32.3300608
              ],
              [
                53.0294693,
                32.3212061
              ],
              [
                53.0286336,
                32.3099209
              ],
              [
                53.0276669,
                32.3022519
              ],
              [
                53.0262539,
                32.2890363
              ],
              [
                53.0249294,
                32.2749347
              ],
              [
                53.029182,
                32.2250781
              ],
              [
                53.0298018,
                32.2029296
              ],
              [
                53.0312917,
                32.1768898
              ],
              [
                53.0323885,
                32.1557259
              ],
              [
                53.0340954,
                32.1311409
              ],
              [
                53.0354687,
                32.1067157
              ],
              [
                53.0419918,
                32.0645378
              ],
              [
                53.0440518,
                32.0488252
              ],
              [
                53.0404469,
                32.0344196
              ],
              [
                53.0522917,
                32.0294716
              ],
              [
                53.0511759,
                32.0051102
              ],
              [
                53.0672262,
                32.0133163
              ],
              [
                53.0780409,
                32.0200116
              ],
              [
                53.0885122,
                32.029035
              ],
              [
                53.0994986,
                32.0368933
              ],
              [
                53.109796,
                32.0468608
              ],
              [
                53.1238745,
                32.06221
              ],
              [
                53.140868,
                32.0772617
              ],
              [
                53.151512,
                32.0873743
              ],
              [
                53.1624608,
                32.0951769
              ],
              [
                53.1791495,
                32.1103506
              ],
              [
                53.1932142,
                32.1207301
              ],
              [
                53.2108323,
                32.1323728
              ],
              [
                53.2373278,
                32.154773
              ],
              [
                53.2441052,
                32.1584146
              ],
              [
                53.2501243,
                32.1616531
              ],
              [
                53.2678623,
                32.1698119
              ],
              [
                53.2765889,
                32.1747631
              ],
              [
                53.2987856,
                32.1885242
              ],
              [
                53.3327468,
                32.2110744
              ],
              [
                53.3625159,
                32.2281397
              ],
              [
                53.4003806,
                32.2495783
              ],
              [
                53.4189942,
                32.2689109
              ],
              [
                53.4452032,
                32.2950051
              ],
              [
                53.4523272,
                32.3003013
              ],
              [
                53.4562111,
                32.3029856
              ],
              [
                53.4594083,
                32.3048899
              ],
              [
                53.4628629,
                32.3066672
              ],
              [
                53.4681836,
                32.3097651
              ],
              [
                53.4722285,
                32.3125598
              ],
              [
                53.4820903,
                32.3186968
              ],
              [
                53.4854059,
                32.3194447
              ],
              [
                53.4878317,
                32.3189926
              ],
              [
                53.4920025,
                32.3171311
              ],
              [
                53.4959373,
                32.3139605
              ],
              [
                53.5021326,
                32.3093682
              ],
              [
                53.5081763,
                32.3043994
              ],
              [
                53.5091574,
                32.3033657
              ],
              [
                53.5100789,
                32.3019721
              ],
              [
                53.5155387,
                32.2981968
              ],
              [
                53.5207567,
                32.2939817
              ],
              [
                53.5309695,
                32.2901802
              ],
              [
                53.5468425,
                32.2916272
              ],
              [
                53.5634994,
                32.2938805
              ],
              [
                53.5789034,
                32.2946568
              ],
              [
                53.587644,
                32.2929881
              ],
              [
                53.5985421,
                32.2863231
              ],
              [
                53.6061469,
                32.2814615
              ],
              [
                53.6144334,
                32.2765477
              ],
              [
                53.6238435,
                32.2746609
              ],
              [
                53.6363249,
                32.2733443
              ],
              [
                53.6506694,
                32.2729089
              ],
              [
                53.6747153,
                32.2713019
              ],
              [
                53.6992343,
                32.2710842
              ],
              [
                53.7078646,
                32.2709215
              ],
              [
                53.7128467,
                32.2707454
              ],
              [
                53.7220844,
                32.2707054
              ],
              [
                53.7500772,
                32.2728095
              ],
              [
                53.7880854,
                32.2841163
              ],
              [
                53.8138205,
                32.2918302
              ],
              [
                53.833985,
                32.2975117
              ],
              [
                53.8531715,
                32.3032747
              ],
              [
                53.8695046,
                32.3080703
              ],
              [
                53.8801011,
                32.3112701
              ],
              [
                53.887937,
                32.3135913
              ],
              [
                53.8938367,
                32.3157028
              ],
              [
                53.898599,
                32.3156756
              ],
              [
                53.9017087,
                32.3146463
              ],
              [
                53.9049216,
                32.3134586
              ],
              [
                53.920127,
                32.3078832
              ],
              [
                53.9293217,
                32.3043286
              ],
              [
                53.942598,
                32.300038
              ],
              [
                53.9592533,
                32.2925651
              ],
              [
                53.9681187,
                32.2892608
              ],
              [
                53.9727365,
                32.2923425
              ],
              [
                53.9834409,
                32.2909373
              ],
              [
                53.9887195,
                32.2889783
              ],
              [
                53.9884877,
                32.2884123
              ],
              [
                53.9889255,
                32.2881511
              ],
              [
                53.9890285,
                32.287694
              ],
              [
                53.9898782,
                32.287128
              ],
              [
                53.9939466,
                32.2867362
              ],
              [
                53.9970622,
                32.2861485
              ],
              [
                53.9967017,
                32.2855825
              ],
              [
                53.9997916,
                32.2848206
              ],
              [
                54.0070014,
                32.2839934
              ],
              [
                54.0061259,
                32.281773
              ],
              [
                54.0103838,
                32.2812164
              ],
              [
                54.0102669,
                32.2817682
              ],
              [
                54.0100985,
                32.2822472
              ],
              [
                54.0116601,
                32.2820918
              ],
              [
                54.0131912,
                32.2818459
              ],
              [
                54.0132371,
                32.2826614
              ],
              [
                54.0133902,
                32.28481
              ],
              [
                54.016927,
                32.2846806
              ],
              [
                54.0192083,
                32.2846159
              ],
              [
                54.021612,
                32.2846677
              ],
              [
                54.0233727,
                32.2847453
              ],
              [
                54.023591,
                32.2830876
              ],
              [
                54.024415,
                32.2802576
              ],
              [
                54.0267334,
                32.2750654
              ],
              [
                54.0296652,
                32.2761746
              ],
              [
                54.0386607,
                32.2856607
              ],
              [
                54.0482843,
                32.2865775
              ],
              [
                54.0592277,
                32.2856197
              ],
              [
                54.0623176,
                32.2855326
              ],
              [
                54.0656393,
                32.2863816
              ],
              [
                54.0714843,
                32.289908
              ],
              [
                54.0790031,
                32.2939566
              ],
              [
                54.0828912,
                32.295502
              ],
              [
                54.0867794,
                32.2969385
              ],
              [
                54.0880588,
                32.2973981
              ],
              [
                54.0969486,
                32.2965673
              ],
              [
                54.1058352,
                32.2965673
              ],
              [
                54.1072252,
                32.2962874
              ],
              [
                54.1136151,
                32.2962874
              ],
              [
                54.1202816,
                32.2968382
              ],
              [
                54.1244482,
                32.297678
              ],
              [
                54.1305616,
                32.2982287
              ],
              [
                54.1466713,
                32.2982287
              ],
              [
                54.1766743,
                32.3015606
              ],
              [
                54.190284,
                32.3037818
              ],
              [
                54.2144538,
                32.3079534
              ],
              [
                54.2161204,
                32.3079534
              ],
              [
                54.2219537,
                32.309064
              ],
              [
                54.2236203,
                32.309064
              ],
              [
                54.2266769,
                32.3096148
              ],
              [
                54.2319535,
                32.3101746
              ],
              [
                54.2616764,
                32.3123958
              ],
              [
                54.2666763,
                32.3123959
              ],
              [
                54.3047359,
                32.3154569
              ],
              [
                54.3086225,
                32.3154568
              ],
              [
                54.3094557,
                32.3157277
              ],
              [
                54.323069,
                32.3157277
              ],
              [
                54.3252923,
                32.3160077
              ],
              [
                54.3327922,
                32.3160077
              ],
              [
                54.3336255,
                32.3162875
              ],
              [
                54.3377921,
                32.3162875
              ],
              [
                54.3386254,
                32.3165675
              ],
              [
                54.3405687,
                32.3165675
              ],
              [
                54.3430687,
                32.3171183
              ],
              [
                54.3447353,
                32.3171182
              ],
              [
                54.3516077,
                32.3181021
              ],
              [
                54.3564052,
                32.3187887
              ],
              [
                54.3575151,
                32.3193394
              ],
              [
                54.3583485,
                32.3193395
              ],
              [
                54.3739049,
                32.3226713
              ],
              [
                54.375295,
                32.3226713
              ],
              [
                54.3758482,
                32.3229512
              ],
              [
                54.3769616,
                32.3229512
              ],
              [
                54.3772383,
                32.3232311
              ],
              [
                54.3786283,
                32.3232311
              ],
              [
                54.3791814,
                32.3235111
              ],
              [
                54.3800148,
                32.323511
              ],
              [
                54.3808481,
                32.323782
              ],
              [
                54.3822382,
                32.3237819
              ],
              [
                54.3827948,
                32.3240619
              ],
              [
                54.3839048,
                32.3240618
              ],
              [
                54.3844616,
                32.3243417
              ],
              [
                54.3852948,
                32.3243418
              ],
              [
                54.3861281,
                32.3246217
              ],
              [
                54.3880715,
                32.3246217
              ],
              [
                54.3883481,
                32.3249015
              ],
              [
                54.3919614,
                32.3254523
              ],
              [
                54.3955712,
                32.3254524
              ],
              [
                54.3955712,
                32.3251725
              ],
              [
                54.3968966,
                32.3233276
              ],
              [
                54.3972379,
                32.3226713
              ],
              [
                54.4189077,
                32.2757275
              ],
              [
                54.4189077,
                32.2737862
              ],
              [
                54.4072378,
                32.2637816
              ],
              [
                54.4055711,
                32.262671
              ],
              [
                54.3516289,
                32.225293
              ],
              [
                54.3464386,
                32.2222225
              ],
              [
                54.3412182,
                32.2187771
              ],
              [
                54.3402921,
                32.2137861
              ],
              [
                54.3408487,
                32.2132263
              ],
              [
                54.344182,
                32.2110051
              ],
              [
                54.3455686,
                32.2096145
              ],
              [
                54.3466819,
                32.2090638
              ],
              [
                54.3511605,
                32.2044032
              ],
              [
                54.3939047,
                32.1598902
              ],
              [
                54.3952946,
                32.1582197
              ],
              [
                54.4247173,
                32.125993
              ],
              [
                54.4284333,
                32.1275901
              ],
              [
                54.4289074,
                32.1276737
              ],
              [
                54.4296311,
                32.1278561
              ],
              [
                54.4300175,
                32.1279535
              ],
              [
                54.4314075,
                32.1282245
              ],
              [
                54.4336308,
                32.1287843
              ],
              [
                54.4352974,
                32.129335
              ],
              [
                54.4597403,
                32.1385087
              ],
              [
                54.473042,
                32.1450209
              ],
              [
                54.4869634,
                32.151836
              ],
              [
                54.4883533,
                32.1521158
              ],
              [
                54.4897433,
                32.1526666
              ],
              [
                54.4953,
                32.1543371
              ],
              [
                54.5061331,
                32.1576689
              ],
              [
                54.5214095,
                32.1635018
              ],
              [
                54.5225228,
                32.1640616
              ],
              [
                54.5455793,
                32.1754475
              ],
              [
                54.5475226,
                32.1760074
              ],
              [
                54.5525225,
                32.1787793
              ],
              [
                54.5525224,
                32.1790592
              ],
              [
                54.5591891,
                32.1887839
              ],
              [
                54.5647456,
                32.1935062
              ],
              [
                54.5755788,
                32.2043323
              ],
              [
                54.5997486,
                32.216838
              ],
              [
                54.6005819,
                32.2173978
              ],
              [
                54.6080818,
                32.2198989
              ],
              [
                54.6116916,
                32.2204497
              ],
              [
                54.6136384,
                32.2204498
              ],
              [
                54.6161383,
                32.2210095
              ],
              [
                54.6214149,
                32.2212804
              ],
              [
                54.6314147,
                32.2212804
              ],
              [
                54.6328048,
                32.2215603
              ],
              [
                54.6358614,
                32.2218402
              ],
              [
                54.6394713,
                32.2215603
              ],
              [
                54.6416947,
                32.2212804
              ],
              [
                54.6439179,
                32.2210095
              ],
              [
                54.6494711,
                32.2210096
              ],
              [
                54.6514178,
                32.2207296
              ],
              [
                54.6530845,
                32.2204496
              ],
              [
                54.6639177,
                32.2176687
              ],
              [
                54.6697509,
                32.2148967
              ],
              [
                54.6705842,
                32.2143369
              ],
              [
                54.7000305,
                32.1873933
              ],
              [
                54.7055872,
                32.1765582
              ],
              [
                54.7058637,
                32.1760073
              ],
              [
                54.7119736,
                32.1671134
              ],
              [
                54.7161436,
                32.1615605
              ],
              [
                54.7500331,
                32.1298947
              ],
              [
                54.753643,
                32.1279535
              ],
              [
                54.7544764,
                32.1276735
              ],
              [
                54.7697562,
                32.1226714
              ],
              [
                54.7780895,
                32.1204501
              ],
              [
                54.7811461,
                32.1196194
              ],
              [
                54.7819794,
                32.1196195
              ],
              [
                54.8050358,
                32.1132267
              ],
              [
                54.8083691,
                32.1118362
              ],
              [
                54.8225355,
                32.1051727
              ],
              [
                54.8239254,
                32.104333
              ],
              [
                54.8400352,
                32.0815522
              ],
              [
                54.8411485,
                32.0779495
              ],
              [
                54.8417019,
                32.0746177
              ],
              [
                54.8422584,
                32.0735072
              ],
              [
                54.8425351,
                32.0715568
              ],
              [
                54.8453151,
                32.0618324
              ],
              [
                54.8453151,
                32.0615615
              ],
              [
                54.8464251,
                32.0490561
              ],
              [
                54.8461486,
                32.0443339
              ],
              [
                54.8458684,
                32.0429434
              ],
              [
                54.8455918,
                32.0421127
              ],
              [
                54.8453151,
                32.0415528
              ],
              [
                54.8453151,
                32.0407222
              ],
              [
                54.8447585,
                32.0401715
              ],
              [
                54.8447584,
                32.0398915
              ],
              [
                54.8639249,
                32.0429434
              ],
              [
                54.877538,
                32.0457244
              ],
              [
                54.8800381,
                32.0465551
              ],
              [
                54.8842046,
                32.0473857
              ],
              [
                54.8853179,
                32.0479455
              ],
              [
                54.8880945,
                32.0485053
              ],
              [
                54.9055943,
                32.0540582
              ],
              [
                54.9111509,
                32.0559995
              ],
              [
                54.9289307,
                32.0610016
              ],
              [
                55.0197661,
                32.0765589
              ],
              [
                55.0269893,
                32.0779494
              ],
              [
                55.0569923,
                32.0851729
              ],
              [
                55.0583789,
                32.0857236
              ],
              [
                55.0942151,
                32.0915565
              ],
              [
                55.1114382,
                32.0937777
              ],
              [
                55.1144948,
                32.0937777
              ],
              [
                55.1186615,
                32.0946174
              ],
              [
                55.1217147,
                32.0948883
              ],
              [
                55.1422711,
                32.0987798
              ],
              [
                55.1853305,
                32.1107256
              ],
              [
                55.1911105,
                32.1082167
              ],
              [
                55.2609545,
                32.130697
              ],
              [
                55.3004409,
                32.143161
              ],
              [
                55.3279193,
                32.1608915
              ],
              [
                55.361066,
                32.1528069
              ],
              [
                55.4216224,
                32.1572746
              ],
              [
                55.4823554,
                32.1720093
              ],
              [
                55.4878431,
                32.1729462
              ],
              [
                55.5000663,
                32.1754472
              ],
              [
                55.5064562,
                32.1778445
              ],
              [
                55.5100662,
                32.1779483
              ],
              [
                55.5106229,
                32.1782282
              ],
              [
                55.5225661,
                32.1782282
              ],
              [
                55.5256226,
                32.1784991
              ],
              [
                55.526456,
                32.1787791
              ],
              [
                55.528956,
                32.178779
              ],
              [
                55.5484024,
                32.1812801
              ],
              [
                55.5581255,
                32.1835013
              ],
              [
                55.5781253,
                32.189894
              ],
              [
                55.5900719,
                32.192666
              ],
              [
                55.6139615,
                32.2004493
              ],
              [
                55.6200714,
                32.2021107
              ],
              [
                55.7086869,
                32.226833
              ],
              [
                55.7311867,
                32.2321151
              ],
              [
                55.8028589,
                32.2546162
              ],
              [
                55.8189688,
                32.2623905
              ],
              [
                55.8253586,
                32.2651716
              ],
              [
                55.8564715,
                32.2801784
              ],
              [
                55.9178641,
                32.3057315
              ],
              [
                56.0106462,
                32.339059
              ],
              [
                56.0742588,
                32.3682329
              ],
              [
                56.0853719,
                32.3735061
              ],
              [
                56.1200949,
                32.3912851
              ],
              [
                56.1234282,
                32.3932264
              ],
              [
                56.2078771,
                32.4310055
              ],
              [
                56.2109337,
                32.4329559
              ],
              [
                56.2309335,
                32.4432313
              ],
              [
                56.2337101,
                32.4448927
              ],
              [
                56.260933,
                32.4573985
              ],
              [
                56.2776027,
                32.4640622
              ],
              [
                56.302326,
                32.4760081
              ],
              [
                56.3048258,
                32.4779494
              ],
              [
                56.3048258,
                32.4782293
              ],
              [
                56.2995458,
                32.4837825
              ],
              [
                56.2778796,
                32.5124058
              ],
              [
                56.2734363,
                32.5190695
              ],
              [
                56.2620465,
                32.5376793
              ],
              [
                56.2612131,
                32.53851
              ],
              [
                56.2487134,
                32.5632326
              ],
              [
                56.2403767,
                32.5765691
              ],
              [
                56.221487,
                32.5937882
              ],
              [
                56.2009307,
                32.6082353
              ],
              [
                56.1998208,
                32.6093459
              ],
              [
                56.1842642,
                32.6187907
              ],
              [
                56.1814876,
                32.6201812
              ],
              [
                56.1803743,
                32.621012
              ],
              [
                56.1684311,
                32.6282355
              ],
              [
                56.1350948,
                32.6468451
              ],
              [
                56.1131519,
                32.6607324
              ],
              [
                56.1117619,
                32.6612922
              ],
              [
                56.0856488,
                32.6818432
              ],
              [
                56.0821777,
                32.6835651
              ],
              [
                56.0531461,
                32.6979606
              ],
              [
                56.0512027,
                32.6985114
              ],
              [
                56.0384263,
                32.7046244
              ],
              [
                56.037593,
                32.7051841
              ],
              [
                56.0306465,
                32.7087959
              ],
              [
                56.0028669,
                32.7221323
              ],
              [
                55.9925902,
                32.7276854
              ],
              [
                55.9862003,
                32.7318479
              ],
              [
                55.9720338,
                32.7396312
              ],
              [
                55.9656441,
                32.7415726
              ],
              [
                55.9634205,
                32.7424032
              ],
              [
                55.9373075,
                32.7482363
              ],
              [
                55.9081413,
                32.7501776
              ],
              [
                55.9070314,
                32.7504575
              ],
              [
                55.8984181,
                32.7504575
              ],
              [
                55.885085,
                32.7515771
              ],
              [
                55.8814717,
                32.7521279
              ],
              [
                55.879805,
                32.7526877
              ],
              [
                55.8764718,
                32.7532385
              ],
              [
                55.8600821,
                32.7593514
              ],
              [
                55.857582,
                32.760742
              ],
              [
                55.8559154,
                32.7612928
              ],
              [
                55.8550821,
                32.7615726
              ],
              [
                55.8542487,
                32.7618525
              ],
              [
                55.8528621,
                32.7621234
              ],
              [
                55.852582,
                32.7624034
              ],
              [
                55.8517488,
                32.7624033
              ],
              [
                55.8511955,
                32.7626833
              ],
              [
                55.8506389,
                32.7626833
              ],
              [
                55.8503621,
                32.7629632
              ],
              [
                55.8492488,
                32.7629632
              ],
              [
                55.8359157,
                32.7671257
              ],
              [
                55.8314725,
                32.7699067
              ],
              [
                55.8298058,
                32.7704666
              ],
              [
                55.8278591,
                32.771848
              ],
              [
                55.8228593,
                32.7740693
              ],
              [
                55.8075795,
                32.7874056
              ],
              [
                55.806746,
                32.7885162
              ],
              [
                55.7823031,
                32.8151888
              ],
              [
                55.7489844,
                32.8697151
              ],
              [
                55.7392913,
                32.8823339
              ],
              [
                55.7274084,
                32.8981241
              ],
              [
                55.7151986,
                32.9141661
              ],
              [
                55.701419,
                32.9313493
              ],
              [
                55.6847125,
                32.9535863
              ],
              [
                55.6692694,
                32.9741081
              ],
              [
                55.6574364,
                32.9939165
              ],
              [
                55.6510998,
                33.0038021
              ],
              [
                55.6455683,
                33.0132702
              ],
              [
                55.6370818,
                33.0273727
              ],
              [
                55.6266717,
                33.0440673
              ],
              [
                55.6062022,
                33.0779479
              ],
              [
                55.6060428,
                33.0782032
              ],
              [
                55.5824758,
                33.1159329
              ],
              [
                55.5619681,
                33.150082
              ],
              [
                55.5260851,
                33.2082013
              ],
              [
                55.5168404,
                33.2234986
              ],
              [
                55.5046955,
                33.2426785
              ],
              [
                55.4849609,
                33.2787612
              ],
              [
                55.467747,
                33.306446
              ],
              [
                55.4455764,
                33.3370295
              ],
              [
                55.4342527,
                33.3521776
              ],
              [
                55.416872,
                33.3758326
              ],
              [
                55.4049914,
                33.3824666
              ],
              [
                55.4005725,
                33.3740407
              ],
              [
                55.3955167,
                33.3680423
              ],
              [
                55.3873936,
                33.3577196
              ],
              [
                55.3803388,
                33.3635331
              ],
              [
                55.3783955,
                33.3635331
              ],
              [
                55.3772855,
                33.3632533
              ],
              [
                55.3758955,
                33.3632533
              ],
              [
                55.3670056,
                33.3604725
              ],
              [
                55.364229,
                33.3601927
              ],
              [
                55.3622824,
                33.359642
              ],
              [
                55.3247828,
                33.3546402
              ],
              [
                55.3233929,
                33.3540895
              ],
              [
                55.2697803,
                33.3435353
              ],
              [
                55.2686668,
                33.3429755
              ],
              [
                55.260057,
                33.3404747
              ],
              [
                55.2592238,
                33.3399239
              ],
              [
                55.2542238,
                33.3382537
              ],
              [
                55.2328341,
                33.3293606
              ],
              [
                55.2281107,
                33.3268597
              ],
              [
                55.2247774,
                33.3251985
              ],
              [
                55.2225541,
                33.324088
              ],
              [
                55.1833846,
                33.2985283
              ],
              [
                55.176718,
                33.2924159
              ],
              [
                55.1758847,
                33.2921451
              ],
              [
                55.175608,
                33.2918652
              ],
              [
                55.1544949,
                33.2757492
              ],
              [
                55.1372718,
                33.2610327
              ],
              [
                55.1097723,
                33.2407542
              ],
              [
                55.1078256,
                33.238804
              ],
              [
                55.1044923,
                33.2363121
              ],
              [
                55.0772693,
                33.2118624
              ],
              [
                55.0333799,
                33.1671339
              ],
              [
                55.0272666,
                33.15964
              ],
              [
                55.01949,
                33.1504757
              ],
              [
                54.9917104,
                33.1257457
              ],
              [
                54.9906005,
                33.1260256
              ],
              [
                54.9617108,
                33.1435235
              ],
              [
                54.9547642,
                33.1482546
              ],
              [
                54.9128181,
                33.1751877
              ],
              [
                54.9011515,
                33.1796389
              ],
              [
                54.8997616,
                33.1796389
              ],
              [
                54.8994849,
                33.1799188
              ],
              [
                54.898095,
                33.1799188
              ],
              [
                54.8972616,
                33.1801987
              ],
              [
                54.8883717,
                33.1765871
              ],
              [
                54.8861518,
                33.1751876
              ],
              [
                54.8839285,
                33.174357
              ],
              [
                54.8786485,
                33.171856
              ],
              [
                54.8778152,
                33.1715851
              ],
              [
                54.8550795,
                33.1376951
              ],
              [
                54.8411749,
                33.1352514
              ],
              [
                54.8277853,
                33.1348202
              ],
              [
                54.8174856,
                33.1261949
              ],
              [
                54.8086194,
                33.1139807
              ],
              [
                54.8063461,
                33.1022218
              ],
              [
                54.8000977,
                33.0953963
              ],
              [
                54.7960527,
                33.0964823
              ],
              [
                54.7908196,
                33.0959225
              ],
              [
                54.782113,
                33.0935632
              ],
              [
                54.7781529,
                33.0878231
              ],
              [
                54.7741602,
                33.0823169
              ],
              [
                54.7753331,
                33.0770338
              ],
              [
                54.7774661,
                33.0679934
              ],
              [
                54.7795701,
                33.0622749
              ],
              [
                54.7739064,
                33.0534423
              ],
              [
                54.7691723,
                33.0460375
              ],
              [
                54.7612721,
                33.032471
              ],
              [
                54.7548798,
                33.0214609
              ],
              [
                54.7496749,
                33.0123759
              ],
              [
                54.7422767,
                33.0021719
              ],
              [
                54.7383736,
                32.9981768
              ],
              [
                54.7365568,
                32.9848776
              ],
              [
                54.7361835,
                32.9572269
              ],
              [
                54.6940695,
                32.9610429
              ],
              [
                54.6572322,
                32.9657644
              ],
              [
                54.6057953,
                32.9684359
              ],
              [
                54.579193,
                32.9656023
              ],
              [
                54.5480564,
                32.9599288
              ],
              [
                54.5165123,
                32.9558958
              ],
              [
                54.4735352,
                32.9484705
              ],
              [
                54.4406894,
                32.9425643
              ],
              [
                54.4087926,
                32.9364832
              ],
              [
                54.3850765,
                32.9328258
              ],
              [
                54.3626304,
                32.928984
              ],
              [
                54.3327468,
                32.9234845
              ],
              [
                54.3145738,
                32.920106
              ],
              [
                54.2882295,
                32.9134001
              ],
              [
                54.2721217,
                32.9080346
              ],
              [
                54.2550669,
                32.9021926
              ],
              [
                54.2492537,
                32.8990505
              ],
              [
                54.2346355,
                32.8962496
              ],
              [
                54.2224605,
                32.8924583
              ],
              [
                54.2042706,
                32.8874055
              ],
              [
                54.1712774,
                32.8775683
              ],
              [
                54.1587543,
                32.873099
              ],
              [
                54.1496147,
                32.8703771
              ],
              [
                54.1402981,
                32.867061
              ],
              [
                54.1246602,
                32.8611662
              ],
              [
                54.0617025,
                32.8407625
              ],
              [
                54.0342008,
                32.8306916
              ],
              [
                54.0199997,
                32.8257447
              ],
              [
                54.0169048,
                32.8241738
              ],
              [
                53.9957834,
                32.8144697
              ],
              [
                53.9853235,
                32.8105343
              ],
              [
                53.9711135,
                32.8049274
              ],
              [
                53.9560573,
                32.7970349
              ],
              [
                53.9455039,
                32.7923077
              ],
              [
                53.9240985,
                32.7858955
              ],
              [
                53.9120142,
                32.7814909
              ],
              [
                53.8934273,
                32.774879
              ],
              [
                53.863918,
                32.7650104
              ],
              [
                53.8265207,
                32.7515759
              ],
              [
                53.7899485,
                32.7391591
              ],
              [
                53.7542296,
                32.727309
              ],
              [
                53.7178873,
                32.7171997
              ],
              [
                53.6858148,
                32.7043691
              ],
              [
                53.6781414,
                32.7007846
              ],
              [
                53.6605212,
                32.6925532
              ],
              [
                53.6351481,
                32.6817172
              ],
              [
                53.6016339,
                32.6666989
              ],
              [
                53.5694176,
                32.6525809
              ],
              [
                53.5222356,
                32.6306184
              ],
              [
                53.4499578,
                32.6024235
              ],
              [
                53.4356975,
                32.6090137
              ],
              [
                53.4146493,
                32.6162236
              ],
              [
                53.3595666,
                32.6375572
              ],
              [
                53.3282276,
                32.6491388
              ],
              [
                53.3031672,
                32.6543251
              ],
              [
                53.278858,
                32.6512261
              ],
              [
                53.2499055,
                32.6418765
              ],
              [
                53.2347649,
                32.6220997
              ],
              [
                53.2170115,
                32.6003287
              ],
              [
                53.2119365,
                32.5581462
              ],
              [
                53.2096097,
                32.528934
              ],
              [
                53.1913374,
                32.5222106
              ],
              [
                53.1697869,
                32.5242318
              ],
              [
                53.1506558,
                32.527841
              ],
              [
                53.1307096,
                32.53187
              ],
              [
                53.1062633,
                32.5325674
              ],
              [
                53.0832767,
                32.5283618
              ],
              [
                53.0685137,
                32.5408802
              ],
              [
                53.0571411,
                32.5396141
              ],
              [
                53.0452482,
                32.5375855
              ],
              [
                53.0337632,
                32.5358151
              ],
              [
                53.0335999,
                32.5356451
              ],
              [
                53.0301046,
                32.5325046
              ],
              [
                53.0288172,
                32.5310573
              ],
              [
                53.0254268,
                32.5286874
              ],
              [
                53.0239032,
                32.5273026
              ],
              [
                53.0136286,
                32.5177438
              ],
              [
                53.0115161,
                32.5143132
              ],
              [
                53.0134234,
                32.5072386
              ],
              [
                53.0175159,
                32.4993752
              ],
              [
                53.0234098,
                32.4823614
              ],
              [
                53.0224441,
                32.465347
              ],
              [
                53.0220287,
                32.4497819
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554886,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان اشکذر",
          "name:en": "Ashkezar County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286550",
          "wikipedia": "en:Ashkezar County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.7022412,
                31.8576347
              ],
              [
                53.7330437,
                31.8798877
              ],
              [
                53.781933,
                31.8440521
              ],
              [
                53.7883228,
                31.841551
              ],
              [
                53.7924895,
                31.8398807
              ],
              [
                53.806656,
                31.8334973
              ],
              [
                53.8088793,
                31.8329465
              ],
              [
                53.8197124,
                31.8284953
              ],
              [
                53.8558253,
                31.8201617
              ],
              [
                53.8574918,
                31.8201617
              ],
              [
                53.8627685,
                31.8190512
              ],
              [
                53.8638819,
                31.8190512
              ],
              [
                53.8655485,
                31.8184914
              ],
              [
                53.8669385,
                31.8184914
              ],
              [
                53.8877716,
                31.8137783
              ],
              [
                53.8947147,
                31.8115482
              ],
              [
                53.9102713,
                31.8068261
              ],
              [
                53.9133278,
                31.8054357
              ],
              [
                53.9149944,
                31.8051649
              ],
              [
                53.9152711,
                31.804885
              ],
              [
                53.9163845,
                31.8048849
              ],
              [
                53.9172177,
                31.8046051
              ],
              [
                53.9183278,
                31.8046051
              ],
              [
                53.9280509,
                31.8015534
              ],
              [
                53.9324942,
                31.7996031
              ],
              [
                53.9380508,
                31.7982218
              ],
              [
                53.9611072,
                31.7946012
              ],
              [
                53.9627738,
                31.7946012
              ],
              [
                53.9644404,
                31.7940504
              ],
              [
                53.9688871,
                31.7934997
              ],
              [
                53.9694404,
                31.7932198
              ],
              [
                53.9705537,
                31.7932197
              ],
              [
                53.971107,
                31.7929399
              ],
              [
                53.9719404,
                31.7929399
              ],
              [
                53.9805536,
                31.7887686
              ],
              [
                53.9811113,
                31.7884978
              ],
              [
                53.9819436,
                31.7882179
              ],
              [
                53.9824968,
                31.787938
              ],
              [
                53.99861,
                31.7743226
              ],
              [
                53.9998262,
                31.771896
              ],
              [
                54.0002767,
                31.7698805
              ],
              [
                54.0019433,
                31.7698805
              ],
              [
                54.0022199,
                31.7701603
              ],
              [
                54.0033333,
                31.7701603
              ],
              [
                54.0036099,
                31.7698805
              ],
              [
                54.0083332,
                31.7698805
              ],
              [
                54.0088865,
                31.7701604
              ],
              [
                54.0102765,
                31.7701604
              ],
              [
                54.0105531,
                31.7698805
              ],
              [
                54.014443,
                31.7698804
              ],
              [
                54.0299996,
                31.7673794
              ],
              [
                54.0313895,
                31.7673795
              ],
              [
                54.0394461,
                31.7654383
              ],
              [
                54.0402794,
                31.7654383
              ],
              [
                54.0413894,
                31.7651584
              ],
              [
                54.0505559,
                31.7623866
              ],
              [
                54.0513893,
                31.7618269
              ],
              [
                54.0591693,
                31.7601566
              ],
              [
                54.0866688,
                31.7573847
              ],
              [
                54.0944487,
                31.7573847
              ],
              [
                54.098892,
                31.7568249
              ],
              [
                54.1019486,
                31.7568249
              ],
              [
                54.1036152,
                31.7565541
              ],
              [
                54.1144484,
                31.7568249
              ],
              [
                54.1161151,
                31.7571048
              ],
              [
                54.1205583,
                31.7571048
              ],
              [
                54.1300048,
                31.7584953
              ],
              [
                54.141948,
                31.7621068
              ],
              [
                54.1711177,
                31.7771034
              ],
              [
                54.1716743,
                31.7776632
              ],
              [
                54.2113971,
                31.8157196
              ],
              [
                54.2116509,
                31.8162331
              ],
              [
                54.2116532,
                31.8162379
              ],
              [
                54.2116737,
                31.8162793
              ],
              [
                54.2119537,
                31.8165502
              ],
              [
                54.2069538,
                31.8193311
              ],
              [
                54.2069538,
                31.819611
              ],
              [
                54.2058404,
                31.8196109
              ],
              [
                54.2052872,
                31.8198818
              ],
              [
                54.2041738,
                31.8201617
              ],
              [
                54.1627844,
                31.8401606
              ],
              [
                54.1483379,
                31.8509952
              ],
              [
                54.144728,
                31.8579384
              ],
              [
                54.1447279,
                31.859049
              ],
              [
                54.144728,
                31.8596088
              ],
              [
                54.1450046,
                31.8604395
              ],
              [
                54.1452812,
                31.8623898
              ],
              [
                54.1460457,
                31.8650555
              ],
              [
                54.1463944,
                31.8662713
              ],
              [
                54.1463946,
                31.8662721
              ],
              [
                54.1963974,
                31.9301611
              ],
              [
                54.1965648,
                31.9305001
              ],
              [
                54.1969505,
                31.9312806
              ],
              [
                54.1980639,
                31.932942
              ],
              [
                54.174563,
                31.9394839
              ],
              [
                54.1827841,
                31.9462779
              ],
              [
                54.1833407,
                31.9471085
              ],
              [
                54.1841741,
                31.9476684
              ],
              [
                54.220287,
                31.9837756
              ],
              [
                54.220287,
                31.9840555
              ],
              [
                54.220287,
                31.9843567
              ],
              [
                54.2198923,
                31.9847278
              ],
              [
                54.2189635,
                31.9856011
              ],
              [
                54.2177747,
                31.9867188
              ],
              [
                54.2171413,
                31.9873144
              ],
              [
                54.2163785,
                31.9880315
              ],
              [
                54.2160558,
                31.9883348
              ],
              [
                54.215287,
                31.9890576
              ],
              [
                54.2151685,
                31.989886
              ],
              [
                54.2148778,
                31.9919185
              ],
              [
                54.2147304,
                31.9929491
              ],
              [
                54.2158403,
                31.9990936
              ],
              [
                54.2205093,
                32.001531
              ],
              [
                54.2254062,
                32.004087
              ],
              [
                54.2269536,
                32.0048947
              ],
              [
                54.2452866,
                32.0235037
              ],
              [
                54.2738996,
                32.0426636
              ],
              [
                54.2752896,
                32.0440631
              ],
              [
                54.2841795,
                32.0487763
              ],
              [
                54.2913993,
                32.0512774
              ],
              [
                54.3275122,
                32.0732274
              ],
              [
                54.3439019,
                32.0785005
              ],
              [
                54.3506771,
                32.0811685
              ],
              [
                54.3608484,
                32.085173
              ],
              [
                54.4016846,
                32.0954483
              ],
              [
                54.4030711,
                32.0954483
              ],
              [
                54.4127943,
                32.0985001
              ],
              [
                54.4130743,
                32.0987801
              ],
              [
                54.4141844,
                32.09878
              ],
              [
                54.4164077,
                32.0996198
              ],
              [
                54.417241,
                32.0998907
              ],
              [
                54.4275175,
                32.1037823
              ],
              [
                54.4333507,
                32.1073939
              ],
              [
                54.4339075,
                32.1073939
              ],
              [
                54.4377974,
                32.1115565
              ],
              [
                54.4377974,
                32.1123961
              ],
              [
                54.4286275,
                32.1271138
              ],
              [
                54.4284333,
                32.1275901
              ],
              [
                54.4247173,
                32.125993
              ],
              [
                54.3952946,
                32.1582197
              ],
              [
                54.3939047,
                32.1598902
              ],
              [
                54.3511605,
                32.2044032
              ],
              [
                54.3466819,
                32.2090638
              ],
              [
                54.3455686,
                32.2096145
              ],
              [
                54.344182,
                32.2110051
              ],
              [
                54.3408487,
                32.2132263
              ],
              [
                54.3402921,
                32.2137861
              ],
              [
                54.3412182,
                32.2187771
              ],
              [
                54.3398462,
                32.2190464
              ],
              [
                54.3384967,
                32.2178377
              ],
              [
                54.3333609,
                32.21693
              ],
              [
                54.3291756,
                32.2161418
              ],
              [
                54.3193262,
                32.2150888
              ],
              [
                54.3004847,
                32.2113363
              ],
              [
                54.284848,
                32.2091256
              ],
              [
                54.2552864,
                32.2029509
              ],
              [
                54.2544532,
                32.2029509
              ],
              [
                54.2485746,
                32.201919
              ],
              [
                54.2421219,
                32.1997402
              ],
              [
                54.2266102,
                32.1975598
              ],
              [
                54.1738662,
                32.1878806
              ],
              [
                54.1681213,
                32.1854109
              ],
              [
                54.1660949,
                32.1797918
              ],
              [
                54.1638029,
                32.1728139
              ],
              [
                54.1581123,
                32.1599101
              ],
              [
                54.1550224,
                32.1494463
              ],
              [
                54.151469,
                32.1422517
              ],
              [
                54.1446197,
                32.1356889
              ],
              [
                54.1378992,
                32.1325708
              ],
              [
                54.1298912,
                32.129976
              ],
              [
                54.1220377,
                32.1275774
              ],
              [
                54.1182783,
                32.1251787
              ],
              [
                54.1132572,
                32.1221257
              ],
              [
                54.0971382,
                32.1183311
              ],
              [
                54.0824096,
                32.1150598
              ],
              [
                54.0723932,
                32.1129225
              ],
              [
                54.0567377,
                32.1094547
              ],
              [
                54.0090244,
                32.0979162
              ],
              [
                53.9994512,
                32.0950222
              ],
              [
                53.9958299,
                32.0948885
              ],
              [
                53.9947201,
                32.0959991
              ],
              [
                53.9944434,
                32.0962789
              ],
              [
                53.9791636,
                32.1198904
              ],
              [
                53.9769402,
                32.1235022
              ],
              [
                53.9733303,
                32.1271139
              ],
              [
                53.966107,
                32.1343372
              ],
              [
                53.9547172,
                32.1290642
              ],
              [
                53.9544406,
                32.1287843
              ],
              [
                53.9538839,
                32.1287842
              ],
              [
                53.9533306,
                32.1282245
              ],
              [
                53.9497173,
                32.126843
              ],
              [
                53.9488839,
                32.1260032
              ],
              [
                53.947774,
                32.1254434
              ],
              [
                53.9461074,
                32.1248926
              ],
              [
                53.9458748,
                32.122172
              ],
              [
                53.9220575,
                32.1097714
              ],
              [
                53.9139536,
                32.1054619
              ],
              [
                53.9024837,
                32.0990053
              ],
              [
                53.8919707,
                32.0956915
              ],
              [
                53.8500022,
                32.0811929
              ],
              [
                53.8448228,
                32.0802433
              ],
              [
                53.8247527,
                32.0760554
              ],
              [
                53.8207293,
                32.0760918
              ],
              [
                53.8149691,
                32.0760482
              ],
              [
                53.8120838,
                32.0759936
              ],
              [
                53.8067038,
                32.0759936
              ],
              [
                53.8015957,
                32.0684133
              ],
              [
                53.7918463,
                32.0556943
              ],
              [
                53.7828825,
                32.0399491
              ],
              [
                53.7730375,
                32.0188405
              ],
              [
                53.7678459,
                32.0120159
              ],
              [
                53.7590496,
                32.0007157
              ],
              [
                53.7498606,
                31.9911126
              ],
              [
                53.7405492,
                31.9764179
              ],
              [
                53.7233639,
                31.9516827
              ],
              [
                53.7207973,
                31.9472156
              ],
              [
                53.7171618,
                31.9413068
              ],
              [
                53.7126897,
                31.9306436
              ],
              [
                53.7088463,
                31.9200921
              ],
              [
                53.7065065,
                31.9103512
              ],
              [
                53.7056743,
                31.8984967
              ],
              [
                53.7054168,
                31.8785607
              ],
              [
                53.7022412,
                31.8576347
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554910,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بافق",
          "name:ar": "مقاطعة بافق",
          "name:en": "Bafq County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1287792",
          "wikipedia": "en:Bafq County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.7189201,
                31.9659973
              ],
              [
                54.7180868,
                31.9634963
              ],
              [
                54.7253101,
                31.958774
              ],
              [
                54.7628095,
                31.9284996
              ],
              [
                54.7983691,
                31.9015571
              ],
              [
                54.8036456,
                31.8962752
              ],
              [
                54.8122589,
                31.8885012
              ],
              [
                54.8133688,
                31.8873817
              ],
              [
                54.8383685,
                31.8654414
              ],
              [
                54.8389251,
                31.8604394
              ],
              [
                54.8386484,
                31.8590489
              ],
              [
                54.8383684,
                31.858778
              ],
              [
                54.8380918,
                31.8576585
              ],
              [
                54.8269786,
                31.841551
              ],
              [
                54.8233687,
                31.8368288
              ],
              [
                54.8186454,
                31.8321068
              ],
              [
                54.8178121,
                31.8312761
              ],
              [
                54.7808659,
                31.7887685
              ],
              [
                54.7755893,
                31.7773832
              ],
              [
                54.7755894,
                31.7768235
              ],
              [
                54.7753127,
                31.7759928
              ],
              [
                54.773646,
                31.768499
              ],
              [
                54.7736138,
                31.7681149
              ],
              [
                54.773366,
                31.7651583
              ],
              [
                54.7730893,
                31.7632172
              ],
              [
                54.7728127,
                31.7609961
              ],
              [
                54.7725327,
                31.758766
              ],
              [
                54.772256,
                31.7557143
              ],
              [
                54.7719794,
                31.7529425
              ],
              [
                54.7716994,
                31.7504415
              ],
              [
                54.7714227,
                31.7490511
              ],
              [
                54.7697561,
                31.7418282
              ],
              [
                54.769476,
                31.739878
              ],
              [
                54.7691994,
                31.7365464
              ],
              [
                54.7689228,
                31.7340454
              ],
              [
                54.7686948,
                31.7326934
              ],
              [
                54.7686427,
                31.7323841
              ],
              [
                54.768366,
                31.7321042
              ],
              [
                54.7683661,
                31.7315445
              ],
              [
                54.7666994,
                31.7268225
              ],
              [
                54.7658661,
                31.7232111
              ],
              [
                54.7666994,
                31.7223805
              ],
              [
                54.773646,
                31.7195996
              ],
              [
                54.774756,
                31.7195996
              ],
              [
                54.7761459,
                31.718769
              ],
              [
                54.7769793,
                31.7187689
              ],
              [
                54.7769793,
                31.7184891
              ],
              [
                54.7789226,
                31.7176585
              ],
              [
                54.7828125,
                31.7154374
              ],
              [
                54.7833659,
                31.7151575
              ],
              [
                54.7836458,
                31.715019
              ],
              [
                54.7844792,
                31.7146068
              ],
              [
                54.7875324,
                31.7132163
              ],
              [
                54.7997556,
                31.7084944
              ],
              [
                54.8003122,
                31.7079347
              ],
              [
                54.8158688,
                31.700161
              ],
              [
                54.817812,
                31.6996102
              ],
              [
                54.847815,
                31.6823837
              ],
              [
                54.8683714,
                31.6695993
              ],
              [
                54.8714279,
                31.6676582
              ],
              [
                54.9736532,
                31.607935
              ],
              [
                54.9794864,
                31.6043237
              ],
              [
                55.0586587,
                31.5523748
              ],
              [
                55.0719918,
                31.5382094
              ],
              [
                55.0736584,
                31.5362684
              ],
              [
                55.0772683,
                31.5326571
              ],
              [
                55.077825,
                31.5315467
              ],
              [
                55.1056047,
                31.493493
              ],
              [
                55.1058813,
                31.4923736
              ],
              [
                55.1072713,
                31.4901527
              ],
              [
                55.1150478,
                31.4643235
              ],
              [
                55.1169945,
                31.459042
              ],
              [
                55.1225476,
                31.4376548
              ],
              [
                55.1228277,
                31.4357048
              ],
              [
                55.1306042,
                31.3879294
              ],
              [
                55.1311609,
                31.386819
              ],
              [
                55.1419941,
                31.347097
              ],
              [
                55.1428273,
                31.3437658
              ],
              [
                55.1508839,
                31.3179289
              ],
              [
                55.1550505,
                31.3065451
              ],
              [
                55.1556071,
                31.3059854
              ],
              [
                55.1559775,
                31.3052423
              ],
              [
                55.1561605,
                31.304875
              ],
              [
                55.1564405,
                31.3034848
              ],
              [
                55.1592171,
                31.297653
              ],
              [
                55.1592171,
                31.2968134
              ],
              [
                55.1783834,
                31.253202
              ],
              [
                55.1797734,
                31.2509813
              ],
              [
                55.1806068,
                31.2487605
              ],
              [
                55.1842167,
                31.242649
              ],
              [
                55.1861634,
                31.2401485
              ],
              [
                55.1861633,
                31.2398686
              ],
              [
                55.2158863,
                31.2173727
              ],
              [
                55.2186629,
                31.2145923
              ],
              [
                55.2200529,
                31.2137617
              ],
              [
                55.2572756,
                31.1820944
              ],
              [
                55.2586656,
                31.1804245
              ],
              [
                55.2592224,
                31.1798738
              ],
              [
                55.2639455,
                31.1720925
              ],
              [
                55.2644989,
                31.1698718
              ],
              [
                55.2650556,
                31.1690323
              ],
              [
                55.2681122,
                31.1593192
              ],
              [
                55.2694988,
                31.1509782
              ],
              [
                55.270332,
                31.1407055
              ],
              [
                55.2742221,
                31.1282033
              ],
              [
                55.2761652,
                31.1198714
              ],
              [
                55.2761653,
                31.1190319
              ],
              [
                55.2769986,
                31.1148705
              ],
              [
                55.2778319,
                31.1151413
              ],
              [
                55.2878352,
                31.1176418
              ],
              [
                55.2881119,
                31.1179216
              ],
              [
                55.2892217,
                31.1179215
              ],
              [
                55.3128348,
                31.1262534
              ],
              [
                55.3150581,
                31.1270929
              ],
              [
                55.325058,
                31.1295934
              ],
              [
                55.326168,
                31.1295933
              ],
              [
                55.3661709,
                31.1420956
              ],
              [
                55.3767273,
                31.1445961
              ],
              [
                55.399507,
                31.1518177
              ],
              [
                55.4195067,
                31.1601496
              ],
              [
                55.4247832,
                31.1618105
              ],
              [
                55.4431198,
                31.1684815
              ],
              [
                55.4595095,
                31.1754234
              ],
              [
                55.4600628,
                31.1754233
              ],
              [
                55.4606195,
                31.1759831
              ],
              [
                55.4850659,
                31.1829248
              ],
              [
                55.4878424,
                31.1834846
              ],
              [
                55.4886758,
                31.1840352
              ],
              [
                55.4917323,
                31.1848657
              ],
              [
                55.4925657,
                31.1854254
              ],
              [
                55.494789,
                31.185976
              ],
              [
                55.5000655,
                31.1884855
              ],
              [
                55.5056222,
                31.190986
              ],
              [
                55.5803478,
                31.2309766
              ],
              [
                55.5811811,
                31.2315362
              ],
              [
                55.5811812,
                31.2318161
              ],
              [
                55.6009042,
                31.2437592
              ],
              [
                55.6070141,
                31.245709
              ],
              [
                55.6364604,
                31.2498707
              ],
              [
                55.6489601,
                31.2507102
              ],
              [
                55.6686832,
                31.2537614
              ],
              [
                55.6711832,
                31.2537614
              ],
              [
                55.6781298,
                31.2545919
              ],
              [
                55.6847964,
                31.2559821
              ],
              [
                55.7181326,
                31.2665441
              ],
              [
                55.7195192,
                31.2673747
              ],
              [
                55.7400756,
                31.2745965
              ],
              [
                55.7550788,
                31.2823692
              ],
              [
                55.7556321,
                31.282649
              ],
              [
                55.7564654,
                31.2829289
              ],
              [
                55.7589654,
                31.2840393
              ],
              [
                55.7595221,
                31.2845989
              ],
              [
                55.7597987,
                31.2848698
              ],
              [
                55.7656319,
                31.28793
              ],
              [
                55.7659121,
                31.2884807
              ],
              [
                55.7728552,
                31.2912612
              ],
              [
                55.8203577,
                31.3132071
              ],
              [
                55.8231345,
                31.3148681
              ],
              [
                55.8298045,
                31.318759
              ],
              [
                55.8342477,
                31.3209888
              ],
              [
                55.8436909,
                31.3245998
              ],
              [
                55.8456376,
                31.3251505
              ],
              [
                55.9267531,
                31.3673728
              ],
              [
                55.9348064,
                31.3732047
              ],
              [
                55.9384197,
                31.3768158
              ],
              [
                55.9435367,
                31.3874806
              ],
              [
                55.9450862,
                31.3907095
              ],
              [
                55.9450862,
                31.39182
              ],
              [
                55.9461962,
                31.395431
              ],
              [
                55.9556427,
                31.416818
              ],
              [
                55.9556427,
                31.4176575
              ],
              [
                55.9564761,
                31.4195986
              ],
              [
                55.9592527,
                31.4248709
              ],
              [
                55.9639761,
                31.4307118
              ],
              [
                55.9656427,
                31.4315425
              ],
              [
                55.9670326,
                31.4329328
              ],
              [
                55.9964755,
                31.4484878
              ],
              [
                56.0128652,
                31.4648737
              ],
              [
                56.0178685,
                31.4759872
              ],
              [
                56.0181454,
                31.4773774
              ],
              [
                56.0195354,
                31.4854305
              ],
              [
                56.0195353,
                31.4868207
              ],
              [
                56.0198119,
                31.4876514
              ],
              [
                56.0200885,
                31.490432
              ],
              [
                56.0203686,
                31.4926529
              ],
              [
                56.0206451,
                31.4954336
              ],
              [
                56.0200885,
                31.506818
              ],
              [
                56.0198119,
                31.5084883
              ],
              [
                56.0200885,
                31.5090389
              ],
              [
                56.0206452,
                31.5218228
              ],
              [
                56.0209219,
                31.5259847
              ],
              [
                56.0212021,
                31.5357171
              ],
              [
                56.0214787,
                31.5384888
              ],
              [
                56.0217552,
                31.5409896
              ],
              [
                56.0220352,
                31.5429306
              ],
              [
                56.0223119,
                31.5448808
              ],
              [
                56.0239785,
                31.5543243
              ],
              [
                56.0259219,
                31.5593169
              ],
              [
                56.0289786,
                31.5640478
              ],
              [
                56.0292551,
                31.5648783
              ],
              [
                56.0350885,
                31.5704307
              ],
              [
                56.0420352,
                31.5734913
              ],
              [
                56.0489782,
                31.5751525
              ],
              [
                56.0525915,
                31.5759921
              ],
              [
                56.053425,
                31.5759921
              ],
              [
                56.0537016,
                31.576272
              ],
              [
                56.0567583,
                31.5762721
              ],
              [
                56.0581481,
                31.5765429
              ],
              [
                56.059222,
                31.5765428
              ],
              [
                56.0628098,
                31.5786875
              ],
              [
                56.0875442,
                31.5856679
              ],
              [
                56.0934911,
                31.5873453
              ],
              [
                56.0995661,
                31.5867636
              ],
              [
                56.1078044,
                31.5886051
              ],
              [
                56.1110169,
                31.5900845
              ],
              [
                56.1123872,
                31.5907155
              ],
              [
                56.1137004,
                31.590709
              ],
              [
                56.115575,
                31.5908616
              ],
              [
                56.1211953,
                31.5906712
              ],
              [
                56.1218783,
                31.5905063
              ],
              [
                56.1251592,
                31.5897145
              ],
              [
                56.1289493,
                31.5878262
              ],
              [
                56.1342837,
                31.5851004
              ],
              [
                56.1393405,
                31.5806838
              ],
              [
                56.14341,
                31.5719498
              ],
              [
                56.1469394,
                31.566504
              ],
              [
                56.1510771,
                31.5601186
              ],
              [
                56.1605022,
                31.5526083
              ],
              [
                56.1784286,
                31.5483171
              ],
              [
                56.1786707,
                31.5483183
              ],
              [
                56.1947249,
                31.5611311
              ],
              [
                56.2019214,
                31.5741572
              ],
              [
                56.2045096,
                31.5978376
              ],
              [
                56.1809918,
                31.6221057
              ],
              [
                56.1566591,
                31.6406029
              ],
              [
                56.1238556,
                31.6496658
              ],
              [
                56.0937878,
                31.6475365
              ],
              [
                56.0587691,
                31.6313141
              ],
              [
                56.0378684,
                31.6334938
              ],
              [
                56.0312019,
                31.6376559
              ],
              [
                56.0275886,
                31.6446078
              ],
              [
                56.0270353,
                31.6470997
              ],
              [
                56.0253687,
                31.6515508
              ],
              [
                56.0245355,
                31.6540426
              ],
              [
                55.9911991,
                31.6954385
              ],
              [
                55.9870327,
                31.69877
              ],
              [
                55.9856426,
                31.7007202
              ],
              [
                55.9856426,
                31.701271
              ],
              [
                55.9853659,
                31.7012709
              ],
              [
                55.9800893,
                31.7076632
              ],
              [
                55.9784194,
                31.7165473
              ],
              [
                55.9781426,
                31.7179377
              ],
              [
                55.9759194,
                31.7246009
              ],
              [
                55.9667528,
                31.7362659
              ],
              [
                55.9661997,
                31.7371056
              ],
              [
                55.9609197,
                31.7418276
              ],
              [
                55.9398066,
                31.7609955
              ],
              [
                55.9350868,
                31.7673788
              ],
              [
                55.9348067,
                31.7682185
              ],
              [
                55.9339733,
                31.7690491
              ],
              [
                55.9311967,
                31.7748817
              ],
              [
                55.9306401,
                31.7896076
              ],
              [
                55.9317535,
                31.7937698
              ],
              [
                55.9320301,
                31.7946005
              ],
              [
                55.9325868,
                31.7965507
              ],
              [
                55.9325868,
                31.7968306
              ],
              [
                55.9325868,
                31.7973813
              ],
              [
                55.9320301,
                31.7973813
              ],
              [
                55.9317535,
                31.7976613
              ],
              [
                55.93064,
                31.7976612
              ],
              [
                55.9284201,
                31.7984919
              ],
              [
                55.9248069,
                31.7984919
              ],
              [
                55.9245301,
                31.7987718
              ],
              [
                55.9217502,
                31.7987718
              ],
              [
                55.9211969,
                31.7984919
              ],
              [
                55.9164735,
                31.7984919
              ],
              [
                55.9159169,
                31.798221
              ],
              [
                55.9142503,
                31.798221
              ],
              [
                55.9036972,
                31.7962709
              ],
              [
                55.9017504,
                31.7962709
              ],
              [
                55.9006407,
                31.7962709
              ],
              [
                55.8995272,
                31.7962708
              ],
              [
                55.8989738,
                31.7959909
              ],
              [
                55.8961939,
                31.795991
              ],
              [
                55.8950839,
                31.7957201
              ],
              [
                55.8775842,
                31.795991
              ],
              [
                55.8767509,
                31.7962709
              ],
              [
                55.8739708,
                31.7962709
              ],
              [
                55.8598045,
                31.7940498
              ],
              [
                55.8584145,
                31.7940499
              ],
              [
                55.8548044,
                31.7932191
              ],
              [
                55.8531378,
                31.7932191
              ],
              [
                55.8481379,
                31.7921086
              ],
              [
                55.845638,
                31.7921086
              ],
              [
                55.8445245,
                31.7918287
              ],
              [
                55.8342482,
                31.7918288
              ],
              [
                55.8292483,
                31.7929393
              ],
              [
                55.8059119,
                31.8026633
              ],
              [
                55.8053586,
                31.8032231
              ],
              [
                55.8048019,
                31.803223
              ],
              [
                55.8042452,
                31.8037738
              ],
              [
                55.8014687,
                31.8054351
              ],
              [
                55.7697989,
                31.8396093
              ],
              [
                55.7550794,
                31.8629399
              ],
              [
                55.7547993,
                31.8634997
              ],
              [
                55.7486894,
                31.8740546
              ],
              [
                55.7484092,
                31.8751651
              ],
              [
                55.7439661,
                31.8818284
              ],
              [
                55.7434094,
                31.8821083
              ],
              [
                55.7431329,
                31.8832189
              ],
              [
                55.7370229,
                31.8915526
              ],
              [
                55.7334096,
                31.8979451
              ],
              [
                55.7278531,
                31.9043286
              ],
              [
                55.715713,
                31.9119333
              ],
              [
                55.69591,
                31.9243368
              ],
              [
                55.6945202,
                31.9248876
              ],
              [
                55.6889634,
                31.9262691
              ],
              [
                55.6728505,
                31.9307204
              ],
              [
                55.6714637,
                31.9307203
              ],
              [
                55.6170146,
                31.9471081
              ],
              [
                55.6159046,
                31.9471081
              ],
              [
                55.6109047,
                31.9484986
              ],
              [
                55.6089613,
                31.9493292
              ],
              [
                55.6086813,
                31.9496092
              ],
              [
                55.607848,
                31.949889
              ],
              [
                55.5839583,
                31.9609948
              ],
              [
                55.5759018,
                31.9637757
              ],
              [
                55.5584021,
                31.9712789
              ],
              [
                55.5511788,
                31.9743308
              ],
              [
                55.5406223,
                31.9804434
              ],
              [
                55.5353457,
                31.9859963
              ],
              [
                55.5353457,
                31.9982217
              ],
              [
                55.5203459,
                32.0340583
              ],
              [
                55.5197893,
                32.0368393
              ],
              [
                55.5195127,
                32.0393314
              ],
              [
                55.5192326,
                32.0398912
              ],
              [
                55.5167326,
                32.0635025
              ],
              [
                55.5158993,
                32.0740577
              ],
              [
                55.5153461,
                32.0773895
              ],
              [
                55.5153461,
                32.086554
              ],
              [
                55.5092328,
                32.1465625
              ],
              [
                55.5075663,
                32.1723953
              ],
              [
                55.5067329,
                32.1765578
              ],
              [
                55.5064563,
                32.1773885
              ],
              [
                55.5064562,
                32.1778445
              ],
              [
                55.5000663,
                32.1754472
              ],
              [
                55.4878431,
                32.1729462
              ],
              [
                55.4823554,
                32.1720093
              ],
              [
                55.4216224,
                32.1572746
              ],
              [
                55.361066,
                32.1528069
              ],
              [
                55.3279193,
                32.1608915
              ],
              [
                55.3004409,
                32.143161
              ],
              [
                55.2609545,
                32.130697
              ],
              [
                55.1911105,
                32.1082167
              ],
              [
                55.1853305,
                32.1107256
              ],
              [
                55.1422711,
                32.0987798
              ],
              [
                55.1217147,
                32.0948883
              ],
              [
                55.1186615,
                32.0946174
              ],
              [
                55.1144948,
                32.0937777
              ],
              [
                55.1114382,
                32.0937777
              ],
              [
                55.0942151,
                32.0915565
              ],
              [
                55.0583789,
                32.0857236
              ],
              [
                55.0569923,
                32.0851729
              ],
              [
                55.0269893,
                32.0779494
              ],
              [
                55.0197661,
                32.0765589
              ],
              [
                54.9289307,
                32.0610016
              ],
              [
                54.9111509,
                32.0559995
              ],
              [
                54.9055943,
                32.0540582
              ],
              [
                54.8880945,
                32.0485053
              ],
              [
                54.8853179,
                32.0479455
              ],
              [
                54.8842046,
                32.0473857
              ],
              [
                54.8800381,
                32.0465551
              ],
              [
                54.877538,
                32.0457244
              ],
              [
                54.8639249,
                32.0429434
              ],
              [
                54.8447584,
                32.0398915
              ],
              [
                54.8417018,
                32.0396116
              ],
              [
                54.8400352,
                32.0390518
              ],
              [
                54.8197588,
                32.0334988
              ],
              [
                54.7789227,
                32.0112782
              ],
              [
                54.7497531,
                31.996531
              ],
              [
                54.749753,
                31.9954411
              ],
              [
                54.7498444,
                31.9952613
              ],
              [
                54.7500331,
                31.9948903
              ],
              [
                54.7503098,
                31.9932199
              ],
              [
                54.7489198,
                31.9890575
              ],
              [
                54.746236,
                31.9868274
              ],
              [
                54.7461431,
                31.9868273
              ],
              [
                54.7458665,
                31.9865565
              ],
              [
                54.7455865,
                31.9862765
              ],
              [
                54.7255867,
                31.9707195
              ],
              [
                54.7253101,
                31.9701687
              ],
              [
                54.7236435,
                31.9684983
              ],
              [
                54.7189201,
                31.9659973
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554942,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان بهاباد",
          "name:en": "Behabad County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q2407851",
          "wikipedia": "en:Behabad County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                55.5064562,
                32.1778445
              ],
              [
                55.5064563,
                32.1773885
              ],
              [
                55.5067329,
                32.1765578
              ],
              [
                55.5075663,
                32.1723953
              ],
              [
                55.5092328,
                32.1465625
              ],
              [
                55.5153461,
                32.086554
              ],
              [
                55.5153461,
                32.0773895
              ],
              [
                55.5158993,
                32.0740577
              ],
              [
                55.5167326,
                32.0635025
              ],
              [
                55.5192326,
                32.0398912
              ],
              [
                55.5195127,
                32.0393314
              ],
              [
                55.5197893,
                32.0368393
              ],
              [
                55.5203459,
                32.0340583
              ],
              [
                55.5353457,
                31.9982217
              ],
              [
                55.5353457,
                31.9859963
              ],
              [
                55.5406223,
                31.9804434
              ],
              [
                55.5511788,
                31.9743308
              ],
              [
                55.5584021,
                31.9712789
              ],
              [
                55.5759018,
                31.9637757
              ],
              [
                55.5839583,
                31.9609948
              ],
              [
                55.607848,
                31.949889
              ],
              [
                55.6086813,
                31.9496092
              ],
              [
                55.6089613,
                31.9493292
              ],
              [
                55.6109047,
                31.9484986
              ],
              [
                55.6159046,
                31.9471081
              ],
              [
                55.6170146,
                31.9471081
              ],
              [
                55.6714637,
                31.9307203
              ],
              [
                55.6728505,
                31.9307204
              ],
              [
                55.6889634,
                31.9262691
              ],
              [
                55.6945202,
                31.9248876
              ],
              [
                55.69591,
                31.9243368
              ],
              [
                55.715713,
                31.9119333
              ],
              [
                55.7278531,
                31.9043286
              ],
              [
                55.7334096,
                31.8979451
              ],
              [
                55.7370229,
                31.8915526
              ],
              [
                55.7431329,
                31.8832189
              ],
              [
                55.7434094,
                31.8821083
              ],
              [
                55.7439661,
                31.8818284
              ],
              [
                55.7484092,
                31.8751651
              ],
              [
                55.7486894,
                31.8740546
              ],
              [
                55.7547993,
                31.8634997
              ],
              [
                55.7550794,
                31.8629399
              ],
              [
                55.7697989,
                31.8396093
              ],
              [
                55.8014687,
                31.8054351
              ],
              [
                55.8042452,
                31.8037738
              ],
              [
                55.8048019,
                31.803223
              ],
              [
                55.8053586,
                31.8032231
              ],
              [
                55.8059119,
                31.8026633
              ],
              [
                55.8292483,
                31.7929393
              ],
              [
                55.8342482,
                31.7918288
              ],
              [
                55.8445245,
                31.7918287
              ],
              [
                55.845638,
                31.7921086
              ],
              [
                55.8481379,
                31.7921086
              ],
              [
                55.8531378,
                31.7932191
              ],
              [
                55.8548044,
                31.7932191
              ],
              [
                55.8584145,
                31.7940499
              ],
              [
                55.8598045,
                31.7940498
              ],
              [
                55.8739708,
                31.7962709
              ],
              [
                55.8767509,
                31.7962709
              ],
              [
                55.8775842,
                31.795991
              ],
              [
                55.8950839,
                31.7957201
              ],
              [
                55.8961939,
                31.795991
              ],
              [
                55.8989738,
                31.7959909
              ],
              [
                55.8995272,
                31.7962708
              ],
              [
                55.9006407,
                31.7962709
              ],
              [
                55.9017504,
                31.7962709
              ],
              [
                55.9036972,
                31.7962709
              ],
              [
                55.9142503,
                31.798221
              ],
              [
                55.9159169,
                31.798221
              ],
              [
                55.9164735,
                31.7984919
              ],
              [
                55.9211969,
                31.7984919
              ],
              [
                55.9217502,
                31.7987718
              ],
              [
                55.9245301,
                31.7987718
              ],
              [
                55.9248069,
                31.7984919
              ],
              [
                55.9284201,
                31.7984919
              ],
              [
                55.93064,
                31.7976612
              ],
              [
                55.9317535,
                31.7976613
              ],
              [
                55.9320301,
                31.7973813
              ],
              [
                55.9325868,
                31.7973813
              ],
              [
                55.9325868,
                31.7968306
              ],
              [
                55.9325868,
                31.7965507
              ],
              [
                55.9320301,
                31.7946005
              ],
              [
                55.9317535,
                31.7937698
              ],
              [
                55.9306401,
                31.7896076
              ],
              [
                55.9311967,
                31.7748817
              ],
              [
                55.9339733,
                31.7690491
              ],
              [
                55.9348067,
                31.7682185
              ],
              [
                55.9350868,
                31.7673788
              ],
              [
                55.9398066,
                31.7609955
              ],
              [
                55.9609197,
                31.7418276
              ],
              [
                55.9661997,
                31.7371056
              ],
              [
                55.9667528,
                31.7362659
              ],
              [
                55.9759194,
                31.7246009
              ],
              [
                55.9781426,
                31.7179377
              ],
              [
                55.9784194,
                31.7165473
              ],
              [
                55.9800893,
                31.7076632
              ],
              [
                55.9853659,
                31.7012709
              ],
              [
                55.9856426,
                31.701271
              ],
              [
                55.9856426,
                31.7007202
              ],
              [
                55.9870327,
                31.69877
              ],
              [
                55.9911991,
                31.6954385
              ],
              [
                56.0245355,
                31.6540426
              ],
              [
                56.0253687,
                31.6515508
              ],
              [
                56.0270353,
                31.6470997
              ],
              [
                56.0275886,
                31.6446078
              ],
              [
                56.0312019,
                31.6376559
              ],
              [
                56.0378684,
                31.6334938
              ],
              [
                56.0587691,
                31.6313141
              ],
              [
                56.0937878,
                31.6475365
              ],
              [
                56.1238556,
                31.6496658
              ],
              [
                56.1566591,
                31.6406029
              ],
              [
                56.1809918,
                31.6221057
              ],
              [
                56.2045096,
                31.5978376
              ],
              [
                56.2019214,
                31.5741572
              ],
              [
                56.1947249,
                31.5611311
              ],
              [
                56.1786707,
                31.5483183
              ],
              [
                56.2236759,
                31.5590635
              ],
              [
                56.2323858,
                31.5596597
              ],
              [
                56.2488428,
                31.559294
              ],
              [
                56.2548249,
                31.5671193
              ],
              [
                56.2581244,
                31.5685967
              ],
              [
                56.2611479,
                31.574361
              ],
              [
                56.2688126,
                31.5921038
              ],
              [
                56.2830354,
                31.5980256
              ],
              [
                56.3103174,
                31.6081753
              ],
              [
                56.3520302,
                31.6229366
              ],
              [
                56.3936885,
                31.6368209
              ],
              [
                56.4070477,
                31.6407776
              ],
              [
                56.4174349,
                31.6449523
              ],
              [
                56.4352572,
                31.651652
              ],
              [
                56.5092944,
                31.6716453
              ],
              [
                56.5625667,
                31.6946365
              ],
              [
                56.5697538,
                31.6977379
              ],
              [
                56.5745257,
                31.7145876
              ],
              [
                56.5767812,
                31.7326539
              ],
              [
                56.5767812,
                31.737105
              ],
              [
                56.5767813,
                31.7373849
              ],
              [
                56.5770579,
                31.7376558
              ],
              [
                56.5776696,
                31.7418341
              ],
              [
                56.5734863,
                31.7479931
              ],
              [
                56.5739791,
                31.7628022
              ],
              [
                56.5746875,
                31.7799519
              ],
              [
                56.5747233,
                31.7912321
              ],
              [
                56.5765857,
                31.7981511
              ],
              [
                56.5758717,
                31.8088323
              ],
              [
                56.57735,
                31.8214695
              ],
              [
                56.5788976,
                31.8317329
              ],
              [
                56.5808908,
                31.8409051
              ],
              [
                56.5834884,
                31.8501584
              ],
              [
                56.5841499,
                31.8589685
              ],
              [
                56.5874115,
                31.8626855
              ],
              [
                56.5877932,
                31.868941
              ],
              [
                56.5888899,
                31.8784443
              ],
              [
                56.5923063,
                31.8956445
              ],
              [
                56.5957012,
                31.905348
              ],
              [
                56.5994972,
                31.9161222
              ],
              [
                56.6023487,
                31.92502
              ],
              [
                56.6028945,
                31.9312794
              ],
              [
                56.6026178,
                31.932381
              ],
              [
                56.6012279,
                31.9379428
              ],
              [
                56.6001143,
                31.9407148
              ],
              [
                56.5998378,
                31.9423851
              ],
              [
                56.5992812,
                31.9434957
              ],
              [
                56.5981712,
                31.9540507
              ],
              [
                56.5984477,
                31.9546105
              ],
              [
                56.5987278,
                31.9562718
              ],
              [
                56.5990044,
                31.9615538
              ],
              [
                56.6003946,
                31.9746098
              ],
              [
                56.600671,
                31.9754405
              ],
              [
                56.6009479,
                31.9762712
              ],
              [
                56.6015045,
                31.9810024
              ],
              [
                56.6020611,
                31.9834944
              ],
              [
                56.6023377,
                31.9857246
              ],
              [
                56.6026178,
                31.9879458
              ],
              [
                56.6026178,
                31.9887764
              ],
              [
                56.6028946,
                31.9893272
              ],
              [
                56.6031712,
                31.9904469
              ],
              [
                56.5967812,
                31.9996114
              ],
              [
                56.6162278,
                32.0329379
              ],
              [
                56.6309509,
                32.0518359
              ],
              [
                56.6312274,
                32.0523868
              ],
              [
                56.6359507,
                32.0576688
              ],
              [
                56.6528972,
                32.075998
              ],
              [
                56.6545639,
                32.0812801
              ],
              [
                56.6534506,
                32.0873839
              ],
              [
                56.6373409,
                32.1076725
              ],
              [
                56.6334509,
                32.1129457
              ],
              [
                56.5912282,
                32.1740559
              ],
              [
                56.584005,
                32.1835005
              ],
              [
                56.5756719,
                32.1915547
              ],
              [
                56.5615019,
                32.2093334
              ],
              [
                56.544559,
                32.2301732
              ],
              [
                56.5437256,
                32.2315637
              ],
              [
                56.543169,
                32.2318346
              ],
              [
                56.5426123,
                32.2326743
              ],
              [
                56.542059,
                32.2329451
              ],
              [
                56.5276123,
                32.2462816
              ],
              [
                56.5273358,
                32.2468414
              ],
              [
                56.5262225,
                32.2473922
              ],
              [
                56.498723,
                32.2757264
              ],
              [
                56.4945564,
                32.2801778
              ],
              [
                56.4942798,
                32.2809995
              ],
              [
                56.4935382,
                32.2817463
              ],
              [
                56.4934463,
                32.2818393
              ],
              [
                56.4892799,
                32.2848913
              ],
              [
                56.4812232,
                32.2898935
              ],
              [
                56.4809432,
                32.2904533
              ],
              [
                56.4801098,
                32.2907332
              ],
              [
                56.4795566,
                32.291284
              ],
              [
                56.4164975,
                32.3548962
              ],
              [
                56.4098309,
                32.3629505
              ],
              [
                56.4006644,
                32.3693433
              ],
              [
                56.3820514,
                32.3887837
              ],
              [
                56.3756614,
                32.3940659
              ],
              [
                56.374828,
                32.3948966
              ],
              [
                56.3742714,
                32.3951765
              ],
              [
                56.3739947,
                32.3954474
              ],
              [
                56.3623284,
                32.4057319
              ],
              [
                56.3209389,
                32.4551771
              ],
              [
                56.3114923,
                32.4668432
              ],
              [
                56.3053824,
                32.4771188
              ],
              [
                56.3048258,
                32.4782293
              ],
              [
                56.3048258,
                32.4779494
              ],
              [
                56.302326,
                32.4760081
              ],
              [
                56.2776027,
                32.4640622
              ],
              [
                56.260933,
                32.4573985
              ],
              [
                56.2337101,
                32.4448927
              ],
              [
                56.2309335,
                32.4432313
              ],
              [
                56.2109337,
                32.4329559
              ],
              [
                56.2078771,
                32.4310055
              ],
              [
                56.1234282,
                32.3932264
              ],
              [
                56.1200949,
                32.3912851
              ],
              [
                56.0853719,
                32.3735061
              ],
              [
                56.0742588,
                32.3682329
              ],
              [
                56.0106462,
                32.339059
              ],
              [
                55.9178641,
                32.3057315
              ],
              [
                55.8564715,
                32.2801784
              ],
              [
                55.8253586,
                32.2651716
              ],
              [
                55.8189688,
                32.2623905
              ],
              [
                55.8028589,
                32.2546162
              ],
              [
                55.7311867,
                32.2321151
              ],
              [
                55.7086869,
                32.226833
              ],
              [
                55.6200714,
                32.2021107
              ],
              [
                55.6139615,
                32.2004493
              ],
              [
                55.5900719,
                32.192666
              ],
              [
                55.5781253,
                32.189894
              ],
              [
                55.5581255,
                32.1835013
              ],
              [
                55.5484024,
                32.1812801
              ],
              [
                55.528956,
                32.178779
              ],
              [
                55.526456,
                32.1787791
              ],
              [
                55.5256226,
                32.1784991
              ],
              [
                55.5225661,
                32.1782282
              ],
              [
                55.5106229,
                32.1782282
              ],
              [
                55.5100662,
                32.1779483
              ],
              [
                55.5064562,
                32.1778445
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554965,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان تفت",
          "name:en": "Taft County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1287765",
          "wikipedia": "en:Taft County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.2029075,
                31.5889258
              ],
              [
                53.2049643,
                31.5851564
              ],
              [
                53.2060743,
                31.584046
              ],
              [
                53.2177407,
                31.5665493
              ],
              [
                53.2296873,
                31.5565459
              ],
              [
                53.2310739,
                31.5559862
              ],
              [
                53.2555202,
                31.5446016
              ],
              [
                53.2616336,
                31.5412701
              ],
              [
                53.2627435,
                31.5401596
              ],
              [
                53.2688534,
                31.535158
              ],
              [
                53.2694101,
                31.5348781
              ],
              [
                53.2910765,
                31.508209
              ],
              [
                53.3013563,
                31.4859909
              ],
              [
                53.3110796,
                31.4468184
              ],
              [
                53.3113562,
                31.4457079
              ],
              [
                53.3144129,
                31.4370953
              ],
              [
                53.3149661,
                31.4365445
              ],
              [
                53.3163561,
                31.4334841
              ],
              [
                53.3294127,
                31.4101561
              ],
              [
                53.3630255,
                31.3448764
              ],
              [
                53.3635822,
                31.3445966
              ],
              [
                53.3641354,
                31.3434861
              ],
              [
                53.3677488,
                31.3376543
              ],
              [
                53.3685821,
                31.3370946
              ],
              [
                53.3702488,
                31.3343231
              ],
              [
                53.3705254,
                31.3337634
              ],
              [
                53.3855252,
                31.3129277
              ],
              [
                53.3888585,
                31.303485
              ],
              [
                53.3899719,
                31.3020947
              ],
              [
                53.3966384,
                31.2943221
              ],
              [
                53.4016384,
                31.2857098
              ],
              [
                53.402195,
                31.28543
              ],
              [
                53.4027483,
                31.2840398
              ],
              [
                53.4034955,
                31.2830442
              ],
              [
                53.4035817,
                31.2829294
              ],
              [
                53.4166381,
                31.2565422
              ],
              [
                53.4171948,
                31.2557027
              ],
              [
                53.4441411,
                31.2157028
              ],
              [
                53.4444178,
                31.2145924
              ],
              [
                53.4449744,
                31.2140328
              ],
              [
                53.4452511,
                31.2129225
              ],
              [
                53.4458078,
                31.2123718
              ],
              [
                53.4483077,
                31.2062604
              ],
              [
                53.4483078,
                31.2059806
              ],
              [
                53.4508077,
                31.2009795
              ],
              [
                53.4513643,
                31.2001489
              ],
              [
                53.451641,
                31.1998691
              ],
              [
                53.4521977,
                31.1998691
              ],
              [
                53.4521977,
                31.1995893
              ],
              [
                53.4585842,
                31.1956986
              ],
              [
                53.4602508,
                31.1940375
              ],
              [
                53.4713641,
                31.1893164
              ],
              [
                53.4727541,
                31.1893164
              ],
              [
                53.4735873,
                31.1890366
              ],
              [
                53.475254,
                31.1887658
              ],
              [
                53.4785874,
                31.1887658
              ],
              [
                53.4796973,
                31.1884859
              ],
              [
                53.4846971,
                31.1884859
              ],
              [
                53.4858072,
                31.1887657
              ],
              [
                53.4888638,
                31.1887657
              ],
              [
                53.4902538,
                31.1890365
              ],
              [
                53.4933104,
                31.1890365
              ],
              [
                53.4941438,
                31.1893164
              ],
              [
                53.4955303,
                31.1893164
              ],
              [
                53.5172001,
                31.1932071
              ],
              [
                53.5224767,
                31.1948681
              ],
              [
                53.52609,
                31.1959875
              ],
              [
                53.5413664,
                31.2004288
              ],
              [
                53.5421997,
                31.2009795
              ],
              [
                53.5502562,
                31.2051501
              ],
              [
                53.5527562,
                31.2073707
              ],
              [
                53.5558129,
                31.2126517
              ],
              [
                53.5560896,
                31.2140328
              ],
              [
                53.5566462,
                31.2195936
              ],
              [
                53.5563662,
                31.2232045
              ],
              [
                53.5560895,
                31.2268153
              ],
              [
                53.5558129,
                31.2270952
              ],
              [
                53.5574794,
                31.2384786
              ],
              [
                53.5588661,
                31.2401487
              ],
              [
                53.5619228,
                31.2432089
              ],
              [
                53.5658127,
                31.2445901
              ],
              [
                53.5669227,
                31.2445901
              ],
              [
                53.567756,
                31.24487
              ],
              [
                53.5694227,
                31.24487
              ],
              [
                53.570256,
                31.2445902
              ],
              [
                53.5727559,
                31.2440395
              ],
              [
                53.5755359,
                31.2423694
              ],
              [
                53.5808126,
                31.2340372
              ],
              [
                53.5813692,
                31.2323761
              ],
              [
                53.5833125,
                31.2304263
              ],
              [
                53.5883124,
                31.2282055
              ],
              [
                53.5891457,
                31.2282055
              ],
              [
                53.5913691,
                31.2276459
              ],
              [
                53.5927591,
                31.2276459
              ],
              [
                53.5935923,
                31.2273751
              ],
              [
                53.5997022,
                31.2279257
              ],
              [
                53.6069255,
                31.2295957
              ],
              [
                53.6083155,
                31.2295958
              ],
              [
                53.609702,
                31.2301465
              ],
              [
                53.6105354,
                31.2301464
              ],
              [
                53.612202,
                31.2304263
              ],
              [
                53.613592,
                31.2309769
              ],
              [
                53.6144254,
                31.2309769
              ],
              [
                53.6183154,
                31.2318165
              ],
              [
                53.619982,
                31.2318165
              ],
              [
                53.621372,
                31.2320964
              ],
              [
                53.6263719,
                31.232647
              ],
              [
                53.6299818,
                31.232647
              ],
              [
                53.6308151,
                31.2329269
              ],
              [
                53.6424816,
                31.2329268
              ],
              [
                53.6488716,
                31.2318165
              ],
              [
                53.6505382,
                31.2312658
              ],
              [
                53.6535949,
                31.2295958
              ],
              [
                53.7800151,
                31.1329177
              ],
              [
                53.780543,
                31.1187614
              ],
              [
                53.7838763,
                31.1082
              ],
              [
                53.784433,
                31.1034789
              ],
              [
                53.7847096,
                31.1029193
              ],
              [
                53.7838763,
                31.0990287
              ],
              [
                53.780543,
                31.0915365
              ],
              [
                53.7813763,
                31.0895958
              ],
              [
                53.7822097,
                31.0887562
              ],
              [
                53.7833231,
                31.0882057
              ],
              [
                53.7855429,
                31.0882056
              ],
              [
                53.7938796,
                31.0920962
              ],
              [
                53.7966561,
                31.0929266
              ],
              [
                53.7983228,
                31.0929266
              ],
              [
                53.7997129,
                31.0926468
              ],
              [
                53.8022128,
                31.0912566
              ],
              [
                53.802766,
                31.0895957
              ],
              [
                53.8033227,
                31.085976
              ],
              [
                53.8083226,
                31.0748732
              ],
              [
                53.8083227,
                31.0729234
              ],
              [
                53.8060994,
                31.059591
              ],
              [
                53.8063794,
                31.0587515
              ],
              [
                53.8063794,
                31.0573704
              ],
              [
                53.8102693,
                31.0495895
              ],
              [
                53.8108227,
                31.0493096
              ],
              [
                53.8122127,
                31.0431986
              ],
              [
                53.8124893,
                31.0423683
              ],
              [
                53.8127694,
                31.0384777
              ],
              [
                53.813046,
                31.0373675
              ],
              [
                53.8161026,
                31.0329264
              ],
              [
                53.8308257,
                31.0090333
              ],
              [
                53.8330456,
                31.0059734
              ],
              [
                53.8330456,
                31.0057026
              ],
              [
                53.8344356,
                31.0048631
              ],
              [
                53.8349923,
                31.0048631
              ],
              [
                53.8355456,
                31.0045833
              ],
              [
                53.8369356,
                31.0045833
              ],
              [
                53.8377688,
                31.0043125
              ],
              [
                53.8391589,
                31.0043125
              ],
              [
                53.8385106,
                30.9992507
              ],
              [
                53.8470505,
                30.9747683
              ],
              [
                53.8600943,
                30.9751954
              ],
              [
                53.8936592,
                30.9765936
              ],
              [
                53.9318705,
                30.978227
              ],
              [
                53.9791271,
                30.9792224
              ],
              [
                54.000657,
                30.9797511
              ],
              [
                54.0128987,
                30.9793832
              ],
              [
                54.0129947,
                30.9808838
              ],
              [
                54.0168142,
                30.98173
              ],
              [
                54.0294896,
                30.9822531
              ],
              [
                54.0441642,
                30.9849165
              ],
              [
                54.0606306,
                30.9829075
              ],
              [
                54.0786551,
                30.9857036
              ],
              [
                54.1009711,
                30.9861451
              ],
              [
                54.1139316,
                30.9852621
              ],
              [
                54.120283,
                30.984747
              ],
              [
                54.1248321,
                30.9851149
              ],
              [
                54.1276645,
                30.9854092
              ],
              [
                54.1305333,
                30.9874376
              ],
              [
                54.1318149,
                31.0005791
              ],
              [
                54.1323966,
                31.0129953
              ],
              [
                54.1324157,
                31.0213521
              ],
              [
                54.134304,
                31.0272124
              ],
              [
                54.133739,
                31.0471768
              ],
              [
                54.1339215,
                31.0576753
              ],
              [
                54.1334258,
                31.0626833
              ],
              [
                54.1347798,
                31.0728487
              ],
              [
                54.1349324,
                31.081149
              ],
              [
                54.1355773,
                31.0865977
              ],
              [
                54.1346224,
                31.09843
              ],
              [
                54.1345364,
                31.1081841
              ],
              [
                54.1344589,
                31.1193753
              ],
              [
                54.1338948,
                31.1515382
              ],
              [
                54.1336147,
                31.1579293
              ],
              [
                54.1327814,
                31.1668119
              ],
              [
                54.1322282,
                31.1695923
              ],
              [
                54.1286148,
                31.2254252
              ],
              [
                54.1280581,
                31.2315366
              ],
              [
                54.1275049,
                31.239589
              ],
              [
                54.1238915,
                31.3307031
              ],
              [
                54.1241717,
                31.3320934
              ],
              [
                54.1244482,
                31.3354336
              ],
              [
                54.1247248,
                31.3379342
              ],
              [
                54.1266715,
                31.3498778
              ],
              [
                54.1266716,
                31.3504284
              ],
              [
                54.1266716,
                31.3509882
              ],
              [
                54.1413947,
                31.3545993
              ],
              [
                54.1419479,
                31.3545993
              ],
              [
                54.142228,
                31.3548791
              ],
              [
                54.1430613,
                31.3548791
              ],
              [
                54.1441712,
                31.3554298
              ],
              [
                54.1572278,
                31.3584811
              ],
              [
                54.1575044,
                31.358761
              ],
              [
                54.1583377,
                31.358761
              ],
              [
                54.1588945,
                31.3590409
              ],
              [
                54.1602844,
                31.3590409
              ],
              [
                54.1613944,
                31.3593207
              ],
              [
                54.1641709,
                31.3598714
              ],
              [
                54.2000071,
                31.3637624
              ],
              [
                54.2191736,
                31.3657033
              ],
              [
                54.2505665,
                31.371815
              ],
              [
                54.2519531,
                31.3718151
              ],
              [
                54.2525097,
                31.3720949
              ],
              [
                54.2547331,
                31.3720949
              ],
              [
                54.2552864,
                31.3723748
              ],
              [
                54.2566763,
                31.3723748
              ],
              [
                54.2600097,
                31.3732054
              ],
              [
                54.2608429,
                31.3737651
              ],
              [
                54.2611229,
                31.3740449
              ],
              [
                54.2613997,
                31.3757061
              ],
              [
                54.2616763,
                31.3765366
              ],
              [
                54.2619564,
                31.3779269
              ],
              [
                54.262233,
                31.3790373
              ],
              [
                54.2625096,
                31.3804276
              ],
              [
                54.2627897,
                31.3820976
              ],
              [
                54.2630663,
                31.3837679
              ],
              [
                54.263343,
                31.3854289
              ],
              [
                54.263623,
                31.3895998
              ],
              [
                54.2638996,
                31.3926511
              ],
              [
                54.2641762,
                31.3954318
              ],
              [
                54.2644563,
                31.3970929
              ],
              [
                54.2644563,
                31.3984922
              ],
              [
                54.2650096,
                31.4001533
              ],
              [
                54.2652896,
                31.4012637
              ],
              [
                54.2772327,
                31.4482087
              ],
              [
                54.2773252,
                31.448951
              ],
              [
                54.2775094,
                31.4504296
              ],
              [
                54.2777894,
                31.4520998
              ],
              [
                54.2816794,
                31.4698759
              ],
              [
                54.281956,
                31.4701558
              ],
              [
                54.2838994,
                31.4754281
              ],
              [
                54.2838993,
                31.475708
              ],
              [
                54.2802894,
                31.4784886
              ],
              [
                54.2797328,
                31.4784886
              ],
              [
                54.2797327,
                31.4787685
              ],
              [
                54.2708429,
                31.4801498
              ],
              [
                54.2700095,
                31.4804297
              ],
              [
                54.2691762,
                31.4804296
              ],
              [
                54.268623,
                31.4807095
              ],
              [
                54.2677896,
                31.4807096
              ],
              [
                54.2672329,
                31.4809894
              ],
              [
                54.2663996,
                31.4809894
              ],
              [
                54.2658429,
                31.4812693
              ],
              [
                54.2647329,
                31.4812692
              ],
              [
                54.2527865,
                31.4846006
              ],
              [
                54.2522331,
                31.4846007
              ],
              [
                54.2041738,
                31.5004269
              ],
              [
                54.2033405,
                31.5004269
              ],
              [
                54.1925073,
                31.5048777
              ],
              [
                54.1911173,
                31.5057083
              ],
              [
                54.1894507,
                31.5062681
              ],
              [
                54.1608376,
                31.5237646
              ],
              [
                54.1602844,
                31.5240444
              ],
              [
                54.1597278,
                31.5243243
              ],
              [
                54.1594511,
                31.5245952
              ],
              [
                54.1552845,
                31.5273759
              ],
              [
                54.1505612,
                31.533488
              ],
              [
                54.1466712,
                31.5412702
              ],
              [
                54.1463946,
                31.5415502
              ],
              [
                54.1463946,
                31.5421009
              ],
              [
                54.1461146,
                31.5434912
              ],
              [
                54.1458379,
                31.5440509
              ],
              [
                54.1461145,
                31.5440509
              ],
              [
                54.1461146,
                31.5448815
              ],
              [
                54.1469479,
                31.5457121
              ],
              [
                54.1472279,
                31.5465427
              ],
              [
                54.1686177,
                31.5648791
              ],
              [
                54.169451,
                31.565159
              ],
              [
                54.1700076,
                31.5657187
              ],
              [
                54.1716743,
                31.5671
              ],
              [
                54.2094538,
                31.5973811
              ],
              [
                54.2102871,
                31.5990512
              ],
              [
                54.2111204,
                31.6023827
              ],
              [
                54.2058404,
                31.6268225
              ],
              [
                54.2052872,
                31.6298832
              ],
              [
                54.2045844,
                31.6356126
              ],
              [
                54.203617,
                31.6434981
              ],
              [
                54.2069538,
                31.6648866
              ],
              [
                54.2077739,
                31.6677521
              ],
              [
                54.2086204,
                31.67071
              ],
              [
                54.2105638,
                31.6754409
              ],
              [
                54.217787,
                31.6879364
              ],
              [
                54.2272302,
                31.6993215
              ],
              [
                54.2300102,
                31.7029419
              ],
              [
                54.2336201,
                31.7065533
              ],
              [
                54.2337561,
                31.7068242
              ],
              [
                54.2344534,
                31.7079348
              ],
              [
                54.2346546,
                31.7084181
              ],
              [
                54.2346992,
                31.7086286
              ],
              [
                54.2377867,
                31.712106
              ],
              [
                54.2483432,
                31.7148778
              ],
              [
                54.2486199,
                31.7151577
              ],
              [
                54.2497332,
                31.7151576
              ],
              [
                54.2516765,
                31.7159974
              ],
              [
                54.2525098,
                31.7159973
              ],
              [
                54.2577864,
                31.7184892
              ],
              [
                54.2583431,
                31.718769
              ],
              [
                54.2586197,
                31.7201595
              ],
              [
                54.2600097,
                31.7248815
              ],
              [
                54.2622331,
                31.7293235
              ],
              [
                54.2944559,
                31.7834958
              ],
              [
                54.2952892,
                31.7843264
              ],
              [
                54.3022359,
                31.7979419
              ],
              [
                54.3025125,
                31.7982217
              ],
              [
                54.3027892,
                31.7990524
              ],
              [
                54.3033458,
                31.7998831
              ],
              [
                54.3036224,
                31.8007226
              ],
              [
                54.3036223,
                31.8007232
              ],
              [
                54.3033459,
                31.8015534
              ],
              [
                54.2963992,
                31.8021041
              ],
              [
                54.2955659,
                31.802384
              ],
              [
                54.2938992,
                31.802384
              ],
              [
                54.2930659,
                31.8026639
              ],
              [
                54.290566,
                31.8026639
              ],
              [
                54.288346,
                31.8029347
              ],
              [
                54.288066,
                31.8032236
              ],
              [
                54.2875127,
                31.8032237
              ],
              [
                54.2863994,
                31.8032237
              ],
              [
                54.2566765,
                31.8126588
              ],
              [
                54.2486198,
                31.8140492
              ],
              [
                54.2475099,
                31.8143291
              ],
              [
                54.2427867,
                31.8143291
              ],
              [
                54.2424044,
                31.8142327
              ],
              [
                54.2416766,
                31.8140492
              ],
              [
                54.2363967,
                31.8140492
              ],
              [
                54.2355634,
                31.8143291
              ],
              [
                54.2313968,
                31.8143291
              ],
              [
                54.2194536,
                31.8151598
              ],
              [
                54.2186203,
                31.8154396
              ],
              [
                54.2161204,
                31.8154396
              ],
              [
                54.2155637,
                31.8157196
              ],
              [
                54.2136204,
                31.8157195
              ],
              [
                54.2130637,
                31.8157195
              ],
              [
                54.2116737,
                31.8162793
              ],
              [
                54.2116532,
                31.8162379
              ],
              [
                54.2116509,
                31.8162331
              ],
              [
                54.2113971,
                31.8157196
              ],
              [
                54.1716743,
                31.7776632
              ],
              [
                54.1711177,
                31.7771034
              ],
              [
                54.141948,
                31.7621068
              ],
              [
                54.1300048,
                31.7584953
              ],
              [
                54.1205583,
                31.7571048
              ],
              [
                54.1161151,
                31.7571048
              ],
              [
                54.1144484,
                31.7568249
              ],
              [
                54.1036152,
                31.7565541
              ],
              [
                54.1019486,
                31.7568249
              ],
              [
                54.098892,
                31.7568249
              ],
              [
                54.0944487,
                31.7573847
              ],
              [
                54.0866688,
                31.7573847
              ],
              [
                54.0591693,
                31.7601566
              ],
              [
                54.0513893,
                31.7618269
              ],
              [
                54.0505559,
                31.7623866
              ],
              [
                54.0413894,
                31.7651584
              ],
              [
                54.0402794,
                31.7654383
              ],
              [
                54.0394461,
                31.7654383
              ],
              [
                54.0313895,
                31.7673795
              ],
              [
                54.0299996,
                31.7673794
              ],
              [
                54.014443,
                31.7698804
              ],
              [
                54.0105531,
                31.7698805
              ],
              [
                54.0102765,
                31.7701604
              ],
              [
                54.0088865,
                31.7701604
              ],
              [
                54.0083332,
                31.7698805
              ],
              [
                54.0036099,
                31.7698805
              ],
              [
                54.0033333,
                31.7701603
              ],
              [
                54.0022199,
                31.7701603
              ],
              [
                54.0019433,
                31.7698805
              ],
              [
                54.0002767,
                31.7698805
              ],
              [
                53.9998262,
                31.771896
              ],
              [
                53.99861,
                31.7743226
              ],
              [
                53.9824968,
                31.787938
              ],
              [
                53.9819436,
                31.7882179
              ],
              [
                53.9811113,
                31.7884978
              ],
              [
                53.9805536,
                31.7887686
              ],
              [
                53.9719404,
                31.7929399
              ],
              [
                53.971107,
                31.7929399
              ],
              [
                53.9705537,
                31.7932197
              ],
              [
                53.9694404,
                31.7932198
              ],
              [
                53.9688871,
                31.7934997
              ],
              [
                53.9644404,
                31.7940504
              ],
              [
                53.9627738,
                31.7946012
              ],
              [
                53.9611072,
                31.7946012
              ],
              [
                53.9380508,
                31.7982218
              ],
              [
                53.9324942,
                31.7996031
              ],
              [
                53.9280509,
                31.8015534
              ],
              [
                53.9183278,
                31.8046051
              ],
              [
                53.9172177,
                31.8046051
              ],
              [
                53.9163845,
                31.8048849
              ],
              [
                53.9152711,
                31.804885
              ],
              [
                53.9149944,
                31.8051649
              ],
              [
                53.9133278,
                31.8054357
              ],
              [
                53.9102713,
                31.8068261
              ],
              [
                53.8947147,
                31.8115482
              ],
              [
                53.8877716,
                31.8137783
              ],
              [
                53.8669385,
                31.8184914
              ],
              [
                53.8655485,
                31.8184914
              ],
              [
                53.8638819,
                31.8190512
              ],
              [
                53.8627685,
                31.8190512
              ],
              [
                53.8574918,
                31.8201617
              ],
              [
                53.8558253,
                31.8201617
              ],
              [
                53.8197124,
                31.8284953
              ],
              [
                53.8088793,
                31.8329465
              ],
              [
                53.806656,
                31.8334973
              ],
              [
                53.7924895,
                31.8398807
              ],
              [
                53.7883228,
                31.841551
              ],
              [
                53.781933,
                31.8440521
              ],
              [
                53.7330437,
                31.8798877
              ],
              [
                53.7022412,
                31.8576347
              ],
              [
                53.6994563,
                31.8592384
              ],
              [
                53.6966681,
                31.8610493
              ],
              [
                53.6930502,
                31.863831
              ],
              [
                53.6870486,
                31.8683946
              ],
              [
                53.6799018,
                31.8739698
              ],
              [
                53.6636734,
                31.8647891
              ],
              [
                53.6423707,
                31.8526264
              ],
              [
                53.6227132,
                31.8415972
              ],
              [
                53.5887447,
                31.8222834
              ],
              [
                53.5769474,
                31.8157009
              ],
              [
                53.5669052,
                31.8099717
              ],
              [
                53.5736499,
                31.8018778
              ],
              [
                53.5846589,
                31.7902387
              ],
              [
                53.5867595,
                31.784071
              ],
              [
                53.5874048,
                31.7802001
              ],
              [
                53.5901757,
                31.7743226
              ],
              [
                53.5956913,
                31.7611076
              ],
              [
                53.5988273,
                31.7492565
              ],
              [
                53.603138,
                31.738572
              ],
              [
                53.6099174,
                31.726393
              ],
              [
                53.6088609,
                31.7243709
              ],
              [
                53.6077863,
                31.7232218
              ],
              [
                53.6028098,
                31.7207206
              ],
              [
                53.5935299,
                31.7182942
              ],
              [
                53.5796355,
                31.7126162
              ],
              [
                53.5682919,
                31.7067694
              ],
              [
                53.5577215,
                31.6989529
              ],
              [
                53.5504265,
                31.6906922
              ],
              [
                53.5358619,
                31.6695999
              ],
              [
                53.5226868,
                31.64655
              ],
              [
                53.5194725,
                31.6390014
              ],
              [
                53.518322,
                31.6339178
              ],
              [
                53.5136943,
                31.6218027
              ],
              [
                53.5058101,
                31.6334946
              ],
              [
                53.5049768,
                31.6334946
              ],
              [
                53.5046968,
                31.6332146
              ],
              [
                53.5027535,
                31.6332147
              ],
              [
                53.5024769,
                31.6329348
              ],
              [
                53.5013635,
                31.6329348
              ],
              [
                53.5008103,
                31.6326639
              ],
              [
                53.4994202,
                31.632664
              ],
              [
                53.4824737,
                31.627933
              ],
              [
                53.4805305,
                31.627933
              ],
              [
                53.4791404,
                31.6276622
              ],
              [
                53.4771972,
                31.6276622
              ],
              [
                53.4596975,
                31.6243216
              ],
              [
                53.4580308,
                31.6243217
              ],
              [
                53.4571975,
                31.6240508
              ],
              [
                53.4555309,
                31.6240508
              ],
              [
                53.450531,
                31.6229403
              ],
              [
                53.4319179,
                31.6182185
              ],
              [
                53.4302512,
                31.6182184
              ],
              [
                53.4291378,
                31.6179386
              ],
              [
                53.4277512,
                31.6179386
              ],
              [
                53.426918,
                31.6176587
              ],
              [
                53.4252513,
                31.6176587
              ],
              [
                53.4241379,
                31.6173788
              ],
              [
                53.4071948,
                31.6154377
              ],
              [
                53.4021949,
                31.6140473
              ],
              [
                53.3971951,
                31.6129369
              ],
              [
                53.3966383,
                31.6129367
              ],
              [
                53.394695,
                31.612377
              ],
              [
                53.3930283,
                31.612377
              ],
              [
                53.3808052,
                31.6107158
              ],
              [
                53.3783052,
                31.6107158
              ],
              [
                53.3727486,
                31.6098762
              ],
              [
                53.3610821,
                31.6087657
              ],
              [
                53.347469,
                31.6068246
              ],
              [
                53.343579,
                31.6068246
              ],
              [
                53.3421925,
                31.6065447
              ],
              [
                53.3402458,
                31.6065447
              ],
              [
                53.3249693,
                31.6046036
              ],
              [
                53.3224693,
                31.6046036
              ],
              [
                53.3210794,
                31.6043237
              ],
              [
                53.3185794,
                31.6043237
              ],
              [
                53.3027463,
                31.6021027
              ],
              [
                53.299413,
                31.6021028
              ],
              [
                53.298023,
                31.6018229
              ],
              [
                53.2960764,
                31.6018229
              ],
              [
                53.2955231,
                31.601543
              ],
              [
                53.294133,
                31.601543
              ],
              [
                53.292743,
                31.6012721
              ],
              [
                53.2905231,
                31.6012721
              ],
              [
                53.2891332,
                31.6009922
              ],
              [
                53.2855233,
                31.6009923
              ],
              [
                53.2849665,
                31.6007124
              ],
              [
                53.2835765,
                31.6007124
              ],
              [
                53.2782999,
                31.5996019
              ],
              [
                53.2738534,
                31.5990511
              ],
              [
                53.2702434,
                31.5984914
              ],
              [
                53.26802,
                31.5984914
              ],
              [
                53.2666334,
                31.5982116
              ],
              [
                53.2630201,
                31.5982115
              ],
              [
                53.2613535,
                31.5979316
              ],
              [
                53.2452438,
                31.5959905
              ],
              [
                53.2413538,
                31.5959905
              ],
              [
                53.2402404,
                31.5957107
              ],
              [
                53.2055175,
                31.5920993
              ],
              [
                53.2046842,
                31.5918284
              ],
              [
                53.203419,
                31.5918284
              ],
              [
                53.2032943,
                31.590718
              ],
              [
                53.2035744,
                31.5904381
              ],
              [
                53.2035743,
                31.5901582
              ],
              [
                53.2029075,
                31.5889258
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6554986,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان خاتم",
          "name:en": "Khatam County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1117046",
          "wikipedia": "en:Khatam County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.0432188,
                29.9967304
              ],
              [
                54.0463829,
                29.9966819
              ],
              [
                54.0574955,
                29.9940403
              ],
              [
                54.077711,
                29.988319
              ],
              [
                54.0958028,
                29.9823305
              ],
              [
                54.1092165,
                29.976676
              ],
              [
                54.117498,
                29.968807
              ],
              [
                54.1161247,
                29.951374
              ],
              [
                54.1156097,
                29.9343663
              ],
              [
                54.113414,
                29.9172419
              ],
              [
                54.1139672,
                29.9071302
              ],
              [
                54.1124332,
                29.8982025
              ],
              [
                54.1101383,
                29.8915995
              ],
              [
                54.1071509,
                29.882402
              ],
              [
                54.1059241,
                29.8771914
              ],
              [
                54.1060958,
                29.8730033
              ],
              [
                54.1054996,
                29.8695594
              ],
              [
                54.1045849,
                29.8629692
              ],
              [
                54.1043594,
                29.8608835
              ],
              [
                54.1040365,
                29.8581378
              ],
              [
                54.1037169,
                29.8496405
              ],
              [
                54.1024833,
                29.8348695
              ],
              [
                54.101486,
                29.8287312
              ],
              [
                54.1013663,
                29.8222895
              ],
              [
                54.1001558,
                29.8113433
              ],
              [
                54.0987015,
                29.8006565
              ],
              [
                54.0973444,
                29.7886407
              ],
              [
                54.1054342,
                29.7856844
              ],
              [
                54.1176222,
                29.7788309
              ],
              [
                54.1294668,
                29.7692949
              ],
              [
                54.1341017,
                29.7630364
              ],
              [
                54.1442297,
                29.7532008
              ],
              [
                54.1560744,
                29.7390418
              ],
              [
                54.1658542,
                29.7229972
              ],
              [
                54.1714857,
                29.7095774
              ],
              [
                54.178047,
                29.6916319
              ],
              [
                54.1814709,
                29.6749774
              ],
              [
                54.1848791,
                29.6674269
              ],
              [
                54.1902006,
                29.6562768
              ],
              [
                54.2069984,
                29.6318744
              ],
              [
                54.2144918,
                29.6272022
              ],
              [
                54.2186654,
                29.6240518
              ],
              [
                54.2261053,
                29.6200708
              ],
              [
                54.2303717,
                29.6177581
              ],
              [
                54.2341804,
                29.6149907
              ],
              [
                54.2460051,
                29.6082384
              ],
              [
                54.2659377,
                29.6004018
              ],
              [
                54.2740141,
                29.6014783
              ],
              [
                54.2835443,
                29.6050154
              ],
              [
                54.2937439,
                29.6089704
              ],
              [
                54.3039795,
                29.6121323
              ],
              [
                54.3158394,
                29.6159731
              ],
              [
                54.3273741,
                29.6195547
              ],
              [
                54.3529901,
                29.6244224
              ],
              [
                54.3709727,
                29.6223295
              ],
              [
                54.3878564,
                29.620688
              ],
              [
                54.3969716,
                29.6215878
              ],
              [
                54.4028906,
                29.6230322
              ],
              [
                54.4092227,
                29.6220172
              ],
              [
                54.4189739,
                29.6228999
              ],
              [
                54.4284373,
                29.6232011
              ],
              [
                54.4397878,
                29.6221538
              ],
              [
                54.4555078,
                29.6213831
              ],
              [
                54.4626785,
                29.6211084
              ],
              [
                54.472114,
                29.6253711
              ],
              [
                54.4846097,
                29.6336246
              ],
              [
                54.4905619,
                29.6348183
              ],
              [
                54.5021241,
                29.6331958
              ],
              [
                54.5272033,
                29.6311068
              ],
              [
                54.5406336,
                29.6297135
              ],
              [
                54.543912,
                29.6284452
              ],
              [
                54.5882766,
                29.6134398
              ],
              [
                54.5856576,
                29.6513378
              ],
              [
                54.5814411,
                29.7037414
              ],
              [
                54.5789962,
                29.7153165
              ],
              [
                54.577072,
                29.7261426
              ],
              [
                54.5751645,
                29.7385077
              ],
              [
                54.5745778,
                29.7508335
              ],
              [
                54.5740878,
                29.7617049
              ],
              [
                54.5738886,
                29.7671174
              ],
              [
                54.5690822,
                29.8032172
              ],
              [
                54.567071,
                29.8189116
              ],
              [
                54.5680618,
                29.8245241
              ],
              [
                54.5663079,
                29.826573
              ],
              [
                54.5672034,
                29.8461532
              ],
              [
                54.5635985,
                29.8538954
              ],
              [
                54.5611952,
                29.8656563
              ],
              [
                54.5541783,
                29.8834471
              ],
              [
                54.5488793,
                29.8954775
              ],
              [
                54.5445019,
                29.9087964
              ],
              [
                54.5422453,
                29.9109498
              ],
              [
                54.5454883,
                29.9246633
              ],
              [
                54.5473765,
                29.9431098
              ],
              [
                54.5519335,
                29.9720507
              ],
              [
                54.5473784,
                29.9997943
              ],
              [
                54.5488953,
                30.0142296
              ],
              [
                54.5421922,
                30.0414166
              ],
              [
                54.5392073,
                30.0555822
              ],
              [
                54.539659,
                30.0623594
              ],
              [
                54.5368625,
                30.0729961
              ],
              [
                54.5346499,
                30.0800877
              ],
              [
                54.5341349,
                30.094792
              ],
              [
                54.53326,
                30.1233052
              ],
              [
                54.5332108,
                30.1442119
              ],
              [
                54.5323716,
                30.1641326
              ],
              [
                54.5314807,
                30.1878518
              ],
              [
                54.5313262,
                30.2064161
              ],
              [
                54.5307254,
                30.2216952
              ],
              [
                54.5315887,
                30.2254789
              ],
              [
                54.5095252,
                30.2256259
              ],
              [
                54.4673625,
                30.2256349
              ],
              [
                54.4407633,
                30.226699
              ],
              [
                54.421297,
                30.2289237
              ],
              [
                54.3946978,
                30.2310171
              ],
              [
                54.368822,
                30.2317587
              ],
              [
                54.3588919,
                30.2335931
              ],
              [
                54.3479765,
                30.2346959
              ],
              [
                54.3186688,
                30.2383859
              ],
              [
                54.2951243,
                30.2432294
              ],
              [
                54.287567,
                30.2467599
              ],
              [
                54.2601812,
                30.2444048
              ],
              [
                54.221649,
                30.2434974
              ],
              [
                54.2040117,
                30.2329675
              ],
              [
                54.1766737,
                30.1979597
              ],
              [
                54.1594019,
                30.174999
              ],
              [
                54.148583,
                30.1639891
              ],
              [
                54.1238803,
                30.1320107
              ],
              [
                54.0975644,
                30.1044829
              ],
              [
                54.0524885,
                30.0507872
              ],
              [
                54.0462703,
                30.0312858
              ],
              [
                54.0441411,
                30.0160153
              ],
              [
                54.0442371,
                30.0100983
              ],
              [
                54.0429496,
                30.0054158
              ],
              [
                54.0429496,
                30.0014764
              ],
              [
                54.0432188,
                29.9967304
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555222,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مهریز",
          "name:en": "Mehriz County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286443",
          "wikipedia": "en:Mehriz County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.1266716,
                31.3504284
              ],
              [
                54.1266715,
                31.3498778
              ],
              [
                54.1247248,
                31.3379342
              ],
              [
                54.1244482,
                31.3354336
              ],
              [
                54.1241717,
                31.3320934
              ],
              [
                54.1238915,
                31.3307031
              ],
              [
                54.1275049,
                31.239589
              ],
              [
                54.1280581,
                31.2315366
              ],
              [
                54.1286148,
                31.2254252
              ],
              [
                54.1322282,
                31.1695923
              ],
              [
                54.1327814,
                31.1668119
              ],
              [
                54.1336147,
                31.1579293
              ],
              [
                54.1338948,
                31.1515382
              ],
              [
                54.1344589,
                31.1193753
              ],
              [
                54.1345364,
                31.1081841
              ],
              [
                54.1346224,
                31.09843
              ],
              [
                54.1355773,
                31.0865977
              ],
              [
                54.1349324,
                31.081149
              ],
              [
                54.1347798,
                31.0728487
              ],
              [
                54.1334258,
                31.0626833
              ],
              [
                54.1339215,
                31.0576753
              ],
              [
                54.133739,
                31.0471768
              ],
              [
                54.134304,
                31.0272124
              ],
              [
                54.1324157,
                31.0213521
              ],
              [
                54.1323966,
                31.0129953
              ],
              [
                54.1318149,
                31.0005791
              ],
              [
                54.1305333,
                30.9874376
              ],
              [
                54.1401596,
                30.9859467
              ],
              [
                54.1471536,
                30.9873448
              ],
              [
                54.1613098,
                30.9880213
              ],
              [
                54.17725,
                30.9885144
              ],
              [
                54.2029266,
                30.9908097
              ],
              [
                54.2150327,
                30.9906269
              ],
              [
                54.2385245,
                30.9926126
              ],
              [
                54.2545716,
                30.9938635
              ],
              [
                54.2852654,
                30.9980571
              ],
              [
                54.3073065,
                31.0012207
              ],
              [
                54.3379488,
                31.0037442
              ],
              [
                54.4091592,
                31.0092986
              ],
              [
                54.4533369,
                31.0127773
              ],
              [
                54.5125066,
                31.0173217
              ],
              [
                54.5205106,
                31.0179102
              ],
              [
                54.5267527,
                31.0183671
              ],
              [
                54.5337229,
                31.019933
              ],
              [
                54.5388087,
                31.0206682
              ],
              [
                54.5577978,
                31.0245661
              ],
              [
                54.5772452,
                31.0301462
              ],
              [
                54.5805784,
                31.0312565
              ],
              [
                54.6128047,
                31.0429187
              ],
              [
                54.6405842,
                31.0481993
              ],
              [
                54.6414176,
                31.0484792
              ],
              [
                54.6430842,
                31.0484791
              ],
              [
                54.6450276,
                31.0490298
              ],
              [
                54.6530841,
                31.05014
              ],
              [
                54.6539175,
                31.0504199
              ],
              [
                54.655304,
                31.0504199
              ],
              [
                54.6664173,
                31.0529203
              ],
              [
                54.6683606,
                31.0532001
              ],
              [
                54.6803071,
                31.0568107
              ],
              [
                54.6819737,
                31.0570905
              ],
              [
                54.684197,
                31.057921
              ],
              [
                54.6894736,
                31.0595909
              ],
              [
                54.6969735,
                31.0623712
              ],
              [
                54.70892,
                31.0657019
              ],
              [
                54.7111399,
                31.0657019
              ],
              [
                54.7116966,
                31.0659818
              ],
              [
                54.7150299,
                31.0659818
              ],
              [
                54.7155171,
                31.0658182
              ],
              [
                54.7158632,
                31.065702
              ],
              [
                54.7163531,
                31.065702
              ],
              [
                54.7183632,
                31.0657019
              ],
              [
                54.7191134,
                31.0655382
              ],
              [
                54.7844789,
                31.0512593
              ],
              [
                54.7936455,
                31.0495894
              ],
              [
                54.7939631,
                31.0495452
              ],
              [
                54.8055886,
                31.0479285
              ],
              [
                54.8378149,
                31.0426479
              ],
              [
                54.8379752,
                31.0426171
              ],
              [
                54.8855942,
                31.0334769
              ],
              [
                54.8865356,
                31.0333187
              ],
              [
                54.9153171,
                31.0284762
              ],
              [
                54.9247636,
                31.0273659
              ],
              [
                54.9258736,
                31.0273659
              ],
              [
                54.9263823,
                31.0272006
              ],
              [
                54.9267069,
                31.0270951
              ],
              [
                54.9271744,
                31.0270951
              ],
              [
                54.9350401,
                31.0270952
              ],
              [
                54.93865,
                31.027366
              ],
              [
                54.9397634,
                31.0276457
              ],
              [
                54.9433733,
                31.0276458
              ],
              [
                54.9464299,
                31.0281963
              ],
              [
                54.9475399,
                31.028756
              ],
              [
                54.9480966,
                31.0290358
              ],
              [
                54.9489299,
                31.0293066
              ],
              [
                54.9489366,
                31.0293134
              ],
              [
                54.9492066,
                31.0295865
              ],
              [
                54.9514298,
                31.0295864
              ],
              [
                54.9564298,
                31.0306967
              ],
              [
                54.9650431,
                31.0345871
              ],
              [
                54.9653196,
                31.034867
              ],
              [
                55.0217122,
                31.05626
              ],
              [
                55.0386553,
                31.0595908
              ],
              [
                55.0397686,
                31.0595908
              ],
              [
                55.0406021,
                31.0598706
              ],
              [
                55.0425452,
                31.0598706
              ],
              [
                55.0544919,
                31.0618113
              ],
              [
                55.0556018,
                31.0620912
              ],
              [
                55.057545,
                31.062371
              ],
              [
                55.0678249,
                31.0640319
              ],
              [
                55.0767149,
                31.0657017
              ],
              [
                55.0978245,
                31.068473
              ],
              [
                55.1019911,
                31.0693124
              ],
              [
                55.1089377,
                31.0701429
              ],
              [
                55.1336606,
                31.0723635
              ],
              [
                55.1847733,
                31.0843148
              ],
              [
                55.1889399,
                31.0851453
              ],
              [
                55.2106096,
                31.0912565
              ],
              [
                55.2594988,
                31.1081997
              ],
              [
                55.2639455,
                31.1101495
              ],
              [
                55.2642221,
                31.1104203
              ],
              [
                55.2647789,
                31.1107001
              ],
              [
                55.2656121,
                31.1112597
              ],
              [
                55.2667221,
                31.1118104
              ],
              [
                55.2669987,
                31.1120903
              ],
              [
                55.2675555,
                31.1120903
              ],
              [
                55.2678321,
                31.1123701
              ],
              [
                55.2689456,
                31.11237
              ],
              [
                55.2692599,
                31.1125291
              ],
              [
                55.2694988,
                31.1126499
              ],
              [
                55.2708887,
                31.1126499
              ],
              [
                55.2750554,
                31.114031
              ],
              [
                55.2751511,
                31.1141279
              ],
              [
                55.2753319,
                31.1143108
              ],
              [
                55.2761653,
                31.1143109
              ],
              [
                55.2764454,
                31.1145907
              ],
              [
                55.2769986,
                31.1148705
              ],
              [
                55.2761653,
                31.1190319
              ],
              [
                55.2761652,
                31.1198714
              ],
              [
                55.2742221,
                31.1282033
              ],
              [
                55.270332,
                31.1407055
              ],
              [
                55.2694988,
                31.1509782
              ],
              [
                55.2681122,
                31.1593192
              ],
              [
                55.2650556,
                31.1690323
              ],
              [
                55.2644989,
                31.1698718
              ],
              [
                55.2639455,
                31.1720925
              ],
              [
                55.2592224,
                31.1798738
              ],
              [
                55.2586656,
                31.1804245
              ],
              [
                55.2572756,
                31.1820944
              ],
              [
                55.2200529,
                31.2137617
              ],
              [
                55.2186629,
                31.2145923
              ],
              [
                55.2158863,
                31.2173727
              ],
              [
                55.1861633,
                31.2398686
              ],
              [
                55.1861634,
                31.2401485
              ],
              [
                55.1842167,
                31.242649
              ],
              [
                55.1806068,
                31.2487605
              ],
              [
                55.1797734,
                31.2509813
              ],
              [
                55.1783834,
                31.253202
              ],
              [
                55.1592171,
                31.2968134
              ],
              [
                55.1592171,
                31.297653
              ],
              [
                55.1564405,
                31.3034848
              ],
              [
                55.1561605,
                31.304875
              ],
              [
                55.1559775,
                31.3052423
              ],
              [
                55.1556071,
                31.3059854
              ],
              [
                55.1550505,
                31.3065451
              ],
              [
                55.1508839,
                31.3179289
              ],
              [
                55.1428273,
                31.3437658
              ],
              [
                55.1419941,
                31.347097
              ],
              [
                55.1311609,
                31.386819
              ],
              [
                55.1306042,
                31.3879294
              ],
              [
                55.1228277,
                31.4357048
              ],
              [
                55.1225476,
                31.4376548
              ],
              [
                55.1169945,
                31.459042
              ],
              [
                55.1150478,
                31.4643235
              ],
              [
                55.1072713,
                31.4901527
              ],
              [
                55.1058813,
                31.4923736
              ],
              [
                55.1056047,
                31.493493
              ],
              [
                55.077825,
                31.5315467
              ],
              [
                55.0772683,
                31.5326571
              ],
              [
                55.0736584,
                31.5362684
              ],
              [
                55.0719918,
                31.5382094
              ],
              [
                55.0586587,
                31.5523748
              ],
              [
                54.9794864,
                31.6043237
              ],
              [
                54.9736532,
                31.607935
              ],
              [
                54.8714279,
                31.6676582
              ],
              [
                54.8683714,
                31.6695993
              ],
              [
                54.847815,
                31.6823837
              ],
              [
                54.817812,
                31.6996102
              ],
              [
                54.8158688,
                31.700161
              ],
              [
                54.8003122,
                31.7079347
              ],
              [
                54.7997556,
                31.7084944
              ],
              [
                54.7875324,
                31.7132163
              ],
              [
                54.7844792,
                31.7146068
              ],
              [
                54.7836458,
                31.715019
              ],
              [
                54.7833659,
                31.7151575
              ],
              [
                54.7828125,
                31.7154374
              ],
              [
                54.7789226,
                31.7176585
              ],
              [
                54.7769793,
                31.7184891
              ],
              [
                54.7769793,
                31.7187689
              ],
              [
                54.7761459,
                31.718769
              ],
              [
                54.774756,
                31.7195996
              ],
              [
                54.773646,
                31.7195996
              ],
              [
                54.7666994,
                31.7223805
              ],
              [
                54.7658661,
                31.7232111
              ],
              [
                54.7641995,
                31.7246015
              ],
              [
                54.7641994,
                31.7248814
              ],
              [
                54.7636427,
                31.7248814
              ],
              [
                54.7636427,
                31.7251613
              ],
              [
                54.7628094,
                31.7251612
              ],
              [
                54.7603095,
                31.7262718
              ],
              [
                54.7597562,
                31.7262718
              ],
              [
                54.7594762,
                31.7265517
              ],
              [
                54.7589229,
                31.7265517
              ],
              [
                54.7583662,
                31.7268226
              ],
              [
                54.7436431,
                31.7315445
              ],
              [
                54.7039204,
                31.7512722
              ],
              [
                54.7011404,
                31.7523827
              ],
              [
                54.6975304,
                31.7534932
              ],
              [
                54.6939171,
                31.7543329
              ],
              [
                54.6878072,
                31.7551636
              ],
              [
                54.6683608,
                31.7557143
              ],
              [
                54.6669742,
                31.7554435
              ],
              [
                54.6653076,
                31.7554435
              ],
              [
                54.6639175,
                31.7551636
              ],
              [
                54.661141,
                31.7551635
              ],
              [
                54.6597509,
                31.7548837
              ],
              [
                54.6578077,
                31.7548836
              ],
              [
                54.6566942,
                31.7546038
              ],
              [
                54.6539176,
                31.7546038
              ],
              [
                54.6530843,
                31.7543329
              ],
              [
                54.6491943,
                31.7543329
              ],
              [
                54.6239147,
                31.7507124
              ],
              [
                54.6225281,
                31.7507125
              ],
              [
                54.6200281,
                31.7501617
              ],
              [
                54.6183581,
                31.7501617
              ],
              [
                54.6175248,
                31.7498818
              ],
              [
                54.6158581,
                31.7498818
              ],
              [
                54.5864152,
                31.7418282
              ],
              [
                54.5794687,
                31.7404378
              ],
              [
                54.5693997,
                31.738787
              ],
              [
                54.5608555,
                31.7373861
              ],
              [
                54.5583555,
                31.7373861
              ],
              [
                54.556969,
                31.7371062
              ],
              [
                54.554469,
                31.7371063
              ],
              [
                54.553079,
                31.7368264
              ],
              [
                54.5514123,
                31.7368263
              ],
              [
                54.5389126,
                31.7346053
              ],
              [
                54.5264127,
                31.7307139
              ],
              [
                54.5214095,
                31.7293235
              ],
              [
                54.5127996,
                31.7282221
              ],
              [
                54.4930765,
                31.7237709
              ],
              [
                54.4666869,
                31.7193288
              ],
              [
                54.464187,
                31.719049
              ],
              [
                54.4614069,
                31.7190489
              ],
              [
                54.4430738,
                31.7168279
              ],
              [
                54.439464,
                31.7168279
              ],
              [
                54.438074,
                31.716548
              ],
              [
                54.4311308,
                31.716548
              ],
              [
                54.4294607,
                31.7168279
              ],
              [
                54.4264075,
                31.7168279
              ],
              [
                54.4239075,
                31.716548
              ],
              [
                54.4211275,
                31.716548
              ],
              [
                54.4480738,
                31.6582145
              ],
              [
                54.4480738,
                31.6576638
              ],
              [
                54.4411306,
                31.6576638
              ],
              [
                54.4380739,
                31.6579346
              ],
              [
                54.4364073,
                31.6582145
              ],
              [
                54.426684,
                31.661546
              ],
              [
                54.4261274,
                31.6621058
              ],
              [
                54.4230741,
                31.6632163
              ],
              [
                54.4225175,
                31.6632163
              ],
              [
                54.4202941,
                31.6643268
              ],
              [
                54.4064043,
                31.6701592
              ],
              [
                54.387238,
                31.6765515
              ],
              [
                54.3855713,
                31.6773821
              ],
              [
                54.3752948,
                31.6801628
              ],
              [
                54.3744615,
                31.6801628
              ],
              [
                54.3739049,
                31.6804337
              ],
              [
                54.3739048,
                31.6807136
              ],
              [
                54.3730715,
                31.6807135
              ],
              [
                54.3719582,
                31.6812734
              ],
              [
                54.3491359,
                31.6859772
              ],
              [
                54.3450153,
                31.6868259
              ],
              [
                54.3358453,
                31.6879364
              ],
              [
                54.3311255,
                31.6884961
              ],
              [
                54.3225121,
                31.6887671
              ],
              [
                54.3205689,
                31.6884962
              ],
              [
                54.3175123,
                31.6884962
              ],
              [
                54.315569,
                31.6882163
              ],
              [
                54.3114023,
                31.6882163
              ],
              [
                54.3100123,
                31.6879364
              ],
              [
                54.307789,
                31.6879364
              ],
              [
                54.259733,
                31.7171078
              ],
              [
                54.2583431,
                31.718769
              ],
              [
                54.2577864,
                31.7184892
              ],
              [
                54.2525098,
                31.7159973
              ],
              [
                54.2516765,
                31.7159974
              ],
              [
                54.2497332,
                31.7151576
              ],
              [
                54.2486199,
                31.7151577
              ],
              [
                54.2483432,
                31.7148778
              ],
              [
                54.2377867,
                31.712106
              ],
              [
                54.2346992,
                31.7086286
              ],
              [
                54.2346546,
                31.7084181
              ],
              [
                54.2344534,
                31.7079348
              ],
              [
                54.2337561,
                31.7068242
              ],
              [
                54.2336201,
                31.7065533
              ],
              [
                54.2300102,
                31.7029419
              ],
              [
                54.2272302,
                31.6993215
              ],
              [
                54.217787,
                31.6879364
              ],
              [
                54.2105638,
                31.6754409
              ],
              [
                54.2086204,
                31.67071
              ],
              [
                54.2077739,
                31.6677521
              ],
              [
                54.2069538,
                31.6648866
              ],
              [
                54.203617,
                31.6434981
              ],
              [
                54.2045844,
                31.6356126
              ],
              [
                54.2052872,
                31.6298832
              ],
              [
                54.2058404,
                31.6268225
              ],
              [
                54.2111204,
                31.6023827
              ],
              [
                54.2102871,
                31.5990512
              ],
              [
                54.2094538,
                31.5973811
              ],
              [
                54.1716743,
                31.5671
              ],
              [
                54.1700076,
                31.5657187
              ],
              [
                54.169451,
                31.565159
              ],
              [
                54.1686177,
                31.5648791
              ],
              [
                54.1472279,
                31.5465427
              ],
              [
                54.1469479,
                31.5457121
              ],
              [
                54.1461146,
                31.5448815
              ],
              [
                54.1461145,
                31.5440509
              ],
              [
                54.1458379,
                31.5440509
              ],
              [
                54.1461146,
                31.5434912
              ],
              [
                54.1463946,
                31.5421009
              ],
              [
                54.1463946,
                31.5415502
              ],
              [
                54.1466712,
                31.5412702
              ],
              [
                54.1505612,
                31.533488
              ],
              [
                54.1552845,
                31.5273759
              ],
              [
                54.1594511,
                31.5245952
              ],
              [
                54.1597278,
                31.5243243
              ],
              [
                54.1602844,
                31.5240444
              ],
              [
                54.1608376,
                31.5237646
              ],
              [
                54.1894507,
                31.5062681
              ],
              [
                54.1911173,
                31.5057083
              ],
              [
                54.1925073,
                31.5048777
              ],
              [
                54.2033405,
                31.5004269
              ],
              [
                54.2041738,
                31.5004269
              ],
              [
                54.2522331,
                31.4846007
              ],
              [
                54.2527865,
                31.4846006
              ],
              [
                54.2647329,
                31.4812692
              ],
              [
                54.2658429,
                31.4812693
              ],
              [
                54.2663996,
                31.4809894
              ],
              [
                54.2672329,
                31.4809894
              ],
              [
                54.2677896,
                31.4807096
              ],
              [
                54.268623,
                31.4807095
              ],
              [
                54.2691762,
                31.4804296
              ],
              [
                54.2700095,
                31.4804297
              ],
              [
                54.2708429,
                31.4801498
              ],
              [
                54.2797327,
                31.4787685
              ],
              [
                54.2797328,
                31.4784886
              ],
              [
                54.2802894,
                31.4784886
              ],
              [
                54.2838993,
                31.475708
              ],
              [
                54.2838994,
                31.4754281
              ],
              [
                54.281956,
                31.4701558
              ],
              [
                54.2816794,
                31.4698759
              ],
              [
                54.2777894,
                31.4520998
              ],
              [
                54.2775094,
                31.4504296
              ],
              [
                54.2773252,
                31.448951
              ],
              [
                54.2772327,
                31.4482087
              ],
              [
                54.2652896,
                31.4012637
              ],
              [
                54.2650096,
                31.4001533
              ],
              [
                54.2644563,
                31.3984922
              ],
              [
                54.2644563,
                31.3970929
              ],
              [
                54.2641762,
                31.3954318
              ],
              [
                54.2638996,
                31.3926511
              ],
              [
                54.263623,
                31.3895998
              ],
              [
                54.263343,
                31.3854289
              ],
              [
                54.2630663,
                31.3837679
              ],
              [
                54.2627897,
                31.3820976
              ],
              [
                54.2625096,
                31.3804276
              ],
              [
                54.262233,
                31.3790373
              ],
              [
                54.2619564,
                31.3779269
              ],
              [
                54.2616763,
                31.3765366
              ],
              [
                54.2613997,
                31.3757061
              ],
              [
                54.2611229,
                31.3740449
              ],
              [
                54.2608429,
                31.3737651
              ],
              [
                54.2600097,
                31.3732054
              ],
              [
                54.2566763,
                31.3723748
              ],
              [
                54.2552864,
                31.3723748
              ],
              [
                54.2547331,
                31.3720949
              ],
              [
                54.2525097,
                31.3720949
              ],
              [
                54.2519531,
                31.3718151
              ],
              [
                54.2505665,
                31.371815
              ],
              [
                54.2191736,
                31.3657033
              ],
              [
                54.2000071,
                31.3637624
              ],
              [
                54.1641709,
                31.3598714
              ],
              [
                54.1613944,
                31.3593207
              ],
              [
                54.1602844,
                31.3590409
              ],
              [
                54.1588945,
                31.3590409
              ],
              [
                54.1583377,
                31.358761
              ],
              [
                54.1575044,
                31.358761
              ],
              [
                54.1572278,
                31.3584811
              ],
              [
                54.1441712,
                31.3554298
              ],
              [
                54.1430613,
                31.3548791
              ],
              [
                54.142228,
                31.3548791
              ],
              [
                54.1419479,
                31.3545993
              ],
              [
                54.1413947,
                31.3545993
              ],
              [
                54.1266716,
                31.3509882
              ],
              [
                54.1266716,
                31.3504284
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555227,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان میبد",
          "name:ar": "مقاطعة ميبد",
          "name:en": "Meybod County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1286571",
          "wikipedia": "en:Meybod County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.0030453,
                31.8541591
              ],
              [
                53.0063296,
                31.8375455
              ],
              [
                53.0089671,
                31.827318
              ],
              [
                53.0155486,
                31.8121175
              ],
              [
                53.0233334,
                31.7921091
              ],
              [
                53.0283699,
                31.7797787
              ],
              [
                53.0364983,
                31.759848
              ],
              [
                53.0409968,
                31.7473041
              ],
              [
                53.0474699,
                31.7396576
              ],
              [
                53.0612546,
                31.7300913
              ],
              [
                53.0757894,
                31.72099
              ],
              [
                53.0794026,
                31.7179383
              ],
              [
                53.0810692,
                31.7171077
              ],
              [
                53.0819026,
                31.716268
              ],
              [
                53.102459,
                31.7046031
              ],
              [
                53.1402385,
                31.6804336
              ],
              [
                53.1771847,
                31.641268
              ],
              [
                53.1802379,
                31.6376566
              ],
              [
                53.186908,
                31.6279329
              ],
              [
                53.1980177,
                31.6134876
              ],
              [
                53.203851,
                31.5968212
              ],
              [
                53.2035743,
                31.5932098
              ],
              [
                53.203419,
                31.5918284
              ],
              [
                53.2046842,
                31.5918284
              ],
              [
                53.2055175,
                31.5920993
              ],
              [
                53.2402404,
                31.5957107
              ],
              [
                53.2413538,
                31.5959905
              ],
              [
                53.2452438,
                31.5959905
              ],
              [
                53.2613535,
                31.5979316
              ],
              [
                53.2630201,
                31.5982115
              ],
              [
                53.2666334,
                31.5982116
              ],
              [
                53.26802,
                31.5984914
              ],
              [
                53.2702434,
                31.5984914
              ],
              [
                53.2738534,
                31.5990511
              ],
              [
                53.2782999,
                31.5996019
              ],
              [
                53.2835765,
                31.6007124
              ],
              [
                53.2849665,
                31.6007124
              ],
              [
                53.2855233,
                31.6009923
              ],
              [
                53.2891332,
                31.6009922
              ],
              [
                53.2905231,
                31.6012721
              ],
              [
                53.292743,
                31.6012721
              ],
              [
                53.294133,
                31.601543
              ],
              [
                53.2955231,
                31.601543
              ],
              [
                53.2960764,
                31.6018229
              ],
              [
                53.298023,
                31.6018229
              ],
              [
                53.299413,
                31.6021028
              ],
              [
                53.3027463,
                31.6021027
              ],
              [
                53.3185794,
                31.6043237
              ],
              [
                53.3210794,
                31.6043237
              ],
              [
                53.3224693,
                31.6046036
              ],
              [
                53.3249693,
                31.6046036
              ],
              [
                53.3402458,
                31.6065447
              ],
              [
                53.3421925,
                31.6065447
              ],
              [
                53.343579,
                31.6068246
              ],
              [
                53.347469,
                31.6068246
              ],
              [
                53.3610821,
                31.6087657
              ],
              [
                53.3727486,
                31.6098762
              ],
              [
                53.3783052,
                31.6107158
              ],
              [
                53.3808052,
                31.6107158
              ],
              [
                53.3930283,
                31.612377
              ],
              [
                53.394695,
                31.612377
              ],
              [
                53.3966383,
                31.6129367
              ],
              [
                53.3971951,
                31.6129369
              ],
              [
                53.4021949,
                31.6140473
              ],
              [
                53.4071948,
                31.6154377
              ],
              [
                53.4241379,
                31.6173788
              ],
              [
                53.4252513,
                31.6176587
              ],
              [
                53.426918,
                31.6176587
              ],
              [
                53.4277512,
                31.6179386
              ],
              [
                53.4291378,
                31.6179386
              ],
              [
                53.4302512,
                31.6182184
              ],
              [
                53.4319179,
                31.6182185
              ],
              [
                53.450531,
                31.6229403
              ],
              [
                53.4555309,
                31.6240508
              ],
              [
                53.4571975,
                31.6240508
              ],
              [
                53.4580308,
                31.6243217
              ],
              [
                53.4596975,
                31.6243216
              ],
              [
                53.4771972,
                31.6276622
              ],
              [
                53.4791404,
                31.6276622
              ],
              [
                53.4805305,
                31.627933
              ],
              [
                53.4824737,
                31.627933
              ],
              [
                53.4994202,
                31.632664
              ],
              [
                53.5008103,
                31.6326639
              ],
              [
                53.5013635,
                31.6329348
              ],
              [
                53.5024769,
                31.6329348
              ],
              [
                53.5027535,
                31.6332147
              ],
              [
                53.5046968,
                31.6332146
              ],
              [
                53.5049768,
                31.6334946
              ],
              [
                53.5058101,
                31.6334946
              ],
              [
                53.5136943,
                31.6218027
              ],
              [
                53.518322,
                31.6339178
              ],
              [
                53.5194725,
                31.6390014
              ],
              [
                53.5226868,
                31.64655
              ],
              [
                53.5358619,
                31.6695999
              ],
              [
                53.5504265,
                31.6906922
              ],
              [
                53.5577215,
                31.6989529
              ],
              [
                53.5682919,
                31.7067694
              ],
              [
                53.5796355,
                31.7126162
              ],
              [
                53.5935299,
                31.7182942
              ],
              [
                53.6028098,
                31.7207206
              ],
              [
                53.6077863,
                31.7232218
              ],
              [
                53.6088609,
                31.7243709
              ],
              [
                53.6099174,
                31.726393
              ],
              [
                53.603138,
                31.738572
              ],
              [
                53.5988273,
                31.7492565
              ],
              [
                53.5956913,
                31.7611076
              ],
              [
                53.5901757,
                31.7743226
              ],
              [
                53.5874048,
                31.7802001
              ],
              [
                53.5867595,
                31.784071
              ],
              [
                53.5846589,
                31.7902387
              ],
              [
                53.5736499,
                31.8018778
              ],
              [
                53.5669052,
                31.8099717
              ],
              [
                53.5769474,
                31.8157009
              ],
              [
                53.5887447,
                31.8222834
              ],
              [
                53.6227132,
                31.8415972
              ],
              [
                53.6423707,
                31.8526264
              ],
              [
                53.6636734,
                31.8647891
              ],
              [
                53.6799018,
                31.8739698
              ],
              [
                53.6870486,
                31.8683946
              ],
              [
                53.6930502,
                31.863831
              ],
              [
                53.6966681,
                31.8610493
              ],
              [
                53.6994563,
                31.8592384
              ],
              [
                53.7022412,
                31.8576347
              ],
              [
                53.7054168,
                31.8785607
              ],
              [
                53.7056743,
                31.8984967
              ],
              [
                53.7065065,
                31.9103512
              ],
              [
                53.7088463,
                31.9200921
              ],
              [
                53.7126897,
                31.9306436
              ],
              [
                53.7171618,
                31.9413068
              ],
              [
                53.7207973,
                31.9472156
              ],
              [
                53.7233639,
                31.9516827
              ],
              [
                53.7405492,
                31.9764179
              ],
              [
                53.7498606,
                31.9911126
              ],
              [
                53.7590496,
                32.0007157
              ],
              [
                53.7678459,
                32.0120159
              ],
              [
                53.7730375,
                32.0188405
              ],
              [
                53.7828825,
                32.0399491
              ],
              [
                53.7918463,
                32.0556943
              ],
              [
                53.8015957,
                32.0684133
              ],
              [
                53.8067038,
                32.0759936
              ],
              [
                53.8120838,
                32.0759936
              ],
              [
                53.8149691,
                32.0760482
              ],
              [
                53.8207293,
                32.0760918
              ],
              [
                53.8247527,
                32.0760554
              ],
              [
                53.8448228,
                32.0802433
              ],
              [
                53.8500022,
                32.0811929
              ],
              [
                53.8919707,
                32.0956915
              ],
              [
                53.9024837,
                32.0990053
              ],
              [
                53.9139536,
                32.1054619
              ],
              [
                53.9220575,
                32.1097714
              ],
              [
                53.9458748,
                32.122172
              ],
              [
                53.9461074,
                32.1248926
              ],
              [
                53.947774,
                32.1254434
              ],
              [
                53.9488839,
                32.1260032
              ],
              [
                53.9497173,
                32.126843
              ],
              [
                53.9533306,
                32.1282245
              ],
              [
                53.9538839,
                32.1287842
              ],
              [
                53.9544406,
                32.1287843
              ],
              [
                53.9547172,
                32.1290642
              ],
              [
                53.966107,
                32.1343372
              ],
              [
                53.9733303,
                32.1271139
              ],
              [
                53.9769402,
                32.1235022
              ],
              [
                53.9791636,
                32.1198904
              ],
              [
                53.9944434,
                32.0962789
              ],
              [
                53.9947201,
                32.0959991
              ],
              [
                53.9958299,
                32.0948885
              ],
              [
                53.9994512,
                32.0950222
              ],
              [
                54.0090244,
                32.0979162
              ],
              [
                54.0567377,
                32.1094547
              ],
              [
                54.0723932,
                32.1129225
              ],
              [
                54.0824096,
                32.1150598
              ],
              [
                54.0971382,
                32.1183311
              ],
              [
                54.1132572,
                32.1221257
              ],
              [
                54.1182783,
                32.1251787
              ],
              [
                54.1220377,
                32.1275774
              ],
              [
                54.1298912,
                32.129976
              ],
              [
                54.1378992,
                32.1325708
              ],
              [
                54.1446197,
                32.1356889
              ],
              [
                54.151469,
                32.1422517
              ],
              [
                54.1550224,
                32.1494463
              ],
              [
                54.1581123,
                32.1599101
              ],
              [
                54.1638029,
                32.1728139
              ],
              [
                54.1660949,
                32.1797918
              ],
              [
                54.1681213,
                32.1854109
              ],
              [
                54.1738662,
                32.1878806
              ],
              [
                54.2266102,
                32.1975598
              ],
              [
                54.2421219,
                32.1997402
              ],
              [
                54.2485746,
                32.201919
              ],
              [
                54.2544532,
                32.2029509
              ],
              [
                54.2552864,
                32.2029509
              ],
              [
                54.284848,
                32.2091256
              ],
              [
                54.3004847,
                32.2113363
              ],
              [
                54.3193262,
                32.2150888
              ],
              [
                54.3291756,
                32.2161418
              ],
              [
                54.3333609,
                32.21693
              ],
              [
                54.3384967,
                32.2178377
              ],
              [
                54.3398462,
                32.2190464
              ],
              [
                54.3412182,
                32.2187771
              ],
              [
                54.3464386,
                32.2222225
              ],
              [
                54.3516289,
                32.225293
              ],
              [
                54.4055711,
                32.262671
              ],
              [
                54.4072378,
                32.2637816
              ],
              [
                54.4189077,
                32.2737862
              ],
              [
                54.4189077,
                32.2757275
              ],
              [
                54.3972379,
                32.3226713
              ],
              [
                54.3968966,
                32.3233276
              ],
              [
                54.3955712,
                32.3251725
              ],
              [
                54.3955712,
                32.3254524
              ],
              [
                54.3919614,
                32.3254523
              ],
              [
                54.3883481,
                32.3249015
              ],
              [
                54.3880715,
                32.3246217
              ],
              [
                54.3861281,
                32.3246217
              ],
              [
                54.3852948,
                32.3243418
              ],
              [
                54.3844616,
                32.3243417
              ],
              [
                54.3839048,
                32.3240618
              ],
              [
                54.3827948,
                32.3240619
              ],
              [
                54.3822382,
                32.3237819
              ],
              [
                54.3808481,
                32.323782
              ],
              [
                54.3800148,
                32.323511
              ],
              [
                54.3791814,
                32.3235111
              ],
              [
                54.3786283,
                32.3232311
              ],
              [
                54.3772383,
                32.3232311
              ],
              [
                54.3769616,
                32.3229512
              ],
              [
                54.3758482,
                32.3229512
              ],
              [
                54.375295,
                32.3226713
              ],
              [
                54.3739049,
                32.3226713
              ],
              [
                54.3583485,
                32.3193395
              ],
              [
                54.3575151,
                32.3193394
              ],
              [
                54.3564052,
                32.3187887
              ],
              [
                54.3516077,
                32.3181021
              ],
              [
                54.3447353,
                32.3171182
              ],
              [
                54.3430687,
                32.3171183
              ],
              [
                54.3405687,
                32.3165675
              ],
              [
                54.3386254,
                32.3165675
              ],
              [
                54.3377921,
                32.3162875
              ],
              [
                54.3336255,
                32.3162875
              ],
              [
                54.3327922,
                32.3160077
              ],
              [
                54.3252923,
                32.3160077
              ],
              [
                54.323069,
                32.3157277
              ],
              [
                54.3094557,
                32.3157277
              ],
              [
                54.3086225,
                32.3154568
              ],
              [
                54.3047359,
                32.3154569
              ],
              [
                54.2666763,
                32.3123959
              ],
              [
                54.2616764,
                32.3123958
              ],
              [
                54.2319535,
                32.3101746
              ],
              [
                54.2266769,
                32.3096148
              ],
              [
                54.2236203,
                32.309064
              ],
              [
                54.2219537,
                32.309064
              ],
              [
                54.2161204,
                32.3079534
              ],
              [
                54.2144538,
                32.3079534
              ],
              [
                54.190284,
                32.3037818
              ],
              [
                54.1766743,
                32.3015606
              ],
              [
                54.1466713,
                32.2982287
              ],
              [
                54.1305616,
                32.2982287
              ],
              [
                54.1244482,
                32.297678
              ],
              [
                54.1202816,
                32.2968382
              ],
              [
                54.1136151,
                32.2962874
              ],
              [
                54.1072252,
                32.2962874
              ],
              [
                54.1058352,
                32.2965673
              ],
              [
                54.0969486,
                32.2965673
              ],
              [
                54.0880588,
                32.2973981
              ],
              [
                54.0867794,
                32.2969385
              ],
              [
                54.0828912,
                32.295502
              ],
              [
                54.0790031,
                32.2939566
              ],
              [
                54.0714843,
                32.289908
              ],
              [
                54.0656393,
                32.2863816
              ],
              [
                54.0623176,
                32.2855326
              ],
              [
                54.0592277,
                32.2856197
              ],
              [
                54.0482843,
                32.2865775
              ],
              [
                54.0386607,
                32.2856607
              ],
              [
                54.0296652,
                32.2761746
              ],
              [
                54.0267334,
                32.2750654
              ],
              [
                54.024415,
                32.2802576
              ],
              [
                54.023591,
                32.2830876
              ],
              [
                54.0233727,
                32.2847453
              ],
              [
                54.021612,
                32.2846677
              ],
              [
                54.0192083,
                32.2846159
              ],
              [
                54.016927,
                32.2846806
              ],
              [
                54.0133902,
                32.28481
              ],
              [
                54.0132371,
                32.2826614
              ],
              [
                54.0131912,
                32.2818459
              ],
              [
                54.0116601,
                32.2820918
              ],
              [
                54.0100985,
                32.2822472
              ],
              [
                54.0102669,
                32.2817682
              ],
              [
                54.0103838,
                32.2812164
              ],
              [
                54.0061259,
                32.281773
              ],
              [
                54.0070014,
                32.2839934
              ],
              [
                53.9997916,
                32.2848206
              ],
              [
                53.9967017,
                32.2855825
              ],
              [
                53.9970622,
                32.2861485
              ],
              [
                53.9939466,
                32.2867362
              ],
              [
                53.9898782,
                32.287128
              ],
              [
                53.9890285,
                32.287694
              ],
              [
                53.9889255,
                32.2881511
              ],
              [
                53.9884877,
                32.2884123
              ],
              [
                53.9887195,
                32.2889783
              ],
              [
                53.9834409,
                32.2909373
              ],
              [
                53.9727365,
                32.2923425
              ],
              [
                53.9681187,
                32.2892608
              ],
              [
                53.9592533,
                32.2925651
              ],
              [
                53.942598,
                32.300038
              ],
              [
                53.9293217,
                32.3043286
              ],
              [
                53.920127,
                32.3078832
              ],
              [
                53.9049216,
                32.3134586
              ],
              [
                53.9017087,
                32.3146463
              ],
              [
                53.898599,
                32.3156756
              ],
              [
                53.8938367,
                32.3157028
              ],
              [
                53.887937,
                32.3135913
              ],
              [
                53.8801011,
                32.3112701
              ],
              [
                53.8695046,
                32.3080703
              ],
              [
                53.8531715,
                32.3032747
              ],
              [
                53.833985,
                32.2975117
              ],
              [
                53.8138205,
                32.2918302
              ],
              [
                53.7880854,
                32.2841163
              ],
              [
                53.7500772,
                32.2728095
              ],
              [
                53.7220844,
                32.2707054
              ],
              [
                53.7128467,
                32.2707454
              ],
              [
                53.7078646,
                32.2709215
              ],
              [
                53.6992343,
                32.2710842
              ],
              [
                53.6747153,
                32.2713019
              ],
              [
                53.6506694,
                32.2729089
              ],
              [
                53.6363249,
                32.2733443
              ],
              [
                53.6238435,
                32.2746609
              ],
              [
                53.6144334,
                32.2765477
              ],
              [
                53.6061469,
                32.2814615
              ],
              [
                53.5985421,
                32.2863231
              ],
              [
                53.587644,
                32.2929881
              ],
              [
                53.5789034,
                32.2946568
              ],
              [
                53.5634994,
                32.2938805
              ],
              [
                53.5468425,
                32.2916272
              ],
              [
                53.5309695,
                32.2901802
              ],
              [
                53.5207567,
                32.2939817
              ],
              [
                53.5155387,
                32.2981968
              ],
              [
                53.5100789,
                32.3019721
              ],
              [
                53.5091574,
                32.3033657
              ],
              [
                53.5081763,
                32.3043994
              ],
              [
                53.5021326,
                32.3093682
              ],
              [
                53.4959373,
                32.3139605
              ],
              [
                53.4920025,
                32.3171311
              ],
              [
                53.4878317,
                32.3189926
              ],
              [
                53.4854059,
                32.3194447
              ],
              [
                53.4820903,
                32.3186968
              ],
              [
                53.4722285,
                32.3125598
              ],
              [
                53.4681836,
                32.3097651
              ],
              [
                53.4628629,
                32.3066672
              ],
              [
                53.4594083,
                32.3048899
              ],
              [
                53.4562111,
                32.3029856
              ],
              [
                53.4523272,
                32.3003013
              ],
              [
                53.4452032,
                32.2950051
              ],
              [
                53.4189942,
                32.2689109
              ],
              [
                53.4003806,
                32.2495783
              ],
              [
                53.3625159,
                32.2281397
              ],
              [
                53.3327468,
                32.2110744
              ],
              [
                53.2987856,
                32.1885242
              ],
              [
                53.2765889,
                32.1747631
              ],
              [
                53.2678623,
                32.1698119
              ],
              [
                53.2501243,
                32.1616531
              ],
              [
                53.2441052,
                32.1584146
              ],
              [
                53.2373278,
                32.154773
              ],
              [
                53.2108323,
                32.1323728
              ],
              [
                53.1932142,
                32.1207301
              ],
              [
                53.1791495,
                32.1103506
              ],
              [
                53.1624608,
                32.0951769
              ],
              [
                53.151512,
                32.0873743
              ],
              [
                53.140868,
                32.0772617
              ],
              [
                53.1238745,
                32.06221
              ],
              [
                53.109796,
                32.0468608
              ],
              [
                53.0994986,
                32.0368933
              ],
              [
                53.0885122,
                32.029035
              ],
              [
                53.0780409,
                32.0200116
              ],
              [
                53.0672262,
                32.0133163
              ],
              [
                53.0511759,
                32.0051102
              ],
              [
                53.0473351,
                32.0034361
              ],
              [
                53.0452537,
                32.0019621
              ],
              [
                53.0349539,
                31.9961391
              ],
              [
                53.0341949,
                31.9934593
              ],
              [
                53.0251385,
                31.9586496
              ],
              [
                53.0224835,
                31.9479982
              ],
              [
                53.0159251,
                31.9253995
              ],
              [
                53.0112986,
                31.9072903
              ],
              [
                53.0045904,
                31.8813453
              ],
              [
                53.0003655,
                31.8667867
              ],
              [
                53.0030453,
                31.8541591
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555259,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان یزد",
          "name:ar": "مقاطعة يزد",
          "name:en": "Yazd County",
          "place": "county",
          "type": "boundary",
          "wikidata": "Q1292178",
          "wikipedia": "en:Yazd County"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.1980639,
                31.932942
              ],
              [
                54.1969505,
                31.9312806
              ],
              [
                54.1965648,
                31.9305001
              ],
              [
                54.1963974,
                31.9301611
              ],
              [
                54.1463946,
                31.8662721
              ],
              [
                54.1463944,
                31.8662713
              ],
              [
                54.1460457,
                31.8650555
              ],
              [
                54.1452812,
                31.8623898
              ],
              [
                54.1450046,
                31.8604395
              ],
              [
                54.144728,
                31.8596088
              ],
              [
                54.1447279,
                31.859049
              ],
              [
                54.144728,
                31.8579384
              ],
              [
                54.1483379,
                31.8509952
              ],
              [
                54.1627844,
                31.8401606
              ],
              [
                54.2041738,
                31.8201617
              ],
              [
                54.2052872,
                31.8198818
              ],
              [
                54.2058404,
                31.8196109
              ],
              [
                54.2069538,
                31.819611
              ],
              [
                54.2069538,
                31.8193311
              ],
              [
                54.2119537,
                31.8165502
              ],
              [
                54.2116737,
                31.8162793
              ],
              [
                54.2130637,
                31.8157195
              ],
              [
                54.2136204,
                31.8157195
              ],
              [
                54.2155637,
                31.8157196
              ],
              [
                54.2161204,
                31.8154396
              ],
              [
                54.2186203,
                31.8154396
              ],
              [
                54.2194536,
                31.8151598
              ],
              [
                54.2313968,
                31.8143291
              ],
              [
                54.2355634,
                31.8143291
              ],
              [
                54.2363967,
                31.8140492
              ],
              [
                54.2416766,
                31.8140492
              ],
              [
                54.2424044,
                31.8142327
              ],
              [
                54.2427867,
                31.8143291
              ],
              [
                54.2475099,
                31.8143291
              ],
              [
                54.2486198,
                31.8140492
              ],
              [
                54.2566765,
                31.8126588
              ],
              [
                54.2863994,
                31.8032237
              ],
              [
                54.2875127,
                31.8032237
              ],
              [
                54.288066,
                31.8032236
              ],
              [
                54.288346,
                31.8029347
              ],
              [
                54.290566,
                31.8026639
              ],
              [
                54.2930659,
                31.8026639
              ],
              [
                54.2938992,
                31.802384
              ],
              [
                54.2955659,
                31.802384
              ],
              [
                54.2963992,
                31.8021041
              ],
              [
                54.3033459,
                31.8015534
              ],
              [
                54.3036223,
                31.8007232
              ],
              [
                54.3036224,
                31.8007226
              ],
              [
                54.3033458,
                31.7998831
              ],
              [
                54.3027892,
                31.7990524
              ],
              [
                54.3025125,
                31.7982217
              ],
              [
                54.3022359,
                31.7979419
              ],
              [
                54.2952892,
                31.7843264
              ],
              [
                54.2944559,
                31.7834958
              ],
              [
                54.2622331,
                31.7293235
              ],
              [
                54.2600097,
                31.7248815
              ],
              [
                54.2586197,
                31.7201595
              ],
              [
                54.2583431,
                31.718769
              ],
              [
                54.259733,
                31.7171078
              ],
              [
                54.307789,
                31.6879364
              ],
              [
                54.3100123,
                31.6879364
              ],
              [
                54.3114023,
                31.6882163
              ],
              [
                54.315569,
                31.6882163
              ],
              [
                54.3175123,
                31.6884962
              ],
              [
                54.3205689,
                31.6884962
              ],
              [
                54.3225121,
                31.6887671
              ],
              [
                54.3311255,
                31.6884961
              ],
              [
                54.3358453,
                31.6879364
              ],
              [
                54.3450153,
                31.6868259
              ],
              [
                54.3491359,
                31.6859772
              ],
              [
                54.3719582,
                31.6812734
              ],
              [
                54.3730715,
                31.6807135
              ],
              [
                54.3739048,
                31.6807136
              ],
              [
                54.3739049,
                31.6804337
              ],
              [
                54.3744615,
                31.6801628
              ],
              [
                54.3752948,
                31.6801628
              ],
              [
                54.3855713,
                31.6773821
              ],
              [
                54.387238,
                31.6765515
              ],
              [
                54.4064043,
                31.6701592
              ],
              [
                54.4202941,
                31.6643268
              ],
              [
                54.4225175,
                31.6632163
              ],
              [
                54.4230741,
                31.6632163
              ],
              [
                54.4261274,
                31.6621058
              ],
              [
                54.426684,
                31.661546
              ],
              [
                54.4364073,
                31.6582145
              ],
              [
                54.4380739,
                31.6579346
              ],
              [
                54.4411306,
                31.6576638
              ],
              [
                54.4480738,
                31.6576638
              ],
              [
                54.4480738,
                31.6582145
              ],
              [
                54.4211275,
                31.716548
              ],
              [
                54.4239075,
                31.716548
              ],
              [
                54.4264075,
                31.7168279
              ],
              [
                54.4294607,
                31.7168279
              ],
              [
                54.4311308,
                31.716548
              ],
              [
                54.438074,
                31.716548
              ],
              [
                54.439464,
                31.7168279
              ],
              [
                54.4430738,
                31.7168279
              ],
              [
                54.4614069,
                31.7190489
              ],
              [
                54.464187,
                31.719049
              ],
              [
                54.4666869,
                31.7193288
              ],
              [
                54.4930765,
                31.7237709
              ],
              [
                54.5127996,
                31.7282221
              ],
              [
                54.5214095,
                31.7293235
              ],
              [
                54.5264127,
                31.7307139
              ],
              [
                54.5389126,
                31.7346053
              ],
              [
                54.5514123,
                31.7368263
              ],
              [
                54.553079,
                31.7368264
              ],
              [
                54.554469,
                31.7371063
              ],
              [
                54.556969,
                31.7371062
              ],
              [
                54.5583555,
                31.7373861
              ],
              [
                54.5608555,
                31.7373861
              ],
              [
                54.5693997,
                31.738787
              ],
              [
                54.5794687,
                31.7404378
              ],
              [
                54.5864152,
                31.7418282
              ],
              [
                54.6158581,
                31.7498818
              ],
              [
                54.6175248,
                31.7498818
              ],
              [
                54.6183581,
                31.7501617
              ],
              [
                54.6200281,
                31.7501617
              ],
              [
                54.6225281,
                31.7507125
              ],
              [
                54.6239147,
                31.7507124
              ],
              [
                54.6491943,
                31.7543329
              ],
              [
                54.6530843,
                31.7543329
              ],
              [
                54.6539176,
                31.7546038
              ],
              [
                54.6566942,
                31.7546038
              ],
              [
                54.6578077,
                31.7548836
              ],
              [
                54.6597509,
                31.7548837
              ],
              [
                54.661141,
                31.7551635
              ],
              [
                54.6639175,
                31.7551636
              ],
              [
                54.6653076,
                31.7554435
              ],
              [
                54.6669742,
                31.7554435
              ],
              [
                54.6683608,
                31.7557143
              ],
              [
                54.6878072,
                31.7551636
              ],
              [
                54.6939171,
                31.7543329
              ],
              [
                54.6975304,
                31.7534932
              ],
              [
                54.7011404,
                31.7523827
              ],
              [
                54.7039204,
                31.7512722
              ],
              [
                54.7436431,
                31.7315445
              ],
              [
                54.7583662,
                31.7268226
              ],
              [
                54.7589229,
                31.7265517
              ],
              [
                54.7594762,
                31.7265517
              ],
              [
                54.7597562,
                31.7262718
              ],
              [
                54.7603095,
                31.7262718
              ],
              [
                54.7628094,
                31.7251612
              ],
              [
                54.7636427,
                31.7251613
              ],
              [
                54.7636427,
                31.7248814
              ],
              [
                54.7641994,
                31.7248814
              ],
              [
                54.7641995,
                31.7246015
              ],
              [
                54.7658661,
                31.7232111
              ],
              [
                54.7666994,
                31.7268225
              ],
              [
                54.7683661,
                31.7315445
              ],
              [
                54.768366,
                31.7321042
              ],
              [
                54.7686427,
                31.7323841
              ],
              [
                54.7686948,
                31.7326934
              ],
              [
                54.7689228,
                31.7340454
              ],
              [
                54.7691994,
                31.7365464
              ],
              [
                54.769476,
                31.739878
              ],
              [
                54.7697561,
                31.7418282
              ],
              [
                54.7714227,
                31.7490511
              ],
              [
                54.7716994,
                31.7504415
              ],
              [
                54.7719794,
                31.7529425
              ],
              [
                54.772256,
                31.7557143
              ],
              [
                54.7725327,
                31.758766
              ],
              [
                54.7728127,
                31.7609961
              ],
              [
                54.7730893,
                31.7632172
              ],
              [
                54.773366,
                31.7651583
              ],
              [
                54.7736138,
                31.7681149
              ],
              [
                54.773646,
                31.768499
              ],
              [
                54.7753127,
                31.7759928
              ],
              [
                54.7755894,
                31.7768235
              ],
              [
                54.7755893,
                31.7773832
              ],
              [
                54.7808659,
                31.7887685
              ],
              [
                54.8178121,
                31.8312761
              ],
              [
                54.8186454,
                31.8321068
              ],
              [
                54.8233687,
                31.8368288
              ],
              [
                54.8269786,
                31.841551
              ],
              [
                54.8380918,
                31.8576585
              ],
              [
                54.8383684,
                31.858778
              ],
              [
                54.8386484,
                31.8590489
              ],
              [
                54.8389251,
                31.8604394
              ],
              [
                54.8383685,
                31.8654414
              ],
              [
                54.8133688,
                31.8873817
              ],
              [
                54.8122589,
                31.8885012
              ],
              [
                54.8036456,
                31.8962752
              ],
              [
                54.7983691,
                31.9015571
              ],
              [
                54.7628095,
                31.9284996
              ],
              [
                54.7253101,
                31.958774
              ],
              [
                54.7180868,
                31.9634963
              ],
              [
                54.7189201,
                31.9659973
              ],
              [
                54.7180869,
                31.9662772
              ],
              [
                54.7180869,
                31.9665571
              ],
              [
                54.7169769,
                31.966557
              ],
              [
                54.7166968,
                31.9662771
              ],
              [
                54.7161436,
                31.9665571
              ],
              [
                54.7144769,
                31.9665571
              ],
              [
                54.7141969,
                31.966828
              ],
              [
                54.7075303,
                31.9668279
              ],
              [
                54.7044736,
                31.9668279
              ],
              [
                54.7039204,
                31.966557
              ],
              [
                54.675584,
                31.9690491
              ],
              [
                54.6739175,
                31.969329
              ],
              [
                54.6703075,
                31.969329
              ],
              [
                54.6494711,
                31.97183
              ],
              [
                54.6391946,
                31.9718301
              ],
              [
                54.6383613,
                31.97211
              ],
              [
                54.631138,
                31.9721099
              ],
              [
                54.611415,
                31.9729406
              ],
              [
                54.6105817,
                31.9729406
              ],
              [
                54.5889153,
                31.9740512
              ],
              [
                54.5825254,
                31.9748909
              ],
              [
                54.5650256,
                31.9762724
              ],
              [
                54.5647455,
                31.9765522
              ],
              [
                54.5636357,
                31.9765523
              ],
              [
                54.5616889,
                31.9771121
              ],
              [
                54.5614123,
                31.977392
              ],
              [
                54.5608557,
                31.977392
              ],
              [
                54.5519691,
                31.9904481
              ],
              [
                54.5514125,
                31.99322
              ],
              [
                54.5511358,
                31.9937798
              ],
              [
                54.5498083,
                32.0001661
              ],
              [
                54.5497458,
                32.0012739
              ],
              [
                54.5494691,
                32.0021136
              ],
              [
                54.5480792,
                32.0068359
              ],
              [
                54.5469692,
                32.009057
              ],
              [
                54.5464125,
                32.009337
              ],
              [
                54.5425226,
                32.0157206
              ],
              [
                54.5377993,
                32.0287767
              ],
              [
                54.5350228,
                32.0404514
              ],
              [
                54.534466,
                32.0410022
              ],
              [
                54.5341894,
                32.0418329
              ],
              [
                54.5330794,
                32.0437741
              ],
              [
                54.5327994,
                32.0443339
              ],
              [
                54.5283561,
                32.0504467
              ],
              [
                54.5272462,
                32.0509975
              ],
              [
                54.5197429,
                32.0557288
              ],
              [
                54.5186329,
                32.0559996
              ],
              [
                54.5102997,
                32.0559996
              ],
              [
                54.509743,
                32.0562795
              ],
              [
                54.5041864,
                32.0562795
              ],
              [
                54.5036332,
                32.0559996
              ],
              [
                54.5011332,
                32.0559996
              ],
              [
                54.5005765,
                32.0557288
              ],
              [
                54.4989098,
                32.0557288
              ],
              [
                54.4980766,
                32.0554398
              ],
              [
                54.4955766,
                32.055169
              ],
              [
                54.4947432,
                32.055169
              ],
              [
                54.4841867,
                32.055169
              ],
              [
                54.48113,
                32.0546092
              ],
              [
                54.4780768,
                32.0546091
              ],
              [
                54.4769635,
                32.0543293
              ],
              [
                54.4755769,
                32.0543293
              ],
              [
                54.4750201,
                32.0540584
              ],
              [
                54.4736302,
                32.0540584
              ],
              [
                54.4725202,
                32.0537785
              ],
              [
                54.4697436,
                32.0537784
              ],
              [
                54.4691869,
                32.0534986
              ],
              [
                54.4669637,
                32.0534986
              ],
              [
                54.4666869,
                32.0532277
              ],
              [
                54.4658536,
                32.0532277
              ],
              [
                54.463907,
                32.0526679
              ],
              [
                54.4625204,
                32.0526679
              ],
              [
                54.461687,
                32.052388
              ],
              [
                54.4577971,
                32.052388
              ],
              [
                54.4569638,
                32.0521171
              ],
              [
                54.4547405,
                32.0521171
              ],
              [
                54.4539072,
                32.0523879
              ],
              [
                54.4536305,
                32.0521171
              ],
              [
                54.4508538,
                32.0521171
              ],
              [
                54.4497405,
                32.0518372
              ],
              [
                54.4472405,
                32.0518372
              ],
              [
                54.4466838,
                32.0515573
              ],
              [
                54.443074,
                32.0515573
              ],
              [
                54.4425173,
                32.0512774
              ],
              [
                54.440574,
                32.0512774
              ],
              [
                54.4400173,
                32.0509975
              ],
              [
                54.4383506,
                32.0509975
              ],
              [
                54.436684,
                32.0504467
              ],
              [
                54.4352974,
                32.0504467
              ],
              [
                54.4273947,
                32.0487839
              ],
              [
                54.4247409,
                32.0482255
              ],
              [
                54.4236274,
                32.0479456
              ],
              [
                54.4030711,
                32.0421127
              ],
              [
                54.4016845,
                32.0421128
              ],
              [
                54.3504514,
                32.0235063
              ],
              [
                54.3458486,
                32.0218333
              ],
              [
                54.3452919,
                32.0215534
              ],
              [
                54.3447353,
                32.0215534
              ],
              [
                54.3314021,
                32.0151698
              ],
              [
                54.3305688,
                32.0151698
              ],
              [
                54.3302922,
                32.0148899
              ],
              [
                54.3247356,
                32.0129397
              ],
              [
                54.315569,
                32.0073958
              ],
              [
                54.3127889,
                32.0046147
              ],
              [
                54.3102785,
                31.9997382
              ],
              [
                54.3100124,
                31.9979422
              ],
              [
                54.3097358,
                31.9968316
              ],
              [
                54.3094558,
                31.9965608
              ],
              [
                54.3097358,
                31.9901682
              ],
              [
                54.3094557,
                31.9890576
              ],
              [
                54.3091791,
                31.987947
              ],
              [
                54.3089024,
                31.9871073
              ],
              [
                54.3086224,
                31.9862767
              ],
              [
                54.3083458,
                31.985166
              ],
              [
                54.3080691,
                31.9843354
              ],
              [
                54.3077891,
                31.9832248
              ],
              [
                54.3075125,
                31.9818344
              ],
              [
                54.3072358,
                31.9796132
              ],
              [
                54.3069557,
                31.9793332
              ],
              [
                54.3069557,
                31.9779428
              ],
              [
                54.3066791,
                31.9776719
              ],
              [
                54.3069557,
                31.977392
              ],
              [
                54.3066792,
                31.9771122
              ],
              [
                54.3069558,
                31.9765523
              ],
              [
                54.3061225,
                31.9659973
              ],
              [
                54.3058458,
                31.9651666
              ],
              [
                54.3055692,
                31.964327
              ],
              [
                54.3047358,
                31.9632254
              ],
              [
                54.3041792,
                31.9632254
              ],
              [
                54.3039025,
                31.9629455
              ],
              [
                54.3033458,
                31.9632254
              ],
              [
                54.3027892,
                31.9629455
              ],
              [
                54.2989766,
                31.9626673
              ],
              [
                54.2901102,
                31.9699237
              ],
              [
                54.2863653,
                31.9729884
              ],
              [
                54.2800137,
                31.9786676
              ],
              [
                54.2712753,
                31.9704437
              ],
              [
                54.2693104,
                31.9685944
              ],
              [
                54.2667483,
                31.9627042
              ],
              [
                54.2638757,
                31.9582345
              ],
              [
                54.2532345,
                31.9416749
              ],
              [
                54.2463681,
                31.9244843
              ],
              [
                54.2360684,
                31.9241929
              ],
              [
                54.225058,
                31.9228384
              ],
              [
                54.2036172,
                31.9301611
              ],
              [
                54.2000072,
                31.9318315
              ],
              [
                54.2000072,
                31.9321114
              ],
              [
                54.1980639,
                31.932942
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 6555543,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان زارچ",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                54.174563,
                31.9394839
              ],
              [
                54.1980639,
                31.932942
              ],
              [
                54.2000072,
                31.9321114
              ],
              [
                54.2000072,
                31.9318315
              ],
              [
                54.2036172,
                31.9301611
              ],
              [
                54.225058,
                31.9228384
              ],
              [
                54.2360684,
                31.9241929
              ],
              [
                54.2463681,
                31.9244843
              ],
              [
                54.2532345,
                31.9416749
              ],
              [
                54.2638757,
                31.9582345
              ],
              [
                54.2667483,
                31.9627042
              ],
              [
                54.2693104,
                31.9685944
              ],
              [
                54.2712753,
                31.9704437
              ],
              [
                54.2800137,
                31.9786676
              ],
              [
                54.2863653,
                31.9729884
              ],
              [
                54.2901102,
                31.9699237
              ],
              [
                54.2989766,
                31.9626673
              ],
              [
                54.3027892,
                31.9629455
              ],
              [
                54.3033458,
                31.9632254
              ],
              [
                54.3039025,
                31.9629455
              ],
              [
                54.3041792,
                31.9632254
              ],
              [
                54.3047358,
                31.9632254
              ],
              [
                54.3055692,
                31.964327
              ],
              [
                54.3058458,
                31.9651666
              ],
              [
                54.3061225,
                31.9659973
              ],
              [
                54.3069558,
                31.9765523
              ],
              [
                54.3066792,
                31.9771122
              ],
              [
                54.3069557,
                31.977392
              ],
              [
                54.3066791,
                31.9776719
              ],
              [
                54.3069557,
                31.9779428
              ],
              [
                54.3069557,
                31.9793332
              ],
              [
                54.3072358,
                31.9796132
              ],
              [
                54.3075125,
                31.9818344
              ],
              [
                54.3077891,
                31.9832248
              ],
              [
                54.3080691,
                31.9843354
              ],
              [
                54.3083458,
                31.985166
              ],
              [
                54.3086224,
                31.9862767
              ],
              [
                54.3089024,
                31.9871073
              ],
              [
                54.3091791,
                31.987947
              ],
              [
                54.3094557,
                31.9890576
              ],
              [
                54.3097358,
                31.9901682
              ],
              [
                54.3094558,
                31.9965608
              ],
              [
                54.3097358,
                31.9968316
              ],
              [
                54.3100124,
                31.9979422
              ],
              [
                54.3102785,
                31.9997382
              ],
              [
                54.3127889,
                32.0046147
              ],
              [
                54.315569,
                32.0073958
              ],
              [
                54.3247356,
                32.0129397
              ],
              [
                54.3302922,
                32.0148899
              ],
              [
                54.3305688,
                32.0151698
              ],
              [
                54.3314021,
                32.0151698
              ],
              [
                54.3447353,
                32.0215534
              ],
              [
                54.3452919,
                32.0215534
              ],
              [
                54.3458486,
                32.0218333
              ],
              [
                54.3504514,
                32.0235063
              ],
              [
                54.4016845,
                32.0421128
              ],
              [
                54.4030711,
                32.0421127
              ],
              [
                54.4236274,
                32.0479456
              ],
              [
                54.4247409,
                32.0482255
              ],
              [
                54.4273947,
                32.0487839
              ],
              [
                54.4352974,
                32.0504467
              ],
              [
                54.436684,
                32.0504467
              ],
              [
                54.4383506,
                32.0509975
              ],
              [
                54.4400173,
                32.0509975
              ],
              [
                54.440574,
                32.0512774
              ],
              [
                54.4425173,
                32.0512774
              ],
              [
                54.443074,
                32.0515573
              ],
              [
                54.4466838,
                32.0515573
              ],
              [
                54.4472405,
                32.0518372
              ],
              [
                54.4497405,
                32.0518372
              ],
              [
                54.4508538,
                32.0521171
              ],
              [
                54.4536305,
                32.0521171
              ],
              [
                54.4539072,
                32.0523879
              ],
              [
                54.4547405,
                32.0521171
              ],
              [
                54.4569638,
                32.0521171
              ],
              [
                54.4577971,
                32.052388
              ],
              [
                54.461687,
                32.052388
              ],
              [
                54.4625204,
                32.0526679
              ],
              [
                54.463907,
                32.0526679
              ],
              [
                54.4658536,
                32.0532277
              ],
              [
                54.4666869,
                32.0532277
              ],
              [
                54.4669637,
                32.0534986
              ],
              [
                54.4691869,
                32.0534986
              ],
              [
                54.4697436,
                32.0537784
              ],
              [
                54.4725202,
                32.0537785
              ],
              [
                54.4736302,
                32.0540584
              ],
              [
                54.4750201,
                32.0540584
              ],
              [
                54.4755769,
                32.0543293
              ],
              [
                54.4769635,
                32.0543293
              ],
              [
                54.4780768,
                32.0546091
              ],
              [
                54.48113,
                32.0546092
              ],
              [
                54.4841867,
                32.055169
              ],
              [
                54.4947432,
                32.055169
              ],
              [
                54.4955766,
                32.055169
              ],
              [
                54.4980766,
                32.0554398
              ],
              [
                54.4989098,
                32.0557288
              ],
              [
                54.5005765,
                32.0557288
              ],
              [
                54.5011332,
                32.0559996
              ],
              [
                54.5036332,
                32.0559996
              ],
              [
                54.5041864,
                32.0562795
              ],
              [
                54.509743,
                32.0562795
              ],
              [
                54.5102997,
                32.0559996
              ],
              [
                54.5186329,
                32.0559996
              ],
              [
                54.5197429,
                32.0557288
              ],
              [
                54.5272462,
                32.0509975
              ],
              [
                54.5283561,
                32.0504467
              ],
              [
                54.5327994,
                32.0443339
              ],
              [
                54.5330794,
                32.0437741
              ],
              [
                54.5341894,
                32.0418329
              ],
              [
                54.534466,
                32.0410022
              ],
              [
                54.5350228,
                32.0404514
              ],
              [
                54.5377993,
                32.0287767
              ],
              [
                54.5425226,
                32.0157206
              ],
              [
                54.5464125,
                32.009337
              ],
              [
                54.5469692,
                32.009057
              ],
              [
                54.5480792,
                32.0068359
              ],
              [
                54.5494691,
                32.0021136
              ],
              [
                54.5497458,
                32.0012739
              ],
              [
                54.5498083,
                32.0001661
              ],
              [
                54.5511358,
                31.9937798
              ],
              [
                54.5514125,
                31.99322
              ],
              [
                54.5519691,
                31.9904481
              ],
              [
                54.5608557,
                31.977392
              ],
              [
                54.5614123,
                31.977392
              ],
              [
                54.5616889,
                31.9771121
              ],
              [
                54.5636357,
                31.9765523
              ],
              [
                54.5647455,
                31.9765522
              ],
              [
                54.5650256,
                31.9762724
              ],
              [
                54.5825254,
                31.9748909
              ],
              [
                54.5889153,
                31.9740512
              ],
              [
                54.6105817,
                31.9729406
              ],
              [
                54.611415,
                31.9729406
              ],
              [
                54.631138,
                31.9721099
              ],
              [
                54.6383613,
                31.97211
              ],
              [
                54.6391946,
                31.9718301
              ],
              [
                54.6494711,
                31.97183
              ],
              [
                54.6703075,
                31.969329
              ],
              [
                54.6739175,
                31.969329
              ],
              [
                54.675584,
                31.9690491
              ],
              [
                54.7039204,
                31.966557
              ],
              [
                54.7044736,
                31.9668279
              ],
              [
                54.7075303,
                31.9668279
              ],
              [
                54.7141969,
                31.966828
              ],
              [
                54.7144769,
                31.9665571
              ],
              [
                54.7161436,
                31.9665571
              ],
              [
                54.7166968,
                31.9662771
              ],
              [
                54.7169769,
                31.966557
              ],
              [
                54.7180869,
                31.9665571
              ],
              [
                54.7180869,
                31.9662772
              ],
              [
                54.7189201,
                31.9659973
              ],
              [
                54.7236435,
                31.9684983
              ],
              [
                54.7253101,
                31.9701687
              ],
              [
                54.7255867,
                31.9707195
              ],
              [
                54.7455865,
                31.9862765
              ],
              [
                54.7458665,
                31.9865565
              ],
              [
                54.7461431,
                31.9868273
              ],
              [
                54.746236,
                31.9868274
              ],
              [
                54.7489198,
                31.9890575
              ],
              [
                54.7503098,
                31.9932199
              ],
              [
                54.7500331,
                31.9948903
              ],
              [
                54.7498444,
                31.9952613
              ],
              [
                54.749753,
                31.9954411
              ],
              [
                54.7497531,
                31.996531
              ],
              [
                54.7789227,
                32.0112782
              ],
              [
                54.8197588,
                32.0334988
              ],
              [
                54.8400352,
                32.0390518
              ],
              [
                54.8417018,
                32.0396116
              ],
              [
                54.8447584,
                32.0398915
              ],
              [
                54.8447585,
                32.0401715
              ],
              [
                54.8453151,
                32.0407222
              ],
              [
                54.8453151,
                32.0415528
              ],
              [
                54.8455918,
                32.0421127
              ],
              [
                54.8458684,
                32.0429434
              ],
              [
                54.8461486,
                32.0443339
              ],
              [
                54.8464251,
                32.0490561
              ],
              [
                54.8453151,
                32.0615615
              ],
              [
                54.8453151,
                32.0618324
              ],
              [
                54.8425351,
                32.0715568
              ],
              [
                54.8422584,
                32.0735072
              ],
              [
                54.8417019,
                32.0746177
              ],
              [
                54.8411485,
                32.0779495
              ],
              [
                54.8400352,
                32.0815522
              ],
              [
                54.8239254,
                32.104333
              ],
              [
                54.8225355,
                32.1051727
              ],
              [
                54.8083691,
                32.1118362
              ],
              [
                54.8050358,
                32.1132267
              ],
              [
                54.7819794,
                32.1196195
              ],
              [
                54.7811461,
                32.1196194
              ],
              [
                54.7780895,
                32.1204501
              ],
              [
                54.7697562,
                32.1226714
              ],
              [
                54.7544764,
                32.1276735
              ],
              [
                54.753643,
                32.1279535
              ],
              [
                54.7500331,
                32.1298947
              ],
              [
                54.7161436,
                32.1615605
              ],
              [
                54.7119736,
                32.1671134
              ],
              [
                54.7058637,
                32.1760073
              ],
              [
                54.7055872,
                32.1765582
              ],
              [
                54.7000305,
                32.1873933
              ],
              [
                54.6705842,
                32.2143369
              ],
              [
                54.6697509,
                32.2148967
              ],
              [
                54.6639177,
                32.2176687
              ],
              [
                54.6530845,
                32.2204496
              ],
              [
                54.6514178,
                32.2207296
              ],
              [
                54.6494711,
                32.2210096
              ],
              [
                54.6439179,
                32.2210095
              ],
              [
                54.6416947,
                32.2212804
              ],
              [
                54.6394713,
                32.2215603
              ],
              [
                54.6358614,
                32.2218402
              ],
              [
                54.6328048,
                32.2215603
              ],
              [
                54.6314147,
                32.2212804
              ],
              [
                54.6214149,
                32.2212804
              ],
              [
                54.6161383,
                32.2210095
              ],
              [
                54.6136384,
                32.2204498
              ],
              [
                54.6116916,
                32.2204497
              ],
              [
                54.6080818,
                32.2198989
              ],
              [
                54.6005819,
                32.2173978
              ],
              [
                54.5997486,
                32.216838
              ],
              [
                54.5755788,
                32.2043323
              ],
              [
                54.5647456,
                32.1935062
              ],
              [
                54.5591891,
                32.1887839
              ],
              [
                54.5525224,
                32.1790592
              ],
              [
                54.5525225,
                32.1787793
              ],
              [
                54.5475226,
                32.1760074
              ],
              [
                54.5455793,
                32.1754475
              ],
              [
                54.5225228,
                32.1640616
              ],
              [
                54.5214095,
                32.1635018
              ],
              [
                54.5061331,
                32.1576689
              ],
              [
                54.4953,
                32.1543371
              ],
              [
                54.4897433,
                32.1526666
              ],
              [
                54.4883533,
                32.1521158
              ],
              [
                54.4869634,
                32.151836
              ],
              [
                54.473042,
                32.1450209
              ],
              [
                54.4597403,
                32.1385087
              ],
              [
                54.4352974,
                32.129335
              ],
              [
                54.4336308,
                32.1287843
              ],
              [
                54.4314075,
                32.1282245
              ],
              [
                54.4300175,
                32.1279535
              ],
              [
                54.4296311,
                32.1278561
              ],
              [
                54.4289074,
                32.1276737
              ],
              [
                54.4284333,
                32.1275901
              ],
              [
                54.4286275,
                32.1271138
              ],
              [
                54.4377974,
                32.1123961
              ],
              [
                54.4377974,
                32.1115565
              ],
              [
                54.4339075,
                32.1073939
              ],
              [
                54.4333507,
                32.1073939
              ],
              [
                54.4275175,
                32.1037823
              ],
              [
                54.417241,
                32.0998907
              ],
              [
                54.4164077,
                32.0996198
              ],
              [
                54.4141844,
                32.09878
              ],
              [
                54.4130743,
                32.0987801
              ],
              [
                54.4127943,
                32.0985001
              ],
              [
                54.4030711,
                32.0954483
              ],
              [
                54.4016846,
                32.0954483
              ],
              [
                54.3608484,
                32.085173
              ],
              [
                54.3506771,
                32.0811685
              ],
              [
                54.3439019,
                32.0785005
              ],
              [
                54.3275122,
                32.0732274
              ],
              [
                54.2913993,
                32.0512774
              ],
              [
                54.2841795,
                32.0487763
              ],
              [
                54.2752896,
                32.0440631
              ],
              [
                54.2738996,
                32.0426636
              ],
              [
                54.2452866,
                32.0235037
              ],
              [
                54.2269536,
                32.0048947
              ],
              [
                54.2254062,
                32.004087
              ],
              [
                54.2205093,
                32.001531
              ],
              [
                54.2158403,
                31.9990936
              ],
              [
                54.2147304,
                31.9929491
              ],
              [
                54.2148778,
                31.9919185
              ],
              [
                54.2151685,
                31.989886
              ],
              [
                54.215287,
                31.9890576
              ],
              [
                54.2160558,
                31.9883348
              ],
              [
                54.2163785,
                31.9880315
              ],
              [
                54.2171413,
                31.9873144
              ],
              [
                54.2177747,
                31.9867188
              ],
              [
                54.2189635,
                31.9856011
              ],
              [
                54.2198923,
                31.9847278
              ],
              [
                54.220287,
                31.9843567
              ],
              [
                54.220287,
                31.9840555
              ],
              [
                54.220287,
                31.9837756
              ],
              [
                54.1841741,
                31.9476684
              ],
              [
                54.1833407,
                31.9471085
              ],
              [
                54.1827841,
                31.9462779
              ],
              [
                54.174563,
                31.9394839
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 14474227,
        "tags": {
          "admin_level": "5",
          "boundary": "administrative",
          "name": "شهرستان مروست",
          "ref:sci": "2112",
          "type": "boundary"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                53.836819,
                30.6525237
              ],
              [
                53.8476964,
                30.6446677
              ],
              [
                53.8616004,
                30.6299459
              ],
              [
                53.8733531,
                30.6117635
              ],
              [
                53.8778076,
                30.6040636
              ],
              [
                53.887482,
                30.5820481
              ],
              [
                53.8968836,
                30.5583246
              ],
              [
                53.9018668,
                30.5437705
              ],
              [
                53.9099119,
                30.5266315
              ],
              [
                53.9215849,
                30.4989762
              ],
              [
                53.9264741,
                30.4868042
              ],
              [
                53.914306,
                30.4323899
              ],
              [
                53.92004,
                30.4118182
              ],
              [
                53.9340739,
                30.3872274
              ],
              [
                53.9365988,
                30.3784839
              ],
              [
                53.9361912,
                30.3474819
              ],
              [
                53.9361941,
                30.331721
              ],
              [
                53.9364331,
                30.3160072
              ],
              [
                53.936558,
                30.2981132
              ],
              [
                53.9330787,
                30.2834454
              ],
              [
                53.9296345,
                30.2706281
              ],
              [
                53.9231997,
                30.2471378
              ],
              [
                53.9219181,
                30.2382399
              ],
              [
                53.9190915,
                30.2225017
              ],
              [
                53.9051055,
                30.2382326
              ],
              [
                53.8998698,
                30.2341542
              ],
              [
                53.8984813,
                30.2316934
              ],
              [
                53.9040435,
                30.2238568
              ],
              [
                53.8997304,
                30.2229837
              ],
              [
                53.8796138,
                30.2252551
              ],
              [
                53.8811442,
                30.2146892
              ],
              [
                53.8893127,
                30.2009269
              ],
              [
                53.9004017,
                30.2026288
              ],
              [
                53.9143696,
                30.2027922
              ],
              [
                53.9133622,
                30.1993398
              ],
              [
                53.9051768,
                30.1891218
              ],
              [
                53.9049742,
                30.1698955
              ],
              [
                53.9041767,
                30.162404
              ],
              [
                53.8705105,
                30.1714395
              ],
              [
                53.8700802,
                30.1662898
              ],
              [
                53.8897142,
                30.1339738
              ],
              [
                53.887582,
                30.1217065
              ],
              [
                53.8930309,
                30.1060752
              ],
              [
                53.8970842,
                30.0969855
              ],
              [
                53.9043049,
                30.0889645
              ],
              [
                53.9160828,
                30.0767538
              ],
              [
                53.9222901,
                30.0695784
              ],
              [
                53.9250386,
                30.0652301
              ],
              [
                53.9298696,
                30.0621121
              ],
              [
                53.930383,
                30.0591873
              ],
              [
                53.9390569,
                30.0529789
              ],
              [
                53.9564966,
                30.0433455
              ],
              [
                53.9687204,
                30.0377689
              ],
              [
                53.9744523,
                30.035201
              ],
              [
                53.9802302,
                30.0317616
              ],
              [
                53.9919484,
                30.0222
              ],
              [
                53.9999096,
                30.0154584
              ],
              [
                54.0238242,
                30.002674
              ],
              [
                54.0362389,
                29.9971728
              ],
              [
                54.0432188,
                29.9967304
              ],
              [
                54.0429496,
                30.0014764
              ],
              [
                54.0429496,
                30.0054158
              ],
              [
                54.0442371,
                30.0100983
              ],
              [
                54.0441411,
                30.0160153
              ],
              [
                54.0462703,
                30.0312858
              ],
              [
                54.0524885,
                30.0507872
              ],
              [
                54.0975644,
                30.1044829
              ],
              [
                54.1238803,
                30.1320107
              ],
              [
                54.148583,
                30.1639891
              ],
              [
                54.1594019,
                30.174999
              ],
              [
                54.1766737,
                30.1979597
              ],
              [
                54.2040117,
                30.2329675
              ],
              [
                54.221649,
                30.2434974
              ],
              [
                54.2601812,
                30.2444048
              ],
              [
                54.287567,
                30.2467599
              ],
              [
                54.2951243,
                30.2432294
              ],
              [
                54.3186688,
                30.2383859
              ],
              [
                54.3479765,
                30.2346959
              ],
              [
                54.3588919,
                30.2335931
              ],
              [
                54.368822,
                30.2317587
              ],
              [
                54.3946978,
                30.2310171
              ],
              [
                54.421297,
                30.2289237
              ],
              [
                54.4407633,
                30.226699
              ],
              [
                54.4673625,
                30.2256349
              ],
              [
                54.5095252,
                30.2256259
              ],
              [
                54.5315887,
                30.2254789
              ],
              [
                54.5332145,
                30.225663
              ],
              [
                54.5332989,
                30.2346077
              ],
              [
                54.5302962,
                30.2377136
              ],
              [
                54.5284079,
                30.2458701
              ],
              [
                54.5301245,
                30.2587708
              ],
              [
                54.5227429,
                30.2679635
              ],
              [
                54.4987105,
                30.2778963
              ],
              [
                54.4899557,
                30.2764138
              ],
              [
                54.480686,
                30.2787857
              ],
              [
                54.4755288,
                30.2829881
              ],
              [
                54.4530484,
                30.2958324
              ],
              [
                54.433479,
                30.3118387
              ],
              [
                54.4156262,
                30.3287313
              ],
              [
                54.3976017,
                30.3429544
              ],
              [
                54.3806073,
                30.3687286
              ],
              [
                54.3778607,
                30.3799841
              ],
              [
                54.3703076,
                30.3933113
              ],
              [
                54.4463903,
                30.4554263
              ],
              [
                54.4767376,
                30.482409
              ],
              [
                54.5285794,
                30.5318068
              ],
              [
                54.5504621,
                30.5652224
              ],
              [
                54.5594686,
                30.5826324
              ],
              [
                54.5630785,
                30.5968009
              ],
              [
                54.5653019,
                30.6098594
              ],
              [
                54.5655785,
                30.6198588
              ],
              [
                54.5645818,
                30.6536253
              ],
              [
                54.5610666,
                30.6682962
              ],
              [
                54.5592212,
                30.6736115
              ],
              [
                54.557805,
                30.680772
              ],
              [
                54.5581107,
                30.6818697
              ],
              [
                54.5573329,
                30.6828757
              ],
              [
                54.5546722,
                30.6915117
              ],
              [
                54.5529555,
                30.7027299
              ],
              [
                54.5534705,
                30.7129137
              ],
              [
                54.5526413,
                30.7308434
              ],
              [
                54.5507239,
                30.768463
              ],
              [
                54.5478915,
                30.7852763
              ],
              [
                54.5468356,
                30.7964279
              ],
              [
                54.5445441,
                30.8046671
              ],
              [
                54.5439122,
                30.8290264
              ],
              [
                54.5439122,
                30.8312557
              ],
              [
                54.539051,
                30.8518373
              ],
              [
                54.5366477,
                30.8694464
              ],
              [
                54.5407257,
                30.8837669
              ],
              [
                54.5406921,
                30.8965921
              ],
              [
                54.535319,
                30.9186348
              ],
              [
                54.5306041,
                30.9325736
              ],
              [
                54.5286324,
                30.9415345
              ],
              [
                54.5277,
                30.9598502
              ],
              [
                54.5278908,
                30.9760685
              ],
              [
                54.5270384,
                30.9888376
              ],
              [
                54.5272733,
                30.9954896
              ],
              [
                54.5266284,
                31.0003865
              ],
              [
                54.5270813,
                31.0049979
              ],
              [
                54.5274639,
                31.0079228
              ],
              [
                54.5274639,
                31.0101665
              ],
              [
                54.5268631,
                31.014286
              ],
              [
                54.5267527,
                31.0183671
              ],
              [
                54.5205106,
                31.0179102
              ],
              [
                54.5125066,
                31.0173217
              ],
              [
                54.4533369,
                31.0127773
              ],
              [
                54.4091592,
                31.0092986
              ],
              [
                54.3379488,
                31.0037442
              ],
              [
                54.3073065,
                31.0012207
              ],
              [
                54.2852654,
                30.9980571
              ],
              [
                54.2545716,
                30.9938635
              ],
              [
                54.2385245,
                30.9926126
              ],
              [
                54.2150327,
                30.9906269
              ],
              [
                54.2029266,
                30.9908097
              ],
              [
                54.17725,
                30.9885144
              ],
              [
                54.1613098,
                30.9880213
              ],
              [
                54.1471536,
                30.9873448
              ],
              [
                54.1401596,
                30.9859467
              ],
              [
                54.1305333,
                30.9874376
              ],
              [
                54.1276645,
                30.9854092
              ],
              [
                54.1248321,
                30.9851149
              ],
              [
                54.120283,
                30.984747
              ],
              [
                54.1139316,
                30.9852621
              ],
              [
                54.1009711,
                30.9861451
              ],
              [
                54.0786551,
                30.9857036
              ],
              [
                54.0606306,
                30.9829075
              ],
              [
                54.0441642,
                30.9849165
              ],
              [
                54.0294896,
                30.9822531
              ],
              [
                54.0168142,
                30.98173
              ],
              [
                54.0129947,
                30.9808838
              ],
              [
                54.0128987,
                30.9793832
              ],
              [
                54.000657,
                30.9797511
              ],
              [
                53.9791271,
                30.9792224
              ],
              [
                53.9609142,
                30.9559747
              ],
              [
                53.9560305,
                30.9483114
              ],
              [
                53.939296,
                30.9162004
              ],
              [
                53.9135642,
                30.8614143
              ],
              [
                53.8890916,
                30.809598
              ],
              [
                53.8619602,
                30.7529087
              ],
              [
                53.8513821,
                30.7286804
              ],
              [
                53.8459593,
                30.7132446
              ],
              [
                53.8414814,
                30.6930443
              ],
              [
                53.839208,
                30.680992
              ],
              [
                53.8383139,
                30.6688755
              ],
              [
                53.8375472,
                30.6582594
              ],
              [
                53.836819,
                30.6525237
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 3549100584
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.0159205,
          32.2510825
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 4320639994
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.0159678,
          32.3063333
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 5515976855
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          54.2071804,
          32.000526
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "node",
        "id": 1883871566
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          55.3966892,
          31.5997065
        ]
      }
    }
  ]
},
"iran_provinces_geo.json":{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 225444,
        "tags": {
          "ISO3166-2": "IR-28",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "خراسان شمالی",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q180075"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [55.8692842, 37.3230584],
              [55.8692841, 37.3226794],
              [55.8838461, 37.3197998],
              [55.8967207, 37.3236221],
              [55.9109227, 37.3225239],
              [55.9136362, 37.3063754],
              [55.9097928, 37.297721],
              [55.9109686, 37.2873019],
              [55.9064431, 37.2803711],
              [55.9061629, 37.2773208],
              [55.9058863, 37.2742615],
              [55.9053296, 37.267315],
              [55.9050531, 37.262591],
              [55.9051029, 37.2558231],
              [55.9048262, 37.2555443],
              [55.9048262, 37.2519272],
              [55.9048262, 37.2455388],
              [55.9045463, 37.2374858],
              [55.9042696, 37.233041],
              [55.9039929, 37.2305395],
              [55.9037128, 37.2288749],
              [55.9034363, 37.2260945],
              [55.9039305, 37.2132418],
              [55.9060778, 37.2049876],
              [55.9092312, 37.2003091],
              [55.9089544, 37.1989139],
              [55.9107969, 37.1876728],
              [55.9197876, 37.1825238],
              [55.9220108, 37.1825239],
              [55.9228443, 37.1822449],
              [55.9278442, 37.1822449],
              [55.9336775, 37.1822448],
              [55.9342342, 37.1822448],
              [55.9361774, 37.1825239],
              [55.9367341, 37.1825239],
              [55.9375674, 37.182803],
              [55.9928576, 37.1743985],
              [56.0062405, 37.1622321],
              [56.0117, 37.1477538],
              [56.0120748, 37.1375232],
              [56.0100179, 37.1046278],
              [56.0074423, 37.0705192],
              [56.0129355, 37.0575061],
              [56.021855, 37.0510878],
              [56.029821, 37.0408502],
              [56.0298709, 37.0349065],
              [56.0306166, 37.0316104],
              [56.0350791, 37.0255818],
              [56.0337309, 37.0176012],
              [56.0275267, 37.012971],
              [56.02787, 37.0100924],
              [56.0326765, 36.9995367],
              [56.0240711, 36.9951731],
              [56.0216469, 36.9813486],
              [56.0209191, 36.968641],
              [56.0110741, 36.9512318],
              [56.0108647, 36.9497598],
              [56.0108498, 36.9496553],
              [56.0107975, 36.9492872],
              [56.0105175, 36.948459],
              [56.0076659, 36.9418165],
              [56.0037592, 36.9303808],
              [56.0034791, 36.9295525],
              [56.0010908, 36.9203914],
              [56.0000608, 36.9061173],
              [56.0038374, 36.8951353],
              [56.0057192, 36.8883389],
              [56.0038377, 36.8776314],
              [56.0046744, 36.8743008],
              [56.0049511, 36.8737517],
              [56.0181712, 36.8746773],
              [56.0278698, 36.8730296],
              [56.0330196, 36.8683605],
              [56.0635754, 36.8592961],
              [56.0773083, 36.8581973],
              [56.0927461, 36.8563466],
              [56.0930263, 36.8560674],
              [56.0974696, 36.8546803],
              [56.1037794, 36.8532569],
              [56.1878582, 36.8120337],
              [56.2235638, 36.7878416],
              [56.2431332, 36.7823424],
              [56.2507752, 36.7791028],
              [56.2596127, 36.7735428],
              [56.2688824, 36.7707927],
              [56.2870785, 36.7562155],
              [56.3170652, 36.7387089],
              [56.3592771, 36.6872246],
              [56.3590005, 36.6863872],
              [56.3595572, 36.6827762],
              [56.3612239, 36.6816685],
              [56.3631671, 36.6822268],
              [56.3716719, 36.6705307],
              [56.3733385, 36.6710891],
              [56.3744486, 36.6710891],
              [56.3967703, 36.6761293],
              [56.4178597, 36.6768119],
              [56.4198064, 36.6768119],
              [56.4206398, 36.6770911],
              [56.4412346, 36.6813653],
              [56.4417911, 36.6810862],
              [56.4429011, 36.6810861],
              [56.4492494, 36.6837056],
              [56.4503627, 36.6834265],
              [56.4590809, 36.684179],
              [56.4618659, 36.6836876],
              [56.4629792, 36.6831293],
              [56.4695292, 36.6778696],
              [56.4709193, 36.6775995],
              [56.4780726, 36.6620934],
              [56.4894624, 36.650141],
              [56.4930723, 36.6484746],
              [56.4939057, 36.6484746],
              [56.4944624, 36.6481954],
              [56.4952957, 36.6481955],
              [56.4961289, 36.6479162],
              [56.4983523, 36.6479162],
              [56.5014057, 36.6484747],
              [56.5036289, 36.6484746],
              [56.5164087, 36.6504202],
              [56.5183521, 36.6504202],
              [56.5194621, 36.6506994],
              [56.5490338, 36.6532718],
              [56.573753, 36.6576786],
              [56.5792462, 36.6590557],
              [56.6053387, 36.6543735],
              [56.618385, 36.6540981],
              [56.6273114, 36.6601573],
              [56.6345211, 36.6623606],
              [56.6460995, 36.6716304],
              [56.6469328, 36.6719094],
              [56.6483228, 36.6736649],
              [56.6410587, 36.6759784],
              [56.6251358, 36.6806655],
              [56.6104885, 36.6849403],
              [56.5992089, 36.6950964],
              [56.5991259, 36.7106298],
              [56.6073208, 36.7174511],
              [56.6100974, 36.7196755],
              [56.6125975, 36.7210624],
              [56.6142642, 36.7227284],
              [56.6518522, 36.7489177],
              [56.6551855, 36.7514124],
              [56.6733285, 36.7583451],
              [56.6752717, 36.7591736],
              [56.6921995, 36.7670798],
              [56.6999243, 36.7782176],
              [56.7129067, 36.7952847],
              [56.7156833, 36.796113],
              [56.7212399, 36.7988951],
              [56.72263, 36.7991742],
              [56.7242966, 36.8000026],
              [56.7634629, 36.8105636],
              [56.7731861, 36.8144531],
              [56.7745761, 36.8147322],
              [56.7773526, 36.8161187],
              [56.7792993, 36.816677],
              [56.7850594, 36.8189212],
              [56.7856161, 36.8192003],
              [56.7875595, 36.8192003],
              [56.7881162, 36.8194794],
              [56.7892531, 36.823639],
              [56.7903629, 36.823918],
              [56.7954496, 36.8280446],
              [56.7965596, 36.8280447],
              [56.8004495, 36.829152],
              [56.8023929, 36.829431],
              [56.8088161, 36.8396154],
              [56.8269527, 36.8473761],
              [56.8316393, 36.8512392],
              [56.8385226, 36.8537116],
              [56.8519224, 36.858965],
              [56.8822986, 36.8809887],
              [56.8889685, 36.8823746],
              [56.9132714, 36.8906472],
              [56.9243377, 36.8885832],
              [56.9320838, 36.8851475],
              [56.9329552, 36.8853667],
              [56.9405856, 36.8814796],
              [56.9428566, 36.8820376],
              [56.9582745, 36.8711071],
              [56.9884869, 36.8678112],
              [57.0137868, 36.8595642],
              [57.0157335, 36.8601225],
              [57.0165667, 36.8601225],
              [57.0222367, 36.8565556],
              [57.0230699, 36.8568348],
              [57.02446, 36.8568348],
              [57.0252932, 36.8571139],
              [57.0311265, 36.8571138],
              [57.03196, 36.857393],
              [57.0347364, 36.8573931],
              [57.0355698, 36.8571138],
              [57.0380698, 36.8571139],
              [57.0405698, 36.8565556],
              [57.041683, 36.8565555],
              [57.0589594, 36.8541766],
              [57.0597927, 36.8536183],
              [57.0907807, 36.8476159],
              [57.102259, 36.8456581],
              [57.1033722, 36.8456581],
              [57.1167056, 36.8414892],
              [57.1178155, 36.840931],
              [57.1222621, 36.8414633],
              [57.1297621, 36.8386812],
              [57.1336487, 36.8375737],
              [57.1363646, 36.8374279],
              [57.137198, 36.8371489],
              [57.138651, 36.8373205],
              [57.1392165, 36.837207],
              [57.144649, 36.8371789],
              [57.1468735, 36.8374493],
              [57.1512523, 36.8361785],
              [57.1648251, 36.8375483],
              [57.1662151, 36.8372691],
              [57.168435, 36.8372692],
              [57.169825, 36.83699],
              [57.1717682, 36.8369901],
              [57.1731583, 36.836711],
              [57.175105, 36.836711],
              [57.1784383, 36.8361528],
              [57.1820481, 36.8361528],
              [57.1851049, 36.8356034],
              [57.1870483, 36.8356035],
              [57.1878815, 36.8353243],
              [57.1895481, 36.8353243],
              [57.1903815, 36.8350453],
              [57.1931614, 36.8350452],
              [57.1945479, 36.8347662],
              [57.1959381, 36.8347662],
              [57.2068402, 36.8241268],
              [57.2317805, 36.822907],
              [57.2370604, 36.8220696],
              [57.2415037, 36.8209619],
              [57.2428937, 36.8209621],
              [57.2432626, 36.820776],
              [57.2928507, 36.8098256],
              [57.2936838, 36.8095465],
              [57.2956304, 36.8095465],
              [57.2967371, 36.8092674],
              [57.371876, 36.7931203],
              [57.3738159, 36.7920128],
              [57.4018293, 36.7872256],
              [57.4034958, 36.7869465],
              [57.4057157, 36.7861182],
              [57.4418286, 36.7802836],
              [57.4437751, 36.7802837],
              [57.4448888, 36.7800045],
              [57.4471085, 36.7800045],
              [57.4548887, 36.778618],
              [57.4898883, 36.7691637],
              [57.4921082, 36.7683355],
              [57.4993345, 36.7658323],
              [57.5057214, 36.7636172],
              [57.5062745, 36.7630591],
              [57.5096078, 36.7619515],
              [57.5101679, 36.7613933],
              [57.5173877, 36.758611],
              [57.5267976, 36.7544584],
              [57.5290243, 36.7541792],
              [57.5356876, 36.7472633],
              [57.5367942, 36.7470404],
              [57.5454077, 36.7436524],
              [57.5470742, 36.7433823],
              [57.5808837, 36.7198556],
              [57.6069366, 36.7089693],
              [57.6119368, 36.7056372],
              [57.6158232, 36.7020259],
              [57.6396198, 36.6913835],
              [57.6585061, 36.6805595],
              [57.663742, 36.6785129],
              [57.7018387, 36.6636118],
              [57.7079521, 36.6619458],
              [57.715732, 36.6583348],
              [57.7182321, 36.6574973],
              [57.7457318, 36.6433319],
              [57.7521249, 36.6405581],
              [57.7773976, 36.6302737],
              [57.8215709, 36.6161078],
              [57.8684105, 36.5870531],
              [57.8695239, 36.5870531],
              [57.8714637, 36.5865036],
              [57.8789634, 36.5848372],
              [57.8931573, 36.5871648],
              [57.8978204, 36.5833137],
              [57.9048156, 36.5783512],
              [57.909708, 36.5772139],
              [57.9170865, 36.5752569],
              [57.9238669, 36.5717998],
              [57.930189, 36.5704957],
              [57.9339201, 36.5696269],
              [57.943698, 36.5685225],
              [57.951538, 36.568367],
              [57.9638671, 36.5680462],
              [57.9699823, 36.5690811],
              [57.9739523, 36.5695282],
              [57.9851532, 36.5712515],
              [57.9884147, 36.5728369],
              [57.9996703, 36.5814981],
              [58.0190041, 36.5951521],
              [58.0376651, 36.6010129],
              [58.0637891, 36.6088154],
              [58.068881, 36.6116425],
              [58.0727004, 36.6181456],
              [58.0787086, 36.6228988],
              [58.083433, 36.6280121],
              [58.0839442, 36.6299249],
              [58.0812835, 36.6330933],
              [58.0765628, 36.6363993],
              [58.0750178, 36.6395674],
              [58.0709838, 36.6414269],
              [58.0658776, 36.6459976],
              [58.066083, 36.6497783],
              [58.0686664, 36.6543732],
              [58.0709343, 36.6609173],
              [58.0750608, 36.6637373],
              [58.0794382, 36.6694516],
              [58.081157, 36.6724085],
              [58.0863771, 36.6753471],
              [58.0884504, 36.678573],
              [58.0875492, 36.6812231],
              [58.083558, 36.6816705],
              [58.0796095, 36.6843552],
              [58.0761337, 36.687177],
              [58.075962, 36.6887944],
              [58.0819273, 36.6907904],
              [58.094115, 36.6976384],
              [58.0938379, 36.7032503],
              [58.0951775, 36.7094058],
              [58.0914545, 36.7102655],
              [58.0872917, 36.7121921],
              [58.0798207, 36.716483],
              [58.0817127, 36.7177307],
              [58.0868625, 36.723785],
              [58.095102, 36.7305269],
              [58.1010675, 36.7371302],
              [58.0995655, 36.7407756],
              [58.0957442, 36.7481638],
              [58.1006813, 36.7532927],
              [58.1079766, 36.7584848],
              [58.1246573, 36.7664635],
              [58.1282574, 36.7683822],
              [58.128386, 36.7744515],
              [58.1273054, 36.7829016],
              [58.1216214, 36.7893409],
              [58.1086452, 36.8045164],
              [58.1068826, 36.8057628],
              [58.104182, 36.8071776],
              [58.0969856, 36.8111915],
              [58.0943261, 36.8176761],
              [58.0898663, 36.8279743],
              [58.0850172, 36.8392403],
              [58.0819273, 36.8455426],
              [58.0781281, 36.8542795],
              [58.0761505, 36.8588681],
              [58.0815189, 36.8601427],
              [58.0925396, 36.8628166],
              [58.1099528, 36.8669799],
              [58.1303191, 36.8715383],
              [58.142399, 36.8740469],
              [58.1543878, 36.8782624],
              [58.166099, 36.8826335],
              [58.1939046, 36.8894989],
              [58.2049671, 36.8922868],
              [58.2110353, 36.8790485],
              [58.2178202, 36.8801677],
              [58.2195107, 36.8797019],
              [58.2226129, 36.8795775],
              [58.2261532, 36.8815633],
              [58.2301291, 36.8844487],
              [58.2382216, 36.8893574],
              [58.2475246, 36.8965927],
              [58.2626539, 36.9106987],
              [58.2721931, 36.9156663],
              [58.2763522, 36.9179427],
              [58.2797298, 36.9198457],
              [58.2909356, 36.9262502],
              [58.2978115, 36.9305869],
              [58.3019936, 36.9341468],
              [58.3131959, 36.939745],
              [58.3227167, 36.9445605],
              [58.3274959, 36.9476302],
              [58.3360185, 36.9541903],
              [58.3407249, 36.9576562],
              [58.3443971, 36.9631784],
              [58.3524176, 36.9766817],
              [58.3544188, 36.9856145],
              [58.3559309, 36.9905253],
              [58.3581942, 36.9971428],
              [58.357726, 36.9999808],
              [58.3555755, 37.0051087],
              [58.351308, 37.0094025],
              [58.3448216, 37.0137642],
              [58.333928, 37.0186814],
              [58.3230578, 37.019693],
              [58.3128693, 37.0192252],
              [58.3023073, 37.0218778],
              [58.2859412, 37.0260814],
              [58.2765811, 37.028476],
              [58.2691814, 37.0306166],
              [58.2606529, 37.0331495],
              [58.2585023, 37.0363777],
              [58.2544429, 37.0426138],
              [58.2512799, 37.0474909],
              [58.2495559, 37.0488613],
              [58.2397744, 37.0581835],
              [58.2323491, 37.0680569],
              [58.2282808, 37.0759122],
              [58.2118877, 37.0795245],
              [58.1975814, 37.0848411],
              [58.1819782, 37.0907336],
              [58.1733704, 37.0968941],
              [58.1841477, 37.1121496],
              [58.1927773, 37.1280923],
              [58.1970691, 37.137672],
              [58.1984725, 37.1403551],
              [58.2080379, 37.1519387],
              [58.2135671, 37.1547662],
              [58.2341476, 37.1529974],
              [58.2455631, 37.1522449],
              [58.2552621, 37.1518344],
              [58.2597255, 37.1519026],
              [58.2636737, 37.1522447],
              [58.26848, 37.1551864],
              [58.270626, 37.1592222],
              [58.2703685, 37.1622319],
              [58.2665062, 37.1657202],
              [58.261399, 37.1668831],
              [58.2479289, 37.167732],
              [58.2395756, 37.172165],
              [58.2384353, 37.1757051],
              [58.2385808, 37.1790635],
              [58.2409636, 37.1818043],
              [58.2484388, 37.1839802],
              [58.2526445, 37.1833306],
              [58.2610988, 37.183946],
              [58.2733726, 37.1880488],
              [58.2756895, 37.1896338],
              [58.2812687, 37.1877413],
              [58.2845425, 37.1864574],
              [58.2917436, 37.1818301],
              [58.2962668, 37.1792603],
              [58.3139811, 37.1689323],
              [58.3099874, 37.1775119],
              [58.3077558, 37.1832852],
              [58.3040066, 37.193598],
              [58.3079457, 37.1961985],
              [58.3099419, 37.1989605],
              [58.308072, 37.2005908],
              [58.3001659, 37.198409],
              [58.3005599, 37.2020466],
              [58.3114128, 37.2101242],
              [58.3193769, 37.2126384],
              [58.3268552, 37.2130485],
              [58.3313206, 37.2141134],
              [58.3350054, 37.2179411],
              [58.3409412, 37.2224918],
              [58.3519337, 37.2216718],
              [58.3633038, 37.2196158],
              [58.3701358, 37.2181803],
              [58.3764828, 37.2167736],
              [58.3899517, 37.2138017],
              [58.3939745, 37.2138704],
              [58.4019899, 37.213891],
              [58.4148067, 37.2201301],
              [58.4177258, 37.2443819],
              [58.4191121, 37.2485478],
              [58.4154325, 37.2585858],
              [58.4151594, 37.2588647],
              [58.4143257, 37.2588648],
              [58.4065658, 37.2735281],
              [58.4032325, 37.2757505],
              [58.3782328, 37.2899205],
              [58.3698832, 37.2962452],
              [58.3690499, 37.2965152],
              [58.360372, 37.3104508],
              [58.3298302, 37.327215],
              [58.3235402, 37.3325165],
              [58.3092495, 37.3431405],
              [58.3096638, 37.3519522],
              [58.3119206, 37.3574911],
              [58.3160406, 37.3608556],
              [58.3163206, 37.3619622],
              [58.3179871, 37.3677918],
              [58.3366803, 37.3820307],
              [58.3405666, 37.3859172],
              [58.35886, 37.39487],
              [58.3638601, 37.4015364],
              [58.3679433, 37.4170664],
              [58.3676632, 37.4212407],
              [58.3682234, 37.4245692],
              [58.3679434, 37.4292921],
              [58.3494197, 37.4432959],
              [58.3379169, 37.4549378],
              [58.3386524, 37.4999863],
              [58.326206, 37.5390237],
              [58.3207883, 37.5672602],
              [58.3142488, 37.5874988],
              [58.2979048, 37.6373714],
              [58.299905, 37.6525298],
              [58.2989117, 37.6547113],
              [58.3112048, 37.662222],
              [58.306389, 37.662222],
              [58.298889, 37.663611],
              [58.288205, 37.6662374],
              [58.2864885, 37.6681187],
              [58.2816889, 37.669368],
              [58.2803236, 37.6708576],
              [58.273254, 37.6717923],
              [58.2628287, 37.6737524],
              [58.2578763, 37.6756835],
              [58.2516721, 37.6772477],
              [58.2460889, 37.6790518],
              [58.2421005, 37.680074],
              [58.2357033, 37.6817136],
              [58.2270467, 37.6840365],
              [58.2260609, 37.692836],
              [58.2289739, 37.6987164],
              [58.2282752, 37.7017188],
              [58.229662, 37.7030492],
              [58.2325767, 37.7043333],
              [58.2335146, 37.7053932],
              [58.234376, 37.7066255],
              [58.2346464, 37.7070215],
              [58.2344858, 37.7075144],
              [58.2337484, 37.7082837],
              [58.2333865, 37.708995],
              [58.2326344, 37.7097757],
              [58.2321857, 37.7105082],
              [58.232053, 37.7114041],
              [58.2313292, 37.7123107],
              [58.229136, 37.7259542],
              [58.2278568, 37.7290972],
              [58.2259349, 37.7307373],
              [58.2253059, 37.7332854],
              [58.2252248, 37.7358549],
              [58.2250647, 37.73651],
              [58.2245287, 37.7372095],
              [58.222782, 37.7380478],
              [58.2216857, 37.7382868],
              [58.2208933, 37.738322],
              [58.2203892, 37.7382056],
              [58.2185295, 37.7382969],
              [58.2180233, 37.7388362],
              [58.2176762, 37.7390763],
              [58.2174578, 37.739732],
              [58.2175846, 37.7405013],
              [58.2172079, 37.7410617],
              [58.2171484, 37.7417158],
              [58.2168727, 37.7422098],
              [58.2165408, 37.7422561],
              [58.2155008, 37.7429427],
              [58.2141264, 37.7443088],
              [58.2138359, 37.7449855],
              [58.2138196, 37.7454206],
              [58.2137023, 37.7460977],
              [58.2138848, 37.7474523],
              [58.213782, 37.7479806],
              [58.2135344, 37.7485419],
              [58.2134424, 37.7486465],
              [58.2135489, 37.7488685],
              [58.2136832, 37.7490091],
              [58.2139412, 37.7496936],
              [58.2141272, 37.7506989],
              [58.2142329, 37.7518717],
              [58.2144477, 37.7525567],
              [58.214514, 37.7542685],
              [58.2142151, 37.755121],
              [58.2137963, 37.7560626],
              [58.2131418, 37.7586943],
              [58.2114241, 37.7630877],
              [58.2092512, 37.7679521],
              [58.2082201, 37.7699545],
              [58.2067575, 37.7722182],
              [58.2058141, 37.7732485],
              [58.2037562, 37.7743015],
              [58.2003642, 37.7748003],
              [58.1986587, 37.7747839],
              [58.1971946, 37.7751795],
              [58.1960306, 37.7759597],
              [58.194572, 37.77718],
              [58.1934393, 37.7779282],
              [58.1917512, 37.7787858],
              [58.1894425, 37.7796247],
              [58.1877775, 37.7799795],
              [58.1865012, 37.7803664],
              [58.1838395, 37.7807019],
              [58.1817778, 37.7808825],
              [58.1793399, 37.7813734],
              [58.1742164, 37.7830378],
              [58.1729211, 37.7835284],
              [58.1716078, 37.784098],
              [58.1703605, 37.7847976],
              [58.1688601, 37.7859707],
              [58.1677903, 37.7865919],
              [58.1665234, 37.7870956],
              [58.1629431, 37.7878971],
              [58.1614857, 37.7887497],
              [58.1606023, 37.7894006],
              [58.1586479, 37.7906996],
              [58.1574463, 37.7916623],
              [58.1562246, 37.7924291],
              [58.1548174, 37.7928259],
              [58.1538069, 37.7927953],
              [58.1531945, 37.7925827],
              [58.1525622, 37.7921833],
              [58.1515962, 37.7911788],
              [58.1505258, 37.7896211],
              [58.1489389, 37.7889088],
              [58.1466756, 37.7874978],
              [58.1457407, 37.7867588],
              [58.144853, 37.7856183],
              [58.1439205, 37.7845233],
              [58.1429788, 37.7842553],
              [58.1417406, 37.7838167],
              [58.1410053, 37.7834498],
              [58.1392236, 37.7832011],
              [58.1374255, 37.783],
              [58.1358233, 37.7829298],
              [58.133678, 37.7827161],
              [58.1322639, 37.7826509],
              [58.1311355, 37.7826527],
              [58.1300314, 37.7827692],
              [58.1288481, 37.7827107],
              [58.1266956, 37.7823482],
              [58.1261575, 37.7827116],
              [58.1264461, 37.783351],
              [58.1264279, 37.783741],
              [58.1258614, 37.7856526],
              [58.1255504, 37.7864352],
              [58.1251409, 37.7880772],
              [58.1247421, 37.7888809],
              [58.1241327, 37.7898398],
              [58.1238162, 37.7907374],
              [58.1231091, 37.7919428],
              [58.1212676, 37.7945177],
              [58.1207581, 37.795514],
              [58.1200794, 37.7957931],
              [58.1188086, 37.7960643],
              [58.1174264, 37.7959197],
              [58.1143314, 37.7949778],
              [58.11204, 37.7941748],
              [58.110486, 37.7936915],
              [58.1089092, 37.7927736],
              [58.1066502, 37.7912807],
              [58.1054131, 37.7905217],
              [58.1039518, 37.7899157],
              [58.1027572, 37.7882483],
              [58.1017586, 37.7882531],
              [58.1012632, 37.7886408],
              [58.1005433, 37.7894902],
              [58.1001216, 37.7901566],
              [58.0998834, 37.7912291],
              [58.0990845, 37.7928341],
              [58.0983034, 37.7940626],
              [58.0981186, 37.7946209],
              [58.0965082, 37.7965578],
              [58.096481, 37.7983719],
              [58.0960844, 37.8006446],
              [58.0961936, 37.8014052],
              [58.0958326, 37.8020034],
              [58.0954427, 37.8019912],
              [58.0951775, 37.8017774],
              [58.0940262, 37.7998143],
              [58.0927934, 37.7983409],
              [58.0923451, 37.7980296],
              [58.0914576, 37.7978305],
              [58.0898047, 37.7979066],
              [58.0887057, 37.7978965],
              [58.0881826, 37.7979509],
              [58.0876112, 37.7981049],
              [58.086693, 37.7988592],
              [58.0863809, 37.7996529],
              [58.0861583, 37.8006915],
              [58.0850925, 37.8021298],
              [58.0842294, 37.8026312],
              [58.0817618, 37.8034177],
              [58.0804796, 37.8036098],
              [58.0796279, 37.8038699],
              [58.0789645, 37.8041374],
              [58.0775558, 37.8045671],
              [58.0763766, 37.8050128],
              [58.0747472, 37.8052056],
              [58.0726943, 37.805177],
              [58.0705289, 37.8047799],
              [58.0671313, 37.8038148],
              [58.0657649, 37.8033382],
              [58.0640952, 37.8025534],
              [58.0631754, 37.8024221],
              [58.0617067, 37.802584],
              [58.0605395, 37.8027793],
              [58.0589563, 37.8032239],
              [58.0558992, 37.8039115],
              [58.0528316, 37.8042206],
              [58.0505039, 37.8041851],
              [58.0493747, 37.8042087],
              [58.0473058, 37.804502],
              [58.0456923, 37.8046695],
              [58.0442716, 37.8047182],
              [58.0418042, 37.8042894],
              [58.0398484, 37.8040453],
              [58.0379999, 37.8039647],
              [58.0348506, 37.8041682],
              [58.0340061, 37.8042928],
              [58.0323023, 37.8048147],
              [58.0310885, 37.8050867],
              [58.0299629, 37.805626],
              [58.0293189, 37.8063887],
              [58.0288454, 37.807213],
              [58.0280163, 37.8091152],
              [58.0271559, 37.8107653],
              [58.0264694, 37.8114923],
              [58.0259291, 37.8119004],
              [58.0251567, 37.8123239],
              [58.0240112, 37.8126674],
              [58.0235771, 37.81289],
              [58.0233139, 37.8130249],
              [58.0227759, 37.8130904],
              [58.0202834, 37.8128642],
              [58.0175249, 37.8124464],
              [58.0167114, 37.8125143],
              [58.0161448, 37.8128752],
              [58.0151954, 37.8136495],
              [58.01382, 37.8142742],
              [58.0126475, 37.8148814],
              [58.0114641, 37.8151078],
              [58.0107845, 37.8151002],
              [58.0091454, 37.8151863],
              [58.0082166, 37.815548],
              [58.0077859, 37.815777],
              [58.0069183, 37.816359],
              [58.0041208, 37.8179489],
              [58.002942, 37.8189932],
              [58.0009546, 37.8196883],
              [58.000599, 37.8198625],
              [57.9981361, 37.8198947],
              [57.9959321, 37.8214929],
              [57.9946572, 37.8222111],
              [57.9937729, 37.8228856],
              [57.9916948, 37.8251495],
              [57.9908677, 37.8258572],
              [57.9902708, 37.8266824],
              [57.9893556, 37.8276545],
              [57.9886597, 37.8280884],
              [57.9877878, 37.8289565],
              [57.9861492, 37.8301193],
              [57.9842625, 37.8317417],
              [57.9837251, 37.8323478],
              [57.9832583, 37.8330344],
              [57.9827659, 37.83339],
              [57.9821435, 37.8336385],
              [57.9816625, 37.8343253],
              [57.9795352, 37.8351203],
              [57.977897, 37.8361141],
              [57.9774482, 37.8362846],
              [57.975811, 37.8372535],
              [57.9747097, 37.8377651],
              [57.9737534, 37.8383926],
              [57.973232, 37.8386087],
              [57.9720571, 37.8394656],
              [57.9698541, 37.8407411],
              [57.9691286, 37.8413126],
              [57.9676797, 37.8420298],
              [57.9662883, 37.842805],
              [57.9651295, 37.8433283],
              [57.9645491, 37.8437611],
              [57.9632924, 37.843803],
              [57.9626137, 37.843777],
              [57.9620083, 37.8436017],
              [57.9610127, 37.8434611],
              [57.9597149, 37.843181],
              [57.9584185, 37.8425787],
              [57.955897, 37.8416506],
              [57.9556528, 37.8413867],
              [57.955541, 37.8408694],
              [57.9538507, 37.8409439],
              [57.9528503, 37.8415356],
              [57.9526836, 37.8428213],
              [57.9525046, 37.8437037],
              [57.9524718, 37.8442988],
              [57.9511998, 37.8467493],
              [57.9509331, 37.8477249],
              [57.9509462, 37.8479659],
              [57.9507989, 37.8483884],
              [57.9504616, 37.8491797],
              [57.9501994, 37.8495581],
              [57.9500335, 37.8506928],
              [57.9497425, 37.8509904],
              [57.9493224, 37.851138],
              [57.9484565, 37.85103],
              [57.9463086, 37.8503916],
              [57.9459197, 37.8502055],
              [57.9430656, 37.8493338],
              [57.9425466, 37.8491375],
              [57.9415102, 37.8486388],
              [57.9397936, 37.8483348],
              [57.9389129, 37.8482855],
              [57.937323, 37.8484491],
              [57.9367154, 37.8485508],
              [57.9334441, 37.8496156],
              [57.932414, 37.850347],
              [57.9325622, 37.8519073],
              [57.9327182, 37.8523319],
              [57.9326294, 37.8526188],
              [57.9321632, 37.8532827],
              [57.9302847, 37.8533313],
              [57.9295495, 37.8531681],
              [57.9283834, 37.852578],
              [57.9265964, 37.8519859],
              [57.9256705, 37.8521419],
              [57.9251354, 37.8523016],
              [57.9244969, 37.8526536],
              [57.9236509, 37.853913],
              [57.9227906, 37.8550554],
              [57.92206, 37.85635],
              [57.9220565, 37.856866],
              [57.921753, 37.8589638],
              [57.9214741, 37.8596172],
              [57.9211916, 37.8608429],
              [57.920783, 37.8614612],
              [57.9204461, 37.8621376],
              [57.9198801, 37.8625025],
              [57.9194005, 37.8629591],
              [57.9182981, 37.8635626],
              [57.9167347, 37.8640592],
              [57.9155186, 37.8643774],
              [57.9140447, 37.8644722],
              [57.9134092, 37.8644478],
              [57.9112443, 37.8641627],
              [57.9101464, 37.8641013],
              [57.9092955, 37.8638916],
              [57.908124, 37.8640809],
              [57.9077774, 37.864034],
              [57.9073148, 37.8641457],
              [57.9066298, 37.8649576],
              [57.9063261, 37.8650478],
              [57.9048293, 37.8642054],
              [57.9031006, 37.8635089],
              [57.9013673, 37.8634208],
              [57.9007773, 37.8631076],
              [57.9003184, 37.8627055],
              [57.8998434, 37.8623824],
              [57.8988775, 37.8621239],
              [57.8984287, 37.8622603],
              [57.8981961, 37.8624198],
              [57.897946, 37.8630616],
              [57.897912, 37.8637716],
              [57.897763, 37.8644938],
              [57.8975697, 37.8651938],
              [57.8972468, 37.8659849],
              [57.8973586, 37.8664775],
              [57.897383, 37.8671442],
              [57.8972572, 37.8685422],
              [57.8969187, 37.8694596],
              [57.8967111, 37.870216],
              [57.8961713, 37.870878],
              [57.8955917, 37.8711393],
              [57.8952299, 37.8711848],
              [57.8946959, 37.871101],
              [57.8945701, 37.8705725],
              [57.8946015, 37.8702298],
              [57.8943153, 37.8698264],
              [57.8942488, 37.8690337],
              [57.8941215, 37.8686088],
              [57.8936359, 37.8678262],
              [57.8934518, 37.8672868],
              [57.8929205, 37.8668942],
              [57.8921714, 37.8665822],
              [57.8917385, 37.8665111],
              [57.8914908, 37.8667721],
              [57.8911001, 37.8688481],
              [57.8903408, 37.8699917],
              [57.890135, 37.8704281],
              [57.8895527, 37.8710566],
              [57.8889578, 37.8714554],
              [57.888392, 37.8717954],
              [57.887175, 37.8722372],
              [57.8863789, 37.8724528],
              [57.8854512, 37.872782],
              [57.8843082, 37.8730519],
              [57.883599, 37.8731744],
              [57.8823704, 37.8732377],
              [57.8808827, 37.8732083],
              [57.8791353, 37.8730862],
              [57.8781428, 37.8724492],
              [57.8768269, 37.8725806],
              [57.8763767, 37.872913],
              [57.8760985, 37.8734265],
              [57.8756202, 37.8735968],
              [57.8749978, 37.8737321],
              [57.8741886, 37.873808],
              [57.8726711, 37.8737787],
              [57.8716475, 37.8736353],
              [57.8697812, 37.8743459],
              [57.8678325, 37.8739043],
              [57.8658477, 37.8738046],
              [57.8629066, 37.8738189],
              [57.860994, 37.8741892],
              [57.8592552, 37.8739652],
              [57.8539917, 37.8720091],
              [57.8511433, 37.8723076],
              [57.8488963, 37.8703316],
              [57.830253, 37.8634927],
              [57.8254738, 37.8632465],
              [57.819142, 37.868518],
              [57.8102291, 37.8730303],
              [57.8065511, 37.8797415],
              [57.8045346, 37.8853088],
              [57.8060473, 37.8923401],
              [57.8009965, 37.8909821],
              [57.7971539, 37.893472],
              [57.7958352, 37.899553],
              [57.7891254, 37.8979745],
              [57.7859965, 37.9011983],
              [57.781413, 37.8982246],
              [57.7718544, 37.899318],
              [57.7646001, 37.8968444],
              [57.7596075, 37.8977141],
              [57.7541404, 37.8974949],
              [57.7504987, 37.902627],
              [57.745, 37.906667],
              [57.7436599, 37.9118129],
              [57.7383007, 37.9156219],
              [57.7331372, 37.9184216],
              [57.726944, 37.92],
              [57.7203676, 37.9218564],
              [57.7135944, 37.92246],
              [57.707525, 37.9217241],
              [57.70058, 37.9221383],
              [57.6949174, 37.9196836],
              [57.6938263, 37.9189108],
              [57.689698, 37.9159867],
              [57.6801062, 37.9178701],
              [57.6733903, 37.9189593],
              [57.6678759, 37.9220725],
              [57.6640192, 37.9244888],
              [57.6575406, 37.9234301],
              [57.6530633, 37.9256169],
              [57.643889, 37.923889],
              [57.6399427, 37.9245945],
              [57.6371816, 37.9228343],
              [57.6286443, 37.9222182],
              [57.622222, 37.923889],
              [57.6152936, 37.9266184],
              [57.607778, 37.927222],
              [57.6014463, 37.9291136],
              [57.5981779, 37.9320639],
              [57.5966337, 37.9328471],
              [57.5919896, 37.9328615],
              [57.5908736, 37.9334481],
              [57.5857355, 37.9362122],
              [57.5796241, 37.9380422],
              [57.5742482, 37.9375884],
              [57.5673183, 37.9357969],
              [57.5622414, 37.9334778],
              [57.5562652, 37.9319685],
              [57.5504361, 37.929432],
              [57.5429743, 37.9247811],
              [57.53406, 37.9265863],
              [57.5289782, 37.9245717],
              [57.52423, 37.9219859],
              [57.5220304, 37.9200284],
              [57.5121923, 37.919263],
              [57.5087742, 37.9205996],
              [57.5057939, 37.9251374],
              [57.4997377, 37.927688],
              [57.4987611, 37.9328253],
              [57.4938512, 37.9371132],
              [57.4879178, 37.9381628],
              [57.480556, 37.939167],
              [57.472778, 37.939167],
              [57.465833, 37.938611],
              [57.457778, 37.937778],
              [57.450278, 37.939167],
              [57.445556, 37.9425],
              [57.439722, 37.945],
              [57.435, 37.948333],
              [57.430278, 37.951389],
              [57.426389, 37.955278],
              [57.421667, 37.958333],
              [57.416944, 37.961667],
              [57.412222, 37.964722],
              [57.4075, 37.968056],
              [57.401667, 37.970556],
              [57.395, 37.9725],
              [57.386389, 37.973333],
              [57.378889, 37.974722],
              [57.375, 37.978611],
              [57.370278, 37.981667],
              [57.3625, 37.983056],
              [57.3588133, 37.9848987],
              [57.356944, 37.985833],
              [57.353056, 37.989444],
              [57.350278, 37.993889],
              [57.348333, 37.998889],
              [57.350278, 38.005],
              [57.351944, 38.010833],
              [57.353611, 38.016944],
              [57.356111, 38.022222],
              [57.358056, 38.028333],
              [57.359722, 38.034167],
              [57.361389, 38.040278],
              [57.363333, 38.046389],
              [57.365, 38.052222],
              [57.366944, 38.058333],
              [57.369444, 38.063611],
              [57.371111, 38.069722],
              [57.373056, 38.075556],
              [57.373889, 38.0825],
              [57.373056, 38.088056],
              [57.371111, 38.093056],
              [57.367222, 38.096667],
              [57.3625, 38.1],
              [57.357778, 38.103056],
              [57.353056, 38.106389],
              [57.349167, 38.11],
              [57.345556, 38.113889],
              [57.341667, 38.1175],
              [57.339722, 38.1225],
              [57.339722, 38.128889],
              [57.338056, 38.133889],
              [57.335, 38.138056],
              [57.332222, 38.1425],
              [57.328333, 38.146389],
              [57.324722, 38.15],
              [57.318889, 38.152778],
              [57.311389, 38.154167],
              [57.304444, 38.156111],
              [57.299722, 38.159167],
              [57.2963749, 38.1615295],
              [57.295, 38.1625],
              [57.292222, 38.166944],
              [57.288333, 38.170556],
              [57.2875, 38.176111],
              [57.288611, 38.183056],
              [57.288611, 38.189167],
              [57.288611, 38.195278],
              [57.286667, 38.200278],
              [57.284722, 38.205278],
              [57.281944, 38.209722],
              [57.28, 38.214722],
              [57.278333, 38.219722],
              [57.274444, 38.223333],
              [57.271667, 38.227778],
              [57.266667, 38.230833],
              [57.261944, 38.232778],
              [57.255278, 38.234722],
              [57.251389, 38.238611],
              [57.249444, 38.243611],
              [57.2475, 38.248611],
              [57.245556, 38.253333],
              [57.246667, 38.260278],
              [57.246667, 38.266389],
              [57.243889, 38.270833],
              [57.2420302, 38.2717653],
              [57.2318957, 38.2705747],
              [57.2228202, 38.2726488],
              [57.2185059, 38.2740329],
              [57.2164884, 38.2774018],
              [57.2127887, 38.2762933],
              [57.2030116, 38.2764888],
              [57.1916779, 38.276843],
              [57.1848766, 38.2763114],
              [57.161111, 38.272222],
              [57.156944, 38.268333],
              [57.152778, 38.264722],
              [57.149722, 38.26],
              [57.147222, 38.255],
              [57.1438512, 38.2501988],
              [57.1413292, 38.2449203],
              [57.1379823, 38.240459],
              [57.1346385, 38.236058],
              [57.1298342, 38.2330077],
              [57.1243492, 38.2307956],
              [57.1187133, 38.2285742],
              [57.1065063, 38.226018],
              [57.0954557, 38.219645],
              [57.0907536, 38.2160363],
              [57.086584, 38.2121113],
              [57.0832865, 38.2077109],
              [57.0801973, 38.2032576],
              [57.0761452, 38.1994725],
              [57.0704964, 38.1971982],
              [57.065, 38.195],
              [57.058611, 38.193611],
              [57.050833, 38.193611],
              [57.044167, 38.195556],
              [57.036389, 38.196944],
              [57.030556, 38.199444],
              [57.025, 38.201944],
              [57.0122329, 38.1871898],
              [57.0109915, 38.1897015],
              [57.0101597, 38.1898024],
              [57.0089296, 38.1889853],
              [57.0072842, 38.1888092],
              [57.0064349, 38.1888614],
              [57.0039172, 38.1904923],
              [57.0008947, 38.1959582],
              [56.9966494, 38.2035305],
              [56.9938588, 38.2096027],
              [56.9919985, 38.2143439],
              [56.985225, 38.2145313],
              [56.9766149, 38.2143626],
              [56.97, 38.214444],
              [56.9672894, 38.2111581],
              [56.9628532, 38.2111581],
              [56.9531699, 38.2133694],
              [56.9462771, 38.2143064],
              [56.9423894, 38.2141565],
              [56.9367846, 38.2146062],
              [56.934328, 38.2142877],
              [56.9309412, 38.2164427],
              [56.9248895, 38.2147897],
              [56.9189991, 38.2158124],
              [56.9098218, 38.2146874],
              [56.9017005, 38.2178293],
              [56.8972643, 38.2201341],
              [56.885983, 38.2191598],
              [56.8771821, 38.2225513],
              [56.8698123, 38.2250808],
              [56.8629264, 38.2285703],
              [56.8569383, 38.2297718],
              [56.8517964, 38.2309989],
              [56.8404712, 38.2298997],
              [56.8345157, 38.2340665],
              [56.8302851, 38.2378241],
              [56.8251757, 38.2398945],
              [56.8210101, 38.2412748],
              [56.8178859, 38.2436774],
              [56.8148594, 38.2455688],
              [56.8036584, 38.2475542],
              [56.7990346, 38.2516414],
              [56.7927133, 38.2516589],
              [56.78905, 38.2582015],
              [56.786111, 38.261111],
              [56.780556, 38.264444],
              [56.7744863, 38.2663745],
              [56.7717835, 38.2685491],
              [56.7668694, 38.269882],
              [56.7636975, 38.2729508],
              [56.7627594, 38.2760196],
              [56.7632954, 38.2788076],
              [56.7619999, 38.2800526],
              [56.7607937, 38.2834016],
              [56.7580686, 38.2837347],
              [56.756389, 38.285],
              [56.7539362, 38.2845939],
              [56.750833, 38.282778],
              [56.744444, 38.281111],
              [56.738889, 38.278889],
              [56.734167, 38.275833],
              [56.727778, 38.274444],
              [56.722222, 38.272222],
              [56.715833, 38.270556],
              [56.709722, 38.269167],
              [56.7025, 38.268333],
              [56.695278, 38.266944],
              [56.687778, 38.268333],
              [56.679167, 38.269167],
              [56.671111, 38.269167],
              [56.664167, 38.268333],
              [56.658611, 38.266111],
              [56.653056, 38.263889],
              [56.648056, 38.260833],
              [56.643333, 38.257778],
              [56.64, 38.253333],
              [56.636111, 38.249444],
              [56.631389, 38.246389],
              [56.625833, 38.244167],
              [56.620278, 38.241944],
              [56.613889, 38.240556],
              [56.605278, 38.241111],
              [56.5975, 38.2425],
              [56.591667, 38.245278],
              [56.586944, 38.248333],
              [56.582222, 38.251389],
              [56.578333, 38.255278],
              [56.5725, 38.257778],
              [56.566944, 38.260278],
              [56.561111, 38.262778],
              [56.554444, 38.264722],
              [56.546667, 38.266111],
              [56.538889, 38.266111],
              [56.5325, 38.264722],
              [56.525278, 38.263889],
              [56.518333, 38.263056],
              [56.511111, 38.2625],
              [56.504167, 38.261667],
              [56.495556, 38.2625],
              [56.486944, 38.263056],
              [56.478889, 38.263056],
              [56.4706157, 38.2634415],
              [56.4685938, 38.263082],
              [56.4665219, 38.2643014],
              [56.4653133, 38.2635348],
              [56.464167, 38.262222],
              [56.4629074, 38.2613272],
              [56.4611103, 38.2644891],
              [56.4606618, 38.2649861],
              [56.4598547, 38.2649674],
              [56.4585913, 38.2640249],
              [56.457492, 38.2641986],
              [56.4558539, 38.2649655],
              [56.4525193, 38.2646529],
              [56.4513827, 38.2634402],
              [56.4499849, 38.2619749],
              [56.4469283, 38.2614729],
              [56.442778, 38.26],
              [56.436389, 38.258611],
              [56.430833, 38.256389],
              [56.424444, 38.254722],
              [56.419722, 38.251667],
              [56.414167, 38.249444],
              [56.409444, 38.246389],
              [56.404722, 38.243333],
              [56.399722, 38.240556],
              [56.395, 38.2375],
              [56.390278, 38.234444],
              [56.385556, 38.231389],
              [56.381389, 38.2275],
              [56.376667, 38.224444],
              [56.371944, 38.221667],
              [56.367222, 38.218611],
              [56.363056, 38.214722],
              [56.358333, 38.211667],
              [56.354444, 38.208056],
              [56.349444, 38.205],
              [56.344722, 38.201944],
              [56.34, 38.198889],
              [56.3327792, 38.1975537],
              [56.3317439, 38.1955008],
              [56.330556, 38.192778],
              [56.326389, 38.189167],
              [56.3309536, 38.1857985],
              [56.3308832, 38.1857084],
              [56.3307836, 38.1856627],
              [56.3302975, 38.1855822],
              [56.3294815, 38.1849731],
              [56.3288768, 38.1841887],
              [56.3286538, 38.1839949],
              [56.3281606, 38.1838103],
              [56.327327, 38.1828689],
              [56.3269161, 38.182712],
              [56.3265521, 38.1823752],
              [56.3264288, 38.1823429],
              [56.3260472, 38.1823336],
              [56.3259239, 38.1822644],
              [56.3249025, 38.1807831],
              [56.3247205, 38.1805339],
              [56.3242743, 38.1803909],
              [56.3234231, 38.1798556],
              [56.3231648, 38.1797633],
              [56.3226658, 38.179791],
              [56.3220024, 38.1799386],
              [56.3210935, 38.1802171],
              [56.3206287, 38.1803263],
              [56.3201783, 38.1803082],
              [56.3188973, 38.1794865],
              [56.3185205, 38.1790722],
              [56.318919, 38.1783983],
              [56.3191186, 38.1774753],
              [56.319101, 38.176137],
              [56.3195109, 38.1755807],
              [56.3194868, 38.1746204],
              [56.3234677, 38.1685081],
              [56.3236376, 38.1652846],
              [56.3260871, 38.160598],
              [56.3280182, 38.1565067],
              [56.3298621, 38.1526001],
              [56.3289752, 38.1514465],
              [56.3282343, 38.15132],
              [56.3277445, 38.1514636],
              [56.327346, 38.1514342],
              [56.3269693, 38.1510574],
              [56.3267451, 38.1496602],
              [56.327248, 38.1479644],
              [56.3276216, 38.1473115],
              [56.3282188, 38.1468348],
              [56.3294268, 38.1468527],
              [56.3314534, 38.1472054],
              [56.3344893, 38.1438215],
              [56.3357709, 38.1428908],
              [56.3386982, 38.1417444],
              [56.3398048, 38.1414373],
              [56.3408204, 38.1414049],
              [56.3417304, 38.1415527],
              [56.3422528, 38.1417697],
              [56.3427225, 38.1424715],
              [56.3431921, 38.1428547],
              [56.3434328, 38.1429147],
              [56.3437651, 38.1428346],
              [56.3448675, 38.1371573],
              [56.3454077, 38.1351323],
              [56.3448175, 38.1314825],
              [56.3461469, 38.1293867],
              [56.3485512, 38.1286774],
              [56.3498118, 38.126605],
              [56.3509634, 38.1203805],
              [56.3511514, 38.119492],
              [56.3518911, 38.118088],
              [56.352079, 38.1171643],
              [56.351895, 38.1169157],
              [56.3509365, 38.116728],
              [56.3498308, 38.1166098],
              [56.3491058, 38.1163812],
              [56.3482722, 38.1160509],
              [56.3479843, 38.1157593],
              [56.3475826, 38.1153997],
              [56.3471944, 38.1151286],
              [56.3464908, 38.1148347],
              [56.346084, 38.1148428],
              [56.3453866, 38.1149326],
              [56.344976, 38.1148043],
              [56.3446379, 38.1144027],
              [56.3444013, 38.1137724],
              [56.3443099, 38.1127403],
              [56.3443431, 38.1122863],
              [56.3442103, 38.1120903],
              [56.343679, 38.1118944],
              [56.343015, 38.1115132],
              [56.3424423, 38.110791],
              [56.3419081, 38.1099041],
              [56.3416146, 38.109747],
              [56.3410921, 38.1097193],
              [56.3405818, 38.109636],
              [56.3400663, 38.1093909],
              [56.3396056, 38.108901],
              [56.339315, 38.108344],
              [56.3388558, 38.1063277],
              [56.3383134, 38.1060503],
              [56.3369485, 38.1049433],
              [56.3330377, 38.0992148],
              [56.3340032, 38.0911769],
              [56.335248, 38.0772496],
              [56.3344803, 38.0779115],
              [56.3270746, 38.0808261],
              [56.321063, 38.0810172],
              [56.3205693, 38.0795449],
              [56.3204774, 38.0788202],
              [56.3202132, 38.0777665],
              [56.3199255, 38.0769209],
              [56.3196573, 38.0767471],
              [56.3187421, 38.0758194],
              [56.318531, 38.0758118],
              [56.3183934, 38.075839],
              [56.3183108, 38.0758903],
              [56.318273, 38.0759665],
              [56.3183159, 38.0770281],
              [56.3181218, 38.0774602],
              [56.3173365, 38.0780299],
              [56.3165557, 38.0789911],
              [56.3149706, 38.0799569],
              [56.3138264, 38.0797704],
              [56.3119126, 38.0796041],
              [56.3105976, 38.0800662],
              [56.3100105, 38.0808055],
              [56.3085391, 38.0815863],
              [56.3066056, 38.0818222],
              [56.3052201, 38.0822103],
              [56.3027929, 38.0830573],
              [56.3021733, 38.0828203],
              [56.3009052, 38.0824506],
              [56.2997605, 38.0822611],
              [56.2974944, 38.0830605],
              [56.2968076, 38.0831021],
              [56.2959094, 38.0828711],
              [56.2950304, 38.0822677],
              [56.2948009, 38.082242],
              [56.2947193, 38.0823509],
              [56.2945725, 38.0830671],
              [56.2940031, 38.0834183],
              [56.2937095, 38.0835061],
              [56.2920482, 38.0840282],
              [56.2894725, 38.084991],
              [56.2889756, 38.0846583],
              [56.2892888, 38.0841197],
              [56.2899866, 38.0819364],
              [56.3070235, 38.0742522],
              [56.3073034, 38.0728594],
              [56.3196942, 38.0551205],
              [56.368446, 38.0213204],
              [56.369476, 38.0061728],
              [56.3681027, 37.9937279],
              [56.3608929, 37.9845281],
              [56.3595196, 37.9783041],
              [56.3593179, 37.944911],
              [56.3573248, 37.9395145],
              [56.3561864, 37.9369846],
              [56.3560805, 37.9361976],
              [56.3449732, 37.9221354],
              [56.33948, 37.9172148],
              [56.3357953, 37.9143766],
              [56.3236712, 37.9070818],
              [56.310484, 37.8898926],
              [56.3041025, 37.880633],
              [56.2935619, 37.8734377],
              [56.2801286, 37.8728814],
              [56.2680631, 37.8719782],
              [56.2669532, 37.8719782],
              [56.2641766, 37.8711423],
              [56.2622298, 37.8711423],
              [56.2472235, 37.8641571],
              [56.2405569, 37.8641572],
              [56.2350003, 37.8647055],
              [56.232233, 37.8635382],
              [56.2319754, 37.8603534],
              [56.2354086, 37.8523568],
              [56.2360953, 37.8352765],
              [56.2307738, 37.8251077],
              [56.2286911, 37.8159743],
              [56.2275811, 37.8143111],
              [56.2270245, 37.8126389],
              [56.2256343, 37.8098609],
              [56.2077598, 37.7975502],
              [56.2074832, 37.7964353],
              [56.2044115, 37.7901749],
              [56.1648238, 37.7453091],
              [56.1488826, 37.7258524],
              [56.1390224, 37.7095356],
              [56.1277911, 37.6891542],
              [56.1264046, 37.6822038],
              [56.1153212, 37.6640619],
              [56.114488, 37.6629471],
              [56.113378, 37.6596203],
              [56.1125446, 37.6582266],
              [56.1066947, 37.645894],
              [56.0972514, 37.6345112],
              [56.0739149, 37.6111783],
              [56.0705817, 37.6075637],
              [56.0697483, 37.6070152],
              [56.056745, 37.5757841],
              [56.0570249, 37.573563],
              [56.0465118, 37.5543064],
              [56.0467886, 37.549306],
              [56.0465118, 37.5484696],
              [56.0400951, 37.5140143],
              [56.0376547, 37.4887528],
              [56.0154596, 37.4756963],
              [56.0152367, 37.475363],
              [56.0144036, 37.4739691],
              [56.0127638, 37.4561918],
              [56.0100172, 37.4504684],
              [56.0125921, 37.4456985],
              [56.016197, 37.4405194],
              [56.0169982, 37.4317542],
              [56.0172698, 37.4233405],
              [56.0100181, 37.4036345],
              [56.0100181, 37.4025281],
              [55.9951197, 37.3661554],
              [55.9942863, 37.3658765],
              [55.983753, 37.3540575],
              [55.9692072, 37.3458583],
              [55.9499357, 37.339319],
              [55.9370611, 37.3389096],
              [55.9214795, 37.3344626],
              [55.9203695, 37.3344627],
              [55.9095953, 37.3316757],
              [55.898609, 37.3301743],
              [55.8865927, 37.3245777],
              [55.8788637, 37.3232431],
              [55.8692842, 37.3230584]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 229593,
        "tags": {
          "ISO3166-2": "IR-08",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "کرمان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q165352"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [54.3976017, 30.3429544],
              [54.4156262, 30.3287313],
              [54.433479, 30.3118387],
              [54.4530484, 30.2958324],
              [54.4755288, 30.2829881],
              [54.480686, 30.2787857],
              [54.4899557, 30.2764138],
              [54.4987105, 30.2778963],
              [54.5227429, 30.2679635],
              [54.5301245, 30.2587708],
              [54.5284079, 30.2458701],
              [54.5302962, 30.2377136],
              [54.5332989, 30.2346077],
              [54.5332145, 30.225663],
              [54.5315887, 30.2254789],
              [54.5307254, 30.2216952],
              [54.5313262, 30.2064161],
              [54.5314807, 30.1878518],
              [54.5323716, 30.1641326],
              [54.5332108, 30.1442119],
              [54.53326, 30.1233052],
              [54.5341349, 30.094792],
              [54.5346499, 30.0800877],
              [54.5368625, 30.0729961],
              [54.539659, 30.0623594],
              [54.5392073, 30.0555822],
              [54.5421922, 30.0414166],
              [54.5488953, 30.0142296],
              [54.5473784, 29.9997943],
              [54.5519335, 29.9720507],
              [54.5473765, 29.9431098],
              [54.5454883, 29.9246633],
              [54.5422453, 29.9109498],
              [54.5445019, 29.9087964],
              [54.5488793, 29.8954775],
              [54.5541783, 29.8834471],
              [54.5611952, 29.8656563],
              [54.5635985, 29.8538954],
              [54.5672034, 29.8461532],
              [54.5663079, 29.826573],
              [54.5680618, 29.8245241],
              [54.567071, 29.8189116],
              [54.5690822, 29.8032172],
              [54.5738886, 29.7671174],
              [54.5740878, 29.7617049],
              [54.5745778, 29.7508335],
              [54.5751645, 29.7385077],
              [54.577072, 29.7261426],
              [54.5789962, 29.7153165],
              [54.5814411, 29.7037414],
              [54.5856576, 29.6513378],
              [54.5882766, 29.6134398],
              [54.6056053, 29.6069479],
              [54.6339164, 29.595708],
              [54.6681402, 29.6052527],
              [54.7033308, 29.6127149],
              [54.719196, 29.6125524],
              [54.7208626, 29.6131683],
              [54.7350874, 29.6128698],
              [54.7518648, 29.6092421],
              [54.7773172, 29.6022072],
              [54.8046432, 29.5905904],
              [54.8308511, 29.5704318],
              [54.846073, 29.5540532],
              [54.8584626, 29.5399842],
              [54.8713788, 29.52631],
              [54.8854205, 29.5041587],
              [54.9043134, 29.4788513],
              [54.9178065, 29.4650212],
              [54.9290231, 29.4516123],
              [54.9748991, 29.3963843],
              [54.9794491, 29.3968289],
              [54.9856486, 29.3830906],
              [54.9879497, 29.3699764],
              [55.0000122, 29.35422],
              [55.0175101, 29.3079453],
              [55.0266016, 29.2713064],
              [55.0296555, 29.2498797],
              [55.0249168, 29.1888802],
              [55.024879, 29.1300821],
              [55.026461, 29.1047736],
              [55.0251775, 29.0828973],
              [55.0246809, 29.0722247],
              [55.031719, 29.039212],
              [55.034294, 29.0396623],
              [55.0353238, 29.0276178],
              [55.0701713, 29.0104298],
              [55.0808569, 29.0142582],
              [55.0847624, 29.0084408],
              [55.0850199, 29.0025106],
              [55.0917148, 29.0035615],
              [55.0942039, 29.0026607],
              [55.0959205, 28.999733],
              [55.1101683, 29.0058886],
              [55.1110267, 29.0044623],
              [55.1035594, 28.992451],
              [55.1056193, 28.9859193],
              [55.1102542, 28.983742],
              [55.119352, 28.9988324],
              [55.1307677, 28.9892228],
              [55.1641558, 28.9700013],
              [55.1649284, 28.9678987],
              [55.1637266, 28.9626421],
              [55.175743, 28.9594129],
              [55.184841, 28.962567],
              [55.1875877, 28.9609148],
              [55.1933383, 28.9541558],
              [55.196514, 28.954306],
              [55.2088737, 28.9394347],
              [55.2134227, 28.9391343],
              [55.2167701, 28.9438663],
              [55.2218341, 28.9430401],
              [55.2258679, 28.9410123],
              [55.2268123, 28.9371813],
              [55.2262114, 28.9348528],
              [55.1668164, 28.921857],
              [55.1758286, 28.9170488],
              [55.1953121, 28.9117145],
              [55.2121421, 28.9030492],
              [55.2006338, 28.8939814],
              [55.2241509, 28.8470801],
              [55.2493759, 28.8285316],
              [55.2576489, 28.8192325],
              [55.263167, 28.8116059],
              [55.2685743, 28.7992988],
              [55.269751, 28.7762127],
              [55.268696, 28.7510634],
              [55.298679, 28.7494706],
              [55.5011195, 28.7500734],
              [55.5173538, 28.7379407],
              [55.529941, 28.7287216],
              [55.5437848, 28.7200985],
              [55.5716628, 28.7044829],
              [55.5960687, 28.6923716],
              [55.6151585, 28.6860689],
              [55.6353645, 28.6809486],
              [55.6553341, 28.6716112],
              [55.6970633, 28.6630073],
              [55.7326123, 28.6592614],
              [55.7477185, 28.6601652],
              [55.802221, 28.6894585],
              [55.8035945, 28.6957828],
              [55.8081435, 28.7003753],
              [55.8159541, 28.7017305],
              [55.8218764, 28.6996978],
              [55.8352658, 28.7050432],
              [55.9165925, 28.7386404],
              [55.919592, 28.748515],
              [55.9394645, 28.7607371],
              [55.9556007, 28.7699915],
              [55.9639476, 28.7734311],
              [56.0022923, 28.787821],
              [56.0202477, 28.7907338],
              [56.0433048, 28.7889229],
              [56.048641, 28.7571255],
              [56.0617385, 28.7360685],
              [56.0603652, 28.7298187],
              [56.0598118, 28.7231511],
              [56.059532, 28.7209256],
              [56.0589786, 28.7139878],
              [56.0586985, 28.7092666],
              [56.058422, 28.7042569],
              [56.0660416, 28.6967598],
              [56.0657615, 28.6928674],
              [56.0654849, 28.6917591],
              [56.0654849, 28.6817578],
              [56.0652084, 28.6698105],
              [56.0623848, 28.6423097],
              [56.065478, 28.6101414],
              [56.0652012, 28.6095922],
              [56.065478, 28.6087548],
              [56.0606715, 28.5921201],
              [56.0603947, 28.591841],
              [56.0603948, 28.5876813],
              [56.0603948, 28.5874023],
              [56.0603948, 28.5871231],
              [56.0601146, 28.5865649],
              [56.0601147, 28.5860157],
              [56.0601146, 28.5840709],
              [56.0240933, 28.5809042],
              [55.9973141, 28.5643212],
              [55.9777447, 28.5679395],
              [55.9228131, 28.5582903],
              [55.9117025, 28.5368429],
              [55.9114258, 28.5346184],
              [55.9111459, 28.5321148],
              [55.9108692, 28.5310071],
              [55.9173199, 28.5193831],
              [55.9318118, 28.5109291],
              [55.9849545, 28.513953],
              [55.9932499, 28.509232],
              [55.9929732, 28.5084036],
              [55.9929732, 28.5053421],
              [55.99325, 28.5020194],
              [55.9935298, 28.501182],
              [55.9940832, 28.4914661],
              [55.9914033, 28.4481069],
              [55.9911267, 28.4439365],
              [55.9908468, 28.4428285],
              [56.0097627, 28.4011495],
              [56.0097627, 28.3922599],
              [56.0097628, 28.3903234],
              [56.0576979, 28.3888102],
              [56.057698, 28.3885401],
              [56.057558, 28.3882609],
              [56.0574179, 28.3879817],
              [56.0829838, 28.3361334],
              [56.0840938, 28.3330715],
              [56.084374, 28.3316846],
              [56.0849272, 28.3305769],
              [56.0941882, 28.3006694],
              [56.0943736, 28.3003012],
              [56.1522554, 28.2634671],
              [56.1579859, 28.2291909],
              [56.1582659, 28.2286327],
              [56.1582659, 28.2283536],
              [56.1585859, 28.2280978],
              [56.1624326, 28.225022],
              [56.1743757, 28.2172423],
              [56.235768, 28.1883575],
              [56.2399346, 28.1861335],
              [56.2574344, 28.1794707],
              [56.2704908, 28.1750228],
              [56.2931644, 28.1674043],
              [56.2935471, 28.1672527],
              [56.3197003, 28.1603238],
              [56.3249803, 28.1586583],
              [56.3272036, 28.1578299],
              [56.3280603, 28.1576865],
              [56.3288702, 28.1575509],
              [56.3294399, 28.1574376],
              [56.3763695, 28.1480976],
              [56.402971, 28.1419367],
              [56.4035276, 28.1422158],
              [56.4088043, 28.1422158],
              [56.4090808, 28.1424948],
              [56.4153075, 28.1358344],
              [56.4158641, 28.1358345],
              [56.4166974, 28.1358344],
              [56.4214207, 28.1358345],
              [56.4219773, 28.1361136],
              [56.4289207, 28.1361135],
              [56.4292733, 28.1359367],
              [56.4294772, 28.1358345],
              [56.4345487, 28.1306398],
              [56.4445487, 28.1306398],
              [56.445382, 28.1309189],
              [56.467605, 28.1320263],
              [56.4695516, 28.1317472],
              [56.4751048, 28.1317472],
              [56.4767715, 28.1320263],
              [56.4792715, 28.1320263],
              [56.4809381, 28.1323054],
              [56.4881612, 28.1323054],
              [56.489828, 28.1325846],
              [56.4942747, 28.1328546],
              [56.4989945, 28.1328547],
              [56.5006611, 28.1331338],
              [56.5051076, 28.1331338],
              [56.505941, 28.1334218],
              [56.5184409, 28.1342502],
              [56.5239975, 28.1353576],
              [56.5245508, 28.1353576],
              [56.5339973, 28.1370324],
              [56.5481637, 28.1389681],
              [56.5506637, 28.1389682],
              [56.551777, 28.1392473],
              [56.5617769, 28.1392473],
              [56.5628869, 28.1395264],
              [56.565667, 28.1395264],
              [56.5662201, 28.1398055],
              [56.57122, 28.1398054],
              [56.5717516, 28.1396274],
              [56.5720534, 28.1395264],
              [56.5724648, 28.1395264],
              [56.5748333, 28.1395264],
              [56.5755412, 28.1393484],
              [56.5759433, 28.1392472],
              [56.5761785, 28.1392472],
              [56.6214277, 28.1565834],
              [56.6266592, 28.1565834],
              [56.6269392, 28.1568534],
              [56.6831337, 28.2301446],
              [56.6842437, 28.231252],
              [56.6873004, 28.235421],
              [56.7012976, 28.2640194],
              [56.7109106, 28.2690087],
              [56.7743371, 28.2794017],
              [56.7784161, 28.2814666],
              [56.7807667, 28.2801686],
              [56.7925219, 28.274196],
              [56.7982542, 28.2717545],
              [56.8021203, 28.2698647],
              [56.8097154, 28.2655557],
              [56.8118786, 28.2646289],
              [56.8187706, 28.2621044],
              [56.8245136, 28.260721],
              [56.8287789, 28.2605698],
              [56.8348468, 28.2608344],
              [56.8408339, 28.260064],
              [56.8509879, 28.2590432],
              [56.8608333, 28.2589378],
              [56.8981506, 28.2643585],
              [56.9113761, 28.2653659],
              [56.9165727, 28.2651846],
              [56.9609211, 28.2781486],
              [56.9692542, 28.2781486],
              [56.9698153, 28.2779674],
              [56.9778641, 28.2753669],
              [56.9851683, 28.2696097],
              [56.9884205, 28.2548154],
              [56.989254, 28.2520427],
              [56.9903672, 28.2450933],
              [56.9906437, 28.2412046],
              [57.0112432, 28.19061],
              [57.015493, 28.1804887],
              [57.0152165, 28.1796602],
              [57.0118798, 28.1547005],
              [57.0124366, 28.148587],
              [57.0124365, 28.1483168],
              [57.0127131, 28.1474795],
              [57.0127131, 28.1408168],
              [57.0159996, 28.1286355],
              [57.0165564, 28.1055804],
              [57.0276058, 28.0464075],
              [57.0273291, 28.043075],
              [57.0270526, 28.0405711],
              [57.0264959, 28.0350142],
              [57.0262191, 28.0325103],
              [57.0259393, 28.0300154],
              [57.0256625, 28.0291779],
              [57.0256625, 28.0269533],
              [57.0256624, 28.0202886],
              [57.0253859, 28.0197302],
              [57.0222111, 27.9250553],
              [57.1442107, 27.9390861],
              [57.1742245, 27.9040247],
              [57.1862099, 27.8947272],
              [57.2216031, 27.8882464],
              [57.2329327, 27.9122163],
              [57.2446057, 27.9395173],
              [57.271111, 27.9814862],
              [57.2722209, 27.9806587],
              [57.2738875, 27.9801011],
              [57.2796908, 27.9723154],
              [57.2860806, 27.9709302],
              [57.286306, 27.9709021],
              [57.357961, 27.8932051],
              [57.3588814, 27.8930208],
              [57.3593543, 27.8929261],
              [57.3593729, 27.8929261],
              [57.4076668, 27.8254264],
              [57.41294, 27.8229249],
              [57.4134884, 27.8229249],
              [57.4140533, 27.8229249],
              [57.4143294, 27.8227402],
              [57.4148869, 27.8223671],
              [57.4157472, 27.8222343],
              [57.4185002, 27.8218092],
              [57.43922, 27.8130143],
              [57.4328698, 27.8057087],
              [57.43931, 27.8030586],
              [57.4747004, 27.7910374],
              [57.4665963, 27.7828675],
              [57.4510801, 27.7773089],
              [57.4302529, 27.7730101],
              [57.4170398, 27.7721904],
              [57.4013947, 27.7760793],
              [57.4004185, 27.7478263],
              [57.3919178, 27.7349036],
              [57.3560305, 27.7035217],
              [57.3409077, 27.6999443],
              [57.3213383, 27.70268],
              [57.2850804, 27.7148039],
              [57.2834247, 27.7158554],
              [57.2837229, 27.7085858],
              [57.2839161, 27.7024521],
              [57.2811283, 27.6969481],
              [57.2741651, 27.694163],
              [57.2749042, 27.6893424],
              [57.2760122, 27.6839315],
              [57.2814528, 27.6785314],
              [57.2831942, 27.6720788],
              [57.28328, 27.666732],
              [57.280097, 27.6621305],
              [57.2716856, 27.6596218],
              [57.2526311, 27.6573791],
              [57.2487635, 27.65822],
              [57.2442624, 27.6490925],
              [57.2404858, 27.6395124],
              [57.2349068, 27.6351022],
              [57.223663, 27.6322127],
              [57.2220322, 27.6201215],
              [57.2302418, 27.6016704],
              [57.2336196, 27.5945656],
              [57.237819, 27.5882338],
              [57.2497557, 27.5895452],
              [57.2554205, 27.5877195],
              [57.2803114, 27.5846765],
              [57.3046015, 27.5885563],
              [57.3082923, 27.5833071],
              [57.3175619, 27.5810249],
              [57.3275184, 27.5795794],
              [57.3353897, 27.5721441],
              [57.3400496, 27.5661889],
              [57.3438262, 27.540088],
              [57.333269, 27.4990597],
              [57.3282972, 27.4853745],
              [57.3317384, 27.462383],
              [57.3322785, 27.4360582],
              [57.3309684, 27.4193102],
              [57.3318088, 27.4101936],
              [57.3309801, 27.4060738],
              [57.3386764, 27.394098],
              [57.3462295, 27.3880013],
              [57.3621081, 27.3776363],
              [57.3922686, 27.349494],
              [57.4024434, 27.3420127],
              [57.4134204, 27.3286425],
              [57.4193717, 27.3208861],
              [57.4420162, 27.2898757],
              [57.4772505, 27.2672613],
              [57.4653622, 27.2479152],
              [57.4654287, 27.2295862],
              [57.4796104, 27.2100605],
              [57.4837435, 27.1920264],
              [57.4869442, 27.1785271],
              [57.490425, 27.1653208],
              [57.4918841, 27.1605098],
              [57.4926566, 27.1526438],
              [57.4929141, 27.1465339],
              [57.4948024, 27.1358408],
              [57.4952315, 27.1318688],
              [57.4967765, 27.1262161],
              [57.4992656, 27.1205631],
              [57.504501, 27.115674],
              [57.5111783, 27.1003336],
              [57.5153158, 27.0886261],
              [57.5378035, 27.0721192],
              [57.5582311, 27.0672278],
              [57.5693892, 27.0643234],
              [57.5798605, 27.0612661],
              [57.6070612, 27.0545364],
              [57.6271987, 27.0484421],
              [57.653275, 27.0447196],
              [57.6742685, 27.0392305],
              [57.6952125, 27.0233273],
              [57.7158199, 27.0086424],
              [57.7350361, 27.0004818],
              [57.7489197, 26.9866903],
              [57.7678296, 26.9710379],
              [57.8043826, 26.9547373],
              [57.8247564, 26.9455638],
              [57.8398415, 26.9388288],
              [57.8522735, 26.9342066],
              [57.8931723, 26.9224626],
              [57.9062772, 26.9242228],
              [57.9076635, 26.9239442],
              [57.9096104, 26.9239441],
              [57.9101735, 26.9237558],
              [57.9104437, 26.9236655],
              [57.9108088, 26.9236655],
              [57.9140571, 26.9236655],
              [57.9732968, 26.8849937],
              [57.9738499, 26.8847151],
              [57.9763499, 26.8819379],
              [58.0019097, 26.8585979],
              [58.0046828, 26.8569353],
              [58.005516, 26.8560995],
              [58.0280155, 26.8436076],
              [58.0327426, 26.8416575],
              [58.034129, 26.8408217],
              [58.0399622, 26.838602],
              [58.0444088, 26.8374875],
              [58.0445787, 26.8374876],
              [58.0457956, 26.8374876],
              [58.049962, 26.8372089],
              [58.0541285, 26.8372089],
              [58.0543194, 26.8370191],
              [58.0544086, 26.8369304],
              [58.0551448, 26.8369303],
              [58.055522, 26.8369303],
              [58.0562282, 26.8367405],
              [58.0627419, 26.8349893],
              [58.0694084, 26.8310979],
              [58.116354, 26.791378],
              [58.1202475, 26.78888],
              [58.1235807, 26.7858157],
              [58.1235807, 26.7855372],
              [58.1241342, 26.7855372],
              [58.1263542, 26.783039],
              [58.1369141, 26.7755447],
              [58.1385806, 26.7749877],
              [58.138937, 26.7749877],
              [58.1394139, 26.7749877],
              [58.1396008, 26.7747972],
              [58.1911465, 26.7546641],
              [58.1936466, 26.7543856],
              [58.1944799, 26.7543856],
              [58.1948591, 26.7541945],
              [58.1950329, 26.7541069],
              [58.1955799, 26.7541069],
              [58.1961462, 26.7541069],
              [58.1965258, 26.7539159],
              [58.1966997, 26.7538284],
              [58.1972464, 26.7538284],
              [58.197813, 26.7538283],
              [58.1981922, 26.7536373],
              [58.1983662, 26.7535497],
              [58.198913, 26.7535497],
              [58.1994795, 26.7535497],
              [58.2000512, 26.7533587],
              [58.200313, 26.7532712],
              [58.2006676, 26.7532712],
              [58.2014193, 26.7532711],
              [58.2018035, 26.75308],
              [58.2019795, 26.7529925],
              [58.2025214, 26.7529925],
              [58.2041995, 26.7529924],
              [58.2047709, 26.7528014],
              [58.2050327, 26.7527139],
              [58.2053872, 26.7527139],
              [58.2075328, 26.752714],
              [58.2081043, 26.7525229],
              [58.2083659, 26.7524353],
              [58.2087206, 26.7524353],
              [58.2094797, 26.7524352],
              [58.2100513, 26.7522442],
              [58.2103129, 26.7521567],
              [58.2106673, 26.7521567],
              [58.2122594, 26.7521568],
              [58.2128312, 26.7519656],
              [58.213093, 26.751878],
              [58.2134473, 26.751878],
              [58.2141992, 26.7518781],
              [58.2145837, 26.7516869],
              [58.2147595, 26.7515996],
              [58.2153012, 26.7515996],
              [58.2169794, 26.7515995],
              [58.224199, 26.7502155],
              [58.2248295, 26.7500809],
              [58.252812, 26.7441044],
              [58.252842, 26.7441044],
              [58.2536453, 26.7441043],
              [58.2540302, 26.7439129],
              [58.2542054, 26.7438258],
              [58.2547463, 26.7438258],
              [58.2555921, 26.7438258],
              [58.2603117, 26.74299],
              [58.286145, 26.7385505],
              [58.2865604, 26.7384466],
              [58.2872582, 26.738272],
              [58.2874179, 26.738272],
              [58.2892047, 26.738272],
              [58.2922579, 26.7377148],
              [58.2936514, 26.7377148],
              [58.2945503, 26.737523],
              [58.3067047, 26.7349289],
              [58.3067316, 26.7349289],
              [58.308091, 26.7349288],
              [58.308665, 26.734737],
              [58.3089243, 26.7346503],
              [58.3092759, 26.7346503],
              [58.3103181, 26.7346503],
              [58.3105061, 26.7344583],
              [58.310591, 26.7343716],
              [58.3113287, 26.7343716],
              [58.3122579, 26.7343716],
              [58.3129238, 26.7341797],
              [58.3247573, 26.7307681],
              [58.3269843, 26.7299323],
              [58.4591998, 26.6525887],
              [58.4861603, 26.688811],
              [58.486994, 26.6882538],
              [58.4969936, 26.6807506],
              [58.4978269, 26.6801935],
              [58.5001937, 26.6858879],
              [58.5138911, 26.6686058],
              [58.535193, 26.6417146],
              [58.5949285, 26.6094943],
              [58.6138147, 26.5947723],
              [58.6451978, 26.5586596],
              [58.6543643, 26.5544919],
              [58.690477, 26.5367166],
              [58.7929557, 26.445822],
              [58.7937571, 26.4456785],
              [58.796016, 26.4452739],
              [58.7961098, 26.4452267],
              [58.7965691, 26.4449955],
              [58.7971027, 26.4449954],
              [58.7971223, 26.4449954],
              [58.7976824, 26.4449954],
              [58.8032356, 26.4455435],
              [58.8054556, 26.4461005],
              [58.8065689, 26.4461005],
              [58.8552077, 26.484768],
              [58.8557608, 26.4850464],
              [58.8574273, 26.4850464],
              [58.8782605, 26.494216],
              [58.8793738, 26.4944855],
              [58.8902068, 26.5011584],
              [58.897987, 26.5086577],
              [58.9049266, 26.5128251],
              [58.9207667, 26.5147651],
              [58.9224331, 26.5150435],
              [58.9238198, 26.5150435],
              [58.9242096, 26.5148473],
              [58.924373, 26.5147651],
              [58.9247541, 26.5148412],
              [58.9257664, 26.5150435],
              [58.9274331, 26.5150435],
              [58.9278229, 26.5148473],
              [58.9279863, 26.514765],
              [58.9285188, 26.514765],
              [58.9310395, 26.514765],
              [58.9368728, 26.5142171],
              [58.937575, 26.5140415],
              [58.9390994, 26.5136603],
              [58.9392367, 26.5136603],
              [58.9404861, 26.5136604],
              [58.9411329, 26.5134641],
              [58.9560458, 26.508936],
              [58.9579856, 26.5081008],
              [58.9643791, 26.5064393],
              [58.9679857, 26.5050472],
              [58.9683987, 26.5050472],
              [58.968819, 26.5050472],
              [58.9693096, 26.5048506],
              [58.9715992, 26.5039335],
              [58.9815989, 26.5017151],
              [58.9816348, 26.5017151],
              [58.9835455, 26.5017151],
              [58.9849321, 26.5014367],
              [58.9868787, 26.5014367],
              [58.987748, 26.50124],
              [58.9954921, 26.4994877],
              [58.9955186, 26.4994936],
              [58.9979918, 26.5000445],
              [58.9990984, 26.5000445],
              [58.9996586, 26.5003229],
              [59.0003551, 26.5003229],
              [59.0021586, 26.5014366],
              [59.0077119, 26.5105975],
              [59.0077119, 26.5133817],
              [59.0074318, 26.5150434],
              [59.0071584, 26.5153218],
              [59.0077118, 26.5169923],
              [59.008265, 26.5172707],
              [59.008265, 26.5175491],
              [59.0085451, 26.5178276],
              [59.0090982, 26.5189323],
              [59.0093783, 26.5206029],
              [59.0090982, 26.5233782],
              [59.0063252, 26.5264319],
              [59.0060451, 26.5281025],
              [59.0135448, 26.5342191],
              [59.0277115, 26.5381081],
              [59.031878, 26.5400482],
              [59.0321581, 26.5405961],
              [59.0332713, 26.5411619],
              [59.0354913, 26.5436589],
              [59.0374382, 26.5475481],
              [59.0374382, 26.5506019],
              [59.0352112, 26.5608774],
              [59.0349382, 26.5611559],
              [59.0349382, 26.5614343],
              [59.0285447, 26.5664375],
              [59.0263248, 26.5680991],
              [59.0043787, 26.5853274],
              [59.002992, 26.5869892],
              [59.000492, 26.5942202],
              [58.9996588, 26.596439],
              [58.9990986, 26.6042091],
              [59.0010456, 26.6158779],
              [59.002432, 26.6186537],
              [59.0118786, 26.6306013],
              [59.0149318, 26.6367189],
              [59.0174318, 26.6514428],
              [59.0177119, 26.6561592],
              [59.0174318, 26.6597707],
              [59.0160451, 26.6625466],
              [59.0029922, 26.6747737],
              [58.9979922, 26.6853299],
              [58.9960457, 26.7114384],
              [58.9957657, 26.7142236],
              [58.9960457, 26.7147717],
              [58.9965988, 26.7231094],
              [58.9965988, 26.7303241],
              [58.9963259, 26.7342145],
              [58.9935458, 26.7489409],
              [58.9929926, 26.7506122],
              [58.9924324, 26.7514388],
              [58.9904926, 26.7583844],
              [58.9904926, 26.7586629],
              [58.9904926, 26.75922],
              [58.9902126, 26.7594986],
              [58.989968, 26.7595803],
              [58.9893793, 26.759777],
              [58.9890709, 26.7597771],
              [58.9885461, 26.7597771],
              [58.9881834, 26.7599556],
              [58.9874324, 26.7603252],
              [58.9872348, 26.7601284],
              [58.9871527, 26.7600466],
              [58.9865992, 26.7600466],
              [58.9865992, 26.7601284],
              [58.9865992, 26.7603251],
              [58.9851862, 26.7603252],
              [58.9846526, 26.7603252],
              [58.9844901, 26.760407],
              [58.9840992, 26.7606037],
              [58.9828843, 26.7606037],
              [58.9821526, 26.7606037],
              [58.9820724, 26.7606855],
              [58.9818796, 26.7608822],
              [58.9801064, 26.7608823],
              [58.9793796, 26.7608823],
              [58.9792973, 26.7609642],
              [58.9790995, 26.7611609],
              [58.9779666, 26.7611609],
              [58.9774327, 26.7611609],
              [58.9772702, 26.7612427],
              [58.9768795, 26.7614394],
              [58.9765753, 26.7614394],
              [58.9760463, 26.7614393],
              [58.9758815, 26.7615213],
              [58.9754861, 26.7617179],
              [58.9742731, 26.7617179],
              [58.9735462, 26.7617179],
              [58.9734638, 26.7617998],
              [58.9732662, 26.7619965],
              [58.9721753, 26.7619965],
              [58.9718794, 26.7619965],
              [58.9585465, 26.7661657],
              [58.957153, 26.7669923],
              [58.9560463, 26.7672709],
              [58.9057608, 26.7878299],
              [58.899374, 26.7911635],
              [58.886321, 26.8000505],
              [58.8629813, 26.8186696],
              [58.8613147, 26.8194963],
              [58.8602082, 26.8206106],
              [58.8535417, 26.8247712],
              [58.8510417, 26.8303338],
              [58.8507615, 26.8311605],
              [58.8502084, 26.8331105],
              [58.8504814, 26.8361659],
              [58.8502084, 26.846725],
              [58.8493752, 26.857554],
              [58.8502084, 26.8619934],
              [58.8643748, 26.9086636],
              [58.8765946, 26.933946],
              [58.897988, 26.9692244],
              [58.8988213, 26.9697817],
              [58.9118742, 26.9886666],
              [58.9129876, 26.9999296],
              [58.908541, 27.0053319],
              [58.9049277, 27.0072735],
              [58.8907615, 27.0189413],
              [58.8893747, 27.0203346],
              [58.8768749, 27.0372794],
              [58.8757616, 27.0394997],
              [58.8746484, 27.040893],
              [58.8713151, 27.0472756],
              [58.8702084, 27.048669],
              [58.8599286, 27.071449],
              [58.8593755, 27.0742269],
              [58.8552091, 27.0872804],
              [58.8504821, 27.096729],
              [58.8485422, 27.1017277],
              [58.8385359, 27.1339499],
              [58.8385358, 27.1342286],
              [58.8385358, 27.1344983],
              [58.8382624, 27.1351502],
              [58.8352026, 27.1508887],
              [58.8349292, 27.1545031],
              [58.8346491, 27.1572813],
              [58.8335358, 27.1642226],
              [58.8330053, 27.183222],
              [58.8310364, 27.2536735],
              [58.8318696, 27.2620006],
              [58.835483, 27.2920006],
              [58.8368694, 27.3017311],
              [58.854096, 27.3931258],
              [58.8624294, 27.426172],
              [58.8657628, 27.4372808],
              [58.8707629, 27.4620085],
              [58.8740962, 27.4756186],
              [58.8746493, 27.4767341],
              [58.8746493, 27.4770128],
              [58.8746493, 27.4772913],
              [58.8746492, 27.4781193],
              [58.8749294, 27.4786771],
              [58.8752095, 27.4797925],
              [58.8754825, 27.4811779],
              [58.8788229, 27.495346],
              [58.879096, 27.4972891],
              [58.8860426, 27.5145073],
              [58.8904892, 27.5328415],
              [58.8904892, 27.5336782],
              [58.8904892, 27.5339571],
              [58.8910427, 27.5347847],
              [58.8922721, 27.5383758],
              [58.8971558, 27.5542349],
              [58.8985424, 27.5589582],
              [58.9010426, 27.5764568],
              [58.9010426, 27.5945137],
              [58.9007625, 27.5986794],
              [58.9010426, 27.5995162],
              [58.9007626, 27.603124],
              [58.9010426, 27.6042397],
              [58.9002095, 27.6253475],
              [58.9019541, 27.6377946],
              [58.9024291, 27.6411833],
              [58.9029893, 27.6456281],
              [58.9057628, 27.6706244],
              [58.9057628, 27.6797935],
              [58.9050376, 27.7015338],
              [58.9050365, 27.7018484],
              [58.9052094, 27.7056278],
              [58.9049293, 27.7114589],
              [58.9049293, 27.7139605],
              [58.9038231, 27.7492361],
              [58.9032629, 27.759792],
              [58.9029895, 27.7617359],
              [58.9032629, 27.7689624],
              [58.9029896, 27.7847923],
              [58.9024295, 27.7953489],
              [58.9027095, 27.7975718],
              [58.9024294, 27.8003528],
              [58.9027096, 27.8025757],
              [58.9021564, 27.8189554],
              [58.900763, 27.8372976],
              [58.8988233, 27.848962],
              [58.8974299, 27.8545152],
              [58.8952099, 27.8675749],
              [58.8935435, 27.8756305],
              [58.8918767, 27.8811839],
              [58.8904901, 27.8981235],
              [58.8907634, 27.8989606],
              [58.9002412, 27.961406],
              [58.9025446, 27.9674952],
              [58.9047288, 27.9702735],
              [58.9097296, 27.9816713],
              [58.9140843, 27.99296],
              [58.9170634, 27.9987454],
              [58.9197468, 28.0014716],
              [58.9240764, 28.0075521],
              [58.9273857, 28.0180088],
              [58.9283298, 28.0216955],
              [58.9295566, 28.0314211],
              [58.9304873, 28.0378334],
              [58.9325627, 28.0456031],
              [58.9347672, 28.0540425],
              [58.936339, 28.0581839],
              [58.9390263, 28.0633086],
              [58.9422858, 28.0692869],
              [58.94428, 28.0740423],
              [58.9485012, 28.0780233],
              [58.9602105, 28.0917223],
              [58.9723105, 28.085223],
              [58.9796304, 28.0812005],
              [58.9823901, 28.0788858],
              [58.9895225, 28.0735847],
              [58.9998553, 28.0658079],
              [59.0027146, 28.0641416],
              [59.0100459, 28.0602271],
              [59.0212942, 28.0535882],
              [59.0658764, 28.0285756],
              [59.0872189, 28.0189542],
              [59.0940854, 28.0077396],
              [59.0930554, 27.9865195],
              [59.1098782, 27.9452799],
              [59.1572567, 27.9067553],
              [59.1946789, 27.9091824],
              [59.2434307, 27.9328443],
              [59.2454907, 27.9543783],
              [59.2732998, 27.973179],
              [59.3272015, 28.0141048],
              [59.332723, 28.0152965],
              [59.3556973, 28.0162264],
              [59.4363781, 28.0141048],
              [59.4725131, 28.0144834],
              [59.5123812, 28.0133091],
              [59.5487308, 28.0134225],
              [59.5813992, 28.0135536],
              [59.5748234, 28.0139435],
              [59.5677423, 28.0151653],
              [59.5637512, 28.0153548],
              [59.5523357, 28.0164914],
              [59.5457696, 28.0174385],
              [59.5504903, 28.0246745],
              [59.5519495, 28.03441],
              [59.5530653, 28.0412282],
              [59.5516491, 28.0451674],
              [59.5493316, 28.0447129],
              [59.5482158, 28.0420994],
              [59.5452976, 28.0417964],
              [59.5401477, 28.0427054],
              [59.5357724, 28.0442869],
              [59.5220382, 28.0550237],
              [59.4832945, 28.0859233],
              [59.4973983, 28.0982945],
              [59.506103, 28.1205522],
              [59.5139315, 28.1392267],
              [59.5227946, 28.1584981],
              [59.5650865, 28.2039522],
              [59.5779227, 28.2259113],
              [59.6050252, 28.2680902],
              [59.5964291, 28.2957708],
              [59.5310793, 28.3116972],
              [59.4783579, 28.287017],
              [59.4383044, 28.3081032],
              [59.4186717, 28.3197897],
              [59.415842, 28.3448278],
              [59.4433078, 28.3977557],
              [59.5559179, 28.3835777],
              [59.6371254, 28.3995574],
              [59.709973, 28.4390211],
              [59.7254961, 28.4868834],
              [59.6821137, 28.5189455],
              [59.5978032, 28.5717089],
              [59.585699, 28.5801563],
              [59.5644375, 28.5950731],
              [59.5314785, 28.6246107],
              [59.5153424, 28.667094],
              [59.511895, 28.6913351],
              [59.50801, 28.7109369],
              [59.5069348, 28.7237471],
              [59.5053182, 28.7448984],
              [59.4996122, 28.8001384],
              [59.4986104, 28.8403558],
              [59.4985021, 28.8706622],
              [59.4989987, 28.917061],
              [59.5005165, 28.9475915],
              [59.4969032, 28.96093],
              [59.5055168, 28.9998199],
              [59.5082965, 29.0042633],
              [59.5294099, 29.0328708],
              [59.5360763, 29.0425961],
              [59.5374631, 29.0450928],
              [59.5374632, 29.0453722],
              [59.5641293, 29.0692669],
              [59.5649625, 29.0709343],
              [59.5655227, 29.0714842],
              [59.5655226, 29.0720431],
              [59.5660759, 29.0723224],
              [59.5707959, 29.0820391],
              [59.5694091, 29.0884298],
              [59.5694091, 29.0906562],
              [59.5696892, 29.0909266],
              [59.5694092, 29.0923238],
              [59.5527429, 29.1206545],
              [59.5513496, 29.1234308],
              [59.5282968, 29.1609301],
              [59.5136732, 29.1929828],
              [59.5107971, 29.2031544],
              [59.5094036, 29.2070489],
              [59.5088505, 29.2092665],
              [59.4944042, 29.2445422],
              [59.4919043, 29.2534401],
              [59.4846842, 29.2762129],
              [59.4838511, 29.2801076],
              [59.4807979, 29.2981567],
              [59.4741245, 29.3284315],
              [59.4735714, 29.3295495],
              [59.469958, 29.3539918],
              [59.4669049, 29.3631612],
              [59.4655181, 29.3673267],
              [59.464685, 29.3706626],
              [59.4635717, 29.3742691],
              [59.462185, 29.3978831],
              [59.461905, 29.4006601],
              [59.4624584, 29.4048257],
              [59.4627386, 29.4142661],
              [59.4632917, 29.4181612],
              [59.4632917, 29.4337151],
              [59.461905, 29.4387194],
              [59.4616249, 29.4392693],
              [59.4616249, 29.4395489],
              [59.4616249, 29.4398284],
              [59.4607917, 29.4412169],
              [59.4607917, 29.4420465],
              [59.4596851, 29.4437146],
              [59.4574585, 29.461496],
              [59.4580187, 29.4662209],
              [59.4580187, 29.4717754],
              [59.4580187, 29.4720459],
              [59.4577387, 29.4801072],
              [59.4552386, 29.5042734],
              [59.4560724, 29.5728883],
              [59.4563521, 29.5745476],
              [59.4560724, 29.5773341],
              [59.4563521, 29.5789934],
              [59.4560725, 29.5881647],
              [59.4557924, 29.5917809],
              [59.4519057, 29.6109443],
              [59.4519057, 29.6114945],
              [59.4499592, 29.6214957],
              [59.4499592, 29.6239937],
              [59.449126, 29.6295489],
              [59.4488525, 29.6390003],
              [59.4480194, 29.6506611],
              [59.4477394, 29.6723327],
              [59.4474593, 29.6745513],
              [59.4477394, 29.6937251],
              [59.4474593, 29.6990011],
              [59.4485727, 29.7117809],
              [59.4488528, 29.7273296],
              [59.4485727, 29.7295574],
              [59.4488528, 29.7303872],
              [59.4485728, 29.7353927],
              [59.4466263, 29.7456656],
              [59.4466262, 29.7470545],
              [59.4460728, 29.7503916],
              [59.4449594, 29.7548381],
              [59.4388466, 29.8148358],
              [59.4335736, 29.8717785],
              [59.4335736, 29.8723377],
              [59.4330135, 29.8887273],
              [59.43246, 29.9020593],
              [59.4321799, 29.9078955],
              [59.4327401, 29.9103941],
              [59.4341269, 29.9192883],
              [59.434407, 29.9206684],
              [59.43468, 29.9231671],
              [59.4349601, 29.9256748],
              [59.4352403, 29.9290033],
              [59.4355133, 29.9312224],
              [59.4399602, 29.95123],
              [59.4402404, 29.9528989],
              [59.4405134, 29.9545587],
              [59.4405134, 29.9548383],
              [59.4432935, 29.9684506],
              [59.446907, 29.9809535],
              [59.447187, 29.9826134],
              [59.4474601, 29.9837319],
              [59.4477402, 29.9851121],
              [59.4480202, 29.9865013],
              [59.4482934, 29.9881703],
              [59.4488535, 29.9909486],
              [59.449127, 29.9926175],
              [59.4494066, 29.9934475],
              [59.4474601, 30.0000509],
              [59.4449602, 30.0176148],
              [59.441627, 30.0351159],
              [59.4407937, 30.0370645],
              [59.4385738, 30.0520669],
              [59.4382937, 30.0545659],
              [59.4357937, 30.0692797],
              [59.4352405, 30.0709488],
              [59.4344074, 30.0990059],
              [59.4338473, 30.1045631],
              [59.4321805, 30.1187273],
              [59.4319074, 30.120676],
              [59.4319075, 30.1234548],
              [59.4316274, 30.1287325],
              [59.4313473, 30.1301218],
              [59.4316273, 30.1312315],
              [59.4313473, 30.1348403],
              [59.4305141, 30.1381784],
              [59.4296809, 30.1445659],
              [59.4294074, 30.1456756],
              [59.4296809, 30.1515038],
              [59.4291275, 30.1787324],
              [59.4285743, 30.1845698],
              [59.4263478, 30.1926266],
              [59.4263478, 30.1934567],
              [59.4260744, 30.1937364],
              [59.4260744, 30.1945665],
              [59.4257943, 30.2090112],
              [59.4257943, 30.2115104],
              [59.4260745, 30.2348424],
              [59.4249612, 30.2526259],
              [59.426348, 30.2595734],
              [59.4269078, 30.2631824],
              [59.4271812, 30.2654019],
              [59.4277414, 30.2704005],
              [59.4280145, 30.2728999],
              [59.4288476, 30.2809572],
              [59.4291277, 30.2826264],
              [59.4307946, 30.2917936],
              [59.4313477, 30.2954027],
              [59.432181, 30.299842],
              [59.4349611, 30.3131779],
              [59.4352413, 30.3148471],
              [59.4357944, 30.3181767],
              [59.4360745, 30.320676],
              [59.4363479, 30.3242942],
              [59.4385746, 30.3359611],
              [59.4388479, 30.337901],
              [59.4391277, 30.3426292],
              [59.4394079, 30.345679],
              [59.4410747, 30.3579055],
              [59.4413477, 30.3595657],
              [59.4416278, 30.3620742],
              [59.4419079, 30.3648443],
              [59.4421814, 30.3687334],
              [59.4432946, 30.3745715],
              [59.444408, 30.3773417],
              [59.4452412, 30.3806803],
              [59.4460745, 30.3826203],
              [59.4460745, 30.3834595],
              [59.4530212, 30.4179021],
              [59.4530211, 30.4226305],
              [59.4532946, 30.4234606],
              [59.4535747, 30.4270701],
              [59.4538547, 30.4298494],
              [59.4594081, 30.4540149],
              [59.4596878, 30.4551248],
              [59.4602413, 30.4590141],
              [59.4602413, 30.460124],
              [59.4663547, 30.4826205],
              [59.4666278, 30.4834598],
              [59.467188, 30.4851292],
              [59.4680212, 30.4898487],
              [59.4680213, 30.4987374],
              [59.4682947, 30.4995767],
              [59.4830583, 30.5275894],
              [59.468116, 30.5427928],
              [59.4582706, 30.5535857],
              [59.4348258, 30.5827064],
              [59.4165464, 30.6010153],
              [59.4029492, 30.6145196],
              [59.3818185, 30.6373168],
              [59.3697661, 30.6489304],
              [59.3536918, 30.6646169],
              [59.3141562, 30.7069197],
              [59.3094605, 30.7118515],
              [59.3036492, 30.7214042],
              [59.2981334, 30.7303009],
              [59.2903345, 30.7481443],
              [59.2819522, 30.763829],
              [59.2742169, 30.7778027],
              [59.2678069, 30.7885207],
              [59.263448, 30.7938734],
              [59.2412655, 30.8108148],
              [59.2329541, 30.8176491],
              [59.1885723, 30.8645116],
              [59.1608189, 30.8911404],
              [59.1434672, 30.90644],
              [59.0834423, 30.95818],
              [59.0439602, 30.9855566],
              [59.0195843, 31.0182216],
              [58.964309, 31.0570522],
              [58.8719555, 31.1287874],
              [58.8389965, 31.1517078],
              [58.8015744, 31.1743289],
              [58.7796014, 31.1857846],
              [58.7708471, 31.1903365],
              [58.7449261, 31.1943015],
              [58.7239834, 31.2081036],
              [58.6920544, 31.226014],
              [58.6661335, 31.2475901],
              [58.6391827, 31.2808985],
              [58.6053895, 31.3194036],
              [58.5880535, 31.3353187],
              [58.5737405, 31.3367174],
              [58.573467, 31.3369975],
              [58.4527574, 31.4063972],
              [58.3834395, 31.4728265],
              [58.3764929, 31.4778278],
              [58.3734397, 31.4800577],
              [58.3353417, 31.5352382],
              [58.3090669, 31.54981],
              [58.3043401, 31.553141],
              [58.2804538, 31.5687031],
              [58.2793405, 31.5689739],
              [58.2288615, 31.5915793],
              [58.2238615, 31.5943506],
              [58.1415761, 31.6259887],
              [58.1385158, 31.627659],
              [58.0723572, 31.6521082],
              [58.0712434, 31.6529389],
              [58.0212781, 31.6688824],
              [57.9937359, 31.6761744],
              [57.959747, 31.6782196],
              [57.9205686, 31.6928896],
              [57.9200156, 31.6931694],
              [57.8005542, 31.7363406],
              [57.7720245, 31.7432724],
              [57.7706312, 31.7438322],
              [57.7578321, 31.7006882],
              [57.7506402, 31.7005402],
              [57.7458216, 31.707815],
              [57.7378368, 31.720644],
              [57.7260756, 31.7388418],
              [57.6941118, 31.7543683],
              [57.6808293, 31.7597914],
              [57.6590665, 31.7681263],
              [57.6227433, 31.7815856],
              [57.5965006, 31.7857487],
              [57.5865273, 31.7897211],
              [57.5546011, 31.7947542],
              [57.5454345, 31.7969758],
              [57.5295636, 31.7988079],
              [57.5231893, 31.7982451],
              [57.5031277, 31.7964736],
              [57.4866482, 31.8058106],
              [57.4359985, 31.8175948],
              [57.3874964, 31.8306892],
              [57.3555895, 31.8394364],
              [57.3300447, 31.8464389],
              [57.254562, 31.867645],
              [57.2380825, 31.8746425],
              [57.1521367, 31.9016862],
              [57.1129371, 31.9127206],
              [57.0756343, 31.9245975],
              [57.0599447, 31.9269099],
              [57.0350552, 31.9346053],
              [57.0168021, 31.9360011],
              [57.0059688, 31.9384932],
              [56.9742794, 31.9410983],
              [56.9339453, 31.9489167],
              [56.8968802, 31.9543386],
              [56.8724277, 31.9569589],
              [56.8632976, 31.9552316],
              [56.8482444, 31.9546717],
              [56.8336015, 31.9528808],
              [56.8146451, 31.9514446],
              [56.7744887, 31.9481468],
              [56.7225426, 31.9439345],
              [56.67484, 31.9390533],
              [56.6728968, 31.9390534],
              [56.6698401, 31.9384935],
              [56.6501171, 31.9354418],
              [56.6374646, 31.9327657],
              [56.6280467, 31.9304423],
              [56.6228941, 31.9293726],
              [56.6097769, 31.92725],
              [56.6023487, 31.92502],
              [56.5994972, 31.9161222],
              [56.5957012, 31.905348],
              [56.5923063, 31.8956445],
              [56.5888899, 31.8784443],
              [56.5877932, 31.868941],
              [56.5874115, 31.8626855],
              [56.5841499, 31.8589685],
              [56.5834884, 31.8501584],
              [56.5808908, 31.8409051],
              [56.5788976, 31.8317329],
              [56.57735, 31.8214695],
              [56.5758717, 31.8088323],
              [56.5765857, 31.7981511],
              [56.5747233, 31.7912321],
              [56.5746875, 31.7799519],
              [56.5739791, 31.7628022],
              [56.5734863, 31.7479931],
              [56.5776696, 31.7418341],
              [56.5770579, 31.7376558],
              [56.5767813, 31.7373849],
              [56.5767812, 31.737105],
              [56.5767812, 31.7326539],
              [56.5745257, 31.7145876],
              [56.5697538, 31.6977379],
              [56.5625667, 31.6946365],
              [56.5092944, 31.6716453],
              [56.4352572, 31.651652],
              [56.4174349, 31.6449523],
              [56.4070477, 31.6407776],
              [56.3936885, 31.6368209],
              [56.3520302, 31.6229366],
              [56.3103174, 31.6081753],
              [56.2830354, 31.5980256],
              [56.2688126, 31.5921038],
              [56.2611479, 31.574361],
              [56.2581244, 31.5685967],
              [56.2548249, 31.5671193],
              [56.2488428, 31.559294],
              [56.2323858, 31.5596597],
              [56.2236759, 31.5590635],
              [56.1786707, 31.5483183],
              [56.1784286, 31.5483171],
              [56.1605022, 31.5526083],
              [56.1510771, 31.5601186],
              [56.1469394, 31.566504],
              [56.14341, 31.5719498],
              [56.1393405, 31.5806838],
              [56.1342837, 31.5851004],
              [56.1289493, 31.5878262],
              [56.1251592, 31.5897145],
              [56.1218783, 31.5905063],
              [56.1211953, 31.5906712],
              [56.115575, 31.5908616],
              [56.1137004, 31.590709],
              [56.1123872, 31.5907155],
              [56.1110169, 31.5900845],
              [56.1078044, 31.5886051],
              [56.0995661, 31.5867636],
              [56.0934911, 31.5873453],
              [56.0875442, 31.5856679],
              [56.0628098, 31.5786875],
              [56.059222, 31.5765428],
              [56.0581481, 31.5765429],
              [56.0567583, 31.5762721],
              [56.0537016, 31.576272],
              [56.053425, 31.5759921],
              [56.0525915, 31.5759921],
              [56.0489782, 31.5751525],
              [56.0420352, 31.5734913],
              [56.0350885, 31.5704307],
              [56.0292551, 31.5648783],
              [56.0289786, 31.5640478],
              [56.0259219, 31.5593169],
              [56.0239785, 31.5543243],
              [56.0223119, 31.5448808],
              [56.0220352, 31.5429306],
              [56.0217552, 31.5409896],
              [56.0214787, 31.5384888],
              [56.0212021, 31.5357171],
              [56.0209219, 31.5259847],
              [56.0206452, 31.5218228],
              [56.0200885, 31.5090389],
              [56.0198119, 31.5084883],
              [56.0200885, 31.506818],
              [56.0206451, 31.4954336],
              [56.0203686, 31.4926529],
              [56.0200885, 31.490432],
              [56.0198119, 31.4876514],
              [56.0195353, 31.4868207],
              [56.0195354, 31.4854305],
              [56.0181454, 31.4773774],
              [56.0178685, 31.4759872],
              [56.0128652, 31.4648737],
              [55.9964755, 31.4484878],
              [55.9670326, 31.4329328],
              [55.9656427, 31.4315425],
              [55.9639761, 31.4307118],
              [55.9592527, 31.4248709],
              [55.9564761, 31.4195986],
              [55.9556427, 31.4176575],
              [55.9556427, 31.416818],
              [55.9461962, 31.395431],
              [55.9450862, 31.39182],
              [55.9450862, 31.3907095],
              [55.9435367, 31.3874806],
              [55.9384197, 31.3768158],
              [55.9348064, 31.3732047],
              [55.9267531, 31.3673728],
              [55.8456376, 31.3251505],
              [55.8436909, 31.3245998],
              [55.8342477, 31.3209888],
              [55.8298045, 31.318759],
              [55.8231345, 31.3148681],
              [55.8203577, 31.3132071],
              [55.7728552, 31.2912612],
              [55.7659121, 31.2884807],
              [55.7656319, 31.28793],
              [55.7597987, 31.2848698],
              [55.7595221, 31.2845989],
              [55.7589654, 31.2840393],
              [55.7564654, 31.2829289],
              [55.7556321, 31.282649],
              [55.7550788, 31.2823692],
              [55.7400756, 31.2745965],
              [55.7195192, 31.2673747],
              [55.7181326, 31.2665441],
              [55.6847964, 31.2559821],
              [55.6781298, 31.2545919],
              [55.6711832, 31.2537614],
              [55.6686832, 31.2537614],
              [55.6489601, 31.2507102],
              [55.6364604, 31.2498707],
              [55.6070141, 31.245709],
              [55.6009042, 31.2437592],
              [55.5811812, 31.2318161],
              [55.5811811, 31.2315362],
              [55.5803478, 31.2309766],
              [55.5056222, 31.190986],
              [55.5000655, 31.1884855],
              [55.494789, 31.185976],
              [55.4925657, 31.1854254],
              [55.4917323, 31.1848657],
              [55.4886758, 31.1840352],
              [55.4878424, 31.1834846],
              [55.4850659, 31.1829248],
              [55.4606195, 31.1759831],
              [55.4600628, 31.1754233],
              [55.4595095, 31.1754234],
              [55.4431198, 31.1684815],
              [55.4247832, 31.1618105],
              [55.4195067, 31.1601496],
              [55.399507, 31.1518177],
              [55.3767273, 31.1445961],
              [55.3661709, 31.1420956],
              [55.326168, 31.1295933],
              [55.325058, 31.1295934],
              [55.3150581, 31.1270929],
              [55.3128348, 31.1262534],
              [55.2892217, 31.1179215],
              [55.2881119, 31.1179216],
              [55.2878352, 31.1176418],
              [55.2778319, 31.1151413],
              [55.2769986, 31.1148705],
              [55.2764454, 31.1145907],
              [55.2761653, 31.1143109],
              [55.2753319, 31.1143108],
              [55.2751511, 31.1141279],
              [55.2750554, 31.114031],
              [55.2708887, 31.1126499],
              [55.2694988, 31.1126499],
              [55.2692599, 31.1125291],
              [55.2689456, 31.11237],
              [55.2678321, 31.1123701],
              [55.2675555, 31.1120903],
              [55.2669987, 31.1120903],
              [55.2667221, 31.1118104],
              [55.2656121, 31.1112597],
              [55.2647789, 31.1107001],
              [55.2642221, 31.1104203],
              [55.2639455, 31.1101495],
              [55.2594988, 31.1081997],
              [55.2106096, 31.0912565],
              [55.1889399, 31.0851453],
              [55.1847733, 31.0843148],
              [55.1336606, 31.0723635],
              [55.1089377, 31.0701429],
              [55.1019911, 31.0693124],
              [55.0978245, 31.068473],
              [55.0767149, 31.0657017],
              [55.0678249, 31.0640319],
              [55.057545, 31.062371],
              [55.0556018, 31.0620912],
              [55.0544919, 31.0618113],
              [55.0425452, 31.0598706],
              [55.0406021, 31.0598706],
              [55.0397686, 31.0595908],
              [55.0386553, 31.0595908],
              [55.0217122, 31.05626],
              [54.9653196, 31.034867],
              [54.9650431, 31.0345871],
              [54.9564298, 31.0306967],
              [54.9514298, 31.0295864],
              [54.9492066, 31.0295865],
              [54.9489366, 31.0293134],
              [54.9489299, 31.0293066],
              [54.9480966, 31.0290358],
              [54.9475399, 31.028756],
              [54.9464299, 31.0281963],
              [54.9433733, 31.0276458],
              [54.9397634, 31.0276457],
              [54.93865, 31.027366],
              [54.9350401, 31.0270952],
              [54.9271744, 31.0270951],
              [54.9267069, 31.0270951],
              [54.9263823, 31.0272006],
              [54.9258736, 31.0273659],
              [54.9247636, 31.0273659],
              [54.9153171, 31.0284762],
              [54.8865356, 31.0333187],
              [54.8855942, 31.0334769],
              [54.8379752, 31.0426171],
              [54.8378149, 31.0426479],
              [54.8055886, 31.0479285],
              [54.7939631, 31.0495452],
              [54.7936455, 31.0495894],
              [54.7844789, 31.0512593],
              [54.7191134, 31.0655382],
              [54.7183632, 31.0657019],
              [54.7163531, 31.065702],
              [54.7158632, 31.065702],
              [54.7155171, 31.0658182],
              [54.7150299, 31.0659818],
              [54.7116966, 31.0659818],
              [54.7111399, 31.0657019],
              [54.70892, 31.0657019],
              [54.6969735, 31.0623712],
              [54.6894736, 31.0595909],
              [54.684197, 31.057921],
              [54.6819737, 31.0570905],
              [54.6803071, 31.0568107],
              [54.6683606, 31.0532001],
              [54.6664173, 31.0529203],
              [54.655304, 31.0504199],
              [54.6539175, 31.0504199],
              [54.6530841, 31.05014],
              [54.6450276, 31.0490298],
              [54.6430842, 31.0484791],
              [54.6414176, 31.0484792],
              [54.6405842, 31.0481993],
              [54.6128047, 31.0429187],
              [54.5805784, 31.0312565],
              [54.5772452, 31.0301462],
              [54.5577978, 31.0245661],
              [54.5388087, 31.0206682],
              [54.5337229, 31.019933],
              [54.5267527, 31.0183671],
              [54.5268631, 31.014286],
              [54.5274639, 31.0101665],
              [54.5274639, 31.0079228],
              [54.5270813, 31.0049979],
              [54.5266284, 31.0003865],
              [54.5272733, 30.9954896],
              [54.5270384, 30.9888376],
              [54.5278908, 30.9760685],
              [54.5277, 30.9598502],
              [54.5286324, 30.9415345],
              [54.5306041, 30.9325736],
              [54.535319, 30.9186348],
              [54.5406921, 30.8965921],
              [54.5407257, 30.8837669],
              [54.5366477, 30.8694464],
              [54.539051, 30.8518373],
              [54.5439122, 30.8312557],
              [54.5439122, 30.8290264],
              [54.5445441, 30.8046671],
              [54.5468356, 30.7964279],
              [54.5478915, 30.7852763],
              [54.5507239, 30.768463],
              [54.5526413, 30.7308434],
              [54.5534705, 30.7129137],
              [54.5529555, 30.7027299],
              [54.5546722, 30.6915117],
              [54.5573329, 30.6828757],
              [54.5581107, 30.6818697],
              [54.557805, 30.680772],
              [54.5592212, 30.6736115],
              [54.5610666, 30.6682962],
              [54.5645818, 30.6536253],
              [54.5655785, 30.6198588],
              [54.5653019, 30.6098594],
              [54.5630785, 30.5968009],
              [54.5594686, 30.5826324],
              [54.5504621, 30.5652224],
              [54.5285794, 30.5318068],
              [54.4767376, 30.482409],
              [54.4463903, 30.4554263],
              [54.3703076, 30.3933113],
              [54.3778607, 30.3799841],
              [54.3806073, 30.3687286],
              [54.3976017, 30.3429544]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 229766,
        "tags": {
          "ISO3166-2": "IR-16",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "ایلام",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q170570"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [45.69252, 33.69097],
              [45.694369, 33.690172],
              [45.69493, 33.688975],
              [45.694325, 33.688311],
              [45.694263, 33.687667],
              [45.694686, 33.687044],
              [45.694639, 33.686327],
              [45.694914, 33.686336],
              [45.695133, 33.686247],
              [45.695323, 33.686109],
              [45.695577, 33.686046],
              [45.695776, 33.685917],
              [45.695939, 33.685643],
              [45.696703, 33.685207],
              [45.696887, 33.685071],
              [45.697035, 33.684881],
              [45.697937, 33.685029],
              [45.698284, 33.685209],
              [45.698547, 33.685198],
              [45.698746, 33.685157],
              [45.698921, 33.684837],
              [45.699148, 33.684686],
              [45.699902, 33.684328],
              [45.699977, 33.684181],
              [45.699871, 33.683985],
              [45.699475, 33.68358],
              [45.69942, 33.6834],
              [45.699925, 33.683094],
              [45.700097, 33.682637],
              [45.700265, 33.68251],
              [45.70093, 33.681793],
              [45.701151, 33.681627],
              [45.701257, 33.68119],
              [45.701446, 33.681025],
              [45.701569, 33.680819],
              [45.70163, 33.680473],
              [45.701802, 33.680318],
              [45.702275, 33.680061],
              [45.702442, 33.679825],
              [45.702504, 33.679484],
              [45.702999, 33.678797],
              [45.70303, 33.678244],
              [45.702747, 33.677685],
              [45.705467, 33.675232],
              [45.705804, 33.675031],
              [45.706406, 33.674978],
              [45.706685, 33.674828],
              [45.706923, 33.674866],
              [45.707139, 33.674811],
              [45.708426, 33.674939],
              [45.708938, 33.675068],
              [45.709055, 33.674973],
              [45.70922, 33.674753],
              [45.709221, 33.674365],
              [45.70936, 33.674101],
              [45.70956, 33.673797],
              [45.70986, 33.673604],
              [45.71002, 33.673281],
              [45.710451, 33.672799],
              [45.710643, 33.672492],
              [45.710922, 33.672423],
              [45.711181, 33.672206],
              [45.711332, 33.671983],
              [45.711444, 33.671676],
              [45.712823, 33.67108],
              [45.713036, 33.670905],
              [45.713325, 33.670435],
              [45.714065, 33.669747],
              [45.714033, 33.669229],
              [45.714117, 33.669003],
              [45.714546, 33.668516],
              [45.714695, 33.668239],
              [45.714756, 33.667937],
              [45.714686, 33.667754],
              [45.714492, 33.66751],
              [45.714649, 33.667281],
              [45.714622, 33.667151],
              [45.714678, 33.666969],
              [45.714897, 33.66671],
              [45.715488, 33.666712],
              [45.715646, 33.666663],
              [45.716091, 33.666406],
              [45.716279, 33.666263],
              [45.716389, 33.666103],
              [45.716817, 33.665812],
              [45.717566, 33.665573],
              [45.717883, 33.665567],
              [45.718012, 33.665491],
              [45.718177, 33.665292],
              [45.71834, 33.66492],
              [45.718236, 33.664433],
              [45.718208, 33.663911],
              [45.718505, 33.663474],
              [45.718753, 33.662361],
              [45.719064, 33.661992],
              [45.719501, 33.661837],
              [45.719863, 33.661609],
              [45.72003, 33.661283],
              [45.721333, 33.660389],
              [45.721749, 33.660393],
              [45.734555, 33.65563],
              [45.7472521, 33.6492352],
              [45.77167, 33.636936],
              [45.772226, 33.63028],
              [45.772251, 33.629472],
              [45.771101, 33.62401],
              [45.770547, 33.623853],
              [45.769849, 33.623542],
              [45.76961, 33.623303],
              [45.769303, 33.62285],
              [45.768673, 33.622459],
              [45.767852, 33.622121],
              [45.767712, 33.621968],
              [45.767559, 33.621547],
              [45.767065, 33.620633],
              [45.767037, 33.620474],
              [45.767114, 33.619733],
              [45.766732, 33.618901],
              [45.766675, 33.61856],
              [45.766473, 33.618049],
              [45.766259, 33.61773],
              [45.766095, 33.617322],
              [45.766057, 33.617107],
              [45.766278, 33.616577],
              [45.766269, 33.616297],
              [45.765976, 33.615587],
              [45.765584, 33.615087],
              [45.764573, 33.614418],
              [45.763776, 33.614133],
              [45.762984, 33.613959],
              [45.76269, 33.613956],
              [45.761887, 33.614067],
              [45.761058, 33.613978],
              [45.760785, 33.61377],
              [45.759837, 33.6133],
              [45.759548, 33.613314],
              [45.759273, 33.613236],
              [45.759001, 33.612958],
              [45.758801, 33.612641],
              [45.758587, 33.611633],
              [45.758589, 33.610725],
              [45.758442, 33.610162],
              [45.757747, 33.609108],
              [45.757579, 33.608613],
              [45.757544, 33.608226],
              [45.757619, 33.607686],
              [45.757573, 33.607243],
              [45.757289, 33.60599],
              [45.757107, 33.60465],
              [45.756904, 33.604093],
              [45.756141, 33.602752],
              [45.75565, 33.602185],
              [45.755184, 33.601542],
              [45.754731, 33.600642],
              [45.754585, 33.600243],
              [45.754724, 33.598259],
              [45.754488, 33.598009],
              [45.754262, 33.597444],
              [45.754068, 33.596502],
              [45.753842, 33.596261],
              [45.7537, 33.595991],
              [45.753268, 33.593209],
              [45.753165, 33.592917],
              [45.757549, 33.594418],
              [45.774864, 33.602428],
              [45.788923, 33.607525],
              [45.80002, 33.612864],
              [45.801702, 33.612672],
              [45.801872, 33.612719],
              [45.802312, 33.61315],
              [45.803229, 33.613909],
              [45.803491, 33.61406],
              [45.803911, 33.614077],
              [45.804493, 33.61459],
              [45.804728, 33.614699],
              [45.805057, 33.615089],
              [45.805854, 33.615256],
              [45.80651, 33.615318],
              [45.806765, 33.615517],
              [45.807687, 33.615946],
              [45.808073, 33.616176],
              [45.80909, 33.617027],
              [45.809169, 33.617187],
              [45.809443, 33.617471],
              [45.809709, 33.617632],
              [45.81012, 33.617987],
              [45.810409, 33.618109],
              [45.810648, 33.618394],
              [45.811218, 33.618844],
              [45.811611, 33.619256],
              [45.811883, 33.619416],
              [45.812288, 33.619819],
              [45.812669, 33.619962],
              [45.812874, 33.62009],
              [45.812792, 33.620584],
              [45.812716, 33.620753],
              [45.812734, 33.620949],
              [45.81256, 33.621398],
              [45.812446, 33.621446],
              [45.812412, 33.621589],
              [45.812501, 33.622288],
              [45.812309, 33.622564],
              [45.812309, 33.622682],
              [45.8124, 33.623269],
              [45.81249, 33.623374],
              [45.812409, 33.623756],
              [45.812571, 33.62391],
              [45.812849, 33.623928],
              [45.812862, 33.624243],
              [45.812796, 33.624469],
              [45.812784, 33.624796],
              [45.812962, 33.625094],
              [45.812987, 33.625353],
              [45.812855, 33.625688],
              [45.81293, 33.625789],
              [45.812906, 33.626218],
              [45.81325, 33.627412],
              [45.813437, 33.627619],
              [45.813807, 33.627729],
              [45.814225, 33.627965],
              [45.814546, 33.628215],
              [45.814716, 33.628415],
              [45.81507, 33.628428],
              [45.815253, 33.628372],
              [45.815835, 33.628425],
              [45.816703, 33.628248],
              [45.817151, 33.627941],
              [45.817389, 33.62772],
              [45.817901, 33.627411],
              [45.818396, 33.627436],
              [45.819125, 33.627341],
              [45.819567, 33.627453],
              [45.819843, 33.627466],
              [45.820297, 33.627658],
              [45.820979, 33.62762],
              [45.821154, 33.627653],
              [45.821562, 33.627585],
              [45.82203, 33.62771],
              [45.822481, 33.627732],
              [45.822711, 33.627872],
              [45.822883, 33.627894],
              [45.823089, 33.628004],
              [45.82328, 33.628046],
              [45.823371, 33.628291],
              [45.823526, 33.628441],
              [45.824531, 33.628818],
              [45.824676, 33.628781],
              [45.825296, 33.628291],
              [45.825292, 33.628139],
              [45.825421, 33.627752],
              [45.82541, 33.627578],
              [45.825804, 33.627259],
              [45.826848, 33.627097],
              [45.827193, 33.627101],
              [45.827644, 33.627193],
              [45.827922, 33.627188],
              [45.828189, 33.626878],
              [45.828873, 33.626386],
              [45.828922, 33.626152],
              [45.829062, 33.626005],
              [45.829256, 33.625916],
              [45.829981, 33.625834],
              [45.830198, 33.62577],
              [45.830751, 33.625871],
              [45.831344, 33.625775],
              [45.832055, 33.625348],
              [45.832861, 33.625637],
              [45.833419, 33.625613],
              [45.833938, 33.62512],
              [45.834519, 33.625009],
              [45.834953, 33.625071],
              [45.835224, 33.624954],
              [45.835546, 33.62491],
              [45.835806, 33.625031],
              [45.836619, 33.624907],
              [45.836952, 33.625148],
              [45.837372, 33.625277],
              [45.838378, 33.625406],
              [45.838755, 33.625332],
              [45.839055, 33.625169],
              [45.839352, 33.625112],
              [45.839705, 33.625279],
              [45.840028, 33.625304],
              [45.840599, 33.625554],
              [45.841412, 33.625636],
              [45.841781, 33.625717],
              [45.842323, 33.626056],
              [45.843346, 33.626351],
              [45.843394, 33.626506],
              [45.843604, 33.62665],
              [45.84415, 33.626888],
              [45.844252, 33.627031],
              [45.844244, 33.62721],
              [45.844349, 33.627317],
              [45.845389, 33.627786],
              [45.845691, 33.628063],
              [45.84663, 33.62846],
              [45.847074, 33.628436],
              [45.847427, 33.628262],
              [45.848054, 33.628182],
              [45.848389, 33.628294],
              [45.848535, 33.628463],
              [45.848732, 33.628545],
              [45.848912, 33.628548],
              [45.849322, 33.628349],
              [45.849477, 33.628776],
              [45.849764, 33.628868],
              [45.850063, 33.628864],
              [45.85038, 33.628803],
              [45.850638, 33.628689],
              [45.850752, 33.628506],
              [45.851241, 33.628444],
              [45.851408, 33.628474],
              [45.851628, 33.628445],
              [45.851837, 33.628336],
              [45.852303, 33.628314],
              [45.8527, 33.628189],
              [45.852999, 33.628184],
              [45.85351, 33.628447],
              [45.85368, 33.628623],
              [45.853824, 33.628899],
              [45.854018, 33.629087],
              [45.854043, 33.629306],
              [45.854137, 33.629492],
              [45.854374, 33.629701],
              [45.85491, 33.629882],
              [45.855205, 33.630114],
              [45.8555, 33.630211],
              [45.855851, 33.630143],
              [45.856197, 33.629922],
              [45.85654, 33.629808],
              [45.856757, 33.629815],
              [45.856876, 33.629943],
              [45.85685, 33.63009],
              [45.857324, 33.630508],
              [45.857445, 33.630871],
              [45.857641, 33.631065],
              [45.857738, 33.631327],
              [45.857739, 33.631651],
              [45.857842, 33.631776],
              [45.857829, 33.631962],
              [45.858349, 33.632458],
              [45.858485, 33.632529],
              [45.858673, 33.63249],
              [45.858946, 33.632538],
              [45.860205, 33.63249],
              [45.861069, 33.632371],
              [45.861565, 33.632514],
              [45.862465, 33.632165],
              [45.862826, 33.631947],
              [45.863067, 33.631872],
              [45.86379, 33.632079],
              [45.864452, 33.63241],
              [45.865108, 33.632907],
              [45.866123, 33.633888],
              [45.867173, 33.633907],
              [45.86815, 33.633965],
              [45.868645, 33.634037],
              [45.869143, 33.634003],
              [45.869387, 33.634075],
              [45.869972, 33.634139],
              [45.870093, 33.634043],
              [45.870301, 33.633976],
              [45.870654, 33.634077],
              [45.870817, 33.634025],
              [45.87142, 33.634169],
              [45.871543, 33.634266],
              [45.871693, 33.634517],
              [45.872187, 33.634631],
              [45.872516, 33.634608],
              [45.872757, 33.634463],
              [45.873023, 33.634466],
              [45.873219, 33.634589],
              [45.873757, 33.634434],
              [45.873984, 33.634451],
              [45.874215, 33.634572],
              [45.874679, 33.634409],
              [45.875384, 33.63426],
              [45.875643, 33.634288],
              [45.875826, 33.634414],
              [45.875983, 33.634434],
              [45.876204, 33.634181],
              [45.87631, 33.634153],
              [45.877274, 33.634102],
              [45.877739, 33.633986],
              [45.877939, 33.633962],
              [45.878232, 33.634006],
              [45.878866, 33.633907],
              [45.879828, 33.633527],
              [45.879941, 33.633615],
              [45.880137, 33.633667],
              [45.880315, 33.633665],
              [45.880494, 33.633598],
              [45.880607, 33.633662],
              [45.881195, 33.633573],
              [45.881634, 33.633604],
              [45.881829, 33.633474],
              [45.882577, 33.633416],
              [45.882827, 33.633299],
              [45.883197, 33.633385],
              [45.883351, 33.633282],
              [45.88357, 33.633342],
              [45.883985, 33.633366],
              [45.884099, 33.633477],
              [45.884247, 33.63354],
              [45.884381, 33.633441],
              [45.884602, 33.633394],
              [45.884775, 33.633464],
              [45.884836, 33.633616],
              [45.885405, 33.633873],
              [45.885679, 33.634086],
              [45.886046, 33.634072],
              [45.886243, 33.633901],
              [45.886443, 33.633877],
              [45.88664, 33.633982],
              [45.887057, 33.634422],
              [45.887268, 33.634819],
              [45.887519, 33.634913],
              [45.887768, 33.635113],
              [45.887884, 33.635324],
              [45.887911, 33.635571],
              [45.887769, 33.635848],
              [45.887528, 33.636058],
              [45.887559, 33.636681],
              [45.887776, 33.636735],
              [45.888438, 33.636565],
              [45.889425, 33.636385],
              [45.889976, 33.636362],
              [45.890782, 33.636402],
              [45.891207, 33.636365],
              [45.89169, 33.636286],
              [45.892075, 33.636168],
              [45.892318, 33.63617],
              [45.892655, 33.636057],
              [45.893848, 33.636009],
              [45.89413, 33.635949],
              [45.894707, 33.636033],
              [45.894936, 33.635983],
              [45.895269, 33.635834],
              [45.895991, 33.635679],
              [45.896226, 33.635736],
              [45.896491, 33.635994],
              [45.897035, 33.635797],
              [45.89747, 33.635769],
              [45.898402, 33.6358],
              [45.898884, 33.635651],
              [45.899732, 33.635618],
              [45.899951, 33.635701],
              [45.900958, 33.635539],
              [45.901177, 33.635599],
              [45.901793, 33.636033],
              [45.901998, 33.636389],
              [45.901966, 33.636631],
              [45.902214, 33.636849],
              [45.903085, 33.637188],
              [45.903483, 33.637409],
              [45.903662, 33.637683],
              [45.903833, 33.637841],
              [45.904543, 33.637984],
              [45.904782, 33.638128],
              [45.905417, 33.63801],
              [45.906055, 33.638175],
              [45.906321, 33.638089],
              [45.907062, 33.638097],
              [45.916596, 33.627614],
              [45.905254, 33.606284],
              [45.906479, 33.606088],
              [45.906845, 33.606163],
              [45.907174, 33.606163],
              [45.908308, 33.605811],
              [45.909013, 33.605755],
              [45.909345, 33.605673],
              [45.910524, 33.605081],
              [45.910914, 33.605115],
              [45.911654, 33.605011],
              [45.912097, 33.604852],
              [45.912321, 33.604675],
              [45.913501, 33.604313],
              [45.913988, 33.604109],
              [45.914486, 33.604056],
              [45.915294, 33.603508],
              [45.915568, 33.603267],
              [45.915806, 33.603205],
              [45.916092, 33.603203],
              [45.91657, 33.602972],
              [45.916996, 33.60294],
              [45.91719, 33.602875],
              [45.917874, 33.602436],
              [45.918404, 33.602164],
              [45.918586, 33.601766],
              [45.919277, 33.601643],
              [45.919604, 33.601362],
              [45.91994, 33.601273],
              [45.920157, 33.601121],
              [45.920352, 33.600785],
              [45.920567, 33.600557],
              [45.920946, 33.600329],
              [45.92134, 33.599945],
              [45.921562, 33.599651],
              [45.9229, 33.599061],
              [45.923206, 33.599149],
              [45.923596, 33.599001],
              [45.923748, 33.598733],
              [45.924083, 33.598456],
              [45.924131, 33.598175],
              [45.924479, 33.597825],
              [45.925022, 33.597757],
              [45.925865, 33.597436],
              [45.926463, 33.59688],
              [45.926459, 33.596686],
              [45.926591, 33.596423],
              [45.926862, 33.596353],
              [45.927091, 33.596399],
              [45.927635, 33.596377],
              [45.927906, 33.596284],
              [45.928571, 33.596261],
              [45.928673, 33.596086],
              [45.929142, 33.595621],
              [45.929461, 33.595566],
              [45.929688, 33.595264],
              [45.929857, 33.59514],
              [45.930083, 33.595063],
              [45.930244, 33.594917],
              [45.930423, 33.594596],
              [45.930744, 33.594481],
              [45.930794, 33.594253],
              [45.93075, 33.594068],
              [45.931202, 33.593801],
              [45.931677, 33.593765],
              [45.931915, 33.593655],
              [45.932707, 33.593446],
              [45.933136, 33.593149],
              [45.93334, 33.59307],
              [45.933858, 33.592601],
              [45.934068, 33.592268],
              [45.934375, 33.592038],
              [45.934514, 33.591844],
              [45.934672, 33.591481],
              [45.935084, 33.591087],
              [45.935241, 33.590789],
              [45.93565, 33.590337],
              [45.935964, 33.590064],
              [45.936098, 33.589807],
              [45.936543, 33.589494],
              [45.937169, 33.588843],
              [45.937479, 33.588625],
              [45.937826, 33.588251],
              [45.937975, 33.587678],
              [45.938115, 33.587395],
              [45.938313, 33.587206],
              [45.938617, 33.587035],
              [45.938768, 33.586673],
              [45.939044, 33.586527],
              [45.939224, 33.586371],
              [45.939424, 33.586075],
              [45.939866, 33.585752],
              [45.940121, 33.585333],
              [45.940136, 33.585153],
              [45.940303, 33.584935],
              [45.940352, 33.584748],
              [45.940666, 33.584587],
              [45.940916, 33.584358],
              [45.941036, 33.584309],
              [45.941405, 33.583912],
              [45.941536, 33.58369],
              [45.941714, 33.583553],
              [45.942032, 33.583403],
              [45.942112, 33.583227],
              [45.942178, 33.582819],
              [45.942448, 33.582473],
              [45.942621, 33.582342],
              [45.943165, 33.582091],
              [45.94343, 33.581705],
              [45.943878, 33.581333],
              [45.944126, 33.581234],
              [45.944675, 33.580705],
              [45.94478, 33.580471],
              [45.944998, 33.580324],
              [45.945333, 33.58023],
              [45.945547, 33.579543],
              [45.94554, 33.579409],
              [45.945368, 33.579246],
              [45.945159, 33.578854],
              [45.944947, 33.578682],
              [45.945111, 33.578335],
              [45.945389, 33.578129],
              [45.945529, 33.57787],
              [45.945598, 33.577543],
              [45.945841, 33.57688],
              [45.946882, 33.575711],
              [45.947137, 33.575269],
              [45.947444, 33.575109],
              [45.948065, 33.575036],
              [45.94837, 33.574871],
              [45.948458, 33.574717],
              [45.948291, 33.574346],
              [45.948579, 33.574168],
              [45.948745, 33.573968],
              [45.949288, 33.573923],
              [45.949439, 33.573696],
              [45.949389, 33.57356],
              [45.949436, 33.573415],
              [45.949719, 33.572972],
              [45.949708, 33.572733],
              [45.950003, 33.572417],
              [45.949852, 33.572073],
              [45.949912, 33.571901],
              [45.950032, 33.571758],
              [45.950685, 33.57129],
              [45.951051, 33.570677],
              [45.951469, 33.570164],
              [45.951802, 33.569334],
              [45.951761, 33.568884],
              [45.952155, 33.568683],
              [45.953049, 33.568022],
              [45.953392, 33.56802],
              [45.95367, 33.568108],
              [45.953925, 33.568283],
              [45.954149, 33.568541],
              [45.9546, 33.568681],
              [45.955558, 33.569113],
              [45.955898, 33.569146],
              [45.956361, 33.569071],
              [45.957062, 33.569076],
              [45.957254, 33.569029],
              [45.957684, 33.568779],
              [45.957902, 33.568744],
              [45.958089, 33.568522],
              [45.958333, 33.568388],
              [45.958467, 33.56813],
              [45.958698, 33.568069],
              [45.958845, 33.567761],
              [45.958906, 33.567413],
              [45.959034, 33.56725],
              [45.959275, 33.567105],
              [45.959241, 33.566541],
              [45.959383, 33.566446],
              [45.959189, 33.56574],
              [45.959382, 33.565441],
              [45.959841, 33.565219],
              [45.959866, 33.565026],
              [45.959753, 33.564756],
              [45.959534, 33.564467],
              [45.959487, 33.564206],
              [45.959576, 33.564034],
              [45.960394, 33.56379],
              [45.960682, 33.563252],
              [45.961139, 33.563272],
              [45.961238, 33.562904],
              [45.961223, 33.562719],
              [45.961136, 33.562443],
              [45.960737, 33.561787],
              [45.961002, 33.56133],
              [45.96053, 33.56106],
              [45.96024, 33.560751],
              [45.959577, 33.560392],
              [45.959321, 33.560146],
              [45.959091, 33.559824],
              [45.959068, 33.559635],
              [45.959172, 33.559513],
              [45.959113, 33.559325],
              [45.958877, 33.559052],
              [45.958642, 33.558643],
              [45.958257, 33.558307],
              [45.95773, 33.557583],
              [45.957236, 33.557147],
              [45.957082, 33.557045],
              [45.956922, 33.557014],
              [45.95679, 33.556889],
              [45.95676, 33.556748],
              [45.956804, 33.556592],
              [45.957048, 33.556346],
              [45.957217, 33.556292],
              [45.956975, 33.555543],
              [45.957087, 33.555355],
              [45.956772, 33.555169],
              [45.956664, 33.555009],
              [45.95641, 33.554904],
              [45.956143, 33.554626],
              [45.955591, 33.55462],
              [45.955496, 33.554522],
              [45.955464, 33.554329],
              [45.955715, 33.553828],
              [45.95553, 33.553515],
              [45.955096, 33.553089],
              [45.954618, 33.552385],
              [45.953779, 33.551898],
              [45.953524, 33.551587],
              [45.953352, 33.551018],
              [45.953637, 33.550581],
              [45.953392, 33.550303],
              [45.953244, 33.550035],
              [45.953109, 33.549516],
              [45.952797, 33.549318],
              [45.952416, 33.548834],
              [45.952385, 33.548529],
              [45.952233, 33.548296],
              [45.951983, 33.548114],
              [45.951524, 33.547223],
              [45.950886, 33.546464],
              [45.950846, 33.546314],
              [45.950739, 33.546225],
              [45.950585, 33.546122],
              [45.950295, 33.546019],
              [45.950038, 33.545791],
              [45.949648, 33.545757],
              [45.949422, 33.545628],
              [45.949298, 33.54546],
              [45.948653, 33.545068],
              [45.94839, 33.544712],
              [45.94811, 33.544912],
              [45.947683, 33.545095],
              [45.947603, 33.545262],
              [45.947277, 33.545378],
              [45.946961, 33.545312],
              [45.924458, 33.530826],
              [45.895249, 33.512558],
              [45.863003, 33.493148],
              [45.873505, 33.493841],
              [45.8747964, 33.4930667],
              [45.878907, 33.490602],
              [45.879607, 33.490745],
              [45.881584, 33.4916],
              [45.882042, 33.491907],
              [45.883615, 33.492517],
              [45.884497, 33.492391],
              [45.887514, 33.493785],
              [45.889325, 33.493625],
              [45.889806, 33.49369],
              [45.890318, 33.493937],
              [45.890894, 33.493964],
              [45.891338, 33.493717],
              [45.891806, 33.493543],
              [45.892872, 33.492893],
              [45.893313, 33.492701],
              [45.893984, 33.49273],
              [45.89424, 33.492424],
              [45.895132, 33.492255],
              [45.895935, 33.492184],
              [45.896647, 33.492059],
              [45.898635, 33.492469],
              [45.899222, 33.492834],
              [45.899415, 33.492778],
              [45.899724, 33.492537],
              [45.900151, 33.492436],
              [45.900376, 33.491631],
              [45.900737, 33.491508],
              [45.901454, 33.491905],
              [45.902635, 33.492027],
              [45.904154, 33.490995],
              [45.905, 33.490055],
              [45.905232, 33.489955],
              [45.90554, 33.489638],
              [45.906038, 33.488907],
              [45.906681, 33.489031],
              [45.90769, 33.489724],
              [45.907991, 33.489829],
              [45.909336, 33.489833],
              [45.90978, 33.489764],
              [45.910271, 33.489792],
              [45.910761, 33.489642],
              [45.911697, 33.489582],
              [45.912217, 33.489633],
              [45.912669, 33.48974],
              [45.912964, 33.48994],
              [45.913385, 33.49048],
              [45.915795, 33.490662],
              [45.916186, 33.490847],
              [45.916687, 33.490908],
              [45.917105, 33.490845],
              [45.917815, 33.49051],
              [45.91795, 33.490285],
              [45.918214, 33.490038],
              [45.918573, 33.490082],
              [45.918827, 33.489979],
              [45.919311, 33.490096],
              [45.920044, 33.489987],
              [45.920341, 33.490105],
              [45.920773, 33.490062],
              [45.921179, 33.490227],
              [45.921675, 33.490271],
              [45.922366, 33.490472],
              [45.923107, 33.490385],
              [45.923405, 33.490639],
              [45.923737, 33.490796],
              [45.924123, 33.490746],
              [45.925132, 33.490469],
              [45.925462, 33.490556],
              [45.925937, 33.490492],
              [45.926891, 33.490683],
              [45.927204, 33.490673],
              [45.927653, 33.490727],
              [45.92858, 33.490705],
              [45.928815, 33.490984],
              [45.928789, 33.491256],
              [45.929463, 33.491142],
              [45.9299, 33.49127],
              [45.930286, 33.491504],
              [45.930861, 33.49133],
              [45.931301, 33.491445],
              [45.931667, 33.491311],
              [45.931968, 33.491286],
              [45.932308, 33.491358],
              [45.932519, 33.491566],
              [45.932987, 33.491756],
              [45.933292, 33.49182],
              [45.933395, 33.49193],
              [45.934085, 33.492095],
              [45.93453, 33.491411],
              [45.934957, 33.491139],
              [45.936015, 33.490699],
              [45.936239, 33.490429],
              [45.936603, 33.490119],
              [45.936945, 33.48992],
              [45.937166, 33.489434],
              [45.936938, 33.488571],
              [45.936998, 33.488368],
              [45.937522, 33.487637],
              [45.937558, 33.487414],
              [45.937712, 33.487177],
              [45.938264, 33.486983],
              [45.938909, 33.486631],
              [45.939226, 33.486269],
              [45.939231, 33.486],
              [45.939117, 33.485582],
              [45.9387, 33.48535],
              [45.938439, 33.485064],
              [45.938161, 33.484621],
              [45.938124, 33.48413],
              [45.938164, 33.483468],
              [45.938028, 33.483149],
              [45.938178, 33.482565],
              [45.938315, 33.482223],
              [45.938446, 33.482046],
              [45.939108, 33.48189],
              [45.939491, 33.481894],
              [45.940014, 33.482557],
              [45.94068, 33.482716],
              [45.942956, 33.483493],
              [45.943443, 33.484224],
              [45.943609, 33.484853],
              [45.944044, 33.485079],
              [45.944151, 33.485441],
              [45.944382, 33.485783],
              [45.944739, 33.486085],
              [45.945332, 33.486148],
              [45.945678, 33.486517],
              [45.945898, 33.486917],
              [45.946525, 33.486893],
              [45.946857, 33.487033],
              [45.94721, 33.487059],
              [45.947408, 33.48744],
              [45.947978, 33.487502],
              [45.948219, 33.487634],
              [45.94859, 33.488223],
              [45.949094, 33.488505],
              [45.949397, 33.489123],
              [45.950297, 33.489183],
              [45.95112, 33.48934],
              [45.951592, 33.489644],
              [45.952281, 33.489809],
              [45.952798, 33.48969],
              [45.953442, 33.489683],
              [45.953712, 33.489517],
              [45.953933, 33.489491],
              [45.954158, 33.489519],
              [45.954473, 33.489472],
              [45.954751, 33.48973],
              [45.954431, 33.490189],
              [45.954049, 33.490495],
              [45.953896, 33.490674],
              [45.953899, 33.490838],
              [45.954005, 33.49104],
              [45.953951, 33.49125],
              [45.953978, 33.492001],
              [45.954053, 33.49233],
              [45.954039, 33.492661],
              [45.95413, 33.492896],
              [45.954347, 33.492978],
              [45.9544, 33.493128],
              [45.954945, 33.493487],
              [45.955065, 33.493644],
              [45.955243, 33.494243],
              [45.955136, 33.494565],
              [45.955143, 33.49475],
              [45.95541, 33.494919],
              [45.955603, 33.495124],
              [45.9559, 33.495298],
              [45.956579, 33.49544],
              [45.956826, 33.495371],
              [45.956929, 33.495445],
              [45.957024, 33.496119],
              [45.957214, 33.496349],
              [45.957381, 33.497267],
              [45.957528, 33.497637],
              [45.957626, 33.497796],
              [45.957927, 33.497903],
              [45.958071, 33.498099],
              [45.958239, 33.498671],
              [45.958411, 33.498855],
              [45.958673, 33.498921],
              [45.959023, 33.498935],
              [45.959599, 33.498654],
              [45.959773, 33.498491],
              [45.959888, 33.498294],
              [45.960035, 33.498241],
              [45.960197, 33.498252],
              [45.960606, 33.498866],
              [45.960625, 33.499009],
              [45.960559, 33.49916],
              [45.960725, 33.499845],
              [45.961395, 33.500707],
              [45.961596, 33.500817],
              [45.961975, 33.50081],
              [45.962228, 33.501209],
              [45.962932, 33.501449],
              [45.963219, 33.501339],
              [45.963427, 33.501337],
              [45.963859, 33.501132],
              [45.964139, 33.501185],
              [45.964285, 33.501345],
              [45.96456, 33.501944],
              [45.964851, 33.502077],
              [45.96504, 33.502085],
              [45.965682, 33.501739],
              [45.965899, 33.5017],
              [45.966139, 33.501499],
              [45.966613, 33.501598],
              [45.967248, 33.501452],
              [45.967481, 33.501459],
              [45.968076, 33.501127],
              [45.968148, 33.500951],
              [45.968133, 33.500818],
              [45.968334, 33.50075],
              [45.968889, 33.501041],
              [45.969594, 33.500779],
              [45.970085, 33.500918],
              [45.970553, 33.501163],
              [45.971199, 33.501293],
              [45.97163, 33.501511],
              [45.972029, 33.501984],
              [45.972208, 33.502092],
              [45.972913, 33.502356],
              [45.973242, 33.502265],
              [45.973461, 33.502122],
              [45.973807, 33.5023],
              [45.973902, 33.502415],
              [45.974175, 33.502437],
              [45.974547, 33.502739],
              [45.975594, 33.503016],
              [45.975759, 33.503104],
              [45.976143, 33.503445],
              [45.976924, 33.503307],
              [45.977288, 33.503386],
              [45.977611, 33.503581],
              [45.977889, 33.503661],
              [45.977988, 33.503965],
              [45.978328, 33.504238],
              [45.978366, 33.504419],
              [45.978661, 33.504442],
              [45.978794, 33.504496],
              [45.978915, 33.505169],
              [45.979124, 33.505352],
              [45.979334, 33.50567],
              [45.979588, 33.505589],
              [45.979779, 33.505388],
              [45.980025, 33.505221],
              [45.980115, 33.505773],
              [45.980286, 33.505788],
              [45.980563, 33.505707],
              [45.981406, 33.505869],
              [45.981512, 33.506194],
              [45.982228, 33.506734],
              [45.982635, 33.506945],
              [45.982828, 33.507097],
              [45.983053, 33.507125],
              [45.983539, 33.50746],
              [45.984002, 33.507691],
              [45.984343, 33.507616],
              [45.984796, 33.507389],
              [45.985212, 33.50754],
              [45.985628, 33.507616],
              [45.986195, 33.507502],
              [45.987291, 33.506935],
              [45.988463, 33.506708],
              [45.98937, 33.507767],
              [45.98971, 33.507994],
              [45.98997, 33.508059],
              [45.990527, 33.507871],
              [45.990733, 33.507689],
              [45.990933, 33.507597],
              [45.991057, 33.507623],
              [45.991301, 33.507581],
              [45.991857, 33.507257],
              [45.992001, 33.507391],
              [45.992267, 33.507521],
              [45.992758, 33.507572],
              [45.99301, 33.50764],
              [45.99318, 33.507851],
              [45.993486, 33.507866],
              [45.993694, 33.507974],
              [45.994008, 33.508011],
              [45.994597, 33.50801],
              [45.994703, 33.508182],
              [45.99485, 33.508256],
              [45.995164, 33.508316],
              [45.995697, 33.50834],
              [45.996189, 33.508285],
              [45.997384, 33.510413],
              [45.998291, 33.511585],
              [45.998782, 33.511471],
              [45.998971, 33.511282],
              [45.999047, 33.510866],
              [45.999236, 33.510791],
              [45.999916, 33.511093],
              [46.000294, 33.511207],
              [46.000634, 33.511093],
              [46.000861, 33.510942],
              [46.00105, 33.510299],
              [46.001579, 33.509921],
              [46.002897, 33.509754],
              [46.003502, 33.509551],
              [46.003843, 33.509298],
              [46.004047, 33.509064],
              [46.003988, 33.508882],
              [46.00405, 33.508655],
              [46.004318, 33.508484],
              [46.004858, 33.5084],
              [46.005128, 33.508192],
              [46.005461, 33.508136],
              [46.005839, 33.507993],
              [46.006174, 33.507919],
              [46.00658, 33.50793],
              [46.007252, 33.50781],
              [46.007403, 33.507546],
              [46.007762, 33.507171],
              [46.00786, 33.506724],
              [46.00772, 33.506341],
              [46.007692, 33.50575],
              [46.007938, 33.505447],
              [46.00795, 33.505066],
              [46.008194, 33.504491],
              [46.008136, 33.504096],
              [46.007669, 33.503833],
              [46.007604, 33.503611],
              [46.007628, 33.503333],
              [46.00754, 33.503063],
              [46.007576, 33.502647],
              [46.007364, 33.502085],
              [46.007346, 33.501746],
              [46.007235, 33.501493],
              [46.007317, 33.501043],
              [46.007486, 33.500615],
              [46.007502, 33.500245],
              [46.007424, 33.500138],
              [46.007465, 33.49923],
              [46.007382, 33.498911],
              [46.007472, 33.498637],
              [46.007438, 33.498313],
              [46.007536, 33.497647],
              [46.00742, 33.497312],
              [46.007407, 33.497054],
              [46.007184, 33.496678],
              [46.006889, 33.496306],
              [46.006996, 33.495797],
              [46.006849, 33.495546],
              [46.006935, 33.495083],
              [46.00684, 33.494749],
              [46.007012, 33.493647],
              [46.006858, 33.493527],
              [46.006424, 33.491826],
              [46.005809, 33.490826],
              [46.00503, 33.490136],
              [46.004847, 33.489685],
              [46.004806, 33.489428],
              [46.004651, 33.489131],
              [46.004954, 33.488585],
              [46.005751, 33.488385],
              [46.006678, 33.488298],
              [46.007078, 33.488115],
              [46.007801, 33.487488],
              [46.007865, 33.486829],
              [46.008076, 33.486593],
              [46.008315, 33.486469],
              [46.008852, 33.486374],
              [46.009176, 33.486201],
              [46.009418, 33.485929],
              [46.009564, 33.485672],
              [46.009573, 33.485457],
              [46.009682, 33.485262],
              [46.009869, 33.485066],
              [46.010519, 33.484657],
              [46.011309, 33.484239],
              [46.012103, 33.484205],
              [46.01238, 33.484108],
              [46.012564, 33.483813],
              [46.013218, 33.483065],
              [46.013343, 33.482635],
              [46.013525, 33.482335],
              [46.013855, 33.482025],
              [46.014513, 33.481643],
              [46.014791, 33.48157],
              [46.015173, 33.481639],
              [46.015953, 33.481957],
              [46.016406, 33.481981],
              [46.016677, 33.482063],
              [46.016812, 33.482542],
              [46.016924, 33.482665],
              [46.017845, 33.482668],
              [46.018047, 33.482404],
              [46.018392, 33.482251],
              [46.018816, 33.482405],
              [46.019184, 33.482785],
              [46.019354, 33.483126],
              [46.019331, 33.483847],
              [46.01886, 33.484584],
              [46.018373, 33.485005],
              [46.018446, 33.485757],
              [46.018636, 33.486053],
              [46.018929, 33.486112],
              [46.019278, 33.486058],
              [46.019647, 33.485693],
              [46.020892, 33.485258],
              [46.021492, 33.485249],
              [46.023258, 33.484242],
              [46.023926, 33.483583],
              [46.024556, 33.482844],
              [46.025194, 33.481926],
              [46.025945, 33.481181],
              [46.026532, 33.480308],
              [46.026474, 33.480057],
              [46.026046, 33.479944],
              [46.026031, 33.479553],
              [46.026139, 33.479195],
              [46.026457, 33.478686],
              [46.026812, 33.47747],
              [46.027269, 33.47724],
              [46.02732, 33.476454],
              [46.028064, 33.474977],
              [46.028118, 33.474707],
              [46.027987, 33.474379],
              [46.027891, 33.47377],
              [46.027983, 33.473141],
              [46.0281847, 33.4729167],
              [46.02859, 33.472466],
              [46.029636, 33.471775],
              [46.030447, 33.471572],
              [46.031259, 33.471154],
              [46.031401, 33.469921],
              [46.031754, 33.469346],
              [46.032391, 33.468926],
              [46.03194, 33.468471],
              [46.031986, 33.46825],
              [46.032787, 33.467805],
              [46.033497, 33.467562],
              [46.033436, 33.467015],
              [46.03347, 33.466355],
              [46.033976, 33.465291],
              [46.034102, 33.464845],
              [46.034419, 33.464456],
              [46.034521, 33.463941],
              [46.034236, 33.46347],
              [46.03445, 33.463184],
              [46.03505, 33.463032],
              [46.035679, 33.462761],
              [46.035649, 33.462378],
              [46.035528, 33.461977],
              [46.035927, 33.461372],
              [46.036502, 33.461247],
              [46.036768, 33.460955],
              [46.036788, 33.460469],
              [46.036564, 33.460143],
              [46.036518, 33.45946],
              [46.036196, 33.458726],
              [46.036701, 33.458442],
              [46.037314, 33.458174],
              [46.037668, 33.457698],
              [46.037844, 33.45671],
              [46.03783, 33.456071],
              [46.038414, 33.455586],
              [46.039054, 33.4554],
              [46.03938, 33.455158],
              [46.039666, 33.454442],
              [46.039599, 33.45402],
              [46.038285, 33.453707],
              [46.038264, 33.453346],
              [46.038659, 33.45278],
              [46.039436, 33.452079],
              [46.040408, 33.451306],
              [46.041133, 33.450268],
              [46.041438, 33.449655],
              [46.042188, 33.449312],
              [46.042784, 33.449266],
              [46.042987, 33.448542],
              [46.043553, 33.447772],
              [46.044604, 33.447238],
              [46.043648, 33.445598],
              [46.042767, 33.445049],
              [46.042053, 33.444899],
              [46.041533, 33.444544],
              [46.041076, 33.44396],
              [46.040413, 33.443336],
              [46.039677, 33.443065],
              [46.038447, 33.443077],
              [46.037858, 33.442978],
              [46.037337, 33.442738],
              [46.036655, 33.442824],
              [46.036092, 33.442732],
              [46.035966, 33.442624],
              [46.036425, 33.441774],
              [46.036809, 33.441584],
              [46.037302, 33.441435],
              [46.038067, 33.441031],
              [46.038429, 33.440507],
              [46.038647, 33.439927],
              [46.039176, 33.439581],
              [46.039758, 33.438914],
              [46.040152, 33.437954],
              [46.040039, 33.437701],
              [46.040189, 33.437424],
              [46.040777, 33.437093],
              [46.040822, 33.436544],
              [46.041212, 33.436293],
              [46.041427, 33.435944],
              [46.041303, 33.435453],
              [46.041012, 33.435149],
              [46.040845, 33.434847],
              [46.040419, 33.434781],
              [46.040338, 33.434524],
              [46.040304, 33.434095],
              [46.040416, 33.433308],
              [46.040424, 33.432865],
              [46.0406, 33.432364],
              [46.040676, 33.431378],
              [46.041144, 33.431062],
              [46.041683, 33.430829],
              [46.043303, 33.430333],
              [46.044274, 33.429954],
              [46.044981, 33.429295],
              [46.045323, 33.429087],
              [46.045131, 33.428411],
              [46.045409, 33.427971],
              [46.045491, 33.427141],
              [46.045431, 33.426449],
              [46.045757, 33.424272],
              [46.04554, 33.423277],
              [46.045487, 33.422501],
              [46.045058, 33.421754],
              [46.045281, 33.421136],
              [46.045827, 33.419973],
              [46.046454, 33.419305],
              [46.047332, 33.41903],
              [46.047725, 33.418732],
              [46.048613, 33.417784],
              [46.048839, 33.417737],
              [46.049162, 33.417575],
              [46.049494, 33.417193],
              [46.049911, 33.416478],
              [46.049888, 33.416048],
              [46.050031, 33.415791],
              [46.049992, 33.415096],
              [46.05031, 33.414817],
              [46.051493, 33.415167],
              [46.051879, 33.415192],
              [46.052275, 33.415113],
              [46.053261, 33.415225],
              [46.053499, 33.415119],
              [46.053942, 33.415082],
              [46.054165, 33.414689],
              [46.054562, 33.414453],
              [46.054652, 33.414211],
              [46.054706, 33.413836],
              [46.055416, 33.412772],
              [46.05605, 33.412444],
              [46.056299, 33.412155],
              [46.0567, 33.411415],
              [46.057057, 33.411352],
              [46.057353, 33.411195],
              [46.057466, 33.410896],
              [46.057421, 33.410533],
              [46.057333, 33.410295],
              [46.058076, 33.410018],
              [46.058343, 33.409764],
              [46.059003, 33.409461],
              [46.059452, 33.409101],
              [46.05996, 33.408338],
              [46.060688, 33.40822],
              [46.061372, 33.407619],
              [46.061755, 33.406659],
              [46.062216, 33.406123],
              [46.063104, 33.405478],
              [46.064145, 33.40463],
              [46.064958, 33.403516],
              [46.065228, 33.403041],
              [46.065488, 33.401958],
              [46.065905, 33.401667],
              [46.066803, 33.401868],
              [46.067948, 33.401947],
              [46.068862, 33.402293],
              [46.069427, 33.40214],
              [46.070142, 33.40159],
              [46.070805, 33.40124],
              [46.070969, 33.399701],
              [46.070538, 33.399119],
              [46.069986, 33.398672],
              [46.069956, 33.397967],
              [46.070438, 33.397603],
              [46.072092, 33.397286],
              [46.072502, 33.39672],
              [46.072254, 33.396042],
              [46.072136, 33.395522],
              [46.072123, 33.394843],
              [46.072694, 33.393022],
              [46.073369, 33.392008],
              [46.073676, 33.391307],
              [46.074288, 33.390982],
              [46.075112, 33.390842],
              [46.075698, 33.391229],
              [46.076484, 33.391058],
              [46.076901, 33.390591],
              [46.077601, 33.389648],
              [46.077612, 33.389223],
              [46.077443, 33.388913],
              [46.077697, 33.388411],
              [46.078016, 33.387948],
              [46.07792, 33.362124],
              [46.078909, 33.361528],
              [46.079442, 33.361033],
              [46.079953, 33.360017],
              [46.079544, 33.359114],
              [46.078998, 33.358689],
              [46.078626, 33.358478],
              [46.077845, 33.357458],
              [46.079286, 33.356635],
              [46.08005, 33.356541],
              [46.081045, 33.356309],
              [46.082003, 33.355585],
              [46.08256, 33.354697],
              [46.082519, 33.353647],
              [46.0824, 33.353219],
              [46.081569, 33.352677],
              [46.080962, 33.351755],
              [46.08644, 33.34745],
              [46.087919, 33.346863],
              [46.088937, 33.34638],
              [46.089465, 33.345927],
              [46.089888, 33.345251],
              [46.089317, 33.34472],
              [46.08897, 33.3443],
              [46.088909, 33.344138],
              [46.089499, 33.343834],
              [46.090194, 33.343616],
              [46.090858, 33.343299],
              [46.091809, 33.342244],
              [46.092581, 33.34225],
              [46.094525, 33.339891],
              [46.094598, 33.339729],
              [46.095318, 33.339174],
              [46.095636, 33.339127],
              [46.095922, 33.339291],
              [46.096583, 33.33915],
              [46.097124, 33.339185],
              [46.098095, 33.338795],
              [46.098514, 33.338171],
              [46.098993, 33.337856],
              [46.099475, 33.337741],
              [46.099863, 33.337753],
              [46.100023, 33.337656],
              [46.100159, 33.337146],
              [46.1003, 33.336931],
              [46.102099, 33.335443],
              [46.102266, 33.334678],
              [46.102113, 33.334281],
              [46.102689, 33.334051],
              [46.103147, 33.333948],
              [46.103496, 33.333396],
              [46.104218, 33.332929],
              [46.104423, 33.332716],
              [46.10496, 33.33291],
              [46.105672, 33.332941],
              [46.107069, 33.332493],
              [46.10736, 33.332204],
              [46.107801, 33.33214],
              [46.108578, 33.3317],
              [46.10887, 33.33158],
              [46.108952, 33.331389],
              [46.109034, 33.330909],
              [46.109252, 33.330916],
              [46.109529, 33.330995],
              [46.109746, 33.331142],
              [46.110039, 33.331167],
              [46.110383, 33.331064],
              [46.110568, 33.330911],
              [46.111204, 33.330662],
              [46.111444, 33.330732],
              [46.111839, 33.330723],
              [46.112101, 33.330572],
              [46.11238, 33.330155],
              [46.112485, 33.329913],
              [46.112275, 33.329392],
              [46.112344, 33.328909],
              [46.112497, 33.328767],
              [46.113081, 33.328522],
              [46.113671, 33.328302],
              [46.114276, 33.328188],
              [46.114547, 33.32803],
              [46.114647, 33.327598],
              [46.114791, 33.327277],
              [46.114821, 33.326899],
              [46.114932, 33.326848],
              [46.11515, 33.326902],
              [46.115447, 33.326874],
              [46.115737, 33.326718],
              [46.116011, 33.326472],
              [46.116114, 33.326319],
              [46.115936, 33.325952],
              [46.115744, 33.325739],
              [46.115469, 33.32524],
              [46.115402, 33.324895],
              [46.115608, 33.324563],
              [46.115733, 33.324235],
              [46.116015, 33.32393],
              [46.116151, 33.323647],
              [46.116442, 33.323496],
              [46.116702, 33.323051],
              [46.116782, 33.322731],
              [46.116701, 33.322207],
              [46.116717, 33.321915],
              [46.116899, 33.321054],
              [46.116838, 33.320832],
              [46.116541, 33.320575],
              [46.116224, 33.320451],
              [46.11601, 33.319817],
              [46.115776, 33.319626],
              [46.115319, 33.319383],
              [46.114737, 33.319281],
              [46.114502, 33.319106],
              [46.114284, 33.31886],
              [46.114147, 33.318445],
              [46.114232, 33.31829],
              [46.114749, 33.318036],
              [46.114939, 33.317878],
              [46.115231, 33.317779],
              [46.115491, 33.317623],
              [46.115801, 33.317262],
              [46.115876, 33.316969],
              [46.116136, 33.316622],
              [46.116973, 33.316046],
              [46.117126, 33.315879],
              [46.117149, 33.315663],
              [46.117226, 33.315545],
              [46.117115, 33.315234],
              [46.116991, 33.315137],
              [46.116625, 33.315074],
              [46.116129, 33.314796],
              [46.115974, 33.314664],
              [46.11584, 33.314357],
              [46.11584, 33.314212],
              [46.11599, 33.313797],
              [46.116286, 33.313546],
              [46.116319, 33.313323],
              [46.116703, 33.312405],
              [46.116842, 33.312183],
              [46.11701, 33.312101],
              [46.117085, 33.311907],
              [46.117046, 33.311795],
              [46.116589, 33.311577],
              [46.1164, 33.311187],
              [46.116075, 33.311152],
              [46.115357, 33.311303],
              [46.115101, 33.311095],
              [46.115037, 33.310713],
              [46.11516, 33.310044],
              [46.115088, 33.309296],
              [46.115349, 33.308996],
              [46.115778, 33.308742],
              [46.116498, 33.308478],
              [46.116743, 33.308449],
              [46.116925, 33.308354],
              [46.117048, 33.308234],
              [46.117115, 33.307745],
              [46.117503, 33.307417],
              [46.117581, 33.307087],
              [46.11781, 33.306901],
              [46.117989, 33.306672],
              [46.118272, 33.30661],
              [46.118698, 33.306699],
              [46.118959, 33.306688],
              [46.119891, 33.306525],
              [46.120295, 33.306287],
              [46.121013, 33.306328],
              [46.121184, 33.306282],
              [46.121389, 33.306141],
              [46.121738, 33.305793],
              [46.122138, 33.305612],
              [46.122371, 33.305369],
              [46.12277, 33.305131],
              [46.123237, 33.304576],
              [46.123358, 33.304497],
              [46.123721, 33.304447],
              [46.123919, 33.304298],
              [46.124025, 33.304159],
              [46.123978, 33.30394],
              [46.124065, 33.303412],
              [46.124289, 33.302699],
              [46.124498, 33.302501],
              [46.125038, 33.30215],
              [46.125024, 33.302018],
              [46.124784, 33.301637],
              [46.125087, 33.300987],
              [46.125191, 33.300833],
              [46.125381, 33.300748],
              [46.125519, 33.300407],
              [46.125638, 33.30022],
              [46.125816, 33.300063],
              [46.125967, 33.299721],
              [46.126085, 33.299632],
              [46.126636, 33.299491],
              [46.126965, 33.299183],
              [46.127136, 33.299116],
              [46.127391, 33.299081],
              [46.127587, 33.299118],
              [46.127993, 33.299101],
              [46.128306, 33.299014],
              [46.128372, 33.298857],
              [46.128556, 33.298699],
              [46.128556, 33.29841],
              [46.128997, 33.298227],
              [46.129223, 33.298217],
              [46.129772, 33.298045],
              [46.129752, 33.297412],
              [46.129869, 33.296863],
              [46.129931, 33.296107],
              [46.130985, 33.296206],
              [46.131259, 33.296033],
              [46.131517, 33.295795],
              [46.131629, 33.29563],
              [46.13166, 33.295469],
              [46.131933, 33.295244],
              [46.132281, 33.294492],
              [46.132303, 33.293981],
              [46.132168, 33.293669],
              [46.132587, 33.29347],
              [46.132823, 33.293499],
              [46.133243, 33.293398],
              [46.133477, 33.293061],
              [46.133966, 33.292641],
              [46.134031, 33.292479],
              [46.13397, 33.292325],
              [46.134, 33.292185],
              [46.134161, 33.292099],
              [46.134336, 33.292072],
              [46.134525, 33.292126],
              [46.134977, 33.292034],
              [46.135467, 33.29162],
              [46.135842, 33.291071],
              [46.136089, 33.290933],
              [46.136164, 33.290785],
              [46.13615, 33.290632],
              [46.136513, 33.290536],
              [46.136845, 33.290336],
              [46.137292, 33.29025],
              [46.137487, 33.290163],
              [46.138589, 33.289519],
              [46.138805, 33.289444],
              [46.13947, 33.28934],
              [46.139517, 33.289197],
              [46.139795, 33.288924],
              [46.139859, 33.288705],
              [46.139997, 33.288551],
              [46.140034, 33.288198],
              [46.140327, 33.288031],
              [46.140447, 33.287875],
              [46.140603, 33.287893],
              [46.141055, 33.287656],
              [46.141313, 33.287589],
              [46.14189, 33.28705],
              [46.14215, 33.286895],
              [46.142435, 33.286647],
              [46.142812, 33.286465],
              [46.142883, 33.286369],
              [46.143026, 33.286359],
              [46.143804, 33.286498],
              [46.14388, 33.286137],
              [46.144082, 33.285744],
              [46.144287, 33.285552],
              [46.145378, 33.284697],
              [46.145565, 33.284576],
              [46.145936, 33.284442],
              [46.146308, 33.284074],
              [46.146711, 33.283805],
              [46.146974, 33.283706],
              [46.147104, 33.283522],
              [46.14747, 33.283197],
              [46.147657, 33.283127],
              [46.148095, 33.283146],
              [46.148547, 33.282797],
              [46.148862, 33.282667],
              [46.149218, 33.282642],
              [46.149545, 33.282441],
              [46.150742, 33.282533],
              [46.150838, 33.282351],
              [46.150941, 33.281866],
              [46.151069, 33.281752],
              [46.151268, 33.281665],
              [46.152002, 33.281555],
              [46.152101, 33.281452],
              [46.152625, 33.28125],
              [46.153019, 33.280968],
              [46.153357, 33.280856],
              [46.154, 33.280786],
              [46.154519, 33.280636],
              [46.155449, 33.28015],
              [46.156329, 33.2792],
              [46.157104, 33.278731],
              [46.157413, 33.278578],
              [46.157913, 33.278477],
              [46.158094, 33.278302],
              [46.159194, 33.277689],
              [46.159624, 33.277725],
              [46.159977, 33.27769],
              [46.160314, 33.277527],
              [46.160294, 33.277269],
              [46.160387, 33.277047],
              [46.160658, 33.276645],
              [46.160911, 33.276452],
              [46.161709, 33.276018],
              [46.162632, 33.275716],
              [46.163271, 33.275191],
              [46.163826, 33.274869],
              [46.164242, 33.274504],
              [46.164935, 33.274362],
              [46.165519, 33.274029],
              [46.165746, 33.273812],
              [46.16596, 33.273756],
              [46.16624, 33.273456],
              [46.166412, 33.273362],
              [46.166594, 33.273073],
              [46.16712, 33.272904],
              [46.167318, 33.272766],
              [46.167513, 33.272481],
              [46.167481, 33.272128],
              [46.167813, 33.271784],
              [46.168369, 33.271513],
              [46.168597, 33.271369],
              [46.168944, 33.271056],
              [46.16971, 33.2706],
              [46.170386, 33.27037],
              [46.170937, 33.270265],
              [46.171403, 33.270455],
              [46.171661, 33.270494],
              [46.171972, 33.270466],
              [46.172085, 33.270366],
              [46.172863, 33.2703],
              [46.173011, 33.270006],
              [46.173583, 33.269721],
              [46.173948, 33.269593],
              [46.174693, 33.269613],
              [46.174879, 33.269551],
              [46.175024, 33.269451],
              [46.175185, 33.269086],
              [46.175356, 33.268896],
              [46.176022, 33.268468],
              [46.176398, 33.268287],
              [46.176694, 33.268205],
              [46.176822, 33.268091],
              [46.177115, 33.268044],
              [46.177465, 33.268067],
              [46.177668, 33.268019],
              [46.178046, 33.2677],
              [46.178256, 33.267628],
              [46.178729, 33.267219],
              [46.178962, 33.266909],
              [46.179322, 33.266201],
              [46.179662, 33.265838],
              [46.180034, 33.265663],
              [46.180208, 33.265461],
              [46.180461, 33.265268],
              [46.180662, 33.26526],
              [46.181257, 33.265409],
              [46.181481, 33.265551],
              [46.182566, 33.26605],
              [46.182769, 33.266071],
              [46.182927, 33.26602],
              [46.183117, 33.265877],
              [46.183263, 33.265851],
              [46.183659, 33.266019],
              [46.184276, 33.26597],
              [46.185126, 33.265681],
              [46.185306, 33.265432],
              [46.185636, 33.26531],
              [46.185836, 33.265297],
              [46.186449, 33.265073],
              [46.18676, 33.265159],
              [46.187213, 33.265118],
              [46.187426, 33.264943],
              [46.187869, 33.26484],
              [46.188028, 33.26463],
              [46.188247, 33.264522],
              [46.188496, 33.264477],
              [46.188962, 33.26453],
              [46.189199, 33.264465],
              [46.189827, 33.26397],
              [46.189986, 33.262541],
              [46.189894, 33.262191],
              [46.190014, 33.261685],
              [46.190529, 33.261373],
              [46.190639, 33.261216],
              [46.19086, 33.260766],
              [46.191531, 33.259828],
              [46.191642, 33.259515],
              [46.191669, 33.25923],
              [46.191586, 33.258927],
              [46.191596, 33.258789],
              [46.191162, 33.258317],
              [46.190696, 33.258338],
              [46.190376, 33.258213],
              [46.189845, 33.257739],
              [46.189334, 33.257734],
              [46.189229, 33.257605],
              [46.188976, 33.257611],
              [46.188887, 33.257519],
              [46.18883, 33.257358],
              [46.188652, 33.25722],
              [46.188603, 33.257063],
              [46.188629, 33.256928],
              [46.188562, 33.256684],
              [46.188676, 33.256521],
              [46.188813, 33.256462],
              [46.188972, 33.256462],
              [46.189103, 33.256381],
              [46.189245, 33.255992],
              [46.189345, 33.255939],
              [46.189484, 33.255983],
              [46.189566, 33.255956],
              [46.189866, 33.255493],
              [46.190007, 33.255405],
              [46.190342, 33.25535],
              [46.190663, 33.25515],
              [46.190896, 33.254909],
              [46.190931, 33.254806],
              [46.190855, 33.254666],
              [46.190719, 33.254519],
              [46.190173, 33.25443],
              [46.190004, 33.254466],
              [46.189854, 33.254823],
              [46.189446, 33.254936],
              [46.189232, 33.254901],
              [46.189119, 33.254745],
              [46.189039, 33.254474],
              [46.189067, 33.254344],
              [46.189372, 33.254227],
              [46.189414, 33.2541],
              [46.189372, 33.253925],
              [46.188979, 33.253142],
              [46.188843, 33.253109],
              [46.188685, 33.25316],
              [46.188522, 33.253332],
              [46.18828, 33.253472],
              [46.188159, 33.253471],
              [46.188046, 33.253406],
              [46.188002, 33.253295],
              [46.18815, 33.252858],
              [46.188125, 33.252766],
              [46.187827, 33.252655],
              [46.187794, 33.252581],
              [46.187964, 33.252294],
              [46.187964, 33.252134],
              [46.187883, 33.252024],
              [46.187748, 33.251974],
              [46.187377, 33.252058],
              [46.187243, 33.252036],
              [46.187204, 33.251987],
              [46.187223, 33.251869],
              [46.187322, 33.251743],
              [46.187841, 33.251383],
              [46.18792, 33.251232],
              [46.187916, 33.250914],
              [46.187983, 33.25081],
              [46.188618, 33.250525],
              [46.188621, 33.250394],
              [46.18849, 33.25015],
              [46.188549, 33.250065],
              [46.188666, 33.250027],
              [46.189027, 33.250065],
              [46.189109, 33.250016],
              [46.189008, 33.249624],
              [46.189057, 33.249433],
              [46.189017, 33.249287],
              [46.18864, 33.249002],
              [46.188618, 33.248852],
              [46.188754, 33.248674],
              [46.18878, 33.248515],
              [46.188678, 33.248329],
              [46.188699, 33.248194],
              [46.188881, 33.248093],
              [46.188928, 33.247868],
              [46.188688, 33.247434],
              [46.188745, 33.247332],
              [46.187525, 33.243189],
              [46.187508, 33.242966],
              [46.187604, 33.242852],
              [46.188098, 33.24282],
              [46.188121, 33.242742],
              [46.188066, 33.242633],
              [46.187717, 33.242547],
              [46.187615, 33.242452],
              [46.187632, 33.242375],
              [46.187741, 33.242309],
              [46.188099, 33.242222],
              [46.188119, 33.241968],
              [46.188188, 33.241893],
              [46.187981, 33.241743],
              [46.187969, 33.241631],
              [46.188049, 33.24148],
              [46.188199, 33.241356],
              [46.188243, 33.241212],
              [46.188387, 33.241089],
              [46.18853, 33.241052],
              [46.18873, 33.241107],
              [46.188905, 33.241075],
              [46.189088, 33.240974],
              [46.189171, 33.240675],
              [46.189185, 33.240376],
              [46.189407, 33.240348],
              [46.189584, 33.240253],
              [46.189679, 33.240111],
              [46.189719, 33.239887],
              [46.190419, 33.239744],
              [46.190786, 33.239713],
              [46.190883, 33.239741],
              [46.190881, 33.240105],
              [46.190984, 33.240155],
              [46.191075, 33.240139],
              [46.191237, 33.240013],
              [46.191577, 33.239906],
              [46.191469, 33.239601],
              [46.191571, 33.239395],
              [46.191711, 33.239279],
              [46.191803, 33.23929],
              [46.191932, 33.239666],
              [46.192001, 33.239687],
              [46.19226, 33.239561],
              [46.192494, 33.239508],
              [46.192553, 33.239469],
              [46.192433, 33.239171],
              [46.192485, 33.239105],
              [46.192766, 33.238992],
              [46.192827, 33.238611],
              [46.193356, 33.238567],
              [46.193522, 33.238383],
              [46.193588, 33.23795],
              [46.193407, 33.237499],
              [46.193258, 33.237349],
              [46.193021, 33.237227],
              [46.192859, 33.236801],
              [46.192856, 33.236579],
              [46.192355, 33.235889],
              [46.192295, 33.235462],
              [46.192332, 33.235296],
              [46.192159, 33.234991],
              [46.192126, 33.234798],
              [46.192158, 33.23457],
              [46.192279, 33.234383],
              [46.192413, 33.234012],
              [46.192171, 33.233293],
              [46.192255, 33.233181],
              [46.192161, 33.232907],
              [46.192178, 33.232807],
              [46.192297, 33.232706],
              [46.192319, 33.232554],
              [46.192137, 33.231938],
              [46.191937, 33.231695],
              [46.191999, 33.231456],
              [46.191755, 33.231102],
              [46.191856, 33.230867],
              [46.191856, 33.230565],
              [46.192163, 33.230499],
              [46.192235, 33.230435],
              [46.192236, 33.230349],
              [46.192181, 33.230262],
              [46.191863, 33.230149],
              [46.191723, 33.229895],
              [46.19152, 33.229732],
              [46.191516, 33.229511],
              [46.191288, 33.229233],
              [46.191059, 33.228654],
              [46.190696, 33.228121],
              [46.19033, 33.227948],
              [46.189727, 33.227931],
              [46.189576, 33.22789],
              [46.189462, 33.227638],
              [46.189341, 33.227591],
              [46.189155, 33.227585],
              [46.188909, 33.227709],
              [46.188566, 33.227759],
              [46.188457, 33.227665],
              [46.188018, 33.22755],
              [46.187754, 33.227421],
              [46.187573, 33.227368],
              [46.187308, 33.227376],
              [46.187147, 33.227206],
              [46.186776, 33.227153],
              [46.186487, 33.227028],
              [46.186006, 33.226944],
              [46.185676, 33.226742],
              [46.185587, 33.226348],
              [46.185331, 33.225899],
              [46.185354, 33.225473],
              [46.185028, 33.225168],
              [46.184871, 33.224735],
              [46.184923, 33.224412],
              [46.184748, 33.223726],
              [46.18467, 33.223604],
              [46.184325, 33.223461],
              [46.184009, 33.222749],
              [46.183633, 33.222379],
              [46.18331, 33.221708],
              [46.182929, 33.221202],
              [46.182785, 33.220818],
              [46.182744, 33.220204],
              [46.182696, 33.220099],
              [46.182562, 33.220004],
              [46.182387, 33.219688],
              [46.182397, 33.219333],
              [46.182791, 33.21854],
              [46.183078, 33.218154],
              [46.183657, 33.217732],
              [46.184062, 33.217294],
              [46.184194, 33.216776],
              [46.184414, 33.216348],
              [46.18507, 33.215638],
              [46.185245, 33.215066],
              [46.185357, 33.214808],
              [46.185552, 33.214599],
              [46.185724, 33.214086],
              [46.186071, 33.213623],
              [46.186304, 33.213146],
              [46.186616, 33.212742],
              [46.186981, 33.212131],
              [46.186872, 33.211801],
              [46.186274, 33.210931],
              [46.186249, 33.210767],
              [46.186331, 33.210497],
              [46.186312, 33.210186],
              [46.186239, 33.209967],
              [46.186122, 33.209842],
              [46.185476, 33.209538],
              [46.18451, 33.209175],
              [46.184139, 33.209142],
              [46.18385, 33.209176],
              [46.183666, 33.209308],
              [46.18343, 33.209751],
              [46.183284, 33.209881],
              [46.183061, 33.209944],
              [46.182637, 33.209979],
              [46.182352, 33.20993],
              [46.182079, 33.209781],
              [46.181918, 33.209641],
              [46.181853, 33.209473],
              [46.181917, 33.208467],
              [46.181835, 33.208308],
              [46.181594, 33.208135],
              [46.181222, 33.207957],
              [46.180927, 33.20773],
              [46.180599, 33.207306],
              [46.180548, 33.207071],
              [46.180584, 33.206344],
              [46.180683, 33.206065],
              [46.180822, 33.205907],
              [46.181573, 33.2055],
              [46.181738, 33.205203],
              [46.182103, 33.2049],
              [46.183233, 33.20422],
              [46.197343, 33.201279],
              [46.205533, 33.202433],
              [46.214986, 33.203587],
              [46.215438, 33.203438],
              [46.215605, 33.203216],
              [46.21552, 33.203069],
              [46.214884, 33.202682],
              [46.214819, 33.202513],
              [46.214041, 33.201576],
              [46.213915, 33.201017],
              [46.213797, 33.200794],
              [46.213622, 33.200604],
              [46.213472, 33.200503],
              [46.213145, 33.200445],
              [46.212649, 33.200236],
              [46.212484, 33.200248],
              [46.212286, 33.200353],
              [46.211769, 33.200404],
              [46.211559, 33.200395],
              [46.211492, 33.200267],
              [46.211529, 33.200069],
              [46.211447, 33.199694],
              [46.211475, 33.199608],
              [46.211614, 33.199595],
              [46.212062, 33.199312],
              [46.212461, 33.19866],
              [46.212366, 33.19802],
              [46.212346, 33.197072],
              [46.211971, 33.197043],
              [46.210848, 33.197103],
              [46.209393, 33.197275],
              [46.208911, 33.197238],
              [46.208547, 33.197117],
              [46.208216, 33.196873],
              [46.207907, 33.19676],
              [46.207416, 33.196789],
              [46.206804, 33.196653],
              [46.206275, 33.196422],
              [46.205739, 33.196116],
              [46.205312, 33.195785],
              [46.205022, 33.195453],
              [46.204883, 33.195036],
              [46.204759, 33.194842],
              [46.204015, 33.194626],
              [46.203057, 33.194029],
              [46.202108, 33.193633],
              [46.199953, 33.192441],
              [46.198729, 33.192007],
              [46.198319, 33.191737],
              [46.198122, 33.191371],
              [46.19806, 33.191045],
              [46.198132, 33.190282],
              [46.198115, 33.189693],
              [46.198182, 33.189274],
              [46.198333, 33.188875],
              [46.199255, 33.187787],
              [46.19934, 33.187406],
              [46.199361, 33.186861],
              [46.199276, 33.186429],
              [46.19901, 33.185686],
              [46.198294, 33.183953],
              [46.198186, 33.183577],
              [46.198193, 33.182982],
              [46.198079, 33.182538],
              [46.197528, 33.181554],
              [46.196846, 33.18078],
              [46.196626, 33.180616],
              [46.196337, 33.180551],
              [46.195158, 33.180429],
              [46.194346, 33.180393],
              [46.193847, 33.180319],
              [46.193436, 33.180142],
              [46.19182, 33.179889],
              [46.191203, 33.179737],
              [46.189447, 33.179014],
              [46.188777, 33.178691],
              [46.188271, 33.178519],
              [46.186831, 33.177601],
              [46.186203, 33.17698],
              [46.184972, 33.175373],
              [46.184332, 33.173348],
              [46.18377, 33.172466],
              [46.18335, 33.171918],
              [46.183143, 33.171467],
              [46.182367, 33.170611],
              [46.182039, 33.170378],
              [46.181568, 33.170241],
              [46.181215, 33.170013],
              [46.180844, 33.16955],
              [46.180607, 33.169156],
              [46.180273, 33.16878],
              [46.179987, 33.168325],
              [46.179969, 33.168089],
              [46.180028, 33.167806],
              [46.18057, 33.167012],
              [46.180611, 33.166348],
              [46.180485, 33.166074],
              [46.179324, 33.165088],
              [46.178338, 33.164578],
              [46.177856, 33.16421],
              [46.176863, 33.163171],
              [46.176611, 33.162623],
              [46.176363, 33.161447],
              [46.176149, 33.161037],
              [46.175782, 33.160783],
              [46.174883, 33.160378],
              [46.17363, 33.159671],
              [46.172986, 33.15928],
              [46.172557, 33.15896],
              [46.171865, 33.15863],
              [46.171016, 33.15767],
              [46.170327, 33.157444],
              [46.169729, 33.157103],
              [46.169254, 33.157094],
              [46.168924, 33.157019],
              [46.168739, 33.156912],
              [46.167859, 33.155505],
              [46.167468, 33.155185],
              [46.16714, 33.154546],
              [46.166877, 33.15422],
              [46.166601, 33.15399],
              [46.166451, 33.153674],
              [46.166058, 33.153325],
              [46.165645, 33.153091],
              [46.165102, 33.152902],
              [46.164662, 33.152829],
              [46.164397, 33.15283],
              [46.163148, 33.153191],
              [46.162348, 33.153107],
              [46.161463, 33.152636],
              [46.161286, 33.152604],
              [46.160924, 33.152435],
              [46.160677, 33.152218],
              [46.159978, 33.151406],
              [46.15977, 33.150804],
              [46.159742, 33.150344],
              [46.159731, 33.149991],
              [46.159944, 33.14925],
              [46.159903, 33.148263],
              [46.159841, 33.147914],
              [46.159589, 33.147252],
              [46.159262, 33.146944],
              [46.159031, 33.146614],
              [46.158892, 33.146252],
              [46.158854, 33.145889],
              [46.158859, 33.145618],
              [46.159211, 33.144786],
              [46.159477, 33.143749],
              [46.159525, 33.143377],
              [46.159462, 33.143062],
              [46.159296, 33.142694],
              [46.158474, 33.142277],
              [46.158096, 33.141967],
              [46.15741, 33.141544],
              [46.155484, 33.140682],
              [46.154868, 33.140379],
              [46.154548, 33.140147],
              [46.154415, 33.139756],
              [46.154124, 33.13937],
              [46.153567, 33.138908],
              [46.153338, 33.13854],
              [46.153116, 33.137905],
              [46.152926, 33.137662],
              [46.151543, 33.136988],
              [46.151213, 33.13667],
              [46.151126, 33.136458],
              [46.151179, 33.136152],
              [46.151072, 33.13574],
              [46.15023, 33.135178],
              [46.150064, 33.134909],
              [46.150079, 33.134625],
              [46.150014, 33.134399],
              [46.149808, 33.13412],
              [46.149506, 33.133835],
              [46.149088, 33.133565],
              [46.148394, 33.132917],
              [46.146658, 33.132028],
              [46.146284, 33.131905],
              [46.145962, 33.131496],
              [46.145651, 33.131395],
              [46.145394, 33.131378],
              [46.144558, 33.131516],
              [46.144079, 33.131547],
              [46.143475, 33.131485],
              [46.142814, 33.13135],
              [46.142373, 33.13121],
              [46.141871, 33.130932],
              [46.141572, 33.130707],
              [46.141375, 33.130388],
              [46.141111, 33.130202],
              [46.140076, 33.129965],
              [46.139795, 33.129809],
              [46.139355, 33.129504],
              [46.138669, 33.12891],
              [46.138087, 33.128254],
              [46.137781, 33.128174],
              [46.137507, 33.128187],
              [46.137202, 33.128134],
              [46.137001, 33.12797],
              [46.136675, 33.126791],
              [46.136691, 33.126006],
              [46.136643, 33.125264],
              [46.136515, 33.124922],
              [46.136116, 33.124505],
              [46.135115, 33.123915],
              [46.134744, 33.123802],
              [46.134363, 33.123746],
              [46.133939, 33.123504],
              [46.133792, 33.123353],
              [46.133143, 33.123022],
              [46.132979, 33.122852],
              [46.13259, 33.122814],
              [46.131108, 33.123072],
              [46.130685, 33.123073],
              [46.130212, 33.122982],
              [46.129979, 33.122862],
              [46.129314, 33.122204],
              [46.128854, 33.121483],
              [46.12859, 33.121297],
              [46.128093, 33.120698],
              [46.127855, 33.120127],
              [46.12766, 33.120011],
              [46.127131, 33.119848],
              [46.126926, 33.119596],
              [46.126569, 33.119001],
              [46.126539, 33.118742],
              [46.126743, 33.118238],
              [46.125454, 33.11708],
              [46.124974, 33.116986],
              [46.124116, 33.116895],
              [46.123875, 33.116672],
              [46.123716, 33.116428],
              [46.123581, 33.116005],
              [46.123463, 33.115893],
              [46.123236, 33.115821],
              [46.122731, 33.115996],
              [46.122681, 33.116192],
              [46.122794, 33.116696],
              [46.122741, 33.116904],
              [46.12255, 33.117168],
              [46.122304, 33.117364],
              [46.121957, 33.117484],
              [46.121696, 33.117528],
              [46.121359, 33.11747],
              [46.120803, 33.117278],
              [46.120356, 33.117189],
              [46.119847, 33.116934],
              [46.119545, 33.116721],
              [46.119352, 33.11649],
              [46.119253, 33.116231],
              [46.119269, 33.11593],
              [46.119196, 33.115579],
              [46.1191, 33.11538],
              [46.118899, 33.115145],
              [46.118584, 33.114928],
              [46.118323, 33.114824],
              [46.118063, 33.114797],
              [46.117769, 33.11488],
              [46.11753, 33.114888],
              [46.115952, 33.114776],
              [46.115363, 33.114915],
              [46.11428, 33.114929],
              [46.113899, 33.115022],
              [46.113201, 33.1154],
              [46.11272, 33.116],
              [46.1125, 33.116126],
              [46.111529, 33.116887],
              [46.109862, 33.118031],
              [46.109047, 33.118446],
              [46.108693, 33.118931],
              [46.108699, 33.119266],
              [46.108827, 33.119636],
              [46.108802, 33.120048],
              [46.108695, 33.120413],
              [46.108137, 33.120916],
              [46.107854, 33.121307],
              [46.107716, 33.121942],
              [46.107742, 33.122379],
              [46.107698, 33.122601],
              [46.107488, 33.122786],
              [46.106891, 33.123163],
              [46.106685, 33.123248],
              [46.1065, 33.123241],
              [46.105944, 33.123071],
              [46.10528, 33.122997],
              [46.10512, 33.12287],
              [46.104845, 33.122421],
              [46.104169, 33.122034],
              [46.103763, 33.121883],
              [46.10134, 33.121657],
              [46.101038, 33.121687],
              [46.100738, 33.121798],
              [46.100516, 33.121941],
              [46.100402, 33.122131],
              [46.10002, 33.122439],
              [46.099535, 33.122202],
              [46.098619, 33.12189],
              [46.098055, 33.12181],
              [46.096854, 33.121425],
              [46.096391, 33.121322],
              [46.0954, 33.121204],
              [46.094771, 33.120975],
              [46.094336, 33.120735],
              [46.093556, 33.120146],
              [46.092916, 33.119583],
              [46.092668, 33.119482],
              [46.092267, 33.119424],
              [46.091605, 33.119454],
              [46.089846, 33.119059],
              [46.089646, 33.119116],
              [46.089435, 33.119251],
              [46.089299, 33.119506],
              [46.089305, 33.120183],
              [46.089071, 33.120471],
              [46.088767, 33.12076],
              [46.0879, 33.121337],
              [46.087633, 33.121454],
              [46.086626, 33.121544],
              [46.085983, 33.121791],
              [46.085721, 33.121974],
              [46.085432, 33.122321],
              [46.084599, 33.122711],
              [46.084131, 33.122835],
              [46.083685, 33.123038],
              [46.083187, 33.123189],
              [46.082481, 33.123221],
              [46.082132, 33.123143],
              [46.081772, 33.123143],
              [46.081209, 33.123284],
              [46.080975, 33.123456],
              [46.080266, 33.124227],
              [46.080015, 33.124402],
              [46.079666, 33.124517],
              [46.078178, 33.124848],
              [46.077295, 33.124806],
              [46.076973, 33.124662],
              [46.076752, 33.124204],
              [46.075791, 33.123839],
              [46.075158, 33.123666],
              [46.074561, 33.123585],
              [46.074087, 33.123606],
              [46.073807, 33.123698],
              [46.073637, 33.12382],
              [46.073541, 33.123986],
              [46.07351, 33.124184],
              [46.07357, 33.124581],
              [46.073467, 33.124742],
              [46.07252, 33.125521],
              [46.072348, 33.12581],
              [46.072116, 33.126059],
              [46.07176, 33.12629],
              [46.070415, 33.126806],
              [46.069898, 33.126933],
              [46.067836, 33.12712],
              [46.067099, 33.126959],
              [46.066592, 33.126665],
              [46.066366, 33.126114],
              [46.065926, 33.125445],
              [46.06575, 33.125039],
              [46.065671, 33.12476],
              [46.065694, 33.124558],
              [46.065642, 33.124335],
              [46.065542, 33.124171],
              [46.065402, 33.124068],
              [46.065207, 33.124024],
              [46.064716, 33.124129],
              [46.063284, 33.124214],
              [46.062633, 33.124165],
              [46.062092, 33.124054],
              [46.061519, 33.124063],
              [46.059988, 33.124396],
              [46.059222, 33.124703],
              [46.058826, 33.12498],
              [46.058553, 33.125098],
              [46.057315, 33.125293],
              [46.055127, 33.125992],
              [46.054541, 33.12624],
              [46.054174, 33.126507],
              [46.05386, 33.126853],
              [46.053639, 33.127304],
              [46.0531735, 33.1282554],
              [46.0513656, 33.1232271],
              [46.0504823, 33.1207269],
              [46.0491399, 33.1169659],
              [46.046832, 33.11135],
              [46.04037, 33.094539],
              [46.04071, 33.094524],
              [46.040996, 33.094288],
              [46.041245, 33.094538],
              [46.041634, 33.094334],
              [46.041757, 33.094346],
              [46.041841, 33.094475],
              [46.041971, 33.094535],
              [46.042122, 33.094532],
              [46.042239, 33.094473],
              [46.042301, 33.094347],
              [46.042471, 33.094296],
              [46.042541, 33.094102],
              [46.042634, 33.094047],
              [46.04284, 33.094062],
              [46.043047, 33.09401],
              [46.043214, 33.093899],
              [46.043577, 33.093837],
              [46.04369, 33.093591],
              [46.04399, 33.093529],
              [46.044161, 33.093528],
              [46.044197, 33.093692],
              [46.044063, 33.093809],
              [46.044013, 33.093955],
              [46.044354, 33.094316],
              [46.044634, 33.094274],
              [46.044988, 33.094302],
              [46.045823, 33.09406],
              [46.04595, 33.093895],
              [46.045971, 33.093781],
              [46.046537, 33.093525],
              [46.046744, 33.093522],
              [46.047461, 33.093362],
              [46.04758, 33.093479],
              [46.047836, 33.093441],
              [46.048062, 33.093507],
              [46.048116, 33.093619],
              [46.04821, 33.093664],
              [46.048353, 33.093678],
              [46.048537, 33.093608],
              [46.048702, 33.093613],
              [46.048853, 33.093923],
              [46.04895, 33.094006],
              [46.049193, 33.093871],
              [46.049388, 33.093843],
              [46.050059, 33.094087],
              [46.05022, 33.094269],
              [46.051022, 33.094364],
              [46.051585, 33.094146],
              [46.051761, 33.093973],
              [46.051864, 33.093763],
              [46.051863, 33.093592],
              [46.051767, 33.093366],
              [46.051817, 33.093219],
              [46.052221, 33.092974],
              [46.052295, 33.092631],
              [46.052493, 33.092564],
              [46.052671, 33.092423],
              [46.052799, 33.092115],
              [46.053117, 33.092049],
              [46.053416, 33.091888],
              [46.053464, 33.091759],
              [46.053966, 33.091524],
              [46.054159, 33.091442],
              [46.054594, 33.091533],
              [46.054904, 33.091656],
              [46.055082, 33.091538],
              [46.055316, 33.091564],
              [46.055866, 33.091272],
              [46.0561, 33.091078],
              [46.056289, 33.091029],
              [46.056331, 33.090851],
              [46.056471, 33.090661],
              [46.056693, 33.090469],
              [46.056945, 33.090393],
              [46.057076, 33.090288],
              [46.057509, 33.090352],
              [46.058233, 33.090289],
              [46.058455, 33.090417],
              [46.058615, 33.090445],
              [46.059279, 33.090232],
              [46.059654, 33.090212],
              [46.059813, 33.09029],
              [46.059972, 33.090268],
              [46.060142, 33.090074],
              [46.060208, 33.089914],
              [46.060317, 33.089823],
              [46.060471, 33.089786],
              [46.060541, 33.089592],
              [46.060837, 33.089564],
              [46.061056, 33.089603],
              [46.061449, 33.089558],
              [46.061573, 33.089455],
              [46.061691, 33.089446],
              [46.061801, 33.089647],
              [46.061931, 33.089735],
              [46.062318, 33.089835],
              [46.062523, 33.089993],
              [46.062913, 33.090081],
              [46.06365, 33.089806],
              [46.064043, 33.089833],
              [46.064104, 33.089971],
              [46.064267, 33.090015],
              [46.064449, 33.089984],
              [46.06478, 33.089701],
              [46.065061, 33.089907],
              [46.065128, 33.090359],
              [46.065419, 33.090458],
              [46.065151, 33.091005],
              [46.065189, 33.091175],
              [46.065578, 33.091428],
              [46.065735, 33.091594],
              [46.066276, 33.091657],
              [46.066659, 33.091624],
              [46.066838, 33.091704],
              [46.067382, 33.091584],
              [46.067502, 33.091414],
              [46.067661, 33.091371],
              [46.06824, 33.091382],
              [46.068461, 33.091262],
              [46.068552, 33.090982],
              [46.068766, 33.090879],
              [46.069168, 33.090921],
              [46.069592, 33.090606],
              [46.069817, 33.090573],
              [46.070018, 33.090445],
              [46.070102, 33.090331],
              [46.070443, 33.090185],
              [46.070517, 33.089985],
              [46.070767, 33.089854],
              [46.070772, 33.089655],
              [46.070868, 33.089489],
              [46.070899, 33.089269],
              [46.071251, 33.089093],
              [46.07185, 33.089206],
              [46.072025, 33.089127],
              [46.072188, 33.089121],
              [46.072365, 33.089317],
              [46.072573, 33.089336],
              [46.072741, 33.089423],
              [46.073253, 33.089424],
              [46.073401, 33.089531],
              [46.073442, 33.08964],
              [46.073624, 33.089802],
              [46.07348, 33.089953],
              [46.073451, 33.090085],
              [46.073484, 33.090333],
              [46.073582, 33.090465],
              [46.074049, 33.090656],
              [46.074163, 33.090802],
              [46.074511, 33.090924],
              [46.074741, 33.090885],
              [46.074826, 33.09092],
              [46.07482, 33.091042],
              [46.074898, 33.091172],
              [46.075011, 33.091219],
              [46.075469, 33.09118],
              [46.075625, 33.091269],
              [46.075694, 33.091439],
              [46.07582, 33.091483],
              [46.076521, 33.091022],
              [46.076695, 33.091108],
              [46.076884, 33.091104],
              [46.077075, 33.090966],
              [46.077379, 33.09087],
              [46.077742, 33.09083],
              [46.07798, 33.090729],
              [46.078208, 33.090365],
              [46.078493, 33.090101],
              [46.078969, 33.090059],
              [46.079259, 33.089838],
              [46.079337, 33.089704],
              [46.07969, 33.089627],
              [46.079793, 33.089659],
              [46.079911, 33.089892],
              [46.080026, 33.089945],
              [46.080262, 33.089904],
              [46.080507, 33.090044],
              [46.080662, 33.090079],
              [46.080788, 33.09003],
              [46.080873, 33.089872],
              [46.081025, 33.089802],
              [46.081135, 33.08981],
              [46.081265, 33.089992],
              [46.081371, 33.090349],
              [46.081836, 33.090556],
              [46.082013, 33.090559],
              [46.082226, 33.090815],
              [46.082451, 33.090975],
              [46.082939, 33.09103],
              [46.083214, 33.090994],
              [46.083338, 33.091177],
              [46.083619, 33.091261],
              [46.083756, 33.091397],
              [46.084369, 33.091497],
              [46.084754, 33.091227],
              [46.084971, 33.091212],
              [46.086144, 33.090742],
              [46.086347, 33.090768],
              [46.086453, 33.090667],
              [46.086487, 33.090457],
              [46.086834, 33.090283],
              [46.08717, 33.089586],
              [46.087295, 33.089437],
              [46.087516, 33.08929],
              [46.087727, 33.088961],
              [46.087948, 33.088885],
              [46.088148, 33.088879],
              [46.088489, 33.08849],
              [46.088445, 33.088222],
              [46.088907, 33.088032],
              [46.089013, 33.087904],
              [46.08905, 33.087732],
              [46.08868, 33.087333],
              [46.088812, 33.087255],
              [46.088844, 33.086897],
              [46.08893, 33.08686],
              [46.089536, 33.08669],
              [46.089785, 33.086868],
              [46.089766, 33.086987],
              [46.09002, 33.087258],
              [46.090252, 33.087324],
              [46.090502, 33.087336],
              [46.091145, 33.087574],
              [46.091085, 33.087804],
              [46.091126, 33.087913],
              [46.091488, 33.087967],
              [46.09169, 33.087916],
              [46.091908, 33.087928],
              [46.09244, 33.088152],
              [46.092664, 33.088136],
              [46.092771, 33.088377],
              [46.093167, 33.08837],
              [46.09348, 33.08809],
              [46.093769, 33.088135],
              [46.093938, 33.088078],
              [46.094334, 33.087878],
              [46.094458, 33.08772],
              [46.094617, 33.087654],
              [46.094935, 33.087611],
              [46.095252, 33.087446],
              [46.09544, 33.087172],
              [46.09565, 33.087058],
              [46.095798, 33.086631],
              [46.096085, 33.086472],
              [46.096182, 33.086334],
              [46.09637, 33.086329],
              [46.096632, 33.086411],
              [46.096909, 33.086116],
              [46.097054, 33.085827],
              [46.09722, 33.085782],
              [46.097223, 33.0856],
              [46.097331, 33.08546],
              [46.097546, 33.085385],
              [46.09761, 33.085026],
              [46.098044, 33.084991],
              [46.098202, 33.085184],
              [46.098324, 33.085241],
              [46.098528, 33.08525],
              [46.099139, 33.084997],
              [46.099372, 33.084775],
              [46.099376, 33.084648],
              [46.09981, 33.08464],
              [46.09985, 33.084743],
              [46.1001, 33.084998],
              [46.100254, 33.085033],
              [46.100403, 33.085024],
              [46.100496, 33.084942],
              [46.100695, 33.084979],
              [46.100865, 33.084951],
              [46.101108, 33.0846],
              [46.10127, 33.08454],
              [46.101559, 33.084535],
              [46.101715, 33.084695],
              [46.101903, 33.084641],
              [46.101999, 33.084548],
              [46.102223, 33.084559],
              [46.102406, 33.084412],
              [46.102402, 33.084253],
              [46.102568, 33.084092],
              [46.102803, 33.083997],
              [46.103189, 33.083926],
              [46.103516, 33.083776],
              [46.103607, 33.08381],
              [46.103793, 33.084423],
              [46.10392, 33.084523],
              [46.104152, 33.084539],
              [46.104535, 33.084435],
              [46.105142, 33.08453],
              [46.105332, 33.084459],
              [46.105465, 33.084243],
              [46.105678, 33.084113],
              [46.106312, 33.084098],
              [46.106496, 33.084028],
              [46.10669, 33.083609],
              [46.106647, 33.083468],
              [46.106851, 33.082992],
              [46.106786, 33.082838],
              [46.106609, 33.082791],
              [46.106496, 33.082695],
              [46.106599, 33.082484],
              [46.106601, 33.082032],
              [46.106651, 33.081885],
              [46.107008, 33.081753],
              [46.10718, 33.081586],
              [46.10729, 33.081016],
              [46.107465, 33.080914],
              [46.107654, 33.080887],
              [46.107834, 33.081066],
              [46.108284, 33.080901],
              [46.108689, 33.080832],
              [46.108784, 33.080733],
              [46.109135, 33.080602],
              [46.109814, 33.080127],
              [46.109868, 33.079633],
              [46.109978, 33.079471],
              [46.110158, 33.079484],
              [46.110254, 33.079584],
              [46.111022, 33.079767],
              [46.111508, 33.079717],
              [46.111993, 33.079563],
              [46.112135, 33.079428],
              [46.112304, 33.07935],
              [46.112413, 33.079381],
              [46.112589, 33.079621],
              [46.112732, 33.079635],
              [46.112908, 33.079511],
              [46.113032, 33.07933],
              [46.113129, 33.078977],
              [46.113492, 33.07843],
              [46.113742, 33.078178],
              [46.113761, 33.077982],
              [46.113719, 33.077824],
              [46.113646, 33.077759],
              [46.113746, 33.077516],
              [46.113668, 33.077359],
              [46.113774, 33.077208],
              [46.113994, 33.077083],
              [46.11419, 33.077011],
              [46.114356, 33.077015],
              [46.114707, 33.076862],
              [46.114968, 33.076624],
              [46.115087, 33.076428],
              [46.115118, 33.075943],
              [46.115015, 33.075839],
              [46.114816, 33.075779],
              [46.114858, 33.075381],
              [46.115145, 33.074726],
              [46.115549, 33.074518],
              [46.115754, 33.07446],
              [46.115682, 33.074179],
              [46.115838, 33.074113],
              [46.116232, 33.074151],
              [46.116455, 33.074101],
              [46.116518, 33.073951],
              [46.116439, 33.073765],
              [46.116507, 33.07354],
              [46.117045, 33.073243],
              [46.117229, 33.073246],
              [46.117825, 33.073483],
              [46.117946, 33.073486],
              [46.118013, 33.073334],
              [46.1181, 33.073264],
              [46.118301, 33.07329],
              [46.118438, 33.073186],
              [46.118709, 33.073144],
              [46.118998, 33.073177],
              [46.119192, 33.073027],
              [46.11964, 33.073026],
              [46.119804, 33.072871],
              [46.119872, 33.072526],
              [46.119977, 33.072484],
              [46.120088, 33.072519],
              [46.120378, 33.072506],
              [46.120666, 33.072242],
              [46.12108, 33.072126],
              [46.121729, 33.072151],
              [46.121939, 33.072041],
              [46.122207, 33.07201],
              [46.122415, 33.071921],
              [46.122792, 33.072009],
              [46.122958, 33.072421],
              [46.123206, 33.072717],
              [46.123341, 33.072754],
              [46.123501, 33.07263],
              [46.123628, 33.07261],
              [46.124291, 33.072863],
              [46.124813, 33.072887],
              [46.124947, 33.073018],
              [46.125126, 33.073095],
              [46.125204, 33.073229],
              [46.12569, 33.073269],
              [46.126144, 33.073465],
              [46.12672, 33.073475],
              [46.126958, 33.073533],
              [46.127064, 33.073668],
              [46.127433, 33.0737],
              [46.127697, 33.073941],
              [46.127999, 33.07403],
              [46.128239, 33.073998],
              [46.128394, 33.073854],
              [46.128947, 33.073717],
              [46.129284, 33.073733],
              [46.129422, 33.073858],
              [46.129619, 33.073864],
              [46.129751, 33.073959],
              [46.130314, 33.074034],
              [46.130354, 33.074106],
              [46.131133, 33.074075],
              [46.131318, 33.074036],
              [46.131521, 33.073895],
              [46.131881, 33.073839],
              [46.132034, 33.073758],
              [46.132158, 33.073604],
              [46.13234, 33.073184],
              [46.132167, 33.073059],
              [46.132205, 33.073001],
              [46.132555, 33.072906],
              [46.13275, 33.072735],
              [46.132789, 33.072583],
              [46.13305, 33.072569],
              [46.133287, 33.072454],
              [46.133567, 33.072447],
              [46.133801, 33.072348],
              [46.134319, 33.072378],
              [46.134524, 33.072347],
              [46.134648, 33.072265],
              [46.134716, 33.072114],
              [46.135067, 33.071898],
              [46.135207, 33.071981],
              [46.135569, 33.072029],
              [46.135777, 33.07182],
              [46.13597, 33.071811],
              [46.136168, 33.071916],
              [46.136269, 33.071859],
              [46.136342, 33.071733],
              [46.136361, 33.071568],
              [46.136751, 33.071618],
              [46.136898, 33.071532],
              [46.13716, 33.071596],
              [46.137313, 33.071515],
              [46.137598, 33.071727],
              [46.138031, 33.071812],
              [46.138872, 33.071578],
              [46.13939, 33.07166],
              [46.139546, 33.071589],
              [46.139916, 33.0716],
              [46.140173, 33.071545],
              [46.140601, 33.071583],
              [46.141056, 33.071325],
              [46.141114, 33.071107],
              [46.141216, 33.070956],
              [46.141351, 33.07092],
              [46.141508, 33.070953],
              [46.141571, 33.071074],
              [46.141774, 33.071157],
              [46.141994, 33.071165],
              [46.142443, 33.07095],
              [46.143761, 33.071425],
              [46.143972, 33.071398],
              [46.144157, 33.071427],
              [46.144241, 33.071294],
              [46.144417, 33.071215],
              [46.145557, 33.070987],
              [46.145956, 33.070951],
              [46.146221, 33.070686],
              [46.146408, 33.070605],
              [46.147037, 33.070571],
              [46.147089, 33.070474],
              [46.147573, 33.070384],
              [46.147877, 33.070431],
              [46.148127, 33.07081],
              [46.148362, 33.070931],
              [46.148436, 33.071269],
              [46.148631, 33.071317],
              [46.148679, 33.071398],
              [46.148853, 33.071429],
              [46.149031, 33.071527],
              [46.149619, 33.071368],
              [46.149963, 33.071462],
              [46.150411, 33.071487],
              [46.150541, 33.07155],
              [46.150986, 33.071612],
              [46.15123, 33.071334],
              [46.151265, 33.071188],
              [46.151939, 33.071225],
              [46.152175, 33.071178],
              [46.152761, 33.071255],
              [46.152921, 33.071178],
              [46.153151, 33.071206],
              [46.153669, 33.071063],
              [46.153794, 33.071133],
              [46.153847, 33.07126],
              [46.154024, 33.071327],
              [46.154433, 33.071311],
              [46.15527, 33.071646],
              [46.155286, 33.072004],
              [46.155067, 33.072121],
              [46.155052, 33.072228],
              [46.155266, 33.072404],
              [46.155614, 33.072543],
              [46.156604, 33.072531],
              [46.15683, 33.072466],
              [46.157215, 33.07225],
              [46.157395, 33.072013],
              [46.157733, 33.07194],
              [46.157989, 33.07176],
              [46.158782, 33.071789],
              [46.158971, 33.071666],
              [46.159114, 33.071467],
              [46.159574, 33.071229],
              [46.159859, 33.070976],
              [46.160672, 33.070846],
              [46.160806, 33.07107],
              [46.161201, 33.071067],
              [46.161332, 33.071135],
              [46.161471, 33.071286],
              [46.161667, 33.071293],
              [46.162873, 33.071076],
              [46.163232, 33.070577],
              [46.16363, 33.070463],
              [46.163654, 33.070298],
              [46.163853, 33.069949],
              [46.164199, 33.069765],
              [46.164373, 33.069576],
              [46.164625, 33.069428],
              [46.164311, 33.069069],
              [46.164144, 33.06897],
              [46.164059, 33.068831],
              [46.16369, 33.068701],
              [46.163598, 33.068558],
              [46.16342, 33.068481],
              [46.163179, 33.068461],
              [46.162653, 33.06803],
              [46.16256, 33.067805],
              [46.162103, 33.067379],
              [46.161857, 33.067261],
              [46.161496, 33.066899],
              [46.160933, 33.066557],
              [46.160838, 33.066348],
              [46.16087, 33.066097],
              [46.160521, 33.065447],
              [46.159614, 33.065252],
              [46.159404, 33.065139],
              [46.159101, 33.06517],
              [46.158861, 33.065076],
              [46.158734, 33.065122],
              [46.158673, 33.065277],
              [46.158513, 33.065401],
              [46.158269, 33.065387],
              [46.158098, 33.065345],
              [46.157899, 33.06511],
              [46.157346, 33.065007],
              [46.15643, 33.065284],
              [46.156434, 33.064886],
              [46.156133, 33.064755],
              [46.155702, 33.064702],
              [46.155647, 33.064642],
              [46.155729, 33.064332],
              [46.155333, 33.063678],
              [46.155222, 33.06357],
              [46.154516, 33.063449],
              [46.154294, 33.063457],
              [46.153853, 33.063583],
              [46.153431, 33.063548],
              [46.152999, 33.063296],
              [46.152787, 33.063105],
              [46.152467, 33.062575],
              [46.151663, 33.061968],
              [46.151472, 33.061669],
              [46.151389, 33.061389],
              [46.151399, 33.061116],
              [46.151471, 33.060886],
              [46.151911, 33.060322],
              [46.152069, 33.060042],
              [46.152267, 33.05986],
              [46.152306, 33.059682],
              [46.152273, 33.05867],
              [46.152199, 33.058405],
              [46.152024, 33.058202],
              [46.151866, 33.058111],
              [46.151483, 33.058045],
              [46.150889, 33.057573],
              [46.149996, 33.057173],
              [46.149819, 33.056981],
              [46.149673, 33.056701],
              [46.149548, 33.05637],
              [46.14945, 33.055081],
              [46.149854, 33.053897],
              [46.14986, 33.053656],
              [46.149643, 33.053345],
              [46.148889, 33.05285],
              [46.148747, 33.052689],
              [46.14866, 33.052489],
              [46.148558, 33.051837],
              [46.148581, 33.051546],
              [46.148357, 33.051012],
              [46.14791, 33.050527],
              [46.147694, 33.050441],
              [46.147593, 33.050451],
              [46.147554, 33.050603],
              [46.147261, 33.05094],
              [46.146586, 33.051243],
              [46.146289, 33.051299],
              [46.146015, 33.051278],
              [46.14509, 33.050935],
              [46.144924, 33.050768],
              [46.144544, 33.050132],
              [46.14398, 33.049541],
              [46.143591, 33.049256],
              [46.14341, 33.049049],
              [46.143361, 33.048916],
              [46.143413, 33.048162],
              [46.143239, 33.047766],
              [46.142995, 33.04773],
              [46.142824, 33.047809],
              [46.142149, 33.048544],
              [46.141976, 33.048639],
              [46.141867, 33.04864],
              [46.14171, 33.048439],
              [46.141704, 33.048268],
              [46.141812, 33.047944],
              [46.141686, 33.047389],
              [46.141683, 33.047108],
              [46.141542, 33.046754],
              [46.141222, 33.046688],
              [46.139982, 33.046884],
              [46.139826, 33.046877],
              [46.139719, 33.046789],
              [46.139517, 33.046372],
              [46.139373, 33.04547],
              [46.138908, 33.043647],
              [46.138979, 33.043],
              [46.139192, 33.042127],
              [46.13919, 33.041855],
              [46.138983, 33.041292],
              [46.138476, 33.040363],
              [46.137662, 33.039372],
              [46.136929, 33.038796],
              [46.136012, 33.038217],
              [46.135728, 33.037916],
              [46.134531, 33.036979],
              [46.133808, 33.036594],
              [46.13182, 33.03583],
              [46.131667, 33.035692],
              [46.13143, 33.035275],
              [46.131322, 33.034963],
              [46.131304, 33.034569],
              [46.131387, 33.03417],
              [46.131564, 33.033824],
              [46.131962, 33.033518],
              [46.132476, 33.033261],
              [46.133059, 33.033103],
              [46.133492, 33.033068],
              [46.134634, 33.032558],
              [46.134874, 33.032333],
              [46.135108, 33.031963],
              [46.135291, 33.031549],
              [46.135376, 33.031228],
              [46.13536, 33.031037],
              [46.135287, 33.030897],
              [46.135103, 33.030727],
              [46.134298, 33.030209],
              [46.133923, 33.030006],
              [46.132879, 33.029624],
              [46.132753, 33.029529],
              [46.1323, 33.028195],
              [46.132169, 33.027954],
              [46.131454, 33.027307],
              [46.131383, 33.02713],
              [46.131363, 33.026753],
              [46.131561, 33.026425],
              [46.131818, 33.026275],
              [46.133032, 33.025848],
              [46.133265, 33.025718],
              [46.133512, 33.025451],
              [46.133729, 33.025057],
              [46.133815, 33.024715],
              [46.133727, 33.024176],
              [46.133592, 33.02392],
              [46.133351, 33.023701],
              [46.133038, 33.023541],
              [46.132628, 33.023458],
              [46.132115, 33.023474],
              [46.131191, 33.023643],
              [46.130259, 33.024],
              [46.128791, 33.023861],
              [46.128511, 33.023768],
              [46.12833, 33.023587],
              [46.128187, 33.023223],
              [46.128212, 33.023063],
              [46.128474, 33.022788],
              [46.128721, 33.02264],
              [46.130097, 33.022073],
              [46.130344, 33.021811],
              [46.130313, 33.021508],
              [46.130071, 33.021117],
              [46.129911, 33.020975],
              [46.129293, 33.020788],
              [46.128807, 33.020748],
              [46.125558, 33.020695],
              [46.125216, 33.020659],
              [46.125033, 33.020515],
              [46.124853, 33.020094],
              [46.125013, 33.018707],
              [46.124425, 33.018161],
              [46.123662, 33.017872],
              [46.123389, 33.017835],
              [46.12328, 33.017857],
              [46.123173, 33.017942],
              [46.122516, 33.018899],
              [46.122417, 33.019431],
              [46.122437, 33.020122],
              [46.122315, 33.02048],
              [46.121812, 33.020635],
              [46.121651, 33.020728],
              [46.12135, 33.021035],
              [46.120736, 33.02184],
              [46.120427, 33.022132],
              [46.11945, 33.022737],
              [46.11909, 33.022886],
              [46.118796, 33.022932],
              [46.118652, 33.022881],
              [46.118589, 33.022786],
              [46.118478, 33.021879],
              [46.118243, 33.021441],
              [46.117994, 33.020754],
              [46.11776, 33.020466],
              [46.117738, 33.020083],
              [46.117952, 33.019748],
              [46.117963, 33.019553],
              [46.117883, 33.019237],
              [46.117794, 33.019151],
              [46.117486, 33.019016],
              [46.116973, 33.018886],
              [46.11552, 33.018593],
              [46.114889, 33.018544],
              [46.114381, 33.01868],
              [46.113771, 33.018988],
              [46.113255, 33.019401],
              [46.112972, 33.019539],
              [46.112334, 33.019684],
              [46.111627, 33.019631],
              [46.111515, 33.019596],
              [46.111079, 33.01923],
              [46.111029, 33.019092],
              [46.111191, 33.018247],
              [46.111144, 33.018046],
              [46.109822, 33.017362],
              [46.109592, 33.017262],
              [46.109423, 33.017252],
              [46.108814, 33.017444],
              [46.108587, 33.01772],
              [46.108373, 33.019125],
              [46.108378, 33.020189],
              [46.108299, 33.020655],
              [46.108228, 33.020864],
              [46.108119, 33.020965],
              [46.107598, 33.021238],
              [46.106679, 33.021233],
              [46.106062, 33.021125],
              [46.105899, 33.02104],
              [46.105511, 33.020662],
              [46.105137, 33.019905],
              [46.10494, 33.019147],
              [46.104701, 33.018767],
              [46.104381, 33.018555],
              [46.104043, 33.018435],
              [46.10312, 33.018342],
              [46.102916, 33.018379],
              [46.102742, 33.018468],
              [46.102421, 33.018737],
              [46.101299, 33.019259],
              [46.100726, 33.019629],
              [46.100479, 33.020111],
              [46.100301, 33.020259],
              [46.099948, 33.020318],
              [46.099603, 33.020027],
              [46.099162, 33.019813],
              [46.098959, 33.019437],
              [46.098868, 33.019083],
              [46.099053, 33.018853],
              [46.099161, 33.018535],
              [46.099338, 33.018293],
              [46.099563, 33.018088],
              [46.100124, 33.017774],
              [46.100196, 33.017595],
              [46.100227, 33.017357],
              [46.100026, 33.016643],
              [46.099915, 33.015699],
              [46.099778, 33.015317],
              [46.099379, 33.014623],
              [46.098585, 33.01371],
              [46.097849, 33.013198],
              [46.097163, 33.012982],
              [46.096495, 33.01285],
              [46.096429, 33.012756],
              [46.096445, 33.012351],
              [46.09632, 33.011847],
              [46.096701, 33.010288],
              [46.097017, 33.009486],
              [46.096942, 33.009056],
              [46.096821, 33.008892],
              [46.096607, 33.008772],
              [46.095898, 33.008529],
              [46.095238, 33.008507],
              [46.094435, 33.008624],
              [46.093717, 33.008645],
              [46.093604, 33.008567],
              [46.093591, 33.008486],
              [46.094025, 33.007806],
              [46.094825, 33.007128],
              [46.095652, 33.006568],
              [46.09581, 33.006415],
              [46.095818, 33.006276],
              [46.095786, 33.006185],
              [46.095452, 33.005832],
              [46.095063, 33.005231],
              [46.094855, 33.005063],
              [46.09397, 33.00459],
              [46.093688, 33.004363],
              [46.09353, 33.004114],
              [46.093482, 33.003904],
              [46.093566, 33.003797],
              [46.093754, 33.003684],
              [46.094599, 33.003354],
              [46.095612, 33.003117],
              [46.098003, 33.00278],
              [46.098343, 33.00264],
              [46.098742, 33.002405],
              [46.099084, 33.002096],
              [46.099364, 33.00171],
              [46.099575, 33.001273],
              [46.099781, 33.000358],
              [46.099575, 32.999358],
              [46.099088, 32.99843],
              [46.098561, 32.99788],
              [46.097888, 32.99747],
              [46.097484, 32.997276],
              [46.09723, 32.996901],
              [46.097136, 32.996596],
              [46.097143, 32.996456],
              [46.097333, 32.996226],
              [46.097546, 32.995662],
              [46.097987, 32.995079],
              [46.098157, 32.994946],
              [46.098242, 32.994697],
              [46.098159, 32.994425],
              [46.097921, 32.994127],
              [46.096693, 32.993214],
              [46.096202, 32.992778],
              [46.096086, 32.992605],
              [46.096033, 32.992408],
              [46.09608, 32.992011],
              [46.095987, 32.991637],
              [46.096097, 32.9911],
              [46.096, 32.99053],
              [46.095939, 32.990398],
              [46.095618, 32.990106],
              [46.095442, 32.98983],
              [46.095278, 32.989431],
              [46.095135, 32.989032],
              [46.095103, 32.988767],
              [46.095147, 32.988406],
              [46.095099, 32.988063],
              [46.094033, 32.985127],
              [46.094107, 32.984979],
              [46.095709, 32.984173],
              [46.095919, 32.984124],
              [46.096286, 32.984175],
              [46.09639, 32.984125],
              [46.09647, 32.983975],
              [46.09669, 32.983774],
              [46.097443, 32.983341],
              [46.097641, 32.983161],
              [46.097772, 32.982926],
              [46.097817, 32.982679],
              [46.097787, 32.982466],
              [46.097583, 32.982075],
              [46.09743, 32.981967],
              [46.096988, 32.982059],
              [46.096756, 32.981984],
              [46.096602, 32.98185],
              [46.096511, 32.98168],
              [46.10218, 32.977612],
              [46.109093, 32.974259],
              [46.119994, 32.968885],
              [46.133748, 32.960869],
              [46.137802, 32.95993],
              [46.159405, 32.955131],
              [46.173556, 32.953285],
              [46.199846, 32.959124],
              [46.207354, 32.960539],
              [46.2098762, 32.9610943],
              [46.2205, 32.963433],
              [46.244134, 32.97019],
              [46.253742, 32.968606],
              [46.266369, 32.972447],
              [46.282369, 32.968902],
              [46.298142, 32.968288],
              [46.312327, 32.968816],
              [46.322019, 32.965782],
              [46.331533, 32.96523],
              [46.344807, 32.958594],
              [46.347508, 32.960324],
              [46.359192, 32.954786],
              [46.387556, 32.948836],
              [46.410102, 32.947231],
              [46.415413, 32.941534],
              [46.422569, 32.937529],
              [46.427617, 32.935532],
              [46.431613, 32.934585],
              [46.436942, 32.933396],
              [46.441183, 32.931093],
              [46.444382, 32.930514],
              [46.447421, 32.933275],
              [46.451022, 32.931069],
              [46.449409, 32.927365],
              [46.461767, 32.921565],
              [46.462092, 32.921379],
              [46.471655, 32.917659],
              [46.480506, 32.916202],
              [46.491513, 32.902993],
              [46.504161, 32.902106],
              [46.510712, 32.900282],
              [46.5142611, 32.8993366],
              [46.518693, 32.898156],
              [46.527683, 32.89241],
              [46.555702, 32.874702],
              [46.5654107, 32.8676237],
              [46.573649, 32.861617],
              [46.585221, 32.851784],
              [46.588738, 32.851383],
              [46.592412, 32.850565],
              [46.592096, 32.847863],
              [46.601585, 32.840752],
              [46.613722, 32.832479],
              [46.622615, 32.822218],
              [46.632469, 32.817805],
              [46.647307, 32.814454],
              [46.655987, 32.80735],
              [46.688649, 32.797894],
              [46.691232, 32.79335],
              [46.698361, 32.789195],
              [46.707899, 32.785457],
              [46.720615, 32.78596],
              [46.734397, 32.775398],
              [46.74046, 32.768775],
              [46.751356, 32.760343],
              [46.758459, 32.751283],
              [46.758474, 32.751162],
              [46.766326, 32.742083],
              [46.766299, 32.742033],
              [46.78366, 32.730313],
              [46.783801, 32.730157],
              [46.787791, 32.722788],
              [46.791315, 32.711954],
              [46.804238, 32.705439],
              [46.811891, 32.701022],
              [46.825896, 32.694731],
              [46.830258, 32.686325],
              [46.836375, 32.672572],
              [46.842392, 32.666982],
              [46.857348, 32.655488],
              [46.872086, 32.646476],
              [46.887238, 32.631954],
              [46.914126, 32.618334],
              [46.922161, 32.615281],
              [46.939698, 32.605766],
              [46.95577, 32.597626],
              [46.973419, 32.581341],
              [47.017411, 32.555623],
              [47.022638, 32.550797],
              [47.033145, 32.54454],
              [47.0480301, 32.531239],
              [47.0521313, 32.5271588],
              [47.055363, 32.526151],
              [47.0795711, 32.5117172],
              [47.0854976, 32.5085116],
              [47.0904973, 32.5052312],
              [47.0950364, 32.5020581],
              [47.1034009, 32.4977322],
              [47.1073234, 32.4939495],
              [47.110917, 32.489598],
              [47.135073, 32.476113],
              [47.149805, 32.469279],
              [47.168401, 32.457281],
              [47.180773, 32.455747],
              [47.180318, 32.45638],
              [47.180128, 32.456956],
              [47.180155, 32.458067],
              [47.180347, 32.459176],
              [47.180466, 32.459368],
              [47.180712, 32.459505],
              [47.182457, 32.459528],
              [47.18284, 32.459586],
              [47.182998, 32.460307],
              [47.183001, 32.460977],
              [47.18328, 32.461468],
              [47.18354, 32.46168],
              [47.183951, 32.461824],
              [47.184437, 32.461891],
              [47.185716, 32.461599],
              [47.187808, 32.461217],
              [47.188571, 32.461171],
              [47.189159, 32.461248],
              [47.189736, 32.461399],
              [47.190226, 32.461639],
              [47.190396, 32.461831],
              [47.190475, 32.462995],
              [47.1921202, 32.4629319],
              [47.194748, 32.462831],
              [47.194912, 32.4625],
              [47.195005, 32.462125],
              [47.195167, 32.462039],
              [47.195531, 32.46201],
              [47.195944, 32.461908],
              [47.196138, 32.461924],
              [47.196277, 32.461866],
              [47.197523, 32.462079],
              [47.197653, 32.46195],
              [47.198556, 32.461823],
              [47.198721, 32.461874],
              [47.198921, 32.46204],
              [47.1993, 32.461888],
              [47.20016, 32.461396],
              [47.200323, 32.461346],
              [47.200567, 32.46139],
              [47.200811, 32.461621],
              [47.201089, 32.461654],
              [47.201226, 32.46174],
              [47.201591, 32.461651],
              [47.201781, 32.461716],
              [47.202074, 32.461567],
              [47.202453, 32.461692],
              [47.202646, 32.461613],
              [47.202674, 32.461488],
              [47.202842, 32.461365],
              [47.203046, 32.461302],
              [47.203452, 32.461477],
              [47.203637, 32.461489],
              [47.203777, 32.461556],
              [47.203945, 32.461649],
              [47.204045, 32.461795],
              [47.204203, 32.461878],
              [47.204298, 32.461784],
              [47.204295, 32.461377],
              [47.204542, 32.461247],
              [47.204753, 32.461219],
              [47.204947, 32.461422],
              [47.205137, 32.461481],
              [47.20543, 32.461488],
              [47.205575, 32.461638],
              [47.205867, 32.461423],
              [47.206059, 32.461374],
              [47.206214, 32.461229],
              [47.206363, 32.461241],
              [47.206729, 32.461128],
              [47.2071, 32.461153],
              [47.207449, 32.461336],
              [47.207557, 32.461301],
              [47.207727, 32.461124],
              [47.207913, 32.461051],
              [47.207838, 32.460824],
              [47.207885, 32.46075],
              [47.208173, 32.460674],
              [47.208449, 32.460821],
              [47.208676, 32.46052],
              [47.208843, 32.460518],
              [47.2091, 32.46074],
              [47.209245, 32.460705],
              [47.209413, 32.460582],
              [47.209524, 32.460378],
              [47.2098, 32.460309],
              [47.21022, 32.460452],
              [47.21034, 32.460372],
              [47.210526, 32.46033],
              [47.210583, 32.460201],
              [47.211138, 32.460268],
              [47.211263, 32.460406],
              [47.211458, 32.460432],
              [47.21161, 32.460596],
              [47.212359, 32.460389],
              [47.21269, 32.460722],
              [47.212801, 32.460914],
              [47.212798, 32.461023],
              [47.21261, 32.461185],
              [47.212476, 32.461674],
              [47.2126, 32.461861],
              [47.212698, 32.462223],
              [47.212977, 32.462661],
              [47.213088, 32.462931],
              [47.212958, 32.463102],
              [47.213011, 32.463234],
              [47.213621, 32.4631],
              [47.214032, 32.46319],
              [47.214223, 32.463075],
              [47.21459, 32.462947],
              [47.215062, 32.462802],
              [47.215345, 32.462795],
              [47.215641, 32.462708],
              [47.2166, 32.462341],
              [47.216809, 32.462547],
              [47.217131, 32.462645],
              [47.218307, 32.462698],
              [47.218643, 32.462686],
              [47.219575, 32.462416],
              [47.21999, 32.462384],
              [47.220165, 32.462445],
              [47.220524, 32.462258],
              [47.220881, 32.462166],
              [47.221157, 32.462148],
              [47.221316, 32.462218],
              [47.222361, 32.462365],
              [47.222671, 32.462335],
              [47.222714, 32.462061],
              [47.222931, 32.461888],
              [47.223141, 32.461797],
              [47.223432, 32.461749],
              [47.223463, 32.461876],
              [47.223917, 32.462095],
              [47.224148, 32.462058],
              [47.22448, 32.462165],
              [47.224529, 32.462457],
              [47.224434, 32.46279],
              [47.224693, 32.462868],
              [47.224759, 32.462929],
              [47.224774, 32.463052],
              [47.225063, 32.463221],
              [47.225336, 32.463206],
              [47.225781, 32.463265],
              [47.226605, 32.463148],
              [47.227301, 32.463106],
              [47.227773, 32.462915],
              [47.228019, 32.462881],
              [47.228259, 32.462908],
              [47.228501, 32.463066],
              [47.228675, 32.463122],
              [47.228969, 32.463073],
              [47.229266, 32.463127],
              [47.229386, 32.463203],
              [47.229355, 32.463406],
              [47.229435, 32.463555],
              [47.229594, 32.463612],
              [47.22985, 32.464068],
              [47.230132, 32.464088],
              [47.230245, 32.464195],
              [47.230974, 32.464526],
              [47.231321, 32.464757],
              [47.23161, 32.465351],
              [47.231606, 32.465544],
              [47.232075, 32.465647],
              [47.232773, 32.466725],
              [47.233422, 32.466817],
              [47.233689, 32.466779],
              [47.234292, 32.466531],
              [47.234619, 32.466465],
              [47.235139, 32.466476],
              [47.235485, 32.466402],
              [47.23578, 32.466234],
              [47.235884, 32.465941],
              [47.236105, 32.465773],
              [47.237224, 32.465368],
              [47.237816, 32.465223],
              [47.238389, 32.465183],
              [47.239383, 32.465314],
              [47.24006, 32.465342],
              [47.240341, 32.465241],
              [47.240675, 32.465235],
              [47.240905, 32.465101],
              [47.241953, 32.464978],
              [47.24213, 32.464865],
              [47.242309, 32.464854],
              [47.242542, 32.464941],
              [47.242915, 32.464916],
              [47.243997, 32.464691],
              [47.2443, 32.464468],
              [47.244413, 32.46394],
              [47.244645, 32.463392],
              [47.244942, 32.463356],
              [47.245207, 32.463426],
              [47.245398, 32.463587],
              [47.246859, 32.46363],
              [47.247204, 32.463729],
              [47.24736, 32.463925],
              [47.247368, 32.46414],
              [47.247459, 32.464335],
              [47.247618, 32.464327],
              [47.247915, 32.4642],
              [47.248188, 32.464185],
              [47.248355, 32.464212],
              [47.248465, 32.464278],
              [47.248382, 32.464507],
              [47.248449, 32.464784],
              [47.248642, 32.464921],
              [47.248837, 32.465272],
              [47.248982, 32.465333],
              [47.249651, 32.465175],
              [47.249995, 32.465149],
              [47.250381, 32.465212],
              [47.250744, 32.465206],
              [47.25096, 32.465105],
              [47.251122, 32.465114],
              [47.251385, 32.465233],
              [47.251429, 32.465388],
              [47.251568, 32.465569],
              [47.252047, 32.465473],
              [47.252245, 32.465506],
              [47.252449, 32.465719],
              [47.25267, 32.46579],
              [47.252749, 32.465903],
              [47.252952, 32.46599],
              [47.253155, 32.466197],
              [47.25348, 32.466305],
              [47.253583, 32.466462],
              [47.254059, 32.466594],
              [47.254044, 32.466771],
              [47.253955, 32.466917],
              [47.254056, 32.467092],
              [47.25455, 32.467569],
              [47.254618, 32.467852],
              [47.254894, 32.468028],
              [47.25516, 32.468075],
              [47.255472, 32.467976],
              [47.255907, 32.46809],
              [47.256373, 32.467936],
              [47.256668, 32.468074],
              [47.256868, 32.468299],
              [47.257116, 32.46845],
              [47.257822, 32.468718],
              [47.258085, 32.468873],
              [47.258374, 32.468952],
              [47.258662, 32.46942],
              [47.258809, 32.469756],
              [47.258869, 32.470094],
              [47.259074, 32.470402],
              [47.259233, 32.471209],
              [47.259419, 32.471527],
              [47.259652, 32.47174],
              [47.259916, 32.471865],
              [47.260048, 32.472173],
              [47.260774, 32.472402],
              [47.261239, 32.472638],
              [47.261229, 32.472807],
              [47.261115, 32.47309],
              [47.261112, 32.473348],
              [47.261449, 32.473508],
              [47.262066, 32.473617],
              [47.262366, 32.473652],
              [47.262688, 32.4736],
              [47.26294, 32.473648],
              [47.263076, 32.473758],
              [47.263401, 32.473867],
              [47.263831, 32.474198],
              [47.26467, 32.474444],
              [47.264928, 32.475122],
              [47.265457, 32.475197],
              [47.265671, 32.47542],
              [47.265837, 32.475716],
              [47.265979, 32.475759],
              [47.266384, 32.475687],
              [47.266717, 32.4758],
              [47.266937, 32.476016],
              [47.267843, 32.476149],
              [47.26816, 32.476014],
              [47.268523, 32.475948],
              [47.26885, 32.476033],
              [47.269211, 32.476261],
              [47.269313, 32.476473],
              [47.269175, 32.476747],
              [47.268286, 32.477198],
              [47.267559, 32.477779],
              [47.267154, 32.478031],
              [47.267211, 32.478177],
              [47.267627, 32.478211],
              [47.268298, 32.478425],
              [47.268468, 32.478583],
              [47.268717, 32.47859],
              [47.268886, 32.478868],
              [47.269515, 32.479299],
              [47.270298, 32.478949],
              [47.270958, 32.478907],
              [47.271126, 32.47903],
              [47.271188, 32.479409],
              [47.271443, 32.479679],
              [47.271635, 32.47999],
              [47.271651, 32.480239],
              [47.271893, 32.480427],
              [47.272325, 32.480494],
              [47.272643, 32.480634],
              [47.272826, 32.48088],
              [47.272764, 32.481406],
              [47.273286, 32.481488],
              [47.273611, 32.481357],
              [47.273911, 32.481452],
              [47.274439, 32.481467],
              [47.274814, 32.481328],
              [47.27524, 32.481342],
              [47.275605, 32.481498],
              [47.275914, 32.481418],
              [47.27619, 32.481414],
              [47.27635, 32.481172],
              [47.276617, 32.481069],
              [47.277261, 32.481173],
              [47.277367, 32.481432],
              [47.277294, 32.481851],
              [47.277495, 32.482082],
              [47.277793, 32.482291],
              [47.277894, 32.482497],
              [47.277641, 32.482928],
              [47.277828, 32.483221],
              [47.277929, 32.483486],
              [47.27772, 32.483766],
              [47.277731, 32.483962],
              [47.278353, 32.484334],
              [47.278463, 32.48452],
              [47.278311, 32.484796],
              [47.278445, 32.48499],
              [47.278512, 32.485237],
              [47.278839, 32.485352],
              [47.279731, 32.485487],
              [47.280054, 32.485644],
              [47.280273, 32.48595],
              [47.280333, 32.486319],
              [47.281976, 32.488519],
              [47.282013, 32.489114],
              [47.281902, 32.489487],
              [47.281492, 32.490231],
              [47.28138, 32.49079],
              [47.281435, 32.49112],
              [47.281797, 32.491744],
              [47.281832, 32.492008],
              [47.281865, 32.492356],
              [47.281824, 32.492549],
              [47.281633, 32.492754],
              [47.281658, 32.492978],
              [47.281822, 32.493053],
              [47.281969, 32.493059],
              [47.28213, 32.493182],
              [47.282348, 32.493602],
              [47.282315, 32.493859],
              [47.282409, 32.493976],
              [47.282605, 32.494094],
              [47.282671, 32.494245],
              [47.282381, 32.494886],
              [47.28253, 32.495017],
              [47.282896, 32.495149],
              [47.282985, 32.495273],
              [47.282871, 32.495735],
              [47.283269, 32.496269],
              [47.283461, 32.49637],
              [47.28368, 32.49628],
              [47.2842, 32.496171],
              [47.284497, 32.496194],
              [47.284863, 32.49614],
              [47.284995, 32.495933],
              [47.285304, 32.495948],
              [47.285872, 32.496125],
              [47.286909, 32.495656],
              [47.28727, 32.495579],
              [47.287534, 32.495314],
              [47.287827, 32.49514],
              [47.2887, 32.495045],
              [47.289123, 32.495048],
              [47.289462, 32.494399],
              [47.289761, 32.494248],
              [47.29051, 32.494065],
              [47.290636, 32.493799],
              [47.290776, 32.493656],
              [47.291417, 32.493563],
              [47.291625, 32.493463],
              [47.292737, 32.493209],
              [47.292969, 32.493202],
              [47.293174, 32.49309],
              [47.293687, 32.493072],
              [47.294049, 32.493121],
              [47.294445, 32.493314],
              [47.294703, 32.493235],
              [47.294928, 32.492989],
              [47.295654, 32.492618],
              [47.295834, 32.492457],
              [47.295895, 32.492255],
              [47.296083, 32.491979],
              [47.296811, 32.491404],
              [47.297069, 32.491386],
              [47.297245, 32.491303],
              [47.297361, 32.491056],
              [47.297368, 32.490875],
              [47.297798, 32.490787],
              [47.298085, 32.49095],
              [47.298906, 32.491031],
              [47.299424, 32.49094],
              [47.299672, 32.490672],
              [47.300027, 32.490512],
              [47.300163, 32.490292],
              [47.30054, 32.490044],
              [47.300684, 32.489853],
              [47.300933, 32.48974],
              [47.301652, 32.49003],
              [47.301961, 32.490016],
              [47.302382, 32.490097],
              [47.302816, 32.489966],
              [47.303072, 32.489336],
              [47.303715, 32.489159],
              [47.303691, 32.488911],
              [47.303868, 32.488679],
              [47.304175, 32.488532],
              [47.305129, 32.488442],
              [47.305525, 32.488569],
              [47.305903, 32.488567],
              [47.306115, 32.488479],
              [47.306643, 32.488015],
              [47.306704, 32.487663],
              [47.306899, 32.487505],
              [47.307505, 32.487658],
              [47.307821, 32.487552],
              [47.308089, 32.487334],
              [47.30821, 32.487171],
              [47.308629, 32.487186],
              [47.309243, 32.486834],
              [47.309507, 32.486839],
              [47.309749, 32.486997],
              [47.310412, 32.487026],
              [47.310532, 32.487163],
              [47.310857, 32.487391],
              [47.311388, 32.487538],
              [47.311582, 32.487375],
              [47.31171, 32.48697],
              [47.311948, 32.486811],
              [47.312295, 32.486467],
              [47.312381, 32.486129],
              [47.312754, 32.486014],
              [47.313379, 32.485618],
              [47.313576, 32.485316],
              [47.313966, 32.48518],
              [47.314428, 32.485134],
              [47.315601, 32.485494],
              [47.315804, 32.485341],
              [47.315942, 32.484947],
              [47.316386, 32.484886],
              [47.316635, 32.484288],
              [47.316876, 32.48402],
              [47.317938, 32.483889],
              [47.318571, 32.483587],
              [47.318907, 32.483376],
              [47.319348, 32.483424],
              [47.320285, 32.482839],
              [47.321043, 32.483051],
              [47.321413, 32.482805],
              [47.321641, 32.482539],
              [47.321743, 32.482211],
              [47.322104, 32.482044],
              [47.322446, 32.482012],
              [47.322563, 32.481681],
              [47.322428, 32.481337],
              [47.323344, 32.4803],
              [47.323606, 32.48027],
              [47.323865, 32.480047],
              [47.3243, 32.479796],
              [47.324614, 32.479739],
              [47.324961, 32.479454],
              [47.325816, 32.479225],
              [47.326351, 32.478663],
              [47.326614, 32.478548],
              [47.326707, 32.478299],
              [47.32699, 32.478205],
              [47.327193, 32.478322],
              [47.327625, 32.478329],
              [47.328036, 32.47828],
              [47.328207, 32.478054],
              [47.328592, 32.477931],
              [47.329388, 32.476943],
              [47.329861, 32.476758],
              [47.330262, 32.476729],
              [47.331674, 32.476815],
              [47.331872, 32.476759],
              [47.33234, 32.476976],
              [47.333016, 32.477093],
              [47.333319, 32.47684],
              [47.333873, 32.476659],
              [47.334105, 32.476412],
              [47.334589, 32.476063],
              [47.334762, 32.475783],
              [47.335137, 32.475589],
              [47.335624, 32.475229],
              [47.33607, 32.475414],
              [47.336554, 32.475712],
              [47.33715, 32.476494],
              [47.337596, 32.476903],
              [47.338192, 32.477015],
              [47.338899, 32.477052],
              [47.339793, 32.477276],
              [47.340091, 32.476978],
              [47.340426, 32.476829],
              [47.340649, 32.476345],
              [47.340947, 32.476159],
              [47.341654, 32.475973],
              [47.342101, 32.476084],
              [47.342585, 32.476047],
              [47.343032, 32.475786],
              [47.343702, 32.475675],
              [47.344186, 32.475786],
              [47.34467, 32.475824],
              [47.345228, 32.475935],
              [47.345787, 32.4756],
              [47.346308, 32.475451],
              [47.346866, 32.475451],
              [47.348169, 32.475153],
              [47.349063, 32.475079],
              [47.351483, 32.475042],
              [47.352525, 32.474967],
              [47.354349, 32.474707],
              [47.354684, 32.474521],
              [47.354871, 32.474334],
              [47.355641, 32.473242],
              [47.355758, 32.472941],
              [47.356071, 32.472794],
              [47.3563, 32.472744],
              [47.35702, 32.472075],
              [47.357598, 32.471723],
              [47.357633, 32.471357],
              [47.358006, 32.470942],
              [47.358629, 32.470834],
              [47.358825, 32.470653],
              [47.358865, 32.470484],
              [47.35911, 32.470504],
              [47.359509, 32.470828],
              [47.359754, 32.470848],
              [47.3601, 32.471073],
              [47.360452, 32.470932],
              [47.360736, 32.470718],
              [47.360791, 32.470253],
              [47.360994, 32.47016],
              [47.36118, 32.470387],
              [47.361594, 32.470529],
              [47.361947, 32.470424],
              [47.362347, 32.470454],
              [47.362509, 32.470518],
              [47.363042, 32.470101],
              [47.363264, 32.470148],
              [47.36348, 32.470377],
              [47.363969, 32.470261],
              [47.364326, 32.470412],
              [47.364942, 32.470245],
              [47.365274, 32.470383],
              [47.365571, 32.470406],
              [47.366285, 32.470649],
              [47.366661, 32.470606],
              [47.367003, 32.470694],
              [47.36746, 32.470655],
              [47.367823, 32.470739],
              [47.367756, 32.471008],
              [47.367863, 32.471206],
              [47.368329, 32.471568],
              [47.368713, 32.471439],
              [47.36891, 32.471563],
              [47.369417, 32.472211],
              [47.369761, 32.472251],
              [47.369936, 32.472672],
              [47.370133, 32.472825],
              [47.370123, 32.473265],
              [47.370389, 32.473461],
              [47.371163, 32.473802],
              [47.371213, 32.474009],
              [47.371095, 32.474424],
              [47.370719, 32.474738],
              [47.370613, 32.474989],
              [47.37065, 32.475175],
              [47.370812, 32.475334],
              [47.371146, 32.475297],
              [47.371572, 32.475162],
              [47.372005, 32.474965],
              [47.372778, 32.474755],
              [47.373092, 32.474727],
              [47.373494, 32.474524],
              [47.374483, 32.474362],
              [47.374767, 32.474213],
              [47.375399, 32.47351],
              [47.375706, 32.473394],
              [47.376101, 32.473342],
              [47.376529, 32.473362],
              [47.376807, 32.47355],
              [47.37746, 32.473689],
              [47.37777, 32.473854],
              [47.378021, 32.473867],
              [47.378, 32.473481],
              [47.378522, 32.473197],
              [47.378916, 32.473199],
              [47.379353, 32.473139],
              [47.379567, 32.473212],
              [47.379738, 32.473076],
              [47.379768, 32.472808],
              [47.37988, 32.472609],
              [47.379818, 32.4722],
              [47.379953, 32.472064],
              [47.379866, 32.471826],
              [47.380081, 32.471509],
              [47.380377, 32.471557],
              [47.380623, 32.471493],
              [47.380884, 32.471216],
              [47.381149, 32.471227],
              [47.381687, 32.471343],
              [47.382233, 32.470948],
              [47.382428, 32.471],
              [47.382955, 32.470919],
              [47.383116, 32.470743],
              [47.383315, 32.470633],
              [47.383858, 32.470526],
              [47.383977, 32.470326],
              [47.384162, 32.469763],
              [47.384001, 32.469369],
              [47.38429, 32.469148],
              [47.384615, 32.469077],
              [47.384709, 32.468894],
              [47.384632, 32.468666],
              [47.384735, 32.468398],
              [47.384932, 32.468156],
              [47.385517, 32.467772],
              [47.386, 32.467088],
              [47.38626, 32.466991],
              [47.386499, 32.467012],
              [47.386796, 32.466766],
              [47.387062, 32.466722],
              [47.38738, 32.466802],
              [47.387523, 32.466911],
              [47.387593, 32.467049],
              [47.387746, 32.467138],
              [47.387946, 32.467153],
              [47.388438, 32.466929],
              [47.388797, 32.466966],
              [47.389094, 32.466869],
              [47.38975, 32.46678],
              [47.391033, 32.465845],
              [47.391536, 32.465697],
              [47.39207, 32.465105],
              [47.392309, 32.464977],
              [47.392622, 32.464883],
              [47.393188, 32.464545],
              [47.393437, 32.464007],
              [47.3944, 32.463068],
              [47.394682, 32.462353],
              [47.394536, 32.461971],
              [47.394477, 32.461502],
              [47.394183, 32.460504],
              [47.394213, 32.460284],
              [47.394345, 32.460093],
              [47.394624, 32.459858],
              [47.394609, 32.459345],
              [47.394785, 32.459286],
              [47.394888, 32.459184],
              [47.395152, 32.458494],
              [47.395299, 32.458406],
              [47.39615, 32.458288],
              [47.396678, 32.457907],
              [47.397221, 32.45776],
              [47.397676, 32.457482],
              [47.397969, 32.457232],
              [47.398277, 32.456836],
              [47.398864, 32.456234],
              [47.400214, 32.454415],
              [47.400493, 32.45421],
              [47.401124, 32.454107],
              [47.40152, 32.453813],
              [47.402146, 32.453755],
              [47.402442, 32.453211],
              [47.402631, 32.453],
              [47.402952, 32.452456],
              [47.403493, 32.451924],
              [47.405102, 32.449928],
              [47.4058, 32.448927],
              [47.406047, 32.448712],
              [47.407331, 32.447243],
              [47.40763, 32.446797],
              [47.408062, 32.446304],
              [47.408783, 32.445297],
              [47.40866, 32.444909],
              [47.408957, 32.444428],
              [47.40924, 32.444264],
              [47.409575, 32.444353],
              [47.410094, 32.443873],
              [47.410901, 32.44288],
              [47.411182, 32.442419],
              [47.41105, 32.44226],
              [47.411021, 32.442094],
              [47.411178, 32.441901],
              [47.411897, 32.441602],
              [47.412551, 32.440899],
              [47.412634, 32.440684],
              [47.412574, 32.440484],
              [47.412605, 32.440205],
              [47.412822, 32.440081],
              [47.413162, 32.440083],
              [47.413797, 32.439332],
              [47.414152, 32.439046],
              [47.414463, 32.43862],
              [47.414556, 32.438153],
              [47.415065, 32.437903],
              [47.415435, 32.437541],
              [47.415816, 32.437251],
              [47.415958, 32.436998],
              [47.415738, 32.43666],
              [47.41584, 32.436443],
              [47.416698, 32.436091],
              [47.416977, 32.435887],
              [47.417887, 32.434836],
              [47.418065, 32.434725],
              [47.418109, 32.434546],
              [47.418417, 32.434371],
              [47.418558, 32.434118],
              [47.418958, 32.433899],
              [47.41901, 32.433701],
              [47.418989, 32.433437],
              [47.419559, 32.432543],
              [47.420241, 32.431812],
              [47.420493, 32.431265],
              [47.420623, 32.430837],
              [47.421076, 32.430477],
              [47.421454, 32.42988],
              [47.421646, 32.429053],
              [47.42198, 32.428555],
              [47.422107, 32.428196],
              [47.422552, 32.427643],
              [47.422907, 32.427016],
              [47.423182, 32.426688],
              [47.423466, 32.426238],
              [47.423694, 32.426129],
              [47.423913, 32.425828],
              [47.423802, 32.4253],
              [47.423925, 32.425107],
              [47.424122, 32.424855],
              [47.424519, 32.424705],
              [47.425032, 32.423964],
              [47.425283, 32.423891],
              [47.425905, 32.423461],
              [47.42614, 32.423088],
              [47.426584, 32.42269],
              [47.42666, 32.422557],
              [47.426652, 32.42237],
              [47.426776, 32.422234],
              [47.427012, 32.422129],
              [47.427095, 32.421995],
              [47.427108, 32.421833],
              [47.427329, 32.421594],
              [47.427446, 32.42114],
              [47.427729, 32.420924],
              [47.42801, 32.420595],
              [47.428689, 32.420115],
              [47.428973, 32.419745],
              [47.42952, 32.419295],
              [47.429845, 32.418764],
              [47.430189, 32.418332],
              [47.430383, 32.418144],
              [47.430597, 32.41806],
              [47.430863, 32.418047],
              [47.431762, 32.418144],
              [47.431761, 32.417825],
              [47.432104, 32.41757],
              [47.432207, 32.417329],
              [47.432466, 32.417152],
              [47.432753, 32.417084],
              [47.433006, 32.416965],
              [47.433356, 32.416954],
              [47.433549, 32.416817],
              [47.433661, 32.416609],
              [47.434293, 32.416189],
              [47.434598, 32.41561],
              [47.434751, 32.415424],
              [47.435052, 32.41533],
              [47.43516, 32.415163],
              [47.435365, 32.415046],
              [47.435342, 32.414823],
              [47.435428, 32.414704],
              [47.435908, 32.414471],
              [47.436033, 32.414312],
              [47.436282, 32.414154],
              [47.436455, 32.413809],
              [47.436465, 32.413608],
              [47.436902, 32.413479],
              [47.436945, 32.413272],
              [47.437059, 32.413069],
              [47.437268, 32.412969],
              [47.437473, 32.412665],
              [47.437696, 32.412488],
              [47.43775, 32.412376],
              [47.438432, 32.411645],
              [47.438684, 32.41152],
              [47.439024, 32.411209],
              [47.439142, 32.410892],
              [47.439378, 32.410787],
              [47.439607, 32.410575],
              [47.439829, 32.410125],
              [47.440862, 32.409811],
              [47.441316, 32.409188],
              [47.44162, 32.408866],
              [47.441866, 32.40872],
              [47.442267, 32.408637],
              [47.442943, 32.407833],
              [47.443207, 32.407729],
              [47.443607, 32.407721],
              [47.443818, 32.407655],
              [47.443904, 32.407189],
              [47.444154, 32.407059],
              [47.444351, 32.406779],
              [47.444676, 32.406619],
              [47.444856, 32.406404],
              [47.44503, 32.406299],
              [47.445446, 32.406169],
              [47.445714, 32.40595],
              [47.445802, 32.405729],
              [47.44567, 32.405518],
              [47.445434, 32.405355],
              [47.445579, 32.405118],
              [47.446068, 32.404627],
              [47.44682, 32.404271],
              [47.447138, 32.403844],
              [47.447464, 32.403689],
              [47.447617, 32.403399],
              [47.447904, 32.403223],
              [47.448485, 32.403034],
              [47.448777, 32.402771],
              [47.44954, 32.40251],
              [47.450001, 32.402075],
              [47.45014, 32.401731],
              [47.450364, 32.401634],
              [47.451067, 32.401566],
              [47.451222, 32.401339],
              [47.451605, 32.400975],
              [47.451788, 32.400457],
              [47.452047, 32.40036],
              [47.452326, 32.400316],
              [47.452391, 32.400031],
              [47.4525, 32.399921],
              [47.453267, 32.399619],
              [47.453503, 32.399332],
              [47.453777, 32.399238],
              [47.453991, 32.399234],
              [47.454142, 32.398859],
              [47.454345, 32.398681],
              [47.454304, 32.39834],
              [47.454502, 32.397854],
              [47.454682, 32.39772],
              [47.455631, 32.397426],
              [47.455851, 32.397261],
              [47.456058, 32.397019],
              [47.456249, 32.396957],
              [47.456713, 32.397006],
              [47.456907, 32.396846],
              [47.457238, 32.396365],
              [47.457543, 32.39602],
              [47.458011, 32.395794],
              [47.458712, 32.395641],
              [47.459187, 32.395392],
              [47.459508, 32.394844],
              [47.459788, 32.394749],
              [47.460698, 32.39473],
              [47.460948, 32.394863],
              [47.461339, 32.394691],
              [47.461635, 32.394444],
              [47.461395, 32.394002],
              [47.461571, 32.393725],
              [47.461963, 32.393553],
              [47.462241, 32.393293],
              [47.462647, 32.393044],
              [47.462851, 32.392842],
              [47.462984, 32.392608],
              [47.463535, 32.392356],
              [47.463909, 32.392119],
              [47.464202, 32.392021],
              [47.464448, 32.391795],
              [47.464584, 32.39152],
              [47.465348, 32.391316],
              [47.464667, 32.38988],
              [47.464456, 32.389632],
              [47.464157, 32.389468],
              [47.464039, 32.388964],
              [47.464194, 32.388578],
              [47.464115, 32.387668],
              [47.463868, 32.387415],
              [47.463467, 32.387338],
              [47.463175, 32.38715],
              [47.463081, 32.386659],
              [47.463173, 32.386215],
              [47.463084, 32.385746],
              [47.462936, 32.38531],
              [47.46297, 32.384831],
              [47.462633, 32.384315],
              [47.462327, 32.384152],
              [47.462187, 32.383909],
              [47.462455, 32.38324],
              [47.462517, 32.382892],
              [47.462404, 32.382542],
              [47.46257, 32.38209],
              [47.462972, 32.382116],
              [47.463315, 32.381679],
              [47.463787, 32.381418],
              [47.463845, 32.380951],
              [47.463996, 32.380656],
              [47.464249, 32.380429],
              [47.464275, 32.380105],
              [47.464113, 32.379832],
              [47.464174, 32.379747],
              [47.464617, 32.379822],
              [47.464842, 32.379942],
              [47.465016, 32.379973],
              [47.465165, 32.379879],
              [47.465122, 32.379715],
              [47.465008, 32.37957],
              [47.465055, 32.379459],
              [47.465418, 32.379309],
              [47.465866, 32.379247],
              [47.466219, 32.378505],
              [47.466076, 32.37812],
              [47.466023, 32.377571],
              [47.465712, 32.377101],
              [47.46537, 32.376774],
              [47.464671, 32.376407],
              [47.464356, 32.375944],
              [47.464032, 32.375289],
              [47.463648, 32.374832],
              [47.463082, 32.374602],
              [47.462451, 32.374628],
              [47.461803, 32.37488],
              [47.461342, 32.375156],
              [47.46089, 32.375202],
              [47.460614, 32.374812],
              [47.460307, 32.37311],
              [47.460191, 32.37272],
              [47.460029, 32.372526],
              [47.459273, 32.37205],
              [47.458351, 32.371306],
              [47.457992, 32.370942],
              [47.457559, 32.370375],
              [47.455816, 32.368694],
              [47.454348, 32.367192],
              [47.453962, 32.366935],
              [47.453523, 32.366876],
              [47.45293, 32.366651],
              [47.452815, 32.366369],
              [47.452919, 32.365945],
              [47.452933, 32.36539],
              [47.452673, 32.364979],
              [47.452015, 32.36448],
              [47.452059, 32.364119],
              [47.451935, 32.363382],
              [47.451624, 32.362884],
              [47.451261, 32.362475],
              [47.450715, 32.361027],
              [47.450737, 32.360344],
              [47.451042, 32.359497],
              [47.451204, 32.358185],
              [47.449528, 32.35753],
              [47.448624, 32.357228],
              [47.447463, 32.356921],
              [47.442853, 32.356102],
              [47.442002, 32.355843],
              [47.44079, 32.355579],
              [47.439885, 32.355038],
              [47.439498, 32.354245],
              [47.438947, 32.353413],
              [47.4382, 32.352628],
              [47.437619, 32.352343],
              [47.436768, 32.352374],
              [47.435855, 32.352302],
              [47.435418, 32.352089],
              [47.435256, 32.351867],
              [47.435689, 32.351379],
              [47.436411, 32.350772],
              [47.437408, 32.350584],
              [47.438893, 32.350406],
              [47.439692, 32.350201],
              [47.440243, 32.349949],
              [47.440903, 32.349268],
              [47.441884, 32.34862],
              [47.442563, 32.348249],
              [47.443023, 32.348179],
              [47.44341, 32.348201],
              [47.444334, 32.348476],
              [47.444787, 32.34851],
              [47.445238, 32.348247],
              [47.445553, 32.347969],
              [47.445726, 32.347437],
              [47.446504, 32.346757],
              [47.446813, 32.346616],
              [47.44717, 32.346576],
              [47.447361, 32.346776],
              [47.447656, 32.346895],
              [47.448143, 32.346877],
              [47.448801, 32.346503],
              [47.449432, 32.346294],
              [47.450394, 32.346181],
              [47.450991, 32.345812],
              [47.451647, 32.345593],
              [47.452382, 32.345092],
              [47.453067, 32.344771],
              [47.453456, 32.344325],
              [47.453734, 32.344088],
              [47.454261, 32.342979],
              [47.454962, 32.341897],
              [47.455094, 32.341291],
              [47.455274, 32.340815],
              [47.455777, 32.340246],
              [47.456201, 32.339589],
              [47.456577, 32.338382],
              [47.4571482, 32.3373821],
              [47.457174, 32.337337],
              [47.457481, 32.336672],
              [47.457958, 32.33468],
              [47.45795, 32.33407],
              [47.457678, 32.333036],
              [47.457371, 32.332745],
              [47.456467, 32.332623],
              [47.456096, 32.332494],
              [47.455812, 32.332198],
              [47.455833, 32.331754],
              [47.456207, 32.331435],
              [47.456999, 32.330985],
              [47.45764, 32.330311],
              [47.458179, 32.329629],
              [47.458932, 32.328393],
              [47.459159, 32.327887],
              [47.459225, 32.327384],
              [47.459856, 32.32673],
              [47.460068, 32.326113],
              [47.460472, 32.325701],
              [47.461685, 32.325226],
              [47.462086, 32.324859],
              [47.461425, 32.324121],
              [47.461363, 32.323653],
              [47.461707, 32.322811],
              [47.462449, 32.321678],
              [47.462703, 32.321047],
              [47.461949, 32.319551],
              [47.461788, 32.318359],
              [47.461743, 32.316214],
              [47.46314, 32.314316],
              [47.463502, 32.31427],
              [47.46397, 32.314331],
              [47.46411, 32.314747],
              [47.464127, 32.315247],
              [47.464451, 32.315693],
              [47.46509, 32.316114],
              [47.465718, 32.316436],
              [47.46654, 32.316768],
              [47.468638, 32.317212],
              [47.470145, 32.317296],
              [47.470707, 32.31705],
              [47.471757, 32.316038],
              [47.472066, 32.315587],
              [47.472551, 32.315104],
              [47.473119, 32.314675],
              [47.473713, 32.313971],
              [47.474256, 32.313823],
              [47.475003, 32.313696],
              [47.475283, 32.313395],
              [47.475548, 32.313007],
              [47.476829, 32.312294],
              [47.477303, 32.311656],
              [47.477676, 32.310953],
              [47.478003, 32.310567],
              [47.478385, 32.310392],
              [47.478857, 32.310295],
              [47.479053, 32.310399],
              [47.479108, 32.310609],
              [47.479294, 32.310822],
              [47.479183, 32.31098],
              [47.479292, 32.311017],
              [47.479524, 32.310969],
              [47.479962, 32.311206],
              [47.480154, 32.31121],
              [47.480298, 32.311379],
              [47.48033, 32.311732],
              [47.480496, 32.311841],
              [47.480773, 32.311848],
              [47.481362, 32.31202],
              [47.481721, 32.311786],
              [47.482416, 32.311782],
              [47.482646, 32.312307],
              [47.48303, 32.312371],
              [47.483434, 32.313004],
              [47.483578, 32.313173],
              [47.483751, 32.313275],
              [47.484251, 32.313865],
              [47.484433, 32.314034],
              [47.484981, 32.314314],
              [47.485191, 32.314358],
              [47.485912, 32.314249],
              [47.486542, 32.31391],
              [47.487402, 32.313718],
              [47.488851, 32.313586],
              [47.489288, 32.313589],
              [47.489372, 32.313732],
              [47.489618, 32.313883],
              [47.489892, 32.31391],
              [47.490107, 32.313909],
              [47.490456, 32.313696],
              [47.490704, 32.313677],
              [47.49118, 32.313976],
              [47.491421, 32.314021],
              [47.491618, 32.313866],
              [47.491603, 32.313636],
              [47.491453, 32.313386],
              [47.49153, 32.313214],
              [47.492215, 32.31262],
              [47.49228, 32.312256],
              [47.492257, 32.311996],
              [47.492379, 32.311848],
              [47.492626, 32.311741],
              [47.49285, 32.31172],
              [47.493038, 32.311649],
              [47.493012, 32.311464],
              [47.492843, 32.311199],
              [47.492691, 32.311087],
              [47.492473, 32.311044],
              [47.492704, 32.310644],
              [47.493903, 32.310462],
              [47.494041, 32.310349],
              [47.494719, 32.310134],
              [47.495026, 32.309758],
              [47.495489, 32.309367],
              [47.49583, 32.308745],
              [47.495997, 32.308596],
              [47.496775, 32.308413],
              [47.49714, 32.308058],
              [47.497241, 32.307656],
              [47.497411, 32.307374],
              [47.49776, 32.307186],
              [47.498208, 32.306741],
              [47.498594, 32.305709],
              [47.498589, 32.304992],
              [47.498746, 32.304687],
              [47.499053, 32.304431],
              [47.499328, 32.304369],
              [47.500547, 32.304322],
              [47.501576, 32.30451],
              [47.502388, 32.304572],
              [47.502872, 32.304813],
              [47.503212, 32.305086],
              [47.503251, 32.305495],
              [47.503502, 32.305664],
              [47.503962, 32.305758],
              [47.504392, 32.305442],
              [47.505379, 32.305153],
              [47.50629, 32.30533],
              [47.506693, 32.305176],
              [47.507228, 32.304942],
              [47.507696, 32.304481],
              [47.508077, 32.303866],
              [47.508427, 32.303772],
              [47.509183, 32.303681],
              [47.509893, 32.303963],
              [47.510735, 32.304228],
              [47.511411, 32.304353],
              [47.511985, 32.304528],
              [47.513467, 32.304666],
              [47.515225, 32.304661],
              [47.51617, 32.304706],
              [47.516875, 32.304593],
              [47.517342, 32.304566],
              [47.517911, 32.304603],
              [47.51833, 32.304887],
              [47.518891, 32.305014],
              [47.519494, 32.304516],
              [47.520189, 32.303611],
              [47.520613, 32.302755],
              [47.521044, 32.302212],
              [47.521542, 32.30172],
              [47.521772, 32.301056],
              [47.521833, 32.300038],
              [47.521498, 32.29894],
              [47.521711, 32.297749],
              [47.521613, 32.2972],
              [47.520965, 32.296397],
              [47.521262, 32.295985],
              [47.52145, 32.295624],
              [47.521196, 32.29504],
              [47.520761, 32.29452],
              [47.52057, 32.293855],
              [47.52137, 32.292768],
              [47.521431, 32.291372],
              [47.521616, 32.290798],
              [47.52166, 32.290066],
              [47.521643, 32.289565],
              [47.521554, 32.289286],
              [47.520525, 32.289475],
              [47.519884, 32.28925],
              [47.519237, 32.289202],
              [47.517334, 32.28895],
              [47.516831, 32.289071],
              [47.516478, 32.289216],
              [47.515333, 32.288904],
              [47.514356, 32.288707],
              [47.513762, 32.28875],
              [47.512889, 32.288717],
              [47.512149, 32.288578],
              [47.511377, 32.288609],
              [47.510749, 32.288696],
              [47.510166, 32.288661],
              [47.509742, 32.288271],
              [47.509416, 32.287731],
              [47.509297, 32.286815],
              [47.509108, 32.286213],
              [47.509249, 32.285791],
              [47.509533, 32.2853],
              [47.509321, 32.284758],
              [47.509157, 32.284076],
              [47.509136, 32.283331],
              [47.509038, 32.282524],
              [47.508382, 32.281312],
              [47.507767, 32.280982],
              [47.507293, 32.280953],
              [47.506767, 32.280757],
              [47.506108, 32.280869],
              [47.505744, 32.280883],
              [47.505479, 32.280716],
              [47.505525, 32.280368],
              [47.505306, 32.280118],
              [47.504867, 32.280051],
              [47.504204, 32.280233],
              [47.503689, 32.280255],
              [47.503344, 32.280455],
              [47.502999, 32.280567],
              [47.502687, 32.28034],
              [47.502216, 32.27963],
              [47.502683, 32.279018],
              [47.502731, 32.278708],
              [47.502511, 32.278571],
              [47.502111, 32.278415],
              [47.501645, 32.27848],
              [47.501086, 32.278794],
              [47.500588, 32.278794],
              [47.499889, 32.278113],
              [47.499849, 32.277875],
              [47.500087, 32.277763],
              [47.500522, 32.277786],
              [47.500968, 32.277505],
              [47.501187, 32.277233],
              [47.50153, 32.277027],
              [47.501953, 32.277034],
              [47.502089, 32.276739],
              [47.502122, 32.276544],
              [47.502681, 32.275764],
              [47.503194, 32.275415],
              [47.504141, 32.274597],
              [47.504154, 32.274123],
              [47.504899, 32.273234],
              [47.505387, 32.272795],
              [47.505953, 32.272473],
              [47.506332, 32.272198],
              [47.506567, 32.271785],
              [47.507065, 32.271293],
              [47.507422, 32.27082],
              [47.507797, 32.270734],
              [47.50849, 32.270346],
              [47.508879, 32.269962],
              [47.509227, 32.269484],
              [47.509778, 32.268989],
              [47.510623, 32.268045],
              [47.511616, 32.267402],
              [47.511871, 32.266948],
              [47.512883, 32.265968],
              [47.512968, 32.265537],
              [47.513166, 32.265099],
              [47.513258, 32.264692],
              [47.513709, 32.264341],
              [47.514286, 32.263747],
              [47.514906, 32.26334],
              [47.515291, 32.262913],
              [47.515836, 32.262545],
              [47.515865, 32.262275],
              [47.515954, 32.262033],
              [47.516304, 32.261851],
              [47.516541, 32.261909],
              [47.516777, 32.262106],
              [47.517168, 32.262225],
              [47.51752, 32.262257],
              [47.517775, 32.262381],
              [47.518181, 32.262328],
              [47.518489, 32.26187],
              [47.518887, 32.261434],
              [47.519178, 32.260973],
              [47.519265, 32.260605],
              [47.519946, 32.260143],
              [47.520108, 32.259799],
              [47.520104, 32.259492],
              [47.519728, 32.259112],
              [47.519877, 32.258865],
              [47.520391, 32.258465],
              [47.520621, 32.258002],
              [47.520969, 32.25755],
              [47.522094, 32.256537],
              [47.522631, 32.255931],
              [47.523497, 32.254807],
              [47.523563, 32.254506],
              [47.523515, 32.253947],
              [47.52377, 32.253638],
              [47.523772, 32.253297],
              [47.524011, 32.252927],
              [47.524906, 32.252346],
              [47.525025, 32.251865],
              [47.525273, 32.2515],
              [47.525527, 32.251247],
              [47.52659, 32.250868],
              [47.526682, 32.25026],
              [47.526983, 32.249892],
              [47.52748, 32.249545],
              [47.52782, 32.248917],
              [47.528171, 32.248622],
              [47.528696, 32.248409],
              [47.529161, 32.248112],
              [47.529369, 32.247684],
              [47.529729, 32.247192],
              [47.530526, 32.246647],
              [47.530754, 32.24626],
              [47.530851, 32.245846],
              [47.531741, 32.24507],
              [47.532525, 32.244099],
              [47.533046, 32.243843],
              [47.533447, 32.243362],
              [47.533581, 32.242822],
              [47.53382, 32.242395],
              [47.533917, 32.24195],
              [47.533907, 32.241536],
              [47.534187, 32.24097],
              [47.535254, 32.239999],
              [47.537019, 32.237871],
              [47.537776, 32.237232],
              [47.538391, 32.236109],
              [47.538623, 32.23586],
              [47.539488, 32.23563],
              [47.539938, 32.235247],
              [47.539912, 32.234887],
              [47.539954, 32.234464],
              [47.540156, 32.234302],
              [47.540597, 32.234179],
              [47.54096, 32.233988],
              [47.541314, 32.23356],
              [47.541433, 32.233168],
              [47.541208, 32.23278],
              [47.541108, 32.23237],
              [47.541377, 32.231969],
              [47.541681, 32.231644],
              [47.541915, 32.231574],
              [47.542209, 32.231644],
              [47.542511, 32.232091],
              [47.542491, 32.232274],
              [47.54309, 32.232629],
              [47.543449, 32.232688],
              [47.544042, 32.232629],
              [47.544179, 32.232755],
              [47.544416, 32.232826],
              [47.545122, 32.232804],
              [47.545392, 32.233001],
              [47.546335, 32.23305],
              [47.54656, 32.232905],
              [47.54672, 32.232858],
              [47.546959, 32.232891],
              [47.54717, 32.232995],
              [47.54739, 32.233003],
              [47.548712, 32.232662],
              [47.549344, 32.23271],
              [47.550074, 32.232995],
              [47.551132, 32.233306],
              [47.552055, 32.233367],
              [47.552543, 32.233261],
              [47.553477, 32.233189],
              [47.553944, 32.233086],
              [47.554523, 32.23302],
              [47.556252, 32.231917],
              [47.556837, 32.231699],
              [47.557252, 32.231748],
              [47.557755, 32.231696],
              [47.558137, 32.231448],
              [47.558474, 32.231161],
              [47.560095, 32.230823],
              [47.560549, 32.230412],
              [47.560774, 32.230088],
              [47.561168, 32.2298],
              [47.561713, 32.229561],
              [47.562925, 32.229193],
              [47.563337, 32.229015],
              [47.56371, 32.228646],
              [47.564563, 32.227119],
              [47.565223, 32.226075],
              [47.565506, 32.225864],
              [47.565986, 32.225769],
              [47.566522, 32.225541],
              [47.56696, 32.225089],
              [47.567118, 32.224669],
              [47.566886, 32.223095],
              [47.56713, 32.222324],
              [47.567456, 32.221496],
              [47.567692, 32.220717],
              [47.567893, 32.220454],
              [47.568747, 32.218866],
              [47.569285, 32.217754],
              [47.569513, 32.217052],
              [47.570273, 32.21515],
              [47.570527, 32.214263],
              [47.570578, 32.213414],
              [47.570558, 32.212534],
              [47.570467, 32.212168],
              [47.570489, 32.211838],
              [47.570415, 32.211516],
              [47.570488, 32.210988],
              [47.57042, 32.210797],
              [47.570176, 32.210482],
              [47.569369, 32.209601],
              [47.56916, 32.20894],
              [47.569242, 32.208448],
              [47.569504, 32.208005],
              [47.569456, 32.207735],
              [47.569261, 32.207604],
              [47.568913, 32.207548],
              [47.568537, 32.207384],
              [47.568372, 32.206979],
              [47.568424, 32.206743],
              [47.568662, 32.206493],
              [47.568626, 32.206353],
              [47.568375, 32.206166],
              [47.568029, 32.206006],
              [47.56774, 32.205954],
              [47.567408, 32.205829],
              [47.566567, 32.205295],
              [47.566257, 32.205166],
              [47.565611, 32.204479],
              [47.565043, 32.20357],
              [47.564889, 32.203163],
              [47.564807, 32.201439],
              [47.564859, 32.200613],
              [47.564776, 32.199282],
              [47.564876, 32.198116],
              [47.564893, 32.197249],
              [47.56477, 32.196326],
              [47.564619, 32.195645],
              [47.564687, 32.195057],
              [47.565245, 32.194475],
              [47.565381, 32.193709],
              [47.565278, 32.193232],
              [47.564708, 32.192942],
              [47.564148, 32.192367],
              [47.563446, 32.191817],
              [47.562793, 32.191126],
              [47.562157, 32.190782],
              [47.560477, 32.19018],
              [47.560079, 32.189978],
              [47.559733, 32.189865],
              [47.559361, 32.189823],
              [47.558821, 32.189541],
              [47.558538, 32.189469],
              [47.557933, 32.188071],
              [47.557814, 32.187903],
              [47.557431, 32.187929],
              [47.557123, 32.188155],
              [47.556817, 32.188124],
              [47.556594, 32.187975],
              [47.556201, 32.188098],
              [47.555927, 32.188057],
              [47.555392, 32.187794],
              [47.555002, 32.187708],
              [47.554783, 32.187553],
              [47.554586, 32.187503],
              [47.55408, 32.187566],
              [47.553696, 32.187521],
              [47.553271, 32.187347],
              [47.553145, 32.187025],
              [47.552922, 32.186658],
              [47.55295, 32.186394],
              [47.553245, 32.185774],
              [47.553078, 32.185771],
              [47.551857, 32.186169],
              [47.550783, 32.185884],
              [47.550202, 32.185856],
              [47.549793, 32.18574],
              [47.549172, 32.184935],
              [47.549097, 32.184627],
              [47.549158, 32.184404],
              [47.549541, 32.183811],
              [47.548646, 32.183508],
              [47.5484, 32.183359],
              [47.548254, 32.183177],
              [47.547908, 32.182497],
              [47.547207, 32.182387],
              [47.546881, 32.182152],
              [47.546338, 32.181985],
              [47.5462, 32.181835],
              [47.546203, 32.18156],
              [47.546331, 32.181353],
              [47.545712, 32.180595],
              [47.544929, 32.180131],
              [47.544503, 32.180126],
              [47.544176, 32.180039],
              [47.543865, 32.180142],
              [47.542733, 32.180051],
              [47.541924, 32.179705],
              [47.541509, 32.179675],
              [47.541174, 32.179452],
              [47.540849, 32.17909],
              [47.5406, 32.178671],
              [47.54024, 32.178372],
              [47.540138, 32.177984],
              [47.539982, 32.177809],
              [47.539182, 32.177711],
              [47.538822, 32.177587],
              [47.538581, 32.177436],
              [47.53833, 32.176924],
              [47.538121, 32.176805],
              [47.537649, 32.176649],
              [47.537421, 32.176458],
              [47.53707, 32.176087],
              [47.536329, 32.175128],
              [47.536359, 32.174873],
              [47.536699, 32.174552],
              [47.537228, 32.174141],
              [47.537456, 32.174029],
              [47.537727, 32.17399],
              [47.537663, 32.173789],
              [47.537448, 32.173478],
              [47.536981, 32.173141],
              [47.536462, 32.172918],
              [47.536033, 32.172858],
              [47.534687, 32.173278],
              [47.534291, 32.173453],
              [47.534108, 32.173325],
              [47.534026, 32.173103],
              [47.533787, 32.172981],
              [47.533331, 32.173034],
              [47.532894, 32.172947],
              [47.53263, 32.172683],
              [47.532226, 32.172613],
              [47.531649, 32.172665],
              [47.531084, 32.172657],
              [47.530628, 32.172517],
              [47.530374, 32.172359],
              [47.530215, 32.17217],
              [47.530152, 32.171974],
              [47.529662, 32.171358],
              [47.529199, 32.170911],
              [47.528784, 32.170707],
              [47.528653, 32.17058],
              [47.528443, 32.17057],
              [47.528032, 32.170686],
              [47.527892, 32.170546],
              [47.527865, 32.170399],
              [47.52796, 32.17026],
              [47.528294, 32.169982],
              [47.528611, 32.169879],
              [47.528922, 32.169426],
              [47.528851, 32.169203],
              [47.529068, 32.168635],
              [47.529038, 32.16839],
              [47.529218, 32.168136],
              [47.529581, 32.167121],
              [47.529321, 32.166549],
              [47.52968, 32.165909],
              [47.529735, 32.165361],
              [47.529856, 32.165207],
              [47.53027, 32.164972],
              [47.530649, 32.164885],
              [47.530829, 32.164655],
              [47.531046, 32.16454],
              [47.531074, 32.164365],
              [47.531168, 32.164287],
              [47.531376, 32.164226],
              [47.531521, 32.16404],
              [47.531835, 32.16388],
              [47.531936, 32.163696],
              [47.531773, 32.163211],
              [47.531719, 32.162682],
              [47.532002, 32.162381],
              [47.532371, 32.161866],
              [47.532417, 32.161608],
              [47.532329, 32.16125],
              [47.532328, 32.160575],
              [47.532496, 32.159147],
              [47.532596, 32.15894],
              [47.532955, 32.158758],
              [47.533311, 32.158713],
              [47.533583, 32.158527],
              [47.533803, 32.158186],
              [47.53374, 32.157342],
              [47.533896, 32.15628],
              [47.534111, 32.156029],
              [47.534489, 32.15581],
              [47.534852, 32.155684],
              [47.535067, 32.155499],
              [47.535217, 32.155198],
              [47.535171, 32.154961],
              [47.535049, 32.154737],
              [47.534715, 32.154362],
              [47.534377, 32.153516],
              [47.53421, 32.153253],
              [47.534159, 32.152932],
              [47.533785, 32.152559],
              [47.533438, 32.152291],
              [47.533311, 32.151893],
              [47.533211, 32.151104],
              [47.532828, 32.150001],
              [47.532492, 32.14973],
              [47.532076, 32.149502],
              [47.531769, 32.14858],
              [47.531247, 32.148319],
              [47.530558, 32.147691],
              [47.530093, 32.147387],
              [47.529527, 32.146827],
              [47.529113, 32.146306],
              [47.528995, 32.145968],
              [47.529037, 32.145626],
              [47.529587, 32.145253],
              [47.529625, 32.144505],
              [47.529792, 32.143965],
              [47.529785, 32.143702],
              [47.529683, 32.143446],
              [47.529479, 32.143261],
              [47.529208, 32.142908],
              [47.529117, 32.142584],
              [47.529067, 32.142201],
              [47.529201, 32.141752],
              [47.529706, 32.141383],
              [47.529855, 32.141163],
              [47.530375, 32.141046],
              [47.530507, 32.14098],
              [47.530707, 32.141001],
              [47.530963, 32.141144],
              [47.531249, 32.141182],
              [47.531659, 32.141085],
              [47.531934, 32.141126],
              [47.53238, 32.141098],
              [47.532944, 32.140822],
              [47.533072, 32.140634],
              [47.533478, 32.140585],
              [47.533874, 32.140259],
              [47.534312, 32.140067],
              [47.534651, 32.140158],
              [47.535318, 32.140119],
              [47.535876, 32.140189],
              [47.536073, 32.140064],
              [47.536111, 32.139816],
              [47.536295, 32.139339],
              [47.536584, 32.139174],
              [47.536886, 32.139101],
              [47.537129, 32.138912],
              [47.537353, 32.138829],
              [47.537479, 32.138651],
              [47.537873, 32.138448],
              [47.538579, 32.13834],
              [47.538906, 32.138405],
              [47.539108, 32.138387],
              [47.539664, 32.138274],
              [47.540836, 32.137866],
              [47.541253, 32.137881],
              [47.541706, 32.137596],
              [47.542553, 32.137327],
              [47.543242, 32.13735],
              [47.543528, 32.137086],
              [47.543711, 32.137039],
              [47.543925, 32.136916],
              [47.544534, 32.136788],
              [47.544915, 32.136753],
              [47.545016, 32.136678],
              [47.545428, 32.136543],
              [47.546297, 32.136355],
              [47.546483, 32.136236],
              [47.546805, 32.136174],
              [47.546928, 32.136095],
              [47.547756, 32.135838],
              [47.54895, 32.135559],
              [47.550073, 32.135074],
              [47.550635, 32.134638],
              [47.551281, 32.134343],
              [47.551301, 32.134094],
              [47.551452, 32.133666],
              [47.551587, 32.133528],
              [47.551878, 32.133433],
              [47.552284, 32.132756],
              [47.552622, 32.131926],
              [47.552779, 32.131695],
              [47.552693, 32.131587],
              [47.552426, 32.131555],
              [47.552276, 32.131398],
              [47.552238, 32.131192],
              [47.552409, 32.130793],
              [47.552548, 32.130669],
              [47.552844, 32.130616],
              [47.553332, 32.130358],
              [47.553786, 32.130272],
              [47.554368, 32.12989],
              [47.554372, 32.129535],
              [47.554161, 32.128869],
              [47.554159, 32.1286],
              [47.554245, 32.128405],
              [47.554576, 32.128332],
              [47.554734, 32.128214],
              [47.554835, 32.127964],
              [47.554554, 32.127835],
              [47.55442, 32.127675],
              [47.554436, 32.127497],
              [47.554815, 32.12717],
              [47.555249, 32.126492],
              [47.555254, 32.126076],
              [47.555433, 32.125907],
              [47.555737, 32.125819],
              [47.556116, 32.125515],
              [47.556433, 32.125043],
              [47.55666, 32.124596],
              [47.557143, 32.124231],
              [47.55728, 32.123795],
              [47.557244, 32.123528],
              [47.557449, 32.123217],
              [47.557424, 32.122863],
              [47.557657, 32.122613],
              [47.558766, 32.122032],
              [47.55906, 32.122018],
              [47.559349, 32.121937],
              [47.559415, 32.121623],
              [47.559573, 32.121524],
              [47.560002, 32.12141],
              [47.560038, 32.121285],
              [47.559745, 32.120983],
              [47.559696, 32.120624],
              [47.559808, 32.119395],
              [47.559745, 32.118919],
              [47.559194, 32.118853],
              [47.559147, 32.118479],
              [47.559037, 32.11813],
              [47.559226, 32.117803],
              [47.559169, 32.117455],
              [47.559214, 32.117083],
              [47.559422, 32.116696],
              [47.559353, 32.116501],
              [47.559077, 32.116347],
              [47.558674, 32.115994],
              [47.558833, 32.115271],
              [47.558923, 32.11518],
              [47.559259, 32.115148],
              [47.560071, 32.115177],
              [47.560396, 32.115062],
              [47.560709, 32.11503],
              [47.561026, 32.115077],
              [47.561406, 32.115061],
              [47.562212, 32.114832],
              [47.562436, 32.114636],
              [47.56265, 32.114295],
              [47.56298, 32.114241],
              [47.56332, 32.114114],
              [47.563592, 32.113952],
              [47.56438, 32.113197],
              [47.564552, 32.11311],
              [47.564995, 32.112657],
              [47.565404, 32.112532],
              [47.565708, 32.112076],
              [47.565933, 32.112017],
              [47.566477, 32.112161],
              [47.566739, 32.112133],
              [47.567336, 32.111936],
              [47.567557, 32.112014],
              [47.567571, 32.112196],
              [47.567977, 32.112431],
              [47.568347, 32.112416],
              [47.568535, 32.112501],
              [47.56937, 32.112446],
              [47.569644, 32.112354],
              [47.570011, 32.112331],
              [47.570603, 32.112202],
              [47.570854, 32.112261],
              [47.570996, 32.112386],
              [47.571361, 32.112444],
              [47.571701, 32.112468],
              [47.572654, 32.112425],
              [47.572982, 32.112257],
              [47.57347, 32.111802],
              [47.574501, 32.111575],
              [47.574991, 32.111279],
              [47.575216, 32.11122],
              [47.575469, 32.111241],
              [47.575729, 32.111379],
              [47.578357, 32.111659],
              [47.57847, 32.111828],
              [47.578208, 32.112267],
              [47.577928, 32.112317],
              [47.577867, 32.112521],
              [47.577928, 32.112751],
              [47.577738, 32.11305],
              [47.577834, 32.113283],
              [47.577981, 32.113408],
              [47.578029, 32.113522],
              [47.577992, 32.113949],
              [47.578051, 32.114194],
              [47.578416, 32.114379],
              [47.578779, 32.11447],
              [47.57894, 32.114667],
              [47.578978, 32.114963],
              [47.578922, 32.115209],
              [47.578753, 32.115414],
              [47.578675, 32.116009],
              [47.579268, 32.116885],
              [47.57961, 32.116942],
              [47.580013, 32.116903],
              [47.580581, 32.116598],
              [47.580927, 32.116475],
              [47.581251, 32.116464],
              [47.581524, 32.116321],
              [47.582277, 32.116219],
              [47.582583, 32.116075],
              [47.582924, 32.115995],
              [47.583064, 32.115828],
              [47.583567, 32.11578],
              [47.583687, 32.115603],
              [47.583666, 32.115437],
              [47.583524, 32.115203],
              [47.584773, 32.115021],
              [47.585669, 32.115088],
              [47.585957, 32.115027],
              [47.586439, 32.114681],
              [47.586773, 32.114682],
              [47.586938, 32.114591],
              [47.587141, 32.11438],
              [47.587143, 32.11413],
              [47.587083, 32.113923],
              [47.587648, 32.113737],
              [47.587859, 32.113709],
              [47.588242, 32.114075],
              [47.588496, 32.11419],
              [47.588955, 32.115071],
              [47.589111, 32.115227],
              [47.589476, 32.115393],
              [47.589564, 32.115571],
              [47.589183, 32.115908],
              [47.589353, 32.116416],
              [47.589674, 32.116439],
              [47.590173, 32.116717],
              [47.590571, 32.116466],
              [47.590891, 32.116352],
              [47.591198, 32.11632],
              [47.591341, 32.116578],
              [47.591255, 32.116773],
              [47.591278, 32.116944],
              [47.591472, 32.117027],
              [47.592287, 32.11696],
              [47.592809, 32.117155],
              [47.593055, 32.117087],
              [47.593257, 32.117154],
              [47.593411, 32.117131],
              [47.593621, 32.117188],
              [47.594348, 32.117199],
              [47.594533, 32.117227],
              [47.594782, 32.117343],
              [47.595189, 32.117317],
              [47.595493, 32.11747],
              [47.595626, 32.117408],
              [47.595749, 32.117268],
              [47.5959, 32.117231],
              [47.596232, 32.117247],
              [47.596547, 32.117181],
              [47.596834, 32.117224],
              [47.59704, 32.117309],
              [47.597505, 32.117155],
              [47.597654, 32.117005],
              [47.597946, 32.116896],
              [47.598503, 32.117046],
              [47.598743, 32.116956],
              [47.598766, 32.116503],
              [47.599258, 32.116277],
              [47.599665, 32.116322],
              [47.599878, 32.116128],
              [47.599931, 32.115854],
              [47.600197, 32.115579],
              [47.600744, 32.115457],
              [47.600947, 32.115312],
              [47.601261, 32.114788],
              [47.601858, 32.114421],
              [47.602111, 32.114314],
              [47.602345, 32.114375],
              [47.602515, 32.114345],
              [47.60288, 32.11384],
              [47.60356, 32.113481],
              [47.604056, 32.113147],
              [47.604287, 32.113086],
              [47.604641, 32.112862],
              [47.604747, 32.11272],
              [47.604907, 32.112611],
              [47.605206, 32.112505],
              [47.606277, 32.111609],
              [47.606844, 32.111455],
              [47.607013, 32.111571],
              [47.60717, 32.111537],
              [47.607622, 32.111617],
              [47.607899, 32.111732],
              [47.608033, 32.111869],
              [47.608164, 32.111907],
              [47.608371, 32.111798],
              [47.608488, 32.111636],
              [47.608441, 32.11146],
              [47.608482, 32.111226],
              [47.608731, 32.111082],
              [47.609327, 32.11097],
              [47.609651, 32.110784],
              [47.610009, 32.110729],
              [47.61006, 32.110512],
              [47.610252, 32.110326],
              [47.610776, 32.110095],
              [47.610947, 32.10996],
              [47.611278, 32.109868],
              [47.611724, 32.109924],
              [47.611965, 32.109881],
              [47.612246, 32.109901],
              [47.612522, 32.109837],
              [47.612658, 32.109747],
              [47.612706, 32.109493],
              [47.613109, 32.109217],
              [47.613738, 32.109142],
              [47.613864, 32.108968],
              [47.613952, 32.108697],
              [47.614509, 32.108091],
              [47.61496, 32.107717],
              [47.615345, 32.107586],
              [47.615554, 32.107402],
              [47.616126, 32.107049],
              [47.616556, 32.106896],
              [47.617118, 32.106417],
              [47.617339, 32.106344],
              [47.617477, 32.106107],
              [47.617598, 32.106043],
              [47.617712, 32.10589],
              [47.618756, 32.10539],
              [47.619572, 32.104832],
              [47.62147, 32.103803],
              [47.621454, 32.103507],
              [47.621848, 32.10292],
              [47.622215, 32.10258],
              [47.622541, 32.102372],
              [47.622673, 32.102394],
              [47.622745, 32.1025],
              [47.623193, 32.1023],
              [47.623378, 32.101983],
              [47.623951, 32.101621],
              [47.624115, 32.101437],
              [47.624028, 32.101344],
              [47.624032, 32.101101],
              [47.624237, 32.100744],
              [47.624284, 32.100406],
              [47.625351, 32.099217],
              [47.62579, 32.098911],
              [47.626123, 32.098562],
              [47.627187, 32.097925],
              [47.627653, 32.097325],
              [47.628403, 32.096849],
              [47.628581, 32.096389],
              [47.62881, 32.096002],
              [47.629037, 32.095868],
              [47.629439, 32.095728],
              [47.630388, 32.095107],
              [47.630702, 32.094829],
              [47.630908, 32.094616],
              [47.631015, 32.094287],
              [47.631393, 32.094013],
              [47.63168, 32.093398],
              [47.6316, 32.093217],
              [47.631684, 32.093062],
              [47.632448, 32.092733],
              [47.633123, 32.092374],
              [47.633434, 32.092085],
              [47.633598, 32.091762],
              [47.633474, 32.091413],
              [47.633368, 32.091277],
              [47.633574, 32.091178],
              [47.633626, 32.090952],
              [47.634094, 32.090872],
              [47.634238, 32.090965],
              [47.634547, 32.090785],
              [47.634452, 32.090617],
              [47.634786, 32.090206],
              [47.635153, 32.090077],
              [47.635222, 32.089864],
              [47.635372, 32.089816],
              [47.635508, 32.089621],
              [47.635825, 32.089682],
              [47.63631, 32.089388],
              [47.636406, 32.089206],
              [47.636576, 32.089304],
              [47.63676, 32.089312],
              [47.637005, 32.089175],
              [47.637217, 32.088961],
              [47.637419, 32.088873],
              [47.637593, 32.088583],
              [47.637744, 32.088611],
              [47.638134, 32.088418],
              [47.639074, 32.088109],
              [47.639746, 32.087827],
              [47.640243, 32.087505],
              [47.640619, 32.087182],
              [47.641479, 32.086981],
              [47.641939, 32.086776],
              [47.642036, 32.086535],
              [47.642084, 32.086173],
              [47.642325, 32.085883],
              [47.642711, 32.085642],
              [47.643267, 32.085473],
              [47.644256, 32.085062],
              [47.644497, 32.084869],
              [47.645414, 32.084459],
              [47.645511, 32.084314],
              [47.646235, 32.084194],
              [47.64679, 32.083639],
              [47.647104, 32.083542],
              [47.647683, 32.082987],
              [47.64831, 32.08289],
              [47.648576, 32.082963],
              [47.64901, 32.08318],
              [47.649252, 32.083156],
              [47.649541, 32.082987],
              [47.650072, 32.082529],
              [47.650386, 32.082384],
              [47.650555, 32.082094],
              [47.650965, 32.083276],
              [47.651042, 32.082347],
              [47.65071, 32.081339],
              [47.650692, 32.079986],
              [47.650982, 32.077695],
              [47.651158, 32.076972],
              [47.651213, 32.076333],
              [47.651296, 32.076009],
              [47.651611, 32.075292],
              [47.652696, 32.07363],
              [47.653355, 32.072836],
              [47.653669, 32.072299],
              [47.653816, 32.071958],
              [47.65414, 32.070687],
              [47.65409, 32.070521],
              [47.653978, 32.070407],
              [47.653459, 32.070249],
              [47.653337, 32.070121],
              [47.65315, 32.069727],
              [47.652719, 32.069217],
              [47.652698, 32.068741],
              [47.652526, 32.067911],
              [47.652245, 32.067163],
              [47.65195, 32.066649],
              [47.651526, 32.066138],
              [47.650133, 32.064961],
              [47.649937, 32.064698],
              [47.649216, 32.063219],
              [47.648629, 32.062196],
              [47.648467, 32.062133],
              [47.647993, 32.062141],
              [47.647789, 32.062034],
              [47.647548, 32.061974],
              [47.647319, 32.061541],
              [47.647088, 32.061356],
              [47.646836, 32.060767],
              [47.64657, 32.060475],
              [47.646016, 32.060091],
              [47.646058, 32.059732],
              [47.646158, 32.059498],
              [47.646696, 32.058885],
              [47.647166, 32.058624],
              [47.647668, 32.058255],
              [47.648035, 32.057796],
              [47.648316, 32.057302],
              [47.649011, 32.056433],
              [47.650231, 32.055418],
              [47.650855, 32.055078],
              [47.65209, 32.053885],
              [47.652556, 32.053564],
              [47.653248, 32.053294],
              [47.653458, 32.053142],
              [47.653578, 32.052419],
              [47.653915, 32.052131],
              [47.65425, 32.051978],
              [47.654606, 32.051903],
              [47.655172, 32.051584],
              [47.655544, 32.051475],
              [47.656158, 32.051426],
              [47.657255, 32.051124],
              [47.658461, 32.050431],
              [47.658726, 32.050342],
              [47.659045, 32.050408],
              [47.65938, 32.050306],
              [47.660582, 32.049408],
              [47.661217, 32.049251],
              [47.661912, 32.048806],
              [47.662449, 32.048564],
              [47.6627, 32.048518],
              [47.663834, 32.048633],
              [47.664111, 32.048542],
              [47.6644396, 32.0488708],
              [47.6646987, 32.0491255],
              [47.6651397, 32.0493721],
              [47.6656316, 32.0496671],
              [47.7001868, 32.0648534],
              [47.7326755, 32.0791152],
              [47.7500797, 32.0867543],
              [47.7558687, 32.0888433],
              [47.7605285, 32.0907703],
              [47.7670287, 32.0933459],
              [47.7724457, 32.0959656],
              [47.7782975, 32.0987743],
              [47.7818756, 32.1004295],
              [47.7839936, 32.1014906],
              [47.7851791, 32.1020845],
              [47.7884331, 32.1034653],
              [47.7930374, 32.1058585],
              [47.7981873, 32.1086192],
              [47.8020364, 32.111011],
              [47.8050728, 32.1130373],
              [47.8100625, 32.116073],
              [47.8107982, 32.1166055],
              [47.8143997, 32.1192025],
              [47.8186303, 32.1218717],
              [47.8213958, 32.1241275],
              [47.8265496, 32.1279443],
              [47.8309441, 32.1310724],
              [47.8388139, 32.1374699],
              [47.8463593, 32.1446499],
              [47.8503762, 32.1480092],
              [47.8576547, 32.1550512],
              [47.8650436, 32.162738],
              [47.8685798, 32.1673402],
              [47.8729857, 32.1731878],
              [47.8782616, 32.1800913],
              [47.8802185, 32.1823011],
              [47.8816871, 32.1840977],
              [47.8835907, 32.1858441],
              [47.8860893, 32.1876864],
              [47.8900528, 32.1902205],
              [47.8904231, 32.19042],
              [47.8954316, 32.1931183],
              [47.9031983, 32.1975396],
              [47.9075966, 32.1999329],
              [47.9118881, 32.2025104],
              [47.9158553, 32.2051814],
              [47.9182472, 32.2069775],
              [47.9212913, 32.2094658],
              [47.925045, 32.2125978],
              [47.9283103, 32.2156795],
              [47.9316292, 32.2190443],
              [47.9352799, 32.2231405],
              [47.9385491, 32.2282484],
              [47.9417152, 32.2335431],
              [47.942245, 32.2343375],
              [47.9434051, 32.2360769],
              [47.9453125, 32.2384717],
              [47.9485816, 32.24165],
              [47.9517365, 32.2440906],
              [47.9552192, 32.2467622],
              [47.9564797, 32.2476356],
              [47.9598738, 32.2499872],
              [47.9620591, 32.2520436],
              [47.9643631, 32.2537309],
              [47.9681892, 32.2555922],
              [47.9727859, 32.2581369],
              [47.9751319, 32.259133],
              [47.9759483, 32.2594028],
              [47.9770354, 32.25967],
              [47.9781799, 32.2598913],
              [47.9795952, 32.2603421],
              [47.9813995, 32.2612486],
              [47.9830932, 32.2620667],
              [47.9840813, 32.2627485],
              [47.9850235, 32.2638935],
              [47.9856416, 32.2651818],
              [47.9860992, 32.2667007],
              [47.9866752, 32.2686393],
              [47.9869232, 32.2703899],
              [47.9870606, 32.2720025],
              [47.987194, 32.2732972],
              [47.9870987, 32.274174],
              [47.9870034, 32.2749133],
              [47.9866448, 32.2760746],
              [47.9861221, 32.2770922],
              [47.9858627, 32.2777396],
              [47.9849549, 32.2785339],
              [47.9836159, 32.2795139],
              [47.9810371, 32.2807844],
              [47.9806177, 32.2810063],
              [47.9772225, 32.2828028],
              [47.9723396, 32.2856181],
              [47.9681548, 32.288148],
              [47.9656447, 32.2901546],
              [47.9630279, 32.292438],
              [47.9624443, 32.2933661],
              [47.9619751, 32.2943871],
              [47.9617768, 32.2954034],
              [47.9618987, 32.2962809],
              [47.9621429, 32.2977113],
              [47.9625512, 32.2995063],
              [47.9627876, 32.3005668],
              [47.9633637, 32.3026386],
              [47.9638901, 32.3048962],
              [47.9643098, 32.3070634],
              [47.9647218, 32.3090929],
              [47.9655799, 32.311532],
              [47.9670754, 32.3166462],
              [47.969574, 32.3230445],
              [47.9717102, 32.3274573],
              [47.9746055, 32.3317259],
              [47.9760476, 32.3335637],
              [47.9778594, 32.3347477],
              [47.9812584, 32.3367991],
              [47.9848061, 32.3380155],
              [47.9890137, 32.3395992],
              [47.9963929, 32.3424035],
              [48.0000037, 32.3437787],
              [48.0008122, 32.3442443],
              [48.0046012, 32.3461353],
              [48.0085144, 32.3473665],
              [48.0135651, 32.347714],
              [48.0175934, 32.3482016],
              [48.020977, 32.3483695],
              [48.0260811, 32.3491279],
              [48.0290909, 32.3495303],
              [48.0312957, 32.3501164],
              [48.0322647, 32.3503421],
              [48.0335046, 32.3511647],
              [48.0342637, 32.3521766],
              [48.0348587, 32.3530043],
              [48.0354539, 32.3539695],
              [48.0356255, 32.3553508],
              [48.0356369, 32.357285],
              [48.0354385, 32.3597755],
              [48.0345955, 32.3621292],
              [48.0332718, 32.3654092],
              [48.0324859, 32.3682713],
              [48.0316505, 32.3723292],
              [48.0311241, 32.3742665],
              [48.030491, 32.3763005],
              [48.0292741, 32.379486],
              [48.0271415, 32.3826296],
              [48.0257073, 32.3852645],
              [48.0243263, 32.3881756],
              [48.0233115, 32.3897024],
              [48.022892, 32.3915476],
              [48.0221062, 32.395194],
              [48.0214232, 32.3980111],
              [48.0200082, 32.4050214],
              [48.0195504, 32.4096786],
              [48.0194015, 32.4119832],
              [48.0187225, 32.4155397],
              [48.0182038, 32.4189061],
              [48.0188942, 32.4270594],
              [48.019291, 32.4306076],
              [48.0193673, 32.4344795],
              [48.0197144, 32.4382091],
              [48.0201607, 32.4412039],
              [48.0212592, 32.4446109],
              [48.0220871, 32.4481084],
              [48.0225334, 32.4506412],
              [48.0229226, 32.4528052],
              [48.0228843, 32.4549253],
              [48.022892, 32.4566769],
              [48.0224724, 32.4588443],
              [48.0223846, 32.4620248],
              [48.022129, 32.4649309],
              [48.0218849, 32.4691739],
              [48.0216904, 32.4725841],
              [48.0217094, 32.4758573],
              [48.0215072, 32.4786272],
              [48.0213547, 32.4805147],
              [48.020939, 32.4828219],
              [48.0208398, 32.4848978],
              [48.020588, 32.4877093],
              [48.0203819, 32.4896022],
              [48.0201188, 32.4912144],
              [48.0202407, 32.4935186],
              [48.0204696, 32.4957306],
              [48.0206565, 32.5000604],
              [48.0206565, 32.5016022],
              [48.0206794, 32.5030295],
              [48.0205917, 32.5044136],
              [48.0205039, 32.5057075],
              [48.0203553, 32.5066755],
              [48.0200997, 32.5075981],
              [48.0198975, 32.5085264],
              [48.0198957, 32.5085354],
              [48.0197983, 32.5090335],
              [48.0191041, 32.5097766],
              [48.0182458, 32.5103333],
              [48.0175552, 32.5112613],
              [48.0168113, 32.5124202],
              [48.0163384, 32.513439],
              [48.015976, 32.5144582],
              [48.0159301, 32.5150116],
              [48.0157204, 32.5154259],
              [48.0153961, 32.5156143],
              [48.0149651, 32.5158001],
              [48.0147018, 32.516265],
              [48.0145493, 32.5169601],
              [48.0145607, 32.5176501],
              [48.0148392, 32.5181075],
              [48.0152321, 32.5187524],
              [48.0154489, 32.5191301],
              [48.0157318, 32.5196231],
              [48.016182, 32.520497],
              [48.0163041, 32.5214646],
              [48.0162659, 32.5223878],
              [48.0160638, 32.5233567],
              [48.0156975, 32.5242384],
              [48.0146828, 32.5251654],
              [48.0129776, 32.5271197],
              [48.0119158, 32.5279594],
              [48.0111542, 32.5285617],
              [48.0098152, 32.529632],
              [48.0091745, 32.5302205],
              [48.0079422, 32.5313523],
              [48.0064964, 32.5326116],
              [48.0057411, 32.5330309],
              [48.0043374, 32.5334122],
              [48.0029297, 32.5336986],
              [48.001091, 32.5340379],
              [47.9999885, 32.5342753],
              [47.9975361, 32.5349377],
              [47.9969368, 32.5350995],
              [47.9935607, 32.5354696],
              [47.9898032, 32.5357019],
              [47.986805, 32.5357923],
              [47.9846267, 32.5359339],
              [47.9842686, 32.5359781],
              [47.9823951, 32.5362094],
              [47.9813614, 32.536304],
              [47.9805985, 32.5363511],
              [47.9799423, 32.5361663],
              [47.9793968, 32.535939],
              [47.9789581, 32.5354777],
              [47.9786835, 32.5349234],
              [47.978569, 32.5343278],
              [47.9785651, 32.5337305],
              [47.9785614, 32.5330384],
              [47.9787751, 32.5321194],
              [47.9792061, 32.5312463],
              [47.9798584, 32.5305091],
              [47.9803749, 32.5296238],
              [47.9804497, 32.5294955],
              [47.9808274, 32.5285309],
              [47.981041, 32.5280717],
              [47.9810372, 32.5275194],
              [47.9809838, 32.5270583],
              [47.9806519, 32.5263674],
              [47.9802132, 32.5258633],
              [47.9794502, 32.5256804],
              [47.9791428, 32.5256299],
              [47.9772149, 32.5253134],
              [47.9716529, 32.5249946],
              [47.9687119, 32.5247659],
              [47.9659843, 32.5244477],
              [47.9637489, 32.5242201],
              [47.9622765, 32.5238487],
              [47.9606399, 32.5232998],
              [47.9588929, 32.5222883],
              [47.9573632, 32.5214151],
              [47.9565964, 32.5209119],
              [47.9555054, 32.5201755],
              [47.9549561, 32.5196235],
              [47.9546814, 32.5191661],
              [47.9546776, 32.5183365],
              [47.9547806, 32.5169101],
              [47.9548835, 32.5160831],
              [47.9548798, 32.5155781],
              [47.954609, 32.5153462],
              [47.9541702, 32.5151643],
              [47.9538422, 32.515118],
              [47.9526481, 32.5153054],
              [47.9509049, 32.5156711],
              [47.9491653, 32.515994],
              [47.9465523, 32.5162281],
              [47.9447129, 32.5164253],
              [47.9444276, 32.5164559],
              [47.9425773, 32.5170105],
              [47.9405671, 32.5178406],
              [47.939373, 32.5188055],
              [47.9388313, 32.5194977],
              [47.9388351, 32.5200951],
              [47.9389992, 32.5208316],
              [47.9393311, 32.5216105],
              [47.9399338, 32.5223465],
              [47.9407005, 32.5232667],
              [47.9414674, 32.5237271],
              [47.9424477, 32.5240012],
              [47.9438096, 32.5240929],
              [47.9464264, 32.5244135],
              [47.9476815, 32.5245048],
              [47.9484978, 32.5247793],
              [47.9491006, 32.5252831],
              [47.9498139, 32.5259292],
              [47.95047, 32.526849],
              [47.9509125, 32.5278131],
              [47.9509697, 32.5286867],
              [47.9510841, 32.5296519],
              [47.9513588, 32.530434],
              [47.9513055, 32.5304327],
              [47.951416, 32.5307081],
              [47.9517975, 32.5309405],
              [47.9521828, 32.5311707],
              [47.9531632, 32.5313522],
              [47.953598, 32.5314913],
              [47.9540841, 32.5318702],
              [47.9543647, 32.5320891],
              [47.9550247, 32.5329165],
              [47.9554099, 32.5341114],
              [47.9553095, 32.5349405],
              [47.9554319, 32.5351251],
              [47.9558342, 32.5357321],
              [47.9552775, 32.5385041],
              [47.9550816, 32.5387652],
              [47.9544439, 32.5396147],
              [47.954444, 32.5398947],
              [47.9525009, 32.5398947],
              [47.9513907, 32.5398946],
              [47.951098, 32.5397963],
              [47.9506988, 32.5399091],
              [47.9493903, 32.5400013],
              [47.9481925, 32.5400917],
              [47.9476471, 32.5400018],
              [47.9472122, 32.5399101],
              [47.9468841, 32.5397263],
              [47.9466096, 32.5394515],
              [47.9465485, 32.5381157],
              [47.9464341, 32.5371054],
              [47.9463805, 32.5369218],
              [47.9460449, 32.5357706],
              [47.9457131, 32.5345297],
              [47.9448357, 32.5332462],
              [47.944397, 32.5325548],
              [47.9438477, 32.532138],
              [47.9433022, 32.5317731],
              [47.9424821, 32.5314985],
              [47.9413413, 32.5314978],
              [47.9397397, 32.5315727],
              [47.9393768, 32.5315897],
              [47.9377441, 32.5320052],
              [47.9371889, 32.5321876],
              [47.936058, 32.5325591],
              [47.9344825, 32.5332036],
              [47.9337768, 32.5339392],
              [47.9328002, 32.5349499],
              [47.9324226, 32.5358287],
              [47.9323197, 32.5365136],
              [47.9323197, 32.5371582],
              [47.9325408, 32.5375738],
              [47.933033, 32.5380321],
              [47.9336891, 32.5387694],
              [47.9339254, 32.539005],
              [47.9342385, 32.539317],
              [47.9346772, 32.5402382],
              [47.9346806, 32.5407961],
              [47.9346848, 32.5414803],
              [47.934486, 32.5420723],
              [47.9343604, 32.5424461],
              [47.9336053, 32.5438724],
              [47.9328728, 32.5448256],
              [47.9327926, 32.5449299],
              [47.9321441, 32.545757],
              [47.9318161, 32.5462178],
              [47.9317131, 32.5468644],
              [47.9318238, 32.5474126],
              [47.9323159, 32.547828],
              [47.9335136, 32.5480579],
              [47.9346047, 32.54824],
              [47.9357528, 32.5483785],
              [47.9368973, 32.5483771],
              [47.9376029, 32.5483785],
              [47.9380951, 32.5486069],
              [47.9383163, 32.549018],
              [47.9385911, 32.5495724],
              [47.938816, 32.5506755],
              [47.9389305, 32.5518729],
              [47.9387169, 32.5528842],
              [47.9391021, 32.5535742],
              [47.9393234, 32.5541679],
              [47.9395981, 32.5549499],
              [47.9397659, 32.5559164],
              [47.9398804, 32.5566517],
              [47.9398842, 32.5573888],
              [47.9398842, 32.557941],
              [47.9399413, 32.5584],
              [47.9401092, 32.5590442],
              [47.940384, 32.5593642],
              [47.9407653, 32.559689],
              [47.9420737, 32.5596893],
              [47.9430007, 32.5598719],
              [47.9430292, 32.5598838],
              [47.9436569, 32.5601471],
              [47.9442063, 32.5606044],
              [47.9442595, 32.5610205],
              [47.944046, 32.561572],
              [47.9433936, 32.5622638],
              [47.942524, 32.5626303],
              [47.9413652, 32.5628336],
              [47.9409448, 32.5629074],
              [47.9409098, 32.5629074],
              [47.93898, 32.5629091],
              [47.9350548, 32.562908],
              [47.9333114, 32.5628159],
              [47.9315644, 32.5623585],
              [47.9300347, 32.56153],
              [47.928997, 32.5610268],
              [47.9280128, 32.5605204],
              [47.9267578, 32.5600164],
              [47.925663, 32.5593721],
              [47.9248962, 32.5588236],
              [47.9241868, 32.5581774],
              [47.923748, 32.5575333],
              [47.9234161, 32.5568919],
              [47.9229239, 32.5562487],
              [47.9222642, 32.5554189],
              [47.9218826, 32.5548213],
              [47.9210624, 32.5543639],
              [47.9202956, 32.5539056],
              [47.9192048, 32.5537189],
              [47.9182243, 32.5538143],
              [47.9175187, 32.5540877],
              [47.9169731, 32.5544597],
              [47.916388, 32.5550781],
              [47.9163208, 32.5551492],
              [47.9162178, 32.5559738],
              [47.9159618, 32.5581211],
              [47.9159547, 32.5581806],
              [47.915474, 32.5602537],
              [47.9147721, 32.5619088],
              [47.9142303, 32.5628737],
              [47.9135208, 32.5632867],
              [47.912922, 32.5633802],
              [47.9116707, 32.5635635],
              [47.9111241, 32.5634937],
              [47.9102515, 32.5633821],
              [47.9094354, 32.5633801],
              [47.9092063, 32.5633867],
              [47.9077987, 32.5634277],
              [47.9067078, 32.5634729],
              [47.9049644, 32.5636599],
              [47.9034385, 32.5642579],
              [47.9025689, 32.5647616],
              [47.9019203, 32.5655434],
              [47.9011575, 32.5661422],
              [47.9007263, 32.5669249],
              [47.9007103, 32.5669758],
              [47.9005089, 32.5676159],
              [47.9006195, 32.5683061],
              [47.9012794, 32.5690391],
              [47.9025917, 32.5698671],
              [47.9035525, 32.5702541],
              [47.9037362, 32.5703281],
              [47.9051552, 32.5708319],
              [47.9059219, 32.5711528],
              [47.90625, 32.571659],
              [47.9064178, 32.5722581],
              [47.9062576, 32.5733157],
              [47.9062081, 32.5743716],
              [47.9063226, 32.5753819],
              [47.9065972, 32.5761189],
              [47.9067146, 32.5763164],
              [47.9070891, 32.5769469],
              [47.9073677, 32.5776817],
              [47.9078064, 32.5783687],
              [47.9082985, 32.5786468],
              [47.9095001, 32.5792894],
              [47.9101259, 32.5794954],
              [47.9104842, 32.5796134],
              [47.9116288, 32.5797948],
              [47.9122848, 32.5797952],
              [47.9128266, 32.5795178],
              [47.913536, 32.5791971],
              [47.9145165, 32.5791964],
              [47.9162063, 32.5791974],
              [47.9170047, 32.5793351],
              [47.9180641, 32.579518],
              [47.9192124, 32.5799744],
              [47.9200162, 32.5802791],
              [47.9207954, 32.5805744],
              [47.9221611, 32.5809392],
              [47.9228133, 32.5809868],
              [47.9232647, 32.580911],
              [47.9238007, 32.5806698],
              [47.9240647, 32.5803864],
              [47.9244995, 32.5797434],
              [47.9247704, 32.5791482],
              [47.9251481, 32.5785489],
              [47.9257469, 32.5784103],
              [47.9265099, 32.5781315],
              [47.9274902, 32.578133],
              [47.928421, 32.5781332],
              [47.9296188, 32.5783158],
              [47.9300575, 32.5784978],
              [47.930142, 32.5785614],
              [47.9305497, 32.5788682],
              [47.9311524, 32.5795095],
              [47.9320832, 32.5807065],
              [47.9324847, 32.5815836],
              [47.9325256, 32.581673],
              [47.9328576, 32.5824091],
              [47.9328575, 32.5828666],
              [47.9326973, 32.5835569],
              [47.9323197, 32.5840638],
              [47.93161, 32.584522],
              [47.9305763, 32.5850287],
              [47.928997, 32.5856752],
              [47.9280561, 32.5860883],
              [47.9275283, 32.58632],
              [47.9266052, 32.5869172],
              [47.9247055, 32.5888022],
              [47.9230765, 32.5905046],
              [47.9207917, 32.5926213],
              [47.9180222, 32.5948297],
              [47.9166068, 32.5959331],
              [47.9159012, 32.5969435],
              [47.9151993, 32.5986911],
              [47.9148217, 32.5999327],
              [47.9146117, 32.6011739],
              [47.9145584, 32.6018172],
              [47.9147264, 32.6024163],
              [47.9152184, 32.6027823],
              [47.9159812, 32.6028754],
              [47.9164832, 32.6029102],
              [47.9166373, 32.6029208],
              [47.9176177, 32.6026925],
              [47.9188727, 32.6023221],
              [47.920723, 32.6015404],
              [47.9230652, 32.600667],
              [47.924862, 32.6002535],
              [47.926609, 32.5998838],
              [47.9289513, 32.5994678],
              [47.9304809, 32.5993768],
              [47.9315719, 32.5994215],
              [47.9323882, 32.599606],
              [47.932991, 32.5998348],
              [47.9335938, 32.6003409],
              [47.9341431, 32.6009854],
              [47.934475, 32.601859],
              [47.9349709, 32.6030544],
              [47.9352649, 32.6044632],
              [47.9353065, 32.6046628],
              [47.9359665, 32.6058577],
              [47.9366265, 32.6070549],
              [47.9375573, 32.6082045],
              [47.9380447, 32.6087568],
              [47.9380707, 32.6087862],
              [47.9383277, 32.6090775],
              [47.9393121, 32.6099513],
              [47.9403534, 32.6103621],
              [47.9413376, 32.6108256],
              [47.9424287, 32.6109153],
              [47.9433556, 32.6109153],
              [47.9445, 32.6107336],
              [47.9457398, 32.6104506],
              [47.9459191, 32.6104097],
              [47.9475517, 32.6099964],
              [47.9485893, 32.6097647],
              [47.9493523, 32.6095804],
              [47.9501152, 32.6097184],
              [47.9507905, 32.6098908],
              [47.951374, 32.6100398],
              [47.9545441, 32.611282],
              [47.9560203, 32.6116942],
              [47.95755, 32.6123399],
              [47.9588623, 32.6127052],
              [47.9600639, 32.6129349],
              [47.961483, 32.6129333],
              [47.963829, 32.612706],
              [47.9652482, 32.6124722],
              [47.9674836, 32.6125172],
              [47.9702149, 32.6126553],
              [47.9725609, 32.6128381],
              [47.9745788, 32.6126546],
              [47.9756164, 32.6124272],
              [47.9770851, 32.611827],
              [47.9785538, 32.6107219],
              [47.9793716, 32.6101549],
              [47.9797477, 32.6098941],
              [47.9807281, 32.6093452],
              [47.9818192, 32.609065],
              [47.9829636, 32.6088829],
              [47.9845467, 32.6090201],
              [47.9847862, 32.6090954],
              [47.9858589, 32.6094325],
              [47.9870071, 32.6100303],
              [47.9876671, 32.6107223],
              [47.9883271, 32.6114121],
              [47.9887123, 32.6121494],
              [47.9892081, 32.6128352],
              [47.9893189, 32.6134802],
              [47.9892159, 32.6143523],
              [47.9889985, 32.614906],
              [47.9882964, 32.6157344],
              [47.9864998, 32.6168408],
              [47.9851417, 32.6176218],
              [47.9835626, 32.6183119],
              [47.9821434, 32.6188164],
              [47.9809493, 32.6195991],
              [47.9794808, 32.6207493],
              [47.9785081, 32.622085],
              [47.977581, 32.6228177],
              [47.9762229, 32.6235085],
              [47.9748039, 32.6238778],
              [47.9733315, 32.6243404],
              [47.9713173, 32.6252136],
              [47.9693031, 32.6262243],
              [47.9639664, 32.6288495],
              [47.9626046, 32.6293981],
              [47.9611358, 32.6303181],
              [47.9596672, 32.6311503],
              [47.9583626, 32.6322051],
              [47.9569511, 32.6334465],
              [47.9554824, 32.6345514],
              [47.9546661, 32.6353339],
              [47.9545594, 32.6359782],
              [47.9548378, 32.6372178],
              [47.9553872, 32.6379547],
              [47.9564858, 32.6385989],
              [47.9569065, 32.6387883],
              [47.9579087, 32.6392397],
              [47.9592781, 32.6402083],
              [47.9606476, 32.6409875],
              [47.9611931, 32.6414042],
              [47.9620704, 32.6422774],
              [47.9624595, 32.6429675],
              [47.9624062, 32.6437956],
              [47.9621925, 32.6443472],
              [47.9617428, 32.6447949],
              [47.9615936, 32.6449435],
              [47.9612694, 32.6454495],
              [47.9609451, 32.6460502],
              [47.960949, 32.6469225],
              [47.9610634, 32.6478877],
              [47.961506, 32.6489442],
              [47.9621123, 32.6502346],
              [47.962883, 32.6512901],
              [47.9639816, 32.6523467],
              [47.9648349, 32.6530119],
              [47.9654617, 32.6535005],
              [47.9665603, 32.6544196],
              [47.9672737, 32.655246],
              [47.9677696, 32.6558913],
              [47.9679909, 32.6565323],
              [47.968212, 32.6571777],
              [47.9686507, 32.6577766],
              [47.9691466, 32.6582799],
              [47.9693907, 32.6587288],
              [47.9588904, 32.6668393],
              [47.9586139, 32.6671192],
              [47.9525004, 32.6748936],
              [47.950557, 32.6790651],
              [47.9519438, 32.6860087],
              [47.9516672, 32.6862887],
              [47.9502769, 32.6901803],
              [47.9411104, 32.6987853],
              [47.9288874, 32.7071194],
              [47.9286104, 32.7073992],
              [47.918054, 32.7126725],
              [47.9172207, 32.7135122],
              [47.9161106, 32.7140629],
              [47.9102776, 32.7212864],
              [47.9105541, 32.7235076],
              [47.9161105, 32.7276792],
              [47.9172207, 32.7276793],
              [47.9222208, 32.7296206],
              [47.9227774, 32.7299004],
              [47.9238873, 32.7310111],
              [47.9247205, 32.737124],
              [47.9244438, 32.7374039],
              [47.9275005, 32.7462887],
              [47.9305537, 32.7471195],
              [47.9308338, 32.7473994],
              [47.931667, 32.7473994],
              [47.9350003, 32.7499005],
              [47.9352768, 32.7551737],
              [47.9350002, 32.7560044],
              [47.9394436, 32.7623972],
              [47.9400004, 32.7623972],
              [47.9400003, 32.7626771],
              [47.9408335, 32.7626771],
              [47.9419438, 32.7632278],
              [47.9433336, 32.7637876],
              [47.9486102, 32.7651782],
              [47.9580566, 32.7660089],
              [47.9586136, 32.7662888],
              [47.9630567, 32.7662889],
              [47.9636133, 32.7665688],
              [47.9825031, 32.7668397],
              [47.9830563, 32.7671196],
              [47.990836, 32.7671196],
              [47.991113, 32.7673995],
              [47.9916697, 32.7671196],
              [47.9952795, 32.7676794],
              [47.996946, 32.7676794],
              [47.9988928, 32.7685101],
              [48.0063926, 32.7743431],
              [48.0066692, 32.7746231],
              [48.0100024, 32.7793454],
              [48.0125025, 32.7904605],
              [48.0116692, 32.7937923],
              [48.0113927, 32.7940722],
              [48.0094457, 32.8007358],
              [48.0030593, 32.8110111],
              [48.0027791, 32.8112911],
              [48.0033358, 32.8118509],
              [48.0033357, 32.8129525],
              [48.0033358, 32.8132324],
              [48.0033358, 32.8135123],
              [48.0033357, 32.8137922],
              [48.0027792, 32.8151827],
              [48.0025026, 32.8165642],
              [48.0025025, 32.8168441],
              [48.0025026, 32.817124],
              [48.0013928, 32.8193452],
              [48.0011126, 32.8204558],
              [48.0008361, 32.8212865],
              [48.0005591, 32.8224062],
              [48.0002794, 32.8232368],
              [47.9952793, 32.8390652],
              [47.9952793, 32.8412864],
              [47.9952793, 32.8418461],
              [47.9941696, 32.8435165],
              [47.9913893, 32.8462976],
              [47.9897225, 32.8462976],
              [47.9897226, 32.8460177],
              [47.9886127, 32.8460177],
              [47.9883362, 32.8457378],
              [47.9875026, 32.8457377],
              [47.9863893, 32.844898],
              [47.9852795, 32.844898],
              [47.9850029, 32.8446181],
              [47.9847228, 32.8446181],
              [47.9833361, 32.8446181],
              [47.9825029, 32.844898],
              [47.9813896, 32.8460177],
              [47.9813896, 32.8465685],
              [47.981113, 32.8468483],
              [47.9822228, 32.8501802],
              [47.9827794, 32.85046],
              [47.9833361, 32.8518505],
              [47.983336, 32.8526813],
              [47.9833361, 32.8529612],
              [47.9811129, 32.8551823],
              [47.9800028, 32.8551823],
              [47.9797227, 32.8554623],
              [47.9780563, 32.8554622],
              [47.9772226, 32.8557331],
              [47.9769461, 32.856013],
              [47.974723, 32.856013],
              [47.9733327, 32.8565638],
              [47.9658329, 32.8649069],
              [47.9652798, 32.8660084],
              [47.9649998, 32.867408],
              [47.9647232, 32.8682387],
              [47.9644461, 32.8707398],
              [47.9641661, 32.872681],
              [47.9638895, 32.8737916],
              [47.9630563, 32.8749022],
              [47.9591663, 32.878234],
              [47.9580562, 32.8779631],
              [47.9547229, 32.878234],
              [47.9438898, 32.8832361],
              [47.9366666, 32.8893489],
              [47.93611, 32.8896198],
              [47.9344432, 32.8924008],
              [47.9347197, 32.8940712],
              [47.9349998, 32.8949019],
              [47.9355534, 32.8987935],
              [47.9344431, 32.8999041],
              [47.9313864, 32.9015654],
              [47.9263868, 32.9001839],
              [47.9236101, 32.9015654],
              [47.9230534, 32.9015654],
              [47.9194436, 32.905457],
              [47.9147201, 32.9079581],
              [47.912497, 32.9079581],
              [47.9105536, 32.9074073],
              [47.910277, 32.9071274],
              [47.9061101, 32.9071274],
              [47.9049969, 32.9076782],
              [47.9044438, 32.9087887],
              [47.9047202, 32.9115697],
              [47.9027768, 32.913791],
              [47.9016636, 32.9137909],
              [47.8997202, 32.9121296],
              [47.8966639, 32.9112898],
              [47.8941638, 32.9112898],
              [47.8936071, 32.9115697],
              [47.892497, 32.9115697],
              [47.8894402, 32.9140708],
              [47.8891636, 32.9149015],
              [47.8888872, 32.9157321],
              [47.8877738, 32.9187931],
              [47.8874973, 32.919073],
              [47.886107, 32.9201836],
              [47.8794404, 32.9229555],
              [47.8774974, 32.9268471],
              [47.8774974, 32.9324091],
              [47.8741641, 32.9365715],
              [47.8719406, 32.9382329],
              [47.8702739, 32.9387927],
              [47.8694405, 32.9387926],
              [47.8691641, 32.9390726],
              [47.8677742, 32.9390726],
              [47.8633307, 32.9349011],
              [47.862774, 32.9349011],
              [47.8613842, 32.9346301],
              [47.8605509, 32.9346302],
              [47.860274, 32.9343503],
              [47.8577743, 32.9343503],
              [47.8572173, 32.9340704],
              [47.8563841, 32.9343502],
              [47.8561076, 32.9340704],
              [47.8555509, 32.9343503],
              [47.8533274, 32.9343503],
              [47.8491608, 32.9362915],
              [47.8486078, 32.9368513],
              [47.8477741, 32.9371222],
              [47.8374942, 32.9482371],
              [47.8333277, 32.951018],
              [47.8322179, 32.9518487],
              [47.8299944, 32.9532393],
              [47.825828, 32.9582414],
              [47.8258279, 32.959072],
              [47.8211044, 32.9654556],
              [47.8111046, 32.9710176],
              [47.8097147, 32.9718482],
              [47.7999915, 32.9740693],
              [47.798048, 32.9746293],
              [47.7969382, 32.9746291],
              [47.7911049, 32.9765704],
              [47.7905483, 32.9765703],
              [47.7902718, 32.9768503],
              [47.7888814, 32.9774101],
              [47.7849915, 32.9785117],
              [47.784715, 32.9787916],
              [47.7808251, 32.9787915],
              [47.7802685, 32.9790714],
              [47.7780484, 32.9790714],
              [47.7763816, 32.9796312],
              [47.7760044, 32.9799021],
              [47.7722151, 32.9832429],
              [47.7713818, 32.9846333],
              [47.7616586, 32.9937979],
              [47.7533252, 32.9982401],
              [47.7519353, 32.9982401],
              [47.7505454, 32.9982402],
              [47.7499919, 32.9979603],
              [47.7491587, 32.9979603],
              [47.7444356, 32.9951883],
              [47.7441555, 32.9949084],
              [47.7422121, 32.9949085],
              [47.7308224, 32.9993507],
              [47.7302689, 33.0007412],
              [47.728599, 33.0026824],
              [47.7280458, 33.0026824],
              [47.7274892, 33.0032423],
              [47.7269321, 33.0032422],
              [47.7266555, 33.0035221],
              [47.7235988, 33.0035221],
              [47.7230457, 33.0032422],
              [47.7216558, 33.0032422],
              [47.7210992, 33.0029623],
              [47.7180459, 33.0029623],
              [47.717489, 33.0032422],
              [47.7122127, 33.0049036],
              [47.7116561, 33.0049035],
              [47.7113791, 33.0051834],
              [47.7083227, 33.0051834],
              [47.7080427, 33.0049035],
              [47.7063759, 33.0049034],
              [47.691656, 33.0021316],
              [47.6905427, 33.0024024],
              [47.6872094, 33.0051834],
              [47.6799862, 33.008795],
              [47.6797096, 33.0090749],
              [47.6785995, 33.0093457],
              [47.6783194, 33.0096257],
              [47.6772095, 33.0096257],
              [47.6769331, 33.0099056],
              [47.6760999, 33.0099056],
              [47.6758198, 33.0101854],
              [47.6749861, 33.0101855],
              [47.661653, 33.0176795],
              [47.6605432, 33.01907],
              [47.65721, 33.0201806],
              [47.6538732, 33.0235123],
              [47.6505399, 33.0257334],
              [47.6502634, 33.0260134],
              [47.648873, 33.0260133],
              [47.6485965, 33.0262933],
              [47.6466535, 33.0262933],
              [47.6458199, 33.026853],
              [47.6416534, 33.0326858],
              [47.6408201, 33.0332366],
              [47.6405401, 33.0337964],
              [47.6372067, 33.0343471],
              [47.6366533, 33.034627],
              [47.6341501, 33.0346271],
              [47.6335969, 33.0349069],
              [47.6322067, 33.0349069],
              [47.6308168, 33.0343471],
              [47.6288734, 33.0326857],
              [47.6280402, 33.0324059],
              [47.6255401, 33.0318461],
              [47.6247069, 33.0318461],
              [47.6244304, 33.032126],
              [47.6238737, 33.0321259],
              [47.6197069, 33.0362883],
              [47.6124836, 33.0387984],
              [47.6113738, 33.0387983],
              [47.6019272, 33.0465724],
              [47.6002604, 33.0471231],
              [47.5999837, 33.047403],
              [47.5977607, 33.047403],
              [47.5933172, 33.0451819],
              [47.5922039, 33.0451818],
              [47.5874839, 33.0490733],
              [47.5872038, 33.0493533],
              [47.5799841, 33.060179],
              [47.5797039, 33.0607388],
              [47.5788708, 33.0610187],
              [47.5785942, 33.0615695],
              [47.5755375, 33.06268],
              [47.5669275, 33.0715736],
              [47.5644275, 33.0740746],
              [47.5622043, 33.0762957],
              [47.556091, 33.0790766],
              [47.5522045, 33.0860199],
              [47.5499811, 33.0871304],
              [47.5491478, 33.0871304],
              [47.5469244, 33.08546],
              [47.5458403, 33.0818492],
              [47.5440654, 33.0815966],
              [47.5432435, 33.081301],
              [47.541999, 33.0808941],
              [47.5403342, 33.0814237],
              [47.539566, 33.0828297],
              [47.5376454, 33.0844568],
              [47.5328328, 33.0835832],
              [47.5291479, 33.0857399],
              [47.5305451, 33.088101],
              [47.527758, 33.0904621],
              [47.5256132, 33.0922632],
              [47.5255392, 33.0934766],
              [47.5259884, 33.0958458],
              [47.5254563, 33.0990389],
              [47.5226399, 33.1013522],
              [47.5236166, 33.1042694],
              [47.5233055, 33.1053696],
              [47.5222314, 33.1062316],
              [47.5191274, 33.1069899],
              [47.5146359, 33.1041982],
              [47.5133302, 33.1022425],
              [47.5116447, 33.1015767],
              [47.5107208, 33.1017614],
              [47.5101803, 33.1018585],
              [47.5092308, 33.1019952],
              [47.5086514, 33.1021194],
              [47.5083352, 33.1023843],
              [47.508061, 33.102614],
              [47.5057499, 33.103622],
              [47.5013386, 33.1049149],
              [47.499645, 33.1073299],
              [47.4955276, 33.1128952],
              [47.4922255, 33.1134397],
              [47.4896619, 33.1149593],
              [47.4914894, 33.1170929],
              [47.4919216, 33.1182439],
              [47.4866449, 33.1207449],
              [47.4844218, 33.123246],
              [47.4827441, 33.1239906],
              [47.4814727, 33.1255496],
              [47.4818534, 33.1278483],
              [47.4847745, 33.1292705],
              [47.487262, 33.1299219],
              [47.4886482, 33.129211],
              [47.4894187, 33.1294441],
              [47.4898592, 33.1297199],
              [47.4901227, 33.1314066],
              [47.4880533, 33.1327125],
              [47.4794217, 33.1349022],
              [47.4769216, 33.1376922],
              [47.4766451, 33.1385138],
              [47.4763649, 33.1401841],
              [47.4758119, 33.1424142],
              [47.4758119, 33.142965],
              [47.474145, 33.1446263],
              [47.474145, 33.1449062],
              [47.4733118, 33.1449062],
              [47.4730317, 33.1451861],
              [47.4727551, 33.145457],
              [47.4719219, 33.1454569],
              [47.4719219, 33.1457368],
              [47.4710887, 33.1457368],
              [47.4710887, 33.1460258],
              [47.4705321, 33.1460258],
              [47.4699785, 33.1462966],
              [47.4671398, 33.1478451],
              [47.4608087, 33.1512986],
              [47.4563654, 33.1512986],
              [47.4560888, 33.1515785],
              [47.4538652, 33.1515785],
              [47.4505321, 33.1521292],
              [47.4499753, 33.1524092],
              [47.4494222, 33.1524091],
              [47.4491421, 33.152689],
              [47.448589, 33.1526891],
              [47.448589, 33.152969],
              [47.4474753, 33.1529689],
              [47.4458089, 33.1535197],
              [47.444419, 33.1535196],
              [47.444142, 33.1537996],
              [47.4413655, 33.1537995],
              [47.4408087, 33.1535196],
              [47.4402521, 33.1535197],
              [47.4391423, 33.1532397],
              [47.4374755, 33.1532398],
              [47.4358091, 33.1551899],
              [47.435809, 33.1590724],
              [47.4371989, 33.169907],
              [47.4369188, 33.1704668],
              [47.4333089, 33.1724079],
              [47.4327522, 33.1724079],
              [47.4313656, 33.1740692],
              [47.4308088, 33.1743491],
              [47.4308088, 33.1749089],
              [47.4302523, 33.1754597],
              [47.4302522, 33.1760195],
              [47.4299756, 33.1762994],
              [47.4299757, 33.1765791],
              [47.429419, 33.1768591],
              [47.4255291, 33.1768591],
              [47.4252526, 33.1765792],
              [47.4241424, 33.1765792],
              [47.4238627, 33.1762993],
              [47.4224759, 33.1762993],
              [47.4221954, 33.1760194],
              [47.4188625, 33.1760194],
              [47.4158093, 33.17713],
              [47.4149757, 33.1779696],
              [47.4152524, 33.1788003],
              [47.4188625, 33.1804616],
              [47.4199759, 33.1813013],
              [47.4196953, 33.1815721],
              [47.4194188, 33.1821319],
              [47.4194188, 33.1824118],
              [47.4158094, 33.1857434],
              [47.4069193, 33.1888041],
              [47.4060857, 33.1888042],
              [47.4030294, 33.1907454],
              [47.3996957, 33.1976884],
              [47.3952526, 33.1990699],
              [47.3919197, 33.1968488],
              [47.3905292, 33.1965779],
              [47.3894157, 33.1965779],
              [47.3877493, 33.1974085],
              [47.3871962, 33.1979593],
              [47.3863626, 33.1982391],
              [47.3808062, 33.2046315],
              [47.3749733, 33.2093536],
              [47.3719162, 33.2104641],
              [47.3680262, 33.210464],
              [47.3602496, 33.2035209],
              [47.3583066, 33.2024104],
              [47.3571933, 33.2024104],
              [47.3566401, 33.2021305],
              [47.3538596, 33.2060219],
              [47.3535831, 33.2062927],
              [47.3533065, 33.2088028],
              [47.3530268, 33.210464],
              [47.3527502, 33.2132449],
              [47.3527501, 33.2146262],
              [47.3524735, 33.215186],
              [47.3510829, 33.2174071],
              [47.3508032, 33.2179669],
              [47.3469164, 33.2190774],
              [47.3444164, 33.2190774],
              [47.338303, 33.2162965],
              [47.3360834, 33.2162965],
              [47.3330271, 33.2174071],
              [47.3313599, 33.2193572],
              [47.3310802, 33.2218491],
              [47.3283036, 33.2249099],
              [47.3263606, 33.2249099],
              [47.3258035, 33.22463],
              [47.3246933, 33.2246299],
              [47.3199706, 33.2224089],
              [47.3169135, 33.2212984],
              [47.3119134, 33.2204677],
              [47.3099704, 33.2226888],
              [47.3105235, 33.2265801],
              [47.310804, 33.2271309],
              [47.3105235, 33.2276906],
              [47.3094133, 33.2299118],
              [47.3085805, 33.2301826],
              [47.308304, 33.2304715],
              [47.3074704, 33.2304715],
              [47.3033038, 33.2274107],
              [47.3021906, 33.2274107],
              [47.301914, 33.2271309],
              [47.3013569, 33.2271309],
              [47.2991373, 33.2274107],
              [47.2971904, 33.2296319],
              [47.2974709, 33.2321327],
              [47.2971904, 33.2324126],
              [47.2883004, 33.2379652],
              [47.2860808, 33.2379652],
              [47.2808011, 33.233794],
              [47.2771908, 33.2310222],
              [47.2749674, 33.2310222],
              [47.2733009, 33.2315729],
              [47.2713579, 33.2329634],
              [47.2702438, 33.2346336],
              [47.2694109, 33.2368547],
              [47.2660772, 33.2451881],
              [47.2594107, 33.2496303],
              [47.2588576, 33.2501901],
              [47.2552443, 33.2515713],
              [47.2552442, 33.2518513],
              [47.2546879, 33.2518512],
              [47.2544114, 33.2521312],
              [47.2524676, 33.2521311],
              [47.2505206, 33.2510206],
              [47.2474675, 33.2462986],
              [47.2474675, 33.2460187],
              [47.2463542, 33.2451881],
              [47.2463542, 33.2443575],
              [47.2455214, 33.2440776],
              [47.2427447, 33.2440776],
              [47.2396877, 33.2446283],
              [47.2324649, 33.2479689],
              [47.2319109, 33.2487995],
              [47.2305211, 33.2504608],
              [47.230521, 33.2513004],
              [47.2302445, 33.2515714],
              [47.2330212, 33.2599137],
              [47.2327445, 33.2601847],
              [47.2324648, 33.2629654],
              [47.2288546, 33.2682472],
              [47.2288546, 33.2687979],
              [47.2282983, 33.2690778],
              [47.2282983, 33.2696285],
              [47.2252443, 33.27324],
              [47.222188, 33.2746304],
              [47.2196879, 33.2751902],
              [47.2177411, 33.2751901],
              [47.2174645, 33.2754701],
              [47.2141316, 33.2751901],
              [47.213855, 33.2749103],
              [47.2121878, 33.2749103],
              [47.2116316, 33.2746303],
              [47.2044079, 33.2746303],
              [47.2013548, 33.2757408],
              [47.1955179, 33.2826838],
              [47.2007985, 33.2907463],
              [47.2030219, 33.2932473],
              [47.2038548, 33.2943577],
              [47.2044079, 33.29852],
              [47.2041313, 33.2990797],
              [47.2019079, 33.3024113],
              [47.201075, 33.3024112],
              [47.2007984, 33.3026911],
              [47.1996851, 33.3026911],
              [47.1991312, 33.3024113],
              [47.1977413, 33.3024112],
              [47.1910748, 33.2990796],
              [47.1894084, 33.2990796],
              [47.1891318, 33.2987997],
              [47.1880185, 33.2987998],
              [47.1805183, 33.3015716],
              [47.1795837, 33.3062327],
              [47.177808, 33.3084196],
              [47.1760399, 33.313121],
              [47.1742718, 33.3160089],
              [47.1708965, 33.3193668],
              [47.1659137, 33.3219186],
              [47.1628598, 33.3248062],
              [47.1575556, 33.3287681],
              [47.1539391, 33.3324612],
              [47.150403, 33.3352813],
              [47.1469473, 33.3376313],
              [47.1440318, 33.3394405],
              [47.1417815, 33.3397762],
              [47.1376828, 33.3403133],
              [47.1347093, 33.3403804],
              [47.1318965, 33.3403804],
              [47.1295658, 33.340649],
              [47.1272352, 33.3403804],
              [47.1254671, 33.3395076],
              [47.1240205, 33.3378962],
              [47.1232972, 33.3364191],
              [47.1206452, 33.3356134],
              [47.1173501, 33.3351434],
              [47.1125281, 33.3338005],
              [47.1111183, 33.3337774],
              [47.1084295, 33.3337333],
              [47.1054559, 33.3349419],
              [47.1034467, 33.3364191],
              [47.1022412, 33.3378962],
              [47.1019198, 33.3399776],
              [47.1013572, 33.3417232],
              [47.1023216, 33.3437373],
              [47.1038486, 33.3458186],
              [47.1050541, 33.3472284],
              [47.1056166, 33.3489739],
              [47.1038486, 33.3496452],
              [47.1017813, 33.349842],
              [47.0988494, 33.3494569],
              [47.097012, 33.3500698],
              [47.0947672, 33.3506522],
              [47.0931598, 33.3511221],
              [47.0905881, 33.3523976],
              [47.0885789, 33.3526661],
              [47.0876094, 33.3524296],
              [47.0860876, 33.3517934],
              [47.0845606, 33.3519948],
              [47.0808638, 33.3521291],
              [47.0786135, 33.3524647],
              [47.0767651, 33.3540758],
              [47.0778075, 33.3560575],
              [47.0761198, 33.3583398],
              [47.0739499, 33.3597494],
              [47.0712174, 33.3598837],
              [47.0675206, 33.3599508],
              [47.0613324, 33.360622],
              [47.0586803, 33.3618974],
              [47.0565907, 33.3650521],
              [47.0558674, 33.3686094],
              [47.0542601, 33.3713612],
              [47.0505632, 33.3728378],
              [47.0462235, 33.3737774],
              [47.0430088, 33.3747841],
              [47.0397941, 33.377133],
              [47.033847, 33.3782739],
              [47.0310342, 33.3799516],
              [47.0307931, 33.383911],
              [47.0297112, 33.385074],
              [47.0268698, 33.3861653],
              [47.0250514, 33.3873041],
              [47.0224373, 33.3877311],
              [47.0204483, 33.3865924],
              [47.0167927, 33.3855445],
              [47.0166409, 33.385501],
              [47.0136858, 33.3853587],
              [47.0110718, 33.3857383],
              [47.0088555, 33.3869245],
              [47.0074348, 33.3884429],
              [47.0073211, 33.3911474],
              [47.0064119, 33.3929978],
              [47.0062414, 33.3952752],
              [47.0062414, 33.3973628],
              [47.0064687, 33.3994503],
              [47.007378, 33.4010633],
              [47.0088555, 33.4028661],
              [47.0114696, 33.4047163],
              [47.0148224, 33.4055702],
              [47.0181752, 33.406851],
              [47.021528, 33.4079421],
              [47.0221377, 33.4096712],
              [47.0228764, 33.4116161],
              [47.0228764, 33.4137507],
              [47.0228764, 33.4155532],
              [47.0231606, 33.4171185],
              [47.0237857, 33.4188735],
              [47.0239562, 33.4198221],
              [47.0254337, 33.4198696],
              [47.0261156, 33.420249],
              [47.0257747, 33.4213874],
              [47.0245245, 33.4219565],
              [47.0234447, 33.4229526],
              [47.0204329, 33.423332],
              [47.0180461, 33.4237114],
              [47.0147501, 33.4245177],
              [47.0139545, 33.4258457],
              [47.014466, 33.4281697],
              [47.0149206, 33.4299245],
              [47.0145796, 33.4319638],
              [47.0128748, 33.4340979],
              [47.0112268, 33.4361845],
              [47.0100902, 33.4374649],
              [47.0074193, 33.438034],
              [47.0043506, 33.4376072],
              [47.0012251, 33.4372278],
              [46.9984406, 33.4367061],
              [46.9960538, 33.4360897],
              [46.9937239, 33.4363742],
              [46.9926441, 33.4376072],
              [46.9913939, 33.4396463],
              [46.9913939, 33.4416854],
              [46.992019, 33.4431554],
              [46.9930419, 33.4446253],
              [46.9946899, 33.4458582],
              [46.9944058, 33.4469488],
              [46.9924168, 33.4478971],
              [46.991053, 33.4468539],
              [46.9901437, 33.4455737],
              [46.9901437, 33.444246],
              [46.9891776, 33.4441511],
              [46.9867909, 33.4445305],
              [46.9845746, 33.4460953],
              [46.982813, 33.4463798],
              [46.9802557, 33.4456685],
              [46.9778689, 33.4469014],
              [46.9756527, 33.4485609],
              [46.9734364, 33.4505998],
              [46.970254, 33.4511214],
              [46.9679809, 33.4524015],
              [46.9664299, 33.453804],
              [46.9648955, 33.4546574],
              [46.9640431, 33.4557953],
              [46.9640999, 33.4573599],
              [46.9651796, 33.45864],
              [46.9648387, 33.4598252],
              [46.9638726, 33.4604889],
              [46.9626224, 33.4621009],
              [46.9606334, 33.4627172],
              [46.9588718, 33.4627646],
              [46.9573943, 33.4634283],
              [46.9554621, 33.4635705],
              [46.9544392, 33.4629068],
              [46.9529049, 33.4621009],
              [46.9505749, 33.4619586],
              [46.9478472, 33.4636179],
              [46.9454036, 33.4652772],
              [46.9431873, 33.4669364],
              [46.9410279, 33.4674578],
              [46.9384138, 33.4674578],
              [46.9351178, 33.4692592],
              [46.9317275, 33.4715915],
              [46.9319548, 33.4725395],
              [46.9317275, 33.4739142],
              [46.9308182, 33.4753836],
              [46.9298522, 33.4767109],
              [46.9287725, 33.4778485],
              [46.9267835, 33.4780381],
              [46.9249082, 33.4774219],
              [46.9230329, 33.4771375],
              [46.9210439, 33.4770901],
              [46.9186571, 33.4774219],
              [46.9168386, 33.4782277],
              [46.9160431, 33.4796023],
              [46.9151338, 33.480882],
              [46.9139404, 33.482304],
              [46.9132017, 33.4837259],
              [46.9120083, 33.4852425],
              [46.9104739, 33.4859061],
              [46.9083145, 33.4864274],
              [46.906496, 33.4876597],
              [46.9054731, 33.4896503],
              [46.9052458, 33.4917355],
              [46.9062687, 33.4936312],
              [46.9072916, 33.4953847],
              [46.9076326, 33.4971381],
              [46.9068938, 33.4980385],
              [46.9054163, 33.4985598],
              [46.9041092, 33.4979437],
              [46.9025181, 33.4975172],
              [46.9009269, 33.4978489],
              [46.8984833, 33.4985124],
              [46.8967217, 33.4985124],
              [46.8948463, 33.4979911],
              [46.8930279, 33.4980385],
              [46.8911525, 33.4980859],
              [46.8905843, 33.4994127],
              [46.891664, 33.5012135],
              [46.8908116, 33.5026825],
              [46.8907547, 33.5048622],
              [46.8902141, 33.5058985],
              [46.888888, 33.505999],
              [46.8867985, 33.5074062],
              [46.8855126, 33.5083779],
              [46.8843473, 33.5092155],
              [46.8829811, 33.5100866],
              [46.8817354, 33.5112593],
              [46.8798066, 33.5120299],
              [46.8779984, 33.5121974],
              [46.8764714, 33.513169],
              [46.8744623, 33.5144086],
              [46.8733773, 33.5159832],
              [46.8728148, 33.5175913],
              [46.8714887, 33.5183953],
              [46.8703636, 33.5194673],
              [46.8689572, 33.5202713],
              [46.8671087, 33.5199028],
              [46.8655014, 33.5188978],
              [46.8631708, 33.5181608],
              [46.8628091, 33.5168877],
              [46.8629297, 33.5163182],
              [46.8612822, 33.5164522],
              [46.8598758, 33.5177923],
              [46.8597552, 33.5191323],
              [46.8599963, 33.5207068],
              [46.860358, 33.5218793],
              [46.8609205, 33.5231188],
              [46.8617242, 33.5246598],
              [46.8624475, 33.5260667],
              [46.862568, 33.5276076],
              [46.8619251, 33.5288135],
              [46.8609607, 33.5304214],
              [46.8595945, 33.5312588],
              [46.8587506, 33.5325651],
              [46.8579068, 33.5342064],
              [46.8565004, 33.5353787],
              [46.8554154, 33.5370199],
              [46.8549886, 33.5375902],
              [46.8541362, 33.5381112],
              [46.8528292, 33.5383244],
              [46.8518915, 33.5377086],
              [46.8509255, 33.5379454],
              [46.8493059, 33.5381349],
              [46.8489649, 33.5394849],
              [46.8489365, 33.5404795],
              [46.8490786, 33.5415926],
              [46.8488797, 33.5427294],
              [46.848766, 33.5436293],
              [46.8480841, 33.5442924],
              [46.8462088, 33.5444582],
              [46.8447597, 33.5443871],
              [46.8432253, 33.5446476],
              [46.841833, 33.5456896],
              [46.8407533, 33.5466368],
              [46.8400714, 33.5476551],
              [46.8395599, 33.5489339],
              [46.8392474, 33.5504494],
              [46.8386223, 33.5514913],
              [46.8385176, 33.5519856],
              [46.8383665, 33.552699],
              [46.8386223, 33.5537646],
              [46.8394747, 33.5546407],
              [46.8400714, 33.5555168],
              [46.8404692, 33.5567954],
              [46.8404976, 33.5576479],
              [46.8406002, 33.5590221],
              [46.8406854, 33.5600876],
              [46.8405149, 33.5614609],
              [46.8402308, 33.5629999],
              [46.8398046, 33.5643494],
              [46.8388669, 33.5657227],
              [46.8380429, 33.5667881],
              [46.8375315, 33.5680665],
              [46.8379861, 33.569345],
              [46.8390942, 33.5708128],
              [46.839492, 33.5719729],
              [46.8406286, 33.5727304],
              [46.8415846, 33.5732736],
              [46.8420668, 33.5737423],
              [46.8431919, 33.5745123],
              [46.8441965, 33.5747467],
              [46.8458038, 33.5746463],
              [46.847813, 33.5750145],
              [46.8494605, 33.5756171],
              [46.8515099, 33.5756506],
              [46.853961, 33.5752489],
              [46.8554076, 33.5739767],
              [46.8572159, 33.5737423],
              [46.8597072, 33.5739432],
              [46.8616762, 33.5746463],
              [46.8632434, 33.5757845],
              [46.86469, 33.5768893],
              [46.8650114, 33.5785967],
              [46.86469, 33.579668],
              [46.8646096, 33.5812414],
              [46.8650114, 33.5822792],
              [46.8647301, 33.5829822],
              [46.8636854, 33.5839865],
              [46.8627612, 33.5845556],
              [46.8615959, 33.585359],
              [46.8610735, 33.5864971],
              [46.8604797, 33.5872663],
              [46.8596273, 33.5886865],
              [46.8593431, 33.5896806],
              [46.8604797, 33.590722],
              [46.8608775, 33.5915268],
              [46.8615026, 33.5913847],
              [46.862696, 33.5920001],
              [46.8625823, 33.5933256],
              [46.8612185, 33.5949823],
              [46.8592295, 33.5967337],
              [46.8572973, 33.5993371],
              [46.8553652, 33.6020351],
              [46.853774, 33.604023],
              [46.8512168, 33.6061055],
              [46.8487164, 33.6082353],
              [46.8466501, 33.6098086],
              [46.8460074, 33.6103239],
              [46.8457917, 33.61145],
              [46.8468428, 33.6116825],
              [46.8472957, 33.6115482],
              [46.8508758, 33.6120688],
              [46.8534899, 33.6129207],
              [46.8562176, 33.6130154],
              [46.8589453, 33.6134886],
              [46.8618436, 33.6140565],
              [46.8648554, 33.6152396],
              [46.8671285, 33.6160915],
              [46.8696289, 33.6168013],
              [46.8713906, 33.6179844],
              [46.8731523, 33.6189309],
              [46.8761641, 33.6194514],
              [46.8788919, 33.6199247],
              [46.8815628, 33.6208711],
              [46.8849156, 33.6207764],
              [46.8869428, 33.6203596],
              [46.8912129, 33.6195913],
              [46.8932728, 33.6190552],
              [46.8946139, 33.6184298],
              [46.8961696, 33.6177151],
              [46.8975536, 33.6171879],
              [46.8987875, 33.6167948],
              [46.9000105, 33.6164106],
              [46.9014267, 33.6157852],
              [46.9022958, 33.6153385],
              [46.9035081, 33.6149275],
              [46.9048063, 33.6148739],
              [46.9057612, 33.6147845],
              [46.9068985, 33.6149364],
              [46.9081323, 33.6151687],
              [46.9093661, 33.6157227],
              [46.9106321, 33.6168841],
              [46.912853, 33.61868],
              [46.913722, 33.6193947],
              [46.9146232, 33.6201184],
              [46.9151811, 33.62044],
              [46.9158785, 33.6211458],
              [46.9163613, 33.6213156],
              [46.9173376, 33.621253],
              [46.9178419, 33.6213424],
              [46.9194083, 33.6210207],
              [46.9211785, 33.6208421],
              [46.9220261, 33.6203596],
              [46.9228522, 33.6203328],
              [46.9234316, 33.6204489],
              [46.9246225, 33.6204758],
              [46.9265537, 33.620172],
              [46.9276909, 33.6203328],
              [46.9294505, 33.6207348],
              [46.930813, 33.6211726],
              [46.9324653, 33.6218963],
              [46.9340639, 33.6228075],
              [46.9362525, 33.6235044],
              [46.9377546, 33.6233078],
              [46.9390528, 33.6228165],
              [46.9410162, 33.6220928],
              [46.942722, 33.6212352],
              [46.9440202, 33.6203953],
              [46.9449322, 33.6199308],
              [46.9453506, 33.6196359],
              [46.9468634, 33.6191267],
              [46.9485049, 33.6187872],
              [46.94961, 33.618805],
              [46.9511549, 33.6184209],
              [46.9520669, 33.6182332],
              [46.9529573, 33.6177329],
              [46.9534616, 33.617045],
              [46.9535903, 33.6162587],
              [46.9536762, 33.6152938],
              [46.9536655, 33.6144361],
              [46.9537513, 33.6135962],
              [46.9537513, 33.6129261],
              [46.9542341, 33.6121487],
              [46.9552748, 33.6115858],
              [46.9562511, 33.6109246],
              [46.9576566, 33.6102634],
              [46.9590406, 33.6099685],
              [46.9602637, 33.6099149],
              [46.9614868, 33.6098256],
              [46.9627313, 33.6096022],
              [46.9638793, 33.6093341],
              [46.9648878, 33.6091822],
              [46.9661216, 33.6088695],
              [46.9671731, 33.6089052],
              [46.9680314, 33.6086819],
              [46.9692759, 33.6083602],
              [46.9700269, 33.6078866],
              [46.9714109, 33.6071092],
              [46.9733207, 33.6063944],
              [46.9740181, 33.6059476],
              [46.9746403, 33.6055455],
              [46.9757454, 33.6049915],
              [46.9769685, 33.6041604],
              [46.9779233, 33.6034366],
              [46.979125, 33.6014171],
              [46.9786958, 33.6008452],
              [46.9775908, 33.6001303],
              [46.9767324, 33.5988613],
              [46.9766359, 33.5972885],
              [46.9777624, 33.5952956],
              [46.9788353, 33.5938969],
              [46.979811, 33.5928267],
              [46.9820226, 33.5908761],
              [46.9857303, 33.5885055],
              [46.9873403, 33.587503],
              [46.9897145, 33.5862296],
              [46.9921375, 33.5854845],
              [46.9939914, 33.5847801],
              [46.9957314, 33.5845227],
              [46.9963299, 33.5847906],
              [46.9968209, 33.5850104],
              [46.9974064, 33.5862296],
              [46.998317, 33.587801],
              [46.9985935, 33.5884919],
              [46.9988049, 33.5904291],
              [46.9992765, 33.5918921],
              [47.0006262, 33.5930435],
              [47.0018621, 33.5938427],
              [47.0074887, 33.5947232],
              [47.0091637, 33.5945877],
              [47.0113265, 33.5939375],
              [47.0142211, 33.5932331],
              [47.0157172, 33.5933144],
              [47.0171645, 33.5933821],
              [47.018498, 33.5938021],
              [47.0197339, 33.5944116],
              [47.0205795, 33.5947367],
              [47.0219259, 33.5945335],
              [47.0245008, 33.5928355],
              [47.0266037, 33.5911553],
              [47.0284061, 33.5901186],
              [47.0298652, 33.5893679],
              [47.031775, 33.5881345],
              [47.0348626, 33.5857417],
              [47.0360021, 33.5854353],
              [47.0364084, 33.586384],
              [47.0369463, 33.5872765],
              [47.0373983, 33.5879007],
              [47.037203, 33.5886828],
              [47.0361738, 33.589636],
              [47.0348207, 33.5904124],
              [47.0338134, 33.5906727],
              [47.0312171, 33.5928534],
              [47.030466, 33.5941761],
              [47.0293502, 33.5971967],
              [47.028213, 33.6013253],
              [47.0269899, 33.6035235],
              [47.0264964, 33.6049533],
              [47.0246081, 33.6068476],
              [47.0248871, 33.607902],
              [47.026947, 33.6105647],
              [47.0275263, 33.6120301],
              [47.0284276, 33.6136384],
              [47.0291571, 33.6154075],
              [47.0281272, 33.6169442],
              [47.0265178, 33.6179091],
              [47.0235996, 33.6195531],
              [47.0220976, 33.620911],
              [47.0215826, 33.6242702],
              [47.0206384, 33.625378],
              [47.0200805, 33.6283082],
              [47.020617, 33.6305057],
              [47.0214538, 33.6317564],
              [47.0234279, 33.6318814],
              [47.0243721, 33.633936],
              [47.0260458, 33.6397957],
              [47.0269899, 33.6439758],
              [47.0277624, 33.645655],
              [47.0281057, 33.6461909],
              [47.0302086, 33.6473698],
              [47.0311098, 33.6480665],
              [47.0319681, 33.6493526],
              [47.0348863, 33.6506386],
              [47.0367531, 33.6513888],
              [47.0377831, 33.6526034],
              [47.0375256, 33.6541038],
              [47.0379237, 33.6546522],
              [47.0381479, 33.6549611],
              [47.0402078, 33.6552826],
              [47.0419459, 33.6550504],
              [47.0432334, 33.6551755],
              [47.0443706, 33.6556756],
              [47.0443706, 33.6568723],
              [47.0439844, 33.6585512],
              [47.0432334, 33.6603193],
              [47.0439629, 33.6618374],
              [47.04392, 33.6626589],
              [47.044199, 33.6634448],
              [47.0447998, 33.6644449],
              [47.0441131, 33.6663558],
              [47.0444779, 33.6672309],
              [47.0472889, 33.6679988],
              [47.0495634, 33.6685345],
              [47.0536832, 33.6682131],
              [47.0582537, 33.6678023],
              [47.0602278, 33.6683738],
              [47.0609359, 33.6705168],
              [47.0606785, 33.6718383],
              [47.0589189, 33.6715704],
              [47.0551424, 33.671749],
              [47.0541768, 33.6728026],
              [47.0549278, 33.6760347],
              [47.0561509, 33.6782132],
              [47.0559792, 33.6798917],
              [47.056108, 33.6808336],
              [47.0563449, 33.6814654],
              [47.0571728, 33.6817108],
              [47.0583713, 33.6820961],
              [47.0601849, 33.6826058],
              [47.0626526, 33.684677],
              [47.0631246, 33.6870695],
              [47.0641975, 33.6883729],
              [47.0656137, 33.6891406],
              [47.067502, 33.6888549],
              [47.0701627, 33.6895155],
              [47.0714717, 33.6912831],
              [47.0712571, 33.6924971],
              [47.0692401, 33.6938004],
              [47.0638756, 33.6956214],
              [47.0601849, 33.6982814],
              [47.0595737, 33.6993101],
              [47.0595491, 33.7004072],
              [47.0599188, 33.7019247],
              [47.0615579, 33.7035959],
              [47.0629136, 33.7047852],
              [47.0643185, 33.7058822],
              [47.065514, 33.7073483],
              [47.0656988, 33.7084556],
              [47.0652305, 33.7090092],
              [47.0672886, 33.7108033],
              [47.0686073, 33.7116337],
              [47.0700493, 33.7112543],
              [47.0719965, 33.7094705],
              [47.0739314, 33.7077071],
              [47.0752378, 33.7061898],
              [47.0773205, 33.7046519],
              [47.0787333, 33.7034711],
              [47.0799022, 33.7033309],
              [47.0807874, 33.7029999],
              [47.0821853, 33.7024496],
              [47.0849779, 33.7009888],
              [47.0872383, 33.70061],
              [47.0889946, 33.7012188],
              [47.0906208, 33.7020441],
              [47.0916128, 33.7036134],
              [47.0927836, 33.7040598],
              [47.0935642, 33.7051962],
              [47.0934178, 33.7067249],
              [47.0937593, 33.7082265],
              [47.0943773, 33.7097957],
              [47.0956578, 33.7099568],
              [47.0963124, 33.7100392],
              [47.0981012, 33.7086729],
              [47.0997762, 33.7075095],
              [47.1029473, 33.7065626],
              [47.1040368, 33.706062],
              [47.1059557, 33.7064814],
              [47.1074518, 33.706292],
              [47.1092244, 33.705805],
              [47.1096583, 33.7045747],
              [47.1104511, 33.7033735],
              [47.1116402, 33.7025844],
              [47.1144008, 33.7031026],
              [47.1167225, 33.7033146],
              [47.1174162, 33.7034677],
              [47.1190442, 33.7035737],
              [47.1218897, 33.7034677],
              [47.1232346, 33.7035266],
              [47.1243813, 33.703715],
              [47.1262642, 33.7042097],
              [47.1273967, 33.7053167],
              [47.1276091, 33.7061647],
              [47.1286425, 33.7068595],
              [47.1298175, 33.7071775],
              [47.1307094, 33.7070244],
              [47.1311341, 33.7066004],
              [47.13221, 33.705882],
              [47.1329037, 33.7059291],
              [47.1344043, 33.7062942],
              [47.1361456, 33.7065768],
              [47.1370233, 33.7066475],
              [47.1378727, 33.7069773],
              [47.1384673, 33.7076132],
              [47.1391327, 33.7084022],
              [47.1405342, 33.7093326],
              [47.1419357, 33.7095799],
              [47.1429833, 33.7096152],
              [47.1440451, 33.7096859],
              [47.1461262, 33.708838],
              [47.1472445, 33.7082138],
              [47.1487168, 33.7082138],
              [47.1498352, 33.7076485],
              [47.1509395, 33.707201],
              [47.1522844, 33.7075072],
              [47.153785, 33.7077545],
              [47.1545494, 33.7070008],
              [47.1555121, 33.7062],
              [47.156319, 33.7063766],
              [47.1571118, 33.7068006],
              [47.157494, 33.7073306],
              [47.1583576, 33.707731],
              [47.1587257, 33.708414],
              [47.1589664, 33.7091324],
              [47.1601414, 33.709521],
              [47.1618119, 33.7098743],
              [47.1635248, 33.7103218],
              [47.1650962, 33.7105573],
              [47.165889, 33.7105927],
              [47.1675737, 33.7106398],
              [47.1688903, 33.7116408],
              [47.1708439, 33.7129832],
              [47.1723587, 33.7133247],
              [47.1734346, 33.7135956],
              [47.1739725, 33.7143728],
              [47.1736611, 33.7160685],
              [47.1734629, 33.7163511],
              [47.1730948, 33.7172578],
              [47.1737036, 33.7187886],
              [47.1746662, 33.720025],
              [47.1761102, 33.7215204],
              [47.1766057, 33.7217677],
              [47.1775967, 33.7221327],
              [47.1787717, 33.7225919],
              [47.1801449, 33.7232513],
              [47.1807395, 33.7236163],
              [47.1812916, 33.7239225],
              [47.1814049, 33.7254178],
              [47.182594, 33.7259476],
              [47.1841796, 33.7255591],
              [47.1865155, 33.7255473],
              [47.1882426, 33.7254531],
              [47.1899839, 33.7248526],
              [47.1919233, 33.72384],
              [47.1940469, 33.7228274],
              [47.1950803, 33.7219443],
              [47.1965526, 33.7211319],
              [47.1980815, 33.7203312],
              [47.198931, 33.7198484],
              [47.2002617, 33.7197424],
              [47.2015075, 33.719919],
              [47.203447, 33.720131],
              [47.2049051, 33.7203312],
              [47.206519, 33.7201545],
              [47.2075949, 33.7199426],
              [47.2086991, 33.7195069],
              [47.2095061, 33.7199073],
              [47.2102847, 33.7201663],
              [47.2120826, 33.7209435],
              [47.2135832, 33.7218266],
              [47.2141353, 33.7225095],
              [47.21456, 33.7233808],
              [47.2146875, 33.72384],
              [47.2151122, 33.7250293],
              [47.2168534, 33.7274783],
              [47.2185947, 33.7286204],
              [47.2200246, 33.7288794],
              [47.2217517, 33.729315],
              [47.2240168, 33.7303393],
              [47.2254891, 33.7309986],
              [47.226565, 33.7315167],
              [47.2268481, 33.732329],
              [47.2272021, 33.7328118],
              [47.2282497, 33.7327411],
              [47.2305572, 33.7320465],
              [47.2331196, 33.7311399],
              [47.2358094, 33.7303511],
              [47.2377772, 33.7302451],
              [47.2388814, 33.7303511],
              [47.2408067, 33.7306454],
              [47.2420101, 33.730669],
              [47.2428311, 33.7306925],
              [47.2435956, 33.7314931],
              [47.2434399, 33.7330825],
              [47.2431284, 33.7348367],
              [47.2429302, 33.7358728],
              [47.2428878, 33.7381684],
              [47.2427604, 33.7400638],
              [47.2426613, 33.7417708],
              [47.2440345, 33.7443959],
              [47.245252, 33.7449138],
              [47.2471206, 33.7460439],
              [47.2477719, 33.7463617],
              [47.249315, 33.7468444],
              [47.2525427, 33.7481039],
              [47.2554165, 33.7489161],
              [47.2574268, 33.7488102],
              [47.2593521, 33.7485394],
              [47.2608952, 33.7480568],
              [47.2617305, 33.747327],
              [47.2620419, 33.7466913],
              [47.2623109, 33.7458438],
              [47.263132, 33.7449727],
              [47.2644627, 33.7441487],
              [47.2655386, 33.7436778],
              [47.2665721, 33.7435248],
              [47.2670959, 33.7428302],
              [47.267917, 33.7419238],
              [47.2683557, 33.7414119],
              [47.2687947, 33.7408996],
              [47.2695981, 33.7403705],
              [47.270525, 33.7401271],
              [47.2718422, 33.7401406],
              [47.2724602, 33.7407221],
              [47.2733871, 33.7409114],
              [47.2743303, 33.7402894],
              [47.2754198, 33.7392616],
              [47.2761679, 33.7376659],
              [47.2764118, 33.7367463],
              [47.276298, 33.7357997],
              [47.2758751, 33.7354346],
              [47.2753873, 33.7350153],
              [47.2750458, 33.7347043],
              [47.2750783, 33.7336359],
              [47.2754361, 33.7327569],
              [47.2761841, 33.7321212],
              [47.2771924, 33.7317155],
              [47.2789974, 33.7319995],
              [47.2815018, 33.7328245],
              [47.2834694, 33.7331355],
              [47.2860226, 33.7330138],
              [47.2891286, 33.7326487],
              [47.291828, 33.7330814],
              [47.293503, 33.7329327],
              [47.2947714, 33.732581],
              [47.2999265, 33.7306877],
              [47.3014876, 33.7301873],
              [47.302382, 33.7290647],
              [47.3028536, 33.7279692],
              [47.3041708, 33.7266303],
              [47.3053904, 33.7259135],
              [47.3060734, 33.725697],
              [47.3071467, 33.7258864],
              [47.3080737, 33.7262245],
              [47.3088217, 33.726779],
              [47.3091607, 33.7270931],
              [47.3095372, 33.7274418],
              [47.3107731, 33.7284155],
              [47.3124644, 33.7297815],
              [47.3138466, 33.7307012],
              [47.314985, 33.7312422],
              [47.3160745, 33.731702],
              [47.3166924, 33.7317155],
              [47.3177169, 33.732013],
              [47.3184813, 33.7323376],
              [47.3192781, 33.7330003],
              [47.3199611, 33.7337982],
              [47.3207742, 33.7341498],
              [47.3223353, 33.7345285],
              [47.3235062, 33.734231],
              [47.3243681, 33.7338658],
              [47.3250023, 33.7330273],
              [47.3257178, 33.73227],
              [47.326287, 33.7315532],
              [47.3275066, 33.7309176],
              [47.3294743, 33.7306877],
              [47.3309704, 33.7313503],
              [47.3324014, 33.7317425],
              [47.3343041, 33.7319319],
              [47.3362067, 33.733095],
              [47.3372149, 33.7340281],
              [47.3384996, 33.734231],
              [47.3402722, 33.734285],
              [47.3425326, 33.7344068],
              [47.3434595, 33.7348666],
              [47.3452971, 33.7367193],
              [47.346842, 33.7378958],
              [47.3476225, 33.7388019],
              [47.3490536, 33.7382068],
              [47.3500456, 33.7367869],
              [47.3511126, 33.7354766],
              [47.3512815, 33.7344879],
              [47.3521433, 33.7330679],
              [47.3550542, 33.7321077],
              [47.3574772, 33.7323106],
              [47.3588432, 33.7325675],
              [47.360632, 33.732838],
              [47.3619005, 33.733406],
              [47.3635104, 33.7341228],
              [47.3650553, 33.7353669],
              [47.3666652, 33.7358808],
              [47.3680312, 33.7359485],
              [47.3693972, 33.7358944],
              [47.3706006, 33.735989],
              [47.3722105, 33.7353805],
              [47.3728284, 33.7352858],
              [47.3729748, 33.7358944],
              [47.3732675, 33.7369898],
              [47.3734952, 33.7375577],
              [47.3742757, 33.738031],
              [47.3753816, 33.7383556],
              [47.3778859, 33.7387748],
              [47.3802113, 33.7386531],
              [47.3825368, 33.7381257],
              [47.3870413, 33.7370438],
              [47.3882447, 33.7367193],
              [47.3907002, 33.7367058],
              [47.3929281, 33.7365435],
              [47.3938713, 33.7363406],
              [47.3974814, 33.7363271],
              [47.4000183, 33.7368951],
              [47.4033195, 33.7385855],
              [47.4039211, 33.739167],
              [47.4048318, 33.7397079],
              [47.4063442, 33.739451],
              [47.4076939, 33.7392887],
              [47.4097429, 33.7406274],
              [47.4107837, 33.7437376],
              [47.4120683, 33.7465908],
              [47.4118732, 33.7480241],
              [47.4123285, 33.749552],
              [47.4128652, 33.7502145],
              [47.4134018, 33.7507959],
              [47.4143938, 33.7511069],
              [47.4178088, 33.7542708],
              [47.4196139, 33.7548657],
              [47.4206546, 33.7549468],
              [47.4220857, 33.755055],
              [47.4232565, 33.7551632],
              [47.4236468, 33.7581376],
              [47.4238094, 33.7593409],
              [47.4243623, 33.7608551],
              [47.425273, 33.7617068],
              [47.4253868, 33.7624233],
              [47.4228988, 33.7647351],
              [47.4226386, 33.7658166],
              [47.4232403, 33.766817],
              [47.4246062, 33.7676551],
              [47.4255657, 33.768669],
              [47.4259072, 33.7695612],
              [47.42633, 33.7699127],
              [47.426704, 33.7701966],
              [47.4282814, 33.7703993],
              [47.4292734, 33.7704264],
              [47.430363, 33.7703858],
              [47.4311273, 33.7700479],
              [47.4322331, 33.7696018],
              [47.4362498, 33.7678444],
              [47.4373393, 33.7681688],
              [47.4392907, 33.7692638],
              [47.4407055, 33.7698316],
              [47.4418601, 33.7700208],
              [47.4435676, 33.7705886],
              [47.4440229, 33.771251],
              [47.4444457, 33.7717782],
              [47.4452588, 33.7726839],
              [47.4455028, 33.7741437],
              [47.446511, 33.7757523],
              [47.4471127, 33.7761308],
              [47.4483323, 33.7768202],
              [47.4483811, 33.7774825],
              [47.4477144, 33.7784963],
              [47.4436001, 33.7826728],
              [47.4427708, 33.7833081],
              [47.4417951, 33.784511],
              [47.4416812, 33.7859572],
              [47.4414048, 33.7869438],
              [47.4411446, 33.7874844],
              [47.4403477, 33.788025],
              [47.4407706, 33.7886738],
              [47.4414048, 33.7888495],
              [47.4421203, 33.7886738],
              [47.4433237, 33.7881061],
              [47.4453401, 33.7867681],
              [47.4471289, 33.7856598],
              [47.4485112, 33.7854571],
              [47.4497634, 33.7861599],
              [47.4507553, 33.7872952],
              [47.4514871, 33.7884575],
              [47.4515522, 33.7892819],
              [47.4513408, 33.7906064],
              [47.4515522, 33.7917822],
              [47.4515684, 33.7927012],
              [47.4519912, 33.7935661],
              [47.4536825, 33.7954446],
              [47.4549997, 33.7967419],
              [47.4562031, 33.7974447],
              [47.4573577, 33.7991203],
              [47.4579431, 33.8009582],
              [47.4575691, 33.801796],
              [47.4562031, 33.8046607],
              [47.4556176, 33.8061336],
              [47.4550485, 33.8064173],
              [47.4545606, 33.8073497],
              [47.455081, 33.8083901],
              [47.4552761, 33.8086468],
              [47.4569023, 33.8101196],
              [47.4585448, 33.8103628],
              [47.459179, 33.810498],
              [47.46061, 33.8107412],
              [47.4631306, 33.8114303],
              [47.4640738, 33.8115654],
              [47.4649845, 33.8118897],
              [47.4658138, 33.8125382],
              [47.4661879, 33.8129976],
              [47.466692, 33.8136596],
              [47.4668383, 33.8145244],
              [47.4672286, 33.8159565],
              [47.468741, 33.8171184],
              [47.4706761, 33.8179831],
              [47.4713429, 33.8193612],
              [47.4719446, 33.8201448],
              [47.4728227, 33.8209013],
              [47.4743513, 33.8214823],
              [47.4750994, 33.8221578],
              [47.4752945, 33.8227252],
              [47.4763027, 33.8238735],
              [47.4768069, 33.8242653],
              [47.4782216, 33.8252245],
              [47.4793437, 33.8258729],
              [47.4798966, 33.8264403],
              [47.4799617, 33.82744],
              [47.4800267, 33.8283991],
              [47.4802869, 33.8295744],
              [47.4811712, 33.8298749],
              [47.4819212, 33.8300414],
              [47.4823957, 33.8300793],
              [47.4829864, 33.8300201],
              [47.4834048, 33.8299104],
              [47.4840071, 33.8297313],
              [47.4846614, 33.8294123],
              [47.4901579, 33.8292502],
              [47.4915048, 33.8290254],
              [47.4936216, 33.8292502],
              [47.4963802, 33.8285861],
              [47.4989777, 33.8263445],
              [47.4993133, 33.8253325],
              [47.5052668, 33.8262366],
              [47.5101274, 33.8327624],
              [47.5112007, 33.8345859],
              [47.5116786, 33.8377159],
              [47.5110219, 33.8404092],
              [47.5092005, 33.8412991],
              [47.5085477, 33.8422826],
              [47.5067578, 33.8437197],
              [47.5054115, 33.8452835],
              [47.5052326, 33.8460534],
              [47.5051838, 33.8467152],
              [47.5051838, 33.8467422],
              [47.5055579, 33.8480658],
              [47.5058181, 33.8482684],
              [47.5059319, 33.8493758],
              [47.5057855, 33.8501861],
              [47.5043618, 33.8533165],
              [47.50407, 33.8554834],
              [47.5063016, 33.8576217],
              [47.504585, 33.8601876],
              [47.5008084, 33.8627534],
              [47.4996325, 33.8714766],
              [47.5000703, 33.8751253],
              [47.5029885, 33.8785458],
              [47.5006368, 33.8856998],
              [47.5051857, 33.8884519],
              [47.5036065, 33.8907443],
              [47.5021817, 33.8941072],
              [47.5011517, 33.8970994],
              [47.4958302, 33.8990942],
              [47.4957787, 33.9010605],
              [47.4990403, 33.9034826],
              [47.5026452, 33.9046224],
              [47.5050484, 33.9071868],
              [47.4983537, 33.9150223],
              [47.4894788, 33.9203215],
              [47.4870755, 33.9234553],
              [47.4815823, 33.9250221],
              [47.4801576, 33.9282697],
              [47.4817025, 33.929694],
              [47.479222, 33.9325924],
              [47.4842774, 33.9376698],
              [47.4836423, 33.9425403],
              [47.4790056, 33.9440778],
              [47.4658092, 33.9435362],
              [47.4652526, 33.943816],
              [47.4630291, 33.943816],
              [47.4624725, 33.9440957],
              [47.4605291, 33.9440957],
              [47.455806, 33.945206],
              [47.4549728, 33.945206],
              [47.4544192, 33.9454858],
              [47.4524727, 33.9460364],
              [47.4383064, 33.9504774],
              [47.4371962, 33.9510371],
              [47.4308062, 33.9518675],
              [47.429973, 33.9521474],
              [47.4274733, 33.9521473],
              [47.4269163, 33.9524271],
              [47.4244163, 33.9524271],
              [47.4235834, 33.9521473],
              [47.4221927, 33.9521474],
              [47.4213599, 33.9524271],
              [47.4185833, 33.9513169],
              [47.4171934, 33.9510371],
              [47.4103898, 33.9517217],
              [47.4052584, 33.9522074],
              [47.4020165, 33.9507483],
              [47.3976269, 33.9505547],
              [47.3941737, 33.9484303],
              [47.3909445, 33.9474609],
              [47.3885393, 33.9460523],
              [47.3902911, 33.9423288],
              [47.3890235, 33.9411189],
              [47.3853922, 33.9408508],
              [47.3824711, 33.9391127],
              [47.3795043, 33.9395527],
              [47.3765331, 33.9426555],
              [47.3731877, 33.946201],
              [47.3715305, 33.9487664],
              [47.3691423, 33.9505315],
              [47.3581098, 33.9547631],
              [47.3526571, 33.9572044],
              [47.348001, 33.96045],
              [47.3465939, 33.9619152],
              [47.343142, 33.9627689],
              [47.3410643, 33.9629317],
              [47.3386381, 33.9624189],
              [47.3336814, 33.9636933],
              [47.3304791, 33.9640947],
              [47.3285205, 33.9637552],
              [47.3274673, 33.9621485],
              [47.326911, 33.9621484],
              [47.3266345, 33.9624283],
              [47.3255244, 33.9624282],
              [47.3248942, 33.9623565],
              [47.3235059, 33.9633256],
              [47.3221906, 33.9632761],
              [47.3210631, 33.9633115],
              [47.3196033, 33.9629962],
              [47.3190028, 33.9626023],
              [47.3184165, 33.9617283],
              [47.3162408, 33.9610453],
              [47.3149679, 33.9571477],
              [47.3144108, 33.9560375],
              [47.3133014, 33.9527067],
              [47.3196907, 33.9390947],
              [47.3505243, 33.90965],
              [47.3535805, 33.9071497],
              [47.3591377, 33.9027085],
              [47.3596909, 33.9027085],
              [47.3774702, 33.8849259],
              [47.379414, 33.8818748],
              [47.3819141, 33.8777045],
              [47.3821938, 33.8765852],
              [47.3830273, 33.8752041],
              [47.3830274, 33.8740938],
              [47.383304, 33.873534],
              [47.3835806, 33.870474],
              [47.3866369, 33.8613118],
              [47.3830275, 33.8538105],
              [47.380804, 33.8527001],
              [47.378861, 33.85131],
              [47.3724709, 33.85131],
              [47.3713608, 33.8510302],
              [47.3605239, 33.8426982],
              [47.3602473, 33.8421476],
              [47.3588574, 33.839927],
              [47.3441346, 33.8168721],
              [47.3435814, 33.8165832],
              [47.343301, 33.8160326],
              [47.3413579, 33.8149222],
              [47.3371915, 33.8138118],
              [47.3355243, 33.8138119],
              [47.3188583, 33.8210335],
              [47.3158012, 33.8196433],
              [47.3116348, 33.8163123],
              [47.3091347, 33.8121418],
              [47.308855, 33.8018691],
              [47.3077448, 33.7963083],
              [47.304412, 33.791867],
              [47.2952454, 33.788536],
              [47.2935782, 33.7885359],
              [47.2932985, 33.7882561],
              [47.2882985, 33.7882561],
              [47.2874656, 33.788536],
              [47.2852452, 33.7885359],
              [47.284132, 33.7888157],
              [47.2807991, 33.7896462],
              [47.2516328, 33.8029792],
              [47.2499656, 33.80325],
              [47.2491327, 33.8038097],
              [47.2460756, 33.8038097],
              [47.2452428, 33.8040896],
              [47.2444092, 33.8040895],
              [47.2438522, 33.8043694],
              [47.2391325, 33.8043693],
              [47.2380192, 33.8040895],
              [47.2360763, 33.8040895],
              [47.2346855, 33.8038096],
              [47.2341293, 33.8038097],
              [47.2335762, 33.8038097],
              [47.2310762, 33.8035388],
              [47.2307956, 33.80325],
              [47.2199626, 33.8029792],
              [47.2138531, 33.8024284],
              [47.2116296, 33.8026992],
              [47.2069061, 33.8038096],
              [47.1949628, 33.8099208],
              [47.1921831, 33.8121416],
              [47.1907964, 33.8132609],
              [47.1902401, 33.8132609],
              [47.189683, 33.8138115],
              [47.1832963, 33.8157613],
              [47.1777399, 33.8165828],
              [47.1771836, 33.8168716],
              [47.1677404, 33.8168716],
              [47.1602371, 33.8163119],
              [47.1546839, 33.8154814],
              [47.1532933, 33.8154815],
              [47.1521838, 33.8152016],
              [47.1499604, 33.8152016],
              [47.1471838, 33.8146419],
              [47.1402367, 33.8146418],
              [47.1396805, 33.8143711],
              [47.1374601, 33.8146418],
              [47.1299607, 33.8199226],
              [47.1296803, 33.8202025],
              [47.1269036, 33.8232536],
              [47.1269036, 33.8238133],
              [47.1127377, 33.8385362],
              [47.1094041, 33.8402062],
              [47.1063476, 33.8404771],
              [47.1024578, 33.8368662],
              [47.0996812, 33.8304842],
              [47.0994007, 33.8299245],
              [47.0960679, 33.8254742],
              [47.0946811, 33.8249235],
              [47.0938475, 33.8249236],
              [47.0927342, 33.8243639],
              [47.0905147, 33.8243638],
              [47.0521778, 33.8332553],
              [47.0471786, 33.8318651],
              [47.0466215, 33.8318651],
              [47.0443981, 33.8302042],
              [47.0399551, 33.8238131],
              [47.0307885, 33.8143708],
              [47.020789, 33.8113106],
              [47.0193984, 33.8113106],
              [47.0185656, 33.8110307],
              [47.0099521, 33.8110307],
              [47.004952, 33.8099204],
              [47.0043989, 33.8102002],
              [47.002452, 33.8102002],
              [46.9996072, 33.8107508],
              [46.9982855, 33.8113105],
              [46.9977324, 33.8113105],
              [46.9971753, 33.8115904],
              [46.9968988, 33.805479],
              [46.9977324, 33.8007489],
              [46.9977324, 33.795477],
              [46.998009, 33.7951972],
              [46.9995462, 33.7865854],
              [46.9991192, 33.7835341],
              [46.9988426, 33.7818642],
              [46.993566, 33.7729724],
              [46.9882862, 33.7624196],
              [46.9874527, 33.7585289],
              [46.9793962, 33.7454754],
              [46.9785626, 33.7443651],
              [46.9779031, 33.7444803],
              [46.9768178, 33.7442498],
              [46.9751694, 33.7438986],
              [46.9735402, 33.7438572],
              [46.971503, 33.743197],
              [46.9706703, 33.7432359],
              [46.969943, 33.7433909],
              [46.9686405, 33.743944],
              [46.9680749, 33.7479871],
              [46.9645137, 33.7513768],
              [46.9474686, 33.7631416],
              [46.9449834, 33.7630144],
              [46.943332, 33.7636485],
              [46.9428607, 33.7637171],
              [46.9413166, 33.7639284],
              [46.9405506, 33.7639328],
              [46.9393299, 33.7641177],
              [46.9376489, 33.7646622],
              [46.9363111, 33.7650639],
              [46.9352661, 33.7655277],
              [46.9341941, 33.7662534],
              [46.9329313, 33.7667351],
              [46.9293276, 33.7682216],
              [46.9247797, 33.7698329],
              [46.9206563, 33.7712064],
              [46.9189626, 33.7715498],
              [46.9172096, 33.769461],
              [46.9161996, 33.767937],
              [46.9149504, 33.7651998],
              [46.9146699, 33.7649199],
              [46.91467, 33.7643693],
              [46.9138371, 33.7632499],
              [46.9141168, 33.7626992],
              [46.9141168, 33.761309],
              [46.9132832, 33.7576981],
              [46.9005041, 33.744085],
              [46.9002275, 33.7435343],
              [46.8968939, 33.7424149],
              [46.8949469, 33.7418643],
              [46.8905891, 33.7403185],
              [46.8893569, 33.7407478],
              [46.8826572, 33.741441],
              [46.8738372, 33.7338119],
              [46.8727239, 33.7338119],
              [46.8718911, 33.7335321],
              [46.8696707, 33.7335321],
              [46.8688378, 33.7332522],
              [46.8630042, 33.7332522],
              [46.8627245, 33.733532],
              [46.8596674, 33.733532],
              [46.8591143, 33.7338119],
              [46.8582814, 33.7338119],
              [46.8427248, 33.7413045],
              [46.8388349, 33.7432543],
              [46.8338347, 33.7460257],
              [46.8307776, 33.7482554],
              [46.8299449, 33.7485353],
              [46.8293918, 33.7490859],
              [46.7799422, 33.7671403],
              [46.7791086, 33.7671403],
              [46.7771656, 33.7676999],
              [46.770499, 33.7693609],
              [46.7688319, 33.7702005],
              [46.7666083, 33.7704713],
              [46.7663317, 33.7707511],
              [46.7652184, 33.770751],
              [46.7646653, 33.771031],
              [46.763552, 33.7710309],
              [46.7627183, 33.7713108],
              [46.7604988, 33.7713107],
              [46.7599418, 33.7710309],
              [46.7588324, 33.7710309],
              [46.7554988, 33.7676999],
              [46.7524425, 33.7574179],
              [46.7513324, 33.7543666],
              [46.7504988, 33.7529764],
              [46.739386, 33.7426944],
              [46.7363289, 33.7421437],
              [46.7360524, 33.7418638],
              [46.7341093, 33.7418639],
              [46.7335524, 33.741584],
              [46.7324429, 33.741584],
              [46.7318858, 33.7418639],
              [46.7313296, 33.7418638],
              [46.7299429, 33.7418639],
              [46.7296624, 33.7421437],
              [46.7288296, 33.7421437],
              [46.7279674, 33.7421437],
              [46.7268858, 33.7421437],
              [46.7268858, 33.7418638],
              [46.7252193, 33.7418638],
              [46.7252193, 33.7421437],
              [46.724106, 33.7421437],
              [46.7143863, 33.7485349],
              [46.7135527, 33.7488058],
              [46.7129964, 33.7493655],
              [46.7052166, 33.7521458],
              [46.7027166, 33.7529764],
              [46.6952163, 33.7571469],
              [46.6932733, 33.7593676],
              [46.6713267, 33.7893649],
              [46.6707696, 33.7904752],
              [46.667993, 33.7932555],
              [46.6657702, 33.7949255],
              [46.6607701, 33.7982565],
              [46.6411214, 33.8144911],
              [46.6352134, 33.8193707],
              [46.6216036, 33.830203],
              [46.621324, 33.830825],
              [46.6210473, 33.8310336],
              [46.62077, 33.8313134],
              [46.6168801, 33.8332542],
              [46.6168801, 33.833534],
              [46.6163238, 33.833534],
              [46.6160473, 33.8338138],
              [46.6154902, 33.8340847],
              [46.5907671, 33.8449259],
              [46.5899342, 33.8451967],
              [46.5835442, 33.8488164],
              [46.582434, 33.8490873],
              [46.5816005, 33.849647],
              [46.5602108, 33.8610298],
              [46.5599343, 33.8613096],
              [46.5593781, 33.8613096],
              [46.5591007, 33.8615894],
              [46.558264, 33.8615895],
              [46.5418777, 33.8696414],
              [46.5415979, 33.8699212],
              [46.5013182, 33.8979763],
              [46.4849288, 33.9057572],
              [46.472705, 33.9107579],
              [46.4718722, 33.910758],
              [46.4710386, 33.9113176],
              [46.4696519, 33.9118682],
              [46.4682619, 33.9129785],
              [46.3929798, 33.9518647],
              [46.3921463, 33.9524244],
              [46.3557564, 33.9704863],
              [46.3490897, 33.9727067],
              [46.3074201, 33.9910392],
              [46.3068639, 33.99131],
              [46.2985308, 33.9954801],
              [46.2982535, 33.9952004],
              [46.2976972, 33.9949296],
              [46.2951972, 33.9927],
              [46.2918636, 33.982419],
              [46.289087, 33.9657563],
              [46.2910309, 33.9604847],
              [46.2913074, 33.9596453],
              [46.2913074, 33.9589556],
              [46.2910309, 33.9574248],
              [46.2913074, 33.957145],
              [46.2904738, 33.9543648],
              [46.2815877, 33.9502036],
              [46.2799213, 33.9507633],
              [46.2788072, 33.9507632],
              [46.2782541, 33.9507633],
              [46.2463081, 33.9588147],
              [46.2451947, 33.9593654],
              [46.2338047, 33.9618656],
              [46.232418, 33.9618657],
              [46.2304718, 33.9624253],
              [46.2290851, 33.9624253],
              [46.2251952, 33.9638154],
              [46.2151949, 33.9654762],
              [46.2146386, 33.965756],
              [46.213248, 33.965756],
              [46.2024149, 33.9696464],
              [46.2001954, 33.970197],
              [46.1954719, 33.9721467],
              [46.1949156, 33.9724175],
              [46.1796355, 33.9801982],
              [46.1682485, 33.9879789],
              [46.1651923, 33.9888093],
              [46.1646353, 33.9890892],
              [46.1574124, 33.9890891],
              [46.1565787, 33.9888093],
              [46.1538022, 33.9888093],
              [46.1493591, 33.9899285],
              [46.1485255, 33.9899285],
              [46.1415791, 33.9951998],
              [46.1401894, 33.9957595],
              [46.1401894, 33.9960303],
              [46.1273844, 33.9999291],
              [46.1110231, 34.0149222],
              [46.1007432, 34.0202025],
              [46.0993564, 34.0202025],
              [46.0965758, 34.0210329],
              [46.0946329, 34.0210329],
              [46.0935227, 34.0215925],
              [46.0865765, 34.0243636],
              [46.0846334, 34.0263132],
              [46.0840763, 34.0274234],
              [46.0821334, 34.0296438],
              [46.0812997, 34.0299237],
              [46.0804662, 34.0307631],
              [46.0776864, 34.0321441],
              [46.0746332, 34.0343646],
              [46.0707433, 34.0363141],
              [46.0693534, 34.0363141],
              [46.0690769, 34.036594],
              [46.0587969, 34.0377041],
              [46.0549102, 34.0377041],
              [46.0549102, 34.0374244],
              [46.0385201, 34.0160322],
              [46.0229643, 33.9999202],
              [46.0137978, 33.9846477],
              [46.0132408, 33.9846477],
              [45.9832378, 33.9724168],
              [45.9824043, 33.9724168],
              [45.9810183, 33.9718663],
              [45.979905, 33.9718662],
              [45.9793511, 33.9715864],
              [45.9699048, 33.9696457],
              [45.9682384, 33.9696456],
              [45.9676812, 33.9693659],
              [45.9643485, 33.9688153],
              [45.9615718, 33.9688153],
              [45.9607382, 33.9685354],
              [45.9543482, 33.9685354],
              [45.9529584, 33.9682556],
              [45.9474051, 33.9682556],
              [45.9462919, 33.9679757],
              [45.9446253, 33.9679757],
              [45.9435153, 33.9676959],
              [45.9379589, 33.9674252],
              [45.937405, 33.9674251],
              [45.9354588, 33.9676959],
              [45.9349018, 33.967425],
              [45.9337916, 33.9676959],
              [45.9326822, 33.967425],
              [45.9321252, 33.9676959],
              [45.9279587, 33.9676958],
              [45.9274017, 33.9679757],
              [45.9260156, 33.9679757],
              [45.9257352, 33.9682555],
              [45.9243484, 33.9682555],
              [45.9235156, 33.9685353],
              [45.9215687, 33.9685353],
              [45.9212921, 33.9688151],
              [45.9193491, 33.9688151],
              [45.9185154, 33.9690949],
              [45.9124021, 33.9707558],
              [45.8762896, 33.9885377],
              [45.8757325, 33.9888084],
              [45.8737895, 33.9893681],
              [45.8679558, 33.989368],
              [45.8679558, 33.9890882],
              [45.8673995, 33.9890883],
              [45.8576811, 33.9790946],
              [45.8573993, 33.9788162],
              [45.851843, 33.9693655],
              [45.8498993, 33.9635345],
              [45.8498993, 33.9629748],
              [45.8460094, 33.955203],
              [45.8446235, 33.9490921],
              [45.8537902, 33.9265889],
              [45.8576761, 33.9226984],
              [45.8587895, 33.9221478],
              [45.8593426, 33.9215881],
              [45.8885128, 33.9063151],
              [45.8893464, 33.9054757],
              [45.9058668, 33.8987048],
              [45.9056854, 33.8978483],
              [45.8986473, 33.893538],
              [45.8933687, 33.8877669],
              [45.8917379, 33.885095],
              [45.8898496, 33.8810334],
              [45.8885622, 33.8783257],
              [45.8880043, 33.8759741],
              [45.8882618, 33.8725179],
              [45.8890342, 33.8679213],
              [45.8884334, 33.8652131],
              [45.8863735, 33.860224],
              [45.8814325, 33.8547885],
              [45.8777982, 33.8539323],
              [45.8673178, 33.8492573],
              [45.8665252, 33.8484452],
              [45.8665225, 33.8470544],
              [45.8667237, 33.8459048],
              [45.868269, 33.8439311],
              [45.8688768, 33.8420836],
              [45.8693141, 33.8394571],
              [45.8694481, 33.8365031],
              [45.8683274, 33.8335958],
              [45.8672691, 33.8304224],
              [45.8651421, 33.8268776],
              [45.8617202, 33.8224671],
              [45.8592506, 33.8185397],
              [45.8557687, 33.813984],
              [45.8516627, 33.8078833],
              [45.8475468, 33.8021779],
              [45.8452161, 33.8002227],
              [45.8441642, 33.7981091],
              [45.8438873, 33.7964102],
              [45.84473, 33.7947438],
              [45.8479955, 33.7926428],
              [45.8527083, 33.7882754],
              [45.8545303, 33.7857818],
              [45.8554101, 33.7825717],
              [45.8542084, 33.7810023],
              [45.8507108, 33.780164],
              [45.8437898, 33.7775293],
              [45.8424164, 33.7742954],
              [45.846391, 33.7710462],
              [45.8522129, 33.7645568],
              [45.8534574, 33.7640217],
              [45.8547878, 33.7632903],
              [45.8554423, 33.7612745],
              [45.85482, 33.7608285],
              [45.8474063, 33.757778],
              [45.8458614, 33.7576709],
              [45.8435654, 33.75638],
              [45.8376646, 33.7502493],
              [45.835431, 33.7485598],
              [45.832768, 33.7477489],
              [45.829103, 33.744522],
              [45.8277863, 33.7428998],
              [45.8255302, 33.7426931],
              [45.8253908, 33.7406054],
              [45.821979, 33.7367869],
              [45.8179235, 33.7327629],
              [45.8172369, 33.7337979],
              [45.8165414, 33.7331621],
              [45.8140075, 33.7353772],
              [45.8111244, 33.7323509],
              [45.8097267, 33.7304966],
              [45.8078833, 33.7303757],
              [45.8076792, 33.7313493],
              [45.8064524, 33.7312129],
              [45.805485, 33.7315064],
              [45.8007715, 33.7300516],
              [45.7993865, 33.7305383],
              [45.7982546, 33.7300351],
              [45.7963664, 33.7291497],
              [45.7949168, 33.7291577],
              [45.7906216, 33.7283316],
              [45.7877794, 33.7264415],
              [45.786488, 33.7266954],
              [45.7854659, 33.7270061],
              [45.7842106, 33.7259628],
              [45.7839453, 33.7242549],
              [45.7835752, 33.72384],
              [45.7829905, 33.7237061],
              [45.782572, 33.7239284],
              [45.7816279, 33.7251606],
              [45.7810749, 33.7250341],
              [45.7804116, 33.7234847],
              [45.7797074, 33.7232332],
              [45.7789993, 33.7235723],
              [45.7780659, 33.723135],
              [45.7770467, 33.7229208],
              [45.7762635, 33.7231261],
              [45.7764029, 33.7226978],
              [45.7763493, 33.7219839],
              [45.7761454, 33.721618],
              [45.7768321, 33.7207345],
              [45.7761601, 33.71937],
              [45.7757324, 33.7196101],
              [45.7749438, 33.7207301],
              [45.7745308, 33.720739],
              [45.7743859, 33.7204401],
              [45.7743967, 33.7191327],
              [45.7738495, 33.7182448],
              [45.7731306, 33.7176737],
              [45.7734686, 33.7175175],
              [45.7733184, 33.7169553],
              [45.7725084, 33.7167054],
              [45.7717116, 33.7163821],
              [45.772843, 33.7162045],
              [45.7733131, 33.7158247],
              [45.7735754, 33.7152669],
              [45.772326, 33.7144877],
              [45.7711857, 33.7135604],
              [45.7690652, 33.7118632],
              [45.7686756, 33.7115999],
              [45.76825, 33.7112919],
              [45.7669401, 33.7120156],
              [45.7651162, 33.7112927],
              [45.7649982, 33.7103824],
              [45.7650578, 33.7094624],
              [45.767617, 33.7081886],
              [45.768641, 33.7067791],
              [45.7688674, 33.7063044],
              [45.7682914, 33.7058513],
              [45.7672083, 33.7059823],
              [45.7669352, 33.7051547],
              [45.7670581, 33.7044382],
              [45.7676151, 33.7038118],
              [45.7672083, 33.7031262],
              [45.7666261, 33.7031229],
              [45.7656956, 33.703992],
              [45.7645047, 33.7033404],
              [45.762831, 33.7038224],
              [45.7611787, 33.7027781],
              [45.7605994, 33.7025193],
              [45.7594192, 33.7028674],
              [45.7591402, 33.7020194],
              [45.7582712, 33.7005824],
              [45.7576479, 33.7000119],
              [45.7565976, 33.7004744],
              [45.755626, 33.701161],
              [45.7536724, 33.6999299],
              [45.7492661, 33.6962515],
              [45.7415812, 33.6921776],
              [45.7328276, 33.6889436],
              [45.7230872, 33.6894406],
              [45.7107663, 33.6900307],
              [45.69252, 33.69097]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 229893,
        "tags": {
          "ISO3166-2": "IR-15",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "لرستان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q1131727"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [46.8385176, 33.5519856],
              [46.8386223, 33.5514913],
              [46.8392474, 33.5504494],
              [46.8395599, 33.5489339],
              [46.8400714, 33.5476551],
              [46.8407533, 33.5466368],
              [46.841833, 33.5456896],
              [46.8432253, 33.5446476],
              [46.8447597, 33.5443871],
              [46.8462088, 33.5444582],
              [46.8480841, 33.5442924],
              [46.848766, 33.5436293],
              [46.8488797, 33.5427294],
              [46.8490786, 33.5415926],
              [46.8489365, 33.5404795],
              [46.8489649, 33.5394849],
              [46.8493059, 33.5381349],
              [46.8509255, 33.5379454],
              [46.8518915, 33.5377086],
              [46.8528292, 33.5383244],
              [46.8541362, 33.5381112],
              [46.8549886, 33.5375902],
              [46.8554154, 33.5370199],
              [46.8565004, 33.5353787],
              [46.8579068, 33.5342064],
              [46.8587506, 33.5325651],
              [46.8595945, 33.5312588],
              [46.8609607, 33.5304214],
              [46.8619251, 33.5288135],
              [46.862568, 33.5276076],
              [46.8624475, 33.5260667],
              [46.8617242, 33.5246598],
              [46.8609205, 33.5231188],
              [46.860358, 33.5218793],
              [46.8599963, 33.5207068],
              [46.8597552, 33.5191323],
              [46.8598758, 33.5177923],
              [46.8612822, 33.5164522],
              [46.8629297, 33.5163182],
              [46.8628091, 33.5168877],
              [46.8631708, 33.5181608],
              [46.8655014, 33.5188978],
              [46.8671087, 33.5199028],
              [46.8689572, 33.5202713],
              [46.8703636, 33.5194673],
              [46.8714887, 33.5183953],
              [46.8728148, 33.5175913],
              [46.8733773, 33.5159832],
              [46.8744623, 33.5144086],
              [46.8764714, 33.513169],
              [46.8779984, 33.5121974],
              [46.8798066, 33.5120299],
              [46.8817354, 33.5112593],
              [46.8829811, 33.5100866],
              [46.8843473, 33.5092155],
              [46.8855126, 33.5083779],
              [46.8867985, 33.5074062],
              [46.888888, 33.505999],
              [46.8902141, 33.5058985],
              [46.8907547, 33.5048622],
              [46.8908116, 33.5026825],
              [46.891664, 33.5012135],
              [46.8905843, 33.4994127],
              [46.8911525, 33.4980859],
              [46.8930279, 33.4980385],
              [46.8948463, 33.4979911],
              [46.8967217, 33.4985124],
              [46.8984833, 33.4985124],
              [46.9009269, 33.4978489],
              [46.9025181, 33.4975172],
              [46.9041092, 33.4979437],
              [46.9054163, 33.4985598],
              [46.9068938, 33.4980385],
              [46.9076326, 33.4971381],
              [46.9072916, 33.4953847],
              [46.9062687, 33.4936312],
              [46.9052458, 33.4917355],
              [46.9054731, 33.4896503],
              [46.906496, 33.4876597],
              [46.9083145, 33.4864274],
              [46.9104739, 33.4859061],
              [46.9120083, 33.4852425],
              [46.9132017, 33.4837259],
              [46.9139404, 33.482304],
              [46.9151338, 33.480882],
              [46.9160431, 33.4796023],
              [46.9168386, 33.4782277],
              [46.9186571, 33.4774219],
              [46.9210439, 33.4770901],
              [46.9230329, 33.4771375],
              [46.9249082, 33.4774219],
              [46.9267835, 33.4780381],
              [46.9287725, 33.4778485],
              [46.9298522, 33.4767109],
              [46.9308182, 33.4753836],
              [46.9317275, 33.4739142],
              [46.9319548, 33.4725395],
              [46.9317275, 33.4715915],
              [46.9351178, 33.4692592],
              [46.9384138, 33.4674578],
              [46.9410279, 33.4674578],
              [46.9431873, 33.4669364],
              [46.9454036, 33.4652772],
              [46.9478472, 33.4636179],
              [46.9505749, 33.4619586],
              [46.9529049, 33.4621009],
              [46.9544392, 33.4629068],
              [46.9554621, 33.4635705],
              [46.9573943, 33.4634283],
              [46.9588718, 33.4627646],
              [46.9606334, 33.4627172],
              [46.9626224, 33.4621009],
              [46.9638726, 33.4604889],
              [46.9648387, 33.4598252],
              [46.9651796, 33.45864],
              [46.9640999, 33.4573599],
              [46.9640431, 33.4557953],
              [46.9648955, 33.4546574],
              [46.9664299, 33.453804],
              [46.9679809, 33.4524015],
              [46.970254, 33.4511214],
              [46.9734364, 33.4505998],
              [46.9756527, 33.4485609],
              [46.9778689, 33.4469014],
              [46.9802557, 33.4456685],
              [46.982813, 33.4463798],
              [46.9845746, 33.4460953],
              [46.9867909, 33.4445305],
              [46.9891776, 33.4441511],
              [46.9901437, 33.444246],
              [46.9901437, 33.4455737],
              [46.991053, 33.4468539],
              [46.9924168, 33.4478971],
              [46.9944058, 33.4469488],
              [46.9946899, 33.4458582],
              [46.9930419, 33.4446253],
              [46.992019, 33.4431554],
              [46.9913939, 33.4416854],
              [46.9913939, 33.4396463],
              [46.9926441, 33.4376072],
              [46.9937239, 33.4363742],
              [46.9960538, 33.4360897],
              [46.9984406, 33.4367061],
              [47.0012251, 33.4372278],
              [47.0043506, 33.4376072],
              [47.0074193, 33.438034],
              [47.0100902, 33.4374649],
              [47.0112268, 33.4361845],
              [47.0128748, 33.4340979],
              [47.0145796, 33.4319638],
              [47.0149206, 33.4299245],
              [47.014466, 33.4281697],
              [47.0139545, 33.4258457],
              [47.0147501, 33.4245177],
              [47.0180461, 33.4237114],
              [47.0204329, 33.423332],
              [47.0234447, 33.4229526],
              [47.0245245, 33.4219565],
              [47.0257747, 33.4213874],
              [47.0261156, 33.420249],
              [47.0254337, 33.4198696],
              [47.0239562, 33.4198221],
              [47.0237857, 33.4188735],
              [47.0231606, 33.4171185],
              [47.0228764, 33.4155532],
              [47.0228764, 33.4137507],
              [47.0228764, 33.4116161],
              [47.0221377, 33.4096712],
              [47.021528, 33.4079421],
              [47.0181752, 33.406851],
              [47.0148224, 33.4055702],
              [47.0114696, 33.4047163],
              [47.0088555, 33.4028661],
              [47.007378, 33.4010633],
              [47.0064687, 33.3994503],
              [47.0062414, 33.3973628],
              [47.0062414, 33.3952752],
              [47.0064119, 33.3929978],
              [47.0073211, 33.3911474],
              [47.0074348, 33.3884429],
              [47.0088555, 33.3869245],
              [47.0110718, 33.3857383],
              [47.0136858, 33.3853587],
              [47.0166409, 33.385501],
              [47.0167927, 33.3855445],
              [47.0204483, 33.3865924],
              [47.0224373, 33.3877311],
              [47.0250514, 33.3873041],
              [47.0268698, 33.3861653],
              [47.0297112, 33.385074],
              [47.0307931, 33.383911],
              [47.0310342, 33.3799516],
              [47.033847, 33.3782739],
              [47.0397941, 33.377133],
              [47.0430088, 33.3747841],
              [47.0462235, 33.3737774],
              [47.0505632, 33.3728378],
              [47.0542601, 33.3713612],
              [47.0558674, 33.3686094],
              [47.0565907, 33.3650521],
              [47.0586803, 33.3618974],
              [47.0613324, 33.360622],
              [47.0675206, 33.3599508],
              [47.0712174, 33.3598837],
              [47.0739499, 33.3597494],
              [47.0761198, 33.3583398],
              [47.0778075, 33.3560575],
              [47.0767651, 33.3540758],
              [47.0786135, 33.3524647],
              [47.0808638, 33.3521291],
              [47.0845606, 33.3519948],
              [47.0860876, 33.3517934],
              [47.0876094, 33.3524296],
              [47.0885789, 33.3526661],
              [47.0905881, 33.3523976],
              [47.0931598, 33.3511221],
              [47.0947672, 33.3506522],
              [47.097012, 33.3500698],
              [47.0988494, 33.3494569],
              [47.1017813, 33.349842],
              [47.1038486, 33.3496452],
              [47.1056166, 33.3489739],
              [47.1050541, 33.3472284],
              [47.1038486, 33.3458186],
              [47.1023216, 33.3437373],
              [47.1013572, 33.3417232],
              [47.1019198, 33.3399776],
              [47.1022412, 33.3378962],
              [47.1034467, 33.3364191],
              [47.1054559, 33.3349419],
              [47.1084295, 33.3337333],
              [47.1111183, 33.3337774],
              [47.1125281, 33.3338005],
              [47.1173501, 33.3351434],
              [47.1206452, 33.3356134],
              [47.1232972, 33.3364191],
              [47.1240205, 33.3378962],
              [47.1254671, 33.3395076],
              [47.1272352, 33.3403804],
              [47.1295658, 33.340649],
              [47.1318965, 33.3403804],
              [47.1347093, 33.3403804],
              [47.1376828, 33.3403133],
              [47.1417815, 33.3397762],
              [47.1440318, 33.3394405],
              [47.1469473, 33.3376313],
              [47.150403, 33.3352813],
              [47.1539391, 33.3324612],
              [47.1575556, 33.3287681],
              [47.1628598, 33.3248062],
              [47.1659137, 33.3219186],
              [47.1708965, 33.3193668],
              [47.1742718, 33.3160089],
              [47.1760399, 33.313121],
              [47.177808, 33.3084196],
              [47.1795837, 33.3062327],
              [47.1805183, 33.3015716],
              [47.1880185, 33.2987998],
              [47.1891318, 33.2987997],
              [47.1894084, 33.2990796],
              [47.1910748, 33.2990796],
              [47.1977413, 33.3024112],
              [47.1991312, 33.3024113],
              [47.1996851, 33.3026911],
              [47.2007984, 33.3026911],
              [47.201075, 33.3024112],
              [47.2019079, 33.3024113],
              [47.2041313, 33.2990797],
              [47.2044079, 33.29852],
              [47.2038548, 33.2943577],
              [47.2030219, 33.2932473],
              [47.2007985, 33.2907463],
              [47.1955179, 33.2826838],
              [47.2013548, 33.2757408],
              [47.2044079, 33.2746303],
              [47.2116316, 33.2746303],
              [47.2121878, 33.2749103],
              [47.213855, 33.2749103],
              [47.2141316, 33.2751901],
              [47.2174645, 33.2754701],
              [47.2177411, 33.2751901],
              [47.2196879, 33.2751902],
              [47.222188, 33.2746304],
              [47.2252443, 33.27324],
              [47.2282983, 33.2696285],
              [47.2282983, 33.2690778],
              [47.2288546, 33.2687979],
              [47.2288546, 33.2682472],
              [47.2324648, 33.2629654],
              [47.2327445, 33.2601847],
              [47.2330212, 33.2599137],
              [47.2302445, 33.2515714],
              [47.230521, 33.2513004],
              [47.2305211, 33.2504608],
              [47.2319109, 33.2487995],
              [47.2324649, 33.2479689],
              [47.2396877, 33.2446283],
              [47.2427447, 33.2440776],
              [47.2455214, 33.2440776],
              [47.2463542, 33.2443575],
              [47.2463542, 33.2451881],
              [47.2474675, 33.2460187],
              [47.2474675, 33.2462986],
              [47.2505206, 33.2510206],
              [47.2524676, 33.2521311],
              [47.2544114, 33.2521312],
              [47.2546879, 33.2518512],
              [47.2552442, 33.2518513],
              [47.2552443, 33.2515713],
              [47.2588576, 33.2501901],
              [47.2594107, 33.2496303],
              [47.2660772, 33.2451881],
              [47.2694109, 33.2368547],
              [47.2702438, 33.2346336],
              [47.2713579, 33.2329634],
              [47.2733009, 33.2315729],
              [47.2749674, 33.2310222],
              [47.2771908, 33.2310222],
              [47.2808011, 33.233794],
              [47.2860808, 33.2379652],
              [47.2883004, 33.2379652],
              [47.2971904, 33.2324126],
              [47.2974709, 33.2321327],
              [47.2971904, 33.2296319],
              [47.2991373, 33.2274107],
              [47.3013569, 33.2271309],
              [47.301914, 33.2271309],
              [47.3021906, 33.2274107],
              [47.3033038, 33.2274107],
              [47.3074704, 33.2304715],
              [47.308304, 33.2304715],
              [47.3085805, 33.2301826],
              [47.3094133, 33.2299118],
              [47.3105235, 33.2276906],
              [47.310804, 33.2271309],
              [47.3105235, 33.2265801],
              [47.3099704, 33.2226888],
              [47.3119134, 33.2204677],
              [47.3169135, 33.2212984],
              [47.3199706, 33.2224089],
              [47.3246933, 33.2246299],
              [47.3258035, 33.22463],
              [47.3263606, 33.2249099],
              [47.3283036, 33.2249099],
              [47.3310802, 33.2218491],
              [47.3313599, 33.2193572],
              [47.3330271, 33.2174071],
              [47.3360834, 33.2162965],
              [47.338303, 33.2162965],
              [47.3444164, 33.2190774],
              [47.3469164, 33.2190774],
              [47.3508032, 33.2179669],
              [47.3510829, 33.2174071],
              [47.3524735, 33.215186],
              [47.3527501, 33.2146262],
              [47.3527502, 33.2132449],
              [47.3530268, 33.210464],
              [47.3533065, 33.2088028],
              [47.3535831, 33.2062927],
              [47.3538596, 33.2060219],
              [47.3566401, 33.2021305],
              [47.3571933, 33.2024104],
              [47.3583066, 33.2024104],
              [47.3602496, 33.2035209],
              [47.3680262, 33.210464],
              [47.3719162, 33.2104641],
              [47.3749733, 33.2093536],
              [47.3808062, 33.2046315],
              [47.3863626, 33.1982391],
              [47.3871962, 33.1979593],
              [47.3877493, 33.1974085],
              [47.3894157, 33.1965779],
              [47.3905292, 33.1965779],
              [47.3919197, 33.1968488],
              [47.3952526, 33.1990699],
              [47.3996957, 33.1976884],
              [47.4030294, 33.1907454],
              [47.4060857, 33.1888042],
              [47.4069193, 33.1888041],
              [47.4158094, 33.1857434],
              [47.4194188, 33.1824118],
              [47.4194188, 33.1821319],
              [47.4196953, 33.1815721],
              [47.4199759, 33.1813013],
              [47.4188625, 33.1804616],
              [47.4152524, 33.1788003],
              [47.4149757, 33.1779696],
              [47.4158093, 33.17713],
              [47.4188625, 33.1760194],
              [47.4221954, 33.1760194],
              [47.4224759, 33.1762993],
              [47.4238627, 33.1762993],
              [47.4241424, 33.1765792],
              [47.4252526, 33.1765792],
              [47.4255291, 33.1768591],
              [47.429419, 33.1768591],
              [47.4299757, 33.1765791],
              [47.4299756, 33.1762994],
              [47.4302522, 33.1760195],
              [47.4302523, 33.1754597],
              [47.4308088, 33.1749089],
              [47.4308088, 33.1743491],
              [47.4313656, 33.1740692],
              [47.4327522, 33.1724079],
              [47.4333089, 33.1724079],
              [47.4369188, 33.1704668],
              [47.4371989, 33.169907],
              [47.435809, 33.1590724],
              [47.4358091, 33.1551899],
              [47.4374755, 33.1532398],
              [47.4391423, 33.1532397],
              [47.4402521, 33.1535197],
              [47.4408087, 33.1535196],
              [47.4413655, 33.1537995],
              [47.444142, 33.1537996],
              [47.444419, 33.1535196],
              [47.4458089, 33.1535197],
              [47.4474753, 33.1529689],
              [47.448589, 33.152969],
              [47.448589, 33.1526891],
              [47.4491421, 33.152689],
              [47.4494222, 33.1524091],
              [47.4499753, 33.1524092],
              [47.4505321, 33.1521292],
              [47.4538652, 33.1515785],
              [47.4560888, 33.1515785],
              [47.4563654, 33.1512986],
              [47.4608087, 33.1512986],
              [47.4671398, 33.1478451],
              [47.4699785, 33.1462966],
              [47.4705321, 33.1460258],
              [47.4710887, 33.1460258],
              [47.4710887, 33.1457368],
              [47.4719219, 33.1457368],
              [47.4719219, 33.1454569],
              [47.4727551, 33.145457],
              [47.4730317, 33.1451861],
              [47.4733118, 33.1449062],
              [47.474145, 33.1449062],
              [47.474145, 33.1446263],
              [47.4758119, 33.142965],
              [47.4758119, 33.1424142],
              [47.4763649, 33.1401841],
              [47.4766451, 33.1385138],
              [47.4769216, 33.1376922],
              [47.4794217, 33.1349022],
              [47.4880533, 33.1327125],
              [47.4901227, 33.1314066],
              [47.4898592, 33.1297199],
              [47.4894187, 33.1294441],
              [47.4886482, 33.129211],
              [47.487262, 33.1299219],
              [47.4847745, 33.1292705],
              [47.4818534, 33.1278483],
              [47.4814727, 33.1255496],
              [47.4827441, 33.1239906],
              [47.4844218, 33.123246],
              [47.4866449, 33.1207449],
              [47.4919216, 33.1182439],
              [47.4914894, 33.1170929],
              [47.4896619, 33.1149593],
              [47.4922255, 33.1134397],
              [47.4955276, 33.1128952],
              [47.499645, 33.1073299],
              [47.5013386, 33.1049149],
              [47.5057499, 33.103622],
              [47.508061, 33.102614],
              [47.5083352, 33.1023843],
              [47.5086514, 33.1021194],
              [47.5092308, 33.1019952],
              [47.5101803, 33.1018585],
              [47.5107208, 33.1017614],
              [47.5116447, 33.1015767],
              [47.5133302, 33.1022425],
              [47.5146359, 33.1041982],
              [47.5191274, 33.1069899],
              [47.5222314, 33.1062316],
              [47.5233055, 33.1053696],
              [47.5236166, 33.1042694],
              [47.5226399, 33.1013522],
              [47.5254563, 33.0990389],
              [47.5259884, 33.0958458],
              [47.5255392, 33.0934766],
              [47.5256132, 33.0922632],
              [47.527758, 33.0904621],
              [47.5305451, 33.088101],
              [47.5291479, 33.0857399],
              [47.5328328, 33.0835832],
              [47.5376454, 33.0844568],
              [47.539566, 33.0828297],
              [47.5403342, 33.0814237],
              [47.541999, 33.0808941],
              [47.5432435, 33.081301],
              [47.5440654, 33.0815966],
              [47.5458403, 33.0818492],
              [47.5469244, 33.08546],
              [47.5491478, 33.0871304],
              [47.5499811, 33.0871304],
              [47.5522045, 33.0860199],
              [47.556091, 33.0790766],
              [47.5622043, 33.0762957],
              [47.5644275, 33.0740746],
              [47.5669275, 33.0715736],
              [47.5755375, 33.06268],
              [47.5785942, 33.0615695],
              [47.5788708, 33.0610187],
              [47.5797039, 33.0607388],
              [47.5799841, 33.060179],
              [47.5872038, 33.0493533],
              [47.5874839, 33.0490733],
              [47.5922039, 33.0451818],
              [47.5933172, 33.0451819],
              [47.5977607, 33.047403],
              [47.5999837, 33.047403],
              [47.6002604, 33.0471231],
              [47.6019272, 33.0465724],
              [47.6113738, 33.0387983],
              [47.6124836, 33.0387984],
              [47.6197069, 33.0362883],
              [47.6238737, 33.0321259],
              [47.6244304, 33.032126],
              [47.6247069, 33.0318461],
              [47.6255401, 33.0318461],
              [47.6280402, 33.0324059],
              [47.6288734, 33.0326857],
              [47.6308168, 33.0343471],
              [47.6322067, 33.0349069],
              [47.6335969, 33.0349069],
              [47.6341501, 33.0346271],
              [47.6366533, 33.034627],
              [47.6372067, 33.0343471],
              [47.6405401, 33.0337964],
              [47.6408201, 33.0332366],
              [47.6416534, 33.0326858],
              [47.6458199, 33.026853],
              [47.6466535, 33.0262933],
              [47.6485965, 33.0262933],
              [47.648873, 33.0260133],
              [47.6502634, 33.0260134],
              [47.6505399, 33.0257334],
              [47.6538732, 33.0235123],
              [47.65721, 33.0201806],
              [47.6605432, 33.01907],
              [47.661653, 33.0176795],
              [47.6749861, 33.0101855],
              [47.6758198, 33.0101854],
              [47.6760999, 33.0099056],
              [47.6769331, 33.0099056],
              [47.6772095, 33.0096257],
              [47.6783194, 33.0096257],
              [47.6785995, 33.0093457],
              [47.6797096, 33.0090749],
              [47.6799862, 33.008795],
              [47.6872094, 33.0051834],
              [47.6905427, 33.0024024],
              [47.691656, 33.0021316],
              [47.7063759, 33.0049034],
              [47.7080427, 33.0049035],
              [47.7083227, 33.0051834],
              [47.7113791, 33.0051834],
              [47.7116561, 33.0049035],
              [47.7122127, 33.0049036],
              [47.717489, 33.0032422],
              [47.7180459, 33.0029623],
              [47.7210992, 33.0029623],
              [47.7216558, 33.0032422],
              [47.7230457, 33.0032422],
              [47.7235988, 33.0035221],
              [47.7266555, 33.0035221],
              [47.7269321, 33.0032422],
              [47.7274892, 33.0032423],
              [47.7280458, 33.0026824],
              [47.728599, 33.0026824],
              [47.7302689, 33.0007412],
              [47.7308224, 32.9993507],
              [47.7422121, 32.9949085],
              [47.7441555, 32.9949084],
              [47.7444356, 32.9951883],
              [47.7491587, 32.9979603],
              [47.7499919, 32.9979603],
              [47.7505454, 32.9982402],
              [47.7519353, 32.9982401],
              [47.7533252, 32.9982401],
              [47.7616586, 32.9937979],
              [47.7713818, 32.9846333],
              [47.7722151, 32.9832429],
              [47.7760044, 32.9799021],
              [47.7763816, 32.9796312],
              [47.7780484, 32.9790714],
              [47.7802685, 32.9790714],
              [47.7808251, 32.9787915],
              [47.784715, 32.9787916],
              [47.7849915, 32.9785117],
              [47.7888814, 32.9774101],
              [47.7902718, 32.9768503],
              [47.7905483, 32.9765703],
              [47.7911049, 32.9765704],
              [47.7969382, 32.9746291],
              [47.798048, 32.9746293],
              [47.7999915, 32.9740693],
              [47.8097147, 32.9718482],
              [47.8111046, 32.9710176],
              [47.8211044, 32.9654556],
              [47.8258279, 32.959072],
              [47.825828, 32.9582414],
              [47.8299944, 32.9532393],
              [47.8322179, 32.9518487],
              [47.8333277, 32.951018],
              [47.8374942, 32.9482371],
              [47.8477741, 32.9371222],
              [47.8486078, 32.9368513],
              [47.8491608, 32.9362915],
              [47.8533274, 32.9343503],
              [47.8555509, 32.9343503],
              [47.8561076, 32.9340704],
              [47.8563841, 32.9343502],
              [47.8572173, 32.9340704],
              [47.8577743, 32.9343503],
              [47.860274, 32.9343503],
              [47.8605509, 32.9346302],
              [47.8613842, 32.9346301],
              [47.862774, 32.9349011],
              [47.8633307, 32.9349011],
              [47.8677742, 32.9390726],
              [47.8691641, 32.9390726],
              [47.8694405, 32.9387926],
              [47.8702739, 32.9387927],
              [47.8719406, 32.9382329],
              [47.8741641, 32.9365715],
              [47.8774974, 32.9324091],
              [47.8774974, 32.9268471],
              [47.8794404, 32.9229555],
              [47.886107, 32.9201836],
              [47.8874973, 32.919073],
              [47.8877738, 32.9187931],
              [47.8888872, 32.9157321],
              [47.8891636, 32.9149015],
              [47.8894402, 32.9140708],
              [47.892497, 32.9115697],
              [47.8936071, 32.9115697],
              [47.8941638, 32.9112898],
              [47.8966639, 32.9112898],
              [47.8997202, 32.9121296],
              [47.9016636, 32.9137909],
              [47.9027768, 32.913791],
              [47.9047202, 32.9115697],
              [47.9044438, 32.9087887],
              [47.9049969, 32.9076782],
              [47.9061101, 32.9071274],
              [47.910277, 32.9071274],
              [47.9105536, 32.9074073],
              [47.912497, 32.9079581],
              [47.9147201, 32.9079581],
              [47.9194436, 32.905457],
              [47.9230534, 32.9015654],
              [47.9236101, 32.9015654],
              [47.9263868, 32.9001839],
              [47.9313864, 32.9015654],
              [47.9344431, 32.8999041],
              [47.9355534, 32.8987935],
              [47.9349998, 32.8949019],
              [47.9347197, 32.8940712],
              [47.9344432, 32.8924008],
              [47.93611, 32.8896198],
              [47.9366666, 32.8893489],
              [47.9438898, 32.8832361],
              [47.9547229, 32.878234],
              [47.9580562, 32.8779631],
              [47.9591663, 32.878234],
              [47.9630563, 32.8749022],
              [47.9638895, 32.8737916],
              [47.9641661, 32.872681],
              [47.9644461, 32.8707398],
              [47.9647232, 32.8682387],
              [47.9649998, 32.867408],
              [47.9652798, 32.8660084],
              [47.9658329, 32.8649069],
              [47.9733327, 32.8565638],
              [47.974723, 32.856013],
              [47.9769461, 32.856013],
              [47.9772226, 32.8557331],
              [47.9780563, 32.8554622],
              [47.9797227, 32.8554623],
              [47.9800028, 32.8551823],
              [47.9811129, 32.8551823],
              [47.9833361, 32.8529612],
              [47.983336, 32.8526813],
              [47.9833361, 32.8518505],
              [47.9827794, 32.85046],
              [47.9822228, 32.8501802],
              [47.981113, 32.8468483],
              [47.9813896, 32.8465685],
              [47.9813896, 32.8460177],
              [47.9825029, 32.844898],
              [47.9833361, 32.8446181],
              [47.9847228, 32.8446181],
              [47.9850029, 32.8446181],
              [47.9852795, 32.844898],
              [47.9863893, 32.844898],
              [47.9875026, 32.8457377],
              [47.9883362, 32.8457378],
              [47.9886127, 32.8460177],
              [47.9897226, 32.8460177],
              [47.9897225, 32.8462976],
              [47.9913893, 32.8462976],
              [47.9941696, 32.8435165],
              [47.9952793, 32.8418461],
              [47.9952793, 32.8412864],
              [47.9952793, 32.8390652],
              [48.0002794, 32.8232368],
              [48.0005591, 32.8224062],
              [48.0008361, 32.8212865],
              [48.0011126, 32.8204558],
              [48.0013928, 32.8193452],
              [48.0025026, 32.817124],
              [48.0025025, 32.8168441],
              [48.0025026, 32.8165642],
              [48.0027792, 32.8151827],
              [48.0033357, 32.8137922],
              [48.0033358, 32.8135123],
              [48.0033358, 32.8132324],
              [48.0033357, 32.8129525],
              [48.0033358, 32.8118509],
              [48.0027791, 32.8112911],
              [48.0030593, 32.8110111],
              [48.0094457, 32.8007358],
              [48.0113927, 32.7940722],
              [48.0116692, 32.7937923],
              [48.0125025, 32.7904605],
              [48.0100024, 32.7793454],
              [48.0066692, 32.7746231],
              [48.0063926, 32.7743431],
              [47.9988928, 32.7685101],
              [47.996946, 32.7676794],
              [47.9952795, 32.7676794],
              [47.9916697, 32.7671196],
              [47.991113, 32.7673995],
              [47.990836, 32.7671196],
              [47.9830563, 32.7671196],
              [47.9825031, 32.7668397],
              [47.9636133, 32.7665688],
              [47.9630567, 32.7662889],
              [47.9586136, 32.7662888],
              [47.9580566, 32.7660089],
              [47.9486102, 32.7651782],
              [47.9433336, 32.7637876],
              [47.9419438, 32.7632278],
              [47.9408335, 32.7626771],
              [47.9400003, 32.7626771],
              [47.9400004, 32.7623972],
              [47.9394436, 32.7623972],
              [47.9350002, 32.7560044],
              [47.9352768, 32.7551737],
              [47.9350003, 32.7499005],
              [47.931667, 32.7473994],
              [47.9308338, 32.7473994],
              [47.9305537, 32.7471195],
              [47.9275005, 32.7462887],
              [47.9244438, 32.7374039],
              [47.9247205, 32.737124],
              [47.9238873, 32.7310111],
              [47.9227774, 32.7299004],
              [47.9222208, 32.7296206],
              [47.9172207, 32.7276793],
              [47.9161105, 32.7276792],
              [47.9105541, 32.7235076],
              [47.9102776, 32.7212864],
              [47.9161106, 32.7140629],
              [47.9172207, 32.7135122],
              [47.918054, 32.7126725],
              [47.9286104, 32.7073992],
              [47.9288874, 32.7071194],
              [47.9411104, 32.6987853],
              [47.9502769, 32.6901803],
              [47.9516672, 32.6862887],
              [47.9519438, 32.6860087],
              [47.950557, 32.6790651],
              [47.9525004, 32.6748936],
              [47.9586139, 32.6671192],
              [47.9588904, 32.6668393],
              [47.9693907, 32.6587288],
              [47.9691466, 32.6582799],
              [47.970131, 32.6585111],
              [47.9713326, 32.6586956],
              [47.9720422, 32.6586947],
              [47.973133, 32.6584213],
              [47.9748801, 32.6579135],
              [47.9774399, 32.6568573],
              [47.9789657, 32.6559835],
              [47.9798889, 32.6552011],
              [47.9804878, 32.65451],
              [47.9815216, 32.653728],
              [47.9821206, 32.6534494],
              [47.9831008, 32.6534955],
              [47.9843064, 32.6537274],
              [47.984447, 32.6537829],
              [47.9852371, 32.6540946],
              [47.9867668, 32.6546025],
              [47.9878082, 32.6549227],
              [47.9891205, 32.6553847],
              [47.9904131, 32.6556886],
              [47.9908715, 32.6557964],
              [47.9919662, 32.6564876],
              [47.9934464, 32.6572691],
              [47.9941389, 32.6578166],
              [47.9944344, 32.6580501],
              [47.9952049, 32.6589702],
              [47.9963569, 32.6597528],
              [47.9972381, 32.661133],
              [47.998066, 32.6627419],
              [47.9989549, 32.6649968],
              [47.9993879, 32.666346],
              [47.9995515, 32.6665736],
              [47.9995906, 32.666628],
              [47.9999771, 32.6668875],
              [48.0012818, 32.6675904],
              [48.0019418, 32.6681358],
              [48.0021668, 32.6685942],
              [48.0021782, 32.6692887],
              [48.0018043, 32.6698004],
              [48.0014801, 32.6698941],
              [48.0013351, 32.6708643],
              [48.001236, 32.6714164],
              [48.0012401, 32.6716658],
              [48.0012435, 32.6718786],
              [48.0012512, 32.6724806],
              [48.0009957, 32.673358],
              [48.0011634, 32.6738669],
              [48.0014992, 32.6743235],
              [48.0020447, 32.6745484],
              [48.0034026, 32.6745335],
              [48.0042152, 32.6745259],
              [48.0050887, 32.6747023],
              [48.0058479, 32.6746979],
              [48.0062828, 32.6748773],
              [48.0067215, 32.6750568],
              [48.0073776, 32.6752348],
              [48.0082474, 32.6755035],
              [48.0086326, 32.6756366],
              [48.0093917, 32.6756322],
              [48.0100366, 32.6753456],
              [48.0107421, 32.675155],
              [48.0119285, 32.6748204],
              [48.0132789, 32.6743477],
              [48.0145759, 32.6739662],
              [48.0159835, 32.6737224],
              [48.0178756, 32.673195],
              [48.0188485, 32.6729544],
              [48.0202561, 32.6727557],
              [48.0211753, 32.6725206],
              [48.0223694, 32.6725084],
              [48.0231819, 32.6723586],
              [48.0239448, 32.6724015],
              [48.0247613, 32.6725314],
              [48.0255241, 32.6727072],
              [48.0260125, 32.6728856],
              [48.0265656, 32.6734352],
              [48.0271683, 32.673889],
              [48.0276146, 32.6744833],
              [48.0283851, 32.675171],
              [48.0291482, 32.675437],
              [48.0298042, 32.6757095],
              [48.030674, 32.6757459],
              [48.0322495, 32.6757314],
              [48.0335502, 32.6756292],
              [48.0352325, 32.675563],
              [48.0371322, 32.6754998],
              [48.0388145, 32.6755756],
              [48.0400123, 32.6757954],
              [48.0416526, 32.6764269],
              [48.043129, 32.6770546],
              [48.0443802, 32.6774131],
              [48.0452004, 32.6776353],
              [48.0462342, 32.6777183],
              [48.0468864, 32.6777562],
              [48.0473175, 32.6775703],
              [48.0478516, 32.6770554],
              [48.0480004, 32.6763151],
              [48.0484772, 32.6755284],
              [48.0492248, 32.6747369],
              [48.0499763, 32.6743173],
              [48.0510559, 32.6738423],
              [48.0525704, 32.6735534],
              [48.0546874, 32.6733484],
              [48.057129, 32.6733697],
              [48.0594102, 32.6735337],
              [48.0618629, 32.6739698],
              [48.0630035, 32.6741904],
              [48.064911, 32.6745416],
              [48.0658416, 32.6751291],
              [48.066887, 32.6758568],
              [48.0676537, 32.6762196],
              [48.068798, 32.676483],
              [48.0697212, 32.6766128],
              [48.0700981, 32.6766379],
              [48.070919, 32.6766927],
              [48.0718955, 32.6766862],
              [48.0727691, 32.6770897],
              [48.0729942, 32.6775976],
              [48.0730592, 32.6782415],
              [48.0732269, 32.6786083],
              [48.0737267, 32.6792939],
              [48.0738564, 32.6804465],
              [48.0745164, 32.6811291],
              [48.0745278, 32.681774],
              [48.0744924, 32.6821173],
              [48.0744324, 32.6826981],
              [48.0743942, 32.6834839],
              [48.0744553, 32.684033],
              [48.0744629, 32.6845403],
              [48.0745811, 32.685048],
              [48.0749093, 32.685272],
              [48.0756226, 32.6855885],
              [48.0767631, 32.6857638],
              [48.0798188, 32.6866532],
              [48.0818368, 32.6873697],
              [48.0833663, 32.6878628],
              [48.0840225, 32.6880426],
              [48.0846749, 32.6882674],
              [48.0853843, 32.688489],
              [48.0865288, 32.6886644],
              [48.0873985, 32.6888852],
              [48.0881156, 32.6893842],
              [48.0883137, 32.689622],
              [48.0886116, 32.6899795],
              [48.0891686, 32.6908941],
              [48.0897255, 32.6917658],
              [48.0899544, 32.6925465],
              [48.0901947, 32.6939698],
              [48.0903205, 32.6948473],
              [48.0904389, 32.6956299],
              [48.0903968, 32.6962285],
              [48.0900269, 32.6969231],
              [48.0895538, 32.6978025],
              [48.0889702, 32.6987311],
              [48.088005, 32.6995246],
              [48.0874786, 32.7005424],
              [48.0870552, 32.7012832],
              [48.08675, 32.7024391],
              [48.0866013, 32.7034522],
              [48.0865632, 32.7042853],
              [48.0859222, 32.7049827],
              [48.0852738, 32.7051276],
              [48.0844574, 32.7051357],
              [48.0832634, 32.7051462],
              [48.0826072, 32.7048762],
              [48.0821724, 32.704697],
              [48.0814055, 32.7042893],
              [48.0804672, 32.7032847],
              [48.0798531, 32.7023237],
              [48.0789222, 32.7018737],
              [48.0781517, 32.7012337],
              [48.0776063, 32.7010564],
              [48.0771714, 32.7009201],
              [48.0764655, 32.7009284],
              [48.0759773, 32.7009801],
              [48.0753365, 32.7015827],
              [48.0748558, 32.7022364],
              [48.0744362, 32.7032094],
              [48.0737457, 32.7040453],
              [48.072731, 32.704975],
              [48.0718193, 32.7057223],
              [48.0705796, 32.7064281],
              [48.0693359, 32.7067597],
              [48.0677147, 32.7071004],
              [48.0656623, 32.7077218],
              [48.0645294, 32.7082407],
              [48.0645027, 32.7082663],
              [48.0639953, 32.7087511],
              [48.0637931, 32.7096299],
              [48.0636979, 32.7104143],
              [48.0638122, 32.710967],
              [48.0640908, 32.7113341],
              [48.0645828, 32.7115598],
              [48.0652351, 32.7115976],
              [48.0661583, 32.7115899],
              [48.0669747, 32.7117646],
              [48.0678977, 32.7118448],
              [48.0686645, 32.7121625],
              [48.0692672, 32.7124786],
              [48.0696526, 32.7127942],
              [48.0698814, 32.7135321],
              [48.0701065, 32.714085],
              [48.0703392, 32.7150033],
              [48.0705643, 32.7154166],
              [48.0710068, 32.7161031],
              [48.0718802, 32.7164165],
              [48.0724297, 32.7167314],
              [48.0732459, 32.7167707],
              [48.0741157, 32.7168542],
              [48.0753594, 32.7166556],
              [48.0765991, 32.7161819],
              [48.078659, 32.715885],
              [48.0802841, 32.715684],
              [48.0820235, 32.7158057],
              [48.0829505, 32.7160729],
              [48.0830421, 32.7160785],
              [48.0835496, 32.7161094],
              [48.0842057, 32.7164718],
              [48.0848656, 32.7170191],
              [48.0854187, 32.7177037],
              [48.0858688, 32.7184827],
              [48.0859832, 32.7189452],
              [48.0860444, 32.7194064],
              [48.0860481, 32.7196815],
              [48.0859489, 32.7200962],
              [48.0854149, 32.7207487],
              [48.084938, 32.7215806],
              [48.0845681, 32.7220926],
              [48.0845795, 32.7228773],
              [48.0845986, 32.7239799],
              [48.0843392, 32.72472],
              [48.0839082, 32.725048],
              [48.0835839, 32.7250517],
              [48.0828782, 32.7250601],
              [48.0824966, 32.7250625],
              [48.081955, 32.7250679],
              [48.0816344, 32.7252588],
              [48.0814209, 32.7254905],
              [48.0814285, 32.7260429],
              [48.0816003, 32.7265923],
              [48.0819397, 32.7273756],
              [48.0819511, 32.7281107],
              [48.0819626, 32.7288931],
              [48.081543, 32.7299111],
              [48.0811272, 32.7309292],
              [48.0809746, 32.7315793],
              [48.0805474, 32.731948],
              [48.0800628, 32.732232],
              [48.0793038, 32.7323293],
              [48.0785941, 32.7321549],
              [48.0776711, 32.7321672],
              [48.0757636, 32.7316787],
              [48.0742874, 32.7310942],
              [48.0728683, 32.7305562],
              [48.072319, 32.7301444],
              [48.0714988, 32.7298322],
              [48.0700874, 32.729709],
              [48.0685693, 32.7298155],
              [48.0678112, 32.7299255],
              [48.0675392, 32.729965],
              [48.0669441, 32.7302012],
              [48.0665779, 32.7310379],
              [48.0665359, 32.7317739],
              [48.0665475, 32.732509],
              [48.066616, 32.7332499],
              [48.0666276, 32.7339399],
              [48.066655, 32.7340791],
              [48.0667457, 32.7345399],
              [48.0670739, 32.7349015],
              [48.0673484, 32.7350837],
              [48.0677834, 32.7350804],
              [48.0681114, 32.7350768],
              [48.0684395, 32.7352107],
              [48.0686645, 32.7357141],
              [48.0686684, 32.7360388],
              [48.0686188, 32.7364073],
              [48.0684585, 32.73655],
              [48.0678138, 32.737015],
              [48.0671158, 32.7373007],
              [48.0664139, 32.737584],
              [48.0656013, 32.7376822],
              [48.0648422, 32.7378312],
              [48.0635986, 32.7382123],
              [48.061689, 32.7392354],
              [48.0609626, 32.7396245],
              [48.0599975, 32.7403727],
              [48.0597916, 32.7409697],
              [48.0598526, 32.7415233],
              [48.0600776, 32.7419817],
              [48.0604096, 32.7423028],
              [48.0611686, 32.7423859],
              [48.0618209, 32.7423787],
              [48.0625267, 32.7424651],
              [48.0631828, 32.7426406],
              [48.063839, 32.7429129],
              [48.063884, 32.7429377],
              [48.064331, 32.7431836],
              [48.0646095, 32.7435959],
              [48.0648919, 32.7442358],
              [48.0648994, 32.7447432],
              [48.0647468, 32.7454834],
              [48.0645408, 32.7461773],
              [48.0641213, 32.7469631],
              [48.0639153, 32.747657],
              [48.0634422, 32.7485858],
              [48.0634499, 32.7491833],
              [48.063501, 32.7501199],
              [48.0636444, 32.7507431],
              [48.063221, 32.7515761],
              [48.0623664, 32.7528656],
              [48.0610275, 32.7541122],
              [48.0600128, 32.7548074],
              [48.0593148, 32.7555438],
              [48.0589272, 32.7566284],
              [48.0588379, 32.7568782],
              [48.058792, 32.7579838],
              [48.0590133, 32.7590416],
              [48.0596085, 32.7595018],
              [48.060955, 32.7598197],
              [48.0617103, 32.7599569],
              [48.0626224, 32.7599175],
              [48.062893, 32.7599058],
              [48.0646171, 32.7601783],
              [48.0655861, 32.760174],
              [48.0663948, 32.7602651],
              [48.066986, 32.760448],
              [48.067852, 32.7609055],
              [48.0681762, 32.7613639],
              [48.0683975, 32.7618717],
              [48.0686684, 32.7624213],
              [48.0687829, 32.7633391],
              [48.0686799, 32.764263],
              [48.0680924, 32.76509],
              [48.0676155, 32.7658767],
              [48.0670242, 32.766521],
              [48.0661125, 32.767124],
              [48.0649873, 32.767864],
              [48.0644494, 32.76823],
              [48.0635375, 32.7685129],
              [48.0627824, 32.7686034],
              [48.0614929, 32.7685619],
              [48.0601997, 32.7685202],
              [48.0587465, 32.768752],
              [48.0580445, 32.7688032],
              [48.0575599, 32.7686205],
              [48.0572357, 32.7683897],
              [48.0565339, 32.7678864],
              [48.0560989, 32.7676124],
              [48.0554505, 32.7671509],
              [48.054966, 32.7669682],
              [48.0544815, 32.7668802],
              [48.0540505, 32.7670165],
              [48.05373, 32.7672051],
              [48.0535697, 32.767758],
              [48.0537415, 32.7698244],
              [48.0537675, 32.7706794],
              [48.0538101, 32.7720822],
              [48.0542527, 32.7741956],
              [48.0545807, 32.7755309],
              [48.054802, 32.7760342],
              [48.0551262, 32.7765895],
              [48.0562095, 32.7773205],
              [48.0569115, 32.7776863],
              [48.0578308, 32.7780528],
              [48.0584903, 32.7783338],
              [48.058693, 32.7784202],
              [48.0595055, 32.778969],
              [48.060154, 32.7795229],
              [48.0622635, 32.781033],
              [48.0640564, 32.7828714],
              [48.0659485, 32.7843808],
              [48.0670357, 32.7856685],
              [48.0675278, 32.7865411],
              [48.0679093, 32.7876004],
              [48.0682373, 32.7883338],
              [48.0682412, 32.7888861],
              [48.0680847, 32.7896691],
              [48.0677644, 32.7902679],
              [48.0672837, 32.7907299],
              [48.0661545, 32.7913323],
              [48.065403, 32.7915649],
              [48.0638923, 32.7916602],
              [48.0629195, 32.7916644],
              [48.0616799, 32.7914347],
              [48.0605469, 32.7913472],
              [48.0591966, 32.7909842],
              [48.0589791, 32.7907514],
              [48.0584373, 32.7901572],
              [48.0578384, 32.7894669],
              [48.0571862, 32.7881353],
              [48.0568581, 32.7873545],
              [48.0565091, 32.7869798],
              [48.0562592, 32.7867115],
              [48.055935, 32.7863884],
              [48.0555573, 32.7861586],
              [48.0553437, 32.786255],
              [48.0552368, 32.7866221],
              [48.0551873, 32.7872656],
              [48.0550873, 32.7878686],
              [48.0550052, 32.7879504],
              [48.0546192, 32.7896279],
              [48.0544558, 32.7903377],
              [48.0543441, 32.7912262],
              [48.054512, 32.7920528],
              [48.0545196, 32.7935248],
              [48.05447, 32.7941705],
              [48.0543666, 32.7946053],
              [48.0542068, 32.7952778],
              [48.0540542, 32.7975349],
              [48.0542222, 32.7986365],
              [48.0543614, 32.7990261],
              [48.0543862, 32.7990956],
              [48.0544472, 32.7997845],
              [48.0547219, 32.8006587],
              [48.0548325, 32.8015832],
              [48.0546761, 32.8024563],
              [48.0544091, 32.8032389],
              [48.0536041, 32.8037947],
              [48.0526351, 32.8044864],
              [48.0517769, 32.8049057],
              [48.0509682, 32.804997],
              [48.0501533, 32.8049608],
              [48.0499955, 32.8049538],
              [48.0490227, 32.8050954],
              [48.0488091, 32.8054172],
              [48.0490266, 32.8057852],
              [48.049889, 32.8061937],
              [48.0562783, 32.8092197],
              [48.0574592, 32.8099007],
              [48.0575661, 32.8099624],
              [48.0579445, 32.8101805],
              [48.0654841, 32.8086245],
              [48.074976, 32.8078603],
              [48.0789286, 32.8034739],
              [48.0783467, 32.8007824],
              [48.0797724, 32.8002151],
              [48.0899842, 32.8047236],
              [48.0979953, 32.8061275],
              [48.1071238, 32.8155439],
              [48.109829, 32.8208779],
              [48.1144269, 32.8246248],
              [48.1208057, 32.8307657],
              [48.1183216, 32.8335299],
              [48.1149866, 32.832806],
              [48.1114794, 32.8353214],
              [48.1077472, 32.8373066],
              [48.1064337, 32.8425198],
              [48.105734, 32.8435321],
              [48.1043761, 32.8442421],
              [48.1045036, 32.8445738],
              [48.1040841, 32.8459548],
              [48.1043091, 32.8469653],
              [48.105236, 32.8480236],
              [48.1062699, 32.8488499],
              [48.106936, 32.8491029],
              [48.1073569, 32.8492627],
              [48.1092605, 32.8505893],
              [48.1104622, 32.8518748],
              [48.1119347, 32.8529772],
              [48.1127548, 32.8541253],
              [48.1135178, 32.8548124],
              [48.1138001, 32.8559639],
              [48.1141319, 32.8570219],
              [48.1141433, 32.8583114],
              [48.1144218, 32.8592307],
              [48.1141502, 32.859774],
              [48.1138915, 32.8602914],
              [48.1146012, 32.8608848],
              [48.1151542, 32.8624505],
              [48.1161346, 32.8629983],
              [48.1173362, 32.8639637],
              [48.1187553, 32.8652],
              [48.1195371, 32.865538],
              [48.1207658, 32.866069],
              [48.1219635, 32.8668021],
              [48.1226234, 32.8676761],
              [48.1230049, 32.868228],
              [48.1236611, 32.8689148],
              [48.1239929, 32.8693778],
              [48.1246986, 32.8698809],
              [48.1256751, 32.8700611],
              [48.1263809, 32.8699691],
              [48.1276245, 32.8699188],
              [48.1282768, 32.8702404],
              [48.1288223, 32.8704693],
              [48.1288833, 32.8712956],
              [48.1286773, 32.8724021],
              [48.1285249, 32.8733205],
              [48.1282081, 32.8742914],
              [48.1282767, 32.8757175],
              [48.1285591, 32.8766819],
              [48.1285668, 32.8777392],
              [48.1285248, 32.87889],
              [48.1285323, 32.8795822],
              [48.1285935, 32.8804085],
              [48.1280097, 32.8816528],
              [48.1273155, 32.8829915],
              [48.1266212, 32.8839154],
              [48.1259193, 32.8843298],
              [48.1257586, 32.8844964],
              [48.1253853, 32.8848833],
              [48.1251716, 32.8854373],
              [48.1253549, 32.8859945],
              [48.1255646, 32.886632],
              [48.1253547, 32.8874633],
              [48.1248208, 32.8883369],
              [48.1245472, 32.8889917],
              [48.1243973, 32.8893504],
              [48.1230507, 32.8905073],
              [48.1219787, 32.8920243],
              [48.1212311, 32.893089],
              [48.1202163, 32.8947944],
              [48.1194688, 32.8961746],
              [48.1190986, 32.8971893],
              [48.1187325, 32.8984792],
              [48.1186829, 32.8990325],
              [48.1195068, 32.9001807],
              [48.1206055, 32.901741],
              [48.1225853, 32.9046356],
              [48.1238519, 32.9066122],
              [48.1265488, 32.9106097],
              [48.1280898, 32.9126331],
              [48.1295127, 32.9139168],
              [48.1310501, 32.9156606],
              [48.1327477, 32.9171759],
              [48.1341172, 32.9183231],
              [48.1356505, 32.919377],
              [48.1368485, 32.9197426],
              [48.1376648, 32.9198808],
              [48.1385345, 32.9198759],
              [48.1397248, 32.9197341],
              [48.1415176, 32.9194979],
              [48.1436807, 32.9188036],
              [48.1456833, 32.9180605],
              [48.1473046, 32.9172748],
              [48.1484908, 32.9165806],
              [48.1496734, 32.9152913],
              [48.1515046, 32.9139018],
              [48.1537055, 32.9117363],
              [48.1554795, 32.9100276],
              [48.1575737, 32.9079521],
              [48.158207, 32.9064293],
              [48.1586081, 32.9059827],
              [48.1594926, 32.9049979],
              [48.1610031, 32.9040292],
              [48.1633224, 32.9028242],
              [48.1641738, 32.9023863],
              [48.1652247, 32.9018459],
              [48.1657486, 32.9015764],
              [48.1691018, 32.9005548],
              [48.1718635, 32.9000403],
              [48.1755486, 32.8997563],
              [48.1767425, 32.8997539],
              [48.1780471, 32.9001621],
              [48.1796875, 32.9009407],
              [48.1817093, 32.9023162],
              [48.1820567, 32.9026734],
              [48.183361, 32.9040146],
              [48.1861687, 32.9070014],
              [48.1879959, 32.9098961],
              [48.1914673, 32.9137541],
              [48.1943398, 32.9175649],
              [48.1973725, 32.920917],
              [48.1991997, 32.9235389],
              [48.2006875, 32.9250058],
              [48.2039413, 32.9284011],
              [48.2073631, 32.9322622],
              [48.2103462, 32.9355205],
              [48.2134857, 32.9384126],
              [48.2164649, 32.9413034],
              [48.2189483, 32.9438787],
              [48.2205544, 32.9457132],
              [48.222599, 32.9479181],
              [48.2254257, 32.9513169],
              [48.2273064, 32.9534752],
              [48.2286873, 32.9547163],
              [48.2303963, 32.9560886],
              [48.2321015, 32.9573751],
              [48.23452, 32.9589344],
              [48.2348116, 32.9591663],
              [48.2358436, 32.9599871],
              [48.2386664, 32.9629753],
              [48.2404862, 32.9643972],
              [48.2441292, 32.9673809],
              [48.2451249, 32.9682955],
              [48.2470818, 32.971465],
              [48.2491394, 32.9739425],
              [48.24965, 32.9765745],
              [48.2499466, 32.9781032],
              [48.2514267, 32.9794815],
              [48.2531777, 32.9810415],
              [48.2551003, 32.9831553],
              [48.2569122, 32.985084],
              [48.2580071, 32.9861404],
              [48.2593193, 32.9871949],
              [48.2604141, 32.9880687],
              [48.2609995, 32.9883782],
              [48.2620506, 32.9889341],
              [48.2635194, 32.9897079],
              [48.26614, 32.9912147],
              [48.268486, 32.9927718],
              [48.2689253, 32.9930986],
              [48.2699622, 32.9938702],
              [48.2710571, 32.994602],
              [48.272419, 32.9952426],
              [48.2730141, 32.9953773],
              [48.2736169, 32.9957421],
              [48.2745972, 32.9963338],
              [48.2759018, 32.9966508],
              [48.2759552, 32.9966971],
              [48.2775841, 32.996913],
              [48.2796974, 32.9971281],
              [48.2818107, 32.997066],
              [48.2827414, 32.9970014],
              [48.2855416, 32.9968069],
              [48.2869492, 32.9965625],
              [48.2881356, 32.9962772],
              [48.2901383, 32.9962148],
              [48.2930603, 32.9959604],
              [48.296196, 32.9956091],
              [48.2990609, 32.9949409],
              [48.3024064, 32.9941252],
              [48.3048363, 32.9935533],
              [48.3068352, 32.9929811],
              [48.3134689, 32.9906582],
              [48.320423, 32.9882899],
              [48.3231735, 32.9871565],
              [48.3253784, 32.9861173],
              [48.3266182, 32.9854631],
              [48.3281822, 32.9849399],
              [48.330288, 32.9844124],
              [48.3323364, 32.9836087],
              [48.3340034, 32.9827607],
              [48.3352432, 32.9821515],
              [48.3378868, 32.9813875],
              [48.3401491, 32.9806775],
              [48.3410682, 32.9803891],
              [48.3438224, 32.9795799],
              [48.3471642, 32.9784879],
              [48.352726, 32.9771949],
              [48.3555908, 32.9765253],
              [48.3575363, 32.9762307],
              [48.3591004, 32.9756168],
              [48.3617935, 32.974434],
              [48.3664246, 32.9725009],
              [48.3696594, 32.971176],
              [48.371601, 32.9707413],
              [48.3740844, 32.9700272],
              [48.3763504, 32.9693152],
              [48.3782348, 32.9683269],
              [48.3806038, 32.9671977],
              [48.3833542, 32.9663402],
              [48.3861084, 32.9658547],
              [48.389679, 32.9654538],
              [48.3934212, 32.965701],
              [48.3976441, 32.9657621],
              [48.4030076, 32.9659031],
              [48.4039555, 32.9658055],
              [48.406414, 32.9655524],
              [48.4097213, 32.9657135],
              [48.4134559, 32.9655881],
              [48.4172973, 32.9651875],
              [48.4212455, 32.9647867],
              [48.422586, 32.964731],
              [48.4238433, 32.9646713],
              [48.4259033, 32.9647025],
              [48.4275323, 32.9651982],
              [48.4304695, 32.9662393],
              [48.4326477, 32.9670573],
              [48.4347648, 32.967599],
              [48.4365539, 32.9678161],
              [48.4399184, 32.9682052],
              [48.4445801, 32.9686772],
              [48.4496193, 32.9686856],
              [48.4538955, 32.9685565],
              [48.4561157, 32.9684935],
              [48.4593582, 32.9680479],
              [48.4629248, 32.9672323],
              [48.466053, 32.9662814],
              [48.4675103, 32.9658511],
              [48.4697837, 32.9656943],
              [48.4738998, 32.9658002],
              [48.4754716, 32.9658816],
              [48.4790381, 32.9653902],
              [48.4808459, 32.9651948],
              [48.4832037, 32.96494],
              [48.4877931, 32.9638332],
              [48.492817, 32.9626357],
              [48.499612, 32.9612031],
              [48.5022086, 32.9615053],
              [48.5045663, 32.9616899],
              [48.5071413, 32.9622869],
              [48.5098801, 32.963622],
              [48.5143167, 32.9654619],
              [48.5174943, 32.9670716],
              [48.5222625, 32.9697835],
              [48.5229936, 32.9702654],
              [48.5265924, 32.9726376],
              [48.5288393, 32.9740143],
              [48.53207, 32.9762694],
              [48.5340461, 32.9780149],
              [48.5351944, 32.9790272],
              [48.5366744, 32.9800866],
              [48.5378264, 32.9807743],
              [48.5396919, 32.9815595],
              [48.5402817, 32.9798486],
              [48.5427459, 32.9802953],
              [48.5437075, 32.9805279],
              [48.5460216, 32.9790355],
              [48.5490732, 32.9790728],
              [48.5509963, 32.9760485],
              [48.5565902, 32.9756971],
              [48.5596838, 32.9737084],
              [48.5595102, 32.9711164],
              [48.56248, 32.9686038],
              [48.5745374, 32.9639392],
              [48.5912501, 32.9558476],
              [48.6082857, 32.9464485],
              [48.6156796, 32.9396993],
              [48.6208507, 32.9379036],
              [48.6267391, 32.937627],
              [48.6312258, 32.9430486],
              [48.6354814, 32.9505641],
              [48.636806, 32.9541694],
              [48.6409962, 32.9548677],
              [48.6471638, 32.9491458],
              [48.6503898, 32.9476055],
              [48.6559733, 32.939888],
              [48.6632446, 32.9361646],
              [48.6685134, 32.934377],
              [48.6774157, 32.9292254],
              [48.6839021, 32.9213477],
              [48.686695, 32.9189753],
              [48.6890955, 32.9169516],
              [48.6911346, 32.9150081],
              [48.6942528, 32.9119811],
              [48.6953008, 32.9084942],
              [48.6993687, 32.907042],
              [48.7050813, 32.9052725],
              [48.7072031, 32.902423],
              [48.7108999, 32.8962061],
              [48.7137121, 32.8923774],
              [48.716316, 32.8911555],
              [48.7199026, 32.8956084],
              [48.7217883, 32.8973072],
              [48.7252617, 32.8980398],
              [48.7268628, 32.899461],
              [48.7275411, 32.9012338],
              [48.7291155, 32.9021081],
              [48.7315063, 32.9026102],
              [48.7338408, 32.902442],
              [48.7341929, 32.9011541],
              [48.7338685, 32.8994216],
              [48.7351807, 32.8975835],
              [48.7380218, 32.8973087],
              [48.7401009, 32.8978049],
              [48.741708, 32.8989916],
              [48.7457799, 32.9017432],
              [48.7471753, 32.9039224],
              [48.7492017, 32.9074671],
              [48.7512282, 32.9115579],
              [48.752983, 32.9152229],
              [48.755292, 32.9164744],
              [48.7598593, 32.9170436],
              [48.7616349, 32.9168185],
              [48.7642897, 32.9180377],
              [48.7661171, 32.9203137],
              [48.7666627, 32.920727],
              [48.7674254, 32.9213268],
              [48.767975, 32.9220625],
              [48.7686882, 32.922986],
              [48.7689666, 32.9235839],
              [48.7692414, 32.9242291],
              [48.7695772, 32.9252022],
              [48.7695885, 32.9264942],
              [48.769436, 32.9278824],
              [48.7693368, 32.9288523],
              [48.7689628, 32.929921],
              [48.7684822, 32.9308435],
              [48.7681124, 32.9316778],
              [48.7675209, 32.9327426],
              [48.7669335, 32.9335775],
              [48.7663421, 32.9345047],
              [48.7659148, 32.935108],
              [48.7657546, 32.9355267],
              [48.765648, 32.9358968],
              [48.7656518, 32.936359],
              [48.7656059, 32.9373321],
              [48.7657737, 32.9380227],
              [48.7659453, 32.9389456],
              [48.7660066, 32.9399634],
              [48.7659607, 32.9409365],
              [48.7660254, 32.9419522],
              [48.7659798, 32.9431529],
              [48.7658768, 32.9438477],
              [48.7657777, 32.9447297],
              [48.765457, 32.9455603],
              [48.7650338, 32.9466258],
              [48.7641717, 32.9476925],
              [48.76326, 32.9488057],
              [48.7626649, 32.949318],
              [48.7620202, 32.949967],
              [48.7612647, 32.9505261],
              [48.7606735, 32.951176],
              [48.7604064, 32.951825],
              [48.7602995, 32.9522852],
              [48.7603072, 32.9529346],
              [48.7605858, 32.9538572],
              [48.761135, 32.9546899],
              [48.7618483, 32.9554714],
              [48.7628325, 32.9562082],
              [48.7640877, 32.9569859],
              [48.7648506, 32.9575384],
              [48.7654533, 32.9579505],
              [48.7657813, 32.9584117],
              [48.7661094, 32.9588279],
              [48.7663878, 32.9593356],
              [48.7664489, 32.9601212],
              [48.7662888, 32.9606775],
              [48.7658615, 32.9613732],
              [48.7653236, 32.9621571],
              [48.7646789, 32.9629481],
              [48.7640343, 32.9637369],
              [48.7637102, 32.9640625],
              [48.7634466, 32.9647566],
              [48.7629622, 32.9653138],
              [48.7623528, 32.965926],
              [48.762314, 32.965965],
              [48.7621573, 32.9664266],
              [48.7620505, 32.9667516],
              [48.7619974, 32.9671203],
              [48.7622185, 32.9674444],
              [48.7624397, 32.9676738],
              [48.7628212, 32.9679489],
              [48.7634202, 32.9681784],
              [48.7638015, 32.9683159],
              [48.7642898, 32.9683608],
              [48.7648849, 32.9683579],
              [48.7649711, 32.9683453],
              [48.7658617, 32.9682153],
              [48.7665138, 32.9680737],
              [48.7670555, 32.9679346],
              [48.7674903, 32.9679288],
              [48.7682184, 32.9678449],
              [48.768303, 32.9678351],
              [48.7691689, 32.9674606],
              [48.7696534, 32.9671356],
              [48.7702554, 32.9664153],
              [48.7703513, 32.9663004],
              [48.7707292, 32.9657909],
              [48.7709961, 32.9652794],
              [48.7711563, 32.964863],
              [48.7713701, 32.9645376],
              [48.7717478, 32.9641679],
              [48.7721788, 32.9639366],
              [48.7727202, 32.9637952],
              [48.7733194, 32.9637901],
              [48.7739145, 32.9637872],
              [48.7739721, 32.9638066],
              [48.7744598, 32.9639705],
              [48.7751121, 32.9641535],
              [48.7756042, 32.9643359],
              [48.7759859, 32.9644734],
              [48.7762566, 32.9644241],
              [48.7764701, 32.9643332],
              [48.7766305, 32.9639619],
              [48.7769547, 32.9636836],
              [48.7779236, 32.9627991],
              [48.7787363, 32.9621958],
              [48.7792206, 32.9618234],
              [48.7798652, 32.9613119],
              [48.7805139, 32.9607553],
              [48.7815401, 32.9602888],
              [48.7824591, 32.9598701],
              [48.7831651, 32.9595873],
              [48.7841379, 32.9593047],
              [48.7846259, 32.9591172],
              [48.78479, 32.9590254],
              [48.7852212, 32.9588392],
              [48.7855987, 32.9586994],
              [48.7863579, 32.9586024],
              [48.7869568, 32.9585544],
              [48.7874985, 32.9584129],
              [48.7882044, 32.958457],
              [48.789074, 32.9587317],
              [48.7900544, 32.9590939],
              [48.7902184, 32.9593268],
              [48.7905464, 32.9593236],
              [48.790924, 32.9591409],
              [48.7913017, 32.9587666],
              [48.7916221, 32.9582605],
              [48.7921066, 32.9579309],
              [48.7930299, 32.9578367],
              [48.7940635, 32.9578325],
              [48.7948761, 32.9579663],
              [48.795639, 32.9581939],
              [48.7964592, 32.9588848],
              [48.7972794, 32.9594809],
              [48.7976609, 32.9597581],
              [48.7984772, 32.959892],
              [48.7992935, 32.9599334],
              [48.7997781, 32.9598428],
              [48.8004264, 32.9593763],
              [48.800911, 32.9590038],
              [48.8015061, 32.9587708],
              [48.802105, 32.9587205],
              [48.8028107, 32.9587171],
              [48.8036805, 32.9588542],
              [48.8045501, 32.9591287],
              [48.805313, 32.9593541],
              [48.8058014, 32.9594911],
              [48.8060761, 32.959629],
              [48.8063468, 32.9596292],
              [48.8065645, 32.9596285],
              [48.806942, 32.9594886],
              [48.8069953, 32.9591176],
              [48.8072624, 32.9586534],
              [48.8076934, 32.9583273],
              [48.808235, 32.9580505],
              [48.8088301, 32.9578174],
              [48.8096962, 32.9576252],
              [48.8105622, 32.9574398],
              [48.8112106, 32.9571581],
              [48.8119127, 32.9566924],
              [48.8123436, 32.956231],
              [48.8126144, 32.9559021],
              [48.8130416, 32.9554407],
              [48.8136367, 32.9548379],
              [48.8143387, 32.9543723],
              [48.8151473, 32.9538566],
              [48.8158988, 32.9530221],
              [48.8163299, 32.9523736],
              [48.8169646, 32.951629],
              [48.8170816, 32.9514917],
              [48.8177833, 32.9508885],
              [48.818161, 32.9506562],
              [48.8188097, 32.9506066],
              [48.8192442, 32.9506999],
              [48.8193317, 32.9507402],
              [48.8197367, 32.9509272],
              [48.8204459, 32.951431],
              [48.8211022, 32.9517513],
              [48.8215371, 32.9519798],
              [48.8222427, 32.9519809],
              [48.8227843, 32.9518393],
              [48.8235435, 32.9516992],
              [48.8243028, 32.9515524],
              [48.8247336, 32.9513209],
              [48.8256569, 32.9511792],
              [48.8261452, 32.951084],
              [48.8265762, 32.9508052],
              [48.8273314, 32.9504328],
              [48.8279266, 32.9501072],
              [48.8282508, 32.9498739],
              [48.8285219, 32.9496419],
              [48.8288459, 32.949501],
              [48.8292238, 32.9493137],
              [48.8294944, 32.9491267],
              [48.8298188, 32.9489408],
              [48.830303, 32.948753],
              [48.8307382, 32.9485216],
              [48.8308984, 32.9483373],
              [48.8310051, 32.9481047],
              [48.8311118, 32.947827],
              [48.8311616, 32.9474559],
              [48.8310749, 32.9472019],
              [48.8310509, 32.9471316],
              [48.8307723, 32.9465789],
              [48.8301163, 32.9457965],
              [48.8296203, 32.9449199],
              [48.829342, 32.9442748],
              [48.8292312, 32.943858],
              [48.8292276, 32.9434432],
              [48.8293343, 32.943073],
              [48.8295481, 32.9426529],
              [48.8298685, 32.942424],
              [48.8305703, 32.9417261],
              [48.8311616, 32.9411231],
              [48.8316995, 32.9405666],
              [48.8322944, 32.9401012],
              [48.8328896, 32.9398681],
              [48.8333741, 32.9396826],
              [48.8339157, 32.9394958],
              [48.8340509, 32.9394025],
              [48.8341866, 32.9393089],
              [48.8345108, 32.9392131],
              [48.8350524, 32.9391639],
              [48.8357049, 32.9393465],
              [48.8363609, 32.9396216],
              [48.8370706, 32.9400826],
              [48.8377228, 32.9404478],
              [48.8381615, 32.9407237],
              [48.8385965, 32.9408146],
              [48.8389778, 32.9408122],
              [48.8395158, 32.9406231],
              [48.8398932, 32.9403456],
              [48.8402175, 32.9400671],
              [48.8403778, 32.939743],
              [48.8405379, 32.9393265],
              [48.8405875, 32.9388155],
              [48.8406907, 32.9383078],
              [48.8405944, 32.9378669],
              [48.8405801, 32.9378009],
              [48.8405188, 32.9372949],
              [48.8402977, 32.9368785],
              [48.8400232, 32.9364161],
              [48.8394737, 32.9357731],
              [48.8388176, 32.9350358],
              [48.8384858, 32.9344326],
              [48.8383751, 32.9341579],
              [48.8383178, 32.9337421],
              [48.8383675, 32.9331388],
              [48.8386344, 32.932679],
              [48.8388481, 32.9323535],
              [48.8389017, 32.9320749],
              [48.8390618, 32.9316606],
              [48.839382, 32.931382],
              [48.8398132, 32.930871],
              [48.8403548, 32.9305422],
              [48.8407325, 32.9302646],
              [48.8411637, 32.9301233],
              [48.8414878, 32.9299846],
              [48.8420868, 32.9299363],
              [48.8425179, 32.9299776],
              [48.8425808, 32.9300067],
              [48.8431207, 32.9302563],
              [48.843609, 32.9304857],
              [48.8442076, 32.9307147],
              [48.8445358, 32.9308511],
              [48.8450776, 32.9308469],
              [48.8456765, 32.9308437],
              [48.8460008, 32.9306554],
              [48.8461569, 32.9302411],
              [48.8461532, 32.9297337],
              [48.8460425, 32.9292268],
              [48.8460352, 32.9291872],
              [48.8458708, 32.9282995],
              [48.8458633, 32.9275622],
              [48.8459701, 32.9271425],
              [48.8460731, 32.9266821],
              [48.8462332, 32.9262655],
              [48.8465042, 32.9260334],
              [48.8467713, 32.9258915],
              [48.8474769, 32.9255227],
              [48.8482322, 32.9252403],
              [48.8486794, 32.9250271],
              [48.8487204, 32.9250075],
              [48.8491517, 32.9247737],
              [48.849312, 32.9245871],
              [48.8495253, 32.9242639],
              [48.8496324, 32.9239388],
              [48.8496817, 32.9234324],
              [48.8496862, 32.9234168],
              [48.8497886, 32.9230623],
              [48.8497313, 32.9227366],
              [48.849617, 32.9223221],
              [48.8492888, 32.9219963],
              [48.8486861, 32.9211225],
              [48.8483542, 32.9206163],
              [48.848301, 32.9204282],
              [48.848297, 32.9202456],
              [48.8482971, 32.9199683],
              [48.8482322, 32.9188129],
              [48.8482819, 32.9185364],
              [48.8484421, 32.9181176],
              [48.8486024, 32.9178881],
              [48.8488198, 32.9176552],
              [48.8488693, 32.9173765],
              [48.8491363, 32.916867],
              [48.8495139, 32.9164497],
              [48.8500519, 32.9160306],
              [48.8503727, 32.9159263],
              [48.8504867, 32.9158893],
              [48.8509749, 32.9158436],
              [48.8517304, 32.9156063],
              [48.8521614, 32.9151921],
              [48.852539, 32.9148176],
              [48.8527526, 32.9144944],
              [48.8529129, 32.9139854],
              [48.8529727, 32.9135383],
              [48.8530119, 32.9132454],
              [48.8530083, 32.9126885],
              [48.8531648, 32.9119945],
              [48.8534315, 32.9113926],
              [48.8538629, 32.9108387],
              [48.8544006, 32.9103745],
              [48.8552094, 32.9098631],
              [48.8558578, 32.9095338],
              [48.856617, 32.9093484],
              [48.8577005, 32.90911],
              [48.8584299, 32.9090526],
              [48.8589477, 32.9090119],
              [48.8608473, 32.9089136],
              [48.8620949, 32.9089079],
              [48.8629609, 32.90881],
              [48.8635062, 32.908763],
              [48.864048, 32.9087136],
              [48.8645364, 32.9085732],
              [48.8649672, 32.9083867],
              [48.8652915, 32.9081532],
              [48.8656693, 32.9079207],
              [48.8659934, 32.9075971],
              [48.8662604, 32.9073176],
              [48.8668022, 32.9072231],
              [48.8674011, 32.9072694],
              [48.8677827, 32.9074067],
              [48.8685454, 32.9077263],
              [48.8697432, 32.9083216],
              [48.8701782, 32.9084598],
              [48.8711053, 32.908683],
              [48.8716468, 32.9086832],
              [48.8721352, 32.9085878],
              [48.8725129, 32.9084004],
              [48.872673, 32.9080762],
              [48.8727225, 32.9077524],
              [48.8727226, 32.9074278],
              [48.8727189, 32.9071053],
              [48.8725509, 32.9066425],
              [48.8723833, 32.9062767],
              [48.872326, 32.905906],
              [48.8722152, 32.9053991],
              [48.8723184, 32.9048417],
              [48.8726386, 32.9043309],
              [48.8729592, 32.9037773],
              [48.8733369, 32.90345],
              [48.8739852, 32.9032176],
              [48.874958, 32.9027967],
              [48.8756104, 32.9026568],
              [48.8768042, 32.90265],
              [48.8777277, 32.9026454],
              [48.8786467, 32.9025032],
              [48.8793527, 32.9023168],
              [48.8803787, 32.9018517],
              [48.8814584, 32.9012455],
              [48.8820533, 32.9010121],
              [48.8825951, 32.9007305],
              [48.8830262, 32.900359],
              [48.8833466, 32.9000353],
              [48.8835105, 32.8998036],
              [48.8836708, 32.8995245],
              [48.8837205, 32.8989212],
              [48.8836594, 32.8984602],
              [48.8835489, 32.8980908],
              [48.883385, 32.897953],
              [48.8833848, 32.8979528],
              [48.8830568, 32.8975865],
              [48.882618, 32.8972161],
              [48.8820725, 32.8968958],
              [48.8819084, 32.8966179],
              [48.8817406, 32.8962025],
              [48.8816835, 32.8956943],
              [48.8816795, 32.895232],
              [48.8817292, 32.8947707],
              [48.8818321, 32.8944478],
              [48.881939, 32.8941678],
              [48.8821565, 32.8939821],
              [48.8825342, 32.8938893],
              [48.8832399, 32.8937953],
              [48.8837813, 32.8937008],
              [48.8845938, 32.8935094],
              [48.8854065, 32.8934126],
              [48.8857842, 32.893277],
              [48.8863258, 32.8930855],
              [48.8866396, 32.8929874],
              [48.8869208, 32.8928994],
              [48.8872986, 32.8925744],
              [48.887947, 32.8921097],
              [48.8884851, 32.8915055],
              [48.8889693, 32.8910876],
              [48.8893, 32.8907304],
              [48.8893968, 32.8906259],
              [48.8900986, 32.8901598],
              [48.8912314, 32.889462],
              [48.8923151, 32.8888084],
              [48.893284, 32.8882476],
              [48.8943137, 32.8877825],
              [48.8957178, 32.8870396],
              [48.8960954, 32.886807],
              [48.8964157, 32.8864787],
              [48.8970107, 32.8861077],
              [48.8980369, 32.8856898],
              [48.8989602, 32.8853604],
              [48.8994981, 32.8851282],
              [48.8998756, 32.8849407],
              [48.9001466, 32.8848911],
              [48.9004747, 32.8848448],
              [48.9006385, 32.8849828],
              [48.9009095, 32.8850753],
              [48.9015617, 32.8851651],
              [48.9021073, 32.8854403],
              [48.9021136, 32.8854446],
              [48.9027061, 32.8858539],
              [48.9034158, 32.88631],
              [48.9037978, 32.8860204],
              [48.9050066, 32.886696],
              [48.9062979, 32.8870113],
              [48.9074345, 32.8872711],
              [48.9084323, 32.8873212],
              [48.9092138, 32.8871442],
              [48.9098605, 32.8868235],
              [48.9104226, 32.88618],
              [48.9111427, 32.8859125],
              [48.9118416, 32.8856589],
              [48.912365, 32.8854903],
              [48.91285, 32.885314],
              [48.9133704, 32.8851298],
              [48.913933, 32.8851643],
              [48.9142887, 32.8853111],
              [48.9158238, 32.8864134],
              [48.9166728, 32.8872015],
              [48.9173241, 32.8878253],
              [48.9184442, 32.8888278],
              [48.9190962, 32.8890716],
              [48.9196081, 32.889379],
              [48.92066, 32.889651],
              [48.9217318, 32.8900871],
              [48.9224554, 32.8909413],
              [48.9229989, 32.8920576],
              [48.9236119, 32.8928987],
              [48.924318, 32.8938144],
              [48.9248394, 32.8945836],
              [48.9253914, 32.8953696],
              [48.9256943, 32.8962231],
              [48.9258221, 32.8969771],
              [48.9259578, 32.8973634],
              [48.9266875, 32.8974549],
              [48.9273769, 32.8973934],
              [48.9279404, 32.8973039],
              [48.9286326, 32.897098],
              [48.9296511, 32.896754],
              [48.930464, 32.8964691],
              [48.9317133, 32.8961375],
              [48.9322987, 32.895801],
              [48.9327228, 32.8954973],
              [48.933495, 32.8951319],
              [48.9340791, 32.8949579],
              [48.9346994, 32.8951421],
              [48.9350484, 32.8957949],
              [48.9352907, 32.896405],
              [48.9356049, 32.8970048],
              [48.9359048, 32.897532],
              [48.9365662, 32.8977851],
              [48.9372455, 32.8976971],
              [48.9379344, 32.8976102],
              [48.9389514, 32.8976503],
              [48.9399465, 32.8976454],
              [48.9409318, 32.8976906],
              [48.9421483, 32.8980449],
              [48.9428747, 32.8980117],
              [48.9433844, 32.8979521],
              [48.9439869, 32.8978808],
              [48.9445691, 32.8975598],
              [48.9448573, 32.8970623],
              [48.9452623, 32.8961189],
              [48.945519, 32.8957407],
              [48.9458426, 32.895264],
              [48.9462585, 32.8949625],
              [48.9470357, 32.8948738],
              [48.9477526, 32.8949317],
              [48.9481622, 32.8949095],
              [48.9488323, 32.8948033],
              [48.9495884, 32.8947777],
              [48.9501643, 32.8944258],
              [48.9506413, 32.8938859],
              [48.9509538, 32.893425],
              [48.9514281, 32.8930684],
              [48.9521096, 32.8927271],
              [48.9526053, 32.8925958],
              [48.9530369, 32.8924726],
              [48.953536, 32.8923488],
              [48.9540458, 32.8924041],
              [48.9547279, 32.8922238],
              [48.9554858, 32.8927051],
              [48.9560164, 32.8932571],
              [48.9565657, 32.8936719],
              [48.9569465, 32.8940734],
              [48.9570044, 32.8941345],
              [48.9576035, 32.894638],
              [48.9580423, 32.8950081],
              [48.9584236, 32.8951902],
              [48.9588586, 32.8953732],
              [48.9596216, 32.8956945],
              [48.9601136, 32.8960159],
              [48.9603348, 32.896245],
              [48.9607696, 32.8964279],
              [48.9612578, 32.8965644],
              [48.9617461, 32.8966107],
              [48.9623986, 32.896698],
              [48.9628333, 32.8968358],
              [48.963272, 32.897109],
              [48.9637643, 32.89748],
              [48.9642526, 32.8975714],
              [48.9647981, 32.8977043],
              [48.9655038, 32.8977969],
              [48.9663163, 32.8977921],
              [48.9667511, 32.8977428],
              [48.9672927, 32.8976479],
              [48.9678346, 32.8976477],
              [48.9681624, 32.8977861],
              [48.9685441, 32.8980132],
              [48.9688185, 32.8984303],
              [48.9688759, 32.8987536],
              [48.9688836, 32.8994436],
              [48.9688874, 32.8998157],
              [48.9691084, 32.9002769],
              [48.9694901, 32.900459],
              [48.9701425, 32.9005057],
              [48.971119, 32.9005463],
              [48.9719352, 32.9005438],
              [48.9728011, 32.90063],
              [48.9734, 32.9007682],
              [48.9742698, 32.9009469],
              [48.9742936, 32.9009437],
              [48.9749755, 32.9008524],
              [48.9757882, 32.9006198],
              [48.9763833, 32.9006159],
              [48.976986, 32.9009368],
              [48.9774208, 32.9011648],
              [48.9778594, 32.9014424],
              [48.9781305, 32.9017173],
              [48.978405, 32.9020893],
              [48.9785194, 32.9026412],
              [48.9785805, 32.9032442],
              [48.978548, 32.903547],
              [48.9785309, 32.9037056],
              [48.9784812, 32.9043045],
              [48.9782714, 32.9049526],
              [48.9781646, 32.9054176],
              [48.9781684, 32.9056927],
              [48.978279, 32.9059267],
              [48.9785003, 32.9061558],
              [48.9788246, 32.9063369],
              [48.9791528, 32.9065203],
              [48.9794809, 32.9065662],
              [48.9799155, 32.9066115],
              [48.9806746, 32.906608],
              [48.9812736, 32.9066966],
              [48.9822501, 32.9068341],
              [48.9826849, 32.9069719],
              [48.9830667, 32.9071088],
              [48.9835051, 32.9074293],
              [48.9838869, 32.9078908],
              [48.9840547, 32.9081641],
              [48.9841118, 32.9085799],
              [48.9841157, 32.908997],
              [48.9841195, 32.9095089],
              [48.9840697, 32.9098778],
              [48.9839631, 32.910203],
              [48.9837495, 32.9106189],
              [48.9836463, 32.9108968],
              [48.9835398, 32.9112197],
              [48.9835435, 32.9115399],
              [48.9836006, 32.9118204],
              [48.9837113, 32.9120522],
              [48.983986, 32.9123722],
              [48.9843674, 32.9126016],
              [48.9845846, 32.9128351],
              [48.9850731, 32.9129218],
              [48.9855652, 32.9129681],
              [48.9861604, 32.9129642],
              [48.986431, 32.9129189],
              [48.9869194, 32.9128231],
              [48.9875146, 32.9126365],
              [48.9881096, 32.9124026],
              [48.9884339, 32.9121711],
              [48.9890251, 32.9117974],
              [48.9894026, 32.9114269],
              [48.9896203, 32.9112861],
              [48.9898337, 32.9110979],
              [48.9901581, 32.9110535],
              [48.9905397, 32.911098],
              [48.9910851, 32.9113277],
              [48.9920122, 32.9119671],
              [48.9928323, 32.9125665],
              [48.9934882, 32.9129332],
              [48.9935767, 32.9119628],
              [48.9938003, 32.9122802],
              [48.9942167, 32.9126556],
              [48.9948882, 32.9127856],
              [48.9956257, 32.9126932],
              [48.9971083, 32.9121711],
              [48.9988196, 32.9120676],
              [49.0005791, 32.9123828],
              [49.0021237, 32.9129934],
              [49.0034524, 32.9138847],
              [49.0045269, 32.9144738],
              [49.0063003, 32.9151821],
              [49.0080594, 32.9148737],
              [49.0085389, 32.9146367],
              [49.009278, 32.9140496],
              [49.0093005, 32.9131483],
              [49.0089463, 32.9123462],
              [49.0082096, 32.911829],
              [49.0078093, 32.9114754],
              [49.0067972, 32.9109612],
              [49.0060777, 32.9102298],
              [49.0052678, 32.9094995],
              [49.0046932, 32.9086448],
              [49.0045852, 32.9082745],
              [49.0043156, 32.907493],
              [49.0046672, 32.90663],
              [49.0055757, 32.9060345],
              [49.0064843, 32.9056441],
              [49.0073588, 32.9051483],
              [49.0084071, 32.9046388],
              [49.0092057, 32.9042565],
              [49.0099401, 32.9036536],
              [49.0103606, 32.903213],
              [49.0111636, 32.9026628],
              [49.0116669, 32.9023],
              [49.0119983, 32.9018629],
              [49.0120107, 32.9010313],
              [49.012134, 32.9004414],
              [49.0121241, 32.8998486],
              [49.0123785, 32.8992193],
              [49.0129846, 32.8987095],
              [49.0135984, 32.8981726],
              [49.0143367, 32.8977427],
              [49.0149645, 32.8976369],
              [49.015971, 32.8983364],
              [49.0164975, 32.8988382],
              [49.0171318, 32.8993413],
              [49.0176813, 32.8996161],
              [49.0182837, 32.9001645],
              [49.0190505, 32.9007155],
              [49.0200348, 32.9013556],
              [49.0209083, 32.9018091],
              [49.0223314, 32.9023096],
              [49.0234755, 32.9027628],
              [49.0247306, 32.9031253],
              [49.0258217, 32.9033049],
              [49.026638, 32.9033471],
              [49.0275118, 32.9033384],
              [49.0281065, 32.9031989],
              [49.0293005, 32.9027759],
              [49.0304946, 32.9023055],
              [49.0317422, 32.9014661],
              [49.0332605, 32.9006265],
              [49.0342904, 32.8999754],
              [49.0355339, 32.8992757],
              [49.0362931, 32.8989021],
              [49.0371094, 32.898712],
              [49.0379792, 32.8984303],
              [49.038685, 32.8981934],
              [49.0398828, 32.8981851],
              [49.041191, 32.8984108],
              [49.0429917, 32.8987704],
              [49.0443535, 32.8991277],
              [49.045233, 32.8994584],
              [49.0454482, 32.8995393],
              [49.0463753, 32.8999033],
              [49.0476341, 32.900676],
              [49.0488357, 32.9014095],
              [49.049713, 32.9020499],
              [49.0499902, 32.902344],
              [49.050537, 32.9029241],
              [49.0516358, 32.9040685],
              [49.0521279, 32.9043422],
              [49.0527841, 32.9047537],
              [49.0531656, 32.9049378],
              [49.0538215, 32.9050247],
              [49.0544206, 32.9051129],
              [49.0549659, 32.9051552],
              [49.0553438, 32.9051092],
              [49.0559426, 32.9047353],
              [49.0564803, 32.9042251],
              [49.0570755, 32.9038037],
              [49.0577277, 32.9033855],
              [49.0588684, 32.9030109],
              [49.0602798, 32.9027262],
              [49.0616952, 32.9025317],
              [49.0634347, 32.9023354],
              [49.0646896, 32.9023752],
              [49.0658303, 32.9021381],
              [49.0667535, 32.9019021],
              [49.0672417, 32.9016188],
              [49.0677262, 32.9010626],
              [49.0680503, 32.9005085],
              [49.0683135, 32.8994912],
              [49.0684522, 32.8987119],
              [49.0684699, 32.8986121],
              [49.0687903, 32.8979181],
              [49.0691799, 32.897382],
              [49.0693282, 32.8971779],
              [49.0701982, 32.8966187],
              [49.0709572, 32.8963846],
              [49.0717201, 32.896331],
              [49.0728607, 32.8963238],
              [49.0739518, 32.8965503],
              [49.0749893, 32.8967737],
              [49.0764657, 32.897412],
              [49.0782128, 32.89814],
              [49.078594, 32.8983691],
              [49.0790291, 32.8983645],
              [49.08012, 32.8983565],
              [49.0804978, 32.897988],
              [49.0809822, 32.8975671],
              [49.0822296, 32.8967317],
              [49.0832595, 32.8960305],
              [49.0840719, 32.8955199],
              [49.0847207, 32.8950992],
              [49.0851516, 32.8945422],
              [49.0859071, 32.8934783],
              [49.0865554, 32.8926427],
              [49.0868225, 32.892135],
              [49.0870362, 32.8915792],
              [49.0871927, 32.890842],
              [49.0874632, 32.8903321],
              [49.0880547, 32.8894506],
              [49.0887567, 32.8886181],
              [49.0894584, 32.8879209],
              [49.0901604, 32.8873184],
              [49.0908662, 32.8868512],
              [49.0915146, 32.8864778],
              [49.0925447, 32.8858712],
              [49.0935784, 32.8855443],
              [49.0950469, 32.8852127],
              [49.09684, 32.8849717],
              [49.0984191, 32.8848695],
              [49.0999451, 32.8849062],
              [49.1009788, 32.8850369],
              [49.1023445, 32.8852605],
              [49.1038704, 32.8857572],
              [49.1058921, 32.8866243],
              [49.1074218, 32.8873982],
              [49.1086806, 32.8880351],
              [49.1098825, 32.8884433],
              [49.1108094, 32.8887594],
              [49.1116255, 32.8888484],
              [49.1125527, 32.8889346],
              [49.1134225, 32.8888846],
              [49.1141321, 32.8887397],
              [49.114891, 32.888458],
              [49.1157569, 32.887948],
              [49.1172217, 32.887199],
              [49.11874, 32.8864508],
              [49.1202623, 32.885892],
              [49.1211815, 32.8851933],
              [49.1225356, 32.8842622],
              [49.1236724, 32.8832399],
              [49.1245383, 32.8823127],
              [49.1250229, 32.8815737],
              [49.1255608, 32.8806912],
              [49.1257486, 32.8801527],
              [49.1259309, 32.8796303],
              [49.1261979, 32.8787031],
              [49.1264077, 32.8775068],
              [49.1265641, 32.8769026],
              [49.1270484, 32.8760261],
              [49.1278037, 32.8750994],
              [49.1283988, 32.8743553],
              [49.1293718, 32.8734748],
              [49.1304017, 32.8727304],
              [49.1317023, 32.8718953],
              [49.1332781, 32.8711928],
              [49.1350668, 32.8705364],
              [49.1370774, 32.8698313],
              [49.1393089, 32.8694948],
              [49.1414299, 32.8692061],
              [49.1425723, 32.8690717],
              [49.1430627, 32.869014],
              [49.1453476, 32.8690005],
              [49.1472015, 32.8688972],
              [49.1491622, 32.8689759],
              [49.1508521, 32.8691519],
              [49.1522674, 32.869236],
              [49.1531399, 32.8693448],
              [49.1536827, 32.8694125],
              [49.1542854, 32.8695003],
              [49.1549949, 32.8699572],
              [49.156086, 32.8704557],
              [49.15707, 32.8708693],
              [49.1585997, 32.8713653],
              [49.1596908, 32.8716362],
              [49.1608888, 32.8718612],
              [49.1614379, 32.8720857],
              [49.1618195, 32.8725468],
              [49.1624793, 32.8732802],
              [49.1629754, 32.8738737],
              [49.1631431, 32.8746157],
              [49.1630468, 32.8748122],
              [49.1628722, 32.8751687],
              [49.1624449, 32.8760462],
              [49.1622314, 32.8768299],
              [49.1620751, 32.8775243],
              [49.1619681, 32.8778046],
              [49.1620787, 32.8784488],
              [49.1624108, 32.8787693],
              [49.1630095, 32.8791321],
              [49.1636124, 32.8794521],
              [49.164486, 32.8797693],
              [49.1652489, 32.8800894],
              [49.1662332, 32.8802233],
              [49.1669961, 32.8804465],
              [49.167431, 32.8806264],
              [49.1679268, 32.8810892],
              [49.1684228, 32.8818675],
              [49.1689187, 32.8828308],
              [49.1695213, 32.8834303],
              [49.1699028, 32.8836546],
              [49.1706694, 32.883977],
              [49.171215, 32.8839714],
              [49.1719742, 32.8839216],
              [49.1725733, 32.8836395],
              [49.1732751, 32.883129],
              [49.174141, 32.8822939],
              [49.1751709, 32.8812763],
              [49.176033, 32.8803486],
              [49.1768457, 32.8797427],
              [49.1780394, 32.8788605],
              [49.1791765, 32.8780203],
              [49.1804771, 32.8772321],
              [49.181343, 32.8764871],
              [49.1825369, 32.8757897],
              [49.1838914, 32.8749504],
              [49.1853028, 32.8741614],
              [49.1870919, 32.8729518],
              [49.1888238, 32.8717887],
              [49.190235, 32.8709952],
              [49.1918107, 32.8701544],
              [49.1932717, 32.869321],
              [49.1947367, 32.8683885],
              [49.1959839, 32.867322],
              [49.1966896, 32.867039],
              [49.1976129, 32.8666645],
              [49.1983146, 32.8661989],
              [49.1989631, 32.8654597],
              [49.1996118, 32.8646235],
              [49.2000427, 32.864021],
              [49.2002749, 32.8637652],
              [49.2017232, 32.8632389],
              [49.2024522, 32.8630096],
              [49.2027054, 32.8630401],
              [49.2027628, 32.8634062],
              [49.2028199, 32.8638693],
              [49.2030945, 32.8643264],
              [49.2033692, 32.8646505],
              [49.2037544, 32.8649221],
              [49.2042998, 32.8649683],
              [49.205059, 32.8645485],
              [49.2062493, 32.8636637],
              [49.2072791, 32.8628736],
              [49.2085228, 32.8618542],
              [49.2100412, 32.86069],
              [49.2113382, 32.8593941],
              [49.2123145, 32.8584678],
              [49.2130698, 32.8575858],
              [49.2137224, 32.8571667],
              [49.2140999, 32.8567054],
              [49.2144737, 32.8559644],
              [49.2149581, 32.8546726],
              [49.215168, 32.8539766],
              [49.2154923, 32.853607],
              [49.2161445, 32.8530053],
              [49.217121, 32.8524938],
              [49.2179907, 32.8521658],
              [49.2188074, 32.8520196],
              [49.2193488, 32.8519258],
              [49.2198409, 32.8520163],
              [49.2204399, 32.8523337],
              [49.2210999, 32.8527917],
              [49.2215348, 32.8530662],
              [49.2222444, 32.8531981],
              [49.2230605, 32.8531961],
              [49.2237665, 32.8530078],
              [49.2248572, 32.8528632],
              [49.2257844, 32.8530883],
              [49.2264403, 32.853314],
              [49.2274744, 32.8534008],
              [49.2288359, 32.8535757],
              [49.2298737, 32.8538474],
              [49.2307472, 32.8539815],
              [49.231781, 32.8542983],
              [49.2324408, 32.8547563],
              [49.2336958, 32.8556218],
              [49.2348479, 32.856815],
              [49.2357789, 32.8574572],
              [49.2364351, 32.8579602],
              [49.2368736, 32.8580927],
              [49.2372016, 32.8581401],
              [49.2377435, 32.8580891],
              [49.2395323, 32.8569261],
              [49.2405662, 32.8564153],
              [49.2407578, 32.8563194],
              [49.2415962, 32.8558999],
              [49.2424089, 32.8553432],
              [49.2434425, 32.8548278],
              [49.2443123, 32.8546416],
              [49.2455634, 32.8543097],
              [49.2461625, 32.8543046],
              [49.2467041, 32.8543054],
              [49.2473603, 32.8544386],
              [49.2477418, 32.8546672],
              [49.2478414, 32.8549973],
              [49.2478525, 32.855034],
              [49.2478027, 32.8556781],
              [49.2478599, 32.8561862],
              [49.2478103, 32.8566027],
              [49.2480851, 32.8569222],
              [49.2485771, 32.8572425],
              [49.2492332, 32.8575132],
              [49.2500496, 32.8577884],
              [49.2513275, 32.8578762],
              [49.2520867, 32.8575937],
              [49.2527848, 32.8569902],
              [49.2533262, 32.8568963],
              [49.2538108, 32.8568963],
              [49.2543293, 32.8570265],
              [49.2543527, 32.8570323],
              [49.2543595, 32.8570382],
              [49.2548371, 32.8574495],
              [49.2551612, 32.8578643],
              [49.2552185, 32.8587445],
              [49.2553291, 32.8594405],
              [49.2555465, 32.860271],
              [49.2558708, 32.8609204],
              [49.2565727, 32.8615186],
              [49.2570075, 32.8618426],
              [49.2576523, 32.8618426],
              [49.2584115, 32.8617021],
              [49.2587318, 32.8613728],
              [49.2594873, 32.8607701],
              [49.2603492, 32.8599816],
              [49.2612115, 32.8593285],
              [49.2618573, 32.8591114],
              [49.2624548, 32.8589106],
              [49.2641257, 32.8586272],
              [49.2652587, 32.8581626],
              [49.2656899, 32.8578845],
              [49.2661742, 32.8572779],
              [49.2667694, 32.8567203],
              [49.2673074, 32.8561167],
              [49.2674674, 32.8555146],
              [49.2678415, 32.8546337],
              [49.268055, 32.8540775],
              [49.2684328, 32.8533319],
              [49.268753, 32.8527298],
              [49.2692413, 32.8524502],
              [49.2697257, 32.8522653],
              [49.2710188, 32.8520284],
              [49.2724227, 32.8519328],
              [49.2734452, 32.8517913],
              [49.2746886, 32.8516055],
              [49.2755508, 32.8515543],
              [49.276306, 32.8515061],
              [49.2770082, 32.8515045],
              [49.2774926, 32.8517344],
              [49.2777673, 32.8521034],
              [49.2780393, 32.8523094],
              [49.2781981, 32.8524295],
              [49.2783623, 32.8526573],
              [49.278633, 32.8527489],
              [49.2789001, 32.8527481],
              [49.2793311, 32.8525624],
              [49.2796556, 32.8521001],
              [49.2797277, 32.8519744],
              [49.2800291, 32.8514491],
              [49.2805671, 32.850753],
              [49.2818071, 32.8501004],
              [49.283043, 32.8495402],
              [49.2837981, 32.8492168],
              [49.2846605, 32.8491204],
              [49.2859039, 32.8491172],
              [49.2865487, 32.8492545],
              [49.2871645, 32.8496655],
              [49.2873076, 32.849761],
              [49.2882804, 32.8505026],
              [49.2891466, 32.850918],
              [49.2897415, 32.8511471],
              [49.2903366, 32.8514213],
              [49.291256, 32.8514677],
              [49.2924423, 32.8514185],
              [49.2934113, 32.851089],
              [49.2941664, 32.8506235],
              [49.2955095, 32.8496926],
              [49.2963716, 32.8491362],
              [49.2965911, 32.8490722],
              [49.2973403, 32.848854],
              [49.298416, 32.8486679],
              [49.2990112, 32.8486219],
              [49.2996596, 32.8487096],
              [49.2996655, 32.8487117],
              [49.3001976, 32.8488951],
              [49.3006325, 32.8490791],
              [49.3011169, 32.8492616],
              [49.3016586, 32.8493072],
              [49.3018104, 32.8492679],
              [49.3021965, 32.849168],
              [49.3025207, 32.8488883],
              [49.3028411, 32.8484733],
              [49.3034859, 32.8479612],
              [49.3042374, 32.8476331],
              [49.3051529, 32.8472126],
              [49.3063354, 32.8466063],
              [49.3073579, 32.8459122],
              [49.3083834, 32.8454356],
              [49.3087579, 32.8452615],
              [49.3098296, 32.8444214],
              [49.3105813, 32.8437281],
              [49.310791, 32.843555],
              [49.3120373, 32.8425988],
              [49.3123916, 32.8423652],
              [49.3125113, 32.8422863],
              [49.3134268, 32.8417733],
              [49.3145026, 32.8412579],
              [49.3154145, 32.8409342],
              [49.3162667, 32.8407837],
              [49.3177486, 32.8401788],
              [49.3179437, 32.8399536],
              [49.3181039, 32.8395837],
              [49.3184241, 32.8393513],
              [49.3187445, 32.8391639],
              [49.3190156, 32.8391653],
              [49.3195037, 32.8392553],
              [49.3199377, 32.8393477],
              [49.3239518, 32.8393477],
              [49.3256434, 32.8397739],
              [49.3258667, 32.8397036],
              [49.3262443, 32.8397019],
              [49.3266754, 32.8396987],
              [49.3269996, 32.8398405],
              [49.3276483, 32.8400679],
              [49.3280678, 32.8403825],
              [49.3280829, 32.8403939],
              [49.3287315, 32.8406686],
              [49.3293801, 32.8408509],
              [49.3300284, 32.840943],
              [49.3302419, 32.8409244],
              [49.3305665, 32.8408961],
              [49.3312682, 32.8408468],
              [49.3316992, 32.840706],
              [49.333313, 32.8402856],
              [49.335144, 32.8399582],
              [49.3363801, 32.8396297],
              [49.3371352, 32.8395811],
              [49.3376197, 32.8395807],
              [49.3382148, 32.8397645],
              [49.3385391, 32.839992],
              [49.3390845, 32.8405044],
              [49.3397369, 32.8411489],
              [49.3400916, 32.8415562],
              [49.3404998, 32.8420248],
              [49.3413162, 32.8430435],
              [49.3418044, 32.8434153],
              [49.3421288, 32.8436428],
              [49.3428879, 32.8439685],
              [49.3434297, 32.8441042],
              [49.3440247, 32.8442428],
              [49.3445626, 32.8444258],
              [49.3450508, 32.8446533],
              [49.3455391, 32.845025],
              [49.3464049, 32.8452529],
              [49.3471109, 32.8454809],
              [49.3471689, 32.8454926],
              [49.3480263, 32.8456644],
              [49.3490523, 32.8457568],
              [49.349594, 32.8457527],
              [49.3500785, 32.8456622],
              [49.3502923, 32.8453831],
              [49.350506, 32.8451492],
              [49.3507158, 32.8448724],
              [49.3510399, 32.8446399],
              [49.3514137, 32.8444509],
              [49.3519517, 32.8442641],
              [49.3526496, 32.8439869],
              [49.3535117, 32.8438449],
              [49.354805, 32.8437966],
              [49.3569105, 32.8437927],
              [49.3583108, 32.8438336],
              [49.3598214, 32.8437339],
              [49.3610078, 32.843639],
              [49.3615456, 32.8436393],
              [49.3625184, 32.843776],
              [49.3633841, 32.8439587],
              [49.3640862, 32.8441437],
              [49.3647346, 32.8443258],
              [49.3653722, 32.8445071],
              [49.365383, 32.8445102],
              [49.3660316, 32.8446472],
              [49.3664666, 32.8446461],
              [49.3671645, 32.8445515],
              [49.3675957, 32.8443632],
              [49.3682145, 32.8440701],
              [49.3692588, 32.8435754],
              [49.3697394, 32.8432006],
              [49.3711282, 32.8421319],
              [49.3727408, 32.8409445],
              [49.3728944, 32.8408314],
              [49.374981, 32.8393906],
              [49.3751946, 32.8391566],
              [49.3754615, 32.8389279],
              [49.375511, 32.8386489],
              [49.375468, 32.8383206],
              [49.3754501, 32.8381836],
              [49.3753928, 32.8378605],
              [49.3754427, 32.8374891],
              [49.3756561, 32.8371198],
              [49.3760261, 32.8364707],
              [49.3765563, 32.8357741],
              [49.3773003, 32.8349382],
              [49.3781547, 32.8342886],
              [49.3795966, 32.8331303],
              [49.3805047, 32.8324318],
              [49.3815726, 32.8317331],
              [49.3825913, 32.8311758],
              [49.3830185, 32.8308477],
              [49.3836593, 32.8303418],
              [49.3850976, 32.8290414],
              [49.3855783, 32.8287116],
              [49.3862228, 32.8284787],
              [49.3866182, 32.8284349],
              [49.3870811, 32.8283837],
              [49.3877793, 32.8281515],
              [49.3888511, 32.8277324],
              [49.3892118, 32.8274854],
              [49.3898658, 32.8270374],
              [49.3908807, 32.8262929],
              [49.3916206, 32.8254117],
              [49.3937529, 32.8236015],
              [49.3958818, 32.8216062],
              [49.3967323, 32.8207693],
              [49.3976364, 32.8199804],
              [49.3981132, 32.8195604],
              [49.3985976, 32.8193749],
              [49.3992386, 32.8192366],
              [49.3996696, 32.8191406],
              [49.4000474, 32.8191409],
              [49.400692, 32.8192326],
              [49.4011231, 32.819184],
              [49.4016038, 32.8189038],
              [49.4018671, 32.8184426],
              [49.4023934, 32.8176985],
              [49.4029236, 32.8169093],
              [49.4036635, 32.8160755],
              [49.4043006, 32.815335],
              [49.4054145, 32.8143571],
              [49.4063684, 32.813199],
              [49.4068412, 32.8124587],
              [49.4071579, 32.8119013],
              [49.4072569, 32.8114403],
              [49.4073562, 32.8109275],
              [49.4076196, 32.8104167],
              [49.4080964, 32.8097689],
              [49.4088898, 32.8089785],
              [49.4098433, 32.8080053],
              [49.4103165, 32.8071703],
              [49.4112167, 32.8062437],
              [49.4123306, 32.8053131],
              [49.4132347, 32.8044316],
              [49.4139213, 32.803597],
              [49.4143905, 32.8028115],
              [49.4146539, 32.8022985],
              [49.41502, 32.8016042],
              [49.4152259, 32.80091],
              [49.415432, 32.8003535],
              [49.4157411, 32.7995186],
              [49.4164735, 32.7982674],
              [49.4170456, 32.7970165],
              [49.4174689, 32.7965551],
              [49.417942, 32.7959026],
              [49.4181519, 32.7954859],
              [49.4182548, 32.7952527],
              [49.4183044, 32.7947911],
              [49.418293, 32.7941889],
              [49.4181824, 32.7939147],
              [49.4180678, 32.7935457],
              [49.4181671, 32.7929878],
              [49.4182129, 32.7924765],
              [49.4185258, 32.7916913],
              [49.4189986, 32.7910884],
              [49.4201087, 32.7900201],
              [49.4230656, 32.7901943],
              [49.4263378, 32.7886019],
              [49.4271499, 32.7871361],
              [49.4290062, 32.7839756],
              [49.430839, 32.7807178],
              [49.4354877, 32.7737911],
              [49.4354586, 32.7693499],
              [49.4366243, 32.76428],
              [49.4420354, 32.7572068],
              [49.4456033, 32.751201],
              [49.4525131, 32.7457109],
              [49.4649419, 32.7404657],
              [49.4699917, 32.7349729],
              [49.4731551, 32.7278668],
              [49.4767932, 32.7274907],
              [49.4799022, 32.7294881],
              [49.4863205, 32.7224433],
              [49.4878946, 32.7207446],
              [49.5004575, 32.7160295],
              [49.5008323, 32.7160473],
              [49.5037787, 32.7161871],
              [49.5124159, 32.7199787],
              [49.512915, 32.7204423],
              [49.520093, 32.7156323],
              [49.5194671, 32.7137457],
              [49.5157088, 32.7109292],
              [49.5117177, 32.7062982],
              [49.510678, 32.7044025],
              [49.5104825, 32.7024073],
              [49.5122602, 32.7033102],
              [49.5151662, 32.7044723],
              [49.5174089, 32.7059375],
              [49.5226861, 32.7086458],
              [49.5262813, 32.7092751],
              [49.5295337, 32.7093867],
              [49.5325127, 32.7101449],
              [49.5382877, 32.7128012],
              [49.5411515, 32.7143664],
              [49.5430611, 32.7148688],
              [49.5448794, 32.7139754],
              [49.5476429, 32.7129462],
              [49.5566968, 32.7127023],
              [49.5621585, 32.713211],
              [49.563686, 32.7140384],
              [49.5701837, 32.7153413],
              [49.5745853, 32.7166108],
              [49.5767623, 32.7197521],
              [49.5775574, 32.7254294],
              [49.5777898, 32.7300056],
              [49.5767125, 32.7306281],
              [49.5770546, 32.7318828],
              [49.5775028, 32.7369457],
              [49.578136, 32.7386062],
              [49.5772268, 32.7441927],
              [49.5775021, 32.7499591],
              [49.591018, 32.7499952],
              [49.5912517, 32.7520796],
              [49.5916118, 32.7533789],
              [49.5926978, 32.754444],
              [49.5946472, 32.7557072],
              [49.5948703, 32.7571073],
              [49.5943689, 32.7585182],
              [49.5944357, 32.7592446],
              [49.5948923, 32.7602297],
              [49.595527, 32.7610452],
              [49.5958249, 32.7633387],
              [49.5956929, 32.7665284],
              [49.5951327, 32.7685225],
              [49.5945307, 32.7716487],
              [49.5943946, 32.7740623],
              [49.5946893, 32.7756977],
              [49.5953096, 32.7768058],
              [49.5975292, 32.7792963],
              [49.5994357, 32.7824354],
              [49.5999494, 32.7853852],
              [49.6004846, 32.7860347],
              [49.600355, 32.7899037],
              [49.602298, 32.7899037],
              [49.6025746, 32.7896238],
              [49.6042415, 32.7896238],
              [49.6181311, 32.7849015],
              [49.6184675, 32.7847885],
              [49.6189644, 32.7846216],
              [49.6272977, 32.7818496],
              [49.6275779, 32.7815697],
              [49.6286876, 32.7815697],
              [49.6314643, 32.780739],
              [49.6325779, 32.780739],
              [49.6331311, 32.7804591],
              [49.6336877, 32.7804591],
              [49.6345209, 32.7801792],
              [49.6356311, 32.7801792],
              [49.6364679, 32.7798993],
              [49.6386878, 32.7798993],
              [49.6406344, 32.7796285],
              [49.6411875, 32.7793485],
              [49.6439676, 32.7793485],
              [49.6442442, 32.7790686],
              [49.6550777, 32.7790687],
              [49.6556343, 32.7793485],
              [49.6600773, 32.7793485],
              [49.6925803, 32.789624],
              [49.69369, 32.7901838],
              [49.6959135, 32.7910145],
              [49.7192463, 32.8057323],
              [49.7248032, 32.8085133],
              [49.7256363, 32.8085133],
              [49.7256364, 32.8087933],
              [49.7273032, 32.8087932],
              [49.7281364, 32.8090731],
              [49.7298032, 32.8090731],
              [49.7311931, 32.8085133],
              [49.7317497, 32.8082425],
              [49.7331365, 32.8082425],
              [49.7350831, 32.809344],
              [49.7352067, 32.8098742],
              [49.7359162, 32.8115743],
              [49.7359162, 32.8118542],
              [49.7370264, 32.8143463],
              [49.7439694, 32.8210099],
              [49.7453594, 32.8251815],
              [49.7453594, 32.8257412],
              [49.7453593, 32.8299038],
              [49.7442495, 32.8329647],
              [49.7439695, 32.8332446],
              [49.743693, 32.8340753],
              [49.7439695, 32.8407389],
              [49.7448026, 32.8435199],
              [49.7492492, 32.8524048],
              [49.7495262, 32.8535154],
              [49.7489726, 32.8549058],
              [49.7486925, 32.8557365],
              [49.7473027, 32.8579577],
              [49.7461929, 32.8590773],
              [49.740083, 32.8646303],
              [49.7323028, 32.8749056],
              [49.7295261, 32.8760162],
              [49.7284128, 32.8760162],
              [49.7217462, 32.8796279],
              [49.7203596, 32.8796279],
              [49.7200798, 32.8799078],
              [49.7195264, 32.8799078],
              [49.7189696, 32.8804676],
              [49.71397, 32.8840702],
              [49.7128598, 32.8846301],
              [49.7061896, 32.8912936],
              [49.7042467, 32.8926841],
              [49.70369, 32.8926841],
              [49.7036901, 32.892964],
              [49.7031365, 32.892964],
              [49.7028564, 32.8932439],
              [49.7000799, 32.8937947],
              [49.6881335, 32.8968466],
              [49.6881335, 32.8971264],
              [49.6867467, 32.8971265],
              [49.6823002, 32.8990767],
              [49.6814669, 32.9001873],
              [49.6809133, 32.9007381],
              [49.6809134, 32.9015689],
              [49.6803568, 32.9024085],
              [49.6809134, 32.9085214],
              [49.6785358, 32.9127921],
              [49.6781336, 32.9135145],
              [49.6775801, 32.9137944],
              [49.6761902, 32.9162955],
              [49.6714671, 32.9210177],
              [49.6706335, 32.9210177],
              [49.6673002, 32.9232389],
              [49.6667435, 32.9240786],
              [49.6659103, 32.9254601],
              [49.6650771, 32.9279612],
              [49.6642435, 32.9293517],
              [49.6636903, 32.9293516],
              [49.6634102, 32.9296315],
              [49.662577, 32.9296316],
              [49.662577, 32.9299114],
              [49.6614668, 32.9299115],
              [49.6589672, 32.9326834],
              [49.6586902, 32.936575],
              [49.6584106, 32.9374057],
              [49.6581336, 32.9385162],
              [49.6559105, 32.9432385],
              [49.6550773, 32.9443491],
              [49.6533512, 32.9636742],
              [49.6518802, 32.965626],
              [49.6498418, 32.9672634],
              [49.6498319, 32.9688363],
              [49.6500226, 32.9700494],
              [49.6498081, 32.9717615],
              [49.6500063, 32.97382],
              [49.6506785, 32.9755246],
              [49.6531235, 32.9764083],
              [49.6406339, 32.9782445],
              [49.6409105, 32.9785153],
              [49.6417437, 32.9787952],
              [49.6453539, 32.9787952],
              [49.6509102, 32.9782444],
              [49.6703568, 32.9707413],
              [49.6720236, 32.9707413],
              [49.6725767, 32.9704614],
              [49.6764667, 32.9704614],
              [49.6772999, 32.9707413],
              [49.6784136, 32.9707413],
              [49.6786902, 32.9710212],
              [49.6803566, 32.9712921],
              [49.6842464, 32.9735222],
              [49.6853567, 32.9749037],
              [49.6864665, 32.9757435],
              [49.6936896, 32.9776847],
              [49.6948033, 32.9779646],
              [49.6953565, 32.9776847],
              [49.6959131, 32.9779646],
              [49.6998031, 32.9779646],
              [49.7050797, 32.9801858],
              [49.7078563, 32.982407],
              [49.7078563, 32.9832467],
              [49.7075797, 32.9835176],
              [49.7075797, 32.9837974],
              [49.7075797, 32.9843572],
              [49.7075798, 32.9846372],
              [49.7064696, 32.9874091],
              [49.7059129, 32.9885197],
              [49.7059128, 32.9887995],
              [49.7048032, 32.9901901],
              [49.7009132, 32.992962],
              [49.7003565, 32.9929619],
              [49.699803, 32.9935217],
              [49.6992463, 32.9935218],
              [49.6989698, 32.9938017],
              [49.6920232, 32.9938017],
              [49.6917466, 32.9935217],
              [49.6861899, 32.9935218],
              [49.6834133, 32.9940725],
              [49.6706333, 32.9987947],
              [49.6645233, 33.0018555],
              [49.6550771, 33.0074084],
              [49.6536869, 33.0101894],
              [49.6539669, 33.0104693],
              [49.6539669, 33.0115799],
              [49.6556337, 33.0140719],
              [49.6678567, 33.0221349],
              [49.6686902, 33.0274078],
              [49.6659101, 33.037132],
              [49.6656335, 33.040193],
              [49.66591, 33.0432448],
              [49.6689667, 33.0501881],
              [49.6717433, 33.0512987],
              [49.6797998, 33.0568515],
              [49.685633, 33.0663048],
              [49.6909129, 33.0699075],
              [49.6956364, 33.0712979],
              [49.6964695, 33.0712979],
              [49.6967461, 33.0715778],
              [49.698413, 33.0715778],
              [49.6989696, 33.0718578],
              [49.7011895, 33.0718577],
              [49.7017462, 33.0715778],
              [49.7036896, 33.0715778],
              [49.7125794, 33.0751895],
              [49.7178594, 33.0815819],
              [49.7188335, 33.0822699],
              [49.722026, 33.0843538],
              [49.724246, 33.0843539],
              [49.7248024, 33.0840739],
              [49.7261924, 33.0835232],
              [49.7281358, 33.0826925],
              [49.7373024, 33.073799],
              [49.7425822, 33.0721377],
              [49.7445256, 33.0715779],
              [49.7456354, 33.0715779],
              [49.7548055, 33.0679663],
              [49.7620255, 33.0660251],
              [49.7661921, 33.0643547],
              [49.7795286, 33.0618537],
              [49.7803619, 33.0618537],
              [49.7809149, 33.0615738],
              [49.7828619, 33.0615738],
              [49.7856386, 33.0610231],
              [49.8098081, 33.0565808],
              [49.8345314, 33.0501883],
              [49.8364743, 33.0501884],
              [49.837308, 33.0499084],
              [49.8389743, 33.0499084],
              [49.8398075, 33.0501883],
              [49.8411979, 33.0501884],
              [49.8489742, 33.0535201],
              [49.8498075, 33.0535201],
              [49.8542543, 33.0571317],
              [49.8564743, 33.0624137],
              [49.8570309, 33.0629645],
              [49.858974, 33.0657453],
              [49.8598076, 33.0668559],
              [49.8636975, 33.0690771],
              [49.8648108, 33.069077],
              [49.8653639, 33.069357],
              [49.8689773, 33.0693569],
              [49.8698105, 33.069077],
              [49.8714773, 33.069077],
              [49.8925872, 33.0624137],
              [49.8928672, 33.0621339],
              [49.8948102, 33.0621338],
              [49.8956439, 33.0618538],
              [49.8967536, 33.0618539],
              [49.8975868, 33.0621338],
              [49.8989771, 33.0621339],
              [49.9000869, 33.0624138],
              [49.9014767, 33.0624138],
              [49.9037002, 33.0629645],
              [49.90481, 33.0629645],
              [49.9053667, 33.0632444],
              [49.9070335, 33.0632444],
              [49.9084234, 33.0638042],
              [49.9095336, 33.0638042],
              [49.9103668, 33.064075],
              [49.9142567, 33.0657455],
              [49.9148102, 33.0657454],
              [49.9214799, 33.0721379],
              [49.9220334, 33.0732485],
              [49.9242565, 33.0896361],
              [49.9239798, 33.0901868],
              [49.9231467, 33.0915773],
              [49.9228666, 33.092417],
              [49.9220333, 33.0932386],
              [49.9217568, 33.0940783],
              [49.9211998, 33.0943582],
              [49.9203665, 33.0962994],
              [49.9198134, 33.0971302],
              [49.9189801, 33.0996311],
              [49.9187001, 33.1004708],
              [49.8795304, 33.1279729],
              [49.878977, 33.1282436],
              [49.878977, 33.1285236],
              [49.8778636, 33.1296341],
              [49.8775871, 33.1301939],
              [49.8767539, 33.1321351],
              [49.8770304, 33.1340855],
              [49.8775871, 33.134907],
              [49.8803637, 33.1379678],
              [49.8884201, 33.1396291],
              [49.8887002, 33.139909],
              [49.8892537, 33.139909],
              [49.8898104, 33.1407396],
              [49.890367, 33.1438005],
              [49.8906435, 33.1446311],
              [49.890367, 33.144911],
              [49.8887001, 33.1507527],
              [49.88842, 33.1518632],
              [49.8823102, 33.1685214],
              [49.8809202, 33.1718531],
              [49.8725869, 33.1826875],
              [49.871197, 33.1876895],
              [49.8714771, 33.191301],
              [49.8770303, 33.2029661],
              [49.8773103, 33.2040768],
              [49.8875867, 33.2179719],
              [49.8895336, 33.2196333],
              [49.8948099, 33.2210237],
              [49.8989768, 33.2218543],
              [49.89981, 33.2218543],
              [49.9050898, 33.2240844],
              [49.9150896, 33.2285265],
              [49.9206464, 33.2301878],
              [49.9250898, 33.2301878],
              [49.9289797, 33.229917],
              [49.9298129, 33.229637],
              [49.9320329, 33.2296371],
              [49.9328661, 33.2293571],
              [49.9384228, 33.2293572],
              [49.9392561, 33.2290774],
              [49.9437027, 33.2290773],
              [49.9442561, 33.2288065],
              [49.9464793, 33.229917],
              [49.9470359, 33.2299169],
              [49.9473125, 33.2326888],
              [49.9462026, 33.2343591],
              [49.9423128, 33.2371399],
              [49.9417561, 33.2376907],
              [49.9400893, 33.2388012],
              [49.9395361, 33.2390811],
              [49.9389794, 33.2390811],
              [49.9389795, 33.239361],
              [49.9384228, 33.239361],
              [49.9361994, 33.241582],
              [49.9359227, 33.2424127],
              [49.9375892, 33.2471437],
              [49.9409228, 33.2490849],
              [49.9423127, 33.2490849],
              [49.9428693, 33.248805],
              [49.9450893, 33.2488049],
              [49.9464792, 33.2499155],
              [49.9473123, 33.2574092],
              [49.9570356, 33.267413],
              [49.9578692, 33.2676929],
              [49.958979, 33.2685235],
              [49.9595356, 33.2688034],
              [49.961479, 33.269914],
              [49.9620358, 33.2704737],
              [49.9673123, 33.2782473],
              [49.9678691, 33.279078],
              [49.9709257, 33.2807483],
              [49.9970387, 33.3015772],
              [49.9987051, 33.3035274],
              [50.0000919, 33.3060283],
              [50.0000919, 33.3068589],
              [50.000372, 33.3074187],
              [49.998425, 33.3104703],
              [49.9981485, 33.31103],
              [49.9967586, 33.3129712],
              [49.9959249, 33.3146414],
              [49.9956485, 33.3154721],
              [49.9953718, 33.3163027],
              [49.9959249, 33.3232456],
              [50.0059251, 33.3440833],
              [50.0070384, 33.3488052],
              [50.0125916, 33.357969],
              [50.0137049, 33.3588088],
              [50.0139815, 33.3593595],
              [50.0162049, 33.3601901],
              [50.0167617, 33.36047],
              [50.0184281, 33.3601901],
              [50.0195382, 33.3615895],
              [50.0198148, 33.3640813],
              [50.018148, 33.3685323],
              [50.0153713, 33.3715839],
              [50.0106482, 33.3738049],
              [50.0100916, 33.3743646],
              [50.0064817, 33.375755],
              [50.0034249, 33.375755],
              [50.0028714, 33.3754751],
              [50.0023148, 33.3754751],
              [49.998705, 33.3751952],
              [49.9975917, 33.3749153],
              [49.9959249, 33.3749153],
              [49.9903685, 33.373534],
              [49.9767584, 33.3721436],
              [49.9620355, 33.3763057],
              [49.9520357, 33.3826978],
              [49.951479, 33.3829776],
              [49.951479, 33.3835283],
              [49.9487024, 33.3865799],
              [49.9484224, 33.3871397],
              [49.9478688, 33.3874196],
              [49.9467555, 33.3860292],
              [49.9437023, 33.3854785],
              [49.9434222, 33.3851986],
              [49.9420359, 33.3851985],
              [49.9373123, 33.3840881],
              [49.9345325, 33.3849186],
              [49.927866, 33.3921413],
              [49.925366, 33.3957526],
              [49.9250894, 33.3963124],
              [49.9225894, 33.399364],
              [49.9203659, 33.401305],
              [49.9086996, 33.4074172],
              [49.9073094, 33.4076971],
              [49.9064762, 33.4082478],
              [49.8986994, 33.4104687],
              [49.8984193, 33.4107486],
              [49.8973094, 33.4107486],
              [49.8823096, 33.4157503],
              [49.8625865, 33.4196414],
              [49.8614732, 33.4196414],
              [49.8586966, 33.420472],
              [49.8578634, 33.420472],
              [49.8573067, 33.4207518],
              [49.8564735, 33.4207518],
              [49.85592, 33.4210317],
              [49.8548067, 33.4210318],
              [49.8528633, 33.4215825],
              [49.8520301, 33.4215825],
              [49.8489734, 33.4229728],
              [49.8481402, 33.4229728],
              [49.8409169, 33.4260333],
              [49.8392501, 33.4268639],
              [49.8353638, 33.4276946],
              [49.8067507, 33.4379776],
              [49.7964708, 33.4465905],
              [49.7956374, 33.4479808],
              [49.7942508, 33.4510324],
              [49.7942508, 33.4513033],
              [49.7920276, 33.4607557],
              [49.7923041, 33.4693685],
              [49.7925842, 33.4738104],
              [49.7920275, 33.4752007],
              [49.7917507, 33.476582],
              [49.791471, 33.4774216],
              [49.7895275, 33.4840844],
              [49.787304, 33.4904763],
              [49.7864708, 33.4918666],
              [49.7864708, 33.4924173],
              [49.7861943, 33.4926971],
              [49.7861942, 33.492977],
              [49.7856375, 33.4935368],
              [49.7856376, 33.4938076],
              [49.7770276, 33.5093628],
              [49.7745275, 33.5129741],
              [49.7736943, 33.5138137],
              [49.7709142, 33.5176957],
              [49.7623042, 33.5263085],
              [49.6969428, 33.5733891],
              [49.6883597, 33.5735974],
              [49.6831369, 33.5712927],
              [49.6742534, 33.5702558],
              [49.6673011, 33.5708636],
              [49.66077, 33.5723398],
              [49.6521349, 33.5780657],
              [49.6477749, 33.5805157],
              [49.6438292, 33.582516],
              [49.639795, 33.58851],
              [49.6382045, 33.5928158],
              [49.6352862, 33.5975344],
              [49.6322786, 33.6039398],
              [49.6297073, 33.6116887],
              [49.6297931, 33.6146908],
              [49.6247632, 33.618874],
              [49.6195668, 33.6229358],
              [49.6114019, 33.6257737],
              [49.6016424, 33.6287039],
              [49.5941704, 33.6328031],
              [49.5843631, 33.6383174],
              [49.5857173, 33.6510752],
              [49.5923929, 33.6628039],
              [49.5946436, 33.6667334],
              [49.5973821, 33.6714104],
              [49.5988161, 33.6745326],
              [49.6008871, 33.6776761],
              [49.6030787, 33.6820793],
              [49.605387, 33.6861336],
              [49.6096837, 33.693153],
              [49.6115303, 33.6981536],
              [49.616661, 33.7099184],
              [49.6191643, 33.7143319],
              [49.6242675, 33.7239378],
              [49.6269425, 33.72842],
              [49.6310372, 33.7349938],
              [49.6332958, 33.738745],
              [49.6223717, 33.7383793],
              [49.6166452, 33.7382163],
              [49.6089219, 33.7355858],
              [49.6015974, 33.7332881],
              [49.5942597, 33.7297507],
              [49.5869701, 33.7261318],
              [49.5829994, 33.7240374],
              [49.5786994, 33.7221563],
              [49.5760542, 33.7206424],
              [49.5717086, 33.7179856],
              [49.5589089, 33.7089036],
              [49.5533609, 33.7044918],
              [49.5473006, 33.7000738],
              [49.54106, 33.6956015],
              [49.5367343, 33.6927419],
              [49.5302255, 33.688034],
              [49.5155096, 33.6869605],
              [49.5028581, 33.6869519],
              [49.4985151, 33.6895672],
              [49.4931508, 33.692926],
              [49.4885165, 33.6957483],
              [49.4863271, 33.6954945],
              [49.4845676, 33.6974226],
              [49.4823789, 33.6996006],
              [49.4810056, 33.7009573],
              [49.4788169, 33.7021712],
              [49.4758987, 33.702671],
              [49.4704485, 33.7024211],
              [49.46002, 33.7022426],
              [49.4558572, 33.7014571],
              [49.4495058, 33.7011715],
              [49.4456005, 33.7007431],
              [49.442811, 33.7004217],
              [49.4380045, 33.700386],
              [49.4350433, 33.6998862],
              [49.4283914, 33.6982795],
              [49.4219276, 33.6966061],
              [49.4220185, 33.7007073],
              [49.4223082, 33.7035011],
              [49.4229948, 33.7045275],
              [49.4227052, 33.7047685],
              [49.4195509, 33.7100433],
              [49.4158172, 33.7168794],
              [49.412384, 33.7206275],
              [49.4089428, 33.7248783],
              [49.3938925, 33.7295897],
              [49.3869267, 33.7285375],
              [49.3799384, 33.7248107],
              [49.3737363, 33.7165953],
              [49.3682047, 33.7036664],
              [49.3685922, 33.7005188],
              [49.3693726, 33.6937849],
              [49.3665489, 33.6878415],
              [49.3664883, 33.6862105],
              [49.3659554, 33.6851749],
              [49.3586724, 33.6802036],
              [49.3556192, 33.6768725],
              [49.3545059, 33.6699212],
              [49.3561726, 33.6657595],
              [49.3567294, 33.6643693],
              [49.3578392, 33.661309],
              [49.3561728, 33.6571472],
              [49.3514492, 33.6529765],
              [49.3467295, 33.6515953],
              [49.3464495, 33.6513154],
              [49.3445061, 33.6513154],
              [49.3439495, 33.6510356],
              [49.3378396, 33.6510355],
              [49.337283, 33.6507557],
              [49.3350629, 33.6507556],
              [49.3342297, 33.6504758],
              [49.3295062, 33.6504758],
              [49.3289495, 33.6507557],
              [49.3281164, 33.6507556],
              [49.3236729, 33.6540868],
              [49.3228397, 33.6551972],
              [49.3217263, 33.6568673],
              [49.3156165, 33.6590881],
              [49.3145032, 33.6588173],
              [49.3061697, 33.6546466],
              [49.3031166, 33.653816],
              [49.3028365, 33.6535361],
              [49.3020033, 33.6535361],
              [49.2970032, 33.6504758],
              [49.29645, 33.6502049],
              [49.2945036, 33.6424232],
              [49.2947802, 33.6421433],
              [49.2953367, 33.6402023],
              [49.2989502, 33.6365913],
              [49.2886704, 33.6121443],
              [49.2881137, 33.6088131],
              [49.2878371, 33.6079825],
              [49.2875602, 33.6077026],
              [49.287366, 33.6072273],
              [49.2850605, 33.6043715],
              [49.2842269, 33.6040916],
              [49.2808936, 33.6040916],
              [49.2667238, 33.6104832],
              [49.265614, 33.610754],
              [49.2586705, 33.6129749],
              [49.2581138, 33.6132547],
              [49.2572807, 33.6132546],
              [49.256724, 33.6135346],
              [49.2556142, 33.6135345],
              [49.2536673, 33.6143651],
              [49.2531141, 33.6143651],
              [49.2528341, 33.6146449],
              [49.2522809, 33.614645],
              [49.2517239, 33.6152046],
              [49.2467242, 33.6171456],
              [49.2408908, 33.6171455],
              [49.2403342, 33.6168658],
              [49.2392244, 33.6168657],
              [49.2228346, 33.6121442],
              [49.2195009, 33.6121442],
              [49.2192213, 33.6124241],
              [49.2181111, 33.6124241],
              [49.2172779, 33.6127039],
              [49.2167212, 33.6127039],
              [49.2156111, 33.6129748],
              [49.2120011, 33.6182559],
              [49.211168, 33.6207566],
              [49.2053347, 33.6243677],
              [49.2045015, 33.6251983],
              [49.2042213, 33.6265885],
              [49.2045014, 33.6301995],
              [49.2083878, 33.6443639],
              [49.2086678, 33.6463139],
              [49.2083877, 33.6468736],
              [49.2064444, 33.6513151],
              [49.2047779, 33.6524255],
              [49.2020014, 33.657147],
              [49.2014446, 33.6588171],
              [49.2011645, 33.6596476],
              [49.2000547, 33.6640891],
              [49.1997778, 33.6665898],
              [49.1989445, 33.6715911],
              [49.1961644, 33.6760326],
              [49.1956113, 33.6763125],
              [49.1956112, 33.6768721],
              [49.1950547, 33.6774228],
              [49.1950546, 33.6777026],
              [49.194778, 33.6785332],
              [49.1950546, 33.6863149],
              [49.1856114, 33.6965881],
              [49.1853313, 33.6976984],
              [49.1842215, 33.6993685],
              [49.1797746, 33.702149],
              [49.1706084, 33.7040899],
              [49.1697747, 33.7040898],
              [49.1669981, 33.7046495],
              [49.1467184, 33.7182628],
              [49.1417187, 33.7215939],
              [49.1383854, 33.7215939],
              [49.1300521, 33.7182628],
              [49.1294954, 33.7179829],
              [49.1283852, 33.7171524],
              [49.1281086, 33.7168636],
              [49.1256055, 33.716033],
              [49.1253289, 33.7157532],
              [49.1244953, 33.7157532],
              [49.123662, 33.7152025],
              [49.1211621, 33.7152025],
              [49.1200522, 33.7152026],
              [49.1194956, 33.7154823],
              [49.1186624, 33.7154823],
              [49.112552, 33.7196439],
              [49.1117189, 33.7199238],
              [49.1114388, 33.7202036],
              [49.1089391, 33.7202037],
              [49.1086621, 33.7199238],
              [49.107829, 33.7199238],
              [49.101439, 33.7171524],
              [49.1011624, 33.7168636],
              [49.0961624, 33.7165927],
              [49.0944959, 33.7168635],
              [49.0894958, 33.7185336],
              [49.0858824, 33.7196439],
              [49.0856058, 33.7199238],
              [49.0850492, 33.7199237],
              [49.0825491, 33.7199238],
              [49.075606, 33.7179829],
              [49.0736596, 33.7007586],
              [49.0708829, 33.689366],
              [49.0703263, 33.6888153],
              [49.0694927, 33.6888152],
              [49.0658829, 33.6907562],
              [49.0650496, 33.6913159],
              [49.0528263, 33.7024286],
              [49.0508833, 33.7032591],
              [49.0497696, 33.7032591],
              [49.049213, 33.703539],
              [49.0461597, 33.703539],
              [49.0458797, 33.7032592],
              [49.0442133, 33.7032591],
              [49.0442132, 33.7029793],
              [49.0433796, 33.7029792],
              [49.0431031, 33.7026994],
              [49.0422698, 33.7026994],
              [49.0342134, 33.6971476],
              [49.0325466, 33.696317],
              [49.0300466, 33.6954775],
              [49.0261566, 33.6954775],
              [49.0258801, 33.6957572],
              [49.02338, 33.6957573],
              [49.0219901, 33.6963169],
              [49.0211569, 33.696317],
              [49.0167135, 33.6990884],
              [49.0161568, 33.7004786],
              [49.0158803, 33.7007585],
              [49.0156037, 33.7018688],
              [49.0144224, 33.7068628],
              [49.0140008, 33.7110607],
              [49.012928, 33.7153802],
              [49.008364, 33.7224282],
              [49.005542, 33.7303133],
              [49.0038552, 33.7361331],
              [49.0078427, 33.7406382],
              [49.0100955, 33.744183],
              [49.0096664, 33.7476087],
              [49.0064906, 33.7497497],
              [49.0088939, 33.7504634],
              [49.0052032, 33.7533179],
              [49.0054169, 33.7598866],
              [49.005448, 33.7630671],
              [49.0001762, 33.7687072],
              [49.0002192, 33.769686],
              [48.9965862, 33.7726863],
              [48.9919097, 33.7779001],
              [48.9883877, 33.7796479],
              [48.9860402, 33.7836164],
              [48.9856741, 33.7896331],
              [48.9856146, 33.7959794],
              [48.9853613, 33.7998151],
              [48.9847668, 33.8077042],
              [48.9847669, 33.807984],
              [48.9928236, 33.8149258],
              [48.9942135, 33.8218676],
              [48.9936569, 33.8260381],
              [48.9939334, 33.8299286],
              [48.9931002, 33.8318695],
              [48.9931002, 33.8324292],
              [48.9919899, 33.8335394],
              [48.9914333, 33.83437],
              [48.9886567, 33.8354802],
              [48.988377, 33.8357601],
              [48.9878235, 33.8357601],
              [48.9875433, 33.8360399],
              [48.9869903, 33.8360399],
              [48.9867101, 33.8363197],
              [48.9858769, 33.8363197],
              [48.9856003, 33.8365906],
              [48.98171, 33.8368704],
              [48.9803237, 33.8368704],
              [48.9803237, 33.8371502],
              [48.9789334, 33.8371502],
              [48.9781003, 33.8374301],
              [48.9758771, 33.8396507],
              [48.9758772, 33.8413116],
              [48.9972666, 33.866596],
              [48.9980997, 33.866596],
              [49.0000467, 33.8665959],
              [49.0011565, 33.8660363],
              [49.0044898, 33.8660364],
              [49.0061566, 33.8671466],
              [49.0061565, 33.8674265],
              [49.0064331, 33.8693762],
              [49.0055999, 33.8710372],
              [48.9978232, 33.8790981],
              [48.9975466, 33.8799286],
              [48.9972665, 33.8827088],
              [48.9947664, 33.8882603],
              [48.9939332, 33.8893705],
              [48.9939332, 33.89021],
              [48.9936567, 33.8904809],
              [48.9947664, 33.8927104],
              [48.99949, 33.8952017],
              [49.0114331, 33.9015927],
              [49.0122663, 33.9060429],
              [49.0117132, 33.9071532],
              [49.0097663, 33.9090939],
              [49.0028232, 33.9121539],
              [49.0011564, 33.9115943],
              [49.0003231, 33.9115943],
              [48.9998178, 33.9113236],
              [48.9980996, 33.9107638],
              [48.9967133, 33.9107638],
              [48.9964333, 33.910484],
              [48.9953235, 33.910484],
              [48.9950465, 33.9102041],
              [48.9942132, 33.9102042],
              [48.9936566, 33.9099334],
              [48.9842098, 33.9124247],
              [48.9839333, 33.9127136],
              [48.9828236, 33.9127136],
              [48.9822669, 33.9129844],
              [48.9803235, 33.9127135],
              [48.9678201, 33.9054832],
              [48.9664338, 33.9049325],
              [48.9642103, 33.9049325],
              [48.9633771, 33.9052033],
              [48.9628205, 33.9054832],
              [48.9606005, 33.9074239],
              [48.9594871, 33.9079835],
              [48.9575438, 33.9102041],
              [48.9555968, 33.9168748],
              [48.9558769, 33.9199348],
              [48.9561538, 33.921325],
              [48.9564304, 33.9218755],
              [48.9561538, 33.9224262],
              [48.9564304, 33.922706],
              [48.9575437, 33.927427],
              [48.9636535, 33.9365979],
              [48.9639336, 33.9393781],
              [48.9617101, 33.9427089],
              [48.9614336, 33.9443698],
              [48.9619867, 33.9499301],
              [48.9653199, 33.9560411],
              [48.9658766, 33.9566007],
              [48.9686532, 33.9596517],
              [48.9869899, 33.9721533],
              [48.9878231, 33.9721534],
              [48.9980995, 33.9777046],
              [49.0086564, 33.981595],
              [49.0089329, 33.9818748],
              [49.0100462, 33.9818748],
              [49.0103227, 33.9821546],
              [49.0119895, 33.9821546],
              [49.0128228, 33.9824254],
              [49.0158795, 33.9824255],
              [49.0189361, 33.9821546],
              [49.0194894, 33.9818748],
              [49.0211562, 33.9818748],
              [49.0228226, 33.9813242],
              [49.0303224, 33.9768742],
              [49.0306025, 33.9763146],
              [49.037269, 33.9752134],
              [49.037546, 33.9749335],
              [49.0381026, 33.9752134],
              [49.0386593, 33.9749335],
              [49.0417125, 33.9763146],
              [49.052549, 33.9857652],
              [49.0528256, 33.9860451],
              [49.0553256, 33.9885453],
              [49.0564354, 33.9940966],
              [49.0561588, 33.9946562],
              [49.0542158, 33.9999276],
              [49.0544924, 34.0015975],
              [49.0708821, 34.0102085],
              [49.0775724, 34.01471],
              [49.0758818, 34.0146495],
              [49.0750486, 34.0143787],
              [49.0739388, 34.0143786],
              [49.0731051, 34.0140989],
              [49.0703254, 34.0140988],
              [49.0700485, 34.013819],
              [49.0681019, 34.013819],
              [49.0678254, 34.0135392],
              [49.0642155, 34.0132685],
              [49.063382, 34.0135392],
              [49.0631023, 34.013819],
              [49.0622687, 34.013819],
              [49.061992, 34.0140988],
              [49.0556021, 34.0157687],
              [49.046712, 34.0160394],
              [49.0467121, 34.0163192],
              [49.0461589, 34.0163193],
              [49.0433788, 34.0171497],
              [49.0433788, 34.0168789],
              [49.0425456, 34.0157687],
              [49.0408791, 34.015209],
              [49.0389357, 34.015209],
              [49.0383791, 34.0149291],
              [49.0378259, 34.015209],
              [49.0367122, 34.015209],
              [49.0361591, 34.0154889],
              [49.0353259, 34.0154889],
              [49.0178228, 34.0218704],
              [49.0167126, 34.0218703],
              [49.0158793, 34.0221501],
              [49.0111558, 34.0221501],
              [49.0039326, 34.0204893],
              [48.9855999, 34.010768],
              [48.9836565, 34.0102084],
              [48.9825433, 34.0102084],
              [48.9819897, 34.0099286],
              [48.9811565, 34.0099286],
              [48.9808764, 34.0096488],
              [48.9778232, 34.0090981],
              [48.9694866, 34.0090981],
              [48.9692101, 34.0088183],
              [48.9500438, 34.0027075],
              [48.948377, 34.0027074],
              [48.9480968, 34.0029873],
              [48.9475437, 34.0029873],
              [48.9447636, 34.0063179],
              [48.9444869, 34.0099284],
              [48.9442104, 34.0102083],
              [48.9442104, 34.0110477],
              [48.9436537, 34.0118781],
              [48.9433768, 34.012149],
              [48.9419869, 34.0132682],
              [48.9308738, 34.0218701],
              [48.9305973, 34.0240997],
              [48.9280971, 34.0268706],
              [48.9225403, 34.0282697],
              [48.9203205, 34.0285404],
              [48.9161503, 34.0285404],
              [48.9136507, 34.0274302],
              [48.9117074, 34.0202093],
              [48.911984, 34.0190991],
              [48.9122641, 34.0185394],
              [48.9117073, 34.0140985],
              [48.9103176, 34.0110477],
              [48.9042073, 34.0063179],
              [48.8992075, 34.0043772],
              [48.8980943, 34.0043772],
              [48.8975407, 34.0040974],
              [48.8936507, 34.003267],
              [48.8911512, 34.0032669],
              [48.890041, 34.0035468],
              [48.8828178, 34.004657],
              [48.8789279, 34.004657],
              [48.8742043, 34.0035468],
              [48.8725379, 34.0035467],
              [48.868928, 34.0027074],
              [48.8675377, 34.0027073],
              [48.8611478, 34.0010465],
              [48.8544813, 34.0018768],
              [48.8517047, 34.0027073],
              [48.849205, 34.006047],
              [48.8472615, 34.0129881],
              [48.8469815, 34.013268],
              [48.8461482, 34.0154884],
              [48.8461482, 34.0174381],
              [48.8458717, 34.0177089],
              [48.8458716, 34.0260401],
              [48.8439283, 34.0338207],
              [48.8417048, 34.0363209],
              [48.8408715, 34.0366007],
              [48.8403148, 34.0371513],
              [48.8147584, 34.0499322],
              [48.8139252, 34.0499322],
              [48.804202, 34.0527122],
              [48.7969788, 34.0557631],
              [48.7944787, 34.0568732],
              [48.7800355, 34.0641031],
              [48.7792022, 34.0649335],
              [48.765589, 34.072434],
              [48.7597557, 34.0804942],
              [48.7583658, 34.0846552],
              [48.7530891, 34.0918759],
              [48.7500324, 34.0952155],
              [48.7497559, 34.0954862],
              [48.7491992, 34.0960459],
              [48.7478094, 34.0977157],
              [48.7308659, 34.1210474],
              [48.7236428, 34.1232677],
              [48.722533, 34.1232677],
              [48.7219759, 34.1235476],
              [48.7175328, 34.1235475],
              [48.7169762, 34.1232677],
              [48.7158659, 34.1232677],
              [48.7147527, 34.1227081],
              [48.7133664, 34.1221575],
              [48.7130863, 34.1213272],
              [48.7116995, 34.1163178],
              [48.7150329, 34.1054869],
              [48.7153094, 34.1040968],
              [48.7155864, 34.1032665],
              [48.7150329, 34.0979864],
              [48.7128097, 34.0946558],
              [48.7094765, 34.0918759],
              [48.6850299, 34.0835448],
              [48.6805868, 34.0815953],
              [48.67225, 34.0790951],
              [48.6672504, 34.0788242],
              [48.6680073, 34.0787291],
              [48.6618974, 34.0787291],
              [48.6593973, 34.0792887],
              [48.6576542, 34.0760602],
              [48.6474543, 34.0783667],
              [48.6469737, 34.0821548],
              [48.6341937, 34.0885451],
              [48.6339171, 34.0890958],
              [48.6333605, 34.0890957],
              [48.6258607, 34.0954861],
              [48.6247506, 34.0954861],
              [48.6244709, 34.0957658],
              [48.6233607, 34.0957658],
              [48.6219708, 34.0963164],
              [48.6172508, 34.0960456],
              [48.6144706, 34.0938253],
              [48.6141941, 34.0935454],
              [48.5994712, 34.0702133],
              [48.5894714, 34.0643825],
              [48.5886378, 34.0643825],
              [48.5875245, 34.0638229],
              [48.5864147, 34.0638229],
              [48.5858581, 34.0635431],
              [48.5816912, 34.063543],
              [48.580858, 34.0632632],
              [48.5755813, 34.0632633],
              [48.574468, 34.0635431],
              [48.5730817, 34.063543],
              [48.5672483, 34.0649331],
              [48.5650248, 34.0654837],
              [48.5641916, 34.0654837],
              [48.5603017, 34.0665938],
              [48.5597482, 34.0671535],
              [48.5566919, 34.0696536],
              [48.5530785, 34.0763148],
              [48.5528015, 34.077434],
              [48.5500249, 34.0915957],
              [48.5494682, 34.094105],
              [48.5489115, 34.0954859],
              [48.5489115, 34.096596],
              [48.5469685, 34.1004863],
              [48.5458583, 34.1018762],
              [48.5450251, 34.102156],
              [48.5414117, 34.1049359],
              [48.5414117, 34.1052158],
              [48.5405785, 34.1054865],
              [48.5364115, 34.1074361],
              [48.5344687, 34.1077069],
              [48.5269684, 34.1071563],
              [48.5258551, 34.1065967],
              [48.5214122, 34.100766],
              [48.5197453, 34.0938251],
              [48.5191887, 34.0874347],
              [48.5186321, 34.0660431],
              [48.5189122, 34.0652127],
              [48.5189121, 34.0632632],
              [48.5191887, 34.0604832],
              [48.520022, 34.0571525],
              [48.520299, 34.0568728],
              [48.5194655, 34.0507621],
              [48.5114124, 34.0441008],
              [48.4830761, 34.0102073],
              [48.4811327, 34.0090971],
              [48.476133, 34.0068767],
              [48.4752994, 34.0068767],
              [48.4750197, 34.0065969],
              [48.474186, 34.0065969],
              [48.4736329, 34.006317],
              [48.4722371, 34.0063171],
              [48.4719661, 34.006317],
              [48.4714094, 34.006317],
              [48.4705762, 34.006317],
              [48.4605764, 34.0085465],
              [48.4561299, 34.0088172],
              [48.4550196, 34.0085464],
              [48.4455734, 34.0085465],
              [48.4447398, 34.0082666],
              [48.4433534, 34.0082667],
              [48.420017, 34.0027065],
              [48.4158502, 34.0027064],
              [48.4147404, 34.0024266],
              [48.4105738, 34.0021558],
              [48.4055738, 34.0021558],
              [48.4044604, 34.0018759],
              [48.3989072, 34.0018759],
              [48.3977939, 34.0015961],
              [48.3944606, 34.0015961],
              [48.3933504, 34.0013163],
              [48.3908508, 34.0013163],
              [48.3883507, 34.0013163],
              [48.3849697, 34.0013163],
              [48.3791841, 34.0013163],
              [48.3522379, 34.0068765],
              [48.333348, 34.0143772],
              [48.3327914, 34.014648],
              [48.3325148, 34.0149278],
              [48.3319582, 34.0149278],
              [48.3250146, 34.0165976],
              [48.3230681, 34.0165976],
              [48.3227915, 34.0168774],
              [48.304735, 34.0213183],
              [48.3041783, 34.0227084],
              [48.3039017, 34.0265987],
              [48.3036251, 34.0268694],
              [48.3039017, 34.0285393],
              [48.3047348, 34.0379897],
              [48.3047348, 34.0390999],
              [48.3050114, 34.0413202],
              [48.305845, 34.0546519],
              [48.305568, 34.0552115],
              [48.3052915, 34.0554912],
              [48.3052915, 34.055762],
              [48.3044582, 34.0566015],
              [48.3030684, 34.0568723],
              [48.3025117, 34.0566015],
              [48.3011249, 34.0566015],
              [48.2994582, 34.0560419],
              [48.2983449, 34.0560419],
              [48.2930682, 34.0549316],
              [48.2905686, 34.0549316],
              [48.2897349, 34.0546518],
              [48.2880685, 34.0546518],
              [48.2866786, 34.054372],
              [48.2752886, 34.054372],
              [48.2741787, 34.0540921],
              [48.255842, 34.0515919],
              [48.2538987, 34.0507615],
              [48.2461223, 34.0491006],
              [48.2405656, 34.0491006],
              [48.2358424, 34.0507614],
              [48.2344526, 34.0513211],
              [48.2308423, 34.0543719],
              [48.2177858, 34.0657627],
              [48.2152862, 34.0671527],
              [48.2147294, 34.0674326],
              [48.193063, 34.0788233],
              [48.1916727, 34.0790941],
              [48.1880628, 34.079094],
              [48.1869531, 34.0796536],
              [48.1861194, 34.0804931],
              [48.1772298, 34.086044],
              [48.1769497, 34.0868744],
              [48.1763966, 34.087434],
              [48.1747297, 34.0918747],
              [48.1693972, 34.1027568],
              [48.1688964, 34.1032654],
              [48.1686163, 34.1040958],
              [48.167783, 34.1049352],
              [48.1675065, 34.1057655],
              [48.1538933, 34.1207665],
              [48.1527831, 34.1221563],
              [48.1447266, 34.1338177],
              [48.1377835, 34.1410472],
              [48.1372268, 34.141327],
              [48.1369499, 34.1415978],
              [48.1363932, 34.1415977],
              [48.1358366, 34.1421574],
              [48.1294501, 34.1449373],
              [48.1291701, 34.1452171],
              [48.1286169, 34.145217],
              [48.1280602, 34.145217],
              [48.1275036, 34.1454878],
              [48.1263934, 34.1454878],
              [48.1258367, 34.1457676],
              [48.1238933, 34.1457676],
              [48.1233367, 34.1454878],
              [48.1130603, 34.1454877],
              [48.1122271, 34.1457676],
              [48.1108368, 34.1457676],
              [48.1080603, 34.1465979],
              [48.100837, 34.1535476],
              [48.0933372, 34.1671582],
              [48.0916704, 34.1685482],
              [48.0900039, 34.1702088],
              [48.0822241, 34.1760484],
              [48.0822241, 34.1763281],
              [48.0817616, 34.1766932],
              [48.0811139, 34.1771585],
              [48.0722242, 34.1946589],
              [48.0722242, 34.1954892],
              [48.0705574, 34.1990994],
              [48.0558344, 34.2099299],
              [48.0547242, 34.2115996],
              [48.053891, 34.2127187],
              [48.0477776, 34.2154894],
              [48.0466678, 34.2154894],
              [48.0463876, 34.2157692],
              [48.0452775, 34.2157692],
              [48.0444443, 34.216049],
              [48.0433345, 34.216049],
              [48.0427778, 34.2163288],
              [48.0388875, 34.2168793],
              [48.0286112, 34.2168793],
              [48.0283311, 34.2171591],
              [48.0272212, 34.217159],
              [48.0269447, 34.2168793],
              [48.0216645, 34.2168793],
              [48.0211113, 34.2171591],
              [48.0191644, 34.217159],
              [48.0130546, 34.219659],
              [48.0119413, 34.2202096],
              [48.0105549, 34.2207692],
              [48.0077748, 34.2207692],
              [48.0074982, 34.221049],
              [48.0055548, 34.221049],
              [48.0047216, 34.2207692],
              [48.0005546, 34.2207691],
              [47.999997, 34.218371],
              [47.9852751, 34.222159],
              [47.9727752, 34.2291084],
              [47.9713853, 34.2293792],
              [47.9711083, 34.2293792],
              [47.9705517, 34.2293792],
              [47.9697185, 34.2293792],
              [47.9647187, 34.2313286],
              [47.9449953, 34.2440993],
              [47.9436054, 34.244379],
              [47.9386057, 34.2457689],
              [47.935549, 34.245769],
              [47.9349954, 34.2454892],
              [47.9316622, 34.2454891],
              [47.9311055, 34.2452094],
              [47.9230491, 34.2440992],
              [47.9113825, 34.2407689],
              [47.9083258, 34.2399386],
              [47.9077727, 34.2399386],
              [47.9049925, 34.2388285],
              [47.9041593, 34.2388285],
              [47.9033261, 34.2385487],
              [47.9002729, 34.2385487],
              [47.9002729, 34.2388285],
              [47.889993, 34.2502093],
              [47.889993, 34.2507688],
              [47.8874929, 34.2540991],
              [47.8874929, 34.2543789],
              [47.8872163, 34.2546586],
              [47.8866593, 34.2552092],
              [47.8863827, 34.2554889],
              [47.874713, 34.2635483],
              [47.8522132, 34.2746581],
              [47.8483233, 34.2785479],
              [47.8477697, 34.279658],
              [47.8472131, 34.2799378],
              [47.8461033, 34.2824377],
              [47.8461034, 34.283268],
              [47.8391566, 34.2991068],
              [47.8391566, 34.2996573],
              [47.8380464, 34.3038268],
              [47.8330467, 34.3188262],
              [47.8280466, 34.3238259],
              [47.8091571, 34.3335455],
              [47.8049901, 34.3346556],
              [47.7966536, 34.3366049],
              [47.784987, 34.3407652],
              [47.780544, 34.3429944],
              [47.7660971, 34.3532645],
              [47.7658206, 34.3535442],
              [47.7652639, 34.3535442],
              [47.7630409, 34.354934],
              [47.7619306, 34.3554935],
              [47.7319312, 34.3727124],
              [47.7308178, 34.3727124],
              [47.7291511, 34.3732719],
              [47.7280412, 34.3732719],
              [47.7252611, 34.3741021],
              [47.7238743, 34.3741021],
              [47.7085947, 34.3777119],
              [47.7052614, 34.3777119],
              [47.7047048, 34.3779917],
              [47.7016512, 34.3779917],
              [47.7010946, 34.3782714],
              [47.7002613, 34.3782714],
              [47.6999847, 34.3779916],
              [47.6969281, 34.3766019],
              [47.6952616, 34.3754918],
              [47.6949846, 34.3752121],
              [47.6930381, 34.3735515],
              [47.6927616, 34.3732718],
              [47.6799817, 34.359383],
              [47.6791485, 34.3560528],
              [47.6788719, 34.3510532],
              [47.6791485, 34.3493836],
              [47.6794286, 34.3477141],
              [47.6797052, 34.3463243],
              [47.6805385, 34.3424346],
              [47.6808149, 34.3416043],
              [47.681095, 34.3402146],
              [47.683315, 34.332715],
              [47.6833151, 34.3324353],
              [47.6833151, 34.3299354],
              [47.6835952, 34.3293849],
              [47.6835952, 34.3285455],
              [47.6835951, 34.3274355],
              [47.6977616, 34.2896574],
              [47.6980385, 34.2890978],
              [47.6977616, 34.2874372],
              [47.6974851, 34.2827171],
              [47.695262, 34.2774375],
              [47.6944284, 34.2760476],
              [47.6519256, 34.237438],
              [47.6499826, 34.2354885],
              [47.6497026, 34.234938],
              [47.640536, 34.2271582],
              [47.6397028, 34.2271582],
              [47.6386088, 34.2265663],
              [47.629426, 34.2215986],
              [47.6280362, 34.2215986],
              [47.6274795, 34.2213189],
              [47.6222029, 34.2213188],
              [47.6213696, 34.2215986],
              [47.6197028, 34.2215986],
              [47.6180364, 34.2221581],
              [47.6147031, 34.2224289],
              [47.6141464, 34.2221581],
              [47.6124797, 34.2221582],
              [47.5944234, 34.2132681],
              [47.5785904, 34.1965983],
              [47.5763669, 34.1935476],
              [47.5649772, 34.1821484],
              [47.5605338, 34.180208],
              [47.559424, 34.1802079],
              [47.5577537, 34.1796574],
              [47.5552539, 34.1796574],
              [47.5541438, 34.1793776],
              [47.5524774, 34.1793776],
              [47.5513672, 34.1796573],
              [47.5474773, 34.1799281],
              [47.5291441, 34.185208],
              [47.5116706, 34.1873297],
              [47.5217055, 34.1797137],
              [47.5297735, 34.1694882],
              [47.5337218, 34.1628126],
              [47.526512, 34.1537215],
              [47.5160406, 34.1486074],
              [47.5071142, 34.1406514],
              [47.5014494, 34.1321263],
              [47.5035093, 34.1236003],
              [47.5091742, 34.1157841],
              [47.5085623, 34.104413],
              [47.503681, 34.0946057],
              [47.4935676, 34.0896517],
              [47.4820517, 34.0893458],
              [47.4692065, 34.0919711],
              [47.4489955, 34.093029],
              [47.432196, 34.0965936],
              [47.4319159, 34.0963137],
              [47.4291393, 34.0896527],
              [47.4288627, 34.0888223],
              [47.4281223, 34.0874322],
              [47.4280291, 34.0871524],
              [47.4266392, 34.0843725],
              [47.4241392, 34.0763123],
              [47.4255259, 34.0746515],
              [47.423583, 34.0682611],
              [47.4233056, 34.0660407],
              [47.423583, 34.0646507],
              [47.4263596, 34.0604807],
              [47.4324726, 34.0554893],
              [47.4327492, 34.0546499],
              [47.4349727, 34.05159],
              [47.4360825, 34.0493787],
              [47.4360825, 34.048819],
              [47.4371958, 34.046039],
              [47.4408057, 34.0410385],
              [47.4410826, 34.0404789],
              [47.4424725, 34.0388181],
              [47.4430291, 34.0382675],
              [47.4455292, 34.0352076],
              [47.4452492, 34.0310376],
              [47.4485859, 34.0265967],
              [47.4491392, 34.0265967],
              [47.4496958, 34.026037],
              [47.4583057, 34.0221467],
              [47.4596955, 34.020486],
              [47.4635855, 34.0113153],
              [47.4635856, 34.0107647],
              [47.4644192, 34.0090948],
              [47.4666423, 34.0077048],
              [47.4674755, 34.0077048],
              [47.4730287, 34.010485],
              [47.4749756, 34.006044],
              [47.4763619, 34.0043741],
              [47.4769187, 34.0043742],
              [47.4771956, 34.0040943],
              [47.478862, 34.0040943],
              [47.4791421, 34.0038145],
              [47.480809, 34.003264],
              [47.4813621, 34.0018739],
              [47.481362, 33.9999243],
              [47.4816422, 33.9927031],
              [47.4841423, 33.9888128],
              [47.4883088, 33.9846516],
              [47.4960852, 33.979651],
              [47.4980321, 33.9771508],
              [47.4983086, 33.9763113],
              [47.4985851, 33.9757608],
              [47.4983086, 33.9729806],
              [47.4974754, 33.9718703],
              [47.4924754, 33.964929],
              [47.4882605, 33.9565067],
              [47.4922253, 33.9526508],
              [47.4961221, 33.9497744],
              [47.4993836, 33.9480656],
              [47.4977185, 33.9459581],
              [47.4935471, 33.9487776],
              [47.4853074, 33.9484928],
              [47.4778568, 33.9497446],
              [47.4763886, 33.9457699],
              [47.4790056, 33.9440778],
              [47.4836423, 33.9425403],
              [47.4842774, 33.9376698],
              [47.479222, 33.9325924],
              [47.4817025, 33.929694],
              [47.4801576, 33.9282697],
              [47.4815823, 33.9250221],
              [47.4870755, 33.9234553],
              [47.4894788, 33.9203215],
              [47.4983537, 33.9150223],
              [47.5050484, 33.9071868],
              [47.5026452, 33.9046224],
              [47.4990403, 33.9034826],
              [47.4957787, 33.9010605],
              [47.4958302, 33.8990942],
              [47.5011517, 33.8970994],
              [47.5021817, 33.8941072],
              [47.5036065, 33.8907443],
              [47.5051857, 33.8884519],
              [47.5006368, 33.8856998],
              [47.5029885, 33.8785458],
              [47.5000703, 33.8751253],
              [47.4996325, 33.8714766],
              [47.5008084, 33.8627534],
              [47.504585, 33.8601876],
              [47.5063016, 33.8576217],
              [47.50407, 33.8554834],
              [47.5043618, 33.8533165],
              [47.5057855, 33.8501861],
              [47.5059319, 33.8493758],
              [47.5058181, 33.8482684],
              [47.5055579, 33.8480658],
              [47.5051838, 33.8467422],
              [47.5051838, 33.8467152],
              [47.5052326, 33.8460534],
              [47.5054115, 33.8452835],
              [47.5067578, 33.8437197],
              [47.5085477, 33.8422826],
              [47.5092005, 33.8412991],
              [47.5110219, 33.8404092],
              [47.5116786, 33.8377159],
              [47.5112007, 33.8345859],
              [47.5101274, 33.8327624],
              [47.5052668, 33.8262366],
              [47.4993133, 33.8253325],
              [47.4989777, 33.8263445],
              [47.4963802, 33.8285861],
              [47.4936216, 33.8292502],
              [47.4915048, 33.8290254],
              [47.4901579, 33.8292502],
              [47.4846614, 33.8294123],
              [47.4840071, 33.8297313],
              [47.4834048, 33.8299104],
              [47.4829864, 33.8300201],
              [47.4823957, 33.8300793],
              [47.4819212, 33.8300414],
              [47.4811712, 33.8298749],
              [47.4802869, 33.8295744],
              [47.4800267, 33.8283991],
              [47.4799617, 33.82744],
              [47.4798966, 33.8264403],
              [47.4793437, 33.8258729],
              [47.4782216, 33.8252245],
              [47.4768069, 33.8242653],
              [47.4763027, 33.8238735],
              [47.4752945, 33.8227252],
              [47.4750994, 33.8221578],
              [47.4743513, 33.8214823],
              [47.4728227, 33.8209013],
              [47.4719446, 33.8201448],
              [47.4713429, 33.8193612],
              [47.4706761, 33.8179831],
              [47.468741, 33.8171184],
              [47.4672286, 33.8159565],
              [47.4668383, 33.8145244],
              [47.466692, 33.8136596],
              [47.4661879, 33.8129976],
              [47.4658138, 33.8125382],
              [47.4649845, 33.8118897],
              [47.4640738, 33.8115654],
              [47.4631306, 33.8114303],
              [47.46061, 33.8107412],
              [47.459179, 33.810498],
              [47.4585448, 33.8103628],
              [47.4569023, 33.8101196],
              [47.4552761, 33.8086468],
              [47.455081, 33.8083901],
              [47.4545606, 33.8073497],
              [47.4550485, 33.8064173],
              [47.4556176, 33.8061336],
              [47.4562031, 33.8046607],
              [47.4575691, 33.801796],
              [47.4579431, 33.8009582],
              [47.4573577, 33.7991203],
              [47.4562031, 33.7974447],
              [47.4549997, 33.7967419],
              [47.4536825, 33.7954446],
              [47.4519912, 33.7935661],
              [47.4515684, 33.7927012],
              [47.4515522, 33.7917822],
              [47.4513408, 33.7906064],
              [47.4515522, 33.7892819],
              [47.4514871, 33.7884575],
              [47.4507553, 33.7872952],
              [47.4497634, 33.7861599],
              [47.4485112, 33.7854571],
              [47.4471289, 33.7856598],
              [47.4453401, 33.7867681],
              [47.4433237, 33.7881061],
              [47.4421203, 33.7886738],
              [47.4414048, 33.7888495],
              [47.4407706, 33.7886738],
              [47.4403477, 33.788025],
              [47.4411446, 33.7874844],
              [47.4414048, 33.7869438],
              [47.4416812, 33.7859572],
              [47.4417951, 33.784511],
              [47.4427708, 33.7833081],
              [47.4436001, 33.7826728],
              [47.4477144, 33.7784963],
              [47.4483811, 33.7774825],
              [47.4483323, 33.7768202],
              [47.4471127, 33.7761308],
              [47.446511, 33.7757523],
              [47.4455028, 33.7741437],
              [47.4452588, 33.7726839],
              [47.4444457, 33.7717782],
              [47.4440229, 33.771251],
              [47.4435676, 33.7705886],
              [47.4418601, 33.7700208],
              [47.4407055, 33.7698316],
              [47.4392907, 33.7692638],
              [47.4373393, 33.7681688],
              [47.4362498, 33.7678444],
              [47.4322331, 33.7696018],
              [47.4311273, 33.7700479],
              [47.430363, 33.7703858],
              [47.4292734, 33.7704264],
              [47.4282814, 33.7703993],
              [47.426704, 33.7701966],
              [47.42633, 33.7699127],
              [47.4259072, 33.7695612],
              [47.4255657, 33.768669],
              [47.4246062, 33.7676551],
              [47.4232403, 33.766817],
              [47.4226386, 33.7658166],
              [47.4228988, 33.7647351],
              [47.4253868, 33.7624233],
              [47.425273, 33.7617068],
              [47.4243623, 33.7608551],
              [47.4238094, 33.7593409],
              [47.4236468, 33.7581376],
              [47.4232565, 33.7551632],
              [47.4220857, 33.755055],
              [47.4206546, 33.7549468],
              [47.4196139, 33.7548657],
              [47.4178088, 33.7542708],
              [47.4143938, 33.7511069],
              [47.4134018, 33.7507959],
              [47.4128652, 33.7502145],
              [47.4123285, 33.749552],
              [47.4118732, 33.7480241],
              [47.4120683, 33.7465908],
              [47.4107837, 33.7437376],
              [47.4097429, 33.7406274],
              [47.4076939, 33.7392887],
              [47.4063442, 33.739451],
              [47.4048318, 33.7397079],
              [47.4039211, 33.739167],
              [47.4033195, 33.7385855],
              [47.4000183, 33.7368951],
              [47.3974814, 33.7363271],
              [47.3938713, 33.7363406],
              [47.3929281, 33.7365435],
              [47.3907002, 33.7367058],
              [47.3882447, 33.7367193],
              [47.3870413, 33.7370438],
              [47.3825368, 33.7381257],
              [47.3802113, 33.7386531],
              [47.3778859, 33.7387748],
              [47.3753816, 33.7383556],
              [47.3742757, 33.738031],
              [47.3734952, 33.7375577],
              [47.3732675, 33.7369898],
              [47.3729748, 33.7358944],
              [47.3728284, 33.7352858],
              [47.3722105, 33.7353805],
              [47.3706006, 33.735989],
              [47.3693972, 33.7358944],
              [47.3680312, 33.7359485],
              [47.3666652, 33.7358808],
              [47.3650553, 33.7353669],
              [47.3635104, 33.7341228],
              [47.3619005, 33.733406],
              [47.360632, 33.732838],
              [47.3588432, 33.7325675],
              [47.3574772, 33.7323106],
              [47.3550542, 33.7321077],
              [47.3521433, 33.7330679],
              [47.3512815, 33.7344879],
              [47.3511126, 33.7354766],
              [47.3500456, 33.7367869],
              [47.3490536, 33.7382068],
              [47.3476225, 33.7388019],
              [47.346842, 33.7378958],
              [47.3452971, 33.7367193],
              [47.3434595, 33.7348666],
              [47.3425326, 33.7344068],
              [47.3402722, 33.734285],
              [47.3384996, 33.734231],
              [47.3372149, 33.7340281],
              [47.3362067, 33.733095],
              [47.3343041, 33.7319319],
              [47.3324014, 33.7317425],
              [47.3309704, 33.7313503],
              [47.3294743, 33.7306877],
              [47.3275066, 33.7309176],
              [47.326287, 33.7315532],
              [47.3257178, 33.73227],
              [47.3250023, 33.7330273],
              [47.3243681, 33.7338658],
              [47.3235062, 33.734231],
              [47.3223353, 33.7345285],
              [47.3207742, 33.7341498],
              [47.3199611, 33.7337982],
              [47.3192781, 33.7330003],
              [47.3184813, 33.7323376],
              [47.3177169, 33.732013],
              [47.3166924, 33.7317155],
              [47.3160745, 33.731702],
              [47.314985, 33.7312422],
              [47.3138466, 33.7307012],
              [47.3124644, 33.7297815],
              [47.3107731, 33.7284155],
              [47.3095372, 33.7274418],
              [47.3091607, 33.7270931],
              [47.3088217, 33.726779],
              [47.3080737, 33.7262245],
              [47.3071467, 33.7258864],
              [47.3060734, 33.725697],
              [47.3053904, 33.7259135],
              [47.3041708, 33.7266303],
              [47.3028536, 33.7279692],
              [47.302382, 33.7290647],
              [47.3014876, 33.7301873],
              [47.2999265, 33.7306877],
              [47.2947714, 33.732581],
              [47.293503, 33.7329327],
              [47.291828, 33.7330814],
              [47.2891286, 33.7326487],
              [47.2860226, 33.7330138],
              [47.2834694, 33.7331355],
              [47.2815018, 33.7328245],
              [47.2789974, 33.7319995],
              [47.2771924, 33.7317155],
              [47.2761841, 33.7321212],
              [47.2754361, 33.7327569],
              [47.2750783, 33.7336359],
              [47.2750458, 33.7347043],
              [47.2753873, 33.7350153],
              [47.2758751, 33.7354346],
              [47.276298, 33.7357997],
              [47.2764118, 33.7367463],
              [47.2761679, 33.7376659],
              [47.2754198, 33.7392616],
              [47.2743303, 33.7402894],
              [47.2733871, 33.7409114],
              [47.2724602, 33.7407221],
              [47.2718422, 33.7401406],
              [47.270525, 33.7401271],
              [47.2695981, 33.7403705],
              [47.2687947, 33.7408996],
              [47.2683557, 33.7414119],
              [47.267917, 33.7419238],
              [47.2670959, 33.7428302],
              [47.2665721, 33.7435248],
              [47.2655386, 33.7436778],
              [47.2644627, 33.7441487],
              [47.263132, 33.7449727],
              [47.2623109, 33.7458438],
              [47.2620419, 33.7466913],
              [47.2617305, 33.747327],
              [47.2608952, 33.7480568],
              [47.2593521, 33.7485394],
              [47.2574268, 33.7488102],
              [47.2554165, 33.7489161],
              [47.2525427, 33.7481039],
              [47.249315, 33.7468444],
              [47.2477719, 33.7463617],
              [47.2471206, 33.7460439],
              [47.245252, 33.7449138],
              [47.2440345, 33.7443959],
              [47.2426613, 33.7417708],
              [47.2427604, 33.7400638],
              [47.2428878, 33.7381684],
              [47.2429302, 33.7358728],
              [47.2431284, 33.7348367],
              [47.2434399, 33.7330825],
              [47.2435956, 33.7314931],
              [47.2428311, 33.7306925],
              [47.2420101, 33.730669],
              [47.2408067, 33.7306454],
              [47.2388814, 33.7303511],
              [47.2377772, 33.7302451],
              [47.2358094, 33.7303511],
              [47.2331196, 33.7311399],
              [47.2305572, 33.7320465],
              [47.2282497, 33.7327411],
              [47.2272021, 33.7328118],
              [47.2268481, 33.732329],
              [47.226565, 33.7315167],
              [47.2254891, 33.7309986],
              [47.2240168, 33.7303393],
              [47.2217517, 33.729315],
              [47.2200246, 33.7288794],
              [47.2185947, 33.7286204],
              [47.2168534, 33.7274783],
              [47.2151122, 33.7250293],
              [47.2146875, 33.72384],
              [47.21456, 33.7233808],
              [47.2141353, 33.7225095],
              [47.2135832, 33.7218266],
              [47.2120826, 33.7209435],
              [47.2102847, 33.7201663],
              [47.2095061, 33.7199073],
              [47.2086991, 33.7195069],
              [47.2075949, 33.7199426],
              [47.206519, 33.7201545],
              [47.2049051, 33.7203312],
              [47.203447, 33.720131],
              [47.2015075, 33.719919],
              [47.2002617, 33.7197424],
              [47.198931, 33.7198484],
              [47.1980815, 33.7203312],
              [47.1965526, 33.7211319],
              [47.1950803, 33.7219443],
              [47.1940469, 33.7228274],
              [47.1919233, 33.72384],
              [47.1899839, 33.7248526],
              [47.1882426, 33.7254531],
              [47.1865155, 33.7255473],
              [47.1841796, 33.7255591],
              [47.182594, 33.7259476],
              [47.1814049, 33.7254178],
              [47.1812916, 33.7239225],
              [47.1807395, 33.7236163],
              [47.1801449, 33.7232513],
              [47.1787717, 33.7225919],
              [47.1775967, 33.7221327],
              [47.1766057, 33.7217677],
              [47.1761102, 33.7215204],
              [47.1746662, 33.720025],
              [47.1737036, 33.7187886],
              [47.1730948, 33.7172578],
              [47.1734629, 33.7163511],
              [47.1736611, 33.7160685],
              [47.1739725, 33.7143728],
              [47.1734346, 33.7135956],
              [47.1723587, 33.7133247],
              [47.1708439, 33.7129832],
              [47.1688903, 33.7116408],
              [47.1675737, 33.7106398],
              [47.165889, 33.7105927],
              [47.1650962, 33.7105573],
              [47.1635248, 33.7103218],
              [47.1618119, 33.7098743],
              [47.1601414, 33.709521],
              [47.1589664, 33.7091324],
              [47.1587257, 33.708414],
              [47.1583576, 33.707731],
              [47.157494, 33.7073306],
              [47.1571118, 33.7068006],
              [47.156319, 33.7063766],
              [47.1555121, 33.7062],
              [47.1545494, 33.7070008],
              [47.153785, 33.7077545],
              [47.1522844, 33.7075072],
              [47.1509395, 33.707201],
              [47.1498352, 33.7076485],
              [47.1487168, 33.7082138],
              [47.1472445, 33.7082138],
              [47.1461262, 33.708838],
              [47.1440451, 33.7096859],
              [47.1429833, 33.7096152],
              [47.1419357, 33.7095799],
              [47.1405342, 33.7093326],
              [47.1391327, 33.7084022],
              [47.1384673, 33.7076132],
              [47.1378727, 33.7069773],
              [47.1370233, 33.7066475],
              [47.1361456, 33.7065768],
              [47.1344043, 33.7062942],
              [47.1329037, 33.7059291],
              [47.13221, 33.705882],
              [47.1311341, 33.7066004],
              [47.1307094, 33.7070244],
              [47.1298175, 33.7071775],
              [47.1286425, 33.7068595],
              [47.1276091, 33.7061647],
              [47.1273967, 33.7053167],
              [47.1262642, 33.7042097],
              [47.1243813, 33.703715],
              [47.1232346, 33.7035266],
              [47.1218897, 33.7034677],
              [47.1190442, 33.7035737],
              [47.1174162, 33.7034677],
              [47.1167225, 33.7033146],
              [47.1144008, 33.7031026],
              [47.1116402, 33.7025844],
              [47.1104511, 33.7033735],
              [47.1096583, 33.7045747],
              [47.1092244, 33.705805],
              [47.1074518, 33.706292],
              [47.1059557, 33.7064814],
              [47.1040368, 33.706062],
              [47.1029473, 33.7065626],
              [47.0997762, 33.7075095],
              [47.0981012, 33.7086729],
              [47.0963124, 33.7100392],
              [47.0956578, 33.7099568],
              [47.0943773, 33.7097957],
              [47.0937593, 33.7082265],
              [47.0934178, 33.7067249],
              [47.0935642, 33.7051962],
              [47.0927836, 33.7040598],
              [47.0916128, 33.7036134],
              [47.0906208, 33.7020441],
              [47.0889946, 33.7012188],
              [47.0872383, 33.70061],
              [47.0849779, 33.7009888],
              [47.0821853, 33.7024496],
              [47.0807874, 33.7029999],
              [47.0799022, 33.7033309],
              [47.0787333, 33.7034711],
              [47.0773205, 33.7046519],
              [47.0752378, 33.7061898],
              [47.0739314, 33.7077071],
              [47.0719965, 33.7094705],
              [47.0700493, 33.7112543],
              [47.0686073, 33.7116337],
              [47.0672886, 33.7108033],
              [47.0652305, 33.7090092],
              [47.0656988, 33.7084556],
              [47.065514, 33.7073483],
              [47.0643185, 33.7058822],
              [47.0629136, 33.7047852],
              [47.0615579, 33.7035959],
              [47.0599188, 33.7019247],
              [47.0595491, 33.7004072],
              [47.0595737, 33.6993101],
              [47.0601849, 33.6982814],
              [47.0638756, 33.6956214],
              [47.0692401, 33.6938004],
              [47.0712571, 33.6924971],
              [47.0714717, 33.6912831],
              [47.0701627, 33.6895155],
              [47.067502, 33.6888549],
              [47.0656137, 33.6891406],
              [47.0641975, 33.6883729],
              [47.0631246, 33.6870695],
              [47.0626526, 33.684677],
              [47.0601849, 33.6826058],
              [47.0583713, 33.6820961],
              [47.0571728, 33.6817108],
              [47.0563449, 33.6814654],
              [47.056108, 33.6808336],
              [47.0559792, 33.6798917],
              [47.0561509, 33.6782132],
              [47.0549278, 33.6760347],
              [47.0541768, 33.6728026],
              [47.0551424, 33.671749],
              [47.0589189, 33.6715704],
              [47.0606785, 33.6718383],
              [47.0609359, 33.6705168],
              [47.0602278, 33.6683738],
              [47.0582537, 33.6678023],
              [47.0536832, 33.6682131],
              [47.0495634, 33.6685345],
              [47.0472889, 33.6679988],
              [47.0444779, 33.6672309],
              [47.0441131, 33.6663558],
              [47.0447998, 33.6644449],
              [47.044199, 33.6634448],
              [47.04392, 33.6626589],
              [47.0439629, 33.6618374],
              [47.0432334, 33.6603193],
              [47.0439844, 33.6585512],
              [47.0443706, 33.6568723],
              [47.0443706, 33.6556756],
              [47.0432334, 33.6551755],
              [47.0419459, 33.6550504],
              [47.0402078, 33.6552826],
              [47.0381479, 33.6549611],
              [47.0379237, 33.6546522],
              [47.0375256, 33.6541038],
              [47.0377831, 33.6526034],
              [47.0367531, 33.6513888],
              [47.0348863, 33.6506386],
              [47.0319681, 33.6493526],
              [47.0311098, 33.6480665],
              [47.0302086, 33.6473698],
              [47.0281057, 33.6461909],
              [47.0277624, 33.645655],
              [47.0269899, 33.6439758],
              [47.0260458, 33.6397957],
              [47.0243721, 33.633936],
              [47.0234279, 33.6318814],
              [47.0214538, 33.6317564],
              [47.020617, 33.6305057],
              [47.0200805, 33.6283082],
              [47.0206384, 33.625378],
              [47.0215826, 33.6242702],
              [47.0220976, 33.620911],
              [47.0235996, 33.6195531],
              [47.0265178, 33.6179091],
              [47.0281272, 33.6169442],
              [47.0291571, 33.6154075],
              [47.0284276, 33.6136384],
              [47.0275263, 33.6120301],
              [47.026947, 33.6105647],
              [47.0248871, 33.607902],
              [47.0246081, 33.6068476],
              [47.0264964, 33.6049533],
              [47.0269899, 33.6035235],
              [47.028213, 33.6013253],
              [47.0293502, 33.5971967],
              [47.030466, 33.5941761],
              [47.0312171, 33.5928534],
              [47.0338134, 33.5906727],
              [47.0348207, 33.5904124],
              [47.0361738, 33.589636],
              [47.037203, 33.5886828],
              [47.0373983, 33.5879007],
              [47.0369463, 33.5872765],
              [47.0364084, 33.586384],
              [47.0360021, 33.5854353],
              [47.0348626, 33.5857417],
              [47.031775, 33.5881345],
              [47.0298652, 33.5893679],
              [47.0284061, 33.5901186],
              [47.0266037, 33.5911553],
              [47.0245008, 33.5928355],
              [47.0219259, 33.5945335],
              [47.0205795, 33.5947367],
              [47.0197339, 33.5944116],
              [47.018498, 33.5938021],
              [47.0171645, 33.5933821],
              [47.0157172, 33.5933144],
              [47.0142211, 33.5932331],
              [47.0113265, 33.5939375],
              [47.0091637, 33.5945877],
              [47.0074887, 33.5947232],
              [47.0018621, 33.5938427],
              [47.0006262, 33.5930435],
              [46.9992765, 33.5918921],
              [46.9988049, 33.5904291],
              [46.9985935, 33.5884919],
              [46.998317, 33.587801],
              [46.9974064, 33.5862296],
              [46.9968209, 33.5850104],
              [46.9963299, 33.5847906],
              [46.9957314, 33.5845227],
              [46.9939914, 33.5847801],
              [46.9921375, 33.5854845],
              [46.9897145, 33.5862296],
              [46.9873403, 33.587503],
              [46.9857303, 33.5885055],
              [46.9820226, 33.5908761],
              [46.979811, 33.5928267],
              [46.9788353, 33.5938969],
              [46.9777624, 33.5952956],
              [46.9766359, 33.5972885],
              [46.9767324, 33.5988613],
              [46.9775908, 33.6001303],
              [46.9786958, 33.6008452],
              [46.979125, 33.6014171],
              [46.9779233, 33.6034366],
              [46.9769685, 33.6041604],
              [46.9757454, 33.6049915],
              [46.9746403, 33.6055455],
              [46.9740181, 33.6059476],
              [46.9733207, 33.6063944],
              [46.9714109, 33.6071092],
              [46.9700269, 33.6078866],
              [46.9692759, 33.6083602],
              [46.9680314, 33.6086819],
              [46.9671731, 33.6089052],
              [46.9661216, 33.6088695],
              [46.9648878, 33.6091822],
              [46.9638793, 33.6093341],
              [46.9627313, 33.6096022],
              [46.9614868, 33.6098256],
              [46.9602637, 33.6099149],
              [46.9590406, 33.6099685],
              [46.9576566, 33.6102634],
              [46.9562511, 33.6109246],
              [46.9552748, 33.6115858],
              [46.9542341, 33.6121487],
              [46.9537513, 33.6129261],
              [46.9537513, 33.6135962],
              [46.9536655, 33.6144361],
              [46.9536762, 33.6152938],
              [46.9535903, 33.6162587],
              [46.9534616, 33.617045],
              [46.9529573, 33.6177329],
              [46.9520669, 33.6182332],
              [46.9511549, 33.6184209],
              [46.94961, 33.618805],
              [46.9485049, 33.6187872],
              [46.9468634, 33.6191267],
              [46.9453506, 33.6196359],
              [46.9449322, 33.6199308],
              [46.9440202, 33.6203953],
              [46.942722, 33.6212352],
              [46.9410162, 33.6220928],
              [46.9390528, 33.6228165],
              [46.9377546, 33.6233078],
              [46.9362525, 33.6235044],
              [46.9340639, 33.6228075],
              [46.9324653, 33.6218963],
              [46.930813, 33.6211726],
              [46.9294505, 33.6207348],
              [46.9276909, 33.6203328],
              [46.9265537, 33.620172],
              [46.9246225, 33.6204758],
              [46.9234316, 33.6204489],
              [46.9228522, 33.6203328],
              [46.9220261, 33.6203596],
              [46.9211785, 33.6208421],
              [46.9194083, 33.6210207],
              [46.9178419, 33.6213424],
              [46.9173376, 33.621253],
              [46.9163613, 33.6213156],
              [46.9158785, 33.6211458],
              [46.9151811, 33.62044],
              [46.9146232, 33.6201184],
              [46.913722, 33.6193947],
              [46.912853, 33.61868],
              [46.9106321, 33.6168841],
              [46.9093661, 33.6157227],
              [46.9081323, 33.6151687],
              [46.9068985, 33.6149364],
              [46.9057612, 33.6147845],
              [46.9048063, 33.6148739],
              [46.9035081, 33.6149275],
              [46.9022958, 33.6153385],
              [46.9014267, 33.6157852],
              [46.9000105, 33.6164106],
              [46.8987875, 33.6167948],
              [46.8975536, 33.6171879],
              [46.8961696, 33.6177151],
              [46.8946139, 33.6184298],
              [46.8932728, 33.6190552],
              [46.8912129, 33.6195913],
              [46.8869428, 33.6203596],
              [46.8849156, 33.6207764],
              [46.8815628, 33.6208711],
              [46.8788919, 33.6199247],
              [46.8761641, 33.6194514],
              [46.8731523, 33.6189309],
              [46.8713906, 33.6179844],
              [46.8696289, 33.6168013],
              [46.8671285, 33.6160915],
              [46.8648554, 33.6152396],
              [46.8618436, 33.6140565],
              [46.8589453, 33.6134886],
              [46.8562176, 33.6130154],
              [46.8534899, 33.6129207],
              [46.8508758, 33.6120688],
              [46.8472957, 33.6115482],
              [46.8468428, 33.6116825],
              [46.8457917, 33.61145],
              [46.8460074, 33.6103239],
              [46.8466501, 33.6098086],
              [46.8487164, 33.6082353],
              [46.8512168, 33.6061055],
              [46.853774, 33.604023],
              [46.8553652, 33.6020351],
              [46.8572973, 33.5993371],
              [46.8592295, 33.5967337],
              [46.8612185, 33.5949823],
              [46.8625823, 33.5933256],
              [46.862696, 33.5920001],
              [46.8615026, 33.5913847],
              [46.8608775, 33.5915268],
              [46.8604797, 33.590722],
              [46.8593431, 33.5896806],
              [46.8596273, 33.5886865],
              [46.8604797, 33.5872663],
              [46.8610735, 33.5864971],
              [46.8615959, 33.585359],
              [46.8627612, 33.5845556],
              [46.8636854, 33.5839865],
              [46.8647301, 33.5829822],
              [46.8650114, 33.5822792],
              [46.8646096, 33.5812414],
              [46.86469, 33.579668],
              [46.8650114, 33.5785967],
              [46.86469, 33.5768893],
              [46.8632434, 33.5757845],
              [46.8616762, 33.5746463],
              [46.8597072, 33.5739432],
              [46.8572159, 33.5737423],
              [46.8554076, 33.5739767],
              [46.853961, 33.5752489],
              [46.8515099, 33.5756506],
              [46.8494605, 33.5756171],
              [46.847813, 33.5750145],
              [46.8458038, 33.5746463],
              [46.8441965, 33.5747467],
              [46.8431919, 33.5745123],
              [46.8420668, 33.5737423],
              [46.8415846, 33.5732736],
              [46.8406286, 33.5727304],
              [46.839492, 33.5719729],
              [46.8390942, 33.5708128],
              [46.8379861, 33.569345],
              [46.8375315, 33.5680665],
              [46.8380429, 33.5667881],
              [46.8388669, 33.5657227],
              [46.8398046, 33.5643494],
              [46.8402308, 33.5629999],
              [46.8405149, 33.5614609],
              [46.8406854, 33.5600876],
              [46.8406002, 33.5590221],
              [46.8404976, 33.5576479],
              [46.8404692, 33.5567954],
              [46.8400714, 33.5555168],
              [46.8394747, 33.5546407],
              [46.8386223, 33.5537646],
              [46.8383665, 33.552699],
              [46.8385176, 33.5519856]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 229958,
        "tags": {
          "ISO3166-2": "IR-00",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "مرکزی",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q134417"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [48.9628205, 33.9054832],
              [48.9633771, 33.9052033],
              [48.9642103, 33.9049325],
              [48.9664338, 33.9049325],
              [48.9678201, 33.9054832],
              [48.9803235, 33.9127135],
              [48.9822669, 33.9129844],
              [48.9828236, 33.9127136],
              [48.9839333, 33.9127136],
              [48.9842098, 33.9124247],
              [48.9936566, 33.9099334],
              [48.9942132, 33.9102042],
              [48.9950465, 33.9102041],
              [48.9953235, 33.910484],
              [48.9964333, 33.910484],
              [48.9967133, 33.9107638],
              [48.9980996, 33.9107638],
              [48.9998178, 33.9113236],
              [49.0003231, 33.9115943],
              [49.0011564, 33.9115943],
              [49.0028232, 33.9121539],
              [49.0097663, 33.9090939],
              [49.0117132, 33.9071532],
              [49.0122663, 33.9060429],
              [49.0114331, 33.9015927],
              [48.99949, 33.8952017],
              [48.9947664, 33.8927104],
              [48.9936567, 33.8904809],
              [48.9939332, 33.89021],
              [48.9939332, 33.8893705],
              [48.9947664, 33.8882603],
              [48.9972665, 33.8827088],
              [48.9975466, 33.8799286],
              [48.9978232, 33.8790981],
              [49.0055999, 33.8710372],
              [49.0064331, 33.8693762],
              [49.0061565, 33.8674265],
              [49.0061566, 33.8671466],
              [49.0044898, 33.8660364],
              [49.0011565, 33.8660363],
              [49.0000467, 33.8665959],
              [48.9980997, 33.866596],
              [48.9972666, 33.866596],
              [48.9758772, 33.8413116],
              [48.9758771, 33.8396507],
              [48.9781003, 33.8374301],
              [48.9789334, 33.8371502],
              [48.9803237, 33.8371502],
              [48.9803237, 33.8368704],
              [48.98171, 33.8368704],
              [48.9856003, 33.8365906],
              [48.9858769, 33.8363197],
              [48.9867101, 33.8363197],
              [48.9869903, 33.8360399],
              [48.9875433, 33.8360399],
              [48.9878235, 33.8357601],
              [48.988377, 33.8357601],
              [48.9886567, 33.8354802],
              [48.9914333, 33.83437],
              [48.9919899, 33.8335394],
              [48.9931002, 33.8324292],
              [48.9931002, 33.8318695],
              [48.9939334, 33.8299286],
              [48.9936569, 33.8260381],
              [48.9942135, 33.8218676],
              [48.9928236, 33.8149258],
              [48.9847669, 33.807984],
              [48.9847668, 33.8077042],
              [48.9853613, 33.7998151],
              [48.9856146, 33.7959794],
              [48.9856741, 33.7896331],
              [48.9860402, 33.7836164],
              [48.9883877, 33.7796479],
              [48.9919097, 33.7779001],
              [48.9965862, 33.7726863],
              [49.0002192, 33.769686],
              [49.0001762, 33.7687072],
              [49.005448, 33.7630671],
              [49.0054169, 33.7598866],
              [49.0052032, 33.7533179],
              [49.0088939, 33.7504634],
              [49.0064906, 33.7497497],
              [49.0096664, 33.7476087],
              [49.0100955, 33.744183],
              [49.0078427, 33.7406382],
              [49.0038552, 33.7361331],
              [49.005542, 33.7303133],
              [49.008364, 33.7224282],
              [49.012928, 33.7153802],
              [49.0140008, 33.7110607],
              [49.0144224, 33.7068628],
              [49.0156037, 33.7018688],
              [49.0158803, 33.7007585],
              [49.0161568, 33.7004786],
              [49.0167135, 33.6990884],
              [49.0211569, 33.696317],
              [49.0219901, 33.6963169],
              [49.02338, 33.6957573],
              [49.0258801, 33.6957572],
              [49.0261566, 33.6954775],
              [49.0300466, 33.6954775],
              [49.0325466, 33.696317],
              [49.0342134, 33.6971476],
              [49.0422698, 33.7026994],
              [49.0431031, 33.7026994],
              [49.0433796, 33.7029792],
              [49.0442132, 33.7029793],
              [49.0442133, 33.7032591],
              [49.0458797, 33.7032592],
              [49.0461597, 33.703539],
              [49.049213, 33.703539],
              [49.0497696, 33.7032591],
              [49.0508833, 33.7032591],
              [49.0528263, 33.7024286],
              [49.0650496, 33.6913159],
              [49.0658829, 33.6907562],
              [49.0694927, 33.6888152],
              [49.0703263, 33.6888153],
              [49.0708829, 33.689366],
              [49.0736596, 33.7007586],
              [49.075606, 33.7179829],
              [49.0825491, 33.7199238],
              [49.0850492, 33.7199237],
              [49.0856058, 33.7199238],
              [49.0858824, 33.7196439],
              [49.0894958, 33.7185336],
              [49.0944959, 33.7168635],
              [49.0961624, 33.7165927],
              [49.1011624, 33.7168636],
              [49.101439, 33.7171524],
              [49.107829, 33.7199238],
              [49.1086621, 33.7199238],
              [49.1089391, 33.7202037],
              [49.1114388, 33.7202036],
              [49.1117189, 33.7199238],
              [49.112552, 33.7196439],
              [49.1186624, 33.7154823],
              [49.1194956, 33.7154823],
              [49.1200522, 33.7152026],
              [49.1211621, 33.7152025],
              [49.123662, 33.7152025],
              [49.1244953, 33.7157532],
              [49.1253289, 33.7157532],
              [49.1256055, 33.716033],
              [49.1281086, 33.7168636],
              [49.1283852, 33.7171524],
              [49.1294954, 33.7179829],
              [49.1300521, 33.7182628],
              [49.1383854, 33.7215939],
              [49.1417187, 33.7215939],
              [49.1467184, 33.7182628],
              [49.1669981, 33.7046495],
              [49.1697747, 33.7040898],
              [49.1706084, 33.7040899],
              [49.1797746, 33.702149],
              [49.1842215, 33.6993685],
              [49.1853313, 33.6976984],
              [49.1856114, 33.6965881],
              [49.1950546, 33.6863149],
              [49.194778, 33.6785332],
              [49.1950546, 33.6777026],
              [49.1950547, 33.6774228],
              [49.1956112, 33.6768721],
              [49.1956113, 33.6763125],
              [49.1961644, 33.6760326],
              [49.1989445, 33.6715911],
              [49.1997778, 33.6665898],
              [49.2000547, 33.6640891],
              [49.2011645, 33.6596476],
              [49.2014446, 33.6588171],
              [49.2020014, 33.657147],
              [49.2047779, 33.6524255],
              [49.2064444, 33.6513151],
              [49.2083877, 33.6468736],
              [49.2086678, 33.6463139],
              [49.2083878, 33.6443639],
              [49.2045014, 33.6301995],
              [49.2042213, 33.6265885],
              [49.2045015, 33.6251983],
              [49.2053347, 33.6243677],
              [49.211168, 33.6207566],
              [49.2120011, 33.6182559],
              [49.2156111, 33.6129748],
              [49.2167212, 33.6127039],
              [49.2172779, 33.6127039],
              [49.2181111, 33.6124241],
              [49.2192213, 33.6124241],
              [49.2195009, 33.6121442],
              [49.2228346, 33.6121442],
              [49.2392244, 33.6168657],
              [49.2403342, 33.6168658],
              [49.2408908, 33.6171455],
              [49.2467242, 33.6171456],
              [49.2517239, 33.6152046],
              [49.2522809, 33.614645],
              [49.2528341, 33.6146449],
              [49.2531141, 33.6143651],
              [49.2536673, 33.6143651],
              [49.2556142, 33.6135345],
              [49.256724, 33.6135346],
              [49.2572807, 33.6132546],
              [49.2581138, 33.6132547],
              [49.2586705, 33.6129749],
              [49.265614, 33.610754],
              [49.2667238, 33.6104832],
              [49.2808936, 33.6040916],
              [49.2842269, 33.6040916],
              [49.2850605, 33.6043715],
              [49.287366, 33.6072273],
              [49.2875602, 33.6077026],
              [49.2878371, 33.6079825],
              [49.2881137, 33.6088131],
              [49.2886704, 33.6121443],
              [49.2989502, 33.6365913],
              [49.2953367, 33.6402023],
              [49.2947802, 33.6421433],
              [49.2945036, 33.6424232],
              [49.29645, 33.6502049],
              [49.2970032, 33.6504758],
              [49.3020033, 33.6535361],
              [49.3028365, 33.6535361],
              [49.3031166, 33.653816],
              [49.3061697, 33.6546466],
              [49.3145032, 33.6588173],
              [49.3156165, 33.6590881],
              [49.3217263, 33.6568673],
              [49.3228397, 33.6551972],
              [49.3236729, 33.6540868],
              [49.3281164, 33.6507556],
              [49.3289495, 33.6507557],
              [49.3295062, 33.6504758],
              [49.3342297, 33.6504758],
              [49.3350629, 33.6507556],
              [49.337283, 33.6507557],
              [49.3378396, 33.6510355],
              [49.3439495, 33.6510356],
              [49.3445061, 33.6513154],
              [49.3464495, 33.6513154],
              [49.3467295, 33.6515953],
              [49.3514492, 33.6529765],
              [49.3561728, 33.6571472],
              [49.3578392, 33.661309],
              [49.3567294, 33.6643693],
              [49.3561726, 33.6657595],
              [49.3545059, 33.6699212],
              [49.3556192, 33.6768725],
              [49.3586724, 33.6802036],
              [49.3659554, 33.6851749],
              [49.3664883, 33.6862105],
              [49.3665489, 33.6878415],
              [49.3693726, 33.6937849],
              [49.3685922, 33.7005188],
              [49.3682047, 33.7036664],
              [49.3737363, 33.7165953],
              [49.3799384, 33.7248107],
              [49.3869267, 33.7285375],
              [49.3938925, 33.7295897],
              [49.4089428, 33.7248783],
              [49.412384, 33.7206275],
              [49.4158172, 33.7168794],
              [49.4195509, 33.7100433],
              [49.4227052, 33.7047685],
              [49.4229948, 33.7045275],
              [49.4223082, 33.7035011],
              [49.4220185, 33.7007073],
              [49.4219276, 33.6966061],
              [49.4283914, 33.6982795],
              [49.4350433, 33.6998862],
              [49.4380045, 33.700386],
              [49.442811, 33.7004217],
              [49.4456005, 33.7007431],
              [49.4495058, 33.7011715],
              [49.4558572, 33.7014571],
              [49.46002, 33.7022426],
              [49.4704485, 33.7024211],
              [49.4758987, 33.702671],
              [49.4788169, 33.7021712],
              [49.4810056, 33.7009573],
              [49.4823789, 33.6996006],
              [49.4845676, 33.6974226],
              [49.4863271, 33.6954945],
              [49.4885165, 33.6957483],
              [49.4931508, 33.692926],
              [49.4985151, 33.6895672],
              [49.5028581, 33.6869519],
              [49.5155096, 33.6869605],
              [49.5302255, 33.688034],
              [49.5367343, 33.6927419],
              [49.54106, 33.6956015],
              [49.5473006, 33.7000738],
              [49.5533609, 33.7044918],
              [49.5589089, 33.7089036],
              [49.5717086, 33.7179856],
              [49.5760542, 33.7206424],
              [49.5786994, 33.7221563],
              [49.5829994, 33.7240374],
              [49.5869701, 33.7261318],
              [49.5942597, 33.7297507],
              [49.6015974, 33.7332881],
              [49.6089219, 33.7355858],
              [49.6166452, 33.7382163],
              [49.6223717, 33.7383793],
              [49.6332958, 33.738745],
              [49.6310372, 33.7349938],
              [49.6269425, 33.72842],
              [49.6242675, 33.7239378],
              [49.6191643, 33.7143319],
              [49.616661, 33.7099184],
              [49.6115303, 33.6981536],
              [49.6096837, 33.693153],
              [49.605387, 33.6861336],
              [49.6030787, 33.6820793],
              [49.6008871, 33.6776761],
              [49.5988161, 33.6745326],
              [49.5973821, 33.6714104],
              [49.5946436, 33.6667334],
              [49.5923929, 33.6628039],
              [49.5857173, 33.6510752],
              [49.5843631, 33.6383174],
              [49.5941704, 33.6328031],
              [49.6016424, 33.6287039],
              [49.6114019, 33.6257737],
              [49.6195668, 33.6229358],
              [49.6247632, 33.618874],
              [49.6297931, 33.6146908],
              [49.6297073, 33.6116887],
              [49.6322786, 33.6039398],
              [49.6352862, 33.5975344],
              [49.6382045, 33.5928158],
              [49.639795, 33.58851],
              [49.6438292, 33.582516],
              [49.6477749, 33.5805157],
              [49.6521349, 33.5780657],
              [49.66077, 33.5723398],
              [49.6673011, 33.5708636],
              [49.6742534, 33.5702558],
              [49.6831369, 33.5712927],
              [49.6883597, 33.5735974],
              [49.6969428, 33.5733891],
              [49.7623042, 33.5263085],
              [49.7709142, 33.5176957],
              [49.7736943, 33.5138137],
              [49.7745275, 33.5129741],
              [49.7770276, 33.5093628],
              [49.7856376, 33.4938076],
              [49.7856375, 33.4935368],
              [49.7861942, 33.492977],
              [49.7861943, 33.4926971],
              [49.7864708, 33.4924173],
              [49.7864708, 33.4918666],
              [49.787304, 33.4904763],
              [49.7895275, 33.4840844],
              [49.791471, 33.4774216],
              [49.7917507, 33.476582],
              [49.7920275, 33.4752007],
              [49.7925842, 33.4738104],
              [49.7923041, 33.4693685],
              [49.7920276, 33.4607557],
              [49.7942508, 33.4513033],
              [49.7942508, 33.4510324],
              [49.7956374, 33.4479808],
              [49.7964708, 33.4465905],
              [49.8067507, 33.4379776],
              [49.8353638, 33.4276946],
              [49.8392501, 33.4268639],
              [49.8409169, 33.4260333],
              [49.8481402, 33.4229728],
              [49.8489734, 33.4229728],
              [49.8520301, 33.4215825],
              [49.8528633, 33.4215825],
              [49.8548067, 33.4210318],
              [49.85592, 33.4210317],
              [49.8564735, 33.4207518],
              [49.8573067, 33.4207518],
              [49.8578634, 33.420472],
              [49.8586966, 33.420472],
              [49.8614732, 33.4196414],
              [49.8625865, 33.4196414],
              [49.8823096, 33.4157503],
              [49.8973094, 33.4107486],
              [49.8984193, 33.4107486],
              [49.8986994, 33.4104687],
              [49.9064762, 33.4082478],
              [49.9073094, 33.4076971],
              [49.9086996, 33.4074172],
              [49.9203659, 33.401305],
              [49.9225894, 33.399364],
              [49.9250894, 33.3963124],
              [49.925366, 33.3957526],
              [49.927866, 33.3921413],
              [49.9345325, 33.3849186],
              [49.9373123, 33.3840881],
              [49.9420359, 33.3851985],
              [49.9434222, 33.3851986],
              [49.9437023, 33.3854785],
              [49.9467555, 33.3860292],
              [49.9478688, 33.3874196],
              [49.9500887, 33.3951929],
              [49.9578689, 33.407977],
              [49.9592588, 33.4135294],
              [49.959812, 33.4157504],
              [49.9606455, 33.4163101],
              [49.9625921, 33.4168608],
              [49.9637018, 33.4171407],
              [49.9656453, 33.4171407],
              [49.9687019, 33.4160302],
              [49.9745352, 33.4160303],
              [49.9748118, 33.4163102],
              [49.9784252, 33.4163102],
              [49.9809252, 33.416581],
              [49.9812019, 33.4168608],
              [49.9823151, 33.4168608],
              [49.9825917, 33.4171408],
              [49.9856483, 33.4171408],
              [49.9898148, 33.4196415],
              [49.9903684, 33.4199214],
              [49.9914817, 33.4326964],
              [49.9912016, 33.4332562],
              [49.990925, 33.4351972],
              [49.9903683, 33.4401989],
              [49.9723117, 33.4663083],
              [49.9720351, 33.4676986],
              [49.9731449, 33.4757517],
              [49.973425, 33.4765823],
              [49.973425, 33.4771421],
              [49.9745351, 33.4801935],
              [49.9837016, 33.4924176],
              [49.9853682, 33.4929773],
              [49.987315, 33.4940878],
              [50.0270377, 33.4993603],
              [50.0284275, 33.4996491],
              [50.0342609, 33.4996491],
              [50.0514839, 33.5007506],
              [50.052594, 33.5010304],
              [50.0545406, 33.5010304],
              [50.071207, 33.5035313],
              [50.0725972, 33.5035312],
              [50.073707, 33.5038111],
              [50.0764836, 33.5038111],
              [50.0789836, 33.504082],
              [50.0798169, 33.5043708],
              [50.0845404, 33.5049215],
              [50.09732, 33.5068626],
              [50.1387094, 33.5190867],
              [50.1431528, 33.5204769],
              [50.1492663, 33.5229777],
              [50.1762125, 33.5285299],
              [50.1831556, 33.5299202],
              [50.1839888, 33.5302001],
              [50.1859358, 33.5302001],
              [50.1867689, 33.5304799],
              [50.1884353, 33.53048],
              [50.1906553, 33.5310397],
              [50.1917691, 33.5310397],
              [50.2056588, 33.542424],
              [50.2064921, 33.5440941],
              [50.206492, 33.5446448],
              [50.206492, 33.5465949],
              [50.2046897, 33.5495951],
              [50.203992, 33.5507567],
              [50.2034352, 33.5524269],
              [50.2037118, 33.556038],
              [50.2048251, 33.5596401],
              [50.2095452, 33.5685326],
              [50.2098253, 33.5707534],
              [50.2098252, 33.5743736],
              [50.2101018, 33.5757548],
              [50.211212, 33.5777048],
              [50.2153784, 33.5799258],
              [50.2259348, 33.5888091],
              [50.228715, 33.5932507],
              [50.2306583, 33.6002021],
              [50.2328815, 33.6027028],
              [50.2353814, 33.6035334],
              [50.2381581, 33.604093],
              [50.2389913, 33.6043729],
              [50.2403816, 33.604373],
              [50.2409383, 33.6046438],
              [50.243438, 33.6043729],
              [50.2487146, 33.600482],
              [50.2562144, 33.5865883],
              [50.2589945, 33.5843674],
              [50.2614946, 33.5835369],
              [50.2731613, 33.5824265],
              [50.2751043, 33.5826973],
              [50.2787175, 33.5829772],
              [50.2889943, 33.5840876],
              [50.2895509, 33.5843675],
              [50.2923276, 33.5843675],
              [50.2928842, 33.5846474],
              [50.2937175, 33.5846473],
              [50.2942706, 33.5849273],
              [50.2951043, 33.5849272],
              [50.3164972, 33.5946502],
              [50.3184406, 33.5957606],
              [50.3259403, 33.6049238],
              [50.3267736, 33.6071446],
              [50.3281634, 33.6099252],
              [50.331217, 33.6135363],
              [50.3370534, 33.6154772],
              [50.3370535, 33.615757],
              [50.3476068, 33.6165876],
              [50.3481635, 33.6163168],
              [50.3526065, 33.6165876],
              [50.3534432, 33.6168675],
              [50.3570531, 33.6168675],
              [50.3578867, 33.6171473],
              [50.3598297, 33.6171474],
              [50.3609433, 33.6174272],
              [50.3659431, 33.6174272],
              [50.3667763, 33.6177071],
              [50.3681631, 33.6177071],
              [50.3770531, 33.6196481],
              [50.3781663, 33.619648],
              [50.3787194, 33.6193682],
              [50.3801098, 33.6193682],
              [50.380943, 33.6196481],
              [50.3820528, 33.619648],
              [50.3823329, 33.6199279],
              [50.3831661, 33.6199279],
              [50.3839997, 33.619648],
              [50.384274, 33.6199256],
              [50.3864993, 33.6199279],
              [50.3884428, 33.6201987],
              [50.3884427, 33.6204786],
              [50.3909428, 33.6204786],
              [50.3928893, 33.6204786],
              [50.3934428, 33.6207584],
              [50.3987226, 33.6207585],
              [50.3992762, 33.6210383],
              [50.4001094, 33.6207585],
              [50.400666, 33.6210383],
              [50.4067759, 33.6210383],
              [50.4112225, 33.6213092],
              [50.4117791, 33.621589],
              [50.4134459, 33.621589],
              [50.4142792, 33.6218689],
              [50.4156659, 33.6218689],
              [50.4164991, 33.6221488],
              [50.4181656, 33.6221487],
              [50.4192793, 33.6224286],
              [50.4206656, 33.6224286],
              [50.4214988, 33.6226995],
              [50.4220556, 33.6224286],
              [50.4253892, 33.6226995],
              [50.4320557, 33.6246495],
              [50.4448352, 33.6315918],
              [50.4495588, 33.6332528],
              [50.4523354, 33.6338125],
              [50.4537253, 33.6346521],
              [50.4540018, 33.6343633],
              [50.455112, 33.6335417],
              [50.4556687, 33.6335417],
              [50.4559452, 33.6332528],
              [50.4573351, 33.6332528],
              [50.4598352, 33.6327021],
              [50.4642786, 33.6318717],
              [50.4656685, 33.6313119],
              [50.4667817, 33.6313119],
              [50.4673349, 33.631032],
              [50.4687252, 33.631032],
              [50.4695584, 33.6313119],
              [50.4737248, 33.6313119],
              [50.4837246, 33.6343632],
              [50.5126144, 33.6360335],
              [50.5251177, 33.6340925],
              [50.5256709, 33.6338126],
              [50.5267846, 33.6338126],
              [50.528171, 33.633253],
              [50.5292842, 33.6332529],
              [50.5376175, 33.6304815],
              [50.5428943, 33.6299308],
              [50.5587274, 33.6282606],
              [50.5601172, 33.6279807],
              [50.5612306, 33.6282607],
              [50.5631739, 33.6282607],
              [50.5742836, 33.6307614],
              [50.5748403, 33.631312],
              [50.5756738, 33.6315919],
              [50.5776168, 33.6340925],
              [50.5778969, 33.6363134],
              [50.5776168, 33.6365932],
              [50.5798402, 33.6435355],
              [50.5831736, 33.6460362],
              [50.5867868, 33.6535381],
              [50.586787, 33.6538179],
              [50.5870635, 33.6540887],
              [50.5873409, 33.6543677],
              [50.5876201, 33.6546484],
              [50.5881736, 33.6549283],
              [50.5934535, 33.6604803],
              [50.5956733, 33.6621504],
              [50.6070631, 33.6685419],
              [50.6084534, 33.6690925],
              [50.6095631, 33.6699231],
              [50.61151, 33.6707627],
              [50.6128964, 33.671873],
              [50.6290095, 33.6796457],
              [50.6426227, 33.6896482],
              [50.6465095, 33.691869],
              [50.6556757, 33.6957598],
              [50.6595661, 33.6965903],
              [50.6904021, 33.7207657],
              [50.7006785, 33.7263176],
              [50.7040117, 33.7271481],
              [50.7156818, 33.7265975],
              [50.7187351, 33.7277078],
              [50.7242917, 33.7277079],
              [50.7292916, 33.7263176],
              [50.7304016, 33.7263176],
              [50.7337381, 33.7252073],
              [50.7351249, 33.7252073],
              [50.7370715, 33.7246476],
              [50.7379048, 33.7246476],
              [50.7381815, 33.7243677],
              [50.7420715, 33.7243677],
              [50.7442913, 33.7240969],
              [50.7445714, 33.7238171],
              [50.7520714, 33.7238171],
              [50.752628, 33.7235372],
              [50.7540145, 33.7235373],
              [50.7548479, 33.7232574],
              [50.7584613, 33.7240969],
              [50.7571071, 33.727937],
              [50.7592516, 33.7290434],
              [50.7633949, 33.7312016],
              [50.7693353, 33.7340924],
              [50.7743551, 33.7363822],
              [50.7831042, 33.7399867],
              [50.7971713, 33.7431051],
              [50.8052503, 33.744247],
              [50.8163634, 33.7452782],
              [50.8265743, 33.7448106],
              [50.8420302, 33.7452383],
              [50.8536554, 33.7448993],
              [50.8716359, 33.7431807],
              [50.8778516, 33.743252],
              [50.8825913, 33.7441027],
              [50.8959802, 33.7439878],
              [50.9015785, 33.7446867],
              [50.9124469, 33.7453249],
              [50.9214387, 33.7466678],
              [50.9338727, 33.7476744],
              [50.9482521, 33.7492101],
              [50.9543213, 33.7484194],
              [50.960647, 33.7481525],
              [50.9653653, 33.7483407],
              [50.9677219, 33.7472519],
              [50.9737235, 33.7477378],
              [50.9746741, 33.7485365],
              [50.9750468, 33.7550939],
              [50.979025, 33.7579856],
              [50.989305, 33.7635374],
              [50.9912482, 33.7640971],
              [50.9998615, 33.7677079],
              [51.0093045, 33.7729798],
              [51.0237511, 33.7860422],
              [51.0468074, 33.8157683],
              [51.0487508, 33.8188195],
              [51.049584, 33.8202096],
              [51.050974, 33.8274312],
              [51.050694, 33.8279819],
              [51.0504174, 33.8296519],
              [51.0484739, 33.8332627],
              [51.0484739, 33.8338224],
              [51.0362508, 33.8460448],
              [51.0351408, 33.8465955],
              [51.0326375, 33.8496556],
              [51.0320842, 33.8529864],
              [51.0359741, 33.860208],
              [51.0373609, 33.8621578],
              [51.0379175, 33.8627085],
              [51.0418074, 33.8754904],
              [51.0415273, 33.8763209],
              [51.0401407, 33.8827118],
              [51.0393073, 33.8868732],
              [51.0390274, 33.8882633],
              [51.0426408, 33.8963242],
              [51.043474, 33.8988156],
              [51.0468073, 33.9024353],
              [51.0473606, 33.9024353],
              [51.0481938, 33.9027151],
              [51.0495839, 33.9077159],
              [51.0498605, 33.9079867],
              [51.0481535, 33.9107632],
              [51.0476407, 33.9115973],
              [51.0476407, 33.912157],
              [51.0470841, 33.9124278],
              [51.0460226, 33.914733],
              [51.0454172, 33.9160475],
              [51.0448605, 33.918268],
              [51.0449459, 33.9197933],
              [51.0451406, 33.9232688],
              [51.0481938, 33.9288202],
              [51.0484071, 33.9330564],
              [51.0487507, 33.9347913],
              [51.0487506, 33.9349311],
              [51.0487506, 33.9366011],
              [51.0484739, 33.9368718],
              [51.0390273, 33.9460428],
              [51.0387506, 33.9463226],
              [51.0354173, 33.9491028],
              [51.0351408, 33.9493826],
              [51.0282877, 33.9548253],
              [51.0270604, 33.9577851],
              [51.0262364, 33.9600062],
              [51.0263651, 33.9620992],
              [51.0281418, 33.9663277],
              [51.0289915, 33.9681856],
              [51.0293263, 33.970556],
              [51.030485, 33.9719654],
              [51.0340384, 33.975019],
              [51.0348109, 33.9763429],
              [51.0348109, 33.9784568],
              [51.0356091, 33.9830047],
              [51.0384158, 33.9866984],
              [51.0403727, 33.989538],
              [51.0441836, 33.995537],
              [51.0453938, 33.9975864],
              [51.0523203, 34.0045241],
              [51.0553587, 34.0103941],
              [51.054097, 34.0145775],
              [51.0539425, 34.0240534],
              [51.0538653, 34.0266356],
              [51.0537108, 34.0280654],
              [51.0462435, 34.0286203],
              [51.0401667, 34.0292818],
              [51.0344246, 34.0306902],
              [51.0318497, 34.0314157],
              [51.0292748, 34.0327814],
              [51.0275753, 34.0336563],
              [51.0268029, 34.0354914],
              [51.0270346, 34.0375825],
              [51.0274981, 34.0388628],
              [51.0280646, 34.0411672],
              [51.0281418, 34.0432582],
              [51.0279873, 34.0443463],
              [51.0277813, 34.0461172],
              [51.0285538, 34.0494241],
              [51.029352, 34.0564216],
              [51.0298413, 34.0594934],
              [51.0296353, 34.060816],
              [51.0290688, 34.0616053],
              [51.0276011, 34.0625439],
              [51.0236357, 34.064549],
              [51.0209649, 34.0654905],
              [51.0018043, 34.0766075],
              [51.0004142, 34.0771581],
              [51.0000233, 34.0788906],
              [50.9998609, 34.0796583],
              [50.9943044, 34.0810482],
              [50.9940242, 34.0813281],
              [50.993191, 34.081328],
              [50.9859712, 34.0849384],
              [50.9837477, 34.0879892],
              [50.9837477, 34.088269],
              [50.9815244, 34.0907692],
              [50.9806912, 34.0915996],
              [50.9693013, 34.0974393],
              [50.968748, 34.0974393],
              [50.961248, 34.1052195],
              [50.9529114, 34.1116009],
              [50.9526347, 34.1124312],
              [50.9518014, 34.1146606],
              [50.9518015, 34.1149403],
              [50.9406423, 34.1327301],
              [50.9343024, 34.1371138],
              [50.931924, 34.1407814],
              [50.9315006, 34.1486309],
              [50.9299439, 34.1563956],
              [50.9282821, 34.1593659],
              [50.9177588, 34.1618173],
              [50.9113343, 34.1631755],
              [50.9034518, 34.1657966],
              [50.8989754, 34.168421],
              [50.8920005, 34.171589],
              [50.8811641, 34.1751681],
              [50.8708035, 34.1796179],
              [50.8565365, 34.1838649],
              [50.8501991, 34.1847255],
              [50.8305247, 34.1875703],
              [50.8234922, 34.1898817],
              [50.815958, 34.1943017],
              [50.8098532, 34.1976995],
              [50.8053588, 34.2000239],
              [50.7954305, 34.2050602],
              [50.7840512, 34.2102926],
              [50.7742082, 34.213951],
              [50.7596978, 34.2180179],
              [50.7502237, 34.222883],
              [50.7360823, 34.2248623],
              [50.7248633, 34.2264236],
              [50.7188437, 34.2282232],
              [50.7131241, 34.2313587],
              [50.7050142, 34.2334916],
              [50.6927487, 34.2353366],
              [50.6771645, 34.2377102],
              [50.6585597, 34.2367831],
              [50.640294, 34.2330941],
              [50.6174772, 34.2280177],
              [50.6023523, 34.2240108],
              [50.5916305, 34.2194898],
              [50.583887, 34.2152801],
              [50.5755453, 34.2114958],
              [50.5639676, 34.2043168],
              [50.5545594, 34.2029937],
              [50.5351165, 34.1954935],
              [50.5340032, 34.1954936],
              [50.5317832, 34.1943834],
              [50.5170602, 34.1899339],
              [50.50928, 34.1899339],
              [50.5056702, 34.1899338],
              [50.4998369, 34.1899338],
              [50.4990037, 34.1902136],
              [50.4962236, 34.1902136],
              [50.4953903, 34.1904934],
              [50.494557, 34.1904934],
              [50.4940036, 34.1907732],
              [50.4815005, 34.189663],
              [50.4792806, 34.1899337],
              [50.4784474, 34.1902135],
              [50.4770571, 34.1902136],
              [50.474834, 34.1907731],
              [50.4731672, 34.1907732],
              [50.472334, 34.1904934],
              [50.4676139, 34.1904934],
              [50.4667807, 34.1907731],
              [50.4651107, 34.1907731],
              [50.4420545, 34.2010531],
              [50.4415009, 34.2016036],
              [50.4387212, 34.2029935],
              [50.4323343, 34.2068835],
              [50.4284443, 34.211324],
              [50.4287213, 34.2154936],
              [50.4317777, 34.2246633],
              [50.4323343, 34.2252139],
              [50.4351108, 34.2371633],
              [50.4356679, 34.2460532],
              [50.4353878, 34.2466037],
              [50.4348342, 34.2491037],
              [50.4245543, 34.2774425],
              [50.4192781, 34.2843917],
              [50.4189979, 34.2849423],
              [50.4176112, 34.2871625],
              [50.4151111, 34.2910522],
              [50.4145545, 34.2924421],
              [50.3962212, 34.3135513],
              [50.3831647, 34.3230002],
              [50.3823315, 34.323271],
              [50.3817749, 34.3238305],
              [50.3812182, 34.3238305],
              [50.3809416, 34.3241103],
              [50.3809416, 34.3249407],
              [50.380385, 34.3260506],
              [50.380385, 34.3263305],
              [50.3701081, 34.3346602],
              [50.3659417, 34.3427193],
              [50.3626084, 34.3460586],
              [50.36219, 34.3461939],
              [50.3614951, 34.3468888],
              [50.3601083, 34.3488291],
              [50.3601083, 34.3493886],
              [50.3528851, 34.374107],
              [50.3531617, 34.3743867],
              [50.3523285, 34.3777168],
              [50.352605, 34.3804964],
              [50.352885, 34.3816063],
              [50.3531617, 34.3821658],
              [50.3495518, 34.3879957],
              [50.3492716, 34.3882754],
              [50.3403852, 34.3957747],
              [50.3362187, 34.4002238],
              [50.335662, 34.4005035],
              [50.3353854, 34.4010541],
              [50.3348287, 34.4013338],
              [50.3317721, 34.4068837],
              [50.3314956, 34.4080028],
              [50.3353854, 34.4213317],
              [50.3362187, 34.4241112],
              [50.3370518, 34.4274411],
              [50.337885, 34.4371693],
              [50.3376054, 34.4379995],
              [50.3373284, 34.439669],
              [50.3351052, 34.4421688],
              [50.3314955, 34.4424394],
              [50.3292719, 34.4421687],
              [50.3126056, 34.4377198],
              [50.311772, 34.4377198],
              [50.3106587, 34.4371692],
              [50.3095489, 34.4371693],
              [50.3084387, 34.4366098],
              [50.3076055, 34.4366098],
              [50.3070488, 34.43633],
              [50.3053825, 34.43633],
              [50.3051055, 34.4360503],
              [50.3042722, 34.4360502],
              [50.300939, 34.4363299],
              [50.2917689, 34.4377198],
              [50.2912157, 34.4379995],
              [50.2903826, 34.4379994],
              [50.2898258, 34.4382792],
              [50.2889926, 34.4382792],
              [50.2814925, 34.4416092],
              [50.2809358, 34.4421686],
              [50.2770459, 34.4435583],
              [50.2762127, 34.4443886],
              [50.2751025, 34.444939],
              [50.2712126, 34.4524471],
              [50.2698261, 34.4529976],
              [50.2664926, 34.4527268],
              [50.2662128, 34.4524471],
              [50.2603795, 34.4529976],
              [50.259826, 34.4532774],
              [50.2545461, 34.4532773],
              [50.2542697, 34.4535571],
              [50.2520461, 34.4535571],
              [50.2512129, 34.4538369],
              [50.2470465, 34.4538369],
              [50.2439897, 34.4541075],
              [50.2437132, 34.4543873],
              [50.2414896, 34.4543873],
              [50.2406565, 34.454667],
              [50.2398229, 34.454667],
              [50.2395462, 34.4549468],
              [50.2384329, 34.4549467],
              [50.2281566, 34.457997],
              [50.2217666, 34.4591159],
              [50.2156568, 34.4602168],
              [50.2148235, 34.4604965],
              [50.2134333, 34.4604966],
              [50.1951004, 34.4643859],
              [50.1937102, 34.4643859],
              [50.1931534, 34.4646657],
              [50.1912101, 34.4646656],
              [50.1906535, 34.4649453],
              [50.1887105, 34.4649454],
              [50.1856538, 34.4655048],
              [50.1784305, 34.4655049],
              [50.177877, 34.4657847],
              [50.1753769, 34.4657846],
              [50.1653772, 34.4677248],
              [50.1637072, 34.4677248],
              [50.1595407, 34.4685549],
              [50.1481542, 34.4732836],
              [50.1464877, 34.4752237],
              [50.1462075, 34.4760539],
              [50.1459306, 34.4763337],
              [50.1467643, 34.4780031],
              [50.147874, 34.4805027],
              [50.1498209, 34.4835528],
              [50.1575972, 34.490781],
              [50.1589871, 34.5035588],
              [50.1570406, 34.5091175],
              [50.1484306, 34.5163366],
              [50.1442641, 34.5180059],
              [50.118151, 34.5368926],
              [50.1175943, 34.5382821],
              [50.1125942, 34.5452213],
              [50.1100946, 34.5496699],
              [50.1051137, 34.557358],
              [50.1045378, 34.5579987],
              [50.1025944, 34.5607869],
              [50.1000943, 34.5632774],
              [50.0987045, 34.564667],
              [50.0912047, 34.5724543],
              [50.0887046, 34.5788339],
              [50.0864811, 34.5823911],
              [50.0864671, 34.5830887],
              [50.0862046, 34.5835621],
              [50.0864812, 34.5860616],
              [50.1014846, 34.6110562],
              [50.1014845, 34.6116156],
              [50.1081511, 34.6238331],
              [50.1092482, 34.6323985],
              [50.1109277, 34.6455065],
              [50.1112077, 34.6463366],
              [50.1109276, 34.6466163],
              [50.1106511, 34.650785],
              [50.1103741, 34.6524542],
              [50.1100944, 34.6538347],
              [50.1096736, 34.6543289],
              [50.1075943, 34.6566138],
              [50.1025941, 34.6643916],
              [50.1023176, 34.6655013],
              [50.1020375, 34.6693903],
              [50.1031508, 34.6755077],
              [50.1081509, 34.6843952],
              [50.1114842, 34.6863352],
              [50.1134276, 34.6899533],
              [50.1139842, 34.6905037],
              [50.1145409, 34.6932827],
              [50.1134276, 34.6952316],
              [50.1134275, 34.6955113],
              [50.1128741, 34.6971714],
              [50.1131506, 34.698561],
              [50.1217605, 34.7102273],
              [50.1245406, 34.7157852],
              [50.1248172, 34.7193943],
              [50.1231507, 34.7249521],
              [50.1206506, 34.7330093],
              [50.120094, 34.7338393],
              [50.1198171, 34.7346783],
              [50.1195405, 34.7388377],
              [50.119817, 34.7393971],
              [50.1195405, 34.7402272],
              [50.1198171, 34.7435566],
              [50.1200941, 34.7441159],
              [50.1203741, 34.7452257],
              [50.1203741, 34.7466151],
              [50.1214839, 34.7510631],
              [50.1220405, 34.7555112],
              [50.1314836, 34.7746745],
              [50.15954, 34.8135599],
              [50.1598201, 34.8143989],
              [50.1620492, 34.8175437],
              [50.1673968, 34.8203045],
              [50.1701204, 34.8210637],
              [50.1730065, 34.8213116],
              [50.174263, 34.8213458],
              [50.1823197, 34.8193971],
              [50.1828764, 34.8193971],
              [50.1853765, 34.818567],
              [50.2139891, 34.8146786],
              [50.2148227, 34.814399],
              [50.2178759, 34.814399],
              [50.2287125, 34.8130095],
              [50.2292657, 34.8132802],
              [50.2426022, 34.8130096],
              [50.2456555, 34.8138396],
              [50.2462121, 34.8141193],
              [50.2684341, 34.8138197],
              [50.2721849, 34.8116225],
              [50.275986, 34.8097799],
              [50.2788544, 34.808439],
              [50.2954101, 34.7998847],
              [50.3120483, 34.7813422],
              [50.3137147, 34.7799527],
              [50.3278814, 34.7680074],
              [50.3412177, 34.7599505],
              [50.3478846, 34.7591204],
              [50.3484378, 34.7588407],
              [50.3587176, 34.7588407],
              [50.3617743, 34.7591204],
              [50.366494, 34.7591204],
              [50.367051, 34.7588407],
              [50.3684409, 34.7588407],
              [50.368994, 34.758561],
              [50.3709409, 34.7585611],
              [50.3948305, 34.7527326],
              [50.4012205, 34.7519026],
              [50.4014971, 34.7516229],
              [50.4059405, 34.7516229],
              [50.4067737, 34.7519026],
              [50.4092738, 34.7519027],
              [50.4153868, 34.7546724],
              [50.4156638, 34.7549522],
              [50.4176103, 34.7557822],
              [50.4181635, 34.7560619],
              [50.4284433, 34.7541222],
              [50.4340001, 34.7574514],
              [50.4398334, 34.7752343],
              [50.4406666, 34.7777334],
              [50.4487234, 34.8035638],
              [50.4501097, 34.8107905],
              [50.451223, 34.8180081],
              [50.4506663, 34.8205072],
              [50.4509428, 34.8243956],
              [50.451223, 34.8269037],
              [50.4551111, 34.8319907],
              [50.458443, 34.8363496],
              [50.4642763, 34.8413477],
              [50.4681662, 34.844397],
              [50.4817794, 34.8566215],
              [50.4881694, 34.8596708],
              [50.4892791, 34.8602302],
              [50.4901123, 34.8602302],
              [50.4903893, 34.8605099],
              [50.4915026, 34.8605099],
              [50.4948359, 34.8618993],
              [50.501779, 34.8638389],
              [50.5087256, 34.8652372],
              [50.5165024, 34.8657875],
              [50.5178922, 34.8655169],
              [50.5184453, 34.8652373],
              [50.5201122, 34.8652373],
              [50.5206688, 34.8649575],
              [50.5226123, 34.8649576],
              [50.5303921, 34.8621789],
              [50.5362254, 34.8596709],
              [50.5420584, 34.8574606],
              [50.542892, 34.8574606],
              [50.5434486, 34.8571809],
              [50.5442818, 34.8574607],
              [50.5445584, 34.8571809],
              [50.5462252, 34.8571809],
              [50.5465054, 34.8574606],
              [50.5473386, 34.8571809],
              [50.5545583, 34.8577312],
              [50.5615049, 34.8555119],
              [50.5617814, 34.8552322],
              [50.5692816, 34.8552323],
              [50.5698382, 34.8549526],
              [50.5720618, 34.8549526],
              [50.5728949, 34.8552322],
              [50.5742814, 34.8552323],
              [50.5751149, 34.855512],
              [50.5765048, 34.8555119],
              [50.5801181, 34.8569013],
              [50.5809515, 34.857181],
              [50.5823381, 34.8574607],
              [50.5826182, 34.8577313],
              [50.5834513, 34.8577313],
              [50.583728, 34.858011],
              [50.5845612, 34.858011],
              [50.5848381, 34.8582907],
              [50.5859515, 34.8582906],
              [50.5923379, 34.86051],
              [50.5981712, 34.8627294],
              [50.5998412, 34.863839],
              [50.600951, 34.8638389],
              [50.6028944, 34.864678],
              [50.6212311, 34.8677274],
              [50.6498406, 34.8702354],
              [50.6506739, 34.8699558],
              [50.6523403, 34.8699557],
              [50.653454, 34.8696761],
              [50.6565102, 34.8696761],
              [50.659287, 34.8694054],
              [50.6601205, 34.8691257],
              [50.6615104, 34.8691258],
              [50.6620635, 34.8688461],
              [50.6642871, 34.8688461],
              [50.6651202, 34.8685665],
              [50.6715102, 34.8685664],
              [50.6720634, 34.8682868],
              [50.6756767, 34.8682868],
              [50.6762337, 34.8685665],
              [50.6895669, 34.8685665],
              [50.6995667, 34.8680071],
              [50.7028999, 34.8680071],
              [50.7034565, 34.8682868],
              [50.7040097, 34.8682868],
              [50.705123, 34.8682868],
              [50.7048433, 34.8713451],
              [50.7045664, 34.8727344],
              [50.7048433, 34.8735644],
              [50.7040097, 34.8766227],
              [50.7042898, 34.8769024],
              [50.7040097, 34.8771821],
              [50.7031765, 34.8799607],
              [50.7029, 34.881341],
              [50.7026234, 34.88301],
              [50.7023432, 34.8857886],
              [50.7023433, 34.8882877],
              [50.7023433, 34.8896769],
              [50.7020667, 34.8899566],
              [50.7020667, 34.8907865],
              [50.7020667, 34.8938449],
              [50.7017898, 34.8941244],
              [50.70151, 34.8963437],
              [50.701233, 34.8980127],
              [50.7009565, 34.8999613],
              [50.7006765, 34.9016213],
              [50.7001233, 34.9041202],
              [50.6998432, 34.9052388],
              [50.6984564, 34.9110666],
              [50.6981764, 34.9130063],
              [50.6962334, 34.9238408],
              [50.6945664, 34.9299572],
              [50.6945665, 34.9310668],
              [50.6942899, 34.9316261],
              [50.6942898, 34.9318968],
              [50.6942899, 34.9324561],
              [50.6934567, 34.9357939],
              [50.6934567, 34.9485678],
              [50.6923434, 34.9518966],
              [50.6851197, 34.9652386],
              [50.6845666, 34.965789],
              [50.6845665, 34.9663482],
              [50.6823435, 34.9685675],
              [50.6820665, 34.9694063],
              [50.6809532, 34.9705159],
              [50.6806767, 34.9710662],
              [50.6603969, 34.9877367],
              [50.65873, 34.9885666],
              [50.6534538, 34.9944031],
              [50.6498404, 34.9996803],
              [50.6506736, 35.008286],
              [50.6512302, 35.0102344],
              [50.6517869, 35.0138427],
              [50.6537302, 35.0182898],
              [50.654287, 35.0193994],
              [50.66512, 35.0299625],
              [50.6715099, 35.0319019],
              [50.6956764, 35.0435744],
              [50.6959565, 35.0441247],
              [50.6970663, 35.044684],
              [50.7003995, 35.0477418],
              [50.7195659, 35.0705181],
              [50.7512355, 35.0930145],
              [50.7537355, 35.0946831],
              [50.7540122, 35.0952424],
              [50.7567922, 35.0966225],
              [50.7570688, 35.0969112],
              [50.7584589, 35.0971817],
              [50.7673454, 35.1057958],
              [50.7704018, 35.1107929],
              [50.7706819, 35.1116317],
              [50.7720685, 35.1141302],
              [50.8065149, 35.1524643],
              [50.8159613, 35.1574612],
              [50.8165147, 35.1580205],
              [50.8195714, 35.1591299],
              [50.8204046, 35.1596891],
              [50.8231812, 35.1607984],
              [50.8317945, 35.1638471],
              [50.8326277, 35.1644063],
              [50.8334612, 35.1644063],
              [50.8470742, 35.1708012],
              [50.8431728, 35.2145523],
              [50.8450219, 35.2226081],
              [50.8466885, 35.2245462],
              [50.8488812, 35.2360305],
              [50.8555604, 35.2527998],
              [50.8666959, 35.2677876],
              [50.8675294, 35.2694552],
              [50.8683626, 35.2702844],
              [50.8740358, 35.2748425],
              [50.8743124, 35.2759602],
              [50.8745891, 35.2762396],
              [50.8765358, 35.2812332],
              [50.8844623, 35.289215],
              [50.8933937, 35.2998653],
              [50.9048304, 35.3211906],
              [50.9067737, 35.3247975],
              [50.9473561, 35.3794128],
              [50.9484661, 35.3819107],
              [50.9583663, 35.3861111],
              [50.9653824, 35.394178],
              [50.9651057, 35.3944576],
              [50.9645489, 35.3955667],
              [50.9645489, 35.3958463],
              [50.9648257, 35.3958463],
              [50.9615226, 35.417188],
              [50.9622033, 35.436015],
              [50.9670258, 35.4392095],
              [50.9667254, 35.4395242],
              [50.9665109, 35.4399787],
              [50.966307, 35.4407129],
              [50.9660495, 35.4413773],
              [50.96591, 35.4418755],
              [50.9654058, 35.442531],
              [50.9650196, 35.4432565],
              [50.9643651, 35.443781],
              [50.9634403, 35.4448193],
              [50.9632864, 35.4457835],
              [50.9634924, 35.4464128],
              [50.9633121, 35.4467904],
              [50.9621534, 35.4476504],
              [50.9611749, 35.4487202],
              [50.960763, 35.4488461],
              [50.9592438, 35.4489509],
              [50.9582395, 35.4493705],
              [50.9578533, 35.4501675],
              [50.9574671, 35.4509017],
              [50.9567461, 35.4516988],
              [50.9552526, 35.4522231],
              [50.9542484, 35.4525168],
              [50.9531412, 35.4528314],
              [50.9527292, 35.453188],
              [50.9515705, 35.4529363],
              [50.950695, 35.4527056],
              [50.9496908, 35.4527895],
              [50.9493818, 35.45323],
              [50.9485063, 35.4537124],
              [50.9488411, 35.4541738],
              [50.9492788, 35.4543626],
              [50.9493046, 35.4550548],
              [50.9487381, 35.4554533],
              [50.9473734, 35.4557259],
              [50.9469356, 35.4555791],
              [50.9462147, 35.455684],
              [50.9458257, 35.4557088],
              [50.9418391, 35.4569857],
              [50.934107, 35.4603151],
              [50.9218277, 35.4656001],
              [50.915952, 35.4684298],
              [50.91212, 35.4704133],
              [50.9096846, 35.4734231],
              [50.9065339, 35.4746713],
              [50.9036046, 35.4760444],
              [50.899977, 35.4799],
              [50.8975415, 35.4816335],
              [50.8948336, 35.4828955],
              [50.8915269, 35.4851248],
              [50.8779066, 35.4846914],
              [50.8765168, 35.4849709],
              [50.8756834, 35.484971],
              [50.8751302, 35.484971],
              [50.8731835, 35.4849709],
              [50.8673502, 35.4835823],
              [50.8637403, 35.4824732],
              [50.8634635, 35.4821936],
              [50.8626303, 35.4821936],
              [50.8623502, 35.4819141],
              [50.8615168, 35.4819141],
              [50.8576269, 35.480805],
              [50.851517, 35.480805],
              [50.845127, 35.4813551],
              [50.8223473, 35.4844118],
              [50.8217941, 35.4846913],
              [50.8112375, 35.4846913],
              [50.8104042, 35.4844117],
              [50.8092942, 35.4844118],
              [50.8084608, 35.4841413],
              [50.8017909, 35.4835822],
              [50.8009575, 35.4835822],
              [50.8004044, 35.4833027],
              [50.799571, 35.4835822],
              [50.7987376, 35.4833027],
              [50.7904044, 35.4833026],
              [50.7895712, 35.4835822],
              [50.7876245, 35.4835822],
              [50.786791, 35.4838617],
              [50.7848478, 35.4838617],
              [50.7842912, 35.4841413],
              [50.7823478, 35.4841413],
              [50.7787346, 35.4849708],
              [50.7776246, 35.4849708],
              [50.775958, 35.4855299],
              [50.7745679, 35.4855298],
              [50.7726247, 35.4860799],
              [50.7715148, 35.4860799],
              [50.7712347, 35.4863594],
              [50.7684581, 35.4869184],
              [50.7676246, 35.4869185],
              [50.7560459, 35.48778],
              [50.7410345, 35.4928463],
              [50.7075471, 35.5040966],
              [50.6885559, 35.5115726],
              [50.6767683, 35.5129611],
              [50.6558252, 35.5207698],
              [50.6526361, 35.5241491],
              [50.6497631, 35.5251971],
              [50.6414739, 35.5323054],
              [50.6328629, 35.540979],
              [50.6270627, 35.5469157],
              [50.6259494, 35.5474747],
              [50.6181764, 35.5524796],
              [50.6063747, 35.5532827],
              [50.5969082, 35.552784],
              [50.5911172, 35.5527142],
              [50.5883665, 35.5527493],
              [50.5762269, 35.5535788],
              [50.5709466, 35.5538583],
              [50.5669582, 35.5542342],
              [50.5587537, 35.5546785],
              [50.5536786, 35.5581875],
              [50.5418645, 35.5651006],
              [50.531693, 35.5706074],
              [50.4929353, 35.56849],
              [50.456632, 35.5601728],
              [50.4523712, 35.5590905],
              [50.4417564, 35.5585589],
              [50.4228684, 35.5582374],
              [50.4157664, 35.5589101],
              [50.4055309, 35.5598813],
              [50.4027049, 35.5606034],
              [50.3884791, 35.564339],
              [50.3738139, 35.5638952],
              [50.3573286, 35.5637571],
              [50.3351497, 35.5508736],
              [50.3329055, 35.5507027],
              [50.3289699, 35.5472422],
              [50.3223609, 35.5432615],
              [50.2850243, 35.5366967],
              [50.2280472, 35.5320984],
              [50.2200507, 35.5311786],
              [50.2019068, 35.5271473],
              [50.1778749, 35.5221916],
              [50.1500954, 35.5185848],
              [50.1467621, 35.5185849],
              [50.1462053, 35.5183053],
              [50.1364821, 35.5183054],
              [50.1356486, 35.5180258],
              [50.1342622, 35.5180258],
              [50.1306489, 35.5177463],
              [50.1295386, 35.5174668],
              [50.127039, 35.5174668],
              [50.1264823, 35.5171872],
              [50.1017591, 35.51386],
              [50.068703, 35.5077466],
              [50.0550899, 35.506358],
              [50.0431466, 35.5055284],
              [50.0359234, 35.5055284],
              [50.0353668, 35.505249],
              [50.02981, 35.5052488],
              [50.0292568, 35.5049694],
              [50.0253666, 35.5049694],
              [50.0242567, 35.5046898],
              [50.0214765, 35.5046898],
              [50.0209235, 35.5044103],
              [50.0198102, 35.5044103],
              [50.0148101, 35.5044102],
              [50.0137003, 35.5041398],
              [50.0103671, 35.5041398],
              [50.0092537, 35.5038602],
              [50.0053669, 35.5038602],
              [50.0042535, 35.5035807],
              [49.9923104, 35.5035807],
              [49.990644, 35.5038603],
              [49.9881439, 35.5038602],
              [49.9839774, 35.5044103],
              [49.9817539, 35.5044103],
              [49.9723072, 35.5060874],
              [49.9253613, 35.5191345],
              [49.9211944, 35.5208027],
              [49.9192514, 35.5221913],
              [49.904528, 35.5385834],
              [49.9042514, 35.539413],
              [49.9039714, 35.5396924],
              [49.9034182, 35.5399719],
              [49.9023048, 35.540522],
              [49.8906383, 35.5449761],
              [49.8803583, 35.5469146],
              [49.8725816, 35.5469147],
              [49.8711917, 35.5466352],
              [49.8599052, 35.5388295],
              [49.8399051, 35.5296681],
              [49.8176168, 35.5206887],
              [49.8051985, 35.5137983],
              [49.8006299, 35.5081479],
              [49.7814488, 35.512829],
              [49.7814728, 35.5213616],
              [49.7781395, 35.5221911],
              [49.7684162, 35.5230207],
              [49.7645264, 35.5230208],
              [49.7636927, 35.5233002],
              [49.7625829, 35.5233003],
              [49.7617497, 35.5235797],
              [49.754803, 35.5241388],
              [49.7445263, 35.5257978],
              [49.7400797, 35.5274658],
              [49.7395265, 35.5280249],
              [49.7259133, 35.5338587],
              [49.7245266, 35.5338587],
              [49.72397, 35.5341381],
              [49.7236935, 35.5338587],
              [49.7173035, 35.5338586],
              [49.7170233, 35.5335792],
              [49.7156366, 35.5335792],
              [49.7153568, 35.5332996],
              [49.7128569, 35.5332996],
              [49.7114702, 35.5332996],
              [49.71119, 35.5335791],
              [49.7106369, 35.5335791],
              [49.7100802, 35.5332996],
              [49.7095236, 35.5330201],
              [49.7081368, 35.5330201],
              [49.7073037, 35.5332996],
              [49.7048036, 35.5332996],
              [49.7042469, 35.5335792],
              [49.6992469, 35.5335791],
              [49.6989671, 35.5332996],
              [49.6978569, 35.5332996],
              [49.6975804, 35.5330201],
              [49.6956335, 35.5327496],
              [49.6945237, 35.5321906],
              [49.6934138, 35.5321906],
              [49.6911904, 35.5316315],
              [49.6856336, 35.5288544],
              [49.6820238, 35.5230206],
              [49.6814672, 35.5177457],
              [49.6842438, 35.5116324],
              [49.6842438, 35.5113529],
              [49.6856337, 35.5094053],
              [49.6895237, 35.5035802],
              [49.6925741, 35.4838602],
              [49.6936838, 35.4810829],
              [49.6942408, 35.4774671],
              [49.6931307, 35.471083],
              [49.692574, 35.4702444],
              [49.6922941, 35.4696943],
              [49.6839606, 35.4608034],
              [49.6842407, 35.4596943],
              [49.6847943, 35.4577466],
              [49.6856275, 35.4519124],
              [49.6847943, 35.4496941],
              [49.6842407, 35.449135],
              [49.6842407, 35.4488555],
              [49.6822942, 35.4471963],
              [49.681461, 35.4471964],
              [49.6811845, 35.4469079],
              [49.6789609, 35.4466373],
              [49.678961, 35.4463577],
              [49.6770176, 35.4463577],
              [49.6764609, 35.4460782],
              [49.6756277, 35.4460782],
              [49.6750745, 35.4457986],
              [49.6717378, 35.4452396],
              [49.6684045, 35.4452395],
              [49.6542377, 35.449135],
              [49.6478478, 35.4510828],
              [49.6445145, 35.4510828],
              [49.6439614, 35.4508032],
              [49.6414613, 35.4508032],
              [49.6403479, 35.4505237],
              [49.6375714, 35.4505236],
              [49.6364617, 35.4502442],
              [49.6336814, 35.4502442],
              [49.6303481, 35.4499645],
              [49.6300716, 35.449694],
              [49.6284048, 35.4496941],
              [49.6228485, 35.4488555],
              [49.6222914, 35.4485759],
              [49.6161815, 35.4460781],
              [49.6075685, 35.4335799],
              [49.5995152, 35.4280252],
              [49.5986819, 35.4280252],
              [49.5959018, 35.426907],
              [49.5925685, 35.4257979],
              [49.5859021, 35.4235796],
              [49.5797921, 35.4194135],
              [49.5778456, 35.4171861],
              [49.5720123, 35.4102425],
              [49.5686791, 35.4083037],
              [49.5678458, 35.4083038],
              [49.5675688, 35.4080242],
              [49.5592324, 35.4052468],
              [49.5581226, 35.4052467],
              [49.5508994, 35.4035785],
              [49.5427042, 35.4027091],
              [49.537807, 35.3910238],
              [49.516501, 35.3952118],
              [49.5136615, 35.3917167],
              [49.4948869, 35.3907057],
              [49.4892882, 35.3905895],
              [49.472796, 35.393249],
              [49.4707195, 35.3796745],
              [49.4687761, 35.375786],
              [49.4684995, 35.3752266],
              [49.4673862, 35.3735666],
              [49.4559961, 35.3646709],
              [49.4451631, 35.352446],
              [49.4428931, 35.3423871],
              [49.4423396, 35.3421073],
              [49.4392833, 35.3407177],
              [49.4158604, 35.3198329],
              [49.3944706, 35.2903821],
              [49.3933608, 35.2887132],
              [49.3889174, 35.2834365],
              [49.3858607, 35.2773207],
              [49.3747816, 35.2632994],
              [49.3764484, 35.2591327],
              [49.3831299, 35.2396773],
              [49.3831299, 35.238578],
              [49.3831298, 35.2382884],
              [49.4378413, 35.2049645],
              [49.4381178, 35.2021866],
              [49.4383944, 35.1999588],
              [49.4386744, 35.1985699],
              [49.4414511, 35.1927434],
              [49.4439512, 35.190236],
              [49.4464508, 35.1894063],
              [49.4481177, 35.1894062],
              [49.4489509, 35.1891267],
              [49.4508978, 35.1891266],
              [49.4511744, 35.188847],
              [49.453951, 35.1888471],
              [49.4542311, 35.1885674],
              [49.4567307, 35.1882968],
              [49.4570077, 35.1880172],
              [49.4661739, 35.1791241],
              [49.4678407, 35.1707992],
              [49.4681209, 35.17024],
              [49.4678408, 35.1694102],
              [49.4658974, 35.1616263],
              [49.4645076, 35.1494048],
              [49.4633974, 35.1455173],
              [49.4631177, 35.1427392],
              [49.4628408, 35.1382925],
              [49.4539512, 35.1196756],
              [49.4536746, 35.1185752],
              [49.450341, 35.1069034],
              [49.4472846, 35.091903],
              [49.4453414, 35.0871766],
              [49.4411749, 35.0794012],
              [49.4206182, 35.0541264],
              [49.4175616, 35.0449527],
              [49.4172849, 35.0435725],
              [49.4170049, 35.0399554],
              [49.4161717, 35.0380069],
              [49.4150619, 35.0366268],
              [49.4111719, 35.0341191],
              [49.4095051, 35.0341191],
              [49.4089485, 35.0343987],
              [49.4078384, 35.0343988],
              [49.4075618, 35.0346784],
              [49.4070051, 35.0346783],
              [49.4042285, 35.0366268],
              [49.3906153, 35.0474603],
              [49.3864488, 35.0485698],
              [49.3842253, 35.0485698],
              [49.3836721, 35.0488494],
              [49.3795056, 35.0488494],
              [49.3720055, 35.0527371],
              [49.3681155, 35.0532874],
              [49.3650589, 35.0532875],
              [49.3642256, 35.053567],
              [49.3628357, 35.0535671],
              [49.3556157, 35.0574637],
              [49.3553356, 35.0582936],
              [49.3545024, 35.0594032],
              [49.3547824, 35.0610719],
              [49.3564493, 35.0638502],
              [49.3567258, 35.0685678],
              [49.3564492, 35.069127],
              [49.3553355, 35.0705161],
              [49.355059, 35.0716256],
              [49.3525589, 35.0741242],
              [49.3520023, 35.0741242],
              [49.3517258, 35.0744038],
              [49.3489456, 35.0744038],
              [49.3428357, 35.0719052],
              [49.3420025, 35.0719053],
              [49.341726, 35.0716256],
              [49.3406126, 35.0716256],
              [49.3383927, 35.0724554],
              [49.337836, 35.0730147],
              [49.3367258, 35.0755133],
              [49.3356125, 35.0774617],
              [49.3328359, 35.0777323],
              [49.3297791, 35.0777323],
              [49.3295026, 35.0780119],
              [49.328946, 35.0780119],
              [49.3283893, 35.0802399],
              [49.3281126, 35.0805105],
              [49.3281127, 35.0810697],
              [49.325056, 35.0830181],
              [49.3242227, 35.083018],
              [49.3239462, 35.0832977],
              [49.3064462, 35.0849574],
              [49.3042232, 35.0843981],
              [49.2939432, 35.078571],
              [49.290333, 35.0760725],
              [49.2900564, 35.0757928],
              [49.2608868, 35.0516185],
              [49.259777, 35.0421831],
              [49.2639435, 35.0318998],
              [49.2656104, 35.0294011],
              [49.2758868, 35.0121808],
              [49.2828334, 35.0077337],
              [49.2842234, 35.0077337],
              [49.2889433, 35.0060648],
              [49.2925566, 35.0060649],
              [49.29339, 35.0063445],
              [49.2972798, 35.0077336],
              [49.3058898, 35.0116216],
              [49.3067231, 35.0116216],
              [49.3125563, 35.0127402],
              [49.322003, 35.0138407],
              [49.3411694, 35.0135701],
              [49.3422792, 35.0138407],
              [49.3483926, 35.0132905],
              [49.3556158, 35.0119013],
              [49.3578357, 35.0110714],
              [49.3636691, 35.0110715],
              [49.3647824, 35.0113511],
              [49.3683922, 35.0116217],
              [49.3703356, 35.012181],
              [49.3764491, 35.0138408],
              [49.378392, 35.0138408],
              [49.3792256, 35.0141205],
              [49.3800589, 35.0138408],
              [49.3908955, 35.0135702],
              [49.391172, 35.0132906],
              [49.3931155, 35.0132906],
              [49.3947822, 35.0127403],
              [49.3958955, 35.0127403],
              [49.3986721, 35.0119014],
              [49.4017285, 35.0105123],
              [49.4025621, 35.0105122],
              [49.4028386, 35.0102326],
              [49.4036719, 35.0102326],
              [49.4039484, 35.009953],
              [49.4050621, 35.0096824],
              [49.4058954, 35.0088434],
              [49.4142284, 35.0016269],
              [49.4142284, 35.0010676],
              [49.4128386, 34.9982892],
              [49.4075619, 34.9835673],
              [49.4050622, 34.9777308],
              [49.4047821, 34.9757913],
              [49.4070053, 34.9649572],
              [49.4072818, 34.962738],
              [49.407562, 34.9607894],
              [49.4078385, 34.9605098],
              [49.4078385, 34.9582906],
              [49.4078385, 34.958011],
              [49.4075619, 34.9574517],
              [49.4072818, 34.9560714],
              [49.4022821, 34.9502348],
              [49.3995055, 34.9488455],
              [49.3986724, 34.9488456],
              [49.3967289, 34.9480066],
              [49.3889491, 34.9452281],
              [49.3883924, 34.9432885],
              [49.3886725, 34.9416197],
              [49.3889491, 34.9407897],
              [49.3892257, 34.9396801],
              [49.3895057, 34.9385705],
              [49.3897824, 34.9374519],
              [49.3903389, 34.9352327],
              [49.3906156, 34.9338434],
              [49.3908957, 34.9335637],
              [49.3911723, 34.9316242],
              [49.3914488, 34.9302349],
              [49.3917288, 34.9291163],
              [49.3920058, 34.9274564],
              [49.3922824, 34.9268971],
              [49.3920059, 34.9260672],
              [49.3897823, 34.9174518],
              [49.3881155, 34.9152326],
              [49.3833925, 34.9132839],
              [49.3825592, 34.9132839],
              [49.3822826, 34.9130043],
              [49.3778392, 34.9119037],
              [49.3758927, 34.9119037],
              [49.3753391, 34.911624],
              [49.3714492, 34.911624],
              [49.3711691, 34.9119036],
              [49.3695027, 34.9119037],
              [49.3678358, 34.912454],
              [49.3658928, 34.9127337],
              [49.3583927, 34.9144026],
              [49.3567263, 34.9144026],
              [49.3558926, 34.9146823],
              [49.349503, 34.9157828],
              [49.3478362, 34.9157828],
              [49.347003, 34.9160625],
              [49.3442264, 34.9160624],
              [49.3433932, 34.9163421],
              [49.3408931, 34.9163421],
              [49.3400594, 34.9166218],
              [49.338393, 34.9166217],
              [49.3378364, 34.9163422],
              [49.331723, 34.916342],
              [49.3311698, 34.9160624],
              [49.3289463, 34.9160625],
              [49.3278365, 34.9155121],
              [49.3264462, 34.9155122],
              [49.3258896, 34.9152324],
              [49.3247799, 34.9152325],
              [49.3242232, 34.9149528],
              [49.3211701, 34.9144025],
              [49.3183899, 34.9144025],
              [49.3175567, 34.9141229],
              [49.3158899, 34.9141228],
              [49.3156133, 34.9138432],
              [49.3142235, 34.9138432],
              [49.3139469, 34.9135636],
              [49.3125566, 34.9135635],
              [49.3070003, 34.912454],
              [49.3061666, 34.9124539],
              [49.3056135, 34.9124539],
              [49.3045002, 34.9119035],
              [49.3036666, 34.9119035],
              [49.2981137, 34.9093956],
              [49.2968225, 34.9089059],
              [49.2933902, 34.907456],
              [49.2931101, 34.9068967],
              [49.2925569, 34.906617],
              [49.2736672, 34.891064],
              [49.2731105, 34.8907844],
              [49.2717207, 34.8902341],
              [49.270887, 34.8902341],
              [49.2706105, 34.8899545],
              [49.2697772, 34.8899544],
              [49.2686675, 34.8893952],
              [49.2681104, 34.8893951],
              [49.2675538, 34.889395],
              [49.2542206, 34.8846768],
              [49.2531109, 34.8838469],
              [49.2347742, 34.8638369],
              [49.2333879, 34.8616266],
              [49.2333879, 34.8613469],
              [49.229498, 34.8530109],
              [49.2256077, 34.8505119],
              [49.2186646, 34.8466235],
              [49.2183844, 34.8460641],
              [49.2117179, 34.8421758],
              [49.209498, 34.8421757],
              [49.2067182, 34.8438357],
              [49.2058846, 34.8460641],
              [49.205608, 34.8471738],
              [49.2050514, 34.8480038],
              [49.2050514, 34.8482834],
              [49.2044983, 34.8513419],
              [49.2042181, 34.8530109],
              [49.2025513, 34.8577292],
              [49.2017181, 34.8585683],
              [49.1964414, 34.8613469],
              [49.1956083, 34.8613468],
              [49.1928281, 34.8621769],
              [49.1917183, 34.8621769],
              [49.1808852, 34.8646759],
              [49.1789383, 34.8657855],
              [49.1786617, 34.8657855],
              [49.1778285, 34.8655149],
              [49.1750519, 34.8663448],
              [49.1697717, 34.8663448],
              [49.1692186, 34.8660651],
              [49.1681052, 34.8660652],
              [49.1631052, 34.8607875],
              [49.1628287, 34.8588388],
              [49.1636618, 34.8566195],
              [49.1681053, 34.8494021],
              [49.1678287, 34.8491224],
              [49.1672721, 34.8468941],
              [49.1639385, 34.841896],
              [49.1619955, 34.8391172],
              [49.1586622, 34.8327298],
              [49.1586622, 34.8318998],
              [49.1575488, 34.8285617],
              [49.1544954, 34.8066203],
              [49.1492156, 34.7971742],
              [49.1425491, 34.7910662],
              [49.1392158, 34.788558],
              [49.1153259, 34.772733],
              [49.1089363, 34.766616],
              [49.1086594, 34.7663363],
              [49.1072695, 34.7649559],
              [49.1072695, 34.7646762],
              [49.1033795, 34.7555095],
              [49.1031031, 34.7535606],
              [49.1028265, 34.7505111],
              [49.1025464, 34.7377264],
              [49.1050462, 34.7280092],
              [49.1056032, 34.7274497],
              [49.1211594, 34.6996692],
              [49.1239361, 34.6952299],
              [49.1244927, 34.6943908],
              [49.1281061, 34.6860629],
              [49.1311593, 34.676616],
              [49.1314394, 34.6760656],
              [49.1314394, 34.6743963],
              [49.1317159, 34.6741167],
              [49.1317159, 34.6735572],
              [49.1317159, 34.6716173],
              [49.1319929, 34.6693887],
              [49.1322729, 34.6682788],
              [49.1325496, 34.6668893],
              [49.1328262, 34.6652291],
              [49.1331063, 34.6635599],
              [49.1333829, 34.6605011],
              [49.1336593, 34.6599507],
              [49.1336594, 34.6552226],
              [49.1350497, 34.6480043],
              [49.1328262, 34.6366172],
              [49.1353263, 34.629119],
              [49.1350497, 34.6280001],
              [49.1347728, 34.6221712],
              [49.1350498, 34.6205019],
              [49.1353263, 34.6188326],
              [49.1356064, 34.6182732],
              [49.1347728, 34.6135541],
              [49.1278262, 34.6030058],
              [49.1203265, 34.5971678],
              [49.1197698, 34.5968881],
              [49.1189367, 34.5963286],
              [49.118103, 34.5960579],
              [49.1069934, 34.5866104],
              [49.1061601, 34.5866104],
              [49.1056036, 34.5863307],
              [49.1028269, 34.5857803],
              [49.1003269, 34.5857803],
              [49.0994937, 34.5855006],
              [49.0972702, 34.5852299],
              [49.0939369, 34.5852298],
              [49.0933803, 34.5849501],
              [49.0906036, 34.5849501],
              [49.090047, 34.5846704],
              [49.0869903, 34.5846704],
              [49.0864372, 34.5843907],
              [49.0831035, 34.5843906],
              [49.0825468, 34.5846704],
              [49.0811569, 34.5846704],
              [49.0808804, 34.58495],
              [49.0803237, 34.5849501],
              [49.0800472, 34.5852298],
              [49.0775471, 34.58606],
              [49.0753236, 34.588],
              [49.0742139, 34.5902288],
              [49.0739372, 34.5907792],
              [49.0742138, 34.5916093],
              [49.0739373, 34.5924485],
              [49.0742138, 34.5932786],
              [49.0742138, 34.6055052],
              [49.0700468, 34.6227215],
              [49.0700468, 34.6285595],
              [49.0683804, 34.6321687],
              [49.0672671, 34.6329988],
              [49.0633803, 34.6346681],
              [49.0625471, 34.634668],
              [49.0619904, 34.6349478],
              [49.060047, 34.6349478],
              [49.0550473, 34.6329988],
              [49.0442108, 34.6163331],
              [49.0397673, 34.614393],
              [49.0383775, 34.614393],
              [49.0356008, 34.6135539],
              [49.0319911, 34.6135538],
              [49.0311543, 34.6132742],
              [49.0239342, 34.6121643],
              [49.0208775, 34.6093941],
              [49.0197677, 34.6077248],
              [49.0186544, 34.6060555],
              [49.0114313, 34.6018867],
              [49.0097644, 34.6018868],
              [49.0097644, 34.601607],
              [49.0028213, 34.5991166],
              [49.0011545, 34.5974473],
              [49.0014314, 34.5971675],
              [49.005878, 34.5907791],
              [49.0078211, 34.58689],
              [49.0086547, 34.5860598],
              [49.0194878, 34.569944],
              [49.0203211, 34.5693936],
              [49.0283778, 34.5613357],
              [49.0286544, 34.5605054],
              [49.029211, 34.5602258],
              [49.0314346, 34.5546672],
              [49.0317111, 34.5543875],
              [49.0317111, 34.551888],
              [49.0317111, 34.5485583],
              [49.033101, 34.5452195],
              [49.0336577, 34.5449398],
              [49.0339342, 34.5443894],
              [49.039491, 34.5363403],
              [49.0400442, 34.5302222],
              [49.0447677, 34.5218843],
              [49.0539343, 34.5107761],
              [49.0547675, 34.5079968],
              [49.0547675, 34.5074373],
              [49.0547675, 34.5052174],
              [49.0531008, 34.5013372],
              [49.0492108, 34.4988286],
              [49.0339344, 34.4960582],
              [49.0314347, 34.4952189],
              [49.0197681, 34.4793909],
              [49.0119882, 34.4724424],
              [49.0103214, 34.4710528],
              [49.0036549, 34.4657827],
              [49.0036549, 34.4652232],
              [49.0030982, 34.4624438],
              [49.0067116, 34.4593847],
              [49.0072647, 34.4591139],
              [49.0072647, 34.4588342],
              [49.014768, 34.4516058],
              [49.0156017, 34.4477255],
              [49.0153216, 34.4454965],
              [49.0108782, 34.4360482],
              [49.0078215, 34.4313285],
              [49.0053219, 34.4257695],
              [49.003655, 34.4238294],
              [49.0005983, 34.4221598],
              [48.9983783, 34.4216093],
              [48.9961552, 34.4207791],
              [48.994765, 34.4207791],
              [48.9942118, 34.4204994],
              [48.9880985, 34.4204994],
              [48.9875418, 34.4202196],
              [48.986432, 34.4202195],
              [48.9858754, 34.4199399],
              [48.9842086, 34.4199398],
              [48.9828222, 34.4193893],
              [48.9819886, 34.4193894],
              [48.977542, 34.4174401],
              [48.9661523, 34.4099408],
              [48.9555955, 34.4043818],
              [48.9528193, 34.4016113],
              [48.951429, 34.3996621],
              [48.9511524, 34.3991026],
              [48.9497625, 34.3896629],
              [48.9500427, 34.388553],
              [48.9525423, 34.3841129],
              [48.9547623, 34.3829938],
              [48.9561526, 34.3827231],
              [48.9583757, 34.3827231],
              [48.9589323, 34.3824434],
              [48.9603191, 34.3824433],
              [48.9608757, 34.3827232],
              [48.9647657, 34.3832737],
              [48.9683754, 34.3841129],
              [48.9747655, 34.3866037],
              [48.9755987, 34.3866037],
              [48.9836556, 34.389663],
              [48.9855989, 34.389663],
              [48.9894889, 34.389663],
              [48.990322, 34.3893833],
              [48.9917088, 34.3893833],
              [48.9922654, 34.3891035],
              [49.007265, 34.3843837],
              [49.0122651, 34.3782741],
              [49.0092119, 34.3618855],
              [49.009212, 34.3568859],
              [49.0094885, 34.3557759],
              [49.0097652, 34.3549366],
              [49.0161973, 34.3448964],
              [49.015602, 34.344107],
              [49.0150454, 34.3432767],
              [49.0153219, 34.3416072],
              [49.0158785, 34.3388275],
              [49.0147683, 34.3332683],
              [49.0125454, 34.3296674],
              [49.0089319, 34.3257687],
              [49.0089319, 34.3241081],
              [49.0108785, 34.3224386],
              [49.015602, 34.3193881],
              [49.0208784, 34.3096594],
              [49.0256019, 34.3054899],
              [49.0331017, 34.3032698],
              [49.0361584, 34.3032698],
              [49.036435, 34.30299],
              [49.038935, 34.3029901],
              [49.0400447, 34.3027102],
              [49.0433781, 34.2996598],
              [49.0450449, 34.2977195],
              [49.0506017, 34.2904905],
              [49.0639348, 34.2863209],
              [49.0642148, 34.2860502],
              [49.0644914, 34.2857705],
              [49.0650481, 34.2854907],
              [49.0700478, 34.2835504],
              [49.0789379, 34.2738304],
              [49.0792144, 34.2735506],
              [49.0839379, 34.2629913],
              [49.0919944, 34.2582712],
              [49.0931046, 34.2582711],
              [49.0933811, 34.2579913],
              [49.0967143, 34.2577117],
              [49.0975476, 34.2574409],
              [49.0986609, 34.2574408],
              [49.0992145, 34.2571611],
              [49.1006043, 34.2571611],
              [49.1011609, 34.2568813],
              [49.1033809, 34.2568813],
              [49.1039376, 34.2566016],
              [49.1061611, 34.2566016],
              [49.1092174, 34.2557712],
              [49.1106041, 34.2557712],
              [49.1133842, 34.2546612],
              [49.1194941, 34.2510511],
              [49.1217173, 34.2488219],
              [49.1219942, 34.2479916],
              [49.1228274, 34.2466017],
              [49.1236607, 34.2435512],
              [49.1239373, 34.2429916],
              [49.1231041, 34.2374411],
              [49.1189375, 34.2296613],
              [49.118661, 34.2293815],
              [49.118384, 34.2291108],
              [49.1169941, 34.2271613],
              [49.1161609, 34.2257714],
              [49.1153274, 34.2218815],
              [49.1156044, 34.2202118],
              [49.1242174, 34.2032713],
              [49.124494, 34.2029915],
              [49.1242175, 34.2021611],
              [49.1236607, 34.2018813],
              [49.1236608, 34.2016016],
              [49.1239374, 34.2004914],
              [49.1242175, 34.1991015],
              [49.1244941, 34.1985419],
              [49.1233842, 34.1910418],
              [49.1197709, 34.1863215],
              [49.1114376, 34.1824315],
              [49.1106044, 34.1824315],
              [49.1072711, 34.1810416],
              [49.1052979, 34.1806167],
              [49.1025479, 34.1796606],
              [49.0997713, 34.1788212],
              [49.0947712, 34.1721604],
              [49.093938, 34.1691007],
              [49.0936614, 34.1641006],
              [49.093938, 34.1627197],
              [49.0979816, 34.1558944],
              [49.0983811, 34.1554901],
              [49.0989378, 34.1552104],
              [49.0992148, 34.1546598],
              [49.1000479, 34.1535496],
              [49.1003281, 34.1532699],
              [49.1008811, 34.1532698],
              [49.1044946, 34.1513293],
              [49.1081043, 34.1471595],
              [49.1092177, 34.145219],
              [49.1103279, 34.1432695],
              [49.1108845, 34.1429897],
              [49.1111611, 34.1421593],
              [49.1167179, 34.1352185],
              [49.1383843, 34.1193784],
              [49.1392176, 34.1193784],
              [49.1394941, 34.1190986],
              [49.1500506, 34.1165984],
              [49.1525506, 34.1165985],
              [49.1531073, 34.1163186],
              [49.1572738, 34.1157682],
              [49.1597739, 34.1157681],
              [49.1606071, 34.1160479],
              [49.1683874, 34.1171581],
              [49.1717207, 34.1171582],
              [49.1736636, 34.1163187],
              [49.1750539, 34.1121578],
              [49.1753304, 34.1115983],
              [49.1734573, 34.1031297],
              [49.173107, 34.1027078],
              [49.1728305, 34.1018774],
              [49.1714405, 34.1002076],
              [49.171164, 34.0999368],
              [49.1672741, 34.0935465],
              [49.153664, 34.0838255],
              [49.1472741, 34.0807658],
              [49.1419944, 34.0766048],
              [49.1225514, 34.0546535],
              [49.1214377, 34.0538231],
              [49.1172712, 34.0515936],
              [49.107828, 34.0482629],
              [49.1031049, 34.0446525],
              [49.1017147, 34.0404824],
              [49.0975482, 34.0288207],
              [49.091995, 34.0218704],
              [49.0811585, 34.0152091],
              [49.0803252, 34.0152091],
              [49.0797717, 34.0149293],
              [49.0786584, 34.0149292],
              [49.0775724, 34.01471],
              [49.0708821, 34.0102085],
              [49.0544924, 34.0015975],
              [49.0542158, 33.9999276],
              [49.0561588, 33.9946562],
              [49.0564354, 33.9940966],
              [49.0553256, 33.9885453],
              [49.0528256, 33.9860451],
              [49.052549, 33.9857652],
              [49.0417125, 33.9763146],
              [49.0386593, 33.9749335],
              [49.0381026, 33.9752134],
              [49.037546, 33.9749335],
              [49.037269, 33.9752134],
              [49.0306025, 33.9763146],
              [49.0303224, 33.9768742],
              [49.0228226, 33.9813242],
              [49.0211562, 33.9818748],
              [49.0194894, 33.9818748],
              [49.0189361, 33.9821546],
              [49.0158795, 33.9824255],
              [49.0128228, 33.9824254],
              [49.0119895, 33.9821546],
              [49.0103227, 33.9821546],
              [49.0100462, 33.9818748],
              [49.0089329, 33.9818748],
              [49.0086564, 33.981595],
              [48.9980995, 33.9777046],
              [48.9878231, 33.9721534],
              [48.9869899, 33.9721533],
              [48.9686532, 33.9596517],
              [48.9658766, 33.9566007],
              [48.9653199, 33.9560411],
              [48.9619867, 33.9499301],
              [48.9614336, 33.9443698],
              [48.9617101, 33.9427089],
              [48.9639336, 33.9393781],
              [48.9636535, 33.9365979],
              [48.9575437, 33.927427],
              [48.9564304, 33.922706],
              [48.9561538, 33.9224262],
              [48.9564304, 33.9218755],
              [48.9561538, 33.921325],
              [48.9558769, 33.9199348],
              [48.9555968, 33.9168748],
              [48.9575438, 33.9102041],
              [48.9594871, 33.9079835],
              [48.9606005, 33.9074239],
              [48.9628205, 33.9054832]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 230033,
        "tags": {
          "ISO3166-2": "IR-14",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "چهارمحال بختیاری",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q171702"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [49.5008323, 32.7160473],
              [49.5008256, 32.7156708],
              [49.5004487, 32.7147847],
              [49.500289, 32.7138876],
              [49.5002391, 32.7113466],
              [49.5002055, 32.7096321],
              [49.5000772, 32.7030932],
              [49.5005647, 32.7029502],
              [49.5019189, 32.7017893],
              [49.5033838, 32.7005418],
              [49.5050086, 32.6987415],
              [49.5067979, 32.6968462],
              [49.5086364, 32.6948139],
              [49.5102616, 32.6930992],
              [49.5124283, 32.6904213],
              [49.5143737, 32.6875581],
              [49.5160483, 32.6849713],
              [49.5166427, 32.6844458],
              [49.5207596, 32.6808058],
              [49.5259551, 32.676179],
              [49.5337981, 32.6690056],
              [49.5370444, 32.6660918],
              [49.5419617, 32.6611409],
              [49.5424463, 32.6599424],
              [49.5437966, 32.6589659],
              [49.5458526, 32.6576233],
              [49.547474, 32.6562801],
              [49.5504495, 32.6539198],
              [49.5522843, 32.6520649],
              [49.5540123, 32.6502155],
              [49.5556298, 32.6482272],
              [49.5570297, 32.6460538],
              [49.5578346, 32.6450393],
              [49.5591317, 32.6437418],
              [49.5600471, 32.6425392],
              [49.5615042, 32.6411511],
              [49.5632821, 32.638885],
              [49.5649528, 32.63671],
              [49.5804386, 32.6324168],
              [49.5850411, 32.6271839],
              [49.5937501, 32.6180594],
              [49.5981825, 32.6136233],
              [49.6044446, 32.6053229],
              [49.6096134, 32.5985551],
              [49.615553, 32.5897906],
              [49.6214599, 32.5804755],
              [49.625492, 32.573668],
              [49.6339988, 32.5683713],
              [49.6429138, 32.5618039],
              [49.6424369, 32.5590087],
              [49.646515, 32.555253],
              [49.6504287, 32.551633],
              [49.6538046, 32.5483859],
              [49.6579895, 32.5447663],
              [49.6613617, 32.5413318],
              [49.6629104, 32.5392917],
              [49.6644555, 32.5369765],
              [49.6659052, 32.5358621],
              [49.6684798, 32.534047],
              [49.6706276, 32.5326987],
              [49.6729394, 32.5313499],
              [49.6746065, 32.5306007],
              [49.6762163, 32.5296706],
              [49.6781998, 32.5283655],
              [49.6799164, 32.5270193],
              [49.6822244, 32.5254356],
              [49.6841545, 32.5242269],
              [49.6864089, 32.5230147],
              [49.6895295, 32.521798],
              [49.691677, 32.5205372],
              [49.6943625, 32.5190926],
              [49.6978455, 32.5168602],
              [49.7018739, 32.5147595],
              [49.7031022, 32.5137822],
              [49.7043381, 32.5129922],
              [49.7055131, 32.5118339],
              [49.7072716, 32.510066],
              [49.7090254, 32.5080787],
              [49.7111625, 32.5056568],
              [49.7152214, 32.5018039],
              [49.7174808, 32.499608],
              [49.7177055, 32.4994095],
              [49.7233847, 32.4944183],
              [49.7273407, 32.4906428],
              [49.7292441, 32.4886122],
              [49.7312048, 32.486634],
              [49.7325097, 32.4846041],
              [49.7360458, 32.4805941],
              [49.7381668, 32.4785701],
              [49.7404517, 32.476356],
              [49.7425242, 32.4744554],
              [49.7462014, 32.4717702],
              [49.749868, 32.4698087],
              [49.7540742, 32.4673315],
              [49.7575284, 32.4655334],
              [49.7616233, 32.4610782],
              [49.7640036, 32.4577814],
              [49.7714177, 32.4524451],
              [49.778963, 32.4456327],
              [49.7857571, 32.4389686],
              [49.7904243, 32.4342615],
              [49.7982388, 32.4275802],
              [49.8010942, 32.4196634],
              [49.8045235, 32.4100631],
              [49.8102129, 32.3930142],
              [49.8167877, 32.386262],
              [49.8289508, 32.377623],
              [49.8530845, 32.3596866],
              [49.8671969, 32.3496697],
              [49.874349, 32.3450448],
              [49.8791293, 32.3419225],
              [49.9051973, 32.325037],
              [49.9115182, 32.3160824],
              [49.9214428, 32.3037715],
              [49.9217128, 32.2908507],
              [49.9221257, 32.2853031],
              [49.9225233, 32.2791611],
              [49.9232014, 32.2669626],
              [49.9195109, 32.2670891],
              [49.922121, 32.2576828],
              [49.9235078, 32.2528076],
              [49.924183, 32.2453158],
              [49.9264878, 32.2372759],
              [49.9276542, 32.2314887],
              [49.9293527, 32.2261526],
              [49.9305791, 32.2178471],
              [49.9313677, 32.2130224],
              [49.9350575, 32.2060517],
              [49.9380597, 32.1992988],
              [49.9422491, 32.1893702],
              [49.947463, 32.1775298],
              [49.9612093, 32.1633836],
              [49.967267, 32.156911],
              [49.9726179, 32.1512555],
              [49.9864806, 32.1369787],
              [49.9961013, 32.1268392],
              [50.0067901, 32.1159335],
              [50.0124581, 32.1100709],
              [50.0159342, 32.1063199],
              [50.0225048, 32.1009987],
              [50.0420244, 32.0845968],
              [50.0569324, 32.0723358],
              [50.0775086, 32.0559369],
              [50.0963785, 32.0426499],
              [50.1098917, 32.0313638],
              [50.1195602, 32.0228919],
              [50.1238784, 32.0190257],
              [50.132555, 32.0115769],
              [50.1436824, 32.0019204],
              [50.1561069, 31.9944648],
              [50.1694679, 31.988155],
              [50.1792568, 31.9802829],
              [50.1847512, 31.9798737],
              [50.1883103, 31.9769883],
              [50.1923634, 31.9720886],
              [50.2004484, 31.969383],
              [50.2038212, 31.9668946],
              [50.2051625, 31.9653588],
              [50.2088598, 31.9618277],
              [50.2134921, 31.9572585],
              [50.2207655, 31.9545741],
              [50.2246314, 31.9512991],
              [50.2264832, 31.9496986],
              [50.2309664, 31.9477381],
              [50.2345071, 31.9461685],
              [50.236076, 31.9434398],
              [50.2371643, 31.9415882],
              [50.2375261, 31.9409835],
              [50.2385688, 31.9391792],
              [50.240243, 31.9363772],
              [50.2399325, 31.9345101],
              [50.2397404, 31.9318632],
              [50.2418073, 31.930283],
              [50.2420449, 31.9252258],
              [50.2417223, 31.9251826],
              [50.2426374, 31.9214044],
              [50.2468437, 31.9175632],
              [50.2526574, 31.9130624],
              [50.2526596, 31.9057781],
              [50.2563841, 31.901378],
              [50.2597861, 31.8972734],
              [50.2674633, 31.8918215],
              [50.2741246, 31.8871328],
              [50.281511, 31.8803941],
              [50.2825244, 31.8761586],
              [50.2835757, 31.8721109],
              [50.2862618, 31.8683982],
              [50.2881296, 31.8661445],
              [50.2891691, 31.86344],
              [50.2848089, 31.8608721],
              [50.2815276, 31.8588175],
              [50.2782641, 31.8577355],
              [50.2790087, 31.8526348],
              [50.2792148, 31.8509172],
              [50.2841049, 31.8524667],
              [50.2850119, 31.8484667],
              [50.2859096, 31.8445838],
              [50.2923275, 31.8439207],
              [50.2967343, 31.8391379],
              [50.3014001, 31.8343512],
              [50.3081556, 31.826769],
              [50.3126157, 31.8222215],
              [50.3118202, 31.8196353],
              [50.3077107, 31.8060296],
              [50.3214341, 31.7917363],
              [50.3232211, 31.77797],
              [50.3512564, 31.7570168],
              [50.3868137, 31.7301895],
              [50.3858906, 31.7159837],
              [50.3832816, 31.7030614],
              [50.3835957, 31.6939611],
              [50.387064, 31.686168],
              [50.3944141, 31.676361],
              [50.4056337, 31.6650457],
              [50.4096387, 31.6550502],
              [50.441513, 31.6189189],
              [50.4279251, 31.6109122],
              [50.4168909, 31.6043103],
              [50.4106532, 31.6005631],
              [50.4056058, 31.5956991],
              [50.4007967, 31.5982059],
              [50.396157, 31.5971395],
              [50.3934777, 31.5960909],
              [50.3938986, 31.5949796],
              [50.3948177, 31.5928883],
              [50.3916923, 31.5885383],
              [50.3873748, 31.5836988],
              [50.3843071, 31.5795029],
              [50.3831806, 31.5740522],
              [50.3808016, 31.5688514],
              [50.3781561, 31.5684996],
              [50.3749127, 31.5681997],
              [50.3702234, 31.5696634],
              [50.3649115, 31.5618989],
              [50.3631932, 31.5581894],
              [50.3632014, 31.5576644],
              [50.363045, 31.5571383],
              [50.3612668, 31.5520873],
              [50.3622079, 31.5498707],
              [50.3692391, 31.5500495],
              [50.3694927, 31.5468553],
              [50.3662024, 31.5403525],
              [50.3637172, 31.5350593],
              [50.3613097, 31.5302529],
              [50.3519581, 31.5125104],
              [50.3490391, 31.5029313],
              [50.3495668, 31.4989908],
              [50.3478221, 31.4920615],
              [50.3350126, 31.4733068],
              [50.3233738, 31.4601098],
              [50.3189523, 31.4572918],
              [50.3262017, 31.4507304],
              [50.3322286, 31.4455016],
              [50.3424963, 31.4344152],
              [50.3529031, 31.4296486],
              [50.3637067, 31.4248693],
              [50.3748315, 31.4219734],
              [50.3841116, 31.4194267],
              [50.4014976, 31.4195344],
              [50.4094106, 31.4197303],
              [50.4146058, 31.4197359],
              [50.4191291, 31.423027],
              [50.4199624, 31.4281257],
              [50.4196494, 31.4322],
              [50.421767, 31.4352611],
              [50.4296708, 31.4356921],
              [50.4410377, 31.4334915],
              [50.4499874, 31.4313345],
              [50.4601692, 31.4289306],
              [50.476229, 31.4276498],
              [50.4773392, 31.4282096],
              [50.4781513, 31.4289187],
              [50.4795622, 31.4301506],
              [50.4803955, 31.431261],
              [50.492062, 31.4498766],
              [50.4956754, 31.4518177],
              [50.4965086, 31.4518176],
              [50.4976188, 31.4523773],
              [50.5003954, 31.4526482],
              [50.5081752, 31.4518177],
              [50.509285, 31.4512579],
              [50.5123417, 31.4504274],
              [50.5226184, 31.4448752],
              [50.5295651, 31.4401535],
              [50.5303983, 31.4401535],
              [50.530955, 31.4398737],
              [50.5315082, 31.4398737],
              [50.5342882, 31.4398737],
              [50.537898, 31.441264],
              [50.5390083, 31.4412641],
              [50.5423447, 31.4401536],
              [50.5426212, 31.4395938],
              [50.5437314, 31.4384834],
              [50.5440115, 31.4368223],
              [50.5442881, 31.4365424],
              [50.5440115, 31.4351521],
              [50.5442881, 31.4337618],
              [50.5445646, 31.4329312],
              [50.5448447, 31.4326514],
              [50.5470646, 31.4304306],
              [50.5476214, 31.4304305],
              [50.5606778, 31.4234881],
              [50.5681776, 31.4134852],
              [50.5681776, 31.4132054],
              [50.5687342, 31.4123748],
              [50.5737344, 31.4090435],
              [50.5767875, 31.4087636],
              [50.5804009, 31.410154],
              [50.5951242, 31.4195972],
              [50.5967906, 31.4195971],
              [50.5981774, 31.4201478],
              [50.6045673, 31.4201479],
              [50.6048474, 31.4204277],
              [50.6054005, 31.4204277],
              [50.6059572, 31.4207075],
              [50.6062338, 31.4207075],
              [50.6070671, 31.4204278],
              [50.6084573, 31.4204277],
              [50.609014, 31.4201478],
              [50.611514, 31.4195972],
              [50.6129004, 31.4195971],
              [50.6131804, 31.4193172],
              [50.6181805, 31.4193173],
              [50.6187371, 31.4190374],
              [50.619847, 31.4190375],
              [50.6204036, 31.4187576],
              [50.6217904, 31.4184868],
              [50.6301237, 31.4187577],
              [50.6301238, 31.4187577],
              [50.6301238, 31.4187579],
              [50.6301237, 31.4190374],
              [50.6301238, 31.4190375],
              [50.6315136, 31.419877],
              [50.6315137, 31.4198771],
              [50.6379034, 31.4273792],
              [50.6395699, 31.42765],
              [50.6412367, 31.4268195],
              [50.6417934, 31.4259889],
              [50.6473467, 31.4182069],
              [50.6490131, 31.4173673],
              [50.6515132, 31.4170965],
              [50.6520698, 31.4173673],
              [50.6545698, 31.4170965],
              [50.6545698, 31.4170964],
              [50.6545698, 31.4170956],
              [50.6545699, 31.4168167],
              [50.6545699, 31.4168166],
              [50.6556797, 31.4168166],
              [50.6559597, 31.4165368],
              [50.6601266, 31.4154263],
              [50.6617931, 31.4154264],
              [50.6623499, 31.4151466],
              [50.6690162, 31.4129256],
              [50.6709597, 31.4126548],
              [50.6740164, 31.4126548],
              [50.6742929, 31.4123749],
              [50.6751261, 31.4123749],
              [50.6756829, 31.4120952],
              [50.679016, 31.4107048],
              [50.6822057, 31.402467],
              [50.6992962, 31.3940394],
              [50.7009626, 31.3909881],
              [50.7165191, 31.3845965],
              [50.7176291, 31.3840366],
              [50.7198524, 31.3832062],
              [50.7242957, 31.3793152],
              [50.7245793, 31.3784822],
              [50.7240191, 31.3709825],
              [50.7245722, 31.370152],
              [50.749852, 31.3487564],
              [50.7506864, 31.3473736],
              [50.7554087, 31.3407038],
              [50.7787455, 31.3223659],
              [50.7892982, 31.3143162],
              [50.7901314, 31.3143161],
              [50.7906944, 31.3140365],
              [50.7915276, 31.3140364],
              [50.7917982, 31.3137564],
              [50.7962447, 31.312926],
              [50.7987446, 31.3120954],
              [50.8006942, 31.311256],
              [50.8062507, 31.3082047],
              [50.8079112, 31.3082045],
              [50.8079113, 31.3082047],
              [50.8081879, 31.3084844],
              [50.8140211, 31.3095948],
              [50.8140263, 31.3095948],
              [50.8140264, 31.3095948],
              [50.8140495, 31.3095948],
              [50.8168013, 31.3095948],
              [50.8170778, 31.3093149],
              [50.8179172, 31.309315],
              [50.8204172, 31.3079248],
              [50.8265304, 31.3009827],
              [50.8304108, 31.3009825],
              [50.8312442, 31.3007027],
              [50.8359676, 31.3004319],
              [50.8362442, 31.300143],
              [50.8376343, 31.2995923],
              [50.8393049, 31.2990402],
              [50.8431909, 31.2976514],
              [50.8437441, 31.2970917],
              [50.8556906, 31.2907093],
              [50.8568068, 31.2907094],
              [50.8570867, 31.2904206],
              [50.8598571, 31.2904204],
              [50.86014, 31.2907095],
              [50.8637472, 31.2926502],
              [50.8718037, 31.2995923],
              [50.8781903, 31.3034832],
              [50.8801431, 31.3045937],
              [50.8890326, 31.3082046],
              [50.889033, 31.3082047],
              [50.8906938, 31.3082047],
              [50.890694, 31.3082047],
              [50.8912529, 31.3084847],
              [50.8923632, 31.3087547],
              [50.8923633, 31.3087547],
              [50.8923662, 31.3087554],
              [50.9118091, 31.3051445],
              [50.9198925, 31.3009305],
              [50.9245891, 31.2984821],
              [50.9254225, 31.2976517],
              [50.9273657, 31.2965323],
              [50.9370889, 31.2865388],
              [50.9390357, 31.2843181],
              [50.959592, 31.2629232],
              [50.9604254, 31.2626523],
              [50.963202, 31.2604226],
              [50.9613761, 31.2398818],
              [50.9694423, 31.2265568],
              [50.9791626, 31.2195027],
              [50.9791627, 31.2195027],
              [50.998246, 31.2056484],
              [51.0195945, 31.1901454],
              [51.0204234, 31.189033],
              [51.0206999, 31.1887622],
              [51.0309765, 31.1818113],
              [51.0406997, 31.1787511],
              [51.0457019, 31.1787534],
              [51.0459828, 31.1790405],
              [51.0459843, 31.1790421],
              [51.0537608, 31.1804232],
              [51.0634031, 31.1849473],
              [51.0695198, 31.1878166],
              [51.06952, 31.1878167],
              [51.0695203, 31.1878169],
              [51.0695204, 31.1878169],
              [51.0715036, 31.1887497],
              [51.071533, 31.1887635],
              [51.071534, 31.188764],
              [51.0715343, 31.1887642],
              [51.0715344, 31.1887642],
              [51.07154, 31.1887642],
              [51.0784776, 31.1887642],
              [51.0887576, 31.1854241],
              [51.0957008, 31.1818133],
              [51.1290385, 31.1573662],
              [51.1487601, 31.1501465],
              [51.1504267, 31.1501465],
              [51.1509834, 31.1498667],
              [51.1529212, 31.1498667],
              [51.1529267, 31.1498667],
              [51.1529271, 31.1498668],
              [51.1537596, 31.1501464],
              [51.15376, 31.1501465],
              [51.1537655, 31.1501465],
              [51.1548662, 31.1501446],
              [51.1548714, 31.1501446],
              [51.1548722, 31.1501447],
              [51.1579281, 31.1506951],
              [51.1579281, 31.1506952],
              [51.1601504, 31.1515344],
              [51.1601514, 31.1515347],
              [51.1601514, 31.1515348],
              [51.1601517, 31.1515349],
              [51.1601518, 31.151535],
              [51.1615379, 31.1523652],
              [51.161538, 31.1523652],
              [51.1645946, 31.157646],
              [51.164318, 31.1584765],
              [51.1643175, 31.158477],
              [51.1643167, 31.1584778],
              [51.1643162, 31.1584782],
              [51.164038, 31.1587563],
              [51.1640381, 31.1587567],
              [51.1640382, 31.1587573],
              [51.1645946, 31.1634774],
              [51.1645947, 31.1634774],
              [51.1707078, 31.1665286],
              [51.1707079, 31.1665286],
              [51.1709846, 31.1670883],
              [51.179041, 31.1748696],
              [51.1801494, 31.1818134],
              [51.1848728, 31.1898746],
              [51.1848742, 31.190983],
              [51.1845963, 31.1923661],
              [51.1843176, 31.1932037],
              [51.1843167, 31.1932056],
              [51.1829276, 31.195984],
              [51.179041, 31.2012559],
              [51.1790408, 31.201257],
              [51.1787611, 31.202646],
              [51.1804257, 31.209869],
              [51.1804258, 31.2098692],
              [51.1804259, 31.2098696],
              [51.182926, 31.2098698],
              [51.1840395, 31.20959],
              [51.1873622, 31.20959],
              [51.1873673, 31.20959],
              [51.1873729, 31.20959],
              [51.1873732, 31.2095902],
              [51.1873739, 31.2095904],
              [51.2237627, 31.2237604],
              [51.2237634, 31.2237607],
              [51.2237637, 31.2237608],
              [51.2237693, 31.2237608],
              [51.2237744, 31.2237608],
              [51.2268188, 31.2237628],
              [51.2326911, 31.220402],
              [51.236542, 31.218202],
              [51.2454319, 31.2093192],
              [51.2520999, 31.2068077],
              [51.2570765, 31.2063379],
              [51.2579332, 31.206257],
              [51.2598265, 31.2078841],
              [51.260496, 31.2097561],
              [51.2622727, 31.2115399],
              [51.2656716, 31.214645],
              [51.2673196, 31.215658],
              [51.2710789, 31.2157681],
              [51.2729329, 31.2157901],
              [51.2759713, 31.215724],
              [51.2784432, 31.2149973],
              [51.2814559, 31.2139183],
              [51.284417, 31.2125089],
              [51.2869662, 31.2102846],
              [51.2901849, 31.2076639],
              [51.2913411, 31.2075568],
              [51.2948026, 31.2072362],
              [51.2961158, 31.2083153],
              [51.2985105, 31.2085135],
              [51.3022699, 31.2086016],
              [51.3043041, 31.2073023],
              [51.3060293, 31.2056064],
              [51.3121318, 31.2004748],
              [51.3156337, 31.197986],
              [51.3216333, 31.1941535],
              [51.3264484, 31.1892415],
              [51.3276843, 31.1871488],
              [51.3316497, 31.1832057],
              [51.3326024, 31.1814434],
              [51.3356224, 31.1788507],
              [51.3353907, 31.1804809],
              [51.332481, 31.1875301],
              [51.332069, 31.1941603],
              [51.3332793, 31.2004155],
              [51.3346955, 31.207265],
              [51.3360087, 31.2123963],
              [51.3400513, 31.226027],
              [51.3400256, 31.2353405],
              [51.3408238, 31.2430901],
              [51.3409954, 31.2464676],
              [51.3389612, 31.2527634],
              [51.3408666, 31.2559332],
              [51.3469434, 31.2630427],
              [51.3468404, 31.2664323],
              [51.3447033, 31.2726607],
              [51.3388324, 31.2780085],
              [51.3347126, 31.2852045],
              [51.333057, 31.289992],
              [51.3288599, 31.2953828],
              [51.3277011, 31.2994532],
              [51.3286539, 31.3017634],
              [51.3287569, 31.3051075],
              [51.3258472, 31.3088035],
              [51.3208261, 31.3127853],
              [51.314981, 31.3211664],
              [51.3136421, 31.323608],
              [51.3116079, 31.3253897],
              [51.308003, 31.3298327],
              [51.3068958, 31.3334838],
              [51.3037544, 31.3384323],
              [51.2975746, 31.3453597],
              [51.2942775, 31.3521852],
              [51.2923463, 31.3538124],
              [51.2912648, 31.3553296],
              [51.2858317, 31.3658616],
              [51.2852652, 31.3672247],
              [51.2852652, 31.3695552],
              [51.2859605, 31.3733147],
              [51.2881492, 31.3754251],
              [51.2910846, 31.3768321],
              [51.2968781, 31.3780632],
              [51.2981656, 31.3780632],
              [51.3020094, 31.3770401],
              [51.305039, 31.3751668],
              [51.3085718, 31.3742308],
              [51.3107827, 31.3759747],
              [51.3136924, 31.3779972],
              [51.3149453, 31.3797876],
              [51.3156149, 31.3815458],
              [51.3143206, 31.384597],
              [51.3137674, 31.388488],
              [51.3140441, 31.3934804],
              [51.3084873, 31.4107055],
              [51.3073775, 31.4126555],
              [51.3068207, 31.4129264],
              [51.3043209, 31.4182076],
              [51.3043209, 31.4195979],
              [51.3040443, 31.4201486],
              [51.3037675, 31.4209882],
              [51.3034874, 31.4215389],
              [51.3032108, 31.4218188],
              [51.3030725, 31.4220986],
              [51.2890444, 31.4440364],
              [51.2884877, 31.4451559],
              [51.286821, 31.4468171],
              [51.283211, 31.4495976],
              [51.259598, 31.4593207],
              [51.259598, 31.4607111],
              [51.2701546, 31.4807082],
              [51.2704061, 31.4855638],
              [51.2723744, 31.4901515],
              [51.273004, 31.4911377],
              [51.2753, 31.4922256],
              [51.2749822, 31.4936781],
              [51.2745663, 31.4951612],
              [51.2735988, 31.4996013],
              [51.2729115, 31.5026075],
              [51.2722357, 31.5042154],
              [51.2798546, 31.5080603],
              [51.289119, 31.5105139],
              [51.2922434, 31.5127273],
              [51.2941387, 31.5239195],
              [51.2910349, 31.535373],
              [51.2917313, 31.5468213],
              [51.2926175, 31.5514879],
              [51.2971884, 31.5694447],
              [51.3016533, 31.5967894],
              [51.3023142, 31.6062341],
              [51.303194, 31.6131465],
              [51.3033854, 31.6159561],
              [51.3042286, 31.6225604],
              [51.3001656, 31.6407525],
              [51.2987276, 31.6469639],
              [51.3001509, 31.6673709],
              [51.3046868, 31.6768578],
              [51.3107153, 31.6816296],
              [51.3117178, 31.6832735],
              [51.3117693, 31.6848731],
              [51.3143957, 31.6952146],
              [51.3162754, 31.7045692],
              [51.3206527, 31.7081837],
              [51.326678, 31.7082933],
              [51.3332698, 31.7082933],
              [51.3447282, 31.7101771],
              [51.3505218, 31.7101333],
              [51.3567016, 31.712981],
              [51.3616455, 31.7144486],
              [51.3630102, 31.7158285],
              [51.3633964, 31.7172304],
              [51.3634737, 31.7197712],
              [51.3621605, 31.7217205],
              [51.3603838, 31.7230347],
              [51.3574226, 31.725422],
              [51.3472002, 31.7289043],
              [51.3418186, 31.7324084],
              [51.3370807, 31.7347297],
              [51.3301542, 31.7416935],
              [51.328532, 31.7446497],
              [51.3246181, 31.7501238],
              [51.3222749, 31.7534519],
              [51.3176401, 31.757174],
              [51.3137005, 31.7605238],
              [51.312619, 31.7629101],
              [51.3120268, 31.7670478],
              [51.3094518, 31.7730241],
              [51.3094776, 31.7760011],
              [51.3088854, 31.7794159],
              [51.3059757, 31.784297],
              [51.3047655, 31.7878865],
              [51.2995206, 31.7955587],
              [51.2938132, 31.8055718],
              [51.2931358, 31.810817],
              [51.2959805, 31.8183708],
              [51.2986787, 31.8222844],
              [51.2991162, 31.822919],
              [51.3095704, 31.8304012],
              [51.3189946, 31.835389],
              [51.3246908, 31.8371497],
              [51.3338832, 31.8402559],
              [51.3389558, 31.8407371],
              [51.3456249, 31.8399715],
              [51.348483, 31.839709],
              [51.3597612, 31.8492459],
              [51.3653745, 31.8555012],
              [51.36625, 31.8563979],
              [51.3697776, 31.8562448],
              [51.3776826, 31.8533141],
              [51.3811588, 31.8516737],
              [51.3837852, 31.8496615],
              [51.387521, 31.8489872],
              [51.3915457, 31.8490527],
              [51.3923825, 31.8490528],
              [51.3926591, 31.8493326],
              [51.3934924, 31.8493327],
              [51.3940491, 31.8493327],
              [51.3998822, 31.8507141],
              [51.4021022, 31.8518337],
              [51.4029355, 31.8518337],
              [51.4096022, 31.858497],
              [51.4109919, 31.8604382],
              [51.4121055, 31.8618287],
              [51.4132155, 31.8640498],
              [51.4140486, 31.8668307],
              [51.4143253, 31.8804463],
              [51.417382, 31.8940529],
              [51.4262719, 31.9126617],
              [51.4282151, 31.9268282],
              [51.4276585, 31.9296091],
              [51.4254384, 31.9354418],
              [51.4223817, 31.9404439],
              [51.4179385, 31.9451661],
              [51.4151585, 31.9484978],
              [51.4143253, 31.9493284],
              [51.4134919, 31.9512787],
              [51.4132154, 31.9523803],
              [51.4146052, 31.9573914],
              [51.414882, 31.958502],
              [51.4150071, 31.958677],
              [51.4161853, 31.9603245],
              [51.4176586, 31.9623844],
              [51.4226238, 31.964328],
              [51.4240483, 31.9648856],
              [51.4249413, 31.9653573],
              [51.433323, 31.9697844],
              [51.4335106, 31.9698835],
              [51.4340484, 31.9701675],
              [51.4342279, 31.971413],
              [51.4343282, 31.9721088],
              [51.433888, 31.9735093],
              [51.4327449, 31.9771462],
              [51.4312718, 31.9818331],
              [51.430715, 31.9826638],
              [51.4304383, 31.9837744],
              [51.4301617, 31.9862755],
              [51.4298817, 31.9907268],
              [51.4296051, 31.9923881],
              [51.4293249, 31.9937786],
              [51.429325, 31.9998914],
              [51.4248817, 32.0071056],
              [51.4143253, 32.0323871],
              [51.4040487, 32.0426623],
              [51.4029354, 32.0435021],
              [51.3967489, 32.0456769],
              [51.3875908, 32.0489633],
              [51.3869213, 32.0489852],
              [51.3868698, 32.0493125],
              [51.3855051, 32.0492252],
              [51.3851961, 32.0497054],
              [51.3842949, 32.0496399],
              [51.381823, 32.0510585],
              [51.3785014, 32.0527171],
              [51.3768792, 32.0556197],
              [51.3760294, 32.0583257],
              [51.3821577, 32.0674471],
              [51.3837799, 32.0698692],
              [51.3843256, 32.0701652],
              [51.3854355, 32.070725],
              [51.3859922, 32.0723864],
              [51.3862687, 32.0835014],
              [51.3865455, 32.0860024],
              [51.3862688, 32.0865532],
              [51.3857121, 32.0915555],
              [51.3851588, 32.0912755],
              [51.3823789, 32.0948871],
              [51.3818255, 32.0959978],
              [51.3676557, 32.1101647],
              [51.3573791, 32.12295],
              [51.3543226, 32.1307242],
              [51.3457126, 32.1396181],
              [51.3445994, 32.1404488],
              [51.3442305, 32.1406355],
              [51.3437659, 32.1409995],
              [51.3434894, 32.1407287],
              [51.3423794, 32.1409995],
              [51.3418227, 32.1412795],
              [51.3409892, 32.1412794],
              [51.3409893, 32.1415593],
              [51.340156, 32.1415594],
              [51.3326561, 32.1451711],
              [51.3320995, 32.1451711],
              [51.3309895, 32.1460017],
              [51.3268228, 32.1476721],
              [51.3020999, 32.1548866],
              [51.2998766, 32.1554463],
              [51.2934865, 32.1559972],
              [51.2926534, 32.1562771],
              [51.2890433, 32.1562771],
              [51.2876533, 32.1559972],
              [51.2845968, 32.1559972],
              [51.2843201, 32.1562771],
              [51.2826534, 32.1562771],
              [51.2820967, 32.1565569],
              [51.2779302, 32.1565569],
              [51.2684869, 32.1587782],
              [51.2593169, 32.1626698],
              [51.258207, 32.1632295],
              [51.2565403, 32.1635004],
              [51.2434838, 32.1685027],
              [51.2423741, 32.1687826],
              [51.2337608, 32.1743356],
              [51.232094, 32.1765568],
              [51.2315408, 32.1768367],
              [51.2309842, 32.1782272],
              [51.2218176, 32.1893332],
              [51.2218176, 32.1896132],
              [51.2212629, 32.190165],
              [51.2093177, 32.2051707],
              [51.2087611, 32.2062813],
              [51.1970946, 32.2182271],
              [51.194038, 32.2226696],
              [51.1937613, 32.2232294],
              [51.1923713, 32.22434],
              [51.1918146, 32.2246199],
              [51.1918146, 32.2251706],
              [51.1915378, 32.2254415],
              [51.1915378, 32.2257215],
              [51.1907047, 32.2265612],
              [51.185148, 32.2373964],
              [51.1843146, 32.2387869],
              [51.1812579, 32.2451706],
              [51.1684814, 32.2626696],
              [51.1657049, 32.2665613],
              [51.1462584, 32.2860105],
              [51.1457017, 32.2862814],
              [51.1443119, 32.2876719],
              [51.138202, 32.2921234],
              [51.1373686, 32.2923943],
              [51.1365351, 32.293225],
              [51.1337587, 32.2946154],
              [51.1326452, 32.2948954],
              [51.0795892, 32.3298933],
              [51.0784759, 32.330724],
              [51.0743093, 32.333505],
              [51.0465296, 32.3426698],
              [51.0418099, 32.3443403],
              [51.0318064, 32.351004],
              [51.02264, 32.3562862],
              [51.0220868, 32.356837],
              [51.0162533, 32.3610086],
              [50.9998944, 32.3679522],
              [50.9854172, 32.3760064],
              [50.973194, 32.3882322],
              [50.9710357, 32.3904972],
              [50.9709707, 32.3912842],
              [50.9706939, 32.392124],
              [50.9704173, 32.3937854],
              [50.9704173, 32.3951758],
              [50.9701373, 32.3954468],
              [50.9698606, 32.3971172],
              [50.9695841, 32.3996184],
              [50.9673605, 32.4146162],
              [50.9676373, 32.4254516],
              [50.9679174, 32.4293432],
              [50.9684705, 32.4335058],
              [50.9698606, 32.4379482],
              [50.9701371, 32.4396187],
              [50.9704172, 32.4401696],
              [50.9731939, 32.4457317],
              [50.9845837, 32.4604497],
              [50.9943069, 32.4740661],
              [50.9993068, 32.4835109],
              [50.9997917, 32.4840617],
              [50.9998634, 32.4846216],
              [51.0051401, 32.5012899],
              [51.0090299, 32.5148973],
              [51.0090299, 32.5151772],
              [51.0090299, 32.5165677],
              [51.00903, 32.5168386],
              [51.00903, 32.5176784],
              [51.0087499, 32.5182291],
              [51.0081965, 32.521561],
              [51.0079166, 32.5240621],
              [51.0001401, 32.5335069],
              [50.9984733, 32.5376786],
              [50.9981967, 32.5379584],
              [50.9990324, 32.5392043],
              [50.9981967, 32.545182],
              [50.9981966, 32.5457328],
              [50.9977867, 32.5505181],
              [50.995493, 32.5541074],
              [50.9821104, 32.5589312],
              [50.9736529, 32.5628285],
              [50.9623231, 32.5673038],
              [50.9549892, 32.5727917],
              [50.9465217, 32.57951],
              [50.9412699, 32.5870349],
              [50.9300017, 32.5957619],
              [50.9261418, 32.6000356],
              [50.923471, 32.6157379],
              [50.9231908, 32.6179591],
              [50.9229143, 32.621291],
              [50.9226377, 32.6246229],
              [50.9215851, 32.6279547],
              [50.9220618, 32.6385581],
              [50.9218042, 32.6440722],
              [50.9214384, 32.6475578],
              [50.920456, 32.6500763],
              [50.9187833, 32.6550611],
              [50.9165393, 32.6611992],
              [50.9122744, 32.6666371],
              [50.8996349, 32.6750001],
              [50.8919712, 32.6878871],
              [50.8901346, 32.6896255],
              [50.8901346, 32.6901853],
              [50.889858, 32.6904652],
              [50.8895779, 32.6915758],
              [50.8879113, 32.6951786],
              [50.8873579, 32.6957384],
              [50.887358, 32.6962892],
              [50.8737447, 32.7065736],
              [50.8737448, 32.7068535],
              [50.8731882, 32.7068535],
              [50.8723547, 32.7076842],
              [50.8662448, 32.7099054],
              [50.8648548, 32.7099055],
              [50.8640216, 32.7101853],
              [50.8626351, 32.7101853],
              [50.8604115, 32.7107362],
              [50.8595783, 32.7107361],
              [50.8592983, 32.7110161],
              [50.8576316, 32.711016],
              [50.8570782, 32.7112959],
              [50.8551317, 32.711296],
              [50.8529117, 32.7118467],
              [50.8523551, 32.7121267],
              [50.8512451, 32.7115669],
              [50.8459652, 32.7115668],
              [50.8431885, 32.7112959],
              [50.8429085, 32.711016],
              [50.8354085, 32.711016],
              [50.8345753, 32.7112959],
              [50.8317987, 32.7112959],
              [50.8290221, 32.711296],
              [50.8123522, 32.7079641],
              [50.7945759, 32.7040724],
              [50.7899403, 32.7007764],
              [50.7798194, 32.6972012],
              [50.7778747, 32.6968401],
              [50.7763381, 32.6966415],
              [50.7757181, 32.6982757],
              [50.7758574, 32.7034038],
              [50.7701294, 32.7001806],
              [50.7690195, 32.7001807],
              [50.7684628, 32.7004606],
              [50.7670728, 32.7004606],
              [50.7606827, 32.7026818],
              [50.7606828, 32.7029617],
              [50.7598496, 32.7029618],
              [50.7573495, 32.7043432],
              [50.7567964, 32.7043433],
              [50.7565163, 32.704903],
              [50.7529063, 32.7062935],
              [50.7523497, 32.7065735],
              [50.7467931, 32.7085147],
              [50.7462397, 32.7085148],
              [50.7459597, 32.7087947],
              [50.7445732, 32.7087947],
              [50.7440165, 32.7090746],
              [50.7417932, 32.7090746],
              [50.7412398, 32.7093455],
              [50.7370732, 32.7090746],
              [50.7365165, 32.7087947],
              [50.7351266, 32.7087947],
              [50.7301267, 32.7068534],
              [50.7155032, 32.7060378],
              [50.7116515, 32.7005607],
              [50.703063, 32.7051584],
              [50.6947619, 32.706669],
              [50.6878443, 32.7044672],
              [50.6725323, 32.7078661],
              [50.664701, 32.707094],
              [50.6428126, 32.7053236],
              [50.6346592, 32.7015252],
              [50.628897, 32.6978593],
              [50.6181914, 32.6935492],
              [50.6147584, 32.6878983],
              [50.6058001, 32.6932115],
              [50.6023914, 32.6869434],
              [50.5871804, 32.6840568],
              [50.5788785, 32.6912385],
              [50.5717563, 32.6867198],
              [50.565016, 32.6723313],
              [50.5626951, 32.6730437],
              [50.5613247, 32.6734644],
              [50.5622097, 32.6883087],
              [50.5554232, 32.6751534],
              [50.548673, 32.6799061],
              [50.5504524, 32.6904529],
              [50.5539533, 32.6942549],
              [50.550751, 32.7015785],
              [50.5526263, 32.7096555],
              [50.5498848, 32.7138973],
              [50.5451313, 32.7166501],
              [50.5423806, 32.7182429],
              [50.5409526, 32.7190698],
              [50.5384525, 32.7190699],
              [50.5381724, 32.7193498],
              [50.5373391, 32.7193498],
              [50.5373392, 32.7190699],
              [50.5342859, 32.7190698],
              [50.5342859, 32.71879],
              [50.5334832, 32.71879],
              [50.5330615, 32.71879],
              [50.5323391, 32.71879],
              [50.5317835, 32.7186544],
              [50.5312292, 32.7185191],
              [50.5302404, 32.7183199],
              [50.529994, 32.7182703],
              [50.5298394, 32.7182392],
              [50.5288346, 32.7180704],
              [50.528708, 32.7180491],
              [50.5281726, 32.7179592],
              [50.5280973, 32.7179592],
              [50.5270627, 32.7179593],
              [50.5266062, 32.7178068],
              [50.5220627, 32.7162888],
              [50.5212295, 32.7162888],
              [50.5200427, 32.7157321],
              [50.5159457, 32.7138098],
              [50.5095529, 32.7108099],
              [50.5087926, 32.710453],
              [50.4973628, 32.705088],
              [50.4940063, 32.7035121],
              [50.4784502, 32.6907356],
              [50.4767833, 32.6887942],
              [50.4695602, 32.6818417],
              [50.4620605, 32.6712863],
              [50.458447, 32.6612907],
              [50.4581705, 32.6607308],
              [50.4584471, 32.6599002],
              [50.4581706, 32.6546271],
              [50.458447, 32.6540672],
              [50.4600501, 32.6505929],
              [50.4601135, 32.6504555],
              [50.4651137, 32.6476835],
              [50.4654338, 32.6475224],
              [50.466227, 32.6471236],
              [50.4667837, 32.6471236],
              [50.4670602, 32.6471236],
              [50.4676168, 32.6471236],
              [50.4678938, 32.6468437],
              [50.4703934, 32.6468436],
              [50.4709501, 32.6465728],
              [50.4784503, 32.6468437],
              [50.4787268, 32.6471235],
              [50.4826167, 32.6471236],
              [50.4842836, 32.6474035],
              [50.4829785, 32.6457596],
              [50.4956077, 32.6448924],
              [50.5009486, 32.6437099],
              [50.5047512, 32.638363],
              [50.5042696, 32.6357422],
              [50.5043624, 32.6323653],
              [50.5048772, 32.6307843],
              [50.504708, 32.6277127],
              [50.504146, 32.6257208],
              [50.5036752, 32.6241214],
              [50.5017168, 32.6168224],
              [50.4994448, 32.6085367],
              [50.4987431, 32.5995428],
              [50.4943811, 32.5929429],
              [50.4892956, 32.5907794],
              [50.4828217, 32.5903938],
              [50.4766204, 32.589905],
              [50.4712272, 32.5890734],
              [50.4630538, 32.5877533],
              [50.4588322, 32.5848802],
              [50.4490742, 32.581136],
              [50.4357862, 32.5758937],
              [50.4342776, 32.5741551],
              [50.4311348, 32.5731291],
              [50.4219774, 32.5681998],
              [50.4141883, 32.5652963],
              [50.4125261, 32.5664544],
              [50.4109071, 32.5685561],
              [50.4029608, 32.572491],
              [50.3952527, 32.573377],
              [50.3892261, 32.5739299],
              [50.3832868, 32.5731166],
              [50.3810596, 32.5696755],
              [50.3767535, 32.5681114],
              [50.3756399, 32.564983],
              [50.3725218, 32.5644198],
              [50.3728188, 32.5609784],
              [50.3666567, 32.5550965],
              [50.3645037, 32.5520928],
              [50.3657366, 32.5488688],
              [50.3599306, 32.5482704],
              [50.3549229, 32.5473146],
              [50.3508231, 32.543843],
              [50.3453697, 32.5396833],
              [50.3349928, 32.5344126],
              [50.3314292, 32.5342874],
              [50.3264907, 32.5277062],
              [50.3249725, 32.5312445],
              [50.3218149, 32.533818],
              [50.3153859, 32.5371178],
              [50.313585, 32.5379933],
              [50.3040388, 32.5407153],
              [50.2895633, 32.5486018],
              [50.2870232, 32.5501633],
              [50.2698578, 32.5623535],
              [50.2641548, 32.562877],
              [50.2585887, 32.5641035],
              [50.2546094, 32.5642059],
              [50.2497005, 32.5739057],
              [50.241432, 32.5837648],
              [50.2410617, 32.5874328],
              [50.2351236, 32.5960466],
              [50.2260489, 32.6057079],
              [50.2170825, 32.6148066],
              [50.2093361, 32.6209472],
              [50.1951801, 32.6332621],
              [50.1859421, 32.6424801],
              [50.1659343, 32.6579585],
              [50.1537111, 32.6637915],
              [50.1523243, 32.6640623],
              [50.151491, 32.6643422],
              [50.1506579, 32.6643422],
              [50.1501012, 32.6646221],
              [50.148991, 32.6646222],
              [50.1484344, 32.664902],
              [50.1464914, 32.664902],
              [50.1456578, 32.6651729],
              [50.1420444, 32.664902],
              [50.1339881, 32.6637914],
              [50.1326013, 32.6632316],
              [50.131768, 32.6632316],
              [50.1253781, 32.6604505],
              [50.1153782, 32.6529561],
              [50.1034316, 32.6462924],
              [50.0992651, 32.6449019],
              [50.096765, 32.644351],
              [50.0948221, 32.6435113],
              [50.0939885, 32.6435113],
              [50.0928752, 32.6429605],
              [50.092322, 32.6429605],
              [50.0909322, 32.6424007],
              [50.0895419, 32.6424007],
              [50.0892654, 32.6421207],
              [50.0870418, 32.6421207],
              [50.0848187, 32.64157],
              [50.0837085, 32.6415699],
              [50.0745424, 32.6390688],
              [50.0744293, 32.6390062],
              [50.0589858, 32.6304547],
              [50.0448191, 32.6276826],
              [50.0445391, 32.6274027],
              [50.0420394, 32.6274028],
              [50.0392628, 32.6279536],
              [50.0370394, 32.6285133],
              [50.0353728, 32.6285133],
              [50.0348194, 32.6287932],
              [50.0289829, 32.6290642],
              [50.024816, 32.6287933],
              [50.0242628, 32.6287933],
              [50.0212062, 32.6282334],
              [50.0200964, 32.6282334],
              [50.0198163, 32.6279535],
              [50.0181495, 32.6279535],
              [50.0175964, 32.6276826],
              [50.0034265, 32.6279535],
              [50.00315, 32.6282334],
              [50.0023164, 32.6282334],
              [50.0017597, 32.6285133],
              [50.00065, 32.6285134],
              [49.9864833, 32.6332357],
              [49.9859266, 32.6332357],
              [49.9853699, 32.6337864],
              [49.9823168, 32.6346172],
              [49.9800229, 32.6359868],
              [49.96648, 32.6440709],
              [49.9662036, 32.6443508],
              [49.9503704, 32.6579581],
              [49.9350907, 32.6676738],
              [49.9120345, 32.6765677],
              [49.9039777, 32.6821207],
              [49.9037011, 32.6829605],
              [49.9028678, 32.6837912],
              [49.9009244, 32.687403],
              [49.9009244, 32.6879628],
              [49.9006444, 32.6885136],
              [49.8995346, 32.6910147],
              [49.8995345, 32.6918454],
              [49.8962012, 32.6979583],
              [49.8875878, 32.7021208],
              [49.8556414, 32.7179583],
              [49.8553648, 32.7182382],
              [49.853975, 32.7187889],
              [49.8267517, 32.7396287],
              [49.8125855, 32.7446219],
              [49.8011954, 32.7557371],
              [49.7953624, 32.7593488],
              [49.7950854, 32.7596286],
              [49.7945289, 32.7596287],
              [49.7942522, 32.7599086],
              [49.7911956, 32.7601794],
              [49.7906389, 32.7604594],
              [49.7856392, 32.7599086],
              [49.7850826, 32.7596287],
              [49.7834157, 32.7596287],
              [49.7831391, 32.7593487],
              [49.7775824, 32.7593487],
              [49.7773058, 32.7596287],
              [49.7764726, 32.7596287],
              [49.767306, 32.7640711],
              [49.7531397, 32.775737],
              [49.7528596, 32.7760168],
              [49.7528597, 32.7762968],
              [49.7323028, 32.8057323],
              [49.7317498, 32.806572],
              [49.7317497, 32.8068519],
              [49.7317497, 32.8071318],
              [49.7314696, 32.8076826],
              [49.7317497, 32.8079626],
              [49.7317497, 32.8082425],
              [49.7311931, 32.8085133],
              [49.7298032, 32.8090731],
              [49.7281364, 32.8090731],
              [49.7273032, 32.8087932],
              [49.7256364, 32.8087933],
              [49.7256363, 32.8085133],
              [49.7248032, 32.8085133],
              [49.7192463, 32.8057323],
              [49.6959135, 32.7910145],
              [49.69369, 32.7901838],
              [49.6925803, 32.789624],
              [49.6600773, 32.7793485],
              [49.6556343, 32.7793485],
              [49.6550777, 32.7790687],
              [49.6442442, 32.7790686],
              [49.6439676, 32.7793485],
              [49.6411875, 32.7793485],
              [49.6406344, 32.7796285],
              [49.6386878, 32.7798993],
              [49.6364679, 32.7798993],
              [49.6356311, 32.7801792],
              [49.6345209, 32.7801792],
              [49.6336877, 32.7804591],
              [49.6331311, 32.7804591],
              [49.6325779, 32.780739],
              [49.6314643, 32.780739],
              [49.6286876, 32.7815697],
              [49.6275779, 32.7815697],
              [49.6272977, 32.7818496],
              [49.6189644, 32.7846216],
              [49.6184675, 32.7847885],
              [49.6181311, 32.7849015],
              [49.6042415, 32.7896238],
              [49.6025746, 32.7896238],
              [49.602298, 32.7899037],
              [49.600355, 32.7899037],
              [49.6004846, 32.7860347],
              [49.5999494, 32.7853852],
              [49.5994357, 32.7824354],
              [49.5975292, 32.7792963],
              [49.5953096, 32.7768058],
              [49.5946893, 32.7756977],
              [49.5943946, 32.7740623],
              [49.5945307, 32.7716487],
              [49.5951327, 32.7685225],
              [49.5956929, 32.7665284],
              [49.5958249, 32.7633387],
              [49.595527, 32.7610452],
              [49.5948923, 32.7602297],
              [49.5944357, 32.7592446],
              [49.5943689, 32.7585182],
              [49.5948703, 32.7571073],
              [49.5946472, 32.7557072],
              [49.5926978, 32.754444],
              [49.5916118, 32.7533789],
              [49.5912517, 32.7520796],
              [49.591018, 32.7499952],
              [49.5775021, 32.7499591],
              [49.5772268, 32.7441927],
              [49.578136, 32.7386062],
              [49.5775028, 32.7369457],
              [49.5770546, 32.7318828],
              [49.5767125, 32.7306281],
              [49.5777898, 32.7300056],
              [49.5775574, 32.7254294],
              [49.5767623, 32.7197521],
              [49.5745853, 32.7166108],
              [49.5701837, 32.7153413],
              [49.563686, 32.7140384],
              [49.5621585, 32.713211],
              [49.5566968, 32.7127023],
              [49.5476429, 32.7129462],
              [49.5448794, 32.7139754],
              [49.5430611, 32.7148688],
              [49.5411515, 32.7143664],
              [49.5382877, 32.7128012],
              [49.5325127, 32.7101449],
              [49.5295337, 32.7093867],
              [49.5262813, 32.7092751],
              [49.5226861, 32.7086458],
              [49.5174089, 32.7059375],
              [49.5151662, 32.7044723],
              [49.5122602, 32.7033102],
              [49.5104825, 32.7024073],
              [49.510678, 32.7044025],
              [49.5117177, 32.7062982],
              [49.5157088, 32.7109292],
              [49.5194671, 32.7137457],
              [49.520093, 32.7156323],
              [49.512915, 32.7204423],
              [49.5124159, 32.7199787],
              [49.5037787, 32.7161871],
              [49.5008323, 32.7160473]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241037,
        "tags": {
          "ISO3166-2": "IR-05",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "کرمانشاه",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q174010"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [45.407661, 33.977255],
              [45.409135, 33.976761],
              [45.412044, 33.975201],
              [45.413407, 33.974283],
              [45.414953, 33.973082],
              [45.415933, 33.97188],
              [45.41714, 33.969983],
              [45.417241, 33.969639],
              [45.417227, 33.969391],
              [45.417496, 33.96895],
              [45.41758, 33.967746],
              [45.41777, 33.967058],
              [45.418269, 33.966132],
              [45.419089, 33.965108],
              [45.419189, 33.964506],
              [45.419134, 33.963786],
              [45.420033, 33.962923],
              [45.420788, 33.961857],
              [45.420788, 33.961738],
              [45.420159, 33.959753],
              [45.420158, 33.959634],
              [45.420467, 33.959365],
              [45.420736, 33.959009],
              [45.421109, 33.958782],
              [45.421534, 33.958856],
              [45.42165, 33.958813],
              [45.421804, 33.958661],
              [45.421985, 33.958672],
              [45.422459, 33.958036],
              [45.423217, 33.957571],
              [45.424016, 33.957321],
              [45.42448, 33.957287],
              [45.424814, 33.957028],
              [45.426294, 33.956454],
              [45.426447, 33.956066],
              [45.427181, 33.955903],
              [45.427758, 33.955267],
              [45.428531, 33.954931],
              [45.429868, 33.954096],
              [45.429993, 33.953966],
              [45.429931, 33.953094],
              [45.429965, 33.952571],
              [45.429797, 33.951842],
              [45.42977, 33.951392],
              [45.429673, 33.951097],
              [45.429849, 33.950997],
              [45.430047, 33.950486],
              [45.42986, 33.94952],
              [45.429898, 33.949417],
              [45.430128, 33.949161],
              [45.430167, 33.949037],
              [45.430189, 33.948449],
              [45.430831, 33.94776],
              [45.431054, 33.946971],
              [45.431109, 33.946416],
              [45.431065, 33.946079],
              [45.431309, 33.945793],
              [45.431354, 33.945628],
              [45.431545, 33.945556],
              [45.43182, 33.945599],
              [45.432113, 33.945737],
              [45.432294, 33.945764],
              [45.432815, 33.94632],
              [45.433255, 33.946508],
              [45.433615, 33.946719],
              [45.434125, 33.946804],
              [45.434432, 33.94674],
              [45.434719, 33.94648],
              [45.435418, 33.94634],
              [45.435637, 33.946666],
              [45.435832, 33.946727],
              [45.436051, 33.947031],
              [45.436382, 33.947283],
              [45.436987, 33.947385],
              [45.437145, 33.947484],
              [45.437523, 33.947437],
              [45.437754, 33.947507],
              [45.437968, 33.947458],
              [45.438258, 33.947541],
              [45.438418, 33.947668],
              [45.438565, 33.947951],
              [45.439061, 33.947954],
              [45.439371, 33.948048],
              [45.439549, 33.948014],
              [45.439903, 33.947512],
              [45.440173, 33.947297],
              [45.440454, 33.9472],
              [45.441518, 33.947265],
              [45.441824, 33.947768],
              [45.441985, 33.94776],
              [45.442122, 33.94765],
              [45.442278, 33.94705],
              [45.442744, 33.9469],
              [45.442935, 33.946781],
              [45.443399, 33.946813],
              [45.443601, 33.946762],
              [45.443768, 33.946586],
              [45.443933, 33.946546],
              [45.444036, 33.946622],
              [45.444112, 33.946846],
              [45.444106, 33.947107],
              [45.444259, 33.947393],
              [45.444477, 33.947571],
              [45.444516, 33.947949],
              [45.444787, 33.947975],
              [45.445105, 33.948128],
              [45.445275, 33.948105],
              [45.445464, 33.947764],
              [45.445672, 33.947619],
              [45.445986, 33.947545],
              [45.446582, 33.947607],
              [45.446817, 33.947671],
              [45.44706, 33.947817],
              [45.44726, 33.947803],
              [45.447413, 33.947593],
              [45.447416, 33.947416],
              [45.447698, 33.947134],
              [45.448013, 33.94699],
              [45.448838, 33.946741],
              [45.449027, 33.946632],
              [45.449832, 33.946557],
              [45.449976, 33.946432],
              [45.450033, 33.946246],
              [45.449997, 33.945928],
              [45.450064, 33.945782],
              [45.450808, 33.945217],
              [45.450955, 33.945008],
              [45.451211, 33.94485],
              [45.451516, 33.944806],
              [45.451774, 33.944871],
              [45.451935, 33.945026],
              [45.452186, 33.945134],
              [45.453776, 33.945373],
              [45.454183, 33.94559],
              [45.454678, 33.945751],
              [45.454967, 33.945756],
              [45.455638, 33.945642],
              [45.455837, 33.945647],
              [45.456092, 33.945912],
              [45.456384, 33.94593],
              [45.456733, 33.94605],
              [45.457005, 33.946052],
              [45.457161, 33.945953],
              [45.457312, 33.94578],
              [45.457722, 33.944972],
              [45.457929, 33.944943],
              [45.458565, 33.945012],
              [45.458907, 33.945096],
              [45.459415, 33.945102],
              [45.459796, 33.945161],
              [45.460045, 33.945237],
              [45.46035, 33.945545],
              [45.460637, 33.945614],
              [45.460839, 33.94573],
              [45.460991, 33.945752],
              [45.461817, 33.945576],
              [45.4621, 33.945888],
              [45.462289, 33.945996],
              [45.462849, 33.94605],
              [45.463045, 33.946139],
              [45.463461, 33.946609],
              [45.463504, 33.946718],
              [45.463545, 33.946842],
              [45.463389, 33.947396],
              [45.463729, 33.94792],
              [45.463884, 33.948406],
              [45.46428, 33.948717],
              [45.46455, 33.948813],
              [45.464788, 33.948862],
              [45.465235, 33.948493],
              [45.466001, 33.948254],
              [45.46634, 33.948282],
              [45.466964, 33.94865],
              [45.467282, 33.94871],
              [45.467576, 33.94883],
              [45.467778, 33.949038],
              [45.467977, 33.94914],
              [45.468224, 33.949114],
              [45.468456, 33.948998],
              [45.468593, 33.948818],
              [45.468779, 33.948417],
              [45.468979, 33.948357],
              [45.469594, 33.948336],
              [45.469907, 33.94842],
              [45.47052, 33.948294],
              [45.470793, 33.948305],
              [45.471056, 33.948462],
              [45.47117, 33.948657],
              [45.471379, 33.948776],
              [45.471663, 33.948832],
              [45.471919, 33.949125],
              [45.472184, 33.949291],
              [45.473508, 33.949411],
              [45.474152, 33.949344],
              [45.474485, 33.949439],
              [45.474843, 33.949474],
              [45.47539, 33.949288],
              [45.476809, 33.949211],
              [45.477187, 33.949141],
              [45.477469, 33.949165],
              [45.477686, 33.94932],
              [45.478243, 33.949527],
              [45.478718, 33.949534],
              [45.479102, 33.949657],
              [45.480022, 33.949569],
              [45.480349, 33.949405],
              [45.480919, 33.948413],
              [45.481348, 33.948112],
              [45.481825, 33.947886],
              [45.48205, 33.947627],
              [45.482369, 33.94752],
              [45.482605, 33.947519],
              [45.482901, 33.947624],
              [45.483668, 33.948122],
              [45.484144, 33.94837],
              [45.48461, 33.948503],
              [45.485038, 33.94874],
              [45.48528, 33.948975],
              [45.485958, 33.949218],
              [45.486531, 33.949705],
              [45.486876, 33.949899],
              [45.487917, 33.95013],
              [45.488377, 33.950121],
              [45.489298, 33.949726],
              [45.490154, 33.94963],
              [45.490857, 33.94972],
              [45.491341, 33.949619],
              [45.49185, 33.949629],
              [45.492336, 33.949797],
              [45.492728, 33.950072],
              [45.493461, 33.950334],
              [45.493806, 33.950408],
              [45.494109, 33.950591],
              [45.494439, 33.951052],
              [45.494657, 33.951258],
              [45.494866, 33.951308],
              [45.495619, 33.951298],
              [45.49603, 33.951412],
              [45.496382, 33.951448],
              [45.496688, 33.951454],
              [45.497967, 33.950932],
              [45.498517, 33.950876],
              [45.49893, 33.950976],
              [45.499409, 33.951024],
              [45.500405, 33.95097],
              [45.500965, 33.950884],
              [45.50126, 33.951105],
              [45.501437, 33.951397],
              [45.501506, 33.95183],
              [45.501646, 33.951989],
              [45.502122, 33.952213],
              [45.502228, 33.952326],
              [45.502385, 33.952394],
              [45.502405, 33.952525],
              [45.502324, 33.952941],
              [45.50246, 33.953086],
              [45.502731, 33.953182],
              [45.502947, 33.953165],
              [45.503305, 33.952968],
              [45.503704, 33.952936],
              [45.503865, 33.952882],
              [45.50395, 33.952767],
              [45.50405, 33.952454],
              [45.504411, 33.952219],
              [45.504295, 33.951825],
              [45.504337, 33.951716],
              [45.50494, 33.95141],
              [45.505265, 33.951353],
              [45.505311, 33.95129],
              [45.505201, 33.951062],
              [45.505191, 33.950925],
              [45.505291, 33.950825],
              [45.5055, 33.950759],
              [45.505701, 33.950773],
              [45.505803, 33.950728],
              [45.505864, 33.95063],
              [45.506253, 33.950512],
              [45.506395, 33.950396],
              [45.506459, 33.950265],
              [45.506755, 33.949948],
              [45.506741, 33.9497],
              [45.507023, 33.949367],
              [45.507042, 33.949257],
              [45.507154, 33.94916],
              [45.50762, 33.948941],
              [45.507662, 33.948619],
              [45.507771, 33.948486],
              [45.508306, 33.948343],
              [45.508371, 33.948217],
              [45.508389, 33.947913],
              [45.508715, 33.947744],
              [45.508976, 33.947465],
              [45.509183, 33.94739],
              [45.509367, 33.947379],
              [45.509586, 33.94719],
              [45.509663, 33.947039],
              [45.509943, 33.946887],
              [45.510033, 33.946771],
              [45.510033, 33.946488],
              [45.510136, 33.94635],
              [45.510448, 33.946217],
              [45.510638, 33.945977],
              [45.51148, 33.945656],
              [45.511585, 33.945574],
              [45.511539, 33.945335],
              [45.511359, 33.945077],
              [45.511404, 33.944935],
              [45.51139, 33.944664],
              [45.511445, 33.944585],
              [45.511757, 33.944498],
              [45.511863, 33.944425],
              [45.511918, 33.943948],
              [45.512078, 33.943625],
              [45.512067, 33.943506],
              [45.511889, 33.94328],
              [45.511906, 33.943166],
              [45.512095, 33.942894],
              [45.51211, 33.94265],
              [45.511789, 33.942364],
              [45.511941, 33.942177],
              [45.512282, 33.942024],
              [45.512329, 33.941887],
              [45.512266, 33.941721],
              [45.512314, 33.941449],
              [45.51245, 33.941357],
              [45.512764, 33.941279],
              [45.51286, 33.941184],
              [45.512946, 33.940767],
              [45.512945, 33.940619],
              [45.512862, 33.940511],
              [45.512545, 33.940363],
              [45.512526, 33.940209],
              [45.512633, 33.939737],
              [45.512884, 33.939446],
              [45.512981, 33.939259],
              [45.512944, 33.938917],
              [45.512768, 33.938579],
              [45.512861, 33.938425],
              [45.513305, 33.938065],
              [45.513868, 33.937923],
              [45.514869, 33.937418],
              [45.515112, 33.936498],
              [45.515711, 33.936007],
              [45.516127, 33.935884],
              [45.516383, 33.935708],
              [45.516517, 33.935371],
              [45.516435, 33.934884],
              [45.516317, 33.934578],
              [45.516478, 33.934214],
              [45.51675, 33.933984],
              [45.516783, 33.93384],
              [45.516604, 33.933586],
              [45.516415, 33.933454],
              [45.516308, 33.933267],
              [45.516311, 33.93271],
              [45.516366, 33.932492],
              [45.516561, 33.932294],
              [45.516652, 33.932038],
              [45.517044, 33.931766],
              [45.516962, 33.931519],
              [45.517054, 33.931217],
              [45.517274, 33.930959],
              [45.517263, 33.930724],
              [45.517329, 33.930574],
              [45.517375, 33.930177],
              [45.517226, 33.92984],
              [45.51722, 33.92972],
              [45.517334, 33.929581],
              [45.517739, 33.929344],
              [45.51781, 33.92924],
              [45.517806, 33.929078],
              [45.51767, 33.92884],
              [45.517761, 33.928418],
              [45.518058, 33.928198],
              [45.518148, 33.928058],
              [45.518235, 33.927877],
              [45.518276, 33.927481],
              [45.518613, 33.927218],
              [45.518622, 33.927068],
              [45.518491, 33.926802],
              [45.518353, 33.926648],
              [45.518367, 33.926539],
              [45.518531, 33.926188],
              [45.518553, 33.925952],
              [45.518962, 33.925399],
              [45.518977, 33.925035],
              [45.519298, 33.924538],
              [45.519266, 33.924121],
              [45.519312, 33.924007],
              [45.519737, 33.923827],
              [45.519747, 33.923394],
              [45.51986, 33.923301],
              [45.520002, 33.923237],
              [45.520406, 33.92325],
              [45.520636, 33.923176],
              [45.520893, 33.922861],
              [45.52097, 33.922547],
              [45.521256, 33.921903],
              [45.521334, 33.921612],
              [45.521631, 33.921323],
              [45.521923, 33.921201],
              [45.521962, 33.921056],
              [45.521921, 33.920956],
              [45.521701, 33.920718],
              [45.521685, 33.920414],
              [45.52146, 33.920205],
              [45.521454, 33.920062],
              [45.522019, 33.919662],
              [45.522357, 33.919639],
              [45.522434, 33.919538],
              [45.522636, 33.919417],
              [45.522796, 33.919145],
              [45.523298, 33.919124],
              [45.523616, 33.91923],
              [45.524088, 33.919269],
              [45.52427, 33.919253],
              [45.524387, 33.919178],
              [45.52446, 33.919036],
              [45.524433, 33.918874],
              [45.524597, 33.91862],
              [45.524385, 33.918209],
              [45.524953, 33.917853],
              [45.525002, 33.917659],
              [45.524937, 33.917317],
              [45.525269, 33.917082],
              [45.525303, 33.916896],
              [45.525484, 33.91669],
              [45.525517, 33.916523],
              [45.525937, 33.916487],
              [45.526603, 33.916633],
              [45.526894, 33.916623],
              [45.527867, 33.916218],
              [45.527749, 33.915987],
              [45.527746, 33.915575],
              [45.52851, 33.914931],
              [45.528552, 33.914804],
              [45.528503, 33.914622],
              [45.528521, 33.914419],
              [45.528956, 33.914186],
              [45.529097, 33.914047],
              [45.528928, 33.913723],
              [45.528898, 33.913477],
              [45.528969, 33.913308],
              [45.52909, 33.913177],
              [45.529727, 33.91299],
              [45.530977, 33.912262],
              [45.531701, 33.911968],
              [45.532488, 33.911844],
              [45.532747, 33.911751],
              [45.53359, 33.911952],
              [45.534079, 33.911761],
              [45.534552, 33.911735],
              [45.534699, 33.911665],
              [45.535543, 33.910794],
              [45.535633, 33.910678],
              [45.535627, 33.910465],
              [45.535935, 33.910081],
              [45.536025, 33.909802],
              [45.536063, 33.90949],
              [45.536008, 33.909263],
              [45.535743, 33.908745],
              [45.535405, 33.908281],
              [45.535218, 33.908112],
              [45.534362, 33.907714],
              [45.534209, 33.907479],
              [45.534164, 33.907222],
              [45.534397, 33.906317],
              [45.534559, 33.906147],
              [45.534771, 33.906043],
              [45.535011, 33.90599],
              [45.535532, 33.906044],
              [45.535871, 33.906002],
              [45.536274, 33.906016],
              [45.536828, 33.905693],
              [45.536899, 33.905589],
              [45.536909, 33.905258],
              [45.53703, 33.904919],
              [45.537549, 33.904338],
              [45.538286, 33.903323],
              [45.538727, 33.902324],
              [45.539542, 33.901667],
              [45.539925, 33.901251],
              [45.54043, 33.900872],
              [45.54049, 33.900698],
              [45.540658, 33.900502],
              [45.540887, 33.900374],
              [45.541341, 33.899887],
              [45.541588, 33.89969],
              [45.5418, 33.899422],
              [45.54265, 33.89936],
              [45.542868, 33.899239],
              [45.543108, 33.898747],
              [45.543158, 33.898444],
              [45.543278, 33.898272],
              [45.543498, 33.898073],
              [45.543978, 33.8979],
              [45.544594, 33.897542],
              [45.544715, 33.897403],
              [45.544826, 33.896498],
              [45.545205, 33.896089],
              [45.545226, 33.895834],
              [45.545369, 33.895763],
              [45.545344, 33.895509],
              [45.545522, 33.895328],
              [45.545936, 33.895105],
              [45.546094, 33.89484],
              [45.546373, 33.894692],
              [45.546483, 33.89456],
              [45.546373, 33.894172],
              [45.5464, 33.893998],
              [45.54664, 33.893857],
              [45.546782, 33.893693],
              [45.546856, 33.893407],
              [45.547134, 33.893227],
              [45.547111, 33.892864],
              [45.547287, 33.892618],
              [45.547451, 33.892521],
              [45.547785, 33.892557],
              [45.548556, 33.892382],
              [45.549084, 33.89213],
              [45.549363, 33.892158],
              [45.549519, 33.892232],
              [45.549721, 33.892239],
              [45.549926, 33.892174],
              [45.550251, 33.891768],
              [45.550216, 33.891527],
              [45.55026, 33.891345],
              [45.550485, 33.891108],
              [45.550627, 33.890856],
              [45.550729, 33.890489],
              [45.551122, 33.889826],
              [45.551222, 33.889219],
              [45.551415, 33.888845],
              [45.55158, 33.888808],
              [45.551859, 33.888518],
              [45.551946, 33.888319],
              [45.551965, 33.887965],
              [45.552066, 33.887884],
              [45.552301, 33.887836],
              [45.552399, 33.887684],
              [45.55245, 33.887326],
              [45.55267, 33.887215],
              [45.552818, 33.887077],
              [45.552893, 33.88694],
              [45.55284, 33.88674],
              [45.553389, 33.886003],
              [45.553589, 33.885337],
              [45.553824, 33.885087],
              [45.554105, 33.8846],
              [45.55425, 33.884479],
              [45.554362, 33.884013],
              [45.554659, 33.88383],
              [45.554856, 33.88347],
              [45.554953, 33.88305],
              [45.555282, 33.882632],
              [45.555672, 33.881926],
              [45.555972, 33.881611],
              [45.556076, 33.881425],
              [45.556129, 33.88099],
              [45.556287, 33.880697],
              [45.55639, 33.880594],
              [45.556605, 33.880489],
              [45.556912, 33.88003],
              [45.556946, 33.879741],
              [45.557124, 33.87939],
              [45.557345, 33.879076],
              [45.557778, 33.87879],
              [45.558045, 33.878415],
              [45.558105, 33.878159],
              [45.558807, 33.877448],
              [45.558918, 33.877151],
              [45.559086, 33.876955],
              [45.559854, 33.876185],
              [45.559922, 33.875873],
              [45.560124, 33.875453],
              [45.560482, 33.875041],
              [45.560494, 33.874487],
              [45.56084, 33.874373],
              [45.561028, 33.874119],
              [45.561117, 33.873782],
              [45.561574, 33.873279],
              [45.562095, 33.873176],
              [45.562296, 33.873008],
              [45.562357, 33.872839],
              [45.562262, 33.872455],
              [45.562326, 33.872269],
              [45.562499, 33.872095],
              [45.562651, 33.872033],
              [45.562878, 33.871833],
              [45.562971, 33.87166],
              [45.562895, 33.870955],
              [45.563059, 33.870886],
              [45.56336, 33.870893],
              [45.563844, 33.870594],
              [45.563982, 33.870244],
              [45.563857, 33.869828],
              [45.563992, 33.869635],
              [45.564237, 33.869514],
              [45.564327, 33.869254],
              [45.564339, 33.869044],
              [45.564641, 33.868869],
              [45.564803, 33.86869],
              [45.565037, 33.868134],
              [45.565035, 33.867806],
              [45.565203, 33.867665],
              [45.565419, 33.867653],
              [45.565534, 33.867602],
              [45.565624, 33.867487],
              [45.565658, 33.867274],
              [45.565865, 33.866987],
              [45.565846, 33.866702],
              [45.565941, 33.866554],
              [45.566119, 33.866011],
              [45.566114, 33.865799],
              [45.566605, 33.865503],
              [45.566767, 33.865152],
              [45.566978, 33.865057],
              [45.56712, 33.864794],
              [45.56712, 33.864317],
              [45.567196, 33.864169],
              [45.56753, 33.863914],
              [45.567752, 33.86365],
              [45.567733, 33.863092],
              [45.568, 33.862864],
              [45.568209, 33.86276],
              [45.568297, 33.862623],
              [45.568357, 33.862116],
              [45.568703, 33.861726],
              [45.568774, 33.861414],
              [45.568977, 33.861122],
              [45.569067, 33.860862],
              [45.569458, 33.860511],
              [45.569555, 33.859962],
              [45.56996, 33.859685],
              [45.57026, 33.859267],
              [45.570297, 33.85908],
              [45.570474, 33.858982],
              [45.570727, 33.858594],
              [45.571288, 33.857979],
              [45.5715, 33.8575],
              [45.571821, 33.857031],
              [45.57204, 33.856855],
              [45.572112, 33.856499],
              [45.572302, 33.856242],
              [45.572306, 33.856069],
              [45.572401, 33.85595],
              [45.572789, 33.855698],
              [45.572934, 33.855547],
              [45.573065, 33.855146],
              [45.573383, 33.85484],
              [45.573414, 33.854668],
              [45.573361, 33.854397],
              [45.5734, 33.85432],
              [45.573623, 33.854203],
              [45.573844, 33.853908],
              [45.574047, 33.853776],
              [45.574431, 33.853393],
              [45.574688, 33.852789],
              [45.574854, 33.852657],
              [45.575384, 33.851666],
              [45.575636, 33.851402],
              [45.57596, 33.850914],
              [45.576072, 33.850622],
              [45.57633, 33.850413],
              [45.576525, 33.850043],
              [45.576936, 33.849634],
              [45.576992, 33.849283],
              [45.577071, 33.849194],
              [45.577454, 33.849009],
              [45.577706, 33.848786],
              [45.577846, 33.848529],
              [45.57784, 33.848267],
              [45.578089, 33.848108],
              [45.578249, 33.847936],
              [45.578307, 33.847697],
              [45.578485, 33.847516],
              [45.578527, 33.847293],
              [45.578479, 33.847158],
              [45.578525, 33.847041],
              [45.579015, 33.846464],
              [45.579368, 33.846294],
              [45.579443, 33.846184],
              [45.579653, 33.845492],
              [45.580179, 33.844871],
              [45.580657, 33.844523],
              [45.580984, 33.844105],
              [45.580965, 33.843835],
              [45.581053, 33.843569],
              [45.581417, 33.84343],
              [45.581828, 33.843175],
              [45.582018, 33.842743],
              [45.58215, 33.842566],
              [45.582302, 33.842129],
              [45.582814, 33.841344],
              [45.582779, 33.841062],
              [45.582596, 33.840732],
              [45.582648, 33.840565],
              [45.582863, 33.840532],
              [45.583092, 33.840603],
              [45.583204, 33.840596],
              [45.583296, 33.840448],
              [45.583475, 33.84036],
              [45.583522, 33.840229],
              [45.58378, 33.840077],
              [45.583808, 33.839938],
              [45.584188, 33.839685],
              [45.584271, 33.839073],
              [45.584463, 33.838682],
              [45.584906, 33.83835],
              [45.585216, 33.837932],
              [45.585237, 33.837795],
              [45.585345, 33.837641],
              [45.585671, 33.837325],
              [45.58579, 33.836899],
              [45.585421, 33.836682],
              [45.585102, 33.836122],
              [45.585078, 33.835553],
              [45.585192, 33.835369],
              [45.585224, 33.834915],
              [45.585156, 33.834778],
              [45.58514, 33.834548],
              [45.585032, 33.834425],
              [45.585087, 33.834263],
              [45.584997, 33.83394],
              [45.585037, 33.83374],
              [45.584865, 33.833137],
              [45.584621, 33.832984],
              [45.584667, 33.832779],
              [45.58463, 33.832621],
              [45.584693, 33.832515],
              [45.585248, 33.832429],
              [45.585652, 33.832451],
              [45.585835, 33.83251],
              [45.586178, 33.832495],
              [45.58634, 33.832317],
              [45.586714, 33.832165],
              [45.586795, 33.832057],
              [45.586802, 33.831853],
              [45.586734, 33.831661],
              [45.586784, 33.831487],
              [45.587218, 33.830869],
              [45.587553, 33.830551],
              [45.587875, 33.830471],
              [45.588292, 33.829944],
              [45.588444, 33.829868],
              [45.588681, 33.82987],
              [45.588837, 33.829823],
              [45.589629, 33.829279],
              [45.589836, 33.828877],
              [45.590059, 33.828648],
              [45.590132, 33.828442],
              [45.590555, 33.827966],
              [45.59117, 33.827793],
              [45.59152, 33.827564],
              [45.591907, 33.827641],
              [45.592006, 33.827581],
              [45.592087, 33.827295],
              [45.592363, 33.826992],
              [45.592835, 33.826875],
              [45.593189, 33.826491],
              [45.593599, 33.826365],
              [45.593762, 33.826235],
              [45.593918, 33.82568],
              [45.594034, 33.825492],
              [45.594187, 33.825378],
              [45.594385, 33.825126],
              [45.594521, 33.824864],
              [45.59445, 33.824713],
              [45.5945, 33.824599],
              [45.595228, 33.824568],
              [45.59538, 33.824475],
              [45.595474, 33.823914],
              [45.595743, 33.823636],
              [45.595895, 33.823358],
              [45.596428, 33.823261],
              [45.596683, 33.823025],
              [45.59683, 33.82281],
              [45.597348, 33.822576],
              [45.597567, 33.82234],
              [45.597654, 33.82214],
              [45.597635, 33.821916],
              [45.597785, 33.821627],
              [45.598279, 33.821605],
              [45.59873, 33.821384],
              [45.598786, 33.821091],
              [45.599169, 33.820933],
              [45.599251, 33.820726],
              [45.599201, 33.820361],
              [45.599725, 33.819836],
              [45.599818, 33.819606],
              [45.600151, 33.819343],
              [45.600409, 33.819281],
              [45.600628, 33.819135],
              [45.601013, 33.818566],
              [45.601207, 33.818456],
              [45.599542, 33.810392],
              [45.603272, 33.803023],
              [45.607034, 33.800299],
              [45.6097194, 33.7989764],
              [45.629784, 33.789094],
              [45.629744, 33.788826],
              [45.630014, 33.788712],
              [45.63036, 33.788378],
              [45.63048, 33.788224],
              [45.630437, 33.788125],
              [45.630489, 33.788002],
              [45.630955, 33.787654],
              [45.631047, 33.787501],
              [45.631504, 33.78733],
              [45.631803, 33.787157],
              [45.631943, 33.786915],
              [45.632179, 33.78676],
              [45.632297, 33.786742],
              [45.632417, 33.786617],
              [45.632588, 33.786289],
              [45.632912, 33.786088],
              [45.633123, 33.786012],
              [45.633312, 33.785794],
              [45.633396, 33.785568],
              [45.633625, 33.78537],
              [45.633824, 33.785324],
              [45.633996, 33.785211],
              [45.634172, 33.784972],
              [45.634168, 33.784866],
              [45.63497, 33.784214],
              [45.635245, 33.783871],
              [45.635427, 33.78379],
              [45.635732, 33.783407],
              [45.635781, 33.783273],
              [45.636013, 33.783153],
              [45.636137, 33.782947],
              [45.636351, 33.782837],
              [45.636577, 33.782532],
              [45.636589, 33.78218],
              [45.636979, 33.782085],
              [45.637077, 33.781997],
              [45.637134, 33.781845],
              [45.637413, 33.781721],
              [45.637484, 33.781543],
              [45.637585, 33.781444],
              [45.637578, 33.781191],
              [45.637685, 33.780927],
              [45.638153, 33.780608],
              [45.638466, 33.780184],
              [45.638493, 33.779834],
              [45.63876, 33.77951],
              [45.639132, 33.779215],
              [45.639246, 33.77895],
              [45.639607, 33.778477],
              [45.639731, 33.778203],
              [45.639944, 33.777997],
              [45.640069, 33.777746],
              [45.640211, 33.777599],
              [45.640282, 33.777399],
              [45.640289, 33.777053],
              [45.640332, 33.776921],
              [45.64052, 33.776674],
              [45.640588, 33.77635],
              [45.6408, 33.776093],
              [45.641203, 33.775741],
              [45.641328, 33.775491],
              [45.641693, 33.774989],
              [45.641795, 33.774708],
              [45.642428, 33.774158],
              [45.64246, 33.773825],
              [45.642663, 33.773192],
              [45.643015, 33.772991],
              [45.643222, 33.772741],
              [45.643433, 33.772343],
              [45.643764, 33.772],
              [45.643841, 33.771844],
              [45.643833, 33.771727],
              [45.644034, 33.771337],
              [45.644158, 33.770855],
              [45.644758, 33.769848],
              [45.644999, 33.769597],
              [45.645245, 33.768758],
              [45.645402, 33.768619],
              [45.645517, 33.768404],
              [45.645666, 33.767911],
              [45.646047, 33.767485],
              [45.646419, 33.766542],
              [45.646417, 33.766305],
              [45.646715, 33.766082],
              [45.64672, 33.765962],
              [45.646994, 33.765704],
              [45.647097, 33.765542],
              [45.64706, 33.765397],
              [45.647115, 33.765189],
              [45.647269, 33.764966],
              [45.64735, 33.764639],
              [45.647983, 33.763768],
              [45.648138, 33.763686],
              [45.648214, 33.763411],
              [45.647746, 33.763302],
              [45.647625, 33.763205],
              [45.647337, 33.762859],
              [45.647108, 33.762676],
              [45.646857, 33.762038],
              [45.646668, 33.76178],
              [45.646513, 33.761605],
              [45.646079, 33.761447],
              [45.645943, 33.760501],
              [45.646108, 33.760214],
              [45.646136, 33.759982],
              [45.646081, 33.759601],
              [45.645954, 33.759384],
              [45.646129, 33.758897],
              [45.646034, 33.758691],
              [45.645814, 33.75847],
              [45.645651, 33.758184],
              [45.645298, 33.757955],
              [45.645272, 33.757763],
              [45.64536, 33.757514],
              [45.645363, 33.757316],
              [45.645046, 33.757069],
              [45.644582, 33.75681],
              [45.644408, 33.756548],
              [45.644196, 33.756376],
              [45.644045, 33.756282],
              [45.643797, 33.756256],
              [45.643247, 33.755754],
              [45.642766, 33.755241],
              [45.6427, 33.75495],
              [45.642739, 33.754663],
              [45.64261, 33.75455],
              [45.642018, 33.754438],
              [45.641355, 33.754193],
              [45.641215, 33.754032],
              [45.640831, 33.753962],
              [45.64061, 33.753645],
              [45.640445, 33.753622],
              [45.640322, 33.753519],
              [45.640297, 33.753028],
              [45.640126, 33.7528],
              [45.640029, 33.752574],
              [45.639819, 33.752399],
              [45.639717, 33.752216],
              [45.639928, 33.75155],
              [45.639931, 33.751386],
              [45.639837, 33.751244],
              [45.639688, 33.751158],
              [45.639646, 33.751051],
              [45.639919, 33.750711],
              [45.639995, 33.750341],
              [45.639896, 33.750101],
              [45.639957, 33.749914],
              [45.640166, 33.749714],
              [45.640216, 33.749608],
              [45.640146, 33.749486],
              [45.640006, 33.749385],
              [45.640138, 33.74911],
              [45.64009, 33.748973],
              [45.639958, 33.748853],
              [45.639833, 33.748545],
              [45.639705, 33.748413],
              [45.639545, 33.747829],
              [45.639219, 33.747466],
              [45.639026, 33.746653],
              [45.639092, 33.746391],
              [45.638957, 33.74582],
              [45.639093, 33.745652],
              [45.639323, 33.745481],
              [45.639375, 33.745262],
              [45.639528, 33.745108],
              [45.639785, 33.745118],
              [45.640212, 33.744384],
              [45.640251, 33.744099],
              [45.640049, 33.743671],
              [45.64004, 33.743549],
              [45.640037, 33.743307],
              [45.640187, 33.742656],
              [45.640466, 33.742324],
              [45.640502, 33.741984],
              [45.640587, 33.741854],
              [45.640779, 33.741714],
              [45.641172, 33.740681],
              [45.640754, 33.740359],
              [45.64046, 33.74022],
              [45.640283, 33.740041],
              [45.640118, 33.739832],
              [45.639855, 33.739337],
              [45.640061, 33.739014],
              [45.640002, 33.738653],
              [45.640092, 33.738285],
              [45.640055, 33.738022],
              [45.640318, 33.737867],
              [45.640437, 33.737714],
              [45.640551, 33.737262],
              [45.640719, 33.736975],
              [45.640854, 33.736874],
              [45.6413, 33.736875],
              [45.641818, 33.73698],
              [45.642088, 33.736689],
              [45.642136, 33.736087],
              [45.641998, 33.735527],
              [45.641847, 33.734418],
              [45.64196, 33.734311],
              [45.642104, 33.733966],
              [45.642367, 33.733743],
              [45.642898, 33.733555],
              [45.643349, 33.733214],
              [45.643621, 33.733103],
              [45.643705, 33.732922],
              [45.643938, 33.732785],
              [45.644369, 33.732778],
              [45.644677, 33.732685],
              [45.644806, 33.732693],
              [45.646508, 33.732149],
              [45.646565, 33.729599],
              [45.646649, 33.729271],
              [45.646893, 33.728985],
              [45.647241, 33.728215],
              [45.647451, 33.728021],
              [45.647933, 33.727749],
              [45.648184, 33.727716],
              [45.648447, 33.727748],
              [45.648934, 33.727656],
              [45.649699, 33.727022],
              [45.650396, 33.727013],
              [45.650822, 33.726854],
              [45.652005, 33.726679],
              [45.652096, 33.72657],
              [45.652542, 33.72648],
              [45.652783, 33.726274],
              [45.652825, 33.726091],
              [45.652929, 33.725957],
              [45.653047, 33.725917],
              [45.653814, 33.725864],
              [45.653834, 33.725725],
              [45.654019, 33.725609],
              [45.654343, 33.725685],
              [45.654808, 33.725563],
              [45.654996, 33.725063],
              [45.654954, 33.724784],
              [45.655053, 33.724702],
              [45.655238, 33.724631],
              [45.655432, 33.72466],
              [45.655665, 33.724568],
              [45.655997, 33.724507],
              [45.656587, 33.724484],
              [45.656857, 33.724379],
              [45.657157, 33.724466],
              [45.657637, 33.724025],
              [45.658065, 33.723804],
              [45.65833, 33.723401],
              [45.658861, 33.723436],
              [45.658963, 33.723364],
              [45.659005, 33.723204],
              [45.65891, 33.722907],
              [45.658935, 33.722642],
              [45.659165, 33.722699],
              [45.659405, 33.722682],
              [45.659675, 33.722304],
              [45.659885, 33.722118],
              [45.659809, 33.721981],
              [45.659344, 33.721694],
              [45.65916, 33.721136],
              [45.659195, 33.721009],
              [45.659329, 33.720927],
              [45.659566, 33.720899],
              [45.659736, 33.720826],
              [45.659877, 33.720655],
              [45.659881, 33.720539],
              [45.659661, 33.720426],
              [45.659553, 33.72029],
              [45.659542, 33.720057],
              [45.65965, 33.719773],
              [45.659868, 33.71968],
              [45.660066, 33.719298],
              [45.660479, 33.717989],
              [45.660431, 33.717808],
              [45.6605, 33.717684],
              [45.660211, 33.717066],
              [45.660228, 33.716926],
              [45.660364, 33.716848],
              [45.660602, 33.716799],
              [45.661139, 33.715858],
              [45.661384, 33.715725],
              [45.661687, 33.715411],
              [45.662163, 33.715362],
              [45.662388, 33.715556],
              [45.662937, 33.715809],
              [45.663089, 33.715762],
              [45.663229, 33.715634],
              [45.663138, 33.715183],
              [45.662924, 33.714959],
              [45.662881, 33.714624],
              [45.663042, 33.714323],
              [45.663159, 33.714227],
              [45.663322, 33.714216],
              [45.663591, 33.71427],
              [45.664123, 33.714165],
              [45.664255, 33.714072],
              [45.664184, 33.713688],
              [45.663868, 33.713218],
              [45.663758, 33.712836],
              [45.664127, 33.712344],
              [45.664503, 33.712032],
              [45.664529, 33.711944],
              [45.664438, 33.711558],
              [45.664633, 33.711065],
              [45.664727, 33.710652],
              [45.665042, 33.710423],
              [45.665105, 33.710257],
              [45.665334, 33.709985],
              [45.665357, 33.709254],
              [45.665605, 33.708935],
              [45.668773, 33.706713],
              [45.669, 33.70672],
              [45.669059, 33.706687],
              [45.669106, 33.706422],
              [45.669244, 33.706298],
              [45.66945, 33.706181],
              [45.669687, 33.706155],
              [45.669855, 33.706204],
              [45.670072, 33.706137],
              [45.67017, 33.706012],
              [45.670227, 33.705822],
              [45.670483, 33.705713],
              [45.670878, 33.70567],
              [45.670955, 33.705438],
              [45.670954, 33.705207],
              [45.67108, 33.704992],
              [45.67173, 33.704683],
              [45.672224, 33.704763],
              [45.673041, 33.704329],
              [45.673136, 33.703924],
              [45.672974, 33.703389],
              [45.673287, 33.702991],
              [45.673246, 33.702785],
              [45.673126, 33.702661],
              [45.673066, 33.702505],
              [45.673212, 33.702248],
              [45.673839, 33.701551],
              [45.673762, 33.700802],
              [45.674029, 33.70062],
              [45.673943, 33.70034],
              [45.674095, 33.700024],
              [45.674055, 33.699533],
              [45.674334, 33.69907],
              [45.674509, 33.698905],
              [45.674718, 33.698829],
              [45.675134, 33.698717],
              [45.675491, 33.698722],
              [45.675695, 33.698846],
              [45.675879, 33.698884],
              [45.676085, 33.69886],
              [45.676337, 33.698968],
              [45.676782, 33.699227],
              [45.677114, 33.699574],
              [45.677422, 33.699511],
              [45.67775, 33.699328],
              [45.677448, 33.69897],
              [45.677238, 33.698521],
              [45.677268, 33.698335],
              [45.677367, 33.697964],
              [45.677858, 33.697655],
              [45.678043, 33.697371],
              [45.678268, 33.697193],
              [45.678401, 33.696865],
              [45.678403, 33.696329],
              [45.678673, 33.695514],
              [45.678895, 33.695348],
              [45.679157, 33.695294],
              [45.679403, 33.695314],
              [45.679973, 33.695005],
              [45.68019, 33.695086],
              [45.680415, 33.695061],
              [45.680635, 33.694978],
              [45.680981, 33.694934],
              [45.681223, 33.694813],
              [45.681885, 33.694173],
              [45.682408, 33.694016],
              [45.682549, 33.693889],
              [45.682705, 33.693638],
              [45.683044, 33.693398],
              [45.683079, 33.693239],
              [45.688797, 33.690916],
              [45.689217, 33.690886],
              [45.690207, 33.690935],
              [45.691379, 33.691167],
              [45.69252, 33.69097],
              [45.7107663, 33.6900307],
              [45.7230872, 33.6894406],
              [45.7328276, 33.6889436],
              [45.7415812, 33.6921776],
              [45.7492661, 33.6962515],
              [45.7536724, 33.6999299],
              [45.755626, 33.701161],
              [45.7565976, 33.7004744],
              [45.7576479, 33.7000119],
              [45.7582712, 33.7005824],
              [45.7591402, 33.7020194],
              [45.7594192, 33.7028674],
              [45.7605994, 33.7025193],
              [45.7611787, 33.7027781],
              [45.762831, 33.7038224],
              [45.7645047, 33.7033404],
              [45.7656956, 33.703992],
              [45.7666261, 33.7031229],
              [45.7672083, 33.7031262],
              [45.7676151, 33.7038118],
              [45.7670581, 33.7044382],
              [45.7669352, 33.7051547],
              [45.7672083, 33.7059823],
              [45.7682914, 33.7058513],
              [45.7688674, 33.7063044],
              [45.768641, 33.7067791],
              [45.767617, 33.7081886],
              [45.7650578, 33.7094624],
              [45.7649982, 33.7103824],
              [45.7651162, 33.7112927],
              [45.7669401, 33.7120156],
              [45.76825, 33.7112919],
              [45.7686756, 33.7115999],
              [45.7690652, 33.7118632],
              [45.7711857, 33.7135604],
              [45.772326, 33.7144877],
              [45.7735754, 33.7152669],
              [45.7733131, 33.7158247],
              [45.772843, 33.7162045],
              [45.7717116, 33.7163821],
              [45.7725084, 33.7167054],
              [45.7733184, 33.7169553],
              [45.7734686, 33.7175175],
              [45.7731306, 33.7176737],
              [45.7738495, 33.7182448],
              [45.7743967, 33.7191327],
              [45.7743859, 33.7204401],
              [45.7745308, 33.720739],
              [45.7749438, 33.7207301],
              [45.7757324, 33.7196101],
              [45.7761601, 33.71937],
              [45.7768321, 33.7207345],
              [45.7761454, 33.721618],
              [45.7763493, 33.7219839],
              [45.7764029, 33.7226978],
              [45.7762635, 33.7231261],
              [45.7770467, 33.7229208],
              [45.7780659, 33.723135],
              [45.7789993, 33.7235723],
              [45.7797074, 33.7232332],
              [45.7804116, 33.7234847],
              [45.7810749, 33.7250341],
              [45.7816279, 33.7251606],
              [45.782572, 33.7239284],
              [45.7829905, 33.7237061],
              [45.7835752, 33.72384],
              [45.7839453, 33.7242549],
              [45.7842106, 33.7259628],
              [45.7854659, 33.7270061],
              [45.786488, 33.7266954],
              [45.7877794, 33.7264415],
              [45.7906216, 33.7283316],
              [45.7949168, 33.7291577],
              [45.7963664, 33.7291497],
              [45.7982546, 33.7300351],
              [45.7993865, 33.7305383],
              [45.8007715, 33.7300516],
              [45.805485, 33.7315064],
              [45.8064524, 33.7312129],
              [45.8076792, 33.7313493],
              [45.8078833, 33.7303757],
              [45.8097267, 33.7304966],
              [45.8111244, 33.7323509],
              [45.8140075, 33.7353772],
              [45.8165414, 33.7331621],
              [45.8172369, 33.7337979],
              [45.8179235, 33.7327629],
              [45.821979, 33.7367869],
              [45.8253908, 33.7406054],
              [45.8255302, 33.7426931],
              [45.8277863, 33.7428998],
              [45.829103, 33.744522],
              [45.832768, 33.7477489],
              [45.835431, 33.7485598],
              [45.8376646, 33.7502493],
              [45.8435654, 33.75638],
              [45.8458614, 33.7576709],
              [45.8474063, 33.757778],
              [45.85482, 33.7608285],
              [45.8554423, 33.7612745],
              [45.8547878, 33.7632903],
              [45.8534574, 33.7640217],
              [45.8522129, 33.7645568],
              [45.846391, 33.7710462],
              [45.8424164, 33.7742954],
              [45.8437898, 33.7775293],
              [45.8507108, 33.780164],
              [45.8542084, 33.7810023],
              [45.8554101, 33.7825717],
              [45.8545303, 33.7857818],
              [45.8527083, 33.7882754],
              [45.8479955, 33.7926428],
              [45.84473, 33.7947438],
              [45.8438873, 33.7964102],
              [45.8441642, 33.7981091],
              [45.8452161, 33.8002227],
              [45.8475468, 33.8021779],
              [45.8516627, 33.8078833],
              [45.8557687, 33.813984],
              [45.8592506, 33.8185397],
              [45.8617202, 33.8224671],
              [45.8651421, 33.8268776],
              [45.8672691, 33.8304224],
              [45.8683274, 33.8335958],
              [45.8694481, 33.8365031],
              [45.8693141, 33.8394571],
              [45.8688768, 33.8420836],
              [45.868269, 33.8439311],
              [45.8667237, 33.8459048],
              [45.8665225, 33.8470544],
              [45.8665252, 33.8484452],
              [45.8673178, 33.8492573],
              [45.8777982, 33.8539323],
              [45.8814325, 33.8547885],
              [45.8863735, 33.860224],
              [45.8884334, 33.8652131],
              [45.8890342, 33.8679213],
              [45.8882618, 33.8725179],
              [45.8880043, 33.8759741],
              [45.8885622, 33.8783257],
              [45.8898496, 33.8810334],
              [45.8917379, 33.885095],
              [45.8933687, 33.8877669],
              [45.8986473, 33.893538],
              [45.9056854, 33.8978483],
              [45.9058668, 33.8987048],
              [45.8893464, 33.9054757],
              [45.8885128, 33.9063151],
              [45.8593426, 33.9215881],
              [45.8587895, 33.9221478],
              [45.8576761, 33.9226984],
              [45.8537902, 33.9265889],
              [45.8446235, 33.9490921],
              [45.8460094, 33.955203],
              [45.8498993, 33.9629748],
              [45.8498993, 33.9635345],
              [45.851843, 33.9693655],
              [45.8573993, 33.9788162],
              [45.8576811, 33.9790946],
              [45.8673995, 33.9890883],
              [45.8679558, 33.9890882],
              [45.8679558, 33.989368],
              [45.8737895, 33.9893681],
              [45.8757325, 33.9888084],
              [45.8762896, 33.9885377],
              [45.9124021, 33.9707558],
              [45.9185154, 33.9690949],
              [45.9193491, 33.9688151],
              [45.9212921, 33.9688151],
              [45.9215687, 33.9685353],
              [45.9235156, 33.9685353],
              [45.9243484, 33.9682555],
              [45.9257352, 33.9682555],
              [45.9260156, 33.9679757],
              [45.9274017, 33.9679757],
              [45.9279587, 33.9676958],
              [45.9321252, 33.9676959],
              [45.9326822, 33.967425],
              [45.9337916, 33.9676959],
              [45.9349018, 33.967425],
              [45.9354588, 33.9676959],
              [45.937405, 33.9674251],
              [45.9379589, 33.9674252],
              [45.9435153, 33.9676959],
              [45.9446253, 33.9679757],
              [45.9462919, 33.9679757],
              [45.9474051, 33.9682556],
              [45.9529584, 33.9682556],
              [45.9543482, 33.9685354],
              [45.9607382, 33.9685354],
              [45.9615718, 33.9688153],
              [45.9643485, 33.9688153],
              [45.9676812, 33.9693659],
              [45.9682384, 33.9696456],
              [45.9699048, 33.9696457],
              [45.9793511, 33.9715864],
              [45.979905, 33.9718662],
              [45.9810183, 33.9718663],
              [45.9824043, 33.9724168],
              [45.9832378, 33.9724168],
              [46.0132408, 33.9846477],
              [46.0137978, 33.9846477],
              [46.0229643, 33.9999202],
              [46.0385201, 34.0160322],
              [46.0549102, 34.0374244],
              [46.0549102, 34.0377041],
              [46.0587969, 34.0377041],
              [46.0690769, 34.036594],
              [46.0693534, 34.0363141],
              [46.0707433, 34.0363141],
              [46.0746332, 34.0343646],
              [46.0776864, 34.0321441],
              [46.0804662, 34.0307631],
              [46.0812997, 34.0299237],
              [46.0821334, 34.0296438],
              [46.0840763, 34.0274234],
              [46.0846334, 34.0263132],
              [46.0865765, 34.0243636],
              [46.0935227, 34.0215925],
              [46.0946329, 34.0210329],
              [46.0965758, 34.0210329],
              [46.0993564, 34.0202025],
              [46.1007432, 34.0202025],
              [46.1110231, 34.0149222],
              [46.1273844, 33.9999291],
              [46.1401894, 33.9960303],
              [46.1401894, 33.9957595],
              [46.1415791, 33.9951998],
              [46.1485255, 33.9899285],
              [46.1493591, 33.9899285],
              [46.1538022, 33.9888093],
              [46.1565787, 33.9888093],
              [46.1574124, 33.9890891],
              [46.1646353, 33.9890892],
              [46.1651923, 33.9888093],
              [46.1682485, 33.9879789],
              [46.1796355, 33.9801982],
              [46.1949156, 33.9724175],
              [46.1954719, 33.9721467],
              [46.2001954, 33.970197],
              [46.2024149, 33.9696464],
              [46.213248, 33.965756],
              [46.2146386, 33.965756],
              [46.2151949, 33.9654762],
              [46.2251952, 33.9638154],
              [46.2290851, 33.9624253],
              [46.2304718, 33.9624253],
              [46.232418, 33.9618657],
              [46.2338047, 33.9618656],
              [46.2451947, 33.9593654],
              [46.2463081, 33.9588147],
              [46.2782541, 33.9507633],
              [46.2788072, 33.9507632],
              [46.2799213, 33.9507633],
              [46.2815877, 33.9502036],
              [46.2904738, 33.9543648],
              [46.2913074, 33.957145],
              [46.2910309, 33.9574248],
              [46.2913074, 33.9589556],
              [46.2913074, 33.9596453],
              [46.2910309, 33.9604847],
              [46.289087, 33.9657563],
              [46.2918636, 33.982419],
              [46.2951972, 33.9927],
              [46.2976972, 33.9949296],
              [46.2982535, 33.9952004],
              [46.2985308, 33.9954801],
              [46.3068639, 33.99131],
              [46.3074201, 33.9910392],
              [46.3490897, 33.9727067],
              [46.3557564, 33.9704863],
              [46.3921463, 33.9524244],
              [46.3929798, 33.9518647],
              [46.4682619, 33.9129785],
              [46.4696519, 33.9118682],
              [46.4710386, 33.9113176],
              [46.4718722, 33.910758],
              [46.472705, 33.9107579],
              [46.4849288, 33.9057572],
              [46.5013182, 33.8979763],
              [46.5415979, 33.8699212],
              [46.5418777, 33.8696414],
              [46.558264, 33.8615895],
              [46.5591007, 33.8615894],
              [46.5593781, 33.8613096],
              [46.5599343, 33.8613096],
              [46.5602108, 33.8610298],
              [46.5816005, 33.849647],
              [46.582434, 33.8490873],
              [46.5835442, 33.8488164],
              [46.5899342, 33.8451967],
              [46.5907671, 33.8449259],
              [46.6154902, 33.8340847],
              [46.6160473, 33.8338138],
              [46.6163238, 33.833534],
              [46.6168801, 33.833534],
              [46.6168801, 33.8332542],
              [46.62077, 33.8313134],
              [46.6210473, 33.8310336],
              [46.621324, 33.830825],
              [46.6216036, 33.830203],
              [46.6352134, 33.8193707],
              [46.6411214, 33.8144911],
              [46.6607701, 33.7982565],
              [46.6657702, 33.7949255],
              [46.667993, 33.7932555],
              [46.6707696, 33.7904752],
              [46.6713267, 33.7893649],
              [46.6932733, 33.7593676],
              [46.6952163, 33.7571469],
              [46.7027166, 33.7529764],
              [46.7052166, 33.7521458],
              [46.7129964, 33.7493655],
              [46.7135527, 33.7488058],
              [46.7143863, 33.7485349],
              [46.724106, 33.7421437],
              [46.7252193, 33.7421437],
              [46.7252193, 33.7418638],
              [46.7268858, 33.7418638],
              [46.7268858, 33.7421437],
              [46.7279674, 33.7421437],
              [46.7288296, 33.7421437],
              [46.7296624, 33.7421437],
              [46.7299429, 33.7418639],
              [46.7313296, 33.7418638],
              [46.7318858, 33.7418639],
              [46.7324429, 33.741584],
              [46.7335524, 33.741584],
              [46.7341093, 33.7418639],
              [46.7360524, 33.7418638],
              [46.7363289, 33.7421437],
              [46.739386, 33.7426944],
              [46.7504988, 33.7529764],
              [46.7513324, 33.7543666],
              [46.7524425, 33.7574179],
              [46.7554988, 33.7676999],
              [46.7588324, 33.7710309],
              [46.7599418, 33.7710309],
              [46.7604988, 33.7713107],
              [46.7627183, 33.7713108],
              [46.763552, 33.7710309],
              [46.7646653, 33.771031],
              [46.7652184, 33.770751],
              [46.7663317, 33.7707511],
              [46.7666083, 33.7704713],
              [46.7688319, 33.7702005],
              [46.770499, 33.7693609],
              [46.7771656, 33.7676999],
              [46.7791086, 33.7671403],
              [46.7799422, 33.7671403],
              [46.8293918, 33.7490859],
              [46.8299449, 33.7485353],
              [46.8307776, 33.7482554],
              [46.8338347, 33.7460257],
              [46.8388349, 33.7432543],
              [46.8427248, 33.7413045],
              [46.8582814, 33.7338119],
              [46.8591143, 33.7338119],
              [46.8596674, 33.733532],
              [46.8627245, 33.733532],
              [46.8630042, 33.7332522],
              [46.8688378, 33.7332522],
              [46.8696707, 33.7335321],
              [46.8718911, 33.7335321],
              [46.8727239, 33.7338119],
              [46.8738372, 33.7338119],
              [46.8826572, 33.741441],
              [46.8893569, 33.7407478],
              [46.8905891, 33.7403185],
              [46.8949469, 33.7418643],
              [46.8968939, 33.7424149],
              [46.9002275, 33.7435343],
              [46.9005041, 33.744085],
              [46.9132832, 33.7576981],
              [46.9141168, 33.761309],
              [46.9141168, 33.7626992],
              [46.9138371, 33.7632499],
              [46.91467, 33.7643693],
              [46.9146699, 33.7649199],
              [46.9149504, 33.7651998],
              [46.9161996, 33.767937],
              [46.9172096, 33.769461],
              [46.9189626, 33.7715498],
              [46.9206563, 33.7712064],
              [46.9247797, 33.7698329],
              [46.9293276, 33.7682216],
              [46.9329313, 33.7667351],
              [46.9341941, 33.7662534],
              [46.9352661, 33.7655277],
              [46.9363111, 33.7650639],
              [46.9376489, 33.7646622],
              [46.9393299, 33.7641177],
              [46.9405506, 33.7639328],
              [46.9413166, 33.7639284],
              [46.9428607, 33.7637171],
              [46.943332, 33.7636485],
              [46.9449834, 33.7630144],
              [46.9474686, 33.7631416],
              [46.9645137, 33.7513768],
              [46.9680749, 33.7479871],
              [46.9686405, 33.743944],
              [46.969943, 33.7433909],
              [46.9706703, 33.7432359],
              [46.971503, 33.743197],
              [46.9735402, 33.7438572],
              [46.9751694, 33.7438986],
              [46.9768178, 33.7442498],
              [46.9779031, 33.7444803],
              [46.9785626, 33.7443651],
              [46.9793962, 33.7454754],
              [46.9874527, 33.7585289],
              [46.9882862, 33.7624196],
              [46.993566, 33.7729724],
              [46.9988426, 33.7818642],
              [46.9991192, 33.7835341],
              [46.9995462, 33.7865854],
              [46.998009, 33.7951972],
              [46.9977324, 33.795477],
              [46.9977324, 33.8007489],
              [46.9968988, 33.805479],
              [46.9971753, 33.8115904],
              [46.9977324, 33.8113105],
              [46.9982855, 33.8113105],
              [46.9996072, 33.8107508],
              [47.002452, 33.8102002],
              [47.0043989, 33.8102002],
              [47.004952, 33.8099204],
              [47.0099521, 33.8110307],
              [47.0185656, 33.8110307],
              [47.0193984, 33.8113106],
              [47.020789, 33.8113106],
              [47.0307885, 33.8143708],
              [47.0399551, 33.8238131],
              [47.0443981, 33.8302042],
              [47.0466215, 33.8318651],
              [47.0471786, 33.8318651],
              [47.0521778, 33.8332553],
              [47.0905147, 33.8243638],
              [47.0927342, 33.8243639],
              [47.0938475, 33.8249236],
              [47.0946811, 33.8249235],
              [47.0960679, 33.8254742],
              [47.0994007, 33.8299245],
              [47.0996812, 33.8304842],
              [47.1024578, 33.8368662],
              [47.1063476, 33.8404771],
              [47.1094041, 33.8402062],
              [47.1127377, 33.8385362],
              [47.1269036, 33.8238133],
              [47.1269036, 33.8232536],
              [47.1296803, 33.8202025],
              [47.1299607, 33.8199226],
              [47.1374601, 33.8146418],
              [47.1396805, 33.8143711],
              [47.1402367, 33.8146418],
              [47.1471838, 33.8146419],
              [47.1499604, 33.8152016],
              [47.1521838, 33.8152016],
              [47.1532933, 33.8154815],
              [47.1546839, 33.8154814],
              [47.1602371, 33.8163119],
              [47.1677404, 33.8168716],
              [47.1771836, 33.8168716],
              [47.1777399, 33.8165828],
              [47.1832963, 33.8157613],
              [47.189683, 33.8138115],
              [47.1902401, 33.8132609],
              [47.1907964, 33.8132609],
              [47.1921831, 33.8121416],
              [47.1949628, 33.8099208],
              [47.2069061, 33.8038096],
              [47.2116296, 33.8026992],
              [47.2138531, 33.8024284],
              [47.2199626, 33.8029792],
              [47.2307956, 33.80325],
              [47.2310762, 33.8035388],
              [47.2335762, 33.8038097],
              [47.2341293, 33.8038097],
              [47.2346855, 33.8038096],
              [47.2360763, 33.8040895],
              [47.2380192, 33.8040895],
              [47.2391325, 33.8043693],
              [47.2438522, 33.8043694],
              [47.2444092, 33.8040895],
              [47.2452428, 33.8040896],
              [47.2460756, 33.8038097],
              [47.2491327, 33.8038097],
              [47.2499656, 33.80325],
              [47.2516328, 33.8029792],
              [47.2807991, 33.7896462],
              [47.284132, 33.7888157],
              [47.2852452, 33.7885359],
              [47.2874656, 33.788536],
              [47.2882985, 33.7882561],
              [47.2932985, 33.7882561],
              [47.2935782, 33.7885359],
              [47.2952454, 33.788536],
              [47.304412, 33.791867],
              [47.3077448, 33.7963083],
              [47.308855, 33.8018691],
              [47.3091347, 33.8121418],
              [47.3116348, 33.8163123],
              [47.3158012, 33.8196433],
              [47.3188583, 33.8210335],
              [47.3355243, 33.8138119],
              [47.3371915, 33.8138118],
              [47.3413579, 33.8149222],
              [47.343301, 33.8160326],
              [47.3435814, 33.8165832],
              [47.3441346, 33.8168721],
              [47.3588574, 33.839927],
              [47.3602473, 33.8421476],
              [47.3605239, 33.8426982],
              [47.3713608, 33.8510302],
              [47.3724709, 33.85131],
              [47.378861, 33.85131],
              [47.380804, 33.8527001],
              [47.3830275, 33.8538105],
              [47.3866369, 33.8613118],
              [47.3835806, 33.870474],
              [47.383304, 33.873534],
              [47.3830274, 33.8740938],
              [47.3830273, 33.8752041],
              [47.3821938, 33.8765852],
              [47.3819141, 33.8777045],
              [47.379414, 33.8818748],
              [47.3774702, 33.8849259],
              [47.3596909, 33.9027085],
              [47.3591377, 33.9027085],
              [47.3535805, 33.9071497],
              [47.3505243, 33.90965],
              [47.3196907, 33.9390947],
              [47.3133014, 33.9527067],
              [47.3144108, 33.9560375],
              [47.3149679, 33.9571477],
              [47.3162408, 33.9610453],
              [47.3184165, 33.9617283],
              [47.3190028, 33.9626023],
              [47.3196033, 33.9629962],
              [47.3210631, 33.9633115],
              [47.3221906, 33.9632761],
              [47.3235059, 33.9633256],
              [47.3248942, 33.9623565],
              [47.3255244, 33.9624282],
              [47.3266345, 33.9624283],
              [47.326911, 33.9621484],
              [47.3274673, 33.9621485],
              [47.3285205, 33.9637552],
              [47.3304791, 33.9640947],
              [47.3336814, 33.9636933],
              [47.3386381, 33.9624189],
              [47.3410643, 33.9629317],
              [47.343142, 33.9627689],
              [47.3465939, 33.9619152],
              [47.348001, 33.96045],
              [47.3526571, 33.9572044],
              [47.3581098, 33.9547631],
              [47.3691423, 33.9505315],
              [47.3715305, 33.9487664],
              [47.3731877, 33.946201],
              [47.3765331, 33.9426555],
              [47.3795043, 33.9395527],
              [47.3824711, 33.9391127],
              [47.3853922, 33.9408508],
              [47.3890235, 33.9411189],
              [47.3902911, 33.9423288],
              [47.3885393, 33.9460523],
              [47.3909445, 33.9474609],
              [47.3941737, 33.9484303],
              [47.3976269, 33.9505547],
              [47.4020165, 33.9507483],
              [47.4052584, 33.9522074],
              [47.4103898, 33.9517217],
              [47.4171934, 33.9510371],
              [47.4185833, 33.9513169],
              [47.4213599, 33.9524271],
              [47.4221927, 33.9521474],
              [47.4235834, 33.9521473],
              [47.4244163, 33.9524271],
              [47.4269163, 33.9524271],
              [47.4274733, 33.9521473],
              [47.429973, 33.9521474],
              [47.4308062, 33.9518675],
              [47.4371962, 33.9510371],
              [47.4383064, 33.9504774],
              [47.4524727, 33.9460364],
              [47.4544192, 33.9454858],
              [47.4549728, 33.945206],
              [47.455806, 33.945206],
              [47.4605291, 33.9440957],
              [47.4624725, 33.9440957],
              [47.4630291, 33.943816],
              [47.4652526, 33.943816],
              [47.4658092, 33.9435362],
              [47.4790056, 33.9440778],
              [47.4763886, 33.9457699],
              [47.4778568, 33.9497446],
              [47.4853074, 33.9484928],
              [47.4935471, 33.9487776],
              [47.4977185, 33.9459581],
              [47.4993836, 33.9480656],
              [47.4961221, 33.9497744],
              [47.4922253, 33.9526508],
              [47.4882605, 33.9565067],
              [47.4924754, 33.964929],
              [47.4974754, 33.9718703],
              [47.4983086, 33.9729806],
              [47.4985851, 33.9757608],
              [47.4983086, 33.9763113],
              [47.4980321, 33.9771508],
              [47.4960852, 33.979651],
              [47.4883088, 33.9846516],
              [47.4841423, 33.9888128],
              [47.4816422, 33.9927031],
              [47.481362, 33.9999243],
              [47.4813621, 34.0018739],
              [47.480809, 34.003264],
              [47.4791421, 34.0038145],
              [47.478862, 34.0040943],
              [47.4771956, 34.0040943],
              [47.4769187, 34.0043742],
              [47.4763619, 34.0043741],
              [47.4749756, 34.006044],
              [47.4730287, 34.010485],
              [47.4674755, 34.0077048],
              [47.4666423, 34.0077048],
              [47.4644192, 34.0090948],
              [47.4635856, 34.0107647],
              [47.4635855, 34.0113153],
              [47.4596955, 34.020486],
              [47.4583057, 34.0221467],
              [47.4496958, 34.026037],
              [47.4491392, 34.0265967],
              [47.4485859, 34.0265967],
              [47.4452492, 34.0310376],
              [47.4455292, 34.0352076],
              [47.4430291, 34.0382675],
              [47.4424725, 34.0388181],
              [47.4410826, 34.0404789],
              [47.4408057, 34.0410385],
              [47.4371958, 34.046039],
              [47.4360825, 34.048819],
              [47.4360825, 34.0493787],
              [47.4349727, 34.05159],
              [47.4327492, 34.0546499],
              [47.4324726, 34.0554893],
              [47.4263596, 34.0604807],
              [47.423583, 34.0646507],
              [47.4233056, 34.0660407],
              [47.423583, 34.0682611],
              [47.4255259, 34.0746515],
              [47.4241392, 34.0763123],
              [47.4266392, 34.0843725],
              [47.4280291, 34.0871524],
              [47.4281223, 34.0874322],
              [47.4288627, 34.0888223],
              [47.4291393, 34.0896527],
              [47.4319159, 34.0963137],
              [47.432196, 34.0965936],
              [47.4489955, 34.093029],
              [47.4692065, 34.0919711],
              [47.4820517, 34.0893458],
              [47.4935676, 34.0896517],
              [47.503681, 34.0946057],
              [47.5085623, 34.104413],
              [47.5091742, 34.1157841],
              [47.5035093, 34.1236003],
              [47.5014494, 34.1321263],
              [47.5071142, 34.1406514],
              [47.5160406, 34.1486074],
              [47.526512, 34.1537215],
              [47.5337218, 34.1628126],
              [47.5297735, 34.1694882],
              [47.5217055, 34.1797137],
              [47.5116706, 34.1873297],
              [47.5291441, 34.185208],
              [47.5474773, 34.1799281],
              [47.5513672, 34.1796573],
              [47.5524774, 34.1793776],
              [47.5541438, 34.1793776],
              [47.5552539, 34.1796574],
              [47.5577537, 34.1796574],
              [47.559424, 34.1802079],
              [47.5605338, 34.180208],
              [47.5649772, 34.1821484],
              [47.5763669, 34.1935476],
              [47.5785904, 34.1965983],
              [47.5944234, 34.2132681],
              [47.6124797, 34.2221582],
              [47.6141464, 34.2221581],
              [47.6147031, 34.2224289],
              [47.6180364, 34.2221581],
              [47.6197028, 34.2215986],
              [47.6213696, 34.2215986],
              [47.6222029, 34.2213188],
              [47.6274795, 34.2213189],
              [47.6280362, 34.2215986],
              [47.629426, 34.2215986],
              [47.6386088, 34.2265663],
              [47.6397028, 34.2271582],
              [47.640536, 34.2271582],
              [47.6497026, 34.234938],
              [47.6499826, 34.2354885],
              [47.6519256, 34.237438],
              [47.6944284, 34.2760476],
              [47.695262, 34.2774375],
              [47.6974851, 34.2827171],
              [47.6977616, 34.2874372],
              [47.6980385, 34.2890978],
              [47.6977616, 34.2896574],
              [47.6835951, 34.3274355],
              [47.6835952, 34.3285455],
              [47.6835952, 34.3293849],
              [47.6833151, 34.3299354],
              [47.6833151, 34.3324353],
              [47.683315, 34.332715],
              [47.681095, 34.3402146],
              [47.6808149, 34.3416043],
              [47.6805385, 34.3424346],
              [47.6797052, 34.3463243],
              [47.6794286, 34.3477141],
              [47.6791485, 34.3493836],
              [47.6788719, 34.3510532],
              [47.6791485, 34.3560528],
              [47.6799817, 34.359383],
              [47.6927616, 34.3732718],
              [47.6930381, 34.3735515],
              [47.6949846, 34.3752121],
              [47.6952616, 34.3754918],
              [47.6969281, 34.3766019],
              [47.6999847, 34.3779916],
              [47.7002613, 34.3782714],
              [47.7010946, 34.3782714],
              [47.7016512, 34.3779917],
              [47.7047048, 34.3779917],
              [47.7052614, 34.3777119],
              [47.7085947, 34.3777119],
              [47.7238743, 34.3741021],
              [47.7252611, 34.3741021],
              [47.7280412, 34.3732719],
              [47.7291511, 34.3732719],
              [47.7308178, 34.3727124],
              [47.7319312, 34.3727124],
              [47.7619306, 34.3554935],
              [47.7630409, 34.354934],
              [47.7652639, 34.3535442],
              [47.7658206, 34.3535442],
              [47.7660971, 34.3532645],
              [47.780544, 34.3429944],
              [47.784987, 34.3407652],
              [47.7966536, 34.3366049],
              [47.8049901, 34.3346556],
              [47.8091571, 34.3335455],
              [47.8280466, 34.3238259],
              [47.8330467, 34.3188262],
              [47.8380464, 34.3038268],
              [47.8391566, 34.2996573],
              [47.8391566, 34.2991068],
              [47.8461034, 34.283268],
              [47.8461033, 34.2824377],
              [47.8472131, 34.2799378],
              [47.8477697, 34.279658],
              [47.8483233, 34.2785479],
              [47.8522132, 34.2746581],
              [47.874713, 34.2635483],
              [47.8863827, 34.2554889],
              [47.8866593, 34.2552092],
              [47.8877695, 34.2618787],
              [47.8916594, 34.2677089],
              [47.8916594, 34.2679887],
              [47.8927691, 34.2679887],
              [47.901106, 34.2732683],
              [47.9066592, 34.2813278],
              [47.9138824, 34.295488],
              [47.9138824, 34.2957678],
              [47.916659, 34.2977172],
              [47.9408286, 34.3196567],
              [47.9452719, 34.3268856],
              [47.9502716, 34.3393759],
              [47.9524951, 34.3454946],
              [47.9633281, 34.3552142],
              [47.9777745, 34.3593836],
              [47.9783315, 34.3596544],
              [47.9936287, 34.364661],
              [47.9886078, 34.3979905],
              [47.989441, 34.4010498],
              [47.989713, 34.4013069],
              [47.9901187, 34.4015108],
              [47.9905181, 34.4017389],
              [47.9985594, 34.4014534],
              [48.0013878, 34.4013296],
              [48.0130539, 34.3988299],
              [48.0136107, 34.3985502],
              [48.0144442, 34.3985501],
              [48.0149973, 34.3982704],
              [48.0166642, 34.3982703],
              [48.0172209, 34.3982703],
              [48.0186107, 34.3974401],
              [48.019444, 34.3968806],
              [48.0344439, 34.3907711],
              [48.0402772, 34.3899408],
              [48.0408339, 34.3896611],
              [48.0444438, 34.3896611],
              [48.0444437, 34.3899409],
              [48.0458336, 34.3899408],
              [48.047777, 34.3907711],
              [48.0555568, 34.3985502],
              [48.0558337, 34.39883],
              [48.0572236, 34.4016094],
              [48.06111, 34.4085492],
              [48.07389, 34.4129982],
              [48.0744466, 34.4132781],
              [48.0758333, 34.413278],
              [48.0802799, 34.414379],
              [48.0836131, 34.4160485],
              [48.0858332, 34.4182685],
              [48.0905563, 34.4321569],
              [48.0905562, 34.4329962],
              [48.0913899, 34.4338263],
              [48.0913899, 34.4341061],
              [48.0919465, 34.4346656],
              [48.0933363, 34.4432747],
              [48.0938894, 34.4457744],
              [48.0958363, 34.4507737],
              [48.0991696, 34.4546632],
              [48.1050029, 34.4674413],
              [48.1036127, 34.4710509],
              [48.103336, 34.4713306],
              [48.1025029, 34.4732799],
              [48.0975028, 34.4791093],
              [48.0908361, 34.492167],
              [48.090556, 34.4935566],
              [48.0913896, 34.4985559],
              [48.0988894, 34.5104944],
              [48.1013894, 34.5210523],
              [48.1013894, 34.5257717],
              [48.1013894, 34.5296699],
              [48.1008358, 34.5307708],
              [48.0977791, 34.5382785],
              [48.0849994, 34.5502258],
              [48.0833326, 34.554945],
              [48.0872225, 34.571052],
              [48.0863893, 34.5743817],
              [48.0855561, 34.57606],
              [48.0686096, 34.5946662],
              [48.0686095, 34.5949459],
              [48.0681225, 34.5954303],
              [48.0527764, 34.6160603],
              [48.0516662, 34.6180003],
              [48.0497196, 34.6204997],
              [48.0466665, 34.6229991],
              [48.0461098, 34.6229992],
              [48.0458328, 34.6232788],
              [48.0449996, 34.6232788],
              [48.044443, 34.6235586],
              [48.0433332, 34.6235586],
              [48.043053, 34.6232789],
              [48.0422194, 34.6232788],
              [48.0377764, 34.6080025],
              [48.038053, 34.6077229],
              [48.0397199, 34.6016051],
              [48.0399999, 34.6002245],
              [48.0397199, 34.5974453],
              [48.0372199, 34.5907771],
              [48.0344432, 34.5885573],
              [48.0330534, 34.5879979],
              [48.0252767, 34.5949458],
              [48.02222, 34.5963264],
              [48.0219433, 34.5966061],
              [48.0211102, 34.5966061],
              [48.0133303, 34.5893874],
              [48.001107, 34.5874384],
              [47.9994402, 34.5866082],
              [47.9930502, 34.5932764],
              [47.9913838, 34.594666],
              [47.9874969, 34.5968858],
              [47.9872172, 34.5971654],
              [47.9861071, 34.5971655],
              [47.9852738, 34.5977249],
              [47.9844407, 34.597725],
              [47.9841637, 34.5979956],
              [47.9827738, 34.5982753],
              [47.9822171, 34.5982753],
              [47.9819405, 34.5985551],
              [47.9811074, 34.5985551],
              [47.9733271, 34.602444],
              [47.968327, 34.6077525],
              [47.9552708, 34.6216093],
              [47.9549942, 34.6221688],
              [47.9547173, 34.6227191],
              [47.943051, 34.6249389],
              [47.9424943, 34.6252186],
              [47.9394376, 34.6252186],
              [47.9386044, 34.6254983],
              [47.9369376, 34.6254983],
              [47.9358279, 34.625778],
              [47.9319375, 34.625778],
              [47.9313809, 34.6254983],
              [47.9166579, 34.6266081],
              [47.9149911, 34.6268878],
              [47.9122144, 34.6268878],
              [47.9099914, 34.6271676],
              [47.9013814, 34.6271675],
              [47.899438, 34.6277269],
              [47.895268, 34.6288368],
              [47.8944348, 34.6288368],
              [47.8938817, 34.6291165],
              [47.8908249, 34.6291164],
              [47.8866581, 34.6282773],
              [47.8838819, 34.6282773],
              [47.8833248, 34.6279976],
              [47.8802684, 34.6279975],
              [47.8730448, 34.6293872],
              [47.865545, 34.6332761],
              [47.8588785, 34.6477219],
              [47.8586019, 34.6482813],
              [47.8577687, 34.649671],
              [47.8574886, 34.6499416],
              [47.8572117, 34.6505011],
              [47.8569351, 34.6507807],
              [47.8569351, 34.6510605],
              [47.8555451, 34.6535598],
              [47.8536018, 34.6613377],
              [47.8538784, 34.6674462],
              [47.854712, 34.6718944],
              [47.8636016, 34.6827218],
              [47.8641581, 34.684391],
              [47.8644351, 34.6880001],
              [47.8638785, 34.6910589],
              [47.8638784, 34.6913386],
              [47.8630449, 34.694668],
              [47.8652683, 34.7224487],
              [47.8649917, 34.7229991],
              [47.8624916, 34.7302261],
              [47.8591548, 34.7346742],
              [47.858045, 34.7371734],
              [47.8574883, 34.7377238],
              [47.8574883, 34.7380035],
              [47.8574883, 34.7382831],
              [47.8572114, 34.7388335],
              [47.8574884, 34.7407824],
              [47.8577684, 34.741053],
              [47.8577684, 34.7441117],
              [47.8574883, 34.7443914],
              [47.8558215, 34.7507792],
              [47.854155, 34.7541175],
              [47.8533214, 34.7549475],
              [47.8513784, 34.7585565],
              [47.8511014, 34.7591159],
              [47.8491549, 34.7630045],
              [47.8488783, 34.7646736],
              [47.8488783, 34.7649533],
              [47.813875, 34.8138351],
              [47.8135985, 34.8143945],
              [47.8119316, 34.8163433],
              [47.8074886, 34.8210617],
              [47.8019318, 34.8321766],
              [47.8002654, 34.834387],
              [47.8016517, 34.8427232],
              [47.7971938, 34.8511636],
              [47.8092814, 34.8562871],
              [47.8231499, 34.8573783],
              [47.8256962, 34.8567797],
              [47.8320284, 34.8577943],
              [47.833598, 34.8518893],
              [47.8338781, 34.852169],
              [47.8347113, 34.852169],
              [47.8352648, 34.8524487],
              [47.8433213, 34.8524488],
              [47.843878, 34.8527284],
              [47.8472112, 34.8527284],
              [47.8480448, 34.8530081],
              [47.8491546, 34.8530081],
              [47.8586012, 34.8557778],
              [47.8622111, 34.8574558],
              [47.863601, 34.8580062],
              [47.8819341, 34.8732888],
              [47.9074905, 34.8868934],
              [47.9086037, 34.8877324],
              [47.9086038, 34.8880031],
              [47.9102705, 34.8891127],
              [47.9177704, 34.8955089],
              [47.9261037, 34.9152297],
              [47.9266603, 34.9163393],
              [47.9274935, 34.9252343],
              [47.9277701, 34.9288428],
              [47.9272133, 34.9299524],
              [47.9236036, 34.9335609],
              [47.9230468, 34.9338405],
              [47.9230469, 34.9341202],
              [47.9223534, 34.9345351],
              [47.919437, 34.9335608],
              [47.9183268, 34.9335608],
              [47.9002707, 34.9280127],
              [47.899437, 34.9277331],
              [47.8980471, 34.9277331],
              [47.8969338, 34.9274534],
              [47.8952669, 34.9274534],
              [47.8941572, 34.9271737],
              [47.8911005, 34.9271738],
              [47.8899907, 34.9268941],
              [47.8836008, 34.926894],
              [47.8833238, 34.9271737],
              [47.8805472, 34.9271737],
              [47.8627675, 34.9318918],
              [47.8624909, 34.9321714],
              [47.8616577, 34.9321714],
              [47.8613776, 34.9324511],
              [47.8608209, 34.9324511],
              [47.8605444, 34.9327308],
              [47.8599874, 34.9327307],
              [47.858601, 34.9332901],
              [47.8399878, 34.938838],
              [47.8322113, 34.945225],
              [47.8144312, 34.968012],
              [47.813598, 34.9696809],
              [47.8052646, 34.980515],
              [47.8052645, 34.9849533],
              [47.8060982, 34.9888412],
              [47.8094314, 34.9977267],
              [47.8113744, 34.9988453],
              [47.8113745, 34.9993955],
              [47.8110978, 35.0003247],
              [47.8108212, 35.001344],
              [47.8105412, 35.0021739],
              [47.8055414, 35.0116186],
              [47.8041512, 35.0130078],
              [47.8038746, 35.0138376],
              [47.8030414, 35.0149562],
              [47.7910904, 35.0219162],
              [47.7901863, 35.0218899],
              [47.7899933, 35.0222065],
              [47.7777883, 35.0329462],
              [47.7769607, 35.0343965],
              [47.7717957, 35.0386575],
              [47.7683729, 35.0414994],
              [47.7657599, 35.0436287],
              [47.7624092, 35.0447168],
              [47.7541762, 35.0459434],
              [47.7537781, 35.0460016],
              [47.7457091, 35.0473936],
              [47.736844, 35.0518469],
              [47.7331741, 35.0562333],
              [47.7311069, 35.0605149],
              [47.7301146, 35.061439],
              [47.7286935, 35.062194],
              [47.7275647, 35.0621909],
              [47.7272307, 35.0624615],
              [47.7261522, 35.0624638],
              [47.725582, 35.0627369],
              [47.7236017, 35.0627673],
              [47.7227645, 35.06246],
              [47.7209811, 35.0624692],
              [47.7114923, 35.0594205],
              [47.7097548, 35.0588353],
              [47.7087165, 35.0588855],
              [47.707848, 35.0585577],
              [47.7044974, 35.0580174],
              [47.7023027, 35.0580228],
              [47.7014774, 35.057709],
              [47.6914726, 35.0577012],
              [47.6909124, 35.0579526],
              [47.6827871, 35.0605787],
              [47.6745879, 35.0632576],
              [47.6666248, 35.0645663],
              [47.6657855, 35.0647184],
              [47.6629571, 35.0649778],
              [47.6545634, 35.065645],
              [47.6471333, 35.0668953],
              [47.6382091, 35.0703052],
              [47.631536, 35.0702348],
              [47.624536, 35.0706644],
              [47.6204343, 35.0711604],
              [47.6187599, 35.0714568],
              [47.6148154, 35.071688],
              [47.6120635, 35.0716071],
              [47.6099675, 35.0716298],
              [47.6068405, 35.0717782],
              [47.6012522, 35.0724866],
              [47.5927645, 35.0728805],
              [47.5868096, 35.0724283],
              [47.5835656, 35.0720255],
              [47.5805981, 35.0717827],
              [47.5758299, 35.0714453],
              [47.5685706, 35.0715242],
              [47.5658435, 35.0708654],
              [47.5598124, 35.0710519],
              [47.5485236, 35.069453],
              [47.5432825, 35.0673527],
              [47.5373016, 35.0639228],
              [47.5236793, 35.0637669],
              [47.5051247, 35.0682052],
              [47.4978056, 35.0661775],
              [47.4872276, 35.0632418],
              [47.4847791, 35.0613824],
              [47.4753793, 35.0544726],
              [47.4728566, 35.0525827],
              [47.4708396, 35.0511043],
              [47.4693599, 35.050844],
              [47.4672476, 35.0508007],
              [47.4667776, 35.0505234],
              [47.457162, 35.0501318],
              [47.4517373, 35.0502176],
              [47.451384, 35.0504702],
              [47.4495099, 35.0504902],
              [47.4491238, 35.0507775],
              [47.4416925, 35.0515702],
              [47.4345097, 35.0516291],
              [47.434173, 35.0518713],
              [47.4296625, 35.0518523],
              [47.4292075, 35.0521714],
              [47.426991, 35.052207],
              [47.4257373, 35.0525998],
              [47.4252047, 35.052776],
              [47.4246721, 35.0530799],
              [47.420581, 35.056306],
              [47.4202721, 35.0561035],
              [47.4108638, 35.0605213],
              [47.4100044, 35.0605119],
              [47.4097927, 35.0607578],
              [47.4091763, 35.06082],
              [47.4089891, 35.0610662],
              [47.4046504, 35.0616286],
              [47.4029975, 35.0616365],
              [47.3997634, 35.061691],
              [47.399424, 35.0612889],
              [47.396038, 35.0604986],
              [47.392917, 35.0597163],
              [47.3901409, 35.0590346],
              [47.3872245, 35.0583513],
              [47.3855304, 35.0574358],
              [47.3846981, 35.0574139],
              [47.3763468, 35.0549607],
              [47.3763143, 35.0546714],
              [47.371857, 35.0538958],
              [47.3657125, 35.0538538],
              [47.3652929, 35.0535888],
              [47.3632763, 35.0535498],
              [47.3608429, 35.0527717],
              [47.35722, 35.0474502],
              [47.356102, 35.045794],
              [47.356081, 35.0427322],
              [47.3585111, 35.0367294],
              [47.3599822, 35.032876],
              [47.3611225, 35.0298943],
              [47.3613554, 35.0288884],
              [47.3616803, 35.0286096],
              [47.3600191, 35.0224775],
              [47.3550574, 35.0180366],
              [47.3494766, 35.0179218],
              [47.3491724, 35.018192],
              [47.3469148, 35.0182483],
              [47.3451204, 35.0182721],
              [47.3376751, 35.018235],
              [47.3333229, 35.0174616],
              [47.3313443, 35.0174831],
              [47.3310545, 35.0171456],
              [47.3293807, 35.0171679],
              [47.3291268, 35.0169121],
              [47.3235745, 35.0168807],
              [47.3232846, 35.017171],
              [47.3217618, 35.0172279],
              [47.3207706, 35.0171825],
              [47.3204654, 35.016869],
              [47.3172841, 35.0160468],
              [47.3159031, 35.015225],
              [47.3119306, 35.0105577],
              [47.3082916, 35.0062991],
              [47.3081532, 35.0047052],
              [47.3080798, 35.003873],
              [47.3080982, 35.0032391],
              [47.3023276, 35.0016452],
              [47.2981632, 34.9989149],
              [47.2951591, 34.9920756],
              [47.2903295, 34.9871304],
              [47.2944478, 34.9798005],
              [47.304292, 34.9763921],
              [47.3090172, 34.9692497],
              [47.310525, 34.9662384],
              [47.3224925, 34.9627787],
              [47.3208743, 34.9615451],
              [47.3199087, 34.9592558],
              [47.3209626, 34.9578281],
              [47.3251874, 34.9580443],
              [47.3276565, 34.957723],
              [47.3293931, 34.9573188],
              [47.3299117, 34.955792],
              [47.3235225, 34.9456842],
              [47.3206042, 34.9402667],
              [47.3177718, 34.938578],
              [47.312622, 34.937804],
              [47.3041247, 34.9344266],
              [47.2987174, 34.9335822],
              [47.2954988, 34.9308379],
              [47.2924518, 34.9296417],
              [47.2742557, 34.9241527],
              [47.2606086, 34.9244342],
              [47.2515534, 34.9284806],
              [47.2458457, 34.9299935],
              [47.2437185, 34.9408529],
              [47.2426739, 34.9480859],
              [47.2421827, 34.9518832],
              [47.2425579, 34.9544228],
              [47.2409749, 34.9544428],
              [47.2386599, 34.9534994],
              [47.2363632, 34.9529384],
              [47.2344138, 34.9524019],
              [47.228673, 34.9501459],
              [47.2269803, 34.9498311],
              [47.2221486, 34.9480131],
              [47.2209647, 34.9448121],
              [47.2172892, 34.9426187],
              [47.2137988, 34.9407365],
              [47.2115023, 34.9396456],
              [47.2080775, 34.9378149],
              [47.2052246, 34.9361773],
              [47.2014989, 34.9344199],
              [47.1955571, 34.9309896],
              [47.1900036, 34.9325922],
              [47.1869052, 34.9379677],
              [47.1865368, 34.9434503],
              [47.1858411, 34.9528746],
              [47.1859477, 34.9583262],
              [47.1858856, 34.9628334],
              [47.1817954, 34.9642208],
              [47.1738871, 34.9633172],
              [47.1688987, 34.9612057],
              [47.1706863, 34.9573719],
              [47.171291, 34.9531052],
              [47.1718882, 34.9520607],
              [47.1734611, 34.947055],
              [47.174124, 34.9431625],
              [47.1745039, 34.9383935],
              [47.1775532, 34.9363354],
              [47.1799563, 34.9348205],
              [47.1804131, 34.9339783],
              [47.1801563, 34.9328334],
              [47.1782814, 34.9320283],
              [47.1771694, 34.9313601],
              [47.1772352, 34.9279093],
              [47.1775334, 34.9263302],
              [47.1769573, 34.9249905],
              [47.1762468, 34.9236923],
              [47.17662, 34.9221744],
              [47.1762371, 34.9205284],
              [47.1750354, 34.9193671],
              [47.17422, 34.9186634],
              [47.1743917, 34.9173262],
              [47.1760654, 34.912857],
              [47.1746063, 34.9102175],
              [47.1744776, 34.908757],
              [47.1739626, 34.90793],
              [47.1739626, 34.9060471],
              [47.1737831, 34.9044802],
              [47.1728099, 34.9033707],
              [47.1719334, 34.9015581],
              [47.1718308, 34.9002753],
              [47.170483, 34.8999761],
              [47.1670292, 34.9012274],
              [47.1647866, 34.9014406],
              [47.1632109, 34.9016322],
              [47.1613449, 34.9019823],
              [47.1592493, 34.9024536],
              [47.157242, 34.9028455],
              [47.1502232, 34.9030168],
              [47.1479607, 34.9024888],
              [47.1457141, 34.9017202],
              [47.1420259, 34.8992916],
              [47.1410635, 34.8983783],
              [47.1392755, 34.8978152],
              [47.1311042, 34.8972297],
              [47.127144, 34.8984968],
              [47.1227675, 34.9000084],
              [47.1150491, 34.9036335],
              [47.1112842, 34.9047755],
              [47.1105148, 34.9041772],
              [47.1097571, 34.9025513],
              [47.1088638, 34.9006595],
              [47.1078132, 34.8991303],
              [47.1060815, 34.898268],
              [47.1029376, 34.8963505],
              [47.1009635, 34.8951537],
              [47.0988177, 34.8927601],
              [47.0969295, 34.8919857],
              [47.0907497, 34.8919857],
              [47.0841407, 34.8943793],
              [47.0807933, 34.8934641],
              [47.0799887, 34.8933057],
              [47.0790874, 34.8933057],
              [47.0766734, 34.8933937],
              [47.07574, 34.8937193],
              [47.0710408, 34.8921881],
              [47.0702898, 34.8917041],
              [47.0697962, 34.8910793],
              [47.0690668, 34.8902696],
              [47.068895, 34.889328],
              [47.0701932, 34.8872863],
              [47.0719635, 34.8847252],
              [47.072095, 34.883975],
              [47.0710676, 34.8834557],
              [47.0720815, 34.8766368],
              [47.0758151, 34.8677641],
              [47.0800209, 34.8605104],
              [47.0835828, 34.8514599],
              [47.0885181, 34.8411404],
              [47.0945262, 34.8293754],
              [47.0991611, 34.8228933],
              [47.1018218, 34.8226114],
              [47.1092891, 34.820709],
              [47.1115422, 34.8207794],
              [47.1161341, 34.8236859],
              [47.1166277, 34.8237035],
              [47.1189022, 34.8226114],
              [47.1212625, 34.821026],
              [47.1237945, 34.8198457],
              [47.1241593, 34.818137],
              [47.1236872, 34.8160759],
              [47.1245241, 34.8140852],
              [47.1272063, 34.8115307],
              [47.1280432, 34.8108965],
              [47.128365, 34.8088704],
              [47.1299958, 34.8068972],
              [47.1319914, 34.8061748],
              [47.134459, 34.8056815],
              [47.1361542, 34.8059282],
              [47.13727, 34.8045891],
              [47.139008, 34.8033734],
              [47.1404028, 34.8012238],
              [47.1405759, 34.7998757],
              [47.1395311, 34.7994244],
              [47.1366906, 34.7987923],
              [47.1336222, 34.7988628],
              [47.1324874, 34.7982923],
              [47.1318948, 34.7979817],
              [47.1288631, 34.7968412],
              [47.1259326, 34.7966248],
              [47.1236596, 34.7959226],
              [47.1215272, 34.7952005],
              [47.119521, 34.7946258],
              [47.1169516, 34.7950976],
              [47.1140243, 34.7966004],
              [47.1126957, 34.7979418],
              [47.110435, 34.7989284],
              [47.1053706, 34.7990287],
              [47.1004057, 34.8010829],
              [47.0976922, 34.7990573],
              [47.0942154, 34.7981785],
              [47.0911502, 34.7972975],
              [47.0878598, 34.7969269],
              [47.0847201, 34.7965897],
              [47.0794351, 34.795971],
              [47.0750212, 34.7957707],
              [47.0709073, 34.7954652],
              [47.0688021, 34.7950582],
              [47.0660778, 34.7944048],
              [47.0636734, 34.7935037],
              [47.0581939, 34.7913042],
              [47.059483, 34.789542],
              [47.0604647, 34.7866327],
              [47.0627208, 34.7841688],
              [47.0635628, 34.7828445],
              [47.0633268, 34.7817165],
              [47.0623797, 34.7804562],
              [47.0598805, 34.7790464],
              [47.0559006, 34.7780289],
              [47.0524263, 34.7769403],
              [47.0489747, 34.774962],
              [47.046682, 34.7710163],
              [47.0456944, 34.769548],
              [47.0451307, 34.7679512],
              [47.045648, 34.7658906],
              [47.0446372, 34.7641084],
              [47.0431995, 34.7626629],
              [47.0431566, 34.7618168],
              [47.0448518, 34.7610412],
              [47.0480275, 34.7601069],
              [47.0502591, 34.7594722],
              [47.05307, 34.7583264],
              [47.0549369, 34.7560522],
              [47.0548939, 34.755065],
              [47.0541644, 34.7539896],
              [47.0515251, 34.7507809],
              [47.0504093, 34.7500051],
              [47.042986, 34.7476042],
              [47.0371055, 34.7495996],
              [47.0363545, 34.7500933],
              [47.0296746, 34.752086],
              [47.0262448, 34.7537631],
              [47.0200124, 34.7533135],
              [47.0164697, 34.7540265],
              [47.0144676, 34.7550511],
              [47.0111285, 34.7557118],
              [47.0071727, 34.7575501],
              [47.0035211, 34.7606258],
              [46.9998194, 34.7627932],
              [46.991447, 34.7656532],
              [46.9775399, 34.7645426],
              [46.9699352, 34.7644071],
              [46.9613492, 34.766137],
              [46.948591, 34.7694309],
              [46.9439765, 34.7661362],
              [46.9440381, 34.7640098],
              [46.9436283, 34.7598415],
              [46.9420588, 34.757378],
              [46.9333015, 34.7546801],
              [46.9268807, 34.7545217],
              [46.9215258, 34.7566486],
              [46.9153496, 34.7592081],
              [46.9096899, 34.7614819],
              [46.9036182, 34.7636315],
              [46.9006733, 34.7647073],
              [46.8920458, 34.7657144],
              [46.8825377, 34.7628057],
              [46.8807989, 34.7613978],
              [46.8760409, 34.7609395],
              [46.8695424, 34.7595406],
              [46.8593869, 34.7555045],
              [46.8545436, 34.7535665],
              [46.846242, 34.7508053],
              [46.8350263, 34.7497122],
              [46.8240737, 34.7457737],
              [46.8134737, 34.7427057],
              [46.7879819, 34.7365695],
              [46.7872969, 34.7369983],
              [46.7718337, 34.7442334],
              [46.7592113, 34.7497603],
              [46.7627477, 34.7530376],
              [46.7601728, 34.7532139],
              [46.7545938, 34.7567046],
              [46.7467832, 34.7630156],
              [46.7440795, 34.7687268],
              [46.7384147, 34.7821572],
              [46.7325782, 34.7922374],
              [46.729243, 34.8002393],
              [46.7250318, 34.8075361],
              [46.7294164, 34.8119864],
              [46.7244939, 34.8207874],
              [46.7232755, 34.8230268],
              [46.7186972, 34.8282178],
              [46.7179685, 34.8329954],
              [46.7136526, 34.8365614],
              [46.7037204, 34.8430064],
              [46.6935682, 34.8502273],
              [46.6815948, 34.8580806],
              [46.6758871, 34.8585032],
              [46.6715526, 34.8597709],
              [46.6694068, 34.8587497],
              [46.666789, 34.8588201],
              [46.6626691, 34.8612499],
              [46.6598367, 34.8624471],
              [46.6583347, 34.8635387],
              [46.6516828, 34.8660388],
              [46.6446018, 34.8693838],
              [46.6427993, 34.8693838],
              [46.6394519, 34.8659684],
              [46.6369199, 34.864419],
              [46.6347312, 34.8634331],
              [46.6324938, 34.8611519],
              [46.6286674, 34.8615275],
              [46.6227475, 34.8668511],
              [46.6170798, 34.870475],
              [46.6133021, 34.8725809],
              [46.611307, 34.8745316],
              [46.6088104, 34.8756862],
              [46.601901, 34.8804391],
              [46.5978241, 34.88403],
              [46.5950775, 34.8853325],
              [46.5915155, 34.8877615],
              [46.5891981, 34.8878671],
              [46.5865389, 34.8873241],
              [46.5842199, 34.8881839],
              [46.5802502, 34.8888352],
              [46.5731263, 34.88968],
              [46.5708518, 34.8898736],
              [46.5701651, 34.890824],
              [46.5691781, 34.8914577],
              [46.5679121, 34.8920737],
              [46.5664744, 34.8919681],
              [46.563878, 34.8921617],
              [46.5623545, 34.8928657],
              [46.5611958, 34.8937985],
              [46.5561103, 34.8956465],
              [46.5529775, 34.897864],
              [46.5506387, 34.8999758],
              [46.5495013, 34.9015949],
              [46.5462398, 34.9060647],
              [46.5448665, 34.9074725],
              [46.5431499, 34.9101472],
              [46.5431499, 34.9122587],
              [46.5440346, 34.9146662],
              [46.5468406, 34.9181707],
              [46.5477599, 34.9199799],
              [46.5452956, 34.9220415],
              [46.5415461, 34.9264755],
              [46.5374395, 34.9285728],
              [46.5347904, 34.9287532],
              [46.531906, 34.9299231],
              [46.5292195, 34.9317859],
              [46.5290598, 34.9328682],
              [46.5286315, 34.9345182],
              [46.5321421, 34.9405481],
              [46.5367324, 34.9432113],
              [46.5391555, 34.9449356],
              [46.5396085, 34.9469968],
              [46.5427247, 34.9519705],
              [46.5468255, 34.9508431],
              [46.5495014, 34.9518048],
              [46.5524196, 34.9546539],
              [46.5544366, 34.9575029],
              [46.5551662, 34.9620752],
              [46.548171, 34.9673858],
              [46.5416391, 34.9752628],
              [46.5348445, 34.9836719],
              [46.53128, 34.9872983],
              [46.5305563, 34.992321],
              [46.5315347, 34.9994295],
              [46.5326162, 35.0081192],
              [46.5320755, 35.0203718],
              [46.529655, 35.0264237],
              [46.5264879, 35.0295864],
              [46.524016, 35.0350051],
              [46.5253468, 35.0411294],
              [46.5197077, 35.0415721],
              [46.5112877, 35.0444814],
              [46.5073996, 35.0448608],
              [46.5040522, 35.0462522],
              [46.5000611, 35.0473273],
              [46.493804, 35.0510584],
              [46.4914093, 35.0524285],
              [46.4889117, 35.0539041],
              [46.4869137, 35.0557191],
              [46.4828169, 35.057973],
              [46.4788515, 35.0602282],
              [46.4757101, 35.0615139],
              [46.4723884, 35.0627364],
              [46.4691955, 35.0629682],
              [46.463299, 35.0657081],
              [46.460621, 35.0658135],
              [46.4567072, 35.0671623],
              [46.4535915, 35.0677102],
              [46.4496776, 35.06849],
              [46.4480554, 35.0695016],
              [46.4485962, 35.07104],
              [46.4479267, 35.0771724],
              [46.4487764, 35.0788582],
              [46.4501154, 35.0808389],
              [46.4507076, 35.0845896],
              [46.4503471, 35.0857274],
              [46.4498321, 35.087708],
              [46.450315, 35.0910396],
              [46.4496197, 35.0935889],
              [46.4486155, 35.0972758],
              [46.4483601, 35.1015193],
              [46.447222, 35.1044368],
              [46.4442865, 35.1058903],
              [46.4419176, 35.1075544],
              [46.4368193, 35.1112617],
              [46.4340126, 35.1137472],
              [46.4325192, 35.1178965],
              [46.429764, 35.1207399],
              [46.4271118, 35.1222352],
              [46.4216015, 35.1233093],
              [46.4150355, 35.1244045],
              [46.412615, 35.1264262],
              [46.4116881, 35.1277951],
              [46.4105036, 35.1303012],
              [46.4077227, 35.1340285],
              [46.4057078, 35.1364942],
              [46.4025406, 35.1383472],
              [46.3988585, 35.139779],
              [46.3956141, 35.140495],
              [46.3898463, 35.1436533],
              [46.3883528, 35.1460957],
              [46.3863959, 35.1483065],
              [46.3835892, 35.1499276],
              [46.3788513, 35.152054],
              [46.3756842, 35.1538646],
              [46.3740105, 35.1553593],
              [46.3732123, 35.1569172],
              [46.3734955, 35.1593802],
              [46.3736754, 35.1610047],
              [46.3670235, 35.164864],
              [46.3653927, 35.166583],
              [46.3630324, 35.1666181],
              [46.3538056, 35.1707577],
              [46.3505506, 35.1690125],
              [46.3498145, 35.1686178],
              [46.3495735, 35.168391],
              [46.3471781, 35.1697954],
              [46.3451954, 35.1703006],
              [46.3437277, 35.1708058],
              [46.3412873, 35.1723819],
              [46.3394591, 35.1725293],
              [46.3358285, 35.1737921],
              [46.3297774, 35.17596],
              [46.3264558, 35.1774543],
              [46.3224389, 35.1785488],
              [46.3168513, 35.1801483],
              [46.3143536, 35.1811374],
              [46.3093068, 35.184189],
              [46.3069894, 35.1849677],
              [46.301891, 35.1861041],
              [46.29584, 35.1893028],
              [46.2924153, 35.1916386],
              [46.287935, 35.1935955],
              [46.2839181, 35.1956787],
              [46.2817037, 35.1974673],
              [46.2765281, 35.1994872],
              [46.2737818, 35.2014143],
              [46.2719705, 35.2026854],
              [46.2673356, 35.206178],
              [46.2648637, 35.2071037],
              [46.2608726, 35.2082188],
              [46.255697, 35.2094811],
              [46.2537658, 35.2111852],
              [46.2502124, 35.2146563],
              [46.2484872, 35.2153506],
              [46.2401584, 35.2175222],
              [46.2379182, 35.2187003],
              [46.2368882, 35.2209931],
              [46.2376058, 35.223895],
              [46.2334636, 35.2256839],
              [46.2295754, 35.2282921],
              [46.2258161, 35.230732],
              [46.2230094, 35.2335713],
              [46.219971, 35.2372729],
              [46.2182973, 35.239397],
              [46.2138942, 35.2422361],
              [46.2106755, 35.2440867],
              [46.2049077, 35.2448438],
              [46.2038486, 35.2462938],
              [46.2029473, 35.2482494],
              [46.2024839, 35.2505625],
              [46.1997287, 35.2549152],
              [46.1961496, 35.2560926],
              [46.1935746, 35.2584686],
              [46.1904847, 35.2624003],
              [46.1837604, 35.2707791],
              [46.1793791, 35.2740734],
              [46.1764952, 35.2754608],
              [46.1741262, 35.2772686],
              [46.1731993, 35.2775209],
              [46.1711651, 35.2783827],
              [46.1695171, 35.2792866],
              [46.1666075, 35.2806319],
              [46.164805, 35.2815568],
              [46.1641871, 35.282881],
              [46.1614576, 35.2842472],
              [46.158684, 35.284506],
              [46.1581915, 35.2835603],
              [46.1579096, 35.2832798],
              [46.157574, 35.282994],
              [46.156862, 35.282538],
              [46.154925, 35.282048],
              [46.153841, 35.281633],
              [46.152081, 35.280891],
              [46.150954, 35.280463],
              [46.149884, 35.280149],
              [46.14894, 35.279894],
              [46.149354, 35.278609],
              [46.149417, 35.277494],
              [46.148946, 35.27667],
              [46.148411, 35.275765],
              [46.14836, 35.27488],
              [46.148257, 35.274006],
              [46.148019, 35.273283],
              [46.14763, 35.272411],
              [46.146861, 35.271749],
              [46.14571, 35.271336],
              [46.144589, 35.269836],
              [46.143793, 35.26947],
              [46.143388, 35.268342],
              [46.143128, 35.267841],
              [46.142335, 35.267037],
              [46.1414232, 35.266168],
              [46.141355, 35.266103],
              [46.140659, 35.265655],
              [46.139295, 35.265013],
              [46.137757, 35.264633],
              [46.136155, 35.264567],
              [46.135614, 35.264339],
              [46.135869, 35.262928],
              [46.135787, 35.261977],
              [46.135723, 35.261594],
              [46.135407, 35.261436],
              [46.134224, 35.260905],
              [46.133109, 35.260475],
              [46.132441, 35.260032],
              [46.131939, 35.259546],
              [46.1312, 35.258743],
              [46.130642, 35.258299],
              [46.130036, 35.257833],
              [46.129497, 35.257261],
              [46.12945, 35.256241],
              [46.129013, 35.255442],
              [46.128418, 35.254516],
              [46.12751, 35.254442],
              [46.126494, 35.254523],
              [46.125903, 35.253857],
              [46.125413, 35.253515],
              [46.125343, 35.252561],
              [46.12527, 35.251796],
              [46.124713, 35.251061],
              [46.12431, 35.250484],
              [46.124122, 35.250145],
              [46.123926, 35.249382],
              [46.123557, 35.248882],
              [46.123637, 35.247827],
              [46.123503, 35.247437],
              [46.123098, 35.246953],
              [46.122881, 35.246413],
              [46.122686, 35.246149],
              [46.121943, 35.245627],
              [46.121249, 35.24524],
              [46.120762, 35.245105],
              [46.12033, 35.245074],
              [46.11973, 35.244628],
              [46.118659, 35.244408],
              [46.118106, 35.244286],
              [46.117418, 35.244117],
              [46.117034, 35.24391],
              [46.1163548, 35.2438579],
              [46.1161854, 35.2435671],
              [46.1162815, 35.243194],
              [46.116488, 35.2429958],
              [46.1170503, 35.2425718],
              [46.1182459, 35.2411728],
              [46.1192911, 35.2393458],
              [46.1194781, 35.2384107],
              [46.1201123, 35.2378396],
              [46.12049, 35.2367413],
              [46.1208439, 35.2353785],
              [46.121044, 35.2343735],
              [46.1213093, 35.2333136],
              [46.121917, 35.232724],
              [46.12213, 35.232984],
              [46.122352, 35.233184],
              [46.122683, 35.233421],
              [46.123163, 35.233776],
              [46.123471, 35.234252],
              [46.123578, 35.234782],
              [46.123622, 35.235254],
              [46.123623, 35.235359],
              [46.123596, 35.235411],
              [46.123462, 35.235585],
              [46.1235, 35.235667],
              [46.123618, 35.235673],
              [46.123755, 35.235664],
              [46.12391, 35.235633],
              [46.124316, 35.235394],
              [46.124653, 35.235282],
              [46.124753, 35.235266],
              [46.124936, 35.235309],
              [46.125321, 35.23544],
              [46.12546, 35.235581],
              [46.125791, 35.23575],
              [46.126151, 35.235994],
              [46.126484, 35.236313],
              [46.12722, 35.23577],
              [46.127224, 35.235767],
              [46.127074, 35.235454],
              [46.127008, 35.235297],
              [46.126812, 35.235],
              [46.126529, 35.234656],
              [46.126524, 35.23465],
              [46.12654, 35.234478],
              [46.12652, 35.234306],
              [46.126453, 35.234104],
              [46.126331, 35.233888],
              [46.12609, 35.233576],
              [46.125692, 35.233176],
              [46.12552, 35.232958],
              [46.125377, 35.232856],
              [46.124852, 35.232532],
              [46.124476, 35.232371],
              [46.124164, 35.232216],
              [46.123914, 35.232001],
              [46.123673, 35.231727],
              [46.123469, 35.231452],
              [46.12348, 35.231447],
              [46.131258, 35.22771],
              [46.13169, 35.227824],
              [46.132558, 35.227977],
              [46.133344, 35.228252],
              [46.134671, 35.228662],
              [46.135449, 35.228658],
              [46.136813, 35.2288],
              [46.138738, 35.2287],
              [46.14005, 35.228302],
              [46.141081, 35.228176],
              [46.141803, 35.22812],
              [46.142923, 35.228269],
              [46.144479, 35.228468],
              [46.146011, 35.228225],
              [46.147393, 35.228084],
              [46.148208, 35.227968],
              [46.14965, 35.227348],
              [46.150633, 35.226649],
              [46.15136, 35.226062],
              [46.152408, 35.22585],
              [46.153205, 35.225717],
              [46.154726, 35.225435],
              [46.15548, 35.225445],
              [46.156023, 35.225684],
              [46.158043, 35.225877],
              [46.158944, 35.225277],
              [46.160211, 35.224368],
              [46.16232, 35.222943],
              [46.162962, 35.222944],
              [46.163428, 35.223197],
              [46.1641, 35.223609],
              [46.164509, 35.224154],
              [46.165024, 35.224637],
              [46.166131, 35.22434],
              [46.167485, 35.2241],
              [46.168431, 35.224064],
              [46.16901, 35.223984],
              [46.16959, 35.224402],
              [46.170031, 35.224816],
              [46.170251, 35.225221],
              [46.170643, 35.225406],
              [46.171219, 35.225367],
              [46.171745, 35.225391],
              [46.172418, 35.225355],
              [46.174727, 35.227353],
              [46.176822, 35.228746],
              [46.177792, 35.228359],
              [46.178566, 35.227867],
              [46.179189, 35.22747],
              [46.179595, 35.227224],
              [46.179908, 35.227104],
              [46.180427, 35.226817],
              [46.180501, 35.226621],
              [46.18068, 35.22651],
              [46.181278, 35.226387],
              [46.182291, 35.225939],
              [46.182716, 35.225662],
              [46.183919, 35.225267],
              [46.183967, 35.225235],
              [46.184435, 35.224684],
              [46.185128, 35.223888],
              [46.18554, 35.223407],
              [46.185758, 35.223295],
              [46.186267, 35.222337],
              [46.18673, 35.222074],
              [46.187197, 35.221405],
              [46.187683, 35.220768],
              [46.188154, 35.220466],
              [46.188649, 35.219654],
              [46.188804, 35.219287],
              [46.189418, 35.218296],
              [46.189443, 35.218023],
              [46.189354, 35.21782],
              [46.189324, 35.217603],
              [46.189287, 35.217379],
              [46.189407, 35.217023],
              [46.189846, 35.216692],
              [46.190326, 35.216433],
              [46.194178, 35.210945],
              [46.194385, 35.209715],
              [46.194911, 35.207934],
              [46.195376, 35.20694],
              [46.195218, 35.206212],
              [46.194745, 35.205481],
              [46.194432, 35.204741],
              [46.194216, 35.203951],
              [46.193999, 35.203057],
              [46.19478, 35.202668],
              [46.19587, 35.202602],
              [46.196877, 35.202295],
              [46.198116, 35.201932],
              [46.199285, 35.201811],
              [46.200277, 35.201513],
              [46.201247, 35.201229],
              [46.2018787, 35.2009191],
              [46.2020044, 35.2008198],
              [46.202009, 35.2005303],
              [46.2023776, 35.1979544],
              [46.2026621, 35.1967627],
              [46.2029851, 35.1957771],
              [46.2030725, 35.1954595],
              [46.2031204, 35.195221],
              [46.2032241, 35.1947348],
              [46.2033783, 35.1944948],
              [46.203746, 35.193906],
              [46.2041902, 35.19337],
              [46.2044438, 35.1930084],
              [46.2042349, 35.1927355],
              [46.2041507, 35.1923383],
              [46.2042583, 35.1909054],
              [46.2036283, 35.1890367],
              [46.2031846, 35.1892218],
              [46.2028673, 35.1892722],
              [46.2023295, 35.1895576],
              [46.2015695, 35.1901493],
              [46.2003896, 35.1907934],
              [46.1995453, 35.1911641],
              [46.198418, 35.191061],
              [46.197327, 35.189479],
              [46.196528, 35.188424],
              [46.196082, 35.186654],
              [46.195818, 35.185496],
              [46.196014, 35.184791],
              [46.194975, 35.184013],
              [46.194476, 35.184013],
              [46.193655, 35.184204],
              [46.191982, 35.18411],
              [46.190305, 35.183913],
              [46.187766, 35.183715],
              [46.18683, 35.183833],
              [46.185251, 35.184326],
              [46.184195, 35.183404],
              [46.183721, 35.183078],
              [46.182878, 35.182782],
              [46.181808, 35.181634],
              [46.181048, 35.181072],
              [46.180397, 35.180697],
              [46.179787, 35.1805121],
              [46.178542, 35.179992],
              [46.177666, 35.179494],
              [46.177152, 35.179217],
              [46.176806, 35.178867],
              [46.17641, 35.178443],
              [46.176066, 35.177738],
              [46.176021, 35.176955],
              [46.17577, 35.17643],
              [46.175343, 35.175991],
              [46.174736, 35.175806],
              [46.174098, 35.175564],
              [46.173505, 35.175387],
              [46.172979, 35.175249],
              [46.172651, 35.174916],
              [46.172422, 35.174689],
              [46.172048, 35.174386],
              [46.171455, 35.173979],
              [46.170928, 35.173747],
              [46.169963, 35.173631],
              [46.169295, 35.173469],
              [46.168465, 35.173264],
              [46.168001, 35.173062],
              [46.166786, 35.172785],
              [46.166203, 35.172502],
              [46.165878, 35.172043],
              [46.165507, 35.171385],
              [46.165358, 35.170976],
              [46.164991, 35.170421],
              [46.164753, 35.169894],
              [46.164574, 35.169699],
              [46.164153, 35.169416],
              [46.163628, 35.169329],
              [46.163233, 35.169135],
              [46.162888, 35.168701],
              [46.162506, 35.168232],
              [46.161946, 35.167527],
              [46.161814, 35.167084],
              [46.161694, 35.166815],
              [46.161539, 35.166657],
              [46.160877, 35.166337],
              [46.160715, 35.166108],
              [46.160377, 35.165516],
              [46.160026, 35.165469],
              [46.159453, 35.165402],
              [46.159074, 35.165215],
              [46.158641, 35.165028],
              [46.158421, 35.164924],
              [46.157905, 35.164638],
              [46.157437, 35.164291],
              [46.156963, 35.164236],
              [46.156918, 35.163859],
              [46.156868, 35.163556],
              [46.156729, 35.16327],
              [46.156705, 35.162962],
              [46.156818, 35.162388],
              [46.15692, 35.162097],
              [46.15686, 35.161806],
              [46.156635, 35.161276],
              [46.156402, 35.16081],
              [46.156146, 35.160495],
              [46.156101, 35.160295],
              [46.155921, 35.159965],
              [46.155373, 35.15957],
              [46.154944, 35.159215],
              [46.154758, 35.159001],
              [46.154892, 35.158589],
              [46.155127, 35.1582],
              [46.155261, 35.157653],
              [46.155225, 35.157034],
              [46.154997, 35.15663],
              [46.154635, 35.156001],
              [46.154474, 35.155553],
              [46.155113, 35.155239],
              [46.155717, 35.154914],
              [46.156333, 35.154357],
              [46.156147, 35.153914],
              [46.15632, 35.153317],
              [46.156587, 35.152765],
              [46.156918, 35.151972],
              [46.157436, 35.151538],
              [46.158401, 35.150976],
              [46.158965, 35.150513],
              [46.159755, 35.149818],
              [46.160254, 35.149138],
              [46.160019, 35.14862],
              [46.159683, 35.148122],
              [46.159307, 35.147674],
              [46.159362, 35.147225],
              [46.159518, 35.146299],
              [46.159411, 35.145214],
              [46.159672, 35.144371],
              [46.1598098, 35.1434076],
              [46.1594493, 35.1430848],
              [46.1592146, 35.1426813],
              [46.1590804, 35.1424137],
              [46.1590923, 35.1422497],
              [46.1591487, 35.141796],
              [46.1591398, 35.1413442],
              [46.160176, 35.140625],
              [46.1607957, 35.1399093],
              [46.160904, 35.13963],
              [46.16046, 35.139132],
              [46.160076, 35.138611],
              [46.159662, 35.138128],
              [46.159227, 35.137524],
              [46.159008, 35.137108],
              [46.158781, 35.136526],
              [46.158415, 35.136065],
              [46.157987, 35.135804],
              [46.157834, 35.135427],
              [46.157321, 35.135015],
              [46.156967, 35.134687],
              [46.156144, 35.134367],
              [46.155701, 35.133785],
              [46.155696, 35.133181],
              [46.155908, 35.132577],
              [46.156136, 35.131803],
              [46.155577, 35.130421],
              [46.154958, 35.129519],
              [46.155059, 35.128999],
              [46.155748, 35.128594],
              [46.156438, 35.128148],
              [46.156677, 35.127456],
              [46.157397, 35.12716],
              [46.158438, 35.126532],
              [46.158756, 35.126199],
              [46.159041, 35.125842],
              [46.159946, 35.12476],
              [46.16118, 35.124011],
              [46.161895, 35.123696],
              [46.163021, 35.123312],
              [46.163861, 35.122826],
              [46.164582, 35.122395],
              [46.16536, 35.122109],
              [46.166094, 35.121634],
              [46.16663, 35.121395],
              [46.167151, 35.120971],
              [46.167826, 35.120747],
              [46.168428, 35.120141],
              [46.168952, 35.119727],
              [46.169356, 35.119273],
              [46.170107, 35.118899],
              [46.17061, 35.118458],
              [46.171481, 35.117987],
              [46.173209, 35.118175],
              [46.174479, 35.118367],
              [46.175525, 35.118436],
              [46.176493, 35.118249],
              [46.177218, 35.117692],
              [46.178299, 35.117067],
              [46.179298, 35.116165],
              [46.180194, 35.115825],
              [46.181389, 35.11549],
              [46.183031, 35.115027],
              [46.183591, 35.114189],
              [46.184374, 35.113558],
              [46.1857651, 35.1134592],
              [46.1869921, 35.1132968],
              [46.1881289, 35.113282],
              [46.189428, 35.1124998],
              [46.1901498, 35.1115551],
              [46.1912362, 35.1109166],
              [46.1903935, 35.1105613],
              [46.1899837, 35.1103888],
              [46.1896095, 35.1102122],
              [46.1890067, 35.1099458],
              [46.1886211, 35.1097479],
              [46.1883018, 35.1095416],
              [46.1880563, 35.109358],
              [46.1878413, 35.1091745],
              [46.1873962, 35.1087614],
              [46.1872685, 35.1086437],
              [46.1871317, 35.108536],
              [46.1869309, 35.1083866],
              [46.1867378, 35.1082583],
              [46.1865823, 35.1081662],
              [46.1863782, 35.108048],
              [46.1863076, 35.1080056],
              [46.1862279, 35.1079632],
              [46.1861141, 35.1079107],
              [46.1858499, 35.1078031],
              [46.1856025, 35.1077096],
              [46.1854066, 35.1076298],
              [46.185204, 35.1075446],
              [46.1848862, 35.1073762],
              [46.1847715, 35.1073291],
              [46.1846165, 35.1072746],
              [46.1843641, 35.1071891],
              [46.1841229, 35.1071101],
              [46.1840043, 35.1070783],
              [46.1838575, 35.1070531],
              [46.183719, 35.1070272],
              [46.183555, 35.1070017],
              [46.1834271, 35.1069777],
              [46.1832996, 35.1069472],
              [46.1831872, 35.1069112],
              [46.1830855, 35.1068635],
              [46.1828521, 35.1067484],
              [46.1826333, 35.1066282],
              [46.1824254, 35.1065051],
              [46.1820239, 35.1062147],
              [46.1813464, 35.1056934],
              [46.1812418, 35.1056257],
              [46.1810832, 35.1055373],
              [46.1809499, 35.1054579],
              [46.1807517, 35.1053239],
              [46.1806039, 35.1052135],
              [46.1803491, 35.1049927],
              [46.1800654, 35.1047836],
              [46.1798882, 35.1046661],
              [46.1797868, 35.1046135],
              [46.1796796, 35.10456],
              [46.1795836, 35.1045222],
              [46.1794731, 35.1044843],
              [46.1792475, 35.1044056],
              [46.178967, 35.1042999],
              [46.1786956, 35.1041926],
              [46.1783492, 35.1040578],
              [46.1780209, 35.1039201],
              [46.1777145, 35.1037854],
              [46.1775742, 35.1037181],
              [46.1771968, 35.1035209],
              [46.1770168, 35.1034589],
              [46.1768375, 35.1034142],
              [46.1767182, 35.1033695],
              [46.176454, 35.1032345],
              [46.1761486, 35.1030803],
              [46.1758419, 35.1029442],
              [46.1755207, 35.102814],
              [46.1751252, 35.1026387],
              [46.1749286, 35.1025571],
              [46.1747212, 35.1024844],
              [46.1743031, 35.1023407],
              [46.1741508, 35.1022915],
              [46.1739985, 35.1022423],
              [46.1738851, 35.1021985],
              [46.1737793, 35.1021494],
              [46.1736933, 35.1021018],
              [46.1735853, 35.1020198],
              [46.1734196, 35.1018964],
              [46.1731655, 35.101657],
              [46.17304, 35.1015079],
              [46.1729874, 35.1014103],
              [46.1729636, 35.1013068],
              [46.1729593, 35.1011894],
              [46.1729369, 35.1010867],
              [46.1728813, 35.1009492],
              [46.172833, 35.1008374],
              [46.1727505, 35.1006371],
              [46.172679, 35.1004245],
              [46.1726148, 35.1002148],
              [46.1725298, 35.0999948],
              [46.1724692, 35.099884],
              [46.1724051, 35.0997821],
              [46.1722863, 35.0996426],
              [46.1721619, 35.0995072],
              [46.1720582, 35.0994085],
              [46.1719793, 35.0993481],
              [46.1719004, 35.0992995],
              [46.1717984, 35.0992503],
              [46.1716332, 35.0991907],
              [46.1715423, 35.0991561],
              [46.1714459, 35.0991245],
              [46.171336, 35.099098],
              [46.1712026, 35.0990759],
              [46.1710685, 35.0990518],
              [46.1709411, 35.0990236],
              [46.1708064, 35.0989864],
              [46.1701061, 35.0987905],
              [46.1695675, 35.0986771],
              [46.1694527, 35.0986616],
              [46.1693379, 35.098655],
              [46.1690417, 35.0986599],
              [46.1689093, 35.0986517],
              [46.1687842, 35.0986347],
              [46.168636, 35.0986125],
              [46.1685095, 35.0985843],
              [46.1681515, 35.0984776],
              [46.168001, 35.0984292],
              [46.1679045, 35.0983938],
              [46.1677973, 35.0983485],
              [46.1676831, 35.0982928],
              [46.1675552, 35.0982197],
              [46.1674329, 35.0981356],
              [46.1673321, 35.0980631],
              [46.1672055, 35.0979621],
              [46.1671152, 35.0978977],
              [46.1670401, 35.0978308],
              [46.1669566, 35.0977391],
              [46.1668703, 35.0976195],
              [46.1668053, 35.097495],
              [46.1666524, 35.0971747],
              [46.1664135, 35.0965067],
              [46.1663201, 35.0962309],
              [46.1662606, 35.0961154],
              [46.1661949, 35.0960024],
              [46.1658928, 35.0955772],
              [46.1657323, 35.0953595],
              [46.1656551, 35.0952395],
              [46.1655786, 35.0951112],
              [46.16549, 35.0949904],
              [46.1653362, 35.0948018],
              [46.1651973, 35.0946183],
              [46.1650462, 35.0944374],
              [46.1647138, 35.0940904],
              [46.1645604, 35.0938942],
              [46.1645176, 35.0938334],
              [46.1644747, 35.0937849],
              [46.1644162, 35.0937303],
              [46.1643612, 35.0936893],
              [46.1643031, 35.0936484],
              [46.1642143, 35.0935664],
              [46.1640459, 35.0933976],
              [46.1635802, 35.0928616],
              [46.1633291, 35.092606],
              [46.1631801, 35.0924447],
              [46.1630462, 35.0922821],
              [46.1629645, 35.0921725],
              [46.1629085, 35.0920861],
              [46.1628737, 35.092022],
              [46.1628238, 35.091905],
              [46.1627831, 35.0918128],
              [46.1627366, 35.0917382],
              [46.1626811, 35.0916661],
              [46.1625396, 35.091492],
              [46.1624883, 35.0914399],
              [46.1624401, 35.0913852],
              [46.1624166, 35.091343],
              [46.1623998, 35.0912908],
              [46.1623814, 35.0912286],
              [46.1623537, 35.0911539],
              [46.1622594, 35.0909519],
              [46.1621925, 35.0907599],
              [46.1621259, 35.0905365],
              [46.1621108, 35.090426],
              [46.1621063, 35.0903167],
              [46.1621063, 35.0901797],
              [46.1620967, 35.0901171],
              [46.1620872, 35.0900621],
              [46.1620682, 35.0899718],
              [46.1620499, 35.0899062],
              [46.1620191, 35.0898011],
              [46.1619869, 35.0897197],
              [46.1618784, 35.0895554],
              [46.1617578, 35.0893813],
              [46.1617028, 35.0892923],
              [46.1616554, 35.0892233],
              [46.1612548, 35.0887594],
              [46.1610667, 35.0885759],
              [46.1604081, 35.087976],
              [46.1603182, 35.0878893],
              [46.1602252, 35.0878051],
              [46.1601031, 35.0877112],
              [46.1598879, 35.0875806],
              [46.1597181, 35.0874756],
              [46.159395, 35.0872576],
              [46.1592074, 35.0871503],
              [46.1590108, 35.0870604],
              [46.1585408, 35.0868717],
              [46.1581375, 35.0867572],
              [46.1577949, 35.0866923],
              [46.1576104, 35.0866404],
              [46.157443, 35.0866165],
              [46.1573186, 35.0866108],
              [46.157147, 35.0866136],
              [46.1568124, 35.0866296],
              [46.1563447, 35.0866421],
              [46.1561238, 35.086694],
              [46.1560133, 35.0867095],
              [46.1559028, 35.0867179],
              [46.1557721, 35.08671],
              [46.1554975, 35.0866687],
              [46.1552299, 35.0866207],
              [46.1549998, 35.0865678],
              [46.1547564, 35.0865175],
              [46.1545659, 35.0864905],
              [46.1544083, 35.086484],
              [46.1542443, 35.0864899],
              [46.1539078, 35.086505],
              [46.1532605, 35.0865284],
              [46.1525116, 35.0866086],
              [46.1523982, 35.0866212],
              [46.1523135, 35.086646],
              [46.1522541, 35.0866708],
              [46.1521924, 35.0867038],
              [46.1521077, 35.0867322],
              [46.1519812, 35.0867539],
              [46.1518569, 35.0867692],
              [46.1516382, 35.0867845],
              [46.1514795, 35.0868068],
              [46.151346, 35.0868406],
              [46.1512489, 35.0868622],
              [46.1511448, 35.0868632],
              [46.1509882, 35.0868406],
              [46.1508252, 35.0868129],
              [46.1507258, 35.0867919],
              [46.1506536, 35.0867857],
              [46.150592, 35.0867846],
              [46.1505152, 35.0867859],
              [46.1504161, 35.086791],
              [46.1502636, 35.0867988],
              [46.1499134, 35.0868204],
              [46.1498524, 35.0868219],
              [46.1497959, 35.0868123],
              [46.1497484, 35.0867952],
              [46.1496658, 35.0867685],
              [46.1496066, 35.0867549],
              [46.1495368, 35.0867525],
              [46.1494154, 35.086765],
              [46.1491938, 35.0867901],
              [46.1487104, 35.086841],
              [46.1485813, 35.0868576],
              [46.1484691, 35.0868892],
              [46.1483419, 35.0869279],
              [46.1481347, 35.0869806],
              [46.1479264, 35.0870123],
              [46.1476813, 35.0870335],
              [46.1473521, 35.0870473],
              [46.1470791, 35.0870531],
              [46.1469303, 35.0870568],
              [46.146835, 35.0870647],
              [46.146563, 35.0871052],
              [46.1463152, 35.0871478],
              [46.1461656, 35.0871762],
              [46.1460404, 35.0872025],
              [46.1459627, 35.0872209],
              [46.1458892, 35.0872358],
              [46.1458535, 35.0872378],
              [46.1458241, 35.0872376],
              [46.1457788, 35.0872349],
              [46.145728, 35.0872273],
              [46.1456884, 35.0872202],
              [46.1456508, 35.0872105],
              [46.1456205, 35.0871986],
              [46.1455825, 35.0871783],
              [46.1455448, 35.0871555],
              [46.1454568, 35.0870902],
              [46.1454337, 35.0870765],
              [46.145411, 35.0870664],
              [46.1453652, 35.08705],
              [46.1452943, 35.0870231],
              [46.145254, 35.0870065],
              [46.1452004, 35.0869807],
              [46.1451511, 35.0869557],
              [46.1450976, 35.0869323],
              [46.1450412, 35.0869136],
              [46.1449847, 35.0868974],
              [46.1449651, 35.0868927],
              [46.1449447, 35.0868887],
              [46.1449207, 35.0868868],
              [46.144899, 35.086888],
              [46.1448787, 35.0868932],
              [46.1448493, 35.086904],
              [46.1448404, 35.0869064],
              [46.144832, 35.0869078],
              [46.1448254, 35.0869082],
              [46.1448184, 35.0869079],
              [46.1448122, 35.0869065],
              [46.1448079, 35.0869051],
              [46.1448001, 35.0869015],
              [46.1447893, 35.0868951],
              [46.144775, 35.0868857],
              [46.1447572, 35.086875],
              [46.1447356, 35.0868643],
              [46.1447109, 35.0868571],
              [46.1446862, 35.0868523],
              [46.1446103, 35.0868444],
              [46.144539, 35.0868393],
              [46.1444661, 35.0868378],
              [46.1443417, 35.0868349],
              [46.1442398, 35.0868261],
              [46.1441636, 35.0868135],
              [46.1440747, 35.0867887],
              [46.1440001, 35.0867639],
              [46.1439125, 35.0867353],
              [46.1438195, 35.0867127],
              [46.1437486, 35.0866966],
              [46.1436814, 35.0866842],
              [46.1435902, 35.0866698],
              [46.1435089, 35.0866586],
              [46.1433684, 35.0866436],
              [46.1433235, 35.0866388],
              [46.143284, 35.0866323],
              [46.1432484, 35.0866254],
              [46.1431924, 35.0866185],
              [46.1431384, 35.0866154],
              [46.1430604, 35.0866151],
              [46.1429816, 35.0866173],
              [46.1429141, 35.08662],
              [46.142735, 35.086641],
              [46.1426571, 35.0866437],
              [46.1425579, 35.0866389],
              [46.1424475, 35.0866195],
              [46.142339, 35.0865856],
              [46.1422252, 35.0865403],
              [46.1417901, 35.086338],
              [46.1414036, 35.0861706],
              [46.1410914, 35.0860166],
              [46.1407564, 35.0858477],
              [46.1404839, 35.0856862],
              [46.140214, 35.0855067],
              [46.1399594, 35.0853248],
              [46.1396622, 35.0851429],
              [46.1393955, 35.0849858],
              [46.1391912, 35.0848646],
              [46.1390781, 35.0848079],
              [46.1389549, 35.0847518],
              [46.1387225, 35.0846584],
              [46.1385023, 35.0845873],
              [46.137979, 35.0844413],
              [46.1377177, 35.084373],
              [46.1374838, 35.0843022],
              [46.1370069, 35.0841532],
              [46.1357904, 35.0838985],
              [46.1355503, 35.0838448],
              [46.1353163, 35.0837875],
              [46.1348604, 35.0836653],
              [46.1341657, 35.0834868],
              [46.133826, 35.0834308],
              [46.1337448, 35.0834112],
              [46.1336781, 35.0833886],
              [46.1336086, 35.0833645],
              [46.1335392, 35.0833464],
              [46.1334859, 35.0833344],
              [46.133416, 35.0833292],
              [46.1333514, 35.0833291],
              [46.1331084, 35.0833242],
              [46.1330186, 35.0833196],
              [46.132945, 35.0833127],
              [46.1328539, 35.0832998],
              [46.1327731, 35.0832838],
              [46.1327068, 35.0832685],
              [46.1325112, 35.0832132],
              [46.1323717, 35.0831724],
              [46.1322585, 35.0831439],
              [46.1321618, 35.0831217],
              [46.1320726, 35.083108],
              [46.1320009, 35.0830989],
              [46.1319216, 35.0830919],
              [46.1318368, 35.0830822],
              [46.1317337, 35.0830648],
              [46.1315937, 35.0830341],
              [46.1306972, 35.082807],
              [46.1302766, 35.0827067],
              [46.1298764, 35.0825981],
              [46.1291372, 35.0823621],
              [46.1288206, 35.0822587],
              [46.128509, 35.0821531],
              [46.128177, 35.0820236],
              [46.12784, 35.0818899],
              [46.1272898, 35.0816569],
              [46.1271472, 35.0815956],
              [46.127029, 35.0815369],
              [46.1269139, 35.0814592],
              [46.126799, 35.0813559],
              [46.1266927, 35.081254],
              [46.1264878, 35.0810353],
              [46.1262965, 35.0808482],
              [46.1262304, 35.0807736],
              [46.1261708, 35.080699],
              [46.1260729, 35.0805477],
              [46.1259626, 35.0803812],
              [46.125865, 35.0802293],
              [46.1258075, 35.0801543],
              [46.125717, 35.0800506],
              [46.1255679, 35.0798874],
              [46.125273, 35.079563],
              [46.1251828, 35.0794647],
              [46.1251364, 35.0794271],
              [46.1250772, 35.0793915],
              [46.1249471, 35.0793277],
              [46.1248285, 35.0792619],
              [46.1247185, 35.0791904],
              [46.1246137, 35.0791188],
              [46.1244565, 35.0790073],
              [46.1243831, 35.0789498],
              [46.1243105, 35.0788808],
              [46.124237, 35.0787988],
              [46.1241797, 35.0787292],
              [46.124127, 35.0786447],
              [46.1239937, 35.0784111],
              [46.1239216, 35.078292],
              [46.1238524, 35.078198],
              [46.1237538, 35.0780948],
              [46.1236114, 35.0780061],
              [46.123473, 35.0779426],
              [46.1233175, 35.0778896],
              [46.1230707, 35.0778399],
              [46.1225129, 35.0778281],
              [46.1218776, 35.0777926],
              [46.1213066, 35.0777922],
              [46.1211198, 35.0777623],
              [46.1209304, 35.0777136],
              [46.12075, 35.0776481],
              [46.120595, 35.0775827],
              [46.1203413, 35.0774242],
              [46.1202279, 35.0773403],
              [46.1201437, 35.0772832],
              [46.1200697, 35.0772386],
              [46.1199379, 35.0771691],
              [46.1196976, 35.0770433],
              [46.1194677, 35.0769018],
              [46.1192825, 35.0767728],
              [46.1191548, 35.0766729],
              [46.118978, 35.0765159],
              [46.118799, 35.0763519],
              [46.1186415, 35.0761879],
              [46.1184333, 35.0758956],
              [46.1183137, 35.0756964],
              [46.1182176, 35.0755621],
              [46.118163, 35.0754947],
              [46.1174545, 35.074739],
              [46.117175, 35.0745111],
              [46.1169062, 35.0743131],
              [46.1167644, 35.0742381],
              [46.1166047, 35.0741748],
              [46.1164377, 35.0741397],
              [46.1162798, 35.0741134],
              [46.1161737, 35.0741023],
              [46.1160712, 35.0741015],
              [46.1159883, 35.0741076],
              [46.1159336, 35.0741162],
              [46.1158773, 35.0741286],
              [46.1157857, 35.0741519],
              [46.1156858, 35.0741801],
              [46.1155984, 35.0742156],
              [46.1154927, 35.0742661],
              [46.1154051, 35.0743192],
              [46.1152451, 35.0744228],
              [46.1149191, 35.0746575],
              [46.1145299, 35.0750199],
              [46.114376, 35.0752099],
              [46.1142565, 35.0753964],
              [46.1141722, 35.0755206],
              [46.1140726, 35.0756472],
              [46.1139883, 35.0757298],
              [46.1139219, 35.0757885],
              [46.1138433, 35.0758472],
              [46.1137567, 35.0759045],
              [46.1136553, 35.075962],
              [46.1134793, 35.0760682],
              [46.1133213, 35.076195],
              [46.1132084, 35.0763042],
              [46.1131243, 35.0764266],
              [46.1130349, 35.0765726],
              [46.1129383, 35.0767039],
              [46.1127911, 35.0768529],
              [46.1124209, 35.077141],
              [46.1123039, 35.0772078],
              [46.1122201, 35.0772441],
              [46.1121557, 35.0772576],
              [46.1120912, 35.0772635],
              [46.1120137, 35.0772577],
              [46.1119445, 35.0772461],
              [46.1118404, 35.0772264],
              [46.1116676, 35.0771944],
              [46.1115635, 35.077187],
              [46.1113855, 35.0771931],
              [46.1112503, 35.0771852],
              [46.1110916, 35.0771693],
              [46.1108923, 35.0771228],
              [46.1107058, 35.0770727],
              [46.1104531, 35.0770323],
              [46.110197, 35.0770052],
              [46.1099043, 35.0769963],
              [46.1094492, 35.0769962],
              [46.1092334, 35.0770183],
              [46.10905, 35.0770611],
              [46.1088233, 35.077123],
              [46.108658, 35.0771614],
              [46.1084989, 35.0771916],
              [46.1083723, 35.0772219],
              [46.1082202, 35.0772646],
              [46.1079814, 35.0773413],
              [46.1078268, 35.0773745],
              [46.1076831, 35.0773959],
              [46.1074936, 35.077411],
              [46.1071616, 35.0774157],
              [46.1068606, 35.0774151],
              [46.1066425, 35.0773908],
              [46.1063866, 35.0773591],
              [46.1061704, 35.0773156],
              [46.1054831, 35.0771418],
              [46.1049419, 35.0770345],
              [46.1046155, 35.0769879],
              [46.1042784, 35.0769856],
              [46.1038683, 35.0770676],
              [46.1034583, 35.0771733],
              [46.1031749, 35.0772651],
              [46.1029168, 35.0773628],
              [46.1024474, 35.0775493],
              [46.1020013, 35.0777715],
              [46.101613, 35.0779937],
              [46.1010729, 35.078382],
              [46.1009215, 35.0784921],
              [46.1007557, 35.0785756],
              [46.1005971, 35.0786317],
              [46.1004348, 35.0786761],
              [46.1001115, 35.0787736],
              [46.0998352, 35.07888],
              [46.0995215, 35.0790216],
              [46.0994169, 35.0790643],
              [46.0992979, 35.0791071],
              [46.0992006, 35.0791247],
              [46.0991116, 35.0791261],
              [46.0990263, 35.0791097],
              [46.0988592, 35.07908],
              [46.0985143, 35.0790411],
              [46.0981523, 35.0791007],
              [46.0979802, 35.0791969],
              [46.0978802, 35.079293],
              [46.0978322, 35.0794343],
              [46.0978276, 35.0795726],
              [46.0978307, 35.0796581],
              [46.0978286, 35.079726],
              [46.0978118, 35.0797844],
              [46.0977629, 35.0798887],
              [46.097727, 35.0799716],
              [46.0976961, 35.0800546],
              [46.0976717, 35.0801386],
              [46.0976549, 35.0802226],
              [46.0976023, 35.0804035],
              [46.0975498, 35.0805624],
              [46.0975071, 35.080676],
              [46.0974474, 35.0808043],
              [46.0973946, 35.0808971],
              [46.0973546, 35.08099],
              [46.0972912, 35.0811455],
              [46.0972125, 35.0813502],
              [46.0971636, 35.0815107],
              [46.097125, 35.0816692],
              [46.0970844, 35.0818308],
              [46.0970515, 35.0819882],
              [46.0970094, 35.0822501],
              [46.0969896, 35.0823606],
              [46.0969647, 35.0824691],
              [46.0969492, 35.082514],
              [46.0969234, 35.0825693],
              [46.0968754, 35.0826423],
              [46.0968108, 35.0827488],
              [46.0967619, 35.0828625],
              [46.0967309, 35.0829762],
              [46.0967008, 35.0832206],
              [46.0967217, 35.0835422],
              [46.0967167, 35.0837161],
              [46.0966684, 35.0839131],
              [46.096675, 35.0842423],
              [46.0965949, 35.084703],
              [46.0964743, 35.0850602],
              [46.0964241, 35.0851928],
              [46.0963509, 35.0853275],
              [46.096288, 35.0854633],
              [46.0961919, 35.0856387],
              [46.0961449, 35.0857381],
              [46.0960825, 35.0859032],
              [46.0960521, 35.0860047],
              [46.0960374, 35.0860501],
              [46.0960075, 35.0861102],
              [46.0959686, 35.0861525],
              [46.0959055, 35.0862022],
              [46.0958253, 35.0862603],
              [46.0956315, 35.0863884],
              [46.0953051, 35.0866007],
              [46.0952147, 35.0866737],
              [46.0951294, 35.0867467],
              [46.0950252, 35.0868551],
              [46.0949239, 35.0869788],
              [46.0948202, 35.087098],
              [46.0947676, 35.0871517],
              [46.0947136, 35.0871981],
              [46.0946458, 35.0872477],
              [46.0945704, 35.0872868],
              [46.0943783, 35.0873623],
              [46.094181, 35.0874499],
              [46.0940986, 35.0875042],
              [46.0940102, 35.0875667],
              [46.0938249, 35.0877086],
              [46.0937392, 35.0877629],
              [46.0936237, 35.0878212],
              [46.0935224, 35.0878587],
              [46.093363, 35.0879024],
              [46.0931666, 35.0879481],
              [46.0929906, 35.087973],
              [46.0927437, 35.0880039],
              [46.0925897, 35.0880235],
              [46.0924637, 35.0880432],
              [46.0923881, 35.0880547],
              [46.0922704, 35.0880725],
              [46.0921515, 35.088084],
              [46.0920325, 35.0880934],
              [46.0919049, 35.0880974],
              [46.09179, 35.088095],
              [46.0916675, 35.088084],
              [46.0915689, 35.0880676],
              [46.0914792, 35.0880448],
              [46.0913979, 35.0880195],
              [46.0913203, 35.0880025],
              [46.0912371, 35.0879895],
              [46.0910007, 35.0879588],
              [46.0907704, 35.0879307],
              [46.0906313, 35.087908],
              [46.0905441, 35.0878886],
              [46.0904594, 35.0878651],
              [46.0903232, 35.0878201],
              [46.0901887, 35.0877865],
              [46.0901085, 35.0877758],
              [46.0900343, 35.0877774],
              [46.0899219, 35.0877905],
              [46.0898285, 35.0878011],
              [46.0897575, 35.0878088],
              [46.089684, 35.0878123],
              [46.0896257, 35.0878106],
              [46.089565, 35.0877985],
              [46.0895036, 35.0877779],
              [46.0894524, 35.0877512],
              [46.0893397, 35.0876893],
              [46.0892666, 35.0876632],
              [46.0888765, 35.0876025],
              [46.0883042, 35.0874801],
              [46.0875765, 35.087392],
              [46.0868127, 35.0872762],
              [46.0862766, 35.0871679],
              [46.0856332, 35.0870731],
              [46.0854514, 35.0870493],
              [46.0853677, 35.0870411],
              [46.0852904, 35.0870358],
              [46.0852199, 35.0870406],
              [46.0851512, 35.0870462],
              [46.0850553, 35.0870499],
              [46.0849883, 35.0870484],
              [46.084925, 35.0870396],
              [46.0848779, 35.0870308],
              [46.0847987, 35.0870165],
              [46.0847294, 35.0870023],
              [46.0846808, 35.0869893],
              [46.0846186, 35.0869711],
              [46.0845394, 35.0869465],
              [46.0844384, 35.0869217],
              [46.0835424, 35.0867607],
              [46.0831833, 35.0867032],
              [46.0830198, 35.0866762],
              [46.0828778, 35.0866457],
              [46.0825398, 35.0865199],
              [46.0822137, 35.0863915],
              [46.0818748, 35.0862675],
              [46.0815391, 35.0861426],
              [46.0811977, 35.0860564],
              [46.0811071, 35.0860278],
              [46.0810331, 35.086001],
              [46.0809555, 35.0859786],
              [46.0808861, 35.0859592],
              [46.0808039, 35.0859427],
              [46.080651, 35.0859163],
              [46.0805486, 35.0858928],
              [46.0804872, 35.0858778],
              [46.080415, 35.0858561],
              [46.0803424, 35.0858267],
              [46.0802274, 35.0857722],
              [46.0800154, 35.085666],
              [46.0795915, 35.0854375],
              [46.0795172, 35.0854061],
              [46.0790235, 35.0850415],
              [46.0786524, 35.0846451],
              [46.0785662, 35.0845328],
              [46.0785021, 35.0844172],
              [46.0784198, 35.0842221],
              [46.0783645, 35.0841298],
              [46.0782875, 35.0840713],
              [46.078177, 35.0840178],
              [46.0780291, 35.0839752],
              [46.0779212, 35.0839599],
              [46.0778584, 35.0839618],
              [46.0778194, 35.0839638],
              [46.0777854, 35.0839678],
              [46.0777392, 35.0839676],
              [46.0776777, 35.0839632],
              [46.0775949, 35.083957],
              [46.0774953, 35.0839456],
              [46.0763375, 35.0837971],
              [46.0757843, 35.0837584],
              [46.0748612, 35.0837148],
              [46.0745051, 35.0837091],
              [46.0743846, 35.0837173],
              [46.0742076, 35.0837448],
              [46.0740883, 35.0837709],
              [46.0739354, 35.0838164],
              [46.0737431, 35.0838905],
              [46.0736897, 35.0839092],
              [46.0736493, 35.0839193],
              [46.0736065, 35.0839281],
              [46.0735653, 35.0839297],
              [46.0735287, 35.0839289],
              [46.0734564, 35.0839173],
              [46.0733887, 35.0839008],
              [46.0732815, 35.0838659],
              [46.0731896, 35.083826],
              [46.0729706, 35.0837275],
              [46.0725312, 35.08353],
              [46.0721956, 35.083367],
              [46.0720079, 35.0832513],
              [46.0718851, 35.0831675],
              [46.0717587, 35.0830502],
              [46.0716761, 35.0829525],
              [46.0715953, 35.082843],
              [46.0715312, 35.0827362],
              [46.0714643, 35.0825964],
              [46.0713667, 35.0823996],
              [46.071207, 35.0821094],
              [46.0711412, 35.081986],
              [46.0711047, 35.0818798],
              [46.0710931, 35.0817757],
              [46.0710941, 35.0815417],
              [46.0710961, 35.0812981],
              [46.0710887, 35.0811451],
              [46.071089, 35.0810247],
              [46.0711079, 35.0809054],
              [46.0711466, 35.0807743],
              [46.0712563, 35.0804836],
              [46.0713274, 35.0802947],
              [46.0713929, 35.0801183],
              [46.0715955, 35.0796984],
              [46.0717475, 35.0794129],
              [46.0718482, 35.0791885],
              [46.0719398, 35.0789042],
              [46.0720061, 35.0786525],
              [46.0720269, 35.0785092],
              [46.0720222, 35.0784141],
              [46.0719947, 35.0782934],
              [46.0719418, 35.0781698],
              [46.0718892, 35.0780401],
              [46.0718233, 35.0779073],
              [46.0717681, 35.0777995],
              [46.0716903, 35.0776993],
              [46.0716033, 35.0776257],
              [46.0714515, 35.0775321],
              [46.0713052, 35.0774474],
              [46.071164, 35.0773844],
              [46.0710887, 35.0773553],
              [46.071017, 35.0773395],
              [46.0708994, 35.0773206],
              [46.0707728, 35.0772825],
              [46.0707021, 35.0772511],
              [46.0706387, 35.0772138],
              [46.0705608, 35.0771496],
              [46.0704985, 35.0770798],
              [46.0703891, 35.0769376],
              [46.0702857, 35.0768302],
              [46.0701943, 35.0767594],
              [46.0700065, 35.0766767],
              [46.069846, 35.0765693],
              [46.0697314, 35.0764835],
              [46.0696587, 35.0763826],
              [46.0696436, 35.0762719],
              [46.0696438, 35.0760851],
              [46.069711, 35.0756767],
              [46.06975, 35.0754068],
              [46.0698028, 35.0751937],
              [46.0699315, 35.0749111],
              [46.0700998, 35.0746294],
              [46.0703628, 35.0743041],
              [46.0706518, 35.0740461],
              [46.070941, 35.0738081],
              [46.0711513, 35.0736296],
              [46.0712673, 35.0734919],
              [46.0714531, 35.0732027],
              [46.0715535, 35.0729755],
              [46.0716522, 35.0728222],
              [46.0717896, 35.0726711],
              [46.0719269, 35.0725249],
              [46.0720351, 35.0723345],
              [46.0722117, 35.0719364],
              [46.0723959, 35.0714681],
              [46.0725831, 35.0710284],
              [46.0727335, 35.0705456],
              [46.0728487, 35.070027],
              [46.0728793, 35.0698323],
              [46.0728738, 35.0696731],
              [46.0728484, 35.0694697],
              [46.0727868, 35.0692787],
              [46.0726836, 35.0690835],
              [46.0725678, 35.0689341],
              [46.0724449, 35.0688207],
              [46.0721759, 35.0686452],
              [46.0720955, 35.068588],
              [46.0720078, 35.068513],
              [46.0718757, 35.0683779],
              [46.0716476, 35.0681105],
              [46.0715162, 35.0679508],
              [46.0713103, 35.0676644],
              [46.0712512, 35.0675851],
              [46.0711993, 35.0675225],
              [46.0711277, 35.0674452],
              [46.07108, 35.067386],
              [46.0710192, 35.0672927],
              [46.0707477, 35.0667866],
              [46.070628, 35.0665756],
              [46.0704779, 35.0663745],
              [46.0700528, 35.0658889],
              [46.0697426, 35.0655373],
              [46.0693959, 35.0651162],
              [46.0691764, 35.0647975],
              [46.0688599, 35.0643025],
              [46.0687729, 35.0641222],
              [46.0687, 35.0639047],
              [46.068618, 35.0635729],
              [46.0685839, 35.0633752],
              [46.0685729, 35.0632143],
              [46.0685916, 35.0631028],
              [46.0686286, 35.0629962],
              [46.0686826, 35.0628597],
              [46.0687243, 35.0627356],
              [46.0687351, 35.0626464],
              [46.0687094, 35.0624479],
              [46.0687209, 35.062361],
              [46.0687444, 35.0622742],
              [46.0688442, 35.0619835],
              [46.0688894, 35.0617922],
              [46.0689196, 35.0615959],
              [46.068959, 35.0613337],
              [46.068974, 35.0610716],
              [46.0689444, 35.0606944],
              [46.0689027, 35.0603867],
              [46.0688798, 35.0599402],
              [46.0689131, 35.0595491],
              [46.0689519, 35.0592968],
              [46.0690955, 35.058885],
              [46.0692781, 35.0583556],
              [46.0694487, 35.0580168],
              [46.0695318, 35.0579015],
              [46.0696222, 35.0578099],
              [46.069736, 35.0577212],
              [46.0698218, 35.0576754],
              [46.069861, 35.0576525],
              [46.0698859, 35.0576296],
              [46.0699028, 35.0575998],
              [46.0699125, 35.0575567],
              [46.0699319, 35.0575061],
              [46.0700105, 35.0573855],
              [46.0700935, 35.0572989],
              [46.0701901, 35.0572375],
              [46.0702653, 35.0571953],
              [46.0703424, 35.057165],
              [46.0704294, 35.0571399],
              [46.0705164, 35.0571207],
              [46.0706422, 35.057084],
              [46.0707699, 35.05704],
              [46.071103, 35.0568903],
              [46.0713997, 35.0568003],
              [46.0717579, 35.056771],
              [46.0721465, 35.0567765],
              [46.0724423, 35.0569151],
              [46.0726302, 35.0570139],
              [46.0728252, 35.0571008],
              [46.0730618, 35.0571905],
              [46.0735317, 35.0576302],
              [46.074265, 35.0580592],
              [46.0750351, 35.0586869],
              [46.0754184, 35.0590191],
              [46.0756144, 35.0591729],
              [46.0757953, 35.0592775],
              [46.076058, 35.0594123],
              [46.0763356, 35.0595295],
              [46.0766063, 35.0596331],
              [46.0769305, 35.0597596],
              [46.0771176, 35.0598119],
              [46.0774012, 35.059866],
              [46.0776688, 35.0598946],
              [46.0778433, 35.0599037],
              [46.0780436, 35.0598952],
              [46.0783342, 35.0598601],
              [46.0786248, 35.0597864],
              [46.0789141, 35.0596881],
              [46.0793512, 35.0594775],
              [46.0795268, 35.0593498],
              [46.0796724, 35.0592221],
              [46.0797419, 35.0591108],
              [46.0797943, 35.0589995],
              [46.0798162, 35.0588736],
              [46.0798424, 35.0587758],
              [46.0798729, 35.0587061],
              [46.0799163, 35.0586435],
              [46.0800237, 35.0585414],
              [46.0801118, 35.0584428],
              [46.0801718, 35.0583631],
              [46.0802203, 35.0582705],
              [46.080246, 35.0581563],
              [46.0802619, 35.0580127],
              [46.0802964, 35.0577033],
              [46.0803232, 35.0573855],
              [46.080341, 35.0571174],
              [46.0803234, 35.0568212],
              [46.0803006, 35.0563495],
              [46.0802986, 35.0561452],
              [46.0802659, 35.055945],
              [46.0801954, 35.055762],
              [46.0801106, 35.0555923],
              [46.0800278, 35.0554742],
              [46.0796751, 35.0550127],
              [46.0794688, 35.0547583],
              [46.0793592, 35.0546257],
              [46.0792725, 35.0544785],
              [46.0792231, 35.0543911],
              [46.0791532, 35.054312],
              [46.0790187, 35.0541872],
              [46.0788312, 35.054038],
              [46.0785582, 35.0538334],
              [46.0783171, 35.0536397],
              [46.0781646, 35.0535157],
              [46.0780683, 35.0534167],
              [46.078002, 35.0533197],
              [46.0779307, 35.0532051],
              [46.0778032, 35.0530508],
              [46.0777091, 35.0529552],
              [46.0775066, 35.0527723],
              [46.0774241, 35.0526855],
              [46.077356, 35.0525997],
              [46.077281, 35.0524697],
              [46.0772124, 35.0523846],
              [46.0771336, 35.0523183],
              [46.0770424, 35.0522588],
              [46.0769415, 35.0522046],
              [46.0768267, 35.0521464],
              [46.0767047, 35.0520817],
              [46.0766438, 35.0520488],
              [46.0765655, 35.0520145],
              [46.0764803, 35.0519876],
              [46.076378, 35.0519614],
              [46.0762731, 35.0519289],
              [46.0761706, 35.0518891],
              [46.0760677, 35.0518344],
              [46.0759589, 35.0517836],
              [46.0758534, 35.0517489],
              [46.0757369, 35.0517213],
              [46.0755244, 35.05168],
              [46.075386, 35.0516471],
              [46.0752366, 35.0515979],
              [46.0750911, 35.0515456],
              [46.0749531, 35.0514994],
              [46.0748251, 35.0514655],
              [46.0746999, 35.0514428],
              [46.0744571, 35.051411],
              [46.0741148, 35.0513793],
              [46.0736494, 35.0513359],
              [46.0735081, 35.0513031],
              [46.0734041, 35.0512582],
              [46.0732982, 35.0511895],
              [46.0730863, 35.0510319],
              [46.0730072, 35.0509996],
              [46.0729079, 35.0509765],
              [46.0724243, 35.0508802],
              [46.0723055, 35.0508445],
              [46.0722211, 35.0507939],
              [46.0721697, 35.0507429],
              [46.0721026, 35.050666],
              [46.0719868, 35.0505976],
              [46.0718439, 35.0505424],
              [46.0713032, 35.0503683],
              [46.0709054, 35.0502192],
              [46.070282, 35.0499585],
              [46.0697942, 35.0497656],
              [46.0693778, 35.0496103],
              [46.06919, 35.0495399],
              [46.0690646, 35.0494841],
              [46.0689632, 35.0494309],
              [46.0688978, 35.0493891],
              [46.0688353, 35.0493405],
              [46.0687694, 35.0492728],
              [46.0687236, 35.0492025],
              [46.0686779, 35.0491425],
              [46.0686136, 35.0490806],
              [46.068463, 35.0489738],
              [46.0683458, 35.0488784],
              [46.0681946, 35.0487434],
              [46.0679634, 35.0485152],
              [46.0678724, 35.0484267],
              [46.0678208, 35.0483483],
              [46.0677965, 35.048236],
              [46.0678026, 35.0481307],
              [46.0678329, 35.0480295],
              [46.0679361, 35.0478568],
              [46.0679918, 35.0477324],
              [46.0680172, 35.047618],
              [46.0680074, 35.0475233],
              [46.067933, 35.0473537],
              [46.0678996, 35.0472282],
              [46.0678782, 35.0469359],
              [46.0678764, 35.0466926],
              [46.0679346, 35.0460455],
              [46.067916, 35.045351],
              [46.0679313, 35.0446205],
              [46.0678422, 35.0436535],
              [46.0677687, 35.0433458],
              [46.0676891, 35.0431475],
              [46.067615, 35.043044],
              [46.0674833, 35.0429575],
              [46.0672639, 35.0428677],
              [46.0670532, 35.0427568],
              [46.0668941, 35.0426494],
              [46.066713, 35.0424698],
              [46.0665741, 35.0423143],
              [46.0664383, 35.0421149],
              [46.0662991, 35.0419208],
              [46.0661556, 35.0417337],
              [46.066021, 35.0416054],
              [46.0658435, 35.0414735],
              [46.0657031, 35.0413784],
              [46.0653537, 35.0411742],
              [46.0650667, 35.0410117],
              [46.0645796, 35.0407044],
              [46.0637191, 35.0401793],
              [46.0635007, 35.0400437],
              [46.063246, 35.039839],
              [46.0625107, 35.039311],
              [46.0620712, 35.0390313],
              [46.0618669, 35.0389157],
              [46.0616454, 35.0388071],
              [46.0612368, 35.0386321],
              [46.0609733, 35.0385316],
              [46.0607483, 35.0384381],
              [46.0604063, 35.0382744],
              [46.0600944, 35.0381528],
              [46.0597806, 35.0380763],
              [46.0594455, 35.0380385],
              [46.0591098, 35.038019],
              [46.0588249, 35.0380322],
              [46.0584371, 35.0380982],
              [46.0579102, 35.0382792],
              [46.0576036, 35.0383953],
              [46.0573829, 35.0385114],
              [46.0571817, 35.0386522],
              [46.056878, 35.0388952],
              [46.0566288, 35.0391047],
              [46.056431, 35.0393141],
              [46.0562676, 35.0395201],
              [46.0561471, 35.039726],
              [46.0560935, 35.0398827],
              [46.0560956, 35.0400077],
              [46.0561256, 35.0401327],
              [46.0561986, 35.0402401],
              [46.0563639, 35.0404221],
              [46.0564744, 35.0405448],
              [46.0565549, 35.040685],
              [46.0565979, 35.0408161],
              [46.0566238, 35.0409682],
              [46.0566498, 35.0412465],
              [46.0566112, 35.0415672],
              [46.0563923, 35.0424641],
              [46.0561685, 35.0432815],
              [46.055988, 35.0439014],
              [46.0554035, 35.0450833],
              [46.0550211, 35.0456391],
              [46.0545185, 35.046237],
              [46.0541997, 35.0465411],
              [46.0528844, 35.0475264],
              [46.0525996, 35.0478296],
              [46.0524362, 35.0480973],
              [46.0523329, 35.0483578],
              [46.0522901, 35.0486852],
              [46.0523117, 35.0490035],
              [46.0523568, 35.0492258],
              [46.0524448, 35.049406],
              [46.0526858, 35.049716],
              [46.0529097, 35.0501246],
              [46.0530643, 35.0506844],
              [46.0531158, 35.0509994],
              [46.053133, 35.0513145],
              [46.0531265, 35.0516258],
              [46.0530342, 35.0519653],
              [46.0528323, 35.0523632],
              [46.0527713, 35.0525078],
              [46.052649, 35.0526858],
              [46.0524964, 35.0528245],
              [46.0522829, 35.0529433],
              [46.0520703, 35.0530388],
              [46.0518122, 35.0531021],
              [46.0515235, 35.0531446],
              [46.051169, 35.0531562],
              [46.0509012, 35.0531343],
              [46.0507229, 35.053099],
              [46.0505131, 35.0530214],
              [46.0503136, 35.0528769],
              [46.0501595, 35.0527134],
              [46.0500657, 35.0525116],
              [46.0499495, 35.0522335],
              [46.0497797, 35.0519168],
              [46.0494187, 35.0513222],
              [46.0490401, 35.0508638],
              [46.0486532, 35.0505028],
              [46.0482662, 35.0501669],
              [46.0480702, 35.050028],
              [46.0478539, 35.0499141],
              [46.0476503, 35.04984],
              [46.0474262, 35.0497909],
              [46.047157, 35.0497992],
              [46.0468419, 35.0498577],
              [46.046447, 35.0500229],
              [46.0461133, 35.0502131],
              [46.0456348, 35.0505893],
              [46.0451067, 35.0512243],
              [46.044676, 35.0516097],
              [46.0442181, 35.0519453],
              [46.0437206, 35.0522382],
              [46.0433869, 35.05243],
              [46.0431893, 35.0525215],
              [46.0429954, 35.0525923],
              [46.0427306, 35.0526489],
              [46.0424549, 35.052676],
              [46.0422198, 35.0526373],
              [46.04201, 35.0525869],
              [46.0417563, 35.052516],
              [46.041499, 35.0524186],
              [46.041118, 35.0521676],
              [46.0408927, 35.0519735],
              [46.0406999, 35.0517794],
              [46.0402689, 35.0512862],
              [46.0399836, 35.0510713],
              [46.0396498, 35.0509061],
              [46.039102, 35.0507458],
              [46.0385663, 35.0506949],
              [46.0378328, 35.0507594],
              [46.0372086, 35.0509034],
              [46.0356274, 35.0512546],
              [46.0345604, 35.0514573],
              [46.0335724, 35.0517246],
              [46.0328527, 35.0520516],
              [46.0320013, 35.0523873],
              [46.0313211, 35.0524608],
              [46.0302146, 35.0525675],
              [46.0298006, 35.0526038],
              [46.0294679, 35.0528264],
              [46.0293469, 35.053157],
              [46.0290877, 35.0534742],
              [46.0282428, 35.0539411],
              [46.0272491, 35.0544205],
              [46.0256293, 35.0552027],
              [46.0254528, 35.0556231],
              [46.0256319, 35.0559299],
              [46.0262496, 35.0562244],
              [46.0268242, 35.0564592],
              [46.0271455, 35.0566337],
              [46.0273946, 35.0568437],
              [46.0276539, 35.0570626],
              [46.0278266, 35.0573997],
              [46.0278141, 35.0576195],
              [46.0276283, 35.0579929],
              [46.0274784, 35.0582209],
              [46.0271841, 35.0584608],
              [46.0268687, 35.0587093],
              [46.0263894, 35.0591493],
              [46.0260978, 35.0595893],
              [46.0257383, 35.0604812],
              [46.0256183, 35.060774],
              [46.0252482, 35.061188],
              [46.0247915, 35.0615312],
              [46.023678, 35.0621837],
              [46.0225376, 35.0627127],
              [46.0217297, 35.0629106],
              [46.021216, 35.0631688],
              [46.0208975, 35.0634669],
              [46.0190256, 35.0648351],
              [46.0180149, 35.0652235],
              [46.0174781, 35.0655628],
              [46.0171285, 35.0658073],
              [46.0165547, 35.0662723],
              [46.0164118, 35.0664188],
              [46.0163296, 35.066615],
              [46.0163209, 35.0668063],
              [46.0163972, 35.0669976],
              [46.0165873, 35.0672425],
              [46.0168695, 35.0675358],
              [46.0170096, 35.0677735],
              [46.0171821, 35.0681715],
              [46.0172696, 35.0684999],
              [46.0172702, 35.0686885],
              [46.0172344, 35.068897],
              [46.0170353, 35.069304],
              [46.0167602, 35.0697538],
              [46.0163675, 35.0702663],
              [46.0159406, 35.0707283],
              [46.0154065, 35.0712009],
              [46.014864, 35.0714774],
              [46.0141669, 35.0716408],
              [46.0136266, 35.0716291],
              [46.0129236, 35.0714311],
              [46.0119824, 35.0713632],
              [46.0096316, 35.0717413],
              [46.0079987, 35.0718063],
              [46.006242, 35.0715156],
              [46.0048747, 35.0713466],
              [46.0038686, 35.0707766],
              [46.0017596, 35.0666405],
              [46.0012653, 35.0659503],
              [46.0010984, 35.0650569],
              [46.0009019, 35.0638298],
              [46.0010454, 35.0626297],
              [46.0008906, 35.0622752],
              [46.0005407, 35.0620139],
              [46.0003318, 35.0618808],
              [45.9983857, 35.0619879],
              [45.9966534, 35.062307],
              [45.9949371, 35.0629572],
              [45.9937493, 35.0638397],
              [45.9927768, 35.0648454],
              [45.9912222, 35.0658578],
              [45.9880968, 35.0688639],
              [45.9862231, 35.0688763],
              [45.9855782, 35.0686441],
              [45.9844947, 35.0686652],
              [45.9834886, 35.0688763],
              [45.9823535, 35.0695942],
              [45.9818633, 35.0705232],
              [45.9815795, 35.0716422],
              [45.9809862, 35.0722756],
              [45.9797479, 35.0724657],
              [45.9783548, 35.0723812],
              [45.9775035, 35.072149],
              [45.9762136, 35.0722123],
              [45.9753881, 35.0725923],
              [45.9752095, 35.072717],
              [45.974511, 35.0732046],
              [45.9739177, 35.0735635],
              [45.9728858, 35.0737536],
              [45.9720086, 35.0737536],
              [45.9711315, 35.0734369],
              [45.9700996, 35.0732046],
              [45.9691967, 35.0733524],
              [45.968268, 35.0741125],
              [45.9675715, 35.0752737],
              [45.9676747, 35.0762449],
              [45.9681648, 35.0769838],
              [45.9683454, 35.0776172],
              [45.9679068, 35.078525],
              [45.9669781, 35.0793694],
              [45.9657398, 35.0800028],
              [45.9640114, 35.0801083],
              [45.9618186, 35.0804884],
              [45.9605029, 35.0811006],
              [45.9591615, 35.0815861],
              [45.9572009, 35.0821983],
              [45.9560658, 35.0828317],
              [45.9552144, 35.0841405],
              [45.9544921, 35.0853016],
              [45.9538988, 35.0860615],
              [45.9529185, 35.0870537],
              [45.9514996, 35.0880247],
              [45.9503903, 35.0890591],
              [45.9492294, 35.0901568],
              [45.9478106, 35.0907689],
              [45.9462111, 35.0909378],
              [45.9442247, 35.0910644],
              [45.9429864, 35.0906634],
              [45.9421609, 35.0899034],
              [45.9415912, 35.0886019],
              [45.941271, 35.0882698],
              [45.9410196, 35.088009],
              [45.9407936, 35.0872859],
              [45.9397875, 35.0863782],
              [45.938704, 35.0854494],
              [45.9376979, 35.084225],
              [45.9373883, 35.0834228],
              [45.937053, 35.0824728],
              [45.9362017, 35.0814806],
              [45.9356599, 35.0811428],
              [45.934628, 35.0812695],
              [45.9332349, 35.0817339],
              [45.9324868, 35.0816917],
              [45.9319451, 35.0816072],
              [45.9312743, 35.0816706],
              [45.9307326, 35.082135],
              [45.9299845, 35.0828739],
              [45.9293395, 35.0840561],
              [45.9281786, 35.0847949],
              [45.9272757, 35.0856816],
              [45.9264244, 35.0870326],
              [45.9259084, 35.088278],
              [45.9254183, 35.09079],
              [45.9249023, 35.0920987],
              [45.9222968, 35.0955393],
              [45.9220009, 35.0956079],
              [45.921987, 35.095489],
              [45.921986, 35.092095],
              [45.922083, 35.091989],
              [45.922215, 35.091824],
              [45.922333, 35.091548],
              [45.922449, 35.091239],
              [45.922598, 35.090744],
              [45.922649, 35.090279],
              [45.922637, 35.089763],
              [45.922532, 35.089143],
              [45.92226, 35.08872],
              [45.92191, 35.088532],
              [45.921437, 35.088219],
              [45.921317, 35.087816],
              [45.921395, 35.087064],
              [45.921689, 35.086288],
              [45.922123, 35.085629],
              [45.922367, 35.085218],
              [45.922672, 35.08486],
              [45.922897, 35.084573],
              [45.923035, 35.084035],
              [45.923179, 35.083475],
              [45.923345, 35.083005],
              [45.923507, 35.082662],
              [45.923554, 35.08236],
              [45.923754, 35.081874],
              [45.923664, 35.081513],
              [45.923567, 35.081174],
              [45.923516, 35.080922],
              [45.923424, 35.080551],
              [45.923409, 35.080197],
              [45.923421, 35.079797],
              [45.9235, 35.079029],
              [45.923411, 35.078374],
              [45.923298, 35.077871],
              [45.92315, 35.077426],
              [45.922974, 35.07707],
              [45.922797, 35.076757],
              [45.922651, 35.07627],
              [45.922436, 35.075952],
              [45.922299, 35.075652],
              [45.922236, 35.075375],
              [45.922248, 35.075174],
              [45.922194, 35.074985],
              [45.9221, 35.074855],
              [45.922146, 35.074569],
              [45.922141, 35.07435],
              [45.922122, 35.074228],
              [45.922102, 35.074095],
              [45.922215, 35.073782],
              [45.922294, 35.07348],
              [45.922266, 35.072971],
              [45.92222, 35.072419],
              [45.922217, 35.072037],
              [45.922117, 35.071511],
              [45.922232, 35.071155],
              [45.922504, 35.070786],
              [45.922785, 35.070427],
              [45.922982, 35.070203],
              [45.923027, 35.069891],
              [45.922946, 35.069712],
              [45.922853, 35.069142],
              [45.922576, 35.068354],
              [45.922667, 35.068002],
              [45.922956, 35.067752],
              [45.923274, 35.06759],
              [45.923437, 35.067377],
              [45.923269, 35.066904],
              [45.922962, 35.066415],
              [45.922729, 35.065802],
              [45.922646, 35.065635],
              [45.922441, 35.065199],
              [45.922237, 35.064906],
              [45.922017, 35.064413],
              [45.92201, 35.063848],
              [45.921741, 35.062884],
              [45.921331, 35.062098],
              [45.92122, 35.061098],
              [45.921221, 35.059873],
              [45.921064, 35.058662],
              [45.921292, 35.057775],
              [45.921119, 35.05751],
              [45.920826, 35.056935],
              [45.920668, 35.056336],
              [45.92053, 35.055909],
              [45.920292, 35.055508],
              [45.920406, 35.055382],
              [45.920578, 35.05516],
              [45.920766, 35.054943],
              [45.920932, 35.054827],
              [45.921204, 35.05473],
              [45.921483, 35.054682],
              [45.921756, 35.054653],
              [45.921855, 35.054642],
              [45.922128, 35.054549],
              [45.922506, 35.054291],
              [45.922809, 35.054207],
              [45.92313, 35.054133],
              [45.923578, 35.054075],
              [45.923938, 35.053986],
              [45.924286, 35.053825],
              [45.924616, 35.053722],
              [45.924795, 35.053682],
              [45.925127, 35.053653],
              [45.925538, 35.053615],
              [45.925952, 35.053507],
              [45.926382, 35.053351],
              [45.926848, 35.053229],
              [45.927246, 35.053097],
              [45.927579, 35.053095],
              [45.927922, 35.052999],
              [45.928302, 35.052971],
              [45.928589, 35.052802],
              [45.92903, 35.052584],
              [45.929191, 35.052382],
              [45.929392, 35.052062],
              [45.929394, 35.051808],
              [45.929526, 35.051514],
              [45.929691, 35.051311],
              [45.929687, 35.051054],
              [45.929865, 35.05077],
              [45.930147, 35.050428],
              [45.930435, 35.05007],
              [45.930678, 35.04983],
              [45.930798, 35.049621],
              [45.930986, 35.049506],
              [45.931183, 35.049413],
              [45.931278, 35.049295],
              [45.93135, 35.049149],
              [45.93133, 35.048959],
              [45.931265, 35.048717],
              [45.931277, 35.048439],
              [45.931381, 35.048182],
              [45.93151, 35.047921],
              [45.931548, 35.04768],
              [45.931537, 35.047419],
              [45.931399, 35.047208],
              [45.931271, 35.046949],
              [45.931244, 35.046646],
              [45.931178, 35.046289],
              [45.931114, 35.045964],
              [45.930963, 35.045635],
              [45.930795, 35.045347],
              [45.930543, 35.045045],
              [45.930254, 35.045094],
              [45.929841, 35.045124],
              [45.92938, 35.045088],
              [45.928947, 35.045143],
              [45.928264, 35.045256],
              [45.927851, 35.045483],
              [45.927535, 35.045574],
              [45.927202, 35.045732],
              [45.926949, 35.045886],
              [45.926672, 35.045961],
              [45.926356, 35.046011],
              [45.926063, 35.046089],
              [45.92583, 35.046193],
              [45.925601, 35.046292],
              [45.925379, 35.046307],
              [45.924995, 35.04617],
              [45.924548, 35.04604],
              [45.924198, 35.045975],
              [45.923952, 35.045981],
              [45.923633, 35.04593],
              [45.923339, 35.045874],
              [45.923056, 35.045817],
              [45.922631, 35.045687],
              [45.922362, 35.045646],
              [45.922033, 35.045688],
              [45.92169, 35.045738],
              [45.921464, 35.045735],
              [45.921138, 35.045814],
              [45.92081, 35.04588],
              [45.920389, 35.045851],
              [45.919971, 35.045816],
              [45.919434, 35.04589],
              [45.919014, 35.045953],
              [45.918657, 35.045926],
              [45.918027, 35.045924],
              [45.917405, 35.045934],
              [45.917002, 35.045961],
              [45.916548, 35.045952],
              [45.916252, 35.04591],
              [45.915885, 35.045886],
              [45.915478, 35.045937],
              [45.915034, 35.04599],
              [45.914746, 35.04598],
              [45.914385, 35.045959],
              [45.914132, 35.045979],
              [45.913789, 35.045854],
              [45.913433, 35.045657],
              [45.913152, 35.045498],
              [45.912812, 35.045409],
              [45.912572, 35.045547],
              [45.912294, 35.045751],
              [45.911887, 35.045871],
              [45.91136, 35.045962],
              [45.910916, 35.046015],
              [45.910577, 35.046105],
              [45.910225, 35.046336],
              [45.909887, 35.046384],
              [45.909595, 35.046425],
              [45.909343, 35.046561],
              [45.909111, 35.046798],
              [45.908924, 35.04689],
              [45.908605, 35.046949],
              [45.908195, 35.046969],
              [45.907759, 35.047099],
              [45.907383, 35.047278],
              [45.907025, 35.047377],
              [45.906461, 35.047446],
              [45.906156, 35.047456],
              [45.905835, 35.04753],
              [45.905483, 35.047608],
              [45.904996, 35.047664],
              [45.904661, 35.04768],
              [45.904235, 35.047569],
              [45.903818, 35.047471],
              [45.903302, 35.047476],
              [45.902976, 35.047417],
              [45.902655, 35.047316],
              [45.902457, 35.047193],
              [45.902114, 35.047045],
              [45.9019962, 35.0470014],
              [45.901765, 35.046916],
              [45.901167, 35.046806],
              [45.900587, 35.04668],
              [45.900242, 35.046634],
              [45.89987, 35.046458],
              [45.899484, 35.046359],
              [45.899068, 35.046283],
              [45.898168, 35.046062],
              [45.88039, 35.037985],
              [45.88039, 35.037984],
              [45.8803005, 35.0378417],
              [45.879807, 35.036878],
              [45.879752, 35.036675],
              [45.87966, 35.036434],
              [45.879586, 35.036267],
              [45.879562, 35.035949],
              [45.879489, 35.035524],
              [45.879334, 35.035155],
              [45.879238, 35.034918],
              [45.879125, 35.034703],
              [45.879074, 35.03456],
              [45.879039, 35.034331],
              [45.879105, 35.03414],
              [45.878922, 35.033813],
              [45.878764, 35.033564],
              [45.87858, 35.033209],
              [45.878379, 35.033008],
              [45.878009, 35.032814],
              [45.877819, 35.032612],
              [45.877681, 35.032488],
              [45.877539, 35.032329],
              [45.877312, 35.032087],
              [45.877198, 35.031991],
              [45.876813, 35.031763],
              [45.876525, 35.031513],
              [45.876671, 35.031318],
              [45.876815, 35.030962],
              [45.876943, 35.030806],
              [45.877112, 35.030639],
              [45.877296, 35.030511],
              [45.877448, 35.030342],
              [45.87745, 35.030153],
              [45.877517, 35.029815],
              [45.877504, 35.02939],
              [45.877558, 35.029104],
              [45.877489, 35.028936],
              [45.877531, 35.028649],
              [45.877609, 35.028285],
              [45.877729, 35.028095],
              [45.877783, 35.027768],
              [45.877677, 35.027515],
              [45.877618, 35.027253],
              [45.877661, 35.027034],
              [45.877549, 35.02669],
              [45.877367, 35.026256],
              [45.877221, 35.025687],
              [45.877185, 35.025344],
              [45.877207, 35.02506],
              [45.87719, 35.02475],
              [45.877182, 35.024567],
              [45.87721, 35.024396],
              [45.877218, 35.024211],
              [45.877396, 35.023969],
              [45.877504, 35.023775],
              [45.8776, 35.023552],
              [45.877683, 35.023386],
              [45.877809, 35.023157],
              [45.877899, 35.022994],
              [45.878051, 35.022784],
              [45.878254, 35.022667],
              [45.878369, 35.0225],
              [45.878386, 35.022221],
              [45.878577, 35.022055],
              [45.878686, 35.021907],
              [45.87893, 35.021695],
              [45.879027, 35.021632],
              [45.879084, 35.021448],
              [45.879243, 35.021176],
              [45.879234, 35.020985],
              [45.87913, 35.020915],
              [45.878976, 35.020859],
              [45.878792, 35.020895],
              [45.878675, 35.020837],
              [45.878624, 35.020717],
              [45.878675, 35.020597],
              [45.878747, 35.020364],
              [45.87876, 35.020265],
              [45.878773, 35.020162],
              [45.87873, 35.019967],
              [45.878704, 35.019796],
              [45.878746, 35.01966],
              [45.878862, 35.019475],
              [45.878919, 35.019226],
              [45.878843, 35.019073],
              [45.87878, 35.018969],
              [45.878589, 35.01896],
              [45.878469, 35.018866],
              [45.878424, 35.018772],
              [45.878387, 35.018686],
              [45.878249, 35.018604],
              [45.878091, 35.018535],
              [45.878055, 35.01843],
              [45.878064, 35.018249],
              [45.878135, 35.018012],
              [45.878365, 35.017876],
              [45.878526, 35.017632],
              [45.878616, 35.017474],
              [45.878752, 35.017326],
              [45.878908, 35.017171],
              [45.879062, 35.017144],
              [45.879179, 35.017179],
              [45.879305, 35.01719],
              [45.879533, 35.017022],
              [45.87957, 35.016845],
              [45.879581, 35.016715],
              [45.879777, 35.016506],
              [45.879854, 35.016337],
              [45.879791, 35.016232],
              [45.879624, 35.016169],
              [45.879644, 35.015986],
              [45.87969, 35.015868],
              [45.879964, 35.015669],
              [45.880049, 35.015553],
              [45.8801, 35.015324],
              [45.880124, 35.015117],
              [45.880039, 35.014772],
              [45.879902, 35.014543],
              [45.879696, 35.014472],
              [45.879558, 35.014459],
              [45.879417, 35.01441],
              [45.879133, 35.014394],
              [45.878845, 35.014383],
              [45.878565, 35.014293],
              [45.878456, 35.014137],
              [45.878359, 35.013984],
              [45.878324, 35.013865],
              [45.87837, 35.013701],
              [45.878579, 35.013545],
              [45.878723, 35.013429],
              [45.878772, 35.013255],
              [45.87894, 35.013065],
              [45.878973, 35.012806],
              [45.87913, 35.012632],
              [45.879093, 35.012482],
              [45.878972, 35.012231],
              [45.878883, 35.012154],
              [45.878777, 35.011988],
              [45.87862, 35.011983],
              [45.878356, 35.012005],
              [45.878185, 35.011924],
              [45.878098, 35.01181],
              [45.878037, 35.011627],
              [45.877644, 35.011474],
              [45.877561, 35.011336],
              [45.87741, 35.011247],
              [45.877288, 35.011079],
              [45.877042, 35.010997],
              [45.876834, 35.010918],
              [45.87649, 35.01077],
              [45.876195, 35.010599],
              [45.875954, 35.010452],
              [45.875704, 35.010334],
              [45.875403, 35.010247],
              [45.875029, 35.010127],
              [45.875061, 35.009975],
              [45.875046, 35.009761],
              [45.875106, 35.009566],
              [45.87513, 35.009317],
              [45.875225, 35.009225],
              [45.87521, 35.009124],
              [45.875262, 35.008974],
              [45.875292, 35.008829],
              [45.875312, 35.008689],
              [45.875325, 35.008499],
              [45.875327, 35.008157],
              [45.875263, 35.007803],
              [45.875227, 35.00764],
              [45.875196, 35.007477],
              [45.875344, 35.007395],
              [45.875566, 35.007383],
              [45.875876, 35.007341],
              [45.87611, 35.007308],
              [45.876387, 35.007137],
              [45.87664, 35.007068],
              [45.876802, 35.006866],
              [45.877151, 35.006517],
              [45.877362, 35.006245],
              [45.877753, 35.006189],
              [45.878018, 35.006146],
              [45.878241, 35.005918],
              [45.878512, 35.005701],
              [45.878783, 35.005441],
              [45.879078, 35.005276],
              [45.879285, 35.005159],
              [45.879403, 35.005007],
              [45.879543, 35.004742],
              [45.879715, 35.004515],
              [45.879777, 35.004382],
              [45.879826, 35.004068],
              [45.879924, 35.003793],
              [45.879956, 35.003656],
              [45.880285, 35.003494],
              [45.88071, 35.003305],
              [45.880818, 35.00307],
              [45.88083, 35.00281],
              [45.880905, 35.002553],
              [45.881005, 35.002352],
              [45.881337, 35.002461],
              [45.88158, 35.002615],
              [45.881755, 35.002705],
              [45.881943, 35.002779],
              [45.882183, 35.002877],
              [45.882381, 35.002836],
              [45.882503, 35.002571],
              [45.882886, 35.002418],
              [45.882989, 35.002268],
              [45.883047, 35.002103],
              [45.883006, 35.001857],
              [45.883048, 35.001714],
              [45.883101, 35.001568],
              [45.883577, 35.001623],
              [45.883898, 35.001556],
              [45.884163, 35.001687],
              [45.884364, 35.001768],
              [45.884583, 35.001766],
              [45.884573, 35.001552],
              [45.884484, 35.001231],
              [45.884476, 35.001026],
              [45.884498, 35.000872],
              [45.884885, 35.000906],
              [45.885136, 35.000856],
              [45.885291, 35.000669],
              [45.885301, 35.000489],
              [45.885389, 35.000417],
              [45.885522, 35.000407],
              [45.885695, 35.000465],
              [45.885727, 35.000328],
              [45.885771, 35.000105],
              [45.886155, 34.999914],
              [45.886175, 34.999751],
              [45.886236, 34.999421],
              [45.886231, 34.999183],
              [45.88644, 34.999052],
              [45.886384, 34.998795],
              [45.886393, 34.998545],
              [45.886466, 34.998414],
              [45.886334, 34.998143],
              [45.886271, 34.997986],
              [45.886209, 34.997725],
              [45.886239, 34.997405],
              [45.886284, 34.997055],
              [45.886217, 34.996819],
              [45.886161, 34.99651],
              [45.88615, 34.996297],
              [45.886017, 34.996129],
              [45.88628, 34.995927],
              [45.886483, 34.995862],
              [45.886523, 34.995583],
              [45.886887, 34.995246],
              [45.887036, 34.995168],
              [45.886997, 34.994973],
              [45.886919, 34.994739],
              [45.886846, 34.994541],
              [45.886717, 34.994152],
              [45.886612, 34.993964],
              [45.886591, 34.993795],
              [45.886564, 34.993603],
              [45.886649, 34.993363],
              [45.886936, 34.993189],
              [45.887392, 34.992971],
              [45.887692, 34.992692],
              [45.887968, 34.992493],
              [45.887876, 34.99227],
              [45.887791, 34.992028],
              [45.887779, 34.991721],
              [45.888069, 34.991467],
              [45.88821, 34.991315],
              [45.888202, 34.991003],
              [45.888163, 34.990677],
              [45.888195, 34.990428],
              [45.888095, 34.990282],
              [45.8881, 34.990084],
              [45.888245, 34.989814],
              [45.888346, 34.989707],
              [45.888372, 34.989609],
              [45.888567, 34.989428],
              [45.88881, 34.989277],
              [45.888997, 34.98915],
              [45.889214, 34.988923],
              [45.889509, 34.988842],
              [45.889706, 34.988732],
              [45.889744, 34.988598],
              [45.889643, 34.988359],
              [45.889483, 34.988242],
              [45.889379, 34.988012],
              [45.889019, 34.987904],
              [45.888872, 34.987705],
              [45.888529, 34.987556],
              [45.888522, 34.987421],
              [45.888652, 34.987271],
              [45.888645, 34.98709],
              [45.888485, 34.986776],
              [45.888282, 34.98649],
              [45.888404, 34.986308],
              [45.888623, 34.986133],
              [45.888469, 34.985842],
              [45.888438, 34.985655],
              [45.888408, 34.985497],
              [45.888294, 34.985316],
              [45.888344, 34.985073],
              [45.888373, 34.984795],
              [45.888179, 34.984741],
              [45.888089, 34.984612],
              [45.888032, 34.984519],
              [45.88791, 34.984354],
              [45.887629, 34.984184],
              [45.887447, 34.98387],
              [45.887476, 34.983654],
              [45.887504, 34.983391],
              [45.887474, 34.983256],
              [45.887509, 34.983062],
              [45.88745, 34.982684],
              [45.887365, 34.982352],
              [45.887566, 34.982105],
              [45.88762, 34.981922],
              [45.887925, 34.9816],
              [45.888213, 34.981403],
              [45.888447, 34.981371],
              [45.888827, 34.981101],
              [45.889237, 34.980811],
              [45.889181, 34.980639],
              [45.889099, 34.980147],
              [45.889449, 34.979845],
              [45.889692, 34.979629],
              [45.889595, 34.979276],
              [45.889535, 34.978846],
              [45.889742, 34.97849],
              [45.88979, 34.978219],
              [45.8898381, 34.9781093],
              [45.889892, 34.977981],
              [45.889935, 34.977757],
              [45.889913, 34.977475],
              [45.889873, 34.977211],
              [45.889997, 34.976949],
              [45.890112, 34.976629],
              [45.8899761, 34.976443],
              [45.890567, 34.976013],
              [45.890866, 34.975753],
              [45.89084, 34.975654],
              [45.890731, 34.975318],
              [45.890879, 34.975062],
              [45.891123, 34.974896],
              [45.891203, 34.974769],
              [45.891337, 34.974483],
              [45.891229, 34.974216],
              [45.891106, 34.973892],
              [45.891094, 34.97365],
              [45.890964, 34.973298],
              [45.890723, 34.973173],
              [45.890541, 34.972882],
              [45.890292, 34.97266],
              [45.89022, 34.972556],
              [45.889933, 34.97234],
              [45.889772, 34.972196],
              [45.889608, 34.972061],
              [45.889574, 34.971889],
              [45.889475, 34.971766],
              [45.889301, 34.971549],
              [45.889139, 34.97125],
              [45.889335, 34.971051],
              [45.889683, 34.970937],
              [45.889772, 34.970865],
              [45.889906, 34.97062],
              [45.889846, 34.970411],
              [45.889949, 34.969938],
              [45.889937, 34.969781],
              [45.890081, 34.969356],
              [45.890688, 34.969154],
              [45.891158, 34.969013],
              [45.891351, 34.968824],
              [45.891624, 34.96892],
              [45.891844, 34.968899],
              [45.891966, 34.968737],
              [45.892092, 34.968419],
              [45.892274, 34.968185],
              [45.8926, 34.967985],
              [45.893025, 34.967689],
              [45.893044, 34.967329],
              [45.893065, 34.966908],
              [45.893062, 34.966548],
              [45.893312, 34.966274],
              [45.893551, 34.96602],
              [45.893624, 34.965824],
              [45.893655, 34.965636],
              [45.893784, 34.965416],
              [45.893839, 34.965195],
              [45.893952, 34.964978],
              [45.894164, 34.964902],
              [45.894389, 34.964707],
              [45.89435, 34.964489],
              [45.894237, 34.964205],
              [45.894262, 34.963952],
              [45.894307, 34.963775],
              [45.894392, 34.963605],
              [45.894739, 34.963398],
              [45.895061, 34.963382],
              [45.895352, 34.963484],
              [45.895604, 34.963388],
              [45.89584, 34.963364],
              [45.895843, 34.963246],
              [45.896062, 34.963048],
              [45.89621, 34.962702],
              [45.896041, 34.962531],
              [45.895929, 34.962336],
              [45.895995, 34.962066],
              [45.896146, 34.961716],
              [45.896166, 34.961379],
              [45.896417, 34.960908],
              [45.89658, 34.960733],
              [45.896725, 34.960534],
              [45.896864, 34.960438],
              [45.897, 34.960222],
              [45.897312, 34.959992],
              [45.897018, 34.959595],
              [45.89683, 34.959498],
              [45.896489, 34.959377],
              [45.896297, 34.959223],
              [45.896151, 34.959161],
              [45.895983, 34.959036],
              [45.895684, 34.958856],
              [45.895446, 34.958786],
              [45.895214, 34.958673],
              [45.895051, 34.958501],
              [45.895118, 34.958324],
              [45.895141, 34.958044],
              [45.89518, 34.957606],
              [45.895062, 34.957388],
              [45.895245, 34.95705],
              [45.895206, 34.956833],
              [45.895059, 34.956634],
              [45.894918, 34.95657],
              [45.8947, 34.956553],
              [45.894615, 34.956423],
              [45.894503, 34.956293],
              [45.894445, 34.956177],
              [45.894462, 34.955916],
              [45.894322, 34.955834],
              [45.89414, 34.955848],
              [45.893951, 34.9559],
              [45.89391, 34.955786],
              [45.893739, 34.955582],
              [45.893496, 34.955424],
              [45.893314, 34.955312],
              [45.893117, 34.955244],
              [45.892721, 34.955151],
              [45.892475, 34.955312],
              [45.892153, 34.955506],
              [45.892133, 34.955229],
              [45.892174, 34.955062],
              [45.892059, 34.954834],
              [45.891866, 34.9547],
              [45.89181, 34.954462],
              [45.891716, 34.954272],
              [45.891636, 34.954113],
              [45.891619, 34.953896],
              [45.891466, 34.953413],
              [45.891806, 34.953333],
              [45.892119, 34.9533],
              [45.892308, 34.953205],
              [45.892751, 34.953173],
              [45.893287, 34.953067],
              [45.893597, 34.952936],
              [45.893943, 34.952729],
              [45.893897, 34.95255],
              [45.893657, 34.952166],
              [45.893628, 34.951881],
              [45.893527, 34.951576],
              [45.893388, 34.951409],
              [45.893466, 34.951188],
              [45.893504, 34.951008],
              [45.89351, 34.950834],
              [45.89365, 34.950724],
              [45.893867, 34.95069],
              [45.894148, 34.950621],
              [45.894222, 34.950364],
              [45.894162, 34.950042],
              [45.894153, 34.949898],
              [45.894145, 34.949782],
              [45.893783, 34.949688],
              [45.893432, 34.949704],
              [45.893021, 34.949881],
              [45.892841, 34.949989],
              [45.892414, 34.950018],
              [45.892209, 34.949919],
              [45.892075, 34.949836],
              [45.891941, 34.949625],
              [45.891725, 34.949552],
              [45.891327, 34.949492],
              [45.890911, 34.949431],
              [45.890542, 34.949445],
              [45.890222, 34.949381],
              [45.890471, 34.948905],
              [45.890734, 34.948506],
              [45.891041, 34.947884],
              [45.891459, 34.947364],
              [45.891535, 34.946961],
              [45.891698, 34.946374],
              [45.891207, 34.946411],
              [45.891005, 34.94648],
              [45.890569, 34.946493],
              [45.890209, 34.946604],
              [45.889952, 34.946636],
              [45.88969, 34.946777],
              [45.889527, 34.946582],
              [45.88937, 34.946389],
              [45.889207, 34.946325],
              [45.889101, 34.946156],
              [45.88894, 34.946012],
              [45.888729, 34.945741],
              [45.888371, 34.945486],
              [45.888108, 34.94543],
              [45.887854, 34.945382],
              [45.887529, 34.945281],
              [45.88729, 34.945273],
              [45.886991, 34.945228],
              [45.886475, 34.944997],
              [45.885932, 34.944837],
              [45.885626, 34.944784],
              [45.885166, 34.945012],
              [45.88444, 34.945339],
              [45.884268, 34.945351],
              [45.883559, 34.945441],
              [45.882828, 34.945446],
              [45.882485, 34.945451],
              [45.88213, 34.945538],
              [45.881906, 34.945476],
              [45.881633, 34.945117],
              [45.881382, 34.944867],
              [45.881456, 34.944629],
              [45.881537, 34.944309],
              [45.881516, 34.943704],
              [45.881448, 34.943529],
              [45.881293, 34.943299],
              [45.88138, 34.94296],
              [45.881257, 34.942569],
              [45.880945, 34.942279],
              [45.880864, 34.942031],
              [45.880651, 34.941797],
              [45.880484, 34.94178],
              [45.880186, 34.94174],
              [45.879983, 34.941542],
              [45.879812, 34.941428],
              [45.879572, 34.941326],
              [45.879479, 34.940986],
              [45.879353, 34.940718],
              [45.879205, 34.940627],
              [45.879045, 34.94053],
              [45.879078, 34.94035],
              [45.879123, 34.940089],
              [45.879191, 34.939852],
              [45.879117, 34.939631],
              [45.878989, 34.939396],
              [45.878881, 34.939242],
              [45.878723, 34.939172],
              [45.878634, 34.939071],
              [45.878474, 34.938997],
              [45.87818, 34.938928],
              [45.877996, 34.938736],
              [45.877973, 34.938473],
              [45.878022, 34.938206],
              [45.878135, 34.937947],
              [45.878196, 34.937786],
              [45.878005, 34.937661],
              [45.877974, 34.937474],
              [45.877933, 34.93736],
              [45.87769, 34.937249],
              [45.877545, 34.937101],
              [45.877188, 34.936959],
              [45.876982, 34.936753],
              [45.876757, 34.936667],
              [45.876431, 34.936603],
              [45.876145, 34.9365],
              [45.875884, 34.93643],
              [45.875597, 34.936495],
              [45.875367, 34.93641],
              [45.875143, 34.936263],
              [45.874992, 34.936027],
              [45.874882, 34.935799],
              [45.874703, 34.935737],
              [45.874328, 34.93564],
              [45.874163, 34.935633],
              [45.87386, 34.93557],
              [45.873591, 34.935642],
              [45.873423, 34.93578],
              [45.873337, 34.935945],
              [45.873266, 34.936216],
              [45.873098, 34.936241],
              [45.872927, 34.936277],
              [45.872635, 34.936413],
              [45.872427, 34.936348],
              [45.87235, 34.936118],
              [45.872306, 34.935924],
              [45.87214, 34.935719],
              [45.871948, 34.935562],
              [45.871785, 34.935371],
              [45.871831, 34.935091],
              [45.871767, 34.934755],
              [45.871685, 34.934569],
              [45.87168, 34.934373],
              [45.871656, 34.934021],
              [45.871515, 34.933474],
              [45.871482, 34.933237],
              [45.871541, 34.932898],
              [45.871824, 34.932599],
              [45.871968, 34.932306],
              [45.872162, 34.932032],
              [45.872343, 34.931924],
              [45.872428, 34.931773],
              [45.872389, 34.931579],
              [45.872459, 34.931346],
              [45.872628, 34.931044],
              [45.872594, 34.930867],
              [45.872627, 34.930711],
              [45.872571, 34.930365],
              [45.87295, 34.930086],
              [45.873065, 34.929724],
              [45.872794, 34.929613],
              [45.872604, 34.929469],
              [45.872265, 34.929398],
              [45.871989, 34.929331],
              [45.871829, 34.929172],
              [45.871675, 34.928989],
              [45.871537, 34.928934],
              [45.871352, 34.928958],
              [45.871136, 34.928973],
              [45.871005, 34.928814],
              [45.870803, 34.928579],
              [45.870528, 34.928323],
              [45.870294, 34.928309],
              [45.869804, 34.928355],
              [45.869401, 34.928385],
              [45.869122, 34.928159],
              [45.868869, 34.927984],
              [45.868676, 34.927695],
              [45.868549, 34.927507],
              [45.86845, 34.9273],
              [45.868177, 34.927269],
              [45.868036, 34.927201],
              [45.867806, 34.927139],
              [45.867611, 34.927062],
              [45.867601, 34.926937],
              [45.867648, 34.926638],
              [45.867523, 34.926417],
              [45.867498, 34.926276],
              [45.867365, 34.926065],
              [45.867546, 34.925873],
              [45.867741, 34.925778],
              [45.867923, 34.92552],
              [45.868116, 34.925396],
              [45.868222, 34.925199],
              [45.86823, 34.924968],
              [45.868534, 34.92466],
              [45.868488, 34.924397],
              [45.868626, 34.923969],
              [45.868579, 34.923767],
              [45.868778, 34.923272],
              [45.868755, 34.922877],
              [45.869009, 34.92264],
              [45.869133, 34.922463],
              [45.869088, 34.922138],
              [45.86924, 34.921787],
              [45.869228, 34.921391],
              [45.868983, 34.921187],
              [45.868794, 34.921108],
              [45.868568, 34.920999],
              [45.868514, 34.920788],
              [45.868593, 34.92046],
              [45.868634, 34.92027],
              [45.868467, 34.920169],
              [45.86818, 34.920169],
              [45.868049, 34.92008],
              [45.86799, 34.919936],
              [45.868041, 34.919744],
              [45.867919, 34.919663],
              [45.867795, 34.91953],
              [45.867591, 34.919351],
              [45.867437, 34.919084],
              [45.867365, 34.918759],
              [45.867417, 34.918506],
              [45.867522, 34.918211],
              [45.867468, 34.918047],
              [45.867326, 34.91789],
              [45.866998, 34.917668],
              [45.86711, 34.917554],
              [45.867291, 34.917404],
              [45.86749, 34.917303],
              [45.867572, 34.917119],
              [45.867396, 34.916917],
              [45.867288, 34.916631],
              [45.867116, 34.916489],
              [45.867137, 34.916307],
              [45.867261, 34.916004],
              [45.86735, 34.915758],
              [45.867416, 34.915512],
              [45.867627, 34.915216],
              [45.867716, 34.915083],
              [45.867802, 34.914847],
              [45.867875, 34.914651],
              [45.867932, 34.914346],
              [45.867859, 34.914022],
              [45.867826, 34.913587],
              [45.867826, 34.913371],
              [45.867893, 34.913064],
              [45.867919, 34.912792],
              [45.868007, 34.912458],
              [45.868139, 34.912181],
              [45.86815, 34.91157],
              [45.868043, 34.911355],
              [45.867939, 34.911125],
              [45.868029, 34.910865],
              [45.868199, 34.910516],
              [45.868373, 34.91034],
              [45.868543, 34.910257],
              [45.868766, 34.91025],
              [45.868942, 34.91034],
              [45.869071, 34.910317],
              [45.869098, 34.910223],
              [45.869061, 34.91008],
              [45.869113, 34.909977],
              [45.869117, 34.90984],
              [45.86921, 34.909613],
              [45.869061, 34.909316],
              [45.868912, 34.909179],
              [45.868573, 34.908959],
              [45.868371, 34.908742],
              [45.868203, 34.908331],
              [45.868186, 34.908067],
              [45.86819, 34.907757],
              [45.868217, 34.907579],
              [45.868193, 34.907288],
              [45.868296, 34.906881],
              [45.868416, 34.906559],
              [45.868481, 34.906224],
              [45.868529, 34.906037],
              [45.868506, 34.905882],
              [45.868419, 34.905654],
              [45.868278, 34.905459],
              [45.868049, 34.905228],
              [45.867757, 34.905145],
              [45.867474, 34.90514],
              [45.867325, 34.905129],
              [45.867107, 34.905112],
              [45.866795, 34.905191],
              [45.866507, 34.905102],
              [45.866227, 34.905064],
              [45.866031, 34.905179],
              [45.865809, 34.905256],
              [45.865554, 34.905274],
              [45.865244, 34.904945],
              [45.865021, 34.904713],
              [45.864969, 34.904141],
              [45.864768, 34.903606],
              [45.864607, 34.903372],
              [45.864462, 34.903094],
              [45.864771, 34.902743],
              [45.864935, 34.902442],
              [45.864923, 34.902219],
              [45.864971, 34.902056],
              [45.864945, 34.901979],
              [45.86484, 34.90193],
              [45.864688, 34.901809],
              [45.864589, 34.901736],
              [45.864355, 34.901656],
              [45.86407, 34.901617],
              [45.863993, 34.90154],
              [45.863909, 34.901375],
              [45.863809, 34.901258],
              [45.863771, 34.901134],
              [45.863738, 34.900987],
              [45.863889, 34.900871],
              [45.86395, 34.900711],
              [45.864024, 34.900514],
              [45.864176, 34.900334],
              [45.864247, 34.900083],
              [45.864226, 34.899898],
              [45.864192, 34.899747],
              [45.86419, 34.899459],
              [45.864528, 34.899355],
              [45.864817, 34.899299],
              [45.86491, 34.899175],
              [45.8649, 34.89901],
              [45.864973, 34.898853],
              [45.864983, 34.898739],
              [45.865056, 34.898497],
              [45.86499, 34.898401],
              [45.864778, 34.898182],
              [45.864914, 34.898005],
              [45.864826, 34.897782],
              [45.864766, 34.897622],
              [45.86475, 34.897193],
              [45.864856, 34.896949],
              [45.865005, 34.896712],
              [45.864933, 34.89659],
              [45.864986, 34.89649],
              [45.86504, 34.896328],
              [45.864775, 34.89619],
              [45.864273, 34.896045],
              [45.86406, 34.895952],
              [45.863895, 34.895783],
              [45.8636, 34.895836],
              [45.86314, 34.895611],
              [45.863051, 34.895469],
              [45.862945, 34.895308],
              [45.862699, 34.895028],
              [45.862559, 34.894931],
              [45.862317, 34.894794],
              [45.862128, 34.894836],
              [45.861829, 34.894831],
              [45.861401, 34.894942],
              [45.861193, 34.894934],
              [45.86092, 34.894919],
              [45.860592, 34.895107],
              [45.860271, 34.895254],
              [45.860137, 34.895462],
              [45.859806, 34.89566],
              [45.859775, 34.895863],
              [45.859632, 34.89632],
              [45.859258, 34.896265],
              [45.858961, 34.896119],
              [45.858721, 34.896031],
              [45.858419, 34.895864],
              [45.858122, 34.895778],
              [45.857791, 34.895849],
              [45.857576, 34.895833],
              [45.857387, 34.89579],
              [45.857084, 34.895556],
              [45.856848, 34.895377],
              [45.856576, 34.895367],
              [45.856213, 34.895291],
              [45.855849, 34.895666],
              [45.855456, 34.895843],
              [45.855128, 34.896072],
              [45.854907, 34.896147],
              [45.854652, 34.896197],
              [45.854371, 34.896111],
              [45.854085, 34.895892],
              [45.853766, 34.8959046],
              [45.853462, 34.8958467],
              [45.853159, 34.895745],
              [45.852859, 34.895803],
              [45.852562, 34.895801],
              [45.852283, 34.895635],
              [45.852027, 34.89564],
              [45.851785, 34.89557],
              [45.85155, 34.895418],
              [45.851197, 34.895381],
              [45.850948, 34.895196],
              [45.850851, 34.895132],
              [45.850632, 34.895018],
              [45.850322, 34.894951],
              [45.849851, 34.894576],
              [45.849629, 34.894516],
              [45.849484, 34.894766],
              [45.849276, 34.894911],
              [45.849179, 34.895234],
              [45.848988, 34.895528],
              [45.848607, 34.895686],
              [45.848235, 34.89599],
              [45.848102, 34.896198],
              [45.847757, 34.896515],
              [45.84757, 34.896651],
              [45.847363, 34.89671],
              [45.847047, 34.896771],
              [45.846819, 34.89686],
              [45.846522, 34.897034],
              [45.846328, 34.897253],
              [45.846047, 34.897464],
              [45.845953, 34.89767],
              [45.845648, 34.897944],
              [45.845423, 34.898217],
              [45.845104, 34.898265],
              [45.844845, 34.898283],
              [45.844282, 34.898252],
              [45.844035, 34.898161],
              [45.843842, 34.898146],
              [45.843609, 34.898236],
              [45.843458, 34.898421],
              [45.843208, 34.898667],
              [45.843007, 34.898685],
              [45.84284, 34.89853],
              [45.842637, 34.898431],
              [45.842562, 34.8983],
              [45.842436, 34.898192],
              [45.842206, 34.898102],
              [45.841865, 34.897852],
              [45.841619, 34.897679],
              [45.841358, 34.897667],
              [45.841166, 34.897782],
              [45.841088, 34.897985],
              [45.840897, 34.898149],
              [45.840683, 34.898312],
              [45.840358, 34.898401],
              [45.840295, 34.898682],
              [45.840213, 34.89876],
              [45.83999, 34.898911],
              [45.839594, 34.898864],
              [45.839412, 34.89887],
              [45.839136, 34.898734],
              [45.838925, 34.898713],
              [45.838693, 34.898637],
              [45.838437, 34.898646],
              [45.838116, 34.89877],
              [45.83789, 34.898824],
              [45.837599, 34.898785],
              [45.837238, 34.898759],
              [45.836768, 34.898648],
              [45.836503, 34.898664],
              [45.835915, 34.898646],
              [45.835821, 34.899027],
              [45.835591, 34.899301],
              [45.83523, 34.899406],
              [45.834935, 34.89948],
              [45.83458, 34.899457],
              [45.834382, 34.899596],
              [45.834246, 34.899795],
              [45.834166, 34.900012],
              [45.834017, 34.900398],
              [45.833928, 34.901034],
              [45.833961, 34.901456],
              [45.834181, 34.901812],
              [45.8344655, 34.902239],
              [45.8345059, 34.9024089],
              [45.8345766, 34.9026368],
              [45.834481, 34.902686],
              [45.83424, 34.902616],
              [45.833962, 34.902602],
              [45.833737, 34.902619],
              [45.83355, 34.902796],
              [45.833388, 34.902987],
              [45.833149, 34.903119],
              [45.832981, 34.903238],
              [45.832899, 34.903446],
              [45.832767, 34.903663],
              [45.832543, 34.903873],
              [45.832126, 34.903898],
              [45.831813, 34.903926],
              [45.831648, 34.903712],
              [45.831468, 34.903443],
              [45.831363, 34.903245],
              [45.831178, 34.90313],
              [45.831005, 34.903232],
              [45.830942, 34.903468],
              [45.830841, 34.903841],
              [45.830637, 34.903999],
              [45.830382, 34.904138],
              [45.830065, 34.904257],
              [45.829912, 34.904221],
              [45.829753, 34.904011],
              [45.829549, 34.904015],
              [45.829437, 34.904197],
              [45.829285, 34.904336],
              [45.829175, 34.904482],
              [45.828931, 34.904489],
              [45.828663, 34.904365],
              [45.828507, 34.904357],
              [45.828289, 34.904269],
              [45.828036, 34.904264],
              [45.827884, 34.904188],
              [45.82772, 34.904086],
              [45.827634, 34.90398],
              [45.827469, 34.903766],
              [45.827318, 34.903694],
              [45.827129, 34.903714],
              [45.826999, 34.903827],
              [45.827011, 34.904198],
              [45.826884, 34.904495],
              [45.826919, 34.904646],
              [45.826846, 34.904911],
              [45.826717, 34.905136],
              [45.826596, 34.905306],
              [45.826543, 34.90545],
              [45.826353, 34.905663],
              [45.826089, 34.905894],
              [45.825993, 34.906181],
              [45.825763, 34.906586],
              [45.825705, 34.906839],
              [45.825655, 34.90719],
              [45.825625, 34.907532],
              [45.825606, 34.907783],
              [45.825466, 34.90801],
              [45.825117, 34.908184],
              [45.824994, 34.908408],
              [45.824894, 34.908633],
              [45.824756, 34.90872],
              [45.824532, 34.908737],
              [45.824312, 34.908812],
              [45.823982, 34.908861],
              [45.823753, 34.908798],
              [45.823522, 34.908681],
              [45.823312, 34.908732],
              [45.823127, 34.908855],
              [45.82312, 34.909085],
              [45.823148, 34.909278],
              [45.823087, 34.909586],
              [45.823113, 34.909815],
              [45.823051, 34.909947],
              [45.822814, 34.910174],
              [45.822554, 34.910444],
              [45.822408, 34.91065],
              [45.822139, 34.910841],
              [45.821821, 34.910938],
              [45.821298, 34.910949],
              [45.82053, 34.911247],
              [45.820041, 34.911428],
              [45.819456, 34.911509],
              [45.818866, 34.911658],
              [45.817818, 34.911933],
              [45.817497, 34.9118],
              [45.81728, 34.911587],
              [45.817074, 34.911308],
              [45.816825, 34.911186],
              [45.816417, 34.911074],
              [45.816311, 34.911191],
              [45.816178, 34.911489],
              [45.816073, 34.911674],
              [45.815904, 34.911812],
              [45.815771, 34.912024],
              [45.815539, 34.912074],
              [45.815274, 34.912134],
              [45.815042, 34.912229],
              [45.81478, 34.912276],
              [45.814457, 34.91218],
              [45.814152, 34.91213],
              [45.813775, 34.912174],
              [45.813579, 34.912065],
              [45.813316, 34.911913],
              [45.813121, 34.911651],
              [45.812889, 34.91149],
              [45.812668, 34.911389],
              [45.812305, 34.911422],
              [45.811929, 34.91134],
              [45.811629, 34.911029],
              [45.81091, 34.91067],
              [45.810575, 34.910765],
              [45.80984, 34.9108],
              [45.80929, 34.910884],
              [45.808836, 34.911306],
              [45.80857, 34.911447],
              [45.807792, 34.911405],
              [45.807338, 34.911458],
              [45.806984, 34.911377],
              [45.8067, 34.911274],
              [45.806171, 34.911286],
              [45.805595, 34.911379],
              [45.80513, 34.911439],
              [45.804433, 34.911679],
              [45.804029, 34.911925],
              [45.803524, 34.912113],
              [45.8032, 34.912121],
              [45.80241, 34.912139],
              [45.801946, 34.912028],
              [45.80151, 34.911875],
              [45.801162, 34.911878],
              [45.800666, 34.911903],
              [45.79988, 34.911831],
              [45.799234, 34.911684],
              [45.798639, 34.911555],
              [45.798202, 34.911524],
              [45.79802, 34.911871],
              [45.797698, 34.912211],
              [45.797286, 34.912405],
              [45.796719, 34.91238],
              [45.795592, 34.911796],
              [45.794816, 34.911699],
              [45.794449, 34.91176],
              [45.794171, 34.911854],
              [45.793938, 34.911859],
              [45.793662, 34.911791],
              [45.792912, 34.911703],
              [45.792188, 34.911795],
              [45.791625, 34.911916],
              [45.791121, 34.91183],
              [45.790552, 34.911688],
              [45.789945, 34.911709],
              [45.789475, 34.912008],
              [45.789303, 34.912178],
              [45.78882, 34.912322],
              [45.788431, 34.912296],
              [45.78826, 34.9116462],
              [45.7889698, 34.9097008],
              [45.7895676, 34.90846],
              [45.7897917, 34.9076787],
              [45.7900346, 34.9059936],
              [45.7904829, 34.9044463],
              [45.7899038, 34.9038029],
              [45.7905576, 34.9013058],
              [45.790782, 34.900229],
              [45.790917, 34.899747],
              [45.791163, 34.899595],
              [45.791116, 34.899073],
              [45.791187, 34.898737],
              [45.79142, 34.898408],
              [45.791758, 34.897871],
              [45.792088, 34.89739],
              [45.792171, 34.896926],
              [45.792099, 34.89657],
              [45.792365, 34.895804],
              [45.792545, 34.895016],
              [45.792871, 34.894347],
              [45.793134, 34.893572],
              [45.793346, 34.893337],
              [45.793453, 34.892877],
              [45.793634, 34.892567],
              [45.793733, 34.892252],
              [45.793871, 34.891176],
              [45.793934, 34.890724],
              [45.793985, 34.8904],
              [45.793866, 34.890079],
              [45.793715, 34.889683],
              [45.793922, 34.889341],
              [45.794191, 34.888718],
              [45.794466, 34.888246],
              [45.794439, 34.887712],
              [45.794364, 34.887257],
              [45.794199, 34.88672],
              [45.794395, 34.886038],
              [45.794791, 34.885851],
              [45.794951, 34.885589],
              [45.79513, 34.884541],
              [45.795419, 34.884292],
              [45.795581, 34.883867],
              [45.79588, 34.883617],
              [45.796109, 34.882668],
              [45.796045, 34.882167],
              [45.79629, 34.881539],
              [45.796383, 34.880983],
              [45.796195, 34.880449],
              [45.796261, 34.880006],
              [45.796396, 34.879181],
              [45.796531, 34.878654],
              [45.796701, 34.87839],
              [45.796982, 34.878026],
              [45.796949, 34.877555],
              [45.797067, 34.876923],
              [45.797431, 34.87657],
              [45.797512, 34.876142],
              [45.797723, 34.875646],
              [45.797964, 34.875172],
              [45.798022, 34.874658],
              [45.798038, 34.8739],
              [45.797845, 34.87326],
              [45.797971, 34.872914],
              [45.798204, 34.872414],
              [45.798052, 34.871712],
              [45.797807, 34.871135],
              [45.797894, 34.870858],
              [45.797775, 34.86998],
              [45.797893, 34.869303],
              [45.797871, 34.868398],
              [45.797825, 34.867795],
              [45.797816, 34.866771],
              [45.797735, 34.86612],
              [45.797716, 34.865188],
              [45.797622, 34.864791],
              [45.797656, 34.864227],
              [45.797426, 34.863791],
              [45.797644, 34.863366],
              [45.797939, 34.862234],
              [45.79774, 34.861874],
              [45.797186, 34.861207],
              [45.796913, 34.860913],
              [45.796751, 34.860088],
              [45.796651, 34.859278],
              [45.796356, 34.858943],
              [45.796315, 34.858357],
              [45.795935, 34.857615],
              [45.795986, 34.857291],
              [45.795752, 34.856882],
              [45.795173, 34.856211],
              [45.794597, 34.855809],
              [45.793831, 34.855162],
              [45.793461, 34.854805],
              [45.793041, 34.854384],
              [45.792569, 34.85364],
              [45.792074, 34.853026],
              [45.791532, 34.852537],
              [45.791054, 34.852073],
              [45.790518, 34.851646],
              [45.789429, 34.850777],
              [45.787894, 34.850382],
              [45.787209, 34.849999],
              [45.786707, 34.849575],
              [45.786506, 34.849206],
              [45.786083, 34.848687],
              [45.784851, 34.848401],
              [45.784427, 34.848224],
              [45.783909, 34.84774],
              [45.783184, 34.847463],
              [45.78281, 34.847089],
              [45.782425, 34.846329],
              [45.781915, 34.8457],
              [45.781299, 34.845017],
              [45.780314, 34.844282],
              [45.779676, 34.843559],
              [45.779056, 34.842733],
              [45.778639, 34.84224],
              [45.778273, 34.841981],
              [45.778091, 34.841338],
              [45.777718, 34.841008],
              [45.777125, 34.840241],
              [45.7769, 34.839912],
              [45.776809, 34.839136],
              [45.776367, 34.838809],
              [45.7761853, 34.8381219],
              [45.77595, 34.837885],
              [45.775825, 34.837457],
              [45.775507, 34.836992],
              [45.775255, 34.836686],
              [45.774805, 34.836198],
              [45.774364, 34.835746],
              [45.77384, 34.835667],
              [45.773193, 34.835557],
              [45.773108, 34.835149],
              [45.772402, 34.83495],
              [45.771779, 34.835015],
              [45.771355, 34.835269],
              [45.770807, 34.835413],
              [45.769886, 34.835575],
              [45.768689, 34.835513],
              [45.768116, 34.835161],
              [45.767934, 34.834768],
              [45.767866, 34.834554],
              [45.767678, 34.834313],
              [45.767025, 34.834098],
              [45.764366, 34.832868],
              [45.762188, 34.832648],
              [45.760078, 34.832209],
              [45.75886, 34.832065],
              [45.758165, 34.832083],
              [45.75756, 34.832049],
              [45.757145, 34.831423],
              [45.756527, 34.831032],
              [45.756108, 34.830653],
              [45.755812, 34.830309],
              [45.755617, 34.830089],
              [45.755236, 34.829505],
              [45.754962, 34.829204],
              [45.754581, 34.829016],
              [45.753623, 34.828685],
              [45.752932, 34.82876],
              [45.752077, 34.828825],
              [45.751136, 34.828906],
              [45.750382, 34.828964],
              [45.749524, 34.828794],
              [45.748259, 34.828769],
              [45.747247, 34.828956],
              [45.747244, 34.828957],
              [45.736536, 34.831227],
              [45.736536, 34.831228],
              [45.736322, 34.831555],
              [45.736163, 34.831914],
              [45.736097, 34.832584],
              [45.735962, 34.833656],
              [45.735947, 34.834043],
              [45.736095, 34.834474],
              [45.73619, 34.835009],
              [45.736197, 34.835783],
              [45.736078, 34.836587],
              [45.735993, 34.837153],
              [45.735908, 34.837749],
              [45.736307, 34.838703],
              [45.736452, 34.839605],
              [45.736632, 34.840591],
              [45.736914, 34.841491],
              [45.737233, 34.842843],
              [45.73738, 34.843998],
              [45.73735, 34.844422],
              [45.737353, 34.844788],
              [45.73739, 34.845098],
              [45.737053, 34.845608],
              [45.736852, 34.846089],
              [45.73689, 34.846417],
              [45.736542, 34.845895],
              [45.736132, 34.845427],
              [45.735976, 34.844796],
              [45.735975, 34.844162],
              [45.736054, 34.84342],
              [45.735884, 34.842814],
              [45.735771, 34.841935],
              [45.735827, 34.841477],
              [45.735699, 34.840647],
              [45.735665, 34.840239],
              [45.735533, 34.839966],
              [45.735386, 34.839823],
              [45.735044, 34.83966],
              [45.734668, 34.839625],
              [45.734367, 34.839503],
              [45.733885, 34.839419],
              [45.733643, 34.83926],
              [45.733508, 34.839273],
              [45.733312, 34.839225],
              [45.733206, 34.839077],
              [45.732679, 34.838956],
              [45.732348, 34.838908],
              [45.731628, 34.839024],
              [45.731146, 34.838965],
              [45.731085, 34.838879],
              [45.730663, 34.838745],
              [45.730497, 34.838622],
              [45.730226, 34.838599],
              [45.729881, 34.838576],
              [45.72955, 34.838578],
              [45.729401, 34.83874],
              [45.729475, 34.838905],
              [45.729447, 34.839048],
              [45.729275, 34.839192],
              [45.729015, 34.839241],
              [45.728783, 34.839171],
              [45.728523, 34.839268],
              [45.728351, 34.83946],
              [45.728092, 34.839557],
              [45.727773, 34.839511],
              [45.727163, 34.839252],
              [45.727045, 34.838991],
              [45.727043, 34.838728],
              [45.726925, 34.838514],
              [45.72649, 34.838397],
              [45.725996, 34.838138],
              [45.72556, 34.83795],
              [45.724953, 34.837953],
              [45.724635, 34.838075],
              [45.724403, 34.838004],
              [45.724171, 34.83791],
              [45.723939, 34.837864],
              [45.723853, 34.837936],
              [45.723621, 34.837961],
              [45.723387, 34.837653],
              [45.723154, 34.837511],
              [45.722895, 34.837584],
              [45.722546, 34.837419],
              [45.722373, 34.837515],
              [45.722521, 34.837849],
              [45.722369, 34.838006],
              [45.714734, 34.830856],
              [45.71363, 34.83029],
              [45.712986, 34.829483],
              [45.711677, 34.828631],
              [45.703344, 34.825292],
              [45.699191, 34.824222],
              [45.698577, 34.823511],
              [45.696957, 34.822559],
              [45.696912, 34.822065],
              [45.696639, 34.821208],
              [45.695421, 34.820544],
              [45.69479, 34.819794],
              [45.694063, 34.819115],
              [45.693804, 34.818615],
              [45.693469, 34.817885],
              [45.693146, 34.817502],
              [45.69281, 34.81706],
              [45.69224, 34.816237],
              [45.691683, 34.815564],
              [45.691121, 34.81551],
              [45.690435, 34.815604],
              [45.689876, 34.815711],
              [45.689538, 34.815161],
              [45.689365, 34.8146],
              [45.689303, 34.813786],
              [45.689137, 34.812911],
              [45.689001, 34.812262],
              [45.689008, 34.81175],
              [45.689184, 34.811442],
              [45.689656, 34.811099],
              [45.690312, 34.810823],
              [45.690749, 34.810719],
              [45.691018, 34.810573],
              [45.691153, 34.810128],
              [45.691304, 34.809511],
              [45.691628, 34.808961],
              [45.691734, 34.808539],
              [45.691802, 34.808151],
              [45.691943, 34.807732],
              [45.691845, 34.807453],
              [45.691862, 34.807083],
              [45.691996, 34.806683],
              [45.691952, 34.806243],
              [45.692038, 34.805833],
              [45.691944, 34.805124],
              [45.691832, 34.804633],
              [45.691781, 34.804212],
              [45.691656, 34.803615],
              [45.69174, 34.803144],
              [45.691762, 34.802647],
              [45.692019, 34.802297],
              [45.692463, 34.801933],
              [45.692613, 34.801557],
              [45.692777, 34.801044],
              [45.693018, 34.800724],
              [45.693203, 34.80045],
              [45.693419, 34.800018],
              [45.69352, 34.799624],
              [45.693676, 34.799372],
              [45.694123, 34.79907],
              [45.694448, 34.799201],
              [45.694839, 34.79967],
              [45.69508, 34.799995],
              [45.695803, 34.800023],
              [45.696475, 34.800068],
              [45.697062, 34.800042],
              [45.69733, 34.799483],
              [45.697676, 34.798961],
              [45.698116, 34.798671],
              [45.698523, 34.798387],
              [45.698546, 34.797913],
              [45.69838, 34.797532],
              [45.698493, 34.797103],
              [45.698755, 34.796733],
              [45.699069, 34.796089],
              [45.699537, 34.795521],
              [45.699827, 34.795086],
              [45.700136, 34.794767],
              [45.700642, 34.794431],
              [45.700753, 34.794079],
              [45.700951, 34.793507],
              [45.701006, 34.792942],
              [45.701166, 34.792393],
              [45.70164, 34.791892],
              [45.701977, 34.791509],
              [45.702165, 34.791024],
              [45.703093, 34.790503],
              [45.703631, 34.790119],
              [45.70402, 34.789633],
              [45.703809, 34.789209],
              [45.703547, 34.788759],
              [45.702956, 34.788163],
              [45.702115, 34.7879],
              [45.701418, 34.787629],
              [45.700942, 34.787302],
              [45.700551, 34.786961],
              [45.700275, 34.786411],
              [45.700096, 34.786024],
              [45.699862, 34.785596],
              [45.699414, 34.785554],
              [45.699012, 34.785513],
              [45.698162, 34.784996],
              [45.697499, 34.7846],
              [45.697184, 34.784032],
              [45.696918, 34.783651],
              [45.696518, 34.783576],
              [45.695982, 34.783669],
              [45.695567, 34.783751],
              [45.695212, 34.783505],
              [45.69486, 34.783225],
              [45.6944, 34.783092],
              [45.693756, 34.782897],
              [45.693283, 34.782843],
              [45.692806, 34.782773],
              [45.692869, 34.78254],
              [45.693362, 34.78224],
              [45.693793, 34.781918],
              [45.694124, 34.781424],
              [45.694459, 34.780862],
              [45.694833, 34.780361],
              [45.69532, 34.779952],
              [45.695938, 34.779358],
              [45.69647, 34.779034],
              [45.696879, 34.778672],
              [45.697267, 34.777965],
              [45.697618, 34.776904],
              [45.69791, 34.775957],
              [45.698113, 34.775316],
              [45.698772, 34.772848],
              [45.69876, 34.77002],
              [45.69774, 34.768675],
              [45.695866, 34.769858],
              [45.695024, 34.770697],
              [45.691336, 34.770762],
              [45.690301, 34.770311],
              [45.689902, 34.769203],
              [45.689245, 34.768353],
              [45.68831, 34.767723],
              [45.685778, 34.766807],
              [45.684417, 34.766089],
              [45.681982, 34.764773],
              [45.680427, 34.763909],
              [45.678303, 34.762538],
              [45.678033, 34.761672],
              [45.677687, 34.759991],
              [45.677092, 34.757696],
              [45.676851, 34.756552],
              [45.676161, 34.755921],
              [45.675925, 34.755399],
              [45.676349, 34.754616],
              [45.676562, 34.75393],
              [45.675838, 34.752563],
              [45.675393, 34.751667],
              [45.675072, 34.750127],
              [45.674665, 34.748166],
              [45.674281, 34.747508],
              [45.673629, 34.747067],
              [45.673355, 34.74644],
              [45.673206, 34.745305],
              [45.672843, 34.743516],
              [45.672406, 34.741962],
              [45.671867, 34.741091],
              [45.671586, 34.739792],
              [45.671526, 34.738266],
              [45.671174, 34.737209],
              [45.670295, 34.736842],
              [45.668881, 34.73644],
              [45.667636, 34.735436],
              [45.666274, 34.734326],
              [45.665828, 34.733166],
              [45.665262, 34.731762],
              [45.664527, 34.730482],
              [45.663802, 34.729541],
              [45.6629, 34.728828],
              [45.662093, 34.728474],
              [45.661453, 34.728338],
              [45.660325, 34.728219],
              [45.659447, 34.727895],
              [45.658598, 34.727428],
              [45.657437, 34.727136],
              [45.656871, 34.726594],
              [45.656191, 34.725655],
              [45.655791, 34.725366],
              [45.654705, 34.72489],
              [45.653868, 34.724208],
              [45.653259, 34.72311],
              [45.654146, 34.722776],
              [45.654645, 34.722629],
              [45.655151, 34.722464],
              [45.655282, 34.72198],
              [45.655153, 34.721568],
              [45.655334, 34.721015],
              [45.655827, 34.720801],
              [45.656375, 34.720757],
              [45.656868, 34.720713],
              [45.657091, 34.720538],
              [45.657058, 34.719937],
              [45.657217, 34.719559],
              [45.657298, 34.719136],
              [45.657549, 34.718853],
              [45.657854, 34.718432],
              [45.658188, 34.718255],
              [45.658837, 34.718295],
              [45.659606, 34.718109],
              [45.660235, 34.718205],
              [45.660637, 34.71816],
              [45.661057, 34.717967],
              [45.661401, 34.717352],
              [45.661839, 34.717096],
              [45.662498, 34.717007],
              [45.662636, 34.716675],
              [45.662769, 34.716413],
              [45.662987, 34.715786],
              [45.663343, 34.715476],
              [45.663753, 34.715371],
              [45.664375, 34.715484],
              [45.665058, 34.71557],
              [45.665685, 34.716049],
              [45.666548, 34.715924],
              [45.667083, 34.715139],
              [45.667854, 34.71427],
              [45.668478, 34.7137],
              [45.669367, 34.713417],
              [45.66944, 34.712747],
              [45.669947, 34.712027],
              [45.670793, 34.711836],
              [45.671307, 34.711661],
              [45.671838, 34.711423],
              [45.672028, 34.710861],
              [45.67213, 34.710476],
              [45.672655, 34.710128],
              [45.672926, 34.709663],
              [45.673656, 34.709373],
              [45.674287, 34.708955],
              [45.674833, 34.70886],
              [45.675607, 34.708998],
              [45.675803, 34.709408],
              [45.676198, 34.709723],
              [45.677188, 34.710002],
              [45.677799, 34.709853],
              [45.678304, 34.709688],
              [45.67875, 34.70955],
              [45.679617, 34.709613],
              [45.679932, 34.709361],
              [45.680156, 34.709015],
              [45.680721, 34.708822],
              [45.681224, 34.708649],
              [45.681958, 34.708973],
              [45.682645, 34.70899],
              [45.682896, 34.708792],
              [45.683555, 34.708532],
              [45.684389, 34.708122],
              [45.684589, 34.707771],
              [45.684834, 34.707464],
              [45.685032, 34.70719],
              [45.686132, 34.707032],
              [45.68694, 34.706567],
              [45.687437, 34.706369],
              [45.68783, 34.706112],
              [45.688254, 34.706021],
              [45.688755, 34.706096],
              [45.689566, 34.705903],
              [45.690547, 34.705544],
              [45.691145, 34.70526],
              [45.691345, 34.704867],
              [45.691443, 34.704466],
              [45.691658, 34.704087],
              [45.691524, 34.703529],
              [45.691449, 34.702894],
              [45.691341, 34.70252],
              [45.691186, 34.701967],
              [45.691038, 34.701566],
              [45.690908, 34.700982],
              [45.690961, 34.700495],
              [45.69136, 34.700178],
              [45.691988, 34.699923],
              [45.69234, 34.699469],
              [45.692755, 34.698824],
              [45.692939, 34.698195],
              [45.693366, 34.697471],
              [45.694079, 34.696937],
              [45.694704, 34.696589],
              [45.695595, 34.696399],
              [45.696099, 34.696354],
              [45.696776, 34.696466],
              [45.697603, 34.696501],
              [45.698497, 34.696456],
              [45.698971, 34.696339],
              [45.699793, 34.696101],
              [45.70106, 34.695462],
              [45.702218, 34.694534],
              [45.702625, 34.693772],
              [45.703342, 34.691359],
              [45.702681, 34.690982],
              [45.702295, 34.690662],
              [45.701814, 34.690226],
              [45.701489, 34.689461],
              [45.701194, 34.688903],
              [45.700996, 34.688337],
              [45.700838, 34.687932],
              [45.700365, 34.687229],
              [45.700148, 34.686462],
              [45.700048, 34.68586],
              [45.699849, 34.68563],
              [45.699767, 34.68514],
              [45.69954, 34.684508],
              [45.699428, 34.684068],
              [45.699228, 34.683537],
              [45.699187, 34.683208],
              [45.698923, 34.682388],
              [45.698528, 34.682114],
              [45.698521, 34.681363],
              [45.698057, 34.680994],
              [45.698078, 34.680566],
              [45.697815, 34.679958],
              [45.697757, 34.679561],
              [45.697828, 34.679203],
              [45.697744, 34.678828],
              [45.697953, 34.678498],
              [45.698043, 34.678172],
              [45.698037, 34.677766],
              [45.6978, 34.677561],
              [45.697681, 34.677263],
              [45.697585, 34.676758],
              [45.697584, 34.676201],
              [45.697524, 34.675839],
              [45.697482, 34.675289],
              [45.697377, 34.67475],
              [45.697089, 34.674049],
              [45.696995, 34.673721],
              [45.69687, 34.673318],
              [45.696825, 34.67276],
              [45.696785, 34.672218],
              [45.696747, 34.671773],
              [45.696864, 34.671123],
              [45.69697, 34.670219],
              [45.696837, 34.66957],
              [45.697333, 34.66964],
              [45.697995, 34.669635],
              [45.698562, 34.669604],
              [45.699233, 34.669509],
              [45.699477, 34.669527],
              [45.699865, 34.669643],
              [45.700388, 34.669647],
              [45.700777, 34.669514],
              [45.701193, 34.669183],
              [45.701364, 34.668877],
              [45.701741, 34.668694],
              [45.702141, 34.668684],
              [45.702534, 34.668648],
              [45.703127, 34.668462],
              [45.703681, 34.668335],
              [45.704238, 34.668305],
              [45.704504, 34.668408],
              [45.704881, 34.668694],
              [45.705307, 34.668617],
              [45.705682, 34.668638],
              [45.70592, 34.668719],
              [45.706271, 34.668647],
              [45.706636, 34.668634],
              [45.707037, 34.668713],
              [45.707669, 34.669059],
              [45.708233, 34.669188],
              [45.708979, 34.669301],
              [45.709583, 34.669281],
              [45.71035, 34.669266],
              [45.711139, 34.66908],
              [45.711053, 34.668528],
              [45.711076, 34.668064],
              [45.711102, 34.667103],
              [45.710918, 34.666596],
              [45.710733, 34.666124],
              [45.710717, 34.665808],
              [45.710574, 34.665418],
              [45.710461, 34.664845],
              [45.710393, 34.664238],
              [45.710366, 34.663578],
              [45.710591, 34.663183],
              [45.710472, 34.662293],
              [45.710672, 34.661584],
              [45.710993, 34.661012],
              [45.711239, 34.660233],
              [45.711446, 34.659682],
              [45.712102, 34.658846],
              [45.712412, 34.658188],
              [45.712436, 34.657555],
              [45.712801, 34.656772],
              [45.713123, 34.656076],
              [45.713548, 34.655273],
              [45.713571, 34.654853],
              [45.713331, 34.654294],
              [45.713578, 34.653134],
              [45.713816, 34.652577],
              [45.714271, 34.65176],
              [45.71464, 34.651038],
              [45.714959, 34.650201],
              [45.715205, 34.649378],
              [45.7161267, 34.6473324],
              [45.7172459, 34.6453064],
              [45.7186319, 34.6432835],
              [45.7186867, 34.6428412],
              [45.718608, 34.642574],
              [45.718646, 34.642257],
              [45.719248, 34.641334],
              [45.71932, 34.641064],
              [45.719621, 34.640797],
              [45.719765, 34.640426],
              [45.719765, 34.639531],
              [45.719676, 34.639052],
              [45.720123, 34.638803],
              [45.72168, 34.638478],
              [45.722263, 34.638249],
              [45.72288, 34.637517],
              [45.723417, 34.637155],
              [45.723787, 34.636132],
              [45.724602, 34.635666],
              [45.724757, 34.635337],
              [45.724888, 34.632612],
              [45.724728, 34.632198],
              [45.724117, 34.631636],
              [45.72422, 34.631316],
              [45.724633, 34.630976],
              [45.725073, 34.630701],
              [45.7255099, 34.6302438],
              [45.725931, 34.629803],
              [45.726163, 34.629265],
              [45.726781, 34.628153],
              [45.72705, 34.626696],
              [45.726993, 34.625963],
              [45.727455, 34.625472],
              [45.728421, 34.624235],
              [45.728503, 34.62345],
              [45.728847, 34.62237],
              [45.729365, 34.621674],
              [45.729534, 34.620678],
              [45.729822, 34.619971],
              [45.729958, 34.619394],
              [45.729473, 34.618314],
              [45.729505, 34.616524],
              [45.729013, 34.615841],
              [45.727553, 34.615052],
              [45.726839, 34.614954],
              [45.725611, 34.614557],
              [45.724874, 34.6145],
              [45.724378, 34.614229],
              [45.724237, 34.613933],
              [45.72442, 34.613624],
              [45.725077, 34.613076],
              [45.725569, 34.612481],
              [45.726385, 34.611741],
              [45.726283, 34.611303],
              [45.726232, 34.610722],
              [45.725613, 34.610569],
              [45.72526, 34.610258],
              [45.724917, 34.609519],
              [45.724569, 34.608931],
              [45.724046, 34.608425],
              [45.722933, 34.607501],
              [45.723439, 34.607255],
              [45.72375, 34.606976],
              [45.724224, 34.606184],
              [45.724371, 34.60565],
              [45.724896, 34.605013],
              [45.725157, 34.604369],
              [45.725156, 34.603981],
              [45.725707, 34.603406],
              [45.726163, 34.603095],
              [45.726719, 34.601981],
              [45.726998, 34.601664],
              [45.726972, 34.601011],
              [45.727308, 34.60019],
              [45.728016, 34.599461],
              [45.728629, 34.598569],
              [45.729219, 34.598226],
              [45.729454, 34.597909],
              [45.729324, 34.597528],
              [45.729077, 34.595974],
              [45.729285, 34.595549],
              [45.729757, 34.594876],
              [45.729984, 34.594186],
              [45.731064, 34.591965],
              [45.73129, 34.591395],
              [45.731724, 34.590707],
              [45.731843, 34.590148],
              [45.732437, 34.590118],
              [45.733202, 34.589947],
              [45.733825, 34.589733],
              [45.734593, 34.589575],
              [45.73573, 34.589659],
              [45.736833, 34.589824],
              [45.737044, 34.589667],
              [45.737208, 34.589369],
              [45.737188, 34.589037],
              [45.737556, 34.588472],
              [45.737817, 34.588209],
              [45.737788, 34.587968],
              [45.738119, 34.587641],
              [45.739151, 34.586847],
              [45.739377, 34.586621],
              [45.739509, 34.586202],
              [45.739826, 34.585818],
              [45.739942, 34.585334],
              [45.739882, 34.584971],
              [45.739723, 34.584738],
              [45.739642, 34.584334],
              [45.739832, 34.584099],
              [45.739963, 34.583673],
              [45.740056, 34.582798],
              [45.740061, 34.582565],
              [45.739979, 34.582244],
              [45.739806, 34.581871],
              [45.73987, 34.580926],
              [45.740291, 34.58027],
              [45.740793, 34.57933],
              [45.740226, 34.577974],
              [45.7394, 34.577312],
              [45.739147, 34.57667],
              [45.739144, 34.576274],
              [45.739346, 34.574932],
              [45.739507, 34.574411],
              [45.740124, 34.573324],
              [45.741249, 34.570811],
              [45.740924, 34.570398],
              [45.740407, 34.570257],
              [45.740048, 34.570007],
              [45.73999, 34.569487],
              [45.740377, 34.567799],
              [45.739996, 34.566402],
              [45.739501, 34.566093],
              [45.739036, 34.565689],
              [45.738243, 34.565112],
              [45.736843, 34.56426],
              [45.736266, 34.563585],
              [45.736351, 34.563324],
              [45.736192, 34.562747],
              [45.736108, 34.562037],
              [45.735494, 34.561391],
              [45.735019, 34.560735],
              [45.735042, 34.559588],
              [45.734617, 34.558319],
              [45.734671, 34.558018],
              [45.734969, 34.557563],
              [45.735844, 34.556542],
              [45.735993, 34.556061],
              [45.73596, 34.555633],
              [45.736011, 34.555281],
              [45.736268, 34.55484],
              [45.736015, 34.554237],
              [45.73659, 34.554136],
              [45.738862, 34.554027],
              [45.739382, 34.554092],
              [45.740059, 34.5541],
              [45.74036, 34.553969],
              [45.740512, 34.553649],
              [45.740614, 34.553231],
              [45.740519, 34.553017],
              [45.740595, 34.552761],
              [45.741119, 34.55237],
              [45.741461, 34.552294],
              [45.741868, 34.552051],
              [45.742121, 34.551743],
              [45.742445, 34.551486],
              [45.742489, 34.551313],
              [45.742464, 34.551098],
              [45.742634, 34.550863],
              [45.74268, 34.550515],
              [45.742787, 34.550263],
              [45.742757, 34.550074],
              [45.742896, 34.549835],
              [45.743302, 34.54954],
              [45.74335, 34.549297],
              [45.743222, 34.549061],
              [45.742935, 34.548875],
              [45.7428, 34.548658],
              [45.742844, 34.548485],
              [45.743103, 34.548062],
              [45.743131, 34.547243],
              [45.742629, 34.546641],
              [45.742579, 34.546403],
              [45.742778, 34.545735],
              [45.742861, 34.544943],
              [45.742732, 34.544751],
              [45.742217, 34.544423],
              [45.742171, 34.544298],
              [45.741914, 34.544064],
              [45.741357, 34.544013],
              [45.741306, 34.543862],
              [45.741336, 34.54363],
              [45.741236, 34.543531],
              [45.74094, 34.543398],
              [45.740951, 34.54316],
              [45.741114, 34.542944],
              [45.740988, 34.542769],
              [45.741039, 34.541912],
              [45.741226, 34.541762],
              [45.741096, 34.541422],
              [45.741291, 34.541219],
              [45.741726, 34.541016],
              [45.741813, 34.540478],
              [45.741955, 34.540256],
              [45.742248, 34.539994],
              [45.742191, 34.539766],
              [45.742223, 34.53949],
              [45.7422938, 34.5393909],
              [45.7425982, 34.5393209],
              [45.7427822, 34.539076],
              [45.7428954, 34.5388486],
              [45.7428388, 34.5385396],
              [45.7428176, 34.5381781],
              [45.7432041, 34.5380347],
              [45.7426762, 34.5377686],
              [45.742296, 34.5374417],
              [45.7414572, 34.536784],
              [45.74081, 34.5365206],
              [45.7397196, 34.5366499],
              [45.7392389, 34.5369997],
              [45.7386905, 34.5372151],
              [45.7377752, 34.5373275],
              [45.736963, 34.538043],
              [45.7365564, 34.5382639],
              [45.7353459, 34.5383048],
              [45.7343163, 34.5383247],
              [45.7333639, 34.5386801],
              [45.7328204, 34.5387085],
              [45.7323073, 34.5385263],
              [45.7321071, 34.538174],
              [45.7323856, 34.5368448],
              [45.7322943, 34.5365251],
              [45.7320281, 34.5362182],
              [45.7314194, 34.5359897],
              [45.730986, 34.536032],
              [45.7304288, 34.5365763],
              [45.7298303, 34.5369666],
              [45.7286656, 34.5374361],
              [45.7277437, 34.5375839],
              [45.7272402, 34.5377779],
              [45.7266772, 34.5378974],
              [45.7255415, 34.5376321],
              [45.7251787, 34.5371937],
              [45.7243827, 34.537125],
              [45.7242213, 34.5372235],
              [45.7243052, 34.5375501],
              [45.7239732, 34.5385247],
              [45.7236689, 34.5386284],
              [45.7234353, 34.538493],
              [45.7231442, 34.538493],
              [45.7228471, 34.5385826],
              [45.7224373, 34.5392113],
              [45.7219062, 34.5395655],
              [45.7214026, 34.5397655],
              [45.7211249, 34.5395875],
              [45.7210407, 34.5390674],
              [45.7206826, 34.5383334],
              [45.7201771, 34.5379233],
              [45.7191265, 34.5379626],
              [45.717977, 34.5378626],
              [45.717439, 34.5379857],
              [45.7173479, 34.5382055],
              [45.7176524, 34.5386042],
              [45.7178173, 34.5390117],
              [45.7180615, 34.5394904],
              [45.7179421, 34.5399215],
              [45.7172251, 34.5401548],
              [45.7164075, 34.5399729],
              [45.7154265, 34.5402336],
              [45.7141487, 34.5409623],
              [45.7138896, 34.5409869],
              [45.7130535, 34.5404319],
              [45.7127489, 34.540489],
              [45.712347, 34.5408325],
              [45.7122792, 34.5411862],
              [45.7124035, 34.5416471],
              [45.712913, 34.5422293],
              [45.7129311, 34.5426398],
              [45.7126801, 34.5428705],
              [45.7112035, 34.5429189],
              [45.7108098, 34.5428231],
              [45.7105053, 34.5424639],
              [45.7101654, 34.5423414],
              [45.7095065, 34.5426595],
              [45.7090166, 34.5435316],
              [45.7090091, 34.5438887],
              [45.7092398, 34.544142],
              [45.7099924, 34.5440839],
              [45.7106679, 34.5441825],
              [45.7113071, 34.544709],
              [45.7115886, 34.5454187],
              [45.7114369, 34.5458014],
              [45.7110988, 34.5458341],
              [45.710571, 34.545687],
              [45.7096785, 34.5458183],
              [45.7088634, 34.5459913],
              [45.707879, 34.5455552],
              [45.7072125, 34.5454605],
              [45.7065829, 34.5458754],
              [45.7061685, 34.5461053],
              [45.7057069, 34.5461711],
              [45.7051208, 34.5459332],
              [45.7047217, 34.5459197],
              [45.7043702, 34.5457813],
              [45.7041461, 34.5459062],
              [45.7039442, 34.5463794],
              [45.7038568, 34.5468898],
              [45.7039717, 34.5476603],
              [45.703625, 34.5485607],
              [45.7022671, 34.5487635],
              [45.7004422, 34.5475052],
              [45.6986244, 34.5487834],
              [45.699807, 34.5500806],
              [45.6996863, 34.5510584],
              [45.698138, 34.5510927],
              [45.6963779, 34.5507303],
              [45.695761, 34.5516077],
              [45.6952435, 34.5530734],
              [45.6936972, 34.5536396],
              [45.6930309, 34.5553035],
              [45.6919256, 34.5556208],
              [45.6907058, 34.5554687],
              [45.6905467, 34.5548885],
              [45.690065, 34.5540712],
              [45.6892219, 34.5544905],
              [45.688314, 34.5553067],
              [45.6875762, 34.5577667],
              [45.6867666, 34.5576097],
              [45.6855937, 34.5569901],
              [45.6851885, 34.5553066],
              [45.6840868, 34.5554038],
              [45.6837179, 34.5559185],
              [45.684416, 34.557639],
              [45.6842883, 34.5589611],
              [45.6834717, 34.5595769],
              [45.6823506, 34.5596119],
              [45.6815102, 34.5580565],
              [45.6805563, 34.5557869],
              [45.6794479, 34.5555679],
              [45.6774207, 34.5566574],
              [45.6761859, 34.5567683],
              [45.6756651, 34.5562535],
              [45.6748715, 34.5555581],
              [45.6740335, 34.5543865],
              [45.67423, 34.5536803],
              [45.6736179, 34.5529914],
              [45.6705671, 34.5520556],
              [45.6680598, 34.5539436],
              [45.666198, 34.5537395],
              [45.6653199, 34.5527091],
              [45.665688, 34.5515963],
              [45.664375, 34.5503217],
              [45.6636097, 34.5513031],
              [45.66226, 34.5522206],
              [45.6609211, 34.554262],
              [45.6597047, 34.5547528],
              [45.657542, 34.5544739],
              [45.6558199, 34.5556087],
              [45.6546552, 34.5551674],
              [45.6550982, 34.5535386],
              [45.6535262, 34.5532732],
              [45.6524696, 34.5546524],
              [45.652774, 34.5557091],
              [45.6519474, 34.5562007],
              [45.6509342, 34.5561619],
              [45.6509072, 34.5553487],
              [45.6504663, 34.5547676],
              [45.6512297, 34.5536216],
              [45.6510563, 34.5527646],
              [45.650118, 34.5531428],
              [45.6486595, 34.553124],
              [45.6486368, 34.5523022],
              [45.647851, 34.5508817],
              [45.645982, 34.5514907],
              [45.6454071, 34.5522124],
              [45.6420566, 34.5533341],
              [45.6410926, 34.5535475],
              [45.6405311, 34.5538345],
              [45.6417839, 34.5562305],
              [45.6406887, 34.5587559],
              [45.6398941, 34.5589125],
              [45.639254, 34.5579146],
              [45.6395831, 34.557025],
              [45.6382128, 34.5565326],
              [45.6365871, 34.5561848],
              [45.6357365, 34.5564363],
              [45.6352733, 34.5577808],
              [45.6337133, 34.5590105],
              [45.6327033, 34.5583677],
              [45.6320862, 34.5567482],
              [45.6326708, 34.5542848],
              [45.6322472, 34.5520519],
              [45.6311593, 34.5511732],
              [45.6295913, 34.5507107],
              [45.6292485, 34.5497965],
              [45.6276892, 34.5488034],
              [45.6262052, 34.5493058],
              [45.626222, 34.5505837],
              [45.6254844, 34.5531871],
              [45.6246502, 34.5533796],
              [45.6227966, 34.5507319],
              [45.6184235, 34.5502564],
              [45.6162405, 34.5517052],
              [45.6152564, 34.5519318],
              [45.6146702, 34.55141],
              [45.6132364, 34.5510586],
              [45.6093555, 34.5509068],
              [45.607493, 34.5486058],
              [45.6000944, 34.5518117],
              [45.5976611, 34.5495531],
              [45.594687, 34.5498888],
              [45.5942279, 34.5528078],
              [45.5953848, 34.5536852],
              [45.5949585, 34.5547326],
              [45.5941011, 34.5554192],
              [45.5937703, 34.5554888],
              [45.5930173, 34.5556471],
              [45.5921144, 34.5556113],
              [45.5915347, 34.5555952],
              [45.5911309, 34.5556033],
              [45.5907759, 34.5556489],
              [45.5906248, 34.5556993],
              [45.5904796, 34.5558018],
              [45.5896967, 34.5565777],
              [45.5895583, 34.5573373],
              [45.5890049, 34.5577884],
              [45.5887616, 34.5587258],
              [45.5878749, 34.5586335],
              [45.5877366, 34.5584008],
              [45.5847833, 34.5568105],
              [45.581821, 34.5577919],
              [45.5816794, 34.5591738],
              [45.5804821, 34.5596686],
              [45.5790787, 34.5577283],
              [45.5771432, 34.5587497],
              [45.5763397, 34.5611986],
              [45.5744696, 34.5621214],
              [45.5752635, 34.5653939],
              [45.5735598, 34.5657402],
              [45.5718046, 34.5628847],
              [45.5658393, 34.5658816],
              [45.5665174, 34.5702177],
              [45.565501, 34.5733499],
              [45.5626164, 34.57461],
              [45.5597454, 34.5738432],
              [45.5581575, 34.5762143],
              [45.5604191, 34.5793838],
              [45.5558014, 34.5799633],
              [45.5545397, 34.5823836],
              [45.5587111, 34.5833976],
              [45.5539475, 34.5887362],
              [45.5569129, 34.5901599],
              [45.5562134, 34.5924457],
              [45.5539775, 34.5916862],
              [45.551364, 34.593442],
              [45.5467776, 34.5940018],
              [45.5432429, 34.5966241],
              [45.5403847, 34.5949532],
              [45.5372647, 34.5921481],
              [45.5338101, 34.5937874],
              [45.5347113, 34.5965181],
              [45.5371617, 34.5984293],
              [45.5375265, 34.6005488],
              [45.5352821, 34.6023115],
              [45.5314626, 34.6018982],
              [45.531175, 34.60147],
              [45.530931, 34.601323],
              [45.530469, 34.601127],
              [45.530239, 34.600863],
              [45.52989, 34.600833],
              [45.529725, 34.600486],
              [45.529817, 34.600299],
              [45.529646, 34.600158],
              [45.529644, 34.600086],
              [45.52957, 34.600012],
              [45.529269, 34.600019],
              [45.529074, 34.599875],
              [45.529041, 34.599702],
              [45.529097, 34.599559],
              [45.528963, 34.599336],
              [45.529045, 34.599253],
              [45.52904, 34.59917],
              [45.528934, 34.598946],
              [45.528836, 34.598902],
              [45.528922, 34.598667],
              [45.528872, 34.5986],
              [45.528666, 34.59856],
              [45.528643, 34.598446],
              [45.528675, 34.598341],
              [45.529194, 34.59825],
              [45.529139, 34.598161],
              [45.529166, 34.5981],
              [45.529315, 34.598089],
              [45.52956, 34.598175],
              [45.529833, 34.598077],
              [45.529972, 34.59784],
              [45.530131, 34.597763],
              [45.53076, 34.597022],
              [45.530463, 34.596584],
              [45.530611, 34.595935],
              [45.530473, 34.59578],
              [45.53041, 34.595404],
              [45.530426, 34.595321],
              [45.530711, 34.595355],
              [45.530791, 34.595329],
              [45.530752, 34.595028],
              [45.530821, 34.594895],
              [45.530979, 34.594795],
              [45.530893, 34.59465],
              [45.530558, 34.594629],
              [45.530537, 34.594485],
              [45.530546, 34.594248],
              [45.530667, 34.593957],
              [45.530782, 34.593857],
              [45.530896, 34.593837],
              [45.530943, 34.593767],
              [45.530653, 34.593439],
              [45.530636, 34.593289],
              [45.530898, 34.593042],
              [45.530882, 34.592958],
              [45.530689, 34.59282],
              [45.530676, 34.592705],
              [45.531059, 34.592402],
              [45.531026, 34.592146],
              [45.531062, 34.59201],
              [45.531375, 34.591773],
              [45.531174, 34.591645],
              [45.531, 34.591603],
              [45.530965, 34.591507],
              [45.531067, 34.591379],
              [45.531269, 34.591279],
              [45.531342, 34.591118],
              [45.531409, 34.590874],
              [45.531381, 34.59072],
              [45.531465, 34.590142],
              [45.531568, 34.589972],
              [45.531499, 34.589768],
              [45.531314, 34.589679],
              [45.531294, 34.58958],
              [45.531543, 34.58941],
              [45.531486, 34.589231],
              [45.531521, 34.589156],
              [45.531765, 34.58909],
              [45.531696, 34.58895],
              [45.531142, 34.588862],
              [45.531282, 34.588602],
              [45.531432, 34.588556],
              [45.531814, 34.588584],
              [45.532093, 34.588425],
              [45.532108, 34.588339],
              [45.532007, 34.58828],
              [45.531481, 34.588198],
              [45.531099, 34.587425],
              [45.530974, 34.586919],
              [45.530923, 34.586867],
              [45.530239, 34.586798],
              [45.530081, 34.586689],
              [45.530061, 34.586612],
              [45.530134, 34.586474],
              [45.530372, 34.586303],
              [45.530356, 34.586219],
              [45.530191, 34.586084],
              [45.53028, 34.585776],
              [45.530118, 34.585611],
              [45.529376, 34.585125],
              [45.529278, 34.584747],
              [45.528715, 34.584516],
              [45.52863, 34.584417],
              [45.52863, 34.584037],
              [45.528429, 34.583673],
              [45.52857, 34.583443],
              [45.528531, 34.583355],
              [45.528359, 34.583298],
              [45.528346, 34.583141],
              [45.528467, 34.582872],
              [45.528411, 34.582783],
              [45.528026, 34.582802],
              [45.527872, 34.582897],
              [45.527888, 34.583111],
              [45.52777, 34.583177],
              [45.527586, 34.583202],
              [45.527428, 34.582755],
              [45.52761, 34.582533],
              [45.52761, 34.582385],
              [45.527353, 34.582122],
              [45.527177, 34.58148],
              [45.527153, 34.58126],
              [45.527297, 34.581125],
              [45.527232, 34.581019],
              [45.527054, 34.580894],
              [45.526883, 34.580863],
              [45.526802, 34.580505],
              [45.527271, 34.580472],
              [45.527514, 34.580578],
              [45.527669, 34.580524],
              [45.527775, 34.580327],
              [45.527769, 34.580176],
              [45.52732, 34.579905],
              [45.527121, 34.57972],
              [45.527099, 34.579401],
              [45.527003, 34.57922],
              [45.526749, 34.579033],
              [45.526532, 34.578733],
              [45.526523, 34.578214],
              [45.52639, 34.578161],
              [45.525973, 34.578246],
              [45.525851, 34.57813],
              [45.525364, 34.577923],
              [45.525179, 34.577751],
              [45.524626, 34.577517],
              [45.524313, 34.577185],
              [45.52421, 34.577229],
              [45.524127, 34.577453],
              [45.524136, 34.577527],
              [45.524348, 34.577699],
              [45.524326, 34.577806],
              [45.524091, 34.577862],
              [45.523983, 34.577797],
              [45.523882, 34.57745],
              [45.523779, 34.577343],
              [45.523698, 34.577091],
              [45.523511, 34.576828],
              [45.523202, 34.576487],
              [45.522937, 34.576427],
              [45.522834, 34.576324],
              [45.522891, 34.575995],
              [45.522951, 34.575912],
              [45.52289, 34.575611],
              [45.52292, 34.575454],
              [45.523009, 34.575316],
              [45.5231, 34.575266],
              [45.523098, 34.575153],
              [45.522847, 34.57479],
              [45.52281, 34.574626],
              [45.522888, 34.574422],
              [45.523027, 34.574329],
              [45.523172, 34.574323],
              [45.523338, 34.574423],
              [45.523554, 34.574438],
              [45.523745, 34.574423],
              [45.52378, 34.574368],
              [45.523731, 34.574285],
              [45.523583, 34.574194],
              [45.523142, 34.574039],
              [45.523061, 34.573784],
              [45.523084, 34.573495],
              [45.522775, 34.57337],
              [45.522642, 34.573147],
              [45.522492, 34.573025],
              [45.522554, 34.572908],
              [45.52272, 34.572837],
              [45.522872, 34.572837],
              [45.523021, 34.572909],
              [45.523152, 34.573042],
              [45.523599, 34.573116],
              [45.523722, 34.573067],
              [45.523701, 34.572965],
              [45.523561, 34.572841],
              [45.523395, 34.572783],
              [45.523409, 34.572606],
              [45.523324, 34.57228],
              [45.52334, 34.572177],
              [45.523474, 34.571988],
              [45.523395, 34.571912],
              [45.523264, 34.571905],
              [45.522847, 34.572059],
              [45.522703, 34.572022],
              [45.522646, 34.571924],
              [45.522318, 34.571839],
              [45.522235, 34.571749],
              [45.522193, 34.571401],
              [45.521986, 34.571368],
              [45.521945, 34.571274],
              [45.522033, 34.570807],
              [45.522148, 34.57069],
              [45.522383, 34.570583],
              [45.522639, 34.570368],
              [45.523013, 34.570503],
              [45.523141, 34.570419],
              [45.52302, 34.570158],
              [45.522962, 34.569852],
              [45.522842, 34.569679],
              [45.522881, 34.569541],
              [45.522988, 34.569437],
              [45.523271, 34.569388],
              [45.52332, 34.569309],
              [45.523283, 34.569185],
              [45.523138, 34.569063],
              [45.52302, 34.568999],
              [45.522859, 34.568981],
              [45.522832, 34.56892],
              [45.522998, 34.568833],
              [45.523023, 34.568682],
              [45.522645, 34.568489],
              [45.522555, 34.56837],
              [45.522559, 34.568056],
              [45.522407, 34.567696],
              [45.522306, 34.567617],
              [45.522304, 34.567529],
              [45.522679, 34.567316],
              [45.522858, 34.566972],
              [45.52314, 34.566961],
              [45.523266, 34.566908],
              [45.523355, 34.566776],
              [45.523553, 34.566691],
              [45.523635, 34.566572],
              [45.523807, 34.56597],
              [45.523756, 34.565921],
              [45.523655, 34.565943],
              [45.523401, 34.566061],
              [45.52323, 34.565944],
              [45.522843, 34.565819],
              [45.522848, 34.565733],
              [45.523488, 34.565053],
              [45.523508, 34.564925],
              [45.523238, 34.56442],
              [45.523366, 34.564212],
              [45.52302, 34.564018],
              [45.522958, 34.563901],
              [45.522966, 34.563768],
              [45.523053, 34.563668],
              [45.523036, 34.563563],
              [45.52269, 34.563059],
              [45.522351, 34.562933],
              [45.522309, 34.562771],
              [45.5223131, 34.5626304],
              [45.522329, 34.562083],
              [45.522407, 34.561907],
              [45.522415, 34.561647],
              [45.522521, 34.561578],
              [45.522951, 34.561541],
              [45.523015, 34.561352],
              [45.5232, 34.56132],
              [45.523347, 34.560935],
              [45.523236, 34.56061],
              [45.523252, 34.560422],
              [45.523187, 34.560337],
              [45.522875, 34.560191],
              [45.522816, 34.56005],
              [45.522446, 34.559845],
              [45.522345, 34.559519],
              [45.521856, 34.559454],
              [45.521755, 34.559232],
              [45.521674, 34.559169],
              [45.521562, 34.559131],
              [45.521192, 34.559153],
              [45.521078, 34.559107],
              [45.520845, 34.559102],
              [45.520705, 34.558914],
              [45.520418, 34.558864],
              [45.520368, 34.558795],
              [45.52046, 34.558547],
              [45.520452, 34.558413],
              [45.520183, 34.55792],
              [45.520049, 34.557835],
              [45.519757, 34.557747],
              [45.519336, 34.55774],
              [45.5189, 34.557283],
              [45.518705, 34.557176],
              [45.518606, 34.557064],
              [45.518417, 34.556647],
              [45.518308, 34.55658],
              [45.5179521, 34.5564772],
              [45.517602, 34.556376],
              [45.517531, 34.556299],
              [45.517516, 34.556183],
              [45.517403, 34.556117],
              [45.516999, 34.556074],
              [45.51692, 34.555872],
              [45.516452, 34.555695],
              [45.51633, 34.555517],
              [45.516274, 34.555307],
              [45.516166, 34.555288],
              [45.515959, 34.555378],
              [45.51551, 34.555155],
              [45.51535, 34.555121],
              [45.515237, 34.554963],
              [45.515024, 34.554849],
              [45.514997, 34.554771],
              [45.515069, 34.554578],
              [45.515019, 34.554485],
              [45.515102, 34.554347],
              [45.515092, 34.554231],
              [45.515253, 34.55413],
              [45.515277, 34.554061],
              [45.515135, 34.553977],
              [45.515041, 34.553794],
              [45.514952, 34.553746],
              [45.514772, 34.553284],
              [45.514668, 34.553234],
              [45.514372, 34.552897],
              [45.51411, 34.552734],
              [45.513874, 34.55265],
              [45.51377, 34.552469],
              [45.513516, 34.55241],
              [45.513377, 34.552317],
              [45.513154, 34.552065],
              [45.51199, 34.551635],
              [45.512834, 34.551049],
              [45.513001, 34.550999],
              [45.513608, 34.551044],
              [45.513728, 34.551005],
              [45.513903, 34.55081],
              [45.514411, 34.550473],
              [45.515108, 34.550182],
              [45.514243, 34.54943],
              [45.513989, 34.549123],
              [45.513945, 34.548807],
              [45.51399, 34.548131],
              [45.513584, 34.547218],
              [45.513572, 34.546868],
              [45.513627, 34.546533],
              [45.513721, 34.546333],
              [45.514646, 34.545727],
              [45.51559, 34.545349],
              [45.516067, 34.544686],
              [45.516585, 34.544481],
              [45.517149, 34.544057],
              [45.517429, 34.543918],
              [45.517623, 34.543742],
              [45.518587, 34.543635],
              [45.518939, 34.543438],
              [45.519272, 34.54336],
              [45.519635, 34.543191],
              [45.520067, 34.543068],
              [45.520303, 34.542952],
              [45.520447, 34.542662],
              [45.520641, 34.542443],
              [45.521183, 34.5422271],
              [45.5212578, 34.5421776],
              [45.5213305, 34.5420766],
              [45.5213328, 34.54189],
              [45.5212209, 34.5415553],
              [45.52119, 34.5412979],
              [45.5212, 34.541223],
              [45.521658, 34.540588],
              [45.521855, 34.540447],
              [45.522573, 34.540119],
              [45.5226295, 34.5400012],
              [45.5226935, 34.539973],
              [45.5227114, 34.539578],
              [45.5227254, 34.5394699],
              [45.522866, 34.539177],
              [45.522888, 34.538895],
              [45.522976, 34.538617],
              [45.52314, 34.538376],
              [45.523218, 34.538096],
              [45.523031, 34.537465],
              [45.523057, 34.537109],
              [45.522996, 34.536987],
              [45.522773, 34.536823],
              [45.522461, 34.53648],
              [45.522504, 34.536226],
              [45.522788, 34.535851],
              [45.522852, 34.535602],
              [45.523079, 34.535261],
              [45.523107, 34.535096],
              [45.523273, 34.534816],
              [45.523506, 34.534548],
              [45.523952, 34.534332],
              [45.52413, 34.534085],
              [45.524117, 34.533617],
              [45.524498, 34.53301],
              [45.524255, 34.532596],
              [45.524291, 34.532469],
              [45.524489, 34.532246],
              [45.524775, 34.531787],
              [45.525025, 34.531604],
              [45.525536, 34.531566],
              [45.525938, 34.531352],
              [45.526642, 34.530573],
              [45.526665, 34.529909],
              [45.526766, 34.529538],
              [45.526666, 34.529078],
              [45.526975, 34.528433],
              [45.527084, 34.528052],
              [45.526959, 34.527343],
              [45.526676, 34.52704],
              [45.526654, 34.526869],
              [45.526698, 34.526462],
              [45.526857, 34.526196],
              [45.5268547, 34.5258138],
              [45.526853, 34.525518],
              [45.527002, 34.52507],
              [45.52669, 34.523957],
              [45.526443, 34.523749],
              [45.526389, 34.523548],
              [45.526364, 34.522981],
              [45.526392, 34.522812],
              [45.526714, 34.522231],
              [45.52677, 34.521966],
              [45.526837, 34.521548],
              [45.526781, 34.521247],
              [45.526573, 34.520676],
              [45.526616, 34.520487],
              [45.52679, 34.520202],
              [45.526742, 34.519934],
              [45.526817, 34.519623],
              [45.527062, 34.519388],
              [45.527029, 34.519193],
              [45.527093, 34.51894],
              [45.527058, 34.518715],
              [45.527208, 34.518293],
              [45.527205, 34.518163],
              [45.527041, 34.517999],
              [45.52636, 34.517591],
              [45.526341, 34.516711],
              [45.526413, 34.516431],
              [45.526581, 34.516185],
              [45.526562, 34.515918],
              [45.526676, 34.515736],
              [45.526629, 34.51516],
              [45.526432, 34.514683],
              [45.526215, 34.514483],
              [45.526123, 34.514288],
              [45.525927, 34.513524],
              [45.525909, 34.513213],
              [45.525068, 34.511732],
              [45.525167, 34.511552],
              [45.525492, 34.511232],
              [45.525692, 34.511129],
              [45.525991, 34.510669],
              [45.526305, 34.510072],
              [45.52637, 34.50985],
              [45.526408, 34.509322],
              [45.526189, 34.509153],
              [45.52597, 34.508897],
              [45.525929, 34.508664],
              [45.526057, 34.508232],
              [45.526002, 34.507483],
              [45.526242, 34.506905],
              [45.52651, 34.505757],
              [45.526393, 34.504947],
              [45.525959, 34.504543],
              [45.525669, 34.504367],
              [45.525522, 34.504188],
              [45.525481, 34.504024],
              [45.525606, 34.503871],
              [45.525877, 34.503689],
              [45.525914, 34.503384],
              [45.526342, 34.502836],
              [45.526377, 34.502631],
              [45.526168, 34.502012],
              [45.526188, 34.50147],
              [45.526306, 34.501218],
              [45.526533, 34.500925],
              [45.526606, 34.50074],
              [45.526597, 34.500585],
              [45.52644, 34.500272],
              [45.526045, 34.499819],
              [45.525152, 34.499228],
              [45.525054, 34.498781],
              [45.525307, 34.497788],
              [45.525704, 34.497074],
              [45.525603, 34.496858],
              [45.525577, 34.496653],
              [45.525624, 34.496211],
              [45.525516, 34.495961],
              [45.525772, 34.495485],
              [45.525955, 34.494898],
              [45.525918, 34.494725],
              [45.525524, 34.494163],
              [45.525506, 34.494013],
              [45.525671, 34.493707],
              [45.525705, 34.493163],
              [45.525542, 34.492799],
              [45.52544, 34.492692],
              [45.525151, 34.492589],
              [45.524988, 34.492451],
              [45.524926, 34.492303],
              [45.524979, 34.491983],
              [45.524904, 34.491458],
              [45.524647, 34.490977],
              [45.52413, 34.490328],
              [45.524183, 34.490025],
              [45.523731, 34.489267],
              [45.523891, 34.488983],
              [45.523864, 34.488791],
              [45.523427, 34.488005],
              [45.52359, 34.487646],
              [45.523632, 34.48734],
              [45.523946, 34.4869],
              [45.52374, 34.486564],
              [45.523184, 34.485102],
              [45.522577, 34.484649],
              [45.522516, 34.484505],
              [45.522517, 34.483466],
              [45.522213, 34.482569],
              [45.521943, 34.48219],
              [45.52134, 34.481827],
              [45.521232, 34.481716],
              [45.521199, 34.481586],
              [45.521281, 34.481261],
              [45.521255, 34.480982],
              [45.521152, 34.480871],
              [45.520618, 34.480664],
              [45.520497, 34.48022],
              [45.52004, 34.479958],
              [45.519785, 34.479873],
              [45.519381, 34.479539],
              [45.519059, 34.47951],
              [45.518316, 34.478863],
              [45.517956, 34.47841],
              [45.518091, 34.478034],
              [45.51835, 34.477545],
              [45.518099, 34.477076],
              [45.517643, 34.476749],
              [45.517478, 34.476398],
              [45.517377, 34.475978],
              [45.517209, 34.475705],
              [45.516112, 34.475157],
              [45.515929, 34.474678],
              [45.515813, 34.474512],
              [45.515156, 34.474257],
              [45.514539, 34.473736],
              [45.514068, 34.473568],
              [45.513681, 34.473649],
              [45.513393, 34.473594],
              [45.513126, 34.473458],
              [45.512519, 34.472526],
              [45.511285, 34.472301],
              [45.510789, 34.472059],
              [45.510362, 34.472006],
              [45.509799, 34.471999],
              [45.509553, 34.471825],
              [45.50938, 34.471484],
              [45.50908, 34.471283],
              [45.508009, 34.471305],
              [45.507672, 34.470935],
              [45.507301, 34.470866],
              [45.506602, 34.470966],
              [45.505975, 34.470759],
              [45.50532, 34.470608],
              [45.504473, 34.470616],
              [45.504239, 34.470536],
              [45.50396, 34.47075],
              [45.50359, 34.470863],
              [45.502951, 34.470832],
              [45.502162, 34.471423],
              [45.501892, 34.471496],
              [45.50159, 34.471426],
              [45.50114, 34.47149],
              [45.500911, 34.471661],
              [45.500509, 34.471675],
              [45.500302, 34.472035],
              [45.500073, 34.472164],
              [45.499703, 34.472234],
              [45.499172, 34.472692],
              [45.49792, 34.473244],
              [45.497695, 34.473659],
              [45.496734, 34.473917],
              [45.495858, 34.474242],
              [45.495325, 34.474109],
              [45.494922, 34.474114],
              [45.494473, 34.47423],
              [45.493535, 34.474363],
              [45.492828, 34.474377],
              [45.492708, 34.474464],
              [45.492654, 34.474758],
              [45.492547, 34.474991],
              [45.492287, 34.475159],
              [45.491651, 34.475093],
              [45.491142, 34.475113],
              [45.491034, 34.47525],
              [45.49078, 34.475399],
              [45.490488, 34.47551],
              [45.490198, 34.475534],
              [45.489099, 34.475429],
              [45.488659, 34.475448],
              [45.488264, 34.4754],
              [45.487887, 34.475436],
              [45.487317, 34.475674],
              [45.487009, 34.475622],
              [45.486622, 34.475703],
              [45.486392, 34.475823],
              [45.485788, 34.475813],
              [45.485593, 34.476006],
              [45.485219, 34.476103],
              [45.484942, 34.476281],
              [45.483415, 34.476611],
              [45.483152, 34.476762],
              [45.482461, 34.476582],
              [45.482116, 34.476535],
              [45.48202, 34.47587],
              [45.481882, 34.47569],
              [45.480821, 34.475396],
              [45.478921, 34.475597],
              [45.478271, 34.475742],
              [45.477758, 34.475606],
              [45.477255, 34.475651],
              [45.475841, 34.475913],
              [45.475126, 34.475893],
              [45.474825, 34.475823],
              [45.474507, 34.475676],
              [45.474165, 34.475647],
              [45.473815, 34.47581],
              [45.473424, 34.476326],
              [45.473065, 34.476534],
              [45.472629, 34.476526],
              [45.47222, 34.476463],
              [45.471845, 34.476507],
              [45.471689, 34.476651],
              [45.471661, 34.476977],
              [45.471478, 34.477221],
              [45.47131, 34.477358],
              [45.47096, 34.477425],
              [45.470784, 34.477572],
              [45.470604, 34.477876],
              [45.470337, 34.47801],
              [45.469923, 34.47806],
              [45.469512, 34.477892],
              [45.469043, 34.477832],
              [45.468759, 34.477502],
              [45.467564, 34.476425],
              [45.467424, 34.476333],
              [45.466721, 34.47616],
              [45.466197, 34.475588],
              [45.466086, 34.475319],
              [45.466127, 34.475081],
              [45.466315, 34.474797],
              [45.466201, 34.474615],
              [45.466019, 34.474507],
              [45.465686, 34.474403],
              [45.465565, 34.474437],
              [45.465271, 34.474779],
              [45.465021, 34.474973],
              [45.464901, 34.475231],
              [45.464557, 34.47552],
              [45.464362, 34.475543],
              [45.464046, 34.475506],
              [45.463394, 34.475218],
              [45.463008, 34.474872],
              [45.462573, 34.474373],
              [45.462404, 34.474259],
              [45.462122, 34.474165],
              [45.461668, 34.474147],
              [45.461139, 34.473611],
              [45.461268, 34.473501],
              [45.461232, 34.473244],
              [45.461113, 34.472964],
              [45.460932, 34.472739],
              [45.460692, 34.471693],
              [45.460744, 34.47156],
              [45.461087, 34.471121],
              [45.46165, 34.470831],
              [45.462408, 34.470958],
              [45.462906, 34.47078],
              [45.463227, 34.470748],
              [45.46353, 34.470603],
              [45.463587, 34.47047],
              [45.463114, 34.470101],
              [45.462912, 34.470043],
              [45.462748, 34.469855],
              [45.462691, 34.469717],
              [45.462736, 34.469375],
              [45.462685, 34.46924],
              [45.462451, 34.469066],
              [45.462226, 34.468693],
              [45.462218, 34.468531],
              [45.462319, 34.468448],
              [45.462657, 34.468401],
              [45.462626, 34.468172],
              [45.462716, 34.468082],
              [45.463017, 34.467946],
              [45.462859, 34.467641],
              [45.462843, 34.467264],
              [45.462758, 34.467177],
              [45.462628, 34.467165],
              [45.462296, 34.467336],
              [45.462187, 34.467283],
              [45.462081, 34.466966],
              [45.461962, 34.466832],
              [45.461781, 34.466758],
              [45.461693, 34.466758],
              [45.46154, 34.466921],
              [45.461363, 34.466989],
              [45.461211, 34.466963],
              [45.460943, 34.46657],
              [45.460823, 34.466509],
              [45.459791, 34.466576],
              [45.459462, 34.466493],
              [45.459015, 34.46628],
              [45.458641, 34.4657],
              [45.457724, 34.465997],
              [45.457354, 34.466202],
              [45.457015, 34.46632],
              [45.456543, 34.466443],
              [45.456209, 34.466451],
              [45.455552, 34.466571],
              [45.455279, 34.466666],
              [45.454803, 34.466939],
              [45.454432, 34.467091],
              [45.454122, 34.466824],
              [45.453908, 34.46675],
              [45.453418, 34.466246],
              [45.453046, 34.465962],
              [45.45276, 34.465876],
              [45.45251, 34.465835],
              [45.452104, 34.465936],
              [45.451893, 34.466058],
              [45.451628, 34.466307],
              [45.451399, 34.466367],
              [45.450851, 34.466165],
              [45.450445, 34.465943],
              [45.450071, 34.465597],
              [45.450227, 34.465233],
              [45.450172, 34.464967],
              [45.449996, 34.464737],
              [45.450318, 34.464153],
              [45.450114, 34.463664],
              [45.449033, 34.463741],
              [45.448618, 34.463576],
              [45.448215, 34.463567],
              [45.447438, 34.463882],
              [45.446986, 34.463999],
              [45.446471, 34.464073],
              [45.446191, 34.463994],
              [45.445971, 34.464036],
              [45.445334, 34.464033],
              [45.444928, 34.464097],
              [45.444657, 34.463934],
              [45.444488, 34.463757],
              [45.444479, 34.463677],
              [45.444552, 34.463562],
              [45.444457, 34.463408],
              [45.444279, 34.463425],
              [45.444099, 34.463605],
              [45.443855, 34.463598],
              [45.443789, 34.463473],
              [45.443943, 34.46314],
              [45.443934, 34.463054],
              [45.443663, 34.462794],
              [45.443512, 34.462735],
              [45.443354, 34.461838],
              [45.443388, 34.461413],
              [45.443323, 34.461287],
              [45.44306, 34.46108],
              [45.443032, 34.460667],
              [45.442941, 34.460633],
              [45.44261, 34.46065],
              [45.442182, 34.460527],
              [45.44204, 34.460411],
              [45.441833, 34.460013],
              [45.441742, 34.460002],
              [45.441567, 34.460091],
              [45.441474, 34.460069],
              [45.441668, 34.459507],
              [45.441656, 34.459202],
              [45.441584, 34.459135],
              [45.44149, 34.459132],
              [45.441217, 34.459245],
              [45.441123, 34.459441],
              [45.44076, 34.459477],
              [45.440675, 34.459447],
              [45.440632, 34.45923],
              [45.440497, 34.459072],
              [45.44042, 34.459055],
              [45.440259, 34.459161],
              [45.440162, 34.459147],
              [45.440097, 34.459041],
              [45.439814, 34.458932],
              [45.439987, 34.458783],
              [45.440082, 34.458395],
              [45.440015, 34.458331],
              [45.439826, 34.458299],
              [45.439852, 34.458131],
              [45.439741, 34.457973],
              [45.44006, 34.457716],
              [45.440077, 34.457603],
              [45.44004, 34.457466],
              [45.439794, 34.45715],
              [45.439895, 34.456888],
              [45.439838, 34.456601],
              [45.43999, 34.4565],
              [45.440068, 34.456222],
              [45.440038, 34.455873],
              [45.439938, 34.455768],
              [45.43993, 34.455654],
              [45.440124, 34.455517],
              [45.440294, 34.455506],
              [45.440364, 34.455458],
              [45.440356, 34.455368],
              [45.440082, 34.455055],
              [45.439969, 34.45471],
              [45.439922, 34.454425],
              [45.439824, 34.454255],
              [45.439841, 34.453823],
              [45.439989, 34.453501],
              [45.440117, 34.453354],
              [45.440335, 34.453237],
              [45.440432, 34.452952],
              [45.440549, 34.452875],
              [45.440735, 34.452843],
              [45.440993, 34.453027],
              [45.441162, 34.453082],
              [45.441287, 34.453019],
              [45.441375, 34.452843],
              [45.441374, 34.45259],
              [45.441801, 34.45253],
              [45.441912, 34.452691],
              [45.441984, 34.452682],
              [45.442139, 34.452125],
              [45.442232, 34.452048],
              [45.442415, 34.452],
              [45.442665, 34.451776],
              [45.442664, 34.451692],
              [45.44256, 34.451663],
              [45.442114, 34.45163],
              [45.442049, 34.451501],
              [45.441964, 34.451294],
              [45.44197, 34.451178],
              [45.442218, 34.450962],
              [45.442284, 34.450849],
              [45.442278, 34.450743],
              [45.442209, 34.450622],
              [45.442001, 34.450592],
              [45.441939, 34.450328],
              [45.441977, 34.450273],
              [45.442228, 34.450244],
              [45.442292, 34.450171],
              [45.442337, 34.450053],
              [45.442271, 34.449821],
              [45.442288, 34.449708],
              [45.443012, 34.44916],
              [45.443192, 34.44883],
              [45.443453, 34.448508],
              [45.443164, 34.448366],
              [45.442976, 34.447866],
              [45.442858, 34.447721],
              [45.442762, 34.447339],
              [45.442494, 34.447156],
              [45.442254, 34.446863],
              [45.44193, 34.446894],
              [45.441755, 34.44681],
              [45.441961, 34.446556],
              [45.441903, 34.446216],
              [45.44195, 34.446156],
              [45.442179, 34.446095],
              [45.442085, 34.44582],
              [45.442315, 34.445686],
              [45.442367, 34.445576],
              [45.44211, 34.445054],
              [45.442157, 34.44452],
              [45.442281, 34.444377],
              [45.442417, 34.444321],
              [45.442656, 34.444036],
              [45.442635, 34.443978],
              [45.442538, 34.443964],
              [45.441894, 34.443992],
              [45.441828, 34.443912],
              [45.441771, 34.443674],
              [45.441802, 34.443533],
              [45.441855, 34.443426],
              [45.441997, 34.443373],
              [45.442043, 34.443282],
              [45.441932, 34.443048],
              [45.441961, 34.442922],
              [45.442032, 34.442809],
              [45.442133, 34.442769],
              [45.442269, 34.442781],
              [45.44238, 34.442847],
              [45.442452, 34.44296],
              [45.442344, 34.443208],
              [45.442384, 34.443337],
              [45.442462, 34.443384],
              [45.442779, 34.443216],
              [45.44299, 34.442966],
              [45.442873, 34.442652],
              [45.442706, 34.442356],
              [45.4426, 34.44227],
              [45.442153, 34.442402],
              [45.442142, 34.442319],
              [45.44218, 34.442188],
              [45.442341, 34.442059],
              [45.442623, 34.441666],
              [45.442851, 34.441479],
              [45.442898, 34.441365],
              [45.442702, 34.441077],
              [45.442562, 34.440988],
              [45.442476, 34.440758],
              [45.442509, 34.440624],
              [45.442756, 34.440507],
              [45.442852, 34.440391],
              [45.442823, 34.439851],
              [45.442858, 34.439559],
              [45.442918, 34.439313],
              [45.44306, 34.439084],
              [45.44324, 34.438926],
              [45.443472, 34.438807],
              [45.443737, 34.438726],
              [45.444574, 34.4386],
              [45.445074, 34.438832],
              [45.445861, 34.43885],
              [45.446166, 34.43903],
              [45.446271, 34.439142],
              [45.446556, 34.438941],
              [45.447041, 34.438336],
              [45.447557, 34.438029],
              [45.448014, 34.437654],
              [45.448199, 34.437268],
              [45.448371, 34.437136],
              [45.448559, 34.437098],
              [45.448679, 34.437129],
              [45.448923, 34.436822],
              [45.44885, 34.436778],
              [45.449004, 34.436732],
              [45.44909, 34.436773],
              [45.449158, 34.436732],
              [45.44913, 34.436623],
              [45.449184, 34.4366],
              [45.449315, 34.436611],
              [45.449429, 34.436723],
              [45.449596, 34.436652],
              [45.449649, 34.436392],
              [45.44992, 34.436256],
              [45.450087, 34.436113],
              [45.450239, 34.435842],
              [45.450266, 34.435696],
              [45.450691, 34.435634],
              [45.450768, 34.435578],
              [45.450745, 34.435525],
              [45.450835, 34.435499],
              [45.45132, 34.435489],
              [45.451427, 34.435328],
              [45.451736, 34.435357],
              [45.452061, 34.43531],
              [45.452169, 34.435201],
              [45.452422, 34.435114],
              [45.452744, 34.435195],
              [45.452867, 34.435289],
              [45.453062, 34.435318],
              [45.453456, 34.435268],
              [45.453961, 34.435074],
              [45.454308, 34.435109],
              [45.454299, 34.432754],
              [45.455941, 34.432991],
              [45.455834, 34.432545],
              [45.455908, 34.432347],
              [45.455887, 34.431699],
              [45.455907, 34.4316],
              [45.456015, 34.431498],
              [45.456109, 34.431129],
              [45.456082, 34.430796],
              [45.456139, 34.430438],
              [45.455985, 34.430327],
              [45.455829, 34.430066],
              [45.455712, 34.429716],
              [45.455725, 34.428555],
              [45.456279, 34.428027],
              [45.456533, 34.427867],
              [45.456655, 34.42771],
              [45.456814, 34.427325],
              [45.456791, 34.42691],
              [45.457062, 34.42669],
              [45.45721, 34.426368],
              [45.456998, 34.425554],
              [45.457034, 34.425239],
              [45.456882, 34.424968],
              [45.457009, 34.424763],
              [45.457096, 34.424434],
              [45.457093, 34.424273],
              [45.456964, 34.424045],
              [45.45696, 34.423927],
              [45.457091, 34.423665],
              [45.457129, 34.423388],
              [45.456998, 34.423175],
              [45.456983, 34.422925],
              [45.456897, 34.422767],
              [45.456476, 34.422264],
              [45.456733, 34.42177],
              [45.456719, 34.421033],
              [45.455552, 34.419845],
              [45.455619, 34.419387],
              [45.455994, 34.418942],
              [45.455517, 34.418319],
              [45.455585, 34.417912],
              [45.455556, 34.417505],
              [45.4562, 34.416448],
              [45.456823, 34.416562],
              [45.457139, 34.416546],
              [45.457305, 34.416451],
              [45.457446, 34.41648],
              [45.458558, 34.415834],
              [45.462498, 34.4025],
              [45.463904, 34.398679],
              [45.4673089, 34.3825649],
              [45.4681427, 34.3819962],
              [45.4677463, 34.3791461],
              [45.480033, 34.365339],
              [45.496178, 34.336867],
              [45.498573, 34.335315],
              [45.498748, 34.335731],
              [45.49888, 34.336551],
              [45.499178, 34.337214],
              [45.5009669, 34.339051],
              [45.5011761, 34.3394319],
              [45.5013478, 34.3395914],
              [45.5015516, 34.339711],
              [45.5017316, 34.3398906],
              [45.5019057, 34.3401562],
              [45.5022007, 34.3403001],
              [45.5025027, 34.3406435],
              [45.5024368, 34.3411373],
              [45.5023386, 34.3416483],
              [45.5022222, 34.3420586],
              [45.5021643, 34.3424422],
              [45.5021248, 34.3430221],
              [45.5023024, 34.3436836],
              [45.502477, 34.344176],
              [45.5027222, 34.34498],
              [45.502986, 34.3454423],
              [45.503702, 34.346278],
              [45.503841, 34.34642],
              [45.504303, 34.346679],
              [45.504725, 34.347012],
              [45.505748, 34.348133],
              [45.505903, 34.3486428],
              [45.5060309, 34.3493799],
              [45.5062743, 34.35028],
              [45.5063863, 34.3509372],
              [45.5067935, 34.3515286],
              [45.5069911, 34.3517959],
              [45.5072094, 34.3520134],
              [45.5076074, 34.3522591],
              [45.5078843, 34.3523229],
              [45.508163, 34.352325],
              [45.508321, 34.352322],
              [45.508716, 34.352178],
              [45.509234, 34.351837],
              [45.510214, 34.350914],
              [45.510931, 34.350337],
              [45.512206, 34.349703],
              [45.513878, 34.348639],
              [45.5140936, 34.3484853],
              [45.5145764, 34.3484188],
              [45.514667, 34.3483402],
              [45.5147253, 34.3482568],
              [45.514842, 34.3481066],
              [45.515017, 34.347991],
              [45.515191, 34.34794],
              [45.515861, 34.347844],
              [45.51672, 34.347876],
              [45.5177136, 34.3480806],
              [45.5185971, 34.3483391],
              [45.519559, 34.348509],
              [45.520327, 34.348606],
              [45.5205806, 34.3486115],
              [45.520838, 34.348594],
              [45.5210264, 34.3485027],
              [45.5211183, 34.3484255],
              [45.5211787, 34.34839],
              [45.5212887, 34.3483635],
              [45.5214496, 34.3483601],
              [45.5216335, 34.3484276],
              [45.5217607, 34.3484819],
              [45.521882, 34.3485632],
              [45.522075, 34.348821],
              [45.5222409, 34.3489007],
              [45.5223097, 34.3490086],
              [45.5223791, 34.3490837],
              [45.5226432, 34.3490909],
              [45.522851, 34.3490832],
              [45.523134, 34.3490267],
              [45.5237887, 34.34895],
              [45.5239508, 34.348958],
              [45.5240192, 34.3489791],
              [45.5241171, 34.3490234],
              [45.524258, 34.349017],
              [45.5243641, 34.3490481],
              [45.5244456, 34.3491075],
              [45.524547, 34.349148],
              [45.5247004, 34.3491861],
              [45.5248906, 34.3492003],
              [45.5250951, 34.3491669],
              [45.5253944, 34.3490482],
              [45.5258471, 34.3488994],
              [45.526125, 34.348863],
              [45.5263178, 34.34873],
              [45.5266786, 34.348452],
              [45.5268969, 34.3483661],
              [45.527141, 34.348184],
              [45.527306, 34.348121],
              [45.527624, 34.347644],
              [45.5278212, 34.3471698],
              [45.5282074, 34.3469794],
              [45.5285346, 34.3467624],
              [45.5289048, 34.3465321],
              [45.5293286, 34.3463682],
              [45.5296451, 34.3462663],
              [45.530026, 34.346253],
              [45.5304176, 34.3462043],
              [45.5307984, 34.3461024],
              [45.5312705, 34.346129],
              [45.5316621, 34.34616],
              [45.5322713, 34.346182],
              [45.532661, 34.3462313],
              [45.5328846, 34.3464096],
              [45.5330166, 34.3465143],
              [45.5330832, 34.3466349],
              [45.5331554, 34.3467461],
              [45.5331856, 34.3469572],
              [45.5331883, 34.3472894],
              [45.5332287, 34.3475426],
              [45.5334109, 34.3480734],
              [45.5335718, 34.3485362],
              [45.5336925, 34.3489104],
              [45.5338785, 34.3495313],
              [45.5339259, 34.3496346],
              [45.5340037, 34.3497409],
              [45.5341083, 34.3498228],
              [45.5342907, 34.3501107],
              [45.5343792, 34.3504689],
              [45.5344087, 34.3507617],
              [45.5343738, 34.351026],
              [45.5343068, 34.3512843],
              [45.5342217, 34.3514522],
              [45.53454, 34.351529],
              [45.535126, 34.352068],
              [45.535361, 34.352077],
              [45.535735, 34.352186],
              [45.535874, 34.3521],
              [45.535945, 34.351953],
              [45.536408, 34.351871],
              [45.536853, 34.351332],
              [45.537206, 34.351212],
              [45.537494, 34.351176],
              [45.537621, 34.351224],
              [45.537661, 34.351304],
              [45.537418, 34.351647],
              [45.537653, 34.351928],
              [45.537719, 34.352077],
              [45.537813, 34.352139],
              [45.538075, 34.352107],
              [45.538192, 34.351902],
              [45.538227, 34.351533],
              [45.538277, 34.351475],
              [45.538381, 34.351468],
              [45.538573, 34.351587],
              [45.538746, 34.351605],
              [45.538865, 34.351546],
              [45.538917, 34.351019],
              [45.539088, 34.350733],
              [45.53943, 34.350342],
              [45.539692, 34.350283],
              [45.539766, 34.350353],
              [45.539515, 34.350615],
              [45.539455, 34.350766],
              [45.539482, 34.350925],
              [45.539533, 34.350963],
              [45.539948, 34.350838],
              [45.540139, 34.35084],
              [45.540261, 34.350775],
              [45.540608, 34.350379],
              [45.5412, 34.349858],
              [45.541287, 34.349731],
              [45.541218, 34.349433],
              [45.541246, 34.349351],
              [45.54135, 34.349298],
              [45.541532, 34.349328],
              [45.541741, 34.349295],
              [45.541965, 34.349146],
              [45.542102, 34.348802],
              [45.542225, 34.34865],
              [45.542494, 34.348512],
              [45.542948, 34.348532],
              [45.543143, 34.348483],
              [45.543345, 34.34851],
              [45.543353, 34.348813],
              [45.543417, 34.348862],
              [45.54354, 34.348825],
              [45.544039, 34.3484],
              [45.544413, 34.347532],
              [45.544716, 34.347198],
              [45.54474, 34.346939],
              [45.544835, 34.346824],
              [45.545057, 34.346821],
              [45.545282, 34.346381],
              [45.545651, 34.34599],
              [45.54609, 34.345675],
              [45.546188, 34.345664],
              [45.546316, 34.345894],
              [45.546416, 34.345938],
              [45.546657, 34.345927],
              [45.546805, 34.345835],
              [45.546887, 34.345713],
              [45.546765, 34.345464],
              [45.546758, 34.34532],
              [45.546904, 34.345151],
              [45.54717, 34.345023],
              [45.547252, 34.344646],
              [45.547035, 34.344262],
              [45.54774, 34.343951],
              [45.548098, 34.343944],
              [45.548222, 34.343838],
              [45.548285, 34.343701],
              [45.548257, 34.343605],
              [45.54805, 34.343465],
              [45.548041, 34.343153],
              [45.548086, 34.343073],
              [45.548183, 34.343058],
              [45.54846, 34.343114],
              [45.548488, 34.343073],
              [45.548405, 34.342832],
              [45.548817, 34.342717],
              [45.548932, 34.342621],
              [45.549042, 34.342163],
              [45.548973, 34.34191],
              [45.549041, 34.341817],
              [45.549562, 34.341535],
              [45.549768, 34.341557],
              [45.549848, 34.341626],
              [45.549868, 34.3418],
              [45.549946, 34.341865],
              [45.550038, 34.341851],
              [45.550407, 34.341279],
              [45.550551, 34.341215],
              [45.550611, 34.340996],
              [45.550843, 34.340791],
              [45.550978, 34.340756],
              [45.551168, 34.340777],
              [45.551301, 34.340874],
              [45.551381, 34.340875],
              [45.551447, 34.340819],
              [45.551443, 34.34046],
              [45.551579, 34.34043],
              [45.551816, 34.340474],
              [45.551933, 34.340428],
              [45.551851, 34.340259],
              [45.551693, 34.340102],
              [45.551782, 34.340034],
              [45.552404, 34.339999],
              [45.552705, 34.340179],
              [45.552974, 34.3402],
              [45.553209, 34.34014],
              [45.553728, 34.339758],
              [45.553892, 34.339532],
              [45.553877, 34.339444],
              [45.553816, 34.339412],
              [45.55353, 34.33943],
              [45.55345, 34.339361],
              [45.55344, 34.339181],
              [45.553476, 34.338993],
              [45.55356, 34.338925],
              [45.554082, 34.338784],
              [45.554169, 34.338724],
              [45.554181, 34.338663],
              [45.554124, 34.3386],
              [45.5539, 34.338453],
              [45.553858, 34.338319],
              [45.554098, 34.338145],
              [45.553937, 34.337797],
              [45.553974, 34.33766],
              [45.554634, 34.337223],
              [45.555223, 34.337235],
              [45.555386, 34.337296],
              [45.555559, 34.337291],
              [45.55572, 34.337211],
              [45.555935, 34.336977],
              [45.55631, 34.336949],
              [45.55646, 34.336889],
              [45.556602, 34.336526],
              [45.556572, 34.336235],
              [45.556685, 34.335881],
              [45.55685, 34.335773],
              [45.557231, 34.335658],
              [45.557276, 34.335583],
              [45.55726, 34.33549],
              [45.557041, 34.335275],
              [45.557036, 34.335184],
              [45.557125, 34.335138],
              [45.557504, 34.335151],
              [45.557603, 34.335054],
              [45.55759, 34.334956],
              [45.557265, 34.334671],
              [45.557254, 34.334582],
              [45.557358, 34.334483],
              [45.557732, 34.334361],
              [45.55829, 34.334418],
              [45.558397, 34.334378],
              [45.558804, 34.333968],
              [45.558758, 34.333748],
              [45.558799, 34.333719],
              [45.559088, 34.333687],
              [45.559312, 34.333561],
              [45.559591, 34.333467],
              [45.559734, 34.333467],
              [45.560339, 34.333226],
              [45.560661, 34.333156],
              [45.560926, 34.332978],
              [45.561153, 34.332701],
              [45.561437, 34.332625],
              [45.561625, 34.332209],
              [45.561807, 34.331623],
              [45.574748, 34.316232],
              [45.583566, 34.302663],
              [45.585172, 34.296881],
              [45.585698, 34.291206],
              [45.585535, 34.288766],
              [45.58562, 34.286706],
              [45.585121, 34.282757],
              [45.584384, 34.278574],
              [45.583216, 34.273258],
              [45.582681, 34.268939],
              [45.582136, 34.26712],
              [45.581739, 34.264227],
              [45.581528, 34.261019],
              [45.581548, 34.257146],
              [45.5816331, 34.2561528],
              [45.581709, 34.255266],
              [45.581772, 34.2551],
              [45.582085, 34.252976],
              [45.582679, 34.250156],
              [45.582813, 34.249059],
              [45.582854, 34.248159],
              [45.582752, 34.247025],
              [45.582462, 34.246049],
              [45.582049, 34.245308],
              [45.581786, 34.244617],
              [45.58149, 34.241788],
              [45.581097, 34.23956],
              [45.578745, 34.232701],
              [45.578221, 34.231653],
              [45.575087, 34.22711],
              [45.573724, 34.225232],
              [45.572126, 34.222567],
              [45.571544, 34.221293],
              [45.570871, 34.219301],
              [45.570332, 34.216252],
              [45.568655, 34.212268],
              [45.566803, 34.210203],
              [45.561731, 34.205817],
              [45.557137, 34.200427],
              [45.556792, 34.200076],
              [45.556031, 34.199023],
              [45.555602, 34.198242],
              [45.555169, 34.196953],
              [45.554975, 34.196132],
              [45.554874, 34.195116],
              [45.555007, 34.193746],
              [45.555702, 34.19206],
              [45.556726, 34.19006],
              [45.558314, 34.187861],
              [45.559949, 34.185702],
              [45.561305, 34.184209],
              [45.56425, 34.180596],
              [45.567476, 34.176942],
              [45.569557, 34.175118],
              [45.571272, 34.173872],
              [45.572253, 34.172655],
              [45.573325, 34.170928],
              [45.573751, 34.169802],
              [45.573889, 34.16899],
              [45.574623, 34.167197],
              [45.574732, 34.166289],
              [45.574782, 34.163526],
              [45.575099, 34.161725],
              [45.575079, 34.158673],
              [45.575167, 34.157773],
              [45.575585, 34.156871],
              [45.576275, 34.154559],
              [45.578897, 34.149925],
              [45.580234, 34.148057],
              [45.580832, 34.147356],
              [45.581162, 34.146888],
              [45.581594, 34.14613],
              [45.56802, 34.139953],
              [45.560063, 34.138826],
              [45.548712, 34.130668],
              [45.544936, 34.128266],
              [45.544597, 34.127378],
              [45.544052, 34.127099],
              [45.543266, 34.126281],
              [45.543052, 34.125964],
              [45.542794, 34.125258],
              [45.542685, 34.125102],
              [45.541953, 34.124861],
              [45.540434, 34.124638],
              [45.5395, 34.124395],
              [45.538495, 34.123953],
              [45.537587, 34.123305],
              [45.536689, 34.123038],
              [45.536116, 34.123008],
              [45.535993, 34.123076],
              [45.535935, 34.123223],
              [45.535955, 34.123384],
              [45.536068, 34.123509],
              [45.536133, 34.123801],
              [45.535976, 34.123932],
              [45.535742, 34.124],
              [45.535485, 34.123961],
              [45.535287, 34.123859],
              [45.535124, 34.123676],
              [45.534866, 34.123516],
              [45.533118, 34.122881],
              [45.531799, 34.122342],
              [45.531374, 34.122218],
              [45.530789, 34.121901],
              [45.530478, 34.121621],
              [45.530106, 34.121097],
              [45.529987, 34.120725],
              [45.52997, 34.119959],
              [45.530101, 34.119285],
              [45.530238, 34.119068],
              [45.531055, 34.118401],
              [45.531664, 34.118087],
              [45.532864, 34.117832],
              [45.53323, 34.117712],
              [45.533548, 34.117546],
              [45.53379, 34.117393],
              [45.53394, 34.117209],
              [45.533955, 34.117064],
              [45.533847, 34.116815],
              [45.532966, 34.116647],
              [45.532368, 34.116483],
              [45.531869, 34.116482],
              [45.531238, 34.116244],
              [45.531119, 34.116089],
              [45.531098, 34.115759],
              [45.530585, 34.114524],
              [45.530286, 34.114371],
              [45.529628, 34.114324],
              [45.528618, 34.114528],
              [45.528057, 34.114772],
              [45.527818, 34.115005],
              [45.527725, 34.115233],
              [45.527731, 34.11545],
              [45.528259, 34.116224],
              [45.528292, 34.11685],
              [45.52822, 34.117075],
              [45.528232, 34.117557],
              [45.52837, 34.117989],
              [45.528353, 34.118125],
              [45.528058, 34.1183],
              [45.527446, 34.11841],
              [45.526778, 34.118604],
              [45.525834, 34.118624],
              [45.525379, 34.118536],
              [45.524806, 34.118226],
              [45.523655, 34.117865],
              [45.523438, 34.117726],
              [45.523412, 34.117419],
              [45.523483, 34.117164],
              [45.523756, 34.116654],
              [45.523998, 34.115856],
              [45.524227, 34.115549],
              [45.524317, 34.115312],
              [45.524304, 34.115181],
              [45.523813, 34.114263],
              [45.52359, 34.114022],
              [45.523205, 34.113745],
              [45.522393, 34.113624],
              [45.522101, 34.113621],
              [45.521652, 34.11375],
              [45.521497, 34.113721],
              [45.521118, 34.11335],
              [45.521025, 34.113195],
              [45.520995, 34.112987],
              [45.52102, 34.111907],
              [45.521084, 34.111457],
              [45.521248, 34.111169],
              [45.521428, 34.111025],
              [45.521473, 34.110774],
              [45.521409, 34.110344],
              [45.521283, 34.110208],
              [45.521108, 34.110134],
              [45.520581, 34.11015],
              [45.520258, 34.110201],
              [45.51956, 34.110422],
              [45.519024, 34.110853],
              [45.518405, 34.111622],
              [45.518157, 34.111767],
              [45.516518, 34.112386],
              [45.515654, 34.112557],
              [45.515284, 34.112585],
              [45.515069, 34.112525],
              [45.514983, 34.112423],
              [45.514948, 34.112242],
              [45.515068, 34.111925],
              [45.515004, 34.111686],
              [45.514449, 34.110667],
              [45.514183, 34.110638],
              [45.513895, 34.110701],
              [45.513283, 34.110696],
              [45.512441, 34.110006],
              [45.511729, 34.109549],
              [45.511585, 34.109403],
              [45.511076, 34.108497],
              [45.51075, 34.108175],
              [45.510052, 34.107867],
              [45.509912, 34.107746],
              [45.509925, 34.107351],
              [45.509828, 34.107165],
              [45.509618, 34.10697],
              [45.50935, 34.106462],
              [45.509196, 34.106307],
              [45.508596, 34.106012],
              [45.508382, 34.105827],
              [45.508076, 34.105293],
              [45.50785, 34.104672],
              [45.507683, 34.104479],
              [45.507134, 34.104247],
              [45.506814, 34.104194],
              [45.505976, 34.104294],
              [45.505668, 34.104177],
              [45.505336, 34.104122],
              [45.504828, 34.103928],
              [45.504428, 34.103696],
              [45.503966, 34.103245],
              [45.503922, 34.103078],
              [45.504109, 34.102744],
              [45.504614, 34.102339],
              [45.504976, 34.101961],
              [45.505896, 34.100968],
              [45.506403, 34.100209],
              [45.506835, 34.0999],
              [45.50698, 34.099681],
              [45.506952, 34.098952],
              [45.506804, 34.098457],
              [45.50668, 34.098382],
              [45.50646, 34.098372],
              [45.505842, 34.098526],
              [45.505182, 34.098813],
              [45.50494, 34.098779],
              [45.504658, 34.09864],
              [45.503962, 34.098686],
              [45.503493, 34.098657],
              [45.503068, 34.098567],
              [45.501267, 34.097843],
              [45.49933, 34.096742],
              [45.498354, 34.095889],
              [45.49761, 34.095098],
              [45.497205, 34.094911],
              [45.496962, 34.094873],
              [45.496476, 34.094886],
              [45.49632, 34.094808],
              [45.496159, 34.094395],
              [45.496249, 34.094077],
              [45.496244, 34.093921],
              [45.496025, 34.093281],
              [45.496002, 34.092913],
              [45.496185, 34.092022],
              [45.496148, 34.091862],
              [45.495961, 34.091722],
              [45.495364, 34.091556],
              [45.494608, 34.091482],
              [45.494097, 34.091499],
              [45.493746, 34.091451],
              [45.493556, 34.091365],
              [45.493427, 34.091224],
              [45.493267, 34.090726],
              [45.493289, 34.088827],
              [45.493188, 34.088673],
              [45.492854, 34.088448],
              [45.492771, 34.088184],
              [45.492616, 34.087958],
              [45.492436, 34.08787],
              [45.491309, 34.087572],
              [45.490226, 34.087371],
              [45.48985, 34.087103],
              [45.489827, 34.086915],
              [45.489973, 34.086521],
              [45.490119, 34.086306],
              [45.49067, 34.085893],
              [45.491601, 34.085489],
              [45.492215, 34.085321],
              [45.494383, 34.084352],
              [45.495378, 34.083727],
              [45.495542, 34.0835],
              [45.49559, 34.083273],
              [45.495543, 34.083075],
              [45.495451, 34.082955],
              [45.494196, 34.082517],
              [45.492941, 34.082467],
              [45.492094, 34.082479],
              [45.491455, 34.082338],
              [45.490886, 34.082266],
              [45.490068, 34.082041],
              [45.489726, 34.081785],
              [45.489536, 34.08161],
              [45.489183, 34.080945],
              [45.488961, 34.079889],
              [45.488841, 34.079805],
              [45.488102, 34.079894],
              [45.487859, 34.079811],
              [45.487569, 34.079637],
              [45.48704, 34.079175],
              [45.486473, 34.078432],
              [45.486016, 34.078115],
              [45.485909, 34.077908],
              [45.485918, 34.077451],
              [45.485969, 34.077282],
              [45.486191, 34.076939],
              [45.486172, 34.076427],
              [45.485888, 34.075721],
              [45.485705, 34.075526],
              [45.485519, 34.075461],
              [45.485313, 34.075489],
              [45.484619, 34.075879],
              [45.484401, 34.076083],
              [45.484181, 34.076502],
              [45.484026, 34.077152],
              [45.483794, 34.077792],
              [45.483679, 34.077984],
              [45.483679, 34.078954],
              [45.483596, 34.079597],
              [45.483203, 34.080816],
              [45.482993, 34.080939],
              [45.482428, 34.081067],
              [45.482059, 34.08108],
              [45.481195, 34.080929],
              [45.480941, 34.080821],
              [45.480472, 34.080452],
              [45.479496, 34.080073],
              [45.479353, 34.079894],
              [45.479268, 34.079693],
              [45.479159, 34.079026],
              [45.479137, 34.07814],
              [45.479241, 34.076979],
              [45.47916, 34.076634],
              [45.478987, 34.076487],
              [45.478536, 34.07633],
              [45.477013, 34.076134],
              [45.476242, 34.075906],
              [45.474756, 34.075866],
              [45.474335, 34.075949],
              [45.473963, 34.075838],
              [45.473516, 34.075608],
              [45.47339, 34.075364],
              [45.473584, 34.0749],
              [45.473604, 34.074198],
              [45.473556, 34.073994],
              [45.473469, 34.07387],
              [45.473302, 34.073839],
              [45.472962, 34.073675],
              [45.472521, 34.072856],
              [45.472503, 34.072555],
              [45.472272, 34.071734],
              [45.471609, 34.071188],
              [45.471522, 34.07102],
              [45.471551, 34.070742],
              [45.472076, 34.070184],
              [45.472326, 34.069647],
              [45.472375, 34.069383],
              [45.472318, 34.069096],
              [45.472181, 34.068853],
              [45.47209, 34.068734],
              [45.471953, 34.068672],
              [45.471106, 34.068648],
              [45.470598, 34.068378],
              [45.470514, 34.06818],
              [45.4706, 34.068074],
              [45.470582, 34.067794],
              [45.470356, 34.06733],
              [45.46984, 34.066532],
              [45.469603, 34.06629],
              [45.469187, 34.06605],
              [45.468792, 34.066173],
              [45.468588, 34.06616],
              [45.46821, 34.06595],
              [45.467853, 34.065559],
              [45.467185, 34.064992],
              [45.466321, 34.064062],
              [45.466126, 34.06373],
              [45.466166, 34.063384],
              [45.466595, 34.063225],
              [45.46835, 34.06207],
              [45.470072, 34.061089],
              [45.470921, 34.06056],
              [45.472049, 34.05975],
              [45.472266, 34.059707],
              [45.472927, 34.059883],
              [45.473588, 34.05997],
              [45.475087, 34.05995],
              [45.477328, 34.05985],
              [45.477637, 34.059811],
              [45.477936, 34.05969],
              [45.478804, 34.059012],
              [45.478939, 34.058753],
              [45.479079, 34.05825],
              [45.479278, 34.057253],
              [45.478977, 34.056355],
              [45.478976, 34.05617],
              [45.479331, 34.055316],
              [45.479258, 34.054153],
              [45.479295, 34.053547],
              [45.479206, 34.053415],
              [45.478808, 34.0533],
              [45.478056, 34.052759],
              [45.477335, 34.052394],
              [45.476696, 34.051862],
              [45.475835, 34.051059],
              [45.475704, 34.050797],
              [45.475678, 34.050325],
              [45.475879, 34.049896],
              [45.476658, 34.049003],
              [45.477241, 34.048555],
              [45.478713, 34.047612],
              [45.479175, 34.04724],
              [45.47946, 34.046941],
              [45.479697, 34.046533],
              [45.479786, 34.046148],
              [45.479783, 34.045752],
              [45.479697, 34.045434],
              [45.479526, 34.045045],
              [45.479228, 34.044699],
              [45.47876, 34.044286],
              [45.4787, 34.044141],
              [45.478783, 34.043889],
              [45.478905, 34.043778],
              [45.479202, 34.04367],
              [45.479381, 34.043528],
              [45.479641, 34.043037],
              [45.479655, 34.042872],
              [45.479422, 34.042356],
              [45.479231, 34.042103],
              [45.479028, 34.041896],
              [45.478119, 34.041295],
              [45.477973, 34.041057],
              [45.477891, 34.040863],
              [45.477874, 34.040614],
              [45.477921, 34.040452],
              [45.478201, 34.040157],
              [45.478249, 34.040004],
              [45.478221, 34.039841],
              [45.478139, 34.039739],
              [45.477747, 34.039759],
              [45.477251, 34.039316],
              [45.477031, 34.039054],
              [45.476913, 34.038825],
              [45.47686, 34.038577],
              [45.476865, 34.037451],
              [45.477088, 34.036759],
              [45.477641, 34.035848],
              [45.477693, 34.035575],
              [45.477662, 34.035328],
              [45.47757, 34.035143],
              [45.477411, 34.035005],
              [45.476918, 34.034755],
              [45.475854, 34.034553],
              [45.475113, 34.034509],
              [45.474634, 34.03461],
              [45.473849, 34.034872],
              [45.473307, 34.035292],
              [45.472716, 34.035432],
              [45.472442, 34.035549],
              [45.471915, 34.035627],
              [45.471712, 34.035574],
              [45.471546, 34.035454],
              [45.471291, 34.035158],
              [45.470846, 34.034887],
              [45.469952, 34.034553],
              [45.469822, 34.034472],
              [45.469725, 34.034311],
              [45.469698, 34.034196],
              [45.469765, 34.034075],
              [45.470035, 34.033804],
              [45.472362, 34.033505],
              [45.472759, 34.033099],
              [45.473044, 34.032265],
              [45.473128, 34.031316],
              [45.473088, 34.030493],
              [45.473134, 34.029567],
              [45.473077, 34.029192],
              [45.472859, 34.02867],
              [45.47216, 34.027679],
              [45.471437, 34.02708],
              [45.470871, 34.026837],
              [45.470687, 34.026729],
              [45.470577, 34.026596],
              [45.470533, 34.026435],
              [45.470567, 34.026196],
              [45.47064, 34.025743],
              [45.470746, 34.025475],
              [45.47183, 34.02412],
              [45.471984, 34.024012],
              [45.472162, 34.023958],
              [45.472371, 34.02397],
              [45.472566, 34.024054],
              [45.474042, 34.025039],
              [45.474933, 34.025789],
              [45.475217, 34.025961],
              [45.4754, 34.025994],
              [45.475523, 34.025958],
              [45.475625, 34.025805],
              [45.475726, 34.025467],
              [45.475736, 34.025152],
              [45.475667, 34.024925],
              [45.475486, 34.024675],
              [45.474927, 34.023989],
              [45.47434, 34.023426],
              [45.474016, 34.023128],
              [45.473263, 34.022609],
              [45.472598, 34.02201],
              [45.472012, 34.021633],
              [45.471849, 34.021437],
              [45.471534, 34.020996],
              [45.471315, 34.020584],
              [45.47109, 34.019944],
              [45.470984, 34.019382],
              [45.470831, 34.019026],
              [45.470646, 34.018755],
              [45.470296, 34.018394],
              [45.470076, 34.018313],
              [45.469755, 34.018367],
              [45.469518, 34.019022],
              [45.469346, 34.019124],
              [45.46904, 34.01922],
              [45.468813, 34.019242],
              [45.468199, 34.019129],
              [45.467705, 34.0191],
              [45.467194, 34.018954],
              [45.466859, 34.018926],
              [45.466762, 34.018646],
              [45.466768, 34.018517],
              [45.467103, 34.017984],
              [45.467182, 34.017442],
              [45.467352, 34.017107],
              [45.467485, 34.016684],
              [45.467547, 34.016229],
              [45.467553, 34.01587],
              [45.467342, 34.015268],
              [45.467302, 34.015009],
              [45.467299, 34.014656],
              [45.467433, 34.014013],
              [45.467377, 34.013819],
              [45.467236, 34.013624],
              [45.46696, 34.013376],
              [45.466265, 34.012918],
              [45.46585, 34.012572],
              [45.465673, 34.012225],
              [45.465698, 34.012062],
              [45.465834, 34.011785],
              [45.466332, 34.011226],
              [45.466926, 34.010715],
              [45.467071, 34.010498],
              [45.467094, 34.010305],
              [45.466848, 34.009822],
              [45.466398, 34.009349],
              [45.464627, 34.008392],
              [45.463753, 34.008187],
              [45.463083, 34.008172],
              [45.462397, 34.008115],
              [45.461866, 34.007994],
              [45.461573, 34.008009],
              [45.460787, 34.007707],
              [45.46025, 34.007582],
              [45.45933, 34.007456],
              [45.459017, 34.007292],
              [45.458543, 34.007123],
              [45.458372, 34.00696],
              [45.458141, 34.006876],
              [45.457601, 34.00681],
              [45.456975, 34.006916],
              [45.454269, 34.006845],
              [45.45233, 34.006611],
              [45.452094, 34.00633],
              [45.451861, 34.005836],
              [45.451011, 34.004763],
              [45.450036, 34.003952],
              [45.449296, 34.003395],
              [45.448786, 34.003073],
              [45.448534, 34.002745],
              [45.448319, 34.002571],
              [45.447562, 34.002101],
              [45.446512, 34.001328],
              [45.446276, 34.001201],
              [45.445896, 34.001115],
              [45.445751, 34.000974],
              [45.445315, 34.000763],
              [45.444948, 34.000193],
              [45.444493, 33.999699],
              [45.444031, 33.999311],
              [45.443681, 33.998655],
              [45.442952, 33.998145],
              [45.442635, 33.998036],
              [45.441638, 33.997329],
              [45.441063, 33.997026],
              [45.440009, 33.996593],
              [45.439837, 33.996562],
              [45.439699, 33.996606],
              [45.439614, 33.996694],
              [45.438941, 33.997072],
              [45.438045, 33.997338],
              [45.437821, 33.997395],
              [45.437439, 33.997415],
              [45.437157, 33.997498],
              [45.436383, 33.997561],
              [45.435312, 33.997488],
              [45.434607, 33.997257],
              [45.434167, 33.996893],
              [45.434066, 33.996692],
              [45.434029, 33.996266],
              [45.433893, 33.996159],
              [45.433605, 33.996058],
              [45.433149, 33.996013],
              [45.432521, 33.99649],
              [45.431771, 33.996611],
              [45.431436, 33.996601],
              [45.431351, 33.996557],
              [45.431275, 33.996436],
              [45.430716, 33.996267],
              [45.430756, 33.995267],
              [45.430629, 33.994775],
              [45.430691, 33.993799],
              [45.43062, 33.993474],
              [45.430646, 33.993135],
              [45.430753, 33.992624],
              [45.431049, 33.992106],
              [45.431132, 33.991581],
              [45.431397, 33.990975],
              [45.431346, 33.990533],
              [45.431297, 33.99035],
              [45.431215, 33.99027],
              [45.430811, 33.990218],
              [45.429623, 33.990274],
              [45.42895, 33.990184],
              [45.428395, 33.990164],
              [45.427843, 33.990272],
              [45.427027, 33.990875],
              [45.426338, 33.991273],
              [45.425688, 33.991797],
              [45.425324, 33.992026],
              [45.424706, 33.991963],
              [45.423634, 33.991749],
              [45.423014, 33.991408],
              [45.422075, 33.990794],
              [45.421545, 33.990541],
              [45.42117, 33.9901],
              [45.420996, 33.989783],
              [45.420832, 33.989155],
              [45.420845, 33.988672],
              [45.420731, 33.98729],
              [45.42107, 33.986373],
              [45.421377, 33.98591],
              [45.421692, 33.98508],
              [45.422084, 33.984386],
              [45.422164, 33.984155],
              [45.422238, 33.983494],
              [45.422671, 33.982473],
              [45.422722, 33.982219],
              [45.422673, 33.981847],
              [45.42236, 33.981457],
              [45.421581, 33.980859],
              [45.4211, 33.98064],
              [45.419718, 33.979667],
              [45.419418, 33.979544],
              [45.41865, 33.979325],
              [45.418186, 33.97927],
              [45.417743, 33.979281],
              [45.417082, 33.979392],
              [45.416361, 33.979323],
              [45.415795, 33.979007],
              [45.415461, 33.978926],
              [45.413963, 33.978741],
              [45.412714, 33.978377],
              [45.411889, 33.978246],
              [45.411551, 33.978227],
              [45.410902, 33.978341],
              [45.410642, 33.978336],
              [45.407661, 33.977255]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241038,
        "tags": {
          "ISO3166-2": "IR-13",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "همدان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q187373"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [47.8320284, 34.8577943],
              [47.8256962, 34.8567797],
              [47.8231499, 34.8573783],
              [47.8092814, 34.8562871],
              [47.7971938, 34.8511636],
              [47.8016517, 34.8427232],
              [47.8002654, 34.834387],
              [47.8019318, 34.8321766],
              [47.8074886, 34.8210617],
              [47.8119316, 34.8163433],
              [47.8135985, 34.8143945],
              [47.813875, 34.8138351],
              [47.8488783, 34.7649533],
              [47.8488783, 34.7646736],
              [47.8491549, 34.7630045],
              [47.8511014, 34.7591159],
              [47.8513784, 34.7585565],
              [47.8533214, 34.7549475],
              [47.854155, 34.7541175],
              [47.8558215, 34.7507792],
              [47.8574883, 34.7443914],
              [47.8577684, 34.7441117],
              [47.8577684, 34.741053],
              [47.8574884, 34.7407824],
              [47.8572114, 34.7388335],
              [47.8574883, 34.7382831],
              [47.8574883, 34.7380035],
              [47.8574883, 34.7377238],
              [47.858045, 34.7371734],
              [47.8591548, 34.7346742],
              [47.8624916, 34.7302261],
              [47.8649917, 34.7229991],
              [47.8652683, 34.7224487],
              [47.8630449, 34.694668],
              [47.8638784, 34.6913386],
              [47.8638785, 34.6910589],
              [47.8644351, 34.6880001],
              [47.8641581, 34.684391],
              [47.8636016, 34.6827218],
              [47.854712, 34.6718944],
              [47.8538784, 34.6674462],
              [47.8536018, 34.6613377],
              [47.8555451, 34.6535598],
              [47.8569351, 34.6510605],
              [47.8569351, 34.6507807],
              [47.8572117, 34.6505011],
              [47.8574886, 34.6499416],
              [47.8577687, 34.649671],
              [47.8586019, 34.6482813],
              [47.8588785, 34.6477219],
              [47.865545, 34.6332761],
              [47.8730448, 34.6293872],
              [47.8802684, 34.6279975],
              [47.8833248, 34.6279976],
              [47.8838819, 34.6282773],
              [47.8866581, 34.6282773],
              [47.8908249, 34.6291164],
              [47.8938817, 34.6291165],
              [47.8944348, 34.6288368],
              [47.895268, 34.6288368],
              [47.899438, 34.6277269],
              [47.9013814, 34.6271675],
              [47.9099914, 34.6271676],
              [47.9122144, 34.6268878],
              [47.9149911, 34.6268878],
              [47.9166579, 34.6266081],
              [47.9313809, 34.6254983],
              [47.9319375, 34.625778],
              [47.9358279, 34.625778],
              [47.9369376, 34.6254983],
              [47.9386044, 34.6254983],
              [47.9394376, 34.6252186],
              [47.9424943, 34.6252186],
              [47.943051, 34.6249389],
              [47.9547173, 34.6227191],
              [47.9549942, 34.6221688],
              [47.9552708, 34.6216093],
              [47.968327, 34.6077525],
              [47.9733271, 34.602444],
              [47.9811074, 34.5985551],
              [47.9819405, 34.5985551],
              [47.9822171, 34.5982753],
              [47.9827738, 34.5982753],
              [47.9841637, 34.5979956],
              [47.9844407, 34.597725],
              [47.9852738, 34.5977249],
              [47.9861071, 34.5971655],
              [47.9872172, 34.5971654],
              [47.9874969, 34.5968858],
              [47.9913838, 34.594666],
              [47.9930502, 34.5932764],
              [47.9994402, 34.5866082],
              [48.001107, 34.5874384],
              [48.0133303, 34.5893874],
              [48.0211102, 34.5966061],
              [48.0219433, 34.5966061],
              [48.02222, 34.5963264],
              [48.0252767, 34.5949458],
              [48.0330534, 34.5879979],
              [48.0344432, 34.5885573],
              [48.0372199, 34.5907771],
              [48.0397199, 34.5974453],
              [48.0399999, 34.6002245],
              [48.0397199, 34.6016051],
              [48.038053, 34.6077229],
              [48.0377764, 34.6080025],
              [48.0422194, 34.6232788],
              [48.043053, 34.6232789],
              [48.0433332, 34.6235586],
              [48.044443, 34.6235586],
              [48.0449996, 34.6232788],
              [48.0458328, 34.6232788],
              [48.0461098, 34.6229992],
              [48.0466665, 34.6229991],
              [48.0497196, 34.6204997],
              [48.0516662, 34.6180003],
              [48.0527764, 34.6160603],
              [48.0681225, 34.5954303],
              [48.0686095, 34.5949459],
              [48.0686096, 34.5946662],
              [48.0855561, 34.57606],
              [48.0863893, 34.5743817],
              [48.0872225, 34.571052],
              [48.0833326, 34.554945],
              [48.0849994, 34.5502258],
              [48.0977791, 34.5382785],
              [48.1008358, 34.5307708],
              [48.1013894, 34.5296699],
              [48.1013894, 34.5257717],
              [48.1013894, 34.5210523],
              [48.0988894, 34.5104944],
              [48.0913896, 34.4985559],
              [48.090556, 34.4935566],
              [48.0908361, 34.492167],
              [48.0975028, 34.4791093],
              [48.1025029, 34.4732799],
              [48.103336, 34.4713306],
              [48.1036127, 34.4710509],
              [48.1050029, 34.4674413],
              [48.0991696, 34.4546632],
              [48.0958363, 34.4507737],
              [48.0938894, 34.4457744],
              [48.0933363, 34.4432747],
              [48.0919465, 34.4346656],
              [48.0913899, 34.4341061],
              [48.0913899, 34.4338263],
              [48.0905562, 34.4329962],
              [48.0905563, 34.4321569],
              [48.0858332, 34.4182685],
              [48.0836131, 34.4160485],
              [48.0802799, 34.414379],
              [48.0758333, 34.413278],
              [48.0744466, 34.4132781],
              [48.07389, 34.4129982],
              [48.06111, 34.4085492],
              [48.0572236, 34.4016094],
              [48.0558337, 34.39883],
              [48.0555568, 34.3985502],
              [48.047777, 34.3907711],
              [48.0458336, 34.3899408],
              [48.0444437, 34.3899409],
              [48.0444438, 34.3896611],
              [48.0408339, 34.3896611],
              [48.0402772, 34.3899408],
              [48.0344439, 34.3907711],
              [48.019444, 34.3968806],
              [48.0186107, 34.3974401],
              [48.0172209, 34.3982703],
              [48.0166642, 34.3982703],
              [48.0149973, 34.3982704],
              [48.0144442, 34.3985501],
              [48.0136107, 34.3985502],
              [48.0130539, 34.3988299],
              [48.0013878, 34.4013296],
              [47.9985594, 34.4014534],
              [47.9905181, 34.4017389],
              [47.9901187, 34.4015108],
              [47.989713, 34.4013069],
              [47.989441, 34.4010498],
              [47.9886078, 34.3979905],
              [47.9936287, 34.364661],
              [47.9783315, 34.3596544],
              [47.9777745, 34.3593836],
              [47.9633281, 34.3552142],
              [47.9524951, 34.3454946],
              [47.9502716, 34.3393759],
              [47.9452719, 34.3268856],
              [47.9408286, 34.3196567],
              [47.916659, 34.2977172],
              [47.9138824, 34.2957678],
              [47.9138824, 34.295488],
              [47.9066592, 34.2813278],
              [47.901106, 34.2732683],
              [47.8927691, 34.2679887],
              [47.8916594, 34.2679887],
              [47.8916594, 34.2677089],
              [47.8877695, 34.2618787],
              [47.8866593, 34.2552092],
              [47.8872163, 34.2546586],
              [47.8874929, 34.2543789],
              [47.8874929, 34.2540991],
              [47.889993, 34.2507688],
              [47.889993, 34.2502093],
              [47.9002729, 34.2388285],
              [47.9002729, 34.2385487],
              [47.9033261, 34.2385487],
              [47.9041593, 34.2388285],
              [47.9049925, 34.2388285],
              [47.9077727, 34.2399386],
              [47.9083258, 34.2399386],
              [47.9113825, 34.2407689],
              [47.9230491, 34.2440992],
              [47.9311055, 34.2452094],
              [47.9316622, 34.2454891],
              [47.9349954, 34.2454892],
              [47.935549, 34.245769],
              [47.9386057, 34.2457689],
              [47.9436054, 34.244379],
              [47.9449953, 34.2440993],
              [47.9647187, 34.2313286],
              [47.9697185, 34.2293792],
              [47.9705517, 34.2293792],
              [47.9711083, 34.2293792],
              [47.9713853, 34.2293792],
              [47.9727752, 34.2291084],
              [47.9852751, 34.222159],
              [47.999997, 34.218371],
              [48.0005546, 34.2207691],
              [48.0047216, 34.2207692],
              [48.0055548, 34.221049],
              [48.0074982, 34.221049],
              [48.0077748, 34.2207692],
              [48.0105549, 34.2207692],
              [48.0119413, 34.2202096],
              [48.0130546, 34.219659],
              [48.0191644, 34.217159],
              [48.0211113, 34.2171591],
              [48.0216645, 34.2168793],
              [48.0269447, 34.2168793],
              [48.0272212, 34.217159],
              [48.0283311, 34.2171591],
              [48.0286112, 34.2168793],
              [48.0388875, 34.2168793],
              [48.0427778, 34.2163288],
              [48.0433345, 34.216049],
              [48.0444443, 34.216049],
              [48.0452775, 34.2157692],
              [48.0463876, 34.2157692],
              [48.0466678, 34.2154894],
              [48.0477776, 34.2154894],
              [48.053891, 34.2127187],
              [48.0547242, 34.2115996],
              [48.0558344, 34.2099299],
              [48.0705574, 34.1990994],
              [48.0722242, 34.1954892],
              [48.0722242, 34.1946589],
              [48.0811139, 34.1771585],
              [48.0817616, 34.1766932],
              [48.0822241, 34.1763281],
              [48.0822241, 34.1760484],
              [48.0900039, 34.1702088],
              [48.0916704, 34.1685482],
              [48.0933372, 34.1671582],
              [48.100837, 34.1535476],
              [48.1080603, 34.1465979],
              [48.1108368, 34.1457676],
              [48.1122271, 34.1457676],
              [48.1130603, 34.1454877],
              [48.1233367, 34.1454878],
              [48.1238933, 34.1457676],
              [48.1258367, 34.1457676],
              [48.1263934, 34.1454878],
              [48.1275036, 34.1454878],
              [48.1280602, 34.145217],
              [48.1286169, 34.145217],
              [48.1291701, 34.1452171],
              [48.1294501, 34.1449373],
              [48.1358366, 34.1421574],
              [48.1363932, 34.1415977],
              [48.1369499, 34.1415978],
              [48.1372268, 34.141327],
              [48.1377835, 34.1410472],
              [48.1447266, 34.1338177],
              [48.1527831, 34.1221563],
              [48.1538933, 34.1207665],
              [48.1675065, 34.1057655],
              [48.167783, 34.1049352],
              [48.1686163, 34.1040958],
              [48.1688964, 34.1032654],
              [48.1693972, 34.1027568],
              [48.1747297, 34.0918747],
              [48.1763966, 34.087434],
              [48.1769497, 34.0868744],
              [48.1772298, 34.086044],
              [48.1861194, 34.0804931],
              [48.1869531, 34.0796536],
              [48.1880628, 34.079094],
              [48.1916727, 34.0790941],
              [48.193063, 34.0788233],
              [48.2147294, 34.0674326],
              [48.2152862, 34.0671527],
              [48.2177858, 34.0657627],
              [48.2308423, 34.0543719],
              [48.2344526, 34.0513211],
              [48.2358424, 34.0507614],
              [48.2405656, 34.0491006],
              [48.2461223, 34.0491006],
              [48.2538987, 34.0507615],
              [48.255842, 34.0515919],
              [48.2741787, 34.0540921],
              [48.2752886, 34.054372],
              [48.2866786, 34.054372],
              [48.2880685, 34.0546518],
              [48.2897349, 34.0546518],
              [48.2905686, 34.0549316],
              [48.2930682, 34.0549316],
              [48.2983449, 34.0560419],
              [48.2994582, 34.0560419],
              [48.3011249, 34.0566015],
              [48.3025117, 34.0566015],
              [48.3030684, 34.0568723],
              [48.3044582, 34.0566015],
              [48.3052915, 34.055762],
              [48.3052915, 34.0554912],
              [48.305568, 34.0552115],
              [48.305845, 34.0546519],
              [48.3050114, 34.0413202],
              [48.3047348, 34.0390999],
              [48.3047348, 34.0379897],
              [48.3039017, 34.0285393],
              [48.3036251, 34.0268694],
              [48.3039017, 34.0265987],
              [48.3041783, 34.0227084],
              [48.304735, 34.0213183],
              [48.3227915, 34.0168774],
              [48.3230681, 34.0165976],
              [48.3250146, 34.0165976],
              [48.3319582, 34.0149278],
              [48.3325148, 34.0149278],
              [48.3327914, 34.014648],
              [48.333348, 34.0143772],
              [48.3522379, 34.0068765],
              [48.3791841, 34.0013163],
              [48.3849697, 34.0013163],
              [48.3883507, 34.0013163],
              [48.3908508, 34.0013163],
              [48.3933504, 34.0013163],
              [48.3944606, 34.0015961],
              [48.3977939, 34.0015961],
              [48.3989072, 34.0018759],
              [48.4044604, 34.0018759],
              [48.4055738, 34.0021558],
              [48.4105738, 34.0021558],
              [48.4147404, 34.0024266],
              [48.4158502, 34.0027064],
              [48.420017, 34.0027065],
              [48.4433534, 34.0082667],
              [48.4447398, 34.0082666],
              [48.4455734, 34.0085465],
              [48.4550196, 34.0085464],
              [48.4561299, 34.0088172],
              [48.4605764, 34.0085465],
              [48.4705762, 34.006317],
              [48.4714094, 34.006317],
              [48.4719661, 34.006317],
              [48.4722371, 34.0063171],
              [48.4736329, 34.006317],
              [48.474186, 34.0065969],
              [48.4750197, 34.0065969],
              [48.4752994, 34.0068767],
              [48.476133, 34.0068767],
              [48.4811327, 34.0090971],
              [48.4830761, 34.0102073],
              [48.5114124, 34.0441008],
              [48.5194655, 34.0507621],
              [48.520299, 34.0568728],
              [48.520022, 34.0571525],
              [48.5191887, 34.0604832],
              [48.5189121, 34.0632632],
              [48.5189122, 34.0652127],
              [48.5186321, 34.0660431],
              [48.5191887, 34.0874347],
              [48.5197453, 34.0938251],
              [48.5214122, 34.100766],
              [48.5258551, 34.1065967],
              [48.5269684, 34.1071563],
              [48.5344687, 34.1077069],
              [48.5364115, 34.1074361],
              [48.5405785, 34.1054865],
              [48.5414117, 34.1052158],
              [48.5414117, 34.1049359],
              [48.5450251, 34.102156],
              [48.5458583, 34.1018762],
              [48.5469685, 34.1004863],
              [48.5489115, 34.096596],
              [48.5489115, 34.0954859],
              [48.5494682, 34.094105],
              [48.5500249, 34.0915957],
              [48.5528015, 34.077434],
              [48.5530785, 34.0763148],
              [48.5566919, 34.0696536],
              [48.5597482, 34.0671535],
              [48.5603017, 34.0665938],
              [48.5641916, 34.0654837],
              [48.5650248, 34.0654837],
              [48.5672483, 34.0649331],
              [48.5730817, 34.063543],
              [48.574468, 34.0635431],
              [48.5755813, 34.0632633],
              [48.580858, 34.0632632],
              [48.5816912, 34.063543],
              [48.5858581, 34.0635431],
              [48.5864147, 34.0638229],
              [48.5875245, 34.0638229],
              [48.5886378, 34.0643825],
              [48.5894714, 34.0643825],
              [48.5994712, 34.0702133],
              [48.6141941, 34.0935454],
              [48.6144706, 34.0938253],
              [48.6172508, 34.0960456],
              [48.6219708, 34.0963164],
              [48.6233607, 34.0957658],
              [48.6244709, 34.0957658],
              [48.6247506, 34.0954861],
              [48.6258607, 34.0954861],
              [48.6333605, 34.0890957],
              [48.6339171, 34.0890958],
              [48.6341937, 34.0885451],
              [48.6469737, 34.0821548],
              [48.6474543, 34.0783667],
              [48.6576542, 34.0760602],
              [48.6593973, 34.0792887],
              [48.6618974, 34.0787291],
              [48.6680073, 34.0787291],
              [48.6672504, 34.0788242],
              [48.67225, 34.0790951],
              [48.6805868, 34.0815953],
              [48.6850299, 34.0835448],
              [48.7094765, 34.0918759],
              [48.7128097, 34.0946558],
              [48.7150329, 34.0979864],
              [48.7155864, 34.1032665],
              [48.7153094, 34.1040968],
              [48.7150329, 34.1054869],
              [48.7116995, 34.1163178],
              [48.7130863, 34.1213272],
              [48.7133664, 34.1221575],
              [48.7147527, 34.1227081],
              [48.7158659, 34.1232677],
              [48.7169762, 34.1232677],
              [48.7175328, 34.1235475],
              [48.7219759, 34.1235476],
              [48.722533, 34.1232677],
              [48.7236428, 34.1232677],
              [48.7308659, 34.1210474],
              [48.7478094, 34.0977157],
              [48.7491992, 34.0960459],
              [48.7497559, 34.0954862],
              [48.7500324, 34.0952155],
              [48.7530891, 34.0918759],
              [48.7583658, 34.0846552],
              [48.7597557, 34.0804942],
              [48.765589, 34.072434],
              [48.7792022, 34.0649335],
              [48.7800355, 34.0641031],
              [48.7944787, 34.0568732],
              [48.7969788, 34.0557631],
              [48.804202, 34.0527122],
              [48.8139252, 34.0499322],
              [48.8147584, 34.0499322],
              [48.8403148, 34.0371513],
              [48.8408715, 34.0366007],
              [48.8417048, 34.0363209],
              [48.8439283, 34.0338207],
              [48.8458716, 34.0260401],
              [48.8458717, 34.0177089],
              [48.8461482, 34.0174381],
              [48.8461482, 34.0154884],
              [48.8469815, 34.013268],
              [48.8472615, 34.0129881],
              [48.849205, 34.006047],
              [48.8517047, 34.0027073],
              [48.8544813, 34.0018768],
              [48.8611478, 34.0010465],
              [48.8675377, 34.0027073],
              [48.868928, 34.0027074],
              [48.8725379, 34.0035467],
              [48.8742043, 34.0035468],
              [48.8789279, 34.004657],
              [48.8828178, 34.004657],
              [48.890041, 34.0035468],
              [48.8911512, 34.0032669],
              [48.8936507, 34.003267],
              [48.8975407, 34.0040974],
              [48.8980943, 34.0043772],
              [48.8992075, 34.0043772],
              [48.9042073, 34.0063179],
              [48.9103176, 34.0110477],
              [48.9117073, 34.0140985],
              [48.9122641, 34.0185394],
              [48.911984, 34.0190991],
              [48.9117074, 34.0202093],
              [48.9136507, 34.0274302],
              [48.9161503, 34.0285404],
              [48.9203205, 34.0285404],
              [48.9225403, 34.0282697],
              [48.9280971, 34.0268706],
              [48.9305973, 34.0240997],
              [48.9308738, 34.0218701],
              [48.9419869, 34.0132682],
              [48.9433768, 34.012149],
              [48.9436537, 34.0118781],
              [48.9442104, 34.0110477],
              [48.9442104, 34.0102083],
              [48.9444869, 34.0099284],
              [48.9447636, 34.0063179],
              [48.9475437, 34.0029873],
              [48.9480968, 34.0029873],
              [48.948377, 34.0027074],
              [48.9500438, 34.0027075],
              [48.9692101, 34.0088183],
              [48.9694866, 34.0090981],
              [48.9778232, 34.0090981],
              [48.9808764, 34.0096488],
              [48.9811565, 34.0099286],
              [48.9819897, 34.0099286],
              [48.9825433, 34.0102084],
              [48.9836565, 34.0102084],
              [48.9855999, 34.010768],
              [49.0039326, 34.0204893],
              [49.0111558, 34.0221501],
              [49.0158793, 34.0221501],
              [49.0167126, 34.0218703],
              [49.0178228, 34.0218704],
              [49.0353259, 34.0154889],
              [49.0361591, 34.0154889],
              [49.0367122, 34.015209],
              [49.0378259, 34.015209],
              [49.0383791, 34.0149291],
              [49.0389357, 34.015209],
              [49.0408791, 34.015209],
              [49.0425456, 34.0157687],
              [49.0433788, 34.0168789],
              [49.0433788, 34.0171497],
              [49.0461589, 34.0163193],
              [49.0467121, 34.0163192],
              [49.046712, 34.0160394],
              [49.0556021, 34.0157687],
              [49.061992, 34.0140988],
              [49.0622687, 34.013819],
              [49.0631023, 34.013819],
              [49.063382, 34.0135392],
              [49.0642155, 34.0132685],
              [49.0678254, 34.0135392],
              [49.0681019, 34.013819],
              [49.0700485, 34.013819],
              [49.0703254, 34.0140988],
              [49.0731051, 34.0140989],
              [49.0739388, 34.0143786],
              [49.0750486, 34.0143787],
              [49.0758818, 34.0146495],
              [49.0775724, 34.01471],
              [49.0786584, 34.0149292],
              [49.0797717, 34.0149293],
              [49.0803252, 34.0152091],
              [49.0811585, 34.0152091],
              [49.091995, 34.0218704],
              [49.0975482, 34.0288207],
              [49.1017147, 34.0404824],
              [49.1031049, 34.0446525],
              [49.107828, 34.0482629],
              [49.1172712, 34.0515936],
              [49.1214377, 34.0538231],
              [49.1225514, 34.0546535],
              [49.1419944, 34.0766048],
              [49.1472741, 34.0807658],
              [49.153664, 34.0838255],
              [49.1672741, 34.0935465],
              [49.171164, 34.0999368],
              [49.1714405, 34.1002076],
              [49.1728305, 34.1018774],
              [49.173107, 34.1027078],
              [49.1734573, 34.1031297],
              [49.1753304, 34.1115983],
              [49.1750539, 34.1121578],
              [49.1736636, 34.1163187],
              [49.1717207, 34.1171582],
              [49.1683874, 34.1171581],
              [49.1606071, 34.1160479],
              [49.1597739, 34.1157681],
              [49.1572738, 34.1157682],
              [49.1531073, 34.1163186],
              [49.1525506, 34.1165985],
              [49.1500506, 34.1165984],
              [49.1394941, 34.1190986],
              [49.1392176, 34.1193784],
              [49.1383843, 34.1193784],
              [49.1167179, 34.1352185],
              [49.1111611, 34.1421593],
              [49.1108845, 34.1429897],
              [49.1103279, 34.1432695],
              [49.1092177, 34.145219],
              [49.1081043, 34.1471595],
              [49.1044946, 34.1513293],
              [49.1008811, 34.1532698],
              [49.1003281, 34.1532699],
              [49.1000479, 34.1535496],
              [49.0992148, 34.1546598],
              [49.0989378, 34.1552104],
              [49.0983811, 34.1554901],
              [49.0979816, 34.1558944],
              [49.093938, 34.1627197],
              [49.0936614, 34.1641006],
              [49.093938, 34.1691007],
              [49.0947712, 34.1721604],
              [49.0997713, 34.1788212],
              [49.1025479, 34.1796606],
              [49.1052979, 34.1806167],
              [49.1072711, 34.1810416],
              [49.1106044, 34.1824315],
              [49.1114376, 34.1824315],
              [49.1197709, 34.1863215],
              [49.1233842, 34.1910418],
              [49.1244941, 34.1985419],
              [49.1242175, 34.1991015],
              [49.1239374, 34.2004914],
              [49.1236608, 34.2016016],
              [49.1236607, 34.2018813],
              [49.1242175, 34.2021611],
              [49.124494, 34.2029915],
              [49.1242174, 34.2032713],
              [49.1156044, 34.2202118],
              [49.1153274, 34.2218815],
              [49.1161609, 34.2257714],
              [49.1169941, 34.2271613],
              [49.118384, 34.2291108],
              [49.118661, 34.2293815],
              [49.1189375, 34.2296613],
              [49.1231041, 34.2374411],
              [49.1239373, 34.2429916],
              [49.1236607, 34.2435512],
              [49.1228274, 34.2466017],
              [49.1219942, 34.2479916],
              [49.1217173, 34.2488219],
              [49.1194941, 34.2510511],
              [49.1133842, 34.2546612],
              [49.1106041, 34.2557712],
              [49.1092174, 34.2557712],
              [49.1061611, 34.2566016],
              [49.1039376, 34.2566016],
              [49.1033809, 34.2568813],
              [49.1011609, 34.2568813],
              [49.1006043, 34.2571611],
              [49.0992145, 34.2571611],
              [49.0986609, 34.2574408],
              [49.0975476, 34.2574409],
              [49.0967143, 34.2577117],
              [49.0933811, 34.2579913],
              [49.0931046, 34.2582711],
              [49.0919944, 34.2582712],
              [49.0839379, 34.2629913],
              [49.0792144, 34.2735506],
              [49.0789379, 34.2738304],
              [49.0700478, 34.2835504],
              [49.0650481, 34.2854907],
              [49.0644914, 34.2857705],
              [49.0642148, 34.2860502],
              [49.0639348, 34.2863209],
              [49.0506017, 34.2904905],
              [49.0450449, 34.2977195],
              [49.0433781, 34.2996598],
              [49.0400447, 34.3027102],
              [49.038935, 34.3029901],
              [49.036435, 34.30299],
              [49.0361584, 34.3032698],
              [49.0331017, 34.3032698],
              [49.0256019, 34.3054899],
              [49.0208784, 34.3096594],
              [49.015602, 34.3193881],
              [49.0108785, 34.3224386],
              [49.0089319, 34.3241081],
              [49.0089319, 34.3257687],
              [49.0125454, 34.3296674],
              [49.0147683, 34.3332683],
              [49.0158785, 34.3388275],
              [49.0153219, 34.3416072],
              [49.0150454, 34.3432767],
              [49.015602, 34.344107],
              [49.0161973, 34.3448964],
              [49.0097652, 34.3549366],
              [49.0094885, 34.3557759],
              [49.009212, 34.3568859],
              [49.0092119, 34.3618855],
              [49.0122651, 34.3782741],
              [49.007265, 34.3843837],
              [48.9922654, 34.3891035],
              [48.9917088, 34.3893833],
              [48.990322, 34.3893833],
              [48.9894889, 34.389663],
              [48.9855989, 34.389663],
              [48.9836556, 34.389663],
              [48.9755987, 34.3866037],
              [48.9747655, 34.3866037],
              [48.9683754, 34.3841129],
              [48.9647657, 34.3832737],
              [48.9608757, 34.3827232],
              [48.9603191, 34.3824433],
              [48.9589323, 34.3824434],
              [48.9583757, 34.3827231],
              [48.9561526, 34.3827231],
              [48.9547623, 34.3829938],
              [48.9525423, 34.3841129],
              [48.9500427, 34.388553],
              [48.9497625, 34.3896629],
              [48.9511524, 34.3991026],
              [48.951429, 34.3996621],
              [48.9528193, 34.4016113],
              [48.9555955, 34.4043818],
              [48.9661523, 34.4099408],
              [48.977542, 34.4174401],
              [48.9819886, 34.4193894],
              [48.9828222, 34.4193893],
              [48.9842086, 34.4199398],
              [48.9858754, 34.4199399],
              [48.986432, 34.4202195],
              [48.9875418, 34.4202196],
              [48.9880985, 34.4204994],
              [48.9942118, 34.4204994],
              [48.994765, 34.4207791],
              [48.9961552, 34.4207791],
              [48.9983783, 34.4216093],
              [49.0005983, 34.4221598],
              [49.003655, 34.4238294],
              [49.0053219, 34.4257695],
              [49.0078215, 34.4313285],
              [49.0108782, 34.4360482],
              [49.0153216, 34.4454965],
              [49.0156017, 34.4477255],
              [49.014768, 34.4516058],
              [49.0072647, 34.4588342],
              [49.0072647, 34.4591139],
              [49.0067116, 34.4593847],
              [49.0030982, 34.4624438],
              [49.0036549, 34.4652232],
              [49.0036549, 34.4657827],
              [49.0103214, 34.4710528],
              [49.0119882, 34.4724424],
              [49.0197681, 34.4793909],
              [49.0314347, 34.4952189],
              [49.0339344, 34.4960582],
              [49.0492108, 34.4988286],
              [49.0531008, 34.5013372],
              [49.0547675, 34.5052174],
              [49.0547675, 34.5074373],
              [49.0547675, 34.5079968],
              [49.0539343, 34.5107761],
              [49.0447677, 34.5218843],
              [49.0400442, 34.5302222],
              [49.039491, 34.5363403],
              [49.0339342, 34.5443894],
              [49.0336577, 34.5449398],
              [49.033101, 34.5452195],
              [49.0317111, 34.5485583],
              [49.0317111, 34.551888],
              [49.0317111, 34.5543875],
              [49.0314346, 34.5546672],
              [49.029211, 34.5602258],
              [49.0286544, 34.5605054],
              [49.0283778, 34.5613357],
              [49.0203211, 34.5693936],
              [49.0194878, 34.569944],
              [49.0086547, 34.5860598],
              [49.0078211, 34.58689],
              [49.005878, 34.5907791],
              [49.0014314, 34.5971675],
              [49.0011545, 34.5974473],
              [49.0028213, 34.5991166],
              [49.0097644, 34.601607],
              [49.0097644, 34.6018868],
              [49.0114313, 34.6018867],
              [49.0186544, 34.6060555],
              [49.0197677, 34.6077248],
              [49.0208775, 34.6093941],
              [49.0239342, 34.6121643],
              [49.0311543, 34.6132742],
              [49.0319911, 34.6135538],
              [49.0356008, 34.6135539],
              [49.0383775, 34.614393],
              [49.0397673, 34.614393],
              [49.0442108, 34.6163331],
              [49.0550473, 34.6329988],
              [49.060047, 34.6349478],
              [49.0619904, 34.6349478],
              [49.0625471, 34.634668],
              [49.0633803, 34.6346681],
              [49.0672671, 34.6329988],
              [49.0683804, 34.6321687],
              [49.0700468, 34.6285595],
              [49.0700468, 34.6227215],
              [49.0742138, 34.6055052],
              [49.0742138, 34.5932786],
              [49.0739373, 34.5924485],
              [49.0742138, 34.5916093],
              [49.0739372, 34.5907792],
              [49.0742139, 34.5902288],
              [49.0753236, 34.588],
              [49.0775471, 34.58606],
              [49.0800472, 34.5852298],
              [49.0803237, 34.5849501],
              [49.0808804, 34.58495],
              [49.0811569, 34.5846704],
              [49.0825468, 34.5846704],
              [49.0831035, 34.5843906],
              [49.0864372, 34.5843907],
              [49.0869903, 34.5846704],
              [49.090047, 34.5846704],
              [49.0906036, 34.5849501],
              [49.0933803, 34.5849501],
              [49.0939369, 34.5852298],
              [49.0972702, 34.5852299],
              [49.0994937, 34.5855006],
              [49.1003269, 34.5857803],
              [49.1028269, 34.5857803],
              [49.1056036, 34.5863307],
              [49.1061601, 34.5866104],
              [49.1069934, 34.5866104],
              [49.118103, 34.5960579],
              [49.1189367, 34.5963286],
              [49.1197698, 34.5968881],
              [49.1203265, 34.5971678],
              [49.1278262, 34.6030058],
              [49.1347728, 34.6135541],
              [49.1356064, 34.6182732],
              [49.1353263, 34.6188326],
              [49.1350498, 34.6205019],
              [49.1347728, 34.6221712],
              [49.1350497, 34.6280001],
              [49.1353263, 34.629119],
              [49.1328262, 34.6366172],
              [49.1350497, 34.6480043],
              [49.1336594, 34.6552226],
              [49.1336593, 34.6599507],
              [49.1333829, 34.6605011],
              [49.1331063, 34.6635599],
              [49.1328262, 34.6652291],
              [49.1325496, 34.6668893],
              [49.1322729, 34.6682788],
              [49.1319929, 34.6693887],
              [49.1317159, 34.6716173],
              [49.1317159, 34.6735572],
              [49.1317159, 34.6741167],
              [49.1314394, 34.6743963],
              [49.1314394, 34.6760656],
              [49.1311593, 34.676616],
              [49.1281061, 34.6860629],
              [49.1244927, 34.6943908],
              [49.1239361, 34.6952299],
              [49.1211594, 34.6996692],
              [49.1056032, 34.7274497],
              [49.1050462, 34.7280092],
              [49.1025464, 34.7377264],
              [49.1028265, 34.7505111],
              [49.1031031, 34.7535606],
              [49.1033795, 34.7555095],
              [49.1072695, 34.7646762],
              [49.1072695, 34.7649559],
              [49.1086594, 34.7663363],
              [49.1089363, 34.766616],
              [49.1153259, 34.772733],
              [49.1392158, 34.788558],
              [49.1425491, 34.7910662],
              [49.1492156, 34.7971742],
              [49.1544954, 34.8066203],
              [49.1575488, 34.8285617],
              [49.1586622, 34.8318998],
              [49.1586622, 34.8327298],
              [49.1619955, 34.8391172],
              [49.1639385, 34.841896],
              [49.1672721, 34.8468941],
              [49.1678287, 34.8491224],
              [49.1681053, 34.8494021],
              [49.1636618, 34.8566195],
              [49.1628287, 34.8588388],
              [49.1631052, 34.8607875],
              [49.1681052, 34.8660652],
              [49.1692186, 34.8660651],
              [49.1697717, 34.8663448],
              [49.1750519, 34.8663448],
              [49.1778285, 34.8655149],
              [49.1786617, 34.8657855],
              [49.1789383, 34.8657855],
              [49.1808852, 34.8646759],
              [49.1917183, 34.8621769],
              [49.1928281, 34.8621769],
              [49.1956083, 34.8613468],
              [49.1964414, 34.8613469],
              [49.2017181, 34.8585683],
              [49.2025513, 34.8577292],
              [49.2042181, 34.8530109],
              [49.2044983, 34.8513419],
              [49.2050514, 34.8482834],
              [49.2050514, 34.8480038],
              [49.205608, 34.8471738],
              [49.2058846, 34.8460641],
              [49.2067182, 34.8438357],
              [49.209498, 34.8421757],
              [49.2117179, 34.8421758],
              [49.2183844, 34.8460641],
              [49.2186646, 34.8466235],
              [49.2256077, 34.8505119],
              [49.229498, 34.8530109],
              [49.2333879, 34.8613469],
              [49.2333879, 34.8616266],
              [49.2347742, 34.8638369],
              [49.2531109, 34.8838469],
              [49.2542206, 34.8846768],
              [49.2675538, 34.889395],
              [49.2681104, 34.8893951],
              [49.2686675, 34.8893952],
              [49.2697772, 34.8899544],
              [49.2706105, 34.8899545],
              [49.270887, 34.8902341],
              [49.2717207, 34.8902341],
              [49.2731105, 34.8907844],
              [49.2736672, 34.891064],
              [49.2925569, 34.906617],
              [49.2931101, 34.9068967],
              [49.2933902, 34.907456],
              [49.2968225, 34.9089059],
              [49.2981137, 34.9093956],
              [49.3036666, 34.9119035],
              [49.3045002, 34.9119035],
              [49.3056135, 34.9124539],
              [49.3061666, 34.9124539],
              [49.3070003, 34.912454],
              [49.3125566, 34.9135635],
              [49.3139469, 34.9135636],
              [49.3142235, 34.9138432],
              [49.3156133, 34.9138432],
              [49.3158899, 34.9141228],
              [49.3175567, 34.9141229],
              [49.3183899, 34.9144025],
              [49.3211701, 34.9144025],
              [49.3242232, 34.9149528],
              [49.3247799, 34.9152325],
              [49.3258896, 34.9152324],
              [49.3264462, 34.9155122],
              [49.3278365, 34.9155121],
              [49.3289463, 34.9160625],
              [49.3311698, 34.9160624],
              [49.331723, 34.916342],
              [49.3378364, 34.9163422],
              [49.338393, 34.9166217],
              [49.3400594, 34.9166218],
              [49.3408931, 34.9163421],
              [49.3433932, 34.9163421],
              [49.3442264, 34.9160624],
              [49.347003, 34.9160625],
              [49.3478362, 34.9157828],
              [49.349503, 34.9157828],
              [49.3558926, 34.9146823],
              [49.3567263, 34.9144026],
              [49.3583927, 34.9144026],
              [49.3658928, 34.9127337],
              [49.3678358, 34.912454],
              [49.3695027, 34.9119037],
              [49.3711691, 34.9119036],
              [49.3714492, 34.911624],
              [49.3753391, 34.911624],
              [49.3758927, 34.9119037],
              [49.3778392, 34.9119037],
              [49.3822826, 34.9130043],
              [49.3825592, 34.9132839],
              [49.3833925, 34.9132839],
              [49.3881155, 34.9152326],
              [49.3897823, 34.9174518],
              [49.3920059, 34.9260672],
              [49.3922824, 34.9268971],
              [49.3920058, 34.9274564],
              [49.3917288, 34.9291163],
              [49.3914488, 34.9302349],
              [49.3911723, 34.9316242],
              [49.3908957, 34.9335637],
              [49.3906156, 34.9338434],
              [49.3903389, 34.9352327],
              [49.3897824, 34.9374519],
              [49.3895057, 34.9385705],
              [49.3892257, 34.9396801],
              [49.3889491, 34.9407897],
              [49.3886725, 34.9416197],
              [49.3883924, 34.9432885],
              [49.3889491, 34.9452281],
              [49.3967289, 34.9480066],
              [49.3986724, 34.9488456],
              [49.3995055, 34.9488455],
              [49.4022821, 34.9502348],
              [49.4072818, 34.9560714],
              [49.4075619, 34.9574517],
              [49.4078385, 34.958011],
              [49.4078385, 34.9582906],
              [49.4078385, 34.9605098],
              [49.407562, 34.9607894],
              [49.4072818, 34.962738],
              [49.4070053, 34.9649572],
              [49.4047821, 34.9757913],
              [49.4050622, 34.9777308],
              [49.4075619, 34.9835673],
              [49.4128386, 34.9982892],
              [49.4142284, 35.0010676],
              [49.4142284, 35.0016269],
              [49.4058954, 35.0088434],
              [49.4050621, 35.0096824],
              [49.4039484, 35.009953],
              [49.4036719, 35.0102326],
              [49.4028386, 35.0102326],
              [49.4025621, 35.0105122],
              [49.4017285, 35.0105123],
              [49.3986721, 35.0119014],
              [49.3958955, 35.0127403],
              [49.3947822, 35.0127403],
              [49.3931155, 35.0132906],
              [49.391172, 35.0132906],
              [49.3908955, 35.0135702],
              [49.3800589, 35.0138408],
              [49.3792256, 35.0141205],
              [49.378392, 35.0138408],
              [49.3764491, 35.0138408],
              [49.3703356, 35.012181],
              [49.3683922, 35.0116217],
              [49.3647824, 35.0113511],
              [49.3636691, 35.0110715],
              [49.3578357, 35.0110714],
              [49.3556158, 35.0119013],
              [49.3483926, 35.0132905],
              [49.3422792, 35.0138407],
              [49.3411694, 35.0135701],
              [49.322003, 35.0138407],
              [49.3125563, 35.0127402],
              [49.3067231, 35.0116216],
              [49.3058898, 35.0116216],
              [49.2972798, 35.0077336],
              [49.29339, 35.0063445],
              [49.2925566, 35.0060649],
              [49.2889433, 35.0060648],
              [49.2842234, 35.0077337],
              [49.2828334, 35.0077337],
              [49.2758868, 35.0121808],
              [49.2656104, 35.0294011],
              [49.2639435, 35.0318998],
              [49.259777, 35.0421831],
              [49.2608868, 35.0516185],
              [49.2900564, 35.0757928],
              [49.290333, 35.0760725],
              [49.2939432, 35.078571],
              [49.3042232, 35.0843981],
              [49.3064462, 35.0849574],
              [49.3239462, 35.0832977],
              [49.3242227, 35.083018],
              [49.325056, 35.0830181],
              [49.3281127, 35.0810697],
              [49.3281126, 35.0805105],
              [49.3283893, 35.0802399],
              [49.328946, 35.0780119],
              [49.3295026, 35.0780119],
              [49.3297791, 35.0777323],
              [49.3328359, 35.0777323],
              [49.3356125, 35.0774617],
              [49.3367258, 35.0755133],
              [49.337836, 35.0730147],
              [49.3383927, 35.0724554],
              [49.3406126, 35.0716256],
              [49.341726, 35.0716256],
              [49.3420025, 35.0719053],
              [49.3428357, 35.0719052],
              [49.3489456, 35.0744038],
              [49.3517258, 35.0744038],
              [49.3520023, 35.0741242],
              [49.3525589, 35.0741242],
              [49.355059, 35.0716256],
              [49.3553355, 35.0705161],
              [49.3564492, 35.069127],
              [49.3567258, 35.0685678],
              [49.3564493, 35.0638502],
              [49.3547824, 35.0610719],
              [49.3545024, 35.0594032],
              [49.3553356, 35.0582936],
              [49.3556157, 35.0574637],
              [49.3628357, 35.0535671],
              [49.3642256, 35.053567],
              [49.3650589, 35.0532875],
              [49.3681155, 35.0532874],
              [49.3720055, 35.0527371],
              [49.3795056, 35.0488494],
              [49.3836721, 35.0488494],
              [49.3842253, 35.0485698],
              [49.3864488, 35.0485698],
              [49.3906153, 35.0474603],
              [49.4042285, 35.0366268],
              [49.4070051, 35.0346783],
              [49.4075618, 35.0346784],
              [49.4078384, 35.0343988],
              [49.4089485, 35.0343987],
              [49.4095051, 35.0341191],
              [49.4111719, 35.0341191],
              [49.4150619, 35.0366268],
              [49.4161717, 35.0380069],
              [49.4170049, 35.0399554],
              [49.4172849, 35.0435725],
              [49.4175616, 35.0449527],
              [49.4206182, 35.0541264],
              [49.4411749, 35.0794012],
              [49.4453414, 35.0871766],
              [49.4472846, 35.091903],
              [49.450341, 35.1069034],
              [49.4536746, 35.1185752],
              [49.4539512, 35.1196756],
              [49.4628408, 35.1382925],
              [49.4631177, 35.1427392],
              [49.4633974, 35.1455173],
              [49.4645076, 35.1494048],
              [49.4658974, 35.1616263],
              [49.4678408, 35.1694102],
              [49.4681209, 35.17024],
              [49.4678407, 35.1707992],
              [49.4661739, 35.1791241],
              [49.4570077, 35.1880172],
              [49.4567307, 35.1882968],
              [49.4542311, 35.1885674],
              [49.453951, 35.1888471],
              [49.4511744, 35.188847],
              [49.4508978, 35.1891266],
              [49.4489509, 35.1891267],
              [49.4481177, 35.1894062],
              [49.4464508, 35.1894063],
              [49.4439512, 35.190236],
              [49.4414511, 35.1927434],
              [49.4386744, 35.1985699],
              [49.4383944, 35.1999588],
              [49.4381178, 35.2021866],
              [49.4378413, 35.2049645],
              [49.3831298, 35.2382884],
              [49.3831299, 35.238578],
              [49.3831299, 35.2396773],
              [49.3764484, 35.2591327],
              [49.3747816, 35.2632994],
              [49.3858607, 35.2773207],
              [49.3889174, 35.2834365],
              [49.3933608, 35.2887132],
              [49.3944706, 35.2903821],
              [49.4158604, 35.3198329],
              [49.4392833, 35.3407177],
              [49.4423396, 35.3421073],
              [49.4428931, 35.3423871],
              [49.4451631, 35.352446],
              [49.4559961, 35.3646709],
              [49.4673862, 35.3735666],
              [49.4684995, 35.3752266],
              [49.4687761, 35.375786],
              [49.4707195, 35.3796745],
              [49.472796, 35.393249],
              [49.4727961, 35.3935198],
              [49.4571875, 35.4072409],
              [49.4159888, 35.4182933],
              [49.4083096, 35.4404832],
              [49.4016431, 35.444369],
              [49.4008095, 35.4443689],
              [49.3999762, 35.4449189],
              [49.3988664, 35.4449188],
              [49.3985864, 35.4452075],
              [49.3960863, 35.4457575],
              [49.3946995, 35.4457574],
              [49.3941429, 35.4454779],
              [49.3926077, 35.4453284],
              [49.3913663, 35.4452074],
              [49.3913663, 35.4449189],
              [49.3782811, 35.4486943],
              [49.3760611, 35.4492532],
              [49.3755045, 35.4495327],
              [49.3732811, 35.4498031],
              [49.3518382, 35.4467057],
              [49.3468381, 35.4478147],
              [49.3326718, 35.4547573],
              [49.311722, 35.4596937],
              [49.3097785, 35.4605232],
              [49.3086652, 35.4608027],
              [49.2992221, 35.4641391],
              [49.2986654, 35.4646892],
              [49.2978322, 35.4646892],
              [49.2922754, 35.4669073],
              [49.290609, 35.4669074],
              [49.2900555, 35.4671869],
              [49.2872753, 35.4671869],
              [49.2867222, 35.4674664],
              [49.283942, 35.4674664],
              [49.281999, 35.4680255],
              [49.2808888, 35.4680255],
              [49.2800556, 35.4685755],
              [49.2789423, 35.4685755],
              [49.2692191, 35.4727504],
              [49.2672757, 35.473021],
              [49.266719, 35.4727505],
              [49.2656092, 35.473021],
              [49.2600525, 35.4727505],
              [49.2594993, 35.4730209],
              [49.2592192, 35.4727505],
              [49.2569957, 35.4727504],
              [49.2522762, 35.4724709],
              [49.2461627, 35.4724708],
              [49.2456092, 35.4727504],
              [49.2228297, 35.4780254],
              [49.2108831, 35.4810821],
              [49.2078299, 35.4810822],
              [49.2069967, 35.4816412],
              [49.2056063, 35.4819117],
              [49.2047732, 35.4824707],
              [49.1969932, 35.4860775],
              [49.1961596, 35.4860775],
              [49.1950499, 35.4866366],
              [49.1942167, 35.4866366],
              [49.1828265, 35.4899729],
              [49.1797699, 35.4905229],
              [49.1781034, 35.4905229],
              [49.1775503, 35.4908025],
              [49.1756034, 35.4910729],
              [49.1689368, 35.4908024],
              [49.1686603, 35.4910728],
              [49.1608804, 35.4933001],
              [49.1603269, 35.4935796],
              [49.1600468, 35.4938591],
              [49.152547, 35.5019112],
              [49.1522704, 35.5030293],
              [49.1519938, 35.5044089],
              [49.150327, 35.5088632],
              [49.1453273, 35.5138585],
              [49.1353239, 35.5208014],
              [49.1347704, 35.5219194],
              [49.1342137, 35.5224694],
              [49.1325472, 35.5296918],
              [49.1322707, 35.5299713],
              [49.1325473, 35.5308008],
              [49.1337036, 35.5493869],
              [49.1298172, 35.5582775],
              [49.1259273, 35.5624523],
              [49.125094, 35.5627228],
              [49.1231507, 35.5643909],
              [49.118704, 35.5668887],
              [49.0922673, 35.5874687],
              [49.0911576, 35.5874687],
              [49.0842109, 35.5997454],
              [49.0828211, 35.5997454],
              [49.0825441, 35.6000248],
              [49.0819875, 35.6000248],
              [49.0814343, 35.6003043],
              [49.0794877, 35.6008632],
              [49.0783777, 35.6008632],
              [49.0731009, 35.6047486],
              [49.071711, 35.6058575],
              [49.0621084, 35.6119197],
              [49.0609149, 35.6146335],
              [49.0606157, 35.6155408],
              [49.0606774, 35.6161077],
              [49.0603213, 35.6161344],
              [49.0475413, 35.6277993],
              [49.0303179, 35.6314007],
              [49.0283749, 35.6314008],
              [49.0278182, 35.6311122],
              [49.0219849, 35.6302828],
              [49.0208747, 35.6305624],
              [49.0189317, 35.6305624],
              [49.0153184, 35.6314007],
              [49.0122617, 35.63278],
              [49.0092085, 35.6358361],
              [49.006985, 35.6380628],
              [48.9886517, 35.6435836],
              [48.9475391, 35.66303],
              [48.9467059, 35.6630299],
              [48.9464258, 35.6633095],
              [48.9439257, 35.6644184],
              [48.9330922, 35.6699718],
              [48.9319825, 35.6699718],
              [48.9311492, 35.6703902],
              [48.9308693, 35.6705309],
              [48.930036, 35.6708103],
              [48.8933696, 35.6938624],
              [48.8917031, 35.6955302],
              [48.8905894, 35.6960801],
              [48.8839229, 35.6994157],
              [48.8830896, 35.6994158],
              [48.882813, 35.6996952],
              [48.8741996, 35.7010835],
              [48.87198, 35.7010835],
              [48.8703132, 35.701363],
              [48.8678131, 35.7013629],
              [48.8614231, 35.7024718],
              [48.8594766, 35.7024718],
              [48.8514232, 35.7038691],
              [48.8439235, 35.7052484],
              [48.8430867, 35.7052484],
              [48.8425337, 35.7055279],
              [48.8417, 35.7055279],
              [48.8189203, 35.71164],
              [48.8016972, 35.7213582],
              [48.7908641, 35.7305263],
              [48.7797506, 35.7335824],
              [48.7750309, 35.7338618],
              [48.773084, 35.7338618],
              [48.7719742, 35.7335824],
              [48.7691976, 35.7335824],
              [48.7680843, 35.733303],
              [48.7655843, 35.7330324],
              [48.7628076, 35.7330324],
              [48.762251, 35.732753],
              [48.7608611, 35.7327529],
              [48.7605841, 35.7324735],
              [48.7589177, 35.7324735],
              [48.7583611, 35.7321941],
              [48.7525278, 35.7310852],
              [48.7486414, 35.7294174],
              [48.7419713, 35.7271908],
              [48.7369711, 35.7244142],
              [48.7366945, 35.7241437],
              [48.7363237, 35.7239575],
              [48.7350277, 35.7227464],
              [48.7350278, 35.7224759],
              [48.743506, 35.7141494],
              [48.7460613, 35.6962608],
              [48.7455261, 35.6892958],
              [48.7458613, 35.684973],
              [48.7466946, 35.6846935],
              [48.7506448, 35.6794017],
              [48.7517546, 35.6788427],
              [48.7466851, 35.6637992],
              [48.7458519, 35.6543583],
              [48.7464051, 35.651581],
              [48.7466851, 35.6476856],
              [48.7469617, 35.6471266],
              [48.6698229, 35.5972334],
              [48.669469, 35.5971873],
              [48.6639126, 35.5988642],
              [48.6505795, 35.6008027],
              [48.6480795, 35.6008027],
              [48.6472458, 35.6010822],
              [48.6441895, 35.6010822],
              [48.6433559, 35.6013616],
              [48.634889, 35.594654],
              [48.6340558, 35.5949336],
              [48.6318323, 35.595204],
              [48.6193324, 35.593545],
              [48.6146092, 35.5918768],
              [48.6126659, 35.5918768],
              [48.6096179, 35.5907677],
              [48.6090525, 35.5904882],
              [48.6084993, 35.5899291],
              [48.6040528, 35.5874315],
              [48.6032196, 35.5874314],
              [48.5754397, 35.5785406],
              [48.5743299, 35.5785406],
              [48.5737733, 35.5782611],
              [48.5729397, 35.5782611],
              [48.5726632, 35.5779816],
              [48.5450207, 35.5852497],
              [48.5430737, 35.5852497],
              [48.5427971, 35.5849702],
              [48.538074, 35.5849702],
              [48.5364072, 35.5855292],
              [48.5255742, 35.5883061],
              [48.5211275, 35.5902536],
              [48.4961278, 35.598864],
              [48.495018, 35.5999729],
              [48.4983512, 35.6199703],
              [48.4980712, 35.6213587],
              [48.4977946, 35.6219177],
              [48.4958511, 35.6277509],
              [48.4952945, 35.6296893],
              [48.4925179, 35.635252],
              [48.4919613, 35.6355225],
              [48.4905709, 35.6374699],
              [48.484181, 35.6446914],
              [48.4839044, 35.644971],
              [48.4836278, 35.6452504],
              [48.4816813, 35.6458093],
              [48.4811277, 35.6458094],
              [48.4719611, 35.6499746],
              [48.4680713, 35.6505245],
              [48.4622378, 35.6521924],
              [48.4616811, 35.6527513],
              [48.4611245, 35.6527513],
              [48.4580714, 35.6541397],
              [48.456958, 35.6541397],
              [48.4558482, 35.6546897],
              [48.4550147, 35.6546897],
              [48.4527916, 35.6552486],
              [48.4514048, 35.6552486],
              [48.4508482, 35.6555281],
              [48.4489047, 35.6557986],
              [48.4450148, 35.6557985],
              [48.4447347, 35.6560871],
              [48.4425148, 35.656087],
              [48.4422351, 35.6557985],
              [48.4414015, 35.6557986],
              [48.4391815, 35.6549691],
              [48.4380682, 35.6549691],
              [48.435015, 35.6541396],
              [48.4258449, 35.6474681],
              [48.4216784, 35.6446913],
              [48.4141787, 35.6408055],
              [48.4016788, 35.6424734],
              [48.3952889, 35.6424734],
              [48.3947357, 35.6427529],
              [48.3916789, 35.6430234],
              [48.357509, 35.6574753],
              [48.353066, 35.6596931],
              [48.3433427, 35.6621994],
              [48.3280627, 35.6666349],
              [48.311953, 35.6727473],
              [48.2961198, 35.6805276],
              [48.2901766, 35.6861535],
              [48.2858379, 35.6894397],
              [48.2826376, 35.6918096],
              [48.2772784, 35.6931287],
              [48.2706979, 35.6960481],
              [48.2649998, 35.696915],
              [48.2576416, 35.6943377],
              [48.2406663, 35.6934826],
              [48.2419109, 35.6918793],
              [48.2293555, 35.6867601],
              [48.2195404, 35.6838154],
              [48.2096005, 35.679811],
              [48.1965552, 35.6765947],
              [48.1839975, 35.6728606],
              [48.175298, 35.6694665],
              [48.173654, 35.6701644],
              [48.1355292, 35.6681734],
              [48.1217479, 35.6597371],
              [48.106665, 35.6510625],
              [48.1008052, 35.6475323],
              [48.09732, 35.6444182],
              [48.085184, 35.6462768],
              [48.0643514, 35.6522853],
              [48.0490296, 35.652793],
              [48.0456963, 35.652243],
              [48.0438242, 35.6513603],
              [48.0303077, 35.6485706],
              [48.0064066, 35.6435558],
              [47.9864504, 35.6351744],
              [47.9869399, 35.6271019],
              [47.9794081, 35.6122227],
              [47.976264, 35.5953297],
              [47.9554277, 35.5872707],
              [47.9537612, 35.5872707],
              [47.9532077, 35.5869913],
              [47.9490412, 35.5867208],
              [47.9036017, 35.5799649],
              [47.8938596, 35.5775297],
              [47.8880482, 35.5722231],
              [47.8851708, 35.5661705],
              [47.8805647, 35.5611842],
              [47.8826164, 35.5491834],
              [47.8823817, 35.5486643],
              [47.8808889, 35.5457386],
              [47.8784626, 35.5410001],
              [47.8778965, 35.5352344],
              [47.8781507, 35.5332846],
              [47.8797743, 35.5284477],
              [47.8802673, 35.5273133],
              [47.8815442, 35.5255306],
              [47.8829201, 35.5226892],
              [47.8835232, 35.522066],
              [47.8851092, 35.5174392],
              [47.8856144, 35.5169117],
              [47.8855726, 35.5137052],
              [47.8855375, 35.510383],
              [47.8861164, 35.5089453],
              [47.8861471, 35.5083135],
              [47.8872237, 35.5065394],
              [47.8875867, 35.5063575],
              [47.8939184, 35.4933252],
              [47.8959432, 35.4849721],
              [47.9016929, 35.4647273],
              [47.9020276, 35.4645399],
              [47.9019263, 35.4638378],
              [47.902856, 35.462245],
              [47.9053066, 35.4577055],
              [47.9088678, 35.4535664],
              [47.9150042, 35.4485338],
              [47.9152361, 35.4480602],
              [47.9158527, 35.4477699],
              [47.9170234, 35.4461009],
              [47.9192454, 35.4432204],
              [47.9214704, 35.4401868],
              [47.9274927, 35.4319791],
              [47.9294172, 35.426621],
              [47.9327526, 35.4172661],
              [47.9366179, 35.4050941],
              [47.9389714, 35.3996633],
              [47.9405738, 35.3960637],
              [47.9414672, 35.3948612],
              [47.9446874, 35.3897206],
              [47.954468, 35.3794286],
              [47.9605446, 35.376615],
              [47.9622, 35.3760806],
              [47.9629014, 35.3760204],
              [47.9634036, 35.3758051],
              [47.9768647, 35.3725322],
              [47.9786343, 35.3721011],
              [47.9802669, 35.3718967],
              [47.9805196, 35.3716773],
              [47.982954, 35.3710341],
              [47.9845319, 35.3710847],
              [47.98478, 35.3707754],
              [47.9852116, 35.3707884],
              [47.9855786, 35.3705494],
              [47.9974921, 35.3680307],
              [47.9999305, 35.3691808],
              [48.0021924, 35.3713434],
              [48.0035665, 35.3715979],
              [48.006114, 35.3716197],
              [48.0063889, 35.3718899],
              [48.0094141, 35.3724486],
              [48.0111462, 35.3724503],
              [48.0114255, 35.372695],
              [48.0136249, 35.3727871],
              [48.0138771, 35.3730239],
              [48.0203744, 35.3729977],
              [48.0209008, 35.3727196],
              [48.0219343, 35.3727596],
              [48.0224515, 35.3724601],
              [48.0233978, 35.3724469],
              [48.023591, 35.3721644],
              [48.0267081, 35.3707768],
              [48.0341478, 35.3628644],
              [48.0341885, 35.3615733],
              [48.0339083, 35.3596764],
              [48.0344691, 35.3579606],
              [48.0465236, 35.3366308],
              [48.0547159, 35.3222471],
              [48.0552784, 35.3204408],
              [48.055256, 35.3199001],
              [48.0568396, 35.3166275],
              [48.0637644, 35.3019368],
              [48.0639713, 35.3014993],
              [48.0717073, 35.291857],
              [48.0874968, 35.2727395],
              [48.0894437, 35.2696822],
              [48.0897204, 35.2694025],
              [48.0919438, 35.2610693],
              [48.0922203, 35.2591302],
              [48.0980537, 35.2424633],
              [48.096387, 35.2307927],
              [48.0963869, 35.2305131],
              [48.0958339, 35.2282944],
              [48.0961104, 35.2280148],
              [48.096387, 35.2277353],
              [48.0972203, 35.227176],
              [48.0980538, 35.2271761],
              [48.0988871, 35.2271761],
              [48.1050005, 35.2266259],
              [48.1088904, 35.226626],
              [48.1094435, 35.2269055],
              [48.1197234, 35.2288537],
              [48.1216669, 35.2288537],
              [48.1225, 35.2285741],
              [48.1269467, 35.2285741],
              [48.139723, 35.2221796],
              [48.1490576, 35.2116498],
              [48.1506136, 35.2098726],
              [48.1544464, 35.2038526],
              [48.1613897, 35.1844071],
              [48.1758361, 35.1727359],
              [48.1775372, 35.1707979],
              [48.1777796, 35.1699579],
              [48.1811128, 35.1652316],
              [48.1812528, 35.1637073],
              [48.1813929, 35.1610646],
              [48.1808363, 35.1599552],
              [48.1783363, 35.1532897],
              [48.1597234, 35.1335636],
              [48.1591699, 35.1313448],
              [48.15778, 35.1288462],
              [48.1563902, 35.1263478],
              [48.1525034, 35.1180134],
              [48.1536135, 35.115515],
              [48.1547234, 35.1144055],
              [48.15528, 35.113296],
              [48.1605567, 35.1091198],
              [48.1661135, 35.1074601],
              [48.1672268, 35.1074601],
              [48.1677798, 35.1071805],
              [48.1722265, 35.1071805],
              [48.1727799, 35.106901],
              [48.1794465, 35.106901],
              [48.1822263, 35.1069009],
              [48.1830599, 35.1069009],
              [48.1850029, 35.1063417],
              [48.1886163, 35.1021745],
              [48.1888928, 35.101065],
              [48.1913929, 35.096068],
              [48.1916694, 35.0952381],
              [48.1919496, 35.0932897],
              [48.1922262, 35.0927395],
              [48.1908363, 35.0793988],
              [48.1875031, 35.0668968],
              [48.1875031, 35.0655076],
              [48.1872265, 35.06079],
              [48.1863934, 35.0588417],
              [48.1861163, 35.0582914],
              [48.1855597, 35.0560724],
              [48.1780601, 35.0146774],
              [48.1772269, 35.0116194],
              [48.1766702, 35.0080111],
              [48.1758367, 35.0021747],
              [48.1758366, 34.9988461],
              [48.173337, 34.9960678],
              [48.1727804, 34.9960677],
              [48.1563906, 34.988842],
              [48.1513906, 34.9816163],
              [48.1502807, 34.977178],
              [48.1441674, 34.9710619],
              [48.1438907, 34.9707822],
              [48.1391673, 34.9685631],
              [48.138614, 34.9685631],
              [48.1372242, 34.968563],
              [48.1363906, 34.9688426],
              [48.1352808, 34.9688427],
              [48.1311143, 34.9702319],
              [48.1291673, 34.9702319],
              [48.1286143, 34.9705115],
              [48.1213911, 34.9716211],
              [48.1161108, 34.9730104],
              [48.1147245, 34.9730103],
              [48.1144445, 34.97329],
              [48.1116679, 34.97329],
              [48.1105576, 34.9730104],
              [48.1091678, 34.9730104],
              [48.1058345, 34.9721804],
              [48.1033345, 34.9710617],
              [48.0886116, 34.9621761],
              [48.0874978, 34.9621761],
              [48.0861114, 34.9618965],
              [48.0858314, 34.9616168],
              [48.0816648, 34.9616168],
              [48.081388, 34.9613371],
              [48.0799981, 34.9613371],
              [48.0797215, 34.9616167],
              [48.0744448, 34.9616167],
              [48.0741647, 34.9618964],
              [48.0730549, 34.9618964],
              [48.0636083, 34.9685629],
              [48.058055, 34.9743994],
              [48.058055, 34.9749497],
              [48.0491649, 34.983285],
              [48.0477751, 34.9843945],
              [48.045275, 34.9855041],
              [48.0444418, 34.9855041],
              [48.0441653, 34.9857837],
              [48.0436085, 34.9857837],
              [48.043052, 34.9860633],
              [48.040832, 34.9860633],
              [48.0333319, 34.9835646],
              [48.0327751, 34.9835646],
              [48.0322185, 34.9832849],
              [48.0180522, 34.9782874],
              [48.0055524, 34.9707819],
              [47.9999871, 34.9612717],
              [47.9719396, 34.9646746],
              [47.9572162, 34.9702315],
              [47.9561064, 34.9702315],
              [47.9558263, 34.9705112],
              [47.9527696, 34.9705112],
              [47.9227703, 34.9518918],
              [47.9199937, 34.9449455],
              [47.9197136, 34.9430059],
              [47.9199937, 34.9407868],
              [47.92138, 34.9371694],
              [47.9216601, 34.9360687],
              [47.9219367, 34.9357891],
              [47.9219366, 34.9352298],
              [47.9223534, 34.9345351],
              [47.9230469, 34.9341202],
              [47.9230468, 34.9338405],
              [47.9236036, 34.9335609],
              [47.9272133, 34.9299524],
              [47.9277701, 34.9288428],
              [47.9274935, 34.9252343],
              [47.9266603, 34.9163393],
              [47.9261037, 34.9152297],
              [47.9177704, 34.8955089],
              [47.9102705, 34.8891127],
              [47.9086038, 34.8880031],
              [47.9086037, 34.8877324],
              [47.9074905, 34.8868934],
              [47.8819341, 34.8732888],
              [47.863601, 34.8580062],
              [47.8622111, 34.8574558],
              [47.8586012, 34.8557778],
              [47.8491546, 34.8530081],
              [47.8480448, 34.8530081],
              [47.8472112, 34.8527284],
              [47.843878, 34.8527284],
              [47.8433213, 34.8524488],
              [47.8352648, 34.8524487],
              [47.8347113, 34.852169],
              [47.8338781, 34.852169],
              [47.833598, 34.8518893],
              [47.8320284, 34.8577943]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241471,
        "tags": {
          "ISO3166-2": "IR-26",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "قزوین",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q1105893"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [48.7363237, 35.7239575],
              [48.7366945, 35.7241437],
              [48.7369711, 35.7244142],
              [48.7419713, 35.7271908],
              [48.7486414, 35.7294174],
              [48.7525278, 35.7310852],
              [48.7583611, 35.7321941],
              [48.7589177, 35.7324735],
              [48.7605841, 35.7324735],
              [48.7608611, 35.7327529],
              [48.762251, 35.732753],
              [48.7628076, 35.7330324],
              [48.7655843, 35.7330324],
              [48.7680843, 35.733303],
              [48.7691976, 35.7335824],
              [48.7719742, 35.7335824],
              [48.773084, 35.7338618],
              [48.7750309, 35.7338618],
              [48.7797506, 35.7335824],
              [48.7908641, 35.7305263],
              [48.8016972, 35.7213582],
              [48.8189203, 35.71164],
              [48.8417, 35.7055279],
              [48.8425337, 35.7055279],
              [48.8430867, 35.7052484],
              [48.8439235, 35.7052484],
              [48.8514232, 35.7038691],
              [48.8594766, 35.7024718],
              [48.8614231, 35.7024718],
              [48.8678131, 35.7013629],
              [48.8703132, 35.701363],
              [48.87198, 35.7010835],
              [48.8741996, 35.7010835],
              [48.882813, 35.6996952],
              [48.8830896, 35.6994158],
              [48.8839229, 35.6994157],
              [48.8905894, 35.6960801],
              [48.8917031, 35.6955302],
              [48.8933696, 35.6938624],
              [48.930036, 35.6708103],
              [48.9308693, 35.6705309],
              [48.9311492, 35.6703902],
              [48.9319825, 35.6699718],
              [48.9330922, 35.6699718],
              [48.9439257, 35.6644184],
              [48.9464258, 35.6633095],
              [48.9467059, 35.6630299],
              [48.9475391, 35.66303],
              [48.9886517, 35.6435836],
              [49.006985, 35.6380628],
              [49.0092085, 35.6358361],
              [49.0122617, 35.63278],
              [49.0153184, 35.6314007],
              [49.0189317, 35.6305624],
              [49.0208747, 35.6305624],
              [49.0219849, 35.6302828],
              [49.0278182, 35.6311122],
              [49.0283749, 35.6314008],
              [49.0303179, 35.6314007],
              [49.0475413, 35.6277993],
              [49.0603213, 35.6161344],
              [49.0606774, 35.6161077],
              [49.0606157, 35.6155408],
              [49.0609149, 35.6146335],
              [49.0621084, 35.6119197],
              [49.071711, 35.6058575],
              [49.0731009, 35.6047486],
              [49.0783777, 35.6008632],
              [49.0794877, 35.6008632],
              [49.0814343, 35.6003043],
              [49.0819875, 35.6000248],
              [49.0825441, 35.6000248],
              [49.0828211, 35.5997454],
              [49.0842109, 35.5997454],
              [49.0911576, 35.5874687],
              [49.0922673, 35.5874687],
              [49.118704, 35.5668887],
              [49.1231507, 35.5643909],
              [49.125094, 35.5627228],
              [49.1259273, 35.5624523],
              [49.1298172, 35.5582775],
              [49.1337036, 35.5493869],
              [49.1325473, 35.5308008],
              [49.1322707, 35.5299713],
              [49.1325472, 35.5296918],
              [49.1342137, 35.5224694],
              [49.1347704, 35.5219194],
              [49.1353239, 35.5208014],
              [49.1453273, 35.5138585],
              [49.150327, 35.5088632],
              [49.1519938, 35.5044089],
              [49.1522704, 35.5030293],
              [49.152547, 35.5019112],
              [49.1600468, 35.4938591],
              [49.1603269, 35.4935796],
              [49.1608804, 35.4933001],
              [49.1686603, 35.4910728],
              [49.1689368, 35.4908024],
              [49.1756034, 35.4910729],
              [49.1775503, 35.4908025],
              [49.1781034, 35.4905229],
              [49.1797699, 35.4905229],
              [49.1828265, 35.4899729],
              [49.1942167, 35.4866366],
              [49.1950499, 35.4866366],
              [49.1961596, 35.4860775],
              [49.1969932, 35.4860775],
              [49.2047732, 35.4824707],
              [49.2056063, 35.4819117],
              [49.2069967, 35.4816412],
              [49.2078299, 35.4810822],
              [49.2108831, 35.4810821],
              [49.2228297, 35.4780254],
              [49.2456092, 35.4727504],
              [49.2461627, 35.4724708],
              [49.2522762, 35.4724709],
              [49.2569957, 35.4727504],
              [49.2592192, 35.4727505],
              [49.2594993, 35.4730209],
              [49.2600525, 35.4727505],
              [49.2656092, 35.473021],
              [49.266719, 35.4727505],
              [49.2672757, 35.473021],
              [49.2692191, 35.4727504],
              [49.2789423, 35.4685755],
              [49.2800556, 35.4685755],
              [49.2808888, 35.4680255],
              [49.281999, 35.4680255],
              [49.283942, 35.4674664],
              [49.2867222, 35.4674664],
              [49.2872753, 35.4671869],
              [49.2900555, 35.4671869],
              [49.290609, 35.4669074],
              [49.2922754, 35.4669073],
              [49.2978322, 35.4646892],
              [49.2986654, 35.4646892],
              [49.2992221, 35.4641391],
              [49.3086652, 35.4608027],
              [49.3097785, 35.4605232],
              [49.311722, 35.4596937],
              [49.3326718, 35.4547573],
              [49.3468381, 35.4478147],
              [49.3518382, 35.4467057],
              [49.3732811, 35.4498031],
              [49.3755045, 35.4495327],
              [49.3760611, 35.4492532],
              [49.3782811, 35.4486943],
              [49.3913663, 35.4449189],
              [49.3913663, 35.4452074],
              [49.3926077, 35.4453284],
              [49.3941429, 35.4454779],
              [49.3946995, 35.4457574],
              [49.3960863, 35.4457575],
              [49.3985864, 35.4452075],
              [49.3988664, 35.4449188],
              [49.3999762, 35.4449189],
              [49.4008095, 35.4443689],
              [49.4016431, 35.444369],
              [49.4083096, 35.4404832],
              [49.4159888, 35.4182933],
              [49.4571875, 35.4072409],
              [49.4727961, 35.3935198],
              [49.472796, 35.393249],
              [49.4892882, 35.3905895],
              [49.4948869, 35.3907057],
              [49.5136615, 35.3917167],
              [49.516501, 35.3952118],
              [49.537807, 35.3910238],
              [49.5427042, 35.4027091],
              [49.5508994, 35.4035785],
              [49.5581226, 35.4052467],
              [49.5592324, 35.4052468],
              [49.5675688, 35.4080242],
              [49.5678458, 35.4083038],
              [49.5686791, 35.4083037],
              [49.5720123, 35.4102425],
              [49.5778456, 35.4171861],
              [49.5797921, 35.4194135],
              [49.5859021, 35.4235796],
              [49.5925685, 35.4257979],
              [49.5959018, 35.426907],
              [49.5986819, 35.4280252],
              [49.5995152, 35.4280252],
              [49.6075685, 35.4335799],
              [49.6161815, 35.4460781],
              [49.6222914, 35.4485759],
              [49.6228485, 35.4488555],
              [49.6284048, 35.4496941],
              [49.6300716, 35.449694],
              [49.6303481, 35.4499645],
              [49.6336814, 35.4502442],
              [49.6364617, 35.4502442],
              [49.6375714, 35.4505236],
              [49.6403479, 35.4505237],
              [49.6414613, 35.4508032],
              [49.6439614, 35.4508032],
              [49.6445145, 35.4510828],
              [49.6478478, 35.4510828],
              [49.6542377, 35.449135],
              [49.6684045, 35.4452395],
              [49.6717378, 35.4452396],
              [49.6750745, 35.4457986],
              [49.6756277, 35.4460782],
              [49.6764609, 35.4460782],
              [49.6770176, 35.4463577],
              [49.678961, 35.4463577],
              [49.6789609, 35.4466373],
              [49.6811845, 35.4469079],
              [49.681461, 35.4471964],
              [49.6822942, 35.4471963],
              [49.6842407, 35.4488555],
              [49.6842407, 35.449135],
              [49.6847943, 35.4496941],
              [49.6856275, 35.4519124],
              [49.6847943, 35.4577466],
              [49.6842407, 35.4596943],
              [49.6839606, 35.4608034],
              [49.6922941, 35.4696943],
              [49.692574, 35.4702444],
              [49.6931307, 35.471083],
              [49.6942408, 35.4774671],
              [49.6936838, 35.4810829],
              [49.6925741, 35.4838602],
              [49.6895237, 35.5035802],
              [49.6856337, 35.5094053],
              [49.6842438, 35.5113529],
              [49.6842438, 35.5116324],
              [49.6814672, 35.5177457],
              [49.6820238, 35.5230206],
              [49.6856336, 35.5288544],
              [49.6911904, 35.5316315],
              [49.6934138, 35.5321906],
              [49.6945237, 35.5321906],
              [49.6956335, 35.5327496],
              [49.6975804, 35.5330201],
              [49.6978569, 35.5332996],
              [49.6989671, 35.5332996],
              [49.6992469, 35.5335791],
              [49.7042469, 35.5335792],
              [49.7048036, 35.5332996],
              [49.7073037, 35.5332996],
              [49.7081368, 35.5330201],
              [49.7095236, 35.5330201],
              [49.7100802, 35.5332996],
              [49.7106369, 35.5335791],
              [49.71119, 35.5335791],
              [49.7114702, 35.5332996],
              [49.7128569, 35.5332996],
              [49.7153568, 35.5332996],
              [49.7156366, 35.5335792],
              [49.7170233, 35.5335792],
              [49.7173035, 35.5338586],
              [49.7236935, 35.5338587],
              [49.72397, 35.5341381],
              [49.7245266, 35.5338587],
              [49.7259133, 35.5338587],
              [49.7395265, 35.5280249],
              [49.7400797, 35.5274658],
              [49.7445263, 35.5257978],
              [49.754803, 35.5241388],
              [49.7617497, 35.5235797],
              [49.7625829, 35.5233003],
              [49.7636927, 35.5233002],
              [49.7645264, 35.5230208],
              [49.7684162, 35.5230207],
              [49.7781395, 35.5221911],
              [49.7814728, 35.5213616],
              [49.7814488, 35.512829],
              [49.8006299, 35.5081479],
              [49.8051985, 35.5137983],
              [49.8176168, 35.5206887],
              [49.8399051, 35.5296681],
              [49.8599052, 35.5388295],
              [49.8711917, 35.5466352],
              [49.8725816, 35.5469147],
              [49.8803583, 35.5469146],
              [49.8906383, 35.5449761],
              [49.9023048, 35.540522],
              [49.9034182, 35.5399719],
              [49.9039714, 35.5396924],
              [49.9042514, 35.539413],
              [49.904528, 35.5385834],
              [49.9192514, 35.5221913],
              [49.9211944, 35.5208027],
              [49.9253613, 35.5191345],
              [49.9723072, 35.5060874],
              [49.9817539, 35.5044103],
              [49.9839774, 35.5044103],
              [49.9881439, 35.5038602],
              [49.990644, 35.5038603],
              [49.9923104, 35.5035807],
              [50.0042535, 35.5035807],
              [50.0053669, 35.5038602],
              [50.0092537, 35.5038602],
              [50.0103671, 35.5041398],
              [50.0137003, 35.5041398],
              [50.0148101, 35.5044102],
              [50.0198102, 35.5044103],
              [50.0209235, 35.5044103],
              [50.0214765, 35.5046898],
              [50.0242567, 35.5046898],
              [50.0253666, 35.5049694],
              [50.0292568, 35.5049694],
              [50.02981, 35.5052488],
              [50.0353668, 35.505249],
              [50.0359234, 35.5055284],
              [50.0431466, 35.5055284],
              [50.0550899, 35.506358],
              [50.068703, 35.5077466],
              [50.1017591, 35.51386],
              [50.1264823, 35.5171872],
              [50.127039, 35.5174668],
              [50.1295386, 35.5174668],
              [50.1306489, 35.5177463],
              [50.1342622, 35.5180258],
              [50.1356486, 35.5180258],
              [50.1364821, 35.5183054],
              [50.1462053, 35.5183053],
              [50.1467621, 35.5185849],
              [50.1500954, 35.5185848],
              [50.1778749, 35.5221916],
              [50.2019068, 35.5271473],
              [50.2027175, 35.5340377],
              [50.2032222, 35.535874],
              [50.2090306, 35.5707473],
              [50.2059774, 35.5732452],
              [50.1678749, 35.5963603],
              [50.1648181, 35.6027528],
              [50.1645415, 35.6033117],
              [50.1631517, 35.6105336],
              [50.1631547, 35.6105736],
              [50.1634282, 35.6141399],
              [50.1650946, 35.6191346],
              [50.168708, 35.6241385],
              [50.1792614, 35.6285833],
              [50.1834313, 35.6294218],
              [50.1937077, 35.6310807],
              [50.1939843, 35.6313692],
              [50.2000977, 35.6313692],
              [50.2034309, 35.6316396],
              [50.2045412, 35.6319191],
              [50.2053744, 35.6319192],
              [50.2056544, 35.6321987],
              [50.2078744, 35.6321986],
              [50.2098209, 35.632469],
              [50.2106542, 35.6327486],
              [50.212321, 35.6327487],
              [50.2128741, 35.6330281],
              [50.2139875, 35.6330282],
              [50.2264873, 35.6363639],
              [50.2273209, 35.6363639],
              [50.2384305, 35.6410792],
              [50.2403774, 35.6427562],
              [50.2417673, 35.644424],
              [50.2437107, 35.6477508],
              [50.2445439, 35.6741391],
              [50.2445387, 35.6741496],
              [50.2442673, 35.6746981],
              [50.2437106, 35.6816399],
              [50.243712, 35.6816555],
              [50.2439872, 35.6846961],
              [50.2439795, 35.6847194],
              [50.2437106, 35.6855345],
              [50.2434336, 35.6891406],
              [50.2434347, 35.689158],
              [50.2434336, 35.6985886],
              [50.2437105, 35.7163664],
              [50.2459336, 35.7277522],
              [50.252063, 35.7535238],
              [50.2531496, 35.7793684],
              [50.2627943, 35.7837027],
              [50.2761837, 35.7791072],
              [50.2857968, 35.7841206],
              [50.2847668, 35.8013865],
              [50.2918249, 35.819517],
              [50.2970462, 35.8224764],
              [50.3151029, 35.8421989],
              [50.3151028, 35.8424783],
              [50.3281589, 35.8533129],
              [50.3309356, 35.8569274],
              [50.3313526, 35.8573375],
              [50.3317692, 35.8577567],
              [50.3320457, 35.8583155],
              [50.3339922, 35.8610917],
              [50.3342688, 35.8613712],
              [50.3989946, 35.9522066],
              [50.4014946, 35.9619224],
              [50.4045337, 35.9708545],
              [50.4059381, 35.9749817],
              [50.4067713, 35.9777576],
              [50.4072636, 35.981417],
              [50.4084996, 35.9865218],
              [50.4088858, 35.9916262],
              [50.4096583, 35.9952512],
              [50.4115895, 35.9976261],
              [50.4141129, 36.0016466],
              [50.4156767, 36.0029763],
              [50.4193073, 36.0034763],
              [50.4220882, 36.0036846],
              [50.4232985, 36.0044761],
              [50.4254614, 36.0048094],
              [50.4280878, 36.0044553],
              [50.4294268, 36.0044553],
              [50.431358, 36.0044553],
              [50.4324137, 36.0045595],
              [50.4337526, 36.0052677],
              [50.4362503, 36.007059],
              [50.4387737, 36.0074756],
              [50.4429193, 36.0095586],
              [50.44655, 36.0107458],
              [50.4510046, 36.0100168],
              [50.4539915, 36.0099335],
              [50.4576445, 36.00964],
              [50.4643217, 36.0092894],
              [50.4683901, 36.0082687],
              [50.4781233, 36.0039153],
              [50.4837881, 36.0016447],
              [50.4891182, 36.0001032],
              [50.4930321, 35.9996449],
              [50.4953495, 35.9998116],
              [50.4973064, 36.0009156],
              [50.4983879, 36.0021863],
              [50.5007053, 36.0046443],
              [50.50413, 36.008477],
              [50.5080953, 36.0120596],
              [50.5108763, 36.0146423],
              [50.5146614, 36.0167667],
              [50.5235191, 36.020807],
              [50.5282312, 36.0222024],
              [50.534308, 36.0215151],
              [50.5451999, 36.0199115],
              [50.5469766, 36.0195366],
              [50.551251, 36.0258468],
              [50.5531307, 36.029137],
              [50.5526672, 36.0346759],
              [50.5570961, 36.037591],
              [50.5604279, 36.0420636],
              [50.6026155, 36.0974818],
              [50.6620785, 36.0990479],
              [50.6736287, 36.1053388],
              [50.6748139, 36.1061732],
              [50.675683, 36.1074734],
              [50.673666, 36.112362],
              [50.6687736, 36.118429],
              [50.6462184, 36.1304475],
              [50.6178974, 36.1439311],
              [50.6125784, 36.1469832],
              [50.6052589, 36.1511478],
              [50.5797243, 36.1623744],
              [50.5703684, 36.1677103],
              [50.5661725, 36.1702798],
              [50.561434, 36.17264],
              [50.5576509, 36.1750412],
              [50.5513366, 36.1786013],
              [50.5465912, 36.1813861],
              [50.5408833, 36.1845985],
              [50.5378597, 36.1870277],
              [50.5305862, 36.1937243],
              [50.5265521, 36.1984689],
              [50.523076, 36.2008931],
              [50.5206728, 36.2012394],
              [50.5171966, 36.202313],
              [50.5110644, 36.2076359],
              [50.504322, 36.2131168],
              [50.5003737, 36.2166485],
              [50.496683, 36.2184143],
              [50.4914903, 36.221184],
              [50.4887008, 36.2225343],
              [50.4811048, 36.2262387],
              [50.4777353, 36.2271836],
              [50.4722214, 36.2287311],
              [50.4676844, 36.2299937],
              [50.4634451, 36.2311718],
              [50.459926, 36.2322276],
              [50.4546298, 36.2337188],
              [50.4506349, 36.2348237],
              [50.4439864, 36.2364441],
              [50.4345845, 36.238666],
              [50.4332141, 36.2393804],
              [50.434606, 36.2410716],
              [50.4383182, 36.2436502],
              [50.4342093, 36.2460411],
              [50.4308939, 36.248115],
              [50.4287909, 36.2503647],
              [50.4314447, 36.254092],
              [50.4322241, 36.2637917],
              [50.4305739, 36.2688319],
              [50.429372, 36.2689705],
              [50.4267659, 36.2717426],
              [50.4213353, 36.2742717],
              [50.419006, 36.2903623],
              [50.4239844, 36.293406],
              [50.4322241, 36.2938211],
              [50.4411505, 36.2985251],
              [50.4471586, 36.2981101],
              [50.4578015, 36.302399],
              [50.4588316, 36.308624],
              [50.4629515, 36.3170617],
              [50.4713629, 36.320243],
              [50.47544, 36.3208998],
              [50.4806536, 36.3209392],
              [50.4842588, 36.3205371],
              [50.4894019, 36.3193932],
              [50.4926383, 36.3185316],
              [50.4967689, 36.3196205],
              [50.5001262, 36.3199527],
              [50.5022401, 36.3190137],
              [50.5040352, 36.3163166],
              [50.504837, 36.3134999],
              [50.5061674, 36.3108717],
              [50.5157068, 36.3069268],
              [50.5179745, 36.3047488],
              [50.5223035, 36.3019491],
              [50.5237197, 36.3000469],
              [50.5280971, 36.2962076],
              [50.5298043, 36.2949701],
              [50.5310583, 36.294582],
              [50.5326032, 36.2976257],
              [50.5333328, 36.300289],
              [50.5408001, 36.3018108],
              [50.5456924, 36.3029867],
              [50.549941, 36.3058918],
              [50.5515047, 36.3092496],
              [50.5529451, 36.3100763],
              [50.5565071, 36.3105605],
              [50.5604124, 36.3093501],
              [50.5646734, 36.3075771],
              [50.571848, 36.3061936],
              [50.5790805, 36.3047505],
              [50.5910968, 36.3011537],
              [50.5976199, 36.3010845],
              [50.5993365, 36.3017762],
              [50.6076621, 36.2970032],
              [50.6121253, 36.296519],
              [50.6210517, 36.2931984],
              [50.6253432, 36.2893935],
              [50.6281719, 36.2870544],
              [50.6379603, 36.2876639],
              [50.6414365, 36.2907425],
              [50.6487643, 36.2907875],
              [50.6537532, 36.2887708],
              [50.6567144, 36.2877676],
              [50.6592464, 36.2859342],
              [50.6606074, 36.2885485],
              [50.6647395, 36.2932676],
              [50.6685161, 36.2939594],
              [50.6723785, 36.2967957],
              [50.67667, 36.2967265],
              [50.6824206, 36.3017762],
              [50.6897163, 36.3064797],
              [50.6923341, 36.3170617],
              [50.6956385, 36.3180645],
              [50.697484, 36.3201045],
              [50.6995868, 36.3221446],
              [50.7027626, 36.3217643],
              [50.7048124, 36.3203741],
              [50.7074403, 36.3186868],
              [50.7084103, 36.3160146],
              [50.7141351, 36.3155401],
              [50.7192359, 36.3147004],
              [50.7218599, 36.3135345],
              [50.7261085, 36.3134999],
              [50.7271814, 36.3144682],
              [50.7273101, 36.3173728],
              [50.7300996, 36.3192747],
              [50.7377715, 36.3191497],
              [50.7423435, 36.3186021],
              [50.74512, 36.3186021],
              [50.7503584, 36.3161852],
              [50.7531451, 36.3161626],
              [50.7586383, 36.3127737],
              [50.7592641, 36.3074533],
              [50.7621574, 36.3062031],
              [50.7824992, 36.3047505],
              [50.7945682, 36.3028732],
              [50.7964305, 36.3028244],
              [50.8075568, 36.3024958],
              [50.8159561, 36.3025563],
              [50.8162469, 36.3030255],
              [50.8169549, 36.303981],
              [50.8186769, 36.3050185],
              [50.8213055, 36.305788],
              [50.8236766, 36.3062895],
              [50.8257472, 36.3061771],
              [50.8276033, 36.3065488],
              [50.8289552, 36.3070503],
              [50.8303499, 36.3081656],
              [50.8320451, 36.3098169],
              [50.8366477, 36.312255],
              [50.8391368, 36.3131887],
              [50.8405745, 36.313059],
              [50.842334, 36.3134739],
              [50.8440614, 36.3142088],
              [50.845617, 36.3142174],
              [50.8469045, 36.3141656],
              [50.8485782, 36.314131],
              [50.849533, 36.3142953],
              [50.8506811, 36.3154537],
              [50.8516252, 36.3165948],
              [50.8520973, 36.3178742],
              [50.8528268, 36.3192314],
              [50.8531057, 36.3205454],
              [50.8529019, 36.3213493],
              [50.8524835, 36.3221359],
              [50.8519256, 36.3225422],
              [50.8512068, 36.3232424],
              [50.8491146, 36.3242278],
              [50.8472264, 36.3259047],
              [50.846647, 36.326661],
              [50.8462285, 36.3273115],
              [50.8464807, 36.3276248],
              [50.8470547, 36.3280786],
              [50.8475697, 36.3283595],
              [50.8481491, 36.3287053],
              [50.8489215, 36.329911],
              [50.8496028, 36.330516],
              [50.8501768, 36.3311945],
              [50.8507937, 36.3317002],
              [50.8513221, 36.3318363],
              [50.8523172, 36.3317628],
              [50.8527866, 36.3316958],
              [50.8533579, 36.3315122],
              [50.8538782, 36.3315057],
              [50.8558953, 36.3317564],
              [50.8568394, 36.3317131],
              [50.861839, 36.3319206],
              [50.8626008, 36.3321194],
              [50.8634376, 36.3335368],
              [50.8637273, 36.3339258],
              [50.8646607, 36.3343147],
              [50.8654654, 36.3343752],
              [50.8690381, 36.3350061],
              [50.8706528, 36.3356154],
              [50.8715164, 36.3358617],
              [50.8720958, 36.3362247],
              [50.8740699, 36.338515],
              [50.8750892, 36.3395607],
              [50.8756578, 36.3406324],
              [50.878458, 36.3432423],
              [50.8791446, 36.3449101],
              [50.8804536, 36.3468113],
              [50.8817839, 36.3481248],
              [50.8820575, 36.3491747],
              [50.8820468, 36.3495938],
              [50.881445, 36.3508941],
              [50.8720834, 36.3615428],
              [50.8656045, 36.3704312],
              [50.8547514, 36.3771124],
              [50.8311191, 36.3911392],
              [50.8287619, 36.3900586],
              [50.8203785, 36.3934856],
              [50.8136557, 36.3957241],
              [50.8106282, 36.4010029],
              [50.8057593, 36.4069156],
              [50.804719, 36.4096702],
              [50.8015212, 36.411306],
              [50.7981295, 36.4151083],
              [50.7915118, 36.4198904],
              [50.786835, 36.4237807],
              [50.7824752, 36.4283524],
              [50.7738884, 36.4334392],
              [50.7674983, 36.4381657],
              [50.7613743, 36.445002],
              [50.7545416, 36.4517144],
              [50.7481323, 36.4592034],
              [50.7334899, 36.4620896],
              [50.7219669, 36.4635276],
              [50.7142203, 36.4644059],
              [50.7024192, 36.4703727],
              [50.6844433, 36.4772949],
              [50.6762353, 36.4810718],
              [50.6759374, 36.4812957],
              [50.670639, 36.4852786],
              [50.6612343, 36.4926325],
              [50.6536018, 36.4980256],
              [50.6490325, 36.4990115],
              [50.6591605, 36.5081875],
              [50.6560351, 36.5144651],
              [50.6511783, 36.5163967],
              [50.6478309, 36.5197077],
              [50.6441402, 36.521846],
              [50.6403636, 36.5241221],
              [50.634613, 36.5262603],
              [50.6321239, 36.5254326],
              [50.6286906, 36.5232944],
              [50.6269059, 36.5243953],
              [50.6227877, 36.5240617],
              [50.6185626, 36.5232945],
              [50.6127638, 36.5264866],
              [50.6094646, 36.527019],
              [50.606886, 36.5271249],
              [50.6042742, 36.5259868],
              [50.6025443, 36.5256938],
              [50.5990502, 36.5256595],
              [50.597425, 36.5261053],
              [50.5949592, 36.5270534],
              [50.5935001, 36.5284329],
              [50.5894153, 36.5305294],
              [50.5879211, 36.5305364],
              [50.5858612, 36.5308123],
              [50.5840587, 36.5311571],
              [50.5787372, 36.530433],
              [50.5775141, 36.5313296],
              [50.5770635, 36.5318985],
              [50.5766772, 36.53264],
              [50.5753469, 36.5339503],
              [50.5752826, 36.5348296],
              [50.5743813, 36.5355365],
              [50.5731368, 36.5365019],
              [50.5712872, 36.5372907],
              [50.5466003, 36.5419683],
              [50.5380756, 36.5412979],
              [50.5173046, 36.5435539],
              [50.5086608, 36.5463533],
              [50.4999585, 36.5497882],
              [50.4867401, 36.5595789],
              [50.4808975, 36.5658775],
              [50.4751394, 36.5674258],
              [50.4660412, 36.5653578],
              [50.455656, 36.5616349],
              [50.4518794, 36.5617039],
              [50.4479312, 36.5632206],
              [50.4420089, 36.5642546],
              [50.4369195, 36.5650352],
              [50.424156, 36.5740433],
              [50.4114531, 36.5761112],
              [50.40699, 36.579902],
              [50.4076765, 36.5825901],
              [50.4048442, 36.5870009],
              [50.3968619, 36.5929277],
              [50.3960036, 36.5938925],
              [50.3933429, 36.5938235],
              [50.3901414, 36.5952063],
              [50.3847598, 36.5955463],
              [50.380125, 36.5966488],
              [50.3752326, 36.5966488],
              [50.3686236, 36.5967867],
              [50.3661346, 36.5982337],
              [50.3605556, 36.5992674],
              [50.3538608, 36.6016791],
              [50.3456615, 36.6060523],
              [50.3490543, 36.609396],
              [50.3519725, 36.6139432],
              [50.352745, 36.6183522],
              [50.3542041, 36.6220722],
              [50.3547191, 36.6230366],
              [50.3551482, 36.6282718],
              [50.3489684, 36.6297183],
              [50.3417801, 36.6325767],
              [50.3389262, 36.6354351],
              [50.3369951, 36.6364853],
              [50.3342888, 36.6376263],
              [50.3321456, 36.6387582],
              [50.3293132, 36.6389476],
              [50.3272641, 36.6395903],
              [50.3252539, 36.6429379],
              [50.323411, 36.6448662],
              [50.3211716, 36.6463619],
              [50.3178977, 36.650586],
              [50.314207, 36.6528584],
              [50.313177, 36.6551307],
              [50.3106879, 36.6587801],
              [50.3069972, 36.6607768],
              [50.2994441, 36.6667667],
              [50.2898311, 36.6673863],
              [50.2861404, 36.6711727],
              [50.2798747, 36.6731692],
              [50.2735232, 36.6772995],
              [50.2703475, 36.6808101],
              [50.2668353, 36.6833764],
              [50.2657446, 36.6843132],
              [50.2613353, 36.681464],
              [50.2506516, 36.6722207],
              [50.2464852, 36.6741658],
              [50.2417651, 36.6761109],
              [50.2320418, 36.6786142],
              [50.230375, 36.6786143],
              [50.2275953, 36.6791725],
              [50.2248187, 36.6791725],
              [50.223985, 36.6794517],
              [50.2214853, 36.6797219],
              [50.2012056, 36.6780559],
              [50.166149, 36.6780568],
              [50.1538753, 36.6743394],
              [50.142288, 36.6723432],
              [50.1309756, 36.6719329],
              [50.1253055, 36.6737765],
              [50.1121317, 36.677318],
              [50.1006602, 36.6779879],
              [50.0951671, 36.6797776],
              [50.085554, 36.6806036],
              [50.0805759, 36.6792269],
              [50.0781546, 36.679457],
              [50.0673288, 36.6752866],
              [50.0628051, 36.6719981],
              [50.0664135, 36.6342644],
              [50.0619415, 36.6146658],
              [50.0580516, 36.6124317],
              [50.0524948, 36.609657],
              [50.0519417, 36.6090985],
              [50.04626, 36.6130272],
              [50.0440067, 36.6136233],
              [50.0395429, 36.6124079],
              [50.0381755, 36.6083625],
              [50.033884, 36.6062956],
              [50.028305, 36.6066401],
              [50.0197219, 36.6082247],
              [50.0134563, 36.6085692],
              [50.001011, 36.6153071],
              [49.9919986, 36.61787],
              [49.9733733, 36.6157344],
              [49.9618718, 36.6179391],
              [49.9550914, 36.6195234],
              [49.9500703, 36.6201089],
              [49.9449634, 36.6187655],
              [49.9409294, 36.6192133],
              [49.9389123, 36.6188344],
              [49.9289131, 36.625172],
              [49.9261665, 36.6257231],
              [49.923377, 36.6270663],
              [49.918828, 36.6267563],
              [49.9177122, 36.6259642],
              [49.917283, 36.6244143],
              [49.9153089, 36.6234499],
              [49.9121868, 36.6221621],
              [49.9094081, 36.6206083],
              [49.9087214, 36.6199194],
              [49.9083568, 36.6190047],
              [49.9082708, 36.6174911],
              [49.9096656, 36.6162855],
              [49.9107384, 36.6137536],
              [49.9122405, 36.6119968],
              [49.9131202, 36.609396],
              [49.9124335, 36.607932],
              [49.9105668, 36.6072257],
              [49.9094295, 36.6069846],
              [49.9089359, 36.606485],
              [49.9085498, 36.6059165],
              [49.9085712, 36.6036256],
              [49.9090218, 36.6023681],
              [49.9089789, 36.6011622],
              [49.9086571, 36.5999908],
              [49.9079919, 36.5987333],
              [49.9073694, 36.5979582],
              [49.9062753, 36.5977513],
              [49.9050521, 36.5972001],
              [49.9035071, 36.5959597],
              [49.9033999, 36.5949949],
              [49.9036788, 36.594237],
              [49.9041939, 36.5933928],
              [49.9060177, 36.5921524],
              [49.9062967, 36.5912048],
              [49.9051164, 36.5898783],
              [49.8979282, 36.5859671],
              [49.893894, 36.5842098],
              [49.8918771, 36.5804534],
              [49.8905897, 36.5779032],
              [49.8901175, 36.5744569],
              [49.8895789, 36.5647416],
              [49.8827361, 36.55674],
              [49.8795604, 36.5548095],
              [49.8770713, 36.5546027],
              [49.871149, 36.5561195],
              [49.8672866, 36.5559816],
              [49.8647117, 36.5549474],
              [49.8615622, 36.5527982],
              [49.8295211, 36.5503968],
              [49.8116683, 36.5530858],
              [49.8077201, 36.5562574],
              [49.8045444, 36.5577742],
              [49.8020553, 36.5561195],
              [49.7987079, 36.5553611],
              [49.7939014, 36.5556369],
              [49.7889488, 36.5566251],
              [49.7853183, 36.5570847],
              [49.7811126, 36.5581189],
              [49.7731303, 36.5610145],
              [49.7687026, 36.5641354],
              [49.7642646, 36.5665516],
              [49.7583062, 36.5683384],
              [49.750462, 36.5692346],
              [49.7491388, 36.5680661],
              [49.7454598, 36.5637231],
              [49.7428763, 36.559735],
              [49.7374334, 36.5571151],
              [49.7326182, 36.5587394],
              [49.7301292, 36.5618418],
              [49.7267818, 36.5718375],
              [49.7220611, 36.5775586],
              [49.7198295, 36.5825901],
              [49.7042941, 36.5866563],
              [49.6954536, 36.5927898],
              [49.6841241, 36.5969795],
              [49.6760745, 36.5997877],
              [49.6700864, 36.6028334],
              [49.6311786, 36.6024991],
              [49.6250647, 36.601377],
              [49.6220247, 36.6028964],
              [49.62192, 36.6014251],
              [49.6190293, 36.5996625],
              [49.6156005, 36.6013407],
              [49.6156993, 36.6000178],
              [49.6133652, 36.5983985],
              [49.6088603, 36.5989188],
              [49.606286, 36.6001176],
              [49.6054729, 36.5989274],
              [49.6003948, 36.5973071],
              [49.5959806, 36.5985437],
              [49.5938943, 36.5977811],
              [49.5903019, 36.5975781],
              [49.5848346, 36.6002482],
              [49.582331, 36.6019827],
              [49.5807739, 36.6027823],
              [49.5782559, 36.6034214],
              [49.5753892, 36.6034213],
              [49.5733968, 36.604348],
              [49.5698693, 36.6042744],
              [49.5660461, 36.6051949],
              [49.5611107, 36.6041792],
              [49.5570928, 36.6059535],
              [49.5531195, 36.6066597],
              [49.5433962, 36.6047234],
              [49.5333964, 36.6047235],
              [49.5331197, 36.6044443],
              [49.5242298, 36.6044442],
              [49.52312, 36.604165],
              [49.5208965, 36.6041651],
              [49.5186734, 36.6036066],
              [49.5156166, 36.6036066],
              [49.5153401, 36.6033275],
              [49.5147831, 36.6036067],
              [49.5139499, 36.6036067],
              [49.5131166, 36.6033275],
              [49.5125635, 36.6036066],
              [49.5120065, 36.6033275],
              [49.5092302, 36.6033275],
              [49.4997836, 36.6008328],
              [49.493117, 36.6036066],
              [49.4853403, 36.6074971],
              [49.484227, 36.6080555],
              [49.4789502, 36.6108293],
              [49.4750603, 36.6130538],
              [49.4731262, 36.636923],
              [49.4772934, 36.6398774],
              [49.4780445, 36.6401872],
              [49.4790744, 36.6411515],
              [49.4802332, 36.6421328],
              [49.4799971, 36.6430453],
              [49.479065, 36.6430738],
              [49.4774007, 36.6441128],
              [49.4750833, 36.6449047],
              [49.472524, 36.6449663],
              [49.4712638, 36.6458688],
              [49.4697818, 36.6479365],
              [49.4669264, 36.649399],
              [49.4657119, 36.6495323],
              [49.464333, 36.6499639],
              [49.462808, 36.6503054],
              [49.4608001, 36.6507347],
              [49.4577737, 36.6516337],
              [49.4525931, 36.658955],
              [49.4487522, 36.6622868],
              [49.4475895, 36.6620989],
              [49.4466246, 36.6626258],
              [49.4414362, 36.6614954],
              [49.4380947, 36.6625316],
              [49.4233522, 36.6831764],
              [49.4178431, 36.6827727],
              [49.4143024, 36.6842459],
              [49.4088969, 36.6867629],
              [49.4019774, 36.6912978],
              [49.3935211, 36.6961411],
              [49.3870137, 36.7011122],
              [49.3792987, 36.7107355],
              [49.3729831, 36.7191383],
              [49.3677225, 36.7257603],
              [49.3610896, 36.7327297],
              [49.3421144, 36.7421042],
              [49.3321021, 36.7487899],
              [49.3277165, 36.7583896],
              [49.3211792, 36.7737582],
              [49.3194293, 36.7779425],
              [49.3018153, 36.7989611],
              [49.2948302, 36.8065297],
              [49.2862068, 36.8119117],
              [49.2758416, 36.8151799],
              [49.26733, 36.8125833],
              [49.2371898, 36.7891701],
              [49.2258041, 36.7829726],
              [49.2087653, 36.7790003],
              [49.192995, 36.7714758],
              [49.1834839, 36.769005],
              [49.1772993, 36.7685972],
              [49.1749472, 36.7700707],
              [49.1712707, 36.7723737],
              [49.166473, 36.775486],
              [49.157837, 36.7780093],
              [49.1538301, 36.7783325],
              [49.148246, 36.7789104],
              [49.1383159, 36.7791745],
              [49.1328093, 36.7795253],
              [49.1253571, 36.7770862],
              [49.1235109, 36.7745358],
              [49.1179787, 36.7711937],
              [49.1090241, 36.7631163],
              [49.1074016, 36.7616524],
              [49.1014726, 36.7506841],
              [49.0993761, 36.7480551],
              [49.0977787, 36.7444468],
              [49.0943518, 36.7386594],
              [49.0875042, 36.7265086],
              [49.0853884, 36.7234202],
              [49.0818379, 36.7201542],
              [49.0794553, 36.7176155],
              [49.0760992, 36.7123053],
              [49.0749411, 36.7095408],
              [49.0737758, 36.7054519],
              [49.0728278, 36.7012539],
              [49.0737272, 36.6962685],
              [49.0747826, 36.6904169],
              [49.0716909, 36.688649],
              [49.0706317, 36.6842745],
              [49.0609606, 36.682277],
              [49.0491207, 36.6757847],
              [49.0359132, 36.6758816],
              [49.0325217, 36.675142],
              [49.0265026, 36.6732976],
              [49.0141472, 36.6670238],
              [49.010489, 36.6623144],
              [49.0079434, 36.6573224],
              [49.0089609, 36.6536589],
              [49.0122024, 36.6515042],
              [49.0121098, 36.649015],
              [49.0104427, 36.6454112],
              [49.0119374, 36.6397611],
              [49.0033696, 36.6347619],
              [49.003973, 36.6303089],
              [49.0038339, 36.6267846],
              [49.0028716, 36.6235801],
              [49.001095, 36.6210996],
              [49.0036484, 36.6157139],
              [49.0033577, 36.6105157],
              [48.9896509, 36.5848636],
              [48.9812231, 36.5741542],
              [48.9717891, 36.5558654],
              [48.977481, 36.5401706],
              [48.9943885, 36.5252257],
              [49.0148162, 36.5137753],
              [49.0288066, 36.5080495],
              [49.0441703, 36.5053589],
              [49.0583324, 36.4972176],
              [49.0633964, 36.4923186],
              [49.0681144, 36.4891203],
              [49.0814319, 36.4716585],
              [49.092542, 36.4511034],
              [49.0950416, 36.4474913],
              [49.0955983, 36.4463834],
              [49.1042083, 36.4377721],
              [49.1050414, 36.4374927],
              [49.1053216, 36.4369343],
              [49.105875, 36.4366551],
              [49.109765, 36.4336014],
              [49.1192117, 36.42971],
              [49.120045, 36.4294398],
              [49.1205981, 36.4294398],
              [49.138168, 36.4192065],
              [49.1403911, 36.419765],
              [49.1426145, 36.419765],
              [49.1440009, 36.4194858],
              [49.1473346, 36.4194858],
              [49.1487245, 36.419765],
              [49.1492811, 36.4194858],
              [49.1509475, 36.419765],
              [49.153171, 36.4197651],
              [49.2015212, 36.4076573],
              [49.2356038, 36.3992007],
              [49.26644, 36.3930475],
              [49.2669967, 36.3927682],
              [49.2729622, 36.390203],
              [49.3065477, 36.394258],
              [49.3369993, 36.3894352],
              [49.3408892, 36.388048],
              [49.3444992, 36.3852644],
              [49.3461655, 36.3797152],
              [49.376897, 36.34579],
              [49.4154036, 36.3240319],
              [49.4175583, 36.3086],
              [49.4167251, 36.3077621],
              [49.4177498, 36.2902789],
              [49.4091223, 36.2738951],
              [49.4036687, 36.2480471],
              [49.4005726, 36.2206729],
              [49.4142804, 36.2116728],
              [49.4231153, 36.2077634],
              [49.4264486, 36.2038709],
              [49.4317254, 36.1974916],
              [49.4317253, 36.1972123],
              [49.4317253, 36.196933],
              [49.4328386, 36.1955453],
              [49.4331153, 36.1944371],
              [49.4333917, 36.1941488],
              [49.4336719, 36.1930405],
              [49.432382, 36.1716536],
              [49.4246021, 36.1580472],
              [49.4168254, 36.1449903],
              [49.4143254, 36.134988],
              [49.4146024, 36.1333209],
              [49.4148821, 36.1316539],
              [49.415159, 36.1308158],
              [49.4151591, 36.1263733],
              [49.4157156, 36.1238771],
              [49.4157157, 36.1235977],
              [49.416549, 36.1211017],
              [49.4165489, 36.1149919],
              [49.4184924, 36.1002673],
              [49.4193257, 36.0944278],
              [49.4196022, 36.0938781],
              [49.4162689, 36.072205],
              [49.4068258, 36.0541541],
              [49.3978359, 36.0463661],
              [49.3931127, 36.0405444],
              [49.3477271, 36.0215108],
              [49.3477271, 36.0206728],
              [49.3477271, 36.0203934],
              [49.3468935, 36.0190057],
              [49.3388406, 36.0131753],
              [49.3431102, 35.9988722],
              [49.3361667, 35.9966461],
              [49.3131553, 35.9597019],
              [49.3053786, 35.9574753],
              [49.3039887, 35.9574753],
              [49.3031555, 35.9571959],
              [49.3017656, 35.9571959],
              [49.3006554, 35.9569164],
              [49.2625511, 35.9719247],
              [49.2592179, 35.9719247],
              [49.2583847, 35.9722041],
              [49.2458848, 35.9749799],
              [49.2110478, 35.9726679],
              [49.1861585, 35.958036],
              [49.1817156, 35.9555395],
              [49.1808823, 35.9555394],
              [49.1739357, 35.9516459],
              [49.163659, 35.9394244],
              [49.1636589, 35.9391451],
              [49.1525458, 35.9324755],
              [49.1517127, 35.9305377],
              [49.1517126, 35.9299788],
              [49.1506025, 35.9296995],
              [49.1475458, 35.9296995],
              [49.1464359, 35.9299788],
              [49.1411561, 35.9299789],
              [49.1406026, 35.9302582],
              [49.1378224, 35.9302582],
              [49.1375459, 35.9305376],
              [49.1358794, 35.9305377],
              [49.1353228, 35.9308171],
              [49.1314361, 35.9313669],
              [49.1247664, 35.9313668],
              [49.1244894, 35.9316463],
              [49.1233795, 35.9316463],
              [49.1230995, 35.9319257],
              [49.1217128, 35.9319256],
              [49.1208796, 35.932205],
              [49.1186564, 35.9324755],
              [49.098146, 35.931374],
              [49.093146, 35.9255432],
              [49.093423, 35.9235965],
              [49.0970363, 35.916657],
              [49.0978696, 35.9163777],
              [49.085423, 35.8913526],
              [49.0854238, 35.8913505],
              [49.0862743, 35.8890786],
              [49.085423, 35.8782902],
              [49.0851465, 35.8774608],
              [49.0839388, 35.8760101],
              [49.0823698, 35.8741252],
              [49.0807034, 35.8732959],
              [49.07959, 35.872187],
              [49.0673668, 35.8663544],
              [49.0665336, 35.8663543],
              [49.06598, 35.866066],
              [49.0645902, 35.8657955],
              [49.0623667, 35.8657955],
              [49.0615335, 35.865516],
              [49.0579236, 35.8655161],
              [49.0570905, 35.8657954],
              [49.0540338, 35.8657954],
              [49.0415338, 35.8702397],
              [49.0362536, 35.8746841],
              [49.0357004, 35.8749545],
              [49.0357005, 35.875243],
              [49.0307004, 35.881905],
              [49.0078174, 35.9044263],
              [48.9919843, 35.9102579],
              [48.9867044, 35.9113665],
              [48.9839278, 35.9113665],
              [48.9825379, 35.9116458],
              [48.9809245, 35.9188716],
              [48.978981, 35.9188716],
              [48.9748145, 35.9197097],
              [48.9609248, 35.9238735],
              [48.9603682, 35.9241529],
              [48.9600912, 35.9244323],
              [48.9417549, 35.936653],
              [48.9115106, 35.957416],
              [48.9008541, 35.9714417],
              [48.8864978, 35.9704722],
              [48.8676456, 35.9603298],
              [48.8563827, 35.9447618],
              [48.8450036, 35.9344009],
              [48.8275331, 35.9144217],
              [48.7872534, 35.8872014],
              [48.7844737, 35.8841459],
              [48.7816971, 35.8794228],
              [48.7803068, 35.8766376],
              [48.7747505, 35.8449726],
              [48.771974, 35.8391406],
              [48.7714173, 35.8388611],
              [48.7594741, 35.827756],
              [48.7583608, 35.8266472],
              [48.7583608, 35.8263678],
              [48.7578073, 35.8260884],
              [48.756694, 35.8249707],
              [48.7564174, 35.8247002],
              [48.756379, 35.8245463],
              [48.7561408, 35.8235915],
              [48.7564174, 35.8233031],
              [48.7528076, 35.8060861],
              [48.7486411, 35.799695],
              [48.7383609, 35.7821982],
              [48.7361378, 35.7788628],
              [48.7361379, 35.7783039],
              [48.7255814, 35.7602479],
              [48.7247478, 35.7569124],
              [48.7244712, 35.7513594],
              [48.7247478, 35.7494213],
              [48.7308612, 35.7335823],
              [48.7328047, 35.7299764],
              [48.7363237, 35.7239575]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241472,
        "tags": {
          "ISO3166-2": "IR-01",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "گیلان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q928828"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [48.5674486, 37.8493404],
              [48.5695708, 37.8478445],
              [48.5729359, 37.8418889],
              [48.5722921, 37.8353266],
              [48.5702311, 37.8316334],
              [48.5661733, 37.8258146],
              [48.5632099, 37.8199981],
              [48.5623169, 37.8128693],
              [48.5677554, 37.8030093],
              [48.5788905, 37.7900884],
              [48.5917757, 37.7813026],
              [48.601101, 37.7789593],
              [48.6094397, 37.7835795],
              [48.6158328, 37.7889383],
              [48.618123, 37.78936],
              [48.6228054, 37.783965],
              [48.627501, 37.7808977],
              [48.6333926, 37.7787375],
              [48.6410506, 37.7779619],
              [48.6442319, 37.7750664],
              [48.6438559, 37.7635228],
              [48.6340712, 37.7498152],
              [48.6330412, 37.7378699],
              [48.6316749, 37.7185589],
              [48.6108499, 37.7055818],
              [48.6083498, 37.7047455],
              [48.60696, 37.7047455],
              [48.6055701, 37.7055818],
              [48.6047364, 37.7055817],
              [48.5991837, 37.7030821],
              [48.59807, 37.7014186],
              [48.59807, 37.7005825],
              [48.59835, 37.6997462],
              [48.59835, 37.6994675],
              [48.5991836, 37.6983525],
              [48.5975134, 37.6944682],
              [48.5958468, 37.691411],
              [48.5961269, 37.6908535],
              [48.5958469, 37.6905837],
              [48.5966801, 37.6880751],
              [48.5997369, 37.6853057],
              [48.6058502, 37.6800275],
              [48.6069601, 37.678355],
              [48.6097367, 37.6725193],
              [48.6097367, 37.6722406],
              [48.6097367, 37.6716921],
              [48.6100168, 37.6714133],
              [48.6097368, 37.662799],
              [48.6097368, 37.6594719],
              [48.6122369, 37.6519724],
              [48.6139032, 37.6497423],
              [48.6144599, 37.6491938],
              [48.615017, 37.6480788],
              [48.6164069, 37.6464152],
              [48.6252935, 37.6330795],
              [48.6369632, 37.6208585],
              [48.6377965, 37.6205798],
              [48.6386302, 37.6197435],
              [48.6809359, 37.6010516],
              [48.6826028, 37.5996668],
              [48.6848263, 37.5966093],
              [48.6848262, 37.5963305],
              [48.6884361, 37.5863307],
              [48.6867693, 37.5766093],
              [48.6848263, 37.575773],
              [48.6839928, 37.575773],
              [48.6839928, 37.5754942],
              [48.682883, 37.5752155],
              [48.6826028, 37.5746668],
              [48.6761296, 37.5691845],
              [48.6825133, 37.5597993],
              [48.6827934, 37.5589724],
              [48.6841799, 37.5561951],
              [48.6850134, 37.5553592],
              [48.6858466, 37.5536964],
              [48.6944958, 37.5317825],
              [48.6896893, 37.5099985],
              [48.7152994, 37.4741889],
              [48.7318804, 37.4570545],
              [48.7359667, 37.450833],
              [48.7414126, 37.4450183],
              [48.7481402, 37.4364985],
              [48.7570134, 37.429946],
              [48.7640189, 37.4240256],
              [48.7668746, 37.4205747],
              [48.8000253, 37.3919627],
              [48.8003024, 37.3916839],
              [48.8097487, 37.3839023],
              [48.8139156, 37.3805738],
              [48.8112257, 37.3505096],
              [48.8266752, 37.3330407],
              [48.8433264, 37.3107892],
              [48.8477896, 37.3072392],
              [48.8654707, 37.3008216],
              [48.8714789, 37.2969981],
              [48.8751944, 37.2929557],
              [48.8756847, 37.2861409],
              [48.8696765, 37.2747359],
              [48.8731097, 37.267974],
              [48.8737964, 37.261553],
              [48.8755566, 37.2548425],
              [48.8777775, 37.2519893],
              [48.8953085, 37.2255624],
              [48.8994749, 37.2183459],
              [48.901422, 37.2150075],
              [48.9203115, 37.1852855],
              [48.9205884, 37.1833418],
              [48.920865, 37.181677],
              [48.9211451, 37.1802912],
              [48.9214217, 37.1800122],
              [48.9208613, 37.1770978],
              [48.9207078, 37.1766933],
              [48.9202965, 37.1756236],
              [48.9201232, 37.1750198],
              [48.919517, 37.1746748],
              [48.9187808, 37.1738121],
              [48.9180229, 37.1727769],
              [48.9178064, 37.1720351],
              [48.9181312, 37.1710344],
              [48.9182611, 37.1706893],
              [48.9228116, 37.1672339],
              [48.9247551, 37.1622304],
              [48.9261449, 37.1600077],
              [48.9308649, 37.1516745],
              [48.9314215, 37.1513956],
              [48.9319782, 37.1502887],
              [48.9394534, 37.1448358],
              [48.9554211, 37.132814],
              [48.9682959, 37.1339087],
              [48.988134, 37.1360832],
              [48.9978216, 37.1371931],
              [49.0197518, 37.1334077],
              [49.0343394, 37.1313055],
              [49.0351731, 37.1304778],
              [49.0715641, 37.121786],
              [49.0908318, 37.1161689],
              [49.1078642, 37.1051205],
              [49.1240481, 37.09095],
              [49.1298434, 37.0840608],
              [49.1393832, 37.0716808],
              [49.1585477, 37.0431084],
              [49.1599379, 37.038942],
              [49.1708095, 37.0212894],
              [49.1748046, 37.0116002],
              [49.1790761, 37.0020017],
              [49.1834031, 36.9914532],
              [49.1996944, 36.9594611],
              [49.2061682, 36.9455976],
              [49.2220402, 36.9263899],
              [49.2270998, 36.9200325],
              [49.2298946, 36.9167409],
              [49.2326744, 36.9130993],
              [49.2393046, 36.902649],
              [49.2443617, 36.8849074],
              [49.2499516, 36.8729205],
              [49.2589381, 36.854392],
              [49.2638796, 36.8454154],
              [49.2681048, 36.8365409],
              [49.2758416, 36.8151799],
              [49.2862068, 36.8119117],
              [49.2948302, 36.8065297],
              [49.3018153, 36.7989611],
              [49.3194293, 36.7779425],
              [49.3211792, 36.7737582],
              [49.3277165, 36.7583896],
              [49.3321021, 36.7487899],
              [49.3421144, 36.7421042],
              [49.3610896, 36.7327297],
              [49.3677225, 36.7257603],
              [49.3729831, 36.7191383],
              [49.3792987, 36.7107355],
              [49.3870137, 36.7011122],
              [49.3935211, 36.6961411],
              [49.4019774, 36.6912978],
              [49.4088969, 36.6867629],
              [49.4143024, 36.6842459],
              [49.4178431, 36.6827727],
              [49.4233522, 36.6831764],
              [49.4380947, 36.6625316],
              [49.4414362, 36.6614954],
              [49.4466246, 36.6626258],
              [49.4475895, 36.6620989],
              [49.4487522, 36.6622868],
              [49.4525931, 36.658955],
              [49.4577737, 36.6516337],
              [49.4608001, 36.6507347],
              [49.462808, 36.6503054],
              [49.464333, 36.6499639],
              [49.4657119, 36.6495323],
              [49.4669264, 36.649399],
              [49.4697818, 36.6479365],
              [49.4712638, 36.6458688],
              [49.472524, 36.6449663],
              [49.4750833, 36.6449047],
              [49.4774007, 36.6441128],
              [49.479065, 36.6430738],
              [49.4799971, 36.6430453],
              [49.4802332, 36.6421328],
              [49.4790744, 36.6411515],
              [49.4780445, 36.6401872],
              [49.4772934, 36.6398774],
              [49.4731262, 36.636923],
              [49.4750603, 36.6130538],
              [49.4789502, 36.6108293],
              [49.484227, 36.6080555],
              [49.4853403, 36.6074971],
              [49.493117, 36.6036066],
              [49.4997836, 36.6008328],
              [49.5092302, 36.6033275],
              [49.5120065, 36.6033275],
              [49.5125635, 36.6036066],
              [49.5131166, 36.6033275],
              [49.5139499, 36.6036067],
              [49.5147831, 36.6036067],
              [49.5153401, 36.6033275],
              [49.5156166, 36.6036066],
              [49.5186734, 36.6036066],
              [49.5208965, 36.6041651],
              [49.52312, 36.604165],
              [49.5242298, 36.6044442],
              [49.5331197, 36.6044443],
              [49.5333964, 36.6047235],
              [49.5433962, 36.6047234],
              [49.5531195, 36.6066597],
              [49.5570928, 36.6059535],
              [49.5611107, 36.6041792],
              [49.5660461, 36.6051949],
              [49.5698693, 36.6042744],
              [49.5733968, 36.604348],
              [49.5753892, 36.6034213],
              [49.5782559, 36.6034214],
              [49.5807739, 36.6027823],
              [49.582331, 36.6019827],
              [49.5848346, 36.6002482],
              [49.5903019, 36.5975781],
              [49.5938943, 36.5977811],
              [49.5959806, 36.5985437],
              [49.6003948, 36.5973071],
              [49.6054729, 36.5989274],
              [49.606286, 36.6001176],
              [49.6088603, 36.5989188],
              [49.6133652, 36.5983985],
              [49.6156993, 36.6000178],
              [49.6156005, 36.6013407],
              [49.6190293, 36.5996625],
              [49.62192, 36.6014251],
              [49.6220247, 36.6028964],
              [49.6250647, 36.601377],
              [49.6311786, 36.6024991],
              [49.6700864, 36.6028334],
              [49.6760745, 36.5997877],
              [49.6841241, 36.5969795],
              [49.6954536, 36.5927898],
              [49.7042941, 36.5866563],
              [49.7198295, 36.5825901],
              [49.7220611, 36.5775586],
              [49.7267818, 36.5718375],
              [49.7301292, 36.5618418],
              [49.7326182, 36.5587394],
              [49.7374334, 36.5571151],
              [49.7428763, 36.559735],
              [49.7454598, 36.5637231],
              [49.7491388, 36.5680661],
              [49.750462, 36.5692346],
              [49.7583062, 36.5683384],
              [49.7642646, 36.5665516],
              [49.7687026, 36.5641354],
              [49.7731303, 36.5610145],
              [49.7811126, 36.5581189],
              [49.7853183, 36.5570847],
              [49.7889488, 36.5566251],
              [49.7939014, 36.5556369],
              [49.7987079, 36.5553611],
              [49.8020553, 36.5561195],
              [49.8045444, 36.5577742],
              [49.8077201, 36.5562574],
              [49.8116683, 36.5530858],
              [49.8295211, 36.5503968],
              [49.8615622, 36.5527982],
              [49.8647117, 36.5549474],
              [49.8672866, 36.5559816],
              [49.871149, 36.5561195],
              [49.8770713, 36.5546027],
              [49.8795604, 36.5548095],
              [49.8827361, 36.55674],
              [49.8895789, 36.5647416],
              [49.8901175, 36.5744569],
              [49.8905897, 36.5779032],
              [49.8918771, 36.5804534],
              [49.893894, 36.5842098],
              [49.8979282, 36.5859671],
              [49.9051164, 36.5898783],
              [49.9062967, 36.5912048],
              [49.9060177, 36.5921524],
              [49.9041939, 36.5933928],
              [49.9036788, 36.594237],
              [49.9033999, 36.5949949],
              [49.9035071, 36.5959597],
              [49.9050521, 36.5972001],
              [49.9062753, 36.5977513],
              [49.9073694, 36.5979582],
              [49.9079919, 36.5987333],
              [49.9086571, 36.5999908],
              [49.9089789, 36.6011622],
              [49.9090218, 36.6023681],
              [49.9085712, 36.6036256],
              [49.9085498, 36.6059165],
              [49.9089359, 36.606485],
              [49.9094295, 36.6069846],
              [49.9105668, 36.6072257],
              [49.9124335, 36.607932],
              [49.9131202, 36.609396],
              [49.9122405, 36.6119968],
              [49.9107384, 36.6137536],
              [49.9096656, 36.6162855],
              [49.9082708, 36.6174911],
              [49.9083568, 36.6190047],
              [49.9087214, 36.6199194],
              [49.9094081, 36.6206083],
              [49.9121868, 36.6221621],
              [49.9153089, 36.6234499],
              [49.917283, 36.6244143],
              [49.9177122, 36.6259642],
              [49.918828, 36.6267563],
              [49.923377, 36.6270663],
              [49.9261665, 36.6257231],
              [49.9289131, 36.625172],
              [49.9389123, 36.6188344],
              [49.9409294, 36.6192133],
              [49.9449634, 36.6187655],
              [49.9500703, 36.6201089],
              [49.9550914, 36.6195234],
              [49.9618718, 36.6179391],
              [49.9733733, 36.6157344],
              [49.9919986, 36.61787],
              [50.001011, 36.6153071],
              [50.0134563, 36.6085692],
              [50.0197219, 36.6082247],
              [50.028305, 36.6066401],
              [50.033884, 36.6062956],
              [50.0381755, 36.6083625],
              [50.0395429, 36.6124079],
              [50.0440067, 36.6136233],
              [50.04626, 36.6130272],
              [50.0519417, 36.6090985],
              [50.0524948, 36.609657],
              [50.0580516, 36.6124317],
              [50.0619415, 36.6146658],
              [50.0664135, 36.6342644],
              [50.0628051, 36.6719981],
              [50.0673288, 36.6752866],
              [50.0781546, 36.679457],
              [50.0805759, 36.6792269],
              [50.085554, 36.6806036],
              [50.0951671, 36.6797776],
              [50.1006602, 36.6779879],
              [50.1121317, 36.677318],
              [50.1253055, 36.6737765],
              [50.1309756, 36.6719329],
              [50.142288, 36.6723432],
              [50.1538753, 36.6743394],
              [50.166149, 36.6780568],
              [50.2012056, 36.6780559],
              [50.2214853, 36.6797219],
              [50.223985, 36.6794517],
              [50.2248187, 36.6791725],
              [50.2275953, 36.6791725],
              [50.230375, 36.6786143],
              [50.2320418, 36.6786142],
              [50.2417651, 36.6761109],
              [50.2464852, 36.6741658],
              [50.2506516, 36.6722207],
              [50.2613353, 36.681464],
              [50.2657446, 36.6843132],
              [50.2668353, 36.6833764],
              [50.2703475, 36.6808101],
              [50.2735232, 36.6772995],
              [50.2798747, 36.6731692],
              [50.2861404, 36.6711727],
              [50.2898311, 36.6673863],
              [50.2994441, 36.6667667],
              [50.3069972, 36.6607768],
              [50.3106879, 36.6587801],
              [50.313177, 36.6551307],
              [50.314207, 36.6528584],
              [50.3178977, 36.650586],
              [50.3211716, 36.6463619],
              [50.323411, 36.6448662],
              [50.3252539, 36.6429379],
              [50.3272641, 36.6395903],
              [50.3293132, 36.6389476],
              [50.3321456, 36.6387582],
              [50.3342888, 36.6376263],
              [50.3382826, 36.6365542],
              [50.3397845, 36.6366059],
              [50.3464793, 36.6366748],
              [50.3493117, 36.637639],
              [50.3505992, 36.6390853],
              [50.3531741, 36.6436307],
              [50.3635962, 36.6533413],
              [50.3775119, 36.6636305],
              [50.3834724, 36.6675928],
              [50.3854465, 36.6680059],
              [50.4125978, 36.6873202],
              [50.4122256, 36.6969844],
              [50.4131481, 36.7074981],
              [50.4129323, 36.7125977],
              [50.4154014, 36.7231315],
              [50.4172896, 36.724301],
              [50.4174613, 36.7282222],
              [50.4197787, 36.7313178],
              [50.4246711, 36.7373022],
              [50.4266452, 36.7384027],
              [50.4310226, 36.7429422],
              [50.433855, 36.7476878],
              [50.4355716, 36.7487194],
              [50.4360866, 36.7533959],
              [50.4359149, 36.7604787],
              [50.4364299, 36.7658421],
              [50.4370843, 36.7703113],
              [50.4369019, 36.7739379],
              [50.4349279, 36.7771175],
              [50.4303787, 36.7828578],
              [50.4286192, 36.7915533],
              [50.4254436, 36.7956084],
              [50.4214094, 36.7996636],
              [50.4159163, 36.8030999],
              [50.4078482, 36.8050241],
              [50.4047583, 36.8116212],
              [50.4126547, 36.8164313],
              [50.423126, 36.8267375],
              [50.4221654, 36.8355556],
              [50.4232977, 36.8440488],
              [50.4314518, 36.8526685],
              [50.4354384, 36.8565305],
              [50.4400561, 36.8617295],
              [50.4431018, 36.8647941],
              [50.4447614, 36.8667343],
              [50.4468139, 36.8683225],
              [50.4494471, 36.870738],
              [50.4513645, 36.8717935],
              [50.4532527, 36.8722055],
              [50.4549694, 36.8729264],
              [50.4575598, 36.8733138],
              [50.4650518, 36.8734855],
              [50.4689169, 36.873716],
              [50.4723404, 36.8744124],
              [50.4813398, 36.8768973],
              [50.4864692, 36.8775953],
              [50.49046, 36.8777485],
              [50.4999446, 36.8768916],
              [50.5054163, 36.8802901],
              [50.506854, 36.8821608],
              [50.5080986, 36.8841518],
              [50.5086135, 36.8855935],
              [50.5099868, 36.8895751],
              [50.510232, 36.8915141],
              [50.5150987, 36.8865545],
              [50.5198544, 36.8882106],
              [50.5217878, 36.8884766],
              [50.521473, 36.8868327],
              [50.5226033, 36.8867565],
              [50.5258783, 36.8927975],
              [50.5336375, 36.9027241],
              [50.5350672, 36.904424],
              [50.5359444, 36.9055611],
              [50.5375697, 36.9069771],
              [50.5400672, 36.9090291],
              [50.5578803, 36.9252631],
              [50.5628585, 36.9299288],
              [50.5660342, 36.9361721],
              [50.5674278, 36.9411326],
              [50.5684621, 36.9487785],
              [50.5730036, 36.9524367],
              [50.5811996, 36.952741],
              [50.5853596, 36.9553636],
              [50.5888539, 36.960171],
              [50.5857445, 36.9672624],
              [50.5875665, 36.968186],
              [50.7315385, 37.1374371],
              [50.7272483, 37.1401417],
              [50.7228852, 37.1427706],
              [50.7184511, 37.1453225],
              [50.7139482, 37.1477961],
              [50.7093788, 37.1501904],
              [50.7047448, 37.1525041],
              [50.7000487, 37.1547362],
              [50.6942799, 37.1573291],
              [50.6884271, 37.1597988],
              [50.6720796, 37.1664753],
              [50.6652526, 37.1691586],
              [50.6583265, 37.1716745],
              [50.6513077, 37.1740203],
              [50.6442026, 37.1761941],
              [50.6390503, 37.1776481],
              [50.6338593, 37.1790115],
              [50.6286322, 37.1802837],
              [50.6233715, 37.1814641],
              [50.6180797, 37.1825523],
              [50.6127594, 37.1835475],
              [50.6087603, 37.1842221],
              [50.6079066, 37.1856549],
              [50.6054481, 37.1895591],
              [50.6028834, 37.1934193],
              [50.6002138, 37.1972338],
              [50.5974406, 37.2010008],
              [50.594565, 37.2047184],
              [50.5915884, 37.2083849],
              [50.5885122, 37.2119984],
              [50.5853379, 37.2155574],
              [50.582067, 37.21906],
              [50.578701, 37.2225046],
              [50.5752416, 37.2258896],
              [50.5711045, 37.2297477],
              [50.566846, 37.2335205],
              [50.5624688, 37.2372055],
              [50.5579756, 37.2408005],
              [50.5564232, 37.2420114],
              [50.5497531, 37.2470265],
              [50.5428575, 37.2518431],
              [50.5386358, 37.2546221],
              [50.534339, 37.2573266],
              [50.5299691, 37.2599555],
              [50.5255282, 37.2625073],
              [50.5210184, 37.2649809],
              [50.5164419, 37.2673752],
              [50.514149, 37.2686541],
              [50.5112612, 37.2754297],
              [50.5093469, 37.279525],
              [50.507321, 37.2835858],
              [50.5051845, 37.2876103],
              [50.5029384, 37.2915966],
              [50.5005523, 37.2955926],
              [50.4965277, 37.3040251],
              [50.4881236, 37.3189529],
              [50.4850899, 37.3265758],
              [50.484642, 37.3276297],
              [50.4829999, 37.3320408],
              [50.4812259, 37.3364326],
              [50.4793256, 37.3407905],
              [50.4774564, 37.3447889],
              [50.4755084, 37.3486991],
              [50.4748739, 37.3551215],
              [50.473967, 37.3616017],
              [50.4725334, 37.3705247],
              [50.471764, 37.3749255],
              [50.4708724, 37.3793115],
              [50.4698764, 37.3836102],
              [50.468763, 37.3878905],
              [50.4675327, 37.3921504],
              [50.4661862, 37.3963878],
              [50.4647239, 37.4006008],
              [50.4631465, 37.4047873],
              [50.4614549, 37.4089454],
              [50.4596498, 37.4130729],
              [50.457612, 37.4174156],
              [50.4554486, 37.4217194],
              [50.4531606, 37.4259821],
              [50.4507493, 37.4302014],
              [50.4455308, 37.4390578],
              [50.4409637, 37.4464119],
              [50.4360217, 37.4536105],
              [50.4334635, 37.4571043],
              [50.4311541, 37.4612001],
              [50.4287942, 37.4651462],
              [50.4263267, 37.4690502],
              [50.4237526, 37.4729103],
              [50.4210732, 37.4767247],
              [50.4170435, 37.482119],
              [50.4128032, 37.48741],
              [50.4083564, 37.4925923],
              [50.4037074, 37.4976609],
              [50.4004046, 37.5011453],
              [50.3966176, 37.5050396],
              [50.3927112, 37.5088584],
              [50.3891466, 37.512182],
              [50.3854916, 37.5154428],
              [50.3817478, 37.5186392],
              [50.377917, 37.5217696],
              [50.3740011, 37.5248326],
              [50.3700019, 37.5278267],
              [50.3659214, 37.5307504],
              [50.3617614, 37.5336025],
              [50.3572479, 37.5365582],
              [50.352649, 37.5394295],
              [50.3521998, 37.5397033],
              [50.345724, 37.5435205],
              [50.3390974, 37.5471704],
              [50.3323268, 37.5506491],
              [50.3254191, 37.553953],
              [50.3206378, 37.5561023],
              [50.3157984, 37.5581678],
              [50.3109033, 37.5601486],
              [50.3059549, 37.5620437],
              [50.3017682, 37.5635582],
              [50.3002491, 37.5642065],
              [50.2953536, 37.5661873],
              [50.2904048, 37.5680824],
              [50.2854049, 37.5698909],
              [50.2803565, 37.5716119],
              [50.2752618, 37.5732447],
              [50.2701234, 37.5747884],
              [50.2614736, 37.57716],
              [50.2527207, 37.5792793],
              [50.2199582, 37.5866905],
              [50.2137902, 37.5880175],
              [50.2075818, 37.5892192],
              [50.2013368, 37.5902948],
              [50.1950594, 37.5912437],
              [50.1931115, 37.5915114],
              [50.1505369, 37.5972186],
              [50.1377042, 37.5984864],
              [50.1357293, 37.6003256],
              [50.13207, 37.6035864],
              [50.1283218, 37.6067827],
              [50.1244866, 37.6099131],
              [50.1205661, 37.6129761],
              [50.1165622, 37.6159702],
              [50.1124769, 37.6188939],
              [50.108312, 37.6217459],
              [50.0998825, 37.6269509],
              [50.0954487, 37.6296403],
              [50.0912535, 37.6321234],
              [50.0865449, 37.6347368],
              [50.0827148, 37.6368111],
              [50.0819988, 37.6371816],
              [50.0773716, 37.6395186],
              [50.0737117, 37.6413226],
              [50.0726991, 37.64181],
              [50.0711247, 37.6425492],
              [50.0698417, 37.6431318],
              [50.0680237, 37.6441518],
              [50.0632365, 37.646301],
              [50.0583913, 37.6483665],
              [50.0534904, 37.6503473],
              [50.0485359, 37.6522424],
              [50.0435305, 37.6540509],
              [50.0384763, 37.6557719],
              [50.0333759, 37.6574046],
              [50.0282317, 37.6589483],
              [50.023118, 37.6603827],
              [50.0179665, 37.6617291],
              [50.0127795, 37.6629869],
              [50.0075595, 37.6641554],
              [49.9958984, 37.6666575],
              [49.9905077, 37.6677631],
              [49.9850876, 37.6687736],
              [49.9796405, 37.6696884],
              [49.9741692, 37.6705071],
              [49.9687437, 37.671221],
              [49.9632997, 37.6718405],
              [49.95784, 37.6723651],
              [49.9523672, 37.6727947],
              [49.9468837, 37.6731291],
              [49.9413924, 37.673368],
              [49.9358958, 37.6735114],
              [49.9281284, 37.6734654],
              [49.9190279, 37.6737956],
              [49.9135287, 37.6737478],
              [49.908032, 37.6736044],
              [49.9025407, 37.6733655],
              [49.8970573, 37.6730311],
              [49.8915844, 37.6726015],
              [49.8861246, 37.6720769],
              [49.8806807, 37.6714574],
              [49.8752552, 37.6707434],
              [49.8699929, 37.6699579],
              [49.8585317, 37.6681456],
              [49.8491035, 37.6665042],
              [49.8397618, 37.6645762],
              [49.8305202, 37.6623647],
              [49.8213925, 37.6598728],
              [49.8198162, 37.6594107],
              [49.8191065, 37.6592005],
              [49.8092763, 37.6560997],
              [49.7996191, 37.652673],
              [49.7901523, 37.6489264],
              [49.789138, 37.6484817],
              [49.779823, 37.6486822],
              [49.7561108, 37.6511624],
              [49.7477207, 37.6515986],
              [49.7437422, 37.6521011],
              [49.735028, 37.6529548],
              [49.7134228, 37.6547622],
              [49.6789071, 37.6576495],
              [49.6732361, 37.6579011],
              [49.6647901, 37.6587519],
              [49.5973932, 37.664582],
              [49.5908839, 37.6650752],
              [49.5844383, 37.6654958],
              [49.5604918, 37.6688479],
              [49.5399187, 37.6721225],
              [49.5346798, 37.6733892],
              [49.5293845, 37.6745696],
              [49.5240579, 37.6756577],
              [49.5187026, 37.6766529],
              [49.5133211, 37.6775548],
              [49.507916, 37.6783629],
              [49.5024899, 37.6790769],
              [49.4970454, 37.6796963],
              [49.4915762, 37.6801829],
              [49.4840979, 37.6818876],
              [49.467749, 37.6863393],
              [49.4303733, 37.6983085],
              [49.4015397, 37.7095083],
              [49.3992962, 37.7105147],
              [49.3944468, 37.7125802],
              [49.3895416, 37.714561],
              [49.386782, 37.7156156],
              [49.3828313, 37.7172109],
              [49.3778724, 37.719106],
              [49.3734818, 37.7206909],
              [49.3694464, 37.7227984],
              [49.367912, 37.7237157],
              [49.3634436, 37.7262675],
              [49.3589059, 37.728741],
              [49.3543011, 37.7311352],
              [49.3496313, 37.7334488],
              [49.3465365, 37.7349084],
              [49.3413851, 37.7379712],
              [49.3353924, 37.7414258],
              [49.3290805, 37.7448372],
              [49.3222644, 37.7491958],
              [49.3190021, 37.7512114],
              [49.3184896, 37.7515618],
              [49.3122939, 37.7555724],
              [49.3059406, 37.7594248],
              [49.2994363, 37.7631152],
              [49.2972598, 37.7642689],
              [49.2962586, 37.7650273],
              [49.2883839, 37.7705144],
              [49.2679205, 37.7859607],
              [49.2620927, 37.7910705],
              [49.26032, 37.7930065],
              [49.2561599, 37.7973003],
              [49.2518546, 37.801503],
              [49.245258, 37.8075189],
              [49.2362111, 37.8154415],
              [49.2333791, 37.8187043],
              [49.233249, 37.8254784],
              [49.2327861, 37.8326556],
              [49.2314177, 37.8483477],
              [49.2308865, 37.8534787],
              [49.2301891, 37.8585971],
              [49.229326, 37.8636995],
              [49.2282978, 37.8687828],
              [49.2272955, 37.8730811],
              [49.226175, 37.8773611],
              [49.2249369, 37.8816207],
              [49.2235817, 37.8858578],
              [49.22211, 37.8900705],
              [49.2205225, 37.8942567],
              [49.21882, 37.8984145],
              [49.2170032, 37.9025418],
              [49.2150731, 37.9066366],
              [49.2130304, 37.9106971],
              [49.2108762, 37.9147213],
              [49.2086114, 37.9187073],
              [49.2062372, 37.9226531],
              [49.2037546, 37.9265569],
              [49.2011649, 37.9304168],
              [49.1984691, 37.934231],
              [49.1939853, 37.9401747],
              [49.1903282, 37.9446619],
              [49.1909329, 37.952302],
              [49.191162, 37.9602989],
              [49.1911588, 37.9619939],
              [49.1911118, 37.968464],
              [49.1908334, 37.976779],
              [49.190119, 37.9850778],
              [49.1889699, 37.9933458],
              [49.1873878, 38.001569],
              [49.1863838, 38.0058673],
              [49.1852614, 38.0101472],
              [49.1840211, 38.0144067],
              [49.1826635, 38.0186438],
              [49.1811892, 38.0228564],
              [49.179599, 38.0270425],
              [49.1778935, 38.0312002],
              [49.1760735, 38.0353274],
              [49.1738759, 38.0399022],
              [49.1738986, 38.0412175],
              [49.1738534, 38.0455884],
              [49.1736875, 38.0499575],
              [49.1734012, 38.0543226],
              [49.1729945, 38.0586818],
              [49.1724675, 38.0630329],
              [49.1718206, 38.0673739],
              [49.1710539, 38.0717027],
              [49.1701679, 38.0760173],
              [49.1691293, 38.0804507],
              [49.1684198, 38.0831395],
              [49.168634, 38.0852766],
              [49.1689506, 38.0896405],
              [49.1691466, 38.0940087],
              [49.1692221, 38.0983793],
              [49.1692228, 38.0991895],
              [49.1692136, 38.1047106],
              [49.1691489, 38.1089801],
              [49.1689691, 38.1132474],
              [49.1686742, 38.1175108],
              [49.1682101, 38.1217767],
              [49.1682205, 38.1224438],
              [49.1688168, 38.1267973],
              [49.169254, 38.1311547],
              [49.1695708, 38.1355185],
              [49.1697669, 38.1398867],
              [49.1698424, 38.1442573],
              [49.1696469, 38.1526896],
              [49.1696119, 38.1533915],
              [49.1691423, 38.1600143],
              [49.1683953, 38.1666212],
              [49.1673715, 38.1732049],
              [49.1660719, 38.1797583],
              [49.1653908, 38.1827236],
              [49.1631617, 38.192027],
              [49.1610831, 38.1998436],
              [49.1586109, 38.2075886],
              [49.1557489, 38.2152496],
              [49.1525015, 38.2228144],
              [49.1494215, 38.2291878],
              [49.1481125, 38.2328703],
              [49.1480711, 38.2368686],
              [49.1479049, 38.2412376],
              [49.147618, 38.2456026],
              [49.1472103, 38.2499617],
              [49.1466821, 38.2543127],
              [49.1460335, 38.2586535],
              [49.1452649, 38.2629822],
              [49.1443767, 38.2672966],
              [49.1431163, 38.2725976],
              [49.1416752, 38.2778699],
              [49.1400543, 38.2831097],
              [49.1382548, 38.2883132],
              [49.1362729, 38.2937527],
              [49.1362825, 38.2941605],
              [49.1363341, 38.2963583],
              [49.1362888, 38.300729],
              [49.1361226, 38.3050979],
              [49.1358354, 38.3094629],
              [49.1354274, 38.3138218],
              [49.1348987, 38.3181728],
              [49.1348429, 38.3185463],
              [49.1342496, 38.3225136],
              [49.1334804, 38.3268423],
              [49.1325914, 38.3311566],
              [49.131583, 38.3354547],
              [49.1303654, 38.3397234],
              [49.1299329, 38.3418272],
              [49.1293658, 38.3461921],
              [49.1285964, 38.3505207],
              [49.1282407, 38.3522462],
              [49.1282332, 38.3531828],
              [49.1282037, 38.356904],
              [49.1288802, 38.3633276],
              [49.1289766, 38.3645358],
              [49.1292034, 38.3653738],
              [49.1302418, 38.3696675],
              [49.1311094, 38.373992],
              [49.1314026, 38.3752818],
              [49.1320426, 38.3782834],
              [49.1323047, 38.3795942],
              [49.133361, 38.3838859],
              [49.1341608, 38.3882111],
              [49.1348407, 38.392549],
              [49.1354003, 38.3968976],
              [49.1358392, 38.4012547],
              [49.1361573, 38.4056183],
              [49.1363543, 38.4099863],
              [49.1364278, 38.414591],
              [49.1364766, 38.4154627],
              [49.1372312, 38.428124],
              [49.1374324, 38.4325381],
              [49.1375098, 38.4369547],
              [49.1374657, 38.4412768],
              [49.137303, 38.4455971],
              [49.1370219, 38.4499137],
              [49.1368682, 38.4515723],
              [48.8822901, 38.4417873],
              [48.8816756, 38.4420418],
              [48.8809664, 38.4422288],
              [48.8801215, 38.4422252],
              [48.8799388, 38.4421659],
              [48.8756913, 38.4407863],
              [48.873879, 38.4401977],
              [48.8732535, 38.4402224],
              [48.8727608, 38.4402419],
              [48.8717076, 38.4405607],
              [48.8711047, 38.4409891],
              [48.8693701, 38.4428635],
              [48.8688552, 38.4438625],
              [48.8680095, 38.4444883],
              [48.8675872, 38.4445487],
              [48.8670282, 38.44438],
              [48.8666526, 38.4444063],
              [48.8660332, 38.4442903],
              [48.8656969, 38.4439519],
              [48.865758, 38.4435453],
              [48.8654777, 38.4427489],
              [48.8651488, 38.4424111],
              [48.8644813, 38.442253],
              [48.8634088, 38.4426818],
              [48.8627289, 38.443476],
              [48.862732, 38.4439447],
              [48.8624645, 38.4444517],
              [48.8619442, 38.4449253],
              [48.8605427, 38.4457575],
              [48.8601256, 38.4461629],
              [48.8590312, 38.4464438],
              [48.858258, 38.4463879],
              [48.8568327, 38.4470823],
              [48.8561715, 38.4475076],
              [48.8554556, 38.4477208],
              [48.8549869, 38.447732],
              [48.8536602, 38.4487946],
              [48.8527655, 38.4485052],
              [48.8520418, 38.4487276],
              [48.8514978, 38.4490862],
              [48.8513945, 38.4497607],
              [48.8508165, 38.4503464],
              [48.8503746, 38.4502079],
              [48.8498861, 38.4499161],
              [48.8491777, 38.4492657],
              [48.8482552, 38.4489143],
              [48.8477548, 38.448632],
              [48.8466433, 38.4487061],
              [48.8462326, 38.448923],
              [48.845484, 38.4492578],
              [48.8444288, 38.4501882],
              [48.84409, 38.4503078],
              [48.8431281, 38.4514148],
              [48.843133, 38.4516614],
              [48.8418546, 38.4521737],
              [48.8411531, 38.4522751],
              [48.8405882, 38.4522034],
              [48.8398248, 38.451926],
              [48.8393056, 38.451805],
              [48.8384602, 38.4519874],
              [48.8373341, 38.4520686],
              [48.8362065, 38.4518016],
              [48.8355211, 38.4517143],
              [48.8341871, 38.4520393],
              [48.8338401, 38.4518064],
              [48.8327394, 38.4501949],
              [48.8314203, 38.4494912],
              [48.8301645, 38.4492316],
              [48.8285316, 38.4494517],
              [48.8255962, 38.4491873],
              [48.8240135, 38.4492084],
              [48.8233257, 38.4487124],
              [48.8210939, 38.4480921],
              [48.8201993, 38.4481808],
              [48.8197822, 38.4485753],
              [48.8195732, 38.4497355],
              [48.8192659, 38.4501612],
              [48.8184354, 38.4506562],
              [48.8169241, 38.4507551],
              [48.815262, 38.4504148],
              [48.8144933, 38.4497906],
              [48.8136288, 38.4480277],
              [48.8122857, 38.447667],
              [48.8115932, 38.4476154],
              [48.8106246, 38.4480449],
              [48.8098918, 38.4488029],
              [48.8089941, 38.4492603],
              [48.8080353, 38.4490923],
              [48.8072108, 38.4492788],
              [48.8065043, 38.4493028],
              [48.8060047, 38.4491377],
              [48.8050486, 38.4489755],
              [48.8042704, 38.4491879],
              [48.8035558, 38.4490827],
              [48.8024474, 38.4494773],
              [48.8019665, 38.4498374],
              [48.8017879, 38.4504027],
              [48.801289, 38.4511792],
              [48.8005299, 38.4515051],
              [48.7999963, 38.4514834],
              [48.7993879, 38.4512277],
              [48.7987924, 38.4508212],
              [48.7978856, 38.4505343],
              [48.7956934, 38.4508574],
              [48.7941665, 38.4512493],
              [48.7926825, 38.4513999],
              [48.7921817, 38.451608],
              [48.7913236, 38.4517477],
              [48.7902702, 38.451144],
              [48.789171, 38.4507088],
              [48.7883893, 38.4509504],
              [48.7877683, 38.4505947],
              [48.7872778, 38.4498073],
              [48.7872443, 38.4488221],
              [48.7870275, 38.4480114],
              [48.7862712, 38.4472004],
              [48.7853267, 38.4471457],
              [48.7841114, 38.4473992],
              [48.7836809, 38.4472988],
              [48.7827791, 38.4469003],
              [48.781439, 38.444947],
              [48.7799252, 38.4437381],
              [48.7795145, 38.441604],
              [48.7742558, 38.4396928],
              [48.7719475, 38.4401542],
              [48.7700408, 38.4413435],
              [48.76731, 38.440739],
              [48.7648876, 38.43793],
              [48.7642574, 38.4345715],
              [48.7614328, 38.4332757],
              [48.7598002, 38.431183],
              [48.7578791, 38.4305851],
              [48.756268, 38.4289275],
              [48.7533339, 38.4282408],
              [48.7524734, 38.4249915],
              [48.7487879, 38.4235326],
              [48.7478518, 38.4225018],
              [48.7478974, 38.4190443],
              [48.7468532, 38.4171495],
              [48.7431185, 38.4158349],
              [48.7413672, 38.4144627],
              [48.7398237, 38.4120439],
              [48.7383031, 38.4111207],
              [48.7327592, 38.4116718],
              [48.7308783, 38.4107843],
              [48.7259062, 38.409945],
              [48.7231122, 38.4101134],
              [48.7207348, 38.4085225],
              [48.7169976, 38.4079736],
              [48.7135296, 38.4083883],
              [48.7111797, 38.4079736],
              [48.7067974, 38.4083586],
              [48.7023639, 38.4066477],
              [48.7012954, 38.4053219],
              [48.6993927, 38.4053138],
              [48.6943126, 38.4011517],
              [48.6936669, 38.4002742],
              [48.6906392, 38.3992739],
              [48.6860783, 38.398891],
              [48.6815596, 38.3974225],
              [48.6764884, 38.3970701],
              [48.6710869, 38.3958997],
              [48.6686731, 38.3969525],
              [48.6673394, 38.396469],
              [48.6664693, 38.3942382],
              [48.6635134, 38.3934911],
              [48.6622715, 38.3929551],
              [48.6592833, 38.3933659],
              [48.6570243, 38.3960313],
              [48.6560848, 38.3981499],
              [48.6544846, 38.3978572],
              [48.6508748, 38.4000145],
              [48.6459001, 38.4014102],
              [48.6421851, 38.401147],
              [48.6409568, 38.3996062],
              [48.6390158, 38.3991402],
              [48.63713, 38.3995158],
              [48.6325079, 38.402033],
              [48.6289704, 38.4021763],
              [48.6282904, 38.4038445],
              [48.6262755, 38.4045353],
              [48.6250371, 38.4046176],
              [48.6236099, 38.4052919],
              [48.6223296, 38.4074136],
              [48.6191602, 38.4078084],
              [48.6184046, 38.4086965],
              [48.6166416, 38.4092722],
              [48.6162123, 38.4099405],
              [48.6145958, 38.4103575],
              [48.6081648, 38.4154124],
              [48.6062137, 38.4162401],
              [48.6048366, 38.4162494],
              [48.6038299, 38.4170543],
              [48.6030904, 38.4168128],
              [48.6018782, 38.4173601],
              [48.602248, 38.4237662],
              [48.6009743, 38.424233],
              [48.5982694, 38.4260715],
              [48.5981218, 38.427941],
              [48.59423, 38.4315578],
              [48.5925356, 38.4352187],
              [48.591972, 38.4369483],
              [48.5928854, 38.4459367],
              [48.5904182, 38.4495263],
              [48.5915804, 38.4530758],
              [48.5908553, 38.4556542],
              [48.5873966, 38.4546229],
              [48.5832971, 38.456565],
              [48.5828061, 38.4585362],
              [48.582031, 38.459962],
              [48.5818264, 38.4603383],
              [48.5813141, 38.4595204],
              [48.5809063, 38.4579987],
              [48.5805953, 38.4548107],
              [48.5807243, 38.4539868],
              [48.5827914, 38.4450453],
              [48.5822344, 38.444767],
              [48.5819578, 38.4442102],
              [48.5736213, 38.4383733],
              [48.5730682, 38.4364336],
              [48.5725115, 38.4267083],
              [48.5706923, 38.4214543],
              [48.5700116, 38.4194882],
              [48.5691779, 38.4142079],
              [48.5694549, 38.4125465],
              [48.5702881, 38.4072661],
              [48.5705683, 38.4058741],
              [48.5733449, 38.3936516],
              [48.5739016, 38.3917118],
              [48.5708448, 38.382264],
              [48.5708449, 38.3747649],
              [48.5739016, 38.3617065],
              [48.5744548, 38.3608803],
              [48.5744548, 38.3605929],
              [48.5766784, 38.3564255],
              [48.5830684, 38.3489262],
              [48.6122347, 38.3214335],
              [48.6191813, 38.3153169],
              [48.6264046, 38.3008737],
              [48.639782, 38.2973434],
              [48.6538376, 38.2989915],
              [48.6646485, 38.3058167],
              [48.6681578, 38.3088708],
              [48.6693263, 38.3099251],
              [48.6737952, 38.3097479],
              [48.6752486, 38.306305],
              [48.675614, 38.302908],
              [48.675785, 38.297313],
              [48.6734444, 38.2817164],
              [48.6739049, 38.276001],
              [48.6790131, 38.2679424],
              [48.6849354, 38.265432],
              [48.6992597, 38.2567844],
              [48.7003437, 38.2551276],
              [48.6962986, 38.249168],
              [48.6893145, 38.2427659],
              [48.6896627, 38.2392046],
              [48.692873, 38.2358719],
              [48.6943521, 38.2330105],
              [48.6936378, 38.2295505],
              [48.693023, 38.224132],
              [48.6964497, 38.2211365],
              [48.7012236, 38.2192437],
              [48.7067699, 38.2179528],
              [48.7086581, 38.2153903],
              [48.7084865, 38.2130974],
              [48.706169, 38.2106021],
              [48.70265, 38.2087812],
              [48.6924328, 38.2079654],
              [48.6894596, 38.2035366],
              [48.6862899, 38.1954056],
              [48.6838506, 38.1839113],
              [48.6832691, 38.1770876],
              [48.6825754, 38.1721181],
              [48.6813726, 38.1643156],
              [48.6792442, 38.1585642],
              [48.674082, 38.1481084],
              [48.6697547, 38.140059],
              [48.6681061, 38.137865],
              [48.6594865, 38.1257881],
              [48.6575202, 38.1144169],
              [48.6538553, 38.1078848],
              [48.6499071, 38.1035624],
              [48.6508082, 38.1006581],
              [48.6548423, 38.0945791],
              [48.6534689, 38.0857973],
              [48.6490057, 38.0752578],
              [48.6419676, 38.0628246],
              [48.6385344, 38.0533631],
              [48.6308096, 38.0495782],
              [48.6175917, 38.0445764],
              [48.6091803, 38.0428189],
              [48.6030005, 38.0375462],
              [48.5998105, 38.0320927],
              [48.5918079, 38.0244786],
              [48.5882377, 38.0196635],
              [48.586774, 38.0166258],
              [48.5859395, 38.012795],
              [48.5861349, 38.0092835],
              [48.5872936, 38.0064431],
              [48.5887527, 38.004448],
              [48.5913291, 38.0019515],
              [48.5957789, 37.9992892],
              [48.5991382, 37.9975832],
              [48.6011123, 37.9973126],
              [48.6034449, 37.9941729],
              [48.6021943, 37.9875002],
              [48.5983228, 37.9804011],
              [48.5920572, 37.9750563],
              [48.5904693, 37.9701847],
              [48.5902977, 37.9583427],
              [48.5904693, 37.955365],
              [48.5913014, 37.9456828],
              [48.5911524, 37.9419484],
              [48.5861349, 37.9383424],
              [48.5817749, 37.9365559],
              [48.5778093, 37.9349238],
              [48.5631752, 37.9332653],
              [48.5532617, 37.9300835],
              [48.5512018, 37.9247688],
              [48.5428762, 37.9187767],
              [48.5375118, 37.9127502],
              [48.5361814, 37.9033371],
              [48.5387563, 37.8979867],
              [48.5414171, 37.8973771],
              [48.5460519, 37.8999847],
              [48.5464811, 37.9000863],
              [48.5527467, 37.9025921],
              [48.5553646, 37.902626],
              [48.5584868, 37.9015366],
              [48.5602139, 37.8994768],
              [48.5611475, 37.8960446],
              [48.5610427, 37.8877656],
              [48.5592594, 37.8830233],
              [48.5581967, 37.8764119],
              [48.5587222, 37.8708663],
              [48.5590179, 37.8585879],
              [48.5641569, 37.8518474],
              [48.5674486, 37.8493404]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241473,
        "tags": {
          "ISO3166-2": "IR-19",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "زنجان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q146726"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [47.1799518, 36.791667],
              [47.1802322, 36.7913878],
              [47.1802322, 36.7911087],
              [47.1810651, 36.7902714],
              [47.1810651, 36.789443],
              [47.1813416, 36.7886056],
              [47.2123715, 36.7685925],
              [47.2615784, 36.7185076],
              [47.270231, 36.7011117],
              [47.2713451, 36.7008326],
              [47.2778646, 36.6815396],
              [47.2784216, 36.6812603],
              [47.2786983, 36.6809813],
              [47.2920314, 36.6693083],
              [47.3212543, 36.6457958],
              [47.3229208, 36.6435716],
              [47.3232004, 36.6427341],
              [47.3434775, 36.614683],
              [47.3702399, 36.5726373],
              [47.3771661, 36.5598429],
              [47.3943322, 36.5504662],
              [47.4142449, 36.5361232],
              [47.4533646, 36.5288049],
              [47.456978, 36.5226991],
              [47.4578115, 36.5204746],
              [47.4583646, 36.5188085],
              [47.4586444, 36.5179709],
              [47.458921, 36.5165842],
              [47.4597546, 36.5127026],
              [47.4603116, 36.5110365],
              [47.4597546, 36.507146],
              [47.4586445, 36.5046423],
              [47.4586445, 36.5043631],
              [47.4578116, 36.5024179],
              [47.3950188, 36.473203],
              [47.3751061, 36.455532],
              [47.3696133, 36.43178],
              [47.3881527, 36.4171387],
              [47.4293515, 36.3958624],
              [47.4640271, 36.4008366],
              [47.4840119, 36.3994962],
              [47.4879121, 36.3992346],
              [47.4887463, 36.3991786],
              [47.4914504, 36.4032449],
              [47.4902416, 36.3990154],
              [47.5069172, 36.397196],
              [47.5071679, 36.3963705],
              [47.5183364, 36.3963641],
              [47.5116402, 36.4146039],
              [47.5479697, 36.4389613],
              [47.589144, 36.4305233],
              [47.595534, 36.4305233],
              [47.5963672, 36.4307935],
              [47.5969204, 36.4305233],
              [47.6192751, 36.4068722],
              [47.6195549, 36.406593],
              [47.6203885, 36.4063138],
              [47.6209416, 36.4063139],
              [47.6212217, 36.4060346],
              [47.6374085, 36.3916205],
              [47.6385183, 36.3916205],
              [47.6393519, 36.3913414],
              [47.6404652, 36.3913414],
              [47.6410184, 36.3910621],
              [47.6596985, 36.3805406],
              [47.6655314, 36.3797118],
              [47.6699748, 36.3788831],
              [47.6710846, 36.3788831],
              [47.6741413, 36.3783245],
              [47.6758081, 36.3783246],
              [47.6769214, 36.3780363],
              [47.6935878, 36.3774868],
              [47.6944211, 36.3777662],
              [47.6991446, 36.3783246],
              [47.7002543, 36.3788832],
              [47.7069209, 36.3799912],
              [47.709421, 36.3799913],
              [47.7099776, 36.3802705],
              [47.7110877, 36.3802705],
              [47.7113675, 36.3802705],
              [47.7141441, 36.3802705],
              [47.7147007, 36.3802705],
              [47.7152543, 36.3799912],
              [47.7241444, 36.3799913],
              [47.724701, 36.379712],
              [47.7255342, 36.379712],
              [47.726644, 36.3794328],
              [47.7283108, 36.3794328],
              [47.7463671, 36.3760997],
              [47.748314, 36.3760996],
              [47.7488672, 36.3758204],
              [47.7505339, 36.3758204],
              [47.7513671, 36.3755411],
              [47.7524806, 36.3755412],
              [47.7533137, 36.3752619],
              [47.7599803, 36.3747124],
              [47.7644237, 36.3747124],
              [47.7652569, 36.3744331],
              [47.7666472, 36.3744331],
              [47.7674805, 36.3741539],
              [47.7685903, 36.3741539],
              [47.7710903, 36.3735953],
              [47.7822034, 36.3719379],
              [47.7877602, 36.3694335],
              [47.7919267, 36.3674877],
              [47.7963702, 36.3655418],
              [47.80026, 36.3627671],
              [47.8155366, 36.3472092],
              [47.81665, 36.3466597],
              [47.8269264, 36.3422094],
              [47.8277595, 36.3422094],
              [47.8283166, 36.3419301],
              [47.8297064, 36.3416599],
              [47.8319264, 36.3416599],
              [47.8322065, 36.3413806],
              [47.8333164, 36.3413806],
              [47.833873, 36.3411013],
              [47.8352597, 36.3411013],
              [47.8355399, 36.340822],
              [47.8383165, 36.3408221],
              [47.838593, 36.3405427],
              [47.8399829, 36.3405428],
              [47.8402595, 36.3402635],
              [47.8410931, 36.3402635],
              [47.8422064, 36.3399842],
              [47.8435962, 36.3399842],
              [47.8483163, 36.3388762],
              [47.866096, 36.3297052],
              [47.8669293, 36.3297052],
              [47.8674859, 36.3294258],
              [47.8708195, 36.3288763],
              [47.8741528, 36.3288763],
              [47.8747059, 36.3291556],
              [47.8758192, 36.3291556],
              [47.8835959, 36.3311015],
              [47.8849858, 36.3311016],
              [47.8849859, 36.3313809],
              [47.8863758, 36.3313809],
              [47.8874859, 36.3313809],
              [47.8885956, 36.3316512],
              [47.8908192, 36.3316511],
              [47.8916524, 36.3316512],
              [47.8927622, 36.3313809],
              [47.8933192, 36.3313809],
              [47.8980424, 36.3313808],
              [47.8985955, 36.3311017],
              [47.8994323, 36.3311016],
              [47.8997088, 36.3308133],
              [47.9185988, 36.3205431],
              [47.9194323, 36.3205431],
              [47.9197089, 36.3202638],
              [47.9202655, 36.3202638],
              [47.9341553, 36.3152638],
              [47.9347084, 36.3147053],
              [47.9385987, 36.31248],
              [47.9410984, 36.310543],
              [47.9413786, 36.3102638],
              [47.956102, 36.2816503],
              [47.9563786, 36.2813709],
              [47.956102, 36.2755418],
              [47.9544317, 36.2735957],
              [47.9458221, 36.2685954],
              [47.943322, 36.2666493],
              [47.9430455, 36.2660997],
              [47.9422119, 36.2649825],
              [47.9419323, 36.2635951],
              [47.9416552, 36.2610994],
              [47.9416553, 36.2569279],
              [47.9455457, 36.2485939],
              [47.9424357, 36.2127732],
              [47.9760418, 36.2069315],
              [47.9821519, 36.1980384],
              [47.9733218, 36.1885955],
              [47.9736019, 36.1855409],
              [47.9738785, 36.1852616],
              [47.9738785, 36.1816485],
              [47.9744352, 36.1791525],
              [47.9744352, 36.1760979],
              [47.9744352, 36.1738723],
              [47.9747122, 36.171097],
              [47.9749887, 36.169421],
              [47.9752688, 36.1683128],
              [47.9758255, 36.1666458],
              [47.9761021, 36.1663755],
              [47.976102, 36.1658168],
              [47.9769353, 36.1638705],
              [48.0033052, 36.148272],
              [47.9845046, 36.1275459],
              [47.9715439, 36.1171465],
              [47.9585749, 36.1055342],
              [47.9507105, 36.0985882],
              [47.9445129, 36.093172],
              [47.9409079, 36.0904008],
              [47.9318918, 36.082269],
              [47.937299, 36.0815716],
              [47.9404306, 36.0803553],
              [47.9479837, 36.0795229],
              [47.956309, 36.0775809],
              [47.9640768, 36.0674173],
              [47.961116, 36.0606759],
              [47.9534911, 36.0483259],
              [47.9503546, 36.0453968],
              [47.9455727, 36.0405353],
              [47.9431341, 36.0389667],
              [47.936611, 36.0348024],
              [47.9313831, 36.0331749],
              [47.9215048, 36.032026],
              [47.9146233, 36.0330238],
              [47.9072921, 36.0339977],
              [47.9013347, 36.0313318],
              [47.8885459, 36.0211278],
              [47.8826236, 36.015088],
              [47.8780669, 36.0069949],
              [47.8737635, 36.0015048],
              [47.8715943, 35.9981812],
              [47.8772163, 35.9966188],
              [47.8851985, 35.9948827],
              [47.8922366, 35.9953688],
              [47.902193, 35.9968965],
              [47.9263982, 35.9978261],
              [47.9474698, 35.9963685],
              [47.9544829, 35.9938686],
              [47.9663085, 35.9879381],
              [47.9720915, 35.983315],
              [47.9736897, 35.9796735],
              [47.9719327, 35.9706714],
              [47.9620169, 35.9648082],
              [47.9574895, 35.963306],
              [47.9391566, 35.9574747],
              [47.9380464, 35.9574747],
              [47.9369331, 35.956925],
              [47.9358234, 35.956925],
              [47.9352663, 35.9566456],
              [47.9344331, 35.9566456],
              [47.9341566, 35.9563662],
              [47.9316566, 35.9563661],
              [47.9310999, 35.9560868],
              [47.9274899, 35.9560867],
              [47.9266567, 35.9558073],
              [47.9258232, 35.9560867],
              [47.9249899, 35.9558073],
              [47.9213766, 35.955537],
              [47.9199902, 35.9555369],
              [47.9177667, 35.9549781],
              [47.9160999, 35.9549782],
              [47.9158203, 35.9546988],
              [47.9144334, 35.9546987],
              [47.9141534, 35.9544193],
              [47.8939034, 35.9483138],
              [47.8881283, 35.9453899],
              [47.8780035, 35.9420623],
              [47.8677327, 35.9391239],
              [47.8666387, 35.9322449],
              [47.8543852, 35.9282588],
              [47.8664121, 35.9127809],
              [47.870693, 35.9076837],
              [47.8835701, 35.89367],
              [47.8892937, 35.887184],
              [47.8955133, 35.8796541],
              [47.9013347, 35.8830003],
              [47.9059304, 35.881636],
              [47.913491, 35.8838841],
              [47.9300876, 35.8932206],
              [47.9422535, 35.9021973],
              [47.9507819, 35.9083679],
              [47.9740332, 35.9243667],
              [47.9881538, 35.9313978],
              [47.9943839, 35.9305875],
              [48.0021391, 35.9302797],
              [48.0065729, 35.9226428],
              [48.0101385, 35.9113748],
              [48.0139401, 35.8992142],
              [48.0173567, 35.8888396],
              [48.0226296, 35.8741134],
              [48.0246578, 35.8640675],
              [48.027939, 35.8489995],
              [48.0313825, 35.8387804],
              [48.0348974, 35.833974],
              [48.0384911, 35.8264395],
              [48.0450991, 35.8136412],
              [48.0732267, 35.8141399],
              [48.0787466, 35.8126628],
              [48.0917, 35.8132946],
              [48.100518, 35.8062978],
              [48.1147119, 35.7988264],
              [48.1325648, 35.7887638],
              [48.1417255, 35.7821427],
              [48.1465344, 35.779117],
              [48.1604523, 35.7663192],
              [48.1850644, 35.7441817],
              [48.1911277, 35.7372279],
              [48.2012943, 35.7292838],
              [48.2100006, 35.7294262],
              [48.220004, 35.7305252],
              [48.2280604, 35.7299535],
              [48.2350039, 35.7283075],
              [48.2415847, 35.725919],
              [48.249434, 35.723168],
              [48.2524032, 35.7196275],
              [48.2704315, 35.707128],
              [48.2779578, 35.6990005],
              [48.2799138, 35.6969894],
              [48.2817249, 35.695222],
              [48.2901766, 35.6861535],
              [48.2961198, 35.6805276],
              [48.311953, 35.6727473],
              [48.3280627, 35.6666349],
              [48.3433427, 35.6621994],
              [48.353066, 35.6596931],
              [48.357509, 35.6574753],
              [48.3916789, 35.6430234],
              [48.3947357, 35.6427529],
              [48.3952889, 35.6424734],
              [48.4016788, 35.6424734],
              [48.4141787, 35.6408055],
              [48.4216784, 35.6446913],
              [48.4258449, 35.6474681],
              [48.435015, 35.6541396],
              [48.4380682, 35.6549691],
              [48.4391815, 35.6549691],
              [48.4414015, 35.6557986],
              [48.4422351, 35.6557985],
              [48.4425148, 35.656087],
              [48.4447347, 35.6560871],
              [48.4450148, 35.6557985],
              [48.4489047, 35.6557986],
              [48.4508482, 35.6555281],
              [48.4514048, 35.6552486],
              [48.4527916, 35.6552486],
              [48.4550147, 35.6546897],
              [48.4558482, 35.6546897],
              [48.456958, 35.6541397],
              [48.4580714, 35.6541397],
              [48.4611245, 35.6527513],
              [48.4616811, 35.6527513],
              [48.4622378, 35.6521924],
              [48.4680713, 35.6505245],
              [48.4719611, 35.6499746],
              [48.4811277, 35.6458094],
              [48.4816813, 35.6458093],
              [48.4836278, 35.6452504],
              [48.4839044, 35.644971],
              [48.484181, 35.6446914],
              [48.4905709, 35.6374699],
              [48.4919613, 35.6355225],
              [48.4925179, 35.635252],
              [48.4952945, 35.6296893],
              [48.4958511, 35.6277509],
              [48.4977946, 35.6219177],
              [48.4980712, 35.6213587],
              [48.4983512, 35.6199703],
              [48.495018, 35.5999729],
              [48.4961278, 35.598864],
              [48.5211275, 35.5902536],
              [48.5255742, 35.5883061],
              [48.5364072, 35.5855292],
              [48.538074, 35.5849702],
              [48.5427971, 35.5849702],
              [48.5430737, 35.5852497],
              [48.5450207, 35.5852497],
              [48.5726632, 35.5779816],
              [48.5729397, 35.5782611],
              [48.5737733, 35.5782611],
              [48.5743299, 35.5785406],
              [48.5754397, 35.5785406],
              [48.6032196, 35.5874314],
              [48.6040528, 35.5874315],
              [48.6084993, 35.5899291],
              [48.6090525, 35.5904882],
              [48.6096179, 35.5907677],
              [48.6126659, 35.5918768],
              [48.6146092, 35.5918768],
              [48.6193324, 35.593545],
              [48.6318323, 35.595204],
              [48.6340558, 35.5949336],
              [48.634889, 35.594654],
              [48.6433559, 35.6013616],
              [48.6441895, 35.6010822],
              [48.6472458, 35.6010822],
              [48.6480795, 35.6008027],
              [48.6505795, 35.6008027],
              [48.6639126, 35.5988642],
              [48.669469, 35.5971873],
              [48.6698229, 35.5972334],
              [48.7469617, 35.6471266],
              [48.7466851, 35.6476856],
              [48.7464051, 35.651581],
              [48.7458519, 35.6543583],
              [48.7466851, 35.6637992],
              [48.7517546, 35.6788427],
              [48.7506448, 35.6794017],
              [48.7466946, 35.6846935],
              [48.7458613, 35.684973],
              [48.7455261, 35.6892958],
              [48.7460613, 35.6962608],
              [48.743506, 35.7141494],
              [48.7350278, 35.7224759],
              [48.7350277, 35.7227464],
              [48.7363237, 35.7239575],
              [48.7328047, 35.7299764],
              [48.7308612, 35.7335823],
              [48.7247478, 35.7494213],
              [48.7244712, 35.7513594],
              [48.7247478, 35.7569124],
              [48.7255814, 35.7602479],
              [48.7361379, 35.7783039],
              [48.7361378, 35.7788628],
              [48.7383609, 35.7821982],
              [48.7486411, 35.799695],
              [48.7528076, 35.8060861],
              [48.7564174, 35.8233031],
              [48.7561408, 35.8235915],
              [48.756379, 35.8245463],
              [48.7564174, 35.8247002],
              [48.756694, 35.8249707],
              [48.7578073, 35.8260884],
              [48.7583608, 35.8263678],
              [48.7583608, 35.8266472],
              [48.7594741, 35.827756],
              [48.7714173, 35.8388611],
              [48.771974, 35.8391406],
              [48.7747505, 35.8449726],
              [48.7803068, 35.8766376],
              [48.7816971, 35.8794228],
              [48.7844737, 35.8841459],
              [48.7872534, 35.8872014],
              [48.8275331, 35.9144217],
              [48.8450036, 35.9344009],
              [48.8563827, 35.9447618],
              [48.8676456, 35.9603298],
              [48.8864978, 35.9704722],
              [48.9008541, 35.9714417],
              [48.9115106, 35.957416],
              [48.9417549, 35.936653],
              [48.9600912, 35.9244323],
              [48.9603682, 35.9241529],
              [48.9609248, 35.9238735],
              [48.9748145, 35.9197097],
              [48.978981, 35.9188716],
              [48.9809245, 35.9188716],
              [48.9825379, 35.9116458],
              [48.9839278, 35.9113665],
              [48.9867044, 35.9113665],
              [48.9919843, 35.9102579],
              [49.0078174, 35.9044263],
              [49.0307004, 35.881905],
              [49.0357005, 35.875243],
              [49.0357004, 35.8749545],
              [49.0362536, 35.8746841],
              [49.0415338, 35.8702397],
              [49.0540338, 35.8657954],
              [49.0570905, 35.8657954],
              [49.0579236, 35.8655161],
              [49.0615335, 35.865516],
              [49.0623667, 35.8657955],
              [49.0645902, 35.8657955],
              [49.06598, 35.866066],
              [49.0665336, 35.8663543],
              [49.0673668, 35.8663544],
              [49.07959, 35.872187],
              [49.0807034, 35.8732959],
              [49.0823698, 35.8741252],
              [49.0839388, 35.8760101],
              [49.0851465, 35.8774608],
              [49.085423, 35.8782902],
              [49.0862743, 35.8890786],
              [49.0854238, 35.8913505],
              [49.085423, 35.8913526],
              [49.0978696, 35.9163777],
              [49.0970363, 35.916657],
              [49.093423, 35.9235965],
              [49.093146, 35.9255432],
              [49.098146, 35.931374],
              [49.1186564, 35.9324755],
              [49.1208796, 35.932205],
              [49.1217128, 35.9319256],
              [49.1230995, 35.9319257],
              [49.1233795, 35.9316463],
              [49.1244894, 35.9316463],
              [49.1247664, 35.9313668],
              [49.1314361, 35.9313669],
              [49.1353228, 35.9308171],
              [49.1358794, 35.9305377],
              [49.1375459, 35.9305376],
              [49.1378224, 35.9302582],
              [49.1406026, 35.9302582],
              [49.1411561, 35.9299789],
              [49.1464359, 35.9299788],
              [49.1475458, 35.9296995],
              [49.1506025, 35.9296995],
              [49.1517126, 35.9299788],
              [49.1517127, 35.9305377],
              [49.1525458, 35.9324755],
              [49.1636589, 35.9391451],
              [49.163659, 35.9394244],
              [49.1739357, 35.9516459],
              [49.1808823, 35.9555394],
              [49.1817156, 35.9555395],
              [49.1861585, 35.958036],
              [49.2110478, 35.9726679],
              [49.2458848, 35.9749799],
              [49.2583847, 35.9722041],
              [49.2592179, 35.9719247],
              [49.2625511, 35.9719247],
              [49.3006554, 35.9569164],
              [49.3017656, 35.9571959],
              [49.3031555, 35.9571959],
              [49.3039887, 35.9574753],
              [49.3053786, 35.9574753],
              [49.3131553, 35.9597019],
              [49.3361667, 35.9966461],
              [49.3431102, 35.9988722],
              [49.3388406, 36.0131753],
              [49.3468935, 36.0190057],
              [49.3477271, 36.0203934],
              [49.3477271, 36.0206728],
              [49.3477271, 36.0215108],
              [49.3931127, 36.0405444],
              [49.3978359, 36.0463661],
              [49.4068258, 36.0541541],
              [49.4162689, 36.072205],
              [49.4196022, 36.0938781],
              [49.4193257, 36.0944278],
              [49.4184924, 36.1002673],
              [49.4165489, 36.1149919],
              [49.416549, 36.1211017],
              [49.4157157, 36.1235977],
              [49.4157156, 36.1238771],
              [49.4151591, 36.1263733],
              [49.415159, 36.1308158],
              [49.4148821, 36.1316539],
              [49.4146024, 36.1333209],
              [49.4143254, 36.134988],
              [49.4168254, 36.1449903],
              [49.4246021, 36.1580472],
              [49.432382, 36.1716536],
              [49.4336719, 36.1930405],
              [49.4333917, 36.1941488],
              [49.4331153, 36.1944371],
              [49.4328386, 36.1955453],
              [49.4317253, 36.196933],
              [49.4317253, 36.1972123],
              [49.4317254, 36.1974916],
              [49.4264486, 36.2038709],
              [49.4231153, 36.2077634],
              [49.4142804, 36.2116728],
              [49.4005726, 36.2206729],
              [49.4036687, 36.2480471],
              [49.4091223, 36.2738951],
              [49.4177498, 36.2902789],
              [49.4167251, 36.3077621],
              [49.4175583, 36.3086],
              [49.4154036, 36.3240319],
              [49.376897, 36.34579],
              [49.3461655, 36.3797152],
              [49.3444992, 36.3852644],
              [49.3408892, 36.388048],
              [49.3369993, 36.3894352],
              [49.3065477, 36.394258],
              [49.2729622, 36.390203],
              [49.2669967, 36.3927682],
              [49.26644, 36.3930475],
              [49.2356038, 36.3992007],
              [49.2015212, 36.4076573],
              [49.153171, 36.4197651],
              [49.1509475, 36.419765],
              [49.1492811, 36.4194858],
              [49.1487245, 36.419765],
              [49.1473346, 36.4194858],
              [49.1440009, 36.4194858],
              [49.1426145, 36.419765],
              [49.1403911, 36.419765],
              [49.138168, 36.4192065],
              [49.1205981, 36.4294398],
              [49.120045, 36.4294398],
              [49.1192117, 36.42971],
              [49.109765, 36.4336014],
              [49.105875, 36.4366551],
              [49.1053216, 36.4369343],
              [49.1050414, 36.4374927],
              [49.1042083, 36.4377721],
              [49.0955983, 36.4463834],
              [49.0950416, 36.4474913],
              [49.092542, 36.4511034],
              [49.0814319, 36.4716585],
              [49.0681144, 36.4891203],
              [49.0633964, 36.4923186],
              [49.0583324, 36.4972176],
              [49.0441703, 36.5053589],
              [49.0288066, 36.5080495],
              [49.0148162, 36.5137753],
              [48.9943885, 36.5252257],
              [48.977481, 36.5401706],
              [48.9717891, 36.5558654],
              [48.9812231, 36.5741542],
              [48.9896509, 36.5848636],
              [49.0033577, 36.6105157],
              [49.0036484, 36.6157139],
              [49.001095, 36.6210996],
              [49.0028716, 36.6235801],
              [49.0038339, 36.6267846],
              [49.003973, 36.6303089],
              [49.0033696, 36.6347619],
              [49.0119374, 36.6397611],
              [49.0104427, 36.6454112],
              [49.0121098, 36.649015],
              [49.0122024, 36.6515042],
              [49.0089609, 36.6536589],
              [49.0079434, 36.6573224],
              [49.010489, 36.6623144],
              [49.0141472, 36.6670238],
              [49.0265026, 36.6732976],
              [49.0325217, 36.675142],
              [49.0359132, 36.6758816],
              [49.0491207, 36.6757847],
              [49.0609606, 36.682277],
              [49.0706317, 36.6842745],
              [49.0716909, 36.688649],
              [49.0747826, 36.6904169],
              [49.0737272, 36.6962685],
              [49.0728278, 36.7012539],
              [49.0737758, 36.7054519],
              [49.0749411, 36.7095408],
              [49.0760992, 36.7123053],
              [49.0794553, 36.7176155],
              [49.0818379, 36.7201542],
              [49.0853884, 36.7234202],
              [49.0875042, 36.7265086],
              [49.0943518, 36.7386594],
              [49.0977787, 36.7444468],
              [49.0993761, 36.7480551],
              [49.1014726, 36.7506841],
              [49.1074016, 36.7616524],
              [49.1090241, 36.7631163],
              [49.1179787, 36.7711937],
              [49.1235109, 36.7745358],
              [49.1253571, 36.7770862],
              [49.1328093, 36.7795253],
              [49.1383159, 36.7791745],
              [49.148246, 36.7789104],
              [49.1538301, 36.7783325],
              [49.157837, 36.7780093],
              [49.166473, 36.775486],
              [49.1712707, 36.7723737],
              [49.1749472, 36.7700707],
              [49.1772993, 36.7685972],
              [49.1834839, 36.769005],
              [49.192995, 36.7714758],
              [49.2087653, 36.7790003],
              [49.2258041, 36.7829726],
              [49.2371898, 36.7891701],
              [49.26733, 36.8125833],
              [49.2758416, 36.8151799],
              [49.2681048, 36.8365409],
              [49.2638796, 36.8454154],
              [49.2589381, 36.854392],
              [49.2499516, 36.8729205],
              [49.2443617, 36.8849074],
              [49.2393046, 36.902649],
              [49.2326744, 36.9130993],
              [49.2298946, 36.9167409],
              [49.2270998, 36.9200325],
              [49.2220402, 36.9263899],
              [49.2061682, 36.9455976],
              [49.1996944, 36.9594611],
              [49.1834031, 36.9914532],
              [49.1790761, 37.0020017],
              [49.1748046, 37.0116002],
              [49.1708095, 37.0212894],
              [49.1599379, 37.038942],
              [49.1585477, 37.0431084],
              [49.1393832, 37.0716808],
              [49.1298434, 37.0840608],
              [49.1240481, 37.09095],
              [49.1078642, 37.1051205],
              [49.0908318, 37.1161689],
              [49.0715641, 37.121786],
              [49.0351731, 37.1304778],
              [49.0343394, 37.1313055],
              [49.0197518, 37.1334077],
              [48.9978216, 37.1371931],
              [48.988134, 37.1360832],
              [48.9682959, 37.1339087],
              [48.9554211, 37.132814],
              [48.9394534, 37.1448358],
              [48.9319782, 37.1502887],
              [48.9314215, 37.1513956],
              [48.9308649, 37.1516745],
              [48.9261449, 37.1600077],
              [48.9247551, 37.1622304],
              [48.9228116, 37.1672339],
              [48.9182611, 37.1706893],
              [48.9176765, 37.1706893],
              [48.9167022, 37.1702752],
              [48.9162691, 37.1703787],
              [48.9147318, 37.1713104],
              [48.9151865, 37.1713277],
              [48.9160309, 37.1712069],
              [48.9163124, 37.1712932],
              [48.9164207, 37.1718453],
              [48.9159443, 37.171759],
              [48.9152081, 37.1723974],
              [48.9142987, 37.1723284],
              [48.9154463, 37.1729495],
              [48.9148184, 37.173191],
              [48.9135728, 37.1732827],
              [48.9130192, 37.1731801],
              [48.9128132, 37.1731801],
              [48.9130836, 37.1734776],
              [48.9131495, 37.1736115],
              [48.912278, 37.1735684],
              [48.9112587, 37.1733343],
              [48.9108588, 37.1733033],
              [48.9105509, 37.1732215],
              [48.9101935, 37.1730185],
              [48.9098678, 37.173151],
              [48.9091565, 37.1732835],
              [48.9088379, 37.1732553],
              [48.9084062, 37.173402],
              [48.90767, 37.1732892],
              [48.9074435, 37.1731143],
              [48.9070259, 37.1730269],
              [48.9062402, 37.172948],
              [48.9059995, 37.1728041],
              [48.9052209, 37.1727082],
              [48.9050085, 37.1725926],
              [48.9049484, 37.1724742],
              [48.90446, 37.1723755],
              [48.9040965, 37.1722961],
              [48.90378, 37.1722042],
              [48.9035241, 37.1722319],
              [48.9035166, 37.1720233],
              [48.9033821, 37.1716624],
              [48.9032087, 37.1714283],
              [48.9029857, 37.1712957],
              [48.9027876, 37.1712196],
              [48.9026283, 37.1711096],
              [48.9025858, 37.170963],
              [48.9025858, 37.1706838],
              [48.9024655, 37.1704694],
              [48.9023862, 37.1704344],
              [48.9018143, 37.1701818],
              [48.9014851, 37.1700972],
              [48.9013011, 37.16999],
              [48.9010994, 37.1696967],
              [48.9009189, 37.1693696],
              [48.9007348, 37.1691298],
              [48.9005685, 37.1689634],
              [48.9004128, 37.1686758],
              [48.9000624, 37.1683486],
              [48.8994961, 37.1679002],
              [48.8992767, 37.1677902],
              [48.8989404, 37.1673503],
              [48.8983211, 37.1668877],
              [48.8977513, 37.1666649],
              [48.8973301, 37.1662729],
              [48.8971355, 37.1661516],
              [48.8968983, 37.1661037],
              [48.8964205, 37.1658329],
              [48.8950084, 37.1653112],
              [48.8947465, 37.1651983],
              [48.8943926, 37.1651758],
              [48.8942899, 37.1650799],
              [48.8942369, 37.1649417],
              [48.8940917, 37.164843],
              [48.8933379, 37.1646737],
              [48.8930654, 37.1647302],
              [48.892531, 37.1649078],
              [48.8922691, 37.1648768],
              [48.8920567, 37.1646145],
              [48.8918762, 37.1642422],
              [48.8919045, 37.1640702],
              [48.8921417, 37.1638192],
              [48.8921593, 37.1635879],
              [48.8920886, 37.1632974],
              [48.8918691, 37.1630746],
              [48.891494, 37.16288],
              [48.8912356, 37.1628264],
              [48.8907755, 37.1625246],
              [48.890641, 37.1622792],
              [48.890641, 37.1620394],
              [48.8907154, 37.1619012],
              [48.890726, 37.1617207],
              [48.890595, 37.1615966],
              [48.890319, 37.1614612],
              [48.889873, 37.1614161],
              [48.889643, 37.1615289],
              [48.8893917, 37.1616079],
              [48.8890519, 37.1616079],
              [48.8888821, 37.1615205],
              [48.8887016, 37.1613682],
              [48.8884927, 37.1613456],
              [48.8882839, 37.1611425],
              [48.8882592, 37.1608971],
              [48.8885104, 37.1604289],
              [48.8885918, 37.1602343],
              [48.8885812, 37.1599128],
              [48.8883936, 37.1596843],
              [48.8883547, 37.1594474],
              [48.8880149, 37.1590243],
              [48.8879371, 37.1585673],
              [48.8880008, 37.1582345],
              [48.8878238, 37.1579045],
              [48.8860259, 37.1579186],
              [48.8857003, 37.1577296],
              [48.8855411, 37.1573545],
              [48.8853216, 37.1571965],
              [48.8851428, 37.15701],
              [48.8851014, 37.1568011],
              [48.8850675, 37.1566365],
              [48.8850798, 37.1564659],
              [48.8850921, 37.1563468],
              [48.8850705, 37.1562019],
              [48.8850243, 37.1560497],
              [48.8848302, 37.1559355],
              [48.8846377, 37.1558864],
              [48.8843511, 37.1557796],
              [48.8840295, 37.1554796],
              [48.8837894, 37.1553112],
              [48.883597, 37.1552505],
              [48.8833551, 37.1552287],
              [48.8830096, 37.1551855],
              [48.882942, 37.1551459],
              [48.8828366, 37.1550841],
              [48.8827241, 37.1550871],
              [48.8825073, 37.1550886],
              [48.8824193, 37.1550748],
              [48.8822606, 37.1550416],
              [48.8820942, 37.1550331],
              [48.8819941, 37.1550809],
              [48.8819202, 37.15513],
              [48.8817923, 37.1551681],
              [48.881672, 37.1552048],
              [48.8815551, 37.1552406],
              [48.8812146, 37.1553204],
              [48.8809589, 37.15541],
              [48.8808541, 37.1554358],
              [48.880717, 37.1553989],
              [48.880546, 37.1554075],
              [48.880489, 37.1555094],
              [48.880221, 37.1555696],
              [48.8798589, 37.155491],
              [48.8790748, 37.1554002],
              [48.8784735, 37.1553566],
              [48.8782346, 37.1553792],
              [48.8780523, 37.1553383],
              [48.8775993, 37.1550605],
              [48.8773746, 37.1549829],
              [48.8771782, 37.1549632],
              [48.8770879, 37.1549039],
              [48.8770596, 37.1548179],
              [48.8770118, 37.1548024],
              [48.876849, 37.154784],
              [48.876534, 37.1545499],
              [48.8763783, 37.1545118],
              [48.8762913, 37.154378],
              [48.8762238, 37.154271],
              [48.8760626, 37.1541287],
              [48.8758379, 37.1540213],
              [48.875536, 37.1539956],
              [48.8751219, 37.1541254],
              [48.8747839, 37.1541635],
              [48.874322, 37.1541],
              [48.8737097, 37.1540323],
              [48.8735186, 37.1538715],
              [48.8732981, 37.1536535],
              [48.8732152, 37.1535506],
              [48.8730245, 37.1534657],
              [48.8727559, 37.153454],
              [48.8726144, 37.1534484],
              [48.8724834, 37.1533877],
              [48.8723631, 37.1532721],
              [48.8721419, 37.1532495],
              [48.8719189, 37.1533031],
              [48.8709617, 37.1527252],
              [48.8705793, 37.1521302],
              [48.8698146, 37.1516513],
              [48.8691956, 37.1504033],
              [48.8685765, 37.1493874],
              [48.865372, 37.1475733],
              [48.8639188, 37.1475078],
              [48.8622525, 37.1475078],
              [48.8614189, 37.1475078],
              [48.8608622, 37.1475078],
              [48.8608623, 37.1477868],
              [48.8589193, 37.1477867],
              [48.8586392, 37.1480657],
              [48.8580856, 37.1477868],
              [48.8564192, 37.1477867],
              [48.8561391, 37.1480657],
              [48.8550288, 37.1480658],
              [48.8434979, 37.1518344],
              [48.8366314, 37.160864],
              [48.8400647, 37.1780994],
              [48.8336827, 37.1869766],
              [48.8331261, 37.1869766],
              [48.8328495, 37.1872554],
              [48.8320159, 37.1872553],
              [48.8314593, 37.1875342],
              [48.8295162, 37.1875342],
              [48.8286826, 37.1878131],
              [48.8228498, 37.1878131],
              [48.8220162, 37.1875342],
              [48.8167398, 37.1875342],
              [48.8122928, 37.1883618],
              [48.8117363, 37.1886406],
              [48.8097931, 37.1886405],
              [48.8092361, 37.1889195],
              [48.8064599, 37.1889195],
              [48.8053497, 37.1889195],
              [48.8028497, 37.188092],
              [48.797836, 37.1802878],
              [48.8105389, 37.159496],
              [48.8101956, 37.1485507],
              [48.8019696, 37.1419551],
              [48.7941932, 37.1394533],
              [48.7939163, 37.1391744],
              [48.7900263, 37.1391743],
              [48.7886364, 37.1397323],
              [48.7883598, 37.1400113],
              [48.7875266, 37.1400113],
              [48.7872497, 37.1402902],
              [48.7866931, 37.1402902],
              [48.7833598, 37.1436199],
              [48.7769698, 37.1466797],
              [48.7764131, 37.1469497],
              [48.7680801, 37.1502884],
              [48.7647469, 37.1566778],
              [48.7589134, 37.1647319],
              [48.7572466, 37.1658387],
              [48.7553037, 37.1663967],
              [48.7553036, 37.1666756],
              [48.7539134, 37.1666756],
              [48.7522469, 37.1694563],
              [48.7519703, 37.179454],
              [48.7519703, 37.1802909],
              [48.7519703, 37.1808398],
              [48.7516902, 37.1811188],
              [48.7511367, 37.1825136],
              [48.7511367, 37.1827925],
              [48.7461334, 37.1858431],
              [48.7450237, 37.185843],
              [48.744467, 37.1861221],
              [48.7436334, 37.1861221],
              [48.7430802, 37.1858431],
              [48.7394669, 37.1858431],
              [48.7391904, 37.1855641],
              [48.7375235, 37.1855641],
              [48.7336336, 37.1841783],
              [48.7278003, 37.1802908],
              [48.726967, 37.1800119],
              [48.7262264, 37.1796396],
              [48.6958538, 37.1600073],
              [48.6947441, 37.1594493],
              [48.6801978, 37.145938],
              [48.6658128, 37.1343733],
              [48.6627641, 37.1320892],
              [48.6525098, 37.1267122],
              [48.6397556, 37.1248841],
              [48.6351956, 37.1239982],
              [48.630885, 37.123635],
              [48.6230422, 37.121853],
              [48.6150598, 37.119914],
              [48.6092532, 37.1178706],
              [48.5946321, 37.1110506],
              [48.5898256, 37.1086207],
              [48.5852766, 37.1064645],
              [48.5799122, 37.1043254],
              [48.5761249, 37.1050014],
              [48.57171, 37.1084667],
              [48.5708249, 37.1113843],
              [48.570621, 37.1145456],
              [48.5705191, 37.1165134],
              [48.5693872, 37.1189345],
              [48.5687005, 37.1204316],
              [48.5654497, 37.1212614],
              [48.565251, 37.121159],
              [48.5597312, 37.1183228],
              [48.5561263, 37.1194606],
              [48.5497159, 37.1194413],
              [48.5475111, 37.1210261],
              [48.5469317, 37.1230279],
              [48.5476827, 37.1269458],
              [48.5476613, 37.1315991],
              [48.5451937, 37.1352599],
              [48.5380053, 37.1349862],
              [48.534497, 37.1351744],
              [48.5308814, 37.135756],
              [48.528403, 37.1363633],
              [48.5251522, 37.1362863],
              [48.5216117, 37.1362008],
              [48.5182214, 37.135833],
              [48.5155177, 37.1360982],
              [48.5119343, 37.1369535],
              [48.5086298, 37.1387325],
              [48.5059905, 37.1404943],
              [48.5041451, 37.1436929],
              [48.50039, 37.1486188],
              [48.4981155, 37.1550237],
              [48.4955406, 37.1594444],
              [48.4966564, 37.1639931],
              [48.4972465, 37.1656261],
              [48.4957445, 37.1673617],
              [48.4938347, 37.1694478],
              [48.4927833, 37.169747],
              [48.4914207, 37.1702428],
              [48.4911096, 37.1706019],
              [48.4912491, 37.1717988],
              [48.492279, 37.172893],
              [48.4944463, 37.1739702],
              [48.4959376, 37.1753807],
              [48.4947145, 37.1776717],
              [48.4920645, 37.1797917],
              [48.4891248, 37.1799969],
              [48.487494, 37.1798772],
              [48.4850585, 37.1796207],
              [48.4830737, 37.1791848],
              [48.4803378, 37.1784582],
              [48.4790289, 37.1787317],
              [48.4782886, 37.1794669],
              [48.4808528, 37.1819629],
              [48.4850156, 37.1839032],
              [48.4868288, 37.1858008],
              [48.4869468, 37.1895445],
              [48.4872687, 37.1925786],
              [48.4891784, 37.1957921],
              [48.4887493, 37.198279],
              [48.487376, 37.1993729],
              [48.4809279, 37.200783],
              [48.4792864, 37.2026887],
              [48.4784335, 37.2037697],
              [48.477425, 37.2045558],
              [48.4761482, 37.2053591],
              [48.4757405, 37.2062307],
              [48.4764004, 37.2071023],
              [48.4777576, 37.2071621],
              [48.4826875, 37.2084182],
              [48.4818774, 37.2100033],
              [48.480531, 37.2106313],
              [48.4795868, 37.2106997],
              [48.4779882, 37.2111397],
              [48.4760034, 37.2111824],
              [48.4750593, 37.211379],
              [48.4720069, 37.2116481],
              [48.4694427, 37.2126094],
              [48.4680802, 37.2127803],
              [48.4649849, 37.2131904],
              [48.4638476, 37.212729],
              [48.4641051, 37.2113619],
              [48.4633755, 37.2097897],
              [48.4634507, 37.2086724],
              [48.4625199, 37.2081106],
              [48.460586, 37.2089865],
              [48.4602642, 37.2086959],
              [48.457582, 37.210422],
              [48.4560478, 37.2104989],
              [48.4541595, 37.2099862],
              [48.4537679, 37.2082003],
              [48.4521854, 37.2076812],
              [48.4509301, 37.2082345],
              [48.4463811, 37.2104049],
              [48.442347, 37.2118575],
              [48.4375191, 37.2153265],
              [48.4303187, 37.221039],
              [48.4265327, 37.2213413],
              [48.4214902, 37.222674],
              [48.4202456, 37.2242289],
              [48.4202456, 37.2286712],
              [48.4263825, 37.2378368],
              [48.4261894, 37.2396476],
              [48.4247196, 37.2409117],
              [48.4235608, 37.2408348],
              [48.4196448, 37.2410398],
              [48.4167695, 37.2425174],
              [48.4166729, 37.2446014],
              [48.4153533, 37.2466426],
              [48.4125638, 37.2483849],
              [48.4098709, 37.2479749],
              [48.4039378, 37.2461345],
              [48.3968782, 37.2492219],
              [48.3919859, 37.2489144],
              [48.384304, 37.2453616],
              [48.3800554, 37.24379],
              [48.3789289, 37.244405],
              [48.3761716, 37.2471721],
              [48.3736181, 37.2483336],
              [48.3691871, 37.2486582],
              [48.3667731, 37.2476675],
              [48.3623207, 37.2468818],
              [48.3558726, 37.2480945],
              [48.3529973, 37.2461814],
              [48.3486414, 37.2422356],
              [48.342483, 37.2416719],
              [48.3402622, 37.2406725],
              [48.3376121, 37.2394768],
              [48.3365285, 37.2397458],
              [48.3346724, 37.2402028],
              [48.332526, 37.2424966],
              [48.3314906, 37.2427598],
              [48.3226926, 37.2445594],
              [48.3172246, 37.2455298],
              [48.3137847, 37.2454136],
              [48.2947248, 37.2452939],
              [48.275835, 37.2375107],
              [48.273335, 37.2375107],
              [48.2730548, 37.2372317],
              [48.2708353, 37.2372318],
              [48.2700017, 37.2375107],
              [48.2680552, 37.2375107],
              [48.2672219, 37.2377896],
              [48.265002, 37.2377896],
              [48.2644453, 37.2380685],
              [48.2616687, 37.2380685],
              [48.260835, 37.2377896],
              [48.2605554, 37.2380685],
              [48.2597217, 37.2377895],
              [48.2580553, 37.2377896],
              [48.2574987, 37.2375106],
              [48.2569451, 37.2377896],
              [48.2561119, 37.2375107],
              [48.249722, 37.2375106],
              [48.2488887, 37.2377895],
              [48.2472219, 37.2377896],
              [48.2463887, 37.2380685],
              [48.2416655, 37.2380684],
              [48.2405553, 37.2380685],
              [48.2399987, 37.2377895],
              [48.2377756, 37.2377896],
              [48.236942, 37.2375106],
              [48.2358322, 37.2375106],
              [48.234999, 37.2372316],
              [48.2336087, 37.2372316],
              [48.2252757, 37.2350091],
              [48.219719, 37.2327866],
              [48.2130524, 37.2311219],
              [48.2074991, 37.2294572],
              [48.2063858, 37.2294573],
              [48.2055526, 37.2291783],
              [48.2044424, 37.2291784],
              [48.202776, 37.2286204],
              [48.2013857, 37.2286205],
              [48.1913859, 37.2269557],
              [48.1872194, 37.2269557],
              [48.1863862, 37.2266768],
              [48.1858295, 37.2269558],
              [48.1849959, 37.2266768],
              [48.1774961, 37.2266768],
              [48.1763864, 37.2263979],
              [48.1736062, 37.2263978],
              [48.1730532, 37.2261188],
              [48.1658295, 37.2250121],
              [48.1644396, 37.2247332],
              [48.1613829, 37.2238963],
              [48.1602731, 37.2238963],
              [48.1594395, 37.2236174],
              [48.1502733, 37.2211248],
              [48.1402731, 37.2133413],
              [48.1319402, 37.2055667],
              [48.1313836, 37.2044509],
              [48.1169368, 37.1883434],
              [48.1163837, 37.1872366],
              [48.1094371, 37.1716777],
              [48.1058273, 37.1650095],
              [48.1055471, 37.1647305],
              [48.0997139, 37.1558395],
              [48.0966606, 37.1541746],
              [48.0955474, 37.1541746],
              [48.0955474, 37.1538956],
              [48.0947141, 37.1538957],
              [48.0941606, 37.1541746],
              [48.0933274, 37.1538956],
              [48.0899941, 37.1538956],
              [48.0894375, 37.1536166],
              [48.0836042, 37.1519518],
              [48.0824909, 37.1511148],
              [48.0811042, 37.1508449],
              [48.0644342, 37.1525097],
              [48.0561012, 37.1525096],
              [48.0555477, 37.1522307],
              [48.0536011, 37.1522307],
              [48.0530479, 37.1519518],
              [48.0519343, 37.1519518],
              [48.0508245, 37.1516728],
              [48.0494347, 37.1516727],
              [48.0472111, 37.1511147],
              [48.0449912, 37.1508448],
              [48.044158, 37.1505658],
              [48.0411012, 37.1494499],
              [48.0336014, 37.1452833],
              [48.0095666, 37.1400672],
              [47.9833218, 37.1477849],
              [47.9755419, 37.1533464],
              [47.9724852, 37.1552812],
              [47.9483186, 37.1652881],
              [47.9472089, 37.1652881],
              [47.9469288, 37.165567],
              [47.9385958, 37.1669528],
              [47.9380423, 37.1666739],
              [47.9327625, 37.1666739],
              [47.9322058, 37.1669529],
              [47.9302624, 37.1669529],
              [47.9299859, 37.1672318],
              [47.9288725, 37.1672318],
              [47.9285956, 37.1675107],
              [47.9274858, 37.1675108],
              [47.9272057, 37.1677898],
              [47.9058158, 37.1727841],
              [47.9044294, 37.1727841],
              [47.9022059, 37.1733419],
              [47.9005394, 37.173342],
              [47.8980394, 37.1738999],
              [47.8960929, 37.1738999],
              [47.8949827, 37.1741789],
              [47.8922061, 37.1744489],
              [47.8891493, 37.1744488],
              [47.8880396, 37.1747278],
              [47.8788695, 37.1747278],
              [47.8769264, 37.1747278],
              [47.8719263, 37.1747277],
              [47.8713697, 37.1744488],
              [47.8641496, 37.1736208],
              [47.8608132, 37.1736209],
              [47.8605367, 37.1733419],
              [47.8591464, 37.1733419],
              [47.8588698, 37.1730629],
              [47.8569265, 37.173063],
              [47.8549799, 37.172514],
              [47.8538697, 37.172514],
              [47.8524798, 37.171956],
              [47.8508135, 37.171956],
              [47.8477599, 37.1708402],
              [47.8474801, 37.1705612],
              [47.8472031, 37.1702822],
              [47.8460934, 37.1702822],
              [47.8441465, 37.1694544],
              [47.8433133, 37.1694543],
              [47.8433133, 37.1691754],
              [47.8424799, 37.1691754],
              [47.8072004, 37.1513932],
              [47.805534, 37.1505653],
              [47.7935908, 37.1444548],
              [47.7933107, 37.1438968],
              [47.7927575, 37.1436179],
              [47.7788675, 37.1322247],
              [47.7785874, 37.1316757],
              [47.7783108, 37.1305598],
              [47.7780342, 37.1236213],
              [47.7785874, 37.1197244],
              [47.7777542, 37.1100048],
              [47.7758108, 37.0919512],
              [47.7755343, 37.0908442],
              [47.7730343, 37.0813942],
              [47.772201, 37.0802872],
              [47.7683112, 37.0772272],
              [47.7660877, 37.0763991],
              [47.7649779, 37.0763992],
              [47.7644212, 37.0761201],
              [47.759698, 37.0761201],
              [47.7591445, 37.0763991],
              [47.7421981, 37.0786131],
              [47.7402547, 37.0794501],
              [47.737755, 37.0802871],
              [47.729418, 37.0841751],
              [47.7266414, 37.0869471],
              [47.7266414, 37.087505],
              [47.7216417, 37.0930581],
              [47.7199749, 37.093616],
              [47.7177518, 37.093616],
              [47.7060851, 37.087784],
              [47.705252, 37.0877841],
              [47.7049754, 37.0875051],
              [47.7038617, 37.0875051],
              [47.7033085, 37.087226],
              [47.7019187, 37.0872261],
              [47.6971951, 37.0863981],
              [47.696642, 37.0863981],
              [47.6924501, 37.07914],
              [47.6913137, 37.0771896],
              [47.6909501, 37.0769173],
              [47.6899976, 37.076313],
              [47.6728854, 37.066302],
              [47.6549822, 37.0577032],
              [47.6457039, 37.0490355],
              [47.6454274, 37.0487563],
              [47.6448708, 37.0484772],
              [47.6448708, 37.0479279],
              [47.6440371, 37.0465325],
              [47.6362577, 37.0407871],
              [47.6365342, 37.0399498],
              [47.6373675, 37.0377349],
              [47.6359776, 37.0321709],
              [47.6255512, 37.0310382],
              [47.6183279, 37.0299309],
              [47.6090614, 37.031092],
              [47.59886, 37.0375081],
              [47.5963563, 37.0375081],
              [47.5946899, 37.0402803],
              [47.5944133, 37.0419544],
              [47.5941364, 37.0430615],
              [47.5938566, 37.0444476],
              [47.5935797, 37.0447266],
              [47.5935796, 37.0452846],
              [47.5921898, 37.0477777],
              [47.5844135, 37.0527819],
              [47.5827466, 37.05334],
              [47.5821899, 37.05334],
              [47.5821899, 37.053619],
              [47.5816369, 37.053619],
              [47.5810798, 37.053898],
              [47.5793754, 37.0544088],
              [47.5755234, 37.0555631],
              [47.5696901, 37.0591722],
              [47.5677466, 37.0591722],
              [47.56719, 37.0588932],
              [47.5658001, 37.0588932],
              [47.5638567, 37.0580561],
              [47.5599668, 37.0572281],
              [47.5585769, 37.0572281],
              [47.5577433, 37.0575071],
              [47.5566335, 37.0575071],
              [47.5499669, 37.0608372],
              [47.5483001, 37.0608373],
              [47.5477436, 37.0605582],
              [47.5433004, 37.0605582],
              [47.5424672, 37.0602792],
              [47.541357, 37.0602792],
              [47.5388538, 37.0608372],
              [47.5371869, 37.0616742],
              [47.5369104, 37.0622322],
              [47.5294106, 37.0683344],
              [47.5241339, 37.0672274],
              [47.5174638, 37.0616742],
              [47.5155205, 37.056949],
              [47.515244, 37.0555629],
              [47.5149639, 37.0508378],
              [47.514964, 37.039731],
              [47.515244, 37.0366708],
              [47.512744, 37.0213966],
              [47.5099643, 37.0172292],
              [47.4941312, 37.0025036],
              [47.4935745, 37.0019455],
              [47.4935746, 37.0016665],
              [47.4924644, 37.0000012],
              [47.4874647, 36.9966709],
              [47.486908, 36.9966709],
              [47.4585751, 36.98334],
              [47.4507948, 36.977228],
              [47.4505182, 36.9769489],
              [47.4382953, 36.9633387],
              [47.4374617, 36.9630597],
              [47.4291288, 36.9577757],
              [47.4285721, 36.9575056],
              [47.4281849, 36.9573415],
              [47.4121824, 36.9505563],
              [47.4113487, 36.9505563],
              [47.4094057, 36.9497282],
              [47.4085721, 36.9497281],
              [47.4080159, 36.9494491],
              [47.4071823, 36.9494491],
              [47.4010728, 36.9474957],
              [47.3955156, 36.9466675],
              [47.3727362, 36.9372245],
              [47.3713495, 36.9366664],
              [47.3188468, 36.9055551],
              [47.3168999, 36.9044478],
              [47.3027333, 36.8972278],
              [47.3005113, 36.8952734],
              [47.2999567, 36.8947162],
              [47.2955105, 36.883337],
              [47.2910675, 36.8780615],
              [47.2693975, 36.8713904],
              [47.2577309, 36.8663849],
              [47.2568973, 36.8658267],
              [47.2432876, 36.8461104],
              [47.2410643, 36.839169],
              [47.2405079, 36.8383317],
              [47.2263413, 36.8275008],
              [47.223285, 36.8252771],
              [47.2091182, 36.811943],
              [47.1982853, 36.7994371],
              [47.1907851, 36.7955565],
              [47.1880082, 36.7924952],
              [47.1868988, 36.7924952],
              [47.1852316, 36.7922161],
              [47.1846753, 36.7922162],
              [47.1843987, 36.7919371],
              [47.1799518, 36.791667]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241474,
        "tags": {
          "ISO3166-2": "IR-20",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "سمنان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q168949"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [51.8341678, 34.5059559],
              [51.83462, 34.5057806],
              [51.8346199, 34.5055009],
              [51.856843, 34.4905032],
              [51.8587863, 34.4899527],
              [51.8598996, 34.4899527],
              [51.8612863, 34.4893932],
              [51.8615663, 34.4888337],
              [51.8732329, 34.4849444],
              [51.8776761, 34.4830043],
              [51.8779563, 34.4827246],
              [51.9065692, 34.4724462],
              [51.9671251, 34.4463306],
              [51.9776816, 34.4424411],
              [52.0146278, 34.4305022],
              [52.0157411, 34.4305022],
              [52.0557406, 34.4224435],
              [52.0665738, 34.4193933],
              [52.0679639, 34.4193933],
              [52.1024101, 34.4113346],
              [52.1065766, 34.4102246],
              [52.1071334, 34.4102246],
              [52.1088002, 34.4096742],
              [52.1099099, 34.4096742],
              [52.1168565, 34.4077249],
              [52.1185232, 34.4077249],
              [52.1187999, 34.4074452],
              [52.12019, 34.4074451],
              [52.1207431, 34.4071654],
              [52.1215765, 34.4071654],
              [52.1247214, 34.4057632],
              [52.129913, 34.4046656],
              [52.1307464, 34.4046656],
              [52.1343563, 34.4035556],
              [52.1354663, 34.4035556],
              [52.139633, 34.4027254],
              [52.1412997, 34.4027254],
              [52.1424129, 34.4024456],
              [52.1440795, 34.4024456],
              [52.1459888, 34.4021873],
              [52.1493562, 34.4016154],
              [52.1529695, 34.4016154],
              [52.1551893, 34.4013356],
              [52.1585226, 34.4013357],
              [52.1607461, 34.4016154],
              [52.1614274, 34.4016155],
              [52.1738027, 34.4016155],
              [52.1751925, 34.4013357],
              [52.1782459, 34.4013356],
              [52.1793592, 34.4010559],
              [52.182969, 34.4010559],
              [52.1838024, 34.4013358],
              [52.1871357, 34.4013356],
              [52.1876924, 34.4016155],
              [52.1907491, 34.4016154],
              [52.1915822, 34.4018952],
              [52.2065822, 34.4018952],
              [52.2082488, 34.4021659],
              [52.2135253, 34.402166],
              [52.2146387, 34.4024457],
              [52.217972, 34.4024457],
              [52.2218587, 34.4029962],
              [52.224082, 34.4029962],
              [52.2254719, 34.4032759],
              [52.229362, 34.403276],
              [52.2307485, 34.4035557],
              [52.2329717, 34.4035557],
              [52.2474183, 34.4055049],
              [52.2535283, 34.406606],
              [52.2596381, 34.4074453],
              [52.2615848, 34.4074453],
              [52.2801979, 34.4102248],
              [52.2840846, 34.4104954],
              [52.2854744, 34.4107753],
              [52.2868645, 34.4110549],
              [52.2874178, 34.4113348],
              [52.2915843, 34.4118943],
              [52.3029742, 34.4141143],
              [52.3129742, 34.415504],
              [52.3285306, 34.419944],
              [52.3296438, 34.4199439],
              [52.3313105, 34.4205035],
              [52.3324205, 34.4205035],
              [52.3527004, 34.4243929],
              [52.3546436, 34.424393],
              [52.3768666, 34.4277229],
              [52.3788133, 34.427723],
              [52.3799233, 34.4280027],
              [52.3885331, 34.428833],
              [52.3929798, 34.4291127],
              [52.3943698, 34.4293925],
              [52.3952031, 34.4291127],
              [52.3954797, 34.4293924],
              [52.3993698, 34.4293924],
              [52.399923, 34.4291127],
              [52.4022866, 34.4291127],
              [52.403813, 34.428833],
              [52.4040897, 34.4285532],
              [52.4054797, 34.4285532],
              [52.4060364, 34.4282734],
              [52.4068696, 34.4282734],
              [52.4090895, 34.4282735],
              [52.4096462, 34.4285532],
              [52.4102029, 34.4282735],
              [52.4160362, 34.4274432],
              [52.4174262, 34.4271725],
              [52.429646, 34.4271725],
              [52.4307592, 34.4274433],
              [52.4368693, 34.426613],
              [52.4440925, 34.426613],
              [52.4446492, 34.4263332],
              [52.4474257, 34.4263332],
              [52.4485358, 34.4260534],
              [52.4504824, 34.4260535],
              [52.4532591, 34.425503],
              [52.4563157, 34.4255031],
              [52.4590923, 34.4249435],
              [52.4796487, 34.4221641],
              [52.4821486, 34.4221641],
              [52.4829819, 34.4218843],
              [52.4888186, 34.4210631],
              [52.4999285, 34.4191138],
              [52.5025119, 34.4184128],
              [52.5264463, 34.4102747],
              [52.5612699, 34.4013693],
              [52.5804843, 34.3960065],
              [52.5928844, 34.3920049],
              [52.6035292, 34.390082],
              [52.6095714, 34.3882974],
              [52.6528082, 34.3775899],
              [52.6732697, 34.3666098],
              [52.677993, 34.3643897],
              [52.7416319, 34.3327637],
              [52.7639419, 34.3198834],
              [52.8017401, 34.3005397],
              [52.820325, 34.2909465],
              [52.8418053, 34.2797346],
              [52.852427, 34.2764549],
              [52.865566, 34.2720898],
              [52.8804077, 34.2674397],
              [52.8943325, 34.265161],
              [52.9205728, 34.2654891],
              [52.9502034, 34.2647483],
              [52.9678454, 34.2644171],
              [52.9816033, 34.2642252],
              [53.0033984, 34.2640873],
              [53.0256643, 34.2620971],
              [53.0413023, 34.2611081],
              [53.0697114, 34.2595554],
              [53.0810578, 34.2585583],
              [53.1004753, 34.2578449],
              [53.1351516, 34.2554909],
              [53.1697219, 34.2534174],
              [53.1735702, 34.2532756],
              [53.194365, 34.2519147],
              [53.2078925, 34.2510909],
              [53.285751, 34.2470006],
              [53.3660885, 34.2461493],
              [53.4983972, 34.2458472],
              [53.5121409, 34.2459223],
              [53.5166735, 34.2458552],
              [53.5190209, 34.2458592],
              [53.5343699, 34.2450538],
              [53.8446401, 34.2457763],
              [53.8732993, 34.2468984],
              [53.9072441, 34.2465018],
              [53.9991759, 34.2479938],
              [54.0271567, 34.2465748],
              [54.1546961, 34.2397033],
              [54.1807712, 34.2392897],
              [54.197569, 34.2385802],
              [54.2222209, 34.2366143],
              [54.2339897, 34.2355854],
              [54.2499703, 34.2342332],
              [54.3447677, 34.237036],
              [54.4302967, 34.237015],
              [54.4967596, 34.2382882],
              [54.5054053, 34.2390538],
              [54.5254896, 34.2379185],
              [54.5677183, 34.2389119],
              [54.6105335, 34.2385698],
              [55.0405855, 34.2397823],
              [55.1082144, 34.2399589],
              [55.1337097, 34.2403038],
              [55.1604007, 34.2380332],
              [55.1818967, 34.2384549],
              [55.1997496, 34.2390266],
              [55.4016493, 34.2393376],
              [55.5007367, 34.2674919],
              [55.5209677, 34.2718896],
              [55.5338286, 34.2684953],
              [55.5524977, 34.2622428],
              [55.5957227, 34.2647793],
              [55.6534093, 34.242445],
              [55.6547961, 34.2421651],
              [55.6584094, 34.2421652],
              [55.6597993, 34.242445],
              [55.6689659, 34.2427157],
              [55.6697991, 34.2424449],
              [55.6775756, 34.242445],
              [55.6786891, 34.2421652],
              [55.7095219, 34.2427157],
              [55.710912, 34.2429954],
              [55.7228551, 34.2429955],
              [55.7236884, 34.2427157],
              [55.7259118, 34.2427157],
              [55.7267452, 34.2424449],
              [55.7464682, 34.2427157],
              [55.7489681, 34.243555],
              [55.7492449, 34.2438258],
              [55.7498016, 34.2441056],
              [55.7520248, 34.2441055],
              [55.7525815, 34.2438258],
              [55.7531348, 34.2441056],
              [55.7623014, 34.243555],
              [55.7631346, 34.2432752],
              [55.773138, 34.2432752],
              [55.7775812, 34.243555],
              [55.7823046, 34.243555],
              [55.7828577, 34.2432752],
              [55.7861909, 34.2432753],
              [55.7867478, 34.2429954],
              [55.788691, 34.2429954],
              [55.7892477, 34.2427157],
              [55.7911944, 34.2427157],
              [55.7914709, 34.2424449],
              [55.7936944, 34.2424449],
              [55.7945276, 34.2421651],
              [55.7973043, 34.2421651],
              [55.7978609, 34.2424449],
              [55.7986944, 34.242165],
              [55.7998043, 34.2424449],
              [55.8075809, 34.2424449],
              [55.8100842, 34.2427157],
              [55.8106373, 34.2429954],
              [55.8417543, 34.2384212],
              [55.8434209, 34.2384211],
              [55.8445342, 34.2387008],
              [55.8514775, 34.2387009],
              [55.8525872, 34.2384211],
              [55.8553674, 34.2384211],
              [55.8564774, 34.2381412],
              [55.8670338, 34.2381413],
              [55.8678673, 34.2378615],
              [55.8864532, 34.2441054],
              [55.88701, 34.2438257],
              [55.88951, 34.2438257],
              [55.8900633, 34.2435549],
              [55.8908965, 34.2438257],
              [55.8931198, 34.2435549],
              [55.8936766, 34.2432751],
              [55.9014532, 34.2432751],
              [55.9036764, 34.2438257],
              [55.9042331, 34.2441054],
              [55.9047864, 34.2441054],
              [55.9050666, 34.2443853],
              [55.9058998, 34.2443852],
              [55.909233, 34.2457751],
              [55.9095096, 34.2460549],
              [55.9100665, 34.2466054],
              [55.9100664, 34.2468852],
              [55.9103431, 34.247165],
              [55.9108997, 34.2474447],
              [55.9436991, 34.282272],
              [56.0098882, 34.3758018],
              [56.0107213, 34.3766319],
              [56.0132214, 34.3813517],
              [56.0168348, 34.3866309],
              [56.2256594, 34.7060607],
              [56.2270463, 34.7080096],
              [56.2273261, 34.7088397],
              [56.2276029, 34.7091193],
              [56.2279736, 34.7104172],
              [56.2284362, 34.7118984],
              [56.2237229, 34.7229952],
              [56.226223, 34.7260448],
              [56.221837, 34.7446398],
              [56.2235036, 34.7471391],
              [56.2237801, 34.7482579],
              [56.2307568, 34.7852731],
              [56.23159, 34.7858323],
              [56.2554798, 34.8199904],
              [56.2579799, 34.8230391],
              [56.3125957, 34.8659688],
              [56.3279786, 34.8775023],
              [56.3324253, 34.8816692],
              [56.3335353, 34.8833287],
              [56.3338118, 34.8836082],
              [56.3413118, 34.8899939],
              [56.348535, 34.9005461],
              [56.3488151, 34.9013759],
              [56.3490918, 34.9016555],
              [56.3490919, 34.901935],
              [56.3883746, 34.9345305],
              [56.3900413, 34.9367495],
              [56.3903212, 34.9375884],
              [56.3939312, 34.9431357],
              [56.3944879, 34.943695],
              [56.3944879, 34.9442453],
              [56.4428905, 34.9796821],
              [56.4537237, 34.9999609],
              [56.4815034, 35.0221877],
              [56.4884468, 35.0285743],
              [56.5170597, 35.0413472],
              [56.5178931, 35.0413472],
              [56.5190065, 35.0421861],
              [56.5328961, 35.0466241],
              [56.5345628, 35.0469038],
              [56.5367828, 35.0477427],
              [56.5620626, 35.0524603],
              [56.5637292, 35.0524603],
              [56.5645624, 35.0527399],
              [56.5687292, 35.0527399],
              [56.5703958, 35.0530195],
              [56.5717858, 35.0530195],
              [56.5723425, 35.0530195],
              [56.580119, 35.0538494],
              [56.5815089, 35.0538494],
              [56.5820622, 35.0541291],
              [56.5840089, 35.0541291],
              [56.585119, 35.0544087],
              [56.5870657, 35.0544087],
              [56.5895655, 35.0549589],
              [56.5915089, 35.0549589],
              [56.5937322, 35.0555181],
              [56.5948422, 35.0555182],
              [56.6240117, 35.0641325],
              [56.6253985, 35.0644031],
              [56.6265119, 35.0649624],
              [56.6401217, 35.0666221],
              [56.641235, 35.0669017],
              [56.6520682, 35.0669018],
              [56.6531782, 35.0666221],
              [56.6579014, 35.0666221],
              [56.6582224, 35.0636936],
              [56.6598891, 35.0631254],
              [56.6615556, 35.0628548],
              [56.6647249, 35.0604994],
              [56.6666683, 35.0604993],
              [56.6672249, 35.0602197],
              [56.6700016, 35.0602197],
              [56.6705582, 35.0604994],
              [56.6725014, 35.0604994],
              [56.6733348, 35.060779],
              [56.6750014, 35.060779],
              [56.6758348, 35.0610586],
              [56.6772248, 35.0610587],
              [56.6869549, 35.0822105],
              [56.6908783, 35.0872661],
              [56.6944748, 35.0920132],
              [56.6969749, 35.0936727],
              [56.6972514, 35.0942319],
              [56.6986415, 35.0953413],
              [56.7133647, 35.1092306],
              [56.7608636, 35.126087],
              [56.7737402, 35.1469087],
              [56.77513, 35.1482977],
              [56.7823499, 35.1535742],
              [56.8112432, 35.1674643],
              [56.8270763, 35.1846825],
              [56.828743, 35.1860714],
              [56.828743, 35.1863511],
              [56.8306861, 35.1882992],
              [56.8429093, 35.1969036],
              [56.8437427, 35.1977425],
              [56.8556893, 35.2024685],
              [56.8573559, 35.2024685],
              [56.8612425, 35.2032983],
              [56.8623558, 35.2032983],
              [56.8629091, 35.2035779],
              [56.865409, 35.2035779],
              [56.8662458, 35.2032983],
              [56.8684657, 35.2032983],
              [56.8695792, 35.2030187],
              [56.8740223, 35.2030187],
              [56.8751322, 35.202739],
              [56.8765224, 35.2030187],
              [56.8826322, 35.2030186],
              [56.8837455, 35.2027391],
              [56.8870788, 35.2027391],
              [56.8876357, 35.2030187],
              [56.8898554, 35.2030186],
              [56.8904122, 35.2032982],
              [56.8912455, 35.2032983],
              [56.8918022, 35.2035778],
              [56.8934688, 35.2035778],
              [56.8940221, 35.2038575],
              [56.8951354, 35.2038574],
              [56.9076353, 35.2074651],
              [56.9081919, 35.2080153],
              [56.9093019, 35.2083039],
              [56.9098586, 35.2088541],
              [56.9109685, 35.2091336],
              [56.9165251, 35.2133005],
              [56.9348583, 35.2205158],
              [56.9354149, 35.2207954],
              [56.9368015, 35.2207954],
              [56.9370816, 35.221075],
              [56.9409682, 35.221075],
              [56.9415249, 35.2207954],
              [56.9426381, 35.2207954],
              [56.9465248, 35.2196861],
              [56.9473582, 35.219686],
              [56.9515247, 35.2180175],
              [56.9523581, 35.217747],
              [56.9656947, 35.2144099],
              [56.966528, 35.2141303],
              [56.967638, 35.2141303],
              [56.9751379, 35.2116319],
              [56.9806945, 35.2108021],
              [56.980971, 35.2105226],
              [56.9831945, 35.2105226],
              [56.9837511, 35.2108022],
              [56.9868043, 35.2108022],
              [56.9906943, 35.2119116],
              [57.0002296, 35.2152486],
              [57.010694, 35.2235732],
              [57.0312505, 35.2674683],
              [57.0315306, 35.2677479],
              [57.0318073, 35.2688572],
              [57.0393071, 35.2810776],
              [57.0501403, 35.3071863],
              [57.0520871, 35.3149691],
              [57.0523637, 35.3210836],
              [57.036254, 35.3374608],
              [57.0359739, 35.3380199],
              [57.0354173, 35.3382996],
              [57.0343073, 35.3394088],
              [57.0195842, 35.3641364],
              [57.0102242, 35.3856591],
              [57.0096676, 35.3940024],
              [57.009391, 35.3953914],
              [56.9906272, 35.4168259],
              [56.9869149, 35.4193241],
              [56.9816383, 35.4290465],
              [56.9813584, 35.4376594],
              [56.9813585, 35.437939],
              [56.9841383, 35.4415465],
              [56.9940279, 35.4558096],
              [56.9943047, 35.4583075],
              [56.9945848, 35.4605257],
              [56.995418, 35.4663598],
              [57.0018744, 35.4727813],
              [57.0024312, 35.4747289],
              [57.0235732, 35.4957848],
              [57.030342, 35.500141],
              [57.0340633, 35.5079853],
              [57.0371961, 35.512352],
              [57.0394706, 35.520945],
              [57.0405435, 35.5259397],
              [57.0441224, 35.526751],
              [57.0463399, 35.5281844],
              [57.0484134, 35.5292768],
              [57.0491429, 35.5304295],
              [57.0513969, 35.5345068],
              [57.0509678, 35.5378598],
              [57.0499142, 35.5423558],
              [57.0477103, 35.545217],
              [57.0429951, 35.5472653],
              [57.0398252, 35.5503299],
              [57.0365523, 35.5579263],
              [57.0318317, 35.5610684],
              [57.0322608, 35.5644896],
              [57.0310877, 35.5679775],
              [57.0245719, 35.5692997],
              [57.0172344, 35.5710454],
              [57.0105396, 35.5741175],
              [56.9974501, 35.5776884],
              [56.9911933, 35.5815763],
              [56.9853973, 35.585014],
              [56.9828223, 35.5900396],
              [56.9856547, 35.5948555],
              [56.9855689, 35.5973681],
              [56.9879574, 35.6036103],
              [56.974211, 35.6168686],
              [56.9709777, 35.6258378],
              [56.9654845, 35.6335118],
              [56.9627379, 35.6404178],
              [56.9584464, 35.657924],
              [56.9582747, 35.6639213],
              [56.9503783, 35.6922976],
              [56.9463974, 35.6984029],
              [56.9426464, 35.7050006],
              [56.9358909, 35.7121805],
              [56.930251, 35.7146196],
              [56.9191061, 35.7215946],
              [56.9120853, 35.7311819],
              [56.9113254, 35.7360625],
              [56.9086911, 35.7432314],
              [56.8983079, 35.7528377],
              [56.8655593, 35.7785791],
              [56.8551921, 35.7876017],
              [56.8399318, 35.7978493],
              [56.818493, 35.8126847],
              [56.7839467, 35.8348289],
              [56.7652614, 35.8463558],
              [56.7538101, 35.8533756],
              [56.7573451, 35.884252],
              [56.7573541, 35.8987346],
              [56.7579801, 35.9083778],
              [56.7599317, 35.9243064],
              [56.7575674, 35.9438673],
              [56.7578475, 35.9447056],
              [56.7561775, 35.9608119],
              [56.7564574, 35.9616502],
              [56.7587941, 35.9655351],
              [56.7593507, 35.9697082],
              [56.7599074, 35.9752603],
              [56.7593508, 35.982489],
              [56.7596274, 35.9830387],
              [56.743458, 36.0116538],
              [56.7437346, 36.0127622],
              [56.7440146, 36.0138706],
              [56.7442912, 36.0169253],
              [56.7451246, 36.0247016],
              [56.7451246, 36.0288646],
              [56.7448481, 36.0310903],
              [56.7451246, 36.0319193],
              [56.744848, 36.0330366],
              [56.7451247, 36.0335862],
              [56.7462347, 36.0444261],
              [56.7465147, 36.0460841],
              [56.7467913, 36.0505353],
              [56.7463732, 36.06283],
              [56.7469299, 36.0698285],
              [56.7472255, 36.0744876],
              [56.747847, 36.0896383],
              [56.7488449, 36.1066758],
              [56.7482471, 36.1137488],
              [56.750104, 36.1318971],
              [56.7528116, 36.1382944],
              [56.7528116, 36.138844],
              [56.7533683, 36.1394024],
              [56.757535, 36.1521773],
              [56.7578116, 36.1524475],
              [56.7581767, 36.1535431],
              [56.7586093, 36.1559498],
              [56.7588859, 36.1565084],
              [56.7590231, 36.1570581],
              [56.7733182, 36.1830371],
              [56.7651453, 36.2367772],
              [56.7626454, 36.2415004],
              [56.7626454, 36.2417799],
              [56.7609788, 36.2462326],
              [56.7551454, 36.2606814],
              [56.7462557, 36.2679012],
              [56.7365324, 36.2729126],
              [56.7299645, 36.2985255],
              [56.7331824, 36.313053],
              [56.7329289, 36.3134953],
              [56.7320724, 36.31499],
              [56.7315157, 36.3183233],
              [56.7317958, 36.3188819],
              [56.7320724, 36.3244404],
              [56.7312391, 36.3341612],
              [56.7276292, 36.341107],
              [56.7245726, 36.345269],
              [56.7321053, 36.3822493],
              [56.7348852, 36.3858619],
              [56.7359952, 36.3866908],
              [56.7368284, 36.3872493],
              [56.7631286, 36.4130196],
              [56.7853515, 36.4244048],
              [56.8004083, 36.4455487],
              [56.8023551, 36.4474943],
              [56.8167982, 36.4619424],
              [56.8562447, 36.5088882],
              [56.8568013, 36.509996],
              [56.8579113, 36.5111039],
              [56.860968, 36.5161117],
              [56.8623579, 36.5183274],
              [56.862358, 36.5186066],
              [56.8640245, 36.5208313],
              [56.8681913, 36.5344405],
              [56.8684678, 36.5358365],
              [56.8688172, 36.5370548],
              [56.8696337, 36.5431063],
              [56.8682436, 36.5492223],
              [56.8651905, 36.5578243],
              [56.8646337, 36.5594996],
              [56.8643572, 36.5606075],
              [56.8521339, 36.5772796],
              [56.8449108, 36.5822785],
              [56.8187677, 36.5898147],
              [56.7800951, 36.5868124],
              [56.7792618, 36.5870917],
              [56.7756517, 36.5876502],
              [56.7742619, 36.5879295],
              [56.7731519, 36.5879295],
              [56.7723185, 36.5882088],
              [56.7714853, 36.5882088],
              [56.7700952, 36.5887672],
              [56.7692617, 36.5887672],
              [56.7556487, 36.5962619],
              [56.752872, 36.6062699],
              [56.7568519, 36.6450633],
              [56.7557418, 36.6497916],
              [56.7554619, 36.6517279],
              [56.7554617, 36.652007],
              [56.7560184, 36.6536822],
              [56.7639526, 36.6639856],
              [56.769825, 36.6670998],
              [56.7733107, 36.6735223],
              [56.774665, 36.6754232],
              [56.7746649, 36.6759816],
              [56.7686151, 36.6828182],
              [56.7594928, 36.6802167],
              [56.758106, 36.6802167],
              [56.7572729, 36.6804959],
              [56.7542162, 36.6804959],
              [56.7531028, 36.6802167],
              [56.7503262, 36.6802167],
              [56.7453262, 36.6796582],
              [56.7442163, 36.6796582],
              [56.7378928, 36.675793],
              [56.7254129, 36.6694349],
              [56.7245796, 36.6691556],
              [56.7187464, 36.6691556],
              [56.717913, 36.6688763],
              [56.7134664, 36.6688764],
              [56.7060632, 36.6639297],
              [56.7043965, 36.6644883],
              [56.6980066, 36.6636506],
              [56.69523, 36.6628216],
              [56.6949532, 36.6625424],
              [56.6935633, 36.6625424],
              [56.6510994, 36.6724587],
              [56.6483228, 36.6736649],
              [56.6469328, 36.6719094],
              [56.6460995, 36.6716304],
              [56.6345211, 36.6623606],
              [56.6273114, 36.6601573],
              [56.618385, 36.6540981],
              [56.6053387, 36.6543735],
              [56.5792462, 36.6590557],
              [56.573753, 36.6576786],
              [56.5490338, 36.6532718],
              [56.5194621, 36.6506994],
              [56.5183521, 36.6504202],
              [56.5164087, 36.6504202],
              [56.5036289, 36.6484746],
              [56.5014057, 36.6484747],
              [56.4983523, 36.6479162],
              [56.4961289, 36.6479162],
              [56.4952957, 36.6481955],
              [56.4944624, 36.6481954],
              [56.4939057, 36.6484746],
              [56.4930723, 36.6484746],
              [56.4894624, 36.650141],
              [56.4780726, 36.6620934],
              [56.4709193, 36.6775995],
              [56.4695292, 36.6778696],
              [56.4629792, 36.6831293],
              [56.4618659, 36.6836876],
              [56.4590809, 36.684179],
              [56.4503627, 36.6834265],
              [56.4492494, 36.6837056],
              [56.4429011, 36.6810861],
              [56.4417911, 36.6810862],
              [56.4412346, 36.6813653],
              [56.4206398, 36.6770911],
              [56.4198064, 36.6768119],
              [56.4178597, 36.6768119],
              [56.3967703, 36.6761293],
              [56.3744486, 36.6710891],
              [56.3733385, 36.6710891],
              [56.3716719, 36.6705307],
              [56.3631671, 36.6822268],
              [56.3612239, 36.6816685],
              [56.3595572, 36.6827762],
              [56.3590005, 36.6863872],
              [56.3592771, 36.6872246],
              [56.3170652, 36.7387089],
              [56.2870785, 36.7562155],
              [56.2688824, 36.7707927],
              [56.2596127, 36.7735428],
              [56.2507752, 36.7791028],
              [56.2431332, 36.7823424],
              [56.2235638, 36.7878416],
              [56.1878582, 36.8120337],
              [56.1037794, 36.8532569],
              [56.0974696, 36.8546803],
              [56.0930263, 36.8560674],
              [56.0927461, 36.8563466],
              [56.0773083, 36.8581973],
              [56.0635754, 36.8592961],
              [56.0330196, 36.8683605],
              [56.0278698, 36.8730296],
              [56.0181712, 36.8746773],
              [56.0049511, 36.8737517],
              [56.0046744, 36.8743008],
              [56.0038377, 36.8776314],
              [56.0057192, 36.8883389],
              [56.0038374, 36.8951353],
              [56.0000608, 36.9061173],
              [56.0010908, 36.9203914],
              [56.0034791, 36.9295525],
              [56.0037592, 36.9303808],
              [56.0076659, 36.9418165],
              [56.0105175, 36.948459],
              [56.0107975, 36.9492872],
              [56.0108498, 36.9496553],
              [56.0108647, 36.9497598],
              [56.0110741, 36.9512318],
              [56.0209191, 36.968641],
              [56.0216469, 36.9813486],
              [56.0240711, 36.9951731],
              [56.0326765, 36.9995367],
              [56.02787, 37.0100924],
              [56.0275267, 37.012971],
              [56.0337309, 37.0176012],
              [56.0350791, 37.0255818],
              [56.0306166, 37.0316104],
              [56.0298709, 37.0349065],
              [56.029821, 37.0408502],
              [56.021855, 37.0510878],
              [56.0129355, 37.0575061],
              [56.0074423, 37.0705192],
              [56.0100179, 37.1046278],
              [56.0120748, 37.1375232],
              [56.0117, 37.1477538],
              [56.0062405, 37.1622321],
              [55.9928576, 37.1743985],
              [55.9375674, 37.182803],
              [55.9367341, 37.1825239],
              [55.9361774, 37.1825239],
              [55.9342342, 37.1822448],
              [55.9336775, 37.1822448],
              [55.9278442, 37.1822449],
              [55.9228443, 37.1822449],
              [55.9220108, 37.1825239],
              [55.9197876, 37.1825238],
              [55.9107969, 37.1876728],
              [55.9089544, 37.1989139],
              [55.9092312, 37.2003091],
              [55.9060778, 37.2049876],
              [55.9039305, 37.2132418],
              [55.9034363, 37.2260945],
              [55.9037128, 37.2288749],
              [55.9039929, 37.2305395],
              [55.9042696, 37.233041],
              [55.9045463, 37.2374858],
              [55.9048262, 37.2455388],
              [55.9048262, 37.2519272],
              [55.9048262, 37.2555443],
              [55.9051029, 37.2558231],
              [55.9050531, 37.262591],
              [55.9053296, 37.267315],
              [55.9058863, 37.2742615],
              [55.9061629, 37.2773208],
              [55.9064431, 37.2803711],
              [55.9109686, 37.2873019],
              [55.9097928, 37.297721],
              [55.9136362, 37.3063754],
              [55.9109227, 37.3225239],
              [55.8967207, 37.3236221],
              [55.8838461, 37.3197998],
              [55.8692841, 37.3226794],
              [55.8692842, 37.3230584],
              [55.8514767, 37.3261317],
              [55.8453635, 37.3255739],
              [55.8417534, 37.3255739],
              [55.8292538, 37.3239094],
              [55.8278637, 37.3233517],
              [55.8253636, 37.3230728],
              [55.8223071, 37.322245],
              [55.8086256, 37.3178633],
              [55.7889741, 37.3080749],
              [55.7578612, 37.2925188],
              [55.7513466, 37.2885519],
              [55.7450811, 37.284736],
              [55.7348443, 37.2626619],
              [55.7312344, 37.2579377],
              [55.7301211, 37.2537713],
              [55.7298443, 37.2493259],
              [55.7278978, 37.233209],
              [55.7276211, 37.2315442],
              [55.7273445, 37.2293215],
              [55.7270644, 37.2284845],
              [55.7273445, 37.2226531],
              [55.7270644, 37.2157058],
              [55.7267877, 37.2120972],
              [55.720528, 37.2018572],
              [55.7205279, 37.2004712],
              [55.7140049, 37.1951219],
              [55.7109782, 37.1912503],
              [55.7072883, 37.1870346],
              [55.7006349, 37.1830671],
              [55.686745, 37.1639085],
              [55.6770253, 37.1552875],
              [55.6767451, 37.1544595],
              [55.6756351, 37.1536226],
              [55.6603553, 37.1408438],
              [55.6547987, 37.1361281],
              [55.6511887, 37.1330683],
              [55.6416647, 37.1234176],
              [55.6306323, 37.1122344],
              [55.6303556, 37.1119554],
              [55.6214658, 37.0991758],
              [55.6070192, 37.0688997],
              [55.6045191, 37.0558493],
              [55.6041872, 37.0530682],
              [55.6041866, 37.0530654],
              [55.6039659, 37.0519521],
              [55.6036858, 37.051124],
              [55.6025759, 37.0439057],
              [55.6020192, 37.0380643],
              [55.6017425, 37.0327899],
              [55.5992426, 37.0130691],
              [55.5989626, 37.0094507],
              [55.5986859, 37.0091717],
              [55.5989626, 37.0086226],
              [55.5986859, 37.0083436],
              [55.5986858, 37.0063993],
              [55.5970192, 37.0019529],
              [55.5961859, 36.9983434],
              [55.5914625, 36.9889012],
              [55.585076, 36.9708445],
              [55.5795194, 36.9572341],
              [55.5792393, 36.9555598],
              [55.5636862, 36.9294545],
              [55.5625728, 36.9283473],
              [55.5603495, 36.9252866],
              [55.5525223, 36.9207796],
              [55.5511324, 36.9207795],
              [55.5508557, 36.9205006],
              [55.548357, 36.9193923],
              [55.5472424, 36.9188355],
              [55.5430758, 36.9168915],
              [55.5416891, 36.9168915],
              [55.5397425, 36.9163334],
              [55.50618, 36.8994503],
              [55.5000701, 36.9011157],
              [55.4706239, 36.8772322],
              [55.4164544, 36.8277791],
              [55.4128444, 36.8252852],
              [55.4008978, 36.8169571],
              [55.3736748, 36.8105647],
              [55.362285, 36.8086199],
              [55.3603416, 36.80862],
              [55.3595083, 36.8083409],
              [55.3542283, 36.8077827],
              [55.3245054, 36.803614],
              [55.3220055, 36.8036141],
              [55.3183956, 36.8030648],
              [55.3164487, 36.8030648],
              [55.2983922, 36.8005618],
              [55.2967257, 36.8000036],
              [55.295339, 36.8000036],
              [55.2947823, 36.7997245],
              [55.2925589, 36.7997245],
              [55.2872823, 36.7991753],
              [55.2867258, 36.7991753],
              [55.2845059, 36.7986171],
              [55.2820058, 36.798617],
              [55.2811725, 36.798338],
              [55.273116, 36.798338],
              [55.2728359, 36.7980589],
              [55.2683926, 36.7955648],
              [55.2661693, 36.7947275],
              [55.2542261, 36.7922245],
              [55.231723, 36.7894513],
              [55.229223, 36.7894514],
              [55.2281131, 36.7891722],
              [55.2258898, 36.7891723],
              [55.2233898, 36.7888932],
              [55.2197798, 36.7888931],
              [55.2172799, 36.788614],
              [55.2075566, 36.788614],
              [55.1986668, 36.7877857],
              [55.1945001, 36.7877857],
              [55.1906102, 36.7872275],
              [55.1878336, 36.7872274],
              [55.1806102, 36.7866692],
              [55.1553305, 36.7855618],
              [55.1417208, 36.7841753],
              [55.1386642, 36.7841752],
              [55.1372741, 36.7838961],
              [55.1317209, 36.7838961],
              [55.1311642, 36.783617],
              [55.1303308, 36.783617],
              [55.1297741, 36.7833379],
              [55.1281075, 36.7833379],
              [55.1278309, 36.7830587],
              [55.1219976, 36.781123],
              [55.1161643, 36.781123],
              [55.115331, 36.7811229],
              [55.1125511, 36.7811229],
              [55.1111644, 36.7811229],
              [55.1097745, 36.7808438],
              [55.1069943, 36.7808439],
              [55.0956079, 36.778899],
              [55.0908846, 36.7775034],
              [55.084218, 36.7769542],
              [55.0808847, 36.7769542],
              [55.079218, 36.776675],
              [55.0761615, 36.7766751],
              [55.072828, 36.7763959],
              [55.0667149, 36.776396],
              [55.0656049, 36.7761168],
              [55.0619949, 36.7761168],
              [55.0611616, 36.7758377],
              [55.0583817, 36.7758377],
              [55.0575483, 36.7755586],
              [55.0561617, 36.7755586],
              [55.0525483, 36.7750094],
              [55.0500485, 36.7750094],
              [55.0406052, 36.7733347],
              [55.0383819, 36.7733347],
              [55.0375485, 36.7730645],
              [55.0100454, 36.767221],
              [55.0014356, 36.7641687],
              [54.9872691, 36.7547233],
              [54.9806026, 36.7472319],
              [54.9769892, 36.7422255],
              [54.9589327, 36.7183369],
              [54.9478228, 36.7058384],
              [54.9478227, 36.7055593],
              [54.9475428, 36.7052802],
              [54.9472661, 36.7050009],
              [54.9472661, 36.7047219],
              [54.923653, 36.6766626],
              [54.9228197, 36.6750057],
              [54.9122631, 36.6644427],
              [54.8598237, 36.6377129],
              [54.842324, 36.6304911],
              [54.8378773, 36.6291045],
              [54.8231499, 36.6100166],
              [54.7889245, 36.6027817],
              [54.7780913, 36.6002781],
              [54.7678114, 36.6002781],
              [54.7669781, 36.6005573],
              [54.7655915, 36.6005573],
              [54.7642015, 36.6008365],
              [54.7617015, 36.6008365],
              [54.7550349, 36.6019442],
              [54.747255, 36.6041687],
              [54.7253119, 36.6158312],
              [54.7219787, 36.6175062],
              [54.7008655, 36.6325007],
              [54.6994755, 36.6316631],
              [54.6911422, 36.6294478],
              [54.690309, 36.6288895],
              [54.6894756, 36.6288894],
              [54.686419, 36.6277817],
              [54.685309, 36.6277817],
              [54.6755857, 36.6252782],
              [54.6662316, 36.6252218],
              [54.6620898, 36.6243932],
              [54.6587123, 36.6232821],
              [54.6567691, 36.6227237],
              [54.6448226, 36.612449],
              [54.6437125, 36.610783],
              [54.630216, 36.5828156],
              [54.6271593, 36.5797623],
              [54.6099469, 36.5728027],
              [54.5776745, 36.5739056],
              [54.5745846, 36.5595669],
              [54.5714947, 36.5303298],
              [54.5578139, 36.5232048],
              [54.5572145, 36.5229677],
              [54.5564239, 36.5226551],
              [54.5561473, 36.522376],
              [54.5439241, 36.5182047],
              [54.5334708, 36.5170059],
              [54.4958949, 36.5224634],
              [54.4910582, 36.5290731],
              [54.4899481, 36.5290731],
              [54.4893915, 36.528794],
              [54.4807816, 36.5268488],
              [54.4727251, 36.5257322],
              [54.4699484, 36.5257322],
              [54.4685585, 36.5254531],
              [54.4657784, 36.5251829],
              [54.4618918, 36.5251828],
              [54.4593919, 36.5249037],
              [54.4580019, 36.5251828],
              [54.436705, 36.5128061],
              [54.4319816, 36.5139141],
              [54.4314251, 36.5139141],
              [54.4122585, 36.511724],
              [54.3961454, 36.511724],
              [54.3950354, 36.5120032],
              [54.3836455, 36.5120031],
              [54.3830924, 36.511724],
              [54.3803123, 36.511724],
              [54.3792023, 36.5114448],
              [54.3775357, 36.5114448],
              [54.3734451, 36.5102939],
              [54.3444595, 36.5122222],
              [54.3419595, 36.511943],
              [54.3414028, 36.5116638],
              [54.3405695, 36.5116638],
              [54.3400162, 36.5113846],
              [54.3377929, 36.5113846],
              [54.3344595, 36.5105559],
              [54.3327929, 36.510556],
              [54.3311263, 36.5102768],
              [54.3258463, 36.5102767],
              [54.325013, 36.5099976],
              [54.3230697, 36.5099975],
              [54.3150131, 36.5086104],
              [54.3127897, 36.5086104],
              [54.3111232, 36.5083312],
              [54.3091799, 36.5083312],
              [54.3019566, 36.5074936],
              [54.2994566, 36.5074936],
              [54.2914, 36.506665],
              [54.2766769, 36.5066649],
              [54.2747335, 36.5063857],
              [54.2597338, 36.5063857],
              [54.2489006, 36.505548],
              [54.234454, 36.5049987],
              [54.2225074, 36.5049987],
              [54.2063842, 36.5088451],
              [54.2032262, 36.5088453],
              [54.2020733, 36.5088453],
              [54.2007506, 36.5088454],
              [54.1993511, 36.5088454],
              [54.1983021, 36.5088455],
              [54.1965468, 36.5085857],
              [54.1951303, 36.508376],
              [54.1936936, 36.5081633],
              [54.1920782, 36.5079241],
              [54.1905883, 36.5077036],
              [54.189106, 36.5074841],
              [54.1876265, 36.5072651],
              [54.1860666, 36.5070342],
              [54.1843423, 36.5067789],
              [54.1827294, 36.5065402],
              [54.1813369, 36.506334],
              [54.1795801, 36.5060739],
              [54.1789886, 36.5057919],
              [54.1779369, 36.5057919],
              [54.1762582, 36.505792],
              [54.1759101, 36.5056977],
              [54.1746296, 36.5053178],
              [54.1729727, 36.504826],
              [54.1721106, 36.5047405],
              [54.1707936, 36.5042344],
              [54.1701908, 36.5033492],
              [54.1700597, 36.5021057],
              [54.1688804, 36.5007357],
              [54.1630099, 36.4979536],
              [54.1588167, 36.4966046],
              [54.1540732, 36.4963727],
              [54.1486932, 36.4975881],
              [54.1465012, 36.4971818],
              [54.1041687, 36.4841652],
              [54.093059, 36.4788868],
              [54.0730592, 36.4719422],
              [54.0613791, 36.4688563],
              [54.0532813, 36.4590488],
              [54.0468223, 36.4455875],
              [54.0462657, 36.4453083],
              [54.0444564, 36.4446138],
              [54.0437658, 36.4444795],
              [54.0432125, 36.4442003],
              [54.033536, 36.4162916],
              [54.0252027, 36.413507],
              [54.0236202, 36.4134109],
              [54.005427, 36.4027964],
              [53.9924609, 36.4043407],
              [53.9871567, 36.4046775],
              [53.9838234, 36.4046775],
              [53.9832667, 36.4049569],
              [53.9796568, 36.4049568],
              [53.9788235, 36.4052272],
              [53.9777134, 36.4049569],
              [53.9763235, 36.4049569],
              [53.966047, 36.4027308],
              [53.9126928, 36.4032289],
              [53.9033888, 36.3919932],
              [53.8863943, 36.371954],
              [53.882532, 36.3633148],
              [53.885536, 36.3584074],
              [53.8987539, 36.3527392],
              [53.9188163, 36.3409097],
              [53.9317124, 36.3342115],
              [53.9566038, 36.3206579],
              [53.967335, 36.302558],
              [53.9701866, 36.291906],
              [53.9699934, 36.2834436],
              [53.9627836, 36.2751406],
              [53.9479122, 36.2675452],
              [53.9504204, 36.2642822],
              [53.9494206, 36.2618379],
              [53.9478756, 36.2601833],
              [53.9459015, 36.2578807],
              [53.9411747, 36.2525794],
              [53.9352965, 36.2480353],
              [53.9250181, 36.243858],
              [53.9135168, 36.2369354],
              [53.88707, 36.2237766],
              [53.8601138, 36.2133532],
              [53.8512323, 36.2081977],
              [53.8457552, 36.198635],
              [53.8380346, 36.1908982],
              [53.8289905, 36.1865184],
              [53.8209851, 36.1826056],
              [53.8155622, 36.1774271],
              [53.8068723, 36.1649287],
              [53.8022449, 36.1601574],
              [53.7906518, 36.1531735],
              [53.7859473, 36.1490848],
              [53.7765443, 36.1451998],
              [53.7666842, 36.1424764],
              [53.7613953, 36.1399947],
              [53.7556811, 36.138895],
              [53.7466851, 36.1355286],
              [53.7353324, 36.1325372],
              [53.7306749, 36.1298444],
              [53.7258362, 36.1259769],
              [53.7198227, 36.1238228],
              [53.7030601, 36.118741],
              [53.6767959, 36.1142342],
              [53.6590289, 36.1065373],
              [53.6523189, 36.1006872],
              [53.6506688, 36.0970745],
              [53.6458267, 36.0914855],
              [53.6401325, 36.0886239],
              [53.6390791, 36.0885863],
              [53.6377863, 36.0887792],
              [53.6364513, 36.0888897],
              [53.6348499, 36.0889227],
              [53.6336699, 36.0888969],
              [53.6321954, 36.0886769],
              [53.6298915, 36.0884549],
              [53.6278828, 36.0884044],
              [53.6264086, 36.0879432],
              [53.6252721, 36.0873463],
              [53.6228969, 36.0876507],
              [53.6225742, 36.0877664],
              [53.6216322, 36.0881042],
              [53.6196501, 36.0885825],
              [53.6175005, 36.0889314],
              [53.6148016, 36.0896911],
              [53.6147427, 36.0896842],
              [53.6137203, 36.0895638],
              [53.6124856, 36.0887255],
              [53.6106327, 36.0879322],
              [53.608751, 36.0875045],
              [53.6066446, 36.0871223],
              [53.6046504, 36.0869246],
              [53.6029358, 36.0870813],
              [53.6013489, 36.0870887],
              [53.5977505, 36.0877436],
              [53.5955166, 36.0879566],
              [53.5934928, 36.0882933],
              [53.5913845, 36.0888031],
              [53.5897678, 36.0892797],
              [53.5884188, 36.0895184],
              [53.586312, 36.0892733],
              [53.5843456, 36.0889485],
              [53.582323, 36.0888163],
              [53.5799771, 36.0887069],
              [53.5763521, 36.0888931],
              [53.5745684, 36.088785],
              [53.5722084, 36.0887343],
              [53.5704108, 36.0884102],
              [53.5684595, 36.0879924],
              [53.5666194, 36.0878155],
              [53.5651298, 36.0880412],
              [53.5638787, 36.0883474],
              [53.5625012, 36.088458],
              [53.5580204, 36.088218],
              [53.554565, 36.0879448],
              [53.552921, 36.0880542],
              [53.5511934, 36.0880505],
              [53.550016, 36.0870278],
              [53.5470294, 36.0848921],
              [53.5454312, 36.0839054],
              [53.5438866, 36.0835236],
              [53.5418936, 36.0831175],
              [53.5405454, 36.0829523],
              [53.5390276, 36.0829935],
              [53.5373424, 36.0829436],
              [53.5360227, 36.0825615],
              [53.5349712, 36.0819754],
              [53.5334578, 36.080554],
              [53.5323226, 36.0798637],
              [53.5303713, 36.079434],
              [53.5278863, 36.0787857],
              [53.5268202, 36.0783035],
              [53.5253344, 36.0773254],
              [53.5240162, 36.0767042],
              [53.5230195, 36.0763917],
              [53.5191989, 36.0764609],
              [53.5173718, 36.0768102],
              [53.5162474, 36.0769105],
              [53.5157293, 36.0764617],
              [53.5133597, 36.0750941],
              [53.5119419, 36.074849],
              [53.5098776, 36.0745925],
              [53.5076179, 36.074036],
              [53.5033262, 36.0721564],
              [53.5020919, 36.0715467],
              [53.500717, 36.0711203],
              [53.4990026, 36.0711268],
              [53.498526, 36.0710849],
              [53.4975455, 36.0714997],
              [53.4965134, 36.0717555],
              [53.4953071, 36.0722268],
              [53.4942895, 36.0729848],
              [53.4922456, 36.0748187],
              [53.4914197, 36.075762],
              [53.4909191, 36.0766107],
              [53.4901085, 36.0775086],
              [53.4893201, 36.0780995],
              [53.4885817, 36.0784056],
              [53.4866772, 36.0787042],
              [53.4828351, 36.0789574],
              [53.4809439, 36.0787758],
              [53.4780592, 36.0778936],
              [53.4773561, 36.0774034],
              [53.476712, 36.0768219],
              [53.4758662, 36.0764067],
              [53.4743359, 36.0758457],
              [53.4734714, 36.0750772],
              [53.4724618, 36.0745009],
              [53.4713296, 36.0742877],
              [53.4700321, 36.0744699],
              [53.4685118, 36.0746049],
              [53.4673047, 36.0745712],
              [53.4648097, 36.074893],
              [53.461092, 36.0747035],
              [53.4579124, 36.0748995],
              [53.4568859, 36.0754523],
              [53.4559759, 36.0763588],
              [53.4549891, 36.0770032],
              [53.4538792, 36.0775307],
              [53.4522649, 36.0774804],
              [53.4485929, 36.0771769],
              [53.4480186, 36.0773525],
              [53.447085, 36.077399],
              [53.4442405, 36.0773102],
              [53.4425107, 36.0770685],
              [53.4415977, 36.077078],
              [53.4400225, 36.0768302],
              [53.4387853, 36.0765455],
              [53.4375008, 36.0763844],
              [53.4367259, 36.0761231],
              [53.4358428, 36.0761114],
              [53.4305672, 36.0771359],
              [53.427861, 36.0763974],
              [53.4266345, 36.0762061],
              [53.4236164, 36.0762265],
              [53.4189566, 36.0772894],
              [53.417354, 36.0773711],
              [53.4123718, 36.0761522],
              [53.4094107, 36.0745566],
              [53.4050333, 36.0722499],
              [53.3936178, 36.0674282],
              [53.3857858, 36.0643408],
              [53.383404, 36.0630919],
              [53.3788335, 36.0623287],
              [53.3773409, 36.0617712],
              [53.3754432, 36.0610625],
              [53.3688771, 36.058634],
              [53.3648431, 36.0566738],
              [53.3592641, 36.0568299],
              [53.3558952, 36.0550431],
              [53.3536851, 36.0539849],
              [53.349694, 36.050151],
              [53.3483153, 36.0493307],
              [53.3469005, 36.0484889],
              [53.3447372, 36.0472017],
              [53.3407461, 36.0449462],
              [53.3373773, 36.0438185],
              [53.3352744, 36.0415283],
              [53.3326566, 36.040574],
              [53.32785, 36.037017],
              [53.3262193, 36.0354901],
              [53.3246529, 36.0338763],
              [53.323065, 36.0312908],
              [53.3173358, 36.0292084],
              [53.313173, 36.0263625],
              [53.3100831, 36.0241759],
              [53.308345, 36.0216942],
              [53.2994615, 36.0160189],
              [53.2862865, 36.0104474],
              [53.2741543, 36.0016722],
              [53.2635751, 35.9933154],
              [53.2246855, 35.9680443],
              [53.2246856, 35.9674855],
              [53.2232955, 35.9660976],
              [53.223375, 35.9655388],
              [53.2235722, 35.9641508],
              [53.2246856, 35.9591489],
              [53.2249622, 35.9580402],
              [53.2455284, 35.9316373],
              [53.2458051, 35.9310874],
              [53.2480283, 35.923019],
              [53.245805, 35.9141301],
              [53.2408051, 35.9099652],
              [53.2380251, 35.9085768],
              [53.2349719, 35.9077474],
              [53.2338585, 35.9077473],
              [53.2333052, 35.907468],
              [53.2321918, 35.907468],
              [53.2302486, 35.9069091],
              [53.2026988, 35.9091427],
              [53.1850458, 35.9133158],
              [53.1792126, 35.9133159],
              [53.1781025, 35.9130274],
              [53.1736559, 35.9135863],
              [53.170046, 35.9135863],
              [53.1678226, 35.9138657],
              [53.1644895, 35.9138657],
              [53.161156, 35.9141452],
              [53.1592128, 35.9138657],
              [53.1567129, 35.9138658],
              [53.1385699, 35.9197082],
              [53.1349565, 35.9197082],
              [53.1341232, 35.9197082],
              [53.1330134, 35.9197082],
              [53.1324566, 35.9194288],
              [53.1285701, 35.9194288],
              [53.1274566, 35.9197082],
              [53.1205134, 35.9197082],
              [53.1191234, 35.9194288],
              [53.1166235, 35.9194287],
              [53.1149568, 35.9191494],
              [53.1124569, 35.9191493],
              [53.108567, 35.9188699],
              [53.107457, 35.9191494],
              [53.1041237, 35.91887],
              [53.1032903, 35.9191494],
              [53.1019003, 35.9191493],
              [53.1015565, 35.9190917],
              [53.1002336, 35.91887],
              [53.097457, 35.9188699],
              [53.0938437, 35.9183201],
              [53.0905105, 35.9183202],
              [53.0874537, 35.9177614],
              [53.0844205, 35.9177614],
              [53.0780106, 35.9177613],
              [53.0763439, 35.917482],
              [53.0744006, 35.917482],
              [53.0649541, 35.9149853],
              [53.0504237, 35.8905439],
              [53.0465337, 35.8855415],
              [53.0482004, 35.8794305],
              [53.0484805, 35.8785922],
              [53.0482004, 35.8713725],
              [53.0470905, 35.8677671],
              [53.0174514, 35.8535946],
              [53.018008, 35.8530357],
              [53.0202313, 35.8516477],
              [53.021898, 35.8499801],
              [53.0221746, 35.8491508],
              [53.0221746, 35.8483126],
              [53.0221745, 35.8480331],
              [53.0216179, 35.8449774],
              [53.0205078, 35.8355399],
              [53.0318978, 35.8266521],
              [53.0330078, 35.8263727],
              [53.0410644, 35.8221993],
              [53.0471743, 35.8199818],
              [53.0485643, 35.8199818],
              [53.0499543, 35.8197024],
              [53.0566209, 35.8191436],
              [53.0580109, 35.819432],
              [53.0585641, 35.8191435],
              [53.0602307, 35.8194319],
              [53.0652308, 35.819432],
              [53.0657875, 35.8191435],
              [53.0766207, 35.8183142],
              [53.0807873, 35.8183142],
              [53.0816206, 35.8180348],
              [53.0830106, 35.8183142],
              [53.0846771, 35.8185937],
              [53.0855106, 35.8185937],
              [53.0891205, 35.8191436],
              [53.0913438, 35.8191435],
              [53.0938437, 35.8197024],
              [53.0971771, 35.8197024],
              [53.0980104, 35.8199818],
              [53.1052337, 35.8199818],
              [53.107457, 35.8202523],
              [53.1180136, 35.8202523],
              [53.1199568, 35.8205407],
              [53.1285701, 35.8205406],
              [53.1394032, 35.8180348],
              [53.1399566, 35.8183142],
              [53.1410699, 35.8177554],
              [53.1532932, 35.8113644],
              [53.1560697, 35.8077587],
              [53.1566264, 35.8055322],
              [53.1563464, 35.8052618],
              [53.1569031, 35.8038645],
              [53.1560698, 35.7960943],
              [53.1546798, 35.7941472],
              [53.1527365, 35.7919297],
              [53.1482932, 35.7894237],
              [53.1469033, 35.7888739],
              [53.13329, 35.7847001],
              [53.1099569, 35.772756],
              [53.0969005, 35.7555382],
              [53.0944005, 35.7499851],
              [53.0938438, 35.7496967],
              [53.0932904, 35.7488673],
              [53.0880105, 35.744982],
              [53.0655109, 35.7349755],
              [53.0649541, 35.7347051],
              [53.0626664, 35.7333319],
              [53.0555043, 35.7262102],
              [53.0537982, 35.7249015],
              [53.0528843, 35.7236171],
              [53.0501364, 35.7226807],
              [53.0482405, 35.720593],
              [53.0450542, 35.7186159],
              [53.0396417, 35.7173855],
              [53.0345465, 35.7157818],
              [53.0294194, 35.7107269],
              [53.0260515, 35.7086249],
              [53.0236118, 35.7059191],
              [53.0124514, 35.7008087],
              [53.001895, 35.6833102],
              [53.0010616, 35.6827602],
              [52.999675, 35.6813629],
              [52.995785, 35.6788656],
              [52.9952283, 35.6785861],
              [52.9846717, 35.6727532],
              [52.9752286, 35.6699764],
              [52.9743952, 35.6694265],
              [52.9296691, 35.6555337],
              [52.9291158, 35.6549747],
              [52.9263359, 35.6541452],
              [52.9143926, 35.6497006],
              [52.8991128, 35.6419201],
              [52.8857797, 35.6322011],
              [52.8846697, 35.6313716],
              [52.8771663, 35.6260885],
              [52.8299438, 35.5810896],
              [52.8291104, 35.579701],
              [52.8227204, 35.572479],
              [52.8024406, 35.5508037],
              [52.8021641, 35.5505331],
              [52.801054, 35.5494151],
              [52.7943875, 35.5459445],
              [52.7932741, 35.545529],
              [52.7929974, 35.5452495],
              [52.7821642, 35.5410839],
              [52.7788309, 35.5410839],
              [52.7768843, 35.5416429],
              [52.7668843, 35.5469175],
              [52.7660511, 35.5469175],
              [52.7343849, 35.5533102],
              [52.7277148, 35.5555282],
              [52.7266049, 35.5555282],
              [52.7260482, 35.5552487],
              [52.725495, 35.5555282],
              [52.7163284, 35.5555282],
              [52.715215, 35.5552487],
              [52.7132718, 35.5552487],
              [52.7121583, 35.5549692],
              [52.7085484, 35.5544192],
              [52.7077151, 35.5544192],
              [52.6977153, 35.5519216],
              [52.6727122, 35.5391362],
              [52.6696589, 35.5369182],
              [52.6674356, 35.5358092],
              [52.6671589, 35.5352501],
              [52.6599357, 35.5294163],
              [52.6596591, 35.5285868],
              [52.6591023, 35.5283073],
              [52.6377126, 35.5083082],
              [52.634656, 35.5038628],
              [52.6338227, 35.5027448],
              [52.6152095, 35.4724748],
              [52.6115996, 35.4674702],
              [52.6082664, 35.4641428],
              [52.6071564, 35.4624657],
              [52.6063231, 35.4619156],
              [52.5629869, 35.4174689],
              [52.555207, 35.4119141],
              [52.5513204, 35.4099663],
              [52.5502071, 35.4091366],
              [52.5363172, 35.4016339],
              [52.5349306, 35.4013544],
              [52.5340973, 35.4008043],
              [52.5327073, 35.4005247],
              [52.5318739, 35.3999656],
              [52.5310407, 35.3999656],
              [52.5302073, 35.3994155],
              [52.5246748, 35.397823],
              [52.5232607, 35.3974677],
              [52.5227074, 35.3971882],
              [52.5210407, 35.3969177],
              [52.5188174, 35.396079],
              [52.5171509, 35.3957995],
              [52.499651, 35.3869169],
              [52.4957611, 35.3863578],
              [52.4949278, 35.3860782],
              [52.4935377, 35.3860782],
              [52.4218687, 35.3660765],
              [52.4104788, 35.3585825],
              [52.4085355, 35.3569142],
              [52.4001154, 35.3507378],
              [52.3829791, 35.3380212],
              [52.3801991, 35.337462],
              [52.3790892, 35.3374621],
              [52.3785325, 35.3377506],
              [52.3688092, 35.3410783],
              [52.3601994, 35.3474632],
              [52.3451995, 35.3610805],
              [52.3401997, 35.3660764],
              [52.3331994, 35.3749235],
              [52.3326963, 35.3755273],
              [52.324363, 35.3860782],
              [52.2810271, 35.4255273],
              [52.2807503, 35.4258009],
              [52.27692, 35.4282479],
              [52.2576937, 35.4405264],
              [52.2568606, 35.4405265],
              [52.254084, 35.4416356],
              [52.2521372, 35.4421946],
              [52.2515839, 35.4421946],
              [52.2374141, 35.445531],
              [52.2143577, 35.4488584],
              [52.2121377, 35.4488584],
              [52.2060245, 35.449697],
              [52.2029677, 35.449697],
              [52.2021344, 35.4499675],
              [52.1968579, 35.4505266],
              [52.169601, 35.4561513],
              [52.1496353, 35.4602472],
              [52.1299753, 35.4611969],
              [52.1264953, 35.4585216],
              [52.1177488, 35.4555851],
              [52.0764298, 35.4509236],
              [52.0689299, 35.4537018],
              [52.0511501, 35.4589783],
              [52.0500402, 35.4589783],
              [52.0296149, 35.4776577],
              [52.027115, 35.4787669],
              [52.017115, 35.4868295],
              [52.003967, 35.5060285],
              [52.0056003, 35.5169627],
              [52.0056003, 35.5183514],
              [52.0096592, 35.5282986],
              [52.0117525, 35.5392061],
              [52.0096267, 35.5488646],
              [51.9935134, 35.5685834],
              [51.9857369, 35.575526],
              [51.9804602, 35.577194],
              [51.979347, 35.577194],
              [51.972957, 35.5785825],
              [51.9704571, 35.5785825],
              [51.9696237, 35.5785825],
              [51.9693471, 35.578312],
              [51.9662904, 35.578312],
              [51.9657371, 35.5785825],
              [51.9629571, 35.5785825],
              [51.9604572, 35.5785825],
              [51.9579572, 35.5780235],
              [51.9365676, 35.5616408],
              [51.9357341, 35.5616408],
              [51.9296242, 35.5585843],
              [51.9243442, 35.548585],
              [51.923511, 35.5458079],
              [51.9229577, 35.5374767],
              [51.9229577, 35.5355292],
              [51.921011, 35.5099668],
              [51.9212911, 35.5085782],
              [51.921011, 35.5080282],
              [51.9212911, 35.5055305],
              [51.9215677, 35.5035829],
              [51.9286453, 35.490324],
              [51.9289218, 35.4889353],
              [51.929202, 35.4883853],
              [51.929202, 35.4880967],
              [51.9257344, 35.4810856],
              [51.9260109, 35.4799675],
              [51.9257344, 35.4794175],
              [51.9257344, 35.4763606],
              [51.9254578, 35.4708061],
              [51.9251778, 35.4702471],
              [51.9196211, 35.4480285],
              [51.9190678, 35.4471991],
              [51.9176778, 35.4413558],
              [51.9135113, 35.4255302],
              [51.9135114, 35.4241415],
              [51.9129545, 35.4224732],
              [51.9119893, 35.4143066],
              [51.9209319, 35.4047028],
              [51.9231206, 35.4000854],
              [51.9242793, 35.3949219],
              [51.9253093, 35.38176],
              [51.9243566, 35.3698347],
              [51.9297557, 35.3679098],
              [51.9392057, 35.3649071],
              [51.952724, 35.3603924],
              [51.9593158, 35.3584395],
              [51.9646716, 35.3576205],
              [51.9718557, 35.3560875],
              [51.9706455, 35.3549955],
              [51.9694095, 35.3537774],
              [51.9676071, 35.3526014],
              [51.9671178, 35.3516353],
              [51.9664998, 35.3500392],
              [51.9661394, 35.348569],
              [51.9655214, 35.3478129],
              [51.9641567, 35.3463217],
              [51.962998, 35.3446835],
              [51.962998, 35.3433813],
              [51.9629722, 35.3424361],
              [51.9629722, 35.34168],
              [51.9632297, 35.3401677],
              [51.9628177, 35.3395375],
              [51.9625345, 35.3377311],
              [51.9616332, 35.3355046],
              [51.9607578, 35.3345593],
              [51.960217, 35.333572],
              [51.9593673, 35.3323536],
              [51.9593673, 35.3315134],
              [51.9586978, 35.3311563],
              [51.9579769, 35.3307151],
              [51.9567409, 35.3295387],
              [51.9558654, 35.3287825],
              [51.9554019, 35.3279422],
              [51.9554019, 35.3271859],
              [51.9555307, 35.3267237],
              [51.9555307, 35.3261355],
              [51.9550929, 35.3253792],
              [51.9543977, 35.3244758],
              [51.9535222, 35.3235094],
              [51.9498144, 35.3215346],
              [51.9494281, 35.3209043],
              [51.9491706, 35.320337],
              [51.9476772, 35.3190344],
              [51.9471364, 35.318215],
              [51.946261, 35.3176268],
              [51.9452825, 35.3162401],
              [51.9443555, 35.3156938],
              [51.9436603, 35.3134876],
              [51.9413686, 35.3121009],
              [51.9359957, 35.3126593],
              [51.932262, 35.3128064],
              [51.9043448, 35.3180273],
              [51.9024015, 35.3152496],
              [51.8976783, 35.3094148],
              [51.8846339, 35.2955786],
              [51.867592, 35.2777152],
              [51.8678688, 35.2763263],
              [51.8681487, 35.2749373],
              [51.868702, 35.2727096],
              [51.8689821, 35.2721594],
              [51.869169, 35.2709737],
              [51.8692586, 35.2702112],
              [51.8695355, 35.2699317],
              [51.8770353, 35.2516048],
              [51.8789819, 35.2490975],
              [51.8792587, 35.2485472],
              [51.8953718, 35.2307702],
              [51.9328714, 35.1779876],
              [51.9334282, 35.176319],
              [51.9417613, 35.1613189],
              [51.9431513, 35.1579815],
              [51.9464847, 35.1521547],
              [51.9467612, 35.1515954],
              [51.9478745, 35.150486],
              [51.9500945, 35.1474282],
              [51.9637077, 35.1365951],
              [51.9645411, 35.1360359],
              [52.0025974, 35.1132599],
              [52.0298238, 35.087146],
              [52.0309338, 35.0854772],
              [52.0320438, 35.0829785],
              [52.0323237, 35.0826989],
              [52.0378768, 35.0693666],
              [52.0381569, 35.0688163],
              [52.0387103, 35.065199],
              [52.0389904, 35.0607609],
              [52.039267, 35.0524257],
              [52.0395435, 35.0482492],
              [52.0398237, 35.0463098],
              [52.035657, 35.0118681],
              [52.0320438, 34.9996445],
              [52.0309338, 34.9965863],
              [52.0215739, 34.9677388],
              [52.0212938, 34.9671794],
              [52.0015707, 34.9185647],
              [51.9987942, 34.9149561],
              [51.9985176, 34.9146855],
              [51.985181, 34.896345],
              [51.9785145, 34.8838502],
              [51.9774045, 34.8824519],
              [51.9768479, 34.8810717],
              [51.9699045, 34.8718967],
              [51.9696244, 34.871617],
              [51.9654579, 34.8657891],
              [51.9649046, 34.8652387],
              [51.9590713, 34.8580124],
              [51.9504581, 34.8343934],
              [51.9487915, 34.8257865],
              [51.9401818, 34.7955087],
              [51.9390683, 34.7846731],
              [51.9379583, 34.776896],
              [51.9376784, 34.7763456],
              [51.9343568, 34.7593378],
              [51.9329584, 34.7521748],
              [51.9279585, 34.7335616],
              [51.9176787, 34.704951],
              [51.9157355, 34.7010622],
              [51.9143454, 34.6969028],
              [51.9135122, 34.6955133],
              [51.8885126, 34.635511],
              [51.8848992, 34.6291226],
              [51.8619819, 34.5833108],
              [51.8557255, 34.5736958],
              [51.8503768, 34.5678171],
              [51.8403823, 34.5680611],
              [51.8412099, 34.5548442],
              [51.8407554, 34.5329227],
              [51.839545, 34.5237742],
              [51.8387866, 34.5230069],
              [51.83712, 34.5163384],
              [51.8360101, 34.5121695],
              [51.8351766, 34.5105],
              [51.8348966, 34.5099496],
              [51.8337865, 34.5082802],
              [51.8335099, 34.5071703],
              [51.8337865, 34.5068905],
              [51.8341678, 34.5059559]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241475,
        "tags": {
          "ISO3166-2": "IR-10",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "اصفهان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q1367759"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [49.6498081, 32.9717615],
              [49.6500226, 32.9700494],
              [49.6498319, 32.9688363],
              [49.6498418, 32.9672634],
              [49.6518802, 32.965626],
              [49.6533512, 32.9636742],
              [49.6550773, 32.9443491],
              [49.6559105, 32.9432385],
              [49.6581336, 32.9385162],
              [49.6584106, 32.9374057],
              [49.6586902, 32.936575],
              [49.6589672, 32.9326834],
              [49.6614668, 32.9299115],
              [49.662577, 32.9299114],
              [49.662577, 32.9296316],
              [49.6634102, 32.9296315],
              [49.6636903, 32.9293516],
              [49.6642435, 32.9293517],
              [49.6650771, 32.9279612],
              [49.6659103, 32.9254601],
              [49.6667435, 32.9240786],
              [49.6673002, 32.9232389],
              [49.6706335, 32.9210177],
              [49.6714671, 32.9210177],
              [49.6761902, 32.9162955],
              [49.6775801, 32.9137944],
              [49.6781336, 32.9135145],
              [49.6785358, 32.9127921],
              [49.6809134, 32.9085214],
              [49.6803568, 32.9024085],
              [49.6809134, 32.9015689],
              [49.6809133, 32.9007381],
              [49.6814669, 32.9001873],
              [49.6823002, 32.8990767],
              [49.6867467, 32.8971265],
              [49.6881335, 32.8971264],
              [49.6881335, 32.8968466],
              [49.7000799, 32.8937947],
              [49.7028564, 32.8932439],
              [49.7031365, 32.892964],
              [49.7036901, 32.892964],
              [49.70369, 32.8926841],
              [49.7042467, 32.8926841],
              [49.7061896, 32.8912936],
              [49.7128598, 32.8846301],
              [49.71397, 32.8840702],
              [49.7189696, 32.8804676],
              [49.7195264, 32.8799078],
              [49.7200798, 32.8799078],
              [49.7203596, 32.8796279],
              [49.7217462, 32.8796279],
              [49.7284128, 32.8760162],
              [49.7295261, 32.8760162],
              [49.7323028, 32.8749056],
              [49.740083, 32.8646303],
              [49.7461929, 32.8590773],
              [49.7473027, 32.8579577],
              [49.7486925, 32.8557365],
              [49.7489726, 32.8549058],
              [49.7495262, 32.8535154],
              [49.7492492, 32.8524048],
              [49.7448026, 32.8435199],
              [49.7439695, 32.8407389],
              [49.743693, 32.8340753],
              [49.7439695, 32.8332446],
              [49.7442495, 32.8329647],
              [49.7453593, 32.8299038],
              [49.7453594, 32.8257412],
              [49.7453594, 32.8251815],
              [49.7439694, 32.8210099],
              [49.7370264, 32.8143463],
              [49.7359162, 32.8118542],
              [49.7359162, 32.8115743],
              [49.7352067, 32.8098742],
              [49.7350831, 32.809344],
              [49.7331365, 32.8082425],
              [49.7317497, 32.8082425],
              [49.7317497, 32.8079626],
              [49.7314696, 32.8076826],
              [49.7317497, 32.8071318],
              [49.7317497, 32.8068519],
              [49.7317498, 32.806572],
              [49.7323028, 32.8057323],
              [49.7528597, 32.7762968],
              [49.7528596, 32.7760168],
              [49.7531397, 32.775737],
              [49.767306, 32.7640711],
              [49.7764726, 32.7596287],
              [49.7773058, 32.7596287],
              [49.7775824, 32.7593487],
              [49.7831391, 32.7593487],
              [49.7834157, 32.7596287],
              [49.7850826, 32.7596287],
              [49.7856392, 32.7599086],
              [49.7906389, 32.7604594],
              [49.7911956, 32.7601794],
              [49.7942522, 32.7599086],
              [49.7945289, 32.7596287],
              [49.7950854, 32.7596286],
              [49.7953624, 32.7593488],
              [49.8011954, 32.7557371],
              [49.8125855, 32.7446219],
              [49.8267517, 32.7396287],
              [49.853975, 32.7187889],
              [49.8553648, 32.7182382],
              [49.8556414, 32.7179583],
              [49.8875878, 32.7021208],
              [49.8962012, 32.6979583],
              [49.8995345, 32.6918454],
              [49.8995346, 32.6910147],
              [49.9006444, 32.6885136],
              [49.9009244, 32.6879628],
              [49.9009244, 32.687403],
              [49.9028678, 32.6837912],
              [49.9037011, 32.6829605],
              [49.9039777, 32.6821207],
              [49.9120345, 32.6765677],
              [49.9350907, 32.6676738],
              [49.9503704, 32.6579581],
              [49.9662036, 32.6443508],
              [49.96648, 32.6440709],
              [49.9800229, 32.6359868],
              [49.9823168, 32.6346172],
              [49.9853699, 32.6337864],
              [49.9859266, 32.6332357],
              [49.9864833, 32.6332357],
              [50.00065, 32.6285134],
              [50.0017597, 32.6285133],
              [50.0023164, 32.6282334],
              [50.00315, 32.6282334],
              [50.0034265, 32.6279535],
              [50.0175964, 32.6276826],
              [50.0181495, 32.6279535],
              [50.0198163, 32.6279535],
              [50.0200964, 32.6282334],
              [50.0212062, 32.6282334],
              [50.0242628, 32.6287933],
              [50.024816, 32.6287933],
              [50.0289829, 32.6290642],
              [50.0348194, 32.6287932],
              [50.0353728, 32.6285133],
              [50.0370394, 32.6285133],
              [50.0392628, 32.6279536],
              [50.0420394, 32.6274028],
              [50.0445391, 32.6274027],
              [50.0448191, 32.6276826],
              [50.0589858, 32.6304547],
              [50.0744293, 32.6390062],
              [50.0745424, 32.6390688],
              [50.0837085, 32.6415699],
              [50.0848187, 32.64157],
              [50.0870418, 32.6421207],
              [50.0892654, 32.6421207],
              [50.0895419, 32.6424007],
              [50.0909322, 32.6424007],
              [50.092322, 32.6429605],
              [50.0928752, 32.6429605],
              [50.0939885, 32.6435113],
              [50.0948221, 32.6435113],
              [50.096765, 32.644351],
              [50.0992651, 32.6449019],
              [50.1034316, 32.6462924],
              [50.1153782, 32.6529561],
              [50.1253781, 32.6604505],
              [50.131768, 32.6632316],
              [50.1326013, 32.6632316],
              [50.1339881, 32.6637914],
              [50.1420444, 32.664902],
              [50.1456578, 32.6651729],
              [50.1464914, 32.664902],
              [50.1484344, 32.664902],
              [50.148991, 32.6646222],
              [50.1501012, 32.6646221],
              [50.1506579, 32.6643422],
              [50.151491, 32.6643422],
              [50.1523243, 32.6640623],
              [50.1537111, 32.6637915],
              [50.1659343, 32.6579585],
              [50.1859421, 32.6424801],
              [50.1951801, 32.6332621],
              [50.2093361, 32.6209472],
              [50.2170825, 32.6148066],
              [50.2260489, 32.6057079],
              [50.2351236, 32.5960466],
              [50.2410617, 32.5874328],
              [50.241432, 32.5837648],
              [50.2497005, 32.5739057],
              [50.2546094, 32.5642059],
              [50.2585887, 32.5641035],
              [50.2641548, 32.562877],
              [50.2698578, 32.5623535],
              [50.2870232, 32.5501633],
              [50.2895633, 32.5486018],
              [50.3040388, 32.5407153],
              [50.313585, 32.5379933],
              [50.3153859, 32.5371178],
              [50.3218149, 32.533818],
              [50.3249725, 32.5312445],
              [50.3264907, 32.5277062],
              [50.3314292, 32.5342874],
              [50.3349928, 32.5344126],
              [50.3453697, 32.5396833],
              [50.3508231, 32.543843],
              [50.3549229, 32.5473146],
              [50.3599306, 32.5482704],
              [50.3657366, 32.5488688],
              [50.3645037, 32.5520928],
              [50.3666567, 32.5550965],
              [50.3728188, 32.5609784],
              [50.3725218, 32.5644198],
              [50.3756399, 32.564983],
              [50.3767535, 32.5681114],
              [50.3810596, 32.5696755],
              [50.3832868, 32.5731166],
              [50.3892261, 32.5739299],
              [50.3952527, 32.573377],
              [50.4029608, 32.572491],
              [50.4109071, 32.5685561],
              [50.4125261, 32.5664544],
              [50.4141883, 32.5652963],
              [50.4219774, 32.5681998],
              [50.4311348, 32.5731291],
              [50.4342776, 32.5741551],
              [50.4357862, 32.5758937],
              [50.4490742, 32.581136],
              [50.4588322, 32.5848802],
              [50.4630538, 32.5877533],
              [50.4712272, 32.5890734],
              [50.4766204, 32.589905],
              [50.4828217, 32.5903938],
              [50.4892956, 32.5907794],
              [50.4943811, 32.5929429],
              [50.4987431, 32.5995428],
              [50.4994448, 32.6085367],
              [50.5017168, 32.6168224],
              [50.5036752, 32.6241214],
              [50.504146, 32.6257208],
              [50.504708, 32.6277127],
              [50.5048772, 32.6307843],
              [50.5043624, 32.6323653],
              [50.5042696, 32.6357422],
              [50.5047512, 32.638363],
              [50.5009486, 32.6437099],
              [50.4956077, 32.6448924],
              [50.4829785, 32.6457596],
              [50.4842836, 32.6474035],
              [50.4826167, 32.6471236],
              [50.4787268, 32.6471235],
              [50.4784503, 32.6468437],
              [50.4709501, 32.6465728],
              [50.4703934, 32.6468436],
              [50.4678938, 32.6468437],
              [50.4676168, 32.6471236],
              [50.4670602, 32.6471236],
              [50.4667837, 32.6471236],
              [50.466227, 32.6471236],
              [50.4654338, 32.6475224],
              [50.4651137, 32.6476835],
              [50.4601135, 32.6504555],
              [50.4600501, 32.6505929],
              [50.458447, 32.6540672],
              [50.4581706, 32.6546271],
              [50.4584471, 32.6599002],
              [50.4581705, 32.6607308],
              [50.458447, 32.6612907],
              [50.4620605, 32.6712863],
              [50.4695602, 32.6818417],
              [50.4767833, 32.6887942],
              [50.4784502, 32.6907356],
              [50.4940063, 32.7035121],
              [50.4973628, 32.705088],
              [50.5087926, 32.710453],
              [50.5095529, 32.7108099],
              [50.5159457, 32.7138098],
              [50.5200427, 32.7157321],
              [50.5212295, 32.7162888],
              [50.5220627, 32.7162888],
              [50.5266062, 32.7178068],
              [50.5270627, 32.7179593],
              [50.5280973, 32.7179592],
              [50.5281726, 32.7179592],
              [50.528708, 32.7180491],
              [50.5288346, 32.7180704],
              [50.5298394, 32.7182392],
              [50.529994, 32.7182703],
              [50.5302404, 32.7183199],
              [50.5312292, 32.7185191],
              [50.5317835, 32.7186544],
              [50.5323391, 32.71879],
              [50.5330615, 32.71879],
              [50.5334832, 32.71879],
              [50.5342859, 32.71879],
              [50.5342859, 32.7190698],
              [50.5373392, 32.7190699],
              [50.5373391, 32.7193498],
              [50.5381724, 32.7193498],
              [50.5384525, 32.7190699],
              [50.5409526, 32.7190698],
              [50.5423806, 32.7182429],
              [50.5451313, 32.7166501],
              [50.5498848, 32.7138973],
              [50.5526263, 32.7096555],
              [50.550751, 32.7015785],
              [50.5539533, 32.6942549],
              [50.5504524, 32.6904529],
              [50.548673, 32.6799061],
              [50.5554232, 32.6751534],
              [50.5622097, 32.6883087],
              [50.5613247, 32.6734644],
              [50.5626951, 32.6730437],
              [50.565016, 32.6723313],
              [50.5717563, 32.6867198],
              [50.5788785, 32.6912385],
              [50.5871804, 32.6840568],
              [50.6023914, 32.6869434],
              [50.6058001, 32.6932115],
              [50.6147584, 32.6878983],
              [50.6181914, 32.6935492],
              [50.628897, 32.6978593],
              [50.6346592, 32.7015252],
              [50.6428126, 32.7053236],
              [50.664701, 32.707094],
              [50.6725323, 32.7078661],
              [50.6878443, 32.7044672],
              [50.6947619, 32.706669],
              [50.703063, 32.7051584],
              [50.7116515, 32.7005607],
              [50.7155032, 32.7060378],
              [50.7301267, 32.7068534],
              [50.7351266, 32.7087947],
              [50.7365165, 32.7087947],
              [50.7370732, 32.7090746],
              [50.7412398, 32.7093455],
              [50.7417932, 32.7090746],
              [50.7440165, 32.7090746],
              [50.7445732, 32.7087947],
              [50.7459597, 32.7087947],
              [50.7462397, 32.7085148],
              [50.7467931, 32.7085147],
              [50.7523497, 32.7065735],
              [50.7529063, 32.7062935],
              [50.7565163, 32.704903],
              [50.7567964, 32.7043433],
              [50.7573495, 32.7043432],
              [50.7598496, 32.7029618],
              [50.7606828, 32.7029617],
              [50.7606827, 32.7026818],
              [50.7670728, 32.7004606],
              [50.7684628, 32.7004606],
              [50.7690195, 32.7001807],
              [50.7701294, 32.7001806],
              [50.7758574, 32.7034038],
              [50.7757181, 32.6982757],
              [50.7763381, 32.6966415],
              [50.7778747, 32.6968401],
              [50.7798194, 32.6972012],
              [50.7899403, 32.7007764],
              [50.7945759, 32.7040724],
              [50.8123522, 32.7079641],
              [50.8290221, 32.711296],
              [50.8317987, 32.7112959],
              [50.8345753, 32.7112959],
              [50.8354085, 32.711016],
              [50.8429085, 32.711016],
              [50.8431885, 32.7112959],
              [50.8459652, 32.7115668],
              [50.8512451, 32.7115669],
              [50.8523551, 32.7121267],
              [50.8529117, 32.7118467],
              [50.8551317, 32.711296],
              [50.8570782, 32.7112959],
              [50.8576316, 32.711016],
              [50.8592983, 32.7110161],
              [50.8595783, 32.7107361],
              [50.8604115, 32.7107362],
              [50.8626351, 32.7101853],
              [50.8640216, 32.7101853],
              [50.8648548, 32.7099055],
              [50.8662448, 32.7099054],
              [50.8723547, 32.7076842],
              [50.8731882, 32.7068535],
              [50.8737448, 32.7068535],
              [50.8737447, 32.7065736],
              [50.887358, 32.6962892],
              [50.8873579, 32.6957384],
              [50.8879113, 32.6951786],
              [50.8895779, 32.6915758],
              [50.889858, 32.6904652],
              [50.8901346, 32.6901853],
              [50.8901346, 32.6896255],
              [50.8919712, 32.6878871],
              [50.8996349, 32.6750001],
              [50.9122744, 32.6666371],
              [50.9165393, 32.6611992],
              [50.9187833, 32.6550611],
              [50.920456, 32.6500763],
              [50.9214384, 32.6475578],
              [50.9218042, 32.6440722],
              [50.9220618, 32.6385581],
              [50.9215851, 32.6279547],
              [50.9226377, 32.6246229],
              [50.9229143, 32.621291],
              [50.9231908, 32.6179591],
              [50.923471, 32.6157379],
              [50.9261418, 32.6000356],
              [50.9300017, 32.5957619],
              [50.9412699, 32.5870349],
              [50.9465217, 32.57951],
              [50.9549892, 32.5727917],
              [50.9623231, 32.5673038],
              [50.9736529, 32.5628285],
              [50.9821104, 32.5589312],
              [50.995493, 32.5541074],
              [50.9977867, 32.5505181],
              [50.9981966, 32.5457328],
              [50.9981967, 32.545182],
              [50.9990324, 32.5392043],
              [50.9981967, 32.5379584],
              [50.9984733, 32.5376786],
              [51.0001401, 32.5335069],
              [51.0079166, 32.5240621],
              [51.0081965, 32.521561],
              [51.0087499, 32.5182291],
              [51.00903, 32.5176784],
              [51.00903, 32.5168386],
              [51.0090299, 32.5165677],
              [51.0090299, 32.5151772],
              [51.0090299, 32.5148973],
              [51.0051401, 32.5012899],
              [50.9998634, 32.4846216],
              [50.9997917, 32.4840617],
              [50.9993068, 32.4835109],
              [50.9943069, 32.4740661],
              [50.9845837, 32.4604497],
              [50.9731939, 32.4457317],
              [50.9704172, 32.4401696],
              [50.9701371, 32.4396187],
              [50.9698606, 32.4379482],
              [50.9684705, 32.4335058],
              [50.9679174, 32.4293432],
              [50.9676373, 32.4254516],
              [50.9673605, 32.4146162],
              [50.9695841, 32.3996184],
              [50.9698606, 32.3971172],
              [50.9701373, 32.3954468],
              [50.9704173, 32.3951758],
              [50.9704173, 32.3937854],
              [50.9706939, 32.392124],
              [50.9709707, 32.3912842],
              [50.9710357, 32.3904972],
              [50.973194, 32.3882322],
              [50.9854172, 32.3760064],
              [50.9998944, 32.3679522],
              [51.0162533, 32.3610086],
              [51.0220868, 32.356837],
              [51.02264, 32.3562862],
              [51.0318064, 32.351004],
              [51.0418099, 32.3443403],
              [51.0465296, 32.3426698],
              [51.0743093, 32.333505],
              [51.0784759, 32.330724],
              [51.0795892, 32.3298933],
              [51.1326452, 32.2948954],
              [51.1337587, 32.2946154],
              [51.1365351, 32.293225],
              [51.1373686, 32.2923943],
              [51.138202, 32.2921234],
              [51.1443119, 32.2876719],
              [51.1457017, 32.2862814],
              [51.1462584, 32.2860105],
              [51.1657049, 32.2665613],
              [51.1684814, 32.2626696],
              [51.1812579, 32.2451706],
              [51.1843146, 32.2387869],
              [51.185148, 32.2373964],
              [51.1907047, 32.2265612],
              [51.1915378, 32.2257215],
              [51.1915378, 32.2254415],
              [51.1918146, 32.2251706],
              [51.1918146, 32.2246199],
              [51.1923713, 32.22434],
              [51.1937613, 32.2232294],
              [51.194038, 32.2226696],
              [51.1970946, 32.2182271],
              [51.2087611, 32.2062813],
              [51.2093177, 32.2051707],
              [51.2212629, 32.190165],
              [51.2218176, 32.1896132],
              [51.2218176, 32.1893332],
              [51.2309842, 32.1782272],
              [51.2315408, 32.1768367],
              [51.232094, 32.1765568],
              [51.2337608, 32.1743356],
              [51.2423741, 32.1687826],
              [51.2434838, 32.1685027],
              [51.2565403, 32.1635004],
              [51.258207, 32.1632295],
              [51.2593169, 32.1626698],
              [51.2684869, 32.1587782],
              [51.2779302, 32.1565569],
              [51.2820967, 32.1565569],
              [51.2826534, 32.1562771],
              [51.2843201, 32.1562771],
              [51.2845968, 32.1559972],
              [51.2876533, 32.1559972],
              [51.2890433, 32.1562771],
              [51.2926534, 32.1562771],
              [51.2934865, 32.1559972],
              [51.2998766, 32.1554463],
              [51.3020999, 32.1548866],
              [51.3268228, 32.1476721],
              [51.3309895, 32.1460017],
              [51.3320995, 32.1451711],
              [51.3326561, 32.1451711],
              [51.340156, 32.1415594],
              [51.3409893, 32.1415593],
              [51.3409892, 32.1412794],
              [51.3418227, 32.1412795],
              [51.3423794, 32.1409995],
              [51.3434894, 32.1407287],
              [51.3437659, 32.1409995],
              [51.3442305, 32.1406355],
              [51.3445994, 32.1404488],
              [51.3457126, 32.1396181],
              [51.3543226, 32.1307242],
              [51.3573791, 32.12295],
              [51.3676557, 32.1101647],
              [51.3818255, 32.0959978],
              [51.3823789, 32.0948871],
              [51.3851588, 32.0912755],
              [51.3857121, 32.0915555],
              [51.3862688, 32.0865532],
              [51.3865455, 32.0860024],
              [51.3862687, 32.0835014],
              [51.3859922, 32.0723864],
              [51.3854355, 32.070725],
              [51.3843256, 32.0701652],
              [51.3837799, 32.0698692],
              [51.3821577, 32.0674471],
              [51.3760294, 32.0583257],
              [51.3768792, 32.0556197],
              [51.3785014, 32.0527171],
              [51.381823, 32.0510585],
              [51.3842949, 32.0496399],
              [51.3851961, 32.0497054],
              [51.3855051, 32.0492252],
              [51.3868698, 32.0493125],
              [51.3869213, 32.0489852],
              [51.3875908, 32.0489633],
              [51.3967489, 32.0456769],
              [51.4029354, 32.0435021],
              [51.4040487, 32.0426623],
              [51.4143253, 32.0323871],
              [51.4248817, 32.0071056],
              [51.429325, 31.9998914],
              [51.4293249, 31.9937786],
              [51.4296051, 31.9923881],
              [51.4298817, 31.9907268],
              [51.4301617, 31.9862755],
              [51.4304383, 31.9837744],
              [51.430715, 31.9826638],
              [51.4312718, 31.9818331],
              [51.4327449, 31.9771462],
              [51.433888, 31.9735093],
              [51.4343282, 31.9721088],
              [51.4342279, 31.971413],
              [51.4340484, 31.9701675],
              [51.4335106, 31.9698835],
              [51.433323, 31.9697844],
              [51.4249413, 31.9653573],
              [51.4240483, 31.9648856],
              [51.4226238, 31.964328],
              [51.4176586, 31.9623844],
              [51.4161853, 31.9603245],
              [51.4150071, 31.958677],
              [51.414882, 31.958502],
              [51.4146052, 31.9573914],
              [51.4132154, 31.9523803],
              [51.4134919, 31.9512787],
              [51.4143253, 31.9493284],
              [51.4151585, 31.9484978],
              [51.4179385, 31.9451661],
              [51.4223817, 31.9404439],
              [51.4254384, 31.9354418],
              [51.4276585, 31.9296091],
              [51.4282151, 31.9268282],
              [51.4262719, 31.9126617],
              [51.417382, 31.8940529],
              [51.4143253, 31.8804463],
              [51.4140486, 31.8668307],
              [51.4132155, 31.8640498],
              [51.4121055, 31.8618287],
              [51.4109919, 31.8604382],
              [51.4096022, 31.858497],
              [51.4029355, 31.8518337],
              [51.4021022, 31.8518337],
              [51.3998822, 31.8507141],
              [51.3940491, 31.8493327],
              [51.3934924, 31.8493327],
              [51.3926591, 31.8493326],
              [51.3923825, 31.8490528],
              [51.3915457, 31.8490527],
              [51.387521, 31.8489872],
              [51.3837852, 31.8496615],
              [51.3811588, 31.8516737],
              [51.3776826, 31.8533141],
              [51.3697776, 31.8562448],
              [51.36625, 31.8563979],
              [51.3653745, 31.8555012],
              [51.3597612, 31.8492459],
              [51.348483, 31.839709],
              [51.3456249, 31.8399715],
              [51.3389558, 31.8407371],
              [51.3338832, 31.8402559],
              [51.3246908, 31.8371497],
              [51.3189946, 31.835389],
              [51.3095704, 31.8304012],
              [51.2991162, 31.822919],
              [51.2986787, 31.8222844],
              [51.2959805, 31.8183708],
              [51.2931358, 31.810817],
              [51.2938132, 31.8055718],
              [51.2995206, 31.7955587],
              [51.3047655, 31.7878865],
              [51.3059757, 31.784297],
              [51.3088854, 31.7794159],
              [51.3094776, 31.7760011],
              [51.3094518, 31.7730241],
              [51.3120268, 31.7670478],
              [51.312619, 31.7629101],
              [51.3137005, 31.7605238],
              [51.3176401, 31.757174],
              [51.3222749, 31.7534519],
              [51.3246181, 31.7501238],
              [51.328532, 31.7446497],
              [51.3301542, 31.7416935],
              [51.3370807, 31.7347297],
              [51.3418186, 31.7324084],
              [51.3472002, 31.7289043],
              [51.3574226, 31.725422],
              [51.3603838, 31.7230347],
              [51.3621605, 31.7217205],
              [51.3634737, 31.7197712],
              [51.3633964, 31.7172304],
              [51.3630102, 31.7158285],
              [51.3616455, 31.7144486],
              [51.3567016, 31.712981],
              [51.3505218, 31.7101333],
              [51.3447282, 31.7101771],
              [51.3332698, 31.7082933],
              [51.326678, 31.7082933],
              [51.3206527, 31.7081837],
              [51.3162754, 31.7045692],
              [51.3143957, 31.6952146],
              [51.3117693, 31.6848731],
              [51.3117178, 31.6832735],
              [51.3107153, 31.6816296],
              [51.3046868, 31.6768578],
              [51.3001509, 31.6673709],
              [51.2987276, 31.6469639],
              [51.3001656, 31.6407525],
              [51.3042286, 31.6225604],
              [51.3033854, 31.6159561],
              [51.303194, 31.6131465],
              [51.3023142, 31.6062341],
              [51.3016533, 31.5967894],
              [51.2971884, 31.5694447],
              [51.2926175, 31.5514879],
              [51.2917313, 31.5468213],
              [51.2910349, 31.535373],
              [51.2941387, 31.5239195],
              [51.2922434, 31.5127273],
              [51.289119, 31.5105139],
              [51.2798546, 31.5080603],
              [51.2722357, 31.5042154],
              [51.2729115, 31.5026075],
              [51.2735988, 31.4996013],
              [51.2745663, 31.4951612],
              [51.2749822, 31.4936781],
              [51.2753, 31.4922256],
              [51.273004, 31.4911377],
              [51.2723744, 31.4901515],
              [51.2704061, 31.4855638],
              [51.2701546, 31.4807082],
              [51.259598, 31.4607111],
              [51.259598, 31.4593207],
              [51.283211, 31.4495976],
              [51.286821, 31.4468171],
              [51.2884877, 31.4451559],
              [51.2890444, 31.4440364],
              [51.3030725, 31.4220986],
              [51.3032108, 31.4218188],
              [51.3034874, 31.4215389],
              [51.3037675, 31.4209882],
              [51.3040443, 31.4201486],
              [51.3043209, 31.4195979],
              [51.3043209, 31.4182076],
              [51.3068207, 31.4129264],
              [51.3073775, 31.4126555],
              [51.3084873, 31.4107055],
              [51.3140441, 31.3934804],
              [51.3137674, 31.388488],
              [51.3143206, 31.384597],
              [51.3156149, 31.3815458],
              [51.3149453, 31.3797876],
              [51.3136924, 31.3779972],
              [51.3107827, 31.3759747],
              [51.3085718, 31.3742308],
              [51.305039, 31.3751668],
              [51.3020094, 31.3770401],
              [51.2981656, 31.3780632],
              [51.2968781, 31.3780632],
              [51.2910846, 31.3768321],
              [51.2881492, 31.3754251],
              [51.2859605, 31.3733147],
              [51.2852652, 31.3695552],
              [51.2852652, 31.3672247],
              [51.2858317, 31.3658616],
              [51.2912648, 31.3553296],
              [51.2923463, 31.3538124],
              [51.2942775, 31.3521852],
              [51.2975746, 31.3453597],
              [51.3037544, 31.3384323],
              [51.3068958, 31.3334838],
              [51.308003, 31.3298327],
              [51.3116079, 31.3253897],
              [51.3136421, 31.323608],
              [51.314981, 31.3211664],
              [51.3208261, 31.3127853],
              [51.3258472, 31.3088035],
              [51.3287569, 31.3051075],
              [51.3286539, 31.3017634],
              [51.3277011, 31.2994532],
              [51.3288599, 31.2953828],
              [51.333057, 31.289992],
              [51.3347126, 31.2852045],
              [51.3388324, 31.2780085],
              [51.3447033, 31.2726607],
              [51.3468404, 31.2664323],
              [51.3469434, 31.2630427],
              [51.3408666, 31.2559332],
              [51.3389612, 31.2527634],
              [51.3409954, 31.2464676],
              [51.3408238, 31.2430901],
              [51.3400256, 31.2353405],
              [51.3400513, 31.226027],
              [51.3360087, 31.2123963],
              [51.3346955, 31.207265],
              [51.3332793, 31.2004155],
              [51.332069, 31.1941603],
              [51.332481, 31.1875301],
              [51.3353907, 31.1804809],
              [51.3356224, 31.1788507],
              [51.3336002, 31.1755919],
              [51.33256, 31.1697426],
              [51.3332037, 31.1658428],
              [51.3358301, 31.1541206],
              [51.3380961, 31.1463858],
              [51.3390746, 31.1366448],
              [51.3391003, 31.1312228],
              [51.3412375, 31.1232216],
              [51.3425764, 31.1190775],
              [51.3430657, 31.1146466],
              [51.3435445, 31.1128778],
              [51.3428808, 31.1044317],
              [51.3413702, 31.0978859],
              [51.343865, 31.0926332],
              [51.3468404, 31.0886152],
              [51.3470445, 31.0846242],
              [51.3472047, 31.0803314],
              [51.3482347, 31.0710198],
              [51.3489671, 31.0672753],
              [51.3482118, 31.0633345],
              [51.3486128, 31.0616629],
              [51.3487598, 31.0592023],
              [51.3491461, 31.0562907],
              [51.3478329, 31.0551436],
              [51.3475239, 31.0518127],
              [51.3490431, 31.0512171],
              [51.3510515, 31.0492097],
              [51.3505623, 31.0443123],
              [51.352648, 31.040628],
              [51.3537294, 31.0385762],
              [51.3532917, 31.0330825],
              [51.3503048, 31.0316042],
              [51.3488886, 31.0286034],
              [51.3493521, 31.0265955],
              [51.3525192, 31.0235284],
              [51.3541414, 31.0209025],
              [51.3560211, 31.0190489],
              [51.3618919, 31.0138851],
              [51.3665889, 31.0065834],
              [51.3695758, 31.0062082],
              [51.3755458, 31.0067497],
              [51.3767817, 30.997502],
              [51.3790992, 30.9944561],
              [51.3828586, 30.9935069],
              [51.384455, 30.9933745],
              [51.3849442, 30.9924033],
              [51.384146, 30.9879223],
              [51.3867467, 30.9855162],
              [51.3884375, 30.9838258],
              [51.3901179, 30.9810248],
              [51.393496, 30.9763112],
              [51.3969979, 30.972536],
              [51.4020554, 30.9690384],
              [51.405171, 30.9662785],
              [51.4075399, 30.9642031],
              [51.4111738, 30.9631283],
              [51.4139289, 30.9626867],
              [51.4164524, 30.9619581],
              [51.4228382, 30.9626646],
              [51.4250268, 30.9617814],
              [51.4257736, 30.9606995],
              [51.4274988, 30.9581823],
              [51.4324426, 30.9521098],
              [51.4361505, 30.9519773],
              [51.4355325, 30.9467878],
              [51.437438, 30.9451757],
              [51.4383134, 30.9453082],
              [51.4407596, 30.9445131],
              [51.4457035, 30.942901],
              [51.4478149, 30.9404275],
              [51.451497, 30.9359883],
              [51.4542693, 30.9316465],
              [51.4591559, 30.9275089],
              [51.4617565, 30.92329],
              [51.4633994, 30.9216305],
              [51.4669485, 30.9199815],
              [51.468854, 30.9215499],
              [51.4706307, 30.9221905],
              [51.4747248, 30.9227648],
              [51.4772224, 30.9219917],
              [51.4776859, 30.9214394],
              [51.4811878, 30.9219475],
              [51.483325, 30.9219917],
              [51.483737, 30.9199594],
              [51.4824238, 30.9184794],
              [51.4824753, 30.9160715],
              [51.4803638, 30.9118079],
              [51.4804668, 30.9090685],
              [51.4826555, 30.9055115],
              [51.48281, 30.9040313],
              [51.4893246, 30.8994357],
              [51.4914875, 30.8972483],
              [51.4930067, 30.8966517],
              [51.4955044, 30.8959226],
              [51.4959164, 30.8911278],
              [51.4954786, 30.8864874],
              [51.4991865, 30.8801452],
              [51.5079927, 30.8728301],
              [51.5134773, 30.8711504],
              [51.5163355, 30.8710399],
              [51.5216913, 30.8716145],
              [51.523983, 30.8705537],
              [51.5261974, 30.8693602],
              [51.5280094, 30.8685666],
              [51.5304164, 30.8656829],
              [51.5333461, 30.8635414],
              [51.5365962, 30.8627162],
              [51.5430736, 30.8610855],
              [51.5444011, 30.8611052],
              [51.5455684, 30.8613016],
              [51.5469188, 30.8628931],
              [51.55097, 30.8647988],
              [51.5521831, 30.8630699],
              [51.5555705, 30.8609676],
              [51.5600795, 30.858158],
              [51.5652522, 30.8547784],
              [51.5688072, 30.852263],
              [51.5710503, 30.849964],
              [51.5718056, 30.8491387],
              [51.57398, 30.8486475],
              [51.5756279, 30.8478811],
              [51.5765892, 30.8420252],
              [51.5787407, 30.840453],
              [51.5824486, 30.8397063],
              [51.5859734, 30.8388023],
              [51.5862251, 30.8386058],
              [51.5861336, 30.8378786],
              [51.5856758, 30.8360903],
              [51.5863854, 30.8344591],
              [51.5894753, 30.8337319],
              [51.5955406, 30.8321203],
              [51.5978294, 30.8317666],
              [51.6020638, 30.828622],
              [51.6046501, 30.8278751],
              [51.6083809, 30.8289757],
              [51.6101603, 30.8289267],
              [51.6109238, 30.8282711],
              [51.6121287, 30.8272364],
              [51.6130213, 30.8227354],
              [51.6113734, 30.8187256],
              [51.6073679, 30.8140277],
              [51.6056742, 30.812003],
              [51.6093592, 30.8105483],
              [51.6143259, 30.8077569],
              [51.6162485, 30.80585],
              [51.6181025, 30.803196],
              [51.6251063, 30.8028225],
              [51.6303248, 30.8024293],
              [51.6331171, 30.797239],
              [51.6341471, 30.794919],
              [51.6354746, 30.7943882],
              [51.6371455, 30.791498],
              [51.6408762, 30.7902986],
              [51.6439432, 30.7889419],
              [51.6492075, 30.7885486],
              [51.6512904, 30.7855599],
              [51.6557536, 30.7799558],
              [51.6616587, 30.7748823],
              [51.6641535, 30.7725815],
              [51.6692118, 30.7739581],
              [51.6734461, 30.7738401],
              [51.6747965, 30.774725],
              [51.6810679, 30.7753543],
              [51.6827616, 30.7743907],
              [51.6829218, 30.7713819],
              [51.6804728, 30.7700249],
              [51.6808619, 30.7655802],
              [51.6934046, 30.7618041],
              [51.6942286, 30.7558446],
              [51.6948958, 30.7527767],
              [51.6959487, 30.7495508],
              [51.6955367, 30.747092],
              [51.6971388, 30.7447315],
              [51.6978026, 30.7424889],
              [51.6970473, 30.7408955],
              [51.6978713, 30.739066],
              [51.7011672, 30.73702],
              [51.7035018, 30.7367643],
              [51.7067519, 30.7372954],
              [51.7108489, 30.7366265],
              [51.7149916, 30.7343248],
              [51.7157927, 30.7321016],
              [51.7171202, 30.7310786],
              [51.7210799, 30.7289341],
              [51.7252913, 30.7282652],
              [51.7300749, 30.7237596],
              [51.7335768, 30.7213394],
              [51.7395278, 30.7187421],
              [51.7424117, 30.7194308],
              [51.7448415, 30.7202932],
              [51.7505865, 30.7170072],
              [51.7566747, 30.7171252],
              [51.7593298, 30.7155904],
              [51.763278, 30.7151329],
              [51.7669973, 30.7123239],
              [51.7732458, 30.71134],
              [51.7842493, 30.7099724],
              [51.801856, 30.7131455],
              [51.8067598, 30.7129585],
              [51.8112459, 30.7142277],
              [51.8164769, 30.7162497],
              [51.827401, 30.7334731],
              [51.8326809, 30.7404135],
              [51.8335142, 30.7420832],
              [51.8465706, 30.7690329],
              [51.8549038, 30.7951345],
              [51.8574039, 30.799584],
              [51.8576804, 30.7998548],
              [51.8579571, 30.8004144],
              [51.8585137, 30.8004145],
              [51.8585138, 30.8026347],
              [51.8562905, 30.8131946],
              [51.8426807, 30.8423565],
              [51.8424005, 30.8440353],
              [51.8415674, 30.8459668],
              [51.8324007, 30.8759777],
              [51.8326808, 30.8826388],
              [51.8354575, 30.8934789],
              [51.8371241, 30.8984793],
              [51.8412905, 30.905971],
              [51.8415673, 30.9065305],
              [51.8499038, 30.9195822],
              [51.8560136, 30.9265323],
              [51.8715702, 30.9426439],
              [51.8724034, 30.9443138],
              [51.87296, 30.9445846],
              [51.894903, 30.9840294],
              [51.8954596, 30.9854194],
              [51.8976831, 30.9893098],
              [51.8976831, 30.9895896],
              [51.8976831, 30.9901493],
              [51.8976831, 30.9906999],
              [51.8979597, 30.9909706],
              [51.8979597, 30.9918101],
              [51.8965697, 31.0001234],
              [51.897403, 31.0123632],
              [51.8976831, 31.0212543],
              [51.8985163, 31.0273653],
              [51.9010164, 31.0329256],
              [51.9012929, 31.0332055],
              [51.9021263, 31.0343067],
              [51.9024062, 31.0345865],
              [51.9218493, 31.0770929],
              [51.9249058, 31.0829242],
              [51.9401857, 31.11181],
              [51.9410189, 31.1129202],
              [51.956852, 31.1509777],
              [51.9679618, 31.1943167],
              [51.9685184, 31.2109809],
              [51.9682418, 31.2112607],
              [51.9685184, 31.2129218],
              [51.9685184, 31.2132016],
              [51.9685184, 31.2134814],
              [51.9682418, 31.2140321],
              [51.9665752, 31.2204234],
              [51.966295, 31.2220934],
              [51.9660186, 31.2245939],
              [51.9657418, 31.2259842],
              [51.9654619, 31.2284847],
              [51.9651851, 31.2309762],
              [51.9646285, 31.2343163],
              [51.9640751, 31.2379273],
              [51.9635185, 31.241818],
              [51.9635184, 31.2437588],
              [51.9546286, 31.2882097],
              [51.9546286, 31.2904215],
              [51.954352, 31.2909812],
              [51.9546286, 31.2929311],
              [51.9546286, 31.294872],
              [51.9562952, 31.3009836],
              [51.9557386, 31.3023738],
              [51.9554618, 31.3040439],
              [51.9551852, 31.3062557],
              [51.9535186, 31.314868],
              [51.9535186, 31.316538],
              [51.9487952, 31.3359835],
              [51.947962, 31.3409848],
              [51.9454619, 31.3501479],
              [51.9451854, 31.3523777],
              [51.9443519, 31.3548783],
              [51.9418521, 31.3765358],
              [51.9382387, 31.3948713],
              [51.9374053, 31.3970921],
              [51.9365721, 31.4029331],
              [51.9362954, 31.4040434],
              [51.9365721, 31.4120964],
              [51.9365721, 31.4123762],
              [51.936572, 31.412656],
              [51.9365721, 31.4134866],
              [51.937682, 31.414597],
              [51.9379619, 31.4154276],
              [51.9387953, 31.4159873],
              [51.9804646, 31.4890417],
              [51.9837981, 31.4943231],
              [51.9882412, 31.5023762],
              [51.9987977, 31.525434],
              [52.0029644, 31.5362679],
              [52.0079642, 31.5459912],
              [52.0096309, 31.5484921],
              [52.0104641, 31.5504331],
              [52.0463004, 31.59571],
              [52.0726898, 31.6171074],
              [52.0782466, 31.6207096],
              [52.1304691, 31.6565526],
              [52.1340824, 31.6579341],
              [52.1426924, 31.6604349],
              [52.1440822, 31.6609947],
              [52.1449156, 31.6609947],
              [52.1463021, 31.6615454],
              [52.1863049, 31.6673778],
              [52.1904715, 31.6679376],
              [52.1918616, 31.6679376],
              [52.1926948, 31.6682175],
              [52.1943615, 31.6682175],
              [52.2007514, 31.669328],
              [52.2013047, 31.669328],
              [52.2020993, 31.6696399],
              [52.2032233, 31.6692013],
              [52.2046413, 31.6690481],
              [52.2051947, 31.6687683],
              [52.2065848, 31.6687682],
              [52.2071414, 31.6684884],
              [52.2088081, 31.6684884],
              [52.211028, 31.6679377],
              [52.2121413, 31.6679376],
              [52.2126946, 31.6676578],
              [52.213808, 31.6676578],
              [52.2140845, 31.6673779],
              [52.2149179, 31.6673779],
              [52.2154746, 31.667107],
              [52.2176945, 31.667107],
              [52.2188079, 31.6668272],
              [52.2199178, 31.6668272],
              [52.2207512, 31.6665472],
              [52.2226977, 31.6665473],
              [52.2374175, 31.6643262],
              [52.2393643, 31.6637665],
              [52.2407508, 31.6637665],
              [52.2446408, 31.662656],
              [52.2474209, 31.6615455],
              [52.3446462, 31.5723811],
              [52.3449228, 31.5721012],
              [52.345203, 31.5718213],
              [52.3729792, 31.5546045],
              [52.3810357, 31.5515438],
              [52.3935389, 31.5482125],
              [52.3977055, 31.5473728],
              [52.3999255, 31.5468221],
              [52.4077054, 31.5459915],
              [52.4107585, 31.5454318],
              [52.4129819, 31.5454318],
              [52.4302051, 31.542931],
              [52.4329851, 31.5426601],
              [52.4965975, 31.5234933],
              [52.4971541, 31.5234933],
              [52.4996541, 31.5229336],
              [52.5596566, 31.5123797],
              [52.5738231, 31.5112692],
              [52.574933, 31.5109894],
              [52.5785464, 31.5109894],
              [52.5796563, 31.5107095],
              [52.5824364, 31.5107095],
              [52.5846562, 31.5104296],
              [52.5866029, 31.5104297],
              [52.5963228, 31.509879],
              [52.6107693, 31.5087685],
              [52.6138259, 31.5087685],
              [52.6154926, 31.5084886],
              [52.6185491, 31.5084886],
              [52.6232691, 31.5079379],
              [52.6260491, 31.5079379],
              [52.6563253, 31.5048773],
              [52.6602152, 31.5048773],
              [52.6866048, 31.5029364],
              [52.6907715, 31.5029364],
              [52.7291076, 31.4990453],
              [52.7304976, 31.4990452],
              [52.7329975, 31.4984855],
              [52.754944, 31.4962646],
              [52.7610538, 31.4959938],
              [52.7621638, 31.4957049],
              [52.7774436, 31.4957049],
              [52.7793869, 31.495434],
              [52.7824435, 31.4954341],
              [52.7843868, 31.4951542],
              [52.7863335, 31.4951542],
              [52.7871668, 31.4948743],
              [52.793, 31.4948743],
              [52.7946667, 31.4946035],
              [52.79661, 31.4946035],
              [52.7977234, 31.4948743],
              [52.7991099, 31.4948743],
              [52.7993899, 31.4951542],
              [52.8005, 31.4948743],
              [52.8010566, 31.4948743],
              [52.8057765, 31.4946034],
              [52.8060565, 31.4943236],
              [52.8077232, 31.4943236],
              [52.8132799, 31.4932132],
              [52.829113, 31.4921027],
              [52.8307796, 31.4918228],
              [52.8321695, 31.4918229],
              [52.8330028, 31.491543],
              [52.8360562, 31.491543],
              [52.8368894, 31.4912631],
              [52.8418894, 31.4912631],
              [52.8491126, 31.4907124],
              [52.849946, 31.4904325],
              [52.8535592, 31.4904326],
              [52.8577259, 31.4898728],
              [52.8585591, 31.4901526],
              [52.8716156, 31.4901527],
              [52.8727256, 31.4898728],
              [52.8807822, 31.4898728],
              [52.8832821, 31.489602],
              [52.8868921, 31.4896019],
              [52.888282, 31.4893221],
              [52.8927253, 31.4893221],
              [52.9016152, 31.4890422],
              [52.9213382, 31.4898729],
              [52.9227283, 31.4901527],
              [52.9360614, 31.4901527],
              [52.9385615, 31.4898728],
              [52.9410613, 31.4901527],
              [52.9460613, 31.4901527],
              [52.9774508, 31.4934932],
              [52.9793974, 31.4934931],
              [52.9824541, 31.4940439],
              [52.9843974, 31.4940438],
              [52.9852307, 31.4943237],
              [52.987174, 31.4943237],
              [52.9938406, 31.4954342],
              [52.9966206, 31.4962647],
              [52.9977306, 31.4962647],
              [53.0063438, 31.4987655],
              [53.0071771, 31.4993252],
              [53.009397, 31.4995961],
              [53.0113437, 31.5004267],
              [53.0524565, 31.5098792],
              [53.0574564, 31.5112694],
              [53.0596797, 31.5115403],
              [53.0832893, 31.5201532],
              [53.0913459, 31.5234936],
              [53.1291253, 31.5398798],
              [53.130792, 31.5407103],
              [53.1327387, 31.5412701],
              [53.133572, 31.5418208],
              [53.1355152, 31.5423805],
              [53.1832945, 31.56682],
              [53.1849612, 31.5676597],
              [53.1860746, 31.5679305],
              [53.1944078, 31.573212],
              [53.2029075, 31.5889258],
              [53.2035743, 31.5901582],
              [53.2035744, 31.5904381],
              [53.2032943, 31.590718],
              [53.203419, 31.5918284],
              [53.2035743, 31.5932098],
              [53.203851, 31.5968212],
              [53.1980177, 31.6134876],
              [53.186908, 31.6279329],
              [53.1802379, 31.6376566],
              [53.1771847, 31.641268],
              [53.1402385, 31.6804336],
              [53.102459, 31.7046031],
              [53.0819026, 31.716268],
              [53.0810692, 31.7171077],
              [53.0794026, 31.7179383],
              [53.0757894, 31.72099],
              [53.0612546, 31.7300913],
              [53.0474699, 31.7396576],
              [53.0409968, 31.7473041],
              [53.0364983, 31.759848],
              [53.0283699, 31.7797787],
              [53.0233334, 31.7921091],
              [53.0155486, 31.8121175],
              [53.0089671, 31.827318],
              [53.0063296, 31.8375455],
              [53.0030453, 31.8541591],
              [53.0003655, 31.8667867],
              [53.0045904, 31.8813453],
              [53.0112986, 31.9072903],
              [53.0159251, 31.9253995],
              [53.0224835, 31.9479982],
              [53.0251385, 31.9586496],
              [53.0341949, 31.9934593],
              [53.0349539, 31.9961391],
              [53.0452537, 32.0019621],
              [53.0473351, 32.0034361],
              [53.0511759, 32.0051102],
              [53.0522917, 32.0294716],
              [53.0404469, 32.0344196],
              [53.0440518, 32.0488252],
              [53.0419918, 32.0645378],
              [53.0354687, 32.1067157],
              [53.0340954, 32.1311409],
              [53.0323885, 32.1557259],
              [53.0312917, 32.1768898],
              [53.0298018, 32.2029296],
              [53.029182, 32.2250781],
              [53.0249294, 32.2749347],
              [53.0262539, 32.2890363],
              [53.0276669, 32.3022519],
              [53.0286336, 32.3099209],
              [53.0294693, 32.3212061],
              [53.0289769, 32.3300608],
              [53.0288684, 32.3390763],
              [53.0278086, 32.350659],
              [53.0276177, 32.3645667],
              [53.0270802, 32.3801167],
              [53.0257736, 32.3968515],
              [53.0250414, 32.4101267],
              [53.0245534, 32.4225924],
              [53.0233668, 32.4336572],
              [53.0228869, 32.4430735],
              [53.0218638, 32.4453502],
              [53.0220287, 32.4497819],
              [53.0224441, 32.465347],
              [53.0234098, 32.4823614],
              [53.0175159, 32.4993752],
              [53.0134234, 32.5072386],
              [53.0115161, 32.5143132],
              [53.0136286, 32.5177438],
              [53.0239032, 32.5273026],
              [53.0254268, 32.5286874],
              [53.0288172, 32.5310573],
              [53.0301046, 32.5325046],
              [53.0335999, 32.5356451],
              [53.0337632, 32.5358151],
              [53.0452482, 32.5375855],
              [53.0571411, 32.5396141],
              [53.0685137, 32.5408802],
              [53.0832767, 32.5283618],
              [53.1062633, 32.5325674],
              [53.1307096, 32.53187],
              [53.1506558, 32.527841],
              [53.1697869, 32.5242318],
              [53.1913374, 32.5222106],
              [53.2096097, 32.528934],
              [53.2119365, 32.5581462],
              [53.2170115, 32.6003287],
              [53.2347649, 32.6220997],
              [53.2499055, 32.6418765],
              [53.278858, 32.6512261],
              [53.3031672, 32.6543251],
              [53.3282276, 32.6491388],
              [53.3595666, 32.6375572],
              [53.4146493, 32.6162236],
              [53.4356975, 32.6090137],
              [53.4499578, 32.6024235],
              [53.5222356, 32.6306184],
              [53.5694176, 32.6525809],
              [53.6016339, 32.6666989],
              [53.6351481, 32.6817172],
              [53.6605212, 32.6925532],
              [53.6781414, 32.7007846],
              [53.6858148, 32.7043691],
              [53.7178873, 32.7171997],
              [53.7542296, 32.727309],
              [53.7899485, 32.7391591],
              [53.8265207, 32.7515759],
              [53.863918, 32.7650104],
              [53.8934273, 32.774879],
              [53.9120142, 32.7814909],
              [53.9240985, 32.7858955],
              [53.9455039, 32.7923077],
              [53.9560573, 32.7970349],
              [53.9711135, 32.8049274],
              [53.9853235, 32.8105343],
              [53.9957834, 32.8144697],
              [54.0169048, 32.8241738],
              [54.0199997, 32.8257447],
              [54.0342008, 32.8306916],
              [54.0617025, 32.8407625],
              [54.1246602, 32.8611662],
              [54.1402981, 32.867061],
              [54.1496147, 32.8703771],
              [54.1587543, 32.873099],
              [54.1712774, 32.8775683],
              [54.2042706, 32.8874055],
              [54.2224605, 32.8924583],
              [54.2346355, 32.8962496],
              [54.2492537, 32.8990505],
              [54.2550669, 32.9021926],
              [54.2721217, 32.9080346],
              [54.2882295, 32.9134001],
              [54.3145738, 32.920106],
              [54.3327468, 32.9234845],
              [54.3626304, 32.928984],
              [54.3850765, 32.9328258],
              [54.4087926, 32.9364832],
              [54.4406894, 32.9425643],
              [54.4735352, 32.9484705],
              [54.5165123, 32.9558958],
              [54.5480564, 32.9599288],
              [54.579193, 32.9656023],
              [54.6057953, 32.9684359],
              [54.6572322, 32.9657644],
              [54.6940695, 32.9610429],
              [54.7361835, 32.9572269],
              [54.7365568, 32.9848776],
              [54.7383736, 32.9981768],
              [54.7422767, 33.0021719],
              [54.7496749, 33.0123759],
              [54.7548798, 33.0214609],
              [54.7612721, 33.032471],
              [54.7691723, 33.0460375],
              [54.7739064, 33.0534423],
              [54.7795701, 33.0622749],
              [54.7774661, 33.0679934],
              [54.7753331, 33.0770338],
              [54.7741602, 33.0823169],
              [54.7781529, 33.0878231],
              [54.782113, 33.0935632],
              [54.7908196, 33.0959225],
              [54.7960527, 33.0964823],
              [54.8000977, 33.0953963],
              [54.8063461, 33.1022218],
              [54.8086194, 33.1139807],
              [54.8174856, 33.1261949],
              [54.8277853, 33.1348202],
              [54.8411749, 33.1352514],
              [54.8550795, 33.1376951],
              [54.8778152, 33.1715851],
              [54.8786485, 33.171856],
              [54.8839285, 33.174357],
              [54.8861518, 33.1751876],
              [54.8883717, 33.1765871],
              [54.8972616, 33.1801987],
              [54.898095, 33.1799188],
              [54.8994849, 33.1799188],
              [54.8997616, 33.1796389],
              [54.9011515, 33.1796389],
              [54.9128181, 33.1751877],
              [54.9547642, 33.1482546],
              [54.9617108, 33.1435235],
              [54.9906005, 33.1260256],
              [54.9917104, 33.1257457],
              [55.01949, 33.1504757],
              [55.0272666, 33.15964],
              [55.0333799, 33.1671339],
              [55.0772693, 33.2118624],
              [55.1044923, 33.2363121],
              [55.1078256, 33.238804],
              [55.1097723, 33.2407542],
              [55.1372718, 33.2610327],
              [55.1544949, 33.2757492],
              [55.175608, 33.2918652],
              [55.1758847, 33.2921451],
              [55.176718, 33.2924159],
              [55.1833846, 33.2985283],
              [55.2225541, 33.324088],
              [55.2247774, 33.3251985],
              [55.2281107, 33.3268597],
              [55.2328341, 33.3293606],
              [55.2542238, 33.3382537],
              [55.2592238, 33.3399239],
              [55.260057, 33.3404747],
              [55.2686668, 33.3429755],
              [55.2697803, 33.3435353],
              [55.3233929, 33.3540895],
              [55.3247828, 33.3546402],
              [55.3622824, 33.359642],
              [55.364229, 33.3601927],
              [55.3670056, 33.3604725],
              [55.3758955, 33.3632533],
              [55.3772855, 33.3632533],
              [55.3783955, 33.3635331],
              [55.3803388, 33.3635331],
              [55.3873936, 33.3577196],
              [55.3955167, 33.3680423],
              [55.4005725, 33.3740407],
              [55.4049914, 33.3824666],
              [55.4110605, 33.3920444],
              [55.4184209, 33.4035702],
              [55.4256223, 33.4149185],
              [55.4324623, 33.4254962],
              [55.4821583, 33.506477],
              [55.4923724, 33.5194296],
              [55.4983399, 33.5246551],
              [55.5041847, 33.5300843],
              [55.5097279, 33.5336609],
              [55.518076, 33.5377327],
              [55.5287619, 33.5423135],
              [55.5326063, 33.5440686],
              [55.5354829, 33.5526702],
              [55.540566, 33.5698173],
              [55.5447942, 33.5811191],
              [55.5479891, 33.5902184],
              [55.5534157, 33.6053637],
              [55.557179, 33.616369],
              [55.559903, 33.6318541],
              [55.5608722, 33.6496318],
              [55.5612156, 33.663732],
              [55.5443, 33.7797181],
              [55.5408667, 33.7904187],
              [55.5379485, 33.8006185],
              [55.5323695, 33.8260771],
              [55.5275519, 33.852175],
              [55.5111605, 33.9408474],
              [55.5080896, 33.9558693],
              [55.503854, 33.9809113],
              [55.5004637, 33.999842],
              [55.5002932, 34.0102337],
              [55.5002682, 34.0249969],
              [55.5002874, 34.0373987],
              [55.5003959, 34.0487802],
              [55.500415, 34.058876],
              [55.5003352, 34.0770147],
              [55.5006366, 34.0926371],
              [55.500385, 34.1062723],
              [55.5007783, 34.1387155],
              [55.5006008, 34.1548445],
              [55.5004484, 34.1746438],
              [55.5005841, 34.2238194],
              [55.5005651, 34.2445108],
              [55.5007367, 34.2674919],
              [55.4016493, 34.2393376],
              [55.1997496, 34.2390266],
              [55.1818967, 34.2384549],
              [55.1604007, 34.2380332],
              [55.1337097, 34.2403038],
              [55.1082144, 34.2399589],
              [55.0405855, 34.2397823],
              [54.6105335, 34.2385698],
              [54.5677183, 34.2389119],
              [54.5254896, 34.2379185],
              [54.5054053, 34.2390538],
              [54.4967596, 34.2382882],
              [54.4302967, 34.237015],
              [54.3447677, 34.237036],
              [54.2499703, 34.2342332],
              [54.2339897, 34.2355854],
              [54.2222209, 34.2366143],
              [54.197569, 34.2385802],
              [54.1807712, 34.2392897],
              [54.1546961, 34.2397033],
              [54.0271567, 34.2465748],
              [53.9991759, 34.2479938],
              [53.9072441, 34.2465018],
              [53.8732993, 34.2468984],
              [53.8446401, 34.2457763],
              [53.5343699, 34.2450538],
              [53.5190209, 34.2458592],
              [53.5166735, 34.2458552],
              [53.5121409, 34.2459223],
              [53.4983972, 34.2458472],
              [53.3660885, 34.2461493],
              [53.285751, 34.2470006],
              [53.2078925, 34.2510909],
              [53.194365, 34.2519147],
              [53.1735702, 34.2532756],
              [53.1697219, 34.2534174],
              [53.1351516, 34.2554909],
              [53.1004753, 34.2578449],
              [53.0810578, 34.2585583],
              [53.0697114, 34.2595554],
              [53.0413023, 34.2611081],
              [53.0256643, 34.2620971],
              [53.0033984, 34.2640873],
              [52.9816033, 34.2642252],
              [52.9678454, 34.2644171],
              [52.9502034, 34.2647483],
              [52.9205728, 34.2654891],
              [52.8943325, 34.265161],
              [52.8804077, 34.2674397],
              [52.865566, 34.2720898],
              [52.852427, 34.2764549],
              [52.8418053, 34.2797346],
              [52.820325, 34.2909465],
              [52.8017401, 34.3005397],
              [52.7639419, 34.3198834],
              [52.7416319, 34.3327637],
              [52.677993, 34.3643897],
              [52.6732697, 34.3666098],
              [52.6528082, 34.3775899],
              [52.6095714, 34.3882974],
              [52.6035292, 34.390082],
              [52.5928844, 34.3920049],
              [52.5804843, 34.3960065],
              [52.5612699, 34.4013693],
              [52.5264463, 34.4102747],
              [52.5025119, 34.4184128],
              [52.4999285, 34.4191138],
              [52.4888186, 34.4210631],
              [52.4829819, 34.4218843],
              [52.4821486, 34.4221641],
              [52.4796487, 34.4221641],
              [52.4590923, 34.4249435],
              [52.4563157, 34.4255031],
              [52.4532591, 34.425503],
              [52.4504824, 34.4260535],
              [52.4485358, 34.4260534],
              [52.4474257, 34.4263332],
              [52.4446492, 34.4263332],
              [52.4440925, 34.426613],
              [52.4368693, 34.426613],
              [52.4307592, 34.4274433],
              [52.429646, 34.4271725],
              [52.4174262, 34.4271725],
              [52.4160362, 34.4274432],
              [52.4102029, 34.4282735],
              [52.4096462, 34.4285532],
              [52.4090895, 34.4282735],
              [52.4068696, 34.4282734],
              [52.4060364, 34.4282734],
              [52.4054797, 34.4285532],
              [52.4040897, 34.4285532],
              [52.403813, 34.428833],
              [52.4022866, 34.4291127],
              [52.399923, 34.4291127],
              [52.3993698, 34.4293924],
              [52.3954797, 34.4293924],
              [52.3952031, 34.4291127],
              [52.3943698, 34.4293925],
              [52.3929798, 34.4291127],
              [52.3885331, 34.428833],
              [52.3799233, 34.4280027],
              [52.3788133, 34.427723],
              [52.3768666, 34.4277229],
              [52.3546436, 34.424393],
              [52.3527004, 34.4243929],
              [52.3324205, 34.4205035],
              [52.3313105, 34.4205035],
              [52.3296438, 34.4199439],
              [52.3285306, 34.419944],
              [52.3129742, 34.415504],
              [52.3029742, 34.4141143],
              [52.2915843, 34.4118943],
              [52.2874178, 34.4113348],
              [52.2868645, 34.4110549],
              [52.2854744, 34.4107753],
              [52.2840846, 34.4104954],
              [52.2801979, 34.4102248],
              [52.2615848, 34.4074453],
              [52.2596381, 34.4074453],
              [52.2535283, 34.406606],
              [52.2474183, 34.4055049],
              [52.2329717, 34.4035557],
              [52.2307485, 34.4035557],
              [52.229362, 34.403276],
              [52.2254719, 34.4032759],
              [52.224082, 34.4029962],
              [52.2218587, 34.4029962],
              [52.217972, 34.4024457],
              [52.2146387, 34.4024457],
              [52.2135253, 34.402166],
              [52.2082488, 34.4021659],
              [52.2065822, 34.4018952],
              [52.1915822, 34.4018952],
              [52.1907491, 34.4016154],
              [52.1876924, 34.4016155],
              [52.1871357, 34.4013356],
              [52.1838024, 34.4013358],
              [52.182969, 34.4010559],
              [52.1793592, 34.4010559],
              [52.1782459, 34.4013356],
              [52.1751925, 34.4013357],
              [52.1738027, 34.4016155],
              [52.1614274, 34.4016155],
              [52.1607461, 34.4016154],
              [52.1585226, 34.4013357],
              [52.1551893, 34.4013356],
              [52.1529695, 34.4016154],
              [52.1493562, 34.4016154],
              [52.1459888, 34.4021873],
              [52.1440795, 34.4024456],
              [52.1424129, 34.4024456],
              [52.1412997, 34.4027254],
              [52.139633, 34.4027254],
              [52.1354663, 34.4035556],
              [52.1343563, 34.4035556],
              [52.1307464, 34.4046656],
              [52.129913, 34.4046656],
              [52.1247214, 34.4057632],
              [52.1215765, 34.4071654],
              [52.1207431, 34.4071654],
              [52.12019, 34.4074451],
              [52.1187999, 34.4074452],
              [52.1185232, 34.4077249],
              [52.1168565, 34.4077249],
              [52.1099099, 34.4096742],
              [52.1088002, 34.4096742],
              [52.1071334, 34.4102246],
              [52.1065766, 34.4102246],
              [52.1024101, 34.4113346],
              [52.0679639, 34.4193933],
              [52.0665738, 34.4193933],
              [52.0557406, 34.4224435],
              [52.0157411, 34.4305022],
              [52.0146278, 34.4305022],
              [51.9776816, 34.4424411],
              [51.9671251, 34.4463306],
              [51.9065692, 34.4724462],
              [51.8779563, 34.4827246],
              [51.8776761, 34.4830043],
              [51.8732329, 34.4849444],
              [51.8615663, 34.4888337],
              [51.8612863, 34.4893932],
              [51.8598996, 34.4899527],
              [51.8587863, 34.4899527],
              [51.856843, 34.4905032],
              [51.8346199, 34.5055009],
              [51.83462, 34.5057806],
              [51.8341678, 34.5059559],
              [51.8321199, 34.5055008],
              [51.82851, 34.5055009],
              [51.8098967, 34.5094458],
              [51.8007816, 34.510984],
              [51.716838, 34.4985614],
              [51.7143382, 34.4980019],
              [51.7129481, 34.498002],
              [51.710448, 34.4974514],
              [51.7076681, 34.4971718],
              [51.6948917, 34.4952225],
              [51.6837784, 34.4941126],
              [51.6810018, 34.4941126],
              [51.6790586, 34.4938329],
              [51.6682221, 34.4927229],
              [51.6337758, 34.4880034],
              [51.6326658, 34.4874529],
              [51.6318324, 34.4874529],
              [51.6304425, 34.4871731],
              [51.6293326, 34.4866136],
              [51.6284991, 34.4866137],
              [51.6062761, 34.4821738],
              [51.6046094, 34.4821739],
              [51.5832197, 34.477725],
              [51.5726632, 34.4760556],
              [51.5154373, 34.469107],
              [51.5062134, 34.4683496],
              [51.5054374, 34.4682859],
              [51.5018274, 34.4682858],
              [51.4387682, 34.4585579],
              [51.4321016, 34.4571681],
              [51.4123786, 34.4541089],
              [51.4054319, 34.4527282],
              [51.3907088, 34.4502285],
              [51.379599, 34.4479996],
              [51.3625594, 34.445794],
              [51.3259785, 34.4410284],
              [51.3235613, 34.4410598],
              [51.3220964, 34.4416104],
              [51.3120964, 34.4413397],
              [51.3115398, 34.4416104],
              [51.3110491, 34.4416104],
              [51.3101499, 34.4416104],
              [51.3068164, 34.4421699],
              [51.3001499, 34.4427203],
              [51.29626, 34.4427203],
              [51.2945933, 34.443],
              [51.2920933, 34.4430001],
              [51.2865402, 34.4438393],
              [51.2568138, 34.4460592],
              [51.2315375, 34.4466097],
              [51.2309809, 34.4463299],
              [51.209591, 34.4454997],
              [51.2020912, 34.44522],
              [51.1973679, 34.4452199],
              [51.1959778, 34.4449402],
              [51.188758, 34.4446694],
              [51.1807015, 34.4446694],
              [51.1793115, 34.4443896],
              [51.1773681, 34.4443897],
              [51.1473651, 34.4391105],
              [51.1459752, 34.438551],
              [51.1431986, 34.4377208],
              [51.1273654, 34.4327213],
              [51.1229187, 34.4302216],
              [51.1201422, 34.4285521],
              [51.115727, 34.4170262],
              [51.1062723, 34.4166048],
              [51.0900306, 34.417602],
              [51.086769, 34.4159026],
              [51.0847949, 34.4119374],
              [51.0778578, 34.4052138],
              [51.0690321, 34.3987266],
              [51.0599847, 34.3958991],
              [51.0467418, 34.3913004],
              [51.0397978, 34.3874424],
              [51.0306581, 34.3800919],
              [51.0221892, 34.369401],
              [51.0184792, 34.3610443],
              [51.0147809, 34.3540495],
              [51.012336, 34.3438541],
              [51.0115962, 34.3383592],
              [51.0123538, 34.3325927],
              [51.0134177, 34.3283861],
              [51.0190486, 34.3228819],
              [51.029005, 34.3160767],
              [51.0331248, 34.312532],
              [51.0360248, 34.3047654],
              [51.0363014, 34.2999669],
              [51.0351831, 34.2941833],
              [51.0314507, 34.2870175],
              [51.0274739, 34.2801981],
              [51.0202293, 34.2694202],
              [51.0094788, 34.2579192],
              [51.0044814, 34.253266],
              [50.9982299, 34.2456367],
              [50.9979, 34.2355141],
              [50.9979731, 34.2280736],
              [50.9946889, 34.2204261],
              [50.9892958, 34.212482],
              [50.9811114, 34.2010837],
              [50.9777382, 34.1892289],
              [50.9794215, 34.1831032],
              [50.9756183, 34.1747431],
              [50.9695243, 34.1692041],
              [50.9642886, 34.164517],
              [50.9587955, 34.1618893],
              [50.9532061, 34.1599682],
              [50.9466677, 34.1590376],
              [50.9380035, 34.1581799],
              [50.9342602, 34.1582668],
              [50.9282821, 34.1593659],
              [50.9299439, 34.1563956],
              [50.9315006, 34.1486309],
              [50.931924, 34.1407814],
              [50.9343024, 34.1371138],
              [50.9406423, 34.1327301],
              [50.9518015, 34.1149403],
              [50.9518014, 34.1146606],
              [50.9526347, 34.1124312],
              [50.9529114, 34.1116009],
              [50.961248, 34.1052195],
              [50.968748, 34.0974393],
              [50.9693013, 34.0974393],
              [50.9806912, 34.0915996],
              [50.9815244, 34.0907692],
              [50.9837477, 34.088269],
              [50.9837477, 34.0879892],
              [50.9859712, 34.0849384],
              [50.993191, 34.081328],
              [50.9940242, 34.0813281],
              [50.9943044, 34.0810482],
              [50.9998609, 34.0796583],
              [51.0000233, 34.0788906],
              [51.0004142, 34.0771581],
              [51.0018043, 34.0766075],
              [51.0209649, 34.0654905],
              [51.0236357, 34.064549],
              [51.0276011, 34.0625439],
              [51.0290688, 34.0616053],
              [51.0296353, 34.060816],
              [51.0298413, 34.0594934],
              [51.029352, 34.0564216],
              [51.0285538, 34.0494241],
              [51.0277813, 34.0461172],
              [51.0279873, 34.0443463],
              [51.0281418, 34.0432582],
              [51.0280646, 34.0411672],
              [51.0274981, 34.0388628],
              [51.0270346, 34.0375825],
              [51.0268029, 34.0354914],
              [51.0275753, 34.0336563],
              [51.0292748, 34.0327814],
              [51.0318497, 34.0314157],
              [51.0344246, 34.0306902],
              [51.0401667, 34.0292818],
              [51.0462435, 34.0286203],
              [51.0537108, 34.0280654],
              [51.0538653, 34.0266356],
              [51.0539425, 34.0240534],
              [51.054097, 34.0145775],
              [51.0553587, 34.0103941],
              [51.0523203, 34.0045241],
              [51.0453938, 33.9975864],
              [51.0441836, 33.995537],
              [51.0403727, 33.989538],
              [51.0384158, 33.9866984],
              [51.0356091, 33.9830047],
              [51.0348109, 33.9784568],
              [51.0348109, 33.9763429],
              [51.0340384, 33.975019],
              [51.030485, 33.9719654],
              [51.0293263, 33.970556],
              [51.0289915, 33.9681856],
              [51.0281418, 33.9663277],
              [51.0263651, 33.9620992],
              [51.0262364, 33.9600062],
              [51.0270604, 33.9577851],
              [51.0282877, 33.9548253],
              [51.0351408, 33.9493826],
              [51.0354173, 33.9491028],
              [51.0387506, 33.9463226],
              [51.0390273, 33.9460428],
              [51.0484739, 33.9368718],
              [51.0487506, 33.9366011],
              [51.0487506, 33.9349311],
              [51.0487507, 33.9347913],
              [51.0484071, 33.9330564],
              [51.0481938, 33.9288202],
              [51.0451406, 33.9232688],
              [51.0449459, 33.9197933],
              [51.0448605, 33.918268],
              [51.0454172, 33.9160475],
              [51.0460226, 33.914733],
              [51.0470841, 33.9124278],
              [51.0476407, 33.912157],
              [51.0476407, 33.9115973],
              [51.0481535, 33.9107632],
              [51.0498605, 33.9079867],
              [51.0495839, 33.9077159],
              [51.0481938, 33.9027151],
              [51.0473606, 33.9024353],
              [51.0468073, 33.9024353],
              [51.043474, 33.8988156],
              [51.0426408, 33.8963242],
              [51.0390274, 33.8882633],
              [51.0393073, 33.8868732],
              [51.0401407, 33.8827118],
              [51.0415273, 33.8763209],
              [51.0418074, 33.8754904],
              [51.0379175, 33.8627085],
              [51.0373609, 33.8621578],
              [51.0359741, 33.860208],
              [51.0320842, 33.8529864],
              [51.0326375, 33.8496556],
              [51.0351408, 33.8465955],
              [51.0362508, 33.8460448],
              [51.0484739, 33.8338224],
              [51.0484739, 33.8332627],
              [51.0504174, 33.8296519],
              [51.050694, 33.8279819],
              [51.050974, 33.8274312],
              [51.049584, 33.8202096],
              [51.0487508, 33.8188195],
              [51.0468074, 33.8157683],
              [51.0237511, 33.7860422],
              [51.0093045, 33.7729798],
              [50.9998615, 33.7677079],
              [50.9912482, 33.7640971],
              [50.989305, 33.7635374],
              [50.979025, 33.7579856],
              [50.9750468, 33.7550939],
              [50.9746741, 33.7485365],
              [50.9737235, 33.7477378],
              [50.9677219, 33.7472519],
              [50.9653653, 33.7483407],
              [50.960647, 33.7481525],
              [50.9543213, 33.7484194],
              [50.9482521, 33.7492101],
              [50.9338727, 33.7476744],
              [50.9214387, 33.7466678],
              [50.9124469, 33.7453249],
              [50.9015785, 33.7446867],
              [50.8959802, 33.7439878],
              [50.8825913, 33.7441027],
              [50.8778516, 33.743252],
              [50.8716359, 33.7431807],
              [50.8536554, 33.7448993],
              [50.8420302, 33.7452383],
              [50.8265743, 33.7448106],
              [50.8163634, 33.7452782],
              [50.8052503, 33.744247],
              [50.7971713, 33.7431051],
              [50.7831042, 33.7399867],
              [50.7743551, 33.7363822],
              [50.7693353, 33.7340924],
              [50.7633949, 33.7312016],
              [50.7592516, 33.7290434],
              [50.7571071, 33.727937],
              [50.7584613, 33.7240969],
              [50.7548479, 33.7232574],
              [50.7540145, 33.7235373],
              [50.752628, 33.7235372],
              [50.7520714, 33.7238171],
              [50.7445714, 33.7238171],
              [50.7442913, 33.7240969],
              [50.7420715, 33.7243677],
              [50.7381815, 33.7243677],
              [50.7379048, 33.7246476],
              [50.7370715, 33.7246476],
              [50.7351249, 33.7252073],
              [50.7337381, 33.7252073],
              [50.7304016, 33.7263176],
              [50.7292916, 33.7263176],
              [50.7242917, 33.7277079],
              [50.7187351, 33.7277078],
              [50.7156818, 33.7265975],
              [50.7040117, 33.7271481],
              [50.7006785, 33.7263176],
              [50.6904021, 33.7207657],
              [50.6595661, 33.6965903],
              [50.6556757, 33.6957598],
              [50.6465095, 33.691869],
              [50.6426227, 33.6896482],
              [50.6290095, 33.6796457],
              [50.6128964, 33.671873],
              [50.61151, 33.6707627],
              [50.6095631, 33.6699231],
              [50.6084534, 33.6690925],
              [50.6070631, 33.6685419],
              [50.5956733, 33.6621504],
              [50.5934535, 33.6604803],
              [50.5881736, 33.6549283],
              [50.5876201, 33.6546484],
              [50.5873409, 33.6543677],
              [50.5870635, 33.6540887],
              [50.586787, 33.6538179],
              [50.5867868, 33.6535381],
              [50.5831736, 33.6460362],
              [50.5798402, 33.6435355],
              [50.5776168, 33.6365932],
              [50.5778969, 33.6363134],
              [50.5776168, 33.6340925],
              [50.5756738, 33.6315919],
              [50.5748403, 33.631312],
              [50.5742836, 33.6307614],
              [50.5631739, 33.6282607],
              [50.5612306, 33.6282607],
              [50.5601172, 33.6279807],
              [50.5587274, 33.6282606],
              [50.5428943, 33.6299308],
              [50.5376175, 33.6304815],
              [50.5292842, 33.6332529],
              [50.528171, 33.633253],
              [50.5267846, 33.6338126],
              [50.5256709, 33.6338126],
              [50.5251177, 33.6340925],
              [50.5126144, 33.6360335],
              [50.4837246, 33.6343632],
              [50.4737248, 33.6313119],
              [50.4695584, 33.6313119],
              [50.4687252, 33.631032],
              [50.4673349, 33.631032],
              [50.4667817, 33.6313119],
              [50.4656685, 33.6313119],
              [50.4642786, 33.6318717],
              [50.4598352, 33.6327021],
              [50.4573351, 33.6332528],
              [50.4559452, 33.6332528],
              [50.4556687, 33.6335417],
              [50.455112, 33.6335417],
              [50.4540018, 33.6343633],
              [50.4537253, 33.6346521],
              [50.4523354, 33.6338125],
              [50.4495588, 33.6332528],
              [50.4448352, 33.6315918],
              [50.4320557, 33.6246495],
              [50.4253892, 33.6226995],
              [50.4220556, 33.6224286],
              [50.4214988, 33.6226995],
              [50.4206656, 33.6224286],
              [50.4192793, 33.6224286],
              [50.4181656, 33.6221487],
              [50.4164991, 33.6221488],
              [50.4156659, 33.6218689],
              [50.4142792, 33.6218689],
              [50.4134459, 33.621589],
              [50.4117791, 33.621589],
              [50.4112225, 33.6213092],
              [50.4067759, 33.6210383],
              [50.400666, 33.6210383],
              [50.4001094, 33.6207585],
              [50.3992762, 33.6210383],
              [50.3987226, 33.6207585],
              [50.3934428, 33.6207584],
              [50.3928893, 33.6204786],
              [50.3909428, 33.6204786],
              [50.3884427, 33.6204786],
              [50.3884428, 33.6201987],
              [50.3864993, 33.6199279],
              [50.384274, 33.6199256],
              [50.3839997, 33.619648],
              [50.3831661, 33.6199279],
              [50.3823329, 33.6199279],
              [50.3820528, 33.619648],
              [50.380943, 33.6196481],
              [50.3801098, 33.6193682],
              [50.3787194, 33.6193682],
              [50.3781663, 33.619648],
              [50.3770531, 33.6196481],
              [50.3681631, 33.6177071],
              [50.3667763, 33.6177071],
              [50.3659431, 33.6174272],
              [50.3609433, 33.6174272],
              [50.3598297, 33.6171474],
              [50.3578867, 33.6171473],
              [50.3570531, 33.6168675],
              [50.3534432, 33.6168675],
              [50.3526065, 33.6165876],
              [50.3481635, 33.6163168],
              [50.3476068, 33.6165876],
              [50.3370535, 33.615757],
              [50.3370534, 33.6154772],
              [50.331217, 33.6135363],
              [50.3281634, 33.6099252],
              [50.3267736, 33.6071446],
              [50.3259403, 33.6049238],
              [50.3184406, 33.5957606],
              [50.3164972, 33.5946502],
              [50.2951043, 33.5849272],
              [50.2942706, 33.5849273],
              [50.2937175, 33.5846473],
              [50.2928842, 33.5846474],
              [50.2923276, 33.5843675],
              [50.2895509, 33.5843675],
              [50.2889943, 33.5840876],
              [50.2787175, 33.5829772],
              [50.2751043, 33.5826973],
              [50.2731613, 33.5824265],
              [50.2614946, 33.5835369],
              [50.2589945, 33.5843674],
              [50.2562144, 33.5865883],
              [50.2487146, 33.600482],
              [50.243438, 33.6043729],
              [50.2409383, 33.6046438],
              [50.2403816, 33.604373],
              [50.2389913, 33.6043729],
              [50.2381581, 33.604093],
              [50.2353814, 33.6035334],
              [50.2328815, 33.6027028],
              [50.2306583, 33.6002021],
              [50.228715, 33.5932507],
              [50.2259348, 33.5888091],
              [50.2153784, 33.5799258],
              [50.211212, 33.5777048],
              [50.2101018, 33.5757548],
              [50.2098252, 33.5743736],
              [50.2098253, 33.5707534],
              [50.2095452, 33.5685326],
              [50.2048251, 33.5596401],
              [50.2037118, 33.556038],
              [50.2034352, 33.5524269],
              [50.203992, 33.5507567],
              [50.2046897, 33.5495951],
              [50.206492, 33.5465949],
              [50.206492, 33.5446448],
              [50.2064921, 33.5440941],
              [50.2056588, 33.542424],
              [50.1917691, 33.5310397],
              [50.1906553, 33.5310397],
              [50.1884353, 33.53048],
              [50.1867689, 33.5304799],
              [50.1859358, 33.5302001],
              [50.1839888, 33.5302001],
              [50.1831556, 33.5299202],
              [50.1762125, 33.5285299],
              [50.1492663, 33.5229777],
              [50.1431528, 33.5204769],
              [50.1387094, 33.5190867],
              [50.09732, 33.5068626],
              [50.0845404, 33.5049215],
              [50.0798169, 33.5043708],
              [50.0789836, 33.504082],
              [50.0764836, 33.5038111],
              [50.073707, 33.5038111],
              [50.0725972, 33.5035312],
              [50.071207, 33.5035313],
              [50.0545406, 33.5010304],
              [50.052594, 33.5010304],
              [50.0514839, 33.5007506],
              [50.0342609, 33.4996491],
              [50.0284275, 33.4996491],
              [50.0270377, 33.4993603],
              [49.987315, 33.4940878],
              [49.9853682, 33.4929773],
              [49.9837016, 33.4924176],
              [49.9745351, 33.4801935],
              [49.973425, 33.4771421],
              [49.973425, 33.4765823],
              [49.9731449, 33.4757517],
              [49.9720351, 33.4676986],
              [49.9723117, 33.4663083],
              [49.9903683, 33.4401989],
              [49.990925, 33.4351972],
              [49.9912016, 33.4332562],
              [49.9914817, 33.4326964],
              [49.9903684, 33.4199214],
              [49.9898148, 33.4196415],
              [49.9856483, 33.4171408],
              [49.9825917, 33.4171408],
              [49.9823151, 33.4168608],
              [49.9812019, 33.4168608],
              [49.9809252, 33.416581],
              [49.9784252, 33.4163102],
              [49.9748118, 33.4163102],
              [49.9745352, 33.4160303],
              [49.9687019, 33.4160302],
              [49.9656453, 33.4171407],
              [49.9637018, 33.4171407],
              [49.9625921, 33.4168608],
              [49.9606455, 33.4163101],
              [49.959812, 33.4157504],
              [49.9592588, 33.4135294],
              [49.9578689, 33.407977],
              [49.9500887, 33.3951929],
              [49.9478688, 33.3874196],
              [49.9484224, 33.3871397],
              [49.9487024, 33.3865799],
              [49.951479, 33.3835283],
              [49.951479, 33.3829776],
              [49.9520357, 33.3826978],
              [49.9620355, 33.3763057],
              [49.9767584, 33.3721436],
              [49.9903685, 33.373534],
              [49.9959249, 33.3749153],
              [49.9975917, 33.3749153],
              [49.998705, 33.3751952],
              [50.0023148, 33.3754751],
              [50.0028714, 33.3754751],
              [50.0034249, 33.375755],
              [50.0064817, 33.375755],
              [50.0100916, 33.3743646],
              [50.0106482, 33.3738049],
              [50.0153713, 33.3715839],
              [50.018148, 33.3685323],
              [50.0198148, 33.3640813],
              [50.0195382, 33.3615895],
              [50.0184281, 33.3601901],
              [50.0167617, 33.36047],
              [50.0162049, 33.3601901],
              [50.0139815, 33.3593595],
              [50.0137049, 33.3588088],
              [50.0125916, 33.357969],
              [50.0070384, 33.3488052],
              [50.0059251, 33.3440833],
              [49.9959249, 33.3232456],
              [49.9953718, 33.3163027],
              [49.9956485, 33.3154721],
              [49.9959249, 33.3146414],
              [49.9967586, 33.3129712],
              [49.9981485, 33.31103],
              [49.998425, 33.3104703],
              [50.000372, 33.3074187],
              [50.0000919, 33.3068589],
              [50.0000919, 33.3060283],
              [49.9987051, 33.3035274],
              [49.9970387, 33.3015772],
              [49.9709257, 33.2807483],
              [49.9678691, 33.279078],
              [49.9673123, 33.2782473],
              [49.9620358, 33.2704737],
              [49.961479, 33.269914],
              [49.9595356, 33.2688034],
              [49.958979, 33.2685235],
              [49.9578692, 33.2676929],
              [49.9570356, 33.267413],
              [49.9473123, 33.2574092],
              [49.9464792, 33.2499155],
              [49.9450893, 33.2488049],
              [49.9428693, 33.248805],
              [49.9423127, 33.2490849],
              [49.9409228, 33.2490849],
              [49.9375892, 33.2471437],
              [49.9359227, 33.2424127],
              [49.9361994, 33.241582],
              [49.9384228, 33.239361],
              [49.9389795, 33.239361],
              [49.9389794, 33.2390811],
              [49.9395361, 33.2390811],
              [49.9400893, 33.2388012],
              [49.9417561, 33.2376907],
              [49.9423128, 33.2371399],
              [49.9462026, 33.2343591],
              [49.9473125, 33.2326888],
              [49.9470359, 33.2299169],
              [49.9464793, 33.229917],
              [49.9442561, 33.2288065],
              [49.9437027, 33.2290773],
              [49.9392561, 33.2290774],
              [49.9384228, 33.2293572],
              [49.9328661, 33.2293571],
              [49.9320329, 33.2296371],
              [49.9298129, 33.229637],
              [49.9289797, 33.229917],
              [49.9250898, 33.2301878],
              [49.9206464, 33.2301878],
              [49.9150896, 33.2285265],
              [49.9050898, 33.2240844],
              [49.89981, 33.2218543],
              [49.8989768, 33.2218543],
              [49.8948099, 33.2210237],
              [49.8895336, 33.2196333],
              [49.8875867, 33.2179719],
              [49.8773103, 33.2040768],
              [49.8770303, 33.2029661],
              [49.8714771, 33.191301],
              [49.871197, 33.1876895],
              [49.8725869, 33.1826875],
              [49.8809202, 33.1718531],
              [49.8823102, 33.1685214],
              [49.88842, 33.1518632],
              [49.8887001, 33.1507527],
              [49.890367, 33.144911],
              [49.8906435, 33.1446311],
              [49.890367, 33.1438005],
              [49.8898104, 33.1407396],
              [49.8892537, 33.139909],
              [49.8887002, 33.139909],
              [49.8884201, 33.1396291],
              [49.8803637, 33.1379678],
              [49.8775871, 33.134907],
              [49.8770304, 33.1340855],
              [49.8767539, 33.1321351],
              [49.8775871, 33.1301939],
              [49.8778636, 33.1296341],
              [49.878977, 33.1285236],
              [49.878977, 33.1282436],
              [49.8795304, 33.1279729],
              [49.9187001, 33.1004708],
              [49.9189801, 33.0996311],
              [49.9198134, 33.0971302],
              [49.9203665, 33.0962994],
              [49.9211998, 33.0943582],
              [49.9217568, 33.0940783],
              [49.9220333, 33.0932386],
              [49.9228666, 33.092417],
              [49.9231467, 33.0915773],
              [49.9239798, 33.0901868],
              [49.9242565, 33.0896361],
              [49.9220334, 33.0732485],
              [49.9214799, 33.0721379],
              [49.9148102, 33.0657454],
              [49.9142567, 33.0657455],
              [49.9103668, 33.064075],
              [49.9095336, 33.0638042],
              [49.9084234, 33.0638042],
              [49.9070335, 33.0632444],
              [49.9053667, 33.0632444],
              [49.90481, 33.0629645],
              [49.9037002, 33.0629645],
              [49.9014767, 33.0624138],
              [49.9000869, 33.0624138],
              [49.8989771, 33.0621339],
              [49.8975868, 33.0621338],
              [49.8967536, 33.0618539],
              [49.8956439, 33.0618538],
              [49.8948102, 33.0621338],
              [49.8928672, 33.0621339],
              [49.8925872, 33.0624137],
              [49.8714773, 33.069077],
              [49.8698105, 33.069077],
              [49.8689773, 33.0693569],
              [49.8653639, 33.069357],
              [49.8648108, 33.069077],
              [49.8636975, 33.0690771],
              [49.8598076, 33.0668559],
              [49.858974, 33.0657453],
              [49.8570309, 33.0629645],
              [49.8564743, 33.0624137],
              [49.8542543, 33.0571317],
              [49.8498075, 33.0535201],
              [49.8489742, 33.0535201],
              [49.8411979, 33.0501884],
              [49.8398075, 33.0501883],
              [49.8389743, 33.0499084],
              [49.837308, 33.0499084],
              [49.8364743, 33.0501884],
              [49.8345314, 33.0501883],
              [49.8098081, 33.0565808],
              [49.7856386, 33.0610231],
              [49.7828619, 33.0615738],
              [49.7809149, 33.0615738],
              [49.7803619, 33.0618537],
              [49.7795286, 33.0618537],
              [49.7661921, 33.0643547],
              [49.7620255, 33.0660251],
              [49.7548055, 33.0679663],
              [49.7456354, 33.0715779],
              [49.7445256, 33.0715779],
              [49.7425822, 33.0721377],
              [49.7373024, 33.073799],
              [49.7281358, 33.0826925],
              [49.7261924, 33.0835232],
              [49.7248024, 33.0840739],
              [49.724246, 33.0843539],
              [49.722026, 33.0843538],
              [49.7188335, 33.0822699],
              [49.7178594, 33.0815819],
              [49.7125794, 33.0751895],
              [49.7036896, 33.0715778],
              [49.7017462, 33.0715778],
              [49.7011895, 33.0718577],
              [49.6989696, 33.0718578],
              [49.698413, 33.0715778],
              [49.6967461, 33.0715778],
              [49.6964695, 33.0712979],
              [49.6956364, 33.0712979],
              [49.6909129, 33.0699075],
              [49.685633, 33.0663048],
              [49.6797998, 33.0568515],
              [49.6717433, 33.0512987],
              [49.6689667, 33.0501881],
              [49.66591, 33.0432448],
              [49.6656335, 33.040193],
              [49.6659101, 33.037132],
              [49.6686902, 33.0274078],
              [49.6678567, 33.0221349],
              [49.6556337, 33.0140719],
              [49.6539669, 33.0115799],
              [49.6539669, 33.0104693],
              [49.6536869, 33.0101894],
              [49.6550771, 33.0074084],
              [49.6645233, 33.0018555],
              [49.6706333, 32.9987947],
              [49.6834133, 32.9940725],
              [49.6861899, 32.9935218],
              [49.6917466, 32.9935217],
              [49.6920232, 32.9938017],
              [49.6989698, 32.9938017],
              [49.6992463, 32.9935218],
              [49.699803, 32.9935217],
              [49.7003565, 32.9929619],
              [49.7009132, 32.992962],
              [49.7048032, 32.9901901],
              [49.7059128, 32.9887995],
              [49.7059129, 32.9885197],
              [49.7064696, 32.9874091],
              [49.7075798, 32.9846372],
              [49.7075797, 32.9843572],
              [49.7075797, 32.9837974],
              [49.7075797, 32.9835176],
              [49.7078563, 32.9832467],
              [49.7078563, 32.982407],
              [49.7050797, 32.9801858],
              [49.6998031, 32.9779646],
              [49.6959131, 32.9779646],
              [49.6953565, 32.9776847],
              [49.6948033, 32.9779646],
              [49.6936896, 32.9776847],
              [49.6864665, 32.9757435],
              [49.6853567, 32.9749037],
              [49.6842464, 32.9735222],
              [49.6803566, 32.9712921],
              [49.6786902, 32.9710212],
              [49.6784136, 32.9707413],
              [49.6772999, 32.9707413],
              [49.6764667, 32.9704614],
              [49.6725767, 32.9704614],
              [49.6720236, 32.9707413],
              [49.6703568, 32.9707413],
              [49.6509102, 32.9782444],
              [49.6453539, 32.9787952],
              [49.6417437, 32.9787952],
              [49.6409105, 32.9785153],
              [49.6406339, 32.9782445],
              [49.6531235, 32.9764083],
              [49.6506785, 32.9755246],
              [49.6500063, 32.97382],
              [49.6498081, 32.9717615]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241478,
        "tags": {
          "ISO3166-2": "IR-17",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "کهگیلویه و بویراحمد",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q180068"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [49.8863183, 30.9644455],
              [49.8862115, 30.9642596],
              [49.8865088, 30.9625502],
              [49.887024, 30.9607005],
              [49.8877565, 30.9594053],
              [49.8884887, 30.9583876],
              [49.8904616, 30.9569216],
              [49.8908654, 30.9566215],
              [49.8936196, 30.9553595],
              [49.8972626, 30.9524808],
              [49.9036483, 30.9476021],
              [49.9130823, 30.9399404],
              [49.9169313, 30.9371058],
              [49.9181442, 30.9360852],
              [49.918934, 30.935573],
              [49.9195672, 30.9351091],
              [49.920044, 30.9349213],
              [49.9207345, 30.9349181],
              [49.9213754, 30.935052],
              [49.9219094, 30.9350971],
              [49.9225464, 30.9351407],
              [49.9230768, 30.9349512],
              [49.92371, 30.9347196],
              [49.9242936, 30.9343929],
              [49.92519, 30.9338815],
              [49.9252929, 30.9336027],
              [49.9253921, 30.933096],
              [49.9253885, 30.9327711],
              [49.9253274, 30.9320353],
              [49.9249953, 30.9312521],
              [49.9246675, 30.9305614],
              [49.9243432, 30.9299632],
              [49.9240151, 30.9294101],
              [49.9236372, 30.9289513],
              [49.9233131, 30.9286306],
              [49.9233094, 30.9282606],
              [49.9234123, 30.9278915],
              [49.9236754, 30.9277065],
              [49.9243128, 30.9276554],
              [49.9250604, 30.9278376],
              [49.9260216, 30.9282471],
              [49.9274672, 30.9289809],
              [49.9285392, 30.9295266],
              [49.9303092, 30.9306262],
              [49.9311638, 30.9310371],
              [49.9315911, 30.9311737],
              [49.9321282, 30.9312326],
              [49.9323921, 30.9312615],
              [49.9329757, 30.9311648],
              [49.9335098, 30.9312549],
              [49.9341544, 30.9318512],
              [49.934536, 30.9324521],
              [49.9348677, 30.9336007],
              [49.9352035, 30.9346163],
              [49.9355277, 30.9352618],
              [49.935852, 30.9356276],
              [49.9358658, 30.935721],
              [49.9359132, 30.9360432],
              [49.9357032, 30.9363663],
              [49.9352799, 30.9363695],
              [49.9343225, 30.9363729],
              [49.9328346, 30.9365659],
              [49.932728, 30.9366575],
              [49.9321443, 30.9368467],
              [49.9318277, 30.9370786],
              [49.9318351, 30.9375862],
              [49.9321593, 30.937907],
              [49.93264, 30.9381816],
              [49.9334412, 30.938407],
              [49.9341353, 30.9384962],
              [49.9353066, 30.9385352],
              [49.9361572, 30.9383459],
              [49.937107, 30.9378823],
              [49.9377403, 30.9374635],
              [49.9381064, 30.9370469],
              [49.9386253, 30.9361219],
              [49.939041, 30.9352884],
              [49.9392509, 30.9349202],
              [49.939617, 30.934639],
              [49.9398843, 30.9346389],
              [49.9402542, 30.9346375],
              [49.9405783, 30.9348206],
              [49.9408493, 30.9352807],
              [49.9411735, 30.9356939],
              [49.9415512, 30.9359676],
              [49.9418715, 30.9361056],
              [49.9422454, 30.9361042],
              [49.942562, 30.9358722],
              [49.9430848, 30.9352674],
              [49.9438704, 30.9342949],
              [49.9454421, 30.9325348],
              [49.946808, 30.9312827],
              [49.9475441, 30.9307248],
              [49.9488641, 30.9301671],
              [49.9500807, 30.9296988],
              [49.9507713, 30.9296007],
              [49.9511414, 30.9293713],
              [49.9512367, 30.9285849],
              [49.9511222, 30.9264444],
              [49.9509507, 30.9232344],
              [49.9510957, 30.9183927],
              [49.9511185, 30.9088424],
              [49.9513512, 30.9063044],
              [49.9511643, 30.9044601],
              [49.950981, 30.9028007],
              [49.9506415, 30.9012799],
              [49.9500389, 30.900084],
              [49.94944, 30.8988408],
              [49.9484596, 30.8970937],
              [49.9479026, 30.8954335],
              [49.9478149, 30.8928974],
              [49.9477959, 30.8913747],
              [49.9485626, 30.8893418],
              [49.9492835, 30.8877236],
              [49.9505233, 30.8853201],
              [49.9510383, 30.8845001],
              [49.9513917, 30.8839374],
              [49.9515057, 30.8837558],
              [49.9527475, 30.8812508],
              [49.9548836, 30.8782884],
              [49.9555053, 30.877364],
              [49.9577904, 30.8776306],
              [49.9619293, 30.8776571],
              [49.968197, 30.8778606],
              [49.9744035, 30.8779234],
              [49.9787026, 30.8779507],
              [49.9856452, 30.877412],
              [49.9922142, 30.8767844],
              [50.0001564, 30.874376],
              [50.0039788, 30.8741168],
              [50.0087051, 30.8739117],
              [50.013855, 30.8737074],
              [50.0196419, 30.873228],
              [50.0250053, 30.8723753],
              [50.0303689, 30.8716171],
              [50.0333405, 30.8713077],
              [50.035267, 30.8685769],
              [50.0401801, 30.8629426],
              [50.0435448, 30.8586929],
              [50.0479164, 30.8538415],
              [50.0528181, 30.8487187],
              [50.0578269, 30.8428543],
              [50.0613443, 30.8386052],
              [50.0654909, 30.8346381],
              [50.0687905, 30.8309467],
              [50.0690295, 30.8306933],
              [50.0697479, 30.8299317],
              [50.0706565, 30.8309732],
              [50.0724335, 30.8330097],
              [50.0766565, 30.8369333],
              [50.0809859, 30.8406229],
              [50.086006, 30.8445044],
              [50.0891227, 30.8468881],
              [50.0962639, 30.8522639],
              [50.0986442, 30.8541798],
              [50.1022949, 30.8566594],
              [50.1055261, 30.8587638],
              [50.1094437, 30.860733],
              [50.1117746, 30.8621385],
              [50.1146353, 30.8644725],
              [50.117176, 30.8667613],
              [50.1188203, 30.8680673],
              [50.1197028, 30.8685872],
              [50.1205675, 30.8690965],
              [50.1223678, 30.8704058],
              [50.1235885, 30.8712464],
              [50.1249658, 30.8725979],
              [50.1262932, 30.8739062],
              [50.128254, 30.8761413],
              [50.1301613, 30.8783309],
              [50.1322289, 30.8805216],
              [50.1336595, 30.882153],
              [50.1357306, 30.8837842],
              [50.1384887, 30.8862568],
              [50.1431617, 30.8901316],
              [50.1461335, 30.8926957],
              [50.1499594, 30.8954503],
              [50.1527749, 30.8978283],
              [50.1564941, 30.9005369],
              [50.1606943, 30.9037561],
              [50.1644708, 30.9062325],
              [50.168564, 30.908986],
              [50.1741525, 30.9122114],
              [50.1804846, 30.9163233],
              [50.1865006, 30.919596],
              [50.1935807, 30.9232901],
              [50.1977386, 30.9255333],
              [50.2045593, 30.9296899],
              [50.2090912, 30.9322577],
              [50.2097283, 30.932354],
              [50.2104225, 30.9322635],
              [50.2108461, 30.9316661],
              [50.2115289, 30.9292115],
              [50.213482, 30.9244052],
              [50.2151109, 30.9183923],
              [50.2174186, 30.9097871],
              [50.2181014, 30.907337],
              [50.2183609, 30.9062265],
              [50.2185668, 30.9044682],
              [50.2190362, 30.9017845],
              [50.2195587, 30.8993808],
              [50.2201843, 30.8964656],
              [50.2206775, 30.8942058],
              [50.2210732, 30.8923926],
              [50.2217485, 30.8884604],
              [50.2231559, 30.8814286],
              [50.2238807, 30.8774042],
              [50.2240333, 30.8751809],
              [50.2242927, 30.8737005],
              [50.2244989, 30.8724971],
              [50.2247086, 30.8716186],
              [50.2251816, 30.8703244],
              [50.225387, 30.8698891],
              [50.22723, 30.8659831],
              [50.228592, 30.8621947],
              [50.2293816, 30.8606227],
              [50.2305947, 30.8586381],
              [50.2322771, 30.8555441],
              [50.2333795, 30.8533287],
              [50.2340089, 30.8515256],
              [50.2379493, 30.8444657],
              [50.2411993, 30.8374468],
              [50.2422011, 30.8353968],
              [50.2432976, 30.8331528],
              [50.2434539, 30.8325063],
              [50.2434387, 30.8299144],
              [50.2433091, 30.82519],
              [50.2430764, 30.8211125],
              [50.2426896, 30.8178604],
              [50.2420846, 30.8127738],
              [50.2409666, 30.8116552],
              [50.2383653, 30.8089533],
              [50.236187, 30.806811],
              [50.234436, 30.8054563],
              [50.2325783, 30.8036835],
              [50.2316741, 30.8026608],
              [50.2309267, 30.8012668],
              [50.2304459, 30.8001067],
              [50.2302283, 30.7984362],
              [50.2302208, 30.7969541],
              [50.230793, 30.7945032],
              [50.2312051, 30.7921438],
              [50.2315138, 30.7905283],
              [50.2328758, 30.7879422],
              [50.2351876, 30.784624],
              [50.2368162, 30.7827365],
              [50.2373972, 30.7820344],
              [50.2377263, 30.7816365],
              [50.2379189, 30.7814008],
              [50.2404329, 30.7772965],
              [50.243309, 30.7719468],
              [50.2460289, 30.7673337],
              [50.2490157, 30.7635568],
              [50.2499919, 30.7610021],
              [50.2515412, 30.7587711],
              [50.2528573, 30.7569628],
              [50.2541769, 30.7555763],
              [50.2541923, 30.7555605],
              [50.2561264, 30.7535821],
              [50.2580224, 30.7519123],
              [50.2599656, 30.7500083],
              [50.261055, 30.7489903],
              [50.2626725, 30.7479867],
              [50.2697295, 30.7437902],
              [50.2811319, 30.7372218],
              [50.2920409, 30.7308336],
              [50.3003693, 30.7259553],
              [50.313568, 30.718338],
              [50.3155516, 30.717198],
              [50.3177489, 30.7160139],
              [50.3209572, 30.7145148],
              [50.323204, 30.7135137],
              [50.3262597, 30.7118761],
              [50.3289299, 30.7107868],
              [50.3317604, 30.7098855],
              [50.3332291, 30.7094355],
              [50.3341065, 30.7091667],
              [50.3354417, 30.7087156],
              [50.3368263, 30.7084971],
              [50.3378372, 30.7084594],
              [50.3388443, 30.7087488],
              [50.3396377, 30.7091724],
              [50.3404275, 30.7097336],
              [50.3411103, 30.7102514],
              [50.3418999, 30.7110923],
              [50.3427888, 30.7122586],
              [50.3441505, 30.7140318],
              [50.3455657, 30.7159925],
              [50.3469313, 30.7176732],
              [50.3477487, 30.7185075],
              [50.3483505, 30.7191218],
              [50.3498231, 30.7204804],
              [50.3513525, 30.7216521],
              [50.3528862, 30.7227335],
              [50.3543625, 30.7240425],
              [50.3561593, 30.7251252],
              [50.3584366, 30.7262125],
              [50.3604507, 30.7270187],
              [50.363262, 30.7280635],
              [50.3654364, 30.7287328],
              [50.368042, 30.7292666],
              [50.3703805, 30.7297066],
              [50.3730353, 30.7301932],
              [50.3772889, 30.7307889],
              [50.3812791, 30.731196],
              [50.3845788, 30.7313651],
              [50.388466, 30.731494],
              [50.3907014, 30.7314233],
              [50.3927478, 30.7313133],
              [50.392841, 30.7313077],
              [50.3942814, 30.7284716],
              [50.3967815, 30.7276412],
              [50.4117845, 30.7179121],
              [50.4148209, 30.7095593],
              [50.4151177, 30.7087426],
              [50.4153943, 30.7079123],
              [50.4153944, 30.7043707],
              [50.4153944, 30.6981923],
              [50.4151178, 30.6979125],
              [50.4142846, 30.6893026],
              [50.4142846, 30.6860279],
              [50.4142847, 30.6823624],
              [50.416254, 30.6754609],
              [50.4165046, 30.6745829],
              [50.4190046, 30.6706931],
              [50.4237277, 30.6651337],
              [50.4531741, 30.6481851],
              [50.4640264, 30.6425948],
              [50.4892869, 30.6295761],
              [50.4901201, 30.6295762],
              [50.5028964, 30.6242967],
              [50.5076201, 30.6229159],
              [50.51151, 30.6215262],
              [50.5123432, 30.6209666],
              [50.513804, 30.620318],
              [50.5169641, 30.6178093],
              [50.5198097, 30.6151195],
              [50.5233918, 30.6115977],
              [50.52602, 30.6083543],
              [50.5300177, 30.6041367],
              [50.5329589, 30.6008018],
              [50.5339013, 30.5996434],
              [50.5343743, 30.5987652],
              [50.5350533, 30.5974683],
              [50.5357856, 30.5955263],
              [50.5367776, 30.5928882],
              [50.5376624, 30.5902496],
              [50.5389672, 30.586735],
              [50.5403748, 30.5828959],
              [50.5413132, 30.5806749],
              [50.5429307, 30.5770666],
              [50.544548, 30.5747983],
              [50.5467414, 30.5711446],
              [50.5483093, 30.5691558],
              [50.5486349, 30.5687654],
              [50.5487199, 30.5685105],
              [50.548733, 30.5684709],
              [50.5492897, 30.5665216],
              [50.5495663, 30.5662419],
              [50.5495662, 30.5630552],
              [50.5491753, 30.5628671],
              [50.548542, 30.562822],
              [50.5472334, 30.5630092],
              [50.546238, 30.5634253],
              [50.5451851, 30.563566],
              [50.5443991, 30.5635656],
              [50.5434531, 30.5632915],
              [50.5426636, 30.5628759],
              [50.5419272, 30.5622281],
              [50.5411376, 30.5613523],
              [50.5406075, 30.5600127],
              [50.5404471, 30.5589947],
              [50.5403365, 30.5583942],
              [50.5402831, 30.5579767],
              [50.5402833, 30.5577917],
              [50.5401763, 30.557471],
              [50.5397034, 30.5570091],
              [50.5386008, 30.5563172],
              [50.5376549, 30.5557611],
              [50.5370752, 30.5552988],
              [50.5364419, 30.5547935],
              [50.5359192, 30.5543314],
              [50.5358125, 30.5542859],
              [50.5356027, 30.5540055],
              [50.5351792, 30.5534535],
              [50.5346528, 30.5528064],
              [50.53434, 30.5523902],
              [50.5341797, 30.5519746],
              [50.53397, 30.5517437],
              [50.5335663, 30.5515232],
              [50.5335502, 30.5515143],
              [50.5331802, 30.5514205],
              [50.5328161, 30.5514853],
              [50.5326578, 30.5515134],
              [50.5318183, 30.5518826],
              [50.530983, 30.552394],
              [50.5303535, 30.5526714],
              [50.5286752, 30.552997],
              [50.5281526, 30.5529974],
              [50.5277329, 30.5528131],
              [50.5275192, 30.5523972],
              [50.5273628, 30.5517966],
              [50.5270996, 30.5509655],
              [50.5269393, 30.5499001],
              [50.5269354, 30.549485],
              [50.5267864, 30.5487614],
              [50.5267256, 30.5484668],
              [50.5263556, 30.5477729],
              [50.5257797, 30.5470805],
              [50.5251463, 30.5464803],
              [50.5243074, 30.5458795],
              [50.523468, 30.5452334],
              [50.5226288, 30.5446326],
              [50.5213164, 30.5438472],
              [50.5202676, 30.5433854],
              [50.5193786, 30.5432467],
              [50.5188524, 30.5430621],
              [50.518013, 30.5425559],
              [50.5173341, 30.5419533],
              [50.5170173, 30.5411219],
              [50.5158616, 30.5402424],
              [50.5150758, 30.5399665],
              [50.5141333, 30.5399675],
              [50.513329, 30.540057],
              [50.5098436, 30.5382292],
              [50.5099944, 30.5377953],
              [50.5103606, 30.5372868],
              [50.5105172, 30.5367776],
              [50.5104638, 30.5363149],
              [50.5103074, 30.5359917],
              [50.5100976, 30.535806],
              [50.5093649, 30.5358077],
              [50.5085257, 30.5358091],
              [50.5079498, 30.5356693],
              [50.5076369, 30.5355779],
              [50.5075303, 30.5352075],
              [50.5075301, 30.5347924],
              [50.5076866, 30.5341884],
              [50.5077934, 30.533679],
              [50.5078429, 30.5331716],
              [50.5076333, 30.5324782],
              [50.5073205, 30.5321093],
              [50.5069543, 30.5315981],
              [50.5065878, 30.5310891],
              [50.5060119, 30.5305816],
              [50.5050162, 30.5301672],
              [50.5039711, 30.5297955],
              [50.5027657, 30.5292405],
              [50.5017205, 30.5289658],
              [50.500885, 30.528455],
              [50.500044, 30.5281788],
              [50.49905, 30.5275749],
              [50.4986838, 30.527014],
              [50.4980011, 30.5266369],
              [50.4973184, 30.526632],
              [50.4965857, 30.5267646],
              [50.4957074, 30.5270764],
              [50.4937305, 30.5270764],
              [50.4937305, 30.5273561],
              [50.4928969, 30.5273561],
              [50.4926203, 30.5276359],
              [50.4892871, 30.5290166],
              [50.486414, 30.5279651],
              [50.4809537, 30.5259664],
              [50.4799358, 30.5260427],
              [50.4791718, 30.5261479],
              [50.4782295, 30.5263246],
              [50.477703, 30.5264128],
              [50.4770735, 30.5263155],
              [50.4763411, 30.5261682],
              [50.4763044, 30.5261648],
              [50.4760299, 30.5261395],
              [50.4754325, 30.5260846],
              [50.4751207, 30.5262371],
              [50.4742872, 30.5262371],
              [50.470664, 30.5271002],
              [50.4665655, 30.5280763],
              [50.4626174, 30.5290165],
              [50.4618168, 30.5291406],
              [50.4600677, 30.5298737],
              [50.4579696, 30.5304583],
              [50.4564438, 30.5308151],
              [50.4552382, 30.5310357],
              [50.4537164, 30.5312549],
              [50.4524574, 30.5312451],
              [50.4515112, 30.5312817],
              [50.4502524, 30.5313644],
              [50.4486238, 30.5316282],
              [50.4477311, 30.5317598],
              [50.4468918, 30.5320292],
              [50.4460487, 30.5324858],
              [50.4446793, 30.5334478],
              [50.443947, 30.5336274],
              [50.4433669, 30.5336655],
              [50.4428939, 30.5336635],
              [50.4419518, 30.5333775],
              [50.4408531, 30.532626],
              [50.4394913, 30.5319186],
              [50.4388123, 30.5315886],
              [50.4381294, 30.5313961],
              [50.4374505, 30.5313909],
              [50.4362946, 30.5314739],
              [50.4353485, 30.5316029],
              [50.4345093, 30.531782],
              [50.4339828, 30.5319625],
              [50.4335098, 30.5321431],
              [50.4331932, 30.5321869],
              [50.4325675, 30.5319495],
              [50.4320947, 30.5318076],
              [50.4313089, 30.5314297],
              [50.430889, 30.5311459],
              [50.4291612, 30.5309917],
              [50.4279517, 30.5312142],
              [50.4264296, 30.5312933],
              [50.4245413, 30.5312759],
              [50.4237021, 30.5311301],
              [50.4202462, 30.5300815],
              [50.4169997, 30.5291715],
              [50.4155809, 30.5291606],
              [50.4105989, 30.5287434],
              [50.4071923, 30.5285271],
              [50.4034653, 30.5284966],
              [50.401947, 30.5283904],
              [50.4006882, 30.5281003],
              [50.3993264, 30.5278121],
              [50.3980178, 30.5276143],
              [50.3967662, 30.5271928],
              [50.3937797, 30.5261869],
              [50.3894348, 30.5250364],
              [50.387863, 30.5247448],
              [50.3870811, 30.5244592],
              [50.3866615, 30.52427],
              [50.3864555, 30.524084],
              [50.3864593, 30.5235268],
              [50.3865662, 30.5231573],
              [50.3868295, 30.5229285],
              [50.3875197, 30.5221467],
              [50.3889543, 30.5198885],
              [50.3911819, 30.5168963],
              [50.3934057, 30.5137642],
              [50.3943139, 30.5119636],
              [50.3968087, 30.5076303],
              [50.4003105, 30.5019142],
              [50.4012108, 30.5001249],
              [50.4044305, 30.497613],
              [50.4086954, 30.493847],
              [50.4132081, 30.4882749],
              [50.4162485, 30.4840993],
              [50.4185982, 30.4803401],
              [50.4202689, 30.4777894],
              [50.4220351, 30.4743118],
              [50.4241676, 30.4700936],
              [50.4260408, 30.4666638],
              [50.4285966, 30.4628129],
              [50.4303209, 30.460402],
              [50.4316786, 30.4585468],
              [50.4347039, 30.4540932],
              [50.4389838, 30.4482958],
              [50.4412308, 30.4455126],
              [50.4441069, 30.4420801],
              [50.4466629, 30.4388807],
              [50.4491238, 30.4360099],
              [50.4494857, 30.4355877],
              [50.4526215, 30.4322936],
              [50.4557129, 30.4294643],
              [50.4557647, 30.4294169],
              [50.4594308, 30.4261204],
              [50.4646646, 30.4215285],
              [50.4667092, 30.4201811],
              [50.4704855, 30.4175344],
              [50.4749986, 30.4144687],
              [50.4800911, 30.4117278],
              [50.4841346, 30.4094969],
              [50.4882317, 30.4074984],
              [50.4930686, 30.4053583],
              [50.4963265, 30.4039632],
              [50.4985314, 30.4028482],
              [50.4999294, 30.4023888],
              [50.5020903, 30.4017857],
              [50.5035247, 30.4010039],
              [50.5045928, 30.4002161],
              [50.505764, 30.3992437],
              [50.5070419, 30.3986462],
              [50.5086325, 30.3979528],
              [50.5105476, 30.3969831],
              [50.5158655, 30.3937995],
              [50.5197448, 30.3914428],
              [50.5204887, 30.3909808],
              [50.5207594, 30.3904245],
              [50.520977, 30.3894981],
              [50.5206796, 30.3869884],
              [50.5206949, 30.3849896],
              [50.5206032, 30.3834552],
              [50.5202522, 30.3809904],
              [50.519909, 30.377551],
              [50.5196572, 30.3758311],
              [50.5193597, 30.3735537],
              [50.5190657, 30.3704844],
              [50.5188753, 30.3680676],
              [50.5188982, 30.365189],
              [50.5189704, 30.362913],
              [50.5190047, 30.3584982],
              [50.5190698, 30.3569666],
              [50.5190888, 30.3545956],
              [50.5190011, 30.3524589],
              [50.5188217, 30.3486478],
              [50.5186233, 30.3468807],
              [50.5185318, 30.3453011],
              [50.5184365, 30.3439066],
              [50.5184517, 30.34228],
              [50.518055, 30.3390254],
              [50.5176659, 30.334979],
              [50.5171167, 30.331214],
              [50.5165406, 30.3244732],
              [50.5164853, 30.3230336],
              [50.5164527, 30.3222417],
              [50.5165826, 30.3196861],
              [50.5164946, 30.3175493],
              [50.5162049, 30.3140627],
              [50.5153694, 30.3072262],
              [50.5146788, 30.3017393],
              [50.5143851, 30.2994145],
              [50.514202, 30.2961607],
              [50.5139656, 30.2932788],
              [50.5135116, 30.2907188],
              [50.5129661, 30.2872764],
              [50.512783, 30.2838827],
              [50.5126076, 30.2802566],
              [50.5124702, 30.2775601],
              [50.5120315, 30.2738857],
              [50.5119515, 30.2711421],
              [50.5117532, 30.2699344],
              [50.5113679, 30.2659804],
              [50.5113982, 30.262495],
              [50.5111047, 30.260028],
              [50.5107079, 30.2575652],
              [50.510479, 30.2539367],
              [50.5102916, 30.2500804],
              [50.5099716, 30.2390225],
              [50.5101126, 30.2323903],
              [50.5099334, 30.2302148],
              [50.5093766, 30.2275799],
              [50.5096016, 30.2183513],
              [50.5096484, 30.2172528],
              [50.5099449, 30.2102805],
              [50.510002, 30.2058295],
              [50.5103415, 30.2024422],
              [50.5108339, 30.198866],
              [50.5114821, 30.1951956],
              [50.5123368, 30.1908762],
              [50.5143279, 30.1838988],
              [50.5155563, 30.1798966],
              [50.5169868, 30.1752928],
              [50.5180168, 30.1725464],
              [50.5198137, 30.1677048],
              [50.520584, 30.1655169],
              [50.5143547, 30.1660513],
              [50.5138933, 30.1660606],
              [50.5148699, 30.1616618],
              [50.5353206, 30.1531104],
              [50.560476, 30.1467128],
              [50.5612367, 30.1462292],
              [50.5654032, 30.1440098],
              [50.5717901, 30.137902],
              [50.5745697, 30.1328949],
              [50.5754033, 30.1306755],
              [50.5762366, 30.1281765],
              [50.5765131, 30.1273465],
              [50.5767897, 30.1259571],
              [50.5770698, 30.1253977],
              [50.5767897, 30.1245677],
              [50.5754034, 30.1137325],
              [50.5748464, 30.1126229],
              [50.5626235, 30.0992888],
              [50.5604001, 30.0981791],
              [50.5595668, 30.0973401],
              [50.5587336, 30.0970694],
              [50.5573468, 30.0959598],
              [50.5481803, 30.0898431],
              [50.5476236, 30.0890131],
              [50.5448471, 30.0856752],
              [50.5426235, 30.0823462],
              [50.5392903, 30.0731804],
              [50.5276242, 30.0203966],
              [50.5279008, 30.0181774],
              [50.5281773, 30.0173475],
              [50.5284574, 30.0153989],
              [50.5284574, 30.01456],
              [50.5290105, 30.0120611],
              [50.5298441, 30.0098419],
              [50.5320673, 30.0040143],
              [50.5323438, 30.0031753],
              [50.5326239, 30.0017862],
              [50.5348204, 29.992891],
              [50.535124, 29.9917909],
              [50.5340107, 29.9790083],
              [50.5342908, 29.9762298],
              [50.5356775, 29.9726215],
              [50.5387338, 29.9670647],
              [50.5392905, 29.966785],
              [50.539844, 29.9659551],
              [50.5554006, 29.9490142],
              [50.5556802, 29.9478957],
              [50.5629039, 29.934013],
              [50.5687368, 29.9281767],
              [50.569847, 29.9270582],
              [50.5737369, 29.9245595],
              [50.5748467, 29.9245596],
              [50.5754037, 29.9248392],
              [50.5762369, 29.9248392],
              [50.5781803, 29.9253984],
              [50.5792901, 29.9262284],
              [50.5851269, 29.9292863],
              [50.6026265, 29.9420685],
              [50.602903, 29.9434486],
              [50.6031831, 29.9437282],
              [50.609293, 29.952343],
              [50.6112364, 29.954562],
              [50.6126263, 29.9573404],
              [50.614293, 29.9576201],
              [50.6151262, 29.9573404],
              [50.6159594, 29.9601188],
              [50.6167927, 29.9601188],
              [50.6173493, 29.9603985],
              [50.6187396, 29.9603984],
              [50.6201259, 29.9598392],
              [50.6215162, 29.9598392],
              [50.6217928, 29.9603984],
              [50.6223495, 29.9606781],
              [50.622626, 29.9620674],
              [50.6223495, 29.962338],
              [50.6220728, 29.9631769],
              [50.622626, 29.9640067],
              [50.6229062, 29.9642864],
              [50.6234592, 29.9648457],
              [50.6242928, 29.9651254],
              [50.6245729, 29.9648457],
              [50.6254062, 29.9648456],
              [50.6259592, 29.9645661],
              [50.6273495, 29.9659552],
              [50.6304058, 29.9704025],
              [50.6337395, 29.9712324],
              [50.635959, 29.9712325],
              [50.6365157, 29.9709528],
              [50.637906, 29.971512],
              [50.6429056, 29.9770599],
              [50.6459624, 29.9787288],
              [50.6479057, 29.9778989],
              [50.6498491, 29.9773395],
              [50.6515156, 29.9773396],
              [50.6545723, 29.9767893],
              [50.6559622, 29.9778989],
              [50.660129, 29.9801179],
              [50.6609622, 29.9792881],
              [50.6670721, 29.9767893],
              [50.6781852, 29.9892832],
              [50.6787419, 29.9898425],
              [50.6834618, 29.9940102],
              [50.6837419, 29.9945605],
              [50.6865185, 29.9956701],
              [50.686795, 29.9959588],
              [50.6954085, 29.9959588],
              [50.697075, 29.9956701],
              [50.7037415, 29.9956701],
              [50.7090181, 29.9953995],
              [50.7098513, 29.9951198],
              [50.7126315, 29.9951198],
              [50.7137412, 29.9948402],
              [50.7170748, 29.9948402],
              [50.7220746, 29.9934509],
              [50.7329111, 29.9912318],
              [50.7342977, 29.9909522],
              [50.7543008, 29.992621],
              [50.7568009, 29.9926211],
              [50.7581874, 29.9923414],
              [50.7593007, 29.9923414],
              [50.7598541, 29.9920618],
              [50.7612441, 29.9920618],
              [50.7829103, 29.9842858],
              [50.7837438, 29.9840151],
              [50.7951336, 29.9776194],
              [50.8073567, 29.9715123],
              [50.8162465, 29.967065],
              [50.8234698, 29.964846],
              [50.8337462, 29.9634567],
              [50.8354129, 29.9634568],
              [50.8365264, 29.9631771],
              [50.8465261, 29.9656759],
              [50.8604158, 29.9737315],
              [50.8648591, 29.9812278],
              [50.864859, 29.9817871],
              [50.8648545, 29.9818216],
              [50.8626393, 29.9987284],
              [50.8665257, 30.0051243],
              [50.8668058, 30.0056746],
              [50.8745823, 30.0095626],
              [50.8870821, 30.0145604],
              [50.8881954, 30.014849],
              [50.897362, 30.0248444],
              [50.9031953, 30.03484],
              [50.9045853, 30.0373388],
              [50.9159717, 30.0584487],
              [50.919585, 30.0662342],
              [50.9229182, 30.0840066],
              [50.9226416, 30.0848456],
              [50.9223616, 30.0890136],
              [50.9223616, 30.0898435],
              [50.9220848, 30.0904029],
              [50.9218082, 30.0923426],
              [50.9215281, 30.0937319],
              [50.9218082, 30.1012288],
              [50.9245848, 30.1126233],
              [50.9248614, 30.1151223],
              [50.9354179, 30.1359537],
              [50.9370846, 30.1395716],
              [50.9373611, 30.1398422],
              [50.9373611, 30.1401218],
              [50.9390314, 30.1412316],
              [50.9393078, 30.1417909],
              [50.9398645, 30.1420616],
              [50.9559742, 30.1559554],
              [50.9579209, 30.1567855],
              [50.9606975, 30.1579042],
              [50.9806972, 30.1670707],
              [50.989587, 30.176237],
              [50.9903616, 30.1763437],
              [50.9915304, 30.1767965],
              [50.994867, 30.1767965],
              [50.9962536, 30.1762372],
              [50.9987536, 30.173738],
              [50.9987536, 30.1734583],
              [50.9998532, 30.1734583],
              [51.0132002, 30.1787363],
              [51.0134768, 30.179016],
              [51.0140334, 30.179016],
              [51.01431, 30.1792957],
              [51.0154234, 30.1792956],
              [51.0165335, 30.1795663],
              [51.0201433, 30.1823452],
              [51.0234765, 30.1840143],
              [51.0245899, 30.1826249],
              [51.0248666, 30.1817948],
              [51.0259766, 30.178186],
              [51.0270899, 30.1773469],
              [51.0279233, 30.1773469],
              [51.0281998, 30.1770672],
              [51.0304232, 30.1770672],
              [51.0309765, 30.1773469],
              [51.0320897, 30.1809557],
              [51.0326431, 30.1809557],
              [51.034313, 30.1792957],
              [51.0381997, 30.1795664],
              [51.0418131, 30.1820655],
              [51.041813, 30.1823451],
              [51.0426464, 30.1823452],
              [51.042923, 30.1826249],
              [51.044313, 30.1826248],
              [51.044313, 30.1823452],
              [51.0448661, 30.1823452],
              [51.0462562, 30.1809558],
              [51.0501462, 30.1809557],
              [51.050423, 30.1806761],
              [51.0523695, 30.1817948],
              [51.0529227, 30.1840144],
              [51.0532029, 30.1845736],
              [51.0529228, 30.1848534],
              [51.0526462, 30.1865134],
              [51.0529227, 30.1870728],
              [51.0532028, 30.189572],
              [51.0557029, 30.190402],
              [51.0559795, 30.1901224],
              [51.0570894, 30.1901223],
              [51.0576461, 30.1898427],
              [51.0612559, 30.1915118],
              [51.0623694, 30.1954003],
              [51.062646, 30.1959598],
              [51.0623694, 30.1962394],
              [51.0629225, 30.1973492],
              [51.0634794, 30.1984589],
              [51.0662558, 30.2003987],
              [51.0754259, 30.2003987],
              [51.0765359, 30.200128],
              [51.0801457, 30.1990093],
              [51.0820924, 30.1990093],
              [51.0851456, 30.1995687],
              [51.085979, 30.1998483],
              [51.0868122, 30.1978996],
              [51.0873689, 30.19402],
              [51.0884789, 30.1934606],
              [51.090149, 30.1915118],
              [51.0920922, 30.1909524],
              [51.0945923, 30.1909525],
              [51.0965355, 30.1951297],
              [51.0962589, 30.1962394],
              [51.0957022, 30.1973492],
              [51.1004254, 30.1995686],
              [51.1040354, 30.1970695],
              [51.1034821, 30.1901224],
              [51.1040355, 30.1890127],
              [51.1045921, 30.1876232],
              [51.1065353, 30.1876232],
              [51.1076488, 30.1879029],
              [51.1079253, 30.1881826],
              [51.1090387, 30.1881826],
              [51.1182052, 30.1990093],
              [51.1201484, 30.2006784],
              [51.1209819, 30.2006785],
              [51.1215385, 30.2009582],
              [51.1270917, 30.2009582],
              [51.129315, 30.199289],
              [51.1309816, 30.1992891],
              [51.1337617, 30.2006785],
              [51.134595, 30.2012379],
              [51.1345949, 30.2020679],
              [51.1343149, 30.2026273],
              [51.1348715, 30.2031867],
              [51.1365382, 30.203737],
              [51.1368149, 30.2040168],
              [51.1373716, 30.2040168],
              [51.138205, 30.2056858],
              [51.138205, 30.2062362],
              [51.137095, 30.2067956],
              [51.1354284, 30.2067957],
              [51.1351482, 30.2065159],
              [51.1340383, 30.2065159],
              [51.1334816, 30.2067956],
              [51.131815, 30.2067957],
              [51.1304283, 30.207346],
              [51.1320951, 30.2092948],
              [51.1423714, 30.2156827],
              [51.1482616, 30.2140891],
              [51.1473713, 30.2126241],
              [51.1470948, 30.2106843],
              [51.1487614, 30.2076257],
              [51.1509846, 30.2076257],
              [51.1518181, 30.2079054],
              [51.1523712, 30.2079054],
              [51.1532046, 30.2081851],
              [51.1537613, 30.2084558],
              [51.1545946, 30.2087355],
              [51.1551514, 30.2095655],
              [51.1584846, 30.2092948],
              [51.1593178, 30.2090152],
              [51.1626512, 30.2090151],
              [51.1693178, 30.2120647],
              [51.1779276, 30.2062363],
              [51.1820942, 30.2079054],
              [51.1832077, 30.2092948],
              [51.1832076, 30.2098453],
              [51.1836495, 30.2105155],
              [51.1840409, 30.2109549],
              [51.1862643, 30.2156827],
              [51.189874, 30.2190119],
              [51.1912641, 30.2259593],
              [51.1923741, 30.227069],
              [51.1929307, 30.2273487],
              [51.1945974, 30.230678],
              [51.1945973, 30.2309577],
              [51.1948739, 30.2323472],
              [51.1968173, 30.2354058],
              [51.2059872, 30.2362359],
              [51.2062638, 30.2365156],
              [51.2073737, 30.2365156],
              [51.2076539, 30.2367952],
              [51.2082071, 30.2367953],
              [51.2101539, 30.2390148],
              [51.210707, 30.2392945],
              [51.2109871, 30.2398539],
              [51.2115404, 30.2401246],
              [51.2115405, 30.2404043],
              [51.2123736, 30.2404042],
              [51.2129303, 30.240684],
              [51.2148736, 30.240684],
              [51.2184871, 30.2417937],
              [51.2251536, 30.2481818],
              [51.2276536, 30.2490208],
              [51.2301535, 30.2492915],
              [51.23043, 30.2495712],
              [51.2312634, 30.2495712],
              [51.2315435, 30.249851],
              [51.2326535, 30.249851],
              [51.2345967, 30.250681],
              [51.2354301, 30.250681],
              [51.2379299, 30.2520705],
              [51.2387633, 30.2567984],
              [51.2490432, 30.2640165],
              [51.2629329, 30.2756829],
              [51.2632097, 30.2759626],
              [51.2634896, 30.2762333],
              [51.2637663, 30.276513],
              [51.2637664, 30.2767927],
              [51.2645995, 30.2767927],
              [51.2648763, 30.2770725],
              [51.265433, 30.2770724],
              [51.265433, 30.2773521],
              [51.2676563, 30.2787416],
              [51.2679328, 30.2790123],
              [51.2690428, 30.2795718],
              [51.2707094, 30.2823507],
              [51.2720995, 30.2890186],
              [51.2784253, 30.2915544],
              [51.2793265, 30.2957602],
              [51.2804852, 30.2978538],
              [51.2412391, 30.3218246],
              [51.240016, 30.3231397],
              [51.2379776, 30.3248808],
              [51.2382994, 30.3362339],
              [51.2409188, 30.3415125],
              [51.2426094, 30.3441305],
              [51.243575, 30.3478525],
              [51.2459997, 30.3511856],
              [51.2467078, 30.3564813],
              [51.2506346, 30.3638318],
              [51.2564925, 30.3699413],
              [51.2636809, 30.3734588],
              [51.2693161, 30.3745189],
              [51.2732643, 30.3758889],
              [51.2799377, 30.3759999],
              [51.283049, 30.3760555],
              [51.2861818, 30.3803872],
              [51.2892932, 30.3890871],
              [51.255433, 30.4156864],
              [51.255433, 30.4159662],
              [51.22043, 30.4537393],
              [51.2195967, 30.4542988],
              [51.2184868, 30.4559682],
              [51.2143201, 30.4615178],
              [51.2045969, 30.4734654],
              [51.203207, 30.474855],
              [51.2026501, 30.4762448],
              [51.2012635, 30.4776344],
              [51.1870971, 30.5048508],
              [51.1848737, 30.5129092],
              [51.1790405, 30.5306869],
              [51.1687606, 30.5398554],
              [51.1684839, 30.5401353],
              [51.1640373, 30.5462446],
              [51.1623708, 30.5476344],
              [51.1429277, 30.5640225],
              [51.1432043, 30.5806907],
              [51.143761, 30.5876396],
              [51.1395795, 30.5929829],
              [51.1355668, 30.5955365],
              [51.1369616, 30.5986025],
              [51.1427766, 30.6082802],
              [51.1532304, 30.6179181],
              [51.1595819, 30.6261167],
              [51.1618173, 30.6287467],
              [51.1770937, 30.6493051],
              [51.1773736, 30.6498557],
              [51.1805821, 30.6529407],
              [51.184466, 30.656208],
              [51.1877061, 30.6605826],
              [51.1888862, 30.6661198],
              [51.1934294, 30.6736349],
              [51.1992574, 30.6737515],
              [51.2039222, 30.6679505],
              [51.2105311, 30.6604384],
              [51.2163891, 30.6524642],
              [51.2189854, 30.6487353],
              [51.225153, 30.6448559],
              [51.2279297, 30.6423561],
              [51.2359863, 30.6329162],
              [51.2376529, 30.6306871],
              [51.2518194, 30.6165183],
              [51.296822, 30.5940291],
              [51.3015453, 30.59069],
              [51.3298783, 30.5734713],
              [51.3307115, 30.5731916],
              [51.3421166, 30.5693355],
              [51.358403, 30.5657512],
              [51.3622505, 30.563534],
              [51.3662994, 30.5605039],
              [51.3720501, 30.5547574],
              [51.3717867, 30.5519217],
              [51.3718511, 30.5468954],
              [51.368375, 30.5344393],
              [51.3646413, 30.5283031],
              [51.3590409, 30.5212238],
              [51.353891, 30.5121474],
              [51.3547923, 30.5062317],
              [51.3581397, 30.5031627],
              [51.3626243, 30.4988179],
              [51.3680746, 30.4927904],
              [51.373954, 30.4851538],
              [51.3781109, 30.4807086],
              [51.3828524, 30.4751034],
              [51.3917743, 30.4683986],
              [51.3952792, 30.4670921],
              [51.4022925, 30.4672563],
              [51.4117075, 30.4680539],
              [51.4164595, 30.4672032],
              [51.4211654, 30.4667634],
              [51.4275818, 30.4654865],
              [51.431802, 30.463489],
              [51.440253, 30.462215],
              [51.4463387, 30.4626566],
              [51.4501538, 30.4654471],
              [51.4593549, 30.4649426],
              [51.464866, 30.4629125],
              [51.467663, 30.4598274],
              [51.4682197, 30.4559684],
              [51.4832195, 30.4512399],
              [51.4840528, 30.45124],
              [51.5007194, 30.4431818],
              [51.502666, 30.4420719],
              [51.5212756, 30.4356831],
              [51.522109, 30.4356831],
              [51.5229424, 30.4356831],
              [51.523499, 30.4354033],
              [51.526279, 30.4354034],
              [51.5271124, 30.4356831],
              [51.5279457, 30.4356832],
              [51.528499, 30.4354034],
              [51.5290555, 30.4356831],
              [51.5326654, 30.4351327],
              [51.5329455, 30.4348529],
              [51.5348889, 30.4348529],
              [51.5487786, 30.4317939],
              [51.5607218, 30.4265151],
              [51.5746115, 30.4223552],
              [51.5762782, 30.4223552],
              [51.5790582, 30.4223552],
              [51.5837814, 30.4234651],
              [51.6040578, 30.4412418],
              [51.6112812, 30.4437413],
              [51.6193375, 30.4437414],
              [51.6251709, 30.4412418],
              [51.6260042, 30.440962],
              [51.6273942, 30.4404026],
              [51.6273941, 30.4401318],
              [51.6282275, 30.4376323],
              [51.6321141, 30.4290147],
              [51.6332274, 30.4279139],
              [51.6337808, 30.4267948],
              [51.6396174, 30.4217957],
              [51.6454505, 30.4192963],
              [51.6465605, 30.4187458],
              [51.6487838, 30.4184662],
              [51.6521173, 30.418466],
              [51.6576738, 30.4165261],
              [51.6579503, 30.4162463],
              [51.6590604, 30.4159666],
              [51.7508455, 30.3608145],
              [51.7618273, 30.362878],
              [51.7669772, 30.3649515],
              [51.7721037, 30.3664878],
              [51.7829418, 30.3715793],
              [51.7854308, 30.3746525],
              [51.7843151, 30.3769109],
              [51.7752812, 30.3793719],
              [51.7724275, 30.3828716],
              [51.772579, 30.385835],
              [51.7726422, 30.387072],
              [51.7737579, 30.3904977],
              [51.7757918, 30.3949112],
              [51.7815653, 30.3990205],
              [51.7968452, 30.4109586],
              [51.8249013, 30.4354036],
              [51.8257346, 30.435963],
              [51.8262914, 30.4365226],
              [51.8262914, 30.4368023],
              [51.8312912, 30.4445717],
              [51.8315678, 30.4456817],
              [51.8374012, 30.4537399],
              [51.8418477, 30.4626283],
              [51.8429576, 30.4656874],
              [51.8432344, 30.4695767],
              [51.8415677, 30.4740164],
              [51.8410145, 30.4745759],
              [51.8410144, 30.4751354],
              [51.8399009, 30.4762453],
              [51.8396244, 30.4770755],
              [51.8390677, 30.4773553],
              [51.8335145, 30.4901332],
              [51.8335145, 30.4912432],
              [51.8326812, 30.4937428],
              [51.8324011, 30.4948527],
              [51.8321243, 30.4968019],
              [51.8318478, 30.4984623],
              [51.8315677, 30.5012417],
              [51.8312912, 30.5054108],
              [51.8318478, 30.5120796],
              [51.8329578, 30.5173588],
              [51.8335144, 30.5184598],
              [51.8335144, 30.519299],
              [51.8340678, 30.5201382],
              [51.8343478, 30.5206887],
              [51.8343478, 30.5209685],
              [51.8343479, 30.5212481],
              [51.8440675, 30.5354161],
              [51.8454576, 30.5379069],
              [51.8482375, 30.5412459],
              [51.8557375, 30.5540243],
              [51.8779605, 30.5754121],
              [51.8846271, 30.5843012],
              [51.8876835, 30.590131],
              [51.8879603, 30.5906905],
              [51.8879604, 30.5920803],
              [51.8879603, 30.59236],
              [51.8879603, 30.5931903],
              [51.8882369, 30.5934701],
              [51.8882369, 30.5981899],
              [51.8874036, 30.5998595],
              [51.8871269, 30.6009695],
              [51.8804604, 30.6087487],
              [51.8704605, 30.6148583],
              [51.8699039, 30.6156887],
              [51.8693472, 30.6159684],
              [51.8643472, 30.6265182],
              [51.8629573, 30.6315269],
              [51.854904, 30.6431869],
              [51.8535141, 30.6442969],
              [51.8521241, 30.6459665],
              [51.8489216, 30.6532311],
              [51.8466815, 30.6589459],
              [51.8426388, 30.6642396],
              [51.8422507, 30.6715815],
              [51.8343133, 30.6773803],
              [51.8262022, 30.6809457],
              [51.8168878, 30.6853959],
              [51.8065451, 30.6901832],
              [51.7978906, 30.6933624],
              [51.8112459, 30.7142277],
              [51.8067598, 30.7129585],
              [51.801856, 30.7131455],
              [51.7842493, 30.7099724],
              [51.7732458, 30.71134],
              [51.7669973, 30.7123239],
              [51.763278, 30.7151329],
              [51.7593298, 30.7155904],
              [51.7566747, 30.7171252],
              [51.7505865, 30.7170072],
              [51.7448415, 30.7202932],
              [51.7424117, 30.7194308],
              [51.7395278, 30.7187421],
              [51.7335768, 30.7213394],
              [51.7300749, 30.7237596],
              [51.7252913, 30.7282652],
              [51.7210799, 30.7289341],
              [51.7171202, 30.7310786],
              [51.7157927, 30.7321016],
              [51.7149916, 30.7343248],
              [51.7108489, 30.7366265],
              [51.7067519, 30.7372954],
              [51.7035018, 30.7367643],
              [51.7011672, 30.73702],
              [51.6978713, 30.739066],
              [51.6970473, 30.7408955],
              [51.6978026, 30.7424889],
              [51.6971388, 30.7447315],
              [51.6955367, 30.747092],
              [51.6959487, 30.7495508],
              [51.6948958, 30.7527767],
              [51.6942286, 30.7558446],
              [51.6934046, 30.7618041],
              [51.6808619, 30.7655802],
              [51.6804728, 30.7700249],
              [51.6829218, 30.7713819],
              [51.6827616, 30.7743907],
              [51.6810679, 30.7753543],
              [51.6747965, 30.774725],
              [51.6734461, 30.7738401],
              [51.6692118, 30.7739581],
              [51.6641535, 30.7725815],
              [51.6616587, 30.7748823],
              [51.6557536, 30.7799558],
              [51.6512904, 30.7855599],
              [51.6492075, 30.7885486],
              [51.6439432, 30.7889419],
              [51.6408762, 30.7902986],
              [51.6371455, 30.791498],
              [51.6354746, 30.7943882],
              [51.6341471, 30.794919],
              [51.6331171, 30.797239],
              [51.6303248, 30.8024293],
              [51.6251063, 30.8028225],
              [51.6181025, 30.803196],
              [51.6162485, 30.80585],
              [51.6143259, 30.8077569],
              [51.6093592, 30.8105483],
              [51.6056742, 30.812003],
              [51.6073679, 30.8140277],
              [51.6113734, 30.8187256],
              [51.6130213, 30.8227354],
              [51.6121287, 30.8272364],
              [51.6109238, 30.8282711],
              [51.6101603, 30.8289267],
              [51.6083809, 30.8289757],
              [51.6046501, 30.8278751],
              [51.6020638, 30.828622],
              [51.5978294, 30.8317666],
              [51.5955406, 30.8321203],
              [51.5894753, 30.8337319],
              [51.5863854, 30.8344591],
              [51.5856758, 30.8360903],
              [51.5861336, 30.8378786],
              [51.5862251, 30.8386058],
              [51.5859734, 30.8388023],
              [51.5824486, 30.8397063],
              [51.5787407, 30.840453],
              [51.5765892, 30.8420252],
              [51.5756279, 30.8478811],
              [51.57398, 30.8486475],
              [51.5718056, 30.8491387],
              [51.5710503, 30.849964],
              [51.5688072, 30.852263],
              [51.5652522, 30.8547784],
              [51.5600795, 30.858158],
              [51.5555705, 30.8609676],
              [51.5521831, 30.8630699],
              [51.55097, 30.8647988],
              [51.5469188, 30.8628931],
              [51.5455684, 30.8613016],
              [51.5444011, 30.8611052],
              [51.5430736, 30.8610855],
              [51.5365962, 30.8627162],
              [51.5333461, 30.8635414],
              [51.5304164, 30.8656829],
              [51.5280094, 30.8685666],
              [51.5261974, 30.8693602],
              [51.523983, 30.8705537],
              [51.5216913, 30.8716145],
              [51.5163355, 30.8710399],
              [51.5134773, 30.8711504],
              [51.5079927, 30.8728301],
              [51.4991865, 30.8801452],
              [51.4954786, 30.8864874],
              [51.4959164, 30.8911278],
              [51.4955044, 30.8959226],
              [51.4930067, 30.8966517],
              [51.4914875, 30.8972483],
              [51.4893246, 30.8994357],
              [51.48281, 30.9040313],
              [51.4826555, 30.9055115],
              [51.4804668, 30.9090685],
              [51.4803638, 30.9118079],
              [51.4824753, 30.9160715],
              [51.4824238, 30.9184794],
              [51.483737, 30.9199594],
              [51.483325, 30.9219917],
              [51.4811878, 30.9219475],
              [51.4776859, 30.9214394],
              [51.4772224, 30.9219917],
              [51.4747248, 30.9227648],
              [51.4706307, 30.9221905],
              [51.468854, 30.9215499],
              [51.4669485, 30.9199815],
              [51.4633994, 30.9216305],
              [51.4617565, 30.92329],
              [51.4591559, 30.9275089],
              [51.4542693, 30.9316465],
              [51.451497, 30.9359883],
              [51.4478149, 30.9404275],
              [51.4457035, 30.942901],
              [51.4407596, 30.9445131],
              [51.4383134, 30.9453082],
              [51.437438, 30.9451757],
              [51.4355325, 30.9467878],
              [51.4361505, 30.9519773],
              [51.4324426, 30.9521098],
              [51.4274988, 30.9581823],
              [51.4257736, 30.9606995],
              [51.4250268, 30.9617814],
              [51.4228382, 30.9626646],
              [51.4164524, 30.9619581],
              [51.4139289, 30.9626867],
              [51.4111738, 30.9631283],
              [51.4075399, 30.9642031],
              [51.405171, 30.9662785],
              [51.4020554, 30.9690384],
              [51.3969979, 30.972536],
              [51.393496, 30.9763112],
              [51.3901179, 30.9810248],
              [51.3884375, 30.9838258],
              [51.3867467, 30.9855162],
              [51.384146, 30.9879223],
              [51.3849442, 30.9924033],
              [51.384455, 30.9933745],
              [51.3828586, 30.9935069],
              [51.3790992, 30.9944561],
              [51.3767817, 30.997502],
              [51.3755458, 31.0067497],
              [51.3695758, 31.0062082],
              [51.3665889, 31.0065834],
              [51.3618919, 31.0138851],
              [51.3560211, 31.0190489],
              [51.3541414, 31.0209025],
              [51.3525192, 31.0235284],
              [51.3493521, 31.0265955],
              [51.3488886, 31.0286034],
              [51.3503048, 31.0316042],
              [51.3532917, 31.0330825],
              [51.3537294, 31.0385762],
              [51.352648, 31.040628],
              [51.3505623, 31.0443123],
              [51.3510515, 31.0492097],
              [51.3490431, 31.0512171],
              [51.3475239, 31.0518127],
              [51.3478329, 31.0551436],
              [51.3491461, 31.0562907],
              [51.3487598, 31.0592023],
              [51.3486128, 31.0616629],
              [51.3482118, 31.0633345],
              [51.3489671, 31.0672753],
              [51.3482347, 31.0710198],
              [51.3472047, 31.0803314],
              [51.3470445, 31.0846242],
              [51.3468404, 31.0886152],
              [51.343865, 31.0926332],
              [51.3413702, 31.0978859],
              [51.3428808, 31.1044317],
              [51.3435445, 31.1128778],
              [51.3430657, 31.1146466],
              [51.3425764, 31.1190775],
              [51.3412375, 31.1232216],
              [51.3391003, 31.1312228],
              [51.3390746, 31.1366448],
              [51.3380961, 31.1463858],
              [51.3358301, 31.1541206],
              [51.3332037, 31.1658428],
              [51.33256, 31.1697426],
              [51.3336002, 31.1755919],
              [51.3356224, 31.1788507],
              [51.3326024, 31.1814434],
              [51.3316497, 31.1832057],
              [51.3276843, 31.1871488],
              [51.3264484, 31.1892415],
              [51.3216333, 31.1941535],
              [51.3156337, 31.197986],
              [51.3121318, 31.2004748],
              [51.3060293, 31.2056064],
              [51.3043041, 31.2073023],
              [51.3022699, 31.2086016],
              [51.2985105, 31.2085135],
              [51.2961158, 31.2083153],
              [51.2948026, 31.2072362],
              [51.2913411, 31.2075568],
              [51.2901849, 31.2076639],
              [51.2869662, 31.2102846],
              [51.284417, 31.2125089],
              [51.2814559, 31.2139183],
              [51.2784432, 31.2149973],
              [51.2759713, 31.215724],
              [51.2729329, 31.2157901],
              [51.2710789, 31.2157681],
              [51.2673196, 31.215658],
              [51.2656716, 31.214645],
              [51.2622727, 31.2115399],
              [51.260496, 31.2097561],
              [51.2598265, 31.2078841],
              [51.2579332, 31.206257],
              [51.2570765, 31.2063379],
              [51.2520999, 31.2068077],
              [51.2454319, 31.2093192],
              [51.236542, 31.218202],
              [51.2326911, 31.220402],
              [51.2268188, 31.2237628],
              [51.2237744, 31.2237608],
              [51.2237693, 31.2237608],
              [51.2237637, 31.2237608],
              [51.2237634, 31.2237607],
              [51.2237627, 31.2237604],
              [51.1873739, 31.2095904],
              [51.1873732, 31.2095902],
              [51.1873729, 31.20959],
              [51.1873673, 31.20959],
              [51.1873622, 31.20959],
              [51.1840395, 31.20959],
              [51.182926, 31.2098698],
              [51.1804259, 31.2098696],
              [51.1804258, 31.2098692],
              [51.1804257, 31.209869],
              [51.1787611, 31.202646],
              [51.1790408, 31.201257],
              [51.179041, 31.2012559],
              [51.1829276, 31.195984],
              [51.1843167, 31.1932056],
              [51.1843176, 31.1932037],
              [51.1845963, 31.1923661],
              [51.1848742, 31.190983],
              [51.1848728, 31.1898746],
              [51.1801494, 31.1818134],
              [51.179041, 31.1748696],
              [51.1709846, 31.1670883],
              [51.1707079, 31.1665286],
              [51.1707078, 31.1665286],
              [51.1645947, 31.1634774],
              [51.1645946, 31.1634774],
              [51.1640382, 31.1587573],
              [51.1640381, 31.1587567],
              [51.164038, 31.1587563],
              [51.1643162, 31.1584782],
              [51.1643167, 31.1584778],
              [51.1643175, 31.158477],
              [51.164318, 31.1584765],
              [51.1645946, 31.157646],
              [51.161538, 31.1523652],
              [51.1615379, 31.1523652],
              [51.1601518, 31.151535],
              [51.1601517, 31.1515349],
              [51.1601514, 31.1515348],
              [51.1601514, 31.1515347],
              [51.1601504, 31.1515344],
              [51.1579281, 31.1506952],
              [51.1579281, 31.1506951],
              [51.1548722, 31.1501447],
              [51.1548714, 31.1501446],
              [51.1548662, 31.1501446],
              [51.1537655, 31.1501465],
              [51.15376, 31.1501465],
              [51.1537596, 31.1501464],
              [51.1529271, 31.1498668],
              [51.1529267, 31.1498667],
              [51.1529212, 31.1498667],
              [51.1509834, 31.1498667],
              [51.1504267, 31.1501465],
              [51.1487601, 31.1501465],
              [51.1290385, 31.1573662],
              [51.0957008, 31.1818133],
              [51.0887576, 31.1854241],
              [51.0784776, 31.1887642],
              [51.07154, 31.1887642],
              [51.0715344, 31.1887642],
              [51.0715343, 31.1887642],
              [51.071534, 31.188764],
              [51.071533, 31.1887635],
              [51.0715036, 31.1887497],
              [51.0695204, 31.1878169],
              [51.0695203, 31.1878169],
              [51.06952, 31.1878167],
              [51.0695198, 31.1878166],
              [51.0634031, 31.1849473],
              [51.0537608, 31.1804232],
              [51.0459843, 31.1790421],
              [51.0459828, 31.1790405],
              [51.0457019, 31.1787534],
              [51.0406997, 31.1787511],
              [51.0309765, 31.1818113],
              [51.0206999, 31.1887622],
              [51.0204234, 31.189033],
              [51.0195945, 31.1901454],
              [50.998246, 31.2056484],
              [50.9791627, 31.2195027],
              [50.9791626, 31.2195027],
              [50.9694423, 31.2265568],
              [50.9613761, 31.2398818],
              [50.963202, 31.2604226],
              [50.9604254, 31.2626523],
              [50.959592, 31.2629232],
              [50.9390357, 31.2843181],
              [50.9370889, 31.2865388],
              [50.9273657, 31.2965323],
              [50.9254225, 31.2976517],
              [50.9245891, 31.2984821],
              [50.9198925, 31.3009305],
              [50.9118091, 31.3051445],
              [50.8923662, 31.3087554],
              [50.8923633, 31.3087547],
              [50.8923632, 31.3087547],
              [50.8912529, 31.3084847],
              [50.890694, 31.3082047],
              [50.8906938, 31.3082047],
              [50.889033, 31.3082047],
              [50.8890326, 31.3082046],
              [50.8801431, 31.3045937],
              [50.8781903, 31.3034832],
              [50.8718037, 31.2995923],
              [50.8637472, 31.2926502],
              [50.86014, 31.2907095],
              [50.8598571, 31.2904204],
              [50.8570867, 31.2904206],
              [50.8568068, 31.2907094],
              [50.8556906, 31.2907093],
              [50.8437441, 31.2970917],
              [50.8431909, 31.2976514],
              [50.8393049, 31.2990402],
              [50.8376343, 31.2995923],
              [50.8362442, 31.300143],
              [50.8359676, 31.3004319],
              [50.8312442, 31.3007027],
              [50.8304108, 31.3009825],
              [50.8265304, 31.3009827],
              [50.8204172, 31.3079248],
              [50.8179172, 31.309315],
              [50.8170778, 31.3093149],
              [50.8168013, 31.3095948],
              [50.8140495, 31.3095948],
              [50.8140264, 31.3095948],
              [50.8140263, 31.3095948],
              [50.8140211, 31.3095948],
              [50.8081879, 31.3084844],
              [50.8079113, 31.3082047],
              [50.8079112, 31.3082045],
              [50.8062507, 31.3082047],
              [50.8006942, 31.311256],
              [50.7987446, 31.3120954],
              [50.7962447, 31.312926],
              [50.7917982, 31.3137564],
              [50.7915276, 31.3140364],
              [50.7906944, 31.3140365],
              [50.7901314, 31.3143161],
              [50.7892982, 31.3143162],
              [50.7787455, 31.3223659],
              [50.7554087, 31.3407038],
              [50.7506864, 31.3473736],
              [50.749852, 31.3487564],
              [50.7245722, 31.370152],
              [50.7240191, 31.3709825],
              [50.7245793, 31.3784822],
              [50.7242957, 31.3793152],
              [50.7198524, 31.3832062],
              [50.7176291, 31.3840366],
              [50.7165191, 31.3845965],
              [50.7009626, 31.3909881],
              [50.6992962, 31.3940394],
              [50.6822057, 31.402467],
              [50.679016, 31.4107048],
              [50.6756829, 31.4120952],
              [50.6751261, 31.4123749],
              [50.6742929, 31.4123749],
              [50.6740164, 31.4126548],
              [50.6709597, 31.4126548],
              [50.6690162, 31.4129256],
              [50.6623499, 31.4151466],
              [50.6617931, 31.4154264],
              [50.6601266, 31.4154263],
              [50.6559597, 31.4165368],
              [50.6556797, 31.4168166],
              [50.6545699, 31.4168166],
              [50.6545699, 31.4168167],
              [50.6545698, 31.4170956],
              [50.6545698, 31.4170964],
              [50.6545698, 31.4170965],
              [50.6520698, 31.4173673],
              [50.6515132, 31.4170965],
              [50.6490131, 31.4173673],
              [50.6473467, 31.4182069],
              [50.6417934, 31.4259889],
              [50.6412367, 31.4268195],
              [50.6395699, 31.42765],
              [50.6379034, 31.4273792],
              [50.6315137, 31.4198771],
              [50.6315136, 31.419877],
              [50.6301238, 31.4190375],
              [50.6301237, 31.4190374],
              [50.6301238, 31.4187579],
              [50.6301238, 31.4187577],
              [50.6301237, 31.4187577],
              [50.6217904, 31.4184868],
              [50.6204036, 31.4187576],
              [50.619847, 31.4190375],
              [50.6187371, 31.4190374],
              [50.6181805, 31.4193173],
              [50.6131804, 31.4193172],
              [50.6129004, 31.4195971],
              [50.611514, 31.4195972],
              [50.609014, 31.4201478],
              [50.6084573, 31.4204277],
              [50.6070671, 31.4204278],
              [50.6062338, 31.4207075],
              [50.6059572, 31.4207075],
              [50.6054005, 31.4204277],
              [50.6048474, 31.4204277],
              [50.6045673, 31.4201479],
              [50.5981774, 31.4201478],
              [50.5967906, 31.4195971],
              [50.5951242, 31.4195972],
              [50.5804009, 31.410154],
              [50.5767875, 31.4087636],
              [50.5737344, 31.4090435],
              [50.5687342, 31.4123748],
              [50.5681776, 31.4132054],
              [50.5681776, 31.4134852],
              [50.5606778, 31.4234881],
              [50.5476214, 31.4304305],
              [50.5470646, 31.4304306],
              [50.5448447, 31.4326514],
              [50.5445646, 31.4329312],
              [50.5442881, 31.4337618],
              [50.5440115, 31.4351521],
              [50.5442881, 31.4365424],
              [50.5440115, 31.4368223],
              [50.5437314, 31.4384834],
              [50.5426212, 31.4395938],
              [50.5423447, 31.4401536],
              [50.5390083, 31.4412641],
              [50.537898, 31.441264],
              [50.5342882, 31.4398737],
              [50.5315082, 31.4398737],
              [50.530955, 31.4398737],
              [50.5303983, 31.4401535],
              [50.5295651, 31.4401535],
              [50.5226184, 31.4448752],
              [50.5123417, 31.4504274],
              [50.509285, 31.4512579],
              [50.5081752, 31.4518177],
              [50.5003954, 31.4526482],
              [50.4976188, 31.4523773],
              [50.4965086, 31.4518176],
              [50.4956754, 31.4518177],
              [50.492062, 31.4498766],
              [50.4803955, 31.431261],
              [50.4795622, 31.4301506],
              [50.4781513, 31.4289187],
              [50.4773392, 31.4282096],
              [50.476229, 31.4276498],
              [50.4601692, 31.4289306],
              [50.4499874, 31.4313345],
              [50.4410377, 31.4334915],
              [50.4296708, 31.4356921],
              [50.421767, 31.4352611],
              [50.4196494, 31.4322],
              [50.4199624, 31.4281257],
              [50.4191291, 31.423027],
              [50.4146058, 31.4197359],
              [50.4094106, 31.4197303],
              [50.4014976, 31.4195344],
              [50.3841116, 31.4194267],
              [50.3748315, 31.4219734],
              [50.3637067, 31.4248693],
              [50.3529031, 31.4296486],
              [50.3424963, 31.4344152],
              [50.3322286, 31.4455016],
              [50.3262017, 31.4507304],
              [50.3189523, 31.4572918],
              [50.3078535, 31.450065],
              [50.3009213, 31.4456747],
              [50.2906772, 31.4405047],
              [50.272572, 31.4314116],
              [50.2607013, 31.42384],
              [50.2368137, 31.4082167],
              [50.234202, 31.4017872],
              [50.2457794, 31.3941911],
              [50.2600674, 31.3966481],
              [50.2601251, 31.3965859],
              [50.2648108, 31.3915394],
              [50.270004, 31.3835008],
              [50.2751766, 31.3780288],
              [50.2774065, 31.3757213],
              [50.2967785, 31.3620987],
              [50.2973316, 31.3618189],
              [50.2995551, 31.3590383],
              [50.2998316, 31.3587585],
              [50.2998317, 31.3584786],
              [50.2995551, 31.357928],
              [50.2992784, 31.3576481],
              [50.2986931, 31.3561277],
              [50.2981126, 31.3546198],
              [50.2978882, 31.354037],
              [50.297566, 31.3537631],
              [50.2967432, 31.3524734],
              [50.2882563, 31.344356],
              [50.2763604, 31.3351205],
              [50.2710175, 31.330101],
              [50.2551509, 31.3151904],
              [50.2467612, 31.306489],
              [50.236351, 31.308735],
              [50.2343711, 31.3087412],
              [50.2317467, 31.3086105],
              [50.229763, 31.308434],
              [50.2279892, 31.3079339],
              [50.2263262, 31.3073396],
              [50.2249794, 31.3067451],
              [50.2236329, 31.3059227],
              [50.2218553, 31.30473],
              [50.220665, 31.3037213],
              [50.2193716, 31.302757],
              [50.2183417, 31.3016997],
              [50.2177429, 31.30069],
              [50.2171975, 31.2995408],
              [50.2168654, 31.2984381],
              [50.2166901, 31.2972844],
              [50.2167894, 31.2963173],
              [50.2168311, 31.2954424],
              [50.2179222, 31.2922619],
              [50.2191163, 31.2888023],
              [50.2193184, 31.2877434],
              [50.2193642, 31.2870038],
              [50.2191429, 31.2864521],
              [50.2187117, 31.2859488],
              [50.2182273, 31.2858127],
              [50.2176399, 31.2858137],
              [50.2166786, 31.286092],
              [50.2155608, 31.2865115],
              [50.213642, 31.2871629],
              [50.2124176, 31.2874915],
              [50.2114526, 31.2875871],
              [50.2107049, 31.2876344],
              [50.2093124, 31.2874093],
              [50.2077559, 31.2868606],
              [50.2064668, 31.2861286],
              [50.2052803, 31.2853498],
              [50.2035562, 31.283882],
              [50.2008516, 31.2810818],
              [50.1984252, 31.2787885],
              [50.196644, 31.2772752],
              [50.1948128, 31.2760367],
              [50.1892815, 31.2730628],
              [50.1831511, 31.2692639],
              [50.1800841, 31.2671557],
              [50.1766931, 31.2642694],
              [50.1698685, 31.2601022],
              [50.1656798, 31.2576774],
              [50.1634293, 31.2566252],
              [50.160103, 31.2552118],
              [50.1576751, 31.2541667],
              [50.1552239, 31.2531114],
              [50.1527063, 31.2518317],
              [50.1509552, 31.2513377],
              [50.1504553, 31.2511966],
              [50.1484221, 31.2508786],
              [50.1454848, 31.2506606],
              [50.1424943, 31.2504874],
              [50.1399269, 31.2504499],
              [50.1352805, 31.2503759],
              [50.1329308, 31.2504773],
              [50.1299934, 31.2503492],
              [50.1269493, 31.2504053],
              [50.1242791, 31.250554],
              [50.1224632, 31.2505597],
              [50.120968, 31.2503825],
              [50.1190988, 31.2502976],
              [50.1174392, 31.2499817],
              [50.1167451, 31.2499363],
              [50.1137198, 31.2529402],
              [50.1114921, 31.2550654],
              [50.1092606, 31.2566853],
              [50.1075554, 31.2574742],
              [50.106594, 31.2578916],
              [50.1052627, 31.2580808],
              [50.1040305, 31.2580857],
              [50.1028171, 31.2580592],
              [50.1015739, 31.2579107],
              [50.0729367, 31.254194],
              [50.0436708, 31.2467033],
              [50.0117279, 31.2381406],
              [50.0000124, 31.2330397],
              [49.9968414, 31.2327623],
              [49.9916268, 31.2306171],
              [49.9902726, 31.2291088],
              [49.987835, 31.2260424],
              [49.9858934, 31.2243489],
              [49.984478, 31.2216469],
              [49.9828035, 31.2199984],
              [49.9812318, 31.218213],
              [49.9783211, 31.2157449],
              [49.9748268, 31.2144247],
              [49.9665641, 31.2122902],
              [49.9621696, 31.2115691],
              [49.9587403, 31.2114399],
              [49.9557419, 31.2114495],
              [49.95467, 31.2114047],
              [49.9541243, 31.2101664],
              [49.9534682, 31.2080589],
              [49.9532775, 31.2042545],
              [49.953125, 31.1983843],
              [49.9535713, 31.1941632],
              [49.9536081, 31.1937247],
              [49.953641, 31.1933333],
              [49.9539642, 31.1894816],
              [49.9544639, 31.1850783],
              [49.9557381, 31.1836992],
              [49.9588584, 31.1793329],
              [49.9615067, 31.1758131],
              [49.9631462, 31.1736339],
              [49.9678573, 31.167796],
              [49.9710768, 31.1626497],
              [49.9735565, 31.1586049],
              [49.9747691, 31.1561136],
              [49.9756583, 31.1542864],
              [49.9778062, 31.1493277],
              [49.9806406, 31.1431721],
              [49.9856912, 31.1341693],
              [49.9878502, 31.1307217],
              [49.9891626, 31.1278742],
              [49.9899942, 31.1256725],
              [49.9900285, 31.1232389],
              [49.9904163, 31.12067],
              [49.9885354, 31.1150946],
              [49.986223, 31.1116406],
              [49.9837072, 31.1093051],
              [49.9809242, 31.1067213],
              [49.9793461, 31.1060267],
              [49.9779726, 31.1047369],
              [49.9779216, 31.1045065],
              [49.9777836, 31.1038828],
              [49.9780954, 31.102521],
              [49.9791954, 31.1015918],
              [49.9806907, 31.100751],
              [49.9822591, 31.0992429],
              [49.9807439, 31.0976705],
              [49.9785858, 31.0968264],
              [49.9775375, 31.0960223],
              [49.9770115, 31.0957907],
              [49.9760461, 31.09458],
              [49.975841, 31.0936531],
              [49.9754568, 31.0929363],
              [49.9751083, 31.0917968],
              [49.9741615, 31.0905386],
              [49.9728776, 31.0892809],
              [49.9711793, 31.0875851],
              [49.9701108, 31.0864136],
              [49.9682825, 31.0844663],
              [49.9671386, 31.0831285],
              [49.9655383, 31.0817159],
              [49.9634448, 31.0798801],
              [49.9613452, 31.0786126],
              [49.9597714, 31.0775768],
              [49.956872, 31.0769849],
              [49.9539702, 31.0766204],
              [49.9528854, 31.0764245],
              [49.9506746, 31.0760252],
              [49.949486, 31.0760155],
              [49.9486948, 31.0758953],
              [49.948037, 31.0756626],
              [49.9475175, 31.0748626],
              [49.9495135, 31.0735146],
              [49.9512541, 31.0713688],
              [49.9523193, 31.0705816],
              [49.9531217, 31.0696786],
              [49.9548584, 31.0678738],
              [49.9557977, 31.0665171],
              [49.9571307, 31.0653911],
              [49.9594041, 31.0627947],
              [49.9605733, 31.0605056],
              [49.9606185, 31.060417],
              [49.9623524, 31.0588394],
              [49.9631682, 31.0566859],
              [49.9647859, 31.0536294],
              [49.9659878, 31.0523885],
              [49.9666664, 31.0506886],
              [49.9666738, 31.0500066],
              [49.9658939, 31.0488634],
              [49.9649783, 31.0480603],
              [49.9630448, 31.0467516],
              [49.961962, 31.046146],
              [49.9610819, 31.0451158],
              [49.9598992, 31.0445947],
              [49.9587258, 31.043221],
              [49.9582391, 31.0424496],
              [49.9576118, 31.0401995],
              [49.9587183, 31.0369295],
              [49.9591027, 31.0356305],
              [49.9596116, 31.0346164],
              [49.9616205, 31.0319893],
              [49.9631278, 31.0299551],
              [49.9640355, 31.0284276],
              [49.9678881, 31.0231294],
              [49.9705635, 31.0198539],
              [49.9708385, 31.0188329],
              [49.971397, 31.0159952],
              [49.97143, 31.0129259],
              [49.9700286, 31.0094322],
              [49.9643708, 31.0030458],
              [49.9615079, 31.0000702],
              [49.9533472, 30.9974599],
              [49.9465117, 30.9964795],
              [49.9394119, 30.9951493],
              [49.9347242, 30.9941859],
              [49.9281769, 30.9914723],
              [49.9226724, 30.9870957],
              [49.9195481, 30.9845275],
              [49.9171257, 30.9828787],
              [49.914173, 30.9812795],
              [49.9061737, 30.9765699],
              [49.8990898, 30.9725466],
              [49.8951303, 30.9708595],
              [49.894774, 30.9707405],
              [49.8918649, 30.9697691],
              [49.8896179, 30.9688115],
              [49.8886491, 30.9681242],
              [49.8877372, 30.96739],
              [49.8872591, 30.9667821],
              [49.8869782, 30.9664249],
              [49.8864899, 30.9653673],
              [49.8863183, 30.9644455]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241546,
        "tags": {
          "ISO3166-2": "IR-12",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "کردستان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q134386"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [45.557841, 35.9950418],
              [45.5580631, 35.9949551],
              [45.5583254, 35.9948187],
              [45.5588848, 35.9948207],
              [45.5590612, 35.9947813],
              [45.5593049, 35.9946488],
              [45.5594686, 35.9946164],
              [45.5596294, 35.9945514],
              [45.5597751, 35.9946179],
              [45.5599101, 35.9946754],
              [45.560028, 35.9947172],
              [45.5601738, 35.9946952],
              [45.5602583, 35.9946617],
              [45.56034, 35.9945097],
              [45.5604565, 35.994213],
              [45.5605826, 35.9938492],
              [45.5606812, 35.9936221],
              [45.5608421, 35.9934347],
              [45.5609835, 35.9931932],
              [45.5610806, 35.992912],
              [45.5611405, 35.9925888],
              [45.561277, 35.9921963],
              [45.5615943, 35.9917079],
              [45.561678, 35.9914281],
              [45.5616105, 35.9911775],
              [45.5616407, 35.9905612],
              [45.5617315, 35.9902218],
              [45.5619973, 35.9898742],
              [45.5627366, 35.9896298],
              [45.5630839, 35.9896258],
              [45.5635596, 35.9897071],
              [45.563815, 35.9897988],
              [45.5640621, 35.9897829],
              [45.564081, 35.9897725],
              [45.5642149, 35.989699],
              [45.5643774, 35.9895687],
              [45.564723, 35.9893616],
              [45.5652795, 35.9891196],
              [45.5654718, 35.9890336],
              [45.5656376, 35.9890104],
              [45.5658393, 35.9888629],
              [45.5659729, 35.9886864],
              [45.566123, 35.988437],
              [45.5663945, 35.988161],
              [45.5665795, 35.9879866],
              [45.5667006, 35.9877867],
              [45.5668709, 35.9876597],
              [45.5670157, 35.9875266],
              [45.567603, 35.9873604],
              [45.5679179, 35.9871617],
              [45.5683148, 35.9867309],
              [45.5684311, 35.9864936],
              [45.5685424, 35.9862258],
              [45.5685777, 35.985956],
              [45.5685789, 35.9857481],
              [45.5685795, 35.9854585],
              [45.5688341, 35.9848904],
              [45.568948, 35.9847675],
              [45.5692467, 35.9846729],
              [45.5705124, 35.9844922],
              [45.5710168, 35.9843552],
              [45.5716173, 35.9840978],
              [45.572267, 35.9838138],
              [45.5728574, 35.9834945],
              [45.5733166, 35.9832553],
              [45.573624, 35.9831423],
              [45.5739642, 35.9829365],
              [45.5741156, 35.9828],
              [45.5742815, 35.9825826],
              [45.5743235, 35.9823081],
              [45.5744469, 35.9820117],
              [45.5746932, 35.981649],
              [45.5751561, 35.9810948],
              [45.5757583, 35.9803483],
              [45.5759875, 35.9794179],
              [45.5761022, 35.9792388],
              [45.5761063, 35.9789271],
              [45.5760366, 35.9786635],
              [45.5760919, 35.9784853],
              [45.5760161, 35.978254],
              [45.5755704, 35.9778973],
              [45.5751984, 35.9774809],
              [45.574949, 35.9773009],
              [45.5748552, 35.9770545],
              [45.5745529, 35.9765883],
              [45.5743897, 35.9761924],
              [45.5744314, 35.9757301],
              [45.5745304, 35.9753308],
              [45.574777, 35.9748851],
              [45.5751008, 35.9748433],
              [45.575361, 35.9748754],
              [45.5757492, 35.9750407],
              [45.5760622, 35.9752394],
              [45.5763969, 35.9753305],
              [45.5769775, 35.9754282],
              [45.5780794, 35.9752116],
              [45.5790136, 35.9746198],
              [45.5799871, 35.9738288],
              [45.5804689, 35.9734153],
              [45.5809113, 35.972898],
              [45.5813538, 35.9724037],
              [45.5818753, 35.9716859],
              [45.5822685, 35.9712874],
              [45.582618, 35.9710523],
              [45.5833524, 35.9707293],
              [45.5839349, 35.9705419],
              [45.5844136, 35.9705001],
              [45.5847566, 35.9707148],
              [45.5850206, 35.9709215],
              [45.5851631, 35.971316],
              [45.5850787, 35.9715427],
              [45.5850874, 35.9719803],
              [45.5852529, 35.9722164],
              [45.5856234, 35.9724732],
              [45.5860217, 35.9724777],
              [45.5863047, 35.9724919],
              [45.586568, 35.972562],
              [45.5867923, 35.9725151],
              [45.5868757, 35.9726609],
              [45.5869339, 35.9727688],
              [45.5870307, 35.9729208],
              [45.5869423, 35.9731348],
              [45.5868046, 35.9733008],
              [45.5866378, 35.9735451],
              [45.586541, 35.9737462],
              [45.5865446, 35.9739167],
              [45.5864927, 35.974162],
              [45.5863494, 35.9745169],
              [45.5862306, 35.9745957],
              [45.5860029, 35.9746894],
              [45.5856166, 35.9748209],
              [45.5851399, 35.9751239],
              [45.5848817, 35.9753462],
              [45.5847912, 35.9756163],
              [45.5847385, 35.9761487],
              [45.5847845, 35.976693],
              [45.5849588, 35.9772133],
              [45.5855254, 35.9774007],
              [45.5858876, 35.9774385],
              [45.5865163, 35.9774843],
              [45.5867021, 35.9775157],
              [45.5868184, 35.9775125],
              [45.5869182, 35.9775636],
              [45.5871066, 35.9775683],
              [45.5871699, 35.9775449],
              [45.587225, 35.9774827],
              [45.5873281, 35.9774157],
              [45.5877313, 35.9773906],
              [45.5882595, 35.9774077],
              [45.5885848, 35.9774522],
              [45.588974, 35.9774934],
              [45.5893685, 35.9774671],
              [45.5896024, 35.9773194],
              [45.5897556, 35.9772098],
              [45.5899728, 35.9772428],
              [45.59019, 35.9772235],
              [45.5904594, 35.9770935],
              [45.5906644, 35.9768334],
              [45.5908165, 35.976521],
              [45.5908162, 35.9760882],
              [45.5908239, 35.975662],
              [45.5909434, 35.9755786],
              [45.5909831, 35.9754751],
              [45.5911115, 35.9752672],
              [45.5911475, 35.9751128],
              [45.5912077, 35.9748316],
              [45.5913369, 35.9746061],
              [45.5914594, 35.974261],
              [45.5916251, 35.9740722],
              [45.5918687, 35.9739192],
              [45.5921915, 35.9738362],
              [45.5924581, 35.9737402],
              [45.5927813, 35.9736358],
              [45.5929871, 35.9736162],
              [45.5932508, 35.973769],
              [45.5934309, 35.9739983],
              [45.5937983, 35.9740935],
              [45.5941187, 35.9741638],
              [45.5943908, 35.9741496],
              [45.5946475, 35.9740572],
              [45.5948562, 35.9739199],
              [45.5949848, 35.9737962],
              [45.5952902, 35.9736138],
              [45.5954268, 35.9734445],
              [45.595487, 35.9732916],
              [45.5957061, 35.9731435],
              [45.5959814, 35.9728328],
              [45.5960282, 35.972643],
              [45.595927, 35.9723822],
              [45.5958202, 35.9719461],
              [45.5957386, 35.9714807],
              [45.5955611, 35.9710757],
              [45.5954319, 35.9703908],
              [45.5953871, 35.9700371],
              [45.5954583, 35.9697958],
              [45.5955703, 35.9697272],
              [45.5957385, 35.9696976],
              [45.5958821, 35.9696125],
              [45.5959699, 35.9694788],
              [45.5960621, 35.9693697],
              [45.5960639, 35.9691947],
              [45.5958889, 35.9689417],
              [45.5956241, 35.968778],
              [45.5953067, 35.9685172],
              [45.5950054, 35.9681913],
              [45.5944751, 35.967841],
              [45.5943225, 35.9676859],
              [45.5941219, 35.9673433],
              [45.5941883, 35.9671833],
              [45.5941692, 35.9668203],
              [45.5942079, 35.9664989],
              [45.5944322, 35.9662797],
              [45.5945323, 35.966079],
              [45.5946146, 35.9657281],
              [45.5947048, 35.9653447],
              [45.5948689, 35.9651047],
              [45.5950073, 35.9650074],
              [45.5952662, 35.9649427],
              [45.5956438, 35.9647845],
              [45.5958487, 35.9647541],
              [45.595915, 35.9646576],
              [45.5959843, 35.9645118],
              [45.5965601, 35.9643074],
              [45.5971482, 35.9639599],
              [45.5973498, 35.9638523],
              [45.5976195, 35.9635708],
              [45.5977905, 35.9633845],
              [45.5980821, 35.9630095],
              [45.5983045, 35.9627894],
              [45.5986395, 35.9625368],
              [45.5991767, 35.9615777],
              [45.5992966, 35.9613715],
              [45.5994851, 35.9614017],
              [45.5997241, 35.9611663],
              [45.6000446, 35.9608697],
              [45.6001159, 35.9606902],
              [45.6004074, 35.960257],
              [45.6006818, 35.9599948],
              [45.6009758, 35.9597498],
              [45.6011469, 35.9596631],
              [45.601732, 35.9595407],
              [45.602209, 35.9594415],
              [45.6029929, 35.9588103],
              [45.603401, 35.9584265],
              [45.6039859, 35.9580426],
              [45.6044077, 35.9579592],
              [45.6049468, 35.9580053],
              [45.6053573, 35.9580449],
              [45.6060309, 35.9582806],
              [45.6062141, 35.9582821],
              [45.6064135, 35.9582331],
              [45.6066177, 35.9582639],
              [45.6067496, 35.9583533],
              [45.6067946, 35.9584765],
              [45.6068044, 35.9586189],
              [45.6067517, 35.9589492],
              [45.606638, 35.9593195],
              [45.6066127, 35.9595337],
              [45.6066505, 35.9596496],
              [45.6067342, 35.9597645],
              [45.6069176, 35.9599356],
              [45.6078344, 35.9607342],
              [45.6079847, 35.9606974],
              [45.60836, 35.9609665],
              [45.6085503, 35.9609304],
              [45.6086856, 35.9607482],
              [45.6088636, 35.9606287],
              [45.6091999, 35.9602816],
              [45.6095253, 35.9587171],
              [45.6102374, 35.95747],
              [45.6127621, 35.9571213],
              [45.6146636, 35.9570003],
              [45.6164205, 35.9569283],
              [45.6177465, 35.9555433],
              [45.6182658, 35.9555566],
              [45.6194661, 35.9564762],
              [45.6199847, 35.9565077],
              [45.6207868, 35.9581806],
              [45.6217719, 35.958659],
              [45.6229582, 35.9577835],
              [45.622925, 35.957687],
              [45.622743, 35.957488],
              [45.622959, 35.956954],
              [45.623441, 35.956235],
              [45.623377, 35.955983],
              [45.623223, 35.955768],
              [45.622895, 35.955633],
              [45.6226853, 35.9554311],
              [45.62268, 35.954757],
              [45.622872, 35.954568],
              [45.623415, 35.953688],
              [45.624108, 35.952811],
              [45.624519, 35.952507],
              [45.624819, 35.952172],
              [45.624966, 35.951554],
              [45.625302, 35.951111],
              [45.625897, 35.950642],
              [45.626162, 35.950318],
              [45.626117, 35.949453],
              [45.625839, 35.949024],
              [45.625734, 35.948622],
              [45.625924, 35.948109],
              [45.626288, 35.947707],
              [45.626598, 35.947258],
              [45.626739, 35.946881],
              [45.627081, 35.946679],
              [45.627528, 35.946553],
              [45.627932, 35.946485],
              [45.628424, 35.946503],
              [45.628883, 35.946354],
              [45.629592, 35.945843],
              [45.630026, 35.945664],
              [45.631175, 35.945426],
              [45.63161, 35.945409],
              [45.632175, 35.945023],
              [45.632677, 35.944822],
              [45.633384, 35.944781],
              [45.634182, 35.944893],
              [45.635016, 35.945084],
              [45.635374, 35.9449],
              [45.636076, 35.944436],
              [45.636615, 35.944256],
              [45.636921, 35.94398],
              [45.637358, 35.943784],
              [45.637753, 35.943785],
              [45.638371, 35.94395],
              [45.639396, 35.944326],
              [45.639842, 35.944385],
              [45.641363, 35.942418],
              [45.641618, 35.941704],
              [45.642389, 35.94087],
              [45.643035, 35.940515],
              [45.643434, 35.939889],
              [45.644699, 35.938736],
              [45.645712, 35.938421],
              [45.646005, 35.938137],
              [45.646253, 35.937715],
              [45.646457, 35.93721],
              [45.646971, 35.936654],
              [45.647531, 35.935922],
              [45.647699, 35.935368],
              [45.64811, 35.935008],
              [45.648795, 35.934714],
              [45.649393, 35.934524],
              [45.649848, 35.934571],
              [45.650234, 35.934797],
              [45.650574, 35.935255],
              [45.651016, 35.935617],
              [45.65187, 35.935787],
              [45.653106, 35.935854],
              [45.654793, 35.934378],
              [45.655117, 35.933972],
              [45.655564, 35.933063],
              [45.655886, 35.93276],
              [45.656221, 35.932624],
              [45.656658, 35.932357],
              [45.657145, 35.931974],
              [45.658931, 35.930787],
              [45.65925, 35.930501],
              [45.659478, 35.930129],
              [45.659845, 35.929958],
              [45.660285, 35.929838],
              [45.660703, 35.929598],
              [45.661441, 35.929291],
              [45.661967, 35.929162],
              [45.66257, 35.928952],
              [45.662986, 35.9284],
              [45.663409, 35.92796],
              [45.665625, 35.926916],
              [45.666691, 35.925676],
              [45.667114, 35.925264],
              [45.667471, 35.924813],
              [45.667602, 35.924474],
              [45.667988, 35.924012],
              [45.668078, 35.923441],
              [45.668063, 35.923076],
              [45.667882, 35.92284],
              [45.668547, 35.922133],
              [45.669233, 35.921603],
              [45.669957, 35.920908],
              [45.669965, 35.919819],
              [45.670142, 35.91916],
              [45.6700265, 35.9171839],
              [45.669977, 35.916337],
              [45.670531, 35.916239],
              [45.670829, 35.916032],
              [45.670699, 35.915577],
              [45.670394, 35.91518],
              [45.670301, 35.914805],
              [45.670619, 35.913386],
              [45.671262, 35.912722],
              [45.671612, 35.911774],
              [45.671999, 35.911289],
              [45.67223, 35.911113],
              [45.673201, 35.910558],
              [45.674613, 35.909831],
              [45.67477, 35.909635],
              [45.674878, 35.908597],
              [45.674992, 35.90813],
              [45.675041, 35.907136],
              [45.674987, 35.906466],
              [45.675099, 35.906129],
              [45.675688, 35.905503],
              [45.675899, 35.905104],
              [45.676186, 35.90434],
              [45.676412, 35.903966],
              [45.676555, 35.903502],
              [45.677038, 35.902614],
              [45.677705, 35.902114],
              [45.67834, 35.901755],
              [45.679248, 35.901377],
              [45.679975, 35.899312],
              [45.680528, 35.897988],
              [45.680761, 35.897862],
              [45.68165, 35.897803],
              [45.682639, 35.897863],
              [45.68323, 35.898169],
              [45.683724, 35.898326],
              [45.684304, 35.89868],
              [45.685741, 35.898853],
              [45.686462, 35.899082],
              [45.687104, 35.899474],
              [45.68757, 35.899373],
              [45.688032, 35.899102],
              [45.689283, 35.899188],
              [45.689622, 35.899374],
              [45.690267, 35.89993],
              [45.691154, 35.90008],
              [45.692885, 35.899746],
              [45.69396, 35.899126],
              [45.694639, 35.897929],
              [45.695103, 35.897406],
              [45.695702, 35.897303],
              [45.696159, 35.897061],
              [45.69647, 35.896702],
              [45.69664, 35.896338],
              [45.697095, 35.895606],
              [45.697275, 35.89515],
              [45.697367, 35.894711],
              [45.697036, 35.894206],
              [45.696439, 35.893788],
              [45.696068, 35.893351],
              [45.695506, 35.892413],
              [45.695463, 35.89212],
              [45.695593, 35.89165],
              [45.695467, 35.891085],
              [45.69543, 35.890511],
              [45.695493, 35.890221],
              [45.696112, 35.889541],
              [45.696219, 35.888766],
              [45.695954, 35.88794],
              [45.696007, 35.88744],
              [45.696682, 35.886577],
              [45.696731, 35.885715],
              [45.697595, 35.885563],
              [45.698132, 35.885359],
              [45.698585, 35.88532],
              [45.699292, 35.885364],
              [45.699965, 35.885323],
              [45.700504, 35.885171],
              [45.701282, 35.885133],
              [45.701969, 35.884968],
              [45.70298, 35.88485],
              [45.703499, 35.884883],
              [45.704018, 35.885179],
              [45.704604, 35.88529],
              [45.70493, 35.885253],
              [45.705346, 35.884942],
              [45.706212, 35.883666],
              [45.706585, 35.883499],
              [45.707509, 35.883397],
              [45.708714, 35.882918],
              [45.709309, 35.882627],
              [45.709988, 35.882125],
              [45.710393, 35.881598],
              [45.710721, 35.881394],
              [45.71109, 35.881039],
              [45.711531, 35.880822],
              [45.711986, 35.880527],
              [45.712201, 35.880246],
              [45.712725, 35.879818],
              [45.714555, 35.877934],
              [45.714739, 35.877538],
              [45.71489, 35.877012],
              [45.71475, 35.876487],
              [45.714699, 35.875856],
              [45.71485, 35.87542],
              [45.715224, 35.874952],
              [45.715696, 35.874503],
              [45.716501, 35.873954],
              [45.717376, 35.872926],
              [45.717438, 35.872507],
              [45.717461, 35.872201],
              [45.717223, 35.871784],
              [45.716729, 35.871408],
              [45.716257, 35.870152],
              [45.715992, 35.869808],
              [45.715868, 35.869251],
              [45.71591, 35.868843],
              [45.715806, 35.868538],
              [45.715432, 35.868395],
              [45.715507, 35.867672],
              [45.717003, 35.866363],
              [45.717555, 35.866046],
              [45.717666, 35.865731],
              [45.716899, 35.864006],
              [45.716446, 35.86326],
              [45.716289, 35.86267],
              [45.716445, 35.862294],
              [45.717055, 35.861578],
              [45.718231, 35.861339],
              [45.71912, 35.861107],
              [45.719918, 35.861013],
              [45.72075, 35.861003],
              [45.722825, 35.861224],
              [45.723118, 35.861148],
              [45.723368, 35.860913],
              [45.723562, 35.859896],
              [45.724134, 35.858992],
              [45.724592, 35.8581],
              [45.724414, 35.857167],
              [45.724435, 35.856763],
              [45.724664, 35.85614],
              [45.724918, 35.855656],
              [45.724735, 35.855275],
              [45.724639, 35.854825],
              [45.724634, 35.854237],
              [45.724896, 35.853827],
              [45.72528, 35.853613],
              [45.72525, 35.853369],
              [45.725036, 35.852956],
              [45.725225, 35.852446],
              [45.726015, 35.851921],
              [45.72642, 35.851569],
              [45.72661, 35.850706],
              [45.727207, 35.849937],
              [45.727545, 35.849417],
              [45.727973, 35.848376],
              [45.728407, 35.847796],
              [45.728757, 35.84743],
              [45.730062, 35.846689],
              [45.730676, 35.846272],
              [45.731247, 35.845962],
              [45.732181, 35.845657],
              [45.733241, 35.84507],
              [45.733995, 35.844825],
              [45.734334, 35.844602],
              [45.734394, 35.844301],
              [45.734345, 35.84398],
              [45.734455, 35.843603],
              [45.734695, 35.84321],
              [45.735092, 35.842976],
              [45.735773, 35.84243],
              [45.736933, 35.842055],
              [45.737331, 35.841821],
              [45.737446, 35.841534],
              [45.737341, 35.841125],
              [45.737744, 35.839957],
              [45.738062, 35.839622],
              [45.738612, 35.839201],
              [45.738803, 35.838891],
              [45.738808, 35.838651],
              [45.738614, 35.837813],
              [45.738744, 35.837177],
              [45.73875, 35.836721],
              [45.738353, 35.836006],
              [45.738234, 35.835508],
              [45.738565, 35.835147],
              [45.738939, 35.834867],
              [45.739914, 35.834785],
              [45.740029, 35.834606],
              [45.739917, 35.834355],
              [45.739664, 35.834041],
              [45.739274, 35.833712],
              [45.739173, 35.83317],
              [45.738944, 35.83276],
              [45.738848, 35.831903],
              [45.738897, 35.830614],
              [45.738604, 35.83034],
              [45.738416, 35.82989],
              [45.738471, 35.82774],
              [45.739771, 35.82742],
              [45.740926, 35.827245],
              [45.7417, 35.827144],
              [45.743259, 35.827047],
              [45.743748, 35.827067],
              [45.744822, 35.826825],
              [45.745185, 35.826688],
              [45.74613, 35.826496],
              [45.746581, 35.826161],
              [45.747013, 35.825977],
              [45.747877, 35.825388],
              [45.748156, 35.824987],
              [45.748661, 35.824442],
              [45.749126, 35.823641],
              [45.749528, 35.822762],
              [45.750085, 35.822034],
              [45.750546, 35.820928],
              [45.75072, 35.820374],
              [45.751583, 35.818976],
              [45.751917, 35.818514],
              [45.75278, 35.818032],
              [45.753119, 35.817628],
              [45.753504, 35.816983],
              [45.753934, 35.816023],
              [45.754512, 35.815514],
              [45.754966, 35.815005],
              [45.755099, 35.814781],
              [45.755639, 35.813552],
              [45.755835, 35.812895],
              [45.755646, 35.811891],
              [45.755438, 35.811114],
              [45.755357, 35.810535],
              [45.755358, 35.809915],
              [45.755497, 35.808723],
              [45.755606, 35.808487],
              [45.756061, 35.808093],
              [45.756661, 35.807332],
              [45.75687, 35.806978],
              [45.757639, 35.806786],
              [45.758913, 35.806555],
              [45.760201, 35.806378],
              [45.760588, 35.805923],
              [45.760927, 35.804858],
              [45.761858, 35.803628],
              [45.762048, 35.803244],
              [45.762318, 35.802663],
              [45.762805, 35.801246],
              [45.762865, 35.800508],
              [45.763041, 35.799961],
              [45.763235, 35.799626],
              [45.763701, 35.799014],
              [45.7641584, 35.7991035],
              [45.7670094, 35.8015681],
              [45.7701371, 35.8056657],
              [45.771725, 35.8088656],
              [45.7730723, 35.813314],
              [45.780287, 35.81056],
              [45.791769, 35.812532],
              [45.791901, 35.812167],
              [45.791901, 35.812165],
              [45.791902, 35.812165],
              [45.792381, 35.812254],
              [45.792541, 35.812398],
              [45.792737, 35.81245],
              [45.793047, 35.812568],
              [45.793401, 35.812655],
              [45.793853, 35.812539],
              [45.794287, 35.812438],
              [45.794568, 35.812428],
              [45.794955, 35.812452],
              [45.795202, 35.812507],
              [45.795525, 35.812721],
              [45.795813, 35.812904],
              [45.795983, 35.813181],
              [45.796113, 35.813366],
              [45.796324, 35.813441],
              [45.796452, 35.813623],
              [45.796623, 35.813845],
              [45.796954, 35.814091],
              [45.797397, 35.814219],
              [45.797579, 35.814374],
              [45.797863, 35.814595],
              [45.798124, 35.814738],
              [45.79834, 35.814737],
              [45.79844, 35.814854],
              [45.79862, 35.815092],
              [45.798605, 35.815367],
              [45.79851, 35.815617],
              [45.798132, 35.816029],
              [45.798145, 35.816407],
              [45.798314, 35.816754],
              [45.798398, 35.817125],
              [45.798501, 35.817452],
              [45.79865, 35.817803],
              [45.798626, 35.818155],
              [45.798598, 35.818532],
              [45.798583, 35.818882],
              [45.798749, 35.819106],
              [45.798849, 35.819317],
              [45.798901, 35.819538],
              [45.799075, 35.819827],
              [45.799185, 35.820111],
              [45.799329, 35.820331],
              [45.799555, 35.820658],
              [45.799606, 35.820987],
              [45.799645, 35.821343],
              [45.799556, 35.821724],
              [45.799359, 35.822051],
              [45.79907, 35.822487],
              [45.799163, 35.82289],
              [45.799144, 35.823299],
              [45.79912, 35.823799],
              [45.799261, 35.824118],
              [45.799528, 35.824446],
              [45.799525, 35.824728],
              [45.799627, 35.825129],
              [45.799826, 35.825619],
              [45.800144, 35.826383],
              [45.80038, 35.827039],
              [45.800704, 35.826984],
              [45.8011, 35.826783],
              [45.801816, 35.826363],
              [45.802305, 35.826161],
              [45.802714, 35.825858],
              [45.803056, 35.82561],
              [45.803866, 35.825121],
              [45.80428, 35.824875],
              [45.804739, 35.82453],
              [45.805284, 35.82416],
              [45.805798, 35.823903],
              [45.806396, 35.823539],
              [45.807024, 35.823466],
              [45.807394, 35.823427],
              [45.807957, 35.823491],
              [45.808384, 35.823507],
              [45.8092, 35.82348],
              [45.80959, 35.823586],
              [45.810231, 35.823196],
              [45.810896, 35.822885],
              [45.811542, 35.822619],
              [45.812128, 35.822142],
              [45.812779, 35.821602],
              [45.813252, 35.821344],
              [45.813595, 35.82117],
              [45.814035, 35.820944],
              [45.814629, 35.820639],
              [45.815898, 35.820284],
              [45.816538, 35.820069],
              [45.817296, 35.819764],
              [45.81762, 35.819486],
              [45.818001, 35.819049],
              [45.818576, 35.818714],
              [45.819274, 35.818305],
              [45.81985, 35.817937],
              [45.820545, 35.817661],
              [45.821357, 35.817255],
              [45.822397, 35.816888],
              [45.823048, 35.816678],
              [45.823409, 35.816534],
              [45.823639, 35.816216],
              [45.823873, 35.815766],
              [45.824381, 35.815486],
              [45.824962, 35.8151],
              [45.82541, 35.814896],
              [45.826206, 35.81445],
              [45.827017, 35.813943],
              [45.827562, 35.813571],
              [45.828142, 35.813027],
              [45.828479, 35.812513],
              [45.829163, 35.811791],
              [45.829417, 35.811419],
              [45.829902, 35.810934],
              [45.830873, 35.809891],
              [45.831285, 35.809702],
              [45.832152, 35.80983],
              [45.832823, 35.809864],
              [45.833385, 35.81006],
              [45.833883, 35.810161],
              [45.834444, 35.810233],
              [45.834908, 35.810398],
              [45.835579, 35.810813],
              [45.836, 35.811351],
              [45.836439, 35.811803],
              [45.837103, 35.812269],
              [45.837631, 35.812679],
              [45.838336, 35.812996],
              [45.839039, 35.813379],
              [45.839865, 35.813623],
              [45.840683, 35.813876],
              [45.841407, 35.813958],
              [45.841405, 35.81395],
              [45.842039, 35.814074],
              [45.84248, 35.814111],
              [45.842918, 35.814174],
              [45.84354, 35.814176],
              [45.844261, 35.813977],
              [45.844791, 35.813856],
              [45.845246, 35.813908],
              [45.845604, 35.814086],
              [45.846095, 35.814353],
              [45.846442, 35.814683],
              [45.847159, 35.814931],
              [45.847912, 35.815239],
              [45.848621, 35.815497],
              [45.849232, 35.815683],
              [45.850033, 35.816023],
              [45.850746, 35.816487],
              [45.851345, 35.816783],
              [45.852072, 35.817071],
              [45.852417, 35.817393],
              [45.853224, 35.81764],
              [45.853957, 35.818026],
              [45.854684, 35.818272],
              [45.855327, 35.818428],
              [45.856012, 35.818401],
              [45.856534, 35.818249],
              [45.856986, 35.818251],
              [45.857375, 35.818166],
              [45.857953, 35.818077],
              [45.858501, 35.818177],
              [45.859157, 35.81823],
              [45.859729, 35.818308],
              [45.860197, 35.818407],
              [45.861004, 35.818654],
              [45.861444, 35.818841],
              [45.861812, 35.818868],
              [45.862402, 35.818669],
              [45.862824, 35.818404],
              [45.863627, 35.817866],
              [45.864251, 35.817222],
              [45.864812, 35.816913],
              [45.865282, 35.816829],
              [45.866706, 35.816252],
              [45.867674, 35.815929],
              [45.868671, 35.815714],
              [45.869133, 35.815464],
              [45.869686, 35.815082],
              [45.870262, 35.81468],
              [45.870816, 35.814317],
              [45.871392, 35.813859],
              [45.872014, 35.8134],
              [45.87222, 35.813096],
              [45.872839, 35.81241],
              [45.873554, 35.811894],
              [45.87388, 35.811614],
              [45.874114, 35.81132],
              [45.8744, 35.811338],
              [45.874868, 35.811362],
              [45.875358, 35.811473],
              [45.875917, 35.811578],
              [45.876395, 35.811832],
              [45.876772, 35.812123],
              [45.877195, 35.812131],
              [45.877859, 35.812174],
              [45.878564, 35.812417],
              [45.879193, 35.812633],
              [45.87944, 35.812733],
              [45.879776, 35.813023],
              [45.879976, 35.813365],
              [45.879955, 35.813783],
              [45.87979, 35.814113],
              [45.879596, 35.814673],
              [45.879594, 35.815128],
              [45.87969, 35.815648],
              [45.879826, 35.816168],
              [45.879885, 35.816545],
              [45.880106, 35.816932],
              [45.880192, 35.817147],
              [45.880255, 35.81754],
              [45.880281, 35.817718],
              [45.880432, 35.817911],
              [45.88076, 35.818129],
              [45.881102, 35.818285],
              [45.881334, 35.818521],
              [45.881411, 35.818779],
              [45.881331, 35.819084],
              [45.881349, 35.819346],
              [45.881352, 35.819743],
              [45.88136, 35.820155],
              [45.881461, 35.82035],
              [45.881526, 35.820561],
              [45.881544, 35.820897],
              [45.881613, 35.821124],
              [45.881799, 35.821336],
              [45.881886, 35.821592],
              [45.881814, 35.821813],
              [45.881718, 35.822063],
              [45.881744, 35.822315],
              [45.88186, 35.822566],
              [45.88183, 35.822911],
              [45.881889, 35.823139],
              [45.882051, 35.823488],
              [45.882121, 35.823872],
              [45.882051, 35.824142],
              [45.881861, 35.824412],
              [45.881911, 35.824716],
              [45.881881, 35.824987],
              [45.881853, 35.825266],
              [45.881679, 35.825557],
              [45.881594, 35.825731],
              [45.881659, 35.825941],
              [45.881759, 35.82617],
              [45.881769, 35.826591],
              [45.881733, 35.826838],
              [45.881833, 35.827298],
              [45.881954, 35.827837],
              [45.881935, 35.828148],
              [45.881978, 35.828545],
              [45.882194, 35.829214],
              [45.882226, 35.829721],
              [45.882067, 35.83015],
              [45.881905, 35.83043],
              [45.881711, 35.830675],
              [45.882179, 35.830767],
              [45.88259, 35.830884],
              [45.883117, 35.831136],
              [45.883691, 35.831412],
              [45.8842, 35.831553],
              [45.884828, 35.831653],
              [45.885341, 35.83185],
              [45.885664, 35.83182],
              [45.886018, 35.831676],
              [45.88672, 35.831637],
              [45.887245, 35.831766],
              [45.88773, 35.83201],
              [45.888034, 35.832365],
              [45.888145, 35.83279],
              [45.888276, 35.833369],
              [45.888423, 35.833853],
              [45.888872, 35.834576],
              [45.889092, 35.835146],
              [45.88933, 35.835521],
              [45.88978, 35.835516],
              [45.890716, 35.835448],
              [45.891478, 35.835373],
              [45.891989, 35.835405],
              [45.89238, 35.835519],
              [45.893038, 35.835696],
              [45.893671, 35.835778],
              [45.894012, 35.835778],
              [45.894512, 35.836193],
              [45.895008, 35.836824],
              [45.895664, 35.837415],
              [45.896036, 35.837649],
              [45.896501, 35.83769],
              [45.896827, 35.837622],
              [45.897175, 35.837516],
              [45.897932, 35.837186],
              [45.898427, 35.836931],
              [45.899089, 35.836797],
              [45.9, 35.836502],
              [45.900559, 35.836339],
              [45.901061, 35.836397],
              [45.9015, 35.836485],
              [45.90177, 35.836539],
              [45.902145, 35.836917],
              [45.902542, 35.837054],
              [45.903043, 35.837089],
              [45.903602, 35.837099],
              [45.904045, 35.83695],
              [45.904788, 35.836663],
              [45.905441, 35.836456],
              [45.90605, 35.836523],
              [45.906343, 35.836437],
              [45.906485, 35.836152],
              [45.906742, 35.835774],
              [45.907095, 35.835511],
              [45.907497, 35.835324],
              [45.908067, 35.835241],
              [45.908816, 35.834995],
              [45.90955, 35.83483],
              [45.910171, 35.834634],
              [45.910744, 35.83414],
              [45.911269, 35.833884],
              [45.911934, 35.833782],
              [45.912358, 35.833658],
              [45.912744, 35.833156],
              [45.91332, 35.832596],
              [45.914021, 35.832553],
              [45.914883, 35.832707],
              [45.91545, 35.832877],
              [45.915998, 35.832927],
              [45.916025, 35.832929],
              [45.916377, 35.83276],
              [45.916786, 35.832733],
              [45.917189, 35.832813],
              [45.917746, 35.83272],
              [45.918597, 35.832404],
              [45.919771, 35.831908],
              [45.920407, 35.831788],
              [45.921268, 35.831648],
              [45.921739, 35.831605],
              [45.92204, 35.831567],
              [45.922368, 35.831593],
              [45.922972, 35.831698],
              [45.923571, 35.831783],
              [45.924022, 35.831612],
              [45.9248, 35.831418],
              [45.924972, 35.831347],
              [45.925496, 35.831049],
              [45.926085, 35.831],
              [45.926428, 35.830837],
              [45.926969, 35.830603],
              [45.927879, 35.830383],
              [45.928193, 35.830259],
              [45.928973, 35.829882],
              [45.929272, 35.829762],
              [45.93006, 35.829417],
              [45.930307, 35.829289],
              [45.93069, 35.829044],
              [45.931308, 35.828666],
              [45.932005, 35.828339],
              [45.932248, 35.828097],
              [45.932344, 35.82785],
              [45.932387, 35.827573],
              [45.932417, 35.827054],
              [45.932339, 35.826258],
              [45.932379, 35.826084],
              [45.93276, 35.82572],
              [45.933114, 35.825443],
              [45.933394, 35.825132],
              [45.933539, 35.824863],
              [45.93417, 35.824321],
              [45.934583, 35.824116],
              [45.935183, 35.824031],
              [45.935854, 35.824048],
              [45.936148, 35.82402],
              [45.936574, 35.823886],
              [45.937388, 35.82366],
              [45.938274, 35.823615],
              [45.938791, 35.823484],
              [45.939586, 35.82351],
              [45.940173, 35.823759],
              [45.940909, 35.824136],
              [45.941035, 35.824447],
              [45.941132, 35.8248],
              [45.941601, 35.824903],
              [45.942041, 35.825052],
              [45.942722, 35.825469],
              [45.943018, 35.825664],
              [45.943557, 35.825616],
              [45.944113, 35.825552],
              [45.944431, 35.82537],
              [45.944703, 35.825316],
              [45.945358, 35.825482],
              [45.946092, 35.825619],
              [45.946377, 35.825753],
              [45.946856, 35.8258],
              [45.947273, 35.8259],
              [45.947811, 35.826093],
              [45.948035, 35.826128],
              [45.948368, 35.825942],
              [45.948808, 35.825765],
              [45.949097, 35.825335],
              [45.949414, 35.824896],
              [45.950017, 35.824074],
              [45.950304, 35.823563],
              [45.950447, 35.823477],
              [45.950814, 35.823363],
              [45.951142, 35.823257],
              [45.951591, 35.823111],
              [45.951869, 35.823082],
              [45.952341, 35.823047],
              [45.952592, 35.823068],
              [45.952945, 35.823152],
              [45.953173, 35.823177],
              [45.953518, 35.823118],
              [45.953861, 35.822989],
              [45.954188, 35.822837],
              [45.954344, 35.822803],
              [45.954629, 35.822838],
              [45.955184, 35.822948],
              [45.955474, 35.823057],
              [45.955589, 35.823191],
              [45.955575, 35.823749],
              [45.955933, 35.824353],
              [45.956233, 35.824791],
              [45.956394, 35.825194],
              [45.956566, 35.825699],
              [45.956704, 35.826495],
              [45.956829, 35.827071],
              [45.956844, 35.827453],
              [45.956778, 35.828025],
              [45.956735, 35.828493],
              [45.956741, 35.828711],
              [45.956595, 35.829034],
              [45.956362, 35.829402],
              [45.956352, 35.829419],
              [45.956364, 35.829973],
              [45.956302, 35.830772],
              [45.956278, 35.831791],
              [45.95624, 35.832663],
              [45.956216, 35.833492],
              [45.956186, 35.834168],
              [45.956185, 35.834181],
              [45.956291, 35.834375],
              [45.956385, 35.834812],
              [45.956375, 35.835117],
              [45.956466, 35.835388],
              [45.956665, 35.835652],
              [45.956904, 35.83582],
              [45.957136, 35.835994],
              [45.95743, 35.836143],
              [45.957682, 35.836147],
              [45.957999, 35.83611],
              [45.958402, 35.835944],
              [45.958652, 35.835961],
              [45.958987, 35.83609],
              [45.959293, 35.836282],
              [45.959511, 35.8365],
              [45.959594, 35.836707],
              [45.960135, 35.837086],
              [45.960472, 35.837243],
              [45.960817, 35.837374],
              [45.960859, 35.83761],
              [45.960942, 35.837946],
              [45.961106, 35.838327],
              [45.961362, 35.838633],
              [45.961675, 35.83887],
              [45.962239, 35.839281],
              [45.962628, 35.83985],
              [45.962634, 35.840408],
              [45.962781, 35.840875],
              [45.962904, 35.841232],
              [45.963195, 35.841692],
              [45.963531, 35.842247],
              [45.963729, 35.84314],
              [45.964013, 35.843593],
              [45.964361, 35.843579],
              [45.965023, 35.843523],
              [45.96555, 35.843333],
              [45.96583, 35.843175],
              [45.966061, 35.842911],
              [45.966369, 35.842837],
              [45.966654, 35.842661],
              [45.966937, 35.84263],
              [45.96738, 35.842564],
              [45.967381, 35.842564],
              [45.968191, 35.842189],
              [45.968616, 35.842052],
              [45.969102, 35.841953],
              [45.96937, 35.841788],
              [45.969583, 35.841395],
              [45.969837, 35.840869],
              [45.970228, 35.840274],
              [45.970655, 35.83995],
              [45.97076, 35.839661],
              [45.97079, 35.839237],
              [45.970695, 35.838875],
              [45.970485, 35.838552],
              [45.970443, 35.838237],
              [45.970481, 35.837902],
              [45.970718, 35.837715],
              [45.971155, 35.837526],
              [45.9713, 35.837237],
              [45.971427, 35.837013],
              [45.971669, 35.836883],
              [45.97196, 35.836788],
              [45.972343, 35.83668],
              [45.972701, 35.836742],
              [45.972925, 35.836698],
              [45.97333, 35.83654],
              [45.973639, 35.836496],
              [45.973831, 35.836537],
              [45.974102, 35.836558],
              [45.974201, 35.836439],
              [45.974094, 35.836183],
              [45.973996, 35.835846],
              [45.974012, 35.835446],
              [45.974047, 35.835041],
              [45.974138, 35.834874],
              [45.974359, 35.834703],
              [45.974587, 35.834691],
              [45.974823, 35.83469],
              [45.975151, 35.834775],
              [45.97545, 35.834882],
              [45.975603, 35.834893],
              [45.975884, 35.834971],
              [45.976131, 35.835034],
              [45.976428, 35.835017],
              [45.97658, 35.834792],
              [45.976765, 35.834598],
              [45.976851, 35.834428],
              [45.977182, 35.834239],
              [45.977625, 35.834168],
              [45.97802, 35.834045],
              [45.978349, 35.834076],
              [45.978762, 35.83443],
              [45.979063, 35.834602],
              [45.979416, 35.834877],
              [45.979701, 35.835065],
              [45.97996, 35.83525],
              [45.980202, 35.83543],
              [45.980586, 35.835611],
              [45.980881, 35.83576],
              [45.981168, 35.836035],
              [45.981258, 35.836208],
              [45.981477, 35.836467],
              [45.981615, 35.836726],
              [45.981791, 35.836844],
              [45.982103, 35.836961],
              [45.982306, 35.837107],
              [45.982442, 35.837416],
              [45.982594, 35.837635],
              [45.982836, 35.837943],
              [45.983062, 35.838118],
              [45.983354, 35.838313],
              [45.983678, 35.838556],
              [45.98411, 35.83879],
              [45.984646, 35.838958],
              [45.985132, 35.839169],
              [45.985411, 35.839391],
              [45.985546, 35.839502],
              [45.985899, 35.839739],
              [45.986225, 35.839999],
              [45.986239, 35.84001],
              [45.986248, 35.840004],
              [45.986914, 35.839462],
              [45.987358, 35.839126],
              [45.987947, 35.838628],
              [45.988478, 35.838279],
              [45.989022, 35.837869],
              [45.989801, 35.837797],
              [45.990545, 35.837742],
              [45.991063, 35.837769],
              [45.991521, 35.837442],
              [45.992225, 35.837125],
              [45.992579, 35.836849],
              [45.993091, 35.836597],
              [45.993954, 35.836372],
              [45.994454, 35.836249],
              [45.994819, 35.836345],
              [45.995247, 35.83656],
              [45.995568, 35.836628],
              [45.996118, 35.836498],
              [45.996496, 35.836277],
              [45.997127, 35.836041],
              [45.99774, 35.835784],
              [45.998293, 35.835607],
              [45.998696, 35.83551],
              [45.99932, 35.835555],
              [45.999737, 35.835469],
              [45.999878, 35.835155],
              [46.000213, 35.834789],
              [46.000587, 35.834487],
              [46.000917, 35.834157],
              [46.001422, 35.83387],
              [46.00181, 35.833765],
              [46.002459, 35.833934],
              [46.002831, 35.834064],
              [46.003311, 35.834155],
              [46.003721, 35.834279],
              [46.004352, 35.834486],
              [46.004807, 35.834709],
              [46.005101, 35.834956],
              [46.005395, 35.835331],
              [46.005452, 35.835673],
              [46.005495, 35.836133],
              [46.005254, 35.83652],
              [46.005462, 35.836721],
              [46.00586, 35.836789],
              [46.006392, 35.836697],
              [46.006681, 35.836734],
              [46.007475, 35.836987],
              [46.008022, 35.837032],
              [46.008732, 35.837181],
              [46.009602, 35.837305],
              [46.010574, 35.837426],
              [46.011399, 35.83751],
              [46.012173, 35.837602],
              [46.012829, 35.837806],
              [46.013305, 35.838002],
              [46.013906, 35.837934],
              [46.014174, 35.838056],
              [46.014308, 35.838211],
              [46.014458, 35.838445],
              [46.015064, 35.838586],
              [46.015849, 35.838607],
              [46.01624, 35.838454],
              [46.016423, 35.838029],
              [46.016429, 35.837748],
              [46.016555, 35.837426],
              [46.01691, 35.83722],
              [46.017462, 35.836658],
              [46.017801, 35.836314],
              [46.018256, 35.836035],
              [46.018698, 35.836003],
              [46.019159, 35.836189],
              [46.019691, 35.836412],
              [46.020152, 35.836412],
              [46.020747, 35.836065],
              [46.021257, 35.835742],
              [46.021835, 35.835374],
              [46.022588, 35.835108],
              [46.02312, 35.834957],
              [46.023886, 35.834817],
              [46.024303, 35.834602],
              [46.024647, 35.834468],
              [46.024842, 35.834671],
              [46.024967, 35.834967],
              [46.024986, 35.835373],
              [46.024723, 35.835716],
              [46.024624, 35.836046],
              [46.024598, 35.836424],
              [46.024798, 35.83665],
              [46.025128, 35.83695],
              [46.025512, 35.837137],
              [46.026001, 35.837459],
              [46.027397, 35.8379],
              [46.02801, 35.838017],
              [46.028662, 35.838011],
              [46.029285, 35.838114],
              [46.029735, 35.838373],
              [46.030072, 35.838707],
              [46.030704, 35.838727],
              [46.031259, 35.838561],
              [46.031728, 35.83835],
              [46.03222, 35.838251],
              [46.032615, 35.838366],
              [46.032801, 35.838653],
              [46.033078, 35.839066],
              [46.033679, 35.839313],
              [46.034029, 35.839586],
              [46.034398, 35.83995],
              [46.034936, 35.840324],
              [46.035648, 35.84074],
              [46.036218, 35.840957],
              [46.036806, 35.841078],
              [46.037227, 35.841259],
              [46.037738, 35.841566],
              [46.038161, 35.841945],
              [46.038457, 35.84239],
              [46.038632, 35.842994],
              [46.039008, 35.843392],
              [46.039362, 35.843688],
              [46.039713, 35.843961],
              [46.039927, 35.844197],
              [46.040152, 35.844793],
              [46.04041, 35.845057],
              [46.041348, 35.845008],
              [46.041948, 35.845185],
              [46.042342, 35.845358],
              [46.042814, 35.845286],
              [46.043134, 35.845098],
              [46.043747, 35.8449],
              [46.044261, 35.844973],
              [46.04462, 35.845163],
              [46.044984, 35.845505],
              [46.045488, 35.845778],
              [46.045678, 35.846018],
              [46.045659, 35.846301],
              [46.045511, 35.84658],
              [46.045695, 35.847042],
              [46.045966, 35.847363],
              [46.04623, 35.847906],
              [46.046341, 35.848262],
              [46.046829, 35.848643],
              [46.047053, 35.849111],
              [46.047113, 35.849405],
              [46.047141, 35.849856],
              [46.047253, 35.849967],
              [46.047738, 35.85008],
              [46.048101, 35.850422],
              [46.048535, 35.850787],
              [46.048767, 35.850985],
              [46.049223, 35.851336],
              [46.049545, 35.851532],
              [46.050039, 35.851787],
              [46.050566, 35.852111],
              [46.050832, 35.852457],
              [46.051097, 35.852764],
              [46.0516, 35.853088],
              [46.051863, 35.85324],
              [46.052292, 35.853353],
              [46.052938, 35.853695],
              [46.053396, 35.854194],
              [46.054018, 35.854498],
              [46.054658, 35.854745],
              [46.055328, 35.854815],
              [46.055805, 35.854965],
              [46.056173, 35.855203],
              [46.056849, 35.855439],
              [46.057487, 35.85568],
              [46.058257, 35.855936],
              [46.059, 35.85594],
              [46.059484, 35.856112],
              [46.059785, 35.856206],
              [46.060317, 35.856241],
              [46.061349, 35.856154],
              [46.062358, 35.856141],
              [46.063296, 35.855777],
              [46.063723, 35.855735],
              [46.064062, 35.855893],
              [46.06441, 35.856027],
              [46.065313, 35.856123],
              [46.065886, 35.856421],
              [46.066273, 35.856747],
              [46.066533, 35.856894],
              [46.066865, 35.856949],
              [46.067599, 35.857094],
              [46.068247, 35.857135],
              [46.068782, 35.857369],
              [46.069074, 35.857546],
              [46.069664, 35.857363],
              [46.070034, 35.857354],
              [46.070367, 35.857291],
              [46.071297, 35.857266],
              [46.07173, 35.857317],
              [46.072521, 35.85743],
              [46.07302, 35.857553],
              [46.073752, 35.857815],
              [46.074674, 35.858001],
              [46.075732, 35.858039],
              [46.076759, 35.858116],
              [46.077444, 35.85821],
              [46.078196, 35.858376],
              [46.078562, 35.85843],
              [46.078898, 35.858427],
              [46.079274, 35.85827],
              [46.079449, 35.858274],
              [46.079596, 35.858244],
              [46.079714, 35.85826],
              [46.079716, 35.85826],
              [46.079846, 35.858088],
              [46.07997, 35.857961],
              [46.080194, 35.857937],
              [46.08039, 35.857912],
              [46.080543, 35.857791],
              [46.080714, 35.857561],
              [46.080964, 35.857376],
              [46.081172, 35.857204],
              [46.081395, 35.85711],
              [46.0818053, 35.8566511],
              [46.0821591, 35.8563228],
              [46.0823649, 35.8561438],
              [46.0828197, 35.8563592],
              [46.0832251, 35.8564524],
              [46.0836482, 35.8567094],
              [46.0838771, 35.8570368],
              [46.08435, 35.8571928],
              [46.08479, 35.857485],
              [46.085068, 35.857339],
              [46.085307, 35.857366],
              [46.085742, 35.857402],
              [46.086448, 35.857276],
              [46.087009, 35.857333],
              [46.087487, 35.857506],
              [46.088007, 35.857575],
              [46.088497, 35.857594],
              [46.088831, 35.857748],
              [46.089078, 35.857673],
              [46.089262, 35.857641],
              [46.08951, 35.857656],
              [46.089817, 35.857718],
              [46.089933, 35.857725],
              [46.090129, 35.857788],
              [46.090241, 35.857856],
              [46.090552, 35.85784],
              [46.090799, 35.85779],
              [46.091051, 35.857758],
              [46.091524, 35.857638],
              [46.091685, 35.857614],
              [46.092176, 35.857566],
              [46.092614, 35.857486],
              [46.092919, 35.857351],
              [46.093279, 35.857067],
              [46.093439, 35.856784],
              [46.093598, 35.856427],
              [46.093885, 35.856128],
              [46.094298, 35.855739],
              [46.094675, 35.85535],
              [46.095018, 35.855154],
              [46.095415, 35.854899],
              [46.095924, 35.854616],
              [46.095962, 35.854569],
              [46.096007, 35.854362],
              [46.096068, 35.854268],
              [46.096124, 35.854213],
              [46.096323, 35.854117],
              [46.096567, 35.853985],
              [46.096952, 35.853738],
              [46.097365, 35.853269],
              [46.097689, 35.853034],
              [46.098201, 35.852767],
              [46.098798, 35.852544],
              [46.099051, 35.85243],
              [46.099217, 35.852269],
              [46.099452, 35.852074],
              [46.099975, 35.85182],
              [46.100183, 35.851613],
              [46.100501, 35.851178],
              [46.100739, 35.850961],
              [46.101139, 35.850351],
              [46.101427, 35.850068],
              [46.101448, 35.849703],
              [46.101723, 35.849417],
              [46.101549, 35.849099],
              [46.101546, 35.848737],
              [46.101746, 35.848462],
              [46.102389, 35.848417],
              [46.102722, 35.848448],
              [46.103246, 35.848502],
              [46.104049, 35.848392],
              [46.104853, 35.848158],
              [46.10558, 35.848048],
              [46.106161, 35.848415],
              [46.106666, 35.848723],
              [46.107183, 35.848714],
              [46.108346, 35.847767],
              [46.109109, 35.847237],
              [46.109671, 35.84676],
              [46.110422, 35.846769],
              [46.110881, 35.846728],
              [46.111555, 35.846579],
              [46.112301, 35.846372],
              [46.112812, 35.846306],
              [46.113226, 35.846231],
              [46.113455, 35.84591],
              [46.114161, 35.845855],
              [46.114657, 35.845681],
              [46.115205, 35.845574],
              [46.115853, 35.845551],
              [46.116605, 35.845594],
              [46.117121, 35.845673],
              [46.117824, 35.845765],
              [46.11838, 35.845698],
              [46.118986, 35.84581],
              [46.119633, 35.845997],
              [46.120385, 35.846011],
              [46.120765, 35.845994],
              [46.121243, 35.845857],
              [46.121742, 35.845694],
              [46.122291, 35.845185],
              [46.123007, 35.84521],
              [46.123421, 35.845199],
              [46.123775, 35.845303],
              [46.124224, 35.84534],
              [46.124824, 35.845108],
              [46.125209, 35.844927],
              [46.125625, 35.844578],
              [46.126522, 35.844301],
              [46.127031, 35.843909],
              [46.127749, 35.843753],
              [46.128531, 35.843319],
              [46.129369, 35.843191],
              [46.129877, 35.843138],
              [46.130455, 35.843242],
              [46.131138, 35.843512],
              [46.1325, 35.843503],
              [46.133168, 35.843483],
              [46.134037, 35.843473],
              [46.13472, 35.843398],
              [46.135796, 35.84334],
              [46.136861, 35.843475],
              [46.137288, 35.843527],
              [46.137693, 35.842625],
              [46.137922, 35.841739],
              [46.138259, 35.840695],
              [46.138464, 35.840069],
              [46.138512, 35.839677],
              [46.138364, 35.839326],
              [46.137808, 35.839049],
              [46.13748, 35.838888],
              [46.137035, 35.838653],
              [46.136731, 35.838419],
              [46.136334, 35.837978],
              [46.136045, 35.83738],
              [46.13587, 35.836834],
              [46.135729, 35.836459],
              [46.135543, 35.835986],
              [46.135392, 35.835309],
              [46.135215, 35.835009],
              [46.135078, 35.834213],
              [46.135259, 35.833532],
              [46.135457, 35.83293],
              [46.135526, 35.832581],
              [46.135596, 35.832232],
              [46.136167, 35.831643],
              [46.136511, 35.831007],
              [46.136633, 35.830604],
              [46.136647, 35.83017],
              [46.13681, 35.829585],
              [46.137043, 35.828849],
              [46.137171, 35.828468],
              [46.137564, 35.827825],
              [46.137661, 35.827168],
              [46.137597, 35.826793],
              [46.137528, 35.826267],
              [46.137255, 35.82562],
              [46.136982, 35.82516],
              [46.137592, 35.824448],
              [46.137902, 35.823899],
              [46.138085, 35.823461],
              [46.138269, 35.823034],
              [46.138574, 35.822521],
              [46.139063, 35.821922],
              [46.139532, 35.821463],
              [46.139911, 35.821109],
              [46.140273, 35.820279],
              [46.140563, 35.81987],
              [46.141098, 35.819538],
              [46.1417, 35.819161],
              [46.142379, 35.818785],
              [46.142983, 35.818305],
              [46.143701, 35.818048],
              [46.1443, 35.817945],
              [46.145273, 35.817467],
              [46.145831, 35.816949],
              [46.146134, 35.816481],
              [46.146387, 35.815793],
              [46.146631, 35.815174],
              [46.14709, 35.814899],
              [46.147761, 35.814376],
              [46.148449, 35.814043],
              [46.148864, 35.813854],
              [46.149211, 35.813015],
              [46.14945, 35.812546],
              [46.149688, 35.811848],
              [46.150085, 35.810831],
              [46.150441, 35.810378],
              [46.151323, 35.809947],
              [46.151726, 35.809703],
              [46.152289, 35.80915],
              [46.152783, 35.808517],
              [46.153214, 35.808052],
              [46.153653, 35.807632],
              [46.153867, 35.806996],
              [46.154032, 35.806594],
              [46.154937, 35.806035],
              [46.155403, 35.805679],
              [46.156062, 35.805328],
              [46.156735, 35.805214],
              [46.157269, 35.805042],
              [46.157812, 35.804572],
              [46.158364, 35.804203],
              [46.158846, 35.80397],
              [46.15948, 35.803737],
              [46.160566, 35.803423],
              [46.161377, 35.803072],
              [46.162148, 35.802886],
              [46.16289, 35.802625],
              [46.163414, 35.802295],
              [46.164058, 35.801878],
              [46.164648, 35.801503],
              [46.165404, 35.801194],
              [46.165807, 35.801008],
              [46.166208, 35.800639],
              [46.166581, 35.80032],
              [46.16736, 35.80011],
              [46.167906, 35.799993],
              [46.168714, 35.80003],
              [46.16921, 35.800034],
              [46.169972, 35.799975],
              [46.170468, 35.799922],
              [46.17091, 35.799855],
              [46.171615, 35.799999],
              [46.171991, 35.800204],
              [46.172512, 35.800318],
              [46.173055, 35.800361],
              [46.173909, 35.800664],
              [46.174506, 35.800835],
              [46.175068, 35.801023],
              [46.17526, 35.801598],
              [46.175454, 35.801899],
              [46.175559, 35.802373],
              [46.175554, 35.802864],
              [46.175482, 35.803456],
              [46.175354, 35.803795],
              [46.175261, 35.804174],
              [46.175396, 35.804552],
              [46.175648, 35.804947],
              [46.176009, 35.805542],
              [46.176404, 35.80612],
              [46.176856, 35.806723],
              [46.177202, 35.807081],
              [46.177742, 35.807512],
              [46.178243, 35.807823],
              [46.178663, 35.808056],
              [46.178926, 35.80838],
              [46.179085, 35.808641],
              [46.179552, 35.809197],
              [46.180028, 35.809398],
              [46.180731, 35.80953],
              [46.181573, 35.809664],
              [46.182045, 35.8099],
              [46.182334, 35.810403],
              [46.182599, 35.810796],
              [46.182808, 35.811163],
              [46.182997, 35.811613],
              [46.183139, 35.811968],
              [46.183144, 35.81199],
              [46.183454, 35.812296],
              [46.183814, 35.812492],
              [46.184598, 35.812361],
              [46.184949, 35.812228],
              [46.185311, 35.811854],
              [46.185682, 35.811296],
              [46.186088, 35.810664],
              [46.186665, 35.810177],
              [46.187388, 35.809657],
              [46.18824, 35.809265],
              [46.188766, 35.80906],
              [46.189297, 35.809048],
              [46.189867, 35.809098],
              [46.190425, 35.808922],
              [46.190931, 35.808571],
              [46.191223, 35.808173],
              [46.19144, 35.807776],
              [46.19187, 35.807482],
              [46.192464, 35.807415],
              [46.19289, 35.807327],
              [46.193265, 35.806962],
              [46.193585, 35.806572],
              [46.193747, 35.806217],
              [46.193679, 35.805737],
              [46.193677, 35.805213],
              [46.193758, 35.804893],
              [46.194127, 35.80421],
              [46.19424, 35.803748],
              [46.194346, 35.803253],
              [46.194381, 35.802895],
              [46.194644, 35.802422],
              [46.194988, 35.80197],
              [46.195104, 35.80152],
              [46.195089, 35.801168],
              [46.195165, 35.800826],
              [46.19503, 35.800442],
              [46.195866, 35.800834],
              [46.196583, 35.800633],
              [46.197053, 35.800346],
              [46.19844, 35.800248],
              [46.199003, 35.800322],
              [46.199978, 35.800197],
              [46.200813, 35.800241],
              [46.201651, 35.800068],
              [46.20244, 35.799788],
              [46.202956, 35.799539],
              [46.203376, 35.799201],
              [46.204276, 35.798848],
              [46.204775, 35.798578],
              [46.205411, 35.798185],
              [46.206099, 35.797909],
              [46.20646, 35.797535],
              [46.206782, 35.797213],
              [46.207502, 35.796909],
              [46.207967, 35.796485],
              [46.208387, 35.796148],
              [46.209105, 35.795606],
              [46.209906, 35.795267],
              [46.210766, 35.794851],
              [46.211505, 35.794864],
              [46.212274, 35.794952],
              [46.21264, 35.795113],
              [46.213067, 35.795379],
              [46.213435, 35.795665],
              [46.21389, 35.796051],
              [46.214211, 35.796698],
              [46.21442, 35.797065],
              [46.214547, 35.797353],
              [46.215267, 35.798133],
              [46.215613, 35.798433],
              [46.215996, 35.798785],
              [46.216411, 35.798939],
              [46.216794, 35.799006],
              [46.217344, 35.79931],
              [46.21798, 35.799601],
              [46.218628, 35.799889],
              [46.21922, 35.800381],
              [46.21953, 35.800516],
              [46.220001, 35.800638],
              [46.221134, 35.800648],
              [46.221731, 35.800762],
              [46.22217, 35.801311],
              [46.222654, 35.801716],
              [46.223034, 35.802057],
              [46.223263, 35.802455],
              [46.223437, 35.802953],
              [46.223554, 35.803254],
              [46.223594, 35.803602],
              [46.224053, 35.804068],
              [46.224556, 35.804447],
              [46.224865, 35.80481],
              [46.224961, 35.80524],
              [46.225231, 35.805541],
              [46.225604, 35.805849],
              [46.225943, 35.806173],
              [46.226083, 35.806403],
              [46.226409, 35.806672],
              [46.226728, 35.807137],
              [46.226895, 35.807544],
              [46.227344, 35.807966],
              [46.227821, 35.808281],
              [46.228285, 35.808712],
              [46.228636, 35.808978],
              [46.229009, 35.809343],
              [46.22939, 35.80957],
              [46.229699, 35.809876],
              [46.229819, 35.810188],
              [46.229883, 35.810475],
              [46.230158, 35.811026],
              [46.230408, 35.81158],
              [46.230476, 35.812288],
              [46.230737, 35.812716],
              [46.231147, 35.812904],
              [46.231479, 35.812854],
              [46.231914, 35.812753],
              [46.232444, 35.812855],
              [46.233257, 35.813027],
              [46.23393, 35.813256],
              [46.234541, 35.813835],
              [46.235042, 35.81426],
              [46.235356, 35.814589],
              [46.235877, 35.814475],
              [46.236282, 35.814299],
              [46.236769, 35.814089],
              [46.23717, 35.814005],
              [46.237995, 35.814062],
              [46.238602, 35.814163],
              [46.239061, 35.814059],
              [46.239324, 35.8137],
              [46.239454, 35.813372],
              [46.239585, 35.812931],
              [46.239556, 35.812457],
              [46.239782, 35.812103],
              [46.240197, 35.811914],
              [46.240794, 35.811687],
              [46.241495, 35.81158],
              [46.241969, 35.811314],
              [46.242605, 35.811035],
              [46.243217, 35.81076],
              [46.244384, 35.810411],
              [46.245074, 35.810375],
              [46.245664, 35.810513],
              [46.246047, 35.810409],
              [46.246239, 35.810129],
              [46.246436, 35.809814],
              [46.24708, 35.809511],
              [46.247993, 35.809338],
              [46.248384, 35.809324],
              [46.248507, 35.809704],
              [46.248747, 35.810044],
              [46.249115, 35.81033],
              [46.249555, 35.81065],
              [46.249806, 35.81092],
              [46.250041, 35.811238],
              [46.250301, 35.811608],
              [46.250556, 35.8119],
              [46.250999, 35.812061],
              [46.251416, 35.812111],
              [46.25204, 35.812176],
              [46.252495, 35.812277],
              [46.253185, 35.812298],
              [46.253698, 35.812436],
              [46.25412, 35.812566],
              [46.254528, 35.812572],
              [46.255312, 35.812327],
              [46.255963, 35.812285],
              [46.256762, 35.81205],
              [46.257396, 35.811874],
              [46.257931, 35.811826],
              [46.2587, 35.81163],
              [46.259054, 35.811337],
              [46.259712, 35.811441],
              [46.260321, 35.811554],
              [46.26096, 35.811628],
              [46.261267, 35.811809],
              [46.26135, 35.812184],
              [46.26151, 35.812388],
              [46.261903, 35.812442],
              [46.262392, 35.812527],
              [46.26276, 35.812813],
              [46.26317, 35.813115],
              [46.263406, 35.813319],
              [46.263813, 35.813667],
              [46.264427, 35.814143],
              [46.264702, 35.814295],
              [46.265049, 35.814425],
              [46.265624, 35.814554],
              [46.265962, 35.814651],
              [46.266458, 35.814769],
              [46.267041, 35.814703],
              [46.267363, 35.814609],
              [46.267775, 35.814466],
              [46.268392, 35.814327],
              [46.269213, 35.814133],
              [46.269854, 35.814218],
              [46.270284, 35.814324],
              [46.270465, 35.814454],
              [46.270964, 35.814642],
              [46.271357, 35.814981],
              [46.271848, 35.815533],
              [46.272425, 35.815901],
              [46.27298, 35.816113],
              [46.273238, 35.81653],
              [46.273498, 35.816901],
              [46.273773, 35.817224],
              [46.27418, 35.817287],
              [46.274839, 35.817107],
              [46.275367, 35.817083],
              [46.275775, 35.817147],
              [46.276222, 35.817387],
              [46.277045, 35.817717],
              [46.277776, 35.818096],
              [46.2784, 35.818389],
              [46.279083, 35.818604],
              [46.279584, 35.818744],
              [46.279869, 35.818883],
              [46.280635, 35.819473],
              [46.280966, 35.819765],
              [46.281155, 35.820044],
              [46.281376, 35.820694],
              [46.281646, 35.82128],
              [46.281995, 35.821819],
              [46.282191, 35.822075],
              [46.282552, 35.822156],
              [46.282992, 35.822135],
              [46.283372, 35.822362],
              [46.28377, 35.822666],
              [46.283957, 35.822934],
              [46.284054, 35.823318],
              [46.284062, 35.823807],
              [46.284283, 35.824172],
              [46.284717, 35.824642],
              [46.285242, 35.825121],
              [46.285488, 35.825311],
              [46.285942, 35.825698],
              [46.286637, 35.826139],
              [46.287242, 35.826344],
              [46.288234, 35.826295],
              [46.288863, 35.826496],
              [46.289553, 35.826915],
              [46.289843, 35.827247],
              [46.290075, 35.827725],
              [46.289979, 35.82815],
              [46.289851, 35.828887],
              [46.289949, 35.829157],
              [46.290094, 35.829637],
              [46.290099, 35.830058],
              [46.289934, 35.830345],
              [46.289614, 35.830621],
              [46.289069, 35.831024],
              [46.288956, 35.831257],
              [46.289096, 35.831544],
              [46.289334, 35.832157],
              [46.289154, 35.83272],
              [46.289019, 35.833368],
              [46.289156, 35.833757],
              [46.28943, 35.834422],
              [46.2894, 35.834974],
              [46.290039, 35.834762],
              [46.290541, 35.834675],
              [46.290951, 35.834635],
              [46.291253, 35.834623],
              [46.291757, 35.834718],
              [46.292235, 35.834873],
              [46.292972, 35.835046],
              [46.293321, 35.835186],
              [46.294119, 35.835635],
              [46.294615, 35.835867],
              [46.295094, 35.835851],
              [46.295598, 35.835603],
              [46.29633, 35.835298],
              [46.29707, 35.835026],
              [46.297954, 35.834721],
              [46.298264, 35.834742],
              [46.299079, 35.834698],
              [46.299276, 35.83444],
              [46.299257, 35.833953],
              [46.299198, 35.833403],
              [46.299228, 35.832909],
              [46.298982, 35.832716],
              [46.299168, 35.831988],
              [46.299484, 35.83142],
              [46.299784, 35.830749],
              [46.299785, 35.829954],
              [46.299823, 35.829654],
              [46.300415, 35.829533],
              [46.300762, 35.829137],
              [46.300871, 35.828871],
              [46.300917, 35.828225],
              [46.301239, 35.827991],
              [46.302473, 35.827333],
              [46.302865, 35.826987],
              [46.303349, 35.826708],
              [46.303921, 35.826541],
              [46.304543, 35.826595],
              [46.305093, 35.826728],
              [46.305442, 35.826755],
              [46.306041, 35.826538],
              [46.306113, 35.826345],
              [46.30625, 35.826107],
              [46.306589, 35.825919],
              [46.306956, 35.825852],
              [46.307299, 35.82597],
              [46.307616, 35.826196],
              [46.307778, 35.826353],
              [46.308038, 35.826382],
              [46.308365, 35.826059],
              [46.308498, 35.825708],
              [46.308658, 35.825456],
              [46.309046, 35.825032],
              [46.309423, 35.824496],
              [46.309782, 35.824111],
              [46.310175, 35.823766],
              [46.310512, 35.823567],
              [46.310882, 35.823408],
              [46.311133, 35.822994],
              [46.31131, 35.822648],
              [46.311662, 35.822457],
              [46.311952, 35.822447],
              [46.312338, 35.822355],
              [46.312615, 35.821834],
              [46.312969, 35.821597],
              [46.313139, 35.821218],
              [46.313392, 35.820872],
              [46.313805, 35.820501],
              [46.314154, 35.820186],
              [46.31438, 35.819833],
              [46.314557, 35.819601],
              [46.315051, 35.81948],
              [46.315624, 35.819484],
              [46.316289, 35.819508],
              [46.316987, 35.819504],
              [46.317503, 35.81954],
              [46.317942, 35.819576],
              [46.318279, 35.819319],
              [46.318699, 35.819153],
              [46.319269, 35.819032],
              [46.319697, 35.818955],
              [46.320146, 35.81875],
              [46.320535, 35.818554],
              [46.320918, 35.818394],
              [46.321232, 35.818437],
              [46.321768, 35.818333],
              [46.322225, 35.818388],
              [46.322721, 35.81845],
              [46.323183, 35.818357],
              [46.323706, 35.818311],
              [46.32433, 35.818205],
              [46.324851, 35.818205],
              [46.32521, 35.818333],
              [46.325735, 35.818413],
              [46.326396, 35.818529],
              [46.327008, 35.818652],
              [46.327472, 35.818798],
              [46.328007, 35.819036],
              [46.328457, 35.819116],
              [46.328867, 35.819133],
              [46.329523, 35.819113],
              [46.329869, 35.818958],
              [46.330437, 35.818826],
              [46.330933, 35.818659],
              [46.331437, 35.818754],
              [46.331901, 35.818842],
              [46.332746, 35.818873],
              [46.333448, 35.819177],
              [46.334102, 35.819374],
              [46.334381, 35.819605],
              [46.334721, 35.819872],
              [46.335327, 35.820145],
              [46.335663, 35.820287],
              [46.336251, 35.820073],
              [46.337, 35.819902],
              [46.337575, 35.819746],
              [46.338425, 35.819799],
              [46.338992, 35.819838],
              [46.339444, 35.819929],
              [46.340244, 35.819902],
              [46.340366, 35.81947],
              [46.340374, 35.819064],
              [46.340514, 35.818693],
              [46.340554, 35.818418],
              [46.340369, 35.817919],
              [46.340121, 35.817432],
              [46.340011, 35.816879],
              [46.340035, 35.816301],
              [46.340054, 35.815717],
              [46.340324, 35.815177],
              [46.340563, 35.81459],
              [46.340729, 35.814016],
              [46.340834, 35.813299],
              [46.341068, 35.812402],
              [46.341262, 35.811755],
              [46.341207, 35.8111],
              [46.341243, 35.810658],
              [46.341559, 35.810273],
              [46.341827, 35.809686],
              [46.341927, 35.80953],
              [46.342535, 35.809129],
              [46.343213, 35.808513],
              [46.343758, 35.807851],
              [46.34407, 35.807252],
              [46.344359, 35.806127],
              [46.344525, 35.805565],
              [46.34444, 35.804862],
              [46.344243, 35.804435],
              [46.343769, 35.804142],
              [46.344477, 35.803335],
              [46.344994, 35.802558],
              [46.345574, 35.801797],
              [46.345923, 35.801026],
              [46.34598, 35.800368],
              [46.3459, 35.799947],
              [46.345561, 35.799452],
              [46.3452, 35.799028],
              [46.345005, 35.798914],
              [46.344771, 35.798836],
              [46.344631, 35.798749],
              [46.344594, 35.798417],
              [46.344424, 35.798052],
              [46.344277, 35.797789],
              [46.344302, 35.797272],
              [46.344189, 35.796708],
              [46.344408, 35.796151],
              [46.34447, 35.795515],
              [46.344372, 35.795131],
              [46.344497, 35.794724],
              [46.344827, 35.793979],
              [46.345218, 35.793452],
              [46.345754, 35.792721],
              [46.345936, 35.792169],
              [46.346148, 35.791578],
              [46.346025, 35.791255],
              [46.345561, 35.790767],
              [46.345463, 35.790269],
              [46.345554, 35.789594],
              [46.345699, 35.789218],
              [46.345968, 35.788767],
              [46.346292, 35.788342],
              [46.346386, 35.787906],
              [46.346823, 35.787418],
              [46.347062, 35.787119],
              [46.346927, 35.786855],
              [46.346652, 35.786589],
              [46.346293, 35.786233],
              [46.345974, 35.78594],
              [46.34564, 35.785751],
              [46.345124, 35.785602],
              [46.344857, 35.785483],
              [46.344668, 35.78509],
              [46.344295, 35.784554],
              [46.344022, 35.784242],
              [46.343781, 35.784017],
              [46.343273, 35.783957],
              [46.342841, 35.783898],
              [46.341959, 35.783302],
              [46.341473, 35.783],
              [46.341095, 35.782727],
              [46.340633, 35.782535],
              [46.340226, 35.78213],
              [46.339658, 35.781806],
              [46.339359, 35.781601],
              [46.338838, 35.781088],
              [46.338504, 35.780785],
              [46.338013, 35.780518],
              [46.337544, 35.78035],
              [46.337114, 35.780187],
              [46.336849, 35.780022],
              [46.336899, 35.779388],
              [46.337226, 35.778746],
              [46.337889, 35.778018],
              [46.33815, 35.777477],
              [46.338212, 35.776897],
              [46.33833, 35.776287],
              [46.338652, 35.775565],
              [46.338887, 35.77508],
              [46.339309, 35.77405],
              [46.339147, 35.77345],
              [46.338202, 35.772853],
              [46.337541, 35.772167],
              [46.336822, 35.771615],
              [46.336265, 35.770709],
              [46.335874, 35.77038],
              [46.334865, 35.769782],
              [46.334436, 35.769277],
              [46.334084, 35.768898],
              [46.333839, 35.768536],
              [46.333884, 35.768221],
              [46.333862, 35.767894],
              [46.333935, 35.767484],
              [46.334027, 35.766866],
              [46.334101, 35.766285],
              [46.334303, 35.765479],
              [46.334288, 35.765185],
              [46.334018, 35.764827],
              [46.333817, 35.764493],
              [46.333468, 35.763954],
              [46.333321, 35.763349],
              [46.333103, 35.763166],
              [46.33243, 35.763052],
              [46.331789, 35.763024],
              [46.331425, 35.762988],
              [46.330723, 35.762742],
              [46.330229, 35.762691],
              [46.329691, 35.762557],
              [46.329222, 35.762446],
              [46.328483, 35.762148],
              [46.327773, 35.762096],
              [46.327314, 35.761801],
              [46.326979, 35.761707],
              [46.326218, 35.761786],
              [46.325648, 35.762021],
              [46.324889, 35.762261],
              [46.32457, 35.762478],
              [46.3241, 35.762843],
              [46.323975, 35.762891],
              [46.323778, 35.762872],
              [46.323387, 35.762649],
              [46.322879, 35.762533],
              [46.322499, 35.762135],
              [46.322196, 35.761748],
              [46.321855, 35.761412],
              [46.321534, 35.761222],
              [46.321254, 35.761048],
              [46.32051, 35.760956],
              [46.320087, 35.760884],
              [46.319718, 35.760997],
              [46.319726, 35.761258],
              [46.319033, 35.761454],
              [46.318406, 35.761493],
              [46.31793, 35.761519],
              [46.317136, 35.761606],
              [46.316662, 35.761701],
              [46.316151, 35.761915],
              [46.315409, 35.762063],
              [46.314557, 35.762226],
              [46.313989, 35.762415],
              [46.313684, 35.762597],
              [46.313194, 35.762751],
              [46.313016, 35.762753],
              [46.312853, 35.762541],
              [46.312643, 35.762301],
              [46.31226, 35.762006],
              [46.311747, 35.761583],
              [46.311472, 35.761374],
              [46.310833, 35.761414],
              [46.310204, 35.761498],
              [46.3097, 35.761518],
              [46.309111, 35.761607],
              [46.30858, 35.76162],
              [46.308, 35.761925],
              [46.307312, 35.762086],
              [46.306516, 35.762105],
              [46.305853, 35.761978],
              [46.30577, 35.761717],
              [46.305603, 35.76148],
              [46.30521, 35.76097],
              [46.304741, 35.760346],
              [46.304395, 35.759704],
              [46.304105, 35.759372],
              [46.303914, 35.759024],
              [46.303797, 35.758666],
              [46.303924, 35.758271],
              [46.304328, 35.75797],
              [46.304551, 35.757662],
              [46.304576, 35.757374],
              [46.304387, 35.757095],
              [46.303935, 35.756776],
              [46.303606, 35.756382],
              [46.303395, 35.75606],
              [46.303206, 35.755781],
              [46.303401, 35.755341],
              [46.303619, 35.754727],
              [46.303806, 35.754311],
              [46.303821, 35.753978],
              [46.303625, 35.753723],
              [46.303348, 35.753446],
              [46.302795, 35.752846],
              [46.302584, 35.752525],
              [46.302179, 35.752359],
              [46.301759, 35.75224],
              [46.301135, 35.752005],
              [46.300386, 35.751435],
              [46.299586, 35.750861],
              [46.299028, 35.750468],
              [46.298586, 35.75025],
              [46.297714, 35.750041],
              [46.297184, 35.749939],
              [46.296732, 35.74962],
              [46.296307, 35.749309],
              [46.295479, 35.749127],
              [46.294757, 35.748735],
              [46.294305, 35.748474],
              [46.293851, 35.748201],
              [46.293291, 35.747853],
              [46.292788, 35.747417],
              [46.292346, 35.747085],
              [46.291901, 35.746742],
              [46.291398, 35.746648],
              [46.290899, 35.746576],
              [46.290268, 35.746535],
              [46.289293, 35.746546],
              [46.288733, 35.746484],
              [46.288524, 35.746173],
              [46.288274, 35.745904],
              [46.287711, 35.745716],
              [46.287053, 35.745554],
              [46.286599, 35.745452],
              [46.285884, 35.745207],
              [46.285427, 35.745151],
              [46.284803, 35.745144],
              [46.284204, 35.744961],
              [46.283793, 35.744887],
              [46.283489, 35.744831],
              [46.283013, 35.744174],
              [46.282519, 35.743611],
              [46.282136, 35.743088],
              [46.281638, 35.742445],
              [46.281601, 35.742052],
              [46.281513, 35.741541],
              [46.281435, 35.741017],
              [46.281467, 35.740534],
              [46.281082, 35.740114],
              [46.280856, 35.73967],
              [46.28082, 35.73939],
              [46.281422, 35.738729],
              [46.2818, 35.738375],
              [46.282176, 35.738067],
              [46.282262, 35.737655],
              [46.282707, 35.737143],
              [46.282744, 35.736738],
              [46.282713, 35.73631],
              [46.282862, 35.735839],
              [46.283032, 35.735803],
              [46.28343, 35.73581],
              [46.283745, 35.735697],
              [46.284108, 35.735583],
              [46.284318, 35.735337],
              [46.284925, 35.735099],
              [46.2853, 35.73455],
              [46.285701, 35.733815],
              [46.285469, 35.733726],
              [46.285213, 35.73373],
              [46.284657, 35.733632],
              [46.284198, 35.733565],
              [46.28326, 35.733571],
              [46.282415, 35.733369],
              [46.28151, 35.733095],
              [46.281238, 35.732982],
              [46.28089, 35.732735],
              [46.280215, 35.732309],
              [46.279675, 35.731944],
              [46.279234, 35.731515],
              [46.278758, 35.73097],
              [46.278534, 35.73058],
              [46.277931, 35.729954],
              [46.277799, 35.729531],
              [46.277535, 35.729187],
              [46.277041, 35.728866],
              [46.276381, 35.728708],
              [46.275683, 35.728727],
              [46.275201, 35.728594],
              [46.27433, 35.728493],
              [46.273646, 35.728333],
              [46.27261, 35.727887],
              [46.272118, 35.727766],
              [46.271503, 35.727773],
              [46.270873, 35.727952],
              [46.270128, 35.728429],
              [46.269193, 35.728942],
              [46.268513, 35.729179],
              [46.267973, 35.729255],
              [46.26717, 35.729248],
              [46.266123, 35.729185],
              [46.265089, 35.729061],
              [46.263694, 35.728987],
              [46.262499, 35.728865],
              [46.262069, 35.728745],
              [46.261089, 35.728142],
              [46.260631, 35.727946],
              [46.260046, 35.727537],
              [46.259515, 35.727402],
              [46.258892, 35.727369],
              [46.258307, 35.727211],
              [46.258095, 35.72701],
              [46.257746, 35.726799],
              [46.257289, 35.726733],
              [46.256738, 35.726691],
              [46.256246, 35.72669],
              [46.255816, 35.726701],
              [46.25526, 35.726438],
              [46.254767, 35.726187],
              [46.25428, 35.725965],
              [46.253902, 35.725607],
              [46.253469, 35.725157],
              [46.252844, 35.724734],
              [46.2527, 35.724313],
              [46.252492, 35.724132],
              [46.251982, 35.723853],
              [46.251799, 35.723384],
              [46.251454, 35.722985],
              [46.25097, 35.722748],
              [46.250558, 35.722591],
              [46.250537, 35.722176],
              [46.25042, 35.721924],
              [46.24989, 35.721471],
              [46.249443, 35.721203],
              [46.248845, 35.720856],
              [46.247981, 35.720276],
              [46.247244, 35.719658],
              [46.246417, 35.719274],
              [46.245879, 35.718918],
              [46.245178, 35.718737],
              [46.244445, 35.718519],
              [46.243997, 35.718302],
              [46.243683, 35.718085],
              [46.243359, 35.71788],
              [46.242674, 35.717716],
              [46.242036, 35.717415],
              [46.241309, 35.717037],
              [46.240691, 35.716964],
              [46.239872, 35.716999],
              [46.238785, 35.716732],
              [46.237319, 35.716417],
              [46.23651, 35.716191],
              [46.234944, 35.71568],
              [46.233992, 35.715283],
              [46.233493, 35.715073],
              [46.233374, 35.71534],
              [46.232993, 35.716036],
              [46.232491, 35.716523],
              [46.2324088, 35.7165801],
              [46.231821, 35.716989],
              [46.231002, 35.717251],
              [46.229934, 35.717185],
              [46.229285, 35.717124],
              [46.228126, 35.716993],
              [46.227347, 35.716918],
              [46.22679, 35.71698],
              [46.226104, 35.717038],
              [46.22519, 35.717098],
              [46.22437, 35.717348],
              [46.223898, 35.717568],
              [46.223202, 35.718038],
              [46.222495, 35.718169],
              [46.221527, 35.718271],
              [46.220986, 35.718581],
              [46.220401, 35.718977],
              [46.219529, 35.719395],
              [46.218703, 35.719623],
              [46.21776, 35.719721],
              [46.216657, 35.719843],
              [46.21658, 35.720534],
              [46.216386, 35.721251],
              [46.216295, 35.721609],
              [46.216152, 35.722407],
              [46.215818, 35.723281],
              [46.215004, 35.723217],
              [46.214315, 35.723234],
              [46.213595, 35.72295],
              [46.21276, 35.722968],
              [46.211838, 35.723234],
              [46.211059, 35.723353],
              [46.210242, 35.723595],
              [46.209301, 35.723824],
              [46.208433, 35.723728],
              [46.207603, 35.723509],
              [46.206495, 35.723495],
              [46.20587, 35.723789],
              [46.2051, 35.723699],
              [46.204111, 35.723669],
              [46.203246, 35.723524],
              [46.20234, 35.723029],
              [46.201485, 35.722744],
              [46.200513, 35.722544],
              [46.19956, 35.722322],
              [46.198851, 35.721514],
              [46.198377, 35.721255],
              [46.197637, 35.721062],
              [46.196996, 35.721014],
              [46.196387, 35.721],
              [46.195795, 35.720954],
              [46.195295, 35.720423],
              [46.194857, 35.719961],
              [46.194365, 35.719281],
              [46.1939, 35.718222],
              [46.193711, 35.71747],
              [46.193271, 35.717068],
              [46.192936, 35.716701],
              [46.192714, 35.716032],
              [46.192171, 35.715595],
              [46.19197, 35.71517],
              [46.191336, 35.714834],
              [46.190861, 35.714693],
              [46.190289, 35.714428],
              [46.189671, 35.714307],
              [46.188775, 35.714383],
              [46.188011, 35.71439],
              [46.187127, 35.71408],
              [46.18632, 35.713985],
              [46.185489, 35.713894],
              [46.184856, 35.713686],
              [46.184236, 35.713359],
              [46.183565, 35.713019],
              [46.182605, 35.712886],
              [46.181874, 35.712742],
              [46.1813, 35.712723],
              [46.180515, 35.712684],
              [46.179573, 35.712648],
              [46.179345, 35.712463],
              [46.179112, 35.711805],
              [46.178881, 35.711414],
              [46.178493, 35.711093],
              [46.177972, 35.710772],
              [46.1775, 35.710457],
              [46.176912, 35.710248],
              [46.176499, 35.710014],
              [46.17614, 35.709469],
              [46.175899, 35.709018],
              [46.175509, 35.708641],
              [46.1749, 35.708174],
              [46.174447, 35.707764],
              [46.173871, 35.707282],
              [46.173408, 35.70643],
              [46.173173, 35.704975],
              [46.173082, 35.704229],
              [46.173291, 35.703786],
              [46.173413, 35.703335],
              [46.173397, 35.70247],
              [46.173874, 35.701901],
              [46.174036, 35.701534],
              [46.174243, 35.700756],
              [46.174366, 35.700315],
              [46.174227, 35.699832],
              [46.173726, 35.699162],
              [46.173227, 35.698769],
              [46.172603, 35.698481],
              [46.171638, 35.698192],
              [46.170627, 35.697268],
              [46.170084, 35.696634],
              [46.1697, 35.695879],
              [46.169376, 35.695382],
              [46.168961, 35.694977],
              [46.168347, 35.694225],
              [46.167985, 35.693654],
              [46.167624, 35.693084],
              [46.167506, 35.692519],
              [46.167549, 35.691192],
              [46.167472, 35.690257],
              [46.167013, 35.689946],
              [46.166379, 35.689611],
              [46.165718, 35.68919],
              [46.165081, 35.688964],
              [46.163791, 35.688931],
              [46.162737, 35.688846],
              [46.161742, 35.688784],
              [46.160924, 35.688839],
              [46.159492, 35.688877],
              [46.159087, 35.689143],
              [46.157808, 35.689704],
              [46.157462, 35.689994],
              [46.15622, 35.691055],
              [46.156105, 35.691271],
              [46.155106, 35.691801],
              [46.153819, 35.692256],
              [46.152363, 35.692784],
              [46.151645, 35.692904],
              [46.15112, 35.692888],
              [46.150222, 35.693151],
              [46.148946, 35.693408],
              [46.147802, 35.693784],
              [46.147066, 35.694004],
              [46.146113, 35.694364],
              [46.145234, 35.694664],
              [46.144086, 35.695149],
              [46.143488, 35.695458],
              [46.143003, 35.695851],
              [46.142108, 35.696715],
              [46.141569, 35.697342],
              [46.140902, 35.697671],
              [46.140387, 35.697773],
              [46.139734, 35.697597],
              [46.138908, 35.696944],
              [46.137955, 35.696455],
              [46.137275, 35.69587],
              [46.136448, 35.695867],
              [46.135559, 35.696071],
              [46.134912, 35.695862],
              [46.133244, 35.695735],
              [46.132158, 35.695435],
              [46.131439, 35.695185],
              [46.130644, 35.695285],
              [46.129813, 35.69545],
              [46.128856, 35.695594],
              [46.127895, 35.695717],
              [46.127444, 35.69577],
              [46.126565, 35.695617],
              [46.125917, 35.69553],
              [46.125506, 35.695212],
              [46.125144, 35.694839],
              [46.124998, 35.694248],
              [46.124781, 35.693805],
              [46.124424, 35.693323],
              [46.123941, 35.692947],
              [46.123705, 35.692398],
              [46.123501, 35.691894],
              [46.123143, 35.691487],
              [46.1226, 35.691207],
              [46.122165, 35.690909],
              [46.121512, 35.690686],
              [46.12062, 35.690507],
              [46.119806, 35.690245],
              [46.11872, 35.689847],
              [46.117939, 35.689357],
              [46.116735, 35.688697],
              [46.115534, 35.688184],
              [46.113704, 35.687877],
              [46.112769, 35.687751],
              [46.111593, 35.687826],
              [46.11, 35.688137],
              [46.108664, 35.688139],
              [46.106717, 35.688109],
              [46.10617, 35.68794],
              [46.105556, 35.687866],
              [46.10511, 35.687901],
              [46.10405, 35.688009],
              [46.10265, 35.688056],
              [46.101857, 35.687842],
              [46.101044, 35.687718],
              [46.100057, 35.688151],
              [46.099377, 35.688285],
              [46.098695, 35.688469],
              [46.098397, 35.689151],
              [46.09824, 35.689675],
              [46.098265, 35.690194],
              [46.098312, 35.691035],
              [46.098242, 35.691696],
              [46.097896, 35.692443],
              [46.097282, 35.692864],
              [46.096563, 35.693096],
              [46.095871, 35.69327],
              [46.094939, 35.693399],
              [46.094106, 35.693356],
              [46.093391, 35.693357],
              [46.092658, 35.693448],
              [46.091812, 35.693161],
              [46.090866, 35.692741],
              [46.090239, 35.692759],
              [46.089186, 35.693189],
              [46.088649, 35.693647],
              [46.088041, 35.693878],
              [46.087207, 35.694072],
              [46.086522, 35.694153],
              [46.085708, 35.694216],
              [46.085061, 35.694166],
              [46.084173, 35.693999],
              [46.083229, 35.693824],
              [46.08205, 35.693692],
              [46.081197, 35.693554],
              [46.080059, 35.693258],
              [46.079068, 35.693218],
              [46.078318, 35.693223],
              [46.077262, 35.693339],
              [46.076641, 35.693268],
              [46.076158, 35.693157],
              [46.074958, 35.693038],
              [46.073856, 35.692924],
              [46.072481, 35.692661],
              [46.071764, 35.692534],
              [46.070859, 35.692197],
              [46.069903, 35.691787],
              [46.069389, 35.692006],
              [46.068948, 35.69246],
              [46.068341, 35.693055],
              [46.06784, 35.693272],
              [46.06735, 35.693487],
              [46.067166, 35.693896],
              [46.067143, 35.69444],
              [46.0666, 35.695057],
              [46.066182, 35.69529],
              [46.065442, 35.696033],
              [46.064289, 35.696684],
              [46.063132, 35.697915],
              [46.062517, 35.69933],
              [46.061902, 35.700594],
              [46.061558, 35.70117],
              [46.061249, 35.700885],
              [46.060822, 35.700693],
              [46.060212, 35.700433],
              [46.059853, 35.700369],
              [46.059639, 35.700242],
              [46.059287, 35.700118],
              [46.058473, 35.69993],
              [46.057808, 35.699761],
              [46.056884, 35.699781],
              [46.056253, 35.699715],
              [46.055262, 35.699764],
              [46.054989, 35.699762],
              [46.054362, 35.699598],
              [46.053536, 35.699564],
              [46.052636, 35.69958],
              [46.051854, 35.69988],
              [46.051369, 35.700084],
              [46.050664, 35.700078],
              [46.050228, 35.700138],
              [46.049721, 35.700302],
              [46.048942, 35.700763],
              [46.048518, 35.701151],
              [46.048307, 35.701815],
              [46.04789, 35.701971],
              [46.047478, 35.70221],
              [46.047047, 35.702299],
              [46.046499, 35.702556],
              [46.046319, 35.702832],
              [46.046309, 35.703143],
              [46.046485, 35.703862],
              [46.046388, 35.704219],
              [46.046529, 35.704559],
              [46.046699, 35.705126],
              [46.046798, 35.705432],
              [46.046734, 35.705957],
              [46.046026, 35.706438],
              [46.045373, 35.706568],
              [46.044382, 35.706645],
              [46.043831, 35.706648],
              [46.043354, 35.706684],
              [46.042848, 35.706729],
              [46.042465, 35.706728],
              [46.042115, 35.706255],
              [46.041591, 35.705584],
              [46.041426, 35.705282],
              [46.041002, 35.704864],
              [46.040779, 35.704723],
              [46.040387, 35.704314],
              [46.040081, 35.704061],
              [46.039734, 35.704109],
              [46.03902, 35.704267],
              [46.038225, 35.704411],
              [46.037405, 35.704854],
              [46.036668, 35.705133],
              [46.036137, 35.705206],
              [46.035721, 35.705278],
              [46.035072, 35.704708],
              [46.034675, 35.704035],
              [46.034487, 35.703466],
              [46.03423, 35.70268],
              [46.033959, 35.701941],
              [46.033451, 35.701681],
              [46.033034, 35.701448],
              [46.032804, 35.700821],
              [46.032366, 35.70066],
              [46.032127, 35.70056],
              [46.031844, 35.700511],
              [46.031404, 35.700375],
              [46.031273, 35.700147],
              [46.031283, 35.699777],
              [46.031449, 35.699311],
              [46.031345, 35.699006],
              [46.031322, 35.698714],
              [46.03161, 35.698369],
              [46.031902, 35.698019],
              [46.03185, 35.697495],
              [46.031696, 35.697182],
              [46.031957, 35.696703],
              [46.032197, 35.696065],
              [46.032081, 35.695673],
              [46.032088, 35.695318],
              [46.03227, 35.694934],
              [46.032554, 35.69427],
              [46.032719, 35.693677],
              [46.032542, 35.693283],
              [46.032269, 35.693104],
              [46.031668, 35.69271],
              [46.031427, 35.692448],
              [46.030938, 35.69228],
              [46.030314, 35.692071],
              [46.029563, 35.691806],
              [46.028721, 35.691838],
              [46.028353, 35.691938],
              [46.02779, 35.69206],
              [46.027083, 35.691922],
              [46.026629, 35.69196],
              [46.026225, 35.691878],
              [46.026084, 35.691184],
              [46.025899, 35.690811],
              [46.025689, 35.690461],
              [46.025664, 35.689948],
              [46.025576, 35.689636],
              [46.025118, 35.689202],
              [46.025308, 35.688734],
              [46.025517, 35.688449],
              [46.025946, 35.687903],
              [46.026262, 35.68752],
              [46.026235, 35.687056],
              [46.02622, 35.686832],
              [46.025845, 35.686151],
              [46.025326, 35.685805],
              [46.024807, 35.685724],
              [46.024284, 35.685599],
              [46.023713, 35.685565],
              [46.023286, 35.68555],
              [46.022608, 35.685526],
              [46.022235, 35.68539],
              [46.022095, 35.685208],
              [46.022133, 35.684888],
              [46.021906, 35.684634],
              [46.021695, 35.68452],
              [46.021072, 35.684857],
              [46.020456, 35.68508],
              [46.020059, 35.685213],
              [46.019557, 35.685396],
              [46.018733, 35.685696],
              [46.018124, 35.685712],
              [46.017747, 35.685621],
              [46.017343, 35.685421],
              [46.016977, 35.68523],
              [46.016551, 35.685043],
              [46.016181, 35.684922],
              [46.015596, 35.684846],
              [46.015186, 35.684681],
              [46.014762, 35.684592],
              [46.014311, 35.68461],
              [46.013923, 35.684373],
              [46.013646, 35.684018],
              [46.013431, 35.683649],
              [46.013311, 35.683115],
              [46.013334, 35.682693],
              [46.013252, 35.682198],
              [46.013165, 35.681709],
              [46.012892, 35.681348],
              [46.012495, 35.681004],
              [46.012036, 35.680659],
              [46.011743, 35.680375],
              [46.011432, 35.680069],
              [46.011072, 35.679907],
              [46.010733, 35.679851],
              [46.010027, 35.67951],
              [46.009443, 35.679138],
              [46.009149, 35.678707],
              [46.009225, 35.678249],
              [46.009269, 35.677864],
              [46.009082, 35.677423],
              [46.008904, 35.677083],
              [46.008632, 35.676845],
              [46.008499, 35.676578],
              [46.008209, 35.676407],
              [46.008478, 35.675848],
              [46.008575, 35.675338],
              [46.008581, 35.674924],
              [46.008533, 35.674385],
              [46.008882, 35.673894],
              [46.009176, 35.673583],
              [46.009717, 35.673292],
              [46.010305, 35.673054],
              [46.01087, 35.67273],
              [46.011084, 35.672651],
              [46.011279, 35.672177],
              [46.011378, 35.671887],
              [46.01159, 35.671494],
              [46.011874, 35.671106],
              [46.012136, 35.670843],
              [46.012546, 35.670684],
              [46.012854, 35.670558],
              [46.013049, 35.670201],
              [46.013162, 35.669925],
              [46.013459, 35.669594],
              [46.013635, 35.669387],
              [46.014011, 35.669055],
              [46.014182, 35.668732],
              [46.014565, 35.668261],
              [46.014832, 35.667604],
              [46.015083, 35.66723],
              [46.015208, 35.666829],
              [46.015079, 35.666464],
              [46.014817, 35.666126],
              [46.014543, 35.665765],
              [46.014431, 35.665422],
              [46.014369, 35.665175],
              [46.014186, 35.664718],
              [46.014214, 35.664527],
              [46.01452, 35.664367],
              [46.01494, 35.664255],
              [46.015185, 35.664206],
              [46.01544, 35.664028],
              [46.015475, 35.663783],
              [46.015351, 35.6635],
              [46.014528, 35.663047],
              [46.014365, 35.662917],
              [46.014095, 35.662301],
              [46.013646, 35.66161],
              [46.013363, 35.661084],
              [46.013367, 35.660326],
              [46.013292, 35.659928],
              [46.013229, 35.65955],
              [46.012988, 35.65899],
              [46.012934, 35.658826],
              [46.012936, 35.658477],
              [46.012973, 35.658312],
              [46.013036, 35.658142],
              [46.013086, 35.657988],
              [46.01309, 35.657829],
              [46.013057, 35.657755],
              [46.012958, 35.657687],
              [46.012762, 35.657546],
              [46.012682, 35.657409],
              [46.012642, 35.657276],
              [46.012627, 35.657133],
              [46.012547, 35.657002],
              [46.0125, 35.656854],
              [46.012542, 35.656626],
              [46.01256, 35.65644],
              [46.012559, 35.656177],
              [46.012523, 35.655976],
              [46.012491, 35.65574],
              [46.012419, 35.655385],
              [46.012449, 35.655054],
              [46.012721, 35.65432],
              [46.01272, 35.65432],
              [46.012694, 35.654305],
              [46.012621, 35.654282],
              [46.012528, 35.654256],
              [46.012461, 35.654235],
              [46.01234, 35.65419],
              [46.012214, 35.65412],
              [46.012082, 35.654019],
              [46.01203, 35.65399],
              [46.01193, 35.653979],
              [46.011815, 35.653972],
              [46.011687, 35.653964],
              [46.01158, 35.653944],
              [46.01144, 35.653924],
              [46.011317, 35.653921],
              [46.011248, 35.653923],
              [46.011147, 35.653934],
              [46.011033, 35.653931],
              [46.010912, 35.653914],
              [46.010849, 35.653898],
              [46.010848, 35.653898],
              [46.010848, 35.653894],
              [46.010857, 35.653828],
              [46.010875, 35.653782],
              [46.010896, 35.653754],
              [46.010939, 35.653758],
              [46.010986, 35.653771],
              [46.011064, 35.65378],
              [46.011178, 35.653781],
              [46.011256, 35.653757],
              [46.011293, 35.65372],
              [46.011314, 35.653689],
              [46.011297, 35.653651],
              [46.011282, 35.653604],
              [46.01126, 35.653529],
              [46.011297, 35.653497],
              [46.0113, 35.653448],
              [46.011332, 35.653395],
              [46.011355, 35.653342],
              [46.011376, 35.653273],
              [46.01139, 35.65322],
              [46.011404, 35.653182],
              [46.011436, 35.653155],
              [46.011465, 35.653131],
              [46.011514, 35.65311],
              [46.01156, 35.653079],
              [46.011559, 35.653042],
              [46.011562, 35.652999],
              [46.011565, 35.652942],
              [46.011561, 35.652889],
              [46.011569, 35.652846],
              [46.011572, 35.652811],
              [46.011518, 35.652718],
              [46.011424, 35.652619],
              [46.011349, 35.652495],
              [46.01131, 35.652379],
              [46.011314, 35.652307],
              [46.011336, 35.652242],
              [46.011345, 35.652178],
              [46.011325, 35.652121],
              [46.011269, 35.652069],
              [46.011236, 35.652016],
              [46.01124, 35.651948],
              [46.011248, 35.651892],
              [46.011243, 35.651839],
              [46.011219, 35.651775],
              [46.011177, 35.651711],
              [46.011138, 35.651632],
              [46.011119, 35.651579],
              [46.011091, 35.651556],
              [46.011036, 35.651553],
              [46.011003, 35.651531],
              [46.010993, 35.651482],
              [46.010993, 35.651429],
              [46.010955, 35.651376],
              [46.010922, 35.65132],
              [46.01093, 35.651252],
              [46.010939, 35.65121],
              [46.01098, 35.651149],
              [46.010997, 35.651089],
              [46.010987, 35.650979],
              [46.010937, 35.650922],
              [46.010814, 35.650824],
              [46.010769, 35.650711],
              [46.010646, 35.650564],
              [46.010601, 35.650451],
              [46.010609, 35.650366],
              [46.010668, 35.650273],
              [46.010737, 35.650237],
              [46.010814, 35.650166],
              [46.010865, 35.650059],
              [46.01082, 35.649932],
              [46.010854, 35.649882],
              [46.010862, 35.649818],
              [46.010965, 35.649718],
              [46.010973, 35.649626],
              [46.010841, 35.6495],
              [46.010787, 35.649401],
              [46.010699, 35.649253],
              [46.010696, 35.649048],
              [46.010737, 35.648877],
              [46.010727, 35.648729],
              [46.010657, 35.648666],
              [46.010483, 35.648667],
              [46.010345, 35.648767],
              [46.010147, 35.648889],
              [46.009949, 35.648962],
              [46.00981, 35.648977],
              [46.009749, 35.648949],
              [46.009695, 35.648801],
              [46.009667, 35.648624],
              [46.009648, 35.648497],
              [46.009578, 35.648469],
              [46.009527, 35.648533],
              [46.009459, 35.648619],
              [46.009398, 35.648612],
              [46.00938, 35.648542],
              [46.009258, 35.648522],
              [46.00917, 35.648444],
              [46.00916, 35.648317],
              [46.009184, 35.648161],
              [46.009209, 35.648069],
              [46.009121, 35.648006],
              [46.009, 35.648035],
              [46.008844, 35.648058],
              [46.008679, 35.648045],
              [46.008626, 35.647967],
              [46.008643, 35.647882],
              [46.008468, 35.647799],
              [46.008381, 35.647807],
              [46.008226, 35.647857],
              [46.008105, 35.647901],
              [46.007939, 35.647803],
              [46.007894, 35.647669],
              [46.007659, 35.647636],
              [46.007467, 35.647559],
              [46.007326, 35.647405],
              [46.007273, 35.64727],
              [46.007263, 35.647157],
              [46.007219, 35.647115],
              [46.00714, 35.647066],
              [46.007061, 35.646989],
              [46.007068, 35.646897],
              [46.007101, 35.646776],
              [46.007074, 35.646663],
              [46.007022, 35.646628],
              [46.006743, 35.646524],
              [46.006638, 35.646468],
              [46.006455, 35.646399],
              [46.006333, 35.646372],
              [46.006263, 35.646323],
              [46.006262, 35.646238],
              [46.00633, 35.646145],
              [46.006425, 35.64606],
              [46.006519, 35.645953],
              [46.006535, 35.645853],
              [46.006559, 35.645697],
              [46.006488, 35.645549],
              [46.006374, 35.645493],
              [46.00626, 35.64536],
              [46.006086, 35.645305],
              [46.00593, 35.645327],
              [46.005834, 35.645321],
              [46.005711, 35.645201],
              [46.005642, 35.645188],
              [46.005529, 35.645203],
              [46.005408, 35.645239],
              [46.005286, 35.645212],
              [46.005285, 35.645106],
              [46.005318, 35.645006],
              [46.005342, 35.644801],
              [46.005393, 35.64473],
              [46.005409, 35.644652],
              [46.00533, 35.644596],
              [46.005243, 35.644596],
              [46.005149, 35.64464],
              [46.005115, 35.644689],
              [46.005184, 35.644724],
              [46.005176, 35.64476],
              [46.005064, 35.644775],
              [46.005038, 35.644818],
              [46.00503, 35.644853],
              [46.00497, 35.644896],
              [46.004822, 35.644876],
              [46.004778, 35.644791],
              [46.004665, 35.644799],
              [46.004612, 35.644779],
              [46.004568, 35.644715],
              [46.004602, 35.644609],
              [46.004618, 35.644538],
              [46.004565, 35.644411],
              [46.004528, 35.644284],
              [46.004415, 35.644242],
              [46.004268, 35.64425],
              [46.004182, 35.644322],
              [46.004087, 35.644372],
              [46.003983, 35.644366],
              [46.003877, 35.644268],
              [46.003771, 35.644077],
              [46.003744, 35.644014],
              [46.003821, 35.64395],
              [46.003803, 35.643893],
              [46.00369, 35.643887],
              [46.003689, 35.643802],
              [46.003515, 35.643768],
              [46.003411, 35.64379],
              [46.003335, 35.643883],
              [46.00324, 35.64399],
              [46.003154, 35.644047],
              [46.00305, 35.644013],
              [46.002962, 35.643928],
              [46.0029, 35.643823],
              [46.002873, 35.643738],
              [46.002803, 35.643731],
              [46.0027, 35.643739],
              [46.002587, 35.643776],
              [46.002562, 35.643826],
              [46.002588, 35.643854],
              [46.002545, 35.643889],
              [46.002468, 35.643925],
              [46.00233, 35.644004],
              [46.002183, 35.644027],
              [46.002045, 35.644099],
              [46.001968, 35.644192],
              [46.001908, 35.644263],
              [46.001752, 35.644278],
              [46.001647, 35.644223],
              [46.001576, 35.644089],
              [46.001583, 35.643982],
              [46.001626, 35.643918],
              [46.001582, 35.643841],
              [46.001433, 35.643757],
              [46.001311, 35.643694],
              [46.001284, 35.643638],
              [46.001283, 35.643595],
              [46.001231, 35.643525],
              [46.001221, 35.643447],
              [46.001237, 35.643369],
              [46.001263, 35.643319],
              [46.001358, 35.643283],
              [46.001462, 35.643282],
              [46.001505, 35.643254],
              [46.001496, 35.643197],
              [46.001434, 35.643148],
              [46.001425, 35.643063],
              [46.001406, 35.642999],
              [46.001319, 35.642936],
              [46.001153, 35.642888],
              [46.001013, 35.642741],
              [46.000952, 35.642706],
              [46.000665, 35.642659],
              [46.000429, 35.642561],
              [46.000385, 35.642498],
              [46.000393, 35.642434],
              [46.000486, 35.642278],
              [46.000529, 35.642199],
              [46.000511, 35.642143],
              [46.000416, 35.642158],
              [46.000346, 35.642173],
              [46.00025, 35.642103],
              [46.000111, 35.642075],
              [45.99992, 35.642084],
              [45.999824, 35.642064],
              [45.999761, 35.64188],
              [45.999743, 35.641781],
              [45.99982, 35.641695],
              [45.999879, 35.641546],
              [45.99986, 35.641447],
              [45.999764, 35.641413],
              [45.99959, 35.641357],
              [45.999398, 35.641246],
              [45.999379, 35.64114],
              [45.9993, 35.641034],
              [45.999116, 35.640943],
              [45.998968, 35.640888],
              [45.99875, 35.640805],
              [45.998595, 35.640863],
              [45.998371, 35.640978],
              [45.998214, 35.640972],
              [45.998039, 35.640839],
              [45.997856, 35.640777],
              [45.99769, 35.640693],
              [45.997533, 35.64061],
              [45.997436, 35.640483],
              [45.997382, 35.64032],
              [45.997337, 35.640193],
              [45.997267, 35.640166],
              [45.997205, 35.640074],
              [45.997136, 35.640046],
              [45.996954, 35.640097],
              [45.996825, 35.640176],
              [45.996748, 35.640276],
              [45.996567, 35.640391],
              [45.996395, 35.640442],
              [45.99623, 35.640443],
              [45.996073, 35.640367],
              [45.995933, 35.640318],
              [45.995838, 35.640376],
              [45.995656, 35.64037],
              [45.9955, 35.640357],
              [45.995327, 35.640394],
              [45.995136, 35.640382],
              [45.995041, 35.640418],
              [45.995086, 35.640517],
              [45.995104, 35.640644],
              [45.995044, 35.64068],
              [45.994932, 35.640695],
              [45.994749, 35.640661],
              [45.994435, 35.640529],
              [45.994269, 35.640417],
              [45.994163, 35.640283],
              [45.994152, 35.640121],
              [45.994159, 35.639972],
              [45.99414, 35.639837],
              [45.994026, 35.639732],
              [45.994007, 35.639598],
              [45.994067, 35.639534],
              [45.994108, 35.639377],
              [45.994125, 35.639285],
              [45.994037, 35.639243],
              [45.993951, 35.639294],
              [45.993812, 35.639295],
              [45.993759, 35.639161],
              [45.993792, 35.63904],
              [45.99393, 35.638954],
              [45.994041, 35.638861],
              [45.994118, 35.638775],
              [45.99417, 35.638704],
              [45.994151, 35.638626],
              [45.994176, 35.638527],
              [45.994253, 35.638441],
              [45.994312, 35.638335],
              [45.994284, 35.638179],
              [45.994195, 35.637974],
              [45.994272, 35.63791],
              [45.994384, 35.637831],
              [45.994513, 35.637759],
              [45.994634, 35.637645],
              [45.994692, 35.637496],
              [45.994682, 35.637368],
              [45.994551, 35.63727],
              [45.994454, 35.637165],
              [45.994426, 35.636995],
              [45.994285, 35.636869],
              [45.994163, 35.636757],
              [45.993986, 35.636524],
              [45.993855, 35.636419],
              [45.993819, 35.636342],
              [45.993853, 35.636249],
              [45.99392, 35.636114],
              [45.994014, 35.635979],
              [45.994135, 35.635879],
              [45.994246, 35.635786],
              [45.994314, 35.635693],
              [45.994261, 35.635623],
              [45.994183, 35.635609],
              [45.993992, 35.635611],
              [45.993767, 35.635591],
              [45.993609, 35.635501],
              [45.993556, 35.635395],
              [45.99359, 35.635331],
              [45.993659, 35.635302],
              [45.993745, 35.635223],
              [45.993805, 35.635166],
              [45.993804, 35.635095],
              [45.993734, 35.635032],
              [45.993586, 35.635026],
              [45.993466, 35.635105],
              [45.99338, 35.635219],
              [45.993294, 35.635255],
              [45.993129, 35.635228],
              [45.992954, 35.635145],
              [45.992876, 35.635089],
              [45.992892, 35.635004],
              [45.992943, 35.634968],
              [45.993056, 35.634924],
              [45.993228, 35.634845],
              [45.993367, 35.634823],
              [45.993392, 35.634759],
              [45.993365, 35.634688],
              [45.993295, 35.634632],
              [45.993165, 35.634626],
              [45.993034, 35.634556],
              [45.992997, 35.634401],
              [45.993171, 35.634442],
              [45.993258, 35.634427],
              [45.993292, 35.634377],
              [45.993317, 35.634306],
              [45.993342, 35.634193],
              [45.993289, 35.634108],
              [45.993279, 35.634023],
              [45.993347, 35.633938],
              [45.993415, 35.633817],
              [45.993465, 35.633632],
              [45.993687, 35.63334],
              [45.993875, 35.63314],
              [45.994038, 35.632997],
              [45.994323, 35.632881],
              [45.994738, 35.632807],
              [45.995189, 35.632768],
              [45.995475, 35.632766],
              [45.995804, 35.632721],
              [45.996254, 35.632618],
              [45.99641, 35.632602],
              [45.99654, 35.632601],
              [45.996756, 35.632543],
              [45.997033, 35.632491],
              [45.99732, 35.63251],
              [45.99752, 35.632543],
              [45.997642, 35.632613],
              [45.997764, 35.63269],
              [45.997938, 35.632717],
              [45.998147, 35.632786],
              [45.998391, 35.632883],
              [45.998532, 35.632995],
              [45.998837, 35.633092],
              [45.999088, 35.633076],
              [45.999157, 35.633082],
              [45.999228, 35.633167],
              [45.999307, 35.633251],
              [45.999577, 35.633362],
              [45.99983, 35.633459],
              [46.000491, 35.633631],
              [46.0007, 35.633629],
              [46.000935, 35.633705],
              [46.001021, 35.633718],
              [46.001213, 35.633759],
              [46.001526, 35.63382],
              [46.001725, 35.633783],
              [46.001942, 35.63381],
              [46.002228, 35.633765],
              [46.002306, 35.633729],
              [46.002426, 35.633657],
              [46.002747, 35.633619],
              [46.002971, 35.633532],
              [46.003186, 35.633396],
              [46.003427, 35.633217],
              [46.003738, 35.63308],
              [46.0041, 35.632956],
              [46.004463, 35.632854],
              [46.004766, 35.632823],
              [46.005035, 35.6328],
              [46.005329, 35.632726],
              [46.005623, 35.632653],
              [46.005969, 35.632516],
              [46.006201, 35.632372],
              [46.00633, 35.6323],
              [46.006503, 35.63227],
              [46.006745, 35.632212],
              [46.006893, 35.632211],
              [46.007023, 35.632224],
              [46.007128, 35.632272],
              [46.007163, 35.632343],
              [46.00727, 35.632505],
              [46.007383, 35.632582],
              [46.007567, 35.632672],
              [46.007731, 35.632685],
              [46.008009, 35.63269],
              [46.008209, 35.632702],
              [46.008426, 35.6327],
              [46.008702, 35.632592],
              [46.008918, 35.632519],
              [46.009108, 35.632468],
              [46.009273, 35.632446],
              [46.009368, 35.632445],
              [46.009533, 35.632479],
              [46.009663, 35.632456],
              [46.009749, 35.632399],
              [46.009661, 35.632322],
              [46.009652, 35.63223],
              [46.009694, 35.632145],
              [46.009684, 35.632038],
              [46.009709, 35.631982],
              [46.009908, 35.631902],
              [46.009993, 35.631823],
              [46.010053, 35.631695],
              [46.010095, 35.63161],
              [46.010181, 35.631567],
              [46.01031, 35.631516],
              [46.010422, 35.631416],
              [46.010453, 35.631125],
              [46.010477, 35.630955],
              [46.010657, 35.630763],
              [46.010794, 35.630634],
              [46.010896, 35.63047],
              [46.011008, 35.630427],
              [46.011128, 35.630334],
              [46.011179, 35.630199],
              [46.011151, 35.630079],
              [46.011072, 35.629959],
              [46.011175, 35.629901],
              [46.011304, 35.629801],
              [46.011406, 35.629637],
              [46.011429, 35.629446],
              [46.011436, 35.629262],
              [46.011286, 35.629114],
              [46.011129, 35.628981],
              [46.011145, 35.628924],
              [46.011145, 35.628854],
              [46.011178, 35.628768],
              [46.011299, 35.628732],
              [46.011506, 35.628645],
              [46.011618, 35.628538],
              [46.011773, 35.628466],
              [46.011885, 35.628451],
              [46.012015, 35.628421],
              [46.01223, 35.62825],
              [46.012272, 35.6282],
              [46.012367, 35.628128],
              [46.012513, 35.628035],
              [46.01266, 35.627963],
              [46.012764, 35.627926],
              [46.012867, 35.627897],
              [46.012945, 35.627868],
              [46.013005, 35.627783],
              [46.013004, 35.627698],
              [46.012977, 35.627613],
              [46.01294, 35.627436],
              [46.012903, 35.627309],
              [46.012816, 35.627246],
              [46.012754, 35.62714],
              [46.012752, 35.627048],
              [46.012803, 35.626913],
              [46.012827, 35.626779],
              [46.012817, 35.626672],
              [46.012869, 35.626622],
              [46.012851, 35.62658],
              [46.01285, 35.626488],
              [46.012857, 35.626396],
              [46.012882, 35.626318],
              [46.012889, 35.626155],
              [46.012913, 35.626013],
              [46.012929, 35.625949],
              [46.012929, 35.625892],
              [46.012962, 35.625743],
              [46.012942, 35.625595],
              [46.012889, 35.625482],
              [46.012905, 35.625354],
              [46.012947, 35.625248],
              [46.012918, 35.625078],
              [46.012839, 35.624973],
              [46.012776, 35.624817],
              [46.012707, 35.624797],
              [46.012619, 35.624698],
              [46.012514, 35.624607],
              [46.012459, 35.624423],
              [46.012414, 35.624254],
              [46.012369, 35.624155],
              [46.012253, 35.623936],
              [46.012181, 35.62371],
              [46.012152, 35.623477],
              [46.012177, 35.623349],
              [46.012254, 35.623264],
              [46.012383, 35.62317],
              [46.012399, 35.623064],
              [46.012292, 35.622845],
              [46.012228, 35.622598],
              [46.012225, 35.622379],
              [46.012267, 35.62223],
              [46.012326, 35.622151],
              [46.012481, 35.622015],
              [46.012618, 35.621929],
              [46.012669, 35.621794],
              [46.012684, 35.621624],
              [46.012682, 35.621454],
              [46.012671, 35.621306],
              [46.012712, 35.621107],
              [46.012772, 35.621028],
              [46.012832, 35.62095],
              [46.012909, 35.620886],
              [46.013064, 35.620828],
              [46.013212, 35.620841],
              [46.013334, 35.620875],
              [46.013498, 35.620817],
              [46.013637, 35.620816],
              [46.013741, 35.620801],
              [46.013896, 35.620729],
              [46.014024, 35.620586],
              [46.014074, 35.620394],
              [46.014246, 35.620265],
              [46.014348, 35.620151],
              [46.014424, 35.619981],
              [46.014588, 35.619908],
              [46.014717, 35.619794],
              [46.014775, 35.619631],
              [46.014835, 35.619545],
              [46.01493, 35.619488],
              [46.015033, 35.619409],
              [46.015177, 35.619202],
              [46.015269, 35.618925],
              [46.015328, 35.618741],
              [46.015377, 35.618563],
              [46.015437, 35.618442],
              [46.015487, 35.618322],
              [46.01559, 35.618207],
              [46.015744, 35.618079],
              [46.015752, 35.617965],
              [46.01575, 35.617831],
              [46.015748, 35.617675],
              [46.015651, 35.617569],
              [46.015649, 35.617385],
              [46.015656, 35.617265],
              [46.01569, 35.617194],
              [46.015784, 35.617087],
              [46.015913, 35.617015],
              [46.016025, 35.616936],
              [46.01611, 35.616801],
              [46.016178, 35.61668],
              [46.016167, 35.616559],
              [46.016184, 35.616496],
              [46.016262, 35.616467],
              [46.016426, 35.616402],
              [46.016598, 35.616266],
              [46.016725, 35.616109],
              [46.016784, 35.615952],
              [46.016876, 35.615654],
              [46.016925, 35.615455],
              [46.016906, 35.615272],
              [46.016826, 35.615109],
              [46.016685, 35.614933],
              [46.016605, 35.614821],
              [46.0164474, 35.6146746],
              [46.0161503, 35.6145422],
              [46.016085, 35.614174],
              [46.016067, 35.614053],
              [46.016194, 35.613868],
              [46.016235, 35.613712],
              [46.016251, 35.613549],
              [46.016328, 35.613449],
              [46.016439, 35.613328],
              [46.016568, 35.613228],
              [46.016635, 35.613093],
              [46.016659, 35.612929],
              [46.016622, 35.612753],
              [46.016655, 35.612561],
              [46.016756, 35.612376],
              [46.016875, 35.61217],
              [46.016968, 35.612006],
              [46.017132, 35.611891],
              [46.017244, 35.611848],
              [46.017278, 35.61177],
              [46.017319, 35.611614],
              [46.017387, 35.611507],
              [46.017489, 35.611322],
              [46.017409, 35.611174],
              [46.017312, 35.611047],
              [46.017311, 35.610948],
              [46.01731, 35.610863],
              [46.01736, 35.610778],
              [46.017403, 35.610699],
              [46.01749, 35.610713],
              [46.017524, 35.610691],
              [46.017515, 35.610635],
              [46.017522, 35.61055],
              [46.01746, 35.610437],
              [46.017519, 35.610309],
              [46.01764, 35.61023],
              [46.017674, 35.610159],
              [46.017724, 35.610017],
              [46.017739, 35.609854],
              [46.017807, 35.609726],
              [46.017883, 35.609569],
              [46.017908, 35.60947],
              [46.017863, 35.609393],
              [46.017879, 35.609244],
              [46.017852, 35.609194],
              [46.017765, 35.60916],
              [46.017626, 35.609133],
              [46.017452, 35.609113],
              [46.017148, 35.60903],
              [46.016973, 35.608954],
              [46.016754, 35.608814],
              [46.016666, 35.608673],
              [46.01655, 35.608448],
              [46.016488, 35.608314],
              [46.016417, 35.608151],
              [46.016258, 35.607954],
              [46.016065, 35.607821],
              [46.015891, 35.607702],
              [46.015855, 35.607625],
              [46.015897, 35.607511],
              [46.015939, 35.607426],
              [46.015991, 35.607376],
              [46.016102, 35.60729],
              [46.016136, 35.607183],
              [46.01623, 35.607076],
              [46.016236, 35.606871],
              [46.016129, 35.606681],
              [46.015997, 35.60654],
              [46.015831, 35.606442],
              [46.015744, 35.606344],
              [46.015829, 35.606251],
              [46.01595, 35.606193],
              [46.015922, 35.606038],
              [46.015849, 35.605812],
              [46.015665, 35.605658],
              [46.015353, 35.605618],
              [46.015179, 35.605598],
              [46.015055, 35.605422],
              [46.014924, 35.605296],
              [46.014861, 35.60514],
              [46.014833, 35.604999],
              [46.014762, 35.604865],
              [46.014691, 35.604738],
              [46.014698, 35.604604],
              [46.014567, 35.604498],
              [46.014495, 35.604322],
              [46.014527, 35.604109],
              [46.014448, 35.603997],
              [46.014281, 35.603856],
              [46.014184, 35.603751],
              [46.014182, 35.603567],
              [46.014041, 35.603363],
              [46.013882, 35.603159],
              [46.013786, 35.603096],
              [46.013706, 35.602983],
              [46.013636, 35.602884],
              [46.013556, 35.602722],
              [46.013468, 35.602603],
              [46.013328, 35.602512],
              [46.013239, 35.602399],
              [46.013273, 35.602257],
              [46.013323, 35.602165],
              [46.013286, 35.601953],
              [46.013284, 35.601818],
              [46.013239, 35.601712],
              [46.013185, 35.60155],
              [46.013096, 35.60131],
              [46.013102, 35.601111],
              [46.013109, 35.60097],
              [46.013151, 35.600828],
              [46.013235, 35.6007],
              [46.013339, 35.600642],
              [46.013398, 35.6005],
              [46.013352, 35.600359],
              [46.013307, 35.600168],
              [46.013296, 35.600019],
              [46.013199, 35.599914],
              [46.01319, 35.599822],
              [46.01311, 35.599674],
              [46.0131828, 35.5995028],
              [46.0131369, 35.5990484],
              [46.013082, 35.598838],
              [46.013107, 35.598753],
              [46.013026, 35.598534],
              [46.0131357, 35.5983398],
              [46.0131388, 35.5981111],
              [46.013125, 35.597429],
              [46.013315, 35.597342],
              [46.013338, 35.597165],
              [46.013215, 35.597038],
              [46.013384, 35.596662],
              [46.013556, 35.596575],
              [46.013711, 35.596432],
              [46.013848, 35.596339],
              [46.01395, 35.596211],
              [46.013992, 35.596055],
              [46.013981, 35.595835],
              [46.013971, 35.59575],
              [46.014186, 35.595642],
              [46.014168, 35.595557],
              [46.014011, 35.595495],
              [46.014027, 35.595374],
              [46.014112, 35.595282],
              [46.014085, 35.595176],
              [46.014023, 35.595056],
              [46.013868, 35.594967],
              [46.014045, 35.594402],
              [46.014144, 35.594105],
              [46.014285, 35.593909],
              [46.014427, 35.59383],
              [46.014569, 35.593699],
              [46.014662, 35.593503],
              [46.01482, 35.593463],
              [46.014915, 35.593436],
              [46.014977, 35.593305],
              [46.015072, 35.593253],
              [46.015199, 35.593226],
              [46.015262, 35.593147],
              [46.01534, 35.593017],
              [46.015403, 35.592977],
              [46.015594, 35.592989],
              [46.015657, 35.592949],
              [46.01572, 35.592896],
              [46.015783, 35.592844],
              [46.015782, 35.592779],
              [46.015766, 35.592727],
              [46.015797, 35.592675],
              [46.015924, 35.592661],
              [46.016004, 35.592686],
              [46.016051, 35.592699],
              [46.016067, 35.592647],
              [46.016065, 35.592543],
              [46.016144, 35.592438],
              [46.016316, 35.592268],
              [46.016491, 35.59224],
              [46.01657, 35.592201],
              [46.016569, 35.592149],
              [46.016585, 35.592084],
              [46.01668, 35.59207],
              [46.016823, 35.59203],
              [46.017044, 35.591963],
              [46.017552, 35.591802],
              [46.018185, 35.591641],
              [46.018678, 35.591585],
              [46.019059, 35.59153],
              [46.01925, 35.591489],
              [46.019281, 35.591437],
              [46.019279, 35.591307],
              [46.019231, 35.591243],
              [46.019243, 35.590996],
              [46.019367, 35.590683],
              [46.019476, 35.590565],
              [46.019777, 35.590406],
              [46.020012, 35.59017],
              [46.020091, 35.590066],
              [46.020376, 35.589985],
              [46.020786, 35.589748],
              [46.021118, 35.589524],
              [46.021528, 35.589235],
              [46.021638, 35.58913],
              [46.02178, 35.589116],
              [46.021891, 35.589063],
              [46.022063, 35.588828],
              [46.022424, 35.588435],
              [46.022738, 35.58812],
              [46.022972, 35.587715],
              [46.023143, 35.587402],
              [46.023237, 35.587271],
              [46.023381, 35.586839],
              [46.023419, 35.586629],
              [46.023511, 35.586279],
              [46.023575, 35.586055],
              [46.023669, 35.585634],
              [46.023753, 35.58523],
              [46.0241278, 35.5848057],
              [46.0244065, 35.5844243],
              [46.0245862, 35.5838456],
              [46.0250923, 35.5831132],
              [46.0253556, 35.5825136],
              [46.0259815, 35.5818956],
              [46.0266305, 35.5818787],
              [46.0269002, 35.5818264],
              [46.027483, 35.581653],
              [46.0280171, 35.5809067],
              [46.0283111, 35.5803733],
              [46.028656, 35.580019],
              [46.028619, 35.57953],
              [46.028807, 35.579067],
              [46.029088, 35.578761],
              [46.029878, 35.578447],
              [46.030008, 35.578082],
              [46.0298983, 35.577581],
              [46.029883, 35.577008],
              [46.0297543, 35.5767227],
              [46.0294706, 35.576611],
              [46.0289427, 35.5763976],
              [46.028674, 35.5759635],
              [46.028437, 35.575339],
              [46.02784, 35.575024],
              [46.027397, 35.574875],
              [46.026846, 35.574464],
              [46.026294, 35.574404],
              [46.0257, 35.574322],
              [46.025136, 35.574263],
              [46.024725, 35.573962],
              [46.024205, 35.573798],
              [46.023565, 35.574036],
              [46.023044, 35.574134],
              [46.02254, 35.574025],
              [46.02206, 35.573961],
              [46.021447, 35.574475],
              [46.020272, 35.574668],
              [46.019354, 35.57456],
              [46.01886, 35.574401],
              [46.018284, 35.574519],
              [46.018014, 35.574862],
              [46.01751, 35.574976],
              [46.016954, 35.575033],
              [46.016063, 35.574405],
              [46.015174, 35.574359],
              [46.014395, 35.574487],
              [46.013572, 35.573797],
              [46.013178, 35.573648],
              [46.012662, 35.573717],
              [46.012366, 35.574055],
              [46.01174, 35.574212],
              [46.010686, 35.573877],
              [46.009983, 35.573935],
              [46.0094, 35.573974],
              [46.008537, 35.574179],
              [46.007952, 35.574473],
              [46.007193, 35.57444],
              [46.006671, 35.574613],
              [46.006044, 35.574795],
              [46.005432, 35.575607],
              [46.004951, 35.576002],
              [46.004292, 35.576474],
              [46.004035, 35.576969],
              [46.003757, 35.577435],
              [46.003242, 35.578011],
              [46.002315, 35.578565],
              [46.001735, 35.578302],
              [46.000965, 35.578064],
              [46.000733, 35.577562],
              [46.000427, 35.577073],
              [45.999622, 35.576754],
              [45.998996, 35.576881],
              [45.998451, 35.576863],
              [45.997919, 35.576733],
              [45.997096, 35.576395],
              [45.996258, 35.576519],
              [45.995022, 35.576999],
              [45.994541, 35.577547],
              [45.993978, 35.578088],
              [45.993492, 35.578669],
              [45.992771, 35.579785],
              [45.992181, 35.58032],
              [45.991122, 35.581139],
              [45.990057, 35.581828],
              [45.989605, 35.582076],
              [45.988368, 35.58187],
              [45.987453, 35.582105],
              [45.986649, 35.582364],
              [45.986119, 35.582615],
              [45.98547, 35.583282],
              [45.985009, 35.583596],
              [45.984518, 35.583895],
              [45.983736, 35.583823],
              [45.982826, 35.583501],
              [45.981615, 35.583661],
              [45.980101, 35.583823],
              [45.976859, 35.585386],
              [45.976057, 35.585655],
              [45.975513, 35.58532],
              [45.974894, 35.585163],
              [45.974292, 35.58497],
              [45.97386, 35.584821],
              [45.973302, 35.584696],
              [45.973268, 35.583982],
              [45.973186, 35.583605],
              [45.973209, 35.583273],
              [45.973285, 35.58279],
              [45.972907, 35.582228],
              [45.972584, 35.581623],
              [45.972104, 35.581178],
              [45.9719744, 35.5803201],
              [45.9714263, 35.5800596],
              [45.9718897, 35.578936],
              [45.9730136, 35.5782517],
              [45.9733035, 35.5773753],
              [45.9740791, 35.5772156],
              [45.9743554, 35.5769297],
              [45.9746985, 35.5766661],
              [45.9755826, 35.5763843],
              [45.976164, 35.576256],
              [45.976262, 35.575649],
              [45.9758939, 35.574734],
              [45.976798, 35.573793],
              [45.977089, 35.573324],
              [45.977631, 35.572809],
              [45.977946, 35.572281],
              [45.977987, 35.571707],
              [45.978575, 35.57127],
              [45.978824, 35.570896],
              [45.978974, 35.570181],
              [45.979251, 35.569552],
              [45.979598, 35.568887],
              [45.979971, 35.568382],
              [45.979966, 35.567728],
              [45.980258, 35.566899],
              [45.980378, 35.565907],
              [45.980508, 35.565108],
              [45.980843, 35.564609],
              [45.981184, 35.564023],
              [45.981508, 35.563428],
              [45.982094, 35.562719],
              [45.982553, 35.562393],
              [45.982689, 35.561888],
              [45.982785, 35.56127],
              [45.984273, 35.560535],
              [45.985392, 35.560218],
              [45.986115, 35.559844],
              [45.986659, 35.559546],
              [45.987919, 35.559006],
              [45.988612, 35.556936],
              [45.98937, 35.555442],
              [45.990001, 35.554387],
              [45.990998, 35.553165],
              [45.991513, 35.552382],
              [45.99283, 35.551646],
              [45.993488, 35.551328],
              [45.994404, 35.551419],
              [45.995066, 35.550617],
              [45.995697, 35.549644],
              [45.995809, 35.549371],
              [45.996298, 35.549231],
              [45.996729, 35.549045],
              [45.996865, 35.548949],
              [45.997014, 35.548724],
              [45.997429, 35.548219],
              [45.997658, 35.548087],
              [45.99879, 35.547889],
              [45.999073, 35.547829],
              [45.998929, 35.547664],
              [45.998717, 35.547028],
              [45.998439, 35.546654],
              [45.998182, 35.546364],
              [45.99787, 35.544699],
              [45.9976, 35.543778],
              [45.997581, 35.54375],
              [45.997557, 35.54371],
              [45.997384, 35.543328],
              [45.997193, 35.5431],
              [45.997163, 35.542931],
              [45.99718, 35.542793],
              [45.996999, 35.542634],
              [45.997028, 35.542402],
              [45.997063, 35.534222],
              [45.997344, 35.534256],
              [45.99799, 35.534435],
              [45.998574, 35.534218],
              [45.999243, 35.534082],
              [45.999994, 35.534202],
              [46.000665, 35.5339],
              [46.000925, 35.533433],
              [46.001175, 35.532881],
              [46.001577, 35.532397],
              [46.001855, 35.531994],
              [46.002374, 35.531449],
              [46.002567, 35.531267],
              [46.00276, 35.530687],
              [46.003135, 35.530325],
              [46.003668, 35.530272],
              [46.004166, 35.530227],
              [46.004463, 35.529889],
              [46.004975, 35.529763],
              [46.00544, 35.529549],
              [46.005751, 35.529354],
              [46.00628, 35.529244],
              [46.006797, 35.529088],
              [46.007662, 35.528915],
              [46.007987, 35.528815],
              [46.008447, 35.528718],
              [46.008896, 35.528449],
              [46.009541, 35.528142],
              [46.009862, 35.527673],
              [46.010154, 35.52754],
              [46.010476, 35.527033],
              [46.010458, 35.526482],
              [46.011255, 35.52606],
              [46.01182, 35.525593],
              [46.012709, 35.525377],
              [46.012991, 35.525032],
              [46.013611, 35.524721],
              [46.014026, 35.524419],
              [46.014141, 35.524038],
              [46.014548, 35.523708],
              [46.014885, 35.523295],
              [46.015204, 35.522952],
              [46.015923, 35.52269],
              [46.016245, 35.522183],
              [46.016565, 35.521665],
              [46.017423, 35.52129],
              [46.017979, 35.520747],
              [46.017991, 35.520698],
              [46.017739, 35.520616],
              [46.01741, 35.520549],
              [46.017141, 35.520493],
              [46.016924, 35.520454],
              [46.016585, 35.520407],
              [46.016362, 35.52038],
              [46.01613, 35.52032],
              [46.015623, 35.520172],
              [46.015329, 35.520075],
              [46.015045, 35.519999],
              [46.014691, 35.519961],
              [46.014403, 35.519967],
              [46.014171, 35.519978],
              [46.014028, 35.519884],
              [46.013941, 35.519777],
              [46.013782, 35.519589],
              [46.013624, 35.519433],
              [46.01344, 35.519307],
              [46.013115, 35.51914],
              [46.013161, 35.519152],
              [46.012897, 35.519039],
              [46.012856, 35.519002],
              [46.012638, 35.518921],
              [46.012496, 35.518889],
              [46.012322, 35.518717],
              [46.012159, 35.51862],
              [46.011988, 35.518646],
              [46.011524, 35.518724],
              [46.011257, 35.518755],
              [46.010874, 35.518804],
              [46.010617, 35.51886],
              [46.010465, 35.518857],
              [46.010409, 35.518837],
              [46.010324, 35.518829],
              [46.010152, 35.518859],
              [46.009879, 35.518829],
              [46.009706, 35.518719],
              [46.009609, 35.518612],
              [46.009492, 35.518555],
              [46.0094, 35.518453],
              [46.009263, 35.518359],
              [46.009146, 35.518315],
              [46.008994, 35.518279],
              [46.008827, 35.518243],
              [46.008715, 35.518153],
              [46.008563, 35.518121],
              [46.00837, 35.518086],
              [46.008264, 35.518058],
              [46.008077, 35.518084],
              [46.007916, 35.518098],
              [46.00777, 35.518103],
              [46.007633, 35.518092],
              [46.007558, 35.518134],
              [46.007502, 35.518134],
              [46.007341, 35.518177],
              [46.007257, 35.518269],
              [46.007111, 35.518315],
              [46.006949, 35.518317],
              [46.006817, 35.518214],
              [46.006694, 35.518067],
              [46.006571, 35.517952],
              [46.00647, 35.517932],
              [46.006358, 35.51788],
              [46.006277, 35.51786],
              [46.006236, 35.517802],
              [46.006138, 35.51765],
              [46.006071, 35.517552],
              [46.005994, 35.517491],
              [46.005983, 35.517459],
              [46.005974, 35.517433],
              [46.005892, 35.517368],
              [46.005784, 35.517224],
              [46.005687, 35.51715],
              [46.005561, 35.517106],
              [46.005348, 35.517095],
              [46.00509, 35.517065],
              [46.004908, 35.517029],
              [46.004811, 35.516943],
              [46.004659, 35.51687],
              [46.004597, 35.516771],
              [46.00449, 35.516723],
              [46.004349, 35.516703],
              [46.004252, 35.516626],
              [46.004201, 35.516618],
              [46.004121, 35.516635],
              [46.003954, 35.516649],
              [46.003828, 35.516654],
              [46.003692, 35.516639],
              [46.00353, 35.516628],
              [46.003338, 35.516666],
              [46.003147, 35.516734],
              [46.002905, 35.516761],
              [46.002658, 35.516804],
              [46.002427, 35.51688],
              [46.002175, 35.516895],
              [46.002009, 35.517004],
              [46.001824, 35.51715],
              [46.001694, 35.517221],
              [46.001472, 35.517272],
              [46.001206, 35.517402],
              [46.000935, 35.517462],
              [46.000788, 35.517497],
              [46.000673, 35.51751],
              [46.000497, 35.517582],
              [46.000265, 35.517608],
              [46.000103, 35.517593],
              [46.000022, 35.51761],
              [45.999906, 35.517615],
              [45.999736, 35.517708],
              [45.999609, 35.517713],
              [45.999494, 35.517772],
              [45.999374, 35.517864],
              [45.999248, 35.517865],
              [45.999168, 35.517939],
              [45.998996, 35.517941],
              [45.998932, 35.518053],
              [45.998806, 35.518071],
              [45.99872, 35.518009],
              [45.998635, 35.518105],
              [45.998586, 35.51825],
              [45.998563, 35.518452],
              [45.998656, 35.518588],
              [45.998591, 35.518638],
              [45.998465, 35.51866],
              [45.998373, 35.518582],
              [45.998261, 35.518508],
              [45.9981, 35.518535],
              [45.997832, 35.51852],
              [45.997867, 35.518541],
              [45.997761, 35.518533],
              [45.997707, 35.518608],
              [45.997641, 35.518625],
              [45.997489, 35.518589],
              [45.997412, 35.518458],
              [45.99734, 35.51833],
              [45.997213, 35.518269],
              [45.997097, 35.518262],
              [45.997021, 35.518312],
              [45.996846, 35.518446],
              [45.996701, 35.518542],
              [45.99653, 35.518597],
              [45.996348, 35.518549],
              [45.99607, 35.518551],
              [45.995878, 35.518528],
              [45.995675, 35.518489],
              [45.995513, 35.518403],
              [45.99535, 35.518351],
              [45.995163, 35.51829],
              [45.995086, 35.518233],
              [45.99492, 35.518234],
              [45.994797, 35.518283],
              [45.994677, 35.518324],
              [45.994476, 35.518354],
              [45.994274, 35.518406],
              [45.994133, 35.518493],
              [45.994034, 35.518545],
              [45.993819, 35.518566],
              [45.993779, 35.518611],
              [45.993711, 35.51871],
              [45.993599, 35.518804],
              [45.993503, 35.51893],
              [45.993397, 35.519067],
              [45.993278, 35.519226],
              [45.993092, 35.519391],
              [45.992937, 35.519453],
              [45.992784, 35.519464],
              [45.992783, 35.519462],
              [45.985425, 35.496023],
              [45.986117, 35.495283],
              [45.986481, 35.49517],
              [45.986987, 35.495087],
              [45.987627, 35.494552],
              [45.987781, 35.493955],
              [45.987959, 35.492729],
              [45.988027, 35.491721],
              [45.988126, 35.490784],
              [45.988496, 35.489796],
              [45.988629, 35.489224],
              [45.988892, 35.488804],
              [45.989618, 35.488285],
              [45.990105, 35.48779],
              [45.990455, 35.487506],
              [45.990695, 35.486816],
              [45.990563, 35.486381],
              [45.990602, 35.48598],
              [45.990884, 35.485523],
              [45.991039, 35.485045],
              [45.991331, 35.484575],
              [45.991781, 35.484032],
              [45.992226, 35.483807],
              [45.992351, 35.483149],
              [45.992587, 35.482613],
              [45.99301, 35.48213],
              [45.993257, 35.48181],
              [45.994297, 35.481255],
              [45.994441, 35.4809],
              [45.994669, 35.480333],
              [45.994636, 35.479858],
              [45.994546, 35.479087],
              [45.99474, 35.478548],
              [45.995132, 35.477764],
              [45.995275, 35.477234],
              [45.995312, 35.476713],
              [45.995654, 35.475719],
              [45.995925, 35.47533],
              [45.99624, 35.475184],
              [45.996685, 35.474904],
              [45.996935, 35.474595],
              [45.997384, 35.474445],
              [45.998075, 35.474065],
              [45.998202, 35.473691],
              [45.998412, 35.473105],
              [45.998639, 35.472254],
              [45.998604, 35.471658],
              [45.999059, 35.471136],
              [45.99944, 35.470365],
              [45.999507, 35.470134],
              [46.000013, 35.469547],
              [46.000319, 35.46925],
              [46.000709, 35.468849],
              [46.001041, 35.468492],
              [46.00184, 35.468113],
              [46.002453, 35.467463],
              [46.002591, 35.466409],
              [46.002881, 35.465874],
              [46.00318, 35.465041],
              [46.003488, 35.46447],
              [46.003729, 35.464009],
              [46.003665, 35.463573],
              [46.003973, 35.462892],
              [46.003941, 35.461506],
              [46.004167, 35.460329],
              [46.004566, 35.458782],
              [46.00563, 35.457467],
              [46.006831, 35.456107],
              [46.008183, 35.454837],
              [46.009469, 35.452784],
              [46.009634, 35.452337],
              [46.009784, 35.451929],
              [46.010691, 35.450862],
              [46.011251, 35.45008],
              [46.011684, 35.448566],
              [46.012126, 35.446991],
              [46.013144, 35.445963],
              [46.013313, 35.445036],
              [46.01371, 35.444026],
              [46.015944, 35.442411],
              [46.016685, 35.441197],
              [46.017814, 35.440207],
              [46.019453, 35.439977],
              [46.020224, 35.439593],
              [46.021503, 35.438694],
              [46.02182, 35.437938],
              [46.023084, 35.436804],
              [46.024352, 35.436227],
              [46.025003, 35.435228],
              [46.026104, 35.434046],
              [46.02613, 35.433325],
              [46.026905, 35.431508],
              [46.027988, 35.429354],
              [46.028011, 35.428534],
              [46.028772, 35.426938],
              [46.029261, 35.425354],
              [46.029687, 35.423543],
              [46.029443, 35.422269],
              [46.029552, 35.421421],
              [46.030701, 35.42005],
              [46.031524, 35.41886],
              [46.032267, 35.417924],
              [46.032944, 35.417021],
              [46.033593, 35.41656],
              [46.034367, 35.415558],
              [46.034718, 35.414378],
              [46.035166, 35.4131],
              [46.03633, 35.411965],
              [46.037266, 35.410913],
              [46.0378, 35.410037],
              [46.038265, 35.408636],
              [46.038492, 35.407738],
              [46.03867, 35.40675],
              [46.038331, 35.405342],
              [46.039772, 35.404393],
              [46.040354, 35.404144],
              [46.041232, 35.403879],
              [46.042307, 35.403238],
              [46.043641, 35.401812],
              [46.044224, 35.400747],
              [46.044906, 35.399684],
              [46.04575, 35.398569],
              [46.04646, 35.398236],
              [46.04761, 35.397323],
              [46.048275, 35.395924],
              [46.048587, 35.395149],
              [46.049192, 35.394259],
              [46.049243, 35.393175],
              [46.05037, 35.392087],
              [46.050893, 35.390716],
              [46.050945, 35.389274],
              [46.050838, 35.387981],
              [46.051615, 35.387258],
              [46.052517, 35.386172],
              [46.054737, 35.385414],
              [46.056513, 35.384681],
              [46.058501, 35.383629],
              [46.05927, 35.382787],
              [46.060189, 35.3814],
              [46.061303, 35.380812],
              [46.062742, 35.379943],
              [46.06355, 35.379154],
              [46.064449, 35.378328],
              [46.064217, 35.377397],
              [46.063997, 35.376603],
              [46.064474, 35.373888],
              [46.065856, 35.373089],
              [46.066337, 35.372382],
              [46.066836, 35.37183],
              [46.0674, 35.371246],
              [46.067937, 35.371105],
              [46.06857, 35.370587],
              [46.068312, 35.369741],
              [46.067782, 35.369185],
              [46.067567, 35.368768],
              [46.068605, 35.368174],
              [46.069577, 35.367613],
              [46.070533, 35.366994],
              [46.071579, 35.366339],
              [46.072401, 35.365507],
              [46.073313, 35.364639],
              [46.0736106, 35.3644429],
              [46.074075, 35.364137],
              [46.07543, 35.363781],
              [46.076513, 35.363715],
              [46.077611, 35.363607],
              [46.078716, 35.363438],
              [46.080276, 35.362288],
              [46.080671, 35.362111],
              [46.081569, 35.361429],
              [46.083249, 35.361083],
              [46.083507, 35.361201],
              [46.084675, 35.360951],
              [46.08563, 35.361076],
              [46.086178, 35.360997],
              [46.086912, 35.361111],
              [46.087913, 35.360501],
              [46.089023, 35.36007],
              [46.090452, 35.359695],
              [46.091371, 35.359655],
              [46.092125, 35.359532],
              [46.092388, 35.359322],
              [46.092718, 35.359279],
              [46.093164, 35.358822],
              [46.093221, 35.358681],
              [46.093495, 35.358452],
              [46.093689, 35.358289],
              [46.093504, 35.358272],
              [46.092182, 35.357783],
              [46.092199, 35.357292],
              [46.092491, 35.355824],
              [46.092897, 35.354356],
              [46.092936, 35.352967],
              [46.093246, 35.35286],
              [46.09349, 35.352013],
              [46.093287, 35.351186],
              [46.093211, 35.350097],
              [46.09498, 35.349474],
              [46.09589, 35.349282],
              [46.096375, 35.349041],
              [46.096822, 35.348529],
              [46.09759, 35.348046],
              [46.0979, 35.347719],
              [46.098341, 35.347228],
              [46.099167, 35.346684],
              [46.099291, 35.346183],
              [46.100353, 35.346171],
              [46.101329, 35.345987],
              [46.102122, 35.345777],
              [46.102701, 35.345608],
              [46.103377, 35.34538],
              [46.104507, 35.344709],
              [46.105157, 35.344298],
              [46.105938, 35.343772],
              [46.106555, 35.343288],
              [46.107397, 35.342661],
              [46.107805, 35.342326],
              [46.108163, 35.341989],
              [46.108983, 35.341467],
              [46.109582, 35.341055],
              [46.110075, 35.340753],
              [46.110522, 35.340151],
              [46.110934, 35.339785],
              [46.111539, 35.339482],
              [46.113467, 35.338501],
              [46.114849, 35.338015],
              [46.115674, 35.337637],
              [46.116496, 35.337349],
              [46.117072, 35.33745],
              [46.117457, 35.337557],
              [46.118331, 35.337551],
              [46.119365, 35.337333],
              [46.120484, 35.337079],
              [46.121349, 35.337335],
              [46.122373, 35.33718],
              [46.123303, 35.336641],
              [46.124158, 35.336226],
              [46.125814, 35.335448],
              [46.127443, 35.334474],
              [46.127784, 35.333836],
              [46.127174, 35.332637],
              [46.126653, 35.331171],
              [46.126413, 35.32973],
              [46.126332, 35.329053],
              [46.126274, 35.328652],
              [46.126335, 35.328038],
              [46.126587, 35.327619],
              [46.126968, 35.327465],
              [46.128704, 35.326682],
              [46.12918, 35.32633],
              [46.129668, 35.325875],
              [46.130073, 35.325416],
              [46.130471, 35.325029],
              [46.130566, 35.324539],
              [46.130849, 35.324083],
              [46.131336, 35.323578],
              [46.131679, 35.323141],
              [46.132044, 35.322881],
              [46.132606, 35.322472],
              [46.133099, 35.322132],
              [46.133383, 35.321972],
              [46.133616, 35.321656],
              [46.134601, 35.320864],
              [46.135618, 35.320439],
              [46.136845, 35.319683],
              [46.137694, 35.318792],
              [46.138919, 35.318129],
              [46.139853, 35.317648],
              [46.14089, 35.316897],
              [46.14179, 35.315892],
              [46.142767, 35.31507],
              [46.14375, 35.314319],
              [46.144336, 35.313718],
              [46.144975, 35.31321],
              [46.145457, 35.312972],
              [46.145984, 35.311706],
              [46.146043, 35.311175],
              [46.146417, 35.310593],
              [46.147046, 35.309349],
              [46.147487, 35.307466],
              [46.14763, 35.306742],
              [46.147877, 35.305498],
              [46.148885, 35.304691],
              [46.149343, 35.303719],
              [46.149848, 35.302769],
              [46.149783, 35.302283],
              [46.149916, 35.30182],
              [46.15006, 35.301398],
              [46.150805, 35.300828],
              [46.151344, 35.299903],
              [46.151443, 35.299468],
              [46.151511, 35.298665],
              [46.151692, 35.297632],
              [46.151194, 35.29701],
              [46.150946, 35.296403],
              [46.150854, 35.295318],
              [46.150956, 35.294394],
              [46.150651, 35.29358],
              [46.15134, 35.292605],
              [46.151604, 35.291972],
              [46.152228, 35.291457],
              [46.153198, 35.290511],
              [46.153502, 35.289725],
              [46.154677, 35.288875],
              [46.155263, 35.288024],
              [46.156568, 35.286805],
              [46.157333, 35.285806],
              [46.158107, 35.285043],
              [46.158684, 35.284506],
              [46.1614576, 35.2842472],
              [46.1641871, 35.282881],
              [46.164805, 35.2815568],
              [46.1666075, 35.2806319],
              [46.1695171, 35.2792866],
              [46.1711651, 35.2783827],
              [46.1731993, 35.2775209],
              [46.1741262, 35.2772686],
              [46.1764952, 35.2754608],
              [46.1793791, 35.2740734],
              [46.1837604, 35.2707791],
              [46.1904847, 35.2624003],
              [46.1935746, 35.2584686],
              [46.1961496, 35.2560926],
              [46.1997287, 35.2549152],
              [46.2024839, 35.2505625],
              [46.2029473, 35.2482494],
              [46.2038486, 35.2462938],
              [46.2049077, 35.2448438],
              [46.2106755, 35.2440867],
              [46.2138942, 35.2422361],
              [46.2182973, 35.239397],
              [46.219971, 35.2372729],
              [46.2230094, 35.2335713],
              [46.2258161, 35.230732],
              [46.2295754, 35.2282921],
              [46.2334636, 35.2256839],
              [46.2376058, 35.223895],
              [46.2368882, 35.2209931],
              [46.2379182, 35.2187003],
              [46.2401584, 35.2175222],
              [46.2484872, 35.2153506],
              [46.2502124, 35.2146563],
              [46.2537658, 35.2111852],
              [46.255697, 35.2094811],
              [46.2608726, 35.2082188],
              [46.2648637, 35.2071037],
              [46.2673356, 35.206178],
              [46.2719705, 35.2026854],
              [46.2737818, 35.2014143],
              [46.2765281, 35.1994872],
              [46.2817037, 35.1974673],
              [46.2839181, 35.1956787],
              [46.287935, 35.1935955],
              [46.2924153, 35.1916386],
              [46.29584, 35.1893028],
              [46.301891, 35.1861041],
              [46.3069894, 35.1849677],
              [46.3093068, 35.184189],
              [46.3143536, 35.1811374],
              [46.3168513, 35.1801483],
              [46.3224389, 35.1785488],
              [46.3264558, 35.1774543],
              [46.3297774, 35.17596],
              [46.3358285, 35.1737921],
              [46.3394591, 35.1725293],
              [46.3412873, 35.1723819],
              [46.3437277, 35.1708058],
              [46.3451954, 35.1703006],
              [46.3471781, 35.1697954],
              [46.3495735, 35.168391],
              [46.3498145, 35.1686178],
              [46.3505506, 35.1690125],
              [46.3538056, 35.1707577],
              [46.3630324, 35.1666181],
              [46.3653927, 35.166583],
              [46.3670235, 35.164864],
              [46.3736754, 35.1610047],
              [46.3734955, 35.1593802],
              [46.3732123, 35.1569172],
              [46.3740105, 35.1553593],
              [46.3756842, 35.1538646],
              [46.3788513, 35.152054],
              [46.3835892, 35.1499276],
              [46.3863959, 35.1483065],
              [46.3883528, 35.1460957],
              [46.3898463, 35.1436533],
              [46.3956141, 35.140495],
              [46.3988585, 35.139779],
              [46.4025406, 35.1383472],
              [46.4057078, 35.1364942],
              [46.4077227, 35.1340285],
              [46.4105036, 35.1303012],
              [46.4116881, 35.1277951],
              [46.412615, 35.1264262],
              [46.4150355, 35.1244045],
              [46.4216015, 35.1233093],
              [46.4271118, 35.1222352],
              [46.429764, 35.1207399],
              [46.4325192, 35.1178965],
              [46.4340126, 35.1137472],
              [46.4368193, 35.1112617],
              [46.4419176, 35.1075544],
              [46.4442865, 35.1058903],
              [46.447222, 35.1044368],
              [46.4483601, 35.1015193],
              [46.4486155, 35.0972758],
              [46.4496197, 35.0935889],
              [46.450315, 35.0910396],
              [46.4498321, 35.087708],
              [46.4503471, 35.0857274],
              [46.4507076, 35.0845896],
              [46.4501154, 35.0808389],
              [46.4487764, 35.0788582],
              [46.4479267, 35.0771724],
              [46.4485962, 35.07104],
              [46.4480554, 35.0695016],
              [46.4496776, 35.06849],
              [46.4535915, 35.0677102],
              [46.4567072, 35.0671623],
              [46.460621, 35.0658135],
              [46.463299, 35.0657081],
              [46.4691955, 35.0629682],
              [46.4723884, 35.0627364],
              [46.4757101, 35.0615139],
              [46.4788515, 35.0602282],
              [46.4828169, 35.057973],
              [46.4869137, 35.0557191],
              [46.4889117, 35.0539041],
              [46.4914093, 35.0524285],
              [46.493804, 35.0510584],
              [46.5000611, 35.0473273],
              [46.5040522, 35.0462522],
              [46.5073996, 35.0448608],
              [46.5112877, 35.0444814],
              [46.5197077, 35.0415721],
              [46.5253468, 35.0411294],
              [46.524016, 35.0350051],
              [46.5264879, 35.0295864],
              [46.529655, 35.0264237],
              [46.5320755, 35.0203718],
              [46.5326162, 35.0081192],
              [46.5315347, 34.9994295],
              [46.5305563, 34.992321],
              [46.53128, 34.9872983],
              [46.5348445, 34.9836719],
              [46.5416391, 34.9752628],
              [46.548171, 34.9673858],
              [46.5551662, 34.9620752],
              [46.5544366, 34.9575029],
              [46.5524196, 34.9546539],
              [46.5495014, 34.9518048],
              [46.5468255, 34.9508431],
              [46.5427247, 34.9519705],
              [46.5396085, 34.9469968],
              [46.5391555, 34.9449356],
              [46.5367324, 34.9432113],
              [46.5321421, 34.9405481],
              [46.5286315, 34.9345182],
              [46.5290598, 34.9328682],
              [46.5292195, 34.9317859],
              [46.531906, 34.9299231],
              [46.5347904, 34.9287532],
              [46.5374395, 34.9285728],
              [46.5415461, 34.9264755],
              [46.5452956, 34.9220415],
              [46.5477599, 34.9199799],
              [46.5468406, 34.9181707],
              [46.5440346, 34.9146662],
              [46.5431499, 34.9122587],
              [46.5431499, 34.9101472],
              [46.5448665, 34.9074725],
              [46.5462398, 34.9060647],
              [46.5495013, 34.9015949],
              [46.5506387, 34.8999758],
              [46.5529775, 34.897864],
              [46.5561103, 34.8956465],
              [46.5611958, 34.8937985],
              [46.5623545, 34.8928657],
              [46.563878, 34.8921617],
              [46.5664744, 34.8919681],
              [46.5679121, 34.8920737],
              [46.5691781, 34.8914577],
              [46.5701651, 34.890824],
              [46.5708518, 34.8898736],
              [46.5731263, 34.88968],
              [46.5802502, 34.8888352],
              [46.5842199, 34.8881839],
              [46.5865389, 34.8873241],
              [46.5891981, 34.8878671],
              [46.5915155, 34.8877615],
              [46.5950775, 34.8853325],
              [46.5978241, 34.88403],
              [46.601901, 34.8804391],
              [46.6088104, 34.8756862],
              [46.611307, 34.8745316],
              [46.6133021, 34.8725809],
              [46.6170798, 34.870475],
              [46.6227475, 34.8668511],
              [46.6286674, 34.8615275],
              [46.6324938, 34.8611519],
              [46.6347312, 34.8634331],
              [46.6369199, 34.864419],
              [46.6394519, 34.8659684],
              [46.6427993, 34.8693838],
              [46.6446018, 34.8693838],
              [46.6516828, 34.8660388],
              [46.6583347, 34.8635387],
              [46.6598367, 34.8624471],
              [46.6626691, 34.8612499],
              [46.666789, 34.8588201],
              [46.6694068, 34.8587497],
              [46.6715526, 34.8597709],
              [46.6758871, 34.8585032],
              [46.6815948, 34.8580806],
              [46.6935682, 34.8502273],
              [46.7037204, 34.8430064],
              [46.7136526, 34.8365614],
              [46.7179685, 34.8329954],
              [46.7186972, 34.8282178],
              [46.7232755, 34.8230268],
              [46.7244939, 34.8207874],
              [46.7294164, 34.8119864],
              [46.7250318, 34.8075361],
              [46.729243, 34.8002393],
              [46.7325782, 34.7922374],
              [46.7384147, 34.7821572],
              [46.7440795, 34.7687268],
              [46.7467832, 34.7630156],
              [46.7545938, 34.7567046],
              [46.7601728, 34.7532139],
              [46.7627477, 34.7530376],
              [46.7592113, 34.7497603],
              [46.7718337, 34.7442334],
              [46.7872969, 34.7369983],
              [46.7879819, 34.7365695],
              [46.8134737, 34.7427057],
              [46.8240737, 34.7457737],
              [46.8350263, 34.7497122],
              [46.846242, 34.7508053],
              [46.8545436, 34.7535665],
              [46.8593869, 34.7555045],
              [46.8695424, 34.7595406],
              [46.8760409, 34.7609395],
              [46.8807989, 34.7613978],
              [46.8825377, 34.7628057],
              [46.8920458, 34.7657144],
              [46.9006733, 34.7647073],
              [46.9036182, 34.7636315],
              [46.9096899, 34.7614819],
              [46.9153496, 34.7592081],
              [46.9215258, 34.7566486],
              [46.9268807, 34.7545217],
              [46.9333015, 34.7546801],
              [46.9420588, 34.757378],
              [46.9436283, 34.7598415],
              [46.9440381, 34.7640098],
              [46.9439765, 34.7661362],
              [46.948591, 34.7694309],
              [46.9613492, 34.766137],
              [46.9699352, 34.7644071],
              [46.9775399, 34.7645426],
              [46.991447, 34.7656532],
              [46.9998194, 34.7627932],
              [47.0035211, 34.7606258],
              [47.0071727, 34.7575501],
              [47.0111285, 34.7557118],
              [47.0144676, 34.7550511],
              [47.0164697, 34.7540265],
              [47.0200124, 34.7533135],
              [47.0262448, 34.7537631],
              [47.0296746, 34.752086],
              [47.0363545, 34.7500933],
              [47.0371055, 34.7495996],
              [47.042986, 34.7476042],
              [47.0504093, 34.7500051],
              [47.0515251, 34.7507809],
              [47.0541644, 34.7539896],
              [47.0548939, 34.755065],
              [47.0549369, 34.7560522],
              [47.05307, 34.7583264],
              [47.0502591, 34.7594722],
              [47.0480275, 34.7601069],
              [47.0448518, 34.7610412],
              [47.0431566, 34.7618168],
              [47.0431995, 34.7626629],
              [47.0446372, 34.7641084],
              [47.045648, 34.7658906],
              [47.0451307, 34.7679512],
              [47.0456944, 34.769548],
              [47.046682, 34.7710163],
              [47.0489747, 34.774962],
              [47.0524263, 34.7769403],
              [47.0559006, 34.7780289],
              [47.0598805, 34.7790464],
              [47.0623797, 34.7804562],
              [47.0633268, 34.7817165],
              [47.0635628, 34.7828445],
              [47.0627208, 34.7841688],
              [47.0604647, 34.7866327],
              [47.059483, 34.789542],
              [47.0581939, 34.7913042],
              [47.0636734, 34.7935037],
              [47.0660778, 34.7944048],
              [47.0688021, 34.7950582],
              [47.0709073, 34.7954652],
              [47.0750212, 34.7957707],
              [47.0794351, 34.795971],
              [47.0847201, 34.7965897],
              [47.0878598, 34.7969269],
              [47.0911502, 34.7972975],
              [47.0942154, 34.7981785],
              [47.0976922, 34.7990573],
              [47.1004057, 34.8010829],
              [47.1053706, 34.7990287],
              [47.110435, 34.7989284],
              [47.1126957, 34.7979418],
              [47.1140243, 34.7966004],
              [47.1169516, 34.7950976],
              [47.119521, 34.7946258],
              [47.1215272, 34.7952005],
              [47.1236596, 34.7959226],
              [47.1259326, 34.7966248],
              [47.1288631, 34.7968412],
              [47.1318948, 34.7979817],
              [47.1324874, 34.7982923],
              [47.1336222, 34.7988628],
              [47.1366906, 34.7987923],
              [47.1395311, 34.7994244],
              [47.1405759, 34.7998757],
              [47.1404028, 34.8012238],
              [47.139008, 34.8033734],
              [47.13727, 34.8045891],
              [47.1361542, 34.8059282],
              [47.134459, 34.8056815],
              [47.1319914, 34.8061748],
              [47.1299958, 34.8068972],
              [47.128365, 34.8088704],
              [47.1280432, 34.8108965],
              [47.1272063, 34.8115307],
              [47.1245241, 34.8140852],
              [47.1236872, 34.8160759],
              [47.1241593, 34.818137],
              [47.1237945, 34.8198457],
              [47.1212625, 34.821026],
              [47.1189022, 34.8226114],
              [47.1166277, 34.8237035],
              [47.1161341, 34.8236859],
              [47.1115422, 34.8207794],
              [47.1092891, 34.820709],
              [47.1018218, 34.8226114],
              [47.0991611, 34.8228933],
              [47.0945262, 34.8293754],
              [47.0885181, 34.8411404],
              [47.0835828, 34.8514599],
              [47.0800209, 34.8605104],
              [47.0758151, 34.8677641],
              [47.0720815, 34.8766368],
              [47.0710676, 34.8834557],
              [47.072095, 34.883975],
              [47.0719635, 34.8847252],
              [47.0701932, 34.8872863],
              [47.068895, 34.889328],
              [47.0690668, 34.8902696],
              [47.0697962, 34.8910793],
              [47.0702898, 34.8917041],
              [47.0710408, 34.8921881],
              [47.07574, 34.8937193],
              [47.0766734, 34.8933937],
              [47.0790874, 34.8933057],
              [47.0799887, 34.8933057],
              [47.0807933, 34.8934641],
              [47.0841407, 34.8943793],
              [47.0907497, 34.8919857],
              [47.0969295, 34.8919857],
              [47.0988177, 34.8927601],
              [47.1009635, 34.8951537],
              [47.1029376, 34.8963505],
              [47.1060815, 34.898268],
              [47.1078132, 34.8991303],
              [47.1088638, 34.9006595],
              [47.1097571, 34.9025513],
              [47.1105148, 34.9041772],
              [47.1112842, 34.9047755],
              [47.1150491, 34.9036335],
              [47.1227675, 34.9000084],
              [47.127144, 34.8984968],
              [47.1311042, 34.8972297],
              [47.1392755, 34.8978152],
              [47.1410635, 34.8983783],
              [47.1420259, 34.8992916],
              [47.1457141, 34.9017202],
              [47.1479607, 34.9024888],
              [47.1502232, 34.9030168],
              [47.157242, 34.9028455],
              [47.1592493, 34.9024536],
              [47.1613449, 34.9019823],
              [47.1632109, 34.9016322],
              [47.1647866, 34.9014406],
              [47.1670292, 34.9012274],
              [47.170483, 34.8999761],
              [47.1718308, 34.9002753],
              [47.1719334, 34.9015581],
              [47.1728099, 34.9033707],
              [47.1737831, 34.9044802],
              [47.1739626, 34.9060471],
              [47.1739626, 34.90793],
              [47.1744776, 34.908757],
              [47.1746063, 34.9102175],
              [47.1760654, 34.912857],
              [47.1743917, 34.9173262],
              [47.17422, 34.9186634],
              [47.1750354, 34.9193671],
              [47.1762371, 34.9205284],
              [47.17662, 34.9221744],
              [47.1762468, 34.9236923],
              [47.1769573, 34.9249905],
              [47.1775334, 34.9263302],
              [47.1772352, 34.9279093],
              [47.1771694, 34.9313601],
              [47.1782814, 34.9320283],
              [47.1801563, 34.9328334],
              [47.1804131, 34.9339783],
              [47.1799563, 34.9348205],
              [47.1775532, 34.9363354],
              [47.1745039, 34.9383935],
              [47.174124, 34.9431625],
              [47.1734611, 34.947055],
              [47.1718882, 34.9520607],
              [47.171291, 34.9531052],
              [47.1706863, 34.9573719],
              [47.1688987, 34.9612057],
              [47.1738871, 34.9633172],
              [47.1817954, 34.9642208],
              [47.1858856, 34.9628334],
              [47.1859477, 34.9583262],
              [47.1858411, 34.9528746],
              [47.1865368, 34.9434503],
              [47.1869052, 34.9379677],
              [47.1900036, 34.9325922],
              [47.1955571, 34.9309896],
              [47.2014989, 34.9344199],
              [47.2052246, 34.9361773],
              [47.2080775, 34.9378149],
              [47.2115023, 34.9396456],
              [47.2137988, 34.9407365],
              [47.2172892, 34.9426187],
              [47.2209647, 34.9448121],
              [47.2221486, 34.9480131],
              [47.2269803, 34.9498311],
              [47.228673, 34.9501459],
              [47.2344138, 34.9524019],
              [47.2363632, 34.9529384],
              [47.2386599, 34.9534994],
              [47.2409749, 34.9544428],
              [47.2425579, 34.9544228],
              [47.2421827, 34.9518832],
              [47.2426739, 34.9480859],
              [47.2437185, 34.9408529],
              [47.2458457, 34.9299935],
              [47.2515534, 34.9284806],
              [47.2606086, 34.9244342],
              [47.2742557, 34.9241527],
              [47.2924518, 34.9296417],
              [47.2954988, 34.9308379],
              [47.2987174, 34.9335822],
              [47.3041247, 34.9344266],
              [47.312622, 34.937804],
              [47.3177718, 34.938578],
              [47.3206042, 34.9402667],
              [47.3235225, 34.9456842],
              [47.3299117, 34.955792],
              [47.3293931, 34.9573188],
              [47.3276565, 34.957723],
              [47.3251874, 34.9580443],
              [47.3209626, 34.9578281],
              [47.3199087, 34.9592558],
              [47.3208743, 34.9615451],
              [47.3224925, 34.9627787],
              [47.310525, 34.9662384],
              [47.3090172, 34.9692497],
              [47.304292, 34.9763921],
              [47.2944478, 34.9798005],
              [47.2903295, 34.9871304],
              [47.2951591, 34.9920756],
              [47.2981632, 34.9989149],
              [47.3023276, 35.0016452],
              [47.3080982, 35.0032391],
              [47.3080798, 35.003873],
              [47.3081532, 35.0047052],
              [47.3082916, 35.0062991],
              [47.3119306, 35.0105577],
              [47.3159031, 35.015225],
              [47.3172841, 35.0160468],
              [47.3204654, 35.016869],
              [47.3207706, 35.0171825],
              [47.3217618, 35.0172279],
              [47.3232846, 35.017171],
              [47.3235745, 35.0168807],
              [47.3291268, 35.0169121],
              [47.3293807, 35.0171679],
              [47.3310545, 35.0171456],
              [47.3313443, 35.0174831],
              [47.3333229, 35.0174616],
              [47.3376751, 35.018235],
              [47.3451204, 35.0182721],
              [47.3469148, 35.0182483],
              [47.3491724, 35.018192],
              [47.3494766, 35.0179218],
              [47.3550574, 35.0180366],
              [47.3600191, 35.0224775],
              [47.3616803, 35.0286096],
              [47.3613554, 35.0288884],
              [47.3611225, 35.0298943],
              [47.3599822, 35.032876],
              [47.3585111, 35.0367294],
              [47.356081, 35.0427322],
              [47.356102, 35.045794],
              [47.35722, 35.0474502],
              [47.3608429, 35.0527717],
              [47.3632763, 35.0535498],
              [47.3652929, 35.0535888],
              [47.3657125, 35.0538538],
              [47.371857, 35.0538958],
              [47.3763143, 35.0546714],
              [47.3763468, 35.0549607],
              [47.3846981, 35.0574139],
              [47.3855304, 35.0574358],
              [47.3872245, 35.0583513],
              [47.3901409, 35.0590346],
              [47.392917, 35.0597163],
              [47.396038, 35.0604986],
              [47.399424, 35.0612889],
              [47.3997634, 35.061691],
              [47.4029975, 35.0616365],
              [47.4046504, 35.0616286],
              [47.4089891, 35.0610662],
              [47.4091763, 35.06082],
              [47.4097927, 35.0607578],
              [47.4100044, 35.0605119],
              [47.4108638, 35.0605213],
              [47.4202721, 35.0561035],
              [47.420581, 35.056306],
              [47.4246721, 35.0530799],
              [47.4252047, 35.052776],
              [47.4257373, 35.0525998],
              [47.426991, 35.052207],
              [47.4292075, 35.0521714],
              [47.4296625, 35.0518523],
              [47.434173, 35.0518713],
              [47.4345097, 35.0516291],
              [47.4416925, 35.0515702],
              [47.4491238, 35.0507775],
              [47.4495099, 35.0504902],
              [47.451384, 35.0504702],
              [47.4517373, 35.0502176],
              [47.457162, 35.0501318],
              [47.4667776, 35.0505234],
              [47.4672476, 35.0508007],
              [47.4693599, 35.050844],
              [47.4708396, 35.0511043],
              [47.4728566, 35.0525827],
              [47.4753793, 35.0544726],
              [47.4847791, 35.0613824],
              [47.4872276, 35.0632418],
              [47.4978056, 35.0661775],
              [47.5051247, 35.0682052],
              [47.5236793, 35.0637669],
              [47.5373016, 35.0639228],
              [47.5432825, 35.0673527],
              [47.5485236, 35.069453],
              [47.5598124, 35.0710519],
              [47.5658435, 35.0708654],
              [47.5685706, 35.0715242],
              [47.5758299, 35.0714453],
              [47.5805981, 35.0717827],
              [47.5835656, 35.0720255],
              [47.5868096, 35.0724283],
              [47.5927645, 35.0728805],
              [47.6012522, 35.0724866],
              [47.6068405, 35.0717782],
              [47.6099675, 35.0716298],
              [47.6120635, 35.0716071],
              [47.6148154, 35.071688],
              [47.6187599, 35.0714568],
              [47.6204343, 35.0711604],
              [47.624536, 35.0706644],
              [47.631536, 35.0702348],
              [47.6382091, 35.0703052],
              [47.6471333, 35.0668953],
              [47.6545634, 35.065645],
              [47.6629571, 35.0649778],
              [47.6657855, 35.0647184],
              [47.6666248, 35.0645663],
              [47.6745879, 35.0632576],
              [47.6827871, 35.0605787],
              [47.6909124, 35.0579526],
              [47.6914726, 35.0577012],
              [47.7014774, 35.057709],
              [47.7023027, 35.0580228],
              [47.7044974, 35.0580174],
              [47.707848, 35.0585577],
              [47.7087165, 35.0588855],
              [47.7097548, 35.0588353],
              [47.7114923, 35.0594205],
              [47.7209811, 35.0624692],
              [47.7227645, 35.06246],
              [47.7236017, 35.0627673],
              [47.725582, 35.0627369],
              [47.7261522, 35.0624638],
              [47.7272307, 35.0624615],
              [47.7275647, 35.0621909],
              [47.7286935, 35.062194],
              [47.7301146, 35.061439],
              [47.7311069, 35.0605149],
              [47.7331741, 35.0562333],
              [47.736844, 35.0518469],
              [47.7457091, 35.0473936],
              [47.7537781, 35.0460016],
              [47.7541762, 35.0459434],
              [47.7624092, 35.0447168],
              [47.7657599, 35.0436287],
              [47.7683729, 35.0414994],
              [47.7717957, 35.0386575],
              [47.7769607, 35.0343965],
              [47.7777883, 35.0329462],
              [47.7899933, 35.0222065],
              [47.7901863, 35.0218899],
              [47.7910904, 35.0219162],
              [47.8030414, 35.0149562],
              [47.8038746, 35.0138376],
              [47.8041512, 35.0130078],
              [47.8055414, 35.0116186],
              [47.8105412, 35.0021739],
              [47.8108212, 35.001344],
              [47.8110978, 35.0003247],
              [47.8113745, 34.9993955],
              [47.8113744, 34.9988453],
              [47.8094314, 34.9977267],
              [47.8060982, 34.9888412],
              [47.8052645, 34.9849533],
              [47.8052646, 34.980515],
              [47.813598, 34.9696809],
              [47.8144312, 34.968012],
              [47.8322113, 34.945225],
              [47.8399878, 34.938838],
              [47.858601, 34.9332901],
              [47.8599874, 34.9327307],
              [47.8605444, 34.9327308],
              [47.8608209, 34.9324511],
              [47.8613776, 34.9324511],
              [47.8616577, 34.9321714],
              [47.8624909, 34.9321714],
              [47.8627675, 34.9318918],
              [47.8805472, 34.9271737],
              [47.8833238, 34.9271737],
              [47.8836008, 34.926894],
              [47.8899907, 34.9268941],
              [47.8911005, 34.9271738],
              [47.8941572, 34.9271737],
              [47.8952669, 34.9274534],
              [47.8969338, 34.9274534],
              [47.8980471, 34.9277331],
              [47.899437, 34.9277331],
              [47.9002707, 34.9280127],
              [47.9183268, 34.9335608],
              [47.919437, 34.9335608],
              [47.9223534, 34.9345351],
              [47.9219366, 34.9352298],
              [47.9219367, 34.9357891],
              [47.9216601, 34.9360687],
              [47.92138, 34.9371694],
              [47.9199937, 34.9407868],
              [47.9197136, 34.9430059],
              [47.9199937, 34.9449455],
              [47.9227703, 34.9518918],
              [47.9527696, 34.9705112],
              [47.9558263, 34.9705112],
              [47.9561064, 34.9702315],
              [47.9572162, 34.9702315],
              [47.9719396, 34.9646746],
              [47.9999871, 34.9612717],
              [48.0055524, 34.9707819],
              [48.0180522, 34.9782874],
              [48.0322185, 34.9832849],
              [48.0327751, 34.9835646],
              [48.0333319, 34.9835646],
              [48.040832, 34.9860633],
              [48.043052, 34.9860633],
              [48.0436085, 34.9857837],
              [48.0441653, 34.9857837],
              [48.0444418, 34.9855041],
              [48.045275, 34.9855041],
              [48.0477751, 34.9843945],
              [48.0491649, 34.983285],
              [48.058055, 34.9749497],
              [48.058055, 34.9743994],
              [48.0636083, 34.9685629],
              [48.0730549, 34.9618964],
              [48.0741647, 34.9618964],
              [48.0744448, 34.9616167],
              [48.0797215, 34.9616167],
              [48.0799981, 34.9613371],
              [48.081388, 34.9613371],
              [48.0816648, 34.9616168],
              [48.0858314, 34.9616168],
              [48.0861114, 34.9618965],
              [48.0874978, 34.9621761],
              [48.0886116, 34.9621761],
              [48.1033345, 34.9710617],
              [48.1058345, 34.9721804],
              [48.1091678, 34.9730104],
              [48.1105576, 34.9730104],
              [48.1116679, 34.97329],
              [48.1144445, 34.97329],
              [48.1147245, 34.9730103],
              [48.1161108, 34.9730104],
              [48.1213911, 34.9716211],
              [48.1286143, 34.9705115],
              [48.1291673, 34.9702319],
              [48.1311143, 34.9702319],
              [48.1352808, 34.9688427],
              [48.1363906, 34.9688426],
              [48.1372242, 34.968563],
              [48.138614, 34.9685631],
              [48.1391673, 34.9685631],
              [48.1438907, 34.9707822],
              [48.1441674, 34.9710619],
              [48.1502807, 34.977178],
              [48.1513906, 34.9816163],
              [48.1563906, 34.988842],
              [48.1727804, 34.9960677],
              [48.173337, 34.9960678],
              [48.1758366, 34.9988461],
              [48.1758367, 35.0021747],
              [48.1766702, 35.0080111],
              [48.1772269, 35.0116194],
              [48.1780601, 35.0146774],
              [48.1855597, 35.0560724],
              [48.1861163, 35.0582914],
              [48.1863934, 35.0588417],
              [48.1872265, 35.06079],
              [48.1875031, 35.0655076],
              [48.1875031, 35.0668968],
              [48.1908363, 35.0793988],
              [48.1922262, 35.0927395],
              [48.1919496, 35.0932897],
              [48.1916694, 35.0952381],
              [48.1913929, 35.096068],
              [48.1888928, 35.101065],
              [48.1886163, 35.1021745],
              [48.1850029, 35.1063417],
              [48.1830599, 35.1069009],
              [48.1822263, 35.1069009],
              [48.1794465, 35.106901],
              [48.1727799, 35.106901],
              [48.1722265, 35.1071805],
              [48.1677798, 35.1071805],
              [48.1672268, 35.1074601],
              [48.1661135, 35.1074601],
              [48.1605567, 35.1091198],
              [48.15528, 35.113296],
              [48.1547234, 35.1144055],
              [48.1536135, 35.115515],
              [48.1525034, 35.1180134],
              [48.1563902, 35.1263478],
              [48.15778, 35.1288462],
              [48.1591699, 35.1313448],
              [48.1597234, 35.1335636],
              [48.1783363, 35.1532897],
              [48.1808363, 35.1599552],
              [48.1813929, 35.1610646],
              [48.1812528, 35.1637073],
              [48.1811128, 35.1652316],
              [48.1777796, 35.1699579],
              [48.1775372, 35.1707979],
              [48.1758361, 35.1727359],
              [48.1613897, 35.1844071],
              [48.1544464, 35.2038526],
              [48.1506136, 35.2098726],
              [48.1490576, 35.2116498],
              [48.139723, 35.2221796],
              [48.1269467, 35.2285741],
              [48.1225, 35.2285741],
              [48.1216669, 35.2288537],
              [48.1197234, 35.2288537],
              [48.1094435, 35.2269055],
              [48.1088904, 35.226626],
              [48.1050005, 35.2266259],
              [48.0988871, 35.2271761],
              [48.0980538, 35.2271761],
              [48.0972203, 35.227176],
              [48.096387, 35.2277353],
              [48.0961104, 35.2280148],
              [48.0958339, 35.2282944],
              [48.0963869, 35.2305131],
              [48.096387, 35.2307927],
              [48.0980537, 35.2424633],
              [48.0922203, 35.2591302],
              [48.0919438, 35.2610693],
              [48.0897204, 35.2694025],
              [48.0894437, 35.2696822],
              [48.0874968, 35.2727395],
              [48.0717073, 35.291857],
              [48.0639713, 35.3014993],
              [48.0637644, 35.3019368],
              [48.0568396, 35.3166275],
              [48.055256, 35.3199001],
              [48.0552784, 35.3204408],
              [48.0547159, 35.3222471],
              [48.0465236, 35.3366308],
              [48.0344691, 35.3579606],
              [48.0339083, 35.3596764],
              [48.0341885, 35.3615733],
              [48.0341478, 35.3628644],
              [48.0267081, 35.3707768],
              [48.023591, 35.3721644],
              [48.0233978, 35.3724469],
              [48.0224515, 35.3724601],
              [48.0219343, 35.3727596],
              [48.0209008, 35.3727196],
              [48.0203744, 35.3729977],
              [48.0138771, 35.3730239],
              [48.0136249, 35.3727871],
              [48.0114255, 35.372695],
              [48.0111462, 35.3724503],
              [48.0094141, 35.3724486],
              [48.0063889, 35.3718899],
              [48.006114, 35.3716197],
              [48.0035665, 35.3715979],
              [48.0021924, 35.3713434],
              [47.9999305, 35.3691808],
              [47.9974921, 35.3680307],
              [47.9855786, 35.3705494],
              [47.9852116, 35.3707884],
              [47.98478, 35.3707754],
              [47.9845319, 35.3710847],
              [47.982954, 35.3710341],
              [47.9805196, 35.3716773],
              [47.9802669, 35.3718967],
              [47.9786343, 35.3721011],
              [47.9768647, 35.3725322],
              [47.9634036, 35.3758051],
              [47.9629014, 35.3760204],
              [47.9622, 35.3760806],
              [47.9605446, 35.376615],
              [47.954468, 35.3794286],
              [47.9446874, 35.3897206],
              [47.9414672, 35.3948612],
              [47.9405738, 35.3960637],
              [47.9389714, 35.3996633],
              [47.9366179, 35.4050941],
              [47.9327526, 35.4172661],
              [47.9294172, 35.426621],
              [47.9274927, 35.4319791],
              [47.9214704, 35.4401868],
              [47.9192454, 35.4432204],
              [47.9170234, 35.4461009],
              [47.9158527, 35.4477699],
              [47.9152361, 35.4480602],
              [47.9150042, 35.4485338],
              [47.9088678, 35.4535664],
              [47.9053066, 35.4577055],
              [47.902856, 35.462245],
              [47.9019263, 35.4638378],
              [47.9020276, 35.4645399],
              [47.9016929, 35.4647273],
              [47.8959432, 35.4849721],
              [47.8939184, 35.4933252],
              [47.8875867, 35.5063575],
              [47.8872237, 35.5065394],
              [47.8861471, 35.5083135],
              [47.8861164, 35.5089453],
              [47.8855375, 35.510383],
              [47.8855726, 35.5137052],
              [47.8856144, 35.5169117],
              [47.8851092, 35.5174392],
              [47.8835232, 35.522066],
              [47.8829201, 35.5226892],
              [47.8815442, 35.5255306],
              [47.8802673, 35.5273133],
              [47.8797743, 35.5284477],
              [47.8781507, 35.5332846],
              [47.8778965, 35.5352344],
              [47.8784626, 35.5410001],
              [47.8808889, 35.5457386],
              [47.8823817, 35.5486643],
              [47.8826164, 35.5491834],
              [47.8805647, 35.5611842],
              [47.8851708, 35.5661705],
              [47.8880482, 35.5722231],
              [47.8938596, 35.5775297],
              [47.9036017, 35.5799649],
              [47.9490412, 35.5867208],
              [47.9532077, 35.5869913],
              [47.9537612, 35.5872707],
              [47.9554277, 35.5872707],
              [47.976264, 35.5953297],
              [47.9794081, 35.6122227],
              [47.9869399, 35.6271019],
              [47.9864504, 35.6351744],
              [48.0064066, 35.6435558],
              [48.0303077, 35.6485706],
              [48.0438242, 35.6513603],
              [48.0456963, 35.652243],
              [48.0490296, 35.652793],
              [48.0643514, 35.6522853],
              [48.085184, 35.6462768],
              [48.09732, 35.6444182],
              [48.1008052, 35.6475323],
              [48.106665, 35.6510625],
              [48.1217479, 35.6597371],
              [48.1355292, 35.6681734],
              [48.173654, 35.6701644],
              [48.175298, 35.6694665],
              [48.1839975, 35.6728606],
              [48.1965552, 35.6765947],
              [48.2096005, 35.679811],
              [48.2195404, 35.6838154],
              [48.2293555, 35.6867601],
              [48.2419109, 35.6918793],
              [48.2406663, 35.6934826],
              [48.2576416, 35.6943377],
              [48.2649998, 35.696915],
              [48.2706979, 35.6960481],
              [48.2772784, 35.6931287],
              [48.2826376, 35.6918096],
              [48.2858379, 35.6894397],
              [48.2901766, 35.6861535],
              [48.2817249, 35.695222],
              [48.2799138, 35.6969894],
              [48.2779578, 35.6990005],
              [48.2704315, 35.707128],
              [48.2524032, 35.7196275],
              [48.249434, 35.723168],
              [48.2415847, 35.725919],
              [48.2350039, 35.7283075],
              [48.2280604, 35.7299535],
              [48.220004, 35.7305252],
              [48.2100006, 35.7294262],
              [48.2012943, 35.7292838],
              [48.1911277, 35.7372279],
              [48.1850644, 35.7441817],
              [48.1604523, 35.7663192],
              [48.1465344, 35.779117],
              [48.1417255, 35.7821427],
              [48.1325648, 35.7887638],
              [48.1147119, 35.7988264],
              [48.100518, 35.8062978],
              [48.0917, 35.8132946],
              [48.0787466, 35.8126628],
              [48.0732267, 35.8141399],
              [48.0450991, 35.8136412],
              [48.0384911, 35.8264395],
              [48.0348974, 35.833974],
              [48.0313825, 35.8387804],
              [48.027939, 35.8489995],
              [48.0246578, 35.8640675],
              [48.0226296, 35.8741134],
              [48.0173567, 35.8888396],
              [48.0139401, 35.8992142],
              [48.0101385, 35.9113748],
              [48.0065729, 35.9226428],
              [48.0021391, 35.9302797],
              [47.9943839, 35.9305875],
              [47.9881538, 35.9313978],
              [47.9740332, 35.9243667],
              [47.9507819, 35.9083679],
              [47.9422535, 35.9021973],
              [47.9300876, 35.8932206],
              [47.913491, 35.8838841],
              [47.9059304, 35.881636],
              [47.9013347, 35.8830003],
              [47.8955133, 35.8796541],
              [47.8892937, 35.887184],
              [47.8835701, 35.89367],
              [47.870693, 35.9076837],
              [47.8664121, 35.9127809],
              [47.8543852, 35.9282588],
              [47.8666387, 35.9322449],
              [47.8677327, 35.9391239],
              [47.8780035, 35.9420623],
              [47.8881283, 35.9453899],
              [47.8939034, 35.9483138],
              [47.9141534, 35.9544193],
              [47.9144334, 35.9546987],
              [47.9158203, 35.9546988],
              [47.9160999, 35.9549782],
              [47.9177667, 35.9549781],
              [47.9199902, 35.9555369],
              [47.9213766, 35.955537],
              [47.9249899, 35.9558073],
              [47.9258232, 35.9560867],
              [47.9266567, 35.9558073],
              [47.9274899, 35.9560867],
              [47.9310999, 35.9560868],
              [47.9316566, 35.9563661],
              [47.9341566, 35.9563662],
              [47.9344331, 35.9566456],
              [47.9352663, 35.9566456],
              [47.9358234, 35.956925],
              [47.9369331, 35.956925],
              [47.9380464, 35.9574747],
              [47.9391566, 35.9574747],
              [47.9574895, 35.963306],
              [47.9620169, 35.9648082],
              [47.9719327, 35.9706714],
              [47.9736897, 35.9796735],
              [47.9720915, 35.983315],
              [47.9663085, 35.9879381],
              [47.9544829, 35.9938686],
              [47.9474698, 35.9963685],
              [47.9263982, 35.9978261],
              [47.902193, 35.9968965],
              [47.8922366, 35.9953688],
              [47.8851985, 35.9948827],
              [47.8772163, 35.9966188],
              [47.8715943, 35.9981812],
              [47.8737635, 36.0015048],
              [47.8780669, 36.0069949],
              [47.8826236, 36.015088],
              [47.8885459, 36.0211278],
              [47.9013347, 36.0313318],
              [47.9072921, 36.0339977],
              [47.9146233, 36.0330238],
              [47.9215048, 36.032026],
              [47.9313831, 36.0331749],
              [47.936611, 36.0348024],
              [47.9431341, 36.0389667],
              [47.9455727, 36.0405353],
              [47.9503546, 36.0453968],
              [47.9534911, 36.0483259],
              [47.961116, 36.0606759],
              [47.9640768, 36.0674173],
              [47.956309, 36.0775809],
              [47.9479837, 36.0795229],
              [47.9404306, 36.0803553],
              [47.937299, 36.0815716],
              [47.9318918, 36.082269],
              [47.9409079, 36.0904008],
              [47.9445129, 36.093172],
              [47.9507105, 36.0985882],
              [47.9585749, 36.1055342],
              [47.9715439, 36.1171465],
              [47.9845046, 36.1275459],
              [48.0033052, 36.148272],
              [47.9769353, 36.1638705],
              [47.976102, 36.1658168],
              [47.9761021, 36.1663755],
              [47.9758255, 36.1666458],
              [47.9752688, 36.1683128],
              [47.9749887, 36.169421],
              [47.9747122, 36.171097],
              [47.9744352, 36.1738723],
              [47.9744352, 36.1760979],
              [47.9744352, 36.1791525],
              [47.9738785, 36.1816485],
              [47.9738785, 36.1852616],
              [47.9736019, 36.1855409],
              [47.9733218, 36.1885955],
              [47.9821519, 36.1980384],
              [47.9760418, 36.2069315],
              [47.9424357, 36.2127732],
              [47.9455457, 36.2485939],
              [47.9416553, 36.2569279],
              [47.9416552, 36.2610994],
              [47.9419323, 36.2635951],
              [47.9422119, 36.2649825],
              [47.9430455, 36.2660997],
              [47.943322, 36.2666493],
              [47.9458221, 36.2685954],
              [47.9544317, 36.2735957],
              [47.956102, 36.2755418],
              [47.9563786, 36.2813709],
              [47.956102, 36.2816503],
              [47.9413786, 36.3102638],
              [47.9410984, 36.310543],
              [47.9385987, 36.31248],
              [47.9347084, 36.3147053],
              [47.9341553, 36.3152638],
              [47.9202655, 36.3202638],
              [47.9197089, 36.3202638],
              [47.9194323, 36.3205431],
              [47.9185988, 36.3205431],
              [47.8997088, 36.3308133],
              [47.8994323, 36.3311016],
              [47.8985955, 36.3311017],
              [47.8980424, 36.3313808],
              [47.8933192, 36.3313809],
              [47.8927622, 36.3313809],
              [47.8916524, 36.3316512],
              [47.8908192, 36.3316511],
              [47.8885956, 36.3316512],
              [47.8874859, 36.3313809],
              [47.8863758, 36.3313809],
              [47.8849859, 36.3313809],
              [47.8849858, 36.3311016],
              [47.8835959, 36.3311015],
              [47.8758192, 36.3291556],
              [47.8747059, 36.3291556],
              [47.8741528, 36.3288763],
              [47.8708195, 36.3288763],
              [47.8674859, 36.3294258],
              [47.8669293, 36.3297052],
              [47.866096, 36.3297052],
              [47.8483163, 36.3388762],
              [47.8435962, 36.3399842],
              [47.8422064, 36.3399842],
              [47.8410931, 36.3402635],
              [47.8402595, 36.3402635],
              [47.8399829, 36.3405428],
              [47.838593, 36.3405427],
              [47.8383165, 36.3408221],
              [47.8355399, 36.340822],
              [47.8352597, 36.3411013],
              [47.833873, 36.3411013],
              [47.8333164, 36.3413806],
              [47.8322065, 36.3413806],
              [47.8319264, 36.3416599],
              [47.8297064, 36.3416599],
              [47.8283166, 36.3419301],
              [47.8277595, 36.3422094],
              [47.8269264, 36.3422094],
              [47.81665, 36.3466597],
              [47.8155366, 36.3472092],
              [47.80026, 36.3627671],
              [47.7963702, 36.3655418],
              [47.7919267, 36.3674877],
              [47.7877602, 36.3694335],
              [47.7822034, 36.3719379],
              [47.7710903, 36.3735953],
              [47.7685903, 36.3741539],
              [47.7674805, 36.3741539],
              [47.7666472, 36.3744331],
              [47.7652569, 36.3744331],
              [47.7644237, 36.3747124],
              [47.7599803, 36.3747124],
              [47.7533137, 36.3752619],
              [47.7524806, 36.3755412],
              [47.7513671, 36.3755411],
              [47.7505339, 36.3758204],
              [47.7488672, 36.3758204],
              [47.748314, 36.3760996],
              [47.7463671, 36.3760997],
              [47.7283108, 36.3794328],
              [47.726644, 36.3794328],
              [47.7255342, 36.379712],
              [47.724701, 36.379712],
              [47.7241444, 36.3799913],
              [47.7152543, 36.3799912],
              [47.7147007, 36.3802705],
              [47.7141441, 36.3802705],
              [47.7113675, 36.3802705],
              [47.7110877, 36.3802705],
              [47.7099776, 36.3802705],
              [47.709421, 36.3799913],
              [47.7069209, 36.3799912],
              [47.7002543, 36.3788832],
              [47.6991446, 36.3783246],
              [47.6944211, 36.3777662],
              [47.6935878, 36.3774868],
              [47.6769214, 36.3780363],
              [47.6758081, 36.3783246],
              [47.6741413, 36.3783245],
              [47.6710846, 36.3788831],
              [47.6699748, 36.3788831],
              [47.6655314, 36.3797118],
              [47.6596985, 36.3805406],
              [47.6410184, 36.3910621],
              [47.6404652, 36.3913414],
              [47.6393519, 36.3913414],
              [47.6385183, 36.3916205],
              [47.6374085, 36.3916205],
              [47.6212217, 36.4060346],
              [47.6209416, 36.4063139],
              [47.6203885, 36.4063138],
              [47.6195549, 36.406593],
              [47.6192751, 36.4068722],
              [47.5969204, 36.4305233],
              [47.5963672, 36.4307935],
              [47.595534, 36.4305233],
              [47.589144, 36.4305233],
              [47.5479697, 36.4389613],
              [47.5116402, 36.4146039],
              [47.5183364, 36.3963641],
              [47.5183364, 36.3960848],
              [47.5131808, 36.3911143],
              [47.5131549, 36.3910319],
              [47.5253102, 36.3635224],
              [47.4920079, 36.3360089],
              [47.465057, 36.3187216],
              [47.4568176, 36.3196205],
              [47.4460885, 36.3214188],
              [47.4302101, 36.3235623],
              [47.4263476, 36.324807],
              [47.4091815, 36.3263975],
              [47.3973741, 36.3296076],
              [47.3889736, 36.3290032],
              [47.3757934, 36.3217643],
              [47.370766, 36.3174458],
              [47.3658983, 36.3120193],
              [47.3614668, 36.3058531],
              [47.3549153, 36.2963912],
              [47.3472976, 36.2878023],
              [47.3395729, 36.278185],
              [47.3291015, 36.2687051],
              [47.3248099, 36.2668367],
              [47.3117647, 36.259455],
              [47.2933101, 36.2556942],
              [47.2486369, 36.2520486],
              [47.2266196, 36.2514029],
              [47.2112691, 36.2503705],
              [47.1872937, 36.2502378],
              [47.1503798, 36.2513417],
              [47.1310618, 36.250538],
              [47.1160697, 36.2507799],
              [47.1038818, 36.252095],
              [47.0952987, 36.2558326],
              [47.0892905, 36.2606081],
              [47.083322, 36.2679466],
              [47.0789257, 36.2708602],
              [47.0720386, 36.2718191],
              [47.0680904, 36.274241],
              [47.0656596, 36.2765801],
              [47.0621741, 36.28151],
              [47.0455019, 36.2952612],
              [47.0435558, 36.2963694],
              [47.0427221, 36.2972072],
              [47.042169, 36.2972073],
              [47.042169, 36.2974865],
              [47.031336, 36.30582],
              [47.0310556, 36.3060993],
              [46.9736602, 36.3355973],
              [46.9615744, 36.337115],
              [46.942005, 36.3386361],
              [46.9202883, 36.3401852],
              [46.905102, 36.3419882],
              [46.8975447, 36.3452732],
              [46.8934544, 36.3495927],
              [46.8896565, 36.3592963],
              [46.8905838, 36.3676668],
              [46.8868512, 36.3778213],
              [46.8777542, 36.3835732],
              [46.8659267, 36.3941974],
              [46.849373, 36.4184417],
              [46.8308939, 36.4378144],
              [46.8297806, 36.4378144],
              [46.8295041, 36.4380936],
              [46.8283939, 36.4383638],
              [46.8278368, 36.4383637],
              [46.8275602, 36.438643],
              [46.827004, 36.438643],
              [46.8237425, 36.439815],
              [46.8205238, 36.4379507],
              [46.8184124, 36.4357962],
              [46.8170992, 36.4352991],
              [46.816919, 36.4346569],
              [46.8157345, 36.4336418],
              [46.8151938, 36.4326059],
              [46.8135201, 36.4317358],
              [46.8124643, 36.4318809],
              [46.8092714, 36.4293948],
              [46.8080355, 36.4290219],
              [46.8069859, 36.4286404],
              [46.8065577, 36.4284946],
              [46.804227, 36.4263742],
              [46.8008565, 36.4269802],
              [46.7954921, 36.4269111],
              [46.7941618, 36.4259097],
              [46.7860078, 36.4222149],
              [46.7784547, 36.4196249],
              [46.768198, 36.4178291],
              [46.7578125, 36.418727],
              [46.7463541, 36.4163787],
              [46.7324066, 36.4128905],
              [46.7254972, 36.4102657],
              [46.7074298, 36.4039451],
              [46.6862296, 36.4037379],
              [46.6707801, 36.4014581],
              [46.6523265, 36.4009746],
              [46.6383361, 36.4006982],
              [46.6316628, 36.3990574],
              [46.6292166, 36.3984184],
              [46.6255045, 36.3989538],
              [46.6223287, 36.3980902],
              [46.6203117, 36.3967948],
              [46.6154193, 36.3967948],
              [46.6025447, 36.3959658],
              [46.5916013, 36.3972094],
              [46.5772247, 36.3986947],
              [46.5530204, 36.4019762],
              [46.5491151, 36.404325],
              [46.5462827, 36.402149],
              [46.5422916, 36.4006291],
              [46.540854, 36.4003355],
              [46.5397596, 36.4003182],
              [46.5377211, 36.4002837],
              [46.5356183, 36.4006118],
              [46.5334081, 36.4014236],
              [46.5320777, 36.4022871],
              [46.5306615, 36.4041178],
              [46.5296745, 36.4056721],
              [46.5288162, 36.4069155],
              [46.5283012, 36.408228],
              [46.5268971, 36.4096782],
              [46.5258168, 36.4100229],
              [46.524148, 36.4105467],
              [46.5221948, 36.4112512],
              [46.5198636, 36.4123689],
              [46.5173618, 36.4135326],
              [46.5152109, 36.4146723],
              [46.5094112, 36.4166903],
              [46.5075573, 36.41703],
              [46.5033908, 36.4175384],
              [46.5027143, 36.4181368],
              [46.4997915, 36.4188045],
              [46.4960501, 36.4196476],
              [46.4911575, 36.4204591],
              [46.4850494, 36.4208014],
              [46.478838, 36.4211122],
              [46.4724163, 36.4208961],
              [46.4645519, 36.4201018],
              [46.4583339, 36.4187693],
              [46.4548198, 36.4176815],
              [46.4515819, 36.4159346],
              [46.4446103, 36.4110449],
              [46.4399151, 36.4052562],
              [46.4380825, 36.4017879],
              [46.4344024, 36.3934441],
              [46.4304203, 36.3849525],
              [46.4275826, 36.3799342],
              [46.4226436, 36.3718157],
              [46.4173218, 36.3653885],
              [46.4117002, 36.3603427],
              [46.4088678, 36.359686],
              [46.4036747, 36.3617944],
              [46.3955211, 36.3654574],
              [46.3845563, 36.3686997],
              [46.378551, 36.3703583],
              [46.3737947, 36.3715995],
              [46.3679424, 36.372397],
              [46.357313, 36.3730531],
              [46.3480358, 36.3725642],
              [46.3326501, 36.3724031],
              [46.3262106, 36.3732678],
              [46.3194175, 36.3742036],
              [46.3090896, 36.3763078],
              [46.303339, 36.3785882],
              [46.299634, 36.3808164],
              [46.2968158, 36.3827343],
              [46.2933436, 36.3860813],
              [46.2896718, 36.3887665],
              [46.2807226, 36.3935822],
              [46.2750148, 36.3965185],
              [46.2691783, 36.3988674],
              [46.260638, 36.4028563],
              [46.2537717, 36.4052231],
              [46.2449312, 36.408746],
              [46.2337732, 36.4158606],
              [46.2248039, 36.4201774],
              [46.2157058, 36.4249429],
              [46.2082386, 36.4280851],
              [46.2036895, 36.4283614],
              [46.2001276, 36.4293627],
              [46.1972382, 36.4312573],
              [46.1949777, 36.4357504],
              [46.1918017, 36.4397556],
              [46.1864834, 36.4457147],
              [46.1857711, 36.447005],
              [46.1843843, 36.4470049],
              [46.1802147, 36.4481131],
              [46.1785482, 36.4481131],
              [46.176881, 36.4486715],
              [46.1757716, 36.4486715],
              [46.1614553, 36.4550265],
              [46.1608982, 36.4550264],
              [46.1538272, 36.459454],
              [46.1193097, 36.4534077],
              [46.1038682, 36.4442091],
              [46.0711666, 36.4381329],
              [46.0657873, 36.4242993],
              [46.0399243, 36.4218352],
              [46.0282295, 36.4316484],
              [46.0154534, 36.4277659],
              [46.0085455, 36.4336523],
              [46.0031032, 36.4328156],
              [45.999349, 36.4313014],
              [45.9951639, 36.4301569],
              [45.9916505, 36.4285528],
              [45.988323, 36.4241959],
              [45.9859508, 36.4210071],
              [45.9826755, 36.4123725],
              [45.9813019, 36.3995931],
              [45.9820747, 36.3956549],
              [45.976839, 36.3924768],
              [45.9716031, 36.3914406],
              [45.9667968, 36.393375],
              [45.9622478, 36.392615],
              [45.9602737, 36.3912331],
              [45.9553472, 36.3860518],
              [45.9549464, 36.380721],
              [45.9601878, 36.372576],
              [45.9622559, 36.3551123],
              [45.9692, 36.3449967],
              [45.9732338, 36.3337964],
              [45.9808992, 36.3278738],
              [45.9810446, 36.307379],
              [45.9830188, 36.2993552],
              [45.988512, 36.2871104],
              [45.9895849, 36.2774931],
              [45.9859371, 36.2742755],
              [45.9796559, 36.269017],
              [45.976766, 36.2647723],
              [45.9614169, 36.2572119],
              [45.9539221, 36.2525796],
              [45.9389876, 36.2481497],
              [45.9182165, 36.2361046],
              [45.883365, 36.2077042],
              [45.8501945, 36.1958325],
              [45.8381156, 36.195407],
              [45.8261438, 36.1949364],
              [45.8234167, 36.1949617],
              [45.811141, 36.194788],
              [45.7922373, 36.1945398],
              [45.7792843, 36.1943675],
              [45.7680276, 36.1942525],
              [45.7665739, 36.1948144],
              [45.7487693, 36.1995873],
              [45.7438775, 36.1986664],
              [45.7381998, 36.2003359],
              [45.7348414, 36.2013748],
              [45.7135445, 36.2075346],
              [45.7089219, 36.2078557],
              [45.7066011, 36.2081998],
              [45.7040262, 36.2078535],
              [45.6999492, 36.2060529],
              [45.6982112, 36.2048322],
              [45.6972146, 36.2045459],
              [45.6949944, 36.2023647],
              [45.6914305, 36.1995771],
              [45.6903362, 36.1978456],
              [45.6896494, 36.195837],
              [45.6895852, 36.1941399],
              [45.6898856, 36.1923562],
              [45.6909798, 36.1886157],
              [45.7016517, 36.1787456],
              [45.6977893, 36.176442],
              [45.6912719, 36.1744202],
              [45.6814077, 36.17137],
              [45.6781709, 36.1705366],
              [45.6705093, 36.168784],
              [45.6639976, 36.1652472],
              [45.6586506, 36.1593008],
              [45.6581068, 36.1582859],
              [45.655119, 36.1545163],
              [45.6542015, 36.1528804],
              [45.6533923, 36.1509283],
              [45.6529599, 36.1488409],
              [45.6516695, 36.1384986],
              [45.6500882, 36.1301873],
              [45.6496095, 36.1258127],
              [45.6505107, 36.120197],
              [45.6542014, 36.1132634],
              [45.6553387, 36.1108192],
              [45.6560683, 36.1084269],
              [45.656476, 36.1061385],
              [45.6563902, 36.1039888],
              [45.6545877, 36.1011282],
              [45.6516266, 36.099013],
              [45.6480002, 36.09747],
              [45.6448972, 36.0954111],
              [45.6427002, 36.0937075],
              [45.639739, 36.0907251],
              [45.6287096, 36.0837891],
              [45.6259632, 36.0826098],
              [45.6208992, 36.0823323],
              [45.6191396, 36.0827832],
              [45.617423, 36.0826098],
              [45.6152935, 36.0834225],
              [45.6089294, 36.0842202],
              [45.6009882, 36.0863679],
              [45.5967378, 36.087812],
              [45.591448, 36.0887951],
              [45.590043, 36.0884016],
              [45.5895845, 36.0876506],
              [45.5896568, 36.0836502],
              [45.5888846, 36.0796674],
              [45.5877685, 36.0781702],
              [45.5856227, 36.077095],
              [45.5807304, 36.0762972],
              [45.5752372, 36.0760198],
              [45.5716753, 36.0747017],
              [45.569229, 36.0721349],
              [45.5675554, 36.0688048],
              [45.5670833, 36.0651971],
              [45.5671267, 36.0638128],
              [45.567255, 36.0597157],
              [45.568639, 36.054156],
              [45.5697343, 36.0524425],
              [45.5745075, 36.050244],
              [45.5787992, 36.0490643],
              [45.5836911, 36.0459493],
              [45.5870575, 36.043935],
              [45.5879349, 36.0419883],
              [45.5861326, 36.039145],
              [45.5817114, 36.0331631],
              [45.572375, 36.0235879],
              [45.568199, 36.0185593],
              [45.5576542, 36.0127509],
              [45.5582105, 36.0069199],
              [45.5584871, 36.004694],
              [45.5587676, 36.0044146],
              [45.5584872, 35.9999714],
              [45.557841, 35.9950418]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 241593,
        "tags": {
          "ISO3166-2": "IR-04",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "آذربایجان غربی",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q134411"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [44.0377009, 39.3612643],
              [44.0386718, 39.3608663],
              [44.0408185, 39.3599883],
              [44.0425381, 39.3591896],
              [44.0435999, 39.3586378],
              [44.0447428, 39.358296],
              [44.0463806, 39.3582838],
              [44.0470259, 39.3584733],
              [44.0480958, 39.3584331],
              [44.0489477, 39.3581541],
              [44.0496959, 39.3574698],
              [44.0512429, 39.3568381],
              [44.0524451, 39.3565558],
              [44.0525803, 39.3564944],
              [44.0540547, 39.3561944],
              [44.0555634, 39.3556082],
              [44.0565238, 39.3554892],
              [44.0565263, 39.3545436],
              [44.0565564, 39.3534506],
              [44.0569331, 39.3516271],
              [44.0572372, 39.3488081],
              [44.0570156, 39.3476305],
              [44.0568634, 39.3471799],
              [44.0565563, 39.3466201],
              [44.0565319, 39.3462819],
              [44.0563491, 39.3455066],
              [44.0571398, 39.3440014],
              [44.0573319, 39.3434079],
              [44.0581369, 39.3425351],
              [44.0587378, 39.3426906],
              [44.0592545, 39.3430609],
              [44.059751, 39.3432488],
              [44.060801, 39.3434393],
              [44.0617201, 39.3436291],
              [44.0619043, 39.3434504],
              [44.0637756, 39.3423429],
              [44.06446, 39.3418452],
              [44.0643793, 39.3415728],
              [44.0644631, 39.3405809],
              [44.0647633, 39.3400737],
              [44.0649749, 39.339729],
              [44.065277, 39.3394357],
              [44.0663913, 39.3389453],
              [44.0681548, 39.3378961],
              [44.0701975, 39.3371482],
              [44.0714633, 39.3367664],
              [44.0722253, 39.3364266],
              [44.0734007, 39.3354126],
              [44.0740838, 39.333683],
              [44.0756455, 39.331796],
              [44.0758396, 39.3313819],
              [44.0758457, 39.3309295],
              [44.0757315, 39.3302777],
              [44.0758593, 39.3298681],
              [44.0762255, 39.3296506],
              [44.076549, 39.3292286],
              [44.0768659, 39.3285943],
              [44.0773572, 39.328092],
              [44.0775174, 39.327524],
              [44.077345, 39.3265493],
              [44.0774721, 39.3261855],
              [44.0777359, 39.3258432],
              [44.0779942, 39.3256494],
              [44.0783436, 39.3255312],
              [44.0790532, 39.3254174],
              [44.0795278, 39.3252284],
              [44.0797056, 39.3249882],
              [44.0795273, 39.3240084],
              [44.0790782, 39.3221797],
              [44.0787019, 39.321227],
              [44.0778636, 39.3199415],
              [44.0777466, 39.3194318],
              [44.0778083, 39.3188725],
              [44.078331, 39.3181092],
              [44.0788744, 39.3174655],
              [44.0790987, 39.3169258],
              [44.079467, 39.3162599],
              [44.0795865, 39.3158467],
              [44.0795859, 39.3154044],
              [44.0794402, 39.3143543],
              [44.0793872, 39.3134792],
              [44.0792932, 39.313257],
              [44.0786114, 39.3126535],
              [44.078536, 39.3120718],
              [44.0781849, 39.3116563],
              [44.0780466, 39.3106055],
              [44.0776572, 39.3098],
              [44.0775425, 39.3095629],
              [44.0772325, 39.3091797],
              [44.0770277, 39.3087738],
              [44.0769482, 39.3083552],
              [44.0767137, 39.3079177],
              [44.0773198, 39.3062117],
              [44.0776345, 39.3055394],
              [44.0782354, 39.3050399],
              [44.0787606, 39.3043392],
              [44.0791346, 39.303182],
              [44.0792553, 39.3004868],
              [44.0791014, 39.2975847],
              [44.0804721, 39.2960014],
              [44.0810014, 39.295171],
              [44.0810285, 39.2947165],
              [44.0812513, 39.2941275],
              [44.0816868, 39.2937834],
              [44.0821559, 39.2935265],
              [44.083845, 39.2931197],
              [44.0849708, 39.2927348],
              [44.0858397, 39.2925356],
              [44.0863608, 39.2923291],
              [44.0882232, 39.2913743],
              [44.0888332, 39.291166],
              [44.0893026, 39.2908435],
              [44.0900438, 39.2902005],
              [44.0905064, 39.2900285],
              [44.0908955, 39.2899955],
              [44.0912217, 39.2900224],
              [44.0916298, 39.2902011],
              [44.0921392, 39.2904995],
              [44.0929357, 39.2907939],
              [44.0936009, 39.2909346],
              [44.0944685, 39.2909127],
              [44.0955762, 39.2907467],
              [44.0960155, 39.2906073],
              [44.0976585, 39.290317],
              [44.0983688, 39.2900747],
              [44.0996892, 39.2897789],
              [44.1010413, 39.2895881],
              [44.1014094, 39.2894732],
              [44.1019137, 39.2890206],
              [44.1028782, 39.2883663],
              [44.1029498, 39.2880474],
              [44.1028891, 39.28754],
              [44.103067, 39.2866872],
              [44.1035764, 39.2859782],
              [44.1040044, 39.2855295],
              [44.1052278, 39.2848633],
              [44.1061212, 39.2845504],
              [44.1067544, 39.2843709],
              [44.1070871, 39.2843553],
              [44.1078107, 39.2844303],
              [44.1080596, 39.2842966],
              [44.1081319, 39.283983],
              [44.1081096, 39.28366],
              [44.1077983, 39.2834656],
              [44.105889, 39.2827246],
              [44.1053724, 39.2822756],
              [44.1039371, 39.2805196],
              [44.1034645, 39.2801482],
              [44.102524, 39.2795518],
              [44.1015003, 39.2784343],
              [44.1013953, 39.277781],
              [44.1012083, 39.2773651],
              [44.100794, 39.2769342],
              [44.1001975, 39.2764647],
              [44.0997591, 39.2762165],
              [44.0991869, 39.2760987],
              [44.0984765, 39.276066],
              [44.0980984, 39.2760907],
              [44.0944506, 39.2759082],
              [44.0937966, 39.2755803],
              [44.0934445, 39.2751022],
              [44.0931065, 39.2735922],
              [44.0925313, 39.2730751],
              [44.0922603, 39.2725588],
              [44.0912222, 39.270144],
              [44.091075, 39.2696567],
              [44.0909704, 39.2689386],
              [44.091113, 39.2681992],
              [44.0918301, 39.2667887],
              [44.0919474, 39.2662578],
              [44.0918313, 39.2654965],
              [44.0918351, 39.2645959],
              [44.0917685, 39.2636812],
              [44.0915587, 39.2628142],
              [44.0913152, 39.2623686],
              [44.090693, 39.2619874],
              [44.0898625, 39.2616656],
              [44.0895411, 39.2614977],
              [44.0867425, 39.2579315],
              [44.0863285, 39.2575169],
              [44.0846282, 39.2564747],
              [44.0843797, 39.2562135],
              [44.0843065, 39.2560217],
              [44.0843946, 39.2558544],
              [44.0850271, 39.2555682],
              [44.0854359, 39.2553257],
              [44.0858328, 39.2550016],
              [44.0864613, 39.2538545],
              [44.0866463, 39.2534712],
              [44.0867208, 39.253039],
              [44.0861728, 39.2517667],
              [44.0860691, 39.2512276],
              [44.0861311, 39.2507621],
              [44.0864025, 39.2504604],
              [44.0885676, 39.2491066],
              [44.0890813, 39.2485506],
              [44.0892651, 39.2481721],
              [44.0892548, 39.2474177],
              [44.089445, 39.247049],
              [44.0897917, 39.2468437],
              [44.0901326, 39.2467848],
              [44.0922555, 39.2469285],
              [44.0927461, 39.2468844],
              [44.0943376, 39.2462673],
              [44.095377, 39.2458084],
              [44.0959179, 39.2457131],
              [44.098093, 39.2457286],
              [44.0991451, 39.2456337],
              [44.0995261, 39.2454006],
              [44.1002983, 39.2445942],
              [44.1019922, 39.2432411],
              [44.1030469, 39.2427928],
              [44.1032307, 39.2425733],
              [44.1032791, 39.2422503],
              [44.1031323, 39.2417395],
              [44.1030211, 39.2410546],
              [44.1027102, 39.237853],
              [44.1027055, 39.2375198],
              [44.103069, 39.2370198],
              [44.103099, 39.236565],
              [44.1029539, 39.2358296],
              [44.1025968, 39.2347313],
              [44.102123, 39.2342047],
              [44.1022442, 39.2335902],
              [44.1022261, 39.2327319],
              [44.1023816, 39.2313926],
              [44.1021439, 39.2311834],
              [44.1019058, 39.2310555],
              [44.1015377, 39.2310259],
              [44.1013112, 39.2308829],
              [44.1011348, 39.2305699],
              [44.1007634, 39.2303658],
              [44.1001281, 39.2302772],
              [44.0998538, 39.2299247],
              [44.0995938, 39.2290376],
              [44.0993675, 39.2286381],
              [44.0989396, 39.2282621],
              [44.0987108, 39.2278631],
              [44.0988068, 39.2273083],
              [44.0991299, 39.2269611],
              [44.0999281, 39.2265653],
              [44.1004885, 39.2261742],
              [44.100648, 39.2252757],
              [44.1003124, 39.2245045],
              [44.1000122, 39.2239909],
              [44.0991704, 39.2231462],
              [44.098482, 39.2220847],
              [44.0979405, 39.2214111],
              [44.0967481, 39.2208352],
              [44.0959966, 39.21979],
              [44.0949837, 39.2180435],
              [44.09431, 39.2171949],
              [44.0940514, 39.216368],
              [44.094084, 39.2155288],
              [44.0945859, 39.2144189],
              [44.0955432, 39.2130218],
              [44.0956276, 39.2122733],
              [44.0959032, 39.2118292],
              [44.0966719, 39.2111325],
              [44.0973153, 39.2101938],
              [44.0974077, 39.2097097],
              [44.0976507, 39.2092272],
              [44.0974353, 39.2086343],
              [44.097009, 39.2082275],
              [44.0968119, 39.2078741],
              [44.096662, 39.2075522],
              [44.0970053, 39.2065212],
              [44.096993, 39.2050193],
              [44.0972566, 39.2044917],
              [44.0975845, 39.2041397],
              [44.0997341, 39.2036813],
              [44.1004988, 39.2036234],
              [44.1016684, 39.2031615],
              [44.1030103, 39.2027324],
              [44.1045859, 39.2021135],
              [44.1058659, 39.2017167],
              [44.1073227, 39.2014626],
              [44.1081411, 39.2011741],
              [44.1092558, 39.1998789],
              [44.1098982, 39.1988918],
              [44.1100854, 39.1981779],
              [44.1100537, 39.1974887],
              [44.1098176, 39.1965473],
              [44.1099816, 39.1956513],
              [44.1105406, 39.1949084],
              [44.1113231, 39.1941423],
              [44.111675, 39.1936405],
              [44.1117736, 39.1927357],
              [44.1122791, 39.1918378],
              [44.1132286, 39.1908538],
              [44.114932, 39.1894902],
              [44.1153558, 39.1890124],
              [44.1158881, 39.1887227],
              [44.1170805, 39.1884819],
              [44.1183961, 39.1879572],
              [44.1189468, 39.1878297],
              [44.1211904, 39.1876915],
              [44.1217739, 39.1874753],
              [44.1225379, 39.1870526],
              [44.1231808, 39.1867981],
              [44.1235049, 39.1864492],
              [44.1241466, 39.1860438],
              [44.125796, 39.1854537],
              [44.1277949, 39.1852492],
              [44.1285138, 39.1852842],
              [44.1295851, 39.1851757],
              [44.130342, 39.1846331],
              [44.1310808, 39.1836802],
              [44.131692, 39.183097],
              [44.1320203, 39.1830034],
              [44.1325457, 39.1829793],
              [44.1330303, 39.1828165],
              [44.1336574, 39.182713],
              [44.1345288, 39.1826799],
              [44.1357854, 39.1824978],
              [44.137134, 39.1827011],
              [44.1374833, 39.1830378],
              [44.1384242, 39.1836999],
              [44.1394341, 39.1842148],
              [44.1408196, 39.1847539],
              [44.1435832, 39.1855823],
              [44.1441674, 39.1855906],
              [44.144875, 39.1854963],
              [44.1455156, 39.1852207],
              [44.1470043, 39.1843051],
              [44.1479833, 39.1836249],
              [44.1494933, 39.1823759],
              [44.1500163, 39.1820659],
              [44.1508458, 39.1817995],
              [44.1518559, 39.1815412],
              [44.1526092, 39.1812803],
              [44.1534791, 39.1810582],
              [44.1554197, 39.1804376],
              [44.1563248, 39.1803671],
              [44.158451, 39.179853],
              [44.1600624, 39.1793414],
              [44.161533, 39.1788112],
              [44.1645706, 39.1781192],
              [44.1663807, 39.1776245],
              [44.1668342, 39.1773325],
              [44.1678675, 39.1759275],
              [44.1684463, 39.1755654],
              [44.1691738, 39.1752171],
              [44.1699343, 39.1749825],
              [44.1706627, 39.1746242],
              [44.1712073, 39.1741833],
              [44.1717042, 39.1736354],
              [44.1722608, 39.1731199],
              [44.1731483, 39.1725871],
              [44.1741073, 39.1716756],
              [44.1746717, 39.1713441],
              [44.1766354, 39.1706247],
              [44.1779327, 39.1697597],
              [44.1784838, 39.1692391],
              [44.1799678, 39.1671808],
              [44.1809399, 39.1661018],
              [44.181817, 39.1654525],
              [44.1821552, 39.1652938],
              [44.1825809, 39.1652066],
              [44.1830035, 39.1650483],
              [44.1832615, 39.1647651],
              [44.1834133, 39.1642036],
              [44.1834623, 39.163279],
              [44.1837299, 39.162891],
              [44.1839208, 39.162419],
              [44.1838165, 39.1620412],
              [44.1839519, 39.1614984],
              [44.1842524, 39.1610696],
              [44.1844995, 39.1608798],
              [44.1862379, 39.1602898],
              [44.1874792, 39.1600026],
              [44.1880781, 39.1599144],
              [44.1885063, 39.1596246],
              [44.1889114, 39.1590828],
              [44.1893978, 39.1586732],
              [44.1902139, 39.1581882],
              [44.1901312, 39.1578647],
              [44.1895092, 39.1573338],
              [44.1898475, 39.1559675],
              [44.1903645, 39.1531692],
              [44.1907752, 39.1526904],
              [44.1915157, 39.1523274],
              [44.1931017, 39.1518225],
              [44.1937754, 39.1513674],
              [44.1945669, 39.1505041],
              [44.1954479, 39.1496653],
              [44.1972577, 39.1477209],
              [44.1979321, 39.1468296],
              [44.1987141, 39.1453974],
              [44.1999753, 39.1441872],
              [44.2007101, 39.1429782],
              [44.2008534, 39.1420917],
              [44.2010388, 39.1402004],
              [44.2014439, 39.1398101],
              [44.2035576, 39.1384863],
              [44.2039268, 39.1383489],
              [44.2063946, 39.1381749],
              [44.2068714, 39.13799],
              [44.2075445, 39.1373609],
              [44.2089184, 39.1363071],
              [44.2093804, 39.1358837],
              [44.2101667, 39.1345337],
              [44.210815, 39.1337228],
              [44.2114864, 39.132738],
              [44.2123024, 39.1318785],
              [44.2135655, 39.1303045],
              [44.2134534, 39.1296812],
              [44.2131184, 39.1287568],
              [44.2126409, 39.1280362],
              [44.2114676, 39.1268754],
              [44.211245, 39.1260021],
              [44.2112988, 39.1251787],
              [44.2115975, 39.1243469],
              [44.2110744, 39.1237057],
              [44.2105547, 39.1227979],
              [44.2102214, 39.120607],
              [44.2098835, 39.1194263],
              [44.2095143, 39.1176911],
              [44.2093752, 39.1174627],
              [44.2082857, 39.1168005],
              [44.2080448, 39.1165213],
              [44.2075342, 39.1148227],
              [44.2075924, 39.1140854],
              [44.2078744, 39.1138214],
              [44.2085067, 39.113065],
              [44.2098329, 39.1117828],
              [44.2100207, 39.1113207],
              [44.2098488, 39.1107767],
              [44.2098131, 39.1104689],
              [44.21052, 39.1101641],
              [44.2111317, 39.1101893],
              [44.211544, 39.1100803],
              [44.2128448, 39.1089362],
              [44.2146638, 39.1083422],
              [44.2151731, 39.1080923],
              [44.2152753, 39.1077074],
              [44.2152948, 39.107158],
              [44.2155331, 39.1068641],
              [44.2158458, 39.1067753],
              [44.216525, 39.1064166],
              [44.2170612, 39.1056918],
              [44.217521, 39.1046326],
              [44.2180401, 39.1037438],
              [44.2190124, 39.1034038],
              [44.2202364, 39.1031055],
              [44.2209183, 39.1032723],
              [44.2213739, 39.103451],
              [44.2217707, 39.1033373],
              [44.2228335, 39.102561],
              [44.2233369, 39.101967],
              [44.2234949, 39.1014324],
              [44.2233645, 39.1008608],
              [44.2239769, 39.0999006],
              [44.224562, 39.0988457],
              [44.2257876, 39.0962523],
              [44.2260246, 39.0954001],
              [44.22591, 39.0950499],
              [44.2255758, 39.0948545],
              [44.2250471, 39.094699],
              [44.2242914, 39.0945462],
              [44.2237822, 39.0945021],
              [44.223291, 39.0943564],
              [44.222913, 39.0940911],
              [44.222601, 39.0937091],
              [44.2224833, 39.0929751],
              [44.2222315, 39.0922599],
              [44.2214546, 39.0918019],
              [44.2215691, 39.0911812],
              [44.2212121, 39.0907636],
              [44.2210071, 39.0907036],
              [44.219422, 39.0911638],
              [44.2180435, 39.0910361],
              [44.2168608, 39.0908357],
              [44.2160155, 39.0903627],
              [44.2156512, 39.09029],
              [44.2152241, 39.0901364],
              [44.2146416, 39.0897352],
              [44.2142056, 39.0891521],
              [44.2135178, 39.0885881],
              [44.2123189, 39.0878149],
              [44.2092274, 39.0876745],
              [44.2079823, 39.0889603],
              [44.2070564, 39.0893604],
              [44.2067631, 39.0896461],
              [44.2063251, 39.0899074],
              [44.2057823, 39.0899555],
              [44.2051695, 39.0896727],
              [44.2048084, 39.089187],
              [44.2043867, 39.0890369],
              [44.2041829, 39.088561],
              [44.2030646, 39.0875461],
              [44.2026104, 39.0873465],
              [44.2019587, 39.0872557],
              [44.2014128, 39.0871142],
              [44.2007421, 39.0871649],
              [44.1999436, 39.0870868],
              [44.199409, 39.0867321],
              [44.1989974, 39.0866304],
              [44.1982417, 39.0868192],
              [44.1975571, 39.0863981],
              [44.1972237, 39.085835],
              [44.1967697, 39.0846157],
              [44.1962169, 39.0837218],
              [44.1951388, 39.08161],
              [44.1947359, 39.0810195],
              [44.1939205, 39.0805684],
              [44.1935224, 39.080146],
              [44.1930366, 39.0797564],
              [44.1927046, 39.0793139],
              [44.1925661, 39.0788125],
              [44.1925668, 39.0781488],
              [44.1922512, 39.077641],
              [44.1917969, 39.0771982],
              [44.1911717, 39.0768918],
              [44.1909206, 39.0766185],
              [44.1909881, 39.0752844],
              [44.1908665, 39.0745913],
              [44.1909647, 39.0737457],
              [44.1919283, 39.0725581],
              [44.1920091, 39.0718669],
              [44.1921888, 39.0710945],
              [44.1922689, 39.0707501],
              [44.1928778, 39.0698241],
              [44.1932503, 39.0689763],
              [44.1936511, 39.0679457],
              [44.1942347, 39.0672985],
              [44.1944491, 39.0668608],
              [44.1954993, 39.0664432],
              [44.1956005, 39.0662788],
              [44.1955677, 39.0657915],
              [44.1964427, 39.0651621],
              [44.196724, 39.0646177],
              [44.1968694, 39.0636482],
              [44.1975345, 39.0629197],
              [44.1986733, 39.0624737],
              [44.2000291, 39.0616249],
              [44.2023568, 39.0590709],
              [44.2032377, 39.0582788],
              [44.2038752, 39.0577003],
              [44.2049207, 39.056358],
              [44.205512, 39.0554679],
              [44.2049836, 39.054548],
              [44.2043233, 39.0540891],
              [44.2029986, 39.0535069],
              [44.2019064, 39.0528806],
              [44.20035, 39.0513163],
              [44.1996037, 39.0499924],
              [44.1991048, 39.0485205],
              [44.199019, 39.0484988],
              [44.1979261, 39.0474898],
              [44.1959068, 39.0461699],
              [44.1951443, 39.0449446],
              [44.1948066, 39.0438966],
              [44.1946546, 39.0420495],
              [44.1947723, 39.0405005],
              [44.1954078, 39.0392853],
              [44.1964667, 39.0384941],
              [44.197931, 39.0371182],
              [44.1988806, 39.0365068],
              [44.2003062, 39.0347941],
              [44.2022094, 39.0321067],
              [44.2026223, 39.0310124],
              [44.2040712, 39.0303155],
              [44.2054827, 39.029258],
              [44.2071426, 39.0276376],
              [44.2079482, 39.0262006],
              [44.2084922, 39.025445],
              [44.20943, 39.0243509],
              [44.2102017, 39.023315],
              [44.2113866, 39.0222157],
              [44.2116539, 39.0217294],
              [44.211677, 39.0209503],
              [44.2114977, 39.0204983],
              [44.2106801, 39.019953],
              [44.2100115, 39.0196929],
              [44.208794, 39.0193678],
              [44.2061875, 39.018148],
              [44.2051481, 39.0178843],
              [44.203223, 39.0172486],
              [44.2004906, 39.0157505],
              [44.19943, 39.014823],
              [44.1985774, 39.0137725],
              [44.1978729, 39.0130833],
              [44.1970161, 39.0126871],
              [44.1957562, 39.0118317],
              [44.1947608, 39.0115134],
              [44.1945966, 39.0112567],
              [44.1944662, 39.0107041],
              [44.1942286, 39.0105454],
              [44.1937264, 39.0104946],
              [44.193139, 39.0102156],
              [44.1916459, 39.0091419],
              [44.1910781, 39.0090057],
              [44.1901913, 39.0091987],
              [44.1901328, 39.0095026],
              [44.1898226, 39.0097556],
              [44.1893025, 39.0108889],
              [44.1891191, 39.0110355],
              [44.1879832, 39.0110979],
              [44.1873039, 39.0113926],
              [44.186851, 39.0114129],
              [44.1862031, 39.0112672],
              [44.185072, 39.0108599],
              [44.1843614, 39.0107303],
              [44.1829909, 39.0106658],
              [44.1824846, 39.010703],
              [44.1815927, 39.0109798],
              [44.181272, 39.0108658],
              [44.1809525, 39.0106834],
              [44.1800391, 39.009926],
              [44.179665, 39.0094084],
              [44.1795107, 39.0089795],
              [44.1794396, 39.0082723],
              [44.1792861, 39.0078903],
              [44.1781035, 39.0070263],
              [44.1772395, 39.0060651],
              [44.1770053, 39.0056597],
              [44.1768385, 39.0051332],
              [44.1768717, 39.0046545],
              [44.1768015, 39.003228],
              [44.1762338, 39.0021681],
              [44.1761208, 39.0018263],
              [44.175487, 39.0011846],
              [44.1747694, 39.0010575],
              [44.1742011, 39.0007269],
              [44.1739031, 39.0004969],
              [44.1736556, 39.0003331],
              [44.1736207, 39.0002011],
              [44.1741738, 38.9991675],
              [44.1741362, 38.9983623],
              [44.1737483, 38.9968613],
              [44.1733294, 38.9960073],
              [44.1730994, 38.9953163],
              [44.1730024, 38.9941503],
              [44.1725333, 38.9935534],
              [44.1719972, 38.9927191],
              [44.1718729, 38.9924328],
              [44.1717941, 38.9917907],
              [44.1721002, 38.9903355],
              [44.1728348, 38.9886241],
              [44.1730001, 38.9882801],
              [44.1762161, 38.9868205],
              [44.176678, 38.9865402],
              [44.1778231, 38.9861555],
              [44.1782757, 38.9859497],
              [44.1807623, 38.9853985],
              [44.1817918, 38.9844098],
              [44.182797, 38.9837529],
              [44.1840404, 38.9827779],
              [44.1849221, 38.9821818],
              [44.1861884, 38.9817765],
              [44.1874231, 38.9817299],
              [44.1890422, 38.9818656],
              [44.1894753, 38.9816243],
              [44.1895388, 38.9812786],
              [44.1893782, 38.9800903],
              [44.1892145, 38.979496],
              [44.1889406, 38.9792897],
              [44.1877311, 38.9787631],
              [44.1873808, 38.9785105],
              [44.1872779, 38.9782064],
              [44.1873353, 38.9778634],
              [44.1877663, 38.9771699],
              [44.1882104, 38.9766092],
              [44.1890386, 38.976266],
              [44.1910991, 38.9752114],
              [44.1914252, 38.9746819],
              [44.1909814, 38.9744678],
              [44.1885147, 38.9742373],
              [44.1878474, 38.9731248],
              [44.1864425, 38.971967],
              [44.1862685, 38.9702417],
              [44.1865059, 38.9698253],
              [44.1887439, 38.9686624],
              [44.1889869, 38.9676089],
              [44.1884975, 38.9668407],
              [44.1872961, 38.9665108],
              [44.1854768, 38.9663676],
              [44.1849596, 38.9659894],
              [44.1847641, 38.96557],
              [44.1844486, 38.9646308],
              [44.182295, 38.9616407],
              [44.1818091, 38.9570916],
              [44.1841169, 38.9555609],
              [44.1845487, 38.9553695],
              [44.1853354, 38.9548929],
              [44.1874085, 38.9534927],
              [44.1895414, 38.9521809],
              [44.1912639, 38.9515689],
              [44.19191, 38.9512949],
              [44.1933467, 38.9509836],
              [44.1956739, 38.951018],
              [44.1968674, 38.9506957],
              [44.1981442, 38.9502913],
              [44.1996691, 38.9496575],
              [44.2002417, 38.9480087],
              [44.2002792, 38.9473873],
              [44.2000902, 38.9467806],
              [44.1993486, 38.9453984],
              [44.1988192, 38.9442081],
              [44.1984182, 38.94356],
              [44.1973567, 38.9421479],
              [44.1966548, 38.9410995],
              [44.1945237, 38.938773],
              [44.1926875, 38.9361972],
              [44.1924717, 38.9324467],
              [44.1953817, 38.9310282],
              [44.1957626, 38.9307797],
              [44.1965527, 38.9299901],
              [44.1967349, 38.9289873],
              [44.1969351, 38.9260923],
              [44.1977222, 38.924276],
              [44.1983052, 38.9232613],
              [44.1996955, 38.9218636],
              [44.2010796, 38.9218683],
              [44.2023022, 38.9219937],
              [44.20404, 38.9219987],
              [44.2093973, 38.9216214],
              [44.2099582, 38.9214533],
              [44.2115488, 38.9209541],
              [44.2127441, 38.9208123],
              [44.2138758, 38.9207128],
              [44.2148684, 38.9203081],
              [44.2170512, 38.9186621],
              [44.2180291, 38.9173369],
              [44.2185329, 38.9167013],
              [44.2192992, 38.9150764],
              [44.219376, 38.9142675],
              [44.219719, 38.9126502],
              [44.2196755, 38.9107199],
              [44.2198973, 38.9097158],
              [44.2200951, 38.9091935],
              [44.2201522, 38.9079048],
              [44.2197805, 38.9061857],
              [44.2200023, 38.905217],
              [44.2201401, 38.9048181],
              [44.2202136, 38.9046055],
              [44.2202203, 38.9042982],
              [44.2199803, 38.9039877],
              [44.219445, 38.9036525],
              [44.2189521, 38.9035674],
              [44.2180071, 38.9035906],
              [44.2173816, 38.9036973],
              [44.2169077, 38.9036709],
              [44.216515, 38.9035116],
              [44.2156619, 38.902824],
              [44.2143108, 38.9019795],
              [44.2134155, 38.9013261],
              [44.2129819, 38.9009005],
              [44.2119432, 38.8988855],
              [44.2115458, 38.8983663],
              [44.2101228, 38.8979001],
              [44.2099638, 38.8974454],
              [44.2104571, 38.896205],
              [44.2106478, 38.894357],
              [44.2106525, 38.8927167],
              [44.2113518, 38.8905571],
              [44.2114822, 38.8903453],
              [44.2116514, 38.8902038],
              [44.2132017, 38.889227],
              [44.2141446, 38.8884546],
              [44.2147102, 38.8881455],
              [44.2167112, 38.8874562],
              [44.2171567, 38.8872162],
              [44.2185623, 38.8856917],
              [44.2192696, 38.8851026],
              [44.2203916, 38.8847901],
              [44.2229232, 38.8843728],
              [44.2242734, 38.8839488],
              [44.2266853, 38.8830518],
              [44.2309135, 38.8811148],
              [44.2346431, 38.8786647],
              [44.2350453, 38.8764147],
              [44.2391948, 38.873279],
              [44.2398948, 38.872287],
              [44.2415177, 38.8713756],
              [44.2449592, 38.8706682],
              [44.2454553, 38.8702175],
              [44.2454873, 38.8685471],
              [44.245697, 38.8676321],
              [44.2456152, 38.8666616],
              [44.244399, 38.8658826],
              [44.2439535, 38.8655447],
              [44.2438167, 38.8652556],
              [44.2438606, 38.8614481],
              [44.2436893, 38.8609583],
              [44.242501, 38.8592764],
              [44.2410992, 38.8584455],
              [44.2412221, 38.8565282],
              [44.2422768, 38.8560312],
              [44.2434439, 38.855162],
              [44.2444919, 38.8535087],
              [44.2444802, 38.85302],
              [44.2444598, 38.8522765],
              [44.2446602, 38.8520225],
              [44.2452578, 38.8516647],
              [44.2454589, 38.8509687],
              [44.245308, 38.8506821],
              [44.2460033, 38.8504524],
              [44.2462891, 38.85019],
              [44.2470371, 38.8501001],
              [44.2487075, 38.8498222],
              [44.2512321, 38.8495836],
              [44.2532361, 38.8491945],
              [44.2544356, 38.8488171],
              [44.2565349, 38.8475485],
              [44.2569929, 38.8469492],
              [44.2577238, 38.8475184],
              [44.257982, 38.8480687],
              [44.2594964, 38.8485236],
              [44.2600002, 38.8487953],
              [44.2603554, 38.8493759],
              [44.2608109, 38.8496584],
              [44.2623943, 38.8501374],
              [44.2632924, 38.850352],
              [44.2641362, 38.8508222],
              [44.2649514, 38.8511751],
              [44.2657878, 38.8516198],
              [44.2660885, 38.8518543],
              [44.2662876, 38.8523303],
              [44.2666064, 38.8527613],
              [44.2674907, 38.8526643],
              [44.2686435, 38.852958],
              [44.2699797, 38.8533515],
              [44.2709943, 38.8536574],
              [44.2722758, 38.8538734],
              [44.2739658, 38.8539331],
              [44.2749056, 38.8542528],
              [44.2753975, 38.854341],
              [44.2765117, 38.8541961],
              [44.27748, 38.8542313],
              [44.2786628, 38.8531549],
              [44.281026, 38.8512857],
              [44.2815542, 38.8504902],
              [44.2816993, 38.8498564],
              [44.2816988, 38.8488988],
              [44.2820406, 38.847847],
              [44.2837455, 38.8475139],
              [44.2844038, 38.8473369],
              [44.2849512, 38.8468926],
              [44.2862926, 38.8460529],
              [44.2868992, 38.8458267],
              [44.2876054, 38.8457421],
              [44.2882804, 38.8457432],
              [44.2891474, 38.8456123],
              [44.289747, 38.8454494],
              [44.291589, 38.843796],
              [44.2926351, 38.8429759],
              [44.293602, 38.842385],
              [44.2948541, 38.8417642],
              [44.2964366, 38.8410655],
              [44.2978981, 38.8408179],
              [44.2992449, 38.8408563],
              [44.3009879, 38.8408017],
              [44.3010599, 38.8401903],
              [44.3006363, 38.8385914],
              [44.3007126, 38.8375979],
              [44.3006871, 38.836599],
              [44.3004488, 38.835752],
              [44.2990879, 38.8343588],
              [44.2985366, 38.8336566],
              [44.2979582, 38.8322537],
              [44.2975701, 38.830688],
              [44.2972198, 38.8300177],
              [44.2959282, 38.8284072],
              [44.2950267, 38.8263251],
              [44.295117, 38.8261872],
              [44.2956679, 38.8257862],
              [44.2964147, 38.8253713],
              [44.2978901, 38.825054],
              [44.2995527, 38.8247646],
              [44.3010449, 38.8246096],
              [44.3018182, 38.8243803],
              [44.3021981, 38.8241669],
              [44.3027065, 38.8234074],
              [44.3036475, 38.8224003],
              [44.3050466, 38.8202628],
              [44.3052164, 38.8197308],
              [44.3052544, 38.8192427],
              [44.3051065, 38.8188621],
              [44.3050447, 38.8184524],
              [44.3051497, 38.8181016],
              [44.3054385, 38.8176672],
              [44.3057132, 38.8170975],
              [44.305971, 38.8162993],
              [44.3060656, 38.815769],
              [44.3065703, 38.8157095],
              [44.3082452, 38.8150732],
              [44.3090701, 38.8145472],
              [44.3095398, 38.8139944],
              [44.3103935, 38.8124312],
              [44.3107359, 38.8119735],
              [44.3110665, 38.8117128],
              [44.3116114, 38.8114514],
              [44.3122944, 38.8112215],
              [44.3126815, 38.810963],
              [44.313285, 38.8103701],
              [44.3135464, 38.8102486],
              [44.3137127, 38.8100612],
              [44.313801, 38.8096948],
              [44.3140179, 38.8093789],
              [44.3146009, 38.8090117],
              [44.3148195, 38.8087951],
              [44.3149064, 38.8081674],
              [44.3148334, 38.8078062],
              [44.3148364, 38.8072531],
              [44.314744, 38.8069272],
              [44.3144191, 38.8064888],
              [44.3131811, 38.8060413],
              [44.3125219, 38.8056638],
              [44.3119992, 38.8052876],
              [44.3114596, 38.8051366],
              [44.3105604, 38.8049888],
              [44.309804, 38.8047042],
              [44.3090929, 38.8046125],
              [44.3080114, 38.8046408],
              [44.3068125, 38.8044814],
              [44.3060474, 38.804479],
              [44.305316, 38.8042854],
              [44.3044856, 38.8039627],
              [44.3038549, 38.8035527],
              [44.3031487, 38.8029532],
              [44.3028097, 38.8025243],
              [44.3025635, 38.8019701],
              [44.3023881, 38.8010228],
              [44.3020914, 38.7999185],
              [44.3017238, 38.799185],
              [44.3012479, 38.7987486],
              [44.3009266, 38.7981471],
              [44.3008777, 38.797729],
              [44.3006589, 38.7971796],
              [44.3005255, 38.7964688],
              [44.3002836, 38.7951806],
              [44.3004325, 38.7946407],
              [44.3008292, 38.7942099],
              [44.300885, 38.7938123],
              [44.3004436, 38.7929208],
              [44.3003479, 38.7918953],
              [44.300227, 38.7914997],
              [44.2981214, 38.7904293],
              [44.2964118, 38.7896453],
              [44.295213, 38.7889711],
              [44.292061, 38.7870484],
              [44.2912021, 38.7865966],
              [44.2895815, 38.7862416],
              [44.2888377, 38.7859756],
              [44.288589, 38.7856685],
              [44.2883093, 38.7844709],
              [44.2880812, 38.7841194],
              [44.2875568, 38.7837134],
              [44.2864982, 38.7831041],
              [44.2863273, 38.7826676],
              [44.2865082, 38.7819833],
              [44.2870666, 38.7813793],
              [44.2881707, 38.7806758],
              [44.288723, 38.7804832],
              [44.2895335, 38.7803676],
              [44.2897906, 38.7800851],
              [44.2899882, 38.779509],
              [44.2904322, 38.7774493],
              [44.2905331, 38.7770681],
              [44.2911488, 38.7757139],
              [44.2912251, 38.7752872],
              [44.2913361, 38.7749852],
              [44.2910732, 38.7740932],
              [44.2893509, 38.7726088],
              [44.2890539, 38.7721329],
              [44.2890161, 38.7717856],
              [44.2893737, 38.770405],
              [44.2901314, 38.7691662],
              [44.2904137, 38.7688526],
              [44.2913539, 38.7683214],
              [44.2919855, 38.7678146],
              [44.2921263, 38.7675619],
              [44.2922324, 38.7664823],
              [44.292412, 38.7657025],
              [44.2925042, 38.7648625],
              [44.292505, 38.7641949],
              [44.2923957, 38.763867],
              [44.2921765, 38.7636949],
              [44.2916074, 38.7633914],
              [44.2912749, 38.7631162],
              [44.2909923, 38.7627261],
              [44.2900124, 38.7601913],
              [44.2876757, 38.7575641],
              [44.2875206, 38.7571729],
              [44.2875614, 38.7568154],
              [44.2877764, 38.7562481],
              [44.2877433, 38.7557511],
              [44.2863845, 38.7525111],
              [44.2861278, 38.7522789],
              [44.2849494, 38.7517325],
              [44.2835794, 38.750906],
              [44.2831046, 38.7504624],
              [44.2821654, 38.7494343],
              [44.2821269, 38.7493867],
              [44.2814337, 38.7485297],
              [44.2802051, 38.7475481],
              [44.2790188, 38.7472522],
              [44.278833, 38.7472059],
              [44.2778971, 38.7468697],
              [44.2773726, 38.7464973],
              [44.277137, 38.7461335],
              [44.2770461, 38.7457035],
              [44.2773065, 38.744738],
              [44.2771889, 38.744025],
              [44.2765516, 38.7426255],
              [44.2766691, 38.7419546],
              [44.2769369, 38.7410518],
              [44.2785385, 38.7375707],
              [44.2788969, 38.7372276],
              [44.2793595, 38.736985],
              [44.2802244, 38.7366843],
              [44.2808395, 38.7364176],
              [44.2810098, 38.7360556],
              [44.2810187, 38.7356963],
              [44.2808884, 38.7347366],
              [44.2806224, 38.7337757],
              [44.2801473, 38.7329247],
              [44.2796744, 38.7324079],
              [44.2790352, 38.7319274],
              [44.2781933, 38.7310761],
              [44.2761536, 38.729443],
              [44.275859, 38.7293616],
              [44.2755318, 38.7293623],
              [44.2743149, 38.7296477],
              [44.2738573, 38.7295802],
              [44.2736591, 38.7294056],
              [44.2736529, 38.7291116],
              [44.2739169, 38.7285168],
              [44.2743582, 38.7270999],
              [44.2742036, 38.726712],
              [44.2736689, 38.7261773],
              [44.2731673, 38.7259034],
              [44.272387, 38.7257309],
              [44.2713997, 38.7256116],
              [44.2699011, 38.7256065],
              [44.2694928, 38.7254647],
              [44.2691577, 38.7250199],
              [44.269088, 38.7245264],
              [44.2695055, 38.7230564],
              [44.2694443, 38.7221868],
              [44.2691983, 38.7220303],
              [44.2691063, 38.7219717],
              [44.2690033, 38.7219643],
              [44.2685734, 38.7219336],
              [44.2684585, 38.7219373],
              [44.2662909, 38.7220067],
              [44.2653479, 38.72198],
              [44.2644978, 38.721776],
              [44.2641643, 38.7210598],
              [44.2640145, 38.7202515],
              [44.263536, 38.7193339],
              [44.2633298, 38.7191828],
              [44.2630145, 38.7191822],
              [44.2602471, 38.71945],
              [44.2584518, 38.7197853],
              [44.257486, 38.7198966],
              [44.2571758, 38.7199323],
              [44.25612, 38.7198635],
              [44.2550123, 38.719547],
              [44.2542973, 38.7190364],
              [44.2540673, 38.718334],
              [44.2541815, 38.717862],
              [44.2546244, 38.7174384],
              [44.2573559, 38.7165893],
              [44.2590046, 38.7159239],
              [44.2601131, 38.7153376],
              [44.2608988, 38.7147018],
              [44.2610128, 38.7141768],
              [44.2608694, 38.7127633],
              [44.2611547, 38.7113503],
              [44.2609856, 38.7105746],
              [44.2610629, 38.7100623],
              [44.2613509, 38.7094249],
              [44.2612575, 38.7085299],
              [44.2608713, 38.7076127],
              [44.2607008, 38.7062521],
              [44.2607687, 38.7052874],
              [44.2612371, 38.7041787],
              [44.262236, 38.7036269],
              [44.2628406, 38.7036289],
              [44.2644143, 38.7041072],
              [44.2649807, 38.7046086],
              [44.2655482, 38.704888],
              [44.2661524, 38.7049733],
              [44.2677889, 38.7048953],
              [44.268537, 38.7046757],
              [44.2691431, 38.7044001],
              [44.2698578, 38.7037641],
              [44.2714288, 38.7026035],
              [44.2713234, 38.7022998],
              [44.2710415, 38.7017993],
              [44.2705121, 38.7011018],
              [44.2694599, 38.6991673],
              [44.269405, 38.6972487],
              [44.2694747, 38.6962886],
              [44.2700711, 38.6955262],
              [44.2702772, 38.6945932],
              [44.2705385, 38.6939582],
              [44.2709855, 38.6933987],
              [44.2716891, 38.6926273],
              [44.2723856, 38.6919685],
              [44.2732609, 38.6909351],
              [44.2735923, 38.6899112],
              [44.2735778, 38.6888485],
              [44.2733774, 38.6883203],
              [44.2730911, 38.6879344],
              [44.2726047, 38.6864975],
              [44.2721293, 38.6858304],
              [44.2718749, 38.6852133],
              [44.2718366, 38.684796],
              [44.2720576, 38.6844525],
              [44.27344, 38.6830338],
              [44.27534, 38.6809697],
              [44.2763587, 38.6802816],
              [44.2769303, 38.6799907],
              [44.2777149, 38.6797867],
              [44.2780647, 38.6795644],
              [44.2787017, 38.6784823],
              [44.2796493, 38.6777934],
              [44.2800466, 38.6772939],
              [44.2804441, 38.6770175],
              [44.2810412, 38.6768091],
              [44.2818448, 38.6763152],
              [44.2823972, 38.6756679],
              [44.2826414, 38.674969],
              [44.2825959, 38.6742417],
              [44.2823208, 38.6735542],
              [44.2812189, 38.6726287],
              [44.2808055, 38.6712907],
              [44.280102, 38.6696232],
              [44.2799304, 38.6689078],
              [44.2798984, 38.6680304],
              [44.2799923, 38.6673009],
              [44.2802388, 38.6667609],
              [44.2808851, 38.6656957],
              [44.2813893, 38.6644736],
              [44.281571, 38.6630314],
              [44.2815212, 38.662423],
              [44.2809587, 38.6614141],
              [44.2796018, 38.6602245],
              [44.2794013, 38.659589],
              [44.2794899, 38.6586204],
              [44.2794604, 38.6576283],
              [44.2792605, 38.6571906],
              [44.2786284, 38.6566781],
              [44.2778307, 38.6563344],
              [44.2764993, 38.6559867],
              [44.2751083, 38.6556918],
              [44.2735252, 38.655561],
              [44.2728633, 38.6554093],
              [44.2723502, 38.6549666],
              [44.271532, 38.6538061],
              [44.2704646, 38.6527097],
              [44.2696033, 38.6514239],
              [44.2693126, 38.6508529],
              [44.2694442, 38.6502709],
              [44.2697285, 38.6499034],
              [44.2702803, 38.6495536],
              [44.2708747, 38.6490196],
              [44.2713017, 38.6482502],
              [44.271718, 38.6470127],
              [44.2721185, 38.6462477],
              [44.2726619, 38.6456616],
              [44.2738091, 38.645216],
              [44.275132, 38.6448415],
              [44.2762633, 38.6442395],
              [44.27748, 38.6434549],
              [44.279193, 38.6426918],
              [44.2814012, 38.6415394],
              [44.2828636, 38.6410991],
              [44.2837038, 38.6411226],
              [44.2843093, 38.6412307],
              [44.2848211, 38.6412298],
              [44.2857321, 38.6410083],
              [44.2866549, 38.6405856],
              [44.2875651, 38.6402637],
              [44.287971, 38.6402135],
              [44.2901246, 38.6404942],
              [44.2910979, 38.6404941],
              [44.2917493, 38.6403397],
              [44.292382, 38.6399024],
              [44.2933494, 38.6389002],
              [44.2940001, 38.6386411],
              [44.294876, 38.6384774],
              [44.2965255, 38.6383456],
              [44.2995814, 38.6376557],
              [44.3007997, 38.6375322],
              [44.3014567, 38.6375176],
              [44.3022611, 38.6373569],
              [44.3030827, 38.6370591],
              [44.3035905, 38.6367158],
              [44.3040796, 38.6365562],
              [44.3055481, 38.6363212],
              [44.3068138, 38.6357953],
              [44.3076794, 38.6352607],
              [44.3083244, 38.6345882],
              [44.3110385, 38.6326041],
              [44.3115894, 38.6316952],
              [44.3116618, 38.6313199],
              [44.3116631, 38.6306852],
              [44.3117843, 38.6303083],
              [44.3120286, 38.6301056],
              [44.3141196, 38.6290823],
              [44.3153059, 38.6285718],
              [44.3162115, 38.6280591],
              [44.3173382, 38.6276469],
              [44.3179752, 38.6271477],
              [44.3190295, 38.6258675],
              [44.3194135, 38.6255807],
              [44.3203711, 38.6251457],
              [44.3212691, 38.6246416],
              [44.3216199, 38.6240924],
              [44.3215893, 38.6234072],
              [44.3214592, 38.6226609],
              [44.320861, 38.6203177],
              [44.3205587, 38.6195064],
              [44.3205551, 38.6189994],
              [44.3219792, 38.6158773],
              [44.3219152, 38.6150707],
              [44.3216313, 38.6136352],
              [44.3216404, 38.6130756],
              [44.3219572, 38.612411],
              [44.3222211, 38.6116448],
              [44.3223763, 38.6108867],
              [44.3223866, 38.6102648],
              [44.3222742, 38.6095996],
              [44.3221658, 38.6092261],
              [44.3219364, 38.609071],
              [44.321603, 38.6089293],
              [44.3213481, 38.6084581],
              [44.3209434, 38.608272],
              [44.3197273, 38.6079683],
              [44.3186565, 38.6078673],
              [44.318083, 38.6075724],
              [44.317093, 38.6071526],
              [44.3167174, 38.6068434],
              [44.3167799, 38.6063337],
              [44.3170379, 38.6060586],
              [44.3183198, 38.6056265],
              [44.3190225, 38.6051767],
              [44.3193612, 38.6049039],
              [44.3195183, 38.604604],
              [44.3199239, 38.6034864],
              [44.32013, 38.6022919],
              [44.3203894, 38.6017236],
              [44.320678, 38.6008058],
              [44.3206728, 38.600584],
              [44.3201443, 38.6000133],
              [44.3198275, 38.5998378],
              [44.3180105, 38.5991695],
              [44.3177041, 38.5989796],
              [44.3176394, 38.5986565],
              [44.3178564, 38.5980969],
              [44.3183819, 38.5976534],
              [44.3187829, 38.5971767],
              [44.3190573, 38.5965141],
              [44.3197442, 38.5955475],
              [44.3204695, 38.5946943],
              [44.3208947, 38.5943403],
              [44.3216065, 38.5940576],
              [44.321783, 38.5937353],
              [44.321764, 38.5932217],
              [44.321545, 38.592373],
              [44.3216883, 38.5918193],
              [44.3227998, 38.5893048],
              [44.3228019, 38.5887594],
              [44.3226985, 38.5884244],
              [44.322334, 38.5879951],
              [44.3219677, 38.5874098],
              [44.3216019, 38.5864779],
              [44.3215424, 38.5861207],
              [44.3215816, 38.5857076],
              [44.3218736, 38.5852499],
              [44.3239682, 38.5832001],
              [44.324314, 38.5827597],
              [44.3245993, 38.5820946],
              [44.3247698, 38.5806259],
              [44.3245308, 38.5789412],
              [44.3246257, 38.578436],
              [44.3249444, 38.5778961],
              [44.3249447, 38.5774874],
              [44.3246561, 38.5770861],
              [44.3239031, 38.5765993],
              [44.3231793, 38.5763237],
              [44.3215978, 38.5754546],
              [44.3200776, 38.5748942],
              [44.3182921, 38.5745842],
              [44.3174009, 38.5743174],
              [44.3172026, 38.5740492],
              [44.3168942, 38.5720846],
              [44.3168503, 38.5702327],
              [44.3164673, 38.5687408],
              [44.3162482, 38.5680649],
              [44.3159134, 38.567348],
              [44.315384, 38.5654119],
              [44.315083, 38.5648588],
              [44.3143392, 38.5643742],
              [44.3141184, 38.5640294],
              [44.3138551, 38.5634078],
              [44.3132359, 38.5627539],
              [44.3127907, 38.5617214],
              [44.3128133, 38.5613494],
              [44.3130792, 38.5600684],
              [44.3131218, 38.5591386],
              [44.31337, 38.5584966],
              [44.3134259, 38.5578968],
              [44.3132484, 38.5567123],
              [44.3132985, 38.5556979],
              [44.3134431, 38.5551454],
              [44.3137494, 38.5544686],
              [44.3143035, 38.5537369],
              [44.3154513, 38.5527822],
              [44.3160884, 38.552356],
              [44.3164082, 38.5520559],
              [44.3164848, 38.5518624],
              [44.3162114, 38.5508666],
              [44.3163104, 38.5496904],
              [44.3163089, 38.5490348],
              [44.3162426, 38.5485128],
              [44.316112, 38.5480827],
              [44.315888, 38.5478594],
              [44.315654, 38.547723],
              [44.3151953, 38.5476286],
              [44.3145575, 38.5470964],
              [44.3141079, 38.5469764],
              [44.3136299, 38.5467237],
              [44.3132509, 38.5463209],
              [44.3130959, 38.5458356],
              [44.3131809, 38.5453218],
              [44.3133611, 38.5449984],
              [44.3133549, 38.5435264],
              [44.3134858, 38.5422059],
              [44.3132701, 38.5413209],
              [44.3130195, 38.5390451],
              [44.3127776, 38.5387556],
              [44.3124711, 38.5385583],
              [44.3110292, 38.5379121],
              [44.310719, 38.5376653],
              [44.3103947, 38.537234],
              [44.3101264, 38.5365475],
              [44.31014, 38.5361234],
              [44.3102254, 38.5357842],
              [44.3107101, 38.5350089],
              [44.3107522, 38.5346128],
              [44.3105618, 38.5337761],
              [44.3105952, 38.533349],
              [44.3107437, 38.5328029],
              [44.310551, 38.5322573],
              [44.3102589, 38.5316976],
              [44.309438, 38.5308463],
              [44.3093356, 38.5302464],
              [44.3094593, 38.5297395],
              [44.3098237, 38.5291676],
              [44.310283, 38.52876],
              [44.3105461, 38.5282945],
              [44.3105068, 38.5279462],
              [44.3103341, 38.5273699],
              [44.3103862, 38.5269365],
              [44.3110135, 38.5261563],
              [44.3114172, 38.5254845],
              [44.3116312, 38.5252749],
              [44.3117798, 38.5249655],
              [44.3118888, 38.5246196],
              [44.3117946, 38.5241445],
              [44.3118443, 38.5238677],
              [44.311993, 38.5236519],
              [44.312888, 38.523301],
              [44.3132055, 38.522954],
              [44.3132655, 38.5222895],
              [44.3130249, 38.5219924],
              [44.3128332, 38.5218557],
              [44.3127705, 38.5216079],
              [44.3131645, 38.5199427],
              [44.313692, 38.5197384],
              [44.3140478, 38.5193181],
              [44.3145727, 38.5189344],
              [44.3147281, 38.5186098],
              [44.3148075, 38.5180804],
              [44.3145354, 38.5170444],
              [44.3141987, 38.5166823],
              [44.3134628, 38.5161385],
              [44.3133273, 38.5155001],
              [44.3133674, 38.5150921],
              [44.3136685, 38.5147926],
              [44.3141283, 38.5145741],
              [44.3148592, 38.5144737],
              [44.3158895, 38.5144033],
              [44.3166672, 38.5142737],
              [44.3173623, 38.5137995],
              [44.3178233, 38.5133099],
              [44.3183225, 38.5126739],
              [44.3185551, 38.5125185],
              [44.319451, 38.5125918],
              [44.3197075, 38.5125041],
              [44.3198513, 38.5123454],
              [44.3198158, 38.5118797],
              [44.320259, 38.511603],
              [44.32073, 38.5111917],
              [44.3209896, 38.5105845],
              [44.3215039, 38.5096297],
              [44.3210833, 38.5090374],
              [44.3209848, 38.5082294],
              [44.3210408, 38.5077907],
              [44.3215096, 38.5065831],
              [44.3222208, 38.5052454],
              [44.3224173, 38.5046696],
              [44.3235701, 38.5038919],
              [44.3246682, 38.5032881],
              [44.3254938, 38.5023992],
              [44.3254601, 38.502081],
              [44.3238756, 38.4993821],
              [44.3232955, 38.4988204],
              [44.3220346, 38.4983883],
              [44.3214799, 38.4979622],
              [44.3210497, 38.497534],
              [44.3199259, 38.4967157],
              [44.3198756, 38.4961887],
              [44.3197807, 38.4948202],
              [44.3197839, 38.4942379],
              [44.3198887, 38.4935562],
              [44.3198002, 38.4930906],
              [44.319511, 38.4925715],
              [44.3194615, 38.4915576],
              [44.3202088, 38.491232],
              [44.3212894, 38.4898602],
              [44.3215533, 38.4896245],
              [44.3220562, 38.489375],
              [44.3221616, 38.489227],
              [44.3220706, 38.4886145],
              [44.3220779, 38.4882334],
              [44.3222347, 38.4877558],
              [44.3227138, 38.487393],
              [44.3227766, 38.4869877],
              [44.3227599, 38.4862676],
              [44.3229719, 38.4856901],
              [44.3228613, 38.484784],
              [44.3226599, 38.4845163],
              [44.3223752, 38.4843696],
              [44.3227351, 38.4838943],
              [44.3227118, 38.4836828],
              [44.3226179, 38.4835879],
              [44.322599, 38.4833364],
              [44.3226619, 38.4831586],
              [44.3222499, 38.4826805],
              [44.3221042, 38.4826844],
              [44.3219729, 38.482598],
              [44.3209257, 38.4826581],
              [44.3203308, 38.4828057],
              [44.3197483, 38.482416],
              [44.3193512, 38.4823315],
              [44.3191268, 38.4818533],
              [44.318979, 38.4817191],
              [44.3185389, 38.4815456],
              [44.3183569, 38.4816177],
              [44.3182168, 38.4814397],
              [44.3181927, 38.481303],
              [44.3180147, 38.481001],
              [44.3174252, 38.4808351],
              [44.3173837, 38.4807535],
              [44.317419, 38.4805613],
              [44.3169489, 38.4803185],
              [44.3167936, 38.4801359],
              [44.3163621, 38.4798801],
              [44.3155445, 38.4796637],
              [44.3154368, 38.4794523],
              [44.315025, 38.4793717],
              [44.3145958, 38.4791845],
              [44.3140558, 38.4790272],
              [44.3139389, 38.4788657],
              [44.3136743, 38.4787262],
              [44.3136001, 38.4783439],
              [44.3128928, 38.4773845],
              [44.3126338, 38.477191],
              [44.3125344, 38.4770317],
              [44.3118914, 38.4764164],
              [44.3116946, 38.4763474],
              [44.3116809, 38.476249],
              [44.3118614, 38.4760248],
              [44.3118935, 38.4758915],
              [44.3116054, 38.4755621],
              [44.3119001, 38.475044],
              [44.3120559, 38.4743272],
              [44.3121717, 38.4741616],
              [44.3129197, 38.4735873],
              [44.3129876, 38.4732732],
              [44.3132566, 38.4728691],
              [44.3132768, 38.4704955],
              [44.3137076, 38.4661324],
              [44.3137012, 38.465112],
              [44.3132591, 38.4633165],
              [44.312498, 38.4617894],
              [44.3110492, 38.4604235],
              [44.3098754, 38.4589535],
              [44.3094456, 38.4576972],
              [44.3093162, 38.4568603],
              [44.3093265, 38.4563487],
              [44.3096528, 38.4555025],
              [44.309709, 38.4546617],
              [44.3092785, 38.4528362],
              [44.3090813, 38.4525633],
              [44.3088446, 38.4515677],
              [44.3088961, 38.4508763],
              [44.3084394, 38.4506894],
              [44.3071549, 38.4503714],
              [44.3052173, 38.449457],
              [44.304007, 38.4486066],
              [44.3025095, 38.4477692],
              [44.3019383, 38.4472285],
              [44.3023455, 38.4466951],
              [44.303337, 38.4453385],
              [44.3040643, 38.4442622],
              [44.3046567, 38.4436308],
              [44.305058, 38.4433225],
              [44.305141, 38.4430961],
              [44.3049184, 38.4417378],
              [44.3050332, 38.4412996],
              [44.3052696, 38.4409624],
              [44.3057701, 38.4407426],
              [44.3064326, 38.4405302],
              [44.3072331, 38.4400478],
              [44.3079988, 38.4396841],
              [44.3086543, 38.4392043],
              [44.308945, 38.4387104],
              [44.309164, 38.437974],
              [44.3095437, 38.4374529],
              [44.3098686, 38.4373098],
              [44.3102483, 38.4372982],
              [44.3109874, 38.4374514],
              [44.3113087, 38.4374294],
              [44.3120059, 38.4370607],
              [44.3124972, 38.4367389],
              [44.3126864, 38.4363624],
              [44.3126338, 38.4350199],
              [44.3127962, 38.4346317],
              [44.3130602, 38.4343058],
              [44.3137208, 38.4341283],
              [44.3146401, 38.4339716],
              [44.3155926, 38.4336522],
              [44.3168777, 38.4330659],
              [44.3172813, 38.4327646],
              [44.3174565, 38.4324044],
              [44.3172767, 38.4305213],
              [44.3168629, 38.4299484],
              [44.3162288, 38.4293968],
              [44.3161017, 38.4290724],
              [44.3161279, 38.4287487],
              [44.3163619, 38.4284548],
              [44.3175833, 38.4273235],
              [44.3177325, 38.4269515],
              [44.3176633, 38.426569],
              [44.3171341, 38.4260438],
              [44.3164992, 38.4252202],
              [44.3163876, 38.4246213],
              [44.3167161, 38.4239944],
              [44.3169398, 38.4233489],
              [44.317044, 38.4221359],
              [44.3170585, 38.4211032],
              [44.3169949, 38.4204855],
              [44.3164491, 38.4198212],
              [44.3160531, 38.4189069],
              [44.3164514, 38.4182788],
              [44.3172717, 38.4179198],
              [44.3178718, 38.4173325],
              [44.3181184, 38.4163786],
              [44.3182808, 38.4150523],
              [44.3181121, 38.4142863],
              [44.3169938, 38.4132401],
              [44.3172296, 38.4124235],
              [44.3173379, 38.411838],
              [44.3189574, 38.4095984],
              [44.319729, 38.408868],
              [44.3198318, 38.4086056],
              [44.3195405, 38.4081167],
              [44.318074, 38.4075837],
              [44.3163675, 38.4066903],
              [44.3148521, 38.4056896],
              [44.3138492, 38.4044728],
              [44.312678, 38.401666],
              [44.3119707, 38.401208],
              [44.3115507, 38.4006484],
              [44.3113815, 38.3998569],
              [44.3114764, 38.3990298],
              [44.3117777, 38.3982826],
              [44.3118091, 38.3978741],
              [44.3116037, 38.3970988],
              [44.3112004, 38.3962517],
              [44.3109697, 38.3954679],
              [44.3107323, 38.3952057],
              [44.3105181, 38.395371],
              [44.3100476, 38.3953451],
              [44.3093316, 38.3953634],
              [44.3084127, 38.3956361],
              [44.307831, 38.3952505],
              [44.3078801, 38.3955897],
              [44.3077029, 38.395807],
              [44.3073592, 38.3958595],
              [44.3070599, 38.3959144],
              [44.3065183, 38.3954691],
              [44.3061045, 38.3956096],
              [44.3059179, 38.3953189],
              [44.3053774, 38.3951788],
              [44.3054436, 38.3949584],
              [44.3048252, 38.3951856],
              [44.3042275, 38.3949734],
              [44.3040432, 38.3945681],
              [44.303205, 38.3947645],
              [44.3030184, 38.3950397],
              [44.3024931, 38.3950564],
              [44.3017656, 38.3947141],
              [44.3009975, 38.3945899],
              [44.3007693, 38.3944565],
              [44.3001128, 38.3945536],
              [44.3000078, 38.3943783],
              [44.299987, 38.3941676],
              [44.300528, 38.3938064],
              [44.3025309, 38.3931483],
              [44.3036725, 38.3925576],
              [44.3050698, 38.3909453],
              [44.3057404, 38.3902719],
              [44.3060091, 38.3895968],
              [44.3066089, 38.3888503],
              [44.3074461, 38.3882149],
              [44.3082416, 38.3872677],
              [44.3086694, 38.3863557],
              [44.3090648, 38.3847212],
              [44.309348, 38.383807],
              [44.3096457, 38.3823876],
              [44.3115921, 38.3814763],
              [44.3114186, 38.380584],
              [44.3119831, 38.3792991],
              [44.3134319, 38.376815],
              [44.3141262, 38.3767604],
              [44.3148022, 38.376633],
              [44.3153159, 38.3758575],
              [44.315836, 38.3751296],
              [44.3163979, 38.3742545],
              [44.3169854, 38.3739935],
              [44.3183729, 38.373522],
              [44.3194361, 38.3728423],
              [44.3205622, 38.3723863],
              [44.3215214, 38.3721953],
              [44.3222422, 38.3718894],
              [44.3228456, 38.3713678],
              [44.3236591, 38.3711874],
              [44.324566, 38.3710606],
              [44.3255982, 38.3707907],
              [44.3274385, 38.370465],
              [44.3277575, 38.3702646],
              [44.3286416, 38.3695409],
              [44.3289214, 38.3693378],
              [44.3300158, 38.369103],
              [44.3305389, 38.3691336],
              [44.3312431, 38.3693051],
              [44.3322828, 38.3693308],
              [44.333179, 38.3692483],
              [44.3341914, 38.3690659],
              [44.3344912, 38.3690658],
              [44.335919, 38.3693763],
              [44.3363554, 38.3698905],
              [44.3368298, 38.3703452],
              [44.3373716, 38.3704502],
              [44.3378945, 38.3704011],
              [44.3381638, 38.3704873],
              [44.3386214, 38.3708946],
              [44.3392645, 38.3712966],
              [44.3400022, 38.3716495],
              [44.341003, 38.3715599],
              [44.3417199, 38.3716098],
              [44.3424523, 38.3718987],
              [44.3436451, 38.371559],
              [44.3460211, 38.3705128],
              [44.3471576, 38.3702603],
              [44.3482475, 38.3701903],
              [44.3490264, 38.3699106],
              [44.3511501, 38.3691678],
              [44.3513842, 38.3696683],
              [44.3519193, 38.3702186],
              [44.3525052, 38.3705947],
              [44.353356, 38.3717397],
              [44.353419, 38.3720894],
              [44.3535841, 38.3722743],
              [44.3551008, 38.3740833],
              [44.3556943, 38.3747547],
              [44.3562654, 38.3750653],
              [44.3577387, 38.3753058],
              [44.3588628, 38.3754019],
              [44.3601799, 38.375426],
              [44.3612645, 38.375354],
              [44.3619279, 38.3752561],
              [44.3625041, 38.3750166],
              [44.3633623, 38.374452],
              [44.363997, 38.3738289],
              [44.3642702, 38.3731],
              [44.3641992, 38.3725439],
              [44.3644014, 38.3717399],
              [44.3646124, 38.3702781],
              [44.3651695, 38.3697709],
              [44.3672481, 38.3687434],
              [44.367852, 38.3687076],
              [44.3685482, 38.3688986],
              [44.3691001, 38.3688773],
              [44.3698242, 38.3680817],
              [44.3699923, 38.367723],
              [44.3703066, 38.3666814],
              [44.3718169, 38.3639941],
              [44.3725372, 38.3629998],
              [44.373577, 38.362004],
              [44.3747839, 38.3606422],
              [44.3756333, 38.3599942],
              [44.3764307, 38.3595315],
              [44.3772491, 38.3592803],
              [44.3780842, 38.3596157],
              [44.3788945, 38.3589078],
              [44.3796451, 38.3585915],
              [44.3806525, 38.3585695],
              [44.3818028, 38.358609],
              [44.3829354, 38.3588826],
              [44.3836993, 38.3591842],
              [44.3846284, 38.3596484],
              [44.3855693, 38.3603125],
              [44.3864508, 38.3613039],
              [44.3877161, 38.362447],
              [44.389871, 38.36365],
              [44.3914775, 38.3643836],
              [44.392027, 38.3645292],
              [44.3934794, 38.3644509],
              [44.3944887, 38.364552],
              [44.3951669, 38.3647206],
              [44.3973657, 38.3660118],
              [44.3983357, 38.3663569],
              [44.399217, 38.3668343],
              [44.3998451, 38.3672677],
              [44.401588, 38.3661616],
              [44.4021581, 38.3659172],
              [44.403043, 38.3658693],
              [44.4042214, 38.3659624],
              [44.4050343, 38.3661361],
              [44.4063422, 38.3664918],
              [44.4072772, 38.3668051],
              [44.4090459, 38.3668189],
              [44.4098131, 38.3670075],
              [44.4104861, 38.3674538],
              [44.4110631, 38.3680131],
              [44.4125903, 38.3688826],
              [44.4134022, 38.3690877],
              [44.4153683, 38.3691309],
              [44.4161169, 38.3691999],
              [44.416887, 38.3695706],
              [44.4172492, 38.3701476],
              [44.4180799, 38.3705365],
              [44.4193284, 38.3708682],
              [44.4212709, 38.371678],
              [44.4227571, 38.3727352],
              [44.4243711, 38.3740737],
              [44.4253609, 38.3745082],
              [44.428045, 38.3751365],
              [44.428678, 38.3753964],
              [44.4294461, 38.3759772],
              [44.4298368, 38.3764023],
              [44.4305297, 38.3770008],
              [44.4314399, 38.3775969],
              [44.432663, 38.3781967],
              [44.4331134, 38.3784893],
              [44.4336603, 38.3787294],
              [44.4341352, 38.3790028],
              [44.4346808, 38.379442],
              [44.4365265, 38.3811109],
              [44.4380326, 38.3823207],
              [44.4395946, 38.3834674],
              [44.4406634, 38.3838748],
              [44.4420445, 38.3842048],
              [44.4435801, 38.384668],
              [44.4466329, 38.3852781],
              [44.4493712, 38.3854921],
              [44.4496203, 38.3850122],
              [44.4498134, 38.3843454],
              [44.4500018, 38.3824915],
              [44.4503712, 38.3810992],
              [44.4511302, 38.3796988],
              [44.4515908, 38.3786345],
              [44.452572, 38.377459],
              [44.4532344, 38.3768331],
              [44.4548674, 38.3757114],
              [44.4558757, 38.3746692],
              [44.4564943, 38.3739132],
              [44.4576932, 38.3725927],
              [44.4579131, 38.3717471],
              [44.4580669, 38.3694104],
              [44.4584359, 38.3690335],
              [44.459556, 38.3687278],
              [44.4603562, 38.367436],
              [44.4611763, 38.3670778],
              [44.4619035, 38.3658759],
              [44.4623217, 38.365729],
              [44.4625568, 38.3653337],
              [44.4626202, 38.3631479],
              [44.4624061, 38.3628775],
              [44.4623496, 38.3597687],
              [44.4627198, 38.3594066],
              [44.463526, 38.3591656],
              [44.4651716, 38.3589717],
              [44.4659713, 38.3589483],
              [44.4666468, 38.3588782],
              [44.4675444, 38.3586655],
              [44.4682083, 38.3583631],
              [44.4706101, 38.3572691],
              [44.4712641, 38.3568848],
              [44.4723974, 38.3557814],
              [44.4727777, 38.3556011],
              [44.4732075, 38.3556854],
              [44.4736656, 38.3558762],
              [44.4740523, 38.3561481],
              [44.4748652, 38.3570114],
              [44.4770569, 38.3576627],
              [44.4777718, 38.3576967],
              [44.4782828, 38.357807],
              [44.4788268, 38.3577917],
              [44.4794123, 38.357665],
              [44.4805189, 38.3577783],
              [44.4814701, 38.3578036],
              [44.4827614, 38.3577718],
              [44.4831453, 38.3578586],
              [44.4837021, 38.3581878],
              [44.4841463, 38.3582818],
              [44.4848575, 38.3583243],
              [44.4854955, 38.3584457],
              [44.4861056, 38.3584348],
              [44.4894193, 38.3580442],
              [44.4904477, 38.3578647],
              [44.4907507, 38.3577049],
              [44.4907308, 38.3568349],
              [44.4906406, 38.3563327],
              [44.490835, 38.3561158],
              [44.4914735, 38.3557668],
              [44.4921672, 38.3551887],
              [44.4926942, 38.3546532],
              [44.4935273, 38.3542222],
              [44.4945318, 38.353824],
              [44.4953573, 38.3533457],
              [44.4968564, 38.3524041],
              [44.4990194, 38.3509064],
              [44.499122, 38.3505319],
              [44.4989073, 38.3500994],
              [44.497546, 38.3494186],
              [44.4961453, 38.3489004],
              [44.4951711, 38.3481536],
              [44.4944962, 38.347817],
              [44.4936303, 38.3475232],
              [44.4933408, 38.3473579],
              [44.4931207, 38.3468695],
              [44.4929634, 38.3463398],
              [44.4929923, 38.3459613],
              [44.4931368, 38.3457028],
              [44.4937497, 38.3451844],
              [44.4946408, 38.3445379],
              [44.4954973, 38.3437118],
              [44.4958274, 38.3435884],
              [44.4961172, 38.3435858],
              [44.4965485, 38.3437398],
              [44.4978202, 38.3444302],
              [44.4980333, 38.3446566],
              [44.4983053, 38.3450655],
              [44.4985218, 38.3455406],
              [44.4988735, 38.3457846],
              [44.4995988, 38.3459215],
              [44.5002093, 38.3459207],
              [44.5010715, 38.3457038],
              [44.5014237, 38.3456725],
              [44.5016767, 38.345703],
              [44.502039, 38.3458715],
              [44.5023973, 38.3458861],
              [44.5034729, 38.3457593],
              [44.5059171, 38.3459226],
              [44.5069312, 38.3460892],
              [44.5073896, 38.3459671],
              [44.5082325, 38.3452138],
              [44.509102, 38.3452284],
              [44.5100577, 38.3451748],
              [44.510353, 38.344748],
              [44.5106841, 38.3432954],
              [44.5110469, 38.3424693],
              [44.5113865, 38.3419904],
              [44.5120597, 38.3414889],
              [44.5125314, 38.3412598],
              [44.5125473, 38.3408754],
              [44.5124748, 38.3404318],
              [44.5122201, 38.339928],
              [44.5117803, 38.339374],
              [44.5112146, 38.3388498],
              [44.5107595, 38.3385951],
              [44.5104524, 38.3384924],
              [44.5103779, 38.3383642],
              [44.5103362, 38.3380644],
              [44.5105855, 38.3360965],
              [44.5105383, 38.3357452],
              [44.5103614, 38.3353408],
              [44.5100034, 38.335215],
              [44.5091448, 38.3350641],
              [44.5082446, 38.3350425],
              [44.5076916, 38.3351188],
              [44.5068144, 38.3349798],
              [44.5061015, 38.3347825],
              [44.5048379, 38.3346488],
              [44.5025948, 38.3347599],
              [44.5020111, 38.3347331],
              [44.5014591, 38.3345664],
              [44.5009901, 38.3343375],
              [44.5007776, 38.3340848],
              [44.5003077, 38.3338803],
              [44.4996474, 38.3338003],
              [44.4975509, 38.3337116],
              [44.4973757, 38.3330915],
              [44.4975881, 38.3321],
              [44.4975772, 38.3317648],
              [44.4974266, 38.3313902],
              [44.4971684, 38.3309813],
              [44.496897, 38.3300796],
              [44.4969863, 38.3295419],
              [44.4971704, 38.3291083],
              [44.4976171, 38.3284247],
              [44.4977352, 38.3280956],
              [44.4977518, 38.3276614],
              [44.4978345, 38.3273291],
              [44.4980729, 38.3270368],
              [44.4981937, 38.3267793],
              [44.4981303, 38.3259403],
              [44.4982001, 38.3257079],
              [44.4990469, 38.3249002],
              [44.4992431, 38.324566],
              [44.499361, 38.3239855],
              [44.4994221, 38.3232448],
              [44.4993425, 38.3225632],
              [44.4991335, 38.3218431],
              [44.4985847, 38.320925],
              [44.4984425, 38.3205971],
              [44.4984122, 38.3201767],
              [44.4983317, 38.3199394],
              [44.4980274, 38.3196191],
              [44.4975725, 38.3192934],
              [44.4972874, 38.3188761],
              [44.4967286, 38.3177447],
              [44.4964674, 38.3175085],
              [44.4964051, 38.3172983],
              [44.497255, 38.3155484],
              [44.4975489, 38.3147254],
              [44.497556, 38.3140911],
              [44.4974443, 38.3133021],
              [44.4975829, 38.3130753],
              [44.4986939, 38.3123287],
              [44.4988858, 38.3119674],
              [44.4988619, 38.3117152],
              [44.4985507, 38.3108585],
              [44.4984118, 38.3101018],
              [44.4984495, 38.3094363],
              [44.4983339, 38.308938],
              [44.4979252, 38.3084855],
              [44.4960293, 38.3068029],
              [44.4956879, 38.3062004],
              [44.4949293, 38.305357],
              [44.4940191, 38.3048746],
              [44.4934891, 38.3044105],
              [44.492951, 38.3036964],
              [44.492569, 38.3034044],
              [44.4915494, 38.3031748],
              [44.4901018, 38.302657],
              [44.4888023, 38.3025808],
              [44.4875907, 38.3026157],
              [44.4861315, 38.3021931],
              [44.485015, 38.3021203],
              [44.4837901, 38.3023173],
              [44.4826478, 38.302177],
              [44.4815811, 38.3022517],
              [44.4806895, 38.3022407],
              [44.4801114, 38.3023252],
              [44.4792607, 38.3026415],
              [44.4788578, 38.3027468],
              [44.4782878, 38.302652],
              [44.47789, 38.3023682],
              [44.4763299, 38.3007369],
              [44.4755108, 38.2995782],
              [44.4752597, 38.2991239],
              [44.4753268, 38.2988393],
              [44.4757122, 38.298455],
              [44.4757542, 38.2980526],
              [44.4753275, 38.297426],
              [44.4741982, 38.2960489],
              [44.473474, 38.2953126],
              [44.4725984, 38.2949136],
              [44.4719763, 38.2948243],
              [44.4698572, 38.294999],
              [44.4692246, 38.2949272],
              [44.4683832, 38.2946001],
              [44.4672868, 38.293558],
              [44.4666621, 38.2926844],
              [44.4662382, 38.2922797],
              [44.4637564, 38.2911885],
              [44.4629423, 38.290451],
              [44.4593923, 38.2884078],
              [44.4583853, 38.2877703],
              [44.4578475, 38.2871777],
              [44.4566769, 38.2854262],
              [44.4558723, 38.2843657],
              [44.4550558, 38.2839901],
              [44.452255, 38.2839798],
              [44.4504938, 38.2838304],
              [44.4491621, 38.283338],
              [44.4475265, 38.28181],
              [44.4466194, 38.281218],
              [44.4457134, 38.2807554],
              [44.4444714, 38.2800332],
              [44.4411169, 38.27775],
              [44.4407868, 38.2773681],
              [44.4396418, 38.275096],
              [44.4347338, 38.269706],
              [44.4339559, 38.2691525],
              [44.4329799, 38.2687392],
              [44.4317883, 38.2688305],
              [44.4298426, 38.2693713],
              [44.4288809, 38.2692528],
              [44.4261819, 38.2687489],
              [44.4235044, 38.2682338],
              [44.4225323, 38.2680027],
              [44.422004, 38.2673679],
              [44.4208506, 38.2664255],
              [44.4193714, 38.2654069],
              [44.417674, 38.2643263],
              [44.4152428, 38.2623395],
              [44.4142948, 38.261721],
              [44.413471, 38.2611],
              [44.4134307, 38.2594329],
              [44.4131859, 38.2581439],
              [44.4127043, 38.2573621],
              [44.4111819, 38.2559697],
              [44.4086661, 38.2542648],
              [44.4073195, 38.2538509],
              [44.4056688, 38.2536193],
              [44.4043031, 38.2530969],
              [44.4030407, 38.2524577],
              [44.4022685, 38.2520003],
              [44.4017805, 38.2510346],
              [44.4017331, 38.2505128],
              [44.4018736, 38.2489038],
              [44.4022375, 38.2464421],
              [44.4020255, 38.2459174],
              [44.4011086, 38.2445658],
              [44.4005163, 38.2441002],
              [44.3998438, 38.243791],
              [44.3994221, 38.2435229],
              [44.3990156, 38.2429418],
              [44.3989075, 38.2415149],
              [44.3986628, 38.2407308],
              [44.3984516, 38.2395958],
              [44.3986824, 38.2385345],
              [44.3990623, 38.2376664],
              [44.3991502, 38.2370886],
              [44.40047, 38.236113],
              [44.4023619, 38.2350354],
              [44.405316, 38.2336446],
              [44.4060023, 38.2325659],
              [44.4067293, 38.2310485],
              [44.4071846, 38.2288978],
              [44.4081764, 38.2267515],
              [44.4095056, 38.2248839],
              [44.4102794, 38.2229885],
              [44.4102952, 38.22105],
              [44.4117396, 38.2195101],
              [44.4116086, 38.2188096],
              [44.410712, 38.2179634],
              [44.4080271, 38.2159455],
              [44.4076428, 38.214202],
              [44.4072118, 38.213094],
              [44.4072921, 38.2125471],
              [44.4068354, 38.2114683],
              [44.4066357, 38.2106842],
              [44.4050096, 38.2075066],
              [44.4023802, 38.2019941],
              [44.4021745, 38.2017009],
              [44.4019686, 38.2016427],
              [44.4009247, 38.2018264],
              [44.4000805, 38.2018484],
              [44.3997955, 38.2017482],
              [44.3993788, 38.2013158],
              [44.3988579, 38.2004671],
              [44.3984207, 38.1995305],
              [44.3980254, 38.1984635],
              [44.3982855, 38.1977966],
              [44.398197, 38.1970597],
              [44.3986479, 38.1968199],
              [44.3993025, 38.1966872],
              [44.4001464, 38.1961309],
              [44.4008788, 38.194572],
              [44.400804, 38.1937361],
              [44.4001449, 38.1926649],
              [44.3994643, 38.1917949],
              [44.3983978, 38.1910398],
              [44.3978407, 38.1905264],
              [44.396911, 38.189168],
              [44.3978132, 38.1884709],
              [44.3984731, 38.1877779],
              [44.3994262, 38.1855976],
              [44.3997361, 38.1850007],
              [44.3998556, 38.1841941],
              [44.4003144, 38.1831992],
              [44.4001279, 38.181952],
              [44.3999362, 38.1809433],
              [44.4001524, 38.1796829],
              [44.3996202, 38.178285],
              [44.3985273, 38.1756149],
              [44.3986432, 38.174736],
              [44.3983906, 38.173487],
              [44.3972184, 38.1715538],
              [44.3955562, 38.1709934],
              [44.3933359, 38.1703507],
              [44.3923264, 38.1693433],
              [44.3911827, 38.1677279],
              [44.3911685, 38.1672241],
              [44.391361, 38.1664271],
              [44.3915432, 38.1652679],
              [44.3919145, 38.1646828],
              [44.392911, 38.164208],
              [44.3933603, 38.1637944],
              [44.3931448, 38.1628801],
              [44.3933287, 38.1619668],
              [44.3940488, 38.1616185],
              [44.3946158, 38.1609923],
              [44.394711, 38.1601149],
              [44.3944422, 38.1591102],
              [44.3942722, 38.1587137],
              [44.3936853, 38.1578064],
              [44.3930447, 38.1552409],
              [44.3927578, 38.1544216],
              [44.392246, 38.1538111],
              [44.3918663, 38.1532176],
              [44.3916636, 38.1520277],
              [44.391846, 38.1512944],
              [44.3922755, 38.15042],
              [44.3924898, 38.1495988],
              [44.3922787, 38.1484808],
              [44.3923149, 38.1476514],
              [44.392385, 38.1472316],
              [44.3926934, 38.1464431],
              [44.3924193, 38.1460966],
              [44.3914511, 38.1457388],
              [44.3903023, 38.1457629],
              [44.3885892, 38.1454743],
              [44.3874077, 38.145152],
              [44.3862035, 38.1446131],
              [44.3855425, 38.1444254],
              [44.3850239, 38.1441622],
              [44.3824399, 38.1413198],
              [44.3811408, 38.1394468],
              [44.3805398, 38.1390596],
              [44.3799211, 38.1389026],
              [44.3764164, 38.1382822],
              [44.3748653, 38.1381236],
              [44.3738278, 38.1380943],
              [44.3728198, 38.1382855],
              [44.3716899, 38.138681],
              [44.3708835, 38.1387481],
              [44.3704568, 38.1385535],
              [44.3701895, 38.1382142],
              [44.370098, 38.1375934],
              [44.3696821, 38.1363896],
              [44.3691243, 38.1358872],
              [44.3686252, 38.1356841],
              [44.367845, 38.1356878],
              [44.366987, 38.1357867],
              [44.3656188, 38.1357567],
              [44.363607, 38.1348687],
              [44.3629298, 38.134645],
              [44.3621443, 38.1345743],
              [44.3612948, 38.1346795],
              [44.3606002, 38.1351512],
              [44.3593578, 38.1356317],
              [44.3585556, 38.1357303],
              [44.3577677, 38.1355833],
              [44.3568015, 38.1350298],
              [44.3560656, 38.1347323],
              [44.3555014, 38.1347492],
              [44.3534741, 38.1352829],
              [44.3525826, 38.1353768],
              [44.351587, 38.1352746],
              [44.3511809, 38.1349942],
              [44.3510621, 38.1338811],
              [44.3507588, 38.1332119],
              [44.3495126, 38.1316841],
              [44.3503132, 38.1305748],
              [44.3515832, 38.1296394],
              [44.353443, 38.1278673],
              [44.3548689, 38.1262452],
              [44.3581704, 38.1244725],
              [44.3591675, 38.1236019],
              [44.3596171, 38.1228582],
              [44.3595901, 38.1217202],
              [44.3588519, 38.1196156],
              [44.3586127, 38.1167459],
              [44.3587591, 38.1143004],
              [44.3595248, 38.1121172],
              [44.3601379, 38.1111239],
              [44.362287, 38.1086576],
              [44.3629363, 38.1074197],
              [44.3640824, 38.1064624],
              [44.3648052, 38.1055825],
              [44.364823, 38.1046532],
              [44.3645086, 38.1039085],
              [44.3638716, 38.1036234],
              [44.3621786, 38.1036424],
              [44.3602553, 38.1037984],
              [44.3581784, 38.1042704],
              [44.3562448, 38.1048278],
              [44.3549673, 38.1050912],
              [44.3537076, 38.1051199],
              [44.3517701, 38.1048418],
              [44.3508122, 38.1044594],
              [44.3498552, 38.1041368],
              [44.3484724, 38.104041],
              [44.3475787, 38.1034791],
              [44.3437959, 38.1016944],
              [44.3414971, 38.1005343],
              [44.3404569, 38.0999325],
              [44.3391971, 38.0993677],
              [44.3380382, 38.0990466],
              [44.33634, 38.098743],
              [44.3357726, 38.0983488],
              [44.335369, 38.0982137],
              [44.3347478, 38.0981657],
              [44.3329035, 38.0985945],
              [44.3322959, 38.0988043],
              [44.3316325, 38.0989174],
              [44.3311142, 38.0989168],
              [44.3305385, 38.0988045],
              [44.3298667, 38.0985795],
              [44.3293645, 38.098353],
              [44.3292737, 38.098155],
              [44.3289155, 38.0976804],
              [44.3287845, 38.097075],
              [44.3288108, 38.0959569],
              [44.3293225, 38.0952874],
              [44.3297621, 38.0943523],
              [44.331109, 38.0920987],
              [44.3314064, 38.0907536],
              [44.3313906, 38.0897769],
              [44.3311533, 38.0887262],
              [44.3308865, 38.0882476],
              [44.3300513, 38.08755],
              [44.3297491, 38.087176],
              [44.3295653, 38.0864851],
              [44.3291864, 38.0857637],
              [44.3288325, 38.0841167],
              [44.3283929, 38.0832889],
              [44.3282662, 38.0828429],
              [44.3283728, 38.0823301],
              [44.3289222, 38.0807631],
              [44.3289444, 38.0804352],
              [44.3287185, 38.0797354],
              [44.3287629, 38.0789369],
              [44.3285769, 38.0786286],
              [44.328216, 38.0782813],
              [44.327478, 38.0780216],
              [44.325845, 38.0777763],
              [44.3244887, 38.0779079],
              [44.3227947, 38.0782377],
              [44.3223657, 38.0784448],
              [44.322067, 38.0786554],
              [44.3218332, 38.0787015],
              [44.3215799, 38.078638],
              [44.3211567, 38.0783055],
              [44.320152, 38.0772512],
              [44.3177477, 38.0745628],
              [44.3172191, 38.0741236],
              [44.3157874, 38.0736709],
              [44.3142743, 38.0733804],
              [44.3119147, 38.0731124],
              [44.311362, 38.0728943],
              [44.3112128, 38.0725601],
              [44.3110731, 38.0717852],
              [44.3111273, 38.0713978],
              [44.3116452, 38.0707346],
              [44.3116918, 38.0703736],
              [44.3115052, 38.0698978],
              [44.3115052, 38.0695365],
              [44.3118796, 38.0689438],
              [44.3120877, 38.0684811],
              [44.312443, 38.0681178],
              [44.3127776, 38.068069],
              [44.3135724, 38.0681334],
              [44.3151551, 38.0684392],
              [44.315693, 38.0687708],
              [44.3158607, 38.0688193],
              [44.3164733, 38.0687327],
              [44.317337, 38.0687463],
              [44.3184555, 38.0689414],
              [44.3195321, 38.0690336],
              [44.3199941, 38.069029],
              [44.3200066, 38.0688761],
              [44.3196762, 38.0685903],
              [44.3194022, 38.0681142],
              [44.3193598, 38.067475],
              [44.3194039, 38.0667544],
              [44.3196578, 38.0658954],
              [44.3197835, 38.0647133],
              [44.3199733, 38.0643598],
              [44.3204552, 38.0640708],
              [44.321083, 38.0639511],
              [44.3212116, 38.06377],
              [44.3211099, 38.0632898],
              [44.3206292, 38.0626918],
              [44.3197274, 38.061971],
              [44.3191097, 38.0618853],
              [44.3184032, 38.0619845],
              [44.3177768, 38.0618969],
              [44.3172568, 38.0616574],
              [44.3167134, 38.0611615],
              [44.3161212, 38.0608324],
              [44.3154484, 38.0606778],
              [44.3148872, 38.0606104],
              [44.314524, 38.0604418],
              [44.3139149, 38.0596207],
              [44.3131608, 38.0592128],
              [44.3117721, 38.0586456],
              [44.3113682, 38.0584212],
              [44.3106739, 38.0582125],
              [44.3092023, 38.0580556],
              [44.3074338, 38.0574739],
              [44.3053112, 38.0566039],
              [44.3038398, 38.0558064],
              [44.3026244, 38.0547443],
              [44.3024973, 38.0545195],
              [44.3028293, 38.0528706],
              [44.3041925, 38.0497969],
              [44.3045953, 38.0484248],
              [44.3051212, 38.0476467],
              [44.3062778, 38.0466958],
              [44.3066768, 38.0465607],
              [44.3069369, 38.0465366],
              [44.3077372, 38.04666],
              [44.3082223, 38.0465873],
              [44.3087309, 38.0464917],
              [44.3088646, 38.0463001],
              [44.3085657, 38.0454392],
              [44.3083953, 38.0446316],
              [44.308014, 38.0436809],
              [44.3071083, 38.0428124],
              [44.3063601, 38.0419865],
              [44.3058957, 38.0404041],
              [44.304213, 38.0374132],
              [44.3038573, 38.0366623],
              [44.3033209, 38.0361733],
              [44.3028038, 38.0355561],
              [44.3017682, 38.0333171],
              [44.3013231, 38.0325345],
              [44.300779, 38.0320105],
              [44.2996512, 38.0312943],
              [44.2982438, 38.030747],
              [44.2978654, 38.0303977],
              [44.2965953, 38.0292252],
              [44.2958597, 38.0286872],
              [44.2950057, 38.0281649],
              [44.2942838, 38.027821],
              [44.2933034, 38.0274883],
              [44.2920116, 38.0272833],
              [44.2911689, 38.0265781],
              [44.290395, 38.0258425],
              [44.2898822, 38.0249071],
              [44.289042, 38.0242941],
              [44.2885934, 38.0231361],
              [44.2878292, 38.0220197],
              [44.2867384, 38.0211755],
              [44.2856269, 38.0207307],
              [44.282792, 38.0209855],
              [44.2817682, 38.020966],
              [44.2800746, 38.0201246],
              [44.2792464, 38.019487],
              [44.2783217, 38.0185706],
              [44.2775602, 38.0181871],
              [44.276214, 38.0171349],
              [44.2753471, 38.0168353],
              [44.2745049, 38.0160998],
              [44.2742495, 38.015579],
              [44.2743016, 38.0147766],
              [44.2741028, 38.0139973],
              [44.2737128, 38.0130192],
              [44.2735487, 38.0121883],
              [44.2726931, 38.0118051],
              [44.2722079, 38.0111332],
              [44.2708642, 38.0104923],
              [44.2701708, 38.0100678],
              [44.2698496, 38.00931],
              [44.2691715, 38.0082248],
              [44.2693027, 38.0076409],
              [44.2692883, 38.0068293],
              [44.2687544, 38.0054218],
              [44.2677478, 38.0030794],
              [44.2675115, 38.0019547],
              [44.2672232, 38.0010425],
              [44.2668324, 38.0000401],
              [44.2667028, 37.9991311],
              [44.2667647, 37.9986283],
              [44.2670653, 37.9981829],
              [44.267469, 37.9981116],
              [44.2675232, 37.9976377],
              [44.267795, 37.9966507],
              [44.2679557, 37.9964613],
              [44.2678782, 37.9955899],
              [44.2676985, 37.9952691],
              [44.2676675, 37.995013],
              [44.2678302, 37.9948002],
              [44.2684218, 37.9943888],
              [44.2683782, 37.9942035],
              [44.2680798, 37.9937114],
              [44.2675947, 37.9932588],
              [44.2671492, 37.9927054],
              [44.2664608, 37.9916266],
              [44.2655734, 37.9911921],
              [44.2649663, 37.9908261],
              [44.2644863, 37.990415],
              [44.2636492, 37.9899444],
              [44.2626368, 37.9889584],
              [44.2619502, 37.988761],
              [44.26158, 37.9885896],
              [44.2614253, 37.9881932],
              [44.2615342, 37.9878557],
              [44.2615357, 37.9875026],
              [44.2611013, 37.986877],
              [44.2606427, 37.9866568],
              [44.2604228, 37.9859237],
              [44.2603087, 37.985295],
              [44.2607657, 37.9840162],
              [44.2606744, 37.9836871],
              [44.2604607, 37.983576],
              [44.2597711, 37.9835371],
              [44.2594208, 37.98338],
              [44.2591366, 37.9828236],
              [44.2587684, 37.9823122],
              [44.2577215, 37.9816279],
              [44.256494, 37.9810774],
              [44.2558899, 37.9805692],
              [44.2549713, 37.9796709],
              [44.254392, 37.9794769],
              [44.2543876, 37.9790808],
              [44.2550599, 37.9784421],
              [44.255436, 37.9779856],
              [44.2560885, 37.9776529],
              [44.2563055, 37.9773599],
              [44.2565431, 37.9769475],
              [44.2566034, 37.9767297],
              [44.2563085, 37.9762083],
              [44.2557674, 37.9755899],
              [44.255336, 37.9752222],
              [44.2545242, 37.9748216],
              [44.2540115, 37.9746205],
              [44.2535188, 37.9745836],
              [44.2531953, 37.9744927],
              [44.2525591, 37.9740486],
              [44.2518329, 37.9739514],
              [44.250922, 37.9736662],
              [44.2504506, 37.9734494],
              [44.250041, 37.973093],
              [44.2487594, 37.9712942],
              [44.2493409, 37.9702428],
              [44.2490979, 37.9696807],
              [44.2483166, 37.9691638],
              [44.2466526, 37.9688177],
              [44.2457337, 37.9682362],
              [44.2449694, 37.9666884],
              [44.2442411, 37.9656816],
              [44.2435591, 37.9651103],
              [44.2426828, 37.9650708],
              [44.2415389, 37.9654091],
              [44.2407127, 37.9650564],
              [44.2405737, 37.9643424],
              [44.2413409, 37.9611715],
              [44.2413264, 37.9607432],
              [44.2411232, 37.9602577],
              [44.2406739, 37.9565807],
              [44.2406054, 37.9555238],
              [44.2408907, 37.9549503],
              [44.241705, 37.9545711],
              [44.2422879, 37.9540808],
              [44.2435064, 37.95189],
              [44.2467192, 37.9513281],
              [44.2477225, 37.9513743],
              [44.2486542, 37.9510362],
              [44.248783, 37.9504074],
              [44.2485603, 37.9498408],
              [44.2485998, 37.9493273],
              [44.2488791, 37.9489015],
              [44.2491973, 37.9477876],
              [44.2496467, 37.9467567],
              [44.2495321, 37.9459261],
              [44.2498042, 37.9454491],
              [44.2508686, 37.9442114],
              [44.251232, 37.9433704],
              [44.2509283, 37.9425378],
              [44.2502348, 37.942231],
              [44.249301, 37.9420436],
              [44.248914, 37.941691],
              [44.2484761, 37.9406145],
              [44.2479655, 37.9398853],
              [44.2477068, 37.9392569],
              [44.2476491, 37.938576],
              [44.2469668, 37.9377284],
              [44.2460126, 37.9370968],
              [44.2461307, 37.9361909],
              [44.2460146, 37.9339933],
              [44.246227, 37.9332456],
              [44.2461786, 37.9320157],
              [44.2459051, 37.9313962],
              [44.2454846, 37.9310231],
              [44.2446569, 37.9307957],
              [44.2438936, 37.9297046],
              [44.2433854, 37.9290987],
              [44.2427635, 37.9289034],
              [44.2424087, 37.9290313],
              [44.2421102, 37.9290679],
              [44.2416277, 37.9289816],
              [44.2412917, 37.9291993],
              [44.2410141, 37.9292356],
              [44.240108, 37.9291084],
              [44.2387664, 37.9284783],
              [44.2378795, 37.928224],
              [44.2363528, 37.9276162],
              [44.235119, 37.9272619],
              [44.234637, 37.9269538],
              [44.2345062, 37.9265297],
              [44.2344369, 37.9252842],
              [44.2345318, 37.9246688],
              [44.2345592, 37.9234762],
              [44.2347833, 37.9229664],
              [44.2347486, 37.9222768],
              [44.2345501, 37.9213234],
              [44.2344478, 37.9203617],
              [44.2343149, 37.9199198],
              [44.2338532, 37.9194739],
              [44.2333247, 37.9191065],
              [44.2323036, 37.9188468],
              [44.2309953, 37.9185999],
              [44.229828, 37.9181523],
              [44.2293834, 37.9178066],
              [44.2291728, 37.9171852],
              [44.2293064, 37.9165257],
              [44.2296031, 37.9159454],
              [44.2303752, 37.9152388],
              [44.2307576, 37.9147167],
              [44.230923, 37.9137275],
              [44.2308903, 37.9123516],
              [44.2305583, 37.9115624],
              [44.2300513, 37.9111392],
              [44.2292571, 37.9109063],
              [44.2264554, 37.9103677],
              [44.2259307, 37.9089001],
              [44.224575, 37.9076481],
              [44.2243172, 37.9070057],
              [44.2253179, 37.9064244],
              [44.2260039, 37.9058727],
              [44.2269551, 37.9052664],
              [44.2278282, 37.9049288],
              [44.2287217, 37.9042374],
              [44.2292699, 37.9036326],
              [44.2295541, 37.9026253],
              [44.2302922, 37.9018239],
              [44.2318366, 37.9009342],
              [44.232465, 37.9002434],
              [44.2321314, 37.8996045],
              [44.2311697, 37.8989974],
              [44.2305078, 37.8981247],
              [44.2293197, 37.8954706],
              [44.2273097, 37.8936804],
              [44.2263919, 37.8927336],
              [44.2260142, 37.8920999],
              [44.2257668, 37.890994],
              [44.2253808, 37.8904109],
              [44.2247473, 37.8898137],
              [44.2236123, 37.8895223],
              [44.2229054, 37.8887606],
              [44.2227458, 37.8882392],
              [44.2232921, 37.8877416],
              [44.2239031, 37.8874998],
              [44.2247364, 37.8868794],
              [44.2264605, 37.886421],
              [44.2274054, 37.886124],
              [44.2283905, 37.8856345],
              [44.2297175, 37.8853978],
              [44.2310991, 37.8849757],
              [44.2323603, 37.8844803],
              [44.2336278, 37.8842345],
              [44.2343626, 37.8842932],
              [44.2352428, 37.8846458],
              [44.236374, 37.8848439],
              [44.2374218, 37.8842894],
              [44.2385502, 37.8841326],
              [44.2390657, 37.883757],
              [44.2396537, 37.8829938],
              [44.2397678, 37.8826008],
              [44.2396513, 37.8819718],
              [44.2397171, 37.880744],
              [44.2408602, 37.8797636],
              [44.241947, 37.8785924],
              [44.2424935, 37.8775853],
              [44.2427933, 37.8768844],
              [44.243527, 37.8763341],
              [44.2441613, 37.8757569],
              [44.2461577, 37.8750493],
              [44.2473878, 37.8749994],
              [44.248023, 37.8751982],
              [44.2488781, 37.8752796],
              [44.2499232, 37.8755999],
              [44.2505595, 37.8754366],
              [44.2517196, 37.8757813],
              [44.2517298, 37.8737368],
              [44.2527994, 37.8732856],
              [44.2546826, 37.8733077],
              [44.2558141, 37.8728159],
              [44.2564406, 37.8717894],
              [44.2565204, 37.871252],
              [44.2578993, 37.8700504],
              [44.2589244, 37.8697372],
              [44.2607563, 37.8688607],
              [44.2628325, 37.8681025],
              [44.2634301, 37.8681051],
              [44.2641759, 37.8683406],
              [44.2661277, 37.8679221],
              [44.2673977, 37.8673051],
              [44.2680203, 37.867248],
              [44.2697747, 37.8678658],
              [44.270109, 37.8686588],
              [44.2706959, 37.8692161],
              [44.2740064, 37.8703359],
              [44.2754154, 37.8705356],
              [44.2771646, 37.8710202],
              [44.2797894, 37.8714445],
              [44.2803522, 37.8716908],
              [44.2807734, 37.8724212],
              [44.281196, 37.8724965],
              [44.2820586, 37.8724624],
              [44.2844905, 37.8731084],
              [44.2862449, 37.8726964],
              [44.2874765, 37.8725379],
              [44.2887948, 37.8718914],
              [44.2897452, 37.8709233],
              [44.2905766, 37.8688371],
              [44.2911665, 37.8681264],
              [44.2916147, 37.8674038],
              [44.2929042, 37.866908],
              [44.2946477, 37.8670345],
              [44.296402, 37.8672446],
              [44.2992984, 37.8682092],
              [44.3007422, 37.8684867],
              [44.3023952, 37.8686861],
              [44.3029692, 37.8687298],
              [44.3040336, 37.8681342],
              [44.3047168, 37.8679322],
              [44.3055266, 37.8681652],
              [44.3071801, 37.8687872],
              [44.3087472, 37.8695259],
              [44.3099329, 37.8702521],
              [44.3107592, 37.8711328],
              [44.3113869, 37.8719339],
              [44.3123046, 37.87257],
              [44.3130837, 37.8734459],
              [44.3143539, 37.8742365],
              [44.3153029, 37.8749083],
              [44.3164163, 37.8760164],
              [44.3170248, 37.8764894],
              [44.3182307, 37.8768847],
              [44.3193365, 37.8770837],
              [44.3207977, 37.8770069],
              [44.3233946, 37.8764215],
              [44.3267277, 37.8757652],
              [44.3295569, 37.8754955],
              [44.331565, 37.8749123],
              [44.3338075, 37.8732706],
              [44.3359579, 37.8708996],
              [44.3375565, 37.8700026],
              [44.3384335, 37.8697664],
              [44.3394292, 37.8699188],
              [44.3409654, 37.8697964],
              [44.3455159, 37.8684426],
              [44.3487652, 37.8666793],
              [44.3499648, 37.8669089],
              [44.351602, 37.8665526],
              [44.3532455, 37.8656074],
              [44.3547482, 37.8649376],
              [44.3561932, 37.8637478],
              [44.3571214, 37.8633178],
              [44.3585043, 37.86331],
              [44.3593718, 37.8631153],
              [44.3600472, 37.8627719],
              [44.3611842, 37.8628659],
              [44.3626576, 37.8625134],
              [44.365237, 37.8624766],
              [44.367856, 37.862722],
              [44.369019, 37.863285],
              [44.370369, 37.863426],
              [44.371299, 37.863883],
              [44.373486, 37.863918],
              [44.37465, 37.864023],
              [44.377581, 37.864094],
              [44.379302, 37.863812],
              [44.380838, 37.863426],
              [44.381955, 37.86325],
              [44.383164, 37.862652],
              [44.384188, 37.862476],
              [44.384793, 37.862511],
              [44.386282, 37.862722],
              [44.387445, 37.862722],
              [44.388189, 37.862511],
              [44.389074, 37.862054],
              [44.390795, 37.860683],
              [44.391307, 37.860085],
              [44.391633, 37.859557],
              [44.392051, 37.85903],
              [44.392842, 37.858573],
              [44.393168, 37.85808],
              [44.394099, 37.857342],
              [44.395913, 37.856674],
              [44.396704, 37.856252],
              [44.397821, 37.855795],
              [44.398426, 37.855197],
              [44.3993937, 37.8547328],
              [44.399775, 37.854388],
              [44.400101, 37.853931],
              [44.400892, 37.853403],
              [44.401543, 37.852911],
              [44.402288, 37.852348],
              [44.402986, 37.852173],
              [44.403172, 37.851715],
              [44.403451, 37.851223],
              [44.403637, 37.85052],
              [44.40373, 37.849922],
              [44.404009, 37.849219],
              [44.404335, 37.84841],
              [44.4048, 37.847425],
              [44.404986, 37.847003],
              [44.40508, 37.846265],
              [44.405033, 37.845667],
              [44.404986, 37.844999],
              [44.4048998, 37.8447814],
              [44.404707, 37.844295],
              [44.404614, 37.8431],
              [44.404521, 37.842467],
              [44.404335, 37.841553],
              [44.404242, 37.840955],
              [44.403777, 37.840287],
              [44.402846, 37.839794],
              [44.401776, 37.839232],
              [44.400752, 37.838774],
              [44.399589, 37.838388],
              [44.398379, 37.838071],
              [44.397542, 37.838106],
              [44.396797, 37.837895],
              [44.396146, 37.837227],
              [44.396006, 37.836453],
              [44.395681, 37.836067],
              [44.395541, 37.835574],
              [44.395122, 37.834801],
              [44.394983, 37.834238],
              [44.394331, 37.833359],
              [44.393587, 37.83262],
              [44.393447, 37.832058],
              [44.392935, 37.831319],
              [44.3925478, 37.8301485],
              [44.3925669, 37.8290511],
              [44.3924171, 37.8284697],
              [44.3922192, 37.8278824],
              [44.3924159, 37.8273688],
              [44.3931264, 37.8268943],
              [44.3934248, 37.8265106],
              [44.3935075, 37.8261405],
              [44.3934205, 37.8256028],
              [44.3933921, 37.8250241],
              [44.3932684, 37.8245706],
              [44.3934623, 37.8240503],
              [44.3944467, 37.8230608],
              [44.3956299, 37.8221307],
              [44.3969467, 37.8209544],
              [44.3974823, 37.8205652],
              [44.3989227, 37.8206035],
              [44.4004354, 37.8204366],
              [44.401686, 37.8199007],
              [44.4025149, 37.8197612],
              [44.4043093, 37.8198346],
              [44.4056334, 37.8195287],
              [44.4066197, 37.8192865],
              [44.4078852, 37.8185394],
              [44.4092224, 37.8181428],
              [44.4107619, 37.8172602],
              [44.412215, 37.8168567],
              [44.413384, 37.8163314],
              [44.4141334, 37.8160567],
              [44.4148019, 37.8156397],
              [44.4152585, 37.814641],
              [44.415518, 37.8131503],
              [44.4155247, 37.811971],
              [44.4153661, 37.8105631],
              [44.4159001, 37.8094889],
              [44.4163517, 37.8085692],
              [44.4171576, 37.8081069],
              [44.4177543, 37.8074854],
              [44.4181325, 37.8067857],
              [44.4178785, 37.8061472],
              [44.4180879, 37.8058291],
              [44.418715, 37.8055069],
              [44.420041, 37.8051422],
              [44.4211529, 37.8046963],
              [44.4215712, 37.8043708],
              [44.422668, 37.8030473],
              [44.4228699, 37.801589],
              [44.4232134, 37.8005091],
              [44.4237529, 37.799449],
              [44.4267568, 37.7985551],
              [44.4297506, 37.7987169],
              [44.4341642, 37.799634],
              [44.4352886, 37.800081],
              [44.4360882, 37.800841],
              [44.4375481, 37.80121],
              [44.4389886, 37.8019965],
              [44.4403043, 37.8026447],
              [44.4418263, 37.8035519],
              [44.4430745, 37.8041214],
              [44.443992, 37.8044527],
              [44.4451202, 37.8047179],
              [44.446124, 37.8051775],
              [44.4469895, 37.8060507],
              [44.4476672, 37.8064946],
              [44.4483769, 37.8065854],
              [44.4485201, 37.8059285],
              [44.4485576, 37.8053915],
              [44.4484716, 37.8046688],
              [44.4481367, 37.8036523],
              [44.4475991, 37.801504],
              [44.447482, 37.8001362],
              [44.4475246, 37.7986552],
              [44.4478726, 37.7971227],
              [44.4480946, 37.7955326],
              [44.4481538, 37.7930256],
              [44.4487591, 37.7910496],
              [44.4494277, 37.7891669],
              [44.4499336, 37.7875453],
              [44.4499409, 37.785845],
              [44.4488441, 37.7826861],
              [44.4485122, 37.782364],
              [44.4476167, 37.7820174],
              [44.4463519, 37.7804514],
              [44.4456478, 37.7797004],
              [44.4449358, 37.7790332],
              [44.4439677, 37.7777237],
              [44.4434252, 37.7767146],
              [44.4431344, 37.7746622],
              [44.443249, 37.7738307],
              [44.4437504, 37.773121],
              [44.4445613, 37.7713546],
              [44.4449506, 37.7709171],
              [44.4464046, 37.7703974],
              [44.4473869, 37.7703097],
              [44.4491856, 37.7697901],
              [44.4497978, 37.7694201],
              [44.4501122, 37.7690403],
              [44.4503824, 37.7685102],
              [44.4508027, 37.767866],
              [44.4512075, 37.767497],
              [44.4515629, 37.7673399],
              [44.4524826, 37.7666873],
              [44.4531248, 37.7666916],
              [44.4535933, 37.7665113],
              [44.4547658, 37.7668572],
              [44.4559734, 37.7669254],
              [44.4580229, 37.7671354],
              [44.4595272, 37.7665937],
              [44.4606845, 37.766022],
              [44.4623158, 37.7657452],
              [44.4633685, 37.7654284],
              [44.4647051, 37.7656321],
              [44.4650471, 37.7654715],
              [44.4656627, 37.765338],
              [44.4664549, 37.7654798],
              [44.4668178, 37.7657022],
              [44.4681731, 37.7649158],
              [44.4696336, 37.7645003],
              [44.471106, 37.7644259],
              [44.4715484, 37.7642783],
              [44.471978, 37.7639285],
              [44.4723466, 37.7638134],
              [44.4727237, 37.7638062],
              [44.4736524, 37.764568],
              [44.4739962, 37.7649172],
              [44.4741947, 37.7652609],
              [44.4742159, 37.7656891],
              [44.4744698, 37.7663803],
              [44.4754947, 37.7673453],
              [44.4761814, 37.76843],
              [44.4766481, 37.7694669],
              [44.4774346, 37.7703729],
              [44.4778796, 37.7708061],
              [44.4794745, 37.771465],
              [44.4802692, 37.7717443],
              [44.4807239, 37.7718249],
              [44.4816381, 37.7718236],
              [44.4827539, 37.7717258],
              [44.4835725, 37.7715757],
              [44.4840809, 37.7715732],
              [44.4849525, 37.7716553],
              [44.4859088, 37.7716132],
              [44.4867754, 37.7714167],
              [44.4875189, 37.771059],
              [44.4879001, 37.7709783],
              [44.4884486, 37.7710658],
              [44.4890656, 37.7710487],
              [44.4909464, 37.7707159],
              [44.4915339, 37.7706817],
              [44.4919142, 37.7705902],
              [44.4926197, 37.7706988],
              [44.4939492, 37.7704602],
              [44.4944304, 37.7708506],
              [44.4951891, 37.7720262],
              [44.4956791, 37.7721409],
              [44.4961318, 37.7728203],
              [44.4968327, 37.7732489],
              [44.4979236, 37.773743],
              [44.4987813, 37.7739174],
              [44.4995607, 37.7741348],
              [44.501882, 37.7745658],
              [44.5034804, 37.7747282],
              [44.5061454, 37.7751358],
              [44.5070515, 37.7751389],
              [44.5077062, 37.7752126],
              [44.5097547, 37.7758173],
              [44.5108444, 37.7757055],
              [44.5121279, 37.7753949],
              [44.5125114, 37.7753761],
              [44.5131507, 37.7754727],
              [44.5177444, 37.7767431],
              [44.5183055, 37.7770715],
              [44.5186835, 37.7775018],
              [44.5189362, 37.7781676],
              [44.5189588, 37.7793476],
              [44.5190809, 37.7800022],
              [44.5193388, 37.780246],
              [44.5219152, 37.7806139],
              [44.5229768, 37.7807237],
              [44.5232938, 37.7809699],
              [44.5236644, 37.7815943],
              [44.5243923, 37.7820804],
              [44.527361, 37.7827882],
              [44.5290991, 37.7829264],
              [44.5297959, 37.783025],
              [44.5303121, 37.7830167],
              [44.5321572, 37.7824294],
              [44.5327203, 37.782195],
              [44.5331755, 37.7817897],
              [44.5336449, 37.7815797],
              [44.5346953, 37.7814654],
              [44.5354304, 37.7814458],
              [44.5376989, 37.7819237],
              [44.5387141, 37.7818806],
              [44.5396909, 37.7819978],
              [44.5401907, 37.7819577],
              [44.5423797, 37.781155],
              [44.5449136, 37.7799974],
              [44.5454574, 37.7798477],
              [44.5469424, 37.7797383],
              [44.5473163, 37.7795998],
              [44.5482032, 37.7795088],
              [44.5485862, 37.7794856],
              [44.5494225, 37.7797722],
              [44.5497219, 37.7799648],
              [44.550067, 37.7803667],
              [44.5511457, 37.7806645],
              [44.5516024, 37.7807181],
              [44.5525223, 37.7806126],
              [44.5545718, 37.7806258],
              [44.5549506, 37.7805011],
              [44.5552305, 37.780316],
              [44.5557669, 37.7798446],
              [44.5573149, 37.7794383],
              [44.5585912, 37.7784263],
              [44.5597469, 37.777611],
              [44.5601676, 37.777149],
              [44.5618504, 37.7760868],
              [44.5624795, 37.7755104],
              [44.5631295, 37.7745934],
              [44.5633371, 37.7739951],
              [44.5633364, 37.7734603],
              [44.563469, 37.7726022],
              [44.5636311, 37.7720086],
              [44.5639154, 37.7716207],
              [44.5645777, 37.7712332],
              [44.5655667, 37.7708534],
              [44.5665214, 37.7705775],
              [44.5671671, 37.7702795],
              [44.5677934, 37.7697706],
              [44.5682828, 37.7692511],
              [44.5685997, 37.7688077],
              [44.5688962, 37.7687287],
              [44.5697865, 37.7687952],
              [44.5703298, 37.7687566],
              [44.5713371, 37.7684378],
              [44.5717476, 37.7682613],
              [44.572178, 37.7680009],
              [44.5724209, 37.7677357],
              [44.5725075, 37.7675559],
              [44.5726169, 37.7674899],
              [44.5737363, 37.7676022],
              [44.5742453, 37.7675436],
              [44.5747994, 37.7672928],
              [44.5752975, 37.7667859],
              [44.575636, 37.7665408],
              [44.5765023, 37.7663755],
              [44.5770406, 37.7663454],
              [44.5773648, 37.7662706],
              [44.5785483, 37.7653339],
              [44.5787312, 37.765327],
              [44.579073, 37.765615],
              [44.5793481, 37.7656935],
              [44.5796846, 37.765697],
              [44.5806977, 37.7655378],
              [44.5814141, 37.7655201],
              [44.583, 37.7657225],
              [44.584134, 37.7656567],
              [44.5860287, 37.7647075],
              [44.5870796, 37.7640076],
              [44.5878635, 37.7633638],
              [44.5886025, 37.7616143],
              [44.5892092, 37.7594669],
              [44.5898972, 37.7576961],
              [44.5907234, 37.7562653],
              [44.5919432, 37.7547516],
              [44.5925563, 37.7536797],
              [44.5935879, 37.7512214],
              [44.5936098, 37.75008],
              [44.5947731, 37.7478413],
              [44.5967705, 37.7463707],
              [44.5971875, 37.7458878],
              [44.5992262, 37.7453198],
              [44.5999247, 37.7449919],
              [44.6005231, 37.7446308],
              [44.6008718, 37.7440604],
              [44.6012459, 37.7437054],
              [44.6013855, 37.7431493],
              [44.6019304, 37.7425615],
              [44.6022572, 37.7417689],
              [44.6023269, 37.7409194],
              [44.602782, 37.7402396],
              [44.6036635, 37.7399393],
              [44.6044212, 37.7397514],
              [44.6058759, 37.7395669],
              [44.606718, 37.7392278],
              [44.6074088, 37.7387596],
              [44.6083354, 37.7365759],
              [44.6088955, 37.735641],
              [44.6091983, 37.7346289],
              [44.6104113, 37.7328991],
              [44.6110145, 37.7324384],
              [44.6128243, 37.7322739],
              [44.6143049, 37.7318023],
              [44.615314, 37.7314294],
              [44.6162024, 37.7309029],
              [44.6164108, 37.7307055],
              [44.6166192, 37.7302119],
              [44.6193941, 37.7282047],
              [44.6193612, 37.7278976],
              [44.620469, 37.7271957],
              [44.6206225, 37.7270202],
              [44.6207103, 37.7264718],
              [44.6205019, 37.7258466],
              [44.6206225, 37.7250021],
              [44.6202825, 37.7241027],
              [44.6205787, 37.7224246],
              [44.6216755, 37.7203626],
              [44.6216316, 37.7197264],
              [44.6216865, 37.7195071],
              [44.6216316, 37.7192438],
              [44.6212279, 37.7189042],
              [44.6211367, 37.7187112],
              [44.6215181, 37.7181517],
              [44.6224109, 37.7166994],
              [44.6233483, 37.7126811],
              [44.6241474, 37.7102333],
              [44.6248199, 37.7089654],
              [44.6259479, 37.7078567],
              [44.6281587, 37.7071094],
              [44.6304124, 37.7063482],
              [44.6289669, 37.7044789],
              [44.628506, 37.7030473],
              [44.6281868, 37.7028096],
              [44.6280768, 37.7021432],
              [44.6274143, 37.701583],
              [44.6273258, 37.7011649],
              [44.6270174, 37.7010779],
              [44.6269793, 37.7006969],
              [44.6258221, 37.7000856],
              [44.6247287, 37.6981466],
              [44.623504, 37.6971719],
              [44.6233258, 37.6966237],
              [44.6224354, 37.6959735],
              [44.621591, 37.6949664],
              [44.6199417, 37.6936097],
              [44.619211, 37.6929946],
              [44.6183598, 37.6919013],
              [44.6176745, 37.6915356],
              [44.617318, 37.6910153],
              [44.6173278, 37.6906911],
              [44.6172028, 37.6904321],
              [44.6143388, 37.688934],
              [44.6135129, 37.6888208],
              [44.6124706, 37.6882132],
              [44.611611, 37.6877385],
              [44.6110747, 37.6877401],
              [44.6108787, 37.6871438],
              [44.6097391, 37.6862204],
              [44.6083566, 37.6853896],
              [44.6075937, 37.6849271],
              [44.6067777, 37.6844443],
              [44.6059677, 37.6836953],
              [44.6049169, 37.6821727],
              [44.6034059, 37.6806131],
              [44.6027067, 37.6800965],
              [44.6006822, 37.6794074],
              [44.5991259, 37.6782223],
              [44.5976419, 37.6771439],
              [44.5967813, 37.6769914],
              [44.5963192, 37.6768663],
              [44.5957719, 37.6767779],
              [44.5937478, 37.6756226],
              [44.591811, 37.6758048],
              [44.5910324, 37.6757111],
              [44.5907018, 37.6750488],
              [44.5902063, 37.6736546],
              [44.5900308, 37.6726081],
              [44.589563, 37.671031],
              [44.588167, 37.670398],
              [44.586259, 37.670011],
              [44.584957, 37.669659],
              [44.583561, 37.669343],
              [44.58263, 37.669062],
              [44.581932, 37.668956],
              [44.58156, 37.668569],
              [44.580397, 37.668288],
              [44.578117, 37.667866],
              [44.576582, 37.667198],
              [44.574348, 37.665861],
              [44.574116, 37.665053],
              [44.574022, 37.663752],
              [44.574209, 37.663013],
              [44.574209, 37.66245],
              [44.574116, 37.661642],
              [44.574348, 37.660833],
              [44.574441, 37.660024],
              [44.574395, 37.658371],
              [44.574162, 37.657633],
              [44.573371, 37.656648],
              [44.572627, 37.65591],
              [44.572534, 37.655312],
              [44.571789, 37.654292],
              [44.571463, 37.652604],
              [44.570998, 37.651795],
              [44.570672, 37.650846],
              [44.570114, 37.650107],
              [44.568904, 37.647329],
              [44.568765, 37.646309],
              [44.56816, 37.644762],
              [44.568113, 37.642828],
              [44.5683, 37.641773],
              [44.568625, 37.640894],
              [44.569602, 37.639522],
              [44.5706964, 37.6391306],
              [44.5715627, 37.6383411],
              [44.5730314, 37.6374982],
              [44.5737834, 37.6372754],
              [44.5745968, 37.6373697],
              [44.5765518, 37.637922],
              [44.5775965, 37.6379892],
              [44.5792172, 37.6377769],
              [44.5809446, 37.6373944],
              [44.5822722, 37.635982],
              [44.5827337, 37.6349322],
              [44.5830036, 37.6335444],
              [44.5831286, 37.6319788],
              [44.5833253, 37.6313572],
              [44.5838301, 37.6306163],
              [44.5847476, 37.6298665],
              [44.5855538, 37.628977],
              [44.5862092, 37.6273421],
              [44.5871749, 37.6257762],
              [44.5889636, 37.6242575],
              [44.589981, 37.6232213],
              [44.5911854, 37.6220932],
              [44.5920888, 37.6208426],
              [44.5928412, 37.6191619],
              [44.5932365, 37.617728],
              [44.5939256, 37.6170041],
              [44.5952714, 37.6162937],
              [44.5964007, 37.6162403],
              [44.5973886, 37.6167937],
              [44.5987162, 37.6171827],
              [44.6001412, 37.6167702],
              [44.6017983, 37.6154614],
              [44.6044075, 37.613057],
              [44.605249, 37.6124524],
              [44.6063954, 37.6119351],
              [44.606499, 37.611671],
              [44.606778, 37.61139],
              [44.607569, 37.610862],
              [44.607057, 37.60942],
              [44.607662, 37.608928],
              [44.607988, 37.608084],
              [44.608686, 37.607627],
              [44.610175, 37.605974],
              [44.610873, 37.605447],
              [44.611384, 37.60513],
              [44.612408, 37.604743],
              [44.612873, 37.604321],
              [44.613897, 37.603161],
              [44.614409, 37.602176],
              [44.614455, 37.600629],
              [44.614083, 37.599855],
              [44.613525, 37.599011],
              [44.613059, 37.597499],
              [44.612827, 37.596972],
              [44.612268, 37.596057],
              [44.611989, 37.594897],
              [44.611989, 37.592787],
              [44.612222, 37.592365],
              [44.612408, 37.591873],
              [44.612082, 37.590958],
              [44.6120546, 37.5903736],
              [44.6115803, 37.589518],
              [44.6107332, 37.5882625],
              [44.6091733, 37.5865513],
              [44.6074879, 37.5855594],
              [44.6060497, 37.5845371],
              [44.6038468, 37.5835551],
              [44.6009847, 37.5827075],
              [44.5989035, 37.580766],
              [44.5999845, 37.5791098],
              [44.6004876, 37.5784965],
              [44.6011461, 37.5782327],
              [44.6012878, 37.577706],
              [44.6018722, 37.5769611],
              [44.6023151, 37.5766007],
              [44.602757, 37.5765437],
              [44.6037939, 37.5768917],
              [44.604764, 37.5768214],
              [44.6051803, 37.5768437],
              [44.6059682, 37.576717],
              [44.6062889, 37.5762491],
              [44.6065967, 37.5759748],
              [44.6075562, 37.5757073],
              [44.6079368, 37.575226],
              [44.6080607, 37.574855],
              [44.6090059, 37.5741582],
              [44.6095208, 37.5734767],
              [44.6101261, 37.573115],
              [44.6109984, 37.572296],
              [44.6119794, 37.5719628],
              [44.6128461, 37.5713523],
              [44.6128495, 37.5710973],
              [44.61067, 37.570843],
              [44.609555, 37.570967],
              [44.608767, 37.570942],
              [44.608267, 37.570738],
              [44.607988, 37.570351],
              [44.607941, 37.57],
              [44.608276, 37.569653],
              [44.608593, 37.569472],
              [44.608964, 37.569158],
              [44.609337, 37.568734],
              [44.60943, 37.568382],
              [44.610047, 37.56772],
              [44.6105, 37.567714],
              [44.610873, 37.567257],
              [44.611338, 37.56694],
              [44.611752, 37.56658],
              [44.612703, 37.566505],
              [44.613246, 37.566588],
              [44.613664, 37.566483],
              [44.613943, 37.56592],
              [44.6142351, 37.5654695],
              [44.6143026, 37.5649391],
              [44.613998, 37.5639997],
              [44.6132202, 37.5634829],
              [44.6128748, 37.5624509],
              [44.6127572, 37.5619157],
              [44.6123769, 37.5616599],
              [44.6119371, 37.5612944],
              [44.6113955, 37.5613465],
              [44.6110825, 37.5616228],
              [44.610243, 37.56182],
              [44.609784, 37.56182],
              [44.6095931, 37.5616583],
              [44.609325, 37.561201],
              [44.6088784, 37.5606555],
              [44.6081058, 37.5603528],
              [44.6072489, 37.5598485],
              [44.606209, 37.56006],
              [44.6056736, 37.5600206],
              [44.6051854, 37.5597716],
              [44.6047958, 37.5598201],
              [44.6040823, 37.560329],
              [44.6036565, 37.5602937],
              [44.602922, 37.5600387],
              [44.6025968, 37.559819],
              [44.6026639, 37.5589784],
              [44.6026268, 37.5583765],
              [44.601782, 37.557458],
              [44.6015647, 37.5571076],
              [44.6013139, 37.5566178],
              [44.6012501, 37.5560898],
              [44.6013714, 37.554896],
              [44.6017877, 37.554283],
              [44.6017727, 37.5538591],
              [44.602372, 37.553392],
              [44.602823, 37.553436],
              [44.603289, 37.553331],
              [44.603568, 37.552663],
              [44.603815, 37.552252],
              [44.604219, 37.55203],
              [44.604766, 37.55131],
              [44.6049598, 37.5510006],
              [44.6058612, 37.5503942],
              [44.6065693, 37.5501202],
              [44.6071822, 37.5497659],
              [44.6079562, 37.5495037],
              [44.6085701, 37.5495148],
              [44.6092636, 37.5496785],
              [44.610161, 37.549835],
              [44.6107219, 37.5498721],
              [44.6113237, 37.5499082],
              [44.6120182, 37.549867],
              [44.612406, 37.5496616],
              [44.6129374, 37.5489605],
              [44.6132991, 37.5485128],
              [44.6136502, 37.5480422],
              [44.6137887, 37.5476266],
              [44.6136796, 37.5471958],
              [44.6134156, 37.546853],
              [44.6133652, 37.5465548],
              [44.6136062, 37.5457821],
              [44.613618, 37.5454054],
              [44.6129882, 37.5446882],
              [44.6124471, 37.5442818],
              [44.6104966, 37.5437377],
              [44.6102737, 37.5435572],
              [44.60992, 37.543133],
              [44.6100475, 37.5429076],
              [44.610407, 37.5425],
              [44.6105, 37.542219],
              [44.6107365, 37.5420116],
              [44.6108469, 37.5416015],
              [44.6104997, 37.541187],
              [44.6103106, 37.5409905],
              [44.6093188, 37.5406102],
              [44.608259, 37.539821],
              [44.607144, 37.539474],
              [44.607029, 37.539114],
              [44.606964, 37.538315],
              [44.607197, 37.538104],
              [44.607243, 37.537612],
              [44.607144, 37.536648],
              [44.606499, 37.535396],
              [44.606359, 37.534834],
              [44.606313, 37.533603],
              [44.606127, 37.53304],
              [44.606127, 37.532091],
              [44.605755, 37.531704],
              [44.605615, 37.531458],
              [44.605615, 37.531247],
              [44.605382, 37.530825],
              [44.605357, 37.530314],
              [44.60516, 37.529818],
              [44.604865, 37.52957],
              [44.604638, 37.529278],
              [44.604701, 37.528405],
              [44.604307, 37.52791],
              [44.603586, 37.527662],
              [44.602634, 37.526645],
              [44.60247, 37.525852],
              [44.602208, 37.525282],
              [44.601913, 37.524786],
              [44.601474, 37.524249],
              [44.601421, 37.523621],
              [44.601159, 37.522927],
              [44.601288, 37.522174],
              [44.601846, 37.5214],
              [44.601986, 37.520767],
              [44.602125, 37.519677],
              [44.602079, 37.519115],
              [44.6018, 37.518482],
              [44.601893, 37.517919],
              [44.601765, 37.517512],
              [44.601009, 37.517286],
              [44.601175, 37.51667],
              [44.601126, 37.51616],
              [44.600798, 37.515491],
              [44.601027, 37.515119],
              [44.601519, 37.514722],
              [44.601454, 37.514202],
              [44.600798, 37.513755],
              [44.600273, 37.513483],
              [44.599847, 37.513458],
              [44.599191, 37.513532],
              [44.598076, 37.513309],
              [44.597584, 37.512665],
              [44.597125, 37.512367],
              [44.596928, 37.512045],
              [44.59637, 37.5115],
              [44.595583, 37.511425],
              [44.594862, 37.511227],
              [44.594435, 37.510979],
              [44.594107, 37.510706],
              [44.593648, 37.510459],
              [44.592533, 37.510459],
              [44.591779, 37.510582],
              [44.590959, 37.510285],
              [44.590204, 37.509938],
              [44.589417, 37.510112],
              [44.5889004, 37.5102822],
              [44.5880259, 37.5102875],
              [44.5871453, 37.5103724],
              [44.5864993, 37.5095869],
              [44.5858112, 37.5090648],
              [44.5855668, 37.5087047],
              [44.5850189, 37.5073768],
              [44.5853583, 37.5054303],
              [44.5849292, 37.5029822],
              [44.5842451, 37.5005089],
              [44.5842732, 37.4979576],
              [44.5842201, 37.4961326],
              [44.5841999, 37.4954372],
              [44.5834458, 37.4930948],
              [44.5832911, 37.4929726],
              [44.5831367, 37.4912132],
              [44.583684, 37.4878593],
              [44.5830567, 37.4858576],
              [44.582373, 37.4840103],
              [44.5826706, 37.4818827],
              [44.5844259, 37.4797683],
              [44.5856885, 37.4776739],
              [44.5861583, 37.4743386],
              [44.586187, 37.4732038],
              [44.5863739, 37.472156],
              [44.586663, 37.4709687],
              [44.5864517, 37.4700289],
              [44.5859674, 37.4687254],
              [44.585706, 37.4678047],
              [44.5858668, 37.4666989],
              [44.5864544, 37.4654318],
              [44.5876071, 37.4616644],
              [44.5875512, 37.4598877],
              [44.5871219, 37.4583516],
              [44.5869082, 37.457294],
              [44.5866245, 37.454062],
              [44.5864477, 37.452705],
              [44.5862519, 37.451861],
              [44.5850992, 37.4511321],
              [44.584179, 37.4504217],
              [44.5832289, 37.4501594],
              [44.5806867, 37.4487332],
              [44.5798293, 37.4476059],
              [44.5804039, 37.4469999],
              [44.5813572, 37.4461274],
              [44.5826672, 37.4447731],
              [44.5839614, 37.4440012],
              [44.5854584, 37.4418465],
              [44.587315, 37.439619],
              [44.5894703, 37.4388465],
              [44.5910918, 37.4384922],
              [44.5926814, 37.4382887],
              [44.5945594, 37.4382919],
              [44.5964265, 37.4384847],
              [44.5985117, 37.4384015],
              [44.6010691, 37.4378989],
              [44.6056452, 37.4364999],
              [44.6064364, 37.4363167],
              [44.6074612, 37.4363408],
              [44.6086151, 37.4364549],
              [44.6134393, 37.4365554],
              [44.6147723, 37.4367602],
              [44.6167361, 37.4371966],
              [44.6178014, 37.4373461],
              [44.6190122, 37.4371387],
              [44.622475, 37.435273],
              [44.622915, 37.434816],
              [44.625006, 37.433735],
              [44.627976, 37.432695],
              [44.628471, 37.432571],
              [44.629406, 37.432197],
              [44.630286, 37.431989],
              [44.630891, 37.431615],
              [44.631551, 37.431032],
              [44.632156, 37.430243],
              [44.632872, 37.429577],
              [44.633807, 37.428871],
              [44.634192, 37.428455],
              [44.635237, 37.426418],
              [44.635842, 37.425919],
              [44.636227, 37.425004],
              [44.636612, 37.424298],
              [44.636722, 37.423674],
              [44.636557, 37.423175],
              [44.636117, 37.422552],
              [44.635402, 37.422219],
              [44.634522, 37.420847],
              [44.634742, 37.419891],
              [44.634797, 37.419101],
              [44.635072, 37.418311],
              [44.635457, 37.417646],
              [44.636392, 37.41644],
              [44.637217, 37.415858],
              [44.637932, 37.414985],
              [44.638537, 37.414403],
              [44.639032, 37.413821],
              [44.639802, 37.412699],
              [44.640407, 37.412283],
              [44.641508, 37.411077],
              [44.642498, 37.410537],
              [44.643158, 37.409955],
              [44.644533, 37.408915],
              [44.645963, 37.408417],
              [44.646788, 37.407959],
              [44.647228, 37.407502],
              [44.648163, 37.407045],
              [44.648878, 37.406047],
              [44.649484, 37.405091],
              [44.650144, 37.4048],
              [44.650859, 37.403719],
              [44.6519494, 37.4027744],
              [44.653236, 37.4025707],
              [44.6541264, 37.4025512],
              [44.6548084, 37.4024333],
              [44.6554316, 37.4024779],
              [44.6559968, 37.4022666],
              [44.656156, 37.4016809],
              [44.6570621, 37.4000864],
              [44.657252, 37.3991879],
              [44.6569198, 37.3988646],
              [44.6563025, 37.3985075],
              [44.6557306, 37.3983609],
              [44.655265, 37.3980762],
              [44.6547925, 37.3970748],
              [44.6546759, 37.3962874],
              [44.6541424, 37.3950059],
              [44.6535095, 37.3937083],
              [44.6533641, 37.3928092],
              [44.6534767, 37.3920948],
              [44.6544204, 37.389706],
              [44.6548637, 37.3882033],
              [44.6557959, 37.3869335],
              [44.6573683, 37.3859048],
              [44.6595444, 37.3851743],
              [44.6624996, 37.3846323],
              [44.6648184, 37.384347],
              [44.6685497, 37.3833234],
              [44.6692297, 37.3832283],
              [44.6710786, 37.3834883],
              [44.673354, 37.3843829],
              [44.6748582, 37.384536],
              [44.6782099, 37.383566],
              [44.6792692, 37.3836004],
              [44.6803792, 37.3833915],
              [44.681454, 37.382526],
              [44.6824285, 37.3822521],
              [44.6839768, 37.3824953],
              [44.6841869, 37.3826006],
              [44.6844329, 37.3829135],
              [44.6847843, 37.3832231],
              [44.6854734, 37.3837022],
              [44.6861074, 37.3844921],
              [44.686629, 37.3847342],
              [44.6870487, 37.3847722],
              [44.687664, 37.384699],
              [44.6892082, 37.3843458],
              [44.6893133, 37.3843217],
              [44.6907344, 37.3842507],
              [44.69267, 37.3842643],
              [44.6940136, 37.3838777],
              [44.6972014, 37.3834742],
              [44.6987781, 37.3828805],
              [44.7002688, 37.3820093],
              [44.7010266, 37.3814309],
              [44.7025156, 37.3810977],
              [44.7042855, 37.3808145],
              [44.7055509, 37.3808381],
              [44.7065384, 37.381065],
              [44.7080873, 37.3808083],
              [44.7110653, 37.3801957],
              [44.7125739, 37.3795749],
              [44.7138493, 37.3783224],
              [44.7162054, 37.3769079],
              [44.717517, 37.3769021],
              [44.7186626, 37.3763685],
              [44.7199387, 37.3763896],
              [44.7214731, 37.3756933],
              [44.7215132, 37.3742369],
              [44.7214012, 37.3734576],
              [44.7210002, 37.3730451],
              [44.720774, 37.3726801],
              [44.7209911, 37.3720293],
              [44.7217691, 37.3706167],
              [44.7218428, 37.3698607],
              [44.723871, 37.3664334],
              [44.7239569, 37.3661264],
              [44.7240212, 37.3655977],
              [44.7244289, 37.3635171],
              [44.7244504, 37.3617093],
              [44.7245362, 37.3604472],
              [44.7243216, 37.3596797],
              [44.7238545, 37.3585337],
              [44.7243044, 37.3579976],
              [44.7244252, 37.3569091],
              [44.7240689, 37.355904],
              [44.7244089, 37.3548696],
              [44.7252907, 37.3540731],
              [44.7261704, 37.3536512],
              [44.7260626, 37.3531575],
              [44.7266605, 37.3525331],
              [44.7268536, 37.351885],
              [44.7273043, 37.3503668],
              [44.7303512, 37.3479958],
              [44.732776, 37.3463923],
              [44.7334412, 37.344857],
              [44.7332909, 37.3436117],
              [44.7323468, 37.3426223],
              [44.732434, 37.342232],
              [44.733424, 37.342024],
              [44.734139, 37.341775],
              [44.735239, 37.341525],
              [44.736669, 37.340777],
              [44.737384, 37.340527],
              [44.738209, 37.340029],
              [44.738869, 37.339738],
              [44.739695, 37.338573],
              [44.74019, 37.337991],
              [44.741015, 37.336536],
              [44.741565, 37.33583],
              [44.74261, 37.335164],
              [44.743215, 37.334624],
              [44.744975, 37.334458],
              [44.7458, 37.334084],
              [44.7469, 37.334042],
              [44.747781, 37.333793],
              [44.748771, 37.333418],
              [44.749761, 37.332629],
              [44.750283, 37.332064],
              [44.750833, 37.331856],
              [44.751713, 37.331357],
              [44.754023, 37.330817],
              [44.755233, 37.330276],
              [44.756444, 37.330235],
              [44.757159, 37.33011],
              [44.758864, 37.329985],
              [44.761394, 37.329486],
              [44.762604, 37.329486],
              [44.763319, 37.32957],
              [44.76519, 37.329985],
              [44.765905, 37.330069],
              [44.76695, 37.330069],
              [44.770635, 37.328406],
              [44.77124, 37.327948],
              [44.772121, 37.327366],
              [44.772946, 37.326909],
              [44.774376, 37.325911],
              [44.774761, 37.325329],
              [44.775091, 37.324581],
              [44.775641, 37.323708],
              [44.776026, 37.32325],
              [44.776631, 37.322793],
              [44.778391, 37.32192],
              [44.779216, 37.321297],
              [44.779986, 37.320839],
              [44.781197, 37.320424],
              [44.784057, 37.318677],
              [44.784937, 37.318303],
              [44.785982, 37.317513],
              [44.786697, 37.316807],
              [44.787467, 37.316225],
              [44.787907, 37.315809],
              [44.788678, 37.315227],
              [44.790218, 37.314229],
              [44.790878, 37.313897],
              [44.791923, 37.313689],
              [44.793793, 37.313023],
              [44.795993, 37.311319],
              [44.797314, 37.311111],
              [44.798139, 37.310903],
              [44.798524, 37.310654],
              [44.799184, 37.310113],
              [44.799294, 37.309947],
              [44.799514, 37.309282],
              [44.799514, 37.306995],
              [44.799569, 37.306538],
              [44.8003507, 37.3050917],
              [44.800999, 37.303628],
              [44.801879, 37.30263],
              [44.804574, 37.300718],
              [44.805015, 37.300053],
              [44.8054, 37.299263],
              [44.805565, 37.298639],
              [44.806005, 37.297766],
              [44.8068075, 37.2967427],
              [44.8070635, 37.2957912],
              [44.8073334, 37.2947856],
              [44.8075567, 37.2940517],
              [44.8079333, 37.2933238],
              [44.80826, 37.291987],
              [44.808535, 37.29153],
              [44.808755, 37.290906],
              [44.80881, 37.290408],
              [44.809415, 37.288869],
              [44.8098, 37.288204],
              [44.810295, 37.287622],
              [44.812385, 37.28546],
              [44.813376, 37.284504],
              [44.813761, 37.283631],
              [44.814256, 37.2828],
              [44.814751, 37.282218],
              [44.815026, 37.281345],
              [44.815191, 37.280472],
              [44.815136, 37.279599],
              [44.814641, 37.278642],
              [44.814586, 37.27806],
              [44.814201, 37.277561],
              [44.813926, 37.276813],
              [44.813541, 37.276314],
              [44.812826, 37.275649],
              [44.81178, 37.274859],
              [44.810845, 37.274527],
              [44.809745, 37.273986],
              [44.80881, 37.273612],
              [44.807765, 37.27303],
              [44.80639, 37.27249],
              [44.805235, 37.271783],
              [44.804299, 37.271325],
              [44.803749, 37.270785],
              [44.803419, 37.270286],
              [44.802979, 37.269829],
              [44.802759, 37.269081],
              [44.802319, 37.268166],
              [44.801879, 37.266004],
              [44.801659, 37.264216],
              [44.801659, 37.26351],
              [44.801549, 37.262678],
              [44.801219, 37.261847],
              [44.801219, 37.26168],
              [44.8009182, 37.26047],
              [44.799844, 37.259477],
              [44.799349, 37.259144],
              [44.798799, 37.258646],
              [44.797644, 37.258105],
              [44.796489, 37.257648],
              [44.795058, 37.257149],
              [44.794453, 37.256983],
              [44.792253, 37.256609],
              [44.790383, 37.256692],
              [44.789338, 37.256858],
              [44.788458, 37.256733],
              [44.787302, 37.256401],
              [44.786257, 37.255943],
              [44.785267, 37.255444],
              [44.783892, 37.254655],
              [44.779161, 37.251703],
              [44.778446, 37.251246],
              [44.777126, 37.250248],
              [44.776466, 37.249874],
              [44.7683538, 37.2446406],
              [44.7676519, 37.2437223],
              [44.7670445, 37.2424543],
              [44.7668754, 37.2404631],
              [44.7664531, 37.2384022],
              [44.7652816, 37.2373539],
              [44.7633238, 37.2367088],
              [44.7616876, 37.2358718],
              [44.7607645, 37.2348668],
              [44.7600861, 37.2340251],
              [44.7597642, 37.2323871],
              [44.7589207, 37.2302385],
              [44.7575679, 37.2283412],
              [44.7587949, 37.2261548],
              [44.7604299, 37.2246004],
              [44.7617913, 37.2241955],
              [44.762648, 37.2234991],
              [44.7624122, 37.222607],
              [44.7615496, 37.2218182],
              [44.7606121, 37.219223],
              [44.760624, 37.218277],
              [44.760459, 37.217279],
              [44.760349, 37.21545],
              [44.760514, 37.213163],
              [44.760459, 37.211916],
              [44.760679, 37.209546],
              [44.761229, 37.207093],
              [44.761559, 37.205971],
              [44.761944, 37.204973],
              [44.763264, 37.202687],
              [44.763924, 37.201232],
              [44.764474, 37.200483],
              [44.76519, 37.199735],
              [44.76596, 37.198571],
              [44.767115, 37.195578],
              [44.767445, 37.194123],
              [44.767885, 37.193208],
              [44.76805, 37.192626],
              [44.76794, 37.191878],
              [44.767665, 37.190838],
              [44.766732, 37.1891532],
              [44.7665119, 37.188229],
              [44.7665655, 37.1875127],
              [44.766345, 37.186515],
              [44.76629, 37.185933],
              [44.76662, 37.184893],
              [44.76596, 37.184103],
              [44.766125, 37.183106],
              [44.768325, 37.181235],
              [44.769205, 37.180985],
              [44.76992, 37.180528],
              [44.77058, 37.180362],
              [44.77135, 37.179905],
              [44.771845, 37.179156],
              [44.77212, 37.178491],
              [44.772065, 37.177535],
              [44.772725, 37.176911],
              [44.774431, 37.17608],
              [44.775586, 37.175872],
              [44.778226, 37.174874],
              [44.779326, 37.174292],
              [44.780371, 37.173627],
              [44.781086, 37.173003],
              [44.782792, 37.170925],
              [44.783562, 37.169678],
              [44.784222, 37.168472],
              [44.784772, 37.167724],
              [44.784992, 37.1671],
              [44.785212, 37.166352],
              [44.785267, 37.165686],
              [44.785267, 37.165063],
              [44.785047, 37.163317],
              [44.785102, 37.16261],
              [44.785707, 37.161197],
              [44.785817, 37.16049],
              [44.785817, 37.159492],
              [44.785707, 37.158827],
              [44.785212, 37.158286],
              [44.784607, 37.157372],
              [44.783562, 37.156208],
              [44.783452, 37.154961],
              [44.783731, 37.154278],
              [44.783925, 37.15336],
              [44.784314, 37.152405],
              [44.784508, 37.151267],
              [44.785984, 37.149896],
              [44.785522, 37.14939],
              [44.785085, 37.148463],
              [44.784914, 37.147667],
              [44.784809, 37.14649],
              [44.784835, 37.145635],
              [44.7849294, 37.1450862],
              [44.7846709, 37.1446404],
              [44.7844154, 37.1440877],
              [44.7843055, 37.1438498],
              [44.783599, 37.14377],
              [44.783271, 37.143654],
              [44.783001, 37.14359],
              [44.7825578, 37.143604],
              [44.7821032, 37.14359],
              [44.781804, 37.143652],
              [44.7814771, 37.143593],
              [44.78116, 37.143648],
              [44.7807031, 37.143678],
              [44.7804061, 37.143901],
              [44.7801491, 37.14396],
              [44.7798679, 37.143539],
              [44.779666, 37.1433],
              [44.7793841, 37.143073],
              [44.779167, 37.142775],
              [44.7790709, 37.142426],
              [44.7789442, 37.142318],
              [44.7788779, 37.142199],
              [44.7787951, 37.142019],
              [44.7787681, 37.141955],
              [44.7786421, 37.141807],
              [44.778461, 37.141573],
              [44.7782789, 37.141332],
              [44.7779009, 37.141198],
              [44.777677, 37.140876],
              [44.7775031, 37.140573],
              [44.7773501, 37.140409],
              [44.7770722, 37.140359],
              [44.7765739, 37.140312],
              [44.7761329, 37.140106],
              [44.7757222, 37.13993],
              [44.775387, 37.139805],
              [44.7749561, 37.139824],
              [44.77464, 37.139733],
              [44.7742699, 37.139611],
              [44.773898, 37.139506],
              [44.7733051, 37.139497],
              [44.7728411, 37.139444],
              [44.772516, 37.139341],
              [44.7721499, 37.139211],
              [44.7718208, 37.139015],
              [44.7713971, 37.138908],
              [44.7706919, 37.138789],
              [44.7701962, 37.138623],
              [44.7698149, 37.138526],
              [44.7694718, 37.138473],
              [44.7687968, 37.138488],
              [44.7683249, 37.138503],
              [44.7677269, 37.138573],
              [44.7676492, 37.13841],
              [44.7673252, 37.138182],
              [44.7669691, 37.137946],
              [44.7666019, 37.137681],
              [44.7664478, 37.137487],
              [44.766184, 37.13732],
              [44.7658891, 37.137172],
              [44.7655421, 37.137046],
              [44.7653819, 37.136802],
              [44.7650129, 37.136784],
              [44.764798, 37.13663],
              [44.7643905, 37.1366095],
              [44.7640284, 37.1365222],
              [44.763878, 37.1364737],
              [44.7638412, 37.1363698],
              [44.7638419, 37.136169],
              [44.763853, 37.135993],
              [44.7639379, 37.13583],
              [44.7640409, 37.135675],
              [44.7641971, 37.135316],
              [44.7643699, 37.135031],
              [44.7644171, 37.134602],
              [44.7644902, 37.134283],
              [44.7645679, 37.133966],
              [44.7646381, 37.133712],
              [44.764466, 37.133517],
              [44.764375, 37.133322],
              [44.7643238, 37.133047],
              [44.7642839, 37.13274],
              [44.7641269, 37.132512],
              [44.7641831, 37.13225],
              [44.7642079, 37.132053],
              [44.764331, 37.131828],
              [44.7644228, 37.13162],
              [44.764519, 37.131355],
              [44.7645881, 37.131124],
              [44.7645841, 37.130774],
              [44.764605, 37.13046],
              [44.7646, 37.130461],
              [44.7646471, 37.130085],
              [44.764663, 37.12985],
              [44.7647152, 37.129568],
              [44.7643861, 37.129344],
              [44.7641629, 37.128999],
              [44.7639689, 37.128862],
              [44.763538, 37.12857],
              [44.763129, 37.128507],
              [44.7629309, 37.128452],
              [44.762711, 37.128391],
              [44.7623359, 37.128333],
              [44.76199, 37.128332],
              [44.7613852, 37.128319],
              [44.761005, 37.128241],
              [44.7604931, 37.128107],
              [44.760182, 37.127938],
              [44.759826, 37.1278],
              [44.7593692, 37.127573],
              [44.759129, 37.127335],
              [44.758939, 37.127241],
              [44.7585329, 37.126979],
              [44.758229, 37.126788],
              [44.7579349, 37.126614],
              [44.757734, 37.126466],
              [44.757392, 37.126081],
              [44.756874, 37.125872],
              [44.756563, 37.12576],
              [44.756262, 37.125053],
              [44.7557288, 37.12496],
              [44.7555989, 37.125098],
              [44.755497, 37.125305],
              [44.7550931, 37.125443],
              [44.7545891, 37.125338],
              [44.75417, 37.125626],
              [44.7537809, 37.125648],
              [44.7534781, 37.125636],
              [44.7532268, 37.125625],
              [44.7528128, 37.125385],
              [44.752477, 37.125189],
              [44.752162, 37.124838],
              [44.7519359, 37.124578],
              [44.7518182, 37.124224],
              [44.7516472, 37.123962],
              [44.7514621, 37.123777],
              [44.7510352, 37.123564],
              [44.7507382, 37.12332],
              [44.7505402, 37.122939],
              [44.750227, 37.122627],
              [44.749926, 37.122503],
              [44.749643, 37.122295],
              [44.7493471, 37.122],
              [44.749152, 37.121715],
              [44.7489479, 37.12142],
              [44.748855, 37.121118],
              [44.7487639, 37.120854],
              [44.7485828, 37.120686],
              [44.748293, 37.120532],
              [44.747914, 37.12047],
              [44.7476029, 37.120276],
              [44.747699, 37.119905],
              [44.7477592, 37.119709],
              [44.7479629, 37.119405],
              [44.7481379, 37.119056],
              [44.748403, 37.11864],
              [44.748611, 37.118194],
              [44.749071, 37.117623],
              [44.749246, 37.117084],
              [44.749473, 37.116704],
              [44.7498, 37.116521],
              [44.749886, 37.116308],
              [44.74985, 37.115998],
              [44.750046, 37.115292],
              [44.750236, 37.115003],
              [44.750398, 37.114238],
              [44.749666, 37.112879],
              [44.750385, 37.112112],
              [44.751228, 37.111405],
              [44.751635, 37.111258],
              [44.75182, 37.111144],
              [44.752142, 37.110595],
              [44.75241, 37.110355],
              [44.752764, 37.110139],
              [44.753291, 37.109896],
              [44.754517, 37.109592],
              [44.754696, 37.109584],
              [44.755043, 37.109661],
              [44.757096, 37.108715],
              [44.75762, 37.108183],
              [44.758381, 37.107877],
              [44.758683, 37.107815],
              [44.758915, 37.10758],
              [44.759624, 37.10718],
              [44.760012, 37.107058],
              [44.76023, 37.10679],
              [44.760373, 37.106411],
              [44.760804, 37.106233],
              [44.761197, 37.105863],
              [44.761503, 37.105683],
              [44.762174, 37.105413],
              [44.7624753, 37.1052457],
              [44.7626113, 37.105111],
              [44.7629184, 37.1047999],
              [44.763273, 37.104383],
              [44.763705, 37.103313],
              [44.763747, 37.102777],
              [44.76441, 37.101821],
              [44.765402, 37.100578],
              [44.765629, 37.100224],
              [44.765721, 37.099827],
              [44.766149, 37.099635],
              [44.766923, 37.099521],
              [44.767386, 37.099541],
              [44.767813, 37.099374],
              [44.768187, 37.099109],
              [44.768575, 37.099015],
              [44.768807, 37.098671],
              [44.769089, 37.098414],
              [44.769465, 37.09835],
              [44.770415, 37.098356],
              [44.771516, 37.098154],
              [44.772204, 37.097578],
              [44.772555, 37.097433],
              [44.772904, 37.097222],
              [44.773686, 37.096296],
              [44.774439, 37.096012],
              [44.774992, 37.095878],
              [44.77527, 37.095903],
              [44.77589, 37.096392],
              [44.776218, 37.096441],
              [44.77743, 37.096401],
              [44.777736, 37.096464],
              [44.778074, 37.096343],
              [44.778291, 37.096153],
              [44.778758, 37.095288],
              [44.779128, 37.094792],
              [44.779947, 37.094082],
              [44.780343, 37.093891],
              [44.781339, 37.092896],
              [44.78231, 37.092641],
              [44.783485, 37.092708],
              [44.783908, 37.092362],
              [44.783981, 37.091209],
              [44.784089, 37.090976],
              [44.784185, 37.090496],
              [44.784423, 37.090073],
              [44.784561, 37.089667],
              [44.784067, 37.089348],
              [44.783499, 37.089197],
              [44.781574, 37.088369],
              [44.780812, 37.087878],
              [44.780061, 37.087136],
              [44.77977, 37.08657],
              [44.778992, 37.085927],
              [44.778578, 37.085768],
              [44.778369, 37.085559],
              [44.77829, 37.085378],
              [44.778217, 37.084702],
              [44.778129, 37.084477],
              [44.777906, 37.084259],
              [44.7775463, 37.0840144],
              [44.7769632, 37.0836844],
              [44.7769269, 37.0836123],
              [44.7768906, 37.0835401],
              [44.7768911, 37.0833301],
              [44.777294, 37.082138],
              [44.77755, 37.081575],
              [44.777826, 37.081263],
              [44.778228, 37.080388],
              [44.778207, 37.079993],
              [44.778041, 37.079153],
              [44.777872, 37.078764],
              [44.777761, 37.078222],
              [44.777954, 37.077352],
              [44.7774821, 37.076901],
              [44.7774808, 37.0764026],
              [44.777665, 37.075947],
              [44.777723, 37.075656],
              [44.778199, 37.075593],
              [44.778388, 37.075637],
              [44.779292, 37.075519],
              [44.780697, 37.075617],
              [44.781226, 37.075736],
              [44.781763, 37.075752],
              [44.782094, 37.075709],
              [44.782569, 37.075288],
              [44.782953, 37.07518],
              [44.783439, 37.074862],
              [44.784611, 37.074507],
              [44.78501, 37.074327],
              [44.78529, 37.07406],
              [44.785462, 37.073641],
              [44.785905, 37.073626],
              [44.786554, 37.073701],
              [44.786897, 37.073653],
              [44.787267, 37.073153],
              [44.787704, 37.073058],
              [44.788257, 37.072873],
              [44.7885, 37.07263],
              [44.789126, 37.072332],
              [44.789392, 37.072137],
              [44.789933, 37.071627],
              [44.790672, 37.071057],
              [44.791113, 37.070845],
              [44.791386, 37.070653],
              [44.792654, 37.070178],
              [44.793141, 37.069838],
              [44.794683, 37.069012],
              [44.795123, 37.068846],
              [44.795974, 37.068279],
              [44.797474, 37.06765],
              [44.798021, 37.067632],
              [44.798323, 37.067675],
              [44.798812, 37.067646],
              [44.799062, 37.067521],
              [44.799206, 37.067089],
              [44.799282, 37.066576],
              [44.799618, 37.065979],
              [44.799851, 37.065399],
              [44.799933, 37.064833],
              [44.799869, 37.064223],
              [44.799502, 37.063507],
              [44.799499, 37.063331],
              [44.800253, 37.062886],
              [44.800552, 37.062566],
              [44.801196, 37.062177],
              [44.801354, 37.062028],
              [44.801483, 37.061479],
              [44.801461, 37.06089],
              [44.801328, 37.06082],
              [44.801339, 37.060544],
              [44.801476, 37.060356],
              [44.801812, 37.060252],
              [44.802121, 37.060002],
              [44.802465, 37.059471],
              [44.802568, 37.059077],
              [44.802618, 37.058533],
              [44.802859, 37.057737],
              [44.802912, 37.057397],
              [44.803037, 37.057021],
              [44.803182, 37.056843],
              [44.802967, 37.056412],
              [44.803012, 37.056095],
              [44.802968, 37.055954],
              [44.802773, 37.055834],
              [44.802607, 37.055593],
              [44.802563, 37.055374],
              [44.802649, 37.054741],
              [44.802584, 37.054508],
              [44.802587, 37.053841],
              [44.802657, 37.053552],
              [44.803131, 37.052936],
              [44.803784, 37.052588],
              [44.803887, 37.052444],
              [44.803783, 37.052204],
              [44.803454, 37.051929],
              [44.803266, 37.051618],
              [44.803346, 37.051179],
              [44.8032665, 37.0511138],
              [44.802599, 37.050566],
              [44.802427, 37.050277],
              [44.802684, 37.049795],
              [44.802616, 37.049552],
              [44.80253, 37.049337],
              [44.802223, 37.049076],
              [44.801787, 37.048223],
              [44.801953, 37.04808],
              [44.802879, 37.048118],
              [44.803301, 37.048011],
              [44.803889, 37.04768],
              [44.804557, 37.047397],
              [44.804871, 37.04706],
              [44.805131, 37.046867],
              [44.805461, 37.046768],
              [44.805879, 37.046778],
              [44.806708, 37.046416],
              [44.806869, 37.046143],
              [44.806849, 37.045533],
              [44.806937, 37.044804],
              [44.80709, 37.044413],
              [44.807265, 37.044148],
              [44.807642, 37.04414],
              [44.808009, 37.044229],
              [44.808813, 37.044709],
              [44.80939, 37.044874],
              [44.809842, 37.044952],
              [44.810266, 37.044909],
              [44.81079, 37.044489],
              [44.811176, 37.044251],
              [44.811925, 37.043891],
              [44.812678, 37.043685],
              [44.812905, 37.04343],
              [44.813175, 37.042791],
              [44.813619, 37.042339],
              [44.814717, 37.041415],
              [44.815364, 37.041043],
              [44.815935, 37.040609],
              [44.815968, 37.0405718],
              [44.816285, 37.040214],
              [44.81666, 37.039928],
              [44.81708, 37.039755],
              [44.818206, 37.039746],
              [44.819011, 37.039902],
              [44.819207, 37.040001],
              [44.819828, 37.040933],
              [44.820429, 37.041125],
              [44.820513, 37.041711],
              [44.821615, 37.042083],
              [44.822231, 37.042068],
              [44.82307, 37.04194],
              [44.82419, 37.042232],
              [44.825289, 37.042372],
              [44.825913, 37.042553],
              [44.826318, 37.042861],
              [44.82694, 37.043117],
              [44.827293, 37.04336],
              [44.827631, 37.0437],
              [44.828244, 37.044108],
              [44.829226, 37.04488],
              [44.829644, 37.045028],
              [44.830295, 37.045082],
              [44.83063, 37.045168],
              [44.832261, 37.045004],
              [44.832549, 37.045043],
              [44.833491, 37.045285],
              [44.834313, 37.045657],
              [44.834538, 37.045881],
              [44.835297, 37.046087],
              [44.835592, 37.046099],
              [44.836004, 37.046195],
              [44.836883, 37.04649],
              [44.837364, 37.046557],
              [44.838025, 37.046577],
              [44.839229, 37.046746],
              [44.839499, 37.046953],
              [44.839724, 37.047202],
              [44.84032, 37.047398],
              [44.841218, 37.047994],
              [44.841984, 37.048064],
              [44.842311, 37.048276],
              [44.842857, 37.048438],
              [44.8431287, 37.0484298],
              [44.843658, 37.048309],
              [44.84437, 37.048032],
              [44.845467, 37.047757],
              [44.845875, 37.04756],
              [44.846472, 37.047352],
              [44.847351, 37.047154],
              [44.848604, 37.046391],
              [44.849463, 37.046489],
              [44.849751, 37.046665],
              [44.850423, 37.046947],
              [44.850773, 37.047233],
              [44.85113, 37.047436],
              [44.851461, 37.047506],
              [44.851922, 37.04746],
              [44.853399, 37.047028],
              [44.854548, 37.04709],
              [44.85484, 37.046768],
              [44.855414, 37.046291],
              [44.856249, 37.046009],
              [44.856416, 37.045682],
              [44.857017, 37.044969],
              [44.857725, 37.044457],
              [44.858336, 37.044115],
              [44.85857, 37.043619],
              [44.858595, 37.043182],
              [44.858462, 37.042897],
              [44.858134, 37.041621],
              [44.857926, 37.041496],
              [44.857718, 37.04129],
              [44.85737, 37.040659],
              [44.857086, 37.04031],
              [44.857031, 37.039005],
              [44.856862, 37.03837],
              [44.856818, 37.037957],
              [44.856923, 37.03744],
              [44.857073, 37.037035],
              [44.857855, 37.036959],
              [44.858355, 37.037058],
              [44.85887, 37.037028],
              [44.85935, 37.036658],
              [44.859866, 37.036473],
              [44.860316, 37.036164],
              [44.860713, 37.035836],
              [44.860998, 37.035452],
              [44.861381, 37.035203],
              [44.862032, 37.034876],
              [44.863519, 37.034489],
              [44.864132, 37.034485],
              [44.864712, 37.034335],
              [44.86503, 37.034153],
              [44.865536, 37.033572],
              [44.865897, 37.033386],
              [44.866228, 37.033287],
              [44.867109, 37.032497],
              [44.867545, 37.032399],
              [44.867962, 37.03205],
              [44.86834, 37.031805],
              [44.86896, 37.031558],
              [44.870403, 37.031494],
              [44.871036, 37.031773],
              [44.871876, 37.031785],
              [44.8733, 37.03213],
              [44.874238, 37.032191],
              [44.874651, 37.032265],
              [44.875277, 37.032154],
              [44.876031, 37.031979],
              [44.876433, 37.031837],
              [44.877416, 37.031636],
              [44.877799, 37.031656],
              [44.879215, 37.031449],
              [44.88013, 37.031572],
              [44.880249, 37.031497],
              [44.880495, 37.031161],
              [44.880859, 37.030933],
              [44.88117, 37.030612],
              [44.881332, 37.030371],
              [44.881905, 37.030078],
              [44.88221, 37.030032],
              [44.882501, 37.030028],
              [44.883245, 37.030193],
              [44.883658, 37.030454],
              [44.88474, 37.030794],
              [44.885078, 37.030948],
              [44.885553, 37.03091],
              [44.887162, 37.031222],
              [44.889109, 37.030594],
              [44.889543, 37.030376],
              [44.890247, 37.029928],
              [44.890679, 37.029866],
              [44.89137, 37.029659],
              [44.891571, 37.029398],
              [44.891894, 37.029127],
              [44.892215, 37.029174],
              [44.892451, 37.029369],
              [44.893592, 37.02934],
              [44.893885, 37.029293],
              [44.894135, 37.028784],
              [44.895227, 37.028023],
              [44.895414, 37.027785],
              [44.895536, 37.027473],
              [44.895522, 37.027087],
              [44.895359, 37.02667],
              [44.895299, 37.026323],
              [44.895497, 37.025992],
              [44.895977, 37.025432],
              [44.896332, 37.025304],
              [44.896779, 37.02525],
              [44.897078, 37.025093],
              [44.897245, 37.024847],
              [44.897331, 37.024541],
              [44.897627, 37.024345],
              [44.898717, 37.02393],
              [44.899431, 37.023882],
              [44.899758, 37.023762],
              [44.900072, 37.023729],
              [44.90046, 37.022951],
              [44.900482, 37.022451],
              [44.900916, 37.021715],
              [44.9008966, 37.0212244],
              [44.900542, 37.020806],
              [44.900496, 37.020599],
              [44.900538, 37.020349],
              [44.900461, 37.020065],
              [44.900866, 37.019394],
              [44.900794, 37.019061],
              [44.901092, 37.018852],
              [44.901165, 37.018653],
              [44.900882, 37.01824],
              [44.900783, 37.017922],
              [44.901054, 37.01749],
              [44.901375, 37.017203],
              [44.901636, 37.016506],
              [44.901617, 37.016216],
              [44.901448, 37.015959],
              [44.901398, 37.015004],
              [44.900834, 37.013841],
              [44.900983, 37.013722],
              [44.902099, 37.013283],
              [44.902699, 37.012909],
              [44.90298, 37.01256],
              [44.903481, 37.012209],
              [44.903595, 37.011954],
              [44.903621, 37.011667],
              [44.903533, 37.011176],
              [44.903617, 37.010996],
              [44.903802, 37.010877],
              [44.904173, 37.010518],
              [44.90475, 37.010174],
              [44.905143, 37.010024],
              [44.905552, 37.009779],
              [44.905102, 37.009258],
              [44.90468, 37.008124],
              [44.904464, 37.007225],
              [44.904553, 37.006921],
              [44.904532, 37.005864],
              [44.904662, 37.005239],
              [44.904546, 37.00495],
              [44.90447, 37.004383],
              [44.904334, 37.004162],
              [44.904065, 37.004045],
              [44.90316, 37.003824],
              [44.901579, 37.003634],
              [44.900572, 37.002813],
              [44.899686, 37.002476],
              [44.899497, 37.002313],
              [44.899389, 37.002103],
              [44.899157, 37.001964],
              [44.898518, 37.0017],
              [44.898279, 37.001658],
              [44.897796, 36.999847],
              [44.896284, 36.998445],
              [44.895916, 36.998159],
              [44.895569, 36.998051],
              [44.895437, 36.997627],
              [44.895454, 36.997209],
              [44.895723, 36.996329],
              [44.89589, 36.996064],
              [44.895741, 36.995526],
              [44.895836, 36.99488],
              [44.895986, 36.994693],
              [44.89578, 36.993931],
              [44.895628, 36.993574],
              [44.895197, 36.993183],
              [44.894839, 36.992597],
              [44.894665, 36.992053],
              [44.894595, 36.991436],
              [44.894745, 36.990866],
              [44.89501, 36.990211],
              [44.895078, 36.989847],
              [44.894884, 36.989178],
              [44.894624, 36.988542],
              [44.894318, 36.988064],
              [44.894169, 36.987718],
              [44.894062, 36.986714],
              [44.893962, 36.986465],
              [44.892925, 36.985042],
              [44.892777, 36.984653],
              [44.892493, 36.98319],
              [44.89207, 36.982445],
              [44.891919, 36.981801],
              [44.891859, 36.981322],
              [44.891893, 36.980676],
              [44.892069, 36.979866],
              [44.892235, 36.978579],
              [44.891691, 36.977888],
              [44.891604, 36.977498],
              [44.891399, 36.977172],
              [44.890793, 36.976578],
              [44.89026, 36.976503],
              [44.889772, 36.976239],
              [44.889488, 36.975554],
              [44.889745, 36.973462],
              [44.889697, 36.972788],
              [44.889826, 36.972049],
              [44.889543, 36.971669],
              [44.888937, 36.971577],
              [44.88877, 36.971462],
              [44.888387, 36.970678],
              [44.888351, 36.970194],
              [44.888421, 36.967943],
              [44.888299, 36.967734],
              [44.888232, 36.967103],
              [44.887394, 36.964962],
              [44.887371, 36.964529],
              [44.887081, 36.964112],
              [44.886669, 36.963312],
              [44.885191, 36.96248],
              [44.885026, 36.962221],
              [44.884902, 36.961828],
              [44.884586, 36.961501],
              [44.884329, 36.961121],
              [44.884214, 36.960715],
              [44.883978, 36.960512],
              [44.883691, 36.96001],
              [44.883637, 36.959167],
              [44.883931, 36.957995],
              [44.883904, 36.957498],
              [44.88329, 36.956532],
              [44.882852, 36.95563],
              [44.882736, 36.955171],
              [44.882758, 36.954677],
              [44.882687, 36.954349],
              [44.882725, 36.954011],
              [44.882994, 36.953761],
              [44.883405, 36.953537],
              [44.883811, 36.953198],
              [44.884212, 36.952742],
              [44.88473, 36.951775],
              [44.885432, 36.950711],
              [44.885559, 36.950336],
              [44.885025, 36.948375],
              [44.884389, 36.947711],
              [44.884551, 36.947234],
              [44.884828, 36.946822],
              [44.886599, 36.945992],
              [44.887849, 36.945683],
              [44.888732, 36.94562],
              [44.889774, 36.945849],
              [44.890273, 36.945876],
              [44.891142, 36.945517],
              [44.891721, 36.945424],
              [44.892394, 36.94541],
              [44.893125, 36.945236],
              [44.894169, 36.945325],
              [44.894453, 36.945182],
              [44.89458, 36.94496],
              [44.894973, 36.944858],
              [44.896185, 36.944933],
              [44.896642, 36.943965],
              [44.896769, 36.943398],
              [44.896998, 36.942941],
              [44.897767, 36.941897],
              [44.898134, 36.94116],
              [44.898296, 36.940683],
              [44.8983741, 36.9400165],
              [44.898467, 36.939224],
              [44.898675, 36.938781],
              [44.899128, 36.938529],
              [44.899523, 36.938437],
              [44.899917, 36.938196],
              [44.900184, 36.937839],
              [44.900233, 36.937647],
              [44.900134, 36.936622],
              [44.899673, 36.935873],
              [44.899462, 36.935378],
              [44.89982, 36.934365],
              [44.900119, 36.933992],
              [44.900566, 36.933229],
              [44.900577, 36.932545],
              [44.900888, 36.931295],
              [44.901041, 36.930927],
              [44.901765, 36.930434],
              [44.902053, 36.929967],
              [44.902917, 36.929204],
              [44.903627, 36.927925],
              [44.903982, 36.926849],
              [44.904315, 36.926512],
              [44.904741, 36.925668],
              [44.905135, 36.925426],
              [44.905659, 36.924874],
              [44.90608, 36.924638],
              [44.906968, 36.924308],
              [44.907642, 36.923814],
              [44.908306, 36.923567],
              [44.908725, 36.923524],
              [44.909028, 36.923405],
              [44.909827, 36.922772],
              [44.910274, 36.922062],
              [44.910802, 36.920795],
              [44.910767, 36.919927],
              [44.910943, 36.918872],
              [44.911179, 36.918542],
              [44.912229, 36.917394],
              [44.912415, 36.917009],
              [44.912456, 36.916639],
              [44.912184, 36.91586],
              [44.911957, 36.915492],
              [44.911646, 36.915117],
              [44.911511, 36.91456],
              [44.911508, 36.91425],
              [44.911755, 36.913919],
              [44.911838, 36.913712],
              [44.911728, 36.912794],
              [44.911466, 36.912585],
              [44.910541, 36.912335],
              [44.910133, 36.912132],
              [44.909796, 36.911819],
              [44.909661, 36.911476],
              [44.908815, 36.910311],
              [44.9088, 36.910051],
              [44.908939, 36.909544],
              [44.9089657, 36.9093654],
              [44.909048, 36.908814],
              [44.909203, 36.908294],
              [44.909433, 36.907866],
              [44.909962, 36.907621],
              [44.910435, 36.907206],
              [44.91084, 36.906568],
              [44.911283, 36.905647],
              [44.911417, 36.905207],
              [44.911445, 36.903955],
              [44.911554, 36.903317],
              [44.911701, 36.902928],
              [44.911981, 36.902622],
              [44.912286, 36.901203],
              [44.912191, 36.900879],
              [44.911651, 36.899814],
              [44.91178, 36.89945],
              [44.911768, 36.899015],
              [44.91201, 36.898609],
              [44.912361, 36.898343],
              [44.91258, 36.897803],
              [44.912388, 36.897283],
              [44.911709, 36.896744],
              [44.911068, 36.895911],
              [44.910964, 36.895599],
              [44.911044, 36.895233],
              [44.911338, 36.894988],
              [44.911156, 36.894754],
              [44.911092, 36.894373],
              [44.909592, 36.893681],
              [44.909009, 36.893562],
              [44.908402, 36.893256],
              [44.908021, 36.892823],
              [44.907524, 36.890908],
              [44.906674, 36.889739],
              [44.906465, 36.889596],
              [44.905614, 36.888565],
              [44.905985, 36.88804],
              [44.905565, 36.887402],
              [44.905498, 36.887137],
              [44.905205, 36.886709],
              [44.904971, 36.886176],
              [44.904883, 36.885829],
              [44.904534, 36.885519],
              [44.904442, 36.885205],
              [44.90406, 36.884815],
              [44.904188, 36.884479],
              [44.904378, 36.884172],
              [44.904698, 36.883821],
              [44.905467, 36.882727],
              [44.905704, 36.882206],
              [44.90581, 36.88167],
              [44.905711, 36.881084],
              [44.905033, 36.880086],
              [44.904496, 36.87954],
              [44.90415, 36.879038],
              [44.903669, 36.878511],
              [44.902968, 36.877927],
              [44.90273, 36.877297],
              [44.902036, 36.876487],
              [44.900535, 36.875698],
              [44.900578, 36.875006],
              [44.901266, 36.874474],
              [44.901958, 36.874205],
              [44.90268, 36.874138],
              [44.903046, 36.873996],
              [44.903265, 36.873691],
              [44.903246, 36.873471],
              [44.902832, 36.872552],
              [44.902857, 36.87205],
              [44.903374, 36.870124],
              [44.903627, 36.868762],
              [44.903681, 36.868177],
              [44.903601, 36.867666],
              [44.902669, 36.866227],
              [44.902617, 36.865875],
              [44.902656, 36.86543],
              [44.902829, 36.864804],
              [44.902835, 36.864179],
              [44.902767, 36.863714],
              [44.903091, 36.863431],
              [44.903349, 36.863287],
              [44.903702, 36.861819],
              [44.903699, 36.86141],
              [44.903508, 36.861113],
              [44.903126, 36.860871],
              [44.902813, 36.860499],
              [44.902139, 36.859968],
              [44.901938, 36.859186],
              [44.901879, 36.858505],
              [44.901359, 36.857176],
              [44.900128, 36.856619],
              [44.899596, 36.856443],
              [44.89911, 36.856395],
              [44.898732, 36.856219],
              [44.898104, 36.856314],
              [44.897179, 36.855751],
              [44.896598, 36.855632],
              [44.896204, 36.855294],
              [44.895999, 36.854893],
              [44.895101, 36.85374],
              [44.894719, 36.853449],
              [44.892883, 36.853626],
              [44.89164, 36.853822],
              [44.891079, 36.853631],
              [44.890608, 36.85359],
              [44.889062, 36.853705],
              [44.888514, 36.853512],
              [44.887946, 36.853147],
              [44.886959, 36.852741],
              [44.886549, 36.852787],
              [44.8845, 36.852388],
              [44.883943, 36.852362],
              [44.883327, 36.852055],
              [44.882932, 36.851912],
              [44.882533, 36.851907],
              [44.881297, 36.852277],
              [44.88087, 36.85216],
              [44.880232, 36.851467],
              [44.879935, 36.851257],
              [44.879653, 36.850958],
              [44.87975, 36.850638],
              [44.879756, 36.850413],
              [44.87967, 36.850077],
              [44.879213, 36.849692],
              [44.878962, 36.849562],
              [44.878204, 36.8493],
              [44.8772, 36.849132],
              [44.876621, 36.849168],
              [44.876133, 36.849062],
              [44.875658, 36.848856],
              [44.874989, 36.848295],
              [44.874714, 36.84817],
              [44.874576, 36.847785],
              [44.874278, 36.847469],
              [44.874174, 36.847215],
              [44.873343, 36.846868],
              [44.872628, 36.846228],
              [44.87088, 36.845951],
              [44.870045, 36.845888],
              [44.869552, 36.845763],
              [44.868674, 36.845834],
              [44.867641, 36.8461],
              [44.867145, 36.846112],
              [44.865807, 36.845536],
              [44.86539, 36.845407],
              [44.864969, 36.845464],
              [44.864491, 36.845697],
              [44.862625, 36.84586],
              [44.861645, 36.84633],
              [44.86133, 36.846348],
              [44.861483, 36.845648],
              [44.861449, 36.845215],
              [44.861495, 36.844895],
              [44.861244, 36.844219],
              [44.86112, 36.843082],
              [44.861198, 36.842541],
              [44.861635, 36.841848],
              [44.861417, 36.841547],
              [44.861112, 36.83936],
              [44.861091, 36.83798],
              [44.861241, 36.837514],
              [44.86144, 36.837195],
              [44.862181, 36.836739],
              [44.862778, 36.835822],
              [44.863149, 36.835472],
              [44.863746, 36.835116],
              [44.864153, 36.834548],
              [44.864482, 36.834351],
              [44.865264, 36.83413],
              [44.865657, 36.833923],
              [44.865928, 36.833623],
              [44.866017, 36.832951],
              [44.86626, 36.832752],
              [44.86684, 36.831883],
              [44.865898, 36.831808],
              [44.865453, 36.831876],
              [44.864994, 36.832006],
              [44.863734, 36.831828],
              [44.861878, 36.831805],
              [44.861299, 36.831843],
              [44.860042, 36.832135],
              [44.859934, 36.832238],
              [44.859696, 36.832261],
              [44.85946, 36.83238],
              [44.859183, 36.832372],
              [44.858041, 36.832016],
              [44.857685, 36.831648],
              [44.857119, 36.831246],
              [44.856508, 36.830913],
              [44.85527, 36.83074],
              [44.853844, 36.830381],
              [44.852992, 36.830561],
              [44.852471, 36.830554],
              [44.851798, 36.829864],
              [44.850881, 36.828517],
              [44.850492, 36.828216],
              [44.849642, 36.827723],
              [44.849324, 36.827392],
              [44.849104, 36.826607],
              [44.848771, 36.825938],
              [44.847837, 36.825311],
              [44.84708, 36.824942],
              [44.845995, 36.823859],
              [44.845335, 36.823412],
              [44.844629, 36.822177],
              [44.843999, 36.821322],
              [44.843699, 36.820586],
              [44.843089, 36.820104],
              [44.842602, 36.819803],
              [44.84147, 36.818841],
              [44.840937, 36.817981],
              [44.840109, 36.817145],
              [44.839278, 36.817001],
              [44.839326, 36.816645],
              [44.838666, 36.81612],
              [44.838355, 36.815753],
              [44.838514, 36.815201],
              [44.838489, 36.814794],
              [44.838664, 36.814195],
              [44.839157, 36.813166],
              [44.839164, 36.812378],
              [44.839055, 36.811381],
              [44.839065, 36.810304],
              [44.839256, 36.809746],
              [44.839191, 36.809363],
              [44.838978, 36.809085],
              [44.838647, 36.808888],
              [44.838204, 36.808824],
              [44.837244, 36.808542],
              [44.837166, 36.808144],
              [44.837272, 36.807067],
              [44.837035, 36.806618],
              [44.837085, 36.806207],
              [44.83767, 36.805442],
              [44.83778, 36.804994],
              [44.837672, 36.804541],
              [44.837733, 36.804128],
              [44.837485, 36.803531],
              [44.837594, 36.803382],
              [44.838193, 36.803025],
              [44.838292, 36.802728],
              [44.838057, 36.802445],
              [44.837951, 36.802157],
              [44.838027, 36.800788],
              [44.837996, 36.800417],
              [44.837835, 36.799972],
              [44.837737, 36.799202],
              [44.8373, 36.798717],
              [44.836876, 36.798098],
              [44.836814, 36.797129],
              [44.837491, 36.795718],
              [44.837941, 36.794994],
              [44.838493, 36.794838],
              [44.838764, 36.794529],
              [44.838921, 36.794266],
              [44.839084, 36.793888],
              [44.839176, 36.79347],
              [44.839171, 36.793208],
              [44.839511, 36.792319],
              [44.839589, 36.791877],
              [44.839533, 36.791248],
              [44.839859, 36.790422],
              [44.840143, 36.790059],
              [44.840463, 36.789033],
              [44.840769, 36.788666],
              [44.841333, 36.787755],
              [44.8416, 36.787421],
              [44.841908, 36.78715],
              [44.842241, 36.786979],
              [44.842459, 36.786679],
              [44.842672, 36.785969],
              [44.842846, 36.785747],
              [44.843458, 36.785248],
              [44.843713, 36.784759],
              [44.843981, 36.783672],
              [44.843928, 36.78215],
              [44.844057, 36.781463],
              [44.844303, 36.78052],
              [44.844998, 36.778703],
              [44.845333, 36.778314],
              [44.845624, 36.77815],
              [44.845955, 36.77812],
              [44.846643, 36.778159],
              [44.847162, 36.777922],
              [44.847675, 36.777563],
              [44.848234, 36.77731],
              [44.849294, 36.777301],
              [44.849679, 36.777254],
              [44.850065, 36.777159],
              [44.850659, 36.776898],
              [44.851076, 36.77657],
              [44.852595, 36.775898],
              [44.85345, 36.77521],
              [44.853807, 36.775052],
              [44.854467, 36.774896],
              [44.854747, 36.774655],
              [44.855016, 36.774338],
              [44.854948, 36.774008],
              [44.855001, 36.773772],
              [44.855241, 36.773635],
              [44.856111, 36.773652],
              [44.856738, 36.773571],
              [44.858223, 36.773116],
              [44.858667, 36.773118],
              [44.858981, 36.773799],
              [44.85903, 36.774071],
              [44.859681, 36.77438],
              [44.859786, 36.774589],
              [44.85971, 36.775118],
              [44.860254, 36.775821],
              [44.860535, 36.776123],
              [44.860949, 36.776051],
              [44.861356, 36.776146],
              [44.862115, 36.776057],
              [44.862267, 36.776253],
              [44.862418, 36.77684],
              [44.862932, 36.778009],
              [44.862943, 36.778538],
              [44.863266, 36.778899],
              [44.863796, 36.779319],
              [44.864767, 36.779896],
              [44.865419, 36.779873],
              [44.865894, 36.779945],
              [44.866848, 36.779886],
              [44.867729, 36.780029],
              [44.868037, 36.779934],
              [44.868462, 36.779642],
              [44.868853, 36.779523],
              [44.86924, 36.779482],
              [44.86977, 36.7796],
              [44.870215, 36.779841],
              [44.870833, 36.779855],
              [44.871128, 36.780007],
              [44.871448, 36.780056],
              [44.871769, 36.77991],
              [44.872094, 36.779929],
              [44.872385, 36.779866],
              [44.873059, 36.779949],
              [44.873406, 36.780052],
              [44.873609, 36.779995],
              [44.873957, 36.779805],
              [44.874496, 36.779961],
              [44.874843, 36.779917],
              [44.875814, 36.779907],
              [44.876778, 36.780073],
              [44.877499, 36.78004],
              [44.879434, 36.779747],
              [44.8799, 36.779868],
              [44.880164, 36.779849],
              [44.880598, 36.779994],
              [44.881273, 36.780379],
              [44.882225, 36.781044],
              [44.882733, 36.781322],
              [44.883088, 36.78199],
              [44.884399, 36.782213],
              [44.885286, 36.782508],
              [44.886811, 36.78257],
              [44.887598, 36.782541],
              [44.888663, 36.782411],
              [44.889895, 36.782392],
              [44.890965, 36.782421],
              [44.891235, 36.782481],
              [44.89147, 36.782245],
              [44.891647, 36.781841],
              [44.891977, 36.781429],
              [44.892852, 36.780949],
              [44.893223, 36.780521],
              [44.893678, 36.780123],
              [44.894389, 36.77969],
              [44.895203, 36.779309],
              [44.895587, 36.779216],
              [44.896137, 36.779166],
              [44.896743, 36.778954],
              [44.897477, 36.778845],
              [44.899519, 36.779286],
              [44.900557, 36.779263],
              [44.902425, 36.779098],
              [44.902825, 36.779031],
              [44.903673, 36.778734],
              [44.904309, 36.778429],
              [44.904893, 36.778017],
              [44.905748, 36.777665],
              [44.906185, 36.777643],
              [44.906613, 36.777711],
              [44.90729, 36.778003],
              [44.907811, 36.77817],
              [44.909023, 36.778112],
              [44.910018, 36.777869],
              [44.910364, 36.777676],
              [44.910721, 36.777161],
              [44.910847, 36.776571],
              [44.91098, 36.776246],
              [44.911496, 36.776193],
              [44.91221, 36.776256],
              [44.913151, 36.776218],
              [44.914293, 36.776269],
              [44.915624, 36.776403],
              [44.916615, 36.776267],
              [44.917995, 36.775851],
              [44.9185946, 36.7756898],
              [44.9189269, 36.7756198],
              [44.9190676, 36.7756549],
              [44.919133, 36.775963],
              [44.919431, 36.776246],
              [44.920747, 36.77645],
              [44.92134, 36.776437],
              [44.921841, 36.776528],
              [44.92268, 36.776969],
              [44.924386, 36.77718],
              [44.924823, 36.777282],
              [44.925481, 36.777666],
              [44.927002, 36.778175],
              [44.927611, 36.778461],
              [44.928113, 36.77864],
              [44.928882, 36.779227],
              [44.930037, 36.779489],
              [44.930448, 36.779738],
              [44.93127, 36.781331],
              [44.931385, 36.781467],
              [44.931748, 36.781684],
              [44.932125, 36.78201],
              [44.932236, 36.782235],
              [44.932447, 36.783068],
              [44.932673, 36.783553],
              [44.932728, 36.783996],
              [44.932864, 36.784212],
              [44.933559, 36.784612],
              [44.934488, 36.784913],
              [44.934912, 36.784968],
              [44.935547, 36.784903],
              [44.936167, 36.784947],
              [44.936462, 36.785096],
              [44.937013, 36.785493],
              [44.93827, 36.786129],
              [44.938773, 36.786126],
              [44.940179, 36.785928],
              [44.940995, 36.78521],
              [44.941414, 36.784982],
              [44.942352, 36.784651],
              [44.942538, 36.784499],
              [44.943009, 36.783898],
              [44.943225, 36.783715],
              [44.943618, 36.783189],
              [44.944059, 36.782758],
              [44.944448, 36.782464],
              [44.945131, 36.781783],
              [44.945383, 36.781593],
              [44.945704, 36.781471],
              [44.945829, 36.781342],
              [44.946278, 36.781203],
              [44.946724, 36.780873],
              [44.947219, 36.780317],
              [44.948655, 36.77962],
              [44.949093, 36.77926],
              [44.949227, 36.779042],
              [44.949816, 36.778585],
              [44.949913, 36.778333],
              [44.951381, 36.777289],
              [44.951764, 36.77685],
              [44.951831, 36.776404],
              [44.952119, 36.775799],
              [44.952314, 36.775561],
              [44.952356, 36.77535],
              [44.952597, 36.774855],
              [44.953024, 36.774537],
              [44.953637, 36.774351],
              [44.953834, 36.7741],
              [44.954309, 36.773672],
              [44.954583, 36.773584],
              [44.955119, 36.773518],
              [44.955706, 36.773217],
              [44.95594, 36.773203],
              [44.956344, 36.773085],
              [44.957696, 36.772913],
              [44.958194, 36.772752],
              [44.958298, 36.772059],
              [44.958484, 36.771787],
              [44.958623, 36.771284],
              [44.959071, 36.770372],
              [44.959259, 36.770251],
              [44.959734, 36.769498],
              [44.959973, 36.769239],
              [44.960159, 36.768604],
              [44.960421, 36.768288],
              [44.960932, 36.767973],
              [44.961251, 36.76754],
              [44.961467, 36.766953],
              [44.96156, 36.766462],
              [44.96158, 36.76597],
              [44.961754, 36.765331],
              [44.961945, 36.765099],
              [44.962248, 36.764931],
              [44.962566, 36.764681],
              [44.962951, 36.764366],
              [44.963112, 36.764165],
              [44.963175, 36.76399],
              [44.963092, 36.763018],
              [44.963172, 36.762827],
              [44.963734, 36.762455],
              [44.964028, 36.762093],
              [44.964433, 36.761775],
              [44.965012, 36.761444],
              [44.965809, 36.760818],
              [44.966572, 36.759763],
              [44.967016, 36.75902],
              [44.967232, 36.758494],
              [44.967271, 36.75807],
              [44.967423, 36.757715],
              [44.967308, 36.757252],
              [44.967324, 36.756641],
              [44.967459, 36.756369],
              [44.967562, 36.755894],
              [44.967807, 36.755594],
              [44.967869, 36.755419],
              [44.96782, 36.755237],
              [44.967996, 36.754403],
              [44.967957, 36.753757],
              [44.968093, 36.753525],
              [44.968856, 36.752651],
              [44.968941, 36.752357],
              [44.968869, 36.751678],
              [44.969078, 36.751441],
              [44.970755, 36.750756],
              [44.971041, 36.750524],
              [44.971583, 36.750218],
              [44.972088, 36.750001],
              [44.972409, 36.749348],
              [44.972765, 36.749292],
              [44.973149, 36.749303],
              [44.974624, 36.749098],
              [44.975088, 36.748951],
              [44.975354, 36.74892],
              [44.975676, 36.748961],
              [44.976193, 36.74884],
              [44.976806, 36.748575],
              [44.978387, 36.748368],
              [44.978797, 36.748429],
              [44.979314, 36.748443],
              [44.980171, 36.748386],
              [44.981147, 36.74819],
              [44.982268, 36.748419],
              [44.982892, 36.748476],
              [44.983773, 36.74828],
              [44.984186, 36.748079],
              [44.984662, 36.747749],
              [44.9851, 36.747687],
              [44.985455, 36.747677],
              [44.985812, 36.747765],
              [44.986087, 36.747949],
              [44.986353, 36.748009],
              [44.986809, 36.747939],
              [44.987287, 36.747945],
              [44.987665, 36.747871],
              [44.988364, 36.747839],
              [44.989509, 36.747659],
              [44.989719, 36.747782],
              [44.990014, 36.748131],
              [44.990194, 36.748224],
              [44.990623, 36.748621],
              [44.990951, 36.749052],
              [44.991105, 36.749372],
              [44.991546, 36.750015],
              [44.99284, 36.750786],
              [44.993595, 36.750877],
              [44.994313, 36.750753],
              [44.99453, 36.750778],
              [44.994938, 36.751059],
              [44.996217, 36.752344],
              [44.997001, 36.75289],
              [44.997655, 36.753217],
              [44.998307, 36.753456],
              [44.999709, 36.753323],
              [45.001234, 36.752872],
              [45.001765, 36.752879],
              [45.002714, 36.753034],
              [45.003814, 36.753602],
              [45.004696, 36.753835],
              [45.00547, 36.753964],
              [45.006016, 36.754277],
              [45.006529, 36.754397],
              [45.006873, 36.754216],
              [45.007204, 36.754159],
              [45.008004, 36.75412],
              [45.008584, 36.753953],
              [45.009264, 36.753858],
              [45.009861, 36.753875],
              [45.01059, 36.753771],
              [45.011072, 36.753577],
              [45.012914, 36.753236],
              [45.013028, 36.752975],
              [45.012966, 36.752601],
              [45.013049, 36.751773],
              [45.012962, 36.750809],
              [45.0128249, 36.7500196],
              [45.012669, 36.749122],
              [45.012085, 36.747244],
              [45.012046, 36.74669],
              [45.012099, 36.746439],
              [45.012568, 36.746247],
              [45.013726, 36.746157],
              [45.014138, 36.74624],
              [45.01478, 36.746106],
              [45.015938, 36.745972],
              [45.016461, 36.745958],
              [45.016951, 36.74583],
              [45.017474, 36.745475],
              [45.018017, 36.744589],
              [45.018305, 36.744012],
              [45.018518, 36.743868],
              [45.01885, 36.743745],
              [45.019564, 36.743863],
              [45.020274, 36.743874],
              [45.020724, 36.743809],
              [45.022137, 36.743763],
              [45.023246, 36.743846],
              [45.023968, 36.743717],
              [45.024669, 36.743237],
              [45.02513, 36.74326],
              [45.025403, 36.743107],
              [45.02569, 36.742725],
              [45.026078, 36.742572],
              [45.026739, 36.742405],
              [45.027064, 36.742164],
              [45.027419, 36.742125],
              [45.028387, 36.741788],
              [45.028625, 36.741641],
              [45.028783, 36.741389],
              [45.029128, 36.741174],
              [45.029591, 36.74102],
              [45.029953, 36.74096],
              [45.030589, 36.740471],
              [45.031236, 36.739745],
              [45.031804, 36.738963],
              [45.032064, 36.738301],
              [45.032184, 36.737494],
              [45.032327, 36.737048],
              [45.032761, 36.736514],
              [45.033142, 36.736244],
              [45.033416, 36.735953],
              [45.033133, 36.735656],
              [45.032727, 36.735418],
              [45.032115, 36.735214],
              [45.031437, 36.734903],
              [45.031789, 36.734117],
              [45.03162, 36.733496],
              [45.031639, 36.73191],
              [45.031704, 36.731319],
              [45.031584, 36.730925],
              [45.031749, 36.730328],
              [45.032014, 36.729822],
              [45.032898, 36.728624],
              [45.033873, 36.727578],
              [45.034613, 36.72719],
              [45.035123, 36.727116],
              [45.035668, 36.726711],
              [45.036136, 36.726438],
              [45.037254, 36.726047],
              [45.037536, 36.725882],
              [45.037828, 36.724919],
              [45.038124, 36.724664],
              [45.038658, 36.724586],
              [45.039171, 36.724659],
              [45.039611, 36.724655],
              [45.039994, 36.724208],
              [45.040521, 36.724013],
              [45.040694, 36.723817],
              [45.039883, 36.722929],
              [45.039623, 36.72244],
              [45.0397, 36.721847],
              [45.039934, 36.721317],
              [45.040711, 36.720146],
              [45.041022, 36.719898],
              [45.041475, 36.719893],
              [45.041899, 36.720059],
              [45.042477, 36.720003],
              [45.043665, 36.71904],
              [45.044708, 36.718376],
              [45.045167, 36.718025],
              [45.045602, 36.717816],
              [45.046043, 36.717674],
              [45.046535, 36.715646],
              [45.047019, 36.71474],
              [45.047448, 36.714463],
              [45.047731, 36.713472],
              [45.047821, 36.712877],
              [45.048126, 36.712561],
              [45.049039, 36.711978],
              [45.049423, 36.711629],
              [45.049781, 36.710587],
              [45.05028, 36.710013],
              [45.050411, 36.709706],
              [45.050905, 36.709113],
              [45.051379, 36.708907],
              [45.0519, 36.708369],
              [45.052308, 36.708105],
              [45.05257, 36.707589],
              [45.053349, 36.706379],
              [45.054516, 36.70483],
              [45.054912, 36.704479],
              [45.055245, 36.703942],
              [45.055651, 36.703443],
              [45.056105, 36.703122],
              [45.057093, 36.702536],
              [45.057272, 36.702221],
              [45.057627, 36.701121],
              [45.057934, 36.700814],
              [45.058168, 36.700422],
              [45.058639, 36.699931],
              [45.059185, 36.699113],
              [45.059171, 36.698693],
              [45.059046, 36.698192],
              [45.059136, 36.697784],
              [45.059404, 36.697425],
              [45.059778, 36.697039],
              [45.060067, 36.696617],
              [45.06025, 36.696135],
              [45.060582, 36.695824],
              [45.061085, 36.695495],
              [45.061518, 36.695139],
              [45.062158, 36.693745],
              [45.062925, 36.692674],
              [45.063907, 36.690821],
              [45.064451, 36.690643],
              [45.06481, 36.690387],
              [45.065172, 36.690003],
              [45.065388, 36.689456],
              [45.065317, 36.688504],
              [45.065681, 36.687991],
              [45.065878, 36.686867],
              [45.06581, 36.685511],
              [45.065473, 36.684603],
              [45.065455, 36.684124],
              [45.065577, 36.68374],
              [45.06553, 36.682509],
              [45.065861, 36.680999],
              [45.066033, 36.680518],
              [45.0662064, 36.6802179],
              [45.0666309, 36.6796927],
              [45.067143, 36.679135],
              [45.067445, 36.678623],
              [45.0676949, 36.6784151],
              [45.0678528, 36.6782678],
              [45.067862, 36.677797],
              [45.0679429, 36.6774044],
              [45.0680241, 36.6767979],
              [45.0680973, 36.6763061],
              [45.0681134, 36.6757667],
              [45.0681658, 36.6754252],
              [45.0682528, 36.6750554],
              [45.0686758, 36.6744723],
              [45.0689369, 36.6738719],
              [45.0692067, 36.6732789],
              [45.0688249, 36.6729026],
              [45.0679722, 36.6707333],
              [45.0679562, 36.6701579],
              [45.0679779, 36.6695574],
              [45.0682623, 36.6689238],
              [45.0683555, 36.6678986],
              [45.0682811, 36.6678835],
              [45.0681147, 36.6668124],
              [45.0680509, 36.6667027],
              [45.06798, 36.665541],
              [45.0679195, 36.6646697],
              [45.067898, 36.663996],
              [45.0678789, 36.6634876],
              [45.067841, 36.6626041],
              [45.0678775, 36.6623164],
              [45.0681273, 36.6611734],
              [45.0685509, 36.6594097],
              [45.0687661, 36.6592488],
              [45.0689207, 36.6591651],
              [45.069311, 36.6585671],
              [45.0696404, 36.6574477],
              [45.0700634, 36.6567004],
              [45.0706158, 36.655322],
              [45.0707056, 36.6545495],
              [45.0706937, 36.6537803],
              [45.0708126, 36.6530491],
              [45.0709073, 36.652599],
              [45.0716931, 36.6520561],
              [45.071871, 36.6510074],
              [45.0718, 36.650379],
              [45.0716882, 36.649531],
              [45.0715305, 36.6488432],
              [45.0713006, 36.6482044],
              [45.0711856, 36.6463524],
              [45.0716859, 36.645595],
              [45.0711927, 36.645119],
              [45.0709854, 36.6444696],
              [45.0710173, 36.6441499],
              [45.0708521, 36.643751],
              [45.0700313, 36.6434931],
              [45.06969, 36.6433595],
              [45.0694432, 36.6432219],
              [45.0689478, 36.6431331],
              [45.0685241, 36.6430847],
              [45.067639, 36.64307],
              [45.067504, 36.642531],
              [45.067529, 36.642252],
              [45.067273, 36.6418152],
              [45.067546, 36.641256],
              [45.068026, 36.640705],
              [45.068382, 36.640528],
              [45.068593, 36.640286],
              [45.068745, 36.638767],
              [45.0693136, 36.6383298],
              [45.069243, 36.638006],
              [45.06957, 36.637677],
              [45.069594, 36.637397],
              [45.069531, 36.637122],
              [45.069616, 36.636833],
              [45.069902, 36.63654],
              [45.070007, 36.636277],
              [45.069928, 36.635897],
              [45.069941, 36.63553],
              [45.070395, 36.6345876],
              [45.07038, 36.634229],
              [45.070321, 36.633875],
              [45.070203, 36.633629],
              [45.069926, 36.633261],
              [45.070038, 36.632751],
              [45.069839, 36.631978],
              [45.0701111, 36.6312757],
              [45.0703713, 36.6308447],
              [45.0707771, 36.6302428],
              [45.0700708, 36.6292429],
              [45.0689563, 36.6280882],
              [45.068508, 36.627535],
              [45.068085, 36.626819],
              [45.067758, 36.626086],
              [45.067065, 36.624941],
              [45.066988, 36.624521],
              [45.067067, 36.623702],
              [45.067004, 36.623289],
              [45.066869, 36.622977],
              [45.066393, 36.62221],
              [45.066162, 36.621688],
              [45.065621, 36.619898],
              [45.06534, 36.619423],
              [45.064497, 36.61736],
              [45.064097, 36.616639],
              [45.063834, 36.616003],
              [45.063721, 36.615452],
              [45.063446, 36.615094],
              [45.062974, 36.61466],
              [45.062701, 36.614538],
              [45.061512, 36.614528],
              [45.061122, 36.614671],
              [45.060173, 36.614847],
              [45.059587, 36.614875],
              [45.057632, 36.615158],
              [45.057249, 36.61528],
              [45.056964, 36.615435],
              [45.0565076, 36.6155875],
              [45.0560943, 36.6155959],
              [45.0549465, 36.6156268],
              [45.054398, 36.615563],
              [45.053854, 36.615328],
              [45.053528, 36.615107],
              [45.053127, 36.615025],
              [45.052849, 36.614884],
              [45.052283, 36.614845],
              [45.051805, 36.614644],
              [45.05142, 36.614343],
              [45.05117, 36.614055],
              [45.050753, 36.613293],
              [45.050369, 36.612953],
              [45.049772, 36.612569],
              [45.049328, 36.612146],
              [45.048838, 36.611415],
              [45.048447, 36.611234],
              [45.0472927, 36.6108224],
              [45.0463189, 36.6104605],
              [45.0454918, 36.6102462],
              [45.0443105, 36.6096748],
              [45.043018, 36.608972],
              [45.0424615, 36.6084946],
              [45.0415684, 36.6081714],
              [45.040737, 36.608041],
              [45.040271, 36.607999],
              [45.039134, 36.607764],
              [45.03871, 36.607598],
              [45.0374892, 36.6074865],
              [45.036637, 36.607635],
              [45.035869, 36.607781],
              [45.033824, 36.607735],
              [45.0331481, 36.6075729],
              [45.0322093, 36.6075205],
              [45.0315997, 36.6074926],
              [45.030948, 36.607236],
              [45.0303405, 36.6067594],
              [45.0304128, 36.6063397],
              [45.0301462, 36.605935],
              [45.0296993, 36.6056101],
              [45.0289875, 36.6055686],
              [45.0283799, 36.6054459],
              [45.028064, 36.605184],
              [45.0276812, 36.6044446],
              [45.0274422, 36.6039342],
              [45.0271747, 36.6036343],
              [45.0269863, 36.6033748],
              [45.0269103, 36.6029749],
              [45.027002, 36.602645],
              [45.027231, 36.602007],
              [45.027135, 36.601747],
              [45.026682, 36.601153],
              [45.026427, 36.600684],
              [45.026374, 36.60026],
              [45.026668, 36.598245],
              [45.026561, 36.597948],
              [45.026487, 36.597311],
              [45.026834, 36.596595],
              [45.027189, 36.596369],
              [45.027533, 36.596243],
              [45.027688, 36.595933],
              [45.027719, 36.594595],
              [45.027942, 36.594303],
              [45.028145, 36.594129],
              [45.028237, 36.593755],
              [45.028304, 36.5921],
              [45.028393, 36.591321],
              [45.028714, 36.590777],
              [45.028637, 36.589486],
              [45.0291683, 36.5887843],
              [45.029862, 36.587868],
              [45.030064, 36.587297],
              [45.030757, 36.586957],
              [45.03165, 36.586385],
              [45.032089, 36.585274],
              [45.032587, 36.584701],
              [45.033275, 36.583653],
              [45.03384, 36.583249],
              [45.034024, 36.5827],
              [45.034315, 36.582236],
              [45.035056, 36.581746],
              [45.035552, 36.581703],
              [45.035921, 36.581945],
              [45.036305, 36.582051],
              [45.037048, 36.581221],
              [45.037844, 36.580703],
              [45.039384, 36.579903],
              [45.039642, 36.579058],
              [45.039302, 36.578538],
              [45.039168, 36.577955],
              [45.0389474, 36.5774869],
              [45.038668, 36.576894],
              [45.038557, 36.576006],
              [45.038698, 36.575435],
              [45.038982, 36.574992],
              [45.038762, 36.573668],
              [45.038714, 36.57308],
              [45.038593, 36.5726],
              [45.038571, 36.572065],
              [45.038718, 36.571616],
              [45.038407, 36.571214],
              [45.038325, 36.570689],
              [45.038333, 36.57013],
              [45.038583, 36.569352],
              [45.038811, 36.568881],
              [45.038902, 36.568308],
              [45.039146, 36.567853],
              [45.038857, 36.56655],
              [45.038954, 36.565608],
              [45.038814, 36.564951],
              [45.038515, 36.564594],
              [45.037974, 36.564352],
              [45.037385, 36.56358],
              [45.037619, 36.563182],
              [45.037712, 36.562912],
              [45.037605, 36.562287],
              [45.037688, 36.561783],
              [45.03762, 36.561312],
              [45.037641, 36.560903],
              [45.037445, 36.560415],
              [45.036561, 36.560334],
              [45.035194, 36.560001],
              [45.034576, 36.5598],
              [45.033916, 36.559776],
              [45.032618, 36.560064],
              [45.031744, 36.560075],
              [45.031365, 36.559845],
              [45.030168, 36.558757],
              [45.028238, 36.557656],
              [45.027907, 36.557616],
              [45.026496, 36.557696],
              [45.024436, 36.55726],
              [45.023963, 36.55729],
              [45.023303, 36.557464],
              [45.022821, 36.557515],
              [45.022179, 36.557413],
              [45.020425, 36.556718],
              [45.019999, 36.556741],
              [45.019469, 36.556941],
              [45.019124, 36.556846],
              [45.018594, 36.556896],
              [45.017684, 36.557158],
              [45.017235, 36.557336],
              [45.016524, 36.557452],
              [45.015582, 36.557682],
              [45.015146, 36.557423],
              [45.01471, 36.557259],
              [45.014181, 36.556675],
              [45.01371, 36.556318],
              [45.013215, 36.556116],
              [45.012738, 36.556184],
              [45.011601, 36.556078],
              [45.010875, 36.555942],
              [45.010815, 36.555602],
              [45.010911, 36.555048],
              [45.010915, 36.554424],
              [45.010804, 36.553932],
              [45.010635, 36.553554],
              [45.010214, 36.553151],
              [45.009631, 36.552349],
              [45.009194, 36.552034],
              [45.008468, 36.551747],
              [45.007861, 36.551638],
              [45.007043, 36.551678],
              [45.006258, 36.551845],
              [45.005179, 36.551823],
              [45.004416, 36.551637],
              [45.004268, 36.55134],
              [45.004405, 36.550949],
              [45.004311, 36.550672],
              [45.00427, 36.55031],
              [45.004808, 36.549107],
              [45.006341, 36.547637],
              [45.006961, 36.547007],
              [45.007134, 36.546761],
              [45.0050955, 36.5425773],
              [45.004854, 36.542139],
              [45.00456, 36.54146],
              [45.003807, 36.54062],
              [45.003516, 36.540195],
              [45.003158, 36.539999],
              [45.002711, 36.539544],
              [45.002363, 36.539336],
              [45.002129, 36.538798],
              [45.001556, 36.538382],
              [45.001781, 36.537307],
              [45.002177, 36.536571],
              [45.002449, 36.53544],
              [45.003626, 36.535162],
              [45.004129, 36.534853],
              [45.004771, 36.534559],
              [45.005136, 36.53414],
              [45.00511, 36.533644],
              [45.004724, 36.532838],
              [45.004863, 36.532164],
              [45.004785, 36.531704],
              [45.004998, 36.53132],
              [45.006007, 36.530965],
              [45.006308, 36.530586],
              [45.006846, 36.530223],
              [45.007001, 36.529509],
              [45.006958, 36.527315],
              [45.007082, 36.526331],
              [45.007449, 36.524987],
              [45.007866, 36.524238],
              [45.00827, 36.523926],
              [45.008868, 36.523309],
              [45.009276, 36.523213],
              [45.009913, 36.523194],
              [45.010372, 36.522958],
              [45.01089, 36.522609],
              [45.01122, 36.5223],
              [45.011202, 36.521934],
              [45.011528, 36.521116],
              [45.01171, 36.520906],
              [45.0120296, 36.5204057],
              [45.012269, 36.520031],
              [45.012812, 36.519441],
              [45.013635, 36.519079],
              [45.014052, 36.518822],
              [45.014581, 36.518717],
              [45.014799, 36.518501],
              [45.015022, 36.518408],
              [45.015657, 36.517983],
              [45.015953, 36.517982],
              [45.016219, 36.518061],
              [45.016505, 36.517919],
              [45.01673, 36.517882],
              [45.017435, 36.51789],
              [45.017731, 36.517936],
              [45.019371, 36.517534],
              [45.020732, 36.517302],
              [45.020944, 36.517163],
              [45.021034, 36.516884],
              [45.021641, 36.516643],
              [45.022099, 36.516303],
              [45.022415, 36.516138],
              [45.02343, 36.515754],
              [45.023702, 36.515558],
              [45.026514, 36.514663],
              [45.02906, 36.514774],
              [45.030633, 36.515045],
              [45.031231, 36.515362],
              [45.031795, 36.514782],
              [45.034218, 36.511907],
              [45.034681, 36.511491],
              [45.03522, 36.511176],
              [45.035704, 36.51104],
              [45.0368, 36.510539],
              [45.037405, 36.510241],
              [45.037794, 36.50997],
              [45.038195, 36.509847],
              [45.03857, 36.509918],
              [45.038735, 36.510033],
              [45.039992, 36.51027],
              [45.040466, 36.510438],
              [45.041493, 36.51129],
              [45.042467, 36.511385],
              [45.042982, 36.51132],
              [45.044424, 36.511263],
              [45.044865, 36.511152],
              [45.045681, 36.510612],
              [45.045965, 36.510122],
              [45.046676, 36.509656],
              [45.047323, 36.509531],
              [45.0476, 36.509599],
              [45.048207, 36.509461],
              [45.048405, 36.509514],
              [45.048675, 36.509507],
              [45.048858, 36.509402],
              [45.049292, 36.509359],
              [45.049501, 36.509108],
              [45.049273, 36.508937],
              [45.049147, 36.508731],
              [45.049238, 36.508452],
              [45.049248, 36.508195],
              [45.049631, 36.507802],
              [45.049921, 36.507679],
              [45.049998, 36.507345],
              [45.05013, 36.507134],
              [45.050407, 36.506909],
              [45.051096, 36.506702],
              [45.051605, 36.506666],
              [45.052246, 36.506466],
              [45.053169, 36.506504],
              [45.053896, 36.506649],
              [45.053994, 36.505884],
              [45.053959, 36.504825],
              [45.053896, 36.504231],
              [45.053447, 36.502435],
              [45.053395, 36.501933],
              [45.053481, 36.501461],
              [45.053512, 36.500847],
              [45.053406, 36.500349],
              [45.053495, 36.499891],
              [45.053658, 36.499482],
              [45.053724, 36.499079],
              [45.054087, 36.498656],
              [45.054267, 36.498366],
              [45.054594, 36.498043],
              [45.054976, 36.497768],
              [45.055053, 36.497633],
              [45.055086, 36.497495],
              [45.055005, 36.497244],
              [45.0548, 36.497089],
              [45.054716, 36.496753],
              [45.054693, 36.495997],
              [45.05493, 36.49507],
              [45.055138, 36.494767],
              [45.05524, 36.494509],
              [45.055275, 36.494031],
              [45.055031, 36.493429],
              [45.054608, 36.492946],
              [45.054412, 36.492628],
              [45.054477, 36.49114],
              [45.054885, 36.490378],
              [45.055048, 36.489573],
              [45.05478, 36.48922],
              [45.054484, 36.488603],
              [45.054419, 36.487579],
              [45.054609, 36.486806],
              [45.054537, 36.486275],
              [45.054574, 36.48531],
              [45.0522806, 36.4845929],
              [45.0539228, 36.4829766],
              [45.0540398, 36.4824476],
              [45.054048, 36.48227],
              [45.054409, 36.481914],
              [45.054482, 36.481689],
              [45.054682, 36.481501],
              [45.054834, 36.481244],
              [45.054949, 36.48089],
              [45.055177, 36.480546],
              [45.055763, 36.480025],
              [45.056092, 36.479588],
              [45.05678, 36.478937],
              [45.056963, 36.477915],
              [45.057291, 36.477351],
              [45.057605, 36.477078],
              [45.057823, 36.47674],
              [45.057949, 36.476431],
              [45.05799, 36.476151],
              [45.058258, 36.475965],
              [45.058413, 36.475595],
              [45.059455, 36.475027],
              [45.059268, 36.474746],
              [45.059191, 36.474414],
              [45.058446, 36.473705],
              [45.057947, 36.472994],
              [45.058769, 36.471447],
              [45.05904, 36.470557],
              [45.059107, 36.470206],
              [45.059105, 36.469805],
              [45.059319, 36.468759],
              [45.059347, 36.468353],
              [45.059514, 36.467839],
              [45.059727, 36.466848],
              [45.060156, 36.466041],
              [45.060367, 36.465801],
              [45.060678, 36.465597],
              [45.06078, 36.465408],
              [45.060908, 36.464767],
              [45.061401, 36.464099],
              [45.061753, 36.463253],
              [45.062314, 36.46285],
              [45.062465, 36.462791],
              [45.062663, 36.46258],
              [45.063493, 36.462252],
              [45.063711, 36.46208],
              [45.064032, 36.461965],
              [45.064484, 36.461911],
              [45.065147, 36.461756],
              [45.065415, 36.461624],
              [45.065764, 36.461652],
              [45.066042, 36.461603],
              [45.066285, 36.461704],
              [45.066588, 36.46172],
              [45.066855, 36.461614],
              [45.067468, 36.461223],
              [45.067839, 36.461077],
              [45.068207, 36.461007],
              [45.068431, 36.460871],
              [45.068701, 36.460813],
              [45.06928, 36.460508],
              [45.069692, 36.460445],
              [45.069887, 36.46032],
              [45.070343, 36.460287],
              [45.070599, 36.459826],
              [45.07107, 36.459311],
              [45.071537, 36.459036],
              [45.072003, 36.458863],
              [45.072221, 36.458697],
              [45.07259, 36.458301],
              [45.072992, 36.458182],
              [45.07335, 36.457926],
              [45.073765, 36.457714],
              [45.074139, 36.456747],
              [45.074635, 36.456099],
              [45.074926, 36.455925],
              [45.075542, 36.455779],
              [45.076158, 36.455339],
              [45.076223, 36.455056],
              [45.076022, 36.45475],
              [45.075988, 36.454005],
              [45.075797, 36.453052],
              [45.075869, 36.452874],
              [45.076744, 36.452053],
              [45.076943, 36.45165],
              [45.0771, 36.451489],
              [45.077245, 36.451229],
              [45.077323, 36.450948],
              [45.077677, 36.450342],
              [45.077705, 36.450124],
              [45.078033, 36.449213],
              [45.078278, 36.44886],
              [45.078418, 36.447774],
              [45.078336, 36.446941],
              [45.078514, 36.446627],
              [45.078746, 36.445573],
              [45.078551, 36.445197],
              [45.078727, 36.444937],
              [45.07879, 36.444606],
              [45.078744, 36.443798],
              [45.078577, 36.443508],
              [45.078482, 36.442405],
              [45.078617, 36.442259],
              [45.078678, 36.44179],
              [45.078202, 36.441016],
              [45.078229, 36.440691],
              [45.078373, 36.440495],
              [45.078203, 36.440056],
              [45.078222, 36.439861],
              [45.077771, 36.439317],
              [45.077706, 36.439168],
              [45.077468, 36.439003],
              [45.076881, 36.438797],
              [45.077167, 36.438592],
              [45.07705, 36.438405],
              [45.076495, 36.438103],
              [45.076153, 36.438009],
              [45.076035, 36.437518],
              [45.076105, 36.437389],
              [45.076393, 36.437295],
              [45.076859, 36.437021],
              [45.076951, 36.436812],
              [45.076912, 36.436606],
              [45.077025, 36.436506],
              [45.077105, 36.436236],
              [45.077311, 36.435341],
              [45.077321, 36.434929],
              [45.077528, 36.434605],
              [45.077676, 36.433997],
              [45.077826, 36.433635],
              [45.077836, 36.433356],
              [45.077697, 36.433082],
              [45.077776, 36.43277],
              [45.078042, 36.432589],
              [45.078115, 36.432416],
              [45.077974, 36.431961],
              [45.078226, 36.43181],
              [45.078288, 36.431511],
              [45.078171, 36.43069],
              [45.078198, 36.43053],
              [45.078592, 36.430503],
              [45.078935, 36.430368],
              [45.080298, 36.429657],
              [45.081107, 36.428981],
              [45.081325, 36.42858],
              [45.081442, 36.427872],
              [45.081418, 36.427545],
              [45.081522, 36.427239],
              [45.081478, 36.426469],
              [45.081591, 36.425878],
              [45.081587, 36.42549],
              [45.082205, 36.425327],
              [45.084174, 36.424978],
              [45.084869, 36.424695],
              [45.085028, 36.424577],
              [45.085335, 36.424218],
              [45.085714, 36.423581],
              [45.085905, 36.423531],
              [45.086268, 36.423536],
              [45.086738, 36.423282],
              [45.086886, 36.423144],
              [45.086933, 36.42296],
              [45.086912, 36.422782],
              [45.087097, 36.422408],
              [45.087331, 36.422324],
              [45.087889, 36.422236],
              [45.088121, 36.422078],
              [45.088361, 36.422025],
              [45.089438, 36.422047],
              [45.089899, 36.421976],
              [45.090241, 36.421873],
              [45.090537, 36.421853],
              [45.090846, 36.421968],
              [45.09137, 36.422302],
              [45.09189, 36.422348],
              [45.092575, 36.422206],
              [45.092696, 36.422057],
              [45.092805, 36.421771],
              [45.093021, 36.421594],
              [45.093249, 36.421479],
              [45.093489, 36.421426],
              [45.094538, 36.420899],
              [45.094861, 36.420692],
              [45.09527, 36.420279],
              [45.095952, 36.419859],
              [45.096311, 36.419711],
              [45.096686, 36.419644],
              [45.096831, 36.419555],
              [45.09738, 36.419489],
              [45.09805, 36.419072],
              [45.099135, 36.418933],
              [45.100025, 36.418456],
              [45.100565, 36.418243],
              [45.100752, 36.418109],
              [45.101186, 36.417925],
              [45.101444, 36.417741],
              [45.101698, 36.417632],
              [45.10246, 36.416708],
              [45.103153, 36.416345],
              [45.103755, 36.416095],
              [45.103794, 36.416003],
              [45.104028, 36.415823],
              [45.10377, 36.415277],
              [45.103467, 36.414957],
              [45.10334, 36.413983],
              [45.103403, 36.413822],
              [45.10335, 36.413341],
              [45.103864, 36.413085],
              [45.104545, 36.412895],
              [45.104805, 36.412849],
              [45.10528, 36.412952],
              [45.106359, 36.412787],
              [45.106645, 36.41271],
              [45.106802, 36.412586],
              [45.107537, 36.412312],
              [45.108031, 36.412219],
              [45.108421, 36.41207],
              [45.108804, 36.411784],
              [45.108931, 36.411564],
              [45.10888, 36.411125],
              [45.109014, 36.410414],
              [45.109367, 36.409866],
              [45.109648, 36.409571],
              [45.109839, 36.409287],
              [45.110181, 36.409216],
              [45.111591, 36.40855],
              [45.112679, 36.407899],
              [45.112963, 36.407486],
              [45.112964, 36.407262],
              [45.113199, 36.407018],
              [45.113289, 36.4064],
              [45.1137, 36.405762],
              [45.114, 36.405735],
              [45.11445, 36.405437],
              [45.115119, 36.405414],
              [45.11573, 36.405541],
              [45.115912, 36.405647],
              [45.116141, 36.405708],
              [45.1168634, 36.405694],
              [45.117018, 36.405691],
              [45.117622, 36.405819],
              [45.117738, 36.406236],
              [45.118163, 36.406272],
              [45.118408, 36.406218],
              [45.118639, 36.406252],
              [45.11915, 36.406476],
              [45.119533, 36.406525],
              [45.119847, 36.406768],
              [45.120123, 36.406911],
              [45.120402, 36.407363],
              [45.121001, 36.407828],
              [45.121644, 36.407863],
              [45.121972, 36.40805],
              [45.12255, 36.407974],
              [45.123169, 36.407678],
              [45.123778, 36.407634],
              [45.124088, 36.407457],
              [45.124548, 36.406917],
              [45.125311, 36.406329],
              [45.125492, 36.406062],
              [45.125789, 36.405951],
              [45.126332, 36.405887],
              [45.126773, 36.405574],
              [45.127915, 36.405047],
              [45.128682, 36.404879],
              [45.12914, 36.404888],
              [45.129748, 36.405005],
              [45.130105, 36.405011],
              [45.13055, 36.405156],
              [45.131182, 36.405566],
              [45.131892, 36.405723],
              [45.133542, 36.406305],
              [45.134911, 36.40698],
              [45.135272, 36.40691],
              [45.135616, 36.406983],
              [45.136124, 36.407197],
              [45.136527, 36.407216],
              [45.136665, 36.407085],
              [45.137096, 36.407254],
              [45.137317, 36.407401],
              [45.137759, 36.407145],
              [45.138086, 36.407045],
              [45.1385, 36.407023],
              [45.139334, 36.406634],
              [45.139699, 36.406579],
              [45.139973, 36.406468],
              [45.140277, 36.406231],
              [45.140657, 36.406079],
              [45.140997, 36.405961],
              [45.141342, 36.405983],
              [45.141529, 36.405814],
              [45.142085, 36.405642],
              [45.142488, 36.405193],
              [45.142811, 36.405183],
              [45.143164, 36.405089],
              [45.14338, 36.405097],
              [45.143585, 36.404987],
              [45.144131, 36.404806],
              [45.144398, 36.405067],
              [45.14492, 36.40524],
              [45.145872, 36.405467],
              [45.146292, 36.40547],
              [45.147005, 36.405609],
              [45.14715, 36.405531],
              [45.147226, 36.405387],
              [45.147619, 36.405197],
              [45.147977, 36.404846],
              [45.148562, 36.404731],
              [45.148706, 36.404627],
              [45.148966, 36.404575],
              [45.149108, 36.404341],
              [45.149525, 36.404413],
              [45.14984, 36.404419],
              [45.150683, 36.404619],
              [45.150936, 36.404793],
              [45.151016, 36.404914],
              [45.151361, 36.405062],
              [45.151638, 36.405273],
              [45.151891, 36.405301],
              [45.152248, 36.405572],
              [45.152483, 36.405686],
              [45.152628, 36.405854],
              [45.152816, 36.406624],
              [45.152992, 36.406875],
              [45.153411, 36.407119],
              [45.153885, 36.407259],
              [45.153886, 36.407656],
              [45.1541486, 36.4085643],
              [45.154163, 36.408614],
              [45.153993, 36.408942],
              [45.153848, 36.410248],
              [45.153642, 36.410707],
              [45.153677, 36.410947],
              [45.153868, 36.411351],
              [45.153802, 36.412047],
              [45.153928, 36.412317],
              [45.1539, 36.412641],
              [45.153825, 36.412847],
              [45.154087, 36.413197],
              [45.15437, 36.414113],
              [45.154589, 36.414445],
              [45.154638, 36.414608],
              [45.154871, 36.414901],
              [45.155234, 36.415813],
              [45.154797, 36.416006],
              [45.154256, 36.416144],
              [45.154108, 36.416275],
              [45.154153, 36.416424],
              [45.154369, 36.416516],
              [45.154783, 36.417016],
              [45.155122, 36.41706],
              [45.156013, 36.416817],
              [45.156575, 36.416769],
              [45.157748, 36.417004],
              [45.158513, 36.417008],
              [45.159227, 36.417152],
              [45.159933, 36.417188],
              [45.160147, 36.41715],
              [45.160644, 36.417155],
              [45.161917, 36.417017],
              [45.162415, 36.417132],
              [45.16271, 36.41709],
              [45.162965, 36.417148],
              [45.163706, 36.417549],
              [45.164222, 36.417619],
              [45.164412, 36.417543],
              [45.164634, 36.41755],
              [45.164815, 36.417591],
              [45.165324, 36.417824],
              [45.166741, 36.418224],
              [45.167495, 36.418272],
              [45.167911, 36.41824],
              [45.168244, 36.418306],
              [45.168429, 36.418419],
              [45.168558, 36.418683],
              [45.168765, 36.418766],
              [45.170068, 36.418622],
              [45.170678, 36.418649],
              [45.171143, 36.418613],
              [45.171846, 36.41841],
              [45.173522, 36.41811],
              [45.17412, 36.418061],
              [45.174523, 36.417942],
              [45.174963, 36.417926],
              [45.175434, 36.417973],
              [45.175991, 36.418176],
              [45.176605, 36.418469],
              [45.176965, 36.418394],
              [45.178106, 36.418274],
              [45.178689, 36.418253],
              [45.179211, 36.418014],
              [45.180113, 36.417848],
              [45.180516, 36.41835],
              [45.181508, 36.419108],
              [45.182247, 36.419169],
              [45.18357, 36.419962],
              [45.184409, 36.420272],
              [45.184643, 36.420403],
              [45.185161, 36.420958],
              [45.186674, 36.421487],
              [45.187364, 36.421802],
              [45.188823, 36.422111],
              [45.189654, 36.4225],
              [45.190218, 36.422604],
              [45.19058, 36.422518],
              [45.191142, 36.42247],
              [45.191326, 36.422353],
              [45.191883, 36.422186],
              [45.192482, 36.422262],
              [45.193451, 36.422585],
              [45.193821, 36.422754],
              [45.194233, 36.423083],
              [45.194687, 36.423341],
              [45.195357, 36.423587],
              [45.197007, 36.423972],
              [45.197529, 36.424312],
              [45.197705, 36.424374],
              [45.199106, 36.423889],
              [45.199614, 36.423809],
              [45.200107, 36.423575],
              [45.20051, 36.42321],
              [45.200821, 36.423223],
              [45.201477, 36.423487],
              [45.202262, 36.42366],
              [45.203625, 36.424211],
              [45.203817, 36.424328],
              [45.203929, 36.424637],
              [45.204079, 36.424762],
              [45.20428, 36.424804],
              [45.205313, 36.424698],
              [45.205665, 36.424578],
              [45.206379, 36.424226],
              [45.206901, 36.424107],
              [45.207109, 36.42409],
              [45.20759, 36.424151],
              [45.208077, 36.424043],
              [45.208866, 36.424163],
              [45.20923, 36.424166],
              [45.209555, 36.424249],
              [45.209823, 36.424368],
              [45.210319, 36.424745],
              [45.210558, 36.424853],
              [45.211159, 36.42508],
              [45.212368, 36.425413],
              [45.213442, 36.426501],
              [45.213998, 36.426746],
              [45.214725, 36.42716],
              [45.215343, 36.427712],
              [45.216053, 36.428092],
              [45.216684, 36.428794],
              [45.216852, 36.429104],
              [45.217372, 36.429476],
              [45.2177577, 36.4295693],
              [45.2181169, 36.4298322],
              [45.218834, 36.429941],
              [45.219927, 36.430033],
              [45.220337, 36.42996],
              [45.220739, 36.429945],
              [45.221212, 36.430143],
              [45.221407, 36.430166],
              [45.221443, 36.430013],
              [45.221572, 36.429818],
              [45.221881, 36.429637],
              [45.221957, 36.429373],
              [45.222126, 36.429207],
              [45.222426, 36.42908],
              [45.223097, 36.429018],
              [45.223594, 36.42884],
              [45.224327, 36.428757],
              [45.22494, 36.429023],
              [45.225222, 36.429213],
              [45.225429, 36.429255],
              [45.225795, 36.429555],
              [45.226097, 36.429663],
              [45.226529, 36.430139],
              [45.22677, 36.430315],
              [45.227214, 36.430894],
              [45.227421, 36.431061],
              [45.228686, 36.430955],
              [45.228899, 36.430996],
              [45.229071, 36.43142],
              [45.229323, 36.431552],
              [45.229538, 36.431743],
              [45.229764, 36.432058],
              [45.230067, 36.432709],
              [45.230206, 36.432836],
              [45.230686, 36.432975],
              [45.230985, 36.433198],
              [45.231457, 36.433307],
              [45.231804, 36.433276],
              [45.232662, 36.433045],
              [45.233884, 36.432592],
              [45.234801, 36.432705],
              [45.235503, 36.432914],
              [45.2356331, 36.4329258],
              [45.235801, 36.432941],
              [45.235922, 36.432991],
              [45.236121, 36.433226],
              [45.236262, 36.433291],
              [45.236467, 36.433584],
              [45.23653, 36.434102],
              [45.236723, 36.434077],
              [45.236907, 36.433974],
              [45.237324, 36.433529],
              [45.237614, 36.43308],
              [45.237731, 36.432991],
              [45.237942, 36.432943],
              [45.238363, 36.432988],
              [45.238846, 36.432782],
              [45.239185, 36.432434],
              [45.239379, 36.432102],
              [45.239611, 36.431935],
              [45.23985, 36.431856],
              [45.239893, 36.431603],
              [45.239729, 36.430499],
              [45.239752, 36.429351],
              [45.239809, 36.429022],
              [45.240056, 36.428367],
              [45.240501, 36.427415],
              [45.240876, 36.426873],
              [45.24174, 36.42604],
              [45.241843, 36.425823],
              [45.241962, 36.425719],
              [45.242146, 36.425644],
              [45.24231, 36.4255],
              [45.2424, 36.425343],
              [45.242482, 36.42491],
              [45.242454, 36.424607],
              [45.242308, 36.424315],
              [45.242226, 36.423812],
              [45.242005, 36.423371],
              [45.241973, 36.423184],
              [45.242193, 36.42304],
              [45.242414, 36.422672],
              [45.242585, 36.42249],
              [45.242637, 36.42225],
              [45.242491, 36.421932],
              [45.242115, 36.421435],
              [45.241908, 36.421017],
              [45.241847, 36.42071],
              [45.241532, 36.419894],
              [45.241444, 36.419502],
              [45.241483, 36.41878],
              [45.241623, 36.418353],
              [45.241969, 36.418108],
              [45.242223, 36.417995],
              [45.242773, 36.417845],
              [45.243399, 36.417759],
              [45.243846, 36.417768],
              [45.24416, 36.417707],
              [45.245337, 36.417314],
              [45.245572, 36.417199],
              [45.245762, 36.417144],
              [45.246083, 36.417128],
              [45.2463, 36.417058],
              [45.246795, 36.416646],
              [45.246917, 36.416468],
              [45.247456, 36.416178],
              [45.248104, 36.416042],
              [45.248651, 36.415705],
              [45.249614, 36.415772],
              [45.250049, 36.4157],
              [45.251332, 36.415199],
              [45.251866, 36.414895],
              [45.252237, 36.414505],
              [45.25256, 36.414432],
              [45.252746, 36.413908],
              [45.25264, 36.413493],
              [45.252603, 36.412998],
              [45.252399, 36.412304],
              [45.252417, 36.412133],
              [45.252349, 36.411806],
              [45.252418, 36.410953],
              [45.25235, 36.410667],
              [45.252444, 36.410107],
              [45.252231, 36.409775],
              [45.251938, 36.409634],
              [45.251682, 36.409617],
              [45.250869, 36.409307],
              [45.250622, 36.409132],
              [45.250452, 36.408922],
              [45.250865, 36.407261],
              [45.251001, 36.406903],
              [45.251155, 36.406708],
              [45.251307, 36.406383],
              [45.251333, 36.405804],
              [45.251545, 36.40551],
              [45.25188, 36.405189],
              [45.252302, 36.404947],
              [45.252502, 36.404676],
              [45.25259, 36.404368],
              [45.252808, 36.40401],
              [45.252916, 36.403683],
              [45.252933, 36.402808],
              [45.253289, 36.402222],
              [45.253848, 36.402164],
              [45.254386, 36.401995],
              [45.255188, 36.40204],
              [45.255991, 36.401959],
              [45.257828, 36.401903],
              [45.257999, 36.401971],
              [45.25855, 36.401805],
              [45.258797, 36.401834],
              [45.259157, 36.401676],
              [45.259711, 36.400442],
              [45.259888, 36.399485],
              [45.260107, 36.398994],
              [45.260582, 36.398716],
              [45.26116, 36.398564],
              [45.261368, 36.39845],
              [45.2625307, 36.3975965],
              [45.263342, 36.397001],
              [45.263775, 36.396819],
              [45.263951, 36.396656],
              [45.264081, 36.396439],
              [45.264132, 36.396193],
              [45.264299, 36.395916],
              [45.264725, 36.395382],
              [45.265557, 36.395201],
              [45.266409, 36.394884],
              [45.267344, 36.394717],
              [45.267426, 36.394522],
              [45.267758, 36.394247],
              [45.268104, 36.394234],
              [45.268059, 36.394673],
              [45.268439, 36.394803],
              [45.268771, 36.394877],
              [45.269622, 36.394824],
              [45.271192, 36.39423],
              [45.271583, 36.394012],
              [45.27199, 36.393884],
              [45.272269, 36.393713],
              [45.272404, 36.393518],
              [45.272289, 36.393021],
              [45.27194, 36.392774],
              [45.271823, 36.392619],
              [45.271796, 36.392403],
              [45.271915, 36.392222],
              [45.272678, 36.391733],
              [45.27283, 36.39094],
              [45.272808, 36.390613],
              [45.272102, 36.390298],
              [45.271808, 36.390218],
              [45.271407, 36.390213],
              [45.27116, 36.389981],
              [45.270878, 36.388675],
              [45.270561, 36.387817],
              [45.271572, 36.386523],
              [45.27226, 36.385117],
              [45.272322, 36.384571],
              [45.272219, 36.384099],
              [45.27228, 36.38384],
              [45.272553, 36.383648],
              [45.272836, 36.383548],
              [45.272888, 36.383335],
              [45.273246, 36.383194],
              [45.273682, 36.38278],
              [45.273783, 36.382657],
              [45.273765, 36.382269],
              [45.273838, 36.382113],
              [45.274585, 36.38193],
              [45.275016, 36.381523],
              [45.275652, 36.380816],
              [45.275735, 36.380664],
              [45.276027, 36.379728],
              [45.276053, 36.378532],
              [45.276161, 36.378276],
              [45.276336, 36.378058],
              [45.276328, 36.377442],
              [45.276426, 36.376961],
              [45.276349, 36.376841],
              [45.276431, 36.376469],
              [45.276292, 36.376313],
              [45.275994, 36.376217],
              [45.275615, 36.375981],
              [45.275396, 36.375756],
              [45.275277, 36.375408],
              [45.274908, 36.374944],
              [45.274693, 36.374735],
              [45.274367, 36.374583],
              [45.273919, 36.374492],
              [45.272901, 36.374558],
              [45.272444, 36.37438],
              [45.271736, 36.374242],
              [45.270939, 36.373904],
              [45.268957, 36.373673],
              [45.268716, 36.372801],
              [45.269016, 36.372317],
              [45.268858, 36.371943],
              [45.268644, 36.371204],
              [45.268645, 36.37105],
              [45.269571, 36.370874],
              [45.271093, 36.370327],
              [45.271359, 36.370131],
              [45.27154, 36.369856],
              [45.272039, 36.369304],
              [45.273448, 36.368541],
              [45.273735, 36.368346],
              [45.273931, 36.368107],
              [45.274389, 36.367893],
              [45.274677, 36.367655],
              [45.27492, 36.367259],
              [45.275163, 36.36705],
              [45.275619, 36.366771],
              [45.275637, 36.366607],
              [45.27527, 36.3661],
              [45.275254, 36.365662],
              [45.275036, 36.365309],
              [45.274685, 36.36503],
              [45.274077, 36.364846],
              [45.274016, 36.364438],
              [45.274116, 36.364233],
              [45.274097, 36.364049],
              [45.273796, 36.363865],
              [45.273716, 36.363725],
              [45.273797, 36.362989],
              [45.273718, 36.362645],
              [45.273554, 36.362349],
              [45.273344, 36.36211],
              [45.27242, 36.361492],
              [45.27226, 36.361163],
              [45.272062, 36.360972],
              [45.271595, 36.360857],
              [45.271478, 36.360674],
              [45.271478, 36.360409],
              [45.271827, 36.359752],
              [45.271725, 36.359097],
              [45.271792, 36.358545],
              [45.271913, 36.358116],
              [45.272151, 36.35793],
              [45.271989, 36.357512],
              [45.272078, 36.357287],
              [45.271859, 36.356902],
              [45.271875, 36.356464],
              [45.272037, 36.356192],
              [45.272054, 36.355594],
              [45.271814, 36.355019],
              [45.271835, 36.354784],
              [45.272057, 36.354623],
              [45.272357, 36.354487],
              [45.272614, 36.354281],
              [45.272751, 36.354092],
              [45.272996, 36.353916],
              [45.273185, 36.353436],
              [45.273552, 36.353117],
              [45.273839, 36.352978],
              [45.274147, 36.352476],
              [45.274427, 36.352256],
              [45.274903, 36.351531],
              [45.274882, 36.351392],
              [45.275092, 36.351101],
              [45.275301, 36.35054],
              [45.275408, 36.34922],
              [45.275377, 36.348856],
              [45.275461, 36.348505],
              [45.275347, 36.347164],
              [45.275225, 36.346778],
              [45.27491, 36.346586],
              [45.274603, 36.346216],
              [45.274512, 36.345847],
              [45.274002, 36.345083],
              [45.274576, 36.344325],
              [45.274816, 36.343892],
              [45.274873, 36.343689],
              [45.275074, 36.34339],
              [45.275463, 36.343332],
              [45.275728, 36.343178],
              [45.275931, 36.343115],
              [45.276101, 36.342902],
              [45.276579, 36.342759],
              [45.276744, 36.342611],
              [45.27765, 36.342445],
              [45.278003, 36.342452],
              [45.279089, 36.342602],
              [45.279767, 36.342584],
              [45.280165, 36.341939],
              [45.280575, 36.341631],
              [45.280851, 36.341582],
              [45.281368, 36.341586],
              [45.281634, 36.341518],
              [45.281808, 36.341412],
              [45.281964, 36.340966],
              [45.282255, 36.340587],
              [45.28208, 36.339889],
              [45.282108, 36.339557],
              [45.282345, 36.338877],
              [45.282897, 36.338264],
              [45.283176, 36.337801],
              [45.283335, 36.337114],
              [45.283314, 36.336817],
              [45.283087, 36.336262],
              [45.282884, 36.336009],
              [45.282604, 36.335839],
              [45.282032, 36.335677],
              [45.281493, 36.335006],
              [45.281242, 36.334799],
              [45.280615, 36.334873],
              [45.280325, 36.334833],
              [45.279811, 36.334672],
              [45.279485, 36.334757],
              [45.279143, 36.334909],
              [45.278866, 36.334899],
              [45.278653, 36.334685],
              [45.278059, 36.333857],
              [45.277272, 36.333557],
              [45.276725, 36.332968],
              [45.276336, 36.332796],
              [45.275892, 36.332666],
              [45.275383, 36.332102],
              [45.275068, 36.331863],
              [45.274662, 36.331812],
              [45.274341, 36.33189],
              [45.273831, 36.331691],
              [45.273311, 36.331419],
              [45.2733, 36.33023],
              [45.272746, 36.329149],
              [45.272158, 36.328202],
              [45.271999, 36.327834],
              [45.272078, 36.327386],
              [45.272262, 36.327037],
              [45.272293, 36.326581],
              [45.272234, 36.326259],
              [45.271952, 36.325853],
              [45.271612, 36.325672],
              [45.271404, 36.325425],
              [45.271324, 36.324983],
              [45.270967, 36.324183],
              [45.270852, 36.323673],
              [45.270675, 36.323361],
              [45.270015, 36.323237],
              [45.269501, 36.32342],
              [45.269205, 36.323408],
              [45.267824, 36.323508],
              [45.267375, 36.323894],
              [45.267125, 36.324034],
              [45.266485, 36.322851],
              [45.266455, 36.322518],
              [45.26655, 36.322115],
              [45.266549, 36.32174],
              [45.266798, 36.321428],
              [45.267089, 36.32136],
              [45.267501, 36.320836],
              [45.267593, 36.320616],
              [45.267537, 36.320337],
              [45.267354, 36.320122],
              [45.267319, 36.319705],
              [45.267215, 36.319439],
              [45.265429, 36.316244],
              [45.264594, 36.314564],
              [45.264513, 36.314144],
              [45.264336, 36.313752],
              [45.264492, 36.313108],
              [45.26484, 36.312182],
              [45.265006, 36.311156],
              [45.264941, 36.310776],
              [45.264855, 36.310507],
              [45.264622, 36.310237],
              [45.264335, 36.310122],
              [45.26321, 36.307769],
              [45.262833, 36.307343],
              [45.262569, 36.307127],
              [45.262324, 36.306774],
              [45.26222, 36.306422],
              [45.261902, 36.305744],
              [45.261832, 36.305285],
              [45.262006, 36.303897],
              [45.262138, 36.303461],
              [45.262119, 36.303202],
              [45.261714, 36.302673],
              [45.261686, 36.302463],
              [45.261523, 36.302278],
              [45.26112, 36.301985],
              [45.260973, 36.301614],
              [45.260964, 36.301289],
              [45.261456, 36.300778],
              [45.261883, 36.300637],
              [45.262042, 36.300518],
              [45.261885, 36.300187],
              [45.261869, 36.299943],
              [45.26192, 36.299773],
              [45.262005, 36.299699],
              [45.262651, 36.299418],
              [45.262791, 36.299045],
              [45.263176, 36.298944],
              [45.263709, 36.299042],
              [45.264317, 36.298913],
              [45.264589, 36.298757],
              [45.264621, 36.297787],
              [45.264734, 36.297552],
              [45.264973, 36.297306],
              [45.265234, 36.297163],
              [45.265347, 36.297014],
              [45.266135, 36.296997],
              [45.266595, 36.296889],
              [45.267584, 36.296317],
              [45.268228, 36.295719],
              [45.268745, 36.295435],
              [45.269566, 36.295396],
              [45.270913, 36.295457],
              [45.271313, 36.295595],
              [45.271694, 36.29593],
              [45.271875, 36.296509],
              [45.272152, 36.297151],
              [45.272249, 36.2973],
              [45.272451, 36.297404],
              [45.27273, 36.297483],
              [45.273097, 36.297525],
              [45.273353, 36.297501],
              [45.273625, 36.297576],
              [45.274009, 36.29761],
              [45.27464, 36.297836],
              [45.275036, 36.297867],
              [45.275319, 36.297962],
              [45.275525, 36.297973],
              [45.275854, 36.297845],
              [45.275977, 36.297255],
              [45.276195, 36.296943],
              [45.27647, 36.296663],
              [45.276732, 36.296579],
              [45.277113, 36.296313],
              [45.277253, 36.296085],
              [45.277449, 36.295905],
              [45.277515, 36.29569],
              [45.277641, 36.295539],
              [45.277766, 36.294642],
              [45.27782, 36.294483],
              [45.277947, 36.294337],
              [45.278466, 36.293864],
              [45.278942, 36.293511],
              [45.279528, 36.293252],
              [45.279882, 36.293178],
              [45.280286, 36.292929],
              [45.280666, 36.292519],
              [45.280947, 36.291895],
              [45.281323, 36.291608],
              [45.281785, 36.291162],
              [45.281828, 36.290983],
              [45.282001, 36.290786],
              [45.282329, 36.290486],
              [45.282832, 36.290139],
              [45.283374, 36.289426],
              [45.283338, 36.289036],
              [45.283589, 36.288477],
              [45.283801, 36.287737],
              [45.283914, 36.287561],
              [45.284033, 36.287465],
              [45.284238, 36.287412],
              [45.284462, 36.287415],
              [45.284712, 36.287451],
              [45.285289, 36.287633],
              [45.285641, 36.28764],
              [45.28642, 36.287443],
              [45.287126, 36.287318],
              [45.287717, 36.286966],
              [45.287781, 36.286681],
              [45.287891, 36.286603],
              [45.288629, 36.286536],
              [45.289003, 36.286411],
              [45.28978, 36.286037],
              [45.29006, 36.285832],
              [45.290842, 36.285537],
              [45.291094, 36.285353],
              [45.291621, 36.284825],
              [45.291751, 36.284668],
              [45.29193, 36.284271],
              [45.292692, 36.283627],
              [45.293464, 36.282771],
              [45.294368, 36.281632],
              [45.294659, 36.281399],
              [45.295055, 36.281186],
              [45.296045, 36.280803],
              [45.297068, 36.280022],
              [45.297468, 36.279827],
              [45.297995, 36.279701],
              [45.298752, 36.279448],
              [45.299083, 36.279249],
              [45.299484, 36.278795],
              [45.299658, 36.278362],
              [45.2998, 36.278189],
              [45.300519, 36.277845],
              [45.300658, 36.27767],
              [45.300772, 36.27745],
              [45.300835, 36.277177],
              [45.300962, 36.277019],
              [45.301088, 36.27693],
              [45.301613, 36.276826],
              [45.301893, 36.276633],
              [45.302013, 36.276426],
              [45.302045, 36.276228],
              [45.3019311, 36.2758825],
              [45.301809, 36.275512],
              [45.301854, 36.275377],
              [45.302168, 36.275189],
              [45.302591, 36.274764],
              [45.302823, 36.274674],
              [45.303288, 36.274707],
              [45.303664, 36.274851],
              [45.303864, 36.274867],
              [45.304103, 36.274809],
              [45.304209, 36.274706],
              [45.304313, 36.274037],
              [45.304393, 36.273872],
              [45.304553, 36.273747],
              [45.303226, 36.273334],
              [45.30242, 36.272975],
              [45.3019556, 36.2728275],
              [45.301472, 36.272674],
              [45.301064, 36.272401],
              [45.3009, 36.27209],
              [45.300356, 36.271598],
              [45.30019, 36.27125],
              [45.300133, 36.270925],
              [45.30024, 36.270113],
              [45.300062, 36.269735],
              [45.299958, 36.268927],
              [45.299766, 36.268756],
              [45.299251, 36.268702],
              [45.298709, 36.268814],
              [45.298278, 36.268998],
              [45.297732, 36.269095],
              [45.297301, 36.268983],
              [45.296966, 36.268772],
              [45.296737, 36.268759],
              [45.296436, 36.268915],
              [45.295771, 36.269028],
              [45.29525, 36.268974],
              [45.294786, 36.269003],
              [45.294437, 36.268881],
              [45.29364, 36.268952],
              [45.293222, 36.268897],
              [45.292805, 36.268728],
              [45.292168, 36.268555],
              [45.29178, 36.268516],
              [45.291504, 36.268376],
              [45.291159, 36.268118],
              [45.290159, 36.268026],
              [45.289653, 36.268072],
              [45.289129, 36.267674],
              [45.288404, 36.267452],
              [45.287649, 36.2673],
              [45.287015, 36.266991],
              [45.28645, 36.266913],
              [45.286051, 36.266946],
              [45.285783, 36.266837],
              [45.285205, 36.2664],
              [45.284751, 36.266179],
              [45.28451, 36.26593],
              [45.28431, 36.265571],
              [45.283959, 36.265348],
              [45.283381, 36.26518],
              [45.282949, 36.265003],
              [45.282634, 36.264768],
              [45.281561, 36.264337],
              [45.280976, 36.264435],
              [45.280158, 36.26417],
              [45.279595, 36.263563],
              [45.279301, 36.262801],
              [45.27898, 36.262566],
              [45.278604, 36.262169],
              [45.277206, 36.261429],
              [45.277039, 36.261162],
              [45.276529, 36.26095],
              [45.276252, 36.260773],
              [45.275307, 36.260843],
              [45.274926, 36.260781],
              [45.274543, 36.260649],
              [45.274217, 36.260453],
              [45.273766, 36.259951],
              [45.273061, 36.259342],
              [45.273032, 36.259088],
              [45.272878, 36.258764],
              [45.272407, 36.258195],
              [45.271206, 36.256999],
              [45.270569, 36.256556],
              [45.270258, 36.256131],
              [45.269815, 36.255724],
              [45.269181, 36.255383],
              [45.268092, 36.254583],
              [45.267397, 36.254337],
              [45.265754, 36.253206],
              [45.265897, 36.253103],
              [45.266247, 36.253089],
              [45.266565, 36.252818],
              [45.266976, 36.252314],
              [45.267831, 36.251025],
              [45.267973, 36.250935],
              [45.268601, 36.250829],
              [45.268849, 36.250726],
              [45.269085, 36.250506],
              [45.269951, 36.250217],
              [45.270311, 36.250272],
              [45.270814, 36.250064],
              [45.271338, 36.250074],
              [45.271718, 36.249985],
              [45.272418, 36.249737],
              [45.272714, 36.249555],
              [45.272894, 36.249312],
              [45.273531, 36.248919],
              [45.273627, 36.24874],
              [45.273666, 36.248441],
              [45.27481, 36.247623],
              [45.275677, 36.246925],
              [45.276466, 36.246132],
              [45.276808, 36.245569],
              [45.277458, 36.245028],
              [45.27814, 36.244723],
              [45.280247, 36.244096],
              [45.280762, 36.243767],
              [45.280961, 36.243705],
              [45.282006, 36.243617],
              [45.282361, 36.243738],
              [45.282897, 36.243804],
              [45.283427, 36.243986],
              [45.283924, 36.244232],
              [45.284211, 36.244246],
              [45.284647, 36.244174],
              [45.285105, 36.244028],
              [45.285791, 36.243626],
              [45.286275, 36.243416],
              [45.286866, 36.24329],
              [45.287564, 36.243209],
              [45.288151, 36.243062],
              [45.288524, 36.243028],
              [45.289057, 36.243079],
              [45.289436, 36.242807],
              [45.289698, 36.24241],
              [45.290551, 36.241497],
              [45.290992, 36.241328],
              [45.291229, 36.241086],
              [45.291667, 36.240906],
              [45.292014, 36.240779],
              [45.292311, 36.240754],
              [45.292786, 36.240626],
              [45.293863, 36.240748],
              [45.294357, 36.241033],
              [45.294515, 36.241021],
              [45.295407, 36.240583],
              [45.2958, 36.240464],
              [45.297322, 36.240141],
              [45.298529, 36.239759],
              [45.298873, 36.239833],
              [45.29956, 36.239641],
              [45.300651, 36.239469],
              [45.301526, 36.239406],
              [45.302233, 36.239426],
              [45.303854, 36.239322],
              [45.304572, 36.239389],
              [45.30489, 36.239252],
              [45.305008, 36.239112],
              [45.305308, 36.238978],
              [45.306191, 36.238951],
              [45.306473, 36.239004],
              [45.306842, 36.239008],
              [45.308054, 36.238772],
              [45.30879, 36.238809],
              [45.309689, 36.238255],
              [45.309939, 36.23819],
              [45.310386, 36.238202],
              [45.310976, 36.238308],
              [45.311289, 36.238382],
              [45.311689, 36.238565],
              [45.312069, 36.238589],
              [45.312404, 36.238424],
              [45.312344, 36.23773],
              [45.313153, 36.236651],
              [45.313771, 36.236229],
              [45.313794, 36.236049],
              [45.31405, 36.235626],
              [45.314093, 36.235467],
              [45.313991, 36.234131],
              [45.314358, 36.233359],
              [45.3147, 36.232882],
              [45.315063, 36.232651],
              [45.315024, 36.232323],
              [45.314806, 36.232178],
              [45.314924, 36.231596],
              [45.315091, 36.231264],
              [45.315227, 36.230404],
              [45.3151481, 36.2301675],
              [45.314955, 36.2300117],
              [45.3149442, 36.2297564],
              [45.314761, 36.229175],
              [45.314667, 36.228976],
              [45.31475, 36.228438],
              [45.314621, 36.22832],
              [45.31436, 36.228215],
              [45.314142, 36.227893],
              [45.31403, 36.227583],
              [45.314053, 36.227363],
              [45.314229, 36.226954],
              [45.314321, 36.226425],
              [45.314208, 36.225846],
              [45.314234, 36.225577],
              [45.314148, 36.225123],
              [45.314464, 36.224231],
              [45.314889, 36.223572],
              [45.3152, 36.222787],
              [45.31525, 36.221726],
              [45.315335, 36.221518],
              [45.315504, 36.221319],
              [45.316144, 36.221037],
              [45.316553, 36.220968],
              [45.317456, 36.220932],
              [45.31797, 36.220328],
              [45.318532, 36.220264],
              [45.31914, 36.220491],
              [45.319733, 36.219778],
              [45.320048, 36.219586],
              [45.321107, 36.219486],
              [45.321465, 36.218845],
              [45.32161, 36.218323],
              [45.322044, 36.217677],
              [45.322193, 36.217232],
              [45.322437, 36.216846],
              [45.322378, 36.216636],
              [45.322573, 36.216296],
              [45.322607, 36.216064],
              [45.323007, 36.215715],
              [45.323576, 36.21578],
              [45.324157, 36.215908],
              [45.324467, 36.215902],
              [45.325005, 36.215737],
              [45.325264, 36.215702],
              [45.326247, 36.215904],
              [45.32732, 36.216299],
              [45.327617, 36.21623],
              [45.328116, 36.215852],
              [45.328225, 36.215608],
              [45.328412, 36.215467],
              [45.328579, 36.215223],
              [45.328868, 36.215242],
              [45.329949, 36.214729],
              [45.330202, 36.214255],
              [45.330328, 36.214131],
              [45.330546, 36.214017],
              [45.330655, 36.213735],
              [45.33047, 36.212791],
              [45.330842, 36.212022],
              [45.330884, 36.211011],
              [45.330989, 36.210639],
              [45.33093, 36.210499],
              [45.330778, 36.210381],
              [45.330934, 36.210214],
              [45.331009, 36.209857],
              [45.331097, 36.209707],
              [45.331074, 36.20955],
              [45.33147, 36.209453],
              [45.331798, 36.209165],
              [45.332211, 36.208985],
              [45.33241, 36.208703],
              [45.332842, 36.208422],
              [45.333199, 36.207774],
              [45.333526, 36.207384],
              [45.333657, 36.207012],
              [45.334033, 36.206741],
              [45.334329, 36.20663],
              [45.335035, 36.205877],
              [45.335138, 36.205634],
              [45.335478, 36.205241],
              [45.335688, 36.204882],
              [45.336004, 36.204633],
              [45.336378, 36.204417],
              [45.336499, 36.204202],
              [45.336511, 36.20406],
              [45.336439, 36.203885],
              [45.336479, 36.203342],
              [45.336439, 36.203236],
              [45.336542, 36.202515],
              [45.336647, 36.202212],
              [45.335923, 36.20198],
              [45.334956, 36.201829],
              [45.334727, 36.201677],
              [45.334243, 36.201108],
              [45.334134, 36.200735],
              [45.333887, 36.200419],
              [45.332746, 36.200138],
              [45.332448, 36.199933],
              [45.331919, 36.199361],
              [45.331243, 36.198767],
              [45.331015, 36.19862],
              [45.330766, 36.198535],
              [45.3303, 36.198059],
              [45.330236, 36.197856],
              [45.329302, 36.196476],
              [45.329036, 36.195858],
              [45.328638, 36.195364],
              [45.328379, 36.194884],
              [45.328145, 36.194743],
              [45.327637, 36.194179],
              [45.327271, 36.194023],
              [45.326969, 36.194034],
              [45.326152, 36.1942],
              [45.325053, 36.194243],
              [45.324776, 36.194319],
              [45.324647, 36.194085],
              [45.324701, 36.193651],
              [45.324626, 36.193455],
              [45.324508, 36.193347],
              [45.324199, 36.192844],
              [45.323988, 36.192717],
              [45.323719, 36.19236],
              [45.323769, 36.192281],
              [45.32449, 36.192122],
              [45.325132, 36.191681],
              [45.325277, 36.191521],
              [45.325366, 36.191312],
              [45.325372, 36.190211],
              [45.324417, 36.189747],
              [45.323958, 36.189442],
              [45.323191, 36.188606],
              [45.32284, 36.188019],
              [45.322627, 36.187885],
              [45.32229, 36.187778],
              [45.319812, 36.186354],
              [45.319092, 36.185864],
              [45.318299, 36.18571],
              [45.318, 36.185467],
              [45.317083, 36.184517],
              [45.316386, 36.183547],
              [45.316454, 36.183258],
              [45.3171, 36.182952],
              [45.317424, 36.182901],
              [45.31819, 36.182906],
              [45.318925, 36.182792],
              [45.319491, 36.182907],
              [45.319923, 36.18283],
              [45.320125, 36.182666],
              [45.320714, 36.182353],
              [45.320919, 36.181935],
              [45.321276, 36.181626],
              [45.321381, 36.181398],
              [45.321504, 36.18085],
              [45.321753, 36.180382],
              [45.321963, 36.180163],
              [45.322053, 36.179884],
              [45.322808, 36.179358],
              [45.322905, 36.179046],
              [45.323201, 36.178693],
              [45.323021, 36.178495],
              [45.322843, 36.177963],
              [45.322842, 36.177346],
              [45.322953, 36.177074],
              [45.322911, 36.176818],
              [45.322672, 36.176238],
              [45.322648, 36.175872],
              [45.322714, 36.175437],
              [45.322838, 36.1752],
              [45.322843, 36.174952],
              [45.322681, 36.174777],
              [45.322159, 36.174483],
              [45.321848, 36.174039],
              [45.321664, 36.17368],
              [45.321156, 36.173222],
              [45.32098, 36.172942],
              [45.320981, 36.172743],
              [45.3212, 36.172426],
              [45.32119, 36.171961],
              [45.321387, 36.171362],
              [45.32145, 36.170772],
              [45.321314, 36.170291],
              [45.320433, 36.168778],
              [45.320397, 36.168388],
              [45.320229, 36.167717],
              [45.320332, 36.167495],
              [45.320702, 36.167449],
              [45.324127, 36.167363],
              [45.324668, 36.167241],
              [45.325412, 36.166793],
              [45.325608, 36.166324],
              [45.325832, 36.166139],
              [45.325528, 36.165388],
              [45.325038, 36.164407],
              [45.325011, 36.16409],
              [45.325688, 36.163117],
              [45.326387, 36.16178],
              [45.326522, 36.160989],
              [45.326932, 36.160144],
              [45.327025, 36.159645],
              [45.327443, 36.159045],
              [45.327663, 36.15863],
              [45.327969, 36.157514],
              [45.328906, 36.156853],
              [45.329278, 36.156484],
              [45.327792, 36.154591],
              [45.327685, 36.154328],
              [45.326912, 36.153054],
              [45.326508, 36.151736],
              [45.326132, 36.151389],
              [45.325781, 36.151145],
              [45.325625, 36.150969],
              [45.325608, 36.150709],
              [45.325787, 36.150183],
              [45.325723, 36.149674],
              [45.325228, 36.148903],
              [45.324975, 36.148626],
              [45.324987, 36.148077],
              [45.325259, 36.147798],
              [45.325523, 36.147622],
              [45.325638, 36.147339],
              [45.325948, 36.147027],
              [45.326462, 36.146598],
              [45.326706, 36.146133],
              [45.326788, 36.145577],
              [45.326955, 36.144983],
              [45.327059, 36.143777],
              [45.327278, 36.143153],
              [45.327107, 36.141591],
              [45.32695, 36.140837],
              [45.327046, 36.139867],
              [45.327135, 36.139698],
              [45.327607, 36.139324],
              [45.32836, 36.13879],
              [45.328704, 36.138636],
              [45.328926, 36.138383],
              [45.329571, 36.136418],
              [45.329667, 36.136275],
              [45.329868, 36.136119],
              [45.33083, 36.135942],
              [45.331323, 36.135668],
              [45.331871, 36.135565],
              [45.332062, 36.13547],
              [45.333567, 36.135366],
              [45.333911, 36.13519],
              [45.334434, 36.134801],
              [45.334482, 36.134562],
              [45.334893, 36.134259],
              [45.335193, 36.134167],
              [45.335401, 36.134158],
              [45.335636, 36.134269],
              [45.335744, 36.134244],
              [45.335861, 36.134005],
              [45.336274, 36.133903],
              [45.336465, 36.133809],
              [45.336902, 36.133457],
              [45.337083, 36.133376],
              [45.337443, 36.13335],
              [45.337692, 36.133464],
              [45.338039, 36.133517],
              [45.338257, 36.133374],
              [45.338369, 36.133218],
              [45.338495, 36.132889],
              [45.339088, 36.132022],
              [45.338959, 36.131635],
              [45.338973, 36.13137],
              [45.339405, 36.130631],
              [45.339636, 36.130365],
              [45.339881, 36.130223],
              [45.340122, 36.129578],
              [45.340319, 36.129335],
              [45.340741, 36.129364],
              [45.34107, 36.129524],
              [45.341445, 36.12943],
              [45.341514, 36.129215],
              [45.341023, 36.128383],
              [45.34092, 36.127334],
              [45.340739, 36.126902],
              [45.340539, 36.126773],
              [45.34064, 36.126378],
              [45.340514, 36.126291],
              [45.34048, 36.125662],
              [45.340534, 36.125198],
              [45.340724, 36.124809],
              [45.340948, 36.124079],
              [45.341146, 36.123792],
              [45.341477, 36.123471],
              [45.341622, 36.122969],
              [45.341589, 36.122197],
              [45.341979, 36.122281],
              [45.342835, 36.12221],
              [45.343538, 36.121833],
              [45.344163, 36.121667],
              [45.344726, 36.121058],
              [45.344956, 36.120738],
              [45.345243, 36.120188],
              [45.345723, 36.119599],
              [45.345815, 36.118592],
              [45.345795, 36.117645],
              [45.345867, 36.117312],
              [45.346753, 36.116014],
              [45.346888, 36.115686],
              [45.347404, 36.115099],
              [45.347596, 36.114413],
              [45.347991, 36.114037],
              [45.348196, 36.113399],
              [45.34846, 36.112972],
              [45.34852, 36.112408],
              [45.348937, 36.111836],
              [45.349553, 36.110664],
              [45.349533, 36.110252],
              [45.34967, 36.109965],
              [45.349689, 36.109716],
              [45.349596, 36.109311],
              [45.34957, 36.108705],
              [45.350507, 36.108563],
              [45.352971, 36.108856],
              [45.353314, 36.108965],
              [45.353744, 36.108975],
              [45.354217, 36.109088],
              [45.355103, 36.109127],
              [45.355643, 36.10931],
              [45.356028, 36.109378],
              [45.356312, 36.109322],
              [45.356523, 36.109131],
              [45.356628, 36.108827],
              [45.357016, 36.108271],
              [45.357254, 36.108174],
              [45.357587, 36.108153],
              [45.357921, 36.10823],
              [45.35822, 36.108231],
              [45.358644, 36.107975],
              [45.359223, 36.107401],
              [45.359773, 36.107062],
              [45.360708, 36.106912],
              [45.361047, 36.106786],
              [45.361775, 36.106355],
              [45.362244, 36.106332],
              [45.36244, 36.106406],
              [45.362621, 36.106565],
              [45.362894, 36.10662],
              [45.363592, 36.106469],
              [45.364596, 36.106421],
              [45.365243, 36.106283],
              [45.365767, 36.106042],
              [45.366827, 36.105415],
              [45.367049, 36.105239],
              [45.367814, 36.104965],
              [45.368788, 36.10495],
              [45.369071, 36.104894],
              [45.370334, 36.104412],
              [45.370547, 36.104235],
              [45.370625, 36.104087],
              [45.370597, 36.103147],
              [45.370356, 36.102594],
              [45.370292, 36.10193],
              [45.370596, 36.101317],
              [45.370581, 36.101118],
              [45.370253, 36.100574],
              [45.370287, 36.100333],
              [45.370117, 36.099821],
              [45.370292, 36.099331],
              [45.370435, 36.09809],
              [45.370572, 36.098071],
              [45.371052, 36.097871],
              [45.371373, 36.09783],
              [45.371848, 36.097586],
              [45.37207, 36.097312],
              [45.372256, 36.096666],
              [45.372687, 36.096386],
              [45.373144, 36.096299],
              [45.373364, 36.096161],
              [45.373604, 36.095878],
              [45.373769, 36.095301],
              [45.373996, 36.095266],
              [45.374151, 36.095042],
              [45.37444, 36.095034],
              [45.374575, 36.094982],
              [45.374687, 36.094919],
              [45.374728, 36.094802],
              [45.374859, 36.094735],
              [45.374879, 36.09449],
              [45.37476, 36.094161],
              [45.374791, 36.093882],
              [45.374495, 36.093579],
              [45.374448, 36.093457],
              [45.374625, 36.093168],
              [45.374709, 36.092813],
              [45.375012, 36.092612],
              [45.37508, 36.092463],
              [45.375133, 36.092267],
              [45.375102, 36.092032],
              [45.37497, 36.091705],
              [45.375651, 36.091349],
              [45.377231, 36.090202],
              [45.377539, 36.089945],
              [45.378539, 36.088907],
              [45.378679, 36.08851],
              [45.379023, 36.088115],
              [45.379259, 36.087501],
              [45.379461, 36.087397],
              [45.379637, 36.087239],
              [45.379741, 36.087002],
              [45.379779, 36.086618],
              [45.379904, 36.086311],
              [45.379776, 36.085805],
              [45.380161, 36.085614],
              [45.380449, 36.085402],
              [45.380532, 36.085075],
              [45.380529, 36.084719],
              [45.380786, 36.084522],
              [45.381033, 36.084473],
              [45.381363, 36.08418],
              [45.381498, 36.08293],
              [45.381396, 36.081924],
              [45.38163, 36.081615],
              [45.381628, 36.081069],
              [45.381837, 36.080798],
              [45.381823, 36.080477],
              [45.381892, 36.080287],
              [45.381789, 36.079971],
              [45.381813, 36.079448],
              [45.381616, 36.079233],
              [45.38096, 36.078709],
              [45.380507, 36.077754],
              [45.380206, 36.077328],
              [45.380067, 36.077253],
              [45.3798, 36.077278],
              [45.379353, 36.077152],
              [45.378991, 36.077105],
              [45.378886, 36.076945],
              [45.378242, 36.076603],
              [45.377979, 36.076321],
              [45.37771, 36.076152],
              [45.377323, 36.075798],
              [45.377208, 36.0752],
              [45.3774, 36.074352],
              [45.377869, 36.073762],
              [45.378197, 36.073514],
              [45.378399, 36.073193],
              [45.378529, 36.072778],
              [45.379451, 36.071761],
              [45.379155, 36.07131],
              [45.37854, 36.070913],
              [45.378265, 36.0708],
              [45.378187, 36.070396],
              [45.377843, 36.069861],
              [45.377608, 36.069764],
              [45.377418, 36.069547],
              [45.377409, 36.069086],
              [45.377231, 36.068461],
              [45.37715, 36.067884],
              [45.376898, 36.067512],
              [45.376433, 36.066993],
              [45.37646, 36.06632],
              [45.3764288, 36.0661742],
              [45.376366, 36.06588],
              [45.376208, 36.065651],
              [45.376058, 36.065294],
              [45.376063, 36.064831],
              [45.375756, 36.063964],
              [45.375505, 36.063791],
              [45.375358, 36.063774],
              [45.374975, 36.063853],
              [45.374854, 36.063158],
              [45.374602, 36.062813],
              [45.374249, 36.062536],
              [45.3737, 36.061831],
              [45.373653, 36.061277],
              [45.373941, 36.060479],
              [45.373977, 36.060077],
              [45.373872, 36.058659],
              [45.373506, 36.057855],
              [45.373444, 36.057643],
              [45.373433, 36.057172],
              [45.373302, 36.056727],
              [45.372749, 36.055444],
              [45.372627, 36.054658],
              [45.372695, 36.054222],
              [45.372656, 36.05375],
              [45.37243, 36.052326],
              [45.372537, 36.051772],
              [45.372477, 36.051487],
              [45.371312, 36.05009],
              [45.371, 36.049918],
              [45.370518, 36.049792],
              [45.370202, 36.049575],
              [45.369787, 36.049382],
              [45.369463, 36.049111],
              [45.369372, 36.048815],
              [45.369342, 36.048352],
              [45.368816, 36.047739],
              [45.367868, 36.046793],
              [45.367491, 36.046504],
              [45.367055, 36.046259],
              [45.365791, 36.045075],
              [45.365233, 36.044656],
              [45.364846, 36.044279],
              [45.364213, 36.043464],
              [45.363478, 36.043057],
              [45.362495, 36.042904],
              [45.362064, 36.042731],
              [45.361944, 36.042596],
              [45.362005, 36.042184],
              [45.361972, 36.0419],
              [45.361707, 36.041101],
              [45.361625, 36.040681],
              [45.361292, 36.040105],
              [45.361184, 36.039773],
              [45.360858, 36.039169],
              [45.360558, 36.038292],
              [45.36023, 36.038032],
              [45.359979, 36.037715],
              [45.359445, 36.037415],
              [45.359123, 36.037338],
              [45.358538, 36.037058],
              [45.35758, 36.036505],
              [45.357195, 36.036239],
              [45.357119, 36.036086],
              [45.356894, 36.036053],
              [45.356718, 36.03589],
              [45.356361, 36.035708],
              [45.356154, 36.035667],
              [45.355977, 36.035498],
              [45.35536, 36.035229],
              [45.355201, 36.034946],
              [45.355002, 36.034803],
              [45.354958, 36.03466],
              [45.355, 36.034553],
              [45.354628, 36.034285],
              [45.354431, 36.03354],
              [45.354309, 36.033344],
              [45.35423, 36.03328],
              [45.353621, 36.033144],
              [45.353381, 36.033003],
              [45.353249, 36.032848],
              [45.353189, 36.032162],
              [45.352878, 36.031967],
              [45.35271, 36.031646],
              [45.352497, 36.031472],
              [45.352318, 36.031192],
              [45.352274, 36.031078],
              [45.352375, 36.030943],
              [45.352378, 36.030619],
              [45.352296, 36.030455],
              [45.351928, 36.030198],
              [45.351798, 36.029569],
              [45.351589, 36.029148],
              [45.351527, 36.028805],
              [45.351564, 36.028681],
              [45.35198, 36.028109],
              [45.352093, 36.027861],
              [45.35234, 36.027644],
              [45.352946, 36.027303],
              [45.353136, 36.027132],
              [45.353305, 36.026838],
              [45.353399, 36.026452],
              [45.353436, 36.026158],
              [45.353321, 36.025989],
              [45.352959, 36.025789],
              [45.352768, 36.025589],
              [45.352499, 36.025126],
              [45.35229, 36.025019],
              [45.351812, 36.02451],
              [45.351716, 36.024279],
              [45.351772, 36.024001],
              [45.352664, 36.022744],
              [45.352785, 36.022324],
              [45.353146, 36.021923],
              [45.353282, 36.020926],
              [45.353515, 36.020464],
              [45.353532, 36.019943],
              [45.353463, 36.019574],
              [45.353067, 36.019205],
              [45.352773, 36.019006],
              [45.352431, 36.018859],
              [45.351685, 36.018964],
              [45.350684, 36.018099],
              [45.35016, 36.017796],
              [45.349108, 36.016806],
              [45.348295, 36.016293],
              [45.34725, 36.01539],
              [45.346728, 36.015012],
              [45.346508, 36.014792],
              [45.34646, 36.014597],
              [45.346543, 36.014135],
              [45.346457, 36.013864],
              [45.346082, 36.013318],
              [45.345559, 36.01285],
              [45.345062, 36.011913],
              [45.344841, 36.01127],
              [45.344574, 36.01073],
              [45.344435, 36.010558],
              [45.344703, 36.009921],
              [45.344488, 36.009831],
              [45.343998, 36.009726],
              [45.343902, 36.009649],
              [45.343745, 36.00928],
              [45.343614, 36.009232],
              [45.34353, 36.009233],
              [45.343387, 36.00934],
              [45.343185, 36.009389],
              [45.342958, 36.009321],
              [45.34261, 36.008935],
              [45.342585, 36.008683],
              [45.342656, 36.008518],
              [45.34256, 36.008431],
              [45.342464, 36.008402],
              [45.341892, 36.008588],
              [45.341761, 36.008539],
              [45.341808, 36.008433],
              [45.342034, 36.008238],
              [45.342152, 36.008005],
              [45.342426, 36.007675],
              [45.343259, 36.007352],
              [45.34339, 36.007206],
              [45.343484, 36.006954],
              [45.343388, 36.00677],
              [45.342994, 36.006655],
              [45.342934, 36.006587],
              [45.342945, 36.006432],
              [45.343266, 36.006043],
              [45.343277, 36.005917],
              [45.343133, 36.005791],
              [45.342859, 36.00586],
              [45.342763, 36.005744],
              [45.342774, 36.005502],
              [45.342987, 36.005103],
              [45.342986, 36.004929],
              [45.342854, 36.004735],
              [45.342375, 36.004368],
              [45.342136, 36.004262],
              [45.342099, 36.00403],
              [45.3417823, 36.003578],
              [45.3425984, 36.0035214],
              [45.3431152, 36.003361],
              [45.3435399, 36.0030146],
              [45.3438796, 36.0027941],
              [45.3444494, 36.0026653],
              [45.3448741, 36.0024534],
              [45.345451, 36.0019753],
              [45.3457236, 36.0018092],
              [45.3458014, 36.0016374],
              [45.3457943, 36.0014227],
              [45.3456952, 36.0012423],
              [45.345175, 36.0001256],
              [45.3443079, 35.9994642],
              [45.3439186, 35.9990175],
              [45.3436036, 35.9981757],
              [45.3430621, 35.9975257],
              [45.3426905, 35.9973768],
              [45.3424427, 35.9972594],
              [45.3423896, 35.997079],
              [45.3423861, 35.9968872],
              [45.3424923, 35.9967641],
              [45.3432497, 35.9960196],
              [45.3442937, 35.9950202],
              [45.3454015, 35.9939264],
              [45.3464066, 35.9929127],
              [45.3471463, 35.9920937],
              [45.3483886, 35.9908481],
              [45.3487283, 35.9903412],
              [45.3490008, 35.9900033],
              [45.3495707, 35.9894392],
              [45.3501865, 35.9888607],
              [45.3507351, 35.9883309],
              [45.3509014, 35.9880818],
              [45.3507988, 35.9879787],
              [45.3506784, 35.9878384],
              [45.3506784, 35.9874174],
              [45.350682, 35.9865955],
              [45.350367, 35.9856562],
              [45.3499458, 35.9847512],
              [45.3493831, 35.9843417],
              [45.3486222, 35.9837775],
              [45.3477727, 35.9829842],
              [45.3474542, 35.9824258],
              [45.3474117, 35.9820363],
              [45.3473233, 35.9814435],
              [45.3474436, 35.9809795],
              [45.3475639, 35.9807017],
              [45.3477197, 35.9803952],
              [45.3481054, 35.9794988],
              [45.3485974, 35.9786511],
              [45.3489407, 35.9783303],
              [45.3493335, 35.9778033],
              [45.3496379, 35.9775341],
              [45.350006, 35.9772648],
              [45.3505227, 35.9769613],
              [45.3511421, 35.9767207],
              [45.3517013, 35.9764142],
              [45.3522569, 35.9759817],
              [45.3526568, 35.9754461],
              [45.3530001, 35.9751941],
              [45.3535523, 35.9747587],
              [45.3538814, 35.9745525],
              [45.3541787, 35.9744637],
              [45.3544017, 35.9743062],
              [45.3546954, 35.9742145],
              [45.355159, 35.9741143],
              [45.3560686, 35.9739367],
              [45.3565181, 35.9740656],
              [45.3567305, 35.9742059],
              [45.3569463, 35.9745009],
              [45.3571162, 35.9750165],
              [45.358001, 35.9758929],
              [45.3584434, 35.9761163],
              [45.3592114, 35.9762996],
              [45.3600148, 35.9762767],
              [45.3608925, 35.9761622],
              [45.362103, 35.9758442],
              [45.3621808, 35.9757927],
              [45.3622127, 35.9757268],
              [45.3623905, 35.9752601],
              [45.3625978, 35.974941],
              [45.362858, 35.9746942],
              [45.3631345, 35.9745857],
              [45.3635817, 35.9742698],
              [45.3636508, 35.9741349],
              [45.3639028, 35.9740691],
              [45.3642525, 35.9740823],
              [45.364659, 35.9741119],
              [45.365155, 35.974079],
              [45.3655087, 35.9740198],
              [45.3658868, 35.9739211],
              [45.3662039, 35.9738816],
              [45.366456, 35.9739211],
              [45.3666592, 35.9739638],
              [45.3668097, 35.9740395],
              [45.3669072, 35.9741283],
              [45.3669194, 35.9742632],
              [45.3668137, 35.9745857],
              [45.3664234, 35.9753556],
              [45.3661998, 35.9759445],
              [45.3652526, 35.976892],
              [45.3649111, 35.9772276],
              [45.3642525, 35.9775566],
              [45.3639232, 35.9777112],
              [45.3631955, 35.9788133],
              [45.3627361, 35.9797016],
              [45.3627564, 35.9802773],
              [45.3630166, 35.9808892],
              [45.3636101, 35.9814847],
              [45.3637735, 35.981894],
              [45.3638825, 35.9821887],
              [45.3639801, 35.9827973],
              [45.3639923, 35.982896],
              [45.3640695, 35.982998],
              [45.3641305, 35.9830506],
              [45.3642972, 35.9830737],
              [45.3644436, 35.9830737],
              [45.3645818, 35.9830572],
              [45.3647566, 35.9829684],
              [45.3652729, 35.9822249],
              [45.3655372, 35.9819321],
              [45.3658096, 35.9815275],
              [45.3660169, 35.9811886],
              [45.3661795, 35.9810866],
              [45.3664844, 35.9809978],
              [45.3676593, 35.9812577],
              [45.3690091, 35.9817216],
              [45.3704686, 35.9823598],
              [45.3709605, 35.982567],
              [45.3719525, 35.9827348],
              [45.3726558, 35.9829125],
              [45.3730745, 35.9829684],
              [45.3733998, 35.982873],
              [45.373847, 35.9826032],
              [45.3745503, 35.9819321],
              [45.3757496, 35.9805997],
              [45.3761643, 35.9792739],
              [45.3764001, 35.9772111],
              [45.3764164, 35.9765827],
              [45.3755707, 35.9761057],
              [45.3740177, 35.9745429],
              [45.3735868, 35.9740922],
              [45.3733957, 35.9726906],
              [45.3736193, 35.9724339],
              [45.3742413, 35.9717265],
              [45.3743511, 35.97121],
              [45.3742047, 35.9700847],
              [45.3743633, 35.969601],
              [45.3749975, 35.969453],
              [45.375522, 35.9695056],
              [45.3761928, 35.9697557],
              [45.3770546, 35.9705914],
              [45.377449, 35.9710784],
              [45.3779084, 35.9715456],
              [45.378689, 35.9727037],
              [45.3792866, 35.9733914],
              [45.380181, 35.9742303],
              [45.3807623, 35.9744804],
              [45.3815216, 35.9745856],
              [45.3823763, 35.974816],
              [45.3828073, 35.9747239],
              [45.3836326, 35.9743883],
              [45.3841408, 35.9739803],
              [45.3851002, 35.9738026],
              [45.3873362, 35.973523],
              [45.3891291, 35.9728287],
              [45.3898975, 35.9725392],
              [45.3903243, 35.9721214],
              [45.3907024, 35.9715028],
              [45.3910642, 35.9704499],
              [45.391109, 35.9696471],
              [45.3913448, 35.9691009],
              [45.3916619, 35.9686139],
              [45.3919505, 35.968252],
              [45.3923367, 35.9680381],
              [45.3925685, 35.96789],
              [45.3929953, 35.9677946],
              [45.3933816, 35.9678144],
              [45.3939304, 35.9680381],
              [45.3944874, 35.9684593],
              [45.3953777, 35.9689298],
              [45.3966787, 35.9695056],
              [45.3980284, 35.9698116],
              [45.399061, 35.9701505],
              [45.4009515, 35.9706243],
              [45.4017646, 35.9708283],
              [45.4039802, 35.9707362],
              [45.4061349, 35.9699169],
              [45.4065415, 35.9698741],
              [45.4073627, 35.9702426],
              [45.4078018, 35.9706177],
              [45.4079929, 35.971029],
              [45.4079725, 35.9713416],
              [45.4077936, 35.9715554],
              [45.4057121, 35.9733683],
              [45.405334, 35.9740724],
              [45.405395, 35.9746646],
              [45.4056918, 35.9751187],
              [45.4060943, 35.9755036],
              [45.406757, 35.9758787],
              [45.4078018, 35.9757273],
              [45.4083506, 35.9758523],
              [45.4087694, 35.9758885],
              [45.4091474, 35.9760761],
              [45.4092775, 35.9762208],
              [45.4096394, 35.9769644],
              [45.4096434, 35.9772243],
              [45.4096638, 35.9773921],
              [45.4091759, 35.9778592],
              [45.4084685, 35.9784185],
              [45.4080538, 35.9787377],
              [45.4077733, 35.9789383],
              [45.4075172, 35.9792509],
              [45.4074562, 35.9795108],
              [45.4075213, 35.9799549],
              [45.4079197, 35.9802313],
              [45.4083222, 35.9804056],
              [45.4090499, 35.9804056],
              [45.4100378, 35.9800503],
              [45.4103712, 35.979797],
              [45.4106639, 35.9796917],
              [45.4108265, 35.9799286],
              [45.4108875, 35.9801556],
              [45.4109606, 35.9809353],
              [45.4111314, 35.9817479],
              [45.4115136, 35.9823137],
              [45.4120055, 35.982669],
              [45.412786, 35.9829585],
              [45.4136154, 35.9832645],
              [45.4146887, 35.9833697],
              [45.4153757, 35.9831789],
              [45.4159734, 35.9828927],
              [45.4183679, 35.9822545],
              [45.4190103, 35.9817216],
              [45.4194534, 35.9815538],
              [45.4201364, 35.98159],
              [45.4207137, 35.9817216],
              [45.4213561, 35.981942],
              [45.4217057, 35.9826098],
              [45.4224863, 35.9830539],
              [45.4238319, 35.9835046],
              [45.4254012, 35.9846363],
              [45.4259378, 35.9849389],
              [45.427003, 35.9850014],
              [45.4276209, 35.9851231],
              [45.4279624, 35.9853929],
              [45.4281047, 35.9857811],
              [45.4281373, 35.9860903],
              [45.4281454, 35.9862317],
              [45.4282023, 35.986314],
              [45.4283324, 35.9863732],
              [45.4285438, 35.9864521],
              [45.4285601, 35.9870015],
              [45.4286373, 35.9874061],
              [45.4289422, 35.9880311],
              [45.4292187, 35.9887252],
              [45.4295439, 35.9894094],
              [45.4299868, 35.9897846],
              [45.4303489, 35.9902285],
              [45.4307513, 35.9903963],
              [45.4311213, 35.9905805],
              [45.4312921, 35.9905476],
              [45.4317149, 35.990541],
              [45.4321702, 35.9904292],
              [45.4328166, 35.9904357],
              [45.433154, 35.9907153],
              [45.4336988, 35.9908765],
              [45.4336907, 35.9911265],
              [45.4334346, 35.9914555],
              [45.4326824, 35.9926956],
              [45.4322068, 35.9933041],
              [45.4319669, 35.9937777],
              [45.4320686, 35.9943895],
              [45.4322393, 35.9947843],
              [45.4330402, 35.9952711],
              [45.4339102, 35.9959059],
              [45.4346664, 35.996021],
              [45.4354307, 35.996544],
              [45.4366503, 35.9971985],
              [45.4374594, 35.9978366],
              [45.4387928, 35.9984977],
              [45.4394962, 35.9991884],
              [45.4396954, 35.9993266],
              [45.4402971, 35.9993924],
              [45.4414883, 35.9992509],
              [45.4422566, 35.9988135],
              [45.4429518, 35.9985372],
              [45.4437405, 35.9980636],
              [45.4447081, 35.9976426],
              [45.4451878, 35.9975505],
              [45.4456676, 35.9975505],
              [45.4461757, 35.9976919],
              [45.446688, 35.9975307],
              [45.4470132, 35.9972084],
              [45.4473669, 35.9970308],
              [45.4474157, 35.9967117],
              [45.4477166, 35.9964223],
              [45.4482613, 35.9961263],
              [45.4486191, 35.9959782],
              [45.4491679, 35.9958335],
              [45.4493712, 35.9958039],
              [45.4500217, 35.9959717],
              [45.450847, 35.9958598],
              [45.4523309, 35.9949092],
              [45.4533269, 35.9943567],
              [45.4535261, 35.9941593],
              [45.4536725, 35.9939356],
              [45.4539936, 35.9931626],
              [45.4545831, 35.992439],
              [45.4545884, 35.9921273],
              [45.4542579, 35.991666],
              [45.4542863, 35.9905542],
              [45.4543392, 35.9903535],
              [45.4544083, 35.9901002],
              [45.4546807, 35.9899752],
              [45.4551848, 35.9898634],
              [45.4556767, 35.9898667],
              [45.4561849, 35.9901298],
              [45.4569452, 35.9907153],
              [45.4571769, 35.9909522],
              [45.4580998, 35.9911627],
              [45.4582624, 35.9911824],
              [45.4583234, 35.9912713],
              [45.458364, 35.9913864],
              [45.458425, 35.9916232],
              [45.4588438, 35.9933368],
              [45.4591707, 35.9941208],
              [45.460114, 35.9954376],
              [45.46056, 35.9957757],
              [45.4608192, 35.9961026],
              [45.46148, 35.9961592],
              [45.4618209, 35.9960478],
              [45.4625284, 35.9959288],
              [45.4639551, 35.9959514],
              [45.4655499, 35.9964124],
              [45.4660379, 35.9963633],
              [45.4668038, 35.9962461],
              [45.4677168, 35.9963293],
              [45.4681021, 35.996539],
              [45.4683683, 35.9967468],
              [45.4688936, 35.9971737],
              [45.469391, 35.997408],
              [45.4702363, 35.9978576],
              [45.4711726, 35.9983355],
              [45.4727114, 35.9986264],
              [45.4736197, 35.999076],
              [45.4740703, 35.9994198],
              [45.4743622, 35.999469],
              [45.4750207, 35.9996673],
              [45.4756138, 36.000047],
              [45.4757188, 36.0001944],
              [45.4757866, 36.0003417],
              [45.475915, 36.0004116],
              [45.477309, 36.0008687],
              [45.4779254, 36.0011445],
              [45.4783784, 36.0015337],
              [45.4786096, 36.0018265],
              [45.4788431, 36.0022364],
              [45.4791069, 36.0023252],
              [45.4796743, 36.0021722],
              [45.4800946, 36.0019908],
              [45.4804729, 36.0017056],
              [45.4807788, 36.001392],
              [45.481045, 36.0008461],
              [45.4811757, 36.0007365],
              [45.4815703, 36.0005438],
              [45.4820747, 36.000404],
              [45.4824086, 36.0004872],
              [45.4831044, 36.0009009],
              [45.4835317, 36.0010274],
              [45.4842252, 36.0009915],
              [45.4848253, 36.0009537],
              [45.4851919, 36.001052],
              [45.485757, 36.001358],
              [45.4867681, 36.0017906],
              [45.4876133, 36.0020739],
              [45.4883745, 36.0022439],
              [45.4887995, 36.0021325],
              [45.4891287, 36.0021533],
              [45.4907259, 36.0023119],
              [45.4917159, 36.00238],
              [45.4925378, 36.0023252],
              [45.49318, 36.0021155],
              [45.493745, 36.0018265],
              [45.4943335, 36.0017339],
              [45.4958652, 36.0016867],
              [45.4976632, 36.0017547],
              [45.4987816, 36.001919],
              [45.5000695, 36.0019555],
              [45.5017579, 36.0026441],
              [45.5027398, 36.0027966],
              [45.5034007, 36.0026932],
              [45.5042, 36.0022419],
              [45.5045251, 36.002166],
              [45.505257, 36.0019873],
              [45.505724, 36.0017847],
              [45.5062385, 36.0013649],
              [45.5062767, 36.001052],
              [45.5062059, 35.9995559],
              [45.5070836, 35.9989431],
              [45.5077915, 35.9986024],
              [45.5086409, 35.9983862],
              [45.5094353, 35.9982569],
              [45.5099576, 35.9982502],
              [45.5104957, 35.9980897],
              [45.5114822, 35.9976711],
              [45.512398, 35.9970118],
              [45.5139747, 35.9961287],
              [45.51458, 35.9960574],
              [45.5154507, 35.9962127],
              [45.5166082, 35.996217],
              [45.5180432, 35.995861],
              [45.5183087, 35.9959134],
              [45.518749, 35.9953895],
              [45.51895, 35.9952338],
              [45.519296, 35.9951954],
              [45.5196837, 35.9952865],
              [45.5199726, 35.9952429],
              [45.5204694, 35.9950677],
              [45.5210454, 35.9948014],
              [45.521337, 35.9946984],
              [45.5217417, 35.9946728],
              [45.5224136, 35.9947513],
              [45.5230116, 35.9948641],
              [45.5235494, 35.9949166],
              [45.524218, 35.9950991],
              [45.5244769, 35.9951356],
              [45.5247716, 35.9952779],
              [45.5253484, 35.9954448],
              [45.5257788, 35.9958001],
              [45.5261916, 35.9958899],
              [45.5264841, 35.9958193],
              [45.5267243, 35.9957416],
              [45.5272172, 35.9955069],
              [45.5275085, 35.9953563],
              [45.5277396, 35.9952172],
              [45.5283077, 35.9950948],
              [45.5284891, 35.995045],
              [45.5288276, 35.9951261],
              [45.5291448, 35.9951613],
              [45.529766, 35.9950785],
              [45.5304579, 35.9950987],
              [45.5307641, 35.9951332],
              [45.5311366, 35.9951348],
              [45.5316861, 35.9953539],
              [45.5322304, 35.9954999],
              [45.5326402, 35.9955256],
              [45.5327354, 35.995536],
              [45.5330606, 35.9955713],
              [45.5334244, 35.9957717],
              [45.5334104, 35.99601],
              [45.5333467, 35.9962322],
              [45.5337927, 35.9966263],
              [45.5340972, 35.9968474],
              [45.5343334, 35.9969827],
              [45.5348559, 35.9972818],
              [45.5352284, 35.99737],
              [45.5356641, 35.9974585],
              [45.5360431, 35.9974669],
              [45.5366319, 35.9973999],
              [45.5372136, 35.9974647],
              [45.5378064, 35.9975012],
              [45.5381444, 35.9977611],
              [45.5384379, 35.9980351],
              [45.5388234, 35.9982805],
              [45.5395732, 35.9986681],
              [45.540775, 35.9990192],
              [45.541798, 35.9990337],
              [45.5429882, 35.9992514],
              [45.5435683, 35.9992531],
              [45.5441876, 35.9992411],
              [45.5444816, 35.9990237],
              [45.5449437, 35.9988152],
              [45.5449968, 35.9988138],
              [45.5456228, 35.9987976],
              [45.545656, 35.998802],
              [45.5463575, 35.9988954],
              [45.5470296, 35.9992414],
              [45.5480223, 35.9997639],
              [45.5484369, 36.0004387],
              [45.5492639, 36.0012483],
              [45.5496254, 36.0015718],
              [45.5498622, 36.0016393],
              [45.5501077, 36.0016545],
              [45.5503353, 36.001621],
              [45.5505154, 36.0015283],
              [45.5506307, 36.001554],
              [45.5507121, 36.0015128],
              [45.5506924, 36.0012967],
              [45.5506489, 36.001126],
              [45.5507392, 36.000907],
              [45.5507562, 36.0006566],
              [45.5506931, 36.0004893],
              [45.5505027, 36.0000113],
              [45.5504021, 35.9998251],
              [45.5504942, 35.9995697],
              [45.5507373, 35.9991887],
              [45.5513156, 35.9988015],
              [45.5514559, 35.998819],
              [45.5517461, 35.9987877],
              [45.5518437, 35.9986603],
              [45.5520665, 35.9986132],
              [45.5524516, 35.9986142],
              [45.5524711, 35.9986187],
              [45.5532452, 35.998764],
              [45.5535183, 35.998863],
              [45.5538246, 35.9990401],
              [45.5542099, 35.9990967],
              [45.5545279, 35.9990705],
              [45.5548599, 35.9990894],
              [45.555758, 35.9987919],
              [45.5558716, 35.9985976],
              [45.5559713, 35.9979861],
              [45.5560586, 35.9977982],
              [45.5563229, 35.9974693],
              [45.5565546, 35.9970541],
              [45.5566222, 35.9968314],
              [45.5567094, 35.9966354],
              [45.5567739, 35.9962632],
              [45.556936, 35.9958797],
              [45.5572403, 35.9955057],
              [45.5573646, 35.9952605],
              [45.55745, 35.9951585],
              [45.557841, 35.9950418],
              [45.5584872, 35.9999714],
              [45.5587676, 36.0044146],
              [45.5584871, 36.004694],
              [45.5582105, 36.0069199],
              [45.5576542, 36.0127509],
              [45.568199, 36.0185593],
              [45.572375, 36.0235879],
              [45.5817114, 36.0331631],
              [45.5861326, 36.039145],
              [45.5879349, 36.0419883],
              [45.5870575, 36.043935],
              [45.5836911, 36.0459493],
              [45.5787992, 36.0490643],
              [45.5745075, 36.050244],
              [45.5697343, 36.0524425],
              [45.568639, 36.054156],
              [45.567255, 36.0597157],
              [45.5671267, 36.0638128],
              [45.5670833, 36.0651971],
              [45.5675554, 36.0688048],
              [45.569229, 36.0721349],
              [45.5716753, 36.0747017],
              [45.5752372, 36.0760198],
              [45.5807304, 36.0762972],
              [45.5856227, 36.077095],
              [45.5877685, 36.0781702],
              [45.5888846, 36.0796674],
              [45.5896568, 36.0836502],
              [45.5895845, 36.0876506],
              [45.590043, 36.0884016],
              [45.591448, 36.0887951],
              [45.5967378, 36.087812],
              [45.6009882, 36.0863679],
              [45.6089294, 36.0842202],
              [45.6152935, 36.0834225],
              [45.617423, 36.0826098],
              [45.6191396, 36.0827832],
              [45.6208992, 36.0823323],
              [45.6259632, 36.0826098],
              [45.6287096, 36.0837891],
              [45.639739, 36.0907251],
              [45.6427002, 36.0937075],
              [45.6448972, 36.0954111],
              [45.6480002, 36.09747],
              [45.6516266, 36.099013],
              [45.6545877, 36.1011282],
              [45.6563902, 36.1039888],
              [45.656476, 36.1061385],
              [45.6560683, 36.1084269],
              [45.6553387, 36.1108192],
              [45.6542014, 36.1132634],
              [45.6505107, 36.120197],
              [45.6496095, 36.1258127],
              [45.6500882, 36.1301873],
              [45.6516695, 36.1384986],
              [45.6529599, 36.1488409],
              [45.6533923, 36.1509283],
              [45.6542015, 36.1528804],
              [45.655119, 36.1545163],
              [45.6581068, 36.1582859],
              [45.6586506, 36.1593008],
              [45.6639976, 36.1652472],
              [45.6705093, 36.168784],
              [45.6781709, 36.1705366],
              [45.6814077, 36.17137],
              [45.6912719, 36.1744202],
              [45.6977893, 36.176442],
              [45.7016517, 36.1787456],
              [45.6909798, 36.1886157],
              [45.6898856, 36.1923562],
              [45.6895852, 36.1941399],
              [45.6896494, 36.195837],
              [45.6903362, 36.1978456],
              [45.6914305, 36.1995771],
              [45.6949944, 36.2023647],
              [45.6972146, 36.2045459],
              [45.6982112, 36.2048322],
              [45.6999492, 36.2060529],
              [45.7040262, 36.2078535],
              [45.7066011, 36.2081998],
              [45.7089219, 36.2078557],
              [45.7135445, 36.2075346],
              [45.7348414, 36.2013748],
              [45.7381998, 36.2003359],
              [45.7438775, 36.1986664],
              [45.7487693, 36.1995873],
              [45.7665739, 36.1948144],
              [45.7680276, 36.1942525],
              [45.7792843, 36.1943675],
              [45.7922373, 36.1945398],
              [45.811141, 36.194788],
              [45.8234167, 36.1949617],
              [45.8261438, 36.1949364],
              [45.8381156, 36.195407],
              [45.8501945, 36.1958325],
              [45.883365, 36.2077042],
              [45.9182165, 36.2361046],
              [45.9389876, 36.2481497],
              [45.9539221, 36.2525796],
              [45.9614169, 36.2572119],
              [45.976766, 36.2647723],
              [45.9796559, 36.269017],
              [45.9859371, 36.2742755],
              [45.9895849, 36.2774931],
              [45.988512, 36.2871104],
              [45.9830188, 36.2993552],
              [45.9810446, 36.307379],
              [45.9808992, 36.3278738],
              [45.9732338, 36.3337964],
              [45.9692, 36.3449967],
              [45.9622559, 36.3551123],
              [45.9601878, 36.372576],
              [45.9549464, 36.380721],
              [45.9553472, 36.3860518],
              [45.9602737, 36.3912331],
              [45.9622478, 36.392615],
              [45.9667968, 36.393375],
              [45.9716031, 36.3914406],
              [45.976839, 36.3924768],
              [45.9820747, 36.3956549],
              [45.9813019, 36.3995931],
              [45.9826755, 36.4123725],
              [45.9859508, 36.4210071],
              [45.988323, 36.4241959],
              [45.9916505, 36.4285528],
              [45.9951639, 36.4301569],
              [45.999349, 36.4313014],
              [46.0031032, 36.4328156],
              [46.0085455, 36.4336523],
              [46.0154534, 36.4277659],
              [46.0282295, 36.4316484],
              [46.0399243, 36.4218352],
              [46.0657873, 36.4242993],
              [46.0711666, 36.4381329],
              [46.1038682, 36.4442091],
              [46.1193097, 36.4534077],
              [46.1538272, 36.459454],
              [46.1608982, 36.4550264],
              [46.1614553, 36.4550265],
              [46.1757716, 36.4486715],
              [46.176881, 36.4486715],
              [46.1785482, 36.4481131],
              [46.1802147, 36.4481131],
              [46.1843843, 36.4470049],
              [46.1857711, 36.447005],
              [46.1864834, 36.4457147],
              [46.1918017, 36.4397556],
              [46.1949777, 36.4357504],
              [46.1972382, 36.4312573],
              [46.2001276, 36.4293627],
              [46.2036895, 36.4283614],
              [46.2082386, 36.4280851],
              [46.2157058, 36.4249429],
              [46.2248039, 36.4201774],
              [46.2337732, 36.4158606],
              [46.2449312, 36.408746],
              [46.2537717, 36.4052231],
              [46.260638, 36.4028563],
              [46.2691783, 36.3988674],
              [46.2750148, 36.3965185],
              [46.2807226, 36.3935822],
              [46.2896718, 36.3887665],
              [46.2933436, 36.3860813],
              [46.2968158, 36.3827343],
              [46.299634, 36.3808164],
              [46.303339, 36.3785882],
              [46.3090896, 36.3763078],
              [46.3194175, 36.3742036],
              [46.3262106, 36.3732678],
              [46.3326501, 36.3724031],
              [46.3480358, 36.3725642],
              [46.357313, 36.3730531],
              [46.3679424, 36.372397],
              [46.3737947, 36.3715995],
              [46.378551, 36.3703583],
              [46.3845563, 36.3686997],
              [46.3955211, 36.3654574],
              [46.4036747, 36.3617944],
              [46.4088678, 36.359686],
              [46.4117002, 36.3603427],
              [46.4173218, 36.3653885],
              [46.4226436, 36.3718157],
              [46.4275826, 36.3799342],
              [46.4304203, 36.3849525],
              [46.4344024, 36.3934441],
              [46.4380825, 36.4017879],
              [46.4399151, 36.4052562],
              [46.4446103, 36.4110449],
              [46.4515819, 36.4159346],
              [46.4548198, 36.4176815],
              [46.4583339, 36.4187693],
              [46.4645519, 36.4201018],
              [46.4724163, 36.4208961],
              [46.478838, 36.4211122],
              [46.4850494, 36.4208014],
              [46.4911575, 36.4204591],
              [46.4960501, 36.4196476],
              [46.4997915, 36.4188045],
              [46.5027143, 36.4181368],
              [46.5033908, 36.4175384],
              [46.5075573, 36.41703],
              [46.5094112, 36.4166903],
              [46.5152109, 36.4146723],
              [46.5173618, 36.4135326],
              [46.5198636, 36.4123689],
              [46.5221948, 36.4112512],
              [46.524148, 36.4105467],
              [46.5258168, 36.4100229],
              [46.5268971, 36.4096782],
              [46.5283012, 36.408228],
              [46.5288162, 36.4069155],
              [46.5296745, 36.4056721],
              [46.5306615, 36.4041178],
              [46.5320777, 36.4022871],
              [46.5334081, 36.4014236],
              [46.5356183, 36.4006118],
              [46.5377211, 36.4002837],
              [46.5397596, 36.4003182],
              [46.540854, 36.4003355],
              [46.5422916, 36.4006291],
              [46.5462827, 36.402149],
              [46.5491151, 36.404325],
              [46.5530204, 36.4019762],
              [46.5772247, 36.3986947],
              [46.5916013, 36.3972094],
              [46.6025447, 36.3959658],
              [46.6154193, 36.3967948],
              [46.6203117, 36.3967948],
              [46.6223287, 36.3980902],
              [46.6255045, 36.3989538],
              [46.6292166, 36.3984184],
              [46.6316628, 36.3990574],
              [46.6383361, 36.4006982],
              [46.6523265, 36.4009746],
              [46.6707801, 36.4014581],
              [46.6862296, 36.4037379],
              [46.7074298, 36.4039451],
              [46.7254972, 36.4102657],
              [46.7324066, 36.4128905],
              [46.7463541, 36.4163787],
              [46.7578125, 36.418727],
              [46.768198, 36.4178291],
              [46.7784547, 36.4196249],
              [46.7860078, 36.4222149],
              [46.7941618, 36.4259097],
              [46.7954921, 36.4269111],
              [46.8008565, 36.4269802],
              [46.804227, 36.4263742],
              [46.8065577, 36.4284946],
              [46.8069859, 36.4286404],
              [46.8080355, 36.4290219],
              [46.8092714, 36.4293948],
              [46.8124643, 36.4318809],
              [46.8135201, 36.4317358],
              [46.8151938, 36.4326059],
              [46.8157345, 36.4336418],
              [46.816919, 36.4346569],
              [46.8170992, 36.4352991],
              [46.8184124, 36.4357962],
              [46.8205238, 36.4379507],
              [46.8237425, 36.439815],
              [46.827004, 36.438643],
              [46.8275602, 36.438643],
              [46.8278368, 36.4383637],
              [46.8283939, 36.4383638],
              [46.8295041, 36.4380936],
              [46.8297806, 36.4378144],
              [46.8308939, 36.4378144],
              [46.849373, 36.4184417],
              [46.8659267, 36.3941974],
              [46.8777542, 36.3835732],
              [46.8868512, 36.3778213],
              [46.8905838, 36.3676668],
              [46.8896565, 36.3592963],
              [46.8934544, 36.3495927],
              [46.8975447, 36.3452732],
              [46.905102, 36.3419882],
              [46.9202883, 36.3401852],
              [46.942005, 36.3386361],
              [46.9615744, 36.337115],
              [46.9736602, 36.3355973],
              [47.0310556, 36.3060993],
              [47.031336, 36.30582],
              [47.042169, 36.2974865],
              [47.042169, 36.2972073],
              [47.0427221, 36.2972072],
              [47.0435558, 36.2963694],
              [47.0455019, 36.2952612],
              [47.0621741, 36.28151],
              [47.0656596, 36.2765801],
              [47.0680904, 36.274241],
              [47.0720386, 36.2718191],
              [47.0789257, 36.2708602],
              [47.083322, 36.2679466],
              [47.0892905, 36.2606081],
              [47.0952987, 36.2558326],
              [47.1038818, 36.252095],
              [47.1160697, 36.2507799],
              [47.1310618, 36.250538],
              [47.1503798, 36.2513417],
              [47.1872937, 36.2502378],
              [47.2112691, 36.2503705],
              [47.2266196, 36.2514029],
              [47.2486369, 36.2520486],
              [47.2933101, 36.2556942],
              [47.3117647, 36.259455],
              [47.3248099, 36.2668367],
              [47.3291015, 36.2687051],
              [47.3395729, 36.278185],
              [47.3472976, 36.2878023],
              [47.3549153, 36.2963912],
              [47.3614668, 36.3058531],
              [47.3658983, 36.3120193],
              [47.370766, 36.3174458],
              [47.3757934, 36.3217643],
              [47.3889736, 36.3290032],
              [47.3973741, 36.3296076],
              [47.4091815, 36.3263975],
              [47.4263476, 36.324807],
              [47.4302101, 36.3235623],
              [47.4460885, 36.3214188],
              [47.4568176, 36.3196205],
              [47.465057, 36.3187216],
              [47.4920079, 36.3360089],
              [47.5253102, 36.3635224],
              [47.5131549, 36.3910319],
              [47.5131808, 36.3911143],
              [47.5183364, 36.3960848],
              [47.5183364, 36.3963641],
              [47.5071679, 36.3963705],
              [47.5069172, 36.397196],
              [47.4902416, 36.3990154],
              [47.4914504, 36.4032449],
              [47.4887463, 36.3991786],
              [47.4879121, 36.3992346],
              [47.4840119, 36.3994962],
              [47.4640271, 36.4008366],
              [47.4293515, 36.3958624],
              [47.3881527, 36.4171387],
              [47.3696133, 36.43178],
              [47.3751061, 36.455532],
              [47.3950188, 36.473203],
              [47.4578116, 36.5024179],
              [47.4586445, 36.5043631],
              [47.4586445, 36.5046423],
              [47.4597546, 36.507146],
              [47.4603116, 36.5110365],
              [47.4597546, 36.5127026],
              [47.458921, 36.5165842],
              [47.4586444, 36.5179709],
              [47.4583646, 36.5188085],
              [47.4578115, 36.5204746],
              [47.456978, 36.5226991],
              [47.4533646, 36.5288049],
              [47.4142449, 36.5361232],
              [47.3943322, 36.5504662],
              [47.3771661, 36.5598429],
              [47.3702399, 36.5726373],
              [47.3434775, 36.614683],
              [47.3232004, 36.6427341],
              [47.3229208, 36.6435716],
              [47.3212543, 36.6457958],
              [47.2920314, 36.6693083],
              [47.2786983, 36.6809813],
              [47.2784216, 36.6812603],
              [47.2778646, 36.6815396],
              [47.2713451, 36.7008326],
              [47.270231, 36.7011117],
              [47.2615784, 36.7185076],
              [47.2123715, 36.7685925],
              [47.1813416, 36.7886056],
              [47.1810651, 36.789443],
              [47.1810651, 36.7902714],
              [47.1802322, 36.7911087],
              [47.1802322, 36.7913878],
              [47.1799518, 36.791667],
              [47.1782853, 36.7938818],
              [47.1777322, 36.7949982],
              [47.1643954, 36.8016609],
              [47.1638392, 36.80194],
              [47.1618923, 36.8038848],
              [47.1532819, 36.8113847],
              [47.1449488, 36.8275006],
              [47.1405026, 36.8322183],
              [47.1374486, 36.8330556],
              [47.1332822, 36.8336047],
              [47.1307821, 36.8330556],
              [47.1205022, 36.8275006],
              [47.119946, 36.8269424],
              [47.1182795, 36.8269424],
              [47.111059, 36.8302735],
              [47.1068925, 36.8319391],
              [47.1049464, 36.8324973],
              [47.1024463, 36.8324973],
              [47.0993892, 36.8313809],
              [47.0974463, 36.8313809],
              [47.0963361, 36.8311108],
              [47.0766131, 36.8194425],
              [47.0721669, 36.8166694],
              [47.0710566, 36.8163904],
              [47.0696668, 36.815274],
              [47.0599432, 36.8108352],
              [47.0493867, 36.8072158],
              [47.0485531, 36.8072158],
              [47.0407771, 36.8033263],
              [47.0368872, 36.8013815],
              [47.0363334, 36.8008322],
              [47.0218869, 36.7908292],
              [47.0204971, 36.7891635],
              [47.0185542, 36.7686077],
              [47.0179971, 36.7661046],
              [47.0177205, 36.7649971],
              [47.0116072, 36.7544354],
              [47.0038305, 36.747223],
              [47.0029977, 36.7466648],
              [46.9979975, 36.7452781],
              [46.9949413, 36.7469438],
              [46.9941076, 36.7477723],
              [46.9699856, 36.7504389],
              [46.9500729, 36.7523645],
              [46.9304953, 36.7555517],
              [46.9302147, 36.7558307],
              [46.9279952, 36.7566592],
              [46.9246615, 36.7605579],
              [46.9229951, 36.7627729],
              [46.9219647, 36.7732868],
              [46.9186318, 36.7755016],
              [46.9175217, 36.7757807],
              [46.9169646, 36.7763389],
              [46.9147451, 36.7771763],
              [46.903355, 36.7799493],
              [46.8972415, 36.7799493],
              [46.8961321, 36.7802284],
              [46.893632, 36.7802283],
              [46.8925219, 36.7805075],
              [46.8914086, 36.7805075],
              [46.890575, 36.7807866],
              [46.8897421, 36.7807866],
              [46.8779925, 36.7799973],
              [46.8735455, 36.78639],
              [46.8732689, 36.7866601],
              [46.8729923, 36.788884],
              [46.8729924, 36.7891632],
              [46.8729923, 36.7894423],
              [46.8727119, 36.7900005],
              [46.8727118, 36.7904101],
              [46.8724353, 36.7911079],
              [46.8721587, 36.7930527],
              [46.8752118, 36.8008319],
              [46.8941113, 36.815332],
              [46.9002911, 36.8293483],
              [46.9135643, 36.8389531],
              [46.9149542, 36.8472791],
              [46.9152338, 36.8503394],
              [46.9157878, 36.8558929],
              [46.9020978, 36.8699023],
              [46.9049731, 36.8821088],
              [46.9074743, 36.8927258],
              [46.9074744, 36.8957864],
              [46.9077509, 36.898559],
              [46.9074743, 36.8991171],
              [46.9027515, 36.9088392],
              [46.892291, 36.9102619],
              [46.8917378, 36.91082],
              [46.8642349, 36.9185977],
              [46.8622918, 36.9194349],
              [46.8492353, 36.9285988],
              [46.8436781, 36.9385999],
              [46.8389552, 36.9544338],
              [46.8389552, 36.9583224],
              [46.8386786, 36.9591506],
              [46.8421779, 36.971124],
              [46.8421779, 36.9736173],
              [46.8421778, 36.9755616],
              [46.8535992, 37.0028271],
              [46.8257901, 37.0368178],
              [46.8027085, 37.0486128],
              [46.8024319, 37.0488918],
              [46.8019014, 37.0492971],
              [46.7893754, 37.0541661],
              [46.7865987, 37.054445],
              [46.7849323, 37.054445],
              [46.7840955, 37.054724],
              [46.783262, 37.054724],
              [46.7827088, 37.055003],
              [46.7807619, 37.0550031],
              [46.7802087, 37.055282],
              [46.7782618, 37.0552821],
              [46.7779853, 37.0555611],
              [46.774929, 37.0555611],
              [46.7713187, 37.0561101],
              [46.7707624, 37.0563891],
              [46.7696522, 37.0563891],
              [46.7690952, 37.056668],
              [46.7674287, 37.0566681],
              [46.7671522, 37.0569471],
              [46.7654857, 37.0569471],
              [46.7652053, 37.0572261],
              [46.7643724, 37.0572261],
              [46.7638194, 37.0575051],
              [46.7621521, 37.0575051],
              [46.7615958, 37.0577841],
              [46.7602059, 37.0577841],
              [46.7329827, 37.0677834],
              [46.7304825, 37.0688904],
              [46.7263161, 37.0702764],
              [46.7093696, 37.0724994],
              [46.7063165, 37.0722294],
              [46.7054828, 37.0719504],
              [46.7046492, 37.0719504],
              [46.7040929, 37.0716714],
              [46.7029828, 37.0716713],
              [46.6908877, 37.0668834],
              [46.6900548, 37.0668834],
              [46.6861649, 37.0646603],
              [46.6850548, 37.0643904],
              [46.6847743, 37.0641115],
              [46.6839414, 37.0635534],
              [46.6833883, 37.0635534],
              [46.6850208, 37.0509351],
              [46.6904427, 37.0382664],
              [46.6887763, 37.0360428],
              [46.6603531, 37.0418209],
              [46.659243, 37.041821],
              [46.6421472, 37.0411149],
              [46.6407573, 37.0411149],
              [46.6382572, 37.0405569],
              [46.6165904, 37.0363595],
              [46.611034, 37.0352824],
              [46.5949211, 37.0330592],
              [46.5940875, 37.0327802],
              [46.591311, 37.0327801],
              [46.5907539, 37.0325011],
              [46.5879773, 37.0325012],
              [46.5871445, 37.0322221],
              [46.5801975, 37.0322221],
              [46.5768646, 37.0319521],
              [46.5760309, 37.031673],
              [46.5729746, 37.031673],
              [46.5690878, 37.0311149],
              [46.567698, 37.031115],
              [46.5665878, 37.030836],
              [46.5660315, 37.030836],
              [46.5626979, 37.0302779],
              [46.561308, 37.0302779],
              [46.559365, 37.0297289],
              [46.5590876, 37.0294498],
              [46.5579743, 37.0294499],
              [46.5507514, 37.0272266],
              [46.5274154, 37.0282318],
              [46.5263053, 37.0282318],
              [46.5257482, 37.0279528],
              [46.5249153, 37.0279529],
              [46.5243583, 37.0276738],
              [46.5232481, 37.0276738],
              [46.5229715, 37.0273948],
              [46.5040966, 37.0176314],
              [46.489855, 37.0158664],
              [46.489019, 37.0161456],
              [46.4812423, 37.0161456],
              [46.4809658, 37.0164246],
              [46.4776321, 37.0164246],
              [46.4767984, 37.0167036],
              [46.4744686, 37.0172145],
              [46.4653015, 37.019036],
              [46.4589524, 37.0196189],
              [46.4526844, 37.0217772],
              [46.4512682, 37.0231135],
              [46.4527702, 37.0252378],
              [46.454892, 37.0269139],
              [46.4570617, 37.0288352],
              [46.4595508, 37.0299316],
              [46.461797, 37.0329132],
              [46.462269, 37.0354984],
              [46.4624678, 37.0390896],
              [46.462276, 37.0401404],
              [46.4626622, 37.0408598],
              [46.4636063, 37.0417675],
              [46.4666107, 37.0431049],
              [46.476953, 37.0483613],
              [46.4829826, 37.051735],
              [46.488959, 37.0564537],
              [46.4915027, 37.0584603],
              [46.4937114, 37.0605883],
              [46.4966297, 37.0651087],
              [46.4967155, 37.0668551],
              [46.4956246, 37.0696583],
              [46.4953851, 37.0719572],
              [46.4958829, 37.0741285],
              [46.4963566, 37.0768892],
              [46.4976596, 37.0828109],
              [46.4978742, 37.0868849],
              [46.4968007, 37.0920848],
              [46.4954099, 37.0948949],
              [46.4933677, 37.0987708],
              [46.4914281, 37.1003228],
              [46.4865897, 37.1004768],
              [46.4829444, 37.0998659],
              [46.4817319, 37.0996673],
              [46.4796586, 37.0989421],
              [46.4753601, 37.0976823],
              [46.4704511, 37.0962908],
              [46.4680437, 37.0959245],
              [46.4638412, 37.095228],
              [46.4604757, 37.0950568],
              [46.4531426, 37.0964134],
              [46.4475137, 37.0977485],
              [46.4413562, 37.1012004],
              [46.4404392, 37.1012347],
              [46.4401449, 37.1008417],
              [46.4398039, 37.098697],
              [46.4391875, 37.096333],
              [46.4391446, 37.0946044],
              [46.4398527, 37.0928757],
              [46.4403891, 37.0922082],
              [46.4397883, 37.0913353],
              [46.437943, 37.0902741],
              [46.4368271, 37.089384],
              [46.4359689, 37.087039],
              [46.4347886, 37.0850705],
              [46.4338231, 37.0838893],
              [46.433351, 37.0825541],
              [46.4329219, 37.0808423],
              [46.4325142, 37.0796097],
              [46.4319133, 37.0772131],
              [46.4282869, 37.0743027],
              [46.4252167, 37.0734606],
              [46.4103698, 37.0667524],
              [46.3943194, 37.0594239],
              [46.3763053, 37.0488913],
              [46.3694088, 37.0463893],
              [46.3545143, 37.0386275],
              [46.346408, 37.0336894],
              [46.3176342, 37.0202686],
              [46.3084796, 37.0157685],
              [46.3086605, 37.0144444],
              [46.3054847, 37.0080361],
              [46.3043583, 37.0048004],
              [46.3037631, 37.0029108],
              [46.3035106, 36.9977544],
              [46.2994991, 36.98751],
              [46.2940692, 36.9792438],
              [46.2907219, 36.9729012],
              [46.290121, 36.971564],
              [46.2885855, 36.9692809],
              [46.286466, 36.9676595],
              [46.2838182, 36.9657498],
              [46.2812805, 36.9635062],
              [46.2777969, 36.9626878],
              [46.2769031, 36.9627176],
              [46.2749273, 36.9639567],
              [46.2714958, 36.9661808],
              [46.269298, 36.9674842],
              [46.2656164, 36.9686496],
              [46.2623977, 36.9685124],
              [46.2599086, 36.9666266],
              [46.2562723, 36.9665532],
              [46.2524199, 36.966798],
              [46.2511754, 36.9671066],
              [46.2497082, 36.9675304],
              [46.2475195, 36.9689065],
              [46.245375, 36.969989],
              [46.2446287, 36.9702757],
              [46.2435154, 36.9708586],
              [46.2414336, 36.9721297],
              [46.2387514, 36.9735869],
              [46.2364983, 36.9745126],
              [46.2344813, 36.9746668],
              [46.2339877, 36.9741698],
              [46.2325287, 36.9726611],
              [46.2314557, 36.9709812],
              [46.2267779, 36.9654608],
              [46.2224864, 36.9625118],
              [46.2178035, 36.9586589],
              [46.2141005, 36.956591],
              [46.2104584, 36.9557586],
              [46.2061311, 36.9549355],
              [46.2008295, 36.9540486],
              [46.1995907, 36.9540144],
              [46.1964579, 36.953436],
              [46.1937098, 36.9413669],
              [46.188397, 36.9441509],
              [46.1827338, 36.947855],
              [46.1805068, 36.948936],
              [46.1755568, 36.9528007],
              [46.171844, 36.9593991],
              [46.1725783, 36.9632976],
              [46.1751038, 36.9681942],
              [46.1762807, 36.9753928],
              [46.1760241, 36.9829693],
              [46.1758953, 36.9844383],
              [46.1769564, 36.9945469],
              [46.175971, 36.9976763],
              [46.1724975, 36.9980092],
              [46.1714172, 36.9986798],
              [46.1699152, 37.0010447],
              [46.1689281, 37.0047118],
              [46.1657799, 37.0084539],
              [46.1602592, 37.0100923],
              [46.1585426, 37.0109833],
              [46.1567831, 37.0125939],
              [46.1556243, 37.0139303],
              [46.1549789, 37.0151171],
              [46.1548948, 37.0164147],
              [46.1560749, 37.0178025],
              [46.1562681, 37.01955],
              [46.1545515, 37.0254776],
              [46.154809, 37.0271564],
              [46.1553239, 37.0302399],
              [46.1560535, 37.0325353],
              [46.154766, 37.0344195],
              [46.153135, 37.0358072],
              [46.1496377, 37.0375541],
              [46.1450243, 37.0392497],
              [46.1442947, 37.0399177],
              [46.1434257, 37.0402688],
              [46.1416983, 37.0404829],
              [46.1404967, 37.0407656],
              [46.1381042, 37.0416648],
              [46.1375892, 37.0420758],
              [46.1361301, 37.0438313],
              [46.1347997, 37.0447905],
              [46.1339199, 37.045133],
              [46.1242532, 37.0489436],
              [46.1115932, 37.0554511],
              [46.1071602, 37.0571469],
              [46.1048675, 37.0575729],
              [46.1021218, 37.0588451],
              [46.0970275, 37.0549483],
              [46.0933596, 37.0584359],
              [46.0867881, 37.0645265],
              [46.0801696, 37.0705701],
              [46.0702387, 37.0808077],
              [46.0624888, 37.0879605],
              [46.0549449, 37.0952035],
              [46.0549879, 37.0967781],
              [46.0545158, 37.0979076],
              [46.0550892, 37.1003523],
              [46.0541296, 37.1011251],
              [46.0532444, 37.102368],
              [46.0531793, 37.1024562],
              [46.0527563, 37.1031788],
              [46.0495376, 37.1042398],
              [46.0470485, 37.1064988],
              [46.0475762, 37.1080667],
              [46.0485838, 37.1088263],
              [46.0482931, 37.1093737],
              [46.0457562, 37.109629],
              [46.0443409, 37.111082],
              [46.0445165, 37.1130356],
              [46.0450315, 37.1138227],
              [46.0446882, 37.114644],
              [46.0430574, 37.1157734],
              [46.0420274, 37.1176897],
              [46.0396671, 37.1183057],
              [46.0397524, 37.1205482],
              [46.0383796, 37.1224805],
              [46.0368347, 37.1248757],
              [46.0372638, 37.1274762],
              [46.0367265, 37.1285151],
              [46.0355901, 37.1313083],
              [46.0332848, 37.1340897],
              [46.0303115, 37.1356192],
              [46.0253763, 37.1377061],
              [46.0213422, 37.1376719],
              [46.0180807, 37.1373298],
              [46.0163111, 37.1376159],
              [46.0146183, 37.1383396],
              [46.0135327, 37.1396334],
              [46.0129737, 37.1416404],
              [46.0118869, 37.1433106],
              [46.0101704, 37.144999],
              [46.0093367, 37.1472219],
              [46.0062568, 37.1514226],
              [46.0048423, 37.153275],
              [46.0033984, 37.1540275],
              [46.0007528, 37.1553326],
              [45.9977312, 37.1568034],
              [45.9950351, 37.1582303],
              [45.9931039, 37.160214],
              [45.9907865, 37.1612058],
              [45.9888055, 37.1632768],
              [45.9861037, 37.1649593],
              [45.9832294, 37.1656433],
              [45.9797573, 37.1667462],
              [45.9749937, 37.1680115],
              [45.9713459, 37.168969],
              [45.9679555, 37.1684903],
              [45.9661531, 37.1695162],
              [45.9653973, 37.1705624],
              [45.9628989, 37.1716223],
              [45.9599304, 37.1726964],
              [45.9565502, 37.1726876],
              [45.9547065, 37.1731771],
              [45.9505956, 37.1741055],
              [45.9474454, 37.1749999],
              [45.9426652, 37.1756838],
              [45.9400445, 37.1756783],
              [45.9355991, 37.1768598],
              [45.932254, 37.1777714],
              [45.9297929, 37.1777714],
              [45.927864, 37.1775374],
              [45.9246791, 37.1768877],
              [45.9221434, 37.1764408],
              [45.9197187, 37.1763553],
              [45.9158563, 37.1744575],
              [45.9124446, 37.1735],
              [45.9106636, 37.1731239],
              [45.908904, 37.1725939],
              [45.8833265, 37.1716364],
              [45.8674478, 37.1722861],
              [45.863285, 37.1726281],
              [45.8460885, 37.1749873],
              [45.7611034, 37.2065666],
              [45.6878289, 37.2901539],
              [45.6421216, 37.3036418],
              [45.6291132, 37.3035606],
              [45.5953151, 37.3033496],
              [45.5868276, 37.3059703],
              [45.5836179, 37.3155446],
              [45.5857526, 37.3244002],
              [45.5723531, 37.3265509],
              [45.5582813, 37.3271867],
              [45.5564822, 37.3290021],
              [45.5551695, 37.3319764],
              [45.5518166, 37.3332071],
              [45.547613, 37.3348653],
              [45.5457115, 37.3357075],
              [45.5442443, 37.3357214],
              [45.5163567, 37.3483266],
              [45.4983608, 37.3604861],
              [45.4718856, 37.3845861],
              [45.4710381, 37.4219812],
              [45.4627587, 37.4451104],
              [45.4588598, 37.4603627],
              [45.4606918, 37.4644556],
              [45.475158, 37.498832],
              [45.4722672, 37.5292754],
              [45.4702849, 37.5362969],
              [45.5225365, 37.5832222],
              [45.5223037, 37.5924467],
              [45.5218499, 37.6104244],
              [45.5086374, 37.6259642],
              [45.4991906, 37.637073],
              [45.4681383, 37.6626187],
              [45.4199217, 37.7022675],
              [45.3931042, 37.7310821],
              [45.3774764, 37.7682854],
              [45.3792518, 37.7814531],
              [45.3689036, 37.7865582],
              [45.3716467, 37.7918799],
              [45.3783413, 37.7945931],
              [45.3809419, 37.8014272],
              [45.3858944, 37.8200907],
              [45.3852673, 37.8423328],
              [45.3844338, 37.8426114],
              [45.3824612, 37.8604891],
              [45.3786811, 37.8744895],
              [45.3749044, 37.8850655],
              [45.3701016, 37.9100756],
              [45.3586406, 37.9297732],
              [45.3586407, 37.9317235],
              [45.3586407, 37.9317236],
              [45.3586406, 37.9325593],
              [45.3583602, 37.9342219],
              [45.3357675, 37.9697083],
              [45.336044, 37.9705438],
              [45.3357675, 37.9710918],
              [45.3360441, 37.9713703],
              [45.3354909, 37.9727628],
              [45.3234746, 37.9846324],
              [45.3126351, 38.0037117],
              [45.3109308, 38.0061197],
              [45.2725979, 38.0602567],
              [45.248222, 38.0859326],
              [45.2438245, 38.1232975],
              [45.2376182, 38.1759983],
              [45.1611606, 38.1901475],
              [45.1611605, 38.1901477],
              [45.133586, 38.2177997],
              [45.1335685, 38.2178206],
              [45.129089, 38.2282022],
              [45.1256991, 38.2308651],
              [45.1229092, 38.2330566],
              [45.1215359, 38.252471],
              [45.1083189, 38.2723535],
              [45.1100487, 38.2880934],
              [45.1099005, 38.2890257],
              [45.1090668, 38.2940292],
              [45.1087871, 38.2943077],
              [45.0951209, 38.3122537],
              [45.0948443, 38.3133675],
              [45.0951208, 38.3139243],
              [45.0937309, 38.3203105],
              [45.0935234, 38.3211458],
              [45.0934543, 38.3219721],
              [45.1061399, 38.3290841],
              [45.1384325, 38.3530628],
              [45.1506481, 38.3621882],
              [45.1514809, 38.3621881],
              [45.1542576, 38.3635805],
              [45.1678711, 38.3671916],
              [45.1684243, 38.3674701],
              [45.1709243, 38.368027],
              [45.1720376, 38.368027],
              [45.1789992, 38.3775968],
              [45.1959455, 38.3903691],
              [45.2025603, 38.3909172],
              [45.2218583, 38.3813408],
              [45.223868, 38.3831248],
              [45.2354248, 38.3905131],
              [45.2435873, 38.3934736],
              [45.2424212, 38.3980432],
              [45.2301977, 38.4127105],
              [45.2257345, 38.4219909],
              [45.2283736, 38.4307204],
              [45.2354337, 38.4335345],
              [45.2404338, 38.4338039],
              [45.2418197, 38.4335346],
              [45.2468238, 38.4338039],
              [45.2575484, 38.4342346],
              [45.273509, 38.4358951],
              [45.2762887, 38.4367303],
              [45.3149985, 38.450228],
              [45.3297613, 38.4616542],
              [45.3356041, 38.4764312],
              [45.3264998, 38.4953845],
              [45.2961157, 38.5210412],
              [45.2750014, 38.5333961],
              [45.2652541, 38.5431761],
              [45.2597008, 38.5540165],
              [45.2594211, 38.554295],
              [45.2686499, 38.5776953],
              [45.2623513, 38.5900401],
              [45.2620708, 38.5919792],
              [45.2617943, 38.5939273],
              [45.2658092, 38.5985816],
              [45.2691673, 38.6070271],
              [45.2680541, 38.6131407],
              [45.2616672, 38.6178629],
              [45.2579042, 38.6283718],
              [45.2581838, 38.6289284],
              [45.2590174, 38.6317021],
              [45.2579041, 38.6353197],
              [45.253461, 38.6453194],
              [45.2526274, 38.6461541],
              [45.2526274, 38.6467107],
              [45.2410189, 38.6574726],
              [45.2374054, 38.6591422],
              [45.2401859, 38.6624726],
              [45.2404626, 38.6630291],
              [45.2387954, 38.6641421],
              [45.2396289, 38.6663684],
              [45.240186, 38.6663684],
              [45.240186, 38.6666466],
              [45.2418524, 38.6666466],
              [45.2432423, 38.6669159],
              [45.2476853, 38.6694205],
              [45.2474088, 38.6708118],
              [45.2492466, 38.6768331],
              [45.2492466, 38.6771204],
              [45.2495263, 38.6776679],
              [45.2511927, 38.6821203],
              [45.2575219, 38.6906351],
              [45.2578016, 38.6945217],
              [45.2641914, 38.7048074],
              [45.2689039, 38.7126727],
              [45.2714032, 38.7171244],
              [45.2730703, 38.7224017],
              [45.2734602, 38.7278233],
              [45.2751266, 38.7303183],
              [45.2754071, 38.7314312],
              [45.2756837, 38.7319877],
              [45.2756836, 38.7331006],
              [45.2751266, 38.7333787],
              [45.2715163, 38.7430984],
              [45.2713616, 38.753891],
              [45.2691411, 38.7650015],
              [45.2732847, 38.7714842],
              [45.2657467, 38.7852611],
              [45.2694183, 38.7925076],
              [45.2755981, 38.8630989],
              [45.2781728, 38.8670312],
              [45.2774194, 38.8677427],
              [45.2776991, 38.8680208],
              [45.2806822, 38.873106],
              [45.2815158, 38.8736622],
              [45.3063601, 38.8773172],
              [45.3063601, 38.8778739],
              [45.3198117, 38.8836864],
              [45.3362203, 38.8877516],
              [45.3362203, 38.8883082],
              [45.3417134, 38.8956119],
              [45.3414343, 38.8997172],
              [45.3458975, 38.90466],
              [45.3493307, 38.9146782],
              [45.3577421, 38.918418],
              [45.362377, 38.9441903],
              [45.3706167, 38.947795],
              [45.3754943, 38.959335],
              [45.3763279, 38.9609946],
              [45.3779074, 38.9625519],
              [45.3840208, 38.9656019],
              [45.391521, 38.9708856],
              [45.3926311, 38.9714417],
              [45.393464, 38.9714418],
              [45.3962446, 38.9725541],
              [45.3976305, 38.9725542],
              [45.398464, 38.9728322],
              [45.399854, 38.9728322],
              [45.4006876, 38.9731103],
              [45.4037439, 38.9731103],
              [45.4042971, 38.9733794],
              [45.4114158, 38.9740586],
              [45.4158589, 38.9746148],
              [45.4194722, 38.9746149],
              [45.4197488, 38.9748929],
              [45.4234505, 38.9752265],
              [45.428329, 38.9767307],
              [45.4286055, 38.9772869],
              [45.4358284, 38.9806241],
              [45.4420768, 38.9842158],
              [45.4431901, 38.9844938],
              [45.44958, 38.9903245],
              [45.4501334, 38.9906022],
              [45.4529047, 38.9929965],
              [45.4512753, 38.9938018],
              [45.4494691, 38.9944591],
              [45.4487791, 38.9945881],
              [45.4464142, 38.9968426],
              [45.4454308, 38.9982848],
              [45.4435936, 38.9995619],
              [45.4403996, 39.0032959],
              [45.4383272, 39.0044242],
              [45.4379406, 39.0063856],
              [45.4388517, 39.0087063],
              [45.4386118, 39.0097039],
              [45.437712, 39.0102201],
              [45.4371892, 39.0108721],
              [45.4368899, 39.0117784],
              [45.4370592, 39.0127601],
              [45.4374816, 39.013617],
              [45.4400106, 39.0169683],
              [45.4401791, 39.0178957],
              [45.4465145, 39.0244808],
              [45.4464797, 39.0251457],
              [45.4469407, 39.025789],
              [45.4480598, 39.0262096],
              [45.4501057, 39.0290281],
              [45.4505518, 39.0306275],
              [45.4504859, 39.032183],
              [45.4500732, 39.0333884],
              [45.4497973, 39.0344326],
              [45.4497695, 39.0350944],
              [45.4507083, 39.0378902],
              [45.4504282, 39.03873],
              [45.4503496, 39.0395054],
              [45.4524792, 39.0424516],
              [45.4543383, 39.0439579],
              [45.455993, 39.0450199],
              [45.4566119, 39.0469824],
              [45.4555844, 39.049068],
              [45.455739, 39.0496005],
              [45.4566746, 39.0498014],
              [45.4570328, 39.0502444],
              [45.4569034, 39.0511283],
              [45.4562818, 39.0519076],
              [45.4537021, 39.0538212],
              [45.4527006, 39.055054],
              [45.4465657, 39.0548363],
              [45.443887, 39.0538674],
              [45.4418409, 39.0517737],
              [45.4407091, 39.0514081],
              [45.4393141, 39.0514762],
              [45.4373305, 39.0526839],
              [45.4349778, 39.0527333],
              [45.4344127, 39.053213],
              [45.4332662, 39.0533489],
              [45.4318257, 39.0549157],
              [45.4320995, 39.0561796],
              [45.4303469, 39.0595101],
              [45.4303868, 39.0606386],
              [45.4291246, 39.0611952],
              [45.4277872, 39.0611753],
              [45.4254471, 39.0609063],
              [45.42238, 39.0625038],
              [45.4201856, 39.0629159],
              [45.4184397, 39.0638454],
              [45.4177622, 39.0651725],
              [45.4158259, 39.0663867],
              [45.4141415, 39.0682985],
              [45.4130527, 39.0686128],
              [45.4093028, 39.0709281],
              [45.4064895, 39.0722315],
              [45.4030843, 39.0727792],
              [45.4020553, 39.0748882],
              [45.4005459, 39.0768259],
              [45.3998628, 39.082567],
              [45.400663, 39.0859288],
              [45.4020924, 39.088302],
              [45.4024111, 39.0916736],
              [45.3987172, 39.094991],
              [45.3901148, 39.1018795],
              [45.3870491, 39.105195],
              [45.3840844, 39.1069178],
              [45.376111, 39.1090251],
              [45.3708976, 39.11182],
              [45.3691225, 39.1133288],
              [45.3663959, 39.1173121],
              [45.3652116, 39.1198219],
              [45.3638892, 39.1212006],
              [45.3637801, 39.1212901],
              [45.3618421, 39.1228787],
              [45.3601889, 39.1235341],
              [45.3585009, 39.1240269],
              [45.3546876, 39.1263944],
              [45.3529652, 39.1293834],
              [45.352587, 39.1329547],
              [45.3540359, 39.1351921],
              [45.3603949, 39.1401906],
              [45.3622142, 39.1439679],
              [45.3631991, 39.1472832],
              [45.3631653, 39.1508581],
              [45.360758, 39.1559525],
              [45.3497813, 39.1705737],
              [45.3476515, 39.1710528],
              [45.3449798, 39.1709314],
              [45.3414806, 39.1695087],
              [45.3347643, 39.1690369],
              [45.329266, 39.1698773],
              [45.321512, 39.1679353],
              [45.3134923, 39.1661377],
              [45.3075085, 39.1657765],
              [45.3042399, 39.166023],
              [45.3040367, 39.1700064],
              [45.3135905, 39.1752936],
              [45.3250085, 39.1806191],
              [45.3275812, 39.1859033],
              [45.3260119, 39.1902296],
              [45.3201164, 39.1961805],
              [45.316613, 39.1984975],
              [45.3133785, 39.2001895],
              [45.3084994, 39.2016259],
              [45.306088, 39.2017751],
              [45.3025922, 39.2012281],
              [45.3009218, 39.2006187],
              [45.2993434, 39.1903979],
              [45.2963509, 39.1878318],
              [45.2856562, 39.1833438],
              [45.2770447, 39.1845762],
              [45.2729092, 39.185898],
              [45.2476296, 39.1856003],
              [45.2372821, 39.1935656],
              [45.2311289, 39.1940917],
              [45.2168433, 39.2087208],
              [45.2036497, 39.2036509],
              [45.1994207, 39.2047839],
              [45.1979446, 39.211562],
              [45.1946249, 39.2142296],
              [45.1899503, 39.2153513],
              [45.1847708, 39.2205229],
              [45.1781489, 39.2225268],
              [45.1734376, 39.223156],
              [45.1710902, 39.221693],
              [45.1695536, 39.2185696],
              [45.1675393, 39.2157778],
              [45.1615157, 39.2129691],
              [45.1555585, 39.2086202],
              [45.1517015, 39.2060229],
              [45.1502993, 39.2060902],
              [45.1495258, 39.2073141],
              [45.1493611, 39.2092421],
              [45.1494355, 39.2129614],
              [45.1499231, 39.2163997],
              [45.1499504, 39.2204266],
              [45.1480671, 39.229162],
              [45.1482903, 39.2320253],
              [45.150881, 39.235741],
              [45.1522099, 39.2399774],
              [45.1520381, 39.2415099],
              [45.151415, 39.2431485],
              [45.148376, 39.2462569],
              [45.1468968, 39.2492289],
              [45.1462174, 39.2538683],
              [45.1478079, 39.257603],
              [45.1486946, 39.2610799],
              [45.148409, 39.2634873],
              [45.1476423, 39.2643321],
              [45.1369904, 39.2680059],
              [45.1358209, 39.2692529],
              [45.1346898, 39.2713856],
              [45.1345036, 39.2720432],
              [45.1347433, 39.2727632],
              [45.1359418, 39.274113],
              [45.1402596, 39.2768268],
              [45.1419404, 39.2788438],
              [45.142576, 39.2825384],
              [45.1419814, 39.2844706],
              [45.1410211, 39.2858877],
              [45.1389025, 39.2870836],
              [45.1309438, 39.2891605],
              [45.1266727, 39.2882763],
              [45.1220074, 39.2868347],
              [45.1206625, 39.2855806],
              [45.1189959, 39.2861254],
              [45.1178194, 39.2868354],
              [45.1175493, 39.2874466],
              [45.1179509, 39.2886626],
              [45.1190056, 39.2895772],
              [45.1245888, 39.2914802],
              [45.1270715, 39.2930516],
              [45.1288319, 39.2946993],
              [45.1293869, 39.2963332],
              [45.1286003, 39.3012738],
              [45.1273271, 39.3035959],
              [45.1267726, 39.3041421],
              [45.1260393, 39.3045072],
              [45.1196051, 39.3058263],
              [45.1087317, 39.3092312],
              [45.1078768, 39.3102651],
              [45.1073818, 39.311527],
              [45.1070452, 39.3155736],
              [45.1067541, 39.3166533],
              [45.10332, 39.3221804],
              [45.104092, 39.3268721],
              [45.103536, 39.3291159],
              [45.1021273, 39.3326582],
              [45.1013315, 39.3333181],
              [45.1002158, 39.333693],
              [45.0980664, 39.3332672],
              [45.0922162, 39.3305683],
              [45.0896154, 39.3288583],
              [45.0887372, 39.3287403],
              [45.0876976, 39.3288577],
              [45.0862784, 39.3292142],
              [45.0851717, 39.3296664],
              [45.0803208, 39.3335707],
              [45.080014, 39.3348005],
              [45.0812725, 39.3367812],
              [45.0855059, 39.3420762],
              [45.0863316, 39.3438036],
              [45.0870302, 39.3473822],
              [45.0867037, 39.3512472],
              [45.0830432, 39.3544971],
              [45.0792117, 39.3564479],
              [45.0764062, 39.3584772],
              [45.0733874, 39.3598961],
              [45.0701556, 39.3605462],
              [45.0681453, 39.3605707],
              [45.0620956, 39.3622907],
              [45.0571425, 39.364346],
              [45.0566199, 39.3651543],
              [45.0566314, 39.3660599],
              [45.0577276, 39.3697118],
              [45.0576315, 39.3715865],
              [45.0588906, 39.379951],
              [45.0581208, 39.3812002],
              [45.0563447, 39.3821398],
              [45.0544989, 39.3823687],
              [45.0524401, 39.3821679],
              [45.0492161, 39.3802806],
              [45.0467794, 39.3795631],
              [45.0459142, 39.3795297],
              [45.045259, 39.3796865],
              [45.04275, 39.3822168],
              [45.0419998, 39.3849729],
              [45.0416875, 39.3861149],
              [45.0414201, 39.3881673],
              [45.0415972, 39.3901113],
              [45.0412333, 39.3910499],
              [45.0406809, 39.3912907],
              [45.0400375, 39.3912143],
              [45.0367839, 39.3903329],
              [45.0350804, 39.3905373],
              [45.033612, 39.3910222],
              [45.0294411, 39.3942767],
              [45.0267108, 39.3973923],
              [45.0241204, 39.3987462],
              [45.0220252, 39.4005384],
              [45.0212464, 39.402183],
              [45.0205446, 39.4032346],
              [45.0195747, 39.4042517],
              [45.0181831, 39.4048917],
              [45.0171168, 39.4057326],
              [45.010569, 39.4044919],
              [45.0097002, 39.4047211],
              [45.0090083, 39.4054406],
              [45.0081162, 39.4066349],
              [45.0075211, 39.4087862],
              [45.0065811, 39.4099323],
              [45.0058494, 39.4103658],
              [45.005198, 39.4104253],
              [45.0024228, 39.4097039],
              [44.99956, 39.4086705],
              [44.9981639, 39.4090545],
              [44.9969354, 39.4097642],
              [44.9959467, 39.4128968],
              [44.9885707, 39.4153007],
              [44.9851965, 39.4168493],
              [44.9830971, 39.4185211],
              [44.9706206, 39.4195778],
              [44.966279, 39.4205157],
              [44.9651438, 39.4210425],
              [44.9645597, 39.421841],
              [44.9637775, 39.4237607],
              [44.9642264, 39.4260323],
              [44.9656209, 39.429032],
              [44.9652704, 39.4322654],
              [44.9619803, 39.4360202],
              [44.9600851, 39.4395834],
              [44.9608079, 39.4421583],
              [44.9620063, 39.4427289],
              [44.9648066, 39.442277],
              [44.9667014, 39.4423001],
              [44.9694826, 39.4437195],
              [44.9736216, 39.4444942],
              [44.9768556, 39.4468659],
              [44.9771798, 39.4487743],
              [44.97645, 39.4500713],
              [44.9756505, 39.4507241],
              [44.9747128, 39.4510923],
              [44.9700168, 39.4515917],
              [44.9610917, 39.4506017],
              [44.9508689, 39.4522111],
              [44.9482411, 39.4516666],
              [44.947164, 39.4516525],
              [44.9466634, 39.4520852],
              [44.9465007, 39.4560927],
              [44.9457195, 39.4572425],
              [44.9423852, 39.4581819],
              [44.9399284, 39.459659],
              [44.93943, 39.4609501],
              [44.9398938, 39.462458],
              [44.9422981, 39.4643224],
              [44.9430179, 39.4657772],
              [44.9438052, 39.4672187],
              [44.9446009, 39.4679127],
              [44.9475002, 39.469735],
              [44.9484734, 39.4715422],
              [44.9477582, 39.4727013],
              [44.9438516, 39.4738787],
              [44.9386333, 39.4773109],
              [44.9368034, 39.4798184],
              [44.9369091, 39.4807141],
              [44.9382528, 39.4816477],
              [44.9424811, 39.4812672],
              [44.9449643, 39.4818972],
              [44.9471586, 39.4817492],
              [44.9493402, 39.4824819],
              [44.9502924, 39.4833062],
              [44.9508425, 39.4840928],
              [44.9503456, 39.4848242],
              [44.948938, 39.4851822],
              [44.945875, 39.4843047],
              [44.9427063, 39.483749],
              [44.9409906, 39.4841874],
              [44.9383999, 39.4862826],
              [44.9378437, 39.4874847],
              [44.9384172, 39.4886931],
              [44.940054, 39.4896523],
              [44.9430497, 39.4894469],
              [44.9466623, 39.4877763],
              [44.9496831, 39.4879646],
              [44.9514032, 39.489126],
              [44.951985, 39.4908229],
              [44.9518498, 39.4921687],
              [44.9473649, 39.4975582],
              [44.9406013, 39.502379],
              [44.9393255, 39.504389],
              [44.9385323, 39.5094695],
              [44.9365256, 39.5119345],
              [44.9353655, 39.5121697],
              [44.9342607, 39.5110611],
              [44.9321974, 39.5112316],
              [44.9294807, 39.5118676],
              [44.927262, 39.5130524],
              [44.9259744, 39.5146754],
              [44.9236034, 39.5161217],
              [44.9181521, 39.5177937],
              [44.9162606, 39.5192413],
              [44.9147683, 39.5206847],
              [44.9126451, 39.5224378],
              [44.9097716, 39.5250712],
              [44.9091986, 39.5280743],
              [44.9149769, 39.529961],
              [44.917158, 39.5311971],
              [44.9185951, 39.5332089],
              [44.9181024, 39.534502],
              [44.9129285, 39.5371574],
              [44.9068803, 39.5386501],
              [44.9065841, 39.5395316],
              [44.9102146, 39.5452039],
              [44.9103357, 39.5468422],
              [44.9112731, 39.5487564],
              [44.908342, 39.5561385],
              [44.9086367, 39.5599898],
              [44.9107743, 39.5619948],
              [44.9129652, 39.5636627],
              [44.91544, 39.565095],
              [44.9157487, 39.5659961],
              [44.9151449, 39.567184],
              [44.9110488, 39.5689584],
              [44.9092891, 39.5708872],
              [44.9057982, 39.5756271],
              [44.9035856, 39.576759],
              [44.8901074, 39.5795194],
              [44.8883296, 39.5817248],
              [44.8880634, 39.5838121],
              [44.8919728, 39.5888056],
              [44.8987787, 39.5955845],
              [44.8997677, 39.59858],
              [44.9002116, 39.6010832],
              [44.8989316, 39.6032151],
              [44.8972058, 39.6052331],
              [44.8954283, 39.6057307],
              [44.8935468, 39.6047696],
              [44.8919764, 39.6019845],
              [44.8928059, 39.5997733],
              [44.8925726, 39.5977431],
              [44.8909207, 39.5961022],
              [44.8760247, 39.5930064],
              [44.8730953, 39.5939691],
              [44.8729454, 39.5965373],
              [44.8731048, 39.5995362],
              [44.8735218, 39.6007009],
              [44.8808237, 39.6072004],
              [44.8810919, 39.6083603],
              [44.8808613, 39.6099619],
              [44.8755201, 39.6152092],
              [44.8726179, 39.6156237],
              [44.8689052, 39.6150926],
              [44.8666004, 39.6130026],
              [44.8666847, 39.6070353],
              [44.8660356, 39.6050162],
              [44.8645363, 39.6035648],
              [44.8612371, 39.602742],
              [44.8558229, 39.6022547],
              [44.8534277, 39.6028074],
              [44.8406864, 39.6110638],
              [44.8373938, 39.6122701],
              [44.8271203, 39.6106534],
              [44.8244366, 39.6107741],
              [44.8219144, 39.6112697],
              [44.8191344, 39.6134193],
              [44.816239, 39.6151265],
              [44.8120838, 39.6197166],
              [44.8098565, 39.6244252],
              [44.8093804, 39.627336],
              [44.8087677, 39.6277727],
              [44.8081264, 39.6282297],
              [44.807226, 39.628764],
              [44.80706, 39.628865],
              [44.8064776, 39.6291172],
              [44.8060172, 39.6293233],
              [44.8052235, 39.6296027],
              [44.8049608, 39.6296309],
              [44.8046981, 39.6295888],
              [44.8044856, 39.6300241],
              [44.8044214, 39.6305082],
              [44.804304, 39.630857],
              [44.8041029, 39.6312109],
              [44.8039388, 39.6317345],
              [44.803894, 39.632151],
              [44.8032842, 39.6324758],
              [44.8030875, 39.6328746],
              [44.8031025, 39.6331702],
              [44.8032921, 39.6334659],
              [44.803546, 39.633724],
              [44.8036366, 39.6343007],
              [44.8035218, 39.634889],
              [44.8035897, 39.6354978],
              [44.803582, 39.636317],
              [44.8034947, 39.6372066],
              [44.8034681, 39.6380502],
              [44.8031725, 39.63855],
              [44.8032301, 39.6390362],
              [44.8032251, 39.6394068],
              [44.803439, 39.640205],
              [44.803434, 39.640586],
              [44.803329, 39.641145],
              [44.8033663, 39.641654],
              [44.8033963, 39.6419913],
              [44.8033121, 39.642378],
              [44.8030615, 39.6426067],
              [44.8026532, 39.6427306],
              [44.802387, 39.642893],
              [44.802252, 39.643146],
              [44.802211, 39.643858],
              [44.801845, 39.644135],
              [44.801417, 39.644133],
              [44.801087, 39.644207],
              [44.801084, 39.644487],
              [44.800883, 39.644765],
              [44.800419, 39.645016],
              [44.799782, 39.645928],
              [44.799417, 39.64618],
              [44.799314, 39.64656],
              [44.799077, 39.647118],
              [44.798876, 39.647422],
              [44.798638, 39.648081],
              [44.79853, 39.648869],
              [44.798231, 39.64907],
              [44.79737, 39.649446],
              [44.796611, 39.649594],
              [44.796115, 39.649769],
              [44.795455, 39.649867],
              [44.794759, 39.650218],
              [44.793836, 39.650264],
              [44.792713, 39.650511],
              [44.792318, 39.650458],
              [44.791857, 39.650455],
              [44.789578, 39.651026],
              [44.789016, 39.651124],
              [44.7876, 39.651141],
              [44.787398, 39.65147],
              [44.7874094, 39.652229],
              [44.7878169, 39.6531512],
              [44.7876144, 39.6534352],
              [44.7872908, 39.6533633],
              [44.786992, 39.6531689],
              [44.7866967, 39.6533374],
              [44.7867399, 39.6537636],
              [44.7868689, 39.6542447],
              [44.7867588, 39.6547429],
              [44.786471, 39.6550697],
              [44.7862353, 39.6551171],
              [44.7853691, 39.6548068],
              [44.7846851, 39.6546637],
              [44.7842272, 39.6548134],
              [44.7832478, 39.6556355],
              [44.7829346, 39.6564182],
              [44.7824856, 39.6567257],
              [44.7801081, 39.6574543],
              [44.778467, 39.6595745],
              [44.7750854, 39.6609508],
              [44.7744862, 39.6608975],
              [44.773895, 39.6605374],
              [44.7703478, 39.6610364],
              [44.770116, 39.6610875],
              [44.7696293, 39.6617204],
              [44.7695374, 39.6618974],
              [44.7698865, 39.6621588],
              [44.770109, 39.6625122],
              [44.7700609, 39.6635501],
              [44.7691451, 39.6646131],
              [44.7678816, 39.6653928],
              [44.7673293, 39.6654269],
              [44.7646446, 39.6651088],
              [44.7640251, 39.6652985],
              [44.7625019, 39.6661279],
              [44.7606275, 39.6678905],
              [44.760677, 39.6684059],
              [44.762075, 39.6692315],
              [44.7616097, 39.6700839],
              [44.7615364, 39.6705152],
              [44.7611119, 39.6706339],
              [44.7604236, 39.6704944],
              [44.7595847, 39.6704252],
              [44.7587891, 39.670018],
              [44.7579519, 39.6699795],
              [44.756858, 39.6704123],
              [44.7563126, 39.6705325],
              [44.7555072, 39.6707099],
              [44.7548046, 39.6707841],
              [44.7545221, 39.6711065],
              [44.7548071, 39.6715764],
              [44.7544682, 39.672053],
              [44.7543943, 39.6723901],
              [44.7540827, 39.6727111],
              [44.7544025, 39.6730539],
              [44.754792, 39.6730304],
              [44.7557634, 39.6723373],
              [44.7561052, 39.6719227],
              [44.7568527, 39.6715102],
              [44.7573267, 39.6715112],
              [44.7578944, 39.6716591],
              [44.7580451, 39.6719226],
              [44.7580604, 39.6723763],
              [44.7583866, 39.6727796],
              [44.7585128, 39.6731646],
              [44.7588286, 39.6734767],
              [44.7586182, 39.6740337],
              [44.7585013, 39.6747692],
              [44.7587451, 39.6753964],
              [44.7585657, 39.6758949],
              [44.7581758, 39.6766439],
              [44.7578052, 39.6768953],
              [44.7571404, 39.6771063],
              [44.7564169, 39.6771533],
              [44.7558576, 39.6774057],
              [44.7554, 39.6774319],
              [44.7550827, 39.677768],
              [44.7546821, 39.6779392],
              [44.7541529, 39.6784015],
              [44.7541086, 39.6789192],
              [44.7542205, 39.679166],
              [44.7535948, 39.6801445],
              [44.7537031, 39.681736],
              [44.7531686, 39.6820352],
              [44.752818, 39.6820823],
              [44.7524137, 39.6824209],
              [44.7518857, 39.6828632],
              [44.7517298, 39.6831336],
              [44.751849, 39.6836272],
              [44.7515854, 39.6838985],
              [44.7515391, 39.6842284],
              [44.7513013, 39.6844372],
              [44.7513163, 39.6850739],
              [44.7509489, 39.6855321],
              [44.7499374, 39.6862714],
              [44.7500782, 39.6867283],
              [44.7498632, 39.686988],
              [44.7495165, 39.6872204],
              [44.7492007, 39.6875963],
              [44.7487221, 39.687891],
              [44.7483196, 39.6879576],
              [44.7479746, 39.6882307],
              [44.7475442, 39.6882355],
              [44.7469815, 39.6883451],
              [44.7458672, 39.689102],
              [44.7449024, 39.6892571],
              [44.7439447, 39.6899503],
              [44.7438174, 39.6904073],
              [44.7433932, 39.6908473],
              [44.7432118, 39.6911801],
              [44.7428971, 39.6915763],
              [44.7428522, 39.691969],
              [44.7426432, 39.6922603],
              [44.742734, 39.692692],
              [44.7426599, 39.6929812],
              [44.7419713, 39.693484],
              [44.741841, 39.6937338],
              [44.7414067, 39.6936967],
              [44.7411298, 39.6938077],
              [44.740531, 39.6937821],
              [44.7404865, 39.6934877],
              [44.7395274, 39.6932305],
              [44.7390969, 39.6933403],
              [44.7385976, 39.6931468],
              [44.7381264, 39.6931233],
              [44.7374675, 39.6934246],
              [44.7371603, 39.6933048],
              [44.7366956, 39.6935138],
              [44.7364716, 39.693455],
              [44.7360905, 39.6935679],
              [44.7358297, 39.6935702],
              [44.7353524, 39.6937906],
              [44.7342854, 39.6938319],
              [44.7334314, 39.69454],
              [44.7333563, 39.6948199],
              [44.7329639, 39.695366],
              [44.7322023, 39.6966748],
              [44.7315834, 39.6973069],
              [44.7306873, 39.6980158],
              [44.7305915, 39.698233],
              [44.7300732, 39.698438],
              [44.7297871, 39.6982396],
              [44.7293678, 39.6983511],
              [44.7289932, 39.6986317],
              [44.7289176, 39.6988173],
              [44.7285987, 39.6988968],
              [44.7281028, 39.6992106],
              [44.7278565, 39.6992165],
              [44.7277347, 39.6993439],
              [44.7276969, 39.699531],
              [44.7273882, 39.6996802],
              [44.7271663, 39.7003595],
              [44.7273999, 39.7008052],
              [44.7277529, 39.700982],
              [44.7278145, 39.7015442],
              [44.7280247, 39.7016902],
              [44.728335, 39.702456],
              [44.7278993, 39.702879],
              [44.7277422, 39.7031293],
              [44.7275435, 39.7032864],
              [44.7269833, 39.7035411],
              [44.7268451, 39.7037134],
              [44.726645, 39.7037772],
              [44.7263672, 39.7039958],
              [44.726151, 39.7043078],
              [44.7257145, 39.7047458],
              [44.7256387, 39.7050265],
              [44.7251596, 39.7053269],
              [44.7244867, 39.7058768],
              [44.7241477, 39.7059729],
              [44.7239864, 39.705928],
              [44.7236307, 39.7062722],
              [44.723289, 39.7062912],
              [44.7227553, 39.7068231],
              [44.7226148, 39.70684],
              [44.722359, 39.7070898],
              [44.7221382, 39.7071231],
              [44.7219561, 39.707032],
              [44.7215769, 39.7072841],
              [44.7214377, 39.7074565],
              [44.7207539, 39.7075259],
              [44.7203726, 39.7077166],
              [44.7194569, 39.7076047],
              [44.7193002, 39.7077406],
              [44.7189236, 39.7079108],
              [44.7185641, 39.7080041],
              [44.718127, 39.7082996],
              [44.7179481, 39.7085525],
              [44.7175849, 39.7086827],
              [44.7173245, 39.7088739],
              [44.7172655, 39.7089841],
              [44.7170449, 39.7090962],
              [44.7169893, 39.7093932],
              [44.7167724, 39.7096914],
              [44.716755, 39.7098471],
              [44.7164344, 39.7099593],
              [44.71638, 39.7102858],
              [44.7162006, 39.7103962],
              [44.7161258, 39.7107069],
              [44.7158661, 39.7108181],
              [44.7157906, 39.711082],
              [44.7155323, 39.7112549],
              [44.7154939, 39.711348],
              [44.7152946, 39.7114429],
              [44.7151584, 39.7116761],
              [44.7149206, 39.7118484],
              [44.7148842, 39.712034],
              [44.7151479, 39.7121704],
              [44.7150726, 39.7124494],
              [44.715096, 39.7126347],
              [44.714957, 39.7127131],
              [44.7147767, 39.7127144],
              [44.7146787, 39.7128388],
              [44.7145446, 39.7132585],
              [44.7147273, 39.7134281],
              [44.7147757, 39.7139554],
              [44.7149787, 39.7140616],
              [44.7150829, 39.7142776],
              [44.71454, 39.7142989],
              [44.7136417, 39.7146],
              [44.7135003, 39.7144917],
              [44.7132197, 39.7144465],
              [44.7130815, 39.714587],
              [44.7124167, 39.7145957],
              [44.712074, 39.7143492],
              [44.7120333, 39.7142091],
              [44.7118101, 39.7140724],
              [44.7112434, 39.7139874],
              [44.7110392, 39.7138977],
              [44.7112678, 39.7137845],
              [44.7112402, 39.7133367],
              [44.710646, 39.7133903],
              [44.7106283, 39.7135143],
              [44.7107123, 39.7137762],
              [44.7106554, 39.7139316],
              [44.7105371, 39.7139795],
              [44.7103578, 39.7139509],
              [44.7103535, 39.7137034],
              [44.7102716, 39.7135651],
              [44.7100065, 39.7134901],
              [44.7096763, 39.71323],
              [44.7094327, 39.7132476],
              [44.7090454, 39.7134048],
              [44.7087393, 39.7132378],
              [44.7086193, 39.7132853],
              [44.7086208, 39.7134856],
              [44.7084405, 39.7135182],
              [44.7082575, 39.713212],
              [44.7080584, 39.713399],
              [44.7078999, 39.7133703],
              [44.7078155, 39.7131549],
              [44.7074997, 39.7131591],
              [44.7073769, 39.7130984],
              [44.7071955, 39.7131309],
              [44.7070582, 39.7133023],
              [44.7068505, 39.7130876],
              [44.7067289, 39.7130733],
              [44.7064484, 39.7131685],
              [44.7062861, 39.7131391],
              [44.7061632, 39.713063],
              [44.7061804, 39.7129393],
              [44.7051973, 39.7125646],
              [44.7049197, 39.7125988],
              [44.7046045, 39.7128344],
              [44.704251, 39.7124662],
              [44.7038432, 39.7122696],
              [44.7034787, 39.7119494],
              [44.7031813, 39.7120913],
              [44.7030609, 39.7120461],
              [44.7028926, 39.711584],
              [44.7030848, 39.7111813],
              [44.7032649, 39.7111329],
              [44.7036077, 39.7112377],
              [44.7039277, 39.7112348],
              [44.704045, 39.7110794],
              [44.7038634, 39.7109884],
              [44.7036036, 39.7110061],
              [44.7034405, 39.7108376],
              [44.7036759, 39.7105577],
              [44.7036334, 39.7104191],
              [44.7033531, 39.7104213],
              [44.7032085, 39.710207],
              [44.7029862, 39.7101482],
              [44.7028683, 39.7103041],
              [44.7022622, 39.7100961],
              [44.7016027, 39.7102109],
              [44.7013266, 39.71049],
              [44.7008668, 39.7106169],
              [44.700709, 39.7108486],
              [44.7004882, 39.7109271],
              [44.6998234, 39.710918],
              [44.6991494, 39.7111751],
              [44.6989722, 39.7113317],
              [44.6983725, 39.7115076],
              [44.6978986, 39.7121921],
              [44.6977388, 39.7122865],
              [44.6969362, 39.7122483],
              [44.6966384, 39.7124214],
              [44.6964177, 39.7126248],
              [44.6957652, 39.7125701],
              [44.6955155, 39.7127749],
              [44.695371, 39.7128077],
              [44.6948692, 39.7125953],
              [44.6944788, 39.7126111],
              [44.6941604, 39.7128313],
              [44.6936381, 39.7130705],
              [44.693501, 39.7133507],
              [44.6933423, 39.7135069],
              [44.6919574, 39.7134751],
              [44.6917401, 39.7136624],
              [44.6905753, 39.7136434],
              [44.6901904, 39.7135082],
              [44.6901858, 39.7133533],
              [44.6904015, 39.7131649],
              [44.690298, 39.7129342],
              [44.6897902, 39.7129222],
              [44.6891847, 39.7132871],
              [44.6889682, 39.7133208],
              [44.6887246, 39.7131382],
              [44.6885267, 39.7131868],
              [44.6882851, 39.7133275],
              [44.688212, 39.7139763],
              [44.6894485, 39.7154889],
              [44.6901929, 39.7157599],
              [44.6908046, 39.716355],
              [44.6906158, 39.7170356],
              [44.6907189, 39.7172044],
              [44.6907214, 39.7173589],
              [44.6902388, 39.7173187],
              [44.6892609, 39.7176223],
              [44.6890592, 39.7174841],
              [44.6887795, 39.7174545],
              [44.6884567, 39.7172093],
              [44.6875125, 39.7168158],
              [44.687172, 39.7167728],
              [44.6866112, 39.7162134],
              [44.6863072, 39.7160936],
              [44.6862706, 39.71586],
              [44.6858069, 39.7155715],
              [44.6854806, 39.7155609],
              [44.6853173, 39.715393],
              [44.6847723, 39.7151673],
              [44.6844923, 39.715201],
              [44.6840101, 39.7151288],
              [44.6835092, 39.7151339],
              [44.6828661, 39.7150325],
              [44.6824264, 39.7148207],
              [44.681433, 39.7151961],
              [44.6810112, 39.7152141],
              [44.679708, 39.715089],
              [44.6791593, 39.7146466],
              [44.6785349, 39.7144067],
              [44.6780936, 39.7143492],
              [44.6777748, 39.71443],
              [44.677519, 39.7146955],
              [44.6773267, 39.7151762],
              [44.6769492, 39.715333],
              [44.6766079, 39.7152265],
              [44.6764028, 39.7148566],
              [44.6760603, 39.7146117],
              [44.6754782, 39.7145738],
              [44.6748972, 39.7147528],
              [44.6745345, 39.7146803],
              [44.6738098, 39.7148151],
              [44.6736082, 39.714693],
              [44.6735658, 39.7143988],
              [44.6734242, 39.7142921],
              [44.6732032, 39.7142947],
              [44.6725708, 39.7146231],
              [44.6717319, 39.7149257],
              [44.6714361, 39.7148799],
              [44.6711324, 39.7143264],
              [44.6705273, 39.7146522],
              [44.6688547, 39.7144106],
              [44.6684425, 39.7144881],
              [44.6679478, 39.7148007],
              [44.6673928, 39.7149102],
              [44.6673159, 39.7150486],
              [44.6672443, 39.7157302],
              [44.6669112, 39.7161178],
              [44.6666006, 39.7166594],
              [44.6663631, 39.7168001],
              [44.6656619, 39.7167448],
              [44.6652844, 39.7169178],
              [44.6646983, 39.7178023],
              [44.6644201, 39.7179282],
              [44.6636391, 39.7179668],
              [44.6632164, 39.7177404],
              [44.6629782, 39.7177432],
              [44.662506, 39.718071],
              [44.6622492, 39.7181504],
              [44.6617489, 39.71814],
              [44.6612937, 39.7185134],
              [44.6611201, 39.7188377],
              [44.6612273, 39.7191434],
              [44.6611512, 39.7193283],
              [44.6608764, 39.7196074],
              [44.6608992, 39.719807],
              [44.6613834, 39.7202334],
              [44.6614665, 39.7204947],
              [44.6613297, 39.7207583],
              [44.6608737, 39.7212741],
              [44.6605741, 39.7213546],
              [44.6601307, 39.7212832],
              [44.6596496, 39.7213505],
              [44.6594469, 39.7212761],
              [44.6592684, 39.7213702],
              [44.6593165, 39.7217541],
              [44.6591404, 39.7219556],
              [44.6587445, 39.7221746],
              [44.6585906, 39.7224679],
              [44.6580971, 39.7227951],
              [44.6579087, 39.7233339],
              [44.6575601, 39.7238585],
              [44.6570118, 39.7243847],
              [44.6569395, 39.7247222],
              [44.6561664, 39.7252937],
              [44.6554432, 39.7253323],
              [44.6551853, 39.725473],
              [44.6550518, 39.7257195],
              [44.6549246, 39.7262269],
              [44.6544556, 39.7266155],
              [44.6541184, 39.7266805],
              [44.6539674, 39.7269286],
              [44.6537709, 39.7270845],
              [44.6533112, 39.7272422],
              [44.6525808, 39.7276503],
              [44.6523617, 39.7276987],
              [44.6521542, 39.7272546],
              [44.6519744, 39.7272717],
              [44.6514373, 39.7274463],
              [44.6502563, 39.7274263],
              [44.6499997, 39.7276137],
              [44.6497454, 39.7279552],
              [44.6494273, 39.7280655],
              [44.6489463, 39.7279611],
              [44.6485398, 39.7275033],
              [44.6481986, 39.7273525],
              [44.6478404, 39.7273554],
              [44.6476247, 39.7275413],
              [44.6478356, 39.7283231],
              [44.6477191, 39.7285395],
              [44.6474434, 39.7286633],
              [44.6470066, 39.7286346],
              [44.6462444, 39.7288011],
              [44.6461788, 39.7289266],
              [44.6463858, 39.7290491],
              [44.6467655, 39.7291837],
              [44.646817, 39.7294154],
              [44.646649, 39.7296347],
              [44.6467343, 39.7299392],
              [44.6467301, 39.7304639],
              [44.6465632, 39.7309677],
              [44.645802, 39.7319426],
              [44.64573, 39.7323849],
              [44.6454123, 39.7324859],
              [44.6452713, 39.7326588],
              [44.6451447, 39.7327334],
              [44.6444712, 39.7326962],
              [44.6441051, 39.7327499],
              [44.6438848, 39.7328989],
              [44.6435163, 39.7327435],
              [44.6429982, 39.7331646],
              [44.6426849, 39.7335622],
              [44.6421469, 39.7338543],
              [44.6419289, 39.7340875],
              [44.6420142, 39.7343771],
              [44.6426362, 39.73448],
              [44.6429929, 39.7347801],
              [44.6430215, 39.7355136],
              [44.6427245, 39.73581],
              [44.6425867, 39.7361172],
              [44.6417165, 39.7363948],
              [44.641179, 39.7366697],
              [44.6410114, 39.7371367],
              [44.641112, 39.7374415],
              [44.6410403, 39.7379192],
              [44.6414923, 39.7383063],
              [44.6409328, 39.7391051],
              [44.6405394, 39.7393405],
              [44.64026, 39.7397596],
              [44.6396354, 39.7403613],
              [44.6394338, 39.7407073],
              [44.6389453, 39.741007],
              [44.638566, 39.7407935],
              [44.638108, 39.7408703],
              [44.637778, 39.7411811],
              [44.6376396, 39.741451],
              [44.6374662, 39.7416008],
              [44.6369943, 39.7412953],
              [44.6367374, 39.7413877],
              [44.6365458, 39.7415398],
              [44.6361232, 39.7414776],
              [44.6358573, 39.7415998],
              [44.6354908, 39.7421257],
              [44.6353991, 39.7425191],
              [44.6350281, 39.7429248],
              [44.6350111, 39.7433019],
              [44.6345535, 39.7434652],
              [44.6330688, 39.7433448],
              [44.6328774, 39.7433961],
              [44.6325605, 39.7436328],
              [44.6323916, 39.7442107],
              [44.6321398, 39.7443721],
              [44.6316158, 39.7444506],
              [44.6314714, 39.744391],
              [44.6314521, 39.7441464],
              [44.6312754, 39.7440504],
              [44.6307025, 39.7440934],
              [44.6304987, 39.7442788],
              [44.6305693, 39.7447299],
              [44.6308771, 39.7450688],
              [44.6308829, 39.7454229],
              [44.6301938, 39.7460157],
              [44.6296892, 39.7462409],
              [44.6292814, 39.7466013],
              [44.6291262, 39.7468868],
              [44.6292084, 39.7470848],
              [44.6297061, 39.7472866],
              [44.6298206, 39.7474678],
              [44.6298262, 39.7478086],
              [44.6301189, 39.7482167],
              [44.6301542, 39.7484454],
              [44.6300151, 39.7486785],
              [44.6300972, 39.7488376],
              [44.6305786, 39.749116],
              [44.6309686, 39.7494548],
              [44.630924, 39.749651],
              [44.6306236, 39.7498442],
              [44.6305418, 39.7500772],
              [44.6307839, 39.7503062],
              [44.6313412, 39.7503324],
              [44.6315434, 39.7509911],
              [44.6315159, 39.7512615],
              [44.6317282, 39.7515537],
              [44.6316522, 39.7518013],
              [44.6313365, 39.7519658],
              [44.63118, 39.7521142],
              [44.6311367, 39.7523955],
              [44.6312373, 39.7527124],
              [44.6315269, 39.7529053],
              [44.632409, 39.7533128],
              [44.6325399, 39.7535317],
              [44.6325766, 39.7539095],
              [44.6324239, 39.7552903],
              [44.6324344, 39.7558674],
              [44.6322932, 39.7560367],
              [44.6319917, 39.7561072],
              [44.6310834, 39.7558898],
              [44.6304454, 39.7558523],
              [44.6300177, 39.7559789],
              [44.629639, 39.7562287],
              [44.6295789, 39.7563992],
              [44.6296622, 39.7566185],
              [44.6300803, 39.7568837],
              [44.6307637, 39.7577544],
              [44.6308836, 39.7581871],
              [44.630849, 39.7585192],
              [44.6303548, 39.7589161],
              [44.6297732, 39.759101],
              [44.629225, 39.7591011],
              [44.628592, 39.7589745],
              [44.6281292, 39.7588189],
              [44.6278369, 39.7586389],
              [44.6274116, 39.7586034],
              [44.6272229, 39.7587151],
              [44.6271618, 39.7588505],
              [44.6272116, 39.7590223],
              [44.6275053, 39.7592767],
              [44.627555, 39.7594608],
              [44.6274254, 39.7596225],
              [44.6269086, 39.7598374],
              [44.6266217, 39.759877],
              [44.6262748, 39.7600635],
              [44.6259179, 39.760555],
              [44.6259396, 39.7608238],
              [44.6260857, 39.761042],
              [44.626533, 39.7612933],
              [44.6266795, 39.7614511],
              [44.6267314, 39.7617432],
              [44.6266701, 39.7619865],
              [44.6263857, 39.762206],
              [44.6259477, 39.7623132],
              [44.6253363, 39.7625132],
              [44.6250325, 39.7628241],
              [44.6243359, 39.7633153],
              [44.6240566, 39.7636218],
              [44.6239688, 39.764834],
              [44.6238136, 39.7651651],
              [44.6235754, 39.7655507],
              [44.623128, 39.7660133],
              [44.6229045, 39.7660656],
              [44.6218899, 39.7660495],
              [44.6216702, 39.7661607],
              [44.6216185, 39.7666352],
              [44.621611, 39.767001],
              [44.6216324, 39.768714],
              [44.6207671, 39.7710847],
              [44.6203215, 39.7721691],
              [44.6199361, 39.7728824],
              [44.6195401, 39.7745115],
              [44.6183103, 39.7758958],
              [44.6179085, 39.7763933],
              [44.6176033, 39.7772965],
              [44.6164358, 39.7794687],
              [44.6157975, 39.7802061],
              [44.6154058, 39.7805716],
              [44.6156085, 39.7810458],
              [44.6155444, 39.781825],
              [44.6151065, 39.7821587],
              [44.614695, 39.7824624],
              [44.6142661, 39.7821524],
              [44.6137719, 39.7819568],
              [44.6133379, 39.7816502],
              [44.6117858, 39.7808031],
              [44.6093367, 39.7790538],
              [44.6019546, 39.7742035],
              [44.591394, 39.7670915],
              [44.5850062, 39.7655254],
              [44.5842559, 39.7639334],
              [44.5811353, 39.7621147],
              [44.5768476, 39.7575],
              [44.5657783, 39.7503595],
              [44.550833, 39.7395887],
              [44.5306499, 39.7258495],
              [44.5198374, 39.7191695],
              [44.5143069, 39.7156554],
              [44.4933296, 39.7018495],
              [44.4855258, 39.6946937],
              [44.4671974, 39.6841019],
              [44.4686771, 39.6823601],
              [44.4690995, 39.6818944],
              [44.4697035, 39.6815796],
              [44.4701248, 39.68115],
              [44.4717751, 39.6806598],
              [44.4726076, 39.6801849],
              [44.4728261, 39.6799214],
              [44.4731914, 39.6797715],
              [44.4735947, 39.6794335],
              [44.4744315, 39.6782942],
              [44.4748896, 39.6769076],
              [44.4748029, 39.6763211],
              [44.4753546, 39.6756125],
              [44.4754925, 39.6747302],
              [44.475765, 39.6741418],
              [44.4766053, 39.6736169],
              [44.4771168, 39.6726956],
              [44.4816613, 39.6714235],
              [44.4822345, 39.6707317],
              [44.4823908, 39.6699882],
              [44.4825615, 39.6686155],
              [44.4823234, 39.6680377],
              [44.4823507, 39.6675177],
              [44.4823957, 39.6671924],
              [44.4825098, 39.666986],
              [44.4828986, 39.6664269],
              [44.4830713, 39.6653842],
              [44.4831356, 39.6642042],
              [44.4830555, 39.6636997],
              [44.4833148, 39.6631727],
              [44.4834071, 39.6625401],
              [44.4834962, 39.6609843],
              [44.4836474, 39.6597056],
              [44.4837687, 39.6582667],
              [44.4838831, 39.6575206],
              [44.4839036, 39.6567261],
              [44.4836668, 39.6560286],
              [44.4836876, 39.6556746],
              [44.4838938, 39.6551593],
              [44.4838745, 39.6546204],
              [44.4838866, 39.6536394],
              [44.4836755, 39.6524601],
              [44.4837006, 39.6516801],
              [44.4838769, 39.6508738],
              [44.4840141, 39.6498267],
              [44.4846605, 39.6487957],
              [44.4849283, 39.6483304],
              [44.4849825, 39.6478299],
              [44.4849871, 39.6471987],
              [44.4850752, 39.6463145],
              [44.48528, 39.6461389],
              [44.4854914, 39.6458103],
              [44.485909, 39.645262],
              [44.4863848, 39.6446042],
              [44.4869352, 39.6440183],
              [44.4870541, 39.643894],
              [44.4871135, 39.6437168],
              [44.4870842, 39.6435108],
              [44.4869905, 39.6428619],
              [44.4867757, 39.6418749],
              [44.4865331, 39.6407679],
              [44.4864786, 39.6404677],
              [44.4865082, 39.6398222],
              [44.4862147, 39.6381673],
              [44.4860762, 39.6377639],
              [44.4859165, 39.6374642],
              [44.4857716, 39.637121],
              [44.4855099, 39.6361918],
              [44.4854151, 39.6356489],
              [44.4855771, 39.6349843],
              [44.485528, 39.6347135],
              [44.4853076, 39.6339558],
              [44.4850703, 39.632927],
              [44.4848757, 39.6319715],
              [44.4845317, 39.630775],
              [44.4842601, 39.6296316],
              [44.484549, 39.628242],
              [44.483656, 39.62478],
              [44.482632, 39.62132],
              [44.481596, 39.616686],
              [44.481117, 39.614956],
              [44.480148, 39.610424],
              [44.477627, 39.609012],
              [44.477224, 39.608249],
              [44.474504, 39.606634],
              [44.466464, 39.600665],
              [44.465403, 39.600059],
              [44.46487, 39.599502],
              [44.462333, 39.596356],
              [44.460799, 39.59458],
              [44.45953, 39.592854],
              [44.453325, 39.585344],
              [44.449991, 39.581489],
              [44.446855, 39.577632],
              [44.445458, 39.576314],
              [44.443066, 39.574339],
              [44.441672, 39.573276],
              [44.440214, 39.57252],
              [44.439224, 39.572372],
              [44.437972, 39.57243],
              [44.435925, 39.572034],
              [44.431694, 39.570732],
              [44.429183, 39.570134],
              [44.427861, 39.569733],
              [44.426074, 39.568876],
              [44.42442, 39.568223],
              [44.422106, 39.567573],
              [44.422694, 39.567009],
              [44.423546, 39.566392],
              [44.424136, 39.566032],
              [44.424394, 39.56547],
              [44.423658, 39.564301],
              [44.42093, 39.561461],
              [44.418939, 39.559993],
              [44.418073, 39.558979],
              [44.416204, 39.55644],
              [44.4163109, 39.5551168],
              [44.417966, 39.554493],
              [44.419672, 39.553668],
              [44.420518, 39.552491],
              [44.420707, 39.551572],
              [44.420836, 39.551265],
              [44.421621, 39.550649],
              [44.422408, 39.550186],
              [44.423257, 39.549417],
              [44.423782, 39.549108],
              [44.423646, 39.548701],
              [44.423312, 39.548193],
              [44.423635, 39.547528],
              [44.424421, 39.546963],
              [44.424746, 39.546452],
              [44.425853, 39.545069],
              [44.426242, 39.544404],
              [44.426562, 39.543383],
              [44.426615, 39.541955],
              [44.426276, 39.540886],
              [44.426136, 39.540071],
              [44.42633, 39.539662],
              [44.427046, 39.538639],
              [44.427107, 39.538129],
              [44.426381, 39.53798],
              [44.425322, 39.537527],
              [44.425375, 39.53615],
              [44.425227, 39.534315],
              [44.425217, 39.533296],
              [44.425076, 39.532328],
              [44.425667, 39.53207],
              [44.426062, 39.532017],
              [44.426587, 39.531861],
              [44.427177, 39.531501],
              [44.4294, 39.529704],
              [44.429525, 39.52899],
              [44.429581, 39.527868],
              [44.429707, 39.527255],
              [44.430938, 39.525056],
              [44.432178, 39.523775],
              [44.432829, 39.522955],
              [44.433813, 39.522542],
              [44.434994, 39.521975],
              [44.435451, 39.521564],
              [44.435906, 39.52095],
              [44.435568, 39.519983],
              [44.435563, 39.519473],
              [44.434963, 39.518763],
              [44.434565, 39.518408],
              [44.433439, 39.517752],
              [44.43284, 39.517041],
              [44.432766, 39.516277],
              [44.43282, 39.515002],
              [44.432805, 39.51332],
              [44.432722, 39.511485],
              [44.43278, 39.51072],
              [44.432906, 39.510107],
              [44.433358, 39.509085],
              [44.43461, 39.509129],
              [44.43553, 39.508971],
              [44.437504, 39.508756],
              [44.438423, 39.508394],
              [44.438941, 39.507525],
              [44.439657, 39.506552],
              [44.440367, 39.505069],
              [44.440099, 39.504561],
              [44.439166, 39.503445],
              [44.437974, 39.502687],
              [44.437639, 39.502128],
              [44.438359, 39.501614],
              [44.439737, 39.501147],
              [44.438742, 39.500337],
              [44.4385377, 39.4998862],
              [44.4358338, 39.4977231],
              [44.4338735, 39.4957628],
              [44.4334003, 39.4932618],
              [44.4329948, 39.4925182],
              [44.4292094, 39.4905579],
              [44.4271139, 39.488868],
              [44.4252212, 39.4880568],
              [44.4243424, 39.4880568],
              [44.420557, 39.4867725],
              [44.4187995, 39.4860965],
              [44.4175827, 39.4851502],
              [44.4166364, 39.4834602],
              [44.4158928, 39.4824463],
              [44.4152169, 39.480486],
              [44.4144057, 39.4790665],
              [44.4138649, 39.4779173],
              [44.413189, 39.4769034],
              [44.4126482, 39.4755514],
              [44.4119722, 39.4748755],
              [44.4102147, 39.4742671],
              [44.4088515, 39.4731494],
              [44.4084339, 39.4711492],
              [44.4101492, 39.470191],
              [44.4119608, 39.4690779],
              [44.4135659, 39.4686742],
              [44.4145305, 39.4677494],
              [44.4162571, 39.4670662],
              [44.4165099, 39.4668178],
              [44.4166358, 39.4665536],
              [44.4174639, 39.4665134],
              [44.4179649, 39.4662993],
              [44.4188621, 39.4655628],
              [44.4193973, 39.4655636],
              [44.4197347, 39.4653807],
              [44.4203218, 39.4648206],
              [44.4203568, 39.4642663],
              [44.4202877, 39.4638756],
              [44.4202958, 39.462911],
              [44.4203727, 39.4622861],
              [44.4207484, 39.4617226],
              [44.4211474, 39.4613086],
              [44.4212721, 39.4610456],
              [44.4216113, 39.4607987],
              [44.4218229, 39.460454],
              [44.4219045, 39.4600416],
              [44.4221959, 39.4597076],
              [44.4222298, 39.4593277],
              [44.4218209, 39.4591006],
              [44.4217445, 39.45833],
              [44.4219537, 39.4580987],
              [44.4221162, 39.4575063],
              [44.4220883, 39.4567632],
              [44.422863, 39.4556363],
              [44.4228156, 39.4553586],
              [44.4225979, 39.4551161],
              [44.4226137, 39.4547726],
              [44.4229095, 39.4544878],
              [44.4229924, 39.4542047],
              [44.4229247, 39.4538241],
              [44.4229647, 39.4535584],
              [44.424276, 39.4529387],
              [44.4245273, 39.4526644],
              [44.4247918, 39.4517011],
              [44.4245311, 39.451369],
              [44.4245709, 39.4511534],
              [44.4248479, 39.4511197],
              [44.4251021, 39.45097],
              [44.4251004, 39.450854],
              [44.4249052, 39.4506392],
              [44.4247679, 39.449948],
              [44.4242743, 39.4497063],
              [44.4241649, 39.4494931],
              [44.4241406, 39.4492293],
              [44.4244577, 39.4490626],
              [44.4245169, 39.4487162],
              [44.4244905, 39.4483373],
              [44.4246569, 39.4480057],
              [44.4251639, 39.4473297],
              [44.425057, 39.4467288],
              [44.425277, 39.4465956],
              [44.4253774, 39.446423],
              [44.4250838, 39.4462016],
              [44.4251668, 39.4460834],
              [44.4254721, 39.4459904],
              [44.4258634, 39.4458015],
              [44.4259796, 39.4455362],
              [44.4262861, 39.4454414],
              [44.4265763, 39.445412],
              [44.426852, 39.445581],
              [44.4270049, 39.4455264],
              [44.4271877, 39.4451808],
              [44.4273251, 39.4451351],
              [44.4276003, 39.445278],
              [44.4279154, 39.4452745],
              [44.4280142, 39.4452063],
              [44.4279816, 39.4449733],
              [44.4281241, 39.4448839],
              [44.4284528, 39.4449025],
              [44.4285645, 39.4448645],
              [44.4286332, 39.4447669],
              [44.4288068, 39.4447484],
              [44.429679, 39.4443467],
              [44.430146, 39.4443072],
              [44.4303043, 39.4442219],
              [44.4303121, 39.4440499],
              [44.4305588, 39.4436934],
              [44.430704, 39.4436242],
              [44.4308777, 39.4434168],
              [44.4313248, 39.4431449],
              [44.4320998, 39.4428202],
              [44.4323825, 39.4429127],
              [44.4326422, 39.442905],
              [44.4328142, 39.44282],
              [44.4328572, 39.4427251],
              [44.4324418, 39.4424998],
              [44.4323896, 39.442372],
              [44.4322731, 39.442295],
              [44.4319333, 39.4422475],
              [44.4318956, 39.4421308],
              [44.4319943, 39.4419572],
              [44.4319601, 39.4415618],
              [44.4320816, 39.4415057],
              [44.4322671, 39.4415005],
              [44.4324651, 39.4417039],
              [44.4325291, 39.4416927],
              [44.4325702, 39.4416208],
              [44.4324818, 39.4413041],
              [44.432552, 39.4412656],
              [44.43269, 39.4413467],
              [44.4327319, 39.4413025],
              [44.4326127, 39.441112],
              [44.4325331, 39.4410689],
              [44.4322902, 39.4410708],
              [44.4322815, 39.441],
              [44.432437, 39.4409279],
              [44.4324085, 39.4408943],
              [44.4323155, 39.4409122],
              [44.4323825, 39.4406931],
              [44.432326, 39.4406183],
              [44.4320311, 39.4404887],
              [44.4319661, 39.4404144],
              [44.4320156, 39.4401264],
              [44.4318449, 39.4398103],
              [44.4318414, 39.4395569],
              [44.4320789, 39.4394975],
              [44.4325437, 39.4396021],
              [44.4326058, 39.4395148],
              [44.4325829, 39.4394203],
              [44.4324519, 39.4393433],
              [44.432356, 39.439188],
              [44.4323769, 39.4391265],
              [44.4325143, 39.4390985],
              [44.4324763, 39.4388933],
              [44.4326424, 39.4387089],
              [44.4325834, 39.4386199],
              [44.4322618, 39.4384988],
              [44.4322611, 39.4384206],
              [44.4326384, 39.4381316],
              [44.432681, 39.4379734],
              [44.4323448, 39.4380386],
              [44.4322421, 39.4379833],
              [44.4324083, 39.4377728],
              [44.4326558, 39.4377257],
              [44.43272, 39.4376181],
              [44.4325078, 39.4375691],
              [44.4325203, 39.4373654],
              [44.4324761, 39.4373146],
              [44.432243, 39.4373847],
              [44.4322554, 39.4371571],
              [44.4324136, 39.4369639],
              [44.4324098, 39.4367691],
              [44.4323367, 39.4367408],
              [44.4320615, 39.4368027],
              [44.4319752, 39.4369334],
              [44.4319018, 39.4369268],
              [44.4318629, 39.4367664],
              [44.4316687, 39.4365579],
              [44.4316754, 39.4364971],
              [44.4315334, 39.4363177],
              [44.4315401, 39.4362517],
              [44.4318371, 39.4360026],
              [44.4318783, 39.4358631],
              [44.4315286, 39.4357144],
              [44.4313608, 39.4357469],
              [44.4311927, 39.4356863],
              [44.431258, 39.4354173],
              [44.4314212, 39.4352041],
              [44.4312731, 39.4350779],
              [44.4306847, 39.4350057],
              [44.4306612, 39.4349553],
              [44.4307528, 39.4348362],
              [44.4310745, 39.4346642],
              [44.4311022, 39.434568],
              [44.4310347, 39.4345174],
              [44.430636, 39.4345651],
              [44.4307332, 39.4343024],
              [44.4306734, 39.4342629],
              [44.4304306, 39.4342649],
              [44.4302438, 39.4344488],
              [44.4298893, 39.4346059],
              [44.4297212, 39.4343315],
              [44.4297567, 39.4341041],
              [44.4296998, 39.4340657],
              [44.4295128, 39.434076],
              [44.4294562, 39.4340266],
              [44.4294393, 39.4339254],
              [44.4293037, 39.43376],
              [44.4292773, 39.4335742],
              [44.4291723, 39.433499],
              [44.4291357, 39.4334212],
              [44.4291961, 39.4332514],
              [44.4291044, 39.4329757],
              [44.4289672, 39.4329593],
              [44.4286821, 39.432768],
              [44.4288371, 39.4326171],
              [44.4287924, 39.4324929],
              [44.4282911, 39.4324782],
              [44.4281157, 39.4323399],
              [44.4279277, 39.4323158],
              [44.4278887, 39.4322194],
              [44.428087, 39.4320644],
              [44.4281345, 39.431967],
              [44.4279127, 39.4318681],
              [44.4277395, 39.4319141],
              [44.4275955, 39.4318253],
              [44.4276829, 39.4316666],
              [44.4277064, 39.431443],
              [44.4275789, 39.4312544],
              [44.4275811, 39.4305672],
              [44.4274664, 39.4303178],
              [44.4272513, 39.430117],
              [44.4272463, 39.4300277],
              [44.4274028, 39.4298095],
              [44.4273821, 39.4297488],
              [44.4271084, 39.4292798],
              [44.4267302, 39.4288716],
              [44.4267921, 39.428345],
              [44.4267602, 39.4281766],
              [44.4264328, 39.4278523],
              [44.4264217, 39.4276997],
              [44.426269, 39.4277235],
              [44.4261579, 39.4276678],
              [44.4261473, 39.4275431],
              [44.4260167, 39.4273166],
              [44.4258614, 39.4272665],
              [44.4258307, 39.4269977],
              [44.4259175, 39.4268278],
              [44.4258729, 39.4266361],
              [44.4260908, 39.4261887],
              [44.425969, 39.4260336],
              [44.4260122, 39.4259004],
              [44.4261175, 39.4258102],
              [44.4262724, 39.4252794],
              [44.4262451, 39.4252146],
              [44.4261191, 39.4252129],
              [44.4259559, 39.4251231],
              [44.426039, 39.4249402],
              [44.4259996, 39.4245718],
              [44.4258884, 39.4244543],
              [44.4261471, 39.4239342],
              [44.4261701, 39.4237496],
              [44.4261387, 39.4236862],
              [44.4257325, 39.4236763],
              [44.4255892, 39.4236208],
              [44.4254089, 39.4234846],
              [44.4253639, 39.4233916],
              [44.4252433, 39.4233677],
              [44.4251572, 39.423399],
              [44.4252029, 39.4230282],
              [44.4248927, 39.4226587],
              [44.4249323, 39.422494],
              [44.4247864, 39.4220394],
              [44.4248292, 39.4219343],
              [44.4251687, 39.4216055],
              [44.4250658, 39.4213863],
              [44.4252202, 39.421189],
              [44.4252576, 39.4210235],
              [44.4251676, 39.4206013],
              [44.4251764, 39.4202023],
              [44.4252599, 39.4200254],
              [44.4252406, 39.419956],
              [44.4249253, 39.4199395],
              [44.4248112, 39.4198069],
              [44.4249039, 39.4196591],
              [44.4249512, 39.4190938],
              [44.4250752, 39.4189331],
              [44.4250501, 39.4188696],
              [44.424876, 39.4188454],
              [44.4244311, 39.4185384],
              [44.4242593, 39.4176313],
              [44.4236815, 39.417289],
              [44.4235776, 39.4170985],
              [44.4231187, 39.4144764],
              [44.4219571, 39.4116039],
              [44.4160923, 39.4118127],
              [44.4144922, 39.4117936],
              [44.4126842, 39.4119139],
              [44.4116232, 39.4120826],
              [44.4104286, 39.412113],
              [44.4079896, 39.4124349],
              [44.3987934, 39.4128841],
              [44.3972092, 39.4125599],
              [44.3905602, 39.4115083],
              [44.3893429, 39.4128236],
              [44.3855811, 39.4129925],
              [44.3818202, 39.4118035],
              [44.379337, 39.4117607],
              [44.3784605, 39.4120152],
              [44.3781219, 39.4119264],
              [44.377915, 39.4118721],
              [44.3772132, 39.4116879],
              [44.3770211, 39.4116375],
              [44.3764159, 39.4114146],
              [44.3762345, 39.4113613],
              [44.3759, 39.4111098],
              [44.3756096, 39.410674],
              [44.3744192, 39.4095452],
              [44.3744499, 39.4088993],
              [44.3741949, 39.4080605],
              [44.37429, 39.4073724],
              [44.373457, 39.407237],
              [44.373267, 39.4071504],
              [44.3721921, 39.4068874],
              [44.3710963, 39.4065759],
              [44.3680451, 39.4054695],
              [44.3659548, 39.4049552],
              [44.3639594, 39.4039798],
              [44.3612814, 39.403074],
              [44.3607761, 39.3980165],
              [44.3576739, 39.3962909],
              [44.3545545, 39.3953972],
              [44.3525295, 39.3942204],
              [44.3513668, 39.3933418],
              [44.3502597, 39.3928859],
              [44.3488586, 39.3926663],
              [44.3476431, 39.3931037],
              [44.346413, 39.3945122],
              [44.3449899, 39.3950584],
              [44.3441692, 39.3933371],
              [44.3428694, 39.3922649],
              [44.3423082, 39.3914676],
              [44.3411677, 39.3910848],
              [44.3404978, 39.3900422],
              [44.3366102, 39.3899505],
              [44.3365156, 39.3884135],
              [44.3347044, 39.3885349],
              [44.3336473, 39.3878721],
              [44.3318777, 39.3877922],
              [44.3308806, 39.3881933],
              [44.3272567, 39.389741],
              [44.3254659, 39.3903065],
              [44.3227382, 39.3906988],
              [44.3187427, 39.3916194],
              [44.3161461, 39.390357],
              [44.3156308, 39.3900051],
              [44.3129446, 39.3881708],
              [44.3127723, 39.3877563],
              [44.311916, 39.3860066],
              [44.3099415, 39.3853241],
              [44.3083789, 39.3846472],
              [44.3068785, 39.3840827],
              [44.3062514, 39.3832601],
              [44.3050078, 39.382224],
              [44.3039667, 39.3816178],
              [44.3023568, 39.3817745],
              [44.3020494, 39.3815177],
              [44.3015442, 39.3801274],
              [44.3007509, 39.3792134],
              [44.299239, 39.3786568],
              [44.2974309, 39.3775431],
              [44.2969318, 39.3768771],
              [44.2958781, 39.3766005],
              [44.294908, 39.3765039],
              [44.2935416, 39.3768439],
              [44.2917045, 39.377817],
              [44.2901951, 39.377941],
              [44.289396, 39.3781431],
              [44.2887722, 39.3787326],
              [44.2877917, 39.3796371],
              [44.2869063, 39.3805124],
              [44.286442, 39.3813968],
              [44.2861825, 39.3827174],
              [44.2854784, 39.3835083],
              [44.2847201, 39.3838238],
              [44.2842575, 39.3837618],
              [44.2833357, 39.3834696],
              [44.2826216, 39.3833596],
              [44.2819664, 39.3834255],
              [44.2805537, 39.3837857],
              [44.2797613, 39.3837455],
              [44.2788497, 39.3834172],
              [44.2779931, 39.3830869],
              [44.2774326, 39.38317],
              [44.2769566, 39.3834319],
              [44.2767312, 39.3840978],
              [44.2760036, 39.3849783],
              [44.2750886, 39.3860483],
              [44.273542, 39.3880107],
              [44.2721558, 39.3896648],
              [44.2716955, 39.3900125],
              [44.2713523, 39.3904176],
              [44.271084, 39.3922967],
              [44.2707689, 39.3943087],
              [44.2706818, 39.3948011],
              [44.2705445, 39.3951243],
              [44.270278, 39.3955344],
              [44.269748, 39.3962113],
              [44.2692243, 39.3968758],
              [44.2689562, 39.3970852],
              [44.2687697, 39.397159],
              [44.2684972, 39.3972125],
              [44.2678562, 39.3972927],
              [44.2674366, 39.397402],
              [44.2669334, 39.3976337],
              [44.2662297, 39.3981941],
              [44.2654284, 39.3989037],
              [44.2649383, 39.3991911],
              [44.2643388, 39.3994229],
              [44.2639489, 39.3994897],
              [44.2635546, 39.3995309],
              [44.2630594, 39.3995103],
              [44.262633, 39.3994426],
              [44.2622088, 39.3993299],
              [44.2618157, 39.3991488],
              [44.2607473, 39.3984675],
              [44.2601393, 39.3980658],
              [44.2598819, 39.3979821],
              [44.2596147, 39.397936],
              [44.2591498, 39.3979852],
              [44.258777, 39.3981465],
              [44.2586045, 39.3982856],
              [44.2584683, 39.3984449],
              [44.2583947, 39.3985887],
              [44.2583702, 39.3986976],
              [44.258293, 39.3988484],
              [44.2582174, 39.3989536],
              [44.2580892, 39.3990038],
              [44.2579209, 39.3990076],
              [44.2577604, 39.3989273],
              [44.2572832, 39.3986393],
              [44.2559504, 39.3983915],
              [44.2530673, 39.3979347],
              [44.2527293, 39.3978188],
              [44.2522959, 39.3974861],
              [44.2518233, 39.3972725],
              [44.2514416, 39.3972906],
              [44.2510934, 39.3973913],
              [44.2505081, 39.3976779],
              [44.2502436, 39.3977138],
              [44.2499365, 39.3976819],
              [44.2484567, 39.3973869],
              [44.2473324, 39.397303],
              [44.2468265, 39.3974079],
              [44.2461664, 39.3976305],
              [44.2447707, 39.3985392],
              [44.2438654, 39.3991416],
              [44.2435908, 39.3993545],
              [44.2433352, 39.3997591],
              [44.2432923, 39.4013406],
              [44.2428259, 39.404232],
              [44.2426966, 39.4049227],
              [44.2406298, 39.4073855],
              [44.2403878, 39.4077729],
              [44.2403282, 39.4080489],
              [44.2401844, 39.4092887],
              [44.2399209, 39.409658],
              [44.2389041, 39.4104019],
              [44.2368286, 39.4111548],
              [44.2351687, 39.4117793],
              [44.2342906, 39.4122337],
              [44.2333339, 39.4130228],
              [44.2331218, 39.4155361],
              [44.2331536, 39.4163292],
              [44.2320266, 39.4164237],
              [44.2312159, 39.4162668],
              [44.2306563, 39.4161582],
              [44.2301111, 39.4161875],
              [44.2296341, 39.4163256],
              [44.2290589, 39.4166101],
              [44.2281011, 39.4171621],
              [44.2275846, 39.4172415],
              [44.2269144, 39.4172566],
              [44.2256728, 39.41731],
              [44.2250722, 39.4174256],
              [44.223605, 39.4179243],
              [44.2233876, 39.4179696],
              [44.2231786, 39.417943],
              [44.2229215, 39.4178358],
              [44.2224854, 39.4174982],
              [44.2221436, 39.4172419],
              [44.2217102, 39.4172114],
              [44.2211861, 39.4173136],
              [44.2206828, 39.4175296],
              [44.2202326, 39.4179882],
              [44.2198858, 39.4182696],
              [44.2196021, 39.4183456],
              [44.2193185, 39.4183365],
              [44.2182026, 39.4181212],
              [44.2169357, 39.4179957],
              [44.2165198, 39.4177826],
              [44.2158069, 39.4177766],
              [44.2145123, 39.4179459],
              [44.213936, 39.4178513],
              [44.2132655, 39.4175307],
              [44.2125592, 39.4169197],
              [44.2120223, 39.4164969],
              [44.2109156, 39.4160794],
              [44.2102463, 39.4158833],
              [44.2092464, 39.4157808],
              [44.2072899, 39.4156236],
              [44.2061493, 39.415521],
              [44.2058039, 39.4154869],
              [44.2054661, 39.415407],
              [44.203408, 39.4143226],
              [44.2000334, 39.4132972],
              [44.1979197, 39.412669],
              [44.1963901, 39.412354],
              [44.1943353, 39.4118492],
              [44.1939165, 39.4116392],
              [44.1931144, 39.4052312],
              [44.1909422, 39.4042393],
              [44.1908097, 39.4029354],
              [44.1908085, 39.4024348],
              [44.1827202, 39.4020374],
              [44.1802935, 39.4015986],
              [44.1789396, 39.4011691],
              [44.1778777, 39.4010144],
              [44.1717562, 39.4013771],
              [44.1662653, 39.4015437],
              [44.1655176, 39.401513],
              [44.1608676, 39.401978],
              [44.1576077, 39.4013484],
              [44.1559325, 39.4004921],
              [44.1546251, 39.3995449],
              [44.1538581, 39.3994769],
              [44.1494387, 39.3999788],
              [44.1488243, 39.3997267],
              [44.1482334, 39.3997023],
              [44.1480733, 39.4008448],
              [44.1448662, 39.4005613],
              [44.143521, 39.3985723],
              [44.1434437, 39.3979413],
              [44.14121, 39.3963071],
              [44.1400666, 39.3960355],
              [44.1389142, 39.3958333],
              [44.1386752, 39.3948742],
              [44.1371845, 39.3935001],
              [44.1338167, 39.3906255],
              [44.1321987, 39.3905522],
              [44.1301405, 39.3896441],
              [44.1293211, 39.3898113],
              [44.1270754, 39.3896175],
              [44.1262666, 39.3896335],
              [44.1248874, 39.3898497],
              [44.1246393, 39.3906465],
              [44.1249102, 39.3911926],
              [44.1270377, 39.3931671],
              [44.1287635, 39.3946515],
              [44.1296727, 39.3952651],
              [44.1309018, 39.3961389],
              [44.1323981, 39.3980266],
              [44.1327798, 39.3987149],
              [44.1321245, 39.4004978],
              [44.1318776, 39.4031489],
              [44.1311756, 39.4042396],
              [44.1301049, 39.4054092],
              [44.1285242, 39.4052297],
              [44.1281218, 39.4050724],
              [44.1274362, 39.4043779],
              [44.1243311, 39.4037598],
              [44.1228714, 39.4036028],
              [44.1220588, 39.403384],
              [44.1203013, 39.4025929],
              [44.1189496, 39.402125],
              [44.1174275, 39.4019447],
              [44.1136006, 39.4025249],
              [44.1125533, 39.4027912],
              [44.1114068, 39.4034695],
              [44.1100823, 39.4046265],
              [44.1085835, 39.4058454],
              [44.1075039, 39.4065032],
              [44.10673, 39.4068119],
              [44.1046308, 39.4070736],
              [44.1030185, 39.4073304],
              [44.1016554, 39.4079579],
              [44.1005197, 39.4087667],
              [44.0996219, 39.4098291],
              [44.0987838, 39.410966],
              [44.0981151, 39.4117552],
              [44.0969923, 39.4121726],
              [44.0935987, 39.4119051],
              [44.091994, 39.4114544],
              [44.0905388, 39.4113021],
              [44.0896987, 39.4111448],
              [44.0886988, 39.4107483],
              [44.0881858, 39.410347],
              [44.0876883, 39.4097048],
              [44.0869009, 39.4092009],
              [44.0859146, 39.408443],
              [44.084893, 39.4079112],
              [44.0843952, 39.4077966],
              [44.0838507, 39.4078471],
              [44.0830574, 39.4081709],
              [44.0819513, 39.4084225],
              [44.0758038, 39.4100624],
              [44.0739102, 39.4109307],
              [44.0723488, 39.411939],
              [44.0715956, 39.4123376],
              [44.0710893, 39.4123425],
              [44.0704062, 39.4122588],
              [44.0698358, 39.4119182],
              [44.0692879, 39.4117579],
              [44.06792, 39.4114852],
              [44.0668433, 39.4111494],
              [44.0644875, 39.4087944],
              [44.0624251, 39.4071038],
              [44.0610559, 39.4061815],
              [44.0595826, 39.405398],
              [44.0590547, 39.4052676],
              [44.0581981, 39.4052909],
              [44.0554382, 39.4060961],
              [44.0538207, 39.4060362],
              [44.0523477, 39.4052677],
              [44.0513157, 39.4040585],
              [44.0511439, 39.4030519],
              [44.0514161, 39.402373],
              [44.0517256, 39.4010157],
              [44.0517798, 39.3995253],
              [44.0514869, 39.398249],
              [44.0523035, 39.396947],
              [44.0528523, 39.3959429],
              [44.052997, 39.3952493],
              [44.0537298, 39.3941858],
              [44.0545327, 39.3932451],
              [44.0549658, 39.392323],
              [44.0560266, 39.3904619],
              [44.057068, 39.3883787],
              [44.0579604, 39.3861475],
              [44.0578682, 39.3861109],
              [44.0570564, 39.3865655],
              [44.0557251, 39.3876695],
              [44.0547524, 39.3888067],
              [44.0545768, 39.3889121],
              [44.0544011, 39.3889311],
              [44.0538417, 39.388806],
              [44.052965, 39.3882865],
              [44.0517635, 39.3874097],
              [44.0493931, 39.3864031],
              [44.0461135, 39.3855264],
              [44.0441327, 39.3846821],
              [44.0427039, 39.3841626],
              [44.0412102, 39.3822792],
              [44.0406257, 39.3817597],
              [44.0400088, 39.380201],
              [44.0396191, 39.3798763],
              [44.0382553, 39.3794866],
              [44.0377682, 39.3791944],
              [44.0363394, 39.3778955],
              [44.0348457, 39.3777656],
              [44.0342937, 39.3775058],
              [44.0340664, 39.3769538],
              [44.0335793, 39.3752004],
              [44.0327351, 39.3727325],
              [44.0318908, 39.3717259],
              [44.0320532, 39.3710115],
              [44.0328, 39.3699399],
              [44.0341963, 39.3688034],
              [44.0352679, 39.3680241],
              [44.0367616, 39.3671473],
              [44.0369564, 39.3667577],
              [44.0371837, 39.3660433],
              [44.0376058, 39.3624714],
              [44.0377009, 39.3612643]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 255446,
        "tags": {
          "ISO3166-2": "IR-07",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "فارس",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q1004666"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [50.6031831, 29.9437282],
              [50.6045699, 29.9437282],
              [50.605403, 29.9440079],
              [50.6084598, 29.9440079],
              [50.6090164, 29.9437282],
              [50.6112364, 29.9437283],
              [50.611793, 29.9434486],
              [50.6142931, 29.9434486],
              [50.6248495, 29.94012],
              [50.6259593, 29.94012],
              [50.6267929, 29.9398404],
              [50.6279063, 29.9398404],
              [50.6287395, 29.9395608],
              [50.6306829, 29.9392902],
              [50.6342927, 29.9392902],
              [50.642349, 29.9373417],
              [50.6456824, 29.9354023],
              [50.6481823, 29.9328946],
              [50.6548489, 29.9237298],
              [50.6573525, 29.9190031],
              [50.6581858, 29.9173433],
              [50.6601292, 29.9151152],
              [50.6604057, 29.9148446],
              [50.6801288, 29.8976157],
              [50.696242, 29.8876123],
              [50.7134649, 29.8734507],
              [50.7137415, 29.873171],
              [50.7126317, 29.8662255],
              [50.7087418, 29.8648364],
              [50.7062417, 29.8648365],
              [50.7056851, 29.8653957],
              [50.7045749, 29.8659549],
              [50.7034651, 29.8665051],
              [50.7034651, 29.8667848],
              [50.700685, 29.8667848],
              [50.6954087, 29.8615081],
              [50.6945752, 29.8615081],
              [50.6940185, 29.8612284],
              [50.689852, 29.8623379],
              [50.6873519, 29.8592801],
              [50.6851284, 29.8592801],
              [50.6837422, 29.8606692],
              [50.6848518, 29.8645658],
              [50.6842952, 29.8651161],
              [50.6837421, 29.865116],
              [50.682909, 29.8656753],
              [50.6815187, 29.8640066],
              [50.680962, 29.8617877],
              [50.6804088, 29.8606692],
              [50.6798522, 29.8609488],
              [50.6790186, 29.8617876],
              [50.6759623, 29.8631767],
              [50.6751287, 29.8628971],
              [50.6742955, 29.8606691],
              [50.6745756, 29.8584502],
              [50.6748521, 29.8573408],
              [50.6751287, 29.8565109],
              [50.6754088, 29.8562313],
              [50.6740189, 29.8548422],
              [50.6731857, 29.8548422],
              [50.6729056, 29.8545626],
              [50.672072, 29.8545626],
              [50.6715189, 29.8548422],
              [50.6695723, 29.8548422],
              [50.6690188, 29.8542829],
              [50.6704055, 29.8523437],
              [50.6709623, 29.8503953],
              [50.6706857, 29.8484561],
              [50.6690189, 29.8470671],
              [50.6681856, 29.8473376],
              [50.6656856, 29.847067],
              [50.6654055, 29.8459485],
              [50.6659622, 29.8456779],
              [50.6670723, 29.8445595],
              [50.6681856, 29.8440093],
              [50.667629, 29.8415017],
              [50.6670723, 29.8412311],
              [50.6648523, 29.8415017],
              [50.6645723, 29.8398421],
              [50.6651289, 29.8392828],
              [50.6659622, 29.8392828],
              [50.6665192, 29.8387236],
              [50.6656856, 29.8381734],
              [50.6642957, 29.8381734],
              [50.6634624, 29.8387235],
              [50.6626289, 29.8387236],
              [50.6620722, 29.8390032],
              [50.661239, 29.8390032],
              [50.6604059, 29.8373435],
              [50.6606859, 29.8370639],
              [50.6606859, 29.8362251],
              [50.6601292, 29.8356749],
              [50.6565191, 29.8356749],
              [50.6559624, 29.8353952],
              [50.654296, 29.8353953],
              [50.6515158, 29.8345655],
              [50.6445727, 29.8287296],
              [50.644016, 29.827061],
              [50.6440161, 29.8253923],
              [50.6448493, 29.822064],
              [50.6476295, 29.817058],
              [50.6656856, 29.8056752],
              [50.6684622, 29.8048364],
              [50.7037418, 29.7915055],
              [50.7304081, 29.7873385],
              [50.7323549, 29.7865087],
              [50.7456879, 29.7834511],
              [50.7484645, 29.7831715],
              [50.7512444, 29.7831715],
              [50.7526345, 29.7828919],
              [50.7654109, 29.7817825],
              [50.7737441, 29.7817825],
              [50.7751342, 29.7820621],
              [50.7790241, 29.7820621],
              [50.7804109, 29.7817826],
              [50.7829107, 29.7817826],
              [50.787914, 29.7812234],
              [50.7912473, 29.7806732],
              [50.7981904, 29.7806732],
              [50.7987471, 29.7803936],
              [50.8001338, 29.7803936],
              [50.8006905, 29.780114],
              [50.8018005, 29.780114],
              [50.8154136, 29.7753968],
              [50.8184704, 29.7756674],
              [50.8195803, 29.7753969],
              [50.8201369, 29.7756675],
              [50.82069, 29.7753968],
              [50.8226368, 29.775947],
              [50.8256935, 29.7759471],
              [50.8262468, 29.7756675],
              [50.8268299, 29.7754366],
              [50.8276367, 29.7751173],
              [50.83458, 29.7737282],
              [50.8365267, 29.7737283],
              [50.8373599, 29.7734487],
              [50.8443032, 29.7734487],
              [50.8476364, 29.7740079],
              [50.852083, 29.7742785],
              [50.8579163, 29.7742785],
              [50.8590263, 29.7745581],
              [50.872916, 29.7745581],
              [50.9273619, 29.7801141],
              [50.9301418, 29.7801141],
              [50.9318085, 29.7803937],
              [50.9345851, 29.7803937],
              [50.9362517, 29.7806733],
              [50.9451417, 29.7806734],
              [50.9476415, 29.780953],
              [50.9618081, 29.7817827],
              [50.9673646, 29.7817827],
              [50.9684745, 29.7820623],
              [50.9712547, 29.7820624],
              [50.9998675, 29.7828922],
              [51.0173673, 29.7778954],
              [51.0179239, 29.7778954],
              [51.0182006, 29.7776158],
              [51.0190339, 29.7776159],
              [51.0195905, 29.7773362],
              [51.0226439, 29.776777],
              [51.0257004, 29.7765065],
              [51.0315337, 29.7765065],
              [51.0318103, 29.7762269],
              [51.0332004, 29.7762268],
              [51.033757, 29.7759473],
              [51.0345904, 29.7759472],
              [51.034867, 29.7756676],
              [51.0376469, 29.7748379],
              [51.0382003, 29.7745583],
              [51.0387569, 29.7745583],
              [51.0395904, 29.7745583],
              [51.0398668, 29.7742787],
              [51.0512567, 29.7709506],
              [51.0901496, 29.7509457],
              [51.0937595, 29.7498364],
              [51.1137592, 29.7409435],
              [51.1623719, 29.7176111],
              [51.1654284, 29.7165018],
              [51.1726518, 29.7142832],
              [51.1743184, 29.7142832],
              [51.1773749, 29.713724],
              [51.1895982, 29.7126147],
              [51.1984847, 29.7126147],
              [51.1998748, 29.7123351],
              [51.2037647, 29.7123352],
              [51.2051545, 29.7120555],
              [51.2120978, 29.7115053],
              [51.2159877, 29.7115054],
              [51.2168212, 29.7112258],
              [51.2234876, 29.7112258],
              [51.2240444, 29.7109462],
              [51.2268209, 29.7109462],
              [51.2279309, 29.7112258],
              [51.2340441, 29.7112259],
              [51.2345975, 29.7109463],
              [51.2409874, 29.7106757],
              [51.2437673, 29.7103961],
              [51.2446008, 29.7103961],
              [51.2451538, 29.7101165],
              [51.2468206, 29.7101165],
              [51.2473773, 29.7098369],
              [51.2487673, 29.7098369],
              [51.2490441, 29.7095574],
              [51.2504339, 29.7095573],
              [51.2507107, 29.7092777],
              [51.262377, 29.7073387],
              [51.2782135, 29.7006648],
              [51.2865468, 29.6953978],
              [51.2868234, 29.6951092],
              [51.2873801, 29.6948386],
              [51.2880716, 29.6941233],
              [51.2970999, 29.6865052],
              [51.2973798, 29.6856665],
              [51.2979367, 29.6851163],
              [51.2979367, 29.6845571],
              [51.2993233, 29.6790017],
              [51.2996034, 29.6784425],
              [51.2965467, 29.6584482],
              [51.2873802, 29.6448303],
              [51.2848803, 29.641782],
              [51.2740436, 29.6259458],
              [51.2704338, 29.6148353],
              [51.2698771, 29.6098303],
              [51.2701572, 29.6081709],
              [51.2704337, 29.6073322],
              [51.2707103, 29.6056639],
              [51.2724124, 29.6011977],
              [51.273085, 29.5994327],
              [51.2773769, 29.5881688],
              [51.277657, 29.5876097],
              [51.277657, 29.5873392],
              [51.2782137, 29.5840025],
              [51.2784904, 29.5826138],
              [51.2973801, 29.5306625],
              [51.2979369, 29.5301125],
              [51.3029369, 29.5198325],
              [51.3043233, 29.5178848],
              [51.3209933, 29.4976138],
              [51.3265465, 29.4931682],
              [51.3273797, 29.4928887],
              [51.3276597, 29.4926092],
              [51.329603, 29.4915],
              [51.3298797, 29.490941],
              [51.3304364, 29.490941],
              [51.3307129, 29.490391],
              [51.3519992, 29.4734668],
              [51.364606, 29.4634389],
              [51.365716, 29.4634388],
              [51.3668258, 29.463998],
              [51.3676592, 29.4639979],
              [51.3687724, 29.464557],
              [51.375439, 29.4715001],
              [51.3759958, 29.4715001],
              [51.3768291, 29.4717796],
              [51.379329, 29.4717796],
              [51.3815488, 29.470941],
              [51.3826624, 29.4690024],
              [51.3851622, 29.4642775],
              [51.3898822, 29.4615002],
              [51.3915489, 29.4615003],
              [51.3948854, 29.4637185],
              [51.3959954, 29.4637184],
              [51.396272, 29.4639979],
              [51.3973855, 29.463998],
              [51.3979386, 29.4642775],
              [51.4004387, 29.4642775],
              [51.4009953, 29.4639979],
              [51.4012721, 29.4642775],
              [51.4018287, 29.463998],
              [51.4040519, 29.463998],
              [51.4068286, 29.4628889],
              [51.4079385, 29.4620503],
              [51.4087719, 29.4617798],
              [51.4123851, 29.4626093],
              [51.4226617, 29.4734388],
              [51.4276615, 29.475107],
              [51.4334982, 29.4737183],
              [51.4359983, 29.4737184],
              [51.4362748, 29.4739979],
              [51.4373848, 29.4737184],
              [51.4379415, 29.4739979],
              [51.4421081, 29.4739979],
              [51.4443314, 29.4706616],
              [51.4440514, 29.4695525],
              [51.4443315, 29.4690025],
              [51.4459981, 29.4664957],
              [51.4471081, 29.4656661],
              [51.4482214, 29.4656662],
              [51.4498879, 29.4662252],
              [51.4515546, 29.4664957],
              [51.4521079, 29.4662252],
              [51.4529411, 29.4662252],
              [51.4543313, 29.4656662],
              [51.4573879, 29.4620503],
              [51.4584979, 29.4615003],
              [51.4593311, 29.4615003],
              [51.4598878, 29.4617798],
              [51.464331, 29.4617798],
              [51.4657211, 29.4617799],
              [51.4662745, 29.4617798],
              [51.4698878, 29.4626094],
              [51.4746109, 29.4626094],
              [51.4746108, 29.462889],
              [51.4776642, 29.4615003],
              [51.4787775, 29.4615004],
              [51.4793309, 29.4617798],
              [51.4812775, 29.4617798],
              [51.4823873, 29.4626094],
              [51.484054, 29.4626094],
              [51.4846109, 29.4623299],
              [51.4859974, 29.4612208],
              [51.4857206, 29.4601117],
              [51.4832208, 29.4559458],
              [51.4832208, 29.4548278],
              [51.4832209, 29.4545573],
              [51.4834974, 29.4537187],
              [51.4846109, 29.4506619],
              [51.4885008, 29.4487233],
              [51.4896108, 29.4487234],
              [51.4898873, 29.4484439],
              [51.490444, 29.4487233],
              [51.5023871, 29.4526097],
              [51.5037772, 29.4526096],
              [51.5043339, 29.4528891],
              [51.5051671, 29.4528891],
              [51.5054438, 29.4531687],
              [51.5073904, 29.4531687],
              [51.5076671, 29.4528892],
              [51.5085004, 29.4528891],
              [51.5118337, 29.4512211],
              [51.5171103, 29.4462258],
              [51.5173904, 29.4451076],
              [51.5176669, 29.4423304],
              [51.5179435, 29.4420509],
              [51.5179435, 29.4409418],
              [51.5193335, 29.4398328],
              [51.5210002, 29.4390032],
              [51.5221101, 29.4390032],
              [51.5226669, 29.4387237],
              [51.5237768, 29.4387237],
              [51.5240569, 29.4384442],
              [51.52989, 29.4384442],
              [51.5304468, 29.4381647],
              [51.5315568, 29.4381647],
              [51.53989, 29.4339989],
              [51.5515564, 29.425388],
              [51.5523899, 29.4242699],
              [51.5526697, 29.4217723],
              [51.5529465, 29.4212223],
              [51.5518365, 29.4142705],
              [51.5535031, 29.4117729],
              [51.5546131, 29.4109433],
              [51.5557232, 29.4101048],
              [51.557113, 29.4098343],
              [51.559613, 29.4089957],
              [51.5601697, 29.4084458],
              [51.5662796, 29.4051097],
              [51.5665597, 29.4045506],
              [51.567113, 29.4042711],
              [51.5687796, 29.4006645],
              [51.5696128, 29.4006645],
              [51.5698929, 29.400385],
              [51.5718361, 29.400385],
              [51.5743362, 29.3959399],
              [51.5746128, 29.3956694],
              [51.5746128, 29.3951104],
              [51.5771129, 29.3934424],
              [51.5776694, 29.3937219],
              [51.5793361, 29.3937219],
              [51.5796126, 29.3934424],
              [51.5810028, 29.3934424],
              [51.5810026, 29.3931629],
              [51.5826694, 29.3931629],
              [51.5860026, 29.3920538],
              [51.5865592, 29.3914949],
              [51.587116, 29.3914949],
              [51.5871159, 29.3912154],
              [51.5885026, 29.3889973],
              [51.5901693, 29.3856613],
              [51.5921288, 29.3834844],
              [51.5926692, 29.3828842],
              [51.5926692, 29.3826047],
              [51.6207289, 29.3173286],
              [51.6218389, 29.3137222],
              [51.6221155, 29.3126042],
              [51.6326721, 29.2923281],
              [51.6335053, 29.2914987],
              [51.6337821, 29.2906602],
              [51.6348954, 29.2895514],
              [51.635172, 29.2887219],
              [51.6629516, 29.250659],
              [51.6654517, 29.247044],
              [51.6660082, 29.2459351],
              [51.6668417, 29.2451057],
              [51.6740614, 29.2342696],
              [51.6760081, 29.2323223],
              [51.6765648, 29.2312135],
              [51.677118, 29.230943],
              [51.6812797, 29.2302746],
              [51.7045783, 29.2076905],
              [51.7052436, 29.2034832],
              [51.7117194, 29.1962733],
              [51.718923, 29.1890381],
              [51.7216608, 29.1865195],
              [51.7267236, 29.1820903],
              [51.7365288, 29.1730751],
              [51.7425094, 29.1675985],
              [51.7559354, 29.1532336],
              [51.7677718, 29.1417916],
              [51.7806936, 29.1272821],
              [51.7908628, 29.1178485],
              [51.8016333, 29.1065415],
              [51.8078013, 29.1003362],
              [51.8117356, 29.0962112],
              [51.817156, 29.0906805],
              [51.8140504, 29.0874596],
              [51.8093656, 29.0797703],
              [51.80462, 29.0720075],
              [51.8013607, 29.0653872],
              [51.7987117, 29.0606513],
              [51.7949032, 29.0473239],
              [51.7946233, 29.046765],
              [51.79304, 29.0421466],
              [51.8146704, 29.0238477],
              [51.8648306, 28.9759208],
              [51.8768487, 28.9617639],
              [51.887962, 28.9473169],
              [51.8882386, 28.945929],
              [51.8887952, 28.9450998],
              [51.8951852, 28.9264894],
              [51.8951852, 28.9253719],
              [51.8960186, 28.923155],
              [51.8962952, 28.9225961],
              [51.8962952, 28.9223168],
              [51.906575, 28.8959295],
              [51.9235182, 28.8645415],
              [51.9321314, 28.8520425],
              [51.9432412, 28.8392643],
              [51.9443545, 28.8381469],
              [51.9590776, 28.8234315],
              [51.9604644, 28.8212057],
              [51.9709425, 28.7897765],
              [51.9743541, 28.7795388],
              [51.9788007, 28.7570392],
              [51.9807442, 28.7456499],
              [51.9807441, 28.7445416],
              [51.9810206, 28.7439831],
              [51.9926871, 28.6975896],
              [51.9929672, 28.69704],
              [51.9929672, 28.6920395],
              [51.9929672, 28.6917601],
              [51.993244, 28.6912015],
              [51.9932439, 28.6909312],
              [51.993244, 28.6903727],
              [51.9935205, 28.6889851],
              [51.9974104, 28.6759299],
              [51.9990771, 28.6714792],
              [51.9993572, 28.6698123],
              [52.0010239, 28.6659291],
              [52.0010239, 28.6651003],
              [52.0071337, 28.6464776],
              [52.0074105, 28.6459281],
              [52.009357, 28.6392611],
              [52.009357, 28.6389818],
              [52.0096338, 28.6381439],
              [52.0101904, 28.6370358],
              [52.010467, 28.6362069],
              [52.0107438, 28.6350987],
              [52.0113004, 28.6348195],
              [52.0135237, 28.6309275],
              [52.0199137, 28.6056479],
              [52.0201902, 28.6031524],
              [52.0207469, 28.6014767],
              [52.0210236, 28.5989812],
              [52.0354701, 28.5411999],
              [52.0360234, 28.5312007],
              [52.0363035, 28.5292549],
              [52.03658, 28.528147],
              [52.0374134, 28.5214809],
              [52.03797, 28.5173101],
              [52.0438035, 28.4867553],
              [52.04797, 28.4609215],
              [52.0485233, 28.4575888],
              [52.04908, 28.4539769],
              [52.0496366, 28.4500856],
              [52.0501899, 28.4464737],
              [52.0510231, 28.4417539],
              [52.0513032, 28.4409252],
              [52.0540799, 28.4298104],
              [52.0540799, 28.4295311],
              [52.0540799, 28.4284232],
              [52.0558232, 28.4230686],
              [52.0560266, 28.4225867],
              [52.0590798, 28.4159215],
              [52.0808427, 28.3638461],
              [52.0971393, 28.324812],
              [52.1040826, 28.3106458],
              [52.1060258, 28.3064761],
              [52.1113058, 28.2973083],
              [52.1121392, 28.2950839],
              [52.1126959, 28.2945346],
              [52.1229722, 28.2623041],
              [52.1232489, 28.2598096],
              [52.1235291, 28.258702],
              [52.1218625, 28.2289763],
              [52.1215824, 28.2239696],
              [52.1213057, 28.2203587],
              [52.1215824, 28.2134161],
              [52.1218624, 28.2111919],
              [52.1254724, 28.1995309],
              [52.1413055, 28.1748048],
              [52.1413055, 28.1745258],
              [52.1414772, 28.1741821],
              [52.1435287, 28.1700776],
              [52.1582518, 28.1456406],
              [52.1590853, 28.1448032],
              [52.1601953, 28.1436958],
              [52.1707517, 28.130082],
              [52.1790848, 28.1234193],
              [52.199088, 28.1114715],
              [52.2174211, 28.0953554],
              [52.2204775, 28.0917541],
              [52.2207542, 28.0911869],
              [52.2299207, 28.0798068],
              [52.233254, 28.0734146],
              [52.2340874, 28.0725865],
              [52.2652003, 28.0442452],
              [52.2785369, 28.0373042],
              [52.2835367, 28.0350806],
              [52.2940899, 28.0303542],
              [52.2954799, 28.0300841],
              [52.3015932, 28.0284187],
              [52.3027031, 28.0284187],
              [52.3043697, 28.0278605],
              [52.3054797, 28.0278606],
              [52.3093696, 28.0270233],
              [52.3107597, 28.0270233],
              [52.3332592, 28.0231342],
              [52.3352024, 28.0231343],
              [52.3393726, 28.022306],
              [52.3632622, 28.0150771],
              [52.3640954, 28.014807],
              [52.3646488, 28.014807],
              [52.3685388, 28.0123043],
              [52.3760385, 28.0059127],
              [52.3774286, 28.0042473],
              [52.3782619, 28.0036892],
              [52.3802053, 28.0014746],
              [52.3821519, 27.998693],
              [52.3875574, 27.993546],
              [52.3879852, 27.9931387],
              [52.3893717, 27.9892497],
              [52.3896518, 27.9881334],
              [52.3899284, 27.9873053],
              [52.390205, 27.9856309],
              [52.3904851, 27.9839746],
              [52.3910383, 27.9809139],
              [52.3913184, 27.9792485],
              [52.391595, 27.9775832],
              [52.3918717, 27.9753597],
              [52.3932617, 27.9684102],
              [52.4015949, 27.9484086],
              [52.4027083, 27.9473013],
              [52.4029849, 27.9470223],
              [52.4067187, 27.940786],
              [52.4071515, 27.9403521],
              [52.4271512, 27.9122951],
              [52.4363211, 27.8956342],
              [52.4365978, 27.8950762],
              [52.4415976, 27.8859133],
              [52.442431, 27.8850763],
              [52.4429876, 27.8839692],
              [52.4496543, 27.8720252],
              [52.4499309, 27.8717462],
              [52.4552109, 27.8561842],
              [52.4552108, 27.8550773],
              [52.4579875, 27.8470219],
              [52.4582641, 27.8464638],
              [52.4585441, 27.8461849],
              [52.4640974, 27.8373016],
              [52.486877, 27.8095185],
              [52.5010434, 27.7872983],
              [52.5016001, 27.7864703],
              [52.5016002, 27.7861823],
              [52.5066001, 27.7756349],
              [52.5082667, 27.7625769],
              [52.5085467, 27.7572943],
              [52.5088233, 27.7520208],
              [52.5093801, 27.7475752],
              [52.5096273, 27.7465781],
              [52.5099334, 27.7439667],
              [52.51049, 27.7420138],
              [52.5135467, 27.732574],
              [52.5266032, 27.7072966],
              [52.5271564, 27.7064597],
              [52.5271564, 27.7059019],
              [52.5277132, 27.7053529],
              [52.5277132, 27.704795],
              [52.5407697, 27.6689638],
              [52.5407696, 27.667848],
              [52.5410462, 27.6670202],
              [52.541603, 27.6661834],
              [52.541603, 27.6659045],
              [52.541603, 27.6656255],
              [52.5418795, 27.6653555],
              [52.5418795, 27.6650767],
              [52.5427129, 27.6631241],
              [52.5485461, 27.6536852],
              [52.5507694, 27.6495192],
              [52.5507695, 27.6492403],
              [52.5510461, 27.6489614],
              [52.5510461, 27.6486824],
              [52.5632693, 27.6245148],
              [52.5635492, 27.6242449],
              [52.5974387, 27.5864565],
              [52.601882, 27.5817421],
              [52.6027152, 27.5806265],
              [52.613358, 27.5719474],
              [52.6238284, 27.5634067],
              [52.6291049, 27.5611844],
              [52.6299382, 27.5611845],
              [52.6318849, 27.5606266],
              [52.6329949, 27.5606266],
              [52.6335516, 27.5603478],
              [52.6346616, 27.5603478],
              [52.6354949, 27.5600689],
              [52.6366048, 27.5600688],
              [52.6371615, 27.55979],
              [52.6404947, 27.55979],
              [52.6407748, 27.5595111],
              [52.647718, 27.5575678],
              [52.6602178, 27.551738],
              [52.6668843, 27.5484093],
              [52.6854974, 27.5386842],
              [52.687164, 27.5372898],
              [52.6874407, 27.5372898],
              [52.6877207, 27.5370109],
              [52.6879974, 27.536741],
              [52.7368899, 27.510904],
              [52.73689, 27.5106251],
              [52.7391098, 27.5097975],
              [52.7423467, 27.5084734],
              [52.7452231, 27.5072966],
              [52.7460565, 27.5072967],
              [52.7546663, 27.5028527],
              [52.7549464, 27.502295],
              [52.7579997, 27.500064],
              [52.7680169, 27.4903309],
              [52.768556, 27.4895119],
              [52.7746694, 27.483125],
              [52.7757793, 27.4809031],
              [52.7888358, 27.4678506],
              [52.7988356, 27.4614549],
              [52.8007789, 27.4600696],
              [52.8088355, 27.4539619],
              [52.8088355, 27.453683],
              [52.8173123, 27.4485982],
              [52.828282, 27.4420163],
              [52.8701614, 27.419808],
              [52.8823067, 27.4071859],
              [52.889471, 27.4008801],
              [52.8981399, 27.3910497],
              [52.9054355, 27.382133],
              [52.9126668, 27.374435],
              [52.9134056, 27.3734652],
              [52.9184983, 27.3722457],
              [52.926642, 27.3693946],
              [52.9607105, 27.3580848],
              [52.9763834, 27.3526672],
              [52.9762941, 27.352272],
              [52.9884767, 27.3476597],
              [52.9991626, 27.343295],
              [53.0048275, 27.3403406],
              [53.0124866, 27.3362573],
              [53.0141884, 27.3353133],
              [53.0161142, 27.3308671],
              [53.0186482, 27.3243704],
              [53.0373722, 27.3150031],
              [53.0393314, 27.3144342],
              [53.0435371, 27.3106211],
              [53.0571841, 27.3064265],
              [53.0732345, 27.3039859],
              [53.0835353, 27.2984124],
              [53.1088982, 27.2850877],
              [53.1128706, 27.2837146],
              [53.134122, 27.2781929],
              [53.1377792, 27.2774415],
              [53.1434717, 27.2771015],
              [53.1542191, 27.2666585],
              [53.1688986, 27.2662566],
              [53.1723295, 27.2648688],
              [53.1822076, 27.2618262],
              [53.2020665, 27.2571377],
              [53.2296889, 27.2397845],
              [53.2692817, 27.2356958],
              [53.2703917, 27.2348596],
              [53.2765015, 27.2320813],
              [53.308067, 27.2225785],
              [53.3362504, 27.2081122],
              [53.3376371, 27.2078424],
              [53.346267, 27.1986785],
              [53.3499703, 27.1920103],
              [53.3502469, 27.1917316],
              [53.3513603, 27.1917315],
              [53.3519136, 27.1914528],
              [53.3527469, 27.1914529],
              [53.353027, 27.1911741],
              [53.3535802, 27.1911741],
              [53.3538603, 27.1908954],
              [53.3541369, 27.1906166],
              [53.3546936, 27.1903469],
              [53.3569169, 27.1864535],
              [53.3627502, 27.1708983],
              [53.3744167, 27.1481148],
              [53.3752499, 27.1472876],
              [53.3843865, 27.1308377],
              [53.4103772, 27.1245357],
              [53.4096961, 27.1139499],
              [53.4105294, 27.11395],
              [53.415527, 27.1065061],
              [53.4464976, 27.1064833],
              [53.4466228, 27.1064573],
              [53.4466515, 27.1064513],
              [53.4468315, 27.1064139],
              [53.4480288, 27.1061732],
              [53.4496989, 27.1061732],
              [53.4736582, 27.1060919],
              [53.4753249, 27.1060919],
              [53.4775482, 27.1055345],
              [53.4789347, 27.1055345],
              [53.4797681, 27.1052558],
              [53.4811581, 27.1052558],
              [53.4819913, 27.1049861],
              [53.4831047, 27.1049861],
              [53.483658, 27.1046984],
              [53.4844914, 27.1046984],
              [53.4964379, 27.1027566],
              [53.5014378, 27.1027566],
              [53.5044944, 27.1027566],
              [53.5056044, 27.1027566],
              [53.506161, 27.1030353],
              [53.5069944, 27.1030353],
              [53.5072711, 27.103314],
              [53.5081043, 27.103314],
              [53.5089376, 27.1041411],
              [53.511161, 27.1049861],
              [53.5117143, 27.1055345],
              [53.5122709, 27.1055345],
              [53.5369373, 27.0918148],
              [53.5372174, 27.0920938],
              [53.537494, 27.0918149],
              [53.5809927, 27.1398997],
              [53.5811326, 27.1397596],
              [53.5814098, 27.1394821],
              [53.5816864, 27.1392032],
              [53.5816865, 27.1389245],
              [53.5822431, 27.1380976],
              [53.6040793, 27.1259521],
              [53.626026, 27.1142885],
              [53.6426924, 27.1081759],
              [53.6776953, 27.0981805],
              [53.6826952, 27.0962298],
              [53.6832485, 27.0959513],
              [53.6846385, 27.0956815],
              [53.7515874, 27.0687429],
              [53.8097297, 27.0680153],
              [53.8102829, 27.0685726],
              [53.8436289, 27.0714554],
              [53.8444622, 27.0720127],
              [53.871845, 27.085262],
              [53.8732351, 27.0858104],
              [53.8737918, 27.0863678],
              [53.9069381, 27.1114507],
              [53.9111047, 27.1131139],
              [53.9130514, 27.1136713],
              [53.9188846, 27.1159009],
              [53.9333276, 27.1236778],
              [53.934161, 27.1245049],
              [53.9640676, 27.1455798],
              [53.9497369, 27.1660849],
              [53.8915663, 27.2222546],
              [53.8823999, 27.2375434],
              [53.8815665, 27.2386592],
              [53.8954919, 27.2839262],
              [53.9658306, 27.3353436],
              [53.97166, 27.3393096],
              [53.9770269, 27.341536],
              [53.9773965, 27.3417234],
              [53.9781369, 27.3423726],
              [53.9781369, 27.3426425],
              [53.9956366, 27.348759],
              [53.9959166, 27.3490378],
              [54.0048001, 27.3521264],
              [54.0123063, 27.3523659],
              [54.0157912, 27.3534385],
              [54.0341517, 27.3588473],
              [54.0444943, 27.3610961],
              [54.0795132, 27.3623158],
              [54.1268914, 27.3809141],
              [54.1811364, 27.4113959],
              [54.1956645, 27.4272149],
              [54.2124109, 27.4373194],
              [54.2132442, 27.4373194],
              [54.2146308, 27.4378772],
              [54.2168541, 27.438147],
              [54.2224107, 27.4395413],
              [54.2343573, 27.4417633],
              [54.2365771, 27.4417633],
              [54.2472487, 27.4433288],
              [54.2688817, 27.4465022],
              [54.2876896, 27.4492569],
              [54.288523, 27.4495449],
              [54.293803, 27.4495449],
              [54.3054694, 27.4478806],
              [54.3065794, 27.4481505],
              [54.3107494, 27.4481504],
              [54.3193592, 27.449257],
              [54.3210258, 27.4492569],
              [54.3221358, 27.4495449],
              [54.3229691, 27.449257],
              [54.3235258, 27.4489871],
              [54.3243591, 27.4489871],
              [54.3249158, 27.4487082],
              [54.327969, 27.4487083],
              [54.3282491, 27.4489871],
              [54.3288057, 27.4489871],
              [54.3290824, 27.4487082],
              [54.3296391, 27.4487083],
              [54.3299157, 27.4489871],
              [54.3335256, 27.4489871],
              [54.3338058, 27.4487083],
              [54.3363056, 27.4487083],
              [54.3371389, 27.4484294],
              [54.3396389, 27.4484294],
              [54.3401922, 27.4481504],
              [54.3471388, 27.4481504],
              [54.3488055, 27.4478806],
              [54.349082, 27.4475928],
              [54.350472, 27.4475927],
              [54.3646385, 27.4439853],
              [54.3660284, 27.4439853],
              [54.3671384, 27.4437065],
              [54.3710284, 27.4437065],
              [54.3735283, 27.4431487],
              [54.3776949, 27.4431487],
              [54.3788048, 27.4428788],
              [54.3804715, 27.4428788],
              [54.3857515, 27.4437065],
              [54.3876948, 27.4437064],
              [54.3904747, 27.4442641],
              [54.3921414, 27.4442642],
              [54.5016386, 27.4523156],
              [54.5019187, 27.4525945],
              [54.5038619, 27.4525945],
              [54.5046953, 27.4528734],
              [54.5080285, 27.4528734],
              [54.5085853, 27.4531523],
              [54.5169184, 27.4531523],
              [54.5183085, 27.4534311],
              [54.5230283, 27.4534311],
              [54.5238616, 27.45371],
              [54.5344181, 27.4537101],
              [54.5349748, 27.4534312],
              [54.5376131, 27.4534312],
              [54.5880807, 27.4656199],
              [54.5897473, 27.4658989],
              [54.5961337, 27.4658988],
              [54.5978004, 27.4661867],
              [54.6039137, 27.4661867],
              [54.608357, 27.4664566],
              [54.6100236, 27.4667355],
              [54.611137, 27.4667354],
              [54.6166902, 27.4670143],
              [54.6180801, 27.4672931],
              [54.6219701, 27.4672931],
              [54.6233601, 27.467572],
              [54.62836, 27.467572],
              [54.6289134, 27.4678509],
              [54.6411365, 27.4678509],
              [54.6416932, 27.467572],
              [54.6464165, 27.4675719],
              [54.6469697, 27.4672931],
              [54.6511363, 27.4672931],
              [54.6544696, 27.4667354],
              [54.6569696, 27.4667354],
              [54.7187798, 27.4741618],
              [54.8744794, 27.4422863],
              [54.8780928, 27.4422863],
              [54.8789261, 27.4420164],
              [54.8806227, 27.4316564],
              [54.8822894, 27.4313775],
              [54.8850693, 27.4313776],
              [54.8909027, 27.4305409],
              [54.8934025, 27.4305409],
              [54.9206254, 27.4274913],
              [54.924792, 27.4274913],
              [54.9256253, 27.4272124],
              [54.9295153, 27.4272125],
              [54.945625, 27.4255482],
              [54.9525716, 27.4255482],
              [54.9810784, 27.4266336],
              [55.0222162, 27.4246509],
              [55.0266594, 27.4246509],
              [55.028326, 27.424372],
              [55.0327727, 27.424372],
              [55.0372159, 27.4238234],
              [55.0399924, 27.4238232],
              [55.0408257, 27.4235443],
              [55.0430491, 27.4234981],
              [55.1310954, 27.4166623],
              [55.1319287, 27.4169323],
              [55.1335953, 27.4169322],
              [55.1338719, 27.4172201],
              [55.1349852, 27.4172201],
              [55.1377618, 27.4183265],
              [55.138042, 27.4186055],
              [55.1383185, 27.4188843],
              [55.1408185, 27.4194331],
              [55.1433185, 27.4205486],
              [55.1438752, 27.4205486],
              [55.1438752, 27.4208274],
              [55.1447084, 27.4208275],
              [55.1463751, 27.421664],
              [55.1463751, 27.421934],
              [55.2063603, 27.4214877],
              [55.2291899, 27.4170963],
              [55.2389097, 27.4220999],
              [55.2433564, 27.4243228],
              [55.2749627, 27.4595399],
              [55.2871494, 27.485323],
              [55.2874294, 27.4858808],
              [55.2879827, 27.4858809],
              [55.2937961, 27.5073666],
              [55.2940682, 27.5076412],
              [55.319129, 27.5401708],
              [55.3210723, 27.542951],
              [55.323409, 27.5569743],
              [55.3267423, 27.5600332],
              [55.3314457, 27.5717377],
              [55.3368892, 27.5786966],
              [55.3396026, 27.5901494],
              [55.3437959, 27.6017514],
              [55.3446292, 27.6025882],
              [55.3521958, 27.6232063],
              [55.3527526, 27.6234854],
              [55.3749756, 27.6395876],
              [55.3964919, 27.677847],
              [55.3970485, 27.6786745],
              [55.3998251, 27.6811752],
              [55.4017718, 27.6836757],
              [55.4034385, 27.6864552],
              [55.4039917, 27.686734],
              [55.4410808, 27.6993526],
              [55.4658936, 27.7056319],
              [55.4675601, 27.7095192],
              [55.4824364, 27.7126103],
              [55.4916031, 27.7231662],
              [55.4924362, 27.7234453],
              [55.4985497, 27.7298348],
              [55.5021596, 27.7320487],
              [55.500063, 27.7423018],
              [55.5050565, 27.7511006],
              [55.5128364, 27.7560948],
              [55.5136697, 27.7560948],
              [55.5164463, 27.7577596],
              [55.5172796, 27.7583175],
              [55.535336, 27.7722116],
              [55.5408528, 27.7735688],
              [55.5414094, 27.7743968],
              [55.5419628, 27.7746757],
              [55.5419628, 27.7749549],
              [55.5430762, 27.7766383],
              [55.561859, 27.7881352],
              [55.5663022, 27.7945249],
              [55.5676922, 27.7967479],
              [55.5679689, 27.7984128],
              [55.5682455, 27.7992408],
              [55.5795118, 27.8036866],
              [55.6567379, 27.8254141],
              [55.7271191, 27.8193414],
              [55.7329556, 27.8290575],
              [55.7295224, 27.8421122],
              [55.7138143, 27.85603],
              [55.7135377, 27.8568666],
              [55.7163643, 27.8618203],
              [55.715958, 27.8630573],
              [55.715811, 27.8632055],
              [55.7104811, 27.8704681],
              [55.7102044, 27.8707469],
              [55.7102045, 27.8710258],
              [55.6986233, 27.8782321],
              [55.6937247, 27.9040506],
              [55.676994, 27.9067553],
              [55.6778216, 27.9360845],
              [55.6772648, 27.9363635],
              [55.6767116, 27.937191],
              [55.6852337, 27.9449767],
              [55.6887477, 27.9568424],
              [55.6840244, 27.9646142],
              [55.6812479, 27.967106],
              [55.6790245, 27.9693369],
              [55.6252026, 27.9818086],
              [55.6246459, 27.9820876],
              [55.6246459, 27.9823664],
              [55.5791467, 27.9950083],
              [55.5241023, 27.9904218],
              [55.4805131, 27.9811548],
              [55.4652368, 27.98921],
              [55.4624568, 27.9908661],
              [55.427734, 28.0069857],
              [55.402188, 28.0090513],
              [55.397188, 28.0109955],
              [55.3949647, 28.0129396],
              [55.3815553, 28.0270741],
              [55.3818353, 28.0292978],
              [55.3818353, 28.0297743],
              [55.3851686, 28.0392992],
              [55.3854451, 28.0401365],
              [55.3857252, 28.0417929],
              [55.3860019, 28.0431882],
              [55.3862785, 28.0445746],
              [55.3865586, 28.045682],
              [55.3995892, 28.078342],
              [55.4096079, 28.0826122],
              [55.4087746, 28.0931643],
              [55.4084946, 28.0953882],
              [55.4166876, 28.1119859],
              [55.4169677, 28.112256],
              [55.4172443, 28.1147599],
              [55.4175209, 28.1183718],
              [55.4175208, 28.1194887],
              [55.4178009, 28.1197588],
              [55.4180776, 28.1225419],
              [55.4183542, 28.1247666],
              [55.4186343, 28.1261537],
              [55.4075814, 28.1577671],
              [55.4078579, 28.163602],
              [55.408138, 28.1663754],
              [55.4086914, 28.169707],
              [55.4089713, 28.1719313],
              [55.4092481, 28.1749929],
              [55.4095246, 28.1777662],
              [55.4120246, 28.1899858],
              [55.4188911, 28.2135891],
              [55.4189847, 28.2136825],
              [55.4200043, 28.2152549],
              [55.420281, 28.2160923],
              [55.4052081, 28.2505536],
              [55.4054881, 28.2511119],
              [55.4057648, 28.2541644],
              [55.4063214, 28.2580545],
              [55.4074315, 28.2624938],
              [55.4077081, 28.2644478],
              [55.404505, 28.2678696],
              [55.4047815, 28.2698058],
              [55.4050582, 28.2723093],
              [55.4053383, 28.2745336],
              [55.4056149, 28.2761996],
              [55.4058915, 28.2792524],
              [55.4056149, 28.2825845],
              [55.4058916, 28.2831428],
              [55.4056149, 28.2856464],
              [55.4058916, 28.2864749],
              [55.4064482, 28.2961919],
              [55.4075582, 28.3017574],
              [55.4078383, 28.3036936],
              [55.4083915, 28.3064764],
              [55.4083915, 28.3073049],
              [55.4083915, 28.3078633],
              [55.4086716, 28.3081425],
              [55.4083916, 28.3086918],
              [55.4086716, 28.308971],
              [55.4083915, 28.3098085],
              [55.4086716, 28.3100877],
              [55.4083915, 28.3125823],
              [55.4083915, 28.3142484],
              [55.4081148, 28.3153652],
              [55.4083915, 28.3156443],
              [55.4081148, 28.3175896],
              [55.4078383, 28.318139],
              [55.4081148, 28.3186973],
              [55.4047817, 28.3520288],
              [55.4050583, 28.3542533],
              [55.4067249, 28.3603686],
              [55.407005, 28.362305],
              [55.4070051, 28.380363],
              [55.4064482, 28.3861993],
              [55.4061716, 28.3878656],
              [55.4064482, 28.3881447],
              [55.406725, 28.3925941],
              [55.407005, 28.3948097],
              [55.4072816, 28.3970344],
              [55.4078383, 28.4184168],
              [55.4083916, 28.4203623],
              [55.4086717, 28.4234246],
              [55.4089483, 28.4253702],
              [55.4078933, 28.4329923],
              [55.4079734, 28.4403444],
              [55.4084966, 28.4567477],
              [55.4109, 28.459721],
              [55.4150999, 28.4623823],
              [55.4188764, 28.4656572],
              [55.4272431, 28.4721142],
              [55.4346963, 28.4794844],
              [55.4454192, 28.4870358],
              [55.447091, 28.5125824],
              [55.4503494, 28.519271],
              [55.4509443, 28.5224757],
              [55.4555208, 28.5357712],
              [55.4550727, 28.5396106],
              [55.452376, 28.5455311],
              [55.4468744, 28.5540597],
              [55.4292614, 28.5810506],
              [55.4122921, 28.602609],
              [55.3953348, 28.6226288],
              [55.3864085, 28.6331452],
              [55.3580471, 28.6571526],
              [55.3192517, 28.6866727],
              [55.2766796, 28.7077533],
              [55.2533242, 28.7136208],
              [55.268696, 28.7510634],
              [55.269751, 28.7762127],
              [55.2685743, 28.7992988],
              [55.263167, 28.8116059],
              [55.2576489, 28.8192325],
              [55.2493759, 28.8285316],
              [55.2241509, 28.8470801],
              [55.2006338, 28.8939814],
              [55.2121421, 28.9030492],
              [55.1953121, 28.9117145],
              [55.1758286, 28.9170488],
              [55.1668164, 28.921857],
              [55.2262114, 28.9348528],
              [55.2268123, 28.9371813],
              [55.2258679, 28.9410123],
              [55.2218341, 28.9430401],
              [55.2167701, 28.9438663],
              [55.2134227, 28.9391343],
              [55.2088737, 28.9394347],
              [55.196514, 28.954306],
              [55.1933383, 28.9541558],
              [55.1875877, 28.9609148],
              [55.184841, 28.962567],
              [55.175743, 28.9594129],
              [55.1637266, 28.9626421],
              [55.1649284, 28.9678987],
              [55.1641558, 28.9700013],
              [55.1307677, 28.9892228],
              [55.119352, 28.9988324],
              [55.1102542, 28.983742],
              [55.1056193, 28.9859193],
              [55.1035594, 28.992451],
              [55.1110267, 29.0044623],
              [55.1101683, 29.0058886],
              [55.0959205, 28.999733],
              [55.0942039, 29.0026607],
              [55.0917148, 29.0035615],
              [55.0850199, 29.0025106],
              [55.0847624, 29.0084408],
              [55.0808569, 29.0142582],
              [55.0701713, 29.0104298],
              [55.0353238, 29.0276178],
              [55.034294, 29.0396623],
              [55.031719, 29.039212],
              [55.0246809, 29.0722247],
              [55.0251775, 29.0828973],
              [55.026461, 29.1047736],
              [55.024879, 29.1300821],
              [55.0249168, 29.1888802],
              [55.0296555, 29.2498797],
              [55.0266016, 29.2713064],
              [55.0175101, 29.3079453],
              [55.0000122, 29.35422],
              [54.9879497, 29.3699764],
              [54.9856486, 29.3830906],
              [54.9794491, 29.3968289],
              [54.9748991, 29.3963843],
              [54.9290231, 29.4516123],
              [54.9178065, 29.4650212],
              [54.9043134, 29.4788513],
              [54.8854205, 29.5041587],
              [54.8713788, 29.52631],
              [54.8584626, 29.5399842],
              [54.846073, 29.5540532],
              [54.8308511, 29.5704318],
              [54.8046432, 29.5905904],
              [54.7773172, 29.6022072],
              [54.7518648, 29.6092421],
              [54.7350874, 29.6128698],
              [54.7208626, 29.6131683],
              [54.719196, 29.6125524],
              [54.7033308, 29.6127149],
              [54.6681402, 29.6052527],
              [54.6339164, 29.595708],
              [54.6056053, 29.6069479],
              [54.5882766, 29.6134398],
              [54.543912, 29.6284452],
              [54.5406336, 29.6297135],
              [54.5272033, 29.6311068],
              [54.5021241, 29.6331958],
              [54.4905619, 29.6348183],
              [54.4846097, 29.6336246],
              [54.472114, 29.6253711],
              [54.4626785, 29.6211084],
              [54.4555078, 29.6213831],
              [54.4397878, 29.6221538],
              [54.4284373, 29.6232011],
              [54.4189739, 29.6228999],
              [54.4092227, 29.6220172],
              [54.4028906, 29.6230322],
              [54.3969716, 29.6215878],
              [54.3878564, 29.620688],
              [54.3709727, 29.6223295],
              [54.3529901, 29.6244224],
              [54.3273741, 29.6195547],
              [54.3158394, 29.6159731],
              [54.3039795, 29.6121323],
              [54.2937439, 29.6089704],
              [54.2835443, 29.6050154],
              [54.2740141, 29.6014783],
              [54.2659377, 29.6004018],
              [54.2460051, 29.6082384],
              [54.2341804, 29.6149907],
              [54.2303717, 29.6177581],
              [54.2261053, 29.6200708],
              [54.2186654, 29.6240518],
              [54.2144918, 29.6272022],
              [54.2069984, 29.6318744],
              [54.1902006, 29.6562768],
              [54.1848791, 29.6674269],
              [54.1814709, 29.6749774],
              [54.178047, 29.6916319],
              [54.1714857, 29.7095774],
              [54.1658542, 29.7229972],
              [54.1560744, 29.7390418],
              [54.1442297, 29.7532008],
              [54.1341017, 29.7630364],
              [54.1294668, 29.7692949],
              [54.1176222, 29.7788309],
              [54.1054342, 29.7856844],
              [54.0973444, 29.7886407],
              [54.0987015, 29.8006565],
              [54.1001558, 29.8113433],
              [54.1013663, 29.8222895],
              [54.101486, 29.8287312],
              [54.1024833, 29.8348695],
              [54.1037169, 29.8496405],
              [54.1040365, 29.8581378],
              [54.1043594, 29.8608835],
              [54.1045849, 29.8629692],
              [54.1054996, 29.8695594],
              [54.1060958, 29.8730033],
              [54.1059241, 29.8771914],
              [54.1071509, 29.882402],
              [54.1101383, 29.8915995],
              [54.1124332, 29.8982025],
              [54.1139672, 29.9071302],
              [54.113414, 29.9172419],
              [54.1156097, 29.9343663],
              [54.1161247, 29.951374],
              [54.117498, 29.968807],
              [54.1092165, 29.976676],
              [54.0958028, 29.9823305],
              [54.077711, 29.988319],
              [54.0574955, 29.9940403],
              [54.0463829, 29.9966819],
              [54.0432188, 29.9967304],
              [54.0362389, 29.9971728],
              [54.0238242, 30.002674],
              [53.9999096, 30.0154584],
              [53.9919484, 30.0222],
              [53.9802302, 30.0317616],
              [53.9744523, 30.035201],
              [53.9687204, 30.0377689],
              [53.9564966, 30.0433455],
              [53.9390569, 30.0529789],
              [53.930383, 30.0591873],
              [53.9298696, 30.0621121],
              [53.9250386, 30.0652301],
              [53.9222901, 30.0695784],
              [53.9160828, 30.0767538],
              [53.9043049, 30.0889645],
              [53.8970842, 30.0969855],
              [53.8930309, 30.1060752],
              [53.887582, 30.1217065],
              [53.8897142, 30.1339738],
              [53.8700802, 30.1662898],
              [53.8705105, 30.1714395],
              [53.9041767, 30.162404],
              [53.9049742, 30.1698955],
              [53.9051768, 30.1891218],
              [53.9133622, 30.1993398],
              [53.9143696, 30.2027922],
              [53.9004017, 30.2026288],
              [53.8893127, 30.2009269],
              [53.8811442, 30.2146892],
              [53.8796138, 30.2252551],
              [53.8997304, 30.2229837],
              [53.9040435, 30.2238568],
              [53.8984813, 30.2316934],
              [53.8998698, 30.2341542],
              [53.9051055, 30.2382326],
              [53.9190915, 30.2225017],
              [53.9219181, 30.2382399],
              [53.9231997, 30.2471378],
              [53.9296345, 30.2706281],
              [53.9330787, 30.2834454],
              [53.936558, 30.2981132],
              [53.9364331, 30.3160072],
              [53.9361941, 30.331721],
              [53.9361912, 30.3474819],
              [53.9365988, 30.3784839],
              [53.9340739, 30.3872274],
              [53.92004, 30.4118182],
              [53.914306, 30.4323899],
              [53.9264741, 30.4868042],
              [53.9215849, 30.4989762],
              [53.9099119, 30.5266315],
              [53.9018668, 30.5437705],
              [53.8968836, 30.5583246],
              [53.887482, 30.5820481],
              [53.8778076, 30.6040636],
              [53.8733531, 30.6117635],
              [53.8616004, 30.6299459],
              [53.8476964, 30.6446677],
              [53.836819, 30.6525237],
              [53.8315486, 30.6563726],
              [53.8071723, 30.669507],
              [53.7838764, 30.6751358],
              [53.7397104, 30.6876354],
              [53.734987, 30.6890253],
              [53.7144308, 30.6934655],
              [53.6638714, 30.7048641],
              [53.6613714, 30.7051349],
              [53.6591515, 30.7056945],
              [53.6577615, 30.7056945],
              [53.6533149, 30.7068046],
              [53.6499816, 30.7073641],
              [53.6330386, 30.7093045],
              [53.6297053, 30.7093045],
              [53.6116488, 30.7115247],
              [53.6083156, 30.7115247],
              [53.6060922, 30.7118045],
              [53.5994257, 30.7118045],
              [53.597479, 30.7120842],
              [53.5922025, 30.7120843],
              [53.5649796, 30.7145842],
              [53.5630362, 30.7145842],
              [53.5619228, 30.714864],
              [53.5533131, 30.7154145],
              [53.5291433, 30.7179145],
              [53.506367, 30.7226346],
              [53.5049771, 30.7226347],
              [53.4969205, 30.7251346],
              [53.4924773, 30.7259739],
              [53.4921972, 30.7262537],
              [53.4905305, 30.7265336],
              [53.4710875, 30.7315245],
              [53.4605311, 30.7368042],
              [53.4585844, 30.7373638],
              [53.4494178, 30.7462446],
              [53.4494178, 30.7465244],
              [53.4487552, 30.7471871],
              [53.4444179, 30.7515245],
              [53.4433079, 30.7540245],
              [53.4327514, 30.7662448],
              [53.4246948, 30.7773641],
              [53.3955286, 30.8120852],
              [53.3880253, 30.8173652],
              [53.3833054, 30.8206957],
              [53.3774721, 30.8254161],
              [53.3635824, 30.8331963],
              [53.2994133, 30.8637484],
              [53.2858002, 30.8701387],
              [53.2799669, 30.8723591],
              [53.2774669, 30.8731985],
              [53.2746868, 30.8745795],
              [53.2735769, 30.8751391],
              [53.2730203, 30.8754189],
              [53.2724669, 30.8756987],
              [53.2638537, 30.880699],
              [53.2624671, 30.882089],
              [53.2530205, 30.8881995],
              [53.247744, 30.8909795],
              [53.2460774, 30.8915301],
              [53.2441307, 30.8926403],
              [53.24368, 30.8929811],
              [53.2430207, 30.8934797],
              [53.2419108, 30.8937505],
              [53.2416308, 30.8940303],
              [53.2407974, 30.8940303],
              [53.2388541, 30.8948607],
              [53.2374641, 30.8948607],
              [53.2269076, 30.8984801],
              [53.225521, 30.8987509],
              [53.2213509, 30.9007005],
              [53.2180176, 30.9018107],
              [53.1474621, 30.9345843],
              [53.1452387, 30.9354238],
              [53.1432921, 30.9365339],
              [53.1427388, 30.9370845],
              [53.1421821, 30.9373644],
              [53.1380154, 30.9387544],
              [53.1371822, 30.9387544],
              [53.1230157, 30.9462552],
              [53.1188491, 30.9487554],
              [53.096626, 30.9615365],
              [53.0957928, 30.9623669],
              [53.081623, 30.9698677],
              [53.0515984, 30.9863858],
              [53.0428962, 30.9887139],
              [53.0333233, 30.9911316],
              [53.0236277, 30.9933287],
              [53.0093356, 30.9943121],
              [52.9965368, 30.9954015],
              [52.9848195, 30.9969758],
              [52.9746639, 30.9984489],
              [52.9534334, 31.0044968],
              [52.9428597, 31.0120171],
              [52.9286069, 31.0307187],
              [52.9254627, 31.0575953],
              [52.924592, 31.0720322],
              [52.9248571, 31.0872694],
              [52.9160618, 31.1118105],
              [52.9118953, 31.1212617],
              [52.8993921, 31.1362644],
              [52.8955055, 31.1401459],
              [52.8952254, 31.1404257],
              [52.8949488, 31.1405657],
              [52.8941155, 31.1415361],
              [52.8927254, 31.1429262],
              [52.8891155, 31.1459773],
              [52.8882822, 31.1462572],
              [52.8877256, 31.1470967],
              [52.8766158, 31.1540384],
              [52.8613359, 31.1584797],
              [52.8568927, 31.1604295],
              [52.855226, 31.1609802],
              [52.8393896, 31.1718126],
              [52.8335564, 31.1790434],
              [52.831613, 31.1865358],
              [52.831613, 31.191257],
              [52.8335564, 31.1956984],
              [52.8502261, 31.2137618],
              [52.8505028, 31.2143124],
              [52.8688358, 31.2237639],
              [52.8755023, 31.2262645],
              [52.8780023, 31.2268151],
              [52.9063386, 31.2309767],
              [52.907172, 31.2312657],
              [52.9085619, 31.2312656],
              [52.9124486, 31.2320961],
              [52.9180051, 31.2326468],
              [52.924395, 31.2337572],
              [52.9288383, 31.2345968],
              [52.9457847, 31.240988],
              [52.9555079, 31.2507104],
              [52.9716178, 31.2770885],
              [52.9746743, 31.2954323],
              [52.9766176, 31.3032049],
              [52.9774509, 31.3076555],
              [52.9777309, 31.3082063],
              [52.9777309, 31.3087569],
              [52.9777309, 31.3107068],
              [52.9780075, 31.3118172],
              [52.9782876, 31.3226504],
              [52.9777308, 31.3254308],
              [52.968841, 31.3618213],
              [52.9682843, 31.3626518],
              [52.9680077, 31.3643219],
              [52.9655077, 31.3695941],
              [52.9627312, 31.3745955],
              [52.9516179, 31.3884892],
              [52.9507846, 31.3898795],
              [52.9346715, 31.4048746],
              [52.9068952, 31.4226505],
              [52.9041152, 31.4237609],
              [52.8896721, 31.4282117],
              [52.8885588, 31.4282117],
              [52.8880055, 31.4284825],
              [52.8874058, 31.4286341],
              [52.8657824, 31.4368243],
              [52.864669, 31.4370951],
              [52.8485593, 31.4476488],
              [52.8457793, 31.4504294],
              [52.8182797, 31.4795988],
              [52.8057766, 31.4871011],
              [52.8016099, 31.4915429],
              [52.8004999, 31.4932131],
              [52.8007765, 31.4943236],
              [52.8010566, 31.4948743],
              [52.8005, 31.4948743],
              [52.7993899, 31.4951542],
              [52.7991099, 31.4948743],
              [52.7977234, 31.4948743],
              [52.79661, 31.4946035],
              [52.7946667, 31.4946035],
              [52.793, 31.4948743],
              [52.7871668, 31.4948743],
              [52.7863335, 31.4951542],
              [52.7843868, 31.4951542],
              [52.7824435, 31.4954341],
              [52.7793869, 31.495434],
              [52.7774436, 31.4957049],
              [52.7621638, 31.4957049],
              [52.7610538, 31.4959938],
              [52.754944, 31.4962646],
              [52.7329975, 31.4984855],
              [52.7304976, 31.4990452],
              [52.7291076, 31.4990453],
              [52.6907715, 31.5029364],
              [52.6866048, 31.5029364],
              [52.6602152, 31.5048773],
              [52.6563253, 31.5048773],
              [52.6260491, 31.5079379],
              [52.6232691, 31.5079379],
              [52.6185491, 31.5084886],
              [52.6154926, 31.5084886],
              [52.6138259, 31.5087685],
              [52.6107693, 31.5087685],
              [52.5963228, 31.509879],
              [52.5866029, 31.5104297],
              [52.5846562, 31.5104296],
              [52.5824364, 31.5107095],
              [52.5796563, 31.5107095],
              [52.5785464, 31.5109894],
              [52.574933, 31.5109894],
              [52.5738231, 31.5112692],
              [52.5596566, 31.5123797],
              [52.4996541, 31.5229336],
              [52.4971541, 31.5234933],
              [52.4965975, 31.5234933],
              [52.4329851, 31.5426601],
              [52.4302051, 31.542931],
              [52.4129819, 31.5454318],
              [52.4107585, 31.5454318],
              [52.4077054, 31.5459915],
              [52.3999255, 31.5468221],
              [52.3977055, 31.5473728],
              [52.3935389, 31.5482125],
              [52.3810357, 31.5515438],
              [52.3729792, 31.5546045],
              [52.345203, 31.5718213],
              [52.3449228, 31.5721012],
              [52.3446462, 31.5723811],
              [52.2474209, 31.6615455],
              [52.2446408, 31.662656],
              [52.2407508, 31.6637665],
              [52.2393643, 31.6637665],
              [52.2374175, 31.6643262],
              [52.2226977, 31.6665473],
              [52.2207512, 31.6665472],
              [52.2199178, 31.6668272],
              [52.2188079, 31.6668272],
              [52.2176945, 31.667107],
              [52.2154746, 31.667107],
              [52.2149179, 31.6673779],
              [52.2140845, 31.6673779],
              [52.213808, 31.6676578],
              [52.2126946, 31.6676578],
              [52.2121413, 31.6679376],
              [52.211028, 31.6679377],
              [52.2088081, 31.6684884],
              [52.2071414, 31.6684884],
              [52.2065848, 31.6687682],
              [52.2051947, 31.6687683],
              [52.2046413, 31.6690481],
              [52.2032233, 31.6692013],
              [52.2020993, 31.6696399],
              [52.2013047, 31.669328],
              [52.2007514, 31.669328],
              [52.1943615, 31.6682175],
              [52.1926948, 31.6682175],
              [52.1918616, 31.6679376],
              [52.1904715, 31.6679376],
              [52.1863049, 31.6673778],
              [52.1463021, 31.6615454],
              [52.1449156, 31.6609947],
              [52.1440822, 31.6609947],
              [52.1426924, 31.6604349],
              [52.1340824, 31.6579341],
              [52.1304691, 31.6565526],
              [52.0782466, 31.6207096],
              [52.0726898, 31.6171074],
              [52.0463004, 31.59571],
              [52.0104641, 31.5504331],
              [52.0096309, 31.5484921],
              [52.0079642, 31.5459912],
              [52.0029644, 31.5362679],
              [51.9987977, 31.525434],
              [51.9882412, 31.5023762],
              [51.9837981, 31.4943231],
              [51.9804646, 31.4890417],
              [51.9387953, 31.4159873],
              [51.9379619, 31.4154276],
              [51.937682, 31.414597],
              [51.9365721, 31.4134866],
              [51.936572, 31.412656],
              [51.9365721, 31.4123762],
              [51.9365721, 31.4120964],
              [51.9362954, 31.4040434],
              [51.9365721, 31.4029331],
              [51.9374053, 31.3970921],
              [51.9382387, 31.3948713],
              [51.9418521, 31.3765358],
              [51.9443519, 31.3548783],
              [51.9451854, 31.3523777],
              [51.9454619, 31.3501479],
              [51.947962, 31.3409848],
              [51.9487952, 31.3359835],
              [51.9535186, 31.316538],
              [51.9535186, 31.314868],
              [51.9551852, 31.3062557],
              [51.9554618, 31.3040439],
              [51.9557386, 31.3023738],
              [51.9562952, 31.3009836],
              [51.9546286, 31.294872],
              [51.9546286, 31.2929311],
              [51.954352, 31.2909812],
              [51.9546286, 31.2904215],
              [51.9546286, 31.2882097],
              [51.9635184, 31.2437588],
              [51.9635185, 31.241818],
              [51.9640751, 31.2379273],
              [51.9646285, 31.2343163],
              [51.9651851, 31.2309762],
              [51.9654619, 31.2284847],
              [51.9657418, 31.2259842],
              [51.9660186, 31.2245939],
              [51.966295, 31.2220934],
              [51.9665752, 31.2204234],
              [51.9682418, 31.2140321],
              [51.9685184, 31.2134814],
              [51.9685184, 31.2132016],
              [51.9685184, 31.2129218],
              [51.9682418, 31.2112607],
              [51.9685184, 31.2109809],
              [51.9679618, 31.1943167],
              [51.956852, 31.1509777],
              [51.9410189, 31.1129202],
              [51.9401857, 31.11181],
              [51.9249058, 31.0829242],
              [51.9218493, 31.0770929],
              [51.9024062, 31.0345865],
              [51.9021263, 31.0343067],
              [51.9012929, 31.0332055],
              [51.9010164, 31.0329256],
              [51.8985163, 31.0273653],
              [51.8976831, 31.0212543],
              [51.897403, 31.0123632],
              [51.8965697, 31.0001234],
              [51.8979597, 30.9918101],
              [51.8979597, 30.9909706],
              [51.8976831, 30.9906999],
              [51.8976831, 30.9901493],
              [51.8976831, 30.9895896],
              [51.8976831, 30.9893098],
              [51.8954596, 30.9854194],
              [51.894903, 30.9840294],
              [51.87296, 30.9445846],
              [51.8724034, 30.9443138],
              [51.8715702, 30.9426439],
              [51.8560136, 30.9265323],
              [51.8499038, 30.9195822],
              [51.8415673, 30.9065305],
              [51.8412905, 30.905971],
              [51.8371241, 30.8984793],
              [51.8354575, 30.8934789],
              [51.8326808, 30.8826388],
              [51.8324007, 30.8759777],
              [51.8415674, 30.8459668],
              [51.8424005, 30.8440353],
              [51.8426807, 30.8423565],
              [51.8562905, 30.8131946],
              [51.8585138, 30.8026347],
              [51.8585137, 30.8004145],
              [51.8579571, 30.8004144],
              [51.8576804, 30.7998548],
              [51.8574039, 30.799584],
              [51.8549038, 30.7951345],
              [51.8465706, 30.7690329],
              [51.8335142, 30.7420832],
              [51.8326809, 30.7404135],
              [51.827401, 30.7334731],
              [51.8164769, 30.7162497],
              [51.8112459, 30.7142277],
              [51.7978906, 30.6933624],
              [51.8065451, 30.6901832],
              [51.8168878, 30.6853959],
              [51.8262022, 30.6809457],
              [51.8343133, 30.6773803],
              [51.8422507, 30.6715815],
              [51.8426388, 30.6642396],
              [51.8466815, 30.6589459],
              [51.8489216, 30.6532311],
              [51.8521241, 30.6459665],
              [51.8535141, 30.6442969],
              [51.854904, 30.6431869],
              [51.8629573, 30.6315269],
              [51.8643472, 30.6265182],
              [51.8693472, 30.6159684],
              [51.8699039, 30.6156887],
              [51.8704605, 30.6148583],
              [51.8804604, 30.6087487],
              [51.8871269, 30.6009695],
              [51.8874036, 30.5998595],
              [51.8882369, 30.5981899],
              [51.8882369, 30.5934701],
              [51.8879603, 30.5931903],
              [51.8879603, 30.59236],
              [51.8879604, 30.5920803],
              [51.8879603, 30.5906905],
              [51.8876835, 30.590131],
              [51.8846271, 30.5843012],
              [51.8779605, 30.5754121],
              [51.8557375, 30.5540243],
              [51.8482375, 30.5412459],
              [51.8454576, 30.5379069],
              [51.8440675, 30.5354161],
              [51.8343479, 30.5212481],
              [51.8343478, 30.5209685],
              [51.8343478, 30.5206887],
              [51.8340678, 30.5201382],
              [51.8335144, 30.519299],
              [51.8335144, 30.5184598],
              [51.8329578, 30.5173588],
              [51.8318478, 30.5120796],
              [51.8312912, 30.5054108],
              [51.8315677, 30.5012417],
              [51.8318478, 30.4984623],
              [51.8321243, 30.4968019],
              [51.8324011, 30.4948527],
              [51.8326812, 30.4937428],
              [51.8335145, 30.4912432],
              [51.8335145, 30.4901332],
              [51.8390677, 30.4773553],
              [51.8396244, 30.4770755],
              [51.8399009, 30.4762453],
              [51.8410144, 30.4751354],
              [51.8410145, 30.4745759],
              [51.8415677, 30.4740164],
              [51.8432344, 30.4695767],
              [51.8429576, 30.4656874],
              [51.8418477, 30.4626283],
              [51.8374012, 30.4537399],
              [51.8315678, 30.4456817],
              [51.8312912, 30.4445717],
              [51.8262914, 30.4368023],
              [51.8262914, 30.4365226],
              [51.8257346, 30.435963],
              [51.8249013, 30.4354036],
              [51.7968452, 30.4109586],
              [51.7815653, 30.3990205],
              [51.7757918, 30.3949112],
              [51.7737579, 30.3904977],
              [51.7726422, 30.387072],
              [51.772579, 30.385835],
              [51.7724275, 30.3828716],
              [51.7752812, 30.3793719],
              [51.7843151, 30.3769109],
              [51.7854308, 30.3746525],
              [51.7829418, 30.3715793],
              [51.7721037, 30.3664878],
              [51.7669772, 30.3649515],
              [51.7618273, 30.362878],
              [51.7508455, 30.3608145],
              [51.6590604, 30.4159666],
              [51.6579503, 30.4162463],
              [51.6576738, 30.4165261],
              [51.6521173, 30.418466],
              [51.6487838, 30.4184662],
              [51.6465605, 30.4187458],
              [51.6454505, 30.4192963],
              [51.6396174, 30.4217957],
              [51.6337808, 30.4267948],
              [51.6332274, 30.4279139],
              [51.6321141, 30.4290147],
              [51.6282275, 30.4376323],
              [51.6273941, 30.4401318],
              [51.6273942, 30.4404026],
              [51.6260042, 30.440962],
              [51.6251709, 30.4412418],
              [51.6193375, 30.4437414],
              [51.6112812, 30.4437413],
              [51.6040578, 30.4412418],
              [51.5837814, 30.4234651],
              [51.5790582, 30.4223552],
              [51.5762782, 30.4223552],
              [51.5746115, 30.4223552],
              [51.5607218, 30.4265151],
              [51.5487786, 30.4317939],
              [51.5348889, 30.4348529],
              [51.5329455, 30.4348529],
              [51.5326654, 30.4351327],
              [51.5290555, 30.4356831],
              [51.528499, 30.4354034],
              [51.5279457, 30.4356832],
              [51.5271124, 30.4356831],
              [51.526279, 30.4354034],
              [51.523499, 30.4354033],
              [51.5229424, 30.4356831],
              [51.522109, 30.4356831],
              [51.5212756, 30.4356831],
              [51.502666, 30.4420719],
              [51.5007194, 30.4431818],
              [51.4840528, 30.45124],
              [51.4832195, 30.4512399],
              [51.4682197, 30.4559684],
              [51.467663, 30.4598274],
              [51.464866, 30.4629125],
              [51.4593549, 30.4649426],
              [51.4501538, 30.4654471],
              [51.4463387, 30.4626566],
              [51.440253, 30.462215],
              [51.431802, 30.463489],
              [51.4275818, 30.4654865],
              [51.4211654, 30.4667634],
              [51.4164595, 30.4672032],
              [51.4117075, 30.4680539],
              [51.4022925, 30.4672563],
              [51.3952792, 30.4670921],
              [51.3917743, 30.4683986],
              [51.3828524, 30.4751034],
              [51.3781109, 30.4807086],
              [51.373954, 30.4851538],
              [51.3680746, 30.4927904],
              [51.3626243, 30.4988179],
              [51.3581397, 30.5031627],
              [51.3547923, 30.5062317],
              [51.353891, 30.5121474],
              [51.3590409, 30.5212238],
              [51.3646413, 30.5283031],
              [51.368375, 30.5344393],
              [51.3718511, 30.5468954],
              [51.3717867, 30.5519217],
              [51.3720501, 30.5547574],
              [51.3662994, 30.5605039],
              [51.3622505, 30.563534],
              [51.358403, 30.5657512],
              [51.3421166, 30.5693355],
              [51.3307115, 30.5731916],
              [51.3298783, 30.5734713],
              [51.3015453, 30.59069],
              [51.296822, 30.5940291],
              [51.2518194, 30.6165183],
              [51.2376529, 30.6306871],
              [51.2359863, 30.6329162],
              [51.2279297, 30.6423561],
              [51.225153, 30.6448559],
              [51.2189854, 30.6487353],
              [51.2163891, 30.6524642],
              [51.2105311, 30.6604384],
              [51.2039222, 30.6679505],
              [51.1992574, 30.6737515],
              [51.1934294, 30.6736349],
              [51.1888862, 30.6661198],
              [51.1877061, 30.6605826],
              [51.184466, 30.656208],
              [51.1805821, 30.6529407],
              [51.1773736, 30.6498557],
              [51.1770937, 30.6493051],
              [51.1618173, 30.6287467],
              [51.1595819, 30.6261167],
              [51.1532304, 30.6179181],
              [51.1427766, 30.6082802],
              [51.1369616, 30.5986025],
              [51.1355668, 30.5955365],
              [51.1395795, 30.5929829],
              [51.143761, 30.5876396],
              [51.1432043, 30.5806907],
              [51.1429277, 30.5640225],
              [51.1623708, 30.5476344],
              [51.1640373, 30.5462446],
              [51.1684839, 30.5401353],
              [51.1687606, 30.5398554],
              [51.1790405, 30.5306869],
              [51.1848737, 30.5129092],
              [51.1870971, 30.5048508],
              [51.2012635, 30.4776344],
              [51.2026501, 30.4762448],
              [51.203207, 30.474855],
              [51.2045969, 30.4734654],
              [51.2143201, 30.4615178],
              [51.2184868, 30.4559682],
              [51.2195967, 30.4542988],
              [51.22043, 30.4537393],
              [51.255433, 30.4159662],
              [51.255433, 30.4156864],
              [51.2892932, 30.3890871],
              [51.2861818, 30.3803872],
              [51.283049, 30.3760555],
              [51.2799377, 30.3759999],
              [51.2732643, 30.3758889],
              [51.2693161, 30.3745189],
              [51.2636809, 30.3734588],
              [51.2564925, 30.3699413],
              [51.2506346, 30.3638318],
              [51.2467078, 30.3564813],
              [51.2459997, 30.3511856],
              [51.243575, 30.3478525],
              [51.2426094, 30.3441305],
              [51.2409188, 30.3415125],
              [51.2382994, 30.3362339],
              [51.2379776, 30.3248808],
              [51.240016, 30.3231397],
              [51.2412391, 30.3218246],
              [51.2804852, 30.2978538],
              [51.2793265, 30.2957602],
              [51.2784253, 30.2915544],
              [51.2720995, 30.2890186],
              [51.2707094, 30.2823507],
              [51.2690428, 30.2795718],
              [51.2679328, 30.2790123],
              [51.2676563, 30.2787416],
              [51.265433, 30.2773521],
              [51.265433, 30.2770724],
              [51.2648763, 30.2770725],
              [51.2645995, 30.2767927],
              [51.2637664, 30.2767927],
              [51.2637663, 30.276513],
              [51.2634896, 30.2762333],
              [51.2632097, 30.2759626],
              [51.2629329, 30.2756829],
              [51.2490432, 30.2640165],
              [51.2387633, 30.2567984],
              [51.2379299, 30.2520705],
              [51.2354301, 30.250681],
              [51.2345967, 30.250681],
              [51.2326535, 30.249851],
              [51.2315435, 30.249851],
              [51.2312634, 30.2495712],
              [51.23043, 30.2495712],
              [51.2301535, 30.2492915],
              [51.2276536, 30.2490208],
              [51.2251536, 30.2481818],
              [51.2184871, 30.2417937],
              [51.2148736, 30.240684],
              [51.2129303, 30.240684],
              [51.2123736, 30.2404042],
              [51.2115405, 30.2404043],
              [51.2115404, 30.2401246],
              [51.2109871, 30.2398539],
              [51.210707, 30.2392945],
              [51.2101539, 30.2390148],
              [51.2082071, 30.2367953],
              [51.2076539, 30.2367952],
              [51.2073737, 30.2365156],
              [51.2062638, 30.2365156],
              [51.2059872, 30.2362359],
              [51.1968173, 30.2354058],
              [51.1948739, 30.2323472],
              [51.1945973, 30.2309577],
              [51.1945974, 30.230678],
              [51.1929307, 30.2273487],
              [51.1923741, 30.227069],
              [51.1912641, 30.2259593],
              [51.189874, 30.2190119],
              [51.1862643, 30.2156827],
              [51.1840409, 30.2109549],
              [51.1836495, 30.2105155],
              [51.1832076, 30.2098453],
              [51.1832077, 30.2092948],
              [51.1820942, 30.2079054],
              [51.1779276, 30.2062363],
              [51.1693178, 30.2120647],
              [51.1626512, 30.2090151],
              [51.1593178, 30.2090152],
              [51.1584846, 30.2092948],
              [51.1551514, 30.2095655],
              [51.1545946, 30.2087355],
              [51.1537613, 30.2084558],
              [51.1532046, 30.2081851],
              [51.1523712, 30.2079054],
              [51.1518181, 30.2079054],
              [51.1509846, 30.2076257],
              [51.1487614, 30.2076257],
              [51.1470948, 30.2106843],
              [51.1473713, 30.2126241],
              [51.1482616, 30.2140891],
              [51.1423714, 30.2156827],
              [51.1320951, 30.2092948],
              [51.1304283, 30.207346],
              [51.131815, 30.2067957],
              [51.1334816, 30.2067956],
              [51.1340383, 30.2065159],
              [51.1351482, 30.2065159],
              [51.1354284, 30.2067957],
              [51.137095, 30.2067956],
              [51.138205, 30.2062362],
              [51.138205, 30.2056858],
              [51.1373716, 30.2040168],
              [51.1368149, 30.2040168],
              [51.1365382, 30.203737],
              [51.1348715, 30.2031867],
              [51.1343149, 30.2026273],
              [51.1345949, 30.2020679],
              [51.134595, 30.2012379],
              [51.1337617, 30.2006785],
              [51.1309816, 30.1992891],
              [51.129315, 30.199289],
              [51.1270917, 30.2009582],
              [51.1215385, 30.2009582],
              [51.1209819, 30.2006785],
              [51.1201484, 30.2006784],
              [51.1182052, 30.1990093],
              [51.1090387, 30.1881826],
              [51.1079253, 30.1881826],
              [51.1076488, 30.1879029],
              [51.1065353, 30.1876232],
              [51.1045921, 30.1876232],
              [51.1040355, 30.1890127],
              [51.1034821, 30.1901224],
              [51.1040354, 30.1970695],
              [51.1004254, 30.1995686],
              [51.0957022, 30.1973492],
              [51.0962589, 30.1962394],
              [51.0965355, 30.1951297],
              [51.0945923, 30.1909525],
              [51.0920922, 30.1909524],
              [51.090149, 30.1915118],
              [51.0884789, 30.1934606],
              [51.0873689, 30.19402],
              [51.0868122, 30.1978996],
              [51.085979, 30.1998483],
              [51.0851456, 30.1995687],
              [51.0820924, 30.1990093],
              [51.0801457, 30.1990093],
              [51.0765359, 30.200128],
              [51.0754259, 30.2003987],
              [51.0662558, 30.2003987],
              [51.0634794, 30.1984589],
              [51.0629225, 30.1973492],
              [51.0623694, 30.1962394],
              [51.062646, 30.1959598],
              [51.0623694, 30.1954003],
              [51.0612559, 30.1915118],
              [51.0576461, 30.1898427],
              [51.0570894, 30.1901223],
              [51.0559795, 30.1901224],
              [51.0557029, 30.190402],
              [51.0532028, 30.189572],
              [51.0529227, 30.1870728],
              [51.0526462, 30.1865134],
              [51.0529228, 30.1848534],
              [51.0532029, 30.1845736],
              [51.0529227, 30.1840144],
              [51.0523695, 30.1817948],
              [51.050423, 30.1806761],
              [51.0501462, 30.1809557],
              [51.0462562, 30.1809558],
              [51.0448661, 30.1823452],
              [51.044313, 30.1823452],
              [51.044313, 30.1826248],
              [51.042923, 30.1826249],
              [51.0426464, 30.1823452],
              [51.041813, 30.1823451],
              [51.0418131, 30.1820655],
              [51.0381997, 30.1795664],
              [51.034313, 30.1792957],
              [51.0326431, 30.1809557],
              [51.0320897, 30.1809557],
              [51.0309765, 30.1773469],
              [51.0304232, 30.1770672],
              [51.0281998, 30.1770672],
              [51.0279233, 30.1773469],
              [51.0270899, 30.1773469],
              [51.0259766, 30.178186],
              [51.0248666, 30.1817948],
              [51.0245899, 30.1826249],
              [51.0234765, 30.1840143],
              [51.0201433, 30.1823452],
              [51.0165335, 30.1795663],
              [51.0154234, 30.1792956],
              [51.01431, 30.1792957],
              [51.0140334, 30.179016],
              [51.0134768, 30.179016],
              [51.0132002, 30.1787363],
              [50.9998532, 30.1734583],
              [50.9987536, 30.1734583],
              [50.9987536, 30.173738],
              [50.9962536, 30.1762372],
              [50.994867, 30.1767965],
              [50.9915304, 30.1767965],
              [50.9903616, 30.1763437],
              [50.989587, 30.176237],
              [50.9806972, 30.1670707],
              [50.9606975, 30.1579042],
              [50.9579209, 30.1567855],
              [50.9559742, 30.1559554],
              [50.9398645, 30.1420616],
              [50.9393078, 30.1417909],
              [50.9390314, 30.1412316],
              [50.9373611, 30.1401218],
              [50.9373611, 30.1398422],
              [50.9370846, 30.1395716],
              [50.9354179, 30.1359537],
              [50.9248614, 30.1151223],
              [50.9245848, 30.1126233],
              [50.9218082, 30.1012288],
              [50.9215281, 30.0937319],
              [50.9218082, 30.0923426],
              [50.9220848, 30.0904029],
              [50.9223616, 30.0898435],
              [50.9223616, 30.0890136],
              [50.9226416, 30.0848456],
              [50.9229182, 30.0840066],
              [50.919585, 30.0662342],
              [50.9159717, 30.0584487],
              [50.9045853, 30.0373388],
              [50.9031953, 30.03484],
              [50.897362, 30.0248444],
              [50.8881954, 30.014849],
              [50.8870821, 30.0145604],
              [50.8745823, 30.0095626],
              [50.8668058, 30.0056746],
              [50.8665257, 30.0051243],
              [50.8626393, 29.9987284],
              [50.8648545, 29.9818216],
              [50.864859, 29.9817871],
              [50.8648591, 29.9812278],
              [50.8604158, 29.9737315],
              [50.8465261, 29.9656759],
              [50.8365264, 29.9631771],
              [50.8354129, 29.9634568],
              [50.8337462, 29.9634567],
              [50.8234698, 29.964846],
              [50.8162465, 29.967065],
              [50.8073567, 29.9715123],
              [50.7951336, 29.9776194],
              [50.7837438, 29.9840151],
              [50.7829103, 29.9842858],
              [50.7612441, 29.9920618],
              [50.7598541, 29.9920618],
              [50.7593007, 29.9923414],
              [50.7581874, 29.9923414],
              [50.7568009, 29.9926211],
              [50.7543008, 29.992621],
              [50.7342977, 29.9909522],
              [50.7329111, 29.9912318],
              [50.7220746, 29.9934509],
              [50.7170748, 29.9948402],
              [50.7137412, 29.9948402],
              [50.7126315, 29.9951198],
              [50.7098513, 29.9951198],
              [50.7090181, 29.9953995],
              [50.7037415, 29.9956701],
              [50.697075, 29.9956701],
              [50.6954085, 29.9959588],
              [50.686795, 29.9959588],
              [50.6865185, 29.9956701],
              [50.6837419, 29.9945605],
              [50.6834618, 29.9940102],
              [50.6787419, 29.9898425],
              [50.6781852, 29.9892832],
              [50.6670721, 29.9767893],
              [50.6609622, 29.9792881],
              [50.660129, 29.9801179],
              [50.6559622, 29.9778989],
              [50.6545723, 29.9767893],
              [50.6515156, 29.9773396],
              [50.6498491, 29.9773395],
              [50.6479057, 29.9778989],
              [50.6459624, 29.9787288],
              [50.6429056, 29.9770599],
              [50.637906, 29.971512],
              [50.6365157, 29.9709528],
              [50.635959, 29.9712325],
              [50.6337395, 29.9712324],
              [50.6304058, 29.9704025],
              [50.6273495, 29.9659552],
              [50.6259592, 29.9645661],
              [50.6254062, 29.9648456],
              [50.6245729, 29.9648457],
              [50.6242928, 29.9651254],
              [50.6234592, 29.9648457],
              [50.6229062, 29.9642864],
              [50.622626, 29.9640067],
              [50.6220728, 29.9631769],
              [50.6223495, 29.962338],
              [50.622626, 29.9620674],
              [50.6223495, 29.9606781],
              [50.6217928, 29.9603984],
              [50.6215162, 29.9598392],
              [50.6201259, 29.9598392],
              [50.6187396, 29.9603984],
              [50.6173493, 29.9603985],
              [50.6167927, 29.9601188],
              [50.6159594, 29.9601188],
              [50.6151262, 29.9573404],
              [50.614293, 29.9576201],
              [50.6126263, 29.9573404],
              [50.6112364, 29.954562],
              [50.609293, 29.952343],
              [50.6031831, 29.9437282]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 269575,
        "tags": {
          "ISO3166-2": "IR-18",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "بوشهر",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q132945"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [49.5801433, 29.6674426],
              [49.7102571, 29.5300835],
              [49.8426242, 29.3901539],
              [50.0519489, 29.1684767],
              [50.1313982, 29.0842133],
              [50.2857055, 28.9015164],
              [50.3840847, 28.7848692],
              [50.5881313, 28.542517],
              [50.7017919, 28.4072764],
              [50.9440729, 28.0718545],
              [50.991349, 28.0120123],
              [51.2423375, 27.7184419],
              [51.2785047, 27.6908719],
              [51.3144248, 27.6622615],
              [51.5230274, 27.523409],
              [51.7123616, 27.431492],
              [51.8420008, 27.3720446],
              [51.8705058, 27.3550408],
              [52.0618571, 27.2408284],
              [52.1150457, 27.2090607],
              [52.242959, 27.1326254],
              [52.482398, 26.989407],
              [52.7379214, 27.2743065],
              [52.7899507, 27.311903],
              [52.7921389, 27.3117624],
              [52.8067069, 27.326112],
              [52.8108037, 27.327995],
              [52.8325609, 27.3224233],
              [52.8387145, 27.3217517],
              [52.8420457, 27.3173905],
              [52.8676735, 27.3060588],
              [52.8679501, 27.3066163],
              [52.9006112, 27.3183472],
              [52.9120874, 27.3412746],
              [52.91316, 27.3669656],
              [52.9134056, 27.3734652],
              [52.9126668, 27.374435],
              [52.9054355, 27.382133],
              [52.8981399, 27.3910497],
              [52.889471, 27.4008801],
              [52.8823067, 27.4071859],
              [52.8701614, 27.419808],
              [52.828282, 27.4420163],
              [52.8173123, 27.4485982],
              [52.8088355, 27.453683],
              [52.8088355, 27.4539619],
              [52.8007789, 27.4600696],
              [52.7988356, 27.4614549],
              [52.7888358, 27.4678506],
              [52.7757793, 27.4809031],
              [52.7746694, 27.483125],
              [52.768556, 27.4895119],
              [52.7680169, 27.4903309],
              [52.7579997, 27.500064],
              [52.7549464, 27.502295],
              [52.7546663, 27.5028527],
              [52.7460565, 27.5072967],
              [52.7452231, 27.5072966],
              [52.7423467, 27.5084734],
              [52.7391098, 27.5097975],
              [52.73689, 27.5106251],
              [52.7368899, 27.510904],
              [52.6879974, 27.536741],
              [52.6877207, 27.5370109],
              [52.6874407, 27.5372898],
              [52.687164, 27.5372898],
              [52.6854974, 27.5386842],
              [52.6668843, 27.5484093],
              [52.6602178, 27.551738],
              [52.647718, 27.5575678],
              [52.6407748, 27.5595111],
              [52.6404947, 27.55979],
              [52.6371615, 27.55979],
              [52.6366048, 27.5600688],
              [52.6354949, 27.5600689],
              [52.6346616, 27.5603478],
              [52.6335516, 27.5603478],
              [52.6329949, 27.5606266],
              [52.6318849, 27.5606266],
              [52.6299382, 27.5611845],
              [52.6291049, 27.5611844],
              [52.6238284, 27.5634067],
              [52.613358, 27.5719474],
              [52.6027152, 27.5806265],
              [52.601882, 27.5817421],
              [52.5974387, 27.5864565],
              [52.5635492, 27.6242449],
              [52.5632693, 27.6245148],
              [52.5510461, 27.6486824],
              [52.5510461, 27.6489614],
              [52.5507695, 27.6492403],
              [52.5507694, 27.6495192],
              [52.5485461, 27.6536852],
              [52.5427129, 27.6631241],
              [52.5418795, 27.6650767],
              [52.5418795, 27.6653555],
              [52.541603, 27.6656255],
              [52.541603, 27.6659045],
              [52.541603, 27.6661834],
              [52.5410462, 27.6670202],
              [52.5407696, 27.667848],
              [52.5407697, 27.6689638],
              [52.5277132, 27.704795],
              [52.5277132, 27.7053529],
              [52.5271564, 27.7059019],
              [52.5271564, 27.7064597],
              [52.5266032, 27.7072966],
              [52.5135467, 27.732574],
              [52.51049, 27.7420138],
              [52.5099334, 27.7439667],
              [52.5096273, 27.7465781],
              [52.5093801, 27.7475752],
              [52.5088233, 27.7520208],
              [52.5085467, 27.7572943],
              [52.5082667, 27.7625769],
              [52.5066001, 27.7756349],
              [52.5016002, 27.7861823],
              [52.5016001, 27.7864703],
              [52.5010434, 27.7872983],
              [52.486877, 27.8095185],
              [52.4640974, 27.8373016],
              [52.4585441, 27.8461849],
              [52.4582641, 27.8464638],
              [52.4579875, 27.8470219],
              [52.4552108, 27.8550773],
              [52.4552109, 27.8561842],
              [52.4499309, 27.8717462],
              [52.4496543, 27.8720252],
              [52.4429876, 27.8839692],
              [52.442431, 27.8850763],
              [52.4415976, 27.8859133],
              [52.4365978, 27.8950762],
              [52.4363211, 27.8956342],
              [52.4271512, 27.9122951],
              [52.4071515, 27.9403521],
              [52.4067187, 27.940786],
              [52.4029849, 27.9470223],
              [52.4027083, 27.9473013],
              [52.4015949, 27.9484086],
              [52.3932617, 27.9684102],
              [52.3918717, 27.9753597],
              [52.391595, 27.9775832],
              [52.3913184, 27.9792485],
              [52.3910383, 27.9809139],
              [52.3904851, 27.9839746],
              [52.390205, 27.9856309],
              [52.3899284, 27.9873053],
              [52.3896518, 27.9881334],
              [52.3893717, 27.9892497],
              [52.3879852, 27.9931387],
              [52.3875574, 27.993546],
              [52.3821519, 27.998693],
              [52.3802053, 28.0014746],
              [52.3782619, 28.0036892],
              [52.3774286, 28.0042473],
              [52.3760385, 28.0059127],
              [52.3685388, 28.0123043],
              [52.3646488, 28.014807],
              [52.3640954, 28.014807],
              [52.3632622, 28.0150771],
              [52.3393726, 28.022306],
              [52.3352024, 28.0231343],
              [52.3332592, 28.0231342],
              [52.3107597, 28.0270233],
              [52.3093696, 28.0270233],
              [52.3054797, 28.0278606],
              [52.3043697, 28.0278605],
              [52.3027031, 28.0284187],
              [52.3015932, 28.0284187],
              [52.2954799, 28.0300841],
              [52.2940899, 28.0303542],
              [52.2835367, 28.0350806],
              [52.2785369, 28.0373042],
              [52.2652003, 28.0442452],
              [52.2340874, 28.0725865],
              [52.233254, 28.0734146],
              [52.2299207, 28.0798068],
              [52.2207542, 28.0911869],
              [52.2204775, 28.0917541],
              [52.2174211, 28.0953554],
              [52.199088, 28.1114715],
              [52.1790848, 28.1234193],
              [52.1707517, 28.130082],
              [52.1601953, 28.1436958],
              [52.1590853, 28.1448032],
              [52.1582518, 28.1456406],
              [52.1435287, 28.1700776],
              [52.1414772, 28.1741821],
              [52.1413055, 28.1745258],
              [52.1413055, 28.1748048],
              [52.1254724, 28.1995309],
              [52.1218624, 28.2111919],
              [52.1215824, 28.2134161],
              [52.1213057, 28.2203587],
              [52.1215824, 28.2239696],
              [52.1218625, 28.2289763],
              [52.1235291, 28.258702],
              [52.1232489, 28.2598096],
              [52.1229722, 28.2623041],
              [52.1126959, 28.2945346],
              [52.1121392, 28.2950839],
              [52.1113058, 28.2973083],
              [52.1060258, 28.3064761],
              [52.1040826, 28.3106458],
              [52.0971393, 28.324812],
              [52.0808427, 28.3638461],
              [52.0590798, 28.4159215],
              [52.0560266, 28.4225867],
              [52.0558232, 28.4230686],
              [52.0540799, 28.4284232],
              [52.0540799, 28.4295311],
              [52.0540799, 28.4298104],
              [52.0513032, 28.4409252],
              [52.0510231, 28.4417539],
              [52.0501899, 28.4464737],
              [52.0496366, 28.4500856],
              [52.04908, 28.4539769],
              [52.0485233, 28.4575888],
              [52.04797, 28.4609215],
              [52.0438035, 28.4867553],
              [52.03797, 28.5173101],
              [52.0374134, 28.5214809],
              [52.03658, 28.528147],
              [52.0363035, 28.5292549],
              [52.0360234, 28.5312007],
              [52.0354701, 28.5411999],
              [52.0210236, 28.5989812],
              [52.0207469, 28.6014767],
              [52.0201902, 28.6031524],
              [52.0199137, 28.6056479],
              [52.0135237, 28.6309275],
              [52.0113004, 28.6348195],
              [52.0107438, 28.6350987],
              [52.010467, 28.6362069],
              [52.0101904, 28.6370358],
              [52.0096338, 28.6381439],
              [52.009357, 28.6389818],
              [52.009357, 28.6392611],
              [52.0074105, 28.6459281],
              [52.0071337, 28.6464776],
              [52.0010239, 28.6651003],
              [52.0010239, 28.6659291],
              [51.9993572, 28.6698123],
              [51.9990771, 28.6714792],
              [51.9974104, 28.6759299],
              [51.9935205, 28.6889851],
              [51.993244, 28.6903727],
              [51.9932439, 28.6909312],
              [51.993244, 28.6912015],
              [51.9929672, 28.6917601],
              [51.9929672, 28.6920395],
              [51.9929672, 28.69704],
              [51.9926871, 28.6975896],
              [51.9810206, 28.7439831],
              [51.9807441, 28.7445416],
              [51.9807442, 28.7456499],
              [51.9788007, 28.7570392],
              [51.9743541, 28.7795388],
              [51.9709425, 28.7897765],
              [51.9604644, 28.8212057],
              [51.9590776, 28.8234315],
              [51.9443545, 28.8381469],
              [51.9432412, 28.8392643],
              [51.9321314, 28.8520425],
              [51.9235182, 28.8645415],
              [51.906575, 28.8959295],
              [51.8962952, 28.9223168],
              [51.8962952, 28.9225961],
              [51.8960186, 28.923155],
              [51.8951852, 28.9253719],
              [51.8951852, 28.9264894],
              [51.8887952, 28.9450998],
              [51.8882386, 28.945929],
              [51.887962, 28.9473169],
              [51.8768487, 28.9617639],
              [51.8648306, 28.9759208],
              [51.8146704, 29.0238477],
              [51.79304, 29.0421466],
              [51.7946233, 29.046765],
              [51.7949032, 29.0473239],
              [51.7987117, 29.0606513],
              [51.8013607, 29.0653872],
              [51.80462, 29.0720075],
              [51.8093656, 29.0797703],
              [51.8140504, 29.0874596],
              [51.817156, 29.0906805],
              [51.8117356, 29.0962112],
              [51.8078013, 29.1003362],
              [51.8016333, 29.1065415],
              [51.7908628, 29.1178485],
              [51.7806936, 29.1272821],
              [51.7677718, 29.1417916],
              [51.7559354, 29.1532336],
              [51.7425094, 29.1675985],
              [51.7365288, 29.1730751],
              [51.7267236, 29.1820903],
              [51.7216608, 29.1865195],
              [51.718923, 29.1890381],
              [51.7117194, 29.1962733],
              [51.7052436, 29.2034832],
              [51.7045783, 29.2076905],
              [51.6812797, 29.2302746],
              [51.677118, 29.230943],
              [51.6765648, 29.2312135],
              [51.6760081, 29.2323223],
              [51.6740614, 29.2342696],
              [51.6668417, 29.2451057],
              [51.6660082, 29.2459351],
              [51.6654517, 29.247044],
              [51.6629516, 29.250659],
              [51.635172, 29.2887219],
              [51.6348954, 29.2895514],
              [51.6337821, 29.2906602],
              [51.6335053, 29.2914987],
              [51.6326721, 29.2923281],
              [51.6221155, 29.3126042],
              [51.6218389, 29.3137222],
              [51.6207289, 29.3173286],
              [51.5926692, 29.3826047],
              [51.5926692, 29.3828842],
              [51.5921288, 29.3834844],
              [51.5901693, 29.3856613],
              [51.5885026, 29.3889973],
              [51.5871159, 29.3912154],
              [51.587116, 29.3914949],
              [51.5865592, 29.3914949],
              [51.5860026, 29.3920538],
              [51.5826694, 29.3931629],
              [51.5810026, 29.3931629],
              [51.5810028, 29.3934424],
              [51.5796126, 29.3934424],
              [51.5793361, 29.3937219],
              [51.5776694, 29.3937219],
              [51.5771129, 29.3934424],
              [51.5746128, 29.3951104],
              [51.5746128, 29.3956694],
              [51.5743362, 29.3959399],
              [51.5718361, 29.400385],
              [51.5698929, 29.400385],
              [51.5696128, 29.4006645],
              [51.5687796, 29.4006645],
              [51.567113, 29.4042711],
              [51.5665597, 29.4045506],
              [51.5662796, 29.4051097],
              [51.5601697, 29.4084458],
              [51.559613, 29.4089957],
              [51.557113, 29.4098343],
              [51.5557232, 29.4101048],
              [51.5546131, 29.4109433],
              [51.5535031, 29.4117729],
              [51.5518365, 29.4142705],
              [51.5529465, 29.4212223],
              [51.5526697, 29.4217723],
              [51.5523899, 29.4242699],
              [51.5515564, 29.425388],
              [51.53989, 29.4339989],
              [51.5315568, 29.4381647],
              [51.5304468, 29.4381647],
              [51.52989, 29.4384442],
              [51.5240569, 29.4384442],
              [51.5237768, 29.4387237],
              [51.5226669, 29.4387237],
              [51.5221101, 29.4390032],
              [51.5210002, 29.4390032],
              [51.5193335, 29.4398328],
              [51.5179435, 29.4409418],
              [51.5179435, 29.4420509],
              [51.5176669, 29.4423304],
              [51.5173904, 29.4451076],
              [51.5171103, 29.4462258],
              [51.5118337, 29.4512211],
              [51.5085004, 29.4528891],
              [51.5076671, 29.4528892],
              [51.5073904, 29.4531687],
              [51.5054438, 29.4531687],
              [51.5051671, 29.4528891],
              [51.5043339, 29.4528891],
              [51.5037772, 29.4526096],
              [51.5023871, 29.4526097],
              [51.490444, 29.4487233],
              [51.4898873, 29.4484439],
              [51.4896108, 29.4487234],
              [51.4885008, 29.4487233],
              [51.4846109, 29.4506619],
              [51.4834974, 29.4537187],
              [51.4832209, 29.4545573],
              [51.4832208, 29.4548278],
              [51.4832208, 29.4559458],
              [51.4857206, 29.4601117],
              [51.4859974, 29.4612208],
              [51.4846109, 29.4623299],
              [51.484054, 29.4626094],
              [51.4823873, 29.4626094],
              [51.4812775, 29.4617798],
              [51.4793309, 29.4617798],
              [51.4787775, 29.4615004],
              [51.4776642, 29.4615003],
              [51.4746108, 29.462889],
              [51.4746109, 29.4626094],
              [51.4698878, 29.4626094],
              [51.4662745, 29.4617798],
              [51.4657211, 29.4617799],
              [51.464331, 29.4617798],
              [51.4598878, 29.4617798],
              [51.4593311, 29.4615003],
              [51.4584979, 29.4615003],
              [51.4573879, 29.4620503],
              [51.4543313, 29.4656662],
              [51.4529411, 29.4662252],
              [51.4521079, 29.4662252],
              [51.4515546, 29.4664957],
              [51.4498879, 29.4662252],
              [51.4482214, 29.4656662],
              [51.4471081, 29.4656661],
              [51.4459981, 29.4664957],
              [51.4443315, 29.4690025],
              [51.4440514, 29.4695525],
              [51.4443314, 29.4706616],
              [51.4421081, 29.4739979],
              [51.4379415, 29.4739979],
              [51.4373848, 29.4737184],
              [51.4362748, 29.4739979],
              [51.4359983, 29.4737184],
              [51.4334982, 29.4737183],
              [51.4276615, 29.475107],
              [51.4226617, 29.4734388],
              [51.4123851, 29.4626093],
              [51.4087719, 29.4617798],
              [51.4079385, 29.4620503],
              [51.4068286, 29.4628889],
              [51.4040519, 29.463998],
              [51.4018287, 29.463998],
              [51.4012721, 29.4642775],
              [51.4009953, 29.4639979],
              [51.4004387, 29.4642775],
              [51.3979386, 29.4642775],
              [51.3973855, 29.463998],
              [51.396272, 29.4639979],
              [51.3959954, 29.4637184],
              [51.3948854, 29.4637185],
              [51.3915489, 29.4615003],
              [51.3898822, 29.4615002],
              [51.3851622, 29.4642775],
              [51.3826624, 29.4690024],
              [51.3815488, 29.470941],
              [51.379329, 29.4717796],
              [51.3768291, 29.4717796],
              [51.3759958, 29.4715001],
              [51.375439, 29.4715001],
              [51.3687724, 29.464557],
              [51.3676592, 29.4639979],
              [51.3668258, 29.463998],
              [51.365716, 29.4634388],
              [51.364606, 29.4634389],
              [51.3519992, 29.4734668],
              [51.3307129, 29.490391],
              [51.3304364, 29.490941],
              [51.3298797, 29.490941],
              [51.329603, 29.4915],
              [51.3276597, 29.4926092],
              [51.3273797, 29.4928887],
              [51.3265465, 29.4931682],
              [51.3209933, 29.4976138],
              [51.3043233, 29.5178848],
              [51.3029369, 29.5198325],
              [51.2979369, 29.5301125],
              [51.2973801, 29.5306625],
              [51.2784904, 29.5826138],
              [51.2782137, 29.5840025],
              [51.277657, 29.5873392],
              [51.277657, 29.5876097],
              [51.2773769, 29.5881688],
              [51.273085, 29.5994327],
              [51.2724124, 29.6011977],
              [51.2707103, 29.6056639],
              [51.2704337, 29.6073322],
              [51.2701572, 29.6081709],
              [51.2698771, 29.6098303],
              [51.2704338, 29.6148353],
              [51.2740436, 29.6259458],
              [51.2848803, 29.641782],
              [51.2873802, 29.6448303],
              [51.2965467, 29.6584482],
              [51.2996034, 29.6784425],
              [51.2993233, 29.6790017],
              [51.2979367, 29.6845571],
              [51.2979367, 29.6851163],
              [51.2973798, 29.6856665],
              [51.2970999, 29.6865052],
              [51.2880716, 29.6941233],
              [51.2873801, 29.6948386],
              [51.2868234, 29.6951092],
              [51.2865468, 29.6953978],
              [51.2782135, 29.7006648],
              [51.262377, 29.7073387],
              [51.2507107, 29.7092777],
              [51.2504339, 29.7095573],
              [51.2490441, 29.7095574],
              [51.2487673, 29.7098369],
              [51.2473773, 29.7098369],
              [51.2468206, 29.7101165],
              [51.2451538, 29.7101165],
              [51.2446008, 29.7103961],
              [51.2437673, 29.7103961],
              [51.2409874, 29.7106757],
              [51.2345975, 29.7109463],
              [51.2340441, 29.7112259],
              [51.2279309, 29.7112258],
              [51.2268209, 29.7109462],
              [51.2240444, 29.7109462],
              [51.2234876, 29.7112258],
              [51.2168212, 29.7112258],
              [51.2159877, 29.7115054],
              [51.2120978, 29.7115053],
              [51.2051545, 29.7120555],
              [51.2037647, 29.7123352],
              [51.1998748, 29.7123351],
              [51.1984847, 29.7126147],
              [51.1895982, 29.7126147],
              [51.1773749, 29.713724],
              [51.1743184, 29.7142832],
              [51.1726518, 29.7142832],
              [51.1654284, 29.7165018],
              [51.1623719, 29.7176111],
              [51.1137592, 29.7409435],
              [51.0937595, 29.7498364],
              [51.0901496, 29.7509457],
              [51.0512567, 29.7709506],
              [51.0398668, 29.7742787],
              [51.0395904, 29.7745583],
              [51.0387569, 29.7745583],
              [51.0382003, 29.7745583],
              [51.0376469, 29.7748379],
              [51.034867, 29.7756676],
              [51.0345904, 29.7759472],
              [51.033757, 29.7759473],
              [51.0332004, 29.7762268],
              [51.0318103, 29.7762269],
              [51.0315337, 29.7765065],
              [51.0257004, 29.7765065],
              [51.0226439, 29.776777],
              [51.0195905, 29.7773362],
              [51.0190339, 29.7776159],
              [51.0182006, 29.7776158],
              [51.0179239, 29.7778954],
              [51.0173673, 29.7778954],
              [50.9998675, 29.7828922],
              [50.9712547, 29.7820624],
              [50.9684745, 29.7820623],
              [50.9673646, 29.7817827],
              [50.9618081, 29.7817827],
              [50.9476415, 29.780953],
              [50.9451417, 29.7806734],
              [50.9362517, 29.7806733],
              [50.9345851, 29.7803937],
              [50.9318085, 29.7803937],
              [50.9301418, 29.7801141],
              [50.9273619, 29.7801141],
              [50.872916, 29.7745581],
              [50.8590263, 29.7745581],
              [50.8579163, 29.7742785],
              [50.852083, 29.7742785],
              [50.8476364, 29.7740079],
              [50.8443032, 29.7734487],
              [50.8373599, 29.7734487],
              [50.8365267, 29.7737283],
              [50.83458, 29.7737282],
              [50.8276367, 29.7751173],
              [50.8268299, 29.7754366],
              [50.8262468, 29.7756675],
              [50.8256935, 29.7759471],
              [50.8226368, 29.775947],
              [50.82069, 29.7753968],
              [50.8201369, 29.7756675],
              [50.8195803, 29.7753969],
              [50.8184704, 29.7756674],
              [50.8154136, 29.7753968],
              [50.8018005, 29.780114],
              [50.8006905, 29.780114],
              [50.8001338, 29.7803936],
              [50.7987471, 29.7803936],
              [50.7981904, 29.7806732],
              [50.7912473, 29.7806732],
              [50.787914, 29.7812234],
              [50.7829107, 29.7817826],
              [50.7804109, 29.7817826],
              [50.7790241, 29.7820621],
              [50.7751342, 29.7820621],
              [50.7737441, 29.7817825],
              [50.7654109, 29.7817825],
              [50.7526345, 29.7828919],
              [50.7512444, 29.7831715],
              [50.7484645, 29.7831715],
              [50.7456879, 29.7834511],
              [50.7323549, 29.7865087],
              [50.7304081, 29.7873385],
              [50.7037418, 29.7915055],
              [50.6684622, 29.8048364],
              [50.6656856, 29.8056752],
              [50.6476295, 29.817058],
              [50.6448493, 29.822064],
              [50.6440161, 29.8253923],
              [50.644016, 29.827061],
              [50.6445727, 29.8287296],
              [50.6515158, 29.8345655],
              [50.654296, 29.8353953],
              [50.6559624, 29.8353952],
              [50.6565191, 29.8356749],
              [50.6601292, 29.8356749],
              [50.6606859, 29.8362251],
              [50.6606859, 29.8370639],
              [50.6604059, 29.8373435],
              [50.661239, 29.8390032],
              [50.6620722, 29.8390032],
              [50.6626289, 29.8387236],
              [50.6634624, 29.8387235],
              [50.6642957, 29.8381734],
              [50.6656856, 29.8381734],
              [50.6665192, 29.8387236],
              [50.6659622, 29.8392828],
              [50.6651289, 29.8392828],
              [50.6645723, 29.8398421],
              [50.6648523, 29.8415017],
              [50.6670723, 29.8412311],
              [50.667629, 29.8415017],
              [50.6681856, 29.8440093],
              [50.6670723, 29.8445595],
              [50.6659622, 29.8456779],
              [50.6654055, 29.8459485],
              [50.6656856, 29.847067],
              [50.6681856, 29.8473376],
              [50.6690189, 29.8470671],
              [50.6706857, 29.8484561],
              [50.6709623, 29.8503953],
              [50.6704055, 29.8523437],
              [50.6690188, 29.8542829],
              [50.6695723, 29.8548422],
              [50.6715189, 29.8548422],
              [50.672072, 29.8545626],
              [50.6729056, 29.8545626],
              [50.6731857, 29.8548422],
              [50.6740189, 29.8548422],
              [50.6754088, 29.8562313],
              [50.6751287, 29.8565109],
              [50.6748521, 29.8573408],
              [50.6745756, 29.8584502],
              [50.6742955, 29.8606691],
              [50.6751287, 29.8628971],
              [50.6759623, 29.8631767],
              [50.6790186, 29.8617876],
              [50.6798522, 29.8609488],
              [50.6804088, 29.8606692],
              [50.680962, 29.8617877],
              [50.6815187, 29.8640066],
              [50.682909, 29.8656753],
              [50.6837421, 29.865116],
              [50.6842952, 29.8651161],
              [50.6848518, 29.8645658],
              [50.6837422, 29.8606692],
              [50.6851284, 29.8592801],
              [50.6873519, 29.8592801],
              [50.689852, 29.8623379],
              [50.6940185, 29.8612284],
              [50.6945752, 29.8615081],
              [50.6954087, 29.8615081],
              [50.700685, 29.8667848],
              [50.7034651, 29.8667848],
              [50.7034651, 29.8665051],
              [50.7045749, 29.8659549],
              [50.7056851, 29.8653957],
              [50.7062417, 29.8648365],
              [50.7087418, 29.8648364],
              [50.7126317, 29.8662255],
              [50.7137415, 29.873171],
              [50.7134649, 29.8734507],
              [50.696242, 29.8876123],
              [50.6801288, 29.8976157],
              [50.6604057, 29.9148446],
              [50.6601292, 29.9151152],
              [50.6581858, 29.9173433],
              [50.6573525, 29.9190031],
              [50.6548489, 29.9237298],
              [50.6481823, 29.9328946],
              [50.6456824, 29.9354023],
              [50.642349, 29.9373417],
              [50.6342927, 29.9392902],
              [50.6306829, 29.9392902],
              [50.6287395, 29.9395608],
              [50.6279063, 29.9398404],
              [50.6267929, 29.9398404],
              [50.6259593, 29.94012],
              [50.6248495, 29.94012],
              [50.6142931, 29.9434486],
              [50.611793, 29.9434486],
              [50.6112364, 29.9437283],
              [50.6090164, 29.9437282],
              [50.6084598, 29.9440079],
              [50.605403, 29.9440079],
              [50.6045699, 29.9437282],
              [50.6031831, 29.9437282],
              [50.602903, 29.9434486],
              [50.6026265, 29.9420685],
              [50.5851269, 29.9292863],
              [50.5792901, 29.9262284],
              [50.5781803, 29.9253984],
              [50.5762369, 29.9248392],
              [50.5754037, 29.9248392],
              [50.5748467, 29.9245596],
              [50.5737369, 29.9245595],
              [50.569847, 29.9270582],
              [50.5687368, 29.9281767],
              [50.5629039, 29.934013],
              [50.5556802, 29.9478957],
              [50.5554006, 29.9490142],
              [50.539844, 29.9659551],
              [50.5392905, 29.966785],
              [50.5387338, 29.9670647],
              [50.5356775, 29.9726215],
              [50.5342908, 29.9762298],
              [50.5340107, 29.9790083],
              [50.535124, 29.9917909],
              [50.5348204, 29.992891],
              [50.5326239, 30.0017862],
              [50.5323438, 30.0031753],
              [50.5320673, 30.0040143],
              [50.5298441, 30.0098419],
              [50.5290105, 30.0120611],
              [50.5284574, 30.01456],
              [50.5284574, 30.0153989],
              [50.5281773, 30.0173475],
              [50.5279008, 30.0181774],
              [50.5276242, 30.0203966],
              [50.5392903, 30.0731804],
              [50.5426235, 30.0823462],
              [50.5448471, 30.0856752],
              [50.5476236, 30.0890131],
              [50.5481803, 30.0898431],
              [50.5573468, 30.0959598],
              [50.5587336, 30.0970694],
              [50.5595668, 30.0973401],
              [50.5604001, 30.0981791],
              [50.5626235, 30.0992888],
              [50.5748464, 30.1126229],
              [50.5754034, 30.1137325],
              [50.5767897, 30.1245677],
              [50.5770698, 30.1253977],
              [50.5767897, 30.1259571],
              [50.5765131, 30.1273465],
              [50.5762366, 30.1281765],
              [50.5754033, 30.1306755],
              [50.5745697, 30.1328949],
              [50.5717901, 30.137902],
              [50.5654032, 30.1440098],
              [50.5612367, 30.1462292],
              [50.560476, 30.1467128],
              [50.5353206, 30.1531104],
              [50.5148699, 30.1616618],
              [50.5138933, 30.1660606],
              [50.5090712, 30.166158],
              [50.5044213, 30.1661179],
              [50.5030833, 30.1660572],
              [50.5003508, 30.1659333],
              [50.4836769, 30.1662094],
              [50.4768295, 30.1670373],
              [50.4731942, 30.1675214],
              [50.4693565, 30.1684692],
              [50.4628793, 30.1695686],
              [50.4561959, 30.1711339],
              [50.4483032, 30.1731223],
              [50.4422037, 30.1747299],
              [50.4367293, 30.1760579],
              [50.4302521, 30.1775753],
              [50.4229433, 30.1800701],
              [50.4165763, 30.1821897],
              [50.406063, 30.1867854],
              [50.3987811, 30.1902193],
              [50.3970222, 30.1910487],
              [50.3882902, 30.1950804],
              [50.3799286, 30.1990636],
              [50.3698731, 30.2035705],
              [50.3648186, 30.2059172],
              [50.3578606, 30.2086492],
              [50.3511657, 30.2113776],
              [50.3482169, 30.2126466],
              [50.3400917, 30.2156177],
              [50.330967, 30.2190615],
              [50.3239478, 30.2217507],
              [50.3186148, 30.2236858],
              [50.3110696, 30.2277207],
              [50.291855, 30.2374928],
              [50.2835046, 30.2417247],
              [50.2758979, 30.2460888],
              [50.2695071, 30.2499607],
              [50.2641181, 30.253707],
              [50.2602425, 30.2566292],
              [50.2564697, 30.2593669],
              [50.252697, 30.262664],
              [50.2500241, 30.2642369],
              [50.2473028, 30.26495],
              [50.2429276, 30.2664701],
              [50.2393989, 30.2679544],
              [50.2354966, 30.269662],
              [50.231804, 30.2714226],
              [50.2270583, 30.2740025],
              [50.2215194, 30.2773581],
              [50.2162398, 30.2809046],
              [50.2117995, 30.2839979],
              [50.2074127, 30.2876035],
              [50.2033959, 30.2912112],
              [50.2024806, 30.2921888],
              [50.2006949, 30.2940959],
              [50.2000071, 30.2949624],
              [50.1992722, 30.2931058],
              [50.1988062, 30.292025],
              [50.1978716, 30.2898572],
              [50.1975481, 30.2891068],
              [50.1951446, 30.283477],
              [50.1934164, 30.2796154],
              [50.1890869, 30.2689158],
              [50.1864356, 30.2609674],
              [50.1846658, 30.2561332],
              [50.1828957, 30.2512019],
              [50.1825508, 30.2501372],
              [50.1814574, 30.2464171],
              [50.1805687, 30.2431427],
              [50.1793595, 30.2397782],
              [50.177616, 30.2357698],
              [50.1759261, 30.2318992],
              [50.1743433, 30.2281669],
              [50.1732026, 30.2258158],
              [50.1718979, 30.2229109],
              [50.1701622, 30.2193174],
              [50.1688117, 30.2169221],
              [50.1659927, 30.2113026],
              [50.1634027, 30.2066952],
              [50.1605453, 30.2019507],
              [50.1580161, 30.1980362],
              [50.1552275, 30.1943072],
              [50.1495512, 30.1872635],
              [50.1439932, 30.1810483],
              [50.1390342, 30.1759444],
              [50.1324843, 30.1699162],
              [50.1292915, 30.1671112],
              [50.1259385, 30.1637049],
              [50.1234323, 30.1608028],
              [50.1208266, 30.1585497],
              [50.1189118, 30.1565697],
              [50.1168438, 30.1547139],
              [50.1161772, 30.1541459],
              [49.5801433, 29.6674426]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 269635,
        "tags": {
          "ISO3166-2": "IR-24",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "اردبیل",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q134228"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [47.2871719, 38.3044815],
              [47.2871719, 38.302263],
              [47.2910619, 38.3003138],
              [47.3021716, 38.296703],
              [47.3035614, 38.2964245],
              [47.3046716, 38.2964246],
              [47.3218946, 38.2914304],
              [47.3235611, 38.2905951],
              [47.3249509, 38.2903167],
              [47.3510642, 38.2755944],
              [47.3532877, 38.2744806],
              [47.3532877, 38.2742021],
              [47.3538408, 38.2739237],
              [47.3577307, 38.2694773],
              [47.3580073, 38.2691989],
              [47.3577307, 38.2661447],
              [47.3605073, 38.2630906],
              [47.3749455, 38.2519849],
              [47.3757875, 38.2514219],
              [47.3777313, 38.2503169],
              [47.3791211, 38.2489245],
              [47.379954, 38.2486461],
              [47.3857877, 38.2439211],
              [47.3985677, 38.2378125],
              [47.4027341, 38.2372556],
              [47.4060671, 38.2372556],
              [47.4071772, 38.2369771],
              [47.4107906, 38.2369771],
              [47.4116242, 38.2372555],
              [47.4130102, 38.2372556],
              [47.4302336, 38.2411454],
              [47.4496802, 38.2478108],
              [47.4507899, 38.2478109],
              [47.4549568, 38.2486463],
              [47.4569034, 38.2486463],
              [47.4580136, 38.2489248],
              [47.4607902, 38.2489248],
              [47.4613468, 38.2492032],
              [47.4624566, 38.2492033],
              [47.4635698, 38.2494817],
              [47.4655133, 38.2494817],
              [47.4663465, 38.2497602],
              [47.4674598, 38.2497602],
              [47.4680134, 38.2494817],
              [47.4688466, 38.2494817],
              [47.4777366, 38.2425378],
              [47.4788465, 38.2405885],
              [47.4791266, 38.239762],
              [47.4794031, 38.2378128],
              [47.4796796, 38.2353153],
              [47.4799598, 38.2342655],
              [47.4799597, 38.2336445],
              [47.4802367, 38.2322611],
              [47.4805132, 38.2303117],
              [47.4807934, 38.2300332],
              [47.4780134, 38.2058675],
              [47.4746801, 38.1947546],
              [47.4744036, 38.1936495],
              [47.4741266, 38.1925355],
              [47.4741267, 38.1875314],
              [47.4744036, 38.1861479],
              [47.4752369, 38.1841984],
              [47.4760701, 38.1841984],
              [47.4763467, 38.1839198],
              [47.4827366, 38.1819793],
              [47.4869035, 38.1819793],
              [47.4880168, 38.1825363],
              [47.48885, 38.1825364],
              [47.4930165, 38.1850339],
              [47.5046832, 38.1939191],
              [47.5060731, 38.1944761],
              [47.5066265, 38.1950331],
              [47.5085731, 38.1958687],
              [47.5102399, 38.1961471],
              [47.5155161, 38.1972611],
              [47.517183, 38.1972611],
              [47.5191264, 38.1969826],
              [47.5207929, 38.1964257],
              [47.5213496, 38.1958686],
              [47.5266297, 38.1925356],
              [47.527463, 38.1925356],
              [47.5277395, 38.1922571],
              [47.529963, 38.1917001],
              [47.531906, 38.1917001],
              [47.5330162, 38.1914216],
              [47.5346827, 38.1914216],
              [47.5360729, 38.1911431],
              [47.5363495, 38.1914216],
              [47.5394063, 38.1914216],
              [47.5396828, 38.1917001],
              [47.5416293, 38.1925356],
              [47.5585726, 38.2030917],
              [47.5713525, 38.2083652],
              [47.5724624, 38.2083652],
              [47.573019, 38.2086436],
              [47.5738523, 38.2086437],
              [47.5746858, 38.2089222],
              [47.5757956, 38.2089222],
              [47.5796856, 38.2100362],
              [47.5807989, 38.2100362],
              [47.5810754, 38.2103146],
              [47.581909, 38.2103147],
              [47.5830188, 38.2108717],
              [47.5838521, 38.2108716],
              [47.5849658, 38.2114287],
              [47.5927421, 38.2128122],
              [47.5952422, 38.2128122],
              [47.5960753, 38.2130907],
              [47.5971856, 38.2130906],
              [47.5977422, 38.2133691],
              [47.5985754, 38.2133692],
              [47.6055221, 38.2147617],
              [47.6060752, 38.2150311],
              [47.6107988, 38.217259],
              [47.611632, 38.2172591],
              [47.6119085, 38.2175376],
              [47.6130218, 38.2175375],
              [47.6132984, 38.2178161],
              [47.6146887, 38.2178161],
              [47.6171887, 38.2183641],
              [47.6232986, 38.2180946],
              [47.6319117, 38.2158666],
              [47.6332984, 38.2158666],
              [47.6338552, 38.2155882],
              [47.6349649, 38.2155882],
              [47.6380216, 38.2150312],
              [47.6399682, 38.2150312],
              [47.6455214, 38.2139263],
              [47.6471882, 38.2139263],
              [47.6483016, 38.2136477],
              [47.6502449, 38.2136478],
              [47.6513548, 38.2133693],
              [47.6546916, 38.2133693],
              [47.6558014, 38.2130908],
              [47.6577448, 38.2130909],
              [47.6588581, 38.2133693],
              [47.6663582, 38.2133693],
              [47.6674681, 38.2136478],
              [47.6749678, 38.2136478],
              [47.6755248, 38.2139263],
              [47.6780245, 38.2139263],
              [47.685966, 38.2155306],
              [47.6980245, 38.2169807],
              [47.6985812, 38.2169808],
              [47.6994144, 38.2167023],
              [47.7013577, 38.2167023],
              [47.7033043, 38.2161453],
              [47.7044141, 38.2161453],
              [47.7141374, 38.2130909],
              [47.7166375, 38.2116985],
              [47.7177476, 38.211429],
              [47.7246942, 38.2122555],
              [47.736084, 38.2233682],
              [47.7383039, 38.2258745],
              [47.738584, 38.2264225],
              [47.740804, 38.2289288],
              [47.7466372, 38.2328096],
              [47.7483073, 38.2333667],
              [47.7485839, 38.2330881],
              [47.7488604, 38.2333667],
              [47.749417, 38.2330882],
              [47.7505272, 38.2330882],
              [47.7510839, 38.2328097],
              [47.7535839, 38.2328096],
              [47.7541406, 38.2325312],
              [47.7563606, 38.2322617],
              [47.7574739, 38.2325312],
              [47.7577504, 38.2322617],
              [47.7596938, 38.2325313],
              [47.7627502, 38.2325312],
              [47.7633068, 38.2328097],
              [47.7646935, 38.2328097],
              [47.7649737, 38.2330882],
              [47.7692257, 38.2342306],
              [47.7699738, 38.2344806],
              [47.770807, 38.2344806],
              [47.7710835, 38.2347591],
              [47.7719167, 38.2347591],
              [47.773307, 38.235873],
              [47.773307, 38.236421],
              [47.7777501, 38.2436525],
              [47.7785833, 38.2461497],
              [47.7805302, 38.2505963],
              [47.7835834, 38.2528152],
              [47.7844165, 38.2528152],
              [47.7846967, 38.2525367],
              [47.7852498, 38.2525367],
              [47.7858068, 38.2525367],
              [47.7874733, 38.2514228],
              [47.7974732, 38.2319834],
              [47.7985865, 38.2264226],
              [47.7988635, 38.2247607],
              [47.79914, 38.2239252],
              [47.7991401, 38.2233683],
              [47.7999733, 38.2200354],
              [47.8033066, 38.2116987],
              [47.8041398, 38.2105937],
              [47.8083099, 38.2025353],
              [47.8088634, 38.2022568],
              [47.80942, 38.2011429],
              [47.8146964, 38.1969833],
              [47.8266431, 38.1892033],
              [47.8269198, 38.1889248],
              [47.834143, 38.1814231],
              [47.8355332, 38.1797611],
              [47.8449765, 38.1664284],
              [47.8519232, 38.1469769],
              [47.8521997, 38.1466985],
              [47.8519232, 38.1439222],
              [47.8521998, 38.1436437],
              [47.8519232, 38.1419814],
              [47.8513666, 38.133365],
              [47.850533, 38.1289265],
              [47.8477564, 38.1164192],
              [47.8463667, 38.0917006],
              [47.8516434, 38.0669718],
              [47.8519235, 38.0667022],
              [47.8519235, 38.0639166],
              [47.8522, 38.0605917],
              [47.8524766, 38.0594774],
              [47.8527568, 38.0578061],
              [47.8530333, 38.0561436],
              [47.8533099, 38.053924],
              [47.8535899, 38.0522526],
              [47.8538666, 38.051417],
              [47.8578491, 38.0358617],
              [47.8580335, 38.0344777],
              [47.8583101, 38.0325277],
              [47.8585902, 38.0311437],
              [47.8619235, 38.0089196],
              [47.8622001, 38.0066999],
              [47.8624801, 38.0064214],
              [47.8685901, 37.9986387],
              [47.8691468, 37.9978119],
              [47.8752567, 37.9947563],
              [47.8763665, 37.9947563],
              [47.8766465, 37.9944777],
              [47.8783134, 37.9944777],
              [47.87859, 37.994199],
              [47.8805365, 37.9941991],
              [47.88109, 37.9939205],
              [47.8827564, 37.9939205],
              [47.8833132, 37.9936419],
              [47.8847034, 37.9936419],
              [47.8852566, 37.9933633],
              [47.8905367, 37.9933633],
              [47.8908132, 37.9930847],
              [47.8922032, 37.9930847],
              [47.8927563, 37.9933633],
              [47.8960899, 37.9933633],
              [47.8969232, 37.9936419],
              [47.9008131, 37.9936419],
              [47.9010932, 37.9933633],
              [47.9024796, 37.9933633],
              [47.9027596, 37.9930847],
              [47.9035933, 37.9930847],
              [47.9041465, 37.9928061],
              [47.9047031, 37.9928062],
              [47.9052597, 37.9925275],
              [47.9060929, 37.9925275],
              [47.9097032, 37.9908649],
              [47.914703, 37.983091],
              [47.9183163, 37.9753079],
              [47.9294264, 37.9625278],
              [47.9297029, 37.9622492],
              [47.9366497, 37.950026],
              [47.9369262, 37.9486419],
              [47.9377595, 37.9466916],
              [47.9372064, 37.9428088],
              [47.9366497, 37.9414157],
              [47.936093, 37.941137],
              [47.9358165, 37.9405798],
              [47.9352593, 37.9403102],
              [47.9258163, 37.9350342],
              [47.924983, 37.9350342],
              [47.9238697, 37.934477],
              [47.9230365, 37.934477],
              [47.922483, 37.9341984],
              [47.9219263, 37.9339197],
              [47.9213697, 37.9339197],
              [47.9119266, 37.928365],
              [47.9055366, 37.9180826],
              [47.9013701, 37.9069729],
              [47.9010935, 37.9064157],
              [47.8899804, 37.8983619],
              [47.887757, 37.8978047],
              [47.8874804, 37.8972474],
              [47.8847038, 37.8919711],
              [47.885537, 37.8897508],
              [47.8888703, 37.8861374],
              [47.8894234, 37.8861374],
              [47.8894234, 37.8858588],
              [47.8899805, 37.8855801],
              [47.8916469, 37.8828026],
              [47.8919235, 37.882524],
              [47.8916469, 37.881697],
              [47.8908137, 37.8764205],
              [47.8908137, 37.8722497],
              [47.8930368, 37.8683574],
              [47.8955368, 37.8658585],
              [47.8963702, 37.8650315],
              [47.898037, 37.8636381],
              [47.8983136, 37.8633595],
              [47.9002604, 37.8625235],
              [47.9038703, 37.8625235],
              [47.9044269, 37.8628022],
              [47.9052601, 37.8628022],
              [47.9116466, 37.8644742],
              [47.92637, 37.8711351],
              [47.9272032, 37.8711351],
              [47.9277599, 37.8714137],
              [47.9285931, 37.8714137],
              [47.9291497, 37.8716924],
              [47.9299833, 37.8716924],
              [47.9305365, 37.8719711],
              [47.9313697, 37.8719711],
              [47.9413731, 37.8741913],
              [47.9419266, 37.8741913],
              [47.9427598, 37.87447],
              [47.9438731, 37.87447],
              [47.9444262, 37.8747487],
              [47.9472064, 37.8747487],
              [47.9480395, 37.8750273],
              [47.9491498, 37.8750273],
              [47.9499831, 37.875306],
              [47.9535929, 37.8753061],
              [47.9541495, 37.8750274],
              [47.9572062, 37.8750274],
              [47.9574828, 37.8747487],
              [47.971096, 37.8747487],
              [47.971373, 37.8750274],
              [47.9733159, 37.8750274],
              [47.9738726, 37.8753061],
              [47.9749828, 37.875306],
              [47.9752629, 37.8755847],
              [47.9760961, 37.8755847],
              [47.9766527, 37.8758634],
              [47.977486, 37.8758633],
              [47.9774859, 37.876142],
              [47.9780394, 37.876142],
              [47.9860959, 37.8828028],
              [47.9866526, 37.8833601],
              [47.9933191, 37.8903084],
              [47.999403, 37.8949567],
              [48.0124855, 37.8886365],
              [48.0202654, 37.8841961],
              [48.0235991, 37.8808612],
              [48.0241522, 37.8808613],
              [48.0244324, 37.8805826],
              [48.0249854, 37.8805826],
              [48.0249855, 37.880304],
              [48.0255422, 37.8803039],
              [48.0260988, 37.8800253],
              [48.027209, 37.8800253],
              [48.0377654, 37.8769692],
              [48.0399889, 37.8755849],
              [48.0402656, 37.8753063],
              [48.0466555, 37.8711354],
              [48.0502653, 37.8653015],
              [48.0497088, 37.8583619],
              [48.0527655, 37.8525279],
              [48.0572121, 37.8500289],
              [48.0583219, 37.8500289],
              [48.0585983, 37.8497502],
              [48.0591554, 37.8497502],
              [48.059432, 37.8494716],
              [48.0599887, 37.8494715],
              [48.0602653, 37.8491929],
              [48.0608219, 37.8491928],
              [48.0616552, 37.8486355],
              [48.0624887, 37.8486355],
              [48.0627653, 37.8483569],
              [48.0638786, 37.8480872],
              [48.0655451, 37.8480872],
              [48.0660985, 37.8478086],
              [48.0691553, 37.8478086],
              [48.0699886, 37.8475299],
              [48.0738785, 37.84753],
              [48.0755453, 37.8478086],
              [48.0761019, 37.8478085],
              [48.0827685, 37.850029],
              [48.0886018, 37.8536427],
              [48.0963782, 37.8536426],
              [48.0985513, 37.8527311],
              [48.0991583, 37.852528],
              [48.1047115, 37.849193],
              [48.108048, 37.8389181],
              [48.1083249, 37.8375248],
              [48.1086016, 37.8364101],
              [48.1088816, 37.8361404],
              [48.114715, 37.8303062],
              [48.1180482, 37.8291915],
              [48.119158, 37.8289128],
              [48.1386046, 37.8216942],
              [48.1391577, 37.8211368],
              [48.1461044, 37.8178016],
              [48.1463809, 37.8172443],
              [48.146938, 37.8169656],
              [48.1511045, 37.8103041],
              [48.1511045, 37.8097468],
              [48.1511045, 37.8094681],
              [48.1502714, 37.8064205],
              [48.1494377, 37.805863],
              [48.148881, 37.8053057],
              [48.1477713, 37.8025278],
              [48.1480479, 37.8011343],
              [48.1491611, 37.7964146],
              [48.1494377, 37.7961359],
              [48.148328, 37.7844667],
              [48.1474947, 37.7805828],
              [48.1352716, 37.7522446],
              [48.1266582, 37.7447462],
              [48.1258249, 37.7441888],
              [48.1191584, 37.7405835],
              [48.1183252, 37.7405834],
              [48.1152684, 37.7391898],
              [48.1144352, 37.7391898],
              [48.1091586, 37.7380839],
              [48.1077687, 37.7380839],
              [48.1052686, 37.7375265],
              [48.1036018, 37.7375264],
              [48.1030451, 37.7372477],
              [48.1016588, 37.7372477],
              [48.100545, 37.736969],
              [48.0988786, 37.736969],
              [48.0983255, 37.7366903],
              [48.0963785, 37.7366903],
              [48.0952688, 37.7364115],
              [48.0913788, 37.7364116],
              [48.0902687, 37.7361329],
              [48.0880452, 37.7361328],
              [48.0874886, 37.7358541],
              [48.0752687, 37.733912],
              [48.0708221, 37.7322487],
              [48.0666557, 37.7294704],
              [48.0652658, 37.7266921],
              [48.0644322, 37.7250198],
              [48.0641556, 37.7247411],
              [48.063599, 37.722799],
              [48.063599, 37.7205781],
              [48.0633224, 37.719751],
              [48.0633224, 37.7147428],
              [48.0638791, 37.7105799],
              [48.0630459, 37.7064078],
              [48.0538794, 37.6925249],
              [48.031067, 37.6662269],
              [48.0308195, 37.6658551],
              [48.0288761, 37.6630765],
              [48.028043, 37.661413],
              [48.0277664, 37.6611342],
              [48.0255429, 37.654462],
              [48.0224862, 37.6414052],
              [48.0199866, 37.6258572],
              [48.0188765, 37.6180785],
              [48.0191531, 37.6166847],
              [48.0216532, 37.6122422],
              [48.0227664, 37.6119634],
              [48.0236001, 37.6111361],
              [48.0241532, 37.6108573],
              [48.0427665, 37.6025209],
              [48.0435997, 37.602521],
              [48.0480428, 37.601127],
              [48.0491561, 37.6011271],
              [48.0494331, 37.6008483],
              [48.055266, 37.5991847],
              [48.0563797, 37.5991846],
              [48.0580384, 37.598574],
              [48.0669327, 37.5952996],
              [48.0677658, 37.5950208],
              [48.0716558, 37.5930784],
              [48.0747125, 37.5902995],
              [48.0785807, 37.5830407],
              [48.0811175, 37.5711937],
              [48.0811348, 37.557525],
              [48.0793109, 37.5474403],
              [48.0795458, 37.5361742],
              [48.0782717, 37.527789],
              [48.0773305, 37.5196657],
              [48.078146, 37.5133683],
              [48.0816114, 37.5111641],
              [48.0836069, 37.5107216],
              [48.0842507, 37.5097259],
              [48.0832636, 37.5080067],
              [48.084079, 37.5058023],
              [48.0855274, 37.5053427],
              [48.0882311, 37.5069513],
              [48.0900979, 37.5073258],
              [48.0917501, 37.5063385],
              [48.093574, 37.5042618],
              [48.0960846, 37.5031383],
              [48.1015456, 37.5037001],
              [48.1029081, 37.5031128],
              [48.1031871, 37.4980824],
              [48.1060409, 37.4963119],
              [48.1120276, 37.4874757],
              [48.1153106, 37.4862839],
              [48.1176495, 37.4867776],
              [48.1221556, 37.4883611],
              [48.1244302, 37.4884462],
              [48.1293225, 37.4840533],
              [48.1340217, 37.4812779],
              [48.1432056, 37.4804946],
              [48.1499004, 37.4791493],
              [48.1558442, 37.477123],
              [48.160758, 37.4734957],
              [48.1638694, 37.4695448],
              [48.1656074, 37.4652871],
              [48.1663799, 37.4614379],
              [48.1658649, 37.4561236],
              [48.1655468, 37.4521246],
              [48.1636039, 37.4479169],
              [48.1629861, 37.4409848],
              [48.1631669, 37.4313737],
              [48.164432, 37.4252284],
              [48.1672392, 37.4186839],
              [48.1720984, 37.4126472],
              [48.1770229, 37.4087643],
              [48.1818044, 37.4042401],
              [48.1904898, 37.3922298],
              [48.1982391, 37.3776978],
              [48.204198, 37.3759872],
              [48.2119686, 37.3738864],
              [48.2182313, 37.3728496],
              [48.2250863, 37.3722288],
              [48.229624, 37.3719288],
              [48.2349626, 37.3715036],
              [48.2341529, 37.3686204],
              [48.2334921, 37.3665035],
              [48.2329227, 37.3638817],
              [48.2322676, 37.3607572],
              [48.2319545, 37.3580486],
              [48.23174, 37.3541597],
              [48.2337785, 37.3483431],
              [48.2371044, 37.3442662],
              [48.2379091, 37.343345],
              [48.2394218, 37.3423299],
              [48.243649, 37.339481],
              [48.2453334, 37.3384318],
              [48.246578, 37.3377238],
              [48.2469749, 37.3345931],
              [48.2471681, 37.3331429],
              [48.2466745, 37.3296026],
              [48.2462668, 37.3264972],
              [48.2460415, 37.3251748],
              [48.2476723, 37.322692],
              [48.250097, 37.3216255],
              [48.252908, 37.3220862],
              [48.2542169, 37.3222483],
              [48.2568455, 37.3231271],
              [48.2570708, 37.3247908],
              [48.2572853, 37.3278707],
              [48.258487, 37.3279816],
              [48.2596242, 37.3281011],
              [48.2601821, 37.3262497],
              [48.2604825, 37.3247994],
              [48.2625747, 37.3234599],
              [48.2636154, 37.3226238],
              [48.2642376, 37.3201068],
              [48.2624352, 37.3174447],
              [48.2591092, 37.3170095],
              [48.257736, 37.315047],
              [48.2610834, 37.313878],
              [48.2638299, 37.3129479],
              [48.2656538, 37.312709],
              [48.267113, 37.3125981],
              [48.2691193, 37.3152603],
              [48.2708573, 37.3160197],
              [48.2716942, 37.3133234],
              [48.2720053, 37.3122567],
              [48.2725739, 37.3113096],
              [48.2745695, 37.3110365],
              [48.276093, 37.3108658],
              [48.2763076, 37.3087922],
              [48.2743657, 37.3076487],
              [48.2705998, 37.307589],
              [48.269881, 37.3063772],
              [48.2700205, 37.3061212],
              [48.272177, 37.3049094],
              [48.276608, 37.3055323],
              [48.2778525, 37.3056518],
              [48.2804811, 37.3055323],
              [48.2813394, 37.3047899],
              [48.2818544, 37.3030063],
              [48.2821655, 37.3016493],
              [48.2821441, 37.2999254],
              [48.2832169, 37.2983038],
              [48.2844829, 37.2965542],
              [48.287015, 37.2957007],
              [48.2906949, 37.2964005],
              [48.291564, 37.2965798],
              [48.2953834, 37.2951971],
              [48.2958046, 37.2946871],
              [48.2963383, 37.2938678],
              [48.2969123, 37.2926515],
              [48.2975936, 37.2908953],
              [48.2958555, 37.2870798],
              [48.2928514, 37.2855177],
              [48.2924437, 37.2840666],
              [48.2922828, 37.2831276],
              [48.2956087, 37.2822056],
              [48.2977545, 37.278919],
              [48.2986343, 37.2776726],
              [48.3034193, 37.2766225],
              [48.3047712, 37.2750432],
              [48.306123, 37.2737967],
              [48.309803, 37.2726954],
              [48.3150494, 37.2753078],
              [48.3169806, 37.2757859],
              [48.3200812, 37.276392],
              [48.3231068, 37.2749151],
              [48.3232677, 37.2724648],
              [48.3215403, 37.270578],
              [48.3206284, 37.2690241],
              [48.3201349, 37.2684435],
              [48.3219159, 37.2664114],
              [48.3287823, 37.2701511],
              [48.3332562, 37.2659674],
              [48.3354878, 37.2637816],
              [48.3366465, 37.2627313],
              [48.3379447, 37.2600928],
              [48.3387172, 37.2586241],
              [48.3402192, 37.2571724],
              [48.3439314, 37.2575908],
              [48.3458197, 37.2550119],
              [48.3438241, 37.2529624],
              [48.3416891, 37.2515618],
              [48.3409488, 37.2511007],
              [48.3407771, 37.2497769],
              [48.3415389, 37.2486582],
              [48.3420753, 37.2479664],
              [48.3401334, 37.2450541],
              [48.3382559, 37.2422868],
              [48.3370757, 37.2406469],
              [48.3365285, 37.2397458],
              [48.3376121, 37.2394768],
              [48.3402622, 37.2406725],
              [48.342483, 37.2416719],
              [48.3486414, 37.2422356],
              [48.3529973, 37.2461814],
              [48.3558726, 37.2480945],
              [48.3623207, 37.2468818],
              [48.3667731, 37.2476675],
              [48.3691871, 37.2486582],
              [48.3736181, 37.2483336],
              [48.3761716, 37.2471721],
              [48.3789289, 37.244405],
              [48.3800554, 37.24379],
              [48.384304, 37.2453616],
              [48.3919859, 37.2489144],
              [48.3968782, 37.2492219],
              [48.4039378, 37.2461345],
              [48.4098709, 37.2479749],
              [48.4125638, 37.2483849],
              [48.4153533, 37.2466426],
              [48.4166729, 37.2446014],
              [48.4167695, 37.2425174],
              [48.4196448, 37.2410398],
              [48.4235608, 37.2408348],
              [48.4247196, 37.2409117],
              [48.4261894, 37.2396476],
              [48.4263825, 37.2378368],
              [48.4202456, 37.2286712],
              [48.4202456, 37.2242289],
              [48.4214902, 37.222674],
              [48.4265327, 37.2213413],
              [48.4303187, 37.221039],
              [48.4375191, 37.2153265],
              [48.442347, 37.2118575],
              [48.4463811, 37.2104049],
              [48.4509301, 37.2082345],
              [48.4521854, 37.2076812],
              [48.4537679, 37.2082003],
              [48.4541595, 37.2099862],
              [48.4560478, 37.2104989],
              [48.457582, 37.210422],
              [48.4602642, 37.2086959],
              [48.460586, 37.2089865],
              [48.4625199, 37.2081106],
              [48.4634507, 37.2086724],
              [48.4633755, 37.2097897],
              [48.4641051, 37.2113619],
              [48.4638476, 37.212729],
              [48.4649849, 37.2131904],
              [48.4680802, 37.2127803],
              [48.4694427, 37.2126094],
              [48.4720069, 37.2116481],
              [48.4750593, 37.211379],
              [48.4760034, 37.2111824],
              [48.4779882, 37.2111397],
              [48.4795868, 37.2106997],
              [48.480531, 37.2106313],
              [48.4818774, 37.2100033],
              [48.4826875, 37.2084182],
              [48.4777576, 37.2071621],
              [48.4764004, 37.2071023],
              [48.4757405, 37.2062307],
              [48.4761482, 37.2053591],
              [48.477425, 37.2045558],
              [48.4784335, 37.2037697],
              [48.4792864, 37.2026887],
              [48.4809279, 37.200783],
              [48.487376, 37.1993729],
              [48.4887493, 37.198279],
              [48.4891784, 37.1957921],
              [48.4872687, 37.1925786],
              [48.4869468, 37.1895445],
              [48.4868288, 37.1858008],
              [48.4850156, 37.1839032],
              [48.4808528, 37.1819629],
              [48.4782886, 37.1794669],
              [48.4790289, 37.1787317],
              [48.4803378, 37.1784582],
              [48.4830737, 37.1791848],
              [48.4850585, 37.1796207],
              [48.487494, 37.1798772],
              [48.4891248, 37.1799969],
              [48.4920645, 37.1797917],
              [48.4947145, 37.1776717],
              [48.4959376, 37.1753807],
              [48.4944463, 37.1739702],
              [48.492279, 37.172893],
              [48.4912491, 37.1717988],
              [48.4911096, 37.1706019],
              [48.4914207, 37.1702428],
              [48.4927833, 37.169747],
              [48.4938347, 37.1694478],
              [48.4957445, 37.1673617],
              [48.4972465, 37.1656261],
              [48.4966564, 37.1639931],
              [48.4955406, 37.1594444],
              [48.4981155, 37.1550237],
              [48.50039, 37.1486188],
              [48.5041451, 37.1436929],
              [48.5059905, 37.1404943],
              [48.5086298, 37.1387325],
              [48.5119343, 37.1369535],
              [48.5155177, 37.1360982],
              [48.5182214, 37.135833],
              [48.5216117, 37.1362008],
              [48.5251522, 37.1362863],
              [48.528403, 37.1363633],
              [48.5308814, 37.135756],
              [48.534497, 37.1351744],
              [48.5380053, 37.1349862],
              [48.5451937, 37.1352599],
              [48.5476613, 37.1315991],
              [48.5476827, 37.1269458],
              [48.5469317, 37.1230279],
              [48.5475111, 37.1210261],
              [48.5497159, 37.1194413],
              [48.5561263, 37.1194606],
              [48.5597312, 37.1183228],
              [48.565251, 37.121159],
              [48.5654497, 37.1212614],
              [48.5687005, 37.1204316],
              [48.5693872, 37.1189345],
              [48.5705191, 37.1165134],
              [48.570621, 37.1145456],
              [48.5708249, 37.1113843],
              [48.57171, 37.1084667],
              [48.5761249, 37.1050014],
              [48.5799122, 37.1043254],
              [48.5852766, 37.1064645],
              [48.5898256, 37.1086207],
              [48.5946321, 37.1110506],
              [48.6092532, 37.1178706],
              [48.6150598, 37.119914],
              [48.6230422, 37.121853],
              [48.630885, 37.123635],
              [48.6351956, 37.1239982],
              [48.6397556, 37.1248841],
              [48.6525098, 37.1267122],
              [48.6627641, 37.1320892],
              [48.6658128, 37.1343733],
              [48.6801978, 37.145938],
              [48.6947441, 37.1594493],
              [48.6958538, 37.1600073],
              [48.7262264, 37.1796396],
              [48.726967, 37.1800119],
              [48.7278003, 37.1802908],
              [48.7336336, 37.1841783],
              [48.7375235, 37.1855641],
              [48.7391904, 37.1855641],
              [48.7394669, 37.1858431],
              [48.7430802, 37.1858431],
              [48.7436334, 37.1861221],
              [48.744467, 37.1861221],
              [48.7450237, 37.185843],
              [48.7461334, 37.1858431],
              [48.7511367, 37.1827925],
              [48.7511367, 37.1825136],
              [48.7516902, 37.1811188],
              [48.7519703, 37.1808398],
              [48.7519703, 37.1802909],
              [48.7519703, 37.179454],
              [48.7522469, 37.1694563],
              [48.7539134, 37.1666756],
              [48.7553036, 37.1666756],
              [48.7553037, 37.1663967],
              [48.7572466, 37.1658387],
              [48.7589134, 37.1647319],
              [48.7647469, 37.1566778],
              [48.7680801, 37.1502884],
              [48.7764131, 37.1469497],
              [48.7769698, 37.1466797],
              [48.7833598, 37.1436199],
              [48.7866931, 37.1402902],
              [48.7872497, 37.1402902],
              [48.7875266, 37.1400113],
              [48.7883598, 37.1400113],
              [48.7886364, 37.1397323],
              [48.7900263, 37.1391743],
              [48.7939163, 37.1391744],
              [48.7941932, 37.1394533],
              [48.8019696, 37.1419551],
              [48.8101956, 37.1485507],
              [48.8105389, 37.159496],
              [48.797836, 37.1802878],
              [48.8028497, 37.188092],
              [48.8053497, 37.1889195],
              [48.8064599, 37.1889195],
              [48.8092361, 37.1889195],
              [48.8097931, 37.1886405],
              [48.8117363, 37.1886406],
              [48.8122928, 37.1883618],
              [48.8167398, 37.1875342],
              [48.8220162, 37.1875342],
              [48.8228498, 37.1878131],
              [48.8286826, 37.1878131],
              [48.8295162, 37.1875342],
              [48.8314593, 37.1875342],
              [48.8320159, 37.1872553],
              [48.8328495, 37.1872554],
              [48.8331261, 37.1869766],
              [48.8336827, 37.1869766],
              [48.8400647, 37.1780994],
              [48.8366314, 37.160864],
              [48.8434979, 37.1518344],
              [48.8550288, 37.1480658],
              [48.8561391, 37.1480657],
              [48.8564192, 37.1477867],
              [48.8580856, 37.1477868],
              [48.8586392, 37.1480657],
              [48.8589193, 37.1477867],
              [48.8608623, 37.1477868],
              [48.8608622, 37.1475078],
              [48.8614189, 37.1475078],
              [48.8622525, 37.1475078],
              [48.8639188, 37.1475078],
              [48.865372, 37.1475733],
              [48.8685765, 37.1493874],
              [48.8691956, 37.1504033],
              [48.8698146, 37.1516513],
              [48.8705793, 37.1521302],
              [48.8709617, 37.1527252],
              [48.8719189, 37.1533031],
              [48.8721419, 37.1532495],
              [48.8723631, 37.1532721],
              [48.8724834, 37.1533877],
              [48.8726144, 37.1534484],
              [48.8727559, 37.153454],
              [48.8730245, 37.1534657],
              [48.8732152, 37.1535506],
              [48.8732981, 37.1536535],
              [48.8735186, 37.1538715],
              [48.8737097, 37.1540323],
              [48.874322, 37.1541],
              [48.8747839, 37.1541635],
              [48.8751219, 37.1541254],
              [48.875536, 37.1539956],
              [48.8758379, 37.1540213],
              [48.8760626, 37.1541287],
              [48.8762238, 37.154271],
              [48.8762913, 37.154378],
              [48.8763783, 37.1545118],
              [48.876534, 37.1545499],
              [48.876849, 37.154784],
              [48.8770118, 37.1548024],
              [48.8770596, 37.1548179],
              [48.8770879, 37.1549039],
              [48.8771782, 37.1549632],
              [48.8773746, 37.1549829],
              [48.8775993, 37.1550605],
              [48.8780523, 37.1553383],
              [48.8782346, 37.1553792],
              [48.8784735, 37.1553566],
              [48.8790748, 37.1554002],
              [48.8798589, 37.155491],
              [48.880221, 37.1555696],
              [48.880489, 37.1555094],
              [48.880546, 37.1554075],
              [48.880717, 37.1553989],
              [48.8808541, 37.1554358],
              [48.8809589, 37.15541],
              [48.8812146, 37.1553204],
              [48.8815551, 37.1552406],
              [48.881672, 37.1552048],
              [48.8817923, 37.1551681],
              [48.8819202, 37.15513],
              [48.8819941, 37.1550809],
              [48.8820942, 37.1550331],
              [48.8822606, 37.1550416],
              [48.8824193, 37.1550748],
              [48.8825073, 37.1550886],
              [48.8827241, 37.1550871],
              [48.8828366, 37.1550841],
              [48.882942, 37.1551459],
              [48.8830096, 37.1551855],
              [48.8833551, 37.1552287],
              [48.883597, 37.1552505],
              [48.8837894, 37.1553112],
              [48.8840295, 37.1554796],
              [48.8843511, 37.1557796],
              [48.8846377, 37.1558864],
              [48.8848302, 37.1559355],
              [48.8850243, 37.1560497],
              [48.8850705, 37.1562019],
              [48.8850921, 37.1563468],
              [48.8850798, 37.1564659],
              [48.8850675, 37.1566365],
              [48.8851014, 37.1568011],
              [48.8851428, 37.15701],
              [48.8853216, 37.1571965],
              [48.8855411, 37.1573545],
              [48.8857003, 37.1577296],
              [48.8860259, 37.1579186],
              [48.8878238, 37.1579045],
              [48.8880008, 37.1582345],
              [48.8879371, 37.1585673],
              [48.8880149, 37.1590243],
              [48.8883547, 37.1594474],
              [48.8883936, 37.1596843],
              [48.8885812, 37.1599128],
              [48.8885918, 37.1602343],
              [48.8885104, 37.1604289],
              [48.8882592, 37.1608971],
              [48.8882839, 37.1611425],
              [48.8884927, 37.1613456],
              [48.8887016, 37.1613682],
              [48.8888821, 37.1615205],
              [48.8890519, 37.1616079],
              [48.8893917, 37.1616079],
              [48.889643, 37.1615289],
              [48.889873, 37.1614161],
              [48.890319, 37.1614612],
              [48.890595, 37.1615966],
              [48.890726, 37.1617207],
              [48.8907154, 37.1619012],
              [48.890641, 37.1620394],
              [48.890641, 37.1622792],
              [48.8907755, 37.1625246],
              [48.8912356, 37.1628264],
              [48.891494, 37.16288],
              [48.8918691, 37.1630746],
              [48.8920886, 37.1632974],
              [48.8921593, 37.1635879],
              [48.8921417, 37.1638192],
              [48.8919045, 37.1640702],
              [48.8918762, 37.1642422],
              [48.8920567, 37.1646145],
              [48.8922691, 37.1648768],
              [48.892531, 37.1649078],
              [48.8930654, 37.1647302],
              [48.8933379, 37.1646737],
              [48.8940917, 37.164843],
              [48.8942369, 37.1649417],
              [48.8942899, 37.1650799],
              [48.8943926, 37.1651758],
              [48.8947465, 37.1651983],
              [48.8950084, 37.1653112],
              [48.8964205, 37.1658329],
              [48.8968983, 37.1661037],
              [48.8971355, 37.1661516],
              [48.8973301, 37.1662729],
              [48.8977513, 37.1666649],
              [48.8983211, 37.1668877],
              [48.8989404, 37.1673503],
              [48.8992767, 37.1677902],
              [48.8994961, 37.1679002],
              [48.9000624, 37.1683486],
              [48.9004128, 37.1686758],
              [48.9005685, 37.1689634],
              [48.9007348, 37.1691298],
              [48.9009189, 37.1693696],
              [48.9010994, 37.1696967],
              [48.9013011, 37.16999],
              [48.9014851, 37.1700972],
              [48.9018143, 37.1701818],
              [48.9023862, 37.1704344],
              [48.9024655, 37.1704694],
              [48.9025858, 37.1706838],
              [48.9025858, 37.170963],
              [48.9026283, 37.1711096],
              [48.9027876, 37.1712196],
              [48.9029857, 37.1712957],
              [48.9032087, 37.1714283],
              [48.9033821, 37.1716624],
              [48.9035166, 37.1720233],
              [48.9035241, 37.1722319],
              [48.90378, 37.1722042],
              [48.9040965, 37.1722961],
              [48.90446, 37.1723755],
              [48.9049484, 37.1724742],
              [48.9050085, 37.1725926],
              [48.9052209, 37.1727082],
              [48.9059995, 37.1728041],
              [48.9062402, 37.172948],
              [48.9070259, 37.1730269],
              [48.9074435, 37.1731143],
              [48.90767, 37.1732892],
              [48.9084062, 37.173402],
              [48.9088379, 37.1732553],
              [48.9091565, 37.1732835],
              [48.9098678, 37.173151],
              [48.9101935, 37.1730185],
              [48.9105509, 37.1732215],
              [48.9108588, 37.1733033],
              [48.9112587, 37.1733343],
              [48.912278, 37.1735684],
              [48.9131495, 37.1736115],
              [48.9130836, 37.1734776],
              [48.9128132, 37.1731801],
              [48.9130192, 37.1731801],
              [48.9135728, 37.1732827],
              [48.9148184, 37.173191],
              [48.9154463, 37.1729495],
              [48.9142987, 37.1723284],
              [48.9152081, 37.1723974],
              [48.9159443, 37.171759],
              [48.9164207, 37.1718453],
              [48.9163124, 37.1712932],
              [48.9160309, 37.1712069],
              [48.9151865, 37.1713277],
              [48.9147318, 37.1713104],
              [48.9162691, 37.1703787],
              [48.9167022, 37.1702752],
              [48.9176765, 37.1706893],
              [48.9182611, 37.1706893],
              [48.9181312, 37.1710344],
              [48.9178064, 37.1720351],
              [48.9180229, 37.1727769],
              [48.9187808, 37.1738121],
              [48.919517, 37.1746748],
              [48.9201232, 37.1750198],
              [48.9202965, 37.1756236],
              [48.9207078, 37.1766933],
              [48.9208613, 37.1770978],
              [48.9214217, 37.1800122],
              [48.9211451, 37.1802912],
              [48.920865, 37.181677],
              [48.9205884, 37.1833418],
              [48.9203115, 37.1852855],
              [48.901422, 37.2150075],
              [48.8994749, 37.2183459],
              [48.8953085, 37.2255624],
              [48.8777775, 37.2519893],
              [48.8755566, 37.2548425],
              [48.8737964, 37.261553],
              [48.8731097, 37.267974],
              [48.8696765, 37.2747359],
              [48.8756847, 37.2861409],
              [48.8751944, 37.2929557],
              [48.8714789, 37.2969981],
              [48.8654707, 37.3008216],
              [48.8477896, 37.3072392],
              [48.8433264, 37.3107892],
              [48.8266752, 37.3330407],
              [48.8112257, 37.3505096],
              [48.8139156, 37.3805738],
              [48.8097487, 37.3839023],
              [48.8003024, 37.3916839],
              [48.8000253, 37.3919627],
              [48.7668746, 37.4205747],
              [48.7640189, 37.4240256],
              [48.7570134, 37.429946],
              [48.7481402, 37.4364985],
              [48.7414126, 37.4450183],
              [48.7359667, 37.450833],
              [48.7318804, 37.4570545],
              [48.7152994, 37.4741889],
              [48.6896893, 37.5099985],
              [48.6944958, 37.5317825],
              [48.6858466, 37.5536964],
              [48.6850134, 37.5553592],
              [48.6841799, 37.5561951],
              [48.6827934, 37.5589724],
              [48.6825133, 37.5597993],
              [48.6761296, 37.5691845],
              [48.6826028, 37.5746668],
              [48.682883, 37.5752155],
              [48.6839928, 37.5754942],
              [48.6839928, 37.575773],
              [48.6848263, 37.575773],
              [48.6867693, 37.5766093],
              [48.6884361, 37.5863307],
              [48.6848262, 37.5963305],
              [48.6848263, 37.5966093],
              [48.6826028, 37.5996668],
              [48.6809359, 37.6010516],
              [48.6386302, 37.6197435],
              [48.6377965, 37.6205798],
              [48.6369632, 37.6208585],
              [48.6252935, 37.6330795],
              [48.6164069, 37.6464152],
              [48.615017, 37.6480788],
              [48.6144599, 37.6491938],
              [48.6139032, 37.6497423],
              [48.6122369, 37.6519724],
              [48.6097368, 37.6594719],
              [48.6097368, 37.662799],
              [48.6100168, 37.6714133],
              [48.6097367, 37.6716921],
              [48.6097367, 37.6722406],
              [48.6097367, 37.6725193],
              [48.6069601, 37.678355],
              [48.6058502, 37.6800275],
              [48.5997369, 37.6853057],
              [48.5966801, 37.6880751],
              [48.5958469, 37.6905837],
              [48.5961269, 37.6908535],
              [48.5958468, 37.691411],
              [48.5975134, 37.6944682],
              [48.5991836, 37.6983525],
              [48.59835, 37.6994675],
              [48.59835, 37.6997462],
              [48.59807, 37.7005825],
              [48.59807, 37.7014186],
              [48.5991837, 37.7030821],
              [48.6047364, 37.7055817],
              [48.6055701, 37.7055818],
              [48.60696, 37.7047455],
              [48.6083498, 37.7047455],
              [48.6108499, 37.7055818],
              [48.6316749, 37.7185589],
              [48.6330412, 37.7378699],
              [48.6340712, 37.7498152],
              [48.6438559, 37.7635228],
              [48.6442319, 37.7750664],
              [48.6410506, 37.7779619],
              [48.6333926, 37.7787375],
              [48.627501, 37.7808977],
              [48.6228054, 37.783965],
              [48.618123, 37.78936],
              [48.6158328, 37.7889383],
              [48.6094397, 37.7835795],
              [48.601101, 37.7789593],
              [48.5917757, 37.7813026],
              [48.5788905, 37.7900884],
              [48.5677554, 37.8030093],
              [48.5623169, 37.8128693],
              [48.5632099, 37.8199981],
              [48.5661733, 37.8258146],
              [48.5702311, 37.8316334],
              [48.5722921, 37.8353266],
              [48.5729359, 37.8418889],
              [48.5695708, 37.8478445],
              [48.5674486, 37.8493404],
              [48.5641569, 37.8518474],
              [48.5590179, 37.8585879],
              [48.5587222, 37.8708663],
              [48.5581967, 37.8764119],
              [48.5592594, 37.8830233],
              [48.5610427, 37.8877656],
              [48.5611475, 37.8960446],
              [48.5602139, 37.8994768],
              [48.5584868, 37.9015366],
              [48.5553646, 37.902626],
              [48.5527467, 37.9025921],
              [48.5464811, 37.9000863],
              [48.5460519, 37.8999847],
              [48.5414171, 37.8973771],
              [48.5387563, 37.8979867],
              [48.5361814, 37.9033371],
              [48.5375118, 37.9127502],
              [48.5428762, 37.9187767],
              [48.5512018, 37.9247688],
              [48.5532617, 37.9300835],
              [48.5631752, 37.9332653],
              [48.5778093, 37.9349238],
              [48.5817749, 37.9365559],
              [48.5861349, 37.9383424],
              [48.5911524, 37.9419484],
              [48.5913014, 37.9456828],
              [48.5904693, 37.955365],
              [48.5902977, 37.9583427],
              [48.5904693, 37.9701847],
              [48.5920572, 37.9750563],
              [48.5983228, 37.9804011],
              [48.6021943, 37.9875002],
              [48.6034449, 37.9941729],
              [48.6011123, 37.9973126],
              [48.5991382, 37.9975832],
              [48.5957789, 37.9992892],
              [48.5913291, 38.0019515],
              [48.5887527, 38.004448],
              [48.5872936, 38.0064431],
              [48.5861349, 38.0092835],
              [48.5859395, 38.012795],
              [48.586774, 38.0166258],
              [48.5882377, 38.0196635],
              [48.5918079, 38.0244786],
              [48.5998105, 38.0320927],
              [48.6030005, 38.0375462],
              [48.6091803, 38.0428189],
              [48.6175917, 38.0445764],
              [48.6308096, 38.0495782],
              [48.6385344, 38.0533631],
              [48.6419676, 38.0628246],
              [48.6490057, 38.0752578],
              [48.6534689, 38.0857973],
              [48.6548423, 38.0945791],
              [48.6508082, 38.1006581],
              [48.6499071, 38.1035624],
              [48.6538553, 38.1078848],
              [48.6575202, 38.1144169],
              [48.6594865, 38.1257881],
              [48.6681061, 38.137865],
              [48.6697547, 38.140059],
              [48.674082, 38.1481084],
              [48.6792442, 38.1585642],
              [48.6813726, 38.1643156],
              [48.6825754, 38.1721181],
              [48.6832691, 38.1770876],
              [48.6838506, 38.1839113],
              [48.6862899, 38.1954056],
              [48.6894596, 38.2035366],
              [48.6924328, 38.2079654],
              [48.70265, 38.2087812],
              [48.706169, 38.2106021],
              [48.7084865, 38.2130974],
              [48.7086581, 38.2153903],
              [48.7067699, 38.2179528],
              [48.7012236, 38.2192437],
              [48.6964497, 38.2211365],
              [48.693023, 38.224132],
              [48.6936378, 38.2295505],
              [48.6943521, 38.2330105],
              [48.692873, 38.2358719],
              [48.6896627, 38.2392046],
              [48.6893145, 38.2427659],
              [48.6962986, 38.249168],
              [48.7003437, 38.2551276],
              [48.6992597, 38.2567844],
              [48.6849354, 38.265432],
              [48.6790131, 38.2679424],
              [48.6739049, 38.276001],
              [48.6734444, 38.2817164],
              [48.675785, 38.297313],
              [48.675614, 38.302908],
              [48.6752486, 38.306305],
              [48.6737952, 38.3097479],
              [48.6693263, 38.3099251],
              [48.6681578, 38.3088708],
              [48.6646485, 38.3058167],
              [48.6538376, 38.2989915],
              [48.639782, 38.2973434],
              [48.6264046, 38.3008737],
              [48.6191813, 38.3153169],
              [48.6122347, 38.3214335],
              [48.5830684, 38.3489262],
              [48.5766784, 38.3564255],
              [48.5744548, 38.3605929],
              [48.5744548, 38.3608803],
              [48.5739016, 38.3617065],
              [48.5708449, 38.3747649],
              [48.5708448, 38.382264],
              [48.5739016, 38.3917118],
              [48.5733449, 38.3936516],
              [48.5705683, 38.4058741],
              [48.5702881, 38.4072661],
              [48.5694549, 38.4125465],
              [48.5691779, 38.4142079],
              [48.5700116, 38.4194882],
              [48.5706923, 38.4214543],
              [48.5725115, 38.4267083],
              [48.5730682, 38.4364336],
              [48.5736213, 38.4383733],
              [48.5819578, 38.4442102],
              [48.5822344, 38.444767],
              [48.5827914, 38.4450453],
              [48.5807243, 38.4539868],
              [48.5805953, 38.4548107],
              [48.5809063, 38.4579987],
              [48.5813141, 38.4595204],
              [48.5818264, 38.4603383],
              [48.5819095, 38.4608046],
              [48.5815206, 38.4627736],
              [48.5788532, 38.4637336],
              [48.579433, 38.4668173],
              [48.5737245, 38.4687234],
              [48.5743428, 38.4709341],
              [48.5663616, 38.4800099],
              [48.5632224, 38.4796501],
              [48.5571388, 38.4811685],
              [48.5567157, 38.4841492],
              [48.5529332, 38.4859712],
              [48.5530467, 38.4886581],
              [48.5496942, 38.4907226],
              [48.5511373, 38.4927909],
              [48.5507374, 38.4940918],
              [48.5433359, 38.4958484],
              [48.5376386, 38.5034509],
              [48.5323299, 38.5044347],
              [48.5310683, 38.5059085],
              [48.5266739, 38.5142544],
              [48.5219245, 38.515759],
              [48.5176091, 38.5154365],
              [48.5167375, 38.5174825],
              [48.5133037, 38.518379],
              [48.5139596, 38.5223081],
              [48.509365, 38.5256711],
              [48.508275, 38.527929],
              [48.5077893, 38.5395051],
              [48.5053279, 38.5426712],
              [48.5053883, 38.5441254],
              [48.5055078, 38.5470001],
              [48.4950289, 38.5532719],
              [48.4887298, 38.552604],
              [48.483957, 38.5540011],
              [48.4768878, 38.5515793],
              [48.4722042, 38.5535327],
              [48.4706685, 38.5564238],
              [48.4685627, 38.5571989],
              [48.4681091, 38.5616275],
              [48.4672182, 38.5622126],
              [48.464684, 38.5613214],
              [48.4619022, 38.5653001],
              [48.4621515, 38.5700897],
              [48.4592363, 38.5775474],
              [48.4545155, 38.5811489],
              [48.4541344, 38.5831819],
              [48.4567645, 38.5859578],
              [48.4541987, 38.5872005],
              [48.4535289, 38.5897663],
              [48.4586107, 38.5980425],
              [48.4584176, 38.6005604],
              [48.4559619, 38.6041669],
              [48.4592932, 38.6076878],
              [48.4541386, 38.609514],
              [48.4514814, 38.6104553],
              [48.4474559, 38.6100329],
              [48.4445053, 38.6120433],
              [48.4413158, 38.6127221],
              [48.4358582, 38.6117569],
              [48.4314838, 38.613568],
              [48.4251103, 38.6132877],
              [48.4214685, 38.6101129],
              [48.4179562, 38.6090349],
              [48.4161312, 38.6059235],
              [48.4094692, 38.6042654],
              [48.4079422, 38.6023118],
              [48.3903587, 38.602443],
              [48.3884074, 38.6050457],
              [48.3856521, 38.6051448],
              [48.3818225, 38.6036449],
              [48.3800827, 38.6018152],
              [48.3755371, 38.6008763],
              [48.3742251, 38.6002886],
              [48.3736743, 38.5984105],
              [48.3669945, 38.5981543],
              [48.361489, 38.5948538],
              [48.3563145, 38.5977879],
              [48.3507154, 38.5951324],
              [48.3440111, 38.5990316],
              [48.3420421, 38.5993976],
              [48.3415533, 38.5995834],
              [48.3409226, 38.5999628],
              [48.3399384, 38.6005384],
              [48.3393935, 38.6009126],
              [48.3390897, 38.6011527],
              [48.3389146, 38.6012482],
              [48.3387297, 38.6012353],
              [48.3384919, 38.6011707],
              [48.3382079, 38.6009668],
              [48.3379946, 38.6006868],
              [48.3376207, 38.6003004],
              [48.3369411, 38.5998952],
              [48.3356942, 38.5996784],
              [48.3334119, 38.5999759],
              [48.3321411, 38.6010417],
              [48.3299424, 38.6028884],
              [48.3298301, 38.6031052],
              [48.329807, 38.6032601],
              [48.3298235, 38.6038175],
              [48.3297674, 38.6038562],
              [48.3296716, 38.6038846],
              [48.3289319, 38.6039363],
              [48.3287219, 38.603958],
              [48.3283991, 38.604171],
              [48.3282043, 38.604264],
              [48.3279269, 38.6043052],
              [48.3269658, 38.6042769],
              [48.3263879, 38.6042098],
              [48.3258347, 38.6042457],
              [48.3211746, 38.6020176],
              [48.3102234, 38.6076539],
              [48.3083656, 38.6111998],
              [48.307157, 38.6130918],
              [48.3072358, 38.6206222],
              [48.3042708, 38.6219208],
              [48.303106, 38.6250552],
              [48.3028275, 38.625776],
              [48.300278, 38.629444],
              [48.296569, 38.6313734],
              [48.296944, 38.633611],
              [48.293611, 38.637778],
              [48.2958296, 38.642036],
              [48.2952436, 38.6455236],
              [48.2949419, 38.6473191],
              [48.2854652, 38.649176],
              [48.2833771, 38.6524101],
              [48.2784822, 38.6521196],
              [48.2754678, 38.6546514],
              [48.2681875, 38.657183],
              [48.2582341, 38.6576272],
              [48.252657, 38.6619076],
              [48.2530584, 38.6825838],
              [48.2515016, 38.6847685],
              [48.2503806, 38.685515],
              [48.2498833, 38.6863929],
              [48.2479729, 38.6891965],
              [48.248041, 38.6917769],
              [48.2522601, 38.6965666],
              [48.2583002, 38.6986486],
              [48.259391, 38.7085091],
              [48.2539181, 38.7135783],
              [48.2495889, 38.7168961],
              [48.2468845, 38.7217306],
              [48.2491558, 38.7260959],
              [48.2431049, 38.7288771],
              [48.2424671, 38.7312832],
              [48.2357116, 38.7320489],
              [48.2325418, 38.7324095],
              [48.2237072, 38.7346897],
              [48.2205007, 38.7378686],
              [48.2173601, 38.7364213],
              [48.2064716, 38.7398805],
              [48.2023756, 38.7437628],
              [48.2002006, 38.7449251],
              [48.2000531, 38.7462378],
              [48.1997534, 38.7489061],
              [48.190467, 38.7517875],
              [48.1918136, 38.7562153],
              [48.1726754, 38.7617366],
              [48.1631169, 38.7597045],
              [48.1482129, 38.7627958],
              [48.1447196, 38.7668058],
              [48.1360452, 38.7672396],
              [48.1329405, 38.7699824],
              [48.1298333, 38.7684374],
              [48.1213841, 38.7697913],
              [48.1204203, 38.7710563],
              [48.1157576, 38.7709194],
              [48.1115885, 38.7698762],
              [48.1073103, 38.7698813],
              [48.1055997, 38.7730359],
              [48.1041168, 38.7741581],
              [48.1027746, 38.7759556],
              [48.1011708, 38.7768986],
              [48.1022216, 38.7795217],
              [48.1038585, 38.7805091],
              [48.1047297, 38.7828996],
              [48.1070769, 38.7866635],
              [48.1071082, 38.7885576],
              [48.0931903, 38.7890377],
              [48.0882912, 38.7939844],
              [48.0783816, 38.7938976],
              [48.0797177, 38.8009266],
              [48.068472, 38.8031826],
              [48.0611234, 38.808649],
              [48.0488756, 38.8118591],
              [48.0448673, 38.8163705],
              [48.0408589, 38.815503],
              [48.0359609, 38.824387],
              [48.034789, 38.830722],
              [48.0207028, 38.8378898],
              [48.0129562, 38.8809304],
              [48.0118328, 38.8909225],
              [48.0107745, 38.9004693],
              [48.01027, 38.907306],
              [48.019223, 38.9120261],
              [48.0226406, 38.9098258],
              [48.0282078, 38.8994282],
              [48.0380272, 38.9008003],
              [48.0498167, 38.9049984],
              [48.0540902, 38.908744],
              [48.0629311, 38.9105692],
              [48.0692648, 38.9109368],
              [48.0795509, 38.9172993],
              [48.078535, 38.9207416],
              [48.0799833, 38.9240089],
              [48.0783123, 38.9272383],
              [48.0796942, 38.9302334],
              [48.0824656, 38.9338592],
              [48.0815724, 38.9372849],
              [48.0848494, 38.9392544],
              [48.0871923, 38.9445813],
              [48.0882345, 38.9469508],
              [48.1073052, 38.9431561],
              [48.1113935, 38.9461589],
              [48.1227535, 38.9469538],
              [48.1247362, 38.9466804],
              [48.127939, 38.945918],
              [48.1293556, 38.946455],
              [48.1313267, 38.9469248],
              [48.1347513, 38.9480754],
              [48.138089, 38.9479156],
              [48.1395288, 38.9469649],
              [48.1426918, 38.9463385],
              [48.1431281, 38.9462776],
              [48.1436752, 38.946255],
              [48.144194, 38.9461934],
              [48.1449112, 38.9458785],
              [48.1456799, 38.9458717],
              [48.1471086, 38.9461598],
              [48.1496539, 38.9479364],
              [48.1519715, 38.9492072],
              [48.152847, 38.9518138],
              [48.152481, 38.952757],
              [48.1548124, 38.9530575],
              [48.1565422, 38.9540406],
              [48.1587811, 38.9538064],
              [48.159215, 38.9532749],
              [48.1611304, 38.9529714],
              [48.1632172, 38.9535003],
              [48.1651341, 38.9548658],
              [48.1682119, 38.9551415],
              [48.1710632, 38.9557254],
              [48.1737917, 38.955175],
              [48.1767835, 38.9546729],
              [48.1781374, 38.9552131],
              [48.1794589, 38.9560189],
              [48.1825617, 38.9557547],
              [48.1851767, 38.9562114],
              [48.190793, 38.9560432],
              [48.2064008, 38.9532876],
              [48.2086872, 38.9540167],
              [48.2109092, 38.9556468],
              [48.2128179, 38.9555788],
              [48.2176851, 38.9554053],
              [48.2294145, 38.95977],
              [48.2327512, 38.9597761],
              [48.235745, 38.9610004],
              [48.2369545, 38.9637748],
              [48.2395571, 38.9649726],
              [48.2532906, 38.964558],
              [48.2585654, 38.9667263],
              [48.2707532, 38.9673018],
              [48.2772997, 38.9725795],
              [48.2853084, 38.9755466],
              [48.2888279, 38.977536],
              [48.2925906, 38.9796628],
              [48.2936239, 38.9815289],
              [48.2962055, 38.983356],
              [48.2973833, 38.9829474],
              [48.2984228, 38.9836805],
              [48.2982769, 38.986048],
              [48.3077952, 38.9961588],
              [48.3106045, 38.9982821],
              [48.3167221, 39.0019411],
              [48.3171236, 39.0052373],
              [48.3262227, 39.0113991],
              [48.3290971, 39.015785],
              [48.3332227, 39.0211657],
              [48.3352662, 39.0249188],
              [48.3374625, 39.0292592],
              [48.3370493, 39.0319564],
              [48.3392349, 39.034108],
              [48.3379248, 39.0373704],
              [48.3351548, 39.0393539],
              [48.3344401, 39.0436525],
              [48.332753, 39.0465774],
              [48.3324292, 39.0509497],
              [48.3311047, 39.0514506],
              [48.3309699, 39.0531113],
              [48.3279531, 39.05243],
              [48.326489, 39.0526846],
              [48.3258756, 39.0534923],
              [48.3266223, 39.0557804],
              [48.3273704, 39.0558168],
              [48.3276891, 39.0566609],
              [48.3266631, 39.0568829],
              [48.3267465, 39.0572901],
              [48.3264673, 39.0577199],
              [48.3252258, 39.0571835],
              [48.3240566, 39.0573299],
              [48.3229835, 39.0601883],
              [48.3247732, 39.0600828],
              [48.3225857, 39.0674917],
              [48.3213057, 39.0670646],
              [48.3194553, 39.0681359],
              [48.3200965, 39.069395],
              [48.3186515, 39.0709973],
              [48.3193044, 39.0720303],
              [48.3192445, 39.0722247],
              [48.3182938, 39.0753109],
              [48.3167804, 39.0764186],
              [48.3154117, 39.0785071],
              [48.3180867, 39.0791354],
              [48.3166385, 39.0825647],
              [48.3167452, 39.0851316],
              [48.3154651, 39.086208],
              [48.3135982, 39.0883194],
              [48.3109847, 39.0873672],
              [48.3098113, 39.0885678],
              [48.310878, 39.0901409],
              [48.3102913, 39.0911759],
              [48.3082908, 39.0903041],
              [48.3048509, 39.0911345],
              [48.3045889, 39.094138],
              [48.3033041, 39.0958951],
              [48.3060776, 39.0958537],
              [48.305971, 39.0971783],
              [48.3042108, 39.0979234],
              [48.304522, 39.09954],
              [48.3074111, 39.1019799],
              [48.3048509, 39.1028491],
              [48.3066764, 39.1039847],
              [48.3074073, 39.104364],
              [48.3076563, 39.1043264],
              [48.3078293, 39.1043389],
              [48.3079377, 39.1044159],
              [48.3079307, 39.1046091],
              [48.3078362, 39.1049312],
              [48.3077422, 39.1049641],
              [48.3072713, 39.1049688],
              [48.3067663, 39.1051745],
              [48.3063582, 39.1049956],
              [48.3061437, 39.105001],
              [48.3057576, 39.1053739],
              [48.3057062, 39.1055798],
              [48.3059541, 39.1057291],
              [48.3061497, 39.105843],
              [48.306091, 39.1060429],
              [48.3061334, 39.1062832],
              [48.3066817, 39.1064958],
              [48.3071932, 39.1066198],
              [48.307516, 39.1068526],
              [48.3080476, 39.1067893],
              [48.3082693, 39.1068349],
              [48.3083318, 39.1069544],
              [48.3083537, 39.1072621],
              [48.3082559, 39.1074797],
              [48.3080668, 39.1074797],
              [48.3078907, 39.1076872],
              [48.3078667, 39.1081982],
              [48.3077928, 39.1085272],
              [48.3075972, 39.1086386],
              [48.3073168, 39.1086031],
              [48.3068928, 39.1085424],
              [48.3066972, 39.1082641],
              [48.3063907, 39.1078946],
              [48.3061037, 39.1077631],
              [48.3058233, 39.107839],
              [48.3056407, 39.108011],
              [48.3057322, 39.1084881],
              [48.3056211, 39.1086993],
              [48.3051189, 39.1089371],
              [48.3046754, 39.1090738],
              [48.3028825, 39.108973],
              [48.3028303, 39.1092868],
              [48.3029738, 39.1104051],
              [48.3029282, 39.1108302],
              [48.3026738, 39.1109922],
              [48.3022825, 39.1110478],
              [48.2995663, 39.1115028],
              [48.2991971, 39.1138995],
              [48.2965442, 39.1134519],
              [48.2892642, 39.1169153],
              [48.2858627, 39.1147686],
              [48.2841559, 39.1155549],
              [48.2860227, 39.1175413],
              [48.2830704, 39.1195745],
              [48.2812756, 39.1192379],
              [48.2793021, 39.1203552],
              [48.2799955, 39.1225897],
              [48.2758189, 39.1234284],
              [48.2746084, 39.1221345],
              [48.2722616, 39.1230035],
              [48.2728991, 39.1246744],
              [48.2677279, 39.124038],
              [48.2664147, 39.1259872],
              [48.265061, 39.124038],
              [48.2606873, 39.1232932],
              [48.2594605, 39.1252793],
              [48.2587138, 39.1238311],
              [48.2568038, 39.1237637],
              [48.2565056, 39.1256549],
              [48.2508732, 39.1256517],
              [48.2472462, 39.1285895],
              [48.2439612, 39.1275703],
              [48.2424992, 39.1299135],
              [48.2387655, 39.1302445],
              [48.2349786, 39.1296652],
              [48.2341369, 39.1306144],
              [48.2358853, 39.1315271],
              [48.2339118, 39.1335957],
              [48.2306589, 39.133771],
              [48.2289216, 39.1380616],
              [48.2292181, 39.1413734],
              [48.2258573, 39.1423763],
              [48.2250044, 39.1450137],
              [48.2270822, 39.14705],
              [48.2210042, 39.1485341],
              [48.2209985, 39.1512466],
              [48.2184972, 39.1535759],
              [48.2164704, 39.1601107],
              [48.2184151, 39.1627439],
              [48.2138379, 39.1632016],
              [48.2134918, 39.1667067],
              [48.2100165, 39.1672237],
              [48.203616, 39.1723513],
              [48.2033849, 39.1746353],
              [48.1987708, 39.1758662],
              [48.1942819, 39.1748323],
              [48.1931619, 39.1765276],
              [48.1900683, 39.1762381],
              [48.1906908, 39.1784617],
              [48.1860679, 39.180042],
              [48.185491, 39.1818007],
              [48.1814511, 39.1825413],
              [48.1778698, 39.1840991],
              [48.1756671, 39.1856234],
              [48.1749157, 39.1877112],
              [48.172156, 39.1881704],
              [48.1703091, 39.1873122],
              [48.1699307, 39.1885123],
              [48.1716421, 39.1897558],
              [48.1689594, 39.1920887],
              [48.1673244, 39.1911694],
              [48.1665683, 39.188941],
              [48.1651093, 39.1906036],
              [48.1628377, 39.1892835],
              [48.1599867, 39.1929407],
              [48.1618712, 39.1940283],
              [48.1581544, 39.1948466],
              [48.1608555, 39.1969394],
              [48.1568789, 39.1985966],
              [48.1537987, 39.1976943],
              [48.1502833, 39.1982545],
              [48.1486109, 39.2000646],
              [48.1498555, 39.2009897],
              [48.1460902, 39.2030557],
              [48.1465959, 39.204069],
              [48.1448115, 39.2039946],
              [48.1434817, 39.2052906],
              [48.1448663, 39.2058855],
              [48.144455, 39.2066397],
              [48.1421725, 39.2065809],
              [48.1421519, 39.208095],
              [48.1408495, 39.2082012],
              [48.1408753, 39.2084125],
              [48.1412105, 39.2111584],
              [48.1439341, 39.2116535],
              [48.1445813, 39.2130962],
              [48.1423056, 39.2148073],
              [48.1370815, 39.2155152],
              [48.1371711, 39.2166681],
              [48.1357784, 39.2179669],
              [48.1385213, 39.2188284],
              [48.1387681, 39.220549],
              [48.1406251, 39.2209642],
              [48.1409432, 39.2219906],
              [48.1409608, 39.2222431],
              [48.1407362, 39.2223933],
              [48.1405864, 39.2226595],
              [48.1406657, 39.2227482],
              [48.1407758, 39.2227858],
              [48.141278, 39.2229154],
              [48.1415027, 39.2230622],
              [48.1415335, 39.2232226],
              [48.1415291, 39.2235161],
              [48.1415996, 39.2237516],
              [48.1418815, 39.223929],
              [48.1419873, 39.2241611],
              [48.1419872, 39.2243641],
              [48.1417978, 39.2245877],
              [48.1415379, 39.2247515],
              [48.1412956, 39.2247242],
              [48.1409697, 39.2245365],
              [48.1404146, 39.2242669],
              [48.139504, 39.2250376],
              [48.1376713, 39.2281318],
              [48.135752, 39.227261],
              [48.1345525, 39.2287016],
              [48.1356875, 39.2298571],
              [48.1330231, 39.2299514],
              [48.1336861, 39.2333203],
              [48.1359476, 39.2340804],
              [48.1348725, 39.235012],
              [48.1337816, 39.2354185],
              [48.1329867, 39.2353848],
              [48.132674, 39.2354091],
              [48.1329864, 39.2362478],
              [48.134424, 39.2374409],
              [48.1345813, 39.2381613],
              [48.1335795, 39.2392267],
              [48.1312959, 39.2384894],
              [48.1299803, 39.2411355],
              [48.1327911, 39.2424489],
              [48.1303421, 39.2439384],
              [48.1294711, 39.2463925],
              [48.1329808, 39.2469974],
              [48.1326195, 39.2483636],
              [48.1300603, 39.2483437],
              [48.1305877, 39.2493485],
              [48.1327053, 39.2525378],
              [48.1345071, 39.2528197],
              [48.133519, 39.2543103],
              [48.1349591, 39.2565405],
              [48.1359974, 39.2569215],
              [48.1366811, 39.2602979],
              [48.1347198, 39.2613213],
              [48.1315306, 39.2620038],
              [48.1332638, 39.2639022],
              [48.1335664, 39.2643421],
              [48.1333379, 39.2648405],
              [48.1328927, 39.2649959],
              [48.1323016, 39.2649962],
              [48.1317105, 39.2647937],
              [48.1304832, 39.2646399],
              [48.129801, 39.2649784],
              [48.1308019, 39.2669066],
              [48.1304583, 39.2690036],
              [48.1317234, 39.2690993],
              [48.1327705, 39.2699265],
              [48.1321556, 39.2707999],
              [48.1301963, 39.2710262],
              [48.1297734, 39.2713758],
              [48.1299685, 39.2716202],
              [48.1306723, 39.271724],
              [48.1312101, 39.2725829],
              [48.1308032, 39.273709],
              [48.1315741, 39.2737126],
              [48.1329187, 39.2727464],
              [48.1335888, 39.2719507],
              [48.1359403, 39.2714675],
              [48.1364119, 39.271571],
              [48.1366133, 39.273071],
              [48.1369394, 39.2734971],
              [48.1373946, 39.2731382],
              [48.1376896, 39.2732322],
              [48.1383528, 39.2742378],
              [48.1393242, 39.2745406],
              [48.1399686, 39.2744215],
              [48.1414754, 39.2754491],
              [48.1410013, 39.276201],
              [48.1408178, 39.2771217],
              [48.1415504, 39.2776676],
              [48.142283, 39.2779322],
              [48.1437136, 39.2765639],
              [48.1452598, 39.2765813],
              [48.146244, 39.2763132],
              [48.1469883, 39.2767059],
              [48.1471665, 39.2779213],
              [48.1463464, 39.2787001],
              [48.1456851, 39.2783992],
              [48.1450766, 39.2787273],
              [48.1425399, 39.2787996],
              [48.1426342, 39.2800452],
              [48.1416747, 39.2807002],
              [48.1420472, 39.2815727],
              [48.142858, 39.2818902],
              [48.1436062, 39.2817664],
              [48.1437494, 39.2831696],
              [48.1442481, 39.2838501],
              [48.1464546, 39.2827613],
              [48.1466337, 39.2831624],
              [48.1474045, 39.2830009],
              [48.1479172, 39.2820132],
              [48.148518, 39.281959],
              [48.1491098, 39.2821509],
              [48.1495331, 39.2823509],
              [48.1502606, 39.2820622],
              [48.1512913, 39.2824056],
              [48.1521585, 39.2829811],
              [48.1519663, 39.2838405],
              [48.1513038, 39.2840196],
              [48.1506533, 39.2848537],
              [48.1506989, 39.2852541],
              [48.1509261, 39.2854295],
              [48.1509235, 39.2861144],
              [48.1504635, 39.2867282],
              [48.1507308, 39.2870368],
              [48.1509039, 39.2874654],
              [48.1517322, 39.2874935],
              [48.1521626, 39.2871559],
              [48.1526014, 39.2870806],
              [48.1528584, 39.2872866],
              [48.153076, 39.2876897],
              [48.1539042, 39.2879156],
              [48.1539981, 39.2881951],
              [48.1537752, 39.2883312],
              [48.1537908, 39.2886972],
              [48.1539803, 39.2888872],
              [48.1542424, 39.2889225],
              [48.1540739, 39.2894552],
              [48.1540145, 39.2897911],
              [48.1536487, 39.2898366],
              [48.1533112, 39.2897314],
              [48.1527545, 39.2892495],
              [48.1521373, 39.2895949],
              [48.151838, 39.2900105],
              [48.1520748, 39.2907017],
              [48.1524332, 39.2909596],
              [48.1528644, 39.2911612],
              [48.1536068, 39.2920177],
              [48.1535435, 39.2922402],
              [48.1531548, 39.2924894],
              [48.153421, 39.2931518],
              [48.1539167, 39.2934304],
              [48.1542426, 39.2937446],
              [48.1546174, 39.2946088],
              [48.155792, 39.2951711],
              [48.1572427, 39.2952712],
              [48.1578529, 39.2948662],
              [48.158591, 39.2947284],
              [48.1592744, 39.2949726],
              [48.1597669, 39.2953833],
              [48.1590555, 39.2961214],
              [48.1594986, 39.2961901],
              [48.1597921, 39.2961198],
              [48.1602594, 39.295794],
              [48.1610187, 39.295499],
              [48.1614469, 39.2953003],
              [48.1616782, 39.2956233],
              [48.1615713, 39.2960296],
              [48.160955, 39.2965335],
              [48.1603036, 39.2970027],
              [48.160055, 39.2975141],
              [48.1604547, 39.2978819],
              [48.1609893, 39.2979885],
              [48.161771, 39.2978838],
              [48.1620235, 39.2973833],
              [48.1619237, 39.2968883],
              [48.1623407, 39.2963267],
              [48.1628002, 39.296152],
              [48.1633394, 39.296239],
              [48.1635974, 39.2963019],
              [48.1638352, 39.296734],
              [48.1638903, 39.2970874],
              [48.1631637, 39.2976973],
              [48.1630283, 39.2981249],
              [48.1632611, 39.2986626],
              [48.1633045, 39.2991855],
              [48.163136, 39.299397],
              [48.1626747, 39.2996029],
              [48.1623977, 39.2998878],
              [48.1625348, 39.3001414],
              [48.1628658, 39.3002366],
              [48.1635459, 39.3002449],
              [48.1638486, 39.3001641],
              [48.1641347, 39.3002082],
              [48.1643962, 39.3005477],
              [48.1647109, 39.3007915],
              [48.1652642, 39.3009261],
              [48.1669529, 39.2997466],
              [48.1674186, 39.2997418],
              [48.1681664, 39.3004774],
              [48.168137, 39.3010613],
              [48.1686692, 39.3021522],
              [48.1675955, 39.3025533],
              [48.1682997, 39.3030509],
              [48.1692013, 39.3032736],
              [48.168611, 39.3039208],
              [48.1678642, 39.3041468],
              [48.1676306, 39.3044775],
              [48.1687899, 39.3047769],
              [48.1697517, 39.3053207],
              [48.1701693, 39.3052555],
              [48.1696805, 39.3045713],
              [48.1704696, 39.3041167],
              [48.1712193, 39.3037844],
              [48.172108, 39.3041699],
              [48.1735052, 39.304077],
              [48.17431, 39.3045035],
              [48.1739432, 39.3048153],
              [48.1732755, 39.3049719],
              [48.1733778, 39.3057636],
              [48.1736568, 39.306254],
              [48.1743371, 39.3060846],
              [48.1759468, 39.30555],
              [48.1770935, 39.3058288],
              [48.1790704, 39.3058456],
              [48.1806848, 39.3062123],
              [48.1808161, 39.3067303],
              [48.180172, 39.3067464],
              [48.1796914, 39.3072523],
              [48.1795952, 39.3078747],
              [48.1812288, 39.30884],
              [48.1816667, 39.3090177],
              [48.1825152, 39.3086333],
              [48.1831692, 39.3086299],
              [48.1834756, 39.3089653],
              [48.1832981, 39.3094365],
              [48.1830295, 39.3096112],
              [48.1826907, 39.3100955],
              [48.1833491, 39.3105524],
              [48.1842416, 39.3107995],
              [48.1858351, 39.3094633],
              [48.1861753, 39.3093491],
              [48.1864327, 39.3095141],
              [48.1864789, 39.3106668],
              [48.1860438, 39.3118195],
              [48.186173, 39.3125383],
              [48.186997, 39.3129134],
              [48.188033, 39.3128263],
              [48.1887805, 39.3122404],
              [48.1888884, 39.3114196],
              [48.188533, 39.3105769],
              [48.1887333, 39.3103523],
              [48.1919502, 39.3108256],
              [48.1925494, 39.3104198],
              [48.1931978, 39.3108019],
              [48.1928807, 39.3112666],
              [48.1928581, 39.3114757],
              [48.1939628, 39.3115766],
              [48.1940491, 39.3121308],
              [48.1943073, 39.3124778],
              [48.1945933, 39.3132819],
              [48.1946218, 39.3135909],
              [48.1947575, 39.3150594],
              [48.1942724, 39.316496],
              [48.1944161, 39.3172739],
              [48.1948351, 39.318064],
              [48.1955981, 39.3188784],
              [48.197339, 39.3197073],
              [48.1981901, 39.3198889],
              [48.1995375, 39.3198346],
              [48.2008515, 39.3194441],
              [48.2012291, 39.3199921],
              [48.2009962, 39.3204427],
              [48.2012315, 39.3210486],
              [48.201728, 39.3209733],
              [48.2022209, 39.3214342],
              [48.2032489, 39.3215978],
              [48.2036557, 39.3218566],
              [48.2035649, 39.3224739],
              [48.2026565, 39.3229723],
              [48.2027486, 39.32329],
              [48.2029411, 39.3233692],
              [48.2030833, 39.3234278],
              [48.2041495, 39.3232014],
              [48.2049, 39.3232952],
              [48.2051489, 39.3235441],
              [48.2058847, 39.3254714],
              [48.211001, 39.3291082],
              [48.2133439, 39.3298023],
              [48.2160689, 39.3296865],
              [48.2164588, 39.329272],
              [48.2155985, 39.3290625],
              [48.2151546, 39.3286186],
              [48.2156865, 39.3284385],
              [48.217244, 39.3288027],
              [48.2177092, 39.3282113],
              [48.2180419, 39.3279186],
              [48.218564, 39.3278217],
              [48.2194269, 39.3282388],
              [48.2201728, 39.3285654],
              [48.2208206, 39.328188],
              [48.2211979, 39.3279032],
              [48.2214804, 39.3278571],
              [48.2220182, 39.3283152],
              [48.2231478, 39.3288286],
              [48.2238689, 39.3285529],
              [48.2242894, 39.3283299],
              [48.2246356, 39.3278658],
              [48.2251177, 39.3274821],
              [48.2257168, 39.3274734],
              [48.2261075, 39.327637],
              [48.2265007, 39.3282654],
              [48.2265319, 39.3294986],
              [48.2279515, 39.3301186],
              [48.2279083, 39.3306474],
              [48.2281058, 39.3309053],
              [48.2286288, 39.3305852],
              [48.2289293, 39.3300919],
              [48.2291107, 39.3298959],
              [48.2293351, 39.329869],
              [48.2294926, 39.3299972],
              [48.2301985, 39.3300332],
              [48.2303164, 39.3312962],
              [48.2328581, 39.3304746],
              [48.2339319, 39.3313073],
              [48.2321689, 39.3318224],
              [48.232094, 39.3326663],
              [48.2313361, 39.3332587],
              [48.2323437, 39.3341869],
              [48.2340746, 39.3342963],
              [48.2357829, 39.3335987],
              [48.2356861, 39.3349421],
              [48.2371769, 39.3347066],
              [48.2400707, 39.3323041],
              [48.2437186, 39.3324452],
              [48.2460159, 39.3295356],
              [48.2478115, 39.3307088],
              [48.2500892, 39.3298723],
              [48.250331, 39.331646],
              [48.2552065, 39.3334862],
              [48.2551934, 39.3325176],
              [48.2573683, 39.332421],
              [48.2584629, 39.3321262],
              [48.2585502, 39.3331099],
              [48.2578155, 39.3336312],
              [48.2587373, 39.3349629],
              [48.2632133, 39.3354359],
              [48.2653165, 39.3334445],
              [48.2667994, 39.3341223],
              [48.2673109, 39.3354359],
              [48.2650329, 39.3373921],
              [48.2628475, 39.3373976],
              [48.2614349, 39.3384431],
              [48.2624852, 39.3399],
              [48.2639923, 39.3383763],
              [48.2658679, 39.3404784],
              [48.2684237, 39.340527],
              [48.2687377, 39.3391256],
              [48.2725597, 39.3398507],
              [48.2732928, 39.3412642],
              [48.2767843, 39.3414108],
              [48.277541, 39.3427113],
              [48.2768594, 39.3438963],
              [48.2773891, 39.3450171],
              [48.2783297, 39.3455311],
              [48.2807678, 39.3441005],
              [48.282066, 39.3459014],
              [48.2832937, 39.3452377],
              [48.2842912, 39.3467181],
              [48.2863322, 39.3469091],
              [48.2876178, 39.3480559],
              [48.2893222, 39.3476913],
              [48.2925315, 39.3500741],
              [48.2935039, 39.3506096],
              [48.2935795, 39.3524741],
              [48.2941477, 39.3515172],
              [48.2944371, 39.3510622],
              [48.2953568, 39.351149],
              [48.2958315, 39.3506344],
              [48.2965822, 39.3502866],
              [48.2974003, 39.3502528],
              [48.298002, 39.3503872],
              [48.2982376, 39.35132],
              [48.2976886, 39.352296],
              [48.2976788, 39.3528252],
              [48.2984513, 39.3530066],
              [48.2990827, 39.3518111],
              [48.2994909, 39.3515797],
              [48.2997339, 39.3516527],
              [48.3002028, 39.3527169],
              [48.3006591, 39.3523088],
              [48.3009094, 39.352283],
              [48.3010429, 39.353963],
              [48.3014572, 39.3540417],
              [48.3020491, 39.3537592],
              [48.3023298, 39.3536881],
              [48.3025623, 39.3545187],
              [48.3031311, 39.3552915],
              [48.3049512, 39.3539445],
              [48.3067644, 39.3563839],
              [48.3073957, 39.3557317],
              [48.3076726, 39.3557514],
              [48.3077159, 39.3565259],
              [48.3094313, 39.3580313],
              [48.3100353, 39.3577313],
              [48.3104251, 39.3579526],
              [48.3116695, 39.3579937],
              [48.3120025, 39.3585063],
              [48.3113434, 39.3583837],
              [48.3110367, 39.3592451],
              [48.3104125, 39.3595501],
              [48.3104015, 39.3602303],
              [48.3115218, 39.3605061],
              [48.3150508, 39.3622257],
              [48.3177921, 39.3623364],
              [48.3187662, 39.3625137],
              [48.3205691, 39.3628419],
              [48.3261793, 39.3632927],
              [48.3267261, 39.3632205],
              [48.3270571, 39.3634138],
              [48.3271247, 39.3636018],
              [48.3273341, 39.363654],
              [48.3275435, 39.3635913],
              [48.3283811, 39.3638577],
              [48.3289882, 39.3639305],
              [48.330097, 39.3643225],
              [48.3298403, 39.3651947],
              [48.329874, 39.3657222],
              [48.3304009, 39.3660512],
              [48.3309751, 39.3660251],
              [48.3315291, 39.3654193],
              [48.3319479, 39.3652156],
              [48.3326707, 39.3654715],
              [48.3328531, 39.3657848],
              [48.3329556, 39.3665056],
              [48.3331908, 39.3666152],
              [48.3336097, 39.3663698],
              [48.3343933, 39.3659154],
              [48.3357511, 39.3663698],
              [48.3368049, 39.366516],
              [48.3369265, 39.3674508],
              [48.3368991, 39.3681076],
              [48.3369468, 39.3683366],
              [48.3371761, 39.3684843],
              [48.3375869, 39.3683956],
              [48.3384372, 39.3682701],
              [48.3393829, 39.3686394],
              [48.3400039, 39.3691785],
              [48.3404433, 39.3694592],
              [48.3406822, 39.3694148],
              [48.3407204, 39.3691342],
              [48.3407395, 39.3685877],
              [48.341179, 39.3683292],
              [48.341542, 39.368307],
              [48.342164, 39.3689166],
              [48.34263, 39.3693942],
              [48.3427028, 39.3696169],
              [48.3425213, 39.3702262],
              [48.3425069, 39.3704404],
              [48.342655, 39.3706656],
              [48.3428795, 39.3706878],
              [48.343424, 39.370902],
              [48.3444224, 39.3712971],
              [48.3451024, 39.3713108],
              [48.346419, 39.3709869],
              [48.3467486, 39.3710977],
              [48.3474078, 39.3712675],
              [48.3478138, 39.3714928],
              [48.3481004, 39.3715482],
              [48.348215, 39.3714928],
              [48.3479619, 39.3707284],
              [48.3476275, 39.3702188],
              [48.3477469, 39.3700379],
              [48.3484443, 39.3700674],
              [48.3489172, 39.370012],
              [48.3491041, 39.3701453],
              [48.3493566, 39.3704367],
              [48.349813, 39.3705949],
              [48.3507514, 39.3703813],
              [48.3522288, 39.3702695],
              [48.3530191, 39.3702591],
              [48.3537604, 39.3704943],
              [48.3539243, 39.3705463],
              [48.3541675, 39.3705149],
              [48.3542621, 39.3704314],
              [48.3545053, 39.3701598],
              [48.3557635, 39.3698189],
              [48.3566132, 39.3699867],
              [48.3576975, 39.3700827],
              [48.3587919, 39.3701124],
              [48.35926, 39.3702342],
              [48.3599138, 39.3703596],
              [48.360475, 39.3705374],
              [48.360728, 39.3706329],
              [48.3613014, 39.3708217],
              [48.3614958, 39.3709825],
              [48.3615244, 39.3712225],
              [48.3612665, 39.3719093],
              [48.3612139, 39.372478],
              [48.3613572, 39.3729285],
              [48.3618063, 39.3734122],
              [48.3623365, 39.3737593],
              [48.362795, 39.3739771],
              [48.3635545, 39.3741618],
              [48.3639557, 39.3743759],
              [48.3645961, 39.3748631],
              [48.3652379, 39.3756005],
              [48.3653595, 39.3763733],
              [48.3652109, 39.3770312],
              [48.3654609, 39.3775795],
              [48.3658189, 39.3778302],
              [48.366231, 39.3779241],
              [48.3668187, 39.3779502],
              [48.3671969, 39.3778093],
              [48.3674131, 39.3775169],
              [48.3675279, 39.37712],
              [48.3676428, 39.3770678],
              [48.3680639, 39.3776466],
              [48.3683866, 39.3783511],
              [48.3686221, 39.3798361],
              [48.3683809, 39.3806818],
              [48.3679557, 39.381375],
              [48.3658203, 39.3839464],
              [48.3641866, 39.3861805],
              [48.3604281, 39.3909207],
              [48.360179, 39.3912349],
              [48.3590224, 39.3927811],
              [48.3610586, 39.3940615],
              [48.3586518, 39.3973015],
              [48.3561952, 39.4006082],
              [48.3550117, 39.4022013],
              [48.3504217, 39.408946],
              [48.3444601, 39.416345],
              [48.3429278, 39.4182466],
              [48.3382318, 39.4225349],
              [48.3321995, 39.4287044],
              [48.2538929, 39.4983066],
              [48.1755484, 39.5678729],
              [48.1370862, 39.602],
              [48.1271866, 39.6068288],
              [48.1190778, 39.6141473],
              [48.0951619, 39.6354594],
              [48.0868736, 39.6428802],
              [48.0805903, 39.6484605],
              [48.068392, 39.6594793],
              [48.0622791, 39.6649358],
              [48.0488871, 39.6768808],
              [48.0422669, 39.6828259],
              [48.0316267, 39.6922285],
              [47.9984402, 39.7045285],
              [47.9897964, 39.7076149],
              [47.9856061, 39.709146],
              [47.9821222, 39.7090003],
              [47.9815228, 39.7072158],
              [47.9798896, 39.7061476],
              [47.9806288, 39.7050874],
              [47.9804798, 39.7039093],
              [47.9785812, 39.7016562],
              [47.9760733, 39.7009088],
              [47.974088, 39.6993454],
              [47.9736028, 39.6969993],
              [47.9737014, 39.6939518],
              [47.9729523, 39.6928617],
              [47.9716699, 39.6920246],
              [47.9671228, 39.6928782],
              [47.9635195, 39.6922164],
              [47.9616601, 39.6900503],
              [47.9608897, 39.68593],
              [47.9580829, 39.6851506],
              [47.9548022, 39.6836879],
              [47.9500178, 39.6804673],
              [47.947699, 39.6796777],
              [47.9464761, 39.6801535],
              [47.9445448, 39.6830041],
              [47.9427999, 39.6834684],
              [47.9406182, 39.6829105],
              [47.9389386, 39.6813534],
              [47.9373351, 39.6750449],
              [47.9353226, 39.6720802],
              [47.9293835, 39.6658206],
              [47.9280497, 39.6658677],
              [47.9272923, 39.6666071],
              [47.9276342, 39.6682324],
              [47.9273393, 39.6694157],
              [47.9261092, 39.6702496],
              [47.9247705, 39.6710871],
              [47.9234488, 39.670712],
              [47.9220547, 39.6686772],
              [47.9216075, 39.6656374],
              [47.9210908, 39.6642779],
              [47.9204016, 39.6632005],
              [47.9174231, 39.6614998],
              [47.9156627, 39.6614079],
              [47.9145743, 39.6613511],
              [47.9067093, 39.6625873],
              [47.9007768, 39.6648826],
              [47.8989861, 39.6649341],
              [47.8961014, 39.6631663],
              [47.8934783, 39.6618461],
              [47.892077, 39.6619075],
              [47.8907759, 39.6625935],
              [47.8904629, 39.6636657],
              [47.8913276, 39.6654713],
              [47.8905456, 39.6662495],
              [47.8869289, 39.665829],
              [47.8852772, 39.6661445],
              [47.8842309, 39.6671661],
              [47.8842256, 39.66957],
              [47.8836436, 39.6702901],
              [47.881938, 39.6706601],
              [47.8800024, 39.670673],
              [47.8705843, 39.6673582],
              [47.8704847, 39.6672874],
              [47.8670816, 39.6648693],
              [47.8653717, 39.6645469],
              [47.86378, 39.6645415],
              [47.8612282, 39.6665549],
              [47.8582512, 39.6680456],
              [47.8564645, 39.6684205],
              [47.8549642, 39.6673588],
              [47.8542912, 39.6648803],
              [47.8531618, 39.6642648],
              [47.8521957, 39.6642399],
              [47.8490975, 39.6657234],
              [47.8475559, 39.6659795],
              [47.8456992, 39.6654813],
              [47.8376276, 39.66163],
              [47.8377395, 39.6598409],
              [47.8369262, 39.6588828],
              [47.8337345, 39.6596784],
              [47.8309258, 39.6611635],
              [47.829286, 39.6606037],
              [47.8265281, 39.6606127],
              [47.8245321, 39.661616],
              [47.8217986, 39.6614963],
              [47.8213265, 39.660229],
              [47.8218635, 39.658998],
              [47.8211375, 39.6578786],
              [47.8200156, 39.6570057],
              [47.8187168, 39.6563584],
              [47.8166913, 39.6560128],
              [47.8151634, 39.6564373],
              [47.8126504, 39.6589767],
              [47.8103114, 39.6596595],
              [47.8073216, 39.6591904],
              [47.806456, 39.6583584],
              [47.8060431, 39.657497],
              [47.8066225, 39.6560211],
              [47.8086757, 39.6546185],
              [47.8091634, 39.6532848],
              [47.8081522, 39.6512128],
              [47.8064087, 39.6505589],
              [47.8009623, 39.6516644],
              [47.7977843, 39.6498605],
              [47.7951841, 39.6489852],
              [47.7939968, 39.648295],
              [47.7944195, 39.645353],
              [47.7953469, 39.6445095],
              [47.7952144, 39.6436863],
              [47.7943419, 39.6422899],
              [47.790225, 39.6415683],
              [47.7889648, 39.6417538],
              [47.7870726, 39.6429023],
              [47.7858912, 39.6430749],
              [47.7846002, 39.6420958],
              [47.7839648, 39.6399899],
              [47.7832698, 39.6389851],
              [47.7833047, 39.6375735],
              [47.7859763, 39.6343092],
              [47.7851887, 39.6329715],
              [47.7831718, 39.6320441],
              [47.7822949, 39.6306698],
              [47.7827554, 39.6269438],
              [47.7818056, 39.6254238],
              [47.7781398, 39.6243867],
              [47.7751207, 39.624463],
              [47.7724422, 39.6267149],
              [47.7703036, 39.6265627],
              [47.7667662, 39.6232932],
              [47.7638983, 39.6226147],
              [47.7626791, 39.6216049],
              [47.7622771, 39.619715],
              [47.7623779, 39.6170823],
              [47.7600698, 39.6154731],
              [47.757694, 39.6123114],
              [47.752969, 39.606023],
              [47.7488031, 39.6048321],
              [47.7438107, 39.6019979],
              [47.7382045, 39.5978525],
              [47.7267626, 39.5965523],
              [47.7260488, 39.5948568],
              [47.7158801, 39.5894546],
              [47.7122848, 39.5919465],
              [47.7110735, 39.5919417],
              [47.70623, 39.5897996],
              [47.7043418, 39.5853129],
              [47.7000315, 39.5849335],
              [47.6953864, 39.5856956],
              [47.690822, 39.5875997],
              [47.688767, 39.5871823],
              [47.6872097, 39.5833106],
              [47.683929, 39.582163],
              [47.6821785, 39.579786],
              [47.6798198, 39.5781003],
              [47.6764872, 39.577494],
              [47.6740371, 39.5785064],
              [47.6727821, 39.5788537],
              [47.6722379, 39.578827],
              [47.6713732, 39.578646],
              [47.6702124, 39.5781315],
              [47.6680746, 39.5765808],
              [47.6663986, 39.5756181],
              [47.6647226, 39.5742193],
              [47.6624943, 39.5720186],
              [47.6597666, 39.5665631],
              [47.6567379, 39.5642199],
              [47.6493905, 39.5616959],
              [47.6466707, 39.5632393],
              [47.6439572, 39.5629557],
              [47.6403072, 39.5577743],
              [47.6305445, 39.5539267],
              [47.6256768, 39.5536143],
              [47.6243193, 39.5528063],
              [47.6200787, 39.5459405],
              [47.6174203, 39.5447009],
              [47.61297, 39.5390449],
              [47.6120516, 39.5388494],
              [47.6103432, 39.539445],
              [47.6094999, 39.5410385],
              [47.6085447, 39.5418984],
              [47.6052974, 39.542684],
              [47.601585, 39.5406725],
              [47.5982943, 39.538285],
              [47.5956295, 39.537732],
              [47.5944747, 39.5373435],
              [47.5926145, 39.5353876],
              [47.5865502, 39.5328854],
              [47.5842191, 39.5320159],
              [47.5814079, 39.5287147],
              [47.579766, 39.5285769],
              [47.5781854, 39.5280503],
              [47.5757939, 39.5278994],
              [47.573029, 39.5256425],
              [47.5705696, 39.5202637],
              [47.56666, 39.5161755],
              [47.5629369, 39.5137751],
              [47.5509836, 39.510387],
              [47.5489591, 39.5087952],
              [47.5459707, 39.5083232],
              [47.542588, 39.5067958],
              [47.5400905, 39.5044331],
              [47.5296314, 39.4987857],
              [47.5271609, 39.4990145],
              [47.5240186, 39.5002583],
              [47.5204911, 39.4999869],
              [47.514069, 39.496702],
              [47.5077122, 39.4982146],
              [47.5050038, 39.4974353],
              [47.4998212, 39.4901826],
              [47.4979735, 39.4890872],
              [47.4899105, 39.4878796],
              [47.4865006, 39.4890482],
              [47.4786454, 39.4854826],
              [47.4692849, 39.4801792],
              [47.4673152, 39.4806193],
              [47.458673, 39.4804322],
              [47.4465476, 39.4783618],
              [47.4426911, 39.4791282],
              [47.4411646, 39.4781975],
              [47.4403271, 39.4756265],
              [47.4414633, 39.4717697],
              [47.4394449, 39.4706707],
              [47.4323824, 39.4717833],
              [47.4300312, 39.4711476],
              [47.4262484, 39.4677948],
              [47.4230461, 39.4665623],
              [47.4205853, 39.4648042],
              [47.4131742, 39.4639106],
              [47.4056581, 39.4640193],
              [47.4036193, 39.4650156],
              [47.4007879, 39.4677902],
              [47.3967342, 39.4696437],
              [47.3950171, 39.4691194],
              [47.3942473, 39.4669402],
              [47.3930891, 39.4658471],
              [47.388474, 39.4639535],
              [47.3867893, 39.4599575],
              [47.3831047, 39.4573544],
              [47.3797216, 39.4566513],
              [47.3775701, 39.4549047],
              [47.3771311, 39.4523226],
              [47.3797286, 39.4480915],
              [47.380262, 39.4461125],
              [47.3698156, 39.4319776],
              [47.3652358, 39.422963],
              [47.363399, 39.4217256],
              [47.3663364, 39.419788],
              [47.3796727, 39.4058968],
              [47.4005061, 39.3733987],
              [47.4032828, 39.3703423],
              [47.4041164, 39.3695088],
              [47.4049493, 39.3683973],
              [47.4293961, 39.3431212],
              [47.439111, 39.3372671],
              [47.4387849, 39.335218],
              [47.4374014, 39.331955],
              [47.4338319, 39.3285859],
              [47.4338318, 39.3285858],
              [47.430553, 39.3250177],
              [47.4300068, 39.3215823],
              [47.4300068, 39.3215822],
              [47.4307925, 39.3186376],
              [47.4342933, 39.3160379],
              [47.4412604, 39.3146716],
              [47.4469293, 39.3123897],
              [47.4508565, 39.3113016],
              [47.454152, 39.3112482],
              [47.4591378, 39.3106373],
              [47.463594, 39.3097876],
              [47.4635941, 39.3097876],
              [47.4700137, 39.3083933],
              [47.4756474, 39.3065347],
              [47.4791124, 39.3043582],
              [47.4840637, 39.3041709],
              [47.4867257, 39.3017425],
              [47.4906687, 39.300441],
              [47.4953635, 39.3000278],
              [47.4999372, 39.2976911],
              [47.5049348, 39.2954356],
              [47.5049349, 39.2954356],
              [47.5024554, 39.2931205],
              [47.5018987, 39.2928425],
              [47.4920538, 39.2866052],
              [47.4913457, 39.286173],
              [47.4886135, 39.283952],
              [47.4817778, 39.2758623],
              [47.4817765, 39.2758608],
              [47.4813429, 39.2753441],
              [47.4813425, 39.2753437],
              [47.4813425, 39.2753436],
              [47.4813424, 39.2753436],
              [47.4813421, 39.2753399],
              [47.4810658, 39.2725645],
              [47.4821758, 39.2706193],
              [47.4852324, 39.2686738],
              [47.4866223, 39.2672842],
              [47.4868992, 39.2664505],
              [47.4882891, 39.2650608],
              [47.4888459, 39.2639495],
              [47.4893989, 39.2636714],
              [47.4905127, 39.2611701],
              [47.4905127, 39.2608924],
              [47.4907892, 39.2600584],
              [47.5077548, 39.2431443],
              [47.5084416, 39.2403773],
              [47.5088455, 39.2389542],
              [47.5091403, 39.2369903],
              [47.5099533, 39.2343706],
              [47.5116521, 39.2309754],
              [47.5144958, 39.2258705],
              [47.5172189, 39.2213192],
              [47.517924, 39.2199805],
              [47.5188467, 39.218199],
              [47.5218496, 39.2126346],
              [47.5258149, 39.2052431],
              [47.5281412, 39.1899164],
              [47.5301311, 39.1780475],
              [47.532022, 39.1656202],
              [47.5286531, 39.1519576],
              [47.5247105, 39.1453012],
              [47.524293, 39.1408742],
              [47.5310675, 39.1309525],
              [47.5364748, 39.1188199],
              [47.5355971, 39.1074665],
              [47.530514, 39.0896069],
              [47.5299684, 39.0833072],
              [47.5308433, 39.0795299],
              [47.528658, 39.0733013],
              [47.5241562, 39.0626094],
              [47.5239449, 39.0586929],
              [47.5263256, 39.0515615],
              [47.5254791, 39.0481725],
              [47.5236151, 39.0476459],
              [47.5222771, 39.0473867],
              [47.5190276, 39.0467087],
              [47.5181655, 39.0450922],
              [47.5194913, 39.043055],
              [47.5245275, 39.0411904],
              [47.5256219, 39.0392197],
              [47.5244406, 39.0380581],
              [47.5170628, 39.0395188],
              [47.512285, 39.0390813],
              [47.509048, 39.0379005],
              [47.5063953, 39.0352981],
              [47.505214, 39.0320349],
              [47.5061237, 39.0288643],
              [47.5087797, 39.0268974],
              [47.5137128, 39.0255168],
              [47.5169102, 39.0245934],
              [47.520724, 39.0236932],
              [47.5250583, 39.0229816],
              [47.5268274, 39.0227733],
              [47.5275593, 39.021692],
              [47.528011, 39.0196802],
              [47.5270719, 39.0167763],
              [47.525159, 39.0122755],
              [47.5261516, 39.0092667],
              [47.5258953, 39.0079994],
              [47.5038897, 38.9998991],
              [47.5005063, 38.9987196],
              [47.5019641, 38.9975383],
              [47.5038707, 38.9965036],
              [47.5073959, 38.9943342],
              [47.5271156, 38.9902972],
              [47.5332931, 38.9875584],
              [47.5377553, 38.9858795],
              [47.5500805, 38.9814536],
              [47.5581264, 38.9796851],
              [47.5624417, 38.978736],
              [47.5667554, 38.9764004],
              [47.5682947, 38.9721852],
              [47.5673935, 38.9683035],
              [47.559514, 38.9664163],
              [47.5559949, 38.9652818],
              [47.5510168, 38.9645811],
              [47.5469827, 38.9633464],
              [47.5413823, 38.9624038],
              [47.5380671, 38.9613359],
              [47.5339579, 38.9607603],
              [47.5316727, 38.9601847],
              [47.5304352, 38.9604058],
              [47.5267154, 38.9579114],
              [47.5243994, 38.9558894],
              [47.5246618, 38.9537033],
              [47.5240299, 38.9511984],
              [47.5240261, 38.9502513],
              [47.524027, 38.948085],
              [47.5229238, 38.948038],
              [47.5216233, 38.9328372],
              [47.5248718, 38.9297448],
              [47.5209331, 38.9274326],
              [47.5232505, 38.9257633],
              [47.5223922, 38.9223578],
              [47.518444, 38.9188854],
              [47.516384, 38.9158134],
              [47.517929, 38.9108046],
              [47.5223523, 38.9036012],
              [47.5285368, 38.8958943],
              [47.533675, 38.8915521],
              [47.5543351, 38.8839918],
              [47.5615724, 38.8803171],
              [47.5657535, 38.876982],
              [47.5704073, 38.8702163],
              [47.5707949, 38.86585],
              [47.5699395, 38.8636577],
              [47.5696563, 38.8615431],
              [47.5680466, 38.8600485],
              [47.5630331, 38.8537456],
              [47.5580978, 38.8356963],
              [47.5531411, 38.8270544],
              [47.5528556, 38.8255908],
              [47.5469096, 38.8213111],
              [47.5427702, 38.817288],
              [47.5374511, 38.8134761],
              [47.5283348, 38.8097792],
              [47.5150966, 38.8011895],
              [47.5075289, 38.7935134],
              [47.5011062, 38.7876095],
              [47.4972102, 38.7847951],
              [47.4941952, 38.7834922],
              [47.4894531, 38.7822578],
              [47.4831581, 38.7807034],
              [47.4723434, 38.7782065],
              [47.4661908, 38.7750252],
              [47.4590396, 38.7710689],
              [47.4559688, 38.7672688],
              [47.4545916, 38.7652107],
              [47.4330119, 38.7192135],
              [47.4332884, 38.7181006],
              [47.4327318, 38.7083805],
              [47.4330119, 38.7069893],
              [47.4343983, 38.7033812],
              [47.4357886, 38.7008771],
              [47.4357886, 38.7003296],
              [47.4360651, 38.7000515],
              [47.4366218, 38.7000514],
              [47.4396785, 38.6983819],
              [47.4405117, 38.698382],
              [47.4416219, 38.6978256],
              [47.4424552, 38.6978255],
              [47.4430118, 38.6975473],
              [47.4441215, 38.6975473],
              [47.4446782, 38.6972691],
              [47.4457884, 38.6972691],
              [47.4485686, 38.6964343],
              [47.4491218, 38.6958779],
              [47.4513452, 38.6922697],
              [47.4560685, 38.6886615],
              [47.4577348, 38.6886615],
              [47.4582883, 38.6883833],
              [47.4594017, 38.6883833],
              [47.4607885, 38.6878269],
              [47.4619018, 38.6878269],
              [47.4630115, 38.6875486],
              [47.4674581, 38.6875486],
              [47.4724582, 38.6894963],
              [47.4757915, 38.6894963],
              [47.4796779, 38.6886616],
              [47.4880148, 38.6858792],
              [47.4969014, 38.683384],
              [47.4991245, 38.6825492],
              [47.5007913, 38.682271],
              [47.5107912, 38.6769933],
              [47.5127377, 38.6764368],
              [47.5257943, 38.6697677],
              [47.566456, 38.6442899],
              [47.565241, 38.6406042],
              [47.5666274, 38.637274],
              [47.5671841, 38.6347696],
              [47.567184, 38.6286565],
              [47.5699607, 38.6161609],
              [47.5688509, 38.6117084],
              [47.5595749, 38.5738529],
              [47.5585343, 38.5675032],
              [47.5551435, 38.5581357],
              [47.5456134, 38.5507],
              [47.5361251, 38.5480312],
              [47.5220489, 38.546353],
              [47.5139808, 38.5422581],
              [47.506652, 38.5353744],
              [47.502737, 38.5271517],
              [47.5004194, 38.5171463],
              [47.4972438, 38.511337],
              [47.4864292, 38.502236],
              [47.4830389, 38.4983401],
              [47.4810218, 38.4942088],
              [47.476693, 38.4891845],
              [47.4737748, 38.4860692],
              [47.4717767, 38.4840104],
              [47.4684962, 38.4805015],
              [47.4598739, 38.473628],
              [47.4410663, 38.4500356],
              [47.415233, 38.4155972],
              [47.4113431, 38.412544],
              [47.3988435, 38.4053147],
              [47.384677, 38.3992079],
              [47.38023, 38.3961456],
              [47.345784, 38.3569797],
              [47.3402307, 38.3533691],
              [47.334951, 38.3505939],
              [47.3316173, 38.3492018],
              [47.3191178, 38.3433728],
              [47.2974517, 38.3366995],
              [47.2952282, 38.3358732],
              [47.2907813, 38.3319841],
              [47.2893945, 38.3167061],
              [47.2888383, 38.3155923],
              [47.2888384, 38.3142001],
              [47.2874485, 38.3069785],
              [47.287172, 38.3061522],
              [47.2871719, 38.3053169],
              [47.2871719, 38.3044815]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 269900,
        "tags": {
          "ISO3166-2": "IR-02",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "مازندران",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q308864"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [50.3342888, 36.6376263],
              [50.3369951, 36.6364853],
              [50.3389262, 36.6354351],
              [50.3417801, 36.6325767],
              [50.3489684, 36.6297183],
              [50.3551482, 36.6282718],
              [50.3547191, 36.6230366],
              [50.3542041, 36.6220722],
              [50.352745, 36.6183522],
              [50.3519725, 36.6139432],
              [50.3490543, 36.609396],
              [50.3456615, 36.6060523],
              [50.3538608, 36.6016791],
              [50.3605556, 36.5992674],
              [50.3661346, 36.5982337],
              [50.3686236, 36.5967867],
              [50.3752326, 36.5966488],
              [50.380125, 36.5966488],
              [50.3847598, 36.5955463],
              [50.3901414, 36.5952063],
              [50.3933429, 36.5938235],
              [50.3960036, 36.5938925],
              [50.3968619, 36.5929277],
              [50.4048442, 36.5870009],
              [50.4076765, 36.5825901],
              [50.40699, 36.579902],
              [50.4114531, 36.5761112],
              [50.424156, 36.5740433],
              [50.4369195, 36.5650352],
              [50.4420089, 36.5642546],
              [50.4479312, 36.5632206],
              [50.4518794, 36.5617039],
              [50.455656, 36.5616349],
              [50.4660412, 36.5653578],
              [50.4751394, 36.5674258],
              [50.4808975, 36.5658775],
              [50.4867401, 36.5595789],
              [50.4999585, 36.5497882],
              [50.5086608, 36.5463533],
              [50.5173046, 36.5435539],
              [50.5380756, 36.5412979],
              [50.5466003, 36.5419683],
              [50.5712872, 36.5372907],
              [50.5731368, 36.5365019],
              [50.5743813, 36.5355365],
              [50.5752826, 36.5348296],
              [50.5753469, 36.5339503],
              [50.5766772, 36.53264],
              [50.5770635, 36.5318985],
              [50.5775141, 36.5313296],
              [50.5787372, 36.530433],
              [50.5840587, 36.5311571],
              [50.5858612, 36.5308123],
              [50.5879211, 36.5305364],
              [50.5894153, 36.5305294],
              [50.5935001, 36.5284329],
              [50.5949592, 36.5270534],
              [50.597425, 36.5261053],
              [50.5990502, 36.5256595],
              [50.6025443, 36.5256938],
              [50.6042742, 36.5259868],
              [50.606886, 36.5271249],
              [50.6094646, 36.527019],
              [50.6127638, 36.5264866],
              [50.6185626, 36.5232945],
              [50.6227877, 36.5240617],
              [50.6269059, 36.5243953],
              [50.6286906, 36.5232944],
              [50.6321239, 36.5254326],
              [50.634613, 36.5262603],
              [50.6403636, 36.5241221],
              [50.6441402, 36.521846],
              [50.6478309, 36.5197077],
              [50.6511783, 36.5163967],
              [50.6560351, 36.5144651],
              [50.6591605, 36.5081875],
              [50.6490325, 36.4990115],
              [50.6536018, 36.4980256],
              [50.6612343, 36.4926325],
              [50.670639, 36.4852786],
              [50.6759374, 36.4812957],
              [50.6762353, 36.4810718],
              [50.6844433, 36.4772949],
              [50.7024192, 36.4703727],
              [50.7142203, 36.4644059],
              [50.7219669, 36.4635276],
              [50.7334899, 36.4620896],
              [50.7481323, 36.4592034],
              [50.7545416, 36.4517144],
              [50.7613743, 36.445002],
              [50.7674983, 36.4381657],
              [50.7738884, 36.4334392],
              [50.7824752, 36.4283524],
              [50.786835, 36.4237807],
              [50.7915118, 36.4198904],
              [50.7981295, 36.4151083],
              [50.8015212, 36.411306],
              [50.804719, 36.4096702],
              [50.8057593, 36.4069156],
              [50.8106282, 36.4010029],
              [50.8136557, 36.3957241],
              [50.8203785, 36.3934856],
              [50.8287619, 36.3900586],
              [50.8311191, 36.3911392],
              [50.8547514, 36.3771124],
              [50.8656045, 36.3704312],
              [50.8720834, 36.3615428],
              [50.881445, 36.3508941],
              [50.8817933, 36.3504978],
              [50.8837366, 36.3493864],
              [50.890485, 36.3469668],
              [50.8954771, 36.3448186],
              [50.9002477, 36.3409258],
              [50.9029717, 36.3376248],
              [50.9049797, 36.3332948],
              [50.9061246, 36.3300928],
              [50.905838, 36.3229744],
              [50.9030485, 36.3159897],
              [50.9017914, 36.3116473],
              [50.9024911, 36.3091185],
              [50.9076038, 36.3011458],
              [50.9140298, 36.2939145],
              [50.9149297, 36.2929376],
              [50.9186055, 36.2865326],
              [50.9273386, 36.2838932],
              [50.9412963, 36.2805097],
              [50.9517574, 36.2780466],
              [50.964117, 36.2729608],
              [50.9756049, 36.267309],
              [50.9845088, 36.2619347],
              [50.9946189, 36.2523003],
              [51.0001284, 36.2485033],
              [50.9989763, 36.2485704],
              [51.0042285, 36.246513],
              [51.0098114, 36.2447504],
              [51.0246514, 36.2409887],
              [51.0410168, 36.2372096],
              [51.063938, 36.2301506],
              [51.1044501, 36.2168909],
              [51.1250198, 36.2123269],
              [51.1346527, 36.2103084],
              [51.144385, 36.2099152],
              [51.157123, 36.2090527],
              [51.1712837, 36.2086446],
              [51.1791362, 36.2085041],
              [51.1854099, 36.2087599],
              [51.1933831, 36.2080661],
              [51.2011319, 36.2085395],
              [51.2098019, 36.2090136],
              [51.2204855, 36.2105949],
              [51.239461, 36.2105845],
              [51.2494899, 36.2096164],
              [51.2433763, 36.2024141],
              [51.2408941, 36.1986662],
              [51.2428373, 36.1973065],
              [51.2453628, 36.1938543],
              [51.2464072, 36.1856445],
              [51.2476134, 36.1785692],
              [51.2494351, 36.1733257],
              [51.2644413, 36.1685286],
              [51.2730428, 36.1672499],
              [51.2821287, 36.1667527],
              [51.2886791, 36.1678267],
              [51.2928339, 36.1676867],
              [51.2973159, 36.1665777],
              [51.3001314, 36.1666993],
              [51.3068389, 36.1650423],
              [51.3125896, 36.1622012],
              [51.3197565, 36.1580434],
              [51.3275479, 36.1543661],
              [51.3312653, 36.1535463],
              [51.3346052, 36.1539026],
              [51.3376912, 36.1535621],
              [51.3388324, 36.1540239],
              [51.3444697, 36.1598446],
              [51.346786, 36.1603174],
              [51.3507201, 36.159828],
              [51.3536246, 36.158031],
              [51.3563012, 36.1576846],
              [51.360781, 36.1589991],
              [51.3693968, 36.1610087],
              [51.3720743, 36.1611451],
              [51.3811708, 36.1600365],
              [51.3850217, 36.1585119],
              [51.4004212, 36.1560885],
              [51.407888, 36.1565044],
              [51.4142812, 36.1574073],
              [51.4239594, 36.1590013],
              [51.4286109, 36.1602465],
              [51.4317368, 36.1603158],
              [51.4382541, 36.1551856],
              [51.4464438, 36.1517204],
              [51.4559429, 36.1461336],
              [51.4696597, 36.1340623],
              [51.4736938, 36.1298336],
              [51.4824485, 36.1269913],
              [51.4866542, 36.1261594],
              [51.4903449, 36.1238715],
              [51.4926623, 36.1217223],
              [51.4967822, 36.1192957],
              [51.5007304, 36.1173543],
              [51.5087985, 36.11153],
              [51.5113735, 36.107092],
              [51.5168666, 36.0948865],
              [51.525278, 36.081708],
              [51.5242488, 36.0792001],
              [51.5380668, 36.0907945],
              [51.5527438, 36.1016137],
              [51.5581069, 36.1003115],
              [51.5729376, 36.0949868],
              [51.5865508, 36.0902648],
              [51.5943274, 36.0860924],
              [51.5979408, 36.084155],
              [51.598494, 36.084155],
              [51.5990507, 36.0835963],
              [51.653777, 36.0602653],
              [51.6548867, 36.0597065],
              [51.6934997, 36.0427643],
              [51.699613, 36.0397092],
              [51.7071128, 36.0369336],
              [51.7145335, 36.0334998],
              [51.7154463, 36.0330404],
              [51.7274191, 36.0266362],
              [51.7285028, 36.0261011],
              [51.760449, 36.0066529],
              [51.7698922, 36.0002271],
              [51.7798922, 35.9808143],
              [51.8143384, 35.9524786],
              [51.8246184, 35.9419245],
              [51.8291354, 35.9346017],
              [51.8473982, 35.9049799],
              [51.8507316, 35.9005364],
              [51.8573981, 35.886088],
              [51.8573981, 35.8855381],
              [51.8607314, 35.8788772],
              [51.8776744, 35.8605858],
              [51.8782311, 35.8599847],
              [51.8821211, 35.8571995],
              [51.9340671, 35.828869],
              [51.9843466, 35.7985906],
              [51.9929599, 35.7933082],
              [52.0062932, 35.7866467],
              [52.0104597, 35.7846996],
              [52.0268495, 35.7785878],
              [52.0376827, 35.7738642],
              [52.0515726, 35.7685908],
              [52.0587959, 35.7666436],
              [52.0601859, 35.7660937],
              [52.0726856, 35.7633173],
              [52.0957422, 35.7616496],
              [52.0965753, 35.7613611],
              [52.1101886, 35.7613611],
              [52.1121319, 35.7616496],
              [52.1185218, 35.7616496],
              [52.1226884, 35.76192],
              [52.1293549, 35.7621995],
              [52.1374115, 35.7621995],
              [52.1551879, 35.7630289],
              [52.1560213, 35.7633173],
              [52.1585212, 35.7630289],
              [52.1751912, 35.7630289],
              [52.1771345, 35.7633173],
              [52.1840776, 35.7633174],
              [52.1907477, 35.7635878],
              [52.1918577, 35.7638672],
              [52.1946343, 35.7638673],
              [52.1954675, 35.7641467],
              [52.1979676, 35.7641467],
              [52.1990809, 35.7644262],
              [52.201024, 35.7644261],
              [52.2024141, 35.7646966],
              [52.2046374, 35.7646966],
              [52.2090807, 35.7652555],
              [52.2107473, 35.7652555],
              [52.2113042, 35.765535],
              [52.2135239, 35.765535],
              [52.2146375, 35.7658144],
              [52.2154707, 35.765535],
              [52.2165806, 35.7655351],
              [52.2171373, 35.7658144],
              [52.217414, 35.765535],
              [52.2179707, 35.7655349],
              [52.2182473, 35.7658144],
              [52.2201905, 35.7658144],
              [52.2260273, 35.7669232],
              [52.2274139, 35.7674821],
              [52.2374138, 35.7696997],
              [52.240747, 35.771088],
              [52.2446369, 35.7730351],
              [52.2657501, 35.7974821],
              [52.2665834, 35.7985908],
              [52.2921399, 35.8155375],
              [52.3003625, 35.818777],
              [52.3196427, 35.8263724],
              [52.326586, 35.8283195],
              [52.3782555, 35.8485917],
              [52.3785321, 35.8488711],
              [52.3793654, 35.8494299],
              [52.3943686, 35.8616436],
              [52.4090882, 35.8830327],
              [52.412425, 35.8874763],
              [52.4152015, 35.8910908],
              [52.4157583, 35.8922085],
              [52.4176557, 35.8941065],
              [52.4357581, 35.9122089],
              [52.4627044, 35.92526],
              [52.4635377, 35.9252599],
              [52.4663143, 35.9263775],
              [52.4685377, 35.9269273],
              [52.4702042, 35.9277655],
              [52.4740942, 35.9288742],
              [52.4752041, 35.929424],
              [52.4790942, 35.9302622],
              [52.4796475, 35.9302622],
              [52.4805157, 35.9304368],
              [52.4935373, 35.9333176],
              [52.4943706, 35.9333176],
              [52.4949272, 35.933597],
              [52.4957606, 35.933597],
              [52.4999272, 35.9338674],
              [52.54104, 35.940537],
              [52.5418733, 35.9402576],
              [52.5435401, 35.940537],
              [52.54604, 35.940537],
              [52.5482634, 35.9410958],
              [52.5679864, 35.943313],
              [52.5685432, 35.9430426],
              [52.5749297, 35.9430426],
              [52.5757629, 35.943313],
              [52.5777097, 35.9433131],
              [52.5799296, 35.9430426],
              [52.581043, 35.943313],
              [52.5832664, 35.9430426],
              [52.6024192, 35.943043],
              [52.6065993, 35.9430426],
              [52.6077093, 35.9427633],
              [52.6129892, 35.9427632],
              [52.6149325, 35.9424838],
              [52.6196559, 35.9424839],
              [52.6227125, 35.941925],
              [52.6435456, 35.9405371],
              [52.6443789, 35.9408165],
              [52.6477122, 35.9402576],
              [52.6488221, 35.9405371],
              [52.6502122, 35.9402576],
              [52.6524355, 35.9402577],
              [52.6538222, 35.9399783],
              [52.6560454, 35.9399783],
              [52.6571589, 35.9397079],
              [52.6585453, 35.9397079],
              [52.6591021, 35.9394285],
              [52.660212, 35.9394284],
              [52.6616785, 35.9390399],
              [52.6832685, 35.9333177],
              [52.6841018, 35.9333177],
              [52.692435, 35.9308211],
              [52.6935484, 35.9308211],
              [52.6949384, 35.9302623],
              [52.6993816, 35.9294241],
              [52.7016049, 35.928595],
              [52.7049383, 35.9280361],
              [52.7057716, 35.9274863],
              [52.7881052, 35.8929868],
              [52.7966072, 35.8894235],
              [52.8038129, 35.8854164],
              [52.8146636, 35.8794276],
              [52.815777, 35.8791482],
              [52.8218869, 35.876372],
              [52.8229968, 35.8760926],
              [52.8281778, 35.8741024],
              [52.8291102, 35.8738753],
              [52.8704997, 35.8594264],
              [52.8718897, 35.8585882],
              [52.8774463, 35.8566503],
              [52.9171691, 35.8391455],
              [52.9180024, 35.8391455],
              [52.9207825, 35.8377573],
              [52.9216158, 35.8377573],
              [52.9357823, 35.8341427],
              [52.9368923, 35.8338723],
              [52.937449, 35.8338723],
              [52.9430055, 35.8327546],
              [52.9449488, 35.8327546],
              [52.9455055, 35.8324842],
              [52.9468922, 35.8324842],
              [52.9480055, 35.8322047],
              [52.9507821, 35.8322048],
              [52.9516155, 35.8319253],
              [52.9613387, 35.8319253],
              [52.9627287, 35.8322048],
              [52.9632819, 35.8319254],
              [52.9643953, 35.8322048],
              [52.9663387, 35.8322048],
              [52.9674485, 35.8324842],
              [52.9707818, 35.8324842],
              [52.9874517, 35.83554],
              [53.0038415, 35.8435893],
              [53.0046748, 35.8444276],
              [53.0068947, 35.8455364],
              [53.0071748, 35.8460951],
              [53.0107847, 35.8483126],
              [53.0110614, 35.8485919],
              [53.0174514, 35.8535946],
              [53.0470905, 35.8677671],
              [53.0482004, 35.8713725],
              [53.0484805, 35.8785922],
              [53.0482004, 35.8794305],
              [53.0465337, 35.8855415],
              [53.0504237, 35.8905439],
              [53.0649541, 35.9149853],
              [53.0744006, 35.917482],
              [53.0763439, 35.917482],
              [53.0780106, 35.9177613],
              [53.0844205, 35.9177614],
              [53.0874537, 35.9177614],
              [53.0905105, 35.9183202],
              [53.0938437, 35.9183201],
              [53.097457, 35.9188699],
              [53.1002336, 35.91887],
              [53.1015565, 35.9190917],
              [53.1019003, 35.9191493],
              [53.1032903, 35.9191494],
              [53.1041237, 35.91887],
              [53.107457, 35.9191494],
              [53.108567, 35.9188699],
              [53.1124569, 35.9191493],
              [53.1149568, 35.9191494],
              [53.1166235, 35.9194287],
              [53.1191234, 35.9194288],
              [53.1205134, 35.9197082],
              [53.1274566, 35.9197082],
              [53.1285701, 35.9194288],
              [53.1324566, 35.9194288],
              [53.1330134, 35.9197082],
              [53.1341232, 35.9197082],
              [53.1349565, 35.9197082],
              [53.1385699, 35.9197082],
              [53.1567129, 35.9138658],
              [53.1592128, 35.9138657],
              [53.161156, 35.9141452],
              [53.1644895, 35.9138657],
              [53.1678226, 35.9138657],
              [53.170046, 35.9135863],
              [53.1736559, 35.9135863],
              [53.1781025, 35.9130274],
              [53.1792126, 35.9133159],
              [53.1850458, 35.9133158],
              [53.2026988, 35.9091427],
              [53.2302486, 35.9069091],
              [53.2321918, 35.907468],
              [53.2333052, 35.907468],
              [53.2338585, 35.9077473],
              [53.2349719, 35.9077474],
              [53.2380251, 35.9085768],
              [53.2408051, 35.9099652],
              [53.245805, 35.9141301],
              [53.2480283, 35.923019],
              [53.2458051, 35.9310874],
              [53.2455284, 35.9316373],
              [53.2249622, 35.9580402],
              [53.2246856, 35.9591489],
              [53.2235722, 35.9641508],
              [53.223375, 35.9655388],
              [53.2232955, 35.9660976],
              [53.2246856, 35.9674855],
              [53.2246855, 35.9680443],
              [53.2635751, 35.9933154],
              [53.2741543, 36.0016722],
              [53.2862865, 36.0104474],
              [53.2994615, 36.0160189],
              [53.308345, 36.0216942],
              [53.3100831, 36.0241759],
              [53.313173, 36.0263625],
              [53.3173358, 36.0292084],
              [53.323065, 36.0312908],
              [53.3246529, 36.0338763],
              [53.3262193, 36.0354901],
              [53.32785, 36.037017],
              [53.3326566, 36.040574],
              [53.3352744, 36.0415283],
              [53.3373773, 36.0438185],
              [53.3407461, 36.0449462],
              [53.3447372, 36.0472017],
              [53.3469005, 36.0484889],
              [53.3483153, 36.0493307],
              [53.349694, 36.050151],
              [53.3536851, 36.0539849],
              [53.3558952, 36.0550431],
              [53.3592641, 36.0568299],
              [53.3648431, 36.0566738],
              [53.3688771, 36.058634],
              [53.3754432, 36.0610625],
              [53.3773409, 36.0617712],
              [53.3788335, 36.0623287],
              [53.383404, 36.0630919],
              [53.3857858, 36.0643408],
              [53.3936178, 36.0674282],
              [53.4050333, 36.0722499],
              [53.4094107, 36.0745566],
              [53.4123718, 36.0761522],
              [53.417354, 36.0773711],
              [53.4189566, 36.0772894],
              [53.4236164, 36.0762265],
              [53.4266345, 36.0762061],
              [53.427861, 36.0763974],
              [53.4305672, 36.0771359],
              [53.4358428, 36.0761114],
              [53.4367259, 36.0761231],
              [53.4375008, 36.0763844],
              [53.4387853, 36.0765455],
              [53.4400225, 36.0768302],
              [53.4415977, 36.077078],
              [53.4425107, 36.0770685],
              [53.4442405, 36.0773102],
              [53.447085, 36.077399],
              [53.4480186, 36.0773525],
              [53.4485929, 36.0771769],
              [53.4522649, 36.0774804],
              [53.4538792, 36.0775307],
              [53.4549891, 36.0770032],
              [53.4559759, 36.0763588],
              [53.4568859, 36.0754523],
              [53.4579124, 36.0748995],
              [53.461092, 36.0747035],
              [53.4648097, 36.074893],
              [53.4673047, 36.0745712],
              [53.4685118, 36.0746049],
              [53.4700321, 36.0744699],
              [53.4713296, 36.0742877],
              [53.4724618, 36.0745009],
              [53.4734714, 36.0750772],
              [53.4743359, 36.0758457],
              [53.4758662, 36.0764067],
              [53.476712, 36.0768219],
              [53.4773561, 36.0774034],
              [53.4780592, 36.0778936],
              [53.4809439, 36.0787758],
              [53.4828351, 36.0789574],
              [53.4866772, 36.0787042],
              [53.4885817, 36.0784056],
              [53.4893201, 36.0780995],
              [53.4901085, 36.0775086],
              [53.4909191, 36.0766107],
              [53.4914197, 36.075762],
              [53.4922456, 36.0748187],
              [53.4942895, 36.0729848],
              [53.4953071, 36.0722268],
              [53.4965134, 36.0717555],
              [53.4975455, 36.0714997],
              [53.498526, 36.0710849],
              [53.4990026, 36.0711268],
              [53.500717, 36.0711203],
              [53.5020919, 36.0715467],
              [53.5033262, 36.0721564],
              [53.5076179, 36.074036],
              [53.5098776, 36.0745925],
              [53.5119419, 36.074849],
              [53.5133597, 36.0750941],
              [53.5157293, 36.0764617],
              [53.5162474, 36.0769105],
              [53.5173718, 36.0768102],
              [53.5191989, 36.0764609],
              [53.5230195, 36.0763917],
              [53.5240162, 36.0767042],
              [53.5253344, 36.0773254],
              [53.5268202, 36.0783035],
              [53.5278863, 36.0787857],
              [53.5303713, 36.079434],
              [53.5323226, 36.0798637],
              [53.5334578, 36.080554],
              [53.5349712, 36.0819754],
              [53.5360227, 36.0825615],
              [53.5373424, 36.0829436],
              [53.5390276, 36.0829935],
              [53.5405454, 36.0829523],
              [53.5418936, 36.0831175],
              [53.5438866, 36.0835236],
              [53.5454312, 36.0839054],
              [53.5470294, 36.0848921],
              [53.550016, 36.0870278],
              [53.5511934, 36.0880505],
              [53.552921, 36.0880542],
              [53.554565, 36.0879448],
              [53.5580204, 36.088218],
              [53.5625012, 36.088458],
              [53.5638787, 36.0883474],
              [53.5651298, 36.0880412],
              [53.5666194, 36.0878155],
              [53.5684595, 36.0879924],
              [53.5704108, 36.0884102],
              [53.5722084, 36.0887343],
              [53.5745684, 36.088785],
              [53.5763521, 36.0888931],
              [53.5799771, 36.0887069],
              [53.582323, 36.0888163],
              [53.5843456, 36.0889485],
              [53.586312, 36.0892733],
              [53.5884188, 36.0895184],
              [53.5897678, 36.0892797],
              [53.5913845, 36.0888031],
              [53.5934928, 36.0882933],
              [53.5955166, 36.0879566],
              [53.5977505, 36.0877436],
              [53.6013489, 36.0870887],
              [53.6029358, 36.0870813],
              [53.6046504, 36.0869246],
              [53.6066446, 36.0871223],
              [53.608751, 36.0875045],
              [53.6106327, 36.0879322],
              [53.6124856, 36.0887255],
              [53.6137203, 36.0895638],
              [53.6147427, 36.0896842],
              [53.6148016, 36.0896911],
              [53.6175005, 36.0889314],
              [53.6196501, 36.0885825],
              [53.6216322, 36.0881042],
              [53.6225742, 36.0877664],
              [53.6228969, 36.0876507],
              [53.6252721, 36.0873463],
              [53.6264086, 36.0879432],
              [53.6278828, 36.0884044],
              [53.6298915, 36.0884549],
              [53.6321954, 36.0886769],
              [53.6336699, 36.0888969],
              [53.6348499, 36.0889227],
              [53.6364513, 36.0888897],
              [53.6377863, 36.0887792],
              [53.6390791, 36.0885863],
              [53.6401325, 36.0886239],
              [53.6458267, 36.0914855],
              [53.6506688, 36.0970745],
              [53.6523189, 36.1006872],
              [53.6590289, 36.1065373],
              [53.6767959, 36.1142342],
              [53.7030601, 36.118741],
              [53.7198227, 36.1238228],
              [53.7258362, 36.1259769],
              [53.7306749, 36.1298444],
              [53.7353324, 36.1325372],
              [53.7466851, 36.1355286],
              [53.7556811, 36.138895],
              [53.7613953, 36.1399947],
              [53.7666842, 36.1424764],
              [53.7765443, 36.1451998],
              [53.7859473, 36.1490848],
              [53.7906518, 36.1531735],
              [53.8022449, 36.1601574],
              [53.8068723, 36.1649287],
              [53.8155622, 36.1774271],
              [53.8209851, 36.1826056],
              [53.8289905, 36.1865184],
              [53.8380346, 36.1908982],
              [53.8457552, 36.198635],
              [53.8512323, 36.2081977],
              [53.8601138, 36.2133532],
              [53.88707, 36.2237766],
              [53.9135168, 36.2369354],
              [53.9250181, 36.243858],
              [53.9352965, 36.2480353],
              [53.9411747, 36.2525794],
              [53.9459015, 36.2578807],
              [53.9478756, 36.2601833],
              [53.9494206, 36.2618379],
              [53.9504204, 36.2642822],
              [53.9479122, 36.2675452],
              [53.9627836, 36.2751406],
              [53.9699934, 36.2834436],
              [53.9701866, 36.291906],
              [53.967335, 36.302558],
              [53.9566038, 36.3206579],
              [53.9317124, 36.3342115],
              [53.9188163, 36.3409097],
              [53.8987539, 36.3527392],
              [53.885536, 36.3584074],
              [53.882532, 36.3633148],
              [53.8863943, 36.371954],
              [53.9033888, 36.3919932],
              [53.9126928, 36.4032289],
              [53.966047, 36.4027308],
              [53.9763235, 36.4049569],
              [53.9777134, 36.4049569],
              [53.9788235, 36.4052272],
              [53.9796568, 36.4049568],
              [53.9832667, 36.4049569],
              [53.9838234, 36.4046775],
              [53.9871567, 36.4046775],
              [53.9924609, 36.4043407],
              [54.005427, 36.4027964],
              [54.0236202, 36.4134109],
              [54.0252027, 36.413507],
              [54.033536, 36.4162916],
              [54.0432125, 36.4442003],
              [54.0437658, 36.4444795],
              [54.0444564, 36.4446138],
              [54.0462657, 36.4453083],
              [54.0468223, 36.4455875],
              [54.0532813, 36.4590488],
              [54.0613791, 36.4688563],
              [54.0730592, 36.4719422],
              [54.093059, 36.4788868],
              [54.1041687, 36.4841652],
              [54.1465012, 36.4971818],
              [54.1486932, 36.4975881],
              [54.1540732, 36.4963727],
              [54.1588167, 36.4966046],
              [54.1630099, 36.4979536],
              [54.1688804, 36.5007357],
              [54.1700597, 36.5021057],
              [54.1701908, 36.5033492],
              [54.1707936, 36.5042344],
              [54.1721106, 36.5047405],
              [54.1729727, 36.504826],
              [54.1725832, 36.5052321],
              [54.1723413, 36.5057876],
              [54.1709785, 36.5067781],
              [54.1645577, 36.5061248],
              [54.1612555, 36.5057032],
              [54.1548411, 36.5064548],
              [54.1518045, 36.5073446],
              [54.1505536, 36.5091793],
              [54.1498379, 36.5127358],
              [54.1501146, 36.5152306],
              [54.1503912, 36.5174551],
              [54.1512245, 36.5221833],
              [54.1515045, 36.5241196],
              [54.1687207, 36.5416789],
              [54.1698306, 36.5494516],
              [54.167884, 36.5691759],
              [54.1673306, 36.5713915],
              [54.1687237, 36.5950181],
              [54.1662237, 36.600575],
              [54.1645571, 36.6036281],
              [54.1559472, 36.6130756],
              [54.1506672, 36.6161287],
              [54.1498339, 36.6169662],
              [54.0832898, 36.6224168],
              [54.0699562, 36.6323587],
              [54.0477795, 36.6422267],
              [54.0346512, 36.6439023],
              [54.0307613, 36.6439023],
              [54.0275861, 36.6425529],
              [54.0264761, 36.642553],
              [54.0256428, 36.6428231],
              [54.0242528, 36.6428231],
              [54.0236961, 36.6431024],
              [54.0225861, 36.6431023],
              [54.0211962, 36.6436607],
              [54.0200862, 36.6436607],
              [54.0195295, 36.6439398],
              [54.0186962, 36.6439399],
              [54.0184196, 36.6442191],
              [54.0173096, 36.644219],
              [54.0167529, 36.6444893],
              [54.014253, 36.6444893],
              [54.0136963, 36.6447684],
              [54.0109196, 36.6450476],
              [53.9969433, 36.6513942],
              [53.9936101, 36.6533394],
              [53.9922201, 36.6544471],
              [53.9744402, 36.6694497],
              [53.9738474, 36.669847],
              [53.9647204, 36.675285],
              [53.9511072, 36.6766628],
              [53.9499972, 36.6769419],
              [53.9472172, 36.6769419],
              [53.9465393, 36.6767714],
              [53.9391606, 36.6766628],
              [53.9383272, 36.676942],
              [53.932774, 36.6769419],
              [53.929994, 36.6763926],
              [53.9280508, 36.6763926],
              [53.9266608, 36.6761135],
              [53.9244409, 36.6761135],
              [53.9233274, 36.6758343],
              [53.9205508, 36.6755551],
              [53.9130509, 36.6730608],
              [53.9063844, 36.6713858],
              [53.9044377, 36.6713858],
              [53.8972144, 36.670008],
              [53.8958278, 36.6700081],
              [53.8949945, 36.6697289],
              [53.8936045, 36.6697289],
              [53.8927711, 36.6694497],
              [53.8911045, 36.6694497],
              [53.8883279, 36.6694497],
              [53.8872145, 36.6691705],
              [53.8827713, 36.6691706],
              [53.8747147, 36.6711157],
              [53.8733247, 36.6713859],
              [53.8711345, 36.672555],
              [53.869158, 36.6736101],
              [53.8647148, 36.6794543],
              [53.8619348, 36.6861091],
              [53.8622148, 36.6902783],
              [53.8622148, 36.6925025],
              [53.8622149, 36.6936191],
              [53.8619348, 36.6941684],
              [53.8613815, 36.6961134],
              [53.8608248, 36.6972211],
              [53.8608248, 36.698896],
              [53.8622148, 36.7044429],
              [53.8624915, 36.7050012],
              [53.8624915, 36.7230554],
              [53.8622149, 36.7233345],
              [53.8619348, 36.7250003],
              [53.8616582, 36.7300068],
              [53.8611015, 36.7333385],
              [53.8602681, 36.7358417],
              [53.8605482, 36.7391733],
              [53.8608248, 36.7397225],
              [53.8644382, 36.7447289],
              [53.8661048, 36.7494471],
              [53.8616582, 36.7636195],
              [53.8622148, 36.7769544],
              [53.8624915, 36.7800067],
              [53.8622148, 36.7805649],
              [53.8624914, 36.780844],
              [53.8622148, 36.7811231],
              [53.8622148, 36.7815592],
              [53.8621766, 36.7823724],
              [53.8574156, 36.8836278],
              [53.8565366, 36.9023082],
              [53.8548049, 36.939096],
              [53.7295316, 37.0930997],
              [53.7287684, 37.0930393],
              [53.7265603, 37.0928646],
              [53.7211424, 37.09234],
              [53.7157402, 37.0917205],
              [53.7103563, 37.0910065],
              [53.708484, 37.0907104],
              [53.6974703, 37.090144],
              [53.6933988, 37.0896508],
              [53.6662469, 37.0863611],
              [53.645455, 37.0852139],
              [53.6388623, 37.0847789],
              [53.6322864, 37.0842039],
              [53.6257318, 37.0834895],
              [53.6192032, 37.0826361],
              [53.6147304, 37.0819594],
              [53.5878877, 37.0802918],
              [53.5710601, 37.0787815],
              [53.5439463, 37.0755943],
              [53.5207122, 37.0736617],
              [53.464508, 37.0689865],
              [53.4532567, 37.0678387],
              [53.4117443, 37.0628613],
              [53.4063396, 37.0635184],
              [53.4009238, 37.0640431],
              [53.3954949, 37.0644727],
              [53.3900556, 37.0648071],
              [53.3846084, 37.065046],
              [53.379156, 37.0651894],
              [53.373701, 37.0652372],
              [53.368246, 37.0651894],
              [53.3627936, 37.065046],
              [53.3573464, 37.0648071],
              [53.3519071, 37.0644727],
              [53.3464782, 37.0640431],
              [53.3410624, 37.0635184],
              [53.3356622, 37.0628989],
              [53.3302803, 37.0621849],
              [53.3249192, 37.0613768],
              [53.3195815, 37.0604748],
              [53.3142698, 37.0594796],
              [53.3089866, 37.0583915],
              [53.3037344, 37.057211],
              [53.2985158, 37.0559387],
              [53.2933332, 37.0545753],
              [53.2881891, 37.0531214],
              [53.2830861, 37.0515777],
              [53.2780265, 37.0499448],
              [53.2730127, 37.0482237],
              [53.272129, 37.0478347],
              [53.2677268, 37.0480953],
              [53.2622756, 37.0482387],
              [53.2568218, 37.0482865],
              [53.251368, 37.0482387],
              [53.2459168, 37.0480953],
              [53.2404708, 37.0478563],
              [53.2350327, 37.0475219],
              [53.229605, 37.0470923],
              [53.2241904, 37.0465676],
              [53.2187915, 37.0459482],
              [53.2134108, 37.0452342],
              [53.2080509, 37.044426],
              [53.2029624, 37.043566],
              [53.2027144, 37.0435241],
              [53.1974038, 37.0425288],
              [53.1921218, 37.0414407],
              [53.1868707, 37.0402602],
              [53.1816532, 37.038988],
              [53.1764718, 37.0376246],
              [53.1713289, 37.0361706],
              [53.166227, 37.0346269],
              [53.1611685, 37.0329941],
              [53.1561559, 37.031273],
              [53.1511915, 37.0294644],
              [53.1462778, 37.0275692],
              [53.1417385, 37.0257193],
              [53.1395597, 37.0254394],
              [53.1327375, 37.0243935],
              [53.1259544, 37.0231957],
              [53.1192157, 37.0218468],
              [53.1125265, 37.0203478],
              [53.100179, 37.0174296],
              [53.0990124, 37.0172537],
              [53.0951989, 37.0167474],
              [53.0865554, 37.0153954],
              [53.0858755, 37.015279],
              [53.0651154, 37.0109684],
              [53.0624727, 37.0103209],
              [53.0574715, 37.0094752],
              [53.0521633, 37.00848],
              [53.0468836, 37.0073918],
              [53.0416349, 37.0062114],
              [53.0364198, 37.0049391],
              [53.0312406, 37.0035757],
              [53.0261, 37.0021218],
              [53.0207666, 37.0005048],
              [52.9950966, 36.9924482],
              [52.9941321, 36.9921435],
              [52.9768066, 36.9866338],
              [52.9625813, 36.9833727],
              [52.9540647, 36.9812865],
              [52.9456467, 36.9789574],
              [52.944895, 36.9787298],
              [52.9415254, 36.9778773],
              [52.9103556, 36.9694672],
              [52.9091765, 36.9692461],
              [52.9038995, 36.9681579],
              [52.8986535, 36.9669774],
              [52.8934411, 36.9657052],
              [52.8882646, 36.9643418],
              [52.8831266, 36.9628878],
              [52.8772544, 36.9610561],
              [52.8728543, 36.9600659],
              [52.8676423, 36.9587936],
              [52.8624663, 36.9574302],
              [52.8601351, 36.9567705],
              [52.8590652, 36.9565506],
              [52.8518129, 36.9548702],
              [52.7975896, 36.9415691],
              [52.7952563, 36.9412033],
              [52.7865799, 36.9395826],
              [52.751428, 36.9324757],
              [52.7465157, 36.9314289],
              [52.7449528, 36.9312779],
              [52.7359028, 36.9301309],
              [52.730551, 36.9293227],
              [52.7252225, 36.9284208],
              [52.7197779, 36.9273962],
              [52.7159293, 36.9270143],
              [52.7065751, 36.9258334],
              [52.6962122, 36.9241797],
              [52.6859463, 36.9221744],
              [52.6793697, 36.9207816],
              [52.6739812, 36.9201613],
              [52.668711, 36.9194599],
              [52.6633599, 36.9186518],
              [52.6580316, 36.9176872],
              [52.6566557, 36.9175639],
              [52.6556655, 36.9174839],
              [52.6504335, 36.9175956],
              [52.6449916, 36.9174521],
              [52.6395549, 36.9172132],
              [52.6341261, 36.9168788],
              [52.6287077, 36.9164492],
              [52.6233024, 36.9159245],
              [52.6179126, 36.915305],
              [52.6125411, 36.914591],
              [52.6071904, 36.9137828],
              [52.601863, 36.9128809],
              [52.5965615, 36.9118856],
              [52.5912885, 36.9107975],
              [52.5860464, 36.909617],
              [52.5808378, 36.9083448],
              [52.5756652, 36.9069813],
              [52.5705311, 36.9055274],
              [52.5644927, 36.9036858],
              [52.5623865, 36.9030182],
              [52.5584397, 36.9030529],
              [52.5529963, 36.9030051],
              [52.5475554, 36.9028617],
              [52.5421198, 36.9026227],
              [52.536692, 36.9022883],
              [52.5312747, 36.9018587],
              [52.5258703, 36.901334],
              [52.5204816, 36.9007145],
              [52.5151111, 36.9000005],
              [52.5097614, 36.8991924],
              [52.504435, 36.8982904],
              [52.4991346, 36.8972952],
              [52.4938625, 36.896207],
              [52.4886215, 36.8950265],
              [52.4834139, 36.8937543],
              [52.4782423, 36.8923908],
              [52.4731091, 36.8909369],
              [52.4680169, 36.8893931],
              [52.462968, 36.8877603],
              [52.457978, 36.8859404],
              [52.4570988, 36.8857231],
              [52.4553544, 36.8854911],
              [52.4500056, 36.8846829],
              [52.4446803, 36.883781],
              [52.4414436, 36.8831731],
              [52.4373199, 36.8827981],
              [52.4296607, 36.8820035],
              [52.422036, 36.8810184],
              [52.4174534, 36.8803319],
              [52.3921071, 36.8763345],
              [52.3826259, 36.8746832],
              [52.3732322, 36.8727362],
              [52.3639403, 36.8704965],
              [52.3547645, 36.8679674],
              [52.3496486, 36.8664158],
              [52.3445766, 36.8647742],
              [52.3395507, 36.8630435],
              [52.3377839, 36.8623977],
              [52.3144962, 36.8570576],
              [52.313312, 36.8567832],
              [52.2898152, 36.8512841],
              [52.2818503, 36.8500852],
              [52.27165, 36.8480939],
              [52.2615636, 36.8457584],
              [52.2516091, 36.8430831],
              [52.2430161, 36.8406091],
              [52.2048628, 36.8326024],
              [52.1838444, 36.8267107],
              [52.1786808, 36.8257403],
              [52.1734136, 36.8246521],
              [52.1681775, 36.8234716],
              [52.1629747, 36.8221993],
              [52.1578079, 36.8208359],
              [52.1526795, 36.819382],
              [52.147592, 36.8178382],
              [52.1425478, 36.8162053],
              [52.1424719, 36.8161792],
              [52.1375494, 36.8144842],
              [52.1352215, 36.8136337],
              [52.1257289, 36.8110266],
              [52.1243485, 36.8106077],
              [52.1194244, 36.8094455],
              [52.1133233, 36.8078671],
              [52.1107788, 36.8071501],
              [52.1052579, 36.8058235],
              [52.0957717, 36.8032069],
              [52.0943704, 36.8029249],
              [52.0852069, 36.8008804],
              [52.0761476, 36.7985556],
              [52.0543489, 36.7925865],
              [52.0202721, 36.7849011],
              [52.0135963, 36.7833954],
              [51.9846635, 36.7786306],
              [51.9793921, 36.7778799],
              [51.969123, 36.7764175],
              [51.9670241, 36.7762134],
              [51.962756, 36.7757219],
              [51.9586134, 36.7754663],
              [51.953205, 36.7750367],
              [51.9478096, 36.774512],
              [51.9424297, 36.7738925],
              [51.9398748, 36.7734837],
              [51.9370656, 36.7732353],
              [51.9344573, 36.7731775],
              [51.9296859, 36.772883],
              [51.9275544, 36.7728643],
              [51.9221228, 36.7727209],
              [51.9164712, 36.772468],
              [51.9084123, 36.7729792],
              [51.9029781, 36.7729314],
              [51.8986427, 36.7728401],
              [51.8973287, 36.7729251],
              [51.8967654, 36.7730849],
              [51.8916018, 36.7744483],
              [51.8864023, 36.7757206],
              [51.8811693, 36.7769011],
              [51.8759055, 36.7779892],
              [51.8706132, 36.7789845],
              [51.8652951, 36.7798865],
              [51.8599537, 36.7806946],
              [51.8537056, 36.7815173],
              [51.8477059, 36.7821815],
              [51.8414346, 36.7833156],
              [51.8339249, 36.7844796],
              [51.8285625, 36.7851936],
              [51.8231819, 36.7858131],
              [51.8177857, 36.7863378],
              [51.8123765, 36.7867675],
              [51.8069568, 36.7871018],
              [51.8015294, 36.7873408],
              [51.7960967, 36.7874842],
              [51.7816031, 36.7872194],
              [51.7804546, 36.7873103],
              [51.7756936, 36.7871754],
              [51.7613063, 36.7890674],
              [51.7569517, 36.7892295],
              [51.751598, 36.7900396],
              [51.7463646, 36.7907375],
              [51.7411139, 36.7913454],
              [51.7370531, 36.7917446],
              [51.7361499, 36.7918689],
              [51.7303498, 36.792641],
              [51.7285881, 36.7931347],
              [51.7221887, 36.7947606],
              [51.7198054, 36.7960152],
              [51.7154189, 36.7985512],
              [51.7109364, 36.8010249],
              [51.7063875, 36.8034193],
              [51.7017745, 36.8057331],
              [51.6970996, 36.8079652],
              [51.692365, 36.8101146],
              [51.6875729, 36.8121803],
              [51.6827256, 36.8141612],
              [51.6778255, 36.8160564],
              [51.672875, 36.817865],
              [51.6678763, 36.8195861],
              [51.6647682, 36.8205922],
              [51.6621506, 36.8222493],
              [51.6578054, 36.8248782],
              [51.6533897, 36.8274302],
              [51.6489055, 36.8299039],
              [51.644355, 36.8322982],
              [51.6397402, 36.834612],
              [51.6350636, 36.8368442],
              [51.6303271, 36.8389936],
              [51.6255332, 36.8410592],
              [51.6206842, 36.8430401],
              [51.6157823, 36.8449353],
              [51.6108298, 36.8467439],
              [51.6058293, 36.8484651],
              [51.6007829, 36.8500979],
              [51.5956933, 36.8516417],
              [51.5905628, 36.8530956],
              [51.5853938, 36.8544591],
              [51.5801889, 36.8557313],
              [51.5749505, 36.8569118],
              [51.5696812, 36.858],
              [51.5643834, 36.8589952],
              [51.5590598, 36.8598972],
              [51.5537128, 36.8607053],
              [51.5483534, 36.8614182],
              [51.5436187, 36.8633519],
              [51.5387155, 36.8652471],
              [51.5337617, 36.8670557],
              [51.5287598, 36.8687768],
              [51.5237122, 36.8704097],
              [51.5186212, 36.8719534],
              [51.5169527, 36.8724373],
              [51.5120475, 36.8738438],
              [51.4840685, 36.880409],
              [51.4819627, 36.8807971],
              [51.4758148, 36.8818648],
              [51.4696352, 36.8828073],
              [51.4634783, 36.8836179],
              [51.457298, 36.8843042],
              [51.4510982, 36.8848659],
              [51.4477694, 36.8850997],
              [51.4448827, 36.8853025],
              [51.4438894, 36.8853621],
              [51.4404255, 36.8858932],
              [51.435056, 36.8866072],
              [51.4296683, 36.8872267],
              [51.4242649, 36.8877513],
              [51.4188486, 36.888181],
              [51.4134218, 36.8885154],
              [51.4079871, 36.8887543],
              [51.4025473, 36.8888977],
              [51.3971049, 36.8889455],
              [51.3925733, 36.8889057],
              [51.3875979, 36.8891841],
              [51.3558096, 36.8919624],
              [51.3409383, 36.893337],
              [51.3402035, 36.8934887],
              [51.3349033, 36.894484],
              [51.3295772, 36.8953859],
              [51.3242278, 36.8961941],
              [51.3149746, 36.8973642],
              [51.3056254, 36.8984011],
              [51.2961008, 36.900424],
              [51.2743004, 36.9035576],
              [51.2703103, 36.9044563],
              [51.2650377, 36.9055444],
              [51.2597367, 36.9065397],
              [51.2544097, 36.9074416],
              [51.2490594, 36.9082498],
              [51.2436883, 36.9089638],
              [51.2382991, 36.9095833],
              [51.2365719, 36.9097509],
              [51.2255462, 36.9121645],
              [51.2188572, 36.9136287],
              [51.2027171, 36.9165348],
              [51.194467, 36.918814],
              [51.1856116, 36.9209684],
              [51.1663096, 36.9253497],
              [51.1602732, 36.9266538],
              [51.1553583, 36.9276101],
              [51.1281787, 36.9353277],
              [51.12435, 36.9366721],
              [51.1225636, 36.9374817],
              [51.1177636, 36.9395474],
              [51.1129083, 36.9415283],
              [51.1080001, 36.9434235],
              [51.1030413, 36.945232],
              [51.0980343, 36.9469532],
              [51.0929815, 36.948586],
              [51.0878853, 36.9501298],
              [51.0851513, 36.9509036],
              [51.0780703, 36.9538308],
              [51.0736934, 36.9564021],
              [51.0692701, 36.958954],
              [51.0647782, 36.9614277],
              [51.0602199, 36.963822],
              [51.0555973, 36.9661358],
              [51.0531763, 36.9672893],
              [51.0456617, 36.9725846],
              [51.0400608, 36.9762582],
              [51.034329, 36.9797998],
              [51.0275384, 36.9838706],
              [51.0216459, 36.9872962],
              [51.0156311, 36.9905824],
              [51.0094989, 36.9937263],
              [51.0059608, 36.9954255],
              [50.9999708, 36.9987307],
              [50.9934571, 37.0020905],
              [50.9866976, 37.0053414],
              [50.9861894, 37.0055769],
              [50.9814698, 37.0077088],
              [50.9766933, 37.009758],
              [50.9718623, 37.0117235],
              [50.9669791, 37.0136043],
              [50.962046, 37.0153995],
              [50.9570652, 37.0171084],
              [50.9520392, 37.0187301],
              [50.9508236, 37.019098],
              [50.9429801, 37.0221793],
              [50.9372961, 37.0251394],
              [50.9324478, 37.0284708],
              [50.9282385, 37.0312499],
              [50.9239543, 37.0339545],
              [50.9195972, 37.0365834],
              [50.9151693, 37.0391353],
              [50.9106727, 37.041609],
              [50.9061095, 37.0440033],
              [50.9014821, 37.046317],
              [50.8967924, 37.0485491],
              [50.8932914, 37.0501441],
              [50.8927074, 37.0504052],
              [50.8839662, 37.0541324],
              [50.8750469, 37.0575786],
              [50.865838, 37.0607774],
              [50.8626426, 37.0620669],
              [50.8577267, 37.0639621],
              [50.8527601, 37.0657707],
              [50.8520718, 37.0660069],
              [50.8434125, 37.0739607],
              [50.8369756, 37.0796476],
              [50.8302706, 37.0851324],
              [50.8233074, 37.090407],
              [50.8160961, 37.0954636],
              [50.8118831, 37.0982427],
              [50.8075951, 37.1009473],
              [50.8032341, 37.1035761],
              [50.7988023, 37.106128],
              [50.7943018, 37.1086017],
              [50.7897347, 37.110996],
              [50.7851031, 37.1133097],
              [50.7804094, 37.1155418],
              [50.7756557, 37.1176911],
              [50.7708443, 37.1197567],
              [50.7659776, 37.1217376],
              [50.7610578, 37.1236327],
              [50.7560873, 37.1254413],
              [50.7520011, 37.1268426],
              [50.7414062, 37.1307152],
              [50.7398919, 37.131806],
              [50.7357537, 37.1346581],
              [50.7315385, 37.1374371],
              [50.5875665, 36.968186],
              [50.5857445, 36.9672624],
              [50.5888539, 36.960171],
              [50.5853596, 36.9553636],
              [50.5811996, 36.952741],
              [50.5730036, 36.9524367],
              [50.5684621, 36.9487785],
              [50.5674278, 36.9411326],
              [50.5660342, 36.9361721],
              [50.5628585, 36.9299288],
              [50.5578803, 36.9252631],
              [50.5400672, 36.9090291],
              [50.5375697, 36.9069771],
              [50.5359444, 36.9055611],
              [50.5350672, 36.904424],
              [50.5336375, 36.9027241],
              [50.5258783, 36.8927975],
              [50.5226033, 36.8867565],
              [50.521473, 36.8868327],
              [50.5217878, 36.8884766],
              [50.5198544, 36.8882106],
              [50.5150987, 36.8865545],
              [50.510232, 36.8915141],
              [50.5099868, 36.8895751],
              [50.5086135, 36.8855935],
              [50.5080986, 36.8841518],
              [50.506854, 36.8821608],
              [50.5054163, 36.8802901],
              [50.4999446, 36.8768916],
              [50.49046, 36.8777485],
              [50.4864692, 36.8775953],
              [50.4813398, 36.8768973],
              [50.4723404, 36.8744124],
              [50.4689169, 36.873716],
              [50.4650518, 36.8734855],
              [50.4575598, 36.8733138],
              [50.4549694, 36.8729264],
              [50.4532527, 36.8722055],
              [50.4513645, 36.8717935],
              [50.4494471, 36.870738],
              [50.4468139, 36.8683225],
              [50.4447614, 36.8667343],
              [50.4431018, 36.8647941],
              [50.4400561, 36.8617295],
              [50.4354384, 36.8565305],
              [50.4314518, 36.8526685],
              [50.4232977, 36.8440488],
              [50.4221654, 36.8355556],
              [50.423126, 36.8267375],
              [50.4126547, 36.8164313],
              [50.4047583, 36.8116212],
              [50.4078482, 36.8050241],
              [50.4159163, 36.8030999],
              [50.4214094, 36.7996636],
              [50.4254436, 36.7956084],
              [50.4286192, 36.7915533],
              [50.4303787, 36.7828578],
              [50.4349279, 36.7771175],
              [50.4369019, 36.7739379],
              [50.4370843, 36.7703113],
              [50.4364299, 36.7658421],
              [50.4359149, 36.7604787],
              [50.4360866, 36.7533959],
              [50.4355716, 36.7487194],
              [50.433855, 36.7476878],
              [50.4310226, 36.7429422],
              [50.4266452, 36.7384027],
              [50.4246711, 36.7373022],
              [50.4197787, 36.7313178],
              [50.4174613, 36.7282222],
              [50.4172896, 36.724301],
              [50.4154014, 36.7231315],
              [50.4129323, 36.7125977],
              [50.4131481, 36.7074981],
              [50.4122256, 36.6969844],
              [50.4125978, 36.6873202],
              [50.3854465, 36.6680059],
              [50.3834724, 36.6675928],
              [50.3775119, 36.6636305],
              [50.3635962, 36.6533413],
              [50.3531741, 36.6436307],
              [50.3505992, 36.6390853],
              [50.3493117, 36.637639],
              [50.3464793, 36.6366748],
              [50.3397845, 36.6366059],
              [50.3382826, 36.6365542],
              [50.3342888, 36.6376263]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 269903,
        "tags": {
          "ISO3166-2": "IR-27",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "گلستان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q170041"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [53.6649493, 37.3561378],
              [53.6615361, 37.3557644],
              [53.6610461, 37.3516823],
              [53.6606429, 37.3473226],
              [53.6603589, 37.342957],
              [53.6601943, 37.3385874],
              [53.6603225, 37.3272808],
              [53.6607963, 37.3203546],
              [53.6615699, 37.3134457],
              [53.6626423, 37.3065622],
              [53.66491, 37.2938074],
              [53.6663438, 37.2866685],
              [53.6673666, 37.2823739],
              [53.6685062, 37.2780982],
              [53.6691179, 37.2764618],
              [53.6692445, 37.2758027],
              [53.6693616, 37.2752005],
              [53.669732, 37.2714612],
              [53.6702826, 37.2671118],
              [53.6709516, 37.262773],
              [53.6717388, 37.2584469],
              [53.6726438, 37.2541355],
              [53.6732982, 37.2520675],
              [53.6737852, 37.2498659],
              [53.6742823, 37.2477773],
              [53.6748382, 37.2455731],
              [53.6753888, 37.2435058],
              [53.6760089, 37.2412966],
              [53.6766102, 37.2392574],
              [53.6772696, 37.2371444],
              [53.6776241, 37.2359424],
              [53.6778915, 37.2350153],
              [53.6791319, 37.2307367],
              [53.6805412, 37.2267468],
              [53.6814494, 37.2236964],
              [53.6836677, 37.2170138],
              [53.6838183, 37.2163634],
              [53.6847287, 37.2120306],
              [53.6858673, 37.2077548],
              [53.687122, 37.2035],
              [53.6884924, 37.1992679],
              [53.6899777, 37.1950608],
              [53.6915807, 37.1910831],
              [53.6931791, 37.1869051],
              [53.6946727, 37.1829018],
              [53.6963854, 37.1787505],
              [53.6968562, 37.1776877],
              [53.6975599, 37.175694],
              [53.699159, 37.1715137],
              [53.7008714, 37.1673624],
              [53.7011251, 37.1667896],
              [53.7017597, 37.1649785],
              [53.7033166, 37.1608748],
              [53.7049826, 37.1567986],
              [53.7067571, 37.1527518],
              [53.7114965, 37.142298],
              [53.7116877, 37.1415795],
              [53.7129414, 37.1373246],
              [53.7143105, 37.1330925],
              [53.7157945, 37.1288853],
              [53.7173925, 37.1247051],
              [53.7178565, 37.1235323],
              [53.7194114, 37.119105],
              [53.7210093, 37.1149248],
              [53.7227205, 37.1107734],
              [53.7235979, 37.1087907],
              [53.7237851, 37.1082149],
              [53.7252557, 37.1040584],
              [53.7268377, 37.0999283],
              [53.7285303, 37.0958264],
              [53.7287893, 37.0952413],
              [53.7289582, 37.0947085],
              [53.7295316, 37.0930997],
              [53.8548049, 36.939096],
              [53.8565366, 36.9023082],
              [53.8574156, 36.8836278],
              [53.8621766, 36.7823724],
              [53.8622148, 36.7815592],
              [53.8622148, 36.7811231],
              [53.8624914, 36.780844],
              [53.8622148, 36.7805649],
              [53.8624915, 36.7800067],
              [53.8622148, 36.7769544],
              [53.8616582, 36.7636195],
              [53.8661048, 36.7494471],
              [53.8644382, 36.7447289],
              [53.8608248, 36.7397225],
              [53.8605482, 36.7391733],
              [53.8602681, 36.7358417],
              [53.8611015, 36.7333385],
              [53.8616582, 36.7300068],
              [53.8619348, 36.7250003],
              [53.8622149, 36.7233345],
              [53.8624915, 36.7230554],
              [53.8624915, 36.7050012],
              [53.8622148, 36.7044429],
              [53.8608248, 36.698896],
              [53.8608248, 36.6972211],
              [53.8613815, 36.6961134],
              [53.8619348, 36.6941684],
              [53.8622149, 36.6936191],
              [53.8622148, 36.6925025],
              [53.8622148, 36.6902783],
              [53.8619348, 36.6861091],
              [53.8647148, 36.6794543],
              [53.869158, 36.6736101],
              [53.8711345, 36.672555],
              [53.8733247, 36.6713859],
              [53.8747147, 36.6711157],
              [53.8827713, 36.6691706],
              [53.8872145, 36.6691705],
              [53.8883279, 36.6694497],
              [53.8911045, 36.6694497],
              [53.8927711, 36.6694497],
              [53.8936045, 36.6697289],
              [53.8949945, 36.6697289],
              [53.8958278, 36.6700081],
              [53.8972144, 36.670008],
              [53.9044377, 36.6713858],
              [53.9063844, 36.6713858],
              [53.9130509, 36.6730608],
              [53.9205508, 36.6755551],
              [53.9233274, 36.6758343],
              [53.9244409, 36.6761135],
              [53.9266608, 36.6761135],
              [53.9280508, 36.6763926],
              [53.929994, 36.6763926],
              [53.932774, 36.6769419],
              [53.9383272, 36.676942],
              [53.9391606, 36.6766628],
              [53.9465393, 36.6767714],
              [53.9472172, 36.6769419],
              [53.9499972, 36.6769419],
              [53.9511072, 36.6766628],
              [53.9647204, 36.675285],
              [53.9738474, 36.669847],
              [53.9744402, 36.6694497],
              [53.9922201, 36.6544471],
              [53.9936101, 36.6533394],
              [53.9969433, 36.6513942],
              [54.0109196, 36.6450476],
              [54.0136963, 36.6447684],
              [54.014253, 36.6444893],
              [54.0167529, 36.6444893],
              [54.0173096, 36.644219],
              [54.0184196, 36.6442191],
              [54.0186962, 36.6439399],
              [54.0195295, 36.6439398],
              [54.0200862, 36.6436607],
              [54.0211962, 36.6436607],
              [54.0225861, 36.6431023],
              [54.0236961, 36.6431024],
              [54.0242528, 36.6428231],
              [54.0256428, 36.6428231],
              [54.0264761, 36.642553],
              [54.0275861, 36.6425529],
              [54.0307613, 36.6439023],
              [54.0346512, 36.6439023],
              [54.0477795, 36.6422267],
              [54.0699562, 36.6323587],
              [54.0832898, 36.6224168],
              [54.1498339, 36.6169662],
              [54.1506672, 36.6161287],
              [54.1559472, 36.6130756],
              [54.1645571, 36.6036281],
              [54.1662237, 36.600575],
              [54.1687237, 36.5950181],
              [54.1673306, 36.5713915],
              [54.167884, 36.5691759],
              [54.1698306, 36.5494516],
              [54.1687207, 36.5416789],
              [54.1515045, 36.5241196],
              [54.1512245, 36.5221833],
              [54.1503912, 36.5174551],
              [54.1501146, 36.5152306],
              [54.1498379, 36.5127358],
              [54.1505536, 36.5091793],
              [54.1518045, 36.5073446],
              [54.1548411, 36.5064548],
              [54.1612555, 36.5057032],
              [54.1645577, 36.5061248],
              [54.1709785, 36.5067781],
              [54.1723413, 36.5057876],
              [54.1725832, 36.5052321],
              [54.1729727, 36.504826],
              [54.1746296, 36.5053178],
              [54.1759101, 36.5056977],
              [54.1762582, 36.505792],
              [54.1779369, 36.5057919],
              [54.1789886, 36.5057919],
              [54.1795801, 36.5060739],
              [54.1813369, 36.506334],
              [54.1827294, 36.5065402],
              [54.1843423, 36.5067789],
              [54.1860666, 36.5070342],
              [54.1876265, 36.5072651],
              [54.189106, 36.5074841],
              [54.1905883, 36.5077036],
              [54.1920782, 36.5079241],
              [54.1936936, 36.5081633],
              [54.1951303, 36.508376],
              [54.1965468, 36.5085857],
              [54.1983021, 36.5088455],
              [54.1993511, 36.5088454],
              [54.2007506, 36.5088454],
              [54.2020733, 36.5088453],
              [54.2032262, 36.5088453],
              [54.2063842, 36.5088451],
              [54.2225074, 36.5049987],
              [54.234454, 36.5049987],
              [54.2489006, 36.505548],
              [54.2597338, 36.5063857],
              [54.2747335, 36.5063857],
              [54.2766769, 36.5066649],
              [54.2914, 36.506665],
              [54.2994566, 36.5074936],
              [54.3019566, 36.5074936],
              [54.3091799, 36.5083312],
              [54.3111232, 36.5083312],
              [54.3127897, 36.5086104],
              [54.3150131, 36.5086104],
              [54.3230697, 36.5099975],
              [54.325013, 36.5099976],
              [54.3258463, 36.5102767],
              [54.3311263, 36.5102768],
              [54.3327929, 36.510556],
              [54.3344595, 36.5105559],
              [54.3377929, 36.5113846],
              [54.3400162, 36.5113846],
              [54.3405695, 36.5116638],
              [54.3414028, 36.5116638],
              [54.3419595, 36.511943],
              [54.3444595, 36.5122222],
              [54.3734451, 36.5102939],
              [54.3775357, 36.5114448],
              [54.3792023, 36.5114448],
              [54.3803123, 36.511724],
              [54.3830924, 36.511724],
              [54.3836455, 36.5120031],
              [54.3950354, 36.5120032],
              [54.3961454, 36.511724],
              [54.4122585, 36.511724],
              [54.4314251, 36.5139141],
              [54.4319816, 36.5139141],
              [54.436705, 36.5128061],
              [54.4580019, 36.5251828],
              [54.4593919, 36.5249037],
              [54.4618918, 36.5251828],
              [54.4657784, 36.5251829],
              [54.4685585, 36.5254531],
              [54.4699484, 36.5257322],
              [54.4727251, 36.5257322],
              [54.4807816, 36.5268488],
              [54.4893915, 36.528794],
              [54.4899481, 36.5290731],
              [54.4910582, 36.5290731],
              [54.4958949, 36.5224634],
              [54.5334708, 36.5170059],
              [54.5439241, 36.5182047],
              [54.5561473, 36.522376],
              [54.5564239, 36.5226551],
              [54.5572145, 36.5229677],
              [54.5578139, 36.5232048],
              [54.5714947, 36.5303298],
              [54.5745846, 36.5595669],
              [54.5776745, 36.5739056],
              [54.6099469, 36.5728027],
              [54.6271593, 36.5797623],
              [54.630216, 36.5828156],
              [54.6437125, 36.610783],
              [54.6448226, 36.612449],
              [54.6567691, 36.6227237],
              [54.6587123, 36.6232821],
              [54.6620898, 36.6243932],
              [54.6662316, 36.6252218],
              [54.6755857, 36.6252782],
              [54.685309, 36.6277817],
              [54.686419, 36.6277817],
              [54.6894756, 36.6288894],
              [54.690309, 36.6288895],
              [54.6911422, 36.6294478],
              [54.6994755, 36.6316631],
              [54.7008655, 36.6325007],
              [54.7219787, 36.6175062],
              [54.7253119, 36.6158312],
              [54.747255, 36.6041687],
              [54.7550349, 36.6019442],
              [54.7617015, 36.6008365],
              [54.7642015, 36.6008365],
              [54.7655915, 36.6005573],
              [54.7669781, 36.6005573],
              [54.7678114, 36.6002781],
              [54.7780913, 36.6002781],
              [54.7889245, 36.6027817],
              [54.8231499, 36.6100166],
              [54.8378773, 36.6291045],
              [54.842324, 36.6304911],
              [54.8598237, 36.6377129],
              [54.9122631, 36.6644427],
              [54.9228197, 36.6750057],
              [54.923653, 36.6766626],
              [54.9472661, 36.7047219],
              [54.9472661, 36.7050009],
              [54.9475428, 36.7052802],
              [54.9478227, 36.7055593],
              [54.9478228, 36.7058384],
              [54.9589327, 36.7183369],
              [54.9769892, 36.7422255],
              [54.9806026, 36.7472319],
              [54.9872691, 36.7547233],
              [55.0014356, 36.7641687],
              [55.0100454, 36.767221],
              [55.0375485, 36.7730645],
              [55.0383819, 36.7733347],
              [55.0406052, 36.7733347],
              [55.0500485, 36.7750094],
              [55.0525483, 36.7750094],
              [55.0561617, 36.7755586],
              [55.0575483, 36.7755586],
              [55.0583817, 36.7758377],
              [55.0611616, 36.7758377],
              [55.0619949, 36.7761168],
              [55.0656049, 36.7761168],
              [55.0667149, 36.776396],
              [55.072828, 36.7763959],
              [55.0761615, 36.7766751],
              [55.079218, 36.776675],
              [55.0808847, 36.7769542],
              [55.084218, 36.7769542],
              [55.0908846, 36.7775034],
              [55.0956079, 36.778899],
              [55.1069943, 36.7808439],
              [55.1097745, 36.7808438],
              [55.1111644, 36.7811229],
              [55.1125511, 36.7811229],
              [55.115331, 36.7811229],
              [55.1161643, 36.781123],
              [55.1219976, 36.781123],
              [55.1278309, 36.7830587],
              [55.1281075, 36.7833379],
              [55.1297741, 36.7833379],
              [55.1303308, 36.783617],
              [55.1311642, 36.783617],
              [55.1317209, 36.7838961],
              [55.1372741, 36.7838961],
              [55.1386642, 36.7841752],
              [55.1417208, 36.7841753],
              [55.1553305, 36.7855618],
              [55.1806102, 36.7866692],
              [55.1878336, 36.7872274],
              [55.1906102, 36.7872275],
              [55.1945001, 36.7877857],
              [55.1986668, 36.7877857],
              [55.2075566, 36.788614],
              [55.2172799, 36.788614],
              [55.2197798, 36.7888931],
              [55.2233898, 36.7888932],
              [55.2258898, 36.7891723],
              [55.2281131, 36.7891722],
              [55.229223, 36.7894514],
              [55.231723, 36.7894513],
              [55.2542261, 36.7922245],
              [55.2661693, 36.7947275],
              [55.2683926, 36.7955648],
              [55.2728359, 36.7980589],
              [55.273116, 36.798338],
              [55.2811725, 36.798338],
              [55.2820058, 36.798617],
              [55.2845059, 36.7986171],
              [55.2867258, 36.7991753],
              [55.2872823, 36.7991753],
              [55.2925589, 36.7997245],
              [55.2947823, 36.7997245],
              [55.295339, 36.8000036],
              [55.2967257, 36.8000036],
              [55.2983922, 36.8005618],
              [55.3164487, 36.8030648],
              [55.3183956, 36.8030648],
              [55.3220055, 36.8036141],
              [55.3245054, 36.803614],
              [55.3542283, 36.8077827],
              [55.3595083, 36.8083409],
              [55.3603416, 36.80862],
              [55.362285, 36.8086199],
              [55.3736748, 36.8105647],
              [55.4008978, 36.8169571],
              [55.4128444, 36.8252852],
              [55.4164544, 36.8277791],
              [55.4706239, 36.8772322],
              [55.5000701, 36.9011157],
              [55.50618, 36.8994503],
              [55.5397425, 36.9163334],
              [55.5416891, 36.9168915],
              [55.5430758, 36.9168915],
              [55.5472424, 36.9188355],
              [55.548357, 36.9193923],
              [55.5508557, 36.9205006],
              [55.5511324, 36.9207795],
              [55.5525223, 36.9207796],
              [55.5603495, 36.9252866],
              [55.5625728, 36.9283473],
              [55.5636862, 36.9294545],
              [55.5792393, 36.9555598],
              [55.5795194, 36.9572341],
              [55.585076, 36.9708445],
              [55.5914625, 36.9889012],
              [55.5961859, 36.9983434],
              [55.5970192, 37.0019529],
              [55.5986858, 37.0063993],
              [55.5986859, 37.0083436],
              [55.5989626, 37.0086226],
              [55.5986859, 37.0091717],
              [55.5989626, 37.0094507],
              [55.5992426, 37.0130691],
              [55.6017425, 37.0327899],
              [55.6020192, 37.0380643],
              [55.6025759, 37.0439057],
              [55.6036858, 37.051124],
              [55.6039659, 37.0519521],
              [55.6041866, 37.0530654],
              [55.6041872, 37.0530682],
              [55.6045191, 37.0558493],
              [55.6070192, 37.0688997],
              [55.6214658, 37.0991758],
              [55.6303556, 37.1119554],
              [55.6306323, 37.1122344],
              [55.6416647, 37.1234176],
              [55.6511887, 37.1330683],
              [55.6547987, 37.1361281],
              [55.6603553, 37.1408438],
              [55.6756351, 37.1536226],
              [55.6767451, 37.1544595],
              [55.6770253, 37.1552875],
              [55.686745, 37.1639085],
              [55.7006349, 37.1830671],
              [55.7072883, 37.1870346],
              [55.7109782, 37.1912503],
              [55.7140049, 37.1951219],
              [55.7205279, 37.2004712],
              [55.720528, 37.2018572],
              [55.7267877, 37.2120972],
              [55.7270644, 37.2157058],
              [55.7273445, 37.2226531],
              [55.7270644, 37.2284845],
              [55.7273445, 37.2293215],
              [55.7276211, 37.2315442],
              [55.7278978, 37.233209],
              [55.7298443, 37.2493259],
              [55.7301211, 37.2537713],
              [55.7312344, 37.2579377],
              [55.7348443, 37.2626619],
              [55.7450811, 37.284736],
              [55.7513466, 37.2885519],
              [55.7578612, 37.2925188],
              [55.7889741, 37.3080749],
              [55.8086256, 37.3178633],
              [55.8223071, 37.322245],
              [55.8253636, 37.3230728],
              [55.8278637, 37.3233517],
              [55.8292538, 37.3239094],
              [55.8417534, 37.3255739],
              [55.8453635, 37.3255739],
              [55.8514767, 37.3261317],
              [55.8692842, 37.3230584],
              [55.8788637, 37.3232431],
              [55.8865927, 37.3245777],
              [55.898609, 37.3301743],
              [55.9095953, 37.3316757],
              [55.9203695, 37.3344627],
              [55.9214795, 37.3344626],
              [55.9370611, 37.3389096],
              [55.9499357, 37.339319],
              [55.9692072, 37.3458583],
              [55.983753, 37.3540575],
              [55.9942863, 37.3658765],
              [55.9951197, 37.3661554],
              [56.0100181, 37.4025281],
              [56.0100181, 37.4036345],
              [56.0172698, 37.4233405],
              [56.0169982, 37.4317542],
              [56.016197, 37.4405194],
              [56.0125921, 37.4456985],
              [56.0100172, 37.4504684],
              [56.0127638, 37.4561918],
              [56.0144036, 37.4739691],
              [56.0152367, 37.475363],
              [56.0154596, 37.4756963],
              [56.0376547, 37.4887528],
              [56.0400951, 37.5140143],
              [56.0465118, 37.5484696],
              [56.0467886, 37.549306],
              [56.0465118, 37.5543064],
              [56.0570249, 37.573563],
              [56.056745, 37.5757841],
              [56.0697483, 37.6070152],
              [56.0705817, 37.6075637],
              [56.0739149, 37.6111783],
              [56.0972514, 37.6345112],
              [56.1066947, 37.645894],
              [56.1125446, 37.6582266],
              [56.113378, 37.6596203],
              [56.114488, 37.6629471],
              [56.1153212, 37.6640619],
              [56.1264046, 37.6822038],
              [56.1277911, 37.6891542],
              [56.1390224, 37.7095356],
              [56.1488826, 37.7258524],
              [56.1648238, 37.7453091],
              [56.2044115, 37.7901749],
              [56.2074832, 37.7964353],
              [56.2077598, 37.7975502],
              [56.2256343, 37.8098609],
              [56.2270245, 37.8126389],
              [56.2275811, 37.8143111],
              [56.2286911, 37.8159743],
              [56.2307738, 37.8251077],
              [56.2360953, 37.8352765],
              [56.2354086, 37.8523568],
              [56.2319754, 37.8603534],
              [56.232233, 37.8635382],
              [56.2350003, 37.8647055],
              [56.2405569, 37.8641572],
              [56.2472235, 37.8641571],
              [56.2622298, 37.8711423],
              [56.2641766, 37.8711423],
              [56.2669532, 37.8719782],
              [56.2680631, 37.8719782],
              [56.2801286, 37.8728814],
              [56.2935619, 37.8734377],
              [56.3041025, 37.880633],
              [56.310484, 37.8898926],
              [56.3236712, 37.9070818],
              [56.3357953, 37.9143766],
              [56.33948, 37.9172148],
              [56.3449732, 37.9221354],
              [56.3560805, 37.9361976],
              [56.3561864, 37.9369846],
              [56.3573248, 37.9395145],
              [56.3593179, 37.944911],
              [56.3595196, 37.9783041],
              [56.3608929, 37.9845281],
              [56.3681027, 37.9937279],
              [56.369476, 38.0061728],
              [56.368446, 38.0213204],
              [56.3196942, 38.0551205],
              [56.3073034, 38.0728594],
              [56.3070235, 38.0742522],
              [56.2899866, 38.0819364],
              [56.2892888, 38.0841197],
              [56.2889756, 38.0846583],
              [56.2865914, 38.0830619],
              [56.2863267, 38.0827046],
              [56.2861794, 38.0821558],
              [56.2859798, 38.081862],
              [56.2856934, 38.0817051],
              [56.2851205, 38.0816267],
              [56.2834642, 38.0816038],
              [56.281237, 38.0811519],
              [56.2806923, 38.0808098],
              [56.2807837, 38.0789934],
              [56.2750711, 38.080458],
              [56.267222, 38.080833],
              [56.260833, 38.079444],
              [56.254444, 38.077778],
              [56.248056, 38.076389],
              [56.2435802, 38.0777346],
              [56.2369056, 38.0765853],
              [56.2316907, 38.0751964],
              [56.2239953, 38.0744558],
              [56.2197567, 38.0739223],
              [56.216111, 38.072222],
              [56.210556, 38.074722],
              [56.204722, 38.077222],
              [56.198889, 38.079722],
              [56.194167, 38.083056],
              [56.189444, 38.086111],
              [56.183611, 38.088611],
              [56.178889, 38.091667],
              [56.173056, 38.094444],
              [56.164444, 38.095],
              [56.1575, 38.094167],
              [56.151111, 38.092778],
              [56.143889, 38.091944],
              [56.136944, 38.091111],
              [56.1301701, 38.0909461],
              [56.123611, 38.088889],
              [56.117222, 38.0875],
              [56.11, 38.086667],
              [56.103889, 38.085],
              [56.096667, 38.084167],
              [56.0931659, 38.0878973],
              [56.0863158, 38.0860852],
              [56.0822053, 38.0847299],
              [56.0734015, 38.0838129],
              [56.0643567, 38.0824909],
              [56.0546311, 38.0814187],
              [56.0387198, 38.0807245],
              [56.0328933, 38.0797611],
              [56.0257659, 38.0789713],
              [56.0213858, 38.0776766],
              [56.0168691, 38.0798921],
              [56.0101299, 38.0783418],
              [56.0016356, 38.0790348],
              [55.9980044, 38.0771301],
              [55.9933502, 38.078591],
              [55.9858853, 38.0765806],
              [55.985971, 38.0777721],
              [55.9837119, 38.0792086],
              [55.979345, 38.0788649],
              [55.976618, 38.0790564],
              [55.9711545, 38.0839578],
              [55.9625, 38.078333],
              [55.956944, 38.080833],
              [55.951944, 38.083889],
              [55.946389, 38.086389],
              [55.940556, 38.088889],
              [55.934722, 38.091667],
              [55.9282736, 38.0926222],
              [55.927222, 38.092778],
              [55.919167, 38.092778],
              [55.911389, 38.092778],
              [55.906111, 38.091944],
              [55.898889, 38.091111],
              [55.891944, 38.090278],
              [55.883333, 38.091111],
              [55.875556, 38.092222],
              [55.868056, 38.093611],
              [55.861111, 38.095556],
              [55.854444, 38.0975],
              [55.848611, 38.1],
              [55.841944, 38.101944],
              [55.837222, 38.105],
              [55.8325, 38.108056],
              [55.8275, 38.111389],
              [55.821944, 38.113889],
              [55.816944, 38.116944],
              [55.812222, 38.12],
              [55.806389, 38.1225],
              [55.798611, 38.1225],
              [55.792222, 38.121111],
              [55.785278, 38.120278],
              [55.777222, 38.120278],
              [55.770556, 38.122222],
              [55.763889, 38.124167],
              [55.756111, 38.125278],
              [55.748333, 38.125278],
              [55.742778, 38.123056],
              [55.736389, 38.121389],
              [55.730278, 38.12],
              [55.723889, 38.118333],
              [55.716944, 38.1175],
              [55.709722, 38.116667],
              [55.703333, 38.115278],
              [55.698056, 38.113056],
              [55.691667, 38.111389],
              [55.684444, 38.110556],
              [55.6827879, 38.1103571],
              [55.6775, 38.109722],
              [55.670278, 38.108889],
              [55.6625, 38.108889],
              [55.654722, 38.108889],
              [55.646944, 38.108889],
              [55.638889, 38.108889],
              [55.631111, 38.108611],
              [55.624167, 38.107778],
              [55.616111, 38.107778],
              [55.61, 38.106389],
              [55.603611, 38.104722],
              [55.597222, 38.103333],
              [55.592778, 38.101389],
              [55.586389, 38.1],
              [55.579444, 38.099167],
              [55.571667, 38.099167],
              [55.564444, 38.098333],
              [55.556667, 38.098333],
              [55.549444, 38.0975],
              [55.5425, 38.096667],
              [55.536111, 38.095],
              [55.53, 38.093611],
              [55.523611, 38.091944],
              [55.516389, 38.091111],
              [55.507778, 38.091944],
              [55.5, 38.091667],
              [55.492222, 38.091667],
              [55.484444, 38.091667],
              [55.477222, 38.090833],
              [55.469444, 38.090833],
              [55.463056, 38.089167],
              [55.456111, 38.088333],
              [55.448889, 38.0875],
              [55.442778, 38.086111],
              [55.438056, 38.083056],
              [55.4325, 38.080556],
              [55.427778, 38.0775],
              [55.423056, 38.074444],
              [55.418889, 38.070833],
              [55.414167, 38.067778],
              [55.410278, 38.063889],
              [55.406389, 38.06],
              [55.402222, 38.056389],
              [55.398333, 38.0525],
              [55.394444, 38.048611],
              [55.389444, 38.045],
              [55.384722, 38.041944],
              [55.379444, 38.039444],
              [55.373889, 38.037222],
              [55.3675595, 38.0361742],
              [55.361944, 38.033333],
              [55.356389, 38.031111],
              [55.350833, 38.028889],
              [55.344722, 38.027222],
              [55.339167, 38.025],
              [55.332778, 38.023333],
              [55.3275, 38.021111],
              [55.321944, 38.018611],
              [55.316389, 38.016389],
              [55.3139263, 38.0088697],
              [55.3031359, 38.0054301],
              [55.2957659, 38.0028555],
              [55.289167, 38.000833],
              [55.2835226, 37.997925],
              [55.273663, 37.9904761],
              [55.2733911, 37.9908448],
              [55.2729267, 37.9915752],
              [55.2726926, 37.9922382],
              [55.2723457, 37.9926347],
              [55.271844, 37.9925905],
              [55.2714784, 37.9923544],
              [55.2711228, 37.9917512],
              [55.2704379, 37.991187],
              [55.2700062, 37.9910677],
              [55.269421, 37.991355],
              [55.2688852, 37.9917324],
              [55.2686799, 37.9920559],
              [55.2687118, 37.9925937],
              [55.2686164, 37.9928735],
              [55.2683649, 37.9931131],
              [55.2679454, 37.993211],
              [55.2676624, 37.9930858],
              [55.2673241, 37.992621],
              [55.2669339, 37.9919785],
              [55.2667737, 37.9912624],
              [55.2665349, 37.9909806],
              [55.2661793, 37.9909738],
              [55.2655376, 37.9911856],
              [55.2649738, 37.9913429],
              [55.2646603, 37.9911172],
              [55.2644882, 37.990632],
              [55.2644882, 37.9902219],
              [55.2642367, 37.9898665],
              [55.2633696, 37.9898878],
              [55.2625881, 37.9903281],
              [55.2616759, 37.9906073],
              [55.2612068, 37.9898004],
              [55.2610682, 37.9889263],
              [55.2610682, 37.9881833],
              [55.2617614, 37.9872655],
              [55.2617614, 37.986741],
              [55.2613177, 37.9862602],
              [55.2606245, 37.9863039],
              [55.2599314, 37.9870688],
              [55.2591273, 37.9873966],
              [55.2589609, 37.9878992],
              [55.2587668, 37.988817],
              [55.2582954, 37.9889482],
              [55.2576854, 37.988533],
              [55.2572141, 37.9879429],
              [55.2572973, 37.9872655],
              [55.2570477, 37.9863913],
              [55.2565209, 37.9860417],
              [55.2557722, 37.9859106],
              [55.2549404, 37.985998],
              [55.2537481, 37.9865662],
              [55.2526945, 37.9868503],
              [55.2518904, 37.9868066],
              [55.2509477, 37.986588],
              [55.2502822, 37.9862384],
              [55.2504486, 37.9856702],
              [55.2511418, 37.9852987],
              [55.2516131, 37.9848834],
              [55.2515577, 37.9843152],
              [55.2510309, 37.9838344],
              [55.2508645, 37.9831132],
              [55.2510586, 37.9825232],
              [55.2506704, 37.9823046],
              [55.2496445, 37.9823046],
              [55.2488127, 37.9821079],
              [55.2472322, 37.9816708],
              [55.2462617, 37.9809715],
              [55.2455408, 37.9805344],
              [55.2449031, 37.9808403],
              [55.2446535, 37.9817801],
              [55.2438772, 37.9824139],
              [55.2432949, 37.9824795],
              [55.2426572, 37.9821079],
              [55.2420749, 37.981496],
              [55.2417144, 37.9805562],
              [55.2412985, 37.9802721],
              [55.2406053, 37.9802721],
              [55.2399676, 37.9800317],
              [55.2394408, 37.9797476],
              [55.2385535, 37.9795509],
              [55.2384703, 37.9791137],
              [55.2389417, 37.9786766],
              [55.2393299, 37.9781739],
              [55.2393853, 37.9776057],
              [55.2388031, 37.9771467],
              [55.237999, 37.9768189],
              [55.2369453, 37.9767314],
              [55.236058, 37.9771248],
              [55.2355867, 37.9776275],
              [55.234533, 37.9779772],
              [55.2335349, 37.9788515],
              [55.2331189, 37.9793104],
              [55.2325644, 37.9793542],
              [55.2316494, 37.9791793],
              [55.2307898, 37.9788733],
              [55.2303739, 37.9784362],
              [55.2300967, 37.978021],
              [55.2295698, 37.9781084],
              [55.2292371, 37.9786548],
              [55.2291539, 37.979223],
              [55.2287657, 37.9796164],
              [55.2279062, 37.9796164],
              [55.2271298, 37.9792886],
              [55.2266862, 37.9788296],
              [55.2262703, 37.9779554],
              [55.225688, 37.977409],
              [55.2247175, 37.9772778],
              [55.2237193, 37.9768844],
              [55.223248, 37.9764692],
              [55.2234143, 37.9757479],
              [55.2233312, 37.9749392],
              [55.2225271, 37.9745676],
              [55.221723, 37.9746113],
              [55.2208911, 37.9743709],
              [55.2209189, 37.9737808],
              [55.2216121, 37.9731906],
              [55.2216398, 37.9724693],
              [55.2213071, 37.9720321],
              [55.2203643, 37.9714201],
              [55.2195602, 37.9712453],
              [55.2190889, 37.971442],
              [55.2185343, 37.971595],
              [55.2182016, 37.9715076],
              [55.2182293, 37.9710704],
              [55.2186175, 37.9705458],
              [55.2191166, 37.96989],
              [55.2196157, 37.9695622],
              [55.2192275, 37.9691469],
              [55.2184789, 37.9686878],
              [55.2177302, 37.9687097],
              [55.2166489, 37.968819],
              [55.2160389, 37.9686878],
              [55.2153457, 37.9681632],
              [55.2154288, 37.9675512],
              [55.2159002, 37.9671358],
              [55.2155952, 37.9666331],
              [55.214902, 37.9664363],
              [55.2137929, 37.9661522],
              [55.2127393, 37.9659991],
              [55.2117966, 37.9662833],
              [55.2106597, 37.9665019],
              [55.2096061, 37.9664145],
              [55.208802, 37.9660647],
              [55.208497, 37.9654745],
              [55.2086911, 37.9650373],
              [55.2084693, 37.9646438],
              [55.2080256, 37.9640973],
              [55.2077484, 37.9633759],
              [55.2075265, 37.962895],
              [55.206667, 37.9627638],
              [55.2060847, 37.9625452],
              [55.205752, 37.9619987],
              [55.2061956, 37.9615396],
              [55.2069997, 37.961321],
              [55.2074434, 37.9608838],
              [55.2073047, 37.9605559],
              [55.2068333, 37.9602061],
              [55.2058352, 37.9595284],
              [55.2056688, 37.9590256],
              [55.2059461, 37.9582167],
              [55.206667, 37.957845],
              [55.2074156, 37.9577139],
              [55.2075543, 37.9573641],
              [55.2073324, 37.9569487],
              [55.2065561, 37.9567519],
              [55.2055024, 37.9567082],
              [55.2045042, 37.9566645],
              [55.2038942, 37.9563803],
              [55.2038665, 37.9560305],
              [55.2041438, 37.9555932],
              [55.204532, 37.9551122],
              [55.2051142, 37.9545875],
              [55.2056688, 37.9544126],
              [55.2062233, 37.9541284],
              [55.2061124, 37.9538442],
              [55.205447, 37.9536693],
              [55.2045874, 37.9535818],
              [55.2037556, 37.9535381],
              [55.2034506, 37.9530352],
              [55.2036447, 37.9526636],
              [55.2037833, 37.9521607],
              [55.2039774, 37.9515704],
              [55.2043933, 37.9510019],
              [55.205142, 37.9506958],
              [55.205752, 37.9502804],
              [55.2055856, 37.949865],
              [55.2050865, 37.9494714],
              [55.2044765, 37.949209],
              [55.2041172, 37.9492023],
              [55.203312, 37.9491872],
              [55.2025911, 37.9491872],
              [55.2020365, 37.9489466],
              [55.2017038, 37.9486405],
              [55.2020088, 37.9481595],
              [55.2020642, 37.947591],
              [55.2015097, 37.9473068],
              [55.200761, 37.9474161],
              [55.2000124, 37.9476566],
              [55.1994301, 37.9482688],
              [55.1989588, 37.9488811],
              [55.1991251, 37.9493621],
              [55.1993192, 37.9497119],
              [55.199236, 37.9500617],
              [55.1986815, 37.9501273],
              [55.1979328, 37.9499961],
              [55.1973506, 37.9494714],
              [55.1968792, 37.9489904],
              [55.1967406, 37.948247],
              [55.196796, 37.9476348],
              [55.1964633, 37.9471974],
              [55.1957978, 37.9473068],
              [55.1952433, 37.9478097],
              [55.1947719, 37.9480721],
              [55.1944669, 37.9478971],
              [55.1940233, 37.9476785],
              [55.1933301, 37.9475036],
              [55.1927201, 37.9475692],
              [55.1923874, 37.9480283],
              [55.1918883, 37.9490122],
              [55.191306, 37.9503241],
              [55.1909455, 37.9515485],
              [55.1905851, 37.9520514],
              [55.1903078, 37.9524449],
              [55.1903355, 37.9528166],
              [55.1905851, 37.9531664],
              [55.1905019, 37.9535381],
              [55.1901137, 37.9537567],
              [55.1896146, 37.9535818],
              [55.1887533, 37.9531925],
              [55.1872086, 37.9533902],
              [55.1864438, 37.9536427],
              [55.1857167, 37.9539797],
              [55.1849886, 37.9543402],
              [55.1843516, 37.9545107],
              [55.1837567, 37.9543965],
              [55.1831681, 37.95416],
              [55.182685, 37.9542016],
              [55.1823657, 37.9546073],
              [55.182156, 37.9551813],
              [55.1815324, 37.955821],
              [55.1811413, 37.9558291],
              [55.1806366, 37.9556165],
              [55.1801235, 37.955134],
              [55.1796905, 37.954993],
              [55.1792328, 37.955416],
              [55.1791361, 37.9560114],
              [55.1792865, 37.9563941],
              [55.1794262, 37.9570576],
              [55.1793499, 37.95742],
              [55.1789535, 37.9576274],
              [55.1782553, 37.9576189],
              [55.1757016, 37.9569621],
              [55.17514, 37.956981],
              [55.1747103, 37.9572532],
              [55.1741786, 37.9581082],
              [55.1738509, 37.9581888],
              [55.1734105, 37.9580272],
              [55.1730237, 37.957704],
              [55.172723, 37.9573042],
              [55.172261, 37.9572957],
              [55.1717669, 37.9576104],
              [55.1713557, 37.9581519],
              [55.1710686, 37.9587077],
              [55.1706712, 37.9592095],
              [55.1703704, 37.9596433],
              [55.1701873, 37.9601765],
              [55.1699085, 37.9605363],
              [55.1695862, 37.9606129],
              [55.1690061, 37.9603237],
              [55.1686306, 37.9598825],
              [55.1683508, 37.9593711],
              [55.1683186, 37.9585971],
              [55.1683616, 37.9580357],
              [55.1681897, 37.9575424],
              [55.1676872, 37.9572562],
              [55.1666106, 37.9571171],
              [55.1658479, 37.9571681],
              [55.1649885, 37.9579251],
              [55.1643762, 37.9582654],
              [55.1639519, 37.9581966],
              [55.1639035, 37.9579422],
              [55.1640109, 37.9573212],
              [55.1643654, 37.9567514],
              [55.164887, 37.9562854],
              [55.1649348, 37.9560114],
              [55.1643547, 37.9557052],
              [55.1635383, 37.9554755],
              [55.1626332, 37.955146],
              [55.162174, 37.9551863],
              [55.1618732, 37.955518],
              [55.1616254, 37.95615],
              [55.1613039, 37.9563431],
              [55.1608097, 37.9564367],
              [55.1601661, 37.9563357],
              [55.1596603, 37.956224],
              [55.1594884, 37.9560454],
              [55.1596173, 37.9558327],
              [55.1597785, 37.9555861],
              [55.1597785, 37.9553224],
              [55.1597033, 37.9550502],
              [55.1593938, 37.9545258],
              [55.1589083, 37.9543272],
              [55.1584571, 37.9542081],
              [55.1581279, 37.9540277],
              [55.1580597, 37.9538083],
              [55.1582745, 37.9536042],
              [55.1585431, 37.9533235],
              [55.1584357, 37.9530683],
              [55.1580489, 37.9529832],
              [55.1576192, 37.9530598],
              [55.1572218, 37.9528982],
              [55.1570714, 37.9526345],
              [55.1570334, 37.9520646],
              [55.1570929, 37.9517753],
              [55.1573185, 37.9515542],
              [55.1576837, 37.9513755],
              [55.1578126, 37.9510863],
              [55.1575055, 37.9507791],
              [55.1569747, 37.9503888],
              [55.1565987, 37.9499805],
              [55.1561537, 37.9496543],
              [55.1555782, 37.9496828],
              [55.1549981, 37.949955],
              [55.1547833, 37.9503037],
              [55.154461, 37.9507206],
              [55.1540514, 37.9510265],
              [55.1537735, 37.9511374],
              [55.1533545, 37.9509502],
              [55.1529571, 37.9505164],
              [55.1522588, 37.9504654],
              [55.1516895, 37.9505589],
              [55.151154, 37.9507358],
              [55.1507227, 37.9510523],
              [55.1503897, 37.9513585],
              [55.1496807, 37.9514266],
              [55.1492725, 37.9513841],
              [55.1487353, 37.9507716],
              [55.1484131, 37.9505759],
              [55.1481385, 37.9506011],
              [55.1477363, 37.9509332],
              [55.147414, 37.9514691],
              [55.1473558, 37.952231],
              [55.1470595, 37.9524473],
              [55.1465838, 37.9526315],
              [55.1461787, 37.9530343],
              [55.1457705, 37.9531789],
              [55.1453837, 37.9528641],
              [55.1452011, 37.9521581],
              [55.1453515, 37.9514861],
              [55.1458349, 37.9510863],
              [55.1462848, 37.9505546],
              [55.146716, 37.9500471],
              [55.1467243, 37.9496101],
              [55.1463732, 37.949332],
              [55.1458201, 37.9491064],
              [55.1451524, 37.9489083],
              [55.1444759, 37.9488982],
              [55.1440153, 37.9487825],
              [55.1434969, 37.9484845],
              [55.1432042, 37.948617],
              [55.1430035, 37.9487891],
              [55.142644, 37.9494314],
              [55.1423368, 37.9499767],
              [55.142159, 37.9501133],
              [55.14195, 37.9501531],
              [55.1417828, 37.9501266],
              [55.1415654, 37.9499346],
              [55.1412393, 37.9493519],
              [55.1409801, 37.948948],
              [55.1408296, 37.9486368],
              [55.1408045, 37.9484845],
              [55.140746, 37.9482263],
              [55.1407376, 37.9480144],
              [55.1405655, 37.9478006],
              [55.1402192, 37.94769],
              [55.139659, 37.9477297],
              [55.139266, 37.9480475],
              [55.1388145, 37.9482991],
              [55.1380286, 37.9486037],
              [55.1373513, 37.9488156],
              [55.1371039, 37.9486643],
              [55.1370336, 37.9483256],
              [55.1373346, 37.9480144],
              [55.137368, 37.9475907],
              [55.1370252, 37.9472265],
              [55.1366257, 37.9469891],
              [55.1360135, 37.9468689],
              [55.1354951, 37.9468491],
              [55.1351673, 37.9473298],
              [55.1346188, 37.9476476],
              [55.1340168, 37.9480502],
              [55.1334817, 37.9486487],
              [55.1331534, 37.9491603],
              [55.1329064, 37.9496234],
              [55.1327124, 37.9498299],
              [55.1323512, 37.9498141],
              [55.1319967, 37.9495386],
              [55.1317358, 37.9491255],
              [55.1314234, 37.9488548],
              [55.1310201, 37.948617],
              [55.1306054, 37.948511],
              [55.1301238, 37.9485746],
              [55.1294013, 37.9488553],
              [55.1286589, 37.9491308],
              [55.1282241, 37.9492579],
              [55.1278829, 37.9492844],
              [55.1276555, 37.9491996],
              [55.1275618, 37.9490036],
              [55.1276154, 37.9486752],
              [55.1278829, 37.9482568],
              [55.1279435, 37.9479267],
              [55.1279364, 37.94769],
              [55.1278695, 37.9474569],
              [55.1276421, 37.9473192],
              [55.1274147, 37.9472662],
              [55.1269197, 37.947049],
              [55.1268127, 37.9466359],
              [55.1268796, 37.9461432],
              [55.1268862, 37.9456082],
              [55.1267859, 37.945301],
              [55.1264515, 37.9451421],
              [55.1260551, 37.944995],
              [55.1255551, 37.9446653],
              [55.1248936, 37.9444353],
              [55.1240434, 37.9445594],
              [55.1231805, 37.9446282],
              [55.1226186, 37.9446547],
              [55.1223054, 37.9446113],
              [55.1222039, 37.9443952],
              [55.1223845, 37.9440826],
              [55.1230333, 37.9435317],
              [55.1236421, 37.9429013],
              [55.1238561, 37.9426153],
              [55.123816, 37.9424034],
              [55.123663, 37.9421981],
              [55.1231203, 37.9420061],
              [55.1224782, 37.9419743],
              [55.1215539, 37.9419821],
              [55.1213878, 37.9417571],
              [55.1212875, 37.9414763],
              [55.1213745, 37.94083],
              [55.1217758, 37.9402314],
              [55.1219631, 37.9396751],
              [55.121797, 37.9394217],
              [55.1212674, 37.9392142],
              [55.1205183, 37.9392142],
              [55.1197148, 37.9393551],
              [55.1185584, 37.9395851],
              [55.1181838, 37.9395586],
              [55.1180166, 37.9393361],
              [55.1179898, 37.9388116],
              [55.1180299, 37.9382289],
              [55.1178359, 37.9378368],
              [55.1174385, 37.9376934],
              [55.1168995, 37.9376355],
              [55.1164781, 37.9377203],
              [55.1160901, 37.9381918],
              [55.1156687, 37.9386898],
              [55.1152941, 37.9390765],
              [55.1149329, 37.9391136],
              [55.1146051, 37.9388646],
              [55.1143577, 37.938471],
              [55.1141235, 37.9380488],
              [55.1137155, 37.9375402],
              [55.1129596, 37.9368621],
              [55.1123712, 37.9364849],
              [55.1116954, 37.9364117],
              [55.1109596, 37.9364912],
              [55.1104896, 37.9364214],
              [55.1103576, 37.9362899],
              [55.1102974, 37.9360462],
              [55.1100566, 37.935527],
              [55.1096418, 37.9351138],
              [55.1093141, 37.9347164],
              [55.1093074, 37.9343879],
              [55.1094151, 37.934075],
              [55.1093342, 37.9338369],
              [55.1084713, 37.9337098],
              [55.1076963, 37.9335876],
              [55.1071401, 37.9335085],
              [55.1068258, 37.9333124],
              [55.1067522, 37.9330369],
              [55.106906, 37.9325283],
              [55.1069863, 37.9321098],
              [55.1069183, 37.9318056],
              [55.1066719, 37.9316011],
              [55.1062371, 37.9315482],
              [55.1056418, 37.9316435],
              [55.1049127, 37.931829],
              [55.104197, 37.9318872],
              [55.103615, 37.9318766],
              [55.1033935, 37.9317797],
              [55.1033675, 37.9315217],
              [55.1034344, 37.9312832],
              [55.1036618, 37.9309283],
              [55.1040097, 37.9304461],
              [55.1041501, 37.9300487],
              [55.1039377, 37.9298842],
              [55.1033541, 37.9298368],
              [55.1027521, 37.9299216],
              [55.1019963, 37.9298474],
              [55.1013942, 37.9297256],
              [55.1012689, 37.9296234],
              [55.1013407, 37.9294235],
              [55.1015213, 37.9292328],
              [55.1018825, 37.9289202],
              [55.1020698, 37.9286447],
              [55.1024244, 37.9283215],
              [55.1028658, 37.9282314],
              [55.1032471, 37.9282155],
              [55.1033635, 37.928143],
              [55.1034143, 37.9280301],
              [55.1034277, 37.9278344],
              [55.1033943, 37.9276539],
              [55.1030392, 37.9271673],
              [55.1025629, 37.9269426],
              [55.1020498, 37.9267902],
              [55.1015013, 37.926729],
              [55.101013, 37.926716],
              [55.1001454, 37.9267634],
              [55.099502, 37.9268782],
              [55.0990868, 37.9268985],
              [55.09874, 37.9266849],
              [55.098496, 37.9261457],
              [55.0982648, 37.9255319],
              [55.0979455, 37.9248784],
              [55.0976355, 37.9245281],
              [55.0971132, 37.9245112],
              [55.0962828, 37.9247021],
              [55.095525, 37.9247926],
              [55.0952938, 37.9246434],
              [55.0952039, 37.9244162],
              [55.0952638, 37.9239889],
              [55.0953281, 37.9235888],
              [55.0951654, 37.9230631],
              [55.0950327, 37.9227613],
              [55.0949342, 37.922273],
              [55.0949, 37.9217507],
              [55.0948058, 37.9215099],
              [55.0945232, 37.9213777],
              [55.0941377, 37.9213574],
              [55.0933759, 37.9215065],
              [55.092417, 37.9216557],
              [55.091244, 37.9217541],
              [55.0909315, 37.9217507],
              [55.0907408, 37.9216588],
              [55.0907046, 37.9215065],
              [55.090863, 37.9212352],
              [55.0911241, 37.9207096],
              [55.0914832, 37.9202644],
              [55.0920017, 37.9201669],
              [55.0925668, 37.92015],
              [55.0931447, 37.9200822],
              [55.0934701, 37.9198448],
              [55.0935429, 37.9193632],
              [55.0934755, 37.9187672],
              [55.0931704, 37.9183898],
              [55.0927006, 37.9180974],
              [55.0918904, 37.9178133],
              [55.0912144, 37.9176878],
              [55.0902178, 37.9175189],
              [55.0896534, 37.9170801],
              [55.0893503, 37.9166247],
              [55.0888904, 37.9161776],
              [55.0886695, 37.9158054],
              [55.0886919, 37.9152336],
              [55.0890368, 37.9151674],
              [55.0895489, 37.9153661],
              [55.0898729, 37.9153247],
              [55.0899983, 37.9151177],
              [55.0898311, 37.9146954],
              [55.089319, 37.9143311],
              [55.088023, 37.9143807],
              [55.0865842, 37.9147113],
              [55.0856086, 37.9153827],
              [55.0851592, 37.9159706],
              [55.0845321, 37.9162438],
              [55.0841182, 37.9162312],
              [55.0838841, 37.9160699],
              [55.0838527, 37.9156393],
              [55.0830584, 37.9147451],
              [55.0822508, 37.9138939],
              [55.081752, 37.9138342],
              [55.0813025, 37.9140909],
              [55.0811353, 37.9146291],
              [55.0806754, 37.9149438],
              [55.0800692, 37.9148527],
              [55.0795609, 37.9144156],
              [55.0793167, 37.9140081],
              [55.0794317, 37.9135527],
              [55.0797243, 37.9131635],
              [55.0799856, 37.9124514],
              [55.0798602, 37.9118635],
              [55.0796825, 37.9110933],
              [55.0796595, 37.9104822],
              [55.0798811, 37.910406],
              [55.0802469, 37.9106048],
              [55.0806754, 37.9105965],
              [55.0807486, 37.9103398],
              [55.0805849, 37.9098966],
              [55.0804873, 37.9092716],
              [55.0807591, 37.9083772],
              [55.0809263, 37.9073752],
              [55.0810238, 37.906975],
              [55.0808636, 37.9066382],
              [55.0805291, 37.9065802],
              [55.0801111, 37.9063732],
              [55.0795236, 37.9060044],
              [55.0787523, 37.9058018],
              [55.0779789, 37.9058349],
              [55.0776445, 37.9056527],
              [55.0773695, 37.9052336],
              [55.0771741, 37.9046424],
              [55.077392, 37.9035054],
              [55.0772891, 37.9031185],
              [55.0770383, 37.9029778],
              [55.0766801, 37.9030772],
              [55.0763485, 37.9031517],
              [55.076162, 37.9030301],
              [55.0760663, 37.9028452],
              [55.0759814, 37.902235],
              [55.0757071, 37.9017633],
              [55.0752634, 37.9014163],
              [55.0748496, 37.901423],
              [55.0746891, 37.9016054],
              [55.0745767, 37.9022456],
              [55.0746325, 37.9029707],
              [55.0740897, 37.903187],
              [55.0733459, 37.9033481],
              [55.0727626, 37.9033015],
              [55.0723506, 37.903081],
              [55.0723773, 37.9029283],
              [55.0724897, 37.9027884],
              [55.0730229, 37.9027926],
              [55.0732068, 37.9027163],
              [55.0733673, 37.902428],
              [55.0731907, 37.9020082],
              [55.0728001, 37.9016562],
              [55.072388, 37.9017877],
              [55.0720241, 37.9018301],
              [55.0714583, 37.9012913],
              [55.0708312, 37.9009468],
              [55.0701642, 37.900808],
              [55.0694264, 37.9003571],
              [55.0689488, 37.9001999],
              [55.0685318, 37.9002842],
              [55.0682809, 37.9004101],
              [55.0678545, 37.9004565],
              [55.0669515, 37.900324],
              [55.0659481, 37.9000788],
              [55.0653628, 37.8999728],
              [55.0647525, 37.9000258],
              [55.063816, 37.9000855],
              [55.062729, 37.8999397],
              [55.0620263, 37.899717],
              [55.0617089, 37.8994892],
              [55.0619347, 37.8991446],
              [55.0623214, 37.89898],
              [55.0626454, 37.8986079],
              [55.0629297, 37.8982965],
              [55.0630969, 37.8979454],
              [55.06307, 37.8976409],
              [55.0622942, 37.8976008],
              [55.0615668, 37.8974948],
              [55.0610484, 37.8973358],
              [55.060626, 37.8968694],
              [55.0600618, 37.8963684],
              [55.0599865, 37.8960437],
              [55.059744, 37.8957058],
              [55.0595099, 37.8953745],
              [55.0594096, 37.8950498],
              [55.0591813, 37.8948176],
              [55.0583393, 37.8947848],
              [55.0579213, 37.8948974],
              [55.0575985, 37.8948839],
              [55.0572858, 37.8946788],
              [55.0569513, 37.8941421],
              [55.0567639, 37.893614],
              [55.0571219, 37.8925589],
              [55.0570926, 37.8920747],
              [55.0568773, 37.8918242],
              [55.0565829, 37.8915824],
              [55.0565937, 37.8913831],
              [55.0568291, 37.8908021],
              [55.0569896, 37.8902041],
              [55.0574659, 37.8897292],
              [55.0574713, 37.8893517],
              [55.0570378, 37.8890676],
              [55.0565669, 37.8889827],
              [55.0555769, 37.888864],
              [55.0545816, 37.8889318],
              [55.0543568, 37.8889191],
              [55.054213, 37.888798],
              [55.0542552, 37.8886095],
              [55.0543836, 37.8883339],
              [55.0542766, 37.8879903],
              [55.0539341, 37.8877401],
              [55.0537147, 37.8874135],
              [55.0536665, 37.8869767],
              [55.0537735, 37.8868961],
              [55.0539394, 37.8868367],
              [55.0543675, 37.8870742],
              [55.0547363, 37.8872531],
              [55.0554699, 37.8869682],
              [55.0565722, 37.8864211],
              [55.0567007, 37.8863108],
              [55.0567151, 37.8861304],
              [55.05631, 37.8858401],
              [55.0555769, 37.8855686],
              [55.0548482, 37.8853264],
              [55.0542016, 37.8850809],
              [55.0534601, 37.8842933],
              [55.0531344, 37.8838642],
              [55.0527996, 37.8838],
              [55.0523555, 37.8840333],
              [55.05212, 37.8844659],
              [55.0518524, 37.884555],
              [55.0514886, 37.8844108],
              [55.0511621, 37.8842199],
              [55.0510872, 37.8838764],
              [55.0512531, 37.883554],
              [55.051617, 37.883414],
              [55.0518953, 37.8832189],
              [55.0519086, 37.8828788],
              [55.0513548, 37.882587],
              [55.0506484, 37.8823749],
              [55.0500544, 37.881955],
              [55.049423, 37.8817514],
              [55.0489574, 37.8817048],
              [55.0483708, 37.8816703],
              [55.04715, 37.8810871],
              [55.046155, 37.8808154],
              [55.0449556, 37.8806322],
              [55.0444744, 37.8807226],
              [55.0442821, 37.8809943],
              [55.0439058, 37.8813124],
              [55.0435163, 37.8814827],
              [55.0433874, 37.8813787],
              [55.0432787, 37.8810208],
              [55.0429108, 37.8806298],
              [55.0421918, 37.8803846],
              [55.0414811, 37.8800267],
              [55.0410295, 37.8796158],
              [55.0406115, 37.8789729],
              [55.0398673, 37.8781445],
              [55.0391993, 37.877644],
              [55.0387469, 37.87721],
              [55.0384961, 37.8769648],
              [55.0383874, 37.8766268],
              [55.038588, 37.8762291],
              [55.0386884, 37.8759706],
              [55.0385964, 37.875679],
              [55.0382369, 37.875447],
              [55.0380027, 37.8750891],
              [55.0378606, 37.8747246],
              [55.0376766, 37.8738961],
              [55.0377827, 37.873565],
              [55.0379693, 37.8734852],
              [55.0387803, 37.8736045],
              [55.039675, 37.8736509],
              [55.040461, 37.8736045],
              [55.040634, 37.8734641],
              [55.0404944, 37.8731471],
              [55.040068, 37.8728422],
              [55.0391733, 37.8727296],
              [55.0385379, 37.8722921],
              [55.0378857, 37.8721264],
              [55.0372001, 37.8718281],
              [55.0368907, 37.8716691],
              [55.036586, 37.8715898],
              [55.0362134, 37.8718878],
              [55.0360462, 37.8723915],
              [55.0359542, 37.8728422],
              [55.0357117, 37.8730875],
              [55.035367, 37.8731064],
              [55.0351181, 37.8730079],
              [55.0348923, 37.8726434],
              [55.0344659, 37.8720203],
              [55.0339931, 37.8716792],
              [55.0335115, 37.8712974],
              [55.0330084, 37.8709623],
              [55.0325964, 37.8708265],
              [55.0322539, 37.8706356],
              [55.0321132, 37.8704094],
              [55.0322272, 37.870186],
              [55.0324305, 37.8700205],
              [55.032789, 37.8699993],
              [55.0331636, 37.8701436],
              [55.0335436, 37.8704363],
              [55.0339021, 37.870555],
              [55.0341429, 37.8705508],
              [55.0345603, 37.870415],
              [55.0348974, 37.8702157],
              [55.0352934, 37.8701139],
              [55.0355736, 37.8699812],
              [55.0357269, 37.8696981],
              [55.035775, 37.8692612],
              [55.0355824, 37.8688242],
              [55.0354326, 37.8685485],
              [55.0355342, 37.8681752],
              [55.0358585, 37.8676857],
              [55.0362727, 37.8672885],
              [55.0366045, 37.8672419],
              [55.0370486, 37.867314],
              [55.0374232, 37.8671867],
              [55.0376105, 37.8668134],
              [55.0376105, 37.8664274],
              [55.0375409, 37.8660328],
              [55.0376694, 37.8658546],
              [55.0380505, 37.8656556],
              [55.0385844, 37.8654092],
              [55.0392212, 37.8648577],
              [55.0395316, 37.8642383],
              [55.039635, 37.8635269],
              [55.0393711, 37.8626176],
              [55.0394085, 37.8620746],
              [55.0394139, 37.861243],
              [55.0392551, 37.8606766],
              [55.0389965, 37.8603775],
              [55.038547, 37.8602715],
              [55.0379744, 37.8602927],
              [55.0374714, 37.8604072],
              [55.037161, 37.8604327],
              [55.0368679, 37.8603289],
              [55.0361229, 37.8598684],
              [55.0358071, 37.8597878],
              [55.0356252, 37.8596775],
              [55.035577, 37.8595587],
              [55.0356627, 37.8593762],
              [55.0358125, 37.8589859],
              [55.0357643, 37.8585531],
              [55.0351277, 37.8583993],
              [55.033763, 37.8583792],
              [55.033383, 37.8585065],
              [55.0326767, 37.8587356],
              [55.0318407, 37.8587038],
              [55.0310285, 37.8585404],
              [55.0306111, 37.8583113],
              [55.0305736, 37.8580143],
              [55.0306111, 37.8576706],
              [55.0305036, 37.8572332],
              [55.0304719, 37.8570172],
              [55.0306539, 37.8568093],
              [55.0312104, 37.856436],
              [55.0324248, 37.8559158],
              [55.0328051, 37.8557698],
              [55.0330673, 37.8555661],
              [55.0330566, 37.8552522],
              [55.0327088, 37.8549382],
              [55.032163, 37.8545948],
              [55.0310017, 37.8540811],
              [55.0298191, 37.8536228],
              [55.0292198, 37.8534149],
              [55.0288452, 37.853084],
              [55.0285318, 37.8528966],
              [55.0282191, 37.852927],
              [55.0274806, 37.8532579],
              [55.0271453, 37.8532903],
              [55.0270632, 37.8531264],
              [55.0270846, 37.8528464],
              [55.0272237, 37.8525239],
              [55.0274699, 37.8521505],
              [55.0275448, 37.851828],
              [55.0274592, 37.8515564],
              [55.0272237, 37.8514164],
              [55.0268893, 37.8513031],
              [55.0263836, 37.8512424],
              [55.0258164, 37.8513485],
              [55.025019, 37.8512976],
              [55.0237182, 37.8512961],
              [55.0227768, 37.8511958],
              [55.0221775, 37.8510345],
              [55.0216638, 37.8507672],
              [55.0215245, 37.8504903],
              [55.0216959, 37.8503132],
              [55.0220598, 37.8503259],
              [55.0223969, 37.8504405],
              [55.0226859, 37.8503938],
              [55.0227875, 37.8502198],
              [55.0226591, 37.849927],
              [55.0222524, 37.8495876],
              [55.0220812, 37.8491462],
              [55.0217922, 37.8490147],
              [55.0212838, 37.8490868],
              [55.0207113, 37.8490232],
              [55.0201012, 37.8488789],
              [55.0197373, 37.8485819],
              [55.0198016, 37.8482976],
              [55.0201547, 37.848043],
              [55.0209146, 37.8477205],
              [55.021225, 37.8474913],
              [55.0212143, 37.8472919],
              [55.0204047, 37.8464907],
              [55.0189454, 37.8453823],
              [55.018528, 37.8449579],
              [55.0184851, 37.8447415],
              [55.0188276, 37.8445888],
              [55.0192878, 37.8446524],
              [55.0196848, 37.8445895],
              [55.0201333, 37.8443469],
              [55.0207594, 37.8440413],
              [55.021439, 37.8439395],
              [55.0220758, 37.8437697],
              [55.0231012, 37.8433946],
              [55.0232906, 37.8432138],
              [55.0233227, 37.8429634],
              [55.0229481, 37.842904],
              [55.0223828, 37.8428993],
              [55.0217922, 37.8429847],
              [55.0213053, 37.8428658],
              [55.0210484, 37.8430441],
              [55.0206925, 37.84334],
              [55.0204223, 37.8435236],
              [55.0201494, 37.8434048],
              [55.019946, 37.8431162],
              [55.0198658, 37.8426112],
              [55.0197656, 37.8422427],
              [55.0193895, 37.8421444],
              [55.0187688, 37.8421741],
              [55.017736, 37.8424372],
              [55.0170243, 37.8426452],
              [55.0165463, 37.8427638],
              [55.0160343, 37.8427979],
              [55.0153012, 37.8427852],
              [55.0147286, 37.8429931],
              [55.0141346, 37.8433241],
              [55.0136637, 37.8434048],
              [55.0129627, 37.8433878],
              [55.01241, 37.8433425],
              [55.0120855, 37.8429135],
              [55.0118282, 37.8425815],
              [55.0111014, 37.8422814],
              [55.0106456, 37.8422123],
              [55.0100944, 37.8422165],
              [55.0093366, 37.8423571],
              [55.0090402, 37.8423778],
              [55.0087566, 37.8422759],
              [55.0085532, 37.8420638],
              [55.0085907, 37.8417625],
              [55.0085158, 37.8413084],
              [55.0081893, 37.8406251],
              [55.0077462, 37.8400716],
              [55.0074627, 37.840041],
              [55.0072537, 37.8400617],
              [55.0063913, 37.8403145],
              [55.0049683, 37.8406016],
              [55.0041167, 37.8409275],
              [55.0037547, 37.8409138],
              [55.0035222, 37.8407882],
              [55.0032544, 37.8402516],
              [55.0025097, 37.839648],
              [55.0023333, 37.8394158],
              [55.0023463, 37.8388638],
              [55.0021827, 37.8380206],
              [55.0019244, 37.8374687],
              [55.0014867, 37.837252],
              [55.0007158, 37.8370817],
              [54.9997359, 37.8370972],
              [54.9986645, 37.8371282],
              [54.9984097, 37.8370043],
              [54.99834, 37.8368061],
              [54.9984685, 37.8365451],
              [54.9988083, 37.8362304],
              [54.9988474, 37.8359105],
              [54.9986057, 37.8355597],
              [54.9982203, 37.8354049],
              [54.9974494, 37.8354359],
              [54.9970019, 37.8353374],
              [54.9967635, 37.8348219],
              [54.9962287, 37.8345057],
              [54.9956268, 37.8341563],
              [54.9953426, 37.8339803],
              [54.9953472, 37.8337687],
              [54.995735, 37.8335678],
              [54.9959077, 37.8334495],
              [54.9961235, 37.833117],
              [54.9959207, 37.8326703],
              [54.9960122, 37.8322782],
              [54.9961951, 37.8321079],
              [54.9968353, 37.8319222],
              [54.9978828, 37.8314341],
              [54.9986341, 37.831011],
              [54.99932, 37.8304795],
              [54.9997904, 37.8297984],
              [55.0000844, 37.829009],
              [54.9999341, 37.8280595],
              [54.9995683, 37.8275384],
              [54.9990587, 37.8270636],
              [54.9982291, 37.8266766],
              [54.9975562, 37.8265476],
              [54.996831, 37.8266973],
              [54.9961712, 37.8270894],
              [54.996217, 37.8273836],
              [54.9967722, 37.8275435],
              [54.9973406, 37.8277138],
              [54.997824, 37.8281421],
              [54.9980788, 37.8285342],
              [54.9978436, 37.8290244],
              [54.9978044, 37.8296127],
              [54.997615, 37.8297675],
              [54.9971838, 37.8296127],
              [54.99672, 37.8295972],
              [54.9962823, 37.8295817],
              [54.9959752, 37.8291534],
              [54.9955791, 37.8291445],
              [54.9942898, 37.8294372],
              [54.9935712, 37.8294682],
              [54.993674, 37.8290206],
              [54.9940601, 37.8284488],
              [54.9941084, 37.8280447],
              [54.993954, 37.8275491],
              [54.9937609, 37.8273661],
              [54.9934134, 37.8272212],
              [54.9929018, 37.8272441],
              [54.9922164, 37.8276177],
              [54.9916403, 37.8277736],
              [54.9887575, 37.8278566],
              [54.9874478, 37.8276253],
              [54.9863377, 37.8273661],
              [54.9862605, 37.8270306],
              [54.9867142, 37.8267027],
              [54.9866852, 37.8259631],
              [54.9862036, 37.8252393],
              [54.9831242, 37.8227038],
              [54.9809667, 37.8215907],
              [54.980343, 37.8212577],
              [54.980302, 37.8211606],
              [54.9803225, 37.8210528],
              [54.9807594, 37.8209665],
              [54.981087, 37.8208479],
              [54.9812508, 37.8206969],
              [54.9811553, 37.8204112],
              [54.9810051, 37.820244],
              [54.9806775, 37.8201092],
              [54.9803839, 37.8200769],
              [54.9792167, 37.8204651],
              [54.9790256, 37.8206592],
              [54.9789369, 37.8213763],
              [54.9787932, 37.821537],
              [54.9781384, 37.8214764],
              [54.976507, 37.821667],
              [54.9763236, 37.8216517],
              [54.9761595, 37.8214535],
              [54.975832, 37.8208411],
              [54.9747791, 37.8201038],
              [54.9741227, 37.819448],
              [54.973698, 37.8189295],
              [54.9737366, 37.8186016],
              [54.9740938, 37.8185559],
              [54.9746826, 37.8186474],
              [54.9752811, 37.8182966],
              [54.9757813, 37.8180578],
              [54.9758217, 37.8178238],
              [54.9755224, 37.817473],
              [54.9749625, 37.8171299],
              [54.9741034, 37.8166952],
              [54.972974, 37.8164817],
              [54.9725879, 37.8166113],
              [54.9720792, 37.8167805],
              [54.9695114, 37.8162847],
              [54.966279, 37.8164577],
              [54.9659076, 37.8163594],
              [54.9651429, 37.8154672],
              [54.9651312, 37.8150264],
              [54.9619456, 37.813076],
              [54.9579635, 37.8118177],
              [54.9559725, 37.8098672],
              [54.9550965, 37.8069728],
              [54.9560521, 37.8050851],
              [54.9581228, 37.8057773],
              [54.9591581, 37.8050222],
              [54.9582821, 37.8032603],
              [54.9551761, 37.8032603],
              [54.9539815, 37.8009949],
              [54.9546186, 37.7993588],
              [54.952309, 37.7979743],
              [54.950314, 37.7971132],
              [54.9500697, 37.7969698],
              [54.9498279, 37.7968182],
              [54.9495352, 37.7966941],
              [54.9493213, 37.7966516],
              [54.9489539, 37.7965894],
              [54.948547, 37.7965012],
              [54.9481245, 37.7964711],
              [54.9477741, 37.7964878],
              [54.947459, 37.7964889],
              [54.9472117, 37.796442],
              [54.9469121, 37.7963516],
              [54.9466493, 37.7962623],
              [54.9465108, 37.7962489],
              [54.9463257, 37.7962545],
              [54.9461208, 37.7961997],
              [54.9459244, 37.7960993],
              [54.9458001, 37.7959753],
              [54.9457393, 37.7958637],
              [54.9456277, 37.7957185],
              [54.9455783, 37.795608],
              [54.9455571, 37.795503],
              [54.945574, 37.7953701],
              [54.9455641, 37.7952205],
              [54.9454906, 37.7950798],
              [54.9453847, 37.7949358],
              [54.9451628, 37.7947817],
              [54.9449904, 37.7946332],
              [54.9448562, 37.794459],
              [54.9447474, 37.7942759],
              [54.9446556, 37.7940615],
              [54.9445906, 37.7939231],
              [54.9444902, 37.7938281],
              [54.9443645, 37.7937734],
              [54.9442274, 37.7937533],
              [54.9440677, 37.7937556],
              [54.943918, 37.793779],
              [54.9437357, 37.7938382],
              [54.9435548, 37.7939365],
              [54.9432524, 37.7941252],
              [54.9430645, 37.794277],
              [54.9428441, 37.7944769],
              [54.9426971, 37.794583],
              [54.9425883, 37.7946276],
              [54.9423947, 37.7946689],
              [54.9422266, 37.7946656],
              [54.9419511, 37.7945975],
              [54.9416444, 37.7945573],
              [54.9414353, 37.7945662],
              [54.9411937, 37.7946198],
              [54.9409549, 37.7946712],
              [54.9408235, 37.7946857],
              [54.9407118, 37.79467],
              [54.9406016, 37.7946254],
              [54.9405493, 37.7945696],
              [54.9405282, 37.7945137],
              [54.940531, 37.7944378],
              [54.9405621, 37.7943596],
              [54.9406596, 37.7942335],
              [54.9408221, 37.7940805],
              [54.9410821, 37.7938527],
              [54.9412445, 37.7936808],
              [54.9413576, 37.7935222],
              [54.9413816, 37.793434],
              [54.9413576, 37.7933391],
              [54.9412926, 37.7932609],
              [54.9411442, 37.7931794],
              [54.9409563, 37.7930867],
              [54.9408291, 37.7929806],
              [54.9408037, 37.7928869],
              [54.9408023, 37.7926189],
              [54.9406746, 37.7922217],
              [54.9405474, 37.7919481],
              [54.9403878, 37.7917884],
              [54.9401673, 37.7916377],
              [54.9398946, 37.7915048],
              [54.9396332, 37.7914143],
              [54.9392305, 37.7912859],
              [54.9388857, 37.7911653],
              [54.9385947, 37.7910481],
              [54.9381708, 37.7908147],
              [54.9380031, 37.7906882],
              [54.9379302, 37.7905832],
              [54.9379112, 37.7905145],
              [54.9379142, 37.7904395],
              [54.9379662, 37.7904024],
              [54.9380881, 37.7903771],
              [54.9383179, 37.7903605],
              [54.9385487, 37.7903882],
              [54.9389112, 37.7904507],
              [54.9392447, 37.7904607],
              [54.9396969, 37.7904697],
              [54.9402183, 37.7905266],
              [54.9408287, 37.790597],
              [54.9413034, 37.7906461],
              [54.9417923, 37.7906483],
              [54.9421089, 37.7906115],
              [54.9422134, 37.7905367],
              [54.9422756, 37.7904429],
              [54.9422714, 37.7903044],
              [54.942229, 37.7901615],
              [54.9420933, 37.7899839],
              [54.9418814, 37.7897863],
              [54.9416087, 37.7895976],
              [54.941432, 37.7895071],
              [54.941141, 37.7894256],
              [54.9409813, 37.7893564],
              [54.9406068, 37.7892905],
              [54.9402804, 37.7892391],
              [54.9400105, 37.7891799],
              [54.939646, 37.7890806],
              [54.9393521, 37.7889868],
              [54.9391359, 37.788884],
              [54.9389653, 37.7887801],
              [54.9388724, 37.7887311],
              [54.9387965, 37.7887177],
              [54.9386896, 37.7887232],
              [54.9385697, 37.7887485],
              [54.9383668, 37.7888243],
              [54.9380951, 37.7889443],
              [54.9379082, 37.7890517],
              [54.9377194, 37.7891077],
              [54.9373944, 37.789177],
              [54.9369352, 37.7892585],
              [54.9366497, 37.7893411],
              [54.9363954, 37.789464],
              [54.9361481, 37.7896091],
              [54.935987, 37.7897409],
              [54.9358132, 37.789924],
              [54.9357087, 37.7901295],
              [54.9356677, 37.7902746],
              [54.9356069, 37.7904745],
              [54.9355342, 37.7906627],
              [54.9354748, 37.7907107],
              [54.9354197, 37.790728],
              [54.9352495, 37.7907319],
              [54.9350986, 37.790709],
              [54.9348838, 37.7906277],
              [54.934621, 37.7905329],
              [54.9343402, 37.79042],
              [54.9342113, 37.790364],
              [54.9341764, 37.7903158],
              [54.9341664, 37.7902589],
              [54.9341794, 37.7901958],
              [54.9342463, 37.790105],
              [54.9343582, 37.7900315],
              [54.9344791, 37.7898918],
              [54.934553, 37.7898499],
              [54.9346604, 37.7896926],
              [54.934737, 37.7895438],
              [54.9347959, 37.789374],
              [54.9348868, 37.7893045],
              [54.9351047, 37.7891798],
              [54.9352046, 37.7890558],
              [54.9352504, 37.7889497],
              [54.9352544, 37.7888431],
              [54.9352044, 37.7887515],
              [54.9350925, 37.7886773],
              [54.9349337, 37.7886212],
              [54.934579, 37.7885683],
              [54.9342318, 37.7885542],
              [54.9339124, 37.7885219],
              [54.9335597, 37.7884209],
              [54.9333738, 37.788334],
              [54.9332679, 37.7882377],
              [54.933136, 37.7880964],
              [54.9329472, 37.7878311],
              [54.9327554, 37.7875231],
              [54.9325655, 37.7873841],
              [54.9323287, 37.7872175],
              [54.9321589, 37.7870667],
              [54.932054, 37.786923],
              [54.931957, 37.786769],
              [54.9318601, 37.7865929],
              [54.9318012, 37.7863718],
              [54.9317033, 37.7861855],
              [54.9316353, 37.7859478],
              [54.9315854, 37.7856454],
              [54.9315284, 37.7854582],
              [54.9315074, 37.7853327],
              [54.9315264, 37.7851803],
              [54.9315514, 37.7850445],
              [54.9315454, 37.7848273],
              [54.9315074, 37.7846449],
              [54.9314485, 37.7845644],
              [54.9313406, 37.7845059],
              [54.9312007, 37.7844901],
              [54.9310598, 37.7845138],
              [54.930804, 37.7846086],
              [54.9305752, 37.7847073],
              [54.9304094, 37.7847405],
              [54.9302295, 37.7847468],
              [54.9299867, 37.7847499],
              [54.9297429, 37.7847807],
              [54.9295401, 37.7848321],
              [54.9294032, 37.7849047],
              [54.9293143, 37.7850018],
              [54.9292533, 37.785125],
              [54.9291724, 37.7852948],
              [54.9290465, 37.7854172],
              [54.9288397, 37.7855546],
              [54.9287068, 37.7855948],
              [54.9285679, 37.7856098],
              [54.928471, 37.7855925],
              [54.9284219, 37.7855448],
              [54.9283821, 37.785451],
              [54.9283801, 37.7853018],
              [54.928431, 37.7851628],
              [54.928509, 37.7850807],
              [54.9285649, 37.7849346],
              [54.9285679, 37.7848604],
              [54.9285269, 37.784704],
              [54.9285399, 37.784479],
              [54.928501, 37.7841758],
              [54.928453, 37.7840068],
              [54.9283891, 37.7839483],
              [54.9282981, 37.7839112],
              [54.9282132, 37.7839231],
              [54.9280883, 37.7839973],
              [54.9279434, 37.7840802],
              [54.9277936, 37.7841876],
              [54.9274908, 37.7843487],
              [54.927341, 37.7845082],
              [54.927293, 37.7846472],
              [54.9272251, 37.7847996],
              [54.927241, 37.7849093],
              [54.927269, 37.7850783],
              [54.9272341, 37.7853729],
              [54.9271301, 37.7857487],
              [54.9270362, 37.7859667],
              [54.9268704, 37.7862904],
              [54.9266565, 37.7866315],
              [54.9265936, 37.7867602],
              [54.9265646, 37.7869071],
              [54.9265766, 37.7871085],
              [54.9265386, 37.7872601],
              [54.9264557, 37.7873785],
              [54.9263648, 37.787448],
              [54.9262589, 37.7874756],
              [54.926144, 37.7874741],
              [54.9260181, 37.7874211],
              [54.9257951, 37.7873162],
              [54.9256349, 37.7872225],
              [54.925421, 37.7870314],
              [54.9253061, 37.7869682],
              [54.9249325, 37.7868648],
              [54.9246797, 37.7867779],
              [54.9244828, 37.7867574],
              [54.924313, 37.7867708],
              [54.9240932, 37.7868229],
              [54.9237864, 37.7868672],
              [54.9234277, 37.7868901],
              [54.923077, 37.7869706],
              [54.9227193, 37.787059],
              [54.9225365, 37.7870764],
              [54.9224556, 37.7870709],
              [54.9223676, 37.7870306],
              [54.9221468, 37.7869106],
              [54.9217442, 37.7867353],
              [54.9215124, 37.7866398],
              [54.9213685, 37.7866184],
              [54.9212766, 37.7865742],
              [54.9211926, 37.7865071],
              [54.9209269, 37.7864037],
              [54.9205872, 37.786271],
              [54.9202594, 37.7861281],
              [54.9199217, 37.7859401],
              [54.9197239, 37.7858399],
              [54.9194911, 37.7857459],
              [54.9192323, 37.7856203],
              [54.9189406, 37.7854324],
              [54.9186658, 37.7852761],
              [54.9183061, 37.7850873],
              [54.9180603, 37.7849918],
              [54.9178075, 37.7849239],
              [54.9176097, 37.7848994],
              [54.9171611, 37.7848773],
              [54.9167514, 37.7848623],
              [54.9164657, 37.7848228],
              [54.9162359, 37.7847833],
              [54.9159711, 37.7846957],
              [54.9158642, 37.784627],
              [54.9158332, 37.784578],
              [54.9158192, 37.7845093],
              [54.9158322, 37.7844335],
              [54.9159091, 37.7843553],
              [54.916092, 37.7842108],
              [54.9162926, 37.7840172],
              [54.9163615, 37.7838956],
              [54.9164375, 37.7836674],
              [54.9164654, 37.7834803],
              [54.9164455, 37.7832813],
              [54.9163475, 37.7831115],
              [54.9162077, 37.7829725],
              [54.9160938, 37.7829086],
              [54.9159049, 37.7828628],
              [54.9155782, 37.7828075],
              [54.9152735, 37.7827885],
              [54.9149308, 37.7827751],
              [54.914629, 37.7827704],
              [54.9143862, 37.7827798],
              [54.9141874, 37.7828209],
              [54.9138657, 37.7829267],
              [54.9136239, 37.7829694],
              [54.9133031, 37.7830444],
              [54.9130354, 37.7831075],
              [54.9128026, 37.7831241],
              [54.9125648, 37.7831162],
              [54.91232, 37.7830681],
              [54.9121561, 37.7830057],
              [54.9120952, 37.7829386],
              [54.9120552, 37.7828485],
              [54.9120322, 37.7826677],
              [54.9119703, 37.782415],
              [54.9118893, 37.7822587],
              [54.9117675, 37.7821426],
              [54.9115157, 37.7819854],
              [54.9112269, 37.7818757],
              [54.9110111, 37.7817383],
              [54.9109551, 37.7816648],
              [54.9109511, 37.7815708],
              [54.9109691, 37.7814785],
              [54.911069, 37.7813766],
              [54.9112119, 37.781281],
              [54.9114427, 37.7811665],
              [54.9116376, 37.7811128],
              [54.9118024, 37.7810978],
              [54.9121251, 37.7810228],
              [54.9124828, 37.7809288],
              [54.9125558, 37.7808941],
              [54.9125848, 37.7808601],
              [54.9125808, 37.7807472],
              [54.9125318, 37.7804527],
              [54.9124069, 37.7802229],
              [54.912345, 37.7799773],
              [54.9121921, 37.7797214],
              [54.9120302, 37.77949],
              [54.9118604, 37.7792318],
              [54.9116286, 37.7789191],
              [54.9114287, 37.7786569],
              [54.9112119, 37.7784294],
              [54.9110341, 37.7782154],
              [54.9108542, 37.7780385],
              [54.9106884, 37.7779311],
              [54.9105485, 37.7778885],
              [54.9104166, 37.7778853],
              [54.9102378, 37.7779169],
              [54.9101448, 37.7779777],
              [54.909954, 37.7781759],
              [54.9096952, 37.7784263],
              [54.9096003, 37.7785321],
              [54.9095443, 37.7786411],
              [54.9094914, 37.7788219],
              [54.9094564, 37.7791046],
              [54.9094185, 37.779291],
              [54.9093555, 37.779411],
              [54.9092936, 37.7794655],
              [54.9092306, 37.7794884],
              [54.9091227, 37.7794813],
              [54.9089988, 37.779445],
              [54.908807, 37.7793487],
              [54.9086531, 37.7793155],
              [54.9084563, 37.779325],
              [54.9082864, 37.7793771],
              [54.9080766, 37.7795003],
              [54.9079187, 37.7795619],
              [54.9077888, 37.7795816],
              [54.907635, 37.7795761],
              [54.9075361, 37.7795532],
              [54.9074511, 37.7794884],
              [54.9074062, 37.7794197],
              [54.9073922, 37.7793487],
              [54.9073982, 37.7792397],
              [54.9074781, 37.7789578],
              [54.907594, 37.7786616],
              [54.9076789, 37.7784247],
              [54.9077059, 37.778157],
              [54.9076689, 37.778003],
              [54.907602, 37.7779406],
              [54.9074671, 37.7778798],
              [54.9073033, 37.7778545],
              [54.9071214, 37.7778656],
              [54.9069665, 37.7779051],
              [54.9067118, 37.7780038],
              [54.906472, 37.7780701],
              [54.9061582, 37.7781214],
              [54.9060114, 37.7781214],
              [54.9059234, 37.7781017],
              [54.9057776, 37.7780227],
              [54.9054788, 37.7778506],
              [54.905294, 37.7777021],
              [54.9051051, 37.7775299],
              [54.9048114, 37.7772938],
              [54.9046165, 37.7771856],
              [54.9044167, 37.7771193],
              [54.904092, 37.7769882],
              [54.9037793, 37.7768547],
              [54.9036064, 37.7767473],
              [54.9035085, 37.7766494],
              [54.9033866, 37.7764678],
              [54.9032477, 37.7762545],
              [54.9031278, 37.7760587],
              [54.902886, 37.7757815],
              [54.9027863, 37.7756242],
              [54.9027263, 37.7754702],
              [54.9026948, 37.7752765],
              [54.9026736, 37.7750554],
              [54.9026793, 37.7747907],
              [54.9026454, 37.7746097],
              [54.9024899, 37.7743551],
              [54.9022737, 37.7740669],
              [54.9020533, 37.773867],
              [54.9018357, 37.7737296],
              [54.9016435, 37.773657],
              [54.9013383, 37.7736291],
              [54.9010727, 37.7735833],
              [54.9006516, 37.7735029],
              [54.9003436, 37.773418],
              [54.9002178, 37.7733588],
              [54.9001556, 37.7732829],
              [54.9000991, 37.773189],
              [54.8998208, 37.7729824],
              [54.8995947, 37.7728808],
              [54.8994124, 37.7728361],
              [54.8991213, 37.7728439],
              [54.89872, 37.7728651],
              [54.8984068, 37.7728911],
              [54.8983208, 37.7728817],
              [54.8982039, 37.7728367],
              [54.898098, 37.7727758],
              [54.8979765, 37.7726373],
              [54.8977207, 37.7723693],
              [54.8975102, 37.7721794],
              [54.8972333, 37.772013],
              [54.8969156, 37.7718226],
              [54.8968696, 37.771776],
              [54.8968576, 37.7717231],
              [54.8968846, 37.7715762],
              [54.8969506, 37.7713859],
              [54.8969526, 37.7712271],
              [54.8968876, 37.7710873],
              [54.8967857, 37.7710004],
              [54.8966289, 37.7709257],
              [54.896493, 37.7708341],
              [54.8962994, 37.7706567],
              [54.8961596, 37.7705372],
              [54.8960263, 37.770474],
              [54.8959114, 37.7704391],
              [54.8957785, 37.7704195],
              [54.8956236, 37.770414],
              [54.8954788, 37.7704456],
              [54.895232, 37.7705538],
              [54.8947714, 37.7707268],
              [54.8944846, 37.7708768],
              [54.8942418, 37.7710585],
              [54.8939331, 37.7712291],
              [54.8934905, 37.7714858],
              [54.8932597, 37.7715948],
              [54.8931717, 37.7716129],
              [54.8931058, 37.7716042],
              [54.8930508, 37.771575],
              [54.8930099, 37.771526],
              [54.8929919, 37.7714565],
              [54.8929869, 37.771233],
              [54.8930119, 37.7709558],
              [54.8930628, 37.7707536],
              [54.8931398, 37.7706423],
              [54.8932547, 37.7704638],
              [54.8934354, 37.7703108],
              [54.8937462, 37.7700975],
              [54.8938593, 37.7699813],
              [54.893985, 37.769806],
              [54.894019, 37.7696719],
              [54.8940246, 37.7695055],
              [54.8939836, 37.7693313],
              [54.8939441, 37.7691559],
              [54.8938664, 37.7689481],
              [54.8937166, 37.7687839],
              [54.8936346, 37.7686499],
              [54.8935908, 37.768527],
              [54.893588, 37.768412],
              [54.8936261, 37.7683237],
              [54.8937505, 37.7681718],
              [54.8938706, 37.7679663],
              [54.8939709, 37.7676457],
              [54.8940444, 37.7673375],
              [54.8940345, 37.7672101],
              [54.8939921, 37.7671464],
              [54.8939285, 37.767066],
              [54.8938282, 37.7669029],
              [54.8937886, 37.7667857],
              [54.8937773, 37.7665187],
              [54.8937491, 37.7662439],
              [54.8936714, 37.7659189],
              [54.8935654, 37.7655469],
              [54.8934396, 37.7652688],
              [54.8932913, 37.7650018],
              [54.893174, 37.7648733],
              [54.8930878, 37.7648275],
              [54.8929557, 37.7648119],
              [54.8928603, 37.76477],
              [54.8927381, 37.7647166],
              [54.8926492, 37.764644],
              [54.8925073, 37.7646218],
              [54.8924263, 37.7645476],
              [54.8922328, 37.7643186],
              [54.8919699, 37.7640717],
              [54.8917396, 37.7639042],
              [54.8914683, 37.763683],
              [54.8911009, 37.7635043],
              [54.8909243, 37.763444],
              [54.8903959, 37.7633747],
              [54.8901797, 37.763368],
              [54.8899677, 37.763378],
              [54.8897628, 37.7634116],
              [54.8895565, 37.7635076],
              [54.8892118, 37.7637422],
              [54.8890012, 37.7638796],
              [54.8888373, 37.7640818],
              [54.8887002, 37.7642371],
              [54.8886536, 37.7643432],
              [54.888648, 37.7644404],
              [54.888672, 37.7645275],
              [54.8887313, 37.7645912],
              [54.8888203, 37.7646157],
              [54.8888896, 37.7646191],
              [54.8889715, 37.7646135],
              [54.8891849, 37.7646749],
              [54.8893856, 37.7647118],
              [54.8895141, 37.7647096],
              [54.8898222, 37.7646437],
              [54.8901231, 37.7645509],
              [54.8902432, 37.7645331],
              [54.8903916, 37.7645521],
              [54.8907039, 37.7646861],
              [54.8909837, 37.7648146],
              [54.8911702, 37.7649073],
              [54.8912126, 37.7649754],
              [54.8912112, 37.7651262],
              [54.8912097, 37.7653038],
              [54.8913256, 37.7654758],
              [54.8914968, 37.7656297],
              [54.8917638, 37.765823],
              [54.8920069, 37.7660531],
              [54.8921849, 37.7662117],
              [54.8922994, 37.7663134],
              [54.892305, 37.766377],
              [54.8922358, 37.766539],
              [54.8921185, 37.7666596],
              [54.8920479, 37.7667734],
              [54.8920349, 37.7668603],
              [54.8920449, 37.7669306],
              [54.8921078, 37.7670143],
              [54.8921058, 37.7671327],
              [54.8921048, 37.7672583],
              [54.8921578, 37.7674518],
              [54.8921708, 37.7675427],
              [54.8921698, 37.7676493],
              [54.8922057, 37.767827],
              [54.8922137, 37.7679992],
              [54.8921688, 37.7680948],
              [54.8921228, 37.7681319],
              [54.8920439, 37.7681493],
              [54.891952, 37.768139],
              [54.8918071, 37.76809],
              [54.8916672, 37.7679937],
              [54.8914014, 37.7677504],
              [54.8912715, 37.7676927],
              [54.8911506, 37.7676627],
              [54.8909558, 37.7676635],
              [54.890689, 37.7676872],
              [54.8903933, 37.7677164],
              [54.8900826, 37.7677678],
              [54.8897189, 37.7678412],
              [54.8894861, 37.7679281],
              [54.8891943, 37.7680347],
              [54.8889066, 37.7681824],
              [54.8886907, 37.7683649],
              [54.8885648, 37.7684889],
              [54.8885309, 37.7685608],
              [54.8884749, 37.768684],
              [54.888421, 37.7688601],
              [54.888405, 37.7689967],
              [54.888358, 37.7691034],
              [54.8882611, 37.7692629],
              [54.8881172, 37.7694074],
              [54.8878415, 37.7695954],
              [54.8875947, 37.7697676],
              [54.88722, 37.769999],
              [54.8871161, 37.7700488],
              [54.8870302, 37.7700622],
              [54.8869352, 37.7700559],
              [54.8868743, 37.770018],
              [54.8868083, 37.7699406],
              [54.8867774, 37.7698474],
              [54.8867166, 37.7696494],
              [54.8866662, 37.7695706],
              [54.8865899, 37.7695394],
              [54.8864924, 37.7695455],
              [54.8864189, 37.7695801],
              [54.8863058, 37.7696622],
              [54.8862492, 37.7697563],
              [54.8861862, 37.7698337],
              [54.8861403, 37.7700012],
              [54.8861133, 37.7702018],
              [54.8860553, 37.770385],
              [54.8860174, 37.7704608],
              [54.8859414, 37.7704885],
              [54.8857946, 37.7704964],
              [54.8855308, 37.7704387],
              [54.885335, 37.7703566],
              [54.8851691, 37.7702492],
              [54.8850732, 37.7701086],
              [54.8849723, 37.7699198],
              [54.8849253, 37.7697516],
              [54.8848943, 37.7695565],
              [54.8847395, 37.7693456],
              [54.8845476, 37.7691355],
              [54.8844487, 37.7690502],
              [54.884147, 37.7688875],
              [54.8839621, 37.7687343],
              [54.8837963, 37.7685487],
              [54.8835884, 37.7683378],
              [54.8833846, 37.7681182],
              [54.8832627, 37.768025],
              [54.8830309, 37.7678963],
              [54.882906, 37.7678726],
              [54.8827911, 37.7678939],
              [54.8826732, 37.7679579],
              [54.8825513, 37.7680843],
              [54.8824964, 37.7681593],
              [54.8824854, 37.7682825],
              [54.8824374, 37.7684429],
              [54.8824514, 37.7685716],
              [54.8824124, 37.7686782],
              [54.8823575, 37.7687469],
              [54.8822736, 37.7687841],
              [54.8821047, 37.7688078],
              [54.8819658, 37.7687999],
              [54.8816921, 37.7687351],
              [54.8815702, 37.768664],
              [54.8813434, 37.7685179],
              [54.8811995, 37.7684176],
              [54.8810156, 37.7683425],
              [54.8809077, 37.7683449],
              [54.8808218, 37.7683852],
              [54.8807668, 37.76845],
              [54.8807459, 37.768506],
              [54.8807379, 37.7685842],
              [54.8807459, 37.7686498],
              [54.8807988, 37.7687422],
              [54.8808468, 37.7688986],
              [54.8809907, 37.7690818],
              [54.881146, 37.7692561],
              [54.8813367, 37.7694963],
              [54.8815077, 37.769761],
              [54.881587, 37.7699607],
              [54.881583, 37.7700618],
              [54.8815381, 37.7701518],
              [54.8814551, 37.7702308],
              [54.8813642, 37.7702893],
              [54.8812783, 37.7703153],
              [54.8811314, 37.7702924],
              [54.8810205, 37.7702269],
              [54.8808127, 37.7701637],
              [54.8806418, 37.7700673],
              [54.880458, 37.7699307],
              [54.8803101, 37.7697403],
              [54.8801652, 37.7695642],
              [54.8799604, 37.7693857],
              [54.8796317, 37.769163],
              [54.8794409, 37.769039],
              [54.879245, 37.7688952],
              [54.8790352, 37.7687697],
              [54.8788953, 37.7687128],
              [54.8788144, 37.7687183],
              [54.8787375, 37.7687452],
              [54.8786306, 37.7688171],
              [54.8785716, 37.7688992],
              [54.8784897, 37.7690453],
              [54.8784277, 37.7691725],
              [54.8784257, 37.7693217],
              [54.8783518, 37.7695642],
              [54.8782739, 37.7698012],
              [54.8782249, 37.7700634],
              [54.878122, 37.7702324],
              [54.878055, 37.7702766],
              [54.8779731, 37.7702948],
              [54.8777613, 37.7702869],
              [54.8776624, 37.7702521],
              [54.8773207, 37.7701929],
              [54.876953, 37.7701605],
              [54.8766492, 37.7701021],
              [54.8762536, 37.7700057],
              [54.8761497, 37.7699615],
              [54.8761107, 37.7699315],
              [54.8761007, 37.7698873],
              [54.8761317, 37.7697119],
              [54.8762136, 37.7695524],
              [54.8763055, 37.7694544],
              [54.8763805, 37.7693802],
              [54.8763985, 37.7693407],
              [54.8764144, 37.769208],
              [54.8764504, 37.7690872],
              [54.8765004, 37.7689166],
              [54.8764914, 37.7688202],
              [54.8764694, 37.7687626],
              [54.8764784, 37.768663],
              [54.8764904, 37.7685256],
              [54.8764854, 37.7681505],
              [54.8764484, 37.7678985],
              [54.8763315, 37.7676063],
              [54.8762386, 37.7673298],
              [54.8761447, 37.7671395],
              [54.8759339, 37.7669207],
              [54.875768, 37.7667951],
              [54.8756644, 37.7667467],
              [54.8755521, 37.7667294],
              [54.87542, 37.7667551],
              [54.8753507, 37.766797],
              [54.8753098, 37.766864],
              [54.8752778, 37.7669668],
              [54.8752814, 37.7670433],
              [54.8753096, 37.767174],
              [54.8753365, 37.7673907],
              [54.8753301, 37.7676526],
              [54.8752785, 37.7678772],
              [54.8752573, 37.7680883],
              [54.87521, 37.768329],
              [54.8751662, 37.7683781],
              [54.8750002, 37.768477],
              [54.8748419, 37.7685552],
              [54.8746533, 37.7686043],
              [54.874341, 37.7686065],
              [54.8740104, 37.7686233],
              [54.8737482, 37.7686736],
              [54.8734402, 37.7687523],
              [54.8732855, 37.7687847],
              [54.8730092, 37.7688042],
              [54.8726291, 37.7688143],
              [54.8723147, 37.7687987],
              [54.8721925, 37.7687685],
              [54.8721402, 37.7687328],
              [54.8721, 37.7686842],
              [54.8720802, 37.7686171],
              [54.8720872, 37.7685278],
              [54.8721134, 37.7684518],
              [54.8721968, 37.768305],
              [54.87229, 37.7681977],
              [54.8724469, 37.7680536],
              [54.8726461, 37.7678721],
              [54.8728178, 37.7677113],
              [54.8729506, 37.7675633],
              [54.8731336, 37.7673617],
              [54.8732602, 37.7671488],
              [54.8734575, 37.7668837],
              [54.8735165, 37.7667281],
              [54.8735414, 37.7665709],
              [54.8735394, 37.766409],
              [54.8734959, 37.7663289],
              [54.8733398, 37.7661748],
              [54.8732105, 37.7660955],
              [54.8731363, 37.7660793],
              [54.8729533, 37.7659793],
              [54.8728756, 37.7659592],
              [54.8727117, 37.7659458],
              [54.8725464, 37.7659475],
              [54.8724263, 37.7659955],
              [54.8722066, 37.7661195],
              [54.8720285, 37.7662586],
              [54.8718597, 37.7664032],
              [54.8717622, 37.7664557],
              [54.8715728, 37.7665093],
              [54.871423, 37.7665451],
              [54.8712789, 37.7665501],
              [54.8711793, 37.76654],
              [54.8711058, 37.7665043],
              [54.8710599, 37.7664384],
              [54.8710514, 37.7663697],
              [54.871067, 37.7663116],
              [54.8711256, 37.7662329],
              [54.8712309, 37.7661363],
              [54.871339, 37.7660402],
              [54.8713828, 37.7659855],
              [54.8714018, 37.7659134],
              [54.8713913, 37.7657872],
              [54.8713107, 37.7656113],
              [54.8712273, 37.7653918],
              [54.8711235, 37.7652147],
              [54.8709907, 37.7650544],
              [54.8708303, 37.7648506],
              [54.8707137, 37.7646607],
              [54.87066, 37.7645233],
              [54.8706409, 37.7643842],
              [54.8706424, 37.7641625],
              [54.8706508, 37.7638882],
              [54.8706014, 37.7636348],
              [54.870494, 37.763307],
              [54.8703809, 37.7630333],
              [54.8702057, 37.7627228],
              [54.8700792, 37.7625479],
              [54.8699383, 37.7624113],
              [54.8698174, 37.7623284],
              [54.8697355, 37.7622904],
              [54.8696625, 37.7622873],
              [54.8695746, 37.7622991],
              [54.8694887, 37.7623536],
              [54.8693798, 37.7625345],
              [54.8692659, 37.7628141],
              [54.8692949, 37.7629919],
              [54.8693678, 37.7632296],
              [54.8693788, 37.7635542],
              [54.8693538, 37.7635993],
              [54.8692806, 37.7636934],
              [54.8692594, 37.7637984],
              [54.8692783, 37.7640338],
              [54.8693343, 37.7642502],
              [54.8694432, 37.7644611],
              [54.869635, 37.7647478],
              [54.8697654, 37.7649947],
              [54.8699167, 37.7651787],
              [54.8700646, 37.7653501],
              [54.8701445, 37.765482],
              [54.8701675, 37.7655554],
              [54.8701445, 37.7656194],
              [54.8700786, 37.7656747],
              [54.8699927, 37.7656984],
              [54.8698648, 37.7657055],
              [54.86966, 37.7656786],
              [54.8693712, 37.7656565],
              [54.8691924, 37.7656597],
              [54.8691074, 37.7656913],
              [54.8690255, 37.7657624],
              [54.8689586, 37.7658682],
              [54.8689466, 37.7659472],
              [54.8689705, 37.766072],
              [54.8690645, 37.7662813],
              [54.8691464, 37.7665246],
              [54.8692723, 37.7667631],
              [54.8693922, 37.7669305],
              [54.8694411, 37.7670806],
              [54.8694421, 37.7671462],
              [54.8694092, 37.7672007],
              [54.8693073, 37.7672441],
              [54.8691234, 37.7672757],
              [54.8689725, 37.7672773],
              [54.8688806, 37.7672599],
              [54.8686488, 37.7671801],
              [54.8683521, 37.7671122],
              [54.8679664, 37.7670443],
              [54.8676137, 37.7670451],
              [54.8670512, 37.7670964],
              [54.8667015, 37.767113],
              [54.8664367, 37.7670909],
              [54.8662049, 37.7670253],
              [54.866049, 37.7669369],
              [54.8658672, 37.7668571],
              [54.8658042, 37.7667986],
              [54.8657783, 37.7667339],
              [54.8657593, 37.766632],
              [54.8657623, 37.7664938],
              [54.8658012, 37.7664377],
              [54.8658172, 37.7663231],
              [54.8657963, 37.7660965],
              [54.8657413, 37.7657939],
              [54.8656933, 37.7655949],
              [54.8656833, 37.7654148],
              [54.8656993, 37.7652561],
              [54.8657463, 37.7651091],
              [54.8658432, 37.7648572],
              [54.8659651, 37.7646755],
              [54.866112, 37.7645357],
              [54.8662609, 37.7643074],
              [54.8662808, 37.7642308],
              [54.8662519, 37.7640302],
              [54.8661929, 37.7638572],
              [54.8661839, 37.7636155],
              [54.8661559, 37.7634173],
              [54.866086, 37.763144],
              [54.8658808, 37.7627752],
              [54.865719, 37.7626686],
              [54.8654612, 37.7624893],
              [54.8653193, 37.7623479],
              [54.8652164, 37.7621552],
              [54.8650685, 37.7619348],
              [54.8649037, 37.7617381],
              [54.8647398, 37.7616141],
              [54.86456, 37.7614956],
              [54.8643521, 37.7614158],
              [54.8640074, 37.7613495],
              [54.8639075, 37.7613518],
              [54.8637676, 37.7614056],
              [54.8634969, 37.7615398],
              [54.8634089, 37.7616086],
              [54.863368, 37.7616757],
              [54.863345, 37.7617523],
              [54.863347, 37.7618534],
              [54.863378, 37.7619395],
              [54.8634659, 37.7620951],
              [54.8635758, 37.7622847],
              [54.8636098, 37.7623842],
              [54.8635918, 37.7624609],
              [54.8635478, 37.7624972],
              [54.8634479, 37.7625225],
              [54.8632761, 37.7625288],
              [54.8631502, 37.7625114],
              [54.8630493, 37.7624577],
              [54.8628814, 37.7623605],
              [54.8628264, 37.7623376],
              [54.8627645, 37.7622642],
              [54.8626346, 37.7619988],
              [54.8625067, 37.7617302],
              [54.8623828, 37.7615098],
              [54.862206, 37.7613376],
              [54.8619282, 37.7610738],
              [54.8617614, 37.760929],
              [54.8616934, 37.7608326],
              [54.8616205, 37.7606849],
              [54.8615206, 37.7604724],
              [54.8614576, 37.7602291],
              [54.8613487, 37.7599542],
              [54.861087, 37.7596588],
              [54.8609031, 37.7594969],
              [54.8608332, 37.7594147],
              [54.8608112, 37.7593515],
              [54.8608052, 37.7593081],
              [54.8608082, 37.7592568],
              [54.8608462, 37.7592086],
              [54.8609391, 37.7591304],
              [54.86109, 37.7590166],
              [54.8611629, 37.758925],
              [54.8611779, 37.7588626],
              [54.8611669, 37.7587852],
              [54.861079, 37.7586888],
              [54.8608591, 37.7585656],
              [54.8606034, 37.7584131],
              [54.8603266, 37.7582251],
              [54.8601677, 37.7581224],
              [54.8600648, 37.7580995],
              [54.8599449, 37.758105],
              [54.8596182, 37.7581706],
              [54.8592995, 37.7582678],
              [54.8590017, 37.7584408],
              [54.858666, 37.758628],
              [54.8584052, 37.7587409],
              [54.8581475, 37.7588444],
              [54.8580166, 37.7588926],
              [54.8579396, 37.7589068],
              [54.8578767, 37.7588942],
              [54.8578018, 37.7588499],
              [54.8577678, 37.7587875],
              [54.8577518, 37.7587101],
              [54.8577548, 37.7586138],
              [54.8577798, 37.7585253],
              [54.8578877, 37.7583499],
              [54.8579886, 37.7582678],
              [54.8581345, 37.7581825],
              [54.8582524, 37.7580806],
              [54.8583023, 37.7580142],
              [54.8583173, 37.7579415],
              [54.8583013, 37.757861],
              [54.8582554, 37.7577986],
              [54.8581604, 37.7577464],
              [54.8580156, 37.7577235],
              [54.8576379, 37.7577275],
              [54.8574471, 37.7577796],
              [54.8572762, 37.7578791],
              [54.8569465, 37.7580908],
              [54.8568206, 37.7581532],
              [54.8566447, 37.7582046],
              [54.8564609, 37.7582322],
              [54.856295, 37.7582243],
              [54.8561442, 37.7581919],
              [54.8560662, 37.7581627],
              [54.8560363, 37.7581208],
              [54.8560133, 37.7580403],
              [54.8560083, 37.7579455],
              [54.8560423, 37.7577717],
              [54.8560642, 37.7576453],
              [54.8560682, 37.7575458],
              [54.8560213, 37.7574897],
              [54.8559433, 37.7574739],
              [54.8557935, 37.7574391],
              [54.8555846, 37.7573586],
              [54.8554667, 37.7572251],
              [54.8554058, 37.7570631],
              [54.8553758, 37.7568569],
              [54.8553818, 37.756556],
              [54.8553628, 37.7562171],
              [54.8553179, 37.756067],
              [54.855205, 37.7559343],
              [54.8549292, 37.7556404],
              [54.8547913, 37.755439],
              [54.8546554, 37.755168],
              [54.8545415, 37.7549255],
              [54.8544136, 37.7546822],
              [54.8543687, 37.754555],
              [54.8543617, 37.7544736],
              [54.8543797, 37.7544152],
              [54.8544176, 37.7543654],
              [54.8544806, 37.7543283],
              [54.8545735, 37.7543362],
              [54.8546484, 37.7543662],
              [54.8547723, 37.7544215],
              [54.8549522, 37.7544294],
              [54.8551633, 37.754416],
              [54.8554521, 37.7543599],
              [54.8557848, 37.7543133],
              [54.8560916, 37.754243],
              [54.8562095, 37.7541727],
              [54.8562694, 37.7541008],
              [54.8562734, 37.7540337],
              [54.8562454, 37.7539705],
              [54.8561065, 37.7538417],
              [54.8559777, 37.7537572],
              [54.8557029, 37.753626],
              [54.8554621, 37.7534791],
              [54.8553502, 37.7533788],
              [54.8552433, 37.7532279],
              [54.8551464, 37.7530494],
              [54.8550325, 37.7527887],
              [54.8549266, 37.7525343],
              [54.8548376, 37.7522752],
              [54.8548216, 37.7521448],
              [54.8548466, 37.7520674],
              [54.8548826, 37.7520303],
              [54.8549755, 37.7520074],
              [54.8551384, 37.7520176],
              [54.8553042, 37.7520042],
              [54.8554691, 37.7519473],
              [54.85552, 37.7519102],
              [54.85555, 37.7518573],
              [54.855518, 37.7517261],
              [54.8553582, 37.7515136],
              [54.8551297, 37.7512679],
              [54.8550458, 37.7511502],
              [54.8550048, 37.7510728],
              [54.8549829, 37.7510064],
              [54.8549809, 37.7509314],
              [54.8550668, 37.7508042],
              [54.8552376, 37.7506841],
              [54.8554505, 37.7505561],
              [54.8557092, 37.7503949],
              [54.8558122, 37.7503009],
              [54.8558331, 37.7502369],
              [54.8558042, 37.7501611],
              [54.8557262, 37.7500545],
              [54.8556183, 37.7499668],
              [54.8553685, 37.7498522],
              [54.8551178, 37.7497685],
              [54.854817, 37.7497448],
              [54.8544663, 37.7497274],
              [54.8541086, 37.7497084],
              [54.8537445, 37.7497081],
              [54.8535426, 37.7496804],
              [54.8534427, 37.7496386],
              [54.8534088, 37.749592],
              [54.8533958, 37.7495367],
              [54.8534038, 37.7494798],
              [54.8534437, 37.7494245],
              [54.8535576, 37.7493605],
              [54.8536575, 37.7493281],
              [54.8538044, 37.749332],
              [54.8541541, 37.7493004],
              [54.8546047, 37.7492341],
              [54.8548385, 37.7491574],
              [54.8549634, 37.7490784],
              [54.8550174, 37.7490034],
              [54.8550364, 37.7489031],
              [54.8550204, 37.7487838],
              [54.8549225, 37.7486566],
              [54.8548046, 37.7486021],
              [54.8545708, 37.7485507],
              [54.8544589, 37.7484891],
              [54.8541271, 37.7484204],
              [54.8538274, 37.7484069],
              [54.8533014, 37.7483743],
              [54.8528803, 37.7483911],
              [54.8522995, 37.7485173],
              [54.8517471, 37.7486481],
              [54.8514023, 37.7487453],
              [54.8510974, 37.7488962],
              [54.8508982, 37.7489928],
              [54.8508003, 37.7490845],
              [54.8507143, 37.7492622],
              [54.8506914, 37.7493949],
              [54.8506374, 37.7496201],
              [54.8504835, 37.749959],
              [54.8504026, 37.7500222],
              [54.8503127, 37.7500507],
              [54.8502527, 37.7500538],
              [54.8501778, 37.7500388],
              [54.8500909, 37.7499969],
              [54.849995, 37.7498998],
              [54.8498721, 37.7497426],
              [54.8497811, 37.7495545],
              [54.8496762, 37.7493507],
              [54.8495623, 37.749218],
              [54.8494654, 37.74912],
              [54.8493795, 37.7491034],
              [54.8492686, 37.7491184],
              [54.8491517, 37.7492006],
              [54.8490777, 37.7493815],
              [54.8489429, 37.7495853],
              [54.8488719, 37.7496312],
              [54.848789, 37.7496509],
              [54.8487011, 37.7496873],
              [54.8485752, 37.7497054],
              [54.8485042, 37.7496983],
              [54.8484243, 37.7496588],
              [54.8483803, 37.7496075],
              [54.8483464, 37.7494976],
              [54.8483314, 37.749357],
              [54.8483574, 37.7492283],
              [54.8484683, 37.7490244],
              [54.8486851, 37.7487345],
              [54.8488649, 37.7485038],
              [54.8489968, 37.7483482],
              [54.8490348, 37.7482723],
              [54.8490068, 37.7481902],
              [54.8488889, 37.7480495],
              [54.8486711, 37.74795],
              [54.8484083, 37.7478868],
              [54.8479057, 37.7477596],
              [54.8478078, 37.7477153],
              [54.8477768, 37.7476758],
              [54.8477719, 37.74763],
              [54.8477958, 37.7475557],
              [54.8479467, 37.7473906],
              [54.8481775, 37.7472058],
              [54.8484133, 37.7470493],
              [54.8486441, 37.7468455],
              [54.848732, 37.746738],
              [54.84875, 37.7466662],
              [54.848719, 37.7465903],
              [54.8485991, 37.7464797],
              [54.8484003, 37.7463904],
              [54.8481805, 37.7463493],
              [54.8478208, 37.7463604],
              [54.847573, 37.7464197],
              [54.8473422, 37.7465145],
              [54.8470964, 37.7466306],
              [54.8468926, 37.7466899],
              [54.8467957, 37.7467057],
              [54.8466908, 37.7467009],
              [54.8465559, 37.7466464],
              [54.8463571, 37.7465729],
              [54.8460783, 37.7465208],
              [54.8458415, 37.7464125],
              [54.8457905, 37.7463565],
              [54.8457885, 37.7462846],
              [54.8458045, 37.7462016],
              [54.8458475, 37.7461455],
              [54.8460134, 37.7460649],
              [54.8462492, 37.7459717],
              [54.8464969, 37.7458974],
              [54.8465239, 37.7458374],
              [54.846427, 37.7456928],
              [54.8462621, 37.7455451],
              [54.8460883, 37.7454747],
              [54.8458905, 37.7454747],
              [54.8456766, 37.7454992],
              [54.8454126, 37.7455572],
              [54.8452161, 37.7456653],
              [54.8450262, 37.7458154],
              [54.8448244, 37.746005],
              [54.8446226, 37.746133],
              [54.8445436, 37.7461583],
              [54.8444667, 37.7461543],
              [54.8443968, 37.746133],
              [54.8443388, 37.7460974],
              [54.8442979, 37.7460113],
              [54.8442579, 37.7458446],
              [54.8442759, 37.7457087],
              [54.8442399, 37.7454022],
              [54.844167, 37.7450877],
              [54.8440551, 37.7447409],
              [54.8439462, 37.7444952],
              [54.8438632, 37.7444423],
              [54.8437523, 37.7444201],
              [54.8435406, 37.7444337],
              [54.8433781, 37.7444895],
              [54.8432457, 37.7445979],
              [54.8430239, 37.7448537],
              [54.8427936, 37.7450155],
              [54.8425568, 37.7450779],
              [54.8422241, 37.7450819],
              [54.842015, 37.7450528],
              [54.8417431, 37.7450259],
              [54.8415683, 37.7450456],
              [54.8414364, 37.7450891],
              [54.8412466, 37.745202],
              [54.8409432, 37.7454673],
              [54.8406365, 37.7456919],
              [54.8404969, 37.7457596],
              [54.840412, 37.7457754],
              [54.8403121, 37.745758],
              [54.8402131, 37.745694],
              [54.8401642, 37.7456142],
              [54.8400813, 37.7454128],
              [54.8400443, 37.74525],
              [54.8400773, 37.7451165],
              [54.8401622, 37.7449648],
              [54.8402331, 37.7447144],
              [54.840356, 37.7444574],
              [54.8403851, 37.7443439],
              [54.8403641, 37.7442025],
              [54.8402792, 37.7440602],
              [54.8401763, 37.7439757],
              [54.8399715, 37.7438556],
              [54.8399185, 37.743794],
              [54.8399075, 37.7437276],
              [54.8399205, 37.7436628],
              [54.8399695, 37.743587],
              [54.8400614, 37.7435293],
              [54.8402662, 37.743455],
              [54.8404471, 37.7433168],
              [54.8406579, 37.7431856],
              [54.8409466, 37.743041],
              [54.8411834, 37.7428704],
              [54.8413713, 37.7427424],
              [54.8414832, 37.7426926],
              [54.8415991, 37.742691],
              [54.841719, 37.7427258],
              [54.8417939, 37.7428064],
              [54.8418349, 37.7429288],
              [54.8418689, 37.7431185],
              [54.8418808, 37.7433342],
              [54.8419118, 37.7434598],
              [54.8419598, 37.7435159],
              [54.8420517, 37.7435617],
              [54.8422096, 37.7435704],
              [54.8424274, 37.7435333],
              [54.8426912, 37.7434424],
              [54.8429559, 37.7432749],
              [54.8430359, 37.7431848],
              [54.8430858, 37.7430339],
              [54.8431448, 37.7427874],
              [54.8431438, 37.7426333],
              [54.8430708, 37.7422999],
              [54.8429919, 37.7420139],
              [54.842847, 37.7417042],
              [54.8426792, 37.7413866],
              [54.8425013, 37.7411424],
              [54.8423245, 37.7408588],
              [54.8422755, 37.7407553],
              [54.8422775, 37.740666],
              [54.8423295, 37.7405364],
              [54.8423994, 37.7404882],
              [54.8425643, 37.7404613],
              [54.842848, 37.7404218],
              [54.8431827, 37.7404416],
              [54.8434695, 37.7404613],
              [54.8437502, 37.7404361],
              [54.8441219, 37.7403618],
              [54.8443691, 37.740319],
              [54.8445952, 37.7403346],
              [54.8450035, 37.7403469],
              [54.8453596, 37.7403145],
              [54.8456451, 37.7402464],
              [54.8457298, 37.7401838],
              [54.8458601, 37.7400109],
              [54.8458731, 37.7398561],
              [54.8458081, 37.7396862],
              [54.8456902, 37.7395274],
              [54.8455194, 37.7394104],
              [54.8453005, 37.7393283],
              [54.8448879, 37.7392864],
              [54.8444822, 37.7392176],
              [54.8437569, 37.7391307],
              [54.8431687, 37.7390993],
              [54.8428196, 37.7390456],
              [54.8425596, 37.7389808],
              [54.8422516, 37.7388669],
              [54.8419959, 37.7388043],
              [54.8416384, 37.7387316],
              [54.841507, 37.7387305],
              [54.841124, 37.7387685],
              [54.840857, 37.7387998],
              [54.8405285, 37.7388282],
              [54.8403107, 37.738829],
              [54.8402378, 37.7388108],
              [54.8401848, 37.7387681],
              [54.8401379, 37.7386622],
              [54.8401269, 37.7384608],
              [54.8400469, 37.7382616],
              [54.8397217, 37.7378735],
              [54.8395288, 37.7376175],
              [54.8394519, 37.7374129],
              [54.8394329, 37.7373323],
              [54.8394389, 37.7372841],
              [54.8394779, 37.7372335],
              [54.8396048, 37.7371695],
              [54.8397277, 37.7371474],
              [54.8400084, 37.7371553],
              [54.8404481, 37.7371316],
              [54.8406978, 37.7370439],
              [54.8407318, 37.7370107],
              [54.8407338, 37.7368187],
              [54.8407338, 37.7367191],
              [54.8406968, 37.7365824],
              [54.8406079, 37.7365018],
              [54.840464, 37.7364109],
              [54.8403112, 37.7362284],
              [54.8401853, 37.736117],
              [54.8400664, 37.7360649],
              [54.8398586, 37.7360222],
              [54.8394929, 37.73588],
              [54.8391502, 37.7357504],
              [54.8388164, 37.7355994],
              [54.8387435, 37.7355512],
              [54.8387115, 37.7354928],
              [54.8386736, 37.735364],
              [54.8386806, 37.7352541],
              [54.8387425, 37.7351222],
              [54.8389144, 37.7349555],
              [54.8390672, 37.7348472],
              [54.8391092, 37.7347816],
              [54.8392331, 37.7346813],
              [54.8392711, 37.7346267],
              [54.839282, 37.7345793],
              [54.8392691, 37.7345035],
              [54.8392081, 37.7344316],
              [54.8390003, 37.7342783],
              [54.8385836, 37.7340286],
              [54.8384717, 37.7339251],
              [54.8384288, 37.7337639],
              [54.8384198, 37.733594],
              [54.8384388, 37.7333482],
              [54.8384228, 37.733127],
              [54.8383349, 37.7329144],
              [54.8380822, 37.732603],
              [54.8378494, 37.7323659],
              [54.8376747, 37.732254],
              [54.8375438, 37.732209],
              [54.8374319, 37.7322066],
              [54.83728, 37.7322335],
              [54.8371371, 37.7323149],
              [54.8370162, 37.7324318],
              [54.8367904, 37.7326942],
              [54.8365896, 37.7329589],
              [54.8364397, 37.7331059],
              [54.8362599, 37.7332181],
              [54.836074, 37.7332584],
              [54.8358492, 37.7332663],
              [54.8355385, 37.7332331],
              [54.8353786, 37.7331896],
              [54.8351778, 37.7331177],
              [54.8351118, 37.7330711],
              [54.8350819, 37.7330253],
              [54.8350649, 37.7329004],
              [54.8350799, 37.7326096],
              [54.8350989, 37.732431],
              [54.8350849, 37.7321213],
              [54.8351019, 37.7319996],
              [54.8351568, 37.7318305],
              [54.8353407, 37.7316621],
              [54.8355755, 37.7314488],
              [54.8357843, 37.7312346],
              [54.8358123, 37.7311809],
              [54.8358123, 37.7311335],
              [54.8357533, 37.7310545],
              [54.8356574, 37.7309999],
              [54.8354935, 37.7309905],
              [54.8351998, 37.731011],
              [54.834978, 37.7310916],
              [54.8347811, 37.7311564],
              [54.8346652, 37.731177],
              [54.8345633, 37.7311619],
              [54.8344874, 37.731128],
              [54.8344554, 37.7310798],
              [54.8344494, 37.7309802],
              [54.8345034, 37.7307534],
              [54.8346702, 37.730465],
              [54.8347472, 37.7303804],
              [54.8348121, 37.7302295],
              [54.8347971, 37.7300801],
              [54.8347032, 37.7299845],
              [54.8344554, 37.7298383],
              [54.8342386, 37.7296265],
              [54.8341057, 37.7293729],
              [54.8339808, 37.7291255],
              [54.8338809, 37.7288624],
              [54.833785, 37.7287138],
              [54.8336139, 37.728604],
              [54.8334381, 37.7285449],
              [54.8332503, 37.7285046],
              [54.8330595, 37.7285046],
              [54.8328077, 37.7285252],
              [54.8326078, 37.7285576],
              [54.8325109, 37.7285457],
              [54.8323231, 37.7284936],
              [54.8321542, 37.728398],
              [54.8320953, 37.7283339],
              [54.8320603, 37.7282478],
              [54.8320263, 37.7281356],
              [54.8320253, 37.7280392],
              [54.8320823, 37.7279396],
              [54.8322302, 37.7277831],
              [54.832446, 37.7275777],
              [54.8326108, 37.7274062],
              [54.8326468, 37.7273082],
              [54.8326188, 37.727158],
              [54.8325279, 37.7270466],
              [54.8324553, 37.7269818],
              [54.8322157, 37.7269382],
              [54.8320174, 37.7269361],
              [54.8318663, 37.7269788],
              [54.8317233, 37.7270695],
              [54.8315641, 37.7272541],
              [54.8314224, 37.727428],
              [54.8312241, 37.7275091],
              [54.8311, 37.7275454],
              [54.830992, 37.7275305],
              [54.830878, 37.7274838],
              [54.8307653, 37.7273794],
              [54.8305917, 37.7272518],
              [54.8304963, 37.7272269],
              [54.8304067, 37.727233],
              [54.8302779, 37.7272881],
              [54.830151, 37.7273628],
              [54.8300813, 37.7274654],
              [54.8300231, 37.7275982],
              [54.8299993, 37.7277083],
              [54.8300003, 37.7279113],
              [54.8299451, 37.7282961],
              [54.8298484, 37.7283688],
              [54.8297453, 37.7283937],
              [54.8296318, 37.7283915],
              [54.8294887, 37.728356],
              [54.8293733, 37.7282851],
              [54.8291825, 37.7280995],
              [54.8290489, 37.7279297],
              [54.8288305, 37.7277433],
              [54.8287809, 37.7276249],
              [54.8287446, 37.7274943],
              [54.8287379, 37.7274098],
              [54.8287522, 37.7273593],
              [54.8288381, 37.7272695],
              [54.8290637, 37.7270333],
              [54.8292013, 37.7269138],
              [54.8292809, 37.7267356],
              [54.829289, 37.7264155],
              [54.8293308, 37.72609],
              [54.8293646, 37.7260046],
              [54.8294536, 37.7258872],
              [54.8295953, 37.7257944],
              [54.8297072, 37.7256535],
              [54.8298233, 37.7254636],
              [54.8298421, 37.7253409],
              [54.8298044, 37.7252438],
              [54.8296937, 37.7251584],
              [54.8294644, 37.7250965],
              [54.8290273, 37.7250154],
              [54.8286212, 37.7250432],
              [54.8283001, 37.7250826],
              [54.8278778, 37.7251808],
              [54.8276565, 37.7252993],
              [54.8275035, 37.7254546],
              [54.8273888, 37.7256712],
              [54.8272391, 37.725859],
              [54.8271042, 37.7259583],
              [54.8267305, 37.7260554],
              [54.826404, 37.7261237],
              [54.8262906, 37.7261952],
              [54.8262367, 37.7262859],
              [54.8262421, 37.726351],
              [54.8263298, 37.7265281],
              [54.8264984, 37.7267981],
              [54.8265119, 37.7269112],
              [54.8264377, 37.7270072],
              [54.8263325, 37.7270435],
              [54.8261746, 37.7270563],
              [54.8259237, 37.726988],
              [54.8256754, 37.7268269],
              [54.8253341, 37.7266348],
              [54.8249982, 37.7264854],
              [54.8246676, 37.7263574],
              [54.8244275, 37.7262336],
              [54.8243735, 37.7261845],
              [54.824356, 37.7261226],
              [54.8243546, 37.7260212],
              [54.824414, 37.7258537],
              [54.824553, 37.7255762],
              [54.8247149, 37.7253532],
              [54.8249483, 37.725016],
              [54.8251129, 37.7247471],
              [54.8251196, 37.7246137],
              [54.8250427, 37.7244344],
              [54.8249172, 37.7241602],
              [54.8247472, 37.723871],
              [54.824584, 37.7235882],
              [54.8243115, 37.7231667],
              [54.8240983, 37.7228786],
              [54.8240214, 37.7227153],
              [54.8239607, 37.7225285],
              [54.8239391, 37.7223909],
              [54.823962, 37.7222618],
              [54.8238716, 37.7218392],
              [54.8237246, 37.7214646],
              [54.8236558, 37.7212682],
              [54.8236356, 37.7210943],
              [54.8236558, 37.7207432],
              [54.8236167, 37.7205148],
              [54.8235155, 37.7202459],
              [54.8233293, 37.7198019],
              [54.8232645, 37.7195586],
              [54.8232564, 37.719405],
              [54.8232672, 37.7192833],
              [54.8233023, 37.7191979],
              [54.82339, 37.7190997],
              [54.8235425, 37.7188095],
              [54.8235613, 37.7186985],
              [54.8235128, 37.7186302],
              [54.8233454, 37.7185374],
              [54.8232252, 37.7184038],
              [54.8231728, 37.7182559],
              [54.8231957, 37.7180551],
              [54.8232434, 37.7178574],
              [54.8233283, 37.7177073],
              [54.8234838, 37.7175941],
              [54.8236173, 37.7175548],
              [54.8238456, 37.7175537],
              [54.8240507, 37.7175823],
              [54.8244295, 37.7176457],
              [54.8246403, 37.7176918],
              [54.8247281, 37.7176872],
              [54.8248225, 37.7176563],
              [54.8249399, 37.7175771],
              [54.8250009, 37.717488],
              [54.8250362, 37.7172329],
              [54.8250553, 37.7169643],
              [54.8250566, 37.7165865],
              [54.8250688, 37.7164061],
              [54.8251173, 37.7162962],
              [54.8252792, 37.7161767],
              [54.8255383, 37.715991],
              [54.8256732, 37.7158426],
              [54.825684, 37.7157434],
              [54.8255949, 37.7154531],
              [54.8253548, 37.714896],
              [54.8250931, 37.7143293],
              [54.8249865, 37.7142631],
              [54.8248678, 37.7142439],
              [54.8246951, 37.7142663],
              [54.8245129, 37.7143442],
              [54.8242863, 37.7145256],
              [54.8241379, 37.7146825],
              [54.8239045, 37.714912],
              [54.8237318, 37.7151511],
              [54.8235861, 37.7153133],
              [54.8234377, 37.7153869],
              [54.8233142, 37.7153969],
              [54.8231816, 37.7153614],
              [54.8229889, 37.715252],
              [54.8226687, 37.7149774],
              [54.8224785, 37.7148536],
              [54.8222438, 37.7147639],
              [54.8219375, 37.7146508],
              [54.8218301, 37.7145946],
              [54.8217748, 37.7145493],
              [54.821751, 37.714504],
              [54.8217481, 37.7144535],
              [54.821792, 37.7143176],
              [54.8219215, 37.7140337],
              [54.82199, 37.7137824],
              [54.821968, 37.7136609],
              [54.8218889, 37.7135899],
              [54.8217916, 37.713556],
              [54.8215912, 37.7135515],
              [54.8214004, 37.7136111],
              [54.8211373, 37.7137324],
              [54.8209053, 37.7139363],
              [54.8207407, 37.7140377],
              [54.8205248, 37.7140974],
              [54.8203909, 37.7140917],
              [54.8201915, 37.7140253],
              [54.8199225, 37.7139189],
              [54.8198424, 37.7138744],
              [54.8197784, 37.7137883],
              [54.8197174, 37.7136865],
              [54.8197069, 37.7136367],
              [54.8197155, 37.7135612],
              [54.819787, 37.7134457],
              [54.819912, 37.7133152],
              [54.8202421, 37.7130254],
              [54.8203833, 37.7128692],
              [54.8205225, 37.7127129],
              [54.8206523, 37.7124601],
              [54.8207582, 37.7122888],
              [54.8208345, 37.7122277],
              [54.821072, 37.7120979],
              [54.8211865, 37.712002],
              [54.8212285, 37.7119379],
              [54.8212428, 37.7118669],
              [54.8212476, 37.7117854],
              [54.8212161, 37.7117145],
              [54.8210825, 37.7116579],
              [54.8208221, 37.7115598],
              [54.8204659, 37.7114274],
              [54.8201529, 37.7113111],
              [54.8198912, 37.7111785],
              [54.819854, 37.7111402],
              [54.8198439, 37.7110847],
              [54.819847, 37.7109789],
              [54.8198766, 37.7108823],
              [54.8199968, 37.7107064],
              [54.8202181, 37.7104528],
              [54.8203788, 37.7101544],
              [54.8205083, 37.7099409],
              [54.8206244, 37.7096827],
              [54.8207701, 37.7095343],
              [54.820909, 37.7094478],
              [54.8214312, 37.7092547],
              [54.8215984, 37.709133],
              [54.8216403, 37.7090156],
              [54.8216254, 37.7089046],
              [54.8215215, 37.7087637],
              [54.8213408, 37.7086548],
              [54.8211829, 37.7086217],
              [54.8210048, 37.7086345],
              [54.8208052, 37.7087285],
              [54.8204233, 37.7089846],
              [54.8202345, 37.7090956],
              [54.8201252, 37.7091212],
              [54.81997, 37.7090839],
              [54.8197636, 37.708991],
              [54.8196935, 37.7089152],
              [54.8196638, 37.7088021],
              [54.8196665, 37.7086601],
              [54.8197016, 37.7085577],
              [54.8199201, 37.7083581],
              [54.8201697, 37.708182],
              [54.8203545, 37.7080656],
              [54.8204895, 37.7079568],
              [54.8205852, 37.7078127],
              [54.8206257, 37.7076675],
              [54.8205852, 37.7074487],
              [54.8205852, 37.7073665],
              [54.8206999, 37.7072182],
              [54.8208106, 37.7071296],
              [54.8210291, 37.7070762],
              [54.8211991, 37.7069652],
              [54.8212652, 37.706835],
              [54.8214635, 37.706265],
              [54.8216206, 37.7059446],
              [54.8218499, 37.705714],
              [54.8221184, 37.7054461],
              [54.8222264, 37.7051729],
              [54.8223936, 37.7048516],
              [54.8225245, 37.7046776],
              [54.8227161, 37.7045922],
              [54.8229751, 37.7045527],
              [54.8231262, 37.7044566],
              [54.8231748, 37.7043467],
              [54.8231559, 37.7041994],
              [54.8229994, 37.7039603],
              [54.8228807, 37.7038322],
              [54.8227338, 37.7035137],
              [54.8225801, 37.7032026],
              [54.8224438, 37.7029677],
              [54.8222145, 37.7028631],
              [54.8219096, 37.7027895],
              [54.8215224, 37.7027638],
              [54.8212604, 37.7027307],
              [54.8211774, 37.7026937],
              [54.8211402, 37.7026431],
              [54.821145, 37.7025292],
              [54.8211888, 37.7023442],
              [54.8212881, 37.702114],
              [54.8212833, 37.7020627],
              [54.8211669, 37.7019646],
              [54.8209828, 37.7019185],
              [54.8207052, 37.7018914],
              [54.8202992, 37.7018796],
              [54.8202124, 37.7018766],
              [54.8201256, 37.7018019],
              [54.8200702, 37.701709],
              [54.8200655, 37.7016071],
              [54.8200865, 37.7014916],
              [54.8201485, 37.7014252],
              [54.8202429, 37.7013814],
              [54.8204327, 37.701349],
              [54.8207934, 37.701346],
              [54.8210821, 37.7013414],
              [54.82124, 37.7013184],
              [54.8213268, 37.7012437],
              [54.8214146, 37.7010814],
              [54.8214976, 37.7009372],
              [54.8216264, 37.7007976],
              [54.8218038, 37.700741],
              [54.8220833, 37.700667],
              [54.8222588, 37.7006512],
              [54.8224811, 37.7006753],
              [54.822692, 37.7006383],
              [54.8228618, 37.7005712],
              [54.8229448, 37.700504],
              [54.8229476, 37.7004232],
              [54.8229457, 37.7002813],
              [54.8228799, 37.7001613],
              [54.8226614, 37.699962],
              [54.8224067, 37.699765],
              [54.822318, 37.6996842],
              [54.8222579, 37.699602],
              [54.8222369, 37.6994782],
              [54.8222493, 37.699365],
              [54.8223037, 37.6992064],
              [54.8223085, 37.6990962],
              [54.8222856, 37.6989558],
              [54.8222121, 37.6988404],
              [54.8220747, 37.6987407],
              [54.8219173, 37.6987083],
              [54.8216597, 37.6987022],
              [54.8213774, 37.6987098],
              [54.821094, 37.6987566],
              [54.8208031, 37.6988471],
              [54.8205331, 37.6989438],
              [54.820223, 37.6990766],
              [54.8198777, 37.6992381],
              [54.8196802, 37.6993393],
              [54.8194942, 37.6993982],
              [54.8192834, 37.6994163],
              [54.819063, 37.6993801],
              [54.8187621, 37.699274],
              [54.8186191, 37.6992452],
              [54.818503, 37.6992623],
              [54.8181226, 37.6994],
              [54.8178514, 37.6994833],
              [54.8176787, 37.6994939],
              [54.8175411, 37.6994352],
              [54.8173873, 37.6992868],
              [54.8173347, 37.6991812],
              [54.8173239, 37.6990648],
              [54.8173981, 37.6988887],
              [54.8175317, 37.698641],
              [54.8176021, 37.698448],
              [54.8175897, 37.6983529],
              [54.8174761, 37.6982487],
              [54.817313, 37.6982246],
              [54.8171193, 37.6982382],
              [54.8166379, 37.6983524],
              [54.8162642, 37.6985168],
              [54.8159742, 37.6986385],
              [54.8158757, 37.6986598],
              [54.8157677, 37.6986481],
              [54.8156117, 37.6985529],
              [54.8155011, 37.6984345],
              [54.8154467, 37.6983469],
              [54.8154114, 37.6982201],
              [54.8154076, 37.6981016],
              [54.8154236, 37.6979079],
              [54.8154546, 37.697799],
              [54.8155545, 37.6976047],
              [54.815647, 37.6975035],
              [54.8157347, 37.6974522],
              [54.8158397, 37.6974522],
              [54.8160705, 37.6975201],
              [54.8164402, 37.6976311],
              [54.8165738, 37.6976461],
              [54.8167761, 37.6976418],
              [54.816938, 37.6975831],
              [54.8171674, 37.6974582],
              [54.8176234, 37.6973397],
              [54.8181388, 37.6972255],
              [54.8182467, 37.6971636],
              [54.818298, 37.6970547],
              [54.8183142, 37.6969404],
              [54.8182454, 37.6966725],
              [54.8181698, 37.6964035],
              [54.8181725, 37.6962914],
              [54.8182265, 37.696158],
              [54.8184383, 37.6958815],
              [54.8185368, 37.6956968],
              [54.8185799, 37.6955345],
              [54.8185489, 37.6953744],
              [54.8184019, 37.6950851],
              [54.818159, 37.6948],
              [54.8180106, 37.6946292],
              [54.8178447, 37.6943453],
              [54.8177367, 37.6942268],
              [54.8174669, 37.6940688],
              [54.817073, 37.6938222],
              [54.8168976, 37.6936919],
              [54.8167734, 37.6936482],
              [54.8166642, 37.6936418],
              [54.8165441, 37.6936813],
              [54.8164658, 37.6937421],
              [54.8163579, 37.69393],
              [54.8162068, 37.6940901],
              [54.8161367, 37.6941158],
              [54.8160017, 37.6941083],
              [54.8159181, 37.6940624],
              [54.8157899, 37.6939225],
              [54.8154985, 37.6935681],
              [54.8152557, 37.6934154],
              [54.81511, 37.6932959],
              [54.8150816, 37.6932158],
              [54.8150749, 37.6931368],
              [54.8151248, 37.6930364],
              [54.8152678, 37.692824],
              [54.8153636, 37.6926703],
              [54.8153784, 37.6925795],
              [54.8153002, 37.6923884],
              [54.8151693, 37.6921899],
              [54.8149737, 37.6918749],
              [54.814882, 37.6916454],
              [54.8148064, 37.6913742],
              [54.8147781, 37.6911394],
              [54.8147754, 37.6909408],
              [54.8146998, 37.6908073],
              [54.8146175, 37.690739],
              [54.8144421, 37.6906878],
              [54.8141602, 37.6906429],
              [54.8136502, 37.6904657],
              [54.8134627, 37.6903867],
              [54.8132805, 37.6902735],
              [54.8129756, 37.6902266],
              [54.8128502, 37.6902276],
              [54.8126114, 37.6902799],
              [54.8123807, 37.6902767],
              [54.8122174, 37.6902383],
              [54.812154, 37.6901625],
              [54.8121378, 37.6900974],
              [54.8121891, 37.6899319],
              [54.81232, 37.6898091],
              [54.8124724, 37.6896778],
              [54.812525, 37.6895625],
              [54.8125034, 37.6894429],
              [54.8123119, 37.6892508],
              [54.8119611, 37.6890084],
              [54.8117128, 37.6889187],
              [54.811381, 37.6889262],
              [54.8110288, 37.6890458],
              [54.8107873, 37.6891045],
              [54.810477, 37.689128],
              [54.8103259, 37.6890767],
              [54.810164, 37.688954],
              [54.809909, 37.688639],
              [54.8095691, 37.6884308],
              [54.8094396, 37.6882974],
              [54.8094315, 37.6882173],
              [54.8094814, 37.6881095],
              [54.8095961, 37.688023],
              [54.8098888, 37.6879429],
              [54.8103084, 37.6878415],
              [54.8105121, 37.6877379],
              [54.8106781, 37.6876045],
              [54.8107455, 37.6875041],
              [54.810983, 37.6872788],
              [54.8113, 37.6870034],
              [54.8115955, 37.6866639],
              [54.8117371, 37.6864749],
              [54.8118478, 37.6864162],
              [54.8119705, 37.6864172],
              [54.8121135, 37.686445],
              [54.8123415, 37.6865176],
              [54.8125641, 37.6865293],
              [54.8127166, 37.6864909],
              [54.8128299, 37.6864322],
              [54.812892, 37.6863542],
              [54.8129122, 37.686271],
              [54.8128718, 37.6860884],
              [54.8127517, 37.6859122],
              [54.8125345, 37.6857489],
              [54.8121635, 37.6855471],
              [54.81181, 37.6854563],
              [54.8115833, 37.6853688],
              [54.8114997, 37.6852919],
              [54.811439, 37.6852033],
              [54.8114376, 37.6850901],
              [54.8115078, 37.6849428],
              [54.8116238, 37.6848221],
              [54.8117695, 37.6847719],
              [54.8119854, 37.6847645],
              [54.8121958, 37.6848072],
              [54.8124711, 37.6849033],
              [54.8126491, 37.6849353],
              [54.8127517, 37.6849268],
              [54.8128353, 37.6848809],
              [54.8129905, 37.6847111],
              [54.8132778, 37.6843588],
              [54.8133588, 37.6842232],
              [54.8133669, 37.6840854],
              [54.8133075, 37.6838612],
              [54.8131132, 37.6837021],
              [54.812896, 37.6835815],
              [54.8127463, 37.6835655],
              [54.8124643, 37.6834299],
              [54.8120852, 37.6833839],
              [54.8116643, 37.6833274],
              [54.8113256, 37.6833049],
              [54.8111071, 37.6833252],
              [54.810562, 37.6833434],
              [54.8101195, 37.6833284],
              [54.8097404, 37.6832056],
              [54.8095286, 37.6831992],
              [54.8093694, 37.6832355],
              [54.8091778, 37.6833348],
              [54.8089808, 37.6835046],
              [54.8087987, 37.6836199],
              [54.8085033, 37.6838879],
              [54.8082253, 37.6840812],
              [54.8080742, 37.6841303],
              [54.8079703, 37.6841207],
              [54.8079015, 37.6840801],
              [54.8078557, 37.6840085],
              [54.8078327, 37.6839359],
              [54.8078368, 37.6838505],
              [54.8078826, 37.6837299],
              [54.8079717, 37.6836242],
              [54.8081228, 37.6834704],
              [54.8081606, 37.6833519],
              [54.8081943, 37.6831469],
              [54.808224, 37.6829462],
              [54.8082901, 37.6827593],
              [54.8083157, 37.6825543],
              [54.8082699, 37.6824337],
              [54.8081187, 37.6823237],
              [54.8079622, 37.6822981],
              [54.8076762, 37.6822767],
              [54.8075386, 37.6822329],
              [54.8074752, 37.6821828],
              [54.8074577, 37.6821166],
              [54.8074698, 37.6820504],
              [54.80754, 37.6819874],
              [54.8077113, 37.6819265],
              [54.8079555, 37.6818582],
              [54.8082334, 37.6818123],
              [54.8085788, 37.6817909],
              [54.808796, 37.6817535],
              [54.8089889, 37.6816649],
              [54.8091711, 37.6815144],
              [54.8092655, 37.6813681],
              [54.80931, 37.6811834],
              [54.8093006, 37.6810307],
              [54.8092372, 37.6808417],
              [54.8090793, 37.6806591],
              [54.8087974, 37.6804733],
              [54.8085151, 37.6803731],
              [54.8082466, 37.6803015],
              [54.8078959, 37.6801595],
              [54.8075707, 37.6800655],
              [54.8074223, 37.6800399],
              [54.8071511, 37.6800495],
              [54.8068287, 37.6799865],
              [54.8066182, 37.6799139],
              [54.8062418, 37.6799075],
              [54.8059234, 37.6799064],
              [54.805717, 37.6798563],
              [54.8054769, 37.679742],
              [54.8052354, 37.6795498],
              [54.8050573, 37.6793779],
              [54.8048306, 37.679143],
              [54.80455, 37.6789252],
              [54.8042478, 37.6787127],
              [54.8041817, 37.6786283],
              [54.8041277, 37.6785087],
              [54.8040306, 37.6782738],
              [54.8038862, 37.677945],
              [54.8037446, 37.6775798],
              [54.8036231, 37.6772349],
              [54.8034626, 37.6770811],
              [54.8033466, 37.6770384],
              [54.8030835, 37.6769797],
              [54.8026882, 37.6769434],
              [54.8023091, 37.6769252],
              [54.801849, 37.6769177],
              [54.8014956, 37.6769113],
              [54.8010503, 37.6768601],
              [54.8006213, 37.6768152],
              [54.8002557, 37.6767907],
              [54.7999548, 37.6767714],
              [54.7997579, 37.6767202],
              [54.7997026, 37.6766647],
              [54.799685, 37.6765547],
              [54.799739, 37.6763689],
              [54.7998645, 37.6761959],
              [54.800141, 37.6760464],
              [54.8004446, 37.6758948],
              [54.8005781, 37.6757666],
              [54.8007616, 37.6755008],
              [54.8009019, 37.6753918],
              [54.8012136, 37.6752445],
              [54.8014672, 37.6750886],
              [54.8018409, 37.6748942],
              [54.8020204, 37.6747458],
              [54.8020824, 37.6745878],
              [54.8021782, 37.6742941],
              [54.8022713, 37.6739278],
              [54.8022794, 37.6736822],
              [54.8022619, 37.673301],
              [54.802305, 37.673096],
              [54.8023792, 37.6730009],
              [54.8025479, 37.6729678],
              [54.8026855, 37.6729956],
              [54.8029971, 37.6730938],
              [54.8030943, 37.6731003],
              [54.8032197, 37.6730672],
              [54.8033155, 37.6730106],
              [54.8034059, 37.6728504],
              [54.8034289, 37.6727233],
              [54.8033614, 37.6725631],
              [54.8032009, 37.6724211],
              [54.8028865, 37.6722663],
              [54.8027017, 37.6722449],
              [54.8024548, 37.6722876],
              [54.8021809, 37.6724115],
              [54.8019462, 37.6725802],
              [54.8016966, 37.6727703],
              [54.8014848, 37.6728803],
              [54.8013539, 37.6728952],
              [54.8011097, 37.6728685],
              [54.8007036, 37.6727543],
              [54.8003569, 37.6726208],
              [54.8000358, 37.6724563],
              [54.7997956, 37.6723677],
              [54.7996891, 37.6723784],
              [54.7995461, 37.6724328],
              [54.7994624, 37.6725119],
              [54.7993855, 37.6726496],
              [54.7993127, 37.6728781],
              [54.799202, 37.6730629],
              [54.7991346, 37.6731152],
              [54.7989241, 37.6731611],
              [54.7986273, 37.6732252],
              [54.7983534, 37.673316],
              [54.7980364, 37.673443],
              [54.7979136, 37.673443],
              [54.7977773, 37.6733939],
              [54.7977328, 37.6733234],
              [54.7977531, 37.6731996],
              [54.7978232, 37.672971],
              [54.7979662, 37.6726945],
              [54.7980634, 37.6724542],
              [54.798116, 37.6721616],
              [54.7981929, 37.6719907],
              [54.7983264, 37.6718007],
              [54.7986327, 37.671492],
              [54.7989093, 37.6712315],
              [54.7991251, 37.6710211],
              [54.7992546, 37.6708257],
              [54.7995177, 37.6705448],
              [54.7997875, 37.6703163],
              [54.7999616, 37.6701583],
              [54.8000412, 37.6700461],
              [54.8000439, 37.6699169],
              [54.8000493, 37.6696873],
              [54.8001019, 37.669509],
              [54.800226, 37.6693499],
              [54.800338, 37.6693029],
              [54.8004743, 37.6693103],
              [54.8005539, 37.6693509],
              [54.800651, 37.6694257],
              [54.8008682, 37.6695143],
              [54.8009991, 37.6695378],
              [54.8011556, 37.6695004],
              [54.8012514, 37.6694267],
              [54.801281, 37.6692911],
              [54.8013222, 37.6691924],
              [54.8013862, 37.6691124],
              [54.8013833, 37.6690641],
              [54.8013375, 37.6689863],
              [54.8013308, 37.6688179],
              [54.8012879, 37.6687227],
              [54.8012354, 37.6686412],
              [54.8011657, 37.668318],
              [54.8010928, 37.6681984],
              [54.8009485, 37.6679144],
              [54.8008743, 37.6678012],
              [54.8008311, 37.6676453],
              [54.8007879, 37.6675694],
              [54.8008054, 37.6674658],
              [54.8008985, 37.6673783],
              [54.8011036, 37.6673195],
              [54.8012776, 37.6673217],
              [54.8014207, 37.6673505],
              [54.8015758, 37.6674349],
              [54.8017202, 37.6674851],
              [54.8019171, 37.6675822],
              [54.802245, 37.6676527],
              [54.8025148, 37.6676666],
              [54.8028116, 37.6676538],
              [54.8031813, 37.6675684],
              [54.8032541, 37.6675203],
              [54.8033364, 37.667469],
              [54.8033756, 37.6673879],
              [54.803354, 37.667249],
              [54.8032217, 37.6669233],
              [54.8030841, 37.6665869],
              [54.8029344, 37.6662687],
              [54.8027738, 37.6661042],
              [54.8024973, 37.6659291],
              [54.8023731, 37.6657935],
              [54.8023002, 37.6656536],
              [54.8022908, 37.6655276],
              [54.8023191, 37.6652713],
              [54.8023947, 37.6650619],
              [54.8024614, 37.6648022],
              [54.8024958, 37.6645016],
              [54.8023987, 37.664209],
              [54.8022957, 37.66391],
              [54.8023057, 37.6637912],
              [54.8023569, 37.663725],
              [54.8024797, 37.6636695],
              [54.8026578, 37.6636567],
              [54.8028049, 37.6636022],
              [54.8028764, 37.6635477],
              [54.8029168, 37.6634933],
              [54.8028993, 37.6633202],
              [54.8028622, 37.6630885],
              [54.8028111, 37.6626997],
              [54.8028287, 37.6626185],
              [54.802973, 37.6625064],
              [54.8032172, 37.6623088],
              [54.8033535, 37.6620856],
              [54.8035801, 37.661731],
              [54.8037596, 37.6615046],
              [54.8039565, 37.6613839],
              [54.8043073, 37.6612376],
              [54.8046608, 37.6610881],
              [54.8047269, 37.6610325],
              [54.8047525, 37.6609439],
              [54.8047512, 37.6607869],
              [54.8047107, 37.6606395],
              [54.8044759, 37.6603874],
              [54.8042628, 37.6602465],
              [54.8038891, 37.6600563],
              [54.8036341, 37.6599506],
              [54.8034938, 37.6599346],
              [54.8033238, 37.6599709],
              [54.8031848, 37.6600147],
              [54.803085, 37.6600927],
              [54.8028988, 37.6601834],
              [54.8027545, 37.6601909],
              [54.8026425, 37.6602646],
              [54.8025264, 37.6603693],
              [54.802235, 37.6604846],
              [54.8019908, 37.6605562],
              [54.8017655, 37.6605775],
              [54.8015429, 37.6605605],
              [54.8011571, 37.660459],
              [54.8007011, 37.6602764],
              [54.8004016, 37.6601845],
              [54.7999833, 37.6601097],
              [54.799646, 37.6600232],
              [54.7995651, 37.6599794],
              [54.7995273, 37.6599271],
              [54.7995314, 37.6598],
              [54.7995853, 37.659548],
              [54.7996083, 37.6594508],
              [54.7995894, 37.6593397],
              [54.7995718, 37.6591688],
              [54.7995341, 37.6590321],
              [54.7994099, 37.6588003],
              [54.799325, 37.6587544],
              [54.7991981, 37.6586198],
              [54.7990254, 37.658497],
              [54.7988716, 37.6584532],
              [54.7986477, 37.658513],
              [54.798305, 37.6585846],
              [54.7980109, 37.6586102],
              [54.7978018, 37.6585878],
              [54.797509, 37.6584863],
              [54.7971717, 37.6583293],
              [54.797022, 37.6582246],
              [54.7969923, 37.6581157],
              [54.7970071, 37.6580228],
              [54.7970989, 37.657932],
              [54.7972608, 37.6577942],
              [54.797478, 37.6576756],
              [54.7975724, 37.6575998],
              [54.7976156, 37.6574909],
              [54.7976008, 37.6574011],
              [54.7974888, 37.6573029],
              [54.7972608, 37.6572463],
              [54.7969788, 37.657132],
              [54.7966753, 37.6570156],
              [54.7963177, 37.6568906],
              [54.7959872, 37.6567945],
              [54.7956513, 37.6567913],
              [54.7952546, 37.6567699],
              [54.795032, 37.6567347],
              [54.794916, 37.6566919],
              [54.7948526, 37.6566225],
              [54.7947946, 37.6564142],
              [54.7947001, 37.6561493],
              [54.7946232, 37.6558674],
              [54.7945018, 37.6556324],
              [54.7943898, 37.655501],
              [54.7943615, 37.6553931],
              [54.7943547, 37.6552639],
              [54.7943993, 37.6551357],
              [54.7945706, 37.654921],
              [54.7946623, 37.6546689],
              [54.7946704, 37.654497],
              [54.7945962, 37.6542225],
              [54.7944654, 37.6538796],
              [54.7942967, 37.6536297],
              [54.7941308, 37.6535698],
              [54.7940121, 37.6535634],
              [54.793865, 37.6535827],
              [54.7936599, 37.6536702],
              [54.79344, 37.653808],
              [54.7930528, 37.6540195],
              [54.7925887, 37.6542139],
              [54.792161, 37.6544521],
              [54.7918116, 37.6546412],
              [54.7916956, 37.6546486],
              [54.7915445, 37.6546348],
              [54.7914635, 37.6545643],
              [54.7914352, 37.6544607],
              [54.7914231, 37.6543368],
              [54.7914541, 37.654215],
              [54.7915674, 37.6540922],
              [54.7917819, 37.6538924],
              [54.7919169, 37.6537536],
              [54.791983, 37.6536062],
              [54.7920464, 37.6533316],
              [54.7920909, 37.6530486],
              [54.7922083, 37.6528531],
              [54.7924093, 37.6527089],
              [54.7927101, 37.652569],
              [54.7931715, 37.652381],
              [54.7935979, 37.6522037],
              [54.7941227, 37.6520883],
              [54.7943858, 37.6519655],
              [54.7944816, 37.6518597],
              [54.7945045, 37.6517123],
              [54.7944532, 37.6515126],
              [54.7943048, 37.6513054],
              [54.7942131, 37.6511088],
              [54.7941955, 37.6509999],
              [54.7942104, 37.6509197],
              [54.7942981, 37.6508225],
              [54.794522, 37.650689],
              [54.7948755, 37.6505053],
              [54.795005, 37.6504113],
              [54.7950738, 37.6503141],
              [54.7950954, 37.6501742],
              [54.7950806, 37.6499253],
              [54.794978, 37.6496839],
              [54.7948742, 37.6495952],
              [54.7946542, 37.6495311],
              [54.7942994, 37.6494798],
              [54.793869, 37.649388],
              [54.7935493, 37.6493111],
              [54.7931823, 37.6492277],
              [54.7929584, 37.6491188],
              [54.7926508, 37.648919],
              [54.7923459, 37.6487524],
              [54.7921476, 37.6487011],
              [54.7919344, 37.6486872],
              [54.7918062, 37.6487033],
              [54.7916619, 37.6487545],
              [54.7915512, 37.6488378],
              [54.7914946, 37.6489457],
              [54.7913516, 37.6492042],
              [54.7912315, 37.6494659],
              [54.791187, 37.6496272],
              [54.7912045, 37.6498975],
              [54.7912976, 37.6500225],
              [54.7914163, 37.6501507],
              [54.7915175, 37.6503333],
              [54.7915755, 37.6505245],
              [54.7916254, 37.6507948],
              [54.7916362, 37.6510052],
              [54.7916025, 37.65119],
              [54.7915404, 37.6512829],
              [54.7914541, 37.651347],
              [54.7913111, 37.6513769],
              [54.7911654, 37.6513748],
              [54.7909037, 37.6513246],
              [54.7907998, 37.651268],
              [54.7906352, 37.6510992],
              [54.7904004, 37.6509059],
              [54.7901225, 37.6506452],
              [54.7898311, 37.6504337],
              [54.7895248, 37.6502543],
              [54.7891849, 37.6500577],
              [54.7888759, 37.6499167],
              [54.7887032, 37.6497747],
              [54.7885494, 37.6495728],
              [54.7884455, 37.6494072],
              [54.7884104, 37.6492758],
              [54.7883929, 37.648981],
              [54.7883875, 37.6486798],
              [54.7883821, 37.6483411],
              [54.7883214, 37.6478797],
              [54.7883228, 37.6476895],
              [54.7883821, 37.6474331],
              [54.7885049, 37.6472932],
              [54.788714, 37.6471298],
              [54.7889879, 37.6469984],
              [54.7893427, 37.6468552],
              [54.7896557, 37.6467805],
              [54.7900766, 37.6468008],
              [54.7906055, 37.6468574],
              [54.790905, 37.646883],
              [54.7910467, 37.6468563],
              [54.7912166, 37.6467676],
              [54.7913003, 37.6466544],
              [54.7913057, 37.6465252],
              [54.7912639, 37.6463478],
              [54.7911101, 37.6461513],
              [54.790851, 37.6459536],
              [54.7905556, 37.6458383],
              [54.7901927, 37.6457592],
              [54.7898662, 37.6457229],
              [54.7894682, 37.6456759],
              [54.789166, 37.6456161],
              [54.7891026, 37.6455637],
              [54.7890676, 37.6454439],
              [54.7890648, 37.6453608],
              [54.7890924, 37.645243],
              [54.7892098, 37.6450277],
              [54.7892546, 37.6449114],
              [54.7892492, 37.6447127],
              [54.7891901, 37.6446151],
              [54.7890651, 37.6445433],
              [54.7888362, 37.6445124],
              [54.7886249, 37.6445394],
              [54.7884528, 37.6445917],
              [54.7882896, 37.6446654],
              [54.7881412, 37.6448097],
              [54.7879645, 37.6450019],
              [54.7878525, 37.6451536],
              [54.7876596, 37.6455307],
              [54.7875284, 37.6456826],
              [54.7874101, 37.64574],
              [54.7872784, 37.6457551],
              [54.7871687, 37.6457294],
              [54.787101, 37.6456667],
              [54.7870352, 37.6455648],
              [54.787018, 37.6454341],
              [54.7869951, 37.645215],
              [54.7869102, 37.6449257],
              [54.7868396, 37.6447913],
              [54.786686, 37.644619],
              [54.7864828, 37.6444582],
              [54.786312, 37.6443078],
              [54.7861766, 37.6441696],
              [54.7860287, 37.6440631],
              [54.7859619, 37.6439717],
              [54.7859495, 37.6438946],
              [54.7859705, 37.6438131],
              [54.7860793, 37.6436673],
              [54.7862061, 37.6435358],
              [54.7863378, 37.6434867],
              [54.7864294, 37.6434701],
              [54.7866364, 37.6434739],
              [54.7868949, 37.643495],
              [54.7870409, 37.6434973],
              [54.7872116, 37.6434505],
              [54.7873194, 37.643384],
              [54.7873939, 37.6432745],
              [54.7874034, 37.6431702],
              [54.7874005, 37.6429731],
              [54.7872861, 37.6427238],
              [54.7871859, 37.6424481],
              [54.7870953, 37.6422116],
              [54.7870399, 37.6420152],
              [54.7870247, 37.641914],
              [54.7870361, 37.6417826],
              [54.7870895, 37.6415914],
              [54.7871849, 37.6414592],
              [54.7873853, 37.6413255],
              [54.7876362, 37.6411503],
              [54.7878422, 37.6409901],
              [54.7879233, 37.6409252],
              [54.7879701, 37.6408164],
              [54.7879853, 37.6407038],
              [54.7879577, 37.6405558],
              [54.7878871, 37.6404477],
              [54.7877783, 37.6403918],
              [54.7875999, 37.6403684],
              [54.7872994, 37.6403737],
              [54.7870762, 37.640348],
              [54.786467, 37.6402264],
              [54.7859368, 37.6401452],
              [54.7854511, 37.6400405],
              [54.7850741, 37.639918],
              [54.7849978, 37.6398575],
              [54.7849453, 37.6397744],
              [54.7849319, 37.6396966],
              [54.784951, 37.6396317],
              [54.7850378, 37.6395047],
              [54.7851533, 37.6394269],
              [54.7853269, 37.6392728],
              [54.785594, 37.6391202],
              [54.7858478, 37.639022],
              [54.7861883, 37.6389042],
              [54.7865623, 37.6387962],
              [54.7868103, 37.638735],
              [54.7870746, 37.6386473],
              [54.7873045, 37.6386065],
              [54.7875592, 37.638599],
              [54.7877347, 37.6386315],
              [54.7879732, 37.6386322],
              [54.7881507, 37.6386065],
              [54.7883071, 37.6385272],
              [54.7883777, 37.6384388],
              [54.788414, 37.6382938],
              [54.7884359, 37.6380838],
              [54.7884207, 37.6378715],
              [54.7882911, 37.6377038],
              [54.7880416, 37.6375392],
              [54.7877194, 37.6373151],
              [54.7875153, 37.6371504],
              [54.7872587, 37.6369736],
              [54.7870707, 37.636886],
              [54.7869171, 37.636852],
              [54.7866977, 37.6368626],
              [54.7865184, 37.6369185],
              [54.786215, 37.6370801],
              [54.7859526, 37.6372184],
              [54.7857132, 37.6372841],
              [54.7854499, 37.6373166],
              [54.7852858, 37.6373158],
              [54.7851608, 37.6372698],
              [54.7850578, 37.6371655],
              [54.7849557, 37.6369585],
              [54.7849195, 37.636787],
              [54.7848813, 37.6365385],
              [54.7848355, 37.6362839],
              [54.7846615, 37.6358544],
              [54.7845131, 37.6357005],
              [54.7841461, 37.635458],
              [54.7840153, 37.6353576],
              [54.7837846, 37.6351845],
              [54.7834621, 37.6349463],
              [54.7830857, 37.6347401],
              [54.782874, 37.6345801],
              [54.7827882, 37.6344555],
              [54.7827548, 37.6343399],
              [54.7827174, 37.6340436],
              [54.7827147, 37.6337188],
              [54.782766, 37.6334934],
              [54.7828887, 37.6333951],
              [54.7831343, 37.633284],
              [54.7833097, 37.6332049],
              [54.7834284, 37.6331782],
              [54.7836523, 37.63319],
              [54.7838534, 37.6332669],
              [54.7840679, 37.6333502],
              [54.7843134, 37.633393],
              [54.7845684, 37.6334015],
              [54.7848058, 37.6333609],
              [54.7849016, 37.6332957],
              [54.7849475, 37.6331964],
              [54.7849124, 37.6328908],
              [54.7848958, 37.6326107],
              [54.7848988, 37.6324438],
              [54.784966, 37.6322647],
              [54.7850996, 37.6320941],
              [54.7853083, 37.6319864],
              [54.7855405, 37.6319429],
              [54.7857941, 37.6319646],
              [54.7861424, 37.6320276],
              [54.7864113, 37.6320856],
              [54.7866099, 37.6321002],
              [54.7867505, 37.6320832],
              [54.7869308, 37.6320276],
              [54.7871574, 37.6317963],
              [54.7867384, 37.631387],
              [54.7864656, 37.6311063],
              [54.7862887, 37.6309063],
              [54.7861809, 37.6307605],
              [54.7861383, 37.6306603],
              [54.786175, 37.6305418],
              [54.7864592, 37.6303377],
              [54.7867189, 37.6302223],
              [54.7871039, 37.6301522],
              [54.7872903, 37.6300844],
              [54.7877525, 37.6298503],
              [54.7889751, 37.6278814],
              [54.7883832, 37.6276031],
              [54.7874372, 37.6278118],
              [54.7871956, 37.6277698],
              [54.7880962, 37.6262098],
              [54.7888087, 37.6260146],
              [54.7890018, 37.6254197],
              [54.7893695, 37.6246523],
              [54.7893721, 37.6244068],
              [54.7876529, 37.6237272],
              [54.7868383, 37.6230244],
              [54.7869625, 37.621994],
              [54.7871539, 37.6217855],
              [54.7876474, 37.621692],
              [54.7882967, 37.6219518],
              [54.788789, 37.6221421],
              [54.7892781, 37.6221999],
              [54.7896087, 37.6220711],
              [54.7897255, 37.6214779],
              [54.7900971, 37.6208512],
              [54.7898002, 37.6204137],
              [54.7890444, 37.620413],
              [54.7889245, 37.6202761],
              [54.7893856, 37.6186714],
              [54.7896701, 37.618565],
              [54.7904334, 37.6185406],
              [54.7912663, 37.6181399],
              [54.7914896, 37.6181226],
              [54.7919237, 37.6186797],
              [54.7923584, 37.6189491],
              [54.7928012, 37.6188838],
              [54.7932561, 37.6182766],
              [54.7937845, 37.6178912],
              [54.7947137, 37.6178599],
              [54.7950648, 37.6175058],
              [54.7948333, 37.6169197],
              [54.7950973, 37.616726],
              [54.7959804, 37.6165194],
              [54.7968345, 37.6159329],
              [54.7968913, 37.6150216],
              [54.7971733, 37.6144321],
              [54.797555, 37.6142383],
              [54.7979084, 37.6142463],
              [54.7983592, 37.6147717],
              [54.8001264, 37.6160606],
              [54.8007365, 37.6153098],
              [54.8021892, 37.615266],
              [54.8031034, 37.6149139],
              [54.804084, 37.6142958],
              [54.8055281, 37.6142746],
              [54.8076713, 37.6139131],
              [54.8101965, 37.6135035],
              [54.8110786, 37.6125735],
              [54.8127063, 37.612366],
              [54.812963, 37.6117903],
              [54.812704, 37.6100055],
              [54.8129248, 37.6087765],
              [54.8136546, 37.6083852],
              [54.8137321, 37.6083436],
              [54.8151658, 37.6079309],
              [54.8159685, 37.6070307],
              [54.8167764, 37.6048279],
              [54.8168046, 37.6013276],
              [54.8190261, 37.6002549],
              [54.8183857, 37.598404],
              [54.8170222, 37.5959703],
              [54.8167633, 37.5942852],
              [54.8171423, 37.5930715],
              [54.8160294, 37.5903124],
              [54.814243, 37.5896108],
              [54.8121358, 37.585699],
              [54.8109679, 37.5849522],
              [54.8101923, 37.5834813],
              [54.8093726, 37.576348],
              [54.8090007, 37.5759831],
              [54.8090411, 37.574928],
              [54.8105229, 37.5731792],
              [54.8098895, 37.5717198],
              [54.8099105, 37.5705603],
              [54.8085215, 37.5702325],
              [54.8079692, 37.5695909],
              [54.8085582, 37.5674694],
              [54.8084275, 37.5665882],
              [54.8069275, 37.5664153],
              [54.8065061, 37.5654926],
              [54.8033921, 37.5654119],
              [54.8031233, 37.5651399],
              [54.80239, 37.5623676],
              [54.8029714, 37.5609594],
              [54.8053905, 37.5614471],
              [54.8060931, 37.5634241],
              [54.8074944, 37.5619653],
              [54.8078242, 37.5607602],
              [54.8067764, 37.5602502],
              [54.8049888, 37.5604764],
              [54.8041238, 37.5599727],
              [54.8044484, 37.559503],
              [54.8051172, 37.5590408],
              [54.8061531, 37.5581021],
              [54.8064318, 37.5561958],
              [54.8040357, 37.5550571],
              [54.8040436, 37.5546136],
              [54.8049025, 37.5543044],
              [54.8035463, 37.5518841],
              [54.8035328, 37.5506004],
              [54.8029627, 37.550399],
              [54.8022807, 37.5511144],
              [54.8001715, 37.5516419],
              [54.7996639, 37.5501229],
              [54.7991971, 37.5498901],
              [54.7978775, 37.5509522],
              [54.7970718, 37.5513025],
              [54.796528, 37.5501085],
              [54.7965233, 37.5498405],
              [54.7977342, 37.5484633],
              [54.7993949, 37.5475836],
              [54.7964496, 37.5462751],
              [54.7964388, 37.5457489],
              [54.798552, 37.5442571],
              [54.798599, 37.5437435],
              [54.7965427, 37.5435383],
              [54.7965308, 37.5426172],
              [54.7982526, 37.5411696],
              [54.7980053, 37.5385113],
              [54.7976807, 37.5361679],
              [54.7983946, 37.535595],
              [54.7982744, 37.5350136],
              [54.7991551, 37.5345115],
              [54.7995544, 37.5337625],
              [54.7987309, 37.5316494],
              [54.7994145, 37.5313458],
              [54.7998962, 37.5307598],
              [54.7996037, 37.5298588],
              [54.7973981, 37.5285076],
              [54.7981074, 37.526607],
              [54.7999263, 37.5267807],
              [54.8000678, 37.5262037],
              [54.7985416, 37.5242277],
              [54.7990254, 37.5229165],
              [54.7985684, 37.5220193],
              [54.7968818, 37.521673],
              [54.7953701, 37.5226715],
              [54.7945967, 37.5225463],
              [54.7932371, 37.5211325],
              [54.7858556, 37.5193774],
              [54.7843485, 37.5199032],
              [54.782604, 37.5173542],
              [54.782206, 37.5183312],
              [54.7808225, 37.5190434],
              [54.7805239, 37.5190594],
              [54.7801229, 37.5173781],
              [54.7791313, 37.5157539],
              [54.7759934, 37.5154468],
              [54.77564, 37.5148184],
              [54.7752033, 37.5146276],
              [54.7739329, 37.5157188],
              [54.7736736, 37.5158015],
              [54.7733827, 37.5155675],
              [54.7734911, 37.5144787],
              [54.7744881, 37.5136061],
              [54.7745615, 37.513012],
              [54.7742292, 37.5128733],
              [54.7721684, 37.5132062],
              [54.7720165, 37.5125172],
              [54.7707021, 37.5117726],
              [54.7698284, 37.5108213],
              [54.7698521, 37.5102189],
              [54.7710214, 37.5093577],
              [54.7724561, 37.5097354],
              [54.7743941, 37.5096644],
              [54.7745072, 37.5095206],
              [54.7717161, 37.5070842],
              [54.7709205, 37.5068959],
              [54.7695379, 37.506285],
              [54.7695373, 37.5059346],
              [54.7702078, 37.505087],
              [54.771017, 37.5046197],
              [54.7710459, 37.5043454],
              [54.7702163, 37.5041333],
              [54.7706309, 37.5036686],
              [54.7715724, 37.5031222],
              [54.7715529, 37.5028432],
              [54.7709418, 37.5025281],
              [54.7705365, 37.5023274],
              [54.7705512, 37.5010754],
              [54.7705652, 37.5005878],
              [54.7705053, 37.5001137],
              [54.7700233, 37.4996228],
              [54.769854, 37.4991785],
              [54.7700299, 37.4984861],
              [54.7700624, 37.4979848],
              [54.7696912, 37.4976128],
              [54.7691831, 37.4976806],
              [54.7680941, 37.4977272],
              [54.766402, 37.4980475],
              [54.7660308, 37.4983213],
              [54.7662978, 37.4989466],
              [54.7664997, 37.4995511],
              [54.7662132, 37.4999025],
              [54.7660012, 37.5000948],
              [54.7645707, 37.5003971],
              [54.7635604, 37.4997952],
              [54.763565, 37.4994079],
              [54.7639262, 37.4983228],
              [54.763917, 37.4974752],
              [54.7636039, 37.4970586],
              [54.7627501, 37.4969032],
              [54.761817, 37.4968102],
              [54.7611814, 37.4970586],
              [54.7596794, 37.49778],
              [54.7587814, 37.4981965],
              [54.7584238, 37.4982235],
              [54.7583208, 37.4981783],
              [54.7579291, 37.4980836],
              [54.7575794, 37.4977289],
              [54.7572938, 37.4974206],
              [54.7572662, 37.4971698],
              [54.7575702, 37.4966217],
              [54.7577197, 37.4961041],
              [54.7580605, 37.4955341],
              [54.7578824, 37.4947706],
              [54.7578639, 37.4943248],
              [54.7581495, 37.4938133],
              [54.7580666, 37.4932944],
              [54.7578639, 37.4928047],
              [54.7575968, 37.4925563],
              [54.7573481, 37.4924539],
              [54.7569981, 37.4924466],
              [54.7565929, 37.492644],
              [54.7561747, 37.4930782],
              [54.7558814, 37.4936815],
              [54.7556626, 37.4941933],
              [54.7554139, 37.4942371],
              [54.7551468, 37.4941056],
              [54.7546634, 37.4940122],
              [54.7543638, 37.4938623],
              [54.7540838, 37.4935006],
              [54.7538428, 37.4930665],
              [54.7535888, 37.4927771],
              [54.7532114, 37.4925225],
              [54.7525518, 37.492252],
              [54.7520437, 37.4921332],
              [54.7514836, 37.492035],
              [54.751423, 37.4919543],
              [54.7514641, 37.4917094],
              [54.7513849, 37.4915582],
              [54.7512491, 37.4914717],
              [54.7506458, 37.4914344],
              [54.7500182, 37.4913477],
              [54.7496339, 37.4916009],
              [54.7492366, 37.4918593],
              [54.7485853, 37.4921073],
              [54.7481945, 37.4925311],
              [54.7477517, 37.4925621],
              [54.7471394, 37.4923244],
              [54.7466359, 37.4919905],
              [54.74647, 37.4917952],
              [54.7463318, 37.4914225],
              [54.7461937, 37.4912654],
              [54.7458253, 37.4912398],
              [54.7453141, 37.4913238],
              [54.744614, 37.4915321],
              [54.7438726, 37.4917915],
              [54.7434627, 37.4922008],
              [54.7432622, 37.4925848],
              [54.743075, 37.4930732],
              [54.7428424, 37.4932526],
              [54.7422133, 37.4933507],
              [54.7414797, 37.4935181],
              [54.7410929, 37.4935181],
              [54.7406231, 37.493509],
              [54.7403767, 37.4934487],
              [54.7401852, 37.4932513],
              [54.740076, 37.4930558],
              [54.7401635, 37.4926667],
              [54.740293, 37.4923828],
              [54.740445, 37.4921727],
              [54.7404283, 37.4918463],
              [54.740251, 37.4917312],
              [54.7399163, 37.4916355],
              [54.7384578, 37.4916129],
              [54.7375567, 37.49157],
              [54.736953, 37.4916057],
              [54.7362534, 37.4918441],
              [54.7358392, 37.4920514],
              [54.735304, 37.4922385],
              [54.7349599, 37.492193],
              [54.7345139, 37.4919857],
              [54.7341443, 37.4918492],
              [54.7339103, 37.491944],
              [54.7335645, 37.4922738],
              [54.7333288, 37.4924912],
              [54.7328764, 37.4927642],
              [54.732647, 37.4927238],
              [54.7325705, 37.4925165],
              [54.7326088, 37.492284],
              [54.7326534, 37.4919705],
              [54.7326406, 37.491647],
              [54.7324176, 37.4915155],
              [54.7321245, 37.4914852],
              [54.7315511, 37.4915458],
              [54.7308757, 37.4915964],
              [54.7304233, 37.4915357],
              [54.7300027, 37.4913891],
              [54.7297479, 37.4912021],
              [54.7296077, 37.4910049],
              [54.7294739, 37.490651],
              [54.7293528, 37.4902516],
              [54.7291298, 37.4898522],
              [54.7288048, 37.4896702],
              [54.7286034, 37.4895302],
              [54.7286047, 37.4894153],
              [54.7289488, 37.4891828],
              [54.729535, 37.4890867],
              [54.7301849, 37.4891625],
              [54.7305162, 37.4893698],
              [54.7310274, 37.4896232],
              [54.7317122, 37.4895088],
              [54.7321898, 37.4893801],
              [54.7328206, 37.4894015],
              [54.7332261, 37.4892657],
              [54.7334243, 37.489137],
              [54.7332396, 37.4886365],
              [54.733181, 37.4885185],
              [54.7329017, 37.4884005],
              [54.7326043, 37.4882075],
              [54.7321988, 37.4881002],
              [54.7316582, 37.4880216],
              [54.7310094, 37.4880144],
              [54.7303876, 37.4880931],
              [54.7297478, 37.4881574],
              [54.7293089, 37.4880568],
              [54.7289881, 37.4878453],
              [54.7284671, 37.4878002],
              [54.7276478, 37.4877498],
              [54.7273944, 37.4875319],
              [54.7275601, 37.4871931],
              [54.7278978, 37.486819],
              [54.7285031, 37.4864752],
              [54.7288599, 37.4862932],
              [54.7290256, 37.4861617],
              [54.7290383, 37.4860303],
              [54.7288917, 37.4858533],
              [54.7284266, 37.48556],
              [54.7280583, 37.4852033],
              [54.7276238, 37.4849685],
              [54.7272224, 37.4847511],
              [54.7269802, 37.4845033],
              [54.7258015, 37.4830927],
              [54.7254574, 37.4826275],
              [54.7253491, 37.4822483],
              [54.7251579, 37.4820208],
              [54.7247246, 37.4817629],
              [54.7243551, 37.481505],
              [54.7238517, 37.4813786],
              [54.7233352, 37.4812611],
              [54.7233118, 37.4810644],
              [54.7235613, 37.4808688],
              [54.7237326, 37.480522],
              [54.723701, 37.4801823],
              [54.7235073, 37.4799213],
              [54.7232415, 37.4795852],
              [54.7231378, 37.4793886],
              [54.7231153, 37.4791419],
              [54.7230297, 37.4789381],
              [54.7228855, 37.478745],
              [54.7226783, 37.4786699],
              [54.72248, 37.4787164],
              [54.7221782, 37.4789238],
              [54.72182, 37.4793196],
              [54.7214186, 37.4798581],
              [54.7211542, 37.4799162],
              [54.7208907, 37.4797833],
              [54.7206864, 37.4795781],
              [54.7205854, 37.4794458],
              [54.7205325, 37.4792044],
              [54.720543, 37.4788874],
              [54.7206271, 37.4786277],
              [54.7211553, 37.4778888],
              [54.7211975, 37.4776804],
              [54.7212224, 37.4775542],
              [54.7211394, 37.4774236],
              [54.7209046, 37.4771913],
              [54.7204433, 37.4768475],
              [54.7200039, 37.476662],
              [54.7193047, 37.4765853],
              [54.7188185, 37.4765878],
              [54.7186124, 37.4765129],
              [54.7184841, 37.4763833],
              [54.7183594, 37.4762423],
              [54.7183313, 37.4758664],
              [54.718432, 37.4753964],
              [54.7185146, 37.4750921],
              [54.7186865, 37.4749801],
              [54.7187923, 37.4749347],
              [54.7188408, 37.4748227],
              [54.7187218, 37.4747073],
              [54.7184882, 37.4746443],
              [54.7181444, 37.4746128],
              [54.7177745, 37.4747615],
              [54.7174042, 37.4749259],
              [54.7169635, 37.4749924],
              [54.7166814, 37.4749189],
              [54.7164213, 37.4746846],
              [54.7162406, 37.4743627],
              [54.7162847, 37.4741074],
              [54.7164257, 37.473817],
              [54.7166152, 37.4735966],
              [54.7169106, 37.4731699],
              [54.7172235, 37.472918],
              [54.7175717, 37.4727536],
              [54.7181624, 37.4725682],
              [54.718277, 37.4724072],
              [54.7182241, 37.4722078],
              [54.717985, 37.4720554],
              [54.7175869, 37.471812],
              [54.7170531, 37.4713569],
              [54.7169908, 37.4709908],
              [54.7171162, 37.4707216],
              [54.7169972, 37.4704102],
              [54.7164699, 37.4701398],
              [54.7158709, 37.4694735],
              [54.7151292, 37.4686595],
              [54.7136139, 37.4672436],
              [54.7135506, 37.4669154],
              [54.7128588, 37.4664969],
              [54.7124327, 37.4661152],
              [54.7119527, 37.4658776],
              [54.7104051, 37.4644856],
              [54.7100322, 37.4639908],
              [54.709543, 37.4635125],
              [54.7089911, 37.4628969],
              [54.708663, 37.4627454],
              [54.7081301, 37.4619928],
              [54.7071148, 37.4590428],
              [54.7064273, 37.4579153],
              [54.7050982, 37.4567113],
              [54.7043433, 37.455685],
              [54.7036514, 37.4551157],
              [54.7025461, 37.4545464],
              [54.7007996, 37.4533407],
              [54.7002317, 37.4524898],
              [54.6992771, 37.4516988],
              [54.6978095, 37.4502827],
              [54.696497, 37.4496101],
              [54.6956735, 37.4494806],
              [54.6913882, 37.4481831],
              [54.687676, 37.4468581],
              [54.6866326, 37.4461489],
              [54.6846114, 37.4444145],
              [54.6837014, 37.4430651],
              [54.6818604, 37.4418897],
              [54.6784733, 37.4397403],
              [54.6736676, 37.437055],
              [54.6734335, 37.4370105],
              [54.6726478, 37.4371365],
              [54.6713486, 37.4370465],
              [54.6703408, 37.4368548],
              [54.6699133, 37.4366327],
              [54.6693468, 37.4363448],
              [54.6687802, 37.4362608],
              [54.6683345, 37.4362548],
              [54.668055, 37.4363508],
              [54.6677378, 37.4365367],
              [54.6674583, 37.4368246],
              [54.6671712, 37.4369865],
              [54.6668508, 37.4369986],
              [54.6662754, 37.4367435],
              [54.6655661, 37.4363185],
              [54.6648435, 37.4356491],
              [54.6643617, 37.4356066],
              [54.6640941, 37.4356809],
              [54.6638799, 37.435936],
              [54.6636658, 37.4363822],
              [54.6634383, 37.4369348],
              [54.6631707, 37.437498],
              [54.6628361, 37.4376361],
              [54.6625417, 37.4375086],
              [54.6622741, 37.4371898],
              [54.6620188, 37.436696],
              [54.6619438, 37.4366277],
              [54.6618207, 37.4365801],
              [54.6614979, 37.4365523],
              [54.6610964, 37.436701],
              [54.6607619, 37.4368923],
              [54.6604273, 37.4371898],
              [54.660219, 37.4376211],
              [54.6598781, 37.4376453],
              [54.6594499, 37.4374752],
              [54.6589607, 37.4370663],
              [54.6584194, 37.4368483],
              [54.6580046, 37.4366996],
              [54.6574425, 37.4365508],
              [54.6570678, 37.4366146],
              [54.656934, 37.4368483],
              [54.6569608, 37.4371033],
              [54.6571883, 37.4374752],
              [54.6578172, 37.4384741],
              [54.6578306, 37.4388247],
              [54.6571749, 37.4389416],
              [54.6566931, 37.4389203],
              [54.6559972, 37.4388885],
              [54.6556761, 37.439101],
              [54.6552478, 37.4394622],
              [54.6549534, 37.4399191],
              [54.6548999, 37.4403442],
              [54.6550471, 37.440631],
              [54.6554084, 37.440801],
              [54.6558366, 37.4409604],
              [54.6559972, 37.4412473],
              [54.6558902, 37.4415129],
              [54.6555958, 37.4417361],
              [54.6551274, 37.4417998],
              [54.652481, 37.44188],
              [54.6518833, 37.4419658],
              [54.6514905, 37.4421038],
              [54.6513168, 37.4421757],
              [54.6510977, 37.4421637],
              [54.6509769, 37.4420378],
              [54.6509693, 37.4418399],
              [54.6510902, 37.4416599],
              [54.6512564, 37.441384],
              [54.6512186, 37.4410961],
              [54.650992, 37.4408982],
              [54.649315, 37.4403884],
              [54.6479251, 37.4399266],
              [54.6475549, 37.4398366],
              [54.6471697, 37.4398126],
              [54.6469582, 37.4398786],
              [54.6466116, 37.4400752],
              [54.6462103, 37.4402445],
              [54.6458251, 37.4403524],
              [54.6455809, 37.4403121],
              [54.6454247, 37.4402625],
              [54.6453718, 37.4400705],
              [54.6453189, 37.4397886],
              [54.6452661, 37.4396027],
              [54.6450546, 37.4395667],
              [54.6447297, 37.4395727],
              [54.644352, 37.4397167],
              [54.6439819, 37.4399386],
              [54.6438082, 37.4401965],
              [54.6438006, 37.4404664],
              [54.6439517, 37.4409282],
              [54.6441995, 37.4420924],
              [54.6442463, 37.4423856],
              [54.6441254, 37.4427215],
              [54.6438308, 37.4428714],
              [54.6434682, 37.4428355],
              [54.6431661, 37.4426016],
              [54.6426977, 37.4422597],
              [54.6422596, 37.4420918],
              [54.6417761, 37.4420798],
              [54.6414664, 37.4423557],
              [54.6413229, 37.4426855],
              [54.64127, 37.4430754],
              [54.6409754, 37.4432253],
              [54.6404617, 37.4432793],
              [54.6397441, 37.4432313],
              [54.6391876, 37.4429327],
              [54.6387319, 37.4426375],
              [54.6380294, 37.4421157],
              [54.6372664, 37.4417859],
              [54.6366545, 37.4416359],
              [54.6361107, 37.4416119],
              [54.6357783, 37.4416659],
              [54.6354988, 37.4418099],
              [54.6354157, 37.4420558],
              [54.6354837, 37.4422297],
              [54.6356725, 37.4422777],
              [54.6363826, 37.4424396],
              [54.6368509, 37.4427515],
              [54.637206, 37.4433273],
              [54.6374553, 37.444035],
              [54.6373477, 37.4449028],
              [54.6370608, 37.4453462],
              [54.6366355, 37.4456432],
              [54.6363947, 37.4457815],
              [54.6362563, 37.4459686],
              [54.636241, 37.4460988],
              [54.6363998, 37.4463713],
              [54.6365126, 37.4465502],
              [54.6366292, 37.4470623],
              [54.6338848, 37.4476603],
              [54.6314249, 37.4481677],
              [54.6309086, 37.447918],
              [54.630458, 37.4479627],
              [54.6302937, 37.4482757],
              [54.6286557, 37.4485589],
              [54.6281424, 37.4484176],
              [54.6273327, 37.4483649],
              [54.627047, 37.4482331],
              [54.6266621, 37.4475586],
              [54.6264629, 37.447],
              [54.6262638, 37.4469157],
              [54.6254275, 37.4474427],
              [54.6251221, 37.44739],
              [54.6249097, 37.447116],
              [54.624238, 37.4462633],
              [54.623583, 37.4459473],
              [54.6230536, 37.4458181],
              [54.6222047, 37.4457822],
              [54.6216176, 37.4458629],
              [54.6208034, 37.4461214],
              [54.6203852, 37.4463223],
              [54.6200671, 37.4465885],
              [54.6186956, 37.4482305],
              [54.6151975, 37.4497615],
              [54.6148046, 37.4499449],
              [54.6146083, 37.4503573],
              [54.6139828, 37.4507996],
              [54.6135617, 37.4513217],
              [54.6133099, 37.4516084],
              [54.6130635, 37.4522724],
              [54.6128809, 37.4526257],
              [54.612697, 37.4530411],
              [54.6126237, 37.4532756],
              [54.6123778, 37.4538036],
              [54.6121576, 37.4543339],
              [54.6120093, 37.4544649],
              [54.6119903, 37.4546388],
              [54.6118788, 37.4547355],
              [54.6115369, 37.4547355],
              [54.611164, 37.4548194],
              [54.6107911, 37.4550562],
              [54.6102317, 37.4551253],
              [54.609747, 37.455145],
              [54.6093057, 37.4552042],
              [54.6089141, 37.4553769],
              [54.6084857, 37.4556107],
              [54.6082319, 37.4555822],
              [54.6078539, 37.4553275],
              [54.6075595, 37.4552054],
              [54.6066801, 37.4550626],
              [54.6060433, 37.4549996],
              [54.605718, 37.4549717],
              [54.6055994, 37.4549717],
              [54.6054763, 37.4550554],
              [54.6054368, 37.4552194],
              [54.6055642, 37.4555682],
              [54.6056038, 37.4560427],
              [54.6038091, 37.456973],
              [54.6029056, 37.4572244],
              [54.6022182, 37.45732],
              [54.6014661, 37.4572065],
              [54.6006893, 37.4569943],
              [54.5996202, 37.4567723],
              [54.5989401, 37.4568504],
              [54.5985139, 37.4570387],
              [54.5982218, 37.4573545],
              [54.5980167, 37.4579219],
              [54.5979732, 37.4583412],
              [54.5977122, 37.458578],
              [54.5973393, 37.4586471],
              [54.5968943, 37.4586951],
              [54.5967389, 37.4588234],
              [54.5966892, 37.4591293],
              [54.5965338, 37.4593809],
              [54.5962666, 37.4594006],
              [54.5959372, 37.4592378],
              [54.5954337, 37.4588579],
              [54.5948868, 37.4584879],
              [54.5945325, 37.4583596],
              [54.593975, 37.4581914],
              [54.5937556, 37.4583646],
              [54.5936065, 37.4586951],
              [54.5935568, 37.4589566],
              [54.5935692, 37.4593069],
              [54.5934262, 37.4595239],
              [54.5927799, 37.4598841],
              [54.592494, 37.4598496],
              [54.5919839, 37.4599257],
              [54.5910458, 37.4599137],
              [54.5902068, 37.4597558],
              [54.5893391, 37.4595057],
              [54.5884518, 37.4594033],
              [54.5877596, 37.4594237],
              [54.5875704, 37.4594749],
              [54.5873898, 37.4596114],
              [54.5872695, 37.4598367],
              [54.5871706, 37.4599664],
              [54.5869728, 37.4600483],
              [54.5867621, 37.4600312],
              [54.5866231, 37.4599729],
              [54.5864526, 37.4599015],
              [54.5862548, 37.4597377],
              [54.5862161, 37.459492],
              [54.5862161, 37.459178],
              [54.5862763, 37.4589084],
              [54.5863881, 37.4586831],
              [54.5865772, 37.4585091],
              [54.5865938, 37.4583232],
              [54.586381, 37.4581446],
              [54.5859392, 37.4580115],
              [54.5857282, 37.4579976],
              [54.5854359, 37.4581341],
              [54.5847523, 37.4587586],
              [54.5843739, 37.4589429],
              [54.5839998, 37.4589327],
              [54.5822551, 37.458475],
              [54.5817007, 37.4577625],
              [54.5813509, 37.4570305],
              [54.5811544, 37.4568451],
              [54.5797073, 37.4564638],
              [54.5794823, 37.456348],
              [54.5794215, 37.4559956],
              [54.5795796, 37.4558025],
              [54.5798653, 37.4555371],
              [54.5795374, 37.4548216],
              [54.5790571, 37.4534556],
              [54.5783274, 37.4521523],
              [54.5782058, 37.4515634],
              [54.5784126, 37.4511483],
              [54.5788747, 37.4507428],
              [54.5789476, 37.4502408],
              [54.5787477, 37.4499963],
              [54.5785198, 37.4499651],
              [54.5782442, 37.4496697],
              [54.5782442, 37.4488491],
              [54.5782855, 37.4483567],
              [54.5780788, 37.4482363],
              [54.577624, 37.4480285],
              [54.577081, 37.4474831],
              [54.5765799, 37.4472188],
              [54.5763362, 37.4472072],
              [54.5760049, 37.4473658],
              [54.5754133, 37.4477569],
              [54.5751034, 37.4478146],
              [54.5746405, 37.4477024],
              [54.5742458, 37.4476444],
              [54.5738463, 37.4477333],
              [54.5737927, 37.4479538],
              [54.5739328, 37.4480948],
              [54.5741094, 37.4482749],
              [54.5742263, 37.4484954],
              [54.5745138, 37.4487701],
              [54.5746405, 37.4490331],
              [54.57447, 37.4492034],
              [54.5741532, 37.4493813],
              [54.5739291, 37.4494316],
              [54.5734564, 37.4493155],
              [54.5731623, 37.4490076],
              [54.5731251, 37.4488745],
              [54.5730374, 37.4485921],
              [54.5728181, 37.4483678],
              [54.5723796, 37.4483523],
              [54.5714635, 37.4484645],
              [54.5705913, 37.4484877],
              [54.5697122, 37.4483211],
              [54.5694638, 37.4482493],
              [54.5690263, 37.4482849],
              [54.5688988, 37.4483971],
              [54.569009, 37.4486049],
              [54.569171, 37.4488593],
              [54.5694845, 37.4490317],
              [54.5698084, 37.4490754],
              [54.570184, 37.4490371],
              [54.5704286, 37.4491165],
              [54.5706009, 37.4491657],
              [54.5705595, 37.4494119],
              [54.5704045, 37.4501094],
              [54.5700398, 37.4506076],
              [54.5698187, 37.4507604],
              [54.5691313, 37.4508616],
              [54.5687438, 37.4508373],
              [54.5685232, 37.4508042],
              [54.5684402, 37.4507101],
              [54.5685226, 37.450611],
              [54.5685925, 37.450387],
              [54.5684652, 37.4501572],
              [54.5684077, 37.4499689],
              [54.5684177, 37.4497766],
              [54.5682704, 37.4497192],
              [54.5679908, 37.449739],
              [54.5676663, 37.4496181],
              [54.5671207, 37.4496032],
              [54.5668135, 37.4493818],
              [54.5666229, 37.4492164],
              [54.5665664, 37.4490819],
              [54.5668273, 37.4489284],
              [54.5670013, 37.4487204],
              [54.5671362, 37.4484112],
              [54.5670563, 37.4482963],
              [54.5668715, 37.4481179],
              [54.5666169, 37.4480307],
              [54.5662874, 37.4480069],
              [54.5659129, 37.4481179],
              [54.5655513, 37.4481339],
              [54.5653887, 37.4484826],
              [54.5652339, 37.4489146],
              [54.5650542, 37.448982],
              [54.5648595, 37.4489384],
              [54.5642513, 37.4485843],
              [54.5632144, 37.4481915],
              [54.5631221, 37.4480776],
              [54.5632269, 37.447919],
              [54.5634192, 37.4477598],
              [54.5636962, 37.447594],
              [54.5637961, 37.447487],
              [54.5637761, 37.44738],
              [54.5637062, 37.447269],
              [54.5634965, 37.4470153],
              [54.5633368, 37.4466268],
              [54.5633526, 37.4463464],
              [54.5632397, 37.4458588],
              [54.5630596, 37.4452337],
              [54.5628375, 37.4448678],
              [54.5625724, 37.4447544],
              [54.5624488, 37.4447264],
              [54.56229, 37.4447824],
              [54.5619708, 37.445059],
              [54.5618204, 37.4452421],
              [54.5619158, 37.4454888],
              [54.5621099, 37.445727],
              [54.5623112, 37.4459512],
              [54.5623712, 37.4461082],
              [54.5622476, 37.4462259],
              [54.5621116, 37.4462655],
              [54.5619166, 37.4462767],
              [54.5616201, 37.4463383],
              [54.5612176, 37.4463551],
              [54.5607586, 37.4464224],
              [54.5602573, 37.4463551],
              [54.5598443, 37.4462262],
              [54.5594206, 37.4460945],
              [54.5589193, 37.4460608],
              [54.5586051, 37.44603],
              [54.5578801, 37.4460589],
              [54.557542, 37.4462452],
              [54.5573223, 37.4465227],
              [54.5572923, 37.4467566],
              [54.5573751, 37.4469155],
              [54.557361, 37.4470612],
              [54.5572251, 37.4471859],
              [54.5570133, 37.4472294],
              [54.5567079, 37.4471775],
              [54.5562922, 37.447095],
              [54.556064, 37.4469683],
              [54.5557581, 37.4467569],
              [54.5555509, 37.4466142],
              [54.555496, 37.4465012],
              [54.5555135, 37.4463744],
              [54.5557312, 37.4460954],
              [54.5564577, 37.4456173],
              [54.5566724, 37.445324],
              [54.5568771, 37.4449315],
              [54.5572865, 37.4446105],
              [54.5575811, 37.4443726],
              [54.5578357, 37.4440159],
              [54.5578407, 37.4437661],
              [54.5577483, 37.4436805],
              [54.5576609, 37.4435996],
              [54.5574013, 37.4435679],
              [54.5571367, 37.4436195],
              [54.5568571, 37.443782],
              [54.5564277, 37.444111],
              [54.5554891, 37.4446977],
              [54.554711, 37.4449708],
              [54.5542958, 37.4453002],
              [54.5539014, 37.445867],
              [54.5537217, 37.4461088],
              [54.553512, 37.4462475],
              [54.5531239, 37.4463867],
              [54.5528907, 37.4464697],
              [54.5526577, 37.4464304],
              [54.5524741, 37.4463127],
              [54.5524, 37.446153],
              [54.5523965, 37.4459119],
              [54.5523894, 37.4455588],
              [54.5522552, 37.4452308],
              [54.5520399, 37.4449223],
              [54.5520258, 37.4446925],
              [54.5520787, 37.4443841],
              [54.5519799, 37.4441459],
              [54.551708, 37.4439581],
              [54.5515965, 37.443748],
              [54.5513908, 37.4436725],
              [54.5510712, 37.4437082],
              [54.5508416, 37.4436448],
              [54.5506918, 37.4435179],
              [54.5507018, 37.443284],
              [54.5509757, 37.4429283],
              [54.5509757, 37.4427737],
              [54.5509207, 37.4426429],
              [54.550766, 37.4425676],
              [54.5505263, 37.4425477],
              [54.5503066, 37.4425715],
              [54.5499871, 37.4428213],
              [54.5497674, 37.4429996],
              [54.5495534, 37.4434624],
              [54.549393, 37.4439114],
              [54.5492332, 37.4440342],
              [54.5490185, 37.4440659],
              [54.5487239, 37.4439946],
              [54.5476339, 37.4433643],
              [54.5462268, 37.4431671],
              [54.5459585, 37.4430886],
              [54.545839, 37.4430016],
              [54.5457661, 37.4429289],
              [54.5457101, 37.4428376],
              [54.5456819, 37.4427171],
              [54.5459594, 37.4423702],
              [54.546691, 37.4420011],
              [54.5467083, 37.4417938],
              [54.5465688, 37.4416153],
              [54.5461944, 37.4415043],
              [54.5456452, 37.4414567],
              [54.545091, 37.4413537],
              [54.5448863, 37.4412625],
              [54.5447265, 37.4410365],
              [54.5447165, 37.4408225],
              [54.5448613, 37.4405291],
              [54.5448513, 37.440216],
              [54.5445279, 37.4398233],
              [54.5439426, 37.4391773],
              [54.5434983, 37.4386263],
              [54.5428542, 37.4383845],
              [54.5421003, 37.4381506],
              [54.5417358, 37.4380436],
              [54.541641, 37.4378295],
              [54.5418137, 37.4374241],
              [54.5418756, 37.4371516],
              [54.5417159, 37.4370406],
              [54.5413764, 37.4370327],
              [54.5407523, 37.4370802],
              [54.5404128, 37.4370049],
              [54.5401931, 37.4367671],
              [54.5400084, 37.4364261],
              [54.5396988, 37.4361605],
              [54.539559, 37.4357601],
              [54.5393094, 37.4355579],
              [54.5386603, 37.4355738],
              [54.5380912, 37.4357641],
              [54.5375992, 37.4359628],
              [54.5373872, 37.435998],
              [54.5371775, 37.4359583],
              [54.5370626, 37.4357284],
              [54.5369977, 37.4354271],
              [54.536798, 37.4353518],
              [54.5365484, 37.4354112],
              [54.5362838, 37.4356015],
              [54.5359393, 37.4359068],
              [54.5357196, 37.4363468],
              [54.535445, 37.4364142],
              [54.5352103, 37.4363865],
              [54.5351305, 37.4362636],
              [54.5351064, 37.4359818],
              [54.5350755, 37.4358037],
              [54.5348858, 37.4356689],
              [54.534756, 37.4356332],
              [54.5342517, 37.435772],
              [54.5340171, 37.435768],
              [54.5338773, 37.435657],
              [54.5336426, 37.4353438],
              [54.533388, 37.434884],
              [54.5332582, 37.434547],
              [54.5330722, 37.4341398],
              [54.5329172, 37.4339608],
              [54.532715, 37.4338538],
              [54.5325652, 37.4338161],
              [54.5322546, 37.4338492],
              [54.5319651, 37.4340157],
              [54.5317009, 37.4342299],
              [54.5315175, 37.4342968],
              [54.5311251, 37.4342606],
              [54.5307656, 37.4340743],
              [54.5304511, 37.4340029],
              [54.5300167, 37.4338007],
              [54.5299967, 37.4335747],
              [54.5301265, 37.433317],
              [54.5304361, 37.4331783],
              [54.530471, 37.4329246],
              [54.5304011, 37.4327224],
              [54.5302164, 37.4326193],
              [54.5298569, 37.4325598],
              [54.5295474, 37.4325995],
              [54.529333, 37.4325433],
              [54.529098, 37.4323973],
              [54.5288434, 37.4321515],
              [54.5285289, 37.4320206],
              [54.5281794, 37.431985],
              [54.5276352, 37.431981],
              [54.5271109, 37.4321039],
              [54.5260674, 37.4325479],
              [54.525708, 37.4328056],
              [54.5252337, 37.4333408],
              [54.5248659, 37.4335978],
              [54.5245447, 37.4337333],
              [54.5241602, 37.4337968],
              [54.5235162, 37.4338404],
              [54.5231467, 37.4338047],
              [54.5228321, 37.4338443],
              [54.5224527, 37.4340584],
              [54.522218, 37.434328],
              [54.5219684, 37.4347403],
              [54.5218036, 37.4349068],
              [54.5214891, 37.4349782],
              [54.5212494, 37.4349147],
              [54.5210148, 37.4347324],
              [54.5208777, 37.4344801],
              [54.5208299, 37.4341231],
              [54.5206801, 37.4337782],
              [54.5202208, 37.4334531],
              [54.5198713, 37.4331954],
              [54.5190075, 37.4328861],
              [54.5184447, 37.4326784],
              [54.5182986, 37.4326245],
              [54.5180589, 37.4324857],
              [54.5179341, 37.4321804],
              [54.5179541, 37.4316928],
              [54.5177943, 37.4312527],
              [54.5175298, 37.4309833],
              [54.517315, 37.4309237],
              [54.5169755, 37.4309435],
              [54.516646, 37.430995],
              [54.5164662, 37.4309157],
              [54.5161417, 37.4305946],
              [54.5152985, 37.4308221],
              [54.5147712, 37.4309652],
              [54.5145095, 37.4308597],
              [54.5146222, 37.430425],
              [54.5143772, 37.4302998],
              [54.5136701, 37.4302252],
              [54.5131387, 37.4300206],
              [54.5129616, 37.4296625],
              [54.5129616, 37.4292405],
              [54.5129294, 37.4286523],
              [54.5125671, 37.4280577],
              [54.5121806, 37.4277764],
              [54.5117861, 37.42777],
              [54.5112466, 37.4279618],
              [54.5109487, 37.4280577],
              [54.5107796, 37.4279106],
              [54.5107716, 37.4275398],
              [54.510675, 37.4268748],
              [54.5104254, 37.4264464],
              [54.510078, 37.4257845],
              [54.5097909, 37.425055],
              [54.5094835, 37.4243089],
              [54.5090451, 37.423893],
              [54.5086181, 37.4234001],
              [54.5081797, 37.4230882],
              [54.5074794, 37.4227807],
              [54.5070183, 37.4223466],
              [54.5068064, 37.4216774],
              [54.5066084, 37.4213022],
              [54.5062895, 37.4209585],
              [54.5059423, 37.4207279],
              [54.5054128, 37.4204702],
              [54.5051224, 37.4204521],
              [54.5047581, 37.4205109],
              [54.5044563, 37.4207144],
              [54.5043083, 37.4212977],
              [54.5041729, 37.4214814],
              [54.5038286, 37.4215763],
              [54.503269, 37.4217042],
              [54.5027778, 37.4218417],
              [54.5026007, 37.4217585],
              [54.5025604, 37.4215475],
              [54.5025926, 37.4210168],
              [54.5028342, 37.4203102],
              [54.5028181, 37.4201375],
              [54.5028221, 37.420016],
              [54.5026571, 37.4198722],
              [54.5023914, 37.4197443],
              [54.5019928, 37.4197379],
              [54.5015822, 37.4196739],
              [54.5013368, 37.4195359],
              [54.5011232, 37.4193286],
              [54.5009542, 37.4190441],
              [54.5007046, 37.4189481],
              [54.5003624, 37.4190537],
              [54.5000363, 37.4193126],
              [54.4996297, 37.4198913],
              [54.4994002, 37.4200448],
              [54.4987682, 37.4199585],
              [54.4979832, 37.4200704],
              [54.4973723, 37.4204632],
              [54.4966064, 37.420534],
              [54.4956925, 37.4209464],
              [54.4945814, 37.420956],
              [54.4938487, 37.4210743],
              [54.4937038, 37.4210487],
              [54.4936474, 37.4209273],
              [54.4926249, 37.42055],
              [54.4923391, 37.4205724],
              [54.4921136, 37.420566],
              [54.4916386, 37.4203517],
              [54.4912722, 37.4203901],
              [54.4910307, 37.4201599],
              [54.4907335, 37.4200773],
              [54.4901611, 37.4199649],
              [54.4894928, 37.4196739],
              [54.4886716, 37.4192615],
              [54.488067, 37.4187774],
              [54.4874066, 37.4182438],
              [54.4870878, 37.4178504],
              [54.486712, 37.4174977],
              [54.4866152, 37.4170365],
              [54.4863932, 37.4167516],
              [54.4861655, 37.4166069],
              [54.4856343, 37.4164874],
              [54.4855717, 37.4161257],
              [54.4856457, 37.4157323],
              [54.4855034, 37.4155288],
              [54.4850991, 37.4154248],
              [54.4847177, 37.4150495],
              [54.4847006, 37.4148369],
              [54.4845009, 37.4143988],
              [54.4840801, 37.4140366],
              [54.4834196, 37.4132814],
              [54.4830837, 37.4127704],
              [54.4827307, 37.4124312],
              [54.4817743, 37.4119112],
              [54.4812733, 37.411468],
              [54.4801105, 37.410874],
              [54.4788707, 37.4101023],
              [54.4786487, 37.4097858],
              [54.4780964, 37.4093562],
              [54.4772424, 37.4090505],
              [54.4765564, 37.4085987],
              [54.4762575, 37.4084381],
              [54.4759614, 37.4084042],
              [54.4756807, 37.4082161],
              [54.4753824, 37.4081003],
              [54.4752226, 37.4079332],
              [54.4751964, 37.4078043],
              [54.4752854, 37.4076359],
              [54.4751545, 37.4073847],
              [54.4749863, 37.4072684],
              [54.4749313, 37.407023],
              [54.474769, 37.4069564],
              [54.4743894, 37.4068795],
              [54.4742324, 37.4066424],
              [54.4740334, 37.4065031],
              [54.4738894, 37.4063908],
              [54.473748, 37.4060851],
              [54.4735412, 37.4058834],
              [54.473193, 37.4057773],
              [54.4730439, 37.4056886],
              [54.4729625, 37.4053945],
              [54.4728182, 37.4052354],
              [54.4725553, 37.405056],
              [54.4723887, 37.4046766],
              [54.4721925, 37.404259],
              [54.4719925, 37.4040619],
              [54.4717001, 37.4038737],
              [54.4714372, 37.4038972],
              [54.4711188, 37.4039678],
              [54.4709374, 37.4037973],
              [54.4708263, 37.4035679],
              [54.4704857, 37.4034649],
              [54.4701451, 37.4035355],
              [54.4697267, 37.4034943],
              [54.4694528, 37.4034237],
              [54.469064, 37.4034708],
              [54.4687975, 37.4034032],
              [54.4686086, 37.4032002],
              [54.4683122, 37.4030647],
              [54.4680607, 37.4028719],
              [54.4678312, 37.4027337],
              [54.4674832, 37.4027278],
              [54.4670648, 37.4025866],
              [54.466602, 37.402519],
              [54.4663984, 37.4025337],
              [54.4661392, 37.4025778],
              [54.4658764, 37.4024543],
              [54.465321, 37.4022896],
              [54.4649582, 37.402166],
              [54.464516, 37.402039],
              [54.4637695, 37.4021286],
              [54.4633094, 37.402101],
              [54.4627582, 37.4019355],
              [54.4622678, 37.4017356],
              [54.4620039, 37.4015382],
              [54.4616602, 37.4010847],
              [54.4614331, 37.4004167],
              [54.460836, 37.3997941],
              [54.4600233, 37.3992862],
              [54.4592985, 37.3989828],
              [54.4590511, 37.3986345],
              [54.4588862, 37.3984345],
              [54.4582829, 37.3981759],
              [54.4581527, 37.3980001],
              [54.4578464, 37.3973495],
              [54.4577751, 37.3968898],
              [54.4576899, 37.3967453],
              [54.4574903, 37.396697],
              [54.4572326, 37.3965106],
              [54.4569456, 37.3961768],
              [54.4567001, 37.3961304],
              [54.4565927, 37.3961012],
              [54.4565629, 37.3959997],
              [54.4565587, 37.3959155],
              [54.4565087, 37.3958535],
              [54.4563156, 37.3958362],
              [54.4562071, 37.395869],
              [54.4561442, 37.3958466],
              [54.4561225, 37.3957811],
              [54.4561507, 37.3954759],
              [54.4561594, 37.3952828],
              [54.4561033, 37.3951484],
              [54.4559867, 37.3950671],
              [54.4557878, 37.395011],
              [54.4555967, 37.3950276],
              [54.4554056, 37.3950068],
              [54.4551935, 37.3949403],
              [54.4549631, 37.3949548],
              [54.4548558, 37.3948113],
              [54.4547746, 37.3947843],
              [54.4545731, 37.3947635],
              [54.4543715, 37.3946512],
              [54.4541333, 37.3946907],
              [54.4539386, 37.3946646],
              [54.45367, 37.3946108],
              [54.4535145, 37.3944137],
              [54.453396, 37.3943961],
              [54.4532479, 37.3944314],
              [54.4532183, 37.3945696],
              [54.4529406, 37.3946902],
              [54.4527, 37.3946696],
              [54.4521298, 37.3948079],
              [54.4519151, 37.3947343],
              [54.4517352, 37.3947752],
              [54.451531, 37.3948217],
              [54.4513375, 37.3948255],
              [54.4511709, 37.3946137],
              [54.4508525, 37.3945225],
              [54.4504711, 37.3944388],
              [54.4502194, 37.3942078],
              [54.4496632, 37.3939101],
              [54.4495012, 37.3936548],
              [54.4492457, 37.393496],
              [54.4491088, 37.3932371],
              [54.4485904, 37.3927959],
              [54.4482386, 37.3925017],
              [54.4480055, 37.3923871],
              [54.4478574, 37.3922047],
              [54.4478356, 37.3918366],
              [54.4476172, 37.3914322],
              [54.4475131, 37.391384],
              [54.4473835, 37.3914193],
              [54.4473205, 37.3914987],
              [54.4471238, 37.3915125],
              [54.4466023, 37.3914929],
              [54.4463839, 37.3915282],
              [54.4462061, 37.391484],
              [54.4460803, 37.3914664],
              [54.4458581, 37.3914929],
              [54.4456841, 37.3913899],
              [54.4456767, 37.3910163],
              [54.4455027, 37.3907339],
              [54.4452102, 37.3903898],
              [54.4450447, 37.3903122],
              [54.4448992, 37.3903339],
              [54.4446993, 37.3903957],
              [54.4445734, 37.3902986],
              [54.4445549, 37.390128],
              [54.444218, 37.3897632],
              [54.4437663, 37.3895662],
              [54.4434887, 37.3893661],
              [54.4432702, 37.3891779],
              [54.4429259, 37.3891896],
              [54.442552, 37.3893191],
              [54.442241, 37.3893955],
              [54.4418477, 37.3891424],
              [54.4414801, 37.3890219],
              [54.4412061, 37.3890543],
              [54.4408174, 37.3889484],
              [54.4405471, 37.389019],
              [54.4403953, 37.3889131],
              [54.4402991, 37.388666],
              [54.4398548, 37.3884924],
              [54.4393323, 37.3883475],
              [54.4388047, 37.3882394],
              [54.4384333, 37.3880991],
              [54.4380642, 37.387806],
              [54.4297094, 37.382206],
              [54.4188565, 37.3749273],
              [54.4082085, 37.367778],
              [54.3976597, 37.3606995],
              [54.3726605, 37.3546483],
              [54.3476436, 37.3486292],
              [54.3296932, 37.3495358],
              [54.3074765, 37.3506518],
              [54.2851929, 37.351769],
              [54.262637, 37.3321853],
              [54.2491366, 37.323784],
              [54.246327, 37.3229226],
              [54.2458388, 37.3224859],
              [54.245475, 37.3219965],
              [54.2446779, 37.3199856],
              [54.2242496, 37.3216901],
              [54.2196008, 37.322078],
              [54.1950823, 37.3241297],
              [54.1705752, 37.3261564],
              [54.1654921, 37.3265843],
              [54.1457754, 37.328244],
              [54.1210053, 37.3302989],
              [54.0976908, 37.3322544],
              [54.0739299, 37.3342226],
              [54.0492799, 37.3362906],
              [54.030556, 37.342222],
              [54.021944, 37.342778],
              [54.013333, 37.343333],
              [54.004722, 37.343889],
              [53.996111, 37.344722],
              [53.987778, 37.345278],
              [53.9706342, 37.3460666],
              [53.9706491, 37.3460373],
              [53.8484159, 37.3562681],
              [53.6649493, 37.3561378]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 537657,
        "tags": {
          "ISO3166-2": "IR-09",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "خراسان رضوی",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q587090"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [56.2279736, 34.7104172],
              [56.2412125, 34.7044005],
              [56.2417693, 34.7044005],
              [56.2420459, 34.7041208],
              [56.2428791, 34.7041208],
              [56.2439926, 34.7035614],
              [56.2642724, 34.6988425],
              [56.2653824, 34.6988425],
              [56.2712156, 34.6971733],
              [56.2723257, 34.6971733],
              [56.2745489, 34.6963433],
              [56.275659, 34.6963432],
              [56.2773255, 34.6957838],
              [56.2787154, 34.6957838],
              [56.2820487, 34.6952334],
              [56.2912153, 34.6941236],
              [56.2926054, 34.6938439],
              [56.2962152, 34.6938439],
              [56.2976053, 34.6935642],
              [56.2998285, 34.6935642],
              [56.3012187, 34.6932845],
              [56.3051053, 34.6932845],
              [56.3064951, 34.6930048],
              [56.3098284, 34.6930048],
              [56.3123284, 34.6927341],
              [56.3131616, 34.6924544],
              [56.318995, 34.6924544],
              [56.3770544, 34.6860662],
              [56.3839975, 34.6852271],
              [56.3889973, 34.6852271],
              [56.395944, 34.6849474],
              [56.3998342, 34.6846767],
              [56.4028873, 34.6841173],
              [56.4070538, 34.6841173],
              [56.4078872, 34.6838376],
              [56.4106671, 34.6838376],
              [56.4109439, 34.6835579],
              [56.4117772, 34.6838376],
              [56.4126106, 34.6835578],
              [56.4159438, 34.6835579],
              [56.4184436, 34.6830075],
              [56.419277, 34.6830075],
              [56.4198338, 34.6827277],
              [56.4209437, 34.6827278],
              [56.421777, 34.6824481],
              [56.4253904, 34.682448],
              [56.4323336, 34.6818977],
              [56.4362236, 34.6824481],
              [56.4384468, 34.682448],
              [56.4462234, 34.6835578],
              [56.4512233, 34.6846767],
              [56.4548367, 34.6846766],
              [56.45789, 34.6849474],
              [56.4584466, 34.685227],
              [56.4615034, 34.685227],
              [56.4623365, 34.6855067],
              [56.4637232, 34.6855067],
              [56.4648366, 34.6857865],
              [56.4662232, 34.6857864],
              [56.4673365, 34.6860661],
              [56.4698366, 34.6860662],
              [56.472893, 34.6868963],
              [56.4734464, 34.6868962],
              [56.4773363, 34.6880061],
              [56.479003, 34.6885654],
              [56.4801129, 34.6885654],
              [56.4809464, 34.6888451],
              [56.4823365, 34.6888451],
              [56.4851128, 34.6896752],
              [56.487893, 34.6902256],
              [56.5603955, 34.7157868],
              [56.5662286, 34.7177266],
              [56.6115081, 34.7324514],
              [56.6256779, 34.7405084],
              [56.6356779, 34.7446767],
              [56.6373446, 34.7449475],
              [56.6378977, 34.7455068],
              [56.6445678, 34.7474556],
              [56.6456778, 34.7474557],
              [56.6462345, 34.7477354],
              [56.6492876, 34.7477353],
              [56.6665108, 34.7521744],
              [56.6723442, 34.7543938],
              [56.7398501, 34.7827327],
              [56.7456832, 34.7896798],
              [56.7479031, 34.7932887],
              [56.7490165, 34.7968974],
              [56.7490165, 34.7971771],
              [56.7517931, 34.8052338],
              [56.7531832, 34.8066233],
              [56.7534598, 34.8074533],
              [56.7823494, 34.8293946],
              [56.7826295, 34.8299539],
              [56.7837396, 34.8305133],
              [56.7901295, 34.8374511],
              [56.795406, 34.8452369],
              [56.7976293, 34.847727],
              [56.7984627, 34.8482862],
              [56.8015194, 34.853573],
              [56.8087393, 34.8632893],
              [56.8092959, 34.8646787],
              [56.8179093, 34.876903],
              [56.8298523, 34.8902367],
              [56.835409, 34.8946753],
              [56.8495757, 34.9149554],
              [56.8509655, 34.9180136],
              [56.8515221, 34.9191232],
              [56.8517989, 34.9205124],
              [56.8520755, 34.9219018],
              [56.8442988, 34.9352351],
              [56.8395756, 34.9371747],
              [56.8298524, 34.9388436],
              [56.8248525, 34.9371747],
              [56.821796, 34.9369041],
              [56.820686, 34.9374544],
              [56.8198526, 34.9391233],
              [56.8209625, 34.9419018],
              [56.8217959, 34.9444006],
              [56.8240192, 34.9466289],
              [56.8273525, 34.948848],
              [56.8337425, 34.954405],
              [56.8640221, 34.9738452],
              [56.8645754, 34.9744045],
              [56.8798552, 34.9799613],
              [56.8959685, 34.9824601],
              [56.9012449, 34.9824601],
              [56.9026351, 34.9821804],
              [56.9051351, 34.9821804],
              [56.9062449, 34.9819008],
              [56.9104115, 34.9819007],
              [56.9162449, 34.9813505],
              [56.9198582, 34.9813505],
              [56.9245813, 34.9816211],
              [56.9259682, 34.9819007],
              [56.9298581, 34.9819007],
              [56.9312481, 34.9821804],
              [56.9331913, 34.9821804],
              [56.9448546, 34.9793346],
              [56.9537445, 34.9812831],
              [56.9545778, 34.9812832],
              [56.9551345, 34.9815627],
              [56.9562445, 34.9815628],
              [56.9699475, 34.9970978],
              [56.9824274, 35.0022814],
              [57.0010372, 35.0064486],
              [57.0098603, 35.0052373],
              [57.0401266, 35.0123643],
              [57.0484632, 35.0162525],
              [57.0517965, 35.0173622],
              [57.053183, 35.018192],
              [57.0559631, 35.019022],
              [57.1321089, 35.0610131],
              [57.1622585, 35.0715818],
              [57.1661484, 35.0724116],
              [57.1686484, 35.0732506],
              [57.1725383, 35.0738009],
              [57.2225142, 35.0958999],
              [57.2255709, 35.0961795],
              [57.2375141, 35.0975685],
              [57.2391807, 35.0975684],
              [57.2633504, 35.1000667],
              [57.2715408, 35.1000189],
              [57.2754307, 35.100019],
              [57.2782073, 35.1002984],
              [57.2848739, 35.1002985],
              [57.2876538, 35.1005781],
              [57.2918207, 35.1005781],
              [57.2945972, 35.1008487],
              [57.2987673, 35.1008487],
              [57.3015404, 35.1011282],
              [57.3121604, 35.1022517],
              [57.3398467, 35.1053709],
              [57.3530957, 35.1106412],
              [57.3695752, 35.1067092],
              [57.3815389, 35.1163708],
              [57.3898722, 35.1141435],
              [57.3920988, 35.113873],
              [57.4040452, 35.1116458],
              [57.4520949, 35.1269001],
              [57.460899, 35.1229978],
              [57.4642349, 35.116266],
              [57.4667346, 35.115716],
              [57.4842483, 35.0933066],
              [57.4862193, 35.0774234],
              [57.4918315, 35.0671804],
              [57.500023, 35.0503605],
              [57.5033582, 35.0391682],
              [57.5094712, 35.0372281],
              [57.5269246, 35.0128173],
              [57.5280379, 35.0128173],
              [57.5288712, 35.0125376],
              [57.5305381, 35.0125376],
              [57.530811, 35.0122577],
              [57.5319243, 35.0122577],
              [57.5327576, 35.0125375],
              [57.5333111, 35.0122577],
              [57.5341444, 35.0125375],
              [57.536371, 35.0125375],
              [57.5645595, 35.0139566],
              [57.5673293, 35.0130566],
              [57.5722217, 35.009401],
              [57.5885295, 34.9999803],
              [57.5917053, 34.9983983],
              [57.6015758, 34.995832],
              [57.6181608, 34.9930692],
              [57.6428422, 34.9782526],
              [57.6497268, 34.9745247],
              [57.6556938, 34.9713098],
              [57.6613998, 34.968265],
              [57.6700322, 34.9618782],
              [57.6728119, 34.9604891],
              [57.6736452, 34.9596593],
              [57.6761452, 34.9582612],
              [57.6795256, 34.9557837],
              [57.6908651, 34.9477076],
              [57.6966934, 34.9386079],
              [57.7018725, 34.9328255],
              [57.7063951, 34.9268426],
              [57.7117824, 34.9229564],
              [57.7224253, 34.9209859],
              [57.7319526, 34.9214081],
              [57.7427259, 34.9206582],
              [57.7507495, 34.917467],
              [57.757101, 34.9157778],
              [57.761481, 34.9140592],
              [57.7615385, 34.9135434],
              [57.7624299, 34.8926181],
              [57.7565979, 34.8810716],
              [57.753955, 34.8608591],
              [57.7550444, 34.8542178],
              [57.7604483, 34.8541013],
              [57.7681731, 34.8532561],
              [57.7968403, 34.8557918],
              [57.8244778, 34.8624121],
              [57.8653332, 34.8659334],
              [57.9346418, 34.8854733],
              [57.9535142, 34.8854034],
              [57.9548547, 34.8853768],
              [57.9300495, 34.8521997],
              [57.9273031, 34.8433947],
              [57.9285046, 34.8205682],
              [57.9178616, 34.7873034],
              [57.902376, 34.7591858],
              [57.9004295, 34.7583554],
              [57.8879296, 34.7516854],
              [57.8870964, 34.750846],
              [57.8820961, 34.7475154],
              [57.8751495, 34.7416757],
              [57.8701397, 34.7249661],
              [57.8574368, 34.7057759],
              [57.8562327, 34.6743682],
              [57.8551194, 34.6729775],
              [57.8506495, 34.6608072],
              [57.8462171, 34.6549216],
              [57.8450224, 34.6188228],
              [57.8413158, 34.5828533],
              [57.8413158, 34.5822932],
              [57.8393692, 34.5797905],
              [57.8388157, 34.5783992],
              [57.8385357, 34.5778481],
              [57.8382556, 34.5775681],
              [57.8360356, 34.573394],
              [57.8290889, 34.565055],
              [57.8079759, 34.5414108],
              [57.807976, 34.5408506],
              [57.7958758, 34.5308163],
              [57.7897694, 34.5247018],
              [57.7897694, 34.5244219],
              [57.7874076, 34.5205282],
              [57.7878225, 34.5205293],
              [57.7852534, 34.511154],
              [57.812269, 34.4991238],
              [57.8125421, 34.498293],
              [57.8183665, 34.4970399],
              [57.8186463, 34.4962094],
              [57.8230931, 34.4892684],
              [57.820243, 34.4497466],
              [57.8055571, 34.4359662],
              [57.8063908, 34.4348469],
              [57.8014752, 34.4256028],
              [57.8011319, 34.4083262],
              [57.7953019, 34.3988677],
              [57.7920156, 34.3858517],
              [57.7925687, 34.3850123],
              [57.7749028, 34.3666507],
              [57.7742173, 34.3662291],
              [57.7695898, 34.3594136],
              [57.7697996, 34.3567577],
              [57.7677707, 34.3549214],
              [57.76695, 34.3546226],
              [57.7713529, 34.3496993],
              [57.7719065, 34.3491397],
              [57.7721865, 34.3488601],
              [57.8457053, 34.3441868],
              [57.8465386, 34.3444666],
              [57.8623999, 34.3424379],
              [57.8640668, 34.3424379],
              [57.8643464, 34.3427177],
              [57.8651801, 34.3427176],
              [57.8657332, 34.3429973],
              [57.8671266, 34.3429973],
              [57.8676797, 34.3432771],
              [57.873513, 34.3438274],
              [57.8751798, 34.3438275],
              [57.8757329, 34.3438275],
              [57.8762932, 34.3441072],
              [57.8810132, 34.3441071],
              [57.8818464, 34.3443869],
              [57.8824066, 34.3441071],
              [57.8832398, 34.3443868],
              [57.8940115, 34.3375834],
              [57.8945645, 34.3373036],
              [57.9027347, 34.3221354],
              [57.9032879, 34.3218556],
              [57.9046813, 34.3218556],
              [57.9071814, 34.321305],
              [57.9099615, 34.3201858],
              [57.9109044, 34.3147337],
              [57.9150898, 34.3155527],
              [57.9206943, 34.3175653],
              [57.925067, 34.3165749],
              [57.9271876, 34.3137037],
              [57.9290691, 34.3119035],
              [57.9316415, 34.3102729],
              [57.9351151, 34.3098197],
              [57.9383516, 34.3087917],
              [57.9419722, 34.307855],
              [57.9515173, 34.3048063],
              [57.9539265, 34.3013511],
              [57.9593275, 34.2957784],
              [57.964351, 34.2922367],
              [57.975406, 34.2879701],
              [57.9803466, 34.2856589],
              [57.9987905, 34.2820302],
              [58.0147808, 34.2741276],
              [58.0251502, 34.2778577],
              [58.0392264, 34.2799854],
              [58.044033, 34.2795599],
              [58.0502128, 34.2760137],
              [58.05768, 34.2717581],
              [58.0626582, 34.2668639],
              [58.0705546, 34.2611891],
              [58.082375, 34.2542869],
              [58.0920123, 34.2495546],
              [58.0966472, 34.2486323],
              [58.1052726, 34.2442376],
              [58.1132125, 34.2404728],
              [58.1206798, 34.2371379],
              [58.1248855, 34.2347253],
              [58.1401148, 34.2316277],
              [58.1578355, 34.2317067],
              [58.1672, 34.2345834],
              [58.1733678, 34.2365279],
              [58.1851862, 34.2351881],
              [58.1996326, 34.2287508],
              [58.206253, 34.2245775],
              [58.2120036, 34.2228742],
              [58.2201094, 34.2229363],
              [58.2358646, 34.2365702],
              [58.2392156, 34.2419976],
              [58.2382413, 34.2441694],
              [58.2372831, 34.2482048],
              [58.2367276, 34.2531717],
              [58.2389451, 34.2582268],
              [58.2429828, 34.2616149],
              [58.2449205, 34.2629363],
              [58.247253, 34.26385],
              [58.250273, 34.2644759],
              [58.2552695, 34.2629602],
              [58.2559627, 34.2638607],
              [58.2592885, 34.2684303],
              [58.260728, 34.2705236],
              [58.262176, 34.2727155],
              [58.2637261, 34.2747201],
              [58.270925, 34.2817319],
              [58.2729123, 34.2840504],
              [58.2760201, 34.2909321],
              [58.2729005, 34.2956576],
              [58.2593839, 34.312246],
              [58.2674035, 34.3159404],
              [58.2699022, 34.3154378],
              [58.2732168, 34.3143966],
              [58.2783749, 34.3121136],
              [58.282168, 34.3106676],
              [58.2857094, 34.3088056],
              [58.2910081, 34.3066148],
              [58.29648, 34.3058053],
              [58.302484, 34.3058445],
              [58.3090988, 34.3059065],
              [58.3141344, 34.3061921],
              [58.3178452, 34.3062566],
              [58.3218615, 34.3063884],
              [58.3270347, 34.3064324],
              [58.3323063, 34.3065599],
              [58.3348046, 34.3065924],
              [58.3381567, 34.3066744],
              [58.3413405, 34.3069474],
              [58.3458369, 34.3074126],
              [58.3613631, 34.3105302],
              [58.3632444, 34.305363],
              [58.3650814, 34.2986035],
              [58.3658978, 34.2916868],
              [58.3718204, 34.288141],
              [58.3786422, 34.2818634],
              [58.3838352, 34.275102],
              [58.3853816, 34.2716162],
              [58.3941755, 34.2631686],
              [58.3986895, 34.2590667],
              [58.4038992, 34.2552993],
              [58.4146198, 34.2533691],
              [58.4148982, 34.2467382],
              [58.4149074, 34.2418919],
              [58.4178256, 34.2313192],
              [58.4191346, 34.2251806],
              [58.4188342, 34.2245952],
              [58.4191131, 34.2232468],
              [58.4172214, 34.2191257],
              [58.418355, 34.2165393],
              [58.4195725, 34.2158732],
              [58.4216022, 34.2149962],
              [58.4237816, 34.2127084],
              [58.4306144, 34.2002673],
              [58.4330177, 34.1959369],
              [58.4343051, 34.1948365],
              [58.4331464, 34.1925647],
              [58.4324169, 34.1902573],
              [58.4316444, 34.1863524],
              [58.4359778, 34.1815256],
              [58.4384621, 34.1783383],
              [58.4431379, 34.1738136],
              [58.4424162, 34.1727547],
              [58.4432316, 34.1721334],
              [58.4435534, 34.1707486],
              [58.4435963, 34.1683874],
              [58.4447336, 34.1653159],
              [58.4450984, 34.1645347],
              [58.4452056, 34.1616052],
              [58.4469222, 34.1577167],
              [58.4671783, 34.138307],
              [58.4608268, 34.1236003],
              [58.4582519, 34.1201897],
              [58.4579085, 34.1137233],
              [58.4636163, 34.1003627],
              [58.4651613, 34.0902697],
              [58.4662771, 34.0854716],
              [58.4659338, 34.0849296],
              [58.46632, 34.0836945],
              [58.4654059, 34.0815654],
              [58.4694314, 34.0815352],
              [58.4739053, 34.0807888],
              [58.4774351, 34.0796336],
              [58.4860611, 34.0780074],
              [58.4912967, 34.0756613],
              [58.4939575, 34.0764433],
              [58.4950733, 34.0774742],
              [58.4963607, 34.0777585],
              [58.4988066, 34.0799981],
              [58.5124966, 34.0901989],
              [58.5245129, 34.0811],
              [58.542709, 34.0762658],
              [58.5560986, 34.058633],
              [58.5736728, 34.0513003],
              [58.6007306, 34.0569264],
              [58.6239816, 34.0579138],
              [58.6347347, 34.0637928],
              [58.6445614, 34.0736577],
              [58.6462279, 34.074208],
              [58.6473412, 34.0744967],
              [58.6481748, 34.0744967],
              [58.6509545, 34.0761566],
              [58.6559547, 34.0836526],
              [58.6562277, 34.0839233],
              [58.6578946, 34.0875405],
              [58.6692076, 34.0878731],
              [58.6725409, 34.09703],
              [58.6847031, 34.105881],
              [58.6861909, 34.1082827],
              [58.6940776, 34.1064393],
              [58.7057745, 34.099937],
              [58.7077145, 34.099937],
              [58.7085476, 34.1002078],
              [58.7118809, 34.099937],
              [58.7127141, 34.0996573],
              [58.7138275, 34.0996572],
              [58.7143809, 34.0993774],
              [58.7152142, 34.0993774],
              [58.7163274, 34.0988268],
              [58.7185475, 34.0982672],
              [58.748827, 34.0893767],
              [58.8079997, 34.0946568],
              [58.8113329, 34.0985469],
              [58.8213328, 34.1063272],
              [58.8249462, 34.1082677],
              [58.8468926, 34.1129882],
              [58.8477259, 34.113268],
              [58.8763125, 34.0879617],
              [58.8777059, 34.0876818],
              [58.8790923, 34.0876818],
              [58.8796458, 34.0874019],
              [58.8810392, 34.0874019],
              [58.8877057, 34.0860115],
              [58.8893722, 34.0860115],
              [58.8938121, 34.0849009],
              [58.8949254, 34.0849009],
              [58.9581295, 34.0793939],
              [58.9741776, 34.0949408],
              [58.9894575, 34.0988308],
              [58.9964509, 34.1211839],
              [58.997284, 34.1217432],
              [58.999231, 34.1222937],
              [59.0311905, 34.1338057],
              [59.0314705, 34.1340765],
              [59.0317439, 34.1343562],
              [59.0323037, 34.134636],
              [59.0323037, 34.1349156],
              [59.0328573, 34.1349157],
              [59.0331373, 34.1351864],
              [59.0481369, 34.1338057],
              [59.0489705, 34.1335259],
              [59.0525768, 34.1335259],
              [59.053137, 34.1332462],
              [59.0536901, 34.1335258],
              [59.0545238, 34.1332462],
              [59.0667502, 34.1332461],
              [59.0678568, 34.1335258],
              [59.0759168, 34.1335258],
              [59.0767499, 34.1332461],
              [59.101903, 34.1218781],
              [59.1032893, 34.1221579],
              [59.1113493, 34.1216073],
              [59.1132891, 34.1210477],
              [59.1155161, 34.1210477],
              [59.1199556, 34.120488],
              [59.1342541, 34.1137946],
              [59.1552352, 34.1185475],
              [59.162462, 34.1190981],
              [59.1627355, 34.1193778],
              [59.1641288, 34.1193778],
              [59.1644019, 34.1196576],
              [59.1657953, 34.1196577],
              [59.179916, 34.1245952],
              [59.1899116, 34.1175212],
              [59.1904652, 34.1175212],
              [59.2134686, 34.1158542],
              [59.2140287, 34.1161341],
              [59.2145822, 34.1161343],
              [59.2148623, 34.1164141],
              [59.219582, 34.1169649],
              [59.2215289, 34.1161341],
              [59.2223621, 34.1161341],
              [59.2248622, 34.1150236],
              [59.2490283, 34.094464],
              [59.2501415, 34.0939042],
              [59.2504149, 34.0933535],
              [59.2576417, 34.0891818],
              [59.259028, 34.088631],
              [59.2907938, 34.0860941],
              [59.291907, 34.0855393],
              [59.3030136, 34.0805411],
              [59.3466329, 34.1082668],
              [59.347193, 34.1079869],
              [59.349413, 34.1079869],
              [59.3499661, 34.1077071],
              [59.3753322, 34.1168924],
              [59.3758853, 34.1171722],
              [59.3764455, 34.1171722],
              [59.3767185, 34.1168924],
              [59.3769986, 34.1166217],
              [59.3772788, 34.1163419],
              [59.3781124, 34.1155116],
              [59.3781124, 34.1152319],
              [59.4044491, 34.108678],
              [59.4236752, 34.0867869],
              [59.4573208, 34.0805313],
              [59.4672772, 34.0617616],
              [59.4916531, 34.0523753],
              [59.5632369, 34.0503742],
              [59.563237, 34.0500944],
              [59.6222608, 34.0478125],
              [59.633274, 34.0495305],
              [59.6407757, 34.0497767],
              [59.6484806, 34.0431196],
              [59.6608505, 34.03144],
              [59.6692114, 34.0304952],
              [59.6734306, 34.028219],
              [59.7041652, 34.0322782],
              [59.7225379, 34.0272684],
              [59.7498247, 34.0179848],
              [59.7712897, 34.0183763],
              [59.8148916, 34.0075621],
              [59.8250197, 33.9966042],
              [59.8742118, 33.9777986],
              [59.9583621, 33.9747657],
              [60.0088541, 33.9730135],
              [60.0924676, 33.9729763],
              [60.1199334, 33.9570306],
              [60.0880562, 33.9277046],
              [60.0921432, 33.9089644],
              [60.1146895, 33.9047552],
              [60.1152426, 33.9036452],
              [60.1158028, 33.9033655],
              [60.1163559, 33.9022556],
              [60.119409, 33.8983661],
              [60.1336731, 33.8841068],
              [60.1352422, 33.8825379],
              [60.136909, 33.8828177],
              [60.1374691, 33.8828176],
              [60.1438556, 33.8839276],
              [60.145522, 33.8839276],
              [60.1460756, 33.8842074],
              [60.147742, 33.8842074],
              [60.1535823, 33.8858678],
              [60.1544156, 33.8864273],
              [60.1571887, 33.8875372],
              [60.1710819, 33.8917063],
              [60.1841417, 33.9027955],
              [60.1858081, 33.9033549],
              [60.1863617, 33.9039053],
              [60.2183077, 33.9277889],
              [60.2605676, 33.9340951],
              [60.2625075, 33.9360357],
              [60.2812951, 33.9331065],
              [60.3334801, 33.9524742],
              [60.3852783, 33.931828],
              [60.396945, 33.9365513],
              [60.4005513, 33.9373823],
              [60.4149977, 33.9409948],
              [60.533076, 34.0002495],
              [60.5176034, 34.0617567],
              [60.5193415, 34.0662727],
              [60.5180749, 34.0703647],
              [60.51788, 34.0724107],
              [60.5179774, 34.0752362],
              [60.5194389, 34.0772822],
              [60.5187569, 34.0811794],
              [60.5191466, 34.0826408],
              [60.5204132, 34.0860509],
              [60.5203158, 34.0902404],
              [60.5209978, 34.0932607],
              [60.5224592, 34.0955016],
              [60.5210952, 34.1009576],
              [60.5226541, 34.1065111],
              [60.5256744, 34.1100186],
              [60.528305, 34.1153772],
              [60.5285973, 34.1187872],
              [60.5308666, 34.1226471],
              [60.5316176, 34.1254124],
              [60.533761, 34.1284328],
              [60.5338585, 34.1341811],
              [60.5351251, 34.1396372],
              [60.5363916, 34.1436318],
              [60.5369762, 34.1486981],
              [60.5374215, 34.150697],
              [60.537991, 34.151212],
              [60.538363, 34.15184],
              [60.538645, 34.152204],
              [60.539007, 34.152323],
              [60.5399, 34.153008],
              [60.540809, 34.154076],
              [60.541025, 34.154717],
              [60.541289, 34.15517],
              [60.541832, 34.155828],
              [60.543006, 34.156298],
              [60.543292, 34.156559],
              [60.543409, 34.157441],
              [60.54382, 34.158399],
              [60.544884, 34.160104],
              [60.546077, 34.160466],
              [60.546719, 34.160967],
              [60.547109, 34.161365],
              [60.54802, 34.161922],
              [60.548589, 34.162359],
              [60.549418, 34.162901],
              [60.550573, 34.163371],
              [60.551236, 34.164082],
              [60.551847, 34.165385],
              [60.552249, 34.165871],
              [60.553875, 34.166998],
              [60.554707, 34.168353],
              [60.554832, 34.170323],
              [60.555394, 34.171126],
              [60.555569, 34.171677],
              [60.555514, 34.172402],
              [60.555807, 34.172746],
              [60.55607, 34.173517],
              [60.556518, 34.174452],
              [60.557455, 34.17597],
              [60.557639, 34.176199],
              [60.557658, 34.176567],
              [60.557999, 34.177489],
              [60.558159, 34.177698],
              [60.558242, 34.177995],
              [60.55851, 34.178499],
              [60.558746, 34.178725],
              [60.558773, 34.179007],
              [60.558636, 34.17934],
              [60.558641, 34.179654],
              [60.558887, 34.180163],
              [60.558886, 34.180485],
              [60.558538, 34.181745],
              [60.558256, 34.182089],
              [60.558119, 34.182517],
              [60.558286, 34.182797],
              [60.558572, 34.182935],
              [60.558916, 34.183538],
              [60.558912, 34.183874],
              [60.558846, 34.184107],
              [60.55934, 34.184823],
              [60.560024, 34.185332],
              [60.56067, 34.185693],
              [60.56109, 34.186065],
              [60.561441, 34.186613],
              [60.561845, 34.187612],
              [60.562257, 34.188304],
              [60.562629, 34.189086],
              [60.563501, 34.19001],
              [60.565261, 34.192074],
              [60.565496, 34.192557],
              [60.565676, 34.192708],
              [60.566147, 34.192799],
              [60.566573, 34.192786],
              [60.567065, 34.192893],
              [60.567522, 34.193112],
              [60.567988, 34.19342],
              [60.568494, 34.193571],
              [60.570696, 34.195585],
              [60.57199, 34.196867],
              [60.572697, 34.197463],
              [60.573477, 34.198268],
              [60.573887, 34.19877],
              [60.574326, 34.198905],
              [60.575368, 34.200042],
              [60.576014, 34.200248],
              [60.57677, 34.200385],
              [60.577765, 34.200883],
              [60.578171, 34.201315],
              [60.578553, 34.201496],
              [60.578999, 34.201628],
              [60.579738, 34.202442],
              [60.580202, 34.202718],
              [60.580632, 34.203423],
              [60.580968, 34.204227],
              [60.581084, 34.204663],
              [60.581633, 34.205335],
              [60.581626, 34.206246],
              [60.581927, 34.207174],
              [60.582415, 34.208358],
              [60.582812, 34.20885],
              [60.583481, 34.209106],
              [60.584044, 34.209449],
              [60.584483, 34.209869],
              [60.584796, 34.210841],
              [60.585105, 34.211402],
              [60.585601, 34.211818],
              [60.585831, 34.212179],
              [60.585931, 34.21266],
              [60.586545, 34.213094],
              [60.5872, 34.213307],
              [60.587616, 34.213355],
              [60.588539, 34.213804],
              [60.588709, 34.213799],
              [60.588945, 34.213862],
              [60.589708, 34.21382],
              [60.590055, 34.214027],
              [60.590143, 34.214187],
              [60.590453, 34.214471],
              [60.590592, 34.214482],
              [60.590977, 34.214771],
              [60.590997, 34.215028],
              [60.591083, 34.215145],
              [60.591468, 34.215337],
              [60.591654, 34.215492],
              [60.59175, 34.215903],
              [60.591746, 34.216401],
              [60.6022896, 34.2263901],
              [60.6206949, 34.2438248],
              [60.6339581, 34.2528679],
              [60.6405898, 34.2582938],
              [60.6426294, 34.2589513],
              [60.644407, 34.259816],
              [60.645202, 34.260147],
              [60.645864, 34.260778],
              [60.646716, 34.26107],
              [60.647652, 34.261249],
              [60.64867, 34.261371],
              [60.649524, 34.261287],
              [60.650294, 34.261615],
              [60.6509395, 34.2619545],
              [60.651254, 34.26212],
              [60.652607, 34.263176],
              [60.653456, 34.263742],
              [60.65478, 34.264476],
              [60.655171, 34.264901],
              [60.65546, 34.265381],
              [60.657025, 34.266399],
              [60.65735, 34.26711],
              [60.657587, 34.267258],
              [60.657954, 34.267302],
              [60.659029, 34.267235],
              [60.65968, 34.267426],
              [60.661672, 34.267809],
              [60.663668, 34.268786],
              [60.664366, 34.269084],
              [60.664996, 34.269618],
              [60.665939, 34.270763],
              [60.666498, 34.27113],
              [60.668959, 34.272035],
              [60.66949, 34.272504],
              [60.669679, 34.272857],
              [60.670531, 34.273789],
              [60.671018, 34.274473],
              [60.6713, 34.275018],
              [60.671421, 34.275392],
              [60.671481, 34.275952],
              [60.671443, 34.277219],
              [60.671478, 34.27783],
              [60.671647, 34.278862],
              [60.671616, 34.279389],
              [60.671253, 34.279574],
              [60.670894, 34.279996],
              [60.670076, 34.281337],
              [60.669904, 34.281867],
              [60.670017, 34.282671],
              [60.670137, 34.28315],
              [60.671032, 34.285968],
              [60.670956, 34.286574],
              [60.67163, 34.289187],
              [60.671705, 34.289315],
              [60.6725059, 34.2899628],
              [60.6727811, 34.290704],
              [60.673001, 34.291879],
              [60.672799, 34.29307],
              [60.6730099, 34.2937434],
              [60.6753553, 34.3025138],
              [60.6830315, 34.3086327],
              [60.686496, 34.310708],
              [60.696298, 34.310742],
              [60.737434, 34.307223],
              [60.784324, 34.310058],
              [60.834018, 34.310593],
              [60.882301, 34.303396],
              [60.918373, 34.304756],
              [60.897928, 34.324435],
              [60.897209, 34.32447],
              [60.896348, 34.324638],
              [60.896256, 34.325084],
              [60.89628, 34.325435],
              [60.896177, 34.325554],
              [60.89602, 34.325901],
              [60.895609, 34.327118],
              [60.895162, 34.327661],
              [60.895114, 34.327844],
              [60.895222, 34.328838],
              [60.895552, 34.329663],
              [60.895889, 34.329988],
              [60.896126, 34.330093],
              [60.896321, 34.33031],
              [60.896519, 34.330843],
              [60.896515, 34.330991],
              [60.896418, 34.331084],
              [60.896218, 34.331151],
              [60.895706, 34.331618],
              [60.895885, 34.332768],
              [60.895667, 34.333301],
              [60.89545, 34.333568],
              [60.895282, 34.333712],
              [60.895069, 34.33375],
              [60.894855, 34.333588],
              [60.894609, 34.333379],
              [60.894124, 34.332767],
              [60.893768, 34.332152],
              [60.893392, 34.332026],
              [60.89302, 34.332058],
              [60.892615, 34.332001],
              [60.8913311, 34.332597],
              [60.8886348, 34.3358766],
              [60.8871794, 34.3380256],
              [60.886175, 34.3400047],
              [60.885126, 34.3409121],
              [60.8848989, 34.3409123],
              [60.884278, 34.3411503],
              [60.882934, 34.342794],
              [60.883053, 34.342991],
              [60.88313, 34.343496],
              [60.883115, 34.343762],
              [60.883044, 34.343954],
              [60.882832, 34.344268],
              [60.882823, 34.344506],
              [60.882943, 34.34497],
              [60.882706, 34.345242],
              [60.88216, 34.345634],
              [60.881894, 34.34595],
              [60.881552, 34.346687],
              [60.88137, 34.347275],
              [60.881314, 34.347877],
              [60.881097, 34.348308],
              [60.881021, 34.348134],
              [60.8811, 34.347659],
              [60.881017, 34.347423],
              [60.880803, 34.347124],
              [60.880323, 34.346992],
              [60.8798693, 34.3469798],
              [60.879247, 34.3468787],
              [60.8788333, 34.3473618],
              [60.878344, 34.347256],
              [60.877599, 34.347255],
              [60.877116, 34.347501],
              [60.876647, 34.347542],
              [60.87622, 34.347322],
              [60.875766, 34.347268],
              [60.874213, 34.347791],
              [60.873756, 34.347714],
              [60.873546, 34.347737],
              [60.873159, 34.347841],
              [60.872367, 34.347925],
              [60.87168, 34.348169],
              [60.871173, 34.348205],
              [60.871119, 34.348253],
              [60.871107, 34.348762],
              [60.871328, 34.34917],
              [60.871165, 34.349311],
              [60.870672, 34.349489],
              [60.870213, 34.349736],
              [60.869843, 34.350063],
              [60.8707662, 34.3525624],
              [60.8707587, 34.3559104],
              [60.8695632, 34.3572285],
              [60.8689077, 34.3575241],
              [60.867688, 34.357781],
              [60.867553, 34.357848],
              [60.866977, 34.35796],
              [60.866873, 34.358122],
              [60.866682, 34.358843],
              [60.866648, 34.359337],
              [60.866729, 34.359582],
              [60.866703, 34.359828],
              [60.866638, 34.359959],
              [60.866412, 34.360229],
              [60.865904, 34.360118],
              [60.865742, 34.360142],
              [60.865206, 34.360597],
              [60.864972, 34.36065],
              [60.86458, 34.360177],
              [60.864361, 34.360145],
              [60.863606, 34.36046],
              [60.863436, 34.360568],
              [60.863157, 34.360859],
              [60.86302, 34.361051],
              [60.863128, 34.361403],
              [60.863114, 34.361715],
              [60.862789, 34.362625],
              [60.862773, 34.362785],
              [60.862875, 34.363075],
              [60.86281, 34.363347],
              [60.862718, 34.363425],
              [60.862153, 34.363493],
              [60.862001, 34.363656],
              [60.861839, 34.363677],
              [60.86135, 34.363523],
              [60.861216, 34.363526],
              [60.861028, 34.363739],
              [60.861261, 34.364294],
              [60.861535, 34.364667],
              [60.861722, 34.365178],
              [60.861714, 34.365393],
              [60.861604, 34.365454],
              [60.86078, 34.365477],
              [60.860625, 34.365566],
              [60.860469, 34.36582],
              [60.860462, 34.366258],
              [60.860411, 34.366356],
              [60.859693, 34.366359],
              [60.859273, 34.366492],
              [60.859224, 34.366586],
              [60.859143, 34.367348],
              [60.85893, 34.367702],
              [60.858834, 34.367783],
              [60.858531, 34.36776],
              [60.857176, 34.367884],
              [60.85658, 34.367852],
              [60.855985, 34.367942],
              [60.855011, 34.367854],
              [60.854229, 34.367919],
              [60.853923, 34.367987],
              [60.853466, 34.367994],
              [60.852514, 34.367959],
              [60.851906, 34.367834],
              [60.850855, 34.367905],
              [60.850088, 34.368068],
              [60.849798, 34.368217],
              [60.849631, 34.368448],
              [60.849552, 34.368837],
              [60.849302, 34.369298],
              [60.84887, 34.370411],
              [60.848547, 34.370733],
              [60.848311, 34.371566],
              [60.847872, 34.372138],
              [60.8479, 34.372325],
              [60.848172, 34.373021],
              [60.848487, 34.373777],
              [60.848704, 34.374151],
              [60.848838, 34.374644],
              [60.849186, 34.375187],
              [60.849283, 34.37633],
              [60.849752, 34.377088],
              [60.849885, 34.377979],
              [60.850123, 34.378823],
              [60.850143, 34.37971],
              [60.85007, 34.380362],
              [60.85026, 34.380765],
              [60.850057, 34.381226],
              [60.849864, 34.382122],
              [60.849786, 34.382199],
              [60.849626, 34.382239],
              [60.84863, 34.382284],
              [60.848429, 34.38256],
              [60.848475, 34.383334],
              [60.848387, 34.38342],
              [60.847742, 34.383749],
              [60.847539, 34.384003],
              [60.847094, 34.384271],
              [60.846922, 34.385567],
              [60.846833, 34.385844],
              [60.846562, 34.386319],
              [60.846383, 34.386504],
              [60.846342, 34.386803],
              [60.846406, 34.387161],
              [60.846715, 34.387531],
              [60.84677, 34.387664],
              [60.846782, 34.38815],
              [60.84672, 34.388345],
              [60.846497, 34.38854],
              [60.846038, 34.389107],
              [60.845898, 34.38935],
              [60.845526, 34.389677],
              [60.845453, 34.389822],
              [60.845365, 34.390279],
              [60.845919, 34.391202],
              [60.846072, 34.391617],
              [60.846062, 34.391701],
              [60.845741, 34.392108],
              [60.84546, 34.39224],
              [60.845241, 34.392516],
              [60.84445, 34.393185],
              [60.844279, 34.393253],
              [60.844024, 34.393207],
              [60.843867, 34.393252],
              [60.843575, 34.393453],
              [60.843514, 34.393647],
              [60.843684, 34.394272],
              [60.843704, 34.394407],
              [60.843653, 34.394567],
              [60.843077, 34.394697],
              [60.842895, 34.394781],
              [60.84265, 34.394931],
              [60.842321, 34.395293],
              [60.842322, 34.3955],
              [60.842141, 34.395985],
              [60.842237, 34.396238],
              [60.842413, 34.396467],
              [60.842292, 34.396704],
              [60.841432, 34.397313],
              [60.840365, 34.397751],
              [60.84003, 34.398003],
              [60.839882, 34.398373],
              [60.839699, 34.398608],
              [60.839662, 34.398782],
              [60.839719, 34.399014],
              [60.840053, 34.399636],
              [60.840093, 34.399952],
              [60.839557, 34.400275],
              [60.839164, 34.400381],
              [60.838638, 34.40101],
              [60.838627, 34.401124],
              [60.838804, 34.401518],
              [60.838769, 34.401684],
              [60.838616, 34.401803],
              [60.838169, 34.401954],
              [60.838074, 34.402041],
              [60.838103, 34.40237],
              [60.838289, 34.402496],
              [60.838651, 34.403053],
              [60.838753, 34.403117],
              [60.839318, 34.403183],
              [60.840387, 34.403463],
              [60.840937, 34.403783],
              [60.841111, 34.403965],
              [60.841367, 34.404506],
              [60.842705, 34.40504],
              [60.843687, 34.405856],
              [60.843833, 34.406143],
              [60.843893, 34.406706],
              [60.843873, 34.40705],
              [60.843754, 34.407548],
              [60.843599, 34.407853],
              [60.842749, 34.408339],
              [60.84244, 34.40872],
              [60.842043, 34.40956],
              [60.841881, 34.410356],
              [60.841701, 34.410641],
              [60.840972, 34.41105],
              [60.840119, 34.411228],
              [60.839814, 34.411398],
              [60.839603, 34.411719],
              [60.839172, 34.411708],
              [60.838599, 34.412024],
              [60.838305, 34.41229],
              [60.83806, 34.412382],
              [60.837562, 34.41247],
              [60.836761, 34.412391],
              [60.835723, 34.412655],
              [60.835501, 34.412824],
              [60.835383, 34.412998],
              [60.835229, 34.413402],
              [60.834877, 34.413748],
              [60.83468, 34.414022],
              [60.834591, 34.41434],
              [60.834475, 34.414447],
              [60.834007, 34.414478],
              [60.833654, 34.414649],
              [60.832984, 34.414749],
              [60.832599, 34.415013],
              [60.8322, 34.415195],
              [60.831626, 34.415245],
              [60.830901, 34.415409],
              [60.829791, 34.415857],
              [60.829733, 34.416101],
              [60.829851, 34.416517],
              [60.830164, 34.417291],
              [60.830508, 34.417778],
              [60.830551, 34.417967],
              [60.830447, 34.418532],
              [60.830404, 34.419169],
              [60.830454, 34.420072],
              [60.830015, 34.42013],
              [60.829861, 34.420206],
              [60.829554, 34.420394],
              [60.828952, 34.420916],
              [60.829082, 34.421378],
              [60.829062, 34.421507],
              [60.828956, 34.421659],
              [60.828844, 34.422315],
              [60.828682, 34.422409],
              [60.828492, 34.4224],
              [60.828159, 34.422283],
              [60.827622, 34.42264],
              [60.827637, 34.422933],
              [60.826762, 34.423126],
              [60.826635, 34.423236],
              [60.826603, 34.423353],
              [60.82694, 34.423776],
              [60.827261, 34.424585],
              [60.827308, 34.424977],
              [60.827278, 34.425283],
              [60.827495, 34.425669],
              [60.827512, 34.426035],
              [60.828181, 34.426566],
              [60.828257, 34.426675],
              [60.828034, 34.426775],
              [60.827902, 34.42698],
              [60.827874, 34.427412],
              [60.827808, 34.427541],
              [60.827239, 34.427921],
              [60.82722, 34.428035],
              [60.827295, 34.428341],
              [60.82725, 34.42847],
              [60.827433, 34.428762],
              [60.827414, 34.428826],
              [60.826937, 34.429053],
              [60.826113, 34.429053],
              [60.825609, 34.428624],
              [60.825455, 34.428592],
              [60.825221, 34.428785],
              [60.82507, 34.428826],
              [60.824572, 34.429102],
              [60.824004, 34.429203],
              [60.823391, 34.429142],
              [60.822808, 34.429275],
              [60.822457, 34.429279],
              [60.822148, 34.429559],
              [60.822255, 34.42993],
              [60.822086, 34.43051],
              [60.822112, 34.430822],
              [60.822228, 34.430921],
              [60.822227, 34.431235],
              [60.822103, 34.431407],
              [60.821739, 34.431678],
              [60.821348, 34.43186],
              [60.821064, 34.432256],
              [60.821183, 34.432484],
              [60.82115, 34.43298],
              [60.821272, 34.433268],
              [60.821364, 34.433692],
              [60.821234, 34.433979],
              [60.821223, 34.434147],
              [60.821279, 34.434291],
              [60.821612, 34.434472],
              [60.821876, 34.434683],
              [60.821739, 34.434984],
              [60.821682, 34.435326],
              [60.821721, 34.435837],
              [60.821196, 34.436185],
              [60.821331, 34.436605],
              [60.821487, 34.436784],
              [60.821506, 34.436876],
              [60.821305, 34.437213],
              [60.821189, 34.437762],
              [60.821248, 34.438108],
              [60.821666, 34.438339],
              [60.82173, 34.43852],
              [60.82189, 34.438719],
              [60.821506, 34.439513],
              [60.821365, 34.4396],
              [60.821249, 34.43991],
              [60.82128, 34.439998],
              [60.821222, 34.440224],
              [60.821156, 34.440333],
              [60.820998, 34.440408],
              [60.82103, 34.440689],
              [60.821201, 34.441111],
              [60.821367, 34.44124],
              [60.821625, 34.441661],
              [60.82169, 34.441862],
              [60.821639, 34.442314],
              [60.82124, 34.442531],
              [60.820816, 34.442897],
              [60.820647, 34.442868],
              [60.820458, 34.442899],
              [60.820113, 34.443038],
              [60.819761, 34.443688],
              [60.819719, 34.444321],
              [60.819147, 34.444483],
              [60.818896, 34.44434],
              [60.818304, 34.444488],
              [60.817877, 34.444739],
              [60.817099, 34.444959],
              [60.817045, 34.445051],
              [60.816607, 34.445279],
              [60.816527, 34.44538],
              [60.816367, 34.446284],
              [60.816142, 34.44676],
              [60.815622, 34.447592],
              [60.815685, 34.44785],
              [60.815656, 34.448253],
              [60.815405, 34.448366],
              [60.815302, 34.448524],
              [60.815099, 34.449242],
              [60.814725, 34.44995],
              [60.814567, 34.450472],
              [60.814585, 34.45089],
              [60.814508, 34.450817],
              [60.814489, 34.45054],
              [60.814361, 34.450349],
              [60.814062, 34.45022],
              [60.813668, 34.450693],
              [60.81313, 34.45157],
              [60.812992, 34.45174],
              [60.81285, 34.451831],
              [60.812205, 34.453348],
              [60.811957, 34.453599],
              [60.811729, 34.453968],
              [60.811601, 34.453962],
              [60.811348, 34.454217],
              [60.811215, 34.454785],
              [60.811396, 34.455261],
              [60.811088, 34.455565],
              [60.810792, 34.455751],
              [60.810696, 34.455924],
              [60.810424, 34.456093],
              [60.810188, 34.456533],
              [60.809671, 34.456823],
              [60.809584, 34.45702],
              [60.809553, 34.457356],
              [60.809583, 34.457805],
              [60.809144, 34.458333],
              [60.80894, 34.458685],
              [60.809045, 34.459171],
              [60.808932, 34.459256],
              [60.808811, 34.459557],
              [60.808812, 34.459693],
              [60.809023, 34.460319],
              [60.808642, 34.460408],
              [60.808555, 34.460519],
              [60.808474, 34.460911],
              [60.808374, 34.461131],
              [60.807977, 34.461219],
              [60.807639, 34.46145],
              [60.807459, 34.461703],
              [60.80739, 34.461911],
              [60.807362, 34.462389],
              [60.807435, 34.462496],
              [60.80747, 34.46273],
              [60.807454, 34.463055],
              [60.807608, 34.463268],
              [60.807727, 34.463348],
              [60.807854, 34.46373],
              [60.807655, 34.464124],
              [60.807563, 34.464505],
              [60.807415, 34.464736],
              [60.80739, 34.46495],
              [60.807601, 34.466344],
              [60.807704, 34.466704],
              [60.808064, 34.467548],
              [60.808645, 34.468636],
              [60.808756, 34.469008],
              [60.808711, 34.469515],
              [60.808613, 34.469721],
              [60.808642, 34.470057],
              [60.808858, 34.470381],
              [60.809271, 34.471493],
              [60.809274, 34.471653],
              [60.808798, 34.471701],
              [60.808545, 34.471846],
              [60.807819, 34.471973],
              [60.807416, 34.471888],
              [60.806705, 34.471912],
              [60.806441, 34.47201],
              [60.806357, 34.472122],
              [60.806073, 34.472262],
              [60.805708, 34.472162],
              [60.803932, 34.472194],
              [60.803754, 34.472311],
              [60.803585, 34.472892],
              [60.803372, 34.47305],
              [60.802743, 34.473018],
              [60.802393, 34.473087],
              [60.802088, 34.473226],
              [60.801661, 34.473509],
              [60.801542, 34.47396],
              [60.801142, 34.474348],
              [60.801075, 34.474626],
              [60.800906, 34.475008],
              [60.800831, 34.475064],
              [60.800364, 34.474966],
              [60.80024, 34.474866],
              [60.799737, 34.474766],
              [60.79923, 34.474186],
              [60.798949, 34.473942],
              [60.797746, 34.473151],
              [60.797528, 34.473042],
              [60.797128, 34.472947],
              [60.796075, 34.473385],
              [60.795587, 34.473502],
              [60.795337, 34.473683],
              [60.794946, 34.473812],
              [60.794446, 34.473779],
              [60.794209, 34.473806],
              [60.793964, 34.47392],
              [60.793602, 34.474238],
              [60.793479, 34.474412],
              [60.79338, 34.474864],
              [60.792778, 34.475289],
              [60.792452, 34.47541],
              [60.791904, 34.475395],
              [60.791716, 34.475431],
              [60.791046, 34.475696],
              [60.790596, 34.475822],
              [60.790455, 34.476061],
              [60.790219, 34.476202],
              [60.790074, 34.476355],
              [60.789936, 34.476961],
              [60.789762, 34.477471],
              [60.789617, 34.477702],
              [60.788204, 34.479516],
              [60.787299, 34.481016],
              [60.787096, 34.48147],
              [60.786463, 34.482361],
              [60.786546, 34.482717],
              [60.787014, 34.483541],
              [60.787014, 34.483671],
              [60.786485, 34.483774],
              [60.784613, 34.48375],
              [60.784307, 34.483781],
              [60.783791, 34.483919],
              [60.783585, 34.484065],
              [60.783185, 34.484485],
              [60.782969, 34.485179],
              [60.782883, 34.485362],
              [60.782734, 34.485498],
              [60.78253, 34.485536],
              [60.78177, 34.485479],
              [60.78114, 34.485161],
              [60.780835, 34.485257],
              [60.780411, 34.485484],
              [60.780206, 34.485523],
              [60.779687, 34.485479],
              [60.7794243, 34.4858567],
              [60.779077, 34.486356],
              [60.77898, 34.486566],
              [60.77849, 34.486623],
              [60.778181, 34.486705],
              [60.777797, 34.486709],
              [60.777212, 34.486396],
              [60.777104, 34.486392],
              [60.777055, 34.486326],
              [60.77663, 34.48631],
              [60.776112, 34.486475],
              [60.775715, 34.486686],
              [60.774981, 34.486922],
              [60.774813, 34.487152],
              [60.774483, 34.48742],
              [60.774236, 34.487789],
              [60.774182, 34.488012],
              [60.773695, 34.488553],
              [60.773602, 34.488718],
              [60.751371, 34.507627],
              [60.741861, 34.510827],
              [60.739083, 34.518086],
              [60.742346, 34.526945],
              [60.790337, 34.537761],
              [60.822836, 34.544868],
              [60.825974, 34.539144],
              [60.83095, 34.544876],
              [60.84865, 34.542077],
              [60.897272, 34.56726],
              [60.903606, 34.580335],
              [60.910524, 34.596911],
              [60.915095, 34.607009],
              [60.918034, 34.613896],
              [60.9214342, 34.6213163],
              [60.922214, 34.623018],
              [60.922306, 34.622878],
              [60.922848, 34.622432],
              [60.923185, 34.622264],
              [60.923434, 34.622231],
              [60.924173, 34.622262],
              [60.924961, 34.622179],
              [60.925485, 34.621959],
              [60.926355, 34.621497],
              [60.926526, 34.621535],
              [60.926876, 34.621424],
              [60.927289, 34.621367],
              [60.927646, 34.621383],
              [60.927917, 34.621346],
              [60.928187, 34.621188],
              [60.92871, 34.621089],
              [60.929401, 34.621432],
              [60.929556, 34.621436],
              [60.929666, 34.621401],
              [60.929897, 34.621185],
              [60.93003, 34.621131],
              [60.930266, 34.621157],
              [60.930645, 34.621086],
              [60.930703, 34.621182],
              [60.930654, 34.621366],
              [60.93069, 34.621484],
              [60.930936, 34.621898],
              [60.931029, 34.622002],
              [60.931343, 34.622142],
              [60.9318, 34.622076],
              [60.932474, 34.621876],
              [60.932662, 34.621742],
              [60.932814, 34.621511],
              [60.93298, 34.621451],
              [60.933582, 34.621527],
              [60.933941, 34.621717],
              [60.935302, 34.62154],
              [60.935707, 34.621819],
              [60.935923, 34.621876],
              [60.936511, 34.622236],
              [60.936791, 34.622464],
              [60.937039, 34.622843],
              [60.937444, 34.623014],
              [60.93777, 34.623044],
              [60.938147, 34.623152],
              [60.938299, 34.623837],
              [60.938541, 34.624089],
              [60.938789, 34.624207],
              [60.938931, 34.624383],
              [60.939049, 34.624383],
              [60.939032, 34.624099],
              [60.939072, 34.624012],
              [60.93949, 34.623577],
              [60.940163, 34.623183],
              [60.940386, 34.622839],
              [60.940398, 34.622315],
              [60.940298, 34.621995],
              [60.940346, 34.621878],
              [60.940757, 34.621773],
              [60.941412, 34.621826],
              [60.941822, 34.621916],
              [60.942267, 34.621834],
              [60.942633, 34.621849],
              [60.942793, 34.62187],
              [60.942914, 34.62196],
              [60.943369, 34.621985],
              [60.943873, 34.621837],
              [60.944075, 34.621484],
              [60.944429, 34.62124],
              [60.945096, 34.6212],
              [60.945882, 34.620945],
              [60.946214, 34.621024],
              [60.946565, 34.621028],
              [60.9469, 34.621197],
              [60.946951, 34.621022],
              [60.947158, 34.620737],
              [60.94727, 34.620618],
              [60.94748, 34.620555],
              [60.94883, 34.620614],
              [60.948997, 34.620667],
              [60.949146, 34.620833],
              [60.949385, 34.620972],
              [60.949605, 34.620903],
              [60.949819, 34.620678],
              [60.950001, 34.620596],
              [60.950325, 34.620562],
              [60.950508, 34.62046],
              [60.950953, 34.620386],
              [60.951072, 34.620289],
              [60.951362, 34.620165],
              [60.951981, 34.619996],
              [60.952342, 34.620035],
              [60.952679, 34.620139],
              [60.953089, 34.620332],
              [60.953292, 34.620384],
              [60.953364, 34.620358],
              [60.953354, 34.620161],
              [60.953154, 34.619941],
              [60.95288, 34.619446],
              [60.952891, 34.619073],
              [60.952943, 34.619012],
              [60.954024, 34.618622],
              [60.954812, 34.618612],
              [60.955276, 34.618522],
              [60.955564, 34.618309],
              [60.955808, 34.618019],
              [60.956509, 34.617403],
              [60.956933, 34.616827],
              [60.957133, 34.616715],
              [60.957415, 34.61667],
              [60.957575, 34.616675],
              [60.958055, 34.616942],
              [60.958322, 34.617251],
              [60.958705, 34.617572],
              [60.959121, 34.617739],
              [60.95957, 34.617833],
              [60.9597, 34.617921],
              [60.960223, 34.61845],
              [60.960387, 34.61926],
              [60.960543, 34.619409],
              [60.960805, 34.619422],
              [60.961321, 34.619161],
              [60.96148, 34.619132],
              [60.961952, 34.619168],
              [60.962251, 34.619296],
              [60.962458, 34.619316],
              [60.962544, 34.619307],
              [60.962825, 34.6191],
              [60.963561, 34.619094],
              [60.963936, 34.619185],
              [60.964095, 34.619293],
              [60.964375, 34.619894],
              [60.965126, 34.619756],
              [60.966728, 34.619935],
              [60.967264, 34.619857],
              [60.968087, 34.619934],
              [60.968591, 34.620076],
              [60.969367, 34.620446],
              [60.969912, 34.620869],
              [60.970249, 34.621026],
              [60.971409, 34.62063],
              [60.971811, 34.620115],
              [60.972235, 34.620006],
              [60.972886, 34.619926],
              [60.973992, 34.620225],
              [60.97487, 34.62079],
              [60.975053, 34.62108],
              [60.975293, 34.621261],
              [60.975501, 34.621327],
              [60.976534, 34.621476],
              [60.976804, 34.621576],
              [60.977235, 34.621617],
              [60.977416, 34.621549],
              [60.978275, 34.620797],
              [60.978453, 34.620718],
              [60.978626, 34.620715],
              [60.978845, 34.620807],
              [60.979089, 34.620947],
              [60.979262, 34.62113],
              [60.979441, 34.621181],
              [60.98008, 34.62114],
              [60.980409, 34.621176],
              [60.981149, 34.620871],
              [60.981239, 34.62073],
              [60.981229, 34.620477],
              [60.981543, 34.619407],
              [60.982116, 34.6193],
              [60.982285, 34.61933],
              [60.982592, 34.619759],
              [60.982858, 34.620036],
              [60.98306, 34.620144],
              [60.983204, 34.620135],
              [60.983717, 34.61994],
              [60.984492, 34.619758],
              [60.984687, 34.619816],
              [60.984934, 34.62],
              [60.984991, 34.620268],
              [60.98514, 34.620386],
              [60.985177, 34.620492],
              [60.985246, 34.620975],
              [60.985913, 34.621712],
              [61.000798, 34.642976],
              [61.000713, 34.643149],
              [61.000292, 34.643673],
              [61.000316, 34.64378],
              [61.000387, 34.643843],
              [61.000653, 34.643922],
              [61.000802, 34.644127],
              [61.000921, 34.64558],
              [61.001124, 34.646033],
              [61.001539, 34.646377],
              [61.00145, 34.646606],
              [61.001534, 34.646926],
              [61.001444, 34.647031],
              [61.001419, 34.647395],
              [61.001919, 34.648622],
              [61.00184, 34.648728],
              [61.001708, 34.648731],
              [61.001676, 34.648767],
              [61.00133, 34.649554],
              [61.000742, 34.650024],
              [61.000491, 34.650325],
              [61.000326, 34.650445],
              [60.999829, 34.650619],
              [60.999644, 34.6508],
              [60.999608, 34.651185],
              [60.999742, 34.652063],
              [60.9997, 34.652424],
              [60.999483, 34.65325],
              [60.999146, 34.65373],
              [60.999251, 34.654057],
              [60.999277, 34.654428],
              [60.99925, 34.655814],
              [61.000064, 34.684581],
              [61.0007206, 34.6955096],
              [61.0023943, 34.7062354],
              [61.0027725, 34.7086939],
              [61.0028093, 34.7090451],
              [61.002802, 34.7092165],
              [61.0034564, 34.709975],
              [61.003844, 34.711239],
              [61.003819, 34.711317],
              [61.004046, 34.711486],
              [61.00435, 34.711859],
              [61.004814, 34.712127],
              [61.005063, 34.712411],
              [61.005866, 34.712623],
              [61.006146, 34.712796],
              [61.006263, 34.713143],
              [61.006246, 34.713282],
              [61.006449, 34.713481],
              [61.006588, 34.713557],
              [61.00678, 34.713584],
              [61.007471, 34.714004],
              [61.007551, 34.714223],
              [61.007521, 34.715361],
              [61.007598, 34.715508],
              [61.008088, 34.71575],
              [61.008301, 34.716067],
              [61.008454, 34.716195],
              [61.008869, 34.71641],
              [61.0093, 34.717081],
              [61.009983, 34.717495],
              [61.010126, 34.717649],
              [61.010276, 34.718033],
              [61.010604, 34.718298],
              [61.010771, 34.718941],
              [61.01075, 34.719596],
              [61.010968, 34.72001],
              [61.010977, 34.720125],
              [61.010885, 34.720345],
              [61.01103, 34.720961],
              [61.01137, 34.721306],
              [61.011651, 34.721733],
              [61.011962, 34.722057],
              [61.012034, 34.722263],
              [61.012331, 34.722735],
              [61.012466, 34.722857],
              [61.01303, 34.723013],
              [61.013323, 34.723202],
              [61.013299, 34.723674],
              [61.012963, 34.724349],
              [61.012945, 34.725395],
              [61.013082, 34.726783],
              [61.013318, 34.727629],
              [61.013514, 34.728068],
              [61.013534, 34.728291],
              [61.01421, 34.729024],
              [61.014356, 34.72933],
              [61.014298, 34.729606],
              [61.014338, 34.730123],
              [61.014421, 34.730576],
              [61.014513, 34.730718],
              [61.01453, 34.731051],
              [61.014416, 34.73125],
              [61.014272, 34.731752],
              [61.014593, 34.732442],
              [61.014867, 34.732687],
              [61.015217, 34.732879],
              [61.016372, 34.733215],
              [61.016828, 34.733608],
              [61.017145, 34.733767],
              [61.017399, 34.733868],
              [61.018262, 34.734064],
              [61.01855, 34.734266],
              [61.01883, 34.734675],
              [61.018971, 34.735403],
              [61.019051, 34.735526],
              [61.019529, 34.735892],
              [61.019695, 34.736232],
              [61.019595, 34.73689],
              [61.01959, 34.737235],
              [61.019665, 34.737733],
              [61.019933, 34.738123],
              [61.020191, 34.73835],
              [61.020612, 34.738588],
              [61.02106, 34.738697],
              [61.022327, 34.738593],
              [61.022884, 34.738672],
              [61.023219, 34.738777],
              [61.023803, 34.739134],
              [61.023988, 34.739408],
              [61.024592, 34.740031],
              [61.024859, 34.740685],
              [61.025098, 34.740871],
              [61.025696, 34.741173],
              [61.02596, 34.741456],
              [61.026006, 34.74173],
              [61.025553, 34.742311],
              [61.025526, 34.742472],
              [61.025676, 34.743044],
              [61.025948, 34.743564],
              [61.026136, 34.744174],
              [61.02627, 34.744372],
              [61.02661, 34.744621],
              [61.026969, 34.744786],
              [61.027573, 34.74491],
              [61.028258, 34.744878],
              [61.028546, 34.744939],
              [61.028936, 34.745119],
              [61.029153, 34.745328],
              [61.029192, 34.745464],
              [61.029156, 34.745623],
              [61.029036, 34.745813],
              [61.028968, 34.746284],
              [61.029271, 34.746669],
              [61.029525, 34.746864],
              [61.030244, 34.747283],
              [61.030838, 34.74754],
              [61.031538, 34.74777],
              [61.032785, 34.748047],
              [61.033749, 34.748577],
              [61.034179, 34.748928],
              [61.034237, 34.749124],
              [61.034182, 34.749268],
              [61.034113, 34.749346],
              [61.033885, 34.74944],
              [61.033596, 34.749768],
              [61.033615, 34.749998],
              [61.033819, 34.750452],
              [61.03378, 34.750519],
              [61.0338, 34.750694],
              [61.034008, 34.751164],
              [61.034396, 34.751447],
              [61.035009, 34.751696],
              [61.035204, 34.751818],
              [61.03531, 34.75197],
              [61.035408, 34.752383],
              [61.035393, 34.752653],
              [61.035368, 34.752889],
              [61.035039, 34.753467],
              [61.035032, 34.753612],
              [61.035119, 34.753781],
              [61.035805, 34.753878],
              [61.036404, 34.754298],
              [61.036938, 34.754475],
              [61.03713, 34.754614],
              [61.037259, 34.754715],
              [61.037308, 34.754825],
              [61.037394, 34.755338],
              [61.037504, 34.755534],
              [61.037916, 34.755877],
              [61.038136, 34.756316],
              [61.038311, 34.75653],
              [61.03899, 34.757091],
              [61.039542, 34.757356],
              [61.039755, 34.75769],
              [61.04006, 34.757927],
              [61.041361, 34.758441],
              [61.041437, 34.758505],
              [61.041542, 34.758745],
              [61.041589, 34.759024],
              [61.041566, 34.759372],
              [61.041506, 34.759515],
              [61.04115, 34.759658],
              [61.041054, 34.759784],
              [61.041276, 34.760528],
              [61.041284, 34.760734],
              [61.041014, 34.76131],
              [61.040724, 34.761633],
              [61.040717, 34.761747],
              [61.040805, 34.761904],
              [61.041116, 34.76218],
              [61.041738, 34.763157],
              [61.04181, 34.763613],
              [61.04168, 34.763936],
              [61.041696, 34.76405],
              [61.042027, 34.764294],
              [61.042196, 34.764314],
              [61.043165, 34.764799],
              [61.04377, 34.766295],
              [61.044145, 34.766745],
              [61.04429, 34.767153],
              [61.044233, 34.767264],
              [61.044424, 34.767728],
              [61.044435, 34.768055],
              [61.044619, 34.768337],
              [61.044651, 34.768574],
              [61.044633, 34.769129],
              [61.044439, 34.769343],
              [61.044339, 34.769596],
              [61.044349, 34.76976],
              [61.044471, 34.76994],
              [61.044588, 34.769991],
              [61.045495, 34.770093],
              [61.04612, 34.770268],
              [61.046548, 34.770596],
              [61.046679, 34.770778],
              [61.04668, 34.770875],
              [61.046417, 34.771229],
              [61.046184, 34.771916],
              [61.046128, 34.772265],
              [61.046201, 34.773257],
              [61.046457, 34.773949],
              [61.047015, 34.774629],
              [61.047415, 34.775649],
              [61.047879, 34.776165],
              [61.048043, 34.776212],
              [61.048217, 34.776376],
              [61.048455, 34.776459],
              [61.048777, 34.776765],
              [61.048787, 34.777104],
              [61.048669, 34.777238],
              [61.04864, 34.777533],
              [61.048728, 34.777816],
              [61.049062, 34.778057],
              [61.049536, 34.778566],
              [61.049611, 34.778717],
              [61.049592, 34.779035],
              [61.049655, 34.779283],
              [61.049899, 34.77966],
              [61.050061, 34.77976],
              [61.050086, 34.779891],
              [61.050253, 34.780059],
              [61.050549, 34.780153],
              [61.05081, 34.780107],
              [61.051145, 34.780228],
              [61.051557, 34.78024],
              [61.05198, 34.780473],
              [61.052247, 34.780529],
              [61.052392, 34.78061],
              [61.052484, 34.780879],
              [61.052701, 34.780865],
              [61.053049, 34.781006],
              [61.053111, 34.781218],
              [61.053357, 34.781381],
              [61.053457, 34.781504],
              [61.053606, 34.781983],
              [61.053854, 34.782246],
              [61.054885, 34.782398],
              [61.054975, 34.782428],
              [61.055241, 34.782684],
              [61.055385, 34.783595],
              [61.054768, 34.783832],
              [61.054835, 34.784179],
              [61.054689, 34.785226],
              [61.054803, 34.785412],
              [61.055029, 34.785397],
              [61.055158, 34.785469],
              [61.055252, 34.785651],
              [61.055717, 34.786084],
              [61.055816, 34.786331],
              [61.055888, 34.786598],
              [61.055831, 34.78672],
              [61.055846, 34.787268],
              [61.055931, 34.78785],
              [61.055865, 34.787987],
              [61.055861, 34.78819],
              [61.055923, 34.788341],
              [61.05669, 34.788662],
              [61.057085, 34.789001],
              [61.057156, 34.789312],
              [61.057688, 34.789529],
              [61.057976, 34.789561],
              [61.05809, 34.789661],
              [61.058202, 34.790276],
              [61.058074, 34.790935],
              [61.058112, 34.791021],
              [61.058517, 34.791229],
              [61.058617, 34.791322],
              [61.059308, 34.792586],
              [61.059339, 34.7929],
              [61.059145, 34.79308],
              [61.05919, 34.7942],
              [61.059581, 34.794697],
              [61.059717, 34.794792],
              [61.060057, 34.794915],
              [61.060149, 34.795054],
              [61.060095, 34.795222],
              [61.059939, 34.795424],
              [61.059911, 34.795615],
              [61.060437, 34.795965],
              [61.060585, 34.796151],
              [61.060701, 34.796577],
              [61.060671, 34.796695],
              [61.060404, 34.796982],
              [61.060482, 34.797146],
              [61.060779, 34.797404],
              [61.060787, 34.797543],
              [61.060706, 34.797666],
              [61.060401, 34.797884],
              [61.060554, 34.798358],
              [61.061117, 34.798571],
              [61.061295, 34.798733],
              [61.061393, 34.7989],
              [61.061391, 34.799191],
              [61.061995, 34.7998],
              [61.062158, 34.800064],
              [61.062251, 34.800866],
              [61.0618, 34.801108],
              [61.061746, 34.801226],
              [61.061917, 34.801381],
              [61.061856, 34.801505],
              [61.06149, 34.80181],
              [61.061247, 34.802238],
              [61.061202, 34.802755],
              [61.061323, 34.803182],
              [61.062014, 34.804227],
              [61.062566, 34.804664],
              [61.062538, 34.804887],
              [61.062579, 34.804955],
              [61.062933, 34.805211],
              [61.063205, 34.80529],
              [61.06347, 34.805792],
              [61.063723, 34.806003],
              [61.064488, 34.806223],
              [61.064979, 34.806075],
              [61.065212, 34.806169],
              [61.065604, 34.806926],
              [61.065832, 34.807189],
              [61.06609, 34.807687],
              [61.066034, 34.808499],
              [61.066128, 34.808933],
              [61.066297, 34.809182],
              [61.066367, 34.809455],
              [61.06628, 34.809815],
              [61.06634, 34.810271],
              [61.066805, 34.810842],
              [61.066955, 34.811335],
              [61.067674, 34.811676],
              [61.068078, 34.81229],
              [61.068151, 34.812705],
              [61.068056, 34.813192],
              [61.068268, 34.814087],
              [61.068116, 34.814507],
              [61.067565, 34.814981],
              [61.067505, 34.815225],
              [61.067607, 34.815734],
              [61.067535, 34.815993],
              [61.067586, 34.816161],
              [61.067759, 34.816284],
              [61.068308, 34.816434],
              [61.068367, 34.816621],
              [61.068199, 34.817151],
              [61.068055, 34.817383],
              [61.067568, 34.818095],
              [61.067131, 34.818493],
              [61.067168, 34.818779],
              [61.067021, 34.819284],
              [61.066967, 34.819708],
              [61.067084, 34.820088],
              [61.067158, 34.820632],
              [61.066945, 34.821132],
              [61.067172, 34.821958],
              [61.067555, 34.82257],
              [61.067932, 34.823542],
              [61.067941, 34.824022],
              [61.06785, 34.824589],
              [61.06787, 34.825255],
              [61.068012, 34.825559],
              [61.068318, 34.825868],
              [61.068766, 34.827769],
              [61.068636, 34.828276],
              [61.068393, 34.828532],
              [61.067112, 34.829243],
              [61.066892, 34.829474],
              [61.066794, 34.829677],
              [61.067169, 34.83099],
              [61.067481, 34.831373],
              [61.067791, 34.832683],
              [61.067651, 34.833071],
              [61.067395, 34.833354],
              [61.065878, 34.833984],
              [61.064997, 34.834454],
              [61.064644, 34.834909],
              [61.064356, 34.835451],
              [61.064226, 34.836321],
              [61.063971, 34.836865],
              [61.063633, 34.837081],
              [61.06258, 34.837494],
              [61.062474, 34.837682],
              [61.062515, 34.837904],
              [61.063134, 34.839029],
              [61.063761, 34.839741],
              [61.065014, 34.84078],
              [61.065314, 34.841226],
              [61.0657, 34.841533],
              [61.066463, 34.841778],
              [61.06749, 34.841929],
              [61.068177, 34.841905],
              [61.069823, 34.841532],
              [61.070346, 34.841515],
              [61.071, 34.84165],
              [61.073156, 34.842323],
              [61.074026, 34.842763],
              [61.074625, 34.843494],
              [61.075061, 34.844264],
              [61.075205, 34.844972],
              [61.075097, 34.845454],
              [61.074815, 34.845972],
              [61.074058, 34.846671],
              [61.073122, 34.847386],
              [61.072336, 34.848212],
              [61.071507, 34.848995],
              [61.070576, 34.849509],
              [61.069707, 34.850184],
              [61.06895, 34.850819],
              [61.068582, 34.851283],
              [61.068522, 34.851713],
              [61.068579, 34.852179],
              [61.068573, 34.852855],
              [61.068719, 34.854221],
              [61.069047, 34.855602],
              [61.069363, 34.856509],
              [61.069481, 34.85724],
              [61.069431, 34.857904],
              [61.069538, 34.85869],
              [61.069666, 34.859033],
              [61.069719, 34.859636],
              [61.06965, 34.860081],
              [61.069081, 34.860886],
              [61.068882, 34.861281],
              [61.069083, 34.862167],
              [61.068522, 34.8633],
              [61.068423, 34.863866],
              [61.068561, 34.864505],
              [61.068876, 34.865026],
              [61.069926, 34.865854],
              [61.070641, 34.866242],
              [61.070883, 34.866686],
              [61.070779, 34.867215],
              [61.070569, 34.867694],
              [61.069815, 34.868356],
              [61.069949, 34.869343],
              [61.070114, 34.869786],
              [61.070489, 34.870174],
              [61.071095, 34.87033],
              [61.0731, 34.870519],
              [61.073858, 34.870678],
              [61.074825, 34.870739],
              [61.075633, 34.870889],
              [61.076308, 34.871154],
              [61.076852, 34.871603],
              [61.077454, 34.872218],
              [61.078009, 34.873203],
              [61.078892, 34.875047],
              [61.080628, 34.875928],
              [61.080891, 34.876279],
              [61.080661, 34.876776],
              [61.080534, 34.877275],
              [61.080132, 34.878005],
              [61.079815, 34.878237],
              [61.079166, 34.878585],
              [61.07871, 34.878955],
              [61.078384, 34.879347],
              [61.077791, 34.880421],
              [61.077291, 34.880985],
              [61.076679, 34.881479],
              [61.075842, 34.881879],
              [61.075155, 34.881998],
              [61.073965, 34.881795],
              [61.072925, 34.881753],
              [61.072245, 34.881787],
              [61.069945, 34.882107],
              [61.068946, 34.88208],
              [61.068318, 34.882159],
              [61.067635, 34.8825],
              [61.067509, 34.88291],
              [61.067432, 34.883452],
              [61.066912, 34.88443],
              [61.066461, 34.884935],
              [61.066326, 34.885356],
              [61.066255, 34.885856],
              [61.065471, 34.887341],
              [61.065348, 34.888083],
              [61.065382, 34.888853],
              [61.065737, 34.88977],
              [61.065978, 34.890126],
              [61.067264, 34.8936],
              [61.067346, 34.89427],
              [61.067265, 34.894868],
              [61.067017, 34.895174],
              [61.066305, 34.895595],
              [61.064268, 34.897043],
              [61.063434, 34.897782],
              [61.062821, 34.898138],
              [61.061859, 34.898582],
              [61.06102, 34.898909],
              [61.05996, 34.899485],
              [61.05896, 34.899779],
              [61.058108, 34.900429],
              [61.057264, 34.901209],
              [61.056726, 34.901914],
              [61.056299, 34.9027327],
              [61.055835, 34.904285],
              [61.055943, 34.904862],
              [61.056459, 34.90588],
              [61.056967, 34.906687],
              [61.057683, 34.907504],
              [61.059004, 34.908482],
              [61.060468, 34.909426],
              [61.061085, 34.909771],
              [61.062307, 34.909902],
              [61.063063, 34.909898],
              [61.064037, 34.909618],
              [61.06486, 34.909321],
              [61.065664, 34.90889],
              [61.066851, 34.908021],
              [61.067395, 34.907565],
              [61.068328, 34.90704],
              [61.068821, 34.906891],
              [61.069619, 34.907038],
              [61.070365, 34.907437],
              [61.071108, 34.907595],
              [61.072229, 34.907732],
              [61.073211, 34.908002],
              [61.073857, 34.908623],
              [61.074152, 34.909435],
              [61.073938, 34.909892],
              [61.073422, 34.910586],
              [61.073163, 34.91106],
              [61.072521, 34.911988],
              [61.071751, 34.912945],
              [61.070548, 34.913624],
              [61.069371, 34.913999],
              [61.066566, 34.914179],
              [61.065434, 34.91411],
              [61.064665, 34.914323],
              [61.06398, 34.914673],
              [61.062989, 34.915313],
              [61.062477, 34.915891],
              [61.062268, 34.916383],
              [61.062174, 34.916794],
              [61.062264, 34.917265],
              [61.062533, 34.917793],
              [61.062937, 34.918336],
              [61.063579, 34.918876],
              [61.064456, 34.919317],
              [61.065765, 34.919859],
              [61.066486, 34.920027],
              [61.067387, 34.920108],
              [61.06846, 34.920121],
              [61.069157, 34.920212],
              [61.070088, 34.920544],
              [61.071057, 34.921251],
              [61.071645, 34.922115],
              [61.071934, 34.922723],
              [61.072084, 34.923728],
              [61.072026, 34.925064],
              [61.071827, 34.926475],
              [61.071991, 34.927729],
              [61.071868, 34.929477],
              [61.072033, 34.930112],
              [61.072492, 34.930725],
              [61.07312, 34.931193],
              [61.07394, 34.931543],
              [61.075141, 34.931671],
              [61.075811, 34.931802],
              [61.076483, 34.932068],
              [61.077034, 34.932703],
              [61.077587, 34.93364],
              [61.078286, 34.934453],
              [61.079105, 34.935173],
              [61.079553, 34.935903],
              [61.079774, 34.936471],
              [61.079892, 34.937053],
              [61.079863, 34.937524],
              [61.079941, 34.937787],
              [61.081844, 34.939069],
              [61.082684, 34.939721],
              [61.083066, 34.940061],
              [61.083638, 34.940825],
              [61.083992, 34.941145],
              [61.084818, 34.941669],
              [61.085111, 34.941957],
              [61.085295, 34.942353],
              [61.08549, 34.943138],
              [61.085398, 34.943804],
              [61.085458, 34.944957],
              [61.085309, 34.945542],
              [61.085001, 34.945987],
              [61.08474, 34.946611],
              [61.083719, 34.948674],
              [61.083496, 34.949558],
              [61.083462, 34.950015],
              [61.083507, 34.950546],
              [61.083628, 34.951059],
              [61.08406, 34.951611],
              [61.084939, 34.952367],
              [61.085432, 34.952681],
              [61.087278, 34.95338],
              [61.087863, 34.953547],
              [61.08863, 34.953617],
              [61.089203, 34.953555],
              [61.090567, 34.953098],
              [61.09108, 34.952701],
              [61.091472, 34.952471],
              [61.092313, 34.951544],
              [61.092941, 34.9512],
              [61.093339, 34.951107],
              [61.094993, 34.951132],
              [61.096086, 34.950895],
              [61.096432, 34.950934],
              [61.096816, 34.95112],
              [61.097467, 34.951861],
              [61.097682, 34.952707],
              [61.0982, 34.953575],
              [61.098405, 34.954121],
              [61.098517, 34.954796],
              [61.098408, 34.95538],
              [61.097578, 34.956337],
              [61.097394, 34.956881],
              [61.096969, 34.957294],
              [61.096696, 34.95775],
              [61.096521, 34.959224],
              [61.097063, 34.960706],
              [61.097179, 34.961345],
              [61.097189, 34.96233],
              [61.09691, 34.963417],
              [61.096856, 34.963935],
              [61.097113, 34.964293],
              [61.097365, 34.964431],
              [61.098258, 34.964763],
              [61.099458, 34.965379],
              [61.100443, 34.965995],
              [61.100829, 34.966507],
              [61.101017, 34.967227],
              [61.101068, 34.967626],
              [61.101228, 34.968143],
              [61.101594, 34.968812],
              [61.101819, 34.96988],
              [61.10171, 34.970194],
              [61.101522, 34.970497],
              [61.100746, 34.971234],
              [61.100487, 34.971759],
              [61.100269, 34.972027],
              [61.099845, 34.972216],
              [61.099272, 34.972032],
              [61.099092, 34.972085],
              [61.097787, 34.972974],
              [61.095761, 34.974158],
              [61.095639, 34.974839],
              [61.095691, 34.975292],
              [61.096651, 34.976574],
              [61.096752, 34.97718],
              [61.096692, 34.97765],
              [61.09594, 34.978345],
              [61.095612, 34.979175],
              [61.095682, 34.979497],
              [61.096069, 34.979591],
              [61.096788, 34.979727],
              [61.097184, 34.979748],
              [61.097971, 34.979641],
              [61.098277, 34.979507],
              [61.098641, 34.979197],
              [61.098841, 34.978744],
              [61.099426, 34.978466],
              [61.100095, 34.97834],
              [61.100596, 34.978321],
              [61.103186, 34.978843],
              [61.103744, 34.978915],
              [61.105675, 34.979397],
              [61.106245, 34.979678],
              [61.10703, 34.980284],
              [61.107438, 34.980743],
              [61.10788, 34.982106],
              [61.10763, 34.98318],
              [61.107252, 34.983935],
              [61.106774, 34.98449],
              [61.106292, 34.984935],
              [61.105591, 34.985825],
              [61.105004, 34.986158],
              [61.104459, 34.98638],
              [61.103687, 34.986583],
              [61.10313, 34.98698],
              [61.102756, 34.987471],
              [61.10264, 34.987771],
              [61.102616, 34.988324],
              [61.102736, 34.988958],
              [61.102749, 34.989481],
              [61.102611, 34.990054],
              [61.102188, 34.990947],
              [61.101999, 34.99199],
              [61.102301, 34.993064],
              [61.103031, 34.994767],
              [61.104199, 34.996717],
              [61.104357, 34.997247],
              [61.104544, 34.997465],
              [61.105014, 34.99777],
              [61.105631, 34.998301],
              [61.106453, 34.99875],
              [61.107415, 34.999552],
              [61.107741, 35.00008],
              [61.108024, 35.000422],
              [61.108897, 35.000931],
              [61.109751, 35.001319],
              [61.110793, 35.001624],
              [61.11172, 35.001743],
              [61.112581, 35.001681],
              [61.113761, 35.001687],
              [61.115223, 35.001221],
              [61.116405, 35.000975],
              [61.117775, 35.001112],
              [61.118333, 35.001263],
              [61.120314, 35.00204],
              [61.12101, 35.002528],
              [61.121411, 35.003062],
              [61.121625, 35.003515],
              [61.121788, 35.004703],
              [61.12175, 35.00503],
              [61.121491, 35.00556],
              [61.121087, 35.005951],
              [61.119844, 35.006179],
              [61.11565, 35.006273],
              [61.113961, 35.007413],
              [61.112881, 35.008306],
              [61.112691, 35.010369],
              [61.112567, 35.011003],
              [61.112524, 35.012824],
              [61.112141, 35.014094],
              [61.11153, 35.015271],
              [61.111125, 35.015918],
              [61.110078, 35.017235],
              [61.109328, 35.0184],
              [61.108478, 35.019049],
              [61.105294, 35.020691],
              [61.102814, 35.021779],
              [61.10052, 35.023246],
              [61.099881, 35.023816],
              [61.099702, 35.024205],
              [61.099759, 35.024785],
              [61.100206, 35.025682],
              [61.100693, 35.026379],
              [61.10098, 35.027278],
              [61.101031, 35.027684],
              [61.101416, 35.028071],
              [61.101807, 35.02809],
              [61.102058, 35.027988],
              [61.103221, 35.028379],
              [61.103713, 35.028768],
              [61.104268, 35.02902],
              [61.105038, 35.029211],
              [61.105972, 35.029263],
              [61.107539, 35.029655],
              [61.108665, 35.030129],
              [61.109483, 35.031078],
              [61.110361, 35.032276],
              [61.110732, 35.033199],
              [61.110743, 35.034869],
              [61.11044, 35.036956],
              [61.110878, 35.037628],
              [61.111338, 35.037833],
              [61.11219, 35.037952],
              [61.11302, 35.037885],
              [61.114271, 35.037489],
              [61.115275, 35.037386],
              [61.116185, 35.03796],
              [61.116746, 35.038556],
              [61.116705, 35.042758],
              [61.116809, 35.04368],
              [61.116287, 35.044572],
              [61.115135, 35.045681],
              [61.114496, 35.046602],
              [61.113656, 35.04761],
              [61.113039, 35.048829],
              [61.111713, 35.050731],
              [61.110934, 35.052576],
              [61.11037, 35.054139],
              [61.110326, 35.055369],
              [61.110572, 35.057271],
              [61.111194, 35.059421],
              [61.1117, 35.060622],
              [61.11231, 35.061334],
              [61.113033, 35.06168],
              [61.114581, 35.06185],
              [61.11619, 35.061506],
              [61.117647, 35.060364],
              [61.11826, 35.059282],
              [61.118978, 35.058781],
              [61.12089, 35.058961],
              [61.12559, 35.058395],
              [61.125863, 35.058524],
              [61.125996, 35.058858],
              [61.126387, 35.060489],
              [61.126598, 35.062675],
              [61.126221, 35.065033],
              [61.125425, 35.066554],
              [61.124127, 35.067799],
              [61.12309, 35.068281],
              [61.120462, 35.069069],
              [61.119808, 35.069456],
              [61.119108, 35.069958],
              [61.117761, 35.070695],
              [61.117325, 35.071142],
              [61.117081, 35.071946],
              [61.117072, 35.072717],
              [61.117244, 35.073585],
              [61.117421, 35.073975],
              [61.118131, 35.07464],
              [61.118772, 35.07514],
              [61.119393, 35.075327],
              [61.121833, 35.075723],
              [61.123332, 35.075607],
              [61.124499, 35.075425],
              [61.127063, 35.075489],
              [61.12873, 35.075273],
              [61.130176, 35.075002],
              [61.131712, 35.074542],
              [61.133063, 35.074211],
              [61.135061, 35.073529],
              [61.137309, 35.073001],
              [61.138139, 35.072758],
              [61.13948, 35.072695],
              [61.140979, 35.073357],
              [61.141944, 35.074176],
              [61.142664, 35.075226],
              [61.14285, 35.075976],
              [61.142871, 35.076594],
              [61.143378, 35.077192],
              [61.144047, 35.07773],
              [61.144474, 35.07836],
              [61.145245, 35.079184],
              [61.145623, 35.079698],
              [61.145771, 35.080611],
              [61.145566, 35.082557],
              [61.145356, 35.083504],
              [61.144381, 35.085194],
              [61.143586, 35.086042],
              [61.14242, 35.086968],
              [61.141201, 35.087784],
              [61.137328, 35.089664],
              [61.136248, 35.090336],
              [61.134825, 35.091495],
              [61.133743, 35.091967],
              [61.132712, 35.092101],
              [61.131844, 35.091945],
              [61.131237, 35.092111],
              [61.12995, 35.092831],
              [61.128493, 35.093496],
              [61.127747, 35.093782],
              [61.126247, 35.094962],
              [61.126077, 35.095384],
              [61.126057, 35.09568],
              [61.126248, 35.096077],
              [61.126467, 35.096313],
              [61.126795, 35.09647],
              [61.127213, 35.096981],
              [61.127562, 35.097541],
              [61.127948, 35.097868],
              [61.128594, 35.09817],
              [61.129075, 35.098452],
              [61.129872, 35.098788],
              [61.132096, 35.099239],
              [61.132798, 35.09955],
              [61.133328, 35.099947],
              [61.133753, 35.100135],
              [61.13436, 35.100315],
              [61.135544, 35.100521],
              [61.136036, 35.100433],
              [61.136883, 35.100493],
              [61.137267, 35.100745],
              [61.138123, 35.101013],
              [61.139069, 35.101389],
              [61.139845, 35.10182],
              [61.140424, 35.102418],
              [61.141005, 35.103246],
              [61.141347, 35.104039],
              [61.141486, 35.104899],
              [61.141374, 35.10566],
              [61.141248, 35.106133],
              [61.140463, 35.107281],
              [61.139885, 35.107818],
              [61.138931, 35.108388],
              [61.138169, 35.108576],
              [61.137503, 35.108569],
              [61.136252, 35.108226],
              [61.135466, 35.10787],
              [61.134856, 35.107482],
              [61.134805, 35.107264],
              [61.134723, 35.107179],
              [61.134365, 35.107009],
              [61.133949, 35.10691],
              [61.133348, 35.106666],
              [61.132034, 35.106307],
              [61.13149, 35.106422],
              [61.131031, 35.106666],
              [61.130521, 35.107322],
              [61.1304, 35.107791],
              [61.130459, 35.108038],
              [61.130451, 35.109574],
              [61.130112, 35.11028],
              [61.130119, 35.110554],
              [61.130254, 35.111624],
              [61.130462, 35.11215],
              [61.130776, 35.112808],
              [61.13112, 35.113374],
              [61.131452, 35.113722],
              [61.13176, 35.115599],
              [61.131861, 35.116753],
              [61.131575, 35.117576],
              [61.131543, 35.118783],
              [61.131799, 35.121657],
              [61.131974, 35.122213],
              [61.132424, 35.122817],
              [61.133188, 35.123487],
              [61.133295, 35.123942],
              [61.133225, 35.124273],
              [61.132905, 35.124538],
              [61.13255, 35.125224],
              [61.13231, 35.126083],
              [61.131921, 35.126563],
              [61.131313, 35.127749],
              [61.130796, 35.128382],
              [61.130611, 35.129029],
              [61.130705, 35.130806],
              [61.130864, 35.131885],
              [61.131176, 35.132613],
              [61.131758, 35.133082],
              [61.132655, 35.1336],
              [61.133109, 35.133988],
              [61.133297, 35.134476],
              [61.133175, 35.134714],
              [61.132679, 35.135392],
              [61.13257, 35.135873],
              [61.131827, 35.136785],
              [61.131046, 35.137043],
              [61.130404, 35.137075],
              [61.129965, 35.137002],
              [61.129563, 35.136715],
              [61.129047, 35.135893],
              [61.128684, 35.135587],
              [61.127726, 35.135031],
              [61.126929, 35.13482],
              [61.12507, 35.134661],
              [61.124396, 35.134778],
              [61.124237, 35.135018],
              [61.124121, 35.135367],
              [61.121931, 35.138475],
              [61.121189, 35.139171],
              [61.120285, 35.140488],
              [61.11973, 35.141498],
              [61.119484, 35.142081],
              [61.11949, 35.143872],
              [61.119413, 35.144598],
              [61.11907, 35.145119],
              [61.118254, 35.14558],
              [61.117376, 35.145931],
              [61.116076, 35.146308],
              [61.114777, 35.14654],
              [61.114128, 35.146893],
              [61.1138069, 35.1472497],
              [61.113208, 35.147915],
              [61.11227, 35.149178],
              [61.111148, 35.151072],
              [61.110727, 35.151924],
              [61.110771, 35.152834],
              [61.110961, 35.15346],
              [61.111561, 35.154685],
              [61.112308, 35.155929],
              [61.112524, 35.156621],
              [61.1124, 35.157331],
              [61.112086, 35.158001],
              [61.111567, 35.158617],
              [61.111116, 35.15904],
              [61.110536, 35.159295],
              [61.108683, 35.15935],
              [61.107841, 35.159693],
              [61.107329, 35.160098],
              [61.106976, 35.16091],
              [61.10695, 35.16149],
              [61.107251, 35.163263],
              [61.107074, 35.163698],
              [61.106646, 35.163899],
              [61.106169, 35.164275],
              [61.104788, 35.164952],
              [61.104042, 35.165269],
              [61.102201, 35.165584],
              [61.101702, 35.165883],
              [61.099838, 35.166049],
              [61.098543, 35.165972],
              [61.097327, 35.165391],
              [61.096679, 35.164973],
              [61.095884, 35.163929],
              [61.095362, 35.162739],
              [61.095285, 35.16178],
              [61.095349, 35.160251],
              [61.095124, 35.159873],
              [61.094547, 35.159399],
              [61.093875, 35.159089],
              [61.093155, 35.15902],
              [61.092805, 35.159261],
              [61.092621, 35.159481],
              [61.092408, 35.159897],
              [61.091981, 35.160232],
              [61.0919, 35.160532],
              [61.091245, 35.160993],
              [61.08838, 35.162616],
              [61.087926, 35.163115],
              [61.087453, 35.163958],
              [61.087117, 35.164807],
              [61.086733, 35.166334],
              [61.086745, 35.16683],
              [61.087116, 35.167422],
              [61.087836, 35.168091],
              [61.089166, 35.16873],
              [61.090201, 35.168802],
              [61.090913, 35.169057],
              [61.092027, 35.169666],
              [61.093251, 35.170405],
              [61.094096, 35.170827],
              [61.094973, 35.171144],
              [61.09608, 35.171749],
              [61.098099, 35.172885],
              [61.098976, 35.173504],
              [61.099101, 35.174027],
              [61.0989, 35.174661],
              [61.09738, 35.176688],
              [61.0967, 35.177474],
              [61.096494, 35.178068],
              [61.095008, 35.179328],
              [61.094002, 35.180503],
              [61.093135, 35.182166],
              [61.092787, 35.183125],
              [61.092985, 35.18393],
              [61.093458, 35.184751],
              [61.094231, 35.185501],
              [61.09513, 35.185916],
              [61.098282, 35.186819],
              [61.099279, 35.187408],
              [61.101538, 35.188973],
              [61.104071, 35.190187],
              [61.105658, 35.190795],
              [61.106329, 35.191167],
              [61.1071, 35.192817],
              [61.107689, 35.193484],
              [61.108151, 35.19422],
              [61.10851, 35.195051],
              [61.109266, 35.195743],
              [61.109693, 35.196595],
              [61.109851, 35.197064],
              [61.109957, 35.199773],
              [61.109806, 35.201814],
              [61.109833, 35.202794],
              [61.110141, 35.203554],
              [61.110612, 35.204021],
              [61.111437, 35.204611],
              [61.11226, 35.204929],
              [61.112915, 35.20492],
              [61.113543, 35.204711],
              [61.11377, 35.204425],
              [61.114606, 35.203821],
              [61.115108, 35.203814],
              [61.115627, 35.204255],
              [61.116699, 35.20569],
              [61.117029, 35.206763],
              [61.117303, 35.207207],
              [61.117521, 35.20776],
              [61.117573, 35.208329],
              [61.117794, 35.208871],
              [61.117854, 35.209644],
              [61.117812, 35.210814],
              [61.117684, 35.211099],
              [61.117097, 35.211391],
              [61.116637, 35.212],
              [61.11611, 35.21248],
              [61.115427, 35.212824],
              [61.115104, 35.212792],
              [61.114456, 35.212502],
              [61.113448, 35.212199],
              [61.112853, 35.212139],
              [61.112119, 35.212171],
              [61.111652, 35.212561],
              [61.110706, 35.213039],
              [61.109014, 35.213209],
              [61.107782, 35.213565],
              [61.105926, 35.214325],
              [61.103887, 35.214329],
              [61.103437, 35.214392],
              [61.103318, 35.214664],
              [61.102139, 35.215836],
              [61.101027, 35.216639],
              [61.100552, 35.217107],
              [61.100173, 35.217395],
              [61.099292, 35.217798],
              [61.098697, 35.218],
              [61.09836, 35.2185],
              [61.098543, 35.218948],
              [61.099028, 35.219659],
              [61.099493, 35.221077],
              [61.099343, 35.221459],
              [61.099399, 35.221699],
              [61.100019, 35.222971],
              [61.100033, 35.22382],
              [61.099817, 35.224335],
              [61.099427, 35.224954],
              [61.099119, 35.226033],
              [61.098725, 35.227932],
              [61.098999, 35.228334],
              [61.099428, 35.228759],
              [61.099857, 35.229446],
              [61.1009, 35.230456],
              [61.101633, 35.231585],
              [61.102326, 35.232358],
              [61.102524, 35.233162],
              [61.102585, 35.233852],
              [61.102344, 35.234429],
              [61.102053, 35.234467],
              [61.101494, 35.234296],
              [61.100681, 35.234443],
              [61.100235, 35.234885],
              [61.099992, 35.235241],
              [61.099071, 35.235699],
              [61.097957, 35.236384],
              [61.097411, 35.237078],
              [61.096282, 35.238902],
              [61.096081, 35.239557],
              [61.096334, 35.240447],
              [61.096664, 35.241109],
              [61.097291, 35.241475],
              [61.097854, 35.241578],
              [61.098856, 35.241642],
              [61.099195, 35.241989],
              [61.099426, 35.242457],
              [61.09926, 35.242955],
              [61.099148, 35.243791],
              [61.098894, 35.244129],
              [61.098695, 35.244599],
              [61.098411, 35.245611],
              [61.097821, 35.246043],
              [61.097704, 35.246387],
              [61.097838, 35.247246],
              [61.097564, 35.247948],
              [61.097825, 35.248651],
              [61.097661, 35.249607],
              [61.097363, 35.250334],
              [61.097458, 35.251032],
              [61.097229, 35.251396],
              [61.097172, 35.252081],
              [61.097231, 35.252505],
              [61.097433, 35.253066],
              [61.097341, 35.253302],
              [61.097459, 35.253934],
              [61.097328, 35.254404],
              [61.097131, 35.257991],
              [61.096817, 35.258419],
              [61.096324, 35.258501],
              [61.094706, 35.259342],
              [61.092795, 35.260078],
              [61.092337, 35.260476],
              [61.092063, 35.260875],
              [61.091916, 35.261224],
              [61.091731, 35.26203],
              [61.091693, 35.263115],
              [61.091775, 35.263737],
              [61.092187, 35.264389],
              [61.092973, 35.265128],
              [61.093787, 35.265753],
              [61.09447, 35.266514],
              [61.095031, 35.267452],
              [61.095503, 35.268826],
              [61.096494, 35.270702],
              [61.09658, 35.27134],
              [61.096947, 35.272146],
              [61.097688, 35.273022],
              [61.099247, 35.274456],
              [61.099545, 35.275091],
              [61.100263, 35.276026],
              [61.101093, 35.277287],
              [61.1016304, 35.2778731],
              [61.102125, 35.278209],
              [61.10417, 35.279121],
              [61.104894, 35.279572],
              [61.105324, 35.28003],
              [61.105561, 35.280579],
              [61.106446, 35.281462],
              [61.107142, 35.281773],
              [61.107967, 35.282413],
              [61.108955, 35.282812],
              [61.109716, 35.282921],
              [61.110355, 35.28258],
              [61.111029, 35.281321],
              [61.111461, 35.281082],
              [61.113192, 35.281502],
              [61.114047, 35.281632],
              [61.115045, 35.281906],
              [61.115594, 35.282219],
              [61.116036, 35.282316],
              [61.116569, 35.282217],
              [61.116925, 35.28195],
              [61.117334, 35.281768],
              [61.117687, 35.280918],
              [61.117678, 35.280202],
              [61.117784, 35.279765],
              [61.117771, 35.279248],
              [61.118479, 35.278707],
              [61.118849, 35.278541],
              [61.119579, 35.278371],
              [61.119975, 35.277952],
              [61.120575, 35.277789],
              [61.12123, 35.277707],
              [61.121616, 35.277708],
              [61.122856, 35.277958],
              [61.123522, 35.278218],
              [61.124426, 35.278852],
              [61.124858, 35.279235],
              [61.125545, 35.280185],
              [61.125909, 35.280467],
              [61.126431, 35.280638],
              [61.126784, 35.280651],
              [61.127106, 35.280579],
              [61.128535, 35.279918],
              [61.128898, 35.279598],
              [61.129427, 35.27886],
              [61.129662, 35.278623],
              [61.12993, 35.27853],
              [61.13124, 35.278457],
              [61.13193, 35.278465],
              [61.132931, 35.278358],
              [61.133271, 35.278425],
              [61.135024, 35.279064],
              [61.136387, 35.279324],
              [61.136894, 35.279552],
              [61.137458, 35.279729],
              [61.138054, 35.279872],
              [61.138507, 35.279931],
              [61.139347, 35.279945],
              [61.140009, 35.280258],
              [61.140492, 35.280429],
              [61.140979, 35.280754],
              [61.141102, 35.281056],
              [61.141166, 35.281822],
              [61.14127, 35.282135],
              [61.141782, 35.282691],
              [61.142211, 35.282993],
              [61.142871, 35.28329],
              [61.143317, 35.283223],
              [61.144064, 35.282908],
              [61.144432, 35.282894],
              [61.14517, 35.283167],
              [61.146243, 35.283397],
              [61.146719, 35.283541],
              [61.147477, 35.283617],
              [61.148052, 35.283812],
              [61.149263, 35.283935],
              [61.149983, 35.284073],
              [61.151017, 35.284388],
              [61.151692, 35.284461],
              [61.152161, 35.284437],
              [61.153828, 35.284702],
              [61.154804, 35.284697],
              [61.155421, 35.284545],
              [61.155767, 35.284299],
              [61.155778, 35.283989],
              [61.155578, 35.283616],
              [61.155603, 35.283316],
              [61.155877, 35.282516],
              [61.156302, 35.280094],
              [61.156232, 35.27893],
              [61.155991, 35.278275],
              [61.155693, 35.27669],
              [61.155796, 35.276266],
              [61.155996, 35.275844],
              [61.156348, 35.275572],
              [61.156678, 35.275472],
              [61.157048, 35.275465],
              [61.157867, 35.275352],
              [61.15837, 35.275484],
              [61.158588, 35.275593],
              [61.159366, 35.276587],
              [61.159747, 35.277244],
              [61.160083, 35.278227],
              [61.160168, 35.278952],
              [61.160342, 35.279402],
              [61.160786, 35.28038],
              [61.161102, 35.280799],
              [61.161543, 35.281073],
              [61.161952, 35.281225],
              [61.162608, 35.281434],
              [61.163113, 35.281464],
              [61.163507, 35.281567],
              [61.16391, 35.281926],
              [61.164156, 35.282237],
              [61.164516, 35.282966],
              [61.164887, 35.283088],
              [61.165851, 35.283299],
              [61.166135, 35.283456],
              [61.166683, 35.283986],
              [61.167062, 35.284505],
              [61.167127, 35.284873],
              [61.167029, 35.284995],
              [61.166033, 35.285379],
              [61.164838, 35.285636],
              [61.164665, 35.285823],
              [61.16471, 35.28609],
              [61.164891, 35.286423],
              [61.165167, 35.287238],
              [61.165319, 35.287516],
              [61.165904, 35.287997],
              [61.166541, 35.288423],
              [61.167302, 35.288859],
              [61.1681878, 35.2892966],
              [61.168302, 35.289353],
              [61.16857, 35.289969],
              [61.168976, 35.290183],
              [61.169188, 35.290211],
              [61.169559, 35.290079],
              [61.170313, 35.289929],
              [61.170796, 35.289997],
              [61.171372, 35.29027],
              [61.172501, 35.290081],
              [61.17285, 35.289908],
              [61.174398, 35.289926],
              [61.174634, 35.290021],
              [61.175551, 35.290631],
              [61.176024, 35.291052],
              [61.176878, 35.292075],
              [61.177799, 35.292548],
              [61.178602, 35.292817],
              [61.179184, 35.29279],
              [61.179527, 35.292594],
              [61.179749, 35.292335],
              [61.180337, 35.291838],
              [61.181358, 35.291275],
              [61.181721, 35.29111],
              [61.182634, 35.290954],
              [61.183149, 35.291101],
              [61.183673, 35.291179],
              [61.184511, 35.29156],
              [61.184673, 35.29172],
              [61.184906, 35.291776],
              [61.185629, 35.291864],
              [61.186297, 35.291678],
              [61.186928, 35.291697],
              [61.187299, 35.291908],
              [61.187543, 35.291962],
              [61.188425, 35.291919],
              [61.189265, 35.292017],
              [61.189539, 35.292131],
              [61.189836, 35.292359],
              [61.190296, 35.292865],
              [61.190254, 35.293594],
              [61.189979, 35.294469],
              [61.189705, 35.296375],
              [61.189712, 35.297624],
              [61.189489, 35.298351],
              [61.189408, 35.298958],
              [61.189518, 35.299339],
              [61.190127, 35.299793],
              [61.190512, 35.300002],
              [61.191, 35.30013],
              [61.191679, 35.300557],
              [61.191882, 35.301104],
              [61.19132, 35.301647],
              [61.190622, 35.301773],
              [61.190261, 35.301548],
              [61.189869, 35.301535],
              [61.189501, 35.301707],
              [61.18839, 35.301619],
              [61.187884, 35.301807],
              [61.187616, 35.302169],
              [61.187427, 35.302737],
              [61.187322, 35.303254],
              [61.187862, 35.304519],
              [61.18812, 35.305368],
              [61.188345, 35.305874],
              [61.189362, 35.307542],
              [61.189484, 35.308052],
              [61.189523, 35.308473],
              [61.189246, 35.308841],
              [61.189325, 35.309295],
              [61.189258, 35.309631],
              [61.188859, 35.310049],
              [61.188834, 35.310561],
              [61.188547, 35.311212],
              [61.188007, 35.31196],
              [61.187529, 35.312812],
              [61.187313, 35.313645],
              [61.186979, 35.314445],
              [61.186497, 35.315145],
              [61.186242, 35.315751],
              [61.185968, 35.31611],
              [61.186126, 35.316489],
              [61.186919, 35.317396],
              [61.187776, 35.317575],
              [61.18849, 35.317227],
              [61.189995, 35.317018],
              [61.190415, 35.317116],
              [61.191093, 35.317939],
              [61.191312, 35.318504],
              [61.191225, 35.31891],
              [61.191343, 35.319504],
              [61.191225, 35.31969],
              [61.190712, 35.319814],
              [61.190365, 35.320666],
              [61.189933, 35.321108],
              [61.187412, 35.322182],
              [61.18671, 35.322531],
              [61.185993, 35.323111],
              [61.185257, 35.324177],
              [61.185078, 35.324846],
              [61.185159, 35.325246],
              [61.185675, 35.326519],
              [61.186088, 35.327072],
              [61.186416, 35.327635],
              [61.186415, 35.328134],
              [61.186048, 35.328653],
              [61.185474, 35.328893],
              [61.185058, 35.32929],
              [61.18443, 35.329694],
              [61.183671, 35.330315],
              [61.183065, 35.330657],
              [61.182642, 35.331191],
              [61.182278, 35.331862],
              [61.182201, 35.333209],
              [61.1823, 35.333937],
              [61.182268, 35.334402],
              [61.18217, 35.334744],
              [61.181936, 35.335219],
              [61.181326, 35.335848],
              [61.181007, 35.336305],
              [61.18072, 35.336623],
              [61.179995, 35.337031],
              [61.179495, 35.337501],
              [61.179112, 35.337781],
              [61.178348, 35.337944],
              [61.178152, 35.337917],
              [61.177916, 35.338053],
              [61.177751, 35.33836],
              [61.177557, 35.338481],
              [61.177273, 35.338559],
              [61.177049, 35.339042],
              [61.176743, 35.339331],
              [61.176522, 35.339664],
              [61.176557, 35.339754],
              [61.176467, 35.340395],
              [61.17613, 35.340996],
              [61.176029, 35.341335],
              [61.17575, 35.343314],
              [61.175845, 35.343594],
              [61.175915, 35.345223],
              [61.176002, 35.345896],
              [61.175913, 35.346474],
              [61.17571, 35.346882],
              [61.175874, 35.347272],
              [61.176484, 35.348231],
              [61.176984, 35.348543],
              [61.177271, 35.348603],
              [61.17764, 35.348946],
              [61.178359, 35.34994],
              [61.178213, 35.350639],
              [61.178081, 35.351843],
              [61.177184, 35.35252],
              [61.177103, 35.352766],
              [61.177085, 35.353591],
              [61.176977, 35.354108],
              [61.17672, 35.354598],
              [61.176201, 35.356365],
              [61.176287, 35.356743],
              [61.17652, 35.356987],
              [61.177685, 35.357816],
              [61.178585, 35.358233],
              [61.179049, 35.358272],
              [61.179306, 35.35815],
              [61.179439, 35.357947],
              [61.180162, 35.357442],
              [61.180515, 35.357325],
              [61.180779, 35.35729],
              [61.18172, 35.357548],
              [61.183596, 35.357778],
              [61.184444, 35.35781],
              [61.185537, 35.358022],
              [61.185812, 35.35814],
              [61.185885, 35.358331],
              [61.185528, 35.358835],
              [61.185396, 35.359224],
              [61.185369, 35.359776],
              [61.185435, 35.360198],
              [61.185628, 35.360629],
              [61.18588, 35.361455],
              [61.186252, 35.363453],
              [61.186425, 35.363909],
              [61.186386, 35.364126],
              [61.18616, 35.364341],
              [61.18607, 35.364642],
              [61.186044, 35.365037],
              [61.185204, 35.365915],
              [61.185048, 35.366707],
              [61.184784, 35.367375],
              [61.184549, 35.368186],
              [61.184035, 35.369109],
              [61.183979, 35.369543],
              [61.184018, 35.36991],
              [61.184208, 35.370729],
              [61.184398, 35.370953],
              [61.185109, 35.37139],
              [61.186266, 35.371597],
              [61.186931, 35.371773],
              [61.187427, 35.372151],
              [61.188718, 35.372949],
              [61.188981, 35.373296],
              [61.189072, 35.3737],
              [61.188965, 35.373908],
              [61.188998, 35.37419],
              [61.189177, 35.374656],
              [61.19013, 35.37538],
              [61.192089, 35.376035],
              [61.193096, 35.376261],
              [61.19394, 35.376183],
              [61.194486, 35.376058],
              [61.194986, 35.37557],
              [61.195564, 35.374421],
              [61.195917, 35.373992],
              [61.197727, 35.373163],
              [61.199122, 35.372872],
              [61.199646, 35.372677],
              [61.199826, 35.372689],
              [61.200429, 35.373588],
              [61.200455, 35.374249],
              [61.200244, 35.375681],
              [61.199448, 35.377334],
              [61.198845, 35.378009],
              [61.198517, 35.378307],
              [61.197859, 35.378451],
              [61.195366, 35.378622],
              [61.194911, 35.378816],
              [61.194306, 35.379152],
              [61.193958, 35.379462],
              [61.193372, 35.38026],
              [61.193012, 35.380473],
              [61.192981, 35.380707],
              [61.193781, 35.382305],
              [61.194183, 35.382709],
              [61.194697, 35.382774],
              [61.195043, 35.382753],
              [61.195533, 35.383005],
              [61.195901, 35.383378],
              [61.196019, 35.383681],
              [61.196471, 35.384016],
              [61.198791, 35.384735],
              [61.199501, 35.385186],
              [61.199845, 35.385676],
              [61.200129, 35.386341],
              [61.200346, 35.386971],
              [61.200558, 35.387843],
              [61.200489, 35.388443],
              [61.200264, 35.38896],
              [61.200001, 35.389289],
              [61.199609, 35.389558],
              [61.198731, 35.390049],
              [61.198114, 35.390149],
              [61.197759, 35.390087],
              [61.197344, 35.389798],
              [61.196991, 35.389468],
              [61.196215, 35.388434],
              [61.196045, 35.387815],
              [61.195876, 35.386545],
              [61.195715, 35.38605],
              [61.195531, 35.385595],
              [61.195153, 35.385218],
              [61.194783, 35.385052],
              [61.1945, 35.385129],
              [61.19368, 35.384982],
              [61.19302, 35.384944],
              [61.192491, 35.385065],
              [61.191753, 35.385422],
              [61.191556, 35.385619],
              [61.191503, 35.385985],
              [61.191915, 35.386394],
              [61.191961, 35.386668],
              [61.192417, 35.38741],
              [61.193456, 35.388503],
              [61.193827, 35.389104],
              [61.194147, 35.389457],
              [61.194422, 35.390176],
              [61.194433, 35.390358],
              [61.194178, 35.390726],
              [61.194063, 35.391011],
              [61.193838, 35.391225],
              [61.193632, 35.391546],
              [61.193281, 35.391895],
              [61.192903, 35.392559],
              [61.192601, 35.392926],
              [61.19189, 35.393543],
              [61.191715, 35.393755],
              [61.191631, 35.394319],
              [61.191024, 35.395318],
              [61.190263, 35.395789],
              [61.189996, 35.396193],
              [61.18911, 35.39677],
              [61.188515, 35.397006],
              [61.188287, 35.397223],
              [61.187932, 35.397433],
              [61.187391, 35.398387],
              [61.187338, 35.398589],
              [61.187459, 35.399592],
              [61.187829, 35.400039],
              [61.188524, 35.400423],
              [61.189449, 35.401243],
              [61.189812, 35.40143],
              [61.190421, 35.402006],
              [61.191045, 35.402699],
              [61.191635, 35.403134],
              [61.191886, 35.403412],
              [61.191967, 35.403788],
              [61.192683, 35.405126],
              [61.192967, 35.405442],
              [61.193368, 35.40567],
              [61.194011, 35.406705],
              [61.194462, 35.407062],
              [61.195094, 35.407508],
              [61.196505, 35.407413],
              [61.197657, 35.407447],
              [61.197985, 35.407637],
              [61.198784, 35.409177],
              [61.198834, 35.409564],
              [61.199057, 35.409885],
              [61.199345, 35.41098],
              [61.199523, 35.411393],
              [61.200189, 35.411875],
              [61.200604, 35.412072],
              [61.201413, 35.412207],
              [61.202138, 35.412421],
              [61.202967, 35.412595],
              [61.203666, 35.412864],
              [61.204343, 35.412993],
              [61.204998, 35.412956],
              [61.206776, 35.411862],
              [61.207294, 35.411702],
              [61.207893, 35.411737],
              [61.208275, 35.41193],
              [61.209416, 35.412009],
              [61.210451, 35.412346],
              [61.210822, 35.412517],
              [61.211056, 35.412915],
              [61.212085, 35.414176],
              [61.212878, 35.414843],
              [61.213233, 35.41533],
              [61.213236, 35.415785],
              [61.213607, 35.417215],
              [61.213585, 35.418471],
              [61.213784, 35.419018],
              [61.213965, 35.419356],
              [61.213947, 35.419646],
              [61.214398, 35.420043],
              [61.215675, 35.420455],
              [61.216857, 35.421184],
              [61.217279, 35.421264],
              [61.217724, 35.421155],
              [61.218581, 35.420569],
              [61.219044, 35.420391],
              [61.22015, 35.420138],
              [61.221007, 35.419887],
              [61.221761, 35.419749],
              [61.222139, 35.419858],
              [61.222419, 35.420358],
              [61.223292, 35.420564],
              [61.224768, 35.420759],
              [61.225988, 35.421101],
              [61.226716, 35.421256],
              [61.227161, 35.421655],
              [61.227087, 35.421967],
              [61.227093, 35.422664],
              [61.227361, 35.423042],
              [61.227475, 35.423486],
              [61.227716, 35.42397],
              [61.228156, 35.424196],
              [61.228409, 35.424401],
              [61.2286, 35.424711],
              [61.228774, 35.425255],
              [61.229538, 35.426125],
              [61.229881, 35.427097],
              [61.230348, 35.429118],
              [61.230627, 35.429709],
              [61.230973, 35.43033],
              [61.231695, 35.431158],
              [61.232309, 35.431726],
              [61.232771, 35.432481],
              [61.232936, 35.43312],
              [61.232796, 35.433371],
              [61.232433, 35.43356],
              [61.2321, 35.434014],
              [61.231505, 35.434573],
              [61.230983, 35.434941],
              [61.23043, 35.435222],
              [61.229781, 35.435422],
              [61.228537, 35.436057],
              [61.227888, 35.436882],
              [61.227105, 35.43748],
              [61.226853, 35.437846],
              [61.226265, 35.438261],
              [61.225401, 35.43855],
              [61.224636, 35.438971],
              [61.223997, 35.439468],
              [61.222863, 35.440747],
              [61.222568, 35.441177],
              [61.22207, 35.442909],
              [61.222263, 35.443312],
              [61.222625, 35.443882],
              [61.223197, 35.444385],
              [61.223783, 35.445258],
              [61.224273, 35.445739],
              [61.225093, 35.44631],
              [61.225919, 35.446736],
              [61.228331, 35.447815],
              [61.229067, 35.448427],
              [61.229713, 35.448775],
              [61.230346, 35.448978],
              [61.231184, 35.449082],
              [61.231924, 35.449096],
              [61.232685, 35.448947],
              [61.234745, 35.449269],
              [61.235515, 35.44951],
              [61.235808, 35.449811],
              [61.235825, 35.450172],
              [61.23563, 35.450752],
              [61.23547, 35.451707],
              [61.235072, 35.452966],
              [61.23507, 35.453237],
              [61.235305, 35.453695],
              [61.235502, 35.453951],
              [61.235755, 35.454717],
              [61.236028, 35.454957],
              [61.236692, 35.455832],
              [61.236868, 35.456571],
              [61.237027, 35.457996],
              [61.236847, 35.458675],
              [61.236403, 35.459461],
              [61.235663, 35.460022],
              [61.234992, 35.460389],
              [61.234034, 35.461607],
              [61.233745, 35.462285],
              [61.234173, 35.463115],
              [61.23455, 35.46362],
              [61.235041, 35.463946],
              [61.236181, 35.464413],
              [61.236356, 35.46468],
              [61.236865, 35.46514],
              [61.237514, 35.466027],
              [61.237398, 35.46636],
              [61.237526, 35.466697],
              [61.238575, 35.467901],
              [61.239065, 35.468688],
              [61.239737, 35.469238],
              [61.239959, 35.46961],
              [61.240165, 35.471235],
              [61.240523, 35.472258],
              [61.241883, 35.474048],
              [61.243371, 35.475529],
              [61.243436, 35.47594],
              [61.24364, 35.476137],
              [61.24427, 35.476297],
              [61.244766, 35.476335],
              [61.245667, 35.476539],
              [61.246266, 35.476731],
              [61.247033, 35.476854],
              [61.247559, 35.476755],
              [61.247767, 35.476838],
              [61.248302, 35.477132],
              [61.248747, 35.47749],
              [61.248842, 35.477785],
              [61.25028, 35.478986],
              [61.251465, 35.479367],
              [61.252343, 35.479534],
              [61.254106, 35.480032],
              [61.254802, 35.480435],
              [61.255524, 35.481009],
              [61.255894, 35.481726],
              [61.255828, 35.482378],
              [61.25478, 35.483433],
              [61.254161, 35.483762],
              [61.252921, 35.484271],
              [61.252777, 35.484503],
              [61.252696, 35.484808],
              [61.25252, 35.485153],
              [61.252612, 35.485624],
              [61.252745, 35.48586],
              [61.253121, 35.486094],
              [61.25326, 35.486413],
              [61.253346, 35.487309],
              [61.253289, 35.488662],
              [61.253345, 35.489315],
              [61.253736, 35.490073],
              [61.254294, 35.49058],
              [61.255341, 35.491101],
              [61.256323, 35.491457],
              [61.257366, 35.491706],
              [61.258001, 35.491808],
              [61.258626, 35.491788],
              [61.258984, 35.491992],
              [61.25987, 35.494055],
              [61.260569, 35.495384],
              [61.26087, 35.49627],
              [61.261056, 35.497002],
              [61.261192, 35.497752],
              [61.261227, 35.498536],
              [61.261056, 35.499054],
              [61.260377, 35.500013],
              [61.259547, 35.502136],
              [61.259306, 35.503088],
              [61.259206, 35.503762],
              [61.259266, 35.504342],
              [61.259482, 35.504768],
              [61.259949, 35.505074],
              [61.260457, 35.505303],
              [61.261708, 35.505515],
              [61.262407, 35.50576],
              [61.263108, 35.505824],
              [61.264037, 35.505815],
              [61.265528, 35.505702],
              [61.266293, 35.505774],
              [61.267065, 35.505983],
              [61.267308, 35.506411],
              [61.267983, 35.507253],
              [61.268643, 35.508658],
              [61.269219, 35.509133],
              [61.269371, 35.509554],
              [61.269416, 35.509901],
              [61.269394, 35.511116],
              [61.269746, 35.512653],
              [61.269724, 35.513036],
              [61.271097, 35.516148],
              [61.2714059, 35.5165231],
              [61.2762629, 35.5182067],
              [61.277778, 35.520278],
              [61.2752663, 35.5274851],
              [61.2781129, 35.5315247],
              [61.2810104, 35.5339777],
              [61.2825792, 35.5379033],
              [61.2826012, 35.5406178],
              [61.282525, 35.5467564],
              [61.2832642, 35.5502138],
              [61.270421, 35.5598025],
              [61.2700927, 35.5640488],
              [61.2737979, 35.5677383],
              [61.2716472, 35.5708354],
              [61.2736386, 35.5751103],
              [61.2793361, 35.5774781],
              [61.2799673, 35.5806089],
              [61.2791447, 35.5817385],
              [61.2740793, 35.5834932],
              [61.2710306, 35.5891943],
              [61.27422, 35.5915029],
              [61.2744299, 35.5954257],
              [61.2773447, 35.5988458],
              [61.274257, 35.6031805],
              [61.2740947, 35.604842],
              [61.2737591, 35.6094121],
              [61.271017, 35.6112956],
              [61.270837, 35.6144662],
              [61.2684923, 35.6157625],
              [61.2610925, 35.6184856],
              [61.2471275, 35.6265853],
              [61.2462837, 35.6286053],
              [61.2503748, 35.633426],
              [61.2510641, 35.6350874],
              [61.2496683, 35.6383565],
              [61.2473786, 35.6404601],
              [61.2467931, 35.645202],
              [61.2416299, 35.6476809],
              [61.2340469, 35.6483081],
              [61.226226, 35.6506896],
              [61.2250065, 35.6529994],
              [61.2254286, 35.6539141],
              [61.2289462, 35.6554766],
              [61.2288524, 35.6571152],
              [61.2226941, 35.6610901],
              [61.2189635, 35.6683383],
              [61.2245995, 35.6729036],
              [61.2229325, 35.6753891],
              [61.2166545, 35.675801],
              [61.2162359, 35.6832534],
              [61.21909, 35.688781],
              [61.2207853, 35.6931578],
              [61.2248658, 35.6981095],
              [61.2261321, 35.697881],
              [61.2284488, 35.696996],
              [61.2294621, 35.6975763],
              [61.2302521, 35.7005941],
              [61.2315258, 35.7024135],
              [61.236389, 35.704167],
              [61.239722, 35.708611],
              [61.243889, 35.712222],
              [61.246389, 35.7175],
              [61.248333, 35.723611],
              [61.249722, 35.730278],
              [61.248889, 35.735833],
              [61.249444, 35.742222],
              [61.248611, 35.747778],
              [61.248889, 35.753889],
              [61.251111, 35.76],
              [61.253611, 35.765278],
              [61.255556, 35.771111],
              [61.255, 35.776944],
              [61.2525, 35.781389],
              [61.250833, 35.786389],
              [61.252222, 35.793056],
              [61.253056, 35.798611],
              [61.255833, 35.803889],
              [61.258611, 35.808889],
              [61.261944, 35.813333],
              [61.262222, 35.819722],
              [61.260556, 35.824722],
              [61.258889, 35.829722],
              [61.256389, 35.834167],
              [61.253889, 35.838611],
              [61.252222, 35.843611],
              [61.249444, 35.848333],
              [61.248056, 35.853333],
              [61.246389, 35.858333],
              [61.243611, 35.862778],
              [61.243056, 35.868333],
              [61.241389, 35.873611],
              [61.240833, 35.879167],
              [61.241111, 35.885278],
              [61.243889, 35.890556],
              [61.245, 35.897222],
              [61.239444, 35.898611],
              [61.233056, 35.8975],
              [61.2275, 35.898889],
              [61.225833, 35.903889],
              [61.226111, 35.91],
              [61.2225305, 35.9144264],
              [61.2106711, 35.9218235],
              [61.205404, 35.9271198],
              [61.1836284, 35.9430414],
              [61.1722681, 35.9474458],
              [61.1602844, 35.9507704],
              [61.1592799, 35.9505163],
              [61.1586791, 35.9503079],
              [61.1544304, 35.9467469],
              [61.1540333, 35.9465719],
              [61.1534648, 35.9464342],
              [61.1530357, 35.9463994],
              [61.1527782, 35.9463473],
              [61.1521559, 35.9465037],
              [61.1518341, 35.94666],
              [61.1513405, 35.946799],
              [61.1478858, 35.9475286],
              [61.14677, 35.9476154],
              [61.1457615, 35.9477023],
              [61.1448389, 35.9478934],
              [61.1440235, 35.9481365],
              [61.1435943, 35.948345],
              [61.142972, 35.948484],
              [61.1424141, 35.9485187],
              [61.1418133, 35.948484],
              [61.1413842, 35.9486056],
              [61.1405688, 35.9489356],
              [61.1401825, 35.9492135],
              [61.139968, 35.9496131],
              [61.1397534, 35.9501168],
              [61.1392384, 35.9509853],
              [61.1390667, 35.9514196],
              [61.1391311, 35.9516107],
              [61.1393671, 35.9521318],
              [61.1393886, 35.9524097],
              [61.1392599, 35.9526008],
              [61.1391097, 35.952705],
              [61.1358695, 35.9527745],
              [61.135376, 35.9528787],
              [61.1339169, 35.9533651],
              [61.1334448, 35.9537472],
              [61.1332088, 35.9540251],
              [61.1330095, 35.9543825],
              [61.1327889, 35.954586],
              [61.1325405, 35.95471],
              [61.1323781, 35.954792],
              [61.132136, 35.9550448],
              [61.1319179, 35.9553812],
              [61.1317834, 35.9555884],
              [61.131578, 35.9558836],
              [61.1313849, 35.9560052],
              [61.1311887, 35.956092],
              [61.1310108, 35.9562757],
              [61.1304131, 35.9574716],
              [61.1301648, 35.9580027],
              [61.1300116, 35.9582632],
              [61.1294752, 35.958628],
              [61.1282092, 35.9590969],
              [61.1269646, 35.9593227],
              [61.1265324, 35.9592607],
              [61.1262351, 35.9591316],
              [61.1257844, 35.9587669],
              [61.1255913, 35.9584543],
              [61.125248, 35.9582632],
              [61.1248188, 35.9579853],
              [61.1246686, 35.9577769],
              [61.1247545, 35.9575511],
              [61.1248832, 35.9573427],
              [61.1250334, 35.9568563],
              [61.1250763, 35.9562658],
              [61.1249905, 35.9559358],
              [61.1247974, 35.9557621],
              [61.1245828, 35.9556405],
              [61.1241107, 35.9555884],
              [61.1236601, 35.9555015],
              [61.1229949, 35.9555189],
              [61.1215144, 35.9556057],
              [61.1206131, 35.9558489],
              [61.1202913, 35.9560921],
              [61.1200982, 35.9561616],
              [61.1194973, 35.9565263],
              [61.1192613, 35.9568042],
              [61.1191111, 35.9571863],
              [61.1188288, 35.957488],
              [61.118612, 35.9577766],
              [61.1185687, 35.9578889],
              [61.1186111, 35.9580816],
              [61.1185062, 35.9582497],
              [61.1182662, 35.9585713],
              [61.1181378, 35.9589154],
              [61.117864, 35.9595572],
              [61.1176073, 35.9599867],
              [61.1174994, 35.9602125],
              [61.1173844, 35.9605586],
              [61.1174086, 35.9607072],
              [61.1174444, 35.9608474],
              [61.1174752, 35.9609684],
              [61.1175236, 35.9612149],
              [61.1174631, 35.9613798],
              [61.1172817, 35.9615897],
              [61.1172049, 35.9617209],
              [61.1172277, 35.9618918],
              [61.1171678, 35.9621307],
              [61.117048, 35.9624793],
              [61.1169839, 35.9628107],
              [61.1169824, 35.9629353],
              [61.1170252, 35.9630392],
              [61.1170908, 35.9631281],
              [61.1172976, 35.9631904],
              [61.1175558, 35.9632135],
              [61.1179955, 35.9631564],
              [61.1183343, 35.9631646],
              [61.1185643, 35.9632462],
              [61.1187049, 35.9633385],
              [61.1188345, 35.9634649],
              [61.1190685, 35.9637294],
              [61.1192763, 35.9640233],
              [61.1195223, 35.9643955],
              [61.1196837, 35.9647905],
              [61.1198226, 35.9649043],
              [61.1199622, 35.9649964],
              [61.1201564, 35.9651694],
              [61.1204166, 35.9654779],
              [61.1207282, 35.966054],
              [61.1214848, 35.9672104],
              [61.1221635, 35.9678233],
              [61.1226745, 35.968095],
              [61.1232304, 35.9682309],
              [61.1240082, 35.9682958],
              [61.1244855, 35.9682566],
              [61.1268965, 35.967853],
              [61.1274293, 35.9676665],
              [61.1277785, 35.9674652],
              [61.128143, 35.9673085],
              [61.1292371, 35.9670129],
              [61.1295802, 35.9670299],
              [61.1300307, 35.9670905],
              [61.1310573, 35.9677167],
              [61.1316035, 35.967986],
              [61.1321243, 35.9683116],
              [61.1325533, 35.9686371],
              [61.1328785, 35.9689903],
              [61.1331039, 35.9692627],
              [61.1342505, 35.9701215],
              [61.1347583, 35.9704978],
              [61.1354828, 35.9709272],
              [61.1361446, 35.9712758],
              [61.1374653, 35.9721184],
              [61.1381042, 35.9725685],
              [61.1387261, 35.9729817],
              [61.139365, 35.9734434],
              [61.1395875, 35.973635],
              [61.1398385, 35.9738774],
              [61.1402321, 35.9741844],
              [61.1404518, 35.9744361],
              [61.1410223, 35.9754171],
              [61.1412761, 35.975925],
              [61.1415871, 35.976569],
              [61.1419237, 35.9773493],
              [61.1420748, 35.9778709],
              [61.1422831, 35.978268],
              [61.1425369, 35.9790089],
              [61.1429145, 35.97974],
              [61.1431061, 35.9800224],
              [61.1432271, 35.9802689],
              [61.143334, 35.9805088],
              [61.1434086, 35.9807585],
              [61.143531, 35.9809532],
              [61.1436944, 35.9810936],
              [61.1438538, 35.9812878],
              [61.1442995, 35.9817611],
              [61.144592, 35.9819766],
              [61.1449268, 35.9822002],
              [61.1452173, 35.9824548],
              [61.1456065, 35.9826882],
              [61.1461491, 35.9829983],
              [61.1468248, 35.9833198],
              [61.1471657, 35.9834455],
              [61.1477062, 35.983625],
              [61.1481769, 35.9837727],
              [61.1487522, 35.9838998],
              [61.1493997, 35.9840417],
              [61.1499181, 35.9841446],
              [61.1514385, 35.9844679],
              [61.152511, 35.984768],
              [61.1532584, 35.9849573],
              [61.1540755, 35.9852524],
              [61.1546242, 35.9855511],
              [61.1552696, 35.9858155],
              [61.1557892, 35.9861236],
              [61.1571225, 35.9869308],
              [61.1578849, 35.9874302],
              [61.1585707, 35.9878219],
              [61.1591009, 35.988083],
              [61.159906, 35.9884896],
              [61.160299, 35.988771],
              [61.1612118, 35.9892072],
              [61.1620789, 35.9896549],
              [61.1628348, 35.9898811],
              [61.1632855, 35.9899757],
              [61.1639673, 35.9900819],
              [61.1647973, 35.9901004],
              [61.1658214, 35.9901465],
              [61.1663434, 35.9901604],
              [61.1669937, 35.9899919],
              [61.1674016, 35.989925],
              [61.1679008, 35.9898973],
              [61.1683087, 35.9899342],
              [61.1685141, 35.9900057],
              [61.1687851, 35.9902458],
              [61.1690275, 35.9903658],
              [61.1691844, 35.9906427],
              [61.1693641, 35.9910559],
              [61.1696494, 35.9915221],
              [61.1699945, 35.9922906],
              [61.1703111, 35.9932645],
              [61.1704395, 35.9935],
              [61.1707789, 35.9938577],
              [61.1708897, 35.9940946],
              [61.1709764, 35.9944487],
              [61.1710491, 35.9949138],
              [61.1710491, 35.9952173],
              [61.171043, 35.9953822],
              [61.1709643, 35.9956302],
              [61.1707969, 35.9960317],
              [61.1705408, 35.9963711],
              [61.1701454, 35.9967236],
              [61.1694181, 35.9974944],
              [61.1691095, 35.997756],
              [61.1688251, 35.9979078],
              [61.1681797, 35.9979682],
              [61.1676802, 35.9981311],
              [61.1674227, 35.9983915],
              [61.1669292, 35.9992074],
              [61.1666717, 35.9999713],
              [61.1665859, 36.0002664],
              [61.166307, 36.0007004],
              [61.1658778, 36.0015683],
              [61.1656632, 36.00228],
              [61.1655619, 36.0030545],
              [61.1655189, 36.0049293],
              [61.1655833, 36.0057625],
              [61.1659052, 36.0071859],
              [61.1661841, 36.0080885],
              [61.1663558, 36.0083836],
              [61.1668279, 36.0086613],
              [61.1672141, 36.0087307],
              [61.1691024, 36.0089043],
              [61.1707761, 36.0092514],
              [61.1725141, 36.0093382],
              [61.1731793, 36.0094771],
              [61.1735012, 36.0096854],
              [61.1736277, 36.009991],
              [61.1736277, 36.0131499],
              [61.1735418, 36.0138616],
              [61.1733273, 36.0145038],
              [61.1729196, 36.0153889],
              [61.1712673, 36.017975],
              [61.1706021, 36.0189122],
              [61.1692932, 36.0203353],
              [61.1667397, 36.0227303],
              [61.1652592, 36.0238236],
              [61.1644652, 36.024726],
              [61.1641005, 36.0252119],
              [61.1639503, 36.0257499],
              [61.1638, 36.0264614],
              [61.1638644, 36.0273638],
              [61.1638644, 36.0277282],
              [61.1636498, 36.0285786],
              [61.1630919, 36.0301403],
              [61.1629847, 36.0308171],
              [61.1629203, 36.0316153],
              [61.1630276, 36.0322053],
              [61.1635426, 36.0343223],
              [61.163843, 36.0350164],
              [61.1649373, 36.0364566],
              [61.1657098, 36.0372027],
              [61.1669972, 36.0383132],
              [61.1686924, 36.039441],
              [61.1703446, 36.0403432],
              [61.1726406, 36.0413322],
              [61.1745074, 36.0419221],
              [61.1782411, 36.0427897],
              [61.1793139, 36.0430326],
              [61.1796573, 36.0432234],
              [61.1802581, 36.0434663],
              [61.180433, 36.0437643],
              [61.1807334, 36.0446144],
              [61.180948, 36.045291],
              [61.1822355, 36.0482578],
              [61.1827719, 36.0497845],
              [61.1829436, 36.0503049],
              [61.1838019, 36.051901],
              [61.1841667, 36.0530286],
              [61.1842954, 36.0537919],
              [61.1844456, 36.0553011],
              [61.1844027, 36.0560644],
              [61.1842954, 36.0568277],
              [61.1840594, 36.0578859],
              [61.1837804, 36.0589093],
              [61.1837804, 36.0594818],
              [61.183716, 36.0598113],
              [61.1829221, 36.0609562],
              [61.1826646, 36.0616674],
              [61.1825725, 36.0623681],
              [61.1825939, 36.0638078],
              [61.1825081, 36.0646924],
              [61.1825725, 36.0650567],
              [61.1828514, 36.0659239],
              [61.1831089, 36.0664096],
              [61.1831304, 36.0666524],
              [61.1831089, 36.0668779],
              [61.1831733, 36.0671381],
              [61.1837097, 36.0677798],
              [61.1842676, 36.0684216],
              [61.1849972, 36.0691154],
              [61.1857053, 36.069601],
              [61.1867782, 36.0701387],
              [61.1884304, 36.0710752],
              [61.1904045, 36.0722893],
              [61.1921211, 36.0732085],
              [61.1927863, 36.0734513],
              [61.1932584, 36.0737635],
              [61.1936017, 36.0742144],
              [61.1940309, 36.0746133],
              [61.1944327, 36.0754346],
              [61.1952696, 36.0767006],
              [61.1959348, 36.0776718],
              [61.1961493, 36.0782615],
              [61.1962352, 36.0786777],
              [61.1962352, 36.0794928],
              [61.1964068, 36.0799263],
              [61.1964283, 36.0803599],
              [61.1962995, 36.0805333],
              [61.1961064, 36.0806547],
              [61.1961493, 36.0808454],
              [61.196321, 36.0810362],
              [61.1964283, 36.0816778],
              [61.1966214, 36.0821287],
              [61.1969004, 36.0831519],
              [61.1974797, 36.0843484],
              [61.1977587, 36.0847126],
              [61.1985955, 36.0851287],
              [61.1988101, 36.0852848],
              [61.1996255, 36.0862212],
              [61.2013803, 36.0878846],
              [61.2020241, 36.0884048],
              [61.2029682, 36.0890464],
              [61.2049209, 36.0898787],
              [61.2054788, 36.0902949],
              [61.2058221, 36.0907284],
              [61.2066589, 36.0915433],
              [61.2072812, 36.0920115],
              [61.2074314, 36.092393],
              [61.2073885, 36.0926704],
              [61.2065516, 36.0948551],
              [61.2062083, 36.0957394],
              [61.2059079, 36.0971958],
              [61.2057362, 36.0978546],
              [61.2055002, 36.0987735],
              [61.2055002, 36.0993977],
              [61.2056719, 36.1001952],
              [61.2059903, 36.1009515],
              [61.2072563, 36.1036734],
              [61.2075567, 36.1043495],
              [61.207664, 36.1046443],
              [61.2080931, 36.1049737],
              [61.2085008, 36.1052684],
              [61.2092089, 36.1060832],
              [61.2095308, 36.1064126],
              [61.2107324, 36.1070367],
              [61.2112525, 36.1074873],
              [61.2122954, 36.1084296],
              [61.2128833, 36.1089608],
              [61.2131408, 36.1093249],
              [61.2133553, 36.1094636],
              [61.2139347, 36.1097063],
              [61.2148145, 36.1103477],
              [61.2160161, 36.1107637],
              [61.2164238, 36.110729],
              [61.2166598, 36.1106597],
              [61.2168744, 36.1105383],
              [61.2173465, 36.1105383],
              [61.2181404, 36.1107117],
              [61.2197497, 36.1114051],
              [61.2202432, 36.1115611],
              [61.2206724, 36.1115785],
              [61.221402, 36.1114224],
              [61.2222174, 36.1111624],
              [61.2229684, 36.1106944],
              [61.2238481, 36.110365],
              [61.2243202, 36.1102783],
              [61.2250069, 36.1103477],
              [61.2261024, 36.1105576],
              [61.2264992, 36.1106977],
              [61.2272566, 36.1111425],
              [61.2281711, 36.1119938],
              [61.22845, 36.1123245],
              [61.2291587, 36.1134784],
              [61.229585, 36.1140126],
              [61.229821, 36.1145563],
              [61.2301039, 36.1154203],
              [61.2304885, 36.11605],
              [61.2306475, 36.1163528],
              [61.2309142, 36.1173118],
              [61.230984, 36.1179704],
              [61.2308504, 36.11873],
              [61.2308104, 36.1191354],
              [61.2306936, 36.1196586],
              [61.2306185, 36.119891],
              [61.2301284, 36.120725],
              [61.2298471, 36.121155],
              [61.2295658, 36.1214754],
              [61.229246, 36.1217464],
              [61.2290723, 36.1218741],
              [61.2286217, 36.1220647],
              [61.2282355, 36.1221514],
              [61.2279136, 36.1221167],
              [61.2274844, 36.1217701],
              [61.2265618, 36.1214407],
              [61.225846, 36.1212826],
              [61.2242014, 36.1209728],
              [61.2224097, 36.1206366],
              [61.2220359, 36.1205156],
              [61.2215896, 36.120233],
              [61.2213905, 36.1201234],
              [61.2207896, 36.1200714],
              [61.2203063, 36.1199677],
              [61.2198944, 36.1199541],
              [61.2197585, 36.1199815],
              [61.2197361, 36.1200524],
              [61.2194381, 36.1202089],
              [61.2190998, 36.1204218],
              [61.2190178, 36.1205221],
              [61.2188995, 36.1206313],
              [61.2188446, 36.1207084],
              [61.2187793, 36.1212318],
              [61.2187229, 36.1213761],
              [61.2186031, 36.1214727],
              [61.2182147, 36.1215967],
              [61.2181244, 36.1216555],
              [61.2180431, 36.1217874],
              [61.2179572, 36.1219954],
              [61.2177355, 36.1222501],
              [61.2170636, 36.1230219],
              [61.2168677, 36.123101],
              [61.2162518, 36.123173],
              [61.2153096, 36.1234186],
              [61.2147386, 36.1236246],
              [61.2142094, 36.1237428],
              [61.2137618, 36.1238756],
              [61.2133009, 36.12411],
              [61.2126549, 36.1245244],
              [61.2125435, 36.1246389],
              [61.2120578, 36.1252995],
              [61.2113559, 36.1260589],
              [61.211241, 36.1262245],
              [61.2107358, 36.1275945],
              [61.2104933, 36.1283499],
              [61.2104845, 36.1285286],
              [61.2105047, 36.1292232],
              [61.2108635, 36.130781],
              [61.2109413, 36.1312193],
              [61.2110868, 36.1316383],
              [61.2113045, 36.1319559],
              [61.211929, 36.1327928],
              [61.2123134, 36.1331907],
              [61.2142432, 36.1347526],
              [61.2150426, 36.1352752],
              [61.216605, 36.1359203],
              [61.2182639, 36.1364326],
              [61.2188606, 36.1365363],
              [61.2196113, 36.1366803],
              [61.2204999, 36.1368952],
              [61.2209644, 36.1372805],
              [61.2219408, 36.1376952],
              [61.2230034, 36.1382732],
              [61.2233897, 36.1384811],
              [61.224248, 36.1385851],
              [61.2245269, 36.1388624],
              [61.2246771, 36.1392089],
              [61.2251492, 36.1399714],
              [61.2253852, 36.1405952],
              [61.2251921, 36.1413404],
              [61.2248059, 36.1419469],
              [61.2244411, 36.1422414],
              [61.2236686, 36.1427266],
              [61.2229176, 36.1429866],
              [61.2220164, 36.1432291],
              [61.2200637, 36.1442688],
              [61.2191304, 36.1448975],
              [61.2189158, 36.1450881],
              [61.2187012, 36.145452],
              [61.2184652, 36.1457985],
              [61.2182935, 36.1460064],
              [61.2174137, 36.1463877],
              [61.2169846, 36.1467862],
              [61.2157615, 36.1482763],
              [61.2154825, 36.1487788],
              [61.2154825, 36.149056],
              [61.2155469, 36.1494372],
              [61.2156113, 36.1496624],
              [61.2158259, 36.1505461],
              [61.2160619, 36.1510139],
              [61.2167271, 36.1517936],
              [61.2174352, 36.1522961],
              [61.2192591, 36.1532317],
              [61.219817, 36.1534049],
              [61.2200101, 36.1535955],
              [61.2222444, 36.1553792],
              [61.2231885, 36.1564533],
              [61.2242185, 36.1579953],
              [61.224476, 36.1584804],
              [61.2245833, 36.1588788],
              [61.2250339, 36.1595718],
              [61.2253772, 36.1602301],
              [61.2261926, 36.1609577],
              [61.2264715, 36.1614948],
              [61.2265359, 36.1621358],
              [61.2266003, 36.1628461],
              [61.226729, 36.1644918],
              [61.2265359, 36.1657564],
              [61.2260638, 36.1685107],
              [61.2257634, 36.1697926],
              [61.2255059, 36.1704854],
              [61.2249051, 36.1709878],
              [61.2245273, 36.1714118],
              [61.2242913, 36.1719488],
              [61.2241411, 36.1724511],
              [61.2241196, 36.1734384],
              [61.2241196, 36.1741659],
              [61.2236261, 36.1764523],
              [61.2230682, 36.1783922],
              [61.2220168, 36.1806092],
              [61.2219739, 36.1809555],
              [61.2220597, 36.181198],
              [61.2220597, 36.1814232],
              [61.2218666, 36.182064],
              [61.2217593, 36.1824623],
              [61.2216683, 36.1826037],
              [61.2214554, 36.182755],
              [61.2213538, 36.1829511],
              [61.2210636, 36.1839572],
              [61.2208937, 36.1841917],
              [61.2204373, 36.1845099],
              [61.220107, 36.1846099],
              [61.2199354, 36.1847138],
              [61.2197298, 36.1851045],
              [61.2194694, 36.1853525],
              [61.2192238, 36.1861391],
              [61.2183059, 36.1873011],
              [61.2179184, 36.1880044],
              [61.2178023, 36.1884948],
              [61.2178453, 36.1889404],
              [61.2180016, 36.1893952],
              [61.2181982, 36.1896025],
              [61.2184855, 36.1898636],
              [61.2187057, 36.1901738],
              [61.2189483, 36.1906886],
              [61.2193457, 36.1917947],
              [61.2194567, 36.1921384],
              [61.2194045, 36.1925391],
              [61.2192972, 36.1926677],
              [61.2184946, 36.1928782],
              [61.2183046, 36.1930438],
              [61.2181758, 36.1933035],
              [61.2181174, 36.1937518],
              [61.2179672, 36.1939353],
              [61.2170171, 36.1947408],
              [61.2165021, 36.1949313],
              [61.2162322, 36.1951094],
              [61.2160834, 36.1951835],
              [61.2146986, 36.1950859],
              [61.2142035, 36.1949489],
              [61.2135576, 36.1950376],
              [61.2131762, 36.1951391],
              [61.2127814, 36.1951766],
              [61.2124719, 36.1951158],
              [61.2122063, 36.1950039],
              [61.2118956, 36.1950151],
              [61.2115669, 36.1950698],
              [61.2108908, 36.1952982],
              [61.2100209, 36.1957454],
              [61.2098214, 36.1960107],
              [61.2092744, 36.1964152],
              [61.2089477, 36.1963822],
              [61.2083683, 36.1966246],
              [61.2079264, 36.1969266],
              [61.207816, 36.1970808],
              [61.2077659, 36.1973745],
              [61.2078195, 36.1976732],
              [61.2078843, 36.1979955],
              [61.2078638, 36.1981556],
              [61.2076527, 36.1984922],
              [61.2072297, 36.1994267],
              [61.2071529, 36.1997191],
              [61.2071526, 36.2013488],
              [61.2071866, 36.2015695],
              [61.2072737, 36.2016844],
              [61.2077394, 36.2021791],
              [61.2079309, 36.2024869],
              [61.2080234, 36.2028084],
              [61.2080402, 36.2031837],
              [61.2080388, 36.203672],
              [61.2079309, 36.2043575],
              [61.2075513, 36.205452],
              [61.2074584, 36.2058559],
              [61.2074692, 36.206073],
              [61.2075275, 36.2067685],
              [61.2074945, 36.2069593],
              [61.2073213, 36.2076665],
              [61.2066861, 36.2087487],
              [61.2064436, 36.2090865],
              [61.2064082, 36.2092965],
              [61.2062212, 36.2105594],
              [61.2061293, 36.2109067],
              [61.2056396, 36.2117019],
              [61.2053327, 36.2121135],
              [61.2050476, 36.2130319],
              [61.2049276, 36.2132439],
              [61.2044563, 36.2138732],
              [61.2041862, 36.214178],
              [61.2039931, 36.2145334],
              [61.2038977, 36.2150098],
              [61.2038475, 36.2161592],
              [61.2037739, 36.216471],
              [61.2036053, 36.2167845],
              [61.2033636, 36.2170096],
              [61.2027731, 36.2174882],
              [61.2025267, 36.2176848],
              [61.2022048, 36.2181868],
              [61.2020115, 36.2183042],
              [61.2017328, 36.2184118],
              [61.2013895, 36.2184811],
              [61.2000805, 36.2185503],
              [61.1994368, 36.2186888],
              [61.1986, 36.2191562],
              [61.1977846, 36.2199525],
              [61.1975056, 36.2205584],
              [61.1971838, 36.2208873],
              [61.1967975, 36.2209912],
              [61.1963254, 36.2211816],
              [61.195789, 36.2217875],
              [61.1951238, 36.2221683],
              [61.1943728, 36.2224799],
              [61.1937505, 36.2229646],
              [61.1930853, 36.2239686],
              [61.1929566, 36.2242109],
              [61.1929995, 36.2245571],
              [61.1932141, 36.2248687],
              [61.1932141, 36.2251457],
              [61.1930424, 36.2255784],
              [61.1926991, 36.2259073],
              [61.1920232, 36.2265391],
              [61.1916906, 36.2269978],
              [61.1911971, 36.228573],
              [61.1911971, 36.2289884],
              [61.1912829, 36.2294038],
              [61.192227, 36.2305116],
              [61.1923558, 36.2309097],
              [61.1923558, 36.2314636],
              [61.1922485, 36.231879],
              [61.1918837, 36.2323117],
              [61.1911327, 36.233229],
              [61.1905533, 36.2341809],
              [61.1903388, 36.2353579],
              [61.1903388, 36.2358425],
              [61.1907035, 36.2372098],
              [61.1906821, 36.2376425],
              [61.190489, 36.2378848],
              [61.1901242, 36.2381963],
              [61.1893088, 36.2384386],
              [61.1888153, 36.238629],
              [61.1885363, 36.2388539],
              [61.1883646, 36.2392347],
              [61.1883646, 36.2398058],
              [61.188193, 36.2407404],
              [61.1881501, 36.2414846],
              [61.1879999, 36.241848],
              [61.1879999, 36.242073],
              [61.1880642, 36.2424537],
              [61.1878926, 36.2430421],
              [61.1878926, 36.2432671],
              [61.1884076, 36.2436651],
              [61.1890981, 36.2444313],
              [61.1895272, 36.2447428],
              [61.1902997, 36.2450197],
              [61.1905786, 36.2452446],
              [61.1907288, 36.2457292],
              [61.1906001, 36.2463349],
              [61.1905357, 36.2467675],
              [61.1902782, 36.2470098],
              [61.1897632, 36.247304],
              [61.1891195, 36.2478923],
              [61.1887118, 36.2484807],
              [61.1885831, 36.2489652],
              [61.1882398, 36.2499862],
              [61.1882612, 36.250315],
              [61.1882398, 36.2506611],
              [61.188111, 36.2509552],
              [61.1876175, 36.2513532],
              [61.1874458, 36.2517166],
              [61.1873814, 36.2520281],
              [61.1875102, 36.2527375],
              [61.1874673, 36.2533259],
              [61.1875102, 36.2544852],
              [61.1874887, 36.2548659],
              [61.1873385, 36.2550908],
              [61.1869523, 36.2553504],
              [61.186609, 36.2557137],
              [61.1863944, 36.2561982],
              [61.1863515, 36.2569942],
              [61.1862871, 36.2573575],
              [61.1861584, 36.2576517],
              [61.185815, 36.2578766],
              [61.1846134, 36.2583265],
              [61.1842486, 36.2586206],
              [61.1840341, 36.2589494],
              [61.1838409, 36.2595896],
              [61.1838195, 36.2598664],
              [61.1836907, 36.2601086],
              [61.1831757, 36.2604028],
              [61.1829397, 36.2606623],
              [61.1828539, 36.2609737],
              [61.1827037, 36.2619599],
              [61.1827251, 36.2631365],
              [61.1825749, 36.2634133],
              [61.1822316, 36.2636901],
              [61.1820599, 36.2639323],
              [61.1812446, 36.2647974],
              [61.1811587, 36.2650915],
              [61.1813304, 36.2655932],
              [61.1813733, 36.2658527],
              [61.1812231, 36.2661642],
              [61.1801931, 36.2671157],
              [61.1799142, 36.2673752],
              [61.1793348, 36.2683094],
              [61.1786696, 36.269728],
              [61.1782834, 36.2704892],
              [61.1774251, 36.2711985],
              [61.1766741, 36.2722365],
              [61.176481, 36.2727555],
              [61.1762235, 36.2730669],
              [61.1751935, 36.2738281],
              [61.1748073, 36.2742951],
              [61.1744425, 36.2750736],
              [61.1742064, 36.2753677],
              [61.1733267, 36.2761288],
              [61.1731121, 36.2767343],
              [61.1730263, 36.277184],
              [61.1731336, 36.2777549],
              [61.1733696, 36.2782219],
              [61.1738631, 36.2787409],
              [61.1740289, 36.2789982],
              [61.1740289, 36.2793614],
              [61.1739431, 36.2798112],
              [61.1739646, 36.2804166],
              [61.1737285, 36.2811258],
              [61.1737285, 36.2817312],
              [61.1733852, 36.2824058],
              [61.1731492, 36.2827345],
              [61.1726771, 36.2831669],
              [61.1725269, 36.2834955],
              [61.1724411, 36.2838242],
              [61.1725055, 36.284395],
              [61.1721621, 36.2855884],
              [61.1721836, 36.2861246],
              [61.1720548, 36.2866435],
              [61.1717544, 36.2870586],
              [61.1712394, 36.2874564],
              [61.1702524, 36.288131],
              [61.169716, 36.2887363],
              [61.1696087, 36.2892379],
              [61.1696516, 36.2897222],
              [61.1698876, 36.2901892],
              [61.1699305, 36.2904486],
              [61.1698876, 36.2909675],
              [61.169716, 36.2913653],
              [61.1694155, 36.2915209],
              [61.1687718, 36.2916247],
              [61.1671839, 36.2912442],
              [61.1667763, 36.2912961],
              [61.1644803, 36.2920571],
              [61.1636434, 36.2924895],
              [61.1632787, 36.2928526],
              [61.1619483, 36.2943919],
              [61.1612616, 36.2947897],
              [61.1604248, 36.2951183],
              [61.1596094, 36.2953085],
              [61.1590515, 36.2953777],
              [61.1585794, 36.2956544],
              [61.1583434, 36.2958273],
              [61.1574636, 36.2960348],
              [61.1567126, 36.2964845],
              [61.156498, 36.296692],
              [61.1563907, 36.2971244],
              [61.1565624, 36.298456],
              [61.1566911, 36.299044],
              [61.1569272, 36.2994417],
              [61.1576567, 36.3001681],
              [61.1593519, 36.3014132],
              [61.1597811, 36.3020184],
              [61.1611329, 36.30335],
              [61.1614333, 36.303886],
              [61.1615406, 36.3044048],
              [61.1614679, 36.3048336],
              [61.1612646, 36.3052227],
              [61.1604133, 36.3062671],
              [61.1603879, 36.306564],
              [61.1604387, 36.3067893],
              [61.1605531, 36.3071886],
              [61.1606674, 36.3081511],
              [61.1607818, 36.3085914],
              [61.1611375, 36.3094719],
              [61.1613154, 36.3100146],
              [61.1613154, 36.3103729],
              [61.1612011, 36.3109053],
              [61.1609724, 36.3113251],
              [61.1606253, 36.311627],
              [61.1596597, 36.3122516],
              [61.1580842, 36.3131014],
              [61.1576694, 36.3132173],
              [61.1571312, 36.3133676],
              [61.1564451, 36.313644],
              [61.1555557, 36.3141764],
              [61.1551237, 36.3143402],
              [61.1547171, 36.3144631],
              [61.153942, 36.3145654],
              [61.1531984, 36.3147279],
              [61.1520874, 36.3151272],
              [61.1512641, 36.3155577],
              [61.1503204, 36.3161328],
              [61.1497802, 36.3166284],
              [61.1495607, 36.3169049],
              [61.1493831, 36.3172169],
              [61.149279, 36.317514],
              [61.1492409, 36.3179337],
              [61.1493157, 36.3182352],
              [61.1494837, 36.3185206],
              [61.149698, 36.3187679],
              [61.1502155, 36.3191189],
              [61.1517185, 36.3197765],
              [61.1526079, 36.3202678],
              [61.1538785, 36.3212199],
              [61.1541842, 36.3213978],
              [61.1545267, 36.3215461],
              [61.1548485, 36.321632],
              [61.1552255, 36.3216587],
              [61.1560768, 36.3216792],
              [61.1564819, 36.3216207],
              [61.1569789, 36.3214437],
              [61.158097, 36.3209319],
              [61.1594368, 36.3199809],
              [61.1598454, 36.3199081],
              [61.1601155, 36.3199228],
              [61.160257, 36.3200412],
              [61.1604603, 36.3202357],
              [61.1609431, 36.3204712],
              [61.1611464, 36.3206964],
              [61.1611973, 36.3209728],
              [61.161121, 36.3213721],
              [61.1606382, 36.322406],
              [61.160562, 36.3228155],
              [61.1605747, 36.3231124],
              [61.1607271, 36.3236652],
              [61.1607907, 36.3240132],
              [61.160689, 36.3244636],
              [61.160041, 36.3266543],
              [61.1599648, 36.3271354],
              [61.1599902, 36.327422],
              [61.1602951, 36.3281897],
              [61.1604095, 36.3289882],
              [61.1603968, 36.3305031],
              [61.160346, 36.3309433],
              [61.1602189, 36.3312299],
              [61.159914, 36.3315267],
              [61.1595201, 36.3317724],
              [61.1590246, 36.3319054],
              [61.1585671, 36.3319976],
              [61.1571568, 36.332059],
              [61.1547808, 36.3322535],
              [61.1541963, 36.3324786],
              [61.1539854, 36.3326123],
              [61.1529465, 36.3330421],
              [61.1525113, 36.3333588],
              [61.1522585, 36.3337094],
              [61.1520901, 36.3339243],
              [61.1518093, 36.3341731],
              [61.1513881, 36.3344332],
              [61.1510371, 36.3348178],
              [61.1492962, 36.3370118],
              [61.1488891, 36.3374868],
              [61.1481169, 36.3384481],
              [61.1478782, 36.3390475],
              [61.1478221, 36.3394207],
              [61.1478782, 36.3399522],
              [61.1479765, 36.3403254],
              [61.1483134, 36.3412754],
              [61.1484117, 36.3418408],
              [61.1483939, 36.3425993],
              [61.1481272, 36.3437641],
              [61.1481412, 36.3440694],
              [61.1482114, 36.3443295],
              [61.1484501, 36.3445105],
              [61.1485343, 36.3446236],
              [61.1485905, 36.3449176],
              [61.1488292, 36.3453812],
              [61.1495873, 36.3461162],
              [61.1500927, 36.346512],
              [61.1504016, 36.3469078],
              [61.1506824, 36.3473601],
              [61.150907, 36.3476202],
              [61.1512299, 36.3479029],
              [61.1514826, 36.3485022],
              [61.1517634, 36.3488188],
              [61.1521284, 36.3492825],
              [61.1522267, 36.3497235],
              [61.1521986, 36.3500288],
              [61.1517915, 36.3506281],
              [61.1517213, 36.350956],
              [61.1517213, 36.3511369],
              [61.1524794, 36.3519737],
              [61.1528585, 36.3522903],
              [61.1529989, 36.3526408],
              [61.1532095, 36.3529122],
              [61.153757, 36.3533757],
              [61.1551469, 36.3540655],
              [61.1556383, 36.3544273],
              [61.1562841, 36.3551622],
              [61.1564105, 36.3554223],
              [61.1563965, 36.3559085],
              [61.1563965, 36.3564625],
              [61.1564947, 36.3569939],
              [61.1565509, 36.3576271],
              [61.1565509, 36.3581133],
              [61.1564386, 36.3584072],
              [61.1561157, 36.3587351],
              [61.1557787, 36.3590291],
              [61.1554418, 36.3595379],
              [61.1553575, 36.3598771],
              [61.1551048, 36.3607702],
              [61.15481, 36.3616521],
              [61.1545011, 36.3623757],
              [61.1539957, 36.3632462],
              [61.1539676, 36.3635515],
              [61.154094, 36.3639246],
              [61.154094, 36.3642863],
              [61.1540378, 36.364682],
              [61.1537711, 36.3656091],
              [61.1535745, 36.3663439],
              [61.1535043, 36.3672822],
              [61.1535745, 36.3675196],
              [61.1538272, 36.3677683],
              [61.1545994, 36.3680284],
              [61.1547679, 36.368164],
              [61.1548381, 36.3683675],
              [61.1548381, 36.3685258],
              [61.1552171, 36.369611],
              [61.1552171, 36.3699163],
              [61.1550196, 36.3706553],
              [61.1547107, 36.3710736],
              [61.1543878, 36.3713223],
              [61.1541211, 36.3715031],
              [61.1535735, 36.3716614],
              [61.1529137, 36.371797],
              [61.1514676, 36.3720005],
              [61.1508779, 36.3721701],
              [61.1503304, 36.3723962],
              [61.149488, 36.3728597],
              [61.1490809, 36.3731875],
              [61.1485614, 36.3738431],
              [61.1483087, 36.3741596],
              [61.1478875, 36.3746796],
              [61.1475225, 36.3750413],
              [61.1472698, 36.3756065],
              [61.1472698, 36.3759683],
              [61.1473821, 36.3763413],
              [61.1474944, 36.3764317],
              [61.1477331, 36.3765448],
              [61.1478875, 36.3767482],
              [61.1478875, 36.376963],
              [61.1479998, 36.3774943],
              [61.1481543, 36.3783194],
              [61.1482104, 36.3792463],
              [61.1481122, 36.3797323],
              [61.1479296, 36.3802975],
              [61.1474663, 36.3809757],
              [61.1471434, 36.3813035],
              [61.1466661, 36.3815182],
              [61.1464555, 36.3816991],
              [61.1458237, 36.3825129],
              [61.1454446, 36.3831006],
              [61.1449954, 36.3840614],
              [61.1440828, 36.3856211],
              [61.1439143, 36.3863897],
              [61.1439284, 36.3871243],
              [61.1440547, 36.3876103],
              [61.1442934, 36.3881189],
              [61.1444759, 36.3891022],
              [61.1444478, 36.3897577],
              [61.1442513, 36.3900515],
              [61.1440547, 36.3902098],
              [61.1435072, 36.3905488],
              [61.1432124, 36.390854],
              [61.1430018, 36.3912721],
              [61.1427771, 36.3918259],
              [61.1425525, 36.3921084],
              [61.1422577, 36.3923571],
              [61.1419348, 36.3927978],
              [61.1414995, 36.3934533],
              [61.1413451, 36.3935663],
              [61.1410924, 36.3936228],
              [61.1405589, 36.3935663],
              [61.1404185, 36.3936115],
              [61.1403343, 36.3937358],
              [61.1404045, 36.3939506],
              [61.1411064, 36.3949903],
              [61.1418646, 36.3966063],
              [61.1421454, 36.3970583],
              [61.1434472, 36.3983579],
              [61.1445704, 36.3991941],
              [61.1450617, 36.3995218],
              [61.1462691, 36.4006067],
              [61.146578, 36.4008666],
              [61.14728, 36.401296],
              [61.1483049, 36.4016124],
              [61.1489366, 36.4017819],
              [61.1508179, 36.4026294],
              [61.1511268, 36.402765],
              [61.1526431, 36.4029797],
              [61.1531625, 36.4030701],
              [61.1537522, 36.4032961],
              [61.1546928, 36.4038385],
              [61.1557177, 36.4045842],
              [61.1566443, 36.4055899],
              [61.1570655, 36.4062679],
              [61.1579079, 36.4069119],
              [61.158315, 36.4071944],
              [61.1589889, 36.408087],
              [61.1593259, 36.4087085],
              [61.1595084, 36.4090927],
              [61.1596207, 36.4093525],
              [61.1606175, 36.4102339],
              [61.1614459, 36.4107762],
              [61.163285, 36.4118835],
              [61.1651242, 36.4127309],
              [61.1662474, 36.4132054],
              [61.1663878, 36.4133749],
              [61.1669915, 36.4145951],
              [61.1673565, 36.4155893],
              [61.1674829, 36.4163463],
              [61.1674407, 36.4173857],
              [61.1673565, 36.4178263],
              [61.167174, 36.4182217],
              [61.1669774, 36.4186058],
              [61.1665703, 36.4192272],
              [61.1663737, 36.4196791],
              [61.1660929, 36.4206507],
              [61.16577, 36.4216335],
              [61.1655454, 36.4222775],
              [61.1653067, 36.4227181],
              [61.1648294, 36.4232716],
              [61.1632289, 36.4249887],
              [61.1629481, 36.4254632],
              [61.1627515, 36.4259715],
              [61.1625269, 36.4268753],
              [61.162204, 36.4281066],
              [61.1618951, 36.4287843],
              [61.1617968, 36.4291458],
              [61.1617968, 36.4294847],
              [61.1618138, 36.430086],
              [61.1617997, 36.4308654],
              [61.1619121, 36.4329777],
              [61.1620665, 36.4337006],
              [61.1625579, 36.4348302],
              [61.1630633, 36.4357564],
              [61.1642426, 36.4373377],
              [61.1645936, 36.4379024],
              [61.1648744, 36.438806],
              [61.1649165, 36.4392804],
              [61.1648884, 36.4397322],
              [61.1646076, 36.4403759],
              [61.1643128, 36.44076],
              [61.164032, 36.4409858],
              [61.1634704, 36.4413134],
              [61.1617015, 36.4423863],
              [61.1609433, 36.4431092],
              [61.1605502, 36.443832],
              [61.1604519, 36.4443515],
              [61.1604941, 36.4446677],
              [61.1605502, 36.4451646],
              [61.1604519, 36.4456842],
              [61.1602133, 36.4461133],
              [61.1598763, 36.447796],
              [61.1598061, 36.4487221],
              [61.1599044, 36.4489367],
              [61.1599044, 36.4492529],
              [61.15975, 36.4495465],
              [61.1596938, 36.4498175],
              [61.1595675, 36.4502692],
              [61.1594271, 36.4504499],
              [61.1588795, 36.4508226],
              [61.158711, 36.4510485],
              [61.1584864, 36.4520761],
              [61.1585707, 36.4523358],
              [61.1587672, 36.4526182],
              [61.1589216, 36.453499],
              [61.1588795, 36.4541652],
              [61.1589638, 36.4544814],
              [61.1591182, 36.4548315],
              [61.1593709, 36.4551251],
              [61.1599184, 36.4554074],
              [61.1613364, 36.455972],
              [61.1634283, 36.456706],
              [61.1642988, 36.4570561],
              [61.1674296, 36.4577336],
              [61.1687212, 36.4578465],
              [61.1704762, 36.4578013],
              [61.1710377, 36.4578917],
              [61.1716836, 36.4581288],
              [61.1720626, 36.4583885],
              [61.1724557, 36.4587047],
              [61.1727646, 36.459066],
              [61.1741124, 36.4603081],
              [61.1742809, 36.4605226],
              [61.1744353, 36.4609743],
              [61.1747863, 36.4627019],
              [61.1747863, 36.4630406],
              [61.1747021, 36.4633342],
              [61.1738597, 36.4646778],
              [61.1736351, 36.4652423],
              [61.1735508, 36.4657165],
              [61.1735087, 36.4661682],
              [61.1734378, 36.4666324],
              [61.1734037, 36.4668555],
              [61.1733756, 36.4672281],
              [61.1732072, 36.4676684],
              [61.1729123, 36.4682216],
              [61.1724069, 36.4689217],
              [61.1713961, 36.4703442],
              [61.1711995, 36.4707055],
              [61.1710872, 36.4711797],
              [61.1709187, 36.4715748],
              [61.1696692, 36.4730877],
              [61.1691076, 36.4738441],
              [61.1687286, 36.4744311],
              [61.1684337, 36.4747134],
              [61.1678862, 36.4750633],
              [61.1677177, 36.4751762],
              [61.1675633, 36.4754472],
              [61.167451, 36.4758649],
              [61.1674229, 36.4764971],
              [61.1675633, 36.4779646],
              [61.1677739, 36.4792629],
              [61.1677037, 36.4794999],
              [61.1675212, 36.4797596],
              [61.1673246, 36.4800418],
              [61.1669596, 36.480911],
              [61.1666928, 36.4812835],
              [61.1664261, 36.4814754],
              [61.1658083, 36.4817577],
              [61.164278, 36.4821527],
              [61.1636182, 36.4822318],
              [61.1628179, 36.4821753],
              [61.1609366, 36.4821527],
              [61.1604733, 36.4821979],
              [61.1600521, 36.4823785],
              [61.1597152, 36.4826043],
              [61.1593642, 36.482751],
              [61.1591396, 36.4829091],
              [61.1587605, 36.4833606],
              [61.1586341, 36.4836541],
              [61.1582551, 36.4840717],
              [61.1575952, 36.4846249],
              [61.1572302, 36.485099],
              [61.1570336, 36.4857311],
              [61.1569211, 36.4865636],
              [61.1569211, 36.486812],
              [61.1569772, 36.4870603],
              [61.1572299, 36.4875344],
              [61.1578758, 36.4887083],
              [61.1587322, 36.4906948],
              [61.1590551, 36.4912931],
              [61.1605994, 36.4935843],
              [61.1607258, 36.4938326],
              [61.160796, 36.4940696],
              [61.1609785, 36.4946678],
              [61.1614278, 36.4957739],
              [61.1620174, 36.497591],
              [61.1620455, 36.4977828],
              [61.1620034, 36.4980198],
              [61.1619753, 36.4983471],
              [61.1620034, 36.4988776],
              [61.161863, 36.4994419],
              [61.1617928, 36.5000964],
              [61.1618349, 36.500672],
              [61.1619191, 36.501146],
              [61.1621438, 36.5015523],
              [61.1621578, 36.5017329],
              [61.1620876, 36.5020601],
              [61.161863, 36.5023874],
              [61.1613856, 36.5026583],
              [61.1612312, 36.5027034],
              [61.1603467, 36.5033128],
              [61.1598694, 36.5036062],
              [61.1593647, 36.5037837],
              [61.1590839, 36.5038739],
              [61.158747, 36.5040884],
              [61.1581292, 36.5045623],
              [61.1576098, 36.5051604],
              [61.1568657, 36.5059955],
              [61.1567253, 36.5062664],
              [61.1566972, 36.5065146],
              [61.1567674, 36.5067968],
              [61.1571465, 36.5078688],
              [61.1575536, 36.5083089],
              [61.1578484, 36.5085233],
              [61.1581713, 36.5086474],
              [61.1587189, 36.5086587],
              [61.1591681, 36.508591],
              [61.1599403, 36.5086361],
              [61.1606563, 36.508828],
              [61.16126, 36.508986],
              [61.1619339, 36.5093471],
              [61.1624815, 36.5097646],
              [61.1628044, 36.5101257],
              [61.1631694, 36.510656],
              [61.1633519, 36.51113],
              [61.1636327, 36.5121343],
              [61.1640118, 36.5132062],
              [61.1642645, 36.5140864],
              [61.1643206, 36.5145941],
              [61.164447, 36.5154517],
              [61.1645593, 36.5156548],
              [61.1653034, 36.5166252],
              [61.1656544, 36.5171442],
              [61.1667916, 36.5189382],
              [61.1671508, 36.51933],
              [61.1674597, 36.5196347],
              [61.1677966, 36.5198942],
              [61.1699728, 36.5214625],
              [61.1705624, 36.5217558],
              [61.1709836, 36.5220266],
              [61.1721208, 36.5223764],
              [61.1728087, 36.5226133],
              [61.1733984, 36.5226359],
              [61.1754482, 36.5229631],
              [61.1777647, 36.5234482],
              [61.1792669, 36.5238318],
              [61.1798425, 36.5240349],
              [61.1806147, 36.5244185],
              [61.1813058, 36.5248746],
              [61.1816287, 36.5251002],
              [61.1819235, 36.525371],
              [61.1825974, 36.5259915],
              [61.1831881, 36.5267233],
              [61.1833846, 36.5270956],
              [61.1835952, 36.5275808],
              [61.1835952, 36.5280659],
              [61.1835391, 36.5283705],
              [61.1833706, 36.5287653],
              [61.182809, 36.5294197],
              [61.1824018, 36.5299048],
              [61.1816297, 36.5308975],
              [61.1813208, 36.5312247],
              [61.1810962, 36.5313601],
              [61.1806329, 36.531518],
              [61.1801976, 36.5316534],
              [61.1797624, 36.5318677],
              [61.1790885, 36.5323641],
              [61.1779373, 36.5333342],
              [61.1771791, 36.5340675],
              [61.1766176, 36.534812],
              [61.1763368, 36.5353986],
              [61.1761262, 36.5359739],
              [61.1760279, 36.5366846],
              [61.1758594, 36.5371471],
              [61.1757892, 36.5376434],
              [61.1758735, 36.5379818],
              [61.176056, 36.5382413],
              [61.1768013, 36.539244],
              [61.1775314, 36.5401464],
              [61.1778543, 36.5407329],
              [61.1786545, 36.5416691],
              [61.1798339, 36.542876],
              [61.1808728, 36.5438686],
              [61.1819258, 36.5446131],
              [61.18413, 36.5463613],
              [61.1847056, 36.5468125],
              [61.185562, 36.5480081],
              [61.1857585, 36.5483239],
              [61.1858849, 36.5490683],
              [61.1858989, 36.5494517],
              [61.1858007, 36.5497675],
              [61.1856603, 36.549948],
              [61.1854637, 36.5500044],
              [61.1852812, 36.550151],
              [61.1851689, 36.550354],
              [61.1851408, 36.5505796],
              [61.1848881, 36.5511886],
              [61.1845371, 36.551933],
              [61.1842844, 36.5525758],
              [61.184158, 36.5527675],
              [61.1835684, 36.5532525],
              [61.1833718, 36.5535119],
              [61.1829506, 36.5538164],
              [61.1825856, 36.5540758],
              [61.1819538, 36.5548652],
              [61.1817994, 36.5552374],
              [61.1817994, 36.5556321],
              [61.1818556, 36.5562524],
              [61.1820662, 36.5570644],
              [61.1825718, 36.5583315],
              [61.1832598, 36.5598878],
              [61.183695, 36.5608125],
              [61.1841723, 36.5613312],
              [61.1843548, 36.5616921],
              [61.1845654, 36.5623687],
              [61.1849164, 36.5639136],
              [61.1849585, 36.5641616],
              [61.1852955, 36.5645676],
              [61.1856605, 36.5652442],
              [61.185843, 36.5657741],
              [61.185829, 36.5661237],
              [61.1857588, 36.5666311],
              [61.1853236, 36.5678151],
              [61.1848883, 36.5686157],
              [61.1844391, 36.569202],
              [61.183709, 36.5698335],
              [61.1827543, 36.5707242],
              [61.1818558, 36.5717954],
              [61.1813644, 36.5724381],
              [61.1800026, 36.5744563],
              [61.1793781, 36.5756603],
              [61.1789148, 36.5767652],
              [61.1788165, 36.5772049],
              [61.1788305, 36.5775544],
              [61.1790131, 36.5781858],
              [61.1790131, 36.5784338],
              [61.1785497, 36.5800911],
              [61.1784374, 36.5803391],
              [61.1782549, 36.5805646],
              [61.1778618, 36.5807901],
              [61.1776933, 36.5809479],
              [61.1776231, 36.5811847],
              [61.177567, 36.5815229],
              [61.1774547, 36.582064],
              [61.1769914, 36.5839918],
              [61.1769352, 36.5843864],
              [61.1769071, 36.5846795],
              [61.1767948, 36.584905],
              [61.1766404, 36.5855814],
              [61.1763596, 36.5865283],
              [61.1762192, 36.5874866],
              [61.1762052, 36.5878924],
              [61.1762473, 36.5881066],
              [61.1764579, 36.5884448],
              [61.1771177, 36.5894255],
              [61.1773002, 36.5897073],
              [61.1773424, 36.5899553],
              [61.1773424, 36.5901131],
              [61.177216, 36.5904851],
              [61.1770054, 36.5907331],
              [61.1765842, 36.5911727],
              [61.1764298, 36.5914658],
              [61.1764017, 36.5916462],
              [61.1763455, 36.5919618],
              [61.1762718, 36.5920569],
              [61.1759208, 36.5922372],
              [61.1751767, 36.5928797],
              [61.174924, 36.5930263],
              [61.1744326, 36.5931841],
              [61.1741939, 36.5932855],
              [61.1738008, 36.5936237],
              [61.172088, 36.5949989],
              [61.1719897, 36.5952243],
              [61.1716388, 36.5957541],
              [61.171021, 36.5968587],
              [61.1709087, 36.5971292],
              [61.1709368, 36.5975012],
              [61.1709368, 36.5979295],
              [61.1708385, 36.5983466],
              [61.1708666, 36.5987411],
              [61.1711053, 36.599237],
              [61.1712737, 36.5994399],
              [61.171386, 36.6003416],
              [61.1714843, 36.6006346],
              [61.1716528, 36.6008037],
              [61.1722565, 36.6010967],
              [61.172453, 36.6012658],
              [61.1725654, 36.601525],
              [61.1734077, 36.6027085],
              [61.1735341, 36.6032269],
              [61.1736043, 36.6034862],
              [61.1736324, 36.6037679],
              [61.173857, 36.6042187],
              [61.1739412, 36.604523],
              [61.1739553, 36.6053232],
              [61.1739132, 36.6055825],
              [61.1737868, 36.6058191],
              [61.1731691, 36.6061009],
              [61.1724671, 36.60627],
              [61.1721161, 36.6062812],
              [61.1718072, 36.6062023],
              [61.1705016, 36.6054923],
              [61.1702208, 36.605481],
              [61.1699961, 36.6055261],
              [61.1697013, 36.6057177],
              [61.1695609, 36.6058755],
              [61.1694486, 36.6061009],
              [61.1694345, 36.6064277],
              [61.1695188, 36.6068898],
              [61.169603, 36.6074308],
              [61.1695328, 36.6081408],
              [61.169603, 36.6085803],
              [61.169603, 36.6088283],
              [61.1693363, 36.6092565],
              [61.1689291, 36.609651],
              [61.1684398, 36.6098469],
              [61.1681169, 36.6098807],
              [61.1673447, 36.6098357],
              [61.1671902, 36.6098695],
              [61.1670358, 36.6099822],
              [61.1667691, 36.6102414],
              [61.1665865, 36.6105795],
              [61.1661934, 36.6115486],
              [61.1657985, 36.612317],
              [61.1655037, 36.6128354],
              [61.1654476, 36.6131172],
              [61.1654897, 36.6133876],
              [61.1655318, 36.6137257],
              [61.1652931, 36.6144807],
              [61.1651387, 36.6148301],
              [61.164886, 36.6151005],
              [61.1645069, 36.6153372],
              [61.1640576, 36.6155062],
              [61.1633697, 36.6156076],
              [61.1630468, 36.6156076],
              [61.1625273, 36.615664],
              [61.1610532, 36.6155513],
              [61.160646, 36.6155964],
              [61.1603091, 36.6157203],
              [61.1592983, 36.6163514],
              [61.1589332, 36.6165317],
              [61.1584418, 36.6166556],
              [61.1580487, 36.6167683],
              [61.1576135, 36.6170388],
              [61.1571221, 36.617512],
              [61.1568694, 36.6176247],
              [61.1565465, 36.6177036],
              [61.1559568, 36.6176698],
              [61.1555216, 36.6177374],
              [61.1551987, 36.6178501],
              [61.154595, 36.6182107],
              [61.1535842, 36.6192249],
              [61.1534578, 36.6194615],
              [61.1534578, 36.6199122],
              [61.153514, 36.6202277],
              [61.1537246, 36.6206897],
              [61.1538228, 36.6210616],
              [61.1536965, 36.6215461],
              [61.1536263, 36.6218278],
              [61.1533174, 36.6223349],
              [61.1529524, 36.6228419],
              [61.1526154, 36.6235856],
              [61.1524329, 36.6242617],
              [61.1520679, 36.6250955],
              [61.1519837, 36.6253433],
              [61.1519837, 36.6256025],
              [61.15211, 36.6259518],
              [61.1522925, 36.6263574],
              [61.1525312, 36.6266616],
              [61.1529664, 36.627056],
              [61.1530787, 36.6271686],
              [61.1531068, 36.6273264],
              [61.1531068, 36.6274841],
              [61.1530507, 36.6277095],
              [61.1529103, 36.6279573],
              [61.1525611, 36.6286053],
              [61.1522522, 36.6288757],
              [61.1519574, 36.6290334],
              [61.151466, 36.6293038],
              [61.1512133, 36.6294165],
              [61.1502165, 36.6295404],
              [61.1497532, 36.6296531],
              [61.1490091, 36.6301263],
              [61.1482369, 36.6305995],
              [61.1474788, 36.6311853],
              [61.1470716, 36.6315459],
              [61.1467347, 36.6319515],
              [61.146496, 36.6324923],
              [61.1463275, 36.632988],
              [61.1462714, 36.6334386],
              [61.1462012, 36.6336865],
              [61.1460608, 36.6342498],
              [61.1459344, 36.6344639],
              [61.1457519, 36.6346441],
              [61.1454571, 36.63523],
              [61.1454009, 36.6355003],
              [61.1453027, 36.6362101],
              [61.1452044, 36.6369536],
              [61.1451201, 36.6371339],
              [61.144713, 36.6376296],
              [61.1441655, 36.6385534],
              [61.1438847, 36.6389815],
              [61.143646, 36.639218],
              [61.1434354, 36.6395222],
              [61.1433652, 36.6397475],
              [61.1434055, 36.6401656],
              [61.143524, 36.6407426],
              [61.143705, 36.6412655],
              [61.1440107, 36.6418158],
              [61.1440606, 36.6423081],
              [61.1442821, 36.6430218],
              [61.1444193, 36.6435552],
              [61.1444528, 36.6440585],
              [61.1446662, 36.6449297],
              [61.1448795, 36.6453278],
              [61.1450308, 36.6458838],
              [61.1454174, 36.6464182],
              [61.1387816, 36.6457884],
              [61.1288645, 36.6442951],
              [61.1012954, 36.6438284],
              [61.076954, 36.6426837],
              [61.0625952, 36.6419809],
              [61.0370811, 36.6407337],
              [61.0159768, 36.6397418],
              [61.0071691, 36.6392999],
              [60.9968859, 36.6389012],
              [60.979364, 36.6380015],
              [60.9528391, 36.6368252],
              [60.928845, 36.6356881],
              [60.9044014, 36.6345934],
              [60.8804153, 36.6333557],
              [60.8530171, 36.6320521],
              [60.8252384, 36.6305155],
              [60.807335, 36.629649],
              [60.7840906, 36.6283703],
              [60.7781099, 36.6280533],
              [60.7572982, 36.6269504],
              [60.7382641, 36.6258818],
              [60.7158069, 36.6245699],
              [60.6937018, 36.6232501],
              [60.6752205, 36.6222116],
              [60.6536179, 36.6240625],
              [60.6384009, 36.6253586],
              [60.6362567, 36.6255412],
              [60.6087152, 36.627961],
              [60.5857407, 36.6281783],
              [60.5711248, 36.6283152],
              [60.5447238, 36.6285362],
              [60.5120363, 36.6270305],
              [60.4888549, 36.6259902],
              [60.4519776, 36.6262977],
              [60.4349428, 36.6269578],
              [60.4226264, 36.6274122],
              [60.3899738, 36.6285373],
              [60.3606236, 36.6294918],
              [60.3587263, 36.6295535],
              [60.3455423, 36.6293939],
              [60.3444209, 36.6327734],
              [60.3446242, 36.6388088],
              [60.3453503, 36.6427331],
              [60.3428842, 36.6427507],
              [60.340633, 36.6430314],
              [60.3363809, 36.6446178],
              [60.3318929, 36.6500677],
              [60.3254705, 36.6589278],
              [60.319665, 36.6649908],
              [60.3110201, 36.6740091],
              [60.307137, 36.6798615],
              [60.3029674, 36.6864232],
              [60.2970904, 36.6969812],
              [60.2930759, 36.7056112],
              [60.2892675, 36.7134494],
              [60.2834851, 36.7231681],
              [60.2771118, 36.7327557],
              [60.2683127, 36.7425716],
              [60.266905, 36.7572095],
              [60.2591345, 36.7634717],
              [60.2512524, 36.7700098],
              [60.2443207, 36.7775324],
              [60.2441431, 36.7793412],
              [60.2451033, 36.7813382],
              [60.2438735, 36.78295],
              [60.2408015, 36.7847158],
              [60.2386659, 36.7859434],
              [60.2314636, 36.7917114],
              [60.2211102, 36.8043995],
              [60.2171489, 36.8126168],
              [60.2149881, 36.8203287],
              [60.2135339, 36.8217136],
              [60.2095864, 36.8229232],
              [60.2042829, 36.823054],
              [60.1970182, 36.8292718],
              [60.1915655, 36.8307899],
              [60.1868484, 36.8334484],
              [60.1695941, 36.8478373],
              [60.1631638, 36.8562322],
              [60.1575597, 36.8668635],
              [60.1549135, 36.8696993],
              [60.1522346, 36.8731511],
              [60.1461891, 36.8783853],
              [60.1449563, 36.8805282],
              [60.1441137, 36.8836215],
              [60.1424111, 36.8846519],
              [60.1387775, 36.8881394],
              [60.1354793, 36.8914479],
              [60.135088, 36.8930126],
              [60.1354234, 36.8955162],
              [60.133411, 36.8986903],
              [60.130334, 36.9008448],
              [60.126631, 36.9032363],
              [60.1246395, 36.9054923],
              [60.1242365, 36.9066676],
              [60.1210597, 36.9092267],
              [60.110818, 36.9169416],
              [60.1071392, 36.9211266],
              [60.1042036, 36.9244661],
              [60.0945536, 36.9366463],
              [60.0931558, 36.9395508],
              [60.0921523, 36.9427599],
              [60.0917618, 36.9449789],
              [60.0912829, 36.9470541],
              [60.0916322, 36.9505119],
              [60.0921511, 36.9530642],
              [60.0928121, 36.9561536],
              [60.0929169, 36.9585711],
              [60.0925446, 36.9623465],
              [60.0919155, 36.9651713],
              [60.0911409, 36.9677383],
              [60.0890045, 36.9717244],
              [60.0864484, 36.9756467],
              [60.0849842, 36.977755],
              [60.0836651, 36.9790754],
              [60.08123, 36.9818354],
              [60.0709697, 36.9909399],
              [60.063879, 36.9984967],
              [60.0540668, 37.0082608],
              [60.0430687, 37.0207635],
              [60.035179, 37.0241786],
              [60.0299988, 37.0267034],
              [60.0168244, 37.0356871],
              [60.0148876, 37.0365014],
              [60.0125008, 37.0371128],
              [60.0095619, 37.0374256],
              [60.0078139, 37.0382235],
              [60.0059104, 37.039928],
              [60.0052514, 37.0405962],
              [60.0042005, 37.0410369],
              [60.001528, 37.0419049],
              [59.9814679, 37.0471137],
              [59.9684021, 37.0433461],
              [59.9604636, 37.0430744],
              [59.9497378, 37.0426232],
              [59.9310662, 37.0423006],
              [59.9182476, 37.0454017],
              [59.9114948, 37.050266],
              [59.9083995, 37.0513353],
              [59.9064308, 37.0514011],
              [59.9038474, 37.051185],
              [59.9022899, 37.0513349],
              [59.9007439, 37.0511238],
              [59.8995292, 37.0514459],
              [59.8982356, 37.052847],
              [59.8954175, 37.0550961],
              [59.8944011, 37.0577507],
              [59.8935838, 37.0588629],
              [59.8916291, 37.0597415],
              [59.8908899, 37.0607001],
              [59.8873326, 37.0622853],
              [59.883267, 37.0650503],
              [59.8794787, 37.0674833],
              [59.8767991, 37.0680362],
              [59.8739809, 37.0676676],
              [59.8724484, 37.0678997],
              [59.8613623, 37.0766884],
              [59.8592115, 37.0780306],
              [59.8571281, 37.0799895],
              [59.8548216, 37.0814734],
              [59.8535567, 37.08272],
              [59.8499109, 37.0858658],
              [59.8487948, 37.0876465],
              [59.8481766, 37.0886765],
              [59.8465071, 37.0905814],
              [59.8438344, 37.0921042],
              [59.8411236, 37.0946929],
              [59.8394486, 37.096127],
              [59.8354096, 37.0991739],
              [59.832418, 37.1004384],
              [59.8314637, 37.1001746],
              [59.8306237, 37.0997178],
              [59.8296071, 37.0979039],
              [59.8286601, 37.0974723],
              [59.8272397, 37.0980144],
              [59.8252654, 37.0996124],
              [59.8226401, 37.1027054],
              [59.8186493, 37.1048632],
              [59.8149291, 37.1052409],
              [59.8121123, 37.1041901],
              [59.8041354, 37.1125597],
              [59.8030289, 37.1114189],
              [59.8010138, 37.1099253],
              [59.7996514, 37.1092288],
              [59.7990698, 37.1114189],
              [59.7975157, 37.1127131],
              [59.7949132, 37.1139153],
              [59.7915142, 37.1148278],
              [59.7859847, 37.1181225],
              [59.7820609, 37.1203614],
              [59.7718478, 37.1253495],
              [59.7660984, 37.1254574],
              [59.7622957, 37.1266865],
              [59.7616704, 37.1255177],
              [59.7596412, 37.1238458],
              [59.7589648, 37.1221739],
              [59.7592776, 37.1202818],
              [59.7573414, 37.1188839],
              [59.7565974, 37.1169961],
              [59.7556504, 37.1125192],
              [59.7552859, 37.108806],
              [59.7497657, 37.1087433],
              [59.7474053, 37.1077803],
              [59.745572, 37.1099301],
              [59.7424605, 37.110901],
              [59.7365758, 37.1121932],
              [59.7345466, 37.1129507],
              [59.7323821, 37.1147307],
              [59.7296088, 37.1182906],
              [59.7262268, 37.1229829],
              [59.7266573, 37.1265105],
              [59.7222879, 37.1274213],
              [59.7147825, 37.1303258],
              [59.7103431, 37.130764],
              [59.685696, 37.1385808],
              [59.6825014, 37.1401736],
              [59.6789985, 37.1412196],
              [59.6674261, 37.1411209],
              [59.6640453, 37.1426137],
              [59.6613444, 37.1430442],
              [59.6572788, 37.1424635],
              [59.6534908, 37.1422099],
              [59.6527993, 37.1397881],
              [59.651246, 37.1370743],
              [59.6502583, 37.1345214],
              [59.6497021, 37.1326989],
              [59.6475649, 37.1309156],
              [59.646701, 37.1292139],
              [59.6451256, 37.125162],
              [59.6452309, 37.1223821],
              [59.6464056, 37.1206207],
              [59.6433988, 37.1192367],
              [59.6416912, 37.1200653],
              [59.6401597, 37.1195151],
              [59.6373565, 37.1204462],
              [59.6265288, 37.1186537],
              [59.6262749, 37.1193262],
              [59.6256995, 37.1202866],
              [59.6247895, 37.1216738],
              [59.6237724, 37.1227622],
              [59.623197, 37.1229115],
              [59.6224074, 37.1226768],
              [59.6211495, 37.1216951],
              [59.6204034, 37.120519],
              [59.6191538, 37.1201592],
              [59.6174112, 37.1200725],
              [59.6157175, 37.1238402],
              [59.6140167, 37.1256944],
              [59.6125359, 37.1263847],
              [59.6114365, 37.12657],
              [59.6108878, 37.1269967],
              [59.6097102, 37.1281064],
              [59.6088135, 37.128021],
              [59.6080374, 37.1281704],
              [59.6074485, 37.1286292],
              [59.6067278, 37.1296851],
              [59.6056285, 37.1297708],
              [59.6045476, 37.1302568],
              [59.6037416, 37.1299735],
              [59.6030559, 37.1302568],
              [59.6025066, 37.1307191],
              [59.6016022, 37.1315623],
              [59.6002659, 37.1322496],
              [59.5992237, 37.13251],
              [59.5975026, 37.1314363],
              [59.5961769, 37.1310461],
              [59.5951532, 37.131027],
              [59.5930364, 37.1321618],
              [59.5908222, 37.1328698],
              [59.5889122, 37.133733],
              [59.5883282, 37.1336554],
              [59.5876226, 37.1331317],
              [59.5867102, 37.1331899],
              [59.5854915, 37.1337149],
              [59.5848778, 37.1342395],
              [59.584145, 37.1342223],
              [59.5834793, 37.1337363],
              [59.5829711, 37.1319941],
              [59.5817139, 37.1310498],
              [59.5790089, 37.1307151],
              [59.5759986, 37.1314745],
              [59.5716174, 37.1327635],
              [59.5677057, 37.1332209],
              [59.5647067, 37.1326803],
              [59.5622552, 37.131085],
              [59.5602812, 37.1311677],
              [59.5581639, 37.1317212],
              [59.5570879, 37.1325237],
              [59.556116, 37.1336582],
              [59.5539292, 37.1354016],
              [59.5525408, 37.136204],
              [59.5508763, 37.1381507],
              [59.550779, 37.1394598],
              [59.5511383, 37.1420407],
              [59.5511457, 37.142952],
              [59.5506238, 37.1431655],
              [59.5494907, 37.1432258],
              [59.5485086, 37.1436637],
              [59.5470734, 37.1448077],
              [59.5461978, 37.1473301],
              [59.5463417, 37.1536065],
              [59.544272, 37.1560376],
              [59.5439359, 37.158359],
              [59.5455792, 37.1609862],
              [59.5465596, 37.1628093],
              [59.5481936, 37.1647192],
              [59.5476268, 37.168267],
              [59.5483406, 37.1701781],
              [59.5511393, 37.1709475],
              [59.552507, 37.1720816],
              [59.5528684, 37.1746943],
              [59.5528575, 37.1755483],
              [59.5525266, 37.175807],
              [59.5522582, 37.1766327],
              [59.5522569, 37.1768473],
              [59.5517307, 37.1775677],
              [59.5505156, 37.1774792],
              [59.5455565, 37.1769477],
              [59.5420137, 37.1780435],
              [59.5402549, 37.1795328],
              [59.538527, 37.1820432],
              [59.5377502, 37.1852982],
              [59.5359146, 37.1856389],
              [59.5335544, 37.1856583],
              [59.5319729, 37.1865984],
              [59.5307076, 37.1871606],
              [59.5292721, 37.186046],
              [59.5284326, 37.1849895],
              [59.527873, 37.1851543],
              [59.5267217, 37.1862333],
              [59.5238974, 37.1883142],
              [59.5223049, 37.1903973],
              [59.5114811, 37.1945722],
              [59.5002582, 37.2000076],
              [59.4911444, 37.2071704],
              [59.4891344, 37.2077294],
              [59.487103, 37.2082922],
              [59.4850768, 37.209067],
              [59.4822158, 37.2106253],
              [59.4747378, 37.2147753],
              [59.4744067, 37.2186057],
              [59.4745722, 37.2188295],
              [59.4751844, 37.2190684],
              [59.4780181, 37.2186558],
              [59.4804499, 37.219074],
              [59.4828723, 37.2192086],
              [59.4841954, 37.2194418],
              [59.4860559, 37.2204773],
              [59.4858946, 37.2217568],
              [59.4871855, 37.2221908],
              [59.4883964, 37.2248586],
              [59.4901572, 37.2264937],
              [59.491833, 37.2300429],
              [59.4921102, 37.2321028],
              [59.4919372, 37.2336303],
              [59.4887952, 37.2403767],
              [59.4834259, 37.248484],
              [59.4778425, 37.2502896],
              [59.473786, 37.2522682],
              [59.4723566, 37.2525556],
              [59.4678103, 37.2578981],
              [59.4657491, 37.2607636],
              [59.465128, 37.2639747],
              [59.4644703, 37.2660859],
              [59.4510826, 37.2696096],
              [59.4500736, 37.2713549],
              [59.4505022, 37.2733042],
              [59.4519806, 37.276961],
              [59.452283, 37.2788556],
              [59.4491242, 37.2793576],
              [59.446008, 37.2802711],
              [59.4408339, 37.2824361],
              [59.4383034, 37.2844917],
              [59.437648, 37.284709],
              [59.436972, 37.2851741],
              [59.435967, 37.2869617],
              [59.4357706, 37.287311],
              [59.435208, 37.2879969],
              [59.434366, 37.2890146],
              [59.4336227, 37.2902334],
              [59.4328046, 37.2918685],
              [59.432551, 37.2925987],
              [59.4337272, 37.2936926],
              [59.4346122, 37.2949061],
              [59.4350897, 37.295938],
              [59.4351204, 37.2968466],
              [59.4351937, 37.3040829],
              [59.4334955, 37.3054859],
              [59.4308059, 37.307101],
              [59.4285527, 37.3077838],
              [59.4269585, 37.3082769],
              [59.4259456, 37.3078008],
              [59.4231493, 37.3059756],
              [59.4172066, 37.3080363],
              [59.4153861, 37.3074003],
              [59.4144324, 37.3068794],
              [59.4136303, 37.3066142],
              [59.4117681, 37.30749],
              [59.4096793, 37.3073225],
              [59.4083029, 37.3077733],
              [59.4050366, 37.310057],
              [59.3998972, 37.3151972],
              [59.3968977, 37.3173029],
              [59.3980986, 37.3186101],
              [59.399203, 37.319639],
              [59.4003109, 37.3237491],
              [59.3968741, 37.3263958],
              [59.3967691, 37.3278076],
              [59.392452, 37.332375],
              [59.3935153, 37.3377539],
              [59.39046, 37.3421842],
              [59.3894913, 37.3512753],
              [59.3903084, 37.3605354],
              [59.3878773, 37.3736975],
              [59.382786, 37.39112],
              [59.377877, 37.4075897],
              [59.3827188, 37.4209632],
              [59.3901516, 37.4239452],
              [59.3990807, 37.4271861],
              [59.4026247, 37.4294995],
              [59.4055379, 37.4317512],
              [59.4113447, 37.4357739],
              [59.4049358, 37.4415594],
              [59.4001112, 37.4455288],
              [59.3960773, 37.4489972],
              [59.3914769, 37.4469292],
              [59.3875995, 37.4453161],
              [59.384024, 37.4478708],
              [59.3814207, 37.4497464],
              [59.3858093, 37.4615346],
              [59.3889529, 37.4699921],
              [59.392131, 37.4791374],
              [59.3886849, 37.4848569],
              [59.3844199, 37.4921965],
              [59.3776157, 37.4977869],
              [59.3688302, 37.5050204],
              [59.3611089, 37.5114385],
              [59.3573493, 37.5198096],
              [59.3534794, 37.5284162],
              [59.3452644, 37.5292494],
              [59.3371858, 37.5300645],
              [59.329987, 37.5295151],
              [59.3193893, 37.5300269],
              [59.308131, 37.5246593],
              [59.2988826, 37.520227],
              [59.2928867, 37.5172623],
              [59.2883999, 37.5146316],
              [59.2840739, 37.51323],
              [59.2833763, 37.5123833],
              [59.2838802, 37.5116126],
              [59.2839538, 37.510912],
              [59.2837625, 37.5103515],
              [59.2833061, 37.5102231],
              [59.2820549, 37.5107252],
              [59.2816133, 37.5110521],
              [59.2811569, 37.5110988],
              [59.2804651, 37.5107719],
              [59.2796849, 37.5097677],
              [59.2789194, 37.5091137],
              [59.2777565, 37.5085883],
              [59.2761885, 37.5086415],
              [59.2738997, 37.5081912],
              [59.2724276, 37.5081679],
              [59.2714119, 37.5084832],
              [59.2698957, 37.5091488],
              [59.2686739, 37.5091488],
              [59.2680115, 37.5095341],
              [59.2675993, 37.5103398],
              [59.2669663, 37.5107018],
              [59.2660978, 37.5107952],
              [59.265877, 37.510515],
              [59.2660389, 37.5100246],
              [59.2656562, 37.5097677],
              [59.2647288, 37.5099311],
              [59.2634481, 37.5106084],
              [59.2620349, 37.5121497],
              [59.260681, 37.5120376],
              [59.2602655, 37.5120236],
              [59.2598769, 37.5123319],
              [59.2600064, 37.5128714],
              [59.2602331, 37.5137319],
              [59.2598283, 37.5144512],
              [59.2590511, 37.5146567],
              [59.2579824, 37.5145026],
              [59.2569467, 37.5140046],
              [59.256266, 37.5139503],
              [59.2559421, 37.5141943],
              [59.2556992, 37.5152347],
              [59.2548896, 37.5159411],
              [59.2542905, 37.5166603],
              [59.2539828, 37.5168401],
              [59.2536428, 37.5165833],
              [59.2528331, 37.5166988],
              [59.2519425, 37.5170713],
              [59.2510034, 37.5176621],
              [59.2497565, 37.5182272],
              [59.2488659, 37.5182144],
              [59.2470362, 37.5178804],
              [59.2469066, 37.5174695],
              [59.2469714, 37.5166988],
              [59.2466805, 37.5162614],
              [59.2463799, 37.5161725],
              [59.245757, 37.5166988],
              [59.2454169, 37.5173667],
              [59.2455465, 37.5177777],
              [59.246097, 37.5180089],
              [59.2463723, 37.5186382],
              [59.2461132, 37.519229],
              [59.2454655, 37.5196271],
              [59.2439434, 37.5198455],
              [59.2417574, 37.5201922],
              [59.240624, 37.5207885],
              [59.2396265, 37.520958],
              [59.2388962, 37.5206896],
              [59.2380057, 37.5198137],
              [59.2371329, 37.5194747],
              [59.236171, 37.5186553],
              [59.2357939, 37.5175191],
              [59.2358927, 37.5166],
              [59.235344, 37.5156022],
              [59.2340994, 37.5147424],
              [59.232614, 37.5145726],
              [59.2311762, 37.5146576],
              [59.2300243, 37.5140067],
              [59.2292497, 37.5120499],
              [59.2218124, 37.5154619],
              [59.2138749, 37.5203529],
              [59.2101439, 37.5226521],
              [59.2076254, 37.5264841],
              [59.2047827, 37.5281238],
              [59.2027225, 37.5285994],
              [59.2001879, 37.5321254],
              [59.1946714, 37.5351358],
              [59.1917995, 37.5362889],
              [59.1908416, 37.538484],
              [59.1897371, 37.5400353],
              [59.1882322, 37.5406987],
              [59.1863292, 37.5412613],
              [59.183853, 37.5413346],
              [59.1825742, 37.5403355],
              [59.1826373, 37.5388343],
              [59.1806178, 37.5382838],
              [59.1785667, 37.5392847],
              [59.174086, 37.5427625],
              [59.167074, 37.5491704],
              [59.154722, 37.571111],
              [59.147222, 37.5725],
              [59.140556, 37.574722],
              [59.133889, 37.576667],
              [59.128333, 37.579444],
              [59.122778, 37.581944],
              [59.118056, 37.585278],
              [59.113333, 37.588611],
              [59.108611, 37.591667],
              [59.105, 37.595556],
              [59.100278, 37.598889],
              [59.095556, 37.601944],
              [59.090833, 37.605278],
              [59.0898627, 37.6060057],
              [59.086389, 37.608611],
              [59.081667, 37.611944],
              [59.077778, 37.615556],
              [59.073333, 37.618889],
              [59.068611, 37.622778],
              [59.0663705, 37.625191],
              [59.065, 37.626667],
              [59.060278, 37.63],
              [59.052778, 37.631389],
              [59.045556, 37.630833],
              [59.038611, 37.63],
              [59.030833, 37.630278],
              [59.024167, 37.632222],
              [59.018333, 37.635],
              [59.012778, 37.6375],
              [59.008056, 37.640833],
              [59.003611, 37.644167],
              [58.997778, 37.646667],
              [58.992222, 37.649444],
              [58.986667, 37.652222],
              [58.980833, 37.654722],
              [58.974167, 37.656667],
              [58.9675, 37.658889],
              [58.961111, 37.660833],
              [58.954444, 37.663056],
              [58.947778, 37.665],
              [58.941111, 37.667222],
              [58.933611, 37.668611],
              [58.926111, 37.67],
              [58.918889, 37.669444],
              [58.9125, 37.668056],
              [58.905556, 37.6675],
              [58.898611, 37.666667],
              [58.890833, 37.666944],
              [58.883889, 37.6675],
              [58.876389, 37.669167],
              [58.870556, 37.671667],
              [58.865, 37.674444],
              [58.860278, 37.6775],
              [58.855556, 37.680833],
              [58.851944, 37.684722],
              [58.848056, 37.688611],
              [58.843333, 37.691667],
              [58.839722, 37.695556],
              [58.836111, 37.699444],
              [58.830278, 37.701944],
              [58.822778, 37.703611],
              [58.815556, 37.702778],
              [58.813056, 37.6975],
              [58.813889, 37.691944],
              [58.814722, 37.686389],
              [58.814722, 37.680278],
              [58.812778, 37.674167],
              [58.808611, 37.670556],
              [58.804444, 37.666944],
              [58.798889, 37.664722],
              [58.793333, 37.6625],
              [58.786389, 37.661667],
              [58.778611, 37.661944],
              [58.770833, 37.663333],
              [58.763333, 37.664722],
              [58.755833, 37.666389],
              [58.748889, 37.666944],
              [58.743333, 37.664722],
              [58.738611, 37.661944],
              [58.735, 37.6575],
              [58.731667, 37.653056],
              [58.726111, 37.650833],
              [58.72, 37.649444],
              [58.712778, 37.648611],
              [58.704444, 37.649444],
              [58.696389, 37.649722],
              [58.688056, 37.650556],
              [58.680278, 37.651944],
              [58.672778, 37.653611],
              [58.665278, 37.655],
              [58.659444, 37.6575],
              [58.652778, 37.659722],
              [58.646389, 37.661667],
              [58.640556, 37.664444],
              [58.635, 37.666944],
              [58.629167, 37.669722],
              [58.623611, 37.672222],
              [58.618056, 37.675],
              [58.613333, 37.678056],
              [58.608611, 37.681389],
              [58.603889, 37.685278],
              [58.5974623, 37.6898565],
              [58.5964395, 37.6892126],
              [58.5959665, 37.6887156],
              [58.5956028, 37.6887759],
              [58.5923108, 37.6901517],
              [58.5867908, 37.6933769],
              [58.5821818, 37.6949411],
              [58.5761695, 37.6965679],
              [58.570377, 37.6985383],
              [58.5662713, 37.6998946],
              [58.5566505, 37.7055032],
              [58.55, 37.705833],
              [58.544444, 37.703611],
              [58.539444, 37.700833],
              [58.534722, 37.697778],
              [58.531389, 37.693333],
              [58.527222, 37.689722],
              [58.524722, 37.684444],
              [58.522222, 37.679167],
              [58.518889, 37.674722],
              [58.516111, 37.669444],
              [58.513611, 37.664167],
              [58.510278, 37.659722],
              [58.506944, 37.655278],
              [58.502778, 37.651389],
              [58.498056, 37.647778],
              [58.4925, 37.645556],
              [58.4896025, 37.6443967],
              [58.486944, 37.643333],
              [58.480556, 37.641944],
              [58.474167, 37.640556],
              [58.467222, 37.64],
              [58.460278, 37.640556],
              [58.451667, 37.641389],
              [58.4406358, 37.6383426],
              [58.4369193, 37.6403328],
              [58.432246, 37.6414589],
              [58.426976, 37.6411584],
              [58.4221653, 37.6406504],
              [58.4179744, 37.6392897],
              [58.4118479, 37.633934],
              [58.4076392, 37.6297397],
              [58.4072962, 37.6296532],
              [58.4062459, 37.6294737],
              [58.4056656, 37.6293745],
              [58.4052221, 37.6292612],
              [58.404247, 37.6291591],
              [58.4032943, 37.6289658],
              [58.4016235, 37.62849],
              [58.400195, 37.6279969],
              [58.3998687, 37.6279806],
              [58.394565, 37.6288596],
              [58.3921227, 37.6289025],
              [58.3918038, 37.6286715],
              [58.3903027, 37.6272769],
              [58.3901323, 37.6272011],
              [58.3887507, 37.6269846],
              [58.3884341, 37.6269846],
              [58.386803, 37.6273721],
              [58.3857285, 37.6277748],
              [58.3845824, 37.6283563],
              [58.3838397, 37.6289559],
              [58.3821193, 37.6306773],
              [58.3815693, 37.6316008],
              [58.3815824, 37.6322591],
              [58.3816386, 37.6328399],
              [58.3811408, 37.633285],
              [58.3806346, 37.6337115],
              [58.3807929, 37.6350232],
              [58.381023, 37.6355997],
              [58.3809882, 37.6357968],
              [58.3808705, 37.6360024],
              [58.3806671, 37.6364285],
              [58.3805586, 37.6365004],
              [58.3804387, 37.6365163],
              [58.3779896, 37.6363297],
              [58.3768681, 37.6365523],
              [58.3759206, 37.6366116],
              [58.3752487, 37.6365464],
              [58.3739587, 37.6359185],
              [58.3722591, 37.6363467],
              [58.3715762, 37.6364015],
              [58.3697024, 37.6363476],
              [58.3683798, 37.6361797],
              [58.3669427, 37.6367737],
              [58.3666521, 37.6369806],
              [58.3663087, 37.6372465],
              [58.36192, 37.6436415],
              [58.36369, 37.648621],
              [58.3583903, 37.6539636],
              [58.3581775, 37.6595492],
              [58.3596512, 37.6611066],
              [58.351667, 37.661944],
              [58.343889, 37.663333],
              [58.336111, 37.663333],
              [58.328333, 37.663333],
              [58.321389, 37.662778],
              [58.314167, 37.662222],
              [58.3112048, 37.662222],
              [58.2989117, 37.6547113],
              [58.299905, 37.6525298],
              [58.2979048, 37.6373714],
              [58.3142488, 37.5874988],
              [58.3207883, 37.5672602],
              [58.326206, 37.5390237],
              [58.3386524, 37.4999863],
              [58.3379169, 37.4549378],
              [58.3494197, 37.4432959],
              [58.3679434, 37.4292921],
              [58.3682234, 37.4245692],
              [58.3676632, 37.4212407],
              [58.3679433, 37.4170664],
              [58.3638601, 37.4015364],
              [58.35886, 37.39487],
              [58.3405666, 37.3859172],
              [58.3366803, 37.3820307],
              [58.3179871, 37.3677918],
              [58.3163206, 37.3619622],
              [58.3160406, 37.3608556],
              [58.3119206, 37.3574911],
              [58.3096638, 37.3519522],
              [58.3092495, 37.3431405],
              [58.3235402, 37.3325165],
              [58.3298302, 37.327215],
              [58.360372, 37.3104508],
              [58.3690499, 37.2965152],
              [58.3698832, 37.2962452],
              [58.3782328, 37.2899205],
              [58.4032325, 37.2757505],
              [58.4065658, 37.2735281],
              [58.4143257, 37.2588648],
              [58.4151594, 37.2588647],
              [58.4154325, 37.2585858],
              [58.4191121, 37.2485478],
              [58.4177258, 37.2443819],
              [58.4148067, 37.2201301],
              [58.4019899, 37.213891],
              [58.3939745, 37.2138704],
              [58.3899517, 37.2138017],
              [58.3764828, 37.2167736],
              [58.3701358, 37.2181803],
              [58.3633038, 37.2196158],
              [58.3519337, 37.2216718],
              [58.3409412, 37.2224918],
              [58.3350054, 37.2179411],
              [58.3313206, 37.2141134],
              [58.3268552, 37.2130485],
              [58.3193769, 37.2126384],
              [58.3114128, 37.2101242],
              [58.3005599, 37.2020466],
              [58.3001659, 37.198409],
              [58.308072, 37.2005908],
              [58.3099419, 37.1989605],
              [58.3079457, 37.1961985],
              [58.3040066, 37.193598],
              [58.3077558, 37.1832852],
              [58.3099874, 37.1775119],
              [58.3139811, 37.1689323],
              [58.2962668, 37.1792603],
              [58.2917436, 37.1818301],
              [58.2845425, 37.1864574],
              [58.2812687, 37.1877413],
              [58.2756895, 37.1896338],
              [58.2733726, 37.1880488],
              [58.2610988, 37.183946],
              [58.2526445, 37.1833306],
              [58.2484388, 37.1839802],
              [58.2409636, 37.1818043],
              [58.2385808, 37.1790635],
              [58.2384353, 37.1757051],
              [58.2395756, 37.172165],
              [58.2479289, 37.167732],
              [58.261399, 37.1668831],
              [58.2665062, 37.1657202],
              [58.2703685, 37.1622319],
              [58.270626, 37.1592222],
              [58.26848, 37.1551864],
              [58.2636737, 37.1522447],
              [58.2597255, 37.1519026],
              [58.2552621, 37.1518344],
              [58.2455631, 37.1522449],
              [58.2341476, 37.1529974],
              [58.2135671, 37.1547662],
              [58.2080379, 37.1519387],
              [58.1984725, 37.1403551],
              [58.1970691, 37.137672],
              [58.1927773, 37.1280923],
              [58.1841477, 37.1121496],
              [58.1733704, 37.0968941],
              [58.1819782, 37.0907336],
              [58.1975814, 37.0848411],
              [58.2118877, 37.0795245],
              [58.2282808, 37.0759122],
              [58.2323491, 37.0680569],
              [58.2397744, 37.0581835],
              [58.2495559, 37.0488613],
              [58.2512799, 37.0474909],
              [58.2544429, 37.0426138],
              [58.2585023, 37.0363777],
              [58.2606529, 37.0331495],
              [58.2691814, 37.0306166],
              [58.2765811, 37.028476],
              [58.2859412, 37.0260814],
              [58.3023073, 37.0218778],
              [58.3128693, 37.0192252],
              [58.3230578, 37.019693],
              [58.333928, 37.0186814],
              [58.3448216, 37.0137642],
              [58.351308, 37.0094025],
              [58.3555755, 37.0051087],
              [58.357726, 36.9999808],
              [58.3581942, 36.9971428],
              [58.3559309, 36.9905253],
              [58.3544188, 36.9856145],
              [58.3524176, 36.9766817],
              [58.3443971, 36.9631784],
              [58.3407249, 36.9576562],
              [58.3360185, 36.9541903],
              [58.3274959, 36.9476302],
              [58.3227167, 36.9445605],
              [58.3131959, 36.939745],
              [58.3019936, 36.9341468],
              [58.2978115, 36.9305869],
              [58.2909356, 36.9262502],
              [58.2797298, 36.9198457],
              [58.2763522, 36.9179427],
              [58.2721931, 36.9156663],
              [58.2626539, 36.9106987],
              [58.2475246, 36.8965927],
              [58.2382216, 36.8893574],
              [58.2301291, 36.8844487],
              [58.2261532, 36.8815633],
              [58.2226129, 36.8795775],
              [58.2195107, 36.8797019],
              [58.2178202, 36.8801677],
              [58.2110353, 36.8790485],
              [58.2049671, 36.8922868],
              [58.1939046, 36.8894989],
              [58.166099, 36.8826335],
              [58.1543878, 36.8782624],
              [58.142399, 36.8740469],
              [58.1303191, 36.8715383],
              [58.1099528, 36.8669799],
              [58.0925396, 36.8628166],
              [58.0815189, 36.8601427],
              [58.0761505, 36.8588681],
              [58.0781281, 36.8542795],
              [58.0819273, 36.8455426],
              [58.0850172, 36.8392403],
              [58.0898663, 36.8279743],
              [58.0943261, 36.8176761],
              [58.0969856, 36.8111915],
              [58.104182, 36.8071776],
              [58.1068826, 36.8057628],
              [58.1086452, 36.8045164],
              [58.1216214, 36.7893409],
              [58.1273054, 36.7829016],
              [58.128386, 36.7744515],
              [58.1282574, 36.7683822],
              [58.1246573, 36.7664635],
              [58.1079766, 36.7584848],
              [58.1006813, 36.7532927],
              [58.0957442, 36.7481638],
              [58.0995655, 36.7407756],
              [58.1010675, 36.7371302],
              [58.095102, 36.7305269],
              [58.0868625, 36.723785],
              [58.0817127, 36.7177307],
              [58.0798207, 36.716483],
              [58.0872917, 36.7121921],
              [58.0914545, 36.7102655],
              [58.0951775, 36.7094058],
              [58.0938379, 36.7032503],
              [58.094115, 36.6976384],
              [58.0819273, 36.6907904],
              [58.075962, 36.6887944],
              [58.0761337, 36.687177],
              [58.0796095, 36.6843552],
              [58.083558, 36.6816705],
              [58.0875492, 36.6812231],
              [58.0884504, 36.678573],
              [58.0863771, 36.6753471],
              [58.081157, 36.6724085],
              [58.0794382, 36.6694516],
              [58.0750608, 36.6637373],
              [58.0709343, 36.6609173],
              [58.0686664, 36.6543732],
              [58.066083, 36.6497783],
              [58.0658776, 36.6459976],
              [58.0709838, 36.6414269],
              [58.0750178, 36.6395674],
              [58.0765628, 36.6363993],
              [58.0812835, 36.6330933],
              [58.0839442, 36.6299249],
              [58.083433, 36.6280121],
              [58.0787086, 36.6228988],
              [58.0727004, 36.6181456],
              [58.068881, 36.6116425],
              [58.0637891, 36.6088154],
              [58.0376651, 36.6010129],
              [58.0190041, 36.5951521],
              [57.9996703, 36.5814981],
              [57.9884147, 36.5728369],
              [57.9851532, 36.5712515],
              [57.9739523, 36.5695282],
              [57.9699823, 36.5690811],
              [57.9638671, 36.5680462],
              [57.951538, 36.568367],
              [57.943698, 36.5685225],
              [57.9339201, 36.5696269],
              [57.930189, 36.5704957],
              [57.9238669, 36.5717998],
              [57.9170865, 36.5752569],
              [57.909708, 36.5772139],
              [57.9048156, 36.5783512],
              [57.8978204, 36.5833137],
              [57.8931573, 36.5871648],
              [57.8789634, 36.5848372],
              [57.8714637, 36.5865036],
              [57.8695239, 36.5870531],
              [57.8684105, 36.5870531],
              [57.8215709, 36.6161078],
              [57.7773976, 36.6302737],
              [57.7521249, 36.6405581],
              [57.7457318, 36.6433319],
              [57.7182321, 36.6574973],
              [57.715732, 36.6583348],
              [57.7079521, 36.6619458],
              [57.7018387, 36.6636118],
              [57.663742, 36.6785129],
              [57.6585061, 36.6805595],
              [57.6396198, 36.6913835],
              [57.6158232, 36.7020259],
              [57.6119368, 36.7056372],
              [57.6069366, 36.7089693],
              [57.5808837, 36.7198556],
              [57.5470742, 36.7433823],
              [57.5454077, 36.7436524],
              [57.5367942, 36.7470404],
              [57.5356876, 36.7472633],
              [57.5290243, 36.7541792],
              [57.5267976, 36.7544584],
              [57.5173877, 36.758611],
              [57.5101679, 36.7613933],
              [57.5096078, 36.7619515],
              [57.5062745, 36.7630591],
              [57.5057214, 36.7636172],
              [57.4993345, 36.7658323],
              [57.4921082, 36.7683355],
              [57.4898883, 36.7691637],
              [57.4548887, 36.778618],
              [57.4471085, 36.7800045],
              [57.4448888, 36.7800045],
              [57.4437751, 36.7802837],
              [57.4418286, 36.7802836],
              [57.4057157, 36.7861182],
              [57.4034958, 36.7869465],
              [57.4018293, 36.7872256],
              [57.3738159, 36.7920128],
              [57.371876, 36.7931203],
              [57.2967371, 36.8092674],
              [57.2956304, 36.8095465],
              [57.2936838, 36.8095465],
              [57.2928507, 36.8098256],
              [57.2432626, 36.820776],
              [57.2428937, 36.8209621],
              [57.2415037, 36.8209619],
              [57.2370604, 36.8220696],
              [57.2317805, 36.822907],
              [57.2068402, 36.8241268],
              [57.1959381, 36.8347662],
              [57.1945479, 36.8347662],
              [57.1931614, 36.8350452],
              [57.1903815, 36.8350453],
              [57.1895481, 36.8353243],
              [57.1878815, 36.8353243],
              [57.1870483, 36.8356035],
              [57.1851049, 36.8356034],
              [57.1820481, 36.8361528],
              [57.1784383, 36.8361528],
              [57.175105, 36.836711],
              [57.1731583, 36.836711],
              [57.1717682, 36.8369901],
              [57.169825, 36.83699],
              [57.168435, 36.8372692],
              [57.1662151, 36.8372691],
              [57.1648251, 36.8375483],
              [57.1512523, 36.8361785],
              [57.1468735, 36.8374493],
              [57.144649, 36.8371789],
              [57.1392165, 36.837207],
              [57.138651, 36.8373205],
              [57.137198, 36.8371489],
              [57.1363646, 36.8374279],
              [57.1336487, 36.8375737],
              [57.1297621, 36.8386812],
              [57.1222621, 36.8414633],
              [57.1178155, 36.840931],
              [57.1167056, 36.8414892],
              [57.1033722, 36.8456581],
              [57.102259, 36.8456581],
              [57.0907807, 36.8476159],
              [57.0597927, 36.8536183],
              [57.0589594, 36.8541766],
              [57.041683, 36.8565555],
              [57.0405698, 36.8565556],
              [57.0380698, 36.8571139],
              [57.0355698, 36.8571138],
              [57.0347364, 36.8573931],
              [57.03196, 36.857393],
              [57.0311265, 36.8571138],
              [57.0252932, 36.8571139],
              [57.02446, 36.8568348],
              [57.0230699, 36.8568348],
              [57.0222367, 36.8565556],
              [57.0165667, 36.8601225],
              [57.0157335, 36.8601225],
              [57.0137868, 36.8595642],
              [56.9884869, 36.8678112],
              [56.9582745, 36.8711071],
              [56.9428566, 36.8820376],
              [56.9405856, 36.8814796],
              [56.9329552, 36.8853667],
              [56.9320838, 36.8851475],
              [56.9243377, 36.8885832],
              [56.9132714, 36.8906472],
              [56.8889685, 36.8823746],
              [56.8822986, 36.8809887],
              [56.8519224, 36.858965],
              [56.8385226, 36.8537116],
              [56.8316393, 36.8512392],
              [56.8269527, 36.8473761],
              [56.8088161, 36.8396154],
              [56.8023929, 36.829431],
              [56.8004495, 36.829152],
              [56.7965596, 36.8280447],
              [56.7954496, 36.8280446],
              [56.7903629, 36.823918],
              [56.7892531, 36.823639],
              [56.7881162, 36.8194794],
              [56.7875595, 36.8192003],
              [56.7856161, 36.8192003],
              [56.7850594, 36.8189212],
              [56.7792993, 36.816677],
              [56.7773526, 36.8161187],
              [56.7745761, 36.8147322],
              [56.7731861, 36.8144531],
              [56.7634629, 36.8105636],
              [56.7242966, 36.8000026],
              [56.72263, 36.7991742],
              [56.7212399, 36.7988951],
              [56.7156833, 36.796113],
              [56.7129067, 36.7952847],
              [56.6999243, 36.7782176],
              [56.6921995, 36.7670798],
              [56.6752717, 36.7591736],
              [56.6733285, 36.7583451],
              [56.6551855, 36.7514124],
              [56.6518522, 36.7489177],
              [56.6142642, 36.7227284],
              [56.6125975, 36.7210624],
              [56.6100974, 36.7196755],
              [56.6073208, 36.7174511],
              [56.5991259, 36.7106298],
              [56.5992089, 36.6950964],
              [56.6104885, 36.6849403],
              [56.6251358, 36.6806655],
              [56.6410587, 36.6759784],
              [56.6483228, 36.6736649],
              [56.6510994, 36.6724587],
              [56.6935633, 36.6625424],
              [56.6949532, 36.6625424],
              [56.69523, 36.6628216],
              [56.6980066, 36.6636506],
              [56.7043965, 36.6644883],
              [56.7060632, 36.6639297],
              [56.7134664, 36.6688764],
              [56.717913, 36.6688763],
              [56.7187464, 36.6691556],
              [56.7245796, 36.6691556],
              [56.7254129, 36.6694349],
              [56.7378928, 36.675793],
              [56.7442163, 36.6796582],
              [56.7453262, 36.6796582],
              [56.7503262, 36.6802167],
              [56.7531028, 36.6802167],
              [56.7542162, 36.6804959],
              [56.7572729, 36.6804959],
              [56.758106, 36.6802167],
              [56.7594928, 36.6802167],
              [56.7686151, 36.6828182],
              [56.7746649, 36.6759816],
              [56.774665, 36.6754232],
              [56.7733107, 36.6735223],
              [56.769825, 36.6670998],
              [56.7639526, 36.6639856],
              [56.7560184, 36.6536822],
              [56.7554617, 36.652007],
              [56.7554619, 36.6517279],
              [56.7557418, 36.6497916],
              [56.7568519, 36.6450633],
              [56.752872, 36.6062699],
              [56.7556487, 36.5962619],
              [56.7692617, 36.5887672],
              [56.7700952, 36.5887672],
              [56.7714853, 36.5882088],
              [56.7723185, 36.5882088],
              [56.7731519, 36.5879295],
              [56.7742619, 36.5879295],
              [56.7756517, 36.5876502],
              [56.7792618, 36.5870917],
              [56.7800951, 36.5868124],
              [56.8187677, 36.5898147],
              [56.8449108, 36.5822785],
              [56.8521339, 36.5772796],
              [56.8643572, 36.5606075],
              [56.8646337, 36.5594996],
              [56.8651905, 36.5578243],
              [56.8682436, 36.5492223],
              [56.8696337, 36.5431063],
              [56.8688172, 36.5370548],
              [56.8684678, 36.5358365],
              [56.8681913, 36.5344405],
              [56.8640245, 36.5208313],
              [56.862358, 36.5186066],
              [56.8623579, 36.5183274],
              [56.860968, 36.5161117],
              [56.8579113, 36.5111039],
              [56.8568013, 36.509996],
              [56.8562447, 36.5088882],
              [56.8167982, 36.4619424],
              [56.8023551, 36.4474943],
              [56.8004083, 36.4455487],
              [56.7853515, 36.4244048],
              [56.7631286, 36.4130196],
              [56.7368284, 36.3872493],
              [56.7359952, 36.3866908],
              [56.7348852, 36.3858619],
              [56.7321053, 36.3822493],
              [56.7245726, 36.345269],
              [56.7276292, 36.341107],
              [56.7312391, 36.3341612],
              [56.7320724, 36.3244404],
              [56.7317958, 36.3188819],
              [56.7315157, 36.3183233],
              [56.7320724, 36.31499],
              [56.7329289, 36.3134953],
              [56.7331824, 36.313053],
              [56.7299645, 36.2985255],
              [56.7365324, 36.2729126],
              [56.7462557, 36.2679012],
              [56.7551454, 36.2606814],
              [56.7609788, 36.2462326],
              [56.7626454, 36.2417799],
              [56.7626454, 36.2415004],
              [56.7651453, 36.2367772],
              [56.7733182, 36.1830371],
              [56.7590231, 36.1570581],
              [56.7588859, 36.1565084],
              [56.7586093, 36.1559498],
              [56.7581767, 36.1535431],
              [56.7578116, 36.1524475],
              [56.757535, 36.1521773],
              [56.7533683, 36.1394024],
              [56.7528116, 36.138844],
              [56.7528116, 36.1382944],
              [56.750104, 36.1318971],
              [56.7482471, 36.1137488],
              [56.7488449, 36.1066758],
              [56.747847, 36.0896383],
              [56.7472255, 36.0744876],
              [56.7469299, 36.0698285],
              [56.7463732, 36.06283],
              [56.7467913, 36.0505353],
              [56.7465147, 36.0460841],
              [56.7462347, 36.0444261],
              [56.7451247, 36.0335862],
              [56.744848, 36.0330366],
              [56.7451246, 36.0319193],
              [56.7448481, 36.0310903],
              [56.7451246, 36.0288646],
              [56.7451246, 36.0247016],
              [56.7442912, 36.0169253],
              [56.7440146, 36.0138706],
              [56.7437346, 36.0127622],
              [56.743458, 36.0116538],
              [56.7596274, 35.9830387],
              [56.7593508, 35.982489],
              [56.7599074, 35.9752603],
              [56.7593507, 35.9697082],
              [56.7587941, 35.9655351],
              [56.7564574, 35.9616502],
              [56.7561775, 35.9608119],
              [56.7578475, 35.9447056],
              [56.7575674, 35.9438673],
              [56.7599317, 35.9243064],
              [56.7579801, 35.9083778],
              [56.7573541, 35.8987346],
              [56.7573451, 35.884252],
              [56.7538101, 35.8533756],
              [56.7652614, 35.8463558],
              [56.7839467, 35.8348289],
              [56.818493, 35.8126847],
              [56.8399318, 35.7978493],
              [56.8551921, 35.7876017],
              [56.8655593, 35.7785791],
              [56.8983079, 35.7528377],
              [56.9086911, 35.7432314],
              [56.9113254, 35.7360625],
              [56.9120853, 35.7311819],
              [56.9191061, 35.7215946],
              [56.930251, 35.7146196],
              [56.9358909, 35.7121805],
              [56.9426464, 35.7050006],
              [56.9463974, 35.6984029],
              [56.9503783, 35.6922976],
              [56.9582747, 35.6639213],
              [56.9584464, 35.657924],
              [56.9627379, 35.6404178],
              [56.9654845, 35.6335118],
              [56.9709777, 35.6258378],
              [56.974211, 35.6168686],
              [56.9879574, 35.6036103],
              [56.9855689, 35.5973681],
              [56.9856547, 35.5948555],
              [56.9828223, 35.5900396],
              [56.9853973, 35.585014],
              [56.9911933, 35.5815763],
              [56.9974501, 35.5776884],
              [57.0105396, 35.5741175],
              [57.0172344, 35.5710454],
              [57.0245719, 35.5692997],
              [57.0310877, 35.5679775],
              [57.0322608, 35.5644896],
              [57.0318317, 35.5610684],
              [57.0365523, 35.5579263],
              [57.0398252, 35.5503299],
              [57.0429951, 35.5472653],
              [57.0477103, 35.545217],
              [57.0499142, 35.5423558],
              [57.0509678, 35.5378598],
              [57.0513969, 35.5345068],
              [57.0491429, 35.5304295],
              [57.0484134, 35.5292768],
              [57.0463399, 35.5281844],
              [57.0441224, 35.526751],
              [57.0405435, 35.5259397],
              [57.0394706, 35.520945],
              [57.0371961, 35.512352],
              [57.0340633, 35.5079853],
              [57.030342, 35.500141],
              [57.0235732, 35.4957848],
              [57.0024312, 35.4747289],
              [57.0018744, 35.4727813],
              [56.995418, 35.4663598],
              [56.9945848, 35.4605257],
              [56.9943047, 35.4583075],
              [56.9940279, 35.4558096],
              [56.9841383, 35.4415465],
              [56.9813585, 35.437939],
              [56.9813584, 35.4376594],
              [56.9816383, 35.4290465],
              [56.9869149, 35.4193241],
              [56.9906272, 35.4168259],
              [57.009391, 35.3953914],
              [57.0096676, 35.3940024],
              [57.0102242, 35.3856591],
              [57.0195842, 35.3641364],
              [57.0343073, 35.3394088],
              [57.0354173, 35.3382996],
              [57.0359739, 35.3380199],
              [57.036254, 35.3374608],
              [57.0523637, 35.3210836],
              [57.0520871, 35.3149691],
              [57.0501403, 35.3071863],
              [57.0393071, 35.2810776],
              [57.0318073, 35.2688572],
              [57.0315306, 35.2677479],
              [57.0312505, 35.2674683],
              [57.010694, 35.2235732],
              [57.0002296, 35.2152486],
              [56.9906943, 35.2119116],
              [56.9868043, 35.2108022],
              [56.9837511, 35.2108022],
              [56.9831945, 35.2105226],
              [56.980971, 35.2105226],
              [56.9806945, 35.2108021],
              [56.9751379, 35.2116319],
              [56.967638, 35.2141303],
              [56.966528, 35.2141303],
              [56.9656947, 35.2144099],
              [56.9523581, 35.217747],
              [56.9515247, 35.2180175],
              [56.9473582, 35.219686],
              [56.9465248, 35.2196861],
              [56.9426381, 35.2207954],
              [56.9415249, 35.2207954],
              [56.9409682, 35.221075],
              [56.9370816, 35.221075],
              [56.9368015, 35.2207954],
              [56.9354149, 35.2207954],
              [56.9348583, 35.2205158],
              [56.9165251, 35.2133005],
              [56.9109685, 35.2091336],
              [56.9098586, 35.2088541],
              [56.9093019, 35.2083039],
              [56.9081919, 35.2080153],
              [56.9076353, 35.2074651],
              [56.8951354, 35.2038574],
              [56.8940221, 35.2038575],
              [56.8934688, 35.2035778],
              [56.8918022, 35.2035778],
              [56.8912455, 35.2032983],
              [56.8904122, 35.2032982],
              [56.8898554, 35.2030186],
              [56.8876357, 35.2030187],
              [56.8870788, 35.2027391],
              [56.8837455, 35.2027391],
              [56.8826322, 35.2030186],
              [56.8765224, 35.2030187],
              [56.8751322, 35.202739],
              [56.8740223, 35.2030187],
              [56.8695792, 35.2030187],
              [56.8684657, 35.2032983],
              [56.8662458, 35.2032983],
              [56.865409, 35.2035779],
              [56.8629091, 35.2035779],
              [56.8623558, 35.2032983],
              [56.8612425, 35.2032983],
              [56.8573559, 35.2024685],
              [56.8556893, 35.2024685],
              [56.8437427, 35.1977425],
              [56.8429093, 35.1969036],
              [56.8306861, 35.1882992],
              [56.828743, 35.1863511],
              [56.828743, 35.1860714],
              [56.8270763, 35.1846825],
              [56.8112432, 35.1674643],
              [56.7823499, 35.1535742],
              [56.77513, 35.1482977],
              [56.7737402, 35.1469087],
              [56.7608636, 35.126087],
              [56.7133647, 35.1092306],
              [56.6986415, 35.0953413],
              [56.6972514, 35.0942319],
              [56.6969749, 35.0936727],
              [56.6944748, 35.0920132],
              [56.6908783, 35.0872661],
              [56.6869549, 35.0822105],
              [56.6772248, 35.0610587],
              [56.6758348, 35.0610586],
              [56.6750014, 35.060779],
              [56.6733348, 35.060779],
              [56.6725014, 35.0604994],
              [56.6705582, 35.0604994],
              [56.6700016, 35.0602197],
              [56.6672249, 35.0602197],
              [56.6666683, 35.0604993],
              [56.6647249, 35.0604994],
              [56.6615556, 35.0628548],
              [56.6598891, 35.0631254],
              [56.6582224, 35.0636936],
              [56.6579014, 35.0666221],
              [56.6531782, 35.0666221],
              [56.6520682, 35.0669018],
              [56.641235, 35.0669017],
              [56.6401217, 35.0666221],
              [56.6265119, 35.0649624],
              [56.6253985, 35.0644031],
              [56.6240117, 35.0641325],
              [56.5948422, 35.0555182],
              [56.5937322, 35.0555181],
              [56.5915089, 35.0549589],
              [56.5895655, 35.0549589],
              [56.5870657, 35.0544087],
              [56.585119, 35.0544087],
              [56.5840089, 35.0541291],
              [56.5820622, 35.0541291],
              [56.5815089, 35.0538494],
              [56.580119, 35.0538494],
              [56.5723425, 35.0530195],
              [56.5717858, 35.0530195],
              [56.5703958, 35.0530195],
              [56.5687292, 35.0527399],
              [56.5645624, 35.0527399],
              [56.5637292, 35.0524603],
              [56.5620626, 35.0524603],
              [56.5367828, 35.0477427],
              [56.5345628, 35.0469038],
              [56.5328961, 35.0466241],
              [56.5190065, 35.0421861],
              [56.5178931, 35.0413472],
              [56.5170597, 35.0413472],
              [56.4884468, 35.0285743],
              [56.4815034, 35.0221877],
              [56.4537237, 34.9999609],
              [56.4428905, 34.9796821],
              [56.3944879, 34.9442453],
              [56.3944879, 34.943695],
              [56.3939312, 34.9431357],
              [56.3903212, 34.9375884],
              [56.3900413, 34.9367495],
              [56.3883746, 34.9345305],
              [56.3490919, 34.901935],
              [56.3490918, 34.9016555],
              [56.3488151, 34.9013759],
              [56.348535, 34.9005461],
              [56.3413118, 34.8899939],
              [56.3338118, 34.8836082],
              [56.3335353, 34.8833287],
              [56.3324253, 34.8816692],
              [56.3279786, 34.8775023],
              [56.3125957, 34.8659688],
              [56.2579799, 34.8230391],
              [56.2554798, 34.8199904],
              [56.23159, 34.7858323],
              [56.2307568, 34.7852731],
              [56.2237801, 34.7482579],
              [56.2235036, 34.7471391],
              [56.221837, 34.7446398],
              [56.226223, 34.7260448],
              [56.2237229, 34.7229952],
              [56.2284362, 34.7118984],
              [56.2279736, 34.7104172]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 537658,
        "tags": {
          "ISO3166-2": "IR-29",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "خراسان جنوبی",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q171551"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [55.4049914, 33.3824666],
              [55.416872, 33.3758326],
              [55.4342527, 33.3521776],
              [55.4455764, 33.3370295],
              [55.467747, 33.306446],
              [55.4849609, 33.2787612],
              [55.5046955, 33.2426785],
              [55.5168404, 33.2234986],
              [55.5260851, 33.2082013],
              [55.5619681, 33.150082],
              [55.5824758, 33.1159329],
              [55.6060428, 33.0782032],
              [55.6062022, 33.0779479],
              [55.6266717, 33.0440673],
              [55.6370818, 33.0273727],
              [55.6455683, 33.0132702],
              [55.6510998, 33.0038021],
              [55.6574364, 32.9939165],
              [55.6692694, 32.9741081],
              [55.6847125, 32.9535863],
              [55.701419, 32.9313493],
              [55.7151986, 32.9141661],
              [55.7274084, 32.8981241],
              [55.7392913, 32.8823339],
              [55.7489844, 32.8697151],
              [55.7823031, 32.8151888],
              [55.806746, 32.7885162],
              [55.8075795, 32.7874056],
              [55.8228593, 32.7740693],
              [55.8278591, 32.771848],
              [55.8298058, 32.7704666],
              [55.8314725, 32.7699067],
              [55.8359157, 32.7671257],
              [55.8492488, 32.7629632],
              [55.8503621, 32.7629632],
              [55.8506389, 32.7626833],
              [55.8511955, 32.7626833],
              [55.8517488, 32.7624033],
              [55.852582, 32.7624034],
              [55.8528621, 32.7621234],
              [55.8542487, 32.7618525],
              [55.8550821, 32.7615726],
              [55.8559154, 32.7612928],
              [55.857582, 32.760742],
              [55.8600821, 32.7593514],
              [55.8764718, 32.7532385],
              [55.879805, 32.7526877],
              [55.8814717, 32.7521279],
              [55.885085, 32.7515771],
              [55.8984181, 32.7504575],
              [55.9070314, 32.7504575],
              [55.9081413, 32.7501776],
              [55.9373075, 32.7482363],
              [55.9634205, 32.7424032],
              [55.9656441, 32.7415726],
              [55.9720338, 32.7396312],
              [55.9862003, 32.7318479],
              [55.9925902, 32.7276854],
              [56.0028669, 32.7221323],
              [56.0306465, 32.7087959],
              [56.037593, 32.7051841],
              [56.0384263, 32.7046244],
              [56.0512027, 32.6985114],
              [56.0531461, 32.6979606],
              [56.0821777, 32.6835651],
              [56.0856488, 32.6818432],
              [56.1117619, 32.6612922],
              [56.1131519, 32.6607324],
              [56.1350948, 32.6468451],
              [56.1684311, 32.6282355],
              [56.1803743, 32.621012],
              [56.1814876, 32.6201812],
              [56.1842642, 32.6187907],
              [56.1998208, 32.6093459],
              [56.2009307, 32.6082353],
              [56.221487, 32.5937882],
              [56.2403767, 32.5765691],
              [56.2487134, 32.5632326],
              [56.2612131, 32.53851],
              [56.2620465, 32.5376793],
              [56.2734363, 32.5190695],
              [56.2778796, 32.5124058],
              [56.2995458, 32.4837825],
              [56.3048258, 32.4782293],
              [56.3053824, 32.4771188],
              [56.3114923, 32.4668432],
              [56.3209389, 32.4551771],
              [56.3623284, 32.4057319],
              [56.3739947, 32.3954474],
              [56.3742714, 32.3951765],
              [56.374828, 32.3948966],
              [56.3756614, 32.3940659],
              [56.3820514, 32.3887837],
              [56.4006644, 32.3693433],
              [56.4098309, 32.3629505],
              [56.4164975, 32.3548962],
              [56.4795566, 32.291284],
              [56.4801098, 32.2907332],
              [56.4809432, 32.2904533],
              [56.4812232, 32.2898935],
              [56.4892799, 32.2848913],
              [56.4934463, 32.2818393],
              [56.4935382, 32.2817463],
              [56.4942798, 32.2809995],
              [56.4945564, 32.2801778],
              [56.498723, 32.2757264],
              [56.5262225, 32.2473922],
              [56.5273358, 32.2468414],
              [56.5276123, 32.2462816],
              [56.542059, 32.2329451],
              [56.5426123, 32.2326743],
              [56.543169, 32.2318346],
              [56.5437256, 32.2315637],
              [56.544559, 32.2301732],
              [56.5615019, 32.2093334],
              [56.5756719, 32.1915547],
              [56.584005, 32.1835005],
              [56.5912282, 32.1740559],
              [56.6334509, 32.1129457],
              [56.6373409, 32.1076725],
              [56.6534506, 32.0873839],
              [56.6545639, 32.0812801],
              [56.6528972, 32.075998],
              [56.6359507, 32.0576688],
              [56.6312274, 32.0523868],
              [56.6309509, 32.0518359],
              [56.6162278, 32.0329379],
              [56.5967812, 31.9996114],
              [56.6031712, 31.9904469],
              [56.6028946, 31.9893272],
              [56.6026178, 31.9887764],
              [56.6026178, 31.9879458],
              [56.6023377, 31.9857246],
              [56.6020611, 31.9834944],
              [56.6015045, 31.9810024],
              [56.6009479, 31.9762712],
              [56.600671, 31.9754405],
              [56.6003946, 31.9746098],
              [56.5990044, 31.9615538],
              [56.5987278, 31.9562718],
              [56.5984477, 31.9546105],
              [56.5981712, 31.9540507],
              [56.5992812, 31.9434957],
              [56.5998378, 31.9423851],
              [56.6001143, 31.9407148],
              [56.6012279, 31.9379428],
              [56.6026178, 31.932381],
              [56.6028945, 31.9312794],
              [56.6023487, 31.92502],
              [56.6097769, 31.92725],
              [56.6228941, 31.9293726],
              [56.6280467, 31.9304423],
              [56.6374646, 31.9327657],
              [56.6501171, 31.9354418],
              [56.6698401, 31.9384935],
              [56.6728968, 31.9390534],
              [56.67484, 31.9390533],
              [56.7225426, 31.9439345],
              [56.7744887, 31.9481468],
              [56.8146451, 31.9514446],
              [56.8336015, 31.9528808],
              [56.8482444, 31.9546717],
              [56.8632976, 31.9552316],
              [56.8724277, 31.9569589],
              [56.8968802, 31.9543386],
              [56.9339453, 31.9489167],
              [56.9742794, 31.9410983],
              [57.0059688, 31.9384932],
              [57.0168021, 31.9360011],
              [57.0350552, 31.9346053],
              [57.0599447, 31.9269099],
              [57.0756343, 31.9245975],
              [57.1129371, 31.9127206],
              [57.1521367, 31.9016862],
              [57.2380825, 31.8746425],
              [57.254562, 31.867645],
              [57.3300447, 31.8464389],
              [57.3555895, 31.8394364],
              [57.3874964, 31.8306892],
              [57.4359985, 31.8175948],
              [57.4866482, 31.8058106],
              [57.5031277, 31.7964736],
              [57.5231893, 31.7982451],
              [57.5295636, 31.7988079],
              [57.5454345, 31.7969758],
              [57.5546011, 31.7947542],
              [57.5865273, 31.7897211],
              [57.5965006, 31.7857487],
              [57.6227433, 31.7815856],
              [57.6590665, 31.7681263],
              [57.6808293, 31.7597914],
              [57.6941118, 31.7543683],
              [57.7260756, 31.7388418],
              [57.7378368, 31.720644],
              [57.7458216, 31.707815],
              [57.7506402, 31.7005402],
              [57.7578321, 31.7006882],
              [57.7706312, 31.7438322],
              [57.7720245, 31.7432724],
              [57.8005542, 31.7363406],
              [57.9200156, 31.6931694],
              [57.9205686, 31.6928896],
              [57.959747, 31.6782196],
              [57.9937359, 31.6761744],
              [58.0212781, 31.6688824],
              [58.0712434, 31.6529389],
              [58.0723572, 31.6521082],
              [58.1385158, 31.627659],
              [58.1415761, 31.6259887],
              [58.2238615, 31.5943506],
              [58.2288615, 31.5915793],
              [58.2793405, 31.5689739],
              [58.2804538, 31.5687031],
              [58.3043401, 31.553141],
              [58.3090669, 31.54981],
              [58.3353417, 31.5352382],
              [58.3734397, 31.4800577],
              [58.3764929, 31.4778278],
              [58.3834395, 31.4728265],
              [58.4527574, 31.4063972],
              [58.573467, 31.3369975],
              [58.5737405, 31.3367174],
              [58.5880535, 31.3353187],
              [58.6053895, 31.3194036],
              [58.6391827, 31.2808985],
              [58.6661335, 31.2475901],
              [58.6920544, 31.226014],
              [58.7239834, 31.2081036],
              [58.7449261, 31.1943015],
              [58.7708471, 31.1903365],
              [58.7796014, 31.1857846],
              [58.8015744, 31.1743289],
              [58.8389965, 31.1517078],
              [58.8719555, 31.1287874],
              [58.964309, 31.0570522],
              [59.0195843, 31.0182216],
              [59.0439602, 30.9855566],
              [59.0834423, 30.95818],
              [59.1434672, 30.90644],
              [59.1608189, 30.8911404],
              [59.1885723, 30.8645116],
              [59.2329541, 30.8176491],
              [59.2412655, 30.8108148],
              [59.263448, 30.7938734],
              [59.2678069, 30.7885207],
              [59.2742169, 30.7778027],
              [59.2819522, 30.763829],
              [59.2903345, 30.7481443],
              [59.2981334, 30.7303009],
              [59.3036492, 30.7214042],
              [59.3094605, 30.7118515],
              [59.3141562, 30.7069197],
              [59.3536918, 30.6646169],
              [59.3697661, 30.6489304],
              [59.3818185, 30.6373168],
              [59.4029492, 30.6145196],
              [59.4165464, 30.6010153],
              [59.4348258, 30.5827064],
              [59.4582706, 30.5535857],
              [59.468116, 30.5427928],
              [59.4830583, 30.5275894],
              [59.4881025, 30.52283],
              [59.5029529, 30.5332544],
              [59.5083903, 30.5361684],
              [59.519861, 30.5484436],
              [59.6416851, 30.5764503],
              [59.6701809, 30.5900462],
              [59.6976468, 30.5876819],
              [59.7051988, 30.6024591],
              [59.7388455, 30.6219596],
              [59.776611, 30.6423432],
              [59.8030468, 30.6379123],
              [59.8583218, 30.6822117],
              [59.8576352, 30.7002209],
              [59.865123, 30.7119149],
              [59.8656764, 30.7124744],
              [59.8673429, 30.7135844],
              [59.8789208, 30.7214737],
              [59.9193923, 30.7487619],
              [59.9243924, 30.7559825],
              [59.9243924, 30.7562623],
              [59.9249455, 30.7568219],
              [59.9274457, 30.7612625],
              [59.9277257, 30.7623728],
              [59.9279987, 30.7646021],
              [59.9285589, 30.7662627],
              [59.9288324, 30.7673731],
              [59.9291124, 30.7690428],
              [59.9293922, 30.7707125],
              [59.9296656, 30.7726531],
              [59.9299457, 30.7751534],
              [59.9302258, 30.7770938],
              [59.9304988, 30.7793233],
              [59.9306454, 30.7939884],
              [59.9312057, 30.8067686],
              [59.9309257, 30.810379],
              [59.9312056, 30.8112093],
              [59.9314791, 30.8148195],
              [59.9314792, 30.8187096],
              [59.9314792, 30.8198197],
              [59.9320393, 30.8245402],
              [59.9320394, 30.8326002],
              [59.9334258, 30.8439907],
              [59.9334258, 30.8551014],
              [59.9339794, 30.8592714],
              [59.9339794, 30.8648223],
              [59.936479, 30.881764],
              [59.9370392, 30.8828832],
              [59.9370393, 30.8837136],
              [59.9378724, 30.8856632],
              [59.9409257, 30.8937144],
              [59.9414792, 30.894265],
              [59.9414792, 30.8945448],
              [59.9428725, 30.8967652],
              [59.9556455, 30.9134363],
              [59.9562057, 30.9145465],
              [59.962039, 30.9192671],
              [59.9839779, 30.973194],
              [60.0121411, 31.0086067],
              [60.0190807, 31.0099956],
              [60.035474, 31.0099955],
              [60.0357541, 31.0097161],
              [60.0396405, 31.009716],
              [60.040194, 31.0094364],
              [60.0418604, 31.0094364],
              [60.0449206, 31.0091659],
              [60.0588673, 31.0070235],
              [60.0599739, 31.006744],
              [60.0616407, 31.0070236],
              [60.0697007, 31.0070236],
              [60.0699737, 31.0067439],
              [60.076087, 31.0067439],
              [60.0772004, 31.0070235],
              [60.0855338, 31.0070235],
              [60.0866471, 31.007303],
              [60.0922003, 31.007303],
              [60.0947004, 31.0075736],
              [60.1022001, 31.0073029],
              [60.1076901, 31.003748],
              [60.1082432, 31.0040277],
              [60.1238033, 31.0040277],
              [60.1246365, 31.003748],
              [60.1249166, 31.0040277],
              [60.1257498, 31.003748],
              [60.1282498, 31.003748],
              [60.128803, 31.0040277],
              [60.1329694, 31.0040276],
              [60.1380328, 31.0084032],
              [60.138866, 31.0086828],
              [60.1402594, 31.0086828],
              [60.1408129, 31.0089624],
              [60.1502596, 31.0089624],
              [60.1510928, 31.009242],
              [60.154146, 31.009242],
              [60.154699, 31.0095215],
              [60.1563659, 31.0092419],
              [60.1588659, 31.009242],
              [60.1622059, 31.009242],
              [60.1669259, 31.0092419],
              [60.1694259, 31.0100717],
              [60.1708122, 31.0100716],
              [60.2063254, 31.0246128],
              [60.2276287, 31.023433],
              [60.2348555, 31.0281526],
              [60.2543019, 31.0348124],
              [60.2556887, 31.0356517],
              [60.2584685, 31.0375919],
              [60.2693019, 31.0467605],
              [60.2701614, 31.0534359],
              [60.265995, 31.0664983],
              [60.2511718, 31.0892741],
              [60.2481186, 31.0937156],
              [60.2431185, 31.1042775],
              [60.2313623, 31.1227381],
              [60.2324756, 31.1260691],
              [60.2630993, 31.1493572],
              [60.282425, 31.1460551],
              [60.282425, 31.146335],
              [60.282978, 31.1466149],
              [60.2849246, 31.1482848],
              [60.2926251, 31.1628721],
              [60.3252407, 31.1672787],
              [60.3415877, 31.196654],
              [60.3457543, 31.1988749],
              [60.3581709, 31.2119562],
              [60.3706173, 31.2154854],
              [60.3910005, 31.2104505],
              [60.4218406, 31.2160037],
              [60.4240601, 31.2162835],
              [60.4293403, 31.2173942],
              [60.5118152, 31.1987011],
              [60.5123683, 31.1989812],
              [60.5137617, 31.1989811],
              [60.5358548, 31.211877],
              [60.536688, 31.211877],
              [60.5383549, 31.212708],
              [60.5731742, 31.2236819],
              [60.5745676, 31.2236819],
              [60.5773407, 31.2245128],
              [60.5798408, 31.2247837],
              [60.5801208, 31.2250636],
              [60.5804009, 31.2250636],
              [60.5815072, 31.2250636],
              [60.5820674, 31.2253437],
              [60.6507107, 31.2227845],
              [60.6658663, 31.2253458],
              [60.6664625, 31.2260158],
              [60.6673588, 31.2270231],
              [60.668093, 31.2278481],
              [60.6683665, 31.2283991],
              [60.6686469, 31.2286792],
              [60.670199, 31.2294182],
              [60.6674774, 31.2399715],
              [60.6527707, 31.2662266],
              [60.6678272, 31.2932275],
              [60.6730741, 31.295724],
              [60.6782323, 31.2981783],
              [60.7214869, 31.3021398],
              [60.7859795, 31.323141],
              [60.7942193, 31.355983],
              [60.809875, 31.3886187],
              [60.8187669, 31.3968452],
              [60.8282086, 31.4028799],
              [60.835075, 31.4151866],
              [60.833302, 31.4241783],
              [60.8344247, 31.4264036],
              [60.8376092, 31.4327152],
              [60.8428745, 31.4431502],
              [60.8448447, 31.4470544],
              [60.8473216, 31.4569733],
              [60.8487315, 31.4626188],
              [60.8487315, 31.4640001],
              [60.8492917, 31.4659502],
              [60.8490729, 31.4752663],
              [60.8572509, 31.4784799],
              [60.8575314, 31.4787598],
              [60.857251, 31.482371],
              [60.8569713, 31.4832016],
              [60.8569713, 31.4834814],
              [60.856057, 31.4865192],
              [60.8549929, 31.491869],
              [60.853881, 31.4974591],
              [60.8514942, 31.5094568],
              [60.8493717, 31.5201248],
              [60.8486974, 31.5235139],
              [60.8496221, 31.5371797],
              [60.8500977, 31.5443054],
              [60.8419141, 31.5575988],
              [60.8409225, 31.5625803],
              [60.839722, 31.568611],
              [60.8380867, 31.5773484],
              [60.8369229, 31.5835658],
              [60.8353337, 31.5920555],
              [60.8343276, 31.5974293],
              [60.8322799, 31.6083664],
              [60.8316128, 31.6119296],
              [60.8304571, 31.6181013],
              [60.829752, 31.6218671],
              [60.8283486, 31.6293607],
              [60.827581, 31.6334597],
              [60.825736, 31.6433102],
              [60.8243906, 31.6504928],
              [60.8225452, 31.6603436],
              [60.821868, 31.6639582],
              [60.8202504, 31.6725924],
              [60.8189515, 31.6795243],
              [60.8168151, 31.6909252],
              [60.8162475, 31.6939539],
              [60.814987, 31.7006798],
              [60.8134835, 31.7087013],
              [60.8136337, 31.7148763],
              [60.8138785, 31.724937],
              [60.8141316, 31.7353365],
              [60.8142403, 31.7398067],
              [60.8143812, 31.7455926],
              [60.8145082, 31.7508117],
              [60.8146658, 31.7572892],
              [60.814807, 31.7630907],
              [60.8150179, 31.7717544],
              [60.815165, 31.7777947],
              [60.815336, 31.7848184],
              [60.8154892, 31.7911094],
              [60.8156224, 31.7965818],
              [60.8157769, 31.802927],
              [60.8160141, 31.8126657],
              [60.816134, 31.8175886],
              [60.8162761, 31.8234224],
              [60.8163534, 31.8265956],
              [60.8165425, 31.8343586],
              [60.8166793, 31.8399742],
              [60.8168245, 31.8459334],
              [60.8169635, 31.8516402],
              [60.8171279, 31.8583847],
              [60.8172442, 31.8631594],
              [60.8174286, 31.8707234],
              [60.8175444, 31.8754785],
              [60.8178255, 31.8870107],
              [60.8178956, 31.8898861],
              [60.8191276, 31.894975],
              [60.8213053, 31.9039692],
              [60.823033, 31.911104],
              [60.8250453, 31.9194136],
              [60.8258401, 31.9226955],
              [60.8274737, 31.9294407],
              [60.8268781, 31.9326332],
              [60.8258138, 31.9383379],
              [60.8249639, 31.9428932],
              [60.8233174, 31.9517177],
              [60.8227018, 31.961064],
              [60.8224952, 31.9642008],
              [60.825404, 31.9687449],
              [60.832519, 31.979859],
              [60.8310091, 31.9833543],
              [60.8277299, 31.9909452],
              [60.8250445, 31.9971609],
              [60.8201424, 32.0085064],
              [60.8187522, 32.0117237],
              [60.8173419, 32.0192252],
              [60.8159668, 32.0265393],
              [60.8225204, 32.0328611],
              [60.8316968, 32.0492082],
              [60.8427148, 32.0688322],
              [60.8639632, 32.1373621],
              [60.882921, 32.197736],
              [60.8791967, 32.2088094],
              [60.8590962, 32.2664924],
              [60.8474185, 32.340298],
              [60.8339864, 32.3998876],
              [60.8149811, 32.4804051],
              [60.814771, 32.4812948],
              [60.7816089, 32.5494463],
              [60.7778957, 32.5570741],
              [60.7764187, 32.5593351],
              [60.7478436, 32.6185296],
              [60.7095814, 32.6958555],
              [60.6886991, 32.7817361],
              [60.6649261, 32.8776041],
              [60.6541746, 32.9214314],
              [60.6337405, 33.0039088],
              [60.6294139, 33.0212334],
              [60.5978837, 33.095297],
              [60.5833775, 33.1299045],
              [60.6058475, 33.1731321],
              [60.612902, 33.1868775],
              [60.6340548, 33.2281412],
              [60.7038369, 33.2923734],
              [60.7592717, 33.3436359],
              [60.8243549, 33.399798],
              [60.8664836, 33.421487],
              [60.8634248, 33.4616233],
              [60.8509231, 33.4820012],
              [60.8824864, 33.5052436],
              [60.8832913, 33.5052232],
              [60.8858606, 33.5045986],
              [60.8864684, 33.5043222],
              [60.8870209, 33.5035917],
              [60.8877562, 33.5032519],
              [60.8883706, 33.5031968],
              [60.8899409, 33.5035153],
              [60.8909279, 33.5033811],
              [60.8914883, 33.5029993],
              [60.8917724, 33.5030586],
              [60.8922933, 33.5029599],
              [60.8927432, 33.5026045],
              [60.893201, 33.5024465],
              [60.8941618, 33.5027736],
              [60.8949769, 33.502486],
              [60.8959714, 33.5025452],
              [60.8984498, 33.501841],
              [60.9016125, 33.5020372],
              [60.903217, 33.5007583],
              [60.9082182, 33.4994855],
              [60.9194759, 33.4982316],
              [60.9215677, 33.4974539],
              [60.9235211, 33.4976029],
              [60.9253405, 33.4972305],
              [60.9258874, 33.4977518],
              [60.9287078, 33.4972033],
              [60.9459035, 33.5134944],
              [60.9439574, 33.5150844],
              [60.9027952, 33.5399665],
              [60.8742226, 33.5405285],
              [60.8262277, 33.5413576],
              [60.7986618, 33.5418599],
              [60.7811881, 33.5423074],
              [60.7529151, 33.5429181],
              [60.7034182, 33.54552],
              [60.6741973, 33.5527693],
              [60.6550163, 33.5574733],
              [60.6262032, 33.5821543],
              [60.6168541, 33.5998234],
              [60.5963244, 33.6513191],
              [60.5468937, 33.7314095],
              [60.5552661, 33.7489647],
              [60.5822135, 33.8054437],
              [60.576597, 33.8271947],
              [60.5713561, 33.8480329],
              [60.5420008, 33.9647513],
              [60.533076, 34.0002495],
              [60.4149977, 33.9409948],
              [60.4005513, 33.9373823],
              [60.396945, 33.9365513],
              [60.3852783, 33.931828],
              [60.3334801, 33.9524742],
              [60.2812951, 33.9331065],
              [60.2625075, 33.9360357],
              [60.2605676, 33.9340951],
              [60.2183077, 33.9277889],
              [60.1863617, 33.9039053],
              [60.1858081, 33.9033549],
              [60.1841417, 33.9027955],
              [60.1710819, 33.8917063],
              [60.1571887, 33.8875372],
              [60.1544156, 33.8864273],
              [60.1535823, 33.8858678],
              [60.147742, 33.8842074],
              [60.1460756, 33.8842074],
              [60.145522, 33.8839276],
              [60.1438556, 33.8839276],
              [60.1374691, 33.8828176],
              [60.136909, 33.8828177],
              [60.1352422, 33.8825379],
              [60.1336731, 33.8841068],
              [60.119409, 33.8983661],
              [60.1163559, 33.9022556],
              [60.1158028, 33.9033655],
              [60.1152426, 33.9036452],
              [60.1146895, 33.9047552],
              [60.0921432, 33.9089644],
              [60.0880562, 33.9277046],
              [60.1199334, 33.9570306],
              [60.0924676, 33.9729763],
              [60.0088541, 33.9730135],
              [59.9583621, 33.9747657],
              [59.8742118, 33.9777986],
              [59.8250197, 33.9966042],
              [59.8148916, 34.0075621],
              [59.7712897, 34.0183763],
              [59.7498247, 34.0179848],
              [59.7225379, 34.0272684],
              [59.7041652, 34.0322782],
              [59.6734306, 34.028219],
              [59.6692114, 34.0304952],
              [59.6608505, 34.03144],
              [59.6484806, 34.0431196],
              [59.6407757, 34.0497767],
              [59.633274, 34.0495305],
              [59.6222608, 34.0478125],
              [59.563237, 34.0500944],
              [59.5632369, 34.0503742],
              [59.4916531, 34.0523753],
              [59.4672772, 34.0617616],
              [59.4573208, 34.0805313],
              [59.4236752, 34.0867869],
              [59.4044491, 34.108678],
              [59.3781124, 34.1152319],
              [59.3781124, 34.1155116],
              [59.3772788, 34.1163419],
              [59.3769986, 34.1166217],
              [59.3767185, 34.1168924],
              [59.3764455, 34.1171722],
              [59.3758853, 34.1171722],
              [59.3753322, 34.1168924],
              [59.3499661, 34.1077071],
              [59.349413, 34.1079869],
              [59.347193, 34.1079869],
              [59.3466329, 34.1082668],
              [59.3030136, 34.0805411],
              [59.291907, 34.0855393],
              [59.2907938, 34.0860941],
              [59.259028, 34.088631],
              [59.2576417, 34.0891818],
              [59.2504149, 34.0933535],
              [59.2501415, 34.0939042],
              [59.2490283, 34.094464],
              [59.2248622, 34.1150236],
              [59.2223621, 34.1161341],
              [59.2215289, 34.1161341],
              [59.219582, 34.1169649],
              [59.2148623, 34.1164141],
              [59.2145822, 34.1161343],
              [59.2140287, 34.1161341],
              [59.2134686, 34.1158542],
              [59.1904652, 34.1175212],
              [59.1899116, 34.1175212],
              [59.179916, 34.1245952],
              [59.1657953, 34.1196577],
              [59.1644019, 34.1196576],
              [59.1641288, 34.1193778],
              [59.1627355, 34.1193778],
              [59.162462, 34.1190981],
              [59.1552352, 34.1185475],
              [59.1342541, 34.1137946],
              [59.1199556, 34.120488],
              [59.1155161, 34.1210477],
              [59.1132891, 34.1210477],
              [59.1113493, 34.1216073],
              [59.1032893, 34.1221579],
              [59.101903, 34.1218781],
              [59.0767499, 34.1332461],
              [59.0759168, 34.1335258],
              [59.0678568, 34.1335258],
              [59.0667502, 34.1332461],
              [59.0545238, 34.1332462],
              [59.0536901, 34.1335258],
              [59.053137, 34.1332462],
              [59.0525768, 34.1335259],
              [59.0489705, 34.1335259],
              [59.0481369, 34.1338057],
              [59.0331373, 34.1351864],
              [59.0328573, 34.1349157],
              [59.0323037, 34.1349156],
              [59.0323037, 34.134636],
              [59.0317439, 34.1343562],
              [59.0314705, 34.1340765],
              [59.0311905, 34.1338057],
              [58.999231, 34.1222937],
              [58.997284, 34.1217432],
              [58.9964509, 34.1211839],
              [58.9894575, 34.0988308],
              [58.9741776, 34.0949408],
              [58.9581295, 34.0793939],
              [58.8949254, 34.0849009],
              [58.8938121, 34.0849009],
              [58.8893722, 34.0860115],
              [58.8877057, 34.0860115],
              [58.8810392, 34.0874019],
              [58.8796458, 34.0874019],
              [58.8790923, 34.0876818],
              [58.8777059, 34.0876818],
              [58.8763125, 34.0879617],
              [58.8477259, 34.113268],
              [58.8468926, 34.1129882],
              [58.8249462, 34.1082677],
              [58.8213328, 34.1063272],
              [58.8113329, 34.0985469],
              [58.8079997, 34.0946568],
              [58.748827, 34.0893767],
              [58.7185475, 34.0982672],
              [58.7163274, 34.0988268],
              [58.7152142, 34.0993774],
              [58.7143809, 34.0993774],
              [58.7138275, 34.0996572],
              [58.7127141, 34.0996573],
              [58.7118809, 34.099937],
              [58.7085476, 34.1002078],
              [58.7077145, 34.099937],
              [58.7057745, 34.099937],
              [58.6940776, 34.1064393],
              [58.6861909, 34.1082827],
              [58.6847031, 34.105881],
              [58.6725409, 34.09703],
              [58.6692076, 34.0878731],
              [58.6578946, 34.0875405],
              [58.6562277, 34.0839233],
              [58.6559547, 34.0836526],
              [58.6509545, 34.0761566],
              [58.6481748, 34.0744967],
              [58.6473412, 34.0744967],
              [58.6462279, 34.074208],
              [58.6445614, 34.0736577],
              [58.6347347, 34.0637928],
              [58.6239816, 34.0579138],
              [58.6007306, 34.0569264],
              [58.5736728, 34.0513003],
              [58.5560986, 34.058633],
              [58.542709, 34.0762658],
              [58.5245129, 34.0811],
              [58.5124966, 34.0901989],
              [58.4988066, 34.0799981],
              [58.4963607, 34.0777585],
              [58.4950733, 34.0774742],
              [58.4939575, 34.0764433],
              [58.4912967, 34.0756613],
              [58.4860611, 34.0780074],
              [58.4774351, 34.0796336],
              [58.4739053, 34.0807888],
              [58.4694314, 34.0815352],
              [58.4654059, 34.0815654],
              [58.46632, 34.0836945],
              [58.4659338, 34.0849296],
              [58.4662771, 34.0854716],
              [58.4651613, 34.0902697],
              [58.4636163, 34.1003627],
              [58.4579085, 34.1137233],
              [58.4582519, 34.1201897],
              [58.4608268, 34.1236003],
              [58.4671783, 34.138307],
              [58.4469222, 34.1577167],
              [58.4452056, 34.1616052],
              [58.4450984, 34.1645347],
              [58.4447336, 34.1653159],
              [58.4435963, 34.1683874],
              [58.4435534, 34.1707486],
              [58.4432316, 34.1721334],
              [58.4424162, 34.1727547],
              [58.4431379, 34.1738136],
              [58.4384621, 34.1783383],
              [58.4359778, 34.1815256],
              [58.4316444, 34.1863524],
              [58.4324169, 34.1902573],
              [58.4331464, 34.1925647],
              [58.4343051, 34.1948365],
              [58.4330177, 34.1959369],
              [58.4306144, 34.2002673],
              [58.4237816, 34.2127084],
              [58.4216022, 34.2149962],
              [58.4195725, 34.2158732],
              [58.418355, 34.2165393],
              [58.4172214, 34.2191257],
              [58.4191131, 34.2232468],
              [58.4188342, 34.2245952],
              [58.4191346, 34.2251806],
              [58.4178256, 34.2313192],
              [58.4149074, 34.2418919],
              [58.4148982, 34.2467382],
              [58.4146198, 34.2533691],
              [58.4038992, 34.2552993],
              [58.3986895, 34.2590667],
              [58.3941755, 34.2631686],
              [58.3853816, 34.2716162],
              [58.3838352, 34.275102],
              [58.3786422, 34.2818634],
              [58.3718204, 34.288141],
              [58.3658978, 34.2916868],
              [58.3650814, 34.2986035],
              [58.3632444, 34.305363],
              [58.3613631, 34.3105302],
              [58.3458369, 34.3074126],
              [58.3413405, 34.3069474],
              [58.3381567, 34.3066744],
              [58.3348046, 34.3065924],
              [58.3323063, 34.3065599],
              [58.3270347, 34.3064324],
              [58.3218615, 34.3063884],
              [58.3178452, 34.3062566],
              [58.3141344, 34.3061921],
              [58.3090988, 34.3059065],
              [58.302484, 34.3058445],
              [58.29648, 34.3058053],
              [58.2910081, 34.3066148],
              [58.2857094, 34.3088056],
              [58.282168, 34.3106676],
              [58.2783749, 34.3121136],
              [58.2732168, 34.3143966],
              [58.2699022, 34.3154378],
              [58.2674035, 34.3159404],
              [58.2593839, 34.312246],
              [58.2729005, 34.2956576],
              [58.2760201, 34.2909321],
              [58.2729123, 34.2840504],
              [58.270925, 34.2817319],
              [58.2637261, 34.2747201],
              [58.262176, 34.2727155],
              [58.260728, 34.2705236],
              [58.2592885, 34.2684303],
              [58.2559627, 34.2638607],
              [58.2552695, 34.2629602],
              [58.250273, 34.2644759],
              [58.247253, 34.26385],
              [58.2449205, 34.2629363],
              [58.2429828, 34.2616149],
              [58.2389451, 34.2582268],
              [58.2367276, 34.2531717],
              [58.2372831, 34.2482048],
              [58.2382413, 34.2441694],
              [58.2392156, 34.2419976],
              [58.2358646, 34.2365702],
              [58.2201094, 34.2229363],
              [58.2120036, 34.2228742],
              [58.206253, 34.2245775],
              [58.1996326, 34.2287508],
              [58.1851862, 34.2351881],
              [58.1733678, 34.2365279],
              [58.1672, 34.2345834],
              [58.1578355, 34.2317067],
              [58.1401148, 34.2316277],
              [58.1248855, 34.2347253],
              [58.1206798, 34.2371379],
              [58.1132125, 34.2404728],
              [58.1052726, 34.2442376],
              [58.0966472, 34.2486323],
              [58.0920123, 34.2495546],
              [58.082375, 34.2542869],
              [58.0705546, 34.2611891],
              [58.0626582, 34.2668639],
              [58.05768, 34.2717581],
              [58.0502128, 34.2760137],
              [58.044033, 34.2795599],
              [58.0392264, 34.2799854],
              [58.0251502, 34.2778577],
              [58.0147808, 34.2741276],
              [57.9987905, 34.2820302],
              [57.9803466, 34.2856589],
              [57.975406, 34.2879701],
              [57.964351, 34.2922367],
              [57.9593275, 34.2957784],
              [57.9539265, 34.3013511],
              [57.9515173, 34.3048063],
              [57.9419722, 34.307855],
              [57.9383516, 34.3087917],
              [57.9351151, 34.3098197],
              [57.9316415, 34.3102729],
              [57.9290691, 34.3119035],
              [57.9271876, 34.3137037],
              [57.925067, 34.3165749],
              [57.9206943, 34.3175653],
              [57.9150898, 34.3155527],
              [57.9109044, 34.3147337],
              [57.9099615, 34.3201858],
              [57.9071814, 34.321305],
              [57.9046813, 34.3218556],
              [57.9032879, 34.3218556],
              [57.9027347, 34.3221354],
              [57.8945645, 34.3373036],
              [57.8940115, 34.3375834],
              [57.8832398, 34.3443868],
              [57.8824066, 34.3441071],
              [57.8818464, 34.3443869],
              [57.8810132, 34.3441071],
              [57.8762932, 34.3441072],
              [57.8757329, 34.3438275],
              [57.8751798, 34.3438275],
              [57.873513, 34.3438274],
              [57.8676797, 34.3432771],
              [57.8671266, 34.3429973],
              [57.8657332, 34.3429973],
              [57.8651801, 34.3427176],
              [57.8643464, 34.3427177],
              [57.8640668, 34.3424379],
              [57.8623999, 34.3424379],
              [57.8465386, 34.3444666],
              [57.8457053, 34.3441868],
              [57.7721865, 34.3488601],
              [57.7719065, 34.3491397],
              [57.7713529, 34.3496993],
              [57.76695, 34.3546226],
              [57.7677707, 34.3549214],
              [57.7697996, 34.3567577],
              [57.7695898, 34.3594136],
              [57.7742173, 34.3662291],
              [57.7749028, 34.3666507],
              [57.7925687, 34.3850123],
              [57.7920156, 34.3858517],
              [57.7953019, 34.3988677],
              [57.8011319, 34.4083262],
              [57.8014752, 34.4256028],
              [57.8063908, 34.4348469],
              [57.8055571, 34.4359662],
              [57.820243, 34.4497466],
              [57.8230931, 34.4892684],
              [57.8186463, 34.4962094],
              [57.8183665, 34.4970399],
              [57.8125421, 34.498293],
              [57.812269, 34.4991238],
              [57.7852534, 34.511154],
              [57.7878225, 34.5205293],
              [57.7874076, 34.5205282],
              [57.7897694, 34.5244219],
              [57.7897694, 34.5247018],
              [57.7958758, 34.5308163],
              [57.807976, 34.5408506],
              [57.8079759, 34.5414108],
              [57.8290889, 34.565055],
              [57.8360356, 34.573394],
              [57.8382556, 34.5775681],
              [57.8385357, 34.5778481],
              [57.8388157, 34.5783992],
              [57.8393692, 34.5797905],
              [57.8413158, 34.5822932],
              [57.8413158, 34.5828533],
              [57.8450224, 34.6188228],
              [57.8462171, 34.6549216],
              [57.8506495, 34.6608072],
              [57.8551194, 34.6729775],
              [57.8562327, 34.6743682],
              [57.8574368, 34.7057759],
              [57.8701397, 34.7249661],
              [57.8751495, 34.7416757],
              [57.8820961, 34.7475154],
              [57.8870964, 34.750846],
              [57.8879296, 34.7516854],
              [57.9004295, 34.7583554],
              [57.902376, 34.7591858],
              [57.9178616, 34.7873034],
              [57.9285046, 34.8205682],
              [57.9273031, 34.8433947],
              [57.9300495, 34.8521997],
              [57.9548547, 34.8853768],
              [57.9535142, 34.8854034],
              [57.9346418, 34.8854733],
              [57.8653332, 34.8659334],
              [57.8244778, 34.8624121],
              [57.7968403, 34.8557918],
              [57.7681731, 34.8532561],
              [57.7604483, 34.8541013],
              [57.7550444, 34.8542178],
              [57.753955, 34.8608591],
              [57.7565979, 34.8810716],
              [57.7624299, 34.8926181],
              [57.7615385, 34.9135434],
              [57.761481, 34.9140592],
              [57.757101, 34.9157778],
              [57.7507495, 34.917467],
              [57.7427259, 34.9206582],
              [57.7319526, 34.9214081],
              [57.7224253, 34.9209859],
              [57.7117824, 34.9229564],
              [57.7063951, 34.9268426],
              [57.7018725, 34.9328255],
              [57.6966934, 34.9386079],
              [57.6908651, 34.9477076],
              [57.6795256, 34.9557837],
              [57.6761452, 34.9582612],
              [57.6736452, 34.9596593],
              [57.6728119, 34.9604891],
              [57.6700322, 34.9618782],
              [57.6613998, 34.968265],
              [57.6556938, 34.9713098],
              [57.6497268, 34.9745247],
              [57.6428422, 34.9782526],
              [57.6181608, 34.9930692],
              [57.6015758, 34.995832],
              [57.5917053, 34.9983983],
              [57.5885295, 34.9999803],
              [57.5722217, 35.009401],
              [57.5673293, 35.0130566],
              [57.5645595, 35.0139566],
              [57.536371, 35.0125375],
              [57.5341444, 35.0125375],
              [57.5333111, 35.0122577],
              [57.5327576, 35.0125375],
              [57.5319243, 35.0122577],
              [57.530811, 35.0122577],
              [57.5305381, 35.0125376],
              [57.5288712, 35.0125376],
              [57.5280379, 35.0128173],
              [57.5269246, 35.0128173],
              [57.5094712, 35.0372281],
              [57.5033582, 35.0391682],
              [57.500023, 35.0503605],
              [57.4918315, 35.0671804],
              [57.4862193, 35.0774234],
              [57.4842483, 35.0933066],
              [57.4667346, 35.115716],
              [57.4642349, 35.116266],
              [57.460899, 35.1229978],
              [57.4520949, 35.1269001],
              [57.4040452, 35.1116458],
              [57.3920988, 35.113873],
              [57.3898722, 35.1141435],
              [57.3815389, 35.1163708],
              [57.3695752, 35.1067092],
              [57.3530957, 35.1106412],
              [57.3398467, 35.1053709],
              [57.3121604, 35.1022517],
              [57.3015404, 35.1011282],
              [57.2987673, 35.1008487],
              [57.2945972, 35.1008487],
              [57.2918207, 35.1005781],
              [57.2876538, 35.1005781],
              [57.2848739, 35.1002985],
              [57.2782073, 35.1002984],
              [57.2754307, 35.100019],
              [57.2715408, 35.1000189],
              [57.2633504, 35.1000667],
              [57.2391807, 35.0975684],
              [57.2375141, 35.0975685],
              [57.2255709, 35.0961795],
              [57.2225142, 35.0958999],
              [57.1725383, 35.0738009],
              [57.1686484, 35.0732506],
              [57.1661484, 35.0724116],
              [57.1622585, 35.0715818],
              [57.1321089, 35.0610131],
              [57.0559631, 35.019022],
              [57.053183, 35.018192],
              [57.0517965, 35.0173622],
              [57.0484632, 35.0162525],
              [57.0401266, 35.0123643],
              [57.0098603, 35.0052373],
              [57.0010372, 35.0064486],
              [56.9824274, 35.0022814],
              [56.9699475, 34.9970978],
              [56.9562445, 34.9815628],
              [56.9551345, 34.9815627],
              [56.9545778, 34.9812832],
              [56.9537445, 34.9812831],
              [56.9448546, 34.9793346],
              [56.9331913, 34.9821804],
              [56.9312481, 34.9821804],
              [56.9298581, 34.9819007],
              [56.9259682, 34.9819007],
              [56.9245813, 34.9816211],
              [56.9198582, 34.9813505],
              [56.9162449, 34.9813505],
              [56.9104115, 34.9819007],
              [56.9062449, 34.9819008],
              [56.9051351, 34.9821804],
              [56.9026351, 34.9821804],
              [56.9012449, 34.9824601],
              [56.8959685, 34.9824601],
              [56.8798552, 34.9799613],
              [56.8645754, 34.9744045],
              [56.8640221, 34.9738452],
              [56.8337425, 34.954405],
              [56.8273525, 34.948848],
              [56.8240192, 34.9466289],
              [56.8217959, 34.9444006],
              [56.8209625, 34.9419018],
              [56.8198526, 34.9391233],
              [56.820686, 34.9374544],
              [56.821796, 34.9369041],
              [56.8248525, 34.9371747],
              [56.8298524, 34.9388436],
              [56.8395756, 34.9371747],
              [56.8442988, 34.9352351],
              [56.8520755, 34.9219018],
              [56.8517989, 34.9205124],
              [56.8515221, 34.9191232],
              [56.8509655, 34.9180136],
              [56.8495757, 34.9149554],
              [56.835409, 34.8946753],
              [56.8298523, 34.8902367],
              [56.8179093, 34.876903],
              [56.8092959, 34.8646787],
              [56.8087393, 34.8632893],
              [56.8015194, 34.853573],
              [56.7984627, 34.8482862],
              [56.7976293, 34.847727],
              [56.795406, 34.8452369],
              [56.7901295, 34.8374511],
              [56.7837396, 34.8305133],
              [56.7826295, 34.8299539],
              [56.7823494, 34.8293946],
              [56.7534598, 34.8074533],
              [56.7531832, 34.8066233],
              [56.7517931, 34.8052338],
              [56.7490165, 34.7971771],
              [56.7490165, 34.7968974],
              [56.7479031, 34.7932887],
              [56.7456832, 34.7896798],
              [56.7398501, 34.7827327],
              [56.6723442, 34.7543938],
              [56.6665108, 34.7521744],
              [56.6492876, 34.7477353],
              [56.6462345, 34.7477354],
              [56.6456778, 34.7474557],
              [56.6445678, 34.7474556],
              [56.6378977, 34.7455068],
              [56.6373446, 34.7449475],
              [56.6356779, 34.7446767],
              [56.6256779, 34.7405084],
              [56.6115081, 34.7324514],
              [56.5662286, 34.7177266],
              [56.5603955, 34.7157868],
              [56.487893, 34.6902256],
              [56.4851128, 34.6896752],
              [56.4823365, 34.6888451],
              [56.4809464, 34.6888451],
              [56.4801129, 34.6885654],
              [56.479003, 34.6885654],
              [56.4773363, 34.6880061],
              [56.4734464, 34.6868962],
              [56.472893, 34.6868963],
              [56.4698366, 34.6860662],
              [56.4673365, 34.6860661],
              [56.4662232, 34.6857864],
              [56.4648366, 34.6857865],
              [56.4637232, 34.6855067],
              [56.4623365, 34.6855067],
              [56.4615034, 34.685227],
              [56.4584466, 34.685227],
              [56.45789, 34.6849474],
              [56.4548367, 34.6846766],
              [56.4512233, 34.6846767],
              [56.4462234, 34.6835578],
              [56.4384468, 34.682448],
              [56.4362236, 34.6824481],
              [56.4323336, 34.6818977],
              [56.4253904, 34.682448],
              [56.421777, 34.6824481],
              [56.4209437, 34.6827278],
              [56.4198338, 34.6827277],
              [56.419277, 34.6830075],
              [56.4184436, 34.6830075],
              [56.4159438, 34.6835579],
              [56.4126106, 34.6835578],
              [56.4117772, 34.6838376],
              [56.4109439, 34.6835579],
              [56.4106671, 34.6838376],
              [56.4078872, 34.6838376],
              [56.4070538, 34.6841173],
              [56.4028873, 34.6841173],
              [56.3998342, 34.6846767],
              [56.395944, 34.6849474],
              [56.3889973, 34.6852271],
              [56.3839975, 34.6852271],
              [56.3770544, 34.6860662],
              [56.318995, 34.6924544],
              [56.3131616, 34.6924544],
              [56.3123284, 34.6927341],
              [56.3098284, 34.6930048],
              [56.3064951, 34.6930048],
              [56.3051053, 34.6932845],
              [56.3012187, 34.6932845],
              [56.2998285, 34.6935642],
              [56.2976053, 34.6935642],
              [56.2962152, 34.6938439],
              [56.2926054, 34.6938439],
              [56.2912153, 34.6941236],
              [56.2820487, 34.6952334],
              [56.2787154, 34.6957838],
              [56.2773255, 34.6957838],
              [56.275659, 34.6963432],
              [56.2745489, 34.6963433],
              [56.2723257, 34.6971733],
              [56.2712156, 34.6971733],
              [56.2653824, 34.6988425],
              [56.2642724, 34.6988425],
              [56.2439926, 34.7035614],
              [56.2428791, 34.7041208],
              [56.2420459, 34.7041208],
              [56.2417693, 34.7044005],
              [56.2412125, 34.7044005],
              [56.2279736, 34.7104172],
              [56.2276029, 34.7091193],
              [56.2273261, 34.7088397],
              [56.2270463, 34.7080096],
              [56.2256594, 34.7060607],
              [56.0168348, 34.3866309],
              [56.0132214, 34.3813517],
              [56.0107213, 34.3766319],
              [56.0098882, 34.3758018],
              [55.9436991, 34.282272],
              [55.9108997, 34.2474447],
              [55.9103431, 34.247165],
              [55.9100664, 34.2468852],
              [55.9100665, 34.2466054],
              [55.9095096, 34.2460549],
              [55.909233, 34.2457751],
              [55.9058998, 34.2443852],
              [55.9050666, 34.2443853],
              [55.9047864, 34.2441054],
              [55.9042331, 34.2441054],
              [55.9036764, 34.2438257],
              [55.9014532, 34.2432751],
              [55.8936766, 34.2432751],
              [55.8931198, 34.2435549],
              [55.8908965, 34.2438257],
              [55.8900633, 34.2435549],
              [55.88951, 34.2438257],
              [55.88701, 34.2438257],
              [55.8864532, 34.2441054],
              [55.8678673, 34.2378615],
              [55.8670338, 34.2381413],
              [55.8564774, 34.2381412],
              [55.8553674, 34.2384211],
              [55.8525872, 34.2384211],
              [55.8514775, 34.2387009],
              [55.8445342, 34.2387008],
              [55.8434209, 34.2384211],
              [55.8417543, 34.2384212],
              [55.8106373, 34.2429954],
              [55.8100842, 34.2427157],
              [55.8075809, 34.2424449],
              [55.7998043, 34.2424449],
              [55.7986944, 34.242165],
              [55.7978609, 34.2424449],
              [55.7973043, 34.2421651],
              [55.7945276, 34.2421651],
              [55.7936944, 34.2424449],
              [55.7914709, 34.2424449],
              [55.7911944, 34.2427157],
              [55.7892477, 34.2427157],
              [55.788691, 34.2429954],
              [55.7867478, 34.2429954],
              [55.7861909, 34.2432753],
              [55.7828577, 34.2432752],
              [55.7823046, 34.243555],
              [55.7775812, 34.243555],
              [55.773138, 34.2432752],
              [55.7631346, 34.2432752],
              [55.7623014, 34.243555],
              [55.7531348, 34.2441056],
              [55.7525815, 34.2438258],
              [55.7520248, 34.2441055],
              [55.7498016, 34.2441056],
              [55.7492449, 34.2438258],
              [55.7489681, 34.243555],
              [55.7464682, 34.2427157],
              [55.7267452, 34.2424449],
              [55.7259118, 34.2427157],
              [55.7236884, 34.2427157],
              [55.7228551, 34.2429955],
              [55.710912, 34.2429954],
              [55.7095219, 34.2427157],
              [55.6786891, 34.2421652],
              [55.6775756, 34.242445],
              [55.6697991, 34.2424449],
              [55.6689659, 34.2427157],
              [55.6597993, 34.242445],
              [55.6584094, 34.2421652],
              [55.6547961, 34.2421651],
              [55.6534093, 34.242445],
              [55.5957227, 34.2647793],
              [55.5524977, 34.2622428],
              [55.5338286, 34.2684953],
              [55.5209677, 34.2718896],
              [55.5007367, 34.2674919],
              [55.5005651, 34.2445108],
              [55.5005841, 34.2238194],
              [55.5004484, 34.1746438],
              [55.5006008, 34.1548445],
              [55.5007783, 34.1387155],
              [55.500385, 34.1062723],
              [55.5006366, 34.0926371],
              [55.5003352, 34.0770147],
              [55.500415, 34.058876],
              [55.5003959, 34.0487802],
              [55.5002874, 34.0373987],
              [55.5002682, 34.0249969],
              [55.5002932, 34.0102337],
              [55.5004637, 33.999842],
              [55.503854, 33.9809113],
              [55.5080896, 33.9558693],
              [55.5111605, 33.9408474],
              [55.5275519, 33.852175],
              [55.5323695, 33.8260771],
              [55.5379485, 33.8006185],
              [55.5408667, 33.7904187],
              [55.5443, 33.7797181],
              [55.5612156, 33.663732],
              [55.5608722, 33.6496318],
              [55.559903, 33.6318541],
              [55.557179, 33.616369],
              [55.5534157, 33.6053637],
              [55.5479891, 33.5902184],
              [55.5447942, 33.5811191],
              [55.540566, 33.5698173],
              [55.5354829, 33.5526702],
              [55.5326063, 33.5440686],
              [55.5287619, 33.5423135],
              [55.518076, 33.5377327],
              [55.5097279, 33.5336609],
              [55.5041847, 33.5300843],
              [55.4983399, 33.5246551],
              [55.4923724, 33.5194296],
              [55.4821583, 33.506477],
              [55.4324623, 33.4254962],
              [55.4256223, 33.4149185],
              [55.4184209, 33.4035702],
              [55.4110605, 33.3920444],
              [55.4049914, 33.3824666]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 537693,
        "tags": {
          "ISO3166-2": "IR-11",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "سیستان و بلوچستان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q939575"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [58.7971223, 26.4449954],
              [58.7971288, 26.4449823],
              [58.7974023, 26.4444295],
              [58.8807599, 26.3542345],
              [58.8712689, 26.3269608],
              [58.8527295, 26.3091121],
              [58.8238903, 26.2823339],
              [58.8173672, 26.2429249],
              [58.8523861, 26.2318386],
              [58.9380595, 26.2292993],
              [58.9377861, 26.2279077],
              [58.9377861, 26.2270727],
              [59.0092034, 26.2080916],
              [59.0098777, 26.2075154],
              [59.0101578, 26.2072463],
              [59.0104378, 26.2064117],
              [59.0134911, 26.2025171],
              [59.0212708, 26.195024],
              [59.0209907, 26.1925205],
              [59.0207177, 26.1905732],
              [59.0204376, 26.190304],
              [59.0158078, 26.167148],
              [59.0228238, 26.1507603],
              [59.0225504, 26.1488218],
              [59.0239371, 26.141041],
              [59.0244902, 26.1402065],
              [59.0140911, 26.1249258],
              [59.0079113, 26.1033464],
              [59.0158078, 26.0953302],
              [59.0120312, 26.0882385],
              [58.9996716, 26.08423],
              [58.9928685, 26.076231],
              [58.9967549, 26.06984],
              [58.9970349, 26.0690051],
              [59.0171417, 26.0614667],
              [59.0761548, 25.9905973],
              [59.0629429, 25.9898172],
              [59.0519113, 25.989059],
              [59.0389425, 25.984685],
              [59.0236051, 25.9749856],
              [59.0165078, 25.9658544],
              [59.0020024, 25.9465741],
              [58.9984263, 25.9419313],
              [58.9995968, 25.9377711],
              [59.0037834, 25.9204774],
              [59.0270591, 25.9203993],
              [59.0373115, 25.9140783],
              [59.0480356, 25.9074309],
              [59.0619377, 25.8985135],
              [59.0687139, 25.8968842],
              [59.0696329, 25.8950698],
              [59.0717585, 25.8926682],
              [59.0732783, 25.8920119],
              [59.0744166, 25.8907072],
              [59.07516, 25.8891489],
              [59.0771579, 25.8888789],
              [59.0796244, 25.8846932],
              [59.0803743, 25.8825462],
              [59.0804827, 25.8806697],
              [59.0798772, 25.8787394],
              [59.0800761, 25.8737417],
              [59.0803062, 25.8630387],
              [59.0797935, 25.8609299],
              [59.0795968, 25.8591298],
              [59.0799536, 25.8561418],
              [59.0806738, 25.8539944],
              [59.0820694, 25.8522721],
              [59.094287, 25.841553],
              [59.0954255, 25.8399529],
              [59.0979266, 25.8377499],
              [59.0994121, 25.8368527],
              [59.1029692, 25.8365429],
              [59.1055226, 25.8361276],
              [59.1092348, 25.8345923],
              [59.1103506, 25.8340515],
              [59.1117132, 25.8332886],
              [59.1127766, 25.8316574],
              [59.1132903, 25.8301598],
              [59.1135798, 25.8283297],
              [59.1152074, 25.8269102],
              [59.1173672, 25.8259493],
              [59.120779, 25.8249064],
              [59.1229892, 25.8244621],
              [59.1253889, 25.8232983],
              [59.1289544, 25.8215262],
              [59.1332391, 25.8195511],
              [59.1406917, 25.8134909],
              [59.1462706, 25.8076186],
              [59.1319644, 25.8067884],
              [59.1370165, 25.7995248],
              [59.1413352, 25.7940185],
              [59.157801, 25.7739415],
              [59.1682309, 25.7614647],
              [59.1922065, 25.7401151],
              [59.2054938, 25.7285449],
              [59.2148563, 25.704146],
              [59.212993, 25.7011465],
              [59.2118864, 25.6972546],
              [59.2114768, 25.6930796],
              [59.2135342, 25.6861947],
              [59.2173512, 25.6721304],
              [59.2195189, 25.6651134],
              [59.2246821, 25.6589755],
              [59.2250633, 25.6579294],
              [59.2291061, 25.6519704],
              [59.2352194, 25.6391929],
              [59.2354994, 25.6386369],
              [59.2357725, 25.6367001],
              [59.2354995, 25.6341986],
              [59.2352194, 25.6322528],
              [59.2349393, 25.6314189],
              [59.2343858, 25.6291952],
              [59.2202195, 25.5922553],
              [59.2199394, 25.5905877],
              [59.2193862, 25.5897539],
              [59.214106, 25.5753105],
              [59.214106, 25.5747456],
              [59.213826, 25.5741987],
              [59.2116059, 25.5636377],
              [59.2113263, 25.5622481],
              [59.2110528, 25.5603027],
              [59.2107727, 25.5580794],
              [59.2104926, 25.5578014],
              [59.2107727, 25.5547533],
              [59.2141059, 25.5208578],
              [59.2146594, 25.51253],
              [59.2146594, 25.5047492],
              [59.2146593, 25.5041934],
              [59.2149391, 25.5008587],
              [59.214939, 25.4997473],
              [59.2160527, 25.4903082],
              [59.2179907, 25.4676514],
              [59.2190376, 25.4581693],
              [59.2211109, 25.4393893],
              [59.2187761, 25.1994033],
              [59.3884626, 25.197502],
              [59.5677381, 25.1954933],
              [59.6708527, 25.1832546],
              [60.0326439, 25.1402345],
              [60.1703289, 25.1239543],
              [60.2594613, 25.1104875],
              [60.3603641, 25.0952406],
              [60.3881286, 25.0867423],
              [60.4193982, 25.0794386],
              [60.4515016, 25.0763731],
              [60.5236134, 25.0742948],
              [60.5765756, 25.0727683],
              [60.9558293, 24.9721656],
              [61.116039, 24.9296429],
              [61.3546759, 24.8662768],
              [61.3973042, 24.85891],
              [61.5820528, 24.8353084],
              [61.582221, 24.8388312],
              [61.5831369, 24.8580138],
              [61.5840257, 24.8766295],
              [61.5880961, 24.9618819],
              [61.5896408, 24.9942356],
              [61.5916305, 25.0359092],
              [61.5916667, 25.0366667],
              [61.6173713, 25.1754455],
              [61.6178362, 25.176862],
              [61.6295361, 25.2092545],
              [61.6316303, 25.2203045],
              [61.6333298, 25.2281157],
              [61.6349777, 25.2346532],
              [61.6373038, 25.2435115],
              [61.6392864, 25.2524158],
              [61.6403851, 25.2592004],
              [61.6401956, 25.2686058],
              [61.6412177, 25.2745819],
              [61.6429407, 25.2822358],
              [61.6448423, 25.289239],
              [61.6459883, 25.2921799],
              [61.648397, 25.2967767],
              [61.6495947, 25.301537],
              [61.6505818, 25.3058125],
              [61.6512062, 25.3103982],
              [61.6519143, 25.3145881],
              [61.65244, 25.322081],
              [61.6532897, 25.3277328],
              [61.6533219, 25.3306362],
              [61.6536738, 25.3305878],
              [61.6541083, 25.332726],
              [61.6501784, 25.3331517],
              [61.6514551, 25.3418303],
              [61.6523542, 25.3481735],
              [61.6532962, 25.3558001],
              [61.6541073, 25.363017],
              [61.654722, 25.369444],
              [61.6552933, 25.3762854],
              [61.6561938, 25.3762161],
              [61.6564891, 25.3782388],
              [61.6552156, 25.3784771],
              [61.655556, 25.383333],
              [61.6558155, 25.3864507],
              [61.6558035, 25.393377],
              [61.6558861, 25.3983801],
              [61.6559805, 25.40363],
              [61.656739, 25.4078738],
              [61.6582797, 25.4138114],
              [61.6598279, 25.4196489],
              [61.6605832, 25.4226354],
              [61.6608997, 25.4249978],
              [61.6606197, 25.4315353],
              [61.6604673, 25.4388949],
              [61.6605725, 25.44331],
              [61.6613256, 25.4433129],
              [61.6614619, 25.4446508],
              [61.6613342, 25.4454452],
              [61.6610038, 25.4461873],
              [61.6610413, 25.4471736],
              [61.6610713, 25.4524282],
              [61.6611422, 25.4553877],
              [61.6613342, 25.4610711],
              [61.6615552, 25.4652935],
              [61.661744, 25.4680861],
              [61.6621569, 25.4739234],
              [61.6628395, 25.4797788],
              [61.6636988, 25.4866648],
              [61.6641602, 25.4893552],
              [61.6654358, 25.491449],
              [61.6664583, 25.5025642],
              [61.6665699, 25.5088796],
              [61.6668274, 25.5142061],
              [61.6671256, 25.5211812],
              [61.6670784, 25.5277648],
              [61.6749572, 25.6257472],
              [61.6754623, 25.6320263],
              [61.676523, 25.64521],
              [61.676361, 25.645247],
              [61.676121, 25.645501],
              [61.675831, 25.645623],
              [61.67584, 25.645789],
              [61.675881, 25.645817],
              [61.675812, 25.64588],
              [61.675779, 25.645999],
              [61.675853, 25.646056],
              [61.675848, 25.646271],
              [61.675977, 25.646307],
              [61.675979, 25.646455],
              [61.67589, 25.64647],
              [61.675845, 25.64658],
              [61.675679, 25.646538],
              [61.675751, 25.646641],
              [61.675547, 25.646852],
              [61.675657, 25.646883],
              [61.675643, 25.646931],
              [61.675353, 25.647049],
              [61.67517, 25.647043],
              [61.675117, 25.646969],
              [61.674958, 25.647004],
              [61.674883, 25.647175],
              [61.674565, 25.646977],
              [61.674508, 25.646988],
              [61.674444, 25.647065],
              [61.674493, 25.647131],
              [61.674259, 25.647224],
              [61.67428, 25.647166],
              [61.674227, 25.647081],
              [61.674133, 25.647142],
              [61.674043, 25.647066],
              [61.673928, 25.647126],
              [61.673751, 25.647033],
              [61.673559, 25.647097],
              [61.67343, 25.646996],
              [61.673345, 25.647022],
              [61.673289, 25.646957],
              [61.672792, 25.646891],
              [61.672642, 25.647321],
              [61.672334, 25.647707],
              [61.672325, 25.647835],
              [61.672451, 25.647904],
              [61.672744, 25.648246],
              [61.672997, 25.648294],
              [61.673083, 25.648373],
              [61.673277, 25.648294],
              [61.673873, 25.64873],
              [61.67395, 25.648916],
              [61.674002, 25.648954],
              [61.674092, 25.648931],
              [61.674136, 25.649104],
              [61.674066, 25.649376],
              [61.674127, 25.649558],
              [61.674061, 25.649784],
              [61.674259, 25.649941],
              [61.674639, 25.650104],
              [61.675044, 25.649987],
              [61.675153, 25.649975],
              [61.675107, 25.650074],
              [61.675158, 25.650097],
              [61.675333, 25.650069],
              [61.675372, 25.650016],
              [61.675517, 25.65009],
              [61.675875, 25.650153],
              [61.676032, 25.650266],
              [61.676211, 25.6503],
              [61.676349, 25.65041],
              [61.676523, 25.650442],
              [61.676624, 25.650529],
              [61.676849, 25.651059],
              [61.677034, 25.65105],
              [61.677304, 25.651206],
              [61.67732, 25.651257],
              [61.677496, 25.651284],
              [61.677609, 25.65135],
              [61.678058, 25.651675],
              [61.678082, 25.651734],
              [61.678044, 25.651768],
              [61.678133, 25.651862],
              [61.678356, 25.651818],
              [61.678458, 25.651958],
              [61.678724, 25.652141],
              [61.678772, 25.652265],
              [61.678917, 25.652258],
              [61.678997, 25.65239],
              [61.679261, 25.652451],
              [61.679277, 25.652525],
              [61.679569, 25.652799],
              [61.679531, 25.652854],
              [61.679553, 25.652922],
              [61.679479, 25.652972],
              [61.679502, 25.65311],
              [61.679385, 25.653091],
              [61.679322, 25.653297],
              [61.679072, 25.6537],
              [61.678994, 25.653994],
              [61.678765, 25.654123],
              [61.678599, 25.654349],
              [61.678579, 25.654663],
              [61.678637, 25.65492],
              [61.67863, 25.655272],
              [61.678693, 25.655495],
              [61.678649, 25.655524],
              [61.678784, 25.655943],
              [61.678744, 25.656206],
              [61.67878, 25.656276],
              [61.678728, 25.656382],
              [61.678844, 25.656828],
              [61.678808, 25.657118],
              [61.678839, 25.657177],
              [61.678665, 25.657493],
              [61.678695, 25.65778],
              [61.678654, 25.658006],
              [61.678688, 25.658009],
              [61.67867, 25.658052],
              [61.678726, 25.658091],
              [61.678771, 25.658254],
              [61.678685, 25.658256],
              [61.678721, 25.658335],
              [61.679202, 25.658353],
              [61.679295, 25.658485],
              [61.67953, 25.6585],
              [61.679493, 25.658926],
              [61.679541, 25.65905],
              [61.679513, 25.659095],
              [61.679597, 25.659256],
              [61.679528, 25.659366],
              [61.679566, 25.659443],
              [61.679977, 25.659765],
              [61.679916, 25.659989],
              [61.680018, 25.660241],
              [61.680111, 25.660294],
              [61.680113, 25.660403],
              [61.680165, 25.660445],
              [61.680115, 25.660527],
              [61.680137, 25.660589],
              [61.680314, 25.660702],
              [61.680403, 25.660872],
              [61.680477, 25.660919],
              [61.680675, 25.66098],
              [61.680814, 25.660937],
              [61.681203, 25.660996],
              [61.681282, 25.661043],
              [61.681344, 25.661004],
              [61.681488, 25.661004],
              [61.681588, 25.661054],
              [61.681658, 25.661032],
              [61.68171, 25.661146],
              [61.682015, 25.661327],
              [61.682583, 25.661435],
              [61.682803, 25.661695],
              [61.683008, 25.661697],
              [61.683061, 25.661618],
              [61.683162, 25.661598],
              [61.683243, 25.661623],
              [61.683369, 25.661508],
              [61.68357, 25.661695],
              [61.683639, 25.661653],
              [61.683804, 25.661724],
              [61.683817, 25.661801],
              [61.68407, 25.661761],
              [61.684312, 25.66187],
              [61.684373, 25.661952],
              [61.684534, 25.661935],
              [61.684546, 25.661901],
              [61.684655, 25.661958],
              [61.684768, 25.661943],
              [61.684996, 25.662216],
              [61.685156, 25.662209],
              [61.685151, 25.662433],
              [61.685296, 25.662463],
              [61.685538, 25.662595],
              [61.685803, 25.662548],
              [61.686139, 25.662675],
              [61.686052, 25.662793],
              [61.686051, 25.662913],
              [61.686248, 25.663044],
              [61.686399, 25.663449],
              [61.686273, 25.663471],
              [61.686045, 25.663694],
              [61.686057, 25.663745],
              [61.685963, 25.663843],
              [61.685973, 25.66392],
              [61.685914, 25.66394],
              [61.685889, 25.664079],
              [61.685805, 25.664096],
              [61.685937, 25.664254],
              [61.686113, 25.664197],
              [61.686134, 25.664254],
              [61.686296, 25.664302],
              [61.68681, 25.664277],
              [61.686954, 25.664363],
              [61.687128, 25.664363],
              [61.68736, 25.664517],
              [61.687347, 25.664619],
              [61.687554, 25.66463],
              [61.687675, 25.664731],
              [61.687875, 25.66472],
              [61.687992, 25.664778],
              [61.688525, 25.664826],
              [61.688654, 25.664885],
              [61.688777, 25.66487],
              [61.689099, 25.664976],
              [61.689342, 25.665136],
              [61.689455, 25.665121],
              [61.689659, 25.665243],
              [61.689843, 25.66516],
              [61.689912, 25.665222],
              [61.689867, 25.665292],
              [61.689959, 25.665295],
              [61.690018, 25.665444],
              [61.690099, 25.665444],
              [61.690132, 25.665547],
              [61.690209, 25.665543],
              [61.690183, 25.665573],
              [61.690306, 25.665649],
              [61.690508, 25.665491],
              [61.690771, 25.665403],
              [61.691341, 25.665364],
              [61.692268, 25.665503],
              [61.692419, 25.66543],
              [61.69271, 25.665458],
              [61.692788, 25.665591],
              [61.692917, 25.665612],
              [61.69284, 25.665674],
              [61.692848, 25.665743],
              [61.692941, 25.665743],
              [61.69295, 25.665838],
              [61.693115, 25.665851],
              [61.693443, 25.666088],
              [61.693628, 25.666137],
              [61.693717, 25.666115],
              [61.693819, 25.666232],
              [61.694224, 25.666337],
              [61.694689, 25.666632],
              [61.69469, 25.666713],
              [61.694788, 25.666849],
              [61.695183, 25.66694],
              [61.695338, 25.667059],
              [61.695336, 25.667103],
              [61.695588, 25.667191],
              [61.695525, 25.667307],
              [61.695563, 25.667328],
              [61.695595, 25.667559],
              [61.695681, 25.667674],
              [61.695628, 25.667706],
              [61.695681, 25.667866],
              [61.695732, 25.667897],
              [61.695951, 25.667861],
              [61.69629, 25.667996],
              [61.696103, 25.668302],
              [61.696085, 25.668479],
              [61.696126, 25.668551],
              [61.695895, 25.668926],
              [61.695579, 25.66889],
              [61.695816, 25.66932],
              [61.695763, 25.669552],
              [61.695464, 25.669618],
              [61.694883, 25.669906],
              [61.694773, 25.670046],
              [61.694777, 25.67011],
              [61.694675, 25.670151],
              [61.694693, 25.670185],
              [61.694633, 25.670232],
              [61.694627, 25.67034],
              [61.694525, 25.670539],
              [61.69456, 25.670988],
              [61.694352, 25.67134],
              [61.694405, 25.671442],
              [61.694315, 25.671625],
              [61.694208, 25.671713],
              [61.694144, 25.672346],
              [61.693813, 25.672585],
              [61.69308, 25.672602],
              [61.692967, 25.672663],
              [61.692714, 25.672949],
              [61.692749, 25.673082],
              [61.692691, 25.67325],
              [61.692502, 25.673332],
              [61.692409, 25.673606],
              [61.692447, 25.673741],
              [61.692518, 25.673809],
              [61.692488, 25.673864],
              [61.692535, 25.673927],
              [61.6925341, 25.6741163],
              [61.692534, 25.674148],
              [61.692509, 25.674229],
              [61.692396, 25.674211],
              [61.692413, 25.674297],
              [61.692371, 25.674357],
              [61.692737, 25.674567],
              [61.692835, 25.674768],
              [61.692621, 25.674796],
              [61.692632, 25.674897],
              [61.692453, 25.675427],
              [61.692335, 25.675417],
              [61.692306, 25.675457],
              [61.692365, 25.675498],
              [61.692236, 25.675618],
              [61.692074, 25.675607],
              [61.691984, 25.675743],
              [61.691865, 25.675778],
              [61.691837, 25.675711],
              [61.691715, 25.675695],
              [61.691672, 25.675749],
              [61.691502, 25.675723],
              [61.691365, 25.675789],
              [61.691359, 25.675908],
              [61.691194, 25.676049],
              [61.691163, 25.676128],
              [61.691241, 25.676156],
              [61.691301, 25.67629],
              [61.6913413, 25.6762875],
              [61.691383, 25.676285],
              [61.691418, 25.676325],
              [61.691516, 25.67657],
              [61.691565, 25.676599],
              [61.691594, 25.676737],
              [61.691541, 25.676907],
              [61.691444, 25.677093],
              [61.691299, 25.677056],
              [61.691249, 25.677259],
              [61.691346, 25.6773],
              [61.691404, 25.677411],
              [61.691404, 25.677722],
              [61.691596, 25.677816],
              [61.69163, 25.677887],
              [61.691592, 25.677954],
              [61.691736, 25.678044],
              [61.691688, 25.678166],
              [61.691618, 25.678216],
              [61.691894, 25.678342],
              [61.69217, 25.678312],
              [61.692322, 25.678415],
              [61.692458, 25.678438],
              [61.692764, 25.678368],
              [61.692879, 25.678578],
              [61.692857, 25.678795],
              [61.692739, 25.678876],
              [61.692609, 25.67914],
              [61.692495, 25.679239],
              [61.692449, 25.679228],
              [61.692471, 25.679292],
              [61.69241, 25.679321],
              [61.692468, 25.679388],
              [61.692467, 25.679485],
              [61.692575, 25.679552],
              [61.692519, 25.67965],
              [61.692595, 25.679706],
              [61.692581, 25.67979],
              [61.692432, 25.679916],
              [61.692429, 25.680093],
              [61.692366, 25.680136],
              [61.692378, 25.68018],
              [61.692458, 25.680155],
              [61.692633, 25.680303],
              [61.692716, 25.680312],
              [61.692824, 25.680444],
              [61.692942, 25.680428],
              [61.693049, 25.680502],
              [61.693025, 25.680564],
              [61.693097, 25.680672],
              [61.693238, 25.680633],
              [61.693337, 25.680739],
              [61.693389, 25.680697],
              [61.693603, 25.680706],
              [61.693592, 25.680657],
              [61.693798, 25.680656],
              [61.693939, 25.680754],
              [61.694101, 25.680719],
              [61.694118, 25.680762],
              [61.694161, 25.680752],
              [61.694194, 25.680865],
              [61.694341, 25.680856],
              [61.694551, 25.680714],
              [61.694768, 25.680834],
              [61.694795, 25.680897],
              [61.695026, 25.680893],
              [61.695388, 25.680707],
              [61.69547, 25.680621],
              [61.69595, 25.680609],
              [61.696015, 25.680811],
              [61.695954, 25.680852],
              [61.696017, 25.680943],
              [61.696006, 25.681151],
              [61.696063, 25.681283],
              [61.696003, 25.681395],
              [61.696084, 25.681465],
              [61.696143, 25.681737],
              [61.696036, 25.68197],
              [61.696025, 25.682155],
              [61.696084, 25.682372],
              [61.696245, 25.682495],
              [61.696178, 25.683049],
              [61.695967, 25.683188],
              [61.695912, 25.683416],
              [61.695586, 25.683638],
              [61.695795, 25.684007],
              [61.695931, 25.684062],
              [61.696044, 25.684307],
              [61.696037, 25.684387],
              [61.696153, 25.684444],
              [61.696164, 25.684783],
              [61.696071, 25.685022],
              [61.695882, 25.685245],
              [61.695654, 25.685322],
              [61.695537, 25.685566],
              [61.695443, 25.685587],
              [61.695503, 25.68565],
              [61.69542, 25.685709],
              [61.69505, 25.685815],
              [61.694877, 25.685786],
              [61.694645, 25.685822],
              [61.694607, 25.685789],
              [61.694537, 25.685891],
              [61.694464, 25.685872],
              [61.694324, 25.685957],
              [61.69426, 25.686244],
              [61.69413, 25.686281],
              [61.693903, 25.686497],
              [61.693833, 25.686509],
              [61.69386, 25.686801],
              [61.693722, 25.687018],
              [61.693667, 25.687264],
              [61.693554, 25.687347],
              [61.693572, 25.687406],
              [61.693487, 25.687567],
              [61.693494, 25.687622],
              [61.693775, 25.687756],
              [61.693893, 25.687754],
              [61.693959, 25.687856],
              [61.694036, 25.687884],
              [61.694221, 25.68846],
              [61.69417, 25.688615],
              [61.694191, 25.688764],
              [61.694271, 25.688873],
              [61.694279, 25.689144],
              [61.694395, 25.689525],
              [61.694398, 25.68981],
              [61.694487, 25.690058],
              [61.694538, 25.690509],
              [61.694536, 25.690795],
              [61.694426, 25.690853],
              [61.694406, 25.690943],
              [61.694487, 25.691126],
              [61.694479, 25.691225],
              [61.694319, 25.691408],
              [61.694354, 25.691444],
              [61.694256, 25.69206],
              [61.694297, 25.692122],
              [61.694103, 25.692066],
              [61.693953, 25.692087],
              [61.693891, 25.691966],
              [61.693817, 25.691942],
              [61.693733, 25.69204],
              [61.693331, 25.692129],
              [61.693284, 25.692207],
              [61.69304, 25.692372],
              [61.692585, 25.69254],
              [61.692385, 25.692594],
              [61.69232, 25.692573],
              [61.692036, 25.692748],
              [61.691795, 25.692976],
              [61.69167, 25.693007],
              [61.691445, 25.693185],
              [61.691424, 25.693249],
              [61.691342, 25.693289],
              [61.691367, 25.693464],
              [61.69149, 25.693528],
              [61.691691, 25.693423],
              [61.691759, 25.693446],
              [61.691957, 25.693205],
              [61.69222, 25.693017],
              [61.692331, 25.693058],
              [61.692564, 25.693038],
              [61.692589, 25.692994],
              [61.692609, 25.693084],
              [61.692954, 25.693125],
              [61.692958, 25.693243],
              [61.693016, 25.693321],
              [61.693242, 25.693493],
              [61.6936, 25.693604],
              [61.693932, 25.693632],
              [61.694181, 25.693818],
              [61.694436, 25.693511],
              [61.694586, 25.693506],
              [61.694677, 25.693562],
              [61.694815, 25.693482],
              [61.69487, 25.69311],
              [61.695102, 25.69297],
              [61.695142, 25.692891],
              [61.695405, 25.69268],
              [61.69552, 25.692674],
              [61.695527, 25.692617],
              [61.695963, 25.692343],
              [61.696021, 25.692219],
              [61.69675, 25.691936],
              [61.697157, 25.691904],
              [61.697357, 25.691768],
              [61.697583, 25.691684],
              [61.697907, 25.691611],
              [61.69799, 25.691631],
              [61.698136, 25.69155],
              [61.698609, 25.691418],
              [61.698742, 25.691358],
              [61.698962, 25.691057],
              [61.69911, 25.690996],
              [61.69944, 25.690936],
              [61.699699, 25.690944],
              [61.699735, 25.690991],
              [61.699899, 25.690977],
              [61.699954, 25.690944],
              [61.699879, 25.690915],
              [61.699976, 25.690905],
              [61.700092, 25.691006],
              [61.700336, 25.690889],
              [61.700658, 25.690637],
              [61.70088, 25.690578],
              [61.70109, 25.690606],
              [61.701264, 25.690728],
              [61.701465, 25.69071],
              [61.701692, 25.690858],
              [61.701988, 25.690882],
              [61.702241, 25.690971],
              [61.702363, 25.690933],
              [61.703042, 25.690928],
              [61.703531, 25.690967],
              [61.703985, 25.690902],
              [61.704032, 25.691065],
              [61.703817, 25.691367],
              [61.703861, 25.691541],
              [61.70402, 25.691573],
              [61.704795, 25.69202],
              [61.704894, 25.692121],
              [61.704897, 25.692218],
              [61.704988, 25.692283],
              [61.704969, 25.692368],
              [61.705136, 25.692424],
              [61.705351, 25.692637],
              [61.705536, 25.692744],
              [61.705603, 25.692714],
              [61.705678, 25.692754],
              [61.705975, 25.693067],
              [61.706136, 25.693131],
              [61.706345, 25.693498],
              [61.706372, 25.693821],
              [61.706137, 25.694068],
              [61.706188, 25.69424],
              [61.706138, 25.694321],
              [61.706241, 25.6947],
              [61.706218, 25.694764],
              [61.706165, 25.694774],
              [61.706139, 25.694887],
              [61.706163, 25.695124],
              [61.706123, 25.695185],
              [61.706201, 25.695259],
              [61.706122, 25.695405],
              [61.706218, 25.695481],
              [61.70625, 25.695578],
              [61.705988, 25.696053],
              [61.70597, 25.696421],
              [61.705688, 25.696481],
              [61.705385, 25.696706],
              [61.705279, 25.696718],
              [61.70509, 25.696834],
              [61.705252, 25.697298],
              [61.705249, 25.697697],
              [61.70521, 25.697795],
              [61.70533, 25.697799],
              [61.705446, 25.697877],
              [61.70567, 25.698141],
              [61.70585, 25.698261],
              [61.706033, 25.698488],
              [61.706016, 25.698612],
              [61.706111, 25.698642],
              [61.706305, 25.698842],
              [61.706291, 25.698907],
              [61.706545, 25.699192],
              [61.706547, 25.699255],
              [61.706682, 25.699396],
              [61.706696, 25.699514],
              [61.706853, 25.699733],
              [61.707054, 25.699918],
              [61.707305, 25.69999],
              [61.707545, 25.700259],
              [61.707665, 25.700219],
              [61.707802, 25.700393],
              [61.707906, 25.700312],
              [61.70806, 25.700438],
              [61.708066, 25.700688],
              [61.708242, 25.700673],
              [61.708291, 25.700757],
              [61.708381, 25.700788],
              [61.708437, 25.700936],
              [61.708468, 25.700891],
              [61.7086, 25.700919],
              [61.708726, 25.700873],
              [61.708976, 25.700983],
              [61.709484, 25.70085],
              [61.70957, 25.700907],
              [61.709582, 25.70096],
              [61.7095, 25.701093],
              [61.709455, 25.701544],
              [61.709591, 25.701618],
              [61.709566, 25.701708],
              [61.709612, 25.70179],
              [61.709822, 25.701847],
              [61.710227, 25.701785],
              [61.710323, 25.701729],
              [61.710459, 25.701468],
              [61.710674, 25.701672],
              [61.711029, 25.701408],
              [61.711075, 25.701458],
              [61.711024, 25.701499],
              [61.711054, 25.701598],
              [61.710962, 25.702067],
              [61.710696, 25.702536],
              [61.710667, 25.70291],
              [61.711102, 25.703636],
              [61.711632, 25.703811],
              [61.711696, 25.70396],
              [61.711799, 25.703993],
              [61.711952, 25.703943],
              [61.712138, 25.70397],
              [61.712227, 25.70405],
              [61.712298, 25.703984],
              [61.712369, 25.703997],
              [61.712487, 25.704524],
              [61.712864, 25.704704],
              [61.712879, 25.704771],
              [61.712994, 25.704856],
              [61.71305, 25.705321],
              [61.712987, 25.705388],
              [61.713287, 25.705528],
              [61.713243, 25.705684],
              [61.713386, 25.705703],
              [61.713414, 25.705768],
              [61.713347, 25.705866],
              [61.713429, 25.706162],
              [61.713525, 25.706375],
              [61.713605, 25.70644],
              [61.713702, 25.706713],
              [61.713632, 25.706918],
              [61.713635, 25.707159],
              [61.713565, 25.707315],
              [61.714063, 25.708035],
              [61.714154, 25.70788],
              [61.714513, 25.707817],
              [61.714628, 25.708011],
              [61.715038, 25.708171],
              [61.715535, 25.708451],
              [61.715866, 25.708555],
              [61.716066, 25.708555],
              [61.716267, 25.708661],
              [61.716945, 25.708868],
              [61.71711, 25.708999],
              [61.717271, 25.709026],
              [61.717333, 25.709224],
              [61.717387, 25.70925],
              [61.717493, 25.709219],
              [61.717548, 25.709314],
              [61.717764, 25.709288],
              [61.717955, 25.709366],
              [61.718129, 25.709328],
              [61.718263, 25.709196],
              [61.718607, 25.709154],
              [61.718699, 25.709224],
              [61.719063, 25.709158],
              [61.71918, 25.709198],
              [61.719218, 25.709265],
              [61.719512, 25.709177],
              [61.719921, 25.709179],
              [61.719884, 25.70913],
              [61.719972, 25.709156],
              [61.719985, 25.70921],
              [61.720242, 25.709132],
              [61.720831, 25.709047],
              [61.721008, 25.709171],
              [61.721151, 25.709206],
              [61.721254, 25.709183],
              [61.721434, 25.709407],
              [61.72183, 25.709462],
              [61.722277, 25.709777],
              [61.722456, 25.709811],
              [61.722682, 25.709783],
              [61.722883, 25.709857],
              [61.723124, 25.709871],
              [61.723277, 25.709804],
              [61.723432, 25.709833],
              [61.723389, 25.709855],
              [61.723404, 25.709911],
              [61.723495, 25.709904],
              [61.723571, 25.710078],
              [61.723701, 25.710227],
              [61.723842, 25.710286],
              [61.723841, 25.710347],
              [61.723921, 25.71035],
              [61.723845, 25.71045],
              [61.723769, 25.710717],
              [61.723809, 25.710754],
              [61.723755, 25.710853],
              [61.723817, 25.710976],
              [61.723853, 25.710976],
              [61.723912, 25.710846],
              [61.72415, 25.710835],
              [61.724253, 25.711023],
              [61.724395, 25.711073],
              [61.72477, 25.711037],
              [61.72484, 25.711098],
              [61.72544, 25.711074],
              [61.725805, 25.711202],
              [61.726143, 25.711182],
              [61.726108, 25.711141],
              [61.72616, 25.711092],
              [61.726362, 25.711038],
              [61.726322, 25.71126],
              [61.726367, 25.711365],
              [61.726247, 25.711518],
              [61.726338, 25.711689],
              [61.726534, 25.711793],
              [61.726648, 25.711799],
              [61.726605, 25.711848],
              [61.726695, 25.711915],
              [61.726889, 25.711956],
              [61.727184, 25.71196],
              [61.72769, 25.711885],
              [61.727578, 25.712083],
              [61.727609, 25.712171],
              [61.727515, 25.712295],
              [61.72764, 25.712402],
              [61.727834, 25.712457],
              [61.728018, 25.712938],
              [61.728215, 25.712892],
              [61.728399, 25.712904],
              [61.728362, 25.713218],
              [61.728403, 25.713283],
              [61.728346, 25.713366],
              [61.728637, 25.713406],
              [61.729033, 25.713332],
              [61.729264, 25.713544],
              [61.729431, 25.713611],
              [61.729377, 25.713829],
              [61.729623, 25.714095],
              [61.729629, 25.714369],
              [61.729737, 25.714502],
              [61.7297, 25.714727],
              [61.729927, 25.714954],
              [61.729971, 25.715111],
              [61.729959, 25.715232],
              [61.729899, 25.715252],
              [61.729925, 25.715337],
              [61.730037, 25.715477],
              [61.730386, 25.715748],
              [61.730524, 25.715932],
              [61.729918, 25.716138],
              [61.729911, 25.716205],
              [61.729535, 25.716346],
              [61.729158, 25.716364],
              [61.728902, 25.716524],
              [61.728871, 25.716555],
              [61.728908, 25.716854],
              [61.729017, 25.717048],
              [61.729004, 25.717156],
              [61.729066, 25.717189],
              [61.72893, 25.717288],
              [61.728947, 25.717414],
              [61.728915, 25.717432],
              [61.728655, 25.717522],
              [61.728503, 25.717462],
              [61.728182, 25.717573],
              [61.727643, 25.717638],
              [61.7274, 25.717713],
              [61.727303, 25.717881],
              [61.727243, 25.717894],
              [61.727178, 25.7179],
              [61.727082, 25.717819],
              [61.727121, 25.717812],
              [61.727105, 25.717765],
              [61.727025, 25.71773],
              [61.726607, 25.717724],
              [61.726494, 25.717775],
              [61.726411, 25.717902],
              [61.726487, 25.717919],
              [61.726423, 25.718062],
              [61.726483, 25.718119],
              [61.726438, 25.718277],
              [61.726483, 25.718391],
              [61.726724, 25.718518],
              [61.726933, 25.718504],
              [61.726899, 25.718674],
              [61.727154, 25.71899],
              [61.727146, 25.719086],
              [61.72724, 25.719149],
              [61.727177, 25.719413],
              [61.726612, 25.719436],
              [61.726534, 25.719396],
              [61.726315, 25.71939],
              [61.726155, 25.719559],
              [61.726073, 25.719817],
              [61.726003, 25.719813],
              [61.726004, 25.719935],
              [61.725947, 25.719933],
              [61.725885, 25.720017],
              [61.726096, 25.72008],
              [61.727182, 25.72021],
              [61.727202, 25.720347],
              [61.727509, 25.720647],
              [61.727489, 25.720986],
              [61.727531, 25.721338],
              [61.727707, 25.72148],
              [61.727638, 25.721535],
              [61.727691, 25.721596],
              [61.72768, 25.721811],
              [61.72772, 25.721872],
              [61.727841, 25.721879],
              [61.727906, 25.722067],
              [61.727952, 25.722523],
              [61.727895, 25.722566],
              [61.728272, 25.722776],
              [61.728509, 25.722828],
              [61.728646, 25.722933],
              [61.728643, 25.723065],
              [61.728481, 25.723375],
              [61.728509, 25.723605],
              [61.728341, 25.723815],
              [61.728321, 25.723926],
              [61.72812, 25.724028],
              [61.728047, 25.724139],
              [61.72816, 25.724253],
              [61.728152, 25.724416],
              [61.728094, 25.724485],
              [61.728217, 25.724846],
              [61.727754, 25.725049],
              [61.727673, 25.725031],
              [61.727644, 25.725181],
              [61.72759, 25.7252],
              [61.72751, 25.725393],
              [61.727288, 25.725624],
              [61.727063, 25.725669],
              [61.726719, 25.725877],
              [61.726347, 25.726002],
              [61.725615, 25.726065],
              [61.725228, 25.726201],
              [61.725016, 25.726192],
              [61.725023, 25.726315],
              [61.725122, 25.726511],
              [61.725115, 25.726611],
              [61.725284, 25.726724],
              [61.725297, 25.726811],
              [61.72543, 25.726823],
              [61.725533, 25.726936],
              [61.725627, 25.726924],
              [61.725677, 25.727014],
              [61.725646, 25.727024],
              [61.725746, 25.727079],
              [61.725632, 25.727498],
              [61.725671, 25.727545],
              [61.725915, 25.727584],
              [61.72638, 25.727518],
              [61.726463, 25.727696],
              [61.726617, 25.727699],
              [61.726811, 25.727829],
              [61.726949, 25.728332],
              [61.727218, 25.728369],
              [61.727405, 25.728468],
              [61.727863, 25.728514],
              [61.727957, 25.728633],
              [61.728684, 25.728704],
              [61.728562, 25.728815],
              [61.728686, 25.728842],
              [61.728641, 25.728899],
              [61.728448, 25.72894],
              [61.728457, 25.729021],
              [61.728355, 25.729121],
              [61.728356, 25.729156],
              [61.728416, 25.729141],
              [61.728728, 25.72925],
              [61.728704, 25.729538],
              [61.728612, 25.729596],
              [61.728567, 25.729808],
              [61.728564, 25.729987],
              [61.72861, 25.730078],
              [61.728752, 25.730214],
              [61.729012, 25.730342],
              [61.729055, 25.730571],
              [61.729219, 25.730735],
              [61.729325, 25.730981],
              [61.729457, 25.731139],
              [61.729755, 25.731288],
              [61.729907, 25.731237],
              [61.730087, 25.731104],
              [61.730309, 25.731157],
              [61.730427, 25.731582],
              [61.730472, 25.731609],
              [61.730486, 25.73178],
              [61.730391, 25.731865],
              [61.730527, 25.731932],
              [61.730774, 25.732353],
              [61.73099, 25.73247],
              [61.731096, 25.732451],
              [61.731253, 25.732501],
              [61.731225, 25.732635],
              [61.731256, 25.732676],
              [61.731631, 25.73295],
              [61.731785, 25.732984],
              [61.732073, 25.733208],
              [61.732422, 25.733193],
              [61.732727, 25.73312],
              [61.732975, 25.733243],
              [61.733063, 25.733572],
              [61.733062, 25.733854],
              [61.733368, 25.734023],
              [61.733173, 25.734163],
              [61.733085, 25.734171],
              [61.732971, 25.734098],
              [61.73283, 25.734169],
              [61.732837, 25.734234],
              [61.733314, 25.735114],
              [61.733231, 25.735248],
              [61.733114, 25.735295],
              [61.732917, 25.735547],
              [61.732793, 25.735616],
              [61.73277, 25.735695],
              [61.732597, 25.735803],
              [61.732601, 25.735864],
              [61.732513, 25.735928],
              [61.732377, 25.73622],
              [61.732393, 25.736264],
              [61.732286, 25.736407],
              [61.732307, 25.736443],
              [61.732231, 25.736576],
              [61.732147, 25.736598],
              [61.732159, 25.736641],
              [61.732074, 25.736747],
              [61.732117, 25.736852],
              [61.732217, 25.736888],
              [61.732265, 25.736972],
              [61.732384, 25.736936],
              [61.732543, 25.737123],
              [61.732299, 25.737653],
              [61.732383, 25.737709],
              [61.732666, 25.737739],
              [61.732729, 25.737812],
              [61.73285, 25.737846],
              [61.732911, 25.73792],
              [61.732924, 25.738063],
              [61.732953, 25.738046],
              [61.733181, 25.738461],
              [61.733184, 25.738716],
              [61.732914, 25.738797],
              [61.732937, 25.738894],
              [61.733005, 25.73891],
              [61.732953, 25.73917],
              [61.733031, 25.739227],
              [61.733057, 25.739351],
              [61.733037, 25.739615],
              [61.733396, 25.739718],
              [61.733538, 25.739888],
              [61.733591, 25.739852],
              [61.733704, 25.739917],
              [61.734151, 25.739986],
              [61.734199, 25.740078],
              [61.734159, 25.740151],
              [61.734424, 25.740351],
              [61.734632, 25.740358],
              [61.734703, 25.74054],
              [61.734635, 25.740597],
              [61.73493, 25.740789],
              [61.735241, 25.740732],
              [61.735558, 25.740788],
              [61.735989, 25.740738],
              [61.736041, 25.740797],
              [61.736238, 25.741452],
              [61.736104, 25.741579],
              [61.736299, 25.741603],
              [61.736329, 25.74172],
              [61.73651, 25.74172],
              [61.736912, 25.741558],
              [61.73752, 25.741462],
              [61.738262, 25.74105],
              [61.738537, 25.741055],
              [61.738961, 25.740945],
              [61.739425, 25.740647],
              [61.739436, 25.740507],
              [61.739569, 25.740204],
              [61.739955, 25.740139],
              [61.740151, 25.739984],
              [61.740202, 25.739884],
              [61.740464, 25.739802],
              [61.740663, 25.739486],
              [61.740858, 25.739294],
              [61.740888, 25.739031],
              [61.74106, 25.738651],
              [61.741665, 25.738122],
              [61.741567, 25.737719],
              [61.741619, 25.737623],
              [61.741602, 25.737462],
              [61.741669, 25.737347],
              [61.742133, 25.737342],
              [61.74236, 25.737164],
              [61.742593, 25.737099],
              [61.7426, 25.737011],
              [61.742827, 25.737021],
              [61.743258, 25.736755],
              [61.743314, 25.736644],
              [61.743524, 25.736623],
              [61.743622, 25.736528],
              [61.743642, 25.736443],
              [61.743988, 25.736149],
              [61.74397, 25.736106],
              [61.744019, 25.736085],
              [61.743991, 25.735893],
              [61.744049, 25.735799],
              [61.74399, 25.735692],
              [61.744199, 25.735669],
              [61.744204, 25.735555],
              [61.744337, 25.735504],
              [61.744394, 25.735332],
              [61.744527, 25.73532],
              [61.744557, 25.735033],
              [61.744461, 25.734921],
              [61.744458, 25.734851],
              [61.744541, 25.734813],
              [61.744564, 25.73453],
              [61.744665, 25.734491],
              [61.744649, 25.734445],
              [61.744868, 25.734202],
              [61.745013, 25.733906],
              [61.745459, 25.733685],
              [61.745594, 25.73356],
              [61.74567, 25.733404],
              [61.745841, 25.733359],
              [61.746151, 25.733145],
              [61.74638, 25.733119],
              [61.746553, 25.733041],
              [61.74662, 25.733074],
              [61.747177, 25.733084],
              [61.747533, 25.733189],
              [61.747587, 25.73318],
              [61.747588, 25.733137],
              [61.747748, 25.733123],
              [61.74777, 25.733185],
              [61.747821, 25.733195],
              [61.747902, 25.733159],
              [61.748101, 25.733171],
              [61.748097, 25.73323],
              [61.748183, 25.733225],
              [61.748288, 25.733136],
              [61.748339, 25.73319],
              [61.748438, 25.733201],
              [61.748692, 25.732931],
              [61.748759, 25.732933],
              [61.74883, 25.732867],
              [61.749006, 25.73292],
              [61.749143, 25.732905],
              [61.749502, 25.732626],
              [61.749553, 25.732645],
              [61.749626, 25.73259],
              [61.749819, 25.73257],
              [61.749968, 25.732607],
              [61.750143, 25.73255],
              [61.750446, 25.732579],
              [61.750685, 25.73267],
              [61.750777, 25.732549],
              [61.751025, 25.732432],
              [61.751469, 25.73234],
              [61.751666, 25.732209],
              [61.751861, 25.732235],
              [61.75196, 25.732199],
              [61.751998, 25.73223],
              [61.752097, 25.732175],
              [61.752316, 25.73215],
              [61.752336, 25.732189],
              [61.752426, 25.732182],
              [61.752443, 25.732231],
              [61.752534, 25.732206],
              [61.752884, 25.732261],
              [61.7534, 25.732217],
              [61.753536, 25.732249],
              [61.753695, 25.732038],
              [61.75385, 25.731954],
              [61.754404, 25.731941],
              [61.75463, 25.731859],
              [61.754755, 25.731912],
              [61.755065, 25.731754],
              [61.755575, 25.731729],
              [61.756044, 25.731572],
              [61.75621, 25.73158],
              [61.756337, 25.731511],
              [61.756674, 25.731578],
              [61.757073, 25.731512],
              [61.75716, 25.7316],
              [61.757289, 25.731624],
              [61.757788, 25.731662],
              [61.758105, 25.73163],
              [61.758213, 25.731667],
              [61.758376, 25.731577],
              [61.758708, 25.731542],
              [61.758705, 25.731508],
              [61.758889, 25.731431],
              [61.759162, 25.731462],
              [61.759346, 25.73157],
              [61.759462, 25.731564],
              [61.759884, 25.731705],
              [61.760106, 25.731718],
              [61.760518, 25.731896],
              [61.760685, 25.732061],
              [61.761009, 25.731995],
              [61.761073, 25.732026],
              [61.761168, 25.731987],
              [61.761295, 25.732017],
              [61.76144, 25.731991],
              [61.76168, 25.732162],
              [61.761876, 25.732174],
              [61.761883, 25.732225],
              [61.762126, 25.732299],
              [61.762075, 25.732322],
              [61.762073, 25.732379],
              [61.762229, 25.732488],
              [61.762391, 25.732494],
              [61.76269, 25.732638],
              [61.762696, 25.732443],
              [61.76276, 25.732431],
              [61.762775, 25.732302],
              [61.763149, 25.732325],
              [61.763143, 25.732214],
              [61.763282, 25.732133],
              [61.763551, 25.732231],
              [61.76374, 25.732045],
              [61.763739, 25.731967],
              [61.763879, 25.732018],
              [61.764012, 25.73191],
              [61.764225, 25.731903],
              [61.764289, 25.731934],
              [61.764294, 25.732045],
              [61.764376, 25.732122],
              [61.764579, 25.732211],
              [61.764567, 25.732117],
              [61.764649, 25.732053],
              [61.76468, 25.731958],
              [61.764996, 25.731823],
              [61.76519, 25.731822],
              [61.765195, 25.731778],
              [61.765262, 25.73179],
              [61.765332, 25.731729],
              [61.765519, 25.73174],
              [61.76594, 25.731621],
              [61.766254, 25.731697],
              [61.766414, 25.731678],
              [61.766471, 25.731738],
              [61.766632, 25.731736],
              [61.766793, 25.731618],
              [61.767369, 25.731657],
              [61.767392, 25.7317],
              [61.76749, 25.731648],
              [61.767847, 25.731676],
              [61.767902, 25.731563],
              [61.768047, 25.731528],
              [61.768073, 25.731474],
              [61.76827, 25.731498],
              [61.7685, 25.731446],
              [61.76872, 25.731215],
              [61.769078, 25.731302],
              [61.769373, 25.73131],
              [61.769617, 25.731413],
              [61.769854, 25.731423],
              [61.770097, 25.731511],
              [61.770558, 25.73158],
              [61.77091, 25.73137],
              [61.771153, 25.731414],
              [61.771403, 25.7314],
              [61.771459, 25.731238],
              [61.771909, 25.731006],
              [61.771914, 25.731049],
              [61.771991, 25.731043],
              [61.772022, 25.731096],
              [61.772246, 25.731073],
              [61.77228, 25.73114],
              [61.772382, 25.731131],
              [61.772524, 25.73119],
              [61.772727, 25.73115],
              [61.772811, 25.731074],
              [61.773027, 25.730991],
              [61.773153, 25.730985],
              [61.773416, 25.73107],
              [61.773729, 25.731056],
              [61.773723, 25.730723],
              [61.773778, 25.730589],
              [61.773686, 25.730411],
              [61.773724, 25.730347],
              [61.773608, 25.730253],
              [61.773678, 25.73002],
              [61.773859, 25.729885],
              [61.773836, 25.729622],
              [61.773714, 25.72942],
              [61.773669, 25.729421],
              [61.773682, 25.729271],
              [61.773444, 25.729433],
              [61.773319, 25.729448],
              [61.773248, 25.729371],
              [61.773094, 25.729316],
              [61.773021, 25.729332],
              [61.772991, 25.729278],
              [61.7729, 25.729285],
              [61.772916, 25.729198],
              [61.772761, 25.729037],
              [61.772769, 25.728987],
              [61.772693, 25.729012],
              [61.772326, 25.728884],
              [61.772291, 25.728787],
              [61.772323, 25.728749],
              [61.772192, 25.728627],
              [61.771989, 25.728568],
              [61.771882, 25.728592],
              [61.771797, 25.728534],
              [61.771396, 25.728439],
              [61.771553, 25.728333],
              [61.771528, 25.7283],
              [61.771382, 25.728268],
              [61.771224, 25.728302],
              [61.771155, 25.728237],
              [61.771032, 25.728233],
              [61.770698, 25.728304],
              [61.770681, 25.728243],
              [61.770492, 25.72823],
              [61.770594, 25.728111],
              [61.770622, 25.727872],
              [61.770912, 25.727656],
              [61.771571, 25.727505],
              [61.771805, 25.727566],
              [61.772003, 25.727536],
              [61.772346, 25.727607],
              [61.772644, 25.72759],
              [61.772745, 25.72744],
              [61.772881, 25.727367],
              [61.772965, 25.727369],
              [61.773344, 25.727187],
              [61.773479, 25.727163],
              [61.773517, 25.727095],
              [61.773608, 25.727135],
              [61.773752, 25.727094],
              [61.773809, 25.726945],
              [61.773944, 25.726867],
              [61.774052, 25.726837],
              [61.77443, 25.726871],
              [61.774653, 25.72673],
              [61.774827, 25.72669],
              [61.77486, 25.726633],
              [61.774646, 25.726504],
              [61.774415, 25.726489],
              [61.774467, 25.726363],
              [61.774431, 25.726033],
              [61.774929, 25.725542],
              [61.774983, 25.725378],
              [61.774907, 25.725187],
              [61.774991, 25.725073],
              [61.775195, 25.72504],
              [61.775195, 25.724868],
              [61.775336, 25.724564],
              [61.775346, 25.72441],
              [61.775532, 25.724234],
              [61.775778, 25.724106],
              [61.775966, 25.72409],
              [61.776181, 25.724115],
              [61.776415, 25.724207],
              [61.776522, 25.724195],
              [61.776703, 25.724105],
              [61.776765, 25.723967],
              [61.77704, 25.723844],
              [61.777427, 25.723979],
              [61.7776, 25.723942],
              [61.777702, 25.72383],
              [61.778032, 25.723713],
              [61.77837, 25.723651],
              [61.778577, 25.723509],
              [61.778595, 25.723278],
              [61.778665, 25.723167],
              [61.778612, 25.723027],
              [61.778822, 25.722865],
              [61.778796, 25.722731],
              [61.779281, 25.722589],
              [61.779518, 25.722442],
              [61.779685, 25.722394],
              [61.779788, 25.722275],
              [61.779953, 25.722227],
              [61.779976, 25.722171],
              [61.780204, 25.722021],
              [61.780278, 25.72186],
              [61.780398, 25.721838],
              [61.780604, 25.721603],
              [61.780677, 25.721578],
              [61.780684, 25.721521],
              [61.780882, 25.721472],
              [61.780981, 25.721325],
              [61.781226, 25.721108],
              [61.781467, 25.721066],
              [61.781553, 25.721006],
              [61.781628, 25.721065],
              [61.782232, 25.721003],
              [61.782387, 25.721046],
              [61.782541, 25.721179],
              [61.7827, 25.721169],
              [61.782761, 25.721243],
              [61.782979, 25.721289],
              [61.783264, 25.721002],
              [61.783568, 25.720915],
              [61.783644, 25.720813],
              [61.783902, 25.720791],
              [61.784335, 25.720599],
              [61.784545, 25.720407],
              [61.784671, 25.720366],
              [61.784898, 25.720188],
              [61.785058, 25.719991],
              [61.785555, 25.719896],
              [61.785743, 25.71975],
              [61.786133, 25.719625],
              [61.786268, 25.719514],
              [61.786395, 25.719501],
              [61.786466, 25.719388],
              [61.786713, 25.719396],
              [61.787027, 25.719275],
              [61.787036, 25.719355],
              [61.787262, 25.719264],
              [61.787386, 25.719279],
              [61.787367, 25.719353],
              [61.787458, 25.71936],
              [61.787646, 25.719287],
              [61.78844, 25.719363],
              [61.788702, 25.719335],
              [61.788805, 25.719392],
              [61.788963, 25.7194],
              [61.789492, 25.719283],
              [61.78951, 25.719237],
              [61.789791, 25.719216],
              [61.790808, 25.71901],
              [61.791098, 25.719046],
              [61.791222, 25.718998],
              [61.791412, 25.719],
              [61.791684, 25.718908],
              [61.79181, 25.718946],
              [61.792071, 25.718816],
              [61.792405, 25.718822],
              [61.792731, 25.71896],
              [61.792844, 25.718951],
              [61.792982, 25.71903],
              [61.793311, 25.719035],
              [61.793446, 25.719077],
              [61.793606, 25.718997],
              [61.793831, 25.719021],
              [61.794003, 25.718979],
              [61.794032, 25.718908],
              [61.794354, 25.718886],
              [61.79451, 25.718659],
              [61.794483, 25.718357],
              [61.794617, 25.718329],
              [61.794574, 25.718221],
              [61.794636, 25.718081],
              [61.795041, 25.718054],
              [61.795439, 25.717963],
              [61.796125, 25.718036],
              [61.796725, 25.718001],
              [61.797262, 25.718035],
              [61.797537, 25.717965],
              [61.798234, 25.717887],
              [61.798361, 25.717907],
              [61.798331, 25.718236],
              [61.798422, 25.718459],
              [61.798368, 25.718558],
              [61.798424, 25.718707],
              [61.798327, 25.718806],
              [61.798355, 25.718947],
              [61.798656, 25.718924],
              [61.79895, 25.719241],
              [61.799128, 25.719868],
              [61.799196, 25.719877],
              [61.799229, 25.719961],
              [61.799202, 25.720144],
              [61.799269, 25.720219],
              [61.799409, 25.720154],
              [61.799567, 25.720314],
              [61.799754, 25.72034],
              [61.79985, 25.720433],
              [61.799845, 25.720539],
              [61.799668, 25.720648],
              [61.799729, 25.720701],
              [61.79981, 25.721111],
              [61.79961, 25.721292],
              [61.799524, 25.721539],
              [61.799587, 25.721565],
              [61.799601, 25.721626],
              [61.799936, 25.721769],
              [61.799868, 25.721983],
              [61.799983, 25.722125],
              [61.80009, 25.722072],
              [61.800388, 25.722226],
              [61.800485, 25.722228],
              [61.80067, 25.72209],
              [61.80083, 25.72215],
              [61.800922, 25.72228],
              [61.801035, 25.722281],
              [61.80118, 25.722237],
              [61.80137, 25.722053],
              [61.801604, 25.72204],
              [61.801989, 25.721882],
              [61.802046, 25.721995],
              [61.802227, 25.722061],
              [61.802542, 25.722019],
              [61.802607, 25.721935],
              [61.802838, 25.721984],
              [61.803516, 25.721923],
              [61.803948, 25.722095],
              [61.803997, 25.722185],
              [61.804103, 25.722236],
              [61.804421, 25.722185],
              [61.804726, 25.722244],
              [61.804939, 25.722345],
              [61.805125, 25.722344],
              [61.805097, 25.722748],
              [61.805158, 25.72292],
              [61.805237, 25.72293],
              [61.805231, 25.723004],
              [61.805022, 25.723064],
              [61.804993, 25.723283],
              [61.805054, 25.723359],
              [61.805212, 25.723392],
              [61.805194, 25.723477],
              [61.805317, 25.723477],
              [61.805281, 25.723619],
              [61.80517, 25.72369],
              [61.805223, 25.723753],
              [61.805368, 25.723761],
              [61.805255, 25.723903],
              [61.805118, 25.723917],
              [61.804953, 25.724052],
              [61.805053, 25.724173],
              [61.805013, 25.724339],
              [61.804907, 25.724391],
              [61.805079, 25.724501],
              [61.805127, 25.724598],
              [61.805392, 25.724596],
              [61.805472, 25.724652],
              [61.805671, 25.724982],
              [61.805746, 25.725235],
              [61.805874, 25.725236],
              [61.805977, 25.725391],
              [61.806121, 25.725493],
              [61.806142, 25.72558],
              [61.806246, 25.725632],
              [61.80631, 25.725919],
              [61.806464, 25.72618],
              [61.806511, 25.726315],
              [61.806462, 25.726434],
              [61.806357, 25.72664],
              [61.806126, 25.726909],
              [61.806136, 25.727008],
              [61.80621, 25.727095],
              [61.806055, 25.727306],
              [61.805884, 25.727425],
              [61.805849, 25.727527],
              [61.806084, 25.727833],
              [61.806208, 25.728177],
              [61.806142, 25.728297],
              [61.806179, 25.728401],
              [61.806076, 25.728606],
              [61.806345, 25.728683],
              [61.806413, 25.728746],
              [61.806486, 25.728914],
              [61.806541, 25.728932],
              [61.806541, 25.729148],
              [61.806711, 25.729404],
              [61.806572, 25.729403],
              [61.806553, 25.729463],
              [61.806482, 25.729487],
              [61.806385, 25.729708],
              [61.806112, 25.729763],
              [61.806168, 25.729857],
              [61.806117, 25.729969],
              [61.80608, 25.730008],
              [61.805882, 25.730001],
              [61.805734, 25.73022],
              [61.805636, 25.730436],
              [61.805667, 25.730806],
              [61.805561, 25.730968],
              [61.805533, 25.731121],
              [61.80562, 25.731216],
              [61.805395, 25.731389],
              [61.805443, 25.731665],
              [61.805419, 25.731805],
              [61.80563, 25.73192],
              [61.806145, 25.731792],
              [61.806191, 25.731873],
              [61.806464, 25.73201],
              [61.806828, 25.731906],
              [61.806858, 25.731837],
              [61.807327, 25.731766],
              [61.807539, 25.731855],
              [61.80747, 25.732151],
              [61.807598, 25.732368],
              [61.808077, 25.732384],
              [61.808159, 25.732351],
              [61.80819, 25.732268],
              [61.808411, 25.732196],
              [61.808546, 25.732421],
              [61.808485, 25.73261],
              [61.80877, 25.732801],
              [61.808842, 25.733018],
              [61.80894, 25.733057],
              [61.808958, 25.733186],
              [61.808896, 25.73337],
              [61.808667, 25.733504],
              [61.808692, 25.733589],
              [61.808653, 25.733676],
              [61.808749, 25.733802],
              [61.808694, 25.733936],
              [61.808723, 25.73406],
              [61.80866, 25.734127],
              [61.808704, 25.734274],
              [61.808825, 25.734419],
              [61.808845, 25.734592],
              [61.808805, 25.734714],
              [61.80895, 25.734963],
              [61.808691, 25.735034],
              [61.808457, 25.735008],
              [61.808256, 25.735109],
              [61.808111, 25.735101],
              [61.807957, 25.735033],
              [61.807522, 25.735116],
              [61.807436, 25.735221],
              [61.807373, 25.735814],
              [61.807245, 25.735909],
              [61.807037, 25.736516],
              [61.807191, 25.736575],
              [61.807466, 25.736942],
              [61.807474, 25.737032],
              [61.807547, 25.736993],
              [61.80765, 25.737006],
              [61.807979, 25.737133],
              [61.807956, 25.737287],
              [61.808049, 25.73728],
              [61.808354, 25.737414],
              [61.808649, 25.737737],
              [61.808635, 25.737828],
              [61.808565, 25.73789],
              [61.808829, 25.73798],
              [61.809152, 25.738181],
              [61.809354, 25.738173],
              [61.809429, 25.73823],
              [61.809681, 25.738249],
              [61.810249, 25.738512],
              [61.81038, 25.738407],
              [61.810587, 25.738342],
              [61.810606, 25.738245],
              [61.810676, 25.738186],
              [61.810969, 25.738137],
              [61.811427, 25.738161],
              [61.811925, 25.738317],
              [61.812134, 25.738325],
              [61.812145, 25.738382],
              [61.812369, 25.738518],
              [61.812564, 25.738533],
              [61.812764, 25.738406],
              [61.813535, 25.738392],
              [61.813853, 25.738014],
              [61.814065, 25.738066],
              [61.81421, 25.738043],
              [61.814344, 25.738101],
              [61.81463, 25.738091],
              [61.81485, 25.738258],
              [61.814924, 25.73843],
              [61.814891, 25.738528],
              [61.815135, 25.738729],
              [61.815152, 25.738859],
              [61.815402, 25.738843],
              [61.815566, 25.738922],
              [61.815789, 25.738841],
              [61.816181, 25.738896],
              [61.816349, 25.738807],
              [61.816701, 25.738814],
              [61.816982, 25.73898],
              [61.817112, 25.739219],
              [61.817378, 25.739381],
              [61.818191, 25.739263],
              [61.818347, 25.739395],
              [61.81844, 25.739388],
              [61.81855, 25.739477],
              [61.818713, 25.739497],
              [61.818875, 25.739436],
              [61.818951, 25.739357],
              [61.819055, 25.739341],
              [61.819494, 25.73935],
              [61.819736, 25.739455],
              [61.819948, 25.73938],
              [61.820139, 25.739398],
              [61.820309, 25.739471],
              [61.820617, 25.7394],
              [61.82102, 25.739439],
              [61.821186, 25.739387],
              [61.821452, 25.739417],
              [61.82176, 25.739335],
              [61.821891, 25.739426],
              [61.822247, 25.739441],
              [61.822311, 25.739528],
              [61.822745, 25.739646],
              [61.823004, 25.739629],
              [61.823296, 25.739523],
              [61.823772, 25.740255],
              [61.823967, 25.740456],
              [61.82431, 25.740536],
              [61.824543, 25.740724],
              [61.824705, 25.740773],
              [61.82471, 25.740911],
              [61.824811, 25.741038],
              [61.82483, 25.741314],
              [61.824987, 25.741397],
              [61.825062, 25.74155],
              [61.825391, 25.74178],
              [61.82562, 25.741787],
              [61.825611, 25.742065],
              [61.825685, 25.742247],
              [61.825801, 25.742461],
              [61.825967, 25.742568],
              [61.826022, 25.742739],
              [61.826102, 25.74271],
              [61.826243, 25.742854],
              [61.826457, 25.742906],
              [61.826787, 25.742862],
              [61.827323, 25.743285],
              [61.827669, 25.743433],
              [61.828174, 25.743482],
              [61.828391, 25.74358],
              [61.828684, 25.743564],
              [61.828785, 25.743515],
              [61.82901, 25.74359],
              [61.840067, 25.74484],
              [61.84325, 25.760278],
              [61.837583, 25.762889],
              [61.842071, 25.781864],
              [61.841903, 25.781763],
              [61.841368, 25.781775],
              [61.841197, 25.781815],
              [61.841065, 25.781746],
              [61.840907, 25.781726],
              [61.840691, 25.781751],
              [61.840375, 25.781583],
              [61.840291, 25.781581],
              [61.840139, 25.781606],
              [61.839987, 25.781736],
              [61.840011, 25.781764],
              [61.839781, 25.781805],
              [61.839603, 25.781888],
              [61.83933, 25.782108],
              [61.839136, 25.782157],
              [61.838946, 25.782017],
              [61.838838, 25.782053],
              [61.838687, 25.782207],
              [61.838212, 25.782455],
              [61.837705, 25.782845],
              [61.837716, 25.782889],
              [61.837496, 25.783107],
              [61.837479, 25.783254],
              [61.837324, 25.78333],
              [61.837376, 25.783488],
              [61.837273, 25.783636],
              [61.837361, 25.783739],
              [61.837305, 25.783763],
              [61.837327, 25.783898],
              [61.837171, 25.784],
              [61.837211, 25.784169],
              [61.83705, 25.78429],
              [61.837109, 25.784426],
              [61.83708, 25.784473],
              [61.837143, 25.784765],
              [61.837071, 25.784864],
              [61.837144, 25.785002],
              [61.83696, 25.785174],
              [61.83676, 25.785216],
              [61.836735, 25.785265],
              [61.836374, 25.785439],
              [61.836332, 25.785636],
              [61.836402, 25.785684],
              [61.836381, 25.785876],
              [61.836271, 25.786039],
              [61.836261, 25.786152],
              [61.836389, 25.786389],
              [61.836368, 25.786448],
              [61.836294, 25.786478],
              [61.836328, 25.786729],
              [61.836813, 25.786976],
              [61.83722, 25.786993],
              [61.837379, 25.787053],
              [61.837553, 25.787045],
              [61.837887, 25.787124],
              [61.837997, 25.787526],
              [61.837963, 25.78778],
              [61.837836, 25.787961],
              [61.837999, 25.788078],
              [61.83823, 25.788159],
              [61.838254, 25.788217],
              [61.838556, 25.788286],
              [61.839011, 25.788267],
              [61.839003, 25.788746],
              [61.839104, 25.788754],
              [61.839164, 25.788863],
              [61.839107, 25.788915],
              [61.839122, 25.788966],
              [61.838819, 25.789041],
              [61.838749, 25.789121],
              [61.838756, 25.789182],
              [61.838875, 25.789226],
              [61.838826, 25.789397],
              [61.83871, 25.78951],
              [61.838758, 25.789736],
              [61.83886, 25.789792],
              [61.83888, 25.789876],
              [61.838811, 25.790176],
              [61.838846, 25.790304],
              [61.838761, 25.790479],
              [61.83885, 25.79051],
              [61.838873, 25.790587],
              [61.838418, 25.79056],
              [61.838144, 25.790676],
              [61.837793, 25.790641],
              [61.837565, 25.790668],
              [61.837408, 25.790817],
              [61.836985, 25.791013],
              [61.836866, 25.791114],
              [61.836657, 25.791077],
              [61.836411, 25.790889],
              [61.836302, 25.790911],
              [61.836232, 25.791311],
              [61.836024, 25.791487],
              [61.835973, 25.791753],
              [61.836015, 25.791783],
              [61.835962, 25.791841],
              [61.835966, 25.791899],
              [61.836045, 25.791942],
              [61.835963, 25.791992],
              [61.83595, 25.792103],
              [61.835792, 25.792155],
              [61.835734, 25.792202],
              [61.835781, 25.792235],
              [61.835604, 25.792328],
              [61.835673, 25.792471],
              [61.835785, 25.792501],
              [61.835828, 25.7926],
              [61.835943, 25.792637],
              [61.835998, 25.792713],
              [61.835988, 25.792764],
              [61.835866, 25.792823],
              [61.835788, 25.793203],
              [61.836084, 25.793273],
              [61.836182, 25.793411],
              [61.836301, 25.793401],
              [61.836367, 25.793438],
              [61.836394, 25.793542],
              [61.836475, 25.793606],
              [61.83636, 25.793622],
              [61.836326, 25.793652],
              [61.836408, 25.793706],
              [61.836281, 25.793736],
              [61.836404, 25.794046],
              [61.836567, 25.794193],
              [61.836649, 25.794122],
              [61.836735, 25.794139],
              [61.836769, 25.794319],
              [61.836875, 25.794388],
              [61.836847, 25.794448],
              [61.836924, 25.794439],
              [61.83704, 25.794534],
              [61.836961, 25.79463],
              [61.836844, 25.794632],
              [61.83671, 25.79461],
              [61.836663, 25.794535],
              [61.836601, 25.794564],
              [61.836451, 25.794505],
              [61.836513, 25.794622],
              [61.836468, 25.794651],
              [61.836483, 25.794725],
              [61.836366, 25.794746],
              [61.836361, 25.79483],
              [61.836483, 25.79491],
              [61.836591, 25.795037],
              [61.836587, 25.795121],
              [61.836682, 25.795192],
              [61.836641, 25.795269],
              [61.836584, 25.79527],
              [61.836376, 25.79543],
              [61.836514, 25.795544],
              [61.836257, 25.795586],
              [61.836177, 25.79608],
              [61.835963, 25.796587],
              [61.836108, 25.796741],
              [61.836042, 25.796774],
              [61.836084, 25.796818],
              [61.836215, 25.796806],
              [61.836229, 25.796854],
              [61.836156, 25.796923],
              [61.836225, 25.797047],
              [61.83618, 25.797192],
              [61.836313, 25.797421],
              [61.836516, 25.797561],
              [61.836717, 25.797636],
              [61.836807, 25.79762],
              [61.8368, 25.797726],
              [61.836889, 25.79777],
              [61.836574, 25.79794],
              [61.836583, 25.79801],
              [61.83648, 25.798168],
              [61.836394, 25.79819],
              [61.836312, 25.798325],
              [61.836384, 25.79838],
              [61.836235, 25.798511],
              [61.836337, 25.798546],
              [61.836392, 25.798663],
              [61.836739, 25.798743],
              [61.837032, 25.799335],
              [61.837079, 25.799345],
              [61.837146, 25.799504],
              [61.837129, 25.79957],
              [61.837304, 25.799631],
              [61.837367, 25.799708],
              [61.837629, 25.799731],
              [61.83788, 25.799679],
              [61.837908, 25.799609],
              [61.838045, 25.799582],
              [61.838076, 25.799537],
              [61.838652, 25.799424],
              [61.838878, 25.799266],
              [61.838946, 25.799126],
              [61.839258, 25.799017],
              [61.839335, 25.798952],
              [61.839621, 25.798931],
              [61.839679, 25.79902],
              [61.839869, 25.799051],
              [61.840254, 25.799021],
              [61.840412, 25.798898],
              [61.840816, 25.798863],
              [61.841025, 25.798777],
              [61.841244, 25.798781],
              [61.841278, 25.79872],
              [61.841757, 25.798502],
              [61.8418, 25.798494],
              [61.84182, 25.798569],
              [61.84196, 25.79866],
              [61.842088, 25.798669],
              [61.842344, 25.798563],
              [61.842568, 25.798572],
              [61.842941, 25.798364],
              [61.843086, 25.798498],
              [61.843101, 25.798667],
              [61.843335, 25.798804],
              [61.843349, 25.798871],
              [61.843489, 25.798962],
              [61.843625, 25.798963],
              [61.843706, 25.79912],
              [61.843912, 25.799238],
              [61.843946, 25.799353],
              [61.844098, 25.799515],
              [61.844219, 25.799575],
              [61.844247, 25.799811],
              [61.844301, 25.799859],
              [61.844324, 25.800082],
              [61.844367, 25.800107],
              [61.844338, 25.800154],
              [61.844424, 25.800194],
              [61.844439, 25.800268],
              [61.844707, 25.800401],
              [61.844817, 25.800407],
              [61.844814, 25.800655],
              [61.84492, 25.800843],
              [61.844933, 25.800979],
              [61.844773, 25.801182],
              [61.844816, 25.801225],
              [61.844787, 25.801428],
              [61.844688, 25.801675],
              [61.844657, 25.801975],
              [61.844688, 25.802178],
              [61.844972, 25.802261],
              [61.845079, 25.802455],
              [61.845108, 25.802735],
              [61.845223, 25.802866],
              [61.84559, 25.803113],
              [61.845814, 25.803123],
              [61.845966, 25.803252],
              [61.846209, 25.80334],
              [61.846596, 25.803602],
              [61.84681, 25.803965],
              [61.846831, 25.804149],
              [61.846759, 25.804313],
              [61.846793, 25.80449],
              [61.846861, 25.804515],
              [61.84689, 25.804616],
              [61.847192, 25.804903],
              [61.847176, 25.805063],
              [61.846902, 25.805219],
              [61.8468, 25.805416],
              [61.846668, 25.805546],
              [61.846788, 25.805585],
              [61.846818, 25.805848],
              [61.846902, 25.806065],
              [61.84681, 25.806346],
              [61.846849, 25.806448],
              [61.846811, 25.806485],
              [61.846815, 25.806619],
              [61.846733, 25.806647],
              [61.846929, 25.807213],
              [61.846869, 25.80739],
              [61.846789, 25.807553],
              [61.846608, 25.80765],
              [61.846491, 25.807771],
              [61.846336, 25.807857],
              [61.846137, 25.807871],
              [61.846316, 25.808002],
              [61.84639, 25.808204],
              [61.846378, 25.808278],
              [61.846231, 25.808374],
              [61.846265, 25.808581],
              [61.846512, 25.808521],
              [61.846547, 25.808575],
              [61.846829, 25.808587],
              [61.84684, 25.808647],
              [61.846757, 25.808729],
              [61.84675, 25.808807],
              [61.846599, 25.808857],
              [61.84665, 25.808915],
              [61.8466, 25.808987],
              [61.846686, 25.80912],
              [61.846613, 25.809177],
              [61.846699, 25.809438],
              [61.846913, 25.809735],
              [61.846649, 25.80978],
              [61.846545, 25.809933],
              [61.846596, 25.810379],
              [61.846666, 25.810572],
              [61.846798, 25.810732],
              [61.84679, 25.810889],
              [61.846668, 25.810936],
              [61.846516, 25.81116],
              [61.846437, 25.811165],
              [61.846427, 25.81125],
              [61.846111, 25.811449],
              [61.845961, 25.811492],
              [61.845863, 25.811662],
              [61.845873, 25.811881],
              [61.845759, 25.811952],
              [61.845912, 25.812133],
              [61.845859, 25.812187],
              [61.845925, 25.812344],
              [61.845886, 25.812419],
              [61.845759, 25.812467],
              [61.845704, 25.812588],
              [61.845793, 25.812797],
              [61.846067, 25.813017],
              [61.846138, 25.813192],
              [61.846075, 25.813342],
              [61.84589, 25.813352],
              [61.845906, 25.813412],
              [61.845808, 25.813561],
              [61.84578, 25.813713],
              [61.845909, 25.813852],
              [61.846096, 25.813946],
              [61.846134, 25.814291],
              [61.846319, 25.814386],
              [61.846258, 25.814408],
              [61.846251, 25.814486],
              [61.846383, 25.814502],
              [61.846522, 25.81485],
              [61.846703, 25.815112],
              [61.846724, 25.815264],
              [61.847332, 25.815175],
              [61.847797, 25.815277],
              [61.848113, 25.815242],
              [61.848266, 25.815161],
              [61.84849, 25.8152],
              [61.84883, 25.815345],
              [61.849085, 25.81535],
              [61.849423, 25.815441],
              [61.84955, 25.815531],
              [61.849873, 25.815541],
              [61.849988, 25.815631],
              [61.85002, 25.815725],
              [61.850305, 25.815929],
              [61.850403, 25.816143],
              [61.851069, 25.81633],
              [61.851426, 25.816329],
              [61.851539, 25.816431],
              [61.851304, 25.816626],
              [61.851198, 25.817077],
              [61.851104, 25.817086],
              [61.850997, 25.817166],
              [61.85099, 25.817251],
              [61.850863, 25.817359],
              [61.8506, 25.817439],
              [61.850442, 25.817643],
              [61.85055, 25.818092],
              [61.850537, 25.818236],
              [61.850051, 25.818539],
              [61.849755, 25.81881],
              [61.849299, 25.818977],
              [61.849036, 25.818983],
              [61.849011, 25.819098],
              [61.84894, 25.819162],
              [61.849067, 25.819302],
              [61.849097, 25.819419],
              [61.849035, 25.819416],
              [61.848948, 25.819541],
              [61.849392, 25.819635],
              [61.84935, 25.819851],
              [61.849188, 25.81991],
              [61.849137, 25.820151],
              [61.849065, 25.820243],
              [61.848797, 25.820259],
              [61.848778, 25.820429],
              [61.848558, 25.820728],
              [61.848388, 25.820865],
              [61.84835, 25.820967],
              [61.848396, 25.821212],
              [61.848534, 25.821275],
              [61.848451, 25.821447],
              [61.848539, 25.821506],
              [61.848552, 25.821675],
              [61.848771, 25.821787],
              [61.848764, 25.821978],
              [61.848895, 25.822397],
              [61.848867, 25.82259],
              [61.848463, 25.822813],
              [61.848233, 25.823],
              [61.848028, 25.822979],
              [61.847926, 25.823058],
              [61.847798, 25.823039],
              [61.84759, 25.82316],
              [61.846935, 25.823342],
              [61.846524, 25.823399],
              [61.84642, 25.823379],
              [61.84632, 25.82357],
              [61.846065, 25.823649],
              [61.845693, 25.823683],
              [61.845138, 25.823861],
              [61.844642, 25.823841],
              [61.84428, 25.823929],
              [61.844164, 25.824332],
              [61.844195, 25.824443],
              [61.844141, 25.824455],
              [61.843582, 25.824483],
              [61.843422, 25.824588],
              [61.842487, 25.824661],
              [61.84218, 25.82479],
              [61.84205, 25.824772],
              [61.841957, 25.824651],
              [61.84176, 25.824654],
              [61.841396, 25.824752],
              [61.841221, 25.824857],
              [61.841111, 25.824861],
              [61.840878, 25.825002],
              [61.840203, 25.825163],
              [61.839823, 25.825166],
              [61.839746, 25.825235],
              [61.839617, 25.825245],
              [61.839117, 25.824713],
              [61.838888, 25.824756],
              [61.838852, 25.824907],
              [61.838888, 25.824916],
              [61.838794, 25.825091],
              [61.838327, 25.825369],
              [61.838369, 25.825461],
              [61.838063, 25.825744],
              [61.838201, 25.826224],
              [61.838304, 25.82644],
              [61.838406, 25.82653],
              [61.838367, 25.826623],
              [61.83832, 25.826634],
              [61.838401, 25.826812],
              [61.838343, 25.826952],
              [61.83841, 25.827225],
              [61.838339, 25.827405],
              [61.838423, 25.82758],
              [61.838423, 25.82774],
              [61.838717, 25.828234],
              [61.838936, 25.828865],
              [61.838539, 25.828982],
              [61.838457, 25.829055],
              [61.838172, 25.829097],
              [61.838164, 25.829316],
              [61.838228, 25.829358],
              [61.838216, 25.829444],
              [61.838299, 25.829554],
              [61.838191, 25.829629],
              [61.838059, 25.829834],
              [61.837965, 25.829853],
              [61.837917, 25.829996],
              [61.838256, 25.830111],
              [61.839036, 25.830231],
              [61.839375, 25.830349],
              [61.839562, 25.830334],
              [61.839935, 25.830411],
              [61.840102, 25.830555],
              [61.840166, 25.830773],
              [61.840597, 25.830865],
              [61.841338, 25.830834],
              [61.841395, 25.830868],
              [61.841376, 25.831006],
              [61.841701, 25.831056],
              [61.84174, 25.831105],
              [61.842015, 25.831067],
              [61.841989, 25.831807],
              [61.842064, 25.832016],
              [61.842089, 25.832331],
              [61.841885, 25.832567],
              [61.841917, 25.832691],
              [61.841749, 25.832949],
              [61.841757, 25.833098],
              [61.841583, 25.833396],
              [61.841627, 25.83352],
              [61.840952, 25.833483],
              [61.840892, 25.833647],
              [61.841023, 25.833795],
              [61.841658, 25.833941],
              [61.841795, 25.834229],
              [61.841721, 25.834231],
              [61.841771, 25.834505],
              [61.841745, 25.834748],
              [61.841922, 25.834747],
              [61.842039, 25.835034],
              [61.842115, 25.835034],
              [61.842178, 25.835109],
              [61.842134, 25.835175],
              [61.842454, 25.835287],
              [61.842582, 25.835266],
              [61.842764, 25.835565],
              [61.842845, 25.835574],
              [61.842844, 25.835611],
              [61.843123, 25.835779],
              [61.843254, 25.835769],
              [61.843437, 25.835878],
              [61.843429, 25.836125],
              [61.843613, 25.836495],
              [61.84359, 25.836616],
              [61.842082, 25.836635],
              [61.841071, 25.836724],
              [61.840196, 25.836704],
              [61.839885, 25.836758],
              [61.840071, 25.836843],
              [61.840195, 25.837057],
              [61.840464, 25.837139],
              [61.840566, 25.83732],
              [61.841422, 25.837437],
              [61.841824, 25.837423],
              [61.842254, 25.837509],
              [61.842857, 25.837564],
              [61.842858, 25.837757],
              [61.842794, 25.837894],
              [61.84312, 25.838137],
              [61.843087, 25.838259],
              [61.843124, 25.838435],
              [61.843226, 25.838514],
              [61.843035, 25.838811],
              [61.843115, 25.838877],
              [61.843086, 25.839184],
              [61.843044, 25.839215],
              [61.843138, 25.839362],
              [61.843023, 25.839668],
              [61.842825, 25.839699],
              [61.842586, 25.83951],
              [61.842425, 25.839465],
              [61.842408, 25.839407],
              [61.84232, 25.839407],
              [61.84227, 25.839323],
              [61.842213, 25.839331],
              [61.842137, 25.83944],
              [61.841719, 25.839403],
              [61.841652, 25.839339],
              [61.841538, 25.839376],
              [61.841472, 25.839348],
              [61.841327, 25.839207],
              [61.841125, 25.839239],
              [61.841102, 25.839192],
              [61.841023, 25.839204],
              [61.840896, 25.839136],
              [61.840777, 25.839162],
              [61.8406, 25.839312],
              [61.840448, 25.839369],
              [61.840035, 25.839177],
              [61.839962, 25.839067],
              [61.839702, 25.838968],
              [61.839582, 25.838859],
              [61.839089, 25.838954],
              [61.838811, 25.838831],
              [61.838689, 25.838845],
              [61.838415, 25.838962],
              [61.838219, 25.838925],
              [61.83777, 25.838989],
              [61.837612, 25.839113],
              [61.837239, 25.839059],
              [61.836997, 25.838965],
              [61.836848, 25.839004],
              [61.836563, 25.838955],
              [61.836171, 25.839134],
              [61.836008, 25.839115],
              [61.835946, 25.839047],
              [61.835858, 25.83923],
              [61.835955, 25.839277],
              [61.835999, 25.839439],
              [61.835945, 25.839525],
              [61.835858, 25.839552],
              [61.835436, 25.839502],
              [61.83532, 25.839753],
              [61.835061, 25.839813],
              [61.835162, 25.83992],
              [61.834935, 25.839991],
              [61.834835, 25.839923],
              [61.834526, 25.839941],
              [61.83433, 25.840313],
              [61.834151, 25.840537],
              [61.834084, 25.840732],
              [61.834124, 25.840799],
              [61.834008, 25.84086],
              [61.833968, 25.841013],
              [61.834022, 25.841182],
              [61.833927, 25.841215],
              [61.833886, 25.841181],
              [61.833775, 25.841191],
              [61.833417, 25.841439],
              [61.833009, 25.8415],
              [61.832854, 25.841732],
              [61.832659, 25.841885],
              [61.832635, 25.842024],
              [61.832554, 25.842089],
              [61.832341, 25.842097],
              [61.831925, 25.842339],
              [61.831456, 25.842224],
              [61.831291, 25.842121],
              [61.830956, 25.842019],
              [61.830895, 25.841928],
              [61.830449, 25.841908],
              [61.830102, 25.841968],
              [61.830035, 25.841859],
              [61.829928, 25.841795],
              [61.829676, 25.841773],
              [61.829522, 25.84165],
              [61.828793, 25.841676],
              [61.828078, 25.841347],
              [61.827572, 25.841543],
              [61.827511, 25.841609],
              [61.826783, 25.841325],
              [61.826212, 25.841228],
              [61.826034, 25.841102],
              [61.824968, 25.840674],
              [61.824906, 25.840588],
              [61.824302, 25.840545],
              [61.824237, 25.840045],
              [61.8243, 25.839978],
              [61.824101, 25.839884],
              [61.82398, 25.839863],
              [61.823846, 25.839966],
              [61.823725, 25.839935],
              [61.82355, 25.839987],
              [61.823367, 25.840101],
              [61.823172, 25.840159],
              [61.823199, 25.84066],
              [61.822965, 25.840975],
              [61.822473, 25.841318],
              [61.82248, 25.841692],
              [61.822413, 25.841702],
              [61.822412, 25.841841],
              [61.822298, 25.842008],
              [61.822329, 25.842053],
              [61.822152, 25.842329],
              [61.822076, 25.842852],
              [61.822357, 25.842978],
              [61.822345, 25.843031],
              [61.822269, 25.843137],
              [61.821968, 25.843284],
              [61.821753, 25.84326],
              [61.821562, 25.843621],
              [61.821585, 25.843772],
              [61.821634, 25.84378],
              [61.821594, 25.843875],
              [61.821679, 25.844045],
              [61.821537, 25.844207],
              [61.821397, 25.844156],
              [61.821356, 25.844182],
              [61.821293, 25.844312],
              [61.821359, 25.844539],
              [61.821279, 25.844766],
              [61.821351, 25.845152],
              [61.821349, 25.84601],
              [61.821098, 25.846275],
              [61.820989, 25.846501],
              [61.820958, 25.846641],
              [61.821008, 25.846873],
              [61.82094, 25.847097],
              [61.820969, 25.8472],
              [61.820927, 25.847261],
              [61.820928, 25.847537],
              [61.820747, 25.848045],
              [61.820734, 25.848411],
              [61.820661, 25.848644],
              [61.820479, 25.848929],
              [61.820502, 25.849016],
              [61.820408, 25.849211],
              [61.820531, 25.849252],
              [61.820597, 25.849333],
              [61.820785, 25.849368],
              [61.821018, 25.849498],
              [61.821125, 25.849365],
              [61.821314, 25.849267],
              [61.821483, 25.849271],
              [61.821776, 25.849341],
              [61.822412, 25.849362],
              [61.822722, 25.849515],
              [61.823029, 25.849562],
              [61.823235, 25.849671],
              [61.823345, 25.849811],
              [61.823423, 25.849809],
              [61.823423, 25.849851],
              [61.823588, 25.849847],
              [61.823988, 25.849935],
              [61.82437, 25.849818],
              [61.824421, 25.849894],
              [61.824432, 25.850066],
              [61.824712, 25.850364],
              [61.824794, 25.850377],
              [61.824831, 25.850503],
              [61.825541, 25.850816],
              [61.825642, 25.850951],
              [61.825843, 25.850977],
              [61.825844, 25.851095],
              [61.825907, 25.851089],
              [61.826087, 25.851209],
              [61.82605, 25.851262],
              [61.826061, 25.851532],
              [61.825983, 25.851703],
              [61.825792, 25.8519],
              [61.825796, 25.851989],
              [61.825709, 25.852005],
              [61.825708, 25.852098],
              [61.825915, 25.85223],
              [61.825936, 25.852298],
              [61.82603, 25.85236],
              [61.826144, 25.852377],
              [61.826291, 25.852284],
              [61.826402, 25.852569],
              [61.82664, 25.852566],
              [61.826802, 25.852507],
              [61.82702, 25.852614],
              [61.827038, 25.852564],
              [61.827111, 25.852574],
              [61.827149, 25.852514],
              [61.827459, 25.852438],
              [61.827688, 25.852466],
              [61.827947, 25.852401],
              [61.827969, 25.852432],
              [61.828411, 25.852374],
              [61.828467, 25.852007],
              [61.828857, 25.852025],
              [61.829234, 25.852245],
              [61.829546, 25.852344],
              [61.829777, 25.852359],
              [61.830074, 25.852468],
              [61.830257, 25.852616],
              [61.83062, 25.852585],
              [61.830732, 25.852704],
              [61.83069, 25.85286],
              [61.830721, 25.85291],
              [61.830662, 25.853004],
              [61.830692, 25.85308],
              [61.830628, 25.853099],
              [61.830682, 25.85314],
              [61.830657, 25.853242],
              [61.830707, 25.853381],
              [61.830612, 25.853533],
              [61.830652, 25.853669],
              [61.831261, 25.853889],
              [61.831358, 25.854036],
              [61.831475, 25.853958],
              [61.831635, 25.853929],
              [61.831774, 25.854034],
              [61.83202, 25.854097],
              [61.832041, 25.854654],
              [61.832099, 25.85468],
              [61.832058, 25.854727],
              [61.832198, 25.854973],
              [61.831834, 25.85528],
              [61.831574, 25.855713],
              [61.831391, 25.855924],
              [61.831471, 25.856077],
              [61.831522, 25.856091],
              [61.831517, 25.856206],
              [61.831479, 25.85622],
              [61.83144, 25.856402],
              [61.831321, 25.856491],
              [61.831305, 25.856654],
              [61.831058, 25.856696],
              [61.830924, 25.856639],
              [61.830498, 25.856643],
              [61.830373, 25.856438],
              [61.830287, 25.856398],
              [61.830127, 25.856337],
              [61.829882, 25.856374],
              [61.829951, 25.856644],
              [61.829923, 25.856693],
              [61.830007, 25.856852],
              [61.829951, 25.856941],
              [61.830061, 25.857102],
              [61.830087, 25.857245],
              [61.82987, 25.857535],
              [61.829622, 25.857582],
              [61.829764, 25.857767],
              [61.829807, 25.857977],
              [61.829856, 25.857996],
              [61.829908, 25.858135],
              [61.830313, 25.858355],
              [61.83035, 25.858501],
              [61.830505, 25.858552],
              [61.830572, 25.858635],
              [61.830666, 25.858911],
              [61.830728, 25.858962],
              [61.830693, 25.859151],
              [61.830634, 25.859201],
              [61.830726, 25.859271],
              [61.830708, 25.85933],
              [61.830997, 25.859394],
              [61.831034, 25.859528],
              [61.83122, 25.859488],
              [61.831407, 25.859874],
              [61.831231, 25.860006],
              [61.831216, 25.860423],
              [61.831134, 25.86041],
              [61.831155, 25.860476],
              [61.830986, 25.860451],
              [61.830987, 25.860573],
              [61.831038, 25.860569],
              [61.831068, 25.860684],
              [61.831495, 25.86077],
              [61.831574, 25.860851],
              [61.831322, 25.861112],
              [61.831333, 25.861159],
              [61.831121, 25.861308],
              [61.830809, 25.861346],
              [61.830838, 25.861572],
              [61.830968, 25.8616],
              [61.830971, 25.861655],
              [61.831082, 25.861663],
              [61.831185, 25.861746],
              [61.831197, 25.861837],
              [61.831053, 25.861877],
              [61.831076, 25.861993],
              [61.830994, 25.862295],
              [61.831043, 25.862356],
              [61.830995, 25.86255],
              [61.831104, 25.862633],
              [61.83114, 25.86283],
              [61.831521, 25.862855],
              [61.832033, 25.86282],
              [61.831979, 25.862977],
              [61.831957, 25.863509],
              [61.831988, 25.86368],
              [61.832065, 25.863777],
              [61.8319826, 25.8638147],
              [61.831864, 25.863869],
              [61.831903, 25.86401],
              [61.832077, 25.8641],
              [61.832145, 25.864264],
              [61.832088, 25.864459],
              [61.832103, 25.864586],
              [61.83216, 25.864701],
              [61.832178, 25.864925],
              [61.8323, 25.865191],
              [61.83224, 25.865355],
              [61.832516, 25.865375],
              [61.832992, 25.86528],
              [61.834603, 25.86514],
              [61.834604, 25.865316],
              [61.834704, 25.865572],
              [61.83472, 25.865782],
              [61.835168, 25.865883],
              [61.83559, 25.86591],
              [61.835565, 25.86604],
              [61.835686, 25.866324],
              [61.835637, 25.866512],
              [61.835804, 25.866756],
              [61.835806, 25.866853],
              [61.835959, 25.866872],
              [61.836843, 25.866728],
              [61.837555, 25.86667],
              [61.837834, 25.866726],
              [61.838534, 25.866679],
              [61.838752, 25.866622],
              [61.838945, 25.866643],
              [61.839591, 25.866518],
              [61.839918, 25.866543],
              [61.841004, 25.866482],
              [61.841587, 25.86636],
              [61.841881, 25.866144],
              [61.84276, 25.866145],
              [61.843375, 25.866011],
              [61.84355, 25.866086],
              [61.843555, 25.866336],
              [61.843479, 25.866619],
              [61.843607, 25.866976],
              [61.843549, 25.867148],
              [61.843568, 25.867228],
              [61.843208, 25.86733],
              [61.843082, 25.867427],
              [61.842635, 25.8676],
              [61.842622, 25.867648],
              [61.842388, 25.867765],
              [61.842281, 25.8679],
              [61.842308, 25.868159],
              [61.842485, 25.868345],
              [61.842771, 25.868447],
              [61.842821, 25.868702],
              [61.84291, 25.868784],
              [61.842676, 25.868983],
              [61.842415, 25.86909],
              [61.842322, 25.869181],
              [61.842026, 25.869244],
              [61.841514, 25.869266],
              [61.841575, 25.869619],
              [61.841772, 25.869681],
              [61.841866, 25.869808],
              [61.841895, 25.870224],
              [61.841829, 25.870487],
              [61.841851, 25.87058],
              [61.841948, 25.870637],
              [61.841901, 25.870789],
              [61.842009, 25.870997],
              [61.841995, 25.871231],
              [61.841843, 25.871254],
              [61.841652, 25.871659],
              [61.84168, 25.871839],
              [61.840912, 25.871889],
              [61.840731, 25.871833],
              [61.840361, 25.871853],
              [61.840241, 25.871805],
              [61.839971, 25.871789],
              [61.839046, 25.871783],
              [61.83887, 25.87187],
              [61.838743, 25.872106],
              [61.838775, 25.872555],
              [61.838891, 25.872984],
              [61.839023, 25.87321],
              [61.839369, 25.873566],
              [61.839722, 25.874119],
              [61.839935, 25.874352],
              [61.840005, 25.87464],
              [61.840058, 25.874686],
              [61.840173, 25.874596],
              [61.840274, 25.874587],
              [61.840306, 25.874702],
              [61.840227, 25.874888],
              [61.840274, 25.875077],
              [61.84119, 25.875112],
              [61.841783, 25.875201],
              [61.842067, 25.875294],
              [61.842077, 25.875649],
              [61.841942, 25.875724],
              [61.841992, 25.875961],
              [61.841853, 25.876227],
              [61.841843, 25.876456],
              [61.84197, 25.877036],
              [61.84219, 25.877674],
              [61.842866, 25.877821],
              [61.843375, 25.877865],
              [61.843816, 25.877832],
              [61.843918, 25.877763],
              [61.844233, 25.87778],
              [61.844454, 25.877713],
              [61.844811, 25.8777],
              [61.844961, 25.877747],
              [61.845441, 25.877712],
              [61.84566, 25.877761],
              [61.845985, 25.877717],
              [61.846345, 25.877824],
              [61.846656, 25.877759],
              [61.846695, 25.877821],
              [61.847038, 25.877894],
              [61.847105, 25.877966],
              [61.847239, 25.87797],
              [61.847221, 25.878019],
              [61.847274, 25.878037],
              [61.847459, 25.878046],
              [61.847611, 25.878125],
              [61.847927, 25.878124],
              [61.848081, 25.878254],
              [61.848589, 25.878381],
              [61.848947, 25.878391],
              [61.849251, 25.879093],
              [61.849947, 25.8792],
              [61.850508, 25.879131],
              [61.851137, 25.879162],
              [61.851296, 25.879292],
              [61.851543, 25.879252],
              [61.851662, 25.879296],
              [61.851977, 25.87929],
              [61.85235, 25.879344],
              [61.852941, 25.87953],
              [61.853103, 25.879459],
              [61.853363, 25.87958],
              [61.853379, 25.879776],
              [61.85358, 25.879559],
              [61.85381, 25.87955],
              [61.853907, 25.87919],
              [61.854343, 25.879177],
              [61.854437, 25.879114],
              [61.854375, 25.879018],
              [61.854394, 25.878973],
              [61.854553, 25.878875],
              [61.854659, 25.878884],
              [61.854967, 25.879019],
              [61.85516, 25.879021],
              [61.855715, 25.879218],
              [61.855963, 25.879225],
              [61.856382, 25.879368],
              [61.856569, 25.879367],
              [61.856725, 25.879297],
              [61.856764, 25.879397],
              [61.85707, 25.879523],
              [61.857163, 25.87952],
              [61.857364, 25.879743],
              [61.857517, 25.879804],
              [61.857591, 25.879935],
              [61.857565, 25.880301],
              [61.857872, 25.880473],
              [61.858113, 25.880472],
              [61.858331, 25.880558],
              [61.858433, 25.880697],
              [61.858541, 25.880506],
              [61.858618, 25.880437],
              [61.858742, 25.880419],
              [61.859002, 25.880535],
              [61.859107, 25.880627],
              [61.859336, 25.880614],
              [61.859702, 25.880678],
              [61.859837, 25.88077],
              [61.860155, 25.880862],
              [61.860205, 25.880931],
              [61.860642, 25.880983],
              [61.860703, 25.88104],
              [61.860907, 25.880983],
              [61.860863, 25.881041],
              [61.8611, 25.881082],
              [61.861556, 25.881343],
              [61.861738, 25.881338],
              [61.861749, 25.881429],
              [61.862064, 25.881465],
              [61.862165, 25.881414],
              [61.86279, 25.881655],
              [61.863029, 25.881542],
              [61.863488, 25.88152],
              [61.86365, 25.881454],
              [61.863783, 25.881389],
              [61.863968, 25.88117],
              [61.864238, 25.881061],
              [61.864417, 25.880501],
              [61.864382, 25.880354],
              [61.864424, 25.880198],
              [61.864611, 25.880216],
              [61.865439, 25.880128],
              [61.865617, 25.88017],
              [61.865825, 25.880114],
              [61.866066, 25.880173],
              [61.866545, 25.880175],
              [61.866968, 25.880271],
              [61.867197, 25.880258],
              [61.867641, 25.880382],
              [61.867833, 25.880362],
              [61.868127, 25.880522],
              [61.868283, 25.880494],
              [61.868282, 25.88055],
              [61.868546, 25.880456],
              [61.868809, 25.880525],
              [61.869165, 25.880508],
              [61.86948, 25.880609],
              [61.869597, 25.880727],
              [61.869577, 25.880809],
              [61.869758, 25.88093],
              [61.869933, 25.881168],
              [61.870112, 25.881173],
              [61.870498, 25.881052],
              [61.871112, 25.880956],
              [61.871506, 25.880974],
              [61.871949, 25.881159],
              [61.872049, 25.881122],
              [61.872436, 25.88115],
              [61.872718, 25.881072],
              [61.872935, 25.881195],
              [61.873212, 25.881095],
              [61.873429, 25.881158],
              [61.873661, 25.881158],
              [61.874554, 25.881114],
              [61.874676, 25.881069],
              [61.874784, 25.880938],
              [61.874862, 25.880414],
              [61.874759, 25.880103],
              [61.874788, 25.879996],
              [61.875417, 25.879837],
              [61.875721, 25.87981],
              [61.875918, 25.879682],
              [61.876264, 25.879643],
              [61.876584, 25.879668],
              [61.876694, 25.879739],
              [61.877056, 25.879794],
              [61.877384, 25.879897],
              [61.877438, 25.879873],
              [61.877529, 25.879945],
              [61.877654, 25.879862],
              [61.878332, 25.880078],
              [61.878572, 25.880039],
              [61.878899, 25.879695],
              [61.879149, 25.879659],
              [61.879456, 25.87984],
              [61.879644, 25.880175],
              [61.879748, 25.880258],
              [61.880263, 25.880433],
              [61.880301, 25.880551],
              [61.880407, 25.880495],
              [61.881123, 25.880639],
              [61.881165, 25.88071],
              [61.881383, 25.88075],
              [61.881421, 25.880932],
              [61.881629, 25.880992],
              [61.881768, 25.881096],
              [61.881861, 25.881089],
              [61.8823, 25.881241],
              [61.882655, 25.881269],
              [61.882814, 25.881223],
              [61.882907, 25.88128],
              [61.88317, 25.881297],
              [61.883332, 25.881185],
              [61.883745, 25.881287],
              [61.884346, 25.881576],
              [61.884519, 25.881614],
              [61.884613, 25.881782],
              [61.884787, 25.881866],
              [61.885551, 25.882126],
              [61.885696, 25.882276],
              [61.885747, 25.882409],
              [61.88602, 25.882384],
              [61.886852, 25.882558],
              [61.887075, 25.882555],
              [61.887416, 25.882627],
              [61.887586, 25.882611],
              [61.887678, 25.882557],
              [61.887899, 25.882564],
              [61.888052, 25.882451],
              [61.88813, 25.882299],
              [61.888119, 25.881916],
              [61.888515, 25.881993],
              [61.888665, 25.881888],
              [61.888947, 25.88222],
              [61.889089, 25.882291],
              [61.889251, 25.882304],
              [61.889355, 25.882262],
              [61.889445, 25.882302],
              [61.889619, 25.882474],
              [61.889737, 25.882517],
              [61.889873, 25.882765],
              [61.890066, 25.882928],
              [61.890354, 25.882928],
              [61.890429, 25.882993],
              [61.890539, 25.882964],
              [61.890722, 25.883199],
              [61.890657, 25.883303],
              [61.890728, 25.88335],
              [61.89069, 25.883421],
              [61.89075, 25.88353],
              [61.890675, 25.883802],
              [61.89055, 25.883884],
              [61.890398, 25.883893],
              [61.8903, 25.883961],
              [61.890161, 25.883986],
              [61.890053, 25.884098],
              [61.889827, 25.884152],
              [61.889433, 25.88455],
              [61.889122, 25.884748],
              [61.88899, 25.884924],
              [61.889008, 25.885106],
              [61.888952, 25.885166],
              [61.889184, 25.885706],
              [61.88934, 25.885835],
              [61.889235, 25.8859],
              [61.889346, 25.885926],
              [61.88917, 25.886257],
              [61.889478, 25.886465],
              [61.889563, 25.886823],
              [61.889709, 25.887083],
              [61.88966, 25.887147],
              [61.889713, 25.88729],
              [61.889851, 25.887348],
              [61.890157, 25.887607],
              [61.890263, 25.887616],
              [61.890291, 25.887819],
              [61.890255, 25.887899],
              [61.890208, 25.887907],
              [61.890254, 25.888019],
              [61.890245, 25.888339],
              [61.890625, 25.888409],
              [61.890708, 25.888547],
              [61.890644, 25.888595],
              [61.89078, 25.888686],
              [61.890808, 25.888783],
              [61.890883, 25.888723],
              [61.891131, 25.888716],
              [61.891267, 25.888788],
              [61.891361, 25.888785],
              [61.891458, 25.889114],
              [61.891521, 25.889102],
              [61.891634, 25.889175],
              [61.891496, 25.889439],
              [61.891535, 25.889773],
              [61.891496, 25.890029],
              [61.891294, 25.890102],
              [61.891158, 25.890556],
              [61.891011, 25.890568],
              [61.891013, 25.890701],
              [61.89053, 25.890594],
              [61.890418, 25.890794],
              [61.890469, 25.891159],
              [61.890206, 25.891122],
              [61.889887, 25.89099],
              [61.889743, 25.890993],
              [61.88972, 25.890919],
              [61.889599, 25.890931],
              [61.889535, 25.890873],
              [61.889302, 25.890897],
              [61.888957, 25.891037],
              [61.888799, 25.891],
              [61.888568, 25.891056],
              [61.888379, 25.891034],
              [61.888306, 25.890913],
              [61.888242, 25.890874],
              [61.888125, 25.890886],
              [61.888024, 25.890756],
              [61.887833, 25.890832],
              [61.88744, 25.890745],
              [61.887354, 25.890761],
              [61.887262, 25.890708],
              [61.887036, 25.890721],
              [61.886929, 25.890777],
              [61.886721, 25.890676],
              [61.886053, 25.890606],
              [61.884917, 25.890874],
              [61.884842, 25.89079],
              [61.884553, 25.890727],
              [61.884491, 25.890673],
              [61.884084, 25.89076],
              [61.884027, 25.890835],
              [61.883783, 25.890837],
              [61.883588, 25.890895],
              [61.883379, 25.890895],
              [61.883309, 25.890852],
              [61.882982, 25.890878],
              [61.882529, 25.890775],
              [61.88222, 25.890941],
              [61.881678, 25.891006],
              [61.881483, 25.890957],
              [61.880972, 25.891072],
              [61.880819, 25.891067],
              [61.88041, 25.890865],
              [61.880284, 25.890874],
              [61.880171, 25.890936],
              [61.879976, 25.890947],
              [61.879773, 25.891109],
              [61.879216, 25.891112],
              [61.878858, 25.89131],
              [61.87858, 25.891388],
              [61.878431, 25.891363],
              [61.878387, 25.891427],
              [61.878088, 25.891499],
              [61.878029, 25.891561],
              [61.877542, 25.891778],
              [61.877479, 25.891928],
              [61.877208, 25.892074],
              [61.876871, 25.892213],
              [61.876519, 25.89223],
              [61.876401, 25.893007],
              [61.876172, 25.893141],
              [61.875823, 25.893148],
              [61.875764, 25.89346],
              [61.875703, 25.893498],
              [61.875697, 25.893638],
              [61.875778, 25.893833],
              [61.875601, 25.89392],
              [61.875558, 25.894197],
              [61.875508, 25.894257],
              [61.875662, 25.894493],
              [61.874959, 25.894525],
              [61.874641, 25.894267],
              [61.874024, 25.894057],
              [61.873857, 25.893901],
              [61.873348, 25.894175],
              [61.873018, 25.894097],
              [61.872926, 25.894152],
              [61.872237, 25.894296],
              [61.872183, 25.894567],
              [61.872274, 25.894779],
              [61.871772, 25.894921],
              [61.871651, 25.894888],
              [61.87156, 25.895026],
              [61.870257, 25.898252],
              [61.869016, 25.899663],
              [61.868088, 25.904018],
              [61.868002, 25.905076],
              [61.867921, 25.905451],
              [61.867598, 25.905601],
              [61.867318, 25.905635],
              [61.866969, 25.905617],
              [61.866614, 25.905674],
              [61.866397, 25.905612],
              [61.865888, 25.905629],
              [61.865527, 25.905585],
              [61.8654, 25.905632],
              [61.865165, 25.906338],
              [61.865024, 25.906425],
              [61.864951, 25.906696],
              [61.865153, 25.907246],
              [61.865202, 25.907545],
              [61.865282, 25.907675],
              [61.865091, 25.907818],
              [61.865042, 25.907911],
              [61.8651, 25.907952],
              [61.865061, 25.908202],
              [61.864965, 25.908262],
              [61.864914, 25.908365],
              [61.864939, 25.908566],
              [61.865082, 25.908679],
              [61.865061, 25.908851],
              [61.865097, 25.908938],
              [61.865049, 25.908975],
              [61.865093, 25.909079],
              [61.86502, 25.909387],
              [61.864415, 25.909403],
              [61.864016, 25.90932],
              [61.863805, 25.909359],
              [61.863048, 25.909283],
              [61.862874, 25.909357],
              [61.862839, 25.909252],
              [61.862275, 25.90926],
              [61.862027, 25.909186],
              [61.861854, 25.909223],
              [61.861721, 25.909094],
              [61.86146, 25.909064],
              [61.861413, 25.90897],
              [61.861098, 25.909053],
              [61.860684, 25.909047],
              [61.860222, 25.908942],
              [61.859957, 25.908955],
              [61.85961, 25.90889],
              [61.859126, 25.908696],
              [61.859019, 25.908749],
              [61.858838, 25.908713],
              [61.858718, 25.909142],
              [61.858403, 25.909776],
              [61.858413, 25.909858],
              [61.85825, 25.909916],
              [61.858249, 25.91001],
              [61.858326, 25.910003],
              [61.858293, 25.910035],
              [61.858372, 25.910099],
              [61.858334, 25.910237],
              [61.858449, 25.910318],
              [61.85827, 25.910525],
              [61.85833, 25.910752],
              [61.858658, 25.910797],
              [61.858768, 25.910875],
              [61.858743, 25.910912],
              [61.858793, 25.910977],
              [61.858705, 25.910989],
              [61.858725, 25.911051],
              [61.858523, 25.911108],
              [61.858476, 25.911308],
              [61.858369, 25.911282],
              [61.858162, 25.911358],
              [61.858066, 25.911315],
              [61.857963, 25.911367],
              [61.857748, 25.911646],
              [61.857583, 25.911635],
              [61.857167, 25.911718],
              [61.857237, 25.911846],
              [61.857316, 25.912269],
              [61.857537, 25.912504],
              [61.857161, 25.912672],
              [61.857133, 25.912832],
              [61.857191, 25.912933],
              [61.857069, 25.912923],
              [61.856918, 25.91319],
              [61.856911, 25.913612],
              [61.85672, 25.91369],
              [61.856671, 25.914334],
              [61.85684, 25.914788],
              [61.856158, 25.914823],
              [61.855677, 25.914914],
              [61.8553, 25.915116],
              [61.855068, 25.915029],
              [61.854989, 25.915044],
              [61.854848, 25.914954],
              [61.854477, 25.91493],
              [61.854372, 25.914773],
              [61.854158, 25.914682],
              [61.853571, 25.914695],
              [61.853438, 25.914739],
              [61.853323, 25.914956],
              [61.853138, 25.914982],
              [61.85304, 25.914935],
              [61.852903, 25.914727],
              [61.852422, 25.914664],
              [61.851974, 25.914674],
              [61.851671, 25.914553],
              [61.851533, 25.914421],
              [61.851198, 25.9144],
              [61.851141, 25.914168],
              [61.851023, 25.914059],
              [61.850387, 25.914203],
              [61.849835, 25.914554],
              [61.849564, 25.914797],
              [61.849356, 25.914752],
              [61.849297, 25.914805],
              [61.848755, 25.914665],
              [61.848732, 25.91459],
              [61.848588, 25.91457],
              [61.84846, 25.914482],
              [61.84835, 25.914246],
              [61.848256, 25.914156],
              [61.84794, 25.914136],
              [61.847865, 25.914066],
              [61.847779, 25.914106],
              [61.847498, 25.914056],
              [61.847216, 25.9141],
              [61.846957, 25.914],
              [61.846494, 25.913914],
              [61.845749, 25.91398],
              [61.845611, 25.913945],
              [61.845233, 25.914068],
              [61.845019, 25.913959],
              [61.844539, 25.914054],
              [61.844013, 25.914097],
              [61.843874, 25.913904],
              [61.84371, 25.91386],
              [61.843594, 25.913658],
              [61.843449, 25.913204],
              [61.843195, 25.913168],
              [61.842515, 25.913132],
              [61.841698, 25.913259],
              [61.841309, 25.913257],
              [61.841163, 25.913285],
              [61.840895, 25.913447],
              [61.840731, 25.913422],
              [61.84066, 25.913464],
              [61.840335, 25.913371],
              [61.840112, 25.91346],
              [61.839688, 25.913255],
              [61.839354, 25.91328],
              [61.838972, 25.913208],
              [61.838783, 25.91322],
              [61.838535, 25.91315],
              [61.838311, 25.91323],
              [61.837779, 25.913115],
              [61.837075, 25.913178],
              [61.836996, 25.912992],
              [61.836785, 25.912719],
              [61.836749, 25.912492],
              [61.836502, 25.912011],
              [61.836519, 25.911629],
              [61.836489, 25.91149],
              [61.836387, 25.911388],
              [61.836256, 25.911478],
              [61.836193, 25.911457],
              [61.836126, 25.911498],
              [61.835339, 25.911473],
              [61.83508, 25.911415],
              [61.83492, 25.911487],
              [61.834691, 25.911432],
              [61.834503, 25.911328],
              [61.834281, 25.911421],
              [61.833758, 25.911323],
              [61.833135, 25.911343],
              [61.832665, 25.911282],
              [61.832446, 25.911347],
              [61.832335, 25.911307],
              [61.832101, 25.911309],
              [61.831706, 25.911402],
              [61.825024, 25.960406],
              [61.825001, 25.960903],
              [61.825075, 25.960991],
              [61.825098, 25.961221],
              [61.825, 25.961272],
              [61.8249, 25.961431],
              [61.824692, 25.961503],
              [61.824222, 25.961461],
              [61.82411, 25.961742],
              [61.823961, 25.961835],
              [61.823623, 25.961749],
              [61.823524, 25.961656],
              [61.823496, 25.961465],
              [61.823559, 25.961369],
              [61.82297, 25.961471],
              [61.822862, 25.961305],
              [61.822548, 25.961196],
              [61.822213, 25.961278],
              [61.821888, 25.961245],
              [61.821541, 25.961647],
              [61.821633, 25.961826],
              [61.822187, 25.961936],
              [61.822291, 25.962398],
              [61.822442, 25.962762],
              [61.822351, 25.963017],
              [61.822241, 25.963094],
              [61.82249, 25.963448],
              [61.822189, 25.963982],
              [61.822238, 25.964122],
              [61.821692, 25.964337],
              [61.821582, 25.964419],
              [61.821832, 25.964811],
              [61.821972, 25.964835],
              [61.822214, 25.964981],
              [61.822362, 25.965019],
              [61.822441, 25.965793],
              [61.821627, 25.965914],
              [61.821476, 25.966531],
              [61.821404, 25.966629],
              [61.821089, 25.966712],
              [61.820921, 25.966925],
              [61.820655, 25.966919],
              [61.820126, 25.967029],
              [61.819942, 25.966984],
              [61.819668, 25.966998],
              [61.81948, 25.967071],
              [61.819001, 25.967115],
              [61.818646, 25.967093],
              [61.818525, 25.967167],
              [61.818359, 25.967194],
              [61.818472, 25.967243],
              [61.818631, 25.967404],
              [61.818653, 25.967493],
              [61.818948, 25.967741],
              [61.819402, 25.967908],
              [61.819585, 25.968069],
              [61.819543, 25.968311],
              [61.819367, 25.968372],
              [61.819358, 25.968495],
              [61.819238, 25.968611],
              [61.819102, 25.968604],
              [61.819061, 25.968649],
              [61.819101, 25.968777],
              [61.818921, 25.968998],
              [61.818968, 25.96919],
              [61.819244, 25.96926],
              [61.81931, 25.96949],
              [61.819459, 25.969494],
              [61.819522, 25.969613],
              [61.819773, 25.969622],
              [61.820256, 25.969554],
              [61.820362, 25.969988],
              [61.820557, 25.969983],
              [61.820555, 25.969895],
              [61.821075, 25.969746],
              [61.821255, 25.969856],
              [61.821579, 25.969889],
              [61.821644, 25.970171],
              [61.82185, 25.970389],
              [61.821561, 25.970518],
              [61.82136, 25.970738],
              [61.821083, 25.970935],
              [61.820473, 25.971106],
              [61.820257, 25.971105],
              [61.820177, 25.971171],
              [61.81986, 25.971208],
              [61.819902, 25.97134],
              [61.819822, 25.971897],
              [61.819607, 25.971937],
              [61.819546, 25.972019],
              [61.819636, 25.972175],
              [61.819549, 25.972308],
              [61.819424, 25.972248],
              [61.819335, 25.972274],
              [61.819329, 25.972387],
              [61.819394, 25.972496],
              [61.819459, 25.97282],
              [61.81929, 25.972955],
              [61.819489, 25.973198],
              [61.819585, 25.973394],
              [61.819541, 25.973468],
              [61.819628, 25.973512],
              [61.819694, 25.973719],
              [61.819838, 25.973683],
              [61.820009, 25.973893],
              [61.820302, 25.973913],
              [61.820552, 25.97374],
              [61.820672, 25.97374],
              [61.820802, 25.973823],
              [61.821124, 25.973786],
              [61.821202, 25.973673],
              [61.821339, 25.973722],
              [61.821465, 25.973712],
              [61.821778, 25.973854],
              [61.821803, 25.973933],
              [61.821999, 25.97405],
              [61.822066, 25.974225],
              [61.822544, 25.974139],
              [61.822674, 25.974222],
              [61.822679, 25.974417],
              [61.822763, 25.974486],
              [61.82293, 25.974464],
              [61.8231, 25.974651],
              [61.823186, 25.974649],
              [61.823391, 25.97476],
              [61.823427, 25.974869],
              [61.823505, 25.974892],
              [61.823614, 25.975161],
              [61.823548, 25.975384],
              [61.823557, 25.975597],
              [61.824008, 25.975479],
              [61.824212, 25.975627],
              [61.824415, 25.975575],
              [61.824776, 25.975717],
              [61.82497, 25.975569],
              [61.825167, 25.975592],
              [61.825276, 25.975702],
              [61.825347, 25.975698],
              [61.825428, 25.975758],
              [61.825573, 25.975665],
              [61.825749, 25.975678],
              [61.825874, 25.97558],
              [61.826201, 25.975584],
              [61.826279, 25.975709],
              [61.82641, 25.975731],
              [61.826963, 25.975506],
              [61.827312, 25.975519],
              [61.827598, 25.976138],
              [61.82799, 25.976078],
              [61.828048, 25.976198],
              [61.82789, 25.976237],
              [61.827975, 25.976268],
              [61.827953, 25.976393],
              [61.82804, 25.976419],
              [61.827973, 25.976478],
              [61.82805, 25.976515],
              [61.828068, 25.97661],
              [61.828137, 25.97662],
              [61.82811, 25.976704],
              [61.828366, 25.97681],
              [61.828398, 25.97686],
              [61.828371, 25.977085],
              [61.828302, 25.977117],
              [61.828359, 25.977171],
              [61.828374, 25.977309],
              [61.828192, 25.977432],
              [61.828296, 25.977599],
              [61.828268, 25.977777],
              [61.828316, 25.977838],
              [61.828064, 25.978002],
              [61.827708, 25.977999],
              [61.827686, 25.977948],
              [61.827606, 25.977953],
              [61.827385, 25.978009],
              [61.827157, 25.978155],
              [61.827134, 25.978239],
              [61.8272, 25.97845],
              [61.827333, 25.978603],
              [61.827423, 25.978558],
              [61.827497, 25.978702],
              [61.827463, 25.978779],
              [61.827648, 25.978753],
              [61.827739, 25.978946],
              [61.827497, 25.979095],
              [61.827482, 25.979191],
              [61.827433, 25.979205],
              [61.827463, 25.979447],
              [61.827789, 25.979404],
              [61.827756, 25.979663],
              [61.827804, 25.979761],
              [61.827768, 25.97981],
              [61.827824, 25.979939],
              [61.827917, 25.979968],
              [61.828033, 25.98011],
              [61.828209, 25.980124],
              [61.828235, 25.980189],
              [61.828298, 25.980135],
              [61.828626, 25.980101],
              [61.828698, 25.980181],
              [61.828796, 25.980209],
              [61.828817, 25.980294],
              [61.829072, 25.980278],
              [61.82927, 25.980461],
              [61.829374, 25.980418],
              [61.829606, 25.980598],
              [61.829557, 25.980752],
              [61.829725, 25.98087],
              [61.829452, 25.980912],
              [61.828903, 25.981137],
              [61.829018, 25.981312],
              [61.829082, 25.981533],
              [61.829707, 25.981481],
              [61.829727, 25.981621],
              [61.829947, 25.981739],
              [61.830085, 25.981732],
              [61.830241, 25.981842],
              [61.830339, 25.982244],
              [61.830243, 25.982435],
              [61.830054, 25.982508],
              [61.830082, 25.982858],
              [61.831258, 25.982645],
              [61.831323, 25.982502],
              [61.831664, 25.982424],
              [61.832006, 25.982256],
              [61.83263, 25.982101],
              [61.833051, 25.982134],
              [61.833468, 25.982056],
              [61.833605, 25.982146],
              [61.83357, 25.9822],
              [61.83364, 25.982448],
              [61.833928, 25.982623],
              [61.833904, 25.982879],
              [61.833952, 25.982936],
              [61.833959, 25.983495],
              [61.833928, 25.983585],
              [61.833843, 25.983629],
              [61.833817, 25.983895],
              [61.833976, 25.983898],
              [61.834006, 25.983981],
              [61.834128, 25.983949],
              [61.834038, 25.984054],
              [61.834092, 25.98439],
              [61.834015, 25.984489],
              [61.834221, 25.984585],
              [61.834162, 25.984694],
              [61.834241, 25.984782],
              [61.834203, 25.984845],
              [61.834275, 25.984846],
              [61.834266, 25.984946],
              [61.834182, 25.984994],
              [61.833868, 25.985021],
              [61.833896, 25.985254],
              [61.833855, 25.98542],
              [61.833586, 25.985536],
              [61.833618, 25.985432],
              [61.833492, 25.985367],
              [61.833379, 25.985375],
              [61.833191, 25.985587],
              [61.832431, 25.985577],
              [61.832089, 25.985627],
              [61.83184, 25.985941],
              [61.831833, 25.986129],
              [61.831679, 25.986186],
              [61.831682, 25.986255],
              [61.831302, 25.98635],
              [61.831203, 25.986453],
              [61.830818, 25.986507],
              [61.830676, 25.986692],
              [61.830717, 25.986741],
              [61.830665, 25.9869],
              [61.830428, 25.987127],
              [61.830495, 25.987184],
              [61.830467, 25.987405],
              [61.830609, 25.987611],
              [61.830914, 25.987586],
              [61.830904, 25.987682],
              [61.831012, 25.987769],
              [61.831076, 25.987912],
              [61.830934, 25.988059],
              [61.830956, 25.988186],
              [61.83122, 25.988383],
              [61.83133, 25.988381],
              [61.831848, 25.988578],
              [61.831752, 25.988755],
              [61.83206, 25.988818],
              [61.83222, 25.988905],
              [61.832298, 25.989203],
              [61.832471, 25.989184],
              [61.832633, 25.989397],
              [61.832849, 25.989398],
              [61.833045, 25.989492],
              [61.833085, 25.989596],
              [61.832758, 25.989728],
              [61.832656, 25.989803],
              [61.832673, 25.989852],
              [61.832512, 25.989901],
              [61.832516, 25.989993],
              [61.832447, 25.990044],
              [61.83223, 25.99008],
              [61.832049, 25.990222],
              [61.832112, 25.990345],
              [61.83209, 25.990527],
              [61.832498, 25.990492],
              [61.832922, 25.990538],
              [61.833282, 25.990521],
              [61.833518, 25.99072],
              [61.833498, 25.990854],
              [61.833726, 25.991021],
              [61.833698, 25.991139],
              [61.833621, 25.991317],
              [61.833347, 25.991429],
              [61.833371, 25.991588],
              [61.833196, 25.991677],
              [61.833058, 25.991914],
              [61.832971, 25.991874],
              [61.832503, 25.991883],
              [61.832426, 25.991841],
              [61.832169, 25.991885],
              [61.832209, 25.991794],
              [61.832125, 25.991688],
              [61.831956, 25.991682],
              [61.831921, 25.99146],
              [61.83163, 25.991487],
              [61.831641, 25.991611],
              [61.83142, 25.991746],
              [61.831247, 25.991606],
              [61.831019, 25.991616],
              [61.830653, 25.991709],
              [61.830584, 25.991815],
              [61.830467, 25.991888],
              [61.830405, 25.992204],
              [61.830445, 25.992855],
              [61.830601, 25.992886],
              [61.830633, 25.992974],
              [61.830708, 25.992969],
              [61.830707, 25.993062],
              [61.830767, 25.993112],
              [61.831071, 25.993064],
              [61.831116, 25.993186],
              [61.831031, 25.993211],
              [61.831071, 25.993316],
              [61.830971, 25.993437],
              [61.830985, 25.993612],
              [61.831151, 25.993604],
              [61.831237, 25.993663],
              [61.831655, 25.993607],
              [61.831815, 25.993633],
              [61.831918, 25.993721],
              [61.831973, 25.993632],
              [61.832038, 25.993624],
              [61.832154, 25.993803],
              [61.832007, 25.993929],
              [61.832128, 25.994069],
              [61.832142, 25.994342],
              [61.832252, 25.994359],
              [61.832359, 25.994521],
              [61.83205, 25.994808],
              [61.8318, 25.994944],
              [61.831759, 25.995068],
              [61.831552, 25.995182],
              [61.831746, 25.995267],
              [61.831812, 25.995479],
              [61.83192, 25.995608],
              [61.832139, 25.995604],
              [61.832445, 25.995831],
              [61.832312, 25.995875],
              [61.832226, 25.995975],
              [61.832282, 25.996011],
              [61.832289, 25.996117],
              [61.832115, 25.996188],
              [61.832581, 25.996329],
              [61.83276, 25.996514],
              [61.832998, 25.996507],
              [61.833128, 25.996567],
              [61.833271, 25.996484],
              [61.833335, 25.996551],
              [61.833705, 25.996654],
              [61.834387, 25.996619],
              [61.834666, 25.996543],
              [61.834955, 25.99653],
              [61.835101, 25.996479],
              [61.83511, 25.996398],
              [61.835276, 25.996311],
              [61.835374, 25.996516],
              [61.835519, 25.996578],
              [61.835574, 25.996806],
              [61.835529, 25.99709],
              [61.835597, 25.997072],
              [61.835837, 25.997233],
              [61.835761, 25.997588],
              [61.835581, 25.997771],
              [61.835456, 25.99779],
              [61.835627, 25.997952],
              [61.835958, 25.998079],
              [61.836192, 25.998424],
              [61.836022, 25.99855],
              [61.835586, 25.998678],
              [61.835613, 25.998888],
              [61.835509, 25.999025],
              [61.835539, 25.999116],
              [61.835645, 25.999172],
              [61.835624, 25.999235],
              [61.835696, 25.999311],
              [61.83565, 25.9994],
              [61.835715, 25.999447],
              [61.835773, 25.999622],
              [61.835867, 25.999634],
              [61.835823, 25.99983],
              [61.835872, 26.000015],
              [61.835764, 26.00007],
              [61.835813, 26.000319],
              [61.83575, 26.000499],
              [61.835767, 26.000904],
              [61.835869, 26.000959],
              [61.836002, 26.000898],
              [61.836324, 26.000883],
              [61.836408, 26.001068],
              [61.836633, 26.001113],
              [61.83674, 26.001106],
              [61.836971, 26.000871],
              [61.837141, 26.000915],
              [61.837114, 26.001045],
              [61.837237, 26.001235],
              [61.837724, 26.001443],
              [61.837525, 26.001778],
              [61.837554, 26.002064],
              [61.837723, 26.00211],
              [61.83791, 26.00235],
              [61.838019, 26.00231],
              [61.838426, 26.002384],
              [61.838521, 26.002509],
              [61.8385, 26.002627],
              [61.838195, 26.003027],
              [61.838143, 26.003182],
              [61.838153, 26.003362],
              [61.838189, 26.0034],
              [61.838231, 26.003382],
              [61.83833, 26.0036],
              [61.838137, 26.003809],
              [61.837936, 26.003939],
              [61.837886, 26.004091],
              [61.837916, 26.004149],
              [61.838059, 26.00416],
              [61.838037, 26.004243],
              [61.837978, 26.004263],
              [61.838045, 26.004348],
              [61.838466, 26.004299],
              [61.838533, 26.004407],
              [61.838728, 26.004562],
              [61.838723, 26.004773],
              [61.838471, 26.004888],
              [61.838472, 26.004979],
              [61.838497, 26.005119],
              [61.838635, 26.005174],
              [61.838744, 26.005278],
              [61.838711, 26.005374],
              [61.838754, 26.005438],
              [61.838661, 26.005635],
              [61.838686, 26.005794],
              [61.838651, 26.005895],
              [61.838955, 26.005975],
              [61.838935, 26.006085],
              [61.83883, 26.006206],
              [61.838772, 26.006393],
              [61.838333, 26.006397],
              [61.838259, 26.006637],
              [61.83774, 26.006701],
              [61.837451, 26.006677],
              [61.83734, 26.006766],
              [61.837293, 26.007113],
              [61.837664, 26.007302],
              [61.837466, 26.007568],
              [61.837463, 26.007787],
              [61.837568, 26.007907],
              [61.837599, 26.008066],
              [61.837677, 26.008176],
              [61.837222, 26.008209],
              [61.83719, 26.008284],
              [61.836575, 26.00835],
              [61.836405, 26.008446],
              [61.836614, 26.00873],
              [61.836526, 26.008824],
              [61.836231, 26.00892],
              [61.836149, 26.009008],
              [61.836266, 26.009217],
              [61.836295, 26.009424],
              [61.836423, 26.009547],
              [61.836677, 26.009667],
              [61.836981, 26.009584],
              [61.83719, 26.009645],
              [61.837353, 26.009543],
              [61.837317, 26.009487],
              [61.837377, 26.009396],
              [61.837563, 26.009348],
              [61.837815, 26.009418],
              [61.838049, 26.009564],
              [61.838169, 26.009565],
              [61.838278, 26.009657],
              [61.838518, 26.009592],
              [61.83869, 26.009714],
              [61.838847, 26.009593],
              [61.839176, 26.009611],
              [61.839567, 26.0098],
              [61.839585, 26.009933],
              [61.839811, 26.010157],
              [61.839773, 26.010277],
              [61.839887, 26.010454],
              [61.839895, 26.010693],
              [61.840086, 26.010742],
              [61.840291, 26.010897],
              [61.840926, 26.010896],
              [61.841256, 26.010714],
              [61.84168, 26.010748],
              [61.842094, 26.010881],
              [61.84222, 26.011025],
              [61.842725, 26.011258],
              [61.843812, 26.011376],
              [61.844261, 26.011507],
              [61.844286, 26.011786],
              [61.84423, 26.011876],
              [61.844296, 26.012045],
              [61.844286, 26.012151],
              [61.844433, 26.012364],
              [61.844532, 26.012855],
              [61.844365, 26.012841],
              [61.844321, 26.013038],
              [61.844173, 26.013228],
              [61.844333, 26.013259],
              [61.84464, 26.013239],
              [61.844588, 26.013551],
              [61.844649, 26.013723],
              [61.8444, 26.013719],
              [61.844374, 26.013874],
              [61.844467, 26.013905],
              [61.844385, 26.014023],
              [61.844454, 26.014339],
              [61.844344, 26.014551],
              [61.844216, 26.014618],
              [61.844319, 26.014762],
              [61.844096, 26.014823],
              [61.843806, 26.014829],
              [61.843753, 26.014893],
              [61.843728, 26.015106],
              [61.843553, 26.015226],
              [61.843544, 26.015334],
              [61.843801, 26.015469],
              [61.844048, 26.015859],
              [61.844213, 26.016231],
              [61.844195, 26.016404],
              [61.844243, 26.016539],
              [61.844463, 26.016699],
              [61.844525, 26.016856],
              [61.844973, 26.01705],
              [61.845143, 26.017172],
              [61.845176, 26.017604],
              [61.845268, 26.017618],
              [61.845366, 26.017833],
              [61.845774, 26.018043],
              [61.846007, 26.018096],
              [61.846175, 26.018455],
              [61.846411, 26.018672],
              [61.846399, 26.018903],
              [61.846292, 26.018905],
              [61.84621, 26.01897],
              [61.846083, 26.018963],
              [61.845953, 26.018891],
              [61.845952, 26.0188],
              [61.845612, 26.018715],
              [61.845535, 26.018878],
              [61.845395, 26.018886],
              [61.845227, 26.018989],
              [61.845121, 26.018998],
              [61.84499, 26.019129],
              [61.844526, 26.019118],
              [61.844335, 26.019221],
              [61.844196, 26.019136],
              [61.843907, 26.019081],
              [61.843386, 26.019117],
              [61.843343, 26.019088],
              [61.843216, 26.019158],
              [61.842794, 26.01926],
              [61.842612, 26.019409],
              [61.842632, 26.019473],
              [61.842862, 26.019638],
              [61.842721, 26.0197],
              [61.842677, 26.019983],
              [61.842518, 26.020066],
              [61.842563, 26.020298],
              [61.842684, 26.020478],
              [61.842653, 26.020616],
              [61.842689, 26.020784],
              [61.842622, 26.020937],
              [61.842381, 26.021096],
              [61.841694, 26.021047],
              [61.840999, 26.021099],
              [61.841032, 26.021298],
              [61.841301, 26.021841],
              [61.841283, 26.022243],
              [61.841347, 26.022305],
              [61.8414, 26.022541],
              [61.840631, 26.022721],
              [61.840626, 26.022857],
              [61.840489, 26.022966],
              [61.840485, 26.023094],
              [61.8406, 26.023151],
              [61.840778, 26.023458],
              [61.840863, 26.023545],
              [61.841014, 26.023592],
              [61.84089, 26.02376],
              [61.840884, 26.023904],
              [61.840701, 26.024092],
              [61.840652, 26.024344],
              [61.840535, 26.024448],
              [61.840372, 26.024716],
              [61.840413, 26.02479],
              [61.840419, 26.025072],
              [61.840265, 26.02499],
              [61.840067, 26.024965],
              [61.839839, 26.025141],
              [61.839544, 26.025176],
              [61.83926, 26.025101],
              [61.839071, 26.024934],
              [61.838779, 26.024978],
              [61.838311, 26.024902],
              [61.837876, 26.024942],
              [61.837539, 26.024904],
              [61.837046, 26.024914],
              [61.836721, 26.025099],
              [61.836295, 26.024994],
              [61.835949, 26.025082],
              [61.835599, 26.025104],
              [61.83554, 26.025231],
              [61.835241, 26.025333],
              [61.835298, 26.025644],
              [61.8354, 26.025826],
              [61.835374, 26.025966],
              [61.835303, 26.026152],
              [61.835001, 26.026305],
              [61.835098, 26.026472],
              [61.835301, 26.026639],
              [61.835356, 26.026916],
              [61.834785, 26.027087],
              [61.83467, 26.027173],
              [61.833933, 26.027162],
              [61.833303, 26.027267],
              [61.833193, 26.027207],
              [61.832899, 26.027246],
              [61.832635, 26.02718],
              [61.832491, 26.027222],
              [61.832056, 26.027233],
              [61.831696, 26.027356],
              [61.831486, 26.027519],
              [61.831252, 26.027561],
              [61.831111, 26.027517],
              [61.831028, 26.027539],
              [61.830937, 26.028223],
              [61.831022, 26.028289],
              [61.831069, 26.028511],
              [61.831009, 26.028565],
              [61.831053, 26.028605],
              [61.830977, 26.028779],
              [61.830795, 26.02879],
              [61.830746, 26.028829],
              [61.830682, 26.029167],
              [61.830505, 26.029346],
              [61.830436, 26.029521],
              [61.830392, 26.029556],
              [61.830055, 26.029518],
              [61.829952, 26.029687],
              [61.830035, 26.029834],
              [61.830139, 26.029894],
              [61.83005, 26.030013],
              [61.830137, 26.030344],
              [61.830099, 26.030437],
              [61.830114, 26.03065],
              [61.829097, 26.030896],
              [61.828775, 26.031115],
              [61.828691, 26.031244],
              [61.828804, 26.031239],
              [61.829078, 26.031415],
              [61.829303, 26.031488],
              [61.829337, 26.031804],
              [61.830692, 26.031657],
              [61.831504, 26.031395],
              [61.831748, 26.031413],
              [61.832317, 26.031315],
              [61.832434, 26.031398],
              [61.832547, 26.031718],
              [61.832793, 26.031787],
              [61.833212, 26.031702],
              [61.833564, 26.031794],
              [61.833879, 26.031771],
              [61.83394, 26.031857],
              [61.83414, 26.031923],
              [61.834463, 26.03221],
              [61.834505, 26.032355],
              [61.834668, 26.032384],
              [61.835044, 26.032188],
              [61.835805, 26.032131],
              [61.836072, 26.032196],
              [61.836108, 26.032298],
              [61.836181, 26.032341],
              [61.836631, 26.032282],
              [61.837521, 26.032327],
              [61.837466, 26.032484],
              [61.83746, 26.032721],
              [61.837706, 26.032827],
              [61.837694, 26.033017],
              [61.837765, 26.033127],
              [61.837753, 26.033306],
              [61.837932, 26.033392],
              [61.838622, 26.033461],
              [61.839005, 26.033708],
              [61.839054, 26.033981],
              [61.839021, 26.034126],
              [61.83905, 26.03446],
              [61.839173, 26.034916],
              [61.839149, 26.035116],
              [61.83933, 26.035209],
              [61.839675, 26.035287],
              [61.839816, 26.035455],
              [61.84005, 26.035569],
              [61.840087, 26.035722],
              [61.840048, 26.035788],
              [61.840141, 26.035961],
              [61.84047, 26.035842],
              [61.840859, 26.03563],
              [61.840981, 26.035592],
              [61.841148, 26.03561],
              [61.841156, 26.035751],
              [61.840975, 26.035869],
              [61.840954, 26.036349],
              [61.840892, 26.036395],
              [61.840914, 26.036479],
              [61.840849, 26.0367],
              [61.840684, 26.036949],
              [61.84074, 26.037115],
              [61.840859, 26.037241],
              [61.840941, 26.037567],
              [61.841038, 26.037641],
              [61.84104, 26.037773],
              [61.84096, 26.037883],
              [61.840988, 26.038034],
              [61.840889, 26.038275],
              [61.840287, 26.03845],
              [61.840305, 26.038599],
              [61.840407, 26.038747],
              [61.840471, 26.039095],
              [61.840384, 26.039368],
              [61.840144, 26.039474],
              [61.840075, 26.039561],
              [61.840042, 26.039716],
              [61.840092, 26.039804],
              [61.840085, 26.040011],
              [61.840015, 26.040038],
              [61.840052, 26.040109],
              [61.839987, 26.040278],
              [61.839585, 26.040363],
              [61.83965, 26.0409],
              [61.839517, 26.040889],
              [61.839375, 26.040941],
              [61.839281, 26.040978],
              [61.839216, 26.041064],
              [61.83855, 26.041021],
              [61.838275, 26.040942],
              [61.838148, 26.041108],
              [61.837988, 26.041172],
              [61.837911, 26.041372],
              [61.837766, 26.041391],
              [61.837573, 26.041587],
              [61.837501, 26.041604],
              [61.837483, 26.041662],
              [61.837527, 26.041716],
              [61.83738, 26.041909],
              [61.837107, 26.041957],
              [61.836844, 26.042157],
              [61.836453, 26.042192],
              [61.836183, 26.042141],
              [61.835873, 26.042409],
              [61.83532, 26.042434],
              [61.835511, 26.043229],
              [61.835842, 26.043432],
              [61.836266, 26.043421],
              [61.836375, 26.043474],
              [61.836267, 26.043657],
              [61.836315, 26.043772],
              [61.836126, 26.043795],
              [61.836147, 26.043884],
              [61.836045, 26.04397],
              [61.836015, 26.044078],
              [61.835929, 26.044121],
              [61.835599, 26.044144],
              [61.835468, 26.044272],
              [61.835493, 26.044311],
              [61.834509, 26.04438],
              [61.834423, 26.044545],
              [61.834456, 26.044585],
              [61.834393, 26.044746],
              [61.834202, 26.04484],
              [61.834011, 26.044876],
              [61.834112, 26.045077],
              [61.834062, 26.045134],
              [61.834182, 26.045166],
              [61.834258, 26.04532],
              [61.834494, 26.045308],
              [61.834617, 26.045353],
              [61.834885, 26.045228],
              [61.835315, 26.04527],
              [61.835495, 26.045642],
              [61.835642, 26.04564],
              [61.835926, 26.045808],
              [61.835953, 26.046013],
              [61.836376, 26.046016],
              [61.83713, 26.045924],
              [61.837204, 26.046092],
              [61.837563, 26.045974],
              [61.83755, 26.046282],
              [61.837433, 26.046307],
              [61.83729, 26.046632],
              [61.83714, 26.046732],
              [61.837105, 26.046874],
              [61.836983, 26.046876],
              [61.836864, 26.046796],
              [61.836512, 26.046827],
              [61.836327, 26.046883],
              [61.836302, 26.047023],
              [61.836331, 26.04709],
              [61.836773, 26.047098],
              [61.836827, 26.047282],
              [61.836973, 26.047308],
              [61.836943, 26.047441],
              [61.837085, 26.047891],
              [61.837364, 26.048153],
              [61.837441, 26.04847],
              [61.837581, 26.048756],
              [61.837767, 26.049038],
              [61.83798, 26.049096],
              [61.838079, 26.049078],
              [61.838214, 26.04956],
              [61.838133, 26.049641],
              [61.838195, 26.049943],
              [61.838175, 26.050171],
              [61.838296, 26.050294],
              [61.838314, 26.050353],
              [61.838248, 26.050382],
              [61.838311, 26.050575],
              [61.83816, 26.050686],
              [61.838027, 26.050908],
              [61.837899, 26.050916],
              [61.838118, 26.051453],
              [61.838068, 26.05189],
              [61.838123, 26.051967],
              [61.838123, 26.052167],
              [61.838079, 26.052259],
              [61.837989, 26.052272],
              [61.83774, 26.052448],
              [61.837609, 26.052464],
              [61.837442, 26.05275],
              [61.837316, 26.052906],
              [61.837219, 26.052955],
              [61.83701, 26.053278],
              [61.836761, 26.053409],
              [61.836521, 26.053404],
              [61.836357, 26.053497],
              [61.836062, 26.053518],
              [61.836044, 26.053483],
              [61.835857, 26.053456],
              [61.835776, 26.053587],
              [61.835671, 26.053614],
              [61.835592, 26.053726],
              [61.83548, 26.053717],
              [61.835354, 26.053832],
              [61.835503, 26.054017],
              [61.835711, 26.054603],
              [61.835724, 26.05491],
              [61.83551, 26.055107],
              [61.835405, 26.055269],
              [61.835523, 26.055603],
              [61.835621, 26.05563],
              [61.835644, 26.055805],
              [61.835268, 26.056178],
              [61.835247, 26.056257],
              [61.8352, 26.05629],
              [61.835095, 26.05625],
              [61.834963, 26.056308],
              [61.834784, 26.056536],
              [61.834664, 26.056605],
              [61.834454, 26.057106],
              [61.834195, 26.05714],
              [61.833938, 26.057374],
              [61.833767, 26.057407],
              [61.833576, 26.057534],
              [61.833158, 26.057679],
              [61.833071, 26.057822],
              [61.833074, 26.057899],
              [61.832981, 26.057949],
              [61.832964, 26.05802],
              [61.832916, 26.059023],
              [61.832838, 26.059377],
              [61.83293, 26.059389],
              [61.833014, 26.059528],
              [61.833176, 26.059664],
              [61.833539, 26.05972],
              [61.833802, 26.059835],
              [61.833969, 26.059967],
              [61.834206, 26.059994],
              [61.834307, 26.059963],
              [61.834643, 26.060051],
              [61.834579, 26.060235],
              [61.834688, 26.060413],
              [61.834678, 26.060521],
              [61.834513, 26.060633],
              [61.834473, 26.060725],
              [61.834594, 26.060973],
              [61.83474, 26.06099],
              [61.834798, 26.061056],
              [61.834971, 26.061117],
              [61.834917, 26.061237],
              [61.835013, 26.061254],
              [61.834999, 26.061301],
              [61.835113, 26.061311],
              [61.835203, 26.061415],
              [61.835242, 26.061677],
              [61.83507, 26.06184],
              [61.834832, 26.062302],
              [61.834836, 26.062452],
              [61.834749, 26.062537],
              [61.834726, 26.062794],
              [61.834637, 26.062794],
              [61.83459, 26.06285],
              [61.834374, 26.06324],
              [61.834541, 26.063414],
              [61.834505, 26.063491],
              [61.83456, 26.063732],
              [61.834616, 26.063754],
              [61.834614, 26.063872],
              [61.834725, 26.063966],
              [61.834915, 26.064008],
              [61.834953, 26.064237],
              [61.83517, 26.064359],
              [61.83528, 26.064373],
              [61.835473, 26.064211],
              [61.835537, 26.064206],
              [61.835557, 26.064147],
              [61.835652, 26.064138],
              [61.835872, 26.063968],
              [61.836254, 26.063976],
              [61.836407, 26.064085],
              [61.836718, 26.064058],
              [61.83692, 26.06383],
              [61.837241, 26.063702],
              [61.83748, 26.063929],
              [61.83759, 26.063943],
              [61.838081, 26.06423],
              [61.838506, 26.064018],
              [61.838798, 26.06413],
              [61.839282, 26.064167],
              [61.839958, 26.064585],
              [61.840157, 26.064604],
              [61.840587, 26.064747],
              [61.840872, 26.064897],
              [61.841136, 26.064916],
              [61.841388, 26.065158],
              [61.846593, 26.0956644],
              [61.854211, 26.140299],
              [61.86017, 26.17597],
              [61.893165, 26.233464],
              [61.889278, 26.251972],
              [61.8903099, 26.2521098],
              [61.8909771, 26.2529107],
              [61.8912843, 26.2532241],
              [61.8916535, 26.2531954],
              [61.8919705, 26.2531848],
              [61.892231, 26.253308],
              [61.892949, 26.253245],
              [61.89335, 26.253491],
              [61.893571, 26.253538],
              [61.893728, 26.253472],
              [61.89391, 26.253262],
              [61.893938, 26.253157],
              [61.894072, 26.253137],
              [61.894261, 26.253254],
              [61.894356, 26.253247],
              [61.894452, 26.253335],
              [61.894813, 26.253399],
              [61.894795, 26.253475],
              [61.894947, 26.253546],
              [61.894972, 26.25456],
              [61.894778, 26.255339],
              [61.894632, 26.255493],
              [61.894527, 26.255742],
              [61.894563, 26.256092],
              [61.89445, 26.256247],
              [61.894401, 26.256494],
              [61.894405, 26.256891],
              [61.894462, 26.257079],
              [61.894863, 26.257507],
              [61.895169, 26.257614],
              [61.895398, 26.257593],
              [61.895466, 26.257622],
              [61.895609, 26.257853],
              [61.895611, 26.258067],
              [61.895767, 26.258292],
              [61.89591, 26.25835],
              [61.895877, 26.258491],
              [61.895909, 26.258592],
              [61.896003, 26.258685],
              [61.896059, 26.258913],
              [61.896151, 26.259019],
              [61.896165, 26.259126],
              [61.896078, 26.259208],
              [61.8961, 26.259343],
              [61.89619, 26.259487],
              [61.896335, 26.259555],
              [61.896565, 26.259969],
              [61.896586, 26.260212],
              [61.896509, 26.260285],
              [61.896429, 26.26048],
              [61.896464, 26.260583],
              [61.8973825, 26.262188],
              [61.898921, 26.262489],
              [61.8989484, 26.2618541],
              [61.8993047, 26.2618349],
              [61.899516, 26.262496],
              [61.899529, 26.2626],
              [61.899448, 26.262619],
              [61.899447, 26.262697],
              [61.899555, 26.26274],
              [61.900289, 26.263364],
              [61.900356, 26.263335],
              [61.900461, 26.263396],
              [61.900522, 26.263386],
              [61.900893, 26.263194],
              [61.900907, 26.263153],
              [61.901122, 26.263115],
              [61.901155, 26.263071],
              [61.901218, 26.263175],
              [61.901359, 26.263089],
              [61.9015, 26.263078],
              [61.901538, 26.263128],
              [61.901599, 26.263115],
              [61.901643, 26.263186],
              [61.901867, 26.263228],
              [61.902015, 26.263183],
              [61.90206, 26.263132],
              [61.9024311, 26.2627598],
              [61.902733, 26.262584],
              [61.902852, 26.262522],
              [61.902953, 26.262472],
              [61.903649, 26.262505],
              [61.904061, 26.2623],
              [61.904165, 26.262059],
              [61.904337, 26.26185],
              [61.904803, 26.261638],
              [61.905054, 26.261707],
              [61.905172, 26.261658],
              [61.905118, 26.261589],
              [61.905141, 26.261432],
              [61.905308, 26.261236],
              [61.905353, 26.261217],
              [61.905505, 26.261285],
              [61.905702, 26.261249],
              [61.905828, 26.261306],
              [61.906252, 26.26119],
              [61.906454, 26.261303],
              [61.906551, 26.261291],
              [61.906674, 26.261201],
              [61.906711, 26.260643],
              [61.906827, 26.26049],
              [61.90692, 26.260147],
              [61.907028, 26.259998],
              [61.906953, 26.259771],
              [61.90708, 26.259693],
              [61.907172, 26.25951],
              [61.90731, 26.259497],
              [61.907441, 26.259542],
              [61.907609, 26.259501],
              [61.90799, 26.259556],
              [61.908275, 26.25975],
              [61.908616, 26.259586],
              [61.908818, 26.259393],
              [61.908799, 26.259202],
              [61.908839, 26.259131],
              [61.909135, 26.258807],
              [61.909133, 26.258535],
              [61.90958, 26.258369],
              [61.909655, 26.258169],
              [61.90997, 26.257913],
              [61.910039, 26.257796],
              [61.910006, 26.257596],
              [61.910241, 26.257323],
              [61.910307, 26.257172],
              [61.910488, 26.257043],
              [61.910476, 26.256891],
              [61.910553, 26.256728],
              [61.910527, 26.256436],
              [61.91058, 26.256308],
              [61.910706, 26.256248],
              [61.910745, 26.256047],
              [61.910721, 26.255862],
              [61.91081, 26.255819],
              [61.910796, 26.255572],
              [61.910872, 26.25532],
              [61.910966, 26.255138],
              [61.911211, 26.255074],
              [61.911301, 26.254811],
              [61.911631, 26.254796],
              [61.911823, 26.255246],
              [61.911895, 26.255242],
              [61.912145, 26.255361],
              [61.91233, 26.255588],
              [61.912416, 26.255791],
              [61.912848, 26.255858],
              [61.912966, 26.255821],
              [61.913035, 26.255894],
              [61.913203, 26.255866],
              [61.913246, 26.255847],
              [61.913344, 26.255585],
              [61.913499, 26.255508],
              [61.91357, 26.255309],
              [61.913629, 26.25526],
              [61.913944, 26.255126],
              [61.914043, 26.255163],
              [61.914304, 26.255088],
              [61.914342, 26.254975],
              [61.914632, 26.254639],
              [61.914654, 26.254575],
              [61.914609, 26.254516],
              [61.914657, 26.254394],
              [61.91489, 26.254434],
              [61.915259, 26.254312],
              [61.915315, 26.253824],
              [61.91538, 26.253863],
              [61.915794, 26.253836],
              [61.916193, 26.253958],
              [61.916365, 26.253895],
              [61.916569, 26.253726],
              [61.916668, 26.253766],
              [61.91674, 26.253861],
              [61.916903, 26.253833],
              [61.917105, 26.253862],
              [61.917421, 26.253761],
              [61.917626, 26.253824],
              [61.917809, 26.254067],
              [61.91815, 26.254135],
              [61.918281, 26.254363],
              [61.918405, 26.254388],
              [61.918538, 26.254495],
              [61.918615, 26.25449],
              [61.918622, 26.254369],
              [61.91875, 26.254133],
              [61.918939, 26.254154],
              [61.919064, 26.254099],
              [61.919096, 26.253968],
              [61.919409, 26.253994],
              [61.919678, 26.254109],
              [61.919795, 26.25428],
              [61.919944, 26.25434],
              [61.920709, 26.254479],
              [61.920703, 26.254731],
              [61.920823, 26.254746],
              [61.921142, 26.254966],
              [61.921168, 26.255171],
              [61.921583, 26.255334],
              [61.921663, 26.255447],
              [61.921781, 26.255441],
              [61.92189, 26.255508],
              [61.922085, 26.255509],
              [61.922156, 26.255619],
              [61.92213, 26.255682],
              [61.922261, 26.255713],
              [61.922652, 26.255624],
              [61.92277, 26.255555],
              [61.922987, 26.255586],
              [61.923002, 26.255687],
              [61.923209, 26.255605],
              [61.923354, 26.255651],
              [61.923588, 26.255598],
              [61.923671, 26.255447],
              [61.923863, 26.255429],
              [61.924067, 26.255311],
              [61.924136, 26.255482],
              [61.924253, 26.255516],
              [61.924272, 26.255619],
              [61.924559, 26.255961],
              [61.924823, 26.256062],
              [61.924972, 26.256179],
              [61.925122, 26.256199],
              [61.925216, 26.256167],
              [61.9256, 26.255912],
              [61.925746, 26.256012],
              [61.925879, 26.255988],
              [61.925921, 26.255937],
              [61.92616, 26.255956],
              [61.926218, 26.255869],
              [61.926517, 26.255793],
              [61.926607, 26.255807],
              [61.928451, 26.257087],
              [61.928791, 26.25706],
              [61.928825, 26.257116],
              [61.929041, 26.257097],
              [61.929408, 26.256843],
              [61.929525, 26.256847],
              [61.92962, 26.256636],
              [61.930218, 26.256614],
              [61.930315, 26.256517],
              [61.930614, 26.256367],
              [61.930722, 26.256387],
              [61.930973, 26.256299],
              [61.931262, 26.256564],
              [61.93133, 26.256742],
              [61.931502, 26.256859],
              [61.931868, 26.257009],
              [61.932028, 26.257176],
              [61.932135, 26.257194],
              [61.932194, 26.257387],
              [61.932298, 26.257458],
              [61.932212, 26.257617],
              [61.932337, 26.257829],
              [61.93232, 26.258104],
              [61.932564, 26.25804],
              [61.932647, 26.258092],
              [61.932792, 26.258073],
              [61.932812, 26.258111],
              [61.93287, 26.258099],
              [61.933115, 26.258197],
              [61.933332, 26.258138],
              [61.933387, 26.258062],
              [61.933546, 26.258045],
              [61.933679, 26.25796],
              [61.93377, 26.258022],
              [61.93394, 26.25793],
              [61.934051, 26.258004],
              [61.934316, 26.257998],
              [61.9344, 26.258056],
              [61.93467, 26.257941],
              [61.935058, 26.258069],
              [61.93517, 26.257979],
              [61.935413, 26.257995],
              [61.935468, 26.258061],
              [61.9357, 26.258004],
              [61.935963, 26.258078],
              [61.93616, 26.258],
              [61.936234, 26.25815],
              [61.936226, 26.258373],
              [61.936131, 26.25852],
              [61.936122, 26.258646],
              [61.936313, 26.258665],
              [61.936271, 26.25873],
              [61.936289, 26.258818],
              [61.936343, 26.258811],
              [61.936566, 26.259475],
              [61.936692, 26.25948],
              [61.936879, 26.259624],
              [61.937207, 26.259602],
              [61.937307, 26.259679],
              [61.937447, 26.259706],
              [61.937688, 26.259896],
              [61.938048, 26.259925],
              [61.938195, 26.25998],
              [61.938366, 26.259968],
              [61.938428, 26.260015],
              [61.938769, 26.259983],
              [61.938935, 26.260057],
              [61.939084, 26.260296],
              [61.939362, 26.260342],
              [61.93954, 26.260495],
              [61.939778, 26.260558],
              [61.939905, 26.260523],
              [61.940329, 26.260596],
              [61.940346, 26.26064],
              [61.940455, 26.260675],
              [61.940606, 26.260682],
              [61.940763, 26.260782],
              [61.940789, 26.261044],
              [61.94093, 26.2612],
              [61.941006, 26.261217],
              [61.941056, 26.261396],
              [61.941402, 26.261351],
              [61.941458, 26.261568],
              [61.941656, 26.261603],
              [61.941788, 26.261696],
              [61.941927, 26.261705],
              [61.94192, 26.261754],
              [61.942044, 26.261814],
              [61.942087, 26.261959],
              [61.942253, 26.262078],
              [61.942303, 26.262322],
              [61.942462, 26.262623],
              [61.942703, 26.262866],
              [61.942837, 26.262954],
              [61.942916, 26.262918],
              [61.943023, 26.262968],
              [61.943109, 26.262946],
              [61.943287, 26.262992],
              [61.94342, 26.263097],
              [61.943633, 26.263106],
              [61.943589, 26.263172],
              [61.943617, 26.263226],
              [61.943921, 26.263464],
              [61.944029, 26.26336],
              [61.944248, 26.263403],
              [61.945125, 26.26311],
              [61.94542, 26.263125],
              [61.945449, 26.263159],
              [61.945546, 26.263097],
              [61.945646, 26.263097],
              [61.945766, 26.263003],
              [61.94602, 26.262968],
              [61.946289, 26.262809],
              [61.946481, 26.262768],
              [61.946632, 26.26267],
              [61.946592, 26.262568],
              [61.946974, 26.262545],
              [61.947019, 26.262579],
              [61.947024, 26.262715],
              [61.947179, 26.262918],
              [61.947304, 26.262897],
              [61.947504, 26.262971],
              [61.947622, 26.263192],
              [61.947567, 26.263298],
              [61.94772, 26.263334],
              [61.947751, 26.263442],
              [61.947874, 26.263435],
              [61.947984, 26.263515],
              [61.948049, 26.263735],
              [61.948043, 26.263966],
              [61.948207, 26.264085],
              [61.948424, 26.264131],
              [61.94852, 26.264457],
              [61.948567, 26.26449],
              [61.948825, 26.264575],
              [61.948936, 26.264542],
              [61.949205, 26.264234],
              [61.949411, 26.264172],
              [61.949519, 26.264088],
              [61.949717, 26.264063],
              [61.949806, 26.264],
              [61.950063, 26.26404],
              [61.950358, 26.263917],
              [61.950543, 26.263912],
              [61.950738, 26.263831],
              [61.951465, 26.264164],
              [61.951599, 26.264274],
              [61.952236, 26.264334],
              [61.952189, 26.264792],
              [61.952282, 26.264905],
              [61.952328, 26.265115],
              [61.952421, 26.265181],
              [61.952562, 26.265404],
              [61.952672, 26.265467],
              [61.953098, 26.265408],
              [61.953729, 26.265502],
              [61.953911, 26.265412],
              [61.954005, 26.265271],
              [61.954078, 26.265299],
              [61.954468, 26.2652],
              [61.954785, 26.265225],
              [61.955025, 26.265069],
              [61.955248, 26.264832],
              [61.955467, 26.264745],
              [61.955673, 26.264591],
              [61.955826, 26.264573],
              [61.955929, 26.264507],
              [61.956042, 26.264305],
              [61.956119, 26.264312],
              [61.956604, 26.264131],
              [61.956974, 26.263881],
              [61.957034, 26.263812],
              [61.956987, 26.263634],
              [61.957074, 26.263637],
              [61.957062, 26.26353],
              [61.957157, 26.263234],
              [61.957377, 26.263047],
              [61.957379, 26.262949],
              [61.957517, 26.262677],
              [61.957722, 26.262486],
              [61.958035, 26.262435],
              [61.958082, 26.262313],
              [61.958065, 26.261931],
              [61.957999, 26.261944],
              [61.958008, 26.26184],
              [61.957875, 26.261817],
              [61.957964, 26.261629],
              [61.957941, 26.261402],
              [61.957878, 26.261405],
              [61.957917, 26.26128],
              [61.957711, 26.261148],
              [61.957693, 26.261036],
              [61.95777, 26.260961],
              [61.957794, 26.260777],
              [61.958435, 26.260121],
              [61.958549, 26.260237],
              [61.958676, 26.260224],
              [61.958718, 26.260288],
              [61.958889, 26.26033],
              [61.959041, 26.260307],
              [61.959092, 26.260436],
              [61.959243, 26.260558],
              [61.959356, 26.260527],
              [61.959415, 26.260573],
              [61.959406, 26.260846],
              [61.959474, 26.260817],
              [61.959696, 26.260884],
              [61.960092, 26.260884],
              [61.960173, 26.260725],
              [61.960342, 26.260596],
              [61.960658, 26.260522],
              [61.961143, 26.260217],
              [61.961094, 26.260584],
              [61.961185, 26.260747],
              [61.961208, 26.260922],
              [61.961323, 26.260841],
              [61.96138, 26.260909],
              [61.96137, 26.261118],
              [61.961524, 26.261209],
              [61.961532, 26.261344],
              [61.961611, 26.261401],
              [61.961543, 26.261758],
              [61.961623, 26.261842],
              [61.961633, 26.261932],
              [61.961575, 26.262053],
              [61.961651, 26.262045],
              [61.961471, 26.262281],
              [61.961467, 26.262479],
              [61.961675, 26.262489],
              [61.962078, 26.262694],
              [61.962214, 26.262684],
              [61.96254, 26.262797],
              [61.96278, 26.263314],
              [61.96296, 26.263355],
              [61.962962, 26.263576],
              [61.962773, 26.263916],
              [61.962789, 26.26403],
              [61.962877, 26.264092],
              [61.962821, 26.264153],
              [61.962862, 26.264277],
              [61.962823, 26.264382],
              [61.963263, 26.264647],
              [61.963206, 26.2648],
              [61.963245, 26.264897],
              [61.963378, 26.265055],
              [61.963573, 26.26507],
              [61.9636, 26.265216],
              [61.963701, 26.265273],
              [61.963718, 26.265414],
              [61.963802, 26.265544],
              [61.963861, 26.26562],
              [61.963942, 26.265603],
              [61.964022, 26.265938],
              [61.963977, 26.266067],
              [61.963988, 26.266289],
              [61.9642, 26.266261],
              [61.964389, 26.266402],
              [61.964724, 26.266486],
              [61.964717, 26.266652],
              [61.964915, 26.266632],
              [61.964896, 26.266793],
              [61.965, 26.266876],
              [61.965117, 26.266857],
              [61.965242, 26.266909],
              [61.965258, 26.266981],
              [61.965615, 26.267183],
              [61.965892, 26.267127],
              [61.966007, 26.267188],
              [61.966271, 26.267114],
              [61.966372, 26.267216],
              [61.966329, 26.26723],
              [61.966312, 26.26759],
              [61.966442, 26.267695],
              [61.966811, 26.267623],
              [61.966931, 26.267756],
              [61.967127, 26.267813],
              [61.967214, 26.267923],
              [61.96743, 26.267903],
              [61.9675, 26.268031],
              [61.967601, 26.268058],
              [61.967596, 26.268112],
              [61.967802, 26.268182],
              [61.96788, 26.268301],
              [61.967979, 26.268338],
              [61.967953, 26.268612],
              [61.967867, 26.268837],
              [61.967854, 26.269071],
              [61.967919, 26.26912],
              [61.967895, 26.26926],
              [61.967971, 26.269214],
              [61.96805, 26.269248],
              [61.968241, 26.269386],
              [61.968285, 26.26949],
              [61.968406, 26.269562],
              [61.968429, 26.269627],
              [61.968532, 26.269567],
              [61.968529, 26.269607],
              [61.968751, 26.269599],
              [61.968952, 26.269519],
              [61.969459, 26.2697],
              [61.969514, 26.269763],
              [61.969649, 26.269781],
              [61.96978, 26.269899],
              [61.969899, 26.269897],
              [61.970125, 26.269999],
              [61.970238, 26.269998],
              [61.970426, 26.269898],
              [61.970859, 26.269914],
              [61.971076, 26.26997],
              [61.971146, 26.269939],
              [61.971361, 26.270032],
              [61.971545, 26.270024],
              [61.971696, 26.269849],
              [61.971773, 26.270302],
              [61.971743, 26.270381],
              [61.971879, 26.270518],
              [61.971888, 26.270615],
              [61.971881, 26.270751],
              [61.97175, 26.270937],
              [61.971746, 26.271008],
              [61.971916, 26.271158],
              [61.97196, 26.271359],
              [61.97197, 26.271645],
              [61.971859, 26.271974],
              [61.971864, 26.272215],
              [61.972002, 26.27213],
              [61.972046, 26.27235],
              [61.97212, 26.272388],
              [61.972166, 26.272353],
              [61.972207, 26.272415],
              [61.97229, 26.272435],
              [61.972477, 26.27245],
              [61.972565, 26.272651],
              [61.972784, 26.272776],
              [61.97278, 26.272869],
              [61.973404, 26.273029],
              [61.973407, 26.273108],
              [61.97354, 26.273241],
              [61.973601, 26.273191],
              [61.973853, 26.273137],
              [61.974138, 26.273219],
              [61.974266, 26.273208],
              [61.974376, 26.273238],
              [61.974396, 26.273294],
              [61.974735, 26.273362],
              [61.975123, 26.27368],
              [61.975215, 26.273704],
              [61.97567, 26.273596],
              [61.97589, 26.273689],
              [61.975937, 26.273804],
              [61.976259, 26.273838],
              [61.976331, 26.273913],
              [61.976675, 26.273891],
              [61.976849, 26.27394],
              [61.976911, 26.274032],
              [61.976964, 26.274009],
              [61.977059, 26.27409],
              [61.977239, 26.274118],
              [61.977273, 26.274198],
              [61.977713, 26.274311],
              [61.977725, 26.274401],
              [61.977824, 26.27447],
              [61.977938, 26.27445],
              [61.978103, 26.27469],
              [61.978169, 26.274722],
              [61.978157, 26.274804],
              [61.978334, 26.274823],
              [61.978356, 26.274896],
              [61.978539, 26.274976],
              [61.97888, 26.274842],
              [61.978944, 26.274759],
              [61.979011, 26.27477],
              [61.979122, 26.274611],
              [61.97927, 26.274608],
              [61.979288, 26.274567],
              [61.979372, 26.274603],
              [61.979435, 26.274557],
              [61.979601, 26.274633],
              [61.979968, 26.274668],
              [61.980269, 26.274568],
              [61.980368, 26.274577],
              [61.980601, 26.27465],
              [61.980725, 26.274881],
              [61.980956, 26.274969],
              [61.981, 26.275234],
              [61.981042, 26.275238],
              [61.981104, 26.275368],
              [61.981219, 26.27581],
              [61.981142, 26.275948],
              [61.981151, 26.276058],
              [61.981069, 26.276137],
              [61.981085, 26.276199],
              [61.981224, 26.276233],
              [61.981219, 26.276289],
              [61.981116, 26.276638],
              [61.981017, 26.276651],
              [61.981353, 26.276812],
              [61.981421, 26.27701],
              [61.981385, 26.277232],
              [61.981609, 26.277219],
              [61.981884, 26.277285],
              [61.98206, 26.277197],
              [61.982286, 26.277308],
              [61.98242, 26.277301],
              [61.982457, 26.277401],
              [61.982643, 26.277455],
              [61.982711, 26.277546],
              [61.982931, 26.277611],
              [61.983033, 26.277792],
              [61.982981, 26.277975],
              [61.983146, 26.278223],
              [61.983319, 26.278686],
              [61.983298, 26.279097],
              [61.983181, 26.279208],
              [61.983138, 26.279501],
              [61.983336, 26.279869],
              [61.983236, 26.280047],
              [61.983184, 26.28003],
              [61.983107, 26.280157],
              [61.982994, 26.280203],
              [61.98279, 26.280551],
              [61.982784, 26.280619],
              [61.982881, 26.280707],
              [61.982873, 26.280993],
              [61.982942, 26.281173],
              [61.983084, 26.281209],
              [61.983161, 26.281176],
              [61.98332, 26.281201],
              [61.983519, 26.281143],
              [61.983532, 26.281193],
              [61.983694, 26.281165],
              [61.983859, 26.281214],
              [61.983959, 26.281323],
              [61.98422, 26.281365],
              [61.984316, 26.281467],
              [61.984503, 26.281497],
              [61.984628, 26.281419],
              [61.985007, 26.281407],
              [61.98528, 26.281549],
              [61.985338, 26.281432],
              [61.985424, 26.281402],
              [61.985674, 26.281381],
              [61.985805, 26.281302],
              [61.986077, 26.281292],
              [61.986192, 26.281221],
              [61.986392, 26.281265],
              [61.986451, 26.281174],
              [61.986976, 26.281359],
              [61.987287, 26.281403],
              [61.987651, 26.281214],
              [61.987917, 26.280831],
              [61.988103, 26.280948],
              [61.988397, 26.281023],
              [61.988741, 26.280909],
              [61.988768, 26.280833],
              [61.988877, 26.280759],
              [61.989181, 26.28063],
              [61.989631, 26.280815],
              [61.989621, 26.280945],
              [61.989764, 26.281227],
              [61.989934, 26.2812],
              [61.990045, 26.281073],
              [61.990156, 26.281023],
              [61.990255, 26.281115],
              [61.99039, 26.281112],
              [61.990555, 26.281241],
              [61.990918, 26.281265],
              [61.991328, 26.281421],
              [61.991418, 26.281554],
              [61.991603, 26.281659],
              [61.991835, 26.281667],
              [61.991964, 26.281798],
              [61.992165, 26.281826],
              [61.992215, 26.281881],
              [61.992529, 26.281892],
              [61.992655, 26.281951],
              [61.993155, 26.282019],
              [61.993316, 26.282146],
              [61.993393, 26.28238],
              [61.993566, 26.282509],
              [61.993725, 26.282462],
              [61.993961, 26.282559],
              [61.994355, 26.282539],
              [61.994456, 26.282478],
              [61.994993, 26.282479],
              [61.995123, 26.282273],
              [61.995385, 26.28213],
              [61.995584, 26.282085],
              [61.995707, 26.281836],
              [61.995783, 26.281785],
              [61.995811, 26.281426],
              [61.996059, 26.281121],
              [61.996164, 26.28106],
              [61.996091, 26.280885],
              [61.996211, 26.280771],
              [61.996332, 26.280722],
              [61.996509, 26.280766],
              [61.996688, 26.280879],
              [61.996801, 26.280866],
              [61.996962, 26.280779],
              [61.996954, 26.280706],
              [61.99709, 26.280548],
              [61.997223, 26.280631],
              [61.997447, 26.281004],
              [61.997558, 26.281365],
              [61.9977, 26.281526],
              [61.997718, 26.281767],
              [61.998102, 26.282516],
              [61.998231, 26.28265],
              [61.998347, 26.282626],
              [61.998299, 26.28276],
              [61.998456, 26.282704],
              [61.998696, 26.282984],
              [61.99912, 26.282938],
              [61.999254, 26.283074],
              [61.999576, 26.283138],
              [61.999632, 26.283216],
              [61.999874, 26.28329],
              [61.99988, 26.283336],
              [62.000272, 26.28336],
              [62.00044, 26.283507],
              [62.000614, 26.283819],
              [62.00059, 26.283982],
              [62.000712, 26.28433],
              [62.000644, 26.284486],
              [62.000733, 26.28454],
              [62.000715, 26.284635],
              [62.000832, 26.284597],
              [62.001036, 26.28462],
              [62.001143, 26.285413],
              [62.001343, 26.285497],
              [62.001382, 26.285611],
              [62.001432, 26.285594],
              [62.001643, 26.285777],
              [62.001714, 26.285774],
              [62.001864, 26.285904],
              [62.001894, 26.286014],
              [62.002005, 26.28608],
              [62.00198, 26.286153],
              [62.002082, 26.286381],
              [62.002085, 26.286517],
              [62.002169, 26.286634],
              [62.002182, 26.286845],
              [62.002319, 26.286861],
              [62.002572, 26.286977],
              [62.002751, 26.286993],
              [62.002904, 26.287093],
              [62.002795, 26.28739],
              [62.002874, 26.287688],
              [62.002982, 26.287749],
              [62.003027, 26.288056],
              [62.003013, 26.288129],
              [62.002914, 26.288208],
              [62.00285, 26.288648],
              [62.002891, 26.288726],
              [62.003129, 26.288781],
              [62.003147, 26.288825],
              [62.003237, 26.288761],
              [62.003305, 26.288908],
              [62.00344, 26.28897],
              [62.003513, 26.28895],
              [62.003514, 26.289053],
              [62.003631, 26.289208],
              [62.003821, 26.289291],
              [62.003782, 26.289374],
              [62.003829, 26.289399],
              [62.003828, 26.289547],
              [62.003938, 26.289714],
              [62.003966, 26.289884],
              [62.004021, 26.28988],
              [62.00403, 26.289947],
              [62.004153, 26.290006],
              [62.00426, 26.290204],
              [62.004081, 26.290616],
              [62.004068, 26.290831],
              [62.004104, 26.29089],
              [62.004029, 26.290944],
              [62.004201, 26.291175],
              [62.004285, 26.291177],
              [62.004133, 26.291399],
              [62.004145, 26.29191],
              [62.004231, 26.291896],
              [62.004687, 26.292126],
              [62.004984, 26.292139],
              [62.005239, 26.292217],
              [62.005373, 26.292483],
              [62.005609, 26.292627],
              [62.005699, 26.292893],
              [62.005757, 26.292916],
              [62.005765, 26.292994],
              [62.005685, 26.293049],
              [62.005742, 26.293137],
              [62.005789, 26.293105],
              [62.005798, 26.293161],
              [62.005883, 26.293144],
              [62.0058, 26.293294],
              [62.005822, 26.293329],
              [62.005682, 26.293453],
              [62.005567, 26.293734],
              [62.005616, 26.293797],
              [62.005527, 26.293949],
              [62.005733, 26.294176],
              [62.005797, 26.294179],
              [62.005848, 26.29428],
              [62.005972, 26.294317],
              [62.005967, 26.294391],
              [62.006112, 26.294572],
              [62.006181, 26.294599],
              [62.006192, 26.294692],
              [62.006237, 26.294693],
              [62.006307, 26.294826],
              [62.006426, 26.29491],
              [62.006448, 26.295002],
              [62.006657, 26.295169],
              [62.00667, 26.29526],
              [62.007124, 26.295285],
              [62.007813, 26.295582],
              [62.008377, 26.295677],
              [62.008711, 26.295891],
              [62.008971, 26.295927],
              [62.009047, 26.295974],
              [62.009148, 26.295944],
              [62.009249, 26.296055],
              [62.009552, 26.296152],
              [62.009664, 26.296259],
              [62.009817, 26.296323],
              [62.00988, 26.296409],
              [62.009986, 26.296416],
              [62.01005, 26.296492],
              [62.010126, 26.296471],
              [62.010124, 26.296589],
              [62.010361, 26.296765],
              [62.010512, 26.296969],
              [62.010677, 26.296906],
              [62.010743, 26.29701],
              [62.010614, 26.297225],
              [62.010587, 26.297653],
              [62.010483, 26.297709],
              [62.010516, 26.297889],
              [62.010362, 26.298141],
              [62.010354, 26.298312],
              [62.01018, 26.298486],
              [62.009712, 26.298728],
              [62.009762, 26.298837],
              [62.009674, 26.298969],
              [62.009745, 26.298968],
              [62.009894, 26.299161],
              [62.009983, 26.29948],
              [62.009934, 26.299611],
              [62.009957, 26.299664],
              [62.009987, 26.299722],
              [62.010109, 26.299775],
              [62.01006, 26.299852],
              [62.010105, 26.299923],
              [62.010332, 26.300107],
              [62.010398, 26.300085],
              [62.010353, 26.300166],
              [62.010397, 26.300221],
              [62.010696, 26.300158],
              [62.0107, 26.300258],
              [62.010771, 26.30023],
              [62.010796, 26.300289],
              [62.011086, 26.300063],
              [62.011346, 26.300333],
              [62.011433, 26.300294],
              [62.011555, 26.300309],
              [62.011574, 26.300273],
              [62.011694, 26.300374],
              [62.011851, 26.300347],
              [62.011893, 26.300414],
              [62.012093, 26.300405],
              [62.012134, 26.300513],
              [62.012078, 26.300528],
              [62.012097, 26.30059],
              [62.012186, 26.300603],
              [62.012236, 26.300559],
              [62.012453, 26.300632],
              [62.012615, 26.300747],
              [62.012728, 26.30093],
              [62.012726, 26.301059],
              [62.012906, 26.301119],
              [62.012934, 26.301207],
              [62.013162, 26.301286],
              [62.01332, 26.30144],
              [62.01332, 26.30168],
              [62.013395, 26.301766],
              [62.013314, 26.301913],
              [62.013326, 26.301982],
              [62.013526, 26.302181],
              [62.013516, 26.302355],
              [62.013453, 26.302423],
              [62.013527, 26.302572],
              [62.013523, 26.302668],
              [62.013727, 26.302869],
              [62.013797, 26.303015],
              [62.013927, 26.303065],
              [62.013968, 26.303022],
              [62.014126, 26.303064],
              [62.014145, 26.302974],
              [62.014315, 26.302964],
              [62.014631, 26.302483],
              [62.014787, 26.302571],
              [62.014899, 26.302514],
              [62.01505, 26.302552],
              [62.015186, 26.30245],
              [62.015539, 26.302711],
              [62.015617, 26.30273],
              [62.015737, 26.302675],
              [62.015732, 26.302807],
              [62.015836, 26.302904],
              [62.015863, 26.303028],
              [62.015982, 26.303142],
              [62.016126, 26.303203],
              [62.016382, 26.303567],
              [62.016476, 26.303617],
              [62.016517, 26.303697],
              [62.016661, 26.303728],
              [62.016674, 26.303805],
              [62.016757, 26.303859],
              [62.016922, 26.303741],
              [62.017547, 26.30373],
              [62.017696, 26.303661],
              [62.017795, 26.303697],
              [62.018213, 26.303635],
              [62.018292, 26.303668],
              [62.018392, 26.30354],
              [62.018701, 26.303357],
              [62.018799, 26.303387],
              [62.01889, 26.303268],
              [62.018945, 26.303371],
              [62.019005, 26.303361],
              [62.019002, 26.303416],
              [62.019122, 26.30338],
              [62.019269, 26.303426],
              [62.019398, 26.303588],
              [62.019769, 26.303417],
              [62.019876, 26.303475],
              [62.020182, 26.303402],
              [62.020299, 26.303517],
              [62.020527, 26.303375],
              [62.020767, 26.303345],
              [62.020851, 26.303293],
              [62.021114, 26.30305],
              [62.0212, 26.302883],
              [62.021346, 26.302831],
              [62.021346, 26.302872],
              [62.021573, 26.302905],
              [62.02158, 26.302852],
              [62.021768, 26.302815],
              [62.021902, 26.303066],
              [62.02187, 26.303151],
              [62.02195, 26.303178],
              [62.022006, 26.303409],
              [62.022072, 26.303455],
              [62.02215, 26.303849],
              [62.022291, 26.303949],
              [62.022175, 26.304129],
              [62.022069, 26.304136],
              [62.022188, 26.304397],
              [62.022325, 26.304568],
              [62.022276, 26.304656],
              [62.022045, 26.304757],
              [62.022051, 26.304922],
              [62.021935, 26.305048],
              [62.021964, 26.305087],
              [62.021911, 26.305101],
              [62.021991, 26.305225],
              [62.021957, 26.305416],
              [62.02204, 26.305484],
              [62.022013, 26.305524],
              [62.022109, 26.30568],
              [62.022087, 26.305954],
              [62.02214, 26.305962],
              [62.022185, 26.306115],
              [62.022092, 26.306212],
              [62.022027, 26.306199],
              [62.021838, 26.306648],
              [62.021694, 26.306683],
              [62.021658, 26.306984],
              [62.021527, 26.307069],
              [62.021416, 26.307256],
              [62.021299, 26.307309],
              [62.02128, 26.307427],
              [62.021074, 26.307551],
              [62.021064, 26.307793],
              [62.021159, 26.308042],
              [62.021372, 26.308217],
              [62.021412, 26.30821],
              [62.021394, 26.308568],
              [62.021648, 26.308605],
              [62.02179, 26.308671],
              [62.021827, 26.308733],
              [62.022045, 26.308708],
              [62.021964, 26.308828],
              [62.022028, 26.308891],
              [62.022009, 26.30893],
              [62.022051, 26.308914],
              [62.021999, 26.309144],
              [62.022035, 26.309187],
              [62.021984, 26.309256],
              [62.02214, 26.30932],
              [62.022243, 26.30945],
              [62.02241, 26.309441],
              [62.022533, 26.309582],
              [62.022771, 26.309586],
              [62.022897, 26.309685],
              [62.023018, 26.309657],
              [62.023185, 26.309812],
              [62.023476, 26.309837],
              [62.023626, 26.309968],
              [62.023792, 26.309978],
              [62.023795, 26.310062],
              [62.024072, 26.310177],
              [62.024202, 26.310158],
              [62.024259, 26.310244],
              [62.024327, 26.310255],
              [62.024251, 26.310568],
              [62.024061, 26.310763],
              [62.02395, 26.311134],
              [62.024106, 26.311141],
              [62.024282, 26.311294],
              [62.024306, 26.311364],
              [62.024196, 26.311543],
              [62.024277, 26.311563],
              [62.024557, 26.311844],
              [62.024795, 26.311662],
              [62.024819, 26.311718],
              [62.024877, 26.31167],
              [62.025283, 26.311635],
              [62.025607, 26.311789],
              [62.025588, 26.311925],
              [62.025648, 26.31197],
              [62.025729, 26.31197],
              [62.025957, 26.312121],
              [62.026075, 26.312131],
              [62.026304, 26.312379],
              [62.026408, 26.312406],
              [62.026418, 26.312522],
              [62.02651, 26.312522],
              [62.026533, 26.312573],
              [62.026828, 26.312661],
              [62.026936, 26.312552],
              [62.027061, 26.31254],
              [62.027066, 26.312506],
              [62.027146, 26.312523],
              [62.027155, 26.312453],
              [62.027446, 26.312492],
              [62.02749, 26.312463],
              [62.027623, 26.312539],
              [62.027794, 26.312478],
              [62.02785, 26.31252],
              [62.027882, 26.312485],
              [62.027947, 26.312542],
              [62.028154, 26.312538],
              [62.028305, 26.312712],
              [62.028383, 26.312701],
              [62.028477, 26.312587],
              [62.028562, 26.312586],
              [62.028588, 26.312633],
              [62.028575, 26.31296],
              [62.028719, 26.3133],
              [62.028778, 26.313587],
              [62.028759, 26.313722],
              [62.028601, 26.313873],
              [62.028629, 26.313948],
              [62.028448, 26.314046],
              [62.028249, 26.314282],
              [62.028234, 26.314432],
              [62.028322, 26.314581],
              [62.028068, 26.31491],
              [62.028097, 26.315028],
              [62.027902, 26.315175],
              [62.027973, 26.315172],
              [62.028004, 26.315232],
              [62.027946, 26.31546],
              [62.027971, 26.315702],
              [62.028187, 26.315698],
              [62.028241, 26.316102],
              [62.028483, 26.316304],
              [62.028497, 26.316436],
              [62.028431, 26.316518],
              [62.028276, 26.316571],
              [62.028175, 26.316793],
              [62.02807, 26.316884],
              [62.028252, 26.31729],
              [62.028366, 26.317394],
              [62.028446, 26.317392],
              [62.028492, 26.31748],
              [62.028444, 26.317575],
              [62.028494, 26.317627],
              [62.028383, 26.317708],
              [62.028339, 26.317849],
              [62.02812, 26.317978],
              [62.028052, 26.318159],
              [62.027963, 26.318231],
              [62.027888, 26.318506],
              [62.027929, 26.31878],
              [62.027774, 26.319041],
              [62.02765, 26.319141],
              [62.027509, 26.319481],
              [62.027365, 26.319519],
              [62.02716, 26.319687],
              [62.027183, 26.319735],
              [62.027139, 26.319767],
              [62.026958, 26.319824],
              [62.026736, 26.319829],
              [62.026663, 26.31989],
              [62.02654, 26.320036],
              [62.02649, 26.320288],
              [62.026347, 26.320369],
              [62.026389, 26.320471],
              [62.026096, 26.320916],
              [62.026453, 26.321266],
              [62.026745, 26.321271],
              [62.027083, 26.321475],
              [62.027151, 26.321627],
              [62.027138, 26.321826],
              [62.027211, 26.32189],
              [62.027286, 26.321867],
              [62.027384, 26.321908],
              [62.027667, 26.32212],
              [62.027951, 26.322223],
              [62.028109, 26.322224],
              [62.028118, 26.322334],
              [62.028186, 26.322402],
              [62.028267, 26.322628],
              [62.028273, 26.32286],
              [62.028458, 26.323063],
              [62.028418, 26.323152],
              [62.028276, 26.323211],
              [62.027883, 26.323539],
              [62.027898, 26.32361],
              [62.027802, 26.323828],
              [62.028134, 26.324417],
              [62.028157, 26.324695],
              [62.028217, 26.324726],
              [62.028249, 26.324819],
              [62.028166, 26.324846],
              [62.028119, 26.325029],
              [62.027954, 26.325062],
              [62.027785, 26.325177],
              [62.027567, 26.325465],
              [62.027428, 26.325494],
              [62.027176, 26.32547],
              [62.026707, 26.325682],
              [62.026414, 26.325909],
              [62.026403, 26.32608],
              [62.026809, 26.326159],
              [62.026822, 26.326234],
              [62.027097, 26.3266],
              [62.02705, 26.326796],
              [62.027101, 26.327143],
              [62.027234, 26.327181],
              [62.027497, 26.327385],
              [62.027905, 26.32783],
              [62.027979, 26.327843],
              [62.027945, 26.327892],
              [62.028224, 26.328179],
              [62.028542, 26.328068],
              [62.028763, 26.328116],
              [62.02883, 26.328192],
              [62.029183, 26.328357],
              [62.029412, 26.328398],
              [62.029403, 26.328563],
              [62.030002, 26.329029],
              [62.029793, 26.329773],
              [62.02974, 26.330203],
              [62.02982, 26.330299],
              [62.029813, 26.330546],
              [62.029857, 26.33065],
              [62.029815, 26.330982],
              [62.029748, 26.331143],
              [62.02979, 26.331284],
              [62.029602, 26.331501],
              [62.02957, 26.331602],
              [62.029598, 26.331745],
              [62.02944, 26.332079],
              [62.02943, 26.332264],
              [62.029288, 26.332394],
              [62.029243, 26.332683],
              [62.02928, 26.332786],
              [62.02949, 26.33295],
              [62.029563, 26.33308],
              [62.029572, 26.333426],
              [62.029791, 26.333616],
              [62.030346, 26.333709],
              [62.0308, 26.333843],
              [62.031459, 26.333676],
              [62.031741, 26.333424],
              [62.031855, 26.333678],
              [62.032052, 26.33382],
              [62.032327, 26.333744],
              [62.032444, 26.333872],
              [62.032553, 26.333884],
              [62.032612, 26.333838],
              [62.032649, 26.333928],
              [62.032959, 26.334175],
              [62.033147, 26.334122],
              [62.033239, 26.334138],
              [62.033312, 26.334235],
              [62.033318, 26.334419],
              [62.033364, 26.334491],
              [62.033713, 26.334364],
              [62.033788, 26.334415],
              [62.033853, 26.334378],
              [62.034256, 26.334372],
              [62.034766, 26.333951],
              [62.034891, 26.334028],
              [62.035084, 26.334043],
              [62.035199, 26.334135],
              [62.03532, 26.334159],
              [62.035657, 26.333907],
              [62.035773, 26.333909],
              [62.035762, 26.333785],
              [62.035932, 26.333608],
              [62.035898, 26.333567],
              [62.036201, 26.333387],
              [62.036482, 26.333312],
              [62.036696, 26.333199],
              [62.036907, 26.332936],
              [62.037263, 26.332904],
              [62.037365, 26.332847],
              [62.03746, 26.332867],
              [62.037654, 26.332772],
              [62.037807, 26.332768],
              [62.03785, 26.332717],
              [62.038875, 26.332854],
              [62.039081, 26.33294],
              [62.039118, 26.333047],
              [62.039334, 26.333141],
              [62.039512, 26.333043],
              [62.039769, 26.333083],
              [62.039752, 26.332984],
              [62.039955, 26.33292],
              [62.040478, 26.333016],
              [62.040724, 26.333021],
              [62.040814, 26.333196],
              [62.041093, 26.333245],
              [62.041334, 26.333363],
              [62.041494, 26.333366],
              [62.041811, 26.333529],
              [62.042049, 26.333493],
              [62.042106, 26.333567],
              [62.042106, 26.333676],
              [62.042628, 26.333828],
              [62.043058, 26.333752],
              [62.043295, 26.333771],
              [62.043274, 26.333821],
              [62.043386, 26.333842],
              [62.043546, 26.333729],
              [62.043734, 26.333781],
              [62.044648, 26.333603],
              [62.04463, 26.333518],
              [62.044836, 26.333391],
              [62.044853, 26.333263],
              [62.044919, 26.333208],
              [62.044878, 26.333183],
              [62.044909, 26.333092],
              [62.044804, 26.333046],
              [62.044842, 26.333001],
              [62.044632, 26.332837],
              [62.044531, 26.332654],
              [62.044709, 26.33261],
              [62.044756, 26.332533],
              [62.045273, 26.332483],
              [62.045379, 26.332394],
              [62.045703, 26.332409],
              [62.045776, 26.332269],
              [62.045883, 26.332202],
              [62.046104, 26.332311],
              [62.046581, 26.332398],
              [62.046991, 26.332399],
              [62.047451, 26.33247],
              [62.047607, 26.332456],
              [62.048085, 26.332254],
              [62.048016, 26.331828],
              [62.048038, 26.331771],
              [62.048123, 26.331745],
              [62.048114, 26.331697],
              [62.04825, 26.331685],
              [62.048152, 26.331524],
              [62.048094, 26.331504],
              [62.048119, 26.331407],
              [62.048074, 26.331352],
              [62.048485, 26.331332],
              [62.048723, 26.331176],
              [62.048706, 26.331138],
              [62.048829, 26.331052],
              [62.048901, 26.330923],
              [62.049186, 26.330935],
              [62.04921, 26.330821],
              [62.04937, 26.330783],
              [62.049388, 26.33056],
              [62.049676, 26.330523],
              [62.049811, 26.330546],
              [62.049861, 26.330466],
              [62.049911, 26.330481],
              [62.04995, 26.330438],
              [62.049902, 26.330402],
              [62.050146, 26.330258],
              [62.050119, 26.330082],
              [62.050399, 26.329903],
              [62.050313, 26.329585],
              [62.050434, 26.329434],
              [62.050398, 26.329375],
              [62.050468, 26.329323],
              [62.050495, 26.329199],
              [62.050892, 26.329354],
              [62.050893, 26.329315],
              [62.051112, 26.329234],
              [62.051368, 26.329211],
              [62.051601, 26.329207],
              [62.051743, 26.32928],
              [62.051819, 26.329199],
              [62.051991, 26.329311],
              [62.052016, 26.329258],
              [62.052142, 26.329235],
              [62.052221, 26.329106],
              [62.052388, 26.329004],
              [62.052531, 26.329073],
              [62.052777, 26.328938],
              [62.052866, 26.329028],
              [62.053123, 26.329095],
              [62.05321, 26.329184],
              [62.053282, 26.329195],
              [62.05352, 26.329135],
              [62.05354, 26.329074],
              [62.053723, 26.329033],
              [62.053745, 26.328995],
              [62.053921, 26.329054],
              [62.054066, 26.328995],
              [62.054433, 26.329142],
              [62.054676, 26.329005],
              [62.054774, 26.329047],
              [62.055044, 26.329014],
              [62.055468, 26.329046],
              [62.055569, 26.329026],
              [62.055629, 26.328854],
              [62.055899, 26.328749],
              [62.055944, 26.328692],
              [62.056364, 26.32872],
              [62.056418, 26.328766],
              [62.056576, 26.328567],
              [62.056871, 26.328715],
              [62.057022, 26.328634],
              [62.05724, 26.328638],
              [62.057523, 26.328502],
              [62.057645, 26.328519],
              [62.057836, 26.328383],
              [62.058496, 26.328313],
              [62.05892, 26.328137],
              [62.059141, 26.327857],
              [62.059342, 26.327942],
              [62.059346, 26.328022],
              [62.059458, 26.328086],
              [62.059606, 26.328077],
              [62.05962, 26.328029],
              [62.059675, 26.328022],
              [62.060115, 26.328287],
              [62.060298, 26.328151],
              [62.060706, 26.32809],
              [62.061093, 26.327803],
              [62.06117, 26.327799],
              [62.061164, 26.327349],
              [62.061275, 26.327278],
              [62.061297, 26.327156],
              [62.061258, 26.327135],
              [62.061266, 26.327028],
              [62.061112, 26.326825],
              [62.06138, 26.326755],
              [62.06153, 26.326659],
              [62.061617, 26.326669],
              [62.061672, 26.32658],
              [62.062058, 26.326653],
              [62.062197, 26.326548],
              [62.06221, 26.326635],
              [62.062435, 26.326674],
              [62.062614, 26.326488],
              [62.06264, 26.326532],
              [62.062971, 26.326506],
              [62.062968, 26.326428],
              [62.063023, 26.326401],
              [62.063084, 26.326482],
              [62.063175, 26.326483],
              [62.063167, 26.326531],
              [62.063217, 26.326558],
              [62.063304, 26.326538],
              [62.063303, 26.326574],
              [62.063501, 26.32662],
              [62.063635, 26.326583],
              [62.06366, 26.326653],
              [62.063758, 26.326652],
              [62.063846, 26.326748],
              [62.063985, 26.326774],
              [62.06404, 26.326919],
              [62.06413, 26.326988],
              [62.064152, 26.327124],
              [62.064402, 26.327062],
              [62.06477, 26.327117],
              [62.064874, 26.327221],
              [62.065038, 26.327249],
              [62.065206, 26.32719],
              [62.065314, 26.32731],
              [62.065423, 26.327328],
              [62.065572, 26.327272],
              [62.065615, 26.327318],
              [62.065749, 26.327271],
              [62.065896, 26.327282],
              [62.065901, 26.327242],
              [62.066081, 26.327194],
              [62.066055, 26.326955],
              [62.066207, 26.326859],
              [62.06629, 26.326726],
              [62.066993, 26.326899],
              [62.067131, 26.326851],
              [62.067335, 26.326637],
              [62.067358, 26.326466],
              [62.067432, 26.32641],
              [62.067621, 26.326501],
              [62.067739, 26.326465],
              [62.068345, 26.326482],
              [62.068405, 26.326622],
              [62.068703, 26.326613],
              [62.068789, 26.326694],
              [62.068891, 26.326696],
              [62.068916, 26.326632],
              [62.069087, 26.326557],
              [62.069364, 26.326547],
              [62.069793, 26.326816],
              [62.070059, 26.32678],
              [62.070363, 26.326855],
              [62.070693, 26.3268],
              [62.070791, 26.326824],
              [62.071117, 26.326737],
              [62.071148, 26.326672],
              [62.070957, 26.32645],
              [62.071039, 26.32627],
              [62.071078, 26.325993],
              [62.071205, 26.325981],
              [62.071142, 26.325911],
              [62.071106, 26.325736],
              [62.071208, 26.325705],
              [62.071431, 26.325505],
              [62.071619, 26.325451],
              [62.071891, 26.32546],
              [62.07193, 26.325419],
              [62.072373, 26.325359],
              [62.072529, 26.325415],
              [62.072557, 26.325469],
              [62.072746, 26.325476],
              [62.072817, 26.32541],
              [62.073019, 26.325348],
              [62.073236, 26.325308],
              [62.073366, 26.325341],
              [62.073675, 26.325196],
              [62.073846, 26.325026],
              [62.073917, 26.324831],
              [62.074044, 26.324799],
              [62.074261, 26.324659],
              [62.07421, 26.324517],
              [62.074146, 26.324471],
              [62.074151, 26.324159],
              [62.074007, 26.324112],
              [62.073973, 26.323855],
              [62.073855, 26.323722],
              [62.073936, 26.323645],
              [62.074075, 26.323652],
              [62.074215, 26.323558],
              [62.074314, 26.323561],
              [62.074317, 26.323601],
              [62.074666, 26.323513],
              [62.074837, 26.32334],
              [62.074912, 26.32316],
              [62.075071, 26.323058],
              [62.075021, 26.322978],
              [62.075093, 26.322939],
              [62.075161, 26.32278],
              [62.075339, 26.322665],
              [62.075461, 26.3227],
              [62.07553, 26.322664],
              [62.07549, 26.322433],
              [62.075556, 26.322422],
              [62.075537, 26.322196],
              [62.07563, 26.322131],
              [62.07584, 26.321711],
              [62.076012, 26.321737],
              [62.076168, 26.321684],
              [62.076474, 26.321368],
              [62.076945, 26.321205],
              [62.076938, 26.321162],
              [62.077246, 26.320879],
              [62.077522, 26.320764],
              [62.077586, 26.320675],
              [62.077965, 26.320739],
              [62.078332, 26.320646],
              [62.078453, 26.320516],
              [62.078545, 26.320501],
              [62.078437, 26.320431],
              [62.078476, 26.320417],
              [62.078491, 26.32025],
              [62.078542, 26.320239],
              [62.078643, 26.320059],
              [62.078629, 26.320006],
              [62.078841, 26.319845],
              [62.079098, 26.319895],
              [62.079123, 26.319817],
              [62.079201, 26.319832],
              [62.0792, 26.319761],
              [62.079304, 26.319801],
              [62.079437, 26.31977],
              [62.079479, 26.31981],
              [62.079643, 26.319771],
              [62.079793, 26.31964],
              [62.079888, 26.319638],
              [62.080227, 26.319488],
              [62.080267, 26.319386],
              [62.080585, 26.319175],
              [62.080646, 26.319017],
              [62.080935, 26.319004],
              [62.080974, 26.31891],
              [62.081433, 26.318692],
              [62.081756, 26.318829],
              [62.081791, 26.318935],
              [62.082168, 26.319033],
              [62.082371, 26.318994],
              [62.08247, 26.319054],
              [62.08264, 26.318974],
              [62.082668, 26.319034],
              [62.082809, 26.319068],
              [62.083209, 26.318922],
              [62.083273, 26.318944],
              [62.083369, 26.318877],
              [62.083471, 26.318922],
              [62.083564, 26.31883],
              [62.083827, 26.318713],
              [62.083807, 26.318591],
              [62.083853, 26.318572],
              [62.083854, 26.318465],
              [62.084098, 26.318285],
              [62.084066, 26.31822],
              [62.084228, 26.318184],
              [62.084471, 26.318335],
              [62.084919, 26.318855],
              [62.085181, 26.318861],
              [62.085378, 26.318569],
              [62.085281, 26.318508],
              [62.085308, 26.318162],
              [62.085224, 26.317991],
              [62.085419, 26.317835],
              [62.085397, 26.317744],
              [62.085476, 26.317684],
              [62.085473, 26.317627],
              [62.085596, 26.317577],
              [62.085628, 26.317601],
              [62.085608, 26.317506],
              [62.085723, 26.317408],
              [62.085823, 26.317124],
              [62.085795, 26.316842],
              [62.08575, 26.316855],
              [62.085664, 26.316784],
              [62.085653, 26.316707],
              [62.085752, 26.316671],
              [62.085972, 26.316752],
              [62.086414, 26.316539],
              [62.086569, 26.316486],
              [62.086693, 26.316495],
              [62.086657, 26.316373],
              [62.086788, 26.316231],
              [62.086944, 26.316074],
              [62.087361, 26.315925],
              [62.087495, 26.315747],
              [62.087492, 26.315633],
              [62.087645, 26.315585],
              [62.08777, 26.315627],
              [62.088324, 26.315649],
              [62.088585, 26.315753],
              [62.088915, 26.315281],
              [62.088819, 26.314933],
              [62.089214, 26.314805],
              [62.089427, 26.31487],
              [62.089989, 26.314705],
              [62.090263, 26.314572],
              [62.090349, 26.314473],
              [62.09029, 26.314033],
              [62.09036, 26.313928],
              [62.090387, 26.313746],
              [62.090556, 26.313647],
              [62.090596, 26.313542],
              [62.090924, 26.313422],
              [62.090976, 26.313347],
              [62.091121, 26.313315],
              [62.091234, 26.313026],
              [62.091407, 26.31285],
              [62.091394, 26.312426],
              [62.091337, 26.312397],
              [62.0913, 26.312267],
              [62.091511, 26.312237],
              [62.091701, 26.312293],
              [62.091925, 26.312283],
              [62.092088, 26.312154],
              [62.092143, 26.31194],
              [62.092284, 26.311753],
              [62.092372, 26.311719],
              [62.092373, 26.311626],
              [62.092498, 26.311491],
              [62.092567, 26.311479],
              [62.092573, 26.31141],
              [62.09264, 26.311361],
              [62.092717, 26.31111],
              [62.093059, 26.31093],
              [62.093142, 26.310736],
              [62.093442, 26.310484],
              [62.093476, 26.310254],
              [62.093564, 26.310166],
              [62.093561, 26.309959],
              [62.093631, 26.309871],
              [62.093603, 26.309794],
              [62.093688, 26.309708],
              [62.093703, 26.309597],
              [62.094176, 26.3091],
              [62.094343, 26.309075],
              [62.094344, 26.308539],
              [62.094606, 26.308455],
              [62.095005, 26.308129],
              [62.095064, 26.30772],
              [62.095308, 26.307655],
              [62.095511, 26.307646],
              [62.095586, 26.30769],
              [62.096052, 26.307632],
              [62.096405, 26.307488],
              [62.096516, 26.307352],
              [62.096539, 26.307182],
              [62.096652, 26.307196],
              [62.096687, 26.307152],
              [62.096982, 26.307116],
              [62.097778, 26.30674],
              [62.09766, 26.306675],
              [62.097596, 26.306151],
              [62.097547, 26.306047],
              [62.097488, 26.306052],
              [62.097428, 26.30598],
              [62.097459, 26.305931],
              [62.097406, 26.305781],
              [62.097185, 26.305706],
              [62.096912, 26.305386],
              [62.09692, 26.30533],
              [62.097043, 26.305266],
              [62.096988, 26.305245],
              [62.096991, 26.305007],
              [62.09707, 26.304794],
              [62.097192, 26.304627],
              [62.097347, 26.304644],
              [62.097292, 26.304553],
              [62.097304, 26.304389],
              [62.097332, 26.304325],
              [62.097398, 26.304314],
              [62.09732, 26.304198],
              [62.097272, 26.304196],
              [62.097272, 26.304127],
              [62.097414, 26.304013],
              [62.097793, 26.303898],
              [62.097933, 26.30376],
              [62.097894, 26.303701],
              [62.097949, 26.303531],
              [62.097888, 26.303232],
              [62.097803, 26.303192],
              [62.097742, 26.302716],
              [62.097591, 26.302512],
              [62.097397, 26.302604],
              [62.097296, 26.30255],
              [62.097236, 26.302244],
              [62.097169, 26.302151],
              [62.096951, 26.302106],
              [62.096972, 26.302036],
              [62.096637, 26.30183],
              [62.096583, 26.301719],
              [62.096483, 26.30167],
              [62.096458, 26.301554],
              [62.096387, 26.301555],
              [62.096376, 26.301421],
              [62.09622, 26.301431],
              [62.096175, 26.301334],
              [62.09582, 26.301322],
              [62.095854, 26.30112],
              [62.09576, 26.30107],
              [62.095671, 26.300905],
              [62.095578, 26.300833],
              [62.095577, 26.300577],
              [62.095524, 26.300552],
              [62.095569, 26.30043],
              [62.095531, 26.300087],
              [62.09566, 26.300131],
              [62.096086, 26.299984],
              [62.096211, 26.299903],
              [62.096253, 26.29971],
              [62.096387, 26.299671],
              [62.096415, 26.299607],
              [62.096565, 26.299582],
              [62.096479, 26.299487],
              [62.096562, 26.29932],
              [62.096549, 26.299235],
              [62.096688, 26.299075],
              [62.096925, 26.298932],
              [62.096874, 26.298891],
              [62.096901, 26.298821],
              [62.096728, 26.298708],
              [62.096736, 26.298635],
              [62.096638, 26.298483],
              [62.096282, 26.29846],
              [62.095957, 26.298356],
              [62.095971, 26.298146],
              [62.095858, 26.298061],
              [62.095668, 26.298006],
              [62.095645, 26.29796],
              [62.095469, 26.297968],
              [62.09528, 26.297835],
              [62.095267, 26.297772],
              [62.095047, 26.297691],
              [62.095226, 26.29764],
              [62.095244, 26.297375],
              [62.095381, 26.297431],
              [62.09549, 26.297396],
              [62.095534, 26.297326],
              [62.095743, 26.297278],
              [62.095863, 26.297102],
              [62.095806, 26.296972],
              [62.095839, 26.296836],
              [62.095951, 26.296719],
              [62.095897, 26.296703],
              [62.095848, 26.296602],
              [62.095889, 26.296543],
              [62.095726, 26.296311],
              [62.09599, 26.296043],
              [62.09613, 26.296031],
              [62.096146, 26.295899],
              [62.096337, 26.295753],
              [62.096527, 26.29568],
              [62.096585, 26.295591],
              [62.096801, 26.295626],
              [62.096874, 26.295581],
              [62.097101, 26.295557],
              [62.097534, 26.295375],
              [62.097663, 26.295196],
              [62.098025, 26.295141],
              [62.098278, 26.294946],
              [62.098302, 26.294821],
              [62.09826, 26.294752],
              [62.097971, 26.294557],
              [62.098004, 26.294486],
              [62.097954, 26.294295],
              [62.097735, 26.294064],
              [62.097815, 26.293868],
              [62.097591, 26.293711],
              [62.097503, 26.293715],
              [62.097285, 26.293601],
              [62.097186, 26.293096],
              [62.097233, 26.292971],
              [62.097344, 26.292865],
              [62.097422, 26.292647],
              [62.097267, 26.292548],
              [62.097297, 26.292439],
              [62.097081, 26.292164],
              [62.097044, 26.291965],
              [62.096849, 26.291929],
              [62.096816, 26.29179],
              [62.0964, 26.291499],
              [62.096455, 26.291353],
              [62.096716, 26.291253],
              [62.096976, 26.290999],
              [62.097139, 26.290895],
              [62.097484, 26.290828],
              [62.097625, 26.290743],
              [62.097672, 26.29076],
              [62.097725, 26.290685],
              [62.097859, 26.290638],
              [62.097925, 26.290513],
              [62.097943, 26.290425],
              [62.097766, 26.29028],
              [62.097722, 26.290143],
              [62.097523, 26.289881],
              [62.097689, 26.289741],
              [62.097753, 26.289621],
              [62.097669, 26.289575],
              [62.097633, 26.289467],
              [62.09739, 26.289218],
              [62.097371, 26.288948],
              [62.097278, 26.288913],
              [62.097228, 26.288815],
              [62.097252, 26.288506],
              [62.097175, 26.288413],
              [62.097308, 26.288269],
              [62.09731, 26.28821],
              [62.097657, 26.287984],
              [62.097703, 26.287885],
              [62.097668, 26.287664],
              [62.097755, 26.287573],
              [62.097821, 26.287393],
              [62.097899, 26.287342],
              [62.098019, 26.287059],
              [62.098341, 26.286815],
              [62.098196, 26.286675],
              [62.097972, 26.286573],
              [62.097897, 26.286314],
              [62.098018, 26.2862],
              [62.09834, 26.286057],
              [62.098364, 26.285867],
              [62.098288, 26.285776],
              [62.098548, 26.285745],
              [62.098773, 26.285653],
              [62.099264, 26.285552],
              [62.099439, 26.285474],
              [62.099538, 26.285337],
              [62.099627, 26.285347],
              [62.099778, 26.28528],
              [62.099749, 26.28524],
              [62.099847, 26.284969],
              [62.099844, 26.284743],
              [62.099982, 26.284608],
              [62.099978, 26.284446],
              [62.09992, 26.284327],
              [62.100255, 26.284266],
              [62.100374, 26.284134],
              [62.100541, 26.284077],
              [62.100762, 26.283803],
              [62.100835, 26.283813],
              [62.100907, 26.283765],
              [62.101038, 26.283837],
              [62.101187, 26.283821],
              [62.101284, 26.283895],
              [62.101459, 26.283797],
              [62.101534, 26.283555],
              [62.101697, 26.283483],
              [62.101893, 26.283472],
              [62.102006, 26.283292],
              [62.102265, 26.283226],
              [62.102423, 26.283268],
              [62.102542, 26.283399],
              [62.102775, 26.283381],
              [62.103013, 26.283266],
              [62.103184, 26.283234],
              [62.10363, 26.283285],
              [62.103744, 26.283133],
              [62.103894, 26.283063],
              [62.104053, 26.282846],
              [62.104197, 26.282736],
              [62.104223, 26.282622],
              [62.104365, 26.282434],
              [62.10436, 26.28236],
              [62.104491, 26.282237],
              [62.104762, 26.282252],
              [62.105003, 26.282092],
              [62.105091, 26.282077],
              [62.105299, 26.282109],
              [62.105593, 26.281926],
              [62.105901, 26.281894],
              [62.106035, 26.281959],
              [62.106198, 26.281914],
              [62.10623, 26.282002],
              [62.106491, 26.282093],
              [62.106585, 26.282187],
              [62.106903, 26.282324],
              [62.107016, 26.282288],
              [62.107007, 26.282216],
              [62.107087, 26.282164],
              [62.107272, 26.282161],
              [62.107373, 26.28227],
              [62.10783, 26.282203],
              [62.108411, 26.282031],
              [62.108683, 26.282142],
              [62.108695, 26.282211],
              [62.108941, 26.282456],
              [62.109531, 26.282591],
              [62.109708, 26.282818],
              [62.110039, 26.282686],
              [62.110134, 26.282768],
              [62.110386, 26.282718],
              [62.110528, 26.282781],
              [62.110641, 26.28277],
              [62.11075, 26.282637],
              [62.11094, 26.282608],
              [62.111328, 26.282369],
              [62.111418, 26.282295],
              [62.111472, 26.282145],
              [62.111627, 26.282028],
              [62.111859, 26.281929],
              [62.111869, 26.281881],
              [62.112015, 26.281865],
              [62.112114, 26.281806],
              [62.112275, 26.281524],
              [62.112504, 26.281528],
              [62.112834, 26.281323],
              [62.113326, 26.280881],
              [62.113352, 26.280807],
              [62.11341, 26.28084],
              [62.11371, 26.280715],
              [62.113827, 26.280712],
              [62.113858, 26.280525],
              [62.113628, 26.280194],
              [62.11362, 26.280005],
              [62.113933, 26.279863],
              [62.114031, 26.279758],
              [62.114144, 26.279796],
              [62.114148, 26.279756],
              [62.114405, 26.279658],
              [62.114542, 26.27948],
              [62.114734, 26.279363],
              [62.114713, 26.27932],
              [62.114875, 26.279334],
              [62.11496, 26.279134],
              [62.115106, 26.278978],
              [62.115303, 26.278995],
              [62.115623, 26.278901],
              [62.115614, 26.278838],
              [62.115714, 26.278686],
              [62.116013, 26.278703],
              [62.116065, 26.278652],
              [62.116421, 26.278622],
              [62.116478, 26.278526],
              [62.116622, 26.278449],
              [62.116635, 26.278269],
              [62.116706, 26.278219],
              [62.116814, 26.278215],
              [62.116963, 26.278384],
              [62.117075, 26.278385],
              [62.117198, 26.278507],
              [62.117297, 26.278499],
              [62.117424, 26.278566],
              [62.117689, 26.278484],
              [62.117859, 26.278529],
              [62.117942, 26.278492],
              [62.118107, 26.278518],
              [62.118205, 26.278464],
              [62.118352, 26.278216],
              [62.118449, 26.278162],
              [62.118627, 26.277939],
              [62.118749, 26.277971],
              [62.118791, 26.277924],
              [62.118872, 26.277927],
              [62.119178, 26.27761],
              [62.119356, 26.277289],
              [62.119722, 26.277022],
              [62.119911, 26.277021],
              [62.120168, 26.276773],
              [62.120768, 26.276924],
              [62.121057, 26.27718],
              [62.121288, 26.277136],
              [62.121301, 26.277183],
              [62.12192, 26.277429],
              [62.121969, 26.277291],
              [62.122168, 26.27719],
              [62.122288, 26.277043],
              [62.122571, 26.27704],
              [62.122977, 26.276903],
              [62.12373, 26.276805],
              [62.124112, 26.276375],
              [62.124214, 26.276314],
              [62.124236, 26.276087],
              [62.124302, 26.275951],
              [62.124463, 26.275812],
              [62.124404, 26.275761],
              [62.124592, 26.27546],
              [62.12455, 26.275333],
              [62.124758, 26.275235],
              [62.124862, 26.275106],
              [62.125019, 26.27505],
              [62.124999, 26.275012],
              [62.125076, 26.274942],
              [62.125088, 26.274847],
              [62.125195, 26.274764],
              [62.125158, 26.274172],
              [62.125388, 26.273986],
              [62.125928, 26.273994],
              [62.126293, 26.273879],
              [62.12648, 26.273711],
              [62.126691, 26.273739],
              [62.126895, 26.273664],
              [62.127231, 26.273791],
              [62.127421, 26.273775],
              [62.127744, 26.27359],
              [62.127857, 26.273451],
              [62.128209, 26.273445],
              [62.128431, 26.273511],
              [62.128872, 26.273391],
              [62.129226, 26.273556],
              [62.129487, 26.273622],
              [62.12964, 26.273725],
              [62.130465, 26.273857],
              [62.130788, 26.273798],
              [62.131181, 26.274082],
              [62.131906, 26.273663],
              [62.132006, 26.273532],
              [62.132417, 26.273455],
              [62.132631, 26.273466],
              [62.132734, 26.273377],
              [62.132725, 26.273308],
              [62.132905, 26.273081],
              [62.13307, 26.273073],
              [62.133319, 26.27299],
              [62.133828, 26.273047],
              [62.134118, 26.27289],
              [62.134412, 26.272843],
              [62.134401, 26.272627],
              [62.134608, 26.272401],
              [62.134532, 26.272255],
              [62.134554, 26.272162],
              [62.134699, 26.272034],
              [62.13489, 26.272013],
              [62.135135, 26.271696],
              [62.13522, 26.271693],
              [62.135418, 26.271796],
              [62.135428, 26.271841],
              [62.135844, 26.27208],
              [62.135842, 26.27214],
              [62.135974, 26.272157],
              [62.136179, 26.272101],
              [62.136217, 26.271988],
              [62.136493, 26.271874],
              [62.136695, 26.271957],
              [62.136846, 26.271957],
              [62.137041, 26.272186],
              [62.137427, 26.272226],
              [62.13783, 26.272109],
              [62.137958, 26.271968],
              [62.138017, 26.271969],
              [62.13812, 26.272061],
              [62.138389, 26.272095],
              [62.138937, 26.272003],
              [62.139224, 26.272051],
              [62.139372, 26.271691],
              [62.139379, 26.271722],
              [62.139486, 26.27165],
              [62.139494, 26.271591],
              [62.139696, 26.271536],
              [62.139736, 26.271403],
              [62.139918, 26.271362],
              [62.139952, 26.271122],
              [62.140182, 26.271157],
              [62.140281, 26.271091],
              [62.140385, 26.27109],
              [62.140393, 26.271141],
              [62.140702, 26.271081],
              [62.140825, 26.271102],
              [62.140982, 26.271059],
              [62.141212, 26.2709],
              [62.141679, 26.270913],
              [62.14183, 26.271035],
              [62.142038, 26.271077],
              [62.142169, 26.271158],
              [62.142385, 26.271046],
              [62.143019, 26.270951],
              [62.143203, 26.270825],
              [62.143548, 26.270797],
              [62.14398, 26.270842],
              [62.14419, 26.270674],
              [62.144438, 26.270597],
              [62.144499, 26.270256],
              [62.144625, 26.270039],
              [62.144624, 26.269938],
              [62.144463, 26.269825],
              [62.144334, 26.269653],
              [62.144392, 26.269619],
              [62.144396, 26.269528],
              [62.144567, 26.26948],
              [62.144801, 26.269223],
              [62.144866, 26.269212],
              [62.144928, 26.269098],
              [62.145031, 26.269105],
              [62.145243, 26.268969],
              [62.14542, 26.268964],
              [62.145579, 26.269082],
              [62.145718, 26.269064],
              [62.14578, 26.269106],
              [62.146033, 26.269053],
              [62.14614, 26.269106],
              [62.146419, 26.269037],
              [62.146587, 26.269083],
              [62.146591, 26.269173],
              [62.146699, 26.269245],
              [62.146997, 26.269192],
              [62.147471, 26.269353],
              [62.147904, 26.269084],
              [62.148226, 26.26899],
              [62.148319, 26.268996],
              [62.148423, 26.269121],
              [62.148741, 26.269174],
              [62.148793, 26.26928],
              [62.1491, 26.269393],
              [62.14922, 26.269386],
              [62.14938, 26.269272],
              [62.149471, 26.269336],
              [62.149749, 26.269276],
              [62.149883, 26.269317],
              [62.150047, 26.269221],
              [62.150098, 26.269281],
              [62.150299, 26.269217],
              [62.150412, 26.269133],
              [62.150645, 26.269307],
              [62.150646, 26.26938],
              [62.150717, 26.269462],
              [62.150918, 26.269567],
              [62.150989, 26.269662],
              [62.151138, 26.269708],
              [62.1511, 26.269793],
              [62.15123, 26.269818],
              [62.151152, 26.269913],
              [62.151313, 26.270036],
              [62.151288, 26.270144],
              [62.151335, 26.27032],
              [62.15132, 26.270502],
              [62.151251, 26.270566],
              [62.151436, 26.270641],
              [62.151733, 26.270597],
              [62.15174, 26.270642],
              [62.151814, 26.270655],
              [62.152469, 26.270704],
              [62.152707, 26.2708],
              [62.152938, 26.270767],
              [62.153105, 26.270797],
              [62.153403, 26.270594],
              [62.153452, 26.27046],
              [62.153675, 26.270224],
              [62.153748, 26.27025],
              [62.154, 26.270164],
              [62.154072, 26.270193],
              [62.154374, 26.269981],
              [62.154593, 26.27],
              [62.154823, 26.269939],
              [62.155426, 26.270046],
              [62.155501, 26.269788],
              [62.155734, 26.269765],
              [62.155717, 26.269686],
              [62.155799, 26.269665],
              [62.155778, 26.269499],
              [62.156293, 26.269336],
              [62.156322, 26.269179],
              [62.156451, 26.269113],
              [62.156618, 26.26873],
              [62.156739, 26.268713],
              [62.156894, 26.268548],
              [62.157, 26.268514],
              [62.157054, 26.268557],
              [62.15715, 26.268508],
              [62.157327, 26.268306],
              [62.157747, 26.268059],
              [62.157844, 26.268032],
              [62.158002, 26.268046],
              [62.158007, 26.268081],
              [62.158077, 26.26805],
              [62.158522, 26.26814],
              [62.158904, 26.268122],
              [62.159034, 26.268155],
              [62.159027, 26.268263],
              [62.159235, 26.268277],
              [62.1593, 26.268329],
              [62.159433, 26.268299],
              [62.159628, 26.268365],
              [62.159854, 26.268144],
              [62.160053, 26.268086],
              [62.160286, 26.267895],
              [62.160397, 26.267901],
              [62.160697, 26.267774],
              [62.160737, 26.267669],
              [62.160894, 26.267596],
              [62.161047, 26.267641],
              [62.161161, 26.267764],
              [62.161212, 26.267917],
              [62.161397, 26.268038],
              [62.162113, 26.267737],
              [62.162456, 26.267776],
              [62.162621, 26.267667],
              [62.162742, 26.267646],
              [62.162849, 26.267683],
              [62.162888, 26.267506],
              [62.163006, 26.267443],
              [62.163197, 26.267454],
              [62.163423, 26.267307],
              [62.163527, 26.267363],
              [62.163657, 26.267311],
              [62.163969, 26.267351],
              [62.164129, 26.267184],
              [62.164312, 26.267076],
              [62.164828, 26.267109],
              [62.164871, 26.266949],
              [62.164968, 26.266818],
              [62.165252, 26.266693],
              [62.165672, 26.26675],
              [62.165958, 26.266898],
              [62.165983, 26.266984],
              [62.165919, 26.267154],
              [62.166012, 26.267446],
              [62.166334, 26.267785],
              [62.166555, 26.267783],
              [62.166674, 26.26793],
              [62.166894, 26.267769],
              [62.167265, 26.267717],
              [62.167471, 26.267811],
              [62.16755, 26.267773],
              [62.167617, 26.267794],
              [62.167621, 26.267865],
              [62.167741, 26.267852],
              [62.167837, 26.268003],
              [62.168077, 26.268049],
              [62.168258, 26.267904],
              [62.168714, 26.267674],
              [62.169066, 26.267764],
              [62.169192, 26.267699],
              [62.169426, 26.267717],
              [62.169523, 26.267654],
              [62.169912, 26.267569],
              [62.171167, 26.267656],
              [62.17167, 26.267492],
              [62.171744, 26.267394],
              [62.171907, 26.267441],
              [62.171985, 26.267632],
              [62.172327, 26.267812],
              [62.172381, 26.267912],
              [62.172591, 26.267953],
              [62.172735, 26.268068],
              [62.172865, 26.268059],
              [62.17324, 26.268187],
              [62.173425, 26.26832],
              [62.173638, 26.268363],
              [62.173668, 26.268322],
              [62.173795, 26.268344],
              [62.173905, 26.268407],
              [62.17407, 26.268314],
              [62.174448, 26.267935],
              [62.174655, 26.267977],
              [62.174844, 26.267937],
              [62.174959, 26.267999],
              [62.175267, 26.267996],
              [62.175296, 26.267841],
              [62.175444, 26.267685],
              [62.175397, 26.267439],
              [62.175473, 26.267267],
              [62.175436, 26.267151],
              [62.175464, 26.267086],
              [62.175513, 26.267009],
              [62.175882, 26.266769],
              [62.175907, 26.266675],
              [62.176001, 26.266601],
              [62.176004, 26.266461],
              [62.176166, 26.266393],
              [62.176325, 26.266246],
              [62.176338, 26.26614],
              [62.176573, 26.266173],
              [62.176662, 26.266243],
              [62.17726, 26.266226],
              [62.177548, 26.265912],
              [62.177647, 26.265898],
              [62.17774, 26.26594],
              [62.17784, 26.265865],
              [62.177887, 26.265683],
              [62.17808, 26.265538],
              [62.178306, 26.265614],
              [62.17833, 26.265706],
              [62.178456, 26.26578],
              [62.178502, 26.265936],
              [62.178617, 26.265941],
              [62.178772, 26.266049],
              [62.179004, 26.266108],
              [62.179113, 26.266076],
              [62.179331, 26.265809],
              [62.17949, 26.26573],
              [62.179583, 26.265731],
              [62.179694, 26.2658],
              [62.179998, 26.265811],
              [62.1801, 26.265725],
              [62.180302, 26.265664],
              [62.180511, 26.265721],
              [62.180631, 26.265679],
              [62.180923, 26.265684],
              [62.18119, 26.265895],
              [62.18124, 26.265892],
              [62.181395, 26.265628],
              [62.181542, 26.265505],
              [62.181977, 26.265415],
              [62.182121, 26.265538],
              [62.182363, 26.266016],
              [62.182384, 26.266141],
              [62.182648, 26.266118],
              [62.182713, 26.266167],
              [62.18274, 26.266277],
              [62.182857, 26.266279],
              [62.183027, 26.2664],
              [62.183407, 26.26626],
              [62.183701, 26.266319],
              [62.183994, 26.266305],
              [62.18425, 26.266502],
              [62.184592, 26.266548],
              [62.184972, 26.266412],
              [62.185398, 26.26617],
              [62.185939, 26.266136],
              [62.186035, 26.266166],
              [62.186312, 26.266021],
              [62.186433, 26.266069],
              [62.18706, 26.265744],
              [62.187305, 26.265538],
              [62.187662, 26.265557],
              [62.187722, 26.265639],
              [62.187894, 26.265687],
              [62.188197, 26.26595],
              [62.188516, 26.265945],
              [62.188558, 26.266055],
              [62.188625, 26.266033],
              [62.188647, 26.266122],
              [62.188839, 26.266166],
              [62.188955, 26.26631],
              [62.189109, 26.26636],
              [62.189287, 26.266625],
              [62.189667, 26.266913],
              [62.190167, 26.267077],
              [62.190207, 26.267002],
              [62.190312, 26.267003],
              [62.19051, 26.267076],
              [62.190541, 26.267134],
              [62.190951, 26.266998],
              [62.191033, 26.267028],
              [62.19118, 26.26688],
              [62.191256, 26.266873],
              [62.191413, 26.26674],
              [62.191718, 26.26686],
              [62.191981, 26.266875],
              [62.192135, 26.266989],
              [62.192386, 26.267015],
              [62.192635, 26.267169],
              [62.192895, 26.267057],
              [62.193114, 26.266894],
              [62.193342, 26.266937],
              [62.193567, 26.267079],
              [62.193743, 26.267019],
              [62.193889, 26.267074],
              [62.194181, 26.266983],
              [62.194421, 26.266959],
              [62.194915, 26.267192],
              [62.195068, 26.267182],
              [62.195194, 26.267278],
              [62.195561, 26.26723],
              [62.195759, 26.267057],
              [62.195864, 26.267085],
              [62.19607, 26.267042],
              [62.196175, 26.26726],
              [62.196321, 26.267328],
              [62.196384, 26.267563],
              [62.196625, 26.267694],
              [62.196851, 26.268043],
              [62.197322, 26.268117],
              [62.19769, 26.268117],
              [62.197746, 26.268332],
              [62.197572, 26.268959],
              [62.197734, 26.269388],
              [62.19803, 26.269428],
              [62.19829, 26.269673],
              [62.198545, 26.269619],
              [62.198664, 26.269687],
              [62.199351, 26.26986],
              [62.199418, 26.269671],
              [62.199544, 26.269657],
              [62.199778, 26.269525],
              [62.199955, 26.269276],
              [62.200121, 26.269202],
              [62.200285, 26.269021],
              [62.200493, 26.269054],
              [62.200626, 26.269009],
              [62.200736, 26.269073],
              [62.200845, 26.269049],
              [62.201043, 26.269149],
              [62.201162, 26.26905],
              [62.201685, 26.268988],
              [62.201953, 26.268462],
              [62.202038, 26.268401],
              [62.202199, 26.268054],
              [62.202298, 26.267969],
              [62.202453, 26.267926],
              [62.202649, 26.268057],
              [62.203167, 26.268139],
              [62.20367, 26.268373],
              [62.203968, 26.268382],
              [62.20419, 26.268205],
              [62.204743, 26.26815],
              [62.204823, 26.26809],
              [62.20513, 26.268002],
              [62.205233, 26.267884],
              [62.205527, 26.267708],
              [62.205937, 26.267775],
              [62.206028, 26.267839],
              [62.206122, 26.267812],
              [62.206254, 26.267667],
              [62.206452, 26.267559],
              [62.206988, 26.267365],
              [62.20716, 26.267219],
              [62.207177, 26.267132],
              [62.207691, 26.267044],
              [62.208229, 26.267057],
              [62.208274, 26.267189],
              [62.208459, 26.267269],
              [62.20844, 26.267308],
              [62.208899, 26.267337],
              [62.209062, 26.267399],
              [62.209453, 26.267833],
              [62.209598, 26.268117],
              [62.209785, 26.26823],
              [62.209944, 26.268506],
              [62.210079, 26.268633],
              [62.210335, 26.268738],
              [62.210471, 26.268854],
              [62.210601, 26.268777],
              [62.210762, 26.268774],
              [62.211072, 26.268643],
              [62.211142, 26.268552],
              [62.211527, 26.268309],
              [62.21193, 26.26827],
              [62.21197, 26.268205],
              [62.212166, 26.268106],
              [62.212608, 26.268054],
              [62.212765, 26.267959],
              [62.212905, 26.267941],
              [62.213019, 26.267677],
              [62.213228, 26.267646],
              [62.213361, 26.267559],
              [62.21367, 26.267823],
              [62.21401, 26.267927],
              [62.214611, 26.268028],
              [62.215011, 26.267929],
              [62.214965, 26.268183],
              [62.214942, 26.269591],
              [62.215219, 26.271521],
              [62.215618, 26.273131],
              [62.216204, 26.274305],
              [62.216653, 26.274884],
              [62.217353, 26.275459],
              [62.218226, 26.276333],
              [62.219418, 26.277076],
              [62.220532, 26.277685],
              [62.221435, 26.278313],
              [62.221962, 26.278753],
              [62.222302, 26.27916],
              [62.2228745, 26.2801091],
              [62.223746, 26.281554],
              [62.224223, 26.28256],
              [62.224455, 26.283652],
              [62.224466, 26.284197],
              [62.224225, 26.285068],
              [62.223853, 26.285863],
              [62.223258, 26.286674],
              [62.222567, 26.287376],
              [62.219682, 26.289494],
              [62.218674, 26.290004],
              [62.218009, 26.290248],
              [62.21785, 26.290537],
              [62.217612, 26.291628],
              [62.218254, 26.292332],
              [62.219312, 26.293726],
              [62.220861, 26.295561],
              [62.222111, 26.296791],
              [62.223234, 26.297551],
              [62.224524, 26.29825],
              [62.225883, 26.299102],
              [62.226998, 26.299983],
              [62.227659, 26.301095],
              [62.227978, 26.30256],
              [62.227887, 26.303679],
              [62.227466, 26.306198],
              [62.227714, 26.307664],
              [62.228394, 26.308805],
              [62.229063, 26.309621],
              [62.230354, 26.310822],
              [62.232714, 26.312749],
              [62.233776, 26.314001],
              [62.234399, 26.316692],
              [62.234434, 26.318719],
              [62.234262, 26.31936],
              [62.233539, 26.32027],
              [62.233105, 26.320584],
              [62.232078, 26.321807],
              [62.229531, 26.324348],
              [62.228087, 26.326068],
              [62.227549, 26.327504],
              [62.227744, 26.328946],
              [62.228244, 26.329538],
              [62.228826, 26.330063],
              [62.22978, 26.330819],
              [62.231424, 26.331327],
              [62.232594, 26.331204],
              [62.234424, 26.330533],
              [62.238604, 26.327027],
              [62.242289, 26.322129],
              [62.243442, 26.321321],
              [62.246298, 26.320749],
              [62.248494, 26.320114],
              [62.250085, 26.319833],
              [62.25211, 26.319894],
              [62.254221, 26.320738],
              [62.255773, 26.322365],
              [62.257638, 26.322956],
              [62.265627, 26.324125],
              [62.267582, 26.324634],
              [62.269246, 26.325456],
              [62.26997, 26.325595],
              [62.271207, 26.326598],
              [62.271944, 26.328003],
              [62.272133, 26.330626],
              [62.271923, 26.332465],
              [62.270684, 26.333866],
              [62.269284, 26.334858],
              [62.268182, 26.335515],
              [62.264565, 26.336773],
              [62.261741, 26.337657],
              [62.259473, 26.338183],
              [62.257467, 26.338261],
              [62.255717, 26.338744],
              [62.25446, 26.339351],
              [62.252185, 26.340611],
              [62.25116, 26.342063],
              [62.250561, 26.343569],
              [62.250452, 26.344801],
              [62.25036, 26.345122],
              [62.250133, 26.346581],
              [62.25148, 26.353423],
              [62.252812, 26.3588],
              [62.253075, 26.359691],
              [62.254049, 26.361625],
              [62.25459, 26.362948],
              [62.254806, 26.363123],
              [62.255006, 26.363378],
              [62.255494, 26.364207],
              [62.255708, 26.364444],
              [62.255989, 26.365202],
              [62.257099, 26.366524],
              [62.259616, 26.368336],
              [62.260758, 26.369267],
              [62.261734, 26.369959],
              [62.262945, 26.370746],
              [62.263717, 26.371161],
              [62.265895, 26.371929],
              [62.268453, 26.372393],
              [62.270088, 26.37278],
              [62.271457, 26.373261],
              [62.27374, 26.374206],
              [62.274934, 26.374643],
              [62.276664, 26.375166],
              [62.277669, 26.375667],
              [62.278439, 26.376157],
              [62.279904, 26.377201],
              [62.28268, 26.378488],
              [62.283469, 26.378953],
              [62.283921, 26.379275],
              [62.284351, 26.379707],
              [62.284695, 26.380344],
              [62.28457, 26.381284],
              [62.284054, 26.382502],
              [62.283581, 26.383429],
              [62.282253, 26.384719],
              [62.281828, 26.38522],
              [62.280816, 26.386028],
              [62.280501, 26.3867],
              [62.280187, 26.387862],
              [62.28017, 26.388082],
              [62.280075, 26.388299],
              [62.278484, 26.39098],
              [62.276723, 26.393459],
              [62.275764, 26.394691],
              [62.275089, 26.395704],
              [62.274117, 26.396743],
              [62.273348, 26.397467],
              [62.272509, 26.398383],
              [62.271339, 26.400089],
              [62.270402, 26.401154],
              [62.269869, 26.401921],
              [62.26975, 26.402459],
              [62.269749, 26.403767],
              [62.269597, 26.404105],
              [62.269048, 26.404395],
              [62.268282, 26.404538],
              [62.267085, 26.404593],
              [62.266263, 26.404487],
              [62.265806, 26.404498],
              [62.264991, 26.404797],
              [62.264007, 26.4053],
              [62.262891, 26.406126],
              [62.261393, 26.40705],
              [62.259498, 26.408339],
              [62.259323, 26.408838],
              [62.259388, 26.409613],
              [62.259642, 26.410487],
              [62.259865, 26.410902],
              [62.260484, 26.411571],
              [62.260649, 26.41226],
              [62.260836, 26.413689],
              [62.260759, 26.414204],
              [62.261006, 26.416308],
              [62.261293, 26.417277],
              [62.261418, 26.419207],
              [62.261536, 26.422126],
              [62.2615, 26.422448],
              [62.261554, 26.423067],
              [62.261741, 26.423451],
              [62.263305, 26.424431],
              [62.263868, 26.425009],
              [62.264343, 26.426129],
              [62.264432, 26.426531],
              [62.264281, 26.427032],
              [62.263801, 26.427526],
              [62.263283, 26.427685],
              [62.263061, 26.427813],
              [62.262876, 26.428135],
              [62.262675, 26.428676],
              [62.262687, 26.431439],
              [62.262555, 26.432137],
              [62.262725, 26.432952],
              [62.262768, 26.43371],
              [62.263098, 26.434876],
              [62.263364, 26.436044],
              [62.263388, 26.436367],
              [62.263655, 26.436658],
              [62.26448, 26.437903],
              [62.264718, 26.438521],
              [62.264992, 26.438653],
              [62.265063, 26.439459],
              [62.264952, 26.44019],
              [62.264638, 26.44111],
              [62.264266, 26.441823],
              [62.263961, 26.44214],
              [62.263431, 26.442385],
              [62.262256, 26.442672],
              [62.260937, 26.442822],
              [62.260108, 26.44306],
              [62.259134, 26.443772],
              [62.2587, 26.444391],
              [62.258507, 26.444941],
              [62.258022, 26.445147],
              [62.257764, 26.445703],
              [62.257767, 26.446225],
              [62.257893, 26.446631],
              [62.258316, 26.4469],
              [62.259036, 26.447113],
              [62.260281, 26.447351],
              [62.261631, 26.447424],
              [62.264094, 26.447461],
              [62.26499, 26.447391],
              [62.266165, 26.447129],
              [62.26955, 26.446195],
              [62.271113, 26.445238],
              [62.271623, 26.445013],
              [62.272456, 26.444151],
              [62.273125, 26.443191],
              [62.27403, 26.442549],
              [62.275664, 26.441749],
              [62.278107, 26.440408],
              [62.279206, 26.44026],
              [62.280269, 26.439976],
              [62.282089, 26.439882],
              [62.283409, 26.439712],
              [62.284365, 26.439673],
              [62.284882, 26.439747],
              [62.285381, 26.439951],
              [62.28612, 26.440329],
              [62.286175, 26.440552],
              [62.286192, 26.441272],
              [62.285982, 26.443439],
              [62.286209, 26.444028],
              [62.286821, 26.446302],
              [62.286955, 26.446584],
              [62.287915, 26.447879],
              [62.288256, 26.448831],
              [62.288263, 26.44925],
              [62.28816, 26.449467],
              [62.288201, 26.44968],
              [62.288535, 26.449914],
              [62.289052, 26.450022],
              [62.290957, 26.449978],
              [62.292075, 26.450078],
              [62.294207, 26.450367],
              [62.294497, 26.450293],
              [62.294937, 26.450342],
              [62.295278, 26.450451],
              [62.295699, 26.450802],
              [62.296396, 26.452052],
              [62.297893, 26.45418],
              [62.298456, 26.455212],
              [62.298199, 26.456876],
              [62.298201, 26.457578],
              [62.297952, 26.458145],
              [62.297825, 26.459365],
              [62.297573, 26.460548],
              [62.297299, 26.461396],
              [62.297452, 26.461832],
              [62.298337, 26.462059],
              [62.299449, 26.462183],
              [62.299995, 26.462328],
              [62.300904, 26.462377],
              [62.301744, 26.462204],
              [62.30273, 26.462118],
              [62.303926, 26.46191],
              [62.305518, 26.461837],
              [62.305962, 26.461966],
              [62.306568, 26.462389],
              [62.306943, 26.462772],
              [62.307104, 26.463173],
              [62.307066, 26.464121],
              [62.306583, 26.464615],
              [62.30566, 26.465427],
              [62.304948, 26.466166],
              [62.30434, 26.467254],
              [62.304411, 26.467789],
              [62.304602, 26.468449],
              [62.304921, 26.468978],
              [62.305176, 26.469257],
              [62.305717, 26.469516],
              [62.306497, 26.469734],
              [62.309345, 26.47032],
              [62.30965, 26.470453],
              [62.310844, 26.471173],
              [62.311165, 26.471557],
              [62.311553, 26.471876],
              [62.312921, 26.472457],
              [62.313823, 26.472918],
              [62.314159, 26.473443],
              [62.31419, 26.47403],
              [62.314081, 26.474988],
              [62.31339, 26.476585],
              [62.312954, 26.477134],
              [62.311692, 26.477777],
              [62.311102, 26.478171],
              [62.310758, 26.47877],
              [62.310592, 26.479912],
              [62.31083, 26.480826],
              [62.311174, 26.481404],
              [62.311592, 26.481874],
              [62.312067, 26.48218],
              [62.312685, 26.48245],
              [62.314161, 26.482763],
              [62.314767, 26.482992],
              [62.314983, 26.483307],
              [62.315162, 26.483753],
              [62.315223, 26.484468],
              [62.315003, 26.485137],
              [62.31491, 26.485762],
              [62.314922, 26.486499],
              [62.314784, 26.486896],
              [62.314534, 26.487048],
              [62.313883, 26.487179],
              [62.313149, 26.487081],
              [62.311783, 26.486635],
              [62.310185, 26.486213],
              [62.308705, 26.486122],
              [62.307577, 26.485986],
              [62.305813, 26.485427],
              [62.305572, 26.48548],
              [62.305001, 26.486242],
              [62.305097, 26.486847],
              [62.305399, 26.487229],
              [62.305455, 26.48747],
              [62.305413, 26.487603],
              [62.30367, 26.488573],
              [62.302742, 26.488998],
              [62.300436, 26.489221],
              [62.299849, 26.489383],
              [62.299474, 26.489653],
              [62.299141, 26.490789],
              [62.299099, 26.492051],
              [62.299309, 26.4933],
              [62.300092, 26.496394],
              [62.300084, 26.496779],
              [62.299939, 26.497544],
              [62.299894, 26.498121],
              [62.3015678, 26.5001541],
              [62.301752, 26.503532],
              [62.303304, 26.508287],
              [62.308438, 26.513877],
              [62.311023, 26.516539],
              [62.312261, 26.51861],
              [62.314217, 26.519898],
              [62.319102, 26.520998],
              [62.32274, 26.52099],
              [62.328443, 26.520227],
              [62.330521, 26.520647],
              [62.335595, 26.522677],
              [62.337731, 26.524174],
              [62.345272, 26.526755],
              [62.349126, 26.527994],
              [62.353272, 26.529062],
              [62.356796, 26.530514],
              [62.357025, 26.530637],
              [62.357958, 26.531404],
              [62.360062, 26.533653],
              [62.361364, 26.534868],
              [62.3634, 26.536268],
              [62.36503, 26.537282],
              [62.366782, 26.537821],
              [62.367759, 26.538244],
              [62.36926, 26.538974],
              [62.370225, 26.539378],
              [62.371392, 26.539414],
              [62.371772, 26.539487],
              [62.372402, 26.539457],
              [62.37335, 26.539514],
              [62.374445, 26.539382],
              [62.374767, 26.539382],
              [62.37541, 26.539284],
              [62.378635, 26.538281],
              [62.379806, 26.537572],
              [62.381406, 26.536374],
              [62.383007, 26.535311],
              [62.385214, 26.533565],
              [62.386146, 26.533156],
              [62.387944, 26.532752],
              [62.388766, 26.532448],
              [62.389793, 26.532202],
              [62.39026, 26.532132],
              [62.390638, 26.532135],
              [62.391412, 26.532225],
              [62.392471, 26.532571],
              [62.393463, 26.532807],
              [62.395674, 26.533704],
              [62.396336, 26.53411],
              [62.397049, 26.534828],
              [62.397537, 26.535466],
              [62.397874, 26.536731],
              [62.398267, 26.537244],
              [62.398423, 26.537388],
              [62.399114, 26.537722],
              [62.400095, 26.537945],
              [62.401227, 26.53788],
              [62.403715, 26.53746],
              [62.404411, 26.53727],
              [62.405144, 26.536823],
              [62.405781, 26.536732],
              [62.40651, 26.536702],
              [62.40739, 26.536823],
              [62.408031, 26.536784],
              [62.408534, 26.53662],
              [62.408806, 26.536485],
              [62.409707, 26.53592],
              [62.410823, 26.53532],
              [62.4112419, 26.5351691],
              [62.412006, 26.534894],
              [62.413105, 26.53434],
              [62.414185, 26.534044],
              [62.415779, 26.533717],
              [62.417279, 26.533572],
              [62.4180889, 26.5333262],
              [62.4189169, 26.5330852],
              [62.4198632, 26.5327758],
              [62.4203312, 26.5328138],
              [62.4211762, 26.5331578],
              [62.4215092, 26.5333488],
              [62.421694, 26.533971],
              [62.42176, 26.534205],
              [62.42276, 26.538055],
              [62.422825, 26.538592],
              [62.422761, 26.539188],
              [62.422524, 26.539861],
              [62.422235, 26.5402],
              [62.421837, 26.540454],
              [62.420602, 26.540627],
              [62.420286, 26.540783],
              [62.420286, 26.54102],
              [62.420706, 26.541435],
              [62.421142, 26.541642],
              [62.421706, 26.542156],
              [62.422091, 26.542595],
              [62.422444, 26.543074],
              [62.42283, 26.544079],
              [62.423348, 26.545995],
              [62.423467, 26.546897],
              [62.423288, 26.547822],
              [62.42332, 26.548057],
              [62.423199, 26.549858],
              [62.423236, 26.550249],
              [62.423661, 26.550926],
              [62.424549, 26.55175],
              [62.42561, 26.552564],
              [62.426834, 26.553379],
              [62.42791, 26.553667],
              [62.428511, 26.55409],
              [62.42876, 26.554203],
              [62.430889, 26.556787],
              [62.432853, 26.559063],
              [62.433651, 26.559498],
              [62.43516, 26.560083],
              [62.436275, 26.560249],
              [62.437612, 26.560302],
              [62.439885, 26.560209],
              [62.440403, 26.560376],
              [62.440691, 26.560932],
              [62.44062, 26.561692],
              [62.440231, 26.562935],
              [62.43999, 26.564125],
              [62.440021, 26.564819],
              [62.440704, 26.565295],
              [62.441469, 26.565634],
              [62.445165, 26.566895],
              [62.446431, 26.567232],
              [62.447453, 26.56737],
              [62.448218, 26.567407],
              [62.448941, 26.567362],
              [62.450807, 26.56704],
              [62.451428, 26.566867],
              [62.452407, 26.566394],
              [62.453196, 26.565375],
              [62.454482, 26.564361],
              [62.455611, 26.563801],
              [62.456765, 26.563333],
              [62.457967, 26.562968],
              [62.458445, 26.562863],
              [62.459556, 26.562954],
              [62.460777, 26.562892],
              [62.461389, 26.56271],
              [62.46231, 26.563004],
              [62.463482, 26.56361],
              [62.4673, 26.565243],
              [62.468829, 26.565787],
              [62.469863, 26.56562],
              [62.472348, 26.567038],
              [62.473732, 26.567501],
              [62.475074, 26.56822],
              [62.475855, 26.568508],
              [62.477278, 26.568525],
              [62.479068, 26.567977],
              [62.479593, 26.567717],
              [62.480883, 26.567343],
              [62.483961, 26.566998],
              [62.484838, 26.567049],
              [62.486549, 26.567359],
              [62.488527, 26.567939],
              [62.489493, 26.568283],
              [62.492853, 26.568944],
              [62.493996, 26.569406],
              [62.495839, 26.571163],
              [62.496684, 26.570968],
              [62.497594, 26.570963],
              [62.499105, 26.571403],
              [62.500479, 26.571916],
              [62.50167, 26.572255],
              [62.502788, 26.572401],
              [62.503563, 26.572693],
              [62.504296, 26.572709],
              [62.504879, 26.572833],
              [62.505576, 26.573234],
              [62.50592, 26.5736],
              [62.506011, 26.574049],
              [62.506046, 26.575113],
              [62.506558, 26.575969],
              [62.507147, 26.577245],
              [62.508263, 26.577677],
              [62.509327, 26.577862],
              [62.510476, 26.577943],
              [62.512024, 26.57773],
              [62.514761, 26.576997],
              [62.515578, 26.57652],
              [62.516305, 26.576258],
              [62.5169577, 26.5757508],
              [62.517283, 26.575498],
              [62.518229, 26.57454],
              [62.519264, 26.573214],
              [62.520929, 26.572006],
              [62.522331, 26.571535],
              [62.523247, 26.571726],
              [62.524433, 26.571534],
              [62.525835, 26.571166],
              [62.526835, 26.570956],
              [62.527646, 26.570906],
              [62.528924, 26.570996],
              [62.530448, 26.571338],
              [62.5319, 26.571405],
              [62.533152, 26.571576],
              [62.534207, 26.571876],
              [62.535115, 26.572301],
              [62.536011, 26.572787],
              [62.536799, 26.572974],
              [62.539298, 26.573295],
              [62.540934, 26.573822],
              [62.543209, 26.574349],
              [62.54672, 26.574436],
              [62.548093, 26.574117],
              [62.54833, 26.574167],
              [62.5505, 26.575072],
              [62.552043, 26.575738],
              [62.552462, 26.575968],
              [62.558237, 26.57681],
              [62.559429, 26.576935],
              [62.561001, 26.576816],
              [62.562715, 26.576542],
              [62.563596, 26.576337],
              [62.565713, 26.576241],
              [62.569542, 26.576172],
              [62.571718, 26.576478],
              [62.576476, 26.577442],
              [62.577197, 26.57753],
              [62.578337, 26.577578],
              [62.579633, 26.577571],
              [62.581254, 26.577438],
              [62.583973, 26.577406],
              [62.58567, 26.577073],
              [62.587378, 26.576824],
              [62.5884451, 26.576841],
              [62.590457, 26.576873],
              [62.591526, 26.576787],
              [62.592412, 26.576774],
              [62.59445, 26.576247],
              [62.595729, 26.576007],
              [62.601445, 26.575989],
              [62.604098, 26.576273],
              [62.604424, 26.576492],
              [62.604557, 26.577937],
              [62.604697, 26.57839],
              [62.605151, 26.579441],
              [62.605833, 26.580323],
              [62.607539, 26.581549],
              [62.609283, 26.582487],
              [62.610743, 26.583143],
              [62.614006, 26.584013],
              [62.614825, 26.584316],
              [62.615597, 26.584834],
              [62.619983, 26.586231],
              [62.621932, 26.586746],
              [62.622958, 26.587143],
              [62.623721, 26.587631],
              [62.624795, 26.588749],
              [62.626824, 26.590226],
              [62.62828, 26.590743],
              [62.629425, 26.591092],
              [62.63045, 26.591231],
              [62.633609, 26.591522],
              [62.634975, 26.592231],
              [62.635831, 26.593085],
              [62.637055, 26.595075],
              [62.637436, 26.596206],
              [62.638224, 26.597291],
              [62.641782, 26.599162],
              [62.642822, 26.599523],
              [62.644306, 26.59984],
              [62.64617, 26.600902],
              [62.646892, 26.601754],
              [62.647749, 26.603082],
              [62.647913, 26.603874],
              [62.647828, 26.605271],
              [62.648111, 26.606866],
              [62.648636, 26.60859],
              [62.649324, 26.609622],
              [62.651571, 26.610976],
              [62.653724, 26.610854],
              [62.655738, 26.610623],
              [62.657836, 26.610266],
              [62.659415, 26.610239],
              [62.661921, 26.610642],
              [62.663932, 26.611208],
              [62.665505, 26.611753],
              [62.668034, 26.61228],
              [62.670853, 26.612561],
              [62.672106, 26.612291],
              [62.673134, 26.611797],
              [62.674239, 26.610968],
              [62.674896, 26.610541],
              [62.675644, 26.610309],
              [62.676465, 26.60991],
              [62.676823, 26.609276],
              [62.677578, 26.608375],
              [62.678564, 26.607551],
              [62.680177, 26.605189],
              [62.681213, 26.604037],
              [62.681912, 26.60338],
              [62.683483, 26.602275],
              [62.684569, 26.601649],
              [62.685838, 26.601123],
              [62.687096, 26.600803],
              [62.688486, 26.600529],
              [62.689236, 26.60049],
              [62.689732, 26.600632],
              [62.690577, 26.601217],
              [62.691378, 26.602027],
              [62.692421, 26.60324],
              [62.694718, 26.606484],
              [62.695751, 26.60785],
              [62.696561, 26.608879],
              [62.696979, 26.609269],
              [62.697616, 26.609444],
              [62.698575, 26.609358],
              [62.699025, 26.609257],
              [62.699875, 26.60898],
              [62.701038, 26.608311],
              [62.703983, 26.608129],
              [62.705112, 26.608011],
              [62.706109, 26.608083],
              [62.706898, 26.608261],
              [62.708731, 26.60878],
              [62.710144, 26.609088],
              [62.713637, 26.610295],
              [62.714847, 26.610835],
              [62.715952, 26.612077],
              [62.716872, 26.612925],
              [62.71759, 26.613862],
              [62.718326, 26.614337],
              [62.719142, 26.61453],
              [62.720102, 26.614573],
              [62.72077, 26.61452],
              [62.721568, 26.614314],
              [62.723213, 26.613757],
              [62.724258, 26.613744],
              [62.724828, 26.613788],
              [62.725351, 26.613983],
              [62.725668, 26.61446],
              [62.725715, 26.61523],
              [62.72598, 26.616321],
              [62.726347, 26.61704],
              [62.727204, 26.618259],
              [62.727305, 26.61834],
              [62.728322, 26.618523],
              [62.729383, 26.618387],
              [62.730194, 26.618205],
              [62.730796, 26.617484],
              [62.731632, 26.616237],
              [62.73231, 26.615047],
              [62.733059, 26.614293],
              [62.733389, 26.614025],
              [62.733826, 26.61375],
              [62.734673, 26.61363],
              [62.735578, 26.613567],
              [62.736343, 26.613433],
              [62.737316, 26.613188],
              [62.738103, 26.613237],
              [62.738544, 26.613542],
              [62.73877, 26.614121],
              [62.738858, 26.614994],
              [62.738479, 26.615762],
              [62.737362, 26.617179],
              [62.735907, 26.619442],
              [62.734547, 26.621263],
              [62.733008, 26.622856],
              [62.732201, 26.623575],
              [62.731781, 26.624411],
              [62.731681, 26.625402],
              [62.73235, 26.627629],
              [62.732607, 26.628067],
              [62.733263, 26.629538],
              [62.733898, 26.630563],
              [62.734834, 26.6313],
              [62.7354, 26.631662],
              [62.735558, 26.631713],
              [62.737552, 26.632794],
              [62.739098, 26.632894],
              [62.740947, 26.632947],
              [62.742177, 26.632908],
              [62.74355, 26.633412],
              [62.74425, 26.63414],
              [62.744453, 26.634449],
              [62.744813, 26.63513],
              [62.745423, 26.636746],
              [62.7461, 26.637764],
              [62.747259, 26.63913],
              [62.74946, 26.640942],
              [62.752246, 26.642764],
              [62.7530063, 26.6431979],
              [62.7535368, 26.6450164],
              [62.7551262, 26.6458089],
              [62.7563549, 26.6458244],
              [62.7588178, 26.6458556],
              [62.7608113, 26.6454665],
              [62.7622559, 26.6461599],
              [62.765293, 26.644437],
              [62.7664, 26.643643],
              [62.767513, 26.643084],
              [62.7690289, 26.641007],
              [62.7718851, 26.6396411],
              [62.7745082, 26.6387006],
              [62.7763719, 26.6387984],
              [62.7772269, 26.6388074],
              [62.7789669, 26.6389914],
              [62.779941, 26.639972],
              [62.780403, 26.641686],
              [62.781358, 26.643],
              [62.782303, 26.643317],
              [62.783592, 26.643923],
              [62.785461, 26.645024],
              [62.788217, 26.647164],
              [62.790634, 26.649111],
              [62.793525, 26.650715],
              [62.7947, 26.651003],
              [62.795972, 26.650248],
              [62.796656, 26.649097],
              [62.796876, 26.64807],
              [62.797338, 26.647311],
              [62.797983, 26.647029],
              [62.800239, 26.646937],
              [62.801253, 26.64712],
              [62.802319, 26.647861],
              [62.803744, 26.648738],
              [62.805235, 26.649472],
              [62.805932, 26.649919],
              [62.806387, 26.650011],
              [62.807767, 26.650146],
              [62.809164, 26.650169],
              [62.809988, 26.649847],
              [62.811339, 26.648827],
              [62.812196, 26.647949],
              [62.813421, 26.646903],
              [62.815903, 26.645514],
              [62.81756, 26.644233],
              [62.819331, 26.643141],
              [62.821488, 26.641233],
              [62.823375, 26.639084],
              [62.823982, 26.638165],
              [62.824409, 26.637995],
              [62.825304, 26.638301],
              [62.826831, 26.639328],
              [62.828261, 26.640558],
              [62.829285, 26.641868],
              [62.830622, 26.644699],
              [62.831594, 26.645235],
              [62.833002, 26.644794],
              [62.83415, 26.644357],
              [62.836332, 26.642454],
              [62.837637, 26.641691],
              [62.838757, 26.641282],
              [62.840862, 26.641245],
              [62.842079, 26.641555],
              [62.844085, 26.642346],
              [62.845741, 26.64257],
              [62.848523, 26.642823],
              [62.851218, 26.643149],
              [62.853909, 26.64338],
              [62.856741, 26.642676],
              [62.857673, 26.642695],
              [62.8587, 26.642846],
              [62.860477, 26.642678],
              [62.861284, 26.642522],
              [62.862828, 26.641671],
              [62.863323, 26.641453],
              [62.864598, 26.641318],
              [62.866953, 26.641436],
              [62.871063, 26.642269],
              [62.873058, 26.642747],
              [62.875403, 26.642749],
              [62.877413, 26.643772],
              [62.878641, 26.644218],
              [62.879982, 26.644767],
              [62.882253, 26.645172],
              [62.883534, 26.645509],
              [62.883949, 26.645556],
              [62.884404, 26.64553],
              [62.885541, 26.646028],
              [62.886958, 26.646431],
              [62.887814, 26.646358],
              [62.889057, 26.646026],
              [62.89172, 26.64515],
              [62.893371, 26.64434],
              [62.894331, 26.643018],
              [62.895087, 26.642225],
              [62.896041, 26.641377],
              [62.89723, 26.640896],
              [62.899402, 26.640582],
              [62.9005901, 26.6404345],
              [62.9024412, 26.6406291],
              [62.9037999, 26.6431029],
              [62.905987, 26.643946],
              [62.9081696, 26.6430714],
              [62.908906, 26.6425304],
              [62.910632, 26.643294],
              [62.9118904, 26.6439926],
              [62.9166813, 26.6456178],
              [62.91852, 26.645579],
              [62.918664, 26.645587],
              [62.9200712, 26.6450989],
              [62.9201696, 26.6435198],
              [62.9227511, 26.6410358],
              [62.925477, 26.640362],
              [62.927121, 26.639843],
              [62.929703, 26.639257],
              [62.931568, 26.639157],
              [62.933721, 26.639178],
              [62.934241, 26.639642],
              [62.934491, 26.64176],
              [62.93474, 26.643005],
              [62.935365, 26.643575],
              [62.936519, 26.644226],
              [62.937338, 26.64446],
              [62.938797, 26.644399],
              [62.939719, 26.644228],
              [62.940779, 26.643861],
              [62.942055, 26.64254],
              [62.943207, 26.641143],
              [62.943479, 26.640727],
              [62.944086, 26.640613],
              [62.944987, 26.640658],
              [62.945861, 26.641065],
              [62.94682, 26.643387],
              [62.949386, 26.645984],
              [62.95114, 26.647441],
              [62.951955, 26.647705],
              [62.953534, 26.648007],
              [62.955922, 26.647537],
              [62.956972, 26.647442],
              [62.960722, 26.64685],
              [62.962336, 26.64736],
              [62.963392, 26.647781],
              [62.96425, 26.648486],
              [62.96509, 26.64896],
              [62.96594, 26.649242],
              [62.966934, 26.649074],
              [62.96771, 26.648744],
              [62.968079, 26.648665],
              [62.970196, 26.648385],
              [62.970628, 26.648385],
              [62.972195, 26.64811],
              [62.973944, 26.647699],
              [62.974777, 26.64684],
              [62.975157, 26.64675],
              [62.975376, 26.646574],
              [62.975468, 26.646358],
              [62.975943, 26.645929],
              [62.976165, 26.645815],
              [62.976481, 26.64576],
              [62.977091, 26.645718],
              [62.977382, 26.645636],
              [62.977653, 26.645643],
              [62.97953, 26.646038],
              [62.980439, 26.646421],
              [62.980943, 26.646674],
              [62.982804, 26.647923],
              [62.983428, 26.648241],
              [62.984739, 26.649039],
              [62.986139, 26.649419],
              [62.987784, 26.649792],
              [62.989011, 26.649921],
              [62.989971, 26.649943],
              [62.992146, 26.649058],
              [62.992682, 26.648658],
              [62.993824, 26.648468],
              [62.994835, 26.64836],
              [62.995261, 26.648028],
              [62.995668, 26.647544],
              [62.996246, 26.646501],
              [62.996715, 26.644579],
              [62.99698, 26.643993],
              [62.997252, 26.642873],
              [62.998122, 26.640136],
              [62.99832, 26.639296],
              [62.998621, 26.63917],
              [62.999257, 26.639054],
              [62.99986, 26.639156],
              [63.000461, 26.639392],
              [63.000899, 26.639724],
              [63.002421, 26.641067],
              [63.003135, 26.641553],
              [63.004337, 26.642078],
              [63.004958, 26.642271],
              [63.006349, 26.642533],
              [63.008544, 26.642618],
              [63.009945, 26.642801],
              [63.010852, 26.643113],
              [63.011656, 26.643747],
              [63.012153, 26.644591],
              [63.012565, 26.645539],
              [63.013772, 26.646011],
              [63.014727, 26.646273],
              [63.015172, 26.646465],
              [63.01593, 26.64645],
              [63.016474, 26.646076],
              [63.016469, 26.645939],
              [63.016569, 26.645733],
              [63.016732, 26.645625],
              [63.016872, 26.645456],
              [63.016918, 26.645268],
              [63.017135, 26.64488],
              [63.017383, 26.644568],
              [63.018866, 26.642213],
              [63.019826, 26.641491],
              [63.021724, 26.640515],
              [63.023589, 26.639891],
              [63.02439, 26.6395],
              [63.025092, 26.638938],
              [63.02553, 26.638393],
              [63.025837, 26.637853],
              [63.026393, 26.637207],
              [63.027616, 26.636188],
              [63.028626, 26.635875],
              [63.030339, 26.635113],
              [63.030633, 26.634816],
              [63.031953, 26.634128],
              [63.032925, 26.633688],
              [63.033943, 26.633416],
              [63.034617, 26.633102],
              [63.03505, 26.632554],
              [63.035425, 26.631572],
              [63.035648, 26.631213],
              [63.035911, 26.63059],
              [63.03639, 26.629653],
              [63.036927, 26.629524],
              [63.037328, 26.629292],
              [63.038425, 26.628865],
              [63.041188, 26.62856],
              [63.042474, 26.628775],
              [63.04342, 26.629325],
              [63.044029, 26.629314],
              [63.045012, 26.629051],
              [63.046014, 26.628323],
              [63.046336, 26.628183],
              [63.048857, 26.627541],
              [63.049491, 26.627821],
              [63.050361, 26.628569],
              [63.05159, 26.629196],
              [63.053278, 26.629679],
              [63.054437, 26.630987],
              [63.054884, 26.631642],
              [63.055522, 26.634324],
              [63.055967, 26.635828],
              [63.056406, 26.636905],
              [63.057121, 26.637772],
              [63.05803, 26.638299],
              [63.058472, 26.638371],
              [63.060435, 26.638293],
              [63.062039, 26.638678],
              [63.062811, 26.639313],
              [63.063225, 26.639914],
              [63.063472, 26.641215],
              [63.063696, 26.641546],
              [63.064194, 26.64194],
              [63.064759, 26.642146],
              [63.065478, 26.642044],
              [63.066437, 26.64167],
              [63.0676, 26.641099],
              [63.069266, 26.639985],
              [63.072085, 26.638357],
              [63.072737, 26.637632],
              [63.073837, 26.637041],
              [63.075448, 26.636327],
              [63.076361, 26.636544],
              [63.077874, 26.63733],
              [63.078574, 26.637823],
              [63.079167, 26.63796],
              [63.080186, 26.638275],
              [63.081444, 26.638559],
              [63.082184, 26.638637],
              [63.082648, 26.638616],
              [63.083415, 26.638492],
              [63.084819, 26.638589],
              [63.086628, 26.638963],
              [63.086802, 26.63917],
              [63.087203, 26.639265],
              [63.088225, 26.639305],
              [63.090389, 26.639747],
              [63.091161, 26.639835],
              [63.091794, 26.639743],
              [63.092249, 26.639819],
              [63.092899, 26.640114],
              [63.093491, 26.640449],
              [63.093505, 26.640644],
              [63.093375, 26.641139],
              [63.093512, 26.641498],
              [63.09378, 26.641921],
              [63.094003, 26.642135],
              [63.09408, 26.642564],
              [63.094504, 26.643544],
              [63.095383, 26.644933],
              [63.095881, 26.645474],
              [63.096504, 26.646004],
              [63.097567, 26.647102],
              [63.097948, 26.64771],
              [63.099007, 26.649064],
              [63.1007, 26.650391],
              [63.102875, 26.65107],
              [63.103997, 26.651204],
              [63.105046, 26.651094],
              [63.105568, 26.651265],
              [63.106426, 26.651858],
              [63.107195, 26.652267],
              [63.108061, 26.652392],
              [63.108576, 26.652419],
              [63.109824, 26.652088],
              [63.111069, 26.651817],
              [63.111425, 26.651608],
              [63.112031, 26.651088],
              [63.113012, 26.650617],
              [63.114488, 26.649825],
              [63.115055, 26.649474],
              [63.11619, 26.64909],
              [63.118958, 26.648473],
              [63.119862, 26.648383],
              [63.121974, 26.64899],
              [63.122859, 26.649116],
              [63.123527, 26.649121],
              [63.124369, 26.649345],
              [63.125878, 26.650026],
              [63.126524, 26.650053],
              [63.128505, 26.649806],
              [63.129303, 26.64995],
              [63.13007, 26.650174],
              [63.130583, 26.650379],
              [63.131023, 26.650644],
              [63.131712, 26.650499],
              [63.132896, 26.650544],
              [63.13399, 26.6508],
              [63.13444, 26.65099],
              [63.137351, 26.650574],
              [63.138705, 26.651218],
              [63.147787, 26.649686],
              [63.148756, 26.649605],
              [63.149587, 26.649615],
              [63.150302, 26.649519],
              [63.151846, 26.649407],
              [63.15556, 26.649485],
              [63.157746, 26.649256],
              [63.158044, 26.649019],
              [63.158764, 26.648701],
              [63.160169, 26.648875],
              [63.161394, 26.648755],
              [63.162841, 26.648322],
              [63.163802, 26.648253],
              [63.16493, 26.647956],
              [63.165446, 26.647951],
              [63.166175, 26.647793],
              [63.168107, 26.647177],
              [63.168549, 26.647178],
              [63.169195, 26.646763],
              [63.169394, 26.64682],
              [63.169737, 26.64682],
              [63.170132, 26.646918],
              [63.17047, 26.646899],
              [63.170954, 26.646797],
              [63.171228, 26.646666],
              [63.171775, 26.646707],
              [63.1726275, 26.646383],
              [63.172646, 26.646376],
              [63.172928, 26.646426],
              [63.173282, 26.646735],
              [63.173677, 26.646682],
              [63.174138, 26.646695],
              [63.17591, 26.646556],
              [63.177344, 26.646316],
              [63.177515, 26.646374],
              [63.177988, 26.646221],
              [63.178136, 26.646249],
              [63.179009, 26.64617],
              [63.179523, 26.646381],
              [63.1797812, 26.6463454],
              [63.180169, 26.646292],
              [63.181329, 26.645928],
              [63.182101, 26.646199],
              [63.182439, 26.646216],
              [63.18289, 26.64596],
              [63.183103, 26.645879],
              [63.183398, 26.645845],
              [63.18345, 26.645881],
              [63.183516, 26.646076],
              [63.1837797, 26.6463347],
              [63.184047, 26.646597],
              [63.184506, 26.646498],
              [63.184845, 26.646696],
              [63.184992, 26.646716],
              [63.185217, 26.646447],
              [63.18612, 26.64629],
              [63.186407, 26.64635],
              [63.186671, 26.646506],
              [63.187097, 26.646931],
              [63.187394, 26.647012],
              [63.18779, 26.647054],
              [63.188114, 26.646975],
              [63.189532, 26.646831],
              [63.189774, 26.646766],
              [63.189885, 26.646772],
              [63.189996, 26.646871],
              [63.190098, 26.646896],
              [63.190327, 26.646888],
              [63.190465, 26.646943],
              [63.190826, 26.646924],
              [63.191046, 26.646989],
              [63.191587, 26.647053],
              [63.191676, 26.647034],
              [63.191723, 26.646832],
              [63.192, 26.64647],
              [63.192216, 26.646347],
              [63.193163, 26.646129],
              [63.193439, 26.64615],
              [63.19365, 26.646265],
              [63.19391, 26.646323],
              [63.194262, 26.646248],
              [63.195087, 26.646296],
              [63.195313, 26.646544],
              [63.195746, 26.646604],
              [63.196149, 26.64673],
              [63.196532, 26.647023],
              [63.19692, 26.647126],
              [63.196871, 26.647325],
              [63.196915, 26.647571],
              [63.196698, 26.64775],
              [63.196524, 26.64781],
              [63.195053, 26.647895],
              [63.19489, 26.647958],
              [63.194732, 26.648338],
              [63.194852, 26.648744],
              [63.194827, 26.649002],
              [63.194382, 26.649361],
              [63.193631, 26.64983],
              [63.193172, 26.650779],
              [63.192929, 26.651471],
              [63.192895, 26.651734],
              [63.192575, 26.652243],
              [63.1925, 26.652472],
              [63.192467, 26.65301],
              [63.192537, 26.653214],
              [63.192726, 26.653493],
              [63.192821, 26.654041],
              [63.192642, 26.654325],
              [63.192628, 26.654734],
              [63.192178, 26.657],
              [63.19184, 26.657657],
              [63.191622, 26.658449],
              [63.191695, 26.658948],
              [63.191984, 26.659453],
              [63.192027, 26.659641],
              [63.191867, 26.659988],
              [63.191888, 26.660173],
              [63.191492, 26.660944],
              [63.191593, 26.661316],
              [63.191484, 26.661436],
              [63.191379, 26.661676],
              [63.191467, 26.662179],
              [63.191448, 26.662296],
              [63.191295, 26.662428],
              [63.19119, 26.662452],
              [63.191117, 26.662574],
              [63.191067, 26.662931],
              [63.19085, 26.663536],
              [63.190809, 26.663883],
              [63.19066, 26.664101],
              [63.19067, 26.664266],
              [63.190529, 26.664375],
              [63.190523, 26.664927],
              [63.190562, 26.665018],
              [63.190459, 26.665157],
              [63.190506, 26.665256],
              [63.190489, 26.665348],
              [63.19033, 26.66549],
              [63.190304, 26.665601],
              [63.190473, 26.666127],
              [63.201, 26.674222],
              [63.188476, 26.695306],
              [63.19065, 26.710533],
              [63.190822, 26.710655],
              [63.190999, 26.710661],
              [63.191262, 26.710557],
              [63.191668, 26.710943],
              [63.191836, 26.71088],
              [63.192199, 26.710858],
              [63.192334, 26.710769],
              [63.193243, 26.71104],
              [63.193415, 26.711153],
              [63.193643, 26.711101],
              [63.193885, 26.710925],
              [63.194258, 26.710933],
              [63.194466, 26.710878],
              [63.194685, 26.710725],
              [63.194959, 26.710797],
              [63.195365, 26.710717],
              [63.195834, 26.710691],
              [63.196106, 26.710796],
              [63.196532, 26.710691],
              [63.196702, 26.710769],
              [63.197082, 26.710803],
              [63.197364, 26.710735],
              [63.197611, 26.710824],
              [63.197941, 26.710775],
              [63.198097, 26.710822],
              [63.198436, 26.710634],
              [63.198865, 26.710539],
              [63.199027, 26.710643],
              [63.199131, 26.710666],
              [63.199357, 26.71063],
              [63.199508, 26.710709],
              [63.19964, 26.71072],
              [63.200163, 26.710636],
              [63.200394, 26.710539],
              [63.200675, 26.710529],
              [63.200815, 26.710466],
              [63.200906, 26.710337],
              [63.201131, 26.710281],
              [63.201182, 26.710553],
              [63.201154, 26.711011],
              [63.201187, 26.711154],
              [63.200864, 26.711984],
              [63.200604, 26.712294],
              [63.200501, 26.712685],
              [63.200532, 26.712753],
              [63.20047, 26.713032],
              [63.200308, 26.713162],
              [63.200147, 26.713205],
              [63.200033, 26.713377],
              [63.200137, 26.71362],
              [63.199997, 26.714182],
              [63.200299, 26.714646],
              [63.200656, 26.714769],
              [63.200904, 26.715556],
              [63.200967, 26.715663],
              [63.201218, 26.715848],
              [63.201166, 26.71613],
              [63.201357, 26.716793],
              [63.201705, 26.716936],
              [63.201972, 26.717231],
              [63.202001, 26.717422],
              [63.202328, 26.717564],
              [63.202793, 26.717659],
              [63.202919, 26.717798],
              [63.203202, 26.717776],
              [63.203318, 26.717906],
              [63.204034, 26.718447],
              [63.203814, 26.718884],
              [63.203647, 26.718976],
              [63.203666, 26.719091],
              [63.2036, 26.719153],
              [63.203215, 26.719227],
              [63.203161, 26.719259],
              [63.203143, 26.719368],
              [63.203046, 26.719427],
              [63.203018, 26.719578],
              [63.202903, 26.719722],
              [63.202982, 26.719898],
              [63.202881, 26.720041],
              [63.202883, 26.720132],
              [63.202836, 26.720104],
              [63.202632, 26.72023],
              [63.20253, 26.720187],
              [63.20251, 26.720119],
              [63.202312, 26.720051],
              [63.2021, 26.720113],
              [63.201925, 26.720091],
              [63.20175, 26.720316],
              [63.201641, 26.720342],
              [63.201581, 26.720407],
              [63.20153, 26.720478],
              [63.20153, 26.720609],
              [63.201334, 26.720744],
              [63.201046, 26.721131],
              [63.200915, 26.721431],
              [63.200789, 26.721769],
              [63.200798, 26.722006],
              [63.200664, 26.722122],
              [63.200678, 26.722279],
              [63.200535, 26.722354],
              [63.200527, 26.722847],
              [63.200487, 26.722942],
              [63.20058, 26.723071],
              [63.20057, 26.723333],
              [63.200472, 26.723374],
              [63.200425, 26.723524],
              [63.200349, 26.72357],
              [63.200295, 26.723717],
              [63.200093, 26.723951],
              [63.200118, 26.72416],
              [63.200168, 26.724174],
              [63.200244, 26.724339],
              [63.200252, 26.724506],
              [63.20016, 26.724586],
              [63.200139, 26.724707],
              [63.200029, 26.724733],
              [63.199813, 26.725187],
              [63.19988, 26.72526],
              [63.199843, 26.725331],
              [63.199775, 26.725395],
              [63.199615, 26.725382],
              [63.199665, 26.725523],
              [63.199627, 26.725951],
              [63.199722, 26.726062],
              [63.199739, 26.726286],
              [63.199849, 26.726429],
              [63.199804, 26.726681],
              [63.199753, 26.726685],
              [63.199645, 26.726824],
              [63.199699, 26.726921],
              [63.199651, 26.727018],
              [63.199647, 26.727672],
              [63.199606, 26.727801],
              [63.199435, 26.727937],
              [63.19925, 26.72837],
              [63.199114, 26.728544],
              [63.198977, 26.729074],
              [63.198739, 26.729347],
              [63.19822, 26.730223],
              [63.197837, 26.730617],
              [63.197715, 26.730826],
              [63.197776, 26.73104],
              [63.197934, 26.73116],
              [63.197997, 26.732],
              [63.198173, 26.732013],
              [63.198064, 26.732429],
              [63.198049, 26.732809],
              [63.197898, 26.733224],
              [63.197461, 26.733582],
              [63.197269, 26.733992],
              [63.197122, 26.734141],
              [63.196944, 26.734491],
              [63.196757, 26.734669],
              [63.196654, 26.73488],
              [63.196597, 26.735516],
              [63.196503, 26.735794],
              [63.196166, 26.736506],
              [63.195666, 26.737151],
              [63.195508, 26.737748],
              [63.194968, 26.73855],
              [63.194873, 26.738866],
              [63.194692, 26.73911],
              [63.194773, 26.739441],
              [63.19455, 26.740378],
              [63.194367, 26.740931],
              [63.194653, 26.741416],
              [63.19478, 26.74179],
              [63.194892, 26.741953],
              [63.195257, 26.742265],
              [63.195408, 26.742266],
              [63.195639, 26.742152],
              [63.1959, 26.742123],
              [63.196087, 26.742283],
              [63.19592, 26.742604],
              [63.195999, 26.742782],
              [63.196204, 26.742883],
              [63.196352, 26.742869],
              [63.196596, 26.742954],
              [63.196745, 26.743398],
              [63.196924, 26.743605],
              [63.197474, 26.74361],
              [63.198036, 26.743695],
              [63.19832, 26.743885],
              [63.198433, 26.744055],
              [63.19862, 26.744117],
              [63.198857, 26.744357],
              [63.199073, 26.744389],
              [63.199171, 26.744464],
              [63.199546, 26.745336],
              [63.199472, 26.745681],
              [63.199539, 26.745765],
              [63.199351, 26.746388],
              [63.199417, 26.74653],
              [63.199311, 26.746617],
              [63.199699, 26.747045],
              [63.199841, 26.747065],
              [63.200046, 26.746991],
              [63.200107, 26.747519],
              [63.199982, 26.747574],
              [63.199974, 26.747668],
              [63.200418, 26.748822],
              [63.200389, 26.749294],
              [63.200547, 26.750179],
              [63.201261, 26.750295],
              [63.201256, 26.750517],
              [63.201582, 26.75079],
              [63.20184, 26.750934],
              [63.201699, 26.751772],
              [63.201752, 26.752917],
              [63.201474, 26.752972],
              [63.201435, 26.753341],
              [63.201447, 26.753496],
              [63.201604, 26.75365],
              [63.201694, 26.753862],
              [63.201542, 26.754159],
              [63.201738, 26.754257],
              [63.201852, 26.754383],
              [63.201899, 26.754731],
              [63.201848, 26.755018],
              [63.201878, 26.755129],
              [63.20178, 26.755309],
              [63.201819, 26.755563],
              [63.201558, 26.755695],
              [63.201528, 26.755817],
              [63.201511, 26.756013],
              [63.201577, 26.756162],
              [63.201525, 26.756272],
              [63.201544, 26.756387],
              [63.201442, 26.756536],
              [63.201487, 26.756733],
              [63.201379, 26.756779],
              [63.201201, 26.756952],
              [63.201191, 26.757395],
              [63.201063, 26.757526],
              [63.200848, 26.757598],
              [63.200766, 26.757682],
              [63.200957, 26.75799],
              [63.200888, 26.758149],
              [63.200814, 26.758151],
              [63.200741, 26.758277],
              [63.200617, 26.758309],
              [63.200529, 26.758407],
              [63.200623, 26.758654],
              [63.200474, 26.7587],
              [63.200392, 26.759233],
              [63.200213, 26.759357],
              [63.200051, 26.75933],
              [63.199935, 26.759396],
              [63.199461, 26.759498],
              [63.199142, 26.759389],
              [63.198904, 26.759381],
              [63.198999, 26.759695],
              [63.19903, 26.759997],
              [63.19894, 26.760103],
              [63.199099, 26.760192],
              [63.199108, 26.76026],
              [63.199065, 26.760466],
              [63.198916, 26.760629],
              [63.199121, 26.761252],
              [63.199171, 26.761264],
              [63.198926, 26.761384],
              [63.198892, 26.761518],
              [63.198931, 26.761685],
              [63.198818, 26.761784],
              [63.198959, 26.761992],
              [63.198857, 26.762007],
              [63.19878, 26.762126],
              [63.198817, 26.7622],
              [63.198782, 26.762338],
              [63.198979, 26.762679],
              [63.199432, 26.762888],
              [63.199088, 26.76298],
              [63.199005, 26.763087],
              [63.198881, 26.763106],
              [63.198771, 26.763205],
              [63.198669, 26.763194],
              [63.198382, 26.763305],
              [63.198201, 26.763493],
              [63.197864, 26.763563],
              [63.197825, 26.763746],
              [63.197652, 26.763883],
              [63.197587, 26.764016],
              [63.197184, 26.764214],
              [63.197216, 26.764317],
              [63.197185, 26.764505],
              [63.19728, 26.76476],
              [63.197464, 26.765021],
              [63.197466, 26.765119],
              [63.197741, 26.765211],
              [63.198409, 26.765041],
              [63.198465, 26.765258],
              [63.198643, 26.765437],
              [63.198681, 26.765875],
              [63.198793, 26.765977],
              [63.198806, 26.76605],
              [63.198932, 26.766101],
              [63.19913, 26.766444],
              [63.199211, 26.766469],
              [63.199163, 26.766552],
              [63.199212, 26.766608],
              [63.199327, 26.766607],
              [63.199424, 26.766853],
              [63.19898, 26.766976],
              [63.198713, 26.767256],
              [63.198703, 26.767356],
              [63.198646, 26.767409],
              [63.198063, 26.767493],
              [63.197783, 26.767642],
              [63.197375, 26.767685],
              [63.197237, 26.767768],
              [63.196583, 26.767986],
              [63.196068, 26.768332],
              [63.195067, 26.768577],
              [63.194898, 26.768696],
              [63.194652, 26.768781],
              [63.194513, 26.768951],
              [63.194328, 26.769077],
              [63.193989, 26.769188],
              [63.193914, 26.769486],
              [63.192732, 26.769903],
              [63.192672, 26.769967],
              [63.192423, 26.770056],
              [63.192259, 26.770181],
              [63.19219, 26.770316],
              [63.191791, 26.770303],
              [63.191485, 26.770481],
              [63.19161, 26.770912],
              [63.191993, 26.770969],
              [63.192156, 26.770913],
              [63.192299, 26.770948],
              [63.192417, 26.770854],
              [63.192464, 26.770869],
              [63.192917, 26.770692],
              [63.19331, 26.770675],
              [63.193486, 26.770625],
              [63.193638, 26.770643],
              [63.193669, 26.770707],
              [63.194041, 26.770766],
              [63.194469, 26.770727],
              [63.19451, 26.770849],
              [63.194668, 26.771031],
              [63.195088, 26.77123],
              [63.195261, 26.771178],
              [63.195582, 26.771227],
              [63.19624, 26.771147],
              [63.196278, 26.771225],
              [63.196446, 26.771336],
              [63.196727, 26.7714],
              [63.196861, 26.771351],
              [63.196995, 26.771359],
              [63.197166, 26.7712],
              [63.197384, 26.771125],
              [63.197582, 26.771308],
              [63.197922, 26.771425],
              [63.197967, 26.77165],
              [63.198155, 26.771685],
              [63.198236, 26.7718],
              [63.1982, 26.771923],
              [63.198266, 26.772056],
              [63.19842, 26.772193],
              [63.198885, 26.772268],
              [63.198985, 26.772243],
              [63.199115, 26.772134],
              [63.19925, 26.772142],
              [63.199988, 26.772008],
              [63.199977, 26.771956],
              [63.200058, 26.771844],
              [63.200246, 26.771819],
              [63.200377, 26.771748],
              [63.200581, 26.771781],
              [63.200983, 26.771653],
              [63.201176, 26.771754],
              [63.201993, 26.771654],
              [63.202328, 26.771718],
              [63.202603, 26.771707],
              [63.202613, 26.771757],
              [63.202879, 26.771851],
              [63.203025, 26.771832],
              [63.203543, 26.771924],
              [63.203629, 26.771974],
              [63.203691, 26.771612],
              [63.203818, 26.771464],
              [63.20417, 26.771231],
              [63.204918, 26.770391],
              [63.204944, 26.770454],
              [63.205183, 26.770493],
              [63.205512, 26.770675],
              [63.205583, 26.770616],
              [63.205708, 26.7706],
              [63.206048, 26.770735],
              [63.206121, 26.770829],
              [63.206202, 26.770856],
              [63.206184, 26.770978],
              [63.20634, 26.771078],
              [63.206354, 26.771146],
              [63.206739, 26.771284],
              [63.206761, 26.771358],
              [63.207516, 26.771694],
              [63.207531, 26.771753],
              [63.207861, 26.771966],
              [63.20865, 26.772712],
              [63.208783, 26.772997],
              [63.208876, 26.773084],
              [63.208945, 26.77333],
              [63.208906, 26.773337],
              [63.208932, 26.773444],
              [63.208733, 26.773578],
              [63.208488, 26.773651],
              [63.208385, 26.773622],
              [63.208325, 26.773692],
              [63.208095, 26.773739],
              [63.207829, 26.773761],
              [63.207633, 26.773835],
              [63.20762, 26.773876],
              [63.207026, 26.77397],
              [63.207081, 26.774325],
              [63.207016, 26.774403],
              [63.206909, 26.774426],
              [63.206956, 26.774744],
              [63.206888, 26.77491],
              [63.206782, 26.774936],
              [63.206369, 26.774857],
              [63.205467, 26.774922],
              [63.205208, 26.774964],
              [63.20501, 26.775068],
              [63.204868, 26.775089],
              [63.204769, 26.775194],
              [63.204489, 26.775254],
              [63.203835, 26.775152],
              [63.203542, 26.775183],
              [63.203373, 26.775119],
              [63.202808, 26.77513],
              [63.202385, 26.775076],
              [63.202326, 26.775122],
              [63.202215, 26.775081],
              [63.201874, 26.775077],
              [63.201559, 26.775206],
              [63.201126, 26.775303],
              [63.20105, 26.77537],
              [63.200968, 26.775353],
              [63.200745, 26.775474],
              [63.200605, 26.775464],
              [63.200573, 26.775705],
              [63.200494, 26.775775],
              [63.200256, 26.77581],
              [63.200147, 26.775868],
              [63.199829, 26.775868],
              [63.199722, 26.775992],
              [63.199626, 26.77598],
              [63.199548, 26.776024],
              [63.199253, 26.775999],
              [63.199094, 26.776086],
              [63.1986, 26.776061],
              [63.198527, 26.776131],
              [63.198317, 26.776134],
              [63.198232, 26.7762],
              [63.198239, 26.776463],
              [63.197964, 26.776645],
              [63.197981, 26.776938],
              [63.197632, 26.777483],
              [63.197768, 26.778383],
              [63.197769, 26.778751],
              [63.197486, 26.778968],
              [63.197026, 26.779156],
              [63.197085, 26.77945],
              [63.197004, 26.779824],
              [63.196825, 26.779918],
              [63.196895, 26.780439],
              [63.196715, 26.780819],
              [63.196701, 26.781464],
              [63.196816, 26.781602],
              [63.197014, 26.782217],
              [63.196554, 26.782335],
              [63.19622, 26.782309],
              [63.195811, 26.78238],
              [63.195595, 26.782491],
              [63.195546, 26.782579],
              [63.195099, 26.782701],
              [63.19519, 26.783202],
              [63.195593, 26.783932],
              [63.195557, 26.784051],
              [63.195774, 26.784493],
              [63.195355, 26.784602],
              [63.195326, 26.784568],
              [63.194815, 26.784649],
              [63.194124, 26.784879],
              [63.19362, 26.784966],
              [63.193237, 26.784953],
              [63.19293, 26.784866],
              [63.192417, 26.784983],
              [63.192378, 26.785162],
              [63.192469, 26.785332],
              [63.19247, 26.785437],
              [63.192512, 26.78543],
              [63.192567, 26.785516],
              [63.192505, 26.785964],
              [63.192395, 26.786139],
              [63.192272, 26.786198],
              [63.192159, 26.786186],
              [63.191905, 26.786306],
              [63.192063, 26.787108],
              [63.191729, 26.787519],
              [63.191886, 26.787827],
              [63.192092, 26.78807],
              [63.191958, 26.788195],
              [63.191956, 26.788402],
              [63.191979, 26.788524],
              [63.192075, 26.788647],
              [63.192046, 26.788723],
              [63.192258, 26.789133],
              [63.192255, 26.789259],
              [63.192651, 26.789288],
              [63.193014, 26.789204],
              [63.19345, 26.78928],
              [63.193634, 26.789233],
              [63.193768, 26.789257],
              [63.194124, 26.789215],
              [63.194109, 26.789609],
              [63.194335, 26.789789],
              [63.1944, 26.78992],
              [63.194598, 26.789956],
              [63.194754, 26.790406],
              [63.194505, 26.791085],
              [63.194549, 26.79141],
              [63.19485, 26.791336],
              [63.195133, 26.791497],
              [63.195198, 26.791427],
              [63.195376, 26.791412],
              [63.195299, 26.791644],
              [63.195317, 26.791788],
              [63.195258, 26.791854],
              [63.195035, 26.791907],
              [63.194959, 26.791966],
              [63.194939, 26.792072],
              [63.194706, 26.792248],
              [63.194642, 26.792413],
              [63.194728, 26.792529],
              [63.195168, 26.792674],
              [63.195128, 26.792766],
              [63.194994, 26.792912],
              [63.19477, 26.792986],
              [63.19438, 26.792915],
              [63.194228, 26.792935],
              [63.1941, 26.793029],
              [63.193911, 26.793048],
              [63.193805, 26.793202],
              [63.193686, 26.793248],
              [63.19263, 26.793188],
              [63.192573, 26.793257],
              [63.192605, 26.793421],
              [63.192233, 26.793548],
              [63.191699, 26.79361],
              [63.191498, 26.793674],
              [63.191421, 26.793729],
              [63.191426, 26.793957],
              [63.191514, 26.794096],
              [63.19151, 26.794254],
              [63.191181, 26.794363],
              [63.19118, 26.794507],
              [63.190984, 26.794666],
              [63.190613, 26.79461],
              [63.190287, 26.794506],
              [63.189937, 26.794523],
              [63.189742, 26.794456],
              [63.189422, 26.794427],
              [63.189393, 26.794867],
              [63.189324, 26.794961],
              [63.189338, 26.795043],
              [63.189349, 26.795083],
              [63.189415, 26.795087],
              [63.189492, 26.795264],
              [63.189454, 26.795371],
              [63.189589, 26.795546],
              [63.18969, 26.795895],
              [63.189886, 26.796196],
              [63.189901, 26.796281],
              [63.189828, 26.796373],
              [63.189818, 26.796511],
              [63.189749, 26.796561],
              [63.189034, 26.796535],
              [63.189006, 26.796504],
              [63.188559, 26.796543],
              [63.188484, 26.79671],
              [63.188365, 26.796871],
              [63.188297, 26.796898],
              [63.188225, 26.797311],
              [63.188148, 26.797337],
              [63.1881, 26.797502],
              [63.188007, 26.7976],
              [63.188108, 26.79773],
              [63.188105, 26.797892],
              [63.18793, 26.797991],
              [63.187878, 26.798152],
              [63.187581, 26.798196],
              [63.187562, 26.798485],
              [63.187601, 26.798569],
              [63.187708, 26.79864],
              [63.187545, 26.798925],
              [63.187727, 26.79934],
              [63.188132, 26.799305],
              [63.188518, 26.799358],
              [63.188991, 26.799451],
              [63.189514, 26.7997],
              [63.18977, 26.799704],
              [63.190092, 26.799773],
              [63.190513, 26.799936],
              [63.190655, 26.800043],
              [63.190764, 26.80002],
              [63.191016, 26.80015],
              [63.19147, 26.800282],
              [63.191489, 26.800415],
              [63.191384, 26.800484],
              [63.191377, 26.800539],
              [63.191633, 26.800759],
              [63.192541, 26.800958],
              [63.192551, 26.801034],
              [63.192651, 26.801102],
              [63.192807, 26.801096],
              [63.19285, 26.800968],
              [63.193256, 26.800944],
              [63.193728, 26.801068],
              [63.193781, 26.80094],
              [63.194098, 26.801049],
              [63.194376, 26.801085],
              [63.194654, 26.801221],
              [63.194683, 26.801416],
              [63.194842, 26.801688],
              [63.194819, 26.801754],
              [63.194519, 26.801832],
              [63.194066, 26.802096],
              [63.193829, 26.802823],
              [63.193709, 26.802835],
              [63.193618, 26.802784],
              [63.193443, 26.80281],
              [63.19315, 26.802965],
              [63.193006, 26.802992],
              [63.192639, 26.803481],
              [63.191438, 26.804534],
              [63.191746, 26.804672],
              [63.191781, 26.804733],
              [63.192034, 26.804799],
              [63.192028, 26.804857],
              [63.191935, 26.804865],
              [63.191983, 26.805109],
              [63.192138, 26.805131],
              [63.192282, 26.805215],
              [63.1925, 26.805212],
              [63.192806, 26.805341],
              [63.193254, 26.805353],
              [63.193334, 26.805455],
              [63.19358, 26.805573],
              [63.193691, 26.805547],
              [63.194202, 26.805595],
              [63.194219, 26.805746],
              [63.194162, 26.805928],
              [63.194233, 26.806119],
              [63.194037, 26.806337],
              [63.193998, 26.80637],
              [63.193679, 26.806243],
              [63.193556, 26.806328],
              [63.193252, 26.806256],
              [63.193096, 26.806359],
              [63.192915, 26.806333],
              [63.192888, 26.806453],
              [63.192403, 26.806787],
              [63.192402, 26.806985],
              [63.192282, 26.807229],
              [63.192676, 26.807407],
              [63.192788, 26.80744],
              [63.192921, 26.80742],
              [63.1933, 26.807583],
              [63.193173, 26.807738],
              [63.192967, 26.80778],
              [63.192874, 26.807847],
              [63.192697, 26.808101],
              [63.192733, 26.808213],
              [63.192708, 26.808312],
              [63.192655, 26.808337],
              [63.192657, 26.808532],
              [63.193038, 26.808553],
              [63.192971, 26.808827],
              [63.19274, 26.808925],
              [63.192582, 26.809424],
              [63.192918, 26.809738],
              [63.19287, 26.8098],
              [63.192963, 26.809864],
              [63.193749, 26.809791],
              [63.194097, 26.809869],
              [63.194223, 26.810213],
              [63.194349, 26.810228],
              [63.194653, 26.810537],
              [63.194744, 26.810748],
              [63.194708, 26.810808],
              [63.194739, 26.81087],
              [63.19494, 26.81108],
              [63.194807, 26.811159],
              [63.194692, 26.811156],
              [63.194701, 26.811257],
              [63.194627, 26.811455],
              [63.194635, 26.811538],
              [63.194805, 26.811719],
              [63.194685, 26.811743],
              [63.194166, 26.812075],
              [63.193905, 26.812147],
              [63.193692, 26.812479],
              [63.193436, 26.812735],
              [63.193401, 26.812901],
              [63.193431, 26.813014],
              [63.193499, 26.813031],
              [63.193679, 26.813273],
              [63.193449, 26.814024],
              [63.192779, 26.815531],
              [63.192471, 26.816586],
              [63.192253, 26.81699],
              [63.19206, 26.817877],
              [63.192219, 26.818267],
              [63.192158, 26.818511],
              [63.192241, 26.818731],
              [63.19219, 26.818879],
              [63.192192, 26.819238],
              [63.191891, 26.819932],
              [63.19194, 26.820325],
              [63.191808, 26.820399],
              [63.191807, 26.820507],
              [63.19163, 26.820745],
              [63.191574, 26.821045],
              [63.191292, 26.821658],
              [63.19112, 26.821932],
              [63.190796, 26.822256],
              [63.190925, 26.822404],
              [63.19167, 26.822832],
              [63.192003, 26.822822],
              [63.192269, 26.822878],
              [63.192499, 26.822772],
              [63.192792, 26.82278],
              [63.192973, 26.822937],
              [63.193601, 26.823019],
              [63.1935, 26.823121],
              [63.193506, 26.82338],
              [63.193692, 26.823418],
              [63.19369, 26.823771],
              [63.19385, 26.823903],
              [63.193746, 26.82399],
              [63.19351, 26.823819],
              [63.19272, 26.823844],
              [63.191231, 26.823716],
              [63.190251, 26.823755],
              [63.189974, 26.82368],
              [63.189574, 26.823706],
              [63.1890443, 26.8258333],
              [63.188645, 26.8261463],
              [63.1885004, 26.8264543],
              [63.1883907, 26.8269577],
              [63.1880698, 26.8274663],
              [63.1878771, 26.8275049],
              [63.1878803, 26.8276143],
              [63.1876748, 26.8276965],
              [63.186722, 26.830243],
              [63.187209, 26.831196],
              [63.187089, 26.832018],
              [63.186987, 26.832161],
              [63.186741, 26.832825],
              [63.186684, 26.833241],
              [63.186473, 26.833663],
              [63.186525, 26.834024],
              [63.186658, 26.834159],
              [63.186749, 26.834516],
              [63.186704, 26.834678],
              [63.186731, 26.834823],
              [63.186569, 26.834969],
              [63.186553, 26.835329],
              [63.186455, 26.83552],
              [63.186365, 26.835589],
              [63.186288, 26.835965],
              [63.186102, 26.836259],
              [63.186119, 26.836328],
              [63.186066, 26.836396],
              [63.186117, 26.836503],
              [63.185979, 26.836726],
              [63.186327, 26.836781],
              [63.186683, 26.836666],
              [63.186862, 26.836556],
              [63.18726, 26.836601],
              [63.187582, 26.836777],
              [63.187779, 26.836795],
              [63.187864, 26.836873],
              [63.188039, 26.836934],
              [63.188411, 26.836937],
              [63.188623, 26.837041],
              [63.188677, 26.837003],
              [63.188747, 26.837022],
              [63.188814, 26.837132],
              [63.188908, 26.83715],
              [63.188957, 26.837307],
              [63.189169, 26.837394],
              [63.189537, 26.837453],
              [63.189704, 26.837432],
              [63.18999, 26.837562],
              [63.190192, 26.837499],
              [63.190397, 26.83757],
              [63.190802, 26.837496],
              [63.19097, 26.837581],
              [63.191209, 26.837507],
              [63.191426, 26.837648],
              [63.191637, 26.837687],
              [63.191688, 26.837748],
              [63.191761, 26.837741],
              [63.191947, 26.837825],
              [63.192074, 26.837734],
              [63.192151, 26.837731],
              [63.192375, 26.837483],
              [63.19258, 26.837405],
              [63.192748, 26.837508],
              [63.193017, 26.837539],
              [63.193059, 26.837607],
              [63.193153, 26.837607],
              [63.193162, 26.837706],
              [63.193708, 26.837783],
              [63.193761, 26.837844],
              [63.194011, 26.837773],
              [63.194356, 26.8379],
              [63.194598, 26.837926],
              [63.194861, 26.838134],
              [63.195034, 26.838187],
              [63.195071, 26.838083],
              [63.195256, 26.838162],
              [63.195366, 26.838162],
              [63.19576, 26.837997],
              [63.195881, 26.838038],
              [63.195957, 26.838131],
              [63.19629, 26.838201],
              [63.196307, 26.838293],
              [63.197193, 26.838633],
              [63.197429, 26.838456],
              [63.197676, 26.838419],
              [63.198003, 26.838288],
              [63.198057, 26.83838],
              [63.198369, 26.838557],
              [63.198418, 26.83868],
              [63.19852, 26.838678],
              [63.19888, 26.838803],
              [63.199126, 26.838758],
              [63.19937, 26.838487],
              [63.199614, 26.838577],
              [63.199627, 26.838743],
              [63.199976, 26.838743],
              [63.200033, 26.838601],
              [63.200201, 26.838482],
              [63.200471, 26.838462],
              [63.200697, 26.838359],
              [63.200759, 26.838441],
              [63.200985, 26.838522],
              [63.20106, 26.838653],
              [63.201165, 26.838635],
              [63.201399, 26.838694],
              [63.201495, 26.838822],
              [63.201785, 26.838953],
              [63.202161, 26.838892],
              [63.20243, 26.838534],
              [63.202537, 26.838469],
              [63.202863, 26.838478],
              [63.202954, 26.838522],
              [63.203708, 26.838365],
              [63.204266, 26.838306],
              [63.204341, 26.838484],
              [63.204561, 26.838736],
              [63.204647, 26.838907],
              [63.204867, 26.838989],
              [63.204936, 26.838917],
              [63.205011, 26.838962],
              [63.205214, 26.838849],
              [63.205228, 26.838769],
              [63.20565, 26.838543],
              [63.206029, 26.838481],
              [63.206427, 26.838475],
              [63.206616, 26.838414],
              [63.207152, 26.838573],
              [63.207144, 26.838536],
              [63.207336, 26.838485],
              [63.20762, 26.838463],
              [63.208169, 26.838578],
              [63.208456, 26.838537],
              [63.208574, 26.838608],
              [63.208609, 26.838571],
              [63.208796, 26.838567],
              [63.208935, 26.838634],
              [63.209143, 26.838634],
              [63.209353, 26.838756],
              [63.209505, 26.838927],
              [63.209699, 26.838899],
              [63.209836, 26.838943],
              [63.209958, 26.838904],
              [63.210734, 26.838919],
              [63.210772, 26.838848],
              [63.210867, 26.838886],
              [63.211243, 26.838837],
              [63.211461, 26.838891],
              [63.211782, 26.838823],
              [63.211932, 26.838857],
              [63.212474, 26.838811],
              [63.213071, 26.838924],
              [63.213659, 26.838849],
              [63.213828, 26.838896],
              [63.214402, 26.838581],
              [63.21457, 26.838565],
              [63.214651, 26.838665],
              [63.214969, 26.83874],
              [63.215483, 26.838784],
              [63.216165, 26.838911],
              [63.216586, 26.838901],
              [63.21688, 26.838949],
              [63.217449, 26.839159],
              [63.218014, 26.839179],
              [63.218091, 26.839246],
              [63.21849, 26.839323],
              [63.218507, 26.839372],
              [63.218621, 26.839396],
              [63.218958, 26.839357],
              [63.219612, 26.839496],
              [63.219926, 26.83945],
              [63.22041, 26.839502],
              [63.220614, 26.839612],
              [63.221402, 26.83971],
              [63.221575, 26.839716],
              [63.221873, 26.83964],
              [63.22204, 26.839694],
              [63.222384, 26.83971],
              [63.222793, 26.839832],
              [63.223128, 26.839811],
              [63.223465, 26.839901],
              [63.223814, 26.840148],
              [63.224324, 26.840085],
              [63.224896, 26.84024],
              [63.225141, 26.840219],
              [63.225806, 26.840357],
              [63.226098, 26.840265],
              [63.226598, 26.840258],
              [63.226968, 26.840112],
              [63.227546, 26.840192],
              [63.227832, 26.84013],
              [63.228287, 26.840233],
              [63.228381, 26.84015],
              [63.228612, 26.840209],
              [63.228858, 26.840164],
              [63.229258, 26.840169],
              [63.229569, 26.840067],
              [63.22968, 26.840104],
              [63.229708, 26.840162],
              [63.229827, 26.84018],
              [63.22995, 26.840188],
              [63.23017, 26.840091],
              [63.230316, 26.840092],
              [63.230475, 26.840191],
              [63.230592, 26.840114],
              [63.230971, 26.840078],
              [63.231025, 26.839984],
              [63.231466, 26.840123],
              [63.231931, 26.840155],
              [63.232182, 26.84035],
              [63.232339, 26.840403],
              [63.232566, 26.840398],
              [63.232834, 26.840226],
              [63.23295, 26.840214],
              [63.233253, 26.84035],
              [63.233405, 26.840358],
              [63.233502, 26.840463],
              [63.233705, 26.840496],
              [63.233783, 26.840552],
              [63.234122, 26.840592],
              [63.234111, 26.840499],
              [63.234694, 26.840417],
              [63.234766, 26.840374],
              [63.234969, 26.840407],
              [63.235057, 26.840348],
              [63.235796, 26.840237],
              [63.236144, 26.840377],
              [63.236181, 26.840477],
              [63.236406, 26.840511],
              [63.236688, 26.840491],
              [63.236851, 26.840652],
              [63.237118, 26.840704],
              [63.237133, 26.840758],
              [63.237293, 26.840821],
              [63.23788, 26.840843],
              [63.238058, 26.841093],
              [63.238554, 26.84124],
              [63.238585, 26.841341],
              [63.238763, 26.841407],
              [63.238809, 26.84149],
              [63.238877, 26.841491],
              [63.238948, 26.841575],
              [63.239113, 26.841638],
              [63.239453, 26.841603],
              [63.239773, 26.841795],
              [63.240239, 26.8417663],
              [63.24091, 26.841725],
              [63.240977, 26.841621],
              [63.241281, 26.84161],
              [63.241304, 26.841515],
              [63.241612, 26.841333],
              [63.241712, 26.841409],
              [63.241733, 26.841504],
              [63.241818, 26.841513],
              [63.242141, 26.841359],
              [63.24265, 26.84135],
              [63.243184, 26.841412],
              [63.243255, 26.841598],
              [63.243228, 26.841646],
              [63.243329, 26.84164],
              [63.243373, 26.8417],
              [63.243878, 26.841713],
              [63.243791, 26.841831],
              [63.243625, 26.842947],
              [63.243311, 26.843128],
              [63.243293, 26.843217],
              [63.243318, 26.843405],
              [63.243281, 26.843447],
              [63.243388, 26.843515],
              [63.243376, 26.843615],
              [63.243463, 26.843691],
              [63.243481, 26.84386],
              [63.243524, 26.843873],
              [63.243483, 26.844041],
              [63.243414, 26.844068],
              [63.24341, 26.844425],
              [63.243318, 26.844615],
              [63.2435, 26.844654],
              [63.243531, 26.844698],
              [63.243522, 26.844845],
              [63.243595, 26.844998],
              [63.243624, 26.845331],
              [63.243718, 26.845453],
              [63.243858, 26.845886],
              [63.243822, 26.846123],
              [63.244047, 26.846134],
              [63.244107, 26.84624],
              [63.244074, 26.84642],
              [63.24417, 26.846907],
              [63.244112, 26.846972],
              [63.244116, 26.847073],
              [63.24488, 26.847243],
              [63.244933, 26.847289],
              [63.244887, 26.847421],
              [63.244993, 26.847567],
              [63.244994, 26.847977],
              [63.245136, 26.848202],
              [63.245136, 26.848506],
              [63.245245, 26.848713],
              [63.245218, 26.848816],
              [63.24528, 26.848829],
              [63.245454, 26.849238],
              [63.24537, 26.849611],
              [63.24597, 26.849677],
              [63.246019, 26.84976],
              [63.246266, 26.849798],
              [63.246334, 26.849903],
              [63.246437, 26.850382],
              [63.246396, 26.850638],
              [63.24642, 26.850865],
              [63.246323, 26.850858],
              [63.246196, 26.850947],
              [63.246039, 26.850979],
              [63.245622, 26.851012],
              [63.245485, 26.85124],
              [63.24514, 26.851465],
              [63.245709, 26.851693],
              [63.245841, 26.8518],
              [63.245985, 26.851807],
              [63.246081, 26.851897],
              [63.246142, 26.852177],
              [63.246083, 26.852712],
              [63.246176, 26.852813],
              [63.246129, 26.852927],
              [63.246198, 26.853217],
              [63.246142, 26.853319],
              [63.246208, 26.853365],
              [63.24625, 26.853545],
              [63.24589, 26.853804],
              [63.245831, 26.853975],
              [63.245713, 26.854115],
              [63.245235, 26.854329],
              [63.245077, 26.854473],
              [63.245146, 26.854518],
              [63.245253, 26.854801],
              [63.245107, 26.855047],
              [63.245, 26.855397],
              [63.245033, 26.855607],
              [63.244998, 26.855675],
              [63.245081, 26.855775],
              [63.245474, 26.855888],
              [63.24542, 26.856255],
              [63.245442, 26.856745],
              [63.245546, 26.85693],
              [63.245945, 26.857386],
              [63.245958, 26.857506],
              [63.245854, 26.857843],
              [63.245816, 26.858634],
              [63.245988, 26.859287],
              [63.246168, 26.860573],
              [63.245992, 26.860894],
              [63.24635, 26.861752],
              [63.246275, 26.862193],
              [63.246659, 26.862193],
              [63.2472781, 26.8623434],
              [63.247293, 26.862347],
              [63.247282, 26.862556],
              [63.247137, 26.862822],
              [63.24708, 26.863144],
              [63.246903, 26.863418],
              [63.246706, 26.863927],
              [63.247372, 26.863941],
              [63.247807, 26.864011],
              [63.247852, 26.864061],
              [63.247841, 26.864325],
              [63.248032, 26.864453],
              [63.248153, 26.864638],
              [63.248626, 26.864809],
              [63.248478, 26.865071],
              [63.248525, 26.865405],
              [63.248405, 26.865683],
              [63.248413, 26.86578],
              [63.248531, 26.865893],
              [63.24853, 26.866334],
              [63.248662, 26.866709],
              [63.248836, 26.866939],
              [63.249327, 26.86706],
              [63.24937, 26.867131],
              [63.249299, 26.867234],
              [63.249492, 26.867712],
              [63.248919, 26.867961],
              [63.248924, 26.868054],
              [63.248505, 26.868107],
              [63.247927, 26.868271],
              [63.247938, 26.868526],
              [63.247874, 26.868936],
              [63.24791, 26.869003],
              [63.247732, 26.868994],
              [63.247749, 26.869088],
              [63.247184, 26.869384],
              [63.247129, 26.869534],
              [63.246954, 26.869668],
              [63.246949, 26.869803],
              [63.247125, 26.870262],
              [63.246662, 26.870398],
              [63.246301, 26.870594],
              [63.245996, 26.870571],
              [63.245838, 26.87125],
              [63.245278, 26.871296],
              [63.244819, 26.871279],
              [63.244314, 26.871393],
              [63.244225, 26.871502],
              [63.244101, 26.871528],
              [63.243918, 26.871671],
              [63.243896, 26.871828],
              [63.243672, 26.872012],
              [63.243697, 26.872213],
              [63.243286, 26.872421],
              [63.243172, 26.872523],
              [63.24316, 26.873045],
              [63.243244, 26.873105],
              [63.243239, 26.873179],
              [63.243086, 26.873294],
              [63.243148, 26.873408],
              [63.24306, 26.873719],
              [63.243068, 26.873998],
              [63.243154, 26.874357],
              [63.243068, 26.874387],
              [63.242798, 26.874343],
              [63.242351, 26.874354],
              [63.24214, 26.874494],
              [63.24203, 26.874518],
              [63.242065, 26.874566],
              [63.242041, 26.874685],
              [63.242313, 26.87468],
              [63.242426, 26.874803],
              [63.242333, 26.874978],
              [63.2424, 26.875462],
              [63.242766, 26.875522],
              [63.242812, 26.875968],
              [63.242733, 26.876244],
              [63.242951, 26.876874],
              [63.2429, 26.876982],
              [63.242948, 26.877464],
              [63.24282, 26.87747],
              [63.242785, 26.877513],
              [63.242492, 26.877589],
              [63.241229, 26.87742],
              [63.241043, 26.877449],
              [63.24077, 26.877389],
              [63.240644, 26.877408],
              [63.240092, 26.877344],
              [63.239861, 26.877384],
              [63.239548, 26.877539],
              [63.239557, 26.877625],
              [63.239309, 26.877709],
              [63.239304, 26.877816],
              [63.239227, 26.877905],
              [63.239155, 26.87819],
              [63.239159, 26.878483],
              [63.238799, 26.878466],
              [63.238791, 26.878512],
              [63.238819, 26.878803],
              [63.238942, 26.879073],
              [63.239232, 26.879111],
              [63.239215, 26.879709],
              [63.239131, 26.879765],
              [63.238711, 26.879741],
              [63.238526, 26.879645],
              [63.238269, 26.879704],
              [63.238157, 26.879659],
              [63.237862, 26.87967],
              [63.2375, 26.879745],
              [63.237412, 26.879812],
              [63.237472, 26.880087],
              [63.237051, 26.880393],
              [63.237013, 26.880547],
              [63.237146, 26.880777],
              [63.237207, 26.881028],
              [63.237115, 26.881049],
              [63.23711, 26.881185],
              [63.236996, 26.881215],
              [63.237155, 26.881567],
              [63.237167, 26.881697],
              [63.237314, 26.881934],
              [63.23735, 26.882201],
              [63.237282, 26.882433],
              [63.237374, 26.882444],
              [63.237464, 26.882384],
              [63.237865, 26.882448],
              [63.238036, 26.882409],
              [63.238267, 26.882535],
              [63.238429, 26.882523],
              [63.238586, 26.882634],
              [63.238805, 26.882589],
              [63.239214, 26.882701],
              [63.239153, 26.882911],
              [63.239219, 26.882941],
              [63.239053, 26.883004],
              [63.239015, 26.883205],
              [63.239073, 26.883418],
              [63.239226, 26.883436],
              [63.23917, 26.883638],
              [63.239182, 26.884023],
              [63.238947, 26.884055],
              [63.238904, 26.884229],
              [63.238823, 26.884242],
              [63.238835, 26.884513],
              [63.238889, 26.884504],
              [63.238908, 26.884563],
              [63.238816, 26.884872],
              [63.238675, 26.88508],
              [63.238793, 26.885097],
              [63.238942, 26.885274],
              [63.238931, 26.885639],
              [63.23899, 26.885697],
              [63.239053, 26.885932],
              [63.238874, 26.88602],
              [63.238853, 26.88611],
              [63.238774, 26.886118],
              [63.238687, 26.886289],
              [63.23878, 26.88635],
              [63.23909, 26.886394],
              [63.239122, 26.886456],
              [63.239078, 26.886681],
              [63.239323, 26.886699],
              [63.239343, 26.886792],
              [63.239619, 26.886618],
              [63.239766, 26.886642],
              [63.239915, 26.886785],
              [63.240177, 26.886852],
              [63.2405, 26.887044],
              [63.240774, 26.886981],
              [63.240949, 26.88706],
              [63.241186, 26.886981],
              [63.241467, 26.88706],
              [63.241298, 26.887268],
              [63.24108, 26.887378],
              [63.241069, 26.887471],
              [63.24085, 26.887604],
              [63.240879, 26.887654],
              [63.240841, 26.887723],
              [63.241004, 26.887848],
              [63.241001, 26.887947],
              [63.241083, 26.88797],
              [63.241078, 26.888163],
              [63.241308, 26.88838],
              [63.240909, 26.888487],
              [63.240943, 26.888687],
              [63.240868, 26.888801],
              [63.240916, 26.888891],
              [63.240866, 26.888934],
              [63.240874, 26.889028],
              [63.240629, 26.88907],
              [63.240408, 26.889009],
              [63.240303, 26.889227],
              [63.240685, 26.88959],
              [63.240826, 26.889611],
              [63.240812, 26.889763],
              [63.240871, 26.88985],
              [63.240545, 26.88989],
              [63.240493, 26.889924],
              [63.240507, 26.890016],
              [63.240659, 26.890119],
              [63.24067, 26.890216],
              [63.240956, 26.890463],
              [63.241195, 26.890799],
              [63.241271, 26.890991],
              [63.241553, 26.891224],
              [63.241605, 26.891248],
              [63.241659, 26.891213],
              [63.241858, 26.891301],
              [63.241843, 26.891364],
              [63.242029, 26.891433],
              [63.242064, 26.891539],
              [63.242073, 26.891654],
              [63.242007, 26.89172],
              [63.241582, 26.891717],
              [63.241374, 26.891771],
              [63.241411, 26.891861],
              [63.241381, 26.892107],
              [63.241233, 26.892514],
              [63.241115, 26.892628],
              [63.240941, 26.892642],
              [63.240713, 26.89298],
              [63.240537, 26.893025],
              [63.240525, 26.893082],
              [63.240939, 26.893136],
              [63.241364, 26.893284],
              [63.241258, 26.893398],
              [63.240976, 26.893384],
              [63.240927, 26.893442],
              [63.240684, 26.893423],
              [63.240713, 26.893629],
              [63.240843, 26.893827],
              [63.241015, 26.893863],
              [63.241034, 26.893938],
              [63.240559, 26.894281],
              [63.240467, 26.894302],
              [63.24024, 26.894642],
              [63.240043, 26.894673],
              [63.23997, 26.894766],
              [63.240377, 26.895047],
              [63.240285, 26.895094],
              [63.240327, 26.895219],
              [63.240523, 26.895294],
              [63.240633, 26.895388],
              [63.240611, 26.89576],
              [63.240511, 26.895889],
              [63.240401, 26.895923],
              [63.240465, 26.896063],
              [63.240119, 26.896483],
              [63.240007, 26.896512],
              [63.239835, 26.896721],
              [63.23984, 26.896829],
              [63.239668, 26.896879],
              [63.2396, 26.897184],
              [63.239332, 26.897264],
              [63.239261, 26.897338],
              [63.239168, 26.897983],
              [63.23979, 26.898326],
              [63.239999, 26.898336],
              [63.240198, 26.898469],
              [63.240575, 26.898578],
              [63.240717, 26.898736],
              [63.240932, 26.898813],
              [63.240927, 26.899019],
              [63.241099, 26.899229],
              [63.241319, 26.899272],
              [63.241457, 26.899409],
              [63.241561, 26.899407],
              [63.242184, 26.899649],
              [63.242385, 26.899996],
              [63.242469, 26.900717],
              [63.242374, 26.900883],
              [63.242875, 26.900909],
              [63.243221, 26.901061],
              [63.243288, 26.901013],
              [63.244052, 26.901077],
              [63.24423, 26.901013],
              [63.244383, 26.901047],
              [63.244692, 26.90103],
              [63.244864, 26.901152],
              [63.244907, 26.901238],
              [63.245557, 26.901352],
              [63.245803, 26.901485],
              [63.246462, 26.901499],
              [63.24678, 26.901577],
              [63.247105, 26.901706],
              [63.247251, 26.901884],
              [63.247382, 26.901903],
              [63.247536, 26.902069],
              [63.247672, 26.902098],
              [63.247833, 26.902241],
              [63.248095, 26.902337],
              [63.248222, 26.90251],
              [63.248355, 26.902524],
              [63.248363, 26.90259],
              [63.248499, 26.90253],
              [63.248707, 26.902534],
              [63.249191, 26.902695],
              [63.249385, 26.902688],
              [63.24967, 26.902894],
              [63.250452, 26.902942],
              [63.250551, 26.902914],
              [63.250747, 26.902759],
              [63.250904, 26.902797],
              [63.251095, 26.902746],
              [63.251281, 26.902473],
              [63.251566, 26.902505],
              [63.251641, 26.902552],
              [63.251639, 26.902773],
              [63.251914, 26.903087],
              [63.252271, 26.903234],
              [63.252366, 26.903376],
              [63.252657, 26.903604],
              [63.252856, 26.903562],
              [63.252985, 26.903483],
              [63.253311, 26.903519],
              [63.2527998, 26.9470489],
              [63.2510944, 27.0921506],
              [63.2556733, 27.0915404],
              [63.2588761, 27.0922359],
              [63.2629076, 27.0941578],
              [63.2633756, 27.0951994],
              [63.2635762, 27.1006249],
              [63.2657881, 27.1055586],
              [63.2648366, 27.1074977],
              [63.2654181, 27.1087246],
              [63.2669575, 27.1096041],
              [63.2700298, 27.1101291],
              [63.2728256, 27.110613],
              [63.2758855, 27.112961],
              [63.2763325, 27.1147515],
              [63.2758056, 27.1159709],
              [63.2756313, 27.1167852],
              [63.2761988, 27.1178147],
              [63.2794691, 27.1199709],
              [63.2841524, 27.1211058],
              [63.2847116, 27.1192542],
              [63.2855679, 27.1183396],
              [63.2952262, 27.1151784],
              [63.2972273, 27.1156049],
              [63.2988389, 27.1176472],
              [63.2988644, 27.1200922],
              [63.2996675, 27.1218036],
              [63.3015727, 27.1259876],
              [63.3048623, 27.1288069],
              [63.3071253, 27.1296461],
              [63.3092171, 27.1293532],
              [63.3138294, 27.1274123],
              [63.3200179, 27.1264612],
              [63.3228578, 27.1240207],
              [63.3272365, 27.120529],
              [63.3304752, 27.1191454],
              [63.3332704, 27.1184003],
              [63.332056, 27.120917],
              [63.283296, 27.208663],
              [63.283116, 27.208824],
              [63.282898, 27.208921],
              [63.28278, 27.209079],
              [63.282772, 27.209182],
              [63.282886, 27.209324],
              [63.28281, 27.209499],
              [63.282847, 27.209678],
              [63.282701, 27.209795],
              [63.28233, 27.209881],
              [63.282265, 27.21019],
              [63.282451, 27.210743],
              [63.28241, 27.210833],
              [63.282254, 27.210851],
              [63.282104, 27.211013],
              [63.282271, 27.211719],
              [63.282352, 27.211772],
              [63.282495, 27.212091],
              [63.282588, 27.212183],
              [63.282539, 27.212436],
              [63.282489, 27.212477],
              [63.282475, 27.212631],
              [63.282525, 27.21277],
              [63.282279, 27.213058],
              [63.281982, 27.213289],
              [63.281796, 27.213607],
              [63.281777, 27.213732],
              [63.281458, 27.213738],
              [63.281338, 27.213648],
              [63.28014, 27.213823],
              [63.280119, 27.214266],
              [63.279993, 27.214433],
              [63.279522, 27.214714],
              [63.27959, 27.215139],
              [63.279488, 27.215207],
              [63.279388, 27.215362],
              [63.279323, 27.215548],
              [63.279258, 27.215605],
              [63.279221, 27.215817],
              [63.278885, 27.215934],
              [63.278787, 27.215811],
              [63.278511, 27.215809],
              [63.278275, 27.21588],
              [63.278082, 27.216202],
              [63.277932, 27.216272],
              [63.277881, 27.216352],
              [63.277681, 27.216404],
              [63.277552, 27.21653],
              [63.277392, 27.216514],
              [63.277301, 27.216554],
              [63.277369, 27.216768],
              [63.277354, 27.216947],
              [63.277206, 27.217106],
              [63.276967, 27.21725],
              [63.276908, 27.217344],
              [63.27691, 27.217489],
              [63.276822, 27.217752],
              [63.277034, 27.217915],
              [63.276901, 27.218159],
              [63.276624, 27.218201],
              [63.276459, 27.218331],
              [63.276346, 27.218312],
              [63.276224, 27.218393],
              [63.276062, 27.218431],
              [63.276037, 27.21848],
              [63.275781, 27.218455],
              [63.2756, 27.21849],
              [63.275131, 27.218705],
              [63.274923, 27.218888],
              [63.274775, 27.218892],
              [63.274131, 27.219242],
              [63.273906, 27.219252],
              [63.273857, 27.219296],
              [63.273639, 27.219335],
              [63.273552, 27.219406],
              [63.273217, 27.219393],
              [63.272885, 27.219452],
              [63.272631, 27.219628],
              [63.272485, 27.219795],
              [63.271957, 27.219647],
              [63.271835, 27.219655],
              [63.271641, 27.219743],
              [63.271477, 27.22],
              [63.271142, 27.220059],
              [63.270919, 27.220156],
              [63.270836, 27.220135],
              [63.270486, 27.219566],
              [63.270292, 27.219582],
              [63.269853, 27.219719],
              [63.269604, 27.219752],
              [63.269194, 27.219918],
              [63.269022, 27.219885],
              [63.268671, 27.220008],
              [63.268229, 27.220057],
              [63.268138, 27.220112],
              [63.268074, 27.220273],
              [63.267754, 27.220399],
              [63.267672, 27.220459],
              [63.267649, 27.220561],
              [63.267525, 27.220617],
              [63.267418, 27.220651],
              [63.267161, 27.220578],
              [63.266822, 27.22067],
              [63.26663, 27.220859],
              [63.266138, 27.221142],
              [63.266125, 27.221198],
              [63.266004, 27.221282],
              [63.265974, 27.221414],
              [63.26585, 27.221533],
              [63.265865, 27.221593],
              [63.265984, 27.22162],
              [63.266225, 27.222084],
              [63.266439, 27.222357],
              [63.266849, 27.22275],
              [63.267168, 27.222889],
              [63.267162, 27.223048],
              [63.266917, 27.223188],
              [63.266751, 27.223406],
              [63.266775, 27.223471],
              [63.266599, 27.223607],
              [63.266005, 27.223811],
              [63.265763, 27.223827],
              [63.265507, 27.223969],
              [63.265214, 27.22402],
              [63.264994, 27.223824],
              [63.264587, 27.223733],
              [63.263876, 27.223945],
              [63.263835, 27.2239],
              [63.26367, 27.223869],
              [63.263505, 27.223955],
              [63.263037, 27.224022],
              [63.262781, 27.223921],
              [63.26264, 27.22391],
              [63.26252, 27.224013],
              [63.262154, 27.223845],
              [63.261901, 27.223876],
              [63.261837, 27.223951],
              [63.261649, 27.223928],
              [63.261503, 27.22385],
              [63.261306, 27.223869],
              [63.260892, 27.223988],
              [63.260621, 27.224294],
              [63.260437, 27.224229],
              [63.260378, 27.224307],
              [63.260159, 27.224369],
              [63.260046, 27.224259],
              [63.259799, 27.224345],
              [63.259383, 27.224414],
              [63.25926, 27.224533],
              [63.25911, 27.224499],
              [63.258976, 27.22438],
              [63.258215, 27.224772],
              [63.258353, 27.225118],
              [63.258177, 27.225127],
              [63.25802, 27.225189],
              [63.257903, 27.225304],
              [63.257479, 27.225308],
              [63.257026, 27.225435],
              [63.256975, 27.225426],
              [63.256954, 27.225342],
              [63.256687, 27.225331],
              [63.256062, 27.225561],
              [63.255783, 27.225534],
              [63.255425, 27.225626],
              [63.254866, 27.225912],
              [63.254535, 27.226021],
              [63.254301, 27.226055],
              [63.25391, 27.226027],
              [63.253745, 27.226066],
              [63.253546, 27.226032],
              [63.253393, 27.226062],
              [63.253312, 27.226157],
              [63.25307, 27.226129],
              [63.25282, 27.226219],
              [63.252847, 27.226249],
              [63.252592, 27.226425],
              [63.2525, 27.226402],
              [63.252133, 27.226575],
              [63.25194, 27.226562],
              [63.251883, 27.226618],
              [63.251861, 27.226874],
              [63.251754, 27.226939],
              [63.251767, 27.226994],
              [63.250908, 27.2272],
              [63.25075, 27.227281],
              [63.250368, 27.227334],
              [63.250017, 27.227302],
              [63.249938, 27.227378],
              [63.249258, 27.227354],
              [63.249366, 27.22719],
              [63.249276, 27.227189],
              [63.249401, 27.227],
              [63.24948, 27.226717],
              [63.248977, 27.226853],
              [63.248908, 27.226816],
              [63.248757, 27.226855],
              [63.248575, 27.226961],
              [63.248186, 27.226971],
              [63.247951, 27.227093],
              [63.24733, 27.227205],
              [63.247048, 27.227194],
              [63.247003, 27.227105],
              [63.246405, 27.227024],
              [63.246333, 27.227076],
              [63.246152, 27.227039],
              [63.245749, 27.22713],
              [63.24542, 27.22711],
              [63.245079, 27.227],
              [63.244999, 27.226858],
              [63.244886, 27.226823],
              [63.244462, 27.226825],
              [63.243679, 27.226947],
              [63.243674, 27.227046],
              [63.243429, 27.227245],
              [63.242805, 27.227273],
              [63.242611, 27.227453],
              [63.242281, 27.227401],
              [63.241953, 27.227566],
              [63.241329, 27.227424],
              [63.24061, 27.227577],
              [63.239841, 27.227485],
              [63.239423, 27.227574],
              [63.239246, 27.227549],
              [63.239034, 27.227612],
              [63.238945, 27.227585],
              [63.238638, 27.227652],
              [63.238541, 27.227715],
              [63.238468, 27.227704],
              [63.238345, 27.227587],
              [63.238422, 27.22719],
              [63.238331, 27.227063],
              [63.238391, 27.226915],
              [63.238357, 27.226837],
              [63.237955, 27.226584],
              [63.237968, 27.226471],
              [63.238171, 27.226192],
              [63.238137, 27.226012],
              [63.238186, 27.225848],
              [63.238121, 27.225643],
              [63.237746, 27.225531],
              [63.237176, 27.225595],
              [63.236863, 27.225578],
              [63.236832, 27.22553],
              [63.236357, 27.22551],
              [63.23596, 27.225547],
              [63.235506, 27.225715],
              [63.23511, 27.225758],
              [63.234924, 27.225731],
              [63.234724, 27.225808],
              [63.234591, 27.225648],
              [63.234612, 27.225524],
              [63.234441, 27.225315],
              [63.234167, 27.225324],
              [63.234108, 27.225371],
              [63.233748, 27.225394],
              [63.233659, 27.22544],
              [63.23361, 27.225604],
              [63.233475, 27.225615],
              [63.23333, 27.225558],
              [63.233185, 27.225587],
              [63.233176, 27.225733],
              [63.232884, 27.225816],
              [63.232605, 27.22588],
              [63.23235, 27.225845],
              [63.232311, 27.225897],
              [63.232063, 27.22592],
              [63.232156, 27.225738],
              [63.232279, 27.225648],
              [63.232141, 27.225362],
              [63.232167, 27.225316],
              [63.23178, 27.224973],
              [63.231673, 27.224902],
              [63.231311, 27.224797],
              [63.231128, 27.224602],
              [63.23113, 27.22476],
              [63.230984, 27.224921],
              [63.230777, 27.225018],
              [63.230352, 27.225082],
              [63.229813, 27.225387],
              [63.22871, 27.225528],
              [63.227843, 27.225698],
              [63.227186, 27.225754],
              [63.225433, 27.225303],
              [63.224699, 27.225621],
              [63.224551, 27.225839],
              [63.222507, 27.227398],
              [63.222371, 27.227768],
              [63.221502, 27.228337],
              [63.221109, 27.22836],
              [63.220916, 27.228455],
              [63.22068, 27.228902],
              [63.219901, 27.230001],
              [63.219527, 27.230611],
              [63.218796, 27.231363],
              [63.218526, 27.231886],
              [63.218192, 27.232115],
              [63.217947, 27.232211],
              [63.21776, 27.232437],
              [63.217491, 27.232657],
              [63.215603, 27.233421],
              [63.215103, 27.233961],
              [63.214537, 27.234202],
              [63.214087, 27.234612],
              [63.21362, 27.234656],
              [63.213067, 27.235011],
              [63.212252, 27.23589],
              [63.211309, 27.236447],
              [63.210884, 27.237111],
              [63.210662, 27.237568],
              [63.210384, 27.237935],
              [63.210129, 27.238546],
              [63.210048, 27.238613],
              [63.209791, 27.239048],
              [63.209723, 27.239254],
              [63.209662, 27.239941],
              [63.20931, 27.240477],
              [63.209142, 27.240958],
              [63.209196, 27.24149],
              [63.209116, 27.241682],
              [63.208763, 27.24206],
              [63.20859, 27.242432],
              [63.208198, 27.243632],
              [63.207902, 27.244213],
              [63.207047, 27.245006],
              [63.206268, 27.245354],
              [63.20549, 27.246214],
              [63.205095, 27.246758],
              [63.20438, 27.247044],
              [63.203975, 27.247564],
              [63.203938, 27.247881],
              [63.203781, 27.248136],
              [63.203407, 27.248461],
              [63.203293, 27.248465],
              [63.202958, 27.248874],
              [63.202985, 27.24903],
              [63.203149, 27.249137],
              [63.203192, 27.249232],
              [63.203562, 27.2494],
              [63.203562, 27.249491],
              [63.203772, 27.24957],
              [63.203945, 27.249564],
              [63.203921, 27.249676],
              [63.204199, 27.250016],
              [63.204313, 27.250356],
              [63.204244, 27.250543],
              [63.204381, 27.250822],
              [63.20417, 27.250968],
              [63.204172, 27.251018],
              [63.203988, 27.25112],
              [63.203988, 27.251164],
              [63.20375, 27.251271],
              [63.203743, 27.251335],
              [63.203588, 27.251401],
              [63.203506, 27.251537],
              [63.203231, 27.251704],
              [63.203251, 27.252069],
              [63.203165, 27.252118],
              [63.203164, 27.252203],
              [63.203008, 27.252309],
              [63.202845, 27.252613],
              [63.202653, 27.252726],
              [63.202596, 27.252829],
              [63.202459, 27.252802],
              [63.202374, 27.252882],
              [63.202226, 27.252914],
              [63.202136, 27.253093],
              [63.202025, 27.253187],
              [63.201991, 27.253351],
              [63.201898, 27.253398],
              [63.20177, 27.253559],
              [63.201709, 27.253791],
              [63.201534, 27.25411],
              [63.20135, 27.25424],
              [63.201291, 27.254334],
              [63.201267, 27.25455],
              [63.201148, 27.254687],
              [63.201137, 27.254809],
              [63.200937, 27.255053],
              [63.200689, 27.255168],
              [63.200675, 27.255442],
              [63.200445, 27.255718],
              [63.200415, 27.256017],
              [63.200083, 27.256259],
              [63.199967, 27.256663],
              [63.199778, 27.256801],
              [63.199441, 27.257173],
              [63.199398, 27.257283],
              [63.199401, 27.257585],
              [63.199252, 27.257794],
              [63.199201, 27.258189],
              [63.199151, 27.258227],
              [63.199221, 27.258286],
              [63.199265, 27.258476],
              [63.199067, 27.2589],
              [63.198822, 27.259172],
              [63.198716, 27.259436],
              [63.198149, 27.259345],
              [63.197798, 27.259357],
              [63.197711, 27.259141],
              [63.19751, 27.258962],
              [63.197445, 27.258912],
              [63.197337, 27.258914],
              [63.197023, 27.258594],
              [63.196592, 27.258373],
              [63.196024, 27.258715],
              [63.195866, 27.258768],
              [63.195624, 27.258834],
              [63.195525, 27.258809],
              [63.195306, 27.25889],
              [63.195061, 27.258863],
              [63.194959, 27.259081],
              [63.194175, 27.25932],
              [63.194086, 27.259398],
              [63.194079, 27.259563],
              [63.194037, 27.259606],
              [63.193781, 27.259673],
              [63.193608, 27.259665],
              [63.193472, 27.259568],
              [63.193023, 27.259488],
              [63.192835, 27.259496],
              [63.192597, 27.25959],
              [63.192539, 27.259357],
              [63.192419, 27.259355],
              [63.192191, 27.259139],
              [63.19189, 27.259268],
              [63.191784, 27.259228],
              [63.19156, 27.259244],
              [63.191493, 27.259216],
              [63.191473, 27.259105],
              [63.191183, 27.258987],
              [63.190615, 27.259044],
              [63.190463, 27.259214],
              [63.190308, 27.259279],
              [63.19018, 27.259276],
              [63.190161, 27.259412],
              [63.189919, 27.259457],
              [63.189894, 27.259598],
              [63.189715, 27.259751],
              [63.189635, 27.260014],
              [63.189541, 27.260026],
              [63.189471, 27.25991],
              [63.189433, 27.260015],
              [63.189337, 27.260034],
              [63.189144, 27.259945],
              [63.189079, 27.26012],
              [63.188858, 27.260284],
              [63.188653, 27.260285],
              [63.188379, 27.26052],
              [63.188328, 27.26046],
              [63.18813, 27.260401],
              [63.187933, 27.260239],
              [63.187836, 27.260255],
              [63.187776, 27.260162],
              [63.187634, 27.260145],
              [63.187632, 27.260076],
              [63.187341, 27.260034],
              [63.187222, 27.259943],
              [63.187237, 27.259854],
              [63.187055, 27.259719],
              [63.187007, 27.259496],
              [63.186768, 27.259359],
              [63.1867, 27.259372],
              [63.186582, 27.259151],
              [63.18625, 27.259273],
              [63.185772, 27.258862],
              [63.18554, 27.258815],
              [63.185439, 27.258841],
              [63.185325, 27.258761],
              [63.18482, 27.258934],
              [63.184688, 27.258946],
              [63.184543, 27.258886],
              [63.183907, 27.259074],
              [63.183585, 27.258756],
              [63.183279, 27.258632],
              [63.18305, 27.258702],
              [63.182924, 27.258663],
              [63.182712, 27.258346],
              [63.182622, 27.2583],
              [63.182505, 27.258142],
              [63.182262, 27.258094],
              [63.182038, 27.257944],
              [63.181841, 27.257916],
              [63.181755, 27.257796],
              [63.18166, 27.257834],
              [63.181492, 27.257759],
              [63.181395, 27.257819],
              [63.181342, 27.257937],
              [63.180969, 27.258042],
              [63.180871, 27.258144],
              [63.18077, 27.258081],
              [63.180587, 27.258126],
              [63.180375, 27.258114],
              [63.180189, 27.257995],
              [63.180147, 27.257917],
              [63.179762, 27.257989],
              [63.179653, 27.257941],
              [63.179524, 27.257991],
              [63.179395, 27.257893],
              [63.179228, 27.257897],
              [63.179112, 27.257713],
              [63.178998, 27.257631],
              [63.17883, 27.257629],
              [63.178493, 27.25746],
              [63.178155, 27.257405],
              [63.17787, 27.257489],
              [63.177675, 27.257455],
              [63.177119, 27.257544],
              [63.176982, 27.257685],
              [63.17694, 27.257862],
              [63.176834, 27.257902],
              [63.176766, 27.258036],
              [63.176402, 27.258116],
              [63.176178, 27.25831],
              [63.175906, 27.258436],
              [63.17582, 27.258341],
              [63.175732, 27.25832],
              [63.175606, 27.258158],
              [63.175307, 27.258156],
              [63.175058, 27.257963],
              [63.174815, 27.25763],
              [63.174089, 27.257165],
              [63.173942, 27.257023],
              [63.17393, 27.256901],
              [63.173791, 27.256824],
              [63.173748, 27.25674],
              [63.173603, 27.256679],
              [63.17356, 27.256459],
              [63.173475, 27.256374],
              [63.173391, 27.256171],
              [63.173178, 27.256032],
              [63.17307, 27.255761],
              [63.172961, 27.255744],
              [63.17294, 27.255675],
              [63.17275, 27.25557],
              [63.172636, 27.255411],
              [63.17258, 27.255228],
              [63.172343, 27.255056],
              [63.172308, 27.254688],
              [63.172368, 27.254536],
              [63.172073, 27.254461],
              [63.171956, 27.254499],
              [63.171506, 27.254476],
              [63.171095, 27.254534],
              [63.170896, 27.254481],
              [63.170467, 27.254604],
              [63.170238, 27.254613],
              [63.169916, 27.254429],
              [63.169705, 27.254406],
              [63.169469, 27.254221],
              [63.169283, 27.254222],
              [63.169062, 27.254084],
              [63.168844, 27.254032],
              [63.168384, 27.253798],
              [63.168153, 27.253757],
              [63.167908, 27.253567],
              [63.167761, 27.253574],
              [63.167415, 27.253381],
              [63.16723, 27.253389],
              [63.166992, 27.253194],
              [63.166668, 27.253124],
              [63.166509, 27.253006],
              [63.166372, 27.253118],
              [63.166096, 27.253058],
              [63.16576, 27.253086],
              [63.164979, 27.25281],
              [63.164872, 27.252666],
              [63.164548, 27.252653],
              [63.164499, 27.252561],
              [63.164182, 27.252572],
              [63.163898, 27.252647],
              [63.163788, 27.252579],
              [63.163589, 27.252593],
              [63.16354, 27.252453],
              [63.163402, 27.252363],
              [63.163378, 27.252266],
              [63.163229, 27.252117],
              [63.163137, 27.251757],
              [63.163164, 27.251654],
              [63.163117, 27.251332],
              [63.163032, 27.251213],
              [63.162914, 27.251217],
              [63.162921, 27.251098],
              [63.162827, 27.251091],
              [63.16283, 27.250985],
              [63.162711, 27.250939],
              [63.162737, 27.250851],
              [63.162643, 27.250803],
              [63.162626, 27.250717],
              [63.162714, 27.250545],
              [63.162666, 27.250427],
              [63.162432, 27.250403],
              [63.162428, 27.250308],
              [63.161539, 27.249882],
              [63.161542, 27.249837],
              [63.161275, 27.249673],
              [63.161225, 27.249594],
              [63.16057, 27.249329],
              [63.160214, 27.249068],
              [63.16008, 27.248827],
              [63.159782, 27.248587],
              [63.159332, 27.248564],
              [63.158832, 27.248621],
              [63.158473, 27.248424],
              [63.158236, 27.248385],
              [63.158176, 27.248292],
              [63.15807, 27.248303],
              [63.158041, 27.248229],
              [63.15766, 27.248212],
              [63.157562, 27.248164],
              [63.15745, 27.248297],
              [63.157386, 27.248491],
              [63.157306, 27.248351],
              [63.156819, 27.248326],
              [63.156588, 27.248209],
              [63.156537, 27.24826],
              [63.156294, 27.248149],
              [63.156143, 27.248128],
              [63.156056, 27.248154],
              [63.156041, 27.248214],
              [63.155842, 27.248345],
              [63.155439, 27.248497],
              [63.155199, 27.248642],
              [63.155049, 27.248774],
              [63.154989, 27.248922],
              [63.154868, 27.248888],
              [63.154816, 27.248797],
              [63.154461, 27.248717],
              [63.154429, 27.24859],
              [63.154245, 27.248464],
              [63.153833, 27.248488],
              [63.153429, 27.248363],
              [63.153192, 27.248159],
              [63.152863, 27.248112],
              [63.152598, 27.247884],
              [63.152485, 27.247881],
              [63.152283, 27.247667],
              [63.152184, 27.247686],
              [63.151931, 27.247555],
              [63.151936, 27.247439],
              [63.151759, 27.247312],
              [63.151691, 27.247189],
              [63.151603, 27.247196],
              [63.151274, 27.24707],
              [63.151052, 27.246869],
              [63.150983, 27.246543],
              [63.150735, 27.246474],
              [63.150569, 27.246481],
              [63.150234, 27.246185],
              [63.150026, 27.246127],
              [63.149933, 27.246053],
              [63.149743, 27.246042],
              [63.149823, 27.24597],
              [63.149763, 27.24588],
              [63.149814, 27.245784],
              [63.149729, 27.245439],
              [63.149452, 27.245287],
              [63.149444, 27.245206],
              [63.149304, 27.245109],
              [63.149208, 27.245099],
              [63.149039, 27.244913],
              [63.148742, 27.244736],
              [63.14852, 27.244459],
              [63.148505, 27.244354],
              [63.148233, 27.243902],
              [63.147714, 27.243839],
              [63.14715, 27.243581],
              [63.146905, 27.2436],
              [63.146859, 27.24352],
              [63.146739, 27.243487],
              [63.146494, 27.243312],
              [63.146255, 27.24328],
              [63.146001, 27.243355],
              [63.145365, 27.243003],
              [63.145005, 27.242616],
              [63.144653, 27.242644],
              [63.144482, 27.242703],
              [63.144071, 27.242986],
              [63.144051, 27.24306],
              [63.143777, 27.243203],
              [63.143572, 27.243173],
              [63.143313, 27.24329],
              [63.143286, 27.243346],
              [63.143139, 27.24334],
              [63.142983, 27.243402],
              [63.142764, 27.243664],
              [63.14217, 27.243812],
              [63.14174, 27.243804],
              [63.141425, 27.243967],
              [63.141034, 27.243908],
              [63.140855, 27.244],
              [63.140611, 27.244009],
              [63.140475, 27.244093],
              [63.140161, 27.244104],
              [63.139935, 27.244202],
              [63.139833, 27.244165],
              [63.139664, 27.244191],
              [63.139495, 27.244053],
              [63.139209, 27.244131],
              [63.139013, 27.244246],
              [63.138604, 27.244354],
              [63.13848, 27.24455],
              [63.138394, 27.244595],
              [63.138256, 27.244594],
              [63.138161, 27.244663],
              [63.1378, 27.244743],
              [63.137218, 27.244349],
              [63.137227, 27.244265],
              [63.137092, 27.244142],
              [63.137058, 27.244022],
              [63.136868, 27.244005],
              [63.136383, 27.243687],
              [63.136457, 27.243533],
              [63.136222, 27.243023],
              [63.136255, 27.242763],
              [63.136319, 27.242614],
              [63.136306, 27.242489],
              [63.13637, 27.242337],
              [63.136443, 27.2423],
              [63.136455, 27.242123],
              [63.13665, 27.241977],
              [63.136378, 27.241964],
              [63.13627, 27.241842],
              [63.136154, 27.241798],
              [63.136055, 27.241652],
              [63.135678, 27.24144],
              [63.135543, 27.241181],
              [63.13533, 27.241073],
              [63.13531, 27.240992],
              [63.135148, 27.240944],
              [63.135074, 27.240974],
              [63.134658, 27.240935],
              [63.134582, 27.24087],
              [63.134026, 27.240947],
              [63.133852, 27.240772],
              [63.133831, 27.240684],
              [63.133389, 27.240707],
              [63.133231, 27.240643],
              [63.133334, 27.24094],
              [63.133329, 27.2411],
              [63.133171, 27.24135],
              [63.132902, 27.241561],
              [63.132469, 27.241528],
              [63.132408, 27.24169],
              [63.131549, 27.241899],
              [63.131354, 27.241819],
              [63.131201, 27.241862],
              [63.130598, 27.241809],
              [63.130342, 27.241862],
              [63.130116, 27.241836],
              [63.129992, 27.241937],
              [63.129672, 27.242047],
              [63.129343, 27.241788],
              [63.129169, 27.241736],
              [63.129094, 27.241655],
              [63.128792, 27.241521],
              [63.128736, 27.241433],
              [63.128614, 27.241375],
              [63.12844, 27.241126],
              [63.128206, 27.241159],
              [63.128121, 27.241103],
              [63.127998, 27.241146],
              [63.127877, 27.241036],
              [63.127623, 27.241092],
              [63.127458, 27.241013],
              [63.127361, 27.241016],
              [63.126886, 27.241223],
              [63.126678, 27.241344],
              [63.126639, 27.241415],
              [63.126464, 27.241229],
              [63.126323, 27.241247],
              [63.126248, 27.241125],
              [63.126116, 27.24104],
              [63.125875, 27.240912],
              [63.125505, 27.240804],
              [63.125251, 27.240606],
              [63.125002, 27.240565],
              [63.124645, 27.240327],
              [63.124378, 27.240259],
              [63.124006, 27.240281],
              [63.124003, 27.240208],
              [63.123799, 27.239924],
              [63.123708, 27.239615],
              [63.123615, 27.239605],
              [63.123555, 27.239543],
              [63.123358, 27.239528],
              [63.123315, 27.239432],
              [63.123407, 27.239261],
              [63.123416, 27.238935],
              [63.123499, 27.238925],
              [63.12351, 27.238727],
              [63.123576, 27.238571],
              [63.123497, 27.238494],
              [63.123471, 27.238359],
              [63.123521, 27.238318],
              [63.12346, 27.238254],
              [63.123436, 27.238112],
              [63.123167, 27.237866],
              [63.122946, 27.237862],
              [63.122445, 27.237633],
              [63.122483, 27.237559],
              [63.122453, 27.237498],
              [63.122219, 27.237414],
              [63.122069, 27.237303],
              [63.121963, 27.236905],
              [63.121111, 27.236945],
              [63.121047, 27.237005],
              [63.120945, 27.237015],
              [63.120575, 27.237011],
              [63.120326, 27.237165],
              [63.120281, 27.237288],
              [63.120195, 27.237257],
              [63.119579, 27.237314],
              [63.119547, 27.237365],
              [63.119391, 27.237383],
              [63.119287, 27.237508],
              [63.119164, 27.237538],
              [63.118636, 27.237499],
              [63.11861, 27.237409],
              [63.118508, 27.237403],
              [63.117947, 27.237564],
              [63.11778, 27.237688],
              [63.11741, 27.237446],
              [63.117348, 27.237376],
              [63.117382, 27.237303],
              [63.117167, 27.237138],
              [63.117171, 27.237052],
              [63.117071, 27.236935],
              [63.117138, 27.236827],
              [63.117162, 27.23665],
              [63.117086, 27.236465],
              [63.117115, 27.236266],
              [63.117074, 27.236191],
              [63.116934, 27.236155],
              [63.116803, 27.236212],
              [63.116741, 27.236082],
              [63.116641, 27.236387],
              [63.116407, 27.236496],
              [63.116092, 27.23658],
              [63.115977, 27.236539],
              [63.115713, 27.2366],
              [63.115406, 27.236565],
              [63.115181, 27.236682],
              [63.115116, 27.236647],
              [63.114735, 27.236766],
              [63.114507, 27.236674],
              [63.114346, 27.236715],
              [63.114123, 27.236661],
              [63.113776, 27.236417],
              [63.113584, 27.236503],
              [63.113513, 27.236424],
              [63.113381, 27.236463],
              [63.113314, 27.236603],
              [63.113102, 27.236362],
              [63.112965, 27.23629],
              [63.112755, 27.236316],
              [63.11261, 27.236229],
              [63.112554, 27.236291],
              [63.112508, 27.236497],
              [63.112305, 27.236639],
              [63.112284, 27.236735],
              [63.112178, 27.236759],
              [63.112114, 27.236908],
              [63.111993, 27.236947],
              [63.111961, 27.236998],
              [63.111993, 27.237052],
              [63.111821, 27.237216],
              [63.111661, 27.23719],
              [63.11144, 27.23723],
              [63.111237, 27.237346],
              [63.110924, 27.237617],
              [63.110831, 27.23786],
              [63.11067, 27.237936],
              [63.110461, 27.237949],
              [63.110439, 27.238055],
              [63.110271, 27.238189],
              [63.110159, 27.238192],
              [63.109401, 27.238521],
              [63.109031, 27.238502],
              [63.108856, 27.238596],
              [63.108655, 27.238566],
              [63.108428, 27.238359],
              [63.108243, 27.238364],
              [63.108109, 27.238307],
              [63.107983, 27.238307],
              [63.107749, 27.238403],
              [63.107458, 27.238374],
              [63.107394, 27.23846],
              [63.107005, 27.238638],
              [63.106683, 27.238726],
              [63.106309, 27.23866],
              [63.106072, 27.238849],
              [63.105852, 27.238473],
              [63.105458, 27.238115],
              [63.105074, 27.237679],
              [63.104615, 27.237556],
              [63.104184, 27.237294],
              [63.104058, 27.237131],
              [63.103526, 27.237048],
              [63.103235, 27.236898],
              [63.103154, 27.236797],
              [63.102882, 27.23672],
              [63.102739, 27.236732],
              [63.102621, 27.23666],
              [63.101614, 27.236647],
              [63.101363, 27.236795],
              [63.101211, 27.236831],
              [63.10088, 27.237089],
              [63.10081, 27.237078],
              [63.100623, 27.236895],
              [63.100319, 27.23684],
              [63.099875, 27.236857],
              [63.099636, 27.236977],
              [63.099387, 27.236994],
              [63.099246, 27.236971],
              [63.09907, 27.236862],
              [63.098781, 27.236916],
              [63.098548, 27.237165],
              [63.09842, 27.237218],
              [63.098321, 27.23712],
              [63.098238, 27.237133],
              [63.098016, 27.237021],
              [63.097767, 27.237054],
              [63.097666, 27.236978],
              [63.097684, 27.236914],
              [63.097614, 27.236874],
              [63.097597, 27.236789],
              [63.097455, 27.236727],
              [63.097276, 27.236759],
              [63.097098, 27.23675],
              [63.097003, 27.236695],
              [63.096555, 27.236723],
              [63.096469, 27.236679],
              [63.09624, 27.236702],
              [63.095534, 27.23691],
              [63.095348, 27.237168],
              [63.095152, 27.237207],
              [63.095076, 27.237183],
              [63.095034, 27.237242],
              [63.094875, 27.237264],
              [63.094534, 27.237077],
              [63.094321, 27.237061],
              [63.093984, 27.23674],
              [63.093532, 27.236812],
              [63.093351, 27.236683],
              [63.093206, 27.236654],
              [63.092653, 27.236667],
              [63.09255, 27.236716],
              [63.092301, 27.236647],
              [63.092088, 27.236326],
              [63.092007, 27.236269],
              [63.091761, 27.236228],
              [63.091719, 27.236148],
              [63.091523, 27.23605],
              [63.091501, 27.23599],
              [63.091419, 27.235978],
              [63.091026, 27.235623],
              [63.090611, 27.23544],
              [63.090281, 27.235416],
              [63.090256, 27.235481],
              [63.090126, 27.235469],
              [63.090031, 27.235522],
              [63.089586, 27.235444],
              [63.08941, 27.235666],
              [63.089393, 27.23593],
              [63.089428, 27.23631],
              [63.089533, 27.236604],
              [63.089432, 27.236767],
              [63.089557, 27.23706],
              [63.089519, 27.237147],
              [63.089272, 27.237208],
              [63.089187, 27.237481],
              [63.089082, 27.23754],
              [63.089066, 27.237686],
              [63.08887, 27.237845],
              [63.088955, 27.238082],
              [63.088849, 27.238122],
              [63.08886, 27.238181],
              [63.088688, 27.238405],
              [63.088603, 27.238618],
              [63.088682, 27.238984],
              [63.088766, 27.239126],
              [63.088655, 27.239313],
              [63.088496, 27.239379],
              [63.088363, 27.23937],
              [63.088157, 27.239261],
              [63.088085, 27.239269],
              [63.087892, 27.23911],
              [63.087565, 27.239082],
              [63.087351, 27.239152],
              [63.087299, 27.239108],
              [63.086955, 27.23915],
              [63.086855, 27.239275],
              [63.08691, 27.239527],
              [63.086988, 27.23963],
              [63.086962, 27.239736],
              [63.087015, 27.23977],
              [63.087064, 27.239939],
              [63.087186, 27.240042],
              [63.087408, 27.240379],
              [63.087581, 27.24046],
              [63.087724, 27.240781],
              [63.087775, 27.240809],
              [63.087656, 27.241144],
              [63.087407, 27.241386],
              [63.087552, 27.241523],
              [63.087635, 27.241735],
              [63.087779, 27.241745],
              [63.087764, 27.241805],
              [63.087548, 27.241898],
              [63.087382, 27.242055],
              [63.08738, 27.242242],
              [63.087447, 27.242363],
              [63.087456, 27.242504],
              [63.087252, 27.242617],
              [63.087213, 27.242745],
              [63.087246, 27.242894],
              [63.087102, 27.242992],
              [63.087234, 27.243538],
              [63.087114, 27.243777],
              [63.086922, 27.243999],
              [63.086889, 27.244152],
              [63.086944, 27.244252],
              [63.086937, 27.244422],
              [63.086857, 27.244701],
              [63.086594, 27.244921],
              [63.08613, 27.244989],
              [63.085884, 27.244929],
              [63.08542, 27.244715],
              [63.085178, 27.244759],
              [63.085009, 27.24471],
              [63.0847, 27.24444],
              [63.084472, 27.244348],
              [63.084236, 27.244061],
              [63.084069, 27.244002],
              [63.083555, 27.244007],
              [63.083402, 27.243884],
              [63.083271, 27.243885],
              [63.083128, 27.243728],
              [63.082976, 27.243746],
              [63.082237, 27.24349],
              [63.082184, 27.24344],
              [63.081667, 27.243494],
              [63.08139, 27.243472],
              [63.08121, 27.243364],
              [63.081055, 27.243369],
              [63.080961, 27.243308],
              [63.080791, 27.243284],
              [63.080587, 27.243425],
              [63.080568, 27.243531],
              [63.079954, 27.243657],
              [63.079384, 27.243448],
              [63.079179, 27.243237],
              [63.079041, 27.243268],
              [63.07897, 27.243205],
              [63.078464, 27.243168],
              [63.078326, 27.243049],
              [63.07817, 27.242717],
              [63.0779, 27.241808],
              [63.077733, 27.241479],
              [63.077713, 27.241232],
              [63.077778, 27.241149],
              [63.07768, 27.241054],
              [63.076136, 27.240784],
              [63.075852, 27.240497],
              [63.075287, 27.240233],
              [63.074889, 27.240251],
              [63.074661, 27.240146],
              [63.074313, 27.240109],
              [63.07355, 27.240163],
              [63.073311, 27.239981],
              [63.073062, 27.239881],
              [63.072737, 27.239665],
              [63.072742, 27.239581],
              [63.072285, 27.239334],
              [63.072017, 27.239063],
              [63.071645, 27.238964],
              [63.071612, 27.238844],
              [63.07133, 27.238943],
              [63.071238, 27.238932],
              [63.071044, 27.239053],
              [63.070604, 27.238828],
              [63.07025, 27.238783],
              [63.069977, 27.23884],
              [63.069529, 27.239184],
              [63.06942, 27.239396],
              [63.069341, 27.239485],
              [63.069278, 27.239484],
              [63.068704, 27.239139],
              [63.068484, 27.2389],
              [63.068293, 27.238791],
              [63.068131, 27.238439],
              [63.067476, 27.237973],
              [63.067342, 27.23778],
              [63.06714, 27.237645],
              [63.067055, 27.237614],
              [63.066868, 27.237689],
              [63.06677, 27.237838],
              [63.066559, 27.238009],
              [63.066389, 27.237957],
              [63.066244, 27.238046],
              [63.065789, 27.23782],
              [63.065589, 27.237783],
              [63.06533, 27.237805],
              [63.065016, 27.237686],
              [63.064718, 27.237744],
              [63.064541, 27.237709],
              [63.064515, 27.237647],
              [63.064266, 27.237652],
              [63.064143, 27.237501],
              [63.063593, 27.237374],
              [63.063524, 27.237339],
              [63.063437, 27.237182],
              [63.063335, 27.237176],
              [63.062851, 27.236909],
              [63.062277, 27.236717],
              [63.062231, 27.236561],
              [63.062258, 27.236339],
              [63.062094, 27.2362],
              [63.061663, 27.236075],
              [63.06157, 27.235788],
              [63.061399, 27.235774],
              [63.060971, 27.235613],
              [63.060637, 27.23538],
              [63.060341, 27.235301],
              [63.059969, 27.234822],
              [63.059873, 27.234764],
              [63.05971, 27.234768],
              [63.05949, 27.234709],
              [63.059322, 27.234815],
              [63.05907, 27.234864],
              [63.058819, 27.235253],
              [63.058284, 27.23558],
              [63.057699, 27.235552],
              [63.057436, 27.235457],
              [63.057558, 27.235255],
              [63.057233, 27.234998],
              [63.057095, 27.234815],
              [63.056475, 27.23454],
              [63.056021, 27.234397],
              [63.05581, 27.234238],
              [63.055345, 27.234043],
              [63.055242, 27.23393],
              [63.054946, 27.234061],
              [63.054541, 27.233889],
              [63.053949, 27.234012],
              [63.053396, 27.233917],
              [63.05328, 27.233857],
              [63.053221, 27.23377],
              [63.052835, 27.233626],
              [63.052587, 27.233649],
              [63.052538, 27.233605],
              [63.05203, 27.233676],
              [63.051823, 27.233777],
              [63.051323, 27.233776],
              [63.05125, 27.23372],
              [63.051088, 27.233714],
              [63.051031, 27.233757],
              [63.050937, 27.233721],
              [63.050765, 27.233736],
              [63.050498, 27.233909],
              [63.049922, 27.233841],
              [63.049818, 27.233858],
              [63.049613, 27.234009],
              [63.04919, 27.233959],
              [63.048809, 27.234093],
              [63.048646, 27.234236],
              [63.048258, 27.234417],
              [63.048109, 27.234446],
              [63.047974, 27.234396],
              [63.047638, 27.234456],
              [63.047315, 27.234433],
              [63.047002, 27.234482],
              [63.046871, 27.234841],
              [63.046712, 27.235028],
              [63.046383, 27.235282],
              [63.046269, 27.23547],
              [63.046059, 27.235632],
              [63.046005, 27.235747],
              [63.04578, 27.235845],
              [63.045817, 27.235876],
              [63.045773, 27.235923],
              [63.045832, 27.236267],
              [63.045784, 27.236359],
              [63.04554, 27.236429],
              [63.044822, 27.236347],
              [63.044657, 27.236373],
              [63.044349, 27.236519],
              [63.043581, 27.236275],
              [63.043247, 27.23636],
              [63.042996, 27.236355],
              [63.042886, 27.236395],
              [63.042686, 27.236641],
              [63.042484, 27.236671],
              [63.042323, 27.236636],
              [63.042067, 27.236721],
              [63.041968, 27.236788],
              [63.042061, 27.236843],
              [63.041993, 27.236992],
              [63.041594, 27.237159],
              [63.041424, 27.23712],
              [63.040552, 27.23729],
              [63.040146, 27.236931],
              [63.040059, 27.236774],
              [63.039643, 27.236617],
              [63.039585, 27.236486],
              [63.039104, 27.236249],
              [63.038871, 27.235895],
              [63.038818, 27.235651],
              [63.038891, 27.235491],
              [63.038348, 27.23541],
              [63.03807, 27.234842],
              [63.037865, 27.234571],
              [63.037646, 27.234363],
              [63.037455, 27.234317],
              [63.037284, 27.234183],
              [63.037259, 27.234038],
              [63.03733, 27.233932],
              [63.03731, 27.233851],
              [63.037179, 27.233638],
              [63.03706, 27.233261],
              [63.03681, 27.233142],
              [63.03671, 27.232479],
              [63.036269, 27.23246],
              [63.036056, 27.232581],
              [63.035924, 27.232607],
              [63.035636, 27.232514],
              [63.035571, 27.232444],
              [63.035445, 27.23245],
              [63.035217, 27.232571],
              [63.034935, 27.232499],
              [63.034695, 27.232374],
              [63.034287, 27.2324],
              [63.033894, 27.23209],
              [63.033494, 27.232016],
              [63.033387, 27.231941],
              [63.033277, 27.23195],
              [63.033166, 27.231803],
              [63.033198, 27.231435],
              [63.033037, 27.231403],
              [63.032969, 27.231309],
              [63.032844, 27.231285],
              [63.032753, 27.2311],
              [63.032383, 27.230883],
              [63.03242, 27.230809],
              [63.032356, 27.230673],
              [63.03225, 27.230617],
              [63.032201, 27.230449],
              [63.032068, 27.230364],
              [63.032071, 27.230303],
              [63.031931, 27.230235],
              [63.031889, 27.230139],
              [63.031823, 27.230129],
              [63.031679, 27.22991],
              [63.031264, 27.22993],
              [63.031154, 27.229869],
              [63.030984, 27.229953],
              [63.030888, 27.23036],
              [63.030684, 27.230276],
              [63.03009, 27.23018],
              [63.029544, 27.230315],
              [63.029424, 27.230596],
              [63.029342, 27.230643],
              [63.02928, 27.230782],
              [63.028866, 27.230755],
              [63.028595, 27.230593],
              [63.028485, 27.230465],
              [63.02816, 27.230449],
              [63.028009, 27.230533],
              [63.027618, 27.230536],
              [63.027533, 27.230524],
              [63.02733, 27.230307],
              [63.026749, 27.230328],
              [63.026576, 27.230184],
              [63.02653, 27.230088],
              [63.026439, 27.230084],
              [63.026353, 27.230021],
              [63.026276, 27.229875],
              [63.02603, 27.229846],
              [63.025931, 27.22978],
              [63.02585, 27.229828],
              [63.02566, 27.229814],
              [63.025073, 27.229646],
              [63.024876, 27.229526],
              [63.024693, 27.229663],
              [63.0243, 27.229778],
              [63.024222, 27.229854],
              [63.024105, 27.229833],
              [63.023788, 27.22991],
              [63.023417, 27.22978],
              [63.023307, 27.229792],
              [63.023115, 27.229674],
              [63.02297, 27.229709],
              [63.022823, 27.229687],
              [63.022626, 27.229598],
              [63.022525, 27.229494],
              [63.02253, 27.229436],
              [63.022277, 27.229155],
              [63.022182, 27.228923],
              [63.021986, 27.228809],
              [63.021918, 27.228667],
              [63.021947, 27.228527],
              [63.021777, 27.228218],
              [63.021563, 27.228075],
              [63.021602, 27.227979],
              [63.021551, 27.227909],
              [63.021564, 27.227567],
              [63.021376, 27.227547],
              [63.021316, 27.227457],
              [63.020904, 27.227147],
              [63.020798, 27.226809],
              [63.020677, 27.226667],
              [63.020619, 27.226314],
              [63.020238, 27.226188],
              [63.02022, 27.226087],
              [63.019823, 27.225688],
              [63.019731, 27.225481],
              [63.019193, 27.225161],
              [63.019051, 27.225192],
              [63.018879, 27.22513],
              [63.018119, 27.224726],
              [63.017745, 27.224587],
              [63.017621, 27.224462],
              [63.017396, 27.22435],
              [63.016751, 27.22446],
              [63.016631, 27.224531],
              [63.01661, 27.224628],
              [63.015993, 27.224488],
              [63.015652, 27.224469],
              [63.015089, 27.224274],
              [63.015005, 27.224278],
              [63.014683, 27.224138],
              [63.014441, 27.223899],
              [63.014343, 27.223896],
              [63.014301, 27.223831],
              [63.014199, 27.223826],
              [63.014068, 27.223718],
              [63.013167, 27.223456],
              [63.012857, 27.223422],
              [63.012657, 27.223143],
              [63.012434, 27.223073],
              [63.012169, 27.223147],
              [63.012122, 27.223229],
              [63.011551, 27.223315],
              [63.011249, 27.223438],
              [63.011029, 27.223906],
              [63.010912, 27.223932],
              [63.010685, 27.223933],
              [63.010063, 27.223803],
              [63.009579, 27.223806],
              [63.009463, 27.223743],
              [63.009324, 27.223754],
              [63.009249, 27.223709],
              [63.008898, 27.223771],
              [63.00846, 27.223704],
              [63.008328, 27.223619],
              [63.008187, 27.223656],
              [63.00811, 27.223992],
              [63.007917, 27.223953],
              [63.007729, 27.223825],
              [63.007646, 27.223682],
              [63.007565, 27.223657],
              [63.007147, 27.223612],
              [63.006935, 27.223631],
              [63.006857, 27.223573],
              [63.006443, 27.223451],
              [63.006259, 27.223462],
              [63.006269, 27.223364],
              [63.006167, 27.223086],
              [63.006192, 27.22292],
              [63.00601, 27.22241],
              [63.005939, 27.222366],
              [63.00593, 27.222277],
              [63.005665, 27.221828],
              [63.005431, 27.221639],
              [63.005258, 27.221334],
              [63.005225, 27.221153],
              [63.004787, 27.221343],
              [63.004714, 27.221332],
              [63.004209, 27.221237],
              [63.004158, 27.22118],
              [63.004081, 27.221186],
              [63.003992, 27.221114],
              [63.00399, 27.22106],
              [63.003821, 27.221011],
              [63.00356, 27.221011],
              [63.003417, 27.22096],
              [63.003407, 27.220908],
              [63.002915, 27.220756],
              [63.002788, 27.22043],
              [63.002308, 27.220323],
              [63.00227, 27.220216],
              [63.002021, 27.220128],
              [63.001665, 27.219867],
              [63.001665, 27.219823],
              [63.001474, 27.219759],
              [63.001248, 27.219615],
              [63.001243, 27.219562],
              [63.001174, 27.21957],
              [63.001084, 27.219311],
              [63.000956, 27.219323],
              [63.000729, 27.219187],
              [63.000397, 27.218798],
              [63.000235, 27.218851],
              [63.000054, 27.219039],
              [62.999901, 27.219069],
              [62.999884, 27.219181],
              [62.999566, 27.21924],
              [62.999426, 27.219337],
              [62.999254, 27.219367],
              [62.998639, 27.219204],
              [62.998403, 27.219051],
              [62.997812, 27.21898],
              [62.997484, 27.218851],
              [62.997346, 27.218907],
              [62.996942, 27.218904],
              [62.996811, 27.218602],
              [62.996591, 27.218323],
              [62.996568, 27.21812],
              [62.996374, 27.218097],
              [62.996135, 27.217979],
              [62.996054, 27.21797],
              [62.995985, 27.21803],
              [62.995922, 27.217965],
              [62.99577, 27.217964],
              [62.99535, 27.217766],
              [62.995231, 27.217558],
              [62.995062, 27.217381],
              [62.994747, 27.217203],
              [62.994558, 27.217158],
              [62.994389, 27.216981],
              [62.994306, 27.216727],
              [62.994358, 27.216662],
              [62.994244, 27.216547],
              [62.993998, 27.216441],
              [62.993566, 27.216057],
              [62.993547, 27.215944],
              [62.993357, 27.215755],
              [62.993183, 27.215804],
              [62.993176, 27.215918],
              [62.993043, 27.216006],
              [62.992836, 27.216035],
              [62.992725, 27.216207],
              [62.992491, 27.216286],
              [62.992372, 27.216476],
              [62.992144, 27.216598],
              [62.991533, 27.216579],
              [62.991083, 27.216667],
              [62.990994, 27.2167],
              [62.99079, 27.21697],
              [62.990672, 27.217055],
              [62.990473, 27.217097],
              [62.990436, 27.217181],
              [62.990289, 27.217237],
              [62.989918, 27.217229],
              [62.989732, 27.217325],
              [62.989564, 27.217356],
              [62.989334, 27.217334],
              [62.989269, 27.217179],
              [62.989153, 27.217173],
              [62.989101, 27.217013],
              [62.988969, 27.216946],
              [62.988866, 27.216965],
              [62.988817, 27.216892],
              [62.988593, 27.216886],
              [62.988502, 27.216793],
              [62.988371, 27.216779],
              [62.988402, 27.216745],
              [62.988371, 27.216717],
              [62.988245, 27.216713],
              [62.988052, 27.2166],
              [62.987745, 27.216618],
              [62.987644, 27.216569],
              [62.987392, 27.216601],
              [62.987359, 27.216516],
              [62.987177, 27.216362],
              [62.986753, 27.216237],
              [62.986505, 27.216413],
              [62.986405, 27.216399],
              [62.986243, 27.216487],
              [62.986042, 27.216523],
              [62.985803, 27.216863],
              [62.985729, 27.217213],
              [62.985537, 27.217244],
              [62.985359, 27.217459],
              [62.984984, 27.217595],
              [62.984812, 27.217748],
              [62.984647, 27.218146],
              [62.984472, 27.218202],
              [62.984216, 27.21813],
              [62.984178, 27.218167],
              [62.984074, 27.218149],
              [62.983885, 27.218031],
              [62.983714, 27.217995],
              [62.983601, 27.218023],
              [62.983543, 27.21799],
              [62.983543, 27.217917],
              [62.983398, 27.217912],
              [62.983309, 27.217857],
              [62.982942, 27.217921],
              [62.982738, 27.217901],
              [62.982388, 27.217778],
              [62.982236, 27.217787],
              [62.981857, 27.217554],
              [62.981516, 27.217541],
              [62.981126, 27.217389],
              [62.980335, 27.217219],
              [62.980136, 27.217231],
              [62.980125, 27.21713],
              [62.979679, 27.216957],
              [62.979336, 27.216744],
              [62.979265, 27.216764],
              [62.978809, 27.216578],
              [62.978753, 27.216446],
              [62.978405, 27.216242],
              [62.978237, 27.21625],
              [62.977461, 27.21598],
              [62.977371, 27.215903],
              [62.977257, 27.215886],
              [62.976965, 27.216008],
              [62.97665, 27.216072],
              [62.976143, 27.216267],
              [62.975943, 27.216424],
              [62.975646, 27.216388],
              [62.975177, 27.216453],
              [62.974938, 27.21644],
              [62.974762, 27.216491],
              [62.974721, 27.216548],
              [62.974208, 27.216409],
              [62.974123, 27.216428],
              [62.973895, 27.216372],
              [62.973794, 27.21644],
              [62.973577, 27.216368],
              [62.973348, 27.216375],
              [62.973208, 27.216249],
              [62.973005, 27.216235],
              [62.972718, 27.215959],
              [62.972723, 27.21585],
              [62.972463, 27.215556],
              [62.97229, 27.215513],
              [62.972059, 27.215295],
              [62.971777, 27.215141],
              [62.971623, 27.214959],
              [62.971312, 27.214875],
              [62.971201, 27.214795],
              [62.971165, 27.214703],
              [62.971056, 27.214696],
              [62.970995, 27.214584],
              [62.970859, 27.214479],
              [62.970847, 27.214407],
              [62.970531, 27.214273],
              [62.970508, 27.214113],
              [62.970307, 27.214072],
              [62.970161, 27.21412],
              [62.970016, 27.213974],
              [62.96994, 27.213973],
              [62.9699, 27.213876],
              [62.96982, 27.213869],
              [62.969675, 27.213715],
              [62.969676, 27.213666],
              [62.96958, 27.213584],
              [62.969596, 27.213508],
              [62.969453, 27.213479],
              [62.96948, 27.213151],
              [62.969566, 27.213127],
              [62.969629, 27.212901],
              [62.969679, 27.212882],
              [62.969604, 27.212747],
              [62.969386, 27.212561],
              [62.969398, 27.212427],
              [62.969338, 27.212451],
              [62.969384, 27.212229],
              [62.969253, 27.212207],
              [62.969279, 27.212154],
              [62.969436, 27.212098],
              [62.969419, 27.211986],
              [62.969323, 27.211946],
              [62.969325, 27.211796],
              [62.969196, 27.211672],
              [62.968883, 27.21154],
              [62.968827, 27.211438],
              [62.96883, 27.211203],
              [62.968586, 27.210782],
              [62.968558, 27.21054],
              [62.968312, 27.210024],
              [62.968271, 27.2098],
              [62.968161, 27.209791],
              [62.968177, 27.209587],
              [62.968113, 27.209409],
              [62.968112, 27.209182],
              [62.967927, 27.208874],
              [62.967734, 27.208865],
              [62.967509, 27.20865],
              [62.967243, 27.208644],
              [62.967061, 27.208717],
              [62.966917, 27.208716],
              [62.966592, 27.208854],
              [62.966432, 27.209036],
              [62.966242, 27.209094],
              [62.966037, 27.209284],
              [62.965743, 27.209292],
              [62.965665, 27.20923],
              [62.96567, 27.209173],
              [62.965558, 27.209144],
              [62.965427, 27.209176],
              [62.964667, 27.209023],
              [62.964461, 27.208844],
              [62.964158, 27.208731],
              [62.963621, 27.208752],
              [62.963431, 27.208692],
              [62.96335, 27.208755],
              [62.963353, 27.208823],
              [62.963066, 27.208698],
              [62.962746, 27.208644],
              [62.962229, 27.208435],
              [62.96206, 27.208279],
              [62.961602, 27.208064],
              [62.961205, 27.207908],
              [62.960827, 27.207849],
              [62.960773, 27.207756],
              [62.960455, 27.207591],
              [62.960351, 27.207478],
              [62.960276, 27.207202],
              [62.960162, 27.207004],
              [62.960103, 27.206673],
              [62.959789, 27.206158],
              [62.959685, 27.206214],
              [62.959534, 27.206154],
              [62.959018, 27.206133],
              [62.958736, 27.205869],
              [62.958679, 27.205883],
              [62.95864, 27.20583],
              [62.958565, 27.205867],
              [62.958129, 27.205776],
              [62.958045, 27.205956],
              [62.957838, 27.205979],
              [62.957759, 27.205909],
              [62.957681, 27.205924],
              [62.957536, 27.205867],
              [62.957256, 27.20563],
              [62.957057, 27.205601],
              [62.956904, 27.205669],
              [62.956709, 27.205633],
              [62.956553, 27.205735],
              [62.956473, 27.205847],
              [62.95639, 27.205891],
              [62.956282, 27.205878],
              [62.956016, 27.206025],
              [62.955806, 27.20596],
              [62.955608, 27.205953],
              [62.955394, 27.206051],
              [62.955068, 27.20608],
              [62.954749, 27.206201],
              [62.954511, 27.206211],
              [62.954405, 27.20615],
              [62.954409, 27.206202],
              [62.954316, 27.206229],
              [62.95361, 27.206146],
              [62.953527, 27.20615],
              [62.953535, 27.206195],
              [62.953454, 27.206238],
              [62.953303, 27.206231],
              [62.952845, 27.205824],
              [62.952814, 27.205685],
              [62.952665, 27.205645],
              [62.952693, 27.205599],
              [62.952549, 27.205489],
              [62.952089, 27.205452],
              [62.951841, 27.205388],
              [62.951133, 27.205094],
              [62.950934, 27.205053],
              [62.950781, 27.204921],
              [62.950652, 27.20497],
              [62.950602, 27.20487],
              [62.950544, 27.204869],
              [62.950483, 27.204792],
              [62.950398, 27.204788],
              [62.950247, 27.204664],
              [62.949844, 27.204502],
              [62.949793, 27.204303],
              [62.949705, 27.204211],
              [62.949365, 27.204108],
              [62.949321, 27.204034],
              [62.949147, 27.203976],
              [62.949101, 27.203872],
              [62.948599, 27.203585],
              [62.948532, 27.203386],
              [62.948424, 27.20333],
              [62.948359, 27.203205],
              [62.948198, 27.203078],
              [62.948117, 27.202919],
              [62.947844, 27.202872],
              [62.947737, 27.202616],
              [62.947566, 27.202465],
              [62.947332, 27.202137],
              [62.947272, 27.202116],
              [62.947152, 27.201895],
              [62.946869, 27.201977],
              [62.946804, 27.202064],
              [62.946678, 27.202096],
              [62.946468, 27.202384],
              [62.946472, 27.202435],
              [62.946334, 27.202462],
              [62.946234, 27.202555],
              [62.946159, 27.202438],
              [62.94582, 27.202584],
              [62.945746, 27.202582],
              [62.945654, 27.202506],
              [62.945538, 27.20271],
              [62.945211, 27.202848],
              [62.944985, 27.203103],
              [62.944987, 27.203219],
              [62.94488, 27.203327],
              [62.944692, 27.203255],
              [62.944428, 27.203255],
              [62.944211, 27.203077],
              [62.9439, 27.203114],
              [62.943855, 27.203173],
              [62.943446, 27.20313],
              [62.943377, 27.203147],
              [62.943315, 27.203281],
              [62.942916, 27.203351],
              [62.942543, 27.203527],
              [62.94243, 27.203528],
              [62.942389, 27.203435],
              [62.942178, 27.203343],
              [62.941891, 27.203369],
              [62.941842, 27.203328],
              [62.941633, 27.203364],
              [62.941609, 27.203525],
              [62.941459, 27.203574],
              [62.941208, 27.203759],
              [62.940117, 27.203612],
              [62.939863, 27.203658],
              [62.939641, 27.203541],
              [62.939322, 27.203521],
              [62.939102, 27.203402],
              [62.938612, 27.203336],
              [62.938424, 27.203254],
              [62.938312, 27.202935],
              [62.938215, 27.202794],
              [62.938048, 27.202742],
              [62.93804, 27.202678],
              [62.937988, 27.202678],
              [62.937837, 27.202445],
              [62.937731, 27.202387],
              [62.937671, 27.202249],
              [62.937588, 27.202188],
              [62.937567, 27.202035],
              [62.937482, 27.202001],
              [62.937427, 27.201743],
              [62.937346, 27.2017],
              [62.937342, 27.201639],
              [62.937255, 27.201615],
              [62.937223, 27.201484],
              [62.937162, 27.201501],
              [62.936974, 27.20144],
              [62.936677, 27.201511],
              [62.936652, 27.201439],
              [62.936478, 27.201448],
              [62.936378, 27.201522],
              [62.936002, 27.201557],
              [62.935996, 27.201629],
              [62.935944, 27.201652],
              [62.935904, 27.201457],
              [62.935479, 27.201529],
              [62.935344, 27.201503],
              [62.93534, 27.20156],
              [62.93512, 27.201638],
              [62.93502, 27.201741],
              [62.934589, 27.201652],
              [62.93445, 27.201576],
              [62.934435, 27.201524],
              [62.934335, 27.201531],
              [62.934216, 27.201461],
              [62.933724, 27.201528],
              [62.933276, 27.2017],
              [62.933153, 27.201829],
              [62.932991, 27.201863],
              [62.932965, 27.202329],
              [62.932862, 27.202496],
              [62.932492, 27.20275],
              [62.932092, 27.202669],
              [62.93178, 27.202742],
              [62.931702, 27.202699],
              [62.931477, 27.20271],
              [62.930939, 27.203009],
              [62.930579, 27.202995],
              [62.930421, 27.203074],
              [62.930403, 27.203162],
              [62.930218, 27.203112],
              [62.930093, 27.203136],
              [62.929983, 27.202965],
              [62.929878, 27.202943],
              [62.929777, 27.202797],
              [62.929781, 27.202704],
              [62.929636, 27.202658],
              [62.929272, 27.202736],
              [62.929211, 27.202808],
              [62.929257, 27.203027],
              [62.929184, 27.2032],
              [62.929073, 27.203273],
              [62.929069, 27.203353],
              [62.928871, 27.203358],
              [62.92875, 27.203579],
              [62.928645, 27.203623],
              [62.928548, 27.20375],
              [62.928405, 27.203767],
              [62.928414, 27.203804],
              [62.928292, 27.203904],
              [62.928329, 27.203983],
              [62.928296, 27.204177],
              [62.928234, 27.204181],
              [62.927964, 27.204429],
              [62.927732, 27.204488],
              [62.927761, 27.204532],
              [62.927599, 27.204597],
              [62.927564, 27.204679],
              [62.927588, 27.204918],
              [62.927536, 27.204982],
              [62.927641, 27.20522],
              [62.92724, 27.205254],
              [62.927078, 27.205317],
              [62.926811, 27.205253],
              [62.926708, 27.205122],
              [62.926622, 27.205178],
              [62.926567, 27.205122],
              [62.926347, 27.205146],
              [62.926229, 27.205326],
              [62.926011, 27.205496],
              [62.925796, 27.205507],
              [62.925499, 27.205601],
              [62.925103, 27.205511],
              [62.924732, 27.205709],
              [62.92447, 27.206029],
              [62.924275, 27.206088],
              [62.924147, 27.206046],
              [62.923689, 27.206222],
              [62.923584, 27.20623],
              [62.923105, 27.206095],
              [62.922814, 27.205963],
              [62.922376, 27.206004],
              [62.922309, 27.205964],
              [62.922169, 27.206005],
              [62.921933, 27.205969],
              [62.921697, 27.205742],
              [62.921524, 27.205676],
              [62.921308, 27.205705],
              [62.92122, 27.205893],
              [62.921128, 27.205967],
              [62.920915, 27.205994],
              [62.920764, 27.206073],
              [62.920477, 27.206046],
              [62.920451, 27.206174],
              [62.920319, 27.206169],
              [62.920308, 27.206232],
              [62.919846, 27.206549],
              [62.919711, 27.206762],
              [62.919737, 27.20689],
              [62.919166, 27.207124],
              [62.919103, 27.207329],
              [62.918882, 27.207486],
              [62.918703, 27.207538],
              [62.918616, 27.20763],
              [62.918608, 27.207758],
              [62.918409, 27.207846],
              [62.918234, 27.208053],
              [62.918085, 27.208063],
              [62.918004, 27.208137],
              [62.91766, 27.208202],
              [62.917594, 27.208112],
              [62.917494, 27.208141],
              [62.917413, 27.20807],
              [62.917242, 27.208046],
              [62.916989, 27.208092],
              [62.916926, 27.207993],
              [62.916864, 27.208017],
              [62.916668, 27.207976],
              [62.916102, 27.208277],
              [62.915582, 27.208787],
              [62.91528, 27.20872],
              [62.915179, 27.208735],
              [62.915013, 27.20869],
              [62.914931, 27.20861],
              [62.914801, 27.208625],
              [62.914662, 27.208569],
              [62.914293, 27.208603],
              [62.914237, 27.208565],
              [62.913883, 27.208576],
              [62.913846, 27.208768],
              [62.913651, 27.20883],
              [62.913582, 27.208897],
              [62.913583, 27.208969],
              [62.913286, 27.209094],
              [62.913105, 27.209093],
              [62.912973, 27.209174],
              [62.912965, 27.209238],
              [62.9128, 27.209387],
              [62.912607, 27.2095],
              [62.912452, 27.209721],
              [62.912198, 27.209841],
              [62.912101, 27.209937],
              [62.91207, 27.210045],
              [62.912152, 27.210145],
              [62.912141, 27.210241],
              [62.91227, 27.210384],
              [62.912214, 27.210518],
              [62.911833, 27.210729],
              [62.91186, 27.21095],
              [62.911733, 27.211316],
              [62.911791, 27.211545],
              [62.911665, 27.211654],
              [62.911633, 27.21192],
              [62.911377, 27.212116],
              [62.911299, 27.212279],
              [62.911491, 27.212702],
              [62.911746, 27.212928],
              [62.911563, 27.21318],
              [62.911556, 27.21342],
              [62.911205, 27.213601],
              [62.911111, 27.213774],
              [62.910629, 27.21412],
              [62.910663, 27.21442],
              [62.910769, 27.214498],
              [62.910971, 27.214478],
              [62.910989, 27.214543],
              [62.910818, 27.21468],
              [62.910685, 27.214726],
              [62.91062, 27.214833],
              [62.91075, 27.214915],
              [62.910619, 27.214928],
              [62.910492, 27.214998],
              [62.910293, 27.214984],
              [62.910074, 27.215249],
              [62.909838, 27.21532],
              [62.909626, 27.215536],
              [62.909517, 27.215518],
              [62.909425, 27.215121],
              [62.909333, 27.215096],
              [62.909265, 27.21499],
              [62.909115, 27.214934],
              [62.90864, 27.215048],
              [62.908524, 27.214992],
              [62.908313, 27.215116],
              [62.907952, 27.215211],
              [62.907697, 27.215199],
              [62.907637, 27.215136],
              [62.907423, 27.215149],
              [62.907096, 27.215324],
              [62.906539, 27.215293],
              [62.90649, 27.215209],
              [62.906031, 27.215325],
              [62.905822, 27.215298],
              [62.905596, 27.215413],
              [62.90555, 27.215491],
              [62.905522, 27.215454],
              [62.905462, 27.21554],
              [62.905105, 27.215656],
              [62.905056, 27.215581],
              [62.905056, 27.215345],
              [62.904924, 27.215211],
              [62.90466, 27.215074],
              [62.904252, 27.214946],
              [62.903911, 27.214948],
              [62.903643, 27.215039],
              [62.903347, 27.214858],
              [62.902813, 27.214792],
              [62.902733, 27.214821],
              [62.902514, 27.214641],
              [62.902061, 27.214554],
              [62.902005, 27.2145],
              [62.901797, 27.214538],
              [62.90169, 27.214604],
              [62.90155, 27.214565],
              [62.901299, 27.21461],
              [62.901217, 27.214519],
              [62.901142, 27.214169],
              [62.90094, 27.21404],
              [62.900949, 27.213959],
              [62.90102, 27.213894],
              [62.90101, 27.213813],
              [62.90095, 27.21381],
              [62.900805, 27.213677],
              [62.900726, 27.213428],
              [62.900492, 27.213428],
              [62.900014, 27.213269],
              [62.89984, 27.213276],
              [62.8997, 27.213486],
              [62.899569, 27.213466],
              [62.899469, 27.213397],
              [62.898933, 27.213349],
              [62.89854, 27.213263],
              [62.898497, 27.213215],
              [62.898044, 27.21314],
              [62.897834, 27.21317],
              [62.897817, 27.213314],
              [62.897723, 27.213402],
              [62.897638, 27.213299],
              [62.897295, 27.213268],
              [62.896931, 27.213335],
              [62.896751, 27.213294],
              [62.896752, 27.213349],
              [62.896659, 27.213379],
              [62.896593, 27.213333],
              [62.89638, 27.213363],
              [62.896076, 27.213306],
              [62.895958, 27.213254],
              [62.895967, 27.213204],
              [62.895397, 27.213141],
              [62.895249, 27.213214],
              [62.894996, 27.213175],
              [62.89468, 27.213201],
              [62.894402, 27.213153],
              [62.894363, 27.213007],
              [62.894227, 27.212824],
              [62.893863, 27.212693],
              [62.89376, 27.212779],
              [62.893745, 27.212887],
              [62.893665, 27.212892],
              [62.893556, 27.212971],
              [62.893283, 27.213011],
              [62.893227, 27.213117],
              [62.893148, 27.213125],
              [62.893057, 27.213352],
              [62.892324, 27.213176],
              [62.892261, 27.213186],
              [62.89225, 27.213278],
              [62.891922, 27.213189],
              [62.891737, 27.213202],
              [62.891437, 27.213112],
              [62.890948, 27.213105],
              [62.890759, 27.213296],
              [62.890746, 27.213339],
              [62.890789, 27.213354],
              [62.890389, 27.213507],
              [62.890394, 27.213655],
              [62.890342, 27.213734],
              [62.890213, 27.213795],
              [62.890036, 27.214038],
              [62.890005, 27.214155],
              [62.889873, 27.214133],
              [62.889773, 27.214291],
              [62.889536, 27.214383],
              [62.889416, 27.214567],
              [62.88928, 27.214675],
              [62.889197, 27.214967],
              [62.889255, 27.215099],
              [62.889182, 27.21524],
              [62.889196, 27.215318],
              [62.888822, 27.215373],
              [62.888663, 27.215464],
              [62.888522, 27.21568],
              [62.888552, 27.215803],
              [62.888471, 27.216018],
              [62.888504, 27.216155],
              [62.888397, 27.216232],
              [62.888314, 27.216427],
              [62.888192, 27.216432],
              [62.888068, 27.216558],
              [62.887924, 27.216622],
              [62.887526, 27.216708],
              [62.887314, 27.216669],
              [62.887142, 27.216575],
              [62.886578, 27.216475],
              [62.886276, 27.216848],
              [62.885989, 27.216949],
              [62.885909, 27.217027],
              [62.885892, 27.217228],
              [62.88574, 27.217182],
              [62.885461, 27.217177],
              [62.885402, 27.217095],
              [62.885328, 27.217083],
              [62.885311, 27.217014],
              [62.885194, 27.217008],
              [62.885207, 27.216963],
              [62.884884, 27.216896],
              [62.884443, 27.216879],
              [62.884115, 27.216931],
              [62.883939, 27.217017],
              [62.883666, 27.217432],
              [62.883435, 27.21757],
              [62.883016, 27.218023],
              [62.882811, 27.218074],
              [62.882599, 27.218203],
              [62.882545, 27.21839],
              [62.882354, 27.218497],
              [62.882367, 27.218607],
              [62.882315, 27.21867],
              [62.882081, 27.21873],
              [62.881924, 27.218849],
              [62.88187, 27.219037],
              [62.881799, 27.219112],
              [62.882055, 27.219229],
              [62.882126, 27.219355],
              [62.882198, 27.21974],
              [62.882085, 27.22008],
              [62.882021, 27.22014],
              [62.882063, 27.220162],
              [62.882041, 27.220277],
              [62.881946, 27.220316],
              [62.882099, 27.220502],
              [62.882311, 27.220601],
              [62.882466, 27.220765],
              [62.882472, 27.220851],
              [62.882606, 27.22096],
              [62.882516, 27.221056],
              [62.88253, 27.221198],
              [62.882542, 27.221289],
              [62.882618, 27.22129],
              [62.88261, 27.221342],
              [62.882678, 27.221376],
              [62.882657, 27.22142],
              [62.882293, 27.221535],
              [62.882211, 27.221501],
              [62.882051, 27.221563],
              [62.882014, 27.221532],
              [62.88143, 27.221576],
              [62.880972, 27.221662],
              [62.880771, 27.221631],
              [62.880706, 27.221698],
              [62.880621, 27.221682],
              [62.880546, 27.22172],
              [62.880475, 27.221913],
              [62.880261, 27.222099],
              [62.880128, 27.222284],
              [62.880174, 27.222537],
              [62.879757, 27.22265],
              [62.879713, 27.222878],
              [62.879652, 27.222888],
              [62.879566, 27.223041],
              [62.879422, 27.223103],
              [62.87944, 27.223255],
              [62.879329, 27.22351],
              [62.879368, 27.223538],
              [62.879358, 27.223895],
              [62.87912, 27.223894],
              [62.878789, 27.224096],
              [62.878469, 27.224203],
              [62.878325, 27.224148],
              [62.878253, 27.224067],
              [62.878168, 27.224085],
              [62.878102, 27.224039],
              [62.877686, 27.224473],
              [62.877635, 27.22464],
              [62.877663, 27.224947],
              [62.877516, 27.225184],
              [62.877638, 27.225457],
              [62.877749, 27.225505],
              [62.877792, 27.225595],
              [62.877756, 27.225822],
              [62.87763, 27.226035],
              [62.877692, 27.226128],
              [62.877642, 27.226142],
              [62.877641, 27.226231],
              [62.877487, 27.226318],
              [62.877297, 27.226292],
              [62.877124, 27.226377],
              [62.87707, 27.226523],
              [62.876971, 27.22661],
              [62.876997, 27.226706],
              [62.876801, 27.226771],
              [62.876734, 27.227004],
              [62.876609, 27.227072],
              [62.876582, 27.227141],
              [62.876474, 27.22714],
              [62.876438, 27.227046],
              [62.876115, 27.226966],
              [62.875914, 27.227033],
              [62.875657, 27.227225],
              [62.875728, 27.227485],
              [62.875447, 27.227581],
              [62.875338, 27.2277],
              [62.875343, 27.227818],
              [62.875024, 27.227919],
              [62.874942, 27.228035],
              [62.874639, 27.22821],
              [62.874354, 27.22823],
              [62.874285, 27.22811],
              [62.873776, 27.228441],
              [62.873709, 27.228629],
              [62.873439, 27.228732],
              [62.873169, 27.228774],
              [62.873027, 27.228859],
              [62.872937, 27.228824],
              [62.872808, 27.228669],
              [62.872716, 27.228475],
              [62.872753, 27.228272],
              [62.872632, 27.228074],
              [62.872484, 27.227951],
              [62.87238, 27.227753],
              [62.872217, 27.227695],
              [62.871941, 27.227399],
              [62.871808, 27.227146],
              [62.87183, 27.227084],
              [62.871743, 27.22677],
              [62.871675, 27.226749],
              [62.871449, 27.226886],
              [62.8713, 27.226673],
              [62.871105, 27.226635],
              [62.87108, 27.226511],
              [62.870977, 27.226543],
              [62.870868, 27.226489],
              [62.870763, 27.226511],
              [62.87066, 27.226434],
              [62.870382, 27.226472],
              [62.870259, 27.226387],
              [62.869947, 27.226414],
              [62.869835, 27.226386],
              [62.869651, 27.226243],
              [62.869458, 27.226261],
              [62.869386, 27.22617],
              [62.869337, 27.226185],
              [62.869204, 27.226068],
              [62.869073, 27.226035],
              [62.869017, 27.226089],
              [62.86862, 27.226191],
              [62.868438, 27.226145],
              [62.868014, 27.226144],
              [62.867984, 27.226086],
              [62.867843, 27.226076],
              [62.867718, 27.225984],
              [62.86766, 27.225995],
              [62.867642, 27.225894],
              [62.867592, 27.225884],
              [62.867526, 27.225751],
              [62.867475, 27.225766],
              [62.867433, 27.225678],
              [62.867089, 27.225516],
              [62.867052, 27.22556],
              [62.866992, 27.225505],
              [62.866889, 27.225517],
              [62.866817, 27.225333],
              [62.866752, 27.225326],
              [62.866767, 27.225266],
              [62.866646, 27.225235],
              [62.866578, 27.225089],
              [62.866342, 27.224961],
              [62.865635, 27.224934],
              [62.865584, 27.224805],
              [62.865731, 27.224646],
              [62.86555, 27.224604],
              [62.865575, 27.224542],
              [62.865528, 27.224511],
              [62.865574, 27.224361],
              [62.865725, 27.224163],
              [62.865802, 27.223875],
              [62.865816, 27.2235],
              [62.865878, 27.223472],
              [62.865749, 27.223273],
              [62.865422, 27.223113],
              [62.865243, 27.22297],
              [62.865017, 27.222924],
              [62.864869, 27.22269],
              [62.86485, 27.222619],
              [62.864896, 27.222559],
              [62.864794, 27.222459],
              [62.864649, 27.222448],
              [62.864615, 27.222361],
              [62.864474, 27.222396],
              [62.864563, 27.222264],
              [62.864519, 27.222163],
              [62.864546, 27.222113],
              [62.864383, 27.222014],
              [62.864372, 27.221833],
              [62.864106, 27.221395],
              [62.863998, 27.221399],
              [62.863852, 27.221292],
              [62.863004, 27.221133],
              [62.862994, 27.221047],
              [62.862533, 27.220977],
              [62.862535, 27.220897],
              [62.862485, 27.220873],
              [62.862436, 27.220732],
              [62.862259, 27.220708],
              [62.862045, 27.220742],
              [62.861966, 27.220728],
              [62.861911, 27.220662],
              [62.861793, 27.220674],
              [62.861781, 27.220615],
              [62.861533, 27.2206],
              [62.861452, 27.220479],
              [62.861355, 27.220425],
              [62.861331, 27.220311],
              [62.861103, 27.220284],
              [62.861087, 27.220204],
              [62.860846, 27.220233],
              [62.860623, 27.220146],
              [62.860445, 27.22013],
              [62.860307, 27.220168],
              [62.859976, 27.220039],
              [62.859748, 27.220006],
              [62.859797, 27.219894],
              [62.859756, 27.219753],
              [62.859788, 27.219566],
              [62.859858, 27.219528],
              [62.85973, 27.219495],
              [62.859141, 27.219422],
              [62.858944, 27.219346],
              [62.858667, 27.219308],
              [62.858423, 27.21937],
              [62.85803, 27.219389],
              [62.857817, 27.219491],
              [62.85776, 27.219595],
              [62.85752, 27.219603],
              [62.85742, 27.219648],
              [62.857156, 27.21961],
              [62.856903, 27.219643],
              [62.856947, 27.219596],
              [62.856476, 27.219374],
              [62.856311, 27.219209],
              [62.85603, 27.219103],
              [62.856004, 27.218991],
              [62.85588, 27.218922],
              [62.855808, 27.218799],
              [62.855751, 27.218798],
              [62.855641, 27.21867],
              [62.855571, 27.218348],
              [62.855387, 27.218216],
              [62.855411, 27.218131],
              [62.855362, 27.218079],
              [62.855368, 27.21797],
              [62.85542, 27.217889],
              [62.855343, 27.217784],
              [62.855269, 27.217783],
              [62.855183, 27.217655],
              [62.8551, 27.217646],
              [62.854966, 27.217429],
              [62.854908, 27.217427],
              [62.854885, 27.217327],
              [62.854936, 27.217278],
              [62.854795, 27.217202],
              [62.85455, 27.216813],
              [62.85445, 27.216824],
              [62.854273, 27.216732],
              [62.854288, 27.216673],
              [62.854239, 27.216641],
              [62.85412, 27.216651],
              [62.854038, 27.216593],
              [62.853423, 27.216692],
              [62.85325, 27.216595],
              [62.853223, 27.216534],
              [62.852957, 27.216444],
              [62.852469, 27.216507],
              [62.852438, 27.216445],
              [62.852373, 27.216435],
              [62.85208, 27.216455],
              [62.85203, 27.216289],
              [62.851761, 27.216163],
              [62.851698, 27.216177],
              [62.85167, 27.216102],
              [62.851586, 27.216114],
              [62.851504, 27.21601],
              [62.851329, 27.216028],
              [62.851177, 27.215997],
              [62.851141, 27.215945],
              [62.851034, 27.215948],
              [62.850829, 27.21603],
              [62.850606, 27.21599],
              [62.8505, 27.216061],
              [62.850262, 27.216104],
              [62.850162, 27.216284],
              [62.85001, 27.216319],
              [62.849707, 27.21653],
              [62.849175, 27.216809],
              [62.849075, 27.216754],
              [62.848861, 27.216762],
              [62.848812, 27.21672],
              [62.848701, 27.21674],
              [62.848627, 27.216705],
              [62.848421, 27.216871],
              [62.848173, 27.216801],
              [62.848027, 27.216841],
              [62.847959, 27.2168],
              [62.847857, 27.216834],
              [62.847487, 27.216805],
              [62.847107, 27.217002],
              [62.846629, 27.217076],
              [62.846546, 27.217026],
              [62.846475, 27.217059],
              [62.846441, 27.216957],
              [62.84631, 27.216949],
              [62.845953, 27.216756],
              [62.845701, 27.216936],
              [62.84564, 27.21711],
              [62.845315, 27.217206],
              [62.845258, 27.21731],
              [62.845278, 27.217633],
              [62.845179, 27.217703],
              [62.845048, 27.217648],
              [62.844816, 27.217737],
              [62.844723, 27.217833],
              [62.844608, 27.217826],
              [62.844436, 27.218124],
              [62.844187, 27.218164],
              [62.844137, 27.218273],
              [62.843453, 27.218375],
              [62.843408, 27.2184],
              [62.843409, 27.218571],
              [62.843174, 27.218489],
              [62.843058, 27.218355],
              [62.843076, 27.218318],
              [62.842842, 27.218186],
              [62.842719, 27.218244],
              [62.842341, 27.218274],
              [62.842164, 27.218213],
              [62.841961, 27.218356],
              [62.841888, 27.218328],
              [62.841834, 27.218355],
              [62.841676, 27.218268],
              [62.841578, 27.218276],
              [62.841536, 27.218162],
              [62.841434, 27.218144],
              [62.841354, 27.218071],
              [62.841179, 27.218032],
              [62.840908, 27.218067],
              [62.840808, 27.218034],
              [62.840597, 27.218055],
              [62.840657, 27.218196],
              [62.840631, 27.218465],
              [62.84047, 27.218454],
              [62.840407, 27.218668],
              [62.840029, 27.218449],
              [62.84008, 27.218318],
              [62.839966, 27.21817],
              [62.839959, 27.217939],
              [62.839442, 27.217734],
              [62.839318, 27.217722],
              [62.839325, 27.217628],
              [62.839151, 27.21764],
              [62.839041, 27.217309],
              [62.83856, 27.217122],
              [62.838216, 27.216923],
              [62.838154, 27.216953],
              [62.838121, 27.217057],
              [62.837989, 27.217067],
              [62.837949, 27.217241],
              [62.837739, 27.217435],
              [62.837377, 27.217364],
              [62.837077, 27.217429],
              [62.836912, 27.2174],
              [62.836731, 27.217436],
              [62.836645, 27.217508],
              [62.836501, 27.217768],
              [62.836388, 27.217812],
              [62.836285, 27.217757],
              [62.836002, 27.217716],
              [62.83482, 27.217193],
              [62.834716, 27.217199],
              [62.834534, 27.217029],
              [62.834267, 27.217047],
              [62.833949, 27.217158],
              [62.833706, 27.217043],
              [62.833521, 27.217364],
              [62.833364, 27.217528],
              [62.833251, 27.217415],
              [62.833116, 27.217369],
              [62.833038, 27.217484],
              [62.832731, 27.217565],
              [62.832644, 27.217633],
              [62.832668, 27.217791],
              [62.832633, 27.217822],
              [62.832268, 27.217735],
              [62.832185, 27.217752],
              [62.832163, 27.217802],
              [62.832096, 27.217755],
              [62.831605, 27.217814],
              [62.831488, 27.218145],
              [62.831501, 27.21838],
              [62.831311, 27.218634],
              [62.831053, 27.218767],
              [62.830508, 27.218802],
              [62.830273, 27.21893],
              [62.829586, 27.218576],
              [62.829489, 27.218656],
              [62.829435, 27.21865],
              [62.829351, 27.21854],
              [62.829052, 27.218422],
              [62.828796, 27.218416],
              [62.828739, 27.218635],
              [62.828783, 27.218754],
              [62.828697, 27.218756],
              [62.828624, 27.219005],
              [62.828229, 27.218917],
              [62.828078, 27.21899],
              [62.827284, 27.219184],
              [62.827062, 27.219104],
              [62.827033, 27.219048],
              [62.826477, 27.219045],
              [62.826292, 27.219008],
              [62.826022, 27.219115],
              [62.825713, 27.219167],
              [62.825527, 27.219326],
              [62.825488, 27.219316],
              [62.825503, 27.219235],
              [62.825118, 27.219388],
              [62.825081, 27.219346],
              [62.824988, 27.219394],
              [62.824865, 27.219378],
              [62.824835, 27.219563],
              [62.824711, 27.219685],
              [62.824618, 27.219637],
              [62.824508, 27.219648],
              [62.824543, 27.219608],
              [62.824503, 27.219583],
              [62.824133, 27.219465],
              [62.824127, 27.219373],
              [62.824024, 27.21935],
              [62.823983, 27.219253],
              [62.823777, 27.219263],
              [62.823708, 27.219183],
              [62.823568, 27.219213],
              [62.823607, 27.219109],
              [62.823562, 27.219044],
              [62.823339, 27.218958],
              [62.823325, 27.218885],
              [62.823068, 27.21889],
              [62.822616, 27.218703],
              [62.822517, 27.218598],
              [62.822134, 27.218524],
              [62.821877, 27.218349],
              [62.821754, 27.218411],
              [62.821409, 27.218373],
              [62.821313, 27.218438],
              [62.821108, 27.218471],
              [62.820731, 27.218458],
              [62.820704, 27.218555],
              [62.820559, 27.218665],
              [62.820482, 27.218853],
              [62.820521, 27.21901],
              [62.820296, 27.219137],
              [62.820322, 27.219202],
              [62.82028, 27.21937],
              [62.82008, 27.219715],
              [62.819565, 27.219598],
              [62.819501, 27.219641],
              [62.819356, 27.219574],
              [62.819295, 27.219624],
              [62.819035, 27.219595],
              [62.81895, 27.219704],
              [62.818693, 27.219765],
              [62.818569, 27.220039],
              [62.818362, 27.220169],
              [62.818024, 27.220218],
              [62.817944, 27.220295],
              [62.817736, 27.220349],
              [62.817698, 27.22051],
              [62.817532, 27.220577],
              [62.817422, 27.220826],
              [62.817175, 27.220819],
              [62.816901, 27.220908],
              [62.816668, 27.221135],
              [62.816682, 27.221215],
              [62.816605, 27.221314],
              [62.816429, 27.221371],
              [62.816199, 27.221345],
              [62.816024, 27.221427],
              [62.815935, 27.221555],
              [62.815766, 27.221464],
              [62.815753, 27.221551],
              [62.815656, 27.22154],
              [62.815392, 27.221639],
              [62.815079, 27.221865],
              [62.815049, 27.222206],
              [62.81496, 27.222221],
              [62.814807, 27.222342],
              [62.814695, 27.222335],
              [62.814363, 27.222424],
              [62.813845, 27.222436],
              [62.813405, 27.222615],
              [62.81346, 27.222704],
              [62.813402, 27.222746],
              [62.813159, 27.222777],
              [62.813004, 27.222901],
              [62.812778, 27.222882],
              [62.812598, 27.223099],
              [62.812076, 27.223107],
              [62.812026, 27.223116],
              [62.812027, 27.223188],
              [62.811844, 27.223151],
              [62.811744, 27.22324],
              [62.811715, 27.223397],
              [62.811622, 27.223436],
              [62.811459, 27.223618],
              [62.811264, 27.223717],
              [62.811258, 27.223757],
              [62.811383, 27.223742],
              [62.811203, 27.223891],
              [62.811015, 27.22391],
              [62.810723, 27.224169],
              [62.81069, 27.224254],
              [62.810727, 27.224364],
              [62.810974, 27.224842],
              [62.810369, 27.225245],
              [62.810288, 27.225382],
              [62.810086, 27.225484],
              [62.810094, 27.225529],
              [62.810006, 27.225548],
              [62.809919, 27.225682],
              [62.810009, 27.225953],
              [62.810112, 27.225963],
              [62.809955, 27.226126],
              [62.810014, 27.226306],
              [62.809874, 27.226351],
              [62.809782, 27.226574],
              [62.809646, 27.226658],
              [62.809617, 27.226859],
              [62.809747, 27.227028],
              [62.809602, 27.227195],
              [62.809703, 27.227298],
              [62.809667, 27.227428],
              [62.809385, 27.227557],
              [62.80863, 27.228375],
              [62.808507, 27.228423],
              [62.808214, 27.228443],
              [62.808184, 27.228506],
              [62.808103, 27.228497],
              [62.808055, 27.22864],
              [62.807974, 27.228719],
              [62.80764, 27.228932],
              [62.807574, 27.229178],
              [62.807615, 27.229186],
              [62.807632, 27.229346],
              [62.807707, 27.229463],
              [62.807924, 27.229612],
              [62.807765, 27.229811],
              [62.807682, 27.229838],
              [62.807657, 27.229901],
              [62.807557, 27.229922],
              [62.807524, 27.229982],
              [62.807562, 27.23009],
              [62.807652, 27.230168],
              [62.807502, 27.2302],
              [62.807361, 27.230307],
              [62.807143, 27.230243],
              [62.807046, 27.230321],
              [62.806905, 27.230317],
              [62.806805, 27.230562],
              [62.806725, 27.230513],
              [62.806569, 27.230567],
              [62.806519, 27.230634],
              [62.805635, 27.23049],
              [62.805537, 27.230501],
              [62.80545, 27.230589],
              [62.805141, 27.230738],
              [62.804982, 27.231091],
              [62.805065, 27.231133],
              [62.805082, 27.231328],
              [62.805165, 27.231423],
              [62.805192, 27.23176],
              [62.805001, 27.232033],
              [62.805035, 27.232121],
              [62.804941, 27.232357],
              [62.804805, 27.232508],
              [62.804697, 27.232483],
              [62.804528, 27.232536],
              [62.804529, 27.23261],
              [62.804698, 27.232747],
              [62.804336, 27.232786],
              [62.804312, 27.23285],
              [62.80413, 27.232895],
              [62.80405, 27.23299],
              [62.803713, 27.233041],
              [62.803628, 27.233004],
              [62.803453, 27.23302],
              [62.803237, 27.233112],
              [62.803213, 27.23321],
              [62.803308, 27.233313],
              [62.803307, 27.233408],
              [62.803477, 27.233561],
              [62.803415, 27.233664],
              [62.803433, 27.233975],
              [62.80353, 27.23413],
              [62.803612, 27.234133],
              [62.803676, 27.234259],
              [62.803756, 27.234295],
              [62.803761, 27.234428],
              [62.803405, 27.234458],
              [62.80331, 27.234558],
              [62.803035, 27.234641],
              [62.803002, 27.234691],
              [62.802766, 27.234785],
              [62.802703, 27.234879],
              [62.802393, 27.23497],
              [62.80215, 27.234923],
              [62.802053, 27.234954],
              [62.801853, 27.235089],
              [62.801819, 27.235247],
              [62.801638, 27.235397],
              [62.801357, 27.235396],
              [62.801197, 27.235322],
              [62.800908, 27.235392],
              [62.800921, 27.235168],
              [62.800977, 27.235104],
              [62.800903, 27.234934],
              [62.800632, 27.23488],
              [62.800542, 27.23479],
              [62.800381, 27.23473],
              [62.800155, 27.234509],
              [62.799975, 27.234517],
              [62.79995, 27.234466],
              [62.799783, 27.234464],
              [62.799543, 27.234392],
              [62.799461, 27.234525],
              [62.799146, 27.234539],
              [62.799008, 27.234705],
              [62.798872, 27.234774],
              [62.79913, 27.234985],
              [62.799126, 27.235259],
              [62.799026, 27.235673],
              [62.799241, 27.23576],
              [62.799597, 27.236039],
              [62.799726, 27.236208],
              [62.800097, 27.236509],
              [62.800082, 27.236557],
              [62.800302, 27.236639],
              [62.80035, 27.236708],
              [62.800352, 27.236862],
              [62.800509, 27.236948],
              [62.800519, 27.237148],
              [62.800395, 27.237247],
              [62.800446, 27.237341],
              [62.800451, 27.237538],
              [62.800591, 27.23762],
              [62.800413, 27.23795],
              [62.80007, 27.237832],
              [62.800006, 27.237772],
              [62.799958, 27.237837],
              [62.799744, 27.23777],
              [62.799545, 27.237783],
              [62.799508, 27.237827],
              [62.79961, 27.237935],
              [62.799635, 27.238175],
              [62.799439, 27.238326],
              [62.799467, 27.238436],
              [62.799608, 27.238596],
              [62.799564, 27.238823],
              [62.799498, 27.238922],
              [62.799124, 27.239058],
              [62.799142, 27.2391],
              [62.799032, 27.23917],
              [62.7988, 27.239245],
              [62.798749, 27.239298],
              [62.798812, 27.239488],
              [62.798684, 27.239693],
              [62.798546, 27.239711],
              [62.798199, 27.239892],
              [62.798121, 27.239894],
              [62.797925, 27.239711],
              [62.797611, 27.239776],
              [62.79754, 27.239876],
              [62.797611, 27.239955],
              [62.797561, 27.240076],
              [62.79761, 27.240149],
              [62.797271, 27.24032],
              [62.797243, 27.240389],
              [62.797149, 27.240419],
              [62.797063, 27.240586],
              [62.796741, 27.240832],
              [62.796364, 27.240738],
              [62.796249, 27.240787],
              [62.796053, 27.240648],
              [62.79599, 27.240681],
              [62.795957, 27.240609],
              [62.795832, 27.240616],
              [62.795894, 27.2408],
              [62.7958, 27.240894],
              [62.795812, 27.240933],
              [62.796234, 27.241168],
              [62.796471, 27.241741],
              [62.796588, 27.241865],
              [62.796357, 27.24208],
              [62.796338, 27.242188],
              [62.796251, 27.242256],
              [62.796269, 27.242312],
              [62.796174, 27.242334],
              [62.796198, 27.242624],
              [62.796261, 27.242647],
              [62.795975, 27.242973],
              [62.795927, 27.243227],
              [62.795856, 27.243294],
              [62.79591, 27.243467],
              [62.79576, 27.243706],
              [62.79538, 27.243954],
              [62.795407, 27.244192],
              [62.795157, 27.244472],
              [62.79495, 27.244481],
              [62.794764, 27.24456],
              [62.794702, 27.244607],
              [62.794605, 27.244846],
              [62.794489, 27.244878],
              [62.793987, 27.24489],
              [62.793641, 27.244954],
              [62.79361, 27.244867],
              [62.793514, 27.244842],
              [62.79352, 27.244777],
              [62.793431, 27.244732],
              [62.793102, 27.244769],
              [62.793023, 27.244821],
              [62.79306, 27.24488],
              [62.792937, 27.244971],
              [62.792714, 27.245264],
              [62.792717, 27.245334],
              [62.792604, 27.245368],
              [62.792576, 27.245437],
              [62.792528, 27.245415],
              [62.792342, 27.245487],
              [62.792234, 27.245631],
              [62.791747, 27.245608],
              [62.791667, 27.245658],
              [62.791545, 27.245613],
              [62.791026, 27.245688],
              [62.790752, 27.245754],
              [62.790633, 27.245896],
              [62.790459, 27.245941],
              [62.790301, 27.245872],
              [62.789494, 27.245802],
              [62.789408, 27.245882],
              [62.789082, 27.245987],
              [62.788811, 27.245964],
              [62.788687, 27.246074],
              [62.788636, 27.24619],
              [62.788113, 27.246598],
              [62.788153, 27.246712],
              [62.788004, 27.246915],
              [62.787995, 27.247069],
              [62.787864, 27.247104],
              [62.787718, 27.247076],
              [62.787588, 27.24763],
              [62.787339, 27.248004],
              [62.78729, 27.2482],
              [62.786641, 27.248786],
              [62.786434, 27.248854],
              [62.786307, 27.248997],
              [62.7863, 27.249369],
              [62.786432, 27.249651],
              [62.786385, 27.249742],
              [62.786417, 27.249823],
              [62.786365, 27.249925],
              [62.786375, 27.250055],
              [62.78633, 27.250043],
              [62.786291, 27.25074],
              [62.786065, 27.250772],
              [62.785783, 27.250929],
              [62.785758, 27.251001],
              [62.78562, 27.25105],
              [62.785386, 27.251345],
              [62.785297, 27.251381],
              [62.785151, 27.251676],
              [62.784953, 27.251773],
              [62.784838, 27.251957],
              [62.784676, 27.251996],
              [62.784665, 27.252317],
              [62.784482, 27.252558],
              [62.784484, 27.252677],
              [62.784315, 27.253174],
              [62.783963, 27.253147],
              [62.783914, 27.25326],
              [62.783728, 27.253322],
              [62.783002, 27.253212],
              [62.782884, 27.253261],
              [62.782898, 27.253309],
              [62.782599, 27.253358],
              [62.782267, 27.253288],
              [62.78212, 27.2533],
              [62.781437, 27.253029],
              [62.781008, 27.253143],
              [62.780787, 27.253139],
              [62.780607, 27.253081],
              [62.780527, 27.252886],
              [62.780434, 27.252918],
              [62.780183, 27.252903],
              [62.780254, 27.253092],
              [62.77981, 27.253198],
              [62.779488, 27.253094],
              [62.779488, 27.252938],
              [62.77909, 27.252935],
              [62.778786, 27.252842],
              [62.77869, 27.252744],
              [62.778292, 27.252721],
              [62.778212, 27.25273],
              [62.778163, 27.252978],
              [62.778, 27.253237],
              [62.777806, 27.253206],
              [62.777759, 27.253254],
              [62.777529, 27.25318],
              [62.777317, 27.253253],
              [62.776993, 27.253186],
              [62.77679, 27.253208],
              [62.776645, 27.253083],
              [62.775572, 27.252896],
              [62.775662, 27.253155],
              [62.775614, 27.253679],
              [62.77566, 27.253895],
              [62.775539, 27.254084],
              [62.775236, 27.254308],
              [62.775284, 27.254388],
              [62.77526, 27.254479],
              [62.775326, 27.25451],
              [62.775601, 27.255129],
              [62.775583, 27.255569],
              [62.775786, 27.2556],
              [62.776172, 27.255563],
              [62.776202, 27.256082],
              [62.776018, 27.256285],
              [62.776169, 27.256345],
              [62.776161, 27.256658],
              [62.776483, 27.256982],
              [62.776692, 27.257097],
              [62.776705, 27.257175],
              [62.776826, 27.257276],
              [62.776615, 27.257509],
              [62.776544, 27.257656],
              [62.776634, 27.257804],
              [62.776567, 27.257829],
              [62.776564, 27.257984],
              [62.776304, 27.258066],
              [62.776143, 27.258175],
              [62.774933, 27.258325],
              [62.774976, 27.25865],
              [62.775181, 27.258996],
              [62.775253, 27.259302],
              [62.775166, 27.25938],
              [62.775235, 27.259595],
              [62.775186, 27.259788],
              [62.775284, 27.259802],
              [62.775278, 27.26001],
              [62.775375, 27.260076],
              [62.775419, 27.26023],
              [62.775583, 27.26029],
              [62.77559, 27.260364],
              [62.775878, 27.260324],
              [62.776179, 27.260416],
              [62.776478, 27.260353],
              [62.776623, 27.260244],
              [62.777019, 27.260249],
              [62.777266, 27.260112],
              [62.778015, 27.260049],
              [62.778195, 27.259966],
              [62.77873, 27.260036],
              [62.778922, 27.259835],
              [62.779015, 27.259817],
              [62.77906, 27.259759],
              [62.779474, 27.259741],
              [62.779589, 27.25968],
              [62.77975, 27.259672],
              [62.779779, 27.259615],
              [62.780636, 27.2596],
              [62.780828, 27.259522],
              [62.781304, 27.259484],
              [62.781363, 27.259634],
              [62.781606, 27.259627],
              [62.781748, 27.25967],
              [62.782212, 27.259619],
              [62.782694, 27.259708],
              [62.78274, 27.259645],
              [62.782853, 27.259634],
              [62.782827, 27.259761],
              [62.783198, 27.25986],
              [62.783246, 27.260073],
              [62.783515, 27.259839],
              [62.783853, 27.259802],
              [62.783981, 27.259726],
              [62.784124, 27.25971],
              [62.784301, 27.259567],
              [62.784565, 27.259604],
              [62.78454, 27.259701],
              [62.784572, 27.259712],
              [62.784836, 27.259728],
              [62.784968, 27.259682],
              [62.784993, 27.259743],
              [62.785094, 27.259724],
              [62.785193, 27.259889],
              [62.785522, 27.259899],
              [62.785632, 27.259763],
              [62.786161, 27.25964],
              [62.786622, 27.259652],
              [62.786742, 27.259749],
              [62.787067, 27.259877],
              [62.787345, 27.259759],
              [62.787501, 27.259742],
              [62.787612, 27.259762],
              [62.787581, 27.259832],
              [62.787679, 27.259924],
              [62.787844, 27.259934],
              [62.788283, 27.260111],
              [62.788702, 27.260079],
              [62.788772, 27.26014],
              [62.788871, 27.260078],
              [62.78907, 27.260162],
              [62.789232, 27.260156],
              [62.78928, 27.260118],
              [62.789614, 27.260337],
              [62.789809, 27.260338],
              [62.790124, 27.260536],
              [62.790239, 27.260578],
              [62.790353, 27.26056],
              [62.79025, 27.260736],
              [62.790474, 27.260735],
              [62.790642, 27.260825],
              [62.790962, 27.260863],
              [62.791142, 27.261148],
              [62.791422, 27.26126],
              [62.791808, 27.26128],
              [62.792092, 27.261367],
              [62.792496, 27.261395],
              [62.793328, 27.261304],
              [62.793634, 27.261195],
              [62.793963, 27.261195],
              [62.79407, 27.261226],
              [62.794167, 27.261426],
              [62.794344, 27.261473],
              [62.794517, 27.261512],
              [62.794775, 27.261482],
              [62.795178, 27.261515],
              [62.795327, 27.261588],
              [62.795472, 27.261567],
              [62.795558, 27.261621],
              [62.795622, 27.261745],
              [62.796102, 27.261728],
              [62.796236, 27.261804],
              [62.796799, 27.261835],
              [62.796973, 27.261901],
              [62.797049, 27.261978],
              [62.797257, 27.261947],
              [62.797338, 27.261866],
              [62.797601, 27.261911],
              [62.797679, 27.261883],
              [62.797967, 27.261922],
              [62.798175, 27.261876],
              [62.798291, 27.261912],
              [62.798409, 27.261886],
              [62.79856, 27.261769],
              [62.798934, 27.26178],
              [62.799186, 27.261852],
              [62.799483, 27.262066],
              [62.799704, 27.262039],
              [62.800045, 27.262127],
              [62.800112, 27.262164],
              [62.800087, 27.262234],
              [62.800407, 27.26233],
              [62.800578, 27.262522],
              [62.800866, 27.262594],
              [62.800943, 27.262561],
              [62.801209, 27.26263],
              [62.801484, 27.262625],
              [62.801985, 27.262838],
              [62.80227, 27.262872],
              [62.802553, 27.262967],
              [62.802959, 27.262973],
              [62.803808, 27.263134],
              [62.804119, 27.263125],
              [62.804207, 27.263197],
              [62.804956, 27.263191],
              [62.805043, 27.263136],
              [62.805568, 27.263059],
              [62.805844, 27.26317],
              [62.805978, 27.263171],
              [62.806455, 27.262995],
              [62.806688, 27.263042],
              [62.806895, 27.263116],
              [62.806896, 27.263167],
              [62.807103, 27.263328],
              [62.807142, 27.263516],
              [62.807393, 27.263565],
              [62.807543, 27.26367],
              [62.807648, 27.263672],
              [62.807693, 27.263856],
              [62.808287, 27.263985],
              [62.808199, 27.264035],
              [62.808679, 27.264142],
              [62.80882, 27.264235],
              [62.808998, 27.264669],
              [62.808947, 27.265612],
              [62.808886, 27.265704],
              [62.808838, 27.265957],
              [62.808627, 27.266025],
              [62.808606, 27.266089],
              [62.808479, 27.266147],
              [62.808475, 27.266419],
              [62.808281, 27.266531],
              [62.808265, 27.266662],
              [62.808126, 27.266732],
              [62.808445, 27.267193],
              [62.808874, 27.267361],
              [62.808979, 27.2675],
              [62.809155, 27.267585],
              [62.809231, 27.26768],
              [62.809185, 27.26776],
              [62.809294, 27.267899],
              [62.809242, 27.267952],
              [62.80943, 27.26811],
              [62.809458, 27.268363],
              [62.809659, 27.268525],
              [62.809618, 27.26858],
              [62.809673, 27.268616],
              [62.809458, 27.268682],
              [62.809376, 27.268807],
              [62.809133, 27.268894],
              [62.809001, 27.269037],
              [62.808968, 27.269281],
              [62.808742, 27.269651],
              [62.808924, 27.269763],
              [62.808813, 27.269813],
              [62.80885, 27.27014],
              [62.8086, 27.270193],
              [62.808528, 27.270407],
              [62.808835, 27.271001],
              [62.809418, 27.271361],
              [62.809347, 27.271487],
              [62.809115, 27.271681],
              [62.809104, 27.271773],
              [62.809177, 27.271928],
              [62.809124, 27.272025],
              [62.809262, 27.272133],
              [62.809352, 27.2723],
              [62.809312, 27.272698],
              [62.809698, 27.272724],
              [62.810009, 27.273002],
              [62.81022, 27.273074],
              [62.810516, 27.273286],
              [62.811036, 27.273774],
              [62.811104, 27.273879],
              [62.811071, 27.273907],
              [62.811126, 27.274324],
              [62.811199, 27.274373],
              [62.811129, 27.274623],
              [62.81117, 27.274765],
              [62.811303, 27.27484],
              [62.811606, 27.274916],
              [62.811895, 27.274918],
              [62.812205, 27.275068],
              [62.813024, 27.275145],
              [62.81307, 27.275218],
              [62.813684, 27.275176],
              [62.813964, 27.275197],
              [62.814186, 27.275236],
              [62.814317, 27.275411],
              [62.814522, 27.275375],
              [62.814308, 27.275662],
              [62.81424, 27.275694],
              [62.814165, 27.276126],
              [62.813993, 27.276328],
              [62.814059, 27.276546],
              [62.814029, 27.276678],
              [62.814713, 27.276638],
              [62.814777, 27.276847],
              [62.814894, 27.276916],
              [62.814862, 27.27695],
              [62.814928, 27.277118],
              [62.81492, 27.277313],
              [62.814754, 27.277679],
              [62.814776, 27.277743],
              [62.814852, 27.277757],
              [62.814729, 27.27794],
              [62.81463, 27.277993],
              [62.814635, 27.278138],
              [62.814781, 27.278313],
              [62.815502, 27.278569],
              [62.815843, 27.27856],
              [62.815969, 27.278515],
              [62.816105, 27.27857],
              [62.816264, 27.278449],
              [62.816633, 27.278301],
              [62.817037, 27.278224],
              [62.817163, 27.278618],
              [62.81707, 27.27882],
              [62.817166, 27.278954],
              [62.817133, 27.279179],
              [62.817264, 27.279276],
              [62.81728, 27.279373],
              [62.817157, 27.279705],
              [62.817072, 27.279802],
              [62.81707, 27.279946],
              [62.816952, 27.280012],
              [62.81682, 27.280187],
              [62.816687, 27.280584],
              [62.816606, 27.280668],
              [62.816383, 27.280751],
              [62.816023, 27.280801],
              [62.815964, 27.280943],
              [62.815747, 27.281019],
              [62.815683, 27.281084],
              [62.815709, 27.28127],
              [62.815618, 27.281524],
              [62.815354, 27.281827],
              [62.815233, 27.281882],
              [62.81517, 27.282056],
              [62.81504, 27.282178],
              [62.814252, 27.282384],
              [62.814095, 27.282467],
              [62.814011, 27.282589],
              [62.813988, 27.282902],
              [62.813915, 27.283035],
              [62.813957, 27.28312],
              [62.813706, 27.283203],
              [62.813606, 27.2833],
              [62.813607, 27.283533],
              [62.813507, 27.283643],
              [62.813471, 27.283843],
              [62.813473, 27.284442],
              [62.813516, 27.284746],
              [62.813597, 27.284799],
              [62.813592, 27.284994],
              [62.813682, 27.285401],
              [62.813669, 27.285622],
              [62.813798, 27.285906],
              [62.814052, 27.28593],
              [62.813958, 27.286113],
              [62.813976, 27.286187],
              [62.814128, 27.286327],
              [62.814273, 27.286983],
              [62.814448, 27.287021],
              [62.814833, 27.287672],
              [62.815386, 27.287538],
              [62.815473, 27.287463],
              [62.815641, 27.287427],
              [62.816178, 27.288111],
              [62.816455, 27.287999],
              [62.816611, 27.288201],
              [62.816763, 27.288262],
              [62.817104, 27.288135],
              [62.817387, 27.288309],
              [62.818092, 27.288496],
              [62.818109, 27.28857],
              [62.818222, 27.288636],
              [62.818147, 27.288729],
              [62.818142, 27.288907],
              [62.81797, 27.288928],
              [62.817878, 27.289026],
              [62.817915, 27.289122],
              [62.817681, 27.289292],
              [62.817487, 27.289369],
              [62.817541, 27.289827],
              [62.817476, 27.289921],
              [62.817281, 27.290023],
              [62.816995, 27.290449],
              [62.816785, 27.29058],
              [62.816731, 27.290702],
              [62.816814, 27.290902],
              [62.816993, 27.291061],
              [62.817152, 27.291096],
              [62.817526, 27.291303],
              [62.817569, 27.291588],
              [62.817452, 27.291738],
              [62.817567, 27.291947],
              [62.817466, 27.292026],
              [62.817663, 27.292244],
              [62.817403, 27.292397],
              [62.817324, 27.292387],
              [62.81712, 27.292469],
              [62.817084, 27.292573],
              [62.816963, 27.292658],
              [62.816699, 27.292762],
              [62.816622, 27.292848],
              [62.816741, 27.292938],
              [62.816789, 27.293141],
              [62.816675, 27.293269],
              [62.816855, 27.293391],
              [62.81692, 27.293512],
              [62.817098, 27.293656],
              [62.817047, 27.293803],
              [62.817226, 27.293891],
              [62.817169, 27.293999],
              [62.817202, 27.294201],
              [62.817631, 27.294304],
              [62.817934, 27.29429],
              [62.818012, 27.29439],
              [62.818125, 27.294409],
              [62.818507, 27.294302],
              [62.818699, 27.294486],
              [62.818948, 27.294561],
              [62.819, 27.294751],
              [62.81937, 27.294915],
              [62.820464, 27.294656],
              [62.820685, 27.294761],
              [62.820729, 27.294899],
              [62.820847, 27.294879],
              [62.820981, 27.295016],
              [62.821078, 27.295207],
              [62.821116, 27.295659],
              [62.821259, 27.295669],
              [62.821386, 27.295595],
              [62.821766, 27.295644],
              [62.821889, 27.29583],
              [62.822257, 27.295844],
              [62.822185, 27.295967],
              [62.822386, 27.296677],
              [62.822529, 27.2969],
              [62.822585, 27.297214],
              [62.822712, 27.297321],
              [62.822812, 27.297317],
              [62.822933, 27.297388],
              [62.823101, 27.297899],
              [62.823059, 27.298072],
              [62.823786, 27.298155],
              [62.82381, 27.298197],
              [62.824083, 27.298282],
              [62.824135, 27.298382],
              [62.824265, 27.298426],
              [62.824451, 27.298602],
              [62.824446, 27.298719],
              [62.824626, 27.298825],
              [62.824803, 27.299191],
              [62.824594, 27.299237],
              [62.824591, 27.299315],
              [62.824462, 27.299396],
              [62.824394, 27.299518],
              [62.824008, 27.299579],
              [62.823744, 27.299942],
              [62.8236, 27.300325],
              [62.823408, 27.300489],
              [62.823491, 27.300595],
              [62.82336, 27.300652],
              [62.823335, 27.300747],
              [62.823405, 27.300886],
              [62.823117, 27.300951],
              [62.822849, 27.300933],
              [62.822682, 27.301002],
              [62.822514, 27.301253],
              [62.822324, 27.301367],
              [62.822361, 27.301566],
              [62.821693, 27.301737],
              [62.821845, 27.302485],
              [62.822264, 27.303248],
              [62.822247, 27.303526],
              [62.822174, 27.303596],
              [62.822439, 27.303682],
              [62.822538, 27.303795],
              [62.822601, 27.304182],
              [62.82285, 27.304472],
              [62.822793, 27.304792],
              [62.823132, 27.304868],
              [62.82336, 27.304977],
              [62.823418, 27.305162],
              [62.823505, 27.305258],
              [62.823754, 27.305306],
              [62.823872, 27.305404],
              [62.823929, 27.305571],
              [62.82388, 27.305848],
              [62.824355, 27.305936],
              [62.82507, 27.306667],
              [62.825205, 27.306872],
              [62.825166, 27.30712],
              [62.82464, 27.307657],
              [62.824659, 27.3078],
              [62.825369, 27.308251],
              [62.825465, 27.308701],
              [62.82581, 27.308926],
              [62.825991, 27.309156],
              [62.826224, 27.309636],
              [62.826318, 27.309987],
              [62.82601, 27.310042],
              [62.825939, 27.310015],
              [62.825516, 27.310105],
              [62.825283, 27.310234],
              [62.824989, 27.310209],
              [62.824849, 27.310367],
              [62.824379, 27.310544],
              [62.824245, 27.310847],
              [62.824047, 27.310987],
              [62.823857, 27.310977],
              [62.823645, 27.31107],
              [62.823338, 27.31107],
              [62.822854, 27.311237],
              [62.822292, 27.311194],
              [62.821948, 27.311281],
              [62.821557, 27.311231],
              [62.821369, 27.311442],
              [62.821026, 27.311545],
              [62.820314, 27.311465],
              [62.820095, 27.311485],
              [62.819901, 27.311397],
              [62.819424, 27.311394],
              [62.819341, 27.311457],
              [62.819324, 27.311566],
              [62.819151, 27.311677],
              [62.818878, 27.311679],
              [62.8186, 27.311754],
              [62.818353, 27.311764],
              [62.818147, 27.311915],
              [62.818012, 27.311876],
              [62.817794, 27.311948],
              [62.817667, 27.312141],
              [62.817582, 27.312544],
              [62.81746, 27.312808],
              [62.817114, 27.313083],
              [62.817317, 27.313119],
              [62.817281, 27.313132],
              [62.817514, 27.313659],
              [62.817511, 27.313859],
              [62.817451, 27.313989],
              [62.817628, 27.314033],
              [62.817569, 27.314166],
              [62.817586, 27.314238],
              [62.817728, 27.314348],
              [62.818049, 27.314365],
              [62.818089, 27.31441],
              [62.817968, 27.314526],
              [62.81815, 27.314667],
              [62.818144, 27.314734],
              [62.81799, 27.315016],
              [62.818038, 27.315258],
              [62.817984, 27.315354],
              [62.817897, 27.315396],
              [62.817694, 27.315363],
              [62.817739, 27.315523],
              [62.817822, 27.315597],
              [62.817669, 27.315639],
              [62.817809, 27.315834],
              [62.817696, 27.316074],
              [62.817521, 27.31611],
              [62.817525, 27.316156],
              [62.817328, 27.316241],
              [62.81734, 27.316369],
              [62.817286, 27.316505],
              [62.816998, 27.3166],
              [62.816496, 27.316643],
              [62.816363, 27.316615],
              [62.816092, 27.31666],
              [62.815986, 27.316656],
              [62.815863, 27.316576],
              [62.815317, 27.316509],
              [62.814847, 27.316642],
              [62.814529, 27.316565],
              [62.814187, 27.316571],
              [62.814156, 27.316652],
              [62.813788, 27.316894],
              [62.813478, 27.316834],
              [62.813226, 27.316854],
              [62.813138, 27.316815],
              [62.812734, 27.316938],
              [62.812612, 27.316849],
              [62.812095, 27.316829],
              [62.811603, 27.317085],
              [62.811378, 27.317156],
              [62.811344, 27.3173],
              [62.811161, 27.317276],
              [62.811239, 27.317514],
              [62.811171, 27.317651],
              [62.811035, 27.317746],
              [62.810928, 27.318088],
              [62.810795, 27.318135],
              [62.810681, 27.318341],
              [62.810535, 27.318394],
              [62.810465, 27.318541],
              [62.810408, 27.318558],
              [62.810412, 27.318623],
              [62.810291, 27.318674],
              [62.810334, 27.318903],
              [62.810274, 27.319011],
              [62.810325, 27.319108],
              [62.810301, 27.319159],
              [62.810037, 27.319379],
              [62.809685, 27.319517],
              [62.809648, 27.319763],
              [62.809281, 27.320239],
              [62.809156, 27.320291],
              [62.808848, 27.320284],
              [62.808683, 27.32033],
              [62.80883, 27.320343],
              [62.80913, 27.320553],
              [62.809091, 27.320762],
              [62.809009, 27.320827],
              [62.808992, 27.320905],
              [62.808923, 27.320934],
              [62.80895, 27.321028],
              [62.80969, 27.321273],
              [62.809928, 27.321582],
              [62.809889, 27.321676],
              [62.810075, 27.3217],
              [62.810127, 27.321839],
              [62.809984, 27.321872],
              [62.809922, 27.322641],
              [62.809789, 27.322731],
              [62.809594, 27.3231],
              [62.809169, 27.32341],
              [62.809056, 27.323705],
              [62.809137, 27.32386],
              [62.80908, 27.323908],
              [62.809034, 27.324193],
              [62.808695, 27.324558],
              [62.808749, 27.32465],
              [62.808586, 27.324883],
              [62.808481, 27.324822],
              [62.808318, 27.324819],
              [62.808044, 27.324877],
              [62.808003, 27.324707],
              [62.807723, 27.324683],
              [62.807521, 27.324606],
              [62.807035, 27.324642],
              [62.806907, 27.324558],
              [62.806806, 27.324394],
              [62.806648, 27.32434],
              [62.806623, 27.324146],
              [62.806476, 27.324028],
              [62.805967, 27.324056],
              [62.805824, 27.324238],
              [62.80587, 27.324279],
              [62.805828, 27.324374],
              [62.805403, 27.324612],
              [62.805371, 27.324702],
              [62.805235, 27.324811],
              [62.805312, 27.324949],
              [62.805446, 27.324924],
              [62.805531, 27.324976],
              [62.805546, 27.325069],
              [62.805149, 27.325197],
              [62.805143, 27.325307],
              [62.80491, 27.325354],
              [62.804751, 27.32534],
              [62.804356, 27.325567],
              [62.804269, 27.32567],
              [62.80343, 27.326118],
              [62.803284, 27.3263],
              [62.803323, 27.326554],
              [62.803108, 27.326616],
              [62.80292, 27.326956],
              [62.803176, 27.327087],
              [62.803149, 27.327201],
              [62.803323, 27.327221],
              [62.803368, 27.327287],
              [62.803777, 27.327262],
              [62.804134, 27.327384],
              [62.804116, 27.327515],
              [62.804205, 27.327495],
              [62.804275, 27.327547],
              [62.804904, 27.327543],
              [62.806166, 27.327395],
              [62.806055, 27.327533],
              [62.806204, 27.327552],
              [62.806192, 27.327635],
              [62.806721, 27.327591],
              [62.806936, 27.32764],
              [62.806805, 27.327786],
              [62.80731, 27.327715],
              [62.807605, 27.327858],
              [62.808165, 27.328311],
              [62.808211, 27.328678],
              [62.808206, 27.328849],
              [62.80806, 27.329048],
              [62.807891, 27.329527],
              [62.807931, 27.329926],
              [62.807831, 27.329944],
              [62.807669, 27.330065],
              [62.807766, 27.330183],
              [62.807657, 27.330325],
              [62.807522, 27.330363],
              [62.807347, 27.33052],
              [62.807057, 27.330677],
              [62.806983, 27.330815],
              [62.806816, 27.330884],
              [62.806756, 27.330995],
              [62.806305, 27.331213],
              [62.806364, 27.33128],
              [62.80634, 27.331328],
              [62.806134, 27.331236],
              [62.805808, 27.331217],
              [62.805714, 27.331142],
              [62.805485, 27.331073],
              [62.805354, 27.330962],
              [62.805254, 27.330984],
              [62.805197, 27.331052],
              [62.805051, 27.331073],
              [62.805021, 27.33116],
              [62.804847, 27.331183],
              [62.804576, 27.331315],
              [62.804389, 27.331434],
              [62.804439, 27.331552],
              [62.804343, 27.33166],
              [62.804421, 27.331714],
              [62.804539, 27.33171],
              [62.804463, 27.331771],
              [62.804494, 27.331821],
              [62.804376, 27.331827],
              [62.804372, 27.331912],
              [62.804496, 27.332007],
              [62.804467, 27.332096],
              [62.804582, 27.332111],
              [62.80451, 27.332228],
              [62.804615, 27.332394],
              [62.804608, 27.33247],
              [62.803743, 27.332438],
              [62.803722, 27.332516],
              [62.803598, 27.332524],
              [62.803293, 27.332454],
              [62.803138, 27.332605],
              [62.802786, 27.332606],
              [62.802723, 27.332807],
              [62.802756, 27.332916],
              [62.80301, 27.332967],
              [62.80304, 27.333073],
              [62.803003, 27.333099],
              [62.802576, 27.333139],
              [62.801666, 27.333336],
              [62.801291, 27.333335],
              [62.801144, 27.333382],
              [62.800487, 27.333422],
              [62.799906, 27.333374],
              [62.799753, 27.333325],
              [62.79942, 27.333332],
              [62.79915, 27.333246],
              [62.799125, 27.333307],
              [62.798894, 27.333461],
              [62.798341, 27.33332],
              [62.797745, 27.333291],
              [62.797681, 27.333223],
              [62.797542, 27.333227],
              [62.797189, 27.333347],
              [62.797072, 27.333294],
              [62.796971, 27.333326],
              [62.796529, 27.333316],
              [62.796648, 27.333375],
              [62.796594, 27.333434],
              [62.796675, 27.333469],
              [62.796602, 27.333511],
              [62.796581, 27.333604],
              [62.796772, 27.33372],
              [62.796767, 27.333777],
              [62.796693, 27.33381],
              [62.796703, 27.33391],
              [62.796757, 27.333987],
              [62.79687, 27.333991],
              [62.796902, 27.33414],
              [62.796844, 27.334269],
              [62.796465, 27.334725],
              [62.795996, 27.335229],
              [62.796066, 27.33534],
              [62.796424, 27.335642],
              [62.796344, 27.335787],
              [62.796346, 27.335986],
              [62.796471, 27.336074],
              [62.796216, 27.336606],
              [62.796443, 27.336653],
              [62.796511, 27.33674],
              [62.796456, 27.336812],
              [62.796272, 27.336897],
              [62.796198, 27.336994],
              [62.795757, 27.337016],
              [62.795667, 27.337079],
              [62.794989, 27.337226],
              [62.794772, 27.337205],
              [62.794283, 27.337285],
              [62.794217, 27.337235],
              [62.794057, 27.337231],
              [62.793786, 27.337301],
              [62.79368, 27.337296],
              [62.793542, 27.337201],
              [62.793445, 27.337201],
              [62.793392, 27.337295],
              [62.792933, 27.337441],
              [62.792808, 27.337548],
              [62.792719, 27.337552],
              [62.792826, 27.33765],
              [62.792763, 27.337718],
              [62.79238, 27.337787],
              [62.792319, 27.337876],
              [62.792241, 27.3379],
              [62.792236, 27.337997],
              [62.792097, 27.338002],
              [62.792106, 27.338159],
              [62.79195, 27.338287],
              [62.791748, 27.338183],
              [62.791767, 27.338291],
              [62.791705, 27.338515],
              [62.791308, 27.338595],
              [62.791328, 27.338783],
              [62.791617, 27.338872],
              [62.791746, 27.33899],
              [62.791793, 27.339155],
              [62.791888, 27.339218],
              [62.792199, 27.339178],
              [62.792383, 27.339313],
              [62.792727, 27.339292],
              [62.792736, 27.339399],
              [62.792959, 27.339667],
              [62.79297, 27.339755],
              [62.793163, 27.339926],
              [62.793112, 27.33997],
              [62.793201, 27.340006],
              [62.793213, 27.340075],
              [62.793075, 27.340185],
              [62.793118, 27.34032],
              [62.793248, 27.340289],
              [62.793287, 27.340378],
              [62.793386, 27.340415],
              [62.793642, 27.340416],
              [62.79373, 27.340614],
              [62.793975, 27.340599],
              [62.79422, 27.340791],
              [62.794334, 27.340829],
              [62.794281, 27.340938],
              [62.794304, 27.341076],
              [62.794265, 27.341186],
              [62.794184, 27.341338],
              [62.794063, 27.34142],
              [62.794121, 27.341539],
              [62.793895, 27.34156],
              [62.793716, 27.34164],
              [62.793467, 27.341902],
              [62.793239, 27.342047],
              [62.792881, 27.342503],
              [62.792209, 27.342748],
              [62.792348, 27.342815],
              [62.792242, 27.342928],
              [62.792353, 27.342941],
              [62.792349, 27.342969],
              [62.792257, 27.343005],
              [62.792301, 27.343155],
              [62.792105, 27.343286],
              [62.792081, 27.343405],
              [62.792629, 27.343512],
              [62.792776, 27.343435],
              [62.792951, 27.343486],
              [62.79307, 27.343414],
              [62.793157, 27.343447],
              [62.793389, 27.343406],
              [62.793514, 27.343432],
              [62.794156, 27.34333],
              [62.794224, 27.344167],
              [62.794487, 27.344568],
              [62.794612, 27.344665],
              [62.794561, 27.344737],
              [62.794732, 27.345055],
              [62.794602, 27.345101],
              [62.794474, 27.345256],
              [62.794177, 27.345324],
              [62.794269, 27.34563],
              [62.794468, 27.345589],
              [62.794904, 27.345631],
              [62.795009, 27.345735],
              [62.795553, 27.345927],
              [62.795511, 27.346097],
              [62.796142, 27.346083],
              [62.796175, 27.346679],
              [62.796305, 27.346753],
              [62.796448, 27.347223],
              [62.796827, 27.347418],
              [62.797645, 27.347434],
              [62.79779, 27.347497],
              [62.797751, 27.347765],
              [62.797795, 27.347872],
              [62.797774, 27.348083],
              [62.798025, 27.348744],
              [62.797782, 27.348827],
              [62.797427, 27.34876],
              [62.797353, 27.349094],
              [62.797388, 27.349699],
              [62.797355, 27.349857],
              [62.796942, 27.350056],
              [62.796776, 27.350087],
              [62.796576, 27.350228],
              [62.796256, 27.350319],
              [62.796282, 27.35047],
              [62.796172, 27.350565],
              [62.796336, 27.350723],
              [62.796189, 27.35077],
              [62.796167, 27.350929],
              [62.795964, 27.351001],
              [62.795941, 27.351232],
              [62.796041, 27.351347],
              [62.795808, 27.35144],
              [62.795859, 27.351549],
              [62.795822, 27.351587],
              [62.795313, 27.351792],
              [62.795241, 27.351982],
              [62.794697, 27.352237],
              [62.794659, 27.352316],
              [62.794695, 27.352526],
              [62.794482, 27.352715],
              [62.794525, 27.352788],
              [62.794652, 27.352807],
              [62.794605, 27.352925],
              [62.794681, 27.352941],
              [62.794686, 27.353108],
              [62.794806, 27.353116],
              [62.794736, 27.353154],
              [62.794752, 27.353192],
              [62.79486, 27.35319],
              [62.794943, 27.353261],
              [62.795089, 27.353258],
              [62.795026, 27.353382],
              [62.795151, 27.353439],
              [62.795343, 27.353428],
              [62.795778, 27.35351],
              [62.795708, 27.353681],
              [62.795723, 27.353772],
              [62.795559, 27.353855],
              [62.795458, 27.354048],
              [62.795515, 27.354239],
              [62.795688, 27.3543],
              [62.795798, 27.354465],
              [62.795492, 27.354796],
              [62.795388, 27.354782],
              [62.795115, 27.35501],
              [62.795293, 27.355547],
              [62.795293, 27.355727],
              [62.79554, 27.355823],
              [62.795702, 27.356044],
              [62.79599, 27.356176],
              [62.796171, 27.356608],
              [62.796365, 27.356757],
              [62.796376, 27.357382],
              [62.796257, 27.357466],
              [62.796243, 27.357779],
              [62.796095, 27.358164],
              [62.795973, 27.358254],
              [62.795936, 27.358429],
              [62.79585, 27.358519],
              [62.795973, 27.358687],
              [62.795986, 27.358874],
              [62.795941, 27.358926],
              [62.79557, 27.359061],
              [62.795055, 27.359518],
              [62.795044, 27.35989],
              [62.795111, 27.360004],
              [62.795321, 27.36011],
              [62.795705, 27.36068],
              [62.795697, 27.360843],
              [62.795455, 27.361078],
              [62.795476, 27.361149],
              [62.795603, 27.361227],
              [62.79613, 27.361097],
              [62.79684, 27.361245],
              [62.797052, 27.361242],
              [62.797321, 27.361458],
              [62.797822, 27.361593],
              [62.798016, 27.361606],
              [62.798208, 27.361551],
              [62.798753, 27.361659],
              [62.79889, 27.361792],
              [62.799359, 27.361796],
              [62.799328, 27.361845],
              [62.799404, 27.362377],
              [62.799375, 27.362498],
              [62.799436, 27.362734],
              [62.799544, 27.362912],
              [62.799631, 27.362943],
              [62.799697, 27.363228],
              [62.799685, 27.363476],
              [62.799727, 27.363514],
              [62.799654, 27.363556],
              [62.799637, 27.363662],
              [62.799534, 27.363759],
              [62.799419, 27.364131],
              [62.799226, 27.364344],
              [62.799111, 27.364807],
              [62.799193, 27.364878],
              [62.79926, 27.365033],
              [62.799455, 27.365049],
              [62.799797, 27.365316],
              [62.800135, 27.365327],
              [62.800369, 27.365149],
              [62.801029, 27.365246],
              [62.801149, 27.365417],
              [62.801218, 27.365379],
              [62.801256, 27.36524],
              [62.801428, 27.365263],
              [62.801749, 27.364998],
              [62.802105, 27.36479],
              [62.802309, 27.364547],
              [62.802385, 27.364548],
              [62.8085015, 27.3761957],
              [62.8484229, 27.4629391],
              [62.8386602, 27.6131746],
              [62.8296412, 27.7517824],
              [62.8289545, 27.7644629],
              [62.7886885, 27.9164568],
              [62.7748219, 27.9729331],
              [62.7661744, 28.0061405],
              [62.7627557, 28.007468],
              [62.7627411, 28.016797],
              [62.7617618, 28.0256579],
              [62.7630223, 28.0319505],
              [62.7640785, 28.0349488],
              [62.7634274, 28.0355626],
              [62.7644, 28.0467999],
              [62.7840067, 28.1656224],
              [62.794427, 28.2272528],
              [62.7929605, 28.2789044],
              [62.6879425, 28.2630526],
              [62.597191, 28.24842],
              [62.596553, 28.250002],
              [62.595425, 28.251245],
              [62.594813, 28.251711],
              [62.593638, 28.252734],
              [62.593176, 28.253251],
              [62.591686, 28.25452],
              [62.589056, 28.25693],
              [62.587418, 28.258302],
              [62.585457, 28.259816],
              [62.584691, 28.260655],
              [62.583976, 28.261617],
              [62.583533, 28.262641],
              [62.583517, 28.263305],
              [62.583048, 28.263814],
              [62.582845, 28.264538],
              [62.582139, 28.266141],
              [62.581257, 28.266886],
              [62.579754, 28.267865],
              [62.578442, 28.269222],
              [62.577637, 28.269762],
              [62.577363, 28.270065],
              [62.576345, 28.270984],
              [62.575098, 28.271928],
              [62.574739, 28.272272],
              [62.574422, 28.272464],
              [62.574053, 28.272601],
              [62.573609, 28.272923],
              [62.572598, 28.273526],
              [62.571815, 28.273848],
              [62.568999, 28.275669],
              [62.568666, 28.275722],
              [62.568062, 28.276036],
              [62.567689, 28.276597],
              [62.567155, 28.277729],
              [62.566915, 28.278003],
              [62.566461, 28.278395],
              [62.565884, 28.278604],
              [62.56471, 28.279472],
              [62.563746, 28.280432],
              [62.562662, 28.281298],
              [62.562034, 28.281944],
              [62.560916, 28.282652],
              [62.557161, 28.285182],
              [62.553523, 28.288791],
              [62.552973, 28.289474],
              [62.552031, 28.290379],
              [62.551601, 28.290878],
              [62.550626, 28.291534],
              [62.549285, 28.292015],
              [62.547225, 28.294741],
              [62.546515, 28.296003],
              [62.545663, 28.297299],
              [62.544475, 28.298935],
              [62.542831, 28.300532],
              [62.541618, 28.301584],
              [62.539959, 28.303184],
              [62.539299, 28.303936],
              [62.538723, 28.304874],
              [62.537687, 28.305846],
              [62.534934, 28.307825],
              [62.534376, 28.308472],
              [62.533734, 28.30908],
              [62.532666, 28.309889],
              [62.531101, 28.311409],
              [62.52977, 28.312893],
              [62.528158, 28.314899],
              [62.527146, 28.31603],
              [62.525481, 28.317739],
              [62.524638, 28.318491],
              [62.523017, 28.319463],
              [62.520958, 28.319464],
              [62.518806, 28.319644],
              [62.516372, 28.320071],
              [62.515275, 28.320489],
              [62.514381, 28.321048],
              [62.513266, 28.321956],
              [62.512278, 28.322855],
              [62.510949, 28.324561],
              [62.510534, 28.325345],
              [62.510261, 28.325989],
              [62.509009, 28.330533],
              [62.50793, 28.334694],
              [62.507802, 28.335953],
              [62.507812, 28.337323],
              [62.507575, 28.33796],
              [62.507078, 28.338537],
              [62.505756, 28.340512],
              [62.505003, 28.341124],
              [62.503506, 28.341836],
              [62.502505, 28.342373],
              [62.501797, 28.342962],
              [62.501432, 28.343599],
              [62.500673, 28.345533],
              [62.50099, 28.346707],
              [62.501628, 28.348453],
              [62.502049, 28.350369],
              [62.50216, 28.351526],
              [62.502136, 28.35223],
              [62.501816, 28.353389],
              [62.501514, 28.354033],
              [62.501025, 28.354813],
              [62.500171, 28.355894],
              [62.499443, 28.356073],
              [62.497361, 28.356906],
              [62.495457, 28.358095],
              [62.49403, 28.35982],
              [62.493077, 28.362],
              [62.492781, 28.363093],
              [62.492414, 28.365169],
              [62.491394, 28.368088],
              [62.491204, 28.368849],
              [62.490915, 28.370422],
              [62.490497, 28.371382],
              [62.489723, 28.372353],
              [62.488771, 28.373405],
              [62.48755, 28.374481],
              [62.486364, 28.374873],
              [62.485161, 28.374602],
              [62.483887, 28.374651],
              [62.482243, 28.374791],
              [62.480294, 28.374832],
              [62.47919, 28.374811],
              [62.476992, 28.374583],
              [62.47405, 28.374976],
              [62.470733, 28.375543],
              [62.468047, 28.376449],
              [62.465315, 28.376924],
              [62.464246, 28.377313],
              [62.463069, 28.377888],
              [62.461401, 28.37921],
              [62.460104, 28.380414],
              [62.456874, 28.383216],
              [62.45524, 28.384134],
              [62.451196, 28.38601],
              [62.44959, 28.386809],
              [62.448528, 28.387537],
              [62.447557, 28.388508],
              [62.446421, 28.389184],
              [62.444997, 28.389806],
              [62.443374, 28.39058],
              [62.441868, 28.391185],
              [62.43815, 28.392851],
              [62.437345, 28.393601],
              [62.437117, 28.394127],
              [62.436265, 28.397899],
              [62.435792, 28.398245],
              [62.434533, 28.399326],
              [62.434111, 28.400357],
              [62.433686, 28.400966],
              [62.432411, 28.402304],
              [62.42899, 28.406329],
              [62.425597, 28.408494],
              [62.424149, 28.409276],
              [62.42311, 28.409679],
              [62.422557, 28.409978],
              [62.421009, 28.410979],
              [62.42069, 28.411229],
              [62.420048, 28.411985],
              [62.419333, 28.412636],
              [62.418876, 28.412966],
              [62.418397, 28.413394],
              [62.418219, 28.413854],
              [62.417619, 28.414646],
              [62.416186, 28.415717],
              [62.413605, 28.417847],
              [62.412212, 28.418816],
              [62.4117, 28.419128],
              [62.410335, 28.419703],
              [62.408554, 28.420354],
              [62.406597, 28.420936],
              [62.405393, 28.421789],
              [62.404735, 28.422482],
              [62.403375, 28.423106],
              [62.402182, 28.423567],
              [62.399697, 28.424906],
              [62.398625, 28.42555],
              [62.397698, 28.426235],
              [62.396171, 28.427599],
              [62.395259, 28.428203],
              [62.392468, 28.430296],
              [62.391584, 28.431109],
              [62.390737, 28.431661],
              [62.389486, 28.432248],
              [62.388535, 28.432674],
              [62.387444, 28.432795],
              [62.38272, 28.433163],
              [62.379238, 28.433563],
              [62.377348, 28.433593],
              [62.375253, 28.433448],
              [62.374385, 28.433276],
              [62.372474, 28.433058],
              [62.371553, 28.433036],
              [62.370788, 28.432947],
              [62.368743, 28.432955],
              [62.367094, 28.432846],
              [62.365724, 28.432672],
              [62.364724, 28.432675],
              [62.364648, 28.432636],
              [62.360936, 28.433338],
              [62.358875, 28.433615],
              [62.357255, 28.434133],
              [62.353621, 28.435078],
              [62.351979, 28.435611],
              [62.350832, 28.436066],
              [62.347666, 28.437858],
              [62.345674, 28.439184],
              [62.344219, 28.440257],
              [62.342999, 28.440828],
              [62.340998, 28.442061],
              [62.338566, 28.443849],
              [62.337564, 28.444471],
              [62.336526, 28.445186],
              [62.333577, 28.446839],
              [62.332989, 28.447051],
              [62.331777, 28.447592],
              [62.331485, 28.447818],
              [62.329873, 28.448799],
              [62.328281, 28.449457],
              [62.326656, 28.449972],
              [62.325617, 28.450176],
              [62.322742, 28.450531],
              [62.321343, 28.45037],
              [62.317101, 28.450737],
              [62.313348, 28.451349],
              [62.312341, 28.451347],
              [62.310777, 28.451442],
              [62.308265, 28.451748],
              [62.306408, 28.452201],
              [62.303503, 28.452255],
              [62.300752, 28.452415],
              [62.299733, 28.452539],
              [62.296997, 28.452754],
              [62.295025, 28.452826],
              [62.292576, 28.452526],
              [62.290482, 28.452138],
              [62.287141, 28.451347],
              [62.283371, 28.450818],
              [62.282794, 28.450635],
              [62.282088, 28.450552],
              [62.28036, 28.450526],
              [62.278664, 28.450731],
              [62.278008, 28.450887],
              [62.27528, 28.451979],
              [62.272558, 28.452709],
              [62.271792, 28.453064],
              [62.269754, 28.454077],
              [62.267163, 28.456013],
              [62.263423, 28.457902],
              [62.261329, 28.458727],
              [62.256908, 28.460274],
              [62.255491, 28.460759],
              [62.251802, 28.461915],
              [62.24976, 28.462663],
              [62.248672, 28.462938],
              [62.247747, 28.462925],
              [62.247106, 28.463015],
              [62.245601, 28.46335],
              [62.243481, 28.463218],
              [62.242213, 28.463025],
              [62.240997, 28.462964],
              [62.237906, 28.462464],
              [62.232107, 28.463136],
              [62.22741, 28.464056],
              [62.22489, 28.465],
              [62.224566, 28.465031],
              [62.22326, 28.46531],
              [62.222346, 28.465413],
              [62.221634, 28.465683],
              [62.217359, 28.467014],
              [62.211277, 28.468462],
              [62.208119, 28.469562],
              [62.207078, 28.469871],
              [62.203148, 28.472155],
              [62.199046, 28.475212],
              [62.197253, 28.476149],
              [62.196264, 28.476611],
              [62.19545, 28.477071],
              [62.193877, 28.478051],
              [62.191392, 28.479761],
              [62.187734, 28.48155],
              [62.179916, 28.484527],
              [62.176291, 28.485802],
              [62.173878, 28.486409],
              [62.171533, 28.486645],
              [62.168297, 28.488768],
              [62.167533, 28.488885],
              [62.158319, 28.489831],
              [62.152109, 28.490179],
              [62.141615, 28.492939],
              [62.141329, 28.493071],
              [62.140329, 28.493827],
              [62.139144, 28.494392],
              [62.137714, 28.49466],
              [62.137105, 28.494726],
              [62.133934, 28.494611],
              [62.131517, 28.494978],
              [62.128029, 28.49526],
              [62.126625, 28.495532],
              [62.124542, 28.496276],
              [62.119445, 28.496927],
              [62.118006, 28.497187],
              [62.114543, 28.497601],
              [62.109484, 28.49758],
              [62.107581, 28.497677],
              [62.103564, 28.499483],
              [62.099416, 28.500749],
              [62.095785, 28.502009],
              [62.092969, 28.503199],
              [62.090482, 28.504364],
              [62.089495, 28.50488],
              [62.088512, 28.505486],
              [62.08764, 28.50573],
              [62.08663, 28.505948],
              [62.085381, 28.505963],
              [62.083267, 28.506307],
              [62.082571, 28.506465],
              [62.080274, 28.50646],
              [62.076939, 28.506381],
              [62.074448, 28.506476],
              [62.071979, 28.506727],
              [62.069587, 28.506913],
              [62.06552, 28.507839],
              [62.062047, 28.508255],
              [62.057555, 28.508545],
              [62.0564037, 28.5085945],
              [62.053927, 28.508701],
              [62.051237, 28.509218],
              [62.04778, 28.510038],
              [62.045738, 28.509891],
              [62.043906, 28.510134],
              [62.041238, 28.511889],
              [62.039443, 28.513304],
              [62.037666, 28.514558],
              [62.036393, 28.515545],
              [62.035275, 28.516521],
              [62.034614, 28.517482],
              [62.033993, 28.518496],
              [62.033382, 28.518967],
              [62.028099, 28.521185],
              [62.026827, 28.521906],
              [62.021964, 28.524955],
              [62.021144, 28.525361],
              [62.020265, 28.525713],
              [62.018954, 28.526154],
              [62.018101, 28.526619],
              [62.017284, 28.527122],
              [62.016437, 28.527571],
              [62.015386, 28.528282],
              [62.014443, 28.528674],
              [62.013299, 28.52928],
              [62.012857, 28.529737],
              [62.012412, 28.53007],
              [62.011689, 28.530741],
              [62.010775, 28.531446],
              [62.009789, 28.532056],
              [62.007879, 28.533411],
              [62.005117, 28.534734],
              [62.003177, 28.535511],
              [62.001558, 28.535894],
              [61.998214, 28.536813],
              [61.996343, 28.537391],
              [61.994272, 28.538124],
              [61.992297, 28.539012],
              [61.988238, 28.541265],
              [61.986971, 28.541671],
              [61.985809, 28.5419],
              [61.982435, 28.542321],
              [61.98109, 28.542259],
              [61.979988, 28.542338],
              [61.978902, 28.542576],
              [61.977627, 28.542627],
              [61.975447, 28.5421],
              [61.973303, 28.54152],
              [61.972447, 28.54098],
              [61.97151, 28.539838],
              [61.970588, 28.539347],
              [61.970155, 28.5393],
              [61.968803, 28.539386],
              [61.966893, 28.539584],
              [61.965243, 28.539843],
              [61.963961, 28.539926],
              [61.963024, 28.539914],
              [61.962536, 28.540038],
              [61.961846, 28.540314],
              [61.960431, 28.540974],
              [61.959285, 28.54123],
              [61.959129, 28.541559],
              [61.958786, 28.543118],
              [61.958172, 28.544276],
              [61.957947, 28.544475],
              [61.957727, 28.54458],
              [61.956531, 28.544868],
              [61.954762, 28.545593],
              [61.954391, 28.545817],
              [61.953731, 28.546006],
              [61.952666, 28.546634],
              [61.952368, 28.546867],
              [61.950786, 28.547503],
              [61.950043, 28.548012],
              [61.949215, 28.548248],
              [61.948695, 28.548533],
              [61.947721, 28.548741],
              [61.946331, 28.549174],
              [61.942525, 28.55129],
              [61.942133, 28.551466],
              [61.941409, 28.551906],
              [61.940136, 28.552395],
              [61.938638, 28.552686],
              [61.937142, 28.553065],
              [61.934974, 28.553502],
              [61.934219, 28.553735],
              [61.933721, 28.553821],
              [61.931711, 28.554671],
              [61.930031, 28.554984],
              [61.929755, 28.555078],
              [61.928243, 28.555805],
              [61.927682, 28.556146],
              [61.927028, 28.556637],
              [61.925235, 28.557425],
              [61.924611, 28.557786],
              [61.924066, 28.558025],
              [61.923146, 28.558293],
              [61.922392, 28.559012],
              [61.920795, 28.559876],
              [61.92053, 28.559954],
              [61.91925, 28.560042],
              [61.917929, 28.560425],
              [61.916891, 28.560924],
              [61.916473, 28.561009],
              [61.916111, 28.561002],
              [61.915362, 28.56114],
              [61.914099, 28.561549],
              [61.913599, 28.561827],
              [61.913082, 28.562136],
              [61.911776, 28.563062],
              [61.911354, 28.563288],
              [61.910018, 28.564377],
              [61.908863, 28.565632],
              [61.90818, 28.566256],
              [61.906142, 28.568356],
              [61.90529, 28.569044],
              [61.904465, 28.570327],
              [61.903545, 28.571593],
              [61.902994, 28.572179],
              [61.902107, 28.57289],
              [61.898557, 28.574599],
              [61.897912, 28.574996],
              [61.897227, 28.575251],
              [61.896315, 28.576139],
              [61.89547, 28.576853],
              [61.894999, 28.577431],
              [61.894093, 28.577935],
              [61.893449, 28.578756],
              [61.89181, 28.579994],
              [61.89169, 28.580285],
              [61.891551, 28.581144],
              [61.891423, 28.581467],
              [61.890657, 28.58232],
              [61.89026, 28.582885],
              [61.889783, 28.583906],
              [61.889506, 28.584705],
              [61.88926, 28.585563],
              [61.889282, 28.586435],
              [61.889215, 28.587303],
              [61.888864, 28.588336],
              [61.888667, 28.588653],
              [61.888658, 28.588896],
              [61.888745, 28.58914],
              [61.888744, 28.58953],
              [61.888636, 28.58986],
              [61.888543, 28.589951],
              [61.888392, 28.590615],
              [61.888359, 28.59091],
              [61.888387, 28.591323],
              [61.88804, 28.5918],
              [61.888071, 28.592027],
              [61.888188, 28.592331],
              [61.887924, 28.593108],
              [61.88761, 28.593338],
              [61.887338, 28.593429],
              [61.88707, 28.593339],
              [61.886688, 28.59333],
              [61.886606, 28.593478],
              [61.886329, 28.593607],
              [61.886322, 28.593772],
              [61.886174, 28.593941],
              [61.885987, 28.593992],
              [61.885975, 28.594088],
              [61.885872, 28.594146],
              [61.885846, 28.594212],
              [61.885677, 28.594348],
              [61.885326, 28.594424],
              [61.885303, 28.594561],
              [61.885059, 28.594666],
              [61.884978, 28.594817],
              [61.884862, 28.59488],
              [61.884878, 28.595055],
              [61.884783, 28.595004],
              [61.884739, 28.595048],
              [61.884748, 28.595212],
              [61.884687, 28.595221],
              [61.884616, 28.595316],
              [61.884636, 28.595478],
              [61.884341, 28.59544],
              [61.884274, 28.595365],
              [61.884117, 28.595344],
              [61.883982, 28.595199],
              [61.883875, 28.595524],
              [61.883824, 28.595533],
              [61.883717, 28.595758],
              [61.883821, 28.595922],
              [61.883559, 28.596108],
              [61.883492, 28.596262],
              [61.88323, 28.596202],
              [61.883038, 28.596206],
              [61.882181, 28.596624],
              [61.881934, 28.596857],
              [61.881558, 28.596942],
              [61.881071, 28.59769],
              [61.880735, 28.598087],
              [61.880448, 28.598327],
              [61.879879, 28.598625],
              [61.879461, 28.598955],
              [61.87944, 28.599039],
              [61.879032, 28.599278],
              [61.87882, 28.599353],
              [61.878555, 28.599632],
              [61.878373, 28.599965],
              [61.878147, 28.600116],
              [61.877715, 28.60021],
              [61.877499, 28.600344],
              [61.877409, 28.600545],
              [61.877009, 28.600844],
              [61.876852, 28.601083],
              [61.876285, 28.601114],
              [61.87622, 28.601041],
              [61.876097, 28.601019],
              [61.87592, 28.601053],
              [61.875715, 28.601305],
              [61.874448, 28.601929],
              [61.874116, 28.602325],
              [61.873862, 28.602546],
              [61.873741, 28.602735],
              [61.873447, 28.602989],
              [61.873313, 28.603267],
              [61.872859, 28.603714],
              [61.872602, 28.60404],
              [61.872365, 28.604129],
              [61.871984, 28.604507],
              [61.87102, 28.60487],
              [61.870757, 28.60482],
              [61.870301, 28.604912],
              [61.869859, 28.604891],
              [61.869405, 28.605019],
              [61.869134, 28.605244],
              [61.868933, 28.60551],
              [61.868716, 28.605656],
              [61.868349, 28.606314],
              [61.868183, 28.6065],
              [61.868016, 28.606563],
              [61.86735, 28.606453],
              [61.86689, 28.606426],
              [61.866529, 28.606531],
              [61.866282, 28.60675],
              [61.865865, 28.606924],
              [61.865552, 28.607215],
              [61.865415, 28.60726],
              [61.865087, 28.607805],
              [61.864964, 28.607927],
              [61.86475, 28.60846],
              [61.864538, 28.608728],
              [61.864499, 28.609015],
              [61.864261, 28.609362],
              [61.864208, 28.609676],
              [61.864038, 28.609844],
              [61.863917, 28.610046],
              [61.863835, 28.610393],
              [61.863656, 28.610759],
              [61.863538, 28.611466],
              [61.863093, 28.612071],
              [61.862739, 28.612435],
              [61.862289, 28.612759],
              [61.862245, 28.612951],
              [61.861998, 28.613288],
              [61.861622, 28.613502],
              [61.861468, 28.613707],
              [61.860801, 28.614291],
              [61.860636, 28.614655],
              [61.860411, 28.614836],
              [61.85818, 28.617651],
              [61.857844, 28.617975],
              [61.857248, 28.618321],
              [61.856735, 28.618725],
              [61.855896, 28.619173],
              [61.855497, 28.619291],
              [61.854818, 28.619681],
              [61.85328, 28.620404],
              [61.852476, 28.621048],
              [61.851794, 28.621421],
              [61.851531, 28.621542],
              [61.851283, 28.621499],
              [61.850752, 28.621538],
              [61.8503, 28.621868],
              [61.849848, 28.621889],
              [61.849477, 28.621964],
              [61.849305, 28.622225],
              [61.848964, 28.622181],
              [61.848161, 28.621822],
              [61.847151, 28.621],
              [61.846716, 28.620849],
              [61.846379, 28.620933],
              [61.845932, 28.621225],
              [61.845456, 28.621465],
              [61.844892, 28.621992],
              [61.842851, 28.62312],
              [61.84253, 28.623088],
              [61.841788, 28.622784],
              [61.84114, 28.62307],
              [61.840173, 28.623314],
              [61.839248, 28.62384],
              [61.838505, 28.624172],
              [61.838241, 28.624322],
              [61.8378, 28.624696],
              [61.836924, 28.625106],
              [61.836279, 28.625477],
              [61.835902, 28.625745],
              [61.834495, 28.627148],
              [61.833286, 28.628247],
              [61.831688, 28.62936],
              [61.830792, 28.630251],
              [61.830022, 28.631124],
              [61.828974, 28.632657],
              [61.828787, 28.632792],
              [61.82733, 28.635435],
              [61.825693, 28.637794],
              [61.82522, 28.638443],
              [61.823894, 28.639571],
              [61.823506, 28.640124],
              [61.823077, 28.641293],
              [61.822548, 28.641659],
              [61.821372, 28.642108],
              [61.82086, 28.642207],
              [61.820293, 28.642531],
              [61.818675, 28.642833],
              [61.817496, 28.64338],
              [61.815809, 28.643934],
              [61.813445, 28.645429],
              [61.812306, 28.646367],
              [61.811721, 28.646952],
              [61.81086, 28.647567],
              [61.810131, 28.648321],
              [61.809063, 28.649074],
              [61.808613, 28.649707],
              [61.807329, 28.651795],
              [61.80527, 28.654843],
              [61.804762, 28.656278],
              [61.804051, 28.657783],
              [61.803214, 28.658718],
              [61.802114, 28.659814],
              [61.801463, 28.660639],
              [61.801515, 28.661218],
              [61.798956, 28.663657],
              [61.796609, 28.667074],
              [61.795008, 28.668316],
              [61.794351, 28.669087],
              [61.793628, 28.670742],
              [61.793157, 28.672016],
              [61.792685, 28.672617],
              [61.791767, 28.674291],
              [61.791069, 28.675622],
              [61.790565, 28.676767],
              [61.790036, 28.677416],
              [61.7893, 28.678061],
              [61.788763, 28.67876],
              [61.788079, 28.679929],
              [61.787305, 28.681035],
              [61.78578, 28.682643],
              [61.783705, 28.684358],
              [61.782683, 28.68585],
              [61.781369, 28.68702],
              [61.78019, 28.688872],
              [61.779412, 28.689353],
              [61.778491, 28.689795],
              [61.776531, 28.691547],
              [61.774763, 28.693575],
              [61.772445, 28.696026],
              [61.771064, 28.697677],
              [61.770147, 28.698878],
              [61.768948, 28.70075],
              [61.767206, 28.703089],
              [61.7661061, 28.7040119],
              [61.765827, 28.704246],
              [61.765175, 28.70511],
              [61.763441, 28.706287],
              [61.761007, 28.707492],
              [61.760283, 28.707791],
              [61.75965, 28.708146],
              [61.758105, 28.709357],
              [61.757276, 28.710495],
              [61.756893, 28.710756],
              [61.756349, 28.711453],
              [61.755515, 28.713246],
              [61.754998, 28.714139],
              [61.75364, 28.715636],
              [61.7527704, 28.7167938],
              [61.7517497, 28.7178175],
              [61.749652, 28.7195711],
              [61.7479363, 28.720991],
              [61.7424884, 28.724903],
              [61.742123, 28.7252422],
              [61.7374667, 28.7290271],
              [61.7341531, 28.7321689],
              [61.7336487, 28.7340023],
              [61.7335667, 28.7340676],
              [61.7318849, 28.7348933],
              [61.7295108, 28.7358961],
              [61.7262666, 28.7379935],
              [61.7207324, 28.7446806],
              [61.7200695, 28.7451587],
              [61.7184759, 28.7460235],
              [61.7139104, 28.749407],
              [61.7118696, 28.7509963],
              [61.7093986, 28.7529206],
              [61.7091479, 28.753129],
              [61.7086035, 28.7534952],
              [61.7075275, 28.7540924],
              [61.7062871, 28.7545423],
              [61.7005668, 28.7563702],
              [61.6983321, 28.7571763],
              [61.693713, 28.7605039],
              [61.6923444, 28.7614131],
              [61.68579, 28.7658934],
              [61.6804332, 28.7702517],
              [61.6764129, 28.7737288],
              [61.662893, 28.783828],
              [61.6621274, 28.7846584],
              [61.6509537, 28.7969023],
              [61.6455716, 28.8029274],
              [61.6415842, 28.8084473],
              [61.6375978, 28.8142299],
              [61.636148, 28.817046],
              [61.6153858, 28.8431877],
              [61.6138381, 28.847499],
              [61.615819, 28.852576],
              [61.61075, 28.859087],
              [61.609372, 28.861627],
              [61.607915, 28.864482],
              [61.606351, 28.86635],
              [61.605341, 28.867765],
              [61.603861, 28.870003],
              [61.602083, 28.872999],
              [61.598882, 28.87921],
              [61.59857, 28.879684],
              [61.598002, 28.88073],
              [61.59462, 28.887653],
              [61.593198, 28.890455],
              [61.592543, 28.89107],
              [61.592181, 28.891471],
              [61.591953, 28.891831],
              [61.590967, 28.894047],
              [61.590309, 28.895082],
              [61.590033, 28.895632],
              [61.589641, 28.896929],
              [61.589478, 28.897266],
              [61.589262, 28.897537],
              [61.588797, 28.897967],
              [61.588317, 28.898616],
              [61.588003, 28.899259],
              [61.587813, 28.899904],
              [61.587627, 28.901171],
              [61.587425, 28.901905],
              [61.586846, 28.903317],
              [61.586253, 28.904154],
              [61.585928, 28.904456],
              [61.584988, 28.904899],
              [61.58476, 28.90509],
              [61.584584, 28.905541],
              [61.584534, 28.906324],
              [61.584421, 28.906938],
              [61.584211, 28.907638],
              [61.582117, 28.90932],
              [61.581416, 28.909821],
              [61.580724, 28.910216],
              [61.578897, 28.911682],
              [61.578014, 28.912605],
              [61.576976, 28.914044],
              [61.576158, 28.915369],
              [61.576034, 28.915793],
              [61.575985, 28.916291],
              [61.576096, 28.917157],
              [61.57606, 28.919999],
              [61.575979, 28.92027],
              [61.575756, 28.920629],
              [61.57509, 28.921485],
              [61.57471, 28.921889],
              [61.574418, 28.922313],
              [61.574176, 28.922873],
              [61.5714601, 28.9274676],
              [61.5709301, 28.9304703],
              [61.5709265, 28.9325419],
              [61.5693702, 28.9356331],
              [61.5606536, 28.9546755],
              [61.5536745, 28.9702967],
              [61.5531117, 28.9710569],
              [61.5515914, 28.9730375],
              [61.5516383, 28.9732923],
              [61.5520719, 28.9739591],
              [61.5519256, 28.9742903],
              [61.5512606, 28.9756588],
              [61.5505646, 28.9770337],
              [61.5501197, 28.9778695],
              [61.546843, 28.9825705],
              [61.5434936, 28.9872967],
              [61.5418131, 28.9902658],
              [61.5414125, 28.9907662],
              [61.5406778, 28.9914271],
              [61.5290709, 28.9972294],
              [61.517492, 29.0030316],
              [61.5142225, 29.0056427],
              [61.5111827, 29.0081322],
              [61.5076666, 29.010965],
              [61.504853, 29.0132665],
              [61.5017419, 29.0157868],
              [61.4991182, 29.0179676],
              [61.4978259, 29.0189283],
              [61.4960022, 29.0192957],
              [61.4820053, 29.0227309],
              [61.4787878, 29.0236923],
              [61.4794068, 29.0257525],
              [61.491773, 29.041135],
              [61.491818, 29.041459],
              [61.491948, 29.041585],
              [61.491929, 29.041688],
              [61.492125, 29.041829],
              [61.492144, 29.042024],
              [61.492261, 29.042061],
              [61.492356, 29.042246],
              [61.492347, 29.04235],
              [61.492227, 29.042514],
              [61.492194, 29.042736],
              [61.492271, 29.043148],
              [61.492355, 29.043247],
              [61.492461, 29.043279],
              [61.492442, 29.043354],
              [61.492532, 29.043612],
              [61.492355, 29.043661],
              [61.492318, 29.043792],
              [61.492356, 29.043832],
              [61.492703, 29.04392],
              [61.49291, 29.044094],
              [61.493479, 29.043825],
              [61.493837, 29.04374],
              [61.493905, 29.043787],
              [61.494164, 29.043767],
              [61.494197, 29.043683],
              [61.494353, 29.043647],
              [61.494495, 29.043527],
              [61.494576, 29.043542],
              [61.49472, 29.043458],
              [61.494949, 29.043518],
              [61.495028, 29.043469],
              [61.49524, 29.043485],
              [61.495479, 29.04341],
              [61.495507, 29.043463],
              [61.495657, 29.043477],
              [61.495857, 29.043622],
              [61.495839, 29.043714],
              [61.495912, 29.043802],
              [61.496124, 29.04387],
              [61.496313, 29.043838],
              [61.496371, 29.043885],
              [61.496582, 29.043912],
              [61.496722, 29.043998],
              [61.496791, 29.044001],
              [61.496853, 29.0439],
              [61.496951, 29.044013],
              [61.497297, 29.044184],
              [61.497491, 29.044383],
              [61.497442, 29.0445],
              [61.497522, 29.044641],
              [61.49775, 29.044787],
              [61.498045, 29.0448],
              [61.498307, 29.044699],
              [61.49855, 29.0447],
              [61.498761, 29.04478],
              [61.499011, 29.044808],
              [61.499277, 29.044667],
              [61.499365, 29.044679],
              [61.499479, 29.044486],
              [61.49987, 29.044478],
              [61.500041, 29.044532],
              [61.500165, 29.044637],
              [61.500264, 29.044593],
              [61.500759, 29.044584],
              [61.501281, 29.044481],
              [61.501554, 29.044349],
              [61.501652, 29.044242],
              [61.5023, 29.044401],
              [61.502568, 29.044303],
              [61.50281, 29.044278],
              [61.503047, 29.04433],
              [61.503183, 29.044303],
              [61.503316, 29.044178],
              [61.5034, 29.044164],
              [61.503399, 29.044004],
              [61.503578, 29.043955],
              [61.503707, 29.043833],
              [61.504006, 29.043915],
              [61.504343, 29.043688],
              [61.504431, 29.043652],
              [61.50452, 29.043673],
              [61.504559, 29.043434],
              [61.504984, 29.043264],
              [61.505247, 29.043016],
              [61.505914, 29.043113],
              [61.506005, 29.043247],
              [61.506158, 29.0432],
              [61.50626, 29.043271],
              [61.50635, 29.043002],
              [61.506571, 29.043083],
              [61.506753, 29.043091],
              [61.506836, 29.043044],
              [61.506906, 29.043155],
              [61.506907, 29.043264],
              [61.506835, 29.043389],
              [61.506917, 29.043588],
              [61.506835, 29.043855],
              [61.507092, 29.044044],
              [61.507145, 29.044135],
              [61.507217, 29.044124],
              [61.507278, 29.044195],
              [61.507138, 29.044402],
              [61.506985, 29.044517],
              [61.506993, 29.044623],
              [61.506828, 29.044752],
              [61.506859, 29.044895],
              [61.506923, 29.044918],
              [61.507065, 29.045116],
              [61.507058, 29.045322],
              [61.507266, 29.045176],
              [61.507437, 29.045114],
              [61.507625, 29.045102],
              [61.507734, 29.045141],
              [61.507873, 29.045541],
              [61.507749, 29.046035],
              [61.507859, 29.046374],
              [61.507809, 29.046412],
              [61.507763, 29.046727],
              [61.507947, 29.046906],
              [61.508335, 29.047149],
              [61.508372, 29.047263],
              [61.508624, 29.047304],
              [61.508691, 29.047426],
              [61.508919, 29.047298],
              [61.50902, 29.04732],
              [61.509124, 29.047429],
              [61.509308, 29.047431],
              [61.509361, 29.047468],
              [61.509591, 29.047778],
              [61.509604, 29.04791],
              [61.509593, 29.047989],
              [61.5094, 29.048115],
              [61.50992, 29.048005],
              [61.510054, 29.048045],
              [61.510319, 29.04796],
              [61.510541, 29.047808],
              [61.510684, 29.04778],
              [61.510784, 29.047887],
              [61.511008, 29.048],
              [61.511095, 29.048245],
              [61.511348, 29.048443],
              [61.511472, 29.04848],
              [61.511324, 29.048942],
              [61.511183, 29.04914],
              [61.511226, 29.04935],
              [61.510918, 29.049424],
              [61.510908, 29.04955],
              [61.510628, 29.049694],
              [61.510301, 29.050095],
              [61.509953, 29.050252],
              [61.509772, 29.050977],
              [61.509673, 29.051057],
              [61.509669, 29.051182],
              [61.509108, 29.051576],
              [61.508908, 29.051859],
              [61.508892, 29.052035],
              [61.5087, 29.05212],
              [61.508635, 29.052378],
              [61.508657, 29.052705],
              [61.508498, 29.05291],
              [61.508409, 29.052941],
              [61.507827, 29.052849],
              [61.507723, 29.052884],
              [61.507564, 29.052752],
              [61.50747, 29.052752],
              [61.507372, 29.052677],
              [61.507191, 29.052743],
              [61.506936, 29.052769],
              [61.506822, 29.052733],
              [61.506528, 29.052987],
              [61.506399, 29.05307],
              [61.506226, 29.053104],
              [61.506029, 29.053281],
              [61.505668, 29.053499],
              [61.505552, 29.053431],
              [61.505319, 29.053625],
              [61.5051, 29.053908],
              [61.505086, 29.054005],
              [61.505002, 29.054032],
              [61.504903, 29.054173],
              [61.504911, 29.05426],
              [61.504852, 29.054297],
              [61.504871, 29.054389],
              [61.504548, 29.054911],
              [61.504523, 29.055029],
              [61.504374, 29.055055],
              [61.504287, 29.055161],
              [61.504095, 29.055201],
              [61.504066, 29.05529],
              [61.503966, 29.055337],
              [61.503963, 29.055481],
              [61.503854, 29.055469],
              [61.503631, 29.055822],
              [61.503742, 29.055985],
              [61.50369, 29.05618],
              [61.503712, 29.0567],
              [61.503882, 29.057058],
              [61.503789, 29.057225],
              [61.503724, 29.057202],
              [61.503661, 29.057639],
              [61.503835, 29.05761],
              [61.504272, 29.057359],
              [61.504481, 29.057309],
              [61.504717, 29.057527],
              [61.505055, 29.057563],
              [61.505321, 29.057684],
              [61.505412, 29.057831],
              [61.505577, 29.05784],
              [61.505782, 29.058009],
              [61.506025, 29.058022],
              [61.506084, 29.057955],
              [61.50632, 29.058019],
              [61.506422, 29.057966],
              [61.506785, 29.05862],
              [61.506921, 29.058601],
              [61.507096, 29.058748],
              [61.507214, 29.059224],
              [61.507165, 29.059358],
              [61.507606, 29.059949],
              [61.507688, 29.060228],
              [61.507417, 29.060728],
              [61.507182, 29.061034],
              [61.50732, 29.061117],
              [61.507332, 29.061319],
              [61.50738, 29.06135],
              [61.507259, 29.061686],
              [61.507147, 29.061854],
              [61.506911, 29.061983],
              [61.506853, 29.062003],
              [61.506728, 29.061945],
              [61.506435, 29.062099],
              [61.506317, 29.062291],
              [61.505838, 29.062727],
              [61.50577, 29.062961],
              [61.505662, 29.063005],
              [61.505666, 29.063098],
              [61.505783, 29.063196],
              [61.505712, 29.06356],
              [61.505642, 29.063667],
              [61.505264, 29.063852],
              [61.505148, 29.064002],
              [61.504724, 29.06432],
              [61.504845, 29.064398],
              [61.504666, 29.064839],
              [61.504707, 29.064982],
              [61.504651, 29.065115],
              [61.504673, 29.065372],
              [61.504601, 29.065626],
              [61.504377, 29.065822],
              [61.504205, 29.065853],
              [61.504179, 29.06598],
              [61.503727, 29.0664],
              [61.503731, 29.066479],
              [61.50361, 29.066533],
              [61.503535, 29.066672],
              [61.503087, 29.066761],
              [61.503025, 29.066619],
              [61.502769, 29.066459],
              [61.502653, 29.066262],
              [61.502353, 29.066294],
              [61.502203, 29.066185],
              [61.501727, 29.066285],
              [61.501308, 29.066211],
              [61.501217, 29.066168],
              [61.501206, 29.066109],
              [61.501026, 29.066073],
              [61.500818, 29.066137],
              [61.500627, 29.066326],
              [61.500477, 29.066284],
              [61.500589, 29.066504],
              [61.50048, 29.066735],
              [61.500558, 29.06685],
              [61.500756, 29.066951],
              [61.500728, 29.066976],
              [61.500646, 29.066959],
              [61.500031, 29.067282],
              [61.499948, 29.067287],
              [61.499772, 29.067404],
              [61.49966, 29.067586],
              [61.499471, 29.067745],
              [61.499138, 29.067935],
              [61.499082, 29.068009],
              [61.498749, 29.06815],
              [61.49798, 29.068674],
              [61.49768, 29.06881],
              [61.497315, 29.068841],
              [61.497177, 29.068926],
              [61.497181, 29.069044],
              [61.497045, 29.069217],
              [61.496792, 29.069209],
              [61.49666, 29.069141],
              [61.496446, 29.068988],
              [61.496368, 29.068857],
              [61.49609, 29.068992],
              [61.495903, 29.069145],
              [61.495206, 29.069037],
              [61.495077, 29.069082],
              [61.494937, 29.069057],
              [61.494674, 29.069153],
              [61.494573, 29.069377],
              [61.494339, 29.069641],
              [61.494265, 29.069879],
              [61.494157, 29.069908],
              [61.494116, 29.070228],
              [61.493972, 29.070546],
              [61.493897, 29.07058],
              [61.493639, 29.070479],
              [61.493644, 29.070591],
              [61.493455, 29.070874],
              [61.493411, 29.071169],
              [61.493338, 29.071189],
              [61.493191, 29.07134],
              [61.49297, 29.071298],
              [61.492374, 29.071584],
              [61.492334, 29.071666],
              [61.49191, 29.072017],
              [61.491598, 29.072181],
              [61.491406, 29.072147],
              [61.490952, 29.072248],
              [61.490705, 29.07201],
              [61.490549, 29.072008],
              [61.490178, 29.071872],
              [61.490007, 29.071925],
              [61.489857, 29.071841],
              [61.489582, 29.07189],
              [61.489047, 29.071745],
              [61.48888, 29.07185],
              [61.488881, 29.07175],
              [61.488773, 29.071702],
              [61.488724, 29.071563],
              [61.488548, 29.071606],
              [61.488557, 29.071514],
              [61.488388, 29.071384],
              [61.488333, 29.071268],
              [61.488174, 29.071228],
              [61.487767, 29.071565],
              [61.487658, 29.071768],
              [61.487403, 29.071885],
              [61.487248, 29.07204],
              [61.486292, 29.072471],
              [61.486136, 29.072507],
              [61.485876, 29.072473],
              [61.485778, 29.072545],
              [61.485585, 29.07271],
              [61.485538, 29.072851],
              [61.485439, 29.072929],
              [61.485465, 29.073153],
              [61.485418, 29.073269],
              [61.485355, 29.073265],
              [61.485033, 29.073434],
              [61.484909, 29.073436],
              [61.484894, 29.073541],
              [61.484364, 29.074349],
              [61.484213, 29.074417],
              [61.484012, 29.074677],
              [61.484067, 29.074882],
              [61.483972, 29.075005],
              [61.484033, 29.075321],
              [61.483804, 29.075402],
              [61.483691, 29.07559],
              [61.483294, 29.075853],
              [61.482982, 29.075912],
              [61.48295, 29.075957],
              [61.482529, 29.076106],
              [61.482355, 29.076094],
              [61.482307, 29.076255],
              [61.48188, 29.076411],
              [61.481834, 29.076547],
              [61.481687, 29.076661],
              [61.481478, 29.076686],
              [61.481288, 29.077057],
              [61.480752, 29.07732],
              [61.480653, 29.077323],
              [61.480628, 29.077606],
              [61.480389, 29.078161],
              [61.480156, 29.078433],
              [61.480118, 29.078556],
              [61.480146, 29.078647],
              [61.479863, 29.078932],
              [61.480103, 29.079102],
              [61.480229, 29.079135],
              [61.480448, 29.07937],
              [61.480575, 29.079433],
              [61.480707, 29.079661],
              [61.480738, 29.079878],
              [61.48116, 29.080095],
              [61.481386, 29.080494],
              [61.481641, 29.080466],
              [61.48189, 29.080676],
              [61.481987, 29.08069],
              [61.482279, 29.08104],
              [61.48246, 29.081054],
              [61.482553, 29.081143],
              [61.482404, 29.081324],
              [61.482316, 29.081631],
              [61.482234, 29.081675],
              [61.482178, 29.081821],
              [61.48193, 29.081961],
              [61.481825, 29.082238],
              [61.481764, 29.0826],
              [61.481571, 29.082986],
              [61.481554, 29.08311],
              [61.481273, 29.083516],
              [61.481236, 29.083854],
              [61.481101, 29.084068],
              [61.480894, 29.084109],
              [61.480718, 29.084257],
              [61.480759, 29.084348],
              [61.480343, 29.084571],
              [61.480297, 29.08482],
              [61.480326, 29.084927],
              [61.480159, 29.085175],
              [61.479942, 29.085372],
              [61.479914, 29.085496],
              [61.479669, 29.085655],
              [61.479336, 29.085693],
              [61.47923, 29.085808],
              [61.478943, 29.085865],
              [61.478991, 29.08596],
              [61.478889, 29.08603],
              [61.478652, 29.086027],
              [61.478454, 29.086143],
              [61.478424, 29.086226],
              [61.478215, 29.08643],
              [61.477906, 29.086604],
              [61.477623, 29.086693],
              [61.477553, 29.086996],
              [61.477299, 29.087204],
              [61.477171, 29.087436],
              [61.476917, 29.08758],
              [61.476817, 29.087564],
              [61.476339, 29.087749],
              [61.47625, 29.088111],
              [61.476277, 29.088266],
              [61.476146, 29.088377],
              [61.476117, 29.088501],
              [61.475966, 29.088688],
              [61.475893, 29.088631],
              [61.475646, 29.088638],
              [61.475317, 29.088767],
              [61.47502, 29.088721],
              [61.475051, 29.088786],
              [61.47493, 29.089006],
              [61.474918, 29.089124],
              [61.474756, 29.089288],
              [61.474606, 29.089312],
              [61.474452, 29.089522],
              [61.474053, 29.089659],
              [61.473639, 29.089914],
              [61.473562, 29.089891],
              [61.473529, 29.089925],
              [61.47321, 29.089952],
              [61.473027, 29.089812],
              [61.472942, 29.089834],
              [61.472917, 29.089781],
              [61.472717, 29.089699],
              [61.472591, 29.089796],
              [61.47258, 29.089853],
              [61.472342, 29.089911],
              [61.472263, 29.090045],
              [61.471929, 29.090282],
              [61.471754, 29.090331],
              [61.471608, 29.090734],
              [61.471443, 29.090872],
              [61.471341, 29.091096],
              [61.471401, 29.091189],
              [61.471454, 29.091614],
              [61.471392, 29.091769],
              [61.471616, 29.091797],
              [61.471557, 29.091963],
              [61.471594, 29.092066],
              [61.471766, 29.092214],
              [61.471885, 29.092163],
              [61.47196, 29.092192],
              [61.472191, 29.092146],
              [61.47233, 29.092207],
              [61.472589, 29.0922],
              [61.473208, 29.092392],
              [61.473261, 29.092564],
              [61.473564, 29.092763],
              [61.473597, 29.092949],
              [61.473853, 29.09329],
              [61.474224, 29.092974],
              [61.474408, 29.093429],
              [61.47467, 29.093614],
              [61.475379, 29.093976],
              [61.475513, 29.094274],
              [61.475918, 29.094459],
              [61.476009, 29.094551],
              [61.476038, 29.0947],
              [61.476178, 29.094739],
              [61.476355, 29.09493],
              [61.476448, 29.095137],
              [61.476704, 29.095269],
              [61.476699, 29.09543],
              [61.476528, 29.095623],
              [61.476205, 29.096167],
              [61.475968, 29.096363],
              [61.475918, 29.09656],
              [61.475822, 29.09656],
              [61.475522, 29.096787],
              [61.475264, 29.097017],
              [61.475075, 29.097344],
              [61.474985, 29.097345],
              [61.474873, 29.097469],
              [61.474794, 29.097686],
              [61.475017, 29.097965],
              [61.475252, 29.098141],
              [61.475509, 29.098474],
              [61.475895, 29.098695],
              [61.475992, 29.098814],
              [61.476153, 29.09881],
              [61.476633, 29.099035],
              [61.47679, 29.099161],
              [61.476985, 29.099142],
              [61.47697, 29.09907],
              [61.477079, 29.098952],
              [61.477619, 29.098975],
              [61.47795, 29.098866],
              [61.478015, 29.098894],
              [61.478214, 29.09929],
              [61.47823, 29.099422],
              [61.478361, 29.099567],
              [61.478455, 29.099904],
              [61.478835, 29.099975],
              [61.479305, 29.09986],
              [61.479342, 29.099938],
              [61.479733, 29.10028],
              [61.479916, 29.100539],
              [61.480228, 29.100761],
              [61.480108, 29.101119],
              [61.480008, 29.101152],
              [61.479626, 29.101503],
              [61.479617, 29.101593],
              [61.479522, 29.101717],
              [61.479473, 29.101704],
              [61.479236, 29.101933],
              [61.479105, 29.101995],
              [61.479011, 29.102146],
              [61.478642, 29.102472],
              [61.478203, 29.102636],
              [61.478065, 29.102851],
              [61.478064, 29.102961],
              [61.477941, 29.103069],
              [61.477947, 29.103175],
              [61.477873, 29.103164],
              [61.477838, 29.103312],
              [61.477341, 29.103843],
              [61.476504, 29.104331],
              [61.476255, 29.104377],
              [61.476122, 29.104459],
              [61.476094, 29.10442],
              [61.476004, 29.104432],
              [61.475752, 29.104576],
              [61.475629, 29.104721],
              [61.475918, 29.104874],
              [61.475874, 29.105208],
              [61.475748, 29.105461],
              [61.47518, 29.105927],
              [61.475239, 29.105992],
              [61.475244, 29.10622],
              [61.475124, 29.106365],
              [61.474978, 29.10638],
              [61.474753, 29.10654],
              [61.474549, 29.106545],
              [61.474299, 29.106809],
              [61.47416, 29.106839],
              [61.47406, 29.106928],
              [61.474005, 29.106878],
              [61.473686, 29.107178],
              [61.473456, 29.107262],
              [61.473693, 29.107375],
              [61.474029, 29.107651],
              [61.474139, 29.107701],
              [61.474412, 29.107702],
              [61.474717, 29.107846],
              [61.474926, 29.10789],
              [61.474941, 29.108003],
              [61.475399, 29.108188],
              [61.475507, 29.108291],
              [61.475443, 29.108551],
              [61.475862, 29.108549],
              [61.475963, 29.108749],
              [61.476449, 29.109053],
              [61.476501, 29.109307],
              [61.476602, 29.109389],
              [61.476867, 29.109395],
              [61.476995, 29.109499],
              [61.477165, 29.109523],
              [61.477348, 29.109738],
              [61.477287, 29.109847],
              [61.477318, 29.109887],
              [61.476911, 29.110312],
              [61.476826, 29.110732],
              [61.476551, 29.111009],
              [61.476089, 29.111337],
              [61.475926, 29.111588],
              [61.475628, 29.111743],
              [61.475595, 29.111865],
              [61.475529, 29.1119],
              [61.475517, 29.111994],
              [61.475391, 29.112151],
              [61.475182, 29.112214],
              [61.474792, 29.112647],
              [61.474684, 29.112842],
              [61.474616, 29.112869],
              [61.474525, 29.113097],
              [61.47459, 29.113172],
              [61.47447, 29.113295],
              [61.474417, 29.113396],
              [61.474455, 29.113452],
              [61.474373, 29.113562],
              [61.474372, 29.113816],
              [61.474307, 29.113895],
              [61.474311, 29.114015],
              [61.474432, 29.114102],
              [61.474459, 29.114188],
              [61.474642, 29.114306],
              [61.474853, 29.114264],
              [61.4749, 29.114304],
              [61.474941, 29.114784],
              [61.475078, 29.114967],
              [61.475203, 29.114969],
              [61.475171, 29.115067],
              [61.475525, 29.115413],
              [61.475603, 29.115828],
              [61.475892, 29.116192],
              [61.475841, 29.116508],
              [61.47588, 29.116589],
              [61.475685, 29.116867],
              [61.475342, 29.117117],
              [61.475359, 29.117626],
              [61.475017, 29.117793],
              [61.474388, 29.117995],
              [61.474199, 29.118423],
              [61.474318, 29.118439],
              [61.474608, 29.118726],
              [61.474708, 29.118935],
              [61.474872, 29.118947],
              [61.475005, 29.119149],
              [61.47535, 29.119329],
              [61.475768, 29.119671],
              [61.476211, 29.119782],
              [61.476213, 29.119828],
              [61.476124, 29.120042],
              [61.476209, 29.120146],
              [61.476133, 29.120244],
              [61.476062, 29.120233],
              [61.476129, 29.120372],
              [61.475829, 29.120767],
              [61.475808, 29.121206],
              [61.475668, 29.121586],
              [61.475619, 29.121674],
              [61.47516, 29.122043],
              [61.474903, 29.122399],
              [61.474769, 29.122501],
              [61.474617, 29.122752],
              [61.474539, 29.123219],
              [61.47438, 29.123348],
              [61.474371, 29.123403],
              [61.473996, 29.12348],
              [61.473995, 29.123245],
              [61.473675, 29.12314],
              [61.473386, 29.1233],
              [61.473395, 29.12343],
              [61.47334, 29.123559],
              [61.473225, 29.123607],
              [61.473054, 29.123411],
              [61.472865, 29.123544],
              [61.472849, 29.123637],
              [61.472952, 29.123672],
              [61.472796, 29.123866],
              [61.472544, 29.124005],
              [61.471691, 29.123597],
              [61.471271, 29.122851],
              [61.47114, 29.122782],
              [61.471367, 29.122485],
              [61.471306, 29.12234],
              [61.471023, 29.12206],
              [61.47081, 29.122068],
              [61.47082, 29.121982],
              [61.470489, 29.121947],
              [61.470152, 29.121705],
              [61.469763, 29.121545],
              [61.469545, 29.12172],
              [61.469304, 29.121776],
              [61.468944, 29.122062],
              [61.468785, 29.122088],
              [61.468291, 29.121748],
              [61.467882, 29.121813],
              [61.467174, 29.121717],
              [61.46649, 29.121825],
              [61.465944, 29.122249],
              [61.465571, 29.122415],
              [61.465445, 29.122538],
              [61.465416, 29.122656],
              [61.465206, 29.12272],
              [61.465119, 29.122793],
              [61.464915, 29.122791],
              [61.464928, 29.12287],
              [61.464818, 29.122942],
              [61.464786, 29.123032],
              [61.464543, 29.123061],
              [61.464167, 29.123472],
              [61.464006, 29.123543],
              [61.463335, 29.124023],
              [61.463067, 29.124031],
              [61.46287, 29.124216],
              [61.462521, 29.12431],
              [61.46221, 29.12427],
              [61.462067, 29.124405],
              [61.461977, 29.124423],
              [61.461971, 29.124491],
              [61.461782, 29.12454],
              [61.461569, 29.124523],
              [61.461423, 29.124566],
              [61.461365, 29.124493],
              [61.461253, 29.124516],
              [61.461114, 29.124706],
              [61.460857, 29.124549],
              [61.46075, 29.12455],
              [61.460638, 29.124679],
              [61.460503, 29.12474],
              [61.460472, 29.124875],
              [61.460379, 29.124988],
              [61.460254, 29.125052],
              [61.46019, 29.125177],
              [61.459852, 29.125171],
              [61.459726, 29.125017],
              [61.459699, 29.124877],
              [61.459226, 29.124729],
              [61.459205, 29.12433],
              [61.458998, 29.124046],
              [61.458435, 29.123659],
              [61.457923, 29.123508],
              [61.457857, 29.123378],
              [61.457541, 29.123634],
              [61.457561, 29.123742],
              [61.457525, 29.123777],
              [61.457152, 29.123966],
              [61.457081, 29.124181],
              [61.457113, 29.124279],
              [61.45685, 29.124249],
              [61.456874, 29.124441],
              [61.456582, 29.124888],
              [61.456522, 29.125286],
              [61.455905, 29.125896],
              [61.455618, 29.126048],
              [61.455335, 29.126294],
              [61.455192, 29.12658],
              [61.454426, 29.127482],
              [61.454263, 29.127632],
              [61.454018, 29.127748],
              [61.454015, 29.127866],
              [61.45391, 29.127906],
              [61.453847, 29.128025],
              [61.453493, 29.128123],
              [61.453416, 29.12829],
              [61.453142, 29.128338],
              [61.452716, 29.128543],
              [61.452539, 29.128556],
              [61.452352, 29.129019],
              [61.452187, 29.129177],
              [61.451651, 29.129964],
              [61.451554, 29.130022],
              [61.451337, 29.130292],
              [61.451235, 29.130553],
              [61.451084, 29.130692],
              [61.450892, 29.131052],
              [61.450778, 29.131092],
              [61.450815, 29.131208],
              [61.450713, 29.131376],
              [61.450851, 29.131512],
              [61.450538, 29.131702],
              [61.450304, 29.131771],
              [61.45018, 29.131874],
              [61.449963, 29.131883],
              [61.449581, 29.131808],
              [61.44939, 29.1317],
              [61.449009, 29.13129],
              [61.448727, 29.131091],
              [61.448595, 29.131162],
              [61.448453, 29.131151],
              [61.447919, 29.131531],
              [61.447763, 29.131422],
              [61.44763, 29.13125],
              [61.44758, 29.131279],
              [61.447288, 29.13116],
              [61.447085, 29.131001],
              [61.446883, 29.130977],
              [61.446723, 29.131157],
              [61.446644, 29.131341],
              [61.446472, 29.131406],
              [61.446371, 29.131381],
              [61.446205, 29.13143],
              [61.446092, 29.131369],
              [61.445738, 29.131399],
              [61.445315, 29.131183],
              [61.445054, 29.131126],
              [61.444887, 29.131195],
              [61.444746, 29.13115],
              [61.444566, 29.131178],
              [61.444002, 29.131522],
              [61.443823, 29.131411],
              [61.4437, 29.131427],
              [61.443562, 29.131382],
              [61.443476, 29.131287],
              [61.443282, 29.131364],
              [61.443002, 29.131319],
              [61.442699, 29.131141],
              [61.442487, 29.131233],
              [61.442331, 29.131393],
              [61.442247, 29.131317],
              [61.441975, 29.131228],
              [61.441745, 29.131038],
              [61.441624, 29.131048],
              [61.441647, 29.130948],
              [61.441522, 29.130889],
              [61.441241, 29.13093],
              [61.440679, 29.130548],
              [61.440504, 29.130533],
              [61.440371, 29.130637],
              [61.43999, 29.130634],
              [61.43949, 29.130532],
              [61.439235, 29.130397],
              [61.438776, 29.130359],
              [61.438619, 29.130497],
              [61.438501, 29.130217],
              [61.438321, 29.13013],
              [61.438296, 29.129866],
              [61.437877, 29.129366],
              [61.438501, 29.129114],
              [61.438707, 29.128939],
              [61.438774, 29.128824],
              [61.438926, 29.128772],
              [61.438888, 29.128455],
              [61.438746, 29.128365],
              [61.438673, 29.128379],
              [61.438523, 29.128544],
              [61.438454, 29.128546],
              [61.437988, 29.128274],
              [61.437777, 29.128215],
              [61.437253, 29.127775],
              [61.436795, 29.127927],
              [61.436486, 29.12796],
              [61.436294, 29.127769],
              [61.435794, 29.127694],
              [61.435233, 29.127732],
              [61.434982, 29.128062],
              [61.43481, 29.128163],
              [61.434356, 29.128331],
              [61.434076, 29.128297],
              [61.433946, 29.128418],
              [61.433781, 29.128445],
              [61.433704, 29.128124],
              [61.433438, 29.127678],
              [61.433248, 29.127626],
              [61.433181, 29.127454],
              [61.43278, 29.127422],
              [61.432811, 29.127287],
              [61.432661, 29.127216],
              [61.432494, 29.127232],
              [61.43237, 29.127167],
              [61.432201, 29.127321],
              [61.432093, 29.127266],
              [61.431857, 29.127433],
              [61.43167, 29.127484],
              [61.431471, 29.127672],
              [61.431416, 29.127638],
              [61.43126, 29.127692],
              [61.43098, 29.128005],
              [61.430912, 29.128181],
              [61.430869, 29.128161],
              [61.430536, 29.128331],
              [61.430449, 29.128563],
              [61.430415, 29.128539],
              [61.430283, 29.128585],
              [61.430188, 29.128716],
              [61.430113, 29.128666],
              [61.429981, 29.128726],
              [61.429411, 29.128794],
              [61.429164, 29.128941],
              [61.428961, 29.12881],
              [61.428817, 29.128631],
              [61.428614, 29.128565],
              [61.428626, 29.128484],
              [61.428462, 29.128396],
              [61.428416, 29.12819],
              [61.428307, 29.12799],
              [61.427906, 29.127943],
              [61.427642, 29.128071],
              [61.427226, 29.12845],
              [61.427011, 29.12849],
              [61.42653, 29.128812],
              [61.426444, 29.12923],
              [61.426295, 29.12927],
              [61.426133, 29.129453],
              [61.425888, 29.12953],
              [61.425669, 29.129764],
              [61.42558, 29.129776],
              [61.425582, 29.129837],
              [61.425366, 29.129981],
              [61.425298, 29.130117],
              [61.424794, 29.13062],
              [61.424889, 29.130856],
              [61.424767, 29.131102],
              [61.42501, 29.131241],
              [61.425128, 29.1314],
              [61.425033, 29.131469],
              [61.425272, 29.131657],
              [61.425663, 29.131857],
              [61.425715, 29.131931],
              [61.425701, 29.1322],
              [61.42586, 29.132309],
              [61.425848, 29.132389],
              [61.426437, 29.132716],
              [61.426369, 29.132866],
              [61.426395, 29.132937],
              [61.426278, 29.133097],
              [61.426576, 29.133385],
              [61.426516, 29.133742],
              [61.426418, 29.133859],
              [61.426253, 29.13394],
              [61.426008, 29.134433],
              [61.425906, 29.13454],
              [61.425816, 29.13449],
              [61.425739, 29.134596],
              [61.425584, 29.134688],
              [61.42541, 29.134706],
              [61.425346, 29.134937],
              [61.425065, 29.135152],
              [61.424955, 29.135404],
              [61.424249, 29.135118],
              [61.424035, 29.135104],
              [61.423779, 29.135236],
              [61.42353, 29.135268],
              [61.423485, 29.135479],
              [61.423143, 29.135611],
              [61.422832, 29.135437],
              [61.42209, 29.134861],
              [61.421586, 29.13498],
              [61.421384, 29.13518],
              [61.421022, 29.1354],
              [61.420823, 29.135652],
              [61.420823, 29.136022],
              [61.420752, 29.136097],
              [61.420775, 29.13618],
              [61.420629, 29.136349],
              [61.420609, 29.136515],
              [61.420523, 29.136566],
              [61.420523, 29.136725],
              [61.420163, 29.137166],
              [61.420129, 29.137445],
              [61.420241, 29.137608],
              [61.420216, 29.137725],
              [61.420128, 29.137731],
              [61.420032, 29.137845],
              [61.419745, 29.137958],
              [61.419657, 29.13804],
              [61.419636, 29.138254],
              [61.419561, 29.138336],
              [61.419635, 29.138433],
              [61.419374, 29.138734],
              [61.419428, 29.138984],
              [61.419387, 29.139073],
              [61.419412, 29.139351],
              [61.419543, 29.139502],
              [61.419493, 29.139674],
              [61.419258, 29.139819],
              [61.419249, 29.139913],
              [61.419149, 29.140011],
              [61.419325, 29.140517],
              [61.419065, 29.140622],
              [61.419046, 29.140793],
              [61.418854, 29.140985],
              [61.418687, 29.140867],
              [61.418467, 29.140813],
              [61.418404, 29.140906],
              [61.418272, 29.140977],
              [61.418064, 29.140926],
              [61.417966, 29.140982],
              [61.417746, 29.141003],
              [61.417488, 29.141236],
              [61.417288, 29.141301],
              [61.417092, 29.141303],
              [61.416778, 29.141511],
              [61.416756, 29.141949],
              [61.416818, 29.141965],
              [61.416749, 29.142024],
              [61.416749, 29.142234],
              [61.416783, 29.142233],
              [61.416864, 29.14246],
              [61.41681, 29.142594],
              [61.416608, 29.142701],
              [61.41672, 29.142971],
              [61.416958, 29.143192],
              [61.416759, 29.143461],
              [61.416698, 29.143706],
              [61.416931, 29.143845],
              [61.417008, 29.143956],
              [61.416936, 29.144023],
              [61.41687, 29.144263],
              [61.416726, 29.14451],
              [61.416772, 29.1447],
              [61.416648, 29.144789],
              [61.416666, 29.14485],
              [61.416491, 29.144887],
              [61.416486, 29.145221],
              [61.416652, 29.145396],
              [61.416636, 29.145584],
              [61.4163, 29.145687],
              [61.416255, 29.145738],
              [61.416201, 29.146],
              [61.416081, 29.146198],
              [61.416065, 29.146383],
              [61.416262, 29.146675],
              [61.416363, 29.14675],
              [61.416459, 29.146756],
              [61.415886, 29.147273],
              [61.415897, 29.147399],
              [61.415748, 29.147544],
              [61.415777, 29.147661],
              [61.415676, 29.147814],
              [61.415587, 29.148185],
              [61.415454, 29.148396],
              [61.415518, 29.14858],
              [61.415622, 29.14865],
              [61.415511, 29.148818],
              [61.41552, 29.148898],
              [61.415273, 29.149065],
              [61.415281, 29.149545],
              [61.415081, 29.149977],
              [61.414834, 29.150244],
              [61.414834, 29.150507],
              [61.414645, 29.15059],
              [61.414586, 29.150748],
              [61.414546, 29.150917],
              [61.414591, 29.151049],
              [61.414559, 29.151234],
              [61.414597, 29.151417],
              [61.414821, 29.151821],
              [61.414732, 29.151979],
              [61.414759, 29.152197],
              [61.414637, 29.152322],
              [61.414356, 29.152445],
              [61.414313, 29.152661],
              [61.414342, 29.152806],
              [61.414271, 29.15296],
              [61.414032, 29.153176],
              [61.413968, 29.153334],
              [61.414061, 29.153484],
              [61.413981, 29.153679],
              [61.41407, 29.153785],
              [61.413454, 29.154226],
              [61.413273, 29.154318],
              [61.412976, 29.154348],
              [61.412949, 29.154499],
              [61.412849, 29.154609],
              [61.412878, 29.15476],
              [61.412784, 29.154818],
              [61.412674, 29.15512],
              [61.412689, 29.155447],
              [61.412743, 29.155621],
              [61.41285, 29.15575],
              [61.412666, 29.155933],
              [61.412613, 29.156106],
              [61.412668, 29.156232],
              [61.412601, 29.156327],
              [61.41252, 29.156668],
              [61.41217, 29.156976],
              [61.412221, 29.157023],
              [61.412208, 29.157152],
              [61.412127, 29.157297],
              [61.412752, 29.157552],
              [61.412761, 29.157903],
              [61.41261, 29.158118],
              [61.412617, 29.158307],
              [61.412444, 29.158403],
              [61.412479, 29.15876],
              [61.412406, 29.15896],
              [61.412684, 29.159588],
              [61.412448, 29.159921],
              [61.412476, 29.160038],
              [61.412283, 29.160211],
              [61.412774, 29.160433],
              [61.412931, 29.160716],
              [61.413182, 29.160996],
              [61.41299, 29.161645],
              [61.412967, 29.161891],
              [61.413242, 29.16221],
              [61.413394, 29.162322],
              [61.413056, 29.163078],
              [61.412995, 29.163353],
              [61.413139, 29.163448],
              [61.413008, 29.16372],
              [61.412817, 29.163769],
              [61.412752, 29.163871],
              [61.412811, 29.164196],
              [61.41287, 29.164201],
              [61.412887, 29.164405],
              [61.41311, 29.164512],
              [61.413811, 29.164502],
              [61.413876, 29.164562],
              [61.414072, 29.164585],
              [61.414411, 29.164744],
              [61.414563, 29.164862],
              [61.414613, 29.164698],
              [61.414877, 29.164426],
              [61.415134, 29.164045],
              [61.415496, 29.163626],
              [61.415556, 29.163429],
              [61.416213, 29.162946],
              [61.416325, 29.162935],
              [61.416888, 29.162588],
              [61.417211, 29.162138],
              [61.417579, 29.162217],
              [61.417999, 29.162408],
              [61.418145, 29.162407],
              [61.418398, 29.162273],
              [61.41847, 29.162444],
              [61.418569, 29.162458],
              [61.418746, 29.162669],
              [61.419083, 29.162855],
              [61.419497, 29.162997],
              [61.419761, 29.16346],
              [61.420175, 29.163675],
              [61.420348, 29.163686],
              [61.420515, 29.163752],
              [61.420639, 29.163892],
              [61.420906, 29.164029],
              [61.420783, 29.164306],
              [61.420764, 29.164545],
              [61.420689, 29.164655],
              [61.420618, 29.165016],
              [61.420417, 29.165157],
              [61.420392, 29.165711],
              [61.420201, 29.165944],
              [61.419987, 29.166502],
              [61.419826, 29.16668],
              [61.419754, 29.166851],
              [61.419533, 29.16704],
              [61.419528, 29.167204],
              [61.419225, 29.167471],
              [61.419058, 29.1677],
              [61.418704, 29.167837],
              [61.418648, 29.168078],
              [61.418435, 29.168299],
              [61.418353, 29.168484],
              [61.418131, 29.168539],
              [61.417778, 29.169073],
              [61.417675, 29.169251],
              [61.417667, 29.169512],
              [61.417454, 29.169491],
              [61.417279, 29.169553],
              [61.41709, 29.16977],
              [61.417012, 29.170077],
              [61.416709, 29.170215],
              [61.416695, 29.170341],
              [61.416568, 29.1705],
              [61.416982, 29.170748],
              [61.416828, 29.17083],
              [61.416531, 29.171528],
              [61.416622, 29.171907],
              [61.416477, 29.171964],
              [61.416309, 29.172238],
              [61.416206, 29.172286],
              [61.41614, 29.172462],
              [61.416096, 29.172829],
              [61.416221, 29.173219],
              [61.416318, 29.173352],
              [61.416211, 29.173363],
              [61.416071, 29.173469],
              [61.415685, 29.173387],
              [61.415445, 29.173417],
              [61.415241, 29.173362],
              [61.415036, 29.173196],
              [61.414677, 29.173334],
              [61.414619, 29.173278],
              [61.4145, 29.173285],
              [61.414488, 29.173422],
              [61.414339, 29.173434],
              [61.414285, 29.173339],
              [61.414028, 29.173345],
              [61.413999, 29.173499],
              [61.413858, 29.173547],
              [61.413867, 29.173623],
              [61.413548, 29.174151],
              [61.41353, 29.174446],
              [61.41339, 29.174681],
              [61.413176, 29.174712],
              [61.413157, 29.174817],
              [61.412824, 29.174776],
              [61.412833, 29.175026],
              [61.412716, 29.175094],
              [61.412662, 29.175262],
              [61.412681, 29.175421],
              [61.412863, 29.175833],
              [61.412897, 29.176134],
              [61.412862, 29.176304],
              [61.412948, 29.176449],
              [61.413029, 29.176758],
              [61.413212, 29.17689],
              [61.413299, 29.177276],
              [61.413431, 29.177507],
              [61.413375, 29.177748],
              [61.4134, 29.178012],
              [61.413982, 29.178373],
              [61.41401, 29.178491],
              [61.413849, 29.178835],
              [61.413972, 29.178838],
              [61.413934, 29.178965],
              [61.41397, 29.179115],
              [61.4139, 29.179269],
              [61.414866, 29.180042],
              [61.414927, 29.180164],
              [61.415162, 29.180297],
              [61.415323, 29.18031],
              [61.415513, 29.180491],
              [61.415833, 29.180506],
              [61.416119, 29.180455],
              [61.416584, 29.180514],
              [61.416762, 29.180546],
              [61.416915, 29.180678],
              [61.417096, 29.180458],
              [61.417435, 29.180254],
              [61.417993, 29.179703],
              [61.418298, 29.180024],
              [61.418458, 29.180267],
              [61.418542, 29.180933],
              [61.418598, 29.181006],
              [61.418946, 29.181101],
              [61.41889, 29.181196],
              [61.41899, 29.181268],
              [61.418949, 29.181416],
              [61.418979, 29.181486],
              [61.419268, 29.181521],
              [61.419651, 29.181432],
              [61.419526, 29.181596],
              [61.419462, 29.181805],
              [61.419531, 29.181903],
              [61.419926, 29.181993],
              [61.42016, 29.182205],
              [61.420233, 29.182218],
              [61.420356, 29.182438],
              [61.42075, 29.182786],
              [61.421234, 29.183334],
              [61.421259, 29.183402],
              [61.421121, 29.183511],
              [61.421103, 29.183579],
              [61.42051, 29.183928],
              [61.420484, 29.18413],
              [61.420356, 29.184238],
              [61.420423, 29.184587],
              [61.420292, 29.184722],
              [61.420275, 29.184809],
              [61.420352, 29.185102],
              [61.420623, 29.185385],
              [61.420397, 29.185631],
              [61.420169, 29.185748],
              [61.420098, 29.185871],
              [61.420262, 29.186151],
              [61.420217, 29.186227],
              [61.420283, 29.186421],
              [61.420516, 29.186706],
              [61.42048, 29.186819],
              [61.420519, 29.186929],
              [61.420449, 29.187032],
              [61.420381, 29.187017],
              [61.420216, 29.187213],
              [61.420108, 29.187459],
              [61.420347, 29.187742],
              [61.42024, 29.187875],
              [61.420278, 29.188164],
              [61.420406, 29.188436],
              [61.42057, 29.188552],
              [61.420585, 29.188607],
              [61.420311, 29.188724],
              [61.420268, 29.188952],
              [61.420383, 29.189045],
              [61.420351, 29.189122],
              [61.420148, 29.189338],
              [61.420131, 29.189504],
              [61.419991, 29.189739],
              [61.419633, 29.190015],
              [61.419606, 29.190264],
              [61.419702, 29.190336],
              [61.41972, 29.190532],
              [61.419807, 29.190663],
              [61.4197, 29.190951],
              [61.419709, 29.191095],
              [61.420056, 29.191248],
              [61.420217, 29.191412],
              [61.420221, 29.191469],
              [61.420329, 29.191522],
              [61.420859, 29.191551],
              [61.421462, 29.191426],
              [61.42169, 29.191503],
              [61.421754, 29.191566],
              [61.421963, 29.191558],
              [61.422342, 29.191812],
              [61.422534, 29.191847],
              [61.422767, 29.191812],
              [61.42302, 29.191678],
              [61.423184, 29.191517],
              [61.4238, 29.191966],
              [61.424218, 29.192203],
              [61.424454, 29.192577],
              [61.42456, 29.192877],
              [61.424189, 29.193004],
              [61.423912, 29.192801],
              [61.423755, 29.19281],
              [61.423533, 29.192994],
              [61.423304, 29.193274],
              [61.42342, 29.193342],
              [61.423499, 29.193561],
              [61.423457, 29.193889],
              [61.423403, 29.193975],
              [61.423485, 29.194158],
              [61.423674, 29.194214],
              [61.423981, 29.194759],
              [61.423927, 29.194844],
              [61.423494, 29.195175],
              [61.423384, 29.195348],
              [61.422974, 29.195648],
              [61.422966, 29.195745],
              [61.423062, 29.195859],
              [61.422734, 29.196256],
              [61.423275, 29.196423],
              [61.423504, 29.196742],
              [61.423584, 29.19676],
              [61.423786, 29.196966],
              [61.424135, 29.197071],
              [61.42441, 29.197319],
              [61.424766, 29.197506],
              [61.424948, 29.197324],
              [61.425179, 29.197281],
              [61.425282, 29.197409],
              [61.42544, 29.197452],
              [61.425599, 29.197436],
              [61.425672, 29.197508],
              [61.425562, 29.197679],
              [61.425849, 29.19795],
              [61.426247, 29.197944],
              [61.426506, 29.198148],
              [61.426562, 29.198259],
              [61.426501, 29.198269],
              [61.426484, 29.198388],
              [61.426626, 29.198481],
              [61.426763, 29.19882],
              [61.426963, 29.198836],
              [61.427096, 29.198911],
              [61.42746, 29.198895],
              [61.427855, 29.198985],
              [61.427939, 29.198884],
              [61.428005, 29.198871],
              [61.428199, 29.19862],
              [61.428515, 29.198563],
              [61.428681, 29.198463],
              [61.429093, 29.198438],
              [61.429641, 29.198105],
              [61.429825, 29.197923],
              [61.43012, 29.19833],
              [61.430255, 29.198877],
              [61.430218, 29.199095],
              [61.429889, 29.199451],
              [61.429656, 29.199814],
              [61.429225, 29.199826],
              [61.429001, 29.200019],
              [61.428798, 29.200095],
              [61.428608, 29.200318],
              [61.428252, 29.200579],
              [61.428045, 29.201064],
              [61.427793, 29.201358],
              [61.427559, 29.20115],
              [61.427142, 29.201189],
              [61.426952, 29.201089],
              [61.426828, 29.201143],
              [61.426464, 29.201577],
              [61.42636, 29.201602],
              [61.426389, 29.201695],
              [61.426277, 29.201856],
              [61.426064, 29.201964],
              [61.426026, 29.202162],
              [61.425556, 29.202915],
              [61.425486, 29.202967],
              [61.425347, 29.202865],
              [61.425064, 29.202825],
              [61.424859, 29.202972],
              [61.424585, 29.202915],
              [61.424416, 29.203241],
              [61.424004, 29.203792],
              [61.423707, 29.203877],
              [61.423515, 29.203767],
              [61.423518, 29.203707],
              [61.423293, 29.203587],
              [61.423087, 29.203522],
              [61.42305, 29.203566],
              [61.422948, 29.203557],
              [61.422688, 29.203251],
              [61.422553, 29.203193],
              [61.422341, 29.203184],
              [61.421992, 29.203596],
              [61.421654, 29.203909],
              [61.421318, 29.204015],
              [61.421095, 29.204036],
              [61.421019, 29.204113],
              [61.420935, 29.204371],
              [61.420762, 29.20455],
              [61.420788, 29.204657],
              [61.420713, 29.204874],
              [61.420746, 29.204979],
              [61.420499, 29.205431],
              [61.42027, 29.205348],
              [61.420055, 29.205379],
              [61.41979, 29.205723],
              [61.419308, 29.205936],
              [61.418447, 29.205703],
              [61.418076, 29.205927],
              [61.417614, 29.205431],
              [61.417308, 29.205687],
              [61.41696, 29.205823],
              [61.416838, 29.205842],
              [61.416432, 29.205788],
              [61.415757, 29.205932],
              [61.415733, 29.206178],
              [61.415531, 29.206313],
              [61.415598, 29.206457],
              [61.415577, 29.206584],
              [61.415439, 29.206746],
              [61.414954, 29.206853],
              [61.414807, 29.20691],
              [61.414703, 29.207048],
              [61.414525, 29.207072],
              [61.414259, 29.207416],
              [61.413937, 29.207649],
              [61.413679, 29.20794],
              [61.413462, 29.208002],
              [61.413315, 29.20797],
              [61.413085, 29.208004],
              [61.41302, 29.208051],
              [61.412584, 29.20775],
              [61.412366, 29.207651],
              [61.411904, 29.207916],
              [61.411726, 29.208141],
              [61.411658, 29.208541],
              [61.411613, 29.208618],
              [61.411516, 29.208623],
              [61.411388, 29.208805],
              [61.411484, 29.208951],
              [61.411424, 29.208966],
              [61.411383, 29.209215],
              [61.41116, 29.209368],
              [61.410798, 29.209487],
              [61.410623, 29.20964],
              [61.410623, 29.209693],
              [61.410433, 29.209798],
              [61.410367, 29.209909],
              [61.41042, 29.210142],
              [61.410368, 29.210253],
              [61.410093, 29.210193],
              [61.409926, 29.209973],
              [61.409711, 29.20987],
              [61.409467, 29.209885],
              [61.409163, 29.210096],
              [61.409164, 29.210203],
              [61.409066, 29.210217],
              [61.408764, 29.210411],
              [61.408527, 29.210614],
              [61.408281, 29.210909],
              [61.408085, 29.210988],
              [61.407805, 29.21125],
              [61.407564, 29.211326],
              [61.407436, 29.21148],
              [61.407419, 29.211674],
              [61.407287, 29.211739],
              [61.40707, 29.212092],
              [61.40692, 29.21246],
              [61.406898, 29.212658],
              [61.406713, 29.212911],
              [61.406335, 29.213196],
              [61.406183, 29.213348],
              [61.406145, 29.213455],
              [61.405945, 29.213589],
              [61.406027, 29.213955],
              [61.40592, 29.214087],
              [61.405721, 29.214149],
              [61.405584, 29.214314],
              [61.405326, 29.214443],
              [61.405377, 29.214632],
              [61.405314, 29.215021],
              [61.405024, 29.215154],
              [61.404803, 29.215319],
              [61.404691, 29.215283],
              [61.404601, 29.215329],
              [61.404487, 29.215288],
              [61.404394, 29.215359],
              [61.404305, 29.215553],
              [61.40409, 29.215549],
              [61.403845, 29.215656],
              [61.403663, 29.215659],
              [61.403525, 29.215595],
              [61.403558, 29.215494],
              [61.403468, 29.215487],
              [61.403318, 29.215389],
              [61.403052, 29.21555],
              [61.402939, 29.215447],
              [61.402927, 29.215306],
              [61.402636, 29.215239],
              [61.402362, 29.215379],
              [61.402351, 29.215437],
              [61.402209, 29.215556],
              [61.402047, 29.215602],
              [61.401712, 29.215898],
              [61.401546, 29.215887],
              [61.401411, 29.21572],
              [61.400925, 29.215738],
              [61.400817, 29.215685],
              [61.400619, 29.215843],
              [61.400522, 29.216106],
              [61.400449, 29.216115],
              [61.400309, 29.21632],
              [61.400108, 29.21636],
              [61.399858, 29.216185],
              [61.399353, 29.215942],
              [61.399313, 29.21598],
              [61.399227, 29.215944],
              [61.398989, 29.216053],
              [61.398847, 29.216225],
              [61.398876, 29.216446],
              [61.398647, 29.216674],
              [61.398503, 29.216753],
              [61.398262, 29.217011],
              [61.39823, 29.217111],
              [61.397839, 29.217422],
              [61.397672, 29.217803],
              [61.397722, 29.21806],
              [61.397538, 29.218162],
              [61.397438, 29.218293],
              [61.397264, 29.218671],
              [61.396907, 29.218808],
              [61.396811, 29.218932],
              [61.396798, 29.219035],
              [61.397288, 29.219342],
              [61.397461, 29.219568],
              [61.397392, 29.219621],
              [61.397282, 29.21987],
              [61.397002, 29.220077],
              [61.397041, 29.220131],
              [61.396788, 29.220247],
              [61.396793, 29.22036],
              [61.396601, 29.220622],
              [61.396317, 29.220803],
              [61.396124, 29.221035],
              [61.39602, 29.221022],
              [61.395779, 29.221131],
              [61.395555, 29.221104],
              [61.395464, 29.221302],
              [61.395599, 29.221402],
              [61.395481, 29.221725],
              [61.395393, 29.221778],
              [61.395221, 29.222056],
              [61.394937, 29.222132],
              [61.394918, 29.22221],
              [61.394778, 29.222346],
              [61.394448, 29.222533],
              [61.393884, 29.223135],
              [61.39356, 29.223368],
              [61.393365, 29.22359],
              [61.393221, 29.223555],
              [61.39311, 29.223684],
              [61.392781, 29.223728],
              [61.392752, 29.223858],
              [61.392702, 29.223871],
              [61.392712, 29.223941],
              [61.391649, 29.224309],
              [61.391471, 29.224275],
              [61.391219, 29.224314],
              [61.391053, 29.224291],
              [61.390997, 29.224361],
              [61.390841, 29.224405],
              [61.390777, 29.22452],
              [61.39066, 29.224544],
              [61.390306, 29.224786],
              [61.390233, 29.224875],
              [61.389894, 29.225011],
              [61.390014, 29.225184],
              [61.390089, 29.225454],
              [61.390072, 29.225724],
              [61.389887, 29.225819],
              [61.389887, 29.225938],
              [61.389765, 29.226084],
              [61.389534, 29.226116],
              [61.389297, 29.226282],
              [61.389276, 29.226394],
              [61.389182, 29.226498],
              [61.389211, 29.226578],
              [61.389054, 29.226792],
              [61.388805, 29.226853],
              [61.388723, 29.226958],
              [61.388634, 29.226903],
              [61.388164, 29.226913],
              [61.387844, 29.227126],
              [61.387622, 29.227198],
              [61.387444, 29.227349],
              [61.387385, 29.227444],
              [61.387416, 29.227599],
              [61.387358, 29.227671],
              [61.38744, 29.227777],
              [61.387316, 29.227912],
              [61.387084, 29.228545],
              [61.386998, 29.228634],
              [61.386773, 29.229139],
              [61.386754, 29.229347],
              [61.386645, 29.229391],
              [61.38649, 29.229267],
              [61.38599, 29.229155],
              [61.385843, 29.229328],
              [61.38566, 29.229431],
              [61.385484, 29.229405],
              [61.384883, 29.229862],
              [61.38496, 29.229941],
              [61.384799, 29.230023],
              [61.384586, 29.230331],
              [61.384277, 29.230276],
              [61.38402, 29.230648],
              [61.383753, 29.230634],
              [61.383316, 29.230859],
              [61.383051, 29.231095],
              [61.383049, 29.231477],
              [61.382911, 29.231632],
              [61.382776, 29.231761],
              [61.382381, 29.23192],
              [61.382262, 29.231921],
              [61.382423, 29.232017],
              [61.382552, 29.232185],
              [61.382557, 29.232339],
              [61.382414, 29.232633],
              [61.382142, 29.232759],
              [61.382098, 29.232967],
              [61.381868, 29.23324],
              [61.381949, 29.233811],
              [61.381664, 29.23399],
              [61.381521, 29.234284],
              [61.381333, 29.234471],
              [61.381171, 29.234503],
              [61.381085, 29.234669],
              [61.38119, 29.234793],
              [61.38089, 29.234802],
              [61.380413, 29.235041],
              [61.379991, 29.235385],
              [61.37995, 29.235526],
              [61.379762, 29.235663],
              [61.379782, 29.235789],
              [61.3797, 29.235883],
              [61.379554, 29.235939],
              [61.379516, 29.235978],
              [61.379557, 29.236013],
              [61.379124, 29.236121],
              [61.37905, 29.23618],
              [61.378878, 29.236198],
              [61.378637, 29.236351],
              [61.378578, 29.236495],
              [61.378407, 29.236546],
              [61.378469, 29.236722],
              [61.378435, 29.237097],
              [61.377853, 29.237516],
              [61.377791, 29.237651],
              [61.377643, 29.237678],
              [61.37763, 29.237836],
              [61.377409, 29.238367],
              [61.377086, 29.238348],
              [61.376969, 29.238213],
              [61.37687, 29.238183],
              [61.376697, 29.238279],
              [61.376638, 29.23837],
              [61.376199, 29.238435],
              [61.375949, 29.238545],
              [61.375866, 29.238778],
              [61.375764, 29.238803],
              [61.375761, 29.23892],
              [61.375597, 29.238986],
              [61.375529, 29.239282],
              [61.375357, 29.239543],
              [61.375111, 29.239669],
              [61.374907, 29.239856],
              [61.37503, 29.239898],
              [61.37511, 29.240007],
              [61.375008, 29.240183],
              [61.374773, 29.240384],
              [61.374804, 29.240644],
              [61.374665, 29.240694],
              [61.374508, 29.24093],
              [61.374605, 29.241648],
              [61.37456, 29.2418],
              [61.374289, 29.241954],
              [61.374093, 29.242214],
              [61.37416, 29.242334],
              [61.374043, 29.242424],
              [61.373956, 29.242581],
              [61.373979, 29.242763],
              [61.373767, 29.242791],
              [61.372966, 29.243313],
              [61.372883, 29.243595],
              [61.372752, 29.243732],
              [61.372683, 29.24389],
              [61.372295, 29.244133],
              [61.372372, 29.24461],
              [61.372313, 29.244705],
              [61.372373, 29.244876],
              [61.372238, 29.244892],
              [61.372123, 29.245042],
              [61.372133, 29.245162],
              [61.372662, 29.24524],
              [61.372781, 29.245366],
              [61.372911, 29.245384],
              [61.373036, 29.245537],
              [61.373531, 29.245843],
              [61.373666, 29.246088],
              [61.373648, 29.246224],
              [61.373813, 29.246413],
              [61.373878, 29.246578],
              [61.374187, 29.247026],
              [61.374324, 29.247071],
              [61.374565, 29.247677],
              [61.374712, 29.247637],
              [61.375471, 29.247752],
              [61.375252, 29.2481],
              [61.375073, 29.248141],
              [61.374893, 29.248332],
              [61.374717, 29.248389],
              [61.374463, 29.249032],
              [61.374192, 29.249213],
              [61.374006, 29.249228],
              [61.373807, 29.249395],
              [61.373572, 29.249491],
              [61.373494, 29.249717],
              [61.37312, 29.250334],
              [61.373156, 29.250532],
              [61.373241, 29.250676],
              [61.373191, 29.250785],
              [61.373232, 29.250982],
              [61.373171, 29.251066],
              [61.372827, 29.251284],
              [61.372612, 29.251332],
              [61.3725, 29.251498],
              [61.37222, 29.251432],
              [61.371057, 29.251518],
              [61.370718, 29.251419],
              [61.370553, 29.251463],
              [61.370267, 29.251348],
              [61.370039, 29.251083],
              [61.370099, 29.250833],
              [61.369629, 29.250765],
              [61.368763, 29.251169],
              [61.368932, 29.251479],
              [61.368548, 29.251506],
              [61.368297, 29.251616],
              [61.367947, 29.251625],
              [61.367779, 29.251713],
              [61.367642, 29.251979],
              [61.367483, 29.251971],
              [61.367172, 29.252144],
              [61.367015, 29.252294],
              [61.366934, 29.252468],
              [61.366763, 29.252513],
              [61.366744, 29.252799],
              [61.366833, 29.252986],
              [61.366717, 29.253081],
              [61.366541, 29.253393],
              [61.366329, 29.25343],
              [61.366217, 29.253513],
              [61.366214, 29.25384],
              [61.366086, 29.25391],
              [61.365689, 29.254509],
              [61.365698, 29.254807],
              [61.365847, 29.254907],
              [61.365839, 29.255175],
              [61.36588, 29.255214],
              [61.366094, 29.255096],
              [61.366181, 29.255116],
              [61.366482, 29.255006],
              [61.366608, 29.255059],
              [61.366814, 29.255367],
              [61.367082, 29.255641],
              [61.367234, 29.255721],
              [61.36741, 29.255642],
              [61.367491, 29.256047],
              [61.367329, 29.256093],
              [61.367199, 29.256243],
              [61.366935, 29.256337],
              [61.366817, 29.256527],
              [61.366617, 29.256572],
              [61.366474, 29.256514],
              [61.365343, 29.256985],
              [61.364969, 29.257455],
              [61.364777, 29.257573],
              [61.364722, 29.257792],
              [61.364473, 29.257958],
              [61.36435, 29.258342],
              [61.36446, 29.258822],
              [61.364738, 29.259063],
              [61.364586, 29.259226],
              [61.364227, 29.259383],
              [61.363832, 29.259456],
              [61.363722, 29.259328],
              [61.3636, 29.259388],
              [61.363393, 29.259332],
              [61.363063, 29.259425],
              [61.362624, 29.259246],
              [61.362241, 29.259333],
              [61.36197, 29.259487],
              [61.361775, 29.259697],
              [61.3619, 29.26011],
              [61.362068, 29.260209],
              [61.362063, 29.260449],
              [61.361913, 29.260506],
              [61.361831, 29.260611],
              [61.361859, 29.260832],
              [61.361608, 29.261054],
              [61.361505, 29.261271],
              [61.361186, 29.261542],
              [61.361119, 29.261888],
              [61.361232, 29.261965],
              [61.36125, 29.262094],
              [61.361397, 29.262231],
              [61.36157, 29.262549],
              [61.361515, 29.262801],
              [61.361522, 29.26322],
              [61.361299, 29.263447],
              [61.361393, 29.263733],
              [61.361298, 29.263885],
              [61.361358, 29.264084],
              [61.361033, 29.264409],
              [61.360978, 29.26499],
              [61.360911, 29.265103],
              [61.360545, 29.265286],
              [61.360348, 29.265477],
              [61.360419, 29.265585],
              [61.360423, 29.26577],
              [61.360333, 29.265816],
              [61.359961, 29.266283],
              [61.360213, 29.266388],
              [61.36032, 29.266755],
              [61.36021, 29.267068],
              [61.360348, 29.26733],
              [61.360119, 29.267464],
              [61.360165, 29.267541],
              [61.360144, 29.267675],
              [61.360051, 29.267758],
              [61.360123, 29.267916],
              [61.360621, 29.268318],
              [61.360819, 29.268567],
              [61.36097, 29.26888],
              [61.361154, 29.268966],
              [61.361259, 29.269244],
              [61.360843, 29.269293],
              [61.360858, 29.269595],
              [61.360934, 29.26974],
              [61.36089, 29.269967],
              [61.361058, 29.270658],
              [61.360994, 29.270914],
              [61.361055, 29.271093],
              [61.361014, 29.271328],
              [61.360858, 29.271802],
              [61.36091, 29.272163],
              [61.360997, 29.27234],
              [61.360321, 29.272789],
              [61.360292, 29.27287],
              [61.360453, 29.27317],
              [61.360439, 29.273381],
              [61.360567, 29.273563],
              [61.360549, 29.273827],
              [61.360354, 29.27401],
              [61.360089, 29.27399],
              [61.360078, 29.274067],
              [61.359981, 29.274161],
              [61.359838, 29.274129],
              [61.359402, 29.27416],
              [61.359314, 29.274238],
              [61.359037, 29.274188],
              [61.359039, 29.274354],
              [61.358916, 29.274467],
              [61.358571, 29.274607],
              [61.358322, 29.274828],
              [61.358121, 29.274879],
              [61.357755, 29.274747],
              [61.357602, 29.274816],
              [61.35744, 29.274665],
              [61.357291, 29.274623],
              [61.357108, 29.274648],
              [61.356945, 29.274442],
              [61.356687, 29.274443],
              [61.356464, 29.274354],
              [61.356281, 29.274352],
              [61.3559, 29.274809],
              [61.355628, 29.274332],
              [61.355511, 29.274287],
              [61.355417, 29.274362],
              [61.354837, 29.274554],
              [61.354481, 29.274564],
              [61.354131, 29.274966],
              [61.353901, 29.275019],
              [61.353629, 29.275184],
              [61.353602, 29.275386],
              [61.3534, 29.27567],
              [61.353047, 29.275851],
              [61.352909, 29.275983],
              [61.353043, 29.276228],
              [61.352999, 29.276304],
              [61.353026, 29.27642],
              [61.353277, 29.276492],
              [61.353521, 29.276643],
              [61.353492, 29.276837],
              [61.353604, 29.276909],
              [61.353777, 29.277208],
              [61.353789, 29.277288],
              [61.353593, 29.277676],
              [61.35358, 29.278011],
              [61.353945, 29.278376],
              [61.353889, 29.278565],
              [61.354308, 29.27923],
              [61.354707, 29.2794],
              [61.354727, 29.27964],
              [61.354846, 29.279821],
              [61.354886, 29.280062],
              [61.354849, 29.280225],
              [61.354748, 29.28033],
              [61.354654, 29.280293],
              [61.354067, 29.280402],
              [61.353843, 29.280518],
              [61.353762, 29.280678],
              [61.353838, 29.280813],
              [61.353962, 29.281298],
              [61.354187, 29.281503],
              [61.354205, 29.281809],
              [61.354375, 29.282152],
              [61.354427, 29.282474],
              [61.354612, 29.282578],
              [61.35458, 29.28277],
              [61.35444, 29.283],
              [61.354515, 29.283168],
              [61.354374, 29.283642],
              [61.354151, 29.283705],
              [61.353665, 29.283985],
              [61.353595, 29.284118],
              [61.353195, 29.284026],
              [61.352956, 29.284023],
              [61.352901, 29.284084],
              [61.35265, 29.284139],
              [61.352601, 29.284199],
              [61.352212, 29.284176],
              [61.351983, 29.284427],
              [61.351844, 29.284833],
              [61.351668, 29.284965],
              [61.351712, 29.285086],
              [61.35143, 29.285138],
              [61.350787, 29.2854],
              [61.350975, 29.285734],
              [61.351545, 29.286313],
              [61.351628, 29.28659],
              [61.35149, 29.286788],
              [61.351729, 29.287662],
              [61.352003, 29.287674],
              [61.352121, 29.287723],
              [61.352101, 29.287926],
              [61.352241, 29.288196],
              [61.352335, 29.288245],
              [61.352194, 29.288523],
              [61.352263, 29.288731],
              [61.352629, 29.288891],
              [61.352738, 29.288819],
              [61.352932, 29.288997],
              [61.353093, 29.289037],
              [61.353409, 29.289252],
              [61.353992, 29.289319],
              [61.354377, 29.289326],
              [61.354784, 29.288756],
              [61.35475, 29.288678],
              [61.354886, 29.28867],
              [61.35498, 29.288752],
              [61.355476, 29.288823],
              [61.356437, 29.289405],
              [61.356602, 29.29025],
              [61.356838, 29.290364],
              [61.357211, 29.290426],
              [61.357462, 29.290551],
              [61.357617, 29.290698],
              [61.357962, 29.290876],
              [61.358247, 29.291118],
              [61.359382, 29.290948],
              [61.359474, 29.291],
              [61.359794, 29.290901],
              [61.360189, 29.290851],
              [61.360332, 29.290785],
              [61.360436, 29.290643],
              [61.36048, 29.290665],
              [61.360824, 29.290575],
              [61.361498, 29.290593],
              [61.361809, 29.290698],
              [61.362326, 29.290529],
              [61.362677, 29.290584],
              [61.362939, 29.290524],
              [61.363073, 29.290572],
              [61.363217, 29.290674],
              [61.363522, 29.291065],
              [61.363642, 29.291113],
              [61.363886, 29.291331],
              [61.364077, 29.29172],
              [61.364495, 29.291911],
              [61.364636, 29.292094],
              [61.364701, 29.292452],
              [61.36466, 29.292662],
              [61.36479, 29.292877],
              [61.364741, 29.292959],
              [61.364906, 29.293043],
              [61.364984, 29.293235],
              [61.364997, 29.293357],
              [61.364864, 29.293536],
              [61.364931, 29.293594],
              [61.364923, 29.293729],
              [61.365195, 29.293828],
              [61.365336, 29.293927],
              [61.365403, 29.294061],
              [61.365503, 29.294046],
              [61.365612, 29.294105],
              [61.365604, 29.294176],
              [61.365692, 29.294242],
              [61.365752, 29.294424],
              [61.365954, 29.294494],
              [61.366263, 29.294782],
              [61.366844, 29.295077],
              [61.366834, 29.295129],
              [61.366965, 29.295344],
              [61.367445, 29.295299],
              [61.3676, 29.295368],
              [61.367809, 29.295553],
              [61.367746, 29.29566],
              [61.367918, 29.295825],
              [61.368117, 29.296129],
              [61.368151, 29.296294],
              [61.368297, 29.296432],
              [61.368513, 29.296544],
              [61.368537, 29.296694],
              [61.36862, 29.296755],
              [61.369014, 29.296899],
              [61.369808, 29.296902],
              [61.370053, 29.297081],
              [61.370346, 29.29747],
              [61.370156, 29.297807],
              [61.369993, 29.297966],
              [61.370033, 29.298108],
              [61.370001, 29.298314],
              [61.370063, 29.298573],
              [61.370025, 29.298885],
              [61.369529, 29.299388],
              [61.369529, 29.299543],
              [61.369387, 29.299843],
              [61.369242, 29.299921],
              [61.368956, 29.300354],
              [61.368814, 29.300444],
              [61.368501, 29.300528],
              [61.368113, 29.300513],
              [61.368273, 29.300647],
              [61.368212, 29.301412],
              [61.368102, 29.301739],
              [61.36763, 29.302447],
              [61.367081, 29.303121],
              [61.367065, 29.30329],
              [61.366982, 29.30339],
              [61.366582, 29.30364],
              [61.366334, 29.303967],
              [61.366148, 29.304032],
              [61.365972, 29.304338],
              [61.365919, 29.304769],
              [61.366031, 29.305002],
              [61.366035, 29.305123],
              [61.366173, 29.305223],
              [61.36616, 29.305326],
              [61.366568, 29.3054],
              [61.366705, 29.3055],
              [61.366879, 29.305515],
              [61.366974, 29.305674],
              [61.366948, 29.305829],
              [61.36688, 29.305886],
              [61.366815, 29.30627],
              [61.366998, 29.306533],
              [61.366926, 29.30678],
              [61.367003, 29.306842],
              [61.366804, 29.307375],
              [61.366779, 29.307635],
              [61.366622, 29.307688],
              [61.366515, 29.307637],
              [61.366055, 29.307872],
              [61.365979, 29.308159],
              [61.365901, 29.308279],
              [61.365496, 29.308559],
              [61.365423, 29.308961],
              [61.365325, 29.309075],
              [61.36521, 29.309358],
              [61.36505, 29.309556],
              [61.365075, 29.309684],
              [61.364909, 29.309938],
              [61.364636, 29.310109],
              [61.364817, 29.310522],
              [61.36515, 29.310717],
              [61.365126, 29.311012],
              [61.365212, 29.311298],
              [61.365305, 29.311338],
              [61.365389, 29.311292],
              [61.365514, 29.311497],
              [61.365597, 29.311527],
              [61.365598, 29.311603],
              [61.365743, 29.311669],
              [61.365876, 29.311665],
              [61.365842, 29.311801],
              [61.365941, 29.31196],
              [61.365884, 29.312025],
              [61.365942, 29.312195],
              [61.366427, 29.312245],
              [61.366545, 29.312295],
              [61.366548, 29.312341],
              [61.366713, 29.312367],
              [61.366769, 29.312507],
              [61.366711, 29.312636],
              [61.366859, 29.312856],
              [61.367002, 29.31295],
              [61.36703, 29.313057],
              [61.36749, 29.313377],
              [61.367177, 29.313828],
              [61.367403, 29.313849],
              [61.367635, 29.313989],
              [61.367944, 29.314365],
              [61.367822, 29.314546],
              [61.367877, 29.314657],
              [61.367824, 29.314773],
              [61.367873, 29.31499],
              [61.367979, 29.315045],
              [61.368011, 29.31512],
              [61.367923, 29.315254],
              [61.367951, 29.315393],
              [61.367849, 29.31547],
              [61.367846, 29.315656],
              [61.367651, 29.315807],
              [61.367665, 29.31587],
              [61.367444, 29.31609],
              [61.367291, 29.31617],
              [61.366927, 29.316494],
              [61.367198, 29.316528],
              [61.367328, 29.316615],
              [61.367538, 29.316571],
              [61.367663, 29.316634],
              [61.367808, 29.316794],
              [61.366917, 29.317728],
              [61.366699, 29.318124],
              [61.366701, 29.318211],
              [61.366544, 29.318419],
              [61.366552, 29.318488],
              [61.366404, 29.318618],
              [61.366417, 29.318681],
              [61.366218, 29.318972],
              [61.366645, 29.319098],
              [61.366918, 29.319247],
              [61.367005, 29.319361],
              [61.367048, 29.319531],
              [61.367013, 29.319665],
              [61.367359, 29.320167],
              [61.367454, 29.320179],
              [61.36748, 29.320125],
              [61.367607, 29.320093],
              [61.367802, 29.320255],
              [61.368035, 29.320526],
              [61.3681, 29.320758],
              [61.368197, 29.320885],
              [61.368326, 29.32086],
              [61.368498, 29.320623],
              [61.368501, 29.32052],
              [61.368694, 29.320334],
              [61.368863, 29.320306],
              [61.368891, 29.320259],
              [61.368979, 29.320278],
              [61.369011, 29.320188],
              [61.369329, 29.319825],
              [61.369491, 29.319836],
              [61.369624, 29.319925],
              [61.369742, 29.319787],
              [61.369855, 29.319803],
              [61.370222, 29.320039],
              [61.37028, 29.32],
              [61.370392, 29.320015],
              [61.370717, 29.320214],
              [61.370888, 29.320229],
              [61.371053, 29.320309],
              [61.371103, 29.320284],
              [61.371324, 29.320412],
              [61.371451, 29.320406],
              [61.371572, 29.32047],
              [61.371711, 29.320652],
              [61.372156, 29.321058],
              [61.371989, 29.321236],
              [61.372079, 29.321318],
              [61.371653, 29.32185],
              [61.371661, 29.321907],
              [61.371215, 29.322294],
              [61.371206, 29.322487],
              [61.371083, 29.322743],
              [61.370969, 29.322783],
              [61.370729, 29.32298],
              [61.370299, 29.32319],
              [61.37018, 29.323441],
              [61.370186, 29.323489],
              [61.370369, 29.323611],
              [61.370463, 29.323906],
              [61.370567, 29.324024],
              [61.370167, 29.324581],
              [61.370237, 29.324721],
              [61.369999, 29.325022],
              [61.370037, 29.325076],
              [61.369948, 29.325194],
              [61.370116, 29.325263],
              [61.370179, 29.325363],
              [61.370367, 29.325436],
              [61.370424, 29.325625],
              [61.370659, 29.325767],
              [61.370748, 29.325925],
              [61.37047, 29.326213],
              [61.370229, 29.326559],
              [61.370355, 29.326742],
              [61.370537, 29.326884],
              [61.370638, 29.327175],
              [61.370279, 29.327703],
              [61.370313, 29.327787],
              [61.369946, 29.328029],
              [61.369809, 29.328075],
              [61.369737, 29.328518],
              [61.369783, 29.328675],
              [61.369592, 29.328823],
              [61.369417, 29.329058],
              [61.369411, 29.329291],
              [61.369506, 29.329566],
              [61.369622, 29.329714],
              [61.369737, 29.329728],
              [61.369705, 29.329793],
              [61.3698, 29.329874],
              [61.36959, 29.330123],
              [61.369627, 29.330141],
              [61.369645, 29.330367],
              [61.369453, 29.330728],
              [61.369414, 29.330917],
              [61.369522, 29.331223],
              [61.369479, 29.331613],
              [61.369386, 29.331869],
              [61.369434, 29.331952],
              [61.369663, 29.332063],
              [61.370036, 29.332478],
              [61.370074, 29.332774],
              [61.370011, 29.3333],
              [61.369907, 29.333521],
              [61.369758, 29.333656],
              [61.369873, 29.33376],
              [61.370096, 29.333677],
              [61.370274, 29.333742],
              [61.370293, 29.334041],
              [61.369986, 29.33422],
              [61.369864, 29.334364],
              [61.369905, 29.334764],
              [61.370264, 29.334768],
              [61.370566, 29.334971],
              [61.370668, 29.335092],
              [61.370666, 29.3352],
              [61.370797, 29.335404],
              [61.370797, 29.335567],
              [61.370892, 29.335681],
              [61.370743, 29.335901],
              [61.371005, 29.336546],
              [61.371183, 29.336403],
              [61.371559, 29.336304],
              [61.371748, 29.336195],
              [61.371845, 29.33624],
              [61.371871, 29.336335],
              [61.372177, 29.336526],
              [61.372059, 29.33665],
              [61.372111, 29.336879],
              [61.37184, 29.337111],
              [61.371678, 29.337354],
              [61.37137, 29.337667],
              [61.371604, 29.337882],
              [61.371892, 29.337967],
              [61.371968, 29.338074],
              [61.372324, 29.338113],
              [61.372411, 29.338336],
              [61.372551, 29.338413],
              [61.372526, 29.338452],
              [61.372727, 29.338609],
              [61.373051, 29.339275],
              [61.372796, 29.339472],
              [61.37264, 29.339532],
              [61.372313, 29.339881],
              [61.372195, 29.339902],
              [61.371966, 29.340669],
              [61.371836, 29.340765],
              [61.371948, 29.340998],
              [61.371881, 29.341033],
              [61.371849, 29.341157],
              [61.371767, 29.341143],
              [61.371698, 29.341194],
              [61.371618, 29.341337],
              [61.371409, 29.341386],
              [61.371342, 29.341526],
              [61.371235, 29.341569],
              [61.371089, 29.341752],
              [61.370969, 29.341774],
              [61.370883, 29.341869],
              [61.370878, 29.342186],
              [61.370691, 29.342364],
              [61.370775, 29.342468],
              [61.370669, 29.342525],
              [61.370665, 29.34258],
              [61.37055, 29.342623],
              [61.370567, 29.342729],
              [61.370387, 29.342841],
              [61.370374, 29.342914],
              [61.370022, 29.34316],
              [61.370001, 29.343269],
              [61.369798, 29.343552],
              [61.369767, 29.343727],
              [61.36971, 29.343689],
              [61.369592, 29.343884],
              [61.369417, 29.344036],
              [61.369466, 29.344124],
              [61.369399, 29.344079],
              [61.369323, 29.344135],
              [61.369235, 29.344268],
              [61.369055, 29.344357],
              [61.368804, 29.344637],
              [61.368877, 29.344918],
              [61.368814, 29.34497],
              [61.3688, 29.345119],
              [61.368771, 29.345093],
              [61.368705, 29.345131],
              [61.368558, 29.345265],
              [61.368461, 29.345465],
              [61.368474, 29.345531],
              [61.368367, 29.345526],
              [61.368274, 29.345652],
              [61.368165, 29.345874],
              [61.36816, 29.345992],
              [61.367985, 29.346056],
              [61.367761, 29.346262],
              [61.367544, 29.346638],
              [61.367509, 29.346933],
              [61.367296, 29.346932],
              [61.367161, 29.347208],
              [61.367077, 29.347229],
              [61.367051, 29.347376],
              [61.366813, 29.347502],
              [61.366747, 29.347857],
              [61.366413, 29.347977],
              [61.366043, 29.348369],
              [61.366018, 29.348472],
              [61.365905, 29.348421],
              [61.36579, 29.348874],
              [61.365687, 29.348889],
              [61.365434, 29.349042],
              [61.365435, 29.349257],
              [61.365243, 29.349432],
              [61.365286, 29.349546],
              [61.365031, 29.349807],
              [61.364765, 29.349889],
              [61.364786, 29.350066],
              [61.36494, 29.350451],
              [61.365252, 29.350472],
              [61.365443, 29.350615],
              [61.365374, 29.35079],
              [61.36447, 29.351889],
              [61.364443, 29.351988],
              [61.364507, 29.352068],
              [61.364507, 29.352161],
              [61.364106, 29.352607],
              [61.364293, 29.352991],
              [61.364542, 29.352907],
              [61.364647, 29.353018],
              [61.364563, 29.353157],
              [61.364559, 29.35328],
              [61.364369, 29.353396],
              [61.364298, 29.353498],
              [61.364296, 29.353802],
              [61.364362, 29.353982],
              [61.364647, 29.35404],
              [61.364613, 29.354375],
              [61.364921, 29.354495],
              [61.364981, 29.354577],
              [61.364901, 29.354792],
              [61.364737, 29.35504],
              [61.364287, 29.355403],
              [61.364237, 29.35552],
              [61.364261, 29.355711],
              [61.363774, 29.356013],
              [61.363259, 29.356703],
              [61.362841, 29.356874],
              [61.362104, 29.358037],
              [61.361877, 29.35821],
              [61.361787, 29.358394],
              [61.361671, 29.358515],
              [61.361473, 29.358622],
              [61.361256, 29.358881],
              [61.361023, 29.358937],
              [61.36189, 29.359332],
              [61.361996, 29.359399],
              [61.362113, 29.35961],
              [61.362408, 29.359395],
              [61.362674, 29.359616],
              [61.362821, 29.3599],
              [61.363221, 29.359938],
              [61.36329, 29.359807],
              [61.363593, 29.359669],
              [61.363783, 29.35967],
              [61.36415, 29.359196],
              [61.364407, 29.359008],
              [61.364535, 29.358846],
              [61.365183, 29.359167],
              [61.365237, 29.359391],
              [61.36519, 29.359567],
              [61.365567, 29.360157],
              [61.365988, 29.360191],
              [61.366127, 29.360672],
              [61.366672, 29.361312],
              [61.367054, 29.361667],
              [61.367087, 29.361802],
              [61.366945, 29.36184],
              [61.366915, 29.361948],
              [61.366744, 29.362051],
              [61.366542, 29.362301],
              [61.366132, 29.362251],
              [61.366066, 29.362323],
              [61.365993, 29.362557],
              [61.365874, 29.362688],
              [61.365557, 29.36281],
              [61.365417, 29.36295],
              [61.36522, 29.363014],
              [61.36516, 29.363089],
              [61.364756, 29.36313],
              [61.364505, 29.363317],
              [61.364268, 29.363423],
              [61.364189, 29.363561],
              [61.364299, 29.363764],
              [61.364224, 29.364101],
              [61.364277, 29.364321],
              [61.364377, 29.364389],
              [61.364466, 29.36464],
              [61.364389, 29.364602],
              [61.364177, 29.364717],
              [61.363927, 29.365026],
              [61.3639, 29.36531],
              [61.36357, 29.365586],
              [61.363512, 29.365695],
              [61.363579, 29.366064],
              [61.363415, 29.366243],
              [61.363321, 29.366247],
              [61.3633, 29.366368],
              [61.362927, 29.366633],
              [61.36284, 29.366802],
              [61.362755, 29.366868],
              [61.362746, 29.366972],
              [61.362612, 29.36716],
              [61.362647, 29.367374],
              [61.362503, 29.367378],
              [61.362371, 29.367668],
              [61.361823, 29.367968],
              [61.361796, 29.36811],
              [61.361707, 29.368113],
              [61.36156, 29.368411],
              [61.361282, 29.36853],
              [61.361214, 29.368621],
              [61.36122, 29.368738],
              [61.361089, 29.368866],
              [61.361159, 29.369366],
              [61.361259, 29.369596],
              [61.361348, 29.369641],
              [61.36146, 29.369829],
              [61.361604, 29.370403],
              [61.361873, 29.370936],
              [61.361693, 29.371167],
              [61.361767, 29.371287],
              [61.361632, 29.371668],
              [61.36168, 29.371913],
              [61.361532, 29.372402],
              [61.361157, 29.37291],
              [61.361213, 29.373026],
              [61.361155, 29.373064],
              [61.361179, 29.37314],
              [61.361051, 29.373166],
              [61.360862, 29.373088],
              [61.360636, 29.373067],
              [61.360338, 29.373155],
              [61.360203, 29.373153],
              [61.360127, 29.373219],
              [61.36014, 29.373667],
              [61.360228, 29.373803],
              [61.360111, 29.373978],
              [61.35987, 29.374183],
              [61.359846, 29.37426],
              [61.359665, 29.374331],
              [61.359548, 29.374484],
              [61.359594, 29.374929],
              [61.359376, 29.375369],
              [61.359075, 29.375607],
              [61.359073, 29.375725],
              [61.35897, 29.375784],
              [61.358985, 29.375847],
              [61.359056, 29.375831],
              [61.359171, 29.375947],
              [61.359326, 29.376242],
              [61.359438, 29.37622],
              [61.359518, 29.376343],
              [61.359621, 29.376364],
              [61.35982, 29.376716],
              [61.359999, 29.376915],
              [61.359979, 29.377049],
              [61.359871, 29.377227],
              [61.359978, 29.377484],
              [61.359875, 29.377549],
              [61.359882, 29.37767],
              [61.359927, 29.377974],
              [61.360069, 29.378134],
              [61.360123, 29.378458],
              [61.359646, 29.37866],
              [61.359506, 29.378825],
              [61.359225, 29.379006],
              [61.359165, 29.379113],
              [61.358922, 29.379081],
              [61.358691, 29.379271],
              [61.358594, 29.379214],
              [61.358488, 29.379287],
              [61.358395, 29.379261],
              [61.358241, 29.379292],
              [61.357957, 29.37946],
              [61.357733, 29.37939],
              [61.357478, 29.379433],
              [61.357309, 29.379569],
              [61.357247, 29.379692],
              [61.357005, 29.379701],
              [61.356854, 29.379885],
              [61.356593, 29.379985],
              [61.356502, 29.380096],
              [61.356145, 29.380192],
              [61.356051, 29.380299],
              [61.355923, 29.380652],
              [61.355758, 29.380846],
              [61.355774, 29.381087],
              [61.355848, 29.381212],
              [61.355772, 29.381244],
              [61.355768, 29.381343],
              [61.355662, 29.381459],
              [61.355419, 29.381471],
              [61.355061, 29.381703],
              [61.355014, 29.381879],
              [61.355062, 29.382055],
              [61.354965, 29.38228],
              [61.355039, 29.382297],
              [61.35504, 29.382431],
              [61.354813, 29.382716],
              [61.354796, 29.383306],
              [61.354677, 29.383349],
              [61.354581, 29.383532],
              [61.354121, 29.384034],
              [61.354162, 29.384065],
              [61.354152, 29.384256],
              [61.354094, 29.38433],
              [61.354085, 29.384489],
              [61.354161, 29.384594],
              [61.354017, 29.384671],
              [61.353975, 29.384763],
              [61.353691, 29.384836],
              [61.353487, 29.385072],
              [61.353244, 29.385177],
              [61.353224, 29.38545],
              [61.353132, 29.38551],
              [61.352934, 29.38593],
              [61.352766, 29.386044],
              [61.352744, 29.386154],
              [61.35251, 29.386247],
              [61.352083, 29.386669],
              [61.351981, 29.386665],
              [61.351755, 29.386807],
              [61.351651, 29.386999],
              [61.351539, 29.387036],
              [61.351357, 29.387197],
              [61.351234, 29.387229],
              [61.351035, 29.38754],
              [61.350918, 29.387546],
              [61.350765, 29.38764],
              [61.3504, 29.388255],
              [61.350286, 29.388118],
              [61.350278, 29.387956],
              [61.349814, 29.387901],
              [61.349609, 29.387815],
              [61.349266, 29.387864],
              [61.348628, 29.387677],
              [61.348275, 29.387684],
              [61.348033, 29.387517],
              [61.347955, 29.387028],
              [61.347901, 29.38697],
              [61.348134, 29.386601],
              [61.348194, 29.386548],
              [61.348322, 29.386581],
              [61.348477, 29.386448],
              [61.348319, 29.386196],
              [61.348347, 29.385686],
              [61.348603, 29.385486],
              [61.349057, 29.385533],
              [61.349053, 29.385377],
              [61.349246, 29.385148],
              [61.349116, 29.385059],
              [61.349125, 29.385016],
              [61.35024, 29.3842],
              [61.350359, 29.384071],
              [61.350371, 29.383932],
              [61.350605, 29.383812],
              [61.350632, 29.38368],
              [61.350724, 29.383576],
              [61.350911, 29.383458],
              [61.351147, 29.383211],
              [61.351157, 29.383133],
              [61.35096, 29.382989],
              [61.3506, 29.383109],
              [61.35019, 29.3823],
              [61.350164, 29.381924],
              [61.349957, 29.381679],
              [61.349654, 29.381666],
              [61.349568, 29.381622],
              [61.349405, 29.381419],
              [61.349062, 29.381436],
              [61.348482, 29.381695],
              [61.348301, 29.381656],
              [61.34819, 29.381692],
              [61.348171, 29.381787],
              [61.34796, 29.381735],
              [61.347072, 29.381926],
              [61.346601, 29.381839],
              [61.346193, 29.381969],
              [61.346134, 29.382034],
              [61.346169, 29.382321],
              [61.346031, 29.382446],
              [61.346017, 29.382535],
              [61.345926, 29.382589],
              [61.345385, 29.382687],
              [61.345116, 29.382581],
              [61.344991, 29.382608],
              [61.344873, 29.382524],
              [61.344839, 29.382485],
              [61.344867, 29.382286],
              [61.344736, 29.381977],
              [61.344648, 29.381877],
              [61.344545, 29.381858],
              [61.344255, 29.38207],
              [61.344036, 29.382111],
              [61.343794, 29.382083],
              [61.343613, 29.382166],
              [61.343362, 29.382484],
              [61.343428, 29.382699],
              [61.343254, 29.382975],
              [61.343214, 29.383519],
              [61.343112, 29.383661],
              [61.342913, 29.383811],
              [61.342492, 29.383816],
              [61.342284, 29.383904],
              [61.342134, 29.384198],
              [61.342037, 29.384281],
              [61.341774, 29.384272],
              [61.341761, 29.384179],
              [61.341531, 29.384039],
              [61.341584, 29.383887],
              [61.341555, 29.383834],
              [61.340612, 29.383239],
              [61.340597, 29.383061],
              [61.340472, 29.382939],
              [61.340009, 29.382664],
              [61.339546, 29.382457],
              [61.339433, 29.382201],
              [61.339514, 29.381999],
              [61.339949, 29.381556],
              [61.339905, 29.381374],
              [61.339733, 29.381237],
              [61.338991, 29.380875],
              [61.338514, 29.380496],
              [61.337617, 29.379999],
              [61.336651, 29.379633],
              [61.334966, 29.379508],
              [61.334094, 29.379554],
              [61.333649, 29.379991],
              [61.333124, 29.380317],
              [61.332904, 29.380681],
              [61.332589, 29.380946],
              [61.332039, 29.381825],
              [61.331541, 29.382231],
              [61.331018, 29.382812],
              [61.330437, 29.383346],
              [61.329864, 29.383787],
              [61.329342, 29.384277],
              [61.327044, 29.386193],
              [61.325699, 29.386741],
              [61.324618, 29.387531],
              [61.323683, 29.388129],
              [61.323372, 29.38823],
              [61.322657, 29.388338],
              [61.322278, 29.38845],
              [61.3217201, 29.3888221],
              [61.320686, 29.389512],
              [61.320115, 29.389821],
              [61.31897, 29.390628],
              [61.318524, 29.390878],
              [61.317207, 29.391401],
              [61.316024, 29.391804],
              [61.314358, 29.392759],
              [61.311383, 29.393731],
              [61.310747, 29.394097],
              [61.308947, 29.395202],
              [61.308121, 29.395941],
              [61.30607, 29.398003],
              [61.305513, 29.398435],
              [61.303527, 29.399676],
              [61.302753, 29.400209],
              [61.302513, 29.400497],
              [61.302134, 29.400803],
              [61.301268, 29.401372],
              [61.300881, 29.401864],
              [61.300736, 29.402491],
              [61.300743, 29.403183],
              [61.300541, 29.403838],
              [61.300017, 29.404691],
              [61.299873, 29.405135],
              [61.299979, 29.405865],
              [61.30035, 29.406628],
              [61.300363, 29.407031],
              [61.300304, 29.407286],
              [61.29994, 29.407932],
              [61.299716, 29.408438],
              [61.299624, 29.409541],
              [61.299458, 29.410114],
              [61.299412, 29.411513],
              [61.299478, 29.411996],
              [61.299486, 29.412804],
              [61.299428, 29.413184],
              [61.2353421, 29.4641137],
              [61.2320235, 29.4696912],
              [61.2217156, 29.4780548],
              [61.2212034, 29.4809464],
              [61.2210133, 29.4808725],
              [61.2208561, 29.4808567],
              [61.2204549, 29.4809071],
              [61.220136, 29.4808732],
              [61.2198594, 29.4810547],
              [61.2197639, 29.4810869],
              [61.2193373, 29.4810763],
              [61.2185057, 29.4811886],
              [61.2176493, 29.4813308],
              [61.2171237, 29.4815133],
              [61.2169451, 29.4817619],
              [61.2167532, 29.4820097],
              [61.216194, 29.4824562],
              [61.215709, 29.4827213],
              [61.2153039, 29.4828529],
              [61.2149821, 29.4833843],
              [61.214763, 29.4833446],
              [61.2144958, 29.4834782],
              [61.2143707, 29.483707],
              [61.2139346, 29.48367],
              [61.2136377, 29.4836931],
              [61.2133225, 29.4837535],
              [61.213215, 29.4838792],
              [61.2132162, 29.4841029],
              [61.2130954, 29.4843746],
              [61.2127678, 29.48445],
              [61.2126143, 29.484631],
              [61.2125319, 29.4848215],
              [61.2123365, 29.4850465],
              [61.2121797, 29.4853006],
              [61.2120362, 29.4854206],
              [61.2118719, 29.4857112],
              [61.2121128, 29.487542],
              [61.2087381, 29.4883635],
              [61.2050326, 29.4882717],
              [61.2048662, 29.489315],
              [61.1975959, 29.4910862],
              [61.1908924, 29.4929592],
              [61.1889622, 29.4935552],
              [61.184553, 29.4952085],
              [61.1816175, 29.4963737],
              [61.1777387, 29.4976165],
              [61.1770493, 29.4977398],
              [61.1716957, 29.4980154],
              [61.1662274, 29.4976687],
              [61.1616195, 29.5024401],
              [61.1546667, 29.5071932],
              [61.1477422, 29.5121783],
              [61.1453607, 29.5139524],
              [61.1434524, 29.5167712],
              [61.1417798, 29.5186262],
              [61.1396231, 29.5228239],
              [61.1358982, 29.5259038],
              [61.1304355, 29.5292473],
              [61.1255348, 29.5325189],
              [61.1251865, 29.5328019],
              [61.1247366, 29.5330909],
              [61.1247226, 29.5331575],
              [61.1247329, 29.5333425],
              [61.1245932, 29.5340108],
              [61.1244863, 29.5343929],
              [61.1249178, 29.5348847],
              [61.1254562, 29.5354717],
              [61.1270274, 29.5368172],
              [61.1277035, 29.537373],
              [61.127964, 29.5375169],
              [61.1288759, 29.5376687],
              [61.1298431, 29.5381779],
              [61.1302485, 29.5384736],
              [61.1302995, 29.5387005],
              [61.1301796, 29.5394228],
              [61.1301651, 29.5409235],
              [61.1299939, 29.5413236],
              [61.1298535, 29.5414268],
              [61.1296707, 29.5417384],
              [61.1296481, 29.5423279],
              [61.1290635, 29.5457343],
              [61.1242566, 29.5659628],
              [61.1256414, 29.5675799],
              [61.1260893, 29.5682972],
              [61.1278575, 29.5711296],
              [61.1214366, 29.579641],
              [61.0824282, 29.632812],
              [61.0598972, 29.6496589],
              [61.0511645, 29.6606111],
              [61.0485059, 29.6617761],
              [61.0475092, 29.6623818],
              [61.0475215, 29.6627166],
              [61.0475837, 29.6629895],
              [61.0475967, 29.6634815],
              [61.0478767, 29.6642135],
              [61.0473777, 29.6648579],
              [61.0471458, 29.6650573],
              [61.0467581, 29.6651906],
              [61.0461985, 29.6656488],
              [61.0455751, 29.6662632],
              [60.9890737, 29.7261254],
              [60.9889353, 29.726272],
              [60.9869687, 29.7280507],
              [60.9870739, 29.7281382],
              [60.9869031, 29.7286477],
              [60.9868952, 29.7288632],
              [60.9867658, 29.729307],
              [60.9868749, 29.7295256],
              [60.9868765, 29.7296915],
              [60.9867313, 29.7297534],
              [60.9864228, 29.7297481],
              [60.9863332, 29.7298024],
              [60.9861196, 29.7298162],
              [60.9855934, 29.729777],
              [60.9852514, 29.7300784],
              [60.9833993, 29.7319824],
              [60.9826762, 29.7326937],
              [60.9824107, 29.7330216],
              [60.9820923, 29.7332904],
              [60.9818767, 29.7335617],
              [60.9815569, 29.7338062],
              [60.9812748, 29.7340814],
              [60.9809359, 29.7345189],
              [60.9802493, 29.7354073],
              [60.9799609, 29.7359196],
              [60.9796349, 29.7368863],
              [60.9789989, 29.737594],
              [60.9787482, 29.7380742],
              [60.9783053, 29.7392336],
              [60.9778205, 29.7398235],
              [60.9773728, 29.7412116],
              [60.977311, 29.7413213],
              [60.9769457, 29.741523],
              [60.9767994, 29.7417029],
              [60.9667485, 29.7550472],
              [60.9257775, 29.7967758],
              [60.9233131, 29.7985416],
              [60.9223443, 29.7995166],
              [60.9182806, 29.8033451],
              [60.9169556, 29.8043632],
              [60.9150266, 29.8055859],
              [60.9144612, 29.8061048],
              [60.91653, 29.8085422],
              [60.9141018, 29.811776],
              [60.9136522, 29.8115175],
              [60.9130577, 29.8116629],
              [60.9119498, 29.8121369],
              [60.9112495, 29.812881],
              [60.9101075, 29.8132449],
              [60.9088215, 29.8132331],
              [60.9085198, 29.8133439],
              [60.9074985, 29.8139791],
              [60.9056323, 29.8146325],
              [60.9044456, 29.8153518],
              [60.9040822, 29.8155771],
              [60.9032023, 29.815713],
              [60.9028211, 29.8156333],
              [60.9014022, 29.8150671],
              [60.901667, 29.826944],
              [60.895, 29.834167],
              [60.888056, 29.841111],
              [60.881389, 29.848333],
              [60.874444, 29.855556],
              [60.872855, 29.8585456],
              [60.8976706, 29.8851747],
              [60.9154075, 29.9061962],
              [60.9168581, 29.9073884],
              [60.9182781, 29.9092513],
              [60.9183524, 29.9094263],
              [60.9195775, 29.9118131],
              [60.9227175, 29.9133608],
              [60.9743855, 29.9670825],
              [61.0346146, 30.0313412],
              [61.094819, 30.0955321],
              [61.1034666, 30.1047319],
              [61.1736538, 30.1792752],
              [61.243373, 30.2532657],
              [61.293325, 30.30608],
              [61.3431915, 30.3587755],
              [61.4028358, 30.422452],
              [61.461496, 30.4850372],
              [61.5117145, 30.538584],
              [61.528695, 30.5559617],
              [61.5412334, 30.5678785],
              [61.5932492, 30.6219804],
              [61.7059509, 30.7399732],
              [61.7199835, 30.7546141],
              [61.7445693, 30.7806815],
              [61.7711277, 30.8081202],
              [61.7713942, 30.8082672],
              [61.7723573, 30.8084247],
              [61.7735229, 30.8085428],
              [61.7740032, 30.8086154],
              [61.7741524, 30.8087763],
              [61.7743367, 30.808975],
              [61.7745239, 30.8095694],
              [61.7747723, 30.8102272],
              [61.7749268, 30.810507],
              [61.775177, 30.8108509],
              [61.7755054, 30.8110966],
              [61.7757512, 30.8112183],
              [61.7759796, 30.811419],
              [61.7760964, 30.8116027],
              [61.7762665, 30.8119782],
              [61.7768557, 30.8130861],
              [61.7772979, 30.8137525],
              [61.7779852, 30.8145739],
              [61.7796881, 30.8158208],
              [61.7825354, 30.8179303],
              [61.7838261, 30.8190787],
              [61.7845664, 30.8198555],
              [61.7864665, 30.8216512],
              [61.7885303, 30.8234019],
              [61.7906335, 30.825085],
              [61.7922977, 30.8261657],
              [61.7927787, 30.8263649],
              [61.7931435, 30.8265189],
              [61.793475, 30.8267607],
              [61.7950625, 30.8282315],
              [61.7953139, 30.8285639],
              [61.7988489, 30.831287],
              [61.8008451, 30.8329047],
              [61.8030683, 30.8353078],
              [61.8040577, 30.8391965],
              [61.8025085, 30.8424519],
              [61.7975319, 30.8496063],
              [61.7938642, 30.8629467],
              [61.792721, 30.8672981],
              [61.7921152, 30.8714082],
              [61.7951324, 30.8799105],
              [61.7949664, 30.8826111],
              [61.7928245, 30.885965],
              [61.7915445, 30.8881245],
              [61.7877922, 30.8917912],
              [61.7852925, 30.8954514],
              [61.7849892, 30.8965145],
              [61.7828947, 30.9054798],
              [61.7793107, 30.9139247],
              [61.7778256, 30.9175664],
              [61.7786308, 30.9229748],
              [61.7799581, 30.9302049],
              [61.7837609, 30.9340048],
              [61.7868065, 30.9369917],
              [61.7881053, 30.9404275],
              [61.7902842, 30.9436405],
              [61.799139, 30.9478104],
              [61.8034354, 30.952223],
              [61.8078474, 30.956564],
              [61.809505, 30.9563753],
              [61.8113427, 30.9585909],
              [61.8130348, 30.9599055],
              [61.8140287, 30.9613055],
              [61.8150003, 30.9645106],
              [61.8207311, 30.9677182],
              [61.8215389, 30.9678114],
              [61.8281506, 30.9753099],
              [61.8289684, 30.9772786],
              [61.8276012, 30.9785716],
              [61.8267494, 30.9797493],
              [61.826773, 30.9808964],
              [61.826944, 30.983333],
              [61.8270718, 30.9864408],
              [61.8240717, 30.9975173],
              [61.8238446, 31.0008681],
              [61.8247366, 31.0051498],
              [61.8275529, 31.0072666],
              [61.8282461, 31.0088634],
              [61.8272496, 31.0136538],
              [61.8282461, 31.0151391],
              [61.8324056, 31.0163273],
              [61.8329688, 31.0177755],
              [61.8329255, 31.0204861],
              [61.8303259, 31.0234936],
              [61.829373, 31.0255369],
              [61.8286794, 31.0268352],
              [61.8282895, 31.0280233],
              [61.8279429, 31.0291743],
              [61.8281162, 31.0305109],
              [61.8280295, 31.0324786],
              [61.8297626, 31.0339265],
              [61.8307158, 31.0346319],
              [61.8332721, 31.0348175],
              [61.834052, 31.0344834],
              [61.8347886, 31.0343349],
              [61.8354818, 31.0349289],
              [61.8386508, 31.0352223],
              [61.8390347, 31.036451],
              [61.8379515, 31.0364139],
              [61.8374749, 31.040052],
              [61.8355685, 31.0420566],
              [61.8352218, 31.0425392],
              [61.8348319, 31.0435415],
              [61.8340953, 31.043987],
              [61.8338354, 31.0446923],
              [61.8307158, 31.0463998],
              [61.8292427, 31.0476248],
              [61.8275962, 31.0522276],
              [61.8273796, 31.0537123],
              [61.8283761, 31.0543433],
              [61.8293727, 31.0558651],
              [61.8288527, 31.0588345],
              [61.8293293, 31.0603191],
              [61.8288527, 31.0619893],
              [61.8284195, 31.0630656],
              [61.8278129, 31.0637336],
              [61.8280295, 31.0644017],
              [61.8275529, 31.0651439],
              [61.8276829, 31.065812],
              [61.827163, 31.0682985],
              [61.8275096, 31.0694119],
              [61.826643, 31.0717499],
              [61.8265997, 31.0744218],
              [61.8276396, 31.0764628],
              [61.829026, 31.0787265],
              [61.829546, 31.0804334],
              [61.8309324, 31.0822517],
              [61.8312791, 31.0857025],
              [61.8315824, 31.0884854],
              [61.8303692, 31.0918618],
              [61.8282461, 31.0937911],
              [61.8258198, 31.0951268],
              [61.8208372, 31.1002467],
              [61.819364, 31.1010258],
              [61.8184542, 31.1021388],
              [61.8162878, 31.1041792],
              [61.8145114, 31.1074067],
              [61.8136882, 31.1094841],
              [61.8111752, 31.1138984],
              [61.8113485, 31.1158644],
              [61.812605, 31.1175336],
              [61.8123017, 31.1209832],
              [61.8112185, 31.1235054],
              [61.8099187, 31.1277336],
              [61.8090521, 31.1303669],
              [61.8097454, 31.1318133],
              [61.8074924, 31.1363378],
              [61.8055426, 31.1383404],
              [61.8067125, 31.140788],
              [61.8072324, 31.1427905],
              [61.8064525, 31.1439771],
              [61.8060626, 31.1450525],
              [61.8034196, 31.1452009],
              [61.8030296, 31.1464987],
              [61.8035062, 31.1482786],
              [61.8023364, 31.1504664],
              [61.8027697, 31.1530249],
              [61.8043295, 31.1539148],
              [61.8038095, 31.1547676],
              [61.8048494, 31.1577338],
              [61.8063658, 31.1598101],
              [61.8059326, 31.160255],
              [61.8047627, 31.1611448],
              [61.8045894, 31.1630357],
              [61.8045461, 31.1657792],
              [61.8035929, 31.1678182],
              [61.8019898, 31.1685968],
              [61.8012532, 31.1694124],
              [61.8003867, 31.1700797],
              [61.7993901, 31.1727489],
              [61.797917, 31.1737868],
              [61.7983936, 31.1743429],
              [61.7981337, 31.1751955],
              [61.7971371, 31.1755662],
              [61.7968772, 31.1764559],
              [61.7960539, 31.1776792],
              [61.7964439, 31.1796809],
              [61.7952741, 31.1809413],
              [61.7953174, 31.1819792],
              [61.7944508, 31.1822016],
              [61.793411, 31.1841661],
              [61.7921978, 31.1850928],
              [61.7921112, 31.1859453],
              [61.7918079, 31.1868349],
              [61.7918079, 31.187428],
              [61.7893382, 31.1894295],
              [61.7889049, 31.1907638],
              [61.7889916, 31.1920981],
              [61.7879084, 31.1945072],
              [61.785872, 31.1959156],
              [61.7850488, 31.1960638],
              [61.7845289, 31.1965456],
              [61.7827525, 31.1968421],
              [61.7827091, 31.1983246],
              [61.7812793, 31.1999553],
              [61.7791563, 31.2001406],
              [61.7785064, 31.2007706],
              [61.7778565, 31.20103],
              [61.7773263, 31.2018654],
              [61.7763102, 31.2028123],
              [61.7743605, 31.2047024],
              [61.7723241, 31.2056659],
              [61.7716308, 31.2062588],
              [61.7715009, 31.2075929],
              [61.772584, 31.2097052],
              [61.7742305, 31.2110763],
              [61.7743171, 31.2131514],
              [61.7758336, 31.2130773],
              [61.7768518, 31.2139204],
              [61.7742169, 31.2284074],
              [61.770859, 31.2450557],
              [61.7699058, 31.2508516],
              [61.7741193, 31.2654263],
              [61.7783849, 31.3022694],
              [61.770556, 31.311667],
              [61.7204513, 31.3619052],
              [61.7066673, 31.375896],
              [61.6986172, 31.3769348],
              [61.6062448, 31.3888541],
              [61.5714213, 31.3942331],
              [61.4515282, 31.4094941],
              [61.3187061, 31.4265614],
              [61.1788319, 31.4448429],
              [61.1741498, 31.4454548],
              [61.1562255, 31.4485621],
              [61.0419254, 31.4625939],
              [60.9095276, 31.4797524],
              [60.856057, 31.4865192],
              [60.8569713, 31.4834814],
              [60.8569713, 31.4832016],
              [60.857251, 31.482371],
              [60.8575314, 31.4787598],
              [60.8572509, 31.4784799],
              [60.8490729, 31.4752663],
              [60.8492917, 31.4659502],
              [60.8487315, 31.4640001],
              [60.8487315, 31.4626188],
              [60.8473216, 31.4569733],
              [60.8448447, 31.4470544],
              [60.8428745, 31.4431502],
              [60.8376092, 31.4327152],
              [60.8344247, 31.4264036],
              [60.833302, 31.4241783],
              [60.835075, 31.4151866],
              [60.8282086, 31.4028799],
              [60.8187669, 31.3968452],
              [60.809875, 31.3886187],
              [60.7942193, 31.355983],
              [60.7859795, 31.323141],
              [60.7214869, 31.3021398],
              [60.6782323, 31.2981783],
              [60.6730741, 31.295724],
              [60.6678272, 31.2932275],
              [60.6527707, 31.2662266],
              [60.6674774, 31.2399715],
              [60.670199, 31.2294182],
              [60.6686469, 31.2286792],
              [60.6683665, 31.2283991],
              [60.668093, 31.2278481],
              [60.6673588, 31.2270231],
              [60.6664625, 31.2260158],
              [60.6658663, 31.2253458],
              [60.6507107, 31.2227845],
              [60.5820674, 31.2253437],
              [60.5815072, 31.2250636],
              [60.5804009, 31.2250636],
              [60.5801208, 31.2250636],
              [60.5798408, 31.2247837],
              [60.5773407, 31.2245128],
              [60.5745676, 31.2236819],
              [60.5731742, 31.2236819],
              [60.5383549, 31.212708],
              [60.536688, 31.211877],
              [60.5358548, 31.211877],
              [60.5137617, 31.1989811],
              [60.5123683, 31.1989812],
              [60.5118152, 31.1987011],
              [60.4293403, 31.2173942],
              [60.4240601, 31.2162835],
              [60.4218406, 31.2160037],
              [60.3910005, 31.2104505],
              [60.3706173, 31.2154854],
              [60.3581709, 31.2119562],
              [60.3457543, 31.1988749],
              [60.3415877, 31.196654],
              [60.3252407, 31.1672787],
              [60.2926251, 31.1628721],
              [60.2849246, 31.1482848],
              [60.282978, 31.1466149],
              [60.282425, 31.146335],
              [60.282425, 31.1460551],
              [60.2630993, 31.1493572],
              [60.2324756, 31.1260691],
              [60.2313623, 31.1227381],
              [60.2431185, 31.1042775],
              [60.2481186, 31.0937156],
              [60.2511718, 31.0892741],
              [60.265995, 31.0664983],
              [60.2701614, 31.0534359],
              [60.2693019, 31.0467605],
              [60.2584685, 31.0375919],
              [60.2556887, 31.0356517],
              [60.2543019, 31.0348124],
              [60.2348555, 31.0281526],
              [60.2276287, 31.023433],
              [60.2063254, 31.0246128],
              [60.1708122, 31.0100716],
              [60.1694259, 31.0100717],
              [60.1669259, 31.0092419],
              [60.1622059, 31.009242],
              [60.1588659, 31.009242],
              [60.1563659, 31.0092419],
              [60.154699, 31.0095215],
              [60.154146, 31.009242],
              [60.1510928, 31.009242],
              [60.1502596, 31.0089624],
              [60.1408129, 31.0089624],
              [60.1402594, 31.0086828],
              [60.138866, 31.0086828],
              [60.1380328, 31.0084032],
              [60.1329694, 31.0040276],
              [60.128803, 31.0040277],
              [60.1282498, 31.003748],
              [60.1257498, 31.003748],
              [60.1249166, 31.0040277],
              [60.1246365, 31.003748],
              [60.1238033, 31.0040277],
              [60.1082432, 31.0040277],
              [60.1076901, 31.003748],
              [60.1022001, 31.0073029],
              [60.0947004, 31.0075736],
              [60.0922003, 31.007303],
              [60.0866471, 31.007303],
              [60.0855338, 31.0070235],
              [60.0772004, 31.0070235],
              [60.076087, 31.0067439],
              [60.0699737, 31.0067439],
              [60.0697007, 31.0070236],
              [60.0616407, 31.0070236],
              [60.0599739, 31.006744],
              [60.0588673, 31.0070235],
              [60.0449206, 31.0091659],
              [60.0418604, 31.0094364],
              [60.040194, 31.0094364],
              [60.0396405, 31.009716],
              [60.0357541, 31.0097161],
              [60.035474, 31.0099955],
              [60.0190807, 31.0099956],
              [60.0121411, 31.0086067],
              [59.9839779, 30.973194],
              [59.962039, 30.9192671],
              [59.9562057, 30.9145465],
              [59.9556455, 30.9134363],
              [59.9428725, 30.8967652],
              [59.9414792, 30.8945448],
              [59.9414792, 30.894265],
              [59.9409257, 30.8937144],
              [59.9378724, 30.8856632],
              [59.9370393, 30.8837136],
              [59.9370392, 30.8828832],
              [59.936479, 30.881764],
              [59.9339794, 30.8648223],
              [59.9339794, 30.8592714],
              [59.9334258, 30.8551014],
              [59.9334258, 30.8439907],
              [59.9320394, 30.8326002],
              [59.9320393, 30.8245402],
              [59.9314792, 30.8198197],
              [59.9314792, 30.8187096],
              [59.9314791, 30.8148195],
              [59.9312056, 30.8112093],
              [59.9309257, 30.810379],
              [59.9312057, 30.8067686],
              [59.9306454, 30.7939884],
              [59.9304988, 30.7793233],
              [59.9302258, 30.7770938],
              [59.9299457, 30.7751534],
              [59.9296656, 30.7726531],
              [59.9293922, 30.7707125],
              [59.9291124, 30.7690428],
              [59.9288324, 30.7673731],
              [59.9285589, 30.7662627],
              [59.9279987, 30.7646021],
              [59.9277257, 30.7623728],
              [59.9274457, 30.7612625],
              [59.9249455, 30.7568219],
              [59.9243924, 30.7562623],
              [59.9243924, 30.7559825],
              [59.9193923, 30.7487619],
              [59.8789208, 30.7214737],
              [59.8673429, 30.7135844],
              [59.8656764, 30.7124744],
              [59.865123, 30.7119149],
              [59.8576352, 30.7002209],
              [59.8583218, 30.6822117],
              [59.8030468, 30.6379123],
              [59.776611, 30.6423432],
              [59.7388455, 30.6219596],
              [59.7051988, 30.6024591],
              [59.6976468, 30.5876819],
              [59.6701809, 30.5900462],
              [59.6416851, 30.5764503],
              [59.519861, 30.5484436],
              [59.5083903, 30.5361684],
              [59.5029529, 30.5332544],
              [59.4881025, 30.52283],
              [59.4830583, 30.5275894],
              [59.4682947, 30.4995767],
              [59.4680213, 30.4987374],
              [59.4680212, 30.4898487],
              [59.467188, 30.4851292],
              [59.4666278, 30.4834598],
              [59.4663547, 30.4826205],
              [59.4602413, 30.460124],
              [59.4602413, 30.4590141],
              [59.4596878, 30.4551248],
              [59.4594081, 30.4540149],
              [59.4538547, 30.4298494],
              [59.4535747, 30.4270701],
              [59.4532946, 30.4234606],
              [59.4530211, 30.4226305],
              [59.4530212, 30.4179021],
              [59.4460745, 30.3834595],
              [59.4460745, 30.3826203],
              [59.4452412, 30.3806803],
              [59.444408, 30.3773417],
              [59.4432946, 30.3745715],
              [59.4421814, 30.3687334],
              [59.4419079, 30.3648443],
              [59.4416278, 30.3620742],
              [59.4413477, 30.3595657],
              [59.4410747, 30.3579055],
              [59.4394079, 30.345679],
              [59.4391277, 30.3426292],
              [59.4388479, 30.337901],
              [59.4385746, 30.3359611],
              [59.4363479, 30.3242942],
              [59.4360745, 30.320676],
              [59.4357944, 30.3181767],
              [59.4352413, 30.3148471],
              [59.4349611, 30.3131779],
              [59.432181, 30.299842],
              [59.4313477, 30.2954027],
              [59.4307946, 30.2917936],
              [59.4291277, 30.2826264],
              [59.4288476, 30.2809572],
              [59.4280145, 30.2728999],
              [59.4277414, 30.2704005],
              [59.4271812, 30.2654019],
              [59.4269078, 30.2631824],
              [59.426348, 30.2595734],
              [59.4249612, 30.2526259],
              [59.4260745, 30.2348424],
              [59.4257943, 30.2115104],
              [59.4257943, 30.2090112],
              [59.4260744, 30.1945665],
              [59.4260744, 30.1937364],
              [59.4263478, 30.1934567],
              [59.4263478, 30.1926266],
              [59.4285743, 30.1845698],
              [59.4291275, 30.1787324],
              [59.4296809, 30.1515038],
              [59.4294074, 30.1456756],
              [59.4296809, 30.1445659],
              [59.4305141, 30.1381784],
              [59.4313473, 30.1348403],
              [59.4316273, 30.1312315],
              [59.4313473, 30.1301218],
              [59.4316274, 30.1287325],
              [59.4319075, 30.1234548],
              [59.4319074, 30.120676],
              [59.4321805, 30.1187273],
              [59.4338473, 30.1045631],
              [59.4344074, 30.0990059],
              [59.4352405, 30.0709488],
              [59.4357937, 30.0692797],
              [59.4382937, 30.0545659],
              [59.4385738, 30.0520669],
              [59.4407937, 30.0370645],
              [59.441627, 30.0351159],
              [59.4449602, 30.0176148],
              [59.4474601, 30.0000509],
              [59.4494066, 29.9934475],
              [59.449127, 29.9926175],
              [59.4488535, 29.9909486],
              [59.4482934, 29.9881703],
              [59.4480202, 29.9865013],
              [59.4477402, 29.9851121],
              [59.4474601, 29.9837319],
              [59.447187, 29.9826134],
              [59.446907, 29.9809535],
              [59.4432935, 29.9684506],
              [59.4405134, 29.9548383],
              [59.4405134, 29.9545587],
              [59.4402404, 29.9528989],
              [59.4399602, 29.95123],
              [59.4355133, 29.9312224],
              [59.4352403, 29.9290033],
              [59.4349601, 29.9256748],
              [59.43468, 29.9231671],
              [59.434407, 29.9206684],
              [59.4341269, 29.9192883],
              [59.4327401, 29.9103941],
              [59.4321799, 29.9078955],
              [59.43246, 29.9020593],
              [59.4330135, 29.8887273],
              [59.4335736, 29.8723377],
              [59.4335736, 29.8717785],
              [59.4388466, 29.8148358],
              [59.4449594, 29.7548381],
              [59.4460728, 29.7503916],
              [59.4466262, 29.7470545],
              [59.4466263, 29.7456656],
              [59.4485728, 29.7353927],
              [59.4488528, 29.7303872],
              [59.4485727, 29.7295574],
              [59.4488528, 29.7273296],
              [59.4485727, 29.7117809],
              [59.4474593, 29.6990011],
              [59.4477394, 29.6937251],
              [59.4474593, 29.6745513],
              [59.4477394, 29.6723327],
              [59.4480194, 29.6506611],
              [59.4488525, 29.6390003],
              [59.449126, 29.6295489],
              [59.4499592, 29.6239937],
              [59.4499592, 29.6214957],
              [59.4519057, 29.6114945],
              [59.4519057, 29.6109443],
              [59.4557924, 29.5917809],
              [59.4560725, 29.5881647],
              [59.4563521, 29.5789934],
              [59.4560724, 29.5773341],
              [59.4563521, 29.5745476],
              [59.4560724, 29.5728883],
              [59.4552386, 29.5042734],
              [59.4577387, 29.4801072],
              [59.4580187, 29.4720459],
              [59.4580187, 29.4717754],
              [59.4580187, 29.4662209],
              [59.4574585, 29.461496],
              [59.4596851, 29.4437146],
              [59.4607917, 29.4420465],
              [59.4607917, 29.4412169],
              [59.4616249, 29.4398284],
              [59.4616249, 29.4395489],
              [59.4616249, 29.4392693],
              [59.461905, 29.4387194],
              [59.4632917, 29.4337151],
              [59.4632917, 29.4181612],
              [59.4627386, 29.4142661],
              [59.4624584, 29.4048257],
              [59.461905, 29.4006601],
              [59.462185, 29.3978831],
              [59.4635717, 29.3742691],
              [59.464685, 29.3706626],
              [59.4655181, 29.3673267],
              [59.4669049, 29.3631612],
              [59.469958, 29.3539918],
              [59.4735714, 29.3295495],
              [59.4741245, 29.3284315],
              [59.4807979, 29.2981567],
              [59.4838511, 29.2801076],
              [59.4846842, 29.2762129],
              [59.4919043, 29.2534401],
              [59.4944042, 29.2445422],
              [59.5088505, 29.2092665],
              [59.5094036, 29.2070489],
              [59.5107971, 29.2031544],
              [59.5136732, 29.1929828],
              [59.5282968, 29.1609301],
              [59.5513496, 29.1234308],
              [59.5527429, 29.1206545],
              [59.5694092, 29.0923238],
              [59.5696892, 29.0909266],
              [59.5694091, 29.0906562],
              [59.5694091, 29.0884298],
              [59.5707959, 29.0820391],
              [59.5660759, 29.0723224],
              [59.5655226, 29.0720431],
              [59.5655227, 29.0714842],
              [59.5649625, 29.0709343],
              [59.5641293, 29.0692669],
              [59.5374632, 29.0453722],
              [59.5374631, 29.0450928],
              [59.5360763, 29.0425961],
              [59.5294099, 29.0328708],
              [59.5082965, 29.0042633],
              [59.5055168, 28.9998199],
              [59.4969032, 28.96093],
              [59.5005165, 28.9475915],
              [59.4989987, 28.917061],
              [59.4985021, 28.8706622],
              [59.4986104, 28.8403558],
              [59.4996122, 28.8001384],
              [59.5053182, 28.7448984],
              [59.5069348, 28.7237471],
              [59.50801, 28.7109369],
              [59.511895, 28.6913351],
              [59.5153424, 28.667094],
              [59.5314785, 28.6246107],
              [59.5644375, 28.5950731],
              [59.585699, 28.5801563],
              [59.5978032, 28.5717089],
              [59.6821137, 28.5189455],
              [59.7254961, 28.4868834],
              [59.709973, 28.4390211],
              [59.6371254, 28.3995574],
              [59.5559179, 28.3835777],
              [59.4433078, 28.3977557],
              [59.415842, 28.3448278],
              [59.4186717, 28.3197897],
              [59.4383044, 28.3081032],
              [59.4783579, 28.287017],
              [59.5310793, 28.3116972],
              [59.5964291, 28.2957708],
              [59.6050252, 28.2680902],
              [59.5779227, 28.2259113],
              [59.5650865, 28.2039522],
              [59.5227946, 28.1584981],
              [59.5139315, 28.1392267],
              [59.506103, 28.1205522],
              [59.4973983, 28.0982945],
              [59.4832945, 28.0859233],
              [59.5220382, 28.0550237],
              [59.5357724, 28.0442869],
              [59.5401477, 28.0427054],
              [59.5452976, 28.0417964],
              [59.5482158, 28.0420994],
              [59.5493316, 28.0447129],
              [59.5516491, 28.0451674],
              [59.5530653, 28.0412282],
              [59.5519495, 28.03441],
              [59.5504903, 28.0246745],
              [59.5457696, 28.0174385],
              [59.5523357, 28.0164914],
              [59.5637512, 28.0153548],
              [59.5677423, 28.0151653],
              [59.5748234, 28.0139435],
              [59.5813992, 28.0135536],
              [59.5487308, 28.0134225],
              [59.5123812, 28.0133091],
              [59.4725131, 28.0144834],
              [59.4363781, 28.0141048],
              [59.3556973, 28.0162264],
              [59.332723, 28.0152965],
              [59.3272015, 28.0141048],
              [59.2732998, 27.973179],
              [59.2454907, 27.9543783],
              [59.2434307, 27.9328443],
              [59.1946789, 27.9091824],
              [59.1572567, 27.9067553],
              [59.1098782, 27.9452799],
              [59.0930554, 27.9865195],
              [59.0940854, 28.0077396],
              [59.0872189, 28.0189542],
              [59.0658764, 28.0285756],
              [59.0212942, 28.0535882],
              [59.0100459, 28.0602271],
              [59.0027146, 28.0641416],
              [58.9998553, 28.0658079],
              [58.9895225, 28.0735847],
              [58.9823901, 28.0788858],
              [58.9796304, 28.0812005],
              [58.9723105, 28.085223],
              [58.9602105, 28.0917223],
              [58.9485012, 28.0780233],
              [58.94428, 28.0740423],
              [58.9422858, 28.0692869],
              [58.9390263, 28.0633086],
              [58.936339, 28.0581839],
              [58.9347672, 28.0540425],
              [58.9325627, 28.0456031],
              [58.9304873, 28.0378334],
              [58.9295566, 28.0314211],
              [58.9283298, 28.0216955],
              [58.9273857, 28.0180088],
              [58.9240764, 28.0075521],
              [58.9197468, 28.0014716],
              [58.9170634, 27.9987454],
              [58.9140843, 27.99296],
              [58.9097296, 27.9816713],
              [58.9047288, 27.9702735],
              [58.9025446, 27.9674952],
              [58.9002412, 27.961406],
              [58.8907634, 27.8989606],
              [58.8904901, 27.8981235],
              [58.8918767, 27.8811839],
              [58.8935435, 27.8756305],
              [58.8952099, 27.8675749],
              [58.8974299, 27.8545152],
              [58.8988233, 27.848962],
              [58.900763, 27.8372976],
              [58.9021564, 27.8189554],
              [58.9027096, 27.8025757],
              [58.9024294, 27.8003528],
              [58.9027095, 27.7975718],
              [58.9024295, 27.7953489],
              [58.9029896, 27.7847923],
              [58.9032629, 27.7689624],
              [58.9029895, 27.7617359],
              [58.9032629, 27.759792],
              [58.9038231, 27.7492361],
              [58.9049293, 27.7139605],
              [58.9049293, 27.7114589],
              [58.9052094, 27.7056278],
              [58.9050365, 27.7018484],
              [58.9050376, 27.7015338],
              [58.9057628, 27.6797935],
              [58.9057628, 27.6706244],
              [58.9029893, 27.6456281],
              [58.9024291, 27.6411833],
              [58.9019541, 27.6377946],
              [58.9002095, 27.6253475],
              [58.9010426, 27.6042397],
              [58.9007626, 27.603124],
              [58.9010426, 27.5995162],
              [58.9007625, 27.5986794],
              [58.9010426, 27.5945137],
              [58.9010426, 27.5764568],
              [58.8985424, 27.5589582],
              [58.8971558, 27.5542349],
              [58.8922721, 27.5383758],
              [58.8910427, 27.5347847],
              [58.8904892, 27.5339571],
              [58.8904892, 27.5336782],
              [58.8904892, 27.5328415],
              [58.8860426, 27.5145073],
              [58.879096, 27.4972891],
              [58.8788229, 27.495346],
              [58.8754825, 27.4811779],
              [58.8752095, 27.4797925],
              [58.8749294, 27.4786771],
              [58.8746492, 27.4781193],
              [58.8746493, 27.4772913],
              [58.8746493, 27.4770128],
              [58.8746493, 27.4767341],
              [58.8740962, 27.4756186],
              [58.8707629, 27.4620085],
              [58.8657628, 27.4372808],
              [58.8624294, 27.426172],
              [58.854096, 27.3931258],
              [58.8368694, 27.3017311],
              [58.835483, 27.2920006],
              [58.8318696, 27.2620006],
              [58.8310364, 27.2536735],
              [58.8330053, 27.183222],
              [58.8335358, 27.1642226],
              [58.8346491, 27.1572813],
              [58.8349292, 27.1545031],
              [58.8352026, 27.1508887],
              [58.8382624, 27.1351502],
              [58.8385358, 27.1344983],
              [58.8385358, 27.1342286],
              [58.8385359, 27.1339499],
              [58.8485422, 27.1017277],
              [58.8504821, 27.096729],
              [58.8552091, 27.0872804],
              [58.8593755, 27.0742269],
              [58.8599286, 27.071449],
              [58.8702084, 27.048669],
              [58.8713151, 27.0472756],
              [58.8746484, 27.040893],
              [58.8757616, 27.0394997],
              [58.8768749, 27.0372794],
              [58.8893747, 27.0203346],
              [58.8907615, 27.0189413],
              [58.9049277, 27.0072735],
              [58.908541, 27.0053319],
              [58.9129876, 26.9999296],
              [58.9118742, 26.9886666],
              [58.8988213, 26.9697817],
              [58.897988, 26.9692244],
              [58.8765946, 26.933946],
              [58.8643748, 26.9086636],
              [58.8502084, 26.8619934],
              [58.8493752, 26.857554],
              [58.8502084, 26.846725],
              [58.8504814, 26.8361659],
              [58.8502084, 26.8331105],
              [58.8507615, 26.8311605],
              [58.8510417, 26.8303338],
              [58.8535417, 26.8247712],
              [58.8602082, 26.8206106],
              [58.8613147, 26.8194963],
              [58.8629813, 26.8186696],
              [58.886321, 26.8000505],
              [58.899374, 26.7911635],
              [58.9057608, 26.7878299],
              [58.9560463, 26.7672709],
              [58.957153, 26.7669923],
              [58.9585465, 26.7661657],
              [58.9718794, 26.7619965],
              [58.9721753, 26.7619965],
              [58.9732662, 26.7619965],
              [58.9734638, 26.7617998],
              [58.9735462, 26.7617179],
              [58.9742731, 26.7617179],
              [58.9754861, 26.7617179],
              [58.9758815, 26.7615213],
              [58.9760463, 26.7614393],
              [58.9765753, 26.7614394],
              [58.9768795, 26.7614394],
              [58.9772702, 26.7612427],
              [58.9774327, 26.7611609],
              [58.9779666, 26.7611609],
              [58.9790995, 26.7611609],
              [58.9792973, 26.7609642],
              [58.9793796, 26.7608823],
              [58.9801064, 26.7608823],
              [58.9818796, 26.7608822],
              [58.9820724, 26.7606855],
              [58.9821526, 26.7606037],
              [58.9828843, 26.7606037],
              [58.9840992, 26.7606037],
              [58.9844901, 26.760407],
              [58.9846526, 26.7603252],
              [58.9851862, 26.7603252],
              [58.9865992, 26.7603251],
              [58.9865992, 26.7601284],
              [58.9865992, 26.7600466],
              [58.9871527, 26.7600466],
              [58.9872348, 26.7601284],
              [58.9874324, 26.7603252],
              [58.9881834, 26.7599556],
              [58.9885461, 26.7597771],
              [58.9890709, 26.7597771],
              [58.9893793, 26.759777],
              [58.989968, 26.7595803],
              [58.9902126, 26.7594986],
              [58.9904926, 26.75922],
              [58.9904926, 26.7586629],
              [58.9904926, 26.7583844],
              [58.9924324, 26.7514388],
              [58.9929926, 26.7506122],
              [58.9935458, 26.7489409],
              [58.9963259, 26.7342145],
              [58.9965988, 26.7303241],
              [58.9965988, 26.7231094],
              [58.9960457, 26.7147717],
              [58.9957657, 26.7142236],
              [58.9960457, 26.7114384],
              [58.9979922, 26.6853299],
              [59.0029922, 26.6747737],
              [59.0160451, 26.6625466],
              [59.0174318, 26.6597707],
              [59.0177119, 26.6561592],
              [59.0174318, 26.6514428],
              [59.0149318, 26.6367189],
              [59.0118786, 26.6306013],
              [59.002432, 26.6186537],
              [59.0010456, 26.6158779],
              [58.9990986, 26.6042091],
              [58.9996588, 26.596439],
              [59.000492, 26.5942202],
              [59.002992, 26.5869892],
              [59.0043787, 26.5853274],
              [59.0263248, 26.5680991],
              [59.0285447, 26.5664375],
              [59.0349382, 26.5614343],
              [59.0349382, 26.5611559],
              [59.0352112, 26.5608774],
              [59.0374382, 26.5506019],
              [59.0374382, 26.5475481],
              [59.0354913, 26.5436589],
              [59.0332713, 26.5411619],
              [59.0321581, 26.5405961],
              [59.031878, 26.5400482],
              [59.0277115, 26.5381081],
              [59.0135448, 26.5342191],
              [59.0060451, 26.5281025],
              [59.0063252, 26.5264319],
              [59.0090982, 26.5233782],
              [59.0093783, 26.5206029],
              [59.0090982, 26.5189323],
              [59.0085451, 26.5178276],
              [59.008265, 26.5175491],
              [59.008265, 26.5172707],
              [59.0077118, 26.5169923],
              [59.0071584, 26.5153218],
              [59.0074318, 26.5150434],
              [59.0077119, 26.5133817],
              [59.0077119, 26.5105975],
              [59.0021586, 26.5014366],
              [59.0003551, 26.5003229],
              [58.9996586, 26.5003229],
              [58.9990984, 26.5000445],
              [58.9979918, 26.5000445],
              [58.9955186, 26.4994936],
              [58.9954921, 26.4994877],
              [58.987748, 26.50124],
              [58.9868787, 26.5014367],
              [58.9849321, 26.5014367],
              [58.9835455, 26.5017151],
              [58.9816348, 26.5017151],
              [58.9815989, 26.5017151],
              [58.9715992, 26.5039335],
              [58.9693096, 26.5048506],
              [58.968819, 26.5050472],
              [58.9683987, 26.5050472],
              [58.9679857, 26.5050472],
              [58.9643791, 26.5064393],
              [58.9579856, 26.5081008],
              [58.9560458, 26.508936],
              [58.9411329, 26.5134641],
              [58.9404861, 26.5136604],
              [58.9392367, 26.5136603],
              [58.9390994, 26.5136603],
              [58.937575, 26.5140415],
              [58.9368728, 26.5142171],
              [58.9310395, 26.514765],
              [58.9285188, 26.514765],
              [58.9279863, 26.514765],
              [58.9278229, 26.5148473],
              [58.9274331, 26.5150435],
              [58.9257664, 26.5150435],
              [58.9247541, 26.5148412],
              [58.924373, 26.5147651],
              [58.9242096, 26.5148473],
              [58.9238198, 26.5150435],
              [58.9224331, 26.5150435],
              [58.9207667, 26.5147651],
              [58.9049266, 26.5128251],
              [58.897987, 26.5086577],
              [58.8902068, 26.5011584],
              [58.8793738, 26.4944855],
              [58.8782605, 26.494216],
              [58.8574273, 26.4850464],
              [58.8557608, 26.4850464],
              [58.8552077, 26.484768],
              [58.8065689, 26.4461005],
              [58.8054556, 26.4461005],
              [58.8032356, 26.4455435],
              [58.7976824, 26.4449954],
              [58.7971223, 26.4449954]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 537701,
        "tags": {
          "ISO3166-2": "IR-23",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "تهران",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q590866"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [50.3329055, 35.5507027],
              [50.3351497, 35.5508736],
              [50.3573286, 35.5637571],
              [50.3738139, 35.5638952],
              [50.3884791, 35.564339],
              [50.4027049, 35.5606034],
              [50.4055309, 35.5598813],
              [50.4157664, 35.5589101],
              [50.4228684, 35.5582374],
              [50.4417564, 35.5585589],
              [50.4523712, 35.5590905],
              [50.456632, 35.5601728],
              [50.4929353, 35.56849],
              [50.531693, 35.5706074],
              [50.5418645, 35.5651006],
              [50.5536786, 35.5581875],
              [50.5587537, 35.5546785],
              [50.5669582, 35.5542342],
              [50.5709466, 35.5538583],
              [50.5762269, 35.5535788],
              [50.5883665, 35.5527493],
              [50.5911172, 35.5527142],
              [50.5969082, 35.552784],
              [50.6063747, 35.5532827],
              [50.6181764, 35.5524796],
              [50.6259494, 35.5474747],
              [50.6270627, 35.5469157],
              [50.6328629, 35.540979],
              [50.6414739, 35.5323054],
              [50.6497631, 35.5251971],
              [50.6526361, 35.5241491],
              [50.6558252, 35.5207698],
              [50.6767683, 35.5129611],
              [50.6885559, 35.5115726],
              [50.7075471, 35.5040966],
              [50.7410345, 35.4928463],
              [50.7560459, 35.48778],
              [50.7676246, 35.4869185],
              [50.7684581, 35.4869184],
              [50.7712347, 35.4863594],
              [50.7715148, 35.4860799],
              [50.7726247, 35.4860799],
              [50.7745679, 35.4855298],
              [50.775958, 35.4855299],
              [50.7776246, 35.4849708],
              [50.7787346, 35.4849708],
              [50.7823478, 35.4841413],
              [50.7842912, 35.4841413],
              [50.7848478, 35.4838617],
              [50.786791, 35.4838617],
              [50.7876245, 35.4835822],
              [50.7895712, 35.4835822],
              [50.7904044, 35.4833026],
              [50.7987376, 35.4833027],
              [50.799571, 35.4835822],
              [50.8004044, 35.4833027],
              [50.8009575, 35.4835822],
              [50.8017909, 35.4835822],
              [50.8084608, 35.4841413],
              [50.8092942, 35.4844118],
              [50.8104042, 35.4844117],
              [50.8112375, 35.4846913],
              [50.8217941, 35.4846913],
              [50.8223473, 35.4844118],
              [50.845127, 35.4813551],
              [50.851517, 35.480805],
              [50.8576269, 35.480805],
              [50.8615168, 35.4819141],
              [50.8623502, 35.4819141],
              [50.8626303, 35.4821936],
              [50.8634635, 35.4821936],
              [50.8637403, 35.4824732],
              [50.8673502, 35.4835823],
              [50.8731835, 35.4849709],
              [50.8751302, 35.484971],
              [50.8756834, 35.484971],
              [50.8765168, 35.4849709],
              [50.8779066, 35.4846914],
              [50.8915269, 35.4851248],
              [50.8948336, 35.4828955],
              [50.8975415, 35.4816335],
              [50.899977, 35.4799],
              [50.9036046, 35.4760444],
              [50.9065339, 35.4746713],
              [50.9096846, 35.4734231],
              [50.91212, 35.4704133],
              [50.915952, 35.4684298],
              [50.9218277, 35.4656001],
              [50.934107, 35.4603151],
              [50.9418391, 35.4569857],
              [50.9458257, 35.4557088],
              [50.9462147, 35.455684],
              [50.9469356, 35.4555791],
              [50.9473734, 35.4557259],
              [50.9487381, 35.4554533],
              [50.9493046, 35.4550548],
              [50.9492788, 35.4543626],
              [50.9488411, 35.4541738],
              [50.9485063, 35.4537124],
              [50.9493818, 35.45323],
              [50.9496908, 35.4527895],
              [50.950695, 35.4527056],
              [50.9515705, 35.4529363],
              [50.9527292, 35.453188],
              [50.9531412, 35.4528314],
              [50.9542484, 35.4525168],
              [50.9552526, 35.4522231],
              [50.9567461, 35.4516988],
              [50.9574671, 35.4509017],
              [50.9578533, 35.4501675],
              [50.9582395, 35.4493705],
              [50.9592438, 35.4489509],
              [50.960763, 35.4488461],
              [50.9611749, 35.4487202],
              [50.9621534, 35.4476504],
              [50.9633121, 35.4467904],
              [50.9634924, 35.4464128],
              [50.9632864, 35.4457835],
              [50.9634403, 35.4448193],
              [50.9643651, 35.443781],
              [50.9650196, 35.4432565],
              [50.9654058, 35.442531],
              [50.96591, 35.4418755],
              [50.9660495, 35.4413773],
              [50.966307, 35.4407129],
              [50.9665109, 35.4399787],
              [50.9667254, 35.4395242],
              [50.9670258, 35.4392095],
              [50.9622033, 35.436015],
              [50.9615226, 35.417188],
              [50.9648257, 35.3958463],
              [50.9645489, 35.3958463],
              [50.9645489, 35.3955667],
              [50.9651057, 35.3944576],
              [50.9653824, 35.394178],
              [50.9583663, 35.3861111],
              [50.9484661, 35.3819107],
              [50.9473561, 35.3794128],
              [50.9067737, 35.3247975],
              [50.9048304, 35.3211906],
              [50.8933937, 35.2998653],
              [50.8844623, 35.289215],
              [50.8765358, 35.2812332],
              [50.8745891, 35.2762396],
              [50.8743124, 35.2759602],
              [50.8740358, 35.2748425],
              [50.8683626, 35.2702844],
              [50.8675294, 35.2694552],
              [50.8666959, 35.2677876],
              [50.8555604, 35.2527998],
              [50.8488812, 35.2360305],
              [50.8466885, 35.2245462],
              [50.8450219, 35.2226081],
              [50.8431728, 35.2145523],
              [50.8712169, 35.2137184],
              [50.9077495, 35.2186113],
              [50.9110829, 35.2174937],
              [50.9498385, 35.2181248],
              [50.983541, 35.2184467],
              [50.992711, 35.2151123],
              [50.993821, 35.2151123],
              [51.0134203, 35.2142742],
              [51.0145337, 35.2142741],
              [51.0181436, 35.2131658],
              [51.0195337, 35.2131658],
              [51.0273102, 35.2114985],
              [51.0320335, 35.2112281],
              [51.0331435, 35.2109489],
              [51.0364768, 35.2109488],
              [51.0375902, 35.2106694],
              [51.0489966, 35.2061812],
              [51.0520531, 35.2061812],
              [51.0590081, 35.2037967],
              [51.0592847, 35.2040762],
              [51.0603947, 35.2037967],
              [51.0680331, 35.2008512],
              [51.0691464, 35.2005717],
              [51.0708131, 35.2005717],
              [51.0710896, 35.2008511],
              [51.0719231, 35.2008512],
              [51.0721996, 35.2005718],
              [51.082003, 35.1966542],
              [51.0828364, 35.1963747],
              [51.0872797, 35.1963748],
              [51.0878363, 35.1960953],
              [51.0903361, 35.1960954],
              [51.096211, 35.1927298],
              [51.0981577, 35.1927298],
              [51.1037144, 35.1927298],
              [51.1117675, 35.1913417],
              [51.1174221, 35.187487],
              [51.1227321, 35.1845114],
              [51.1320876, 35.1802358],
              [51.1398642, 35.1802358],
              [51.1406974, 35.1805155],
              [51.1451407, 35.1805155],
              [51.146254, 35.1802358],
              [51.158404, 35.173526],
              [51.1776174, 35.1668309],
              [51.1837272, 35.1662716],
              [51.2190068, 35.1590464],
              [51.2209536, 35.1590464],
              [51.2217869, 35.1587667],
              [51.2459973, 35.1505134],
              [51.2687771, 35.1449482],
              [51.3107592, 35.1267086],
              [51.3196491, 35.1247599],
              [51.328259, 35.1222607],
              [51.3620884, 35.1057775],
              [51.398988, 35.1047632],
              [51.4404723, 35.0937979],
              [51.4405978, 35.0938196],
              [51.4442626, 35.0934499],
              [51.4464176, 35.0932326],
              [51.4480369, 35.0929204],
              [51.4754534, 35.0876352],
              [51.5157356, 35.080332],
              [51.5229589, 35.0792221],
              [51.5297971, 35.0775504],
              [51.5359071, 35.0750509],
              [51.5408083, 35.070961],
              [51.5473918, 35.0641688],
              [51.5874823, 35.0254863],
              [51.5993289, 35.0177316],
              [51.614332, 35.0110744],
              [51.6193319, 35.0099559],
              [51.6321085, 35.0080164],
              [51.6365551, 35.0077368],
              [51.6384983, 35.0077368],
              [51.6421116, 35.0077368],
              [51.6459982, 35.0080164],
              [51.650445, 35.008287],
              [51.674988, 35.0026244],
              [51.6794313, 35.0029041],
              [51.6833688, 35.0031775],
              [51.6863744, 35.0031838],
              [51.6894311, 35.0029041],
              [51.6922112, 35.0026244],
              [51.7069308, 34.9998458],
              [51.7183207, 34.9970671],
              [51.7219341, 34.9959575],
              [51.7308239, 34.9923488],
              [51.7327673, 34.9909414],
              [51.7747135, 34.9631722],
              [51.7758234, 34.9626219],
              [51.8098465, 34.946282],
              [51.8290129, 34.9348878],
              [51.8487359, 34.9251713],
              [51.9073521, 34.8951647],
              [51.9351782, 34.8832909],
              [51.9354584, 34.8830113],
              [51.9521246, 34.8743957],
              [51.9524014, 34.8738453],
              [51.962958, 34.8677287],
              [51.9649046, 34.8652387],
              [51.9654579, 34.8657891],
              [51.9696244, 34.871617],
              [51.9699045, 34.8718967],
              [51.9768479, 34.8810717],
              [51.9774045, 34.8824519],
              [51.9785145, 34.8838502],
              [51.985181, 34.896345],
              [51.9985176, 34.9146855],
              [51.9987942, 34.9149561],
              [52.0015707, 34.9185647],
              [52.0212938, 34.9671794],
              [52.0215739, 34.9677388],
              [52.0309338, 34.9965863],
              [52.0320438, 34.9996445],
              [52.035657, 35.0118681],
              [52.0398237, 35.0463098],
              [52.0395435, 35.0482492],
              [52.039267, 35.0524257],
              [52.0389904, 35.0607609],
              [52.0387103, 35.065199],
              [52.0381569, 35.0688163],
              [52.0378768, 35.0693666],
              [52.0323237, 35.0826989],
              [52.0320438, 35.0829785],
              [52.0309338, 35.0854772],
              [52.0298238, 35.087146],
              [52.0025974, 35.1132599],
              [51.9645411, 35.1360359],
              [51.9637077, 35.1365951],
              [51.9500945, 35.1474282],
              [51.9478745, 35.150486],
              [51.9467612, 35.1515954],
              [51.9464847, 35.1521547],
              [51.9431513, 35.1579815],
              [51.9417613, 35.1613189],
              [51.9334282, 35.176319],
              [51.9328714, 35.1779876],
              [51.8953718, 35.2307702],
              [51.8792587, 35.2485472],
              [51.8789819, 35.2490975],
              [51.8770353, 35.2516048],
              [51.8695355, 35.2699317],
              [51.8692586, 35.2702112],
              [51.869169, 35.2709737],
              [51.8689821, 35.2721594],
              [51.868702, 35.2727096],
              [51.8681487, 35.2749373],
              [51.8678688, 35.2763263],
              [51.867592, 35.2777152],
              [51.8846339, 35.2955786],
              [51.8976783, 35.3094148],
              [51.9024015, 35.3152496],
              [51.9043448, 35.3180273],
              [51.932262, 35.3128064],
              [51.9359957, 35.3126593],
              [51.9413686, 35.3121009],
              [51.9436603, 35.3134876],
              [51.9443555, 35.3156938],
              [51.9452825, 35.3162401],
              [51.946261, 35.3176268],
              [51.9471364, 35.318215],
              [51.9476772, 35.3190344],
              [51.9491706, 35.320337],
              [51.9494281, 35.3209043],
              [51.9498144, 35.3215346],
              [51.9535222, 35.3235094],
              [51.9543977, 35.3244758],
              [51.9550929, 35.3253792],
              [51.9555307, 35.3261355],
              [51.9555307, 35.3267237],
              [51.9554019, 35.3271859],
              [51.9554019, 35.3279422],
              [51.9558654, 35.3287825],
              [51.9567409, 35.3295387],
              [51.9579769, 35.3307151],
              [51.9586978, 35.3311563],
              [51.9593673, 35.3315134],
              [51.9593673, 35.3323536],
              [51.960217, 35.333572],
              [51.9607578, 35.3345593],
              [51.9616332, 35.3355046],
              [51.9625345, 35.3377311],
              [51.9628177, 35.3395375],
              [51.9632297, 35.3401677],
              [51.9629722, 35.34168],
              [51.9629722, 35.3424361],
              [51.962998, 35.3433813],
              [51.962998, 35.3446835],
              [51.9641567, 35.3463217],
              [51.9655214, 35.3478129],
              [51.9661394, 35.348569],
              [51.9664998, 35.3500392],
              [51.9671178, 35.3516353],
              [51.9676071, 35.3526014],
              [51.9694095, 35.3537774],
              [51.9706455, 35.3549955],
              [51.9718557, 35.3560875],
              [51.9646716, 35.3576205],
              [51.9593158, 35.3584395],
              [51.952724, 35.3603924],
              [51.9392057, 35.3649071],
              [51.9297557, 35.3679098],
              [51.9243566, 35.3698347],
              [51.9253093, 35.38176],
              [51.9242793, 35.3949219],
              [51.9231206, 35.4000854],
              [51.9209319, 35.4047028],
              [51.9119893, 35.4143066],
              [51.9129545, 35.4224732],
              [51.9135114, 35.4241415],
              [51.9135113, 35.4255302],
              [51.9176778, 35.4413558],
              [51.9190678, 35.4471991],
              [51.9196211, 35.4480285],
              [51.9251778, 35.4702471],
              [51.9254578, 35.4708061],
              [51.9257344, 35.4763606],
              [51.9257344, 35.4794175],
              [51.9260109, 35.4799675],
              [51.9257344, 35.4810856],
              [51.929202, 35.4880967],
              [51.929202, 35.4883853],
              [51.9289218, 35.4889353],
              [51.9286453, 35.490324],
              [51.9215677, 35.5035829],
              [51.9212911, 35.5055305],
              [51.921011, 35.5080282],
              [51.9212911, 35.5085782],
              [51.921011, 35.5099668],
              [51.9229577, 35.5355292],
              [51.9229577, 35.5374767],
              [51.923511, 35.5458079],
              [51.9243442, 35.548585],
              [51.9296242, 35.5585843],
              [51.9357341, 35.5616408],
              [51.9365676, 35.5616408],
              [51.9579572, 35.5780235],
              [51.9604572, 35.5785825],
              [51.9629571, 35.5785825],
              [51.9657371, 35.5785825],
              [51.9662904, 35.578312],
              [51.9693471, 35.578312],
              [51.9696237, 35.5785825],
              [51.9704571, 35.5785825],
              [51.972957, 35.5785825],
              [51.979347, 35.577194],
              [51.9804602, 35.577194],
              [51.9857369, 35.575526],
              [51.9935134, 35.5685834],
              [52.0096267, 35.5488646],
              [52.0117525, 35.5392061],
              [52.0096592, 35.5282986],
              [52.0056003, 35.5183514],
              [52.0056003, 35.5169627],
              [52.003967, 35.5060285],
              [52.017115, 35.4868295],
              [52.027115, 35.4787669],
              [52.0296149, 35.4776577],
              [52.0500402, 35.4589783],
              [52.0511501, 35.4589783],
              [52.0689299, 35.4537018],
              [52.0764298, 35.4509236],
              [52.1177488, 35.4555851],
              [52.1264953, 35.4585216],
              [52.1299753, 35.4611969],
              [52.1496353, 35.4602472],
              [52.169601, 35.4561513],
              [52.1968579, 35.4505266],
              [52.2021344, 35.4499675],
              [52.2029677, 35.449697],
              [52.2060245, 35.449697],
              [52.2121377, 35.4488584],
              [52.2143577, 35.4488584],
              [52.2374141, 35.445531],
              [52.2515839, 35.4421946],
              [52.2521372, 35.4421946],
              [52.254084, 35.4416356],
              [52.2568606, 35.4405265],
              [52.2576937, 35.4405264],
              [52.27692, 35.4282479],
              [52.2807503, 35.4258009],
              [52.2810271, 35.4255273],
              [52.324363, 35.3860782],
              [52.3326963, 35.3755273],
              [52.3331994, 35.3749235],
              [52.3401997, 35.3660764],
              [52.3451995, 35.3610805],
              [52.3601994, 35.3474632],
              [52.3688092, 35.3410783],
              [52.3785325, 35.3377506],
              [52.3790892, 35.3374621],
              [52.3801991, 35.337462],
              [52.3829791, 35.3380212],
              [52.4001154, 35.3507378],
              [52.4085355, 35.3569142],
              [52.4104788, 35.3585825],
              [52.4218687, 35.3660765],
              [52.4935377, 35.3860782],
              [52.4949278, 35.3860782],
              [52.4957611, 35.3863578],
              [52.499651, 35.3869169],
              [52.5171509, 35.3957995],
              [52.5188174, 35.396079],
              [52.5210407, 35.3969177],
              [52.5227074, 35.3971882],
              [52.5232607, 35.3974677],
              [52.5246748, 35.397823],
              [52.5302073, 35.3994155],
              [52.5310407, 35.3999656],
              [52.5318739, 35.3999656],
              [52.5327073, 35.4005247],
              [52.5340973, 35.4008043],
              [52.5349306, 35.4013544],
              [52.5363172, 35.4016339],
              [52.5502071, 35.4091366],
              [52.5513204, 35.4099663],
              [52.555207, 35.4119141],
              [52.5629869, 35.4174689],
              [52.6063231, 35.4619156],
              [52.6071564, 35.4624657],
              [52.6082664, 35.4641428],
              [52.6115996, 35.4674702],
              [52.6152095, 35.4724748],
              [52.6338227, 35.5027448],
              [52.634656, 35.5038628],
              [52.6377126, 35.5083082],
              [52.6591023, 35.5283073],
              [52.6596591, 35.5285868],
              [52.6599357, 35.5294163],
              [52.6671589, 35.5352501],
              [52.6674356, 35.5358092],
              [52.6696589, 35.5369182],
              [52.6727122, 35.5391362],
              [52.6977153, 35.5519216],
              [52.7077151, 35.5544192],
              [52.7085484, 35.5544192],
              [52.7121583, 35.5549692],
              [52.7132718, 35.5552487],
              [52.715215, 35.5552487],
              [52.7163284, 35.5555282],
              [52.725495, 35.5555282],
              [52.7260482, 35.5552487],
              [52.7266049, 35.5555282],
              [52.7277148, 35.5555282],
              [52.7343849, 35.5533102],
              [52.7660511, 35.5469175],
              [52.7668843, 35.5469175],
              [52.7768843, 35.5416429],
              [52.7788309, 35.5410839],
              [52.7821642, 35.5410839],
              [52.7929974, 35.5452495],
              [52.7932741, 35.545529],
              [52.7943875, 35.5459445],
              [52.801054, 35.5494151],
              [52.8021641, 35.5505331],
              [52.8024406, 35.5508037],
              [52.8227204, 35.572479],
              [52.8291104, 35.579701],
              [52.8299438, 35.5810896],
              [52.8771663, 35.6260885],
              [52.8846697, 35.6313716],
              [52.8857797, 35.6322011],
              [52.8991128, 35.6419201],
              [52.9143926, 35.6497006],
              [52.9263359, 35.6541452],
              [52.9291158, 35.6549747],
              [52.9296691, 35.6555337],
              [52.9743952, 35.6694265],
              [52.9752286, 35.6699764],
              [52.9846717, 35.6727532],
              [52.9952283, 35.6785861],
              [52.995785, 35.6788656],
              [52.999675, 35.6813629],
              [53.0010616, 35.6827602],
              [53.001895, 35.6833102],
              [53.0124514, 35.7008087],
              [53.0236118, 35.7059191],
              [53.0260515, 35.7086249],
              [53.0294194, 35.7107269],
              [53.0345465, 35.7157818],
              [53.0396417, 35.7173855],
              [53.0450542, 35.7186159],
              [53.0482405, 35.720593],
              [53.0501364, 35.7226807],
              [53.0528843, 35.7236171],
              [53.0537982, 35.7249015],
              [53.0555043, 35.7262102],
              [53.0626664, 35.7333319],
              [53.0649541, 35.7347051],
              [53.0655109, 35.7349755],
              [53.0880105, 35.744982],
              [53.0932904, 35.7488673],
              [53.0938438, 35.7496967],
              [53.0944005, 35.7499851],
              [53.0969005, 35.7555382],
              [53.1099569, 35.772756],
              [53.13329, 35.7847001],
              [53.1469033, 35.7888739],
              [53.1482932, 35.7894237],
              [53.1527365, 35.7919297],
              [53.1546798, 35.7941472],
              [53.1560698, 35.7960943],
              [53.1569031, 35.8038645],
              [53.1563464, 35.8052618],
              [53.1566264, 35.8055322],
              [53.1560697, 35.8077587],
              [53.1532932, 35.8113644],
              [53.1410699, 35.8177554],
              [53.1399566, 35.8183142],
              [53.1394032, 35.8180348],
              [53.1285701, 35.8205406],
              [53.1199568, 35.8205407],
              [53.1180136, 35.8202523],
              [53.107457, 35.8202523],
              [53.1052337, 35.8199818],
              [53.0980104, 35.8199818],
              [53.0971771, 35.8197024],
              [53.0938437, 35.8197024],
              [53.0913438, 35.8191435],
              [53.0891205, 35.8191436],
              [53.0855106, 35.8185937],
              [53.0846771, 35.8185937],
              [53.0830106, 35.8183142],
              [53.0816206, 35.8180348],
              [53.0807873, 35.8183142],
              [53.0766207, 35.8183142],
              [53.0657875, 35.8191435],
              [53.0652308, 35.819432],
              [53.0602307, 35.8194319],
              [53.0585641, 35.8191435],
              [53.0580109, 35.819432],
              [53.0566209, 35.8191436],
              [53.0499543, 35.8197024],
              [53.0485643, 35.8199818],
              [53.0471743, 35.8199818],
              [53.0410644, 35.8221993],
              [53.0330078, 35.8263727],
              [53.0318978, 35.8266521],
              [53.0205078, 35.8355399],
              [53.0216179, 35.8449774],
              [53.0221745, 35.8480331],
              [53.0221746, 35.8483126],
              [53.0221746, 35.8491508],
              [53.021898, 35.8499801],
              [53.0202313, 35.8516477],
              [53.018008, 35.8530357],
              [53.0174514, 35.8535946],
              [53.0110614, 35.8485919],
              [53.0107847, 35.8483126],
              [53.0071748, 35.8460951],
              [53.0068947, 35.8455364],
              [53.0046748, 35.8444276],
              [53.0038415, 35.8435893],
              [52.9874517, 35.83554],
              [52.9707818, 35.8324842],
              [52.9674485, 35.8324842],
              [52.9663387, 35.8322048],
              [52.9643953, 35.8322048],
              [52.9632819, 35.8319254],
              [52.9627287, 35.8322048],
              [52.9613387, 35.8319253],
              [52.9516155, 35.8319253],
              [52.9507821, 35.8322048],
              [52.9480055, 35.8322047],
              [52.9468922, 35.8324842],
              [52.9455055, 35.8324842],
              [52.9449488, 35.8327546],
              [52.9430055, 35.8327546],
              [52.937449, 35.8338723],
              [52.9368923, 35.8338723],
              [52.9357823, 35.8341427],
              [52.9216158, 35.8377573],
              [52.9207825, 35.8377573],
              [52.9180024, 35.8391455],
              [52.9171691, 35.8391455],
              [52.8774463, 35.8566503],
              [52.8718897, 35.8585882],
              [52.8704997, 35.8594264],
              [52.8291102, 35.8738753],
              [52.8281778, 35.8741024],
              [52.8229968, 35.8760926],
              [52.8218869, 35.876372],
              [52.815777, 35.8791482],
              [52.8146636, 35.8794276],
              [52.8038129, 35.8854164],
              [52.7966072, 35.8894235],
              [52.7881052, 35.8929868],
              [52.7057716, 35.9274863],
              [52.7049383, 35.9280361],
              [52.7016049, 35.928595],
              [52.6993816, 35.9294241],
              [52.6949384, 35.9302623],
              [52.6935484, 35.9308211],
              [52.692435, 35.9308211],
              [52.6841018, 35.9333177],
              [52.6832685, 35.9333177],
              [52.6616785, 35.9390399],
              [52.660212, 35.9394284],
              [52.6591021, 35.9394285],
              [52.6585453, 35.9397079],
              [52.6571589, 35.9397079],
              [52.6560454, 35.9399783],
              [52.6538222, 35.9399783],
              [52.6524355, 35.9402577],
              [52.6502122, 35.9402576],
              [52.6488221, 35.9405371],
              [52.6477122, 35.9402576],
              [52.6443789, 35.9408165],
              [52.6435456, 35.9405371],
              [52.6227125, 35.941925],
              [52.6196559, 35.9424839],
              [52.6149325, 35.9424838],
              [52.6129892, 35.9427632],
              [52.6077093, 35.9427633],
              [52.6065993, 35.9430426],
              [52.6024192, 35.943043],
              [52.5832664, 35.9430426],
              [52.581043, 35.943313],
              [52.5799296, 35.9430426],
              [52.5777097, 35.9433131],
              [52.5757629, 35.943313],
              [52.5749297, 35.9430426],
              [52.5685432, 35.9430426],
              [52.5679864, 35.943313],
              [52.5482634, 35.9410958],
              [52.54604, 35.940537],
              [52.5435401, 35.940537],
              [52.5418733, 35.9402576],
              [52.54104, 35.940537],
              [52.4999272, 35.9338674],
              [52.4957606, 35.933597],
              [52.4949272, 35.933597],
              [52.4943706, 35.9333176],
              [52.4935373, 35.9333176],
              [52.4805157, 35.9304368],
              [52.4796475, 35.9302622],
              [52.4790942, 35.9302622],
              [52.4752041, 35.929424],
              [52.4740942, 35.9288742],
              [52.4702042, 35.9277655],
              [52.4685377, 35.9269273],
              [52.4663143, 35.9263775],
              [52.4635377, 35.9252599],
              [52.4627044, 35.92526],
              [52.4357581, 35.9122089],
              [52.4176557, 35.8941065],
              [52.4157583, 35.8922085],
              [52.4152015, 35.8910908],
              [52.412425, 35.8874763],
              [52.4090882, 35.8830327],
              [52.3943686, 35.8616436],
              [52.3793654, 35.8494299],
              [52.3785321, 35.8488711],
              [52.3782555, 35.8485917],
              [52.326586, 35.8283195],
              [52.3196427, 35.8263724],
              [52.3003625, 35.818777],
              [52.2921399, 35.8155375],
              [52.2665834, 35.7985908],
              [52.2657501, 35.7974821],
              [52.2446369, 35.7730351],
              [52.240747, 35.771088],
              [52.2374138, 35.7696997],
              [52.2274139, 35.7674821],
              [52.2260273, 35.7669232],
              [52.2201905, 35.7658144],
              [52.2182473, 35.7658144],
              [52.2179707, 35.7655349],
              [52.217414, 35.765535],
              [52.2171373, 35.7658144],
              [52.2165806, 35.7655351],
              [52.2154707, 35.765535],
              [52.2146375, 35.7658144],
              [52.2135239, 35.765535],
              [52.2113042, 35.765535],
              [52.2107473, 35.7652555],
              [52.2090807, 35.7652555],
              [52.2046374, 35.7646966],
              [52.2024141, 35.7646966],
              [52.201024, 35.7644261],
              [52.1990809, 35.7644262],
              [52.1979676, 35.7641467],
              [52.1954675, 35.7641467],
              [52.1946343, 35.7638673],
              [52.1918577, 35.7638672],
              [52.1907477, 35.7635878],
              [52.1840776, 35.7633174],
              [52.1771345, 35.7633173],
              [52.1751912, 35.7630289],
              [52.1585212, 35.7630289],
              [52.1560213, 35.7633173],
              [52.1551879, 35.7630289],
              [52.1374115, 35.7621995],
              [52.1293549, 35.7621995],
              [52.1226884, 35.76192],
              [52.1185218, 35.7616496],
              [52.1121319, 35.7616496],
              [52.1101886, 35.7613611],
              [52.0965753, 35.7613611],
              [52.0957422, 35.7616496],
              [52.0726856, 35.7633173],
              [52.0601859, 35.7660937],
              [52.0587959, 35.7666436],
              [52.0515726, 35.7685908],
              [52.0376827, 35.7738642],
              [52.0268495, 35.7785878],
              [52.0104597, 35.7846996],
              [52.0062932, 35.7866467],
              [51.9929599, 35.7933082],
              [51.9843466, 35.7985906],
              [51.9340671, 35.828869],
              [51.8821211, 35.8571995],
              [51.8782311, 35.8599847],
              [51.8776744, 35.8605858],
              [51.8607314, 35.8788772],
              [51.8573981, 35.8855381],
              [51.8573981, 35.886088],
              [51.8507316, 35.9005364],
              [51.8473982, 35.9049799],
              [51.8291354, 35.9346017],
              [51.8246184, 35.9419245],
              [51.8143384, 35.9524786],
              [51.7798922, 35.9808143],
              [51.7698922, 36.0002271],
              [51.760449, 36.0066529],
              [51.7285028, 36.0261011],
              [51.7274191, 36.0266362],
              [51.7154463, 36.0330404],
              [51.7145335, 36.0334998],
              [51.7071128, 36.0369336],
              [51.699613, 36.0397092],
              [51.6934997, 36.0427643],
              [51.6548867, 36.0597065],
              [51.653777, 36.0602653],
              [51.5990507, 36.0835963],
              [51.598494, 36.084155],
              [51.5979408, 36.084155],
              [51.5943274, 36.0860924],
              [51.5865508, 36.0902648],
              [51.5729376, 36.0949868],
              [51.5581069, 36.1003115],
              [51.5527438, 36.1016137],
              [51.5380668, 36.0907945],
              [51.5242488, 36.0792001],
              [51.5074585, 36.0639025],
              [51.5019194, 36.0602148],
              [51.4997068, 36.0599459],
              [51.4972339, 36.0583245],
              [51.4917255, 36.054211],
              [51.4918105, 36.0535754],
              [51.4859965, 36.0486349],
              [51.4682373, 36.0286934],
              [51.4682487, 36.0286479],
              [51.464424, 36.0243905],
              [51.459391, 36.0233815],
              [51.459389, 36.0233755],
              [51.4558891, 36.0194846],
              [51.4508104, 36.0128413],
              [51.4508193, 36.0128169],
              [51.4449159, 36.0053379],
              [51.437264, 35.9993626],
              [51.4334394, 35.9971348],
              [51.4324276, 35.9953988],
              [51.4281661, 35.9902778],
              [51.4122623, 35.9677832],
              [51.4075587, 35.9597271],
              [51.407046, 35.9587478],
              [51.4050718, 35.955836],
              [51.4026685, 35.9505595],
              [51.4026685, 35.9504887],
              [51.3988614, 35.9427845],
              [51.3954812, 35.9363812],
              [51.3925405, 35.9315233],
              [51.387189, 35.9263349],
              [51.3770218, 35.9211929],
              [51.3667596, 35.9212172],
              [51.3529149, 35.9220974],
              [51.3423232, 35.9269476],
              [51.3359596, 35.9303989],
              [51.3231104, 35.9373673],
              [51.2781918, 35.9626491],
              [51.2688181, 35.9673484],
              [51.2525322, 35.9694481],
              [51.2096837, 35.9847159],
              [51.2096296, 35.9847279],
              [51.1781926, 35.9926449],
              [51.1542253, 35.998958],
              [51.1520964, 35.9983533],
              [51.1535452, 35.9821737],
              [51.1647525, 35.9633304],
              [51.1786078, 35.9357647],
              [51.1820654, 35.9296816],
              [51.1820081, 35.9296333],
              [51.182008, 35.9296332],
              [51.1826618, 35.9265048],
              [51.1826037, 35.9264506],
              [51.1828911, 35.9231683],
              [51.1802406, 35.918515],
              [51.1429022, 35.8794537],
              [51.1274527, 35.8642915],
              [51.1247061, 35.8494221],
              [51.1224424, 35.8472999],
              [51.1189556, 35.8470736],
              [51.1165998, 35.8459713],
              [51.1121943, 35.8439591],
              [51.1079443, 35.8425779],
              [51.1099432, 35.8281132],
              [51.1107225, 35.8217835],
              [51.1127952, 35.8172794],
              [51.1147097, 35.81241],
              [51.1167779, 35.8005118],
              [51.1187901, 35.7915401],
              [51.1185605, 35.7838232],
              [51.1149537, 35.7781703],
              [51.1124564, 35.7724766],
              [51.1098306, 35.7684567],
              [51.1057053, 35.7671917],
              [51.1015078, 35.7659094],
              [51.0988756, 35.7647237],
              [51.0956954, 35.7621845],
              [51.095373, 35.7605029],
              [51.0941942, 35.7577691],
              [51.0941876, 35.7577586],
              [51.0941943, 35.7577126],
              [51.094197, 35.7576935],
              [51.0941966, 35.7576132],
              [51.0941883, 35.7575946],
              [51.0941734, 35.7575792],
              [51.0941235, 35.7575703],
              [51.0941116, 35.7575654],
              [51.0941073, 35.7575551],
              [51.0941102, 35.7575368],
              [51.0941068, 35.7574954],
              [51.0940979, 35.7574547],
              [51.0940866, 35.7574188],
              [51.0936705, 35.7565435],
              [51.093584, 35.7562732],
              [51.0934702, 35.7559179],
              [51.0921226, 35.7489801],
              [51.0920783, 35.7488362],
              [51.0920291, 35.7487229],
              [51.0901497, 35.7456386],
              [51.0890493, 35.7429636],
              [51.0933876, 35.7421762],
              [51.0925702, 35.7401965],
              [51.0913784, 35.7403866],
              [51.090503, 35.7373142],
              [51.0903742, 35.7360393],
              [51.090606, 35.7349942],
              [51.088855, 35.7344508],
              [51.0855591, 35.7336983],
              [51.0829842, 35.7336849],
              [51.0804608, 35.7336147],
              [51.0776284, 35.7341791],
              [51.0756199, 35.733991],
              [51.072942, 35.7339492],
              [51.0701611, 35.7343254],
              [51.0681269, 35.7341791],
              [51.0663245, 35.7343463],
              [51.0642388, 35.7344717],
              [51.0631733, 35.7342617],
              [51.0613638, 35.7348334],
              [51.0587088, 35.735499],
              [51.056651, 35.7351495],
              [51.0543849, 35.7356809],
              [51.0540791, 35.736051],
              [51.0539369, 35.7363232],
              [51.0529472, 35.7379626],
              [51.0516776, 35.7389746],
              [51.0511817, 35.739324],
              [51.0495595, 35.7385089],
              [51.0475253, 35.7382372],
              [51.0425815, 35.73807],
              [51.0378951, 35.7385925],
              [51.0349597, 35.7391359],
              [51.0305823, 35.7394912],
              [51.0289344, 35.7391777],
              [51.0268377, 35.7376632],
              [51.0257243, 35.7389339],
              [51.0254871, 35.7387642],
              [51.0248221, 35.7378989],
              [51.0220463, 35.7340461],
              [51.0215354, 35.7333765],
              [51.0208281, 35.7319956],
              [51.0202111, 35.7313073],
              [51.0196918, 35.7305882],
              [51.0188357, 35.7294448],
              [51.0183954, 35.7290645],
              [51.0182893, 35.7289665],
              [51.0171804, 35.7279563],
              [51.0170337, 35.7278236],
              [51.0128492, 35.7240356],
              [51.010918, 35.7222987],
              [51.0095132, 35.7205797],
              [51.0085794, 35.7195565],
              [51.0066424, 35.7150205],
              [51.0071644, 35.7144409],
              [51.0067856, 35.7138288],
              [51.0063014, 35.7130463],
              [51.0062688, 35.7129664],
              [51.0062255, 35.7129183],
              [51.0061786, 35.7128664],
              [51.0060756, 35.7128182],
              [51.0060191, 35.7128156],
              [51.0059234, 35.7128439],
              [51.00582, 35.7128616],
              [51.0057399, 35.7128644],
              [51.0056812, 35.7128579],
              [51.0056264, 35.7128329],
              [51.0056015, 35.7127928],
              [51.0055029, 35.7125872],
              [51.0050844, 35.7117561],
              [51.0044854, 35.7065077],
              [51.0023672, 35.7071764],
              [50.9976089, 35.7004433],
              [50.9938969, 35.7022083],
              [50.9935205, 35.7011163],
              [50.9932375, 35.70122],
              [50.9921349, 35.7014783],
              [50.9915648, 35.701597],
              [50.9910821, 35.7016929],
              [50.9900359, 35.7018829],
              [50.9899005, 35.7014788],
              [50.9898436, 35.701309],
              [50.987997, 35.7016476],
              [50.9863934, 35.7019323],
              [50.9830709, 35.7025309],
              [50.9788688, 35.7032691],
              [50.9762069, 35.7037615],
              [50.975248, 35.7039554],
              [50.9745443, 35.7040653],
              [50.9730415, 35.7043025],
              [50.9712783, 35.7046287],
              [50.9691545, 35.7050869],
              [50.9691294, 35.7050923],
              [50.969009, 35.7051183],
              [50.9640026, 35.7060231],
              [50.9562672, 35.7072722],
              [50.9555426, 35.7069001],
              [50.9508618, 35.7077805],
              [50.9385389, 35.7106328],
              [50.9422206, 35.7199756],
              [50.9404877, 35.7205201],
              [50.9370855, 35.7213377],
              [50.9323866, 35.7221269],
              [50.9284382, 35.720095],
              [50.9266487, 35.7187188],
              [50.9249557, 35.7173982],
              [50.9226629, 35.7153764],
              [50.9216179, 35.71419],
              [50.9187834, 35.7098239],
              [50.9179298, 35.7082547],
              [50.9171622, 35.7062572],
              [50.9167578, 35.7052135],
              [50.9171172, 35.702172],
              [50.9165818, 35.6991531],
              [50.9161226, 35.6948757],
              [50.9160969, 35.6943111],
              [50.9192383, 35.6928054],
              [50.9188778, 35.6917598],
              [50.9108997, 35.6938743],
              [50.9059632, 35.69503],
              [50.9047107, 35.695483],
              [50.9042187, 35.6959901],
              [50.9038824, 35.6966323],
              [50.9000716, 35.7065461],
              [50.9001031, 35.7072262],
              [50.9027308, 35.7194308],
              [50.8991517, 35.7218139],
              [50.8983277, 35.7218767],
              [50.8950576, 35.7189499],
              [50.8769816, 35.7123853],
              [50.8732782, 35.719615],
              [50.8538014, 35.712108],
              [50.8507917, 35.7101038],
              [50.8442526, 35.7088027],
              [50.8370207, 35.7080116],
              [50.8320043, 35.7064941],
              [50.8297126, 35.7052814],
              [50.8286054, 35.7048632],
              [50.8266484, 35.7049469],
              [50.8220651, 35.7046541],
              [50.8163487, 35.7043405],
              [50.8153744, 35.7037954],
              [50.8139752, 35.7042993],
              [50.8118316, 35.7048444],
              [50.8110548, 35.6938755],
              [50.8104966, 35.6941038],
              [50.8068811, 35.6958905],
              [50.803404, 35.6976624],
              [50.802819, 35.6979606],
              [50.801957, 35.6983999],
              [50.8007775, 35.6987567],
              [50.7999945, 35.6989663],
              [50.7849981, 35.7020961],
              [50.7696551, 35.7041298],
              [50.7683124, 35.7034198],
              [50.7609338, 35.6995273],
              [50.759426, 35.6987318],
              [50.7455233, 35.6887396],
              [50.7365797, 35.6821196],
              [50.7140921, 35.6832351],
              [50.7091523, 35.68334],
              [50.6622927, 35.6843348],
              [50.6473003, 35.6843362],
              [50.6022051, 35.6853998],
              [50.5603199, 35.678499],
              [50.5550048, 35.6780321],
              [50.5017886, 35.6768269],
              [50.4784791, 35.6746135],
              [50.4449465, 35.668183],
              [50.4320327, 35.6659741],
              [50.4010756, 35.6624981],
              [50.3899732, 35.6601183],
              [50.3735038, 35.6584407],
              [50.3684747, 35.6549579],
              [50.3554448, 35.6429279],
              [50.3504345, 35.6366497],
              [50.3497457, 35.6342697],
              [50.3443563, 35.6265629],
              [50.3390459, 35.6171459],
              [50.3390627, 35.617093],
              [50.3348166, 35.6108344],
              [50.3327898, 35.5909379],
              [50.3363967, 35.5796417],
              [50.3359547, 35.5722262],
              [50.3329055, 35.5507027]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 537702,
        "tags": {
          "ISO3166-2": "IR-25",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "قم",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q131664"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [50.0864811, 34.5823911],
              [50.0887046, 34.5788339],
              [50.0912047, 34.5724543],
              [50.0987045, 34.564667],
              [50.1000943, 34.5632774],
              [50.1025944, 34.5607869],
              [50.1045378, 34.5579987],
              [50.1051137, 34.557358],
              [50.1100946, 34.5496699],
              [50.1125942, 34.5452213],
              [50.1175943, 34.5382821],
              [50.118151, 34.5368926],
              [50.1442641, 34.5180059],
              [50.1484306, 34.5163366],
              [50.1570406, 34.5091175],
              [50.1589871, 34.5035588],
              [50.1575972, 34.490781],
              [50.1498209, 34.4835528],
              [50.147874, 34.4805027],
              [50.1467643, 34.4780031],
              [50.1459306, 34.4763337],
              [50.1462075, 34.4760539],
              [50.1464877, 34.4752237],
              [50.1481542, 34.4732836],
              [50.1595407, 34.4685549],
              [50.1637072, 34.4677248],
              [50.1653772, 34.4677248],
              [50.1753769, 34.4657846],
              [50.177877, 34.4657847],
              [50.1784305, 34.4655049],
              [50.1856538, 34.4655048],
              [50.1887105, 34.4649454],
              [50.1906535, 34.4649453],
              [50.1912101, 34.4646656],
              [50.1931534, 34.4646657],
              [50.1937102, 34.4643859],
              [50.1951004, 34.4643859],
              [50.2134333, 34.4604966],
              [50.2148235, 34.4604965],
              [50.2156568, 34.4602168],
              [50.2217666, 34.4591159],
              [50.2281566, 34.457997],
              [50.2384329, 34.4549467],
              [50.2395462, 34.4549468],
              [50.2398229, 34.454667],
              [50.2406565, 34.454667],
              [50.2414896, 34.4543873],
              [50.2437132, 34.4543873],
              [50.2439897, 34.4541075],
              [50.2470465, 34.4538369],
              [50.2512129, 34.4538369],
              [50.2520461, 34.4535571],
              [50.2542697, 34.4535571],
              [50.2545461, 34.4532773],
              [50.259826, 34.4532774],
              [50.2603795, 34.4529976],
              [50.2662128, 34.4524471],
              [50.2664926, 34.4527268],
              [50.2698261, 34.4529976],
              [50.2712126, 34.4524471],
              [50.2751025, 34.444939],
              [50.2762127, 34.4443886],
              [50.2770459, 34.4435583],
              [50.2809358, 34.4421686],
              [50.2814925, 34.4416092],
              [50.2889926, 34.4382792],
              [50.2898258, 34.4382792],
              [50.2903826, 34.4379994],
              [50.2912157, 34.4379995],
              [50.2917689, 34.4377198],
              [50.300939, 34.4363299],
              [50.3042722, 34.4360502],
              [50.3051055, 34.4360503],
              [50.3053825, 34.43633],
              [50.3070488, 34.43633],
              [50.3076055, 34.4366098],
              [50.3084387, 34.4366098],
              [50.3095489, 34.4371693],
              [50.3106587, 34.4371692],
              [50.311772, 34.4377198],
              [50.3126056, 34.4377198],
              [50.3292719, 34.4421687],
              [50.3314955, 34.4424394],
              [50.3351052, 34.4421688],
              [50.3373284, 34.439669],
              [50.3376054, 34.4379995],
              [50.337885, 34.4371693],
              [50.3370518, 34.4274411],
              [50.3362187, 34.4241112],
              [50.3353854, 34.4213317],
              [50.3314956, 34.4080028],
              [50.3317721, 34.4068837],
              [50.3348287, 34.4013338],
              [50.3353854, 34.4010541],
              [50.335662, 34.4005035],
              [50.3362187, 34.4002238],
              [50.3403852, 34.3957747],
              [50.3492716, 34.3882754],
              [50.3495518, 34.3879957],
              [50.3531617, 34.3821658],
              [50.352885, 34.3816063],
              [50.352605, 34.3804964],
              [50.3523285, 34.3777168],
              [50.3531617, 34.3743867],
              [50.3528851, 34.374107],
              [50.3601083, 34.3493886],
              [50.3601083, 34.3488291],
              [50.3614951, 34.3468888],
              [50.36219, 34.3461939],
              [50.3626084, 34.3460586],
              [50.3659417, 34.3427193],
              [50.3701081, 34.3346602],
              [50.380385, 34.3263305],
              [50.380385, 34.3260506],
              [50.3809416, 34.3249407],
              [50.3809416, 34.3241103],
              [50.3812182, 34.3238305],
              [50.3817749, 34.3238305],
              [50.3823315, 34.323271],
              [50.3831647, 34.3230002],
              [50.3962212, 34.3135513],
              [50.4145545, 34.2924421],
              [50.4151111, 34.2910522],
              [50.4176112, 34.2871625],
              [50.4189979, 34.2849423],
              [50.4192781, 34.2843917],
              [50.4245543, 34.2774425],
              [50.4348342, 34.2491037],
              [50.4353878, 34.2466037],
              [50.4356679, 34.2460532],
              [50.4351108, 34.2371633],
              [50.4323343, 34.2252139],
              [50.4317777, 34.2246633],
              [50.4287213, 34.2154936],
              [50.4284443, 34.211324],
              [50.4323343, 34.2068835],
              [50.4387212, 34.2029935],
              [50.4415009, 34.2016036],
              [50.4420545, 34.2010531],
              [50.4651107, 34.1907731],
              [50.4667807, 34.1907731],
              [50.4676139, 34.1904934],
              [50.472334, 34.1904934],
              [50.4731672, 34.1907732],
              [50.474834, 34.1907731],
              [50.4770571, 34.1902136],
              [50.4784474, 34.1902135],
              [50.4792806, 34.1899337],
              [50.4815005, 34.189663],
              [50.4940036, 34.1907732],
              [50.494557, 34.1904934],
              [50.4953903, 34.1904934],
              [50.4962236, 34.1902136],
              [50.4990037, 34.1902136],
              [50.4998369, 34.1899338],
              [50.5056702, 34.1899338],
              [50.50928, 34.1899339],
              [50.5170602, 34.1899339],
              [50.5317832, 34.1943834],
              [50.5340032, 34.1954936],
              [50.5351165, 34.1954935],
              [50.5545594, 34.2029937],
              [50.5639676, 34.2043168],
              [50.5755453, 34.2114958],
              [50.583887, 34.2152801],
              [50.5916305, 34.2194898],
              [50.6023523, 34.2240108],
              [50.6174772, 34.2280177],
              [50.640294, 34.2330941],
              [50.6585597, 34.2367831],
              [50.6771645, 34.2377102],
              [50.6927487, 34.2353366],
              [50.7050142, 34.2334916],
              [50.7131241, 34.2313587],
              [50.7188437, 34.2282232],
              [50.7248633, 34.2264236],
              [50.7360823, 34.2248623],
              [50.7502237, 34.222883],
              [50.7596978, 34.2180179],
              [50.7742082, 34.213951],
              [50.7840512, 34.2102926],
              [50.7954305, 34.2050602],
              [50.8053588, 34.2000239],
              [50.8098532, 34.1976995],
              [50.815958, 34.1943017],
              [50.8234922, 34.1898817],
              [50.8305247, 34.1875703],
              [50.8501991, 34.1847255],
              [50.8565365, 34.1838649],
              [50.8708035, 34.1796179],
              [50.8811641, 34.1751681],
              [50.8920005, 34.171589],
              [50.8989754, 34.168421],
              [50.9034518, 34.1657966],
              [50.9113343, 34.1631755],
              [50.9177588, 34.1618173],
              [50.9282821, 34.1593659],
              [50.9342602, 34.1582668],
              [50.9380035, 34.1581799],
              [50.9466677, 34.1590376],
              [50.9532061, 34.1599682],
              [50.9587955, 34.1618893],
              [50.9642886, 34.164517],
              [50.9695243, 34.1692041],
              [50.9756183, 34.1747431],
              [50.9794215, 34.1831032],
              [50.9777382, 34.1892289],
              [50.9811114, 34.2010837],
              [50.9892958, 34.212482],
              [50.9946889, 34.2204261],
              [50.9979731, 34.2280736],
              [50.9979, 34.2355141],
              [50.9982299, 34.2456367],
              [51.0044814, 34.253266],
              [51.0094788, 34.2579192],
              [51.0202293, 34.2694202],
              [51.0274739, 34.2801981],
              [51.0314507, 34.2870175],
              [51.0351831, 34.2941833],
              [51.0363014, 34.2999669],
              [51.0360248, 34.3047654],
              [51.0331248, 34.312532],
              [51.029005, 34.3160767],
              [51.0190486, 34.3228819],
              [51.0134177, 34.3283861],
              [51.0123538, 34.3325927],
              [51.0115962, 34.3383592],
              [51.012336, 34.3438541],
              [51.0147809, 34.3540495],
              [51.0184792, 34.3610443],
              [51.0221892, 34.369401],
              [51.0306581, 34.3800919],
              [51.0397978, 34.3874424],
              [51.0467418, 34.3913004],
              [51.0599847, 34.3958991],
              [51.0690321, 34.3987266],
              [51.0778578, 34.4052138],
              [51.0847949, 34.4119374],
              [51.086769, 34.4159026],
              [51.0900306, 34.417602],
              [51.1062723, 34.4166048],
              [51.115727, 34.4170262],
              [51.1201422, 34.4285521],
              [51.1229187, 34.4302216],
              [51.1273654, 34.4327213],
              [51.1431986, 34.4377208],
              [51.1459752, 34.438551],
              [51.1473651, 34.4391105],
              [51.1773681, 34.4443897],
              [51.1793115, 34.4443896],
              [51.1807015, 34.4446694],
              [51.188758, 34.4446694],
              [51.1959778, 34.4449402],
              [51.1973679, 34.4452199],
              [51.2020912, 34.44522],
              [51.209591, 34.4454997],
              [51.2309809, 34.4463299],
              [51.2315375, 34.4466097],
              [51.2568138, 34.4460592],
              [51.2865402, 34.4438393],
              [51.2920933, 34.4430001],
              [51.2945933, 34.443],
              [51.29626, 34.4427203],
              [51.3001499, 34.4427203],
              [51.3068164, 34.4421699],
              [51.3101499, 34.4416104],
              [51.3110491, 34.4416104],
              [51.3115398, 34.4416104],
              [51.3120964, 34.4413397],
              [51.3220964, 34.4416104],
              [51.3235613, 34.4410598],
              [51.3259785, 34.4410284],
              [51.3625594, 34.445794],
              [51.379599, 34.4479996],
              [51.3907088, 34.4502285],
              [51.4054319, 34.4527282],
              [51.4123786, 34.4541089],
              [51.4321016, 34.4571681],
              [51.4387682, 34.4585579],
              [51.5018274, 34.4682858],
              [51.5054374, 34.4682859],
              [51.5062134, 34.4683496],
              [51.5154373, 34.469107],
              [51.5726632, 34.4760556],
              [51.5832197, 34.477725],
              [51.6046094, 34.4821739],
              [51.6062761, 34.4821738],
              [51.6284991, 34.4866137],
              [51.6293326, 34.4866136],
              [51.6304425, 34.4871731],
              [51.6318324, 34.4874529],
              [51.6326658, 34.4874529],
              [51.6337758, 34.4880034],
              [51.6682221, 34.4927229],
              [51.6790586, 34.4938329],
              [51.6810018, 34.4941126],
              [51.6837784, 34.4941126],
              [51.6948917, 34.4952225],
              [51.7076681, 34.4971718],
              [51.710448, 34.4974514],
              [51.7129481, 34.498002],
              [51.7143382, 34.4980019],
              [51.716838, 34.4985614],
              [51.8007816, 34.510984],
              [51.8098967, 34.5094458],
              [51.82851, 34.5055009],
              [51.8321199, 34.5055008],
              [51.8341678, 34.5059559],
              [51.8337865, 34.5068905],
              [51.8335099, 34.5071703],
              [51.8337865, 34.5082802],
              [51.8348966, 34.5099496],
              [51.8351766, 34.5105],
              [51.8360101, 34.5121695],
              [51.83712, 34.5163384],
              [51.8387866, 34.5230069],
              [51.839545, 34.5237742],
              [51.8407554, 34.5329227],
              [51.8412099, 34.5548442],
              [51.8403823, 34.5680611],
              [51.8503768, 34.5678171],
              [51.8557255, 34.5736958],
              [51.8619819, 34.5833108],
              [51.8848992, 34.6291226],
              [51.8885126, 34.635511],
              [51.9135122, 34.6955133],
              [51.9143454, 34.6969028],
              [51.9157355, 34.7010622],
              [51.9176787, 34.704951],
              [51.9279585, 34.7335616],
              [51.9329584, 34.7521748],
              [51.9343568, 34.7593378],
              [51.9376784, 34.7763456],
              [51.9379583, 34.776896],
              [51.9390683, 34.7846731],
              [51.9401818, 34.7955087],
              [51.9487915, 34.8257865],
              [51.9504581, 34.8343934],
              [51.9590713, 34.8580124],
              [51.9649046, 34.8652387],
              [51.962958, 34.8677287],
              [51.9524014, 34.8738453],
              [51.9521246, 34.8743957],
              [51.9354584, 34.8830113],
              [51.9351782, 34.8832909],
              [51.9073521, 34.8951647],
              [51.8487359, 34.9251713],
              [51.8290129, 34.9348878],
              [51.8098465, 34.946282],
              [51.7758234, 34.9626219],
              [51.7747135, 34.9631722],
              [51.7327673, 34.9909414],
              [51.7308239, 34.9923488],
              [51.7219341, 34.9959575],
              [51.7183207, 34.9970671],
              [51.7069308, 34.9998458],
              [51.6922112, 35.0026244],
              [51.6894311, 35.0029041],
              [51.6863744, 35.0031838],
              [51.6833688, 35.0031775],
              [51.6794313, 35.0029041],
              [51.674988, 35.0026244],
              [51.650445, 35.008287],
              [51.6459982, 35.0080164],
              [51.6421116, 35.0077368],
              [51.6384983, 35.0077368],
              [51.6365551, 35.0077368],
              [51.6321085, 35.0080164],
              [51.6193319, 35.0099559],
              [51.614332, 35.0110744],
              [51.5993289, 35.0177316],
              [51.5874823, 35.0254863],
              [51.5473918, 35.0641688],
              [51.5408083, 35.070961],
              [51.5359071, 35.0750509],
              [51.5297971, 35.0775504],
              [51.5229589, 35.0792221],
              [51.5157356, 35.080332],
              [51.4754534, 35.0876352],
              [51.4480369, 35.0929204],
              [51.4464176, 35.0932326],
              [51.4442626, 35.0934499],
              [51.4405978, 35.0938196],
              [51.4404723, 35.0937979],
              [51.398988, 35.1047632],
              [51.3620884, 35.1057775],
              [51.328259, 35.1222607],
              [51.3196491, 35.1247599],
              [51.3107592, 35.1267086],
              [51.2687771, 35.1449482],
              [51.2459973, 35.1505134],
              [51.2217869, 35.1587667],
              [51.2209536, 35.1590464],
              [51.2190068, 35.1590464],
              [51.1837272, 35.1662716],
              [51.1776174, 35.1668309],
              [51.158404, 35.173526],
              [51.146254, 35.1802358],
              [51.1451407, 35.1805155],
              [51.1406974, 35.1805155],
              [51.1398642, 35.1802358],
              [51.1320876, 35.1802358],
              [51.1227321, 35.1845114],
              [51.1174221, 35.187487],
              [51.1117675, 35.1913417],
              [51.1037144, 35.1927298],
              [51.0981577, 35.1927298],
              [51.096211, 35.1927298],
              [51.0903361, 35.1960954],
              [51.0878363, 35.1960953],
              [51.0872797, 35.1963748],
              [51.0828364, 35.1963747],
              [51.082003, 35.1966542],
              [51.0721996, 35.2005718],
              [51.0719231, 35.2008512],
              [51.0710896, 35.2008511],
              [51.0708131, 35.2005717],
              [51.0691464, 35.2005717],
              [51.0680331, 35.2008512],
              [51.0603947, 35.2037967],
              [51.0592847, 35.2040762],
              [51.0590081, 35.2037967],
              [51.0520531, 35.2061812],
              [51.0489966, 35.2061812],
              [51.0375902, 35.2106694],
              [51.0364768, 35.2109488],
              [51.0331435, 35.2109489],
              [51.0320335, 35.2112281],
              [51.0273102, 35.2114985],
              [51.0195337, 35.2131658],
              [51.0181436, 35.2131658],
              [51.0145337, 35.2142741],
              [51.0134203, 35.2142742],
              [50.993821, 35.2151123],
              [50.992711, 35.2151123],
              [50.983541, 35.2184467],
              [50.9498385, 35.2181248],
              [50.9110829, 35.2174937],
              [50.9077495, 35.2186113],
              [50.8712169, 35.2137184],
              [50.8431728, 35.2145523],
              [50.8470742, 35.1708012],
              [50.8334612, 35.1644063],
              [50.8326277, 35.1644063],
              [50.8317945, 35.1638471],
              [50.8231812, 35.1607984],
              [50.8204046, 35.1596891],
              [50.8195714, 35.1591299],
              [50.8165147, 35.1580205],
              [50.8159613, 35.1574612],
              [50.8065149, 35.1524643],
              [50.7720685, 35.1141302],
              [50.7706819, 35.1116317],
              [50.7704018, 35.1107929],
              [50.7673454, 35.1057958],
              [50.7584589, 35.0971817],
              [50.7570688, 35.0969112],
              [50.7567922, 35.0966225],
              [50.7540122, 35.0952424],
              [50.7537355, 35.0946831],
              [50.7512355, 35.0930145],
              [50.7195659, 35.0705181],
              [50.7003995, 35.0477418],
              [50.6970663, 35.044684],
              [50.6959565, 35.0441247],
              [50.6956764, 35.0435744],
              [50.6715099, 35.0319019],
              [50.66512, 35.0299625],
              [50.654287, 35.0193994],
              [50.6537302, 35.0182898],
              [50.6517869, 35.0138427],
              [50.6512302, 35.0102344],
              [50.6506736, 35.008286],
              [50.6498404, 34.9996803],
              [50.6534538, 34.9944031],
              [50.65873, 34.9885666],
              [50.6603969, 34.9877367],
              [50.6806767, 34.9710662],
              [50.6809532, 34.9705159],
              [50.6820665, 34.9694063],
              [50.6823435, 34.9685675],
              [50.6845665, 34.9663482],
              [50.6845666, 34.965789],
              [50.6851197, 34.9652386],
              [50.6923434, 34.9518966],
              [50.6934567, 34.9485678],
              [50.6934567, 34.9357939],
              [50.6942899, 34.9324561],
              [50.6942898, 34.9318968],
              [50.6942899, 34.9316261],
              [50.6945665, 34.9310668],
              [50.6945664, 34.9299572],
              [50.6962334, 34.9238408],
              [50.6981764, 34.9130063],
              [50.6984564, 34.9110666],
              [50.6998432, 34.9052388],
              [50.7001233, 34.9041202],
              [50.7006765, 34.9016213],
              [50.7009565, 34.8999613],
              [50.701233, 34.8980127],
              [50.70151, 34.8963437],
              [50.7017898, 34.8941244],
              [50.7020667, 34.8938449],
              [50.7020667, 34.8907865],
              [50.7020667, 34.8899566],
              [50.7023433, 34.8896769],
              [50.7023433, 34.8882877],
              [50.7023432, 34.8857886],
              [50.7026234, 34.88301],
              [50.7029, 34.881341],
              [50.7031765, 34.8799607],
              [50.7040097, 34.8771821],
              [50.7042898, 34.8769024],
              [50.7040097, 34.8766227],
              [50.7048433, 34.8735644],
              [50.7045664, 34.8727344],
              [50.7048433, 34.8713451],
              [50.705123, 34.8682868],
              [50.7040097, 34.8682868],
              [50.7034565, 34.8682868],
              [50.7028999, 34.8680071],
              [50.6995667, 34.8680071],
              [50.6895669, 34.8685665],
              [50.6762337, 34.8685665],
              [50.6756767, 34.8682868],
              [50.6720634, 34.8682868],
              [50.6715102, 34.8685664],
              [50.6651202, 34.8685665],
              [50.6642871, 34.8688461],
              [50.6620635, 34.8688461],
              [50.6615104, 34.8691258],
              [50.6601205, 34.8691257],
              [50.659287, 34.8694054],
              [50.6565102, 34.8696761],
              [50.653454, 34.8696761],
              [50.6523403, 34.8699557],
              [50.6506739, 34.8699558],
              [50.6498406, 34.8702354],
              [50.6212311, 34.8677274],
              [50.6028944, 34.864678],
              [50.600951, 34.8638389],
              [50.5998412, 34.863839],
              [50.5981712, 34.8627294],
              [50.5923379, 34.86051],
              [50.5859515, 34.8582906],
              [50.5848381, 34.8582907],
              [50.5845612, 34.858011],
              [50.583728, 34.858011],
              [50.5834513, 34.8577313],
              [50.5826182, 34.8577313],
              [50.5823381, 34.8574607],
              [50.5809515, 34.857181],
              [50.5801181, 34.8569013],
              [50.5765048, 34.8555119],
              [50.5751149, 34.855512],
              [50.5742814, 34.8552323],
              [50.5728949, 34.8552322],
              [50.5720618, 34.8549526],
              [50.5698382, 34.8549526],
              [50.5692816, 34.8552323],
              [50.5617814, 34.8552322],
              [50.5615049, 34.8555119],
              [50.5545583, 34.8577312],
              [50.5473386, 34.8571809],
              [50.5465054, 34.8574606],
              [50.5462252, 34.8571809],
              [50.5445584, 34.8571809],
              [50.5442818, 34.8574607],
              [50.5434486, 34.8571809],
              [50.542892, 34.8574606],
              [50.5420584, 34.8574606],
              [50.5362254, 34.8596709],
              [50.5303921, 34.8621789],
              [50.5226123, 34.8649576],
              [50.5206688, 34.8649575],
              [50.5201122, 34.8652373],
              [50.5184453, 34.8652373],
              [50.5178922, 34.8655169],
              [50.5165024, 34.8657875],
              [50.5087256, 34.8652372],
              [50.501779, 34.8638389],
              [50.4948359, 34.8618993],
              [50.4915026, 34.8605099],
              [50.4903893, 34.8605099],
              [50.4901123, 34.8602302],
              [50.4892791, 34.8602302],
              [50.4881694, 34.8596708],
              [50.4817794, 34.8566215],
              [50.4681662, 34.844397],
              [50.4642763, 34.8413477],
              [50.458443, 34.8363496],
              [50.4551111, 34.8319907],
              [50.451223, 34.8269037],
              [50.4509428, 34.8243956],
              [50.4506663, 34.8205072],
              [50.451223, 34.8180081],
              [50.4501097, 34.8107905],
              [50.4487234, 34.8035638],
              [50.4406666, 34.7777334],
              [50.4398334, 34.7752343],
              [50.4340001, 34.7574514],
              [50.4284433, 34.7541222],
              [50.4181635, 34.7560619],
              [50.4176103, 34.7557822],
              [50.4156638, 34.7549522],
              [50.4153868, 34.7546724],
              [50.4092738, 34.7519027],
              [50.4067737, 34.7519026],
              [50.4059405, 34.7516229],
              [50.4014971, 34.7516229],
              [50.4012205, 34.7519026],
              [50.3948305, 34.7527326],
              [50.3709409, 34.7585611],
              [50.368994, 34.758561],
              [50.3684409, 34.7588407],
              [50.367051, 34.7588407],
              [50.366494, 34.7591204],
              [50.3617743, 34.7591204],
              [50.3587176, 34.7588407],
              [50.3484378, 34.7588407],
              [50.3478846, 34.7591204],
              [50.3412177, 34.7599505],
              [50.3278814, 34.7680074],
              [50.3137147, 34.7799527],
              [50.3120483, 34.7813422],
              [50.2954101, 34.7998847],
              [50.2788544, 34.808439],
              [50.275986, 34.8097799],
              [50.2721849, 34.8116225],
              [50.2684341, 34.8138197],
              [50.2462121, 34.8141193],
              [50.2456555, 34.8138396],
              [50.2426022, 34.8130096],
              [50.2292657, 34.8132802],
              [50.2287125, 34.8130095],
              [50.2178759, 34.814399],
              [50.2148227, 34.814399],
              [50.2139891, 34.8146786],
              [50.1853765, 34.818567],
              [50.1828764, 34.8193971],
              [50.1823197, 34.8193971],
              [50.174263, 34.8213458],
              [50.1730065, 34.8213116],
              [50.1701204, 34.8210637],
              [50.1673968, 34.8203045],
              [50.1620492, 34.8175437],
              [50.1598201, 34.8143989],
              [50.15954, 34.8135599],
              [50.1314836, 34.7746745],
              [50.1220405, 34.7555112],
              [50.1214839, 34.7510631],
              [50.1203741, 34.7466151],
              [50.1203741, 34.7452257],
              [50.1200941, 34.7441159],
              [50.1198171, 34.7435566],
              [50.1195405, 34.7402272],
              [50.119817, 34.7393971],
              [50.1195405, 34.7388377],
              [50.1198171, 34.7346783],
              [50.120094, 34.7338393],
              [50.1206506, 34.7330093],
              [50.1231507, 34.7249521],
              [50.1248172, 34.7193943],
              [50.1245406, 34.7157852],
              [50.1217605, 34.7102273],
              [50.1131506, 34.698561],
              [50.1128741, 34.6971714],
              [50.1134275, 34.6955113],
              [50.1134276, 34.6952316],
              [50.1145409, 34.6932827],
              [50.1139842, 34.6905037],
              [50.1134276, 34.6899533],
              [50.1114842, 34.6863352],
              [50.1081509, 34.6843952],
              [50.1031508, 34.6755077],
              [50.1020375, 34.6693903],
              [50.1023176, 34.6655013],
              [50.1025941, 34.6643916],
              [50.1075943, 34.6566138],
              [50.1096736, 34.6543289],
              [50.1100944, 34.6538347],
              [50.1103741, 34.6524542],
              [50.1106511, 34.650785],
              [50.1109276, 34.6466163],
              [50.1112077, 34.6463366],
              [50.1109277, 34.6455065],
              [50.1092482, 34.6323985],
              [50.1081511, 34.6238331],
              [50.1014845, 34.6116156],
              [50.1014846, 34.6110562],
              [50.0864812, 34.5860616],
              [50.0862046, 34.5835621],
              [50.0864671, 34.5830887],
              [50.0864811, 34.5823911]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 1015996,
        "tags": {
          "ISO3166-2": "IR-30",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "البرز",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q392522"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [50.2019068, 35.5271473],
              [50.2200507, 35.5311786],
              [50.2280472, 35.5320984],
              [50.2850243, 35.5366967],
              [50.3223609, 35.5432615],
              [50.3289699, 35.5472422],
              [50.3329055, 35.5507027],
              [50.3359547, 35.5722262],
              [50.3363967, 35.5796417],
              [50.3327898, 35.5909379],
              [50.3348166, 35.6108344],
              [50.3390627, 35.617093],
              [50.3390459, 35.6171459],
              [50.3443563, 35.6265629],
              [50.3497457, 35.6342697],
              [50.3504345, 35.6366497],
              [50.3554448, 35.6429279],
              [50.3684747, 35.6549579],
              [50.3735038, 35.6584407],
              [50.3899732, 35.6601183],
              [50.4010756, 35.6624981],
              [50.4320327, 35.6659741],
              [50.4449465, 35.668183],
              [50.4784791, 35.6746135],
              [50.5017886, 35.6768269],
              [50.5550048, 35.6780321],
              [50.5603199, 35.678499],
              [50.6022051, 35.6853998],
              [50.6473003, 35.6843362],
              [50.6622927, 35.6843348],
              [50.7091523, 35.68334],
              [50.7140921, 35.6832351],
              [50.7365797, 35.6821196],
              [50.7455233, 35.6887396],
              [50.759426, 35.6987318],
              [50.7609338, 35.6995273],
              [50.7683124, 35.7034198],
              [50.7696551, 35.7041298],
              [50.7849981, 35.7020961],
              [50.7999945, 35.6989663],
              [50.8007775, 35.6987567],
              [50.801957, 35.6983999],
              [50.802819, 35.6979606],
              [50.803404, 35.6976624],
              [50.8068811, 35.6958905],
              [50.8104966, 35.6941038],
              [50.8110548, 35.6938755],
              [50.8118316, 35.7048444],
              [50.8139752, 35.7042993],
              [50.8153744, 35.7037954],
              [50.8163487, 35.7043405],
              [50.8220651, 35.7046541],
              [50.8266484, 35.7049469],
              [50.8286054, 35.7048632],
              [50.8297126, 35.7052814],
              [50.8320043, 35.7064941],
              [50.8370207, 35.7080116],
              [50.8442526, 35.7088027],
              [50.8507917, 35.7101038],
              [50.8538014, 35.712108],
              [50.8732782, 35.719615],
              [50.8769816, 35.7123853],
              [50.8950576, 35.7189499],
              [50.8983277, 35.7218767],
              [50.8991517, 35.7218139],
              [50.9027308, 35.7194308],
              [50.9001031, 35.7072262],
              [50.9000716, 35.7065461],
              [50.9038824, 35.6966323],
              [50.9042187, 35.6959901],
              [50.9047107, 35.695483],
              [50.9059632, 35.69503],
              [50.9108997, 35.6938743],
              [50.9188778, 35.6917598],
              [50.9192383, 35.6928054],
              [50.9160969, 35.6943111],
              [50.9161226, 35.6948757],
              [50.9165818, 35.6991531],
              [50.9171172, 35.702172],
              [50.9167578, 35.7052135],
              [50.9171622, 35.7062572],
              [50.9179298, 35.7082547],
              [50.9187834, 35.7098239],
              [50.9216179, 35.71419],
              [50.9226629, 35.7153764],
              [50.9249557, 35.7173982],
              [50.9266487, 35.7187188],
              [50.9284382, 35.720095],
              [50.9323866, 35.7221269],
              [50.9370855, 35.7213377],
              [50.9404877, 35.7205201],
              [50.9422206, 35.7199756],
              [50.9385389, 35.7106328],
              [50.9508618, 35.7077805],
              [50.9555426, 35.7069001],
              [50.9562672, 35.7072722],
              [50.9640026, 35.7060231],
              [50.969009, 35.7051183],
              [50.9691294, 35.7050923],
              [50.9691545, 35.7050869],
              [50.9712783, 35.7046287],
              [50.9730415, 35.7043025],
              [50.9745443, 35.7040653],
              [50.975248, 35.7039554],
              [50.9762069, 35.7037615],
              [50.9788688, 35.7032691],
              [50.9830709, 35.7025309],
              [50.9863934, 35.7019323],
              [50.987997, 35.7016476],
              [50.9898436, 35.701309],
              [50.9899005, 35.7014788],
              [50.9900359, 35.7018829],
              [50.9910821, 35.7016929],
              [50.9915648, 35.701597],
              [50.9921349, 35.7014783],
              [50.9932375, 35.70122],
              [50.9935205, 35.7011163],
              [50.9938969, 35.7022083],
              [50.9976089, 35.7004433],
              [51.0023672, 35.7071764],
              [51.0044854, 35.7065077],
              [51.0050844, 35.7117561],
              [51.0055029, 35.7125872],
              [51.0056015, 35.7127928],
              [51.0056264, 35.7128329],
              [51.0056812, 35.7128579],
              [51.0057399, 35.7128644],
              [51.00582, 35.7128616],
              [51.0059234, 35.7128439],
              [51.0060191, 35.7128156],
              [51.0060756, 35.7128182],
              [51.0061786, 35.7128664],
              [51.0062255, 35.7129183],
              [51.0062688, 35.7129664],
              [51.0063014, 35.7130463],
              [51.0067856, 35.7138288],
              [51.0071644, 35.7144409],
              [51.0066424, 35.7150205],
              [51.0085794, 35.7195565],
              [51.0095132, 35.7205797],
              [51.010918, 35.7222987],
              [51.0128492, 35.7240356],
              [51.0170337, 35.7278236],
              [51.0171804, 35.7279563],
              [51.0182893, 35.7289665],
              [51.0183954, 35.7290645],
              [51.0188357, 35.7294448],
              [51.0196918, 35.7305882],
              [51.0202111, 35.7313073],
              [51.0208281, 35.7319956],
              [51.0215354, 35.7333765],
              [51.0220463, 35.7340461],
              [51.0248221, 35.7378989],
              [51.0254871, 35.7387642],
              [51.0257243, 35.7389339],
              [51.0268377, 35.7376632],
              [51.0289344, 35.7391777],
              [51.0305823, 35.7394912],
              [51.0349597, 35.7391359],
              [51.0378951, 35.7385925],
              [51.0425815, 35.73807],
              [51.0475253, 35.7382372],
              [51.0495595, 35.7385089],
              [51.0511817, 35.739324],
              [51.0516776, 35.7389746],
              [51.0529472, 35.7379626],
              [51.0539369, 35.7363232],
              [51.0540791, 35.736051],
              [51.0543849, 35.7356809],
              [51.056651, 35.7351495],
              [51.0587088, 35.735499],
              [51.0613638, 35.7348334],
              [51.0631733, 35.7342617],
              [51.0642388, 35.7344717],
              [51.0663245, 35.7343463],
              [51.0681269, 35.7341791],
              [51.0701611, 35.7343254],
              [51.072942, 35.7339492],
              [51.0756199, 35.733991],
              [51.0776284, 35.7341791],
              [51.0804608, 35.7336147],
              [51.0829842, 35.7336849],
              [51.0855591, 35.7336983],
              [51.088855, 35.7344508],
              [51.090606, 35.7349942],
              [51.0903742, 35.7360393],
              [51.090503, 35.7373142],
              [51.0913784, 35.7403866],
              [51.0925702, 35.7401965],
              [51.0933876, 35.7421762],
              [51.0890493, 35.7429636],
              [51.0901497, 35.7456386],
              [51.0920291, 35.7487229],
              [51.0920783, 35.7488362],
              [51.0921226, 35.7489801],
              [51.0934702, 35.7559179],
              [51.093584, 35.7562732],
              [51.0936705, 35.7565435],
              [51.0940866, 35.7574188],
              [51.0940979, 35.7574547],
              [51.0941068, 35.7574954],
              [51.0941102, 35.7575368],
              [51.0941073, 35.7575551],
              [51.0941116, 35.7575654],
              [51.0941235, 35.7575703],
              [51.0941734, 35.7575792],
              [51.0941883, 35.7575946],
              [51.0941966, 35.7576132],
              [51.094197, 35.7576935],
              [51.0941943, 35.7577126],
              [51.0941876, 35.7577586],
              [51.0941942, 35.7577691],
              [51.095373, 35.7605029],
              [51.0956954, 35.7621845],
              [51.0988756, 35.7647237],
              [51.1015078, 35.7659094],
              [51.1057053, 35.7671917],
              [51.1098306, 35.7684567],
              [51.1124564, 35.7724766],
              [51.1149537, 35.7781703],
              [51.1185605, 35.7838232],
              [51.1187901, 35.7915401],
              [51.1167779, 35.8005118],
              [51.1147097, 35.81241],
              [51.1127952, 35.8172794],
              [51.1107225, 35.8217835],
              [51.1099432, 35.8281132],
              [51.1079443, 35.8425779],
              [51.1121943, 35.8439591],
              [51.1165998, 35.8459713],
              [51.1189556, 35.8470736],
              [51.1224424, 35.8472999],
              [51.1247061, 35.8494221],
              [51.1274527, 35.8642915],
              [51.1429022, 35.8794537],
              [51.1802406, 35.918515],
              [51.1828911, 35.9231683],
              [51.1826037, 35.9264506],
              [51.1826618, 35.9265048],
              [51.182008, 35.9296332],
              [51.1820081, 35.9296333],
              [51.1820654, 35.9296816],
              [51.1786078, 35.9357647],
              [51.1647525, 35.9633304],
              [51.1535452, 35.9821737],
              [51.1520964, 35.9983533],
              [51.1542253, 35.998958],
              [51.1781926, 35.9926449],
              [51.2096296, 35.9847279],
              [51.2096837, 35.9847159],
              [51.2525322, 35.9694481],
              [51.2688181, 35.9673484],
              [51.2781918, 35.9626491],
              [51.3231104, 35.9373673],
              [51.3359596, 35.9303989],
              [51.3423232, 35.9269476],
              [51.3529149, 35.9220974],
              [51.3667596, 35.9212172],
              [51.3770218, 35.9211929],
              [51.387189, 35.9263349],
              [51.3925405, 35.9315233],
              [51.3954812, 35.9363812],
              [51.3988614, 35.9427845],
              [51.4026685, 35.9504887],
              [51.4026685, 35.9505595],
              [51.4050718, 35.955836],
              [51.407046, 35.9587478],
              [51.4075587, 35.9597271],
              [51.4122623, 35.9677832],
              [51.4281661, 35.9902778],
              [51.4324276, 35.9953988],
              [51.4334394, 35.9971348],
              [51.437264, 35.9993626],
              [51.4449159, 36.0053379],
              [51.4508193, 36.0128169],
              [51.4508104, 36.0128413],
              [51.4558891, 36.0194846],
              [51.459389, 36.0233755],
              [51.459391, 36.0233815],
              [51.464424, 36.0243905],
              [51.4682487, 36.0286479],
              [51.4682373, 36.0286934],
              [51.4859965, 36.0486349],
              [51.4918105, 36.0535754],
              [51.4917255, 36.054211],
              [51.4972339, 36.0583245],
              [51.4997068, 36.0599459],
              [51.5019194, 36.0602148],
              [51.5074585, 36.0639025],
              [51.5242488, 36.0792001],
              [51.525278, 36.081708],
              [51.5168666, 36.0948865],
              [51.5113735, 36.107092],
              [51.5087985, 36.11153],
              [51.5007304, 36.1173543],
              [51.4967822, 36.1192957],
              [51.4926623, 36.1217223],
              [51.4903449, 36.1238715],
              [51.4866542, 36.1261594],
              [51.4824485, 36.1269913],
              [51.4736938, 36.1298336],
              [51.4696597, 36.1340623],
              [51.4559429, 36.1461336],
              [51.4464438, 36.1517204],
              [51.4382541, 36.1551856],
              [51.4317368, 36.1603158],
              [51.4286109, 36.1602465],
              [51.4239594, 36.1590013],
              [51.4142812, 36.1574073],
              [51.407888, 36.1565044],
              [51.4004212, 36.1560885],
              [51.3850217, 36.1585119],
              [51.3811708, 36.1600365],
              [51.3720743, 36.1611451],
              [51.3693968, 36.1610087],
              [51.360781, 36.1589991],
              [51.3563012, 36.1576846],
              [51.3536246, 36.158031],
              [51.3507201, 36.159828],
              [51.346786, 36.1603174],
              [51.3444697, 36.1598446],
              [51.3388324, 36.1540239],
              [51.3376912, 36.1535621],
              [51.3346052, 36.1539026],
              [51.3312653, 36.1535463],
              [51.3275479, 36.1543661],
              [51.3197565, 36.1580434],
              [51.3125896, 36.1622012],
              [51.3068389, 36.1650423],
              [51.3001314, 36.1666993],
              [51.2973159, 36.1665777],
              [51.2928339, 36.1676867],
              [51.2886791, 36.1678267],
              [51.2821287, 36.1667527],
              [51.2730428, 36.1672499],
              [51.2644413, 36.1685286],
              [51.2494351, 36.1733257],
              [51.2476134, 36.1785692],
              [51.2464072, 36.1856445],
              [51.2453628, 36.1938543],
              [51.2428373, 36.1973065],
              [51.2408941, 36.1986662],
              [51.2433763, 36.2024141],
              [51.2494899, 36.2096164],
              [51.239461, 36.2105845],
              [51.2204855, 36.2105949],
              [51.2098019, 36.2090136],
              [51.2011319, 36.2085395],
              [51.1933831, 36.2080661],
              [51.1854099, 36.2087599],
              [51.1791362, 36.2085041],
              [51.1712837, 36.2086446],
              [51.157123, 36.2090527],
              [51.144385, 36.2099152],
              [51.1346527, 36.2103084],
              [51.1250198, 36.2123269],
              [51.1044501, 36.2168909],
              [51.063938, 36.2301506],
              [51.0410168, 36.2372096],
              [51.0246514, 36.2409887],
              [51.0098114, 36.2447504],
              [51.0042285, 36.246513],
              [50.9989763, 36.2485704],
              [51.0001284, 36.2485033],
              [50.9946189, 36.2523003],
              [50.9845088, 36.2619347],
              [50.9756049, 36.267309],
              [50.964117, 36.2729608],
              [50.9517574, 36.2780466],
              [50.9412963, 36.2805097],
              [50.9273386, 36.2838932],
              [50.9186055, 36.2865326],
              [50.9149297, 36.2929376],
              [50.9140298, 36.2939145],
              [50.9076038, 36.3011458],
              [50.9024911, 36.3091185],
              [50.9017914, 36.3116473],
              [50.9030485, 36.3159897],
              [50.905838, 36.3229744],
              [50.9061246, 36.3300928],
              [50.9049797, 36.3332948],
              [50.9029717, 36.3376248],
              [50.9002477, 36.3409258],
              [50.8954771, 36.3448186],
              [50.890485, 36.3469668],
              [50.8837366, 36.3493864],
              [50.8817933, 36.3504978],
              [50.881445, 36.3508941],
              [50.8820468, 36.3495938],
              [50.8820575, 36.3491747],
              [50.8817839, 36.3481248],
              [50.8804536, 36.3468113],
              [50.8791446, 36.3449101],
              [50.878458, 36.3432423],
              [50.8756578, 36.3406324],
              [50.8750892, 36.3395607],
              [50.8740699, 36.338515],
              [50.8720958, 36.3362247],
              [50.8715164, 36.3358617],
              [50.8706528, 36.3356154],
              [50.8690381, 36.3350061],
              [50.8654654, 36.3343752],
              [50.8646607, 36.3343147],
              [50.8637273, 36.3339258],
              [50.8634376, 36.3335368],
              [50.8626008, 36.3321194],
              [50.861839, 36.3319206],
              [50.8568394, 36.3317131],
              [50.8558953, 36.3317564],
              [50.8538782, 36.3315057],
              [50.8533579, 36.3315122],
              [50.8527866, 36.3316958],
              [50.8523172, 36.3317628],
              [50.8513221, 36.3318363],
              [50.8507937, 36.3317002],
              [50.8501768, 36.3311945],
              [50.8496028, 36.330516],
              [50.8489215, 36.329911],
              [50.8481491, 36.3287053],
              [50.8475697, 36.3283595],
              [50.8470547, 36.3280786],
              [50.8464807, 36.3276248],
              [50.8462285, 36.3273115],
              [50.846647, 36.326661],
              [50.8472264, 36.3259047],
              [50.8491146, 36.3242278],
              [50.8512068, 36.3232424],
              [50.8519256, 36.3225422],
              [50.8524835, 36.3221359],
              [50.8529019, 36.3213493],
              [50.8531057, 36.3205454],
              [50.8528268, 36.3192314],
              [50.8520973, 36.3178742],
              [50.8516252, 36.3165948],
              [50.8506811, 36.3154537],
              [50.849533, 36.3142953],
              [50.8485782, 36.314131],
              [50.8469045, 36.3141656],
              [50.845617, 36.3142174],
              [50.8440614, 36.3142088],
              [50.842334, 36.3134739],
              [50.8405745, 36.313059],
              [50.8391368, 36.3131887],
              [50.8366477, 36.312255],
              [50.8320451, 36.3098169],
              [50.8303499, 36.3081656],
              [50.8289552, 36.3070503],
              [50.8276033, 36.3065488],
              [50.8257472, 36.3061771],
              [50.8236766, 36.3062895],
              [50.8213055, 36.305788],
              [50.8186769, 36.3050185],
              [50.8169549, 36.303981],
              [50.8162469, 36.3030255],
              [50.8159561, 36.3025563],
              [50.8075568, 36.3024958],
              [50.7964305, 36.3028244],
              [50.7945682, 36.3028732],
              [50.7824992, 36.3047505],
              [50.7621574, 36.3062031],
              [50.7592641, 36.3074533],
              [50.7586383, 36.3127737],
              [50.7531451, 36.3161626],
              [50.7503584, 36.3161852],
              [50.74512, 36.3186021],
              [50.7423435, 36.3186021],
              [50.7377715, 36.3191497],
              [50.7300996, 36.3192747],
              [50.7273101, 36.3173728],
              [50.7271814, 36.3144682],
              [50.7261085, 36.3134999],
              [50.7218599, 36.3135345],
              [50.7192359, 36.3147004],
              [50.7141351, 36.3155401],
              [50.7084103, 36.3160146],
              [50.7074403, 36.3186868],
              [50.7048124, 36.3203741],
              [50.7027626, 36.3217643],
              [50.6995868, 36.3221446],
              [50.697484, 36.3201045],
              [50.6956385, 36.3180645],
              [50.6923341, 36.3170617],
              [50.6897163, 36.3064797],
              [50.6824206, 36.3017762],
              [50.67667, 36.2967265],
              [50.6723785, 36.2967957],
              [50.6685161, 36.2939594],
              [50.6647395, 36.2932676],
              [50.6606074, 36.2885485],
              [50.6592464, 36.2859342],
              [50.6567144, 36.2877676],
              [50.6537532, 36.2887708],
              [50.6487643, 36.2907875],
              [50.6414365, 36.2907425],
              [50.6379603, 36.2876639],
              [50.6281719, 36.2870544],
              [50.6253432, 36.2893935],
              [50.6210517, 36.2931984],
              [50.6121253, 36.296519],
              [50.6076621, 36.2970032],
              [50.5993365, 36.3017762],
              [50.5976199, 36.3010845],
              [50.5910968, 36.3011537],
              [50.5790805, 36.3047505],
              [50.571848, 36.3061936],
              [50.5646734, 36.3075771],
              [50.5604124, 36.3093501],
              [50.5565071, 36.3105605],
              [50.5529451, 36.3100763],
              [50.5515047, 36.3092496],
              [50.549941, 36.3058918],
              [50.5456924, 36.3029867],
              [50.5408001, 36.3018108],
              [50.5333328, 36.300289],
              [50.5326032, 36.2976257],
              [50.5310583, 36.294582],
              [50.5298043, 36.2949701],
              [50.5280971, 36.2962076],
              [50.5237197, 36.3000469],
              [50.5223035, 36.3019491],
              [50.5179745, 36.3047488],
              [50.5157068, 36.3069268],
              [50.5061674, 36.3108717],
              [50.504837, 36.3134999],
              [50.5040352, 36.3163166],
              [50.5022401, 36.3190137],
              [50.5001262, 36.3199527],
              [50.4967689, 36.3196205],
              [50.4926383, 36.3185316],
              [50.4894019, 36.3193932],
              [50.4842588, 36.3205371],
              [50.4806536, 36.3209392],
              [50.47544, 36.3208998],
              [50.4713629, 36.320243],
              [50.4629515, 36.3170617],
              [50.4588316, 36.308624],
              [50.4578015, 36.302399],
              [50.4471586, 36.2981101],
              [50.4411505, 36.2985251],
              [50.4322241, 36.2938211],
              [50.4239844, 36.293406],
              [50.419006, 36.2903623],
              [50.4213353, 36.2742717],
              [50.4267659, 36.2717426],
              [50.429372, 36.2689705],
              [50.4305739, 36.2688319],
              [50.4322241, 36.2637917],
              [50.4314447, 36.254092],
              [50.4287909, 36.2503647],
              [50.4308939, 36.248115],
              [50.4342093, 36.2460411],
              [50.4383182, 36.2436502],
              [50.434606, 36.2410716],
              [50.4332141, 36.2393804],
              [50.4345845, 36.238666],
              [50.4439864, 36.2364441],
              [50.4506349, 36.2348237],
              [50.4546298, 36.2337188],
              [50.459926, 36.2322276],
              [50.4634451, 36.2311718],
              [50.4676844, 36.2299937],
              [50.4722214, 36.2287311],
              [50.4777353, 36.2271836],
              [50.4811048, 36.2262387],
              [50.4887008, 36.2225343],
              [50.4914903, 36.221184],
              [50.496683, 36.2184143],
              [50.5003737, 36.2166485],
              [50.504322, 36.2131168],
              [50.5110644, 36.2076359],
              [50.5171966, 36.202313],
              [50.5206728, 36.2012394],
              [50.523076, 36.2008931],
              [50.5265521, 36.1984689],
              [50.5305862, 36.1937243],
              [50.5378597, 36.1870277],
              [50.5408833, 36.1845985],
              [50.5465912, 36.1813861],
              [50.5513366, 36.1786013],
              [50.5576509, 36.1750412],
              [50.561434, 36.17264],
              [50.5661725, 36.1702798],
              [50.5703684, 36.1677103],
              [50.5797243, 36.1623744],
              [50.6052589, 36.1511478],
              [50.6125784, 36.1469832],
              [50.6178974, 36.1439311],
              [50.6462184, 36.1304475],
              [50.6687736, 36.118429],
              [50.673666, 36.112362],
              [50.675683, 36.1074734],
              [50.6748139, 36.1061732],
              [50.6736287, 36.1053388],
              [50.6620785, 36.0990479],
              [50.6026155, 36.0974818],
              [50.5604279, 36.0420636],
              [50.5570961, 36.037591],
              [50.5526672, 36.0346759],
              [50.5531307, 36.029137],
              [50.551251, 36.0258468],
              [50.5469766, 36.0195366],
              [50.5451999, 36.0199115],
              [50.534308, 36.0215151],
              [50.5282312, 36.0222024],
              [50.5235191, 36.020807],
              [50.5146614, 36.0167667],
              [50.5108763, 36.0146423],
              [50.5080953, 36.0120596],
              [50.50413, 36.008477],
              [50.5007053, 36.0046443],
              [50.4983879, 36.0021863],
              [50.4973064, 36.0009156],
              [50.4953495, 35.9998116],
              [50.4930321, 35.9996449],
              [50.4891182, 36.0001032],
              [50.4837881, 36.0016447],
              [50.4781233, 36.0039153],
              [50.4683901, 36.0082687],
              [50.4643217, 36.0092894],
              [50.4576445, 36.00964],
              [50.4539915, 36.0099335],
              [50.4510046, 36.0100168],
              [50.44655, 36.0107458],
              [50.4429193, 36.0095586],
              [50.4387737, 36.0074756],
              [50.4362503, 36.007059],
              [50.4337526, 36.0052677],
              [50.4324137, 36.0045595],
              [50.431358, 36.0044553],
              [50.4294268, 36.0044553],
              [50.4280878, 36.0044553],
              [50.4254614, 36.0048094],
              [50.4232985, 36.0044761],
              [50.4220882, 36.0036846],
              [50.4193073, 36.0034763],
              [50.4156767, 36.0029763],
              [50.4141129, 36.0016466],
              [50.4115895, 35.9976261],
              [50.4096583, 35.9952512],
              [50.4088858, 35.9916262],
              [50.4084996, 35.9865218],
              [50.4072636, 35.981417],
              [50.4067713, 35.9777576],
              [50.4059381, 35.9749817],
              [50.4045337, 35.9708545],
              [50.4014946, 35.9619224],
              [50.3989946, 35.9522066],
              [50.3342688, 35.8613712],
              [50.3339922, 35.8610917],
              [50.3320457, 35.8583155],
              [50.3317692, 35.8577567],
              [50.3313526, 35.8573375],
              [50.3309356, 35.8569274],
              [50.3281589, 35.8533129],
              [50.3151028, 35.8424783],
              [50.3151029, 35.8421989],
              [50.2970462, 35.8224764],
              [50.2918249, 35.819517],
              [50.2847668, 35.8013865],
              [50.2857968, 35.7841206],
              [50.2761837, 35.7791072],
              [50.2627943, 35.7837027],
              [50.2531496, 35.7793684],
              [50.252063, 35.7535238],
              [50.2459336, 35.7277522],
              [50.2437105, 35.7163664],
              [50.2434336, 35.6985886],
              [50.2434347, 35.689158],
              [50.2434336, 35.6891406],
              [50.2437106, 35.6855345],
              [50.2439795, 35.6847194],
              [50.2439872, 35.6846961],
              [50.243712, 35.6816555],
              [50.2437106, 35.6816399],
              [50.2442673, 35.6746981],
              [50.2445387, 35.6741496],
              [50.2445439, 35.6741391],
              [50.2437107, 35.6477508],
              [50.2417673, 35.644424],
              [50.2403774, 35.6427562],
              [50.2384305, 35.6410792],
              [50.2273209, 35.6363639],
              [50.2264873, 35.6363639],
              [50.2139875, 35.6330282],
              [50.2128741, 35.6330281],
              [50.212321, 35.6327487],
              [50.2106542, 35.6327486],
              [50.2098209, 35.632469],
              [50.2078744, 35.6321986],
              [50.2056544, 35.6321987],
              [50.2053744, 35.6319192],
              [50.2045412, 35.6319191],
              [50.2034309, 35.6316396],
              [50.2000977, 35.6313692],
              [50.1939843, 35.6313692],
              [50.1937077, 35.6310807],
              [50.1834313, 35.6294218],
              [50.1792614, 35.6285833],
              [50.168708, 35.6241385],
              [50.1650946, 35.6191346],
              [50.1634282, 35.6141399],
              [50.1631547, 35.6105736],
              [50.1631517, 35.6105336],
              [50.1645415, 35.6033117],
              [50.1648181, 35.6027528],
              [50.1678749, 35.5963603],
              [50.2059774, 35.5732452],
              [50.2090306, 35.5707473],
              [50.2032222, 35.535874],
              [50.2027175, 35.5340377],
              [50.2019068, 35.5271473]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 2232180,
        "tags": {
          "ISO3166-2": "IR-03",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "آذربایجان شرقی",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q176081"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [45.0935234, 38.3211458],
              [45.0937309, 38.3203105],
              [45.0951208, 38.3139243],
              [45.0948443, 38.3133675],
              [45.0951209, 38.3122537],
              [45.1087871, 38.2943077],
              [45.1090668, 38.2940292],
              [45.1099005, 38.2890257],
              [45.1100487, 38.2880934],
              [45.1083189, 38.2723535],
              [45.1215359, 38.252471],
              [45.1229092, 38.2330566],
              [45.1256991, 38.2308651],
              [45.129089, 38.2282022],
              [45.1335685, 38.2178206],
              [45.133586, 38.2177997],
              [45.1611605, 38.1901477],
              [45.1611606, 38.1901475],
              [45.2376182, 38.1759983],
              [45.2438245, 38.1232975],
              [45.248222, 38.0859326],
              [45.2725979, 38.0602567],
              [45.3109308, 38.0061197],
              [45.3126351, 38.0037117],
              [45.3234746, 37.9846324],
              [45.3354909, 37.9727628],
              [45.3360441, 37.9713703],
              [45.3357675, 37.9710918],
              [45.336044, 37.9705438],
              [45.3357675, 37.9697083],
              [45.3583602, 37.9342219],
              [45.3586406, 37.9325593],
              [45.3586407, 37.9317236],
              [45.3586407, 37.9317235],
              [45.3586406, 37.9297732],
              [45.3701016, 37.9100756],
              [45.3749044, 37.8850655],
              [45.3786811, 37.8744895],
              [45.3824612, 37.8604891],
              [45.3844338, 37.8426114],
              [45.3852673, 37.8423328],
              [45.3858944, 37.8200907],
              [45.3809419, 37.8014272],
              [45.3783413, 37.7945931],
              [45.3716467, 37.7918799],
              [45.3689036, 37.7865582],
              [45.3792518, 37.7814531],
              [45.3774764, 37.7682854],
              [45.3931042, 37.7310821],
              [45.4199217, 37.7022675],
              [45.4681383, 37.6626187],
              [45.4991906, 37.637073],
              [45.5086374, 37.6259642],
              [45.5218499, 37.6104244],
              [45.5223037, 37.5924467],
              [45.5225365, 37.5832222],
              [45.4702849, 37.5362969],
              [45.4722672, 37.5292754],
              [45.475158, 37.498832],
              [45.4606918, 37.4644556],
              [45.4588598, 37.4603627],
              [45.4627587, 37.4451104],
              [45.4710381, 37.4219812],
              [45.4718856, 37.3845861],
              [45.4983608, 37.3604861],
              [45.5163567, 37.3483266],
              [45.5442443, 37.3357214],
              [45.5457115, 37.3357075],
              [45.547613, 37.3348653],
              [45.5518166, 37.3332071],
              [45.5551695, 37.3319764],
              [45.5564822, 37.3290021],
              [45.5582813, 37.3271867],
              [45.5723531, 37.3265509],
              [45.5857526, 37.3244002],
              [45.5836179, 37.3155446],
              [45.5868276, 37.3059703],
              [45.5953151, 37.3033496],
              [45.6291132, 37.3035606],
              [45.6421216, 37.3036418],
              [45.6878289, 37.2901539],
              [45.7611034, 37.2065666],
              [45.8460885, 37.1749873],
              [45.863285, 37.1726281],
              [45.8674478, 37.1722861],
              [45.8833265, 37.1716364],
              [45.908904, 37.1725939],
              [45.9106636, 37.1731239],
              [45.9124446, 37.1735],
              [45.9158563, 37.1744575],
              [45.9197187, 37.1763553],
              [45.9221434, 37.1764408],
              [45.9246791, 37.1768877],
              [45.927864, 37.1775374],
              [45.9297929, 37.1777714],
              [45.932254, 37.1777714],
              [45.9355991, 37.1768598],
              [45.9400445, 37.1756783],
              [45.9426652, 37.1756838],
              [45.9474454, 37.1749999],
              [45.9505956, 37.1741055],
              [45.9547065, 37.1731771],
              [45.9565502, 37.1726876],
              [45.9599304, 37.1726964],
              [45.9628989, 37.1716223],
              [45.9653973, 37.1705624],
              [45.9661531, 37.1695162],
              [45.9679555, 37.1684903],
              [45.9713459, 37.168969],
              [45.9749937, 37.1680115],
              [45.9797573, 37.1667462],
              [45.9832294, 37.1656433],
              [45.9861037, 37.1649593],
              [45.9888055, 37.1632768],
              [45.9907865, 37.1612058],
              [45.9931039, 37.160214],
              [45.9950351, 37.1582303],
              [45.9977312, 37.1568034],
              [46.0007528, 37.1553326],
              [46.0033984, 37.1540275],
              [46.0048423, 37.153275],
              [46.0062568, 37.1514226],
              [46.0093367, 37.1472219],
              [46.0101704, 37.144999],
              [46.0118869, 37.1433106],
              [46.0129737, 37.1416404],
              [46.0135327, 37.1396334],
              [46.0146183, 37.1383396],
              [46.0163111, 37.1376159],
              [46.0180807, 37.1373298],
              [46.0213422, 37.1376719],
              [46.0253763, 37.1377061],
              [46.0303115, 37.1356192],
              [46.0332848, 37.1340897],
              [46.0355901, 37.1313083],
              [46.0367265, 37.1285151],
              [46.0372638, 37.1274762],
              [46.0368347, 37.1248757],
              [46.0383796, 37.1224805],
              [46.0397524, 37.1205482],
              [46.0396671, 37.1183057],
              [46.0420274, 37.1176897],
              [46.0430574, 37.1157734],
              [46.0446882, 37.114644],
              [46.0450315, 37.1138227],
              [46.0445165, 37.1130356],
              [46.0443409, 37.111082],
              [46.0457562, 37.109629],
              [46.0482931, 37.1093737],
              [46.0485838, 37.1088263],
              [46.0475762, 37.1080667],
              [46.0470485, 37.1064988],
              [46.0495376, 37.1042398],
              [46.0527563, 37.1031788],
              [46.0531793, 37.1024562],
              [46.0532444, 37.102368],
              [46.0541296, 37.1011251],
              [46.0550892, 37.1003523],
              [46.0545158, 37.0979076],
              [46.0549879, 37.0967781],
              [46.0549449, 37.0952035],
              [46.0624888, 37.0879605],
              [46.0702387, 37.0808077],
              [46.0801696, 37.0705701],
              [46.0867881, 37.0645265],
              [46.0933596, 37.0584359],
              [46.0970275, 37.0549483],
              [46.1021218, 37.0588451],
              [46.1048675, 37.0575729],
              [46.1071602, 37.0571469],
              [46.1115932, 37.0554511],
              [46.1242532, 37.0489436],
              [46.1339199, 37.045133],
              [46.1347997, 37.0447905],
              [46.1361301, 37.0438313],
              [46.1375892, 37.0420758],
              [46.1381042, 37.0416648],
              [46.1404967, 37.0407656],
              [46.1416983, 37.0404829],
              [46.1434257, 37.0402688],
              [46.1442947, 37.0399177],
              [46.1450243, 37.0392497],
              [46.1496377, 37.0375541],
              [46.153135, 37.0358072],
              [46.154766, 37.0344195],
              [46.1560535, 37.0325353],
              [46.1553239, 37.0302399],
              [46.154809, 37.0271564],
              [46.1545515, 37.0254776],
              [46.1562681, 37.01955],
              [46.1560749, 37.0178025],
              [46.1548948, 37.0164147],
              [46.1549789, 37.0151171],
              [46.1556243, 37.0139303],
              [46.1567831, 37.0125939],
              [46.1585426, 37.0109833],
              [46.1602592, 37.0100923],
              [46.1657799, 37.0084539],
              [46.1689281, 37.0047118],
              [46.1699152, 37.0010447],
              [46.1714172, 36.9986798],
              [46.1724975, 36.9980092],
              [46.175971, 36.9976763],
              [46.1769564, 36.9945469],
              [46.1758953, 36.9844383],
              [46.1760241, 36.9829693],
              [46.1762807, 36.9753928],
              [46.1751038, 36.9681942],
              [46.1725783, 36.9632976],
              [46.171844, 36.9593991],
              [46.1755568, 36.9528007],
              [46.1805068, 36.948936],
              [46.1827338, 36.947855],
              [46.188397, 36.9441509],
              [46.1937098, 36.9413669],
              [46.1964579, 36.953436],
              [46.1995907, 36.9540144],
              [46.2008295, 36.9540486],
              [46.2061311, 36.9549355],
              [46.2104584, 36.9557586],
              [46.2141005, 36.956591],
              [46.2178035, 36.9586589],
              [46.2224864, 36.9625118],
              [46.2267779, 36.9654608],
              [46.2314557, 36.9709812],
              [46.2325287, 36.9726611],
              [46.2339877, 36.9741698],
              [46.2344813, 36.9746668],
              [46.2364983, 36.9745126],
              [46.2387514, 36.9735869],
              [46.2414336, 36.9721297],
              [46.2435154, 36.9708586],
              [46.2446287, 36.9702757],
              [46.245375, 36.969989],
              [46.2475195, 36.9689065],
              [46.2497082, 36.9675304],
              [46.2511754, 36.9671066],
              [46.2524199, 36.966798],
              [46.2562723, 36.9665532],
              [46.2599086, 36.9666266],
              [46.2623977, 36.9685124],
              [46.2656164, 36.9686496],
              [46.269298, 36.9674842],
              [46.2714958, 36.9661808],
              [46.2749273, 36.9639567],
              [46.2769031, 36.9627176],
              [46.2777969, 36.9626878],
              [46.2812805, 36.9635062],
              [46.2838182, 36.9657498],
              [46.286466, 36.9676595],
              [46.2885855, 36.9692809],
              [46.290121, 36.971564],
              [46.2907219, 36.9729012],
              [46.2940692, 36.9792438],
              [46.2994991, 36.98751],
              [46.3035106, 36.9977544],
              [46.3037631, 37.0029108],
              [46.3043583, 37.0048004],
              [46.3054847, 37.0080361],
              [46.3086605, 37.0144444],
              [46.3084796, 37.0157685],
              [46.3176342, 37.0202686],
              [46.346408, 37.0336894],
              [46.3545143, 37.0386275],
              [46.3694088, 37.0463893],
              [46.3763053, 37.0488913],
              [46.3943194, 37.0594239],
              [46.4103698, 37.0667524],
              [46.4252167, 37.0734606],
              [46.4282869, 37.0743027],
              [46.4319133, 37.0772131],
              [46.4325142, 37.0796097],
              [46.4329219, 37.0808423],
              [46.433351, 37.0825541],
              [46.4338231, 37.0838893],
              [46.4347886, 37.0850705],
              [46.4359689, 37.087039],
              [46.4368271, 37.089384],
              [46.437943, 37.0902741],
              [46.4397883, 37.0913353],
              [46.4403891, 37.0922082],
              [46.4398527, 37.0928757],
              [46.4391446, 37.0946044],
              [46.4391875, 37.096333],
              [46.4398039, 37.098697],
              [46.4401449, 37.1008417],
              [46.4404392, 37.1012347],
              [46.4413562, 37.1012004],
              [46.4475137, 37.0977485],
              [46.4531426, 37.0964134],
              [46.4604757, 37.0950568],
              [46.4638412, 37.095228],
              [46.4680437, 37.0959245],
              [46.4704511, 37.0962908],
              [46.4753601, 37.0976823],
              [46.4796586, 37.0989421],
              [46.4817319, 37.0996673],
              [46.4829444, 37.0998659],
              [46.4865897, 37.1004768],
              [46.4914281, 37.1003228],
              [46.4933677, 37.0987708],
              [46.4954099, 37.0948949],
              [46.4968007, 37.0920848],
              [46.4978742, 37.0868849],
              [46.4976596, 37.0828109],
              [46.4963566, 37.0768892],
              [46.4958829, 37.0741285],
              [46.4953851, 37.0719572],
              [46.4956246, 37.0696583],
              [46.4967155, 37.0668551],
              [46.4966297, 37.0651087],
              [46.4937114, 37.0605883],
              [46.4915027, 37.0584603],
              [46.488959, 37.0564537],
              [46.4829826, 37.051735],
              [46.476953, 37.0483613],
              [46.4666107, 37.0431049],
              [46.4636063, 37.0417675],
              [46.4626622, 37.0408598],
              [46.462276, 37.0401404],
              [46.4624678, 37.0390896],
              [46.462269, 37.0354984],
              [46.461797, 37.0329132],
              [46.4595508, 37.0299316],
              [46.4570617, 37.0288352],
              [46.454892, 37.0269139],
              [46.4527702, 37.0252378],
              [46.4512682, 37.0231135],
              [46.4526844, 37.0217772],
              [46.4589524, 37.0196189],
              [46.4653015, 37.019036],
              [46.4744686, 37.0172145],
              [46.4767984, 37.0167036],
              [46.4776321, 37.0164246],
              [46.4809658, 37.0164246],
              [46.4812423, 37.0161456],
              [46.489019, 37.0161456],
              [46.489855, 37.0158664],
              [46.5040966, 37.0176314],
              [46.5229715, 37.0273948],
              [46.5232481, 37.0276738],
              [46.5243583, 37.0276738],
              [46.5249153, 37.0279529],
              [46.5257482, 37.0279528],
              [46.5263053, 37.0282318],
              [46.5274154, 37.0282318],
              [46.5507514, 37.0272266],
              [46.5579743, 37.0294499],
              [46.5590876, 37.0294498],
              [46.559365, 37.0297289],
              [46.561308, 37.0302779],
              [46.5626979, 37.0302779],
              [46.5660315, 37.030836],
              [46.5665878, 37.030836],
              [46.567698, 37.031115],
              [46.5690878, 37.0311149],
              [46.5729746, 37.031673],
              [46.5760309, 37.031673],
              [46.5768646, 37.0319521],
              [46.5801975, 37.0322221],
              [46.5871445, 37.0322221],
              [46.5879773, 37.0325012],
              [46.5907539, 37.0325011],
              [46.591311, 37.0327801],
              [46.5940875, 37.0327802],
              [46.5949211, 37.0330592],
              [46.611034, 37.0352824],
              [46.6165904, 37.0363595],
              [46.6382572, 37.0405569],
              [46.6407573, 37.0411149],
              [46.6421472, 37.0411149],
              [46.659243, 37.041821],
              [46.6603531, 37.0418209],
              [46.6887763, 37.0360428],
              [46.6904427, 37.0382664],
              [46.6850208, 37.0509351],
              [46.6833883, 37.0635534],
              [46.6839414, 37.0635534],
              [46.6847743, 37.0641115],
              [46.6850548, 37.0643904],
              [46.6861649, 37.0646603],
              [46.6900548, 37.0668834],
              [46.6908877, 37.0668834],
              [46.7029828, 37.0716713],
              [46.7040929, 37.0716714],
              [46.7046492, 37.0719504],
              [46.7054828, 37.0719504],
              [46.7063165, 37.0722294],
              [46.7093696, 37.0724994],
              [46.7263161, 37.0702764],
              [46.7304825, 37.0688904],
              [46.7329827, 37.0677834],
              [46.7602059, 37.0577841],
              [46.7615958, 37.0577841],
              [46.7621521, 37.0575051],
              [46.7638194, 37.0575051],
              [46.7643724, 37.0572261],
              [46.7652053, 37.0572261],
              [46.7654857, 37.0569471],
              [46.7671522, 37.0569471],
              [46.7674287, 37.0566681],
              [46.7690952, 37.056668],
              [46.7696522, 37.0563891],
              [46.7707624, 37.0563891],
              [46.7713187, 37.0561101],
              [46.774929, 37.0555611],
              [46.7779853, 37.0555611],
              [46.7782618, 37.0552821],
              [46.7802087, 37.055282],
              [46.7807619, 37.0550031],
              [46.7827088, 37.055003],
              [46.783262, 37.054724],
              [46.7840955, 37.054724],
              [46.7849323, 37.054445],
              [46.7865987, 37.054445],
              [46.7893754, 37.0541661],
              [46.8019014, 37.0492971],
              [46.8024319, 37.0488918],
              [46.8027085, 37.0486128],
              [46.8257901, 37.0368178],
              [46.8535992, 37.0028271],
              [46.8421778, 36.9755616],
              [46.8421779, 36.9736173],
              [46.8421779, 36.971124],
              [46.8386786, 36.9591506],
              [46.8389552, 36.9583224],
              [46.8389552, 36.9544338],
              [46.8436781, 36.9385999],
              [46.8492353, 36.9285988],
              [46.8622918, 36.9194349],
              [46.8642349, 36.9185977],
              [46.8917378, 36.91082],
              [46.892291, 36.9102619],
              [46.9027515, 36.9088392],
              [46.9074743, 36.8991171],
              [46.9077509, 36.898559],
              [46.9074744, 36.8957864],
              [46.9074743, 36.8927258],
              [46.9049731, 36.8821088],
              [46.9020978, 36.8699023],
              [46.9157878, 36.8558929],
              [46.9152338, 36.8503394],
              [46.9149542, 36.8472791],
              [46.9135643, 36.8389531],
              [46.9002911, 36.8293483],
              [46.8941113, 36.815332],
              [46.8752118, 36.8008319],
              [46.8721587, 36.7930527],
              [46.8724353, 36.7911079],
              [46.8727118, 36.7904101],
              [46.8727119, 36.7900005],
              [46.8729923, 36.7894423],
              [46.8729924, 36.7891632],
              [46.8729923, 36.788884],
              [46.8732689, 36.7866601],
              [46.8735455, 36.78639],
              [46.8779925, 36.7799973],
              [46.8897421, 36.7807866],
              [46.890575, 36.7807866],
              [46.8914086, 36.7805075],
              [46.8925219, 36.7805075],
              [46.893632, 36.7802283],
              [46.8961321, 36.7802284],
              [46.8972415, 36.7799493],
              [46.903355, 36.7799493],
              [46.9147451, 36.7771763],
              [46.9169646, 36.7763389],
              [46.9175217, 36.7757807],
              [46.9186318, 36.7755016],
              [46.9219647, 36.7732868],
              [46.9229951, 36.7627729],
              [46.9246615, 36.7605579],
              [46.9279952, 36.7566592],
              [46.9302147, 36.7558307],
              [46.9304953, 36.7555517],
              [46.9500729, 36.7523645],
              [46.9699856, 36.7504389],
              [46.9941076, 36.7477723],
              [46.9949413, 36.7469438],
              [46.9979975, 36.7452781],
              [47.0029977, 36.7466648],
              [47.0038305, 36.747223],
              [47.0116072, 36.7544354],
              [47.0177205, 36.7649971],
              [47.0179971, 36.7661046],
              [47.0185542, 36.7686077],
              [47.0204971, 36.7891635],
              [47.0218869, 36.7908292],
              [47.0363334, 36.8008322],
              [47.0368872, 36.8013815],
              [47.0407771, 36.8033263],
              [47.0485531, 36.8072158],
              [47.0493867, 36.8072158],
              [47.0599432, 36.8108352],
              [47.0696668, 36.815274],
              [47.0710566, 36.8163904],
              [47.0721669, 36.8166694],
              [47.0766131, 36.8194425],
              [47.0963361, 36.8311108],
              [47.0974463, 36.8313809],
              [47.0993892, 36.8313809],
              [47.1024463, 36.8324973],
              [47.1049464, 36.8324973],
              [47.1068925, 36.8319391],
              [47.111059, 36.8302735],
              [47.1182795, 36.8269424],
              [47.119946, 36.8269424],
              [47.1205022, 36.8275006],
              [47.1307821, 36.8330556],
              [47.1332822, 36.8336047],
              [47.1374486, 36.8330556],
              [47.1405026, 36.8322183],
              [47.1449488, 36.8275006],
              [47.1532819, 36.8113847],
              [47.1618923, 36.8038848],
              [47.1638392, 36.80194],
              [47.1643954, 36.8016609],
              [47.1777322, 36.7949982],
              [47.1782853, 36.7938818],
              [47.1799518, 36.791667],
              [47.1843987, 36.7919371],
              [47.1846753, 36.7922162],
              [47.1852316, 36.7922161],
              [47.1868988, 36.7924952],
              [47.1880082, 36.7924952],
              [47.1907851, 36.7955565],
              [47.1982853, 36.7994371],
              [47.2091182, 36.811943],
              [47.223285, 36.8252771],
              [47.2263413, 36.8275008],
              [47.2405079, 36.8383317],
              [47.2410643, 36.839169],
              [47.2432876, 36.8461104],
              [47.2568973, 36.8658267],
              [47.2577309, 36.8663849],
              [47.2693975, 36.8713904],
              [47.2910675, 36.8780615],
              [47.2955105, 36.883337],
              [47.2999567, 36.8947162],
              [47.3005113, 36.8952734],
              [47.3027333, 36.8972278],
              [47.3168999, 36.9044478],
              [47.3188468, 36.9055551],
              [47.3713495, 36.9366664],
              [47.3727362, 36.9372245],
              [47.3955156, 36.9466675],
              [47.4010728, 36.9474957],
              [47.4071823, 36.9494491],
              [47.4080159, 36.9494491],
              [47.4085721, 36.9497281],
              [47.4094057, 36.9497282],
              [47.4113487, 36.9505563],
              [47.4121824, 36.9505563],
              [47.4281849, 36.9573415],
              [47.4285721, 36.9575056],
              [47.4291288, 36.9577757],
              [47.4374617, 36.9630597],
              [47.4382953, 36.9633387],
              [47.4505182, 36.9769489],
              [47.4507948, 36.977228],
              [47.4585751, 36.98334],
              [47.486908, 36.9966709],
              [47.4874647, 36.9966709],
              [47.4924644, 37.0000012],
              [47.4935746, 37.0016665],
              [47.4935745, 37.0019455],
              [47.4941312, 37.0025036],
              [47.5099643, 37.0172292],
              [47.512744, 37.0213966],
              [47.515244, 37.0366708],
              [47.514964, 37.039731],
              [47.5149639, 37.0508378],
              [47.515244, 37.0555629],
              [47.5155205, 37.056949],
              [47.5174638, 37.0616742],
              [47.5241339, 37.0672274],
              [47.5294106, 37.0683344],
              [47.5369104, 37.0622322],
              [47.5371869, 37.0616742],
              [47.5388538, 37.0608372],
              [47.541357, 37.0602792],
              [47.5424672, 37.0602792],
              [47.5433004, 37.0605582],
              [47.5477436, 37.0605582],
              [47.5483001, 37.0608373],
              [47.5499669, 37.0608372],
              [47.5566335, 37.0575071],
              [47.5577433, 37.0575071],
              [47.5585769, 37.0572281],
              [47.5599668, 37.0572281],
              [47.5638567, 37.0580561],
              [47.5658001, 37.0588932],
              [47.56719, 37.0588932],
              [47.5677466, 37.0591722],
              [47.5696901, 37.0591722],
              [47.5755234, 37.0555631],
              [47.5793754, 37.0544088],
              [47.5810798, 37.053898],
              [47.5816369, 37.053619],
              [47.5821899, 37.053619],
              [47.5821899, 37.05334],
              [47.5827466, 37.05334],
              [47.5844135, 37.0527819],
              [47.5921898, 37.0477777],
              [47.5935796, 37.0452846],
              [47.5935797, 37.0447266],
              [47.5938566, 37.0444476],
              [47.5941364, 37.0430615],
              [47.5944133, 37.0419544],
              [47.5946899, 37.0402803],
              [47.5963563, 37.0375081],
              [47.59886, 37.0375081],
              [47.6090614, 37.031092],
              [47.6183279, 37.0299309],
              [47.6255512, 37.0310382],
              [47.6359776, 37.0321709],
              [47.6373675, 37.0377349],
              [47.6365342, 37.0399498],
              [47.6362577, 37.0407871],
              [47.6440371, 37.0465325],
              [47.6448708, 37.0479279],
              [47.6448708, 37.0484772],
              [47.6454274, 37.0487563],
              [47.6457039, 37.0490355],
              [47.6549822, 37.0577032],
              [47.6728854, 37.066302],
              [47.6899976, 37.076313],
              [47.6909501, 37.0769173],
              [47.6913137, 37.0771896],
              [47.6924501, 37.07914],
              [47.696642, 37.0863981],
              [47.6971951, 37.0863981],
              [47.7019187, 37.0872261],
              [47.7033085, 37.087226],
              [47.7038617, 37.0875051],
              [47.7049754, 37.0875051],
              [47.705252, 37.0877841],
              [47.7060851, 37.087784],
              [47.7177518, 37.093616],
              [47.7199749, 37.093616],
              [47.7216417, 37.0930581],
              [47.7266414, 37.087505],
              [47.7266414, 37.0869471],
              [47.729418, 37.0841751],
              [47.737755, 37.0802871],
              [47.7402547, 37.0794501],
              [47.7421981, 37.0786131],
              [47.7591445, 37.0763991],
              [47.759698, 37.0761201],
              [47.7644212, 37.0761201],
              [47.7649779, 37.0763992],
              [47.7660877, 37.0763991],
              [47.7683112, 37.0772272],
              [47.772201, 37.0802872],
              [47.7730343, 37.0813942],
              [47.7755343, 37.0908442],
              [47.7758108, 37.0919512],
              [47.7777542, 37.1100048],
              [47.7785874, 37.1197244],
              [47.7780342, 37.1236213],
              [47.7783108, 37.1305598],
              [47.7785874, 37.1316757],
              [47.7788675, 37.1322247],
              [47.7927575, 37.1436179],
              [47.7933107, 37.1438968],
              [47.7935908, 37.1444548],
              [47.805534, 37.1505653],
              [47.8072004, 37.1513932],
              [47.8424799, 37.1691754],
              [47.8433133, 37.1691754],
              [47.8433133, 37.1694543],
              [47.8441465, 37.1694544],
              [47.8460934, 37.1702822],
              [47.8472031, 37.1702822],
              [47.8474801, 37.1705612],
              [47.8477599, 37.1708402],
              [47.8508135, 37.171956],
              [47.8524798, 37.171956],
              [47.8538697, 37.172514],
              [47.8549799, 37.172514],
              [47.8569265, 37.173063],
              [47.8588698, 37.1730629],
              [47.8591464, 37.1733419],
              [47.8605367, 37.1733419],
              [47.8608132, 37.1736209],
              [47.8641496, 37.1736208],
              [47.8713697, 37.1744488],
              [47.8719263, 37.1747277],
              [47.8769264, 37.1747278],
              [47.8788695, 37.1747278],
              [47.8880396, 37.1747278],
              [47.8891493, 37.1744488],
              [47.8922061, 37.1744489],
              [47.8949827, 37.1741789],
              [47.8960929, 37.1738999],
              [47.8980394, 37.1738999],
              [47.9005394, 37.173342],
              [47.9022059, 37.1733419],
              [47.9044294, 37.1727841],
              [47.9058158, 37.1727841],
              [47.9272057, 37.1677898],
              [47.9274858, 37.1675108],
              [47.9285956, 37.1675107],
              [47.9288725, 37.1672318],
              [47.9299859, 37.1672318],
              [47.9302624, 37.1669529],
              [47.9322058, 37.1669529],
              [47.9327625, 37.1666739],
              [47.9380423, 37.1666739],
              [47.9385958, 37.1669528],
              [47.9469288, 37.165567],
              [47.9472089, 37.1652881],
              [47.9483186, 37.1652881],
              [47.9724852, 37.1552812],
              [47.9755419, 37.1533464],
              [47.9833218, 37.1477849],
              [48.0095666, 37.1400672],
              [48.0336014, 37.1452833],
              [48.0411012, 37.1494499],
              [48.044158, 37.1505658],
              [48.0449912, 37.1508448],
              [48.0472111, 37.1511147],
              [48.0494347, 37.1516727],
              [48.0508245, 37.1516728],
              [48.0519343, 37.1519518],
              [48.0530479, 37.1519518],
              [48.0536011, 37.1522307],
              [48.0555477, 37.1522307],
              [48.0561012, 37.1525096],
              [48.0644342, 37.1525097],
              [48.0811042, 37.1508449],
              [48.0824909, 37.1511148],
              [48.0836042, 37.1519518],
              [48.0894375, 37.1536166],
              [48.0899941, 37.1538956],
              [48.0933274, 37.1538956],
              [48.0941606, 37.1541746],
              [48.0947141, 37.1538957],
              [48.0955474, 37.1538956],
              [48.0955474, 37.1541746],
              [48.0966606, 37.1541746],
              [48.0997139, 37.1558395],
              [48.1055471, 37.1647305],
              [48.1058273, 37.1650095],
              [48.1094371, 37.1716777],
              [48.1163837, 37.1872366],
              [48.1169368, 37.1883434],
              [48.1313836, 37.2044509],
              [48.1319402, 37.2055667],
              [48.1402731, 37.2133413],
              [48.1502733, 37.2211248],
              [48.1594395, 37.2236174],
              [48.1602731, 37.2238963],
              [48.1613829, 37.2238963],
              [48.1644396, 37.2247332],
              [48.1658295, 37.2250121],
              [48.1730532, 37.2261188],
              [48.1736062, 37.2263978],
              [48.1763864, 37.2263979],
              [48.1774961, 37.2266768],
              [48.1849959, 37.2266768],
              [48.1858295, 37.2269558],
              [48.1863862, 37.2266768],
              [48.1872194, 37.2269557],
              [48.1913859, 37.2269557],
              [48.2013857, 37.2286205],
              [48.202776, 37.2286204],
              [48.2044424, 37.2291784],
              [48.2055526, 37.2291783],
              [48.2063858, 37.2294573],
              [48.2074991, 37.2294572],
              [48.2130524, 37.2311219],
              [48.219719, 37.2327866],
              [48.2252757, 37.2350091],
              [48.2336087, 37.2372316],
              [48.234999, 37.2372316],
              [48.2358322, 37.2375106],
              [48.236942, 37.2375106],
              [48.2377756, 37.2377896],
              [48.2399987, 37.2377895],
              [48.2405553, 37.2380685],
              [48.2416655, 37.2380684],
              [48.2463887, 37.2380685],
              [48.2472219, 37.2377896],
              [48.2488887, 37.2377895],
              [48.249722, 37.2375106],
              [48.2561119, 37.2375107],
              [48.2569451, 37.2377896],
              [48.2574987, 37.2375106],
              [48.2580553, 37.2377896],
              [48.2597217, 37.2377895],
              [48.2605554, 37.2380685],
              [48.260835, 37.2377896],
              [48.2616687, 37.2380685],
              [48.2644453, 37.2380685],
              [48.265002, 37.2377896],
              [48.2672219, 37.2377896],
              [48.2680552, 37.2375107],
              [48.2700017, 37.2375107],
              [48.2708353, 37.2372318],
              [48.2730548, 37.2372317],
              [48.273335, 37.2375107],
              [48.275835, 37.2375107],
              [48.2947248, 37.2452939],
              [48.3137847, 37.2454136],
              [48.3172246, 37.2455298],
              [48.3226926, 37.2445594],
              [48.3314906, 37.2427598],
              [48.332526, 37.2424966],
              [48.3346724, 37.2402028],
              [48.3365285, 37.2397458],
              [48.3370757, 37.2406469],
              [48.3382559, 37.2422868],
              [48.3401334, 37.2450541],
              [48.3420753, 37.2479664],
              [48.3415389, 37.2486582],
              [48.3407771, 37.2497769],
              [48.3409488, 37.2511007],
              [48.3416891, 37.2515618],
              [48.3438241, 37.2529624],
              [48.3458197, 37.2550119],
              [48.3439314, 37.2575908],
              [48.3402192, 37.2571724],
              [48.3387172, 37.2586241],
              [48.3379447, 37.2600928],
              [48.3366465, 37.2627313],
              [48.3354878, 37.2637816],
              [48.3332562, 37.2659674],
              [48.3287823, 37.2701511],
              [48.3219159, 37.2664114],
              [48.3201349, 37.2684435],
              [48.3206284, 37.2690241],
              [48.3215403, 37.270578],
              [48.3232677, 37.2724648],
              [48.3231068, 37.2749151],
              [48.3200812, 37.276392],
              [48.3169806, 37.2757859],
              [48.3150494, 37.2753078],
              [48.309803, 37.2726954],
              [48.306123, 37.2737967],
              [48.3047712, 37.2750432],
              [48.3034193, 37.2766225],
              [48.2986343, 37.2776726],
              [48.2977545, 37.278919],
              [48.2956087, 37.2822056],
              [48.2922828, 37.2831276],
              [48.2924437, 37.2840666],
              [48.2928514, 37.2855177],
              [48.2958555, 37.2870798],
              [48.2975936, 37.2908953],
              [48.2969123, 37.2926515],
              [48.2963383, 37.2938678],
              [48.2958046, 37.2946871],
              [48.2953834, 37.2951971],
              [48.291564, 37.2965798],
              [48.2906949, 37.2964005],
              [48.287015, 37.2957007],
              [48.2844829, 37.2965542],
              [48.2832169, 37.2983038],
              [48.2821441, 37.2999254],
              [48.2821655, 37.3016493],
              [48.2818544, 37.3030063],
              [48.2813394, 37.3047899],
              [48.2804811, 37.3055323],
              [48.2778525, 37.3056518],
              [48.276608, 37.3055323],
              [48.272177, 37.3049094],
              [48.2700205, 37.3061212],
              [48.269881, 37.3063772],
              [48.2705998, 37.307589],
              [48.2743657, 37.3076487],
              [48.2763076, 37.3087922],
              [48.276093, 37.3108658],
              [48.2745695, 37.3110365],
              [48.2725739, 37.3113096],
              [48.2720053, 37.3122567],
              [48.2716942, 37.3133234],
              [48.2708573, 37.3160197],
              [48.2691193, 37.3152603],
              [48.267113, 37.3125981],
              [48.2656538, 37.312709],
              [48.2638299, 37.3129479],
              [48.2610834, 37.313878],
              [48.257736, 37.315047],
              [48.2591092, 37.3170095],
              [48.2624352, 37.3174447],
              [48.2642376, 37.3201068],
              [48.2636154, 37.3226238],
              [48.2625747, 37.3234599],
              [48.2604825, 37.3247994],
              [48.2601821, 37.3262497],
              [48.2596242, 37.3281011],
              [48.258487, 37.3279816],
              [48.2572853, 37.3278707],
              [48.2570708, 37.3247908],
              [48.2568455, 37.3231271],
              [48.2542169, 37.3222483],
              [48.252908, 37.3220862],
              [48.250097, 37.3216255],
              [48.2476723, 37.322692],
              [48.2460415, 37.3251748],
              [48.2462668, 37.3264972],
              [48.2466745, 37.3296026],
              [48.2471681, 37.3331429],
              [48.2469749, 37.3345931],
              [48.246578, 37.3377238],
              [48.2453334, 37.3384318],
              [48.243649, 37.339481],
              [48.2394218, 37.3423299],
              [48.2379091, 37.343345],
              [48.2371044, 37.3442662],
              [48.2337785, 37.3483431],
              [48.23174, 37.3541597],
              [48.2319545, 37.3580486],
              [48.2322676, 37.3607572],
              [48.2329227, 37.3638817],
              [48.2334921, 37.3665035],
              [48.2341529, 37.3686204],
              [48.2349626, 37.3715036],
              [48.229624, 37.3719288],
              [48.2250863, 37.3722288],
              [48.2182313, 37.3728496],
              [48.2119686, 37.3738864],
              [48.204198, 37.3759872],
              [48.1982391, 37.3776978],
              [48.1904898, 37.3922298],
              [48.1818044, 37.4042401],
              [48.1770229, 37.4087643],
              [48.1720984, 37.4126472],
              [48.1672392, 37.4186839],
              [48.164432, 37.4252284],
              [48.1631669, 37.4313737],
              [48.1629861, 37.4409848],
              [48.1636039, 37.4479169],
              [48.1655468, 37.4521246],
              [48.1658649, 37.4561236],
              [48.1663799, 37.4614379],
              [48.1656074, 37.4652871],
              [48.1638694, 37.4695448],
              [48.160758, 37.4734957],
              [48.1558442, 37.477123],
              [48.1499004, 37.4791493],
              [48.1432056, 37.4804946],
              [48.1340217, 37.4812779],
              [48.1293225, 37.4840533],
              [48.1244302, 37.4884462],
              [48.1221556, 37.4883611],
              [48.1176495, 37.4867776],
              [48.1153106, 37.4862839],
              [48.1120276, 37.4874757],
              [48.1060409, 37.4963119],
              [48.1031871, 37.4980824],
              [48.1029081, 37.5031128],
              [48.1015456, 37.5037001],
              [48.0960846, 37.5031383],
              [48.093574, 37.5042618],
              [48.0917501, 37.5063385],
              [48.0900979, 37.5073258],
              [48.0882311, 37.5069513],
              [48.0855274, 37.5053427],
              [48.084079, 37.5058023],
              [48.0832636, 37.5080067],
              [48.0842507, 37.5097259],
              [48.0836069, 37.5107216],
              [48.0816114, 37.5111641],
              [48.078146, 37.5133683],
              [48.0773305, 37.5196657],
              [48.0782717, 37.527789],
              [48.0795458, 37.5361742],
              [48.0793109, 37.5474403],
              [48.0811348, 37.557525],
              [48.0811175, 37.5711937],
              [48.0785807, 37.5830407],
              [48.0747125, 37.5902995],
              [48.0716558, 37.5930784],
              [48.0677658, 37.5950208],
              [48.0669327, 37.5952996],
              [48.0580384, 37.598574],
              [48.0563797, 37.5991846],
              [48.055266, 37.5991847],
              [48.0494331, 37.6008483],
              [48.0491561, 37.6011271],
              [48.0480428, 37.601127],
              [48.0435997, 37.602521],
              [48.0427665, 37.6025209],
              [48.0241532, 37.6108573],
              [48.0236001, 37.6111361],
              [48.0227664, 37.6119634],
              [48.0216532, 37.6122422],
              [48.0191531, 37.6166847],
              [48.0188765, 37.6180785],
              [48.0199866, 37.6258572],
              [48.0224862, 37.6414052],
              [48.0255429, 37.654462],
              [48.0277664, 37.6611342],
              [48.028043, 37.661413],
              [48.0288761, 37.6630765],
              [48.0308195, 37.6658551],
              [48.031067, 37.6662269],
              [48.0538794, 37.6925249],
              [48.0630459, 37.7064078],
              [48.0638791, 37.7105799],
              [48.0633224, 37.7147428],
              [48.0633224, 37.719751],
              [48.063599, 37.7205781],
              [48.063599, 37.722799],
              [48.0641556, 37.7247411],
              [48.0644322, 37.7250198],
              [48.0652658, 37.7266921],
              [48.0666557, 37.7294704],
              [48.0708221, 37.7322487],
              [48.0752687, 37.733912],
              [48.0874886, 37.7358541],
              [48.0880452, 37.7361328],
              [48.0902687, 37.7361329],
              [48.0913788, 37.7364116],
              [48.0952688, 37.7364115],
              [48.0963785, 37.7366903],
              [48.0983255, 37.7366903],
              [48.0988786, 37.736969],
              [48.100545, 37.736969],
              [48.1016588, 37.7372477],
              [48.1030451, 37.7372477],
              [48.1036018, 37.7375264],
              [48.1052686, 37.7375265],
              [48.1077687, 37.7380839],
              [48.1091586, 37.7380839],
              [48.1144352, 37.7391898],
              [48.1152684, 37.7391898],
              [48.1183252, 37.7405834],
              [48.1191584, 37.7405835],
              [48.1258249, 37.7441888],
              [48.1266582, 37.7447462],
              [48.1352716, 37.7522446],
              [48.1474947, 37.7805828],
              [48.148328, 37.7844667],
              [48.1494377, 37.7961359],
              [48.1491611, 37.7964146],
              [48.1480479, 37.8011343],
              [48.1477713, 37.8025278],
              [48.148881, 37.8053057],
              [48.1494377, 37.805863],
              [48.1502714, 37.8064205],
              [48.1511045, 37.8094681],
              [48.1511045, 37.8097468],
              [48.1511045, 37.8103041],
              [48.146938, 37.8169656],
              [48.1463809, 37.8172443],
              [48.1461044, 37.8178016],
              [48.1391577, 37.8211368],
              [48.1386046, 37.8216942],
              [48.119158, 37.8289128],
              [48.1180482, 37.8291915],
              [48.114715, 37.8303062],
              [48.1088816, 37.8361404],
              [48.1086016, 37.8364101],
              [48.1083249, 37.8375248],
              [48.108048, 37.8389181],
              [48.1047115, 37.849193],
              [48.0991583, 37.852528],
              [48.0985513, 37.8527311],
              [48.0963782, 37.8536426],
              [48.0886018, 37.8536427],
              [48.0827685, 37.850029],
              [48.0761019, 37.8478085],
              [48.0755453, 37.8478086],
              [48.0738785, 37.84753],
              [48.0699886, 37.8475299],
              [48.0691553, 37.8478086],
              [48.0660985, 37.8478086],
              [48.0655451, 37.8480872],
              [48.0638786, 37.8480872],
              [48.0627653, 37.8483569],
              [48.0624887, 37.8486355],
              [48.0616552, 37.8486355],
              [48.0608219, 37.8491928],
              [48.0602653, 37.8491929],
              [48.0599887, 37.8494715],
              [48.059432, 37.8494716],
              [48.0591554, 37.8497502],
              [48.0585983, 37.8497502],
              [48.0583219, 37.8500289],
              [48.0572121, 37.8500289],
              [48.0527655, 37.8525279],
              [48.0497088, 37.8583619],
              [48.0502653, 37.8653015],
              [48.0466555, 37.8711354],
              [48.0402656, 37.8753063],
              [48.0399889, 37.8755849],
              [48.0377654, 37.8769692],
              [48.027209, 37.8800253],
              [48.0260988, 37.8800253],
              [48.0255422, 37.8803039],
              [48.0249855, 37.880304],
              [48.0249854, 37.8805826],
              [48.0244324, 37.8805826],
              [48.0241522, 37.8808613],
              [48.0235991, 37.8808612],
              [48.0202654, 37.8841961],
              [48.0124855, 37.8886365],
              [47.999403, 37.8949567],
              [47.9933191, 37.8903084],
              [47.9866526, 37.8833601],
              [47.9860959, 37.8828028],
              [47.9780394, 37.876142],
              [47.9774859, 37.876142],
              [47.977486, 37.8758633],
              [47.9766527, 37.8758634],
              [47.9760961, 37.8755847],
              [47.9752629, 37.8755847],
              [47.9749828, 37.875306],
              [47.9738726, 37.8753061],
              [47.9733159, 37.8750274],
              [47.971373, 37.8750274],
              [47.971096, 37.8747487],
              [47.9574828, 37.8747487],
              [47.9572062, 37.8750274],
              [47.9541495, 37.8750274],
              [47.9535929, 37.8753061],
              [47.9499831, 37.875306],
              [47.9491498, 37.8750273],
              [47.9480395, 37.8750273],
              [47.9472064, 37.8747487],
              [47.9444262, 37.8747487],
              [47.9438731, 37.87447],
              [47.9427598, 37.87447],
              [47.9419266, 37.8741913],
              [47.9413731, 37.8741913],
              [47.9313697, 37.8719711],
              [47.9305365, 37.8719711],
              [47.9299833, 37.8716924],
              [47.9291497, 37.8716924],
              [47.9285931, 37.8714137],
              [47.9277599, 37.8714137],
              [47.9272032, 37.8711351],
              [47.92637, 37.8711351],
              [47.9116466, 37.8644742],
              [47.9052601, 37.8628022],
              [47.9044269, 37.8628022],
              [47.9038703, 37.8625235],
              [47.9002604, 37.8625235],
              [47.8983136, 37.8633595],
              [47.898037, 37.8636381],
              [47.8963702, 37.8650315],
              [47.8955368, 37.8658585],
              [47.8930368, 37.8683574],
              [47.8908137, 37.8722497],
              [47.8908137, 37.8764205],
              [47.8916469, 37.881697],
              [47.8919235, 37.882524],
              [47.8916469, 37.8828026],
              [47.8899805, 37.8855801],
              [47.8894234, 37.8858588],
              [47.8894234, 37.8861374],
              [47.8888703, 37.8861374],
              [47.885537, 37.8897508],
              [47.8847038, 37.8919711],
              [47.8874804, 37.8972474],
              [47.887757, 37.8978047],
              [47.8899804, 37.8983619],
              [47.9010935, 37.9064157],
              [47.9013701, 37.9069729],
              [47.9055366, 37.9180826],
              [47.9119266, 37.928365],
              [47.9213697, 37.9339197],
              [47.9219263, 37.9339197],
              [47.922483, 37.9341984],
              [47.9230365, 37.934477],
              [47.9238697, 37.934477],
              [47.924983, 37.9350342],
              [47.9258163, 37.9350342],
              [47.9352593, 37.9403102],
              [47.9358165, 37.9405798],
              [47.936093, 37.941137],
              [47.9366497, 37.9414157],
              [47.9372064, 37.9428088],
              [47.9377595, 37.9466916],
              [47.9369262, 37.9486419],
              [47.9366497, 37.950026],
              [47.9297029, 37.9622492],
              [47.9294264, 37.9625278],
              [47.9183163, 37.9753079],
              [47.914703, 37.983091],
              [47.9097032, 37.9908649],
              [47.9060929, 37.9925275],
              [47.9052597, 37.9925275],
              [47.9047031, 37.9928062],
              [47.9041465, 37.9928061],
              [47.9035933, 37.9930847],
              [47.9027596, 37.9930847],
              [47.9024796, 37.9933633],
              [47.9010932, 37.9933633],
              [47.9008131, 37.9936419],
              [47.8969232, 37.9936419],
              [47.8960899, 37.9933633],
              [47.8927563, 37.9933633],
              [47.8922032, 37.9930847],
              [47.8908132, 37.9930847],
              [47.8905367, 37.9933633],
              [47.8852566, 37.9933633],
              [47.8847034, 37.9936419],
              [47.8833132, 37.9936419],
              [47.8827564, 37.9939205],
              [47.88109, 37.9939205],
              [47.8805365, 37.9941991],
              [47.87859, 37.994199],
              [47.8783134, 37.9944777],
              [47.8766465, 37.9944777],
              [47.8763665, 37.9947563],
              [47.8752567, 37.9947563],
              [47.8691468, 37.9978119],
              [47.8685901, 37.9986387],
              [47.8624801, 38.0064214],
              [47.8622001, 38.0066999],
              [47.8619235, 38.0089196],
              [47.8585902, 38.0311437],
              [47.8583101, 38.0325277],
              [47.8580335, 38.0344777],
              [47.8578491, 38.0358617],
              [47.8538666, 38.051417],
              [47.8535899, 38.0522526],
              [47.8533099, 38.053924],
              [47.8530333, 38.0561436],
              [47.8527568, 38.0578061],
              [47.8524766, 38.0594774],
              [47.8522, 38.0605917],
              [47.8519235, 38.0639166],
              [47.8519235, 38.0667022],
              [47.8516434, 38.0669718],
              [47.8463667, 38.0917006],
              [47.8477564, 38.1164192],
              [47.850533, 38.1289265],
              [47.8513666, 38.133365],
              [47.8519232, 38.1419814],
              [47.8521998, 38.1436437],
              [47.8519232, 38.1439222],
              [47.8521997, 38.1466985],
              [47.8519232, 38.1469769],
              [47.8449765, 38.1664284],
              [47.8355332, 38.1797611],
              [47.834143, 38.1814231],
              [47.8269198, 38.1889248],
              [47.8266431, 38.1892033],
              [47.8146964, 38.1969833],
              [47.80942, 38.2011429],
              [47.8088634, 38.2022568],
              [47.8083099, 38.2025353],
              [47.8041398, 38.2105937],
              [47.8033066, 38.2116987],
              [47.7999733, 38.2200354],
              [47.7991401, 38.2233683],
              [47.79914, 38.2239252],
              [47.7988635, 38.2247607],
              [47.7985865, 38.2264226],
              [47.7974732, 38.2319834],
              [47.7874733, 38.2514228],
              [47.7858068, 38.2525367],
              [47.7852498, 38.2525367],
              [47.7846967, 38.2525367],
              [47.7844165, 38.2528152],
              [47.7835834, 38.2528152],
              [47.7805302, 38.2505963],
              [47.7785833, 38.2461497],
              [47.7777501, 38.2436525],
              [47.773307, 38.236421],
              [47.773307, 38.235873],
              [47.7719167, 38.2347591],
              [47.7710835, 38.2347591],
              [47.770807, 38.2344806],
              [47.7699738, 38.2344806],
              [47.7692257, 38.2342306],
              [47.7649737, 38.2330882],
              [47.7646935, 38.2328097],
              [47.7633068, 38.2328097],
              [47.7627502, 38.2325312],
              [47.7596938, 38.2325313],
              [47.7577504, 38.2322617],
              [47.7574739, 38.2325312],
              [47.7563606, 38.2322617],
              [47.7541406, 38.2325312],
              [47.7535839, 38.2328096],
              [47.7510839, 38.2328097],
              [47.7505272, 38.2330882],
              [47.749417, 38.2330882],
              [47.7488604, 38.2333667],
              [47.7485839, 38.2330881],
              [47.7483073, 38.2333667],
              [47.7466372, 38.2328096],
              [47.740804, 38.2289288],
              [47.738584, 38.2264225],
              [47.7383039, 38.2258745],
              [47.736084, 38.2233682],
              [47.7246942, 38.2122555],
              [47.7177476, 38.211429],
              [47.7166375, 38.2116985],
              [47.7141374, 38.2130909],
              [47.7044141, 38.2161453],
              [47.7033043, 38.2161453],
              [47.7013577, 38.2167023],
              [47.6994144, 38.2167023],
              [47.6985812, 38.2169808],
              [47.6980245, 38.2169807],
              [47.685966, 38.2155306],
              [47.6780245, 38.2139263],
              [47.6755248, 38.2139263],
              [47.6749678, 38.2136478],
              [47.6674681, 38.2136478],
              [47.6663582, 38.2133693],
              [47.6588581, 38.2133693],
              [47.6577448, 38.2130909],
              [47.6558014, 38.2130908],
              [47.6546916, 38.2133693],
              [47.6513548, 38.2133693],
              [47.6502449, 38.2136478],
              [47.6483016, 38.2136477],
              [47.6471882, 38.2139263],
              [47.6455214, 38.2139263],
              [47.6399682, 38.2150312],
              [47.6380216, 38.2150312],
              [47.6349649, 38.2155882],
              [47.6338552, 38.2155882],
              [47.6332984, 38.2158666],
              [47.6319117, 38.2158666],
              [47.6232986, 38.2180946],
              [47.6171887, 38.2183641],
              [47.6146887, 38.2178161],
              [47.6132984, 38.2178161],
              [47.6130218, 38.2175375],
              [47.6119085, 38.2175376],
              [47.611632, 38.2172591],
              [47.6107988, 38.217259],
              [47.6060752, 38.2150311],
              [47.6055221, 38.2147617],
              [47.5985754, 38.2133692],
              [47.5977422, 38.2133691],
              [47.5971856, 38.2130906],
              [47.5960753, 38.2130907],
              [47.5952422, 38.2128122],
              [47.5927421, 38.2128122],
              [47.5849658, 38.2114287],
              [47.5838521, 38.2108716],
              [47.5830188, 38.2108717],
              [47.581909, 38.2103147],
              [47.5810754, 38.2103146],
              [47.5807989, 38.2100362],
              [47.5796856, 38.2100362],
              [47.5757956, 38.2089222],
              [47.5746858, 38.2089222],
              [47.5738523, 38.2086437],
              [47.573019, 38.2086436],
              [47.5724624, 38.2083652],
              [47.5713525, 38.2083652],
              [47.5585726, 38.2030917],
              [47.5416293, 38.1925356],
              [47.5396828, 38.1917001],
              [47.5394063, 38.1914216],
              [47.5363495, 38.1914216],
              [47.5360729, 38.1911431],
              [47.5346827, 38.1914216],
              [47.5330162, 38.1914216],
              [47.531906, 38.1917001],
              [47.529963, 38.1917001],
              [47.5277395, 38.1922571],
              [47.527463, 38.1925356],
              [47.5266297, 38.1925356],
              [47.5213496, 38.1958686],
              [47.5207929, 38.1964257],
              [47.5191264, 38.1969826],
              [47.517183, 38.1972611],
              [47.5155161, 38.1972611],
              [47.5102399, 38.1961471],
              [47.5085731, 38.1958687],
              [47.5066265, 38.1950331],
              [47.5060731, 38.1944761],
              [47.5046832, 38.1939191],
              [47.4930165, 38.1850339],
              [47.48885, 38.1825364],
              [47.4880168, 38.1825363],
              [47.4869035, 38.1819793],
              [47.4827366, 38.1819793],
              [47.4763467, 38.1839198],
              [47.4760701, 38.1841984],
              [47.4752369, 38.1841984],
              [47.4744036, 38.1861479],
              [47.4741267, 38.1875314],
              [47.4741266, 38.1925355],
              [47.4744036, 38.1936495],
              [47.4746801, 38.1947546],
              [47.4780134, 38.2058675],
              [47.4807934, 38.2300332],
              [47.4805132, 38.2303117],
              [47.4802367, 38.2322611],
              [47.4799597, 38.2336445],
              [47.4799598, 38.2342655],
              [47.4796796, 38.2353153],
              [47.4794031, 38.2378128],
              [47.4791266, 38.239762],
              [47.4788465, 38.2405885],
              [47.4777366, 38.2425378],
              [47.4688466, 38.2494817],
              [47.4680134, 38.2494817],
              [47.4674598, 38.2497602],
              [47.4663465, 38.2497602],
              [47.4655133, 38.2494817],
              [47.4635698, 38.2494817],
              [47.4624566, 38.2492033],
              [47.4613468, 38.2492032],
              [47.4607902, 38.2489248],
              [47.4580136, 38.2489248],
              [47.4569034, 38.2486463],
              [47.4549568, 38.2486463],
              [47.4507899, 38.2478109],
              [47.4496802, 38.2478108],
              [47.4302336, 38.2411454],
              [47.4130102, 38.2372556],
              [47.4116242, 38.2372555],
              [47.4107906, 38.2369771],
              [47.4071772, 38.2369771],
              [47.4060671, 38.2372556],
              [47.4027341, 38.2372556],
              [47.3985677, 38.2378125],
              [47.3857877, 38.2439211],
              [47.379954, 38.2486461],
              [47.3791211, 38.2489245],
              [47.3777313, 38.2503169],
              [47.3757875, 38.2514219],
              [47.3749455, 38.2519849],
              [47.3605073, 38.2630906],
              [47.3577307, 38.2661447],
              [47.3580073, 38.2691989],
              [47.3577307, 38.2694773],
              [47.3538408, 38.2739237],
              [47.3532877, 38.2742021],
              [47.3532877, 38.2744806],
              [47.3510642, 38.2755944],
              [47.3249509, 38.2903167],
              [47.3235611, 38.2905951],
              [47.3218946, 38.2914304],
              [47.3046716, 38.2964246],
              [47.3035614, 38.2964245],
              [47.3021716, 38.296703],
              [47.2910619, 38.3003138],
              [47.2871719, 38.302263],
              [47.2871719, 38.3044815],
              [47.2871719, 38.3053169],
              [47.287172, 38.3061522],
              [47.2874485, 38.3069785],
              [47.2888384, 38.3142001],
              [47.2888383, 38.3155923],
              [47.2893945, 38.3167061],
              [47.2907813, 38.3319841],
              [47.2952282, 38.3358732],
              [47.2974517, 38.3366995],
              [47.3191178, 38.3433728],
              [47.3316173, 38.3492018],
              [47.334951, 38.3505939],
              [47.3402307, 38.3533691],
              [47.345784, 38.3569797],
              [47.38023, 38.3961456],
              [47.384677, 38.3992079],
              [47.3988435, 38.4053147],
              [47.4113431, 38.412544],
              [47.415233, 38.4155972],
              [47.4410663, 38.4500356],
              [47.4598739, 38.473628],
              [47.4684962, 38.4805015],
              [47.4717767, 38.4840104],
              [47.4737748, 38.4860692],
              [47.476693, 38.4891845],
              [47.4810218, 38.4942088],
              [47.4830389, 38.4983401],
              [47.4864292, 38.502236],
              [47.4972438, 38.511337],
              [47.5004194, 38.5171463],
              [47.502737, 38.5271517],
              [47.506652, 38.5353744],
              [47.5139808, 38.5422581],
              [47.5220489, 38.546353],
              [47.5361251, 38.5480312],
              [47.5456134, 38.5507],
              [47.5551435, 38.5581357],
              [47.5585343, 38.5675032],
              [47.5595749, 38.5738529],
              [47.5688509, 38.6117084],
              [47.5699607, 38.6161609],
              [47.567184, 38.6286565],
              [47.5671841, 38.6347696],
              [47.5666274, 38.637274],
              [47.565241, 38.6406042],
              [47.566456, 38.6442899],
              [47.5257943, 38.6697677],
              [47.5127377, 38.6764368],
              [47.5107912, 38.6769933],
              [47.5007913, 38.682271],
              [47.4991245, 38.6825492],
              [47.4969014, 38.683384],
              [47.4880148, 38.6858792],
              [47.4796779, 38.6886616],
              [47.4757915, 38.6894963],
              [47.4724582, 38.6894963],
              [47.4674581, 38.6875486],
              [47.4630115, 38.6875486],
              [47.4619018, 38.6878269],
              [47.4607885, 38.6878269],
              [47.4594017, 38.6883833],
              [47.4582883, 38.6883833],
              [47.4577348, 38.6886615],
              [47.4560685, 38.6886615],
              [47.4513452, 38.6922697],
              [47.4491218, 38.6958779],
              [47.4485686, 38.6964343],
              [47.4457884, 38.6972691],
              [47.4446782, 38.6972691],
              [47.4441215, 38.6975473],
              [47.4430118, 38.6975473],
              [47.4424552, 38.6978255],
              [47.4416219, 38.6978256],
              [47.4405117, 38.698382],
              [47.4396785, 38.6983819],
              [47.4366218, 38.7000514],
              [47.4360651, 38.7000515],
              [47.4357886, 38.7003296],
              [47.4357886, 38.7008771],
              [47.4343983, 38.7033812],
              [47.4330119, 38.7069893],
              [47.4327318, 38.7083805],
              [47.4332884, 38.7181006],
              [47.4330119, 38.7192135],
              [47.4545916, 38.7652107],
              [47.4559688, 38.7672688],
              [47.4590396, 38.7710689],
              [47.4661908, 38.7750252],
              [47.4723434, 38.7782065],
              [47.4831581, 38.7807034],
              [47.4894531, 38.7822578],
              [47.4941952, 38.7834922],
              [47.4972102, 38.7847951],
              [47.5011062, 38.7876095],
              [47.5075289, 38.7935134],
              [47.5150966, 38.8011895],
              [47.5283348, 38.8097792],
              [47.5374511, 38.8134761],
              [47.5427702, 38.817288],
              [47.5469096, 38.8213111],
              [47.5528556, 38.8255908],
              [47.5531411, 38.8270544],
              [47.5580978, 38.8356963],
              [47.5630331, 38.8537456],
              [47.5680466, 38.8600485],
              [47.5696563, 38.8615431],
              [47.5699395, 38.8636577],
              [47.5707949, 38.86585],
              [47.5704073, 38.8702163],
              [47.5657535, 38.876982],
              [47.5615724, 38.8803171],
              [47.5543351, 38.8839918],
              [47.533675, 38.8915521],
              [47.5285368, 38.8958943],
              [47.5223523, 38.9036012],
              [47.517929, 38.9108046],
              [47.516384, 38.9158134],
              [47.518444, 38.9188854],
              [47.5223922, 38.9223578],
              [47.5232505, 38.9257633],
              [47.5209331, 38.9274326],
              [47.5248718, 38.9297448],
              [47.5216233, 38.9328372],
              [47.5229238, 38.948038],
              [47.524027, 38.948085],
              [47.5240261, 38.9502513],
              [47.5240299, 38.9511984],
              [47.5246618, 38.9537033],
              [47.5243994, 38.9558894],
              [47.5267154, 38.9579114],
              [47.5304352, 38.9604058],
              [47.5316727, 38.9601847],
              [47.5339579, 38.9607603],
              [47.5380671, 38.9613359],
              [47.5413823, 38.9624038],
              [47.5469827, 38.9633464],
              [47.5510168, 38.9645811],
              [47.5559949, 38.9652818],
              [47.559514, 38.9664163],
              [47.5673935, 38.9683035],
              [47.5682947, 38.9721852],
              [47.5667554, 38.9764004],
              [47.5624417, 38.978736],
              [47.5581264, 38.9796851],
              [47.5500805, 38.9814536],
              [47.5377553, 38.9858795],
              [47.5332931, 38.9875584],
              [47.5271156, 38.9902972],
              [47.5073959, 38.9943342],
              [47.5038707, 38.9965036],
              [47.5019641, 38.9975383],
              [47.5005063, 38.9987196],
              [47.5038897, 38.9998991],
              [47.5258953, 39.0079994],
              [47.5261516, 39.0092667],
              [47.525159, 39.0122755],
              [47.5270719, 39.0167763],
              [47.528011, 39.0196802],
              [47.5275593, 39.021692],
              [47.5268274, 39.0227733],
              [47.5250583, 39.0229816],
              [47.520724, 39.0236932],
              [47.5169102, 39.0245934],
              [47.5137128, 39.0255168],
              [47.5087797, 39.0268974],
              [47.5061237, 39.0288643],
              [47.505214, 39.0320349],
              [47.5063953, 39.0352981],
              [47.509048, 39.0379005],
              [47.512285, 39.0390813],
              [47.5170628, 39.0395188],
              [47.5244406, 39.0380581],
              [47.5256219, 39.0392197],
              [47.5245275, 39.0411904],
              [47.5194913, 39.043055],
              [47.5181655, 39.0450922],
              [47.5190276, 39.0467087],
              [47.5222771, 39.0473867],
              [47.5236151, 39.0476459],
              [47.5254791, 39.0481725],
              [47.5263256, 39.0515615],
              [47.5239449, 39.0586929],
              [47.5241562, 39.0626094],
              [47.528658, 39.0733013],
              [47.5308433, 39.0795299],
              [47.5299684, 39.0833072],
              [47.530514, 39.0896069],
              [47.5355971, 39.1074665],
              [47.5364748, 39.1188199],
              [47.5310675, 39.1309525],
              [47.524293, 39.1408742],
              [47.5247105, 39.1453012],
              [47.5286531, 39.1519576],
              [47.532022, 39.1656202],
              [47.5301311, 39.1780475],
              [47.5281412, 39.1899164],
              [47.5258149, 39.2052431],
              [47.5218496, 39.2126346],
              [47.5188467, 39.218199],
              [47.517924, 39.2199805],
              [47.5172189, 39.2213192],
              [47.5144958, 39.2258705],
              [47.5116521, 39.2309754],
              [47.5099533, 39.2343706],
              [47.5091403, 39.2369903],
              [47.5088455, 39.2389542],
              [47.5084416, 39.2403773],
              [47.5077548, 39.2431443],
              [47.4907892, 39.2600584],
              [47.4905127, 39.2608924],
              [47.4905127, 39.2611701],
              [47.4893989, 39.2636714],
              [47.4888459, 39.2639495],
              [47.4882891, 39.2650608],
              [47.4868992, 39.2664505],
              [47.4866223, 39.2672842],
              [47.4852324, 39.2686738],
              [47.4821758, 39.2706193],
              [47.4810658, 39.2725645],
              [47.4813421, 39.2753399],
              [47.4813424, 39.2753436],
              [47.4813425, 39.2753436],
              [47.4813425, 39.2753437],
              [47.4813429, 39.2753441],
              [47.4817765, 39.2758608],
              [47.4817778, 39.2758623],
              [47.4886135, 39.283952],
              [47.4913457, 39.286173],
              [47.4920538, 39.2866052],
              [47.5018987, 39.2928425],
              [47.5024554, 39.2931205],
              [47.5049349, 39.2954356],
              [47.5049348, 39.2954356],
              [47.4999372, 39.2976911],
              [47.4953635, 39.3000278],
              [47.4906687, 39.300441],
              [47.4867257, 39.3017425],
              [47.4840637, 39.3041709],
              [47.4791124, 39.3043582],
              [47.4756474, 39.3065347],
              [47.4700137, 39.3083933],
              [47.4635941, 39.3097876],
              [47.463594, 39.3097876],
              [47.4591378, 39.3106373],
              [47.454152, 39.3112482],
              [47.4508565, 39.3113016],
              [47.4469293, 39.3123897],
              [47.4412604, 39.3146716],
              [47.4342933, 39.3160379],
              [47.4307925, 39.3186376],
              [47.4300068, 39.3215822],
              [47.4300068, 39.3215823],
              [47.430553, 39.3250177],
              [47.4338318, 39.3285858],
              [47.4338319, 39.3285859],
              [47.4374014, 39.331955],
              [47.4387849, 39.335218],
              [47.439111, 39.3372671],
              [47.4293961, 39.3431212],
              [47.4049493, 39.3683973],
              [47.4041164, 39.3695088],
              [47.4032828, 39.3703423],
              [47.4005061, 39.3733987],
              [47.3796727, 39.4058968],
              [47.3663364, 39.419788],
              [47.363399, 39.4217256],
              [47.3608277, 39.4200102],
              [47.3595582, 39.4182437],
              [47.3555378, 39.4185647],
              [47.3537642, 39.4180874],
              [47.3499931, 39.4126685],
              [47.3468753, 39.4125839],
              [47.3451308, 39.4141522],
              [47.3433619, 39.4142756],
              [47.3415951, 39.4134759],
              [47.3398535, 39.4113563],
              [47.3412014, 39.4061242],
              [47.3370202, 39.4047769],
              [47.335519, 39.4035682],
              [47.3346844, 39.3970296],
              [47.3301002, 39.3909623],
              [47.3257055, 39.3838955],
              [47.3220476, 39.3825008],
              [47.3206243, 39.3814892],
              [47.3188852, 39.3784046],
              [47.3181412, 39.3742176],
              [47.3156299, 39.3696027],
              [47.3152019, 39.3691175],
              [47.314477, 39.3688494],
              [47.313612, 39.3687565],
              [47.3109828, 39.3685104],
              [47.3068533, 39.3689826],
              [47.3052471, 39.3686982],
              [47.3043519, 39.3686449],
              [47.3026262, 39.3687987],
              [47.3007045, 39.3687456],
              [47.298964, 39.3683588],
              [47.2971423, 39.3677183],
              [47.2960443, 39.3670896],
              [47.2897202, 39.3633319],
              [47.2795265, 39.3611279],
              [47.2754146, 39.358916],
              [47.2733101, 39.3561652],
              [47.2703565, 39.3523046],
              [47.267973, 39.3504667],
              [47.262051, 39.349619],
              [47.2591783, 39.3474366],
              [47.2553449, 39.3486523],
              [47.2518772, 39.3482015],
              [47.2502595, 39.3463522],
              [47.2488912, 39.340561],
              [47.2458971, 39.3372045],
              [47.2393843, 39.3364805],
              [47.2366772, 39.3347047],
              [47.232953, 39.3351795],
              [47.2264752, 39.3334789],
              [47.2247937, 39.3317596],
              [47.223787, 39.3255172],
              [47.2183309, 39.322266],
              [47.2156721, 39.3189532],
              [47.2082841, 39.3188846],
              [47.2067571, 39.3203073],
              [47.2061063, 39.3209477],
              [47.2025694, 39.3190477],
              [47.1992954, 39.3187276],
              [47.1962492, 39.3199963],
              [47.1949602, 39.3199172],
              [47.1927866, 39.3189756],
              [47.1887822, 39.3157691],
              [47.182525, 39.3156811],
              [47.1794498, 39.3147999],
              [47.1777574, 39.3126951],
              [47.172365, 39.3093203],
              [47.1668112, 39.3075966],
              [47.1657852, 39.3074527],
              [47.1650717, 39.3079242],
              [47.1631684, 39.3111912],
              [47.161355, 39.3118332],
              [47.1591326, 39.3114533],
              [47.1570534, 39.3098883],
              [47.1527279, 39.3020136],
              [47.1489089, 39.3014158],
              [47.1482569, 39.3004691],
              [47.1483552, 39.2978786],
              [47.1469315, 39.2961818],
              [47.1455362, 39.2957852],
              [47.1429091, 39.2962773],
              [47.1409673, 39.2954642],
              [47.1399324, 39.293326],
              [47.1390336, 39.2923985],
              [47.1344399, 39.2923578],
              [47.1327739, 39.2918267],
              [47.130708, 39.2892217],
              [47.1295799, 39.285867],
              [47.1272548, 39.2818029],
              [47.1265971, 39.2798041],
              [47.1255638, 39.2783635],
              [47.1243922, 39.2780905],
              [47.1232163, 39.2781224],
              [47.1200665, 39.2803936],
              [47.1163312, 39.2805553],
              [47.1134905, 39.2792425],
              [47.1132696, 39.2791401],
              [47.111281, 39.2746271],
              [47.1099309, 39.2735018],
              [47.1068048, 39.2725983],
              [47.1041172, 39.2727346],
              [47.1016583, 39.2741979],
              [47.1007335, 39.2760846],
              [47.0983303, 39.2767338],
              [47.0968952, 39.2755379],
              [47.094658, 39.2659549],
              [47.0924526, 39.2648099],
              [47.0904566, 39.2647549],
              [47.0882671, 39.2663615],
              [47.0863643, 39.266456],
              [47.084414, 39.2657214],
              [47.0814019, 39.2636205],
              [47.0764564, 39.256504],
              [47.0755366, 39.2524189],
              [47.0755972, 39.2490182],
              [47.0727628, 39.2453158],
              [47.0704147, 39.2444756],
              [47.064326, 39.2457228],
              [47.063112, 39.2454184],
              [47.0620276, 39.2436593],
              [47.0594628, 39.2420049],
              [47.0580694, 39.2398185],
              [47.0579494, 39.2381368],
              [47.0601712, 39.2335688],
              [47.0598289, 39.2326175],
              [47.0577703, 39.2308198],
              [47.0572275, 39.2279736],
              [47.057799, 39.2241999],
              [47.057206, 39.2213424],
              [47.0547813, 39.2157349],
              [47.054989, 39.2137032],
              [47.0567319, 39.2107285],
              [47.0606894, 39.2064423],
              [47.0607312, 39.2062385],
              [47.0609185, 39.2052735],
              [47.0603918, 39.2041153],
              [47.057593, 39.203267],
              [47.056313, 39.2012657],
              [47.055114, 39.1955681],
              [47.0539374, 39.1939118],
              [47.0488839, 39.1906411],
              [47.0464504, 39.1884477],
              [47.0445034, 39.1870612],
              [47.0412129, 39.1853256],
              [47.0406442, 39.1849331],
              [47.0364815, 39.1834034],
              [47.0345501, 39.1799619],
              [47.0334918, 39.1788332],
              [47.025578, 39.1768502],
              [47.0225644, 39.1754808],
              [47.0223098, 39.1741689],
              [47.0212274, 39.1734651],
              [47.0213572, 39.1704574],
              [47.0197939, 39.1677187],
              [47.0191103, 39.1670014],
              [47.0157934, 39.166207],
              [47.0069414, 39.1670683],
              [47.0036516, 39.1666787],
              [46.9993569, 39.1677849],
              [46.9976387, 39.1672296],
              [46.9957006, 39.1656732],
              [46.9932635, 39.1645118],
              [46.9930966, 39.1637164],
              [46.9919001, 39.1624044],
              [46.9919231, 39.1593481],
              [46.9939832, 39.1557421],
              [46.9934585, 39.1545376],
              [46.9889855, 39.1528015],
              [46.9845088, 39.1504479],
              [46.9820556, 39.1498838],
              [46.9762969, 39.1473595],
              [46.9681622, 39.1445301],
              [46.9647404, 39.1424734],
              [46.9637943, 39.1415398],
              [46.9632831, 39.140536],
              [46.9624954, 39.1403575],
              [46.9609178, 39.1414107],
              [46.9592159, 39.1415467],
              [46.9562419, 39.1411485],
              [46.9532832, 39.1403351],
              [46.9515984, 39.1394056],
              [46.9499057, 39.1395053],
              [46.9485042, 39.1404421],
              [46.9480611, 39.1416702],
              [46.9477768, 39.1474914],
              [46.9463776, 39.1485484],
              [46.9443847, 39.1481093],
              [46.9385584, 39.151977],
              [46.9382587, 39.1546695],
              [46.93705, 39.1572273],
              [46.9255441, 39.1647287],
              [46.9111848, 39.158891],
              [46.8936754, 39.1517784],
              [46.8664708, 39.1407097],
              [46.8452627, 39.1395615],
              [46.8390194, 39.1374974],
              [46.8404835, 39.1334667],
              [46.8414717, 39.1304528],
              [46.8390088, 39.1233406],
              [46.8366858, 39.1218189],
              [46.8344638, 39.1209205],
              [46.8338894, 39.1202046],
              [46.8337387, 39.1188287],
              [46.8344832, 39.1155966],
              [46.8342366, 39.1144444],
              [46.8331208, 39.113403],
              [46.8320209, 39.112961],
              [46.8305165, 39.1128693],
              [46.8269452, 39.1147576],
              [46.8259393, 39.1145494],
              [46.8241304, 39.1131311],
              [46.8242197, 39.1122648],
              [46.8227375, 39.1108147],
              [46.8203317, 39.1105519],
              [46.8185215, 39.1100567],
              [46.8155292, 39.1099205],
              [46.8147235, 39.1090702],
              [46.8148651, 39.1077811],
              [46.8157574, 39.1068268],
              [46.8171872, 39.1062208],
              [46.8199085, 39.1066481],
              [46.8206697, 39.1062696],
              [46.8211771, 39.1055312],
              [46.8209774, 39.1047598],
              [46.8203512, 39.1041591],
              [46.8179908, 39.1035204],
              [46.8130578, 39.103531],
              [46.8119538, 39.1030956],
              [46.8111034, 39.1014421],
              [46.8134035, 39.0979481],
              [46.8133781, 39.0971634],
              [46.8124184, 39.0964775],
              [46.8016959, 39.0937324],
              [46.7998986, 39.0925551],
              [46.7974082, 39.0919786],
              [46.7964251, 39.0906416],
              [46.7963536, 39.0887062],
              [46.7957335, 39.0880824],
              [46.7916138, 39.0876571],
              [46.790686, 39.0871097],
              [46.7896884, 39.0818958],
              [46.7885209, 39.0804797],
              [46.78799, 39.0783271],
              [46.7867182, 39.0770149],
              [46.7819046, 39.0756975],
              [46.7780202, 39.0727645],
              [46.7775614, 39.0711868],
              [46.7757076, 39.069856],
              [46.7746989, 39.069685],
              [46.773844, 39.0698675],
              [46.7716342, 39.0712774],
              [46.7704519, 39.0715391],
              [46.7693349, 39.0713247],
              [46.7683432, 39.0704193],
              [46.7683242, 39.0680164],
              [46.767482, 39.0646965],
              [46.7679346, 39.0588894],
              [46.7669087, 39.0579532],
              [46.761296, 39.0584633],
              [46.7590985, 39.0579337],
              [46.7584939, 39.057075],
              [46.7572989, 39.0498306],
              [46.7580788, 39.045616],
              [46.7586494, 39.0435729],
              [46.7619092, 39.0381835],
              [46.761784, 39.0369011],
              [46.7564149, 39.0301181],
              [46.7530928, 39.025914],
              [46.7519509, 39.0257572],
              [46.7505397, 39.0278033],
              [46.7493545, 39.0284318],
              [46.7479451, 39.0285695],
              [46.7437876, 39.0263366],
              [46.7399777, 39.0200042],
              [46.7385151, 39.0187238],
              [46.7367822, 39.0176203],
              [46.7346592, 39.0168215],
              [46.7315016, 39.0160731],
              [46.728139, 39.0161088],
              [46.7253955, 39.0158121],
              [46.7223576, 39.0145849],
              [46.720087, 39.0144641],
              [46.7174075, 39.0145854],
              [46.7155307, 39.0138702],
              [46.7140226, 39.0128099],
              [46.707876, 39.0138459],
              [46.7071415, 39.0144235],
              [46.706744, 39.0180331],
              [46.7060969, 39.0184937],
              [46.7032403, 39.0186224],
              [46.6993894, 39.0194567],
              [46.6969383, 39.0190302],
              [46.6957247, 39.0180166],
              [46.6914397, 39.012144],
              [46.6870776, 39.0081386],
              [46.6851093, 39.0079064],
              [46.6835639, 39.0071507],
              [46.6831597, 39.0063436],
              [46.6835176, 39.0048994],
              [46.6882792, 39.002611],
              [46.6889914, 39.0015501],
              [46.6888772, 38.9964944],
              [46.6903284, 38.9949352],
              [46.6892893, 38.9935398],
              [46.6857012, 38.9924209],
              [46.683769, 38.9922933],
              [46.681183, 38.9900944],
              [46.6781039, 38.9847995],
              [46.6751787, 38.9838387],
              [46.6747571, 38.9833449],
              [46.6748078, 38.980007],
              [46.6734554, 38.9778726],
              [46.6672622, 38.9742393],
              [46.6634131, 38.9707893],
              [46.6632108, 38.9679396],
              [46.6622646, 38.966546],
              [46.6602529, 38.9655123],
              [46.6577537, 38.9635164],
              [46.6565406, 38.9621307],
              [46.656832, 38.9587237],
              [46.656581, 38.9571361],
              [46.6560564, 38.9555994],
              [46.6549773, 38.9540911],
              [46.6522705, 38.9526976],
              [46.6483008, 38.9516245],
              [46.6414431, 38.9515578],
              [46.6404129, 38.951116],
              [46.6392368, 38.9492908],
              [46.6387397, 38.9470519],
              [46.6389387, 38.9458308],
              [46.6404154, 38.9450297],
              [46.6406695, 38.9442104],
              [46.6382403, 38.9403444],
              [46.6367328, 38.9394547],
              [46.6323061, 38.9393082],
              [46.6281636, 38.9371325],
              [46.6268552, 38.9350177],
              [46.6274715, 38.930396],
              [46.625356, 38.9291857],
              [46.6229779, 38.9282119],
              [46.621666, 38.9270849],
              [46.6205885, 38.9245446],
              [46.6191232, 38.9234543],
              [46.6134121, 38.9206628],
              [46.609647, 38.9216355],
              [46.607642, 38.9213736],
              [46.6071525, 38.9204832],
              [46.6078117, 38.9177536],
              [46.6041917, 38.9145456],
              [46.6034497, 38.912529],
              [46.6034552, 38.9099154],
              [46.6009537, 38.9060612],
              [46.5983379, 38.9057576],
              [46.5920823, 38.9020786],
              [46.5887857, 38.8993499],
              [46.5875463, 38.8985874],
              [46.5850084, 38.8980868],
              [46.5820807, 38.8958925],
              [46.5745915, 38.8914114],
              [46.5710988, 38.8910552],
              [46.5684859, 38.8904363],
              [46.5661959, 38.888648],
              [46.5663729, 38.8863702],
              [46.5653437, 38.8856997],
              [46.5569798, 38.8853894],
              [46.5544482, 38.8842288],
              [46.5521943, 38.8826185],
              [46.5500033, 38.8793524],
              [46.5462798, 38.8784449],
              [46.5438043, 38.8769913],
              [46.5409967, 38.8718692],
              [46.5398256, 38.8706266],
              [46.5339832, 38.867172],
              [46.5337126, 38.8673273],
              [46.5319385, 38.8683425],
              [46.5301643, 38.8693577],
              [46.5271301, 38.8723603],
              [46.5249491, 38.8756999],
              [46.5236921, 38.8780122],
              [46.523999, 38.8811365],
              [46.5254238, 38.8852005],
              [46.52578, 38.8861726],
              [46.525684, 38.886675],
              [46.5255338, 38.8874615],
              [46.5251148, 38.8878846],
              [46.5243816, 38.8883123],
              [46.5225997, 38.8889067],
              [46.5194821, 38.8890119],
              [46.5172934, 38.8889034],
              [46.5144017, 38.8887828],
              [46.5120488, 38.8879839],
              [46.5093541, 38.8872248],
              [46.5079759, 38.8865829],
              [46.5065282, 38.8854024],
              [46.5052613, 38.8852319],
              [46.5043116, 38.8855629],
              [46.5026036, 38.887245],
              [46.5007603, 38.8888199],
              [46.498775, 38.8895891],
              [46.4981425, 38.8897886],
              [46.491463, 38.8892616],
              [46.4913765, 38.8892334],
              [46.4907879, 38.8890412],
              [46.4901686, 38.8886787],
              [46.4894843, 38.8877092],
              [46.489259, 38.887016],
              [46.489114, 38.8865093],
              [46.4889739, 38.8861054],
              [46.4884436, 38.8861225],
              [46.4866412, 38.8861642],
              [46.485343, 38.8856548],
              [46.4834821, 38.8853672],
              [46.4821436, 38.8859532],
              [46.4802843, 38.8874211],
              [46.4782709, 38.8887602],
              [46.4748824, 38.8898428],
              [46.4738614, 38.8900742],
              [46.4723752, 38.889413],
              [46.4704127, 38.8890707],
              [46.4692503, 38.889018],
              [46.4681715, 38.8889326],
              [46.4665067, 38.8884814],
              [46.4659399, 38.8884482],
              [46.4652801, 38.8885808],
              [46.4641857, 38.8899138],
              [46.4635282, 38.8914723],
              [46.4620711, 38.8933478],
              [46.4618355, 38.8935776],
              [46.4612353, 38.8936549],
              [46.4607608, 38.8940159],
              [46.4593433, 38.894597],
              [46.4587247, 38.895158],
              [46.4584458, 38.8959429],
              [46.4581907, 38.8971694],
              [46.4566175, 38.8981941],
              [46.4550662, 38.8987986],
              [46.4534998, 38.8990073],
              [46.4528212, 38.8987104],
              [46.4514184, 38.8977047],
              [46.4507532, 38.8972079],
              [46.4499736, 38.8970283],
              [46.4465829, 38.8975799],
              [46.4455227, 38.8972803],
              [46.4438653, 38.8973874],
              [46.4430714, 38.8973457],
              [46.4420307, 38.8968697],
              [46.4415264, 38.8961433],
              [46.441256, 38.8951351],
              [46.4405328, 38.8947248],
              [46.4395845, 38.8944482],
              [46.4382457, 38.8945469],
              [46.4367467, 38.8950452],
              [46.4352822, 38.8952248],
              [46.4329326, 38.894849],
              [46.4315929, 38.8945492],
              [46.430937, 38.8944649],
              [46.4301216, 38.8935965],
              [46.4296281, 38.8932458],
              [46.4290917, 38.8925777],
              [46.4273, 38.8920349],
              [46.4268058, 38.8914883],
              [46.4262014, 38.8904049],
              [46.4263454, 38.8883599],
              [46.4250076, 38.8855468],
              [46.4238762, 38.8844082],
              [46.4225934, 38.883218],
              [46.4210438, 38.8830219],
              [46.4197563, 38.8833559],
              [46.418185, 38.8844625],
              [46.4167455, 38.8866249],
              [46.4164304, 38.8878657],
              [46.4163605, 38.8882836],
              [46.416248, 38.8889555],
              [46.4166541, 38.8907556],
              [46.4164036, 38.8921956],
              [46.4161322, 38.8925719],
              [46.4150786, 38.8928761],
              [46.413598, 38.8930097],
              [46.4103513, 38.8932787],
              [46.4091358, 38.894173],
              [46.4041903, 38.8979772],
              [46.4028565, 38.8996405],
              [46.4012043, 38.9004693],
              [46.3975396, 38.9023077],
              [46.3943455, 38.9036707],
              [46.3939494, 38.904138],
              [46.3933432, 38.9042466],
              [46.3918119, 38.9041438],
              [46.3897705, 38.9050272],
              [46.3889904, 38.9054708],
              [46.3878013, 38.905795],
              [46.3840948, 38.9064098],
              [46.3831018, 38.9064534],
              [46.382529, 38.9064785],
              [46.3818458, 38.9064358],
              [46.3807865, 38.9063696],
              [46.3774222, 38.9069766],
              [46.374243, 38.9081569],
              [46.3711901, 38.9090107],
              [46.369077, 38.9097007],
              [46.3682945, 38.9106479],
              [46.3682052, 38.9120058],
              [46.3681786, 38.9124097],
              [46.3657828, 38.9142157],
              [46.3648847, 38.9149137],
              [46.3632197, 38.9163092],
              [46.3619518, 38.9163349],
              [46.3595773, 38.9151162],
              [46.3588545, 38.9150537],
              [46.3568537, 38.916409],
              [46.3533479, 38.9167606],
              [46.3505824, 38.9165906],
              [46.3461404, 38.9168198],
              [46.3453843, 38.9166828],
              [46.3392587, 38.9163631],
              [46.3368347, 38.9154026],
              [46.3360524, 38.9136629],
              [46.3357656, 38.9130251],
              [46.3363473, 38.9117424],
              [46.3358569, 38.9104609],
              [46.3336282, 38.9092444],
              [46.3298321, 38.9086945],
              [46.3277395, 38.9081518],
              [46.3266091, 38.9071172],
              [46.321343, 38.9035617],
              [46.31949, 38.9025689],
              [46.3190224, 38.9023183],
              [46.3173615, 38.901543],
              [46.3160419, 38.9014004],
              [46.3156705, 38.9014708],
              [46.3135242, 38.9018779],
              [46.3094577, 38.9035316],
              [46.3078233, 38.9045714],
              [46.3057519, 38.9058891],
              [46.303102, 38.9063377],
              [46.302099, 38.9059511],
              [46.3016702, 38.9055229],
              [46.3009491, 38.9023984],
              [46.300241, 38.9014733],
              [46.2979311, 38.9003082],
              [46.2962161, 38.9001765],
              [46.293548, 38.9010681],
              [46.2920613, 38.8999861],
              [46.2912605, 38.8998203],
              [46.2896044, 38.9004666],
              [46.2883862, 38.9008216],
              [46.2860078, 38.9008903],
              [46.2858593, 38.9008946],
              [46.2832922, 38.900504],
              [46.282509, 38.9002305],
              [46.2787282, 38.8979747],
              [46.2774646, 38.8955964],
              [46.276353, 38.8957128],
              [46.271982, 38.8953511],
              [46.2704417, 38.8939738],
              [46.2691042, 38.8938219],
              [46.2670688, 38.8929759],
              [46.2666294, 38.8918514],
              [46.2670106, 38.8886505],
              [46.2670636, 38.8882705],
              [46.2671541, 38.8876217],
              [46.2670077, 38.8872764],
              [46.2668368, 38.887071],
              [46.2664811, 38.8866402],
              [46.262686, 38.8848307],
              [46.2599684, 38.884357],
              [46.2579588, 38.8819884],
              [46.2558355, 38.8813551],
              [46.2533191, 38.8803027],
              [46.2496221, 38.8780127],
              [46.2488752, 38.8756364],
              [46.2478026, 38.8740488],
              [46.2438071, 38.8725932],
              [46.2404416, 38.8718008],
              [46.2360896, 38.8691662],
              [46.2338341, 38.8687666],
              [46.231933, 38.8683514],
              [46.230772, 38.8668896],
              [46.2285717, 38.8663465],
              [46.2266131, 38.8663651],
              [46.2241831, 38.8661199],
              [46.2187294, 38.8652316],
              [46.2162251, 38.8643871],
              [46.2161933, 38.8624375],
              [46.2157095, 38.8611697],
              [46.2147846, 38.8585362],
              [46.2147646, 38.8581705],
              [46.2146201, 38.8557027],
              [46.2118933, 38.8539579],
              [46.2104637, 38.8539939],
              [46.2094129, 38.8537584],
              [46.2078078, 38.8533086],
              [46.2064965, 38.8528824],
              [46.2027699, 38.8516713],
              [46.2017895, 38.8517075],
              [46.1956887, 38.8523923],
              [46.1935851, 38.8519199],
              [46.1918934, 38.8508804],
              [46.1913604, 38.848739],
              [46.1903903, 38.8469486],
              [46.1869987, 38.843148],
              [46.1841363, 38.8414876],
              [46.1817758, 38.8407564],
              [46.1782862, 38.8407632],
              [46.175674, 38.8405526],
              [46.173374, 38.8404775],
              [46.1710533, 38.8415986],
              [46.1696737, 38.8422269],
              [46.1676286, 38.8425622],
              [46.1660426, 38.8430156],
              [46.1645218, 38.8427802],
              [46.1623533, 38.8419916],
              [46.161411, 38.8411987],
              [46.1597595, 38.8411961],
              [46.1586828, 38.8414973],
              [46.1577035, 38.8419823],
              [46.1559717, 38.8428203],
              [46.1544234, 38.8432223],
              [46.1528391, 38.8423044],
              [46.1508207, 38.8417069],
              [46.1476006, 38.8418111],
              [46.1449527, 38.8421851],
              [46.1406764, 38.8445178],
              [46.1364163, 38.8468745],
              [46.1354777, 38.8467589],
              [46.1301808, 38.8462261],
              [46.1291369, 38.8464012],
              [46.1284484, 38.847192],
              [46.128913, 38.8495651],
              [46.1281172, 38.8511058],
              [46.1235569, 38.8531072],
              [46.1216772, 38.8547768],
              [46.1186829, 38.8560278],
              [46.1172168, 38.856445],
              [46.1153831, 38.8574044],
              [46.1142623, 38.8585939],
              [46.1128228, 38.858341],
              [46.1117495, 38.8583846],
              [46.1114506, 38.8589393],
              [46.1130563, 38.8626522],
              [46.1131494, 38.8637454],
              [46.1121896, 38.8650738],
              [46.1104437, 38.8658321],
              [46.1037838, 38.8669639],
              [46.1018815, 38.8666432],
              [46.0987769, 38.8671718],
              [46.0971842, 38.8671078],
              [46.0951957, 38.8668311],
              [46.0930324, 38.8672867],
              [46.0910885, 38.8685846],
              [46.0863366, 38.8698909],
              [46.0827539, 38.8711645],
              [46.0804348, 38.8714615],
              [46.0792422, 38.8724573],
              [46.0778614, 38.8741276],
              [46.0755056, 38.8758005],
              [46.0724386, 38.8773235],
              [46.0712649, 38.8784194],
              [46.0690309, 38.8824594],
              [46.06761, 38.885657],
              [46.0670219, 38.8869124],
              [46.0654204, 38.8874386],
              [46.0628381, 38.8877486],
              [46.0606153, 38.8875446],
              [46.058888, 38.8877766],
              [46.0562041, 38.8856649],
              [46.0555085, 38.8848686],
              [46.0546186, 38.8843128],
              [46.0542577, 38.8837144],
              [46.0542839, 38.8815938],
              [46.0547886, 38.8804538],
              [46.0545168, 38.8787658],
              [46.0541375, 38.8780497],
              [46.0518492, 38.8761008],
              [46.0488935, 38.8749851],
              [46.0468369, 38.874706],
              [46.0446455, 38.8738931],
              [46.0436448, 38.8734266],
              [46.0415763, 38.8719227],
              [46.0409451, 38.871789],
              [46.040357, 38.8718666],
              [46.0379306, 38.8726924],
              [46.034476, 38.8747593],
              [46.0326504, 38.8750095],
              [46.0290652, 38.8745452],
              [46.028199, 38.8742733],
              [46.0278359, 38.8739387],
              [46.0274223, 38.8725664],
              [46.0245089, 38.872378],
              [46.0200541, 38.8736158],
              [46.0156497, 38.8736581],
              [46.0119036, 38.8719802],
              [46.0062956, 38.8723619],
              [46.0040135, 38.8730733],
              [45.9996589, 38.8753441],
              [45.9977188, 38.8754711],
              [45.994545, 38.8748504],
              [45.9877911, 38.8759636],
              [45.979187, 38.8788158],
              [45.975994, 38.8808698],
              [45.9729251, 38.8839337],
              [45.9681829, 38.8870769],
              [45.9677169, 38.8878839],
              [45.9673985, 38.8896198],
              [45.9667606, 38.8901154],
              [45.9644781, 38.89066],
              [45.9626366, 38.890382],
              [45.959927, 38.8888703],
              [45.9580632, 38.8886164],
              [45.9561369, 38.88925],
              [45.9472825, 38.8950688],
              [45.9455251, 38.8957305],
              [45.9445223, 38.8965928],
              [45.9435292, 38.896398],
              [45.9423372, 38.89541],
              [45.9417497, 38.8940663],
              [45.9342371, 38.8894642],
              [45.930471, 38.8861348],
              [45.9286317, 38.8833482],
              [45.9289272, 38.8825187],
              [45.9283938, 38.8808975],
              [45.9279565, 38.8795686],
              [45.9275699, 38.8790766],
              [45.9266648, 38.8778907],
              [45.9251893, 38.8772071],
              [45.9238704, 38.8765574],
              [45.9222377, 38.8754702],
              [45.9221466, 38.8754162],
              [45.9198348, 38.8740443],
              [45.9190602, 38.8735846],
              [45.9178801, 38.8733221],
              [45.9124279, 38.8746039],
              [45.9102916, 38.8739433],
              [45.9087076, 38.8739169],
              [45.9038441, 38.8777271],
              [45.9004192, 38.8775724],
              [45.898829, 38.8770517],
              [45.8973636, 38.8765718],
              [45.8953641, 38.8764066],
              [45.8940243, 38.8766728],
              [45.8939065, 38.8767793],
              [45.8922881, 38.8782419],
              [45.892105, 38.8784074],
              [45.8912751, 38.8814177],
              [45.8915728, 38.8833575],
              [45.8904347, 38.8848101],
              [45.885314, 38.8862172],
              [45.8823295, 38.8865427],
              [45.8808493, 38.8884318],
              [45.8795807, 38.8892032],
              [45.8757342, 38.8897957],
              [45.8735291, 38.8891079],
              [45.871333, 38.8887123],
              [45.8692518, 38.8885515],
              [45.8684468, 38.889006],
              [45.8650175, 38.8915492],
              [45.8608606, 38.8930754],
              [45.8603997, 38.8937478],
              [45.861601, 38.8954243],
              [45.862065, 38.8971194],
              [45.86413, 38.8991991],
              [45.8640587, 38.9003033],
              [45.8612544, 38.9034596],
              [45.8576532, 38.9046213],
              [45.8560747, 38.9060757],
              [45.8517853, 38.9083948],
              [45.8493614, 38.9095575],
              [45.8467457, 38.910444],
              [45.844416, 38.9107035],
              [45.8430723, 38.9102715],
              [45.8393831, 38.9079954],
              [45.8352172, 38.9049677],
              [45.83327, 38.9026563],
              [45.8321366, 38.9023566],
              [45.830335, 38.9024718],
              [45.8267452, 38.9023752],
              [45.82346, 38.9039028],
              [45.8218016, 38.9049816],
              [45.8200469, 38.9054862],
              [45.8152735, 38.9052549],
              [45.8137932, 38.9060087],
              [45.8122977, 38.907104],
              [45.8119384, 38.9081011],
              [45.8118074, 38.9091544],
              [45.8119303, 38.9105338],
              [45.8111467, 38.9120004],
              [45.8062037, 38.9135085],
              [45.805287, 38.9140772],
              [45.8036461, 38.9141158],
              [45.8024327, 38.9134028],
              [45.8013015, 38.913365],
              [45.7998297, 38.9150389],
              [45.7997838, 38.9180359],
              [45.8007719, 38.9193387],
              [45.8010689, 38.9204],
              [45.8009083, 38.9218734],
              [45.7987254, 38.9245543],
              [45.7979968, 38.9249278],
              [45.7941264, 38.9244456],
              [45.7917567, 38.9236915],
              [45.7901506, 38.9222045],
              [45.7885289, 38.9207032],
              [45.7864352, 38.9195238],
              [45.785821, 38.9194587],
              [45.7853007, 38.9198983],
              [45.7861729, 38.9229394],
              [45.7856739, 38.9243673],
              [45.7841797, 38.9251816],
              [45.7822494, 38.9256294],
              [45.7768698, 38.9234187],
              [45.7745216, 38.9233469],
              [45.7724338, 38.9236948],
              [45.7684929, 38.9253917],
              [45.766781, 38.9271553],
              [45.7637848, 38.929009],
              [45.7627509, 38.9292503],
              [45.7616364, 38.9291846],
              [45.7597116, 38.9286727],
              [45.758327, 38.9284652],
              [45.7569697, 38.9286514],
              [45.7535696, 38.9289354],
              [45.736821, 38.9275348],
              [45.7356, 38.9279836],
              [45.7321303, 38.9307798],
              [45.7303488, 38.9314572],
              [45.7255194, 38.9321637],
              [45.7234149, 38.9336337],
              [45.7216312, 38.9354682],
              [45.7174335, 38.9364822],
              [45.7132097, 38.9394462],
              [45.7101704, 38.9449647],
              [45.7093961, 38.945086],
              [45.7041117, 38.9438245],
              [45.7017946, 38.9436372],
              [45.6988577, 38.9442388],
              [45.6978175, 38.9450685],
              [45.6967022, 38.9480755],
              [45.6961922, 38.950327],
              [45.6924464, 38.9514945],
              [45.690013, 38.9514056],
              [45.6842876, 38.9490936],
              [45.6793462, 38.9465584],
              [45.678701, 38.9464488],
              [45.6780987, 38.9465839],
              [45.6771362, 38.9479881],
              [45.6759501, 38.9490045],
              [45.6752965, 38.949443],
              [45.6739215, 38.9495647],
              [45.6725092, 38.9491122],
              [45.670521, 38.9471515],
              [45.6700803, 38.9470146],
              [45.6693909, 38.9468005],
              [45.6686719, 38.9469743],
              [45.6677114, 38.9472064],
              [45.6634872, 38.950588],
              [45.660556, 38.9517049],
              [45.6552268, 38.9518252],
              [45.6501931, 38.9513683],
              [45.647385, 38.9518779],
              [45.6461949, 38.9515358],
              [45.6451083, 38.9475088],
              [45.6443865, 38.9463939],
              [45.6421623, 38.9472251],
              [45.6385911, 38.9469864],
              [45.6370793, 38.9466514],
              [45.6356111, 38.9454555],
              [45.6334874, 38.9447496],
              [45.6299422, 38.9446953],
              [45.6266648, 38.9436702],
              [45.6183144, 38.9426502],
              [45.6158711, 38.9414165],
              [45.6152749, 38.9415467],
              [45.6147172, 38.941661],
              [45.6145737, 38.9416943],
              [45.6140798, 38.9425109],
              [45.6162879, 38.9464809],
              [45.6163367, 38.9481484],
              [45.6147663, 38.952512],
              [45.6147743, 38.954721],
              [45.6144147, 38.9563456],
              [45.6130813, 38.9578852],
              [45.6124994, 38.9581083],
              [45.6118125, 38.9579732],
              [45.6110367, 38.9568577],
              [45.6102487, 38.956245],
              [45.6093557, 38.9561696],
              [45.6073515, 38.9567509],
              [45.6055737, 38.9578489],
              [45.603413, 38.9592524],
              [45.6029076, 38.9604547],
              [45.6007733, 38.9617761],
              [45.5951445, 38.9622535],
              [45.5928433, 38.9632642],
              [45.5911856, 38.9644915],
              [45.5853422, 38.9672141],
              [45.5841409, 38.9693805],
              [45.5838549, 38.9717955],
              [45.5843135, 38.9761121],
              [45.5835793, 38.977269],
              [45.5818975, 38.978503],
              [45.580174, 38.9789688],
              [45.5778086, 38.9786447],
              [45.5702203, 38.9761019],
              [45.5692938, 38.9760695],
              [45.5684944, 38.9755344],
              [45.5673363, 38.9738216],
              [45.5660987, 38.9711706],
              [45.5663613, 38.9705931],
              [45.5656763, 38.9690676],
              [45.5634456, 38.9682605],
              [45.5624929, 38.9689215],
              [45.5585236, 38.9681513],
              [45.5576438, 38.9678045],
              [45.5531415, 38.9644899],
              [45.5508721, 38.9640201],
              [45.5495158, 38.9641164],
              [45.5481452, 38.965025],
              [45.546695, 38.9654361],
              [45.5450956, 38.9655026],
              [45.5439576, 38.9645904],
              [45.5415028, 38.9648285],
              [45.5372482, 38.9664181],
              [45.5357426, 38.9680809],
              [45.5356521, 38.9688668],
              [45.5342739, 38.9698785],
              [45.5322152, 38.9703529],
              [45.5306669, 38.9696847],
              [45.5291658, 38.9698331],
              [45.5277553, 38.9715283],
              [45.5263299, 38.9719121],
              [45.5250186, 38.9718084],
              [45.5232969, 38.9723617],
              [45.5215983, 38.9741336],
              [45.5204504, 38.974591],
              [45.514872, 38.9760075],
              [45.512366, 38.9770595],
              [45.5092522, 38.9785633],
              [45.5081919, 38.9788588],
              [45.5067759, 38.9793378],
              [45.5064081, 38.9804888],
              [45.5050149, 38.9806658],
              [45.5043888, 38.9804389],
              [45.5036668, 38.9802789],
              [45.5029716, 38.9803512],
              [45.5019754, 38.9807008],
              [45.5007862, 38.9818621],
              [45.5008102, 38.9830817],
              [45.4983923, 38.9840775],
              [45.4973399, 38.9841618],
              [45.4957085, 38.9839449],
              [45.4939766, 38.9832525],
              [45.4932969, 38.9832378],
              [45.4907466, 38.9841688],
              [45.4892007, 38.9848425],
              [45.4868096, 38.9866546],
              [45.4825803, 38.9865989],
              [45.4802459, 38.9861774],
              [45.4776419, 38.9863391],
              [45.4724097, 38.9897452],
              [45.4708896, 38.9890138],
              [45.4685871, 38.989138],
              [45.4644005, 38.9899667],
              [45.4620447, 38.9899853],
              [45.4590372, 38.990321],
              [45.4579998, 38.9901077],
              [45.4549509, 38.9905356],
              [45.4542424, 38.9913843],
              [45.4535963, 38.9926547],
              [45.4529047, 38.9929965],
              [45.4501334, 38.9906022],
              [45.44958, 38.9903245],
              [45.4431901, 38.9844938],
              [45.4420768, 38.9842158],
              [45.4358284, 38.9806241],
              [45.4286055, 38.9772869],
              [45.428329, 38.9767307],
              [45.4234505, 38.9752265],
              [45.4197488, 38.9748929],
              [45.4194722, 38.9746149],
              [45.4158589, 38.9746148],
              [45.4114158, 38.9740586],
              [45.4042971, 38.9733794],
              [45.4037439, 38.9731103],
              [45.4006876, 38.9731103],
              [45.399854, 38.9728322],
              [45.398464, 38.9728322],
              [45.3976305, 38.9725542],
              [45.3962446, 38.9725541],
              [45.393464, 38.9714418],
              [45.3926311, 38.9714417],
              [45.391521, 38.9708856],
              [45.3840208, 38.9656019],
              [45.3779074, 38.9625519],
              [45.3763279, 38.9609946],
              [45.3754943, 38.959335],
              [45.3706167, 38.947795],
              [45.362377, 38.9441903],
              [45.3577421, 38.918418],
              [45.3493307, 38.9146782],
              [45.3458975, 38.90466],
              [45.3414343, 38.8997172],
              [45.3417134, 38.8956119],
              [45.3362203, 38.8883082],
              [45.3362203, 38.8877516],
              [45.3198117, 38.8836864],
              [45.3063601, 38.8778739],
              [45.3063601, 38.8773172],
              [45.2815158, 38.8736622],
              [45.2806822, 38.873106],
              [45.2776991, 38.8680208],
              [45.2774194, 38.8677427],
              [45.2781728, 38.8670312],
              [45.2755981, 38.8630989],
              [45.2694183, 38.7925076],
              [45.2657467, 38.7852611],
              [45.2732847, 38.7714842],
              [45.2691411, 38.7650015],
              [45.2713616, 38.753891],
              [45.2715163, 38.7430984],
              [45.2751266, 38.7333787],
              [45.2756836, 38.7331006],
              [45.2756837, 38.7319877],
              [45.2754071, 38.7314312],
              [45.2751266, 38.7303183],
              [45.2734602, 38.7278233],
              [45.2730703, 38.7224017],
              [45.2714032, 38.7171244],
              [45.2689039, 38.7126727],
              [45.2641914, 38.7048074],
              [45.2578016, 38.6945217],
              [45.2575219, 38.6906351],
              [45.2511927, 38.6821203],
              [45.2495263, 38.6776679],
              [45.2492466, 38.6771204],
              [45.2492466, 38.6768331],
              [45.2474088, 38.6708118],
              [45.2476853, 38.6694205],
              [45.2432423, 38.6669159],
              [45.2418524, 38.6666466],
              [45.240186, 38.6666466],
              [45.240186, 38.6663684],
              [45.2396289, 38.6663684],
              [45.2387954, 38.6641421],
              [45.2404626, 38.6630291],
              [45.2401859, 38.6624726],
              [45.2374054, 38.6591422],
              [45.2410189, 38.6574726],
              [45.2526274, 38.6467107],
              [45.2526274, 38.6461541],
              [45.253461, 38.6453194],
              [45.2579041, 38.6353197],
              [45.2590174, 38.6317021],
              [45.2581838, 38.6289284],
              [45.2579042, 38.6283718],
              [45.2616672, 38.6178629],
              [45.2680541, 38.6131407],
              [45.2691673, 38.6070271],
              [45.2658092, 38.5985816],
              [45.2617943, 38.5939273],
              [45.2620708, 38.5919792],
              [45.2623513, 38.5900401],
              [45.2686499, 38.5776953],
              [45.2594211, 38.554295],
              [45.2597008, 38.5540165],
              [45.2652541, 38.5431761],
              [45.2750014, 38.5333961],
              [45.2961157, 38.5210412],
              [45.3264998, 38.4953845],
              [45.3356041, 38.4764312],
              [45.3297613, 38.4616542],
              [45.3149985, 38.450228],
              [45.2762887, 38.4367303],
              [45.273509, 38.4358951],
              [45.2575484, 38.4342346],
              [45.2468238, 38.4338039],
              [45.2418197, 38.4335346],
              [45.2404338, 38.4338039],
              [45.2354337, 38.4335345],
              [45.2283736, 38.4307204],
              [45.2257345, 38.4219909],
              [45.2301977, 38.4127105],
              [45.2424212, 38.3980432],
              [45.2435873, 38.3934736],
              [45.2354248, 38.3905131],
              [45.223868, 38.3831248],
              [45.2218583, 38.3813408],
              [45.2025603, 38.3909172],
              [45.1959455, 38.3903691],
              [45.1789992, 38.3775968],
              [45.1720376, 38.368027],
              [45.1709243, 38.368027],
              [45.1684243, 38.3674701],
              [45.1678711, 38.3671916],
              [45.1542576, 38.3635805],
              [45.1514809, 38.3621881],
              [45.1506481, 38.3621882],
              [45.1384325, 38.3530628],
              [45.1061399, 38.3290841],
              [45.0934543, 38.3219721],
              [45.0935234, 38.3211458]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 3300249,
        "tags": {
          "ISO3166-2": "IR-21",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "یزد",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q170568"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [52.8010566, 31.4948743],
              [52.8007765, 31.4943236],
              [52.8004999, 31.4932131],
              [52.8016099, 31.4915429],
              [52.8057766, 31.4871011],
              [52.8182797, 31.4795988],
              [52.8457793, 31.4504294],
              [52.8485593, 31.4476488],
              [52.864669, 31.4370951],
              [52.8657824, 31.4368243],
              [52.8874058, 31.4286341],
              [52.8880055, 31.4284825],
              [52.8885588, 31.4282117],
              [52.8896721, 31.4282117],
              [52.9041152, 31.4237609],
              [52.9068952, 31.4226505],
              [52.9346715, 31.4048746],
              [52.9507846, 31.3898795],
              [52.9516179, 31.3884892],
              [52.9627312, 31.3745955],
              [52.9655077, 31.3695941],
              [52.9680077, 31.3643219],
              [52.9682843, 31.3626518],
              [52.968841, 31.3618213],
              [52.9777308, 31.3254308],
              [52.9782876, 31.3226504],
              [52.9780075, 31.3118172],
              [52.9777309, 31.3107068],
              [52.9777309, 31.3087569],
              [52.9777309, 31.3082063],
              [52.9774509, 31.3076555],
              [52.9766176, 31.3032049],
              [52.9746743, 31.2954323],
              [52.9716178, 31.2770885],
              [52.9555079, 31.2507104],
              [52.9457847, 31.240988],
              [52.9288383, 31.2345968],
              [52.924395, 31.2337572],
              [52.9180051, 31.2326468],
              [52.9124486, 31.2320961],
              [52.9085619, 31.2312656],
              [52.907172, 31.2312657],
              [52.9063386, 31.2309767],
              [52.8780023, 31.2268151],
              [52.8755023, 31.2262645],
              [52.8688358, 31.2237639],
              [52.8505028, 31.2143124],
              [52.8502261, 31.2137618],
              [52.8335564, 31.1956984],
              [52.831613, 31.191257],
              [52.831613, 31.1865358],
              [52.8335564, 31.1790434],
              [52.8393896, 31.1718126],
              [52.855226, 31.1609802],
              [52.8568927, 31.1604295],
              [52.8613359, 31.1584797],
              [52.8766158, 31.1540384],
              [52.8877256, 31.1470967],
              [52.8882822, 31.1462572],
              [52.8891155, 31.1459773],
              [52.8927254, 31.1429262],
              [52.8941155, 31.1415361],
              [52.8949488, 31.1405657],
              [52.8952254, 31.1404257],
              [52.8955055, 31.1401459],
              [52.8993921, 31.1362644],
              [52.9118953, 31.1212617],
              [52.9160618, 31.1118105],
              [52.9248571, 31.0872694],
              [52.924592, 31.0720322],
              [52.9254627, 31.0575953],
              [52.9286069, 31.0307187],
              [52.9428597, 31.0120171],
              [52.9534334, 31.0044968],
              [52.9746639, 30.9984489],
              [52.9848195, 30.9969758],
              [52.9965368, 30.9954015],
              [53.0093356, 30.9943121],
              [53.0236277, 30.9933287],
              [53.0333233, 30.9911316],
              [53.0428962, 30.9887139],
              [53.0515984, 30.9863858],
              [53.081623, 30.9698677],
              [53.0957928, 30.9623669],
              [53.096626, 30.9615365],
              [53.1188491, 30.9487554],
              [53.1230157, 30.9462552],
              [53.1371822, 30.9387544],
              [53.1380154, 30.9387544],
              [53.1421821, 30.9373644],
              [53.1427388, 30.9370845],
              [53.1432921, 30.9365339],
              [53.1452387, 30.9354238],
              [53.1474621, 30.9345843],
              [53.2180176, 30.9018107],
              [53.2213509, 30.9007005],
              [53.225521, 30.8987509],
              [53.2269076, 30.8984801],
              [53.2374641, 30.8948607],
              [53.2388541, 30.8948607],
              [53.2407974, 30.8940303],
              [53.2416308, 30.8940303],
              [53.2419108, 30.8937505],
              [53.2430207, 30.8934797],
              [53.24368, 30.8929811],
              [53.2441307, 30.8926403],
              [53.2460774, 30.8915301],
              [53.247744, 30.8909795],
              [53.2530205, 30.8881995],
              [53.2624671, 30.882089],
              [53.2638537, 30.880699],
              [53.2724669, 30.8756987],
              [53.2730203, 30.8754189],
              [53.2735769, 30.8751391],
              [53.2746868, 30.8745795],
              [53.2774669, 30.8731985],
              [53.2799669, 30.8723591],
              [53.2858002, 30.8701387],
              [53.2994133, 30.8637484],
              [53.3635824, 30.8331963],
              [53.3774721, 30.8254161],
              [53.3833054, 30.8206957],
              [53.3880253, 30.8173652],
              [53.3955286, 30.8120852],
              [53.4246948, 30.7773641],
              [53.4327514, 30.7662448],
              [53.4433079, 30.7540245],
              [53.4444179, 30.7515245],
              [53.4487552, 30.7471871],
              [53.4494178, 30.7465244],
              [53.4494178, 30.7462446],
              [53.4585844, 30.7373638],
              [53.4605311, 30.7368042],
              [53.4710875, 30.7315245],
              [53.4905305, 30.7265336],
              [53.4921972, 30.7262537],
              [53.4924773, 30.7259739],
              [53.4969205, 30.7251346],
              [53.5049771, 30.7226347],
              [53.506367, 30.7226346],
              [53.5291433, 30.7179145],
              [53.5533131, 30.7154145],
              [53.5619228, 30.714864],
              [53.5630362, 30.7145842],
              [53.5649796, 30.7145842],
              [53.5922025, 30.7120843],
              [53.597479, 30.7120842],
              [53.5994257, 30.7118045],
              [53.6060922, 30.7118045],
              [53.6083156, 30.7115247],
              [53.6116488, 30.7115247],
              [53.6297053, 30.7093045],
              [53.6330386, 30.7093045],
              [53.6499816, 30.7073641],
              [53.6533149, 30.7068046],
              [53.6577615, 30.7056945],
              [53.6591515, 30.7056945],
              [53.6613714, 30.7051349],
              [53.6638714, 30.7048641],
              [53.7144308, 30.6934655],
              [53.734987, 30.6890253],
              [53.7397104, 30.6876354],
              [53.7838764, 30.6751358],
              [53.8071723, 30.669507],
              [53.8315486, 30.6563726],
              [53.836819, 30.6525237],
              [53.8476964, 30.6446677],
              [53.8616004, 30.6299459],
              [53.8733531, 30.6117635],
              [53.8778076, 30.6040636],
              [53.887482, 30.5820481],
              [53.8968836, 30.5583246],
              [53.9018668, 30.5437705],
              [53.9099119, 30.5266315],
              [53.9215849, 30.4989762],
              [53.9264741, 30.4868042],
              [53.914306, 30.4323899],
              [53.92004, 30.4118182],
              [53.9340739, 30.3872274],
              [53.9365988, 30.3784839],
              [53.9361912, 30.3474819],
              [53.9361941, 30.331721],
              [53.9364331, 30.3160072],
              [53.936558, 30.2981132],
              [53.9330787, 30.2834454],
              [53.9296345, 30.2706281],
              [53.9231997, 30.2471378],
              [53.9219181, 30.2382399],
              [53.9190915, 30.2225017],
              [53.9051055, 30.2382326],
              [53.8998698, 30.2341542],
              [53.8984813, 30.2316934],
              [53.9040435, 30.2238568],
              [53.8997304, 30.2229837],
              [53.8796138, 30.2252551],
              [53.8811442, 30.2146892],
              [53.8893127, 30.2009269],
              [53.9004017, 30.2026288],
              [53.9143696, 30.2027922],
              [53.9133622, 30.1993398],
              [53.9051768, 30.1891218],
              [53.9049742, 30.1698955],
              [53.9041767, 30.162404],
              [53.8705105, 30.1714395],
              [53.8700802, 30.1662898],
              [53.8897142, 30.1339738],
              [53.887582, 30.1217065],
              [53.8930309, 30.1060752],
              [53.8970842, 30.0969855],
              [53.9043049, 30.0889645],
              [53.9160828, 30.0767538],
              [53.9222901, 30.0695784],
              [53.9250386, 30.0652301],
              [53.9298696, 30.0621121],
              [53.930383, 30.0591873],
              [53.9390569, 30.0529789],
              [53.9564966, 30.0433455],
              [53.9687204, 30.0377689],
              [53.9744523, 30.035201],
              [53.9802302, 30.0317616],
              [53.9919484, 30.0222],
              [53.9999096, 30.0154584],
              [54.0238242, 30.002674],
              [54.0362389, 29.9971728],
              [54.0432188, 29.9967304],
              [54.0463829, 29.9966819],
              [54.0574955, 29.9940403],
              [54.077711, 29.988319],
              [54.0958028, 29.9823305],
              [54.1092165, 29.976676],
              [54.117498, 29.968807],
              [54.1161247, 29.951374],
              [54.1156097, 29.9343663],
              [54.113414, 29.9172419],
              [54.1139672, 29.9071302],
              [54.1124332, 29.8982025],
              [54.1101383, 29.8915995],
              [54.1071509, 29.882402],
              [54.1059241, 29.8771914],
              [54.1060958, 29.8730033],
              [54.1054996, 29.8695594],
              [54.1045849, 29.8629692],
              [54.1043594, 29.8608835],
              [54.1040365, 29.8581378],
              [54.1037169, 29.8496405],
              [54.1024833, 29.8348695],
              [54.101486, 29.8287312],
              [54.1013663, 29.8222895],
              [54.1001558, 29.8113433],
              [54.0987015, 29.8006565],
              [54.0973444, 29.7886407],
              [54.1054342, 29.7856844],
              [54.1176222, 29.7788309],
              [54.1294668, 29.7692949],
              [54.1341017, 29.7630364],
              [54.1442297, 29.7532008],
              [54.1560744, 29.7390418],
              [54.1658542, 29.7229972],
              [54.1714857, 29.7095774],
              [54.178047, 29.6916319],
              [54.1814709, 29.6749774],
              [54.1848791, 29.6674269],
              [54.1902006, 29.6562768],
              [54.2069984, 29.6318744],
              [54.2144918, 29.6272022],
              [54.2186654, 29.6240518],
              [54.2261053, 29.6200708],
              [54.2303717, 29.6177581],
              [54.2341804, 29.6149907],
              [54.2460051, 29.6082384],
              [54.2659377, 29.6004018],
              [54.2740141, 29.6014783],
              [54.2835443, 29.6050154],
              [54.2937439, 29.6089704],
              [54.3039795, 29.6121323],
              [54.3158394, 29.6159731],
              [54.3273741, 29.6195547],
              [54.3529901, 29.6244224],
              [54.3709727, 29.6223295],
              [54.3878564, 29.620688],
              [54.3969716, 29.6215878],
              [54.4028906, 29.6230322],
              [54.4092227, 29.6220172],
              [54.4189739, 29.6228999],
              [54.4284373, 29.6232011],
              [54.4397878, 29.6221538],
              [54.4555078, 29.6213831],
              [54.4626785, 29.6211084],
              [54.472114, 29.6253711],
              [54.4846097, 29.6336246],
              [54.4905619, 29.6348183],
              [54.5021241, 29.6331958],
              [54.5272033, 29.6311068],
              [54.5406336, 29.6297135],
              [54.543912, 29.6284452],
              [54.5882766, 29.6134398],
              [54.5856576, 29.6513378],
              [54.5814411, 29.7037414],
              [54.5789962, 29.7153165],
              [54.577072, 29.7261426],
              [54.5751645, 29.7385077],
              [54.5745778, 29.7508335],
              [54.5740878, 29.7617049],
              [54.5738886, 29.7671174],
              [54.5690822, 29.8032172],
              [54.567071, 29.8189116],
              [54.5680618, 29.8245241],
              [54.5663079, 29.826573],
              [54.5672034, 29.8461532],
              [54.5635985, 29.8538954],
              [54.5611952, 29.8656563],
              [54.5541783, 29.8834471],
              [54.5488793, 29.8954775],
              [54.5445019, 29.9087964],
              [54.5422453, 29.9109498],
              [54.5454883, 29.9246633],
              [54.5473765, 29.9431098],
              [54.5519335, 29.9720507],
              [54.5473784, 29.9997943],
              [54.5488953, 30.0142296],
              [54.5421922, 30.0414166],
              [54.5392073, 30.0555822],
              [54.539659, 30.0623594],
              [54.5368625, 30.0729961],
              [54.5346499, 30.0800877],
              [54.5341349, 30.094792],
              [54.53326, 30.1233052],
              [54.5332108, 30.1442119],
              [54.5323716, 30.1641326],
              [54.5314807, 30.1878518],
              [54.5313262, 30.2064161],
              [54.5307254, 30.2216952],
              [54.5315887, 30.2254789],
              [54.5332145, 30.225663],
              [54.5332989, 30.2346077],
              [54.5302962, 30.2377136],
              [54.5284079, 30.2458701],
              [54.5301245, 30.2587708],
              [54.5227429, 30.2679635],
              [54.4987105, 30.2778963],
              [54.4899557, 30.2764138],
              [54.480686, 30.2787857],
              [54.4755288, 30.2829881],
              [54.4530484, 30.2958324],
              [54.433479, 30.3118387],
              [54.4156262, 30.3287313],
              [54.3976017, 30.3429544],
              [54.3806073, 30.3687286],
              [54.3778607, 30.3799841],
              [54.3703076, 30.3933113],
              [54.4463903, 30.4554263],
              [54.4767376, 30.482409],
              [54.5285794, 30.5318068],
              [54.5504621, 30.5652224],
              [54.5594686, 30.5826324],
              [54.5630785, 30.5968009],
              [54.5653019, 30.6098594],
              [54.5655785, 30.6198588],
              [54.5645818, 30.6536253],
              [54.5610666, 30.6682962],
              [54.5592212, 30.6736115],
              [54.557805, 30.680772],
              [54.5581107, 30.6818697],
              [54.5573329, 30.6828757],
              [54.5546722, 30.6915117],
              [54.5529555, 30.7027299],
              [54.5534705, 30.7129137],
              [54.5526413, 30.7308434],
              [54.5507239, 30.768463],
              [54.5478915, 30.7852763],
              [54.5468356, 30.7964279],
              [54.5445441, 30.8046671],
              [54.5439122, 30.8290264],
              [54.5439122, 30.8312557],
              [54.539051, 30.8518373],
              [54.5366477, 30.8694464],
              [54.5407257, 30.8837669],
              [54.5406921, 30.8965921],
              [54.535319, 30.9186348],
              [54.5306041, 30.9325736],
              [54.5286324, 30.9415345],
              [54.5277, 30.9598502],
              [54.5278908, 30.9760685],
              [54.5270384, 30.9888376],
              [54.5272733, 30.9954896],
              [54.5266284, 31.0003865],
              [54.5270813, 31.0049979],
              [54.5274639, 31.0079228],
              [54.5274639, 31.0101665],
              [54.5268631, 31.014286],
              [54.5267527, 31.0183671],
              [54.5337229, 31.019933],
              [54.5388087, 31.0206682],
              [54.5577978, 31.0245661],
              [54.5772452, 31.0301462],
              [54.5805784, 31.0312565],
              [54.6128047, 31.0429187],
              [54.6405842, 31.0481993],
              [54.6414176, 31.0484792],
              [54.6430842, 31.0484791],
              [54.6450276, 31.0490298],
              [54.6530841, 31.05014],
              [54.6539175, 31.0504199],
              [54.655304, 31.0504199],
              [54.6664173, 31.0529203],
              [54.6683606, 31.0532001],
              [54.6803071, 31.0568107],
              [54.6819737, 31.0570905],
              [54.684197, 31.057921],
              [54.6894736, 31.0595909],
              [54.6969735, 31.0623712],
              [54.70892, 31.0657019],
              [54.7111399, 31.0657019],
              [54.7116966, 31.0659818],
              [54.7150299, 31.0659818],
              [54.7155171, 31.0658182],
              [54.7158632, 31.065702],
              [54.7163531, 31.065702],
              [54.7183632, 31.0657019],
              [54.7191134, 31.0655382],
              [54.7844789, 31.0512593],
              [54.7936455, 31.0495894],
              [54.7939631, 31.0495452],
              [54.8055886, 31.0479285],
              [54.8378149, 31.0426479],
              [54.8379752, 31.0426171],
              [54.8855942, 31.0334769],
              [54.8865356, 31.0333187],
              [54.9153171, 31.0284762],
              [54.9247636, 31.0273659],
              [54.9258736, 31.0273659],
              [54.9263823, 31.0272006],
              [54.9267069, 31.0270951],
              [54.9271744, 31.0270951],
              [54.9350401, 31.0270952],
              [54.93865, 31.027366],
              [54.9397634, 31.0276457],
              [54.9433733, 31.0276458],
              [54.9464299, 31.0281963],
              [54.9475399, 31.028756],
              [54.9480966, 31.0290358],
              [54.9489299, 31.0293066],
              [54.9489366, 31.0293134],
              [54.9492066, 31.0295865],
              [54.9514298, 31.0295864],
              [54.9564298, 31.0306967],
              [54.9650431, 31.0345871],
              [54.9653196, 31.034867],
              [55.0217122, 31.05626],
              [55.0386553, 31.0595908],
              [55.0397686, 31.0595908],
              [55.0406021, 31.0598706],
              [55.0425452, 31.0598706],
              [55.0544919, 31.0618113],
              [55.0556018, 31.0620912],
              [55.057545, 31.062371],
              [55.0678249, 31.0640319],
              [55.0767149, 31.0657017],
              [55.0978245, 31.068473],
              [55.1019911, 31.0693124],
              [55.1089377, 31.0701429],
              [55.1336606, 31.0723635],
              [55.1847733, 31.0843148],
              [55.1889399, 31.0851453],
              [55.2106096, 31.0912565],
              [55.2594988, 31.1081997],
              [55.2639455, 31.1101495],
              [55.2642221, 31.1104203],
              [55.2647789, 31.1107001],
              [55.2656121, 31.1112597],
              [55.2667221, 31.1118104],
              [55.2669987, 31.1120903],
              [55.2675555, 31.1120903],
              [55.2678321, 31.1123701],
              [55.2689456, 31.11237],
              [55.2692599, 31.1125291],
              [55.2694988, 31.1126499],
              [55.2708887, 31.1126499],
              [55.2750554, 31.114031],
              [55.2751511, 31.1141279],
              [55.2753319, 31.1143108],
              [55.2761653, 31.1143109],
              [55.2764454, 31.1145907],
              [55.2769986, 31.1148705],
              [55.2778319, 31.1151413],
              [55.2878352, 31.1176418],
              [55.2881119, 31.1179216],
              [55.2892217, 31.1179215],
              [55.3128348, 31.1262534],
              [55.3150581, 31.1270929],
              [55.325058, 31.1295934],
              [55.326168, 31.1295933],
              [55.3661709, 31.1420956],
              [55.3767273, 31.1445961],
              [55.399507, 31.1518177],
              [55.4195067, 31.1601496],
              [55.4247832, 31.1618105],
              [55.4431198, 31.1684815],
              [55.4595095, 31.1754234],
              [55.4600628, 31.1754233],
              [55.4606195, 31.1759831],
              [55.4850659, 31.1829248],
              [55.4878424, 31.1834846],
              [55.4886758, 31.1840352],
              [55.4917323, 31.1848657],
              [55.4925657, 31.1854254],
              [55.494789, 31.185976],
              [55.5000655, 31.1884855],
              [55.5056222, 31.190986],
              [55.5803478, 31.2309766],
              [55.5811811, 31.2315362],
              [55.5811812, 31.2318161],
              [55.6009042, 31.2437592],
              [55.6070141, 31.245709],
              [55.6364604, 31.2498707],
              [55.6489601, 31.2507102],
              [55.6686832, 31.2537614],
              [55.6711832, 31.2537614],
              [55.6781298, 31.2545919],
              [55.6847964, 31.2559821],
              [55.7181326, 31.2665441],
              [55.7195192, 31.2673747],
              [55.7400756, 31.2745965],
              [55.7550788, 31.2823692],
              [55.7556321, 31.282649],
              [55.7564654, 31.2829289],
              [55.7589654, 31.2840393],
              [55.7595221, 31.2845989],
              [55.7597987, 31.2848698],
              [55.7656319, 31.28793],
              [55.7659121, 31.2884807],
              [55.7728552, 31.2912612],
              [55.8203577, 31.3132071],
              [55.8231345, 31.3148681],
              [55.8298045, 31.318759],
              [55.8342477, 31.3209888],
              [55.8436909, 31.3245998],
              [55.8456376, 31.3251505],
              [55.9267531, 31.3673728],
              [55.9348064, 31.3732047],
              [55.9384197, 31.3768158],
              [55.9435367, 31.3874806],
              [55.9450862, 31.3907095],
              [55.9450862, 31.39182],
              [55.9461962, 31.395431],
              [55.9556427, 31.416818],
              [55.9556427, 31.4176575],
              [55.9564761, 31.4195986],
              [55.9592527, 31.4248709],
              [55.9639761, 31.4307118],
              [55.9656427, 31.4315425],
              [55.9670326, 31.4329328],
              [55.9964755, 31.4484878],
              [56.0128652, 31.4648737],
              [56.0178685, 31.4759872],
              [56.0181454, 31.4773774],
              [56.0195354, 31.4854305],
              [56.0195353, 31.4868207],
              [56.0198119, 31.4876514],
              [56.0200885, 31.490432],
              [56.0203686, 31.4926529],
              [56.0206451, 31.4954336],
              [56.0200885, 31.506818],
              [56.0198119, 31.5084883],
              [56.0200885, 31.5090389],
              [56.0206452, 31.5218228],
              [56.0209219, 31.5259847],
              [56.0212021, 31.5357171],
              [56.0214787, 31.5384888],
              [56.0217552, 31.5409896],
              [56.0220352, 31.5429306],
              [56.0223119, 31.5448808],
              [56.0239785, 31.5543243],
              [56.0259219, 31.5593169],
              [56.0289786, 31.5640478],
              [56.0292551, 31.5648783],
              [56.0350885, 31.5704307],
              [56.0420352, 31.5734913],
              [56.0489782, 31.5751525],
              [56.0525915, 31.5759921],
              [56.053425, 31.5759921],
              [56.0537016, 31.576272],
              [56.0567583, 31.5762721],
              [56.0581481, 31.5765429],
              [56.059222, 31.5765428],
              [56.0628098, 31.5786875],
              [56.0875442, 31.5856679],
              [56.0934911, 31.5873453],
              [56.0995661, 31.5867636],
              [56.1078044, 31.5886051],
              [56.1110169, 31.5900845],
              [56.1123872, 31.5907155],
              [56.1137004, 31.590709],
              [56.115575, 31.5908616],
              [56.1211953, 31.5906712],
              [56.1218783, 31.5905063],
              [56.1251592, 31.5897145],
              [56.1289493, 31.5878262],
              [56.1342837, 31.5851004],
              [56.1393405, 31.5806838],
              [56.14341, 31.5719498],
              [56.1469394, 31.566504],
              [56.1510771, 31.5601186],
              [56.1605022, 31.5526083],
              [56.1784286, 31.5483171],
              [56.1786707, 31.5483183],
              [56.2236759, 31.5590635],
              [56.2323858, 31.5596597],
              [56.2488428, 31.559294],
              [56.2548249, 31.5671193],
              [56.2581244, 31.5685967],
              [56.2611479, 31.574361],
              [56.2688126, 31.5921038],
              [56.2830354, 31.5980256],
              [56.3103174, 31.6081753],
              [56.3520302, 31.6229366],
              [56.3936885, 31.6368209],
              [56.4070477, 31.6407776],
              [56.4174349, 31.6449523],
              [56.4352572, 31.651652],
              [56.5092944, 31.6716453],
              [56.5625667, 31.6946365],
              [56.5697538, 31.6977379],
              [56.5745257, 31.7145876],
              [56.5767812, 31.7326539],
              [56.5767812, 31.737105],
              [56.5767813, 31.7373849],
              [56.5770579, 31.7376558],
              [56.5776696, 31.7418341],
              [56.5734863, 31.7479931],
              [56.5739791, 31.7628022],
              [56.5746875, 31.7799519],
              [56.5747233, 31.7912321],
              [56.5765857, 31.7981511],
              [56.5758717, 31.8088323],
              [56.57735, 31.8214695],
              [56.5788976, 31.8317329],
              [56.5808908, 31.8409051],
              [56.5834884, 31.8501584],
              [56.5841499, 31.8589685],
              [56.5874115, 31.8626855],
              [56.5877932, 31.868941],
              [56.5888899, 31.8784443],
              [56.5923063, 31.8956445],
              [56.5957012, 31.905348],
              [56.5994972, 31.9161222],
              [56.6023487, 31.92502],
              [56.6028945, 31.9312794],
              [56.6026178, 31.932381],
              [56.6012279, 31.9379428],
              [56.6001143, 31.9407148],
              [56.5998378, 31.9423851],
              [56.5992812, 31.9434957],
              [56.5981712, 31.9540507],
              [56.5984477, 31.9546105],
              [56.5987278, 31.9562718],
              [56.5990044, 31.9615538],
              [56.6003946, 31.9746098],
              [56.600671, 31.9754405],
              [56.6009479, 31.9762712],
              [56.6015045, 31.9810024],
              [56.6020611, 31.9834944],
              [56.6023377, 31.9857246],
              [56.6026178, 31.9879458],
              [56.6026178, 31.9887764],
              [56.6028946, 31.9893272],
              [56.6031712, 31.9904469],
              [56.5967812, 31.9996114],
              [56.6162278, 32.0329379],
              [56.6309509, 32.0518359],
              [56.6312274, 32.0523868],
              [56.6359507, 32.0576688],
              [56.6528972, 32.075998],
              [56.6545639, 32.0812801],
              [56.6534506, 32.0873839],
              [56.6373409, 32.1076725],
              [56.6334509, 32.1129457],
              [56.5912282, 32.1740559],
              [56.584005, 32.1835005],
              [56.5756719, 32.1915547],
              [56.5615019, 32.2093334],
              [56.544559, 32.2301732],
              [56.5437256, 32.2315637],
              [56.543169, 32.2318346],
              [56.5426123, 32.2326743],
              [56.542059, 32.2329451],
              [56.5276123, 32.2462816],
              [56.5273358, 32.2468414],
              [56.5262225, 32.2473922],
              [56.498723, 32.2757264],
              [56.4945564, 32.2801778],
              [56.4942798, 32.2809995],
              [56.4935382, 32.2817463],
              [56.4934463, 32.2818393],
              [56.4892799, 32.2848913],
              [56.4812232, 32.2898935],
              [56.4809432, 32.2904533],
              [56.4801098, 32.2907332],
              [56.4795566, 32.291284],
              [56.4164975, 32.3548962],
              [56.4098309, 32.3629505],
              [56.4006644, 32.3693433],
              [56.3820514, 32.3887837],
              [56.3756614, 32.3940659],
              [56.374828, 32.3948966],
              [56.3742714, 32.3951765],
              [56.3739947, 32.3954474],
              [56.3623284, 32.4057319],
              [56.3209389, 32.4551771],
              [56.3114923, 32.4668432],
              [56.3053824, 32.4771188],
              [56.3048258, 32.4782293],
              [56.2995458, 32.4837825],
              [56.2778796, 32.5124058],
              [56.2734363, 32.5190695],
              [56.2620465, 32.5376793],
              [56.2612131, 32.53851],
              [56.2487134, 32.5632326],
              [56.2403767, 32.5765691],
              [56.221487, 32.5937882],
              [56.2009307, 32.6082353],
              [56.1998208, 32.6093459],
              [56.1842642, 32.6187907],
              [56.1814876, 32.6201812],
              [56.1803743, 32.621012],
              [56.1684311, 32.6282355],
              [56.1350948, 32.6468451],
              [56.1131519, 32.6607324],
              [56.1117619, 32.6612922],
              [56.0856488, 32.6818432],
              [56.0821777, 32.6835651],
              [56.0531461, 32.6979606],
              [56.0512027, 32.6985114],
              [56.0384263, 32.7046244],
              [56.037593, 32.7051841],
              [56.0306465, 32.7087959],
              [56.0028669, 32.7221323],
              [55.9925902, 32.7276854],
              [55.9862003, 32.7318479],
              [55.9720338, 32.7396312],
              [55.9656441, 32.7415726],
              [55.9634205, 32.7424032],
              [55.9373075, 32.7482363],
              [55.9081413, 32.7501776],
              [55.9070314, 32.7504575],
              [55.8984181, 32.7504575],
              [55.885085, 32.7515771],
              [55.8814717, 32.7521279],
              [55.879805, 32.7526877],
              [55.8764718, 32.7532385],
              [55.8600821, 32.7593514],
              [55.857582, 32.760742],
              [55.8559154, 32.7612928],
              [55.8550821, 32.7615726],
              [55.8542487, 32.7618525],
              [55.8528621, 32.7621234],
              [55.852582, 32.7624034],
              [55.8517488, 32.7624033],
              [55.8511955, 32.7626833],
              [55.8506389, 32.7626833],
              [55.8503621, 32.7629632],
              [55.8492488, 32.7629632],
              [55.8359157, 32.7671257],
              [55.8314725, 32.7699067],
              [55.8298058, 32.7704666],
              [55.8278591, 32.771848],
              [55.8228593, 32.7740693],
              [55.8075795, 32.7874056],
              [55.806746, 32.7885162],
              [55.7823031, 32.8151888],
              [55.7489844, 32.8697151],
              [55.7392913, 32.8823339],
              [55.7274084, 32.8981241],
              [55.7151986, 32.9141661],
              [55.701419, 32.9313493],
              [55.6847125, 32.9535863],
              [55.6692694, 32.9741081],
              [55.6574364, 32.9939165],
              [55.6510998, 33.0038021],
              [55.6455683, 33.0132702],
              [55.6370818, 33.0273727],
              [55.6266717, 33.0440673],
              [55.6062022, 33.0779479],
              [55.6060428, 33.0782032],
              [55.5824758, 33.1159329],
              [55.5619681, 33.150082],
              [55.5260851, 33.2082013],
              [55.5168404, 33.2234986],
              [55.5046955, 33.2426785],
              [55.4849609, 33.2787612],
              [55.467747, 33.306446],
              [55.4455764, 33.3370295],
              [55.4342527, 33.3521776],
              [55.416872, 33.3758326],
              [55.4049914, 33.3824666],
              [55.4005725, 33.3740407],
              [55.3955167, 33.3680423],
              [55.3873936, 33.3577196],
              [55.3803388, 33.3635331],
              [55.3783955, 33.3635331],
              [55.3772855, 33.3632533],
              [55.3758955, 33.3632533],
              [55.3670056, 33.3604725],
              [55.364229, 33.3601927],
              [55.3622824, 33.359642],
              [55.3247828, 33.3546402],
              [55.3233929, 33.3540895],
              [55.2697803, 33.3435353],
              [55.2686668, 33.3429755],
              [55.260057, 33.3404747],
              [55.2592238, 33.3399239],
              [55.2542238, 33.3382537],
              [55.2328341, 33.3293606],
              [55.2281107, 33.3268597],
              [55.2247774, 33.3251985],
              [55.2225541, 33.324088],
              [55.1833846, 33.2985283],
              [55.176718, 33.2924159],
              [55.1758847, 33.2921451],
              [55.175608, 33.2918652],
              [55.1544949, 33.2757492],
              [55.1372718, 33.2610327],
              [55.1097723, 33.2407542],
              [55.1078256, 33.238804],
              [55.1044923, 33.2363121],
              [55.0772693, 33.2118624],
              [55.0333799, 33.1671339],
              [55.0272666, 33.15964],
              [55.01949, 33.1504757],
              [54.9917104, 33.1257457],
              [54.9906005, 33.1260256],
              [54.9617108, 33.1435235],
              [54.9547642, 33.1482546],
              [54.9128181, 33.1751877],
              [54.9011515, 33.1796389],
              [54.8997616, 33.1796389],
              [54.8994849, 33.1799188],
              [54.898095, 33.1799188],
              [54.8972616, 33.1801987],
              [54.8883717, 33.1765871],
              [54.8861518, 33.1751876],
              [54.8839285, 33.174357],
              [54.8786485, 33.171856],
              [54.8778152, 33.1715851],
              [54.8550795, 33.1376951],
              [54.8411749, 33.1352514],
              [54.8277853, 33.1348202],
              [54.8174856, 33.1261949],
              [54.8086194, 33.1139807],
              [54.8063461, 33.1022218],
              [54.8000977, 33.0953963],
              [54.7960527, 33.0964823],
              [54.7908196, 33.0959225],
              [54.782113, 33.0935632],
              [54.7781529, 33.0878231],
              [54.7741602, 33.0823169],
              [54.7753331, 33.0770338],
              [54.7774661, 33.0679934],
              [54.7795701, 33.0622749],
              [54.7739064, 33.0534423],
              [54.7691723, 33.0460375],
              [54.7612721, 33.032471],
              [54.7548798, 33.0214609],
              [54.7496749, 33.0123759],
              [54.7422767, 33.0021719],
              [54.7383736, 32.9981768],
              [54.7365568, 32.9848776],
              [54.7361835, 32.9572269],
              [54.6940695, 32.9610429],
              [54.6572322, 32.9657644],
              [54.6057953, 32.9684359],
              [54.579193, 32.9656023],
              [54.5480564, 32.9599288],
              [54.5165123, 32.9558958],
              [54.4735352, 32.9484705],
              [54.4406894, 32.9425643],
              [54.4087926, 32.9364832],
              [54.3850765, 32.9328258],
              [54.3626304, 32.928984],
              [54.3327468, 32.9234845],
              [54.3145738, 32.920106],
              [54.2882295, 32.9134001],
              [54.2721217, 32.9080346],
              [54.2550669, 32.9021926],
              [54.2492537, 32.8990505],
              [54.2346355, 32.8962496],
              [54.2224605, 32.8924583],
              [54.2042706, 32.8874055],
              [54.1712774, 32.8775683],
              [54.1587543, 32.873099],
              [54.1496147, 32.8703771],
              [54.1402981, 32.867061],
              [54.1246602, 32.8611662],
              [54.0617025, 32.8407625],
              [54.0342008, 32.8306916],
              [54.0199997, 32.8257447],
              [54.0169048, 32.8241738],
              [53.9957834, 32.8144697],
              [53.9853235, 32.8105343],
              [53.9711135, 32.8049274],
              [53.9560573, 32.7970349],
              [53.9455039, 32.7923077],
              [53.9240985, 32.7858955],
              [53.9120142, 32.7814909],
              [53.8934273, 32.774879],
              [53.863918, 32.7650104],
              [53.8265207, 32.7515759],
              [53.7899485, 32.7391591],
              [53.7542296, 32.727309],
              [53.7178873, 32.7171997],
              [53.6858148, 32.7043691],
              [53.6781414, 32.7007846],
              [53.6605212, 32.6925532],
              [53.6351481, 32.6817172],
              [53.6016339, 32.6666989],
              [53.5694176, 32.6525809],
              [53.5222356, 32.6306184],
              [53.4499578, 32.6024235],
              [53.4356975, 32.6090137],
              [53.4146493, 32.6162236],
              [53.3595666, 32.6375572],
              [53.3282276, 32.6491388],
              [53.3031672, 32.6543251],
              [53.278858, 32.6512261],
              [53.2499055, 32.6418765],
              [53.2347649, 32.6220997],
              [53.2170115, 32.6003287],
              [53.2119365, 32.5581462],
              [53.2096097, 32.528934],
              [53.1913374, 32.5222106],
              [53.1697869, 32.5242318],
              [53.1506558, 32.527841],
              [53.1307096, 32.53187],
              [53.1062633, 32.5325674],
              [53.0832767, 32.5283618],
              [53.0685137, 32.5408802],
              [53.0571411, 32.5396141],
              [53.0452482, 32.5375855],
              [53.0337632, 32.5358151],
              [53.0335999, 32.5356451],
              [53.0301046, 32.5325046],
              [53.0288172, 32.5310573],
              [53.0254268, 32.5286874],
              [53.0239032, 32.5273026],
              [53.0136286, 32.5177438],
              [53.0115161, 32.5143132],
              [53.0134234, 32.5072386],
              [53.0175159, 32.4993752],
              [53.0234098, 32.4823614],
              [53.0224441, 32.465347],
              [53.0220287, 32.4497819],
              [53.0218638, 32.4453502],
              [53.0228869, 32.4430735],
              [53.0233668, 32.4336572],
              [53.0245534, 32.4225924],
              [53.0250414, 32.4101267],
              [53.0257736, 32.3968515],
              [53.0270802, 32.3801167],
              [53.0276177, 32.3645667],
              [53.0278086, 32.350659],
              [53.0288684, 32.3390763],
              [53.0289769, 32.3300608],
              [53.0294693, 32.3212061],
              [53.0286336, 32.3099209],
              [53.0276669, 32.3022519],
              [53.0262539, 32.2890363],
              [53.0249294, 32.2749347],
              [53.029182, 32.2250781],
              [53.0298018, 32.2029296],
              [53.0312917, 32.1768898],
              [53.0323885, 32.1557259],
              [53.0340954, 32.1311409],
              [53.0354687, 32.1067157],
              [53.0419918, 32.0645378],
              [53.0440518, 32.0488252],
              [53.0404469, 32.0344196],
              [53.0522917, 32.0294716],
              [53.0511759, 32.0051102],
              [53.0473351, 32.0034361],
              [53.0452537, 32.0019621],
              [53.0349539, 31.9961391],
              [53.0341949, 31.9934593],
              [53.0251385, 31.9586496],
              [53.0224835, 31.9479982],
              [53.0159251, 31.9253995],
              [53.0112986, 31.9072903],
              [53.0045904, 31.8813453],
              [53.0003655, 31.8667867],
              [53.0030453, 31.8541591],
              [53.0063296, 31.8375455],
              [53.0089671, 31.827318],
              [53.0155486, 31.8121175],
              [53.0233334, 31.7921091],
              [53.0283699, 31.7797787],
              [53.0364983, 31.759848],
              [53.0409968, 31.7473041],
              [53.0474699, 31.7396576],
              [53.0612546, 31.7300913],
              [53.0757894, 31.72099],
              [53.0794026, 31.7179383],
              [53.0810692, 31.7171077],
              [53.0819026, 31.716268],
              [53.102459, 31.7046031],
              [53.1402385, 31.6804336],
              [53.1771847, 31.641268],
              [53.1802379, 31.6376566],
              [53.186908, 31.6279329],
              [53.1980177, 31.6134876],
              [53.203851, 31.5968212],
              [53.2035743, 31.5932098],
              [53.203419, 31.5918284],
              [53.2032943, 31.590718],
              [53.2035744, 31.5904381],
              [53.2035743, 31.5901582],
              [53.2029075, 31.5889258],
              [53.1944078, 31.573212],
              [53.1860746, 31.5679305],
              [53.1849612, 31.5676597],
              [53.1832945, 31.56682],
              [53.1355152, 31.5423805],
              [53.133572, 31.5418208],
              [53.1327387, 31.5412701],
              [53.130792, 31.5407103],
              [53.1291253, 31.5398798],
              [53.0913459, 31.5234936],
              [53.0832893, 31.5201532],
              [53.0596797, 31.5115403],
              [53.0574564, 31.5112694],
              [53.0524565, 31.5098792],
              [53.0113437, 31.5004267],
              [53.009397, 31.4995961],
              [53.0071771, 31.4993252],
              [53.0063438, 31.4987655],
              [52.9977306, 31.4962647],
              [52.9966206, 31.4962647],
              [52.9938406, 31.4954342],
              [52.987174, 31.4943237],
              [52.9852307, 31.4943237],
              [52.9843974, 31.4940438],
              [52.9824541, 31.4940439],
              [52.9793974, 31.4934931],
              [52.9774508, 31.4934932],
              [52.9460613, 31.4901527],
              [52.9410613, 31.4901527],
              [52.9385615, 31.4898728],
              [52.9360614, 31.4901527],
              [52.9227283, 31.4901527],
              [52.9213382, 31.4898729],
              [52.9016152, 31.4890422],
              [52.8927253, 31.4893221],
              [52.888282, 31.4893221],
              [52.8868921, 31.4896019],
              [52.8832821, 31.489602],
              [52.8807822, 31.4898728],
              [52.8727256, 31.4898728],
              [52.8716156, 31.4901527],
              [52.8585591, 31.4901526],
              [52.8577259, 31.4898728],
              [52.8535592, 31.4904326],
              [52.849946, 31.4904325],
              [52.8491126, 31.4907124],
              [52.8418894, 31.4912631],
              [52.8368894, 31.4912631],
              [52.8360562, 31.491543],
              [52.8330028, 31.491543],
              [52.8321695, 31.4918229],
              [52.8307796, 31.4918228],
              [52.829113, 31.4921027],
              [52.8132799, 31.4932132],
              [52.8077232, 31.4943236],
              [52.8060565, 31.4943236],
              [52.8057765, 31.4946034],
              [52.8010566, 31.4948743]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 3385992,
        "tags": {
          "ISO3166-2": "IR-22",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "هرمزگان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q633659"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [52.482398, 26.989407],
              [52.6792243, 26.8715402],
              [52.8757597, 26.753725],
              [52.9477745, 26.7105243],
              [53.0913411, 26.6243518],
              [53.1282214, 26.6061774],
              [53.4031013, 26.4987712],
              [53.8207246, 26.3353974],
              [53.849842, 26.3222684],
              [53.8721513, 26.3160149],
              [53.8865706, 26.310408],
              [53.9313845, 26.2993223],
              [53.9642391, 26.2946269],
              [54.2235447, 26.0576023],
              [54.2297691, 26.0410041],
              [54.2375385, 26.0250214],
              [54.2468543, 26.0096503],
              [54.2575724, 25.9951275],
              [54.2696951, 25.9814492],
              [54.275906, 25.9467903],
              [54.2729859, 25.8995289],
              [54.2778793, 25.8768174],
              [54.2860221, 25.8528901],
              [54.296753, 25.8296844],
              [54.3101781, 25.8076861],
              [54.3260118, 25.7870329],
              [54.3441077, 25.7679515],
              [54.3642839, 25.7506226],
              [54.3863527, 25.735296],
              [54.4100443, 25.7220685],
              [54.4351214, 25.7111078],
              [54.4613158, 25.7025255],
              [54.4708746, 25.700382],
              [54.4883627, 25.6965272],
              [54.5159429, 25.6928202],
              [54.5436524, 25.6918282],
              [54.5716023, 25.6934357],
              [54.58534, 25.6955214],
              [54.5990909, 25.6975881],
              [54.6190637, 25.7026044],
              [54.6258258, 25.7042635],
              [54.6519252, 25.7134028],
              [54.6767096, 25.7248928],
              [54.7000503, 25.7386164],
              [54.7217009, 25.7544272],
              [54.7414318, 25.7721568],
              [54.7590341, 25.7916165],
              [54.7743209, 25.8125993],
              [54.7871304, 25.8348818],
              [54.7973266, 25.8582273],
              [54.8048017, 25.8823877],
              [54.8087095, 25.8996273],
              [54.8076138, 25.8774522],
              [54.8091753, 25.8552956],
              [54.8133758, 25.8334146],
              [54.8201666, 25.812063],
              [54.829469, 25.7914891],
              [54.841175, 25.7719318],
              [54.855149, 25.7536187],
              [54.8712287, 25.7367627],
              [54.8957331, 25.7157681],
              [54.9239689, 25.6989095],
              [54.954653, 25.6859813],
              [54.9871159, 25.6772667],
              [55.0206491, 25.6729569],
              [55.0545208, 25.6731464],
              [55.0879921, 25.677831],
              [55.1203324, 25.6869081],
              [55.150836, 25.7001786],
              [55.1788374, 25.7173514],
              [55.2037254, 25.7380504],
              [55.224957, 25.761822],
              [55.2420689, 25.788146],
              [55.2546876, 25.8164463],
              [55.2625378, 25.8461041],
              [55.2654482, 25.8764716],
              [55.2637304, 25.9069312],
              [55.2591225, 25.9287322],
              [55.2519346, 25.9499572],
              [55.2422501, 25.9703603],
              [55.2301812, 25.9897054],
              [55.215868, 26.0077687],
              [55.1994765, 26.0243412],
              [55.1811969, 26.0392315],
              [55.1788651, 26.0409943],
              [55.1612411, 26.0522674],
              [55.1504174, 26.0578601],
              [55.1519953, 26.0576683],
              [55.18293, 26.0587404],
              [55.2132042, 26.0645704],
              [55.2276063, 26.0697747],
              [55.2305856, 26.070854],
              [55.2305889, 26.0708541],
              [55.2364483, 26.0687437],
              [55.262387, 26.0617678],
              [55.2890603, 26.0575868],
              [55.3160963, 26.0562592],
              [55.3431179, 26.0578037],
              [55.3697486, 26.0621986],
              [55.3956169, 26.0693824],
              [55.4203623, 26.0792544],
              [55.452337, 26.0972343],
              [55.4805966, 26.1196753],
              [55.5043764, 26.1459677],
              [55.5183109, 26.1668057],
              [55.5294118, 26.1889687],
              [55.5375243, 26.2121469],
              [55.5425355, 26.2360167],
              [55.5443754, 26.260245],
              [55.5430183, 26.2844938],
              [55.5430188, 26.2844948],
              [55.7282468, 26.3367641],
              [55.9322062, 26.4183004],
              [55.9601773, 26.4301178],
              [56.1340243, 26.5034653],
              [56.1431226, 26.5180653],
              [56.1736781, 26.5472319],
              [56.2417336, 26.5902874],
              [56.2750669, 26.5930651],
              [56.298146, 26.6033906],
              [56.3278446, 26.6166762],
              [56.5462498, 26.7026737],
              [56.5500665, 26.7041759],
              [56.6833996, 26.7375091],
              [56.7333995, 26.6930647],
              [56.7542328, 26.6611203],
              [56.7958993, 26.5875094],
              [56.7917325, 26.420843],
              [56.8014547, 26.3666764],
              [56.797288, 26.2750099],
              [56.8000657, 26.1930656],
              [56.8375656, 26.0513992],
              [56.9740812, 25.9318997],
              [57.0020189, 25.9007986],
              [57.0091291, 25.8924765],
              [57.0563963, 25.8314821],
              [57.0773002, 25.7760651],
              [57.0835873, 25.7454101],
              [57.0959893, 25.7129881],
              [57.1125809, 25.685279],
              [57.146293, 25.6475882],
              [57.1858621, 25.6190402],
              [57.2168101, 25.6039768],
              [57.2380265, 25.5962327],
              [57.2561872, 25.5909346],
              [57.2826351, 25.585335],
              [57.2966522, 25.583358],
              [57.4990268, 25.5121635],
              [57.6780601, 25.4491451],
              [57.7013035, 25.4422427],
              [57.9250327, 25.3877415],
              [58.031375, 25.3618275],
              [58.0529943, 25.3575735],
              [58.632055, 25.2688666],
              [58.8229909, 25.2396028],
              [59.0569858, 25.2037298],
              [59.0921639, 25.2008219],
              [59.2187761, 25.1994033],
              [59.2211109, 25.4393893],
              [59.2190376, 25.4581693],
              [59.2179907, 25.4676514],
              [59.2160527, 25.4903082],
              [59.214939, 25.4997473],
              [59.2149391, 25.5008587],
              [59.2146593, 25.5041934],
              [59.2146594, 25.5047492],
              [59.2146594, 25.51253],
              [59.2141059, 25.5208578],
              [59.2107727, 25.5547533],
              [59.2104926, 25.5578014],
              [59.2107727, 25.5580794],
              [59.2110528, 25.5603027],
              [59.2113263, 25.5622481],
              [59.2116059, 25.5636377],
              [59.213826, 25.5741987],
              [59.214106, 25.5747456],
              [59.214106, 25.5753105],
              [59.2193862, 25.5897539],
              [59.2199394, 25.5905877],
              [59.2202195, 25.5922553],
              [59.2343858, 25.6291952],
              [59.2349393, 25.6314189],
              [59.2352194, 25.6322528],
              [59.2354995, 25.6341986],
              [59.2357725, 25.6367001],
              [59.2354994, 25.6386369],
              [59.2352194, 25.6391929],
              [59.2291061, 25.6519704],
              [59.2250633, 25.6579294],
              [59.2246821, 25.6589755],
              [59.2195189, 25.6651134],
              [59.2173512, 25.6721304],
              [59.2135342, 25.6861947],
              [59.2114768, 25.6930796],
              [59.2118864, 25.6972546],
              [59.212993, 25.7011465],
              [59.2148563, 25.704146],
              [59.2054938, 25.7285449],
              [59.1922065, 25.7401151],
              [59.1682309, 25.7614647],
              [59.157801, 25.7739415],
              [59.1413352, 25.7940185],
              [59.1370165, 25.7995248],
              [59.1319644, 25.8067884],
              [59.1462706, 25.8076186],
              [59.1406917, 25.8134909],
              [59.1332391, 25.8195511],
              [59.1289544, 25.8215262],
              [59.1253889, 25.8232983],
              [59.1229892, 25.8244621],
              [59.120779, 25.8249064],
              [59.1173672, 25.8259493],
              [59.1152074, 25.8269102],
              [59.1135798, 25.8283297],
              [59.1132903, 25.8301598],
              [59.1127766, 25.8316574],
              [59.1117132, 25.8332886],
              [59.1103506, 25.8340515],
              [59.1092348, 25.8345923],
              [59.1055226, 25.8361276],
              [59.1029692, 25.8365429],
              [59.0994121, 25.8368527],
              [59.0979266, 25.8377499],
              [59.0954255, 25.8399529],
              [59.094287, 25.841553],
              [59.0820694, 25.8522721],
              [59.0806738, 25.8539944],
              [59.0799536, 25.8561418],
              [59.0795968, 25.8591298],
              [59.0797935, 25.8609299],
              [59.0803062, 25.8630387],
              [59.0800761, 25.8737417],
              [59.0798772, 25.8787394],
              [59.0804827, 25.8806697],
              [59.0803743, 25.8825462],
              [59.0796244, 25.8846932],
              [59.0771579, 25.8888789],
              [59.07516, 25.8891489],
              [59.0744166, 25.8907072],
              [59.0732783, 25.8920119],
              [59.0717585, 25.8926682],
              [59.0696329, 25.8950698],
              [59.0687139, 25.8968842],
              [59.0619377, 25.8985135],
              [59.0480356, 25.9074309],
              [59.0373115, 25.9140783],
              [59.0270591, 25.9203993],
              [59.0037834, 25.9204774],
              [58.9995968, 25.9377711],
              [58.9984263, 25.9419313],
              [59.0020024, 25.9465741],
              [59.0165078, 25.9658544],
              [59.0236051, 25.9749856],
              [59.0389425, 25.984685],
              [59.0519113, 25.989059],
              [59.0629429, 25.9898172],
              [59.0761548, 25.9905973],
              [59.0171417, 26.0614667],
              [58.9970349, 26.0690051],
              [58.9967549, 26.06984],
              [58.9928685, 26.076231],
              [58.9996716, 26.08423],
              [59.0120312, 26.0882385],
              [59.0158078, 26.0953302],
              [59.0079113, 26.1033464],
              [59.0140911, 26.1249258],
              [59.0244902, 26.1402065],
              [59.0239371, 26.141041],
              [59.0225504, 26.1488218],
              [59.0228238, 26.1507603],
              [59.0158078, 26.167148],
              [59.0204376, 26.190304],
              [59.0207177, 26.1905732],
              [59.0209907, 26.1925205],
              [59.0212708, 26.195024],
              [59.0134911, 26.2025171],
              [59.0104378, 26.2064117],
              [59.0101578, 26.2072463],
              [59.0098777, 26.2075154],
              [59.0092034, 26.2080916],
              [58.9377861, 26.2270727],
              [58.9377861, 26.2279077],
              [58.9380595, 26.2292993],
              [58.8523861, 26.2318386],
              [58.8173672, 26.2429249],
              [58.8238903, 26.2823339],
              [58.8527295, 26.3091121],
              [58.8712689, 26.3269608],
              [58.8807599, 26.3542345],
              [58.7974023, 26.4444295],
              [58.7971288, 26.4449823],
              [58.7971223, 26.4449954],
              [58.7971027, 26.4449954],
              [58.7965691, 26.4449955],
              [58.7961098, 26.4452267],
              [58.796016, 26.4452739],
              [58.7937571, 26.4456785],
              [58.7929557, 26.445822],
              [58.690477, 26.5367166],
              [58.6543643, 26.5544919],
              [58.6451978, 26.5586596],
              [58.6138147, 26.5947723],
              [58.5949285, 26.6094943],
              [58.535193, 26.6417146],
              [58.5138911, 26.6686058],
              [58.5001937, 26.6858879],
              [58.4978269, 26.6801935],
              [58.4969936, 26.6807506],
              [58.486994, 26.6882538],
              [58.4861603, 26.688811],
              [58.4591998, 26.6525887],
              [58.3269843, 26.7299323],
              [58.3247573, 26.7307681],
              [58.3129238, 26.7341797],
              [58.3122579, 26.7343716],
              [58.3113287, 26.7343716],
              [58.310591, 26.7343716],
              [58.3105061, 26.7344583],
              [58.3103181, 26.7346503],
              [58.3092759, 26.7346503],
              [58.3089243, 26.7346503],
              [58.308665, 26.734737],
              [58.308091, 26.7349288],
              [58.3067316, 26.7349289],
              [58.3067047, 26.7349289],
              [58.2945503, 26.737523],
              [58.2936514, 26.7377148],
              [58.2922579, 26.7377148],
              [58.2892047, 26.738272],
              [58.2874179, 26.738272],
              [58.2872582, 26.738272],
              [58.2865604, 26.7384466],
              [58.286145, 26.7385505],
              [58.2603117, 26.74299],
              [58.2555921, 26.7438258],
              [58.2547463, 26.7438258],
              [58.2542054, 26.7438258],
              [58.2540302, 26.7439129],
              [58.2536453, 26.7441043],
              [58.252842, 26.7441044],
              [58.252812, 26.7441044],
              [58.2248295, 26.7500809],
              [58.224199, 26.7502155],
              [58.2169794, 26.7515995],
              [58.2153012, 26.7515996],
              [58.2147595, 26.7515996],
              [58.2145837, 26.7516869],
              [58.2141992, 26.7518781],
              [58.2134473, 26.751878],
              [58.213093, 26.751878],
              [58.2128312, 26.7519656],
              [58.2122594, 26.7521568],
              [58.2106673, 26.7521567],
              [58.2103129, 26.7521567],
              [58.2100513, 26.7522442],
              [58.2094797, 26.7524352],
              [58.2087206, 26.7524353],
              [58.2083659, 26.7524353],
              [58.2081043, 26.7525229],
              [58.2075328, 26.752714],
              [58.2053872, 26.7527139],
              [58.2050327, 26.7527139],
              [58.2047709, 26.7528014],
              [58.2041995, 26.7529924],
              [58.2025214, 26.7529925],
              [58.2019795, 26.7529925],
              [58.2018035, 26.75308],
              [58.2014193, 26.7532711],
              [58.2006676, 26.7532712],
              [58.200313, 26.7532712],
              [58.2000512, 26.7533587],
              [58.1994795, 26.7535497],
              [58.198913, 26.7535497],
              [58.1983662, 26.7535497],
              [58.1981922, 26.7536373],
              [58.197813, 26.7538283],
              [58.1972464, 26.7538284],
              [58.1966997, 26.7538284],
              [58.1965258, 26.7539159],
              [58.1961462, 26.7541069],
              [58.1955799, 26.7541069],
              [58.1950329, 26.7541069],
              [58.1948591, 26.7541945],
              [58.1944799, 26.7543856],
              [58.1936466, 26.7543856],
              [58.1911465, 26.7546641],
              [58.1396008, 26.7747972],
              [58.1394139, 26.7749877],
              [58.138937, 26.7749877],
              [58.1385806, 26.7749877],
              [58.1369141, 26.7755447],
              [58.1263542, 26.783039],
              [58.1241342, 26.7855372],
              [58.1235807, 26.7855372],
              [58.1235807, 26.7858157],
              [58.1202475, 26.78888],
              [58.116354, 26.791378],
              [58.0694084, 26.8310979],
              [58.0627419, 26.8349893],
              [58.0562282, 26.8367405],
              [58.055522, 26.8369303],
              [58.0551448, 26.8369303],
              [58.0544086, 26.8369304],
              [58.0543194, 26.8370191],
              [58.0541285, 26.8372089],
              [58.049962, 26.8372089],
              [58.0457956, 26.8374876],
              [58.0445787, 26.8374876],
              [58.0444088, 26.8374875],
              [58.0399622, 26.838602],
              [58.034129, 26.8408217],
              [58.0327426, 26.8416575],
              [58.0280155, 26.8436076],
              [58.005516, 26.8560995],
              [58.0046828, 26.8569353],
              [58.0019097, 26.8585979],
              [57.9763499, 26.8819379],
              [57.9738499, 26.8847151],
              [57.9732968, 26.8849937],
              [57.9140571, 26.9236655],
              [57.9108088, 26.9236655],
              [57.9104437, 26.9236655],
              [57.9101735, 26.9237558],
              [57.9096104, 26.9239441],
              [57.9076635, 26.9239442],
              [57.9062772, 26.9242228],
              [57.8931723, 26.9224626],
              [57.8522735, 26.9342066],
              [57.8398415, 26.9388288],
              [57.8247564, 26.9455638],
              [57.8043826, 26.9547373],
              [57.7678296, 26.9710379],
              [57.7489197, 26.9866903],
              [57.7350361, 27.0004818],
              [57.7158199, 27.0086424],
              [57.6952125, 27.0233273],
              [57.6742685, 27.0392305],
              [57.653275, 27.0447196],
              [57.6271987, 27.0484421],
              [57.6070612, 27.0545364],
              [57.5798605, 27.0612661],
              [57.5693892, 27.0643234],
              [57.5582311, 27.0672278],
              [57.5378035, 27.0721192],
              [57.5153158, 27.0886261],
              [57.5111783, 27.1003336],
              [57.504501, 27.115674],
              [57.4992656, 27.1205631],
              [57.4967765, 27.1262161],
              [57.4952315, 27.1318688],
              [57.4948024, 27.1358408],
              [57.4929141, 27.1465339],
              [57.4926566, 27.1526438],
              [57.4918841, 27.1605098],
              [57.490425, 27.1653208],
              [57.4869442, 27.1785271],
              [57.4837435, 27.1920264],
              [57.4796104, 27.2100605],
              [57.4654287, 27.2295862],
              [57.4653622, 27.2479152],
              [57.4772505, 27.2672613],
              [57.4420162, 27.2898757],
              [57.4193717, 27.3208861],
              [57.4134204, 27.3286425],
              [57.4024434, 27.3420127],
              [57.3922686, 27.349494],
              [57.3621081, 27.3776363],
              [57.3462295, 27.3880013],
              [57.3386764, 27.394098],
              [57.3309801, 27.4060738],
              [57.3318088, 27.4101936],
              [57.3309684, 27.4193102],
              [57.3322785, 27.4360582],
              [57.3317384, 27.462383],
              [57.3282972, 27.4853745],
              [57.333269, 27.4990597],
              [57.3438262, 27.540088],
              [57.3400496, 27.5661889],
              [57.3353897, 27.5721441],
              [57.3275184, 27.5795794],
              [57.3175619, 27.5810249],
              [57.3082923, 27.5833071],
              [57.3046015, 27.5885563],
              [57.2803114, 27.5846765],
              [57.2554205, 27.5877195],
              [57.2497557, 27.5895452],
              [57.237819, 27.5882338],
              [57.2336196, 27.5945656],
              [57.2302418, 27.6016704],
              [57.2220322, 27.6201215],
              [57.223663, 27.6322127],
              [57.2349068, 27.6351022],
              [57.2404858, 27.6395124],
              [57.2442624, 27.6490925],
              [57.2487635, 27.65822],
              [57.2526311, 27.6573791],
              [57.2716856, 27.6596218],
              [57.280097, 27.6621305],
              [57.28328, 27.666732],
              [57.2831942, 27.6720788],
              [57.2814528, 27.6785314],
              [57.2760122, 27.6839315],
              [57.2749042, 27.6893424],
              [57.2741651, 27.694163],
              [57.2811283, 27.6969481],
              [57.2839161, 27.7024521],
              [57.2837229, 27.7085858],
              [57.2834247, 27.7158554],
              [57.2850804, 27.7148039],
              [57.3213383, 27.70268],
              [57.3409077, 27.6999443],
              [57.3560305, 27.7035217],
              [57.3919178, 27.7349036],
              [57.4004185, 27.7478263],
              [57.4013947, 27.7760793],
              [57.4170398, 27.7721904],
              [57.4302529, 27.7730101],
              [57.4510801, 27.7773089],
              [57.4665963, 27.7828675],
              [57.4747004, 27.7910374],
              [57.43931, 27.8030586],
              [57.4328698, 27.8057087],
              [57.43922, 27.8130143],
              [57.4185002, 27.8218092],
              [57.4157472, 27.8222343],
              [57.4148869, 27.8223671],
              [57.4143294, 27.8227402],
              [57.4140533, 27.8229249],
              [57.4134884, 27.8229249],
              [57.41294, 27.8229249],
              [57.4076668, 27.8254264],
              [57.3593729, 27.8929261],
              [57.3593543, 27.8929261],
              [57.3588814, 27.8930208],
              [57.357961, 27.8932051],
              [57.286306, 27.9709021],
              [57.2860806, 27.9709302],
              [57.2796908, 27.9723154],
              [57.2738875, 27.9801011],
              [57.2722209, 27.9806587],
              [57.271111, 27.9814862],
              [57.2446057, 27.9395173],
              [57.2329327, 27.9122163],
              [57.2216031, 27.8882464],
              [57.1862099, 27.8947272],
              [57.1742245, 27.9040247],
              [57.1442107, 27.9390861],
              [57.0222111, 27.9250553],
              [57.0253859, 28.0197302],
              [57.0256624, 28.0202886],
              [57.0256625, 28.0269533],
              [57.0256625, 28.0291779],
              [57.0259393, 28.0300154],
              [57.0262191, 28.0325103],
              [57.0264959, 28.0350142],
              [57.0270526, 28.0405711],
              [57.0273291, 28.043075],
              [57.0276058, 28.0464075],
              [57.0165564, 28.1055804],
              [57.0159996, 28.1286355],
              [57.0127131, 28.1408168],
              [57.0127131, 28.1474795],
              [57.0124365, 28.1483168],
              [57.0124366, 28.148587],
              [57.0118798, 28.1547005],
              [57.0152165, 28.1796602],
              [57.015493, 28.1804887],
              [57.0112432, 28.19061],
              [56.9906437, 28.2412046],
              [56.9903672, 28.2450933],
              [56.989254, 28.2520427],
              [56.9884205, 28.2548154],
              [56.9851683, 28.2696097],
              [56.9778641, 28.2753669],
              [56.9698153, 28.2779674],
              [56.9692542, 28.2781486],
              [56.9609211, 28.2781486],
              [56.9165727, 28.2651846],
              [56.9113761, 28.2653659],
              [56.8981506, 28.2643585],
              [56.8608333, 28.2589378],
              [56.8509879, 28.2590432],
              [56.8408339, 28.260064],
              [56.8348468, 28.2608344],
              [56.8287789, 28.2605698],
              [56.8245136, 28.260721],
              [56.8187706, 28.2621044],
              [56.8118786, 28.2646289],
              [56.8097154, 28.2655557],
              [56.8021203, 28.2698647],
              [56.7982542, 28.2717545],
              [56.7925219, 28.274196],
              [56.7807667, 28.2801686],
              [56.7784161, 28.2814666],
              [56.7743371, 28.2794017],
              [56.7109106, 28.2690087],
              [56.7012976, 28.2640194],
              [56.6873004, 28.235421],
              [56.6842437, 28.231252],
              [56.6831337, 28.2301446],
              [56.6269392, 28.1568534],
              [56.6266592, 28.1565834],
              [56.6214277, 28.1565834],
              [56.5761785, 28.1392472],
              [56.5759433, 28.1392472],
              [56.5755412, 28.1393484],
              [56.5748333, 28.1395264],
              [56.5724648, 28.1395264],
              [56.5720534, 28.1395264],
              [56.5717516, 28.1396274],
              [56.57122, 28.1398054],
              [56.5662201, 28.1398055],
              [56.565667, 28.1395264],
              [56.5628869, 28.1395264],
              [56.5617769, 28.1392473],
              [56.551777, 28.1392473],
              [56.5506637, 28.1389682],
              [56.5481637, 28.1389681],
              [56.5339973, 28.1370324],
              [56.5245508, 28.1353576],
              [56.5239975, 28.1353576],
              [56.5184409, 28.1342502],
              [56.505941, 28.1334218],
              [56.5051076, 28.1331338],
              [56.5006611, 28.1331338],
              [56.4989945, 28.1328547],
              [56.4942747, 28.1328546],
              [56.489828, 28.1325846],
              [56.4881612, 28.1323054],
              [56.4809381, 28.1323054],
              [56.4792715, 28.1320263],
              [56.4767715, 28.1320263],
              [56.4751048, 28.1317472],
              [56.4695516, 28.1317472],
              [56.467605, 28.1320263],
              [56.445382, 28.1309189],
              [56.4445487, 28.1306398],
              [56.4345487, 28.1306398],
              [56.4294772, 28.1358345],
              [56.4292733, 28.1359367],
              [56.4289207, 28.1361135],
              [56.4219773, 28.1361136],
              [56.4214207, 28.1358345],
              [56.4166974, 28.1358344],
              [56.4158641, 28.1358345],
              [56.4153075, 28.1358344],
              [56.4090808, 28.1424948],
              [56.4088043, 28.1422158],
              [56.4035276, 28.1422158],
              [56.402971, 28.1419367],
              [56.3763695, 28.1480976],
              [56.3294399, 28.1574376],
              [56.3288702, 28.1575509],
              [56.3280603, 28.1576865],
              [56.3272036, 28.1578299],
              [56.3249803, 28.1586583],
              [56.3197003, 28.1603238],
              [56.2935471, 28.1672527],
              [56.2931644, 28.1674043],
              [56.2704908, 28.1750228],
              [56.2574344, 28.1794707],
              [56.2399346, 28.1861335],
              [56.235768, 28.1883575],
              [56.1743757, 28.2172423],
              [56.1624326, 28.225022],
              [56.1585859, 28.2280978],
              [56.1582659, 28.2283536],
              [56.1582659, 28.2286327],
              [56.1579859, 28.2291909],
              [56.1522554, 28.2634671],
              [56.0943736, 28.3003012],
              [56.0941882, 28.3006694],
              [56.0849272, 28.3305769],
              [56.084374, 28.3316846],
              [56.0840938, 28.3330715],
              [56.0829838, 28.3361334],
              [56.0574179, 28.3879817],
              [56.057558, 28.3882609],
              [56.057698, 28.3885401],
              [56.0576979, 28.3888102],
              [56.0097628, 28.3903234],
              [56.0097627, 28.3922599],
              [56.0097627, 28.4011495],
              [55.9908468, 28.4428285],
              [55.9911267, 28.4439365],
              [55.9914033, 28.4481069],
              [55.9940832, 28.4914661],
              [55.9935298, 28.501182],
              [55.99325, 28.5020194],
              [55.9929732, 28.5053421],
              [55.9929732, 28.5084036],
              [55.9932499, 28.509232],
              [55.9849545, 28.513953],
              [55.9318118, 28.5109291],
              [55.9173199, 28.5193831],
              [55.9108692, 28.5310071],
              [55.9111459, 28.5321148],
              [55.9114258, 28.5346184],
              [55.9117025, 28.5368429],
              [55.9228131, 28.5582903],
              [55.9777447, 28.5679395],
              [55.9973141, 28.5643212],
              [56.0240933, 28.5809042],
              [56.0601146, 28.5840709],
              [56.0601147, 28.5860157],
              [56.0601146, 28.5865649],
              [56.0603948, 28.5871231],
              [56.0603948, 28.5874023],
              [56.0603948, 28.5876813],
              [56.0603947, 28.591841],
              [56.0606715, 28.5921201],
              [56.065478, 28.6087548],
              [56.0652012, 28.6095922],
              [56.065478, 28.6101414],
              [56.0623848, 28.6423097],
              [56.0652084, 28.6698105],
              [56.0654849, 28.6817578],
              [56.0654849, 28.6917591],
              [56.0657615, 28.6928674],
              [56.0660416, 28.6967598],
              [56.058422, 28.7042569],
              [56.0586985, 28.7092666],
              [56.0589786, 28.7139878],
              [56.059532, 28.7209256],
              [56.0598118, 28.7231511],
              [56.0603652, 28.7298187],
              [56.0617385, 28.7360685],
              [56.048641, 28.7571255],
              [56.0433048, 28.7889229],
              [56.0202477, 28.7907338],
              [56.0022923, 28.787821],
              [55.9639476, 28.7734311],
              [55.9556007, 28.7699915],
              [55.9394645, 28.7607371],
              [55.919592, 28.748515],
              [55.9165925, 28.7386404],
              [55.8352658, 28.7050432],
              [55.8218764, 28.6996978],
              [55.8159541, 28.7017305],
              [55.8081435, 28.7003753],
              [55.8035945, 28.6957828],
              [55.802221, 28.6894585],
              [55.7477185, 28.6601652],
              [55.7326123, 28.6592614],
              [55.6970633, 28.6630073],
              [55.6553341, 28.6716112],
              [55.6353645, 28.6809486],
              [55.6151585, 28.6860689],
              [55.5960687, 28.6923716],
              [55.5716628, 28.7044829],
              [55.5437848, 28.7200985],
              [55.529941, 28.7287216],
              [55.5173538, 28.7379407],
              [55.5011195, 28.7500734],
              [55.298679, 28.7494706],
              [55.268696, 28.7510634],
              [55.2533242, 28.7136208],
              [55.2766796, 28.7077533],
              [55.3192517, 28.6866727],
              [55.3580471, 28.6571526],
              [55.3864085, 28.6331452],
              [55.3953348, 28.6226288],
              [55.4122921, 28.602609],
              [55.4292614, 28.5810506],
              [55.4468744, 28.5540597],
              [55.452376, 28.5455311],
              [55.4550727, 28.5396106],
              [55.4555208, 28.5357712],
              [55.4509443, 28.5224757],
              [55.4503494, 28.519271],
              [55.447091, 28.5125824],
              [55.4454192, 28.4870358],
              [55.4346963, 28.4794844],
              [55.4272431, 28.4721142],
              [55.4188764, 28.4656572],
              [55.4150999, 28.4623823],
              [55.4109, 28.459721],
              [55.4084966, 28.4567477],
              [55.4079734, 28.4403444],
              [55.4078933, 28.4329923],
              [55.4089483, 28.4253702],
              [55.4086717, 28.4234246],
              [55.4083916, 28.4203623],
              [55.4078383, 28.4184168],
              [55.4072816, 28.3970344],
              [55.407005, 28.3948097],
              [55.406725, 28.3925941],
              [55.4064482, 28.3881447],
              [55.4061716, 28.3878656],
              [55.4064482, 28.3861993],
              [55.4070051, 28.380363],
              [55.407005, 28.362305],
              [55.4067249, 28.3603686],
              [55.4050583, 28.3542533],
              [55.4047817, 28.3520288],
              [55.4081148, 28.3186973],
              [55.4078383, 28.318139],
              [55.4081148, 28.3175896],
              [55.4083915, 28.3156443],
              [55.4081148, 28.3153652],
              [55.4083915, 28.3142484],
              [55.4083915, 28.3125823],
              [55.4086716, 28.3100877],
              [55.4083915, 28.3098085],
              [55.4086716, 28.308971],
              [55.4083916, 28.3086918],
              [55.4086716, 28.3081425],
              [55.4083915, 28.3078633],
              [55.4083915, 28.3073049],
              [55.4083915, 28.3064764],
              [55.4078383, 28.3036936],
              [55.4075582, 28.3017574],
              [55.4064482, 28.2961919],
              [55.4058916, 28.2864749],
              [55.4056149, 28.2856464],
              [55.4058916, 28.2831428],
              [55.4056149, 28.2825845],
              [55.4058915, 28.2792524],
              [55.4056149, 28.2761996],
              [55.4053383, 28.2745336],
              [55.4050582, 28.2723093],
              [55.4047815, 28.2698058],
              [55.404505, 28.2678696],
              [55.4077081, 28.2644478],
              [55.4074315, 28.2624938],
              [55.4063214, 28.2580545],
              [55.4057648, 28.2541644],
              [55.4054881, 28.2511119],
              [55.4052081, 28.2505536],
              [55.420281, 28.2160923],
              [55.4200043, 28.2152549],
              [55.4189847, 28.2136825],
              [55.4188911, 28.2135891],
              [55.4120246, 28.1899858],
              [55.4095246, 28.1777662],
              [55.4092481, 28.1749929],
              [55.4089713, 28.1719313],
              [55.4086914, 28.169707],
              [55.408138, 28.1663754],
              [55.4078579, 28.163602],
              [55.4075814, 28.1577671],
              [55.4186343, 28.1261537],
              [55.4183542, 28.1247666],
              [55.4180776, 28.1225419],
              [55.4178009, 28.1197588],
              [55.4175208, 28.1194887],
              [55.4175209, 28.1183718],
              [55.4172443, 28.1147599],
              [55.4169677, 28.112256],
              [55.4166876, 28.1119859],
              [55.4084946, 28.0953882],
              [55.4087746, 28.0931643],
              [55.4096079, 28.0826122],
              [55.3995892, 28.078342],
              [55.3865586, 28.045682],
              [55.3862785, 28.0445746],
              [55.3860019, 28.0431882],
              [55.3857252, 28.0417929],
              [55.3854451, 28.0401365],
              [55.3851686, 28.0392992],
              [55.3818353, 28.0297743],
              [55.3818353, 28.0292978],
              [55.3815553, 28.0270741],
              [55.3949647, 28.0129396],
              [55.397188, 28.0109955],
              [55.402188, 28.0090513],
              [55.427734, 28.0069857],
              [55.4624568, 27.9908661],
              [55.4652368, 27.98921],
              [55.4805131, 27.9811548],
              [55.5241023, 27.9904218],
              [55.5791467, 27.9950083],
              [55.6246459, 27.9823664],
              [55.6246459, 27.9820876],
              [55.6252026, 27.9818086],
              [55.6790245, 27.9693369],
              [55.6812479, 27.967106],
              [55.6840244, 27.9646142],
              [55.6887477, 27.9568424],
              [55.6852337, 27.9449767],
              [55.6767116, 27.937191],
              [55.6772648, 27.9363635],
              [55.6778216, 27.9360845],
              [55.676994, 27.9067553],
              [55.6937247, 27.9040506],
              [55.6986233, 27.8782321],
              [55.7102045, 27.8710258],
              [55.7102044, 27.8707469],
              [55.7104811, 27.8704681],
              [55.715811, 27.8632055],
              [55.715958, 27.8630573],
              [55.7163643, 27.8618203],
              [55.7135377, 27.8568666],
              [55.7138143, 27.85603],
              [55.7295224, 27.8421122],
              [55.7329556, 27.8290575],
              [55.7271191, 27.8193414],
              [55.6567379, 27.8254141],
              [55.5795118, 27.8036866],
              [55.5682455, 27.7992408],
              [55.5679689, 27.7984128],
              [55.5676922, 27.7967479],
              [55.5663022, 27.7945249],
              [55.561859, 27.7881352],
              [55.5430762, 27.7766383],
              [55.5419628, 27.7749549],
              [55.5419628, 27.7746757],
              [55.5414094, 27.7743968],
              [55.5408528, 27.7735688],
              [55.535336, 27.7722116],
              [55.5172796, 27.7583175],
              [55.5164463, 27.7577596],
              [55.5136697, 27.7560948],
              [55.5128364, 27.7560948],
              [55.5050565, 27.7511006],
              [55.500063, 27.7423018],
              [55.5021596, 27.7320487],
              [55.4985497, 27.7298348],
              [55.4924362, 27.7234453],
              [55.4916031, 27.7231662],
              [55.4824364, 27.7126103],
              [55.4675601, 27.7095192],
              [55.4658936, 27.7056319],
              [55.4410808, 27.6993526],
              [55.4039917, 27.686734],
              [55.4034385, 27.6864552],
              [55.4017718, 27.6836757],
              [55.3998251, 27.6811752],
              [55.3970485, 27.6786745],
              [55.3964919, 27.677847],
              [55.3749756, 27.6395876],
              [55.3527526, 27.6234854],
              [55.3521958, 27.6232063],
              [55.3446292, 27.6025882],
              [55.3437959, 27.6017514],
              [55.3396026, 27.5901494],
              [55.3368892, 27.5786966],
              [55.3314457, 27.5717377],
              [55.3267423, 27.5600332],
              [55.323409, 27.5569743],
              [55.3210723, 27.542951],
              [55.319129, 27.5401708],
              [55.2940682, 27.5076412],
              [55.2937961, 27.5073666],
              [55.2879827, 27.4858809],
              [55.2874294, 27.4858808],
              [55.2871494, 27.485323],
              [55.2749627, 27.4595399],
              [55.2433564, 27.4243228],
              [55.2389097, 27.4220999],
              [55.2291899, 27.4170963],
              [55.2063603, 27.4214877],
              [55.1463751, 27.421934],
              [55.1463751, 27.421664],
              [55.1447084, 27.4208275],
              [55.1438752, 27.4208274],
              [55.1438752, 27.4205486],
              [55.1433185, 27.4205486],
              [55.1408185, 27.4194331],
              [55.1383185, 27.4188843],
              [55.138042, 27.4186055],
              [55.1377618, 27.4183265],
              [55.1349852, 27.4172201],
              [55.1338719, 27.4172201],
              [55.1335953, 27.4169322],
              [55.1319287, 27.4169323],
              [55.1310954, 27.4166623],
              [55.0430491, 27.4234981],
              [55.0408257, 27.4235443],
              [55.0399924, 27.4238232],
              [55.0372159, 27.4238234],
              [55.0327727, 27.424372],
              [55.028326, 27.424372],
              [55.0266594, 27.4246509],
              [55.0222162, 27.4246509],
              [54.9810784, 27.4266336],
              [54.9525716, 27.4255482],
              [54.945625, 27.4255482],
              [54.9295153, 27.4272125],
              [54.9256253, 27.4272124],
              [54.924792, 27.4274913],
              [54.9206254, 27.4274913],
              [54.8934025, 27.4305409],
              [54.8909027, 27.4305409],
              [54.8850693, 27.4313776],
              [54.8822894, 27.4313775],
              [54.8806227, 27.4316564],
              [54.8789261, 27.4420164],
              [54.8780928, 27.4422863],
              [54.8744794, 27.4422863],
              [54.7187798, 27.4741618],
              [54.6569696, 27.4667354],
              [54.6544696, 27.4667354],
              [54.6511363, 27.4672931],
              [54.6469697, 27.4672931],
              [54.6464165, 27.4675719],
              [54.6416932, 27.467572],
              [54.6411365, 27.4678509],
              [54.6289134, 27.4678509],
              [54.62836, 27.467572],
              [54.6233601, 27.467572],
              [54.6219701, 27.4672931],
              [54.6180801, 27.4672931],
              [54.6166902, 27.4670143],
              [54.611137, 27.4667354],
              [54.6100236, 27.4667355],
              [54.608357, 27.4664566],
              [54.6039137, 27.4661867],
              [54.5978004, 27.4661867],
              [54.5961337, 27.4658988],
              [54.5897473, 27.4658989],
              [54.5880807, 27.4656199],
              [54.5376131, 27.4534312],
              [54.5349748, 27.4534312],
              [54.5344181, 27.4537101],
              [54.5238616, 27.45371],
              [54.5230283, 27.4534311],
              [54.5183085, 27.4534311],
              [54.5169184, 27.4531523],
              [54.5085853, 27.4531523],
              [54.5080285, 27.4528734],
              [54.5046953, 27.4528734],
              [54.5038619, 27.4525945],
              [54.5019187, 27.4525945],
              [54.5016386, 27.4523156],
              [54.3921414, 27.4442642],
              [54.3904747, 27.4442641],
              [54.3876948, 27.4437064],
              [54.3857515, 27.4437065],
              [54.3804715, 27.4428788],
              [54.3788048, 27.4428788],
              [54.3776949, 27.4431487],
              [54.3735283, 27.4431487],
              [54.3710284, 27.4437065],
              [54.3671384, 27.4437065],
              [54.3660284, 27.4439853],
              [54.3646385, 27.4439853],
              [54.350472, 27.4475927],
              [54.349082, 27.4475928],
              [54.3488055, 27.4478806],
              [54.3471388, 27.4481504],
              [54.3401922, 27.4481504],
              [54.3396389, 27.4484294],
              [54.3371389, 27.4484294],
              [54.3363056, 27.4487083],
              [54.3338058, 27.4487083],
              [54.3335256, 27.4489871],
              [54.3299157, 27.4489871],
              [54.3296391, 27.4487083],
              [54.3290824, 27.4487082],
              [54.3288057, 27.4489871],
              [54.3282491, 27.4489871],
              [54.327969, 27.4487083],
              [54.3249158, 27.4487082],
              [54.3243591, 27.4489871],
              [54.3235258, 27.4489871],
              [54.3229691, 27.449257],
              [54.3221358, 27.4495449],
              [54.3210258, 27.4492569],
              [54.3193592, 27.449257],
              [54.3107494, 27.4481504],
              [54.3065794, 27.4481505],
              [54.3054694, 27.4478806],
              [54.293803, 27.4495449],
              [54.288523, 27.4495449],
              [54.2876896, 27.4492569],
              [54.2688817, 27.4465022],
              [54.2472487, 27.4433288],
              [54.2365771, 27.4417633],
              [54.2343573, 27.4417633],
              [54.2224107, 27.4395413],
              [54.2168541, 27.438147],
              [54.2146308, 27.4378772],
              [54.2132442, 27.4373194],
              [54.2124109, 27.4373194],
              [54.1956645, 27.4272149],
              [54.1811364, 27.4113959],
              [54.1268914, 27.3809141],
              [54.0795132, 27.3623158],
              [54.0444943, 27.3610961],
              [54.0341517, 27.3588473],
              [54.0157912, 27.3534385],
              [54.0123063, 27.3523659],
              [54.0048001, 27.3521264],
              [53.9959166, 27.3490378],
              [53.9956366, 27.348759],
              [53.9781369, 27.3426425],
              [53.9781369, 27.3423726],
              [53.9773965, 27.3417234],
              [53.9770269, 27.341536],
              [53.97166, 27.3393096],
              [53.9658306, 27.3353436],
              [53.8954919, 27.2839262],
              [53.8815665, 27.2386592],
              [53.8823999, 27.2375434],
              [53.8915663, 27.2222546],
              [53.9497369, 27.1660849],
              [53.9640676, 27.1455798],
              [53.934161, 27.1245049],
              [53.9333276, 27.1236778],
              [53.9188846, 27.1159009],
              [53.9130514, 27.1136713],
              [53.9111047, 27.1131139],
              [53.9069381, 27.1114507],
              [53.8737918, 27.0863678],
              [53.8732351, 27.0858104],
              [53.871845, 27.085262],
              [53.8444622, 27.0720127],
              [53.8436289, 27.0714554],
              [53.8102829, 27.0685726],
              [53.8097297, 27.0680153],
              [53.7515874, 27.0687429],
              [53.6846385, 27.0956815],
              [53.6832485, 27.0959513],
              [53.6826952, 27.0962298],
              [53.6776953, 27.0981805],
              [53.6426924, 27.1081759],
              [53.626026, 27.1142885],
              [53.6040793, 27.1259521],
              [53.5822431, 27.1380976],
              [53.5816865, 27.1389245],
              [53.5816864, 27.1392032],
              [53.5814098, 27.1394821],
              [53.5811326, 27.1397596],
              [53.5809927, 27.1398997],
              [53.537494, 27.0918149],
              [53.5372174, 27.0920938],
              [53.5369373, 27.0918148],
              [53.5122709, 27.1055345],
              [53.5117143, 27.1055345],
              [53.511161, 27.1049861],
              [53.5089376, 27.1041411],
              [53.5081043, 27.103314],
              [53.5072711, 27.103314],
              [53.5069944, 27.1030353],
              [53.506161, 27.1030353],
              [53.5056044, 27.1027566],
              [53.5044944, 27.1027566],
              [53.5014378, 27.1027566],
              [53.4964379, 27.1027566],
              [53.4844914, 27.1046984],
              [53.483658, 27.1046984],
              [53.4831047, 27.1049861],
              [53.4819913, 27.1049861],
              [53.4811581, 27.1052558],
              [53.4797681, 27.1052558],
              [53.4789347, 27.1055345],
              [53.4775482, 27.1055345],
              [53.4753249, 27.1060919],
              [53.4736582, 27.1060919],
              [53.4496989, 27.1061732],
              [53.4480288, 27.1061732],
              [53.4468315, 27.1064139],
              [53.4466515, 27.1064513],
              [53.4466228, 27.1064573],
              [53.4464976, 27.1064833],
              [53.415527, 27.1065061],
              [53.4105294, 27.11395],
              [53.4096961, 27.1139499],
              [53.4103772, 27.1245357],
              [53.3843865, 27.1308377],
              [53.3752499, 27.1472876],
              [53.3744167, 27.1481148],
              [53.3627502, 27.1708983],
              [53.3569169, 27.1864535],
              [53.3546936, 27.1903469],
              [53.3541369, 27.1906166],
              [53.3538603, 27.1908954],
              [53.3535802, 27.1911741],
              [53.353027, 27.1911741],
              [53.3527469, 27.1914529],
              [53.3519136, 27.1914528],
              [53.3513603, 27.1917315],
              [53.3502469, 27.1917316],
              [53.3499703, 27.1920103],
              [53.346267, 27.1986785],
              [53.3376371, 27.2078424],
              [53.3362504, 27.2081122],
              [53.308067, 27.2225785],
              [53.2765015, 27.2320813],
              [53.2703917, 27.2348596],
              [53.2692817, 27.2356958],
              [53.2296889, 27.2397845],
              [53.2020665, 27.2571377],
              [53.1822076, 27.2618262],
              [53.1723295, 27.2648688],
              [53.1688986, 27.2662566],
              [53.1542191, 27.2666585],
              [53.1434717, 27.2771015],
              [53.1377792, 27.2774415],
              [53.134122, 27.2781929],
              [53.1128706, 27.2837146],
              [53.1088982, 27.2850877],
              [53.0835353, 27.2984124],
              [53.0732345, 27.3039859],
              [53.0571841, 27.3064265],
              [53.0435371, 27.3106211],
              [53.0393314, 27.3144342],
              [53.0373722, 27.3150031],
              [53.0186482, 27.3243704],
              [53.0161142, 27.3308671],
              [53.0141884, 27.3353133],
              [53.0124866, 27.3362573],
              [53.0048275, 27.3403406],
              [52.9991626, 27.343295],
              [52.9884767, 27.3476597],
              [52.9762941, 27.352272],
              [52.9763834, 27.3526672],
              [52.9607105, 27.3580848],
              [52.926642, 27.3693946],
              [52.9184983, 27.3722457],
              [52.9134056, 27.3734652],
              [52.91316, 27.3669656],
              [52.9120874, 27.3412746],
              [52.9006112, 27.3183472],
              [52.8679501, 27.3066163],
              [52.8676735, 27.3060588],
              [52.8420457, 27.3173905],
              [52.8387145, 27.3217517],
              [52.8325609, 27.3224233],
              [52.8108037, 27.327995],
              [52.8067069, 27.326112],
              [52.7921389, 27.3117624],
              [52.7899507, 27.311903],
              [52.7379214, 27.2743065],
              [52.482398, 26.989407]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "type": "relation",
        "id": 3661581,
        "tags": {
          "ISO3166-2": "IR-06",
          "admin_level": "4",
          "boundary": "administrative",
          "is_in:country_code": "IR",
          "name": "خوزستان",
          "place": "province",
          "type": "boundary",
          "wikidata": "Q241119"
        }
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [47.664111, 32.048542],
              [47.664464, 32.048271],
              [47.665077, 32.048078],
              [47.667338, 32.046688],
              [47.667594, 32.046333],
              [47.667517, 32.04614],
              [47.667276, 32.045988],
              [47.666991, 32.045905],
              [47.666902, 32.045808],
              [47.666998, 32.045605],
              [47.667532, 32.044931],
              [47.667551, 32.044721],
              [47.667423, 32.044569],
              [47.66738, 32.044411],
              [47.667518, 32.044129],
              [47.667762, 32.043868],
              [47.668212, 32.043724],
              [47.66957, 32.042334],
              [47.669565, 32.042128],
              [47.669761, 32.041598],
              [47.669694, 32.041393],
              [47.669747, 32.041074],
              [47.670037, 32.040424],
              [47.670587, 32.039622],
              [47.670613, 32.039205],
              [47.670555, 32.038752],
              [47.67042, 32.038343],
              [47.670412, 32.037983],
              [47.670334, 32.037647],
              [47.67011, 32.036903],
              [47.67015, 32.036369],
              [47.669981, 32.035974],
              [47.670169, 32.035635],
              [47.669869, 32.035447],
              [47.669831, 32.035335],
              [47.670546, 32.034056],
              [47.670884, 32.033342],
              [47.670959, 32.032553],
              [47.671182, 32.032006],
              [47.671513, 32.031977],
              [47.671764, 32.031746],
              [47.671981, 32.031665],
              [47.672306, 32.031709],
              [47.672569, 32.031992],
              [47.67299, 32.032112],
              [47.673517, 32.03216],
              [47.675086, 32.032495],
              [47.675451, 32.032408],
              [47.675919, 32.031952],
              [47.676354, 32.031894],
              [47.677205, 32.031328],
              [47.677595, 32.031236],
              [47.677829, 32.03108],
              [47.678127, 32.030789],
              [47.678499, 32.030681],
              [47.678764, 32.030736],
              [47.678901, 32.030917],
              [47.679066, 32.031021],
              [47.679482, 32.031121],
              [47.679814, 32.031144],
              [47.680057, 32.031306],
              [47.680191, 32.031478],
              [47.680451, 32.031513],
              [47.680782, 32.031484],
              [47.681096, 32.031345],
              [47.682648, 32.031291],
              [47.68344, 32.030974],
              [47.684042, 32.030635],
              [47.684756, 32.030372],
              [47.686398, 32.030396],
              [47.686487, 32.030317],
              [47.686833, 32.030254],
              [47.687062, 32.030264],
              [47.687363, 32.030127],
              [47.687603, 32.029898],
              [47.687723, 32.029598],
              [47.687701, 32.029282],
              [47.687618, 32.029112],
              [47.687354, 32.028922],
              [47.687359, 32.028798],
              [47.688073, 32.028142],
              [47.68816, 32.027951],
              [47.688173, 32.027763],
              [47.688318, 32.027603],
              [47.688324, 32.027488],
              [47.688111, 32.027393],
              [47.688008, 32.027288],
              [47.688011, 32.027112],
              [47.688807, 32.026364],
              [47.688902, 32.026202],
              [47.688839, 32.025848],
              [47.688609, 32.025621],
              [47.688411, 32.025538],
              [47.688013, 32.025574],
              [47.687174, 32.025742],
              [47.686664, 32.025896],
              [47.686429, 32.026022],
              [47.686147, 32.026049],
              [47.685921, 32.025974],
              [47.685621, 32.025748],
              [47.685546, 32.025522],
              [47.685621, 32.025335],
              [47.685959, 32.025184],
              [47.686493, 32.024859],
              [47.686619, 32.024697],
              [47.686722, 32.024472],
              [47.686688, 32.02418],
              [47.686568, 32.023969],
              [47.685206, 32.023164],
              [47.68497, 32.022959],
              [47.68484, 32.022802],
              [47.684405, 32.021973],
              [47.683858, 32.021474],
              [47.683316, 32.020876],
              [47.683114, 32.020428],
              [47.68307, 32.019487],
              [47.682984, 32.019214],
              [47.682729, 32.018821],
              [47.682665, 32.018632],
              [47.682652, 32.018418],
              [47.682828, 32.018185],
              [47.683147, 32.018044],
              [47.6836, 32.018003],
              [47.684218, 32.017876],
              [47.68515, 32.017939],
              [47.685475, 32.017911],
              [47.68629, 32.017516],
              [47.687292, 32.017139],
              [47.687776, 32.01686],
              [47.688191, 32.016517],
              [47.688821, 32.015779],
              [47.689026, 32.015443],
              [47.689848, 32.013736],
              [47.690072, 32.013402],
              [47.690236, 32.013243],
              [47.690799, 32.013167],
              [47.691144, 32.013264],
              [47.691352, 32.013407],
              [47.691581, 32.01384],
              [47.691773, 32.014512],
              [47.691892, 32.014676],
              [47.692038, 32.014778],
              [47.692215, 32.014875],
              [47.692558, 32.014942],
              [47.694595, 32.015263],
              [47.694981, 32.015389],
              [47.69529, 32.015559],
              [47.695634, 32.015765],
              [47.695849, 32.016004],
              [47.696094, 32.016331],
              [47.696243, 32.016836],
              [47.696223, 32.017412],
              [47.696049, 32.018048],
              [47.696076, 32.018265],
              [47.696869, 32.019137],
              [47.69708, 32.019476],
              [47.69724, 32.019906],
              [47.697323, 32.02019],
              [47.697292, 32.020474],
              [47.697432, 32.021202],
              [47.697475, 32.022057],
              [47.697583, 32.022228],
              [47.69788, 32.022375],
              [47.698846, 32.022653],
              [47.699067, 32.022845],
              [47.699423, 32.02293],
              [47.699799, 32.022954],
              [47.700117, 32.022854],
              [47.700574, 32.02257],
              [47.700864, 32.022321],
              [47.701141, 32.021997],
              [47.701498, 32.021715],
              [47.70183, 32.021623],
              [47.702807, 32.021569],
              [47.703443, 32.021251],
              [47.703802, 32.021139],
              [47.704433, 32.021039],
              [47.706477, 32.020966],
              [47.708098, 32.020788],
              [47.708956, 32.020668],
              [47.70999, 32.02036],
              [47.711699, 32.019507],
              [47.712108, 32.01921],
              [47.712418, 32.018895],
              [47.712962, 32.018073],
              [47.713107, 32.017355],
              [47.712958, 32.016639],
              [47.712598, 32.016142],
              [47.712499, 32.015845],
              [47.712438, 32.015526],
              [47.7124, 32.01464],
              [47.712294, 32.014504],
              [47.712015, 32.014307],
              [47.71121, 32.013881],
              [47.710376, 32.013672],
              [47.710006, 32.013673],
              [47.709446, 32.013734],
              [47.709002, 32.013949],
              [47.708723, 32.014403],
              [47.708623, 32.014756],
              [47.708592, 32.015128],
              [47.70885, 32.015944],
              [47.70912, 32.016596],
              [47.709112, 32.016778],
              [47.708996, 32.01714],
              [47.708871, 32.017395],
              [47.70868, 32.017616],
              [47.708486, 32.017734],
              [47.707739, 32.017803],
              [47.707466, 32.01777],
              [47.706822, 32.017217],
              [47.706653, 32.017103],
              [47.706508, 32.017078],
              [47.706333, 32.017079],
              [47.705894, 32.017361],
              [47.70553, 32.017474],
              [47.705126, 32.017583],
              [47.704983, 32.017542],
              [47.704671, 32.017104],
              [47.704434, 32.016321],
              [47.703962, 32.015592],
              [47.703663, 32.015321],
              [47.703338, 32.015117],
              [47.702446, 32.014785],
              [47.701822, 32.014377],
              [47.701399, 32.013928],
              [47.701235, 32.013596],
              [47.701156, 32.013306],
              [47.701131, 32.012908],
              [47.701385, 32.011943],
              [47.701608, 32.011608],
              [47.701815, 32.0114],
              [47.702086, 32.011216],
              [47.702425, 32.011056],
              [47.702814, 32.010939],
              [47.703168, 32.0109],
              [47.703562, 32.010921],
              [47.70409, 32.011088],
              [47.704551, 32.011448],
              [47.705171, 32.011561],
              [47.705512, 32.011566],
              [47.705684, 32.011509],
              [47.705982, 32.011264],
              [47.707145, 32.010179],
              [47.707741, 32.009575],
              [47.70794, 32.009291],
              [47.708284, 32.00833],
              [47.708325, 32.00795],
              [47.708295, 32.007605],
              [47.708202, 32.007281],
              [47.708007, 32.006956],
              [47.707745, 32.00673],
              [47.706952, 32.006136],
              [47.706175, 32.005721],
              [47.706006, 32.005535],
              [47.705963, 32.005377],
              [47.706032, 32.005143],
              [47.706279, 32.004969],
              [47.706496, 32.004888],
              [47.706694, 32.00497],
              [47.706881, 32.004988],
              [47.70703, 32.004914],
              [47.70716, 32.004653],
              [47.707533, 32.004198],
              [47.708458, 32.003394],
              [47.709292, 32.002901],
              [47.710389, 32.002479],
              [47.71161, 32.002287],
              [47.712211, 32.002141],
              [47.712732, 32.001958],
              [47.71335, 32.001665],
              [47.713998, 32.001139],
              [47.71451, 32.000106],
              [47.714608, 31.999794],
              [47.714601, 31.999444],
              [47.714471, 31.999122],
              [47.714007, 31.998473],
              [47.71332, 31.998181],
              [47.712886, 31.998131],
              [47.712633, 31.998193],
              [47.712366, 31.998319],
              [47.712237, 31.998446],
              [47.712176, 31.998663],
              [47.712194, 31.998892],
              [47.712412, 31.999327],
              [47.712383, 31.999524],
              [47.712178, 31.999902],
              [47.710969, 32.000143],
              [47.710686, 32.000138],
              [47.710003, 31.999839],
              [47.709663, 31.999535],
              [47.709271, 31.999266],
              [47.709134, 31.999084],
              [47.708995, 31.998521],
              [47.708953, 31.99762],
              [47.70885, 31.997448],
              [47.708505, 31.99717],
              [47.707883, 31.996794],
              [47.707114, 31.996242],
              [47.70613, 31.995828],
              [47.705707, 31.995539],
              [47.705396, 31.994873],
              [47.705359, 31.994575],
              [47.705397, 31.994321],
              [47.70559, 31.99413],
              [47.706569, 31.994014],
              [47.706819, 31.993824],
              [47.707534, 31.992635],
              [47.707803, 31.991564],
              [47.707956, 31.9912],
              [47.708193, 31.990894],
              [47.708468, 31.990751],
              [47.708737, 31.990722],
              [47.709069, 31.99077],
              [47.709253, 31.990891],
              [47.709833, 31.991508],
              [47.710038, 31.991641],
              [47.710287, 31.991771],
              [47.710834, 31.991754],
              [47.71132, 31.991975],
              [47.711919, 31.992495],
              [47.712191, 31.992667],
              [47.712434, 31.992757],
              [47.712794, 31.992882],
              [47.71316, 31.992888],
              [47.713634, 31.992807],
              [47.71392, 31.992661],
              [47.714125, 31.992464],
              [47.714229, 31.99227],
              [47.714205, 31.992109],
              [47.713928, 31.991803],
              [47.713865, 31.991639],
              [47.713921, 31.991407],
              [47.714746, 31.990545],
              [47.715047, 31.989861],
              [47.715188, 31.989309],
              [47.715417, 31.988764],
              [47.716066, 31.987498],
              [47.716583, 31.986904],
              [47.7169, 31.986651],
              [47.717107, 31.986544],
              [47.717379, 31.986509],
              [47.717542, 31.986442],
              [47.717659, 31.986296],
              [47.717693, 31.98601],
              [47.717653, 31.985456],
              [47.71775, 31.984175],
              [47.717669, 31.983776],
              [47.717174, 31.982641],
              [47.71641, 31.981573],
              [47.714244, 31.97946],
              [47.713967, 31.979128],
              [47.713596, 31.97851],
              [47.712338, 31.975966],
              [47.711993, 31.974024],
              [47.711476, 31.971825],
              [47.711473, 31.971073],
              [47.711573, 31.970599],
              [47.711769, 31.970159],
              [47.712018, 31.969902],
              [47.712855, 31.969461],
              [47.713141, 31.96922],
              [47.71341, 31.96891],
              [47.714221, 31.9676],
              [47.714505, 31.967271],
              [47.715289, 31.966592],
              [47.717023, 31.965339],
              [47.717441, 31.965146],
              [47.719307, 31.964705],
              [47.720922, 31.964461],
              [47.72258, 31.964386],
              [47.723023, 31.964275],
              [47.724413, 31.963708],
              [47.724656, 31.963407],
              [47.72475, 31.963185],
              [47.725093, 31.962962],
              [47.726179, 31.960416],
              [47.726274, 31.959666],
              [47.726917, 31.957656],
              [47.727459, 31.956198],
              [47.728622, 31.953977],
              [47.728771, 31.953076],
              [47.728833, 31.951229],
              [47.728739, 31.948037],
              [47.729796, 31.946169],
              [47.730693, 31.94537],
              [47.730855, 31.944924],
              [47.73132, 31.944124],
              [47.731422, 31.943524],
              [47.731192, 31.942959],
              [47.731025, 31.942245],
              [47.730813, 31.941831],
              [47.730748, 31.941391],
              [47.731181, 31.941201],
              [47.731391, 31.941001],
              [47.731374, 31.940091],
              [47.731546, 31.939555],
              [47.731711, 31.939258],
              [47.732178, 31.9392],
              [47.732481, 31.93934],
              [47.732768, 31.939368],
              [47.733567, 31.938857],
              [47.734098, 31.938656],
              [47.734525, 31.93855],
              [47.734654, 31.938424],
              [47.734757, 31.938015],
              [47.735128, 31.937606],
              [47.735195, 31.937424],
              [47.73518, 31.937151],
              [47.734944, 31.936301],
              [47.734995, 31.936078],
              [47.735938, 31.934685],
              [47.736174, 31.934507],
              [47.736564, 31.934358],
              [47.736916, 31.934457],
              [47.737175, 31.934319],
              [47.738003, 31.933682],
              [47.738671, 31.933287],
              [47.73887, 31.932857],
              [47.739011, 31.932729],
              [47.73953, 31.932431],
              [47.740738, 31.931317],
              [47.740898, 31.93108],
              [47.741105, 31.930473],
              [47.741598, 31.93007],
              [47.741671, 31.929777],
              [47.741738, 31.929699],
              [47.742148, 31.929711],
              [47.742737, 31.929396],
              [47.743771, 31.928598],
              [47.74423, 31.927986],
              [47.74442, 31.92781],
              [47.744713, 31.927677],
              [47.745529, 31.926438],
              [47.745683, 31.926016],
              [47.746587, 31.924547],
              [47.747234, 31.924095],
              [47.747461, 31.923858],
              [47.747947, 31.922928],
              [47.748086, 31.922789],
              [47.748178, 31.922521],
              [47.749287, 31.92083],
              [47.749798, 31.919868],
              [47.750483, 31.918931],
              [47.750734, 31.918817],
              [47.751168, 31.918814],
              [47.751418, 31.918667],
              [47.751629, 31.918367],
              [47.752273, 31.91819],
              [47.752555, 31.917988],
              [47.753152, 31.917836],
              [47.753354, 31.917659],
              [47.753459, 31.917492],
              [47.753519, 31.917174],
              [47.753682, 31.916871],
              [47.754284, 31.916399],
              [47.754537, 31.91563],
              [47.754728, 31.91546],
              [47.754994, 31.915376],
              [47.755307, 31.915449],
              [47.755422, 31.915616],
              [47.755747, 31.915632],
              [47.75613, 31.915561],
              [47.756565, 31.915404],
              [47.756802, 31.915182],
              [47.756923, 31.914947],
              [47.757076, 31.914838],
              [47.757437, 31.914732],
              [47.757691, 31.914601],
              [47.758073, 31.914183],
              [47.758105, 31.913996],
              [47.758047, 31.913605],
              [47.758118, 31.913439],
              [47.758275, 31.913318],
              [47.759035, 31.913232],
              [47.759209, 31.913131],
              [47.759106, 31.912379],
              [47.759125, 31.912216],
              [47.759232, 31.912137],
              [47.759879, 31.912054],
              [47.760632, 31.911864],
              [47.760989, 31.911952],
              [47.761798, 31.912324],
              [47.761948, 31.912524],
              [47.762035, 31.912998],
              [47.762162, 31.913103],
              [47.762423, 31.91313],
              [47.763409, 31.912724],
              [47.76385, 31.912593],
              [47.764641, 31.912656],
              [47.765073, 31.91262],
              [47.766356, 31.912279],
              [47.767853, 31.91199],
              [47.768479, 31.911772],
              [47.769453, 31.911265],
              [47.769904, 31.911094],
              [47.770164, 31.910934],
              [47.77039, 31.910609],
              [47.770841, 31.909674],
              [47.771627, 31.908979],
              [47.771888, 31.908874],
              [47.772283, 31.9088],
              [47.773171, 31.908797],
              [47.774181, 31.908722],
              [47.775373, 31.90826],
              [47.775965, 31.908092],
              [47.776318, 31.908059],
              [47.777201, 31.908221],
              [47.777932, 31.908656],
              [47.778284, 31.908646],
              [47.778796, 31.908558],
              [47.78096, 31.90789],
              [47.781573, 31.90747],
              [47.783335, 31.905786],
              [47.783334, 31.896723],
              [47.784644, 31.896499],
              [47.785434, 31.89586],
              [47.785546, 31.895484],
              [47.785622, 31.894957],
              [47.785283, 31.893717],
              [47.785246, 31.892927],
              [47.785338, 31.89227],
              [47.785648, 31.892001],
              [47.785727, 31.891839],
              [47.785619, 31.891467],
              [47.78582, 31.890652],
              [47.785945, 31.89051],
              [47.786414, 31.890303],
              [47.786789, 31.889887],
              [47.786925, 31.889633],
              [47.787076, 31.888963],
              [47.787212, 31.888682],
              [47.787652, 31.888255],
              [47.787926, 31.888181],
              [47.788119, 31.888077],
              [47.788761, 31.88743],
              [47.789073, 31.887294],
              [47.789585, 31.887267],
              [47.789893, 31.887171],
              [47.790356, 31.88713],
              [47.790606, 31.886961],
              [47.791153, 31.886758],
              [47.791566, 31.886496],
              [47.791977, 31.886354],
              [47.792846, 31.886266],
              [47.793125, 31.886158],
              [47.793779, 31.885635],
              [47.794658, 31.885271],
              [47.795019, 31.885198],
              [47.795242, 31.885264],
              [47.795411, 31.885405],
              [47.795647, 31.885469],
              [47.7962, 31.885341],
              [47.796543, 31.885327],
              [47.796911, 31.885335],
              [47.797318, 31.885446],
              [47.797522, 31.885411],
              [47.797656, 31.885202],
              [47.797991, 31.885134],
              [47.798255, 31.885176],
              [47.798747, 31.88512],
              [47.799275, 31.885314],
              [47.800041, 31.885369],
              [47.800561, 31.885214],
              [47.801173, 31.885241],
              [47.801498, 31.885186],
              [47.802133, 31.885219],
              [47.802526, 31.885327],
              [47.802722, 31.885288],
              [47.803598, 31.884908],
              [47.804083, 31.884535],
              [47.804454, 31.884346],
              [47.805558, 31.883576],
              [47.805741, 31.88343],
              [47.806205, 31.882661],
              [47.806386, 31.882482],
              [47.806594, 31.882381],
              [47.80705, 31.882292],
              [47.807632, 31.882356],
              [47.80792, 31.882335],
              [47.808117, 31.882273],
              [47.808832, 31.881861],
              [47.809742, 31.881486],
              [47.80986, 31.881373],
              [47.810224, 31.880681],
              [47.810311, 31.880365],
              [47.810303, 31.880016],
              [47.810209, 31.879698],
              [47.810051, 31.879467],
              [47.809813, 31.879289],
              [47.809384, 31.879121],
              [47.808588, 31.878945],
              [47.808441, 31.878839],
              [47.808285, 31.87851],
              [47.808276, 31.878292],
              [47.808457, 31.877823],
              [47.808422, 31.877418],
              [47.80794, 31.876778],
              [47.807923, 31.876551],
              [47.808175, 31.875785],
              [47.808416, 31.875393],
              [47.808662, 31.874814],
              [47.808864, 31.874506],
              [47.808869, 31.874368],
              [47.80881, 31.874241],
              [47.808639, 31.874194],
              [47.807738, 31.874342],
              [47.807459, 31.874264],
              [47.806938, 31.873943],
              [47.806029, 31.873534],
              [47.805955, 31.873399],
              [47.805956, 31.87319],
              [47.806139, 31.872677],
              [47.806143, 31.872485],
              [47.806077, 31.872326],
              [47.805929, 31.872187],
              [47.805627, 31.87202],
              [47.805536, 31.871899],
              [47.805589, 31.871632],
              [47.80555, 31.87148],
              [47.805389, 31.871261],
              [47.805183, 31.871105],
              [47.804787, 31.870909],
              [47.804606, 31.870743],
              [47.804464, 31.870527],
              [47.804313, 31.869873],
              [47.804265, 31.86929],
              [47.804194, 31.869089],
              [47.803923, 31.868779],
              [47.803757, 31.868703],
              [47.803614, 31.868717],
              [47.803374, 31.868846],
              [47.80302, 31.868895],
              [47.802803, 31.86885],
              [47.802568, 31.868633],
              [47.801805, 31.868484],
              [47.80108, 31.868143],
              [47.799872, 31.868158],
              [47.799671, 31.868044],
              [47.799616, 31.867906],
              [47.799621, 31.867741],
              [47.79981, 31.867171],
              [47.79995, 31.867016],
              [47.800045, 31.866786],
              [47.800023, 31.866593],
              [47.79944, 31.865499],
              [47.799058, 31.864485],
              [47.799079, 31.864043],
              [47.799368, 31.863288],
              [47.79949, 31.863036],
              [47.799624, 31.862931],
              [47.799684, 31.862773],
              [47.799667, 31.86242],
              [47.799499, 31.861989],
              [47.799347, 31.861862],
              [47.799009, 31.860736],
              [47.79896, 31.860383],
              [47.799017, 31.860056],
              [47.799259, 31.859538],
              [47.799212, 31.859327],
              [47.799108, 31.859098],
              [47.798719, 31.858771],
              [47.798654, 31.858645],
              [47.798666, 31.858457],
              [47.799056, 31.857787],
              [47.799335, 31.857099],
              [47.799557, 31.856738],
              [47.79962, 31.856278],
              [47.799784, 31.856086],
              [47.800121, 31.855836],
              [47.800486, 31.855281],
              [47.800993, 31.854756],
              [47.801271, 31.854566],
              [47.801849, 31.854325],
              [47.802011, 31.854177],
              [47.802134, 31.853953],
              [47.802104, 31.853674],
              [47.802028, 31.853506],
              [47.801592, 31.853175],
              [47.801409, 31.852982],
              [47.80136, 31.852837],
              [47.801385, 31.852619],
              [47.801524, 31.852381],
              [47.801821, 31.852161],
              [47.802139, 31.851997],
              [47.802339, 31.851788],
              [47.802423, 31.851538],
              [47.802315, 31.851113],
              [47.802426, 31.850946],
              [47.802849, 31.850775],
              [47.803194, 31.850535],
              [47.803608, 31.850147],
              [47.804017, 31.849868],
              [47.80431, 31.849501],
              [47.804986, 31.848805],
              [47.805101, 31.848571],
              [47.805, 31.847882],
              [47.805172, 31.846905],
              [47.80504, 31.846621],
              [47.804867, 31.846486],
              [47.804829, 31.845967],
              [47.804956, 31.845759],
              [47.805232, 31.845559],
              [47.805358, 31.8454],
              [47.805351, 31.845029],
              [47.805429, 31.844813],
              [47.805615, 31.844573],
              [47.806028, 31.844179],
              [47.80555, 31.843631],
              [47.805337, 31.842578],
              [47.805441, 31.842412],
              [47.805678, 31.84224],
              [47.806318, 31.842142],
              [47.806635, 31.842049],
              [47.807301, 31.842105],
              [47.807513, 31.842047],
              [47.807807, 31.842106],
              [47.808611, 31.842073],
              [47.808908, 31.842197],
              [47.80915, 31.842232],
              [47.809666, 31.842221],
              [47.810771, 31.841955],
              [47.812406, 31.841845],
              [47.812783, 31.841781],
              [47.813152, 31.841608],
              [47.813832, 31.840928],
              [47.814042, 31.840601],
              [47.814296, 31.840339],
              [47.814767, 31.840072],
              [47.815176, 31.839581],
              [47.815899, 31.839101],
              [47.816613, 31.838447],
              [47.816887, 31.838401],
              [47.81743, 31.838439],
              [47.817538, 31.838552],
              [47.817561, 31.838904],
              [47.818008, 31.83949],
              [47.818161, 31.839767],
              [47.818886, 31.840123],
              [47.820027, 31.840179],
              [47.821045, 31.839965],
              [47.822015, 31.838923],
              [47.822481, 31.838306],
              [47.823075, 31.837687],
              [47.823607, 31.836925],
              [47.824122, 31.836339],
              [47.824419, 31.835606],
              [47.824538, 31.834877],
              [47.824615, 31.833908],
              [47.824948, 31.833016],
              [47.825222, 31.832504],
              [47.843989, 31.822082],
              [47.844525, 31.821891],
              [47.845302, 31.821377],
              [47.845392, 31.821214],
              [47.846293, 31.820961],
              [47.846694, 31.820782],
              [47.848556, 31.820145],
              [47.849628, 31.819725],
              [47.850297, 31.819637],
              [47.850516, 31.819501],
              [47.850706, 31.818937],
              [47.850977, 31.818617],
              [47.851403, 31.818483],
              [47.852366, 31.818373],
              [47.852568, 31.818223],
              [47.852865, 31.817345],
              [47.853084, 31.816896],
              [47.853237, 31.816344],
              [47.853647, 31.815836],
              [47.853815, 31.815686],
              [47.854137, 31.81551],
              [47.854399, 31.815022],
              [47.854614, 31.814793],
              [47.854718, 31.814573],
              [47.854954, 31.814351],
              [47.855132, 31.814003],
              [47.855497, 31.813869],
              [47.855645, 31.81369],
              [47.856029, 31.813027],
              [47.856069, 31.812763],
              [47.856002, 31.812369],
              [47.85614, 31.812176],
              [47.856187, 31.811943],
              [47.856094, 31.81134],
              [47.856123, 31.804563],
              [47.865855, 31.783613],
              [47.850052, 31.75],
              [47.8275773, 31.695542],
              [47.8216193, 31.6828874],
              [47.7925145, 31.6202521],
              [47.7876095, 31.609671],
              [47.7864635, 31.6075349],
              [47.7564203, 31.5438096],
              [47.7524852, 31.5356392],
              [47.7281329, 31.4838542],
              [47.7204431, 31.4667499],
              [47.7168324, 31.4589055],
              [47.7122005, 31.4490706],
              [47.7077828, 31.4414011],
              [47.7050752, 31.4368463],
              [47.702283, 31.4310081],
              [47.6971048, 31.4200567],
              [47.6852868, 31.3948254],
              [47.6850838, 31.3748765],
              [47.6851613, 31.3682863],
              [47.6851096, 31.3621052],
              [47.6851068, 31.3572988],
              [47.6853314, 31.3440242],
              [47.6853403, 31.3434985],
              [47.6853567, 31.3425272],
              [47.6852819, 31.3314979],
              [47.685266, 31.3260081],
              [47.6852646, 31.3255214],
              [47.6852507, 31.3206918],
              [47.6852565, 31.315065],
              [47.6849662, 31.3048861],
              [47.6850073, 31.2871605],
              [47.6850475, 31.2721091],
              [47.6849799, 31.262729],
              [47.6849965, 31.2570519],
              [47.6850105, 31.2448995],
              [47.6849362, 31.2402344],
              [47.6849929, 31.2151123],
              [47.6849688, 31.2026175],
              [47.6849481, 31.1960523],
              [47.6849547, 31.1681613],
              [47.6849591, 31.1559627],
              [47.6849719, 31.1306581],
              [47.6850136, 31.1188321],
              [47.6849461, 31.1129169],
              [47.6849182, 31.1053909],
              [47.6848923, 31.0975014],
              [47.6848698, 31.0821878],
              [47.6846639, 31.0758186],
              [47.684463, 31.0615979],
              [47.6844189, 31.0538664],
              [47.6850854, 31.0487744],
              [47.685381, 31.0465162],
              [47.6854417, 31.0408728],
              [47.687027, 31.0159873],
              [47.6871111, 31.0007127],
              [47.6964971, 31.0005319],
              [47.7318265, 31.000468],
              [47.7768986, 31.0006268],
              [47.7999634, 31.0005512],
              [47.7989943, 31.0028666],
              [47.8703929, 31.0101038],
              [47.9565999, 31.0056998],
              [47.9838282, 31.007415],
              [47.9894612, 31.0059069],
              [48.0073306, 31.0043777],
              [48.0253238, 31.0045923],
              [48.0307025, 31.0057707],
              [48.032859, 30.9909788],
              [48.0335364, 30.8974702],
              [48.0299781, 30.8644217],
              [48.029968, 30.8588067],
              [48.026586, 30.5227934],
              [48.0256918, 30.5055349],
              [48.0257241, 30.5014546],
              [48.0257251, 30.5013912],
              [48.0259641, 30.4865463],
              [48.0255254, 30.4803075],
              [48.0251519, 30.4776043],
              [48.0366633, 30.475662],
              [48.0385639, 30.4755062],
              [48.0416503, 30.4744986],
              [48.0478934, 30.4719393],
              [48.0537623, 30.468997],
              [48.057784, 30.4671227],
              [48.0622017, 30.4652183],
              [48.0696757, 30.4627394],
              [48.0782305, 30.4601974],
              [48.0853444, 30.4583893],
              [48.0944603, 30.4567501],
              [48.099876, 30.4556165],
              [48.1047587, 30.4546872],
              [48.1072497, 30.4540662],
              [48.10857, 30.4533166],
              [48.1089571, 30.4522908],
              [48.108819, 30.4508883],
              [48.1136987, 30.4501858],
              [48.1200099, 30.4488043],
              [48.1229509, 30.4481078],
              [48.1257847, 30.4472494],
              [48.1281784, 30.4464048],
              [48.1285511, 30.4462733],
              [48.1320928, 30.4448574],
              [48.1324082, 30.4447308],
              [48.1332702, 30.4443848],
              [48.1357176, 30.4434426],
              [48.1381016, 30.4424377],
              [48.1420289, 30.4403907],
              [48.1424605, 30.4401657],
              [48.1440703, 30.4393616],
              [48.1450668, 30.4388638],
              [48.1476057, 30.4373422],
              [48.1499223, 30.4359538],
              [48.1520193, 30.4346343],
              [48.1529024, 30.4340786],
              [48.1548309, 30.4327998],
              [48.1584317, 30.4304121],
              [48.158686, 30.4302434],
              [48.1627579, 30.4273979],
              [48.1632534, 30.4268594],
              [48.163423, 30.4266457],
              [48.1669286, 30.422229],
              [48.1670674, 30.4220541],
              [48.1682479, 30.4205461],
              [48.1684927, 30.4202309],
              [48.1701666, 30.4180761],
              [48.1727075, 30.4145566],
              [48.1734178, 30.4133856],
              [48.1734634, 30.4133104],
              [48.1737878, 30.4127364],
              [48.1739427, 30.4124621],
              [48.1760223, 30.4091829],
              [48.179491, 30.403196],
              [48.1805997, 30.3995153],
              [48.1812926, 30.3973527],
              [48.1823543, 30.3937365],
              [48.1825438, 30.3917197],
              [48.1829127, 30.3844677],
              [48.1831635, 30.380617],
              [48.1831703, 30.3805119],
              [48.1861437, 30.3690659],
              [48.1862043, 30.3687632],
              [48.1865037, 30.3675081],
              [48.1900993, 30.3511506],
              [48.1919435, 30.3435403],
              [48.191975, 30.34344],
              [48.1926977, 30.3383227],
              [48.1936671, 30.3353293],
              [48.1978618, 30.3271977],
              [48.1986602, 30.3260393],
              [48.1991826, 30.3252385],
              [48.2024504, 30.3210285],
              [48.2042624, 30.3195542],
              [48.2056449, 30.3188115],
              [48.2067938, 30.3180076],
              [48.2085199, 30.3174036],
              [48.2106712, 30.316938],
              [48.2129332, 30.3164779],
              [48.215088, 30.316305],
              [48.2171993, 30.3164824],
              [48.2194017, 30.3171921],
              [48.2222526, 30.3185629],
              [48.2244046, 30.3203433],
              [48.2265845, 30.3224466],
              [48.2276564, 30.3234524],
              [48.2308614, 30.3263675],
              [48.2373447, 30.333122],
              [48.243422, 30.3381059],
              [48.246425, 30.3396403],
              [48.2486925, 30.3404332],
              [48.2497082, 30.3406648],
              [48.2522042, 30.3409857],
              [48.2555133, 30.3408364],
              [48.2581734, 30.3403972],
              [48.2599633, 30.3399802],
              [48.2628166, 30.3393154],
              [48.2629273, 30.3392896],
              [48.2671971, 30.3378773],
              [48.2724511, 30.3348376],
              [48.272624, 30.3347376],
              [48.2747059, 30.3334385],
              [48.2748013, 30.3333789],
              [48.2768904, 30.3319061],
              [48.276961, 30.3318492],
              [48.2810907, 30.328523],
              [48.2861021, 30.3229036],
              [48.2863984, 30.3225795],
              [48.2913663, 30.3171466],
              [48.2937571, 30.3146047],
              [48.296057, 30.3121255],
              [48.2976729, 30.3105013],
              [48.3016346, 30.3063201],
              [48.3051628, 30.3025965],
              [48.3110124, 30.2967259],
              [48.314051, 30.2936763],
              [48.3163315, 30.2913875],
              [48.316846, 30.290871],
              [48.3177765, 30.2899825],
              [48.3189402, 30.288947],
              [48.3209934, 30.286865],
              [48.3261198, 30.2806683],
              [48.3307379, 30.2754907],
              [48.3357809, 30.2698364],
              [48.3407413, 30.2644425],
              [48.3414007, 30.2637254],
              [48.34495, 30.2598657],
              [48.3515649, 30.2529267],
              [48.357345, 30.246863],
              [48.3578373, 30.2463805],
              [48.3643315, 30.2400155],
              [48.3714295, 30.2330582],
              [48.3721786, 30.2324762],
              [48.3731251, 30.2317409],
              [48.3734609, 30.23148],
              [48.3766878, 30.2288512],
              [48.3832103, 30.2235375],
              [48.3883847, 30.2193219],
              [48.3897429, 30.2182152],
              [48.3898923, 30.2180935],
              [48.3992668, 30.2104233],
              [48.4073989, 30.2024495],
              [48.4075148, 30.2023358],
              [48.4113732, 30.1974557],
              [48.4120031, 30.1966588],
              [48.4150431, 30.1928597],
              [48.4157402, 30.1912083],
              [48.4161423, 30.1894179],
              [48.4169592, 30.1859761],
              [48.4176503, 30.1800694],
              [48.4171931, 30.1771772],
              [48.4158932, 30.1724489],
              [48.4144464, 30.1677206],
              [48.407751, 30.1571818],
              [48.4046102, 30.1539697],
              [48.404536, 30.1538938],
              [48.4014281, 30.151164],
              [48.4011856, 30.150942],
              [48.3994353, 30.1493399],
              [48.3993392, 30.1492519],
              [48.3981875, 30.1480399],
              [48.3978202, 30.1476534],
              [48.3952143, 30.1449111],
              [48.3937898, 30.1434121],
              [48.3931624, 30.1427518],
              [48.3870457, 30.1366763],
              [48.3864866, 30.136121],
              [48.3841504, 30.1327981],
              [48.3840846, 30.1326249],
              [48.3826143, 30.128756],
              [48.3824493, 30.1268628],
              [48.382432, 30.1266642],
              [48.3822991, 30.1236552],
              [48.3822963, 30.1235919],
              [48.3824261, 30.1211262],
              [48.382832, 30.1199379],
              [48.3834075, 30.1187251],
              [48.3865861, 30.1148653],
              [48.3896518, 30.1111425],
              [48.3948254, 30.1076958],
              [48.3996202, 30.1045015],
              [48.3998914, 30.1043208],
              [48.404429, 30.1016319],
              [48.4050264, 30.1012779],
              [48.4128905, 30.0965144],
              [48.4142103, 30.0956536],
              [48.415375, 30.0948941],
              [48.4214963, 30.0905636],
              [48.421556, 30.0905214],
              [48.4249312, 30.0874076],
              [48.4274903, 30.0850466],
              [48.4276308, 30.0849088],
              [48.4328125, 30.079826],
              [48.4366139, 30.0751147],
              [48.4397213, 30.0708247],
              [48.4399136, 30.0705592],
              [48.4434791, 30.0648931],
              [48.4456638, 30.0606613],
              [48.4459204, 30.0598965],
              [48.4460952, 30.0593754],
              [48.4465035, 30.0577861],
              [48.4466408, 30.0572518],
              [48.4471262, 30.0553989],
              [48.447519, 30.0535666],
              [48.4477279, 30.0525922],
              [48.4481684, 30.0505375],
              [48.4483204, 30.0494464],
              [48.4484091, 30.0488099],
              [48.4484532, 30.0478783],
              [48.4484895, 30.0471109],
              [48.4485569, 30.0456885],
              [48.4486788, 30.0433381],
              [48.448681, 30.0432533],
              [48.4487243, 30.0415997],
              [48.4487457, 30.0407843],
              [48.4487336, 30.0399222],
              [48.4486998, 30.0375108],
              [48.4486557, 30.0343587],
              [48.4486103, 30.0336161],
              [48.448459, 30.0311433],
              [48.4483462, 30.0293004],
              [48.448183, 30.0272715],
              [48.4479446, 30.022172],
              [48.4479762, 30.0198541],
              [48.4479777, 30.0197412],
              [48.4482984, 30.0140722],
              [48.4486937, 30.0117311],
              [48.4490282, 30.0095349],
              [48.449089, 30.0091357],
              [48.4496187, 30.0071261],
              [48.4496332, 30.0070709],
              [48.4501774, 30.00543],
              [48.4502688, 30.0052338],
              [48.4511487, 30.003344],
              [48.4512345, 30.0031597],
              [48.4520071, 30.0019349],
              [48.4531135, 30.0001906],
              [48.4532065, 30.000044],
              [48.4537824, 29.9992989],
              [48.4538642, 29.9991931],
              [48.4551935, 29.9976487],
              [48.4553329, 29.9974867],
              [48.4562582, 29.9965332],
              [48.4597907, 29.9936741],
              [48.4599081, 29.9935791],
              [48.4620719, 29.9921674],
              [48.4621448, 29.9921199],
              [48.4631729, 29.9914997],
              [48.4635253, 29.9912781],
              [48.4649189, 29.9904018],
              [48.4651829, 29.9902562],
              [48.4689097, 29.9882011],
              [48.4723229, 29.9863188],
              [48.4741566, 29.9853152],
              [48.4774643, 29.9835049],
              [48.4790433, 29.9826406],
              [48.4818062, 29.9811284],
              [48.4822242, 29.9808996],
              [48.4833698, 29.9802275],
              [48.4855625, 29.9789412],
              [48.485958, 29.9787092],
              [48.4881574, 29.9773813],
              [48.4891428, 29.9767864],
              [48.4945539, 29.9735393],
              [48.4956136, 29.9729034],
              [48.5025173, 29.9686974],
              [48.5034003, 29.9681594],
              [48.5061778, 29.9664624],
              [48.5073526, 29.9657446],
              [48.5106334, 29.9637787],
              [48.5137326, 29.9625117],
              [48.5144518, 29.9622177],
              [48.5178054, 29.9609283],
              [48.5255699, 29.9580869],
              [48.5403781, 29.9538388],
              [48.5486874, 29.9522],
              [48.5587479, 29.9499882],
              [48.5691414, 29.9483389],
              [48.5715604, 29.9479429],
              [48.5757064, 29.9471445],
              [48.5794394, 29.9463942],
              [48.5839637, 29.9451092],
              [48.5869306, 29.944118],
              [48.590143, 29.9432176],
              [48.5931535, 29.9424327],
              [48.5974859, 29.9408007],
              [48.6006204, 29.9396136],
              [48.6037434, 29.9383817],
              [48.6112542, 29.9353374],
              [48.6176008, 29.932435],
              [48.6176674, 29.9323998],
              [48.6235183, 29.9293095],
              [48.637415, 29.9226729],
              [48.6891496, 29.8979601],
              [48.8809795, 29.8157281],
              [48.9537333, 29.8125171],
              [49.0973992, 29.8059254],
              [49.1629583, 29.8031143],
              [49.4643006, 29.7895783],
              [49.5801433, 29.6674426],
              [50.1161772, 30.1541459],
              [50.1168438, 30.1547139],
              [50.1189118, 30.1565697],
              [50.1208266, 30.1585497],
              [50.1234323, 30.1608028],
              [50.1259385, 30.1637049],
              [50.1292915, 30.1671112],
              [50.1324843, 30.1699162],
              [50.1390342, 30.1759444],
              [50.1439932, 30.1810483],
              [50.1495512, 30.1872635],
              [50.1552275, 30.1943072],
              [50.1580161, 30.1980362],
              [50.1605453, 30.2019507],
              [50.1634027, 30.2066952],
              [50.1659927, 30.2113026],
              [50.1688117, 30.2169221],
              [50.1701622, 30.2193174],
              [50.1718979, 30.2229109],
              [50.1732026, 30.2258158],
              [50.1743433, 30.2281669],
              [50.1759261, 30.2318992],
              [50.177616, 30.2357698],
              [50.1793595, 30.2397782],
              [50.1805687, 30.2431427],
              [50.1814574, 30.2464171],
              [50.1825508, 30.2501372],
              [50.1828957, 30.2512019],
              [50.1846658, 30.2561332],
              [50.1864356, 30.2609674],
              [50.1890869, 30.2689158],
              [50.1934164, 30.2796154],
              [50.1951446, 30.283477],
              [50.1975481, 30.2891068],
              [50.1978716, 30.2898572],
              [50.1988062, 30.292025],
              [50.1992722, 30.2931058],
              [50.2000071, 30.2949624],
              [50.2006949, 30.2940959],
              [50.2024806, 30.2921888],
              [50.2033959, 30.2912112],
              [50.2074127, 30.2876035],
              [50.2117995, 30.2839979],
              [50.2162398, 30.2809046],
              [50.2215194, 30.2773581],
              [50.2270583, 30.2740025],
              [50.231804, 30.2714226],
              [50.2354966, 30.269662],
              [50.2393989, 30.2679544],
              [50.2429276, 30.2664701],
              [50.2473028, 30.26495],
              [50.2500241, 30.2642369],
              [50.252697, 30.262664],
              [50.2564697, 30.2593669],
              [50.2602425, 30.2566292],
              [50.2641181, 30.253707],
              [50.2695071, 30.2499607],
              [50.2758979, 30.2460888],
              [50.2835046, 30.2417247],
              [50.291855, 30.2374928],
              [50.3110696, 30.2277207],
              [50.3186148, 30.2236858],
              [50.3239478, 30.2217507],
              [50.330967, 30.2190615],
              [50.3400917, 30.2156177],
              [50.3482169, 30.2126466],
              [50.3511657, 30.2113776],
              [50.3578606, 30.2086492],
              [50.3648186, 30.2059172],
              [50.3698731, 30.2035705],
              [50.3799286, 30.1990636],
              [50.3882902, 30.1950804],
              [50.3970222, 30.1910487],
              [50.3987811, 30.1902193],
              [50.406063, 30.1867854],
              [50.4165763, 30.1821897],
              [50.4229433, 30.1800701],
              [50.4302521, 30.1775753],
              [50.4367293, 30.1760579],
              [50.4422037, 30.1747299],
              [50.4483032, 30.1731223],
              [50.4561959, 30.1711339],
              [50.4628793, 30.1695686],
              [50.4693565, 30.1684692],
              [50.4731942, 30.1675214],
              [50.4768295, 30.1670373],
              [50.4836769, 30.1662094],
              [50.5003508, 30.1659333],
              [50.5030833, 30.1660572],
              [50.5044213, 30.1661179],
              [50.5090712, 30.166158],
              [50.5138933, 30.1660606],
              [50.5143547, 30.1660513],
              [50.520584, 30.1655169],
              [50.5198137, 30.1677048],
              [50.5180168, 30.1725464],
              [50.5169868, 30.1752928],
              [50.5155563, 30.1798966],
              [50.5143279, 30.1838988],
              [50.5123368, 30.1908762],
              [50.5114821, 30.1951956],
              [50.5108339, 30.198866],
              [50.5103415, 30.2024422],
              [50.510002, 30.2058295],
              [50.5099449, 30.2102805],
              [50.5096484, 30.2172528],
              [50.5096016, 30.2183513],
              [50.5093766, 30.2275799],
              [50.5099334, 30.2302148],
              [50.5101126, 30.2323903],
              [50.5099716, 30.2390225],
              [50.5102916, 30.2500804],
              [50.510479, 30.2539367],
              [50.5107079, 30.2575652],
              [50.5111047, 30.260028],
              [50.5113982, 30.262495],
              [50.5113679, 30.2659804],
              [50.5117532, 30.2699344],
              [50.5119515, 30.2711421],
              [50.5120315, 30.2738857],
              [50.5124702, 30.2775601],
              [50.5126076, 30.2802566],
              [50.512783, 30.2838827],
              [50.5129661, 30.2872764],
              [50.5135116, 30.2907188],
              [50.5139656, 30.2932788],
              [50.514202, 30.2961607],
              [50.5143851, 30.2994145],
              [50.5146788, 30.3017393],
              [50.5153694, 30.3072262],
              [50.5162049, 30.3140627],
              [50.5164946, 30.3175493],
              [50.5165826, 30.3196861],
              [50.5164527, 30.3222417],
              [50.5164853, 30.3230336],
              [50.5165406, 30.3244732],
              [50.5171167, 30.331214],
              [50.5176659, 30.334979],
              [50.518055, 30.3390254],
              [50.5184517, 30.34228],
              [50.5184365, 30.3439066],
              [50.5185318, 30.3453011],
              [50.5186233, 30.3468807],
              [50.5188217, 30.3486478],
              [50.5190011, 30.3524589],
              [50.5190888, 30.3545956],
              [50.5190698, 30.3569666],
              [50.5190047, 30.3584982],
              [50.5189704, 30.362913],
              [50.5188982, 30.365189],
              [50.5188753, 30.3680676],
              [50.5190657, 30.3704844],
              [50.5193597, 30.3735537],
              [50.5196572, 30.3758311],
              [50.519909, 30.377551],
              [50.5202522, 30.3809904],
              [50.5206032, 30.3834552],
              [50.5206949, 30.3849896],
              [50.5206796, 30.3869884],
              [50.520977, 30.3894981],
              [50.5207594, 30.3904245],
              [50.5204887, 30.3909808],
              [50.5197448, 30.3914428],
              [50.5158655, 30.3937995],
              [50.5105476, 30.3969831],
              [50.5086325, 30.3979528],
              [50.5070419, 30.3986462],
              [50.505764, 30.3992437],
              [50.5045928, 30.4002161],
              [50.5035247, 30.4010039],
              [50.5020903, 30.4017857],
              [50.4999294, 30.4023888],
              [50.4985314, 30.4028482],
              [50.4963265, 30.4039632],
              [50.4930686, 30.4053583],
              [50.4882317, 30.4074984],
              [50.4841346, 30.4094969],
              [50.4800911, 30.4117278],
              [50.4749986, 30.4144687],
              [50.4704855, 30.4175344],
              [50.4667092, 30.4201811],
              [50.4646646, 30.4215285],
              [50.4594308, 30.4261204],
              [50.4557647, 30.4294169],
              [50.4557129, 30.4294643],
              [50.4526215, 30.4322936],
              [50.4494857, 30.4355877],
              [50.4491238, 30.4360099],
              [50.4466629, 30.4388807],
              [50.4441069, 30.4420801],
              [50.4412308, 30.4455126],
              [50.4389838, 30.4482958],
              [50.4347039, 30.4540932],
              [50.4316786, 30.4585468],
              [50.4303209, 30.460402],
              [50.4285966, 30.4628129],
              [50.4260408, 30.4666638],
              [50.4241676, 30.4700936],
              [50.4220351, 30.4743118],
              [50.4202689, 30.4777894],
              [50.4185982, 30.4803401],
              [50.4162485, 30.4840993],
              [50.4132081, 30.4882749],
              [50.4086954, 30.493847],
              [50.4044305, 30.497613],
              [50.4012108, 30.5001249],
              [50.4003105, 30.5019142],
              [50.3968087, 30.5076303],
              [50.3943139, 30.5119636],
              [50.3934057, 30.5137642],
              [50.3911819, 30.5168963],
              [50.3889543, 30.5198885],
              [50.3875197, 30.5221467],
              [50.3868295, 30.5229285],
              [50.3865662, 30.5231573],
              [50.3864593, 30.5235268],
              [50.3864555, 30.524084],
              [50.3866615, 30.52427],
              [50.3870811, 30.5244592],
              [50.387863, 30.5247448],
              [50.3894348, 30.5250364],
              [50.3937797, 30.5261869],
              [50.3967662, 30.5271928],
              [50.3980178, 30.5276143],
              [50.3993264, 30.5278121],
              [50.4006882, 30.5281003],
              [50.401947, 30.5283904],
              [50.4034653, 30.5284966],
              [50.4071923, 30.5285271],
              [50.4105989, 30.5287434],
              [50.4155809, 30.5291606],
              [50.4169997, 30.5291715],
              [50.4202462, 30.5300815],
              [50.4237021, 30.5311301],
              [50.4245413, 30.5312759],
              [50.4264296, 30.5312933],
              [50.4279517, 30.5312142],
              [50.4291612, 30.5309917],
              [50.430889, 30.5311459],
              [50.4313089, 30.5314297],
              [50.4320947, 30.5318076],
              [50.4325675, 30.5319495],
              [50.4331932, 30.5321869],
              [50.4335098, 30.5321431],
              [50.4339828, 30.5319625],
              [50.4345093, 30.531782],
              [50.4353485, 30.5316029],
              [50.4362946, 30.5314739],
              [50.4374505, 30.5313909],
              [50.4381294, 30.5313961],
              [50.4388123, 30.5315886],
              [50.4394913, 30.5319186],
              [50.4408531, 30.532626],
              [50.4419518, 30.5333775],
              [50.4428939, 30.5336635],
              [50.4433669, 30.5336655],
              [50.443947, 30.5336274],
              [50.4446793, 30.5334478],
              [50.4460487, 30.5324858],
              [50.4468918, 30.5320292],
              [50.4477311, 30.5317598],
              [50.4486238, 30.5316282],
              [50.4502524, 30.5313644],
              [50.4515112, 30.5312817],
              [50.4524574, 30.5312451],
              [50.4537164, 30.5312549],
              [50.4552382, 30.5310357],
              [50.4564438, 30.5308151],
              [50.4579696, 30.5304583],
              [50.4600677, 30.5298737],
              [50.4618168, 30.5291406],
              [50.4626174, 30.5290165],
              [50.4665655, 30.5280763],
              [50.470664, 30.5271002],
              [50.4742872, 30.5262371],
              [50.4751207, 30.5262371],
              [50.4754325, 30.5260846],
              [50.4760299, 30.5261395],
              [50.4763044, 30.5261648],
              [50.4763411, 30.5261682],
              [50.4770735, 30.5263155],
              [50.477703, 30.5264128],
              [50.4782295, 30.5263246],
              [50.4791718, 30.5261479],
              [50.4799358, 30.5260427],
              [50.4809537, 30.5259664],
              [50.486414, 30.5279651],
              [50.4892871, 30.5290166],
              [50.4926203, 30.5276359],
              [50.4928969, 30.5273561],
              [50.4937305, 30.5273561],
              [50.4937305, 30.5270764],
              [50.4957074, 30.5270764],
              [50.4965857, 30.5267646],
              [50.4973184, 30.526632],
              [50.4980011, 30.5266369],
              [50.4986838, 30.527014],
              [50.49905, 30.5275749],
              [50.500044, 30.5281788],
              [50.500885, 30.528455],
              [50.5017205, 30.5289658],
              [50.5027657, 30.5292405],
              [50.5039711, 30.5297955],
              [50.5050162, 30.5301672],
              [50.5060119, 30.5305816],
              [50.5065878, 30.5310891],
              [50.5069543, 30.5315981],
              [50.5073205, 30.5321093],
              [50.5076333, 30.5324782],
              [50.5078429, 30.5331716],
              [50.5077934, 30.533679],
              [50.5076866, 30.5341884],
              [50.5075301, 30.5347924],
              [50.5075303, 30.5352075],
              [50.5076369, 30.5355779],
              [50.5079498, 30.5356693],
              [50.5085257, 30.5358091],
              [50.5093649, 30.5358077],
              [50.5100976, 30.535806],
              [50.5103074, 30.5359917],
              [50.5104638, 30.5363149],
              [50.5105172, 30.5367776],
              [50.5103606, 30.5372868],
              [50.5099944, 30.5377953],
              [50.5098436, 30.5382292],
              [50.513329, 30.540057],
              [50.5141333, 30.5399675],
              [50.5150758, 30.5399665],
              [50.5158616, 30.5402424],
              [50.5170173, 30.5411219],
              [50.5173341, 30.5419533],
              [50.518013, 30.5425559],
              [50.5188524, 30.5430621],
              [50.5193786, 30.5432467],
              [50.5202676, 30.5433854],
              [50.5213164, 30.5438472],
              [50.5226288, 30.5446326],
              [50.523468, 30.5452334],
              [50.5243074, 30.5458795],
              [50.5251463, 30.5464803],
              [50.5257797, 30.5470805],
              [50.5263556, 30.5477729],
              [50.5267256, 30.5484668],
              [50.5267864, 30.5487614],
              [50.5269354, 30.549485],
              [50.5269393, 30.5499001],
              [50.5270996, 30.5509655],
              [50.5273628, 30.5517966],
              [50.5275192, 30.5523972],
              [50.5277329, 30.5528131],
              [50.5281526, 30.5529974],
              [50.5286752, 30.552997],
              [50.5303535, 30.5526714],
              [50.530983, 30.552394],
              [50.5318183, 30.5518826],
              [50.5326578, 30.5515134],
              [50.5328161, 30.5514853],
              [50.5331802, 30.5514205],
              [50.5335502, 30.5515143],
              [50.5335663, 30.5515232],
              [50.53397, 30.5517437],
              [50.5341797, 30.5519746],
              [50.53434, 30.5523902],
              [50.5346528, 30.5528064],
              [50.5351792, 30.5534535],
              [50.5356027, 30.5540055],
              [50.5358125, 30.5542859],
              [50.5359192, 30.5543314],
              [50.5364419, 30.5547935],
              [50.5370752, 30.5552988],
              [50.5376549, 30.5557611],
              [50.5386008, 30.5563172],
              [50.5397034, 30.5570091],
              [50.5401763, 30.557471],
              [50.5402833, 30.5577917],
              [50.5402831, 30.5579767],
              [50.5403365, 30.5583942],
              [50.5404471, 30.5589947],
              [50.5406075, 30.5600127],
              [50.5411376, 30.5613523],
              [50.5419272, 30.5622281],
              [50.5426636, 30.5628759],
              [50.5434531, 30.5632915],
              [50.5443991, 30.5635656],
              [50.5451851, 30.563566],
              [50.546238, 30.5634253],
              [50.5472334, 30.5630092],
              [50.548542, 30.562822],
              [50.5491753, 30.5628671],
              [50.5495662, 30.5630552],
              [50.5495663, 30.5662419],
              [50.5492897, 30.5665216],
              [50.548733, 30.5684709],
              [50.5487199, 30.5685105],
              [50.5486349, 30.5687654],
              [50.5483093, 30.5691558],
              [50.5467414, 30.5711446],
              [50.544548, 30.5747983],
              [50.5429307, 30.5770666],
              [50.5413132, 30.5806749],
              [50.5403748, 30.5828959],
              [50.5389672, 30.586735],
              [50.5376624, 30.5902496],
              [50.5367776, 30.5928882],
              [50.5357856, 30.5955263],
              [50.5350533, 30.5974683],
              [50.5343743, 30.5987652],
              [50.5339013, 30.5996434],
              [50.5329589, 30.6008018],
              [50.5300177, 30.6041367],
              [50.52602, 30.6083543],
              [50.5233918, 30.6115977],
              [50.5198097, 30.6151195],
              [50.5169641, 30.6178093],
              [50.513804, 30.620318],
              [50.5123432, 30.6209666],
              [50.51151, 30.6215262],
              [50.5076201, 30.6229159],
              [50.5028964, 30.6242967],
              [50.4901201, 30.6295762],
              [50.4892869, 30.6295761],
              [50.4640264, 30.6425948],
              [50.4531741, 30.6481851],
              [50.4237277, 30.6651337],
              [50.4190046, 30.6706931],
              [50.4165046, 30.6745829],
              [50.416254, 30.6754609],
              [50.4142847, 30.6823624],
              [50.4142846, 30.6860279],
              [50.4142846, 30.6893026],
              [50.4151178, 30.6979125],
              [50.4153944, 30.6981923],
              [50.4153944, 30.7043707],
              [50.4153943, 30.7079123],
              [50.4151177, 30.7087426],
              [50.4148209, 30.7095593],
              [50.4117845, 30.7179121],
              [50.3967815, 30.7276412],
              [50.3942814, 30.7284716],
              [50.392841, 30.7313077],
              [50.3927478, 30.7313133],
              [50.3907014, 30.7314233],
              [50.388466, 30.731494],
              [50.3845788, 30.7313651],
              [50.3812791, 30.731196],
              [50.3772889, 30.7307889],
              [50.3730353, 30.7301932],
              [50.3703805, 30.7297066],
              [50.368042, 30.7292666],
              [50.3654364, 30.7287328],
              [50.363262, 30.7280635],
              [50.3604507, 30.7270187],
              [50.3584366, 30.7262125],
              [50.3561593, 30.7251252],
              [50.3543625, 30.7240425],
              [50.3528862, 30.7227335],
              [50.3513525, 30.7216521],
              [50.3498231, 30.7204804],
              [50.3483505, 30.7191218],
              [50.3477487, 30.7185075],
              [50.3469313, 30.7176732],
              [50.3455657, 30.7159925],
              [50.3441505, 30.7140318],
              [50.3427888, 30.7122586],
              [50.3418999, 30.7110923],
              [50.3411103, 30.7102514],
              [50.3404275, 30.7097336],
              [50.3396377, 30.7091724],
              [50.3388443, 30.7087488],
              [50.3378372, 30.7084594],
              [50.3368263, 30.7084971],
              [50.3354417, 30.7087156],
              [50.3341065, 30.7091667],
              [50.3332291, 30.7094355],
              [50.3317604, 30.7098855],
              [50.3289299, 30.7107868],
              [50.3262597, 30.7118761],
              [50.323204, 30.7135137],
              [50.3209572, 30.7145148],
              [50.3177489, 30.7160139],
              [50.3155516, 30.717198],
              [50.313568, 30.718338],
              [50.3003693, 30.7259553],
              [50.2920409, 30.7308336],
              [50.2811319, 30.7372218],
              [50.2697295, 30.7437902],
              [50.2626725, 30.7479867],
              [50.261055, 30.7489903],
              [50.2599656, 30.7500083],
              [50.2580224, 30.7519123],
              [50.2561264, 30.7535821],
              [50.2541923, 30.7555605],
              [50.2541769, 30.7555763],
              [50.2528573, 30.7569628],
              [50.2515412, 30.7587711],
              [50.2499919, 30.7610021],
              [50.2490157, 30.7635568],
              [50.2460289, 30.7673337],
              [50.243309, 30.7719468],
              [50.2404329, 30.7772965],
              [50.2379189, 30.7814008],
              [50.2377263, 30.7816365],
              [50.2373972, 30.7820344],
              [50.2368162, 30.7827365],
              [50.2351876, 30.784624],
              [50.2328758, 30.7879422],
              [50.2315138, 30.7905283],
              [50.2312051, 30.7921438],
              [50.230793, 30.7945032],
              [50.2302208, 30.7969541],
              [50.2302283, 30.7984362],
              [50.2304459, 30.8001067],
              [50.2309267, 30.8012668],
              [50.2316741, 30.8026608],
              [50.2325783, 30.8036835],
              [50.234436, 30.8054563],
              [50.236187, 30.806811],
              [50.2383653, 30.8089533],
              [50.2409666, 30.8116552],
              [50.2420846, 30.8127738],
              [50.2426896, 30.8178604],
              [50.2430764, 30.8211125],
              [50.2433091, 30.82519],
              [50.2434387, 30.8299144],
              [50.2434539, 30.8325063],
              [50.2432976, 30.8331528],
              [50.2422011, 30.8353968],
              [50.2411993, 30.8374468],
              [50.2379493, 30.8444657],
              [50.2340089, 30.8515256],
              [50.2333795, 30.8533287],
              [50.2322771, 30.8555441],
              [50.2305947, 30.8586381],
              [50.2293816, 30.8606227],
              [50.228592, 30.8621947],
              [50.22723, 30.8659831],
              [50.225387, 30.8698891],
              [50.2251816, 30.8703244],
              [50.2247086, 30.8716186],
              [50.2244989, 30.8724971],
              [50.2242927, 30.8737005],
              [50.2240333, 30.8751809],
              [50.2238807, 30.8774042],
              [50.2231559, 30.8814286],
              [50.2217485, 30.8884604],
              [50.2210732, 30.8923926],
              [50.2206775, 30.8942058],
              [50.2201843, 30.8964656],
              [50.2195587, 30.8993808],
              [50.2190362, 30.9017845],
              [50.2185668, 30.9044682],
              [50.2183609, 30.9062265],
              [50.2181014, 30.907337],
              [50.2174186, 30.9097871],
              [50.2151109, 30.9183923],
              [50.213482, 30.9244052],
              [50.2115289, 30.9292115],
              [50.2108461, 30.9316661],
              [50.2104225, 30.9322635],
              [50.2097283, 30.932354],
              [50.2090912, 30.9322577],
              [50.2045593, 30.9296899],
              [50.1977386, 30.9255333],
              [50.1935807, 30.9232901],
              [50.1865006, 30.919596],
              [50.1804846, 30.9163233],
              [50.1741525, 30.9122114],
              [50.168564, 30.908986],
              [50.1644708, 30.9062325],
              [50.1606943, 30.9037561],
              [50.1564941, 30.9005369],
              [50.1527749, 30.8978283],
              [50.1499594, 30.8954503],
              [50.1461335, 30.8926957],
              [50.1431617, 30.8901316],
              [50.1384887, 30.8862568],
              [50.1357306, 30.8837842],
              [50.1336595, 30.882153],
              [50.1322289, 30.8805216],
              [50.1301613, 30.8783309],
              [50.128254, 30.8761413],
              [50.1262932, 30.8739062],
              [50.1249658, 30.8725979],
              [50.1235885, 30.8712464],
              [50.1223678, 30.8704058],
              [50.1205675, 30.8690965],
              [50.1197028, 30.8685872],
              [50.1188203, 30.8680673],
              [50.117176, 30.8667613],
              [50.1146353, 30.8644725],
              [50.1117746, 30.8621385],
              [50.1094437, 30.860733],
              [50.1055261, 30.8587638],
              [50.1022949, 30.8566594],
              [50.0986442, 30.8541798],
              [50.0962639, 30.8522639],
              [50.0891227, 30.8468881],
              [50.086006, 30.8445044],
              [50.0809859, 30.8406229],
              [50.0766565, 30.8369333],
              [50.0724335, 30.8330097],
              [50.0706565, 30.8309732],
              [50.0697479, 30.8299317],
              [50.0690295, 30.8306933],
              [50.0687905, 30.8309467],
              [50.0654909, 30.8346381],
              [50.0613443, 30.8386052],
              [50.0578269, 30.8428543],
              [50.0528181, 30.8487187],
              [50.0479164, 30.8538415],
              [50.0435448, 30.8586929],
              [50.0401801, 30.8629426],
              [50.035267, 30.8685769],
              [50.0333405, 30.8713077],
              [50.0303689, 30.8716171],
              [50.0250053, 30.8723753],
              [50.0196419, 30.873228],
              [50.013855, 30.8737074],
              [50.0087051, 30.8739117],
              [50.0039788, 30.8741168],
              [50.0001564, 30.874376],
              [49.9922142, 30.8767844],
              [49.9856452, 30.877412],
              [49.9787026, 30.8779507],
              [49.9744035, 30.8779234],
              [49.968197, 30.8778606],
              [49.9619293, 30.8776571],
              [49.9577904, 30.8776306],
              [49.9555053, 30.877364],
              [49.9548836, 30.8782884],
              [49.9527475, 30.8812508],
              [49.9515057, 30.8837558],
              [49.9513917, 30.8839374],
              [49.9510383, 30.8845001],
              [49.9505233, 30.8853201],
              [49.9492835, 30.8877236],
              [49.9485626, 30.8893418],
              [49.9477959, 30.8913747],
              [49.9478149, 30.8928974],
              [49.9479026, 30.8954335],
              [49.9484596, 30.8970937],
              [49.94944, 30.8988408],
              [49.9500389, 30.900084],
              [49.9506415, 30.9012799],
              [49.950981, 30.9028007],
              [49.9511643, 30.9044601],
              [49.9513512, 30.9063044],
              [49.9511185, 30.9088424],
              [49.9510957, 30.9183927],
              [49.9509507, 30.9232344],
              [49.9511222, 30.9264444],
              [49.9512367, 30.9285849],
              [49.9511414, 30.9293713],
              [49.9507713, 30.9296007],
              [49.9500807, 30.9296988],
              [49.9488641, 30.9301671],
              [49.9475441, 30.9307248],
              [49.946808, 30.9312827],
              [49.9454421, 30.9325348],
              [49.9438704, 30.9342949],
              [49.9430848, 30.9352674],
              [49.942562, 30.9358722],
              [49.9422454, 30.9361042],
              [49.9418715, 30.9361056],
              [49.9415512, 30.9359676],
              [49.9411735, 30.9356939],
              [49.9408493, 30.9352807],
              [49.9405783, 30.9348206],
              [49.9402542, 30.9346375],
              [49.9398843, 30.9346389],
              [49.939617, 30.934639],
              [49.9392509, 30.9349202],
              [49.939041, 30.9352884],
              [49.9386253, 30.9361219],
              [49.9381064, 30.9370469],
              [49.9377403, 30.9374635],
              [49.937107, 30.9378823],
              [49.9361572, 30.9383459],
              [49.9353066, 30.9385352],
              [49.9341353, 30.9384962],
              [49.9334412, 30.938407],
              [49.93264, 30.9381816],
              [49.9321593, 30.937907],
              [49.9318351, 30.9375862],
              [49.9318277, 30.9370786],
              [49.9321443, 30.9368467],
              [49.932728, 30.9366575],
              [49.9328346, 30.9365659],
              [49.9343225, 30.9363729],
              [49.9352799, 30.9363695],
              [49.9357032, 30.9363663],
              [49.9359132, 30.9360432],
              [49.9358658, 30.935721],
              [49.935852, 30.9356276],
              [49.9355277, 30.9352618],
              [49.9352035, 30.9346163],
              [49.9348677, 30.9336007],
              [49.934536, 30.9324521],
              [49.9341544, 30.9318512],
              [49.9335098, 30.9312549],
              [49.9329757, 30.9311648],
              [49.9323921, 30.9312615],
              [49.9321282, 30.9312326],
              [49.9315911, 30.9311737],
              [49.9311638, 30.9310371],
              [49.9303092, 30.9306262],
              [49.9285392, 30.9295266],
              [49.9274672, 30.9289809],
              [49.9260216, 30.9282471],
              [49.9250604, 30.9278376],
              [49.9243128, 30.9276554],
              [49.9236754, 30.9277065],
              [49.9234123, 30.9278915],
              [49.9233094, 30.9282606],
              [49.9233131, 30.9286306],
              [49.9236372, 30.9289513],
              [49.9240151, 30.9294101],
              [49.9243432, 30.9299632],
              [49.9246675, 30.9305614],
              [49.9249953, 30.9312521],
              [49.9253274, 30.9320353],
              [49.9253885, 30.9327711],
              [49.9253921, 30.933096],
              [49.9252929, 30.9336027],
              [49.92519, 30.9338815],
              [49.9242936, 30.9343929],
              [49.92371, 30.9347196],
              [49.9230768, 30.9349512],
              [49.9225464, 30.9351407],
              [49.9219094, 30.9350971],
              [49.9213754, 30.935052],
              [49.9207345, 30.9349181],
              [49.920044, 30.9349213],
              [49.9195672, 30.9351091],
              [49.918934, 30.935573],
              [49.9181442, 30.9360852],
              [49.9169313, 30.9371058],
              [49.9130823, 30.9399404],
              [49.9036483, 30.9476021],
              [49.8972626, 30.9524808],
              [49.8936196, 30.9553595],
              [49.8908654, 30.9566215],
              [49.8904616, 30.9569216],
              [49.8884887, 30.9583876],
              [49.8877565, 30.9594053],
              [49.887024, 30.9607005],
              [49.8865088, 30.9625502],
              [49.8862115, 30.9642596],
              [49.8863183, 30.9644455],
              [49.8864899, 30.9653673],
              [49.8869782, 30.9664249],
              [49.8872591, 30.9667821],
              [49.8877372, 30.96739],
              [49.8886491, 30.9681242],
              [49.8896179, 30.9688115],
              [49.8918649, 30.9697691],
              [49.894774, 30.9707405],
              [49.8951303, 30.9708595],
              [49.8990898, 30.9725466],
              [49.9061737, 30.9765699],
              [49.914173, 30.9812795],
              [49.9171257, 30.9828787],
              [49.9195481, 30.9845275],
              [49.9226724, 30.9870957],
              [49.9281769, 30.9914723],
              [49.9347242, 30.9941859],
              [49.9394119, 30.9951493],
              [49.9465117, 30.9964795],
              [49.9533472, 30.9974599],
              [49.9615079, 31.0000702],
              [49.9643708, 31.0030458],
              [49.9700286, 31.0094322],
              [49.97143, 31.0129259],
              [49.971397, 31.0159952],
              [49.9708385, 31.0188329],
              [49.9705635, 31.0198539],
              [49.9678881, 31.0231294],
              [49.9640355, 31.0284276],
              [49.9631278, 31.0299551],
              [49.9616205, 31.0319893],
              [49.9596116, 31.0346164],
              [49.9591027, 31.0356305],
              [49.9587183, 31.0369295],
              [49.9576118, 31.0401995],
              [49.9582391, 31.0424496],
              [49.9587258, 31.043221],
              [49.9598992, 31.0445947],
              [49.9610819, 31.0451158],
              [49.961962, 31.046146],
              [49.9630448, 31.0467516],
              [49.9649783, 31.0480603],
              [49.9658939, 31.0488634],
              [49.9666738, 31.0500066],
              [49.9666664, 31.0506886],
              [49.9659878, 31.0523885],
              [49.9647859, 31.0536294],
              [49.9631682, 31.0566859],
              [49.9623524, 31.0588394],
              [49.9606185, 31.060417],
              [49.9605733, 31.0605056],
              [49.9594041, 31.0627947],
              [49.9571307, 31.0653911],
              [49.9557977, 31.0665171],
              [49.9548584, 31.0678738],
              [49.9531217, 31.0696786],
              [49.9523193, 31.0705816],
              [49.9512541, 31.0713688],
              [49.9495135, 31.0735146],
              [49.9475175, 31.0748626],
              [49.948037, 31.0756626],
              [49.9486948, 31.0758953],
              [49.949486, 31.0760155],
              [49.9506746, 31.0760252],
              [49.9528854, 31.0764245],
              [49.9539702, 31.0766204],
              [49.956872, 31.0769849],
              [49.9597714, 31.0775768],
              [49.9613452, 31.0786126],
              [49.9634448, 31.0798801],
              [49.9655383, 31.0817159],
              [49.9671386, 31.0831285],
              [49.9682825, 31.0844663],
              [49.9701108, 31.0864136],
              [49.9711793, 31.0875851],
              [49.9728776, 31.0892809],
              [49.9741615, 31.0905386],
              [49.9751083, 31.0917968],
              [49.9754568, 31.0929363],
              [49.975841, 31.0936531],
              [49.9760461, 31.09458],
              [49.9770115, 31.0957907],
              [49.9775375, 31.0960223],
              [49.9785858, 31.0968264],
              [49.9807439, 31.0976705],
              [49.9822591, 31.0992429],
              [49.9806907, 31.100751],
              [49.9791954, 31.1015918],
              [49.9780954, 31.102521],
              [49.9777836, 31.1038828],
              [49.9779216, 31.1045065],
              [49.9779726, 31.1047369],
              [49.9793461, 31.1060267],
              [49.9809242, 31.1067213],
              [49.9837072, 31.1093051],
              [49.986223, 31.1116406],
              [49.9885354, 31.1150946],
              [49.9904163, 31.12067],
              [49.9900285, 31.1232389],
              [49.9899942, 31.1256725],
              [49.9891626, 31.1278742],
              [49.9878502, 31.1307217],
              [49.9856912, 31.1341693],
              [49.9806406, 31.1431721],
              [49.9778062, 31.1493277],
              [49.9756583, 31.1542864],
              [49.9747691, 31.1561136],
              [49.9735565, 31.1586049],
              [49.9710768, 31.1626497],
              [49.9678573, 31.167796],
              [49.9631462, 31.1736339],
              [49.9615067, 31.1758131],
              [49.9588584, 31.1793329],
              [49.9557381, 31.1836992],
              [49.9544639, 31.1850783],
              [49.9539642, 31.1894816],
              [49.953641, 31.1933333],
              [49.9536081, 31.1937247],
              [49.9535713, 31.1941632],
              [49.953125, 31.1983843],
              [49.9532775, 31.2042545],
              [49.9534682, 31.2080589],
              [49.9541243, 31.2101664],
              [49.95467, 31.2114047],
              [49.9557419, 31.2114495],
              [49.9587403, 31.2114399],
              [49.9621696, 31.2115691],
              [49.9665641, 31.2122902],
              [49.9748268, 31.2144247],
              [49.9783211, 31.2157449],
              [49.9812318, 31.218213],
              [49.9828035, 31.2199984],
              [49.984478, 31.2216469],
              [49.9858934, 31.2243489],
              [49.987835, 31.2260424],
              [49.9902726, 31.2291088],
              [49.9916268, 31.2306171],
              [49.9968414, 31.2327623],
              [50.0000124, 31.2330397],
              [50.0117279, 31.2381406],
              [50.0436708, 31.2467033],
              [50.0729367, 31.254194],
              [50.1015739, 31.2579107],
              [50.1028171, 31.2580592],
              [50.1040305, 31.2580857],
              [50.1052627, 31.2580808],
              [50.106594, 31.2578916],
              [50.1075554, 31.2574742],
              [50.1092606, 31.2566853],
              [50.1114921, 31.2550654],
              [50.1137198, 31.2529402],
              [50.1167451, 31.2499363],
              [50.1174392, 31.2499817],
              [50.1190988, 31.2502976],
              [50.120968, 31.2503825],
              [50.1224632, 31.2505597],
              [50.1242791, 31.250554],
              [50.1269493, 31.2504053],
              [50.1299934, 31.2503492],
              [50.1329308, 31.2504773],
              [50.1352805, 31.2503759],
              [50.1399269, 31.2504499],
              [50.1424943, 31.2504874],
              [50.1454848, 31.2506606],
              [50.1484221, 31.2508786],
              [50.1504553, 31.2511966],
              [50.1509552, 31.2513377],
              [50.1527063, 31.2518317],
              [50.1552239, 31.2531114],
              [50.1576751, 31.2541667],
              [50.160103, 31.2552118],
              [50.1634293, 31.2566252],
              [50.1656798, 31.2576774],
              [50.1698685, 31.2601022],
              [50.1766931, 31.2642694],
              [50.1800841, 31.2671557],
              [50.1831511, 31.2692639],
              [50.1892815, 31.2730628],
              [50.1948128, 31.2760367],
              [50.196644, 31.2772752],
              [50.1984252, 31.2787885],
              [50.2008516, 31.2810818],
              [50.2035562, 31.283882],
              [50.2052803, 31.2853498],
              [50.2064668, 31.2861286],
              [50.2077559, 31.2868606],
              [50.2093124, 31.2874093],
              [50.2107049, 31.2876344],
              [50.2114526, 31.2875871],
              [50.2124176, 31.2874915],
              [50.213642, 31.2871629],
              [50.2155608, 31.2865115],
              [50.2166786, 31.286092],
              [50.2176399, 31.2858137],
              [50.2182273, 31.2858127],
              [50.2187117, 31.2859488],
              [50.2191429, 31.2864521],
              [50.2193642, 31.2870038],
              [50.2193184, 31.2877434],
              [50.2191163, 31.2888023],
              [50.2179222, 31.2922619],
              [50.2168311, 31.2954424],
              [50.2167894, 31.2963173],
              [50.2166901, 31.2972844],
              [50.2168654, 31.2984381],
              [50.2171975, 31.2995408],
              [50.2177429, 31.30069],
              [50.2183417, 31.3016997],
              [50.2193716, 31.302757],
              [50.220665, 31.3037213],
              [50.2218553, 31.30473],
              [50.2236329, 31.3059227],
              [50.2249794, 31.3067451],
              [50.2263262, 31.3073396],
              [50.2279892, 31.3079339],
              [50.229763, 31.308434],
              [50.2317467, 31.3086105],
              [50.2343711, 31.3087412],
              [50.236351, 31.308735],
              [50.2467612, 31.306489],
              [50.2551509, 31.3151904],
              [50.2710175, 31.330101],
              [50.2763604, 31.3351205],
              [50.2882563, 31.344356],
              [50.2967432, 31.3524734],
              [50.297566, 31.3537631],
              [50.2978882, 31.354037],
              [50.2981126, 31.3546198],
              [50.2986931, 31.3561277],
              [50.2992784, 31.3576481],
              [50.2995551, 31.357928],
              [50.2998317, 31.3584786],
              [50.2998316, 31.3587585],
              [50.2995551, 31.3590383],
              [50.2973316, 31.3618189],
              [50.2967785, 31.3620987],
              [50.2774065, 31.3757213],
              [50.2751766, 31.3780288],
              [50.270004, 31.3835008],
              [50.2648108, 31.3915394],
              [50.2601251, 31.3965859],
              [50.2600674, 31.3966481],
              [50.2457794, 31.3941911],
              [50.234202, 31.4017872],
              [50.2368137, 31.4082167],
              [50.2607013, 31.42384],
              [50.272572, 31.4314116],
              [50.2906772, 31.4405047],
              [50.3009213, 31.4456747],
              [50.3078535, 31.450065],
              [50.3189523, 31.4572918],
              [50.3233738, 31.4601098],
              [50.3350126, 31.4733068],
              [50.3478221, 31.4920615],
              [50.3495668, 31.4989908],
              [50.3490391, 31.5029313],
              [50.3519581, 31.5125104],
              [50.3613097, 31.5302529],
              [50.3637172, 31.5350593],
              [50.3662024, 31.5403525],
              [50.3694927, 31.5468553],
              [50.3692391, 31.5500495],
              [50.3622079, 31.5498707],
              [50.3612668, 31.5520873],
              [50.363045, 31.5571383],
              [50.3632014, 31.5576644],
              [50.3631932, 31.5581894],
              [50.3649115, 31.5618989],
              [50.3702234, 31.5696634],
              [50.3749127, 31.5681997],
              [50.3781561, 31.5684996],
              [50.3808016, 31.5688514],
              [50.3831806, 31.5740522],
              [50.3843071, 31.5795029],
              [50.3873748, 31.5836988],
              [50.3916923, 31.5885383],
              [50.3948177, 31.5928883],
              [50.3938986, 31.5949796],
              [50.3934777, 31.5960909],
              [50.396157, 31.5971395],
              [50.4007967, 31.5982059],
              [50.4056058, 31.5956991],
              [50.4106532, 31.6005631],
              [50.4168909, 31.6043103],
              [50.4279251, 31.6109122],
              [50.441513, 31.6189189],
              [50.4096387, 31.6550502],
              [50.4056337, 31.6650457],
              [50.3944141, 31.676361],
              [50.387064, 31.686168],
              [50.3835957, 31.6939611],
              [50.3832816, 31.7030614],
              [50.3858906, 31.7159837],
              [50.3868137, 31.7301895],
              [50.3512564, 31.7570168],
              [50.3232211, 31.77797],
              [50.3214341, 31.7917363],
              [50.3077107, 31.8060296],
              [50.3118202, 31.8196353],
              [50.3126157, 31.8222215],
              [50.3081556, 31.826769],
              [50.3014001, 31.8343512],
              [50.2967343, 31.8391379],
              [50.2923275, 31.8439207],
              [50.2859096, 31.8445838],
              [50.2850119, 31.8484667],
              [50.2841049, 31.8524667],
              [50.2792148, 31.8509172],
              [50.2790087, 31.8526348],
              [50.2782641, 31.8577355],
              [50.2815276, 31.8588175],
              [50.2848089, 31.8608721],
              [50.2891691, 31.86344],
              [50.2881296, 31.8661445],
              [50.2862618, 31.8683982],
              [50.2835757, 31.8721109],
              [50.2825244, 31.8761586],
              [50.281511, 31.8803941],
              [50.2741246, 31.8871328],
              [50.2674633, 31.8918215],
              [50.2597861, 31.8972734],
              [50.2563841, 31.901378],
              [50.2526596, 31.9057781],
              [50.2526574, 31.9130624],
              [50.2468437, 31.9175632],
              [50.2426374, 31.9214044],
              [50.2417223, 31.9251826],
              [50.2420449, 31.9252258],
              [50.2418073, 31.930283],
              [50.2397404, 31.9318632],
              [50.2399325, 31.9345101],
              [50.240243, 31.9363772],
              [50.2385688, 31.9391792],
              [50.2375261, 31.9409835],
              [50.2371643, 31.9415882],
              [50.236076, 31.9434398],
              [50.2345071, 31.9461685],
              [50.2309664, 31.9477381],
              [50.2264832, 31.9496986],
              [50.2246314, 31.9512991],
              [50.2207655, 31.9545741],
              [50.2134921, 31.9572585],
              [50.2088598, 31.9618277],
              [50.2051625, 31.9653588],
              [50.2038212, 31.9668946],
              [50.2004484, 31.969383],
              [50.1923634, 31.9720886],
              [50.1883103, 31.9769883],
              [50.1847512, 31.9798737],
              [50.1792568, 31.9802829],
              [50.1694679, 31.988155],
              [50.1561069, 31.9944648],
              [50.1436824, 32.0019204],
              [50.132555, 32.0115769],
              [50.1238784, 32.0190257],
              [50.1195602, 32.0228919],
              [50.1098917, 32.0313638],
              [50.0963785, 32.0426499],
              [50.0775086, 32.0559369],
              [50.0569324, 32.0723358],
              [50.0420244, 32.0845968],
              [50.0225048, 32.1009987],
              [50.0159342, 32.1063199],
              [50.0124581, 32.1100709],
              [50.0067901, 32.1159335],
              [49.9961013, 32.1268392],
              [49.9864806, 32.1369787],
              [49.9726179, 32.1512555],
              [49.967267, 32.156911],
              [49.9612093, 32.1633836],
              [49.947463, 32.1775298],
              [49.9422491, 32.1893702],
              [49.9380597, 32.1992988],
              [49.9350575, 32.2060517],
              [49.9313677, 32.2130224],
              [49.9305791, 32.2178471],
              [49.9293527, 32.2261526],
              [49.9276542, 32.2314887],
              [49.9264878, 32.2372759],
              [49.924183, 32.2453158],
              [49.9235078, 32.2528076],
              [49.922121, 32.2576828],
              [49.9195109, 32.2670891],
              [49.9232014, 32.2669626],
              [49.9225233, 32.2791611],
              [49.9221257, 32.2853031],
              [49.9217128, 32.2908507],
              [49.9214428, 32.3037715],
              [49.9115182, 32.3160824],
              [49.9051973, 32.325037],
              [49.8791293, 32.3419225],
              [49.874349, 32.3450448],
              [49.8671969, 32.3496697],
              [49.8530845, 32.3596866],
              [49.8289508, 32.377623],
              [49.8167877, 32.386262],
              [49.8102129, 32.3930142],
              [49.8045235, 32.4100631],
              [49.8010942, 32.4196634],
              [49.7982388, 32.4275802],
              [49.7904243, 32.4342615],
              [49.7857571, 32.4389686],
              [49.778963, 32.4456327],
              [49.7714177, 32.4524451],
              [49.7640036, 32.4577814],
              [49.7616233, 32.4610782],
              [49.7575284, 32.4655334],
              [49.7540742, 32.4673315],
              [49.749868, 32.4698087],
              [49.7462014, 32.4717702],
              [49.7425242, 32.4744554],
              [49.7404517, 32.476356],
              [49.7381668, 32.4785701],
              [49.7360458, 32.4805941],
              [49.7325097, 32.4846041],
              [49.7312048, 32.486634],
              [49.7292441, 32.4886122],
              [49.7273407, 32.4906428],
              [49.7233847, 32.4944183],
              [49.7177055, 32.4994095],
              [49.7174808, 32.499608],
              [49.7152214, 32.5018039],
              [49.7111625, 32.5056568],
              [49.7090254, 32.5080787],
              [49.7072716, 32.510066],
              [49.7055131, 32.5118339],
              [49.7043381, 32.5129922],
              [49.7031022, 32.5137822],
              [49.7018739, 32.5147595],
              [49.6978455, 32.5168602],
              [49.6943625, 32.5190926],
              [49.691677, 32.5205372],
              [49.6895295, 32.521798],
              [49.6864089, 32.5230147],
              [49.6841545, 32.5242269],
              [49.6822244, 32.5254356],
              [49.6799164, 32.5270193],
              [49.6781998, 32.5283655],
              [49.6762163, 32.5296706],
              [49.6746065, 32.5306007],
              [49.6729394, 32.5313499],
              [49.6706276, 32.5326987],
              [49.6684798, 32.534047],
              [49.6659052, 32.5358621],
              [49.6644555, 32.5369765],
              [49.6629104, 32.5392917],
              [49.6613617, 32.5413318],
              [49.6579895, 32.5447663],
              [49.6538046, 32.5483859],
              [49.6504287, 32.551633],
              [49.646515, 32.555253],
              [49.6424369, 32.5590087],
              [49.6429138, 32.5618039],
              [49.6339988, 32.5683713],
              [49.625492, 32.573668],
              [49.6214599, 32.5804755],
              [49.615553, 32.5897906],
              [49.6096134, 32.5985551],
              [49.6044446, 32.6053229],
              [49.5981825, 32.6136233],
              [49.5937501, 32.6180594],
              [49.5850411, 32.6271839],
              [49.5804386, 32.6324168],
              [49.5649528, 32.63671],
              [49.5632821, 32.638885],
              [49.5615042, 32.6411511],
              [49.5600471, 32.6425392],
              [49.5591317, 32.6437418],
              [49.5578346, 32.6450393],
              [49.5570297, 32.6460538],
              [49.5556298, 32.6482272],
              [49.5540123, 32.6502155],
              [49.5522843, 32.6520649],
              [49.5504495, 32.6539198],
              [49.547474, 32.6562801],
              [49.5458526, 32.6576233],
              [49.5437966, 32.6589659],
              [49.5424463, 32.6599424],
              [49.5419617, 32.6611409],
              [49.5370444, 32.6660918],
              [49.5337981, 32.6690056],
              [49.5259551, 32.676179],
              [49.5207596, 32.6808058],
              [49.5166427, 32.6844458],
              [49.5160483, 32.6849713],
              [49.5143737, 32.6875581],
              [49.5124283, 32.6904213],
              [49.5102616, 32.6930992],
              [49.5086364, 32.6948139],
              [49.5067979, 32.6968462],
              [49.5050086, 32.6987415],
              [49.5033838, 32.7005418],
              [49.5019189, 32.7017893],
              [49.5005647, 32.7029502],
              [49.5000772, 32.7030932],
              [49.5002055, 32.7096321],
              [49.5002391, 32.7113466],
              [49.500289, 32.7138876],
              [49.5004487, 32.7147847],
              [49.5008256, 32.7156708],
              [49.5008323, 32.7160473],
              [49.5004575, 32.7160295],
              [49.4878946, 32.7207446],
              [49.4863205, 32.7224433],
              [49.4799022, 32.7294881],
              [49.4767932, 32.7274907],
              [49.4731551, 32.7278668],
              [49.4699917, 32.7349729],
              [49.4649419, 32.7404657],
              [49.4525131, 32.7457109],
              [49.4456033, 32.751201],
              [49.4420354, 32.7572068],
              [49.4366243, 32.76428],
              [49.4354586, 32.7693499],
              [49.4354877, 32.7737911],
              [49.430839, 32.7807178],
              [49.4290062, 32.7839756],
              [49.4271499, 32.7871361],
              [49.4263378, 32.7886019],
              [49.4230656, 32.7901943],
              [49.4201087, 32.7900201],
              [49.4189986, 32.7910884],
              [49.4185258, 32.7916913],
              [49.4182129, 32.7924765],
              [49.4181671, 32.7929878],
              [49.4180678, 32.7935457],
              [49.4181824, 32.7939147],
              [49.418293, 32.7941889],
              [49.4183044, 32.7947911],
              [49.4182548, 32.7952527],
              [49.4181519, 32.7954859],
              [49.417942, 32.7959026],
              [49.4174689, 32.7965551],
              [49.4170456, 32.7970165],
              [49.4164735, 32.7982674],
              [49.4157411, 32.7995186],
              [49.415432, 32.8003535],
              [49.4152259, 32.80091],
              [49.41502, 32.8016042],
              [49.4146539, 32.8022985],
              [49.4143905, 32.8028115],
              [49.4139213, 32.803597],
              [49.4132347, 32.8044316],
              [49.4123306, 32.8053131],
              [49.4112167, 32.8062437],
              [49.4103165, 32.8071703],
              [49.4098433, 32.8080053],
              [49.4088898, 32.8089785],
              [49.4080964, 32.8097689],
              [49.4076196, 32.8104167],
              [49.4073562, 32.8109275],
              [49.4072569, 32.8114403],
              [49.4071579, 32.8119013],
              [49.4068412, 32.8124587],
              [49.4063684, 32.813199],
              [49.4054145, 32.8143571],
              [49.4043006, 32.815335],
              [49.4036635, 32.8160755],
              [49.4029236, 32.8169093],
              [49.4023934, 32.8176985],
              [49.4018671, 32.8184426],
              [49.4016038, 32.8189038],
              [49.4011231, 32.819184],
              [49.400692, 32.8192326],
              [49.4000474, 32.8191409],
              [49.3996696, 32.8191406],
              [49.3992386, 32.8192366],
              [49.3985976, 32.8193749],
              [49.3981132, 32.8195604],
              [49.3976364, 32.8199804],
              [49.3967323, 32.8207693],
              [49.3958818, 32.8216062],
              [49.3937529, 32.8236015],
              [49.3916206, 32.8254117],
              [49.3908807, 32.8262929],
              [49.3898658, 32.8270374],
              [49.3892118, 32.8274854],
              [49.3888511, 32.8277324],
              [49.3877793, 32.8281515],
              [49.3870811, 32.8283837],
              [49.3866182, 32.8284349],
              [49.3862228, 32.8284787],
              [49.3855783, 32.8287116],
              [49.3850976, 32.8290414],
              [49.3836593, 32.8303418],
              [49.3830185, 32.8308477],
              [49.3825913, 32.8311758],
              [49.3815726, 32.8317331],
              [49.3805047, 32.8324318],
              [49.3795966, 32.8331303],
              [49.3781547, 32.8342886],
              [49.3773003, 32.8349382],
              [49.3765563, 32.8357741],
              [49.3760261, 32.8364707],
              [49.3756561, 32.8371198],
              [49.3754427, 32.8374891],
              [49.3753928, 32.8378605],
              [49.3754501, 32.8381836],
              [49.375468, 32.8383206],
              [49.375511, 32.8386489],
              [49.3754615, 32.8389279],
              [49.3751946, 32.8391566],
              [49.374981, 32.8393906],
              [49.3728944, 32.8408314],
              [49.3727408, 32.8409445],
              [49.3711282, 32.8421319],
              [49.3697394, 32.8432006],
              [49.3692588, 32.8435754],
              [49.3682145, 32.8440701],
              [49.3675957, 32.8443632],
              [49.3671645, 32.8445515],
              [49.3664666, 32.8446461],
              [49.3660316, 32.8446472],
              [49.365383, 32.8445102],
              [49.3653722, 32.8445071],
              [49.3647346, 32.8443258],
              [49.3640862, 32.8441437],
              [49.3633841, 32.8439587],
              [49.3625184, 32.843776],
              [49.3615456, 32.8436393],
              [49.3610078, 32.843639],
              [49.3598214, 32.8437339],
              [49.3583108, 32.8438336],
              [49.3569105, 32.8437927],
              [49.354805, 32.8437966],
              [49.3535117, 32.8438449],
              [49.3526496, 32.8439869],
              [49.3519517, 32.8442641],
              [49.3514137, 32.8444509],
              [49.3510399, 32.8446399],
              [49.3507158, 32.8448724],
              [49.350506, 32.8451492],
              [49.3502923, 32.8453831],
              [49.3500785, 32.8456622],
              [49.349594, 32.8457527],
              [49.3490523, 32.8457568],
              [49.3480263, 32.8456644],
              [49.3471689, 32.8454926],
              [49.3471109, 32.8454809],
              [49.3464049, 32.8452529],
              [49.3455391, 32.845025],
              [49.3450508, 32.8446533],
              [49.3445626, 32.8444258],
              [49.3440247, 32.8442428],
              [49.3434297, 32.8441042],
              [49.3428879, 32.8439685],
              [49.3421288, 32.8436428],
              [49.3418044, 32.8434153],
              [49.3413162, 32.8430435],
              [49.3404998, 32.8420248],
              [49.3400916, 32.8415562],
              [49.3397369, 32.8411489],
              [49.3390845, 32.8405044],
              [49.3385391, 32.839992],
              [49.3382148, 32.8397645],
              [49.3376197, 32.8395807],
              [49.3371352, 32.8395811],
              [49.3363801, 32.8396297],
              [49.335144, 32.8399582],
              [49.333313, 32.8402856],
              [49.3316992, 32.840706],
              [49.3312682, 32.8408468],
              [49.3305665, 32.8408961],
              [49.3302419, 32.8409244],
              [49.3300284, 32.840943],
              [49.3293801, 32.8408509],
              [49.3287315, 32.8406686],
              [49.3280829, 32.8403939],
              [49.3280678, 32.8403825],
              [49.3276483, 32.8400679],
              [49.3269996, 32.8398405],
              [49.3266754, 32.8396987],
              [49.3262443, 32.8397019],
              [49.3258667, 32.8397036],
              [49.3256434, 32.8397739],
              [49.3239518, 32.8393477],
              [49.3199377, 32.8393477],
              [49.3195037, 32.8392553],
              [49.3190156, 32.8391653],
              [49.3187445, 32.8391639],
              [49.3184241, 32.8393513],
              [49.3181039, 32.8395837],
              [49.3179437, 32.8399536],
              [49.3177486, 32.8401788],
              [49.3162667, 32.8407837],
              [49.3154145, 32.8409342],
              [49.3145026, 32.8412579],
              [49.3134268, 32.8417733],
              [49.3125113, 32.8422863],
              [49.3123916, 32.8423652],
              [49.3120373, 32.8425988],
              [49.310791, 32.843555],
              [49.3105813, 32.8437281],
              [49.3098296, 32.8444214],
              [49.3087579, 32.8452615],
              [49.3083834, 32.8454356],
              [49.3073579, 32.8459122],
              [49.3063354, 32.8466063],
              [49.3051529, 32.8472126],
              [49.3042374, 32.8476331],
              [49.3034859, 32.8479612],
              [49.3028411, 32.8484733],
              [49.3025207, 32.8488883],
              [49.3021965, 32.849168],
              [49.3018104, 32.8492679],
              [49.3016586, 32.8493072],
              [49.3011169, 32.8492616],
              [49.3006325, 32.8490791],
              [49.3001976, 32.8488951],
              [49.2996655, 32.8487117],
              [49.2996596, 32.8487096],
              [49.2990112, 32.8486219],
              [49.298416, 32.8486679],
              [49.2973403, 32.848854],
              [49.2965911, 32.8490722],
              [49.2963716, 32.8491362],
              [49.2955095, 32.8496926],
              [49.2941664, 32.8506235],
              [49.2934113, 32.851089],
              [49.2924423, 32.8514185],
              [49.291256, 32.8514677],
              [49.2903366, 32.8514213],
              [49.2897415, 32.8511471],
              [49.2891466, 32.850918],
              [49.2882804, 32.8505026],
              [49.2873076, 32.849761],
              [49.2871645, 32.8496655],
              [49.2865487, 32.8492545],
              [49.2859039, 32.8491172],
              [49.2846605, 32.8491204],
              [49.2837981, 32.8492168],
              [49.283043, 32.8495402],
              [49.2818071, 32.8501004],
              [49.2805671, 32.850753],
              [49.2800291, 32.8514491],
              [49.2797277, 32.8519744],
              [49.2796556, 32.8521001],
              [49.2793311, 32.8525624],
              [49.2789001, 32.8527481],
              [49.278633, 32.8527489],
              [49.2783623, 32.8526573],
              [49.2781981, 32.8524295],
              [49.2780393, 32.8523094],
              [49.2777673, 32.8521034],
              [49.2774926, 32.8517344],
              [49.2770082, 32.8515045],
              [49.276306, 32.8515061],
              [49.2755508, 32.8515543],
              [49.2746886, 32.8516055],
              [49.2734452, 32.8517913],
              [49.2724227, 32.8519328],
              [49.2710188, 32.8520284],
              [49.2697257, 32.8522653],
              [49.2692413, 32.8524502],
              [49.268753, 32.8527298],
              [49.2684328, 32.8533319],
              [49.268055, 32.8540775],
              [49.2678415, 32.8546337],
              [49.2674674, 32.8555146],
              [49.2673074, 32.8561167],
              [49.2667694, 32.8567203],
              [49.2661742, 32.8572779],
              [49.2656899, 32.8578845],
              [49.2652587, 32.8581626],
              [49.2641257, 32.8586272],
              [49.2624548, 32.8589106],
              [49.2618573, 32.8591114],
              [49.2612115, 32.8593285],
              [49.2603492, 32.8599816],
              [49.2594873, 32.8607701],
              [49.2587318, 32.8613728],
              [49.2584115, 32.8617021],
              [49.2576523, 32.8618426],
              [49.2570075, 32.8618426],
              [49.2565727, 32.8615186],
              [49.2558708, 32.8609204],
              [49.2555465, 32.860271],
              [49.2553291, 32.8594405],
              [49.2552185, 32.8587445],
              [49.2551612, 32.8578643],
              [49.2548371, 32.8574495],
              [49.2543595, 32.8570382],
              [49.2543527, 32.8570323],
              [49.2543293, 32.8570265],
              [49.2538108, 32.8568963],
              [49.2533262, 32.8568963],
              [49.2527848, 32.8569902],
              [49.2520867, 32.8575937],
              [49.2513275, 32.8578762],
              [49.2500496, 32.8577884],
              [49.2492332, 32.8575132],
              [49.2485771, 32.8572425],
              [49.2480851, 32.8569222],
              [49.2478103, 32.8566027],
              [49.2478599, 32.8561862],
              [49.2478027, 32.8556781],
              [49.2478525, 32.855034],
              [49.2478414, 32.8549973],
              [49.2477418, 32.8546672],
              [49.2473603, 32.8544386],
              [49.2467041, 32.8543054],
              [49.2461625, 32.8543046],
              [49.2455634, 32.8543097],
              [49.2443123, 32.8546416],
              [49.2434425, 32.8548278],
              [49.2424089, 32.8553432],
              [49.2415962, 32.8558999],
              [49.2407578, 32.8563194],
              [49.2405662, 32.8564153],
              [49.2395323, 32.8569261],
              [49.2377435, 32.8580891],
              [49.2372016, 32.8581401],
              [49.2368736, 32.8580927],
              [49.2364351, 32.8579602],
              [49.2357789, 32.8574572],
              [49.2348479, 32.856815],
              [49.2336958, 32.8556218],
              [49.2324408, 32.8547563],
              [49.231781, 32.8542983],
              [49.2307472, 32.8539815],
              [49.2298737, 32.8538474],
              [49.2288359, 32.8535757],
              [49.2274744, 32.8534008],
              [49.2264403, 32.853314],
              [49.2257844, 32.8530883],
              [49.2248572, 32.8528632],
              [49.2237665, 32.8530078],
              [49.2230605, 32.8531961],
              [49.2222444, 32.8531981],
              [49.2215348, 32.8530662],
              [49.2210999, 32.8527917],
              [49.2204399, 32.8523337],
              [49.2198409, 32.8520163],
              [49.2193488, 32.8519258],
              [49.2188074, 32.8520196],
              [49.2179907, 32.8521658],
              [49.217121, 32.8524938],
              [49.2161445, 32.8530053],
              [49.2154923, 32.853607],
              [49.215168, 32.8539766],
              [49.2149581, 32.8546726],
              [49.2144737, 32.8559644],
              [49.2140999, 32.8567054],
              [49.2137224, 32.8571667],
              [49.2130698, 32.8575858],
              [49.2123145, 32.8584678],
              [49.2113382, 32.8593941],
              [49.2100412, 32.86069],
              [49.2085228, 32.8618542],
              [49.2072791, 32.8628736],
              [49.2062493, 32.8636637],
              [49.205059, 32.8645485],
              [49.2042998, 32.8649683],
              [49.2037544, 32.8649221],
              [49.2033692, 32.8646505],
              [49.2030945, 32.8643264],
              [49.2028199, 32.8638693],
              [49.2027628, 32.8634062],
              [49.2027054, 32.8630401],
              [49.2024522, 32.8630096],
              [49.2017232, 32.8632389],
              [49.2002749, 32.8637652],
              [49.2000427, 32.864021],
              [49.1996118, 32.8646235],
              [49.1989631, 32.8654597],
              [49.1983146, 32.8661989],
              [49.1976129, 32.8666645],
              [49.1966896, 32.867039],
              [49.1959839, 32.867322],
              [49.1947367, 32.8683885],
              [49.1932717, 32.869321],
              [49.1918107, 32.8701544],
              [49.190235, 32.8709952],
              [49.1888238, 32.8717887],
              [49.1870919, 32.8729518],
              [49.1853028, 32.8741614],
              [49.1838914, 32.8749504],
              [49.1825369, 32.8757897],
              [49.181343, 32.8764871],
              [49.1804771, 32.8772321],
              [49.1791765, 32.8780203],
              [49.1780394, 32.8788605],
              [49.1768457, 32.8797427],
              [49.176033, 32.8803486],
              [49.1751709, 32.8812763],
              [49.174141, 32.8822939],
              [49.1732751, 32.883129],
              [49.1725733, 32.8836395],
              [49.1719742, 32.8839216],
              [49.171215, 32.8839714],
              [49.1706694, 32.883977],
              [49.1699028, 32.8836546],
              [49.1695213, 32.8834303],
              [49.1689187, 32.8828308],
              [49.1684228, 32.8818675],
              [49.1679268, 32.8810892],
              [49.167431, 32.8806264],
              [49.1669961, 32.8804465],
              [49.1662332, 32.8802233],
              [49.1652489, 32.8800894],
              [49.164486, 32.8797693],
              [49.1636124, 32.8794521],
              [49.1630095, 32.8791321],
              [49.1624108, 32.8787693],
              [49.1620787, 32.8784488],
              [49.1619681, 32.8778046],
              [49.1620751, 32.8775243],
              [49.1622314, 32.8768299],
              [49.1624449, 32.8760462],
              [49.1628722, 32.8751687],
              [49.1630468, 32.8748122],
              [49.1631431, 32.8746157],
              [49.1629754, 32.8738737],
              [49.1624793, 32.8732802],
              [49.1618195, 32.8725468],
              [49.1614379, 32.8720857],
              [49.1608888, 32.8718612],
              [49.1596908, 32.8716362],
              [49.1585997, 32.8713653],
              [49.15707, 32.8708693],
              [49.156086, 32.8704557],
              [49.1549949, 32.8699572],
              [49.1542854, 32.8695003],
              [49.1536827, 32.8694125],
              [49.1531399, 32.8693448],
              [49.1522674, 32.869236],
              [49.1508521, 32.8691519],
              [49.1491622, 32.8689759],
              [49.1472015, 32.8688972],
              [49.1453476, 32.8690005],
              [49.1430627, 32.869014],
              [49.1425723, 32.8690717],
              [49.1414299, 32.8692061],
              [49.1393089, 32.8694948],
              [49.1370774, 32.8698313],
              [49.1350668, 32.8705364],
              [49.1332781, 32.8711928],
              [49.1317023, 32.8718953],
              [49.1304017, 32.8727304],
              [49.1293718, 32.8734748],
              [49.1283988, 32.8743553],
              [49.1278037, 32.8750994],
              [49.1270484, 32.8760261],
              [49.1265641, 32.8769026],
              [49.1264077, 32.8775068],
              [49.1261979, 32.8787031],
              [49.1259309, 32.8796303],
              [49.1257486, 32.8801527],
              [49.1255608, 32.8806912],
              [49.1250229, 32.8815737],
              [49.1245383, 32.8823127],
              [49.1236724, 32.8832399],
              [49.1225356, 32.8842622],
              [49.1211815, 32.8851933],
              [49.1202623, 32.885892],
              [49.11874, 32.8864508],
              [49.1172217, 32.887199],
              [49.1157569, 32.887948],
              [49.114891, 32.888458],
              [49.1141321, 32.8887397],
              [49.1134225, 32.8888846],
              [49.1125527, 32.8889346],
              [49.1116255, 32.8888484],
              [49.1108094, 32.8887594],
              [49.1098825, 32.8884433],
              [49.1086806, 32.8880351],
              [49.1074218, 32.8873982],
              [49.1058921, 32.8866243],
              [49.1038704, 32.8857572],
              [49.1023445, 32.8852605],
              [49.1009788, 32.8850369],
              [49.0999451, 32.8849062],
              [49.0984191, 32.8848695],
              [49.09684, 32.8849717],
              [49.0950469, 32.8852127],
              [49.0935784, 32.8855443],
              [49.0925447, 32.8858712],
              [49.0915146, 32.8864778],
              [49.0908662, 32.8868512],
              [49.0901604, 32.8873184],
              [49.0894584, 32.8879209],
              [49.0887567, 32.8886181],
              [49.0880547, 32.8894506],
              [49.0874632, 32.8903321],
              [49.0871927, 32.890842],
              [49.0870362, 32.8915792],
              [49.0868225, 32.892135],
              [49.0865554, 32.8926427],
              [49.0859071, 32.8934783],
              [49.0851516, 32.8945422],
              [49.0847207, 32.8950992],
              [49.0840719, 32.8955199],
              [49.0832595, 32.8960305],
              [49.0822296, 32.8967317],
              [49.0809822, 32.8975671],
              [49.0804978, 32.897988],
              [49.08012, 32.8983565],
              [49.0790291, 32.8983645],
              [49.078594, 32.8983691],
              [49.0782128, 32.89814],
              [49.0764657, 32.897412],
              [49.0749893, 32.8967737],
              [49.0739518, 32.8965503],
              [49.0728607, 32.8963238],
              [49.0717201, 32.896331],
              [49.0709572, 32.8963846],
              [49.0701982, 32.8966187],
              [49.0693282, 32.8971779],
              [49.0691799, 32.897382],
              [49.0687903, 32.8979181],
              [49.0684699, 32.8986121],
              [49.0684522, 32.8987119],
              [49.0683135, 32.8994912],
              [49.0680503, 32.9005085],
              [49.0677262, 32.9010626],
              [49.0672417, 32.9016188],
              [49.0667535, 32.9019021],
              [49.0658303, 32.9021381],
              [49.0646896, 32.9023752],
              [49.0634347, 32.9023354],
              [49.0616952, 32.9025317],
              [49.0602798, 32.9027262],
              [49.0588684, 32.9030109],
              [49.0577277, 32.9033855],
              [49.0570755, 32.9038037],
              [49.0564803, 32.9042251],
              [49.0559426, 32.9047353],
              [49.0553438, 32.9051092],
              [49.0549659, 32.9051552],
              [49.0544206, 32.9051129],
              [49.0538215, 32.9050247],
              [49.0531656, 32.9049378],
              [49.0527841, 32.9047537],
              [49.0521279, 32.9043422],
              [49.0516358, 32.9040685],
              [49.050537, 32.9029241],
              [49.0499902, 32.902344],
              [49.049713, 32.9020499],
              [49.0488357, 32.9014095],
              [49.0476341, 32.900676],
              [49.0463753, 32.8999033],
              [49.0454482, 32.8995393],
              [49.045233, 32.8994584],
              [49.0443535, 32.8991277],
              [49.0429917, 32.8987704],
              [49.041191, 32.8984108],
              [49.0398828, 32.8981851],
              [49.038685, 32.8981934],
              [49.0379792, 32.8984303],
              [49.0371094, 32.898712],
              [49.0362931, 32.8989021],
              [49.0355339, 32.8992757],
              [49.0342904, 32.8999754],
              [49.0332605, 32.9006265],
              [49.0317422, 32.9014661],
              [49.0304946, 32.9023055],
              [49.0293005, 32.9027759],
              [49.0281065, 32.9031989],
              [49.0275118, 32.9033384],
              [49.026638, 32.9033471],
              [49.0258217, 32.9033049],
              [49.0247306, 32.9031253],
              [49.0234755, 32.9027628],
              [49.0223314, 32.9023096],
              [49.0209083, 32.9018091],
              [49.0200348, 32.9013556],
              [49.0190505, 32.9007155],
              [49.0182837, 32.9001645],
              [49.0176813, 32.8996161],
              [49.0171318, 32.8993413],
              [49.0164975, 32.8988382],
              [49.015971, 32.8983364],
              [49.0149645, 32.8976369],
              [49.0143367, 32.8977427],
              [49.0135984, 32.8981726],
              [49.0129846, 32.8987095],
              [49.0123785, 32.8992193],
              [49.0121241, 32.8998486],
              [49.012134, 32.9004414],
              [49.0120107, 32.9010313],
              [49.0119983, 32.9018629],
              [49.0116669, 32.9023],
              [49.0111636, 32.9026628],
              [49.0103606, 32.903213],
              [49.0099401, 32.9036536],
              [49.0092057, 32.9042565],
              [49.0084071, 32.9046388],
              [49.0073588, 32.9051483],
              [49.0064843, 32.9056441],
              [49.0055757, 32.9060345],
              [49.0046672, 32.90663],
              [49.0043156, 32.907493],
              [49.0045852, 32.9082745],
              [49.0046932, 32.9086448],
              [49.0052678, 32.9094995],
              [49.0060777, 32.9102298],
              [49.0067972, 32.9109612],
              [49.0078093, 32.9114754],
              [49.0082096, 32.911829],
              [49.0089463, 32.9123462],
              [49.0093005, 32.9131483],
              [49.009278, 32.9140496],
              [49.0085389, 32.9146367],
              [49.0080594, 32.9148737],
              [49.0063003, 32.9151821],
              [49.0045269, 32.9144738],
              [49.0034524, 32.9138847],
              [49.0021237, 32.9129934],
              [49.0005791, 32.9123828],
              [48.9988196, 32.9120676],
              [48.9971083, 32.9121711],
              [48.9956257, 32.9126932],
              [48.9948882, 32.9127856],
              [48.9942167, 32.9126556],
              [48.9938003, 32.9122802],
              [48.9935767, 32.9119628],
              [48.9934882, 32.9129332],
              [48.9928323, 32.9125665],
              [48.9920122, 32.9119671],
              [48.9910851, 32.9113277],
              [48.9905397, 32.911098],
              [48.9901581, 32.9110535],
              [48.9898337, 32.9110979],
              [48.9896203, 32.9112861],
              [48.9894026, 32.9114269],
              [48.9890251, 32.9117974],
              [48.9884339, 32.9121711],
              [48.9881096, 32.9124026],
              [48.9875146, 32.9126365],
              [48.9869194, 32.9128231],
              [48.986431, 32.9129189],
              [48.9861604, 32.9129642],
              [48.9855652, 32.9129681],
              [48.9850731, 32.9129218],
              [48.9845846, 32.9128351],
              [48.9843674, 32.9126016],
              [48.983986, 32.9123722],
              [48.9837113, 32.9120522],
              [48.9836006, 32.9118204],
              [48.9835435, 32.9115399],
              [48.9835398, 32.9112197],
              [48.9836463, 32.9108968],
              [48.9837495, 32.9106189],
              [48.9839631, 32.910203],
              [48.9840697, 32.9098778],
              [48.9841195, 32.9095089],
              [48.9841157, 32.908997],
              [48.9841118, 32.9085799],
              [48.9840547, 32.9081641],
              [48.9838869, 32.9078908],
              [48.9835051, 32.9074293],
              [48.9830667, 32.9071088],
              [48.9826849, 32.9069719],
              [48.9822501, 32.9068341],
              [48.9812736, 32.9066966],
              [48.9806746, 32.906608],
              [48.9799155, 32.9066115],
              [48.9794809, 32.9065662],
              [48.9791528, 32.9065203],
              [48.9788246, 32.9063369],
              [48.9785003, 32.9061558],
              [48.978279, 32.9059267],
              [48.9781684, 32.9056927],
              [48.9781646, 32.9054176],
              [48.9782714, 32.9049526],
              [48.9784812, 32.9043045],
              [48.9785309, 32.9037056],
              [48.978548, 32.903547],
              [48.9785805, 32.9032442],
              [48.9785194, 32.9026412],
              [48.978405, 32.9020893],
              [48.9781305, 32.9017173],
              [48.9778594, 32.9014424],
              [48.9774208, 32.9011648],
              [48.976986, 32.9009368],
              [48.9763833, 32.9006159],
              [48.9757882, 32.9006198],
              [48.9749755, 32.9008524],
              [48.9742936, 32.9009437],
              [48.9742698, 32.9009469],
              [48.9734, 32.9007682],
              [48.9728011, 32.90063],
              [48.9719352, 32.9005438],
              [48.971119, 32.9005463],
              [48.9701425, 32.9005057],
              [48.9694901, 32.900459],
              [48.9691084, 32.9002769],
              [48.9688874, 32.8998157],
              [48.9688836, 32.8994436],
              [48.9688759, 32.8987536],
              [48.9688185, 32.8984303],
              [48.9685441, 32.8980132],
              [48.9681624, 32.8977861],
              [48.9678346, 32.8976477],
              [48.9672927, 32.8976479],
              [48.9667511, 32.8977428],
              [48.9663163, 32.8977921],
              [48.9655038, 32.8977969],
              [48.9647981, 32.8977043],
              [48.9642526, 32.8975714],
              [48.9637643, 32.89748],
              [48.963272, 32.897109],
              [48.9628333, 32.8968358],
              [48.9623986, 32.896698],
              [48.9617461, 32.8966107],
              [48.9612578, 32.8965644],
              [48.9607696, 32.8964279],
              [48.9603348, 32.896245],
              [48.9601136, 32.8960159],
              [48.9596216, 32.8956945],
              [48.9588586, 32.8953732],
              [48.9584236, 32.8951902],
              [48.9580423, 32.8950081],
              [48.9576035, 32.894638],
              [48.9570044, 32.8941345],
              [48.9569465, 32.8940734],
              [48.9565657, 32.8936719],
              [48.9560164, 32.8932571],
              [48.9554858, 32.8927051],
              [48.9547279, 32.8922238],
              [48.9540458, 32.8924041],
              [48.953536, 32.8923488],
              [48.9530369, 32.8924726],
              [48.9526053, 32.8925958],
              [48.9521096, 32.8927271],
              [48.9514281, 32.8930684],
              [48.9509538, 32.893425],
              [48.9506413, 32.8938859],
              [48.9501643, 32.8944258],
              [48.9495884, 32.8947777],
              [48.9488323, 32.8948033],
              [48.9481622, 32.8949095],
              [48.9477526, 32.8949317],
              [48.9470357, 32.8948738],
              [48.9462585, 32.8949625],
              [48.9458426, 32.895264],
              [48.945519, 32.8957407],
              [48.9452623, 32.8961189],
              [48.9448573, 32.8970623],
              [48.9445691, 32.8975598],
              [48.9439869, 32.8978808],
              [48.9433844, 32.8979521],
              [48.9428747, 32.8980117],
              [48.9421483, 32.8980449],
              [48.9409318, 32.8976906],
              [48.9399465, 32.8976454],
              [48.9389514, 32.8976503],
              [48.9379344, 32.8976102],
              [48.9372455, 32.8976971],
              [48.9365662, 32.8977851],
              [48.9359048, 32.897532],
              [48.9356049, 32.8970048],
              [48.9352907, 32.896405],
              [48.9350484, 32.8957949],
              [48.9346994, 32.8951421],
              [48.9340791, 32.8949579],
              [48.933495, 32.8951319],
              [48.9327228, 32.8954973],
              [48.9322987, 32.895801],
              [48.9317133, 32.8961375],
              [48.930464, 32.8964691],
              [48.9296511, 32.896754],
              [48.9286326, 32.897098],
              [48.9279404, 32.8973039],
              [48.9273769, 32.8973934],
              [48.9266875, 32.8974549],
              [48.9259578, 32.8973634],
              [48.9258221, 32.8969771],
              [48.9256943, 32.8962231],
              [48.9253914, 32.8953696],
              [48.9248394, 32.8945836],
              [48.924318, 32.8938144],
              [48.9236119, 32.8928987],
              [48.9229989, 32.8920576],
              [48.9224554, 32.8909413],
              [48.9217318, 32.8900871],
              [48.92066, 32.889651],
              [48.9196081, 32.889379],
              [48.9190962, 32.8890716],
              [48.9184442, 32.8888278],
              [48.9173241, 32.8878253],
              [48.9166728, 32.8872015],
              [48.9158238, 32.8864134],
              [48.9142887, 32.8853111],
              [48.913933, 32.8851643],
              [48.9133704, 32.8851298],
              [48.91285, 32.885314],
              [48.912365, 32.8854903],
              [48.9118416, 32.8856589],
              [48.9111427, 32.8859125],
              [48.9104226, 32.88618],
              [48.9098605, 32.8868235],
              [48.9092138, 32.8871442],
              [48.9084323, 32.8873212],
              [48.9074345, 32.8872711],
              [48.9062979, 32.8870113],
              [48.9050066, 32.886696],
              [48.9037978, 32.8860204],
              [48.9034158, 32.88631],
              [48.9027061, 32.8858539],
              [48.9021136, 32.8854446],
              [48.9021073, 32.8854403],
              [48.9015617, 32.8851651],
              [48.9009095, 32.8850753],
              [48.9006385, 32.8849828],
              [48.9004747, 32.8848448],
              [48.9001466, 32.8848911],
              [48.8998756, 32.8849407],
              [48.8994981, 32.8851282],
              [48.8989602, 32.8853604],
              [48.8980369, 32.8856898],
              [48.8970107, 32.8861077],
              [48.8964157, 32.8864787],
              [48.8960954, 32.886807],
              [48.8957178, 32.8870396],
              [48.8943137, 32.8877825],
              [48.893284, 32.8882476],
              [48.8923151, 32.8888084],
              [48.8912314, 32.889462],
              [48.8900986, 32.8901598],
              [48.8893968, 32.8906259],
              [48.8893, 32.8907304],
              [48.8889693, 32.8910876],
              [48.8884851, 32.8915055],
              [48.887947, 32.8921097],
              [48.8872986, 32.8925744],
              [48.8869208, 32.8928994],
              [48.8866396, 32.8929874],
              [48.8863258, 32.8930855],
              [48.8857842, 32.893277],
              [48.8854065, 32.8934126],
              [48.8845938, 32.8935094],
              [48.8837813, 32.8937008],
              [48.8832399, 32.8937953],
              [48.8825342, 32.8938893],
              [48.8821565, 32.8939821],
              [48.881939, 32.8941678],
              [48.8818321, 32.8944478],
              [48.8817292, 32.8947707],
              [48.8816795, 32.895232],
              [48.8816835, 32.8956943],
              [48.8817406, 32.8962025],
              [48.8819084, 32.8966179],
              [48.8820725, 32.8968958],
              [48.882618, 32.8972161],
              [48.8830568, 32.8975865],
              [48.8833848, 32.8979528],
              [48.883385, 32.897953],
              [48.8835489, 32.8980908],
              [48.8836594, 32.8984602],
              [48.8837205, 32.8989212],
              [48.8836708, 32.8995245],
              [48.8835105, 32.8998036],
              [48.8833466, 32.9000353],
              [48.8830262, 32.900359],
              [48.8825951, 32.9007305],
              [48.8820533, 32.9010121],
              [48.8814584, 32.9012455],
              [48.8803787, 32.9018517],
              [48.8793527, 32.9023168],
              [48.8786467, 32.9025032],
              [48.8777277, 32.9026454],
              [48.8768042, 32.90265],
              [48.8756104, 32.9026568],
              [48.874958, 32.9027967],
              [48.8739852, 32.9032176],
              [48.8733369, 32.90345],
              [48.8729592, 32.9037773],
              [48.8726386, 32.9043309],
              [48.8723184, 32.9048417],
              [48.8722152, 32.9053991],
              [48.872326, 32.905906],
              [48.8723833, 32.9062767],
              [48.8725509, 32.9066425],
              [48.8727189, 32.9071053],
              [48.8727226, 32.9074278],
              [48.8727225, 32.9077524],
              [48.872673, 32.9080762],
              [48.8725129, 32.9084004],
              [48.8721352, 32.9085878],
              [48.8716468, 32.9086832],
              [48.8711053, 32.908683],
              [48.8701782, 32.9084598],
              [48.8697432, 32.9083216],
              [48.8685454, 32.9077263],
              [48.8677827, 32.9074067],
              [48.8674011, 32.9072694],
              [48.8668022, 32.9072231],
              [48.8662604, 32.9073176],
              [48.8659934, 32.9075971],
              [48.8656693, 32.9079207],
              [48.8652915, 32.9081532],
              [48.8649672, 32.9083867],
              [48.8645364, 32.9085732],
              [48.864048, 32.9087136],
              [48.8635062, 32.908763],
              [48.8629609, 32.90881],
              [48.8620949, 32.9089079],
              [48.8608473, 32.9089136],
              [48.8589477, 32.9090119],
              [48.8584299, 32.9090526],
              [48.8577005, 32.90911],
              [48.856617, 32.9093484],
              [48.8558578, 32.9095338],
              [48.8552094, 32.9098631],
              [48.8544006, 32.9103745],
              [48.8538629, 32.9108387],
              [48.8534315, 32.9113926],
              [48.8531648, 32.9119945],
              [48.8530083, 32.9126885],
              [48.8530119, 32.9132454],
              [48.8529727, 32.9135383],
              [48.8529129, 32.9139854],
              [48.8527526, 32.9144944],
              [48.852539, 32.9148176],
              [48.8521614, 32.9151921],
              [48.8517304, 32.9156063],
              [48.8509749, 32.9158436],
              [48.8504867, 32.9158893],
              [48.8503727, 32.9159263],
              [48.8500519, 32.9160306],
              [48.8495139, 32.9164497],
              [48.8491363, 32.916867],
              [48.8488693, 32.9173765],
              [48.8488198, 32.9176552],
              [48.8486024, 32.9178881],
              [48.8484421, 32.9181176],
              [48.8482819, 32.9185364],
              [48.8482322, 32.9188129],
              [48.8482971, 32.9199683],
              [48.848297, 32.9202456],
              [48.848301, 32.9204282],
              [48.8483542, 32.9206163],
              [48.8486861, 32.9211225],
              [48.8492888, 32.9219963],
              [48.849617, 32.9223221],
              [48.8497313, 32.9227366],
              [48.8497886, 32.9230623],
              [48.8496862, 32.9234168],
              [48.8496817, 32.9234324],
              [48.8496324, 32.9239388],
              [48.8495253, 32.9242639],
              [48.849312, 32.9245871],
              [48.8491517, 32.9247737],
              [48.8487204, 32.9250075],
              [48.8486794, 32.9250271],
              [48.8482322, 32.9252403],
              [48.8474769, 32.9255227],
              [48.8467713, 32.9258915],
              [48.8465042, 32.9260334],
              [48.8462332, 32.9262655],
              [48.8460731, 32.9266821],
              [48.8459701, 32.9271425],
              [48.8458633, 32.9275622],
              [48.8458708, 32.9282995],
              [48.8460352, 32.9291872],
              [48.8460425, 32.9292268],
              [48.8461532, 32.9297337],
              [48.8461569, 32.9302411],
              [48.8460008, 32.9306554],
              [48.8456765, 32.9308437],
              [48.8450776, 32.9308469],
              [48.8445358, 32.9308511],
              [48.8442076, 32.9307147],
              [48.843609, 32.9304857],
              [48.8431207, 32.9302563],
              [48.8425808, 32.9300067],
              [48.8425179, 32.9299776],
              [48.8420868, 32.9299363],
              [48.8414878, 32.9299846],
              [48.8411637, 32.9301233],
              [48.8407325, 32.9302646],
              [48.8403548, 32.9305422],
              [48.8398132, 32.930871],
              [48.839382, 32.931382],
              [48.8390618, 32.9316606],
              [48.8389017, 32.9320749],
              [48.8388481, 32.9323535],
              [48.8386344, 32.932679],
              [48.8383675, 32.9331388],
              [48.8383178, 32.9337421],
              [48.8383751, 32.9341579],
              [48.8384858, 32.9344326],
              [48.8388176, 32.9350358],
              [48.8394737, 32.9357731],
              [48.8400232, 32.9364161],
              [48.8402977, 32.9368785],
              [48.8405188, 32.9372949],
              [48.8405801, 32.9378009],
              [48.8405944, 32.9378669],
              [48.8406907, 32.9383078],
              [48.8405875, 32.9388155],
              [48.8405379, 32.9393265],
              [48.8403778, 32.939743],
              [48.8402175, 32.9400671],
              [48.8398932, 32.9403456],
              [48.8395158, 32.9406231],
              [48.8389778, 32.9408122],
              [48.8385965, 32.9408146],
              [48.8381615, 32.9407237],
              [48.8377228, 32.9404478],
              [48.8370706, 32.9400826],
              [48.8363609, 32.9396216],
              [48.8357049, 32.9393465],
              [48.8350524, 32.9391639],
              [48.8345108, 32.9392131],
              [48.8341866, 32.9393089],
              [48.8340509, 32.9394025],
              [48.8339157, 32.9394958],
              [48.8333741, 32.9396826],
              [48.8328896, 32.9398681],
              [48.8322944, 32.9401012],
              [48.8316995, 32.9405666],
              [48.8311616, 32.9411231],
              [48.8305703, 32.9417261],
              [48.8298685, 32.942424],
              [48.8295481, 32.9426529],
              [48.8293343, 32.943073],
              [48.8292276, 32.9434432],
              [48.8292312, 32.943858],
              [48.829342, 32.9442748],
              [48.8296203, 32.9449199],
              [48.8301163, 32.9457965],
              [48.8307723, 32.9465789],
              [48.8310509, 32.9471316],
              [48.8310749, 32.9472019],
              [48.8311616, 32.9474559],
              [48.8311118, 32.947827],
              [48.8310051, 32.9481047],
              [48.8308984, 32.9483373],
              [48.8307382, 32.9485216],
              [48.830303, 32.948753],
              [48.8298188, 32.9489408],
              [48.8294944, 32.9491267],
              [48.8292238, 32.9493137],
              [48.8288459, 32.949501],
              [48.8285219, 32.9496419],
              [48.8282508, 32.9498739],
              [48.8279266, 32.9501072],
              [48.8273314, 32.9504328],
              [48.8265762, 32.9508052],
              [48.8261452, 32.951084],
              [48.8256569, 32.9511792],
              [48.8247336, 32.9513209],
              [48.8243028, 32.9515524],
              [48.8235435, 32.9516992],
              [48.8227843, 32.9518393],
              [48.8222427, 32.9519809],
              [48.8215371, 32.9519798],
              [48.8211022, 32.9517513],
              [48.8204459, 32.951431],
              [48.8197367, 32.9509272],
              [48.8193317, 32.9507402],
              [48.8192442, 32.9506999],
              [48.8188097, 32.9506066],
              [48.818161, 32.9506562],
              [48.8177833, 32.9508885],
              [48.8170816, 32.9514917],
              [48.8169646, 32.951629],
              [48.8163299, 32.9523736],
              [48.8158988, 32.9530221],
              [48.8151473, 32.9538566],
              [48.8143387, 32.9543723],
              [48.8136367, 32.9548379],
              [48.8130416, 32.9554407],
              [48.8126144, 32.9559021],
              [48.8123436, 32.956231],
              [48.8119127, 32.9566924],
              [48.8112106, 32.9571581],
              [48.8105622, 32.9574398],
              [48.8096962, 32.9576252],
              [48.8088301, 32.9578174],
              [48.808235, 32.9580505],
              [48.8076934, 32.9583273],
              [48.8072624, 32.9586534],
              [48.8069953, 32.9591176],
              [48.806942, 32.9594886],
              [48.8065645, 32.9596285],
              [48.8063468, 32.9596292],
              [48.8060761, 32.959629],
              [48.8058014, 32.9594911],
              [48.805313, 32.9593541],
              [48.8045501, 32.9591287],
              [48.8036805, 32.9588542],
              [48.8028107, 32.9587171],
              [48.802105, 32.9587205],
              [48.8015061, 32.9587708],
              [48.800911, 32.9590038],
              [48.8004264, 32.9593763],
              [48.7997781, 32.9598428],
              [48.7992935, 32.9599334],
              [48.7984772, 32.959892],
              [48.7976609, 32.9597581],
              [48.7972794, 32.9594809],
              [48.7964592, 32.9588848],
              [48.795639, 32.9581939],
              [48.7948761, 32.9579663],
              [48.7940635, 32.9578325],
              [48.7930299, 32.9578367],
              [48.7921066, 32.9579309],
              [48.7916221, 32.9582605],
              [48.7913017, 32.9587666],
              [48.790924, 32.9591409],
              [48.7905464, 32.9593236],
              [48.7902184, 32.9593268],
              [48.7900544, 32.9590939],
              [48.789074, 32.9587317],
              [48.7882044, 32.958457],
              [48.7874985, 32.9584129],
              [48.7869568, 32.9585544],
              [48.7863579, 32.9586024],
              [48.7855987, 32.9586994],
              [48.7852212, 32.9588392],
              [48.78479, 32.9590254],
              [48.7846259, 32.9591172],
              [48.7841379, 32.9593047],
              [48.7831651, 32.9595873],
              [48.7824591, 32.9598701],
              [48.7815401, 32.9602888],
              [48.7805139, 32.9607553],
              [48.7798652, 32.9613119],
              [48.7792206, 32.9618234],
              [48.7787363, 32.9621958],
              [48.7779236, 32.9627991],
              [48.7769547, 32.9636836],
              [48.7766305, 32.9639619],
              [48.7764701, 32.9643332],
              [48.7762566, 32.9644241],
              [48.7759859, 32.9644734],
              [48.7756042, 32.9643359],
              [48.7751121, 32.9641535],
              [48.7744598, 32.9639705],
              [48.7739721, 32.9638066],
              [48.7739145, 32.9637872],
              [48.7733194, 32.9637901],
              [48.7727202, 32.9637952],
              [48.7721788, 32.9639366],
              [48.7717478, 32.9641679],
              [48.7713701, 32.9645376],
              [48.7711563, 32.964863],
              [48.7709961, 32.9652794],
              [48.7707292, 32.9657909],
              [48.7703513, 32.9663004],
              [48.7702554, 32.9664153],
              [48.7696534, 32.9671356],
              [48.7691689, 32.9674606],
              [48.768303, 32.9678351],
              [48.7682184, 32.9678449],
              [48.7674903, 32.9679288],
              [48.7670555, 32.9679346],
              [48.7665138, 32.9680737],
              [48.7658617, 32.9682153],
              [48.7649711, 32.9683453],
              [48.7648849, 32.9683579],
              [48.7642898, 32.9683608],
              [48.7638015, 32.9683159],
              [48.7634202, 32.9681784],
              [48.7628212, 32.9679489],
              [48.7624397, 32.9676738],
              [48.7622185, 32.9674444],
              [48.7619974, 32.9671203],
              [48.7620505, 32.9667516],
              [48.7621573, 32.9664266],
              [48.762314, 32.965965],
              [48.7623528, 32.965926],
              [48.7629622, 32.9653138],
              [48.7634466, 32.9647566],
              [48.7637102, 32.9640625],
              [48.7640343, 32.9637369],
              [48.7646789, 32.9629481],
              [48.7653236, 32.9621571],
              [48.7658615, 32.9613732],
              [48.7662888, 32.9606775],
              [48.7664489, 32.9601212],
              [48.7663878, 32.9593356],
              [48.7661094, 32.9588279],
              [48.7657813, 32.9584117],
              [48.7654533, 32.9579505],
              [48.7648506, 32.9575384],
              [48.7640877, 32.9569859],
              [48.7628325, 32.9562082],
              [48.7618483, 32.9554714],
              [48.761135, 32.9546899],
              [48.7605858, 32.9538572],
              [48.7603072, 32.9529346],
              [48.7602995, 32.9522852],
              [48.7604064, 32.951825],
              [48.7606735, 32.951176],
              [48.7612647, 32.9505261],
              [48.7620202, 32.949967],
              [48.7626649, 32.949318],
              [48.76326, 32.9488057],
              [48.7641717, 32.9476925],
              [48.7650338, 32.9466258],
              [48.765457, 32.9455603],
              [48.7657777, 32.9447297],
              [48.7658768, 32.9438477],
              [48.7659798, 32.9431529],
              [48.7660254, 32.9419522],
              [48.7659607, 32.9409365],
              [48.7660066, 32.9399634],
              [48.7659453, 32.9389456],
              [48.7657737, 32.9380227],
              [48.7656059, 32.9373321],
              [48.7656518, 32.936359],
              [48.765648, 32.9358968],
              [48.7657546, 32.9355267],
              [48.7659148, 32.935108],
              [48.7663421, 32.9345047],
              [48.7669335, 32.9335775],
              [48.7675209, 32.9327426],
              [48.7681124, 32.9316778],
              [48.7684822, 32.9308435],
              [48.7689628, 32.929921],
              [48.7693368, 32.9288523],
              [48.769436, 32.9278824],
              [48.7695885, 32.9264942],
              [48.7695772, 32.9252022],
              [48.7692414, 32.9242291],
              [48.7689666, 32.9235839],
              [48.7686882, 32.922986],
              [48.767975, 32.9220625],
              [48.7674254, 32.9213268],
              [48.7666627, 32.920727],
              [48.7661171, 32.9203137],
              [48.7642897, 32.9180377],
              [48.7616349, 32.9168185],
              [48.7598593, 32.9170436],
              [48.755292, 32.9164744],
              [48.752983, 32.9152229],
              [48.7512282, 32.9115579],
              [48.7492017, 32.9074671],
              [48.7471753, 32.9039224],
              [48.7457799, 32.9017432],
              [48.741708, 32.8989916],
              [48.7401009, 32.8978049],
              [48.7380218, 32.8973087],
              [48.7351807, 32.8975835],
              [48.7338685, 32.8994216],
              [48.7341929, 32.9011541],
              [48.7338408, 32.902442],
              [48.7315063, 32.9026102],
              [48.7291155, 32.9021081],
              [48.7275411, 32.9012338],
              [48.7268628, 32.899461],
              [48.7252617, 32.8980398],
              [48.7217883, 32.8973072],
              [48.7199026, 32.8956084],
              [48.716316, 32.8911555],
              [48.7137121, 32.8923774],
              [48.7108999, 32.8962061],
              [48.7072031, 32.902423],
              [48.7050813, 32.9052725],
              [48.6993687, 32.907042],
              [48.6953008, 32.9084942],
              [48.6942528, 32.9119811],
              [48.6911346, 32.9150081],
              [48.6890955, 32.9169516],
              [48.686695, 32.9189753],
              [48.6839021, 32.9213477],
              [48.6774157, 32.9292254],
              [48.6685134, 32.934377],
              [48.6632446, 32.9361646],
              [48.6559733, 32.939888],
              [48.6503898, 32.9476055],
              [48.6471638, 32.9491458],
              [48.6409962, 32.9548677],
              [48.636806, 32.9541694],
              [48.6354814, 32.9505641],
              [48.6312258, 32.9430486],
              [48.6267391, 32.937627],
              [48.6208507, 32.9379036],
              [48.6156796, 32.9396993],
              [48.6082857, 32.9464485],
              [48.5912501, 32.9558476],
              [48.5745374, 32.9639392],
              [48.56248, 32.9686038],
              [48.5595102, 32.9711164],
              [48.5596838, 32.9737084],
              [48.5565902, 32.9756971],
              [48.5509963, 32.9760485],
              [48.5490732, 32.9790728],
              [48.5460216, 32.9790355],
              [48.5437075, 32.9805279],
              [48.5427459, 32.9802953],
              [48.5402817, 32.9798486],
              [48.5396919, 32.9815595],
              [48.5378264, 32.9807743],
              [48.5366744, 32.9800866],
              [48.5351944, 32.9790272],
              [48.5340461, 32.9780149],
              [48.53207, 32.9762694],
              [48.5288393, 32.9740143],
              [48.5265924, 32.9726376],
              [48.5229936, 32.9702654],
              [48.5222625, 32.9697835],
              [48.5174943, 32.9670716],
              [48.5143167, 32.9654619],
              [48.5098801, 32.963622],
              [48.5071413, 32.9622869],
              [48.5045663, 32.9616899],
              [48.5022086, 32.9615053],
              [48.499612, 32.9612031],
              [48.492817, 32.9626357],
              [48.4877931, 32.9638332],
              [48.4832037, 32.96494],
              [48.4808459, 32.9651948],
              [48.4790381, 32.9653902],
              [48.4754716, 32.9658816],
              [48.4738998, 32.9658002],
              [48.4697837, 32.9656943],
              [48.4675103, 32.9658511],
              [48.466053, 32.9662814],
              [48.4629248, 32.9672323],
              [48.4593582, 32.9680479],
              [48.4561157, 32.9684935],
              [48.4538955, 32.9685565],
              [48.4496193, 32.9686856],
              [48.4445801, 32.9686772],
              [48.4399184, 32.9682052],
              [48.4365539, 32.9678161],
              [48.4347648, 32.967599],
              [48.4326477, 32.9670573],
              [48.4304695, 32.9662393],
              [48.4275323, 32.9651982],
              [48.4259033, 32.9647025],
              [48.4238433, 32.9646713],
              [48.422586, 32.964731],
              [48.4212455, 32.9647867],
              [48.4172973, 32.9651875],
              [48.4134559, 32.9655881],
              [48.4097213, 32.9657135],
              [48.406414, 32.9655524],
              [48.4039555, 32.9658055],
              [48.4030076, 32.9659031],
              [48.3976441, 32.9657621],
              [48.3934212, 32.965701],
              [48.389679, 32.9654538],
              [48.3861084, 32.9658547],
              [48.3833542, 32.9663402],
              [48.3806038, 32.9671977],
              [48.3782348, 32.9683269],
              [48.3763504, 32.9693152],
              [48.3740844, 32.9700272],
              [48.371601, 32.9707413],
              [48.3696594, 32.971176],
              [48.3664246, 32.9725009],
              [48.3617935, 32.974434],
              [48.3591004, 32.9756168],
              [48.3575363, 32.9762307],
              [48.3555908, 32.9765253],
              [48.352726, 32.9771949],
              [48.3471642, 32.9784879],
              [48.3438224, 32.9795799],
              [48.3410682, 32.9803891],
              [48.3401491, 32.9806775],
              [48.3378868, 32.9813875],
              [48.3352432, 32.9821515],
              [48.3340034, 32.9827607],
              [48.3323364, 32.9836087],
              [48.330288, 32.9844124],
              [48.3281822, 32.9849399],
              [48.3266182, 32.9854631],
              [48.3253784, 32.9861173],
              [48.3231735, 32.9871565],
              [48.320423, 32.9882899],
              [48.3134689, 32.9906582],
              [48.3068352, 32.9929811],
              [48.3048363, 32.9935533],
              [48.3024064, 32.9941252],
              [48.2990609, 32.9949409],
              [48.296196, 32.9956091],
              [48.2930603, 32.9959604],
              [48.2901383, 32.9962148],
              [48.2881356, 32.9962772],
              [48.2869492, 32.9965625],
              [48.2855416, 32.9968069],
              [48.2827414, 32.9970014],
              [48.2818107, 32.997066],
              [48.2796974, 32.9971281],
              [48.2775841, 32.996913],
              [48.2759552, 32.9966971],
              [48.2759018, 32.9966508],
              [48.2745972, 32.9963338],
              [48.2736169, 32.9957421],
              [48.2730141, 32.9953773],
              [48.272419, 32.9952426],
              [48.2710571, 32.994602],
              [48.2699622, 32.9938702],
              [48.2689253, 32.9930986],
              [48.268486, 32.9927718],
              [48.26614, 32.9912147],
              [48.2635194, 32.9897079],
              [48.2620506, 32.9889341],
              [48.2609995, 32.9883782],
              [48.2604141, 32.9880687],
              [48.2593193, 32.9871949],
              [48.2580071, 32.9861404],
              [48.2569122, 32.985084],
              [48.2551003, 32.9831553],
              [48.2531777, 32.9810415],
              [48.2514267, 32.9794815],
              [48.2499466, 32.9781032],
              [48.24965, 32.9765745],
              [48.2491394, 32.9739425],
              [48.2470818, 32.971465],
              [48.2451249, 32.9682955],
              [48.2441292, 32.9673809],
              [48.2404862, 32.9643972],
              [48.2386664, 32.9629753],
              [48.2358436, 32.9599871],
              [48.2348116, 32.9591663],
              [48.23452, 32.9589344],
              [48.2321015, 32.9573751],
              [48.2303963, 32.9560886],
              [48.2286873, 32.9547163],
              [48.2273064, 32.9534752],
              [48.2254257, 32.9513169],
              [48.222599, 32.9479181],
              [48.2205544, 32.9457132],
              [48.2189483, 32.9438787],
              [48.2164649, 32.9413034],
              [48.2134857, 32.9384126],
              [48.2103462, 32.9355205],
              [48.2073631, 32.9322622],
              [48.2039413, 32.9284011],
              [48.2006875, 32.9250058],
              [48.1991997, 32.9235389],
              [48.1973725, 32.920917],
              [48.1943398, 32.9175649],
              [48.1914673, 32.9137541],
              [48.1879959, 32.9098961],
              [48.1861687, 32.9070014],
              [48.183361, 32.9040146],
              [48.1820567, 32.9026734],
              [48.1817093, 32.9023162],
              [48.1796875, 32.9009407],
              [48.1780471, 32.9001621],
              [48.1767425, 32.8997539],
              [48.1755486, 32.8997563],
              [48.1718635, 32.9000403],
              [48.1691018, 32.9005548],
              [48.1657486, 32.9015764],
              [48.1652247, 32.9018459],
              [48.1641738, 32.9023863],
              [48.1633224, 32.9028242],
              [48.1610031, 32.9040292],
              [48.1594926, 32.9049979],
              [48.1586081, 32.9059827],
              [48.158207, 32.9064293],
              [48.1575737, 32.9079521],
              [48.1554795, 32.9100276],
              [48.1537055, 32.9117363],
              [48.1515046, 32.9139018],
              [48.1496734, 32.9152913],
              [48.1484908, 32.9165806],
              [48.1473046, 32.9172748],
              [48.1456833, 32.9180605],
              [48.1436807, 32.9188036],
              [48.1415176, 32.9194979],
              [48.1397248, 32.9197341],
              [48.1385345, 32.9198759],
              [48.1376648, 32.9198808],
              [48.1368485, 32.9197426],
              [48.1356505, 32.919377],
              [48.1341172, 32.9183231],
              [48.1327477, 32.9171759],
              [48.1310501, 32.9156606],
              [48.1295127, 32.9139168],
              [48.1280898, 32.9126331],
              [48.1265488, 32.9106097],
              [48.1238519, 32.9066122],
              [48.1225853, 32.9046356],
              [48.1206055, 32.901741],
              [48.1195068, 32.9001807],
              [48.1186829, 32.8990325],
              [48.1187325, 32.8984792],
              [48.1190986, 32.8971893],
              [48.1194688, 32.8961746],
              [48.1202163, 32.8947944],
              [48.1212311, 32.893089],
              [48.1219787, 32.8920243],
              [48.1230507, 32.8905073],
              [48.1243973, 32.8893504],
              [48.1245472, 32.8889917],
              [48.1248208, 32.8883369],
              [48.1253547, 32.8874633],
              [48.1255646, 32.886632],
              [48.1253549, 32.8859945],
              [48.1251716, 32.8854373],
              [48.1253853, 32.8848833],
              [48.1257586, 32.8844964],
              [48.1259193, 32.8843298],
              [48.1266212, 32.8839154],
              [48.1273155, 32.8829915],
              [48.1280097, 32.8816528],
              [48.1285935, 32.8804085],
              [48.1285323, 32.8795822],
              [48.1285248, 32.87889],
              [48.1285668, 32.8777392],
              [48.1285591, 32.8766819],
              [48.1282767, 32.8757175],
              [48.1282081, 32.8742914],
              [48.1285249, 32.8733205],
              [48.1286773, 32.8724021],
              [48.1288833, 32.8712956],
              [48.1288223, 32.8704693],
              [48.1282768, 32.8702404],
              [48.1276245, 32.8699188],
              [48.1263809, 32.8699691],
              [48.1256751, 32.8700611],
              [48.1246986, 32.8698809],
              [48.1239929, 32.8693778],
              [48.1236611, 32.8689148],
              [48.1230049, 32.868228],
              [48.1226234, 32.8676761],
              [48.1219635, 32.8668021],
              [48.1207658, 32.866069],
              [48.1195371, 32.865538],
              [48.1187553, 32.8652],
              [48.1173362, 32.8639637],
              [48.1161346, 32.8629983],
              [48.1151542, 32.8624505],
              [48.1146012, 32.8608848],
              [48.1138915, 32.8602914],
              [48.1141502, 32.859774],
              [48.1144218, 32.8592307],
              [48.1141433, 32.8583114],
              [48.1141319, 32.8570219],
              [48.1138001, 32.8559639],
              [48.1135178, 32.8548124],
              [48.1127548, 32.8541253],
              [48.1119347, 32.8529772],
              [48.1104622, 32.8518748],
              [48.1092605, 32.8505893],
              [48.1073569, 32.8492627],
              [48.106936, 32.8491029],
              [48.1062699, 32.8488499],
              [48.105236, 32.8480236],
              [48.1043091, 32.8469653],
              [48.1040841, 32.8459548],
              [48.1045036, 32.8445738],
              [48.1043761, 32.8442421],
              [48.105734, 32.8435321],
              [48.1064337, 32.8425198],
              [48.1077472, 32.8373066],
              [48.1114794, 32.8353214],
              [48.1149866, 32.832806],
              [48.1183216, 32.8335299],
              [48.1208057, 32.8307657],
              [48.1144269, 32.8246248],
              [48.109829, 32.8208779],
              [48.1071238, 32.8155439],
              [48.0979953, 32.8061275],
              [48.0899842, 32.8047236],
              [48.0797724, 32.8002151],
              [48.0783467, 32.8007824],
              [48.0789286, 32.8034739],
              [48.074976, 32.8078603],
              [48.0654841, 32.8086245],
              [48.0579445, 32.8101805],
              [48.0575661, 32.8099624],
              [48.0574592, 32.8099007],
              [48.0562783, 32.8092197],
              [48.049889, 32.8061937],
              [48.0490266, 32.8057852],
              [48.0488091, 32.8054172],
              [48.0490227, 32.8050954],
              [48.0499955, 32.8049538],
              [48.0501533, 32.8049608],
              [48.0509682, 32.804997],
              [48.0517769, 32.8049057],
              [48.0526351, 32.8044864],
              [48.0536041, 32.8037947],
              [48.0544091, 32.8032389],
              [48.0546761, 32.8024563],
              [48.0548325, 32.8015832],
              [48.0547219, 32.8006587],
              [48.0544472, 32.7997845],
              [48.0543862, 32.7990956],
              [48.0543614, 32.7990261],
              [48.0542222, 32.7986365],
              [48.0540542, 32.7975349],
              [48.0542068, 32.7952778],
              [48.0543666, 32.7946053],
              [48.05447, 32.7941705],
              [48.0545196, 32.7935248],
              [48.054512, 32.7920528],
              [48.0543441, 32.7912262],
              [48.0544558, 32.7903377],
              [48.0546192, 32.7896279],
              [48.0550052, 32.7879504],
              [48.0550873, 32.7878686],
              [48.0551873, 32.7872656],
              [48.0552368, 32.7866221],
              [48.0553437, 32.786255],
              [48.0555573, 32.7861586],
              [48.055935, 32.7863884],
              [48.0562592, 32.7867115],
              [48.0565091, 32.7869798],
              [48.0568581, 32.7873545],
              [48.0571862, 32.7881353],
              [48.0578384, 32.7894669],
              [48.0584373, 32.7901572],
              [48.0589791, 32.7907514],
              [48.0591966, 32.7909842],
              [48.0605469, 32.7913472],
              [48.0616799, 32.7914347],
              [48.0629195, 32.7916644],
              [48.0638923, 32.7916602],
              [48.065403, 32.7915649],
              [48.0661545, 32.7913323],
              [48.0672837, 32.7907299],
              [48.0677644, 32.7902679],
              [48.0680847, 32.7896691],
              [48.0682412, 32.7888861],
              [48.0682373, 32.7883338],
              [48.0679093, 32.7876004],
              [48.0675278, 32.7865411],
              [48.0670357, 32.7856685],
              [48.0659485, 32.7843808],
              [48.0640564, 32.7828714],
              [48.0622635, 32.781033],
              [48.060154, 32.7795229],
              [48.0595055, 32.778969],
              [48.058693, 32.7784202],
              [48.0584903, 32.7783338],
              [48.0578308, 32.7780528],
              [48.0569115, 32.7776863],
              [48.0562095, 32.7773205],
              [48.0551262, 32.7765895],
              [48.054802, 32.7760342],
              [48.0545807, 32.7755309],
              [48.0542527, 32.7741956],
              [48.0538101, 32.7720822],
              [48.0537675, 32.7706794],
              [48.0537415, 32.7698244],
              [48.0535697, 32.767758],
              [48.05373, 32.7672051],
              [48.0540505, 32.7670165],
              [48.0544815, 32.7668802],
              [48.054966, 32.7669682],
              [48.0554505, 32.7671509],
              [48.0560989, 32.7676124],
              [48.0565339, 32.7678864],
              [48.0572357, 32.7683897],
              [48.0575599, 32.7686205],
              [48.0580445, 32.7688032],
              [48.0587465, 32.768752],
              [48.0601997, 32.7685202],
              [48.0614929, 32.7685619],
              [48.0627824, 32.7686034],
              [48.0635375, 32.7685129],
              [48.0644494, 32.76823],
              [48.0649873, 32.767864],
              [48.0661125, 32.767124],
              [48.0670242, 32.766521],
              [48.0676155, 32.7658767],
              [48.0680924, 32.76509],
              [48.0686799, 32.764263],
              [48.0687829, 32.7633391],
              [48.0686684, 32.7624213],
              [48.0683975, 32.7618717],
              [48.0681762, 32.7613639],
              [48.067852, 32.7609055],
              [48.066986, 32.760448],
              [48.0663948, 32.7602651],
              [48.0655861, 32.760174],
              [48.0646171, 32.7601783],
              [48.062893, 32.7599058],
              [48.0626224, 32.7599175],
              [48.0617103, 32.7599569],
              [48.060955, 32.7598197],
              [48.0596085, 32.7595018],
              [48.0590133, 32.7590416],
              [48.058792, 32.7579838],
              [48.0588379, 32.7568782],
              [48.0589272, 32.7566284],
              [48.0593148, 32.7555438],
              [48.0600128, 32.7548074],
              [48.0610275, 32.7541122],
              [48.0623664, 32.7528656],
              [48.063221, 32.7515761],
              [48.0636444, 32.7507431],
              [48.063501, 32.7501199],
              [48.0634499, 32.7491833],
              [48.0634422, 32.7485858],
              [48.0639153, 32.747657],
              [48.0641213, 32.7469631],
              [48.0645408, 32.7461773],
              [48.0647468, 32.7454834],
              [48.0648994, 32.7447432],
              [48.0648919, 32.7442358],
              [48.0646095, 32.7435959],
              [48.064331, 32.7431836],
              [48.063884, 32.7429377],
              [48.063839, 32.7429129],
              [48.0631828, 32.7426406],
              [48.0625267, 32.7424651],
              [48.0618209, 32.7423787],
              [48.0611686, 32.7423859],
              [48.0604096, 32.7423028],
              [48.0600776, 32.7419817],
              [48.0598526, 32.7415233],
              [48.0597916, 32.7409697],
              [48.0599975, 32.7403727],
              [48.0609626, 32.7396245],
              [48.061689, 32.7392354],
              [48.0635986, 32.7382123],
              [48.0648422, 32.7378312],
              [48.0656013, 32.7376822],
              [48.0664139, 32.737584],
              [48.0671158, 32.7373007],
              [48.0678138, 32.737015],
              [48.0684585, 32.73655],
              [48.0686188, 32.7364073],
              [48.0686684, 32.7360388],
              [48.0686645, 32.7357141],
              [48.0684395, 32.7352107],
              [48.0681114, 32.7350768],
              [48.0677834, 32.7350804],
              [48.0673484, 32.7350837],
              [48.0670739, 32.7349015],
              [48.0667457, 32.7345399],
              [48.066655, 32.7340791],
              [48.0666276, 32.7339399],
              [48.066616, 32.7332499],
              [48.0665475, 32.732509],
              [48.0665359, 32.7317739],
              [48.0665779, 32.7310379],
              [48.0669441, 32.7302012],
              [48.0675392, 32.729965],
              [48.0678112, 32.7299255],
              [48.0685693, 32.7298155],
              [48.0700874, 32.729709],
              [48.0714988, 32.7298322],
              [48.072319, 32.7301444],
              [48.0728683, 32.7305562],
              [48.0742874, 32.7310942],
              [48.0757636, 32.7316787],
              [48.0776711, 32.7321672],
              [48.0785941, 32.7321549],
              [48.0793038, 32.7323293],
              [48.0800628, 32.732232],
              [48.0805474, 32.731948],
              [48.0809746, 32.7315793],
              [48.0811272, 32.7309292],
              [48.081543, 32.7299111],
              [48.0819626, 32.7288931],
              [48.0819511, 32.7281107],
              [48.0819397, 32.7273756],
              [48.0816003, 32.7265923],
              [48.0814285, 32.7260429],
              [48.0814209, 32.7254905],
              [48.0816344, 32.7252588],
              [48.081955, 32.7250679],
              [48.0824966, 32.7250625],
              [48.0828782, 32.7250601],
              [48.0835839, 32.7250517],
              [48.0839082, 32.725048],
              [48.0843392, 32.72472],
              [48.0845986, 32.7239799],
              [48.0845795, 32.7228773],
              [48.0845681, 32.7220926],
              [48.084938, 32.7215806],
              [48.0854149, 32.7207487],
              [48.0859489, 32.7200962],
              [48.0860481, 32.7196815],
              [48.0860444, 32.7194064],
              [48.0859832, 32.7189452],
              [48.0858688, 32.7184827],
              [48.0854187, 32.7177037],
              [48.0848656, 32.7170191],
              [48.0842057, 32.7164718],
              [48.0835496, 32.7161094],
              [48.0830421, 32.7160785],
              [48.0829505, 32.7160729],
              [48.0820235, 32.7158057],
              [48.0802841, 32.715684],
              [48.078659, 32.715885],
              [48.0765991, 32.7161819],
              [48.0753594, 32.7166556],
              [48.0741157, 32.7168542],
              [48.0732459, 32.7167707],
              [48.0724297, 32.7167314],
              [48.0718802, 32.7164165],
              [48.0710068, 32.7161031],
              [48.0705643, 32.7154166],
              [48.0703392, 32.7150033],
              [48.0701065, 32.714085],
              [48.0698814, 32.7135321],
              [48.0696526, 32.7127942],
              [48.0692672, 32.7124786],
              [48.0686645, 32.7121625],
              [48.0678977, 32.7118448],
              [48.0669747, 32.7117646],
              [48.0661583, 32.7115899],
              [48.0652351, 32.7115976],
              [48.0645828, 32.7115598],
              [48.0640908, 32.7113341],
              [48.0638122, 32.710967],
              [48.0636979, 32.7104143],
              [48.0637931, 32.7096299],
              [48.0639953, 32.7087511],
              [48.0645027, 32.7082663],
              [48.0645294, 32.7082407],
              [48.0656623, 32.7077218],
              [48.0677147, 32.7071004],
              [48.0693359, 32.7067597],
              [48.0705796, 32.7064281],
              [48.0718193, 32.7057223],
              [48.072731, 32.704975],
              [48.0737457, 32.7040453],
              [48.0744362, 32.7032094],
              [48.0748558, 32.7022364],
              [48.0753365, 32.7015827],
              [48.0759773, 32.7009801],
              [48.0764655, 32.7009284],
              [48.0771714, 32.7009201],
              [48.0776063, 32.7010564],
              [48.0781517, 32.7012337],
              [48.0789222, 32.7018737],
              [48.0798531, 32.7023237],
              [48.0804672, 32.7032847],
              [48.0814055, 32.7042893],
              [48.0821724, 32.704697],
              [48.0826072, 32.7048762],
              [48.0832634, 32.7051462],
              [48.0844574, 32.7051357],
              [48.0852738, 32.7051276],
              [48.0859222, 32.7049827],
              [48.0865632, 32.7042853],
              [48.0866013, 32.7034522],
              [48.08675, 32.7024391],
              [48.0870552, 32.7012832],
              [48.0874786, 32.7005424],
              [48.088005, 32.6995246],
              [48.0889702, 32.6987311],
              [48.0895538, 32.6978025],
              [48.0900269, 32.6969231],
              [48.0903968, 32.6962285],
              [48.0904389, 32.6956299],
              [48.0903205, 32.6948473],
              [48.0901947, 32.6939698],
              [48.0899544, 32.6925465],
              [48.0897255, 32.6917658],
              [48.0891686, 32.6908941],
              [48.0886116, 32.6899795],
              [48.0883137, 32.689622],
              [48.0881156, 32.6893842],
              [48.0873985, 32.6888852],
              [48.0865288, 32.6886644],
              [48.0853843, 32.688489],
              [48.0846749, 32.6882674],
              [48.0840225, 32.6880426],
              [48.0833663, 32.6878628],
              [48.0818368, 32.6873697],
              [48.0798188, 32.6866532],
              [48.0767631, 32.6857638],
              [48.0756226, 32.6855885],
              [48.0749093, 32.685272],
              [48.0745811, 32.685048],
              [48.0744629, 32.6845403],
              [48.0744553, 32.684033],
              [48.0743942, 32.6834839],
              [48.0744324, 32.6826981],
              [48.0744924, 32.6821173],
              [48.0745278, 32.681774],
              [48.0745164, 32.6811291],
              [48.0738564, 32.6804465],
              [48.0737267, 32.6792939],
              [48.0732269, 32.6786083],
              [48.0730592, 32.6782415],
              [48.0729942, 32.6775976],
              [48.0727691, 32.6770897],
              [48.0718955, 32.6766862],
              [48.070919, 32.6766927],
              [48.0700981, 32.6766379],
              [48.0697212, 32.6766128],
              [48.068798, 32.676483],
              [48.0676537, 32.6762196],
              [48.066887, 32.6758568],
              [48.0658416, 32.6751291],
              [48.064911, 32.6745416],
              [48.0630035, 32.6741904],
              [48.0618629, 32.6739698],
              [48.0594102, 32.6735337],
              [48.057129, 32.6733697],
              [48.0546874, 32.6733484],
              [48.0525704, 32.6735534],
              [48.0510559, 32.6738423],
              [48.0499763, 32.6743173],
              [48.0492248, 32.6747369],
              [48.0484772, 32.6755284],
              [48.0480004, 32.6763151],
              [48.0478516, 32.6770554],
              [48.0473175, 32.6775703],
              [48.0468864, 32.6777562],
              [48.0462342, 32.6777183],
              [48.0452004, 32.6776353],
              [48.0443802, 32.6774131],
              [48.043129, 32.6770546],
              [48.0416526, 32.6764269],
              [48.0400123, 32.6757954],
              [48.0388145, 32.6755756],
              [48.0371322, 32.6754998],
              [48.0352325, 32.675563],
              [48.0335502, 32.6756292],
              [48.0322495, 32.6757314],
              [48.030674, 32.6757459],
              [48.0298042, 32.6757095],
              [48.0291482, 32.675437],
              [48.0283851, 32.675171],
              [48.0276146, 32.6744833],
              [48.0271683, 32.673889],
              [48.0265656, 32.6734352],
              [48.0260125, 32.6728856],
              [48.0255241, 32.6727072],
              [48.0247613, 32.6725314],
              [48.0239448, 32.6724015],
              [48.0231819, 32.6723586],
              [48.0223694, 32.6725084],
              [48.0211753, 32.6725206],
              [48.0202561, 32.6727557],
              [48.0188485, 32.6729544],
              [48.0178756, 32.673195],
              [48.0159835, 32.6737224],
              [48.0145759, 32.6739662],
              [48.0132789, 32.6743477],
              [48.0119285, 32.6748204],
              [48.0107421, 32.675155],
              [48.0100366, 32.6753456],
              [48.0093917, 32.6756322],
              [48.0086326, 32.6756366],
              [48.0082474, 32.6755035],
              [48.0073776, 32.6752348],
              [48.0067215, 32.6750568],
              [48.0062828, 32.6748773],
              [48.0058479, 32.6746979],
              [48.0050887, 32.6747023],
              [48.0042152, 32.6745259],
              [48.0034026, 32.6745335],
              [48.0020447, 32.6745484],
              [48.0014992, 32.6743235],
              [48.0011634, 32.6738669],
              [48.0009957, 32.673358],
              [48.0012512, 32.6724806],
              [48.0012435, 32.6718786],
              [48.0012401, 32.6716658],
              [48.001236, 32.6714164],
              [48.0013351, 32.6708643],
              [48.0014801, 32.6698941],
              [48.0018043, 32.6698004],
              [48.0021782, 32.6692887],
              [48.0021668, 32.6685942],
              [48.0019418, 32.6681358],
              [48.0012818, 32.6675904],
              [47.9999771, 32.6668875],
              [47.9995906, 32.666628],
              [47.9995515, 32.6665736],
              [47.9993879, 32.666346],
              [47.9989549, 32.6649968],
              [47.998066, 32.6627419],
              [47.9972381, 32.661133],
              [47.9963569, 32.6597528],
              [47.9952049, 32.6589702],
              [47.9944344, 32.6580501],
              [47.9941389, 32.6578166],
              [47.9934464, 32.6572691],
              [47.9919662, 32.6564876],
              [47.9908715, 32.6557964],
              [47.9904131, 32.6556886],
              [47.9891205, 32.6553847],
              [47.9878082, 32.6549227],
              [47.9867668, 32.6546025],
              [47.9852371, 32.6540946],
              [47.984447, 32.6537829],
              [47.9843064, 32.6537274],
              [47.9831008, 32.6534955],
              [47.9821206, 32.6534494],
              [47.9815216, 32.653728],
              [47.9804878, 32.65451],
              [47.9798889, 32.6552011],
              [47.9789657, 32.6559835],
              [47.9774399, 32.6568573],
              [47.9748801, 32.6579135],
              [47.973133, 32.6584213],
              [47.9720422, 32.6586947],
              [47.9713326, 32.6586956],
              [47.970131, 32.6585111],
              [47.9691466, 32.6582799],
              [47.9686507, 32.6577766],
              [47.968212, 32.6571777],
              [47.9679909, 32.6565323],
              [47.9677696, 32.6558913],
              [47.9672737, 32.655246],
              [47.9665603, 32.6544196],
              [47.9654617, 32.6535005],
              [47.9648349, 32.6530119],
              [47.9639816, 32.6523467],
              [47.962883, 32.6512901],
              [47.9621123, 32.6502346],
              [47.961506, 32.6489442],
              [47.9610634, 32.6478877],
              [47.960949, 32.6469225],
              [47.9609451, 32.6460502],
              [47.9612694, 32.6454495],
              [47.9615936, 32.6449435],
              [47.9617428, 32.6447949],
              [47.9621925, 32.6443472],
              [47.9624062, 32.6437956],
              [47.9624595, 32.6429675],
              [47.9620704, 32.6422774],
              [47.9611931, 32.6414042],
              [47.9606476, 32.6409875],
              [47.9592781, 32.6402083],
              [47.9579087, 32.6392397],
              [47.9569065, 32.6387883],
              [47.9564858, 32.6385989],
              [47.9553872, 32.6379547],
              [47.9548378, 32.6372178],
              [47.9545594, 32.6359782],
              [47.9546661, 32.6353339],
              [47.9554824, 32.6345514],
              [47.9569511, 32.6334465],
              [47.9583626, 32.6322051],
              [47.9596672, 32.6311503],
              [47.9611358, 32.6303181],
              [47.9626046, 32.6293981],
              [47.9639664, 32.6288495],
              [47.9693031, 32.6262243],
              [47.9713173, 32.6252136],
              [47.9733315, 32.6243404],
              [47.9748039, 32.6238778],
              [47.9762229, 32.6235085],
              [47.977581, 32.6228177],
              [47.9785081, 32.622085],
              [47.9794808, 32.6207493],
              [47.9809493, 32.6195991],
              [47.9821434, 32.6188164],
              [47.9835626, 32.6183119],
              [47.9851417, 32.6176218],
              [47.9864998, 32.6168408],
              [47.9882964, 32.6157344],
              [47.9889985, 32.614906],
              [47.9892159, 32.6143523],
              [47.9893189, 32.6134802],
              [47.9892081, 32.6128352],
              [47.9887123, 32.6121494],
              [47.9883271, 32.6114121],
              [47.9876671, 32.6107223],
              [47.9870071, 32.6100303],
              [47.9858589, 32.6094325],
              [47.9847862, 32.6090954],
              [47.9845467, 32.6090201],
              [47.9829636, 32.6088829],
              [47.9818192, 32.609065],
              [47.9807281, 32.6093452],
              [47.9797477, 32.6098941],
              [47.9793716, 32.6101549],
              [47.9785538, 32.6107219],
              [47.9770851, 32.611827],
              [47.9756164, 32.6124272],
              [47.9745788, 32.6126546],
              [47.9725609, 32.6128381],
              [47.9702149, 32.6126553],
              [47.9674836, 32.6125172],
              [47.9652482, 32.6124722],
              [47.963829, 32.612706],
              [47.961483, 32.6129333],
              [47.9600639, 32.6129349],
              [47.9588623, 32.6127052],
              [47.95755, 32.6123399],
              [47.9560203, 32.6116942],
              [47.9545441, 32.611282],
              [47.951374, 32.6100398],
              [47.9507905, 32.6098908],
              [47.9501152, 32.6097184],
              [47.9493523, 32.6095804],
              [47.9485893, 32.6097647],
              [47.9475517, 32.6099964],
              [47.9459191, 32.6104097],
              [47.9457398, 32.6104506],
              [47.9445, 32.6107336],
              [47.9433556, 32.6109153],
              [47.9424287, 32.6109153],
              [47.9413376, 32.6108256],
              [47.9403534, 32.6103621],
              [47.9393121, 32.6099513],
              [47.9383277, 32.6090775],
              [47.9380707, 32.6087862],
              [47.9380447, 32.6087568],
              [47.9375573, 32.6082045],
              [47.9366265, 32.6070549],
              [47.9359665, 32.6058577],
              [47.9353065, 32.6046628],
              [47.9352649, 32.6044632],
              [47.9349709, 32.6030544],
              [47.934475, 32.601859],
              [47.9341431, 32.6009854],
              [47.9335938, 32.6003409],
              [47.932991, 32.5998348],
              [47.9323882, 32.599606],
              [47.9315719, 32.5994215],
              [47.9304809, 32.5993768],
              [47.9289513, 32.5994678],
              [47.926609, 32.5998838],
              [47.924862, 32.6002535],
              [47.9230652, 32.600667],
              [47.920723, 32.6015404],
              [47.9188727, 32.6023221],
              [47.9176177, 32.6026925],
              [47.9166373, 32.6029208],
              [47.9164832, 32.6029102],
              [47.9159812, 32.6028754],
              [47.9152184, 32.6027823],
              [47.9147264, 32.6024163],
              [47.9145584, 32.6018172],
              [47.9146117, 32.6011739],
              [47.9148217, 32.5999327],
              [47.9151993, 32.5986911],
              [47.9159012, 32.5969435],
              [47.9166068, 32.5959331],
              [47.9180222, 32.5948297],
              [47.9207917, 32.5926213],
              [47.9230765, 32.5905046],
              [47.9247055, 32.5888022],
              [47.9266052, 32.5869172],
              [47.9275283, 32.58632],
              [47.9280561, 32.5860883],
              [47.928997, 32.5856752],
              [47.9305763, 32.5850287],
              [47.93161, 32.584522],
              [47.9323197, 32.5840638],
              [47.9326973, 32.5835569],
              [47.9328575, 32.5828666],
              [47.9328576, 32.5824091],
              [47.9325256, 32.581673],
              [47.9324847, 32.5815836],
              [47.9320832, 32.5807065],
              [47.9311524, 32.5795095],
              [47.9305497, 32.5788682],
              [47.930142, 32.5785614],
              [47.9300575, 32.5784978],
              [47.9296188, 32.5783158],
              [47.928421, 32.5781332],
              [47.9274902, 32.578133],
              [47.9265099, 32.5781315],
              [47.9257469, 32.5784103],
              [47.9251481, 32.5785489],
              [47.9247704, 32.5791482],
              [47.9244995, 32.5797434],
              [47.9240647, 32.5803864],
              [47.9238007, 32.5806698],
              [47.9232647, 32.580911],
              [47.9228133, 32.5809868],
              [47.9221611, 32.5809392],
              [47.9207954, 32.5805744],
              [47.9200162, 32.5802791],
              [47.9192124, 32.5799744],
              [47.9180641, 32.579518],
              [47.9170047, 32.5793351],
              [47.9162063, 32.5791974],
              [47.9145165, 32.5791964],
              [47.913536, 32.5791971],
              [47.9128266, 32.5795178],
              [47.9122848, 32.5797952],
              [47.9116288, 32.5797948],
              [47.9104842, 32.5796134],
              [47.9101259, 32.5794954],
              [47.9095001, 32.5792894],
              [47.9082985, 32.5786468],
              [47.9078064, 32.5783687],
              [47.9073677, 32.5776817],
              [47.9070891, 32.5769469],
              [47.9067146, 32.5763164],
              [47.9065972, 32.5761189],
              [47.9063226, 32.5753819],
              [47.9062081, 32.5743716],
              [47.9062576, 32.5733157],
              [47.9064178, 32.5722581],
              [47.90625, 32.571659],
              [47.9059219, 32.5711528],
              [47.9051552, 32.5708319],
              [47.9037362, 32.5703281],
              [47.9035525, 32.5702541],
              [47.9025917, 32.5698671],
              [47.9012794, 32.5690391],
              [47.9006195, 32.5683061],
              [47.9005089, 32.5676159],
              [47.9007103, 32.5669758],
              [47.9007263, 32.5669249],
              [47.9011575, 32.5661422],
              [47.9019203, 32.5655434],
              [47.9025689, 32.5647616],
              [47.9034385, 32.5642579],
              [47.9049644, 32.5636599],
              [47.9067078, 32.5634729],
              [47.9077987, 32.5634277],
              [47.9092063, 32.5633867],
              [47.9094354, 32.5633801],
              [47.9102515, 32.5633821],
              [47.9111241, 32.5634937],
              [47.9116707, 32.5635635],
              [47.912922, 32.5633802],
              [47.9135208, 32.5632867],
              [47.9142303, 32.5628737],
              [47.9147721, 32.5619088],
              [47.915474, 32.5602537],
              [47.9159547, 32.5581806],
              [47.9159618, 32.5581211],
              [47.9162178, 32.5559738],
              [47.9163208, 32.5551492],
              [47.916388, 32.5550781],
              [47.9169731, 32.5544597],
              [47.9175187, 32.5540877],
              [47.9182243, 32.5538143],
              [47.9192048, 32.5537189],
              [47.9202956, 32.5539056],
              [47.9210624, 32.5543639],
              [47.9218826, 32.5548213],
              [47.9222642, 32.5554189],
              [47.9229239, 32.5562487],
              [47.9234161, 32.5568919],
              [47.923748, 32.5575333],
              [47.9241868, 32.5581774],
              [47.9248962, 32.5588236],
              [47.925663, 32.5593721],
              [47.9267578, 32.5600164],
              [47.9280128, 32.5605204],
              [47.928997, 32.5610268],
              [47.9300347, 32.56153],
              [47.9315644, 32.5623585],
              [47.9333114, 32.5628159],
              [47.9350548, 32.562908],
              [47.93898, 32.5629091],
              [47.9409098, 32.5629074],
              [47.9409448, 32.5629074],
              [47.9413652, 32.5628336],
              [47.942524, 32.5626303],
              [47.9433936, 32.5622638],
              [47.944046, 32.561572],
              [47.9442595, 32.5610205],
              [47.9442063, 32.5606044],
              [47.9436569, 32.5601471],
              [47.9430292, 32.5598838],
              [47.9430007, 32.5598719],
              [47.9420737, 32.5596893],
              [47.9407653, 32.559689],
              [47.940384, 32.5593642],
              [47.9401092, 32.5590442],
              [47.9399413, 32.5584],
              [47.9398842, 32.557941],
              [47.9398842, 32.5573888],
              [47.9398804, 32.5566517],
              [47.9397659, 32.5559164],
              [47.9395981, 32.5549499],
              [47.9393234, 32.5541679],
              [47.9391021, 32.5535742],
              [47.9387169, 32.5528842],
              [47.9389305, 32.5518729],
              [47.938816, 32.5506755],
              [47.9385911, 32.5495724],
              [47.9383163, 32.549018],
              [47.9380951, 32.5486069],
              [47.9376029, 32.5483785],
              [47.9368973, 32.5483771],
              [47.9357528, 32.5483785],
              [47.9346047, 32.54824],
              [47.9335136, 32.5480579],
              [47.9323159, 32.547828],
              [47.9318238, 32.5474126],
              [47.9317131, 32.5468644],
              [47.9318161, 32.5462178],
              [47.9321441, 32.545757],
              [47.9327926, 32.5449299],
              [47.9328728, 32.5448256],
              [47.9336053, 32.5438724],
              [47.9343604, 32.5424461],
              [47.934486, 32.5420723],
              [47.9346848, 32.5414803],
              [47.9346806, 32.5407961],
              [47.9346772, 32.5402382],
              [47.9342385, 32.539317],
              [47.9339254, 32.539005],
              [47.9336891, 32.5387694],
              [47.933033, 32.5380321],
              [47.9325408, 32.5375738],
              [47.9323197, 32.5371582],
              [47.9323197, 32.5365136],
              [47.9324226, 32.5358287],
              [47.9328002, 32.5349499],
              [47.9337768, 32.5339392],
              [47.9344825, 32.5332036],
              [47.936058, 32.5325591],
              [47.9371889, 32.5321876],
              [47.9377441, 32.5320052],
              [47.9393768, 32.5315897],
              [47.9397397, 32.5315727],
              [47.9413413, 32.5314978],
              [47.9424821, 32.5314985],
              [47.9433022, 32.5317731],
              [47.9438477, 32.532138],
              [47.944397, 32.5325548],
              [47.9448357, 32.5332462],
              [47.9457131, 32.5345297],
              [47.9460449, 32.5357706],
              [47.9463805, 32.5369218],
              [47.9464341, 32.5371054],
              [47.9465485, 32.5381157],
              [47.9466096, 32.5394515],
              [47.9468841, 32.5397263],
              [47.9472122, 32.5399101],
              [47.9476471, 32.5400018],
              [47.9481925, 32.5400917],
              [47.9493903, 32.5400013],
              [47.9506988, 32.5399091],
              [47.951098, 32.5397963],
              [47.9513907, 32.5398946],
              [47.9525009, 32.5398947],
              [47.954444, 32.5398947],
              [47.9544439, 32.5396147],
              [47.9550816, 32.5387652],
              [47.9552775, 32.5385041],
              [47.9558342, 32.5357321],
              [47.9554319, 32.5351251],
              [47.9553095, 32.5349405],
              [47.9554099, 32.5341114],
              [47.9550247, 32.5329165],
              [47.9543647, 32.5320891],
              [47.9540841, 32.5318702],
              [47.953598, 32.5314913],
              [47.9531632, 32.5313522],
              [47.9521828, 32.5311707],
              [47.9517975, 32.5309405],
              [47.951416, 32.5307081],
              [47.9513055, 32.5304327],
              [47.9513588, 32.530434],
              [47.9510841, 32.5296519],
              [47.9509697, 32.5286867],
              [47.9509125, 32.5278131],
              [47.95047, 32.526849],
              [47.9498139, 32.5259292],
              [47.9491006, 32.5252831],
              [47.9484978, 32.5247793],
              [47.9476815, 32.5245048],
              [47.9464264, 32.5244135],
              [47.9438096, 32.5240929],
              [47.9424477, 32.5240012],
              [47.9414674, 32.5237271],
              [47.9407005, 32.5232667],
              [47.9399338, 32.5223465],
              [47.9393311, 32.5216105],
              [47.9389992, 32.5208316],
              [47.9388351, 32.5200951],
              [47.9388313, 32.5194977],
              [47.939373, 32.5188055],
              [47.9405671, 32.5178406],
              [47.9425773, 32.5170105],
              [47.9444276, 32.5164559],
              [47.9447129, 32.5164253],
              [47.9465523, 32.5162281],
              [47.9491653, 32.515994],
              [47.9509049, 32.5156711],
              [47.9526481, 32.5153054],
              [47.9538422, 32.515118],
              [47.9541702, 32.5151643],
              [47.954609, 32.5153462],
              [47.9548798, 32.5155781],
              [47.9548835, 32.5160831],
              [47.9547806, 32.5169101],
              [47.9546776, 32.5183365],
              [47.9546814, 32.5191661],
              [47.9549561, 32.5196235],
              [47.9555054, 32.5201755],
              [47.9565964, 32.5209119],
              [47.9573632, 32.5214151],
              [47.9588929, 32.5222883],
              [47.9606399, 32.5232998],
              [47.9622765, 32.5238487],
              [47.9637489, 32.5242201],
              [47.9659843, 32.5244477],
              [47.9687119, 32.5247659],
              [47.9716529, 32.5249946],
              [47.9772149, 32.5253134],
              [47.9791428, 32.5256299],
              [47.9794502, 32.5256804],
              [47.9802132, 32.5258633],
              [47.9806519, 32.5263674],
              [47.9809838, 32.5270583],
              [47.9810372, 32.5275194],
              [47.981041, 32.5280717],
              [47.9808274, 32.5285309],
              [47.9804497, 32.5294955],
              [47.9803749, 32.5296238],
              [47.9798584, 32.5305091],
              [47.9792061, 32.5312463],
              [47.9787751, 32.5321194],
              [47.9785614, 32.5330384],
              [47.9785651, 32.5337305],
              [47.978569, 32.5343278],
              [47.9786835, 32.5349234],
              [47.9789581, 32.5354777],
              [47.9793968, 32.535939],
              [47.9799423, 32.5361663],
              [47.9805985, 32.5363511],
              [47.9813614, 32.536304],
              [47.9823951, 32.5362094],
              [47.9842686, 32.5359781],
              [47.9846267, 32.5359339],
              [47.986805, 32.5357923],
              [47.9898032, 32.5357019],
              [47.9935607, 32.5354696],
              [47.9969368, 32.5350995],
              [47.9975361, 32.5349377],
              [47.9999885, 32.5342753],
              [48.001091, 32.5340379],
              [48.0029297, 32.5336986],
              [48.0043374, 32.5334122],
              [48.0057411, 32.5330309],
              [48.0064964, 32.5326116],
              [48.0079422, 32.5313523],
              [48.0091745, 32.5302205],
              [48.0098152, 32.529632],
              [48.0111542, 32.5285617],
              [48.0119158, 32.5279594],
              [48.0129776, 32.5271197],
              [48.0146828, 32.5251654],
              [48.0156975, 32.5242384],
              [48.0160638, 32.5233567],
              [48.0162659, 32.5223878],
              [48.0163041, 32.5214646],
              [48.016182, 32.520497],
              [48.0157318, 32.5196231],
              [48.0154489, 32.5191301],
              [48.0152321, 32.5187524],
              [48.0148392, 32.5181075],
              [48.0145607, 32.5176501],
              [48.0145493, 32.5169601],
              [48.0147018, 32.516265],
              [48.0149651, 32.5158001],
              [48.0153961, 32.5156143],
              [48.0157204, 32.5154259],
              [48.0159301, 32.5150116],
              [48.015976, 32.5144582],
              [48.0163384, 32.513439],
              [48.0168113, 32.5124202],
              [48.0175552, 32.5112613],
              [48.0182458, 32.5103333],
              [48.0191041, 32.5097766],
              [48.0197983, 32.5090335],
              [48.0198957, 32.5085354],
              [48.0198975, 32.5085264],
              [48.0200997, 32.5075981],
              [48.0203553, 32.5066755],
              [48.0205039, 32.5057075],
              [48.0205917, 32.5044136],
              [48.0206794, 32.5030295],
              [48.0206565, 32.5016022],
              [48.0206565, 32.5000604],
              [48.0204696, 32.4957306],
              [48.0202407, 32.4935186],
              [48.0201188, 32.4912144],
              [48.0203819, 32.4896022],
              [48.020588, 32.4877093],
              [48.0208398, 32.4848978],
              [48.020939, 32.4828219],
              [48.0213547, 32.4805147],
              [48.0215072, 32.4786272],
              [48.0217094, 32.4758573],
              [48.0216904, 32.4725841],
              [48.0218849, 32.4691739],
              [48.022129, 32.4649309],
              [48.0223846, 32.4620248],
              [48.0224724, 32.4588443],
              [48.022892, 32.4566769],
              [48.0228843, 32.4549253],
              [48.0229226, 32.4528052],
              [48.0225334, 32.4506412],
              [48.0220871, 32.4481084],
              [48.0212592, 32.4446109],
              [48.0201607, 32.4412039],
              [48.0197144, 32.4382091],
              [48.0193673, 32.4344795],
              [48.019291, 32.4306076],
              [48.0188942, 32.4270594],
              [48.0182038, 32.4189061],
              [48.0187225, 32.4155397],
              [48.0194015, 32.4119832],
              [48.0195504, 32.4096786],
              [48.0200082, 32.4050214],
              [48.0214232, 32.3980111],
              [48.0221062, 32.395194],
              [48.022892, 32.3915476],
              [48.0233115, 32.3897024],
              [48.0243263, 32.3881756],
              [48.0257073, 32.3852645],
              [48.0271415, 32.3826296],
              [48.0292741, 32.379486],
              [48.030491, 32.3763005],
              [48.0311241, 32.3742665],
              [48.0316505, 32.3723292],
              [48.0324859, 32.3682713],
              [48.0332718, 32.3654092],
              [48.0345955, 32.3621292],
              [48.0354385, 32.3597755],
              [48.0356369, 32.357285],
              [48.0356255, 32.3553508],
              [48.0354539, 32.3539695],
              [48.0348587, 32.3530043],
              [48.0342637, 32.3521766],
              [48.0335046, 32.3511647],
              [48.0322647, 32.3503421],
              [48.0312957, 32.3501164],
              [48.0290909, 32.3495303],
              [48.0260811, 32.3491279],
              [48.020977, 32.3483695],
              [48.0175934, 32.3482016],
              [48.0135651, 32.347714],
              [48.0085144, 32.3473665],
              [48.0046012, 32.3461353],
              [48.0008122, 32.3442443],
              [48.0000037, 32.3437787],
              [47.9963929, 32.3424035],
              [47.9890137, 32.3395992],
              [47.9848061, 32.3380155],
              [47.9812584, 32.3367991],
              [47.9778594, 32.3347477],
              [47.9760476, 32.3335637],
              [47.9746055, 32.3317259],
              [47.9717102, 32.3274573],
              [47.969574, 32.3230445],
              [47.9670754, 32.3166462],
              [47.9655799, 32.311532],
              [47.9647218, 32.3090929],
              [47.9643098, 32.3070634],
              [47.9638901, 32.3048962],
              [47.9633637, 32.3026386],
              [47.9627876, 32.3005668],
              [47.9625512, 32.2995063],
              [47.9621429, 32.2977113],
              [47.9618987, 32.2962809],
              [47.9617768, 32.2954034],
              [47.9619751, 32.2943871],
              [47.9624443, 32.2933661],
              [47.9630279, 32.292438],
              [47.9656447, 32.2901546],
              [47.9681548, 32.288148],
              [47.9723396, 32.2856181],
              [47.9772225, 32.2828028],
              [47.9806177, 32.2810063],
              [47.9810371, 32.2807844],
              [47.9836159, 32.2795139],
              [47.9849549, 32.2785339],
              [47.9858627, 32.2777396],
              [47.9861221, 32.2770922],
              [47.9866448, 32.2760746],
              [47.9870034, 32.2749133],
              [47.9870987, 32.274174],
              [47.987194, 32.2732972],
              [47.9870606, 32.2720025],
              [47.9869232, 32.2703899],
              [47.9866752, 32.2686393],
              [47.9860992, 32.2667007],
              [47.9856416, 32.2651818],
              [47.9850235, 32.2638935],
              [47.9840813, 32.2627485],
              [47.9830932, 32.2620667],
              [47.9813995, 32.2612486],
              [47.9795952, 32.2603421],
              [47.9781799, 32.2598913],
              [47.9770354, 32.25967],
              [47.9759483, 32.2594028],
              [47.9751319, 32.259133],
              [47.9727859, 32.2581369],
              [47.9681892, 32.2555922],
              [47.9643631, 32.2537309],
              [47.9620591, 32.2520436],
              [47.9598738, 32.2499872],
              [47.9564797, 32.2476356],
              [47.9552192, 32.2467622],
              [47.9517365, 32.2440906],
              [47.9485816, 32.24165],
              [47.9453125, 32.2384717],
              [47.9434051, 32.2360769],
              [47.942245, 32.2343375],
              [47.9417152, 32.2335431],
              [47.9385491, 32.2282484],
              [47.9352799, 32.2231405],
              [47.9316292, 32.2190443],
              [47.9283103, 32.2156795],
              [47.925045, 32.2125978],
              [47.9212913, 32.2094658],
              [47.9182472, 32.2069775],
              [47.9158553, 32.2051814],
              [47.9118881, 32.2025104],
              [47.9075966, 32.1999329],
              [47.9031983, 32.1975396],
              [47.8954316, 32.1931183],
              [47.8904231, 32.19042],
              [47.8900528, 32.1902205],
              [47.8860893, 32.1876864],
              [47.8835907, 32.1858441],
              [47.8816871, 32.1840977],
              [47.8802185, 32.1823011],
              [47.8782616, 32.1800913],
              [47.8729857, 32.1731878],
              [47.8685798, 32.1673402],
              [47.8650436, 32.162738],
              [47.8576547, 32.1550512],
              [47.8503762, 32.1480092],
              [47.8463593, 32.1446499],
              [47.8388139, 32.1374699],
              [47.8309441, 32.1310724],
              [47.8265496, 32.1279443],
              [47.8213958, 32.1241275],
              [47.8186303, 32.1218717],
              [47.8143997, 32.1192025],
              [47.8107982, 32.1166055],
              [47.8100625, 32.116073],
              [47.8050728, 32.1130373],
              [47.8020364, 32.111011],
              [47.7981873, 32.1086192],
              [47.7930374, 32.1058585],
              [47.7884331, 32.1034653],
              [47.7851791, 32.1020845],
              [47.7839936, 32.1014906],
              [47.7818756, 32.1004295],
              [47.7782975, 32.0987743],
              [47.7724457, 32.0959656],
              [47.7670287, 32.0933459],
              [47.7605285, 32.0907703],
              [47.7558687, 32.0888433],
              [47.7500797, 32.0867543],
              [47.7326755, 32.0791152],
              [47.7001868, 32.0648534],
              [47.6656316, 32.0496671],
              [47.6651397, 32.0493721],
              [47.6646987, 32.0491255],
              [47.6644396, 32.0488708],
              [47.664111, 32.048542]
            ]
          ]
        ]
      }
    }
  ]
}
}

export default config;